
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iuVKP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $a1L5E = parcelRequire("a1L5E");


var $d5gEx = parcelRequire("d5gEx");











var $6cFsl = parcelRequire("6cFsl");


var $kiAM2 = parcelRequire("kiAM2");


var $7akNQ = parcelRequire("7akNQ");


var $5HApy = parcelRequire("5HApy");





var $8BQV6 = parcelRequire("8BQV6");


var $iA8l9 = parcelRequire("iA8l9");


var $hdBxM = parcelRequire("hdBxM");


var $37RgG = parcelRequire("37RgG");


var $aQWBL = parcelRequire("aQWBL");


var $aJU2k = parcelRequire("aJU2k");


var $hOUgz = parcelRequire("hOUgz");


var $6rwn6 = parcelRequire("6rwn6");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $89QZA = parcelRequire("89QZA");


var $bjY3F = parcelRequire("bjY3F");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");


var $lJ6db = parcelRequire("lJ6db");


var $4m5jb = parcelRequire("4m5jb");


var $gzMZq = parcelRequire("gzMZq");


var $k4g8h = parcelRequire("k4g8h");


var $iW40i = parcelRequire("iW40i");


var $isp1U = parcelRequire("isp1U");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d59150c4763cb391$var$initialReconnectionState = {
    isReconnecting: false,
    messageId: null
};
const $d59150c4763cb391$var$initialState = {
    reconnections: {}
};
const $d59150c4763cb391$var$store = (0, $8s9DV.createStore)({
    name: 'rovoReconnect',
    initialState: $d59150c4763cb391$var$initialState,
    actions: {
        startReconnection: (conversationId, messageId)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Guard: already reconnecting
                if (state.reconnections[conversationId]?.isReconnecting) return false;
                setState({
                    reconnections: {
                        ...state.reconnections,
                        [conversationId]: {
                            isReconnecting: true,
                            messageId: messageId
                        }
                    }
                });
                return true;
            },
        endReconnection: (conversationId)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                setState({
                    reconnections: {
                        ...state.reconnections,
                        [conversationId]: $d59150c4763cb391$var$initialReconnectionState
                    }
                });
            },
        isReconnecting: (conversationId)=>({ getState: getState })=>{
                return getState().reconnections[conversationId]?.isReconnecting ?? false;
            }
    }
});
const $d59150c4763cb391$export$2d5e21bcae15bf2 = (0, $kBr4q.createHook)($d59150c4763cb391$var$store);
const $d59150c4763cb391$export$bec843ddf321b89b = (0, $kBr4q.createActionsHook)($d59150c4763cb391$var$store);
const $d59150c4763cb391$export$489be5bbb9bfa3f2 = (0, $kBr4q.createHook)($d59150c4763cb391$var$store, {
    selector: (state, conversationId)=>state.reconnections[conversationId] ?? $d59150c4763cb391$var$initialReconnectionState
});



var $8akfd = parcelRequire("8akfd");


var $hSR6U = parcelRequire("hSR6U");


var $bGNkz = parcelRequire("bGNkz");


var $9qJ1N = parcelRequire("9qJ1N");


var $lTU4O = parcelRequire("lTU4O");


var $8VrqA = parcelRequire("8VrqA");


var $kb3cs = parcelRequire("kb3cs");


var $7bLo5 = parcelRequire("7bLo5");


var $12shJ = parcelRequire("12shJ");











var $9EOlJ = parcelRequire("9EOlJ");

const $741693f1d6085f6e$var$enableDebugging = ()=>{
    if (window.top) window.top.__aifcDebuggerEnabled__ = true;
};
const $741693f1d6085f6e$var$disableDebugging = ()=>{
    if (window.top) window.top.__aifcDebuggerEnabled__ = false;
};
function $741693f1d6085f6e$var$addAifcDebugListeners() {
    if (window.top) {
        window.top.__aifcDebuggerStart__ = $741693f1d6085f6e$var$enableDebugging;
        window.top.__aifcDebuggerStop__ = $741693f1d6085f6e$var$disableDebugging;
    }
}
function $741693f1d6085f6e$var$removeAifcDebugListeners() {
    if (window.top) {
        window.top.__aifcDebuggerStart__ = undefined;
        window.top.__aifcDebuggerStop__ = undefined;
    }
}
const $741693f1d6085f6e$var$AifcDebuggerListeners = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($741693f1d6085f6e$var$_temp2, t0);
    return null;
} : ()=>{
    (0, $cozmU.useEffect)(()=>{
        $741693f1d6085f6e$var$addAifcDebugListeners();
        return ()=>{
            $741693f1d6085f6e$var$removeAifcDebugListeners();
        };
    }, []);
    return null;
};
const $741693f1d6085f6e$var$onAifcDebuggerError = (error, errorInfo)=>{
    // eslint-disable-next-line no-console
    console.error('AifcDebugger failed:', error, errorInfo);
};
const $741693f1d6085f6e$export$1f35aa17211e523d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: $741693f1d6085f6e$var$_temp3,
            onError: $741693f1d6085f6e$var$onAifcDebuggerError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741693f1d6085f6e$var$AifcDebuggerListeners, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null,
        onError: $741693f1d6085f6e$var$onAifcDebuggerError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741693f1d6085f6e$var$AifcDebuggerListeners, null));
};
function $741693f1d6085f6e$var$_temp() {
    $741693f1d6085f6e$var$removeAifcDebugListeners();
}
function $741693f1d6085f6e$var$_temp2() {
    $741693f1d6085f6e$var$addAifcDebugListeners();
    return $741693f1d6085f6e$var$_temp;
}
function $741693f1d6085f6e$var$_temp3() {
    return null;
}



var $oV0CU = parcelRequire("oV0CU");







const $bd4e57972be9e4ca$export$e0427dd13bcccf1b = ()=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const capabilities = (0, $cozmU.useMemo)(()=>[
            'ask-question-enabled',
            ...(0, $iDrrr.fg)('rovo_chat_csat_interaction_conclusion_signal') ? [
                'interaction-conclusion-v1'
            ] : [],
            ...(0, $iDrrr.fg)('rovo_chat_enable_inline_lumina') ? [
                'inline_lumina_enabled'
            ] : [],
            ...(0, $iDrrr.fg)('rovo_chat_enable_tool_resumption') ? [
                'tool_resumption_enabled'
            ] : [],
            // TODO - once experiment is decided use actionable-follow-ups or actionable-follow-ups-stacked
            // The actual value does not matter outside of SSE. Do this to prevent an additional experiment check.
            ...(0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled') ? [
                'actionable-follow-ups'
            ] : []
        ], // fg() values are static at runtime — gates don't change between renders
    []);
    return capabilities;
};












var $20Kr8 = parcelRequire("20Kr8");

const $e2d7843b3ff1bcdd$export$47f0b7e1efb22e0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BackBehaviorOverrideProvider(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [override, setOverride] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== override) {
        t1 = {
            override: override,
            setOverride: setOverride
        };
        $[0] = override;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    if ($[2] !== children || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20Kr8.BackBehaviorOverrideContext).Provider, {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function BackBehaviorOverrideProvider({ children: children }) {
    const [override, setOverride] = (0, $cozmU.useState)(null);
    const value = (0, $cozmU.useMemo)(()=>({
            override: override,
            setOverride: setOverride
        }), [
        override
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20Kr8.BackBehaviorOverrideContext).Provider, {
        value: value
    }, children);
};



var $gyWKg = parcelRequire("gyWKg");











var $hJC44 = parcelRequire("hJC44");

const $83df2c4d369ade6b$export$1ea8b76066893345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { showFlag: showFlag, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showFlag) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJC44.default).Provider, {
            value: showFlag
        }, children);
        $[0] = children;
        $[1] = showFlag;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ showFlag: showFlag, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJC44.default).Provider, {
        value: showFlag
    }, children);












var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $8KiU9 = parcelRequire("8KiU9");


var $idzM5 = parcelRequire("idzM5");

const $55592f6773d96032$export$4610738c067a7645 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { showFlag: showFlagFromFlags } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage || $[1] !== showFlagFromFlags) {
        t0 = (flagId)=>{
            bb2: switch(flagId){
                case (0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN:
                    showFlagFromFlags({
                        id: "conversation-assistant.conversation-forbidden",
                        title: formatMessage((0, $8KiU9.default).conversationForbiddenTitle),
                        description: formatMessage((0, $8KiU9.default).conversationForbiddenDescription),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
                    break bb2;
                case (0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED:
                    showFlagFromFlags({
                        id: "conversation-assistant.conversation-history-load-failed",
                        title: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedTitle),
                        description: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedDescription),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
                    break bb2;
                case (0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE:
                    showFlagFromFlags({
                        id: "ai-mate.follow-up-agent-unavailable",
                        title: formatMessage((0, $8KiU9.default).followUpAgentUnavailableTitle),
                        description: formatMessage((0, $8KiU9.default).followUpAgentUnavailableDescription),
                        appearance: "error",
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                            color: "var(--ds-icon-danger, #C9372C)",
                            label: ""
                        }),
                        isAutoDismiss: true
                    });
            }
        };
        $[0] = formatMessage;
        $[1] = showFlagFromFlags;
        $[2] = t0;
    } else t0 = $[2];
    const showFlag = t0;
    return showFlag;
} : ()=>{
    const { showFlag: showFlagFromFlags } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showFlag = (0, $cozmU.useCallback)((flagId)=>{
        switch(flagId){
            case (0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN:
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-forbidden',
                    title: formatMessage((0, $8KiU9.default).conversationForbiddenTitle),
                    description: formatMessage((0, $8KiU9.default).conversationForbiddenDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
            case (0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED:
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-history-load-failed',
                    title: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedTitle),
                    description: formatMessage((0, $8KiU9.default).conversationHistoryLoadFailedDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
            case (0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE:
                showFlagFromFlags({
                    id: 'ai-mate.follow-up-agent-unavailable',
                    title: formatMessage((0, $8KiU9.default).followUpAgentUnavailableTitle),
                    description: formatMessage((0, $8KiU9.default).followUpAgentUnavailableDescription),
                    appearance: 'error',
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
        }
    }, [
        showFlagFromFlags,
        formatMessage
    ]);
    return showFlag;
};








const $66b2cc9d5a9f46b4$export$d41865d5350d9e0a = (product)=>{
    switch(product){
        case 'confluence':
            return 'confluence';
        case 'jira-software':
        case 'jira-core':
        case 'jsm':
        case 'jpd':
        case 'jira':
            return 'jira';
        case 'atlassian-studio':
        case 'rovo':
        case 'atlas':
            return 'atlas';
        case 'bitbucket':
            return 'bitbucket';
        case 'trello':
            return 'trello';
        case 'admin':
            return 'admin';
        case 'store':
            return 'store';
        default:
            return 'unknown';
    }
};


const $58f16686a4f70667$export$b9c35db6980960f2 = ({ profileData: profileData, displaySubmitFlag: displaySubmitFlag, siteId: siteId, product: product, experienceId: experienceId = (0, $oV0CU.AI_MATE_EXPERIENCE_ID), workspaceId: workspaceId, orgId: orgId, assistanceServiceConfig: assistanceServiceConfig, closeChat: closeChat, emojiProvider: emojiProvider, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose, renderingTouchpoint: renderingTouchpoint, inProductExperience: inProductExperience, smartCreationContext: smartCreationContext, jiraIssueCommentEditor: jiraIssueCommentEditor })=>({
        profileData: profileData,
        feedbackCollector: {
            entryPointId: (0, $oV0CU.FEEDBACK_COLLECTOR_ENTRYPOINT_ID),
            displaySubmitFlag: displaySubmitFlag
        },
        siteId: siteId,
        experienceId: experienceId,
        workspaceId: workspaceId,
        productKey: (0, $66b2cc9d5a9f46b4$export$d41865d5350d9e0a)(product),
        productHeader: product,
        orgId: orgId,
        assistanceServiceConfig: assistanceServiceConfig,
        closeChat: closeChat,
        emojiProvider: emojiProvider,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose,
        ...(0, $iDrrr.fg)('fe_enable_sa_externally') && {
            renderingTouchpoint: renderingTouchpoint
        },
        inProductExperience: inProductExperience,
        smartCreationContext: smartCreationContext,
        jiraIssueCommentEditor: jiraIssueCommentEditor
    });



var $6H2Ay = parcelRequire("6H2Ay");

const $b6e4c82a4164acfc$export$920227929045c1b5 = (0, $6H2Ay.globalConfig).Provider;



var $eKjv9 = parcelRequire("eKjv9");

// NOTE: Global `Window` augmentations merge across the entire program. The sibling
// package `@atlassian/conversation-assistant-service` declares this same
// `__ROVO_CHAT_CONFIG_PRODUCT__` global; keep the modifier (`?: string`) identical to
// that declaration, otherwise TS2687 ("All declarations of X must have identical
// modifiers") will fail at the program level.
const $de717ae3a7549f1b$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};












var $cXtTj = parcelRequire("cXtTj");


var $atEX8 = parcelRequire("atEX8");

const $557d858394512263$var$StabilizedSideNavContextProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen } = t0;
    let t1;
    if ($[0] !== isSideNavOpen || $[1] !== setSideNavOpen) {
        t1 = {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        };
        $[0] = isSideNavOpen;
        $[1] = setSideNavOpen;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }), [
        isSideNavOpen,
        setSideNavOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
        value: value
    }, children);
};
const $557d858394512263$var$InlineSideNavContextProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen } = t0;
    let t1;
    if ($[0] !== isSideNavOpen || $[1] !== setSideNavOpen) {
        t1 = {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        };
        $[0] = isSideNavOpen;
        $[1] = setSideNavOpen;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
            value: t1
        }, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atEX8.SideNavContext).Provider, {
        value: {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }
    }, children);
const $557d858394512263$export$b0b2d9624bbf3936 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const [isSideNavOpen, setSideNavOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== children || $[1] !== isSideNavOpen) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$StabilizedSideNavContextProvider, {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$InlineSideNavContextProvider, {
            isSideNavOpen: isSideNavOpen,
            setSideNavOpen: setSideNavOpen
        }, children);
        $[0] = children;
        $[1] = isSideNavOpen;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const [isSideNavOpen, setSideNavOpen] = (0, $cozmU.useState)(false);
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$StabilizedSideNavContextProvider, {
        isSideNavOpen: isSideNavOpen,
        setSideNavOpen: setSideNavOpen
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($557d858394512263$var$InlineSideNavContextProvider, {
        isSideNavOpen: isSideNavOpen,
        setSideNavOpen: setSideNavOpen
    }, children);
};



var $blKf8 = parcelRequire("blKf8");

const $735ca6a936ab5049$export$3063519296e335bf = (0, $blKf8.uiConfig).Provider;



var $dSCNl = parcelRequire("dSCNl");


var $6YdPR = parcelRequire("6YdPR");


var $5BOJB = parcelRequire("5BOJB");


var $c69qG = parcelRequire("c69qG");

const $31f0ba1c2c4d97e2$export$51f901728a02d39c = (0, $c69qG.agentVersioningConfigContext).Provider;



var $j180q = parcelRequire("j180q");








var $4MASx = parcelRequire("4MASx");


var $8vae9 = parcelRequire("8vae9");


var $3Ak5G = parcelRequire("3Ak5G");

const $0e8cab1d0778bbd2$export$4fbf4621651f722d = ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const requestJiraContext = (0, $cozmU.useCallback)(async ()=>{
        try {
            const invocation = await sendCommand((0, $8vae9.JiraContextCommand), {
                receiverId: (0, $4MASx.JIRA_SMART_CREATE_TABLE_CLIENT_ID),
                buffer: false
            });
            return await invocation.result() ?? undefined;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendJiraContextCommandError'
            });
            return undefined;
        }
    }, [
        sendCommand
    ]);
    return {
        requestJiraContext: requestJiraContext
    };
};















var $1qXpt = parcelRequire("1qXpt");


var $457kL = parcelRequire("457kL");




const $cb145149c0b90d17$export$46457d11c8328445 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    let t0;
    if ($[0] !== sendCommand) {
        t0 = async ()=>{
            try {
                const invocation = await sendCommand((0, $457kL.BrowserContextCommand), {
                    receiverId: (0, $1qXpt.ROVO_EXTENSION_CLIENT_ID),
                    buffer: false
                });
                const result = await invocation.result();
                return result;
            } catch (t1) {
                const error = t1;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "SendBridgeCommandError"
                });
                return;
            }
        };
        $[0] = sendCommand;
        $[1] = t0;
    } else t0 = $[1];
    const requestBrowserContent = t0;
    let t1;
    if ($[2] !== requestBrowserContent) {
        t1 = {
            requestBrowserContent: requestBrowserContent
        };
        $[2] = requestBrowserContent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const requestBrowserContent = (0, $cozmU.useCallback)(async ()=>{
        try {
            const invocation = await sendCommand((0, $457kL.BrowserContextCommand), {
                receiverId: (0, $1qXpt.ROVO_EXTENSION_CLIENT_ID),
                buffer: false
            });
            const result = await invocation.result();
            return result;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendBridgeCommandError'
            });
            return undefined;
        }
    }, [
        sendCommand
    ]);
    return {
        requestBrowserContent: requestBrowserContent
    };
};












var $ieeJu = parcelRequire("ieeJu");


var $lUXDc = parcelRequire("lUXDc");













const $d91d74abbb95cf45$var$SEND_MESSAGE_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).SEND_MESSAGE
]);
const $d91d74abbb95cf45$var$toError = (error)=>error ?? new Error('aiMateSendMessage failed');
const $d91d74abbb95cf45$var$matchesSendMessageFailure = (event, context)=>{
    if (!$d91d74abbb95cf45$var$SEND_MESSAGE_EXPERIENCE_NAMES.has(event.name) || event.action !== 'taskFail') return false;
    const attributes = event.attributes;
    const isRemixRegenerate = attributes?.isRemixRegenerate === true;
    if (!isRemixRegenerate) return false;
    const requestSource = attributes?.remixRegenerateSource;
    if (context.regenerateSource && requestSource !== context.regenerateSource) return false;
    const requestConversationId = attributes?.conversationId;
    if (context.conversationChannelId && requestConversationId === context.conversationChannelId) return true;
    // For now, if allowCollectFallback is true, we will assume there's only one conversation stream at a time
    // and that this failure event is related to the inflight Remix request
    return Boolean(context.allowCollectFallback && context.regenerateSource === 'inline-existing-node');
};
const $d91d74abbb95cf45$export$a9538f4db585a467 = (context)=>{
    return (events, experience)=>{
        for (const event of events){
            if (!$d91d74abbb95cf45$var$matchesSendMessageFailure(event, context)) continue;
            const attributes = event.attributes;
            experience.fail({
                error: $d91d74abbb95cf45$var$toError(event.error),
                attributes: {
                    ...attributes ?? {},
                    failureSource: 'send_message_collect',
                    failureStage: 'request',
                    upstreamExperience: event.name,
                    ...context.regenerateSource ? {
                        regenerateSource: context.regenerateSource
                    } : {},
                    ...context.targetIds ?? {}
                }
            });
            return;
        }
    };
};





















var $5Tn11 = parcelRequire("5Tn11");


var $j1J3n = parcelRequire("j1J3n");


var $8gcBG = parcelRequire("8gcBG");


var $2BLI8 = parcelRequire("2BLI8");


var $6yHkF = parcelRequire("6yHkF");


var $3MoJD = parcelRequire("3MoJD");


var $2YoG8 = parcelRequire("2YoG8");


var $95cHD = parcelRequire("95cHD");


var $85mU8 = parcelRequire("85mU8");


var $n71o5 = parcelRequire("n71o5");


var $3TxKn = parcelRequire("3TxKn");





var $7lXV4 = parcelRequire("7lXV4");


var $3wccB = parcelRequire("3wccB");


var $5OXoi = parcelRequire("5OXoi");


var $6isLN = parcelRequire("6isLN");





var $4nKqn = parcelRequire("4nKqn");





var $jb3zd = parcelRequire("jb3zd");

const $e4efc8cb7e22be34$export$ff6a2981a5436d75 = (status, streamId, content)=>{
    if (!content) return;
    const api = (0, $85mU8.getBrowserBridgeAPI)();
    const id = String(content.id);
    const receiverId = (()=>{
        switch(content.type){
            case 'page':
                return (0, $5OXoi.getConfluenceEditorClientId)(id);
            case 'database':
                return (0, $7lXV4.getConfluenceDatabaseClientId)(id);
            case 'whiteboard':
                return (0, $6isLN.getConfluenceWhiteboardClientId)(id);
            case 'slide':
                return (0, $3wccB.getConfluenceSlidesClientId)(id);
            default:
                return undefined;
        }
    })();
    try {
        if (!receiverId) return;
        switch(status){
            case (0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY:
                api.send((0, $4nKqn.RovoSendContextReadyCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).COMPLETED:
                api.send((0, $4nKqn.RovoStreamCompletedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).ERRORED:
                api.send((0, $4nKqn.RovoStreamErroredCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case (0, $jb3zd.StreamLifecycleState).ABORTED:
                api.send((0, $4nKqn.RovoStreamAbortedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            default:
                (0, $hlvTd.logException)({
                    exception: new Error(`Unknown stream lifecycle state: ${status}`),
                    name: 'UnknownStreamLifecycleState'
                });
        }
    } catch (error) {
        (0, $hlvTd.logException)({
            exception: error,
            name: 'SendStreamLifecycleCommandError'
        });
    }
};





















var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");








var $2zvMw = parcelRequire("2zvMw");


var $9jFb0 = parcelRequire("9jFb0");


var $2lEwc = parcelRequire("2lEwc");


var $i35QN = parcelRequire("i35QN");














var $dE5YE = parcelRequire("dE5YE");

/**
 * This is a temporary helper function to get the current page ID from the current URL.
 * Eventually this is come from the backend.
 */ const $93ce060b6123b497$export$365076dec8e1120e = ()=>{
    // Extracts the numeric page ID from the current Confluence page URL.
    // Handles both view and edit URL formats:
    //   View: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/<pageId>/<page-title>
    //   Edit: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/edit-v2/<pageId>
    return window?.location.href.match(/\/pages\/(?:edit-v2\/)?(\d+)/)?.[1] ?? '';
};


function $4a71479a1e1aaf2c$export$cb00071f594190c2(sendCommand, { contentId: contentId, groupId: groupId }) {
    const resolvedContentId = contentId || (0, $93ce060b6123b497$export$365076dec8e1120e)();
    if (!resolvedContentId) return;
    sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
        key: (0, $aYC8J.IMAGE_CREATE_KEY),
        data: {
            __isError: true
        },
        isStreamComplete: false,
        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(resolvedContentId),
        groupId: groupId,
        buffer: false
    });
}


const $c1435cb431a8c757$export$ef93491bca821fa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const [t0] = (0, $gzMZq.useChatContextEditorContext)();
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isViewMode: editorIsViewMode } = t1;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const { mounted: mounted } = (0, $bGNkz.useUIStore)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[2] = t2;
    } else t2 = $[2];
    const publishedMessagesRef = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Set();
        $[3] = t3;
    } else t3 = $[3];
    const messagesWithUpdateActionsRef = (0, $cozmU.useRef)(t3);
    elements?.stagingAreaEnabled;
    const stagingAreaEnabled = elements?.stagingAreaEnabled;
    let t4;
    if ($[4] !== mounted || $[5] !== publish || $[6] !== stagingAreaEnabled) {
        t4 = (conversationId, messageId, openChat)=>{
            if (!publishedMessagesRef.current.has(messageId) && !mounted && !stagingAreaEnabled) {
                publishedMessagesRef.current.add(messageId);
                publish({
                    type: "chat-open",
                    source: "input-prompt-box",
                    openChat: openChat,
                    data: {
                        channelId: conversationId
                    }
                });
            }
        };
        $[4] = mounted;
        $[5] = publish;
        $[6] = stagingAreaEnabled;
        $[7] = t4;
    } else t4 = $[7];
    const publishChatOpen = t4;
    let t5;
    if ($[8] !== mounted || $[9] !== publish || $[10] !== stagingAreaEnabled) {
        t5 = (conversationId_0, messageId_0)=>{
            if (!publishedMessagesRef.current.has(messageId_0) && !mounted && !stagingAreaEnabled) {
                publishedMessagesRef.current.add(messageId_0);
                publish({
                    type: "open-smart-creation-modal",
                    source: "input-prompt-box",
                    openChat: false,
                    data: {
                        channelId: conversationId_0,
                        entryPoint: "dynamicUiFromInlineEditorToolbarAskRovo",
                        stagingAreaActive: true,
                        isFloating: true,
                        shouldShowBackButton: false
                    }
                });
            }
        };
        $[8] = mounted;
        $[9] = publish;
        $[10] = stagingAreaEnabled;
        $[11] = t5;
    } else t5 = $[11];
    const publishEphemeralPreviewOpen = t5;
    let t6;
    if ($[12] !== sendCommand) {
        t6 = (t7, invocationId)=>{
            const { message: message } = t7;
            const command = sendCommand((0, $i35QN.InlineInputBoxTraceMessageCommand), {
                message: message,
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId,
                buffer: false
            });
            return command.result();
        };
        $[12] = sendCommand;
        $[13] = t6;
    } else t6 = $[13];
    const onTraceMessage = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (action, messageId_1)=>new Promise((resolve)=>{
                if (!(0, $i7OAD.isEphemeralCreateAction)(action.message) && (0, $i7OAD.isUpdatableAction)(action.message) && (0, $iDrrr.fg)("platform_editor_ai_fix_update_backend_no_chat_open")) messagesWithUpdateActionsRef.current.add(messageId_1);
                resolve();
            });
        $[14] = t7;
    } else t7 = $[14];
    const onActionComplete = t7;
    let t8;
    if ($[15] !== editorIsViewMode || $[16] !== publishChatOpen || $[17] !== publishEphemeralPreviewOpen) {
        t8 = (actionPart, messageId_2, conversationId_1, openChat_0)=>new Promise((resolve_0)=>{
                if ((0, $i7OAD.isEphemeralCreateAction)(actionPart.message)) {
                    if (!editorIsViewMode && (0, $iDrrr.fg)("cc-maui-phase-2")) messagesWithUpdateActionsRef.current.add(messageId_2);
                    else publishEphemeralPreviewOpen(conversationId_1, messageId_2);
                } else if ((0, $i7OAD.isUpdatableAction)(actionPart.message)) messagesWithUpdateActionsRef.current.add(messageId_2);
                else publishChatOpen(conversationId_1, messageId_2, openChat_0);
                resolve_0();
            });
        $[15] = editorIsViewMode;
        $[16] = publishChatOpen;
        $[17] = publishEphemeralPreviewOpen;
        $[18] = t8;
    } else t8 = $[18];
    const onActionPart = t8;
    let t9;
    if ($[19] !== publishChatOpen) {
        t9 = (_, messageId_3, conversationId_2)=>new Promise((resolve_1)=>{
                if (!messagesWithUpdateActionsRef.current.has(messageId_3)) publishChatOpen(conversationId_2, messageId_3);
                resolve_1();
            });
        $[19] = publishChatOpen;
        $[20] = t9;
    } else t9 = $[20];
    const onAnswerPart = t9;
    let t10;
    if ($[21] !== sendCommand) {
        t10 = (response, invocationId_0)=>{
            const command_0 = sendCommand((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), {
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_0,
                buffer: false
            });
            messagesWithUpdateActionsRef.current.delete(invocationId_0);
            return command_0.result();
        };
        $[21] = sendCommand;
        $[22] = t10;
    } else t10 = $[22];
    const onFinalResponse = t10;
    let t11;
    if ($[23] !== sendCommand) {
        t11 = (error, invocationId_1, options)=>{
            if ("message" in error && error.message && typeof error.message === "object" && "key" in error.message && error.message.key === (0, $aYC8J.IMAGE_CREATE_KEY)) {
                const errorData = "data" in error.message ? error.message.data : undefined;
                (0, $4a71479a1e1aaf2c$export$cb00071f594190c2)(sendCommand, {
                    contentId: errorData?.contentId,
                    groupId: invocationId_1
                });
            }
            const command_1 = sendCommand((0, $9jFb0.InlineInputBoxErrorMessageCommand), {
                error: {
                    message: error.message,
                    metadata: error.metadata
                },
                receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
                groupId: invocationId_1,
                buffer: false,
                openChatOnError: options?.openChatOnError,
                conversationId: options?.conversationId
            });
            messagesWithUpdateActionsRef.current.delete(invocationId_1);
            return command_1.result();
        };
        $[23] = sendCommand;
        $[24] = t11;
    } else t11 = $[24];
    const onError = t11;
    let t12;
    if ($[25] !== onActionPart || $[26] !== onAnswerPart || $[27] !== onError || $[28] !== onFinalResponse || $[29] !== onTraceMessage) {
        t12 = {
            onTraceMessage: onTraceMessage,
            onActionPart: onActionPart,
            onActionComplete: onActionComplete,
            onAnswerPart: onAnswerPart,
            onFinalResponse: onFinalResponse,
            onError: onError
        };
        $[25] = onActionPart;
        $[26] = onAnswerPart;
        $[27] = onError;
        $[28] = onFinalResponse;
        $[29] = onTraceMessage;
        $[30] = t12;
    } else t12 = $[30];
    return t12;
} : ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const [{ isViewMode: editorIsViewMode } = {}] = (0, $gzMZq.useChatContextEditorContext)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { mounted: mounted } = (0, $bGNkz.useUIStore)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    // Track which messages have already called publish to avoid duplicate calls
    const publishedMessagesRef = (0, $cozmU.useRef)(new Set());
    // Track which messages have update actions to prevent processing publishChatOpen
    const messagesWithUpdateActionsRef = (0, $cozmU.useRef)(new Set());
    const stagingAreaEnabled = (0, $cozmU.useMemo)(()=>elements?.stagingAreaEnabled, [
        elements?.stagingAreaEnabled
    ]);
    const publishChatOpen = (0, $cozmU.useCallback)((conversationId, messageId, openChat)=>{
        if (!publishedMessagesRef.current.has(messageId) && !mounted && !stagingAreaEnabled) {
            publishedMessagesRef.current.add(messageId);
            publish({
                type: 'chat-open',
                source: 'input-prompt-box',
                openChat: openChat,
                data: {
                    channelId: conversationId
                }
            });
        }
    }, [
        publish,
        stagingAreaEnabled,
        mounted
    ]);
    const publishEphemeralPreviewOpen = (0, $cozmU.useCallback)((conversationId_0, messageId_0)=>{
        if (!publishedMessagesRef.current.has(messageId_0) && !mounted && !stagingAreaEnabled) {
            publishedMessagesRef.current.add(messageId_0);
            publish({
                type: 'open-smart-creation-modal',
                source: 'input-prompt-box',
                openChat: false,
                data: {
                    channelId: conversationId_0,
                    entryPoint: 'dynamicUiFromInlineEditorToolbarAskRovo',
                    stagingAreaActive: true,
                    isFloating: true,
                    shouldShowBackButton: false
                }
            });
        }
    }, [
        publish,
        stagingAreaEnabled,
        mounted
    ]);
    const onTraceMessage = (0, $cozmU.useCallback)(({ message: message }, invocationId)=>{
        const command = sendCommand((0, $i35QN.InlineInputBoxTraceMessageCommand), {
            message: message,
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId,
            buffer: false
        });
        return command.result();
    }, [
        sendCommand
    ]);
    const onActionComplete = (0, $cozmU.useCallback)((action, messageId_1)=>{
        return new Promise((resolve)=>{
            // Backend-persisted edits stream no incremental action parts, so completion is the
            // only signal that the document was updated before the answer arrives.
            // Ephemeral create actions are left to the action part flow, which opens a preview.
            if (!(0, $i7OAD.isEphemeralCreateAction)(action.message) && (0, $i7OAD.isUpdatableAction)(action.message) && (0, $iDrrr.fg)('platform_editor_ai_fix_update_backend_no_chat_open')) messagesWithUpdateActionsRef.current.add(messageId_1);
            resolve();
        });
    }, []);
    const onActionPart = (0, $cozmU.useCallback)((actionPart, messageId_2, conversationId_1, openChat_0)=>{
        return new Promise((resolve_0)=>{
            // Ephemeral create actions must be checked before update actions, since they are update actions too.
            if ((0, $i7OAD.isEphemeralCreateAction)(actionPart.message)) {
                if (!editorIsViewMode && (0, $iDrrr.fg)('cc-maui-phase-2')) // When phase-2 is enabled and in edit mode, suppress ephemeral preview —
                // the inline editor handles it. In view mode, always open the preview.
                messagesWithUpdateActionsRef.current.add(messageId_2);
                else // When phase-2 is disabled, open the AIFC modal in ephemeral preview mode
                publishEphemeralPreviewOpen(conversationId_1, messageId_2);
            } else if ((0, $i7OAD.isUpdatableAction)(actionPart.message)) // Temporary Patch to not open Rovo Chat on update actions
            messagesWithUpdateActionsRef.current.add(messageId_2);
            else publishChatOpen(conversationId_1, messageId_2, openChat_0);
            resolve_0();
        });
    }, [
        publishChatOpen,
        publishEphemeralPreviewOpen,
        editorIsViewMode
    ]);
    const onAnswerPart = (0, $cozmU.useCallback)((_, messageId_3, conversationId_2)=>{
        return new Promise((resolve_1)=>{
            if (!messagesWithUpdateActionsRef.current.has(messageId_3)) publishChatOpen(conversationId_2, messageId_3);
            resolve_1();
        });
    }, [
        publishChatOpen
    ]);
    const onFinalResponse = (0, $cozmU.useCallback)((response, invocationId_0)=>{
        const command_0 = sendCommand((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), {
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_0,
            buffer: false
        });
        // Clean up message tracking for this invocation
        messagesWithUpdateActionsRef.current.delete(invocationId_0);
        return command_0.result();
    }, [
        sendCommand
    ]);
    const onError = (0, $cozmU.useCallback)((error, invocationId_1, options)=>{
        // If the error is for an image-create action, signal the editor bridge to
        // clear the AI generating state from the existing image node
        if ('message' in error && error.message && typeof error.message === 'object' && 'key' in error.message && error.message.key === (0, $aYC8J.IMAGE_CREATE_KEY)) {
            const errorData = 'data' in error.message ? error.message.data : undefined;
            (0, $4a71479a1e1aaf2c$export$cb00071f594190c2)(sendCommand, {
                contentId: errorData?.contentId,
                groupId: invocationId_1
            });
        }
        const command_1 = sendCommand((0, $9jFb0.InlineInputBoxErrorMessageCommand), {
            error: {
                message: error.message,
                metadata: error.metadata
            },
            receiverId: (0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID),
            groupId: invocationId_1,
            buffer: false,
            openChatOnError: options?.openChatOnError,
            conversationId: options?.conversationId
        });
        // Clean up message tracking for this invocation
        messagesWithUpdateActionsRef.current.delete(invocationId_1);
        return command_1.result();
    }, [
        sendCommand
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onTraceMessage: onTraceMessage,
            onActionPart: onActionPart,
            onActionComplete: onActionComplete,
            onAnswerPart: onAnswerPart,
            onFinalResponse: onFinalResponse,
            onError: onError
        }), [
        onTraceMessage,
        onActionPart,
        onActionComplete,
        onAnswerPart,
        onFinalResponse,
        onError
    ]);
};


const $cd23f59678a0acda$export$4ae751989dace185 = ()=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const currentConversationIdRef = (0, $cozmU.useRef)(currentConversationId);
    currentConversationIdRef.current = currentConversationId;
    const { sendMessage: sendMessage, abortRequests: abortRequests } = (0, $3TxKn.useChatStoreActions)();
    const { getTarget: getTarget, getContentContext: getContentContext, getCurrentTargetId: getCurrentTargetId, setTarget: setTarget, clearTarget: clearTarget, getActiveContext: getActiveContext, setCurrentTargetId: setCurrentTargetId } = (0, $gzMZq.useChatContextStoreActions)();
    const promptStreamHook = (0, $c1435cb431a8c757$export$ef93491bca821fa2)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const [messageIdSelectedForPreview] = (0, $8akfd.useMessageIdSelectedForPreview)();
    const { stagingAreaEntryPoint: stagingAreaEntryPoint } = (0, $8akfd.useStagingAreaState)();
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = preferences;
    const messageIdSelectedForPreviewRef = (0, $cozmU.useRef)(messageIdSelectedForPreview);
    messageIdSelectedForPreviewRef.current = messageIdSelectedForPreview;
    const stagingAreaEntryPointRef = (0, $cozmU.useRef)(stagingAreaEntryPoint);
    stagingAreaEntryPointRef.current = stagingAreaEntryPoint;
    const trackAIMAUEventRef = (0, $cozmU.useRef)(trackAIMAUEvent);
    trackAIMAUEventRef.current = trackAIMAUEvent;
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const isFirstInlineMessageOnGlobalContent = (0, $cozmU.useRef)(false);
    const storeUserMessagesRef = (0, $cozmU.useRef)(storeUserMessages);
    storeUserMessagesRef.current = storeUserMessages;
    (0, $cozmU.useEffect)(()=>{
        // we don't want to clash between the rovo chat client which is offered and implemented in desktop
        // and web; in a future iteration, we will re-use the below code in desktop itself.
        if ((0, $95cHD.isWebviewContext)()) return;
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2BLI8.ContentReadyCommand), (command)=>{
            const ctx = command.contentContext;
            setTarget(ctx, {
                id: command.contentId,
                type: command.contentType,
                canProvideContext: command.canProvideContext
            });
            const currentContext = getActiveContext();
            isFirstInlineMessageOnGlobalContent.current = currentContext === 'global';
            // Mark this content as the active target for staging-area context.
            // This ensures broadcasts and follow-up messages use the correct content
            // even if the modal re-sets the page target.
            if ((ctx === 'staging-area' || currentContext === 'staging-area') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) setCurrentTargetId(command.contentId);
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2BLI8.ContentDestroyCommand), (command_0)=>{
            const ctx_0 = command_0.contentContext;
            // Targets are stored as arrays; clear by specific ID for the target content.
            clearTarget(ctx_0, command_0.contentId);
            const currentContext_0 = getActiveContext();
            isFirstInlineMessageOnGlobalContent.current = currentContext_0 === 'global';
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $3MoJD.InlineInputBoxSendMessageCommand), (command_1)=>{
            if (!command_1.prompt || !command_1.contentId) return;
            setCurrentTargetId(command_1.contentId);
            const encodedPrompt = command_1.skillMetadata ? (0, $6rwn6.encodePromptToAdf)(command_1.prompt, command_1.skillMetadata).adf : (0, $6rwn6.encodeAdf)(command_1.prompt);
            sendMessage({
                ...command_1,
                prompt: encodedPrompt,
                // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                storeUserMessages: storeUserMessagesRef.current,
                promptStreamHook: promptStreamHook,
                messageSources: {
                    interactionSource: command_1.source === 'CONFLUENCE_MAUI_INLINE_EDITOR' ? 'inlineRovoFromRemix' : 'inlineRovo',
                    // Mark the Create with Rovo blank-object route on AIMAU events.
                    entryPoint: command_1.source === 'CONFLUENCE_CWR_BLANK_OBJECT' ? 'cwrBlankObject' : undefined
                },
                // Using agents with inline prompt should always start a new chat
                // The first inline prompt message on a new content ID should always start a new chat
                conversationId: command_1.agentId || isFirstInlineMessageOnGlobalContent.current ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : undefined
            });
            isFirstInlineMessageOnGlobalContent.current = false;
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $6yHkF.InlineInputBoxAbortMessageCommand), ()=>{
            abortRequests({
                conversationId: currentConversationIdRef.current
            });
            if ((0, $ieeJu.expValEquals)('platform_editor_remove_pause_streaming', 'isEnabled', true)) {
                const currentTargetId = getCurrentTargetId();
                const currentTargetContext = currentTargetId ? getContentContext(currentTargetId) ?? getActiveContext() : getActiveContext();
                const activeTarget = getTarget(currentTargetContext, currentTargetId);
                const activeTargetType = activeTarget?.type;
                if (activeTarget?.id && activeTargetType === 'page') (0, $e4efc8cb7e22be34$export$ff6a2981a5436d75)((0, $jb3zd.StreamLifecycleState).ABORTED, `inline-abort-${Date.now()}`, {
                    id: activeTarget.id,
                    type: activeTargetType
                });
            }
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                reason: 'User cancelled remix thinking'
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $8gcBG.AifcExperienceTrackingCommand), (command_2)=>{
            if (!command_2?.status || !command_2.experienceName) return;
            if (command_2.status === 'start') {
                const isEditExperienceTrackerFixEnabled = !(0, $iDrrr.fg)('cc-maui-disable-edit-experience-tracker-fixes');
                const attributes = {
                    ...command_2.attributes || {},
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    },
                    ...command_2.remixType && {
                        remixType: command_2.remixType
                    },
                    ...command_2.remixSubtype && {
                        remixSubtype: command_2.remixSubtype
                    },
                    ...currentConversationIdRef.current && {
                        conversationChannelId: currentConversationIdRef.current
                    }
                };
                let collect;
                if (isEditExperienceTrackerFixEnabled) // Collect callbacks have to be constructed parent-side because functions are
                // not serializable and cannot be sent over the bridge as command payload data.
                switch(command_2.experienceName){
                    case (0, $irnO2.ExperienceName).REMIX_REGENERATE:
                        collect = (0, $d91d74abbb95cf45$export$a9538f4db585a467)({
                            conversationChannelId: currentConversationIdRef.current,
                            regenerateSource: command_2.attributes?.regenerateSource,
                            allowCollectFallback: true,
                            targetIds: {
                                actionId: command_2.actionId ?? undefined,
                                selectionLocalId: command_2.actionId ?? undefined
                            }
                        });
                        break;
                    default:
                        break;
                }
                experienceTracker.start({
                    name: command_2.experienceName,
                    id: command_2.messageId ?? command_2.actionId ?? command_2.experienceName,
                    attributes: attributes,
                    ...collect ? {
                        collect: collect
                    } : {}
                });
            } else if (command_2.status === 'success') experienceTracker.succeed({
                name: command_2.experienceName,
                ...command_2.messageId && {
                    id: command_2.messageId
                },
                attributes: {
                    ...command_2.attributes || {},
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    },
                    ...command_2.remixType && {
                        remixType: command_2.remixType
                    },
                    ...command_2.remixSubtype && {
                        remixSubtype: command_2.remixSubtype
                    }
                }
            });
            else if (command_2.status === 'fail') experienceTracker.fail({
                name: command_2.experienceName,
                ...command_2.messageId && {
                    id: command_2.messageId
                },
                error: new Error(command_2.error ?? 'Unknown error'),
                attributes: {
                    ...command_2.attributes || {},
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    }
                }
            });
            else if (command_2.status === 'abort') {
                const isKillswitchEnabled = (0, $cXtTj.default).getExperimentValue('platform_aifc_bridge_experience_tracker_fix_aborts', 'value', false);
                const attributes_0 = {
                    ...command_2.attributes || {},
                    ...command_2.actionType && {
                        actionType: command_2.actionType
                    },
                    ...command_2.actionId && {
                        actionId: command_2.actionId
                    },
                    ...command_2.contentContext && {
                        contentContext: command_2.contentContext
                    },
                    ...command_2.dynamicUiSubtype && {
                        dynamicUiSubtype: command_2.dynamicUiSubtype
                    }
                };
                if (isKillswitchEnabled) experienceTracker.fail({
                    name: command_2.experienceName,
                    ...command_2.messageId && {
                        id: command_2.messageId
                    },
                    error: new Error(command_2.reason ?? 'Aborted'),
                    attributes: attributes_0
                });
                else experienceTracker.abort({
                    name: command_2.experienceName,
                    ...command_2.messageId && {
                        id: command_2.messageId
                    },
                    reason: command_2.reason ?? 'Aborted',
                    attributes: attributes_0
                });
            }
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2YoG8.SmartCreationModalActivatedCommand), (command_3)=>{
            setTarget('staging-area', {
                id: command_3.type,
                // Currently, there is only Jira is using this Command and Jira doesn't have a content id for the smart creation modal
                type: command_3.type,
                canProvideContext: true
            });
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $2YoG8.SmartCreationModalDeactivatedCommand), (command_4)=>{
            if (getTarget('staging-area')?.id === command_4.type) {
                clearTarget('staging-area', command_4.type);
                if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) setCurrentTargetId(undefined);
            }
        });
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $j1J3n.AifcContentCopiedCommand), (command_5)=>{
            const askQuestionAttributes = (0, $ieeJu.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true) ? (0, $lUXDc.getConfluenceResultAcceptanceAttributesForAskQuestion)({
                messages: getMessages(currentConversationIdRef.current ?? ''),
                contentId: command_5.contentId
            }) : undefined;
            trackAIMAUEventRef.current({
                type: 'actioned',
                actionResult: 'copy',
                source: 'AIMate',
                invokedFrom: 'AIFC',
                proactive: false,
                userGenerated: true,
                singleInstrumentationID: messageIdSelectedForPreviewRef.current ?? undefined,
                attributes: {
                    isInSmartCreateFlow: true,
                    createdContentProduct: 'confluence',
                    createdContentType: command_5.contentType,
                    copiedCharCount: command_5.copiedCharCount,
                    copiedWordCount: command_5.copiedWordCount,
                    totalDocCharCount: command_5.totalDocCharCount,
                    copiedPercentage: command_5.copiedPercentage,
                    entryPoint: stagingAreaEntryPointRef.current || undefined,
                    ...askQuestionAttributes ?? {}
                }
            });
        });
        // handlers have been setup - now we can mark ourselves as 'ready' to handle incoming messages
        bridgeAPI.ready((0, $5Tn11.ROVO_CHAT_CLIENT_ID));
    }, [
        bridgeAPI,
        sendMessage,
        abortRequests,
        promptStreamHook,
        setTarget,
        clearTarget,
        getTarget,
        getContentContext,
        getCurrentTargetId,
        getActiveContext,
        setCurrentTargetId,
        experienceTracker,
        currentConversationId,
        getMessages
    ]);
    return null;
};















var $eTCWv = parcelRequire("eTCWv");











var $bxkJA = parcelRequire("bxkJA");


var $1teNl = parcelRequire("1teNl");











var $4Y660 = parcelRequire("4Y660");





var $lzoay = parcelRequire("lzoay");


var $dSoGR = parcelRequire("dSoGR");

const $3198e830c76ae77b$export$afe0f8c15b322bae = (0, $dSoGR.createCommand)('avp-chart-create-command');





const $36224131a47080f4$export$8e7b6355e5c9f9b8 = (0, $dSoGR.createCommand)('avp-chart-delete-command');





const $5c20a362f938841b$export$bf9f3058c24acaf7 = (0, $dSoGR.createCommand)('avp-chart-update-command');





const $2d7555c6a20a6e0d$export$30119ee169641415 = (0, $dSoGR.createCommand)('avp_dashboard_remove_element');





const $33b1e48b44bef4bc$export$1043d497905355c5 = (0, $dSoGR.createCommand)('avp_dashboard_remove_row');





const $a7e4d48d0be08f3f$export$60aa7d56c60ccf3 = (0, $dSoGR.createCommand)('avp-filter-expression-create-command');





const $75314bd107214525$export$8bcde83747cc4995 = (0, $dSoGR.createCommand)('avp-filter-expression-delete-command');





const $913d8206dd988764$export$70ff4e7a2a918421 = (0, $dSoGR.createCommand)('avp-filter-expression-update-command');



var $1HNcu = parcelRequire("1HNcu");


var $hwIq7 = parcelRequire("hwIq7");




const $9304f1c94bc0e75e$export$41fae3f948f80e82 = (0, $dSoGR.createCommand)('confluence-slides-create-command');



var $eDZUH = parcelRequire("eDZUH");


var $iL3p7 = parcelRequire("iL3p7");


var $6HplX = parcelRequire("6HplX");


var $3elg8 = parcelRequire("3elg8");


var $kFVAr = parcelRequire("kFVAr");







const $c835c164f3a5f5c5$export$1e1d6631b3e74025 = (0, $dSoGR.createCommand)('confluence-slides-update-command');



var $jd9s8 = parcelRequire("jd9s8");


var $joJ6c = parcelRequire("joJ6c");


var $j0orF = parcelRequire("j0orF");


var $irHFv = parcelRequire("irHFv");


var $1r5s7 = parcelRequire("1r5s7");


var $l3qz4 = parcelRequire("l3qz4");


var $2xH7b = parcelRequire("2xH7b");














var $2xjCL = parcelRequire("2xjCL");







const $3d563edd0e5ff26e$export$1fbbb7c0119badfd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $85mU8.getBrowserBridgeAPI)();
        $[0] = t0;
    } else t0 = $[0];
    const bridgeAPI = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (command, params)=>{
            const paramsWithRovoSenderId = {
                ...params,
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            };
            return bridgeAPI.broadcast(command, paramsWithRovoSenderId, {
                filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
            });
        };
        $[1] = t1;
    } else t1 = $[1];
    const broadcastConfirmedActionCommand = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            broadcastConfirmedActionCommand: broadcastConfirmedActionCommand
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const broadcastConfirmedActionCommand = (0, $cozmU.useCallback)((command, params)=>{
        const paramsWithRovoSenderId = {
            ...params,
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        };
        return bridgeAPI.broadcast(command, paramsWithRovoSenderId, {
            filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
        });
    }, [
        bridgeAPI
    ]);
    return {
        broadcastConfirmedActionCommand: broadcastConfirmedActionCommand
    };
};







var $jIWEY = parcelRequire("jIWEY");


const $571372d50c430197$var$cloneSerializableValue = (value)=>{
    if (value === undefined || value === null || typeof value !== 'object') return value;
    return typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? window.structuredClone(value) : JSON.parse(JSON.stringify(value));
};
const $571372d50c430197$export$392dcf789ba32ca6 = ()=>{
    const { sendCommand: sendCommand } = (0, $3Ak5G.useBridgeSendCommand)();
    const { broadcastConfirmedActionCommand: broadcastConfirmedActionCommand } = (0, $3d563edd0e5ff26e$export$1fbbb7c0119badfd)();
    const { productKey: productKey, smartCreationContext: smartCreationContext } = (0, $eKjv9.useGlobalConfig)();
    const sendBridgeCommand = (0, $cozmU.useCallback)(({ invocationId: invocationId, key: key, data: data, status: status, prompt: prompt, traceId: traceId, requestId: requestId, singleInstrumentationId: singleInstrumentationId, isFinalResponse: isFinalResponse = false, agent: agent, experience: experience })=>{
        const resolveEditorReceiverId = (contentId)=>contentId ?? (productKey !== 'confluence' && (0, $iDrrr.fg)('platform_editor_maui_jira_updates_1') ? smartCreationContext?.editor?.editorId : undefined) ?? (0, $93ce060b6123b497$export$365076dec8e1120e)();
        try {
            switch(key){
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY:
                case 0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCPageCreateActionData)(data)) {
                        sendCommand((0, $hwIq7.ConfluencePageCreateCommand), {
                            key: key,
                            data: data,
                            isStreamComplete: isFinalResponse,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            groupId: invocationId,
                            traceId: traceId,
                            singleInstrumentationId: singleInstrumentationId
                        });
                        if (status === 'PREPARING' && prompt) sendCommand((0, $3elg8.ConfluenceSubmitPromptOnPageCreateCommand), {
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            userPrompt: (0, $jIWEY.extractTextFromDocNode)(prompt)
                        });
                    }
                    break;
                case 0, $aYC8J.AIFC_ADF_UPDATE_KEY:
                    if ((0, $aYC8J.isAIFCADFUpdateActionData)(data)) sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId ?? (0, $93ce060b6123b497$export$365076dec8e1120e)()),
                        groupId: invocationId,
                        traceId: traceId,
                        requestId: requestId,
                        singleInstrumentationId: singleInstrumentationId,
                        agentId: agent?.id,
                        agentName: agent?.name,
                        agentIdentityAccountId: agent?.identityAccountId,
                        // Mark inline edits so the editor receiver only
                        // auto-opens the Post Stream Review "Review moment" for them.
                        isInlineEdit: experience === 'inline_edit'
                    });
                    break;
                case 0, $aYC8J.DYNAMIC_UI_CREATE_KEY:
                case 0, $aYC8J.IMAGE_CREATE_KEY:
                    if ((0, $aYC8J.isDynamicUiUpdateActionData)(data) || (0, $aYC8J.isImageUpdateActionData)(data) || (0, $aYC8J.isImageCreateData)(data)) sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(resolveEditorReceiverId(data.contentId)),
                        groupId: invocationId,
                        traceId: traceId,
                        requestId: requestId,
                        singleInstrumentationId: singleInstrumentationId
                    });
                    else if (key === (0, $aYC8J.IMAGE_CREATE_KEY) && (0, $aYC8J.isImageUpdatePrepareData)(data) && !isFinalResponse) // ACTION_PREPARE: send partial data to trigger loading state on the existing image
                    sendCommand((0, $dE5YE.ConfluenceUpdatePageCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: false,
                        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(resolveEditorReceiverId(data.contentId)),
                        groupId: invocationId,
                        traceId: traceId,
                        requestId: requestId,
                        singleInstrumentationId: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.AIFC_ACTION_CLASSIFICATION_METADATA:
                    if ((0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) {
                        if ((0, $aYC8J.isAIFCADFSetActionClassificationActionData)(data)) sendCommand((0, $lzoay.ActionClassificationCommand), {
                            data: data,
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                            groupId: invocationId
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionData)(data)) sendCommand((0, $6HplX.ConfluenceDeepResearchPageCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data.contentId),
                        groupId: invocationId
                    });
                    // TODO: Remove isConfluenceAIFCDeepResearchPageCreateActionPrepare condition and type once BE fix is in
                    // https://hello.jira.atlassian.cloud/browse/CCI-12965
                    if ((0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionPrepare)(data) || (0, $aYC8J.isConfluenceAIFCDeepResearchPageCreateActionData)(data)) {
                        if (status === 'PREPARING' && prompt) sendCommand((0, $3elg8.ConfluenceSubmitPromptOnPageCreateCommand), {
                            receiverId: (0, $5OXoi.getConfluenceEditorClientId)(data?.contentId),
                            userPrompt: (0, $jIWEY.extractTextFromDocNode)(prompt)
                        });
                    }
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) sendCommand((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SLIDES_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSlidesCreateActionData)(data)) sendCommand((0, $9304f1c94bc0e75e$export$41fae3f948f80e82), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $3wccB.getConfluenceSlidesClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SLIDES_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSlidesUpdateActionData)(data)) sendCommand((0, $c835c164f3a5f5c5$export$1e1d6631b3e74025), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $3wccB.getConfluenceSlidesClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDatabaseCreateActionData)(data)) sendCommand((0, $1HNcu.ConfluenceDatabaseCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $7lXV4.getConfluenceDatabaseClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_DATABASE_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCDatabaseUpdateActionData)(data)) sendCommand((0, $kFVAr.ConfluenceDatabaseUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $7lXV4.getConfluenceDatabaseClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardUpdateActionData)(data)) sendCommand((0, $joJ6c.ConfluenceWhiteboardUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY:
                    if ((0, $aYC8J.isConfluenceWhiteboardBrainstormingActionData)(data)) sendCommand((0, $j0orF.ConfluenceWhiteboardBrainstormingCommand), {
                        key: key,
                        data: data,
                        status: status,
                        // Brainst. agent sends `status=SUCCESS` in the last message of the stream to mark end of data
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
                    if ((0, $aYC8J.isConfluenceWhiteboardDiagrammingActionData)(data)) sendCommand((0, $irHFv.ConfluenceWhiteboardDiagrammingCommand), {
                        key: key,
                        data: data,
                        status: status,
                        // Diag. agent sends `status=SUCCESS` in the last message of the stream to mark end of data
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
                    // This new key goes through the new AIFC flow for diagramming
                    // Before we were going through the legacy flow, LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY
                    if ((0, $aYC8J.isConfluenceAIFCWhiteboardCreateActionData)(data)) sendCommand((0, $iL3p7.ConfluenceWhiteboardCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $6isLN.getConfluenceWhiteboardClientId)(data.contentId),
                        groupId: invocationId,
                        singleInstrumentationID: singleInstrumentationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SPACE_CREATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSpaceCreateActionData)(data)) sendCommand((0, $eDZUH.ConfluenceSpaceCreateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
                        groupId: invocationId
                    });
                    break;
                case 0, $aYC8J.CONFLUENCE_AIFC_SPACE_UPDATE_KEY:
                    if ((0, $aYC8J.isConfluenceAIFCSpaceUpdateActionData)(data)) sendCommand((0, $jd9s8.ConfluenceSpaceUpdateCommand), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_CREATE_KEY:
                    if ((0, $eTCWv.isAvpChartCreateActionData)(data)) sendCommand((0, $3198e830c76ae77b$export$afe0f8c15b322bae), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_DELETE_KEY:
                    if ((0, $eTCWv.isAvpChartDeleteActionData)(data)) sendCommand((0, $36224131a47080f4$export$8e7b6355e5c9f9b8), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_CHART_UPDATE_KEY:
                    if ((0, $eTCWv.isAvpChartUpdateActionData)(data)) sendCommand((0, $5c20a362f938841b$export$bf9f3058c24acaf7), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_DASHBOARD_REMOVE_ROW_KEY:
                    if ((0, $eTCWv.isAvpDashboardRemoveRowActionData)(data)) sendCommand((0, $33b1e48b44bef4bc$export$1043d497905355c5), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_DASHBOARD_REMOVE_ELEMENT_KEY:
                    if ((0, $eTCWv.isAvpDashboardRemoveElementActionData)(data)) sendCommand((0, $2d7555c6a20a6e0d$export$30119ee169641415), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_CREATE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionCreateActionData)(data)) sendCommand((0, $a7e4d48d0be08f3f$export$60aa7d56c60ccf3), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_DELETE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionDeleteActionData)(data)) sendCommand((0, $75314bd107214525$export$8bcde83747cc4995), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                case 0, $eTCWv.AVP_FILTER_EXPRESSION_UPDATE_KEY:
                    if ((0, $eTCWv.isAvpFilterExpressionUpdateActionData)(data)) sendCommand((0, $913d8206dd988764$export$70ff4e7a2a918421), {
                        key: key,
                        data: data,
                        isStreamComplete: isFinalResponse,
                        receiverId: (0, $1teNl.getAvpDashboardClientId)(data.dashboardAri),
                        groupId: invocationId
                    });
                    break;
                default:
                    (0, $hlvTd.logException)({
                        exception: new Error(`Unsupported action key: ${key}`),
                        name: 'SendBridgeCommandUnsupportedActionKey'
                    });
                    break;
            }
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendBridgeCommandError'
            });
        }
    }, [
        sendCommand,
        productKey,
        smartCreationContext
    ]);
    // receiver
    const processMessageStreamAction = (0, $cozmU.useCallback)((invocationId_0, streamAction, traceId_0, requestId_0, prompt_0, attributes, agent_0)=>{
        const { message: action } = streamAction;
        if (!(0, $i7OAD.isSupportedStreamAction)(action)) return;
        sendBridgeCommand({
            invocationId: invocationId_0,
            key: action.key,
            data: action.data,
            status: action.status,
            prompt: prompt_0,
            isFinalResponse: false,
            traceId: traceId_0,
            requestId: requestId_0,
            singleInstrumentationId: attributes?.singleInstrumentationId,
            agent: agent_0,
            experience: attributes?.experience
        });
    }, [
        sendBridgeCommand
    ]);
    const processMessageStreamComplete = (0, $cozmU.useCallback)((invocationId_1, streamAction_0, traceId_1, requestId_1, attributes_0)=>{
        const { message: action_0 } = streamAction_0;
        if (!(0, $i7OAD.isSupportedStreamAction)(action_0)) return;
        // metadata is only available on ACTION_COMPLETE for editing remix.
        if (action_0.key === 'dynamic-ui-create' || action_0.key === 'image-create') {
            (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).ACTION_COMPLETE_RECEIVED);
            const actionData = action_0.data;
            // marking image create to infographic to be same as generating preview
            if (action_0.key === 'image-create') (0, $irnO2.remixEditExistingExperience).addMetadata({
                remixType: 'infographic'
            });
            else (0, $irnO2.remixEditExistingExperience).addMetadata({
                remixType: actionData?.contentType,
                remixSubtype: actionData?.dynamicUiSubtype
            });
        }
        sendBridgeCommand({
            invocationId: invocationId_1,
            key: action_0.key,
            data: action_0.data,
            isFinalResponse: true,
            traceId: traceId_1,
            requestId: requestId_1,
            singleInstrumentationId: attributes_0?.singleInstrumentationId,
            experience: attributes_0?.experience
        });
    }, [
        sendBridgeCommand
    ]);
    const processMessageStreamError = (0, $cozmU.useCallback)((errorInfo)=>{
        // Fail the remix-edit-existing UFO experience when the stream errors.
        // .failure() is a no-op on a non-started experience, so this is safe
        // for non-remix-edit-existing flows.
        if (errorInfo.actionKey === 'dynamic-ui-create' || errorInfo.actionKey === 'image-create') (0, $irnO2.remixEditExistingExperience).failure({
            metadata: {
                errorType: errorInfo.errorType,
                errorMessage: errorInfo.errorMessage,
                traceId: errorInfo.traceId
            }
        });
    }, []);
    const processMessageStreamActionClassification = (0, $cozmU.useCallback)((invocationId_2, streamActionClassification, traceId_2, requestId_2, attributes_1)=>{
        if (streamActionClassification.message.metadata && (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) sendBridgeCommand({
            invocationId: invocationId_2,
            key: (0, $aYC8J.AIFC_ACTION_CLASSIFICATION_METADATA),
            data: streamActionClassification.message.metadata,
            isFinalResponse: false,
            traceId: traceId_2,
            requestId: requestId_2,
            singleInstrumentationId: attributes_1?.singleInstrumentationId
        });
    }, [
        sendBridgeCommand
    ]);
    /**
   * Broadcasts confirmed message actions to subscribed clients.
   *
   * Iterates over the provided list of actions, and for each action that is confirmed
   * (as determined by `isConfirmAction`), it sends a broadcast command using
   * `broadcastConfirmedActionCommand`. The broadcast includes the action's key and
   * the provided invocation ID as the group identifier.
   *
   * @param invocationId - The unique identifier for the current invocation or group.
   * @param actions - An array of message action payload contexts to be checked and broadcasted if confirmed.
   */ const broadcastConfirmedActions = (0, $cozmU.useCallback)((invocationId_3, actions)=>{
        for (const action_1 of actions)if ((0, $bxkJA.isConfirmAction)(action_1)) broadcastConfirmedActionCommand((0, $2xH7b.RovoBroadcastConfirmedActionsCommand), {
            key: action_1.key,
            groupId: invocationId_3
        });
    }, [
        broadcastConfirmedActionCommand
    ]);
    const getContentBody = (0, $cozmU.useCallback)(async ({ type: type, id: id, source: source, prompt: prompt_1 })=>{
        const identifier = String(id);
        let receiverId;
        switch(type){
            case 'page':
                receiverId = (0, $5OXoi.getConfluenceEditorClientId)(identifier);
                break;
            case 'whiteboard':
                receiverId = (0, $6isLN.getConfluenceWhiteboardClientId)(identifier);
                break;
            case 'slide':
                receiverId = (0, $3wccB.getConfluenceSlidesClientId)(identifier);
                break;
            case 'database':
                receiverId = (0, $7lXV4.getConfluenceDatabaseClientId)(identifier);
                break;
            case 'dashboard':
                receiverId = (0, $1teNl.getAvpDashboardClientId)(identifier);
                break;
            default:
                receiverId = (0, $5OXoi.getConfluenceEditorClientId)(identifier);
        }
        const shouldSendFastPathInputs = (0, $ieeJu.expValEquals)('platform_editor_ai_minion_skip_orchestrator', 'isEnabled', true);
        const shouldSendSource = source !== undefined && shouldSendFastPathInputs;
        const shouldSendPrompt = prompt_1 !== undefined && shouldSendFastPathInputs;
        const invocation = sendCommand((0, $1r5s7.ReadContentCommand), {
            receiverId: receiverId,
            buffer: false,
            ...shouldSendSource ? {
                source: source
            } : {},
            ...shouldSendPrompt ? {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- DocNode is serializable ADF, but its type does not satisfy the bridge SerializableValue index signature.
                prompt: $571372d50c430197$var$cloneSerializableValue(prompt_1)
            } : {}
        });
        return invocation.result();
    }, [
        sendCommand
    ]);
    const getStagingSpace = (0, $cozmU.useCallback)((id_0)=>sendCommand((0, $l3qz4.ReadSpaceCommand), {
            id: id_0,
            receiverId: (0, $4Y660.CONFLUENCE_SPACE_CLIENT_ID),
            buffer: false
        }).result(), [
        sendCommand
    ]);
    return {
        getContentBody: getContentBody,
        getStagingSpace: getStagingSpace,
        processMessageStreamAction: processMessageStreamAction,
        processMessageStreamComplete: processMessageStreamComplete,
        processMessageStreamError: processMessageStreamError,
        processMessageStreamActionClassification: processMessageStreamActionClassification,
        broadcastStreamStatus: $e4efc8cb7e22be34$export$ff6a2981a5436d75,
        broadcastConfirmedActions: broadcastConfirmedActions
    };
};








const $8447bc9ff2b3f038$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        initiator: 'unknown',
        initiatorApplied: false
    },
    actions: {
        initChatInitiator: (initiator)=>({ setState: setState, getState: getState })=>{
                if (!getState().initiatorApplied) setState({
                    initiator: initiator ?? 'unknown',
                    initiatorApplied: true
                });
            },
        getChatInitiator: ()=>({ getState: getState })=>{
                return getState().initiator;
            }
    }
});


const $70f03fc4cd84995c$export$8a56a4af5643d61b = (0, $kBr4q.createActionsHook)((0, $8447bc9ff2b3f038$export$6f57813fe9f31bf9));



var $guRLk = parcelRequire("guRLk");










const $37f0dfcbe79a956a$export$1e02c4fe277d3d74 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    let t0;
    if ($[0] !== setChatMode) {
        t0 = (newConversationId, mode)=>{
            setChatMode(newConversationId, {
                reasoningMode: mode.deepResearchEnabled ? "deep-research" : mode.thinkDeeperEnabled ? mode.alphaExtendedThinkingMode === "LONG_HORIZON" ? "think-deeper-orchestrator" : mode.alphaExtendedThinkingMode === "MARATHON" ? "think-deeper-marathon" : "think-deeper" : mode.planModeEnabled ? "task" : mode.fastModeEnabled ? "fast" : "auto",
                webSearchEnabled: mode.webSearchEnabled ?? false,
                sourceMode: mode.sourceMode ?? "GENERAL",
                useCurrentPageContext: mode.useCurrentPageContext ?? false,
                appFilters: mode.appFilters
            });
        };
        $[0] = setChatMode;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    return (newConversationId, mode)=>{
        setChatMode(newConversationId, {
            // TODO: ROVOFE-1411 - refactor into passing the reasoningMode directly
            reasoningMode: mode.deepResearchEnabled ? 'deep-research' : mode.thinkDeeperEnabled ? mode.alphaExtendedThinkingMode === 'LONG_HORIZON' ? 'think-deeper-orchestrator' : mode.alphaExtendedThinkingMode === 'MARATHON' ? 'think-deeper-marathon' : 'think-deeper' : mode.planModeEnabled ? 'task' : mode.fastModeEnabled ? 'fast' : 'auto',
            webSearchEnabled: mode.webSearchEnabled ?? false,
            sourceMode: mode.sourceMode ?? 'GENERAL',
            useCurrentPageContext: mode.useCurrentPageContext ?? false,
            appFilters: mode.appFilters
        });
    };
};



var $j8on0 = parcelRequire("j8on0");





var $4tJut = parcelRequire("4tJut");


var $lx3cN = parcelRequire("lx3cN");


var $7eGGZ = parcelRequire("7eGGZ");


var $dHz2q = parcelRequire("dHz2q");

/**
 * ************************************************************
 * Container
 * ************************************************************
 */ const $07964e27dfae7b36$var$storeInit = ()=>async ({ dispatch: dispatch }, { setChatStatus: setChatStatus, skipAutoConversationSelection: skipAutoConversationSelection })=>{
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: storeInit');
        setChatStatus('launching');
        // Init conversation hydrates the chat store with conversation from URL or Storage
        // and fetches conversations list (however, fetching conversations list is performed "in the background")
        // conversations list is fetched to be later on displayed in the sidebar/conversation list to remove/minimize
        // visual delay when user opens the side-navigation; or in full-screen mode to fetch conversations as early as possible;
        const initConversation = async ()=>{
            dispatch((0, $dHz2q.hydrateConversationWithExternalParams)({
                autoSelectConversation: !skipAutoConversationSelection
            }));
            (0, $4tJut.interactionMetrics).initializeChannels.start();
            await dispatch((0, $7eGGZ.fetchConversationChannelsData)({
                isInitialLoad: true
            }));
            (0, $4tJut.interactionMetrics).initializeChannels.stop();
        };
        initConversation();
        (0, $hlvTd.addSentryBreadcrumb)('ChatStoreContainer: storeInit completed');
    };
const $07964e27dfae7b36$var$storeInitOnUpdate = ()=>{
    return ()=>{};
};
const $07964e27dfae7b36$var$chatStoreContainerOptions = {
    onInit: $07964e27dfae7b36$var$storeInit,
    onUpdate: $07964e27dfae7b36$var$storeInitOnUpdate
};
const $07964e27dfae7b36$export$9b7b433b0520b82b = (0, $j8on0.createContainer)((0, $lx3cN.chatStore), $07964e27dfae7b36$var$chatStoreContainerOptions);



var $iDdTC = parcelRequire("iDdTC");

const $67bde2f896c04cc0$export$d077ccae10682bac = {
    createViewDeadAirMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.view-dead-air'
        });
    }
};


/**
 * Calculates the total excess dead air time above a given threshold.
 * For each interval exceeding the threshold, only the portion above the threshold is summed.
 * Example: threshold=3000, intervals=[2000, 4000, 5000] => (4000-3000) + (5000-3000) = 3000
 */ function $ed4bda8939492652$export$f21d08fe326f3fd8(intervals, thresholdMs) {
    return intervals.filter((interval)=>interval > thresholdMs).reduce((sum, interval)=>sum + (interval - thresholdMs), 0);
}


const $af849802a7ce9421$export$d679f89c82173941 = (conditions)=>{
    return(// AIFC: Not tracking the full extent of AIFC flow. Visual changes in the staging area
    // (where content is created/modified) are not instrumented, resulting in incomplete metrics.
    conditions.isAIFC || // Deep Research: Has a separate research steps view/handler not tracked by ViewDeadAirTracker.
    // Requires additional instrumentation work to capture accurately.
    conditions.isDeepResearch);
};



var $cWJWG = parcelRequire("cWJWG");

const $3a2dcf28cd216b6e$var$createInitialState = ()=>({
        isActive: false,
        sessionConfig: null,
        startTimestamp: 0,
        previousMark: null,
        intervals: [],
        maxDeadAirMs: 0,
        finishedOnce: false,
        identity: null
    });
const $3a2dcf28cd216b6e$var$LOG_PREFIX = '[ViewDeadAir]';
const $3a2dcf28cd216b6e$var$DEBUG_LOGGING = false; // Set to true for debugging
// Threshold constants in milliseconds
const $3a2dcf28cd216b6e$var$THRESHOLD_3_SECONDS = 3000;
const $3a2dcf28cd216b6e$var$THRESHOLD_5_SECONDS = 5000;
const $3a2dcf28cd216b6e$var$THRESHOLD_7_SECONDS = 7000;
function $3a2dcf28cd216b6e$export$e75a25d5c6776a72(brokerConfig) {
    let state = $3a2dcf28cd216b6e$var$createInitialState();
    function start(config) {
        // If a session was active and never finished, finish it first to avoid losing data
        if (state.isActive && !state.finishedOnce) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interrupting active session to start new one`);
            finish('interrupted');
        }
        // Preserve identity across session resets
        const currentIdentity = state.identity;
        state = $3a2dcf28cd216b6e$var$createInitialState();
        state.identity = currentIdentity;
        state.isActive = true;
        state.sessionConfig = config;
        state.startTimestamp = performance.now();
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Session started:`, config);
    }
    function mark({ id: id, contentType: contentType }) {
        if (!state.isActive) return;
        const now = performance.now();
        const currentMark = {
            id: id,
            contentType: contentType,
            timestamp: now
        };
        if (!state.previousMark) {
            // First mark — interval from session start
            const interval = now - state.startTimestamp;
            if ((0, $cWJWG.shouldExcludeInterval)(interval)) {
                state.previousMark = currentMark;
                return;
            }
            state.intervals.push(interval);
            state.maxDeadAirMs = interval;
            state.previousMark = currentMark;
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interval: ${interval.toFixed(1)}ms Mark: id=${id}, contentType=${contentType}`);
            return;
        }
        // Aggregate consecutive stream marks with same id and same contentType
        if (contentType === 'stream' && state.previousMark.id === id && state.previousMark.contentType === 'stream') {
            state.previousMark.timestamp = now;
            return;
        }
        const interval = now - state.previousMark.timestamp;
        if ((0, $cWJWG.shouldExcludeInterval)(interval)) {
            state.previousMark = currentMark;
            return;
        }
        state.intervals.push(interval);
        if (interval > state.maxDeadAirMs) state.maxDeadAirMs = interval;
        state.previousMark = currentMark;
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} interval: ${interval.toFixed(1)}ms Mark: id=${id}, contentType=${contentType}`);
    }
    function finish(reason) {
        if (state.finishedOnce || !state.isActive) return;
        state.finishedOnce = true;
        state.isActive = false;
        const { intervals: intervals, maxDeadAirMs: maxDeadAirMs, sessionConfig: sessionConfig } = state;
        // Calculate excess dead air time above thresholds
        const excessDeadAirAbove3s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_3_SECONDS);
        const excessDeadAirAbove5s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_5_SECONDS);
        const excessDeadAirAbove7s = (0, $ed4bda8939492652$export$f21d08fe326f3fd8)(intervals, $3a2dcf28cd216b6e$var$THRESHOLD_7_SECONDS);
        const result = {
            sessionConfig: sessionConfig,
            reason: reason,
            intervals: intervals,
            maxDeadAirMs: maxDeadAirMs
        };
        brokerConfig?.onEmit?.(result);
        const shouldSkip = (0, $af849802a7ce9421$export$d679f89c82173941)({
            isAIFC: sessionConfig?.isAIFCEnabled ?? false,
            isDeepResearch: sessionConfig?.reasoningMode === 'deep-research'
        });
        if (shouldSkip) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Skipping metrics (AIFC=${sessionConfig?.isAIFCEnabled}, reasoningMode=${sessionConfig?.reasoningMode})`);
            return;
        }
        // Send browser metric - truncate all numeric values to integers before egress
        const metric = (0, $67bde2f896c04cc0$export$d077ccae10682bac).createViewDeadAirMetrics();
        const now = performance.now();
        const intervalsInt = intervals.map((i)=>Math.trunc(i));
        metric.start({
            startTime: now - maxDeadAirMs
        });
        metric.stop({
            stopTime: now,
            customData: {
                // Session config
                messageId: sessionConfig?.messageId ?? '',
                conversationId: sessionConfig?.conversationId ?? '',
                traceId: sessionConfig?.traceId ?? '',
                productKey: sessionConfig?.productKey ?? '',
                reasoningMode: sessionConfig?.reasoningMode ?? '',
                isAIFCEnabled: sessionConfig?.isAIFCEnabled ?? false,
                isWebSearchEnabled: sessionConfig?.isWebSearchEnabled ?? false,
                reason: // Result data
                reason,
                maxDeadAirMs: Math.trunc(maxDeadAirMs),
                intervalCount: intervalsInt.length,
                intervals: JSON.stringify(intervalsInt),
                // Excess dead air time above thresholds
                excessDeadAirAbove3s: Math.trunc(excessDeadAirAbove3s),
                excessDeadAirAbove5s: Math.trunc(excessDeadAirAbove5s),
                excessDeadAirAbove7s: Math.trunc(excessDeadAirAbove7s)
            }
        });
        if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
        console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} Session finished (${reason}):`, {
            intervals: result.intervals,
            maxDeadAirMs: result.maxDeadAirMs,
            excessDeadAirAbove3s: excessDeadAirAbove3s,
            excessDeadAirAbove5s: excessDeadAirAbove5s,
            excessDeadAirAbove7s: excessDeadAirAbove7s
        });
    }
    function updateIdentity(newIdentity) {
        // If session is active and identity changed, finish the current session
        if (state.isActive && state.identity !== null && state.identity !== newIdentity) {
            if ($3a2dcf28cd216b6e$var$DEBUG_LOGGING) // eslint-disable-next-line no-console
            console.log(`${$3a2dcf28cd216b6e$var$LOG_PREFIX} identity changed from ${state.identity} to ${newIdentity}, finishing session`);
            finish('identity-changed');
        }
        state.identity = newIdentity;
    }
    return {
        start: start,
        mark: mark,
        finish: finish,
        updateIdentity: updateIdentity
    };
}

















/**
 * Warms the smart-link store for the chat `<ContextBanner>` URL so the
 * inline SmartCard mounts already `'resolved'` and the
 * `smart-card-inline-card` UFO hold never registers.
 */ 



var $cMyWi = parcelRequire("cMyWi");


var $fxYwc = parcelRequire("fxYwc");













const $3cb83a1eb7ebc9e6$var$MAX_FIRED_KEYS = 100;
const $3cb83a1eb7ebc9e6$export$d2d09ba8afc1e816 = (condition, key, fire)=>{
    const firedKeysRef = (0, $cozmU.useRef)(new Set());
    if (condition && key && !firedKeysRef.current.has(key)) {
        firedKeysRef.current.add(key);
        if (firedKeysRef.current.size > $3cb83a1eb7ebc9e6$var$MAX_FIRED_KEYS) {
            const oldestKey = firedKeysRef.current.values().next().value;
            if (oldestKey !== undefined) firedKeysRef.current.delete(oldestKey);
        }
        fire();
    }
};






var $2NrpD = parcelRequire("2NrpD");


var $jOKtZ = parcelRequire("jOKtZ");


var $76AAr = parcelRequire("76AAr");

// Singleflight: promises are reusable, so one Map entry covers both
// in-flight and settled.
const $1d6888cf104f54b7$var$warmResolveCache = new Map();
const $1d6888cf104f54b7$var$getOrCreateWarmResolve = (url)=>{
    let promise = $1d6888cf104f54b7$var$warmResolveCache.get(url);
    if (!promise) {
        promise = $1d6888cf104f54b7$var$fetchResolveBatch(url);
        $1d6888cf104f54b7$var$warmResolveCache.set(url, promise);
    }
    return promise;
};
/**
 * Direct POST instead of `client.fetchData` — the public API goes through a
 * dataloader with a ~250 ms throttle that defeats the head-start window.
 * Endpoint shape mirrors `CardClient.postBatchResolve` (private).
 */ const $1d6888cf104f54b7$var$fetchResolveBatch = async (url)=>{
    try {
        const response = await fetch('/gateway/api/object-resolver/resolve/batch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'origin-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            credentials: 'include',
            body: JSON.stringify([
                {
                    resourceUrl: url
                }
            ])
        });
        if (!response.ok) return null;
        const data = await response.json().catch(()=>undefined);
        const first = Array.isArray(data) ? data[0] : undefined;
        if (first?.status === 200 && 'body' in first) return first.body;
        return null;
    } catch  {
        return null;
    }
};
const $1d6888cf104f54b7$export$9317dfcbec30a2cc = ({ enableBrowserContextBanner: enableBrowserContextBanner, useCurrentPageContext: useCurrentPageContext = true, isSpaceScopedConversation: isSpaceScopedConversation })=>{
    const smartLinkCtx = (0, $cMyWi.useSmartLinkContext)();
    const experience = (0, $bjY3F.useAIMateExperienceTracker)();
    const [{ projectContext: projectContext }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const { currentContext: currentContext } = (0, $hOUgz.useCurrentPageAsContext)();
    const sharedContext = (0, $cozmU.useMemo)(()=>{
        if (projectContext?.projectUrl) return {
            type: (0, $2NrpD.ENTITY_CONTEXT_TYPE),
            url: projectContext.projectUrl,
            name: projectContext.projectName
        };
        return currentContext;
    }, [
        currentContext,
        projectContext?.projectName,
        projectContext?.projectUrl
    ]);
    // Browser-context URL arrives async after warm time; force current-page/entity URL derivation here.
    const { displayUrl: url } = (0, $76AAr.useContextBannerSmartLinkInfo)({
        currentContext: sharedContext,
        hasBrowserContext: false,
        browserContextUrl: undefined
    });
    const store = smartLinkCtx?.store;
    const client = smartLinkCtx?.connections?.client;
    // Browser-ext URL (`browserContext.browserUrl`) populates async after warm
    // time; skip rather than warm the wrong URL.
    const isBrowserContextBannerFlow = !!enableBrowserContextBanner;
    const hasActiveContextForWarm = !!projectContext?.projectUrl || currentContext?.type === 'current_page';
    const shouldRenderBannerSmartCard = (0, $jOKtZ.shouldRenderContextBannerSmartCard)({
        useCurrentPageContext: useCurrentPageContext,
        isSpaceScopedConversation: isSpaceScopedConversation,
        hasActiveEditorContext: hasActiveContextForWarm
    });
    const storeHasUrl = !!store && store.getState()[url] !== undefined;
    const shouldWarm = !!url && !!store && !!client && shouldRenderBannerSmartCard && !isBrowserContextBannerFlow && // One-shot snapshot (no subscription); the consumer's store wiring
    // handles later changes.
    !storeHasUrl;
    // Render-time fire is intentional: `<SmartCard>` calls `client.fetchData`
    // from a render-time `useResolve` hook, so post-commit paths start too
    // late. Strict-Mode safety is preserved by the module-level
    // `warmResolveCache` singleflight (the second fire is a no-op).
    (0, $3cb83a1eb7ebc9e6$export$d2d09ba8afc1e816)(shouldWarm, 'initial-context-banner-url', ()=>{
        const targetUrl = url;
        const targetStore = store;
        experience.start({
            id: (0, $irnO2.ExperienceName).WARM_CONTEXT_BANNER_LINK,
            name: (0, $irnO2.ExperienceName).WARM_CONTEXT_BANNER_LINK
        });
        (async ()=>{
            const body = await $1d6888cf104f54b7$var$getOrCreateWarmResolve(targetUrl);
            if (body !== null) {
                // Cast at boundary: ResolvedBody is `unknown` to avoid a `@atlaskit/json-ld-types` dep.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                targetStore.dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RESOLVED), {
                    url: targetUrl
                }, body));
                experience.succeed({
                    name: (0, $irnO2.ExperienceName).WARM_CONTEXT_BANNER_LINK
                });
            } else experience.abort({
                name: (0, $irnO2.ExperienceName).WARM_CONTEXT_BANNER_LINK,
                reason: 'warm-resolve-failed'
            });
        })();
    });
    return null;
};






var $5wAPd = parcelRequire("5wAPd");

const $880313826a79edf3$export$e17502d4af1a1395 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { enableBrowserContextBanner: enableBrowserContextBanner, shouldShowContextBanner: shouldShowContextBanner, stagingAreaEnabled: stagingAreaEnabled } = t0;
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, selectedSpace: selectedSpace } = (0, $bGNkz.useUIStore)();
    const useCurrentPageContext = shouldShowContextBanner !== false && !stagingAreaEnabled && !isChatOnboardingMiniModalOpen;
    const isSpaceScopedConversation = Boolean(conversation?.rovoSpaceId || selectedSpace);
    let t1;
    if ($[0] !== enableBrowserContextBanner || $[1] !== isSpaceScopedConversation || $[2] !== useCurrentPageContext) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d6888cf104f54b7$export$9317dfcbec30a2cc), {
            enableBrowserContextBanner: enableBrowserContextBanner,
            useCurrentPageContext: useCurrentPageContext,
            isSpaceScopedConversation: isSpaceScopedConversation
        });
        $[0] = enableBrowserContextBanner;
        $[1] = isSpaceScopedConversation;
        $[2] = useCurrentPageContext;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ enableBrowserContextBanner: enableBrowserContextBanner, shouldShowContextBanner: shouldShowContextBanner, stagingAreaEnabled: stagingAreaEnabled })=>{
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, selectedSpace: selectedSpace } = (0, $bGNkz.useUIStore)();
    const useCurrentPageContext = shouldShowContextBanner !== false && !stagingAreaEnabled && !isChatOnboardingMiniModalOpen;
    const isSpaceScopedConversation = Boolean(conversation?.rovoSpaceId || selectedSpace);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d6888cf104f54b7$export$9317dfcbec30a2cc), {
        enableBrowserContextBanner: enableBrowserContextBanner,
        useCurrentPageContext: useCurrentPageContext,
        isSpaceScopedConversation: isSpaceScopedConversation
    });
};














const $e3ec8a0fdb6de1e9$export$2667f637482a3695 = (condition, fire)=>{
    const firedRef = (0, $cozmU.useRef)(false);
    if (condition && !firedRef.current) {
        firedRef.current = true;
        fire();
    }
};

















const $3ca849ddfc3fa586$export$71348ea8616e75b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { warmConversationCache: warmConversationCache, prefetchConversationMessages: prefetchMessagesAction } = (0, $3TxKn.useChatStoreActions)();
    let t0;
    if ($[0] !== warmConversationCache) {
        t0 = (options)=>{
            warmConversationCache({
                conversation: options.conversation,
                forceRefresh: options.forceRefresh,
                onSuccess: options.onSuccess,
                onError: options.onError
            });
        };
        $[0] = warmConversationCache;
        $[1] = t0;
    } else t0 = $[1];
    const prefetchConversation = t0;
    let t1;
    if ($[2] !== prefetchMessagesAction) {
        t1 = (options_0)=>{
            prefetchMessagesAction({
                conversationId: options_0.conversationId,
                skipNextFetch: options_0.skipNextFetch,
                onStart: options_0.onStart,
                onSuccess: options_0.onSuccess,
                onError: options_0.onError
            });
        };
        $[2] = prefetchMessagesAction;
        $[3] = t1;
    } else t1 = $[3];
    const prefetchConversationMessages = t1;
    let t2;
    if ($[4] !== prefetchConversation || $[5] !== prefetchConversationMessages) {
        t2 = {
            prefetchConversation: prefetchConversation,
            prefetchConversationMessages: prefetchConversationMessages
        };
        $[4] = prefetchConversation;
        $[5] = prefetchConversationMessages;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { warmConversationCache: warmConversationCache, prefetchConversationMessages: prefetchMessagesAction } = (0, $3TxKn.useChatStoreActions)();
    const prefetchConversation = (0, $cozmU.useCallback)((options)=>{
        warmConversationCache({
            conversation: options.conversation,
            forceRefresh: options.forceRefresh,
            onSuccess: options.onSuccess,
            onError: options.onError
        });
    }, [
        warmConversationCache
    ]);
    const prefetchConversationMessages = (0, $cozmU.useCallback)((options_0)=>{
        prefetchMessagesAction({
            conversationId: options_0.conversationId,
            skipNextFetch: options_0.skipNextFetch,
            onStart: options_0.onStart,
            onSuccess: options_0.onSuccess,
            onError: options_0.onError
        });
    }, [
        prefetchMessagesAction
    ]);
    return {
        prefetchConversation: prefetchConversation,
        prefetchConversationMessages: prefetchConversationMessages
    };
};


const $e72a034435e3e1d9$export$29a6ffde3a8c1975 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [t0] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId } = t0;
    const { prefetchConversationMessages: prefetchConversationMessages } = (0, $3ca849ddfc3fa586$export$71348ea8616e75b2)();
    const hasSelectedConversation = !!currentConversationId && currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID);
    let t1;
    if ($[0] !== currentConversationId || $[1] !== prefetchConversationMessages) {
        t1 = ()=>{
            prefetchConversationMessages({
                conversationId: currentConversationId,
                skipNextFetch: true
            });
        };
        $[0] = currentConversationId;
        $[1] = prefetchConversationMessages;
        $[2] = t1;
    } else t1 = $[2];
    (0, $e3ec8a0fdb6de1e9$export$2667f637482a3695)(hasSelectedConversation, t1);
    return null;
} : ()=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { prefetchConversationMessages: prefetchConversationMessages } = (0, $3ca849ddfc3fa586$export$71348ea8616e75b2)();
    const hasSelectedConversation = !!currentConversationId && currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID);
    (0, $e3ec8a0fdb6de1e9$export$2667f637482a3695)(hasSelectedConversation, ()=>{
        prefetchConversationMessages({
            conversationId: currentConversationId,
            skipNextFetch: true
        });
    });
    return null;
};



var $aXbSS = parcelRequire("aXbSS");


var $dPoYT = parcelRequire("dPoYT");

const $ad68d77a48a38e4c$export$d4f9eca8f56c7ee5 = (mode, isFullScreen)=>isFullScreen ? 'rovo-chat.fullscreen' : `rovo-chat.${mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR}`;


const $0f2cd6a53c0a2177$export$6e73203ac85a4798 = ({ mode: mode, isFullScreen: isFullScreen, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, productKey: productKey })=>({
        bridgeProduct: (0, $ad68d77a48a38e4c$export$d4f9eca8f56c7ee5)(mode, isFullScreen),
        xpcProduct: xpcProduct || productKey,
        xpcSubProduct: xpcSubProduct
    });












var $dqxOF = parcelRequire("dqxOF");








var $jqg1p = parcelRequire("jqg1p");





var $2zlSy = parcelRequire("2zlSy");

const $53ffa4edfba5c089$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...(0, $2zlSy.initialState),
            ...processedConfig,
            enableSkills: processedConfig?.enableSkills ?? (0, $2zlSy.initialState).enableSkills,
            enableAgentMentions: processedConfig?.enableAgentMentions,
            enableAutoSuggest: processedConfig?.enableAutoSuggest ?? (0, $2zlSy.initialState).enableAutoSuggest,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? (0, $2zlSy.initialState).enableBrowserContextBanner,
            disableSettingsModal: processedConfig?.disableSettingsModal ?? (0, $2zlSy.initialState).disableSettingsModal,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...(0, $2zlSy.initialState).elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};



var $jAZYc = parcelRequire("jAZYc");

const $2af21e7e5be03781$var$areAgentsConfigsEqual = (current, next)=>current?.defaultAgentId === next?.defaultAgentId && (0, $jqg1p.areStringArraysEqual)(current?.filter, next?.filter);
const $2af21e7e5be03781$var$getUIConfigForShallowCompare = (config)=>{
    const { customHandlers: _customHandlers, elements: _elements, ...shallowConfig } = config ?? {};
    return shallowConfig;
};
const $2af21e7e5be03781$var$hasCustomHandlersProperty = (config)=>Object.prototype.hasOwnProperty.call(config ?? {}, 'customHandlers');
const $2af21e7e5be03781$var$areUIConfigsEqual = (current, next)=>(0, $dqxOF.shallowEqualObjects)($2af21e7e5be03781$var$getUIConfigForShallowCompare(current), $2af21e7e5be03781$var$getUIConfigForShallowCompare(next)) && (0, $dqxOF.shallowEqualObjects)(current?.elements ?? {}, next?.elements ?? {}) && $2af21e7e5be03781$var$hasCustomHandlersProperty(current) === $2af21e7e5be03781$var$hasCustomHandlersProperty(next) && (0, $dqxOF.shallowEqualObjects)(current?.customHandlers, next?.customHandlers);
const $2af21e7e5be03781$export$1d5179b714ffcf31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { agentsConfig: agentsConfig, uiConfig: uiConfig } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[0] = t1;
    } else t1 = $[0];
    const isTreatmentEnabled = t1 === true;
    const stableAgentsConfig = (0, $jAZYc.useSemanticStableValue)(agentsConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areAgentsConfigsEqual);
    const stableUIConfig = (0, $jAZYc.useSemanticStableValue)(uiConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areUIConfigsEqual);
    let t2;
    if ($[1] !== stableAgentsConfig) {
        t2 = isTreatmentEnabled ? {
            value: (0, $37RgG.createAgentsConfig)(stableAgentsConfig)
        } : undefined;
        $[1] = stableAgentsConfig;
        $[2] = t2;
    } else t2 = $[2];
    const memoizedAgentOverriderValue = t2;
    let t3;
    if ($[3] !== stableUIConfig) {
        t3 = isTreatmentEnabled ? {
            value: (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(stableUIConfig)
        } : undefined;
        $[3] = stableUIConfig;
        $[4] = t3;
    } else t3 = $[4];
    const memoizedUIConfigValue = t3;
    if (memoizedAgentOverriderValue && memoizedUIConfigValue) {
        let t4;
        if ($[5] !== memoizedAgentOverriderValue.value || $[6] !== memoizedUIConfigValue.value) {
            t4 = {
                agentOverriderValue: memoizedAgentOverriderValue.value,
                uiConfigValue: memoizedUIConfigValue.value
            };
            $[5] = memoizedAgentOverriderValue.value;
            $[6] = memoizedUIConfigValue.value;
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    let t4;
    if ($[8] !== agentsConfig) {
        t4 = (0, $37RgG.createAgentsConfig)(agentsConfig);
        $[8] = agentsConfig;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== uiConfig) {
        t5 = (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(uiConfig);
        $[10] = uiConfig;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = {
            agentOverriderValue: t4,
            uiConfigValue: t5
        };
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ agentsConfig: agentsConfig, uiConfig: uiConfig })=>{
    const isTreatmentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const stableAgentsConfig = (0, $jAZYc.useSemanticStableValue)(agentsConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areAgentsConfigsEqual);
    const stableUIConfig = (0, $jAZYc.useSemanticStableValue)(uiConfig, isTreatmentEnabled, $2af21e7e5be03781$var$areUIConfigsEqual);
    const memoizedAgentOverriderValue = (0, $cozmU.useMemo)(()=>isTreatmentEnabled ? {
            value: (0, $37RgG.createAgentsConfig)(stableAgentsConfig)
        } : undefined, [
        isTreatmentEnabled,
        stableAgentsConfig
    ]);
    const memoizedUIConfigValue = (0, $cozmU.useMemo)(()=>isTreatmentEnabled ? {
            value: (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(stableUIConfig)
        } : undefined, [
        isTreatmentEnabled,
        stableUIConfig
    ]);
    if (memoizedAgentOverriderValue && memoizedUIConfigValue) return {
        agentOverriderValue: memoizedAgentOverriderValue.value,
        uiConfigValue: memoizedUIConfigValue.value
    };
    return {
        agentOverriderValue: (0, $37RgG.createAgentsConfig)(agentsConfig),
        uiConfigValue: (0, $53ffa4edfba5c089$export$3e623b13d2da727a)(uiConfig)
    };
};














const $6390d7b9d52b6817$export$94b280d16f0eef6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, children: children } = t0;
    const smartLinkContext = (0, $cMyWi.useSmartLinkContext)();
    let t1;
    if ($[0] !== bridgeProduct || $[1] !== smartLinkContext || $[2] !== xpcProduct || $[3] !== xpcSubProduct) {
        t1 = {
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
        $[0] = bridgeProduct;
        $[1] = smartLinkContext;
        $[2] = xpcProduct;
        $[3] = xpcSubProduct;
        $[4] = t1;
    } else t1 = $[4];
    const smartCardContextValue = t1;
    let t2;
    if ($[5] !== children || $[6] !== smartCardContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
            value: smartCardContextValue
        }, children);
        $[5] = children;
        $[6] = smartCardContextValue;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct, children: children })=>{
    const smartLinkContext = (0, $cMyWi.useSmartLinkContext)();
    const smartCardContextValue = (0, $cozmU.useMemo)(()=>({
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        }), [
        smartLinkContext,
        bridgeProduct,
        xpcProduct,
        xpcSubProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
        value: smartCardContextValue
    }, children);
};


const $b1c23cecabb25d6f$export$fa770f2a78bdd2f7 = ({ enableBrowserContextBanner: enableBrowserContextBanner, shouldShowContextBanner: shouldShowContextBanner = true, pageType: pageType })=>{
    if (!shouldShowContextBanner) return false;
    // Using browser context (rovo extension sidebar) return true
    if (enableBrowserContextBanner) return true;
    // if user is viewing a 1p atlassian page in mini modal or in product side panel return true else return undefined
    return pageType === 'current_page' ? true : undefined;
};


















var $5AzUy = parcelRequire("5AzUy");


var $3PNw6 = parcelRequire("3PNw6");





var $hd4Ag = parcelRequire("hd4Ag");

const $d53b47274490f517$export$b0f54970cfd52c5b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { fullscreen: fullscreen, mode: mode, shouldPublishChatOpenOnTransitionData: t1 } = t0;
    const shouldPublishChatOpenOnTransitionData = t1 === undefined ? true : t1;
    const location = (0, $hd4Ag.useWindowLocation)();
    const previousLocationRef = (0, $cozmU.useRef)(location);
    const [isChatMountedAcrossTransition, setIsChatMountedAcrossTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let conversationAssistantMode = "unknown";
    const [t2] = (0, $8akfd.useStagingArea)();
    const { stagingAreaMode: stagingAreaMode } = t2;
    if (stagingAreaMode === "modal" || stagingAreaMode === "ephemeralModal") conversationAssistantMode = "aifc-modal";
    else if (fullscreen) conversationAssistantMode = "fullscreen";
    else {
        if (mode === "mini-modal") conversationAssistantMode = "mini-modal";
        else if (mode === "sidebar") conversationAssistantMode = "sidebar";
    }
    let t3;
    let t4;
    if ($[0] !== fullscreen || $[1] !== location) {
        t3 = ()=>{
            if (!fullscreen) (0, $iDrrr.fg)("platform_ufo_custom_cohort_data_migration") ? (0, $5AzUy.addUFOCustomCohortData)("isRovoSidebarVisible", true) : (0, $3PNw6.addUFOCustomData)({
                isRovoSidebarVisible: true
            });
            if (previousLocationRef.current !== location) {
                previousLocationRef.current = location;
                setIsChatMountedAcrossTransition(true);
            }
            return $d53b47274490f517$var$_temp;
        };
        t4 = [
            fullscreen,
            location
        ];
        $[0] = fullscreen;
        $[1] = location;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[4] !== isChatMountedAcrossTransition || $[5] !== shouldPublishChatOpenOnTransitionData) {
        t5 = shouldPublishChatOpenOnTransitionData ? {
            isChatMountedAcrossTransition: isChatMountedAcrossTransition
        } : undefined;
        $[4] = isChatMountedAcrossTransition;
        $[5] = shouldPublishChatOpenOnTransitionData;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== conversationAssistantMode || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                conversationAssistantMode: conversationAssistantMode,
                ...t5
            }
        });
        $[7] = conversationAssistantMode;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ fullscreen: fullscreen, mode: mode, shouldPublishChatOpenOnTransitionData: shouldPublishChatOpenOnTransitionData = true })=>{
    const location = (0, $hd4Ag.useWindowLocation)();
    const previousLocationRef = (0, $cozmU.useRef)(location);
    const [isChatMountedAcrossTransition, setIsChatMountedAcrossTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let conversationAssistantMode = 'unknown';
    const [{ stagingAreaMode: stagingAreaMode }] = (0, $8akfd.useStagingArea)();
    if (stagingAreaMode === 'modal' || stagingAreaMode === 'ephemeralModal') conversationAssistantMode = 'aifc-modal';
    else if (fullscreen) conversationAssistantMode = 'fullscreen';
    else if (mode === 'mini-modal') conversationAssistantMode = 'mini-modal';
    else if (mode === 'sidebar') conversationAssistantMode = 'sidebar';
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!fullscreen) (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? (0, $5AzUy.addUFOCustomCohortData)('isRovoSidebarVisible', true) : (0, $3PNw6.addUFOCustomData)({
            isRovoSidebarVisible: true
        });
        if (previousLocationRef.current !== location) {
            previousLocationRef.current = location;
            setIsChatMountedAcrossTransition(true);
        }
        return ()=>{
            (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? (0, $5AzUy.addUFOCustomCohortData)('isRovoSidebarVisible', false) : (0, $3PNw6.addUFOCustomData)({
                isRovoSidebarVisible: false
            });
        };
    }, [
        fullscreen,
        location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            conversationAssistantMode: conversationAssistantMode,
            ...shouldPublishChatOpenOnTransitionData ? {
                isChatMountedAcrossTransition: isChatMountedAcrossTransition
            } : undefined
        }
    });
};
function $d53b47274490f517$var$_temp() {
    (0, $iDrrr.fg)("platform_ufo_custom_cohort_data_migration") ? (0, $5AzUy.addUFOCustomCohortData)("isRovoSidebarVisible", false) : (0, $3PNw6.addUFOCustomData)({
        isRovoSidebarVisible: false
    });
}








const $14ef7fd43c14a77d$export$ec13cfad88fac634 = {
    hasOpenedChatInPageSession: false
};


const $5469d9b486aa8c2f$export$18df69d24ab6177f = ()=>{
    const isFirstOpenRef = (0, $cozmU.useRef)(!(0, $14ef7fd43c14a77d$export$ec13cfad88fac634).hasOpenedChatInPageSession);
    (0, $cozmU.useLayoutEffect)(()=>{
        (0, $14ef7fd43c14a77d$export$ec13cfad88fac634).hasOpenedChatInPageSession = true;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            isFirstChatOpen: isFirstOpenRef.current
        }
    });
};















var $O96nq = parcelRequire("O96nq");

const $c036c439c40c28d8$export$c1e7a155a036a9ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewDeadAirProvider(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { value: value, identity: identity, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_track_view_dead_air");
        $[0] = t1;
    } else t1 = $[0];
    const isEnabled = t1;
    let t2;
    let t3;
    if ($[1] !== identity || $[2] !== value) {
        t2 = ()=>{
            if (!isEnabled) return;
            if (identity !== undefined && value) value.updateIdentity(identity);
        };
        t3 = [
            identity,
            value,
            isEnabled
        ];
        $[1] = identity;
        $[2] = value;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    if (!isEnabled) {
        let t4;
        if ($[5] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[5] = children;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    let t4;
    if ($[7] !== children || $[8] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $O96nq.ViewDeadAirContext).Provider, {
            value: value
        }, children);
        $[7] = children;
        $[8] = value;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : function ViewDeadAirProvider({ value: value, identity: identity, children: children }) {
    const isEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        if (identity !== undefined && value) value.updateIdentity(identity);
    }, [
        identity,
        value,
        isEnabled
    ]);
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $O96nq.ViewDeadAirContext).Provider, {
        value: value
    }, children);
};


function $37f8d57d84bed17b$export$cd17d76da7967240() {
    // return packageInfo;
    return {
        name: '@atlassian/conversation-assistant',
        version: 'unavailable'
    };
}


const $8065a799419bdbe8$var$ConversationAssistantWrapper = ({ onPromptSent: onPromptSent, children: children })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker), (0, $eKjv9.useGlobalConfig));
    const showFlag = (0, $55592f6773d96032$export$4610738c067a7645)();
    const { getContentBody: getContentBody, getStagingSpace: getStagingSpace, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastConfirmedActions: broadcastConfirmedActions, broadcastStreamStatus: broadcastStreamStatus } = (0, $571372d50c430197$export$392dcf789ba32ca6)();
    const { requestBrowserContent: requestBrowserContent } = (0, $cb145149c0b90d17$export$46457d11c8328445)();
    const { requestJiraContext: requestJiraContext } = (0, $0e8cab1d0778bbd2$export$4fbf4621651f722d)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    const { getIsMounted: getIsChatMounted } = (0, $bGNkz.useUIStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const onSentrySetupFailure = (0, $cozmU.useCallback)((failure)=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: 'sentryClientSetup',
            attributes: failure
        });
    }, [
        sendAnalyticsEvent
    ]);
    const { browserContextSanitizer: browserContextSanitizer, enableBrowserContextBanner: enableBrowserContextBanner, elements: elements } = (0, $dSCNl.useUIConfig)();
    const { productHeader: productHeader, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { currentContext: currentContext } = (0, $hOUgz.useCurrentPageAsContext)();
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)(); // Read the active conversation's "use current page as context" toggle from the
    // chat mode store so the chat-context provider can derive useCurrentBrowsingContext.
    const { useCurrentPageContext: useCurrentPageContext } = (0, $aQWBL.useChatModeState)(currentConversationId);
    const chatContextStoreActions = (0, $gzMZq.useChatContextProvider)({
        requestBrowserContent: requestBrowserContent,
        requestJiraContext: requestJiraContext,
        getContentBody: getContentBody,
        getStagingSpace: getStagingSpace,
        useCurrentNonEditingPageAsContext: (0, $b1c23cecabb25d6f$export$fa770f2a78bdd2f7)({
            enableBrowserContextBanner: enableBrowserContextBanner,
            shouldShowContextBanner: elements?.shouldShowContextBanner,
            pageType: currentContext?.type
        }),
        useCurrentPageContext: useCurrentPageContext
    });
    const { setStatus: setStatus, setConversationError: setConversationError } = (0, $k4g8h.useChatSignalsActions)();
    const { getMessages: getMessages, setMessages: setMessages } = (0, $iW40i.useChatMessagesActions)();
    const { setIsRovoEnabled: setIsRovoEnabled } = (0, $8lt5O.useRovoEntitlementActions)();
    const { startReconnection: startReconnection, endReconnection: endReconnection, isReconnecting: isReconnecting } = (0, $d59150c4763cb391$export$bec843ddf321b89b)();
    (0, $cozmU.useEffect)(()=>{
        (0, $hlvTd.setupSentryClient)({
            packageVersion: (0, $37f8d57d84bed17b$export$cd17d76da7967240)().version,
            product: productHeader,
            onSetupFailure: onSentrySetupFailure
        });
    }, [
        productHeader,
        onSentrySetupFailure
    ]);
    const { processStreamResearch: processStreamResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, completeAllSteps: completeAllSteps, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart } = (0, $guRLk.useChatMessageResearchActions)();
    const { getChatInitiator: getChatInitiator, initChatInitiator: initChatInitiator } = (0, $70f03fc4cd84995c$export$8a56a4af5643d61b)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    const { setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setStagingAreaMode: setStagingAreaMode, getMessageIdSelectedForPreview: getMessageIdSelectedForPreview, getInvocationIdSelectedForPreview: getInvocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaActions)();
    const { forceSkipAutoConversationSelection: forceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaState)();
    const onNewConversationStartingWithSendMessage = (0, $37f0dfcbe79a956a$export$1e02c4fe277d3d74)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
    // value when BE user settings are fully rolled out; BE overrides it via the capability header.
    const getStoreUserMessagesPreference = (0, $cozmU.useCallback)(()=>preferences.storeUserMessages, [
        preferences.storeUserMessages
    ]);
    const { activeAction: activeAction } = (0, $5BOJB.useActiveAction)();
    // Skip auto conversation selection if we're already previewing a message or an action is pending.
    // When an action is set, the chat store must start with EMPTY_CONVERSATION_ID rather than
    // restoring the previous conversation from localStorage via autoSelectConversation.
    // Matters only on initialization.
    const skipAutoConversationSelection = !!getMessageIdSelectedForPreview?.() || !!getInvocationIdSelectedForPreview?.() || forceSkipAutoConversationSelection || !!activeAction;
    const onTempMessageIdReplaced = (0, $cozmU.useCallback)((oldId, newId)=>{
        // Update messageIdSelectedForPreview when the message ID changes during streaming
        if (oldId === getMessageIdSelectedForPreview?.()) setMessageIdSelectedForPreview(newId);
    }, [
        getMessageIdSelectedForPreview,
        setMessageIdSelectedForPreview
    ]);
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({});
    const { setReasoningMode: setReasoningMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { setSmartContextLinkRecommendations: setSmartContextLinkRecommendations } = (0, $12shJ.useSpaceStoreActions)(); // Build the unified tasks container dep consumed by chat-store actions.
    // Always assembled (cheap) so the container shape is stable across renders.
    // All read accessors are sweet-state actions so the dep object identity does not depend on store
    // state — chat-store consumers won't re-render on every task mutation.
    const unifiedTasksActions = (0, $9qJ1N.useTasksStoreActions)();
    const unifiedTasksContainerDep = (0, $cozmU.useMemo)(()=>({
            createTaskFromStream: unifiedTasksActions.createTaskFromStream,
            setTaskProgressState: unifiedTasksActions.setTaskProgressState,
            setTaskTodoSnapshot: unifiedTasksActions.setTaskTodoSnapshot,
            ackTaskCompleted: unifiedTasksActions.ackTaskCompleted,
            mergeConversationChannelTasks: unifiedTasksActions.mergeConversationChannelTasks,
            getTaskById: unifiedTasksActions.getTaskById,
            getActiveTaskForConversation: unifiedTasksActions.getActiveTaskForConversation
        }), [
        unifiedTasksActions
    ]);
    const isViewDeadAirEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    const viewDeadAirBroker = (0, $cozmU.useMemo)(()=>isViewDeadAirEnabled ? (0, $3a2dcf28cd216b6e$export$e75a25d5c6776a72)() : null, [
        isViewDeadAirEnabled
    ]);
    const capabilities = (0, $bd4e57972be9e4ca$export$e0427dd13bcccf1b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07964e27dfae7b36$export$9b7b433b0520b82b), {
        isGlobal: true,
        siteId: siteId,
        onPromptSent: onPromptSent,
        assistanceService: assistanceService,
        experienceTracker: experienceTracker,
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        chatContextStoreActions: chatContextStoreActions,
        capabilities: capabilities,
        setChatStatus: setStatus,
        setConversationError: setConversationError,
        getMessages: getMessages,
        setMessages: setMessages,
        getIsChatMounted: getIsChatMounted,
        startReconnection: startReconnection,
        endReconnection: endReconnection,
        isReconnecting: isReconnecting,
        setRovoEnabled: setIsRovoEnabled,
        processStreamResearch: processStreamResearch,
        markIncompleteResearchesErrored: markIncompleteResearchesErrored,
        completeAllSteps: completeAllSteps,
        updateResearchMessageId: updateResearchMessageId,
        clearMessageResearch: clearMessageResearch,
        addImplicitResearchPlan: addImplicitResearchPlan,
        resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
        initChatInitiator: initChatInitiator,
        getChatInitiator: getChatInitiator,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        processMessageStreamAction: processMessageStreamAction,
        processMessageStreamComplete: processMessageStreamComplete,
        processMessageStreamError: processMessageStreamError,
        processMessageStreamActionClassification: processMessageStreamActionClassification,
        broadcastStreamStatus: broadcastStreamStatus,
        broadcastConfirmedActions: broadcastConfirmedActions,
        setStagingAreaMode: setStagingAreaMode,
        setMessageIdSelectedForPreview: setMessageIdSelectedForPreview,
        onTempMessageIdReplaced: onTempMessageIdReplaced,
        skipAutoConversationSelection: skipAutoConversationSelection,
        onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage,
        browserContextSanitizer: browserContextSanitizer,
        getStoreUserMessagesPreference: getStoreUserMessagesPreference,
        trackAgentEvent: trackAgentEvent,
        viewDeadAirBroker: viewDeadAirBroker,
        showFlag: showFlag,
        setReasoningMode: setReasoningMode,
        unifiedTasksActions: unifiedTasksContainerDep,
        onSpaceSourceRecommendations: setSmartContextLinkRecommendations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83df2c4d369ade6b$export$1ea8b76066893345), {
        showFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c036c439c40c28d8$export$c1e7a155a036a9ec), {
        value: viewDeadAirBroker,
        identity: currentConversationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2d7843b3ff1bcdd$export$47f0b7e1efb22e0f), null, children)))));
};
/**
 * BE-backed storeUserMessages bootstrap. Must be rendered inside the main
 * conversation providers so `useAssistanceServiceParams` can read GlobalConfig.
 *
 * The enabled setup path loads `/user-settings` through `useStoreUserMessagesPreference`.
 * MigrationRunner is the temporary one-shot localStorage -> BE migration and remains
 * gated by the legacy `ai_mate_show_store_messages` eligibility flag.
 */ const $8065a799419bdbe8$var$StoreUserMessagesBackendSetup = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    if (!(0, $iDrrr.fg)("ai_mate_store_messages_be_driven")) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8065a799419bdbe8$var$StoreUserMessagesBackendSetupEnabled, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    if (!(0, $iDrrr.fg)('ai_mate_store_messages_be_driven')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8065a799419bdbe8$var$StoreUserMessagesBackendSetupEnabled, null);
};
const $8065a799419bdbe8$var$StoreUserMessagesBackendSetupEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            touchpointSource: "rovo-chat-store-user-messages"
        };
        $[0] = t0;
    } else t0 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t0);
    let t1;
    if ($[1] !== assistanceServiceParams) {
        t1 = JSON.stringify(assistanceServiceParams);
        $[1] = assistanceServiceParams;
        $[2] = t1;
    } else t1 = $[2];
    const assistanceServiceParamsKey = t1;
    let t2;
    if ($[3] !== assistanceServiceParamsKey) {
        t2 = JSON.parse(assistanceServiceParamsKey);
        $[3] = assistanceServiceParamsKey;
        $[4] = t2;
    } else t2 = $[4];
    const stableAssistanceServiceParams = t2;
    let t3;
    if ($[5] !== stableAssistanceServiceParams) {
        t3 = {
            assistanceServiceParams: stableAssistanceServiceParams
        };
        $[5] = stableAssistanceServiceParams;
        $[6] = t3;
    } else t3 = $[6];
    const { localStoreUserMessages: localStoreUserMessages, storeUserMessageMigratedToBE: storeUserMessageMigratedToBE, markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE, updateBackendStoreUserMessages: updateBackendStoreUserMessages } = (0, $hSR6U.useStoreUserMessagesPreference)(t3);
    if (!(0, $iDrrr.fg)("ai_mate_show_store_messages")) return null;
    let t4;
    if ($[7] !== localStoreUserMessages || $[8] !== markStoreUserMessageMigratedToBE || $[9] !== storeUserMessageMigratedToBE || $[10] !== updateBackendStoreUserMessages) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSR6U.StoreUserMessagesMigrationRunner), {
            isCurrentUserMigrated: storeUserMessageMigratedToBE,
            markCurrentUserAsMigrated: markStoreUserMessageMigratedToBE,
            currentUserStoreMessagesPreference: localStoreUserMessages,
            updateBackendStoreUserMessages: updateBackendStoreUserMessages
        });
        $[7] = localStoreUserMessages;
        $[8] = markStoreUserMessageMigratedToBE;
        $[9] = storeUserMessageMigratedToBE;
        $[10] = updateBackendStoreUserMessages;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ()=>{
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'rovo-chat-store-user-messages'
    });
    const assistanceServiceParamsKey = JSON.stringify(assistanceServiceParams);
    const stableAssistanceServiceParams = (0, $cozmU.useMemo)(()=>JSON.parse(assistanceServiceParamsKey), [
        assistanceServiceParamsKey
    ]);
    const { localStoreUserMessages: localStoreUserMessages, storeUserMessageMigratedToBE: storeUserMessageMigratedToBE, markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE, updateBackendStoreUserMessages: updateBackendStoreUserMessages } = (0, $hSR6U.useStoreUserMessagesPreference)({
        assistanceServiceParams: stableAssistanceServiceParams
    });
    if (!(0, $iDrrr.fg)('ai_mate_show_store_messages')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSR6U.StoreUserMessagesMigrationRunner), {
        isCurrentUserMigrated: storeUserMessageMigratedToBE,
        markCurrentUserAsMigrated: markStoreUserMessageMigratedToBE,
        currentUserStoreMessagesPreference: localStoreUserMessages,
        updateBackendStoreUserMessages: updateBackendStoreUserMessages
    });
}; /**
    * Wraps RovoSettingsModalProvider with the chat-specific callback for
    * "See what Rovo knows about you". Must be rendered inside ChatStoreContainer.
    */ 
const $8065a799419bdbe8$var$ChatAwareRovoSettingsModalProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { config: config, disableSettingsModal: disableSettingsModal, children: children } = t0;
    const { sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { preferences: t1 } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = t1;
    let t2;
    if ($[0] !== sendMessage || $[1] !== storeUserMessages) {
        t2 = ()=>{
            sendMessage({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                prompt: (0, $6rwn6.encodeAdf)("What does Rovo know about me?"),
                storeUserMessages: storeUserMessages
            });
        };
        $[0] = sendMessage;
        $[1] = storeUserMessages;
        $[2] = t2;
    } else t2 = $[2];
    const handleSeeWhatRovoKnows = t2;
    let t3;
    if ($[3] !== children || $[4] !== config.orgId || $[5] !== config.product || $[6] !== config.siteId || $[7] !== disableSettingsModal || $[8] !== handleSeeWhatRovoKnows) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7bLo5.RovoSettingsModalProvider), {
            product: config.product,
            cloudId: config.siteId,
            orgId: config.orgId,
            onSeeWhatRovoKnows: handleSeeWhatRovoKnows,
            surface: (0, $kb3cs.RovoSettingsModalSurface).CHAT,
            disableSettingsModal: disableSettingsModal
        }, children);
        $[3] = children;
        $[4] = config.orgId;
        $[5] = config.product;
        $[6] = config.siteId;
        $[7] = disableSettingsModal;
        $[8] = handleSeeWhatRovoKnows;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ config: config, disableSettingsModal: disableSettingsModal, children: children })=>{
    const { sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const handleSeeWhatRovoKnows = (0, $cozmU.useCallback)(()=>{
        sendMessage({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
            prompt: (0, $6rwn6.encodeAdf)('What does Rovo know about me?'),
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages
        });
    }, [
        sendMessage,
        storeUserMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7bLo5.RovoSettingsModalProvider), {
        product: config.product,
        cloudId: config.siteId,
        orgId: config.orgId,
        onSeeWhatRovoKnows: handleSeeWhatRovoKnows,
        surface: (0, $kb3cs.RovoSettingsModalSurface).CHAT,
        disableSettingsModal: disableSettingsModal
    }, children);
};
const $8065a799419bdbe8$export$e4ac8b50628685c4 = ({ testId: testId, onCloseChat: onCloseChat, config: config, uiConfig: uiConfig, agentsConfig: agentsConfig, agentVersioningConfig: agentVersioningConfig, isNav4Enabled: isNav4Enabled, sitePickerRender: sitePickerRender, overridingChildren: overridingChildren, modeConfig: modeConfig, getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults, numStartersToShow: numStartersToShow, stagingAreaRef: stagingAreaRef, topOffset: topOffset = 0, tags: tags, initialPrompt: initialPrompt, suppressInitialFocus: suppressInitialFocus })=>{
    (0, $6cFsl.di)((0, $lJ6db.AssistanceServiceProvider), (0, $07964e27dfae7b36$export$9b7b433b0520b82b), (0, $5HApy.SmartCardProvider), (0, $89QZA.AnalyticsContextWithSourceAndProperties));
    (0, $cozmU.useMemo)(()=>{
        // Setting devtools in useMemo to make sure we catch the first render.
        // ReactSweetStateDefaults may be undefined when bundlers tree-shake or when the
        // module isn't available at runtime. Guard access to avoid runtime exceptions.
        try {
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $iDrrr.fg)('ai_mate_react_sweet_state_devtools') && typeof (0, $kiAM2.default) !== 'undefined' && (0, $kiAM2.default) && 'devtools' in (0, $kiAM2.default)) (0, $kiAM2.default).devtools = true;
        } catch  {}
    }, []);
    const ufoContext = (0, $8BQV6.useInteractionContext)();
    const ufoLabelStack = (0, $cozmU.useMemo)(()=>ufoContext?.labelStack ?? [
            {
                name: 'rovo-conversation-assistant'
            }
        ], [
        ufoContext?.labelStack
    ]);
    const setUFOLabelStack = (0, $bjY3F.useUFOLabelStackSetter)();
    (0, $cozmU.useMemo)(()=>{
        setUFOLabelStack(ufoLabelStack); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ufoLabelStack
    ]);
    const profileData = (0, $isp1U.useProfileController)();
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStoreActions)();
    const { isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStore)();
    (0, $cozmU.useEffect)(()=>{
        (0, $de717ae3a7549f1b$export$caa27b16709bc2df)(config.product);
    }, [
        config.product
    ]);
    const [sharedFeaturesInstrumentationId, setSharedFeaturesInstrumentationId] = (0, $cozmU.useState)(undefined);
    const assistanceService = (0, $cozmU.useMemo)(()=>new (0, $lJ6db.AssistanceServiceImpl)({
            baseUrl: config.assistanceServiceConfig?.baseUrl,
            headers: config.assistanceServiceConfig?.headers,
            channelId: config.assistanceServiceConfig?.channelId,
            product: config.product,
            experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
            minionAlias: config.assistanceServiceConfig?.minionAlias,
            labelStack: ufoLabelStack
        }), [
        config.assistanceServiceConfig?.baseUrl,
        config.assistanceServiceConfig?.headers,
        config.assistanceServiceConfig?.channelId,
        config.product,
        config.experienceId,
        config.assistanceServiceConfig?.minionAlias,
        ufoLabelStack
    ]);
    const globalConfig = (0, $cozmU.useMemo)(()=>(0, $58f16686a4f70667$export$b9c35db6980960f2)({
            ...config,
            profileData: profileData,
            closeChat: ()=>{
                onCloseChat?.();
                if (isChatOnboardingMiniModalOpen) setIsChatOnboardingMiniModalOpen(false);
            }
        }), [
        config,
        profileData,
        onCloseChat,
        setIsChatOnboardingMiniModalOpen,
        isChatOnboardingMiniModalOpen
    ]);
    const { agentOverriderValue: agentOverriderValue, uiConfigValue: uiConfigValue } = (0, $2af21e7e5be03781$export$1d5179b714ffcf31)({
        agentsConfig: agentsConfig,
        uiConfig: uiConfig
    }); // When initialPrompt is provided, self-publish a chat-new PubSub event
    // to trigger the existing PubSubListener handler which creates a seeded
    // conversation and auto-sends the prompt.
    const initialPromptFiredRef = (0, $cozmU.useRef)(false);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        if (!initialPrompt || initialPromptFiredRef.current) return;
        initialPromptFiredRef.current = true; // Use requestAnimationFrame to ensure PubSubListener has subscribed
        requestAnimationFrame(()=>{
            publish({
                type: 'chat-new',
                source: 'linkedConfluenceDocRovoNudge',
                data: {
                    prompt: initialPrompt,
                    dialogues: [],
                    mode: {
                        useCurrentPageContext: true
                    }
                }
            });
        });
    }, [
        initialPrompt,
        publish
    ]);
    const rovoChatXpcContextValues = (0, $cozmU.useMemo)(()=>(0, $0f2cd6a53c0a2177$export$6e73203ac85a4798)({
            mode: modeConfig?.mode,
            isFullScreen: uiConfig?.fullScreen,
            xpcProduct: config.xpcProduct,
            xpcSubProduct: config.xpcSubProduct,
            productKey: globalConfig.productKey
        }), [
        config.xpcProduct,
        config.xpcSubProduct,
        globalConfig.productKey,
        modeConfig?.mode,
        uiConfig?.fullScreen
    ]);
    return(// The order of analytics properties context and experienceTracker matters here
    // for experience tracker to send correct analytics properties, it needs to be under analyticsContext
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $89QZA.AnalyticsContextWithSourceAndProperties), {
        source: "AIMate",
        mode: modeConfig?.mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId,
        isAlwaysInSmartCreateFlow: sharedFeaturesInstrumentationId !== undefined ? true : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt5O.RovoEntitlementSetter), {
        isRovoEnabled: isRovoEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyWKg.ErrorBoundary), {
        experienceName: (0, $irnO2.ExperienceName).LOAD_PANEL,
        rethrowErrors: config.rethrowErrors ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6e4c82a4164acfc$export$920227929045c1b5), {
        value: globalConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37RgG.AgentOverriderProvider), {
        value: agentOverriderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31f0ba1c2c4d97e2$export$51f901728a02d39c), {
        value: agentVersioningConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $735ca6a936ab5049$export$3063519296e335bf), {
        value: uiConfigValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), {
        bridgeProduct: rovoChatXpcContextValues.bridgeProduct,
        xpcProduct: rovoChatXpcContextValues.xpcProduct,
        xpcSubProduct: rovoChatXpcContextValues.xpcSubProduct
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6390d7b9d52b6817$export$94b280d16f0eef6b), rovoChatXpcContextValues, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lJ6db.AssistanceServiceProvider), {
        value: assistanceService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $557d858394512263$export$b0b2d9624bbf3936), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d53b47274490f517$export$b0f54970cfd52c5b), {
        fullscreen: uiConfig?.fullScreen,
        mode: modeConfig?.mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        shouldPublishChatOpenOnTransitionData: !overridingChildren
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8065a799419bdbe8$var$ConversationAssistantWrapper, {
        onPromptSent: config.onPromptSent
    }, overridingChildren ? // NOTE: `overridingChildren` consumers (e.g. CwR staging-area-modal,
    // chat-only-creation-modal) are responsible for wrapping their own
    // subtree with `RovoSettingsModalProvider` so entrypoints to the
    // settings modal work via useSideNavModal(). The provider is
    // idempotent, so defensive wrapping is safe. See ASIMO-3977.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j180q.AnalyticsPropertiesUpdater), null), overridingChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e72a034435e3e1d9$export$29a6ffde3a8c1975), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $880313826a79edf3$export$e17502d4af1a1395), {
        enableBrowserContextBanner: uiConfig?.enableBrowserContextBanner,
        shouldShowContextBanner: uiConfig?.elements?.shouldShowContextBanner,
        stagingAreaEnabled: !!uiConfig?.elements?.stagingAreaEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5469d9b486aa8c2f$export$18df69d24ab6177f), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8065a799419bdbe8$var$StoreUserMessagesBackendSetup, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8065a799419bdbe8$var$ChatAwareRovoSettingsModalProvider, {
        config: config,
        disableSettingsModal: uiConfig?.disableSettingsModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).LOAD_PANEL
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXbSS.ConversationAssistantRender), {
        sitePickerRender: sitePickerRender,
        testId: testId,
        isNav4Enabled: isNav4Enabled,
        modeConfig: modeConfig,
        getActions: getActions,
        prioritizeCustomActionResults: prioritizeCustomActionResults,
        numStartersToShow: numStartersToShow,
        stagingAreaRef: stagingAreaRef,
        topOffset: topOffset,
        isInPreviewModal: false,
        config: config,
        setSharedFeaturesInstrumentationId: setSharedFeaturesInstrumentationId,
        tags: tags,
        suppressInitialFocus: suppressInitialFocus
    })))), ((0, $iDrrr.fg)('aifc_create_enabled') || (0, $iDrrr.fg)('jira_aifc_enabled')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd23f59678a0acda$export$4ae751989dace185), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $741693f1d6085f6e$export$1f35aa17211e523d), null)))))))))))))));
};


const $4bc8868ee45f5b87$export$9777b121d71c4de1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let props;
    let skipRelayProvider;
    if ($[0] !== t0) {
        ({ skipRelayProvider: skipRelayProvider, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = skipRelayProvider;
    } else {
        props = $[1];
        skipRelayProvider = $[2];
    }
    const rootSegmentName = props.overridingChildren ? "rovo-conversation-assistant-wOverriddenChildren" : "rovo-conversation-assistant";
    let t1;
    if ($[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8065a799419bdbe8$export$e4ac8b50628685c4), props);
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    const content = t1;
    let t2;
    if ($[5] !== content || $[6] !== skipRelayProvider) {
        t2 = skipRelayProvider && (0, $iDrrr.fg)("ai_agent_sessions_warming_cache") ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, content);
        $[5] = content;
        $[6] = skipRelayProvider;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== rootSegmentName || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: rootSegmentName
        }, t2);
        $[8] = rootSegmentName;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ skipRelayProvider: skipRelayProvider, ...props })=>{
    const rootSegmentName = props.overridingChildren ? 'rovo-conversation-assistant-wOverriddenChildren' : 'rovo-conversation-assistant';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8065a799419bdbe8$export$e4ac8b50628685c4), props);
    return(// The UFOSegment has to be absolute top, please do not introduce any side effects in this parent level component,
    // otherwise it may not get captured with performance metrics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: rootSegmentName
    }, skipRelayProvider && (0, $iDrrr.fg)('ai_agent_sessions_warming_cache') ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, content)));
};
module.exports["ConversationAssistant"] = $4bc8868ee45f5b87$export$9777b121d71c4de1;

});

parcelRegister("iA8l9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");

var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $3Uocj = parcelRequire("3Uocj");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $65d9609224d5a714$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $65d9609224d5a714$export$885784b0858eefcc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(7);
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t0;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t0 = (event)=>{
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                library: (0, $3Uocj.LIBRARY_ATTRIBUTE),
                ...event.attributes
            };
            createAnalyticsEvent({
                ...$65d9609224d5a714$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const fireAnalyticsEvent = t0;
    let t1;
    if ($[3] !== fireAnalyticsEvent) {
        t1 = (payload)=>{
            const { action: action, actionSubject: actionSubject, attributes: attributes_0, ...eventProps } = payload;
            fireAnalyticsEvent({
                actionSubject: actionSubject,
                action: action,
                ...eventProps,
                attributes: attributes_0
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const trackAgentEvent = t1;
    let t2;
    if ($[5] !== trackAgentEvent) {
        t2 = {
            trackAgentEvent: trackAgentEvent
        };
        $[5] = trackAgentEvent;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (commonAttributes)=>{
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            library: (0, $3Uocj.LIBRARY_ATTRIBUTE),
            ...event.attributes
        };
        createAnalyticsEvent({
            ...$65d9609224d5a714$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fully-typed event tracking using discriminated union payload types.
   * The payload type enforces correct action, actionSubject, and attributes.
   */ const trackAgentEvent = (0, $cozmU.useCallback)((payload)=>{
        const { action: action, actionSubject: actionSubject, attributes: attributes_0, ...eventProps } = payload;
        fireAnalyticsEvent({
            actionSubject: actionSubject,
            action: action,
            ...eventProps,
            attributes: attributes_0
        });
    }, [
        fireAnalyticsEvent
    ]);
    return {
        trackAgentEvent: trackAgentEvent
    };
};
module.exports["useRovoAgentActionAnalytics"] = $65d9609224d5a714$export$885784b0858eefcc;

});

parcelRegister("6CGVr", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a107ebb1ee65d2$export$2e2bcd8739ae039);

var $3ge84 = parcelRequire("3ge84");

var $34a107ebb1ee65d2$export$2e2bcd8739ae039 = (0, $3ge84.default);

});

parcelRegister("iGwRU", function(module, exports) {

var $fmu9K = parcelRequire("fmu9K");

const $3011e158d8129415$export$85183a312807388d = (0, $fmu9K.FabricChannel).aiMate;
module.exports["ANALYTICS_CHANNEL"] = $3011e158d8129415$export$85183a312807388d;

});

parcelRegister("3Uocj", function(module, exports) {
const $22c81417b0ee1e9b$export$88bd91d3e490ceb5 = 'agents-analytics';
module.exports["LIBRARY_ATTRIBUTE"] = $22c81417b0ee1e9b$export$88bd91d3e490ceb5;

});

parcelRegister("l9F99", function(module, exports) {
const $9a048168f718fa86$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $9a048168f718fa86$export$d97c97ed77ff09e8;

});

parcelRegister("i8NpI", function(module, exports) {
const $5912f9d7fe53faa6$export$f6abe2eda5c1912f = ()=>({
        eventType: 'track',
        tags: [
            'atlaskit'
        ]
    });
module.exports["getDefaultTrackEventConfig"] = $5912f9d7fe53faa6$export$f6abe2eda5c1912f;

});

parcelRegister("37RgG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $cd2bff7865b1d155$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $cd2bff7865b1d155$export$7b61e11d4e81ba17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
} : ()=>(0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
const $cd2bff7865b1d155$export$aa582af5b4b72bb2 = $cd2bff7865b1d155$export$ccc6603eb027f48b.Provider;
const $cd2bff7865b1d155$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $cd2bff7865b1d155$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $cd2bff7865b1d155$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $cd2bff7865b1d155$export$6aab84dc399ad753;

});

parcelRegister("aQWBL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $7685l = parcelRequire("7685l");

const $e2fc5133d9d39a50$export$e8c93422b36ab121 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (key)=>{
    const state = (0, $7685l.useChatModeStore)(key)[0];
    return state;
} : (key)=>{
    const state = (0, $7685l.useChatModeStore)(key)[0];
    return state;
};
module.exports["useChatModeState"] = $e2fc5133d9d39a50$export$e8c93422b36ab121;

});

parcelRegister("6rwn6", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- This file predates the rule and is a shared subpath entry point consumed by many packages; splitting would require coordinated changes across the entire monorepo. */ 
var $4wRTw = parcelRequire("4wRTw");


var $6FNab = parcelRequire("6FNab");


var $hUsog = parcelRequire("hUsog");


var $8lhhf = parcelRequire("8lhhf");

const $c360078fe01b00e3$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $c360078fe01b00e3$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($c360078fe01b00e3$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $c360078fe01b00e3$var$pluginConfig = {
    linkify: {
        findFilepaths: $4wRTw.findFilepaths,
        isLinkInMatches: $4wRTw.isLinkInMatches
    },
    smartLinks: {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        regexStorage: globalThis.localStorage
    }
};
const $c360078fe01b00e3$export$3374c63d7715b4ce = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, false));
const $c360078fe01b00e3$var$streamingAdfEncoder = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, true));
const $c360078fe01b00e3$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl)=>{
    if ($c360078fe01b00e3$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || shouldShowAsInline || xpcWrapUrl) return new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, undefined, xpcWrapUrl)).encode(content);
    else if (useGroupedCitations) return streaming ? new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, true, undefined, undefined, true)).encode(content) : new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations)).encode(content);
    else return streaming ? $c360078fe01b00e3$var$streamingAdfEncoder.encode(content) : $c360078fe01b00e3$export$3374c63d7715b4ce.encode(content);
};
const $c360078fe01b00e3$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $8lhhf.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        // The skill name without the slash
        length: match[0].length // Length of "/skill-name"
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
const $c360078fe01b00e3$export$b663bc0d84e6eaa6 = '`';
// encodeAdf removes leading spaces, so prepend a text node with the segment's leading spaces to preserve them.
const $c360078fe01b00e3$var$preserveLeadingSpaces = (textSegment, nodes)=>{
    const leading = textSegment.match(/^\s*/)?.[0] ?? '';
    if (leading.length === 0) return nodes;
    return [
        {
            type: 'text',
            text: leading
        },
        ...nodes
    ];
};
// Collect all content nodes from all top-level blocks, since encodeAdf can return multiple paragraphs for e.g. "line1\n\nline2".
const $c360078fe01b00e3$var$getAllNodesFromSegmentAdf = (segmentAdf, fallbackSegment)=>{
    const blocks = segmentAdf.content ?? [];
    if (blocks.length === 0) return [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
    const nodes = blocks.flatMap((block)=>block.content ?? []);
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
};
const $c360078fe01b00e3$var$detectSkills = (content, skillMetadata)=>{
    if (!skillMetadata) return [];
    const regex = new RegExp((0, $8lhhf.ROVO_SKILL_TAG_PATTERN).source, 'g');
    const matches = [
        ...content.matchAll(regex)
    ];
    if (matches.length === 0) return [];
    return matches.filter((m)=>m[1] in skillMetadata).map((m)=>({
            index: m.index ?? 0,
            slug: m[1],
            length: m[0].length
        }));
};
// The conversation input editor only supports a limited set of block node types.
// Convert unsupported block nodes to paragraph nodes so that prompts containing
// markdown headings (e.g. "## Title") or horizontal rules (e.g. "---") do not
// trigger "This editor does not support displaying this content: <type>" when inserted.
const $c360078fe01b00e3$var$sanitizeAdfForPromptInput = (adf)=>{
    if (!adf.content) return adf;
    return {
        ...adf,
        content: adf.content.flatMap((node)=>{
            if (node.type === 'heading') // Convert heading to paragraph, preserving inner text content
            return [
                {
                    type: 'paragraph',
                    content: node.content
                }
            ];
            if (node.type === 'rule') // Drop horizontal rules entirely — they have no content to preserve
            return [];
            return [
                node
            ];
        })
    };
};
const $c360078fe01b00e3$export$20cf1197bba4fe47 = (content, skillMetadata, shouldShowAsInline)=>{
    const skillMatches = $c360078fe01b00e3$var$detectSkills(content, skillMetadata);
    if (skillMatches.length === 0) {
        const { placeholderRange: placeholderRange } = $c360078fe01b00e3$var$getPlaceholderRange(content, 0);
        return {
            adf: $c360078fe01b00e3$var$sanitizeAdfForPromptInput($c360078fe01b00e3$export$53ded0b846f45216(content, false, undefined, shouldShowAsInline)),
            promptLength: content.length,
            ...placeholderRange && {
                placeholderRange: placeholderRange
            }
        };
    }
    return $c360078fe01b00e3$var$encodePromptWithSkills(content, skillMatches, skillMetadata);
};
const $c360078fe01b00e3$var$encodePromptWithSkills = (content, skillMatches, skillMetadata)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let promptLength = 0;
    let placeholderRange;
    for(let i = 0; i < skillMatches.length; i++){
        const currentMatch = skillMatches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text and placeholder range before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textSegment = content.substring(lastIndex, matchStart);
            if (textSegment) {
                const { placeholderRange: range } = $c360078fe01b00e3$var$getPlaceholderRange(textSegment, promptLength);
                if (range) placeholderRange = range;
                const segmentAdf = $c360078fe01b00e3$export$53ded0b846f45216(textSegment);
                const nodes = $c360078fe01b00e3$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
                contentNodes.push(...$c360078fe01b00e3$var$preserveLeadingSpaces(textSegment, nodes));
                promptLength += textSegment.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.slug,
                    ...skillMetadata?.[currentMatch.slug]
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text and placeholder range after the last match (if any)
    if (lastIndex < content.length) {
        const textSegment = content.substring(lastIndex);
        if (textSegment) {
            const { placeholderRange: range } = $c360078fe01b00e3$var$getPlaceholderRange(textSegment, promptLength);
            if (range) placeholderRange = range;
            const segmentAdf = $c360078fe01b00e3$export$53ded0b846f45216(textSegment);
            const nodes = $c360078fe01b00e3$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
            contentNodes.push(...$c360078fe01b00e3$var$preserveLeadingSpaces(textSegment, nodes));
            promptLength += textSegment.length;
        }
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength,
        ...placeholderRange && {
            placeholderRange: placeholderRange
        }
    };
};
// Returns the placeholder range for link typeahead when content has `label` backticks.
const $c360078fe01b00e3$var$getPlaceholderRange = (segment, currentContentIndex)=>{
    const firstBacktick = segment.indexOf($c360078fe01b00e3$export$b663bc0d84e6eaa6);
    const lastBacktick = segment.lastIndexOf($c360078fe01b00e3$export$b663bc0d84e6eaa6);
    if (firstBacktick !== -1 && lastBacktick !== -1 && firstBacktick !== lastBacktick) {
        const label = segment.slice(firstBacktick + 1, lastBacktick);
        const start = currentContentIndex + firstBacktick + 1;
        return {
            placeholderRange: {
                start: start,
                end: start + label.length,
                label: label
            }
        };
    }
    return {};
};
module.exports["isAdfContent"] = $c360078fe01b00e3$export$d801201dc544181;
module.exports["appendContent"] = $c360078fe01b00e3$export$a236f395afded7e0;
module.exports["adfEncoder"] = $c360078fe01b00e3$export$3374c63d7715b4ce;
module.exports["encodeAdf"] = $c360078fe01b00e3$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $c360078fe01b00e3$export$cc924f6f2bb49b7c;
module.exports["PROMPT_PLACEHOLDER_CHAR"] = $c360078fe01b00e3$export$b663bc0d84e6eaa6;
module.exports["encodePromptToAdf"] = $c360078fe01b00e3$export$20cf1197bba4fe47;

});

parcelRegister("hUsog", function(module, exports) {

var $3GWdi = parcelRequire("3GWdi");


var $zBSTr = parcelRequire("zBSTr");


var $c9zHD = parcelRequire("c9zHD");


var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $iDrrr = parcelRequire("iDrrr");


var $ae1na = parcelRequire("ae1na");


var $lz2jD = parcelRequire("lz2jD");


var $lxRLM = parcelRequire("lxRLM");


var $diCaM = parcelRequire("diCaM");


var $7CEea = parcelRequire("7CEea");


var $3eAWZ = parcelRequire("3eAWZ");


var $77gNR = parcelRequire("77gNR");


var $a1mp1 = parcelRequire("a1mp1");


var $8Idwp = parcelRequire("8Idwp");


var $a52Mw = parcelRequire("a52Mw");


var $ejOiD = parcelRequire("ejOiD");


var $1JPkQ = parcelRequire("1JPkQ");


var $dapfS = parcelRequire("dapfS");


var $6X3gJ = parcelRequire("6X3gJ");


var $bf7Qg = parcelRequire("bf7Qg");


var $k73tv = parcelRequire("k73tv");

class $ed41d4af387b8a76$export$614853bf2169db97 extends (0, $c9zHD.MarkdownTransformer) {
    parse(content) {
        // Sanitize the raw markdown string before it reaches the markdown-it block
        // tokenizer (ParserBlock.tokenize). Indented tables and 4+ space-indented
        // fences can cause catastrophic backtracking / OOM; `sanitizeMarkdown`
        // outdents fences with 4+ spaces of indentation so the parser recognises
        // them as fenced code blocks rather than entering an infinite tokenization
        // loop.
        //
        // Note: md.core.ruler cannot be used here — core rules run AFTER block
        // tokenization, which is too late to prevent the crash. The sanitization
        // must happen on the raw string before parse() is called.
        const preprocessed = (0, $bf7Qg.normalizeBorderlessTables)(content);
        const node = this.parser.parse((0, $bf7Qg.sanitizeMarkdown)(preprocessed));
        if (!node) return new (0, $aPdNQ.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl){
        super();
        this.parser = void 0;
        const md = (0, $3GWdi.default)('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $k73tv.enableSchemaPlugins)(md, schema);
        // Handle blockquotes inside list items - ADF doesn't support this nesting,
        // so we transform them into emphasized paragraphs
        md.use((0, $a1mp1.default));
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $77gNR.createLinkifyPlugin)(pluginConfig.linkify));
        if (useGroupedCitations) md.use((0, $diCaM.default));
        else md.use((0, $ae1na.default));
        if ((0, $iDrrr.fg)('rovo_enable_data_sculptor')) md.use((0, $lz2jD.default));
        md.use((0, $lxRLM.default));
        md.use((0, $dapfS.default));
        if ((0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) md.use((0, $3eAWZ.default));
        // Actionable follow-up questions
        if ((0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled')) md.use((0, $7CEea.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $ejOiD.createSmartLinksPlugin)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $a52Mw.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $zBSTr.markdownItTable));
            md.use((0, $1JPkQ.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $8Idwp.default));
        const filter = (0, $k73tv.filterSchemaMapping)(schema, (0, $6X3gJ.mdToPmSchema));
        this.parser = new (0, $2jzwX.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $ed41d4af387b8a76$export$614853bf2169db97;

});

parcelRegister("ae1na", function(module, exports) {
$parcel$export(module.exports, "default", () => $330d5ffa0743cdd8$export$2e2bcd8739ae039);
const $330d5ffa0743cdd8$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $330d5ffa0743cdd8$var$citation = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $330d5ffa0743cdd8$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($330d5ffa0743cdd8$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $330d5ffa0743cdd8$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $330d5ffa0743cdd8$var$citation);

});

parcelRegister("lz2jD", function(module, exports) {
$parcel$export(module.exports, "default", () => $157bfca8bd99df8f$export$2e2bcd8739ae039);
const $157bfca8bd99df8f$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $157bfca8bd99df8f$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $157bfca8bd99df8f$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($157bfca8bd99df8f$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $157bfca8bd99df8f$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $157bfca8bd99df8f$var$dataSculptor);

});

parcelRegister("lxRLM", function(module, exports) {
const $14c428bc00c0e101$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $14c428bc00c0e101$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $14c428bc00c0e101$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($14c428bc00c0e101$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $14c428bc00c0e101$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $14c428bc00c0e101$var$expandable);
};
var $14c428bc00c0e101$export$2e2bcd8739ae039 = $14c428bc00c0e101$var$mdPluginExpandable;
module.exports["default"] = $14c428bc00c0e101$export$2e2bcd8739ae039;

});

parcelRegister("diCaM", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c7e36d126f9ad4$export$2e2bcd8739ae039);
const $26c7e36d126f9ad4$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $26c7e36d126f9ad4$var$groupedCitations = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $26c7e36d126f9ad4$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($26c7e36d126f9ad4$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                let citationIndices = [];
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if ((isLastCitationDuplicate || citationIndices.length > 0) && part.trim() === '') return;
                        if (part.trim() !== '') {
                            /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                            /**
                 * once we reach a text part, we need to capture the indices of the citations that have occurred up to this point
                 *
                 * Example
                 * `Hello [^1^][^2^] The example continues` -> parts = ['Hello ', '1', '', '2', 'The example continues']
                 * When 'The example continues' is reached, we need to create a status token for the citations prior
                 */ if (citationIndices.length > 0) {
                                const citationToken = new state.Token('status', '', 0);
                                citationToken.content = '';
                                citationToken.block = false;
                                citationToken.level = childToken.level;
                                // localId is used to identify the citation indices in the DOM
                                // this overrides the uuid that is normally used
                                // NOTE: ReactRenderer expects specific props for status nodes and
                                // therefore we cannot pass in custom attributes
                                citationToken.attrs = [
                                    [
                                        'color',
                                        'blue'
                                    ],
                                    [
                                        'text',
                                        'citation'
                                    ],
                                    // citationIndices is used to identify the citation token in the DOM
                                    // this overrides the uuid that is normally used
                                    [
                                        'localId',
                                        JSON.stringify(citationIndices)
                                    ]
                                ];
                                newChildren.push(citationToken);
                                citationIndices = [];
                            }
                        }
                        const textToken = new state.Token('text', '', 0);
                        // don't add trailing space if part already ends with one
                        textToken.content = index === parts.length - 1 ? part : part.endsWith(' ') ? part : part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        if (part !== '') newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        citationIndices.push(parseInt(part));
                    }
                });
                /**
           * Once we've reached the end of parts, we need to create a status token for any citations at the very end
           *
           * Example: `Hello [^1^][^2^]` -> parts = ['Hello ', '1', '', '2', '']
           * When we've iterated through all of parts, 1 and 2 indices exist in citationIndices, and a status token needs to be created
           */ if (citationIndices.length > 0) {
                    const citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'color',
                            'blue'
                        ],
                        [
                            'text',
                            'citation'
                        ],
                        [
                            'localId',
                            JSON.stringify(citationIndices)
                        ]
                    ];
                    newChildren.push(citationToken);
                    citationIndices = [];
                }
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $26c7e36d126f9ad4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $26c7e36d126f9ad4$var$groupedCitations);

});

parcelRegister("7CEea", function(module, exports) {
$parcel$export(module.exports, "default", () => $04a93a56598a27a8$export$2e2bcd8739ae039);

var $6Bfyn = parcelRequire("6Bfyn");

const $04a93a56598a27a8$var$FOLLOW_UPS_REGEX = /\[\^(actionable-follow-ups)\^\]/;
/**
 * Replaces the `[^actionable-follow-ups^]` placeholder (injected when the `◈`
 * marker is extracted from the assistant response) with a `status` node whose
 * `localId`/`text` is prefixed with `ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX`. The
 * renderer swaps that status node for the actionable follow-up questions UI,
 * pulling the parsed questions from the message's `markdownData`.
 *
 * Mirrors `md-plugin-inline-lumina`.
 */ const $04a93a56598a27a8$var$inlineFollowUps = (state)=>{
    const tokens = [];
    let followUpsCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $04a93a56598a27a8$var$FOLLOW_UPS_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($04a93a56598a27a8$var$FOLLOW_UPS_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const followUpsToken = new state.Token('status', '', 0);
                        followUpsToken.content = '';
                        followUpsToken.block = false;
                        followUpsToken.level = childToken.level;
                        followUpsToken.attrs = [
                            [
                                'localId',
                                (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'text',
                                (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(followUpsToken);
                        followUpsCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $04a93a56598a27a8$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-follow-ups', $04a93a56598a27a8$var$inlineFollowUps);
}

});

parcelRegister("6Bfyn", function(module, exports) {
/**
 * Actionable Follow-Up Questions parsing utilities.
 *
 * The backend appends a follow-up section to the end of an assistant answer using a
 * single section marker followed by prose with inline `<followup>…</followup>` tagged
 * questions interspersed:
 *
 *   Normal answer text...
 *
 *   ◈If you want I can <followup>Convert this to a FAQ</followup>, <followup>Add target personas</followup>, or <followup>Make the tone more formal</followup>
 *
 * There is no end marker — everything after the first `◈` is the follow-up payload and
 * is assumed to be the last thing in the message. The surrounding prose renders as
 * normal text, while each `<followup>…</followup>` renders as an inline clickable link.
 *
 * See LDR: https://hello.atlassian.net/wiki/spaces/AA6/pages/7164582669
 */ /** Section marker (U+25C8) that denotes the start of the follow-up questions payload. */ const $d346e53a09a489f1$export$159e069055621f01 = "\u25C8";
const $d346e53a09a489f1$export$3b3ac8a86d553ab4 = 'actionable-follow-ups-';
const $d346e53a09a489f1$export$5b6a3157002ae3dc = (localId)=>{
    return localId != null && localId.startsWith($d346e53a09a489f1$export$3b3ac8a86d553ab4);
};
/**
 * Matches each `<followup>…</followup>` segment in the follow-up payload. The inner capture
 * is non-greedy and allows any character (including `<`/`>`), so question text containing
 * angle brackets parses correctly. An unterminated `<followup>` with no closing tag simply
 * does not match and is treated as in-flight prose.
 */ const $d346e53a09a489f1$var$FOLLOW_UP_QUESTION_REGEX = /<followup>([\s\S]*?)<\/followup>/g;
const $d346e53a09a489f1$export$7111c271f22de367 = (payload)=>{
    if (!payload) return [];
    // Strip a leading marker if the caller passed the full section including `◈`.
    const markerIndex = payload.indexOf($d346e53a09a489f1$export$159e069055621f01);
    let text = markerIndex === -1 ? payload : payload.slice(markerIndex + $d346e53a09a489f1$export$159e069055621f01.length);
    // Drop an unterminated trailing `<followup>` fragment so a half-streamed question
    // is not rendered as raw text until its closing tag arrives.
    const lastOpen = text.lastIndexOf('<followup>');
    if (lastOpen !== -1 && text.indexOf('</followup>', lastOpen) === -1) text = text.slice(0, lastOpen);
    const segments = [];
    let lastIndex = 0;
    const pushText = (value)=>{
        if (value) segments.push({
            type: 'text',
            value: value
        });
    };
    for (const match of text.matchAll($d346e53a09a489f1$var$FOLLOW_UP_QUESTION_REGEX)){
        const matchIndex = match.index ?? 0;
        // Prose preceding this question (preserved verbatim).
        pushText(text.slice(lastIndex, matchIndex));
        lastIndex = matchIndex + match[0].length;
        const question = match[1]?.trim();
        if (question) segments.push({
            type: 'question',
            value: question
        });
    }
    // Trailing prose after the final question.
    pushText(text.slice(lastIndex));
    return segments;
};
module.exports["ACTIONABLE_FOLLOW_UPS_MARKER"] = $d346e53a09a489f1$export$159e069055621f01;
module.exports["ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX"] = $d346e53a09a489f1$export$3b3ac8a86d553ab4;
module.exports["isActionableFollowUpsStatus"] = $d346e53a09a489f1$export$5b6a3157002ae3dc;
module.exports["parseActionableFollowUps"] = $d346e53a09a489f1$export$7111c271f22de367;

});

parcelRegister("3eAWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbeb09636b3688aa$export$2e2bcd8739ae039);

var $1rNZu = parcelRequire("1rNZu");

const $bbeb09636b3688aa$var$LUMINA_REGEX = /\[\^(lumina)\^\]/;
const $bbeb09636b3688aa$var$inlineLumina = (state)=>{
    const tokens = [];
    let luminaCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $bbeb09636b3688aa$var$LUMINA_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($bbeb09636b3688aa$var$LUMINA_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const luminaToken = new state.Token('status', '', 0);
                        luminaToken.content = '';
                        luminaToken.block = false;
                        luminaToken.level = childToken.level;
                        luminaToken.attrs = [
                            [
                                'localId',
                                (0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'text',
                                (0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(luminaToken);
                        luminaCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $bbeb09636b3688aa$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-lumina', $bbeb09636b3688aa$var$inlineLumina);
}

});

parcelRegister("1rNZu", function(module, exports) {
const $90cb542132d5af8c$export$8288860537fb7872 = 'inline-lumina-';
const $90cb542132d5af8c$export$5d9d37bd58628e00 = (localId)=>{
    return localId != null && localId.startsWith($90cb542132d5af8c$export$8288860537fb7872);
};
module.exports["INLINE_LUMINA_STATUS_PREFIX"] = $90cb542132d5af8c$export$8288860537fb7872;
module.exports["isInlineLuminaStatus"] = $90cb542132d5af8c$export$5d9d37bd58628e00;

});

parcelRegister("77gNR", function(module, exports) {

var $fX7cS = parcelRequire("fX7cS");

const $b9f103c37ce71df9$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', (0, $fX7cS.createLinkify)(params));
module.exports["createLinkifyPlugin"] = $b9f103c37ce71df9$export$763ac077c9998026;

});

parcelRegister("fX7cS", function(module, exports) {

var $tALAR = parcelRequire("tALAR");


var $9p0BY = parcelRequire("9p0BY");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $d7524ac980d0a478$var$arrayReplaceAt = (src, pos, newElements)=>[].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
const $d7524ac980d0a478$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $d7524ac980d0a478$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $d7524ac980d0a478$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, $tALAR.default)();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children ?? [];
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($d7524ac980d0a478$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($d7524ac980d0a478$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $9p0BY.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $d7524ac980d0a478$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
module.exports["createLinkify"] = $d7524ac980d0a478$export$8cd7d1ec2e6808da;

});

parcelRegister("a1mp1", function(module, exports) {
/**
 * This plugin handles blockquotes nested inside list items.
 * Since ADF doesn't support blockquotes as children of listItems,
 * we transform blockquote content into emphasized (italic) paragraphs.
 *
 * Before: 1. Item\n   > "Quote"
 * After:  1. Item\n   _"Quote"_
 *
 * This allows quotes within lists to render gracefully as italicized text
 * rather than failing due to ADF schema constraints.
 */ const $d2188aa6b0aad9ac$var$listBlockquoteFallback = (state)=>{
    const tokens = state.tokens;
    let listDepth = 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Track list nesting depth
        if (token.type === 'ordered_list_open' || token.type === 'bullet_list_open') listDepth++;
        else if (token.type === 'ordered_list_close' || token.type === 'bullet_list_close') listDepth--;
        // If we're inside a list and encounter a blockquote, transform it
        if (listDepth > 0 && token.type === 'blockquote_open') {
            // Find the matching blockquote_close
            let closeIndex = -1;
            let depth = 1;
            for(let j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'blockquote_open') depth++;
                else if (tokens[j].type === 'blockquote_close') {
                    depth--;
                    if (depth === 0) {
                        closeIndex = j;
                        break;
                    }
                }
            }
            if (closeIndex !== -1) {
                // Mark the blockquote tokens for removal
                token.type = 'blockquote_fallback_open';
                token.hidden = true;
                tokens[closeIndex].type = 'blockquote_fallback_close';
                tokens[closeIndex].hidden = true;
                // Process the content inside the blockquote
                // We need to wrap the inline content with emphasis marks
                for(let j = i + 1; j < closeIndex; j++){
                    const innerToken = tokens[j];
                    if (innerToken.type === 'inline' && innerToken.children) {
                        // Wrap all children with em marks
                        const emOpen = new state.Token('em_open', 'em', 1);
                        emOpen.block = false;
                        const emClose = new state.Token('em_close', 'em', -1);
                        emClose.block = false;
                        innerToken.children = [
                            emOpen,
                            ...innerToken.children,
                            emClose
                        ];
                    }
                }
            }
        }
    }
    // Filter out the hidden blockquote fallback tokens
    state.tokens = tokens.filter((t)=>t.type !== 'blockquote_fallback_open' && t.type !== 'blockquote_fallback_close');
};
const $d2188aa6b0aad9ac$var$mdPluginListBlockquoteFallback = (md)=>{
    md.core.ruler.push('list_blockquote_fallback', $d2188aa6b0aad9ac$var$listBlockquoteFallback);
};
var $d2188aa6b0aad9ac$export$2e2bcd8739ae039 = $d2188aa6b0aad9ac$var$mdPluginListBlockquoteFallback;
module.exports["default"] = $d2188aa6b0aad9ac$export$2e2bcd8739ae039;

});

parcelRegister("8Idwp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5125c80d561f745e$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $5125c80d561f745e$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                // Adjust cursor to account for previously skipped/modified tokens
                const adjustedCursor = cursor - indexOffset;
                tokens = [
                    ...tokens.slice(0, adjustedCursor),
                    ...subTree
                ];
                // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                indexOffset += i + 1 - cursor - subTree.length;
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $5125c80d561f745e$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $5125c80d561f745e$var$createRule());
};

});

parcelRegister("a52Mw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6cf044b287ff6bb$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $d6cf044b287ff6bb$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $d6cf044b287ff6bb$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $d6cf044b287ff6bb$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $d6cf044b287ff6bb$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$d6cf044b287ff6bb$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $d6cf044b287ff6bb$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $d6cf044b287ff6bb$var$mentionLinks);

});

parcelRegister("ejOiD", function(module, exports) {

var $kUcLs = parcelRequire("kUcLs");

const $b36376af2b96b431$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $b36376af2b96b431$var$linkPatternEnd = '[^\\s\\]\\)]*';
const $b36376af2b96b431$var$linkRegex = {
    youtube: `${$b36376af2b96b431$var$linkPatternStart}youtube\\.com${$b36376af2b96b431$var$linkPatternEnd}`,
    youtubeShortUrl: `${$b36376af2b96b431$var$linkPatternStart}youtu\\.be${$b36376af2b96b431$var$linkPatternEnd}`,
    loomVideo: `${$b36376af2b96b431$var$linkPatternStart}loom\\.com\\/share\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    figmaFile: `${$b36376af2b96b431$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$b36376af2b96b431$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googleDoc: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googleForm: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    microsoftForm: `${$b36376af2b96b431$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$b36376af2b96b431$var$linkPatternEnd}`,
    // this will be removed following project
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$b36376af2b96b431$var$linkPatternEnd}` // this will be removed following project
};
const $b36376af2b96b431$var$newThirdPartyLinkRegex = {
    github: `${$b36376af2b96b431$var$linkPatternStart}github\\.com${$b36376af2b96b431$var$linkPatternEnd}`,
    canvaDesign: `${$b36376af2b96b431$var$linkPatternStart}canva\\.com\\/design\\/[a-zA-Z0-9_\\-.]{1,255}\\/[a-zA-Z0-9_\\-.]{1,255}(?:\\/[^\\s\\]\\)]*)?`,
    canvaShortLink: `${$b36376af2b96b431$var$linkPatternStart}canva\\.link\\/[a-zA-Z0-9]+(?:\\?${$b36376af2b96b431$var$linkPatternEnd})?`,
    rovo: `${$b36376af2b96b431$var$linkPatternStart}[^\\s\\]\\)]*\\.atlassian\\.net\\/rovo${$b36376af2b96b431$var$linkPatternEnd}`,
    amplitude: `${$b36376af2b96b431$var$linkPatternStart}app\\.amplitude\\.com${$b36376af2b96b431$var$linkPatternEnd}`
};
const $b36376af2b96b431$var$buildEmbedRegex = (includeNewThirdParties)=>{
    const patterns = [
        ...Object.values($b36376af2b96b431$var$linkRegex),
        ...includeNewThirdParties ? Object.values($b36376af2b96b431$var$newThirdPartyLinkRegex) : []
    ];
    return new RegExp(patterns.join('|'), 'g');
};
const $b36376af2b96b431$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$b36376af2b96b431$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$b36376af2b96b431$var$linkPatternEnd}`
];
const $b36376af2b96b431$var$avpChartsRegex = `${$b36376af2b96b431$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$b36376af2b96b431$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $b36376af2b96b431$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $b36376af2b96b431$var$createSmartLinks = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline, xpcWrapUrl: xpcWrapUrl })=>(state)=>{
        const embedRegex = $b36376af2b96b431$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $b36376af2b96b431$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $kUcLs.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // This link will be rendered as a smart link (embed or inline card) by the linking
                        // platform, so we only strip the `datasource` param without applying full XPC wrapping.
                        const smartLinkUrl = xpcWrapUrl ? xpcWrapUrl(url, true) : url;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $b36376af2b96b431$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($b36376af2b96b431$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($b36376af2b96b431$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($b36376af2b96b431$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                // Capture whether the URL was standalone on its own line
                                // (i.e. there was no preceding text in the same paragraph)
                                const isStandaloneUrl = processedTokenChildren.length === 0;
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', smartLinkUrl);
                                embedToken.attrSet('layout', 'center');
                                // Mark whether this embed came from a standalone-line URL
                                if (isStandaloneUrl && isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false)) embedToken.attrSet('isStandalone', 'true');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', smartLinkUrl);
                        processedTokenChildren.push(cardToken);
                        return;
                    } else if (xpcWrapUrl && childToken?.type === 'link_open') // For plain links not supported by the linking platform, apply xpcWrapUrl (with full wrapping) to the href
                    childToken.attrSet('href', xpcWrapUrl(url, false));
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $b36376af2b96b431$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl)=>(md)=>md.core.ruler.push('inlineCard', $b36376af2b96b431$var$createSmartLinks({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline,
            xpcWrapUrl: xpcWrapUrl
        }));
module.exports["createSmartLinksPlugin"] = $b36376af2b96b431$export$9625a798761643ac;

});

parcelRegister("kUcLs", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $3LOz3 = parcelRequire("3LOz3");

const $300d1def19fa699b$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $300d1def19fa699b$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    try {
        const regexPattern = new RegExp(cachedProviderRegex, 'g');
        return regexPattern.test(url);
    } catch  {
        // Malformed joined provider regex (e.g. duplicate named capture groups) — treat as unsupported.
        return false;
    }
};
const $300d1def19fa699b$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $3LOz3.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $3LOz3.LS_PROVIDER_KEY))}`);
    return '';
};
const $300d1def19fa699b$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $3LOz3.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $300d1def19fa699b$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $300d1def19fa699b$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $300d1def19fa699b$export$b7ac97ae80c7eb5a(providerData);
        $300d1def19fa699b$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $300d1def19fa699b$export$8eafd18d19de7df5(providerData);
        $300d1def19fa699b$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $300d1def19fa699b$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $300d1def19fa699b$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $300d1def19fa699b$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $3LOz3.LS_PROVIDER_MAPPING_KEY));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $300d1def19fa699b$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $3LOz3.LS_PROVIDER_MAPPING_KEY), JSON.stringify(providerMapping));
};
const $300d1def19fa699b$export$dfebbb511ada4128 = (0, $dOBRD.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $3LOz3.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $300d1def19fa699b$export$ab8eaff0f2d596bd = (0, $dOBRD.default)(async (baseUrl = '')=>{
    const data = await $300d1def19fa699b$export$dfebbb511ada4128(baseUrl);
    return data ? $300d1def19fa699b$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $300d1def19fa699b$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $300d1def19fa699b$export$d08c351b3b4e4934;

});

parcelRegister("3LOz3", function(module, exports) {
const $88340c96f33dece1$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $88340c96f33dece1$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $88340c96f33dece1$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $88340c96f33dece1$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';
module.exports["PROVIDERS_API"] = $88340c96f33dece1$export$57ad190cdc563df3;
module.exports["LS_PROVIDER_KEY"] = $88340c96f33dece1$export$56bec2f197c16818;
module.exports["LS_PROVIDER_MAPPING_KEY"] = $88340c96f33dece1$export$b9858121ed269ff3;

});

parcelRegister("1JPkQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $75906c97e0460a14$export$2e2bcd8739ae039);
const $75906c97e0460a14$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $75906c97e0460a14$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $75906c97e0460a14$var$tableBreakTags);

});

parcelRegister("dapfS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1502a9fc09adec99$export$2e2bcd8739ae039);
const $1502a9fc09adec99$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $1502a9fc09adec99$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $1502a9fc09adec99$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($1502a9fc09adec99$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $1502a9fc09adec99$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $1502a9fc09adec99$var$visualizationChart);
}

});

parcelRegister("6X3gJ", function(module, exports) {
const $d663afbcbcce9912$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $d663afbcbcce9912$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('start') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};
module.exports["pmToMd"] = $d663afbcbcce9912$export$cd54a56af01ba875;
module.exports["mdToPmSchema"] = $d663afbcbcce9912$export$eb83d753215c78a2;

});

parcelRegister("bf7Qg", function(module, exports) {
/**
 * Sanitizes raw markdown content before it reaches the markdown-it block tokenizer.
 *
 * Two constructs cause `ParserBlock.prototype.tokenize` to enter catastrophic
 * backtracking / exponential rule-matching, causing OOM browser crashes:
 *
 * ## 1. Tables indented 2+ spaces (inside a list item)
 *
 * The `markdown-it-table` plugin requires the table header row to start at
 * column 0 (or ≤1 space of indentation). When an AI response places a table
 * inside a list item — a common pattern — the table rows are indented with
 * 2+ spaces and are never recognized as a table block.
 *
 * Instead, each `|---` separator row triggers markdown-it's `lheading`
 * (setext heading) rule which checks whether the preceding paragraph can be
 * promoted to a heading. This check is O(n) against all prior paragraphs,
 * repeated for every `|` row in the table → O(n²) overall. For documents
 * with 200+ lines and multiple tables, this crashes the browser.
 *
 * ## 2. Code fences indented 4+ spaces (inside nested list items)
 *
 * markdown-it's `fence` block rule only recognizes fences with 0–3 spaces of
 * leading indentation. Fences indented with 4+ spaces (common inside nested
 * list items like "     ```jql") are treated as indented code continuation,
 * meaning the opening fence is never paired with its closing fence. The block
 * parser then tries every rule against the remaining content until EOF →
 * effectively infinite loop → OOM.
 *
 * ## Fix
 *
 * Strip excess leading whitespace from table rows and fence delimiters so
 * they are recognized by the parser as valid block-level constructs. A
 * fence-tracking state machine ensures that table rows and fence delimiters
 * *inside* a code fence are never modified.
 */ // Fast pre-check: matches a line starting with 2+ spaces followed by `|` or ` ``` `.
// Uses (^|\n) so it also catches indented constructs on the very first line.
// If the content has neither, skip the full line-by-line pass entirely.
const $75f540d30ffc20bf$var$NEEDS_SANITIZE_RE = /(?:^|\n) {2,}[|`]/;
function $75f540d30ffc20bf$export$20209a1e2cc01cc1(content) {
    if (!$75f540d30ffc20bf$var$NEEDS_SANITIZE_RE.test(content)) return content;
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    let fenceIndent = 0;
    for (const line of lines){
        const stripped = line.replace(/^\s+/, '');
        const indent = line.length - stripped.length;
        if (!inFence && stripped.startsWith('```')) {
            if (indent >= 4) {
                // Outdent deeply-indented opening fence to column 0 so the parser
                // recognizes it as a fenced code block
                result.push(stripped);
                inFence = true;
                fenceIndent = indent;
            } else {
                result.push(line);
                inFence = true;
                fenceIndent = indent;
            }
        } else if (inFence && stripped.startsWith('```')) {
            if (indent >= 4 && fenceIndent >= 4) // Outdent matching closing fence
            result.push(stripped);
            else result.push(line);
            inFence = false;
            fenceIndent = 0;
        } else if (!inFence && indent >= 2 && stripped.startsWith('|')) // Outdent table rows that are indented inside list items so
        // markdown-it-table recognizes them as a proper table block
        result.push(stripped);
        else result.push(line);
    }
    return result.join('\n');
}
// Matches a markdown table delimiter/separator row, with or without outer pipes,
// e.g. "--- | ---", "| :--- | ---: |", ":-:|:-:". Requires at least one dash.
const $75f540d30ffc20bf$var$SEPARATOR_ROW_RE = /^\s*\|?\s*:?-{3,}:?\s*(?:\|\s*:?-{3,}:?\s*)*\|?\s*$/;
const $75f540d30ffc20bf$var$isSeparatorRow = (line)=>line.includes('-') && $75f540d30ffc20bf$var$SEPARATOR_ROW_RE.test(line);
const $75f540d30ffc20bf$var$isTableRow = (line)=>line.includes('|') && line.trim().length > 0;
function $75f540d30ffc20bf$export$d000c4875e648c8(content) {
    // Fast pre-check: needs at least one line with a pipe.
    if (!content.includes('|')) return content;
    const addOuterPipes = (line)=>{
        let trimmed = line.trim();
        if (!trimmed.startsWith('|')) trimmed = `| ${trimmed}`;
        if (!trimmed.endsWith('|')) trimmed = `${trimmed} |`;
        return trimmed;
    };
    const isFenceDelimiter = (line)=>line.trimStart().startsWith('```');
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        // Skip fenced code blocks entirely.
        if (isFenceDelimiter(line)) {
            inFence = !inFence;
            result.push(line);
            continue;
        }
        const next = lines[i + 1];
        // A table starts on a row immediately followed by a separator.
        if (!inFence && $75f540d30ffc20bf$var$isTableRow(line) && next !== undefined && $75f540d30ffc20bf$var$isSeparatorRow(next)) {
            let j = i;
            // Consume contiguous, non-blank rows until the table ends.
            while(j < lines.length && lines[j].trim() !== '' && $75f540d30ffc20bf$var$isTableRow(lines[j])){
                result.push(addOuterPipes(lines[j]));
                j++;
            }
            i = j - 1;
        } else result.push(line);
    }
    return result.join('\n');
}
module.exports["sanitizeMarkdown"] = $75f540d30ffc20bf$export$20209a1e2cc01cc1;
module.exports["normalizeBorderlessTables"] = $75f540d30ffc20bf$export$d000c4875e648c8;

});

parcelRegister("k73tv", function(module, exports) {

var $6X3gJ = parcelRequire("6X3gJ");

const $f6c1dd52940ddca5$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $f6c1dd52940ddca5$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $6X3gJ.pmToMd){
        const key = k;
        for(const i in (0, $6X3gJ.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $6X3gJ.pmToMd)[key][idx]);
        }
    }
};
module.exports["filterSchemaMapping"] = $f6c1dd52940ddca5$export$155749302793c60c;
module.exports["enableSchemaPlugins"] = $f6c1dd52940ddca5$export$a1cf9d9b96e16789;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("iuCeV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $bjY3F = parcelRequire("bjY3F");

const $4726ba45c1bca0cb$export$4962f3898bd5c829 = ({ name: name, trigger: trigger = 'mount' })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const successTriggerRef = (0, $cozmU.useRef)(trigger);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        if (successTriggerRef.current === 'mount') experienceTracker.succeed({
            name: name
        });
        if (successTriggerRef.current === 'unmount') return ()=>{
            experienceTracker.succeed({
                name: name
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab = ({ error: error, name: name })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.fail({
            name: name,
            error: error
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$f20b867e738a222c = ({ name: name, attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useMemo)(()=>{
        experienceTracker.start({
            id: name,
            name: name,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["ExperienceSuccess"] = $4726ba45c1bca0cb$export$4962f3898bd5c829;
module.exports["ExperienceFailure"] = $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab;
module.exports["ExperienceStart"] = $4726ba45c1bca0cb$export$f20b867e738a222c;

});

parcelRegister("4m5jb", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $igOtY = parcelRequire("igOtY");

const $ee15880d8017ee4c$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $ee15880d8017ee4c$var$initialState = {
    conversations: {
        EMPTY_CONVERSATION_ID: {
            id: $ee15880d8017ee4c$export$a08ae3ac6db36809,
            messages: [],
            name: '',
            status: (0, $igOtY.CHAT_STORE_STATUS).idle,
            traces: [],
            timeCreated: new Date().toISOString()
        }
    },
    currentConversationId: $ee15880d8017ee4c$export$a08ae3ac6db36809,
    isConversationsInitialized: false,
    conversationPagination: {
        ...(0, $igOtY.DEFAULT_CONVERSATION_PAGINATION)
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $ee15880d8017ee4c$var$store;
const $ee15880d8017ee4c$export$8572e013e9dc20c3 = (actions)=>{
    if (!$ee15880d8017ee4c$var$store) $ee15880d8017ee4c$var$store = (0, $8s9DV.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $ee15880d8017ee4c$var$initialState,
        actions: actions
    });
    // The module-level `store` is typed as `any` because its action type T is
    // not known at declaration time. The cast here is safe: `createChatStore` is
    // always called with the same concrete actions object.
    return $ee15880d8017ee4c$var$store;
};
module.exports["EMPTY_CONVERSATION_ID"] = $ee15880d8017ee4c$export$a08ae3ac6db36809;
module.exports["createChatStore"] = $ee15880d8017ee4c$export$8572e013e9dc20c3;

});

parcelRegister("igOtY", function(module, exports) {
var $318bcc25577ef9d7$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["loadMoreConversationChannelsData"] = "loadMoreConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $318bcc25577ef9d7$export$61e8a5ac076d12b3 = {
    nextCursor: null,
    hasMore: false,
    isLoadingMore: false,
    loadMoreError: null,
    isConversationListMounted: false
};
const $318bcc25577ef9d7$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $318bcc25577ef9d7$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $318bcc25577ef9d7$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $318bcc25577ef9d7$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $318bcc25577ef9d7$export$e87901ebf76c08a1 = (state)=>$318bcc25577ef9d7$var$TERMINAL_TASK_STATES.includes(state);
const $318bcc25577ef9d7$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $318bcc25577ef9d7$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $318bcc25577ef9d7$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $318bcc25577ef9d7$export$f2b8d80523e7041 = (message)=>$318bcc25577ef9d7$export$75e97486ff2b4c62(message) || $318bcc25577ef9d7$export$d99f52ae2a325014(message);
const $318bcc25577ef9d7$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $318bcc25577ef9d7$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $318bcc25577ef9d7$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $318bcc25577ef9d7$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $318bcc25577ef9d7$export$908578fde1b22b55 = (message)=>$318bcc25577ef9d7$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $318bcc25577ef9d7$export$3db8a80b25c44828 = (message)=>$318bcc25577ef9d7$export$20f0f8aded5b11e5(message) || $318bcc25577ef9d7$export$908578fde1b22b55(message);
const $318bcc25577ef9d7$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $318bcc25577ef9d7$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $318bcc25577ef9d7$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $318bcc25577ef9d7$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';
module.exports["StoreActionLoggableName"] = $318bcc25577ef9d7$export$69799355b7de2229;
module.exports["DEFAULT_CONVERSATION_PAGINATION"] = $318bcc25577ef9d7$export$61e8a5ac076d12b3;
module.exports["isAnswerNowAvailable"] = $318bcc25577ef9d7$export$8ec4190061b584d5;
module.exports["AnswerNowStatusType"] = $318bcc25577ef9d7$export$fe950e85847f6d5d;
module.exports["CHAT_STORE_STATUS"] = $318bcc25577ef9d7$export$817d6b1b984afeb7;
module.exports["isTerminalTaskState"] = $318bcc25577ef9d7$export$e87901ebf76c08a1;
module.exports["isStoreHuman"] = $318bcc25577ef9d7$export$75e97486ff2b4c62;
module.exports["isStoreAssistant"] = $318bcc25577ef9d7$export$d99f52ae2a325014;
module.exports["isStoreError"] = $318bcc25577ef9d7$export$9e2d714e96946d26;
module.exports["isStoreMessage"] = $318bcc25577ef9d7$export$f2b8d80523e7041;
module.exports["isStoreFollowUp"] = $318bcc25577ef9d7$export$7c65a4fb7b6131a1;
module.exports["isStoreUsageHint"] = $318bcc25577ef9d7$export$155f16100a67670d;
module.exports["getActionInvocationStatus"] = $318bcc25577ef9d7$export$3070678f252266e3;

});

parcelRegister("gzMZq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $2a83073b2ae5e0c1$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined,
        isSmartCreationModalOpen: false
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        updateEditorContextIsViewMode: (isViewMode)=>({ setState: setState, getState: getState })=>{
                const { editorContext: editorContext } = getState();
                if (editorContext) setState({
                    editorContext: {
                        ...editorContext,
                        isViewMode: isViewMode
                    }
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const state = getState();
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                // `isSmartCreationModalOpen` covers the window before any staging-area content target
                // exists yet (e.g. a clarifying question asked before content generation starts) —
                // without it, this would incorrectly resolve to 'global' for that window.
                if (state.contentTargets['staging-area'] || state.isSmartCreationModalOpen) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId,
        setIsSmartCreationModalOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isSmartCreationModalOpen: isOpen
                });
            },
        getIsSmartCreationModalOpen: ()=>({ getState: getState })=>getState().isSmartCreationModalOpen
    }
});
const $2a83073b2ae5e0c1$export$53bf948a400e8426 = (0, $kBr4q.createActionsHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9);
const $2a83073b2ae5e0c1$export$9465f65715425f1b = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $2a83073b2ae5e0c1$export$eea520981851a092 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $2a83073b2ae5e0c1$export$c517e9a5e436c401 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $2a83073b2ae5e0c1$export$debe3dc2612d2a8e = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $2a83073b2ae5e0c1$export$376b2a7bf70dad8 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $2a83073b2ae5e0c1$export$6280f21050465fe4 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $2a83073b2ae5e0c1$export$3794ec8d9f571031 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $2a83073b2ae5e0c1$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext, useCurrentPageContext: useCurrentPageContext })=>{
    const actions = $2a83073b2ae5e0c1$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $cozmU.useCallback)(async ({ type: type, contentContext: contentContext, activeTargetId: activeTargetId, source: source, prompt: prompt })=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody({
            type: type,
            id: selectedTargetId,
            source: source,
            prompt: prompt
        });
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                    useFastPath: contentBody.useFastPath,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    mediaFileId: contentBody.mediaFileId,
                    mediaCollection: contentBody.mediaCollection,
                    isViewMode: contentBody.isViewMode,
                    isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData,
                    location: contentBody.location,
                    products: contentBody.products,
                    subProducts: contentBody.subProducts
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getEditorContext = (0, $cozmU.useCallback)(async ({ source: source_0, prompt: prompt_0, contentContext: contentContext_0, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId_0 })=>{
        const isAifcEnabled = (0, $iDrrr.fg)('aifc_create_enabled');
        const shouldProvideContext = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_0,
            source: source_0,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent({
            type: 'page',
            contentContext: contentContext_0,
            activeTargetId: activeTargetId_0,
            source: source_0,
            prompt: prompt_0
        }) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getWhiteboardContext = (0, $cozmU.useCallback)(async ({ source: source_1, contentContext: contentContext_1, isFirstPrompt: isFirstPrompt_0, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_0, activeTargetId: activeTargetId_1 })=>{
        const isAifcEnabled_0 = (0, $iDrrr.fg)('aifc_create_enabled');
        const shouldProvideContext_0 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_1,
            source: source_1,
            isFirstPrompt: isFirstPrompt_0,
            isAifcEnabled: isAifcEnabled_0,
            userPreference: addCurrentPageAsContextUserPreference_0
        });
        if (!shouldProvideContext_0) return undefined;
        return isAifcEnabled_0 ? await fetchContent({
            type: 'whiteboard',
            contentContext: contentContext_1,
            activeTargetId: activeTargetId_1
        }) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $cozmU.useCallback)(async ({ source: source_2, contentContext: contentContext_2, isFirstPrompt: isFirstPrompt_1, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_1, activeTargetId: activeTargetId_2 })=>{
        const isAifcEnabled_1 = (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext_1 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_2,
            source: source_2,
            isFirstPrompt: isFirstPrompt_1,
            isAifcEnabled: isAifcEnabled_1,
            userPreference: addCurrentPageAsContextUserPreference_1
        });
        if (!shouldProvideContext_1) return undefined;
        return isAifcEnabled_1 ? await fetchContent({
            type: 'slide',
            contentContext: contentContext_2,
            activeTargetId: activeTargetId_2
        }) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $cozmU.useCallback)(async ({ source: source_3, contentContext: contentContext_3, isFirstPrompt: isFirstPrompt_2, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_2, activeTargetId: activeTargetId_3 })=>{
        const isAifcEnabled_2 = (0, $iDrrr.fg)('aifc_create_enabled');
        const shouldProvideContext_2 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_3,
            source: source_3,
            isFirstPrompt: isFirstPrompt_2,
            isAifcEnabled: isAifcEnabled_2,
            userPreference: addCurrentPageAsContextUserPreference_2
        });
        if (!shouldProvideContext_2) return undefined;
        return isAifcEnabled_2 ? await fetchContent({
            type: 'database',
            contentContext: contentContext_3,
            activeTargetId: activeTargetId_3
        }) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $cozmU.useCallback)(async ({ contentContext: contentContext_4, activeTargetId: activeTargetId_4 })=>{
        if (!(0, $iDrrr.fg)('platform_avp_aifc_enabled')) return undefined;
        return await fetchContent({
            type: 'dashboard',
            contentContext: contentContext_4,
            activeTargetId: activeTargetId_4
        });
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $cozmU.useCallback)(({ contentContext: contentContext_5, isFirstPrompt: isFirstPrompt_3 })=>{
        if (contentContext_5 === 'staging-area' && !isFirstPrompt_3 && (0, $iDrrr.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext_5)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $cozmU.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    /**
   * Whether the chat was launched about one specific linked thing, rather than about the page the
   * user is on. Several flows do this — the Smart Link toolbar, pinned items, onboarding — and all
   * of them put the target in `aiFeatureContext.projectContext`.
   *
   * Rovo Spaces launches populate `projectContext` too, but with `projectUrl: ''`, because a space
   * has no canonical URL. Those should still offer the current page, hence the non-empty check.
   */ const hasEntityContext = (0, $cozmU.useCallback)(()=>{
        const projectContext = actions.getAIFeatureContext()?.projectContext;
        return typeof projectContext?.projectUrl === 'string' && projectContext.projectUrl !== '';
    }, [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $cozmU.useCallback)((addCurrentPageAsContextUserPreference_3)=>{
        // Drive useCurrentBrowsingContext directly from the chat mode store's
        // `useCurrentPageContext` toggle: when the user has current-page context
        // enabled we treat the current page as usable context, and off otherwise.
        if ((0, $iDrrr.fg)('rovo_browsing_context_from_banner')) {
            // A `true` here tells the backend to use `browser_url`, so a chat launched about a
            // link would answer about the host page instead of the link. `useCurrentPageContext`
            // cannot be used to spot that case: such launches force it on, because the context
            // banner only renders while it is true.
            if (hasEntityContext() && (0, $iDrrr.fg)('rovo_chat_smartlink_entity_context_killswitch')) return false;
            return useCurrentPageContext;
        }
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference_3) return addCurrentPageAsContextUserPreference_3;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference_3 && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea,
        useCurrentPageContext,
        hasEntityContext
    ]);
    const getBrowserContext = (0, $cozmU.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_4, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference_4) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $cozmU.useCallback)(async ()=>{
        const isStagingArea = getIsStagingArea();
        if (!isStagingArea) {
            const jiraCreateContext = actions.getJiraCreateContext();
            if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $2a83073b2ae5e0c1$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
   * If AIFC is not enabled, we default to the user's preference.
   */ if (!isAifcEnabled) return userPreference;
    /**
   * In the staging area, we always want to provide context if the source is the
   * inline editor, from the blank object experience, or if the prompt is not the
   * first in a new conversation.
   */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
     * On real content when AIFC is enabled, we only want to default to true
     * if the source of the content is the inline editing experience. Otherwise,
     * we want to respect the preference chosen by the user.
     */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $2a83073b2ae5e0c1$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $2a83073b2ae5e0c1$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $2a83073b2ae5e0c1$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $2a83073b2ae5e0c1$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $2a83073b2ae5e0c1$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $2a83073b2ae5e0c1$export$3794ec8d9f571031;
module.exports["useChatContextProvider"] = $2a83073b2ae5e0c1$export$904052abb7b98535;

});

parcelRegister("isp1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $2A9fJ = parcelRequire("2A9fJ");

const $2def26aed08f588d$var$fetchProfileData = (0, $dOBRD.default)(async ()=>{
    const data = await (0, $2A9fJ.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email,
        organization: data.extended_profile?.organization
    };
});
const $2def26aed08f588d$export$3c814b55c7cbb1fb = (0, $cozmU.createContext)(null);
const $2def26aed08f588d$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $2def26aed08f588d$export$68afc71177137005 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (preFetchedProfileData)=>{
    const $ = (0, $bDgLe.c)(4);
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    let t0;
    let t1;
    if ($[0] !== preFetchedProfileData || $[1] !== profileContextData) {
        t0 = ()=>{
            if (preFetchedProfileData) setProfileData(preFetchedProfileData);
            else if (profileContextData) setProfileData(profileContextData);
            else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
        };
        t1 = [
            setProfileData,
            profileContextData,
            preFetchedProfileData
        ];
        $[0] = preFetchedProfileData;
        $[1] = profileContextData;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return profileData;
} : (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    (0, $cozmU.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $2def26aed08f588d$export$68afc71177137005;

});

parcelRegister("2A9fJ", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $baf5ee02956fd5a8$export$3e32638432616b6 = async ()=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $baf5ee02956fd5a8$export$3e32638432616b6;

});

parcelRegister("8akfd", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9cc5462c799c5c3$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    promptAppConnectorSources: [],
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $d9cc5462c799c5c3$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setPromptAppConnectorSources: (promptAppConnectorSources)=>({ setState: setState })=>{
            setState({
                promptAppConnectorSources: promptAppConnectorSources
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                promptAppConnectorSources: [],
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $d9cc5462c799c5c3$var$store = (0, $8s9DV.createStore)({
    initialState: $d9cc5462c799c5c3$var$initialState,
    actions: $d9cc5462c799c5c3$var$actions
});
const $d9cc5462c799c5c3$export$a2795b51ce92008f = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $d9cc5462c799c5c3$export$916334da9df8d04 = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$8f9a13b17bec42d5 = (0, $kBr4q.createActionsHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$5a57f796673aabea = (0, $kBr4q.createStateHook)($d9cc5462c799c5c3$var$store);
module.exports["useMessageIdSelectedForPreview"] = $d9cc5462c799c5c3$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $d9cc5462c799c5c3$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $d9cc5462c799c5c3$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $d9cc5462c799c5c3$export$5a57f796673aabea;

});

parcelRegister("lTU4O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $2TZSo = parcelRequire("2TZSo");


var $isp1U = parcelRequire("isp1U");

const $1dccc6823e49008a$export$205c270e325a7524 = (aaid)=>{
    const preferences = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem((0, $2TZSo.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $1dccc6823e49008a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
            (0, $cXtTj.default).initializeCalled() && (0, $cXtTj.default).checkGate('ai_mate_show_store_messages'),
            // default is undefined because we do not want migration to be started until we read from local storage value
            storeUserMessageMigratedToBE: undefined,
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $1dccc6823e49008a$var$useStore = (0, $kBr4q.createHook)($1dccc6823e49008a$var$store);
const $1dccc6823e49008a$export$b6472e0d8983f5f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(27);
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [t0, t1] = $1dccc6823e49008a$var$useStore();
    const { preferences: preferences, firstLoad: firstLoad } = t0;
    const { updatePreferences: storeUpdatePreferences } = t1;
    let t2;
    if ($[0] !== aaid || $[1] !== preferences || $[2] !== storeUpdatePreferences) {
        t2 = (data)=>{
            if (!aaid) return;
            storeUpdatePreferences(data);
            localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                [aaid]: {
                    ...preferences,
                    ...data
                }
            }));
        };
        $[0] = aaid;
        $[1] = preferences;
        $[2] = storeUpdatePreferences;
        $[3] = t2;
    } else t2 = $[3];
    const updatePreferences = t2;
    let t3;
    if ($[4] !== updatePreferences) {
        t3 = (storeUserMessages)=>{
            updatePreferences({
                storeUserMessages: storeUserMessages
            });
        };
        $[4] = updatePreferences;
        $[5] = t3;
    } else t3 = $[5];
    const setStoreUserMessages = t3;
    let t4;
    if ($[6] !== updatePreferences) {
        t4 = (useEditorContext)=>{
            updatePreferences({
                useEditorContext: useEditorContext
            });
        };
        $[6] = updatePreferences;
        $[7] = t4;
    } else t4 = $[7];
    const setUseEditorContext = t4;
    let t5;
    if ($[8] !== aaid || $[9] !== updatePreferences) {
        t5 = ()=>{
            if (!aaid) return;
            updatePreferences({
                storeUserMessageMigratedToBE: true
            });
        };
        $[8] = aaid;
        $[9] = updatePreferences;
        $[10] = t5;
    } else t5 = $[10];
    const markStoreUserMessageMigratedToBE = t5;
    let t6;
    if ($[11] !== updatePreferences) {
        t6 = (hasSeenFeedbackOptInPrompt)=>{
            updatePreferences({
                hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
            });
        };
        $[11] = updatePreferences;
        $[12] = t6;
    } else t6 = $[12];
    const setHasSeenFeedbackOptInPrompt = t6;
    let t7;
    let t8;
    if ($[13] !== aaid || $[14] !== firstLoad || $[15] !== updatePreferences) {
        t7 = ()=>{
            if (aaid && firstLoad) {
                const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
                if (preferences_0) updatePreferences({
                    ...preferences_0,
                    ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                        storeUserMessageMigratedToBE: false
                    }
                });
            }
        };
        t8 = [
            aaid,
            firstLoad,
            updatePreferences
        ];
        $[13] = aaid;
        $[14] = firstLoad;
        $[15] = updatePreferences;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = aaid ? preferences.storeUserMessageMigratedToBE : undefined;
    let t10;
    if ($[18] !== preferences || $[19] !== t9) {
        t10 = {
            ...preferences,
            storeUserMessageMigratedToBE: t9
        };
        $[18] = preferences;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== markStoreUserMessageMigratedToBE || $[22] !== setHasSeenFeedbackOptInPrompt || $[23] !== setStoreUserMessages || $[24] !== setUseEditorContext || $[25] !== t10) {
        t11 = {
            preferences: t10,
            setStoreUserMessages: setStoreUserMessages,
            setUseEditorContext: setUseEditorContext,
            setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
            markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
        };
        $[21] = markStoreUserMessageMigratedToBE;
        $[22] = setHasSeenFeedbackOptInPrompt;
        $[23] = setStoreUserMessages;
        $[24] = setUseEditorContext;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ()=>{
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $1dccc6823e49008a$var$useStore();
    const updatePreferences = (0, $cozmU.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $cozmU.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const markStoreUserMessageMigratedToBE = (0, $cozmU.useCallback)(()=>{
        if (!aaid) return;
        updatePreferences({
            storeUserMessageMigratedToBE: true
        });
    }, [
        updatePreferences,
        aaid
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $cozmU.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
            if (preferences_0) updatePreferences({
                ...preferences_0,
                ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                    storeUserMessageMigratedToBE: false
                }
            });
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: {
            ...preferences,
            storeUserMessageMigratedToBE: aaid ? preferences.storeUserMessageMigratedToBE : undefined
        },
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
        markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
    };
};
module.exports["useUserPreferences"] = $1dccc6823e49008a$export$b6472e0d8983f5f5;

});

parcelRegister("2TZSo", function(module, exports) {
const $9ca4df0845d80c9e$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $9ca4df0845d80c9e$export$97d0beb2ccc70a4d;

});

parcelRegister("bGNkz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $4m5jb = parcelRequire("4m5jb");

const $af081181a641afaf$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $af081181a641afaf$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    // If productionized will look to move this logic into conversation-assistant-onboarding
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchInteractionSource: undefined,
    emptyChatLaunchInvokedFrom: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    emptyChatLaunchActive: false,
    selectedSpace: undefined,
    selectedPinnedItem: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
};
const $af081181a641afaf$var$store = (0, $8s9DV.createStore)({
    name: 'uiStore',
    initialState: $af081181a641afaf$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$af081181a641afaf$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchInteractionSource: payload.interactionSource,
                    emptyChatLaunchInvokedFrom: payload.invokedFrom,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1,
                    emptyChatLaunchActive: true
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined,
                    emptyChatLaunchActive: false
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setSelectedPinnedItem: (item)=>({ setState: setState })=>{
                setState({
                    selectedPinnedItem: item
                });
            },
        clearSelectedPinnedItem: ()=>({ setState: setState })=>{
                setState({
                    selectedPinnedItem: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $af081181a641afaf$var$useStore = (0, $kBr4q.createHook)($af081181a641afaf$var$store);
const $af081181a641afaf$export$13a6c73a57f1d6a6 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            interactionSource: state.emptyChatLaunchInteractionSource,
            invokedFrom: state.emptyChatLaunchInvokedFrom,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId,
            isEmptyChatLaunchActive: state.emptyChatLaunchActive
        })
});
const $af081181a641afaf$export$81a40d215ef1c1de = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $af081181a641afaf$export$5f449dc44751be0a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$5c79552389bcd8c6 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedPinnedItem: state.selectedPinnedItem
        })
});
const $af081181a641afaf$export$78ce19c6cc1eeb16 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$1bd034c20714e002 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu
        })
});
const $af081181a641afaf$export$762e860bb8461339 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            mounted: state.mounted
        })
});
const $af081181a641afaf$export$d3b1853c9cb98102 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen
        })
});
const $af081181a641afaf$export$f4c4584d8302c703 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            conversationHeader: state.conversationHeader
        })
});
const $af081181a641afaf$export$1e3791eaae70097a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$357ffd05205e0c5d = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$9e369d8095358b77 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$8f5523dfac6ff4fa = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$5b2ba9b8ea3b0771 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(29);
    const [t0, t1] = $af081181a641afaf$var$useStore();
    const { activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth } = t0;
    const { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setSelectedPinnedItem: setSelectedPinnedItem, clearSelectedPinnedItem: clearSelectedPinnedItem, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth } = t1;
    const t2 = conversationHeader ?? null;
    let t3;
    if ($[0] !== activeMenu || $[1] !== activeTabId || $[2] !== clearSelectedPinnedItem || $[3] !== clearSelectedSpace || $[4] !== clearSmartLink3PPostAuth || $[5] !== isAgentSelectorMenuOpen || $[6] !== isChatOnboardingMiniModalOpen || $[7] !== lastTabConversationId || $[8] !== mounted || $[9] !== previousTabId || $[10] !== reset || $[11] !== selectedPinnedItem || $[12] !== selectedSpace || $[13] !== setActiveMenu || $[14] !== setActiveTabId || $[15] !== setConversationHeader || $[16] !== setIsAgentSelectorMenuOpen || $[17] !== setIsChatOnboardingMiniModalOpen || $[18] !== setLastTabConversationId || $[19] !== setMounted || $[20] !== setPreviousTabId || $[21] !== setSelectedPinnedItem || $[22] !== setSelectedSpace || $[23] !== setSmartLink3PPostAuth || $[24] !== setStreamingStatus || $[25] !== smartLink3PPostAuth || $[26] !== streaming || $[27] !== t2) {
        t3 = {
            activeMenu: activeMenu,
            mounted: mounted,
            streaming: streaming,
            isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
            conversationHeader: t2,
            selectedSpace: selectedSpace,
            selectedPinnedItem: selectedPinnedItem,
            reset: reset,
            setActiveMenu: setActiveMenu,
            setMounted: setMounted,
            setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
            setStreamingStatus: setStreamingStatus,
            isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
            setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
            setConversationHeader: setConversationHeader,
            setSelectedSpace: setSelectedSpace,
            clearSelectedSpace: clearSelectedSpace,
            setSelectedPinnedItem: setSelectedPinnedItem,
            clearSelectedPinnedItem: clearSelectedPinnedItem,
            activeTabId: activeTabId,
            previousTabId: previousTabId,
            lastTabConversationId: lastTabConversationId,
            smartLink3PPostAuth: smartLink3PPostAuth,
            setSmartLink3PPostAuth: setSmartLink3PPostAuth,
            clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
            setActiveTabId: setActiveTabId,
            setPreviousTabId: setPreviousTabId,
            setLastTabConversationId: setLastTabConversationId
        };
        $[0] = activeMenu;
        $[1] = activeTabId;
        $[2] = clearSelectedPinnedItem;
        $[3] = clearSelectedSpace;
        $[4] = clearSmartLink3PPostAuth;
        $[5] = isAgentSelectorMenuOpen;
        $[6] = isChatOnboardingMiniModalOpen;
        $[7] = lastTabConversationId;
        $[8] = mounted;
        $[9] = previousTabId;
        $[10] = reset;
        $[11] = selectedPinnedItem;
        $[12] = selectedSpace;
        $[13] = setActiveMenu;
        $[14] = setActiveTabId;
        $[15] = setConversationHeader;
        $[16] = setIsAgentSelectorMenuOpen;
        $[17] = setIsChatOnboardingMiniModalOpen;
        $[18] = setLastTabConversationId;
        $[19] = setMounted;
        $[20] = setPreviousTabId;
        $[21] = setSelectedPinnedItem;
        $[22] = setSelectedSpace;
        $[23] = setSmartLink3PPostAuth;
        $[24] = setStreamingStatus;
        $[25] = smartLink3PPostAuth;
        $[26] = streaming;
        $[27] = t2;
        $[28] = t3;
    } else t3 = $[28];
    return t3;
} : ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setSelectedPinnedItem: setSelectedPinnedItem, clearSelectedPinnedItem: clearSelectedPinnedItem, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $af081181a641afaf$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        selectedPinnedItem: selectedPinnedItem,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        setSelectedPinnedItem: setSelectedPinnedItem,
        clearSelectedPinnedItem: clearSelectedPinnedItem,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $af081181a641afaf$export$cd2fc25ddd3752d4 = (0, $kBr4q.createActionsHook)($af081181a641afaf$var$store);
const $af081181a641afaf$var$isRenderStabilizationEnabled = ()=>(0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false);
const $af081181a641afaf$export$f0adc1af32e51b = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>$af081181a641afaf$var$isRenderStabilizationEnabled() ? null : state
});
module.exports["useEmptyChatLaunchSelector"] = $af081181a641afaf$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $af081181a641afaf$export$81a40d215ef1c1de;
module.exports["useSelectedSpaceSelector"] = $af081181a641afaf$export$5f449dc44751be0a;
module.exports["useSelectedPinnedItemSelector"] = $af081181a641afaf$export$5c79552389bcd8c6;
module.exports["useChatHeaderUISelector"] = $af081181a641afaf$export$78ce19c6cc1eeb16;
module.exports["useActiveMenuSelector"] = $af081181a641afaf$export$1bd034c20714e002;
module.exports["useConversationHeaderSelector"] = $af081181a641afaf$export$f4c4584d8302c703;
module.exports["useChatInputUISelector"] = $af081181a641afaf$export$357ffd05205e0c5d;
module.exports["useSideNavUISelector"] = $af081181a641afaf$export$9e369d8095358b77;
module.exports["useRootUISelector"] = $af081181a641afaf$export$8f5523dfac6ff4fa;
module.exports["useUIStore"] = $af081181a641afaf$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $af081181a641afaf$export$cd2fc25ddd3752d4;
module.exports["useUIStoreSubscription"] = $af081181a641afaf$export$f0adc1af32e51b;

});

parcelRegister("8VrqA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kMkDS = parcelRequire("kMkDS");


var $cGJsZ = parcelRequire("cGJsZ");

const $e14a5679e33f0f1b$var$state = (0, $8s9DV.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder
                });
            }
    }
});
const $e14a5679e33f0f1b$export$e638cf26ae51308d = (0, $kBr4q.createHook)($e14a5679e33f0f1b$var$state);
const $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $kMkDS.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $e14a5679e33f0f1b$export$21b2d5ca0689f678 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const [t0, t1] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder } = t0;
    const { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== setHighlightActionsEditorPlaceholder) {
        t2 = (prompt, options)=>{
            const placeholderData = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
            setHighlightActionsEditorPlaceholder(placeholderData);
        };
        $[0] = formatMessage;
        $[1] = setHighlightActionsEditorPlaceholder;
        $[2] = t2;
    } else t2 = $[2];
    const insertHighlightActionsEditorPlaceholder = t2;
    let t3;
    if ($[3] !== setHighlightActionsEditorPlaceholder) {
        t3 = ()=>{
            setHighlightActionsEditorPlaceholder(null);
        };
        $[3] = setHighlightActionsEditorPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    const clearHighlightActionsEditorPlaceholder = t3;
    let t4;
    if ($[5] !== clearHighlightActionsEditorPlaceholder || $[6] !== highlightActionsEditorPlaceholder || $[7] !== insertHighlightActionsEditorPlaceholder) {
        t4 = {
            highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
            insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
            clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
        };
        $[5] = clearHighlightActionsEditorPlaceholder;
        $[6] = highlightActionsEditorPlaceholder;
        $[7] = insertHighlightActionsEditorPlaceholder;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const insertHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)((prompt, options)=>{
        // When `skipPlaceholderPrompt` is set, seed the editor with the prompt
        // exactly as provided instead of appending the highlight-action
        // "Ask a question about this." trailer. This lets non-highlight callers
        // (e.g. a prompt supplied via URL param) pre-fill the input as an
        // editable draft without injecting extra text.
        const placeholderData = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
        setHighlightActionsEditorPlaceholder(placeholderData);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $e14a5679e33f0f1b$export$21b2d5ca0689f678;

});

parcelRegister("kMkDS", function(module, exports) {
const $00de4dd959d7802e$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $00de4dd959d7802e$export$f00236a854eaa848;

});

parcelRegister("cGJsZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $12b4cc67f5ec0d6d$var$message = (0, $kSwu1.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $12b4cc67f5ec0d6d$export$2e2bcd8739ae039 = $12b4cc67f5ec0d6d$var$message;
module.exports["default"] = $12b4cc67f5ec0d6d$export$2e2bcd8739ae039;

});

parcelRegister("12shJ", function(module, exports) {
/** Sweet-state hooks for the spaces store. */ 
var $kBr4q = parcelRequire("kBr4q");


var $9k1Oq = parcelRequire("9k1Oq");

const $05a1a54631ae3038$export$d71442297730a984 = (0, $kBr4q.createHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$c0aa94e8be00c505 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$995700e1beba27e2 = (0, $kBr4q.createActionsHook)((0, $9k1Oq.spaceStore));
const $05a1a54631ae3038$export$4a0158bb8391bcb = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.spaces
});
const $05a1a54631ae3038$export$40840f9e6173b9a6 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.isListLoading
});
const $05a1a54631ae3038$export$98766e9d1f093889 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.listError
});
const $05a1a54631ae3038$export$3939f7e557578ce8 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.hasFetchedList
});
const $05a1a54631ae3038$export$be7cd4af1e0d2a9f = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state)=>state.conversationIds
});
const $05a1a54631ae3038$export$d021bec3570c33bf = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceDetails.get(spaceId)
});
const $05a1a54631ae3038$export$a3814fef5b67c2b2 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.detailLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$70f1b26c4cbf89d = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.detailErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$2cd2cb4a55b2965d = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceConversations.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$ed4ca1f1560fcd15 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.conversationsLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$24e28f766ba9071e = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.conversationsErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$c2f6acacddd0717f = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.spaceMemories.get(spaceId) ?? []
});
const $05a1a54631ae3038$export$fa3b9f71961b2b87 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.memoriesLoading.get(spaceId) ?? false
});
const $05a1a54631ae3038$export$70ff4bf3a8bd3e16 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.memoriesErrors.get(spaceId) ?? null
});
const $05a1a54631ae3038$export$9a7c6df39e4e5fd4 = (0, $kBr4q.createStateHook)((0, $9k1Oq.spaceStore), {
    selector: (state, spaceId)=>state.smartContextLinkRecommendations.get(spaceId) ?? []
});
module.exports["useSpaceStoreActions"] = $05a1a54631ae3038$export$995700e1beba27e2;
module.exports["useSpaces"] = $05a1a54631ae3038$export$4a0158bb8391bcb;
module.exports["useSpacesLoading"] = $05a1a54631ae3038$export$40840f9e6173b9a6;
module.exports["useSpacesError"] = $05a1a54631ae3038$export$98766e9d1f093889;
module.exports["useHasFetchedSpaces"] = $05a1a54631ae3038$export$3939f7e557578ce8;
module.exports["useSpaceConversationIds"] = $05a1a54631ae3038$export$be7cd4af1e0d2a9f;
module.exports["useSpaceById"] = $05a1a54631ae3038$export$d021bec3570c33bf;
module.exports["useSpaceDetailLoading"] = $05a1a54631ae3038$export$a3814fef5b67c2b2;
module.exports["useSpaceDetailError"] = $05a1a54631ae3038$export$70f1b26c4cbf89d;
module.exports["useSpaceConversationsPage"] = $05a1a54631ae3038$export$2cd2cb4a55b2965d;
module.exports["useSpaceConversationsLoading"] = $05a1a54631ae3038$export$ed4ca1f1560fcd15;
module.exports["useSpaceConversationsError"] = $05a1a54631ae3038$export$24e28f766ba9071e;
module.exports["useSpaceMemories"] = $05a1a54631ae3038$export$c2f6acacddd0717f;
module.exports["useSpaceMemoriesLoading"] = $05a1a54631ae3038$export$fa3b9f71961b2b87;
module.exports["useSpaceMemoriesError"] = $05a1a54631ae3038$export$70ff4bf3a8bd3e16;
module.exports["useSmartContextLinkRecommendations"] = $05a1a54631ae3038$export$9a7c6df39e4e5fd4;

});

parcelRegister("9k1Oq", function(module, exports) {
/**
 * react-sweet-state singleton store for Rovo Spaces. Mutating actions keep the
 * list and detail slices in sync so all consumers see a consistent view.
 */ 
var $8s9DV = parcelRequire("8s9DV");


var $73iDe = parcelRequire("73iDe");


var $1RoaH = parcelRequire("1RoaH");


var $6OvwE = parcelRequire("6OvwE");


var $2Z9WR = parcelRequire("2Z9WR");


var $10p5Q = parcelRequire("10p5Q");


var $9RoLt = parcelRequire("9RoLt");


var $2IYpC = parcelRequire("2IYpC");

// --- Initial state ---
/** Derives a stable flat deduplicated conversationIds array from a spaces list. */ const $c7f6d0062ae88238$var$computeConversationIds = (spaces)=>{
    const ids = new Set();
    for (const space of spaces){
        if (!space.sources) continue;
        for (const source of space.sources){
            if (!source.conversationIds) continue;
            for (const id of source.conversationIds)ids.add(id);
        }
    }
    return Array.from(ids);
};
/** Fresh initial state on every call so `reset()` doesn't share Set/Map refs. */ const $c7f6d0062ae88238$var$makeInitialState = ()=>({
        spaces: [],
        conversationIds: [],
        isListLoading: false,
        listError: null,
        hasFetchedList: false,
        deletedIds: new Set(),
        pendingAdds: new Map(),
        lastFetchedListParams: null,
        spaceDetails: new Map(),
        detailLoading: new Map(),
        detailErrors: new Map(),
        spaceConversations: new Map(),
        conversationsLoading: new Map(),
        conversationsErrors: new Map(),
        spaceMemories: new Map(),
        memoriesLoading: new Map(),
        memoriesErrors: new Map(),
        smartContextLinkRecommendations: new Map()
    });
/** Project a {@link SpaceResponse} down to the lighter {@link Space} list shape. */ const $c7f6d0062ae88238$var$detailToListShape = (response)=>({
        name: response.name,
        emoji: response.emoji ?? null,
        description: response.description ?? null,
        owner: response.owner,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt
    });
/** Build a `Space` from a `CreateSpaceResponse`, defaulting fields not yet present. */ const $c7f6d0062ae88238$var$createResponseToSpace = (response, emojiId)=>({
        id: response.id,
        name: response.name,
        owner: response.owner,
        description: response.description ?? null,
        emoji: emojiId ?? null,
        threadId: null,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt,
        conversationPage: null
    });
/** Immutable Map setter — returns a new Map so sweet-state equality checks fire. */ const $c7f6d0062ae88238$var$mapSet = (map, key, value)=>{
    const next = new Map(map);
    next.set(key, value);
    return next;
};
const $c7f6d0062ae88238$var$mapDelete = (map, key)=>{
    if (!map.has(key)) return map;
    const next = new Map(map);
    next.delete(key);
    return next;
};
const $c7f6d0062ae88238$var$replaceOrAppend = (arr, item, getKey)=>{
    const key = getKey(item);
    const idx = arr.findIndex((it)=>getKey(it) === key);
    if (idx < 0) return [
        ...arr,
        item
    ];
    const next = arr.slice();
    next[idx] = item;
    return next;
};
// --- Actions ---
const $c7f6d0062ae88238$var$actions = {
    /** Test-only — restores the store to its initial empty state. */ reset: ()=>({ setState: setState })=>{
            setState($c7f6d0062ae88238$var$makeInitialState());
        },
    /**
   * Merge spaces into the store (applies tombstones, re-injects pending adds).
   * `{ isLoading: true }` = loading snapshot; `{ error }` = record fetch failure.
   */ setSpaces: (nextSpaces, { isLoading: nextIsLoading = false, error: nextError = null } = {})=>({ getState: getState, setState: setState })=>{
            const { deletedIds: deletedIds, pendingAdds: pendingAdds, hasFetchedList: hasFetchedList } = getState();
            // 1. Drop any rows that have been optimistically deleted client-side.
            const withoutDeleted = deletedIds.size === 0 ? nextSpaces : nextSpaces.filter((s)=>!deletedIds.has(s.id));
            // 2. Reconcile pending adds. On a real server response, drop pending
            //    entries that the server now knows about; on a loading snapshot,
            //    leave them untouched.
            let merged = withoutDeleted;
            let nextPendingAdds = pendingAdds;
            if (pendingAdds.size > 0) {
                const serverIds = new Set(withoutDeleted.map((s)=>s.id));
                const stillPending = [];
                const isServerResponse = !nextIsLoading && nextError === null;
                if (isServerResponse) nextPendingAdds = new Map(pendingAdds);
                pendingAdds.forEach((space, id)=>{
                    if (serverIds.has(id)) {
                        if (isServerResponse) nextPendingAdds.delete(id);
                    } else stillPending.push(space);
                });
                if (stillPending.length > 0) merged = [
                    ...withoutDeleted,
                    ...stillPending
                ];
            }
            setState({
                spaces: merged,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(merged),
                isListLoading: nextIsLoading,
                listError: nextError,
                hasFetchedList: !nextIsLoading && nextError === null ? true : hasFetchedList,
                pendingAdds: nextPendingAdds
            });
        },
    addSpace: (response, emojiId)=>({ getState: getState, setState: setState })=>{
            const space = $c7f6d0062ae88238$var$createResponseToSpace(response, emojiId);
            const { spaces: spaces, deletedIds: deletedIds, pendingAdds: pendingAdds } = getState();
            // If a space with this id was previously tombstoned, clear it so the
            // new space (potentially reusing an id) is allowed to surface again.
            const nextDeletedIds = deletedIds.has(response.id) ? new Set(Array.from(deletedIds).filter((id)=>id !== response.id)) : deletedIds;
            // Idempotent guard: if a space with this id is already in the list
            // (e.g. because another `addSpace` call has already run for the same
            // `CreateSpaceModal.onCreated` event, or a server list-fetch landed
            // before us), DO NOT append a duplicate row. We still want to
            // (a) clear any tombstone (handled above) and
            // (b) keep the entry in `pendingAdds` so a subsequent `setSpaces`
            //     loading-snapshot can't drop it before the server confirms it.
            if (spaces.some((s)=>s.id === response.id)) {
                if (deletedIds.has(response.id) || !pendingAdds.has(response.id)) setState({
                    deletedIds: nextDeletedIds,
                    pendingAdds: $c7f6d0062ae88238$var$mapSet(pendingAdds, response.id, space)
                });
                return;
            }
            const nextPendingAdds = $c7f6d0062ae88238$var$mapSet(pendingAdds, response.id, space);
            const nextSpacesAdd = [
                ...spaces,
                space
            ];
            setState({
                spaces: nextSpacesAdd,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesAdd),
                deletedIds: nextDeletedIds,
                pendingAdds: nextPendingAdds
            });
        },
    removeSpace: (spaceId)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, deletedIds: deletedIds, pendingAdds: pendingAdds } = getState();
            const nextDeletedIds = new Set(deletedIds);
            nextDeletedIds.add(spaceId);
            const nextPendingAdds = $c7f6d0062ae88238$var$mapDelete(pendingAdds, spaceId);
            const nextSpacesRemove = spaces.filter((s)=>s.id !== spaceId);
            setState({
                spaces: nextSpacesRemove,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesRemove),
                deletedIds: nextDeletedIds,
                pendingAdds: nextPendingAdds
            });
        },
    restoreSpace: (space)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, deletedIds: deletedIds } = getState();
            const nextDeletedIds = new Set(deletedIds);
            nextDeletedIds.delete(space.id);
            const nextSpacesRestore = spaces.some((s)=>s.id === space.id) ? spaces : [
                ...spaces,
                space
            ];
            setState({
                spaces: nextSpacesRestore,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesRestore),
                deletedIds: nextDeletedIds
            });
        },
    patchSpace: (spaceId, patch)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            // Mirror the patch into the detail slice if a detail entry exists, so
            // any open ManageSpaceModal stays consistent with the side-nav list.
            let nextDetails = spaceDetails;
            const existing = spaceDetails.get(spaceId);
            if (existing) {
                // Only mirror fields that exist on the detail shape. The list-only
                // `sources` field intentionally has a different element type
                // (`SpaceSource` vs `SpaceSourceResponse`) and is owned by the
                // dedicated `upsertSpaceSource` / `removeSpaceSource` actions.
                const { sources: _ignoredSources, conversationPage: _ignoredCP, threadId: _ignoredTid, ...detailPatch } = patch;
                nextDetails = $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                    ...existing,
                    ...detailPatch
                });
            }
            const nextSpacesPatch = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    ...patch
                } : s);
            setState({
                spaces: nextSpacesPatch,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpacesPatch),
                spaceDetails: nextDetails
            });
        },
    /**
   * Fetches the list of spaces from the BE and merges into the store. Marks
   * `isListLoading=true` *without* clearing the existing list so any
   * optimistic state is preserved while the request is in flight.
   *
   * Idempotent: if the store has already fetched for the same params, this
   * is a no-op unless `force=true`.
   */ fetchSpaces: (params)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { cloudId: cloudId, product: product, experienceId: experienceId, force: force = false } = params;
            const key = `${cloudId}|${product}|${experienceId}`;
            const { hasFetchedList: hasFetchedList, lastFetchedListParams: lastFetchedListParams, spaces: spaces } = getState();
            if (!force && hasFetchedList && lastFetchedListParams === key) return;
            // Loading snapshot — keep current spaces visible while fetching.
            dispatch($c7f6d0062ae88238$var$actions.setSpaces(spaces, {
                isLoading: true
            }));
            try {
                const response = await (0, $9RoLt.listSpacesFetchAction)({
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
                dispatch($c7f6d0062ae88238$var$actions.setSpaces(response.data));
                setState({
                    lastFetchedListParams: key
                });
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaces(getState().spaces, {
                    error: error
                }));
            }
        },
    setSpaceDetail: (spaceId, response)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails, detailLoading: detailLoading, detailErrors: detailErrors } = getState();
            setState({
                spaceDetails: $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, response),
                detailLoading: $c7f6d0062ae88238$var$mapSet(detailLoading, spaceId, false),
                detailErrors: $c7f6d0062ae88238$var$mapSet(detailErrors, spaceId, null),
                // Keep list-shape in sync if this space is in the list.
                spaces: spaces.some((s)=>s.id === spaceId) ? spaces.map((s)=>s.id === spaceId ? {
                        ...s,
                        ...$c7f6d0062ae88238$var$detailToListShape(response)
                    } : s) : spaces
            });
        },
    setSpaceDetailLoading: (spaceId, isLoading)=>({ getState: getState, setState: setState })=>{
            setState({
                detailLoading: $c7f6d0062ae88238$var$mapSet(getState().detailLoading, spaceId, isLoading)
            });
        },
    setSpaceDetailError: (spaceId, error)=>({ getState: getState, setState: setState })=>{
            setState({
                detailErrors: $c7f6d0062ae88238$var$mapSet(getState().detailErrors, spaceId, error),
                detailLoading: $c7f6d0062ae88238$var$mapSet(getState().detailLoading, spaceId, false)
            });
        },
    /**
   * Fetches a single space by id and populates the detail slice. Always
   * fetches when called (consumers wanting cache-only reads should use
   * `useSpaceById`).
   */ fetchSpace: (params)=>async ({ dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailLoading(spaceId, true));
            dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailError(spaceId, null));
            try {
                const response = await (0, $6OvwE.getSpaceFetchAction)(params);
                dispatch($c7f6d0062ae88238$var$actions.setSpaceDetail(spaceId, response));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceDetailError(spaceId, error));
            }
        },
    /**
   * Performs a PUT against the spaces API and, on success, patches both the
   * list and detail slices so all consumers see the change immediately.
   */ updateSpace: (params)=>async ({ dispatch: dispatch })=>{
            const response = await (0, $2IYpC.updateSpaceFetchAction)(params);
            // Patch both slices via patchSpace which knows to update both.
            dispatch($c7f6d0062ae88238$var$actions.patchSpace(params.spaceId, {
                name: response.name,
                emoji: response.emoji ?? null,
                description: response.description ?? null,
                updatedAt: response.updatedAt
            }));
            return response;
        },
    /**
   * Patches a source into the detail slice's `sources` array (and the list
   * slice's `sources` array if present). Used by `addSpaceSource` after a
   * successful POST to keep the open ManageSpaceModal in sync.
   */ upsertSpaceSource: (spaceId, source)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            const detail = spaceDetails.get(spaceId);
            const nextDetails = detail !== undefined ? $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                ...detail,
                sources: $c7f6d0062ae88238$var$replaceOrAppend(detail.sources ?? [], source, (s)=>s.id)
            }) : spaceDetails;
            const nextSpaces = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    sources: $c7f6d0062ae88238$var$replaceOrAppend(s.sources ?? [], {
                        id: source.id,
                        ari: source.ari,
                        url: source.url,
                        sourceType: source.sourceType,
                        name: source.name ?? null
                    }, (it)=>it.id)
                } : s);
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: nextDetails
            });
        },
    removeSpaceSource: (spaceId, sourceId)=>({ getState: getState, setState: setState })=>{
            const { spaces: spaces, spaceDetails: spaceDetails } = getState();
            const detail = spaceDetails.get(spaceId);
            const nextDetails = detail !== undefined ? $c7f6d0062ae88238$var$mapSet(spaceDetails, spaceId, {
                ...detail,
                sources: (detail.sources ?? []).filter((s)=>s.id !== sourceId)
            }) : spaceDetails;
            const nextSpaces = spaces.map((s)=>s.id === spaceId ? {
                    ...s,
                    sources: (s.sources ?? []).filter((it)=>it.id !== sourceId)
                } : s);
            setState({
                spaces: nextSpaces,
                conversationIds: $c7f6d0062ae88238$var$computeConversationIds(nextSpaces),
                spaceDetails: nextDetails
            });
        },
    setSpaceConversations: (spaceId, page, isLoading, error)=>({ getState: getState, setState: setState })=>{
            const { spaceConversations: spaceConversations, conversationsLoading: conversationsLoading, conversationsErrors: conversationsErrors } = getState();
            setState({
                spaceConversations: page !== null ? $c7f6d0062ae88238$var$mapSet(spaceConversations, spaceId, page) : spaceConversations,
                conversationsLoading: $c7f6d0062ae88238$var$mapSet(conversationsLoading, spaceId, isLoading),
                conversationsErrors: $c7f6d0062ae88238$var$mapSet(conversationsErrors, spaceId, error)
            });
        },
    removeConversationFromSpaceConversations: (conversationIds)=>({ getState: getState, setState: setState })=>{
            if (conversationIds.length === 0) return;
            const idsToRemove = new Set(conversationIds);
            const { spaceConversations: spaceConversations } = getState();
            let nextSpaceConversations = spaceConversations;
            spaceConversations.forEach((page, spaceId)=>{
                const nextConversations = page.conversations.filter((conversation)=>!idsToRemove.has(conversation.id) && !(conversation.backendConversationId && idsToRemove.has(conversation.backendConversationId)));
                if (nextConversations.length !== page.conversations.length) nextSpaceConversations = $c7f6d0062ae88238$var$mapSet(nextSpaceConversations, spaceId, {
                    ...page,
                    conversations: nextConversations,
                    totalCount: Math.max(0, page.totalCount - (page.conversations.length - nextConversations.length))
                });
            });
            if (nextSpaceConversations !== spaceConversations) setState({
                spaceConversations: nextSpaceConversations
            });
        },
    fetchSpaceConversations: (params)=>async ({ dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, null, true, null));
            try {
                const response = await (0, $2Z9WR.getSpaceConversationsFetchAction)(params);
                dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, response, false, null));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceConversations(spaceId, null, false, error));
            }
        },
    /** Internal setter — drives loading/error state and populates the memory list. */ setSpaceMemories: (spaceId, items, isLoading, error)=>({ getState: getState, setState: setState })=>{
            const { spaceMemories: spaceMemories, memoriesLoading: memoriesLoading, memoriesErrors: memoriesErrors } = getState();
            setState({
                spaceMemories: items !== null ? $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, items) : spaceMemories,
                memoriesLoading: $c7f6d0062ae88238$var$mapSet(memoriesLoading, spaceId, isLoading),
                memoriesErrors: $c7f6d0062ae88238$var$mapSet(memoriesErrors, spaceId, error)
            });
        },
    /**
   * Lazily fetches the memory list for a space from GET /spaces/{spaceId}/memory.
   * Only fires a network request the first time it's called for a given spaceId
   * (or if a previous fetch errored).
   */ fetchSpaceMemories: (params)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { spaceId: spaceId } = params;
            const { memoriesLoading: memoriesLoading, spaceMemories: spaceMemories } = getState();
            // Skip if already loading or already fetched successfully.
            if (memoriesLoading.get(spaceId) || spaceMemories.has(spaceId)) return;
            dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, null, true, null));
            try {
                const response = await (0, $10p5Q.getSpaceMemoryFetchAction)(params);
                const items = response.items.map((item)=>({
                        id: item.id,
                        text: item.content
                    }));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, items, false, null));
            } catch (err) {
                const error = err instanceof Error ? err : new Error(String(err));
                dispatch($c7f6d0062ae88238$var$actions.setSpaceMemories(spaceId, null, false, error));
            }
        },
    /**
   * POSTs a new memory item and optimistically inserts it at the end of the
   * list so the UI updates immediately without a refetch.
   */ createSpaceMemory: (params)=>async ({ getState: getState, setState: setState })=>{
            const response = await (0, $73iDe.createSpaceMemoryFetchAction)(params);
            const { spaceMemories: spaceMemories } = getState();
            const { spaceId: spaceId } = params;
            const existing = spaceMemories.get(spaceId) ?? [];
            setState({
                spaceMemories: $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, [
                    ...existing,
                    {
                        id: response.id,
                        text: response.content
                    }
                ])
            });
        },
    /**
   * Optimistically removes a memory item from the store, then fires the
   * DELETE request. Rolls back on failure.
   */ removeSpaceMemory: (spaceId, memoryId, cloudId, product, experienceId)=>async ({ getState: getState, setState: setState })=>{
            const { spaceMemories: spaceMemories } = getState();
            const existing = spaceMemories.get(spaceId) ?? [];
            const optimistic = existing.filter((m)=>m.id !== memoryId);
            setState({
                spaceMemories: $c7f6d0062ae88238$var$mapSet(spaceMemories, spaceId, optimistic)
            });
            try {
                await (0, $1RoaH.deleteSpaceMemoryFetchAction)({
                    spaceId: spaceId,
                    memoryId: memoryId,
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
            } catch (err) {
                // Roll back the optimistic removal.
                setState({
                    spaceMemories: $c7f6d0062ae88238$var$mapSet(getState().spaceMemories, spaceId, existing)
                });
                throw err;
            }
        },
    setSmartContextLinkRecommendations: (spaceId, recommendations)=>({ getState: getState, setState: setState })=>{
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapSet(getState().smartContextLinkRecommendations, spaceId, recommendations)
            });
        },
    clearSmartContextLinkRecommendations: (spaceId)=>({ getState: getState, setState: setState })=>{
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapDelete(getState().smartContextLinkRecommendations, spaceId)
            });
        },
    removeSmartContextLinkRecommendation: (spaceId, recommendationId)=>({ getState: getState, setState: setState })=>{
            const { smartContextLinkRecommendations: smartContextLinkRecommendations } = getState();
            const existing = smartContextLinkRecommendations.get(spaceId);
            if (!existing) return;
            setState({
                smartContextLinkRecommendations: $c7f6d0062ae88238$var$mapSet(smartContextLinkRecommendations, spaceId, existing.filter((recommendation)=>recommendation.recommendationId !== recommendationId))
            });
        }
};
const $c7f6d0062ae88238$export$34ecf36458142176 = (0, $8s9DV.createStore)({
    name: 'spaceStore',
    initialState: $c7f6d0062ae88238$var$makeInitialState(),
    actions: $c7f6d0062ae88238$var$actions
});
module.exports["spaceStore"] = $c7f6d0062ae88238$export$34ecf36458142176;

});

parcelRegister("73iDe", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $f1fa406f69b22b7e$export$1b63f5338cb50250 = ({ spaceId: spaceId, content: content, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    return (0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory`,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content
            })
        }
    });
};
module.exports["createSpaceMemoryFetchAction"] = $f1fa406f69b22b7e$export$1b63f5338cb50250;

});

parcelRegister("98i9C", function(module, exports) {
/** Base path for the ConvoAI Spaces REST API. */ const $8ef18f344ac2d2f3$export$472fb0d2ff1c7d85 = '/gateway/api/assist/rovo/v1/spaces';
const $8ef18f344ac2d2f3$export$1dd3d5c121ebda25 = 100;
const $8ef18f344ac2d2f3$export$33d45ef69b8a7178 = 500;
module.exports["SPACES_API_PATH"] = $8ef18f344ac2d2f3$export$472fb0d2ff1c7d85;
module.exports["SPACE_NAME_MAX_LENGTH"] = $8ef18f344ac2d2f3$export$1dd3d5c121ebda25;
module.exports["SPACE_ABOUT_MAX_LENGTH"] = $8ef18f344ac2d2f3$export$33d45ef69b8a7178;

});

parcelRegister("1RoaH", function(module, exports) {
/**
 * The DELETE endpoint returns 204 No Content; `performHttpFetch` would
 * attempt `response.json()` and throw on an empty body, so we use the
 * manual `fetch` here instead.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $11c6d2f4dd10a9f1$export$53573fd484f1b3c3 = async ({ spaceId: spaceId, memoryId: memoryId, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    const path = `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory/${memoryId}`;
    let response;
    try {
        response = await fetch(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`deleteSpaceMemoryFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'deleteSpaceMemoryFetchError'
        });
    }
    if (!response.ok || response.status >= 400) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`deleteSpaceMemoryFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'deleteSpaceMemoryFetchError',
            statusCode: response.status
        });
    }
// 204 No Content — no body to parse.
};
module.exports["deleteSpaceMemoryFetchAction"] = $11c6d2f4dd10a9f1$export$53573fd484f1b3c3;

});

parcelRegister("6OvwE", function(module, exports) {
/**
 * Pure fetch helper extracted from `useGetSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $51d5e1a1500b2e17$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $51d5e1a1500b2e17$export$fbca0b4b208eec07 = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${$51d5e1a1500b2e17$var$SPACES_API_PATH}/${spaceId}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["getSpaceFetchAction"] = $51d5e1a1500b2e17$export$fbca0b4b208eec07;

});

parcelRegister("2Z9WR", function(module, exports) {
/**
 * Pure fetch helper extracted from `useGetSpaceConversations` so the spaces
 * sweet-state store can call it from inside an action without depending on
 * React or on the hook itself.
 */ 
var $igOtY = parcelRequire("igOtY");


var $jTKfH = parcelRequire("jTKfH");

const $3cc16f24d97017b7$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $3cc16f24d97017b7$var$mapSpaceConversationFromApi = (channel, spaceId)=>{
    const lastMessage = channel.last_message ?? undefined;
    return {
        id: channel.id,
        name: channel.name ?? '',
        messages: [],
        status: (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: [],
        timeCreated: channel.time_created,
        lastMessage: lastMessage,
        lastMessageType: channel.last_message_type ?? [],
        lastMessageTimestamp: channel.last_message_timestamp,
        lastAgentMessageStatus: channel.last_agent_message_status,
        readStatus: channel.readStatus ?? channel.read_status ?? null,
        agent: channel.agent,
        scopes: channel.scopes,
        tags: channel.tags,
        rovoSpaceId: spaceId,
        isEmpty: !lastMessage?.trim(),
        isPinned: channel.isPinned ?? channel.is_pinned ?? undefined,
        pinnedAt: channel.pinnedAt ?? channel.pinned_at ?? null
    };
};
const $3cc16f24d97017b7$export$539f16f68a4805bb = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, offset: offset, count: count })=>{
    const params = new URLSearchParams();
    if (offset !== undefined) params.set('offset', String(offset));
    if (count !== undefined) params.set('count', String(count));
    const query = params.toString();
    const raw = await (0, $jTKfH.performHttpFetch)({
        path: `${$3cc16f24d97017b7$var$SPACES_API_PATH}/${spaceId}/conversations${query ? `?${query}` : ''}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
    return {
        ...raw,
        conversations: raw.conversations.map((row)=>$3cc16f24d97017b7$var$mapSpaceConversationFromApi(row, spaceId))
    };
};
module.exports["getSpaceConversationsFetchAction"] = $3cc16f24d97017b7$export$539f16f68a4805bb;

});

parcelRegister("10p5Q", function(module, exports) {
/**
 * Pure fetch helper for GET /spaces/{spaceId}/memory.
 * Extracted from `useGetSpaceMemory` so callers (e.g. the sweet-state store)
 * can invoke it without depending on React or the hook lifecycle.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $4aa5bad3aecdc97a$export$8149ce67f430cbb = ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/memory`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["getSpaceMemoryFetchAction"] = $4aa5bad3aecdc97a$export$8149ce67f430cbb;

});

parcelRegister("9RoLt", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $296439ad4ec4b4aa$export$6c7ca5b71363fc06 = async ({ cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: (0, $98i9C.SPACES_API_PATH),
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["listSpacesFetchAction"] = $296439ad4ec4b4aa$export$6c7ca5b71363fc06;

});

parcelRegister("2IYpC", function(module, exports) {
/**
 * Pure fetch helper extracted from `useUpdateSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $078217057a30f7df$var$SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
const $078217057a30f7df$export$9c961ef5c3a31b95 = async ({ spaceId: spaceId, request: request, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${$078217057a30f7df$var$SPACES_API_PATH}/${spaceId}`,
        options: {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }
    });
module.exports["updateSpaceFetchAction"] = $078217057a30f7df$export$9c961ef5c3a31b95;

});

parcelRegister("oV0CU", function(module, exports) {
const $b9ae9242f3c4f5b9$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $b9ae9242f3c4f5b9$export$c87b1e2e3344192f = 1000;
const $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e = 60;
const $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb = $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * 60;
const $b9ae9242f3c4f5b9$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $b9ae9242f3c4f5b9$export$e8114853eca81277 = 'ai-mate';
const $b9ae9242f3c4f5b9$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $b9ae9242f3c4f5b9$export$1ea9613e3e37d315 = 30 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$501af059da333e01 = 5 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $b9ae9242f3c4f5b9$export$85d90d98449e85fd = 140;
const $b9ae9242f3c4f5b9$export$cad0f6e78cd99203 = '600px';
const $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda = 380;
const $b9ae9242f3c4f5b9$export$2c094f7f70c376e3 = 480;
const $b9ae9242f3c4f5b9$export$2e9abc2f500a1704 = 280;
const $b9ae9242f3c4f5b9$export$ac95424456cde4ce = 760;
const $b9ae9242f3c4f5b9$export$1a72156daebf0ea3 = 'conversation-assistant.split-layout.right-width';
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $b9ae9242f3c4f5b9$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb;
module.exports["AI_MATE_EXPERIENCE_ID"] = $b9ae9242f3c4f5b9$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $b9ae9242f3c4f5b9$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $b9ae9242f3c4f5b9$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $b9ae9242f3c4f5b9$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $b9ae9242f3c4f5b9$export$cad0f6e78cd99203;
module.exports["SPLIT_LAYOUT_INITIAL_WIDTH"] = $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda;
module.exports["SPLIT_LAYOUT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2c094f7f70c376e3;
module.exports["SPLIT_LAYOUT_ADJACENT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2e9abc2f500a1704;
module.exports["SPLIT_LAYOUT_MIN_PANEL_WIDTH"] = $b9ae9242f3c4f5b9$export$ac95424456cde4ce;
module.exports["SPLIT_LAYOUT_STORAGE_KEY"] = $b9ae9242f3c4f5b9$export$1a72156daebf0ea3;

});

parcelRegister("gyWKg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");

function $e5d42e7967be8c63$var$_defineProperty(e, r, t) {
    return (r = $e5d42e7967be8c63$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e5d42e7967be8c63$var$_toPropertyKey(t) {
    var i = $e5d42e7967be8c63$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e5d42e7967be8c63$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $e5d42e7967be8c63$var$styles = {
    wrapper: "_0jFU0VN91d _39xV02N91d _0KLXruhH7k"
};
const $e5d42e7967be8c63$var$ErrorView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error } = t0;
    let t1;
    if ($[0] !== error) {
        t1 = error?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, "[", error.message, "]") : null;
        $[0] = error;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $e5d42e7967be8c63$var$styles.wrapper,
            testId: "ai-mate-error-boundary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: "Oops. We've got an error.",
            appearance: "error"
        }, t1)));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $e5d42e7967be8c63$var$styles.wrapper,
        testId: "ai-mate-error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: "Oops. We've got an error.",
        appearance: "error"
    }, error?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, "[", error.message, "]") : null)));
};
class $e5d42e7967be8c63$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error) {
        (0, $hlvTd.addSentryBreadcrumb)(`ErrorBoundary: componentDidCatch: ${error.message}`);
        this.setState({
            error: error
        });
        if (this.props.rethrowErrors) throw error;
    }
    render() {
        const { error: error } = this.state;
        const { children: children, experienceName: experienceName, experienceNameList: experienceNameList } = this.props;
        if (!!error) {
            const combinedExperienceNameList = [
                ...new Set([
                    ...experienceNameList || [],
                    experienceName
                ])
            ].filter((experienceName)=>experienceName !== undefined);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, this.props.fallback ? this.props.fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5d42e7967be8c63$var$ErrorView, {
                error: error
            }), combinedExperienceNameList.map((experienceName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                    error: error,
                    name: experienceName
                })));
        }
        return children;
    }
    constructor(...args){
        super(...args);
        $e5d42e7967be8c63$var$_defineProperty(this, "state", {});
    }
}
$e5d42e7967be8c63$var$_defineProperty($e5d42e7967be8c63$export$e926676385687eaf, "displayName", 'ConversationAssistantErrorBoundary');
module.exports["ErrorBoundary"] = $e5d42e7967be8c63$export$e926676385687eaf;

});

parcelRegister("6H2Ay", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8wqiw = parcelRequire("8wqiw");

const $e3dfb33e54e47641$export$f9cd1e43211d8a4a = (0, $cozmU.createContext)((0, $8wqiw.initialState));
module.exports["globalConfig"] = $e3dfb33e54e47641$export$f9cd1e43211d8a4a;

});

parcelRegister("8wqiw", function(module, exports) {
const $fc6f73f3a32dac3c$export$d4c72bab9d6cc13a = {
    profileData: {
        name: 'John Doe'
    },
    feedbackCollector: {
        entryPointId: ''
    },
    siteId: '',
    experienceId: '',
    productKey: '',
    productHeader: '',
    orgId: '',
    assistanceServiceConfig: undefined,
    closeChat: ()=>{},
    emojiProvider: undefined,
    preventAbortRequestsOnStagingModalClose: false,
    preventAbortRequestsOnStandaloneChatClose: false,
    inProductExperience: '',
    smartCreationContext: undefined
};
module.exports["initialState"] = $fc6f73f3a32dac3c$export$d4c72bab9d6cc13a;

});

parcelRegister("eKjv9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6H2Ay = parcelRequire("6H2Ay");

const $964b2b4aa2fb5756$export$29031ce8b4e54e85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $6H2Ay.globalConfig));
} : ()=>(0, $cozmU.useContext)((0, $6H2Ay.globalConfig));
module.exports["useGlobalConfig"] = $964b2b4aa2fb5756$export$29031ce8b4e54e85;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {
const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    isContextPanelEnabled: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("6YdPR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eKjv9 = parcelRequire("eKjv9");

const $8640d528854286da$export$2a9125424215710e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { touchpointSource: touchpointSource } = t0;
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig } = (0, $eKjv9.useGlobalConfig)();
    assistanceServiceConfig?.headers;
    assistanceServiceConfig?.channelId;
    const t1 = assistanceServiceConfig?.headers;
    const t2 = assistanceServiceConfig?.channelId;
    let t3;
    if ($[0] !== experienceId || $[1] !== productHeader || $[2] !== siteId || $[3] !== t1 || $[4] !== t2 || $[5] !== touchpointSource) {
        t3 = {
            product: productHeader,
            experienceId: experienceId,
            touchpointSource: touchpointSource,
            siteId: siteId,
            headers: t1,
            channelId: t2
        };
        $[0] = experienceId;
        $[1] = productHeader;
        $[2] = siteId;
        $[3] = t1;
        $[4] = t2;
        $[5] = touchpointSource;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ touchpointSource: touchpointSource })=>{
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig } = (0, $eKjv9.useGlobalConfig)();
    return (0, $cozmU.useMemo)(()=>({
            product: productHeader,
            experienceId: experienceId,
            touchpointSource: touchpointSource,
            siteId: siteId,
            headers: assistanceServiceConfig?.headers,
            channelId: assistanceServiceConfig?.channelId
        }), [
        productHeader,
        experienceId,
        touchpointSource,
        siteId,
        assistanceServiceConfig?.headers,
        assistanceServiceConfig?.channelId
    ]);
};
module.exports["useAssistanceServiceParams"] = $8640d528854286da$export$2a9125424215710e;

});

parcelRegister("5BOJB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $9aRNV = parcelRequire("9aRNV");


var $6iQ4q = parcelRequire("6iQ4q");


var $3TxKn = parcelRequire("3TxKn");


var $iLyZq = parcelRequire("iLyZq");

const $ebee8f54e12cc0bd$var$dismissActiveAction = (action, clearAction)=>{
    try {
        (0, $iLyZq.getActionOnDismiss)(action)?.();
    } finally{
        clearAction();
    }
};
const $ebee8f54e12cc0bd$export$e60c4e7dea337eb3 = ()=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $9aRNV.useConversationActionsStoreActions), (0, $9aRNV.useConversationActionsStore), (0, $bGNkz.useUIStoreActions));
    const { setActiveAction_UNSAFE: setActiveAction_UNSAFE } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const activeActionRef = (0, $cozmU.useRef)(activeAction);
    // Keep clearActiveAction safe for hook instances that did not set the action.
    (0, $cozmU.useEffect)(()=>{
        activeActionRef.current = activeAction;
    }, [
        activeAction
    ]);
    const setActiveAction = (0, $cozmU.useCallback)((action)=>{
        activeActionRef.current = action;
        setActiveAction_UNSAFE(action);
        if (action) {
            setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                sourceAgentId: (0, $6iQ4q.DEFAULT_AGENT).id
            });
            setActiveMenu('none');
        }
    }, [
        setActiveAction_UNSAFE,
        setSelectedConversation,
        setActiveMenu
    ]);
    const clearActiveAction = (0, $cozmU.useCallback)(()=>{
        $ebee8f54e12cc0bd$var$dismissActiveAction(activeActionRef.current, ()=>{
            activeActionRef.current = undefined;
            setActiveAction_UNSAFE(undefined);
        });
    }, [
        setActiveAction_UNSAFE
    ]);
    return {
        activeAction: activeAction,
        setActiveAction: setActiveAction,
        clearActiveAction: clearActiveAction
    };
};
module.exports["useActiveAction"] = $ebee8f54e12cc0bd$export$e60c4e7dea337eb3;

});

parcelRegister("9aRNV", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $09ecffa85d56d9ae$var$store = (0, $8s9DV.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $09ecffa85d56d9ae$export$83a8985e8d377ba1 = (0, $kBr4q.createHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$74d7aed167e24a67 = (0, $kBr4q.createActionsHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$d6ed3fb83640b335 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$4be353558b8b8a37 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $09ecffa85d56d9ae$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $09ecffa85d56d9ae$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $09ecffa85d56d9ae$export$d6ed3fb83640b335;

});

parcelRegister("iLyZq", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $3bc7276fe39ce470$export$42c34726e4093ea = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.onDismiss;
module.exports["getActionOnDismiss"] = $3bc7276fe39ce470$export$42c34726e4093ea;

});

parcelRegister("gR7ri", function(module, exports) {
const $e7fea99b17cf91ca$export$89c94a468e7458db = (action)=>action;
module.exports["getConversationActionWithAssistantMetadata"] = $e7fea99b17cf91ca$export$89c94a468e7458db;

});

parcelRegister("c69qG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $12fb09f9899d13ab$export$dfdd5bb3b7412d6d = (0, $cozmU.createContext)(undefined);
module.exports["agentVersioningConfigContext"] = $12fb09f9899d13ab$export$dfdd5bb3b7412d6d;

});

parcelRegister("n71o5", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");


var $3TrVh = parcelRequire("3TrVh");

/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $cea7beaf4fdf86cd$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $3TrVh.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458 = (0, $kBr4q.createHook)((0, $lx3cN.chatStore), {
    selector: $cea7beaf4fdf86cd$var$publicStateSelector
});
module.exports["useChatStore"] = $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458;

});

parcelRegister("3TrVh", function(module, exports) {
const $8991d15323cea08f$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
module.exports["checkActiveConversationMatchesSource"] = $8991d15323cea08f$export$80b847bfebcaa3fd;

});

parcelRegister("5wAPd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $n71o5 = parcelRequire("n71o5");


var $i4nJ0 = parcelRequire("i4nJ0");

const $2344621fd00df2c4$export$626f7ff9a7747889 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { conversationId: conversationIdParam, assistanceServiceParams: assistanceServiceParams } = t1;
    const [t2] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId, conversations: conversations } = t2;
    const conversationId = conversationIdParam ?? currentConversationId;
    const conversation = conversations[conversationId];
    let t3;
    if ($[2] !== assistanceServiceParams || $[3] !== conversation || $[4] !== conversationId) {
        t3 = {
            conversationId: conversationId,
            conversation: conversation,
            assistanceServiceParams: assistanceServiceParams
        };
        $[2] = assistanceServiceParams;
        $[3] = conversation;
        $[4] = conversationId;
        $[5] = t3;
    } else t3 = $[5];
    return (0, $i4nJ0.useConversationData)(t3);
} : ({ conversationId: conversationIdParam, assistanceServiceParams: assistanceServiceParams } = {})=>{
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const conversationId = conversationIdParam ?? currentConversationId;
    const conversation = conversations[conversationId];
    return (0, $i4nJ0.useConversationData)({
        conversationId: conversationId,
        conversation: conversation,
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["useConversation"] = $2344621fd00df2c4$export$626f7ff9a7747889;

});

parcelRegister("i4nJ0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $37RgG = parcelRequire("37RgG");


var $3z1p5 = parcelRequire("3z1p5");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $6YdPR = parcelRequire("6YdPR");


var $gn6Jj = parcelRequire("gn6Jj");


var $222kR = parcelRequire("222kR");


var $1IZrU = parcelRequire("1IZrU");


var $dvUlt = parcelRequire("dvUlt");

const $daf188600e0350bc$var$createProvisionalSelectedAgent = (conversationAgent)=>{
    const conversationAgentId = conversationAgent?.agent_id;
    if (!conversationAgentId) return undefined;
    const conversationAgentCreatorType = conversationAgent?.creator_type;
    return {
        id: conversationAgentId,
        named_id: conversationAgent?.agent_named_id || conversationAgentId,
        name: conversationAgent?.agent_name || conversationAgentId,
        description: null,
        creator_type: conversationAgentCreatorType || 'CUSTOMER',
        available_plugins: {},
        is_default: conversationAgent?.is_default ?? false,
        actor_type: 'AGENT',
        user_defined_conversation_starters: null,
        favourite: false,
        deactivated: false,
        identity_account_id: conversationAgent?.identity_account_id
    };
};
const $daf188600e0350bc$export$23f34d314e5eff9c = ({ conversationId: conversationId, conversation: conversation, assistanceServiceParams: assistanceServiceParams })=>{
    const fallbackParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'useConversationHook'
    });
    const serviceParams = assistanceServiceParams || fallbackParams;
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const { agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    // Read only the specific conversation fields the derivation needs as locals,
    // so the memo below depends on these primitives rather than the whole
    // `conversation` object. A whole-object dependency would re-run the memo (and
    // the downstream `useAgentsPaginatedByAgentId` fetch) on unrelated per-turn
    // conversation writes during streaming, even though neither the gate-on nor
    // gate-off path reads those fields here.
    const conversationBackendAgentId = conversation?.agent?.agent_id;
    const conversationSourceAgentId = conversation?.sourceAgentId;
    const selectedAgentId = (0, $cozmU.useMemo)(()=>{
        if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) // CONVERSATION identity shown in the agent selector header. Prefer the
        // canonical backend/store conversation agent when present. Before the first
        // turn is sent, use the surface-level default agent so that first turn is
        // routed to it and the backend persists it as the conversation agent.
        return conversationBackendAgentId || agentDefaultIdOverride || undefined;
        const firstAssistantAuthorId = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT')?.content.message.message.author_id;
        const agentIdFromConversation = conversationSourceAgentId ?? firstAssistantAuthorId;
        if ((0, $iDrrr.fg)('rovo_chat_fix_agent_selection_after_cancel')) // fixing the fallback to correctly select an agent if a user cancels a session
        return agentIdFromConversation ?? conversationBackendAgentId ?? agentDefaultIdOverride;
        return agentIdFromConversation ?? agentDefaultIdOverride;
    }, [
        agentDefaultIdOverride,
        conversationSourceAgentId,
        conversationBackendAgentId,
        messages
    ]);
    const { agent: agent, error: agentError } = (0, $3z1p5.useAgentsPaginatedByAgentId)({
        agentId: selectedAgentId,
        assistanceServiceParams: serviceParams
    });
    const agentErrorCode = agentError?.errorAttributes?.errorCode;
    /**
   * if agent fetch failed with status code AGENT_FORBIDDEN or AGENT_DEACTIVATED, extract agent name from messages because user has no access to the agent endpoint anymore
   * scenario: user has access to an agent, created a conversation with it, but then lost access to the agent, this will be triggered when user tries to reopen the conversation;
   * scenario: user has access to an agent, created a conversation with it, but then the agent was deactivated, this will be triggered when user tries to reopen the conversation;
   */ const fallbackAgent = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('convo-ai-enable-agents-use-permission')) return undefined;
        // Don't create fallback agent for empty conversations (new chats)
        if ((0, $1IZrU.isEmptyConversation)(conversationId) || !selectedAgentId) return undefined;
        // Only create fallback agent when agent fetch failed (to extract agent name from messages for display)
        // If agent was successfully fetched, no need for fallback
        if (!(0, $dvUlt.isAgentUnavailable)(agentErrorCode)) return undefined;
        // Try to extract agent metadata from the first assistant message
        const firstAssistantMessage = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT');
        const author = firstAssistantMessage?.content.message.message.author;
        if (!author?.name) return undefined;
        // Create a minimal Agent object with only required fields from message metadata
        // This allows the UI to display the agent name even when access is denied
        return {
            id: selectedAgentId,
            named_id: author.named_id ?? selectedAgentId,
            name: author.name,
            description: null,
            creator_type: 'CUSTOMER',
            available_plugins: {},
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            deactivated: false
        };
    }, [
        selectedAgentId,
        messages,
        agentErrorCode,
        conversationId
    ]);
    const conversationAgentNamedId = conversation?.agent?.agent_named_id;
    const conversationAgentName = conversation?.agent?.agent_name;
    const conversationAgentCreatorType = conversation?.agent?.creator_type;
    const conversationAgentIdentityAccountId = conversation?.agent?.identity_account_id;
    const conversationAgentIsDefault = conversation?.agent?.is_default;
    const provisionalSelectedAgent = (0, $cozmU.useMemo)(()=>{
        if (!(0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') || !conversationBackendAgentId) return undefined;
        const conversationAgentForFallback = {
            agent_id: conversationBackendAgentId
        };
        if (conversationAgentNamedId) conversationAgentForFallback.agent_named_id = conversationAgentNamedId;
        if (conversationAgentName) conversationAgentForFallback.agent_name = conversationAgentName;
        if (conversationAgentCreatorType) conversationAgentForFallback.creator_type = conversationAgentCreatorType;
        if (conversationAgentIdentityAccountId) conversationAgentForFallback.identity_account_id = conversationAgentIdentityAccountId;
        if (typeof conversationAgentIsDefault === 'boolean') conversationAgentForFallback.is_default = conversationAgentIsDefault;
        return $daf188600e0350bc$var$createProvisionalSelectedAgent(conversationAgentForFallback);
    }, [
        conversationBackendAgentId,
        conversationAgentNamedId,
        conversationAgentName,
        conversationAgentCreatorType,
        conversationAgentIdentityAccountId,
        conversationAgentIsDefault
    ]);
    const selectedAgent = agent ?? fallbackAgent ?? provisionalSelectedAgent;
    const isFetching = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && Boolean(selectedAgentId && !selectedAgent && !agentError);
    // Calculate agentIdForNewChat: only use valid agents (not fallback/error state) for new chats
    const agentIdForNewChat = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('convo-ai-enable-agents-use-permission')) return selectedAgent?.id;
        // No agent selected
        if (!selectedAgent?.id) return undefined;
        // If agent fetch failed with forbidden/deactivated error, don't use it for new chats
        if ((0, $dvUlt.isAgentUnavailable)(agentErrorCode)) return undefined;
        // If conversation has an error state, the agent is a fallback - don't use it for new chats
        if (conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError) return undefined;
        // Valid agent - safe to use for new chats
        return selectedAgent?.id;
    }, [
        agentErrorCode,
        selectedAgent?.id,
        conversation?.status
    ]);
    const agentVersioningConfig = (0, $gn6Jj.useAgentVersioningConfig)();
    const agentVersion = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) return undefined;
        // Prefer version stored on conversation (from chat-new event)
        if (conversation?.agentVersion) return conversation.agentVersion;
        // Fall back to version from first assistant message author (from BE response)
        const firstAssistantMessage_0 = (0, $222kR.getFirstMessageOfType)(messages ?? [], 'ASSISTANT');
        const author_0 = firstAssistantMessage_0?.content.message.message.author;
        if (author_0?.versionId || author_0?.versionType) return {
            versionId: author_0.versionId,
            versionType: author_0.versionType,
            versionNumber: author_0.versionNumber
        };
        return undefined;
    }, [
        conversation?.agentVersion,
        messages
    ]);
    const agentVersionForNewChat = (0, $cozmU.useMemo)(()=>{
        if (!agentVersioningConfig?.preserveVersionOnNewChat) return undefined;
        return agentVersion;
    }, [
        agentVersioningConfig?.preserveVersionOnNewChat,
        agentVersion
    ]);
    return {
        conversation: conversation,
        selectedAgent: selectedAgent,
        selectedAgentId: selectedAgentId,
        isFetching: isFetching,
        agentErrorCode: agentErrorCode,
        agentIdForNewChat: agentIdForNewChat,
        agentVersion: agentVersion,
        agentVersionForNewChat: agentVersionForNewChat
    };
};
module.exports["useConversationData"] = $daf188600e0350bc$export$23f34d314e5eff9c;

});

parcelRegister("3z1p5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $iDrrr = parcelRequire("iDrrr");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $bJzbV = parcelRequire("bJzbV");


var $33DP2 = parcelRequire("33DP2");


var $ig6TM = parcelRequire("ig6TM");


var $aihbI = parcelRequire("aihbI");


var $h6LPv = parcelRequire("h6LPv");


var $3ay5Z = parcelRequire("3ay5Z");


var $37RgG = parcelRequire("37RgG");


var $5Vuk7 = parcelRequire("5Vuk7");


var $8reXX = parcelRequire("8reXX");


var $fU4xN = parcelRequire("fU4xN");

const $808992f64c91fd00$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
/**
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$agentsStore = (0, $8s9DV.createStore)({
    initialState: {
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    },
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $808992f64c91fd00$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            }
    }
});
/**
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$useAgentsStore = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsStore);
const $808992f64c91fd00$export$f5b1109ecd7858c1 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $808992f64c91fd00$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $cozmU.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $cozmU.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $cozmU.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            try {
                experienceTracker.start({
                    id: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $fU4xN.default).defaultAgentName);
                        agent.description = formatMessage((0, $fU4xN.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $5Vuk7.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $8reXX.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                if ((0, $bxkJA.isRateLimitedError)(error)) setAgentsError(error);
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $cozmU.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $808992f64c91fd00$var$agentsPaginatedStore = (0, $8s9DV.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['verified-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['available-for-jira']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    // Ensure isPlaceholder is cleared when hydrating with real BE data
                    const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                    updatedAgentsMap[agent.id] = {
                        ...existingData,
                        ...agent
                    };
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                // Ensure isPlaceholder is cleared when adding full agent data
                const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                updatedAgentsMap[agent.id] = {
                    ...existingData,
                    ...agent
                };
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                // Clean up placeholder flag when real agent data arrives
                // Keep placeholderAvatarUrl to avoid avatar flicker (same image, stable source)
                if (prevData.isPlaceholder) delete updatedData.isPlaceholder;
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        /**
     * Sets a placeholder agent in the agentsMap with partial data for immediate rendering.
     * The agent is marked with `isPlaceholder: true` so that `useAgentsPaginatedByAgentId`
     * still fetches full details from the network to replace it.
     * Used for optimistic rendering of agent name/avatar from pubsub payloads.
     */ setPlaceholderAgent: (agentId, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                // Only set placeholder if agent doesn't already exist with full data
                if (!agentsMap[agentId]) {
                    const updatedAgentsMap = {
                        ...agentsMap
                    };
                    updatedAgentsMap[agentId] = {
                        ...data,
                        id: agentId,
                        isPlaceholder: true
                    };
                    setState({
                        agentsMap: updatedAgentsMap
                    });
                }
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            }
    }
});
const $808992f64c91fd00$export$1553678862324ff0 = (0, $kBr4q.createActionsHook)($808992f64c91fd00$var$agentsPaginatedStore);
const $808992f64c91fd00$export$cea603150faaa56f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId]),
            isPlaceholder: Boolean(state.agentsMap[agentId]?.isPlaceholder)
        })
});
const $808992f64c91fd00$export$44c2e95a7a8b47c9 = (0, $lJ6db.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$44c2e95a7a8b47c9, $808992f64c91fd00$export$cea603150faaa56f, $808992f64c91fd00$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist, isPlaceholder: isPlaceholder }] = $808992f64c91fd00$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { error: error } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            const response = await assistanceService.getAgentDetails(agentId);
            return response;
        },
        enabled: Boolean(agentId) && (!doesAgentExist || isPlaceholder),
        onSuccess: (data)=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            updateAgent(agentId ?? '', data);
        },
        onError: (error)=>{
            if (!agentId) return;
            const is404Error = error.errorAttributes.statusCode === 404;
            const is403Error = error.errorAttributes.statusCode === 403 && (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission');
            if (!(is404Error || is403Error)) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined,
        error: undefined
    };
    return {
        agent: agent,
        error: error ?? undefined
    };
});
const $808992f64c91fd00$export$eae59c91509947e4 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const removedAgentCache = (0, $cozmU.useRef)({
        categories: [],
        agent: undefined
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            removedAgentCache.current = {
                categories: categories,
                agent: agent
            };
        },
        onError: ()=>{
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, favourite, agentAri)=>{
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri) (0, $6SsN4.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $bJzbV.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
                const root = store.getRoot();
                const connection = (0, $6SsN4.ConnectionHandler).getConnection(root, 'paginatedAgentsList_agentStudio_getAgents', {
                    cloudId: assistanceServiceInjectedParams.siteId,
                    input: {
                        onlyFavouriteAgents: true
                    },
                    product: assistanceServiceInjectedParams.product
                });
                const agentDataID = agentRecord?.getDataID();
                if (!connection || !agentDataID || !agentRecord) return;
                if (isFavourite) {
                    const edge = (0, $6SsN4.ConnectionHandler).createEdge(store, connection, agentRecord, 'AgentStudioAgentEdge');
                    (0, $6SsN4.ConnectionHandler).insertEdgeAfter(connection, edge);
                } else (0, $6SsN4.ConnectionHandler).deleteNode(connection, agentDataID);
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update
                updateAgent(id, {
                    favourite: !favourite
                });
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        assistanceServiceInjectedParams.product,
        assistanceServiceInjectedParams.siteId,
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    /**
   * Function that updates the verified status of an agent.
   * This can be removed once the dropdown has converted over to relay.
   */ const setVerifiedAgent = (0, $cozmU.useCallback)((id, isVerified)=>{
        updateAgent(id, {
            is_verified: isVerified
        });
    }, [
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $cozmU.useCallback)((id)=>{
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        setVerifiedAgent: setVerifiedAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $808992f64c91fd00$export$cc3deb815b1c179b = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $808992f64c91fd00$export$e6997ec35c535c54 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $6cFsl.di)((0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $808992f64c91fd00$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
            });
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $808992f64c91fd00$export$94c2040c41639ede = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $808992f64c91fd00$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $808992f64c91fd00$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $cozmU.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
            case 'verified-agents':
                queryInput.onlyVerifiedAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $ig6TM.fetchPaginatedAgents)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $8A2GO.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $808992f64c91fd00$export$65c6565d33cf8f4f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT = 3;
const $808992f64c91fd00$var$getRecommendedAgentsQueryKey = ({ limit: limit, pageUrl: pageUrl })=>[
        'recommendedAgents',
        limit,
        pageUrl ?? ''
    ];
const $808992f64c91fd00$var$fetchRecommendedAgents = async ({ assistanceService: assistanceService, limit: limit, pageUrl: pageUrl, updateAgent: updateAgent })=>{
    const response = await assistanceService.getRecommendedAgents({
        limit: limit,
        pageUrl: pageUrl
    });
    // Store the agents in the paginated store for optimistic updates etc.
    // Not adding them to a specific category in local cache on purpose.
    response.agents.forEach((agent)=>{
        updateAgent(agent.id, agent);
    });
    return response;
};
const $808992f64c91fd00$export$100f85e1b969f92e = ({ assistanceService: assistanceService, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl, updateAgent: updateAgent, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    (0, $5SS4O.prefetchQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl
        }),
        queryFn: ()=>$808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            }),
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
const $808992f64c91fd00$export$631401679afcb10f = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $808992f64c91fd00$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $5SS4O.useQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl
        }),
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            return $808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            });
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $8reXX.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $808992f64c91fd00$export$71d3696dcc60eb2d = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $ig6TM.fetchAgentByExternalConfigReference));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $808992f64c91fd00$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $cozmU.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $ig6TM.fetchAgentByExternalConfigReference)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $808992f64c91fd00$export$eee66751ca85dbf7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
} : (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
};
const $808992f64c91fd00$export$6553fa633373a34 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $808992f64c91fd00$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $aihbI.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["useAgentsPaginatedStoreActions"] = $808992f64c91fd00$export$1553678862324ff0;
module.exports["useAgentsPaginatedByAgentId"] = $808992f64c91fd00$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $808992f64c91fd00$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $808992f64c91fd00$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $808992f64c91fd00$export$94c2040c41639ede;
module.exports["useRecommendedAgents"] = $808992f64c91fd00$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $808992f64c91fd00$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $808992f64c91fd00$export$6553fa633373a34;

});

parcelRegister("33DP2", function(module, exports) {
const $1034fab58a3f1117$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $1034fab58a3f1117$export$73b400613798970e;

});

parcelRegister("ig6TM", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $haiCi = parcelRequire("haiCi");


var $hkokM = parcelRequire("hkokM");

const $23d23aea84aebb6d$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $23d23aea84aebb6d$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $23d23aea84aebb6d$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $hkokM.transformAgentGqlResponse)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $23d23aea84aebb6d$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam @skip(if: $skipAuthoringTeam) {
    id
    profileUrl
    displayName
		smallAvatarImageUrl
  }
  isVerified
  executionConfig @include(if: $includeExecutionConfig) {
    executionTier
    modelId
  }
}
`;
const $23d23aea84aebb6d$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId,
        skipAuthoringTeam: (0, $iDrrr.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $23d23aea84aebb6d$var$transformAgentListToGqlResponse(response);
};
const $23d23aea84aebb6d$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			...conversationAssistantAgent_agentStudioAssistant
			}
		}

		${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
		`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference,
        skipAuthoringTeam: (0, $iDrrr.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    return (0, $hkokM.transformAgentGqlResponse)(response.data.agentStudio_getByExternalReference);
};
module.exports["DEFAULT_PAGE_INFO"] = $23d23aea84aebb6d$export$cf57de7718965ae3;
module.exports["fetchPaginatedAgents"] = $23d23aea84aebb6d$export$44f796a68d9bc9f1;
module.exports["fetchAgentByExternalConfigReference"] = $23d23aea84aebb6d$export$fce04ce5e2fe57d3;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    const operation = startedAt === undefined ? undefined : $a406323faf455711$var$extractQueryName(gqlQuery);
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'graphqlError'
            });
            throw err;
        }
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'abort'
            });
            return {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
                data: null,
                errors: undefined
            };
        }
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'networkError'
        });
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("hkokM", function(module, exports) {
const $296d37b9c9e504ab$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $296d37b9c9e504ab$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        agentAri: agentNode.id,
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null,
        is_verified: agentNode.isVerified,
        execution_config: agentNode.executionConfig ? {
            execution_tier: agentNode.executionConfig.executionTier
        } : null
    });
module.exports["transformAgentGqlResponse"] = $296d37b9c9e504ab$export$91e35509133d1cc1;

});

parcelRegister("aihbI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $12QCz = parcelRequire("12QCz");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $hSs5g = parcelRequire("hSs5g");


var $hq9Cp = parcelRequire("hq9Cp");


var $a9aSv = parcelRequire("a9aSv");


var $hlvTd = parcelRequire("hlvTd");


var $5SS4O = parcelRequire("5SS4O");


var $ji12t = parcelRequire("ji12t");


var $yJycJ = parcelRequire("yJycJ");


var $8reXX = parcelRequire("8reXX");


var $aaPn1 = parcelRequire("aaPn1");


var $fjlCA = parcelRequire("fjlCA");


var $cKhij = parcelRequire("cKhij");

const $117d671412ecf119$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $117d671412ecf119$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $117d671412ecf119$export$1565ea9a9fb7ad67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agent: agent, siteId: siteId, simplified: simplified, onClick: onClick } = t0;
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) {
            let t1;
            if ($[1] !== authoringTeam.display_name || $[2] !== authoringTeam.profile_url || $[3] !== onClick) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: authoringTeam.profile_url,
                    target: "_blank",
                    onClick: onClick
                }, authoringTeam.display_name));
                $[1] = authoringTeam.display_name;
                $[2] = authoringTeam.profile_url;
                $[3] = onClick;
                $[4] = t1;
            } else t1 = $[4];
            return t1;
        }
        let t1;
        if ($[5] !== agent.creator) {
            t1 = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
            $[5] = agent.creator;
            $[6] = t1;
        } else t1 = $[6];
        const aaid = t1;
        if (!aaid) return null;
        let t2;
        if ($[7] !== aaid || $[8] !== onClick || $[9] !== simplified || $[10] !== siteId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified,
                onClick: onClick
            });
            $[7] = aaid;
            $[8] = onClick;
            $[9] = simplified;
            $[10] = siteId;
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    if ((0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === "REMOTE_A2A" && (0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
        let t1;
        if ($[12] !== agent.creator) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, agent.creator);
            $[12] = agent.creator;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    return null;
} : ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        testId: "atlassian-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        label: "",
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"));
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: authoringTeam.profile_url,
            target: "_blank",
            onClick: onClick
        }, authoringTeam.display_name));
        const aaid = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === 'REMOTE_A2A' && (0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, agent.creator);
    }
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $117d671412ecf119$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $6cFsl.di)($117d671412ecf119$export$5d980898591175e, (0, $yJycJ.useAgentCrossProductUrlWrapper));
    const { profile: profile, client: client } = $117d671412ecf119$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { atlasURL: atlasURL } = (0, $aaPn1.useAtlasURL)(siteId);
    const wrapCrossProductUrl = (0, $yJycJ.useAgentCrossProductUrlWrapper)({
        xpcBridge: 'rovoAgents-browseAgentsModal'
    });
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $cKhij.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = wrapCrossProductUrl(atlasURL(`/people/${userId}`));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick
        }, fullName);
    }
    return profileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
const $117d671412ecf119$export$5d980898591175e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProfileResolution(userId, siteId, t0) {
    const $ = (0, $bDgLe.c)(14);
    const shouldFetch = t0 === undefined ? true : t0;
    const profileClient = (0, $fjlCA.useProfileClient)();
    let t1;
    if ($[0] !== siteId || $[1] !== userId) {
        t1 = [
            "fetchProfile",
            siteId,
            userId
        ];
        $[0] = siteId;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== profileClient || $[4] !== siteId || $[5] !== userId) {
        t2 = async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (t3) {
                const error = t3;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "ConversationAssistantAgentUseProfileResolutionError"
                });
                return {};
            }
        };
        $[3] = profileClient;
        $[4] = siteId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== shouldFetch || $[8] !== t1 || $[9] !== t2) {
        t3 = {
            queryKey: t1,
            queryFn: t2,
            enabled: shouldFetch
        };
        $[7] = shouldFetch;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const profile = (0, $5SS4O.useQuery)(t3);
    let t4;
    if ($[11] !== profile || $[12] !== profileClient) {
        t4 = {
            profile: profile,
            client: profileClient
        };
        $[11] = profile;
        $[12] = profileClient;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useProfileResolution(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $fjlCA.useProfileClient)();
    const profile = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
};
const $117d671412ecf119$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $117d671412ecf119$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $117d671412ecf119$export$4aa0ac5d998cf08e = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled === true);
    const filtersByAri = new Map();
    enabledSources?.forEach((source)=>{
        const sourceAris = [
            ...source.filters?.parentFilter ?? [],
            ...source.filters?.spaceFilter ?? [],
            ...source.filters?.projectFilter ?? []
        ];
        sourceAris.forEach((ari)=>{
            if (!filtersByAri.has(ari)) filtersByAri.set(ari, {
                ari: ari,
                cloudId: source.cloudId ?? null
            });
        });
    });
    return [
        ...filtersByAri.values()
    ];
};
const $117d671412ecf119$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $8reXX.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $117d671412ecf119$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $117d671412ecf119$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $117d671412ecf119$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $117d671412ecf119$export$a6e36c224ec3c0cb;
module.exports["getEnabledKnowledgeFiltersFromAgent"] = $117d671412ecf119$export$4aa0ac5d998cf08e;
module.exports["getSuggestedOotbAgents"] = $117d671412ecf119$export$6d876204c5d593ac;

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0WKd3G4z3T",
    baseT26Shape: "_0bjKvDcjp5",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("12QCz", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-deprecated-imports, @typescript-eslint/ban-types -- Preserve existing mention implementation while focus-ring usage is reviewed separately. */ 
var $cozmU = parcelRequire("cozmU");


var $b1FLc = parcelRequire("b1FLc");


var $21cx5 = parcelRequire("21cx5");


var $cK6Td = parcelRequire("cK6Td");


var $iD1Wv = parcelRequire("iD1Wv");


var $gcaru = parcelRequire("gcaru");


var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");


var $lzgC6 = parcelRequire("lzgC6");


var $j7Sza = parcelRequire("j7Sza");


var $j1Rvl = parcelRequire("j1Rvl");


var $27ALb = parcelRequire("27ALb");

const $1b57c88557e5831b$export$7452d7062a4d0634 = 1000;
const $1b57c88557e5831b$export$af8124aa496797f2 = '_|unknown|_';
class $1b57c88557e5831b$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $j7Sza.UFOExperienceState)['STARTED'],
            (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rvl.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId, disabledTooltip: disabledTooltip } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$1b57c88557e5831b$export$af8124aa496797f2}`;
        const showRestrictedTooltip = mentionType === (0, $caelp.MentionType).RESTRICTED;
        const showDisabledTooltip = mentionType === (0, $caelp.MentionType).DISABLED && !!disabledTooltip;
        // A11y: when the chip is in the disabled visual state, expose
        // `aria-disabled` so assistive tech announces it as such. The
        // disabled-tooltip text is mirrored into `aria-label` so the
        // announcement carries the reason even without portal-id wiring for
        // `aria-describedby`.
        const isDisabledChip = mentionType === (0, $caelp.MentionType).DISABLED;
        const disabledA11yProps = isDisabledChip ? {
            'aria-disabled': true,
            tabIndex: 0,
            ...disabledTooltip ? {
                'aria-label': `${text || '@...'} \u{2014} ${disabledTooltip}`
            } : {}
        } : {};
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1FLc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK6Td.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showRestrictedTooltip || showDisabledTooltip,
            ...disabledA11yProps
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        const wrappedMention = (()=>{
            if (showRestrictedTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iD1Wv.default), {
                name: text
            }, mentionComponent));
            if (showDisabledTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gcaru.default), {
                tooltip: disabledTooltip
            }, mentionComponent));
            return mentionComponent;
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27ALb.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, wrappedMention)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick, isDisabled: isDisabled } = this.props;
            if (isDisabled) // Disabled chips do not invoke their click handler.
            return;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $1b57c88557e5831b$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted, isDisabled: isDisabled } = this.props;
            if (isDisabled) return (0, $caelp.MentionType).DISABLED;
            if (isHighlighted) return (0, $caelp.MentionType).SELF;
            if ((0, $caelp.isRestricted)(accessLevel)) return (0, $caelp.MentionType).RESTRICTED;
            return (0, $caelp.MentionType).DEFAULT;
        };
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $1b57c88557e5831b$var$MentionWithAnalytics = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $b3nqj.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $b3nqj.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($1b57c88557e5831b$export$92ab8442e7a15cef);
const $1b57c88557e5831b$var$Mention = $1b57c88557e5831b$var$MentionWithAnalytics;
var $1b57c88557e5831b$export$2e2bcd8739ae039 = $1b57c88557e5831b$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $1b57c88557e5831b$export$af8124aa496797f2;
module.exports["default"] = $1b57c88557e5831b$export$2e2bcd8739ae039;

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $j1Rvl = parcelRequire("j1Rvl");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("j1Rvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $92AHJ = parcelRequire("92AHJ");

const $878ccfcc8552aaa6$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $878ccfcc8552aaa6$export$98e06fe7a6174253 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).differentText);































const $878ccfcc8552aaa6$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("jX0rV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2tbWn")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("dOzBl")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ePsdA")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("2GvIV")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("16HIv")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("WAFjY")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("474Ah")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("84VXz")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("fQ8BA")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("dDWYb")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5XRxk")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("hMxVZ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("58PuX")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("jglh9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("iHOtt")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("d3k1V")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lXcxb")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("jK2My")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("ge9it")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("1O6Yy")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jNfyP")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("eL47t")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $878ccfcc8552aaa6$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $878ccfcc8552aaa6$export$d0a3169680473b6c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("jX0rV", function(module, exports) {

let $e863e0441b14ec08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e863e0441b14ec08$var$load("1JYrd"),
    $e863e0441b14ec08$var$load("cip6w"),
    $e863e0441b14ec08$var$load("gAG2n"),
    $e863e0441b14ec08$var$load("hFpP9"),
    $e863e0441b14ec08$var$load("3feYV"),
    $e863e0441b14ec08$var$load("cwjU2"),
    $e863e0441b14ec08$var$load("3Ff1R"),
    $e863e0441b14ec08$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2tbWn", function(module, exports) {

let $1cc78d5897d732a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1cc78d5897d732a7$var$load("30242"),
    $1cc78d5897d732a7$var$load("3qBwQ"),
    $1cc78d5897d732a7$var$load("cYGDU"),
    $1cc78d5897d732a7$var$load("ddSTH"),
    $1cc78d5897d732a7$var$load("7Q1SM"),
    $1cc78d5897d732a7$var$load("33Iaa"),
    $1cc78d5897d732a7$var$load("blA7x"),
    $1cc78d5897d732a7$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("dOzBl", function(module, exports) {

let $a0eb8f8a89644122$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a0eb8f8a89644122$var$load("15aAJ"),
    $a0eb8f8a89644122$var$load("8rREG"),
    $a0eb8f8a89644122$var$load("dgXJL"),
    $a0eb8f8a89644122$var$load("9d8JZ"),
    $a0eb8f8a89644122$var$load("7JdzX"),
    $a0eb8f8a89644122$var$load("6681T"),
    $a0eb8f8a89644122$var$load("3dn3H"),
    $a0eb8f8a89644122$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("ePsdA", function(module, exports) {

let $acbbb7a8f95cd6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acbbb7a8f95cd6fc$var$load("l5BBd"),
    $acbbb7a8f95cd6fc$var$load("93ASN"),
    $acbbb7a8f95cd6fc$var$load("htu5t"),
    $acbbb7a8f95cd6fc$var$load("1A450"),
    $acbbb7a8f95cd6fc$var$load("24LNf"),
    $acbbb7a8f95cd6fc$var$load("iYQCc"),
    $acbbb7a8f95cd6fc$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("2GvIV", function(module, exports) {

let $1f481cafca2c7f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f481cafca2c7f01$var$load("bbv9t"),
    $1f481cafca2c7f01$var$load("9fQoJ"),
    $1f481cafca2c7f01$var$load("lTboH"),
    $1f481cafca2c7f01$var$load("gBDXQ"),
    $1f481cafca2c7f01$var$load("cnlNg"),
    $1f481cafca2c7f01$var$load("d3Phe"),
    $1f481cafca2c7f01$var$load("lASLx"),
    $1f481cafca2c7f01$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("16HIv", function(module, exports) {

let $0ce8433c656a7df9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ce8433c656a7df9$var$load("7p4je"),
    $0ce8433c656a7df9$var$load("8SZbD"),
    $0ce8433c656a7df9$var$load("iE05k"),
    $0ce8433c656a7df9$var$load("lv5aU"),
    $0ce8433c656a7df9$var$load("9Uf61"),
    $0ce8433c656a7df9$var$load("3Yk1e"),
    $0ce8433c656a7df9$var$load("5lJyy"),
    $0ce8433c656a7df9$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("WAFjY", function(module, exports) {

let $0b01dbe497441ac5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0b01dbe497441ac5$var$load("5ZQnr"),
    $0b01dbe497441ac5$var$load("lJyww"),
    $0b01dbe497441ac5$var$load("gVfjY"),
    $0b01dbe497441ac5$var$load("2hqQb"),
    $0b01dbe497441ac5$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("474Ah", function(module, exports) {

let $2feb5f3312640ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2feb5f3312640ee1$var$load("1jQRQ"),
    $2feb5f3312640ee1$var$load("5pOQA"),
    $2feb5f3312640ee1$var$load("5GSny"),
    $2feb5f3312640ee1$var$load("cQump"),
    $2feb5f3312640ee1$var$load("fJSEb"),
    $2feb5f3312640ee1$var$load("ajzkj"),
    $2feb5f3312640ee1$var$load("eyysG"),
    $2feb5f3312640ee1$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("84VXz", function(module, exports) {

let $5e1ba813b36eb977$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5e1ba813b36eb977$var$load("km37l"),
    $5e1ba813b36eb977$var$load("gbksI"),
    $5e1ba813b36eb977$var$load("j2X7f"),
    $5e1ba813b36eb977$var$load("fE8pi"),
    $5e1ba813b36eb977$var$load("9TeWr"),
    $5e1ba813b36eb977$var$load("kUZ7k"),
    $5e1ba813b36eb977$var$load("dJQL7"),
    $5e1ba813b36eb977$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("fQ8BA", function(module, exports) {

let $b882632b90032289$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b882632b90032289$var$load("lTbXI"),
    $b882632b90032289$var$load("a98cw"),
    $b882632b90032289$var$load("e40mE"),
    $b882632b90032289$var$load("btBGI"),
    $b882632b90032289$var$load("fOGnR"),
    $b882632b90032289$var$load("cDQOq"),
    $b882632b90032289$var$load("8upye"),
    $b882632b90032289$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("dDWYb", function(module, exports) {

let $9eeca90420daddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9eeca90420daddea$var$load("iUyZj"),
    $9eeca90420daddea$var$load("4PDaO"),
    $9eeca90420daddea$var$load("lMhbw"),
    $9eeca90420daddea$var$load("amTTV"),
    $9eeca90420daddea$var$load("8nEeY"),
    $9eeca90420daddea$var$load("kLZKK"),
    $9eeca90420daddea$var$load("c7GMc"),
    $9eeca90420daddea$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("5XRxk", function(module, exports) {

let $457bfdb241591b32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $457bfdb241591b32$var$load("kPlMQ"),
    $457bfdb241591b32$var$load("ervs7"),
    $457bfdb241591b32$var$load("8CX31"),
    $457bfdb241591b32$var$load("kYd4i"),
    $457bfdb241591b32$var$load("fzzMQ"),
    $457bfdb241591b32$var$load("33S6H"),
    $457bfdb241591b32$var$load("kFae4"),
    $457bfdb241591b32$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("hMxVZ", function(module, exports) {

let $03573eef817c65ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03573eef817c65ad$var$load("iT2sv"),
    $03573eef817c65ad$var$load("iMMtn"),
    $03573eef817c65ad$var$load("23VWs"),
    $03573eef817c65ad$var$load("e1KaU"),
    $03573eef817c65ad$var$load("3gNEO"),
    $03573eef817c65ad$var$load("93obY"),
    $03573eef817c65ad$var$load("6Y9jE"),
    $03573eef817c65ad$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("58PuX", function(module, exports) {

let $3be5a59a48a9e11b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3be5a59a48a9e11b$var$load("lyPpF"),
    $3be5a59a48a9e11b$var$load("eX5n7"),
    $3be5a59a48a9e11b$var$load("aiYuN"),
    $3be5a59a48a9e11b$var$load("gqMCT"),
    $3be5a59a48a9e11b$var$load("gvylW"),
    $3be5a59a48a9e11b$var$load("bxfRe"),
    $3be5a59a48a9e11b$var$load("ed6s8"),
    $3be5a59a48a9e11b$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("jglh9", function(module, exports) {

let $e06003d5e1220a42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e06003d5e1220a42$var$load("iN3cj"),
    $e06003d5e1220a42$var$load("3nHdy"),
    $e06003d5e1220a42$var$load("gDEvm"),
    $e06003d5e1220a42$var$load("5MwHB"),
    $e06003d5e1220a42$var$load("80OLx"),
    $e06003d5e1220a42$var$load("1EVcg"),
    $e06003d5e1220a42$var$load("96q1k"),
    $e06003d5e1220a42$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("iHOtt", function(module, exports) {

let $d9e3654e24ebe721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d9e3654e24ebe721$var$load("eC1OL"),
    $d9e3654e24ebe721$var$load("ilL9c"),
    $d9e3654e24ebe721$var$load("64nco"),
    $d9e3654e24ebe721$var$load("9cx6P"),
    $d9e3654e24ebe721$var$load("e4s0V"),
    $d9e3654e24ebe721$var$load("28EXy"),
    $d9e3654e24ebe721$var$load("7RZp5"),
    $d9e3654e24ebe721$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("d3k1V", function(module, exports) {

let $980b17bc6670e7c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $980b17bc6670e7c7$var$load("4NJ49"),
    $980b17bc6670e7c7$var$load("bfOZL"),
    $980b17bc6670e7c7$var$load("jLbRX"),
    $980b17bc6670e7c7$var$load("5g0HW"),
    $980b17bc6670e7c7$var$load("4dPO1"),
    $980b17bc6670e7c7$var$load("gg8tK"),
    $980b17bc6670e7c7$var$load("eF54W"),
    $980b17bc6670e7c7$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("lXcxb", function(module, exports) {

let $ffb8d4b57da0499e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffb8d4b57da0499e$var$load("fsCDU"),
    $ffb8d4b57da0499e$var$load("kuolm"),
    $ffb8d4b57da0499e$var$load("fvE7S"),
    $ffb8d4b57da0499e$var$load("apVmx"),
    $ffb8d4b57da0499e$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("jK2My", function(module, exports) {

let $e5f478a9b13e5070$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f478a9b13e5070$var$load("g9gkE"),
    $e5f478a9b13e5070$var$load("jYdbS"),
    $e5f478a9b13e5070$var$load("6ncWv"),
    $e5f478a9b13e5070$var$load("gFneG"),
    $e5f478a9b13e5070$var$load("ltrgi"),
    $e5f478a9b13e5070$var$load("fu25G"),
    $e5f478a9b13e5070$var$load("iQGcz"),
    $e5f478a9b13e5070$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("ge9it", function(module, exports) {

let $bd052a544036c7c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd052a544036c7c1$var$load("jhikU"),
    $bd052a544036c7c1$var$load("f0i3H"),
    $bd052a544036c7c1$var$load("bvBAp"),
    $bd052a544036c7c1$var$load("9kqmW"),
    $bd052a544036c7c1$var$load("69YlM"),
    $bd052a544036c7c1$var$load("cyTsc"),
    $bd052a544036c7c1$var$load("kXCsp"),
    $bd052a544036c7c1$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("1O6Yy", function(module, exports) {

let $150fdf33bc578fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $150fdf33bc578fed$var$load("fSsz4"),
    $150fdf33bc578fed$var$load("kWOpS"),
    $150fdf33bc578fed$var$load("9tUAi"),
    $150fdf33bc578fed$var$load("bS9pO"),
    $150fdf33bc578fed$var$load("kgHzZ"),
    $150fdf33bc578fed$var$load("j4ur8"),
    $150fdf33bc578fed$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("jNfyP", function(module, exports) {

let $e68ea9f4734869ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e68ea9f4734869ef$var$load("d91RK"),
    $e68ea9f4734869ef$var$load("f7hfJ"),
    $e68ea9f4734869ef$var$load("QI1kr"),
    $e68ea9f4734869ef$var$load("5LvhC"),
    $e68ea9f4734869ef$var$load("brdRT"),
    $e68ea9f4734869ef$var$load("lWBlc"),
    $e68ea9f4734869ef$var$load("s2EmI"),
    $e68ea9f4734869ef$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("eL47t", function(module, exports) {

let $abe8a684a19ae877$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abe8a684a19ae877$var$load("708J7"),
    $abe8a684a19ae877$var$load("kVqUf"),
    $abe8a684a19ae877$var$load("2IMxh"),
    $abe8a684a19ae877$var$load("98tcg"),
    $abe8a684a19ae877$var$load("j03Pa"),
    $abe8a684a19ae877$var$load("kke1I"),
    $abe8a684a19ae877$var$load("gOwMq"),
    $abe8a684a19ae877$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("cK6Td", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $3U6po = parcelRequire("3U6po");

const $ef75f214d8da3bca$var$getStyle = ({ mentionType: mentionType }, property)=>(0, $3U6po.mentionStyle)[mentionType][property];
const $ef75f214d8da3bca$var$PrimitiveMention = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $lOiVq.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $ef75f214d8da3bca$export$2e2bcd8739ae039 = $ef75f214d8da3bca$var$PrimitiveMention;
module.exports["default"] = $ef75f214d8da3bca$export$2e2bcd8739ae039;

});

parcelRegister("3U6po", function(module, exports) {

var $caelp = parcelRequire("caelp");

const $4789bd4e087c7edf$export$b0888661f7c77ab5 = {
    [(0, $caelp.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $caelp.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $caelp.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    [(0, $caelp.MentionType).DISABLED]: {
        background: "var(--ds-background-disabled, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-disabled, #080F214A)",
        // Disabled chips do not change on hover / press.
        hoveredBackground: "var(--ds-background-disabled, #0515240F)",
        pressedBackground: "var(--ds-background-disabled, #0515240F)"
    }
};
module.exports["mentionStyle"] = $4789bd4e087c7edf$export$b0888661f7c77ab5;

});

parcelRegister("caelp", function(module, exports) {
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $c573a2458006a7eb$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $c573a2458006a7eb$export$81124e6148ca5db0[0];
}
function $c573a2458006a7eb$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[1];
}
function $c573a2458006a7eb$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[2];
}
function $c573a2458006a7eb$export$374d169f8869a22b(mention) {
    // Like `isAgentTypeAheadItem` in `editor-plugin-mentions/src/ui/type-ahead/index.tsx`
    // and `isAgentUserType` in `editor-plugin-mentions/src/pm-plugins/agent.ts`
    return mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[2] || mention.userType === 'AGENT' || mention.appType === 'agent';
}
function $c573a2458006a7eb$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[3];
}
function $c573a2458006a7eb$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $c573a2458006a7eb$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;
module.exports["isRestricted"] = $c573a2458006a7eb$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $c573a2458006a7eb$export$37b8dcac6198c514;
module.exports["isAppMention"] = $c573a2458006a7eb$export$eb590c844d13454c;
module.exports["isAgentMention"] = $c573a2458006a7eb$export$374d169f8869a22b;
module.exports["isTeamMention"] = $c573a2458006a7eb$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $c573a2458006a7eb$export$d13d4f976b36a397;
module.exports["isPromise"] = $c573a2458006a7eb$export$4369c812aac99591;

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("gcaru", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $139bcf7839d1a883$var$AsyncDisabledMentionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2GsKr")).then((module)=>{
        return {
            default: module.DisabledMentionTooltip
        };
    }));
var $139bcf7839d1a883$export$2e2bcd8739ae039 = $139bcf7839d1a883$var$AsyncDisabledMentionTooltip;
module.exports["default"] = $139bcf7839d1a883$export$2e2bcd8739ae039;

});

parcelRegister("2GsKr", function(module, exports) {

let $1f45cdcc4b463c3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f45cdcc4b463c3d$var$load("5bU1Y").then(()=>parcelRequire('eZafG'));

});

parcelRegister("b3nqj", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $caelp = parcelRequire("caelp");

const $39262f9932c4c2bd$var$packageName = "platform-pkg";
const $39262f9932c4c2bd$var$packageVersion = "0.0.0-use.local";
const $39262f9932c4c2bd$export$245097525aef1262 = 'sli';
const $39262f9932c4c2bd$export$c724588856bbfbcf = 'smart';
const $39262f9932c4c2bd$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $39262f9932c4c2bd$var$packageName,
                    packageVersion: $39262f9932c4c2bd$var$packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
const $39262f9932c4c2bd$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            attributes: {
                packageName: $39262f9932c4c2bd$var$packageName,
                packageVersion: $39262f9932c4c2bd$var$packageVersion,
                componentName: (0, $caelp.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $caelp.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $4cczm.ELEMENTS_CHANNEL));
        return event;
    };
const $39262f9932c4c2bd$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $39262f9932c4c2bd$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
const $39262f9932c4c2bd$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $39262f9932c4c2bd$var$packageName,
            packageVersion: $39262f9932c4c2bd$var$packageVersion,
            componentName: (0, $caelp.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $39262f9932c4c2bd$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $39262f9932c4c2bd$var$packageName,
                    packageVersion: $39262f9932c4c2bd$var$packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $39262f9932c4c2bd$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $39262f9932c4c2bd$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$39262f9932c4c2bd$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $caelp.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $39262f9932c4c2bd$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $39262f9932c4c2bd$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $39262f9932c4c2bd$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $39262f9932c4c2bd$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $39262f9932c4c2bd$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $39262f9932c4c2bd$export$91b2fa6a0fe06408;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;

});

parcelRegister("27ALb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

const $0f53e930d80d4c74$export$1d011e4240507c78 = new (0, $fh15z.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
class $0f53e930d80d4c74$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        $0f53e930d80d4c74$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $0f53e930d80d4c74$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $0f53e930d80d4c74$export$5ef1c2550074a375;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("ji12t", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ee0754b6a3322402$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $ee0754b6a3322402$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $ee0754b6a3322402$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar');
const $ee0754b6a3322402$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $ee0754b6a3322402$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $ee0754b6a3322402$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira',
    /** Jira browse tab: 3P marketplace coding agents (UI label localized in product). */ CODING_AGENTS: 'coding-agents'
};
module.exports["isSystemAgent"] = $ee0754b6a3322402$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $ee0754b6a3322402$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $ee0754b6a3322402$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $ee0754b6a3322402$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $ee0754b6a3322402$export$916e4870f74f205b;

});

parcelRegister("yJycJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $6cFsl = parcelRequire("6cFsl");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");

const $77c2e4e3c0f10222$var$identity = (url)=>url;
const $77c2e4e3c0f10222$export$3c82e87d2696be5a = ({ xpcBridge: xpcBridge })=>{
    (0, $6cFsl.di)((0, $aIlZA.default));
    // Read defensively: `useSmartLinkContext()` throws without a provider, but
    // these components can render outside one.
    const cardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    const xpcProduct = cardContext?.xpcProduct;
    // Always call the hook (Rules of Hooks); result unused when we return identity.
    const wrapUrl = (0, $aIlZA.default)({
        bridge: xpcBridge,
        product: xpcProduct ?? ''
    });
    // No host product (unknown host / no provider) or kill-switch off: do not report.
    if (!xpcProduct || !(0, $iDrrr.fg)('ai-mate-xpc')) return $77c2e4e3c0f10222$var$identity;
    return wrapUrl;
};
module.exports["useAgentCrossProductUrlWrapper"] = $77c2e4e3c0f10222$export$3c82e87d2696be5a;

});

parcelRegister("8reXX", function(module, exports) {
const $631eae7ab6cb77ba$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $631eae7ab6cb77ba$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $631eae7ab6cb77ba$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $631eae7ab6cb77ba$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE;
const $631eae7ab6cb77ba$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE;
const $631eae7ab6cb77ba$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $631eae7ab6cb77ba$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $631eae7ab6cb77ba$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $631eae7ab6cb77ba$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $631eae7ab6cb77ba$export$429080cfef3412f2;

});

parcelRegister("aaPn1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7cQjw = parcelRequire("7cQjw");


var $iTxmV = parcelRequire("iTxmV");

const $bebfe5469a5e55d3$export$8a1abb7c176bd202 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(5);
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    let t0;
    if ($[0] !== siteId || $[1] !== tenantData?.orgId) {
        t0 = (path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId);
        $[0] = siteId;
        $[1] = tenantData?.orgId;
        $[2] = t0;
    } else t0 = $[2];
    tenantData?.orgId;
    const atlasURL = t0;
    let t1;
    if ($[3] !== atlasURL) {
        t1 = {
            atlasURL: atlasURL
        };
        $[3] = atlasURL;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (siteId)=>{
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    const atlasURL = (0, $cozmU.useCallback)((path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $bebfe5469a5e55d3$export$b61b99f9ac0264be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(2);
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    let t0;
    if ($[0] !== atlasURL) {
        t0 = atlasURL("/chat/agents/new");
        $[0] = atlasURL;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (siteId)=>{
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $bebfe5469a5e55d3$export$8a1abb7c176bd202;

});

parcelRegister("7cQjw", function(module, exports) {

var $dTEBe = parcelRequire("dTEBe");


var $2J4Io = parcelRequire("2J4Io");

const $4c09219c949e06e3$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c09219c949e06e3$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c09219c949e06e3$export$5105758c0e772381 = ()=>{
    return (0, $2J4Io.isStaging)() ? $4c09219c949e06e3$var$ATLAS_STAGING_URL : $4c09219c949e06e3$var$ATLAS_PROD_URL;
};
const $4c09219c949e06e3$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$4c09219c949e06e3$export$5105758c0e772381()}/o/${orgId}` : $4c09219c949e06e3$export$5105758c0e772381();
    return (0, $dTEBe.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $4c09219c949e06e3$export$5105758c0e772381;
module.exports["getAtlasURL"] = $4c09219c949e06e3$export$bfee0f88bf621ad3;

});

parcelRegister("dTEBe", function(module, exports) {

var $iDZi9 = parcelRequire("iDZi9");

const $f229989060597496$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $f229989060597496$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $f229989060597496$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $f229989060597496$export$9748efee331ec573 = (param)=>`${0, $iDZi9.ROVO_PARAM_PREFIX}${$f229989060597496$export$fda91e425d265029(param)}`;
const $f229989060597496$export$f2888183a34644d4 = (param)=>{
    return $f229989060597496$export$858653b7ee3cbb17(param.replace((0, $iDZi9.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $f229989060597496$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $f229989060597496$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $iDZi9.ROVO_PARAM_PREFIX))) return;
        const paramKey = $f229989060597496$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $f229989060597496$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $f229989060597496$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $f229989060597496$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $f229989060597496$export$ef04687636c850fe(window.location.pathname, params));
};
const $f229989060597496$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $f229989060597496$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $f229989060597496$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $f229989060597496$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$f229989060597496$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$f229989060597496$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $f229989060597496$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $f229989060597496$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
  For products using react-resource-router (e.g Atlas) to
  pass as the value of `query` on the route definition. It ensures that our parameters
  are not stripped from the URL when loading the page, or through redirect hops
  Any new parameters we want to maintain should be added here as well, which means
  only a version bump is needed in those products to support the latest param list
  The !=false simply means that the parameter is supported but is optional, and should
  not contain a value of 'false'
  */ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $iDZi9.ROVO_VALID_PARAMS).map((param)=>`${$f229989060597496$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $f229989060597496$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $f229989060597496$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $f229989060597496$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $f229989060597496$export$eddc20a009406015;

});

parcelRegister("iDZi9", function(module, exports) {
const $36649e4ee5b3590e$export$5a550907ffbc9119 = 'rovoChat';
const $36649e4ee5b3590e$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];
module.exports["ROVO_PARAM_PREFIX"] = $36649e4ee5b3590e$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $36649e4ee5b3590e$export$3cd6b610e7ede579;

});

parcelRegister("2J4Io", function(module, exports) {
const $d610f1a90044572d$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $d610f1a90044572d$export$23da1d24a38b0bde;

});

parcelRegister("iTxmV", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $fBeNh = parcelRequire("fBeNh");

const $a5b67b50b6da9994$export$b863fec6791eae25 = (siteId)=>{
    (0, $6cFsl.di)((0, $5SS4O.useQuery));
    const experience = (0, $bjY3F.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error_0 } = (0, $5SS4O.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $fBeNh.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error_0
    };
};
module.exports["useTenantDataController"] = $a5b67b50b6da9994$export$b863fec6791eae25;

});

parcelRegister("fBeNh", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $haiCi = parcelRequire("haiCi");


var $8JTh2 = parcelRequire("8JTh2");

const $c818cddb4b471711$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
    orgId
    customDomains {
      product
      hostName
    }
  }
}
`;
// Cached per `cloudId` — the raw AGG payload is product-agnostic, so we fetch
// once per tenant and let the rewrite step branch on product. The cache stores
// the in-flight Promise so concurrent product lookups dedupe to one request.
const $c818cddb4b471711$var$rawTenantCache = new Map();
const $c818cddb4b471711$var$fetchTenantContext = async (cloudId)=>{
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: $c818cddb4b471711$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
const $c818cddb4b471711$export$d4ace54df9bd6bb1 = async (cloudId, product)=>{
    const cachingEnabled = (0, $iDrrr.fg)('aifc_create_enabled');
    let inFlight = cachingEnabled ? $c818cddb4b471711$var$rawTenantCache.get(cloudId) : undefined;
    if (!inFlight) {
        inFlight = $c818cddb4b471711$var$fetchTenantContext(cloudId);
        if (cachingEnabled) {
            $c818cddb4b471711$var$rawTenantCache.set(cloudId, inFlight);
            inFlight.then((result)=>{
                if (result === undefined) $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            }, ()=>{
                $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            });
        }
    }
    const raw = await inFlight;
    if (!raw) return undefined;
    return {
        cloudUrl: product ? (0, $8JTh2.rewriteBaseToCustomDomain)(raw.cloudUrl, product, raw.customDomains) : raw.cloudUrl,
        orgId: raw.orgId
    };
};
module.exports["getCloudUrlFromId"] = $c818cddb4b471711$export$d4ace54df9bd6bb1;

});

parcelRegister("8JTh2", function(module, exports) {
const $43581a61b5d6dd12$export$432453592155ebf4 = (base, product, customDomains)=>{
    const match = customDomains?.find((domain)=>domain.product === product && Boolean(domain.hostName));
    if (!match) return base;
    try {
        const url = new URL(base);
        url.hostname = match.hostName;
        // url.toString() normalises bare-root URLs to include a trailing slash
        // (e.g. 'https://wiki.starbucks.com/'). All handlers concatenate a
        // leading-slash path, so we strip the trailing slash to avoid double-slashes
        // (e.g. 'https://wiki.starbucks.com//wiki/spaces/...' → correct).
        return url.toString().replace(/\/$/, '');
    } catch  {
        return base;
    }
};
module.exports["rewriteBaseToCustomDomain"] = $43581a61b5d6dd12$export$432453592155ebf4;

});

parcelRegister("fjlCA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5hJlu = parcelRequire("5hJlu");

const $b39593d68f627ba8$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $b39593d68f627ba8$var$client;
const $b39593d68f627ba8$export$d43dc22a8337ee9f = ()=>{
    (0, $6cFsl.di)((0, $5hJlu.default));
    const profileClient = (0, $cozmU.useMemo)(()=>{
        if (!$b39593d68f627ba8$var$client) // To support di
        $b39593d68f627ba8$var$client = new (0, $5hJlu.default)({
            url: $b39593d68f627ba8$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $b39593d68f627ba8$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $b39593d68f627ba8$export$d43dc22a8337ee9f;

});

parcelRegister("cKhij", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f61c2cb3f029b6ef$var$message = (0, $kSwu1.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $f61c2cb3f029b6ef$export$2e2bcd8739ae039 = $f61c2cb3f029b6ef$var$message;
module.exports["default"] = $f61c2cb3f029b6ef$export$2e2bcd8739ae039;

});

parcelRegister("h6LPv", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $ceec91f359597657$export$89877d4f8d8790ca = (0, $lJ6db.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).DELETE_AGENT,
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $ceec91f359597657$export$89877d4f8d8790ca;

});

parcelRegister("3ay5Z", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $852df1b03fff5c54$export$5c4c46b1f93a6e69 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $852df1b03fff5c54$export$5c4c46b1f93a6e69;

});

parcelRegister("5Vuk7", function(module, exports) {
const $17fc5339fe3ee56f$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};
module.exports["getOverridenAgents"] = $17fc5339fe3ee56f$export$b873e2166b2a4c4f;

});

parcelRegister("fU4xN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4657aea77ee8f7d7$var$message = (0, $kSwu1.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});
var $4657aea77ee8f7d7$export$2e2bcd8739ae039 = $4657aea77ee8f7d7$var$message;
module.exports["default"] = $4657aea77ee8f7d7$export$2e2bcd8739ae039;

});

parcelRegister("gn6Jj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $c69qG = parcelRequire("c69qG");

const $397d0442e822624b$export$e2f65d68917ec2b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $c69qG.agentVersioningConfigContext));
} : ()=>(0, $cozmU.useContext)((0, $c69qG.agentVersioningConfigContext));
module.exports["useAgentVersioningConfig"] = $397d0442e822624b$export$e2f65d68917ec2b1;

});

parcelRegister("222kR", function(module, exports) {
const $925623d692bcf893$export$d669251a312339ff = (chat, type)=>{
    const lastIndex = chat.map((item)=>item.type).indexOf(type);
    if (lastIndex >= 0) return chat[lastIndex];
};
module.exports["getFirstMessageOfType"] = $925623d692bcf893$export$d669251a312339ff;

});

parcelRegister("dvUlt", function(module, exports) {

var $fCunh = parcelRequire("fCunh");

const $90bfb4e6c87059a4$export$8d253468a0039e81 = (errorCode)=>{
    return errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN || errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED;
};
module.exports["isAgentUnavailable"] = $90bfb4e6c87059a4$export$8d253468a0039e81;

});

parcelRegister("3Ak5G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5Tn11 = parcelRequire("5Tn11");


var $85mU8 = parcelRequire("85mU8");

const $80d108dec70fe388$export$ff8fdce0b2574720 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $85mU8.getBrowserBridgeAPI)();
        $[0] = t0;
    } else t0 = $[0];
    const bridgeAPI = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (command, params)=>{
            const fullParams = {
                ...params,
                senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            };
            return bridgeAPI.send(command, fullParams);
        };
        $[1] = t1;
    } else t1 = $[1];
    const sendCommand = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            sendCommand: sendCommand
        };
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const sendCommand = (0, $cozmU.useCallback)((command, params)=>{
        // Automatically inject senderId while preserving all other params
        const fullParams = {
            ...params,
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        };
        return bridgeAPI.send(command, fullParams);
    }, [
        bridgeAPI
    ]);
    return {
        sendCommand: sendCommand
    };
};
module.exports["useBridgeSendCommand"] = $80d108dec70fe388$export$ff8fdce0b2574720;

});

parcelRegister("j1J3n", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $76129364d697533a$export$5ea0e7c17cb45f8e = (0, $dSoGR.createCommand)('aifc-content-copied');
module.exports["AifcContentCopiedCommand"] = $76129364d697533a$export$5ea0e7c17cb45f8e;

});

parcelRegister("lzoay", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $6b458841b18d92d3$export$2d48a0bb3ca90998 = (0, $dSoGR.createCommand)('action-classification-command');
module.exports["ActionClassificationCommand"] = $6b458841b18d92d3$export$2d48a0bb3ca90998;

});

parcelRegister("jIWEY", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $6a4afb8ff5c7a0df$export$91924c1e64eedc26 = (docNode)=>{
    if (!docNode) return '';
    const text = (0, $4EPzQ.reduce)(docNode, (acc, node)=>node.type === 'text' ? acc + (node.text || '') : acc, '');
    return text.trim();
};
module.exports["extractTextFromDocNode"] = $6a4afb8ff5c7a0df$export$91924c1e64eedc26;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b94r6 = parcelRequire("b94r6");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $b94r6.pageLoad,
    pageSegmentLoad: $b94r6.pageSegmentLoad,
    interaction: $b94r6.interaction,
    custom: $b94r6.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b94r6 = parcelRequire("b94r6");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b94r6.interaction) : (0, $b94r6.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b94r6", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $3L5Pu = parcelRequire("3L5Pu");


var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $01df368966019ba1$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
const $01df368966019ba1$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $01df368966019ba1$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
const $01df368966019ba1$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $01df368966019ba1$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $01df368966019ba1$export$94114666844d5f66;
module.exports["interaction"] = $01df368966019ba1$export$92473e6020ad89b4;
module.exports["custom"] = $01df368966019ba1$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("aXbSS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $dqxOF = parcelRequire("dqxOF");


var $kHija = parcelRequire("kHija");


var $1hQ0e = parcelRequire("1hQ0e");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");


var $3PNw6 = parcelRequire("3PNw6");


var $a1L5E = parcelRequire("a1L5E");


var $91ZZN = parcelRequire("91ZZN");


var $dTEBe = parcelRequire("dTEBe");


var $ieeJu = parcelRequire("ieeJu");







/**
 * @generated SignedSource<<84b5cec36358517f031ac3e5bb7d0219>>
 * @relayHash 66d191a5cf4d158b1d095665d91c4624
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 803ac5f4f755934617bd8141a7b5076bee417b0a28ce3ac9ea08f2f5e07bebe4
const $2990500f18e1130a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchKeyword"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldFetch"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "searchKeyword",
        "variableName": "searchKeyword"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v10 = [
        {
            "concreteType": "ConvoAiSkillEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "ConvoAiSkill",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "slashCommand"
                        },
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "iconKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "helpText"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tags"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "integrationKeys"
                        },
                        {
                            "concreteType": "ConvoAiSkillIntegration",
                            "kind": "LinkedField",
                            "name": "integrations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "cursor"
                }
            ]
        },
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasPreviousPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "startCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalCount"
        },
        {
            "concreteType": "ConvoAiSkillListMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "anthropicCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "stratusCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDegraded"
                }
            ]
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "autoSuggestSkills_AvailableSkillsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "convoai_availableSkills",
                            "args": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ],
                            "concreteType": "ConvoAiAvailableSkillsResult",
                            "kind": "LinkedField",
                            "name": "__AutoSuggestSkills__convoai_availableSkills_connection",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "autoSuggestSkills_AvailableSkillsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "ConvoAiAvailableSkillsResult",
                            "kind": "LinkedField",
                            "name": "convoai_availableSkills",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "searchKeyword"
                            ],
                            "handle": "connection",
                            "key": "AutoSuggestSkills__convoai_availableSkills",
                            "kind": "LinkedHandle",
                            "name": "convoai_availableSkills"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "803ac5f4f755934617bd8141a7b5076bee417b0a28ce3ac9ea08f2f5e07bebe4",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "convoai_availableSkills"
                        ]
                    }
                ]
            },
            "name": "autoSuggestSkills_AvailableSkillsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2990500f18e1130a$var$node.hash = "7be476b3761df5f61da30000c9ce27d1";
var $2990500f18e1130a$export$2e2bcd8739ae039 = $2990500f18e1130a$var$node;


/**
 * @generated SignedSource<<17d611c91bc3951a0eec321545a487e6>>
 * @relayHash 668d74eb31b88713cc12d2da9bcd29b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 35b0ceb0f240bd9d7d8d9c3a63f3c66d48681a3ce291328e5aeb58d506fa62ba
const $e893dcfbbab5e216$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dimensionIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": [
            "SKILL"
        ],
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchKeyword"
    }, v6 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "shouldFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "Variable",
        "name": "dimensionIds",
        "variableName": "dimensionIds"
    }, v10 = {
        "kind": "Variable",
        "name": "relevantFor",
        "variableName": "relevantFor"
    }, v11 = {
        "kind": "Variable",
        "name": "searchKeyword",
        "variableName": "searchKeyword"
    }, v12 = {
        "kind": "Variable",
        "name": "surface",
        "variableName": "surface"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "ScalarField",
        "name": "slashCommand"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "description"
    }, v18 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v19 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v20 = {
        "kind": "ScalarField",
        "name": "color"
    }, v21 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v22 = {
        "kind": "ScalarField",
        "name": "message"
    }, v23 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v24 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v25 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v26 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v27 = [
        v14 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "autoSuggestSkills_Query",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "graphIntegration_componentDirectoryItems",
                            "args": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ],
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "__Skills__graphIntegration_componentDirectoryItems_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "autoSuggestSkills_Query",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationActionDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpServer"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpTool"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "GraphIntegrationSkillItem"
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        },
                        {
                            "args": v26 /*: any*/ ,
                            "filters": [
                                "dimensionIds",
                                "searchKeyword",
                                "relevantFor",
                                "cloudId",
                                "surface"
                            ],
                            "handle": "connection",
                            "key": "Skills__graphIntegration_componentDirectoryItems",
                            "kind": "LinkedHandle",
                            "name": "graphIntegration_componentDirectoryItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "35b0ceb0f240bd9d7d8d9c3a63f3c66d48681a3ce291328e5aeb58d506fa62ba",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "graphIntegration_componentDirectoryItems"
                        ]
                    }
                ]
            },
            "name": "autoSuggestSkills_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e893dcfbbab5e216$var$node.hash = "8b255b0911cefe3d524b12dc716f3447";
var $e893dcfbbab5e216$export$2e2bcd8739ae039 = $e893dcfbbab5e216$var$node;









var $6SsN4 = parcelRequire("6SsN4");


var $jXPru = parcelRequire("jXPru");





var $2hJf7 = parcelRequire("2hJf7");











var $8lhhf = parcelRequire("8lhhf");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $89QZA = parcelRequire("89QZA");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");


var $bGNkz = parcelRequire("bGNkz");


var $iDlFY = parcelRequire("iDlFY");


var $d5gEx = parcelRequire("d5gEx");


var $9OqBj = parcelRequire("9OqBj");


var $9MCKh = parcelRequire("9MCKh");


var $80Hjq = parcelRequire("80Hjq");


var $f6VI9 = parcelRequire("f6VI9");











var $5SS4O = parcelRequire("5SS4O");


var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $c19bbb1f83cfe63e$export$fd6d70680144ad1d = async ({ cloudId: cloudId, product: product, experienceId: experienceId, query: query, limit: limit = 20 })=>{
    const params = new URLSearchParams({
        q: query,
        limit: String(limit)
    });
    return (0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/search?${params.toString()}`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
};


const $ff1a6e6cc93a8de4$export$1e7662bb7b25ce15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { cloudId: cloudId, product: product, experienceId: experienceId, searchQuery: searchQuery, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== searchQuery) {
        t2 = searchQuery?.trim() ?? "";
        $[0] = searchQuery;
        $[1] = t2;
    } else t2 = $[1];
    const trimmedQuery = t2;
    const isQueryEmpty = trimmedQuery.length === 0;
    const isEnabled = !skip && !isQueryEmpty;
    let t3;
    let t4;
    if ($[2] !== cloudId || $[3] !== experienceId || $[4] !== product || $[5] !== trimmedQuery) {
        t3 = [
            "rovo-spaces:searchSpaces",
            cloudId,
            product,
            experienceId,
            trimmedQuery
        ];
        t4 = ()=>(0, $c19bbb1f83cfe63e$export$fd6d70680144ad1d)({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                query: trimmedQuery
            });
        $[2] = cloudId;
        $[3] = experienceId;
        $[4] = product;
        $[5] = trimmedQuery;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    let t5;
    if ($[8] !== isEnabled || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            queryKey: t3,
            queryFn: t4,
            enabled: isEnabled
        };
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, isFetching: isFetching, error: error, refetch: refetchQuery } = (0, $5SS4O.useQuery)(t5);
    const hasFetched = data !== null || error !== null;
    let t6;
    if ($[12] !== refetchQuery) {
        t6 = async ()=>{
            await refetchQuery();
        };
        $[12] = refetchQuery;
        $[13] = t6;
    } else t6 = $[13];
    const refetch = t6;
    let t7;
    if ($[14] !== data?.data) {
        t7 = data?.data ?? [];
        $[14] = data?.data;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== error || $[17] !== hasFetched || $[18] !== isFetching || $[19] !== refetch || $[20] !== t7) {
        t8 = {
            spaces: t7,
            isLoading: isFetching,
            error: error,
            hasFetched: hasFetched,
            refetch: refetch
        };
        $[16] = error;
        $[17] = hasFetched;
        $[18] = isFetching;
        $[19] = refetch;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
} : ({ cloudId: cloudId, product: product, experienceId: experienceId, searchQuery: searchQuery, skip: skip = false })=>{
    const trimmedQuery = searchQuery?.trim() ?? '';
    const isQueryEmpty = trimmedQuery.length === 0;
    const isEnabled = !skip && !isQueryEmpty;
    const { data: data, isFetching: isFetching, error: error, refetch: refetchQuery } = (0, $5SS4O.useQuery)({
        queryKey: [
            'rovo-spaces:searchSpaces',
            cloudId,
            product,
            experienceId,
            trimmedQuery
        ],
        queryFn: ()=>(0, $c19bbb1f83cfe63e$export$fd6d70680144ad1d)({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                query: trimmedQuery
            }),
        enabled: isEnabled
    });
    const hasFetched = data !== null || error !== null;
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        await refetchQuery();
    }, [
        refetchQuery
    ]);
    return (0, $cozmU.useMemo)(()=>({
            spaces: data?.data ?? [],
            isLoading: isFetching,
            error: error,
            hasFetched: hasFetched,
            refetch: refetch
        }), [
        data,
        isFetching,
        error,
        hasFetched,
        refetch
    ]);
};



var $d26Wq = parcelRequire("d26Wq");














var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $h5LaW = parcelRequire("h5LaW");


var $9KSWX = parcelRequire("9KSWX");




var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");





var $fGEnS = parcelRequire("fGEnS");


var $l0ley = parcelRequire("l0ley");

const $57299e02d73bd6b6$var$MAX_LIST_ITEMS = 9;
const $57299e02d73bd6b6$var$MAX_FULLSCREEN_SKILLS = 8;
const $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID = '__view_all_skills__';
const $57299e02d73bd6b6$var$ITEM_HEIGHT_PX = 56;
const $57299e02d73bd6b6$var$LIST_ITEM_GAP_PX = 12;
const $57299e02d73bd6b6$var$ROW_HEIGHT_PX = $57299e02d73bd6b6$var$ITEM_HEIGHT_PX + $57299e02d73bd6b6$var$LIST_ITEM_GAP_PX;
const $57299e02d73bd6b6$var$listStyles = {
    wrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuz9WS _0jFU0VN91d _39xV02N91d _4bt5LAnQyn _2Zuz6QkG2W _1ZnuxbkG2W",
    wrapperFullscreen: "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _39xV02N91d _1EqgXl1btN _2XsHFMIZbP _0adFHsIZbP _4bt5LAnQyn _2WAcuGYvD1 _1wydGW2ADO",
    titleSection: "_2Zuz6QPgdg _313842NHnM _1DCdHi2ADO",
    itemsContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _3YEZNOdnbC",
    itemsList: "_2mHwu81Y8M _1LMyvKYbGa _4bt5LAnQyn _2WAcuGnQyn _2Zuz6QPgdg _1ZnuxbPgdg _313842Pgdg",
    itemsListFullscreen: "_2mHwu88HPE _1LMyvKYbGa _3iDTPbgBM8 _2iEGP2Lmr7 _2Zuz6QPgdg _1ZnuxbPgdg _313842Pgdg",
    itemButton: "_39xV02N91d _4kiQYAHMkp _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _0KLXru66of _2fwxA5ecOK _0Am33zKxmn _1eOmH6o126 _3gzVzLN4oS",
    itemButtonSelected: "_0bjKvDKxmn _0KLXruo126",
    itemInner: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d",
    itemContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    itemIconContainer: "_0bjKvDKTcp _30huDKOeNX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1UtDYzZpcK _0KLXrulfZc",
    descriptionExpandable: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHVWD4 _3iDTPbgBM8",
    descriptionExpandableInner: "_4bt5LAnQyn _2WAcuGnQyn _4kiQYAdnbC"
};
const $57299e02d73bd6b6$var$filterItems = (items, searchValue)=>{
    if (!searchValue) return items;
    const search = searchValue.toLowerCase();
    return items.filter((item)=>item.name.toLowerCase().includes(search) || item.description?.toLowerCase().includes(search));
};
const $57299e02d73bd6b6$var$ItemRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { item: item, isSelected: isSelected, shortcutLabel: shortcutLabel, onClick: onClick, onHover: onHover, isViewAll: isViewAll, isHoveredFromParent: isHoveredFromParent } = t0;
    const [isHoveredLocal, setIsHoveredLocal] = (0, $cozmU.useState)(false);
    const showHoverStyle = isHoveredFromParent ?? isHoveredLocal;
    let t1;
    if ($[0] !== item || $[1] !== onHover) {
        t1 = ()=>{
            setIsHoveredLocal(true);
            onHover?.(item);
        };
        $[0] = item;
        $[1] = onHover;
        $[2] = t1;
    } else t1 = $[2];
    const handleMouseEnter = t1;
    let t2;
    if ($[3] !== onHover) {
        t2 = ()=>{
            setIsHoveredLocal(false);
            onHover?.(null);
        };
        $[3] = onHover;
        $[4] = t2;
    } else t2 = $[4];
    const handleMouseLeave = t2;
    const handleMouseDown = $57299e02d73bd6b6$var$_temp;
    const t3 = (showHoverStyle || isSelected) && $57299e02d73bd6b6$var$listStyles.itemButtonSelected;
    let t4;
    if ($[5] !== t3) {
        t4 = (0, $w6R6I.cx)($57299e02d73bd6b6$var$listStyles.itemButton, t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = isViewAll ? "auto-suggest-view-all-skills" : `auto-suggest-item-${item.id}`;
    let t6;
    if ($[7] !== item.icon) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $57299e02d73bd6b6$var$listStyles.itemIconContainer
        }, item.icon);
        $[7] = item.icon;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== item.name) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, item.name);
        $[9] = item.name;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== isSelected || $[12] !== item.description || $[13] !== showHoverStyle) {
        t8 = item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $57299e02d73bd6b6$var$listStyles.descriptionExpandable,
            style: {
                gridTemplateRows: showHoverStyle || isSelected ? "1fr" : "0fr"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $57299e02d73bd6b6$var$listStyles.descriptionExpandableInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            maxLines: 1
        }, item.description)));
        $[11] = isSelected;
        $[12] = item.description;
        $[13] = showHoverStyle;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t7 || $[16] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $57299e02d73bd6b6$var$listStyles.itemContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, t7, t8));
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== shortcutLabel) {
        t10 = shortcutLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "neutral"
        }, shortcutLabel);
        $[18] = shortcutLabel;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t6 || $[22] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $57299e02d73bd6b6$var$listStyles.itemInner
        }, t6, t9, t10);
        $[20] = t10;
        $[21] = t6;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== handleMouseEnter || $[25] !== handleMouseLeave || $[26] !== isSelected || $[27] !== onClick || $[28] !== t11 || $[29] !== t4 || $[30] !== t5) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: t4,
            onClick: onClick,
            onMouseDown: handleMouseDown,
            role: "option",
            "aria-selected": isSelected,
            testId: t5,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave
        }, t11);
        $[24] = handleMouseEnter;
        $[25] = handleMouseLeave;
        $[26] = isSelected;
        $[27] = onClick;
        $[28] = t11;
        $[29] = t4;
        $[30] = t5;
        $[31] = t12;
    } else t12 = $[31];
    return t12;
} : ({ item: item, isSelected: isSelected, shortcutLabel: shortcutLabel, onClick: onClick, onHover: onHover, isViewAll: isViewAll, isHoveredFromParent: isHoveredFromParent })=>{
    const [isHoveredLocal, setIsHoveredLocal] = (0, $cozmU.useState)(false);
    const showHoverStyle = isHoveredFromParent ?? isHoveredLocal;
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHoveredLocal(true);
        onHover?.(item);
    }, [
        item,
        onHover
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHoveredLocal(false);
        onHover?.(null);
    }, [
        onHover
    ]);
    const handleMouseDown = (event)=>event.preventDefault();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($57299e02d73bd6b6$var$listStyles.itemButton, (showHoverStyle || isSelected) && $57299e02d73bd6b6$var$listStyles.itemButtonSelected),
        onClick: onClick,
        onMouseDown: handleMouseDown,
        role: "option",
        "aria-selected": isSelected,
        testId: isViewAll ? 'auto-suggest-view-all-skills' : `auto-suggest-item-${item.id}`,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57299e02d73bd6b6$var$listStyles.itemInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57299e02d73bd6b6$var$listStyles.itemIconContainer
    }, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57299e02d73bd6b6$var$listStyles.itemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, item.name), item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57299e02d73bd6b6$var$listStyles.descriptionExpandable,
        style: {
            gridTemplateRows: showHoverStyle || isSelected ? '1fr' : '0fr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57299e02d73bd6b6$var$listStyles.descriptionExpandableInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, item.description))))), shortcutLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, shortcutLabel)));
};
const $57299e02d73bd6b6$var$getShortcutLabel = (index)=>{
    const mod = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform) ? "\u2318" : 'Ctrl';
    return `${mod}${index + 1}`;
};
const $57299e02d73bd6b6$export$7afadbf289b7f123 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { items: items, searchQuery: searchQuery, onSelectItem: onSelectItem, onDismiss: onDismiss, onItemHover: onItemHover, onViewAllSkills: onViewAllSkills, renderHoverCardContent: renderHoverCardContent, layout: t1 } = t0;
    const layout = t1 === undefined ? "sidebar" : t1;
    const isFullscreen = layout === "fullscreen";
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $l0ley.messages).title);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const title = t2;
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $l0ley.messages).viewAllSkills);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5LaW))), {
            label: ""
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3) {
        t5 = {
            id: $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID,
            name: t3,
            description: undefined,
            icon: t4
        };
        $[5] = t3;
        $[6] = t5;
    } else t5 = $[6];
    const viewAllPlaceholderItem = t5;
    const [selectedIndex, setSelectedIndex] = (0, $cozmU.useState)(-1);
    const [hoveredIndex, setHoveredIndex] = (0, $cozmU.useState)(null);
    const [wrapperHeight, setWrapperHeight] = (0, $cozmU.useState)(null);
    const wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    let t6;
    if ($[7] !== items || $[8] !== searchQuery) {
        t6 = $57299e02d73bd6b6$var$filterItems(items, searchQuery);
        $[7] = items;
        $[8] = searchQuery;
        $[9] = t6;
    } else t6 = $[9];
    const filteredItems = t6;
    let t7;
    bb0: {
        if (isFullscreen) {
            t7 = $57299e02d73bd6b6$var$MAX_FULLSCREEN_SKILLS;
            break bb0;
        }
        if (wrapperHeight == null) {
            t7 = $57299e02d73bd6b6$var$MAX_LIST_ITEMS;
            break bb0;
        }
        const fit = Math.floor(wrapperHeight / $57299e02d73bd6b6$var$ROW_HEIGHT_PX);
        t7 = Math.min($57299e02d73bd6b6$var$MAX_LIST_ITEMS, Math.max(1, fit));
    }
    const maxVisibleTotal = t7;
    const maxVisibleSkills = onViewAllSkills ? maxVisibleTotal - 1 : maxVisibleTotal;
    let t8;
    if ($[10] !== filteredItems || $[11] !== maxVisibleSkills) {
        t8 = filteredItems.slice(0, maxVisibleSkills);
        $[10] = filteredItems;
        $[11] = maxVisibleSkills;
        $[12] = t8;
    } else t8 = $[12];
    const visibleSkillItems = t8;
    let t9;
    bb1: {
        if (onViewAllSkills && visibleSkillItems.length > 0) {
            let t10;
            if ($[13] !== viewAllPlaceholderItem || $[14] !== visibleSkillItems) {
                t10 = [
                    ...visibleSkillItems,
                    viewAllPlaceholderItem
                ];
                $[13] = viewAllPlaceholderItem;
                $[14] = visibleSkillItems;
                $[15] = t10;
            } else t10 = $[15];
            t9 = t10;
            break bb1;
        }
        t9 = visibleSkillItems;
    }
    const listItems = t9;
    let t10;
    let t11;
    if ($[16] !== sendAnalyticsEvent) {
        t10 = ()=>{
            sendAnalyticsEvent({
                eventType: "screen",
                name: "rovoChatPromptTypeAhead"
            });
        };
        t11 = [
            sendAnalyticsEvent
        ];
        $[16] = sendAnalyticsEvent;
        $[17] = t10;
        $[18] = t11;
    } else {
        t10 = $[17];
        t11 = $[18];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[19] !== isFullscreen) {
        t12 = ()=>{
            if (isFullscreen) return;
            const el = wrapperRef.current;
            if (!el) return;
            const observer = new ResizeObserver((entries)=>{
                const entry = entries[0];
                if (entry) setWrapperHeight(entry.contentRect.height);
            });
            observer.observe(el);
            return ()=>observer.disconnect();
        };
        t13 = [
            isFullscreen
        ];
        $[19] = isFullscreen;
        $[20] = t12;
        $[21] = t13;
    } else {
        t12 = $[20];
        t13 = $[21];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            setSelectedIndex(-1);
            setHoveredIndex(null);
        };
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== searchQuery) {
        t15 = [
            searchQuery
        ];
        $[23] = searchQuery;
        $[24] = t15;
    } else t15 = $[24];
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    let t17;
    if ($[25] !== listItems.length) {
        t16 = ()=>{
            if (listItems.length === 0) {
                setSelectedIndex(-1);
                setHoveredIndex(null);
            }
        };
        t17 = [
            listItems.length
        ];
        $[25] = listItems.length;
        $[26] = t16;
        $[27] = t17;
    } else {
        t16 = $[26];
        t17 = $[27];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[28] !== listItems || $[29] !== onSelectItem || $[30] !== onViewAllSkills) {
        t18 = (index)=>{
            const item = listItems[index];
            if (item.id === $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID) onViewAllSkills?.();
            else onSelectItem(item);
        };
        $[28] = listItems;
        $[29] = onSelectItem;
        $[30] = onViewAllSkills;
        $[31] = t18;
    } else t18 = $[31];
    const handleSelectIndex = t18;
    let t19;
    let t20;
    if ($[32] !== handleSelectIndex || $[33] !== listItems || $[34] !== onDismiss || $[35] !== onViewAllSkills || $[36] !== selectedIndex) {
        t19 = ()=>{
            const handleKeyDown = (event)=>{
                if (listItems.length === 0) return;
                if ((event.metaKey || event.ctrlKey) && event.key >= "1" && event.key <= "9") {
                    const index_0 = parseInt(event.key, 10) - 1;
                    if (index_0 < listItems.length) {
                        event.preventDefault();
                        event.stopPropagation();
                        handleSelectIndex(index_0);
                    } else if (event.key === "9" && listItems.length > 0 && listItems[listItems.length - 1].id === $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID) {
                        event.preventDefault();
                        event.stopPropagation();
                        onViewAllSkills?.();
                    }
                    return;
                }
                if (event.key === "ArrowDown") {
                    event.preventDefault();
                    event.stopPropagation();
                    setSelectedIndex((prev)=>prev < listItems.length - 1 ? prev + 1 : 0);
                } else if (event.key === "ArrowUp") {
                    event.preventDefault();
                    event.stopPropagation();
                    setSelectedIndex((prev_0)=>prev_0 > 0 ? prev_0 - 1 : listItems.length - 1);
                } else {
                    if (event.key === "Enter" && selectedIndex >= 0) {
                        event.preventDefault();
                        event.stopPropagation();
                        handleSelectIndex(selectedIndex);
                    } else if (event.key === "Escape") {
                        event.stopPropagation();
                        setSelectedIndex(-1);
                        onDismiss?.();
                    }
                }
            };
            return (0, $cbY7C.bind)(document, {
                type: "keydown",
                listener: handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        t20 = [
            listItems,
            selectedIndex,
            handleSelectIndex,
            onViewAllSkills,
            onDismiss
        ];
        $[32] = handleSelectIndex;
        $[33] = listItems;
        $[34] = onDismiss;
        $[35] = onViewAllSkills;
        $[36] = selectedIndex;
        $[37] = t19;
        $[38] = t20;
    } else {
        t19 = $[37];
        t20 = $[38];
    }
    (0, $cozmU.useEffect)(t19, t20);
    const t21 = isFullscreen ? $57299e02d73bd6b6$var$listStyles.wrapperFullscreen : $57299e02d73bd6b6$var$listStyles.wrapper;
    let t22;
    if ($[39] !== title) {
        t22 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $57299e02d73bd6b6$var$listStyles.titleSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium",
            color: "color.text.subtle"
        }, title));
        $[39] = title;
        $[40] = t22;
    } else t22 = $[40];
    const t23 = isFullscreen ? $57299e02d73bd6b6$var$listStyles.itemsListFullscreen : $57299e02d73bd6b6$var$listStyles.itemsList;
    let t24;
    if ($[41] !== handleSelectIndex || $[42] !== hoveredIndex || $[43] !== listItems || $[44] !== onItemHover || $[45] !== renderHoverCardContent || $[46] !== selectedIndex) {
        t24 = listItems.length > 0 && listItems.map((item_0, index_1)=>{
            const isViewAll = item_0.id === $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID;
            const isSkillRow = !isViewAll;
            const isSelected = index_1 === selectedIndex;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57299e02d73bd6b6$var$ItemRow, {
                item: item_0,
                isSelected: isSelected,
                shortcutLabel: isViewAll ? $57299e02d73bd6b6$var$getShortcutLabel(8) : $57299e02d73bd6b6$var$getShortcutLabel(index_1),
                onClick: ()=>handleSelectIndex(index_1),
                onHover: isSkillRow ? onItemHover : undefined,
                isViewAll: isViewAll,
                isHoveredFromParent: isSkillRow && renderHoverCardContent ? hoveredIndex === index_1 : undefined
            });
            const wrapped = isSkillRow && renderHoverCardContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                onMouseEnter: ()=>setHoveredIndex(index_1),
                onMouseLeave: ()=>setHoveredIndex(null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGEnS.HoverCard), {
                content: renderHoverCardContent(item_0),
                placement: "left",
                fallbackPlacements: [
                    "right",
                    "bottom",
                    "top"
                ],
                testId: `auto-suggest-item-${item_0.id}--hovercard`
            }, row)) : row;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                key: item_0.id
            }, wrapped);
        });
        $[41] = handleSelectIndex;
        $[42] = hoveredIndex;
        $[43] = listItems;
        $[44] = onItemHover;
        $[45] = renderHoverCardContent;
        $[46] = selectedIndex;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== t23 || $[49] !== t24 || $[50] !== title) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $57299e02d73bd6b6$var$listStyles.itemsContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t23,
            role: "listbox",
            "aria-label": title
        }, t24));
        $[48] = t23;
        $[49] = t24;
        $[50] = title;
        $[51] = t25;
    } else t25 = $[51];
    let t26;
    if ($[52] !== t21 || $[53] !== t22 || $[54] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: wrapperRef,
            xcss: t21,
            testId: "auto-suggest-skills-screen"
        }, t22, t25);
        $[52] = t21;
        $[53] = t22;
        $[54] = t25;
        $[55] = t26;
    } else t26 = $[55];
    return t26;
} : ({ items: items, searchQuery: searchQuery, onSelectItem: onSelectItem, onDismiss: onDismiss, onItemHover: onItemHover, onViewAllSkills: onViewAllSkills, renderHoverCardContent: renderHoverCardContent, layout: layout = 'sidebar' })=>{
    const isFullscreen = layout === 'fullscreen';
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const title = formatMessage((0, $l0ley.messages).title);
    const viewAllPlaceholderItem = (0, $cozmU.useMemo)(()=>({
            id: $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID,
            name: formatMessage((0, $l0ley.messages).viewAllSkills),
            description: undefined,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5LaW))), {
                label: ""
            })
        }), [
        formatMessage
    ]);
    const [selectedIndex, setSelectedIndex] = (0, $cozmU.useState)(-1);
    const [hoveredIndex, setHoveredIndex] = (0, $cozmU.useState)(null);
    const [wrapperHeight, setWrapperHeight] = (0, $cozmU.useState)(null);
    const wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const filteredItems = (0, $cozmU.useMemo)(()=>$57299e02d73bd6b6$var$filterItems(items, searchQuery), [
        items,
        searchQuery
    ]);
    const maxVisibleTotal = (0, $cozmU.useMemo)(()=>{
        if (isFullscreen) return $57299e02d73bd6b6$var$MAX_FULLSCREEN_SKILLS;
        if (wrapperHeight == null) return $57299e02d73bd6b6$var$MAX_LIST_ITEMS;
        const fit = Math.floor(wrapperHeight / $57299e02d73bd6b6$var$ROW_HEIGHT_PX);
        return Math.min($57299e02d73bd6b6$var$MAX_LIST_ITEMS, Math.max(1, fit));
    }, [
        wrapperHeight,
        isFullscreen
    ]);
    const maxVisibleSkills = onViewAllSkills ? maxVisibleTotal - 1 : maxVisibleTotal;
    const visibleSkillItems = (0, $cozmU.useMemo)(()=>filteredItems.slice(0, maxVisibleSkills), [
        filteredItems,
        maxVisibleSkills
    ]);
    const listItems = (0, $cozmU.useMemo)(()=>{
        if (onViewAllSkills && visibleSkillItems.length > 0) return [
            ...visibleSkillItems,
            viewAllPlaceholderItem
        ];
        return visibleSkillItems;
    }, [
        visibleSkillItems,
        onViewAllSkills,
        viewAllPlaceholderItem
    ]);
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatPromptTypeAhead'
        });
    }, [
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isFullscreen) return;
        const el = wrapperRef.current;
        if (!el) return;
        const observer = new ResizeObserver((entries)=>{
            const entry = entries[0];
            if (entry) setWrapperHeight(entry.contentRect.height);
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        isFullscreen
    ]);
    (0, $cozmU.useEffect)(()=>{
        setSelectedIndex(-1);
        setHoveredIndex(null);
    }, [
        searchQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (listItems.length === 0) {
            setSelectedIndex(-1);
            setHoveredIndex(null);
        }
    }, [
        listItems.length
    ]);
    const handleSelectIndex = (0, $cozmU.useCallback)((index)=>{
        const item = listItems[index];
        if (item.id === $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID) onViewAllSkills?.();
        else onSelectItem(item);
    }, [
        listItems,
        onSelectItem,
        onViewAllSkills
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (listItems.length === 0) return;
            if ((event.metaKey || event.ctrlKey) && event.key >= '1' && event.key <= '9') {
                const index_0 = parseInt(event.key, 10) - 1;
                if (index_0 < listItems.length) {
                    event.preventDefault();
                    event.stopPropagation();
                    handleSelectIndex(index_0);
                } else if (event.key === '9' && listItems.length > 0 && listItems[listItems.length - 1].id === $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID) {
                    event.preventDefault();
                    event.stopPropagation();
                    onViewAllSkills?.();
                }
                return;
            }
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                event.stopPropagation();
                setSelectedIndex((prev)=>prev < listItems.length - 1 ? prev + 1 : 0);
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                event.stopPropagation();
                setSelectedIndex((prev_0)=>prev_0 > 0 ? prev_0 - 1 : listItems.length - 1);
            } else if (event.key === 'Enter' && selectedIndex >= 0) {
                event.preventDefault();
                event.stopPropagation();
                handleSelectIndex(selectedIndex);
            } else if (event.key === 'Escape') {
                event.stopPropagation();
                setSelectedIndex(-1);
                onDismiss?.();
            }
        };
        return (0, $cbY7C.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
    }, [
        listItems,
        selectedIndex,
        handleSelectIndex,
        onViewAllSkills,
        onDismiss
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef,
        xcss: isFullscreen ? $57299e02d73bd6b6$var$listStyles.wrapperFullscreen : $57299e02d73bd6b6$var$listStyles.wrapper,
        testId: "auto-suggest-skills-screen"
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57299e02d73bd6b6$var$listStyles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $57299e02d73bd6b6$var$listStyles.itemsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isFullscreen ? $57299e02d73bd6b6$var$listStyles.itemsListFullscreen : $57299e02d73bd6b6$var$listStyles.itemsList,
        role: "listbox",
        "aria-label": title
    }, listItems.length > 0 && listItems.map((item_0, index_1)=>{
        const isViewAll = item_0.id === $57299e02d73bd6b6$var$VIEW_ALL_SKILLS_ID;
        const isSkillRow = !isViewAll;
        const isSelected = index_1 === selectedIndex;
        const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57299e02d73bd6b6$var$ItemRow, {
            item: item_0,
            isSelected: isSelected,
            shortcutLabel: isViewAll ? $57299e02d73bd6b6$var$getShortcutLabel(8) : $57299e02d73bd6b6$var$getShortcutLabel(index_1),
            onClick: ()=>handleSelectIndex(index_1),
            onHover: isSkillRow ? onItemHover : undefined,
            isViewAll: isViewAll,
            isHoveredFromParent: isSkillRow && renderHoverCardContent ? hoveredIndex === index_1 : undefined
        });
        const wrapped = isSkillRow && renderHoverCardContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: ()=>setHoveredIndex(index_1),
            onMouseLeave: ()=>setHoveredIndex(null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGEnS.HoverCard), {
            content: renderHoverCardContent(item_0),
            placement: "left",
            fallbackPlacements: [
                'right',
                'bottom',
                'top'
            ],
            testId: `auto-suggest-item-${item_0.id}--hovercard`
        }, row)) : row;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: item_0.id
        }, wrapped);
    }))));
};
function $57299e02d73bd6b6$var$_temp(event) {
    return event.preventDefault();
}



// Rovo Spaces experiment never pay the bundle cost.
const $6935ff72f1e18294$var$AutoSuggestFloatingMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("gJYG3")).then((m)=>({
            default: m.AutoSuggestFloatingMenu
        })));
const $6935ff72f1e18294$var$overlayStyles = {
    overlay: "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _3OE6xYdnbC _4bt5LAnQyn _2WAcuGnQyn _1pp6NdYbGa _42Yu6B7dHp",
    overlayFloating: "_1mT5xdWVPG _2IhTondnbC _4ApkO25zaO _0Bm75GgVvo _3OE6xY5zaO _1pp6NdYbGa _42Yu6B7dHp _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuz9WS",
    overlayFloatingFullscreen: "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _3OE6xYdnbC _0Of8r25zaO _1pp6NdYbGa _42Yu6B7dHp _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
    overlayFullscreen: "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _3OE6xYdnbC _0jFU0VIZbP _0NUa3rnHzY _4bt5LAnQyn _2WAcuGIZbP _1pp6NdIZbP _42Yu6B7dHp",
    fullscreenContainer: "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _3OE6xYdnbC _0Bm75GdnbC _0KLXrulfZc _1pp6NdIZbP _42Yu6B7dHp",
    panel: "_0jFU0VN91d _39xV02N91d _0KLXrulfZc _1pp6NdIZbP",
    panelFullscreen: "_39xV02N91d _1EqgXl1btN _2XsHFMIZbP _0adFHsIZbP _1pp6NdIZbP _4bt5LAYvD1 _2WAcuGYvD1 _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE"
};
const $6935ff72f1e18294$var$SkillIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { iconName: iconName, iconColor: iconColor } = t0;
    const IconComponent = iconName && iconName in (0, $9MCKh.skillIconMap) ? (0, $9MCKh.skillIconMap)[iconName] : (0, $9MCKh.DefaultSkillIcon);
    let t1;
    if ($[0] !== iconColor) {
        t1 = iconColor && {
            color: iconColor
        };
        $[0] = iconColor;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== IconComponent || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            label: "",
            ...t1
        });
        $[2] = IconComponent;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ iconName: iconName, iconColor: iconColor })=>{
    const IconComponent = iconName && iconName in (0, $9MCKh.skillIconMap) ? (0, $9MCKh.skillIconMap)[iconName] : (0, $9MCKh.DefaultSkillIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        label: "",
        ...iconColor && {
            color: iconColor
        }
    });
};
const $6935ff72f1e18294$var$SkillsContentRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkillsContentRenderer(t0) {
    const $ = (0, $bDgLe.c)(65);
    const { skillsResponse: skillsResponse, siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProviderProp, searchQuery: searchQuery, debouncedSearchQuery: debouncedSearchQuery, isSlideVisible: isSlideVisible, isSpacesEnabled: isSpacesEnabled, onSelectSkill: onSelectSkill, onSelectSpace: onSelectSpace, onViewAllSkills: onViewAllSkills, onDismiss: onDismiss, onSkillsLoaded: onSkillsLoaded, layout: layout, experienceName: experienceName } = t0;
    if (skillsResponse) {
        if ("error" in skillsResponse && skillsResponse.error) {
            const err = skillsResponse.error;
            const errExtensions = err.extensions ? `[${err.extensions?.map($6935ff72f1e18294$var$_temp)?.join(", ")}] ` : "";
            throw new Error(err.message || errExtensions ? `${errExtensions}${err.message}` : "Failed to load skills");
        }
        if ("errors" in skillsResponse && skillsResponse.errors && skillsResponse.errors.length > 0) {
            const errorMessages = skillsResponse.errors.map($6935ff72f1e18294$var$_temp2).join(", ");
            throw new Error(errorMessages || "Failed to load skills");
        }
    }
    skillsResponse?.edges;
    const t1 = skillsResponse?.edges ?? null;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $f6VI9.parseUniversalSkillEdges)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const skills = t2;
    let t3;
    if ($[2] !== skills) {
        t3 = new Map(skills.map($6935ff72f1e18294$var$_temp3));
        $[2] = skills;
        $[3] = t3;
    } else t3 = $[3];
    const skillSlugMap = t3;
    const t4 = product ?? "";
    const t5 = experienceId ?? "";
    const t6 = !isSpacesEnabled || !product || !experienceId;
    let t7;
    if ($[4] !== debouncedSearchQuery || $[5] !== siteId || $[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
        t7 = {
            cloudId: siteId,
            product: t4,
            experienceId: t5,
            searchQuery: debouncedSearchQuery,
            skip: t6
        };
        $[4] = debouncedSearchQuery;
        $[5] = siteId;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const { spaces: spaces } = (0, $ff1a6e6cc93a8de4$export$1e7662bb7b25ce15)(t7);
    let t8;
    if ($[10] !== spaces) {
        t8 = new Map(spaces.map($6935ff72f1e18294$var$_temp4));
        $[10] = spaces;
        $[11] = t8;
    } else t8 = $[11];
    const spaceIdMap = t8;
    let t9;
    if ($[12] !== emojiProviderProp || $[13] !== isSpacesEnabled || $[14] !== siteId) {
        t9 = isSpacesEnabled ? emojiProviderProp ?? (0, $d26Wq.createEmojiProvider)(siteId) : undefined;
        $[12] = emojiProviderProp;
        $[13] = isSpacesEnabled;
        $[14] = siteId;
        $[15] = t9;
    } else t9 = $[15];
    const emojiProvider = t9;
    let t10;
    if ($[16] !== skills) {
        t10 = skills.map($6935ff72f1e18294$var$_temp5);
        $[16] = skills;
        $[17] = t10;
    } else t10 = $[17];
    const skillItems = t10;
    let t11;
    if ($[18] !== isSpacesEnabled || $[19] !== skills || $[20] !== spaces) {
        t11 = [
            ...skills.map($6935ff72f1e18294$var$_temp6),
            ...isSpacesEnabled ? spaces.map($6935ff72f1e18294$var$_temp7) : []
        ];
        $[18] = isSpacesEnabled;
        $[19] = skills;
        $[20] = spaces;
        $[21] = t11;
    } else t11 = $[21];
    const floatingMenuItems = t11;
    let t12;
    if ($[22] !== onSelectSkill || $[23] !== skillSlugMap) {
        t12 = (item)=>{
            const skill_1 = skillSlugMap.get(item.id);
            if (skill_1) onSelectSkill(skill_1);
        };
        $[22] = onSelectSkill;
        $[23] = skillSlugMap;
        $[24] = t12;
    } else t12 = $[24];
    const onSelectSkillItem = t12;
    let t13;
    if ($[25] !== onSelectSkill || $[26] !== onSelectSpace || $[27] !== skillSlugMap || $[28] !== spaceIdMap) {
        t13 = (item_0)=>{
            if (item_0.kind === "space") {
                const space_0 = spaceIdMap.get(item_0.id);
                if (space_0) onSelectSpace(space_0);
                return;
            }
            const skill_2 = skillSlugMap.get(item_0.id);
            if (skill_2) onSelectSkill(skill_2);
        };
        $[25] = onSelectSkill;
        $[26] = onSelectSpace;
        $[27] = skillSlugMap;
        $[28] = spaceIdMap;
        $[29] = t13;
    } else t13 = $[29];
    const onSelectFloatingMenuItem = t13;
    let t14;
    if ($[30] !== skillSlugMap) {
        t14 = (item_1)=>{
            const skill_3 = skillSlugMap.get(item_1.id);
            if (!skill_3) return null;
            const { slug: _slug, ...skillContentProps } = skill_3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80Hjq.SkillHoverCardContent), skillContentProps);
        };
        $[30] = skillSlugMap;
        $[31] = t14;
    } else t14 = $[31];
    const renderHoverCardContent = t14;
    let t15;
    bb0: {
        const sourceItems = isSpacesEnabled ? floatingMenuItems : skillItems;
        if (!searchQuery.trim()) {
            t15 = sourceItems.length > 0;
            break bb0;
        }
        let t16;
        if ($[32] !== searchQuery || $[33] !== sourceItems) {
            const search = searchQuery.toLowerCase();
            t16 = sourceItems.some((item_2)=>item_2.name.toLowerCase().includes(search) || (item_2.description?.toLowerCase().includes(search) ?? false));
            $[32] = searchQuery;
            $[33] = sourceItems;
            $[34] = t16;
        } else t16 = $[34];
        t15 = t16;
    }
    const hasItems = t15;
    let t16;
    let t17;
    if ($[35] !== hasItems || $[36] !== onSkillsLoaded) {
        t16 = ()=>{
            onSkillsLoaded?.({
                hasItems: hasItems
            });
        };
        t17 = [
            hasItems,
            onSkillsLoaded
        ];
        $[35] = hasItems;
        $[36] = onSkillsLoaded;
        $[37] = t16;
        $[38] = t17;
    } else {
        t16 = $[37];
        t17 = $[38];
    }
    (0, $cozmU.useEffect)(t16, t17);
    if (!isSlideVisible) return null;
    const isFullscreen = layout === "fullscreen";
    if (isSpacesEnabled) {
        let t18;
        if ($[39] !== experienceName) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
                name: experienceName
            });
            $[39] = experienceName;
            $[40] = t18;
        } else t18 = $[40];
        let t19;
        if ($[41] !== emojiProvider || $[42] !== floatingMenuItems || $[43] !== layout || $[44] !== onDismiss || $[45] !== onSelectFloatingMenuItem || $[46] !== searchQuery) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$AutoSuggestFloatingMenu, {
                items: floatingMenuItems,
                searchQuery: searchQuery,
                onSelectItem: onSelectFloatingMenuItem,
                onDismiss: onDismiss,
                emojiProvider: emojiProvider,
                layout: layout
            }));
            $[41] = emojiProvider;
            $[42] = floatingMenuItems;
            $[43] = layout;
            $[44] = onDismiss;
            $[45] = onSelectFloatingMenuItem;
            $[46] = searchQuery;
            $[47] = t19;
        } else t19 = $[47];
        let t20;
        if ($[48] !== t18 || $[49] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t18, t19);
            $[48] = t18;
            $[49] = t19;
            $[50] = t20;
        } else t20 = $[50];
        return t20;
    }
    const t18 = isFullscreen ? $6935ff72f1e18294$var$overlayStyles.panelFullscreen : $6935ff72f1e18294$var$overlayStyles.panel;
    let t19;
    if ($[51] !== experienceName) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: experienceName
        });
        $[51] = experienceName;
        $[52] = t19;
    } else t19 = $[52];
    const t20 = isFullscreen ? undefined : onViewAllSkills;
    let t21;
    if ($[53] !== layout || $[54] !== onDismiss || $[55] !== onSelectSkillItem || $[56] !== renderHoverCardContent || $[57] !== searchQuery || $[58] !== skillItems || $[59] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57299e02d73bd6b6$export$7afadbf289b7f123), {
            items: skillItems,
            searchQuery: searchQuery,
            onSelectItem: onSelectSkillItem,
            onDismiss: onDismiss,
            onViewAllSkills: t20,
            renderHoverCardContent: renderHoverCardContent,
            layout: layout
        });
        $[53] = layout;
        $[54] = onDismiss;
        $[55] = onSelectSkillItem;
        $[56] = renderHoverCardContent;
        $[57] = searchQuery;
        $[58] = skillItems;
        $[59] = t20;
        $[60] = t21;
    } else t21 = $[60];
    let t22;
    if ($[61] !== t18 || $[62] !== t19 || $[63] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t18
        }, t19, t21);
        $[61] = t18;
        $[62] = t19;
        $[63] = t21;
        $[64] = t22;
    } else t22 = $[64];
    return t22;
} : function SkillsContentRenderer({ skillsResponse: skillsResponse, siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProviderProp, searchQuery: searchQuery, debouncedSearchQuery: debouncedSearchQuery, isSlideVisible: isSlideVisible, isSpacesEnabled: isSpacesEnabled, onSelectSkill: onSelectSkill, onSelectSpace: onSelectSpace, onViewAllSkills: onViewAllSkills, onDismiss: onDismiss, onSkillsLoaded: onSkillsLoaded, layout: layout, experienceName: experienceName }) {
    if (skillsResponse) {
        // Legacy error format
        if ('error' in skillsResponse && skillsResponse.error) {
            const err = skillsResponse.error;
            const errExtensions = err.extensions ? `[${err.extensions?.map((ext)=>`${ext?.statusCode} - ${ext?.errorType}`)?.join(', ')}] ` : '';
            throw new Error(err.message || errExtensions ? `${errExtensions}${err.message}` : 'Failed to load skills');
        } // Unified skills error format
        if ('errors' in skillsResponse && skillsResponse.errors && skillsResponse.errors.length > 0) {
            const errorMessages = skillsResponse.errors.map((err_0)=>err_0?.message).join(', ');
            throw new Error(errorMessages || 'Failed to load skills');
        }
    }
    const skills = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $f6VI9.parseUniversalSkillEdges)(skillsResponse?.edges ?? null), [
        skillsResponse?.edges
    ]);
    const skillSlugMap = (0, $cozmU.useMemo)(()=>new Map(skills.map((s)=>[
                s.slug,
                s
            ])), [
        skills
    ]); // Spaces are gated separately from skills. When the gate is off we pass
    // `skip: true` so no search request is issued.
    // `debouncedSearchQuery` is debounced by the caller (SkillsContentUnified /
    // SkillsContentLegacy) so a single 300 ms timer covers both this REST call
    // and the Relay skills query — no need to debounce again here.
    const { spaces: spaces } = (0, $ff1a6e6cc93a8de4$export$1e7662bb7b25ce15)({
        cloudId: siteId,
        product: product ?? '',
        experienceId: experienceId ?? '',
        searchQuery: debouncedSearchQuery,
        skip: !isSpacesEnabled || !product || !experienceId
    });
    const spaceIdMap = (0, $cozmU.useMemo)(()=>new Map(spaces.map((s_0)=>[
                s_0.id,
                s_0
            ])), [
        spaces
    ]);
    const emojiProvider = (0, $cozmU.useMemo)(()=>isSpacesEnabled ? emojiProviderProp ?? (0, $d26Wq.createEmojiProvider)(siteId) : undefined, [
        isSpacesEnabled,
        emojiProviderProp,
        siteId
    ]); // Items for the legacy `AutoSuggestScreen` — skills only, no `kind`/`emoji`.
    const skillItems = (0, $cozmU.useMemo)(()=>skills.map((skill)=>({
                id: skill.slug,
                name: skill.name,
                description: skill.description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillIcon, {
                    iconName: skill.iconName,
                    iconColor: (0, $9OqBj.getIconColor)(skill.color)
                })
            })), [
        skills
    ]); // Items for the new floating-menu typeahead — skills + spaces, tagged with
    // `kind` so the menu can render them under separate section headings.
    const floatingMenuItems = (0, $cozmU.useMemo)(()=>[
            ...skills.map((skill_0)=>({
                    id: skill_0.slug,
                    kind: 'skill',
                    name: skill_0.name,
                    description: skill_0.description,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillIcon, {
                        iconName: skill_0.iconName,
                        iconColor: (0, $9OqBj.getIconColor)(skill_0.color)
                    })
                })),
            ...isSpacesEnabled ? spaces.map((space)=>({
                    id: space.id,
                    kind: 'space',
                    name: space.name,
                    description: space.description ?? undefined,
                    emoji: space.emoji ?? undefined,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                        label: "",
                        color: "var(--ds-text-subtlest, #6B6E76)"
                    })
                })) : []
        ], [
        skills,
        spaces,
        isSpacesEnabled
    ]);
    const onSelectSkillItem = (0, $cozmU.useCallback)((item)=>{
        const skill_1 = skillSlugMap.get(item.id);
        if (skill_1) onSelectSkill(skill_1);
    }, [
        skillSlugMap,
        onSelectSkill
    ]);
    const onSelectFloatingMenuItem = (0, $cozmU.useCallback)((item_0)=>{
        if (item_0.kind === 'space') {
            const space_0 = spaceIdMap.get(item_0.id);
            if (space_0) onSelectSpace(space_0);
            return;
        }
        const skill_2 = skillSlugMap.get(item_0.id);
        if (skill_2) onSelectSkill(skill_2);
    }, [
        skillSlugMap,
        spaceIdMap,
        onSelectSkill,
        onSelectSpace
    ]);
    const renderHoverCardContent = (0, $cozmU.useCallback)((item_1)=>{
        const skill_3 = skillSlugMap.get(item_1.id);
        if (!skill_3) return null;
        const { slug: _slug, ...skillContentProps } = skill_3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80Hjq.SkillHoverCardContent), skillContentProps);
    }, [
        skillSlugMap
    ]); // Visibility check considers whichever list will be rendered. When the
    // spaces gate is on, the floating menu surfaces both skills and spaces, so
    // the typeahead stays open if either category matches the current query.
    const hasItems = (0, $cozmU.useMemo)(()=>{
        const sourceItems = isSpacesEnabled ? floatingMenuItems : skillItems;
        if (!searchQuery.trim()) return sourceItems.length > 0;
        const search = searchQuery.toLowerCase();
        return sourceItems.some((item_2)=>item_2.name.toLowerCase().includes(search) || (item_2.description?.toLowerCase().includes(search) ?? false));
    }, [
        floatingMenuItems,
        skillItems,
        isSpacesEnabled,
        searchQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        onSkillsLoaded?.({
            hasItems: hasItems
        });
    }, [
        hasItems,
        onSkillsLoaded
    ]);
    if (!isSlideVisible) return null;
    const isFullscreen = layout === 'fullscreen'; // The floating menu positions itself absolutely within the overlay and
    // must NOT be wrapped in the opaque full-height `panel` div — that div
    // fills the entire overlay with `elevation.surface`, which clips the
    // input's drop-shadow and creates a hard white edge at the menu boundary.
    if (isSpacesEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: experienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$AutoSuggestFloatingMenu, {
        items: floatingMenuItems,
        searchQuery: searchQuery,
        onSelectItem: onSelectFloatingMenuItem,
        onDismiss: onDismiss,
        emojiProvider: emojiProvider,
        layout: layout
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isFullscreen ? $6935ff72f1e18294$var$overlayStyles.panelFullscreen : $6935ff72f1e18294$var$overlayStyles.panel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: experienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57299e02d73bd6b6$export$7afadbf289b7f123), {
        items: skillItems,
        searchQuery: searchQuery,
        onSelectItem: onSelectSkillItem,
        onDismiss: onDismiss,
        onViewAllSkills: isFullscreen ? undefined : onViewAllSkills,
        renderHoverCardContent: renderHoverCardContent,
        layout: layout
    }));
};
function $6935ff72f1e18294$var$_temp7(space) {
    return {
        id: space.id,
        kind: "space",
        name: space.name,
        description: space.description ?? undefined,
        emoji: space.emoji ?? undefined,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)"
        })
    };
}
function $6935ff72f1e18294$var$_temp6(skill_0) {
    return {
        id: skill_0.slug,
        kind: "skill",
        name: skill_0.name,
        description: skill_0.description,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillIcon, {
            iconName: skill_0.iconName,
            iconColor: (0, $9OqBj.getIconColor)(skill_0.color)
        })
    };
}
function $6935ff72f1e18294$var$_temp5(skill) {
    return {
        id: skill.slug,
        name: skill.name,
        description: skill.description,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillIcon, {
            iconName: skill.iconName,
            iconColor: (0, $9OqBj.getIconColor)(skill.color)
        })
    };
}
function $6935ff72f1e18294$var$_temp4(s_0) {
    return [
        s_0.id,
        s_0
    ];
}
function $6935ff72f1e18294$var$_temp3(s) {
    return [
        s.slug,
        s
    ];
}
function $6935ff72f1e18294$var$_temp2(err_0) {
    return err_0?.message;
}
function $6935ff72f1e18294$var$_temp(ext) {
    return `${ext?.statusCode} - ${ext?.errorType}`;
}
const $6935ff72f1e18294$var$SkillsContentLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkillsContentLegacy(t0) {
    const $ = (0, $bDgLe.c)(17);
    const { siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProvider, searchQuery: searchQuery, debouncedSearchQuery: debouncedSearchQuery, isSlideVisible: isSlideVisible, isSpacesEnabled: isSpacesEnabled, onSelectSkill: onSelectSkill, onSelectSpace: onSelectSpace, onViewAllSkills: onViewAllSkills, onDismiss: onDismiss, onSkillsLoaded: onSkillsLoaded, layout: layout, experienceName: experienceName } = t0;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)((0, $e893dcfbbab5e216$export$2e2bcd8739ae039), {
        first: 100,
        cloudId: siteId,
        surface: "ROVO"
    })?.graphIntegration_componentDirectoryItems;
    let t1;
    if ($[0] !== debouncedSearchQuery || $[1] !== emojiProvider || $[2] !== experienceId || $[3] !== experienceName || $[4] !== isSlideVisible || $[5] !== isSpacesEnabled || $[6] !== layout || $[7] !== onDismiss || $[8] !== onSelectSkill || $[9] !== onSelectSpace || $[10] !== onSkillsLoaded || $[11] !== onViewAllSkills || $[12] !== product || $[13] !== searchQuery || $[14] !== siteId || $[15] !== skillsResponse) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentRenderer, {
            skillsResponse: skillsResponse,
            siteId: siteId,
            product: product,
            experienceId: experienceId,
            emojiProvider: emojiProvider,
            searchQuery: searchQuery,
            debouncedSearchQuery: debouncedSearchQuery,
            isSlideVisible: isSlideVisible,
            isSpacesEnabled: isSpacesEnabled,
            onSelectSkill: onSelectSkill,
            onSelectSpace: onSelectSpace,
            onViewAllSkills: onViewAllSkills,
            onDismiss: onDismiss,
            onSkillsLoaded: onSkillsLoaded,
            layout: layout,
            experienceName: experienceName
        });
        $[0] = debouncedSearchQuery;
        $[1] = emojiProvider;
        $[2] = experienceId;
        $[3] = experienceName;
        $[4] = isSlideVisible;
        $[5] = isSpacesEnabled;
        $[6] = layout;
        $[7] = onDismiss;
        $[8] = onSelectSkill;
        $[9] = onSelectSpace;
        $[10] = onSkillsLoaded;
        $[11] = onViewAllSkills;
        $[12] = product;
        $[13] = searchQuery;
        $[14] = siteId;
        $[15] = skillsResponse;
        $[16] = t1;
    } else t1 = $[16];
    return t1;
} : function SkillsContentLegacy({ siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProvider, searchQuery: searchQuery, debouncedSearchQuery: debouncedSearchQuery, isSlideVisible: isSlideVisible, isSpacesEnabled: isSpacesEnabled, onSelectSkill: onSelectSkill, onSelectSpace: onSelectSpace, onViewAllSkills: onViewAllSkills, onDismiss: onDismiss, onSkillsLoaded: onSkillsLoaded, layout: layout, experienceName: experienceName }) {
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseSkillEdges */ (0, $e893dcfbbab5e216$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: 100,
        cloudId: siteId,
        surface: 'ROVO'
    })?.graphIntegration_componentDirectoryItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentRenderer, {
        skillsResponse: skillsResponse,
        siteId: siteId,
        product: product,
        experienceId: experienceId,
        emojiProvider: emojiProvider,
        searchQuery: searchQuery,
        debouncedSearchQuery: debouncedSearchQuery,
        isSlideVisible: isSlideVisible,
        isSpacesEnabled: isSpacesEnabled,
        onSelectSkill: onSelectSkill,
        onSelectSpace: onSelectSpace,
        onViewAllSkills: onViewAllSkills,
        onDismiss: onDismiss,
        onSkillsLoaded: onSkillsLoaded,
        layout: layout,
        experienceName: experienceName
    });
};
const $6935ff72f1e18294$var$SkillsContentUnified = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkillsContentUnified(t0) {
    const $ = (0, $bDgLe.c)(20);
    const { siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProvider, searchQuery: searchQuery, debouncedSearchQuery: debouncedSearchQuery, isSlideVisible: isSlideVisible, isSpacesEnabled: isSpacesEnabled, onSelectSkill: onSelectSkill, onSelectSpace: onSelectSpace, onViewAllSkills: onViewAllSkills, onDismiss: onDismiss, onSkillsLoaded: onSkillsLoaded, layout: layout, experienceName: experienceName } = t0;
    let t1;
    if ($[0] !== debouncedSearchQuery || $[1] !== isSpacesEnabled) {
        t1 = isSpacesEnabled ? debouncedSearchQuery.trim().length > 0 ? debouncedSearchQuery.trim() : null : null;
        $[0] = debouncedSearchQuery;
        $[1] = isSpacesEnabled;
        $[2] = t1;
    } else t1 = $[2];
    const debouncedKeyword = t1;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)((0, $2990500f18e1130a$export$2e2bcd8739ae039), {
        first: 100,
        cloudId: siteId,
        searchKeyword: debouncedKeyword,
        shouldFetch: true
    })?.convoai_availableSkills;
    let t2;
    if ($[3] !== debouncedSearchQuery || $[4] !== emojiProvider || $[5] !== experienceId || $[6] !== experienceName || $[7] !== isSlideVisible || $[8] !== isSpacesEnabled || $[9] !== layout || $[10] !== onDismiss || $[11] !== onSelectSkill || $[12] !== onSelectSpace || $[13] !== onSkillsLoaded || $[14] !== onViewAllSkills || $[15] !== product || $[16] !== searchQuery || $[17] !== siteId || $[18] !== skillsResponse) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentRenderer, {
            skillsResponse: skillsResponse,
            siteId: siteId,
            product: product,
            experienceId: experienceId,
            emojiProvider: emojiProvider,
            searchQuery: searchQuery,
            debouncedSearchQuery: debouncedSearchQuery,
            isSlideVisible: isSlideVisible,
            isSpacesEnabled: isSpacesEnabled,
            onSelectSkill: onSelectSkill,
            onSelectSpace: onSelectSpace,
            onViewAllSkills: onViewAllSkills,
            onDismiss: onDismiss,
            onSkillsLoaded: onSkillsLoaded,
            layout: layout,
            experienceName: experienceName
        });
        $[3] = debouncedSearchQuery;
        $[4] = emojiProvider;
        $[5] = experienceId;
        $[6] = experienceName;
        $[7] = isSlideVisible;
        $[8] = isSpacesEnabled;
        $[9] = layout;
        $[10] = onDismiss;
        $[11] = onSelectSkill;
        $[12] = onSelectSpace;
        $[13] = onSkillsLoaded;
        $[14] = onViewAllSkills;
        $[15] = product;
        $[16] = searchQuery;
        $[17] = siteId;
        $[18] = skillsResponse;
        $[19] = t2;
    } else t2 = $[19];
    return t2;
} : function SkillsContentUnified({ siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProvider, searchQuery: searchQuery, debouncedSearchQuery: debouncedSearchQuery, isSlideVisible: isSlideVisible, isSpacesEnabled: isSpacesEnabled, onSelectSkill: onSelectSkill, onSelectSpace: onSelectSpace, onViewAllSkills: onViewAllSkills, onDismiss: onDismiss, onSkillsLoaded: onSkillsLoaded, layout: layout, experienceName: experienceName }) {
    // When the spaces gate is off we fall back to AutoSuggestScreen which
    // filters client-side, so pass null as searchKeyword to avoid a network
    // request per keystroke. When the gate is on, use the debounced value
    // (already computed by the caller) for server-side filtering.
    const debouncedKeyword = isSpacesEnabled ? debouncedSearchQuery.trim().length > 0 ? debouncedSearchQuery.trim() : null : null;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseUniversalSkillEdges */ (0, $2990500f18e1130a$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: 100,
        cloudId: siteId,
        searchKeyword: debouncedKeyword,
        shouldFetch: true
    })?.convoai_availableSkills;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentRenderer, {
        skillsResponse: skillsResponse,
        siteId: siteId,
        product: product,
        experienceId: experienceId,
        emojiProvider: emojiProvider,
        searchQuery: searchQuery,
        debouncedSearchQuery: debouncedSearchQuery,
        isSlideVisible: isSlideVisible,
        isSpacesEnabled: isSpacesEnabled,
        onSelectSkill: onSelectSkill,
        onSelectSpace: onSelectSpace,
        onViewAllSkills: onViewAllSkills,
        onDismiss: onDismiss,
        onSkillsLoaded: onSkillsLoaded,
        layout: layout,
        experienceName: experienceName
    });
};
const $6935ff72f1e18294$var$SkillsContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkillsContent(props) {
    const $ = (0, $bDgLe.c)(7);
    const [debouncedSearchQuery] = (0, $jXPru.default)(props.searchQuery, 300);
    let t0;
    if ($[0] !== debouncedSearchQuery || $[1] !== props) {
        t0 = {
            ...props,
            debouncedSearchQuery: debouncedSearchQuery
        };
        $[0] = debouncedSearchQuery;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const propsWithDebounce = t0;
    if ((0, $iDrrr.fg)("rovo_chat_unified_skills_agg")) {
        let t1;
        if ($[3] !== propsWithDebounce) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentUnified, propsWithDebounce);
            $[3] = propsWithDebounce;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    let t1;
    if ($[5] !== propsWithDebounce) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentLegacy, propsWithDebounce);
        $[5] = propsWithDebounce;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function SkillsContent(props) {
    // Debounce once here so both SkillsContentLegacy (spaces REST search) and
    // SkillsContentUnified (Relay skills query) share a single 300 ms timer
    // rather than each maintaining their own independent debounce.
    const [debouncedSearchQuery] = (0, $jXPru.default)(props.searchQuery, 300);
    const propsWithDebounce = {
        ...props,
        debouncedSearchQuery: debouncedSearchQuery
    };
    if ((0, $iDrrr.fg)('rovo_chat_unified_skills_agg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentUnified, propsWithDebounce);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContentLegacy, propsWithDebounce);
};
const $6935ff72f1e18294$export$688cd78731269cac = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AutoSuggestSkills(t0) {
    const $ = (0, $bDgLe.c)(54);
    const { searchQuery: searchQuery, siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProvider, onViewAllSkills: onViewAllSkills, onVisibleChange: onVisibleChange, onDismissHandle: onDismissHandle, layout: t1 } = t0;
    const layout = t1 === undefined ? "sidebar" : t1;
    const [, t2] = (0, $iDlFY.usePlaceholderStore)();
    const { setPlaceholder: setPlaceholder } = t2;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { setSelectedSpace: setSelectedSpace, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const [hasItems, setHasItems] = (0, $cozmU.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] !== searchQuery) {
        t3 = searchQuery.trim();
        $[0] = searchQuery;
        $[1] = t3;
    } else t3 = $[1];
    const isQueryActive = t3.length > 0;
    const isSlideVisible = hasItems && !isDismissed && isQueryActive;
    const prevSlideVisibleRef = (0, $cozmU.useRef)(isSlideVisible);
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsDismissed(true);
        $[2] = t4;
    } else t4 = $[2];
    const dismiss = t4;
    let t5;
    let t6;
    if ($[3] !== onDismissHandle) {
        t5 = ()=>{
            if (!onDismissHandle) return;
            onDismissHandle({
                dismiss: dismiss
            });
            return ()=>{
                onDismissHandle(null);
            };
        };
        t6 = [
            onDismissHandle,
            dismiss
        ];
        $[3] = onDismissHandle;
        $[4] = t5;
        $[5] = t6;
    } else {
        t5 = $[4];
        t6 = $[5];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const prevSearchQueryRef = (0, $cozmU.useRef)(searchQuery);
    let t7;
    let t8;
    if ($[6] !== searchQuery) {
        t7 = ()=>{
            const prev = prevSearchQueryRef.current;
            prevSearchQueryRef.current = searchQuery;
            if (searchQuery.trim().length > 0 && searchQuery !== prev) setIsDismissed(false);
        };
        t8 = [
            searchQuery
        ];
        $[6] = searchQuery;
        $[7] = t7;
        $[8] = t8;
    } else {
        t7 = $[7];
        t8 = $[8];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[9] !== isSlideVisible || $[10] !== onVisibleChange) {
        t9 = ()=>{
            if (prevSlideVisibleRef.current !== isSlideVisible) {
                prevSlideVisibleRef.current = isSlideVisible;
                onVisibleChange?.(isSlideVisible);
            }
        };
        t10 = [
            isSlideVisible,
            onVisibleChange
        ];
        $[9] = isSlideVisible;
        $[10] = onVisibleChange;
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (payload)=>{
            setHasItems(payload.hasItems);
        };
        $[13] = t11;
    } else t11 = $[13];
    const handleSkillsLoaded = t11;
    let t12;
    if ($[14] !== onViewAllSkills) {
        t12 = ()=>{
            setIsDismissed(true);
            onViewAllSkills();
        };
        $[14] = onViewAllSkills;
        $[15] = t12;
    } else t12 = $[15];
    const handleViewAllSkills = t12;
    let t13;
    if ($[16] !== sendAnalyticsEvent || $[17] !== setAnalyticsPropertiesWithoutRerender || $[18] !== setPlaceholder) {
        t13 = (skill)=>{
            setIsDismissed(true);
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "rovoChatSkillSelected",
                attributes: {
                    slashCommand: skill.slug,
                    skillProductKey: skill.product,
                    skillSelectionSource: "autoSuggest"
                }
            });
            setAnalyticsPropertiesWithoutRerender({
                skillSelectionSource: "autoSuggest"
            });
            setPlaceholder({
                prompt: "",
                adfDocument: (0, $8lhhf.createSkillAdf)(skill),
                type: "generic",
                selectionStartIndex: 3,
                selectionEndIndex: 3,
                insertAtCursor: false
            });
        };
        $[16] = sendAnalyticsEvent;
        $[17] = setAnalyticsPropertiesWithoutRerender;
        $[18] = setPlaceholder;
        $[19] = t13;
    } else t13 = $[19];
    const handleSelectSkill = t13;
    let t14;
    if ($[20] !== sendAnalyticsEvent || $[21] !== setActiveMenu || $[22] !== setSelectedSpace) {
        t14 = (space)=>{
            setIsDismissed(true);
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "rovoChatSpaceSelected",
                attributes: {
                    spaceId: space.id,
                    spaceSelectionSource: "autoSuggest"
                }
            });
            setSelectedSpace({
                id: space.id,
                name: space.name,
                emoji: space.emoji ?? undefined,
                entryPoint: "typeahead"
            });
            setActiveMenu("space-landing");
        };
        $[20] = sendAnalyticsEvent;
        $[21] = setActiveMenu;
        $[22] = setSelectedSpace;
        $[23] = t14;
    } else t14 = $[23];
    const handleSelectSpace = t14;
    let t15;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setIsDismissed(true);
        };
        $[24] = t15;
    } else t15 = $[24];
    const handleClose = t15;
    const [experienceName] = (0, $cozmU.useState)($6935ff72f1e18294$var$_temp8);
    let t16;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false);
        $[25] = t16;
    } else t16 = $[25];
    const isSpacesEnabledOuter = t16;
    const t17 = layout === "sidebar" ? isSpacesEnabledOuter ? $6935ff72f1e18294$var$overlayStyles.overlayFloating : $6935ff72f1e18294$var$overlayStyles.overlay : isSpacesEnabledOuter ? $6935ff72f1e18294$var$overlayStyles.overlayFloatingFullscreen : $6935ff72f1e18294$var$overlayStyles.overlayFullscreen;
    let t18;
    if ($[26] !== experienceName) {
        t18 = (t19)=>{
            const { error: error } = t19;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                name: experienceName,
                error: error instanceof Error ? error : new Error(String(error))
            });
        };
        $[26] = experienceName;
        $[27] = t18;
    } else t18 = $[27];
    let t19;
    if ($[28] !== siteId) {
        t19 = (error_0)=>{
            (0, $hlvTd.logException)({
                exception: error_0,
                name: "autoSuggestSkillsRelay",
                tags: {
                    siteId: siteId
                }
            });
            handleClose();
        };
        $[28] = siteId;
        $[29] = t19;
    } else t19 = $[29];
    let t20;
    if ($[30] !== experienceName) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: experienceName
        });
        $[30] = experienceName;
        $[31] = t20;
    } else t20 = $[31];
    let t21;
    if ($[32] !== emojiProvider || $[33] !== experienceId || $[34] !== experienceName || $[35] !== handleSelectSkill || $[36] !== handleSelectSpace || $[37] !== handleViewAllSkills || $[38] !== isSlideVisible || $[39] !== layout || $[40] !== product || $[41] !== searchQuery || $[42] !== siteId) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "auto-suggest-skills"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContent, {
            siteId: siteId,
            product: product,
            experienceId: experienceId,
            emojiProvider: emojiProvider,
            searchQuery: searchQuery,
            isSlideVisible: isSlideVisible,
            isSpacesEnabled: isSpacesEnabledOuter,
            onSelectSkill: handleSelectSkill,
            onSelectSpace: handleSelectSpace,
            onViewAllSkills: handleViewAllSkills,
            onDismiss: handleClose,
            onSkillsLoaded: handleSkillsLoaded,
            layout: layout,
            experienceName: experienceName
        }))));
        $[32] = emojiProvider;
        $[33] = experienceId;
        $[34] = experienceName;
        $[35] = handleSelectSkill;
        $[36] = handleSelectSpace;
        $[37] = handleViewAllSkills;
        $[38] = isSlideVisible;
        $[39] = layout;
        $[40] = product;
        $[41] = searchQuery;
        $[42] = siteId;
        $[43] = t21;
    } else t21 = $[43];
    let t22;
    if ($[44] !== t18 || $[45] !== t19 || $[46] !== t20 || $[47] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: t18,
            onError: t19
        }, t20, t21);
        $[44] = t18;
        $[45] = t19;
        $[46] = t20;
        $[47] = t21;
        $[48] = t22;
    } else t22 = $[48];
    let t23;
    if ($[49] !== t17 || $[50] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "auto-suggest-overlay",
            xcss: t17
        }, t22);
        $[49] = t17;
        $[50] = t22;
        $[51] = t23;
    } else t23 = $[51];
    const content = t23;
    if (layout === "fullscreen" && isSlideVisible && !isSpacesEnabledOuter) {
        let t24;
        if ($[52] !== content) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $6935ff72f1e18294$var$overlayStyles.fullscreenContainer
            }, content);
            $[52] = content;
            $[53] = t24;
        } else t24 = $[53];
        return t24;
    }
    return content;
} : function AutoSuggestSkills({ searchQuery: searchQuery, siteId: siteId, product: product, experienceId: experienceId, emojiProvider: emojiProvider, onViewAllSkills: onViewAllSkills, onVisibleChange: onVisibleChange, onDismissHandle: onDismissHandle, layout: layout = 'sidebar' }) {
    const [, { setPlaceholder: setPlaceholder }] = (0, $iDlFY.usePlaceholderStore)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { setSelectedSpace: setSelectedSpace, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)(); // Used to record the skill selection source on the AnalyticsPropertiesContext so
    // the chat input can attach it to the next `aiResult viewed` event. The provider
    // is mounted once per chat instance, so writes here are scoped to the same input
    // that will eventually consume them at submit time.
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const [hasItems, setHasItems] = (0, $cozmU.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    const isQueryActive = searchQuery.trim().length > 0;
    const isSlideVisible = hasItems && !isDismissed && isQueryActive;
    const prevSlideVisibleRef = (0, $cozmU.useRef)(isSlideVisible);
    const dismiss = (0, $cozmU.useCallback)(()=>setIsDismissed(true), []);
    (0, $cozmU.useEffect)(()=>{
        if (!onDismissHandle) return;
        onDismissHandle({
            dismiss: dismiss
        });
        return ()=>{
            onDismissHandle(null);
        };
    }, [
        onDismissHandle,
        dismiss
    ]); // Only un-dismiss when the user starts typing a new non-empty query.
    // Resetting on every searchQuery change (including the clear-to-"" on submit)
    // would cause the menu to reappear immediately after the user submits without
    // having selected an item.
    const prevSearchQueryRef = (0, $cozmU.useRef)(searchQuery);
    (0, $cozmU.useEffect)(()=>{
        const prev = prevSearchQueryRef.current;
        prevSearchQueryRef.current = searchQuery;
        if (searchQuery.trim().length > 0 && searchQuery !== prev) setIsDismissed(false);
    }, [
        searchQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (prevSlideVisibleRef.current !== isSlideVisible) {
            prevSlideVisibleRef.current = isSlideVisible;
            onVisibleChange?.(isSlideVisible);
        }
    }, [
        isSlideVisible,
        onVisibleChange
    ]);
    const handleSkillsLoaded = (0, $cozmU.useCallback)((payload)=>{
        setHasItems(payload.hasItems);
    }, []);
    const handleViewAllSkills = (0, $cozmU.useCallback)(()=>{
        setIsDismissed(true);
        onViewAllSkills();
    }, [
        onViewAllSkills
    ]);
    const handleSelectSkill = (0, $cozmU.useCallback)((skill)=>{
        setIsDismissed(true);
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoChatSkillSelected',
            attributes: {
                slashCommand: skill.slug,
                skillProductKey: skill.product,
                skillSelectionSource: 'autoSuggest'
            }
        });
        setAnalyticsPropertiesWithoutRerender({
            skillSelectionSource: 'autoSuggest'
        }); // Place the cursor *after* the skill tag and its trailing space so the
        // user can keep typing immediately. The skill ADF is:
        //   paragraph( inlineExtension(skillTag), text(' ') )
        // In ProseMirror positions, that maps to:
        //   0: before paragraph
        //   1: before the inline extension (skill tag)
        //   2: after the inline extension
        //   3: after the trailing space (the desired caret position)
        setPlaceholder({
            prompt: '',
            adfDocument: (0, $8lhhf.createSkillAdf)(skill),
            type: 'generic',
            selectionStartIndex: 3,
            selectionEndIndex: 3,
            insertAtCursor: false
        });
    }, [
        sendAnalyticsEvent,
        setAnalyticsPropertiesWithoutRerender,
        setPlaceholder
    ]);
    const handleSelectSpace = (0, $cozmU.useCallback)((space)=>{
        setIsDismissed(true);
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoChatSpaceSelected',
            attributes: {
                spaceId: space.id,
                spaceSelectionSource: 'autoSuggest'
            }
        }); // Set the currently selected space so the landing page (and any
        // observers like the selected-space bar) pick up the new context.
        setSelectedSpace({
            id: space.id,
            name: space.name,
            emoji: space.emoji ?? undefined,
            entryPoint: 'typeahead'
        });
        setActiveMenu('space-landing');
    }, [
        sendAnalyticsEvent,
        setSelectedSpace,
        setActiveMenu
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsDismissed(true);
    }, []); // Determine which experience name to track based on the active query path.
    // Read once on mount so start/success/failure all use the same name even if
    // the gate flips mid-session (which it shouldn't, but defensive against
    // double-counting in the cohort dashboard).
    const [experienceName] = (0, $cozmU.useState)(()=>(0, $iDrrr.fg)('rovo_chat_unified_skills_agg') ? (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED : (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY);
    const isSpacesEnabledOuter = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "auto-suggest-overlay",
        xcss: layout === 'sidebar' ? isSpacesEnabledOuter ? $6935ff72f1e18294$var$overlayStyles.overlayFloating : $6935ff72f1e18294$var$overlayStyles.overlay : isSpacesEnabledOuter ? $6935ff72f1e18294$var$overlayStyles.overlayFloatingFullscreen : $6935ff72f1e18294$var$overlayStyles.overlayFullscreen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                name: experienceName,
                error: error instanceof Error ? error : new Error(String(error))
            }),
        onError: (error_0)=>{
            (0, $hlvTd.logException)({
                exception: error_0,
                name: 'autoSuggestSkillsRelay',
                tags: {
                    siteId: siteId
                }
            });
            handleClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: experienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "auto-suggest-skills"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6935ff72f1e18294$var$SkillsContent, {
        siteId: siteId,
        product: product,
        experienceId: experienceId,
        emojiProvider: emojiProvider,
        searchQuery: searchQuery,
        isSlideVisible: isSlideVisible,
        isSpacesEnabled: isSpacesEnabledOuter,
        onSelectSkill: handleSelectSkill,
        onSelectSpace: handleSelectSpace,
        onViewAllSkills: handleViewAllSkills,
        onDismiss: handleClose,
        onSkillsLoaded: handleSkillsLoaded,
        layout: layout,
        experienceName: experienceName
    }))))));
    if (layout === 'fullscreen' && isSlideVisible && !isSpacesEnabledOuter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6935ff72f1e18294$var$overlayStyles.fullscreenContainer
    }, content);
    return content;
};
function $6935ff72f1e18294$var$_temp8() {
    return (0, $iDrrr.fg)("rovo_chat_unified_skills_agg") ? (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED : (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY;
}












var $4m5jb = parcelRequire("4m5jb");


var $k4g8h = parcelRequire("k4g8h");


var $igOtY = parcelRequire("igOtY");


var $8akfd = parcelRequire("8akfd");





var $lTU4O = parcelRequire("lTU4O");





var $hMLWD = parcelRequire("hMLWD");


var $33LwY = parcelRequire("33LwY");













const $2ea50d39fb584b32$var$ActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2ea50d39fb584b32$export$94bf5e4fee4a62be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults, numStartersToShow: numStartersToShow } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[0] = t1;
    } else t1 = $[0];
    const isRenderStabilizationEnabled = t1 === true;
    let t2;
    if ($[1] !== getActions || $[2] !== numStartersToShow || $[3] !== prioritizeCustomActionResults) {
        t2 = isRenderStabilizationEnabled ? {
            getActions: getActions,
            prioritizeCustomActionResults: prioritizeCustomActionResults,
            numStartersToShow: numStartersToShow
        } : undefined;
        $[1] = getActions;
        $[2] = numStartersToShow;
        $[3] = prioritizeCustomActionResults;
        $[4] = t2;
    } else t2 = $[4];
    const stabilizedValue = t2;
    let t3;
    if ($[5] !== getActions || $[6] !== numStartersToShow || $[7] !== prioritizeCustomActionResults || $[8] !== stabilizedValue) {
        t3 = stabilizedValue ?? {
            getActions: getActions,
            prioritizeCustomActionResults: prioritizeCustomActionResults,
            numStartersToShow: numStartersToShow
        };
        $[5] = getActions;
        $[6] = numStartersToShow;
        $[7] = prioritizeCustomActionResults;
        $[8] = stabilizedValue;
        $[9] = t3;
    } else t3 = $[9];
    const value = t3;
    let t4;
    if ($[10] !== children || $[11] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ea50d39fb584b32$var$ActionsContext.Provider, {
            value: value
        }, children);
        $[10] = children;
        $[11] = value;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ children: children, getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults, numStartersToShow: numStartersToShow })=>{
    const isRenderStabilizationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const stabilizedValue = (0, $cozmU.useMemo)(()=>isRenderStabilizationEnabled ? {
            getActions: getActions,
            prioritizeCustomActionResults: prioritizeCustomActionResults,
            numStartersToShow: numStartersToShow
        } : undefined, [
        getActions,
        isRenderStabilizationEnabled,
        prioritizeCustomActionResults,
        numStartersToShow
    ]);
    const value = stabilizedValue ?? {
        getActions: getActions,
        prioritizeCustomActionResults: prioritizeCustomActionResults,
        numStartersToShow: numStartersToShow
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ea50d39fb584b32$var$ActionsContext.Provider, {
        value: value
    }, children);
};
const $2ea50d39fb584b32$export$4a3b04775eb5de55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const context = (0, $cozmU.useContext)($2ea50d39fb584b32$var$ActionsContext);
    let t0;
    if ($[0] !== context) {
        t0 = context ?? {
            getActions: undefined,
            prioritizeCustomActionResults: false,
            numStartersToShow: 3
        };
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const context = (0, $cozmU.useContext)($2ea50d39fb584b32$var$ActionsContext);
    // Return empty object if no provider found (allows optional usage)
    return context ?? {
        getActions: undefined,
        prioritizeCustomActionResults: false,
        numStartersToShow: 3
    };
};



var $ZKswU = parcelRequire("ZKswU");


var $2TzCj = parcelRequire("2TzCj");




const $fc5ecfceab3714cd$export$4f04c281a7e57c7d = ()=>{
    const spacesEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const pinnedWorkEnabled = (0, $cXtTj.default).getExperimentValue('rovo_your_work_tab_pin_objects', 'isEnabled', false);
    return spacesEnabled || pinnedWorkEnabled;
};











const $a2dc017075ecc27d$var$DEFAULT_STATE = {
    currentView: {
        type: 'threads-list'
    }
};
// resetNavigation is a no-op — only one view exists today.
// Kept for API compatibility with external consumers (e.g. conversation-assistant)
// and to support potential future navigation states without a breaking change.
const $a2dc017075ecc27d$var$DEFAULT_ACTIONS = {
    resetNavigation: ()=>{}
};
const $a2dc017075ecc27d$var$ForYouNavigationStateContext = /*#__PURE__*/ (0, $cozmU.createContext)($a2dc017075ecc27d$var$DEFAULT_STATE);
const $a2dc017075ecc27d$var$ForYouNavigationActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)($a2dc017075ecc27d$var$DEFAULT_ACTIONS);
const $a2dc017075ecc27d$export$ae12f5af34ff779c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ForYouNavigationProvider(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a2dc017075ecc27d$var$ForYouNavigationStateContext.Provider, {
            value: $a2dc017075ecc27d$var$DEFAULT_STATE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a2dc017075ecc27d$var$ForYouNavigationActionsContext.Provider, {
            value: $a2dc017075ecc27d$var$DEFAULT_ACTIONS
        }, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function ForYouNavigationProvider({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a2dc017075ecc27d$var$ForYouNavigationStateContext.Provider, {
        value: $a2dc017075ecc27d$var$DEFAULT_STATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a2dc017075ecc27d$var$ForYouNavigationActionsContext.Provider, {
        value: $a2dc017075ecc27d$var$DEFAULT_ACTIONS
    }, children));
};
const $a2dc017075ecc27d$export$30ffc6f2dc2c1cf5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useForYouNavigationState() {
    return (0, $cozmU.useContext)($a2dc017075ecc27d$var$ForYouNavigationStateContext);
} : function useForYouNavigationState() {
    return (0, $cozmU.useContext)($a2dc017075ecc27d$var$ForYouNavigationStateContext);
};
const $a2dc017075ecc27d$export$ff19d21aed959849 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useForYouNavigationActions() {
    return (0, $cozmU.useContext)($a2dc017075ecc27d$var$ForYouNavigationActionsContext);
} : function useForYouNavigationActions() {
    return (0, $cozmU.useContext)($a2dc017075ecc27d$var$ForYouNavigationActionsContext);
};
const $a2dc017075ecc27d$export$174967b1e9ed7d46 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useForYouNavigation() {
    const $ = (0, $bDgLe.c)(3);
    const state = $a2dc017075ecc27d$export$30ffc6f2dc2c1cf5();
    const actions = $a2dc017075ecc27d$export$ff19d21aed959849();
    let t0;
    if ($[0] !== actions || $[1] !== state) {
        t0 = {
            ...state,
            ...actions
        };
        $[0] = actions;
        $[1] = state;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useForYouNavigation() {
    const state = $a2dc017075ecc27d$export$30ffc6f2dc2c1cf5();
    const actions = $a2dc017075ecc27d$export$ff19d21aed959849();
    return {
        ...state,
        ...actions
    };
};


































var $fmu9K = parcelRequire("fmu9K");


var $9DHhW = parcelRequire("9DHhW");

const $b4766f9d5329f065$var$ANALYTICS_CHANNEL = (0, $fmu9K.FabricChannel).aiMate;
const $b4766f9d5329f065$var$ANALYTICS_SOURCE = 'rovoGrowthPulse';
const $b4766f9d5329f065$var$DEFAULT_TAGS = [
    'atlaskit'
];
const $b4766f9d5329f065$export$eed8c476984ddfad = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>{
            createAnalyticsEvent({
                ...payload,
                source: $b4766f9d5329f065$var$ANALYTICS_SOURCE,
                tags: Array.from(new Set([
                    ...$b4766f9d5329f065$var$DEFAULT_TAGS,
                    ...payload.tags ?? []
                ])),
                attributes: {
                    ...payload.attributes
                }
            }).fire($b4766f9d5329f065$var$ANALYTICS_CHANNEL);
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireAnalyticsEvent = t0;
    let t1;
    if ($[2] !== fireAnalyticsEvent) {
        t1 = {
            fireAnalyticsEvent: fireAnalyticsEvent
        };
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: $b4766f9d5329f065$var$ANALYTICS_SOURCE,
            tags: Array.from(new Set([
                ...$b4766f9d5329f065$var$DEFAULT_TAGS,
                ...payload.tags ?? []
            ])),
            attributes: {
                ...payload.attributes
            }
        }).fire($b4766f9d5329f065$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};












var $cXLoX = parcelRequire("cXLoX");


const $ed7c817b0c93b0a6$var$DWELL_TIME_MS = 5000;
const $ed7c817b0c93b0a6$var$ANALYTICS_SOURCE = 'rovoInsights';
// `enablePlatformEvents` adds `atlaskit`; only pass feature-specific tags here.
const $ed7c817b0c93b0a6$var$AI_EVENT_ADDITIONAL_TAGS = [
    'aiMate'
];
const $ed7c817b0c93b0a6$export$b3975bf0ef145e10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { invokedFrom: t2 } = t1;
    const invokedFrom = t2 === undefined ? "weeklyInsights" : t2;
    const mauQualifiedViewFired = (0, $cozmU.useRef)(false);
    const interactionInitFired = (0, $cozmU.useRef)(false);
    const dwellTimerRef = (0, $cozmU.useRef)(null);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            product: "rovo",
            subproduct: "rovoInsights",
            aiFeatureName: "rovoInsights",
            proactiveGeneratedAI: 1,
            userGeneratedAI: 0,
            source: $ed7c817b0c93b0a6$var$ANALYTICS_SOURCE,
            enablePlatformEvents: true,
            tags: $ed7c817b0c93b0a6$var$AI_EVENT_ADDITIONAL_TAGS
        };
        $[2] = t3;
    } else t3 = $[2];
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $cXLoX.useAIEventsInstrumentation)(t3);
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (dwellTimerRef.current) clearTimeout(dwellTimerRef.current);
            };
        t5 = [];
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[5] !== invokedFrom || $[6] !== trackAIInteractionInit) {
        t6 = ()=>{
            if (!interactionInitFired.current) {
                interactionInitFired.current = true;
                trackAIInteractionInit({
                    attributes: {
                        invokedFrom: invokedFrom
                    }
                });
            }
        };
        $[5] = invokedFrom;
        $[6] = trackAIInteractionInit;
        $[7] = t6;
    } else t6 = $[7];
    const fireAIInteractionInitIfNeeded = t6;
    let t7;
    if ($[8] !== fireAIInteractionInitIfNeeded || $[9] !== invokedFrom || $[10] !== trackAIResultView) {
        t7 = (mauEligibilityCriteria)=>{
            if (!mauQualifiedViewFired.current) {
                mauQualifiedViewFired.current = true;
                fireAIInteractionInitIfNeeded();
                trackAIResultView({
                    doesNotMeetMAUCriteria: false,
                    attributes: {
                        mauEligibilityCriteria: mauEligibilityCriteria,
                        invokedFrom: invokedFrom
                    }
                });
            }
        };
        $[8] = fireAIInteractionInitIfNeeded;
        $[9] = invokedFrom;
        $[10] = trackAIResultView;
        $[11] = t7;
    } else t7 = $[11];
    const fireMAUViewedIfNeeded = t7;
    let t8;
    if ($[12] !== fireAIInteractionInitIfNeeded || $[13] !== fireMAUViewedIfNeeded || $[14] !== invokedFrom || $[15] !== trackAIResultView) {
        t8 = (attributes)=>{
            fireAIInteractionInitIfNeeded();
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    invokedFrom: invokedFrom,
                    ...attributes
                }
            });
            if (!dwellTimerRef.current && !mauQualifiedViewFired.current) dwellTimerRef.current = setTimeout(()=>{
                dwellTimerRef.current = null;
                fireMAUViewedIfNeeded("dwellTimeRealized");
            }, $ed7c817b0c93b0a6$var$DWELL_TIME_MS);
        };
        $[12] = fireAIInteractionInitIfNeeded;
        $[13] = fireMAUViewedIfNeeded;
        $[14] = invokedFrom;
        $[15] = trackAIResultView;
        $[16] = t8;
    } else t8 = $[16];
    const onFeedContentDisplayed = t8;
    let t9;
    if ($[17] !== fireAnalyticsEvent || $[18] !== fireMAUViewedIfNeeded || $[19] !== invokedFrom || $[20] !== trackAIResultAction) {
        t9 = (insightCategory)=>{
            fireMAUViewedIfNeeded("insightsCardClicked");
            trackAIResultAction("insightsCardClicked", {
                attributes: {
                    invokedFrom: invokedFrom,
                    insightCategory: insightCategory
                }
            });
            fireAnalyticsEvent({
                eventType: "ui",
                actionSubject: "insightCard",
                action: "clicked",
                attributes: {
                    insightCategory: insightCategory
                }
            });
        };
        $[17] = fireAnalyticsEvent;
        $[18] = fireMAUViewedIfNeeded;
        $[19] = invokedFrom;
        $[20] = trackAIResultAction;
        $[21] = t9;
    } else t9 = $[21];
    const onInsightCardClicked = t9;
    let t10;
    if ($[22] !== fireMAUViewedIfNeeded || $[23] !== invokedFrom || $[24] !== trackAIResultAction) {
        t10 = (url)=>{
            fireMAUViewedIfNeeded("outputUrlClicked");
            trackAIResultAction("outputUrlClicked", {
                attributes: {
                    invokedFrom: invokedFrom,
                    url: url
                }
            });
        };
        $[22] = fireMAUViewedIfNeeded;
        $[23] = invokedFrom;
        $[24] = trackAIResultAction;
        $[25] = t10;
    } else t10 = $[25];
    const onUrlClicked = t10;
    let t11;
    if ($[26] !== fireAnalyticsEvent) {
        t11 = ()=>{
            fireAnalyticsEvent({
                eventType: "ui",
                actionSubject: "insightsFeedRetryButton",
                action: "clicked"
            });
        };
        $[26] = fireAnalyticsEvent;
        $[27] = t11;
    } else t11 = $[27];
    const onRetryClicked = t11;
    let t12;
    if ($[28] !== onFeedContentDisplayed || $[29] !== onInsightCardClicked || $[30] !== onRetryClicked || $[31] !== onUrlClicked) {
        t12 = {
            onFeedContentDisplayed: onFeedContentDisplayed,
            onInsightCardClicked: onInsightCardClicked,
            onUrlClicked: onUrlClicked,
            onRetryClicked: onRetryClicked
        };
        $[28] = onFeedContentDisplayed;
        $[29] = onInsightCardClicked;
        $[30] = onRetryClicked;
        $[31] = onUrlClicked;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
} : ({ invokedFrom: invokedFrom = 'weeklyInsights' } = {})=>{
    const mauQualifiedViewFired = (0, $cozmU.useRef)(false);
    const interactionInitFired = (0, $cozmU.useRef)(false);
    const dwellTimerRef = (0, $cozmU.useRef)(null);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $cXLoX.useAIEventsInstrumentation)({
        product: 'rovo',
        subproduct: 'rovoInsights',
        aiFeatureName: 'rovoInsights',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        source: $ed7c817b0c93b0a6$var$ANALYTICS_SOURCE,
        enablePlatformEvents: true,
        tags: $ed7c817b0c93b0a6$var$AI_EVENT_ADDITIONAL_TAGS
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (dwellTimerRef.current) clearTimeout(dwellTimerRef.current);
        };
    }, []);
    const fireAIInteractionInitIfNeeded = (0, $cozmU.useCallback)(()=>{
        if (!interactionInitFired.current) {
            interactionInitFired.current = true;
            trackAIInteractionInit({
                attributes: {
                    invokedFrom: invokedFrom
                }
            });
        }
    }, [
        trackAIInteractionInit,
        invokedFrom
    ]);
    const fireMAUViewedIfNeeded = (0, $cozmU.useCallback)((mauEligibilityCriteria)=>{
        if (!mauQualifiedViewFired.current) {
            mauQualifiedViewFired.current = true;
            fireAIInteractionInitIfNeeded();
            trackAIResultView({
                doesNotMeetMAUCriteria: false,
                attributes: {
                    mauEligibilityCriteria: mauEligibilityCriteria,
                    invokedFrom: invokedFrom
                }
            });
        }
    }, [
        fireAIInteractionInitIfNeeded,
        trackAIResultView,
        invokedFrom
    ]);
    const onFeedContentDisplayed = (0, $cozmU.useCallback)((attributes)=>{
        fireAIInteractionInitIfNeeded();
        trackAIResultView({
            doesNotMeetMAUCriteria: true,
            attributes: {
                invokedFrom: invokedFrom,
                ...attributes
            }
        });
        if (!dwellTimerRef.current && !mauQualifiedViewFired.current) dwellTimerRef.current = setTimeout(()=>{
            dwellTimerRef.current = null;
            fireMAUViewedIfNeeded('dwellTimeRealized');
        }, $ed7c817b0c93b0a6$var$DWELL_TIME_MS);
    }, [
        fireAIInteractionInitIfNeeded,
        trackAIResultView,
        invokedFrom,
        fireMAUViewedIfNeeded
    ]);
    const onInsightCardClicked = (0, $cozmU.useCallback)((insightCategory)=>{
        fireMAUViewedIfNeeded('insightsCardClicked');
        trackAIResultAction('insightsCardClicked', {
            attributes: {
                invokedFrom: invokedFrom,
                insightCategory: insightCategory
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'insightCard',
            action: 'clicked',
            attributes: {
                insightCategory: insightCategory
            }
        });
    }, [
        fireMAUViewedIfNeeded,
        trackAIResultAction,
        invokedFrom,
        fireAnalyticsEvent
    ]);
    const onUrlClicked = (0, $cozmU.useCallback)((url)=>{
        fireMAUViewedIfNeeded('outputUrlClicked');
        trackAIResultAction('outputUrlClicked', {
            attributes: {
                invokedFrom: invokedFrom,
                url: url
            }
        });
    }, [
        fireMAUViewedIfNeeded,
        trackAIResultAction,
        invokedFrom
    ]);
    const onRetryClicked = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'insightsFeedRetryButton',
            action: 'clicked'
        });
    }, [
        fireAnalyticsEvent
    ]);
    return {
        onFeedContentDisplayed: onFeedContentDisplayed,
        onInsightCardClicked: onInsightCardClicked,
        onUrlClicked: onUrlClicked,
        onRetryClicked: onRetryClicked
    };
};





































var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");





















var $ad7Ou = parcelRequire("ad7Ou");


var $eh6Ml = parcelRequire("eh6Ml");


var $fHs3z = parcelRequire("fHs3z");




const $5f36b330a5efb738$var$debugMessages = (0, $kSwu1.defineMessages)({
    debugLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.label",
        defaultMessage: "Debug"
    },
    aiThinking: {
        id: "rovo-growth-pulse.insights-feed.debug.ai-thinking",
        defaultMessage: "AI Thinking"
    },
    copyLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.copy",
        defaultMessage: "Copy"
    },
    copiedLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.copied",
        defaultMessage: "Copied!"
    },
    copyDebugReport: {
        id: "rovo-growth-pulse.insights-feed.debug.copy-debug-report",
        defaultMessage: "Copy Debug Report"
    },
    copyRawResponse: {
        id: "rovo-growth-pulse.insights-feed.debug.copy-raw-response",
        defaultMessage: "Copy Raw Response"
    },
    durationLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.duration",
        defaultMessage: "Duration:"
    },
    attemptsLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.attempts",
        defaultMessage: "Attempts:"
    },
    errorLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.error",
        defaultMessage: "Error:"
    },
    errorYes: {
        id: "rovo-growth-pulse.insights-feed.debug.error-yes",
        defaultMessage: "Yes"
    },
    generatedLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.generated",
        defaultMessage: "Generated: {timestamp}"
    },
    groupsCount: {
        id: "rovo-growth-pulse.insights-feed.debug.groups-count",
        defaultMessage: "{count} groups"
    },
    insightsCount: {
        id: "rovo-growth-pulse.insights-feed.debug.insights-count",
        defaultMessage: "{count} insights"
    },
    totalDuration: {
        id: "rovo-growth-pulse.insights-feed.debug.total-duration",
        defaultMessage: "{duration} total"
    },
    toggleDebugMode: {
        id: "rovo-growth-pulse.insights-feed.debug.toggle-debug-mode",
        defaultMessage: "Toggle debug mode"
    },
    promptTitle: {
        id: "rovo-growth-pulse.insights-feed.debug.prompt-title",
        defaultMessage: "Prompt"
    },
    llmResponseTitle: {
        id: "rovo-growth-pulse.insights-feed.debug.llm-response-title",
        defaultMessage: "LLM Response"
    },
    charsCount: {
        id: "rovo-growth-pulse.insights-feed.debug.chars-count",
        defaultMessage: "{title} ({count} chars)"
    },
    emptyContent: {
        id: "rovo-growth-pulse.insights-feed.debug.empty-content",
        defaultMessage: "(empty)"
    },
    longestTask: {
        id: "rovo-growth-pulse.insights-feed.debug.longest-task",
        defaultMessage: "longest: {title} ({duration})"
    },
    totalErrors: {
        id: "rovo-growth-pulse.insights-feed.debug.total-errors",
        defaultMessage: "{count, plural, one {# error} other {# errors}}"
    },
    collapseLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.collapse-label",
        defaultMessage: "Collapse"
    },
    expandLabel: {
        id: "rovo-growth-pulse.insights-feed.debug.expand-label",
        defaultMessage: "Expand"
    },
    summaryLine: {
        id: "rovo-growth-pulse.insights-feed.debug.summary-line",
        defaultMessage: "{groups} \xB7 {insights} \xB7 {duration}"
    },
    summaryLineWithLongest: {
        id: "rovo-growth-pulse.insights-feed.debug.summary-line-with-longest",
        defaultMessage: "{groups} \xB7 {insights} \xB7 {duration} \xB7 {longest}"
    }
});
var $5f36b330a5efb738$export$2e2bcd8739ae039 = $5f36b330a5efb738$var$debugMessages;


const $539318e7586c3c0a$export$4f2558dd25106ae2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { text: text, label: label } = t0;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== text) {
        t1 = async ()=>{
            try {
                await navigator.clipboard.writeText(text);
                setCopied(true);
                setTimeout(()=>setCopied(false), 2000);
            } catch  {}
        };
        $[0] = text;
        $[1] = t1;
    } else t1 = $[1];
    const handleCopy = t1;
    let t2;
    if ($[2] !== copied) {
        t2 = (iconProps)=>copied ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), iconProps) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), iconProps);
        $[2] = copied;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== copied || $[5] !== formatMessage || $[6] !== label) {
        t3 = copied ? formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copiedLabel) : label;
        $[4] = copied;
        $[5] = formatMessage;
        $[6] = label;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== handleCopy || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: t2,
            onClick: handleCopy,
            spacing: "compact"
        }, t3);
        $[8] = handleCopy;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ text: text, label: label })=>{
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleCopy = (0, $cozmU.useCallback)(async ()=>{
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch  {}
    }, [
        text
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (iconProps)=>copied ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), iconProps) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), iconProps),
        onClick: handleCopy,
        spacing: "compact"
    }, copied ? formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copiedLabel) : label);
};



const $42f6c3f987b41988$var$styles = {
    header: "_0bjKvDKxmn _4c065U2ADO _2Y7lL42ADO _0wOv4Q7zJH _0KLXruDMqu",
    label: "_2sNsIg7NXe _1kk5Tkf7mX",
    codeBlock: "_2sNsIg7NXe _4bt5LAIZbP _2WAcuGIZbP _0bjKvDKxmn _4c065U2ADO _2Y7lL42ADO _0WKd3Gfx9v _1ANEUSlpBW _3W2Oc84hR5 _0NUa3rBfNa _0KLXrunmFW _43nrzTPgdg _0rIjykPgdg _0GTcwRPgdg _2xTnZxPgdg"
};
const $42f6c3f987b41988$export$ea6bc8720b8c75b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { title: title, content: content, isJson: t1, defaultExpanded: t2 } = t0;
    const isJson = t1 === undefined ? false : t1;
    const defaultExpanded = t2 === undefined ? false : t2;
    const [expanded, setExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setExpanded($42f6c3f987b41988$var$_temp);
        $[0] = t3;
    } else t3 = $[0];
    const toggle = t3;
    const safeContent = content ?? "";
    let displayContent = safeContent;
    if (isJson && safeContent) try {
        let t4;
        if ($[1] !== safeContent) {
            t4 = JSON.stringify(JSON.parse(safeContent), null, 2);
            $[1] = safeContent;
            $[2] = t4;
        } else t4 = $[2];
        displayContent = t4;
    } catch  {}
    const charCount = safeContent.length;
    let t4;
    if ($[3] !== charCount || $[4] !== formatMessage || $[5] !== title) {
        t4 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).charsCount, {
            title: title,
            count: charCount.toLocaleString()
        });
        $[3] = charCount;
        $[4] = formatMessage;
        $[5] = title;
        $[6] = t4;
    } else t4 = $[6];
    const label = t4;
    let t5;
    if ($[7] !== expanded || $[8] !== formatMessage) {
        t5 = expanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).collapseLabel),
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).expandLabel),
            color: "var(--ds-icon, #292A2E)"
        });
        $[7] = expanded;
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== label) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $42f6c3f987b41988$var$styles.label
        }, label);
        $[10] = label;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: toggle,
            xcss: $42f6c3f987b41988$var$styles.header
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.050"
        }, t5, t6));
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== displayContent || $[16] !== expanded || $[17] !== formatMessage || $[18] !== safeContent) {
        t8 = expanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
            text: safeContent,
            label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyLabel)
        }), /*#__PURE__*/ $cozmU.createElement("pre", {
            className: (0, $hekY6.default)([
                $42f6c3f987b41988$var$styles.codeBlock
            ])
        }, displayContent || formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).emptyContent)));
        $[15] = displayContent;
        $[16] = expanded;
        $[17] = formatMessage;
        $[18] = safeContent;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t7, t8);
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : ({ title: title, content: content, isJson: isJson = false, defaultExpanded: defaultExpanded = false })=>{
    const [expanded, setExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const toggle = (0, $cozmU.useCallback)(()=>setExpanded((prev)=>!prev), []);
    const safeContent = content ?? '';
    let displayContent = safeContent;
    if (isJson && safeContent) try {
        displayContent = JSON.stringify(JSON.parse(safeContent), null, 2);
    } catch  {}
    const charCount = safeContent.length;
    const label = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).charsCount, {
        title: title,
        count: charCount.toLocaleString()
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: toggle,
        xcss: $42f6c3f987b41988$var$styles.header
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.050"
    }, expanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).collapseLabel),
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).expandLabel),
        color: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $42f6c3f987b41988$var$styles.label
    }, label))), expanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
        text: safeContent,
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyLabel)
    }), /*#__PURE__*/ $cozmU.createElement("pre", {
        className: (0, $hekY6.default)([
            $42f6c3f987b41988$var$styles.codeBlock
        ])
    }, displayContent || formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).emptyContent))));
};
function $42f6c3f987b41988$var$_temp(prev) {
    return !prev;
}



const $e09ee8f8beac8cd4$var$styles = {
    container: "_0bjKvDKxmn _4c065U8HPE _2Y7lL48HPE _0KLXrunmFW _43nrzT2ADO",
    metricLabel: "_2sNsIg7NXe _1UtDYzKGUX",
    metricValue: "_2sNsIgNxAV _1UtDYzZpcK",
    successValue: "_2sNsIgNxAV _1UtDYzGL5O",
    warningValue: "_2sNsIgNxAV _1UtDYzZSA9",
    dangerValue: "_2sNsIgNxAV _1UtDYzAyGJ",
    errorPanel: "_0bjKvDKxmn _2sNsIg7NXe _4c065U2ADO _2Y7lL42ADO _0KLXruhH7k _1UtDYzAyGJ"
};
function $e09ee8f8beac8cd4$var$formatDuration(secs) {
    if (secs < 60) return `${secs}s`;
    const mins = Math.floor(secs / 60);
    const remainSecs = secs % 60;
    return `${mins}m ${remainSecs}s`;
}
const $e09ee8f8beac8cd4$export$6b086eff7b8c2fb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { debugInfo: debugInfo } = t0;
    const { generatedAt: generatedAt, prompt: prompt, llmResponse: llmResponse, error: error, durationSecs: durationSecs, attempts: attempts } = debugInfo;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).durationLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = durationSecs >= 600 ? $e09ee8f8beac8cd4$var$styles.dangerValue : durationSecs >= 300 ? $e09ee8f8beac8cd4$var$styles.warningValue : $e09ee8f8beac8cd4$var$styles.successValue;
    let t4;
    if ($[4] !== durationSecs) {
        t4 = $e09ee8f8beac8cd4$var$formatDuration(durationSecs);
        $[4] = durationSecs;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: t3
        }, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t2 || $[10] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            alignItems: "center"
        }, t2, t5);
        $[9] = t2;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== formatMessage) {
        t7 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).attemptsLabel);
        $[12] = formatMessage;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
        }, t7);
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const t9 = attempts > 1 ? $e09ee8f8beac8cd4$var$styles.warningValue : $e09ee8f8beac8cd4$var$styles.metricValue;
    let t10;
    if ($[16] !== attempts || $[17] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: t9
        }, attempts);
        $[16] = attempts;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== t10 || $[20] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            alignItems: "center"
        }, t8, t10);
        $[19] = t10;
        $[20] = t8;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== error || $[23] !== formatMessage) {
        t12 = error && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            alignItems: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
        }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).errorLabel)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e09ee8f8beac8cd4$var$styles.dangerValue
        }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).errorYes)));
        $[22] = error;
        $[23] = formatMessage;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== formatMessage || $[26] !== generatedAt) {
        t13 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).generatedLabel, {
            timestamp: new Date(generatedAt).toLocaleString()
        });
        $[25] = formatMessage;
        $[26] = generatedAt;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
        }, t13);
        $[28] = t13;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== t11 || $[31] !== t12 || $[32] !== t14 || $[33] !== t6) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.150",
            alignItems: "center",
            wrap: "wrap"
        }, t6, t11, t12, t14);
        $[30] = t11;
        $[31] = t12;
        $[32] = t14;
        $[33] = t6;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== error) {
        t16 = error && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e09ee8f8beac8cd4$var$styles.errorPanel
        }, error);
        $[35] = error;
        $[36] = t16;
    } else t16 = $[36];
    let t17;
    if ($[37] !== formatMessage) {
        t17 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).promptTitle);
        $[37] = formatMessage;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== prompt || $[40] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $42f6c3f987b41988$export$ea6bc8720b8c75b9), {
            title: t17,
            content: prompt
        });
        $[39] = prompt;
        $[40] = t17;
        $[41] = t18;
    } else t18 = $[41];
    let t19;
    if ($[42] !== formatMessage) {
        t19 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).llmResponseTitle);
        $[42] = formatMessage;
        $[43] = t19;
    } else t19 = $[43];
    let t20;
    if ($[44] !== llmResponse || $[45] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $42f6c3f987b41988$export$ea6bc8720b8c75b9), {
            title: t19,
            content: llmResponse,
            isJson: true
        });
        $[44] = llmResponse;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    let t21;
    if ($[47] !== t15 || $[48] !== t16 || $[49] !== t18 || $[50] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: $e09ee8f8beac8cd4$var$styles.container
        }, t15, t16, t18, t20);
        $[47] = t15;
        $[48] = t16;
        $[49] = t18;
        $[50] = t20;
        $[51] = t21;
    } else t21 = $[51];
    return t21;
} : ({ debugInfo: debugInfo })=>{
    const { generatedAt: generatedAt, prompt: prompt, llmResponse: llmResponse, error: error, durationSecs: durationSecs, attempts: attempts } = debugInfo;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $e09ee8f8beac8cd4$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.150",
        alignItems: "center",
        wrap: "wrap"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).durationLabel)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: durationSecs >= 600 ? $e09ee8f8beac8cd4$var$styles.dangerValue : durationSecs >= 300 ? $e09ee8f8beac8cd4$var$styles.warningValue : $e09ee8f8beac8cd4$var$styles.successValue
    }, $e09ee8f8beac8cd4$var$formatDuration(durationSecs))), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).attemptsLabel)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: attempts > 1 ? $e09ee8f8beac8cd4$var$styles.warningValue : $e09ee8f8beac8cd4$var$styles.metricValue
    }, attempts)), error && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).errorLabel)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e09ee8f8beac8cd4$var$styles.dangerValue
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).errorYes))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e09ee8f8beac8cd4$var$styles.metricLabel
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).generatedLabel, {
        timestamp: new Date(generatedAt).toLocaleString()
    }))), error && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e09ee8f8beac8cd4$var$styles.errorPanel
    }, error), /*#__PURE__*/ $cozmU.createElement((0, $42f6c3f987b41988$export$ea6bc8720b8c75b9), {
        title: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).promptTitle),
        content: prompt
    }), /*#__PURE__*/ $cozmU.createElement((0, $42f6c3f987b41988$export$ea6bc8720b8c75b9), {
        title: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).llmResponseTitle),
        content: llmResponse,
        isJson: true
    }));
};























const $20dc3054e9f448fc$var$styles = {
    container: "_0bjKvD8fU6 _4c065U2ADO _2Y7lL45zaO _0KLXrunmFW _0rIjyk5zaO",
    label: "_2sNsIg7NXe _1kk5Tk7GSX _1UtDYzKGUX",
    summaryText: "_2sNsIg7NXe _1UtDYzZpcK",
    errorText: "_2sNsIg7NXe _1UtDYzAyGJ"
};
function $20dc3054e9f448fc$var$formatDuration(secs) {
    if (secs < 60) return `${secs}s`;
    const mins = Math.floor(secs / 60);
    const remainSecs = secs % 60;
    return `${mins}m ${remainSecs}s`;
}
function $20dc3054e9f448fc$var$buildDebugReport(items) {
    const lines = [
        '# Rovo Insights Debug Report',
        ''
    ];
    for (const item of items){
        if (!item.debugInfo) continue;
        const di = item.debugInfo;
        lines.push(`## ${item.title}`);
        lines.push(`- Insights: ${item.count}`);
        lines.push(`- Duration: ${$20dc3054e9f448fc$var$formatDuration(di.durationSecs)}`);
        lines.push(`- Attempts: ${di.attempts}`);
        lines.push(`- Error: ${di.error ?? 'None'}`);
        lines.push(`- Generated: ${di.generatedAt}`);
        lines.push('');
        if (item.subItems) for (const sub of item.subItems){
            lines.push(`### ${sub.title}`);
            lines.push(sub.description);
            if (sub.thinking) {
                lines.push('');
                lines.push('**AI Thinking:**');
                lines.push(sub.thinking);
            }
            lines.push('');
        }
    }
    return lines.join('\n');
}
const $20dc3054e9f448fc$export$b360852b92fd2157 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(65);
    const { items: items, rawResponse: rawResponse } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let T1;
    let T2;
    let T3;
    let debugReport;
    let errorCount;
    let rawJson;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] !== formatMessage || $[1] !== items || $[2] !== rawResponse) {
        const debugItems = items.filter($20dc3054e9f448fc$var$_temp);
        const totalDuration = debugItems.reduce($20dc3054e9f448fc$var$_temp2, 0);
        const totalInsights = debugItems.reduce($20dc3054e9f448fc$var$_temp3, 0);
        errorCount = debugItems.filter($20dc3054e9f448fc$var$_temp4).length;
        const longestTask = debugItems.reduce($20dc3054e9f448fc$var$_temp5, {
            title: "",
            duration: 0
        });
        let t10;
        if ($[19] !== items) {
            t10 = $20dc3054e9f448fc$var$buildDebugReport(items);
            $[19] = items;
            $[20] = t10;
        } else t10 = $[20];
        debugReport = t10;
        let t11;
        if ($[21] !== rawResponse) {
            t11 = rawResponse ? JSON.stringify(rawResponse, null, 2) : "";
            $[21] = rawResponse;
            $[22] = t11;
        } else t11 = $[22];
        rawJson = t11;
        T3 = (0, $iMnC5.Box);
        t9 = $20dc3054e9f448fc$var$styles.container;
        T2 = (0, $dinVW.Stack);
        t8 = "space.075";
        T1 = (0, $4ez2K.Flex);
        t4 = "center";
        t5 = "space.100";
        t6 = "wrap";
        let t12;
        if ($[23] !== formatMessage) {
            t12 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).debugLabel);
            $[23] = formatMessage;
            $[24] = t12;
        } else t12 = $[24];
        if ($[25] !== t12) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $20dc3054e9f448fc$var$styles.label
            }, t12);
            $[25] = t12;
            $[26] = t7;
        } else t7 = $[26];
        T0 = (0, $iMnC5.Box);
        t1 = "span";
        t2 = $20dc3054e9f448fc$var$styles.summaryText;
        t3 = longestTask.title ? formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).summaryLineWithLongest, {
            groups: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).groupsCount, {
                count: debugItems.length
            }),
            insights: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).insightsCount, {
                count: totalInsights
            }),
            duration: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).totalDuration, {
                duration: $20dc3054e9f448fc$var$formatDuration(totalDuration)
            }),
            longest: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).longestTask, {
                title: longestTask.title,
                duration: $20dc3054e9f448fc$var$formatDuration(longestTask.duration)
            })
        }) : formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).summaryLine, {
            groups: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).groupsCount, {
                count: debugItems.length
            }),
            insights: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).insightsCount, {
                count: totalInsights
            }),
            duration: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).totalDuration, {
                duration: $20dc3054e9f448fc$var$formatDuration(totalDuration)
            })
        });
        $[0] = formatMessage;
        $[1] = items;
        $[2] = rawResponse;
        $[3] = T0;
        $[4] = T1;
        $[5] = T2;
        $[6] = T3;
        $[7] = debugReport;
        $[8] = errorCount;
        $[9] = rawJson;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
        $[18] = t9;
    } else {
        T0 = $[3];
        T1 = $[4];
        T2 = $[5];
        T3 = $[6];
        debugReport = $[7];
        errorCount = $[8];
        rawJson = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        t7 = $[16];
        t8 = $[17];
        t9 = $[18];
    }
    let t10;
    if ($[27] !== T0 || $[28] !== t1 || $[29] !== t2 || $[30] !== t3) {
        t10 = /*#__PURE__*/ $cozmU.createElement(T0, {
            as: t1,
            xcss: t2
        }, t3);
        $[27] = T0;
        $[28] = t1;
        $[29] = t2;
        $[30] = t3;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== errorCount || $[33] !== formatMessage) {
        t11 = errorCount > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $20dc3054e9f448fc$var$styles.errorText
        }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).totalErrors, {
            count: errorCount
        })) : null;
        $[32] = errorCount;
        $[33] = formatMessage;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== T1 || $[36] !== t10 || $[37] !== t11 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7) {
        t12 = /*#__PURE__*/ $cozmU.createElement(T1, {
            alignItems: t4,
            gap: t5,
            wrap: t6
        }, t7, t10, t11);
        $[35] = T1;
        $[36] = t10;
        $[37] = t11;
        $[38] = t4;
        $[39] = t5;
        $[40] = t6;
        $[41] = t7;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== formatMessage) {
        t13 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyDebugReport);
        $[43] = formatMessage;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== debugReport || $[46] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
            text: debugReport,
            label: t13
        });
        $[45] = debugReport;
        $[46] = t13;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] !== formatMessage) {
        t15 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyRawResponse);
        $[48] = formatMessage;
        $[49] = t15;
    } else t15 = $[49];
    let t16;
    if ($[50] !== rawJson || $[51] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
            text: rawJson,
            label: t15
        });
        $[50] = rawJson;
        $[51] = t15;
        $[52] = t16;
    } else t16 = $[52];
    let t17;
    if ($[53] !== t14 || $[54] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.100",
            wrap: "wrap"
        }, t14, t16);
        $[53] = t14;
        $[54] = t16;
        $[55] = t17;
    } else t17 = $[55];
    let t18;
    if ($[56] !== T2 || $[57] !== t12 || $[58] !== t17 || $[59] !== t8) {
        t18 = /*#__PURE__*/ $cozmU.createElement(T2, {
            space: t8
        }, t12, t17);
        $[56] = T2;
        $[57] = t12;
        $[58] = t17;
        $[59] = t8;
        $[60] = t18;
    } else t18 = $[60];
    let t19;
    if ($[61] !== T3 || $[62] !== t18 || $[63] !== t9) {
        t19 = /*#__PURE__*/ $cozmU.createElement(T3, {
            xcss: t9
        }, t18);
        $[61] = T3;
        $[62] = t18;
        $[63] = t9;
        $[64] = t19;
    } else t19 = $[64];
    return t19;
} : ({ items: items, rawResponse: rawResponse })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const debugItems = items.filter((item)=>item.debugInfo);
    const totalDuration = debugItems.reduce((sum, item_0)=>sum + (item_0.debugInfo?.durationSecs ?? 0), 0);
    const totalInsights = debugItems.reduce((sum_0, item_1)=>sum_0 + item_1.count, 0);
    const errorCount = debugItems.filter((item_2)=>item_2.debugInfo?.error).length;
    const longestTask = debugItems.reduce((max, item_3)=>{
        const dur = item_3.debugInfo?.durationSecs ?? 0;
        return dur > max.duration ? {
            title: item_3.title,
            duration: dur
        } : max;
    }, {
        title: '',
        duration: 0
    });
    const debugReport = (0, $cozmU.useMemo)(()=>$20dc3054e9f448fc$var$buildDebugReport(items), [
        items
    ]);
    const rawJson = (0, $cozmU.useMemo)(()=>rawResponse ? JSON.stringify(rawResponse, null, 2) : '', [
        rawResponse
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $20dc3054e9f448fc$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100",
        wrap: "wrap"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $20dc3054e9f448fc$var$styles.label
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).debugLabel)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $20dc3054e9f448fc$var$styles.summaryText
    }, longestTask.title ? formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).summaryLineWithLongest, {
        groups: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).groupsCount, {
            count: debugItems.length
        }),
        insights: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).insightsCount, {
            count: totalInsights
        }),
        duration: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).totalDuration, {
            duration: $20dc3054e9f448fc$var$formatDuration(totalDuration)
        }),
        longest: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).longestTask, {
            title: longestTask.title,
            duration: $20dc3054e9f448fc$var$formatDuration(longestTask.duration)
        })
    }) : formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).summaryLine, {
        groups: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).groupsCount, {
            count: debugItems.length
        }),
        insights: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).insightsCount, {
            count: totalInsights
        }),
        duration: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).totalDuration, {
            duration: $20dc3054e9f448fc$var$formatDuration(totalDuration)
        })
    })), errorCount > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $20dc3054e9f448fc$var$styles.errorText
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).totalErrors, {
        count: errorCount
    })) : null), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        wrap: "wrap"
    }, /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
        text: debugReport,
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyDebugReport)
    }), /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
        text: rawJson,
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyRawResponse)
    }))));
};
function $20dc3054e9f448fc$var$_temp(item) {
    return item.debugInfo;
}
function $20dc3054e9f448fc$var$_temp2(sum, item_0) {
    return sum + (item_0.debugInfo?.durationSecs ?? 0);
}
function $20dc3054e9f448fc$var$_temp3(sum_0, item_1) {
    return sum_0 + item_1.count;
}
function $20dc3054e9f448fc$var$_temp4(item_2) {
    return item_2.debugInfo?.error;
}
function $20dc3054e9f448fc$var$_temp5(max, item_3) {
    const dur = item_3.debugInfo?.durationSecs ?? 0;
    return dur > max.duration ? {
        title: item_3.title,
        duration: dur
    } : max;
}


































const $d8c8e5081997f20d$var$styles = {
    container: "_43nrzT1Y8M",
    header: "_4c065U1Y8M _0wOv4Q7zJH",
    label: "_2sNsIg7NXe _1kk5Tkf7mX _1UtDYzKGUX",
    thinkingBlock: "_2sNsIg7NXe _0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _4c065U2ADO _2Y7lL42ADO _0WKd3Gfx9v _1ANEUSlpBW _3W2Oc8wPeg _0KLXrunmFW _43nrzT1Y8M _0rIjykPgdg _0GTcwRPgdg _2xTnZxPgdg _0NUa3rHakr"
};
const $d8c8e5081997f20d$export$a4e4618569bae392 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { thinking: thinking } = t0;
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setExpanded($d8c8e5081997f20d$var$_temp);
        $[0] = t1;
    } else t1 = $[0];
    const toggle = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[1] !== expanded || $[2] !== formatMessage) {
        t2 = expanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).collapseLabel),
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).expandLabel),
            color: "var(--ds-icon, #292A2E)"
        });
        $[1] = expanded;
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).aiThinking);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $d8c8e5081997f20d$var$styles.label
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: toggle,
            xcss: $d8c8e5081997f20d$var$styles.header
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.050"
        }, t2, t4));
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== expanded || $[12] !== formatMessage || $[13] !== thinking) {
        t6 = expanded && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
            text: thinking,
            label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyLabel)
        }), /*#__PURE__*/ $cozmU.createElement("pre", {
            className: (0, $hekY6.default)([
                $d8c8e5081997f20d$var$styles.thinkingBlock
            ])
        }, thinking));
        $[11] = expanded;
        $[12] = formatMessage;
        $[13] = thinking;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d8c8e5081997f20d$var$styles.container
        }, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ thinking: thinking })=>{
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const toggle = (0, $cozmU.useCallback)(()=>setExpanded((prev)=>!prev), []);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d8c8e5081997f20d$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: toggle,
        xcss: $d8c8e5081997f20d$var$styles.header
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.050"
    }, expanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).collapseLabel),
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).expandLabel),
        color: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d8c8e5081997f20d$var$styles.label
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).aiThinking)))), expanded && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $539318e7586c3c0a$export$4f2558dd25106ae2), {
        text: thinking,
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).copyLabel)
    }), /*#__PURE__*/ $cozmU.createElement("pre", {
        className: (0, $hekY6.default)([
            $d8c8e5081997f20d$var$styles.thinkingBlock
        ])
    }, thinking)));
};
function $d8c8e5081997f20d$var$_temp(prev) {
    return !prev;
}




















var $c0A7H = parcelRequire("c0A7H");


const $d2aeeba3d8d86e16$var$styles = {
    container: "_4c065U1Y8M",
    label: "_2sNsIg7NXe _1UtDYzKGUX _1kk5Tkf7mX"
};
const $d2aeeba3d8d86e16$export$82fd044c23f7dd3e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { isEnabled: isEnabled, onChange: onChange } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).debugLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $d2aeeba3d8d86e16$var$styles.label
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onChange) {
        t3 = (e)=>onChange(e.currentTarget.checked);
        $[4] = onChange;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).toggleDebugMode);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== isEnabled || $[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
            id: "insights-debug-toggle",
            isChecked: isEnabled,
            onChange: t3,
            label: t4
        });
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t2 || $[13] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.050",
            xcss: $d2aeeba3d8d86e16$var$styles.container
        }, t2, t5);
        $[12] = t2;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ isEnabled: isEnabled, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.050",
        xcss: $d2aeeba3d8d86e16$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d2aeeba3d8d86e16$var$styles.label
    }, formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).debugLabel)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        id: "insights-debug-toggle",
        isChecked: isEnabled,
        onChange: (e)=>onChange(e.currentTarget.checked),
        label: formatMessage((0, $5f36b330a5efb738$export$2e2bcd8739ae039).toggleDebugMode)
    }));
};














const $31ed0cf6e998fd5f$export$860d8bee96747b14 = 90;
const $31ed0cf6e998fd5f$var$feedSectionEntrance = null;
const $31ed0cf6e998fd5f$var$animatedFeedSectionStyles = null;
const $31ed0cf6e998fd5f$export$88a8e03778d59330 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, index: index, isEnabled: isEnabled, testId: testId } = t0;
    if (!isEnabled) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    const t1 = `${index * $31ed0cf6e998fd5f$export$860d8bee96747b14}ms`;
    let t2;
    if ($[2] !== t1) {
        t2 = {
            animationDelay: t1
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const style = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_1gBibyLvav _0nFVCGwiJJ _43vdfT3jQl _3Y6bKp38c8 _39Ohv4YbGa _1SdfoHYbGa"
        ]);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== style || $[7] !== t3 || $[8] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            style: style,
            className: t3
        }, children);
        $[5] = children;
        $[6] = style;
        $[7] = t3;
        $[8] = testId;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, index: index, isEnabled: isEnabled, testId: testId })=>{
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const style = {
        animationDelay: `${index * $31ed0cf6e998fd5f$export$860d8bee96747b14}ms`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        style: style,
        className: (0, $hekY6.default)([
            "_1gBibyLvav _0nFVCGwiJJ _43vdfT3jQl _3Y6bKp38c8 _39Ohv4YbGa _1SdfoHYbGa"
        ])
    }, children);
};












var $a1ZzW = parcelRequire("a1ZzW");




var $1l0kj = parcelRequire("1l0kj");


var $aIn0d = parcelRequire("aIn0d");

const $6615ee31bf93d5ae$var$styles = {
    root: "_4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0KLXrulfZc"
};
const $6615ee31bf93d5ae$export$521d6a85dda09ec9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6615ee31bf93d5ae$var$styles.root,
            testId: "insights-feed-ai-disclaimer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), {
            withLink: true
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6615ee31bf93d5ae$var$styles.root,
        testId: "insights-feed-ai-disclaimer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), {
        withLink: true
    })));


















var $I7hWB = parcelRequire("I7hWB");


var $24dy7 = parcelRequire("24dy7");













const $0c8669a8fa4ede47$var$message = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "rovo-growth-pulse.insights-feed.error.title",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "rovo-growth-pulse.insights-feed.error.description",
        defaultMessage: "We couldn\u2019t load your insights. Check your connection and try again."
    },
    retryButton: {
        id: "rovo-growth-pulse.insights-feed.error.retry-button",
        defaultMessage: "Try again"
    }
});
var $0c8669a8fa4ede47$export$2e2bcd8739ae039 = $0c8669a8fa4ede47$var$message;


const $61f5479ff8b33c43$var$styles = {
    container: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _2O5Vij7dHp _0Of8r2p0Oa _1wydGWp0Oa _2Zuz6QVa5s _1ZnuxbVa5s _2fwxA5DIqT",
    iconWrapper: "_1wydGW5zaO",
    buttonWrapper: "_0Of8r2NHnM"
};
const $61f5479ff8b33c43$export$a40a0d17d63f9975 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { onRetry: onRetry, testId: t1 } = t0;
    const testId = t1 === undefined ? "insights-feed-error" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $61f5479ff8b33c43$var$styles.iconWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            size: "medium"
        }));
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0c8669a8fa4ede47$export$2e2bcd8739ae039).errorTitle));
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "center"
        }, t3, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text.subtle"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0c8669a8fa4ede47$export$2e2bcd8739ae039).errorDescription)));
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== onRetry || $[4] !== testId) {
        t5 = onRetry && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $61f5479ff8b33c43$var$styles.buttonWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onRetry,
            testId: `${testId}__retry-button`
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0c8669a8fa4ede47$export$2e2bcd8739ae039).retryButton)));
        $[3] = onRetry;
        $[4] = testId;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5 || $[7] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $61f5479ff8b33c43$var$styles.container,
            testId: testId
        }, t2, t4, t5);
        $[6] = t5;
        $[7] = testId;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ onRetry: onRetry, testId: testId = 'insights-feed-error' })=>/*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: $61f5479ff8b33c43$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $61f5479ff8b33c43$var$styles.iconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        size: "medium"
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0c8669a8fa4ede47$export$2e2bcd8739ae039).errorTitle)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0c8669a8fa4ede47$export$2e2bcd8739ae039).errorDescription))), onRetry && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $61f5479ff8b33c43$var$styles.buttonWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onRetry,
        testId: `${testId}__retry-button`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0c8669a8fa4ede47$export$2e2bcd8739ae039).retryButton))));















var $lSQgn = parcelRequire("lSQgn");


























var $2pOgk = parcelRequire("2pOgk");














var $bcDqz = parcelRequire("bcDqz");


var $hSs5g = parcelRequire("hSs5g");

var $5hJlu = parcelRequire("5hJlu");


var $jjhH6 = parcelRequire("jjhH6");

/**
 * Format a list of full names into a comma-separated string of first names,
 * with an ampersand between the last two names.
 *
 * The first name is derived by splitting the full display name on whitespace
 * and taking the first token. The backend currently only provides a single
 * `name` field (full display name), so this is the best we can do client-side.
 *
 * Examples (assuming first names are derivable from the input):
 *   []                         -> ''
 *   ['Amira Badran']           -> 'Amira'
 *   ['Amira', 'Anya Smith']    -> 'Amira & Anya'
 *   ['Amira', 'Anya', 'Blaze'] -> 'Amira, Anya & Blaze'
 *
 * The function formats any number of names, but callers are responsible for
 * suppressing the output when the count exceeds maxCount (per design).
 */ const $20520348fa46ec60$export$80b286440602e4a6 = (fullNames)=>{
    const firstNames = fullNames.map((name)=>name.trim().split(/\s+/)[0]).filter(Boolean);
    if (firstNames.length === 0) return '';
    if (firstNames.length === 1) return firstNames[0];
    if (firstNames.length === 2) return `${firstNames[0]} & ${firstNames[1]}`;
    // 3 names: "A, B & C"
    const head = firstNames.slice(0, -1).join(', ');
    const tail = firstNames[firstNames.length - 1];
    return `${head} & ${tail}`;
};


const $58d3258b3d35f149$var$getCloudId = ()=>{
    if (typeof document === 'undefined') return undefined;
    return document.querySelector('meta[name="ajs-cloud-id"]')?.content;
};
let $58d3258b3d35f149$var$profileClientInstance;
const $58d3258b3d35f149$var$getProfileClient = ()=>{
    if (!$58d3258b3d35f149$var$profileClientInstance) $58d3258b3d35f149$var$profileClientInstance = new (0, $5hJlu.default)({
        cacheMaxAge: 86400000,
        cacheSize: 1000,
        url: '/gateway/api/directory/graphql'
    });
    return $58d3258b3d35f149$var$profileClientInstance;
};
const $58d3258b3d35f149$var$styles = {
    container: "_2mHwu8gVvo _4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _4ouGXIdnbC _1EqgXlN91d",
    names: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _4ouGXIdnbC _1EqgXllQqW _3YEZNO7dHp _39HuIbz8Lp _1ANEUSLRg7"
};
const $58d3258b3d35f149$export$5f27de8db37a44b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { people: people, testId: t1, maxCount: t2, namesFirst: t3 } = t0;
    const testId = t1 === undefined ? "insight-avatar-group" : t1;
    const maxCount = t2 === undefined ? 3 : t2;
    const namesFirst = t3 === undefined ? false : t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = $58d3258b3d35f149$var$getCloudId();
        $[0] = t4;
    } else t4 = $[0];
    const cloudId = t4;
    const renderProfileTrigger = (0, $jjhH6.useProfileTrigger)();
    const showNames = people.length > 0 && people.length <= maxCount;
    let t5;
    if ($[1] !== people || $[2] !== showNames) {
        t5 = showNames ? (0, $20520348fa46ec60$export$80b286440602e4a6)(people.map($58d3258b3d35f149$var$_temp)) : "";
        $[1] = people;
        $[2] = showNames;
        $[3] = t5;
    } else t5 = $[3];
    const namesText = t5;
    let t6;
    if ($[4] !== people) {
        t6 = people.map($58d3258b3d35f149$var$_temp2);
        $[4] = people;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== renderProfileTrigger) {
        t7 = {
            Avatar: {
                render: (Component, props, index)=>{
                    const aaid = props.key;
                    const avatarItem = /*#__PURE__*/ $cozmU.createElement(Component, {
                        ...props,
                        key: `profile-avatar-${props.key ?? index}`
                    });
                    if (typeof aaid === "string" && cloudId) {
                        if (renderProfileTrigger) return renderProfileTrigger({
                            userId: aaid,
                            cloudId: cloudId,
                            children: avatarItem
                        });
                        return /*#__PURE__*/ $cozmU.createElement((0, $hSs5g.default), {
                            key: `profile-avatar-${props.key ?? index}`,
                            resourceClient: $58d3258b3d35f149$var$getProfileClient(),
                            cloudId: cloudId,
                            userId: aaid
                        }, avatarItem);
                    }
                    return avatarItem;
                }
            }
        };
        $[6] = renderProfileTrigger;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== maxCount || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
            testId: testId,
            appearance: "stack",
            size: "small",
            maxCount: maxCount,
            isTooltipDisabled: true,
            data: t6,
            overrides: t7
        });
        $[8] = maxCount;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    const avatarGroup = t8;
    let t9;
    if ($[13] !== namesText || $[14] !== testId) {
        t9 = namesText ? /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": `${testId}-names`,
            className: (0, $hekY6.default)([
                $58d3258b3d35f149$var$styles.names
            ])
        }, namesText) : null;
        $[13] = namesText;
        $[14] = testId;
        $[15] = t9;
    } else t9 = $[15];
    const namesElement = t9;
    let t10;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            $58d3258b3d35f149$var$styles.container
        ]);
        $[16] = t10;
    } else t10 = $[16];
    const t11 = namesFirst && namesElement;
    const t12 = !namesFirst && namesElement;
    let t13;
    if ($[17] !== avatarGroup || $[18] !== t11 || $[19] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t10
        }, t11, avatarGroup, t12);
        $[17] = avatarGroup;
        $[18] = t11;
        $[19] = t12;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ people: people, testId: testId = 'insight-avatar-group', maxCount: maxCount = 3, namesFirst: namesFirst = false })=>{
    const cloudId = $58d3258b3d35f149$var$getCloudId(); // Injected by a provider outside the ai-mate cluster (keeps this package free of a
    // direct @atlassian/user-profile-card dependency). Falls back to legacy when absent.
    const renderProfileTrigger = (0, $jjhH6.useProfileTrigger)(); // Only show the first-name text when the number of people fits within the
    // max avatar count. When there are more, AvatarGroup uses the last visible
    // slot as the overflow trigger, which stands in for the remaining people.
    const showNames = people.length > 0 && people.length <= maxCount;
    const namesText = showNames ? (0, $20520348fa46ec60$export$80b286440602e4a6)(people.map((p)=>p.name)) : '';
    const avatarGroup = /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
        testId: testId,
        appearance: "stack",
        size: "small",
        maxCount: maxCount,
        isTooltipDisabled: true,
        data: people.map((person)=>({
                name: person.name,
                src: person.avatarUrl,
                key: person.aaid
            })),
        overrides: {
            Avatar: {
                render: (Component, props, index)=>{
                    const aaid = props.key;
                    const avatarItem = /*#__PURE__*/ $cozmU.createElement(Component, {
                        ...props,
                        key: `profile-avatar-${props.key ?? index}`
                    });
                    if (typeof aaid === 'string' && cloudId) {
                        if (renderProfileTrigger) return renderProfileTrigger({
                            userId: aaid,
                            cloudId: cloudId,
                            children: avatarItem
                        });
                        return /*#__PURE__*/ $cozmU.createElement((0, $hSs5g.default), {
                            key: `profile-avatar-${props.key ?? index}`,
                            resourceClient: $58d3258b3d35f149$var$getProfileClient(),
                            cloudId: cloudId,
                            userId: aaid
                        }, avatarItem);
                    }
                    return avatarItem;
                }
            }
        }
    });
    const namesElement = namesText ? /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-names`,
        className: (0, $hekY6.default)([
            $58d3258b3d35f149$var$styles.names
        ])
    }, namesText) : null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $58d3258b3d35f149$var$styles.container
        ])
    }, namesFirst && namesElement, avatarGroup, !namesFirst && namesElement);
};
function $58d3258b3d35f149$var$_temp(p) {
    return p.name;
}
function $58d3258b3d35f149$var$_temp2(person) {
    return {
        name: person.name,
        src: person.avatarUrl,
        key: person.aaid
    };
}


const $97ae465b9296e651$var$styles = {
    card: "_2mHwu82ADO _39xV02N91d _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLchRC _46hvQm5zaO _0xmtkoPgdg _0LQT5E5zaO _03SyCP5zaO _0wOv4Q7zJH _0KLXrujOvk",
    textSection: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _1EqgXlrfJe _2O5Vij7dHp _4ouGXIdnbC _2fwxA5ecOK",
    bottomSection: "_3iDTPbQ4SZ _0hPCNLDIqT _0LQT5E5zaO _03SyCP5zaO _0xmtko5zaO",
    bottomSectionWithoutLinks: "_3iDTPbQ4SZ _0hPCNLDIqT _0LQT5E5zaO _03SyCP5zaO _46hvQm8HPE _0xmtko5zaO",
    bottomSectionFullScreen: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7 _0LQT5E5zaO _03SyCP5zaO _0xmtko5zaO",
    linkGroupFullScreen: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _1pp6NdYbGa _4ouGXIdnbC _1EqgXlN91d",
    avatarContainerFullScreen: "_4ouGXIdnbC _1EqgXlN91d _3YEZNOdnbC _4xdlr0z9WS",
    avatarContainerFullScreenWithSpacing: "_4ouGXIdnbC _1EqgXlN91d _3YEZNOdnbC _4xdlr0z9WS _46hvQm2ADO"
};
// Cards live inside a shared bordered+rounded container (overflow:hidden clips corners).
// No individual card borders — rely on group-level border.
// overflow:hidden on ALL positions ensures content clips to the rounded shape —
// child elements (e.g. Pressable) do NOT need their own borderRadius.
// Hover/active/cursor styles live here so the entire card area — including the
// link-cards section below the Pressable — highlights on mouse interaction.
// position:relative anchors the Pressable's absolute click-overlay to the whole card.
const $97ae465b9296e651$var$positionStyles = {
    only: "_4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6mhAQ",
    first: "_4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6mhAQ",
    middle: "_4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6mhAQ",
    last: "_4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6mhAQ"
}; // Vendor-prefixed styles — use @compiled/react cssMap (unbounded)
// because @atlaskit/css cssMap rejects vendor-prefixed props.
const $97ae465b9296e651$var$vendorStyles = {
    titleClampDefault: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbgJ9S _4Gn54R7LI7 _1U1ZhbbI28 _1UtDYzy7kJ",
    titleClampFullScreen: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28 _1UtDYzy7kJ",
    titleWeight: "_1kk5Tkf7mX",
    meetingTitlePrimaryDefaultLines: "_4Gn54RiZR3",
    meetingTitlePrimaryFullScreenLines: "_4Gn54R7dHp",
    meetingTitleSecondary: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbvLZJ _1ANEUSLRg7 _39HuIbz8Lp _1UtDYzy7kJ",
    descriptionClamp: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbgJ9S _39xV02N91d _4Gn54RiZR3 _1U1ZhbbI28 _39HuIbz8Lp _1UtDYzKGUX",
    delimiter: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    clickOverlay: "_1mT5xdWVPG _2I62gzPgdg _3iC0zdPgdg _1ZB6UyPgdg _1OKFqYPgdg",
    linkGroupWrapper: "_1mT5xdRAKS _1pp6NdYbGa _0LQT5E5zaO _03SyCP5zaO _0xmtko8HPE",
    linkGroupWrapperWithoutPeople: "_1mT5xdRAKS _1pp6NdYbGa _0LQT5E5zaO _03SyCP5zaO _0xmtko5zaO",
    linkInteractive: "_1pp6NdIZbP",
    bottomPadding: "_0xmtko5zaO"
}; /** Controls border-radius and border per card position within a group list. */ 
const $97ae465b9296e651$export$f10b743adc8a53 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { item: item, onInsightPress: onInsightPress, position: t1, isFullScreen: t2, onLinkClick: onLinkClick } = t0;
    const position = t1 === undefined ? "only" : t1;
    const isFullScreen = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== item.id || $[1] !== onInsightPress) {
        t3 = ()=>{
            onInsightPress(item.id);
        };
        $[0] = item.id;
        $[1] = onInsightPress;
        $[2] = t3;
    } else t3 = $[2];
    const handleClick = t3;
    const hasDelimiter = position === "first" || position === "middle";
    const urlList = item.urls && item.urls.length > 0 ? item.urls : null;
    const hasPeople = item.people && item.people.length > 0;
    let t4;
    if ($[3] !== hasPeople || $[4] !== isFullScreen || $[5] !== item.people) {
        t4 = hasPeople ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58d3258b3d35f149$export$5f27de8db37a44b), {
            people: item.people,
            testId: "insight-card-avatars",
            namesFirst: isFullScreen
        }) : null;
        $[3] = hasPeople;
        $[4] = isFullScreen;
        $[5] = item.people;
        $[6] = t4;
    } else t4 = $[6];
    const avatarElement = t4;
    let t5;
    if ($[7] !== isFullScreen || $[8] !== onLinkClick || $[9] !== urlList) {
        t5 = urlList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.linkInteractive
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2pOgk.InsightLinkCardGroup), {
            urls: urlList,
            isFullScreen: isFullScreen,
            onLinkClick: onLinkClick
        })) : null;
        $[7] = isFullScreen;
        $[8] = onLinkClick;
        $[9] = urlList;
        $[10] = t5;
    } else t5 = $[10];
    const linkCardGroupElement = t5;
    const t6 = `generic-insight-cell-${item.id}`;
    const t7 = $97ae465b9296e651$var$positionStyles[position];
    let t8;
    if ($[11] !== t7) {
        t8 = (0, $hekY6.default)([
            t7
        ]);
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.clickOverlay
            ])
        });
        $[13] = t9;
    } else t9 = $[13];
    const t10 = isFullScreen ? "space.150" : "space.100";
    let t11;
    if ($[14] !== isFullScreen || $[15] !== item.title || $[16] !== item.titleSecondary) {
        t11 = item.titleSecondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                isFullScreen ? $97ae465b9296e651$var$vendorStyles.titleClampFullScreen : $97ae465b9296e651$var$vendorStyles.titleClampDefault,
                $97ae465b9296e651$var$vendorStyles.titleWeight,
                isFullScreen ? $97ae465b9296e651$var$vendorStyles.meetingTitlePrimaryFullScreenLines : $97ae465b9296e651$var$vendorStyles.meetingTitlePrimaryDefaultLines
            ])
        }, item.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.meetingTitleSecondary,
                $97ae465b9296e651$var$vendorStyles.titleWeight
            ])
        }, item.titleSecondary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                isFullScreen ? $97ae465b9296e651$var$vendorStyles.titleClampFullScreen : $97ae465b9296e651$var$vendorStyles.titleClampDefault,
                $97ae465b9296e651$var$vendorStyles.titleWeight
            ])
        }, item.title);
        $[14] = isFullScreen;
        $[15] = item.title;
        $[16] = item.titleSecondary;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.descriptionClamp
        ]);
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== item.description) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t12
        }, item.description);
        $[19] = item.description;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== t10 || $[22] !== t11 || $[23] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $97ae465b9296e651$var$styles.textSection,
            direction: "column",
            gap: t10
        }, t11, t13);
        $[21] = t10;
        $[22] = t11;
        $[23] = t13;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== handleClick || $[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $97ae465b9296e651$var$styles.card,
            onClick: handleClick
        }, t9, t14);
        $[25] = handleClick;
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== avatarElement || $[29] !== isFullScreen || $[30] !== linkCardGroupElement || $[31] !== urlList) {
        t16 = isFullScreen ? urlList || avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $97ae465b9296e651$var$styles.bottomSectionFullScreen,
            justifyContent: urlList && avatarElement ? "space-between" : avatarElement ? "end" : "start"
        }, urlList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97ae465b9296e651$var$styles.linkGroupFullScreen
        }, linkCardGroupElement), avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: urlList ? $97ae465b9296e651$var$styles.avatarContainerFullScreen : $97ae465b9296e651$var$styles.avatarContainerFullScreenWithSpacing
        }, avatarElement) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.bottomPadding
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, urlList && avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.linkGroupWrapper
            ])
        }, linkCardGroupElement) : null, urlList && !avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.linkGroupWrapperWithoutPeople
            ])
        }, linkCardGroupElement) : null, avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: urlList ? $97ae465b9296e651$var$styles.bottomSection : $97ae465b9296e651$var$styles.bottomSectionWithoutLinks
        }, avatarElement) : null, !urlList && !avatarElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.bottomPadding
            ])
        }));
        $[28] = avatarElement;
        $[29] = isFullScreen;
        $[30] = linkCardGroupElement;
        $[31] = urlList;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== hasDelimiter) {
        t17 = hasDelimiter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $97ae465b9296e651$var$vendorStyles.delimiter
            ])
        });
        $[33] = hasDelimiter;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] !== t15 || $[36] !== t16 || $[37] !== t17 || $[38] !== t6 || $[39] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t6,
            className: t8
        }, t15, t16, t17);
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
        $[38] = t6;
        $[39] = t8;
        $[40] = t18;
    } else t18 = $[40];
    return t18;
} : ({ item: item, onInsightPress: onInsightPress, position: position = 'only', isFullScreen: isFullScreen = false, onLinkClick: onLinkClick })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onInsightPress(item.id);
    }, [
        onInsightPress,
        item.id
    ]);
    const hasDelimiter = position === 'first' || position === 'middle';
    const urlList = item.urls && item.urls.length > 0 ? item.urls : null;
    const hasPeople = item.people && item.people.length > 0;
    const avatarElement = hasPeople ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58d3258b3d35f149$export$5f27de8db37a44b), {
        people: item.people,
        testId: "insight-card-avatars",
        namesFirst: isFullScreen
    }) : null;
    const linkCardGroupElement = urlList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.linkInteractive
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2pOgk.InsightLinkCardGroup), {
        urls: urlList,
        isFullScreen: isFullScreen,
        onLinkClick: onLinkClick
    })) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": `generic-insight-cell-${item.id}`,
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$positionStyles[position]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $97ae465b9296e651$var$styles.card,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.clickOverlay
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $97ae465b9296e651$var$styles.textSection,
        direction: "column",
        gap: isFullScreen ? 'space.150' : 'space.100'
    }, item.titleSecondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isFullScreen ? $97ae465b9296e651$var$vendorStyles.titleClampFullScreen : $97ae465b9296e651$var$vendorStyles.titleClampDefault,
            $97ae465b9296e651$var$vendorStyles.titleWeight,
            isFullScreen ? $97ae465b9296e651$var$vendorStyles.meetingTitlePrimaryFullScreenLines : $97ae465b9296e651$var$vendorStyles.meetingTitlePrimaryDefaultLines
        ])
    }, item.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.meetingTitleSecondary,
            $97ae465b9296e651$var$vendorStyles.titleWeight
        ])
    }, item.titleSecondary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isFullScreen ? $97ae465b9296e651$var$vendorStyles.titleClampFullScreen : $97ae465b9296e651$var$vendorStyles.titleClampDefault,
            $97ae465b9296e651$var$vendorStyles.titleWeight
        ])
    }, item.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.descriptionClamp
        ])
    }, item.description))), isFullScreen ? // Fullscreen: artifact link cards and avatar group on the same row, spaced apart
    urlList || avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $97ae465b9296e651$var$styles.bottomSectionFullScreen,
        justifyContent: urlList && avatarElement ? 'space-between' : avatarElement ? 'end' : 'start'
    }, urlList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $97ae465b9296e651$var$styles.linkGroupFullScreen
    }, linkCardGroupElement), avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: urlList ? $97ae465b9296e651$var$styles.avatarContainerFullScreen : $97ae465b9296e651$var$styles.avatarContainerFullScreenWithSpacing
    }, avatarElement) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.bottomPadding
        ])
    }) : // Sidebar: artifact link cards above, avatar group below
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, urlList && avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.linkGroupWrapper
        ])
    }, linkCardGroupElement) : null, urlList && !avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.linkGroupWrapperWithoutPeople
        ])
    }, linkCardGroupElement) : null, avatarElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: urlList ? $97ae465b9296e651$var$styles.bottomSection : $97ae465b9296e651$var$styles.bottomSectionWithoutLinks
    }, avatarElement) : null, !urlList && !avatarElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.bottomPadding
        ])
    })), hasDelimiter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $97ae465b9296e651$var$vendorStyles.delimiter
        ])
    }));
};

























const $0716349fdb99733b$var$styles = {
    cell: "_2mHwu82ADO _0bjKvDyzSk _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0Of8r25zaO _1wydGW5zaO _2Zuz6Q5zaO _1Znuxb5zaO _0wOv4Q7zJH _0KLXrujOvk",
    cellContent: "_39xV02N91d",
    metricRow: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _3TGfC9LRg7",
    metricValueWrapper: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLQame _1Znuxb2ADO _2O5Vij7dHp _4ouGXIdnbC _4kiQYAUF4f",
    avatarChevronGroup: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    descriptionSection: "_3iDTPbQ4SZ _0aFT5vbt8w _2fwxA5ecOK"
}; // Vendor-prefixed and unconstrained styles — use @compiled/react cssMap directly
const $0716349fdb99733b$var$vendorStyles = {
    metricValue: "_2sNsIgJ6H4 _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1UtDYzGL5O",
    metricUnit: "_2sNsIgEqul _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1UtDYzy7kJ",
    descriptionText: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28 _39HuIbz8Lp _1UtDYzKGUX",
    descriptionBold: "_2sNsIg7NXe _1kk5Tkf7mX _1UtDYzKGUX",
    delimiter: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    clickOverlay: "_1mT5xdWVPG _2I62gzPgdg _3iC0zdPgdg _1ZB6UyPgdg _1OKFqYPgdg",
    linkGroupWrapper: "_1mT5xdRAKS _1pp6NdYbGa _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW8HPE",
    linkInteractive: "_1pp6NdIZbP"
}; /** Controls border-radius and border per cell position within a group list. */ 
// Hover/active/cursor styles live here so the entire card area — including the
// link-cards section below the Pressable — highlights on mouse hover.
const $0716349fdb99733b$var$positionStyles = {
    only: "_4bt5LAnQyn _2WAcuGnQyn _2C2kUQKxmn _1Lz9loKxmn _1v9SsVKxmn _3XDz3BKxmn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6d1Zr _3gzVzLJNoT",
    first: "_4bt5LAnQyn _2WAcuGnQyn _2C2kUQKxmn _1Lz9loKxmn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6d1Zr _3gzVzLJNoT",
    middle: "_4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6d1Zr _3gzVzLJNoT",
    last: "_4bt5LAnQyn _2WAcuGnQyn _1v9SsVKxmn _3XDz3BKxmn _0wOv4Q7zJH _1mT5xdRAKS _0KLXruqi9L _1eOmH6d1Zr _3gzVzLJNoT"
};
const $0716349fdb99733b$export$2062a6a3996997e2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { item: item, onInsightPress: onInsightPress, position: t1, isFullScreen: t2, onLinkClick: onLinkClick } = t0;
    const position = t1 === undefined ? "only" : t1;
    const isFullScreen = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== item.id || $[1] !== onInsightPress) {
        t3 = ()=>{
            onInsightPress(item.id);
        };
        $[0] = item.id;
        $[1] = onInsightPress;
        $[2] = t3;
    } else t3 = $[2];
    const handleClick = t3;
    const hasDelimiter = position === "first" || position === "middle";
    const urlList = item.urls && item.urls.length > 0 ? item.urls : null;
    const t4 = $0716349fdb99733b$var$positionStyles[position];
    let t5;
    if ($[3] !== t4) {
        t5 = (0, $hekY6.default)([
            t4
        ]);
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $0716349fdb99733b$var$vendorStyles.clickOverlay
            ])
        });
        $[5] = t6;
    } else t6 = $[5];
    const t7 = isFullScreen ? "space.150" : "space.100";
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.metricValue
        ]);
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== item.metricValue) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t8
        }, item.metricValue);
        $[7] = item.metricValue;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.metricUnit
        ]);
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== item.metricUnit) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t10
        }, item.metricUnit);
        $[10] = item.metricUnit;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== t11 || $[13] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $0716349fdb99733b$var$styles.metricValueWrapper
        }, t9, t11);
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== item.people) {
        t13 = item.people && item.people.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58d3258b3d35f149$export$5f27de8db37a44b), {
            people: item.people,
            testId: "insight-cell-avatars"
        });
        $[15] = item.people;
        $[16] = t13;
    } else t13 = $[16];
    let t14;
    if ($[17] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $0716349fdb99733b$var$styles.avatarChevronGroup
        }, t13);
        $[17] = t13;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    if ($[19] !== t12 || $[20] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $0716349fdb99733b$var$styles.metricRow
        }, t12, t14);
        $[19] = t12;
        $[20] = t14;
        $[21] = t15;
    } else t15 = $[21];
    let t16;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.descriptionText
        ]);
        $[22] = t16;
    } else t16 = $[22];
    let t17;
    if ($[23] !== item.descriptionBoldPrefix) {
        t17 = item.descriptionBoldPrefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $0716349fdb99733b$var$vendorStyles.descriptionBold
            ])
        }, item.descriptionBoldPrefix);
        $[23] = item.descriptionBoldPrefix;
        $[24] = t17;
    } else t17 = $[24];
    const t18 = item.descriptionBoldPrefix ? " " : "";
    let t19;
    if ($[25] !== item.description || $[26] !== t17 || $[27] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0716349fdb99733b$var$styles.descriptionSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t16
        }, t17, t18, item.description));
        $[25] = item.description;
        $[26] = t17;
        $[27] = t18;
        $[28] = t19;
    } else t19 = $[28];
    let t20;
    if ($[29] !== t15 || $[30] !== t19 || $[31] !== t7) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: t7,
            xcss: $0716349fdb99733b$var$styles.cellContent
        }, t15, t19);
        $[29] = t15;
        $[30] = t19;
        $[31] = t7;
        $[32] = t20;
    } else t20 = $[32];
    let t21;
    if ($[33] !== handleClick || $[34] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $0716349fdb99733b$var$styles.cell,
            onClick: handleClick
        }, t6, t20);
        $[33] = handleClick;
        $[34] = t20;
        $[35] = t21;
    } else t21 = $[35];
    let t22;
    if ($[36] !== isFullScreen || $[37] !== onLinkClick || $[38] !== urlList) {
        t22 = urlList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $0716349fdb99733b$var$vendorStyles.linkGroupWrapper
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $0716349fdb99733b$var$vendorStyles.linkInteractive
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2pOgk.InsightLinkCardGroup), {
            urls: urlList,
            isFullScreen: isFullScreen,
            onLinkClick: onLinkClick
        })));
        $[36] = isFullScreen;
        $[37] = onLinkClick;
        $[38] = urlList;
        $[39] = t22;
    } else t22 = $[39];
    let t23;
    if ($[40] !== hasDelimiter) {
        t23 = hasDelimiter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $0716349fdb99733b$var$vendorStyles.delimiter
            ])
        });
        $[40] = hasDelimiter;
        $[41] = t23;
    } else t23 = $[41];
    let t24;
    if ($[42] !== t21 || $[43] !== t22 || $[44] !== t23 || $[45] !== t5) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t5
        }, t21, t22, t23);
        $[42] = t21;
        $[43] = t22;
        $[44] = t23;
        $[45] = t5;
        $[46] = t24;
    } else t24 = $[46];
    return t24;
} : ({ item: item, onInsightPress: onInsightPress, position: position = 'only', isFullScreen: isFullScreen = false, onLinkClick: onLinkClick })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onInsightPress(item.id);
    }, [
        onInsightPress,
        item.id
    ]);
    const hasDelimiter = position === 'first' || position === 'middle';
    const urlList = item.urls && item.urls.length > 0 ? item.urls : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$positionStyles[position]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $0716349fdb99733b$var$styles.cell,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.clickOverlay
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: isFullScreen ? 'space.150' : 'space.100',
        xcss: $0716349fdb99733b$var$styles.cellContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $0716349fdb99733b$var$styles.metricRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $0716349fdb99733b$var$styles.metricValueWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.metricValue
        ])
    }, item.metricValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.metricUnit
        ])
    }, item.metricUnit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $0716349fdb99733b$var$styles.avatarChevronGroup
    }, item.people && item.people.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58d3258b3d35f149$export$5f27de8db37a44b), {
        people: item.people,
        testId: "insight-cell-avatars"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0716349fdb99733b$var$styles.descriptionSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.descriptionText
        ])
    }, item.descriptionBoldPrefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.descriptionBold
        ])
    }, item.descriptionBoldPrefix), item.descriptionBoldPrefix ? ' ' : '', item.description)))), urlList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.linkGroupWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.linkInteractive
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2pOgk.InsightLinkCardGroup), {
        urls: urlList,
        isFullScreen: isFullScreen,
        onLinkClick: onLinkClick
    }))), hasDelimiter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0716349fdb99733b$var$vendorStyles.delimiter
        ])
    }));
};


const $7292d9f50aa149ae$var$styles = {
    groupItem: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _46hvQm2ADO",
    headerButton: "_39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _46hvQm2ADO _0xmtko8HPE _0LQT5EdnbC _03SyCPdnbC",
    headerRow: "_2mHwu82ADO _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT",
    titleSection: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _2O5VijdnbC",
    subItemsContainer: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _43nrzTdnbC _0rIjyk5zaO _0GTcwRdnbC _2xTnZxdnbC"
};
const $7292d9f50aa149ae$export$90d156cbbda6692f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { item: item, onInsightPress: onInsightPress, headerExtra: headerExtra, renderSubItemExtra: renderSubItemExtra, isFullScreen: t1, onLinkClick: onLinkClick } = t0;
    const isFullScreen = t1 === undefined ? false : t1;
    const t2 = `insights-feed-group-${item.category}`;
    let t3;
    if ($[0] !== item.icon || $[1] !== item.iconAppearance || $[2] !== item.title) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            icon: item.icon,
            label: item.title,
            appearance: item.iconAppearance,
            size: "small"
        }));
        $[0] = item.icon;
        $[1] = item.iconAppearance;
        $[2] = item.title;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== item.title) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $7292d9f50aa149ae$var$styles.titleSection
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, item.title));
        $[4] = item.title;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7292d9f50aa149ae$var$styles.headerButton
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $7292d9f50aa149ae$var$styles.headerRow
        }, t3, t4));
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = `insights-feed-group-items-${item.category}`;
    let t7;
    if ($[9] !== isFullScreen || $[10] !== item.subItems || $[11] !== onInsightPress || $[12] !== onLinkClick || $[13] !== renderSubItemExtra) {
        t7 = item.subItems?.map((subItem, index)=>{
            const total = item.subItems.length;
            let position;
            if (total === 1) position = "only";
            else {
                if (index === 0) position = "first";
                else if (index === total - 1) position = "last";
                else position = "middle";
            }
            if (subItem.layout === "trending-content") return /*#__PURE__*/ $cozmU.createElement((0, $0716349fdb99733b$export$2062a6a3996997e2), {
                key: subItem.id,
                item: {
                    ...subItem,
                    metricValue: subItem.metricValue ?? "",
                    metricUnit: subItem.metricUnit ?? ""
                },
                position: position,
                onInsightPress: onInsightPress,
                isFullScreen: isFullScreen,
                onLinkClick: onLinkClick
            });
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                key: subItem.id
            }, /*#__PURE__*/ $cozmU.createElement((0, $97ae465b9296e651$export$f10b743adc8a53), {
                item: subItem,
                position: position,
                onInsightPress: onInsightPress,
                isFullScreen: isFullScreen,
                onLinkClick: onLinkClick
            }), renderSubItemExtra?.(subItem));
        });
        $[9] = isFullScreen;
        $[10] = item.subItems;
        $[11] = onInsightPress;
        $[12] = onLinkClick;
        $[13] = renderSubItemExtra;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7292d9f50aa149ae$var$styles.subItemsContainer,
            testId: t6
        }, t7);
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== headerExtra || $[19] !== t2 || $[20] !== t5 || $[21] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7292d9f50aa149ae$var$styles.groupItem,
            testId: t2
        }, t5, headerExtra, t8);
        $[18] = headerExtra;
        $[19] = t2;
        $[20] = t5;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : ({ item: item, onInsightPress: onInsightPress, headerExtra: headerExtra, renderSubItemExtra: renderSubItemExtra, isFullScreen: isFullScreen = false, onLinkClick: onLinkClick })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7292d9f50aa149ae$var$styles.groupItem,
        testId: `insights-feed-group-${item.category}`
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7292d9f50aa149ae$var$styles.headerButton
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $7292d9f50aa149ae$var$styles.headerRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
        icon: item.icon,
        label: item.title,
        appearance: item.iconAppearance,
        size: "small"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $7292d9f50aa149ae$var$styles.titleSection
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, item.title)))), headerExtra, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7292d9f50aa149ae$var$styles.subItemsContainer,
        testId: `insights-feed-group-items-${item.category}`
    }, item.subItems?.map((subItem, index)=>{
        const total = item.subItems.length;
        let position;
        if (total === 1) position = 'only';
        else if (index === 0) position = 'first';
        else if (index === total - 1) position = 'last';
        else position = 'middle';
        if (subItem.layout === 'trending-content') return /*#__PURE__*/ $cozmU.createElement((0, $0716349fdb99733b$export$2062a6a3996997e2), {
            key: subItem.id,
            item: {
                ...subItem,
                metricValue: subItem.metricValue ?? '',
                metricUnit: subItem.metricUnit ?? ''
            },
            position: position,
            onInsightPress: onInsightPress,
            isFullScreen: isFullScreen,
            onLinkClick: onLinkClick
        });
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: subItem.id
        }, /*#__PURE__*/ $cozmU.createElement((0, $97ae465b9296e651$export$f10b743adc8a53), {
            item: subItem,
            position: position,
            onInsightPress: onInsightPress,
            isFullScreen: isFullScreen,
            onLinkClick: onLinkClick
        }), renderSubItemExtra?.(subItem));
    })));
};
































const $004abc2094aee036$export$822cdd78febe6c96 = (0, $kSwu1.defineMessages)({
    generatedAt: {
        id: "rovo-growth-pulse.common.messages.generatedAt",
        defaultMessage: "Generated {day, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} {month}"
    }
}); /* eslint-enable @atlassian/i18n/enforce-icu-format, @atlassian/i18n/blocklist-elements */ 















var $cJ0FD = parcelRequire("cJ0FD");





var $9NPFC = parcelRequire("9NPFC");

var $2562d2031211559c$exports = {};
$2562d2031211559c$exports = new URL("generative-indicator.ec5627c1.svg", import.meta.url).toString();











const $eb47661d16286be1$var$generativeIndicatorOutlinePath = 'M8.11719 1.00879C8.38352 1.05062 8.61063 1.23423 8.70508 1.49316L10.2549 5.74414L14.5068 7.29492C14.8027 7.40285 14.9998 7.6841 15 7.99902V8.00098C14.9998 8.3159 14.8027 8.59715 14.5068 8.70508L10.2549 10.2549L8.70508 14.5068C8.59715 14.8027 8.3159 14.9998 8.00098 15H7.99902C7.6841 14.9998 7.40285 14.8027 7.29492 14.5068L5.74414 10.2549L1.49316 8.70508C1.19728 8.59715 1.00018 8.3159 1 8.00098V7.99902C1.00018 7.6841 1.19728 7.40285 1.49316 7.29492L5.74414 5.74414L7.29492 1.49316L7.34277 1.38672C7.47321 1.15076 7.72343 1.00016 7.99902 1H8.00098L8.11719 1.00879Z';
const $eb47661d16286be1$export$c4293a633e573f5f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { primaryColor: primaryColor, testId: testId } = t0;
    let t1;
    if ($[0] !== primaryColor) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: $eb47661d16286be1$var$generativeIndicatorOutlinePath,
            stroke: primaryColor,
            strokeLinejoin: "round",
            strokeWidth: 1.5
        });
        $[0] = primaryColor;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            "aria-hidden": "true",
            "data-testid": testId,
            fill: "none",
            focusable: "false",
            height: "20",
            viewBox: "0 0 16 16",
            width: "20",
            xmlns: "http://www.w3.org/2000/svg"
        }, t1);
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ primaryColor: primaryColor, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "aria-hidden": "true",
        "data-testid": testId,
        fill: "none",
        focusable: "false",
        height: "20",
        viewBox: "0 0 16 16",
        width: "20",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: $eb47661d16286be1$var$generativeIndicatorOutlinePath,
        stroke: primaryColor,
        strokeLinejoin: "round",
        strokeWidth: 1.5
    }));





const $16709114dc5b025a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    pulseTileLabel: {
        id: "rovo-growth-pulse.pulse-tile.label.V3",
        defaultMessage: "Rovo Insights"
    }
});


const $92db9dd378ea9422$var$styles = {
    iconWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $92db9dd378ea9422$export$b2ab96b128cdb752 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { testId: t1, size: t2, appearance: t3, backgroundColor: t4, hasBorder: t5 } = t0;
    const testId = t1 === undefined ? "pulse-tile" : t1;
    const size = t2 === undefined ? "xlarge" : t2;
    const appearance = t3 === undefined ? "colorful" : t3;
    const backgroundColor = t4 === undefined ? "color.background.neutral" : t4;
    const hasBorder = t5 === undefined ? false : t5;
    const intl = (0, $kSwu1.useIntl)();
    let t6;
    if ($[0] !== intl) {
        t6 = intl.formatMessage((0, $16709114dc5b025a$export$defe85febe8b728c).pulseTileLabel);
        $[0] = intl;
        $[1] = t6;
    } else t6 = $[1];
    let t7;
    if ($[2] !== appearance || $[3] !== testId) {
        t7 = appearance === "monochrome" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb47661d16286be1$export$c4293a633e573f5f), {
            primaryColor: "var(--ds-icon-subtle, #505258)",
            testId: `${testId}-single-color-monochrome-icon`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $92db9dd378ea9422$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2562d2031211559c$exports))),
            alt: ""
        }));
        $[2] = appearance;
        $[3] = testId;
        $[4] = t7;
    } else t7 = $[4];
    let t8;
    if ($[5] !== backgroundColor || $[6] !== hasBorder || $[7] !== size || $[8] !== t6 || $[9] !== t7 || $[10] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: t6,
            size: size,
            backgroundColor: backgroundColor,
            hasBorder: hasBorder,
            testId: testId
        }, t7);
        $[5] = backgroundColor;
        $[6] = hasBorder;
        $[7] = size;
        $[8] = t6;
        $[9] = t7;
        $[10] = testId;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ testId: testId = 'pulse-tile', size: size = 'xlarge', appearance: appearance = 'colorful', backgroundColor: backgroundColor = 'color.background.neutral', hasBorder: hasBorder = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: intl.formatMessage((0, $16709114dc5b025a$export$defe85febe8b728c).pulseTileLabel),
        size: size,
        backgroundColor: backgroundColor,
        hasBorder: hasBorder,
        testId: testId
    }, appearance === 'monochrome' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb47661d16286be1$export$c4293a633e573f5f), {
        primaryColor: "var(--ds-icon-subtle, #505258)",
        testId: `${testId}-single-color-monochrome-icon`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $92db9dd378ea9422$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2562d2031211559c$exports))),
        alt: ""
    })));
};


/**
 * Formats a UTC ISO-8601 timestamp into a human-readable date string
 * using react-intl's formatMessage with {day} and {month} placeholders.
 *
 * Example: "2025-05-19T02:30:00Z" → "Generated 19th May" (en, via selectordinal)
 *                                 → "Généré le 19 mai" (fr, via translation)
 *
 * Date values are derived from the user's local timezone so the displayed date
 * matches what the user sees on their own clock.
 */ function $13854e22d2f33375$export$8c68a43a9bc19046(isoTimestamp, formatMessage, message, locale, timeZone) {
    if (!isoTimestamp) return undefined;
    const date = new Date(isoTimestamp);
    if (isNaN(date.getTime())) return undefined;
    // Use the user's local timezone by default so the date matches what they see on their clock.
    const dateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        ...timeZone ? {
            timeZone: timeZone
        } : {}
    };
    const parts = new Intl.DateTimeFormat(locale ?? undefined, dateTimeFormatOptions).formatToParts(date);
    const day = Number(parts.find((part)=>part.type === 'day')?.value);
    const month = parts.find((part)=>part.type === 'month')?.value;
    return formatMessage(message, {
        day: day,
        month: month
    });
}



















var $9HdWb = parcelRequire("9HdWb");


var $7wqCp = parcelRequire("7wqCp");


var $edkvd = parcelRequire("edkvd");







var $90c8o = parcelRequire("90c8o");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0b81f2aa2e25e0d5c338278b466b81b>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $2484f66e2e897ec7$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#bbe2ff" d="M13.107 14.91A4.91 4.91 0 0 1 18.016 10h12a4.91 4.91 0 0 1 4.91 4.91v5.18a4.91 4.91 0 0 1-4.91 4.91h-12a4.91 4.91 0 0 1-4.91-4.91z"/><path fill="#3c90ff" d="M11.039 17.057a4.432 4.432 0 0 1 4.394-5.01h17.166a4.432 4.432 0 0 1 4.394 5.01L35.948 25l1.045 7.945a4.432 4.432 0 0 1-4.394 5.01H15.433a4.432 4.432 0 0 1-4.394-5.01L12.084 25z"/><mask id="mask0_118280_5567" width="27" height="26" x="11" y="12" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#3c90ff" d="M11.039 17.057a4.432 4.432 0 0 1 4.394-5.01h17.166a4.432 4.432 0 0 1 4.394 5.01L35.948 25l1.045 7.945a4.432 4.432 0 0 1-4.394 5.01H15.433a4.432 4.432 0 0 1-4.394-5.01L12.084 25z"/></mask><g mask="url(#mask0_118280_5567)"><path fill="url(#paint0_linear_118280_5567)" d="M9.868 37.957h28.296V25.003H9.868z"/></g><mask id="mask1_118280_5567" width="27" height="26" x="11" y="12" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#3186ff" d="M11.039 17.057a4.432 4.432 0 0 1 4.394-5.01h17.166a4.432 4.432 0 0 1 4.394 5.01L35.948 25l1.045 7.945a4.432 4.432 0 0 1-4.394 5.01H15.433a4.432 4.432 0 0 1-4.394-5.01L12.084 25z"/></mask><g filter="url(#filter0_f_118280_5567)" mask="url(#mask1_118280_5567)"><path fill="url(#paint1_linear_118280_5567)" d="M13.107 13.273A3.273 3.273 0 0 1 16.38 10h15.272a3.273 3.273 0 0 1 3.273 3.273V25H13.107z"/></g><path fill="#fff" d="M20.497 31.365q-1.071 0-1.837-.348a3.9 3.9 0 0 1-1.298-.932q-.522-.592-.74-1.158-.218-.565-.174-.688a.35.35 0 0 1 .174-.191l.967-.383a.3.3 0 0 1 .244-.018q.12.035.287.4.174.366.487.776c.21.262.47.478.766.635q.444.225 1.097.226 1.054 0 1.672-.609.627-.61.627-1.55 0-1.018-.662-1.567-.661-.557-1.75-.557h-.914a.32.32 0 0 1-.226-.087.32.32 0 0 1-.087-.218v-.931q0-.13.087-.218a.3.3 0 0 1 .226-.096h.792q.976 0 1.567-.53.592-.532.592-1.376 0-.835-.53-1.35-.532-.513-1.463-.513-.523 0-.906.174c-.252.114-.478.28-.662.487a4 4 0 0 0-.478.645q-.2.33-.322.365a.3.3 0 0 1-.236-.043l-.914-.444a.3.3 0 0 1-.148-.192q-.035-.13.21-.61.252-.486.765-.992a3.6 3.6 0 0 1 1.202-.783q.688-.279 1.602-.279 1.697 0 2.69.897.993.888.993 2.35 0 1.01-.488 1.75-.48.74-1.358 1.045v.035q1.062.313 1.671 1.15.62.826.618 1.975 0 1.646-1.149 2.7-1.149 1.053-2.994 1.053m8.735-.2a.36.36 0 0 1-.261-.114.38.38 0 0 1-.104-.27v-9.68l-1.96 1.41a.3.3 0 0 1-.243.052.33.33 0 0 1-.209-.13l-.566-.802a.34.34 0 0 1-.06-.244.33.33 0 0 1 .138-.217l3.474-2.481a.3.3 0 0 1 .096-.052.3.3 0 0 1 .122-.027h.731a.29.29 0 0 1 .235.105.33.33 0 0 1 .096.244V30.78a.37.37 0 0 1-.113.27.34.34 0 0 1-.261.113z"/><defs><linearGradient id="paint0_linear_118280_5567" x1="24.016" x2="24.016" y1="25.003" y2="37.957" gradientUnits="userSpaceOnUse"><stop stop-color="#4fa0ff"/><stop offset="1" stop-color="#3186ff"/></linearGradient><linearGradient id="paint1_linear_118280_5567" x1="22.833" x2="22.833" y1="12.344" y2="25.067" gradientUnits="userSpaceOnUse"><stop stop-color="#a9a8ff"/><stop offset=".8" stop-color="#3c90ff"/></linearGradient><filter id="filter0_f_118280_5567" width="25.909" height="19.091" x="11.062" y="7.955" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_118280_5567" stdDeviation="1.023"/></filter></defs></svg>';
function $2484f66e2e897ec7$export$5d128e0a6ffc0558({ size: size, label: label = 'Google Calendar', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $2484f66e2e897ec7$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}



var $aMsxt = parcelRequire("aMsxt");


var $lp1F5 = parcelRequire("lp1F5");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6e344077c5967168cc3ec206e578948>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 


parcelRequire("cozmU");




const $2a0da4e4a9bfde21$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#e01e5a" fill-rule="evenodd" d="M15.327 27.97a3.151 3.151 0 1 1-6.303 0 3.15 3.15 0 0 1 3.152-3.154h3.151zm1.574 0a3.15 3.15 0 0 1 3.151-3.154 3.15 3.15 0 0 1 3.152 3.154v7.881a3.15 3.15 0 0 1-3.152 3.154 3.15 3.15 0 0 1-3.151-3.154z" clip-rule="evenodd"/><path fill="#36c5f0" fill-rule="evenodd" d="M20.052 15.307a3.15 3.15 0 0 1-3.151-3.154A3.15 3.15 0 0 1 20.052 9a3.15 3.15 0 0 1 3.152 3.153v3.154zm0 1.598a3.15 3.15 0 0 1 3.152 3.153 3.15 3.15 0 0 1-3.152 3.154h-7.9A3.15 3.15 0 0 1 9 20.058a3.15 3.15 0 0 1 3.152-3.153z" clip-rule="evenodd"/><path fill="#2eb67d" fill-rule="evenodd" d="M32.679 20.058a3.15 3.15 0 0 1 3.151-3.153 3.15 3.15 0 0 1 3.152 3.153 3.15 3.15 0 0 1-3.152 3.154h-3.15zm-1.574 0a3.15 3.15 0 0 1-3.151 3.154 3.15 3.15 0 0 1-3.152-3.154v-7.905A3.15 3.15 0 0 1 27.954 9a3.15 3.15 0 0 1 3.151 3.153z" clip-rule="evenodd"/><path fill="#ecb22e" fill-rule="evenodd" d="M27.954 32.698a3.15 3.15 0 0 1 3.151 3.153 3.15 3.15 0 0 1-3.151 3.154 3.15 3.15 0 0 1-3.152-3.154v-3.153zm0-1.575a3.15 3.15 0 0 1-3.152-3.153 3.15 3.15 0 0 1 3.152-3.154h7.9a3.15 3.15 0 0 1 3.152 3.154 3.15 3.15 0 0 1-3.152 3.153z" clip-rule="evenodd"/></svg>';
function $2a0da4e4a9bfde21$export$b33fb54b08bb6422({ size: size, label: label = 'Slack', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $2a0da4e4a9bfde21$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}


const $8b385943bbfb42c2$export$f66e051a71a15e68 = 6;
const $8b385943bbfb42c2$var$ICON_ROTATIONS = [
    0,
    -6,
    4
];
const $8b385943bbfb42c2$var$messages = (0, $kSwu1.defineMessages)({
    overflowCount: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.app-icon-stack.AppIconStack.overflowCount",
        defaultMessage: "+{count}"
    }
});
const $8b385943bbfb42c2$var$styles = {
    container: "_3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS",
    inlineContainer: "_3iDTPbccYA _0hPCNLDIqT _1mT5xdRAKS _0GTcwRgVvo _1RrJLit2nV",
    item: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS",
    itemFirst: "_2XsHFMPgdg",
    itemRest: "_2XsHFM5UaJ",
    tile: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _39xV02SPN1 _0jFU0VSPN1 _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS",
    filledTile: "_3vBAKHjOvk _0KLXrujOvk",
    overflowTile: "_0bjKvD0O7w _2Y7lL41Y8M _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4ouGXISPN1 _0jFU0VSPN1 _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _0KLXrulfZc"
};
const $8b385943bbfb42c2$var$ATLASSIAN_LOGOS_BY_APP_ID = {
    confluence: (0, $9HdWb.ConfluenceIcon),
    jira: (0, $7wqCp.JiraIcon),
    loom: (0, $edkvd.LoomIcon)
};
const $8b385943bbfb42c2$var$THIRD_PARTY_LOGOS_BY_APP_ID = {
    github: (0, $90c8o.GithubIcon),
    'google-calendar': (0, $2484f66e2e897ec7$export$5d128e0a6ffc0558),
    'google-drive': (0, $aMsxt.GoogleDriveIcon),
    'microsoft-sharepoint': (0, $lp1F5.MicrosoftSharePointIcon),
    slack: (0, $2a0da4e4a9bfde21$export$b33fb54b08bb6422)
};
const $8b385943bbfb42c2$var$SOURCE_APP_ID_TO_LOGO_ID = {
    drive: 'google-drive',
    gcal: 'google-calendar',
    sharepoint: 'microsoft-sharepoint'
};
const $8b385943bbfb42c2$var$normalizeAppId = (appId)=>appId.trim().toLowerCase().replace(/_/g, '-');
const $8b385943bbfb42c2$var$getLogoId = (appId)=>{
    const normalizedAppId = $8b385943bbfb42c2$var$normalizeAppId(appId);
    return $8b385943bbfb42c2$var$SOURCE_APP_ID_TO_LOGO_ID[normalizedAppId] ?? normalizedAppId;
};
const $8b385943bbfb42c2$var$resolveAppLogo = (app)=>{
    const logoId = $8b385943bbfb42c2$var$getLogoId(app.id);
    const testId = `app-logo-${app.id}`;
    const AtlassianLogo = $8b385943bbfb42c2$var$ATLASSIAN_LOGOS_BY_APP_ID[logoId];
    if (AtlassianLogo) return {
        app: app,
        node: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $w6R6I.cx)($8b385943bbfb42c2$var$styles.tile, $8b385943bbfb42c2$var$styles.filledTile)
        }, /*#__PURE__*/ $cozmU.createElement(AtlassianLogo, {
            label: "",
            size: "xsmall",
            testId: testId
        }))
    };
    const ThirdPartyLogo = $8b385943bbfb42c2$var$THIRD_PARTY_LOGOS_BY_APP_ID[logoId];
    if (ThirdPartyLogo) return {
        app: app,
        node: /*#__PURE__*/ $cozmU.createElement(ThirdPartyLogo, {
            label: "",
            size: "xsmall",
            testId: testId
        })
    };
    return null;
};
const $8b385943bbfb42c2$export$cef5f51815150663 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { sourceApps: sourceApps, appCount: appCount, appearance: t1, testId: testId } = t0;
    const appearance = t1 === undefined ? "block" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (sourceApps.length === 0) return null;
    const totalCount = appCount ?? sourceApps.length;
    let T0;
    let formattedOverflowCount;
    let overflowCount;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let visibleLogos;
    if ($[0] !== appearance || $[1] !== formatMessage || $[2] !== sourceApps || $[3] !== testId || $[4] !== totalCount) {
        t7 = Symbol.for("react.early_return_sentinel");
        bb0: {
            visibleLogos = sourceApps.slice(0, totalCount).map($8b385943bbfb42c2$var$resolveAppLogo).filter($8b385943bbfb42c2$var$_temp).slice(0, $8b385943bbfb42c2$export$f66e051a71a15e68);
            overflowCount = Math.max(totalCount - visibleLogos.length, 0);
            if (visibleLogos.length === 0 && overflowCount === 0) {
                t7 = null;
                break bb0;
            }
            const isInline = appearance === "inline";
            let t8;
            if ($[15] !== formatMessage || $[16] !== overflowCount) {
                t8 = formatMessage($8b385943bbfb42c2$var$messages.overflowCount, {
                    count: overflowCount
                });
                $[15] = formatMessage;
                $[16] = overflowCount;
                $[17] = t8;
            } else t8 = $[17];
            formattedOverflowCount = t8;
            T0 = (0, $iMnC5.Box);
            t2 = isInline ? "span" : undefined;
            t3 = isInline ? $8b385943bbfb42c2$var$styles.inlineContainer : $8b385943bbfb42c2$var$styles.container;
            t4 = testId;
            t5 = "true";
            t6 = visibleLogos.map($8b385943bbfb42c2$var$_temp2);
        }
        $[0] = appearance;
        $[1] = formatMessage;
        $[2] = sourceApps;
        $[3] = testId;
        $[4] = totalCount;
        $[5] = T0;
        $[6] = formattedOverflowCount;
        $[7] = overflowCount;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = visibleLogos;
    } else {
        T0 = $[5];
        formattedOverflowCount = $[6];
        overflowCount = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        visibleLogos = $[14];
    }
    if (t7 !== Symbol.for("react.early_return_sentinel")) return t7;
    let t8;
    if ($[18] !== formattedOverflowCount || $[19] !== overflowCount || $[20] !== testId || $[21] !== visibleLogos) {
        t8 = overflowCount > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $w6R6I.cx)($8b385943bbfb42c2$var$styles.item, visibleLogos.length === 0 ? $8b385943bbfb42c2$var$styles.itemFirst : $8b385943bbfb42c2$var$styles.itemRest),
            style: {
                zIndex: visibleLogos.length,
                transform: `rotate(${$8b385943bbfb42c2$var$ICON_ROTATIONS[visibleLogos.length % $8b385943bbfb42c2$var$ICON_ROTATIONS.length]}deg)`
            }
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $8b385943bbfb42c2$var$styles.overflowTile,
            testId: testId ? `${testId}-overflow` : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, formattedOverflowCount))) : null;
        $[18] = formattedOverflowCount;
        $[19] = overflowCount;
        $[20] = testId;
        $[21] = visibleLogos;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== T0 || $[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement(T0, {
            as: t2,
            xcss: t3,
            testId: t4,
            "aria-hidden": t5
        }, t6, t8);
        $[23] = T0;
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
} : ({ sourceApps: sourceApps, appCount: appCount, appearance: appearance = 'block', testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (sourceApps.length === 0) return null;
    const totalCount = appCount ?? sourceApps.length;
    const visibleLogos = sourceApps.slice(0, totalCount).map($8b385943bbfb42c2$var$resolveAppLogo).filter((logo)=>logo !== null).slice(0, $8b385943bbfb42c2$export$f66e051a71a15e68);
    const overflowCount = Math.max(totalCount - visibleLogos.length, 0);
    if (visibleLogos.length === 0 && overflowCount === 0) return null;
    const isInline = appearance === 'inline';
    const formattedOverflowCount = formatMessage($8b385943bbfb42c2$var$messages.overflowCount, {
        count: overflowCount
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: isInline ? 'span' : undefined,
        xcss: isInline ? $8b385943bbfb42c2$var$styles.inlineContainer : $8b385943bbfb42c2$var$styles.container,
        testId: testId,
        "aria-hidden": "true"
    }, visibleLogos.map(({ app: app, node: node }, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            key: `${app.id}-${index}`,
            xcss: (0, $w6R6I.cx)($8b385943bbfb42c2$var$styles.item, index === 0 ? $8b385943bbfb42c2$var$styles.itemFirst : $8b385943bbfb42c2$var$styles.itemRest),
            style: {
                zIndex: index,
                transform: `rotate(${$8b385943bbfb42c2$var$ICON_ROTATIONS[index % $8b385943bbfb42c2$var$ICON_ROTATIONS.length]}deg)`
            }
        }, node)), overflowCount > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($8b385943bbfb42c2$var$styles.item, visibleLogos.length === 0 ? $8b385943bbfb42c2$var$styles.itemFirst : $8b385943bbfb42c2$var$styles.itemRest),
        style: {
            zIndex: visibleLogos.length,
            transform: `rotate(${$8b385943bbfb42c2$var$ICON_ROTATIONS[visibleLogos.length % $8b385943bbfb42c2$var$ICON_ROTATIONS.length]}deg)`
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $8b385943bbfb42c2$var$styles.overflowTile,
        testId: testId ? `${testId}-overflow` : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formattedOverflowCount))) : null);
};
function $8b385943bbfb42c2$var$_temp(logo) {
    return logo !== null;
}
function $8b385943bbfb42c2$var$_temp2(t0, index) {
    const { app: app, node: node } = t0;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        key: `${app.id}-${index}`,
        xcss: (0, $w6R6I.cx)($8b385943bbfb42c2$var$styles.item, index === 0 ? $8b385943bbfb42c2$var$styles.itemFirst : $8b385943bbfb42c2$var$styles.itemRest),
        style: {
            zIndex: index,
            transform: `rotate(${$8b385943bbfb42c2$var$ICON_ROTATIONS[index % $8b385943bbfb42c2$var$ICON_ROTATIONS.length]}deg)`
        }
    }, node);
}


const $0695b3e1a8e71014$var$MAX_NAMED_SOURCE_APPS = 4;
const $0695b3e1a8e71014$var$messages = (0, $kSwu1.defineMessages)({
    insightsFeedTitle: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.insightsFeedTitle",
        defaultMessage: "Your weekly insights"
    },
    connectMoreApps: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.connectMoreApps",
        defaultMessage: "Connect more apps to get greater insights."
    },
    keyItemsLabel: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.keyItemsLabel",
        defaultMessage: "{count, plural, one {key item} other {key items}}"
    },
    appsLabel: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.appsLabel",
        defaultMessage: "{count, plural, one {app} other {apps}}"
    },
    summaryWithAppNames: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.summaryWithAppNames",
        defaultMessage: "Rovo spotted <b>{insightCount}</b> {keyItems} from across your {appNames} activity this week."
    },
    summaryWithAppCount: {
        id: "rovo-growth-pulse.insights-feed.insights-feed-header.summaryWithAppCount",
        defaultMessage: "Rovo spotted <b>{insightCount}</b> {keyItems} from across <b>{appCount}</b> {apps} this week."
    }
});
const $0695b3e1a8e71014$var$GRID_LINE_COLOR = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $0695b3e1a8e71014$var$GRID_SUNKEN_COLOR = "var(--ds-surface-sunken, #F8F8F8)";
const $0695b3e1a8e71014$var$GRID_PATTERN_BG_IMAGE = `linear-gradient(${$0695b3e1a8e71014$var$GRID_LINE_COLOR} 1px, transparent 1px), linear-gradient(90deg, ${$0695b3e1a8e71014$var$GRID_LINE_COLOR} 1px, transparent 1px)`;
const $0695b3e1a8e71014$var$GRID_PATTERN_BG_SIZE = '24px 24px';
const $0695b3e1a8e71014$var$GRID_PATTERN_BG_SIZE_FULLSCREEN = '26.4px 26.4px';
const $0695b3e1a8e71014$var$GRID_PATTERN_BG_POSITION = '6px 4px';
const $0695b3e1a8e71014$var$GRID_OVERLAY_BG_IMAGE_SIDEBAR = `linear-gradient(225deg, rgba(248, 248, 248, 0) 0%, ${$0695b3e1a8e71014$var$GRID_SUNKEN_COLOR} 100%)`;
const $0695b3e1a8e71014$var$GRID_OVERLAY_BG_IMAGE_FULLSCREEN_BASE = `linear-gradient(45deg, ${$0695b3e1a8e71014$var$GRID_SUNKEN_COLOR} 0%, rgba(255, 255, 255, 0) 48%, ${$0695b3e1a8e71014$var$GRID_SUNKEN_COLOR} 97%)`;
const $0695b3e1a8e71014$var$GRID_OVERLAY_BG_IMAGE_FULLSCREEN_TOP = `linear-gradient(1deg, ${$0695b3e1a8e71014$var$GRID_SUNKEN_COLOR} 0%, rgba(255, 255, 255, 0) 60%, ${$0695b3e1a8e71014$var$GRID_SUNKEN_COLOR} 96%)`;
const $0695b3e1a8e71014$var$gridLayerContainerStyles = null;
const $0695b3e1a8e71014$var$gridPatternLayerStyles = null;
const $0695b3e1a8e71014$var$gridPatternLayerFullScreenStyles = null;
const $0695b3e1a8e71014$var$gridOverlayLayerStyles = null;
const $0695b3e1a8e71014$var$gridOverlayLayerFullScreenBaseStyles = null;
const $0695b3e1a8e71014$var$gridOverlayLayerFullScreenTopStyles = null;
const $0695b3e1a8e71014$var$styles = {
    headerWrapper: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _1DCdHi5zaO",
    headerWrapperWithGrid: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _1mT5xdRAKS _1DCdHi5zaO _46hvQmGXk2 _0xmtkoS40j _0LQT5ENHnM _03SyCPNHnM _0KLXrunmFW",
    headerContent: "_1mT5xdRAKS _1wydGW1Y8M",
    headerContentCentered: "_1mT5xdRAKS _1wydGW1Y8M _39xV02N91d _2eplquIZbP _2pzWtIflcy",
    summaryWrapper: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    summaryWrapperWithGrid: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _4c065UkG2W _2Y7lL4kG2W _1mT5xdRAKS _0KLXrunmFW",
    gridContent: "_1mT5xdRAKS",
    headerRow: "_0hPCNLDIqT",
    titleColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC",
    summaryRow: "_0hPCNLDIqT _37wbyuI7V3",
    summaryColumnFullScreen: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC _1EqgXl5m2b",
    summaryContentFullScreen: "_3iDTPbS8kF",
    connectAppsActionFullScreen: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _0rIjyk2ADO",
    connectAppsActionSidebar: "_3iDTPbvLZJ",
    connectAppsActionHidden: "_3iDTPbYbGa"
};
const $0695b3e1a8e71014$var$GridBackgroundLayers = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { variant: variant } = t0;
    let t1;
    if ($[0] !== variant) {
        t1 = variant === "fullScreen" ? /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _1pp6NdYbGa"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _1YKVNsWOAI _3CkH9oT8oN _3OqcjT6BdM _1DJ2rVtsBy"
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _3CkH9o1bJa"
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _1YKVNsVpNL _3CkH9od2mg"
            ])
        })) : /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _1pp6NdYbGa"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _1YKVNsWOAI _3CkH9oT8oN _3OqcjTkyAR _1DJ2rVtsBy"
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _3CkH9oEnpP"
            ])
        }));
        $[0] = variant;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ variant: variant })=>variant === 'fullScreen' ? /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _1YKVNsWOAI _3CkH9oT8oN _3OqcjT6BdM _1DJ2rVtsBy"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3CkH9o1bJa"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _1YKVNsVpNL _3CkH9od2mg"
        ])
    })) : /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _1YKVNsWOAI _3CkH9oT8oN _3OqcjTkyAR _1DJ2rVtsBy"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3CkH9oEnpP"
        ])
    }));
const $0695b3e1a8e71014$var$renderSummaryWithBoldNumbers = (summary)=>{
    // Temporary until the backend provides structured summary counts.
    return summary.split(/(\d+)/g).map((part, index)=>{
        if (/^\d+$/.test(part)) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            weight: "bold",
            key: `${part}-${index}`
        }, part);
        return part;
    });
}; /** Renders a count wrapped in bold, used as the `<b>` chunk for summary messages. */ 
const $0695b3e1a8e71014$var$boldChunk = (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "span",
        weight: "bold"
    }, chunks);
const $0695b3e1a8e71014$export$4cdacb015559b223 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { title: title, summary: summary, summaryDetails: summaryDetails, generatedAt: generatedAt, isFullScreen: t1, connectAppsAction: connectAppsAction, animationEnabled: t2, animationStartIndex: t3 } = t0;
    const isFullScreen = t1 === undefined ? false : t1;
    const animationEnabled = t2 === undefined ? false : t2;
    const animationStartIndex = t3 === undefined ? 0 : t3;
    const { formatMessage: formatMessage, formatList: formatList, locale: locale } = (0, $kSwu1.useIntl)();
    const [hasVisibleConnectAppsAction, setHasVisibleConnectAppsAction] = (0, $cozmU.useState)(false);
    let t4;
    if ($[0] !== connectAppsAction) {
        t4 = connectAppsAction?.({
            onVisibilityChange: setHasVisibleConnectAppsAction
        });
        $[0] = connectAppsAction;
        $[1] = t4;
    } else t4 = $[1];
    const connectAppsActionContent = t4;
    let t5;
    if ($[2] !== formatMessage || $[3] !== generatedAt || $[4] !== locale) {
        t5 = (0, $13854e22d2f33375$export$8c68a43a9bc19046)(generatedAt, formatMessage, (0, $004abc2094aee036$export$822cdd78febe6c96).generatedAt, locale);
        $[2] = formatMessage;
        $[3] = generatedAt;
        $[4] = locale;
        $[5] = t5;
    } else t5 = $[5];
    const formattedDate = t5;
    let t6;
    if ($[6] !== hasVisibleConnectAppsAction) {
        t6 = hasVisibleConnectAppsAction ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text.subtle"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $0695b3e1a8e71014$var$messages.connectMoreApps)) : null;
        $[6] = hasVisibleConnectAppsAction;
        $[7] = t6;
    } else t6 = $[7];
    const connectMoreAppsNode = t6;
    let t7;
    if ($[8] !== hasVisibleConnectAppsAction) {
        t7 = hasVisibleConnectAppsAction ? /*#__PURE__*/ $cozmU.createElement("span", null, " ", /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $0695b3e1a8e71014$var$messages.connectMoreApps)) : null;
        $[8] = hasVisibleConnectAppsAction;
        $[9] = t7;
    } else t7 = $[9];
    const connectMoreAppsInlineNode = t7;
    const hasSummaryDetails = summaryDetails !== undefined;
    let t8;
    if ($[10] !== formatList || $[11] !== formatMessage || $[12] !== summaryDetails) {
        const namedSourceApps = summaryDetails !== undefined ? summaryDetails.sourceApps.slice(0, summaryDetails.appCount) : [];
        const shouldListAppNames = summaryDetails !== undefined && summaryDetails.appCount > 0 && summaryDetails.appCount <= $0695b3e1a8e71014$var$MAX_NAMED_SOURCE_APPS && namedSourceApps.length === summaryDetails.appCount;
        t8 = summaryDetails !== undefined ? shouldListAppNames ? formatMessage($0695b3e1a8e71014$var$messages.summaryWithAppNames, {
            insightCount: summaryDetails.insightCount,
            keyItems: formatMessage($0695b3e1a8e71014$var$messages.keyItemsLabel, {
                count: summaryDetails.insightCount
            }),
            appNames: formatList(namedSourceApps.map($0695b3e1a8e71014$var$_temp), {
                type: "conjunction"
            }),
            b: $0695b3e1a8e71014$var$boldChunk
        }) : formatMessage($0695b3e1a8e71014$var$messages.summaryWithAppCount, {
            insightCount: summaryDetails.insightCount,
            keyItems: formatMessage($0695b3e1a8e71014$var$messages.keyItemsLabel, {
                count: summaryDetails.insightCount
            }),
            appCount: summaryDetails.appCount,
            apps: formatMessage($0695b3e1a8e71014$var$messages.appsLabel, {
                count: summaryDetails.appCount
            }),
            b: $0695b3e1a8e71014$var$boldChunk
        }) : null;
        $[10] = formatList;
        $[11] = formatMessage;
        $[12] = summaryDetails;
        $[13] = t8;
    } else t8 = $[13];
    const structuredSummaryNode = t8;
    let t9;
    if ($[14] !== isFullScreen || $[15] !== summaryDetails) {
        t9 = summaryDetails !== undefined && summaryDetails.sourceApps.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $8b385943bbfb42c2$export$cef5f51815150663), {
            sourceApps: summaryDetails.sourceApps,
            appCount: summaryDetails.appCount,
            appearance: isFullScreen ? "inline" : "block",
            testId: "insights-feed-app-icon-stack"
        }) : null;
        $[14] = isFullScreen;
        $[15] = summaryDetails;
        $[16] = t9;
    } else t9 = $[16];
    const iconStackNode = t9;
    let t10;
    if ($[17] !== connectMoreAppsInlineNode || $[18] !== hasSummaryDetails || $[19] !== isFullScreen || $[20] !== structuredSummaryNode || $[21] !== summary) {
        t10 = hasSummaryDetails ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            size: "medium",
            color: "color.text.subtle",
            testId: "insights-feed-summary"
        }, structuredSummaryNode, isFullScreen ? null : connectMoreAppsInlineNode) : summary ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            size: "medium",
            color: "color.text.subtle",
            testId: "insights-feed-summary"
        }, $0695b3e1a8e71014$var$renderSummaryWithBoldNumbers(summary), isFullScreen ? null : connectMoreAppsInlineNode) : null;
        $[17] = connectMoreAppsInlineNode;
        $[18] = hasSummaryDetails;
        $[19] = isFullScreen;
        $[20] = structuredSummaryNode;
        $[21] = summary;
        $[22] = t10;
    } else t10 = $[22];
    const summaryTextNode = t10;
    const hasSummaryContent = summaryTextNode !== null;
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $92db9dd378ea9422$export$b2ab96b128cdb752), {
            backgroundColor: "color.background.accent.gray.subtlest"
        });
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== formattedDate) {
        t12 = formattedDate ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            testId: "insights-feed-generated-date"
        }, formattedDate) : null;
        $[24] = formattedDate;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== title) {
        t13 = title ?? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $0695b3e1a8e71014$var$messages.insightsFeedTitle);
        $[26] = title;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "large"
        }, t13);
        $[28] = t13;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== t12 || $[31] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.150",
            xcss: $0695b3e1a8e71014$var$styles.headerRow
        }, t11, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0695b3e1a8e71014$var$styles.titleColumn
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, t12, t14)));
        $[30] = t12;
        $[31] = t14;
        $[32] = t15;
    } else t15 = $[32];
    const headerRowNode = t15;
    let t16;
    if ($[33] !== animationEnabled || $[34] !== animationStartIndex || $[35] !== headerRowNode || $[36] !== isFullScreen) {
        t16 = isFullScreen ? headerRowNode : /*#__PURE__*/ $cozmU.createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
            index: animationStartIndex,
            isEnabled: animationEnabled,
            testId: "insights-feed-title-animation-section"
        }, headerRowNode);
        $[33] = animationEnabled;
        $[34] = animationStartIndex;
        $[35] = headerRowNode;
        $[36] = isFullScreen;
        $[37] = t16;
    } else t16 = $[37];
    const animatedHeaderRowNode = t16;
    const t17 = isFullScreen ? $0695b3e1a8e71014$var$styles.summaryWrapper : $0695b3e1a8e71014$var$styles.summaryWrapperWithGrid;
    let t18;
    if ($[38] !== isFullScreen) {
        t18 = isFullScreen ? null : /*#__PURE__*/ $cozmU.createElement($0695b3e1a8e71014$var$GridBackgroundLayers, {
            variant: "sidebar"
        });
        $[38] = isFullScreen;
        $[39] = t18;
    } else t18 = $[39];
    let t19;
    if ($[40] !== connectAppsActionContent || $[41] !== connectMoreAppsNode || $[42] !== hasVisibleConnectAppsAction || $[43] !== iconStackNode || $[44] !== isFullScreen || $[45] !== summaryTextNode) {
        t19 = isFullScreen ? /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.200",
            xcss: $0695b3e1a8e71014$var$styles.summaryRow
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0695b3e1a8e71014$var$styles.summaryColumnFullScreen
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.075",
            xcss: $0695b3e1a8e71014$var$styles.summaryContentFullScreen
        }, summaryTextNode, iconStackNode), connectMoreAppsNode)), connectAppsActionContent != null ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: hasVisibleConnectAppsAction ? $0695b3e1a8e71014$var$styles.connectAppsActionFullScreen : $0695b3e1a8e71014$var$styles.connectAppsActionHidden
        }, connectAppsActionContent) : null) : /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $0695b3e1a8e71014$var$styles.gridContent,
            space: "space.200"
        }, iconStackNode, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, summaryTextNode, connectAppsActionContent != null ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: hasVisibleConnectAppsAction ? $0695b3e1a8e71014$var$styles.connectAppsActionSidebar : $0695b3e1a8e71014$var$styles.connectAppsActionHidden
        }, connectAppsActionContent) : null));
        $[40] = connectAppsActionContent;
        $[41] = connectMoreAppsNode;
        $[42] = hasVisibleConnectAppsAction;
        $[43] = iconStackNode;
        $[44] = isFullScreen;
        $[45] = summaryTextNode;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    if ($[47] !== t17 || $[48] !== t18 || $[49] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t17
        }, t18, t19);
        $[47] = t17;
        $[48] = t18;
        $[49] = t19;
        $[50] = t20;
    } else t20 = $[50];
    const summaryContentNode = t20;
    let t21;
    if ($[51] !== animationEnabled || $[52] !== animationStartIndex || $[53] !== isFullScreen || $[54] !== summaryContentNode) {
        t21 = isFullScreen ? summaryContentNode : /*#__PURE__*/ $cozmU.createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
            index: animationStartIndex + 1,
            isEnabled: animationEnabled,
            testId: "insights-feed-summary-animation-section"
        }, summaryContentNode);
        $[51] = animationEnabled;
        $[52] = animationStartIndex;
        $[53] = isFullScreen;
        $[54] = summaryContentNode;
        $[55] = t21;
    } else t21 = $[55];
    const animatedSummaryContentNode = t21;
    const t22 = isFullScreen ? $0695b3e1a8e71014$var$styles.headerWrapperWithGrid : $0695b3e1a8e71014$var$styles.headerWrapper;
    let t23;
    if ($[56] !== isFullScreen) {
        t23 = isFullScreen ? /*#__PURE__*/ $cozmU.createElement($0695b3e1a8e71014$var$GridBackgroundLayers, {
            variant: "fullScreen"
        }) : null;
        $[56] = isFullScreen;
        $[57] = t23;
    } else t23 = $[57];
    const t24 = isFullScreen ? $0695b3e1a8e71014$var$styles.headerContentCentered : $0695b3e1a8e71014$var$styles.headerContent;
    const t25 = hasSummaryContent ? animatedSummaryContentNode : null;
    let t26;
    if ($[58] !== animatedHeaderRowNode || $[59] !== t24 || $[60] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: t24,
            space: "space.200"
        }, animatedHeaderRowNode, t25);
        $[58] = animatedHeaderRowNode;
        $[59] = t24;
        $[60] = t25;
        $[61] = t26;
    } else t26 = $[61];
    let t27;
    if ($[62] !== t22 || $[63] !== t23 || $[64] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t22
        }, t23, t26);
        $[62] = t22;
        $[63] = t23;
        $[64] = t26;
        $[65] = t27;
    } else t27 = $[65];
    return t27;
} : ({ title: title, summary: summary, summaryDetails: summaryDetails, generatedAt: generatedAt, isFullScreen: isFullScreen = false, connectAppsAction: connectAppsAction, animationEnabled: animationEnabled = false, animationStartIndex: animationStartIndex = 0 })=>{
    const { formatMessage: formatMessage, formatList: formatList, locale: locale } = (0, $kSwu1.useIntl)(); // The action reports via onVisibilityChange whether it rendered anything, so we can hide the
    // wrapper and "Connect more apps" copy when there is nothing to connect.
    const [hasVisibleConnectAppsAction, setHasVisibleConnectAppsAction] = (0, $cozmU.useState)(false);
    const connectAppsActionContent = connectAppsAction?.({
        onVisibilityChange: setHasVisibleConnectAppsAction
    });
    const formattedDate = (0, $13854e22d2f33375$export$8c68a43a9bc19046)(generatedAt, formatMessage, (0, $004abc2094aee036$export$822cdd78febe6c96).generatedAt, locale);
    const connectMoreAppsNode = hasVisibleConnectAppsAction ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $0695b3e1a8e71014$var$messages.connectMoreApps)) : null;
    const connectMoreAppsInlineNode = hasVisibleConnectAppsAction ? /*#__PURE__*/ $cozmU.createElement("span", null, ' ', /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $0695b3e1a8e71014$var$messages.connectMoreApps)) : null;
    const hasSummaryDetails = summaryDetails !== undefined;
    const namedSourceApps = summaryDetails !== undefined ? summaryDetails.sourceApps.slice(0, summaryDetails.appCount) : [];
    const shouldListAppNames = summaryDetails !== undefined && summaryDetails.appCount > 0 && summaryDetails.appCount <= $0695b3e1a8e71014$var$MAX_NAMED_SOURCE_APPS && namedSourceApps.length === summaryDetails.appCount;
    const structuredSummaryNode = summaryDetails !== undefined ? shouldListAppNames ? formatMessage($0695b3e1a8e71014$var$messages.summaryWithAppNames, {
        insightCount: summaryDetails.insightCount,
        keyItems: formatMessage($0695b3e1a8e71014$var$messages.keyItemsLabel, {
            count: summaryDetails.insightCount
        }),
        appNames: formatList(namedSourceApps.map((app)=>app.name), {
            type: 'conjunction'
        }),
        b: $0695b3e1a8e71014$var$boldChunk
    }) : formatMessage($0695b3e1a8e71014$var$messages.summaryWithAppCount, {
        insightCount: summaryDetails.insightCount,
        keyItems: formatMessage($0695b3e1a8e71014$var$messages.keyItemsLabel, {
            count: summaryDetails.insightCount
        }),
        appCount: summaryDetails.appCount,
        apps: formatMessage($0695b3e1a8e71014$var$messages.appsLabel, {
            count: summaryDetails.appCount
        }),
        b: $0695b3e1a8e71014$var$boldChunk
    }) : null;
    const iconStackNode = summaryDetails !== undefined && summaryDetails.sourceApps.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $8b385943bbfb42c2$export$cef5f51815150663), {
        sourceApps: summaryDetails.sourceApps,
        appCount: summaryDetails.appCount,
        appearance: isFullScreen ? 'inline' : 'block',
        testId: "insights-feed-app-icon-stack"
    }) : null;
    const summaryTextNode = hasSummaryDetails ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "span",
        size: "medium",
        color: "color.text.subtle",
        testId: "insights-feed-summary"
    }, structuredSummaryNode, isFullScreen ? null : connectMoreAppsInlineNode) : summary ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "span",
        size: "medium",
        color: "color.text.subtle",
        testId: "insights-feed-summary"
    }, $0695b3e1a8e71014$var$renderSummaryWithBoldNumbers(summary), isFullScreen ? null : connectMoreAppsInlineNode) : null;
    const hasSummaryContent = summaryTextNode !== null;
    const headerRowNode = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.150",
        xcss: $0695b3e1a8e71014$var$styles.headerRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $92db9dd378ea9422$export$b2ab96b128cdb752), {
        backgroundColor: "color.background.accent.gray.subtlest"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0695b3e1a8e71014$var$styles.titleColumn
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, formattedDate ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        testId: "insights-feed-generated-date"
    }, formattedDate) : null, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "large"
    }, title ?? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $0695b3e1a8e71014$var$messages.insightsFeedTitle)))));
    const animatedHeaderRowNode = isFullScreen ? headerRowNode : /*#__PURE__*/ $cozmU.createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
        index: animationStartIndex,
        isEnabled: animationEnabled,
        testId: "insights-feed-title-animation-section"
    }, headerRowNode);
    const summaryContentNode = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isFullScreen ? $0695b3e1a8e71014$var$styles.summaryWrapper : $0695b3e1a8e71014$var$styles.summaryWrapperWithGrid
    }, isFullScreen ? null : /*#__PURE__*/ $cozmU.createElement($0695b3e1a8e71014$var$GridBackgroundLayers, {
        variant: "sidebar"
    }), isFullScreen ? /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.200",
        xcss: $0695b3e1a8e71014$var$styles.summaryRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0695b3e1a8e71014$var$styles.summaryColumnFullScreen
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.075",
        xcss: $0695b3e1a8e71014$var$styles.summaryContentFullScreen
    }, summaryTextNode, iconStackNode), connectMoreAppsNode)), connectAppsActionContent != null ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: hasVisibleConnectAppsAction ? $0695b3e1a8e71014$var$styles.connectAppsActionFullScreen : $0695b3e1a8e71014$var$styles.connectAppsActionHidden
    }, connectAppsActionContent) : null) : /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $0695b3e1a8e71014$var$styles.gridContent,
        space: "space.200"
    }, iconStackNode, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, summaryTextNode, connectAppsActionContent != null ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: hasVisibleConnectAppsAction ? $0695b3e1a8e71014$var$styles.connectAppsActionSidebar : $0695b3e1a8e71014$var$styles.connectAppsActionHidden
    }, connectAppsActionContent) : null)));
    const animatedSummaryContentNode = isFullScreen ? summaryContentNode : /*#__PURE__*/ $cozmU.createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
        index: animationStartIndex + 1,
        isEnabled: animationEnabled,
        testId: "insights-feed-summary-animation-section"
    }, summaryContentNode);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isFullScreen ? $0695b3e1a8e71014$var$styles.headerWrapperWithGrid : $0695b3e1a8e71014$var$styles.headerWrapper
    }, isFullScreen ? /*#__PURE__*/ $cozmU.createElement($0695b3e1a8e71014$var$GridBackgroundLayers, {
        variant: "fullScreen"
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: isFullScreen ? $0695b3e1a8e71014$var$styles.headerContentCentered : $0695b3e1a8e71014$var$styles.headerContent,
        space: "space.200"
    }, animatedHeaderRowNode, hasSummaryContent ? animatedSummaryContentNode : null));
};
function $0695b3e1a8e71014$var$_temp(app) {
    return app.name;
}

















var $a9aSv = parcelRequire("a9aSv");

const $c833cdb04e51bd40$var$styles = {
    container: "_0Of8r2Va5s _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    paragraph: "_1wydGWNHnM"
}; /**
    * Text-line widths that simulate the look of a wall-of-text / chat-style
    * response being loaded.  Two "paragraph" groups are rendered with a gap
    * between them so the shimmer feels natural.
    */ 
const $c833cdb04e51bd40$var$PARAGRAPH_1_WIDTHS = [
    '100%',
    '95%',
    '100%',
    '85%',
    '90%',
    '60%'
];
const $c833cdb04e51bd40$var$PARAGRAPH_2_WIDTHS = [
    '100%',
    '90%',
    '95%',
    '70%',
    '100%',
    '85%',
    '45%'
];
const $c833cdb04e51bd40$var$LINE_HEIGHT = '14px';
const $c833cdb04e51bd40$export$ab0118c030d8731d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { testId: t1 } = t0;
    const testId = t1 === undefined ? "insights-feed-loading-shimmer" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $c833cdb04e51bd40$var$styles.paragraph,
            space: "space.100"
        }, $c833cdb04e51bd40$var$PARAGRAPH_1_WIDTHS.map($c833cdb04e51bd40$var$_temp));
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, $c833cdb04e51bd40$var$PARAGRAPH_2_WIDTHS.map($c833cdb04e51bd40$var$_temp2));
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c833cdb04e51bd40$var$styles.container,
            testId: testId
        }, t2, t3);
        $[2] = testId;
        $[3] = t4;
    } else t4 = $[3];
    return t4;
} : ({ testId: testId = 'insights-feed-loading-shimmer' })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c833cdb04e51bd40$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $c833cdb04e51bd40$var$styles.paragraph,
        space: "space.100"
    }, $c833cdb04e51bd40$var$PARAGRAPH_1_WIDTHS.map((width, i)=>/*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            key: `p1-${i}`,
            width: width,
            height: $c833cdb04e51bd40$var$LINE_HEIGHT,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }))), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, $c833cdb04e51bd40$var$PARAGRAPH_2_WIDTHS.map((width_0, i_0)=>/*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            key: `p2-${i_0}`,
            width: width_0,
            height: $c833cdb04e51bd40$var$LINE_HEIGHT,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }))));
function $c833cdb04e51bd40$var$_temp(width, i) {
    return /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        key: `p1-${i}`,
        width: width,
        height: $c833cdb04e51bd40$var$LINE_HEIGHT,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    });
}
function $c833cdb04e51bd40$var$_temp2(width_0, i_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        key: `p2-${i_0}`,
        width: width_0,
        height: $c833cdb04e51bd40$var$LINE_HEIGHT,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    });
}


/**
 * Fetches Rovo Insights data through the Rovo Insights service and maps it for the feed UI.
 */ 









var $lJ6db = parcelRequire("lJ6db");


var $4pKRH = parcelRequire("4pKRH");

/**
 * Maps Rovo Insights API responses into the feed UI model.
 *
 * The API shape includes explicit `icon` and `color` fields for each insight group;
 * see the backend endpoint introduction for the original response contract.
 *
 * @see https://bitbucket.org/atlassian/conversational-ai-platform/pull-requests/23676
 */ /**
 * Resolves Rovo Insights API icon/color string keys into Atlaskit icon components
 * and IconTile appearances.
 *
 * The Rovo Insights API returns each insight group's visual identity as plain
 * string keys (`icon`, `color`). This module is the single source of truth for
 * turning those strings into renderable values, shared by:
 *  - the feed mapper ({@link ./mapApiResponseToInsightItems}), which resolves at
 *    fetch time for the in-panel InsightsFeed, and
 *  - external consumers (e.g. the home insights carousel via the
 *    `insights-open-in-chat` rovo-trigger), which only have the raw string keys
 *    available over the event bus and must re-resolve panel-side.
 *
 * Keeping resolution here guarantees both paths produce identical icons and
 * appearances, so the two surfaces cannot drift.
 */ 



var $dVbiN = parcelRequire("dVbiN");

const $0e0ee51c18759f54$export$f7510da71913f375 = {
    gray: 'gray',
    blue: 'blue',
    teal: 'teal',
    green: 'green',
    lime: 'lime',
    yellow: 'yellow',
    orange: 'orange',
    red: 'red',
    magenta: 'magenta',
    purple: 'purple',
    grayBold: 'grayBold',
    blueBold: 'blueBold',
    tealBold: 'tealBold',
    greenBold: 'greenBold',
    limeBold: 'limeBold',
    yellowBold: 'yellowBold',
    orangeBold: 'orangeBold',
    redBold: 'redBold',
    magentaBold: 'magentaBold',
    purpleBold: 'purpleBold'
};


/**
 * Lazy-loaders for Atlaskit icons referenced by Rovo Insights API icon keys.
 */ 



































const $095a9ee13fa278e9$export$a5650b22218152b5 = {
    alert: ()=>(parcelRequire("hBRNG")),
    automation: ()=>Promise.resolve((parcelRequire("hMcNB"))),
    'book-with-bookmark': ()=>(parcelRequire("eKZMd")),
    briefcase: ()=>Promise.resolve((parcelRequire("p6OqS"))),
    calendar: ()=>Promise.resolve((parcelRequire("824lD"))),
    'chart-bar': ()=>Promise.resolve((parcelRequire("gJ798"))),
    'chart-trend-up': ()=>Promise.resolve((parcelRequire("1TvTa"))),
    'check-circle': ()=>Promise.resolve((parcelRequire("iZMIZ"))),
    clock: ()=>Promise.resolve((parcelRequire("5ZtfK"))),
    comment: ()=>Promise.resolve((parcelRequire("eDtFr"))),
    compass: ()=>(parcelRequire("8tRtw")),
    dashboard: ()=>(parcelRequire("kjQn1")),
    department: ()=>Promise.resolve((parcelRequire("eleTd"))),
    'eye-open': ()=>Promise.resolve((parcelRequire("a79Sy"))),
    flag: ()=>Promise.resolve((parcelRequire("gMfOo"))),
    globe: ()=>Promise.resolve((parcelRequire("krxYo"))),
    goal: ()=>Promise.resolve((parcelRequire("6CsCB"))),
    lightbulb: ()=>Promise.resolve((parcelRequire("dVbiN"))),
    link: ()=>Promise.resolve((parcelRequire("kTb7m"))),
    megaphone: ()=>Promise.resolve((parcelRequire("f3HCt"))),
    objective: ()=>(parcelRequire("9htuM")),
    'office-building': ()=>Promise.resolve((parcelRequire("kpuvJ"))),
    'party-popper': ()=>(parcelRequire("7iLdD")),
    'people-group': ()=>Promise.resolve((parcelRequire("fBqzD"))),
    person: ()=>Promise.resolve((parcelRequire("g9ioO"))),
    'priority-high': ()=>(parcelRequire("kkvW6")),
    'question-circle': ()=>Promise.resolve((parcelRequire("kyJuy"))),
    sprint: ()=>(parcelRequire("bbbIY")),
    'star-starred': ()=>Promise.resolve((parcelRequire("6Cex3"))),
    'status-warning': ()=>Promise.resolve((parcelRequire("lMGh1"))),
    stopwatch: ()=>(parcelRequire("bw9C4")),
    target: ()=>(parcelRequire("kF94T")),
    task: ()=>Promise.resolve((parcelRequire("iAaYd"))),
    teams: ()=>Promise.resolve((parcelRequire("dflgH"))),
    'thumbs-up': ()=>Promise.resolve((parcelRequire("c8bBH"))),
    warning: ()=>Promise.resolve((parcelRequire("lMGh1")))
};


const $47f35143d0efa6a5$var$lazyIconCache = new Map();
function $47f35143d0efa6a5$export$2449f7dd7c6cf072(iconKey) {
    const key = iconKey?.toLowerCase();
    const loader = key ? (0, $095a9ee13fa278e9$export$a5650b22218152b5)[key] : undefined;
    if (!key || !loader) return 0, (/*@__PURE__*/$parcel$interopDefault($dVbiN));
    const cachedIcon = $47f35143d0efa6a5$var$lazyIconCache.get(key);
    if (cachedIcon) return cachedIcon;
    const icon = (0, $cozmU.lazy)(loader);
    $47f35143d0efa6a5$var$lazyIconCache.set(key, icon);
    return icon;
}
function $47f35143d0efa6a5$export$4298f62f89b93bab(color) {
    return (color ? (0, $0e0ee51c18759f54$export$f7510da71913f375)[color] : undefined) ?? 'blueBold';
}


// ---------------------------------------------------------------------------
// Mapper Helpers
// ---------------------------------------------------------------------------
function $215d678d855c7560$var$makeId(groupType, index) {
    return `${groupType.toLowerCase().replace(/\s+/g, '-')}-${index}`;
}
const $215d678d855c7560$var$MEETING_GROUP_TYPE = 'meeting-insights';
const $215d678d855c7560$var$MEETING_TITLE_SEPARATOR = " \xb7 ";
function $215d678d855c7560$var$isMeetingGroup(group) {
    return group.type.trim().toLowerCase() === $215d678d855c7560$var$MEETING_GROUP_TYPE;
}
function $215d678d855c7560$var$splitMeetingTitle(title) {
    const separatorIndex = title.lastIndexOf($215d678d855c7560$var$MEETING_TITLE_SEPARATOR);
    if (separatorIndex === -1) return {
        title: title
    };
    const meetingName = title.slice(0, separatorIndex).trim();
    const titleSecondary = title.slice(separatorIndex + $215d678d855c7560$var$MEETING_TITLE_SEPARATOR.length).trim();
    if (!meetingName || !titleSecondary) return {
        title: title
    };
    return {
        title: meetingName,
        titleSecondary: titleSecondary
    };
}
function $215d678d855c7560$var$mapSubItem(insight, groupId, index, options) {
    const titleParts = options.isMeetingGroup ? $215d678d855c7560$var$splitMeetingTitle(insight.title) : {
        title: insight.title
    };
    return {
        id: `${groupId}-sub-${index}`,
        ...titleParts,
        description: insight.overview ?? '',
        detailsAdf: insight.details_adf,
        people: insight.people?.map((p)=>({
                name: p.name,
                aaid: p.aaid,
                avatarUrl: p.avatar_url
            })),
        followUps: insight.follow_ups,
        urls: options.isMeetingGroup ? null : insight.urls,
        thinking: insight.thinking
    };
}
function $215d678d855c7560$var$mapGroup(group, groupIndex) {
    const groupId = $215d678d855c7560$var$makeId(group.type, groupIndex);
    const subItems = (group.insights ?? []).map((insight, idx)=>$215d678d855c7560$var$mapSubItem(insight, groupId, idx, {
            isMeetingGroup: $215d678d855c7560$var$isMeetingGroup(group)
        }));
    return {
        id: groupId,
        title: group.title,
        category: group.type,
        icon: (0, $47f35143d0efa6a5$export$2449f7dd7c6cf072)(group.icon),
        iconAppearance: (0, $47f35143d0efa6a5$export$4298f62f89b93bab)(group.color),
        // Preserve the raw API string keys alongside the resolved values so external
        // consumers (e.g. the home insights carousel) can pass them over the
        // rovo-triggers event bus and re-resolve panel-side. React components and
        // IconTile appearances are not serializable across the bus; the string keys are.
        iconKey: group.icon,
        iconColor: group.color,
        count: group.count,
        subItems: subItems,
        debugInfo: group.debug_info ? {
            generatedAt: group.debug_info.generated_at ?? '',
            prompt: group.debug_info.prompt ?? '',
            llmResponse: group.debug_info.llm_response ?? '',
            error: group.debug_info.error ?? null,
            durationSecs: group.debug_info.duration_secs ?? 0,
            attempts: group.debug_info.attempts ?? 0
        } : undefined
    };
}
/**
 * Maps the API `summary_details` object into the UI summary model, if present.
 * Returns `undefined` when the backend has not supplied structured summary data
 * so the header can fall back to the flat `summary` string.
 */ function $215d678d855c7560$var$mapSummaryDetails(response) {
    const details = response.summary_details;
    if (!details) return undefined;
    return {
        insightCount: details.insight_count,
        appCount: details.app_count,
        sourceApps: (details.source_apps ?? []).map((app)=>({
                id: app.id,
                name: app.name
            }))
    };
}
function $215d678d855c7560$export$b880df30f8e495e7(response) {
    const items = (response.insight_groups ?? []).map($215d678d855c7560$var$mapGroup);
    const totalCount = response.count > 0 ? response.count : items.reduce((sum, item)=>sum + item.count, 0);
    return {
        totalCount: totalCount,
        summary: response.summary,
        summaryDetails: $215d678d855c7560$var$mapSummaryDetails(response),
        generatedAt: response.generated_at,
        items: items
    };
}


const $46a7b2d8f96f6487$export$f0db2ad628cc4761 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, debugInfo: debugInfoRequested, enabled: enabled })=>{
    const insightsService = (0, $cozmU.useMemo)(()=>{
        const config = assistanceService.getConfig();
        return new (0, $4pKRH.RovoInsightsService)(config);
    }, [
        assistanceService
    ]);
    const { data: data, error: error, isFetching: isFetching, refetch: refetch } = (0, $5SS4O.useQuery)({
        queryKey: [
            'insightsFeed',
            String(debugInfoRequested ?? false)
        ],
        enabled: enabled,
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_FEED,
                name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_FEED
            });
            try {
                const response = await insightsService.getInsightsFeed({
                    debugInfo: debugInfoRequested
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_FEED
                });
                return response;
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_FEED,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        }
    });
    const mapped = (0, $cozmU.useMemo)(()=>data ? (0, $215d678d855c7560$export$b880df30f8e495e7)(data) : null, [
        data
    ]);
    const hasDebugData = mapped?.items.some((item)=>item.debugInfo !== undefined) ?? false;
    return {
        items: mapped?.items ?? [],
        totalCount: mapped?.totalCount ?? 0,
        summary: mapped?.summary ?? '',
        summaryDetails: mapped?.summaryDetails,
        generatedAt: mapped?.generatedAt,
        isLoading: isFetching && !data,
        hasError: !isFetching && !data && error !== null,
        retry: refetch,
        hasDebugData: hasDebugData,
        rawResponse: data ?? null
    };
});


const $dc4876b59268118a$var$debugStyles = {
    headerHoverContainer: "_1mT5xdRAKS",
    debugToggleWrapper: "_23rrnHWgmT _1mT5xdWVPG _1OKFqYdnbC _2I62gz2ADO _1YKVNsdnbC",
    debugToggleWrapperActive: "_23rrnHWgmT _1mT5xdWVPG _1OKFqYdnbC _2I62gz2ADO _1YKVNs7dHp"
};
const $dc4876b59268118a$var$scrollContainerBaseStyles = null;
const $dc4876b59268118a$var$scrollContainerPaddingStyles = {
    default: "_46hvQm5zaO _03SyCP5zaO _0xmtko5zaO _0LQT5E5zaO",
    fullScreen: "_46hvQm2ADO _03SyCPNHnM _0xmtkoNHnM _0LQT5ENHnM"
};
const $dc4876b59268118a$var$styles = {
    mainContent: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w",
    centeredContainer: "_39xV02N91d _2eplquIZbP _2pzWtIflcy",
    listContainer: "_2mHwu8dnbC _3iDTPbQ4SZ _0aFT5vbt8w"
}; /**
    * InsightsFeed — Top-level component that composes InsightsFeedHeader
    * and multiple InsightsFeedGroup components into the full weekly insights list view.
    *
    * Fetches live data from the Rovo Insights API (`/rovo/v1/insights/fetch`).
    * Shows a loading shimmer while fetching and an error screen with retry on failure.
    */ 
const $dc4876b59268118a$var$InsightsFeedBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { chatRefreshHeader: chatRefreshHeader, assistanceServiceParams: assistanceServiceParams, onInsightReady: onInsightReady, invokedFrom: invokedFrom, isFullScreen: t1, connectAppsAction: connectAppsAction } = t0;
    const isFullScreen = t1 === undefined ? false : t1;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    let t2;
    if ($[0] !== invokedFrom) {
        t2 = {
            invokedFrom: invokedFrom
        };
        $[0] = invokedFrom;
        $[1] = t2;
    } else t2 = $[1];
    const { onFeedContentDisplayed: onFeedContentDisplayed, onInsightCardClicked: onInsightCardClicked, onUrlClicked: onUrlClicked, onRetryClicked: onRetryClicked } = (0, $ed7c817b0c93b0a6$export$b3975bf0ef145e10)(t2);
    const hasScreenFired = (0, $cozmU.useRef)(false);
    const hasContentFired = (0, $cozmU.useRef)(false);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("rovo-growth-insights-debug-enabled");
        $[2] = t3;
    } else t3 = $[2];
    const isDebugGateEnabled = t3;
    const [debugEnabled, setDebugEnabled] = (0, $cozmU.useState)(false);
    const [headerHovered, setHeaderHovered] = (0, $cozmU.useState)(false);
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setHeaderHovered(true);
        $[3] = t4;
    } else t4 = $[3];
    const handleHeaderMouseEnter = t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setHeaderHovered(false);
        $[4] = t5;
    } else t5 = $[4];
    const handleHeaderMouseLeave = t5;
    let t6;
    if ($[5] !== assistanceServiceParams || $[6] !== debugEnabled) {
        t6 = {
            assistanceServiceParams: assistanceServiceParams,
            debugInfo: debugEnabled
        };
        $[5] = assistanceServiceParams;
        $[6] = debugEnabled;
        $[7] = t6;
    } else t6 = $[7];
    const { items: items, totalCount: totalCount, summary: summary, summaryDetails: summaryDetails, generatedAt: generatedAt, isLoading: isLoading, hasError: hasError, retry: retry, hasDebugData: hasDebugData, rawResponse: rawResponse } = (0, $46a7b2d8f96f6487$export$f0db2ad628cc4761)(t6);
    let t7;
    let t8;
    if ($[8] !== fireAnalyticsEvent) {
        t7 = ()=>{
            if (!hasScreenFired.current) {
                hasScreenFired.current = true;
                fireAnalyticsEvent({
                    eventType: "screen",
                    name: "insightsFeedScreen"
                });
            }
        };
        t8 = [
            fireAnalyticsEvent
        ];
        $[8] = fireAnalyticsEvent;
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[11] !== fireAnalyticsEvent || $[12] !== hasError) {
        t9 = ()=>{
            if (hasError) fireAnalyticsEvent({
                eventType: "screen",
                name: "insightsFeedErrorScreen",
                tags: [
                    "atlaskit"
                ]
            });
        };
        t10 = [
            hasError,
            fireAnalyticsEvent
        ];
        $[11] = fireAnalyticsEvent;
        $[12] = hasError;
        $[13] = t10;
        $[14] = t9;
    } else {
        t10 = $[13];
        t9 = $[14];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[15] !== fireAnalyticsEvent || $[16] !== hasError || $[17] !== isLoading || $[18] !== items || $[19] !== onFeedContentDisplayed || $[20] !== totalCount) {
        t11 = ()=>{
            if (!isLoading && !hasError && items.length > 0 && !hasContentFired.current) {
                hasContentFired.current = true;
                const contentAttributes = {
                    insightTypes: items.map($dc4876b59268118a$var$_temp),
                    insightCount: totalCount,
                    groupCount: items.length
                };
                fireAnalyticsEvent({
                    eventType: "track",
                    actionSubject: "insightsFeedContent",
                    action: "displayed",
                    attributes: contentAttributes
                });
                onFeedContentDisplayed(contentAttributes);
            }
        };
        t12 = [
            isLoading,
            hasError,
            items,
            totalCount,
            fireAnalyticsEvent,
            onFeedContentDisplayed
        ];
        $[15] = fireAnalyticsEvent;
        $[16] = hasError;
        $[17] = isLoading;
        $[18] = items;
        $[19] = onFeedContentDisplayed;
        $[20] = totalCount;
        $[21] = t11;
        $[22] = t12;
    } else {
        t11 = $[21];
        t12 = $[22];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[23] !== items || $[24] !== onInsightCardClicked || $[25] !== onInsightReady) {
        t13 = (insightId)=>{
            for (const group of items){
                const subItem = group.subItems?.find((s)=>s.id === insightId);
                if (subItem?.detailsAdf) {
                    onInsightCardClicked(group.category);
                    onInsightReady?.(subItem.detailsAdf, {
                        conversationTitle: subItem.title,
                        conversationIcon: group.icon,
                        conversationIconAppearance: group.iconAppearance,
                        followUps: subItem.followUps ?? []
                    });
                    return;
                }
            }
        };
        $[23] = items;
        $[24] = onInsightCardClicked;
        $[25] = onInsightReady;
        $[26] = t13;
    } else t13 = $[26];
    const handleInsightClick = t13;
    const t14 = !isFullScreen;
    let t15;
    if ($[27] !== connectAppsAction || $[28] !== generatedAt || $[29] !== isFullScreen || $[30] !== summary || $[31] !== summaryDetails || $[32] !== t14 || $[33] !== totalCount) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0695b3e1a8e71014$export$4cdacb015559b223), {
            totalCount: totalCount,
            summary: summary,
            summaryDetails: summaryDetails,
            generatedAt: generatedAt,
            isFullScreen: isFullScreen,
            connectAppsAction: connectAppsAction,
            animationEnabled: t14
        });
        $[27] = connectAppsAction;
        $[28] = generatedAt;
        $[29] = isFullScreen;
        $[30] = summary;
        $[31] = summaryDetails;
        $[32] = t14;
        $[33] = totalCount;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== debugEnabled || $[36] !== headerHovered) {
        t16 = isDebugGateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: headerHovered || debugEnabled ? $dc4876b59268118a$var$debugStyles.debugToggleWrapperActive : $dc4876b59268118a$var$debugStyles.debugToggleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2aeeba3d8d86e16$export$82fd044c23f7dd3e), {
            isEnabled: debugEnabled,
            onChange: setDebugEnabled
        }));
        $[35] = debugEnabled;
        $[36] = headerHovered;
        $[37] = t16;
    } else t16 = $[37];
    let t17;
    if ($[38] !== t15 || $[39] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dc4876b59268118a$var$debugStyles.headerHoverContainer,
            onMouseEnter: handleHeaderMouseEnter,
            onMouseLeave: handleHeaderMouseLeave
        }, t15, t16);
        $[38] = t15;
        $[39] = t16;
        $[40] = t17;
    } else t17 = $[40];
    const headerBlock = t17;
    let t18;
    if ($[41] !== headerBlock || $[42] !== isFullScreen) {
        t18 = isFullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
            index: 0,
            isEnabled: true,
            testId: "insights-feed-header-animation-section"
        }, headerBlock) : headerBlock;
        $[41] = headerBlock;
        $[42] = isFullScreen;
        $[43] = t18;
    } else t18 = $[43];
    const animatedHeaderBlock = t18;
    const groupAnimationStartIndex = isFullScreen ? 1 : 2;
    let t19;
    if ($[44] !== isLoading) {
        t19 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c833cdb04e51bd40$export$ab0118c030d8731d), null);
        $[44] = isLoading;
        $[45] = t19;
    } else t19 = $[45];
    let t20;
    if ($[46] !== hasError || $[47] !== onRetryClicked || $[48] !== retry) {
        t20 = hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61f5479ff8b33c43$export$a40a0d17d63f9975), {
            onRetry: ()=>{
                onRetryClicked();
                retry();
            }
        });
        $[46] = hasError;
        $[47] = onRetryClicked;
        $[48] = retry;
        $[49] = t20;
    } else t20 = $[49];
    let t21;
    if ($[50] !== animatedHeaderBlock || $[51] !== groupAnimationStartIndex || $[52] !== handleInsightClick || $[53] !== hasDebugData || $[54] !== hasError || $[55] !== headerBlock || $[56] !== isFullScreen || $[57] !== isLoading || $[58] !== items || $[59] !== onUrlClicked || $[60] !== rawResponse) {
        t21 = !isLoading && !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "insights-feed-scroll-container",
            className: (0, $hekY6.default)([
                "_4bt5LAIZbP _2WAcuGIZbP _2R4pr3YbGa _2O5Vij7dHp _0KLXrulfZc",
                $dc4876b59268118a$var$scrollContainerPaddingStyles[isFullScreen ? "fullScreen" : "default"]
            ])
        }, isFullScreen && animatedHeaderBlock, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dc4876b59268118a$var$styles.centeredContainer
        }, !isFullScreen && headerBlock, hasDebugData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20dc3054e9f448fc$export$b360852b92fd2157), {
            items: items,
            rawResponse: rawResponse
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $dc4876b59268118a$var$styles.listContainer
        }, items.map((item_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
                key: item_0.id,
                index: groupAnimationStartIndex + index,
                isEnabled: true,
                testId: `insights-feed-group-animation-section-${index}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7292d9f50aa149ae$export$90d156cbbda6692f), {
                item: item_0,
                onInsightPress: handleInsightClick,
                isFullScreen: isFullScreen,
                onLinkClick: onUrlClicked,
                headerExtra: hasDebugData && item_0.debugInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e09ee8f8beac8cd4$export$6b086eff7b8c2fb4), {
                    debugInfo: item_0.debugInfo
                }) : undefined,
                renderSubItemExtra: hasDebugData ? $dc4876b59268118a$var$_temp2 : undefined
            }))))));
        $[50] = animatedHeaderBlock;
        $[51] = groupAnimationStartIndex;
        $[52] = handleInsightClick;
        $[53] = hasDebugData;
        $[54] = hasError;
        $[55] = headerBlock;
        $[56] = isFullScreen;
        $[57] = isLoading;
        $[58] = items;
        $[59] = onUrlClicked;
        $[60] = rawResponse;
        $[61] = t21;
    } else t21 = $[61];
    let t22;
    if ($[62] !== hasError || $[63] !== isLoading || $[64] !== items) {
        t22 = !isLoading && !hasError && items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6615ee31bf93d5ae$export$521d6a85dda09ec9), null);
        $[62] = hasError;
        $[63] = isLoading;
        $[64] = items;
        $[65] = t22;
    } else t22 = $[65];
    let t23;
    if ($[66] !== chatRefreshHeader || $[67] !== t19 || $[68] !== t20 || $[69] !== t21 || $[70] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $dc4876b59268118a$var$styles.mainContent
        }, chatRefreshHeader, t19, t20, t21, t22);
        $[66] = chatRefreshHeader;
        $[67] = t19;
        $[68] = t20;
        $[69] = t21;
        $[70] = t22;
        $[71] = t23;
    } else t23 = $[71];
    return t23;
} : ({ chatRefreshHeader: chatRefreshHeader, assistanceServiceParams: assistanceServiceParams, onInsightReady: onInsightReady, invokedFrom: invokedFrom, isFullScreen: isFullScreen = false, connectAppsAction: connectAppsAction })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    const { onFeedContentDisplayed: onFeedContentDisplayed, onInsightCardClicked: onInsightCardClicked, onUrlClicked: onUrlClicked, onRetryClicked: onRetryClicked } = (0, $ed7c817b0c93b0a6$export$b3975bf0ef145e10)({
        invokedFrom: invokedFrom
    });
    const hasScreenFired = (0, $cozmU.useRef)(false);
    const hasContentFired = (0, $cozmU.useRef)(false);
    const isDebugGateEnabled = (0, $iDrrr.fg)('rovo-growth-insights-debug-enabled');
    const [debugEnabled, setDebugEnabled] = (0, $cozmU.useState)(false);
    const [headerHovered, setHeaderHovered] = (0, $cozmU.useState)(false);
    const handleHeaderMouseEnter = (0, $cozmU.useCallback)(()=>setHeaderHovered(true), []);
    const handleHeaderMouseLeave = (0, $cozmU.useCallback)(()=>setHeaderHovered(false), []);
    const { items: items, totalCount: totalCount, summary: summary, summaryDetails: summaryDetails, generatedAt: generatedAt, isLoading: isLoading, hasError: hasError, retry: retry, hasDebugData: hasDebugData, rawResponse: rawResponse } = (0, $46a7b2d8f96f6487$export$f0db2ad628cc4761)({
        assistanceServiceParams: assistanceServiceParams,
        debugInfo: debugEnabled
    });
    (0, $cozmU.useEffect)(()=>{
        if (!hasScreenFired.current) {
            hasScreenFired.current = true;
            fireAnalyticsEvent({
                eventType: 'screen',
                name: 'insightsFeedScreen'
            });
        }
    }, [
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasError) fireAnalyticsEvent({
            eventType: 'screen',
            name: 'insightsFeedErrorScreen',
            tags: [
                'atlaskit'
            ]
        });
    }, [
        hasError,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isLoading && !hasError && items.length > 0 && !hasContentFired.current) {
            hasContentFired.current = true;
            const contentAttributes = {
                insightTypes: items.map((item)=>item.category),
                insightCount: totalCount,
                groupCount: items.length
            };
            fireAnalyticsEvent({
                eventType: 'track',
                actionSubject: 'insightsFeedContent',
                action: 'displayed',
                attributes: contentAttributes
            });
            onFeedContentDisplayed(contentAttributes);
        }
    }, [
        isLoading,
        hasError,
        items,
        totalCount,
        fireAnalyticsEvent,
        onFeedContentDisplayed
    ]);
    const handleInsightClick = (0, $cozmU.useCallback)((insightId)=>{
        for (const group of items){
            const subItem = group.subItems?.find((s)=>s.id === insightId);
            if (subItem?.detailsAdf) {
                onInsightCardClicked(group.category);
                onInsightReady?.(subItem.detailsAdf, {
                    conversationTitle: subItem.title,
                    conversationIcon: group.icon,
                    conversationIconAppearance: group.iconAppearance,
                    followUps: subItem.followUps ?? []
                });
                return;
            }
        }
    }, [
        items,
        onInsightReady,
        onInsightCardClicked
    ]);
    const headerBlock = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $dc4876b59268118a$var$debugStyles.headerHoverContainer,
        onMouseEnter: handleHeaderMouseEnter,
        onMouseLeave: handleHeaderMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0695b3e1a8e71014$export$4cdacb015559b223), {
        totalCount: totalCount,
        summary: summary,
        summaryDetails: summaryDetails,
        generatedAt: generatedAt,
        isFullScreen: isFullScreen,
        connectAppsAction: connectAppsAction,
        animationEnabled: !isFullScreen
    }), isDebugGateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: headerHovered || debugEnabled ? $dc4876b59268118a$var$debugStyles.debugToggleWrapperActive : $dc4876b59268118a$var$debugStyles.debugToggleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2aeeba3d8d86e16$export$82fd044c23f7dd3e), {
        isEnabled: debugEnabled,
        onChange: setDebugEnabled
    })));
    const animatedHeaderBlock = isFullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
        index: 0,
        isEnabled: true,
        testId: "insights-feed-header-animation-section"
    }, headerBlock) : headerBlock;
    const groupAnimationStartIndex = isFullScreen ? 1 : 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: $dc4876b59268118a$var$styles.mainContent
    }, chatRefreshHeader, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c833cdb04e51bd40$export$ab0118c030d8731d), null), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61f5479ff8b33c43$export$a40a0d17d63f9975), {
        onRetry: ()=>{
            onRetryClicked();
            retry();
        }
    }), !isLoading && !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "insights-feed-scroll-container",
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _2R4pr3YbGa _2O5Vij7dHp _0KLXrulfZc",
            $dc4876b59268118a$var$scrollContainerPaddingStyles[isFullScreen ? 'fullScreen' : 'default']
        ])
    }, isFullScreen && animatedHeaderBlock, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $dc4876b59268118a$var$styles.centeredContainer
    }, !isFullScreen && headerBlock, hasDebugData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20dc3054e9f448fc$export$b360852b92fd2157), {
        items: items,
        rawResponse: rawResponse
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $dc4876b59268118a$var$styles.listContainer
    }, items.map((item_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ed0cf6e998fd5f$export$88a8e03778d59330), {
            key: item_0.id,
            index: groupAnimationStartIndex + index,
            isEnabled: true,
            testId: `insights-feed-group-animation-section-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7292d9f50aa149ae$export$90d156cbbda6692f), {
            item: item_0,
            onInsightPress: handleInsightClick,
            isFullScreen: isFullScreen,
            onLinkClick: onUrlClicked,
            headerExtra: hasDebugData && item_0.debugInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e09ee8f8beac8cd4$export$6b086eff7b8c2fb4), {
                debugInfo: item_0.debugInfo
            }) : undefined,
            renderSubItemExtra: hasDebugData ? (subItem_0)=>subItem_0.thinking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8c8e5081997f20d$export$a4e4618569bae392), {
                    thinking: subItem_0.thinking
                }) : null : undefined
        })))))), !isLoading && !hasError && items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6615ee31bf93d5ae$export$521d6a85dda09ec9), null));
};
const $dc4876b59268118a$export$fe20473522563107 = /*#__PURE__*/ (0, $cozmU.memo)($dc4876b59268118a$var$InsightsFeedBase);
function $dc4876b59268118a$var$_temp(item) {
    return item.category;
}
function $dc4876b59268118a$var$_temp2(subItem_0) {
    return subItem_0.thinking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8c8e5081997f20d$export$a4e4618569bae392), {
        thinking: subItem_0.thinking
    }) : null;
}






var $7bLo5 = parcelRequire("7bLo5");


var $1Bxlw = parcelRequire("1Bxlw");


var $7dHQW = parcelRequire("7dHQW");


var $12shJ = parcelRequire("12shJ");

const $e690d34cff371f6d$export$561111ab539b745 = (sources, overrideConversationIds)=>sources.map((s)=>({
            id: s.ari,
            ari: s.ari,
            url: s.url,
            sourceType: s.sourceType,
            name: s.name,
            conversationIds: overrideConversationIds ?? s.conversationIds
        }));



var $gh5g4 = parcelRequire("gh5g4");


var $jxAn2 = parcelRequire("jxAn2");





var $9zU5G = parcelRequire("9zU5G");











var $hdBxM = parcelRequire("hdBxM");




const $00ac30b4544c79bb$export$86880b4b2e1a2384 = 'rovo_chat_auto_convo_fired';


const $e3aa6c347ce3bde3$export$535da5763501ee13 = ()=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem((0, $00ac30b4544c79bb$export$86880b4b2e1a2384)) === 'true';
    } catch  {
        // localStorage unavailable — fail open (don't block)
        return false;
    }
};



const $6e0e77bda375d48d$export$8980ee4e9a4e0712 = ()=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem((0, $00ac30b4544c79bb$export$86880b4b2e1a2384), 'true');
    } catch  {
    // localStorage unavailable (e.g. private browsing quota exceeded) — silently ignore
    }
};














const $dfacf41752d9a6aa$var$getPersonalizationUserTraitsUrl = (userId)=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
const $dfacf41752d9a6aa$var$fetchUserPersonalization = async (userId)=>{
    const response = await fetch($dfacf41752d9a6aa$var$getPersonalizationUserTraitsUrl(userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch user personalization: ${response.status}`);
    const { attributes: attributes } = await response.json();
    return attributes ?? [];
};
const $dfacf41752d9a6aa$var$fetchHasSentRovoChatAudience = async (userId)=>{
    const userTraits = await $dfacf41752d9a6aa$var$fetchUserPersonalization(userId);
    const audience = userTraits?.find((t)=>t.name === 'segment_has_sent_rovo_chat_message_aaid');
    if (!audience || typeof audience.value !== 'boolean') return undefined;
    return audience.value;
};
const $dfacf41752d9a6aa$export$d0e560b64caf187d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (userId)=>{
    const $ = (0, $bDgLe.c)(7);
    const [hasSentRovoChatMessage, setHasSentRovoChatMessage] = (0, $cozmU.useState)(undefined);
    const [loaded, setLoaded] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t0;
    let t1;
    if ($[0] !== sendAnalyticsEvent || $[1] !== userId) {
        t0 = ()=>{
            let cancelled = false;
            setLoaded(false);
            setHasSentRovoChatMessage(undefined);
            $dfacf41752d9a6aa$var$fetchHasSentRovoChatAudience(userId).then((audience)=>{
                if (!cancelled) {
                    setHasSentRovoChatMessage(audience);
                    setLoaded(true);
                }
            }).catch(()=>{
                if (!cancelled) {
                    sendAnalyticsEvent({
                        eventType: "operational",
                        action: "failed",
                        actionSubject: "fetchHasSentRovoChatMessage",
                        attributes: {
                            reason: "TAP failure - `segment_has_sent_rovo_chat_message_aaid` fetch failed, silently failing"
                        }
                    });
                    setLoaded(true);
                }
            });
            return ()=>{
                cancelled = true;
            };
        };
        t1 = [
            userId,
            sendAnalyticsEvent
        ];
        $[0] = sendAnalyticsEvent;
        $[1] = userId;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] !== hasSentRovoChatMessage || $[5] !== loaded) {
        t2 = {
            hasSentRovoChatMessage: hasSentRovoChatMessage,
            loaded: loaded
        };
        $[4] = hasSentRovoChatMessage;
        $[5] = loaded;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (userId)=>{
    const [hasSentRovoChatMessage, setHasSentRovoChatMessage] = (0, $cozmU.useState)(undefined);
    const [loaded, setLoaded] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        // Reset loaded state when userId changes so callers don't act on stale settled state
        setLoaded(false);
        setHasSentRovoChatMessage(undefined);
        $dfacf41752d9a6aa$var$fetchHasSentRovoChatAudience(userId).then((audience)=>{
            if (!cancelled) {
                setHasSentRovoChatMessage(audience);
                setLoaded(true);
            }
        }).catch(()=>{
            if (!cancelled) {
                // Silently fail — fire an analytics event so we can monitor TAP failures.
                // loaded is set to true so callers are not blocked forever; hasSentRovoChatMessage
                // remains undefined, which means we will still evaluate the experiment if all
                // other checks pass. For non-control cohorts, this could incorrectly trigger the
                // experiment for users who have already sent a message before, so we log here to
                // keep an eye on it.
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchHasSentRovoChatMessage',
                    attributes: {
                        reason: 'TAP failure - `segment_has_sent_rovo_chat_message_aaid` fetch failed, silently failing'
                    }
                });
                setLoaded(true);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        userId,
        sendAnalyticsEvent
    ]);
    return {
        hasSentRovoChatMessage: hasSentRovoChatMessage,
        loaded: loaded
    };
};



var $8KiU9 = parcelRequire("8KiU9");

const $4a19df5316a59c71$export$ff48c21c5b9b5257 = ({ userId: userId, firedRef: firedRef })=>{
    const { hasSentRovoChatMessage: hasSentRovoChatMessage, loaded: loaded } = (0, $dfacf41752d9a6aa$export$d0e560b64caf187d)(userId);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    // Conditions to evaluate the `full_screen_chat_auto_conversations` experiment:
    // 1. firedRef is false — only evaluate once. Ref lives in the parent so it survives
    //    unmount/remount cycles (e.g. user navigates away mid-stream, isEmptyConvo toggles).
    // 2. hasAutoConversationFired() is false — localStorage guard (30-min TTL) that persists
    //    across full React remounts, page reloads, and new tabs. Prevents re-exposure during the
    //    window where the TAP trait hasn't updated yet after the user sent their first message.
    // 3. loaded is true — the TAP fetch has settled. Without this guard, the effect fires on the
    //    first render while the fetch is still in-flight (hasSentRovoChatMessage = undefined),
    //    which causes the experiment to evaluate before we know if the user has already sent a
    //    message. This was most visible in townsquare where the userStore hydrates async, giving
    //    the fetch even less time to resolve before the component mounts and the effect fires.
    // 4. hasSentRovoChatMessage is strictly NOT true — undefined (new user, no trait) and false
    //    both warrant evaluation; only true blocks it.
    const shouldEvaluateAutoConversation = !firedRef.current && !(0, $e3aa6c347ce3bde3$export$535da5763501ee13)() && loaded && hasSentRovoChatMessage !== true;
    const fireExperimentAnalytics = (cohort)=>{
        sendAnalyticsEvent({
            action: 'fired',
            actionSubject: 'autoConversationPrompt',
            attributes: {
                userId: userId,
                experimentCohort: cohort,
                hasSentRovoChatMessage: hasSentRovoChatMessage
            }
        });
    };
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'autoConversationEvaluator',
            attributes: {
                shouldEvaluateAutoConversation: // If this is true, we will evaluate the experiment and potentially expose the user to it
                shouldEvaluateAutoConversation,
                userId: userId,
                // Logging left side of shouldEvaluateAutoConversation: If this is true, we have already evaluated the experiment and will not evaluate it again
                autoConversationFiredRefCurrentValue: firedRef.current,
                // Logging right side of shouldEvaluateAutoConversation: If this is true, the TAP fetch has settled
                hasSentRovoChatMessageLoaded: loaded,
                hasSentRovoChatMessage: // Logging right side of shouldEvaluateAutoConversation: If this is true, the user has already sent a message and we will NOT evaluate the experiment
                hasSentRovoChatMessage
            }
        });
        if (shouldEvaluateAutoConversation) {
            // Set this to true so that we don't evaluate the experiment again. Because firedRef
            // lives in the parent, this persists across unmount/remount cycles of this component
            // (e.g. when the user navigates away mid-stream and isEmptyConvo toggles back to true).
            firedRef.current = true;
            // Also persist to localStorage (30-min TTL) so we don't re-expose the user if the
            // React tree fully remounts (e.g. page reload, tab reopen) before the TAP trait
            // (`segment_has_sent_rovo_chat_message_aaid`) has had time to update.
            (0, $6e0e77bda375d48d$export$8980ee4e9a4e0712)();
            switch((0, $cXtTj.default).getExperimentValue('full_screen_chat_auto_conversations', 'cohort', 'control')){
                case 'auto-trigger':
                    requestAnimationFrame(()=>{
                        publish({
                            type: 'chat-new',
                            source: 'ai-mate-auto-conversations',
                            data: {
                                prompt: formatMessage((0, $8KiU9.default).autoConversationPrompt),
                                dialogues: []
                            }
                        });
                    });
                    fireExperimentAnalytics('auto-trigger');
                    break;
                case 'manual-trigger':
                    requestAnimationFrame(()=>{
                        publish({
                            type: 'insert-prompt',
                            source: 'ai-mate-auto-conversations',
                            data: {
                                prompt: formatMessage((0, $8KiU9.default).autoConversationPrompt),
                                overrideAutoSend: true
                            }
                        });
                    });
                    fireExperimentAnalytics('manual-trigger');
                    break;
                case 'control':
                    fireExperimentAnalytics('control');
                    break;
                default:
                    fireExperimentAnalytics('none');
                    break;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- firedRef.current is intentionally excluded (refs are mutable by design and should not be deps); hasSentRovoChatMessage is intentionally excluded (already captured by shouldEvaluateAutoConversation — including it causes the effect to fire twice per trait change)
    }, [
        shouldEvaluateAutoConversation,
        sendAnalyticsEvent,
        fireExperimentAnalytics,
        publish,
        formatMessage,
        userId
    ]);
    // manual-trigger: fire on unmount if prompt was inserted but user left without sending.
    // Measures prompt visibility — high rate may indicate cohort/placement needs revisiting.
    // FeatureGates.getExperimentValue in cleanup is safe: cohort is stable for the session.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (shouldEvaluateAutoConversation && (0, $cXtTj.default).getExperimentValue('full_screen_chat_auto_conversations', 'cohort', 'control') === 'manual-trigger') sendAnalyticsEvent({
                action: 'dismissed',
                actionSubject: 'autoConversationPrompt',
                attributes: {
                    userId: userId,
                    hasSentRovoChatMessage: hasSentRovoChatMessage
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: this cleanup should only run on unmount, capturing the values at mount time via closure is correct here
    }, []);
    return null;
};


/**
 * SBSIntegrationWrapper — owns all SBS orchestration logic so that main.tsx
 * doesn't need to know about SBS internals.
 *
 * This component:
 *  - Checks the `rovo-ext_sbs_enabled` feature flag
 *  - Tracks the streaming → idle transition to derive `isRovoResponseComplete`
 *  - Lazily loads SBSIntegration via React.lazy + Suspense
 */ 












// Lazy-loaded — never bundled with the main entry point
const $28da84cb48823e6d$var$LazySBSIntegration = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("ciTZQ")));
function $28da84cb48823e6d$export$c774df50165feb42({ userId: userId, siteId: siteId, product: product, conversationId: conversationId, conversationStatus: conversationStatus }) {
    // Track the streaming → idle transition to derive isRovoResponseComplete.
    // The conversation status goes through: idle → awaitingResponse → typingResponse → idle.
    // We only report "complete" after the conversation has been in a streaming state
    // (awaitingResponse or typingResponse) and then returns to idle. This prevents
    // a false positive on initial load when the status is already idle.
    const hasSeenStreamingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).typingResponse) hasSeenStreamingRef.current = true;
    }, [
        conversationStatus
    ]);
    // Gate on feature flag — render nothing when disabled
    if (!(0, $iDrrr.fg)('rovo-ext_sbs_enabled')) return null;
    const isRovoResponseComplete = product === 'rovo' && conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).idle && hasSeenStreamingRef.current;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "conversation-assistant-sbs-suspense"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28da84cb48823e6d$var$LazySBSIntegration, {
        userId: userId,
        siteId: siteId,
        product: product,
        isRovoResponseComplete: isRovoResponseComplete,
        conversationId: conversationId
    }));
}



var $oV0CU = parcelRequire("oV0CU");


var $kQqCc = parcelRequire("kQqCc");











var $n71o5 = parcelRequire("n71o5");


var $20Kr8 = parcelRequire("20Kr8");

const $e3d69e952650eeff$export$dc569ceb34d86e76 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { override: override, setOverride: setOverride } = (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext));
    const [t0] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId } = t0;
    let t1;
    if ($[0] !== currentConversationId || $[1] !== override || $[2] !== setOverride) {
        t1 = ()=>{
            if (override && currentConversationId !== override.conversationId) setOverride(null);
        };
        $[0] = currentConversationId;
        $[1] = override;
        $[2] = setOverride;
        $[3] = t1;
    } else t1 = $[3];
    const clearIfConversationChanged = t1;
    let t2;
    let t3;
    if ($[4] !== clearIfConversationChanged) {
        t2 = ()=>{
            clearIfConversationChanged();
        };
        t3 = [
            clearIfConversationChanged
        ];
        $[4] = clearIfConversationChanged;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return null;
} : ()=>{
    const { override: override, setOverride: setOverride } = (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext));
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const clearIfConversationChanged = (0, $cozmU.useCallback)(()=>{
        if (override && currentConversationId !== override.conversationId) setOverride(null);
    }, [
        override,
        currentConversationId,
        setOverride
    ]);
    (0, $cozmU.useEffect)(()=>{
        clearIfConversationChanged();
    }, [
        clearIfConversationChanged
    ]);
    return null;
};












var $iW40i = parcelRequire("iW40i");





var $2g97a = parcelRequire("2g97a");

const $15955c64672089f8$export$d9047a7a8ec8ea5c = (messages)=>{
    return (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreHuman));
};



var $e8YqO = parcelRequire("e8YqO");


var $6GT8L = parcelRequire("6GT8L");

const $028d4bac1398707f$var$EXPERIMENT_NAME = 'rovo_minimodal_auto_expand_on_chat';
const $028d4bac1398707f$var$EXPERIMENT_PARAM = 'isEnabled';
/** Target size (px) the mini-modal auto-expands toward when a chat begins. */ const $028d4bac1398707f$var$TARGET_WIDTH = 450;
const $028d4bac1398707f$var$TARGET_HEIGHT = 700;
const $028d4bac1398707f$export$37d36887304d381f = ({ setSize: setSize, isResizeEnabled: isResizeEnabled })=>{
    // Emptiness is derived from the actual chat messages, NOT from the conversation
    // id. When the modal opens directly onto a conversation, the chat store assigns
    // a real `currentConversationId` before the history has loaded, so an id-only
    // check reports "non-empty" while there are still zero messages — causing a
    // premature grow into a modal full of awkward whitespace with no greeting
    // (TREX-1726). Reading the real messages, plus waiting for any in-flight
    // history fetch to settle, avoids that race.
    //
    // Messages live in the dedicated `useChatMessages` store keyed by conversation
    // id — NOT on `Conversation.messages` (which stays empty). We only read
    // `useCurrentConversation` for its load `status`.
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    const currentConversation = (0, $e8YqO.useCurrentConversation)();
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const isFetchInFlight = currentConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).loadingChat;
    // Memoised so the human-message scan only re-runs when the messages array
    // reference changes, not on every unrelated re-render.
    const hasHumanMessage = (0, $cozmU.useMemo)(()=>(0, $15955c64672089f8$export$d9047a7a8ec8ea5c)(messages) !== undefined, [
        messages
    ]);
    // Tracks whether the conversation had a human message on the previous settled
    // render, so we grow exactly once on the no-message -> has-message edge.
    const hadHumanMessageRef = (0, $cozmU.useRef)(false);
    // Whether we've observed the first settled (not-in-flight) render yet. Used
    // only to label the analytics source: the very first settled render that
    // already has a message is a "mount into non-empty chat"; any later edge is a
    // "first message transition". It never affects whether we grow.
    const hasSettledOnceRef = (0, $cozmU.useRef)(false);
    // Stable ref so the trigger helper and effect don't need setSize in deps.
    const setSizeRef = (0, $cozmU.useRef)(setSize);
    setSizeRef.current = setSize;
    const runAutoExpandTrigger = (source)=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
        const isInTest = (0, $cXtTj.default).getExperimentValue($028d4bac1398707f$var$EXPERIMENT_NAME, $028d4bac1398707f$var$EXPERIMENT_PARAM, false, {
            fireExperimentExposure: false
        });
        // Control uses a dry-run so the "would grow" check applies the identical
        // viewport-clamp / don't-shrink logic as the real Test resize — otherwise
        // a viewport too small to reach the target would over-count Control.
        const result = setSizeRef.current({
            targetWidth: $028d4bac1398707f$var$TARGET_WIDTH,
            targetHeight: $028d4bac1398707f$var$TARGET_HEIGHT,
            source: source,
            dryRun: !isInTest
        });
        if (result.widthGrew || result.heightGrew) (0, $cXtTj.default).manuallyLogExperimentExposure($028d4bac1398707f$var$EXPERIMENT_NAME);
    };
    // Single source of truth for auto-expand: grow whenever the conversation goes
    // from "no human message" to "has a human message". A single effect (rather
    // than separate mount + transition effects) avoids any chance of both firing
    // for the same edge and double-counting the grow / exposure.
    //
    // This deliberately keys on the presence of a real human message rather than
    // the conversation id. When the modal opens directly onto a conversation, the
    // store assigns a real `currentConversationId` before the history loads, so an
    // id-only check would report "non-empty" while there are still zero messages —
    // growing into an empty, whitespace-filled modal with no greeting (TREX-1726).
    //
    // It covers both cases with one rule:
    //   - Send a chat in a fresh modal: false -> true edge fires the grow.
    //   - Open onto an existing conversation (deep-link/reload): the initial
    //     `hadHumanMessageRef` is false and, once the in-flight fetch settles with
    //     messages, the same false -> true edge fires the grow exactly once.
    // While the history fetch is in flight we hold off updating the baseline so a
    // transient empty render can't be mistaken for a genuine "no message" state.
    (0, $cozmU.useEffect)(()=>{
        if (!isResizeEnabled) return;
        if (isFetchInFlight) return;
        if (!hadHumanMessageRef.current && hasHumanMessage) // Label the source by whether the message was already present at the
        // first settled render (opened onto a non-empty chat) vs appeared later
        // (the user sent a chat). This is analytics-only; the grow is identical.
        runAutoExpandTrigger(hasSettledOnceRef.current ? 'first-message-transition' : 'mount-into-non-empty-chat');
        hadHumanMessageRef.current = hasHumanMessage;
        hasSettledOnceRef.current = true;
    // runAutoExpandTrigger is recreated every render and is intentionally
    // omitted from deps. This is only safe because every version of it reads
    // solely stable refs (setSizeRef) and the FeatureGates global — no
    // captured reactive values. Keep it that way: if this function ever
    // closes over a prop/state value, that value must be added to deps here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasHumanMessage,
        isFetchInFlight,
        isResizeEnabled
    ]);
};























const $a5f47f4537efba60$var$resizeHandleStyles = {
    topResizeHandle: "_30huDKYbGa _39xV02N91d _0jFU0VxpxF _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0wOv4QsE4D _0KLXrujOvk _4klSoXYbGa",
    topResizeIndicator: "_0bjKvDcjp5 _23rrnHFGLP _1mT5xdWVPG _0jFU0VUNDJ _39xV02HMkp _2IhTonPgdg _3OE6xY715P _1VJPcaiDnZ _0KLXrujOvk _1pp6NdYbGa",
    topResizeIndicatorHovered: "_0KLXruG6qS",
    leftResizeHandle: "_30huDKYbGa _39xV02xpxF _0jFU0VN91d _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0Bm75GdnbC _0wOv4QYNYw _0KLXrujOvk _4klSoXYbGa",
    leftResizeIndicator: "_0bjKvDcjp5 _23rrnHFGLP _1mT5xdWVPG _39xV02UNDJ _0jFU0VHMkp _3OE6xYPgdg _2IhTon715P _1VJPcaiDnZ _0KLXrujOvk _1pp6NdYbGa",
    leftResizeIndicatorHovered: "_0KLXruG6qS",
    cornerResizeHandle: "_30huDKYbGa _39xV02oWWg _0jFU0VoWWg _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0wOv4Qcuwk _0KLXrujOvk _4klSoXYbGa"
};
/**
 * Safety margin in pixels to prevent modal from reaching the bottom edge of the viewport
 */ const $a5f47f4537efba60$var$HEIGHT_SAFETY_MARGIN = 180; /**
                                   * Minimum height in pixels at which to show the greeting header when user has resized the mini modal
                                   */ 
const $a5f47f4537efba60$var$GREETING_HEADER_HEIGHT_THRESHOLD = 700; /**
                                               * Safety margin in pixels to prevent modal from reaching the right edge of the viewport
                                               */ 
const $a5f47f4537efba60$var$WIDTH_SAFETY_MARGIN = 100; /**
                                  * Hook for handling resizing from top (vertical) and left (horizontal) borders.
                                  * - Top border: drag down decreases height, drag up increases height
                                  * - Left border: drag left increases width, drag right decreases width
                                  *
                                  * @param options - Configuration options for the resize hook
                                  * @returns Object containing ref, state, handlers, and styles for resizing
                                  */ 
const $a5f47f4537efba60$export$7de9561ff806a5a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(84);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { minHeight: t2, maxHeight: maxHeight, topOffset: t3, bottomOffset: t4, leftOffset: t5, maxWidth: t6, minWidth: t7, greetingHeight: t8, greetingKey: t9, enableMiniModalResize: t10 } = t1;
    const minHeight = t2 === undefined ? 350 : t2;
    const topOffset = t3 === undefined ? 0 : t3;
    const bottomOffset = t4 === undefined ? $a5f47f4537efba60$var$HEIGHT_SAFETY_MARGIN : t4;
    const leftOffset = t5 === undefined ? 0 : t5;
    const maxWidth = t6 === undefined ? 800 : t6;
    const minWidth = t7 === undefined ? 400 : t7;
    const greetingHeight = t8 === undefined ? 0 : t8;
    const greetingKey = t9 === undefined ? "default" : t9;
    const enableMiniModalResize = t10 === undefined ? true : t10;
    let t11;
    bb0: {
        if (!enableMiniModalResize && (0, $cXtTj.default).checkGate("cc_ai_growth_welcome_from_rovo_gate")) {
            t11 = false;
            break bb0;
        }
        let t12;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = (0, $cXtTj.default).getExperimentValue("rovo_button_floating_modal_resize", "isEnabled", false) || (0, $cXtTj.default).checkGate("rovo_button_floating_modal_resize_extended") || (0, $cXtTj.default).getExperimentValue("cc-maui-experiment", "isEnabled", false);
            $[2] = t12;
        } else t12 = $[2];
        t11 = t12;
    }
    const enabled = t11;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [height, setHeight] = (0, $cozmU.useState)(null);
    const [width, setWidth] = (0, $cozmU.useState)(null);
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const [hasUserResized, setHasUserResized] = (0, $cozmU.useState)(false);
    const resizeModeRef = (0, $cozmU.useRef)(null);
    const prevGreetingKeyRef = (0, $cozmU.useRef)(greetingKey);
    const widthRef = (0, $cozmU.useRef)(null);
    const heightRef = (0, $cozmU.useRef)(null);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isDraggingRef = (0, $cozmU.useRef)(false);
    const hasMovedRef = (0, $cozmU.useRef)(false);
    let t12;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            x: 0,
            y: 0
        };
        $[3] = t12;
    } else t12 = $[3];
    const initialPositionRef = (0, $cozmU.useRef)(t12);
    const initialHeightRef = (0, $cozmU.useRef)(0);
    const initialWidthRef = (0, $cozmU.useRef)(0);
    const animationFrameRef = (0, $cozmU.useRef)(null);
    const defaultMinHeightRef = (0, $cozmU.useRef)(null);
    const topIndicatorRef = (0, $cozmU.useRef)(null);
    const leftIndicatorRef = (0, $cozmU.useRef)(null);
    let t13;
    if ($[4] !== bottomOffset || $[5] !== enabled || $[6] !== greetingHeight || $[7] !== leftOffset || $[8] !== maxHeight || $[9] !== maxWidth || $[10] !== minHeight || $[11] !== minWidth || $[12] !== topOffset) {
        t13 = {
            minHeight: minHeight,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minWidth: minWidth,
            topOffset: topOffset,
            bottomOffset: bottomOffset,
            leftOffset: leftOffset,
            enabled: enabled,
            greetingHeight: greetingHeight
        };
        $[4] = bottomOffset;
        $[5] = enabled;
        $[6] = greetingHeight;
        $[7] = leftOffset;
        $[8] = maxHeight;
        $[9] = maxWidth;
        $[10] = minHeight;
        $[11] = minWidth;
        $[12] = topOffset;
        $[13] = t13;
    } else t13 = $[13];
    const optionsRef = (0, $cozmU.useRef)(t13);
    let t14;
    let t15;
    if ($[14] !== bottomOffset || $[15] !== enabled || $[16] !== greetingHeight || $[17] !== leftOffset || $[18] !== maxHeight || $[19] !== maxWidth || $[20] !== minHeight || $[21] !== minWidth || $[22] !== topOffset) {
        t14 = ()=>{
            if (!enabled) return;
            optionsRef.current = {
                minHeight: minHeight,
                maxHeight: maxHeight,
                maxWidth: maxWidth,
                minWidth: minWidth,
                topOffset: topOffset,
                bottomOffset: bottomOffset,
                leftOffset: leftOffset,
                enabled: enabled,
                greetingHeight: greetingHeight
            };
        };
        t15 = [
            minHeight,
            maxHeight,
            maxWidth,
            minWidth,
            topOffset,
            bottomOffset,
            leftOffset,
            enabled,
            greetingHeight
        ];
        $[14] = bottomOffset;
        $[15] = enabled;
        $[16] = greetingHeight;
        $[17] = leftOffset;
        $[18] = maxHeight;
        $[19] = maxWidth;
        $[20] = minHeight;
        $[21] = minWidth;
        $[22] = topOffset;
        $[23] = t14;
        $[24] = t15;
    } else {
        t14 = $[23];
        t15 = $[24];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    let t17;
    if ($[25] !== enabled || $[26] !== greetingKey) {
        t16 = ()=>{
            if (!enabled) return;
            if (prevGreetingKeyRef.current !== greetingKey) {
                setHasUserResized(false);
                setHeight(null);
                defaultMinHeightRef.current = null;
            }
            prevGreetingKeyRef.current = greetingKey;
        };
        t17 = [
            enabled,
            greetingKey
        ];
        $[25] = enabled;
        $[26] = greetingKey;
        $[27] = t16;
        $[28] = t17;
    } else {
        t16 = $[27];
        t17 = $[28];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    let t19;
    if ($[29] !== width) {
        t18 = ()=>{
            widthRef.current = width;
        };
        t19 = [
            width
        ];
        $[29] = width;
        $[30] = t18;
        $[31] = t19;
    } else {
        t18 = $[30];
        t19 = $[31];
    }
    (0, $cozmU.useEffect)(t18, t19);
    let t20;
    let t21;
    if ($[32] !== height) {
        t20 = ()=>{
            heightRef.current = height;
        };
        t21 = [
            height
        ];
        $[32] = height;
        $[33] = t20;
        $[34] = t21;
    } else {
        t20 = $[33];
        t21 = $[34];
    }
    (0, $cozmU.useEffect)(t20, t21);
    let t22;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (indicator)=>{
            if (topIndicatorRef.current) topIndicatorRef.current.style.backgroundColor = indicator === "top" || indicator === "both" ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : "transparent";
            if (leftIndicatorRef.current) leftIndicatorRef.current.style.backgroundColor = indicator === "left" || indicator === "both" ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : "transparent";
        };
        $[35] = t22;
    } else t22 = $[35];
    const setIndicatorHover = t22;
    let t23;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = ()=>{
            if (!wrapperRef.current) return {
                height: 0,
                width: 0
            };
            const rect = wrapperRef.current.getBoundingClientRect();
            return {
                height: rect.height || 0,
                width: rect.width || 0
            };
        };
        $[36] = t23;
    } else t23 = $[36];
    const getWrapperDimensions = t23;
    let t24;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = ()=>{
            const { maxHeight: currentMaxHeight, topOffset: currentTopOffset, bottomOffset: currentBottomOffset } = optionsRef.current;
            if (currentMaxHeight !== undefined) return currentMaxHeight;
            return window.innerHeight - currentTopOffset - currentBottomOffset;
        };
        $[37] = t24;
    } else t24 = $[37];
    const calculateMaxHeight = t24;
    let t25;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = ()=>{
            const { maxWidth: currentMaxWidth, leftOffset: currentLeftOffset } = optionsRef.current;
            if (currentMaxWidth !== undefined) return currentMaxWidth;
            return window.innerWidth - currentLeftOffset - $a5f47f4537efba60$var$WIDTH_SAFETY_MARGIN;
        };
        $[38] = t25;
    } else t25 = $[38];
    const calculateMaxWidth = t25;
    let t26;
    if ($[39] !== sendAnalyticsEvent) {
        t26 = ()=>{
            sendAnalyticsEvent({
                action: "resized",
                actionSubject: "miniModal",
                actionSubjectId: "aiMatePanel",
                eventType: "ui",
                attributes: {
                    mode: resizeModeRef.current
                }
            });
        };
        $[39] = sendAnalyticsEvent;
        $[40] = t26;
    } else t26 = $[40];
    const fireOnEndResizeAnalyticsEvent = t26;
    let t27;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = (currentX, currentY)=>{
            if (!isDraggingRef.current || !optionsRef.current.enabled || !resizeModeRef.current) return;
            const deltaX = currentX - initialPositionRef.current.x;
            const deltaY = currentY - initialPositionRef.current.y;
            if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
            animationFrameRef.current = requestAnimationFrame(()=>{
                hasMovedRef.current = true;
                if (!isDraggingRef.current || !resizeModeRef.current) return;
                const calculatedMaxHeight = calculateMaxHeight();
                const calculatedMaxWidth = calculateMaxWidth();
                const { minHeight: currentMinHeight, minWidth: currentMinWidth } = optionsRef.current;
                if (resizeModeRef.current === "vertical" || resizeModeRef.current === "corner") {
                    const updatedHeight = initialHeightRef.current - deltaY;
                    const clampedHeight = Math.max(Math.max(defaultMinHeightRef.current ?? 0, currentMinHeight), Math.min(calculatedMaxHeight, updatedHeight));
                    setHeight(clampedHeight);
                }
                if (resizeModeRef.current === "horizontal" || resizeModeRef.current === "corner") {
                    const updatedWidth = initialWidthRef.current - deltaX;
                    const clampedWidth = Math.max(currentMinWidth, Math.min(calculatedMaxWidth, updatedWidth));
                    setWidth(clampedWidth);
                }
            });
        };
        $[41] = t27;
    } else t27 = $[41];
    const handleMove = t27;
    let t28;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = (event)=>{
            handleMove(event.clientX, event.clientY);
        };
        $[42] = t28;
    } else t28 = $[42];
    const handlePointerMove = t28;
    let t29;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = (startX, startY, mode)=>{
            if (!optionsRef.current.enabled || !wrapperRef.current) return;
            isDraggingRef.current = true;
            setIsResizing(true);
            setHasUserResized(true);
            resizeModeRef.current = mode;
            initialPositionRef.current = {
                x: startX,
                y: startY
            };
            const dimensions = getWrapperDimensions();
            initialHeightRef.current = dimensions.height;
            initialWidthRef.current = dimensions.width;
            if (defaultMinHeightRef.current === null && dimensions.height > 0) defaultMinHeightRef.current = dimensions.height - (optionsRef.current.greetingHeight ?? 0);
            const indicatorMap = {
                vertical: "top",
                horizontal: "left",
                corner: "both"
            };
            setIndicatorHover(indicatorMap[mode]);
        };
        $[43] = t29;
    } else t29 = $[43];
    const startResize = t29;
    let t30;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = (event_0)=>{
            if (!optionsRef.current.enabled) return;
            event_0.preventDefault();
            event_0.currentTarget.setPointerCapture(event_0.pointerId);
            startResize(event_0.clientX, event_0.clientY, "vertical");
        };
        $[44] = t30;
    } else t30 = $[44];
    const handleTopPointerDown = t30;
    let t31;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = (event_1)=>{
            if (!optionsRef.current.enabled) return;
            event_1.preventDefault();
            event_1.currentTarget.setPointerCapture(event_1.pointerId);
            startResize(event_1.clientX, event_1.clientY, "horizontal");
        };
        $[45] = t31;
    } else t31 = $[45];
    const handleLeftPointerDown = t31;
    let t32;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = (event_2)=>{
            if (!optionsRef.current.enabled) return;
            event_2.preventDefault();
            event_2.currentTarget.setPointerCapture(event_2.pointerId);
            startResize(event_2.clientX, event_2.clientY, "corner");
        };
        $[46] = t32;
    } else t32 = $[46];
    const handleCornerPointerDown = t32;
    let t33;
    if ($[47] !== fireOnEndResizeAnalyticsEvent) {
        t33 = ()=>{
            if (!isDraggingRef.current) return;
            if (hasMovedRef.current) fireOnEndResizeAnalyticsEvent();
            isDraggingRef.current = false;
            hasMovedRef.current = false;
            setIsResizing(false);
            resizeModeRef.current = null;
            setIndicatorHover(null);
        };
        $[47] = fireOnEndResizeAnalyticsEvent;
        $[48] = t33;
    } else t33 = $[48];
    const handleEnd = t33;
    let t34;
    if ($[49] !== handleEnd) {
        t34 = ()=>{
            handleEnd();
        };
        $[49] = handleEnd;
        $[50] = t34;
    } else t34 = $[50];
    const handlePointerUp = t34;
    let t35;
    if ($[51] !== isResizing) {
        t35 = ()=>{
            if (!isResizing) setIndicatorHover(null);
        };
        $[51] = isResizing;
        $[52] = t35;
    } else t35 = $[52];
    const handlePointerLeaveIfNotResizing = t35;
    let t36;
    let t37;
    if ($[53] !== enabled) {
        t36 = ()=>{
            if (!enabled) return;
            return ()=>{
                if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
            };
        };
        t37 = [
            enabled
        ];
        $[53] = enabled;
        $[54] = t36;
        $[55] = t37;
    } else {
        t36 = $[54];
        t37 = $[55];
    }
    (0, $cozmU.useEffect)(t36, t37);
    let t38;
    let t39;
    if ($[56] !== enabled || $[57] !== handlePointerUp || $[58] !== isResizing) {
        t38 = ()=>{
            if (!enabled || !isResizing) return;
            const pointerMoveHandler = (0, $cbY7C.bind)(window, {
                type: "pointermove",
                listener: handlePointerMove,
                options: {
                    passive: true
                }
            });
            const pointerUpHandler = (0, $cbY7C.bind)(window, {
                type: "pointerup",
                listener: handlePointerUp,
                options: {
                    passive: true
                }
            });
            const pointerCancelHandler = (0, $cbY7C.bind)(window, {
                type: "pointercancel",
                listener: handlePointerUp,
                options: {
                    passive: true
                }
            });
            return ()=>{
                pointerMoveHandler();
                pointerUpHandler();
                pointerCancelHandler();
                if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
            };
        };
        t39 = [
            handlePointerMove,
            handlePointerUp,
            enabled,
            isResizing
        ];
        $[56] = enabled;
        $[57] = handlePointerUp;
        $[58] = isResizing;
        $[59] = t38;
        $[60] = t39;
    } else {
        t38 = $[59];
        t39 = $[60];
    }
    (0, $cozmU.useEffect)(t38, t39);
    let t40;
    bb1: {
        if (!enabled) {
            t40 = undefined;
            break bb1;
        }
        let t41;
        if ($[61] !== height || $[62] !== width) {
            const styles = {};
            if (height !== null) styles.height = `${height}px`;
            if (width !== null) styles.width = `${width}px`;
            t41 = Object.keys(styles).length > 0 ? styles : undefined;
            $[61] = height;
            $[62] = width;
            $[63] = t41;
        } else t41 = $[63];
        t40 = t41;
    }
    const wrapperStyle = t40;
    let t41;
    if ($[64] !== handlePointerLeaveIfNotResizing || $[65] !== isResizing) {
        t41 = ()=>{
            const isVerticalResizing = isResizing && resizeModeRef.current === "vertical";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                onPointerDown: handleTopPointerDown,
                onPointerEnter: ()=>setIndicatorHover("top"),
                onPointerLeave: handlePointerLeaveIfNotResizing,
                testId: "resize-handle-top",
                "data-dragging": isVerticalResizing ? "true" : undefined,
                xcss: $a5f47f4537efba60$var$resizeHandleStyles.topResizeHandle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: topIndicatorRef,
                xcss: $a5f47f4537efba60$var$resizeHandleStyles.topResizeIndicator
            }));
        };
        $[64] = handlePointerLeaveIfNotResizing;
        $[65] = isResizing;
        $[66] = t41;
    } else t41 = $[66];
    const TopResizeHandler = t41;
    let t42;
    if ($[67] !== handlePointerLeaveIfNotResizing || $[68] !== isResizing) {
        t42 = ()=>{
            const isHorizontalResizing = isResizing && resizeModeRef.current === "horizontal";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                onPointerDown: handleLeftPointerDown,
                onPointerEnter: ()=>setIndicatorHover("left"),
                onPointerLeave: handlePointerLeaveIfNotResizing,
                testId: "resize-handle-left",
                "data-dragging": isHorizontalResizing ? "true" : undefined,
                xcss: $a5f47f4537efba60$var$resizeHandleStyles.leftResizeHandle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: leftIndicatorRef,
                xcss: $a5f47f4537efba60$var$resizeHandleStyles.leftResizeIndicator
            }));
        };
        $[67] = handlePointerLeaveIfNotResizing;
        $[68] = isResizing;
        $[69] = t42;
    } else t42 = $[69];
    const LeftResizeHandler = t42;
    let t43;
    if ($[70] !== handlePointerLeaveIfNotResizing || $[71] !== isResizing) {
        t43 = ()=>{
            const isCornerResizing = isResizing && resizeModeRef.current === "corner";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                onPointerDown: handleCornerPointerDown,
                onPointerEnter: ()=>setIndicatorHover("both"),
                onPointerLeave: handlePointerLeaveIfNotResizing,
                testId: "resize-handle-corner",
                "data-dragging": isCornerResizing ? "true" : undefined,
                xcss: $a5f47f4537efba60$var$resizeHandleStyles.cornerResizeHandle
            });
        };
        $[70] = handlePointerLeaveIfNotResizing;
        $[71] = isResizing;
        $[72] = t43;
    } else t43 = $[72];
    const CornerResizeHandler = t43;
    let t44;
    if ($[73] !== CornerResizeHandler || $[74] !== LeftResizeHandler || $[75] !== TopResizeHandler || $[76] !== enabled) {
        t44 = ()=>{
            if (!enabled) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TopResizeHandler, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LeftResizeHandler, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CornerResizeHandler, null));
        };
        $[73] = CornerResizeHandler;
        $[74] = LeftResizeHandler;
        $[75] = TopResizeHandler;
        $[76] = enabled;
        $[77] = t44;
    } else t44 = $[77];
    const ResizeHandlers = t44;
    const isResizeHeaderThresholdReached = !enabled || !hasUserResized ? null : height !== null && height >= $a5f47f4537efba60$var$GREETING_HEADER_HEIGHT_THRESHOLD;
    let t45;
    if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
        t45 = (t46)=>{
            const { targetWidth: targetWidth, targetHeight: targetHeight, source: source, dryRun: t47 } = t46;
            const dryRun = t47 === undefined ? false : t47;
            const currentStateWidth = widthRef.current;
            const currentStateHeight = heightRef.current;
            const measured = getWrapperDimensions();
            const fallbackWidth = measured.width > 0 ? measured.width : 0;
            const fallbackHeight = measured.height > 0 ? measured.height : 0;
            const noOp = ()=>({
                    appliedWidth: currentStateWidth ?? fallbackWidth,
                    appliedHeight: currentStateHeight ?? fallbackHeight,
                    previousWidth: currentStateWidth,
                    previousHeight: currentStateHeight,
                    widthGrew: false,
                    heightGrew: false,
                    widthClampedByViewport: false,
                    heightClampedByViewport: false,
                    didChange: false,
                    source: source
                });
            if (!optionsRef.current.enabled) return noOp();
            const currentWidth = currentStateWidth ?? (measured.width > 0 ? measured.width : null);
            const currentHeight = currentStateHeight ?? (measured.height > 0 ? measured.height : null);
            const { minWidth: currentMinWidth_0, minHeight: currentMinHeight_0 } = optionsRef.current;
            const calculatedMaxWidth_0 = calculateMaxWidth();
            const calculatedMaxHeight_0 = calculateMaxHeight();
            const desiredWidth = Math.max(currentWidth ?? 0, targetWidth, currentMinWidth_0);
            const desiredHeight = Math.max(currentHeight ?? 0, targetHeight, currentMinHeight_0);
            const safeMaxWidth = currentWidth !== null ? Math.max(currentWidth, calculatedMaxWidth_0) : calculatedMaxWidth_0;
            const safeMaxHeight = currentHeight !== null ? Math.max(currentHeight, calculatedMaxHeight_0) : calculatedMaxHeight_0;
            const appliedWidth = Math.min(safeMaxWidth, desiredWidth);
            const appliedHeight = Math.min(safeMaxHeight, desiredHeight);
            const effectiveCurrentWidth = currentWidth === null ? null : Math.max(currentWidth, currentMinWidth_0);
            const effectiveCurrentHeight = currentHeight === null ? null : Math.max(currentHeight, currentMinHeight_0);
            const widthGrew = effectiveCurrentWidth === null ? appliedWidth > 0 : appliedWidth > effectiveCurrentWidth;
            const heightGrew = effectiveCurrentHeight === null ? appliedHeight > 0 : appliedHeight > effectiveCurrentHeight;
            if (dryRun) return {
                appliedWidth: appliedWidth,
                appliedHeight: appliedHeight,
                previousWidth: currentWidth,
                previousHeight: currentHeight,
                widthGrew: widthGrew,
                heightGrew: heightGrew,
                widthClampedByViewport: targetWidth > calculatedMaxWidth_0,
                heightClampedByViewport: targetHeight > calculatedMaxHeight_0,
                didChange: widthGrew || heightGrew,
                source: source
            };
            if (widthGrew) {
                setWidth(appliedWidth);
                widthRef.current = appliedWidth;
            }
            if (heightGrew) {
                setHeight(appliedHeight);
                heightRef.current = appliedHeight;
                if (defaultMinHeightRef.current === null && currentHeight !== null) defaultMinHeightRef.current = currentHeight - (optionsRef.current.greetingHeight ?? 0);
            }
            if (widthGrew || heightGrew) setHasUserResized(true);
            return {
                appliedWidth: appliedWidth,
                appliedHeight: appliedHeight,
                previousWidth: currentWidth,
                previousHeight: currentHeight,
                widthGrew: widthGrew,
                heightGrew: heightGrew,
                widthClampedByViewport: targetWidth > calculatedMaxWidth_0,
                heightClampedByViewport: targetHeight > calculatedMaxHeight_0,
                didChange: widthGrew || heightGrew,
                source: source
            };
        };
        $[78] = t45;
    } else t45 = $[78];
    const setSize = t45;
    let t46;
    if ($[79] !== ResizeHandlers || $[80] !== enabled || $[81] !== isResizeHeaderThresholdReached || $[82] !== wrapperStyle) {
        t46 = {
            wrapperRef: wrapperRef,
            wrapperStyle: wrapperStyle,
            ResizeHandlers: ResizeHandlers,
            isResizeEnabled: enabled,
            isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
            setSize: setSize
        };
        $[79] = ResizeHandlers;
        $[80] = enabled;
        $[81] = isResizeHeaderThresholdReached;
        $[82] = wrapperStyle;
        $[83] = t46;
    } else t46 = $[83];
    return t46;
} : ({ minHeight: minHeight = 350, maxHeight: maxHeight, topOffset: topOffset = 0, bottomOffset: bottomOffset = $a5f47f4537efba60$var$HEIGHT_SAFETY_MARGIN, leftOffset: leftOffset = 0, maxWidth: maxWidth = 800, minWidth: minWidth = 400, greetingHeight: greetingHeight = 0, greetingKey: greetingKey = 'default', enableMiniModalResize: enableMiniModalResize = true } = {})=>{
    // Only evaluate experiment when in mini modal mode to prevent over-exposures
    const enabled = (0, $cozmU.useMemo)(()=>{
        if (!enableMiniModalResize && (0, $cXtTj.default).checkGate('cc_ai_growth_welcome_from_rovo_gate')) return false;
        return (0, $cXtTj.default).getExperimentValue('rovo_button_floating_modal_resize', 'isEnabled', false) || (0, $cXtTj.default).checkGate('rovo_button_floating_modal_resize_extended') || (0, $cXtTj.default).getExperimentValue('cc-maui-experiment', 'isEnabled', false);
    }, [
        enableMiniModalResize
    ]);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [height, setHeight] = (0, $cozmU.useState)(null);
    const [width, setWidth] = (0, $cozmU.useState)(null);
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const [hasUserResized, setHasUserResized] = (0, $cozmU.useState)(false);
    const resizeModeRef = (0, $cozmU.useRef)(null);
    const prevGreetingKeyRef = (0, $cozmU.useRef)(greetingKey); // Mirror width/height state into refs so `setSize` (and any other callback)
    // can read the current dimensions without taking them as deps. This keeps
    // `setSize`'s identity stable for the lifetime of the hook, preventing
    // infinite render loops in consumers that follow the documented
    // `useEffect(() => { setSize(...); }, [setSize])` pattern.
    const widthRef = (0, $cozmU.useRef)(null);
    const heightRef = (0, $cozmU.useRef)(null);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isDraggingRef = (0, $cozmU.useRef)(false);
    const hasMovedRef = (0, $cozmU.useRef)(false);
    const initialPositionRef = (0, $cozmU.useRef)({
        x: 0,
        y: 0
    });
    const initialHeightRef = (0, $cozmU.useRef)(0);
    const initialWidthRef = (0, $cozmU.useRef)(0);
    const animationFrameRef = (0, $cozmU.useRef)(null);
    const defaultMinHeightRef = (0, $cozmU.useRef)(null);
    const topIndicatorRef = (0, $cozmU.useRef)(null);
    const leftIndicatorRef = (0, $cozmU.useRef)(null);
    const optionsRef = (0, $cozmU.useRef)({
        minHeight: minHeight,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minWidth: minWidth,
        topOffset: topOffset,
        bottomOffset: bottomOffset,
        leftOffset: leftOffset,
        enabled: enabled,
        greetingHeight: greetingHeight
    }); /**
       * Keep options ref up to date for use in callbacks.
       * This ensures that callbacks always have access to the latest option values
       * without needing to include them in dependency arrays.
       */ 
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        optionsRef.current = {
            minHeight: minHeight,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minWidth: minWidth,
            topOffset: topOffset,
            bottomOffset: bottomOffset,
            leftOffset: leftOffset,
            enabled: enabled,
            greetingHeight: greetingHeight
        };
    }, [
        minHeight,
        maxHeight,
        maxWidth,
        minWidth,
        topOffset,
        bottomOffset,
        leftOffset,
        enabled,
        greetingHeight
    ]); /**
                                                                                                                 * Reset resize state when greeting context changes.
                                                                                                                 * This ensures greeting can use its default visibility when switching between contexts.
                                                                                                                 * We reset hasUserResized, height, and defaultMinHeightRef so the user starts fresh.
                                                                                                                 */ 
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        if (prevGreetingKeyRef.current !== greetingKey) {
            setHasUserResized(false);
            setHeight(null);
            defaultMinHeightRef.current = null;
        }
        prevGreetingKeyRef.current = greetingKey;
    }, [
        enabled,
        greetingKey
    ]); // Keep width/height refs in sync with state so `setSize` can read the
    // current dimensions without depending on them (see ref declarations
    // above for why we mirror).
    (0, $cozmU.useEffect)(()=>{
        widthRef.current = width;
    }, [
        width
    ]);
    (0, $cozmU.useEffect)(()=>{
        heightRef.current = height;
    }, [
        height
    ]); /**
                 * Helper to set hover state on indicators without causing React re-renders.
                 * Directly manipulates the DOM to apply hover styles.
                 */ 
    const setIndicatorHover = (0, $cozmU.useCallback)((indicator)=>{
        const hoverColor = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
        if (topIndicatorRef.current) topIndicatorRef.current.style.backgroundColor = indicator === 'top' || indicator === 'both' ? hoverColor : 'transparent';
        if (leftIndicatorRef.current) leftIndicatorRef.current.style.backgroundColor = indicator === 'left' || indicator === 'both' ? hoverColor : 'transparent';
    }, []); /**
           * Gets the current dimensions of the wrapper element.
           * Returns zero dimensions if the wrapper ref is not available.
           *
           * @returns Object containing height and width in pixels
           */ 
    const getWrapperDimensions = (0, $cozmU.useCallback)(()=>{
        if (!wrapperRef.current) return {
            height: 0,
            width: 0
        };
        const rect = wrapperRef.current.getBoundingClientRect();
        return {
            height: rect.height || 0,
            width: rect.width || 0
        };
    }, []); /**
           * Calculates the maximum height allowed for resizing.
           * Uses the provided maxHeight option if available, otherwise calculates
           * based on viewport height minus top offset and a safety margin.
           *
           * @returns Maximum height in pixels
           */ 
    const calculateMaxHeight = (0, $cozmU.useCallback)(()=>{
        const { maxHeight: currentMaxHeight, topOffset: currentTopOffset, bottomOffset: currentBottomOffset } = optionsRef.current;
        if (currentMaxHeight !== undefined) return currentMaxHeight;
        return window.innerHeight - currentTopOffset - currentBottomOffset;
    }, []); /**
           * Calculates the maximum width allowed for resizing.
           * Uses the provided maxWidth option if available, otherwise calculates
           * based on viewport width minus left offset and a safety margin.
           *
           * @returns Maximum width in pixels
           */ 
    const calculateMaxWidth = (0, $cozmU.useCallback)(()=>{
        const { maxWidth: currentMaxWidth, leftOffset: currentLeftOffset } = optionsRef.current;
        if (currentMaxWidth !== undefined) return currentMaxWidth;
        return window.innerWidth - currentLeftOffset - $a5f47f4537efba60$var$WIDTH_SAFETY_MARGIN;
    }, []); /**
           * Fires an analytics event when the resize operation is released.
           */ 
    const fireOnEndResizeAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'resized',
            actionSubject: 'miniModal',
            actionSubjectId: 'aiMatePanel',
            eventType: 'ui',
            attributes: {
                mode: resizeModeRef.current
            }
        });
    }, [
        sendAnalyticsEvent
    ]); /**
                             * Handles pointer movement during resize operation.
                             * Calculates the new dimensions based on the movement delta and applies
                             * min/max constraints. Uses requestAnimationFrame for smooth updates.
                             *
                             * @param currentX - Current X coordinate of the pointer
                             * @param currentY - Current Y coordinate of the pointer
                             */ 
    const handleMove = (0, $cozmU.useCallback)((currentX, currentY)=>{
        if (!isDraggingRef.current || !optionsRef.current.enabled || !resizeModeRef.current) return;
        const deltaX = currentX - initialPositionRef.current.x;
        const deltaY = currentY - initialPositionRef.current.y; // Clear queued animation frame
        if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = requestAnimationFrame(()=>{
            hasMovedRef.current = true;
            if (!isDraggingRef.current || !resizeModeRef.current) return;
            const calculatedMaxHeight = calculateMaxHeight();
            const calculatedMaxWidth = calculateMaxWidth();
            const { minHeight: currentMinHeight, minWidth: currentMinWidth } = optionsRef.current;
            if (resizeModeRef.current === 'vertical' || resizeModeRef.current === 'corner') {
                // When dragging down (positive distance), decreases height
                // When dragging up (negative distance), increases height
                const updatedHeight = initialHeightRef.current - deltaY;
                const clampedHeight = Math.max(Math.max(defaultMinHeightRef.current ?? 0, currentMinHeight), Math.min(calculatedMaxHeight, updatedHeight));
                setHeight(clampedHeight);
            }
            if (resizeModeRef.current === 'horizontal' || resizeModeRef.current === 'corner') {
                // When dragging left (negative distance), increases width
                // When dragging right (positive distance), decreases width
                const updatedWidth = initialWidthRef.current - deltaX;
                const clampedWidth = Math.max(currentMinWidth, Math.min(calculatedMaxWidth, updatedWidth));
                setWidth(clampedWidth);
            }
        });
    }, [
        calculateMaxHeight,
        calculateMaxWidth
    ]); /**
                                                * Wrapper for pointer move events. Required because the window bind() listener
                                                * needs a typed PointerEvent parameter; delegates to the generic handleMove.
                                                */ 
    const handlePointerMove = (0, $cozmU.useCallback)((event)=>{
        handleMove(event.clientX, event.clientY);
    }, [
        handleMove
    ]); /**
                     * Initializes a resize operation by storing the starting position and dimensions.
                     * Sets up the resize mode and marks the operation as active.
                     *
                     * @param startX - Initial X coordinate of the pointer
                     * @param startY - Initial Y coordinate of the pointer
                     * @param mode - Resize mode: 'vertical', 'horizontal', or 'corner'
                     */ 
    const startResize = (0, $cozmU.useCallback)((startX, startY, mode)=>{
        if (!optionsRef.current.enabled || !wrapperRef.current) return;
        isDraggingRef.current = true;
        setIsResizing(true);
        setHasUserResized(true);
        resizeModeRef.current = mode;
        initialPositionRef.current = {
            x: startX,
            y: startY
        };
        const dimensions = getWrapperDimensions();
        initialHeightRef.current = dimensions.height;
        initialWidthRef.current = dimensions.width; // Capture default min height, subtracting greetingHeight for collapsible content.
        // This allows users to resize below the initial height to collapse the greeting.
        if (defaultMinHeightRef.current === null && dimensions.height > 0) defaultMinHeightRef.current = dimensions.height - (optionsRef.current.greetingHeight ?? 0);
         // Keep indicators visible during drag
        const indicatorMap = {
            vertical: 'top',
            horizontal: 'left',
            corner: 'both'
        };
        setIndicatorHover(indicatorMap[mode]);
    }, [
        getWrapperDimensions,
        setIndicatorHover
    ]); /**
                                                  * Handles pointer down event on the top resize handle.
                                                  * Initiates vertical resizing from the top border.
                                                  * Uses setPointerCapture to ensure all subsequent pointer events are routed
                                                  * to this element, preventing conflicts with underlying surfaces (e.g., whiteboards).
                                                  *
                                                  * @param event - Pointer down event
                                                  */ 
    const handleTopPointerDown = (0, $cozmU.useCallback)((event_0)=>{
        if (!optionsRef.current.enabled) return;
        event_0.preventDefault();
        event_0.currentTarget.setPointerCapture(event_0.pointerId);
        startResize(event_0.clientX, event_0.clientY, 'vertical');
    }, [
        startResize
    ]); /**
                      * Handles pointer down event on the left resize handle.
                      * Initiates horizontal resizing from the left border.
                      *
                      * @param event - Pointer down event
                      */ 
    const handleLeftPointerDown = (0, $cozmU.useCallback)((event_1)=>{
        if (!optionsRef.current.enabled) return;
        event_1.preventDefault();
        event_1.currentTarget.setPointerCapture(event_1.pointerId);
        startResize(event_1.clientX, event_1.clientY, 'horizontal');
    }, [
        startResize
    ]); /**
                      * Handles pointer down event on the corner resize handle.
                      * Initiates resizing of both dimensions simultaneously from the top-left corner.
                      *
                      * @param event - Pointer down event
                      */ 
    const handleCornerPointerDown = (0, $cozmU.useCallback)((event_2)=>{
        if (!optionsRef.current.enabled) return;
        event_2.preventDefault();
        event_2.currentTarget.setPointerCapture(event_2.pointerId);
        startResize(event_2.clientX, event_2.clientY, 'corner');
    }, [
        startResize
    ]); /**
                      * Ends the resize operation by resetting all resize-related state.
                      * Called when the user releases the pointer or the browser cancels the gesture.
                      *
                      * Guards against:
                      * - Double-fire: pointerup and pointercancel can both fire in some browser/tablet scenarios.
                      *   The isDraggingRef check ensures cleanup runs only once.
                      * - Zero-movement false positives: analytics only fire if actual movement occurred (hasMovedRef).
                      */ 
    const handleEnd = (0, $cozmU.useCallback)(()=>{
        if (!isDraggingRef.current) return; // already cleaned up — prevents double-fire on pointerup + pointercancel
        if (hasMovedRef.current) fireOnEndResizeAnalyticsEvent(); // only fire if actual movement occurred
        isDraggingRef.current = false;
        hasMovedRef.current = false; // reset for next drag
        setIsResizing(false);
        resizeModeRef.current = null; // Clear hover indicators when drag ends
        setIndicatorHover(null);
    }, [
        fireOnEndResizeAnalyticsEvent,
        setIndicatorHover
    ]); /**
                                                           * Wrapper for pointer up events that delegates to handleEnd.
                                                           */ 
    const handlePointerUp = (0, $cozmU.useCallback)(()=>{
        handleEnd();
    }, [
        handleEnd
    ]); /**
                    * Shared handler for pointer leave events on resize handles.
                    * Only clears hover state if not actively resizing.
                    */ 
    const handlePointerLeaveIfNotResizing = (0, $cozmU.useCallback)(()=>{
        if (!isResizing) setIndicatorHover(null);
    }, [
        isResizing,
        setIndicatorHover
    ]); /**
                                        * Cleanup effect that cancels any pending animation frames on unmount.
                                        * Prevents memory leaks and ensures no updates occur after component unmounts.
                                        */ 
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        return ()=>{
            if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
        };
    }, [
        enabled
    ]); /**
                  * Binds pointer event handlers to the window when actively resizing.
                  * This allows resizing to continue even when the pointer moves outside the component.
                  * Includes pointercancel handler to clean up when the browser takes over the gesture
                  * (e.g., scrolling on tablet). Handlers are automatically cleaned up when resizing
                  * ends or component unmounts.
                  */ 
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !isResizing) return;
        const pointerMoveHandler = (0, $cbY7C.bind)(window, {
            type: 'pointermove',
            listener: handlePointerMove,
            options: {
                passive: true
            }
        });
        const pointerUpHandler = (0, $cbY7C.bind)(window, {
            type: 'pointerup',
            listener: handlePointerUp,
            options: {
                passive: true
            }
        });
        const pointerCancelHandler = (0, $cbY7C.bind)(window, {
            type: 'pointercancel',
            listener: handlePointerUp,
            options: {
                passive: true
            }
        });
        return ()=>{
            pointerMoveHandler();
            pointerUpHandler();
            pointerCancelHandler();
            if (animationFrameRef.current !== null) cancelAnimationFrame(animationFrameRef.current);
        };
    }, [
        handlePointerMove,
        handlePointerUp,
        enabled,
        isResizing
    ]); /**
                                                                  * Computes the wrapper style object based on current resize dimensions.
                                                                  * Returns undefined if resizing is disabled or no dimensions have been set.
                                                                  * Only includes height/width properties that have been explicitly set.
                                                                  *
                                                                  * @returns Style object with height and/or width, or undefined
                                                                  */ 
    const wrapperStyle = (0, $cozmU.useMemo)(()=>{
        if (!enabled) return undefined;
        const styles = {};
        if (height !== null) styles.height = `${height}px`;
        if (width !== null) styles.width = `${width}px`;
        return Object.keys(styles).length > 0 ? styles : undefined;
    }, [
        enabled,
        height,
        width
    ]); /**
                                 * React component for the top resize handle.
                                 * Renders a horizontal bar at the top of the container for vertical resizing.
                                 * Uses direct DOM manipulation for hover states to avoid re-renders.
                                 *
                                 * @returns Box component configured for top border resizing
                                 */ 
    const TopResizeHandler = (0, $cozmU.useCallback)(()=>{
        const isVerticalResizing = isResizing && resizeModeRef.current === 'vertical';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onPointerDown: handleTopPointerDown,
            onPointerEnter: ()=>setIndicatorHover('top'),
            onPointerLeave: handlePointerLeaveIfNotResizing,
            testId: "resize-handle-top",
            "data-dragging": isVerticalResizing ? 'true' : undefined,
            xcss: $a5f47f4537efba60$var$resizeHandleStyles.topResizeHandle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: topIndicatorRef,
            xcss: $a5f47f4537efba60$var$resizeHandleStyles.topResizeIndicator
        }));
    }, [
        handleTopPointerDown,
        handlePointerLeaveIfNotResizing,
        isResizing,
        setIndicatorHover
    ]); /**
                                                                                               * React component for the left resize handle.
                                                                                               * Renders a vertical bar on the left side of the container for horizontal resizing.
                                                                                               * Uses direct DOM manipulation for hover states to avoid re-renders.
                                                                                               *
                                                                                               * @returns Box component configured for left border resizing
                                                                                               */ 
    const LeftResizeHandler = (0, $cozmU.useCallback)(()=>{
        const isHorizontalResizing = isResizing && resizeModeRef.current === 'horizontal';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onPointerDown: handleLeftPointerDown,
            onPointerEnter: ()=>setIndicatorHover('left'),
            onPointerLeave: handlePointerLeaveIfNotResizing,
            testId: "resize-handle-left",
            "data-dragging": isHorizontalResizing ? 'true' : undefined,
            xcss: $a5f47f4537efba60$var$resizeHandleStyles.leftResizeHandle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: leftIndicatorRef,
            xcss: $a5f47f4537efba60$var$resizeHandleStyles.leftResizeIndicator
        }));
    }, [
        handleLeftPointerDown,
        handlePointerLeaveIfNotResizing,
        isResizing,
        setIndicatorHover
    ]); /**
                                                                                                * React component for the corner resize handle.
                                                                                                * Renders a small square at the top-left corner for resizing both dimensions simultaneously.
                                                                                                * When hovering over corner, both top and left indicators show hover state via direct DOM manipulation.
                                                                                                *
                                                                                                * @returns Box component configured for corner resizing
                                                                                                */ 
    const CornerResizeHandler = (0, $cozmU.useCallback)(()=>{
        const isCornerResizing = isResizing && resizeModeRef.current === 'corner';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onPointerDown: handleCornerPointerDown,
            onPointerEnter: ()=>setIndicatorHover('both'),
            onPointerLeave: handlePointerLeaveIfNotResizing,
            testId: "resize-handle-corner",
            "data-dragging": isCornerResizing ? 'true' : undefined,
            xcss: $a5f47f4537efba60$var$resizeHandleStyles.cornerResizeHandle
        });
    }, [
        handleCornerPointerDown,
        handlePointerLeaveIfNotResizing,
        isResizing,
        setIndicatorHover
    ]); /**
                                                                                                  * React component that renders all resize handlers (top, left, and corner).
                                                                                                  * This component should be rendered as the **last child** of the element being resized
                                                                                                  * to ensure handlers appear on top via natural DOM paint order without z-index.
                                                                                                  * Uses direct DOM manipulation for hover effects to prevent component re-renders.
                                                                                                  *
                                                                                                  * @returns Fragment containing all resize handler components
                                                                                                  */ 
    const ResizeHandlers = (0, $cozmU.useCallback)(()=>{
        if (!enabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TopResizeHandler, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LeftResizeHandler, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CornerResizeHandler, null));
    }, [
        enabled,
        TopResizeHandler,
        LeftResizeHandler,
        CornerResizeHandler
    ]); // Greeting visibility: null = not yet resized (use default), true/false = above/below threshold
    const isResizeHeaderThresholdReached = !enabled || !hasUserResized ? null : height !== null && height >= $a5f47f4537efba60$var$GREETING_HEADER_HEIGHT_THRESHOLD; /**
                                                                                                                                                              * Programmatically resize the wrapper toward the requested target dimensions.
                                                                                                                                                              *
                                                                                                                                                              * Implementation notes:
                                                                                                                                                              * - The hook tracks `width` / `height` as `null` until the user has manually
                                                                                                                                                              *   resized at least once (or the modal has been auto-resized once). When
                                                                                                                                                              *   either is `null`, fall back to the measured wrapper dimensions so the
                                                                                                                                                              *   per-axis don't-shrink rule still works on the very first call (e.g.
                                                                                                                                                              *   when auto-expand fires on a freshly-mounted modal).
                                                                                                                                                              * - Width / height state is only updated on axes that actually grew, so the
                                                                                                                                                              *   no-op case (caller-requested target is already met or exceeded on both
                                                                                                                                                              *   axes) does not dirty React state and does not flip `hasUserResized`.
                                                                                                                                                              */ 
    const setSize = (0, $cozmU.useCallback)(({ targetWidth: targetWidth, targetHeight: targetHeight, source: source, dryRun: dryRun = false })=>{
        // Read width/height through refs (not state) so `setSize` keeps a
        // stable identity for the lifetime of the hook (see widthRef /
        // heightRef declarations for context).
        const currentStateWidth = widthRef.current;
        const currentStateHeight = heightRef.current; // Measure the wrapper once — used both as a fallback when state is
        // null and as the source of truth for the disabled `noOp` return so
        // analytics callers see a meaningful currently-rendered size rather
        // than 0x0 (PR feedback: fix #4).
        const measured = getWrapperDimensions();
        const fallbackWidth = measured.width > 0 ? measured.width : 0;
        const fallbackHeight = measured.height > 0 ? measured.height : 0;
        const noOp = ()=>({
                appliedWidth: currentStateWidth ?? fallbackWidth,
                appliedHeight: currentStateHeight ?? fallbackHeight,
                previousWidth: currentStateWidth,
                previousHeight: currentStateHeight,
                widthGrew: false,
                heightGrew: false,
                widthClampedByViewport: false,
                heightClampedByViewport: false,
                didChange: false,
                source: source
            });
        if (!optionsRef.current.enabled) return noOp();
         // Resolve current dimensions: prefer state, fall back to measured wrapper.
        const currentWidth = currentStateWidth ?? (measured.width > 0 ? measured.width : null);
        const currentHeight = currentStateHeight ?? (measured.height > 0 ? measured.height : null);
        const { minWidth: currentMinWidth_0, minHeight: currentMinHeight_0 } = optionsRef.current;
        const calculatedMaxWidth_0 = calculateMaxWidth();
        const calculatedMaxHeight_0 = calculateMaxHeight(); // Per-axis don't-shrink rule. When current is null (wrapper not yet
        // mounted), treat as "smaller than any target" so we always grow.
        // We also floor by the configured min here (rather than at the end) so
        // the min-bound correction is treated as part of "where we want to be"
        // and not as a growth event — otherwise a sub-min current dimension
        // would falsely flag `widthGrew`/`heightGrew` even when the caller
        // requested no growth.
        const desiredWidth = Math.max(currentWidth ?? 0, targetWidth, currentMinWidth_0);
        const desiredHeight = Math.max(currentHeight ?? 0, targetHeight, currentMinHeight_0); // Viewport clamp, bounded below by the current dimension so the viewport
        // can prevent further growth but never force a shrink past what the user
        // is already showing. If the wrapper has not measured yet, the viewport
        // max is used as-is.
        const safeMaxWidth = currentWidth !== null ? Math.max(currentWidth, calculatedMaxWidth_0) : calculatedMaxWidth_0;
        const safeMaxHeight = currentHeight !== null ? Math.max(currentHeight, calculatedMaxHeight_0) : calculatedMaxHeight_0; // Final applied value: desired (already floored by min) clamped by the
        // viewport-bounded max.
        const appliedWidth = Math.min(safeMaxWidth, desiredWidth);
        const appliedHeight = Math.min(safeMaxHeight, desiredHeight); // Did either axis actually move? We compare against the *effective* current
        // dimension — the larger of the rendered value and the configured min —
        // so a min-bound correction (e.g. wrapper measured at 300 while min is
        // 350) is not mistaken for caller-driven growth.
        // `currentWidth === null` means the wrapper hasn't measured yet — treat
        // any applied value as a growth so the modal does adopt the new size.
        const effectiveCurrentWidth = currentWidth === null ? null : Math.max(currentWidth, currentMinWidth_0);
        const effectiveCurrentHeight = currentHeight === null ? null : Math.max(currentHeight, currentMinHeight_0);
        const widthGrew = effectiveCurrentWidth === null ? appliedWidth > 0 : appliedWidth > effectiveCurrentWidth;
        const heightGrew = effectiveCurrentHeight === null ? appliedHeight > 0 : appliedHeight > effectiveCurrentHeight; // Dry-run callers (e.g. the auto-expand Control-exposure probe) want the
        // computed result without mutating state. Skip all writes below.
        if (dryRun) return {
            appliedWidth: appliedWidth,
            appliedHeight: appliedHeight,
            previousWidth: currentWidth,
            previousHeight: currentHeight,
            widthGrew: widthGrew,
            heightGrew: heightGrew,
            widthClampedByViewport: targetWidth > calculatedMaxWidth_0,
            heightClampedByViewport: targetHeight > calculatedMaxHeight_0,
            didChange: widthGrew || heightGrew,
            source: source
        };
        if (widthGrew) {
            setWidth(appliedWidth); // Also update the ref synchronously so a follow-up call within the
            // same tick sees the new value (without waiting for the mirror
            // effect to commit).
            widthRef.current = appliedWidth;
        }
        if (heightGrew) {
            setHeight(appliedHeight);
            heightRef.current = appliedHeight; // PR feedback fix #3: when the auto-expand grows the height for the
            // first time, anchor `defaultMinHeightRef` to the *pre-grow* height
            // (minus greeting offset). Otherwise the first subsequent manual
            // drag uses the post-auto-expand height as its lower bound and the
            // user cannot drag back below the auto-expanded size.
            if (defaultMinHeightRef.current === null && currentHeight !== null) defaultMinHeightRef.current = currentHeight - (optionsRef.current.greetingHeight ?? 0);
        }
        if (widthGrew || heightGrew) setHasUserResized(true);
        return {
            appliedWidth: appliedWidth,
            appliedHeight: appliedHeight,
            previousWidth: currentWidth,
            previousHeight: currentHeight,
            widthGrew: widthGrew,
            heightGrew: heightGrew,
            // PR feedback fix #2: compare against the *requested* target, not
            // the don't-shrink-adjusted `desiredWidth`. The JSDoc contract is
            // "true if the requested target width was larger than the viewport
            // could accommodate" — clamping should not be reported when the
            // modal merely happens to already be wider than the viewport.
            widthClampedByViewport: targetWidth > calculatedMaxWidth_0,
            heightClampedByViewport: targetHeight > calculatedMaxHeight_0,
            didChange: widthGrew || heightGrew,
            source: source
        };
    }, [
        calculateMaxHeight,
        calculateMaxWidth,
        getWrapperDimensions
    ]);
    return {
        wrapperRef: wrapperRef,
        wrapperStyle: wrapperStyle,
        ResizeHandlers: ResizeHandlers,
        isResizeEnabled: enabled,
        isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
        setSize: setSize
    };
};


















const $e0357dee8bc8185f$export$b8fb44be361a2c5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMiniModalTabHeight(params) {
    const $ = (0, $bDgLe.c)(16);
    const { isEmptyConvo: isEmptyConvo, activeAction: activeAction, screenType: screenType, isAutoSuggestSkillsVisible: isAutoSuggestSkillsVisible, topOffset: topOffset } = params;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)();
        $[0] = t0;
    } else t0 = $[0];
    const isFypTabsEnabled = t0;
    const [tabShellHeightPx, setTabShellHeightPx] = (0, $cozmU.useState)(null);
    const [forYouShellHeightPx, setForYouShellHeightPx] = (0, $cozmU.useState)(null);
    let t1;
    let t2;
    if ($[1] !== isEmptyConvo) {
        t1 = ()=>{
            if (!isFypTabsEnabled || !isEmptyConvo) {
                setTabShellHeightPx(null);
                setForYouShellHeightPx(null);
            }
        };
        t2 = [
            isEmptyConvo,
            isFypTabsEnabled
        ];
        $[1] = isEmptyConvo;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const hasTabsView = isFypTabsEnabled && isEmptyConvo;
    const shouldLockToExpandedHeight = Boolean(activeAction) || screenType === "conversation" || screenType === "skills" || screenType === "prompt-library" || isAutoSuggestSkillsVisible;
    const isSmallViewportNavAware = (0, $iDrrr.fg)("rovo-button-minimodal-height-small-view");
    const defaultMaxHeight = topOffset === 0 && isSmallViewportNavAware ? `min(${0, $oV0CU.MINI_MODAL_EXPANDED_HEIGHT}, calc(100vh - 3.5rem - 1.5rem))` : `min(${0, $oV0CU.MINI_MODAL_EXPANDED_HEIGHT}, calc(100vh - ${topOffset}px))`;
    const defaultMinHeight = shouldLockToExpandedHeight ? defaultMaxHeight : undefined;
    let t3;
    if ($[4] !== defaultMaxHeight || $[5] !== defaultMinHeight || $[6] !== forYouShellHeightPx || $[7] !== hasTabsView || $[8] !== isEmptyConvo || $[9] !== tabShellHeightPx) {
        t3 = (wrapperStyle)=>{
            const isManuallyResized = Boolean(wrapperStyle?.height);
            const effectiveMinHeightPx = tabShellHeightPx === null && forYouShellHeightPx === null ? null : Math.max(tabShellHeightPx ?? 0, forYouShellHeightPx ?? 0);
            const useTabShellSnapshot = hasTabsView && !isManuallyResized && effectiveMinHeightPx !== null && isEmptyConvo;
            return {
                ...wrapperStyle,
                maxHeight: isManuallyResized ? undefined : defaultMaxHeight,
                minHeight: isManuallyResized ? undefined : defaultMinHeight,
                ...useTabShellSnapshot ? {
                    minHeight: `${effectiveMinHeightPx}px`
                } : {}
            };
        };
        $[4] = defaultMaxHeight;
        $[5] = defaultMinHeight;
        $[6] = forYouShellHeightPx;
        $[7] = hasTabsView;
        $[8] = isEmptyConvo;
        $[9] = tabShellHeightPx;
        $[10] = t3;
    } else t3 = $[10];
    const getDynamicContainerStyle = t3;
    let t4;
    if ($[11] !== forYouShellHeightPx || $[12] !== getDynamicContainerStyle || $[13] !== hasTabsView || $[14] !== tabShellHeightPx) {
        t4 = {
            hasTabsView: hasTabsView,
            tabShellHeightPx: tabShellHeightPx,
            setTabShellHeightPx: setTabShellHeightPx,
            forYouShellHeightPx: forYouShellHeightPx,
            setForYouShellHeightPx: setForYouShellHeightPx,
            getDynamicContainerStyle: getDynamicContainerStyle
        };
        $[11] = forYouShellHeightPx;
        $[12] = getDynamicContainerStyle;
        $[13] = hasTabsView;
        $[14] = tabShellHeightPx;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : function useMiniModalTabHeight(params) {
    const { isEmptyConvo: isEmptyConvo, activeAction: activeAction, screenType: screenType, isAutoSuggestSkillsVisible: isAutoSuggestSkillsVisible, topOffset: topOffset } = params;
    // Shell-level gate: the tab shell is sized for both spaces and pins, so this must match
    // whatever condition renders the tab strip (see `use-empty-state-render`).
    const isFypTabsEnabled = (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)();
    const [tabShellHeightPx, setTabShellHeightPx] = (0, $cozmU.useState)(null);
    const [forYouShellHeightPx, setForYouShellHeightPx] = (0, $cozmU.useState)(null);
    // Clear the captured shell height when leaving the empty-conversation tabs view
    // (e.g. user starts a conversation) so the stale snapshot isn't applied during transitions.
    (0, $cozmU.useEffect)(()=>{
        if (!isFypTabsEnabled || !isEmptyConvo) {
            setTabShellHeightPx(null);
            setForYouShellHeightPx(null);
        }
    }, [
        isEmptyConvo,
        isFypTabsEnabled
    ]);
    const hasTabsView = isFypTabsEnabled && isEmptyConvo;
    // Whether the modal should expand to full height (conversation, skills, etc.).
    // Tabs view is excluded: it uses the shell-height snapshot instead of locking minHeight,
    // so the user can still resize the modal smaller.
    const shouldLockToExpandedHeight = Boolean(activeAction) || screenType === 'conversation' || screenType === 'skills' || screenType === 'prompt-library' || isAutoSuggestSkillsVisible;
    // On very small viewports with Nav4, use a nav-aware formula to prevent the default
    // opened modal height from overlapping the top navigation bar.
    // 3.5rem = Nav4 standard top nav bar height (56px at base 16px font size)
    // 1.5rem = bottom clearance from the floating shell container (space.300)
    // Falls back to the topOffset-based formula for legacy callers (topOffset !== 0).
    // fg is hoisted so exposure is always tracked regardless of topOffset value.
    const isSmallViewportNavAware = (0, $iDrrr.fg)('rovo-button-minimodal-height-small-view');
    const defaultMaxHeight = topOffset === 0 && isSmallViewportNavAware ? `min(${0, $oV0CU.MINI_MODAL_EXPANDED_HEIGHT}, calc(100vh - 3.5rem - 1.5rem))` : `min(${0, $oV0CU.MINI_MODAL_EXPANDED_HEIGHT}, calc(100vh - ${topOffset}px))`;
    const defaultMinHeight = shouldLockToExpandedHeight ? defaultMaxHeight : undefined;
    const getDynamicContainerStyle = (0, $cozmU.useCallback)((wrapperStyle)=>{
        const isManuallyResized = Boolean(wrapperStyle?.height);
        // Apply the captured shell heights to prevent layout shifts on tab switch.
        // Use the max of both tab heights so the modal never shrinks when switching
        // between tabs, but can still grow if one tab has more content.
        // Only apply when not manually resized and still in empty convo.
        const effectiveMinHeightPx = tabShellHeightPx === null && forYouShellHeightPx === null ? null : Math.max(tabShellHeightPx ?? 0, forYouShellHeightPx ?? 0);
        const useTabShellSnapshot = hasTabsView && !isManuallyResized && effectiveMinHeightPx !== null && isEmptyConvo;
        return {
            ...wrapperStyle,
            maxHeight: isManuallyResized ? undefined : defaultMaxHeight,
            minHeight: isManuallyResized ? undefined : defaultMinHeight,
            ...useTabShellSnapshot ? {
                minHeight: `${effectiveMinHeightPx}px`
            } : {}
        };
    }, [
        hasTabsView,
        tabShellHeightPx,
        forYouShellHeightPx,
        isEmptyConvo,
        defaultMaxHeight,
        defaultMinHeight
    ]);
    return {
        hasTabsView: hasTabsView,
        tabShellHeightPx: tabShellHeightPx,
        setTabShellHeightPx: setTabShellHeightPx,
        forYouShellHeightPx: forYouShellHeightPx,
        setForYouShellHeightPx: setForYouShellHeightPx,
        getDynamicContainerStyle: getDynamicContainerStyle
    };
};









var $hJC44 = parcelRequire("hJC44");

const $0226839d0b5ae712$export$2fee09931cf10a53 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $hJC44.default));
} : ()=>(0, $cozmU.useContext)((0, $hJC44.default));

















const $aaf05328afc9c75c$export$81d79b770bf609f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { override: override } = (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext));
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const wasInInsightChat = (0, $cozmU.useRef)(false);
    const publishRef = (0, $cozmU.useRef)(publish);
    let t0;
    let t1;
    if ($[0] !== publish) {
        t0 = ()=>{
            publishRef.current = publish;
        };
        t1 = [
            publish
        ];
        $[0] = publish;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const isInInsightChat = override?.source === "pulse";
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            publishRef.current({
                type: "insights-chat-exited",
                source: "ai-mate",
                openChat: false,
                data: {}
            });
        };
        $[3] = t2;
    } else t2 = $[3];
    const publishExited = t2;
    let t3;
    let t4;
    if ($[4] !== isInInsightChat) {
        t3 = ()=>{
            if (wasInInsightChat.current && !isInInsightChat) publishExited();
            wasInInsightChat.current = isInInsightChat;
        };
        t4 = [
            isInInsightChat,
            publishExited
        ];
        $[4] = isInInsightChat;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>()=>{
                if (wasInInsightChat.current) publishExited();
            };
        t6 = [
            publishExited
        ];
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    return null;
} : ()=>{
    const { override: override } = (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext));
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const wasInInsightChat = (0, $cozmU.useRef)(false);
    // Latest-publish ref so the unmount cleanup calls the current publish fn.
    const publishRef = (0, $cozmU.useRef)(publish);
    (0, $cozmU.useEffect)(()=>{
        publishRef.current = publish;
    }, [
        publish
    ]);
    const isInInsightChat = override?.source === 'pulse';
    const publishExited = (0, $cozmU.useCallback)(()=>{
        publishRef.current({
            type: 'insights-chat-exited',
            source: 'ai-mate',
            // Prevent this close signal from reopening chat through ChatOpenerSubscriber.
            openChat: false,
            data: {}
        });
    }, []);
    // Handles in-place exits where the component stays mounted and re-renders.
    (0, $cozmU.useEffect)(()=>{
        if (wasInInsightChat.current && !isInInsightChat) publishExited();
        wasInInsightChat.current = isInInsightChat;
    }, [
        isInInsightChat,
        publishExited
    ]);
    // Handles teardown while still in an insight chat (e.g. chat panel closes).
    (0, $cozmU.useEffect)(()=>()=>{
            if (wasInInsightChat.current) publishExited();
        }, [
        publishExited
    ]);
    return null;
};



var $55KWY = parcelRequire("55KWY");


var $eKjv9 = parcelRequire("eKjv9");










const $0ddd4a030c9463c6$export$155581e8dc02007a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { title: title } = props;
    let t0;
    let t1;
    if ($[0] !== title) {
        t0 = ()=>{
            document.title = title;
        };
        t1 = [
            title
        ];
        $[0] = title;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return null;
} : (props)=>{
    const { title: title } = props;
    (0, $cozmU.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
    return null;
};









var $atEX8 = parcelRequire("atEX8");

const $ecef698430401e91$export$8323ee170f55f743 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)((0, $atEX8.SideNavContext));
    if (context === undefined) throw new Error("useSideNav must be used within a SideNavProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $atEX8.SideNavContext));
    if (context === undefined) throw new Error('useSideNav must be used within a SideNavProvider');
    return context;
};



var $dSCNl = parcelRequire("dSCNl");


var $6YdPR = parcelRequire("6YdPR");























var $9aRNV = parcelRequire("9aRNV");




const $fb5a7b7fdd168f1b$export$3902b208060a7183 = (chatStatus, conversationStatus)=>{
    return chatStatus === 'launching' || conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).loadingChat;
};



var $3TxKn = parcelRequire("3TxKn");


var $5wAPd = parcelRequire("5wAPd");

const $6a3a2f991f4c8b17$export$d4a1aceb2518d83a = (conversationId)=>{
    (0, $6cFsl.di)((0, $5wAPd.useConversation), (0, $3TxKn.useChatStoreActions), (0, $k4g8h.useChatSignals), (0, $iW40i.useChatMessages), (0, $fb5a7b7fdd168f1b$export$3902b208060a7183), (0, $9aRNV.useConversationActionsStore));
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    });
    const [{ status: chatStatus }] = (0, $k4g8h.useChatSignals)();
    const [conversationMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const [inlineBrowseScreen, setInlineBrowseScreen] = (0, $cozmU.useState)(null);
    const prevConversationIdRef = (0, $cozmU.useRef)(conversationId);
    const prevAgentIdRef = (0, $cozmU.useRef)(selectedAgent?.id);
    const prevStatusRef = (0, $cozmU.useRef)(conversation?.status);
    // Auto-close inline browse when conversation, agent, or message status changes
    (0, $cozmU.useEffect)(()=>{
        const conversationChanged = prevConversationIdRef.current !== conversationId;
        const agentChanged = prevAgentIdRef.current !== selectedAgent?.id;
        const messageSent = prevStatusRef.current !== conversation?.status && conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse;
        prevConversationIdRef.current = conversationId;
        prevAgentIdRef.current = selectedAgent?.id;
        prevStatusRef.current = conversation?.status;
        if ((conversationChanged || agentChanged || messageSent) && inlineBrowseScreen) setInlineBrowseScreen(null);
    }, [
        conversationId,
        selectedAgent?.id,
        conversation?.status,
        inlineBrowseScreen
    ]);
    // Get the base screen type based on the conversation state
    const getBaseScreenType = (0, $cozmU.useCallback)(()=>{
        const noConversation = !conversation || !conversationMessages.length;
        const isChatStoreOrConversationLoading = (0, $fb5a7b7fdd168f1b$export$3902b208060a7183)(chatStatus, conversation?.status);
        const isActiveActionInEmptyConversation = activeAction && conversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID);
        if (noConversation && isChatStoreOrConversationLoading) return 'loading';
        if (noConversation) return 'empty';
        if (isActiveActionInEmptyConversation) return 'empty';
        return 'conversation';
    }, [
        conversation,
        conversationMessages.length,
        chatStatus,
        activeAction,
        conversationId
    ]);
    const openInlineBrowse = (0, $cozmU.useCallback)((screen)=>{
        setInlineBrowseScreen(screen);
    }, []);
    const closeInlineBrowse = (0, $cozmU.useCallback)(()=>{
        setInlineBrowseScreen(null);
        // Return focus to chat input for accessibility
        setTimeout(()=>{
            const chatTextarea = (0, $1hQ0e.getDocument)()?.querySelector('#ak-editor-textarea');
            if (chatTextarea) chatTextarea.focus();
        }, 100);
    }, []);
    const screenType = inlineBrowseScreen ?? getBaseScreenType();
    return {
        screenType: screenType,
        openInlineBrowse: openInlineBrowse,
        closeInlineBrowse: closeInlineBrowse
    };
};














const $3681f9f0278ae1e7$export$2417674bdeeeee0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (selectedAgentName, selectedAgentIsDefault, currentConversationId, conversationName)=>{
    let t0;
    bb0: {
        if (currentConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID)) {
            t0 = selectedAgentName && !selectedAgentIsDefault ? selectedAgentName : (0, $kQqCc.DEFAULT_PAGE_TITLE);
            break bb0;
        } else if (selectedAgentIsDefault) {
            t0 = conversationName ? (0, $kQqCc.DEFAULT_PAGE_TITLE) + " - " + conversationName : (0, $kQqCc.DEFAULT_PAGE_TITLE);
            break bb0;
        }
        if (selectedAgentName && conversationName) {
            t0 = selectedAgentName + " - " + conversationName;
            break bb0;
        }
        if (conversationName) {
            t0 = (0, $kQqCc.DEFAULT_PAGE_TITLE) + " - " + conversationName;
            break bb0;
        }
        t0 = selectedAgentName || (0, $kQqCc.DEFAULT_PAGE_TITLE);
    }
    return t0;
} : (selectedAgentName, selectedAgentIsDefault, currentConversationId, conversationName)=>{
    return (0, $cozmU.useMemo)(()=>{
        if (currentConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID)) return selectedAgentName && !selectedAgentIsDefault ? selectedAgentName : (0, $kQqCc.DEFAULT_PAGE_TITLE);
        else if (selectedAgentIsDefault) return conversationName ? (0, $kQqCc.DEFAULT_PAGE_TITLE) + ' - ' + conversationName : (0, $kQqCc.DEFAULT_PAGE_TITLE);
        if (selectedAgentName && conversationName) return selectedAgentName + ' - ' + conversationName;
        if (conversationName) return (0, $kQqCc.DEFAULT_PAGE_TITLE) + ' - ' + conversationName;
        return selectedAgentName || (0, $kQqCc.DEFAULT_PAGE_TITLE);
    }, [
        selectedAgentName,
        selectedAgentIsDefault,
        currentConversationId,
        conversationName
    ]);
};



var $5BOJB = parcelRequire("5BOJB");


var $gR7ri = parcelRequire("gR7ri");

const $d7d494c6f701221a$export$686d2858de1a6c61 = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.presentation ?? {};



var $j180q = parcelRequire("j180q");



var $1IZrU = parcelRequire("1IZrU");
































var $dvUlt = parcelRequire("dvUlt");

const $3a01bf6f140b15bf$export$e4594b7cd3624f07 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { agentErrorCode: agentErrorCode, conversationId: conversationId } = t0;
    const { setConversationData: setConversationData } = (0, $3TxKn.useChatStoreActions)();
    let t1;
    let t2;
    if ($[0] !== agentErrorCode || $[1] !== conversationId || $[2] !== setConversationData) {
        t1 = ()=>{
            if (!conversationId || (0, $1IZrU.isEmptyConversation)(conversationId)) return;
            if (agentErrorCode && (0, $dvUlt.isAgentUnavailable)(agentErrorCode) && (0, $iDrrr.fg)("convo-ai-enable-agents-use-permission")) setConversationData({
                conversationId: conversationId,
                data: {
                    status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
                    errorCode: agentErrorCode
                }
            });
        };
        t2 = [
            agentErrorCode,
            conversationId,
            setConversationData
        ];
        $[0] = agentErrorCode;
        $[1] = conversationId;
        $[2] = setConversationData;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ agentErrorCode: agentErrorCode, conversationId: conversationId })=>{
    const { setConversationData: setConversationData } = (0, $3TxKn.useChatStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        // Don't set error state for empty conversations (new chats)
        if (!conversationId || (0, $1IZrU.isEmptyConversation)(conversationId)) return;
        if (agentErrorCode && (0, $dvUlt.isAgentUnavailable)(agentErrorCode) && (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission')) setConversationData({
            conversationId: conversationId,
            data: {
                status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
                errorCode: agentErrorCode
            }
        });
    }, [
        agentErrorCode,
        conversationId,
        setConversationData
    ]);
};



var $j8on0 = parcelRequire("j8on0");


var $8s9DV = parcelRequire("8s9DV");

const $edfbad14347f2caa$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        isOpen: false,
        feedbackData: {
            answerQuality: 'general'
        }
    },
    actions: {
        open: (payload)=>({ setState: setState })=>{
                setState({
                    isOpen: true,
                    feedbackData: payload
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false,
                    feedbackData: {
                        answerQuality: 'general'
                    }
                });
            }
    }
});


const $b102523dfc9f7a6e$export$d75860f72b50dfd = (0, $j8on0.createContainer)((0, $edfbad14347f2caa$export$6f57813fe9f31bf9));


















var $2429E = parcelRequire("2429E");

const $b660a9aa617f7771$export$4593c8e703770407 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const [t0] = (0, $2429E.useCurrentActionAuth)();
    const { currentAuth: currentAuth } = t0;
    const { clearAuth: clearAuth } = (0, $2429E.useCurrentActionAuthActions)();
    let t1;
    let t2;
    if ($[0] !== clearAuth || $[1] !== currentAuth || $[2] !== publish) {
        t1 = ()=>{
            if (!currentAuth) return;
            const handlerUnbind = (0, $cbY7C.bind)(window, {
                type: "message",
                listener: (event)=>{
                    const { data: data } = event;
                    if (!data) return;
                    if (![
                        "outbound-auth:success",
                        "outbound-auth:failure"
                    ].includes(data.type)) return;
                    const window$0 = event.source;
                    window$0?.close?.();
                    const is3pActionAuth = currentAuth.authType === "3p";
                    if (data.type === "outbound-auth:success") publish({
                        type: "forge-auth-success",
                        source: "forge-auth-listener",
                        data: {
                            is3pActionAuth: is3pActionAuth,
                            agentMessageId: currentAuth.agentMessageId,
                            authUrl: currentAuth.url
                        }
                    });
                    else if (data.type === "outbound-auth:failure") publish({
                        type: "forge-auth-failure",
                        data: {
                            errorMessage: data.message || undefined,
                            is3pActionAuth: is3pActionAuth
                        },
                        source: "forge-auth-listener"
                    });
                    clearAuth();
                }
            });
            return handlerUnbind;
        };
        t2 = [
            currentAuth,
            publish,
            clearAuth
        ];
        $[0] = clearAuth;
        $[1] = currentAuth;
        $[2] = publish;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ()=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const [{ currentAuth: currentAuth }] = (0, $2429E.useCurrentActionAuth)();
    const { clearAuth: clearAuth } = (0, $2429E.useCurrentActionAuthActions)();
    (0, $cozmU.useEffect)(()=>{
        // Only bind the listener if there's an active auth flow
        if (!currentAuth) return;
        const handlerUnbind = (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: (event)=>{
                const { data: data } = event;
                if (!data) return;
                if (![
                    'outbound-auth:success',
                    'outbound-auth:failure'
                ].includes(data.type)) return;
                const window1 = event.source;
                // close the auth window, so this window gets focused
                window1?.close?.();
                const is3pActionAuth = currentAuth.authType === '3p';
                if (data.type === 'outbound-auth:success') publish({
                    type: 'forge-auth-success',
                    source: 'forge-auth-listener',
                    data: {
                        is3pActionAuth: is3pActionAuth,
                        agentMessageId: currentAuth.agentMessageId,
                        authUrl: currentAuth.url
                    }
                });
                else if (data.type === 'outbound-auth:failure') publish({
                    type: 'forge-auth-failure',
                    data: {
                        errorMessage: data.message || undefined,
                        is3pActionAuth: is3pActionAuth
                    },
                    source: 'forge-auth-listener'
                });
                // Clear the auth state after handling the callback
                // This prevents the listener from being triggered erroneously next time
                clearAuth();
            }
        });
        return handlerUnbind;
    }, [
        currentAuth,
        publish,
        clearAuth
    ]);
    return null;
};



var $bCuI8 = parcelRequire("bCuI8");































const $091a94a3eed485a1$export$58f0f8109b629481 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSetBackBehaviorOverride() {
    return (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext)).setOverride;
} : function useSetBackBehaviorOverride() {
    return (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext)).setOverride;
};















var $4wH3g = parcelRequire("4wH3g");





var $6iWVH = parcelRequire("6iWVH");


var $fqtnH = parcelRequire("fqtnH");

const $fb8fa2f60c0b90d6$export$8941fb6670d59d11 = 'rovo-insight';



const $0e79ec138f6ad91b$var$InsightChatViewLazyComponent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("aDqDQ")).then((m)=>({
            default: m.InsightChatView
        })));
Object.assign($0e79ec138f6ad91b$var$InsightChatViewLazyComponent, {
    displayName: 'lazy(InsightChatView)'
});

const $0e79ec138f6ad91b$var$InsightChatViewLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "q9r8U",
    name: "InsightChatViewLoadableComponent",
    loader: ()=>(parcelRequire("aDqDQ")).then((m)=>m.InsightChatView),
    loading: ()=>null
});
const $0e79ec138f6ad91b$var$InsightChatViewWithSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function InsightChatViewWithSuspense(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatViewLazyComponent, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function InsightChatViewWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatViewLazyComponent, props));
};
const $0e79ec138f6ad91b$var$InsightChatView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("nike_r19_react_loadable") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatViewWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatViewLoadableComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $iDrrr.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatViewWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatViewLoadableComponent, props);
const $0e79ec138f6ad91b$export$c84bb17aac8596e7 = (insight, icon, lifecycle)=>{
    const InsightIcon = icon;
    const { agentMessageAdf: agentMessageAdf, title: title, followUps: followUps } = insight;
    return {
        id: `${0, $fb8fa2f60c0b90d6$export$8941fb6670d59d11}:${crypto.randomUUID()}`,
        title: title,
        followUps: followUps,
        presentation: {
            hideActionHeader: true,
            suppressPromptLibrary: true,
            centerInFullScreen: true
        },
        seededConversation: {
            name: title,
            followUpSource: 'insightsFeed',
            tags: [
                (0, $fqtnH.TAGS).INSIGHTS
            ],
            skipNextFetch: true,
            onCreated: lifecycle.onCreated
        },
        onDismiss: lifecycle.onDismiss,
        handleType: (0, $6iWVH.HandleActionType).Base,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InsightIcon, {
                label: title
            }),
        viewConfig: {
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79ec138f6ad91b$var$InsightChatView, {
                    agentMessageAdf: agentMessageAdf
                })
        },
        customFollowUpContext: {
            available: true,
            fetch: async ()=>[
                    {
                        human_message: {
                            content: ''
                        },
                        agent_message: {
                            content: agentMessageAdf,
                            mimeType: 'text/adf'
                        }
                    }
                ]
        }
    };
};


const $e5d1fdf7ab29ba5c$var$backToInsightsMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate.seed-insight-conversation.back-to-insights.label",
    defaultMessage: "Go back to Insights"
});
const $e5d1fdf7ab29ba5c$export$3edf947a58c1a4fc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { setActiveAction: setActiveAction, clearActiveAction: clearActiveAction } = (0, $5BOJB.useActiveAction)();
    const { setActiveMenu: setActiveMenu, setConversationHeader: setConversationHeader } = (0, $bGNkz.useUIStore)();
    const setBackBehaviorOverride = (0, $091a94a3eed485a1$export$58f0f8109b629481)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== clearActiveAction || $[1] !== formatMessage || $[2] !== setActiveAction || $[3] !== setActiveMenu || $[4] !== setBackBehaviorOverride || $[5] !== setConversationHeader) {
        t0 = async (agentMessage, meta)=>{
            if (!(0, $cXtTj.default).getExperimentValue("rovo_growth_chat_pulse", "isEnabled", false)) return;
            const action = (0, $0e79ec138f6ad91b$export$c84bb17aac8596e7)({
                agentMessageAdf: agentMessage,
                title: meta.conversationTitle,
                followUps: meta.followUps
            }, meta.conversationIcon, {
                onDismiss: ()=>{
                    setConversationHeader(null);
                    setBackBehaviorOverride(null);
                },
                onCreated: (conversationId)=>{
                    setConversationHeader({
                        conversationId: conversationId,
                        title: meta.conversationTitle,
                        icon: meta.conversationIcon,
                        iconAppearance: meta.conversationIconAppearance,
                        source: "pulse"
                    });
                    setBackBehaviorOverride(null);
                }
            });
            setActiveAction(action);
            setConversationHeader({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                title: meta.conversationTitle,
                icon: meta.conversationIcon,
                iconAppearance: meta.conversationIconAppearance,
                source: "pulse"
            });
            setBackBehaviorOverride({
                source: "pulse",
                backButtonLabel: meta.backButtonLabel ?? formatMessage($e5d1fdf7ab29ba5c$var$backToInsightsMessage),
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                previousView: ()=>{
                    setActiveMenu("pulse");
                    clearActiveAction();
                }
            });
            setActiveMenu("none");
        };
        $[0] = clearActiveAction;
        $[1] = formatMessage;
        $[2] = setActiveAction;
        $[3] = setActiveMenu;
        $[4] = setBackBehaviorOverride;
        $[5] = setConversationHeader;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : ()=>{
    const { setActiveAction: setActiveAction, clearActiveAction: clearActiveAction } = (0, $5BOJB.useActiveAction)();
    const { setActiveMenu: setActiveMenu, setConversationHeader: setConversationHeader } = (0, $bGNkz.useUIStore)();
    const setBackBehaviorOverride = (0, $091a94a3eed485a1$export$58f0f8109b629481)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(async (agentMessage, meta)=>{
        // Insight activeAction opens are pulse-only.
        if (!(0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false)) return;
        const action = (0, $0e79ec138f6ad91b$export$c84bb17aac8596e7)({
            agentMessageAdf: agentMessage,
            title: meta.conversationTitle,
            followUps: meta.followUps
        }, meta.conversationIcon, {
            onDismiss: ()=>{
                setConversationHeader(null);
                setBackBehaviorOverride(null);
            },
            onCreated: (conversationId)=>{
                setConversationHeader({
                    conversationId: conversationId,
                    title: meta.conversationTitle,
                    icon: meta.conversationIcon,
                    iconAppearance: meta.conversationIconAppearance,
                    source: 'pulse'
                });
                setBackBehaviorOverride(null);
            }
        });
        setActiveAction(action);
        setConversationHeader({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
            title: meta.conversationTitle,
            icon: meta.conversationIcon,
            iconAppearance: meta.conversationIconAppearance,
            source: 'pulse'
        });
        setBackBehaviorOverride({
            source: 'pulse',
            backButtonLabel: meta.backButtonLabel ?? formatMessage($e5d1fdf7ab29ba5c$var$backToInsightsMessage),
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
            previousView: ()=>{
                setActiveMenu('pulse');
                clearActiveAction();
            }
        });
        setActiveMenu('none');
    }, [
        setActiveAction,
        clearActiveAction,
        setConversationHeader,
        setBackBehaviorOverride,
        setActiveMenu,
        formatMessage
    ]);
};















var $aJU2k = parcelRequire("aJU2k");








var $9qJ1N = parcelRequire("9qJ1N");





var $3Cuhs = parcelRequire("3Cuhs");




const $ddcfc9463ea1b073$var$useHydrateInner = ({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning -- enable_tasks is the umbrella gate for task updates.
    const enabled = (0, $iDrrr.fg)('rovo_chat_enable_tasks');
    const { mountSSESubscriber: mountSSESubscriber, unmountSSESubscriber: unmountSSESubscriber, setActiveConversationContext: setActiveConversationContext } = (0, $9qJ1N.useTasksStoreActions)();
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const { setReasoningMode: setReasoningMode } = (0, $aJU2k.useChatModeStoreActions)();
    // Track the active task for the *current* conversation so we can react to
    // task lifecycle transitions (e.g. reset reasoning mode when task completes).
    const [activeTaskForCurrent] = (0, $9qJ1N.useActiveTaskForConversation)(currentConversationId ?? '');
    const previousActiveTaskRef = (0, $cozmU.useRef)({
        taskId: null,
        isTerminal: false
    });
    // SSE lifecycle: open ref-counted SSE connection through the unified store.
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return undefined;
        const getService = ()=>assistanceService;
        mountSSESubscriber(getService);
        return ()=>unmountSSESubscriber();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled
    ]);
    // Keep the tasks store informed of the current conversation context for
    // SSE reconnect guards (replaces the idle-status + currentMessageId guards
    // that were in consumeTaskStatusUpdates).
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        const conversation = currentConversationId ? conversations[currentConversationId] : undefined;
        const lastMsgId = conversation ? (0, $3Cuhs.getLastAgentMessageID)(conversation.messages ?? []) ?? null : null;
        setActiveConversationContext({
            conversationId: currentConversationId ?? null,
            lastAgentMessageId: lastMsgId,
            status: conversation?.status ?? null
        });
    }, [
        currentConversationId,
        conversations,
        enabled,
        setActiveConversationContext
    ]);
    // ─── Reasoning-mode auto-reset bridge ────────────────────────────────────
    //
    // Reset the reasoning mode to 'auto' when the *current conversation* has no
    // active in-flight task to drive task mode. Two distinct triggers:
    //
    //  1. Same-task completion: the active task transitions from non-terminal
    //     → terminal. Replaces the inline `setReasoningMode` side effect that
    //     lived inside the legacy `setTaskProgressState` chat-store action.
    //
    //  2. Conversation switch: when the user navigates to a conversation whose
    //     active task is in a TERMINAL state (i.e. there's stale "task mode"
    //     to clean up because a task previously completed in the background
    //     while the user was elsewhere). Conversations with NO task at all are
    //     intentionally excluded — a brand-new conversation may have its
    //     reasoning mode pre-set to 'task' by the UI in anticipation of a task
    //     the user is about to start, and clobbering that to 'auto' here would
    //     suppress the chat-input overlay until the BE catches up.
    const previousConversationIdRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !currentConversationId) return;
        const currentTaskId = activeTaskForCurrent?.taskId ?? null;
        const currentIsTerminal = activeTaskForCurrent ? (0, $igOtY.isTerminalTaskState)(activeTaskForCurrent.progressState) : false;
        const previous = previousActiveTaskRef.current;
        const previousConversationId = previousConversationIdRef.current;
        const conversationJustSwitched = previousConversationId !== null && previousConversationId !== currentConversationId;
        const sameTaskCompletedNow = previous.taskId !== null && previous.taskId === currentTaskId && !previous.isTerminal && currentIsTerminal;
        // Only fires when the new conversation has an EXISTING terminal task —
        // a brand-new conversation (no task) is intentionally excluded so the
        // user's pre-set 'task' reasoning mode is preserved. See bridge comment.
        const switchedToConversationWithStaleTerminalTask = conversationJustSwitched && activeTaskForCurrent !== undefined && currentIsTerminal;
        if (sameTaskCompletedNow || switchedToConversationWithStaleTerminalTask) setReasoningMode(currentConversationId, 'auto');
        previousActiveTaskRef.current = {
            taskId: currentTaskId,
            isTerminal: currentIsTerminal
        };
        previousConversationIdRef.current = currentConversationId;
    }, [
        activeTaskForCurrent,
        currentConversationId,
        enabled,
        setReasoningMode
    ]);
};
/**
 * Hydrates the unified tasks store context.
 *
 * Responsibilities:
 * 1. Opens the Tasks SSE connection via the unified tasks store (ref-counted).
 * 2. Keeps the tasks store informed of the current conversation context so
 *    it can guard against stale SSE reconnect replays.
 *
 * Must be mounted globally (e.g. ConversationAssistantRender) so it is always
 * active when the chat is mounted, regardless of which panel is visible.
 *
 * Only active when fg('rovo_chat_enable_tasks') is true.
 */ const $ddcfc9463ea1b073$var$useHydrateInternal = (0, $lJ6db.createHookWithAssistanceService)($ddcfc9463ea1b073$var$useHydrateInner);
const $ddcfc9463ea1b073$export$f0a74a1c06d4e66 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            touchpointSource: "rovo-tasks"
        };
        $[0] = t0;
    } else t0 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t0);
    let t1;
    if ($[1] !== assistanceServiceParams) {
        t1 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[1] = assistanceServiceParams;
        $[2] = t1;
    } else t1 = $[2];
    $ddcfc9463ea1b073$var$useHydrateInternal(t1);
} : ()=>{
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'rovo-tasks'
    });
    $ddcfc9463ea1b073$var$useHydrateInternal({
        assistanceServiceParams: assistanceServiceParams
    });
};





const $8efb636d62a22c96$export$25945d84bef50db1 = (sendAnalyticsEvent, sourceComponent)=>{
    return (error, info)=>{
        if (!(0, $iDrrr.fg)('ai_mate_unhandled_error_reporting')) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'unhandledError',
            actionSubject: 'aiMate',
            attributes: {
                errorName: error?.name,
                errorMessage: error?.message,
                errorStack: error?.stack ?? undefined,
                componentStack: info?.componentStack ?? undefined,
                componentName: info?.componentStack ? info.componentStack.split('\n').find(Boolean)?.trim()?.replace(/^at\s+/, '') : undefined,
                sourceComponent: sourceComponent
            }
        });
    };
};



var $fCunh = parcelRequire("fCunh");

const $c3a833363cbb29f5$export$42e0acafa7afe658 = (chatError)=>{
    if (chatError.message_template === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE || chatError.message_template === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED) return 'rovo-inactive';
    return chatError.status_code === 429 ? 'rate-limited' : 'generic';
};














const $0ec3851bfc318f14$export$667744853b9051e4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCombinedProviderAndCustomActions(getActions) {
    const $ = (0, $bDgLe.c)(8);
    const [t0] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const { customConversationActions: customConversationActions, replaceProviderActions: replaceProviderActions } = t0;
    let t1;
    if ($[0] !== customConversationActions || $[1] !== getActions || $[2] !== replaceProviderActions) {
        t1 = async ()=>{
            const runtimeActions = customConversationActions;
            if (runtimeActions?.length && replaceProviderActions) return runtimeActions;
            const providerActions = await getActions?.() ?? [];
            if (runtimeActions?.length) return [
                ...runtimeActions,
                ...providerActions
            ];
            return providerActions;
        };
        $[0] = customConversationActions;
        $[1] = getActions;
        $[2] = replaceProviderActions;
        $[3] = t1;
    } else t1 = $[3];
    const mergedGetActions = t1;
    const t2 = Boolean(replaceProviderActions);
    const t3 = replaceProviderActions && customConversationActions && customConversationActions.length > 0 ? customConversationActions?.length : undefined;
    let t4;
    if ($[4] !== mergedGetActions || $[5] !== t2 || $[6] !== t3) {
        t4 = {
            mergedGetActions: mergedGetActions,
            replaceProviderActions: t2,
            numStartersToShow: t3
        };
        $[4] = mergedGetActions;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function useCombinedProviderAndCustomActions(getActions) {
    const [{ customConversationActions: customConversationActions, replaceProviderActions: replaceProviderActions }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    // Recreated whenever customConversationActions, replaceProviderActions, or getActions changes.
    // Reading values directly (no ref) ensures the callback always has fresh data.
    const mergedGetActions = (0, $cozmU.useCallback)(async ()=>{
        const runtimeActions = customConversationActions;
        // Precedence rule: runtime store actions (setEmptyChatLaunch) take priority over prop getActions.
        if (runtimeActions?.length && replaceProviderActions) // Runtime launch with replace=true: store actions completely replace the prop provider.
        // getActions is intentionally NOT called here — store actions win entirely.
        // Note: prioritizeCustomActionResults (prop) is still applied downstream to these actions,
        // but it doesn't affect WHICH actions are shown — only that dynamic starters are suppressed.
        return runtimeActions;
        // For all other cases we need the provider actions.
        const providerActions = await getActions?.() ?? [];
        if (runtimeActions?.length) // Runtime launch without replace: prepend store actions to prop provider actions.
        return [
            ...runtimeActions,
            ...providerActions
        ];
        // No runtime actions: fall through to prop provider only.
        return providerActions;
    }, [
        getActions,
        customConversationActions,
        replaceProviderActions
    ]);
    return {
        mergedGetActions: mergedGetActions,
        replaceProviderActions: Boolean(replaceProviderActions),
        // When replacing all provider actions, ensure all custom actions are shown rather than being
        // sliced to the default display limit of 3.
        numStartersToShow: replaceProviderActions && customConversationActions && customConversationActions.length > 0 ? customConversationActions?.length : undefined
    };
};




















const $55dbad1906719e56$export$66a5dbe4271b0de3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useEmptyChatLaunchLifecycle(currentConversationId) {
    const $ = (0, $bDgLe.c)(9);
    const [t0] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const { projectContext: emptyLaunchProjectContext, launchId: emptyLaunchId } = t0;
    const { clearEmptyChatLaunchGreeting: clearEmptyChatLaunchGreeting, clearEmptyChatLaunchAll: clearEmptyChatLaunchAll, checkAndUpdateLifecycleGuard: checkAndUpdateLifecycleGuard } = (0, $bGNkz.useUIStoreActions)();
    const prevLaunchIdRef = (0, $cozmU.useRef)(emptyLaunchId);
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    let t1;
    let t2;
    if ($[0] !== checkAndUpdateLifecycleGuard || $[1] !== clearEmptyChatLaunchAll || $[2] !== clearEmptyChatLaunchGreeting || $[3] !== currentConversationId || $[4] !== emptyLaunchId || $[5] !== emptyLaunchProjectContext || $[6] !== setChatMode) {
        t1 = ()=>{
            const shouldRun = checkAndUpdateLifecycleGuard(currentConversationId, emptyLaunchId);
            if (!shouldRun) return;
            if (currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) {
                if (emptyLaunchProjectContext) setChatMode(currentConversationId, {
                    useCurrentPageContext: true
                });
                clearEmptyChatLaunchGreeting();
            } else if (emptyLaunchId === prevLaunchIdRef.current) clearEmptyChatLaunchAll();
            prevLaunchIdRef.current = emptyLaunchId;
        };
        t2 = [
            currentConversationId,
            clearEmptyChatLaunchGreeting,
            clearEmptyChatLaunchAll,
            emptyLaunchProjectContext,
            emptyLaunchId,
            setChatMode,
            checkAndUpdateLifecycleGuard
        ];
        $[0] = checkAndUpdateLifecycleGuard;
        $[1] = clearEmptyChatLaunchAll;
        $[2] = clearEmptyChatLaunchGreeting;
        $[3] = currentConversationId;
        $[4] = emptyLaunchId;
        $[5] = emptyLaunchProjectContext;
        $[6] = setChatMode;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useEmptyChatLaunchLifecycle(currentConversationId) {
    const [{ projectContext: emptyLaunchProjectContext, launchId: emptyLaunchId }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const { clearEmptyChatLaunchGreeting: clearEmptyChatLaunchGreeting, clearEmptyChatLaunchAll: clearEmptyChatLaunchAll, checkAndUpdateLifecycleGuard: checkAndUpdateLifecycleGuard } = (0, $bGNkz.useUIStoreActions)();
    const prevLaunchIdRef = (0, $cozmU.useRef)(emptyLaunchId);
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        const shouldRun = checkAndUpdateLifecycleGuard(currentConversationId, emptyLaunchId);
        if (!shouldRun) return;
        if (currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) {
            if (emptyLaunchProjectContext) setChatMode(currentConversationId, {
                useCurrentPageContext: true
            });
            clearEmptyChatLaunchGreeting();
        } else if (emptyLaunchId === prevLaunchIdRef.current) // Returning to empty state without a new launch — clear stale context
        clearEmptyChatLaunchAll();
        prevLaunchIdRef.current = emptyLaunchId;
    }, [
        currentConversationId,
        clearEmptyChatLaunchGreeting,
        clearEmptyChatLaunchAll,
        emptyLaunchProjectContext,
        emptyLaunchId,
        setChatMode,
        checkAndUpdateLifecycleGuard
    ]);
};















var $jqg1p = parcelRequire("jqg1p");


var $jAZYc = parcelRequire("jAZYc");

const $9b053e82e6486083$var$areRovoSkillTagsEqual = (current, next)=>(0, $jqg1p.areStringArraysEqual)(current?.skillRegistryTags, next?.skillRegistryTags);
const $9b053e82e6486083$export$40c152105e92ac90 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { tags: tags } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[0] = t1;
    } else t1 = $[0];
    const isTreatmentEnabled = t1 === true;
    const stableTags = (0, $jAZYc.useSemanticStableValue)(tags, isTreatmentEnabled, $9b053e82e6486083$var$areRovoSkillTagsEqual);
    let t2;
    if ($[1] !== stableTags) {
        t2 = isTreatmentEnabled ? {
            tags: stableTags
        } : undefined;
        $[1] = stableTags;
        $[2] = t2;
    } else t2 = $[2];
    const memoizedRovoSkillsConfig = t2;
    if (memoizedRovoSkillsConfig) return memoizedRovoSkillsConfig;
    let t3;
    if ($[3] !== tags) {
        t3 = {
            tags: tags
        };
        $[3] = tags;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ tags: tags })=>{
    const isTreatmentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const stableTags = (0, $jAZYc.useSemanticStableValue)(tags, isTreatmentEnabled, $9b053e82e6486083$var$areRovoSkillTagsEqual);
    const memoizedRovoSkillsConfig = (0, $cozmU.useMemo)(()=>isTreatmentEnabled ? {
            tags: stableTags
        } : undefined, [
        isTreatmentEnabled,
        stableTags
    ]);
    if (memoizedRovoSkillsConfig) return memoizedRovoSkillsConfig;
    return {
        tags: tags
    };
};



var $dPoYT = parcelRequire("dPoYT");



















const $eef113145ca4ccce$export$4e2d22a4f1ea8ef3 = 'for-you';
const $eef113145ca4ccce$export$a6818377be660b14 = 'suggestions';






const $8bfedffef2e76c2c$export$1f821a7525912239 = (0, $cozmU.createContext)({
    activeTabId: (0, $eef113145ca4ccce$export$a6818377be660b14),
    handleActiveTabChange: ()=>{},
    resetToPreviousTab: ()=>{}
});


function $8f18edf7c8a3493e$var$readMiniModalShellHeightPx(shellRef) {
    if (!shellRef?.current) return null;
    const h = Math.floor(shellRef.current.getBoundingClientRect().height);
    return h > 0 ? h : null;
}
const $8f18edf7c8a3493e$export$ab0974fd6d9a834e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { currentConversationId: currentConversationId, children: children, miniModalShellRef: miniModalShellRef, captureShellHeightOnTabChange: t1, onShellHeightCapture: onShellHeightCapture, selectedAgentId: selectedAgentId } = t0;
    const captureShellHeightOnTabChange = t1 === undefined ? false : t1;
    const [t2] = (0, $bGNkz.useActiveTabSelector)();
    const { activeTabId: activeTabIdRaw, previousTabId: previousTabIdRaw, lastTabConversationId: lastTabConversationId } = t2;
    const { setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId } = (0, $bGNkz.useUIStoreActions)();
    const activeTabId = activeTabIdRaw;
    const previousTabId = previousTabIdRaw;
    let t3;
    if ($[0] !== miniModalShellRef || $[1] !== onShellHeightCapture) {
        t3 = (fromTabId)=>{
            if (!onShellHeightCapture) return;
            const h = $8f18edf7c8a3493e$var$readMiniModalShellHeightPx(miniModalShellRef);
            if (h !== null) onShellHeightCapture(fromTabId, h);
        };
        $[0] = miniModalShellRef;
        $[1] = onShellHeightCapture;
        $[2] = t3;
    } else t3 = $[2];
    const captureShellHeight = t3;
    let t4;
    if ($[3] !== activeTabId || $[4] !== captureShellHeight || $[5] !== captureShellHeightOnTabChange || $[6] !== setActiveTabId || $[7] !== setPreviousTabId) {
        t4 = (tabId)=>{
            if (tabId !== (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3) && tabId !== (0, $eef113145ca4ccce$export$a6818377be660b14)) return;
            if (captureShellHeightOnTabChange) captureShellHeight(activeTabId);
            if (tabId !== activeTabId) setPreviousTabId(activeTabId);
            setActiveTabId(tabId);
        };
        $[3] = activeTabId;
        $[4] = captureShellHeight;
        $[5] = captureShellHeightOnTabChange;
        $[6] = setActiveTabId;
        $[7] = setPreviousTabId;
        $[8] = t4;
    } else t4 = $[8];
    const handleActiveTabChange = t4;
    let t5;
    if ($[9] !== activeTabId || $[10] !== captureShellHeight || $[11] !== captureShellHeightOnTabChange || $[12] !== previousTabId || $[13] !== setActiveTabId) {
        t5 = ()=>{
            if (captureShellHeightOnTabChange) captureShellHeight(activeTabId);
            setActiveTabId(previousTabId);
        };
        $[9] = activeTabId;
        $[10] = captureShellHeight;
        $[11] = captureShellHeightOnTabChange;
        $[12] = previousTabId;
        $[13] = setActiveTabId;
        $[14] = t5;
    } else t5 = $[14];
    const resetToPreviousTab = t5;
    let t6;
    if ($[15] !== activeTabId || $[16] !== currentConversationId || $[17] !== lastTabConversationId || $[18] !== setActiveTabId || $[19] !== setLastTabConversationId || $[20] !== setPreviousTabId) {
        t6 = ()=>{
            if (currentConversationId === lastTabConversationId) return;
            setLastTabConversationId(currentConversationId);
            if (currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) {
                setPreviousTabId(activeTabId);
                setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
            }
        };
        $[15] = activeTabId;
        $[16] = currentConversationId;
        $[17] = lastTabConversationId;
        $[18] = setActiveTabId;
        $[19] = setLastTabConversationId;
        $[20] = setPreviousTabId;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== currentConversationId) {
        t7 = [
            currentConversationId
        ];
        $[22] = currentConversationId;
        $[23] = t7;
    } else t7 = $[23];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[24] !== activeTabId || $[25] !== selectedAgentId || $[26] !== setActiveTabId || $[27] !== setPreviousTabId) {
        t8 = ()=>{
            if (selectedAgentId) {
                setPreviousTabId(activeTabId);
                setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
            }
        };
        $[24] = activeTabId;
        $[25] = selectedAgentId;
        $[26] = setActiveTabId;
        $[27] = setPreviousTabId;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== selectedAgentId) {
        t9 = [
            selectedAgentId
        ];
        $[29] = selectedAgentId;
        $[30] = t9;
    } else t9 = $[30];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[31] !== activeTabId || $[32] !== handleActiveTabChange || $[33] !== resetToPreviousTab) {
        t10 = {
            activeTabId: activeTabId,
            handleActiveTabChange: handleActiveTabChange,
            resetToPreviousTab: resetToPreviousTab
        };
        $[31] = activeTabId;
        $[32] = handleActiveTabChange;
        $[33] = resetToPreviousTab;
        $[34] = t10;
    } else t10 = $[34];
    const memoizedValue = t10;
    let t11;
    if ($[35] !== activeTabId || $[36] !== handleActiveTabChange || $[37] !== memoizedValue || $[38] !== resetToPreviousTab) {
        t11 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) === true ? memoizedValue : {
            activeTabId: activeTabId,
            handleActiveTabChange: handleActiveTabChange,
            resetToPreviousTab: resetToPreviousTab
        };
        $[35] = activeTabId;
        $[36] = handleActiveTabChange;
        $[37] = memoizedValue;
        $[38] = resetToPreviousTab;
        $[39] = t11;
    } else t11 = $[39];
    const value = t11;
    let t12;
    if ($[40] !== children || $[41] !== value) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bfedffef2e76c2c$export$1f821a7525912239).Provider, {
            value: value
        }, children);
        $[40] = children;
        $[41] = value;
        $[42] = t12;
    } else t12 = $[42];
    return t12;
} : ({ currentConversationId: currentConversationId, children: children, miniModalShellRef: miniModalShellRef, captureShellHeightOnTabChange: captureShellHeightOnTabChange = false, onShellHeightCapture: onShellHeightCapture, selectedAgentId: selectedAgentId })=>{
    const [{ activeTabId: activeTabIdRaw, previousTabId: previousTabIdRaw, lastTabConversationId: lastTabConversationId }] = (0, $bGNkz.useActiveTabSelector)();
    const { setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId } = (0, $bGNkz.useUIStoreActions)();
    const activeTabId = activeTabIdRaw;
    const previousTabId = previousTabIdRaw;
    // Reads and reports the shell height. The boolean guard is checked at the
    // call site so this callback's identity stays stable across prop changes.
    const captureShellHeight = (0, $cozmU.useCallback)((fromTabId)=>{
        if (!onShellHeightCapture) return;
        const h = $8f18edf7c8a3493e$var$readMiniModalShellHeightPx(miniModalShellRef);
        if (h !== null) onShellHeightCapture(fromTabId, h);
    }, [
        onShellHeightCapture,
        miniModalShellRef
    ]);
    const handleActiveTabChange = (0, $cozmU.useCallback)((tabId)=>{
        if (tabId !== (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3) && tabId !== (0, $eef113145ca4ccce$export$a6818377be660b14)) return;
        if (captureShellHeightOnTabChange) // Capture the height of the tab we're leaving before switching
        captureShellHeight(activeTabId);
        // Save the tab being left so `resetToPreviousTab()` can restore it later.
        // Prior to this, `previousTabId` was only written by the auto-switch effects
        // (conversation-created / agent-selected) — meaning a user manually clicking
        // between tabs left `previousTabId` stale. That broke back-navigation from
        // space launches that originated via manual tab clicks (For You → space
        // landing → back would land on Suggestions because `previousTabId` still
        // held its default 'suggestions'). Writing it on every user-initiated tab
        // change keeps the invariant "the tab I was on before the current one" true.
        if (tabId !== activeTabId) setPreviousTabId(activeTabId);
        setActiveTabId(tabId);
    }, [
        captureShellHeight,
        captureShellHeightOnTabChange,
        setActiveTabId,
        setPreviousTabId,
        activeTabId
    ]);
    const resetToPreviousTab = (0, $cozmU.useCallback)(()=>{
        if (captureShellHeightOnTabChange) captureShellHeight(activeTabId);
        setActiveTabId(previousTabId);
    }, [
        captureShellHeight,
        captureShellHeightOnTabChange,
        setActiveTabId,
        previousTabId,
        activeTabId
    ]);
    // When a conversation becomes active (e.g. via Daily Brief CTA),
    // save the current tab so we can restore it on back navigation,
    // then switch to Suggestions so the mini-modal chat input is available.
    (0, $cozmU.useEffect)(()=>{
        if (currentConversationId === lastTabConversationId) return;
        setLastTabConversationId(currentConversationId);
        if (currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) {
            setPreviousTabId(activeTabId);
            setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
        }
    }, [
        currentConversationId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // When the user selects a non-default agent while on the For You tab,
    // switch back to Suggestions so the agent greeting is visible.
    // Save the current tab so it can be restored when the agent is deselected.
    (0, $cozmU.useEffect)(()=>{
        if (selectedAgentId) {
            setPreviousTabId(activeTabId);
            setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
        }
    }, [
        selectedAgentId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            activeTabId: activeTabId,
            handleActiveTabChange: handleActiveTabChange,
            resetToPreviousTab: resetToPreviousTab
        }), [
        activeTabId,
        handleActiveTabChange,
        resetToPreviousTab
    ]);
    const value = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true ? memoizedValue : {
        activeTabId: activeTabId,
        handleActiveTabChange: handleActiveTabChange,
        resetToPreviousTab: resetToPreviousTab
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bfedffef2e76c2c$export$1f821a7525912239).Provider, {
        value: value
    }, children);
};












var $aRGok = parcelRequire("aRGok");





var $5bVzv = parcelRequire("5bVzv");





const $79d26fb07b302949$export$b00f37bb31d8d793 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("b68JT")).then(({ RovoAgentDebugModal: RovoAgentDebugModal })=>({
            default: RovoAgentDebugModal
        })));









var $kBr4q = parcelRequire("kBr4q");


var $igyuJ = parcelRequire("igyuJ");

const $9e707e902fd673b1$export$a665115052767fd4 = (0, $kBr4q.createHook)((0, $igyuJ.store));











const $be30eedcd71718d5$export$63ab9e0e034c881 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, conversationId: conversationId, messageId: messageId })=>{
    const { refetch: refetch } = (0, $5SS4O.useQuery)({
        queryKey: [
            'debugLogs',
            conversationId
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_DEBUG_MODAL_DATA,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_DEBUG_MODAL_DATA
            });
            const response = await assistanceService.getConversationDebugLogs(conversationId);
            const messageData = response.find((message)=>'id' in message && message.id === messageId);
            return messageData;
        },
        enabled: false,
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_DEBUG_MODAL_DATA
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_DEBUG_MODAL_DATA,
                error: error
            });
        }
    });
    return refetch;
});


const $d7b9d3550aa1d7ec$export$5e9fd08c176f87fa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(15);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            touchpointSource: "debug-modal-contents"
        };
        $[0] = t0;
    } else t0 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t0);
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const [t1, t2] = (0, $9e707e902fd673b1$export$a665115052767fd4)();
    const { isOpen: isOpen, data: data } = t1;
    const { closeModal: closeModal } = t2;
    const t3 = data?.conversationId ?? "";
    const t4 = data?.messageId ?? "";
    let t5;
    if ($[1] !== assistanceServiceParams || $[2] !== t3 || $[3] !== t4) {
        t5 = {
            conversationId: t3,
            messageId: t4,
            assistanceServiceParams: assistanceServiceParams
        };
        $[1] = assistanceServiceParams;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    const debugLogsService = (0, $be30eedcd71718d5$export$63ab9e0e034c881)(t5);
    let t6;
    if ($[5] !== siteId) {
        t6 = {
            siteId: siteId,
            source: "chat-header"
        };
        $[5] = siteId;
        $[6] = t6;
    } else t6 = $[6];
    const { onViewAgentFullProfile: onViewAgentFullProfile } = (0, $5bVzv.useAgentUrlActions)(t6);
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== closeModal || $[9] !== debugLogsService || $[10] !== isOpen || $[11] !== onViewAgentFullProfile) {
        t8 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79d26fb07b302949$export$b00f37bb31d8d793), {
            source: "ai-mate-conversation-assistant-debug-modal",
            debugLogService: debugLogsService,
            onViewAgent: (authorId)=>onViewAgentFullProfile(authorId),
            onClose: closeModal
        });
        $[8] = closeModal;
        $[9] = debugLogsService;
        $[10] = isOpen;
        $[11] = onViewAgentFullProfile;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "conversation-assistant-agent-debug-modal-suspense",
            fallback: t7
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t8));
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    return t9;
} : ()=>{
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'debug-modal-contents'
    });
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const [{ isOpen: isOpen, data: data }, { closeModal: closeModal }] = (0, $9e707e902fd673b1$export$a665115052767fd4)();
    const debugLogsService = (0, $be30eedcd71718d5$export$63ab9e0e034c881)({
        conversationId: data?.conversationId ?? '',
        messageId: data?.messageId ?? '',
        assistanceServiceParams: assistanceServiceParams
    });
    const { onViewAgentFullProfile: onViewAgentFullProfile } = (0, $5bVzv.useAgentUrlActions)({
        siteId: siteId,
        source: 'chat-header'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-agent-debug-modal-suspense",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79d26fb07b302949$export$b00f37bb31d8d793), {
        source: "ai-mate-conversation-assistant-debug-modal",
        debugLogService: debugLogsService,
        onViewAgent: (authorId)=>onViewAgentFullProfile(authorId),
        onClose: closeModal
    })));
};












var $fRQ3t = parcelRequire("fRQ3t");








var $bltJZ = parcelRequire("bltJZ");


var $a2bT0 = parcelRequire("a2bT0");













const $96d19dda060f2176$export$89267176c0f41dba = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Map();
        $[0] = t0;
    } else t0 = $[0];
    const cacheRef = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (agentName)=>cacheRef.current.get(agentName) || null;
        $[1] = t1;
    } else t1 = $[1];
    const get = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (agentName_0, faviconUrl)=>{
            cacheRef.current.set(agentName_0, faviconUrl);
        };
        $[2] = t2;
    } else t2 = $[2];
    const set = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            cacheRef.current.clear();
        };
        $[3] = t3;
    } else t3 = $[3];
    const clear = t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (agentName_1)=>{
            cacheRef.current.delete(agentName_1);
        };
        $[4] = t4;
    } else t4 = $[4];
    const deleteAgent = t4;
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            get: get,
            set: set,
            clear: clear,
            delete: deleteAgent
        };
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ()=>{
    const cacheRef = (0, $cozmU.useRef)(new Map());
    /**
   * Get cached favicon URL for an agent by name
   */ const get = (0, $cozmU.useCallback)((agentName)=>{
        return cacheRef.current.get(agentName) || null;
    }, []);
    /**
   * Set cached favicon URL for an agent by name
   */ const set = (0, $cozmU.useCallback)((agentName_0, faviconUrl)=>{
        cacheRef.current.set(agentName_0, faviconUrl);
    }, []);
    /**
   * Clear all cached favicons
   */ const clear = (0, $cozmU.useCallback)(()=>{
        cacheRef.current.clear();
    }, []);
    /**
   * Remove a specific agent's favicon from cache by name
   */ const deleteAgent = (0, $cozmU.useCallback)((agentName_1)=>{
        cacheRef.current.delete(agentName_1);
    }, []);
    return {
        get: get,
        set: set,
        clear: clear,
        delete: deleteAgent
    };
};


// Observer component for RovoIcon rendering
const $e70d543a73f5bd2d$var$RovoIconObserver = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onLoad: onLoad } = t0;
    let t1;
    let t2;
    if ($[0] !== onLoad) {
        t1 = ()=>{
            onLoad();
        };
        t2 = [
            onLoad
        ];
        $[0] = onLoad;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ onLoad: onLoad })=>{
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};
// Create favicon by rendering RovoIcon off-screen for the default agent
const $e70d543a73f5bd2d$var$createRovoIconFavicon = async ()=>{
    return new Promise((resolve, reject)=>{
        const document = (0, $1hQ0e.getDocument)();
        if (!document) {
            reject(new Error('Document not available'));
            return;
        }
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px';
        container.style.top = '-9999px';
        container.style.width = '32px';
        container.style.height = '32px';
        document.body.appendChild(container);
        const cleanup = ()=>{
            try {
                if (root) root.unmount();
                if (document.body.contains(container)) document.body.removeChild(container);
            } catch (e) {
            // Expected cleanup errors - silently continue
            }
        };
        const handleRenderComplete = ()=>{
            try {
                const svgElement = container.querySelector('svg');
                if (svgElement) {
                    const svgData = new XMLSerializer().serializeToString(svgElement);
                    const svgBlob = new Blob([
                        svgData
                    ], {
                        type: 'image/svg+xml;charset=utf-8'
                    });
                    const svgUrl = URL.createObjectURL(svgBlob);
                    const img = new Image();
                    const canvas = document.createElement('canvas');
                    canvas.width = 32;
                    canvas.height = 32;
                    const ctx = canvas.getContext('2d');
                    img.onload = ()=>{
                        if (ctx) {
                            ctx.drawImage(img, 0, 0, 32, 32);
                            URL.revokeObjectURL(svgUrl);
                            cleanup();
                            resolve(canvas.toDataURL('image/png'));
                        }
                    };
                    img.src = svgUrl;
                } else {
                    cleanup();
                    const exception = new Error('No SVG found for RovoIcon');
                    (0, $hlvTd.logException)({
                        exception: exception,
                        name: 'NoSVGFoundForRovoIcon',
                        tags: {
                            component: 'AgentFavicon'
                        }
                    });
                    reject(exception);
                }
            } catch (error) {
                cleanup();
                const exception = new Error('Failed to create RovoIcon favicon');
                (0, $hlvTd.logException)({
                    exception: exception,
                    name: 'FailedToCreateRovoIconFavicon',
                    tags: {
                        component: 'AgentFavicon'
                    }
                });
                reject(error);
            }
        };
        const root = (0, $fRQ3t.createRoot)(container);
        root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e70d543a73f5bd2d$var$RovoIconObserver, {
            onLoad: handleRenderComplete
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            size: "medium"
        })));
    });
};
// Create favicon by rendering GeneratedAvatar off-screen and extracting its visual output
const $e70d543a73f5bd2d$var$createAgentFaviconFromGeneratedAvatar = async (agent, cache, pageTitle)=>{
    // Check cache first
    const agentName = agent.name;
    const cachedFavicon = cache.get(agentName);
    if (cachedFavicon) return cachedFavicon;
    // Create a promise that resolves when the avatar is rendered
    return new Promise((resolve, reject)=>{
        // If agent has an icon URL, use it directly
        if (agent.icon) {
            const faviconUrl = agent.icon;
            cache.set(agentName, faviconUrl);
            resolve(faviconUrl);
            return;
        }
        // Special handling for default Rovo agent
        if (agent.is_default && agent.creator_type === 'SYSTEM' || !agent) {
            $e70d543a73f5bd2d$var$createRovoIconFavicon().then((faviconUrl)=>{
                cache.set(agentName, faviconUrl);
                resolve(faviconUrl);
            }).catch(reject);
            return;
        }
        // Create off-screen container
        const document = (0, $1hQ0e.getDocument)();
        if (!document) throw new Error('Document not available');
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px';
        container.style.top = '-9999px';
        container.style.width = '32px';
        container.style.height = '32px';
        container.style.overflow = 'hidden';
        document.body.appendChild(container);
        const timeout = setTimeout(()=>{
            cleanup();
            reject(new Error('Timeout'));
        }, 5000);
        const cleanup = ()=>{
            try {
                if (root) root.unmount();
                if (document.body.contains(container)) document.body.removeChild(container);
            } catch (e) {
            // Expected cleanup errors - silently continue
            }
        };
        // Render GeneratedAvatar with proper context
        const root = (0, $fRQ3t.createRoot)(container);
        // Render the component and wait for it to complete
        root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2bT0.GeneratedAvatar), {
            agentNamedId: agent.external_config_reference || agent.named_id,
            agentId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "medium",
            onLoad: async ()=>{
                try {
                    const faviconUrl = await $e70d543a73f5bd2d$var$extractFaviconFromContainer(container);
                    clearTimeout(timeout);
                    cleanup();
                    // Cache the generated favicon
                    if (faviconUrl) cache.set(agentName, faviconUrl);
                    resolve(faviconUrl);
                } catch (error) {
                    clearTimeout(timeout);
                    cleanup();
                    reject(error);
                }
            }
        })));
    });
};
// Extract favicon from the rendered AgentAvatar container
const $e70d543a73f5bd2d$var$extractFaviconFromContainer = async (container)=>{
    // Look for an img element first (for agents with icon URLs)
    const imgElement = container.querySelector('img');
    if (imgElement && imgElement.src && imgElement.complete) {
        // If it's an external URL (not data:), we need to convert it to avoid CORS issues
        if (!imgElement.src.startsWith('data:')) try {
            const document = (0, $1hQ0e.getDocument)();
            if (!document) return imgElement.src; // Fall back to original URL
            const canvas = document.createElement('canvas');
            canvas.width = 32;
            canvas.height = 32;
            const ctx = canvas.getContext('2d');
            if (ctx) {
                // Draw the image to canvas
                ctx.drawImage(imgElement, 0, 0, 32, 32);
                return canvas.toDataURL('image/png');
            }
        } catch (e) {
        // Could not convert img to canvas, using src directly
        }
        return imgElement.src;
    }
    // Look for SVG element (for OOTB generated avatars)
    const svgElement = container.querySelector('svg');
    if (svgElement) {
        // Convert SVG to canvas
        const document = (0, $1hQ0e.getDocument)();
        if (!document) throw new Error('Document not available');
        const canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Could not get canvas context');
        // Create a data URL from the SVG
        const svgData = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([
            svgData
        ], {
            type: 'image/svg+xml;charset=utf-8'
        });
        const svgUrl = URL.createObjectURL(svgBlob);
        // Create an image from the SVG and draw it to canvas
        const img = new Image();
        return new Promise((resolve, reject)=>{
            let urlRevoked = false;
            const cleanup = ()=>{
                if (!urlRevoked) {
                    URL.revokeObjectURL(svgUrl);
                    urlRevoked = true;
                }
            };
            img.onload = ()=>{
                try {
                    // Scale the SVG to fit 32x32
                    ctx.drawImage(img, 0, 0, 32, 32);
                    cleanup();
                    resolve(canvas.toDataURL('image/png'));
                } catch (error) {
                    cleanup();
                    reject(error);
                }
            };
            img.onerror = ()=>{
                cleanup();
                reject(new Error('Failed to load SVG as image'));
            };
            img.src = svgUrl;
        });
    }
    // For generated avatars without SVG, extract the visual characteristics and recreate
    const avatarElement = container.querySelector('[data-testid*="avatar"], [class*="avatar"], div > div');
    if (avatarElement) {
        const computedStyle = window.getComputedStyle(avatarElement);
        const bgColor = computedStyle.backgroundColor || '#0052CC';
        const textContent = avatarElement.textContent?.trim()?.charAt(0)?.toUpperCase() || 'A';
        // Create canvas and draw the favicon
        const document = (0, $1hQ0e.getDocument)();
        if (!document) throw new Error('Document not available');
        const canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Could not get canvas context');
        // Draw background circle
        ctx.beginPath();
        ctx.arc(16, 16, 15, 0, 2 * Math.PI);
        ctx.fillStyle = bgColor;
        ctx.fill();
        // Draw text
        ctx.fillStyle = '#FFFFFF';
        ctx.font = 'bold 16px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(textContent, 16, 16);
        return canvas.toDataURL('image/png');
    }
    throw new Error('Could not extract favicon from container - no suitable elements found');
};
const $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon = async (cache)=>{
    try {
        const defaultAgentName = 'default-rovo-agent';
        // Check cache first
        const cachedFavicon = cache.get(defaultAgentName);
        if (cachedFavicon) {
            $e70d543a73f5bd2d$var$updateFavicon(cachedFavicon);
            return;
        }
        const rovoFaviconUrl = await $e70d543a73f5bd2d$var$createRovoIconFavicon();
        cache.set(defaultAgentName, rovoFaviconUrl);
        $e70d543a73f5bd2d$var$updateFavicon(rovoFaviconUrl);
    } catch (error) {
        $e70d543a73f5bd2d$var$setDefaultAtlassianFavicon();
    }
};
// Set favicon to default Atlassian logo
const $e70d543a73f5bd2d$var$setDefaultAtlassianFavicon = ()=>{
    try {
        const atlassianLogoUrl = '/assets/logos/atlassian-home-apple-touch-icon.png';
        $e70d543a73f5bd2d$var$updateFavicon(atlassianLogoUrl);
    } catch (error) {
        // Fallback to browser default favicon by clearing all agent favicons
        $e70d543a73f5bd2d$var$updateFavicon('');
        (0, $hlvTd.logException)({
            exception: error,
            name: 'FailedToSetDefaultAtlassianFavicon',
            tags: {
                component: 'AgentFavicon'
            }
        });
    }
};
const $e70d543a73f5bd2d$var$updateFavicon = (faviconUrl)=>{
    const document = (0, $1hQ0e.getDocument)();
    if (!document) return; // Skip favicon updates in SSR or when document is not available
    if (!faviconUrl) {
        // Remove any existing agent-specific favicons
        const existingLinks = document.querySelectorAll("link[rel*='icon'][data-agent-favicon]");
        existingLinks.forEach((link)=>link.remove());
        return;
    }
    try {
        // Remove any existing favicon links
        const existingLinks = document.querySelectorAll("link[rel*='icon']");
        existingLinks.forEach((link)=>link.remove());
        // Create new favicon link
        const link = document.createElement('link');
        link.type = 'image/png';
        link.rel = 'icon';
        link.href = faviconUrl;
        link.setAttribute('data-agent-favicon', 'true');
        document.getElementsByTagName('head')[0].appendChild(link);
        // Also create shortcut icon for better browser support
        const shortcutLink = document.createElement('link');
        shortcutLink.type = 'image/png';
        shortcutLink.rel = 'shortcut icon';
        shortcutLink.href = faviconUrl;
        shortcutLink.setAttribute('data-agent-favicon', 'true');
        document.getElementsByTagName('head')[0].appendChild(shortcutLink);
    } catch (error) {
        (0, $hlvTd.logException)({
            exception: error,
            name: 'FailedToUpdateFavicon',
            tags: {
                component: 'AgentFavicon'
            }
        });
        return;
    }
};
const $e70d543a73f5bd2d$export$7550661a55336d56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { selectedAgent: selectedAgent, currentConversationId: currentConversationId } = t0;
    const prevAgentRef = (0, $cozmU.useRef)(null);
    const cache = (0, $96d19dda060f2176$export$89267176c0f41dba)();
    let t1;
    if ($[0] !== cache || $[1] !== selectedAgent) {
        t1 = ()=>{
            if (!selectedAgent) {
                $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon(cache);
                return;
            }
            const agentChanged = prevAgentRef.current?.id !== selectedAgent.id;
            if (!agentChanged) return;
            prevAgentRef.current = selectedAgent;
            $e70d543a73f5bd2d$var$createAgentFaviconFromGeneratedAvatar(selectedAgent, cache).then((generatedFaviconUrl)=>{
                if (generatedFaviconUrl) $e70d543a73f5bd2d$var$updateFavicon(generatedFaviconUrl);
                else $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon(cache);
            }).catch((error)=>{
                $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon(cache);
            });
        };
        $[0] = cache;
        $[1] = selectedAgent;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== cache || $[4] !== currentConversationId || $[5] !== selectedAgent) {
        t2 = [
            selectedAgent,
            currentConversationId,
            cache
        ];
        $[3] = cache;
        $[4] = currentConversationId;
        $[5] = selectedAgent;
        $[6] = t2;
    } else t2 = $[6];
    (0, $cozmU.useEffect)(t1, t2);
} : ({ selectedAgent: selectedAgent, currentConversationId: currentConversationId })=>{
    const prevAgentRef = (0, $cozmU.useRef)(null);
    const cache = (0, $96d19dda060f2176$export$89267176c0f41dba)();
    // Generate favicon URL by rendering AgentAvatar
    (0, $cozmU.useEffect)(()=>{
        if (!selectedAgent) {
            $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon(cache);
            return;
        }
        // Only regenerate if the agent actually changed
        const agentChanged = prevAgentRef.current?.id !== selectedAgent.id;
        if (!agentChanged) return;
        prevAgentRef.current = selectedAgent;
        $e70d543a73f5bd2d$var$createAgentFaviconFromGeneratedAvatar(selectedAgent, cache).then((generatedFaviconUrl)=>{
            if (generatedFaviconUrl) $e70d543a73f5bd2d$var$updateFavicon(generatedFaviconUrl);
            else // default Rovo icon
            $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon(cache);
        }).catch((error)=>{
            // within this catch try to set to rovo and if fails then set to default Atlassian
            $e70d543a73f5bd2d$var$createRovoIconAndSetAsFavicon(cache);
        });
    }, [
        selectedAgent,
        currentConversationId,
        cache
    ]);
    return undefined;
};















var $7rd1R = parcelRequire("7rd1R");


var $6rwn6 = parcelRequire("6rwn6");






















const $3084e29142635054$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        isOpen: false
    },
    name: 'AgentModalStore',
    actions: {
        openAgentModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        closeAgentModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    }
});


const $7cda85dca3247264$export$d9b7333a9bf73397 = (0, $kBr4q.createHook)((0, $3084e29142635054$export$6f57813fe9f31bf9));





const $e4186f3d50a4f7ba$export$9e01ca19610ab51c = ()=>{
    (0, $6cFsl.di)((0, $7cda85dca3247264$export$d9b7333a9bf73397), (0, $iDrrr.fg));
    const [{ isOpen: isOpen }, { closeAgentModal: closeAgentModal }] = (0, $7cda85dca3247264$export$d9b7333a9bf73397)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'agentModal'
    });
    const { createConversationOptimistically: createConversationOptimistically, sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const handleClickChat = (0, $cozmU.useCallback)((agent)=>{
        createConversationOptimistically({
            sourceAgentId: agent.id
        });
        if (!fullScreen) setActiveMenu('none');
        closeAgentModal();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'agentModal',
            actionSubjectId: 'agentCard'
        });
    }, [
        createConversationOptimistically,
        fullScreen,
        closeAgentModal,
        sendAnalyticsEvent,
        setActiveMenu
    ]);
    const handleClickConversationStarter = (0, $cozmU.useCallback)((agent_0, conversationStarter)=>{
        createConversationOptimistically({
            sourceAgentId: agent_0.id
        });
        sendMessage({
            agent: agent_0,
            prompt: (0, $6rwn6.encodeAdf)(conversationStarter.message),
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages,
            messageSources: {
                interactionSource: 'viewAgentConversationStarters',
                followUpSource: 'ai-mate'
            }
        });
    }, [
        createConversationOptimistically,
        sendMessage,
        storeUserMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7rd1R.BrowseAgentsModal), {
        onClose: closeAgentModal,
        siteId: assistanceServiceParams.siteId,
        onClickChat: handleClickChat,
        handleClickConversationStarter: handleClickConversationStarter,
        assistanceServiceParams: assistanceServiceParams
    }));
};


















var $8xxUz = parcelRequire("8xxUz");































const $123d2d3c26774d3f$var$message = (0, $kSwu1.defineMessages)({
    closeButton: {
        id: "ai-mate.browse-agents-view.close-button",
        defaultMessage: "Close agents view"
    },
    headerTitle: {
        id: "ai-mate.browse-agents-view.header-title",
        defaultMessage: "Browse agents"
    }
});
var $123d2d3c26774d3f$export$2e2bcd8739ae039 = $123d2d3c26774d3f$var$message;


const $4e7f717cb93b2c30$export$aa7b1f2c2cce452b = ({ chatRefreshHeader: chatRefreshHeader })=>{
    (0, $6cFsl.di)((0, $7rd1R.BrowseAgentsFullscreen));
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { fullScreen: fullScreen, elements: elements } = (0, $dSCNl.useUIConfig)();
    const { siteId: siteId, closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'browse-agents-panel'
    });
    const [_, { resetBrowseAgentsUI: resetBrowseAgentsUI }] = (0, $8xxUz.useBrowseAgentsUIStore)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { createConversationOptimistically: createConversationOptimistically, sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            resetBrowseAgentsUI();
        };
    }, [
        resetBrowseAgentsUI
    ]);
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatBrowseAgents'
        });
    // Should only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClose = (0, $cozmU.useCallback)(({ resetActiveMenu: resetActiveMenu = true } = {})=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'agentsViewCloseButton'
        });
        if (resetActiveMenu) setActiveMenu('none');
        resetBrowseAgentsUI();
        closeChat();
    }, [
        setActiveMenu,
        resetBrowseAgentsUI,
        sendAnalyticsEvent,
        closeChat
    ]);
    const handleAgentChat = (0, $cozmU.useCallback)((agent)=>{
        createConversationOptimistically({
            sourceAgentId: agent.id
        });
        setActiveMenu('none');
    }, [
        setActiveMenu,
        createConversationOptimistically
    ]);
    const handleConversationStarter = (0, $cozmU.useCallback)((agent, conversationStarter)=>{
        setActiveMenu('none');
        resetBrowseAgentsUI();
        createConversationOptimistically({
            sourceAgentId: agent.id
        });
        sendMessage({
            agent: agent,
            prompt: (0, $6rwn6.encodeAdf)(conversationStarter.message),
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages,
            messageSources: {
                interactionSource: 'viewAgentConversationStarters',
                followUpSource: 'ai-mate'
            }
        });
    }, [
        createConversationOptimistically,
        sendMessage,
        storeUserMessages,
        resetBrowseAgentsUI,
        setActiveMenu
    ]);
    if (fullScreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, !!elements?.forceFullscreenHeader && chatRefreshHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7rd1R.BrowseAgentsFullscreen), {
        siteId: siteId,
        onClickChat: handleAgentChat,
        handleClickConversationStarter: handleConversationStarter,
        assistanceServiceParams: assistanceServiceParams
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7rd1R.BrowseAgentsSidebar), {
        chatRefreshHeader: chatRefreshHeader,
        onClose: ()=>handleClose(),
        siteId: siteId,
        onClickChat: handleAgentChat,
        handleClickConversationStarter: handleConversationStarter,
        assistanceServiceParams: assistanceServiceParams,
        singleColumn: !fullScreen,
        titleElement: fullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium",
            as: "h2"
        }, formatMessage((0, $123d2d3c26774d3f$export$2e2bcd8739ae039).headerTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, $123d2d3c26774d3f$export$2e2bcd8739ae039).headerTitle))
    });
};


















var $gzMZq = parcelRequire("gzMZq");



















var $1sCHt = parcelRequire("1sCHt");





var $6OpMl = parcelRequire("6OpMl");

















var $dovdS = parcelRequire("dovdS");



















var $lfoFx = parcelRequire("lfoFx");


























var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $6TaGl = parcelRequire("6TaGl");





var $4n1IT = parcelRequire("4n1IT");













var $g3RoK = parcelRequire("g3RoK");


var $hq9Cp = parcelRequire("hq9Cp");


var $6gGPb = parcelRequire("6gGPb");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");


var $9GVkD = parcelRequire("9GVkD");




function $39042d5343910bf7$export$c3ada257199e2c2a(conversation, isUnread) {
    const { currentTask: currentTask, lastAgentMessageStatus: lastAgentMessageStatus } = conversation;
    if (currentTask) return $39042d5343910bf7$export$2ae9604c91bcacc1(currentTask.status, isUnread);
    if (lastAgentMessageStatus === 'IN_PROGRESS') return 'loading';
    if (lastAgentMessageStatus === 'FAILED') return 'error';
    // 'CANCELLED' (user-initiated Stop) intentionally returns undefined.
    return undefined;
}
function $39042d5343910bf7$export$ad77583906430cd3(taskStatus) {
    return taskStatus === 'AWAITING_DISAMBIGUATION' || taskStatus === 'AWAITING_PLAN_CONFIRMATION' || taskStatus === 'AWAITING_ACTION_CONFIRMATION';
}
function $39042d5343910bf7$export$b9930f0f61f0a6(taskStatus) {
    return taskStatus === 'DRAFT' || taskStatus === 'QUEUED' || taskStatus === 'RUNNING';
}
function $39042d5343910bf7$export$2ae9604c91bcacc1(taskStatus, isUnread) {
    if ($39042d5343910bf7$export$b9930f0f61f0a6(taskStatus)) return 'loading';
    switch(taskStatus){
        case 'AWAITING_DISAMBIGUATION':
        case 'AWAITING_PLAN_CONFIRMATION':
        case 'AWAITING_ACTION_CONFIRMATION':
            return 'info';
        case 'COMPLETED':
            return isUnread ? 'success' : undefined;
        case 'FAILED':
            return 'error';
        default:
            return undefined;
    }
}

















const $680324bca057d738$var$message = (0, $kSwu1.defineMessages)({
    yesterday: {
        id: "ai-mate.date-time-utils.time.yesterday",
        defaultMessage: "Yesterday"
    },
    now: {
        id: "ai-mate.date-time-utils.time.now",
        defaultMessage: "Just now"
    }
});
var $680324bca057d738$export$2e2bcd8739ae039 = $680324bca057d738$var$message;


const $ae8705a2e8335756$var$SECONDS_IN_MIN = 60;
const $ae8705a2e8335756$var$SECONDS_IN_HR = $ae8705a2e8335756$var$SECONDS_IN_MIN * 60;
const $ae8705a2e8335756$var$SECONDS_IN_DAY = $ae8705a2e8335756$var$SECONDS_IN_HR * 24;
const $ae8705a2e8335756$var$SECONDS_IN_WEEK = $ae8705a2e8335756$var$SECONDS_IN_DAY * 7;
const $ae8705a2e8335756$var$SECONDS_IN_MONTH = $ae8705a2e8335756$var$SECONDS_IN_DAY * 30;
const $ae8705a2e8335756$export$e7677c07caaad319 = ()=>{
    if (typeof window === 'undefined') return;
    try {
        return window.origin;
    } catch  {
        return undefined;
    }
};
const $ae8705a2e8335756$export$9051e20aaf97bc82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isoDate)=>{
    const $ = (0, $bDgLe.c)(6);
    const { formatDate: formatDate, formatTime: formatTime } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatDate || $[1] !== isoDate) {
        t0 = formatDate(isoDate, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
        $[0] = formatDate;
        $[1] = isoDate;
        $[2] = t0;
    } else t0 = $[2];
    const date = t0;
    let t1;
    if ($[3] !== formatTime || $[4] !== isoDate) {
        t1 = formatTime(isoDate, {
            hour: "2-digit",
            hour12: true,
            minute: "numeric"
        });
        $[3] = formatTime;
        $[4] = isoDate;
        $[5] = t1;
    } else t1 = $[5];
    const time = t1;
    return `${date} ${time}`;
} : (isoDate)=>{
    const { formatDate: formatDate, formatTime: formatTime } = (0, $kSwu1.useIntl)();
    const date = formatDate(isoDate, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    const time = formatTime(isoDate, {
        hour: '2-digit',
        hour12: true,
        minute: 'numeric'
    });
    return `${date} ${time}`;
};
const $ae8705a2e8335756$export$89068eaab1fdf9be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { isoDate: isoDate, relativeTimeStyle: t1, useAbbreviation: t2 } = t0;
    const relativeTimeStyle = t1 === undefined ? "narrow" : t1;
    const useAbbreviation = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage, formatRelativeTime: formatRelativeTime } = (0, $kSwu1.useIntl)();
    const parsedDate = $ae8705a2e8335756$export$9051e20aaf97bc82(isoDate || "");
    let t3;
    if ($[0] !== formatRelativeTime || $[1] !== relativeTimeStyle || $[2] !== useAbbreviation) {
        t3 = (value, unit)=>formatRelativeTime(useAbbreviation ? value : -value, unit, {
                style: relativeTimeStyle
            });
        $[0] = formatRelativeTime;
        $[1] = relativeTimeStyle;
        $[2] = useAbbreviation;
        $[3] = t3;
    } else t3 = $[3];
    const formatRelativeTimeValue = t3;
    if (!isoDate) {
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                updateInterval: "stop"
            };
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    const t4 = Date.now();
    let t5;
    if ($[5] !== isoDate) {
        t5 = new Date(isoDate).getTime();
        $[5] = isoDate;
        $[6] = t5;
    } else t5 = $[6];
    const secondsSinceUpdate = Math.floor((t4 - t5) / 1000);
    const totalMinutes = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_MIN);
    const totalHours = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_HR);
    const totalDays = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_DAY);
    const totalWeeks = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_WEEK);
    const totalMonths = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_MONTH);
    if (totalHours <= 24) {
        if (totalMinutes < 1) {
            let t6;
            if ($[7] !== formatMessage) {
                t6 = formatMessage((0, $680324bca057d738$export$2e2bcd8739ae039).now);
                $[7] = formatMessage;
                $[8] = t6;
            } else t6 = $[8];
            let t7;
            if ($[9] !== t6) {
                t7 = {
                    updateInterval: "m",
                    value: t6
                };
                $[9] = t6;
                $[10] = t7;
            } else t7 = $[10];
            return t7;
        }
        if (totalMinutes >= 1 && totalMinutes < 60) {
            let t6;
            if ($[11] !== formatRelativeTimeValue || $[12] !== totalMinutes) {
                t6 = formatRelativeTimeValue(totalMinutes, "minute");
                $[11] = formatRelativeTimeValue;
                $[12] = totalMinutes;
                $[13] = t6;
            } else t6 = $[13];
            let t7;
            if ($[14] !== t6) {
                t7 = {
                    updateInterval: "m",
                    value: t6
                };
                $[14] = t6;
                $[15] = t7;
            } else t7 = $[15];
            return t7;
        }
        if (totalHours >= 1 && totalHours < 24) {
            let t6;
            if ($[16] !== formatRelativeTimeValue || $[17] !== totalHours) {
                t6 = formatRelativeTimeValue(totalHours, "hour");
                $[16] = formatRelativeTimeValue;
                $[17] = totalHours;
                $[18] = t6;
            } else t6 = $[18];
            let t7;
            if ($[19] !== t6) {
                t7 = {
                    updateInterval: "h",
                    value: t6
                };
                $[19] = t6;
                $[20] = t7;
            } else t7 = $[20];
            return t7;
        }
    }
    if (totalDays === 1) {
        let t6;
        if ($[21] !== formatMessage) {
            t6 = formatMessage((0, $680324bca057d738$export$2e2bcd8739ae039).yesterday);
            $[21] = formatMessage;
            $[22] = t6;
        } else t6 = $[22];
        let t7;
        if ($[23] !== t6) {
            t7 = {
                updateInterval: "stop",
                value: t6
            };
            $[23] = t6;
            $[24] = t7;
        } else t7 = $[24];
        return t7;
    }
    if (totalDays >= 2 && totalDays < 7) {
        let t6;
        if ($[25] !== formatRelativeTimeValue || $[26] !== totalDays) {
            t6 = formatRelativeTimeValue(totalDays, "day");
            $[25] = formatRelativeTimeValue;
            $[26] = totalDays;
            $[27] = t6;
        } else t6 = $[27];
        let t7;
        if ($[28] !== t6) {
            t7 = {
                updateInterval: "stop",
                value: t6
            };
            $[28] = t6;
            $[29] = t7;
        } else t7 = $[29];
        return t7;
    }
    if (totalDays >= 7 && totalDays < 30) {
        let t6;
        if ($[30] !== formatRelativeTimeValue || $[31] !== totalWeeks) {
            t6 = formatRelativeTimeValue(totalWeeks, "week");
            $[30] = formatRelativeTimeValue;
            $[31] = totalWeeks;
            $[32] = t6;
        } else t6 = $[32];
        let t7;
        if ($[33] !== t6) {
            t7 = {
                updateInterval: "stop",
                value: t6
            };
            $[33] = t6;
            $[34] = t7;
        } else t7 = $[34];
        return t7;
    }
    if (totalDays >= 30 && totalDays < 365) {
        let t6;
        if ($[35] !== formatRelativeTimeValue || $[36] !== totalMonths) {
            t6 = formatRelativeTimeValue(totalMonths, "month");
            $[35] = formatRelativeTimeValue;
            $[36] = totalMonths;
            $[37] = t6;
        } else t6 = $[37];
        let t7;
        if ($[38] !== t6) {
            t7 = {
                updateInterval: "stop",
                value: t6
            };
            $[38] = t6;
            $[39] = t7;
        } else t7 = $[39];
        return t7;
    }
    let t6;
    if ($[40] !== parsedDate) {
        t6 = {
            updateInterval: "stop",
            value: parsedDate
        };
        $[40] = parsedDate;
        $[41] = t6;
    } else t6 = $[41];
    return t6;
} : ({ isoDate: isoDate, relativeTimeStyle: relativeTimeStyle = 'narrow', useAbbreviation: useAbbreviation = false })=>{
    const { formatMessage: formatMessage, formatRelativeTime: formatRelativeTime } = (0, $kSwu1.useIntl)();
    const parsedDate = $ae8705a2e8335756$export$9051e20aaf97bc82(isoDate || ''); // Call hook at top level
    // Helper to format relative time
    const formatRelativeTimeValue = (value, unit)=>{
        return formatRelativeTime(useAbbreviation ? value : -value, unit, {
            style: relativeTimeStyle
        });
    };
    if (!isoDate) return {
        updateInterval: 'stop'
    };
    const secondsSinceUpdate = Math.floor((Date.now() - new Date(isoDate).getTime()) / 1000);
    const totalMinutes = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_MIN);
    const totalHours = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_HR);
    const totalDays = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_DAY);
    const totalWeeks = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_WEEK);
    const totalMonths = Math.floor(secondsSinceUpdate / $ae8705a2e8335756$var$SECONDS_IN_MONTH);
    // relative time if less than 1 day
    if (totalHours <= 24) {
        if (totalMinutes < 1) return {
            updateInterval: 'm',
            value: formatMessage((0, $680324bca057d738$export$2e2bcd8739ae039).now)
        };
        if (totalMinutes >= 1 && totalMinutes < 60) return {
            updateInterval: 'm',
            value: formatRelativeTimeValue(totalMinutes, 'minute')
        };
        if (totalHours >= 1 && totalHours < 24) return {
            updateInterval: 'h',
            value: formatRelativeTimeValue(totalHours, 'hour')
        };
    }
    // Yesterday
    if (totalDays === 1) return {
        updateInterval: 'stop',
        value: formatMessage((0, $680324bca057d738$export$2e2bcd8739ae039).yesterday)
    };
    // X days ago (2-6 days)
    if (totalDays >= 2 && totalDays < 7) return {
        updateInterval: 'stop',
        value: formatRelativeTimeValue(totalDays, 'day')
    };
    // X weeks ago
    if (totalDays >= 7 && totalDays < 30) return {
        updateInterval: 'stop',
        value: formatRelativeTimeValue(totalWeeks, 'week')
    };
    // X months ago
    if (totalDays >= 30 && totalDays < 365) return {
        updateInterval: 'stop',
        value: formatRelativeTimeValue(totalMonths, 'month')
    };
    // date timestamp
    return {
        updateInterval: 'stop',
        value: parsedDate
    };
};


const $de4d3154ef5b0570$var$INTERVALS = {
    m: 60000,
    h: 3600000,
    stop: Infinity
};
function $de4d3154ef5b0570$export$6feb2ea55018719b({ isoDate: isoDate, relativeTimeStyle: relativeTimeStyle = 'narrow', useAbbreviation: useAbbreviation = false }) {
    const timeData = (0, $ae8705a2e8335756$export$89068eaab1fdf9be)({
        isoDate: isoDate,
        relativeTimeStyle: relativeTimeStyle,
        useAbbreviation: useAbbreviation
    });
    const [, forceUpdate] = (0, $cozmU.useState)({});
    const intervalRef = (0, $cozmU.useRef)();
    const isMountedRef = (0, $cozmU.useRef)(false);
    const updateTime = (0, $cozmU.useCallback)(()=>{
        if (isMountedRef.current) forceUpdate({});
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // don't set interval if 'stop'
        if (timeData.updateInterval === 'stop') return;
        intervalRef.current = setInterval(updateTime, $de4d3154ef5b0570$var$INTERVALS[timeData.updateInterval]);
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        updateTime,
        timeData.updateInterval
    ]);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
            clearInterval(intervalRef.current);
        };
    }, []);
    return timeData.value || '';
}





































var $iDtkd = parcelRequire("iDtkd");





var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");


var $kRZje = parcelRequire("kRZje");







const $520e2ba18024e43a$var$message = (0, $kSwu1.defineMessages)({
    success: {
        id: "ai-mate.loading-status-indicator.success",
        defaultMessage: "Success"
    },
    loading: {
        id: "ai-mate.loading-status-indicator.loading",
        defaultMessage: "Loading"
    },
    error: {
        id: "ai-mate.loading-status-indicator.error",
        defaultMessage: "Error"
    },
    info: {
        id: "ai-mate.loading-status-indicator.info",
        defaultMessage: "Information"
    },
    warning: {
        id: "ai-mate.loading-status-indicator.warning",
        defaultMessage: "Warning"
    },
    discovery: {
        id: "ai-mate.loading-status-indicator.discovery",
        defaultMessage: "Discovery"
    },
    todo: {
        id: "ai-mate.loading-status-indicator.todo",
        defaultMessage: "To do"
    }
});
var $520e2ba18024e43a$export$2e2bcd8739ae039 = $520e2ba18024e43a$var$message;


const $16197e1e18275c50$export$b4f88f0ca5784eef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { status: status, testId: testId, size: t1 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    switch(status){
        case "loading":
            {
                let t2;
                if ($[0] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).loading);
                    $[0] = formatMessage;
                    $[1] = t2;
                } else t2 = $[1];
                let t3;
                if ($[2] !== t2 || $[3] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                        size: "small",
                        label: t2,
                        testId: testId
                    });
                    $[2] = t2;
                    $[3] = testId;
                    $[4] = t3;
                } else t3 = $[4];
                return t3;
            }
        case "success":
            {
                let t2;
                if ($[5] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).success);
                    $[5] = formatMessage;
                    $[6] = t2;
                } else t2 = $[6];
                let t3;
                if ($[7] !== size || $[8] !== t2 || $[9] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                        label: t2,
                        size: size,
                        color: "var(--ds-icon-success, #6A9A23)",
                        testId: testId
                    });
                    $[7] = size;
                    $[8] = t2;
                    $[9] = testId;
                    $[10] = t3;
                } else t3 = $[10];
                return t3;
            }
        case "info":
            {
                let t2;
                if ($[11] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).info);
                    $[11] = formatMessage;
                    $[12] = t2;
                } else t2 = $[12];
                let t3;
                if ($[13] !== size || $[14] !== t2 || $[15] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                        label: t2,
                        size: size,
                        color: "var(--ds-text-information, #1558BC)",
                        testId: testId
                    });
                    $[13] = size;
                    $[14] = t2;
                    $[15] = testId;
                    $[16] = t3;
                } else t3 = $[16];
                return t3;
            }
        case "error":
            {
                let t2;
                if ($[17] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).error);
                    $[17] = formatMessage;
                    $[18] = t2;
                } else t2 = $[18];
                let t3;
                if ($[19] !== size || $[20] !== t2 || $[21] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        label: t2,
                        size: size,
                        color: "var(--ds-text-danger, #AE2E24)",
                        testId: testId
                    });
                    $[19] = size;
                    $[20] = t2;
                    $[21] = testId;
                    $[22] = t3;
                } else t3 = $[22];
                return t3;
            }
        case "warning":
            {
                let t2;
                if ($[23] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).warning);
                    $[23] = formatMessage;
                    $[24] = t2;
                } else t2 = $[24];
                let t3;
                if ($[25] !== size || $[26] !== t2 || $[27] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                        label: t2,
                        size: size,
                        color: "var(--ds-icon-warning, #E06C00)",
                        testId: testId
                    });
                    $[25] = size;
                    $[26] = t2;
                    $[27] = testId;
                    $[28] = t3;
                } else t3 = $[28];
                return t3;
            }
        case "discovery":
            {
                let t2;
                if ($[29] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).discovery);
                    $[29] = formatMessage;
                    $[30] = t2;
                } else t2 = $[30];
                let t3;
                if ($[31] !== size || $[32] !== t2 || $[33] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDtkd))), {
                        label: t2,
                        size: size,
                        color: "var(--ds-icon-discovery, #AF59E1)",
                        testId: testId
                    });
                    $[31] = size;
                    $[32] = t2;
                    $[33] = testId;
                    $[34] = t3;
                } else t3 = $[34];
                return t3;
            }
        case "to-do":
            {
                let t2;
                if ($[35] !== formatMessage) {
                    t2 = formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).todo);
                    $[35] = formatMessage;
                    $[36] = t2;
                } else t2 = $[36];
                let t3;
                if ($[37] !== size || $[38] !== t2 || $[39] !== testId) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kRZje))), {
                        label: t2,
                        size: size,
                        testId: testId
                    });
                    $[37] = size;
                    $[38] = t2;
                    $[39] = testId;
                    $[40] = t3;
                } else t3 = $[40];
                return t3;
            }
        default:
    }
} : ({ status: status, testId: testId, size: size = 'medium' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    switch(status){
        case 'loading':
            return /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: "small",
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).loading),
                testId: testId
            });
        case 'success':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).success),
                size: size,
                color: "var(--ds-icon-success, #6A9A23)",
                testId: testId
            });
        case 'info':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).info),
                size: size,
                color: "var(--ds-text-information, #1558BC)",
                testId: testId
            });
        case 'error':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).error),
                size: size,
                color: "var(--ds-text-danger, #AE2E24)",
                testId: testId
            });
        case 'warning':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).warning),
                size: size,
                color: "var(--ds-icon-warning, #E06C00)",
                testId: testId
            });
        case 'discovery':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDtkd))), {
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).discovery),
                size: size,
                color: "var(--ds-icon-discovery, #AF59E1)",
                testId: testId
            });
        case 'to-do':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kRZje))), {
                label: formatMessage((0, $520e2ba18024e43a$export$2e2bcd8739ae039).todo),
                size: size,
                testId: testId
            });
        // explicitly return nothing from default case.
        // This shouldn't happen since `status` is required, but it could if someone casts incorrectly or data is undefined from the server.
        default:
    }
};



var $6wOvs = parcelRequire("6wOvs");





const $a0580d32645a7c6b$var$message = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "conversation-assistant-ui-components.conversation-status-label.rovo-is-thinking.ai-non-final",
        defaultMessage: "Rovo is thinking..."
    },
    awaitingUserResponse: {
        id: "ai-mate.conversation-status-label.awaiting-user-response",
        defaultMessage: "Awaiting user response"
    },
    successStatusLabel: {
        id: "ai-mate.conversation-status-label.success",
        defaultMessage: "Done"
    },
    errorStatusLabel: {
        id: "ai-mate.conversation-status-label.error",
        defaultMessage: "Failed"
    }
});
var $a0580d32645a7c6b$export$2e2bcd8739ae039 = $a0580d32645a7c6b$var$message;


const $c5fb9783c4b6e9b4$var$styles = {
    shimmerTraceWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    notificationDot: "_0bjKvDS5Zs _39xV02Jg58 _0jFU0VJg58 _0KLXrukLmD",
    dotSmall: "_39xV02Zimw _0jFU0VZimw"
};
function $c5fb9783c4b6e9b4$var$statusToFooterMessage(status) {
    switch(status){
        case 'loading':
            return (0, $a0580d32645a7c6b$export$2e2bcd8739ae039).rovoIsThinking;
        case 'info':
            return (0, $a0580d32645a7c6b$export$2e2bcd8739ae039).awaitingUserResponse;
        case 'error':
            return (0, $a0580d32645a7c6b$export$2e2bcd8739ae039).errorStatusLabel;
        case 'success':
            return (0, $a0580d32645a7c6b$export$2e2bcd8739ae039).successStatusLabel;
        default:
            return null;
    }
} /** True when the footer should show task status copy (Done / FAILED / awaiting) beside the optional icon. */ 
function $c5fb9783c4b6e9b4$export$f13ad37e3a27f791(conversation) {
    const status = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, conversation.readStatus === false);
    return status && status !== 'loading' ? $c5fb9783c4b6e9b4$var$statusToFooterMessage(status) !== null : false;
} /** Status chip used in row `elemAfter` / controls: spinner, status icon, or unread dot. */ 
const $c5fb9783c4b6e9b4$export$88ead18fb18a2576 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConversationListRowStatusChip(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { conversation: conversation, showUnreadDot: t1, testId: testId } = t0;
    const showUnreadDot = t1 === undefined ? true : t1;
    const isUnread = conversation.readStatus === false;
    let t2;
    if ($[0] !== conversation || $[1] !== isUnread) {
        t2 = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, isUnread);
        $[0] = conversation;
        $[1] = isUnread;
        $[2] = t2;
    } else t2 = $[2];
    const status = t2;
    if (status) {
        let t3;
        if ($[3] !== status || $[4] !== testId) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16197e1e18275c50$export$b4f88f0ca5784eef), {
                status: status,
                size: "small",
                testId: testId
            });
            $[3] = status;
            $[4] = testId;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    if (isUnread && showUnreadDot) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $w6R6I.cx)($c5fb9783c4b6e9b4$var$styles.notificationDot, $c5fb9783c4b6e9b4$var$styles.dotSmall);
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== testId) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t3,
                testId: testId
            });
            $[7] = testId;
            $[8] = t4;
        } else t4 = $[8];
        return t4;
    }
    return null;
} : function ConversationListRowStatusChip({ conversation: conversation, showUnreadDot: showUnreadDot = true, testId: testId }) {
    const isUnread = conversation.readStatus === false;
    const status = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, isUnread);
    if (status) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16197e1e18275c50$export$b4f88f0ca5784eef), {
        status: status,
        size: "small",
        testId: testId
    });
    if (isUnread && showUnreadDot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c5fb9783c4b6e9b4$var$styles.notificationDot, $c5fb9783c4b6e9b4$var$styles.dotSmall),
        testId: testId
    });
    return null;
};
const $c5fb9783c4b6e9b4$export$80b5b1a1eb299c96 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConversationStatusLabel(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { conversation: conversation, showStatusIcon: t1 } = t0;
    const showStatusIcon = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    let t3;
    if ($[0] !== conversation || $[1] !== formatMessage || $[2] !== showStatusIcon) {
        t3 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const status = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, conversation.readStatus === false);
            const labelDescriptor = status ? $c5fb9783c4b6e9b4$var$statusToFooterMessage(status) : null;
            const isShimmering = status === "loading" || status === "info";
            if (!labelDescriptor) {
                t3 = null;
                break bb0;
            }
            let t4;
            if ($[5] !== conversation || $[6] !== showStatusIcon) {
                t4 = showStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5fb9783c4b6e9b4$export$88ead18fb18a2576, {
                    conversation: conversation,
                    showUnreadDot: false
                });
                $[5] = conversation;
                $[6] = showStatusIcon;
                $[7] = t4;
            } else t4 = $[7];
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050"
            }, t4, isShimmering ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $c5fb9783c4b6e9b4$var$styles.shimmerTraceWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
                size: "small",
                truncate: true
            }, formatMessage(labelDescriptor))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                weight: "regular",
                maxLines: 1,
                align: "start",
                color: "color.text.subtle"
            }, formatMessage(labelDescriptor)));
        }
        $[0] = conversation;
        $[1] = formatMessage;
        $[2] = showStatusIcon;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    if (t3 !== Symbol.for("react.early_return_sentinel")) return t3;
    return t2;
} : function ConversationStatusLabel({ conversation: conversation, showStatusIcon: showStatusIcon = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const status = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, conversation.readStatus === false);
    const labelDescriptor = status ? $c5fb9783c4b6e9b4$var$statusToFooterMessage(status) : null;
    const isShimmering = status === 'loading' || status === 'info';
    if (!labelDescriptor) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, showStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5fb9783c4b6e9b4$export$88ead18fb18a2576, {
        conversation: conversation,
        showUnreadDot: false
    }), isShimmering ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c5fb9783c4b6e9b4$var$styles.shimmerTraceWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
        size: "small",
        truncate: true
    }, formatMessage(labelDescriptor))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        maxLines: 1,
        align: "start",
        color: "color.text.subtle"
    }, formatMessage(labelDescriptor)));
};













const $08aaee4c987ae451$var$store = (0, $8s9DV.createStore)({
    initialState: {
        isOpen: false,
        conversation: {},
        mode: 'edit'
    },
    actions: {
        openModal: (conversation, mode)=>({ setState: setState })=>{
                setState({
                    isOpen: true,
                    conversation: conversation,
                    mode: mode
                });
            },
        closeModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    }
});
const $08aaee4c987ae451$var$useStore = (0, $kBr4q.createHook)($08aaee4c987ae451$var$store);
const $08aaee4c987ae451$export$3b5a3be90f35989a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [state, actions] = $08aaee4c987ae451$var$useStore();
    let t0;
    if ($[0] !== actions.closeModal || $[1] !== actions.openModal || $[2] !== state.conversation || $[3] !== state.isOpen || $[4] !== state.mode) {
        t0 = {
            isOpen: state.isOpen,
            conversation: state.conversation,
            mode: state.mode,
            openModal: actions.openModal,
            closeModal: actions.closeModal
        };
        $[0] = actions.closeModal;
        $[1] = actions.openModal;
        $[2] = state.conversation;
        $[3] = state.isOpen;
        $[4] = state.mode;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : ()=>{
    const [state, actions] = $08aaee4c987ae451$var$useStore();
    return {
        isOpen: state.isOpen,
        conversation: state.conversation,
        mode: state.mode,
        openModal: actions.openModal,
        closeModal: actions.closeModal
    };
};












var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");











const $fcfb7982faac66d1$var$styles = {
    filePreviewImage: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlN91d _0NUa3rBM7N _00EA0egIor _3iDTPbvLZJ",
    filePreviewFallback: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s _4kiQYAgZxp",
    filePreviewTextContent: "_4bt5LAIZbP _2WAcuGIZbP _0bjKvDKxmn _2sNsIgNxAV _0NUa3rhLcO _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruDMqu _1ANEUSlpBW _3W2Oc8wPeg",
    filePreviewLoadingContainer: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _4kiQYAHakr"
};
function $fcfb7982faac66d1$var$isImageFileName(fileName) {
    return /\.(png|jpe?g|gif|webp|svg|bmp|avif)$/i.test(fileName);
}
const $fcfb7982faac66d1$var$TEXT_EXTENSIONS = [
    '.txt',
    '.md',
    '.markdown',
    '.json',
    '.xml',
    '.yaml',
    '.yml',
    '.js',
    '.jsx',
    '.ts',
    '.tsx',
    '.css',
    '.scss',
    '.less',
    '.html',
    '.htm',
    '.csv',
    '.log',
    '.sh',
    '.bash',
    '.py',
    '.rb',
    '.java',
    '.c',
    '.cpp',
    '.h',
    '.go',
    '.rs',
    '.sql'
];
function $fcfb7982faac66d1$var$getBlobPreviewKindFromFileName(fileName) {
    const base = fileName.split(/[/\\]/).pop() ?? fileName;
    const lower = base.toLowerCase();
    if ($fcfb7982faac66d1$var$isImageFileName(lower)) return 'image';
    if ($fcfb7982faac66d1$var$TEXT_EXTENSIONS.some((ext)=>lower.endsWith(ext))) return 'text';
    return 'unknown';
} /** Headers for authenticated Rovo file/blob fetches (gateway). `x-cloudid` is omitted when absent. */ 
function $fcfb7982faac66d1$export$808d9587801c199e(cloudId) {
    const headers = {
        'x-product': 'rovo',
        'x-experience-id': 'ai-mate'
    };
    if (cloudId) headers['x-cloudid'] = cloudId;
    return headers;
}
const $fcfb7982faac66d1$export$298d258c84f7f125 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ScopeFileBlobPreviewModal(t0) {
    const $ = (0, $bDgLe.c)(35);
    const { isOpen: isOpen, onClose: onClose, fileUrl: fileUrl, fileName: fileName, formatMessage: formatMessage, filePreviewFallbackDescription: filePreviewFallbackDescription, cloudId: cloudId } = t0;
    let t1;
    if ($[0] !== fileName) {
        t1 = $fcfb7982faac66d1$var$getBlobPreviewKindFromFileName(fileName);
        $[0] = fileName;
        $[1] = t1;
    } else t1 = $[1];
    const kind = t1;
    const [textContent, setTextContent] = (0, $cozmU.useState)(null);
    const [isLoadingText, setIsLoadingText] = (0, $cozmU.useState)(false);
    const [imageBlobUrl, setImageBlobUrl] = (0, $cozmU.useState)(null);
    let t2;
    if ($[2] !== cloudId || $[3] !== fileUrl || $[4] !== isOpen || $[5] !== kind) {
        t2 = ()=>{
            if (!isOpen || kind !== "text") return;
            let cancelled = false;
            setIsLoadingText(true);
            fetch(fileUrl, {
                method: "GET",
                headers: $fcfb7982faac66d1$export$808d9587801c199e(cloudId),
                credentials: "include"
            }).then($fcfb7982faac66d1$var$_temp).then((text)=>{
                if (!cancelled) setTextContent(text);
            }).catch(()=>{
                if (!cancelled) setTextContent(null);
            }).finally(()=>{
                if (!cancelled) setIsLoadingText(false);
            });
            return ()=>{
                cancelled = true;
            };
        };
        $[2] = cloudId;
        $[3] = fileUrl;
        $[4] = isOpen;
        $[5] = kind;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== cloudId || $[8] !== fileName || $[9] !== fileUrl || $[10] !== isOpen || $[11] !== kind) {
        t3 = [
            isOpen,
            kind,
            fileUrl,
            cloudId,
            fileName
        ];
        $[7] = cloudId;
        $[8] = fileName;
        $[9] = fileUrl;
        $[10] = isOpen;
        $[11] = kind;
        $[12] = t3;
    } else t3 = $[12];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[13] !== cloudId || $[14] !== fileName || $[15] !== fileUrl || $[16] !== isOpen || $[17] !== kind) {
        t4 = ()=>{
            if (!isOpen || kind !== "image") return;
            let cancelled_0 = false;
            const ext = (fileName.split(".").pop() ?? "").toLowerCase();
            const MIME_BY_EXT = {
                jpg: "image/jpeg",
                jpeg: "image/jpeg",
                png: "image/png",
                gif: "image/gif",
                webp: "image/webp",
                svg: "image/svg+xml",
                bmp: "image/bmp",
                ico: "image/x-icon",
                avif: "image/avif"
            };
            const mimeType = MIME_BY_EXT[ext] ?? "application/octet-stream";
            fetch(fileUrl, {
                method: "GET",
                headers: $fcfb7982faac66d1$export$808d9587801c199e(cloudId),
                credentials: "include"
            }).then($fcfb7982faac66d1$var$_temp2).then((payload)=>{
                if (cancelled_0) return Promise.resolve(null);
                if (payload.kind === "text") {
                    const b64 = payload.text.trim();
                    return Promise.resolve(`data:${mimeType};base64,${b64}`);
                }
                const correctBlob = new Blob([
                    payload.blob
                ], {
                    type: mimeType
                });
                return new Promise((resolve, reject)=>{
                    const reader = new FileReader();
                    reader.onload = ()=>resolve(reader.result);
                    reader.onerror = (e)=>reject(e);
                    reader.readAsDataURL(correctBlob);
                });
            }).then((dataUrl)=>{
                if (!cancelled_0 && dataUrl !== null) setImageBlobUrl(dataUrl);
            }).catch((err)=>{
                console.error("[ImagePreview] pipeline error:", err);
                if (!cancelled_0) setImageBlobUrl(null);
            });
            return ()=>{
                cancelled_0 = true;
            };
        };
        t5 = [
            isOpen,
            kind,
            fileUrl,
            cloudId,
            fileName
        ];
        $[13] = cloudId;
        $[14] = fileName;
        $[15] = fileUrl;
        $[16] = isOpen;
        $[17] = kind;
        $[18] = t4;
        $[19] = t5;
    } else {
        t4 = $[18];
        t5 = $[19];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[20] !== fileName || $[21] !== filePreviewFallbackDescription || $[22] !== formatMessage || $[23] !== imageBlobUrl || $[24] !== isLoadingText || $[25] !== kind || $[26] !== textContent) {
        t6 = ()=>{
            if (kind === "image") {
                if (!imageBlobUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $fcfb7982faac66d1$var$styles.filePreviewLoadingContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                    size: "large"
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    as: "img",
                    src: imageBlobUrl,
                    alt: fileName,
                    xcss: $fcfb7982faac66d1$var$styles.filePreviewImage
                });
            }
            if (kind === "text") {
                if (isLoadingText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $fcfb7982faac66d1$var$styles.filePreviewLoadingContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                    size: "large"
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $fcfb7982faac66d1$var$styles.filePreviewTextContent
                }, textContent);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fcfb7982faac66d1$var$styles.filePreviewFallback
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium",
                color: "color.text.subtle"
            }, formatMessage(filePreviewFallbackDescription)));
        };
        $[20] = fileName;
        $[21] = filePreviewFallbackDescription;
        $[22] = formatMessage;
        $[23] = imageBlobUrl;
        $[24] = isLoadingText;
        $[25] = kind;
        $[26] = textContent;
        $[27] = t6;
    } else t6 = $[27];
    const renderBody = t6;
    let t7;
    if ($[28] !== fileName || $[29] !== isOpen || $[30] !== onClose || $[31] !== renderBody) {
        t7 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: onClose,
            width: "x-large",
            shouldScrollInViewport: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, fileName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
            hasInlinePadding: false
        }, renderBody()));
        $[28] = fileName;
        $[29] = isOpen;
        $[30] = onClose;
        $[31] = renderBody;
        $[32] = t7;
    } else t7 = $[32];
    let t8;
    if ($[33] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t7);
        $[33] = t7;
        $[34] = t8;
    } else t8 = $[34];
    return t8;
} : function ScopeFileBlobPreviewModal({ isOpen: isOpen, onClose: onClose, fileUrl: fileUrl, fileName: fileName, formatMessage: formatMessage, filePreviewFallbackDescription: filePreviewFallbackDescription, cloudId: cloudId }) {
    const kind = $fcfb7982faac66d1$var$getBlobPreviewKindFromFileName(fileName);
    const [textContent, setTextContent] = (0, $cozmU.useState)(null);
    const [isLoadingText, setIsLoadingText] = (0, $cozmU.useState)(false);
    const [imageBlobUrl, setImageBlobUrl] = (0, $cozmU.useState)(null); // Fetch text files with auth headers
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || kind !== 'text') return;
        let cancelled = false;
        setIsLoadingText(true);
        fetch(fileUrl, {
            method: 'GET',
            headers: $fcfb7982faac66d1$export$808d9587801c199e(cloudId),
            credentials: 'include'
        }).then((res)=>res.text()).then((text)=>{
            if (!cancelled) setTextContent(text);
        }).catch(()=>{
            if (!cancelled) setTextContent(null);
        }).finally(()=>{
            if (!cancelled) setIsLoadingText(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isOpen,
        kind,
        fileUrl,
        cloudId,
        fileName
    ]); // Fetch images as blobs with auth headers (browsers don't support custom headers on <img src>).
    // We convert to a data URL via FileReader to satisfy CSP img-src policies.
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || kind !== 'image') return;
        let cancelled_0 = false;
        const ext = (fileName.split('.').pop() ?? '').toLowerCase();
        const MIME_BY_EXT = {
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            webp: 'image/webp',
            svg: 'image/svg+xml',
            bmp: 'image/bmp',
            ico: 'image/x-icon',
            avif: 'image/avif'
        };
        const mimeType = MIME_BY_EXT[ext] ?? 'application/octet-stream';
        fetch(fileUrl, {
            method: 'GET',
            headers: $fcfb7982faac66d1$export$808d9587801c199e(cloudId),
            credentials: 'include'
        }).then(async (res_0)=>{
            if (!res_0.ok) throw new Error(`[ImagePreview] fetch failed with status ${res_0.status}`);
            const contentType = res_0.headers.get('content-type') ?? '';
            const looksLikeBinary = contentType.startsWith('image/');
            if (looksLikeBinary) {
                const blob = await res_0.blob();
                return {
                    kind: 'blob',
                    blob: blob
                };
            }
            const text_0 = await res_0.text();
            return {
                kind: 'text',
                text: text_0
            };
        }).then((payload)=>{
            if (cancelled_0) return Promise.resolve(null);
            if (payload.kind === 'text') {
                const b64 = payload.text.trim();
                return Promise.resolve(`data:${mimeType};base64,${b64}`);
            }
            const correctBlob = new Blob([
                payload.blob
            ], {
                type: mimeType
            });
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = (e)=>reject(e);
                reader.readAsDataURL(correctBlob);
            });
        }).then((dataUrl)=>{
            if (!cancelled_0 && dataUrl !== null) setImageBlobUrl(dataUrl);
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('[ImagePreview] pipeline error:', err);
            if (!cancelled_0) setImageBlobUrl(null);
        });
        return ()=>{
            cancelled_0 = true;
        };
    }, [
        isOpen,
        kind,
        fileUrl,
        cloudId,
        fileName
    ]);
    const renderBody = ()=>{
        if (kind === 'image') {
            if (!imageBlobUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fcfb7982faac66d1$var$styles.filePreviewLoadingContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "large"
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "img",
                src: imageBlobUrl,
                alt: fileName,
                xcss: $fcfb7982faac66d1$var$styles.filePreviewImage
            });
        }
        if (kind === 'text') {
            if (isLoadingText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fcfb7982faac66d1$var$styles.filePreviewLoadingContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "large"
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fcfb7982faac66d1$var$styles.filePreviewTextContent
            }, textContent);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fcfb7982faac66d1$var$styles.filePreviewFallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage(filePreviewFallbackDescription)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "x-large",
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, fileName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, renderBody())));
};
async function $fcfb7982faac66d1$var$_temp2(res_0) {
    if (!res_0.ok) throw new Error(`[ImagePreview] fetch failed with status ${res_0.status}`);
    const contentType = res_0.headers.get("content-type") ?? "";
    const looksLikeBinary = contentType.startsWith("image/");
    if (looksLikeBinary) {
        const blob = await res_0.blob();
        return {
            kind: "blob",
            blob: blob
        };
    }
    const text_0 = await res_0.text();
    return {
        kind: "text",
        text: text_0
    };
}
function $fcfb7982faac66d1$var$_temp(res) {
    return res.text();
}












var $kkFbH = parcelRequire("kkFbH");


var $6NvYG = parcelRequire("6NvYG");


var $kTb7m = parcelRequire("kTb7m");


var $hMaHH = parcelRequire("hMaHH");


var $ds2zu = parcelRequire("ds2zu");


var $jrU5N = parcelRequire("jrU5N");


var $bDjVc = parcelRequire("bDjVc");


var $7vK9E = parcelRequire("7vK9E");







const $2eee1fcf3aa6b759$var$styles = {
    scopeLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _0clgaMZpcK",
    scopeLinkTooltip: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYze5R3 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMe5R3",
    scopeLinkIconImage: "_0bjKvDKxmn _39xV02xpxF _0jFU0VxpxF _00EA0eiObl _3YEZNOdnbC _3iDTPbvLZJ"
};
function $2eee1fcf3aa6b759$var$getScopeIconComponent(scope, showLinkFallbackIcon) {
    switch(scope.type){
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($6NvYG));
        case 'file':
            return 0, (/*@__PURE__*/$parcel$interopDefault($kkFbH));
        case 'jira':
            return 0, (/*@__PURE__*/$parcel$interopDefault($jrU5N));
        case 'confluence':
            switch(scope.sub_type){
                case 'space':
                    return 0, (/*@__PURE__*/$parcel$interopDefault($ds2zu));
                case 'whiteboard':
                    return 0, (/*@__PURE__*/$parcel$interopDefault($bDjVc));
                case 'page':
                default:
                    return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
            }
        case 'link':
            return showLinkFallbackIcon ? (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))) : null;
        default:
            return null;
    }
}
const $2eee1fcf3aa6b759$export$85b4c654d12206aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { scope: scope, variant: variant, maxLines: maxLines, showName: t1, showLinkFallbackIcon: t2, showIconWithoutLink: t3, onFilePreview: onFilePreview, onScopeLinkClick: onScopeLinkClick, onScopeLinkHover: onScopeLinkHover } = t0;
    const showName = t1 === undefined ? true : t1;
    const showLinkFallbackIcon = t2 === undefined ? false : t2;
    const showIconWithoutLink = t3 === undefined ? false : t3;
    const textColor = variant === "tooltip" ? "color.text.inverse" : "color.text.subtlest";
    const iconColor = variant === "tooltip" ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
    const isFile = scope.type === "file" || scope.type === "image";
    const canUseIconUrl = scope.type === "link" || scope.type === "jira";
    let t4;
    if ($[0] !== scope || $[1] !== showLinkFallbackIcon) {
        t4 = $2eee1fcf3aa6b759$var$getScopeIconComponent(scope, showLinkFallbackIcon);
        $[0] = scope;
        $[1] = showLinkFallbackIcon;
        $[2] = t4;
    } else t4 = $[2];
    const ScopeIcon = t4;
    let t5;
    if ($[3] !== canUseIconUrl || $[4] !== scope.icon_url) {
        t5 = canUseIconUrl && typeof scope.icon_url === "string" && scope.icon_url.trim().length > 0;
        $[3] = canUseIconUrl;
        $[4] = scope.icon_url;
        $[5] = t5;
    } else t5 = $[5];
    const hasRemoteScopeIcon = t5;
    let t6;
    if ($[6] !== ScopeIcon || $[7] !== hasRemoteScopeIcon || $[8] !== iconColor || $[9] !== scope.icon_url || $[10] !== scope.name || $[11] !== showName) {
        t6 = hasRemoteScopeIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "img",
            src: scope.icon_url,
            alt: showName ? "" : scope.name,
            xcss: $2eee1fcf3aa6b759$var$styles.scopeLinkIconImage
        }) : ScopeIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ScopeIcon, {
            label: showName ? "" : scope.name,
            size: "small",
            color: iconColor
        }) : null;
        $[6] = ScopeIcon;
        $[7] = hasRemoteScopeIcon;
        $[8] = iconColor;
        $[9] = scope.icon_url;
        $[10] = scope.name;
        $[11] = showName;
        $[12] = t6;
    } else t6 = $[12];
    const icon = t6;
    const rawLink = scope.link;
    const resolvedLink = typeof rawLink === "string" ? rawLink : rawLink !== null && typeof rawLink === "object" ? String(rawLink.url ?? rawLink.href ?? "") : "";
    const hasHoveredRef = (0, $cozmU.useRef)(false);
    let t7;
    if ($[13] !== onScopeLinkHover) {
        t7 = ()=>{
            if (!hasHoveredRef.current) {
                hasHoveredRef.current = true;
                onScopeLinkHover?.();
            }
        };
        $[13] = onScopeLinkHover;
        $[14] = t7;
    } else t7 = $[14];
    const handleMouseEnter = t7;
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            hasHoveredRef.current = false;
        };
        $[15] = t8;
    } else t8 = $[15];
    const handleMouseLeave = t8;
    let t9;
    if ($[16] !== isFile || $[17] !== onFilePreview || $[18] !== onScopeLinkClick || $[19] !== resolvedLink || $[20] !== scope.name || $[21] !== variant) {
        t9 = (e)=>{
            e.stopPropagation();
            onScopeLinkClick?.(variant);
            if (isFile && onFilePreview) {
                e.preventDefault();
                onFilePreview(resolvedLink, scope.name);
            }
        };
        $[16] = isFile;
        $[17] = onFilePreview;
        $[18] = onScopeLinkClick;
        $[19] = resolvedLink;
        $[20] = scope.name;
        $[21] = variant;
        $[22] = t9;
    } else t9 = $[22];
    const handleClick = t9;
    if (!resolvedLink) {
        const t10 = showIconWithoutLink && icon;
        let t11;
        if ($[23] !== maxLines || $[24] !== scope.name || $[25] !== showName || $[26] !== textColor) {
            t11 = showName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                weight: "regular",
                maxLines: maxLines,
                align: "start",
                color: textColor
            }, scope.name);
            $[23] = maxLines;
            $[24] = scope.name;
            $[25] = showName;
            $[26] = textColor;
            $[27] = t11;
        } else t11 = $[27];
        let t12;
        if ($[28] !== t10 || $[29] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050"
            }, t10, t11);
            $[28] = t10;
            $[29] = t11;
            $[30] = t12;
        } else t12 = $[30];
        return t12;
    }
    const t10 = showName ? undefined : scope.name;
    let t11;
    if ($[31] !== isFile) {
        t11 = isFile ? {} : {
            target: "_blank",
            rel: "noreferrer"
        };
        $[31] = isFile;
        $[32] = t11;
    } else t11 = $[32];
    const t12 = variant === "tooltip" ? $2eee1fcf3aa6b759$var$styles.scopeLinkTooltip : $2eee1fcf3aa6b759$var$styles.scopeLink;
    let t13;
    if ($[33] !== maxLines || $[34] !== scope.name || $[35] !== showName || $[36] !== textColor) {
        t13 = showName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "regular",
            maxLines: maxLines,
            align: "start",
            color: textColor
        }, scope.name);
        $[33] = maxLines;
        $[34] = scope.name;
        $[35] = showName;
        $[36] = textColor;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== icon || $[39] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, icon, t13);
        $[38] = icon;
        $[39] = t13;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== handleClick || $[42] !== handleMouseEnter || $[43] !== resolvedLink || $[44] !== t10 || $[45] !== t11 || $[46] !== t12 || $[47] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: resolvedLink,
            "aria-label": t10,
            ...t11,
            xcss: t12,
            onClick: handleClick,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        }, t14));
        $[41] = handleClick;
        $[42] = handleMouseEnter;
        $[43] = resolvedLink;
        $[44] = t10;
        $[45] = t11;
        $[46] = t12;
        $[47] = t14;
        $[48] = t15;
    } else t15 = $[48];
    return t15;
} : ({ scope: scope, variant: variant, maxLines: maxLines, showName: showName = true, showLinkFallbackIcon: showLinkFallbackIcon = false, showIconWithoutLink: showIconWithoutLink = false, onFilePreview: onFilePreview, onScopeLinkClick: onScopeLinkClick, onScopeLinkHover: onScopeLinkHover })=>{
    const textColor = variant === 'tooltip' ? 'color.text.inverse' : 'color.text.subtlest';
    const iconColor = variant === 'tooltip' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
    const isFile = scope.type === 'file' || scope.type === 'image';
    const canUseIconUrl = scope.type === 'link' || scope.type === 'jira';
    const ScopeIcon = $2eee1fcf3aa6b759$var$getScopeIconComponent(scope, showLinkFallbackIcon);
    const hasRemoteScopeIcon = canUseIconUrl && typeof scope.icon_url === 'string' && scope.icon_url.trim().length > 0; // Prefer a remote `icon_url` (links / jira) when present; otherwise fall back to the built-in icon.
    const icon = hasRemoteScopeIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "img",
        src: scope.icon_url,
        alt: showName ? '' : scope.name,
        xcss: $2eee1fcf3aa6b759$var$styles.scopeLinkIconImage
    }) : ScopeIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ScopeIcon, {
        label: showName ? '' : scope.name,
        size: "small",
        color: iconColor
    }) : null; // Defensively resolve `link` to a string — the API may return an object or
    // null/undefined for freshly-pasted links before backend normalisation.
    const rawLink = scope.link;
    const resolvedLink = typeof rawLink === 'string' ? rawLink : rawLink !== null && typeof rawLink === 'object' ? String(rawLink.url ?? rawLink.href ?? '') : ''; // Guard: fire the hover analytics event only once per mouseenter/mouseleave
    // cycle, regardless of how many synthetic mouseenter events the browser emits.
    const hasHoveredRef = (0, $cozmU.useRef)(false);
    const handleMouseEnter = ()=>{
        if (!hasHoveredRef.current) {
            hasHoveredRef.current = true;
            onScopeLinkHover?.();
        }
    };
    const handleMouseLeave = ()=>{
        hasHoveredRef.current = false;
    };
    const handleClick = (e)=>{
        e.stopPropagation();
        onScopeLinkClick?.(variant);
        if (isFile && onFilePreview) {
            e.preventDefault();
            onFilePreview(resolvedLink, scope.name);
        }
    };
    if (!resolvedLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, showIconWithoutLink && icon, showName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        maxLines: maxLines,
        align: "start",
        color: textColor
    }, scope.name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: resolvedLink,
        "aria-label": showName ? undefined : scope.name,
        ...isFile ? {} : {
            target: '_blank',
            rel: 'noreferrer'
        },
        xcss: variant === 'tooltip' ? $2eee1fcf3aa6b759$var$styles.scopeLinkTooltip : $2eee1fcf3aa6b759$var$styles.scopeLink,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, icon, showName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        maxLines: maxLines,
        align: "start",
        color: textColor
    }, scope.name))));
};





const $86a1cb35bcd94554$var$message = (0, $kSwu1.defineMessages)({
    chatOptionsForConversationButtonLabel: {
        id: "ai-mate.all-chat-view.chat-item.chat-options-button-label",
        defaultMessage: "Chat options for {conversationName}"
    },
    chatPinLabel: {
        id: "ai-mate.all-chat-view.chat-item.pin-label",
        defaultMessage: "Pin conversation"
    },
    chatUnpinLabel: {
        id: "ai-mate.all-chat-view.chat-item.unpin-label",
        defaultMessage: "Unpin conversation"
    },
    chatPinnedStatusLabel: {
        id: "ai-mate.all-chat-view.chat-item.pinned-status-label",
        defaultMessage: "Pinned"
    },
    chatRenameLabel: {
        id: "ai-mate.all-chat-view.chat-item.rename-label",
        defaultMessage: "Rename"
    },
    chatDeleteLabel: {
        id: "ai-mate.all-chat-view.chat-item.delete-label",
        defaultMessage: "Delete"
    },
    lastMessageTimestampWithSeparator: {
        id: "ai-mate.all-chat-view.chat-item.last-message-timestamp-with-separator",
        defaultMessage: "\xB7 {lastMessageTimeDelta}"
    },
    footerSeparator: {
        id: "ai-mate.all-chat-view.chat-item.footer-separator",
        defaultMessage: "\xB7"
    },
    scopesOverflowCount: {
        id: "ai-mate.all-chat-view.chat-item.scopes-overflow-count",
        defaultMessage: "+{count}"
    },
    scopesOverflowAccessibleLabel: {
        id: "conversation-assistant-ui-components.common.chat-conversation-list-refresh.chat-item.scopesOverflowAccessibleLabel",
        defaultMessage: "{count, plural, one {# more source} other {# more sources}}"
    },
    imagePreviewTitle: {
        id: "ai-mate.all-chat-view.chat-item.image-preview-title",
        defaultMessage: "Image Preview"
    },
    filePreviewFallbackDescription: {
        id: "rovo.chat-list.file-preview.fallback-description",
        defaultMessage: "Preview not available for this file type."
    }
});
var $86a1cb35bcd94554$export$2e2bcd8739ae039 = $86a1cb35bcd94554$var$message;


const $deb50bf6f27fb3b7$var$MAX_VISIBLE_SCOPE_ICONS = 3;
const $deb50bf6f27fb3b7$var$styles = {
    wrapper: "_0bjKvDKxmn _4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _37wbyuF05b _1mT5xdRAKS _0wOv4Q7zJH",
    wrapperHoverBackground: "_1eOmH6o126 _3gzVzLN4oS",
    wrapperParentHoverBackground: "_0LQT5EkG2W",
    pressableContainer: "_49OCfRdnbC _2Y7lL4Pgdg _1mT5xdWVPG _42Yu6BdnbC _0KLXrujOvk",
    visualContent: "_1mT5xdRAKS _42Yu6B7dHp _2O5Vij7dHp _1pp6NdYbGa",
    inlineContainer: "_2mHwu88HPE _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    contentContainer: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _2O5Vij7dHp _4ouGXIdnbC",
    hidden: "_1YKVNsdnbC",
    footerInline: "_4ouGXIdnbC _39xV02N91d",
    timestamp: "_3YEZNOdnbC _1ANEUSLRg7",
    controlsContainer: "_1mT5xdRAKS _42Yu6BgtVO _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    pinnedLabel: "_3YEZNOdnbC",
    statusContainer: "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _0adFHs2ADO",
    contextMenuContainer: "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    firstScopeTooltipTrigger: "_1mT5xdRAKS _42Yu6B7dHp _3iDTPbccYA _0hPCNLDIqT _1EqgXlN91d _4ouGXIdnbC _1pp6NdIZbP",
    firstScopeTooltipClickableTrigger: "_0wOv4Q7zJH",
    scopeTooltipContent: "_0bjKvDKxmn _2sNsIg7NXe _4c065U1Y8M _2Y7lL4gVvo _24h04i2Njc _1EqgXlGVdc _0KLXrugozt _1UtDYze5R3 _3zvHkHwPeg _1T2N03wPeg",
    scopeOverflowCount: "_3YEZNOdnbC _1ANEUSLRg7 _0GTcwRLl21",
    scopeNameWrapper: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    scopeNameClickableWrapper: "_0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $deb50bf6f27fb3b7$var$FooterSeparator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { color: color } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).footerSeparator);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== color || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: color
        }, t1));
        $[2] = color;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ color: color })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: color
    }, formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).footerSeparator)));
};
const $deb50bf6f27fb3b7$var$ScopeOverflowCount = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { count: count } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (count <= 0) return null;
    let t1;
    if ($[0] !== count || $[1] !== formatMessage) {
        t1 = formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).scopesOverflowCount, {
            count: count
        });
        $[0] = count;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            "aria-hidden": "true",
            xcss: $deb50bf6f27fb3b7$var$styles.scopeOverflowCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            size: "small",
            weight: "regular",
            align: "start",
            color: "color.text.subtlest"
        }, t1));
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== count || $[6] !== formatMessage) {
        t3 = formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).scopesOverflowAccessibleLabel, {
            count: count
        });
        $[5] = count;
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t2 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t4);
        $[10] = t2;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ count: count })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (count <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": "true",
        xcss: $deb50bf6f27fb3b7$var$styles.scopeOverflowCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        weight: "regular",
        align: "start",
        color: "color.text.subtlest"
    }, formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).scopesOverflowCount, {
        count: count
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).scopesOverflowAccessibleLabel, {
        count: count
    })));
};
const $deb50bf6f27fb3b7$export$86e6771ca9311520 = ({ conversation: conversation, onConversationSelect: onConversationSelect, onConversationPinToggle: onConversationPinToggle, isPinnedChatsEnabled: isPinnedChatsEnabled = false, cloudId: cloudId, hideActions: hideActions = false, hasParentHoverBackground: hasParentHoverBackground = false, ariaLabel: ariaLabel, testId: testId, footerPrefix: footerPrefix })=>{
    (0, $6cFsl.di)((0, $08aaee4c987ae451$export$3b5a3be90f35989a));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { openModal: openModal } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $cozmU.useState)(false);
    const [isScopeTooltipOpen, setIsScopeTooltipOpen] = (0, $cozmU.useState)(false);
    const [isHoveredOrFocused, setIsHoveredOrFocused] = (0, $cozmU.useState)(false);
    const [, setSelectedConversation] = (0, $cozmU.useState)(null);
    const [fileScopePreview, setFileScopePreview] = (0, $cozmU.useState)(null);
    const lastMessageTimeDelta = (0, $de4d3154ef5b0570$export$6feb2ea55018719b)({
        isoDate: conversation.lastMessageTimestamp,
        relativeTimeStyle: 'long'
    });
    const showThinkingFooterRow = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, conversation.readStatus === false) === 'loading';
    const agentName = conversation.agent?.agent_name;
    const shouldShowAgentInfo = !conversation.agent?.is_default;
    const scopes = conversation.scopes;
    const firstScope = scopes?.[0];
    const hasMultipleScopes = (scopes?.length ?? 0) > 1;
    const visibleScopes = hasMultipleScopes ? scopes?.slice(0, $deb50bf6f27fb3b7$var$MAX_VISIBLE_SCOPE_ICONS) ?? [] : firstScope ? [
        firstScope
    ] : [];
    const scopesOverflowCount = Math.max((scopes?.length ?? 0) - visibleScopes.length, 0);
    const isClickableScopeTooltipsEnabled = (0, $iDrrr.fg)('rovo_chat_clickable_scope_tooltips');
    const showControls = isHoveredOrFocused || isContextMenuOpen;
    const handleConversationClick = (conversation_0)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewChatItemClick',
            attributes: {
                conversationId: conversation_0.id
            }
        });
        if (onConversationSelect) onConversationSelect(conversation_0.id);
        setSelectedConversation(conversation_0.id);
    };
    const handleContextMenuToggle = (0, $cozmU.useCallback)((update)=>{
        setIsContextMenuOpen(update.isOpen);
    }, []);
    const handleScopeTooltipClose = (0, $cozmU.useCallback)(()=>{
        setIsScopeTooltipOpen(false);
    }, []);
    const handleScopeTooltipTriggerClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        setIsScopeTooltipOpen((isOpen)=>!isOpen);
    }, []);
    const handleScopeTooltipTriggerKeyDown = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.key === 'Enter' || event_0.key === ' ') {
            event_0.preventDefault();
            event_0.stopPropagation();
            setIsScopeTooltipOpen((isOpen_0)=>!isOpen_0);
        }
    }, []);
    const pinButtonLabel = formatMessage(conversation.isPinned ? (0, $86a1cb35bcd94554$export$2e2bcd8739ae039).chatUnpinLabel : (0, $86a1cb35bcd94554$export$2e2bcd8739ae039).chatPinLabel);
    const handlePinToggle = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: conversation.isPinned ? 'unpinConversationButton' : 'pinConversationButton'
        });
        Promise.resolve(onConversationPinToggle?.(conversation.id, !conversation.isPinned)).catch(()=>{});
    }, [
        conversation.id,
        conversation.isPinned,
        onConversationPinToggle,
        sendAnalyticsEvent
    ]);
    const handlePinMenuItemClicked = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        handlePinToggle();
    }, [
        handlePinToggle
    ]);
    const handleScopeLinkClick = (0, $cozmU.useCallback)((variant)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'scopeLink',
            attributes: {
                isTooltip: variant === 'tooltip'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const handleScopeLinkHovered = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'link',
            actionSubjectId: 'scopeLink',
            attributes: {
                scopeCount: scopes?.length ?? 0
            }
        });
    }, [
        sendAnalyticsEvent,
        scopes
    ]);
    const footerTextColor = 'color.text.subtlest';
    const agentCreatorType = conversation.agent?.creator_type;
    const isForgeAgent = typeof agentCreatorType === 'string' && (0, $g3RoK.isAgentCreatorType)(agentCreatorType) ? (0, $hq9Cp.isForgeAgentByCreatorType)(agentCreatorType) : false;
    const hasFooterContentAfterPrefix = showThinkingFooterRow || shouldShowAgentInfo && Boolean(conversation.agent) || Boolean(firstScope) || Boolean(conversation.lastMessageTimestamp) || isPinnedChatsEnabled && Boolean(conversation.isPinned);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($deb50bf6f27fb3b7$var$styles.wrapper, hasParentHoverBackground && $deb50bf6f27fb3b7$var$styles.wrapperParentHoverBackground, !hasParentHoverBackground && $deb50bf6f27fb3b7$var$styles.wrapperHoverBackground),
        onMouseEnter: ()=>setIsHoveredOrFocused(true),
        onMouseLeave: ()=>setIsHoveredOrFocused(false),
        onFocus: ()=>setIsHoveredOrFocused(true),
        onBlur: ()=>setIsHoveredOrFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $deb50bf6f27fb3b7$var$styles.pressableContainer,
        key: conversation.id,
        onClick: ()=>handleConversationClick(conversation),
        "aria-label": ariaLabel ?? conversation.name,
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($deb50bf6f27fb3b7$var$styles.inlineContainer, $deb50bf6f27fb3b7$var$styles.visualContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $deb50bf6f27fb3b7$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "regular",
        maxLines: 1,
        align: "start"
    }, conversation.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050",
        xcss: $deb50bf6f27fb3b7$var$styles.footerInline
    }, footerPrefix, footerPrefix && hasFooterContentAfterPrefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deb50bf6f27fb3b7$var$FooterSeparator, {
        color: footerTextColor
    }), showThinkingFooterRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5fb9783c4b6e9b4$export$80b5b1a1eb299c96), {
        conversation: conversation
    }), !showThinkingFooterRow && conversation.lastMessageTimestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $deb50bf6f27fb3b7$var$styles.timestamp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        weight: "regular",
        align: "start",
        color: footerTextColor
    }, lastMessageTimeDelta)), !showThinkingFooterRow && shouldShowAgentInfo && conversation.agent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, conversation.lastMessageTimestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deb50bf6f27fb3b7$var$FooterSeparator, {
        color: footerTextColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentNamedId: conversation.agent.agent_named_id,
        agentId: conversation.agent.agent_id,
        agentIdentityAccountId: conversation.agent.identity_account_id,
        size: "xxsmall",
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? isForgeAgent : conversation.agent.creator_type === 'THIRD_PARTY' || conversation.agent.creator_type === 'FORGE',
        forgeAgentIconUrl: conversation.agent.forge_url
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        maxLines: 1,
        align: "start",
        color: footerTextColor
    }, agentName)), !showThinkingFooterRow && firstScope && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (conversation.lastMessageTimestamp || shouldShowAgentInfo && conversation.agent) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deb50bf6f27fb3b7$var$FooterSeparator, {
        color: footerTextColor
    }), isClickableScopeTooltipsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isScopeTooltipOpen,
        onClose: handleScopeTooltipClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
                placement: "bottom",
                role: "tooltip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $deb50bf6f27fb3b7$var$styles.scopeTooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, (scopes ?? []).map((scope, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `${scope.link ?? 'scope'}-${index}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                    scope: scope,
                    variant: "tooltip",
                    maxLines: 2,
                    onFilePreview: (link, name)=>setFileScopePreview({
                            link: link,
                            name: name
                        }),
                    onScopeLinkClick: handleScopeLinkClick
                })))))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                role: "button",
                tabIndex: 0,
                xcss: (0, $w6R6I.cx)($deb50bf6f27fb3b7$var$styles.firstScopeTooltipTrigger, $deb50bf6f27fb3b7$var$styles.firstScopeTooltipClickableTrigger),
                ...triggerProps,
                onClick: handleScopeTooltipTriggerClick,
                onKeyDown: handleScopeTooltipTriggerKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050"
            }, visibleScopes.map((scope_0, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `${scope_0.link ?? 'scope'}-${index_0}`,
                    xcss: (0, $w6R6I.cx)($deb50bf6f27fb3b7$var$styles.scopeNameWrapper, !hasMultipleScopes && $deb50bf6f27fb3b7$var$styles.scopeNameClickableWrapper)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                    scope: {
                        ...scope_0,
                        link: undefined
                    },
                    variant: "default",
                    maxLines: 1,
                    showName: !hasMultipleScopes,
                    showLinkFallbackIcon: true,
                    showIconWithoutLink: true,
                    onScopeLinkHover: handleScopeLinkHovered
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deb50bf6f27fb3b7$var$ScopeOverflowCount, {
                count: scopesOverflowCount
            })))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, (scopes ?? []).map((scope_1, index_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: `${scope_1.link ?? 'scope'}-${index_1}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                scope: scope_1,
                variant: "tooltip",
                maxLines: 2,
                onFilePreview: (link_0, name_0)=>setFileScopePreview({
                        link: link_0,
                        name: name_0
                    }),
                onScopeLinkClick: handleScopeLinkClick
            })))),
        delay: 0,
        position: "bottom",
        tag: "span"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $deb50bf6f27fb3b7$var$styles.firstScopeTooltipTrigger,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, visibleScopes.map((scope_2, index_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: `${scope_2.link ?? 'scope'}-${index_2}`,
                xcss: $deb50bf6f27fb3b7$var$styles.scopeNameWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                scope: {
                    ...scope_2,
                    link: undefined
                },
                variant: "default",
                maxLines: 1,
                showName: !hasMultipleScopes,
                showLinkFallbackIcon: true,
                showIconWithoutLink: true,
                onScopeLinkHover: handleScopeLinkHovered
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deb50bf6f27fb3b7$var$ScopeOverflowCount, {
            count: scopesOverflowCount
        }))))), !showThinkingFooterRow && isPinnedChatsEnabled && conversation.isPinned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (conversation.lastMessageTimestamp || shouldShowAgentInfo && conversation.agent || firstScope) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deb50bf6f27fb3b7$var$FooterSeparator, {
        color: footerTextColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $deb50bf6f27fb3b7$var$styles.pinnedLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.accent.blue"
    }, formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).chatPinnedStatusLabel))))))), !hideActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($deb50bf6f27fb3b7$var$styles.contextMenuContainer, $deb50bf6f27fb3b7$var$styles.controlsContainer)
    }, !showControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $deb50bf6f27fb3b7$var$styles.statusContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5fb9783c4b6e9b4$export$88ead18fb18a2576), {
        conversation: conversation,
        testId: `chat-conversation-list-refresh-row-status-${conversation.id}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!showControls && $deb50bf6f27fb3b7$var$styles.hidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        shouldRenderToParent: true,
        onOpenChange: handleContextMenuToggle,
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...rest,
                label: formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).chatOptionsForConversationButtonLabel, {
                    conversationName: conversation.name
                }),
                appearance: "default",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                onClick: (e_0, analyticsEvent)=>{
                    sendAnalyticsEvent(analyticsEvent.update({
                        actionSubjectId: 'chatViewChatOptionsTrigger'
                    }));
                    e_0.stopPropagation();
                    onClick?.(e_0);
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: (e_1)=>{
            e_1.stopPropagation();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'renameConversationButton'
            });
            openModal(conversation, 'edit');
        }
    }, formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).chatRenameLabel)), onConversationPinToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handlePinMenuItemClicked
    }, pinButtonLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: (e_2)=>{
            e_2.stopPropagation();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'deleteConversationButton'
            });
            openModal(conversation, 'delete');
        }
    }, formatMessage((0, $86a1cb35bcd94554$export$2e2bcd8739ae039).chatDeleteLabel)))))), fileScopePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcfb7982faac66d1$export$298d258c84f7f125), {
        isOpen: true,
        onClose: ()=>setFileScopePreview(null),
        fileUrl: fileScopePreview.link,
        fileName: fileScopePreview.name,
        formatMessage: formatMessage,
        filePreviewFallbackDescription: (0, $86a1cb35bcd94554$export$2e2bcd8739ae039).filePreviewFallbackDescription,
        cloudId: cloudId
    }) : null);
};



var $gitiq = parcelRequire("gitiq");


var $7CqGl = parcelRequire("7CqGl");











var $kuIhJ = parcelRequire("kuIhJ");










const $69b832321cab8f5c$var$getDeleteSpacePath = (spaceId)=>`${0, $98i9C.SPACES_API_PATH}/${spaceId}`;
const $69b832321cab8f5c$export$46f39558b0dd0694 = async ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    const path = $69b832321cab8f5c$var$getDeleteSpacePath(spaceId);
    let response;
    try {
        response = await fetch(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`deleteSpaceFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'deleteSpaceFetchError'
        });
    }
    if (!response.ok || response.status >= 400) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`deleteSpaceFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'deleteSpaceFetchError',
            statusCode: response.status
        });
    }
};


const $caa0451413d57c80$export$fb4d1ac6bee39cfb = ({ cloudId: cloudId, product: product, experienceId: experienceId, onSuccess: onSuccess })=>{
    const { removeSpace: removeSpace, restoreSpace: restoreSpace } = (0, $12shJ.useSpaceStoreActions)();
    const spaces = (0, $12shJ.useSpaces)();
    // Stable refs so neither `spaces` nor a churning consumer-supplied
    // `onSuccess` becomes a `useCallback` dependency that thrashes the
    // returned `deleteSpace` identity. Matches the pre-migration pattern.
    const spacesRef = (0, $cozmU.useRef)(spaces);
    spacesRef.current = spaces;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    // Snapshot of pre-delete spaces keyed by spaceId. Used by `onError` to
    // roll back the optimistic removal — `useMutation`'s `onError(error,
    // payload)` exposes the original `spaceId`, so we look up the snapshot
    // and restore.
    const deletedSpacesRef = (0, $cozmU.useRef)(new Map());
    const { mutate: mutate } = (0, $kuIhJ.useMutation)({
        mutationFn: async (spaceId)=>{
            const deletedSpace = spacesRef.current.find((s)=>s.id === spaceId);
            if (deletedSpace) deletedSpacesRef.current.set(spaceId, deletedSpace);
            // Optimistic remove; `onError` will re-insert via `restoreSpace`.
            removeSpace(spaceId);
            await (0, $69b832321cab8f5c$export$46f39558b0dd0694)({
                spaceId: spaceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
            // Successful: drop the snapshot and notify caller.
            deletedSpacesRef.current.delete(spaceId);
            onSuccessRef.current?.(spaceId);
        },
        onError: (_error, spaceId_0)=>{
            const deletedSpace_0 = deletedSpacesRef.current.get(spaceId_0);
            if (deletedSpace_0) {
                restoreSpace(deletedSpace_0);
                deletedSpacesRef.current.delete(spaceId_0);
            }
        }
    });
    const deleteSpace = (0, $cozmU.useCallback)(async (spaceId_1)=>{
        await mutate(spaceId_1);
    }, [
        mutate
    ]);
    return {
        deleteSpace: deleteSpace
    };
};














const $00719b79ddea4cb7$export$fa8943ec3a6d0129 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, offset: offset, count: count, enabled: t1 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const { fetchSpaceConversations: fetchSpaceConversations } = (0, $12shJ.useSpaceStoreActions)();
    const conversationPage = (0, $12shJ.useSpaceConversationsPage)(spaceId);
    const isLoading = (0, $12shJ.useSpaceConversationsLoading)(spaceId);
    const error = (0, $12shJ.useSpaceConversationsError)(spaceId);
    const t2 = offset ?? -1;
    const t3 = count ?? -1;
    let t4;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product || $[3] !== spaceId || $[4] !== t2 || $[5] !== t3) {
        t4 = [
            "rovo-spaces:getSpaceConversations",
            spaceId,
            cloudId,
            product,
            experienceId,
            t2,
            t3
        ];
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = spaceId;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== cloudId || $[8] !== count || $[9] !== experienceId || $[10] !== fetchSpaceConversations || $[11] !== offset || $[12] !== product || $[13] !== spaceId) {
        t5 = ()=>fetchSpaceConversations({
                spaceId: spaceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                offset: offset,
                count: count
            });
        $[7] = cloudId;
        $[8] = count;
        $[9] = experienceId;
        $[10] = fetchSpaceConversations;
        $[11] = offset;
        $[12] = product;
        $[13] = spaceId;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== enabled || $[16] !== t4 || $[17] !== t5) {
        t6 = {
            queryKey: t4,
            queryFn: t5,
            enabled: enabled
        };
        $[15] = enabled;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    (0, $5SS4O.useQuery)(t6);
    let t7;
    if ($[19] !== conversationPage || $[20] !== error || $[21] !== isLoading) {
        t7 = {
            conversationPage: conversationPage,
            isLoading: isLoading,
            error: error
        };
        $[19] = conversationPage;
        $[20] = error;
        $[21] = isLoading;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
} : ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, offset: offset, count: count, enabled: enabled = true })=>{
    const { fetchSpaceConversations: fetchSpaceConversations } = (0, $12shJ.useSpaceStoreActions)();
    const conversationPage = (0, $12shJ.useSpaceConversationsPage)(spaceId);
    const isLoading = (0, $12shJ.useSpaceConversationsLoading)(spaceId);
    const error = (0, $12shJ.useSpaceConversationsError)(spaceId);
    (0, $5SS4O.useQuery)({
        queryKey: [
            'rovo-spaces:getSpaceConversations',
            spaceId,
            cloudId,
            product,
            experienceId,
            // Stringify-safe pagination keys so a missing param yields a
            // stable distinct cache key (vs. `undefined`, which the
            // `queryKey.map(toString)` step would coerce to the literal
            // string 'undefined' anyway, but being explicit avoids surprises
            // if the helper changes).
            offset ?? -1,
            count ?? -1
        ],
        queryFn: ()=>fetchSpaceConversations({
                spaceId: spaceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                offset: offset,
                count: count
            }),
        enabled: enabled
    });
    return {
        conversationPage: conversationPage,
        isLoading: isLoading,
        error: error
    };
};



var $9dT53 = parcelRequire("9dT53");











var $2IYpC = parcelRequire("2IYpC");

const $09fc8399fb744e1c$export$3a6d3c054cf6f88d = ({ cloudId: cloudId, product: product, experienceId: experienceId, onSuccess: onSuccess })=>{
    const spaces = (0, $12shJ.useSpaces)();
    const { patchSpace: patchSpace } = (0, $12shJ.useSpaceStoreActions)();
    // Stable refs so neither `spaces` nor the consumer-supplied `onSuccess`
    // becomes a `useCallback` dependency that thrashes the returned
    // `renameSpace` identity.
    const spacesRef = (0, $cozmU.useRef)(spaces);
    spacesRef.current = spaces;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    // Snapshot of pre-rename names keyed by spaceId. Used by `onError` to
    // roll back the optimistic patch — `useMutation`'s `onError` exposes the
    // original `payload`, so we look up the snapshot by `spaceId` and
    // restore. The ref is necessary because the snapshot is captured inside
    // `mutationFn` (where the optimistic update happens) and consumed in
    // `onError`, which runs in a separate microtask.
    const previousNamesRef = (0, $cozmU.useRef)(new Map());
    const { mutate: mutate } = (0, $kuIhJ.useMutation)({
        mutationFn: async ({ spaceId: spaceId, newName: newName })=>{
            const currentSpace = spacesRef.current.find((s)=>s.id === spaceId);
            if (!currentSpace) return;
            previousNamesRef.current.set(spaceId, currentSpace.name);
            // Optimistically update the name (only) in the store. patchSpace
            // also mirrors the change into the detail slice if a detail entry
            // exists, so any open ManageSpaceModal stays consistent.
            patchSpace(spaceId, {
                name: newName
            });
            const request = {
                name: newName,
                description: currentSpace.description ?? undefined,
                emoji: currentSpace.emoji,
                threadId: currentSpace.threadId
            };
            await (0, $2IYpC.updateSpaceFetchAction)({
                spaceId: spaceId,
                request: request,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
            // Successful: clear snapshot and notify caller. Mirrors the prior
            // hook's behaviour of fanning out an `onSuccess(space, newName)`.
            previousNamesRef.current.delete(spaceId);
            onSuccessRef.current?.({
                ...currentSpace,
                name: newName
            }, newName);
        },
        onError: (_error, { spaceId: spaceId_0 })=>{
            // Roll back the optimistic name change on failure. We deliberately
            // only undo if a snapshot exists for this spaceId — otherwise the
            // mutation aborted before the optimistic update happened (or the
            // snapshot was already consumed by a successful retry).
            const previousName = previousNamesRef.current.get(spaceId_0);
            if (previousName !== undefined) {
                patchSpace(spaceId_0, {
                    name: previousName
                });
                previousNamesRef.current.delete(spaceId_0);
            }
        }
    });
    const renameSpace = (0, $cozmU.useCallback)(async (spaceId_1, newName_0)=>{
        await mutate({
            spaceId: spaceId_1,
            newName: newName_0
        });
    }, [
        mutate
    ]);
    return {
        renameSpace: renameSpace
    };
};






/* DeleteSpaceModal.tsx generated by @compiled/babel-plugin v2.0.0 */ 













var $eQiT1 = parcelRequire("eQiT1");















const $5e5d9e5a33e1945c$var$message = (0, $kSwu1.defineMessages)({
    deleteSpaceTitle: {
        id: "ai-mate.rovo-spaces.delete-space-modal.title",
        defaultMessage: "Delete \"{name}\"?"
    },
    modalBody: {
        id: "ai-mate.rovo-spaces.delete-space-modal.body",
        defaultMessage: "This Rovo space, all its settings, and conversations will be permanently deleted."
    },
    cancelButtonLabel: {
        id: "ai-mate.rovo-spaces.delete-space-modal.cancel",
        defaultMessage: "Cancel"
    },
    deleteButtonLabel: {
        id: "ai-mate.rovo-spaces.delete-space-modal.delete",
        defaultMessage: "Delete"
    },
    genericErrorMessage: {
        id: "ai-mate.rovo-spaces.delete-space-modal.error",
        defaultMessage: "Something went wrong. Please try again."
    }
});
var $5e5d9e5a33e1945c$export$2e2bcd8739ae039 = $5e5d9e5a33e1945c$var$message;


const $47b3db5602ad731d$var$styles = {
    errorContainer: "_0bjKvDKxmn _2sNsIgmnOE _3138425zaO _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXruhH7k _1UtDYzAyGJ"
};
const $47b3db5602ad731d$export$8df669469ae96f03 = ({ space: space, isOpen: isOpen, onClose: onClose, onDeleteConfirm: onDeleteConfirm })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const handleDelete = async ()=>{
        setIsSubmitting(true);
        try {
            await onDeleteConfirm(space.id);
            setError(undefined);
            onClose();
        } catch (e) {
            setError(formatMessage((0, $5e5d9e5a33e1945c$export$2e2bcd8739ae039).genericErrorMessage));
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleCancel = ()=>{
        setError(undefined);
        onClose();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: handleCancel,
        width: "small",
        testId: "deleteSpaceModal"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $5e5d9e5a33e1945c$export$2e2bcd8739ae039).deleteSpaceTitle, {
        name: space.name
    }))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, formatMessage((0, $5e5d9e5a33e1945c$export$2e2bcd8739ae039).modalBody)), !!error?.length && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $47b3db5602ad731d$var$styles.errorContainer
    }, error))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, formatMessage((0, $5e5d9e5a33e1945c$export$2e2bcd8739ae039).cancelButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        isLoading: isSubmitting,
        appearance: "danger",
        onClick: handleDelete
    }, formatMessage((0, $5e5d9e5a33e1945c$export$2e2bcd8739ae039).deleteButtonLabel)))));
};


var $8a8ea7eeeb0f6216$exports = {};
$8a8ea7eeeb0f6216$exports = new URL("no_result.875f5997.svg", import.meta.url).toString();





const $460025aacd94cc45$var$messages = (0, $kSwu1.defineMessages)({
    pageTitle: {
        id: "rovo-spaces.browse-spaces-fullscreen.pageTitle",
        defaultMessage: "All Rovo spaces"
    },
    searchPlaceholder: {
        id: "rovo-spaces.browse-spaces-fullscreen.searchPlaceholder",
        defaultMessage: "Search Rovo spaces"
    },
    createSpaceButtonLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.createSpaceButtonLabel",
        defaultMessage: "Create Rovo space"
    },
    emptyStateTitle: {
        id: "rovo-spaces.browse-spaces-fullscreen.emptyStateTitle",
        defaultMessage: "No Rovo spaces yet"
    },
    emptyStateDescription: {
        id: "rovo-spaces.browse-spaces-fullscreen.emptyStateDescription",
        defaultMessage: "Collect team or project context in Rovo spaces, so that your chat answers come from documents, links, and other information that matter to you, not just general knowledge."
    },
    viewRecommendedSpacesButtonLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.viewRecommendedSpacesButtonLabel",
        defaultMessage: "View recommended Rovo spaces"
    },
    createNewSpaceButtonLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.createNewSpaceButtonLabel",
        defaultMessage: "Create new Rovo space"
    },
    searchEmptyStateTitle: {
        id: "rovo-spaces.browse-spaces-fullscreen.searchEmptyStateTitle",
        defaultMessage: "No results found for"
    },
    searchEmptyStateQuery: {
        id: "rovo-spaces.browse-spaces-fullscreen.searchEmptyStateQuery",
        defaultMessage: "\u201C{query}\u201D"
    },
    errorTitle: {
        id: "rovo-spaces.browse-spaces-fullscreen.errorTitle",
        defaultMessage: "We couldn\u2019t load your Rovo spaces"
    },
    loadingLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.loadingLabel",
        defaultMessage: "Loading Rovo spaces\u2026"
    },
    spaceChatsToggleLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.spaceChatsToggleLabel",
        defaultMessage: "Chats in {spaceName}"
    },
    loadingChatsLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.loadingChatsLabel",
        defaultMessage: "Loading chats\u2026"
    },
    chatsErrorTitle: {
        id: "rovo-spaces.browse-spaces-fullscreen.chatsErrorTitle",
        defaultMessage: "We couldn\u2019t load chats"
    },
    noChatsTitle: {
        id: "rovo-spaces.browse-spaces-fullscreen.noChatsTitle",
        defaultMessage: "There are no chats in this Rovo space yet"
    },
    untitledChat: {
        id: "rovo-spaces.browse-spaces-fullscreen.untitledChat",
        defaultMessage: "Untitled chat"
    },
    openChatLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.openChatLabel",
        defaultMessage: "Open chat {name}"
    },
    openChatInSpaceLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.openChatInSpaceLabel",
        defaultMessage: "Open chat {name} in {spaceName}"
    },
    chatCount: {
        id: "rovo-spaces.browse-spaces-fullscreen.chatCount",
        defaultMessage: "{count, plural, one {# chat} other {# chats}}"
    },
    sourceCount: {
        id: "rovo-spaces.browse-spaces-fullscreen.sourceCount",
        defaultMessage: "{count, plural, one {# source} other {# sources}}"
    },
    moreMenuDeleteLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.moreMenuDeleteLabel",
        defaultMessage: "Delete"
    },
    moreMenuRenameLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.moreMenuRenameLabel",
        defaultMessage: "Rename"
    },
    moreMenuLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.moreMenuLabel",
        defaultMessage: "More options"
    },
    cancelRenameLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.cancelRenameLabel",
        defaultMessage: "Cancel rename"
    },
    confirmRenameLabel: {
        id: "rovo-spaces.browse-spaces-fullscreen.confirmRenameLabel",
        defaultMessage: "Confirm rename"
    },
    renameErrorMessage: {
        id: "rovo-spaces.browse-spaces-fullscreen.renameErrorMessage",
        defaultMessage: "We couldn\u2019t rename this Rovo space. Try again."
    }
});
var $460025aacd94cc45$export$2e2bcd8739ae039 = $460025aacd94cc45$var$messages;


































var $1860f7ede8dcf6e7$exports = {};
$1860f7ede8dcf6e7$exports = new URL("folder_empty_state.1214f305.svg", import.meta.url).toString();



const $f19171fcb4ea0e73$var$styles = {
    emptyState: "_2mHwu85zaO _0bjKvD8fU6 _4c065UGXk2 _2Y7lL4Va5s _2V7sgONvrM _3hxITisurO _3vBAKH9r67 _3iDTPbQ4SZ _37wbyuDIqT _4kiQYAwBC3 _3138422ADO _0hPCNLDIqT _2fwxA5DIqT _0KLXrulfZc",
    fullscreenEmptyState: "_313842NHnM",
    sidebarEmptyState: "_0GTcwRNHnM _2xTnZxNHnM",
    emptyStateCopy: "_1EqgXlyrAa",
    emptyStateActions: "_37wbyuDIqT _3TGfC9HnLE"
};
const $f19171fcb4ea0e73$export$d32bea11b1082c07 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { isFullscreenLayout: isFullscreenLayout, onCreateSpace: onCreateSpace, onViewRecommendedSpaces: onViewRecommendedSpaces } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = isFullscreenLayout ? $f19171fcb4ea0e73$var$styles.fullscreenEmptyState : $f19171fcb4ea0e73$var$styles.sidebarEmptyState;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($f19171fcb4ea0e73$var$styles.emptyState, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1860f7ede8dcf6e7$exports))),
            alt: "",
            "aria-hidden": "true",
            width: 100,
            height: 100,
            "data-testid": "rovo-spaces-browse-spaces-fullscreen-empty-state-icon"
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== formatMessage) {
        t4 = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).emptyStateTitle);
        $[3] = formatMessage;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, t4);
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== formatMessage) {
        t6 = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).emptyStateDescription);
        $[7] = formatMessage;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f19171fcb4ea0e73$var$styles.emptyStateCopy
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text.subtlest"
        }, t6));
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t5 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "center",
            space: "space.050"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "center",
            space: "space.100"
        }, t5, t7));
        $[11] = t5;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== formatMessage || $[15] !== onViewRecommendedSpaces) {
        t9 = onViewRecommendedSpaces && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            spacing: "default",
            onClick: onViewRecommendedSpaces,
            testId: "rovo-spaces-browse-spaces-fullscreen-view-recommended-spaces-button"
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).viewRecommendedSpacesButtonLabel));
        $[14] = formatMessage;
        $[15] = onViewRecommendedSpaces;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== formatMessage) {
        t10 = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).createNewSpaceButtonLabel);
        $[17] = formatMessage;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== onCreateSpace || $[20] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            spacing: "default",
            onClick: onCreateSpace,
            testId: "rovo-spaces-browse-spaces-fullscreen-empty-create-space-button"
        }, t10);
        $[19] = onCreateSpace;
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== t11 || $[23] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f19171fcb4ea0e73$var$styles.emptyStateActions,
            space: "space.100"
        }, t9, t11);
        $[22] = t11;
        $[23] = t9;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== t12 || $[26] !== t2 || $[27] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: t2
        }, t8, t12);
        $[25] = t12;
        $[26] = t2;
        $[27] = t8;
        $[28] = t13;
    } else t13 = $[28];
    return t13;
} : ({ isFullscreenLayout: isFullscreenLayout, onCreateSpace: onCreateSpace, onViewRecommendedSpaces: onViewRecommendedSpaces })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: (0, $w6R6I.cx)($f19171fcb4ea0e73$var$styles.emptyState, isFullscreenLayout ? $f19171fcb4ea0e73$var$styles.fullscreenEmptyState : $f19171fcb4ea0e73$var$styles.sidebarEmptyState)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1860f7ede8dcf6e7$exports))),
        alt: "",
        "aria-hidden": "true",
        width: 100,
        height: 100,
        "data-testid": "rovo-spaces-browse-spaces-fullscreen-empty-state-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).emptyStateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f19171fcb4ea0e73$var$styles.emptyStateCopy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).emptyStateDescription))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f19171fcb4ea0e73$var$styles.emptyStateActions,
        space: "space.100"
    }, onViewRecommendedSpaces && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        spacing: "default",
        onClick: onViewRecommendedSpaces,
        testId: "rovo-spaces-browse-spaces-fullscreen-view-recommended-spaces-button"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).viewRecommendedSpacesButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "default",
        onClick: onCreateSpace,
        testId: "rovo-spaces-browse-spaces-fullscreen-empty-create-space-button"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).createNewSpaceButtonLabel))));
};



























var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");








const $34d6a3e5a14abc2e$var$styles = {
    rowActions: "_3YEZNOdnbC _39xV02Uofl _3iDTPbQ4SZ _37wbyuDIqT"
};
const $34d6a3e5a14abc2e$export$f222c0d10838fe9d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { space: space, onRename: onRename, onDeleteSpace: onDeleteSpace, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const [isActionVisible, setIsActionVisible] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsActionVisible(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const showActions = t1;
    let t2;
    if ($[1] !== isMoreMenuOpen) {
        t2 = ()=>{
            if (!isMoreMenuOpen) setIsActionVisible(false);
        };
        $[1] = isMoreMenuOpen;
        $[2] = t2;
    } else t2 = $[2];
    const hideActionsIfMenuClosed = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (event)=>{
            if (event.currentTarget.contains(event.relatedTarget)) return;
            setIsActionVisible(false);
        };
        $[3] = t3;
    } else t3 = $[3];
    const handleBlur = t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (t5)=>{
            const { isOpen: isOpen } = t5;
            setIsMoreMenuOpen(isOpen);
        };
        $[4] = t4;
    } else t4 = $[4];
    const handleOpenChange = t4;
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event_0)=>{
            event_0.preventDefault();
            event_0.stopPropagation();
            setIsMoreMenuOpen($34d6a3e5a14abc2e$var$_temp);
        };
        $[5] = t5;
    } else t5 = $[5];
    const handleMoreButtonClick = t5;
    let t6;
    if ($[6] !== onRename) {
        t6 = ()=>{
            setIsMoreMenuOpen(false);
            onRename();
        };
        $[6] = onRename;
        $[7] = t6;
    } else t6 = $[7];
    const handleRenameClick = t6;
    let t7;
    if ($[8] !== onDeleteSpace || $[9] !== space) {
        t7 = ()=>{
            setIsMoreMenuOpen(false);
            onDeleteSpace(space);
        };
        $[8] = onDeleteSpace;
        $[9] = space;
        $[10] = t7;
    } else t7 = $[10];
    const handleDeleteClick = t7;
    let t8;
    if ($[11] !== hideActionsIfMenuClosed) {
        t8 = {
            onMouseEnter: showActions,
            onMouseLeave: hideActionsIfMenuClosed,
            onFocus: showActions,
            onBlur: handleBlur
        };
        $[11] = hideActionsIfMenuClosed;
        $[12] = t8;
    } else t8 = $[12];
    const rowInteractionProps = t8;
    const shouldShowActions = isActionVisible || isMoreMenuOpen;
    let t9;
    if ($[13] !== formatMessage || $[14] !== handleDeleteClick || $[15] !== handleRenameClick || $[16] !== isMoreMenuOpen || $[17] !== shouldShowActions || $[18] !== space) {
        t9 = shouldShowActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            isOpen: isMoreMenuOpen,
            placement: "bottom-end",
            onOpenChange: handleOpenChange,
            label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuLabel),
            trigger: (t10)=>{
                const { triggerRef: triggerRef, ...triggerProps } = t10;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    ...triggerProps,
                    ref: triggerRef,
                    testId: `browse-spaces-fullscreen-row-more-${space.id}`,
                    icon: $34d6a3e5a14abc2e$var$_temp2,
                    appearance: "subtle",
                    spacing: "compact",
                    onClick: handleMoreButtonClick,
                    label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuLabel)
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                label: ""
            }),
            onClick: handleRenameClick
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuRenameLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            onClick: handleDeleteClick
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuDeleteLabel)))) : null;
        $[13] = formatMessage;
        $[14] = handleDeleteClick;
        $[15] = handleRenameClick;
        $[16] = isMoreMenuOpen;
        $[17] = shouldShowActions;
        $[18] = space;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $34d6a3e5a14abc2e$var$styles.rowActions
        }, t9);
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== children || $[23] !== rowInteractionProps || $[24] !== t10) {
        t11 = children({
            rowInteractionProps: rowInteractionProps,
            actions: t10
        });
        $[22] = children;
        $[23] = rowInteractionProps;
        $[24] = t10;
        $[25] = t11;
    } else t11 = $[25];
    return t11;
} : ({ space: space, onRename: onRename, onDeleteSpace: onDeleteSpace, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const [isActionVisible, setIsActionVisible] = (0, $cozmU.useState)(false);
    const showActions = (0, $cozmU.useCallback)(()=>{
        setIsActionVisible(true);
    }, []);
    const hideActionsIfMenuClosed = (0, $cozmU.useCallback)(()=>{
        if (!isMoreMenuOpen) setIsActionVisible(false);
    }, [
        isMoreMenuOpen
    ]);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setIsActionVisible(false);
    }, []);
    const handleOpenChange = (0, $cozmU.useCallback)(({ isOpen: isOpen })=>{
        setIsMoreMenuOpen(isOpen);
    }, []);
    const handleMoreButtonClick = (0, $cozmU.useCallback)((event_0)=>{
        event_0.preventDefault();
        event_0.stopPropagation();
        setIsMoreMenuOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const handleRenameClick = (0, $cozmU.useCallback)(()=>{
        setIsMoreMenuOpen(false);
        onRename();
    }, [
        onRename
    ]);
    const handleDeleteClick = (0, $cozmU.useCallback)(()=>{
        setIsMoreMenuOpen(false);
        onDeleteSpace(space);
    }, [
        onDeleteSpace,
        space
    ]);
    const rowInteractionProps = (0, $cozmU.useMemo)(()=>({
            onMouseEnter: showActions,
            onMouseLeave: hideActionsIfMenuClosed,
            onFocus: showActions,
            onBlur: handleBlur
        }), [
        handleBlur,
        hideActionsIfMenuClosed,
        showActions
    ]);
    const shouldShowActions = isActionVisible || isMoreMenuOpen;
    return children({
        rowInteractionProps: rowInteractionProps,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $34d6a3e5a14abc2e$var$styles.rowActions
        }, shouldShowActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            isOpen: isMoreMenuOpen,
            placement: "bottom-end",
            onOpenChange: handleOpenChange,
            label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuLabel),
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    ...triggerProps,
                    ref: triggerRef,
                    testId: `browse-spaces-fullscreen-row-more-${space.id}`,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    onClick: handleMoreButtonClick,
                    label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuLabel)
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                label: ""
            }),
            onClick: handleRenameClick
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuRenameLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            onClick: handleDeleteClick
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuDeleteLabel)))) : null)
    });
};
function $34d6a3e5a14abc2e$var$_temp(currentIsOpen) {
    return !currentIsOpen;
}
function $34d6a3e5a14abc2e$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        ...iconProps,
        size: "small"
    });
}





















var $dUI0h = parcelRequire("dUI0h");


var $dTHYM = parcelRequire("dTHYM");





var $l3wuH = parcelRequire("l3wuH");









const $9e3ffb46cea88f04$var$styles = {
    renameFormInner: "_2mHwu81Y8M _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT",
    textFieldContainer: "_2O5Vij7dHp _4ouGXIdnbC",
    textFieldStack: "_39xV02N91d",
    textField: "_2sNsIgmnOE _30huDKS6k6 _0bjKvDKxmn _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _24h04i2Njc _1kk5Tkf7mX _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6Q1Y8M _0xkEdpnXvL _1zr6DcnXvL _0htemX6wH8 _067LceNvrM"
};
const $9e3ffb46cea88f04$export$6fecef72e09fc5cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { spaceId: spaceId, formRef: formRef, inputRef: inputRef, formXcss: formXcss, hasRenameError: hasRenameError, isRenaming: isRenaming, localSpaceName: localSpaceName, onCancelRename: onCancelRename, onSubmitRename: onSubmitRename } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorId = `browse-spaces-fullscreen-row-name-edit-error-${spaceId}`;
    let t1;
    if ($[0] !== onSubmitRename) {
        t1 = (data)=>{
            onSubmitRename(data.spaceName);
        };
        $[0] = onSubmitRename;
        $[1] = t1;
    } else t1 = $[1];
    const handleSubmit = t1;
    let t2;
    if ($[2] !== onCancelRename) {
        t2 = (event)=>{
            if (event.key === "Escape") onCancelRename();
        };
        $[2] = onCancelRename;
        $[3] = t2;
    } else t2 = $[3];
    const handleKeyDown = t2;
    let t3;
    if ($[4] !== errorId || $[5] !== formatMessage || $[6] !== handleKeyDown || $[7] !== hasRenameError || $[8] !== inputRef || $[9] !== isRenaming || $[10] !== localSpaceName || $[11] !== onCancelRename || $[12] !== spaceId) {
        t3 = (t4)=>{
            const { formProps: formProps } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
                ...formProps,
                className: (0, $hekY6.default)([
                    $9e3ffb46cea88f04$var$styles.renameFormInner
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $9e3ffb46cea88f04$var$styles.textFieldContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "spaceName",
                defaultValue: localSpaceName
            }, (t5)=>{
                const { fieldProps: fieldProps } = t5;
                const { isDisabled: _isDisabled, isInvalid: _isInvalid, isRequired: _isRequired, ...inputFieldProps } = fieldProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    xcss: $9e3ffb46cea88f04$var$styles.textFieldStack,
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
                    ...inputFieldProps,
                    ref: inputRef,
                    "aria-label": formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuRenameLabel),
                    "aria-invalid": hasRenameError ? true : undefined,
                    "aria-errormessage": hasRenameError ? errorId : undefined,
                    onKeyDown: handleKeyDown,
                    "data-testid": `browse-spaces-fullscreen-row-name-edit-${spaceId}`,
                    className: (0, $hekY6.default)([
                        $9e3ffb46cea88f04$var$styles.textField
                    ])
                }), hasRenameError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    id: errorId,
                    color: "color.text.danger",
                    size: "small",
                    role: "alert",
                    testId: `browse-spaces-fullscreen-row-name-edit-error-${spaceId}`
                }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).renameErrorMessage)) : null);
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: $9e3ffb46cea88f04$var$_temp,
                type: "submit",
                appearance: "subtle",
                shape: "circle",
                spacing: "compact",
                isDisabled: isRenaming,
                label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).confirmRenameLabel),
                testId: `browse-spaces-fullscreen-row-rename-confirm-${spaceId}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: $9e3ffb46cea88f04$var$_temp2,
                type: "button",
                onClick: onCancelRename,
                appearance: "subtle",
                shape: "circle",
                spacing: "compact",
                isDisabled: isRenaming,
                label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).cancelRenameLabel),
                testId: `browse-spaces-fullscreen-row-rename-cancel-${spaceId}`
            }));
        };
        $[4] = errorId;
        $[5] = formatMessage;
        $[6] = handleKeyDown;
        $[7] = hasRenameError;
        $[8] = inputRef;
        $[9] = isRenaming;
        $[10] = localSpaceName;
        $[11] = onCancelRename;
        $[12] = spaceId;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== handleSubmit || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: handleSubmit
        }, t3);
        $[14] = handleSubmit;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== formRef || $[18] !== formXcss || $[19] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: formXcss,
            ref: formRef
        }, t4);
        $[17] = formRef;
        $[18] = formXcss;
        $[19] = t4;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ spaceId: spaceId, formRef: formRef, inputRef: inputRef, formXcss: formXcss, hasRenameError: hasRenameError, isRenaming: isRenaming, localSpaceName: localSpaceName, onCancelRename: onCancelRename, onSubmitRename: onSubmitRename })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorId = `browse-spaces-fullscreen-row-name-edit-error-${spaceId}`;
    const handleSubmit = (0, $cozmU.useCallback)((data)=>{
        onSubmitRename(data.spaceName);
    }, [
        onSubmitRename
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Escape') onCancelRename();
    }, [
        onCancelRename
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: formXcss,
        ref: formRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            ...formProps,
            className: (0, $hekY6.default)([
                $9e3ffb46cea88f04$var$styles.renameFormInner
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9e3ffb46cea88f04$var$styles.textFieldContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "spaceName",
            defaultValue: localSpaceName
        }, ({ fieldProps: fieldProps })=>{
            const { isDisabled: _isDisabled, isInvalid: _isInvalid, isRequired: _isRequired, ...inputFieldProps } = fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $9e3ffb46cea88f04$var$styles.textFieldStack,
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
                ...inputFieldProps,
                ref: inputRef,
                "aria-label": formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).moreMenuRenameLabel),
                "aria-invalid": hasRenameError ? true : undefined,
                "aria-errormessage": hasRenameError ? errorId : undefined,
                onKeyDown: handleKeyDown,
                "data-testid": `browse-spaces-fullscreen-row-name-edit-${spaceId}`,
                className: (0, $hekY6.default)([
                    $9e3ffb46cea88f04$var$styles.textField
                ])
            }), hasRenameError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                id: errorId,
                color: "color.text.danger",
                size: "small",
                role: "alert",
                testId: `browse-spaces-fullscreen-row-name-edit-error-${spaceId}`
            }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).renameErrorMessage)) : null);
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    ...iconProps,
                    color: "var(--ds-icon-accent-green, #22A06B)"
                }),
            type: "submit",
            appearance: "subtle",
            shape: "circle",
            spacing: "compact",
            isDisabled: isRenaming,
            label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).confirmRenameLabel),
            testId: `browse-spaces-fullscreen-row-rename-confirm-${spaceId}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    ...iconProps_0,
                    color: "var(--ds-icon-accent-red, #C9372C)"
                }),
            type: "button",
            onClick: onCancelRename,
            appearance: "subtle",
            shape: "circle",
            spacing: "compact",
            isDisabled: isRenaming,
            label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).cancelRenameLabel),
            testId: `browse-spaces-fullscreen-row-rename-cancel-${spaceId}`
        }))));
};
function $9e3ffb46cea88f04$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        ...iconProps,
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}
function $9e3ffb46cea88f04$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}








const $6028e15caa415103$export$6b07a1eaaaddb91b = ({ space: space, renameSpace: renameSpace, onStartRename: onStartRename })=>{
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [isRenaming, setIsRenaming] = (0, $cozmU.useState)(false);
    const [localSpaceName, setLocalSpaceName] = (0, $cozmU.useState)(space.name);
    const [hasRenameError, setHasRenameError] = (0, $cozmU.useState)(false);
    const formRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    const onRenameBtnClicked = (0, $cozmU.useCallback)(()=>{
        onStartRename?.();
        setLocalSpaceName(space.name);
        setHasRenameError(false);
        setIsEditing(true);
    }, [
        onStartRename,
        space.name
    ]);
    const onSubmitRename = (0, $cozmU.useCallback)(async (value)=>{
        const trimmed = value.trim();
        if (!trimmed) {
            setHasRenameError(false);
            setIsEditing(false);
            return;
        }
        setLocalSpaceName(trimmed);
        setHasRenameError(false);
        setIsRenaming(true);
        try {
            await renameSpace(space.id, trimmed);
            setIsEditing(false);
        } catch  {
            setHasRenameError(true);
        } finally{
            setIsRenaming(false);
        }
    }, [
        renameSpace,
        space.id
    ]);
    const onCancelRename = (0, $cozmU.useCallback)(()=>{
        setHasRenameError(false);
        setIsEditing(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) {
            setLocalSpaceName(space.name);
            setHasRenameError(false);
        }
    }, [
        isEditing,
        space.name
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isEditing) inputRef.current?.focus();
    }, [
        isEditing
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) return;
        const handleClickOutside = (event)=>{
            if (formRef.current && !formRef.current.contains(event.target)) onCancelRename();
        };
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'mousedown',
            listener: handleClickOutside,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isEditing,
        onCancelRename
    ]);
    return {
        formRef: formRef,
        inputRef: inputRef,
        isEditing: isEditing,
        isRenaming: isRenaming,
        localSpaceName: localSpaceName,
        hasRenameError: hasRenameError,
        onCancelRename: onCancelRename,
        onRenameBtnClicked: onRenameBtnClicked,
        onSubmitRename: onSubmitRename
    };
};












var $2Z9WR = parcelRequire("2Z9WR");

const $dd8bb6bbfdd7eb11$var$SEARCH_SPACE_CONVERSATION_COUNT = 50;
const $dd8bb6bbfdd7eb11$export$12eb92daee0cfdf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { cloudId: cloudId, product: product, experienceId: experienceId, spaceIds: spaceIds, enabled: enabled } = t0;
    const [conversationsBySpaceId, setConversationsBySpaceId] = (0, $cozmU.useState)($dd8bb6bbfdd7eb11$var$_temp);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== spaceIds) {
        t1 = spaceIds.join("\0");
        $[0] = spaceIds;
        $[1] = t1;
    } else t1 = $[1];
    const spaceIdsKey = t1;
    let t2;
    if ($[2] !== spaceIdsKey) {
        t2 = spaceIdsKey ? spaceIdsKey.split("\0") : [];
        $[2] = spaceIdsKey;
        $[3] = t2;
    } else t2 = $[3];
    const stableSpaceIds = t2;
    let t3;
    let t4;
    if ($[4] !== cloudId || $[5] !== enabled || $[6] !== experienceId || $[7] !== product || $[8] !== stableSpaceIds) {
        t3 = ()=>{
            if (!enabled || stableSpaceIds.length === 0) {
                setConversationsBySpaceId(new Map());
                setIsLoading(false);
                return;
            }
            let isCancelled = false;
            setIsLoading(true);
            Promise.allSettled(stableSpaceIds.map(async (spaceId)=>{
                const conversationPage = await (0, $2Z9WR.getSpaceConversationsFetchAction)({
                    spaceId: spaceId,
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId,
                    count: $dd8bb6bbfdd7eb11$var$SEARCH_SPACE_CONVERSATION_COUNT
                });
                return [
                    spaceId,
                    conversationPage.conversations
                ];
            })).then((results)=>{
                if (isCancelled) return;
                const fulfilledEntries = results.flatMap($dd8bb6bbfdd7eb11$var$_temp2);
                setConversationsBySpaceId(new Map(fulfilledEntries));
            }).finally(()=>{
                if (!isCancelled) setIsLoading(false);
            });
            return ()=>{
                isCancelled = true;
            };
        };
        t4 = [
            cloudId,
            enabled,
            experienceId,
            product,
            stableSpaceIds
        ];
        $[4] = cloudId;
        $[5] = enabled;
        $[6] = experienceId;
        $[7] = product;
        $[8] = stableSpaceIds;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[11] !== conversationsBySpaceId || $[12] !== isLoading) {
        t5 = {
            conversationsBySpaceId: conversationsBySpaceId,
            isLoading: isLoading
        };
        $[11] = conversationsBySpaceId;
        $[12] = isLoading;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ cloudId: cloudId, product: product, experienceId: experienceId, spaceIds: spaceIds, enabled: enabled })=>{
    const [conversationsBySpaceId, setConversationsBySpaceId] = (0, $cozmU.useState)(()=>new Map());
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const spaceIdsKey = spaceIds.join('\u0000');
    const stableSpaceIds = (0, $cozmU.useMemo)(()=>spaceIdsKey ? spaceIdsKey.split('\u0000') : [], [
        spaceIdsKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || stableSpaceIds.length === 0) {
            setConversationsBySpaceId(new Map());
            setIsLoading(false);
            return;
        }
        let isCancelled = false;
        setIsLoading(true);
        Promise.allSettled(stableSpaceIds.map(async (spaceId)=>{
            const conversationPage = await (0, $2Z9WR.getSpaceConversationsFetchAction)({
                spaceId: spaceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                count: $dd8bb6bbfdd7eb11$var$SEARCH_SPACE_CONVERSATION_COUNT
            });
            return [
                spaceId,
                conversationPage.conversations
            ];
        })).then((results)=>{
            if (isCancelled) return;
            const fulfilledEntries = results.flatMap((result)=>result.status === 'fulfilled' ? [
                    result.value
                ] : []);
            setConversationsBySpaceId(new Map(fulfilledEntries));
        }).finally(()=>{
            if (!isCancelled) setIsLoading(false);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudId,
        enabled,
        experienceId,
        product,
        stableSpaceIds
    ]);
    return {
        conversationsBySpaceId: conversationsBySpaceId,
        isLoading: isLoading
    };
};
function $dd8bb6bbfdd7eb11$var$_temp() {
    return new Map();
}
function $dd8bb6bbfdd7eb11$var$_temp2(result) {
    return result.status === "fulfilled" ? [
        result.value
    ] : [];
}


const $f46e57de210714b9$var$ROW_MIN_HEIGHT = '64px'; /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- fixed Figma content/list/icon dimensions */ 
const $f46e57de210714b9$var$styles = {
    wrapper: "_39xV02N91d",
    sidebarWrapper: "_4bt5LAnQyn _0jFU0VN91d _1wydGW5zaO",
    fullscreenWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d",
    fullscreenContentContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _39xV02N91d _1EqgXlOAqP _0jFU0VN91d _4kiQYAdnbC _0GTcwRIZbP _2xTnZxIZbP _0Of8r2S40j",
    headerContainerBase: "_2mHwu85zaO",
    sidebarHeaderContainer: "_2Y7lL4NHnM _0Of8r2kG2W _1wydGWkG2W",
    header: "_37wbyuI7V3",
    searchBarContainer: "_3iDTPbQ4SZ _3138425zaO",
    listContainerBase: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4bt5LAnQyn _2WAcuGIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0NUa3rN91d _4kiQYAdnbC _313842NHnM _0KLXrulfZc",
    searchResultsContainer: "_42d1HA8HPE _17lj8p8HPE _22sfPndnbC _1aEeYednbC _3hhsrrdnbC _1Vs123dnbC _0KLXrujOvk",
    searchResultItem: "_0bjKvD8fU6 _22sfPnNvrM _1aEeYeNvrM _3hhsrrNvrM _1Vs123NvrM _2IVJ4M6wH8 _3587oR6wH8 _3BoeID6wH8 _421I1o6wH8 _3zygPU9r67 _1uR5uv9r67 _3XVgLM9r67 _0obpEh9r67 _0KLXrulfZc",
    sidebarListContainer: "_3138421Y8M _0GTcwRNHnM _2xTnZxNHnM",
    spinnerContainer: "_4c065US40j _2Y7lL48HPE _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    rowLayout: "_3iDTPbQ4SZ _0hPCNLDIqT _4kiQYA9LX5",
    rowContentGap: "_2mHwu88HPE",
    rowContainerGap: "_2mHwu82ADO",
    rowInlinePadding: "_0LQT5E8HPE _03SyCPgVvo",
    rowBlockPadding: "_4c065U2ADO",
    row: "_39xV02N91d _0KLXrulfZc _1eOmH6o126",
    searchResultRow: "_0bjKvD8fU6",
    rowTogglePlaceholder: "_39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    rowDivider: "_22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    spaceChats: "_22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXrulfZc",
    spaceChatItem: "_0LQT5Ep0Oa _0KLXrulfZc _1eOmH6o126 _3gzVzLN4oS",
    spaceChatItemDivider: "_22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    spaceChatContent: "_2mHwu8Pgdg _3iDTPbQ4SZ _0hPCNLDIqT",
    spaceChatIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02Uofl _0jFU0VUofl",
    spaceChatItemContent: "_2O5Vij7dHp _4ouGXIdnbC _0GTcwR4F84",
    spaceChatsState: "_4c065U5zaO _0LQT5Ep0Oa _03SyCP5zaO",
    searchChatItem: "_0bjKvD8fU6 _0KLXrulfZc _1eOmH6o126 _3gzVzLN4oS",
    searchChatItemContent: "_0Of8r2FQfX _1Znuxb5zaO _1wydGWFQfX _2Zuz6Q5zaO",
    searchChatSpaceMetadata: "_4ouGXIdnbC _1EqgXloaux _3YEZNOdnbC",
    searchChatSpaceMetadataName: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _3YEZNO7dHp _39HuIbz8Lp _1ANEUSLRg7",
    emojiTile: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _0KLXruDMqu",
    rowText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu8FQfX _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    rowName: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    rowMetadata: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    rowButton: "_2O5Vij7dHp _4ouGXIdnbC _0KLXrujOvk _2fwxA5ecOK _3gzVzLN4oS",
    renameForm: "_2mHwu81Y8M _0KLXrulfZc",
    rowMetadataSkeleton: "_39xV02NNui",
    noResultsWrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _2fwxA5DIqT _0jFU0VN91d _1wydGWGXk2"
};
const $f46e57de210714b9$var$getSpaceConversationCount = (space)=>{
    const conversationIds = new Set();
    space.sources?.forEach((source)=>{
        source.conversationIds?.forEach((conversationId)=>{
            conversationIds.add(conversationId);
        });
    });
    return conversationIds.size;
};
const $f46e57de210714b9$var$isEmptySpaceConversation = (conversation)=>conversation.isEmpty ?? !conversation.lastMessage?.trim();
const $f46e57de210714b9$var$isConversationInSpace = ({ conversation: conversation, spaceId: spaceId, activeSpaceId: activeSpaceId, activeConversationId: activeConversationId })=>conversation.rovoSpaceId === spaceId || !conversation.rovoSpaceId && activeSpaceId === spaceId && conversation.id === activeConversationId;
const $f46e57de210714b9$var$getFetchedSpaceConversationCount = ({ spaceId: spaceId, fetchedConversationCount: fetchedConversationCount, fetchedConversations: fetchedConversations, localSpaceConversations: localSpaceConversations = [], activeSpaceId: activeSpaceId, activeConversationId: activeConversationId })=>{
    if (fetchedConversationCount === undefined) return undefined;
    const fetchedConversationIds = new Set(fetchedConversations?.flatMap((conversation)=>conversation.backendConversationId ? [
            conversation.id,
            conversation.backendConversationId
        ] : [
            conversation.id
        ]));
    const localOnlyCount = localSpaceConversations.filter((conversation)=>$f46e57de210714b9$var$isConversationInSpace({
            conversation: conversation,
            spaceId: spaceId,
            activeSpaceId: activeSpaceId,
            activeConversationId: activeConversationId
        }) && !fetchedConversationIds.has(conversation.id) && (!conversation.backendConversationId || !fetchedConversationIds.has(conversation.backendConversationId))).length;
    return fetchedConversationCount + localOnlyCount;
};
const $f46e57de210714b9$var$getLocalSpaceConversations = ({ spaceId: spaceId, localSpaceConversations: localSpaceConversations = [], activeSpaceId: activeSpaceId, activeConversationId: activeConversationId })=>localSpaceConversations.filter((conversation)=>$f46e57de210714b9$var$isConversationInSpace({
            conversation: conversation,
            spaceId: spaceId,
            activeSpaceId: activeSpaceId,
            activeConversationId: activeConversationId
        })).map((conversation)=>({
            ...conversation,
            rovoSpaceId: conversation.rovoSpaceId ?? spaceId,
            isEmpty: $f46e57de210714b9$var$isEmptySpaceConversation(conversation)
        }));
const $f46e57de210714b9$var$mergeFetchedAndLocalSpaceConversations = ({ spaceId: spaceId, fetchedConversations: fetchedConversations, localSpaceConversations: localSpaceConversations, activeSpaceId: activeSpaceId, activeConversationId: activeConversationId })=>{
    const localConversations = $f46e57de210714b9$var$getLocalSpaceConversations({
        spaceId: spaceId,
        localSpaceConversations: localSpaceConversations,
        activeSpaceId: activeSpaceId,
        activeConversationId: activeConversationId
    });
    const localById = new Map(localConversations.map((conversation)=>[
            conversation.id,
            conversation
        ]));
    const localByBackendId = new Map(localConversations.filter((conversation)=>Boolean(conversation.backendConversationId)).map((conversation)=>[
            conversation.backendConversationId,
            conversation
        ]));
    const consumedLocalIds = new Set();
    const mergedFetchedConversations = fetchedConversations.map((fetchedConversation)=>{
        const local = localById.get(fetchedConversation.id) ?? localByBackendId.get(fetchedConversation.id);
        if (!local) return fetchedConversation;
        consumedLocalIds.add(local.id);
        const localLastMessage = local.lastMessage?.trim() ? local.lastMessage : undefined;
        return {
            ...fetchedConversation,
            name: local.name ?? fetchedConversation.name,
            lastMessage: localLastMessage ?? fetchedConversation.lastMessage,
            lastMessageType: local.lastMessageType ?? fetchedConversation.lastMessageType,
            lastMessageTimestamp: localLastMessage ? local.lastMessageTimestamp ?? fetchedConversation.lastMessageTimestamp : fetchedConversation.lastMessageTimestamp,
            lastAgentMessageStatus: local.lastAgentMessageStatus ?? fetchedConversation.lastAgentMessageStatus,
            agent: local.agent ?? fetchedConversation.agent,
            readStatus: local.readStatus ?? fetchedConversation.readStatus,
            scopes: local.scopes ?? fetchedConversation.scopes,
            tags: local.tags ?? fetchedConversation.tags,
            currentTask: local.currentTask ?? fetchedConversation.currentTask
        };
    });
    const localOnlyConversations = localConversations.filter((conversation)=>!consumedLocalIds.has(conversation.id));
    return [
        ...localOnlyConversations,
        ...mergedFetchedConversations
    ];
};
const $f46e57de210714b9$var$doesConversationMatchSearch = (conversation, trimmedSearchQuery)=>conversation.name?.toLocaleLowerCase().includes(trimmedSearchQuery.toLocaleLowerCase()) ?? false; /**
                                                                                                                                                                                                                          * Single space row. Mirrors the Spaces Figma row pattern: icon tile, title, and
                                                                                                                                                                                                                          * compact chat/source metadata.
                                                                                                                                                                                                                          */ 
const $f46e57de210714b9$var$SpaceRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(80);
    const { space: space, emojiProvider: emojiProvider, renameSpace: renameSpace, onDeleteSpace: onDeleteSpace, onSelectSpace: onSelectSpace, onSelectSpaceChat: onSelectSpaceChat, localSpaceConversations: localSpaceConversations, activeSpaceId: activeSpaceId, activeConversationId: activeConversationId, cloudId: cloudId, product: product, experienceId: experienceId, isSearchResult: t1 } = t0;
    const isSearchResult = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] !== renameSpace || $[1] !== space) {
        t2 = {
            space: space,
            renameSpace: renameSpace
        };
        $[0] = renameSpace;
        $[1] = space;
        $[2] = t2;
    } else t2 = $[2];
    const { formRef: formRef, inputRef: inputRef, isEditing: isEditing, localSpaceName: localSpaceName, hasRenameError: hasRenameError, isRenaming: isRenaming, onCancelRename: onCancelRename, onRenameBtnClicked: onRenameBtnClicked, onSubmitRename: onSubmitRename } = (0, $6028e15caa415103$export$6b07a1eaaaddb91b)(t2);
    let t3;
    if ($[3] !== onSelectSpace || $[4] !== space) {
        t3 = ()=>{
            onSelectSpace(space);
        };
        $[3] = onSelectSpace;
        $[4] = space;
        $[5] = t3;
    } else t3 = $[5];
    const handleClick = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsExpanded($f46e57de210714b9$var$_temp);
        };
        $[6] = t4;
    } else t4 = $[6];
    const handleToggleChats = t4;
    const sourceCount = space.sources?.length ?? 0;
    const chatsRegionId = `browse-spaces-fullscreen-row-chats-${space.id}`;
    let t5;
    if ($[7] !== cloudId || $[8] !== experienceId || $[9] !== product || $[10] !== space.id) {
        t5 = {
            spaceId: space.id,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId,
            enabled: true
        };
        $[7] = cloudId;
        $[8] = experienceId;
        $[9] = product;
        $[10] = space.id;
        $[11] = t5;
    } else t5 = $[11];
    const { conversationPage: conversationPage, isLoading: isChatsLoading, error: spaceChatsError } = (0, $00719b79ddea4cb7$export$fa8943ec3a6d0129)(t5);
    conversationPage?.conversations;
    let t6;
    if ($[12] !== conversationPage?.conversations) {
        t6 = conversationPage?.conversations ?? [];
        $[12] = conversationPage?.conversations;
        $[13] = t6;
    } else t6 = $[13];
    const fetchedChats = t6;
    let t7;
    if ($[14] !== activeConversationId || $[15] !== activeSpaceId || $[16] !== fetchedChats || $[17] !== localSpaceConversations || $[18] !== space.id) {
        t7 = $f46e57de210714b9$var$mergeFetchedAndLocalSpaceConversations({
            spaceId: space.id,
            fetchedConversations: fetchedChats,
            localSpaceConversations: localSpaceConversations,
            activeSpaceId: activeSpaceId,
            activeConversationId: activeConversationId
        });
        $[14] = activeConversationId;
        $[15] = activeSpaceId;
        $[16] = fetchedChats;
        $[17] = localSpaceConversations;
        $[18] = space.id;
        $[19] = t7;
    } else t7 = $[19];
    const chats = t7;
    const t8 = conversationPage?.totalCount;
    let t9;
    if ($[20] !== activeConversationId || $[21] !== activeSpaceId || $[22] !== fetchedChats || $[23] !== localSpaceConversations || $[24] !== space.id || $[25] !== t8) {
        t9 = $f46e57de210714b9$var$getFetchedSpaceConversationCount({
            spaceId: space.id,
            fetchedConversationCount: t8,
            fetchedConversations: fetchedChats,
            localSpaceConversations: localSpaceConversations,
            activeSpaceId: activeSpaceId,
            activeConversationId: activeConversationId
        });
        $[20] = activeConversationId;
        $[21] = activeSpaceId;
        $[22] = fetchedChats;
        $[23] = localSpaceConversations;
        $[24] = space.id;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    const fetchedChatCount = t9;
    const isChatCountLoading = fetchedChatCount === undefined && !spaceChatsError;
    let chatCount;
    let t10;
    if ($[27] !== chats || $[28] !== fetchedChatCount || $[29] !== formatMessage || $[30] !== space) {
        chatCount = fetchedChatCount !== undefined ? Math.max(fetchedChatCount, chats.length) : $f46e57de210714b9$var$getSpaceConversationCount(space);
        t10 = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).chatCount, {
            count: chatCount
        });
        $[27] = chats;
        $[28] = fetchedChatCount;
        $[29] = formatMessage;
        $[30] = space;
        $[31] = chatCount;
        $[32] = t10;
    } else {
        chatCount = $[31];
        t10 = $[32];
    }
    const chatCountText = t10;
    let t11;
    if ($[33] !== formatMessage || $[34] !== sourceCount) {
        t11 = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).sourceCount, {
            count: sourceCount
        });
        $[33] = formatMessage;
        $[34] = sourceCount;
        $[35] = t11;
    } else t11 = $[35];
    const sourceCountText = t11;
    const isWaitingForChats = isExpanded && isChatCountLoading;
    const hasExpandedChatsMismatch = isExpanded && chatCount > 0 && chats.length === 0;
    const shouldShowChatsLoadError = !isChatsLoading && !isWaitingForChats && (Boolean(spaceChatsError) || hasExpandedChatsMismatch);
    const shouldShowNoChats = !isChatsLoading && !isWaitingForChats && !spaceChatsError && !hasExpandedChatsMismatch && chats.length === 0;
    const shouldRenderChats = !isChatsLoading && !isWaitingForChats && !spaceChatsError && !hasExpandedChatsMismatch;
    if (isEditing) {
        const t12 = space.id;
        let t13;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
            t13 = (0, $w6R6I.cx)($f46e57de210714b9$var$styles.rowLayout, $f46e57de210714b9$var$styles.rowInlinePadding, $f46e57de210714b9$var$styles.rowBlockPadding, $f46e57de210714b9$var$styles.renameForm);
            $[36] = t13;
        } else t13 = $[36];
        let t14;
        if ($[37] !== formRef || $[38] !== hasRenameError || $[39] !== inputRef || $[40] !== isRenaming || $[41] !== localSpaceName || $[42] !== onCancelRename || $[43] !== onSubmitRename || $[44] !== space.id) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e3ffb46cea88f04$export$6fecef72e09fc5cc), {
                spaceId: t12,
                formRef: formRef,
                inputRef: inputRef,
                formXcss: t13,
                hasRenameError: hasRenameError,
                isRenaming: isRenaming,
                localSpaceName: localSpaceName,
                onCancelRename: onCancelRename,
                onSubmitRename: onSubmitRename
            });
            $[37] = formRef;
            $[38] = hasRenameError;
            $[39] = inputRef;
            $[40] = isRenaming;
            $[41] = localSpaceName;
            $[42] = onCancelRename;
            $[43] = onSubmitRename;
            $[44] = space.id;
            $[45] = t14;
        } else t14 = $[45];
        return t14;
    }
    let t12;
    if ($[46] !== chatCountText || $[47] !== chatsRegionId || $[48] !== emojiProvider || $[49] !== formatMessage || $[50] !== handleClick || $[51] !== isChatCountLoading || $[52] !== isExpanded || $[53] !== isSearchResult || $[54] !== sourceCountText || $[55] !== space.emoji || $[56] !== space.id || $[57] !== space.name) {
        t12 = (t13)=>{
            const { rowInteractionProps: rowInteractionProps, actions: actions } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.rowLayout, $f46e57de210714b9$var$styles.rowContainerGap, $f46e57de210714b9$var$styles.rowInlinePadding, $f46e57de210714b9$var$styles.row, isSearchResult && $f46e57de210714b9$var$styles.searchResultRow),
                ...rowInteractionProps,
                testId: `browse-spaces-fullscreen-row-container-${space.id}`
            }, !isChatCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).spaceChatsToggleLabel, {
                    spaceName: space.name
                }),
                "aria-expanded": isExpanded,
                "aria-controls": isExpanded ? chatsRegionId : undefined,
                onClick: handleToggleChats,
                testId: `browse-spaces-fullscreen-row-toggle-${space.id}`
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.rowTogglePlaceholder,
                "aria-hidden": "true",
                testId: `browse-spaces-fullscreen-row-toggle-placeholder-${space.id}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.rowLayout, $f46e57de210714b9$var$styles.rowContentGap, $f46e57de210714b9$var$styles.rowBlockPadding, $f46e57de210714b9$var$styles.rowButton),
                onClick: handleClick,
                testId: `browse-spaces-fullscreen-row-${space.id}`
            }, space.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.emojiTile,
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                emojiId: {
                    id: space.emoji,
                    shortName: space.emoji
                },
                emojiProvider: emojiProvider,
                fitToHeight: 16
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
                label: "",
                appearance: "gray",
                size: "medium"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.rowText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.rowName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "medium"
            }, space.name)), isChatCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.rowMetadataSkeleton,
                testId: `browse-spaces-fullscreen-row-metadata-skeleton-${space.id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                width: "100%",
                height: 14,
                isShimmering: true,
                borderRadius: "var(--ds-radius-small, 4px)"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.rowMetadata
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, chatCountText, " \u2022 ", sourceCountText)))), actions);
        };
        $[46] = chatCountText;
        $[47] = chatsRegionId;
        $[48] = emojiProvider;
        $[49] = formatMessage;
        $[50] = handleClick;
        $[51] = isChatCountLoading;
        $[52] = isExpanded;
        $[53] = isSearchResult;
        $[54] = sourceCountText;
        $[55] = space.emoji;
        $[56] = space.id;
        $[57] = space.name;
        $[58] = t12;
    } else t12 = $[58];
    let t13;
    if ($[59] !== onDeleteSpace || $[60] !== onRenameBtnClicked || $[61] !== space || $[62] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34d6a3e5a14abc2e$export$f222c0d10838fe9d), {
            space: space,
            onRename: onRenameBtnClicked,
            onDeleteSpace: onDeleteSpace
        }, t12);
        $[59] = onDeleteSpace;
        $[60] = onRenameBtnClicked;
        $[61] = space;
        $[62] = t12;
        $[63] = t13;
    } else t13 = $[63];
    let t14;
    if ($[64] !== chats || $[65] !== chatsRegionId || $[66] !== cloudId || $[67] !== formatMessage || $[68] !== isChatsLoading || $[69] !== isExpanded || $[70] !== isWaitingForChats || $[71] !== onSelectSpaceChat || $[72] !== shouldRenderChats || $[73] !== shouldShowChatsLoadError || $[74] !== shouldShowNoChats || $[75] !== space.id) {
        t14 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            id: chatsRegionId,
            xcss: $f46e57de210714b9$var$styles.spaceChats,
            role: "list",
            testId: `browse-spaces-fullscreen-row-chats-${space.id}`
        }, (isChatsLoading || isWaitingForChats) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.spaceChatsState,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).loadingChatsLabel)
        })), shouldShowChatsLoadError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.spaceChatsState,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.danger"
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).chatsErrorTitle))), shouldShowNoChats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.spaceChatsState,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.disabled"
        }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).noChatsTitle))), shouldRenderChats && chats.map((chat, index)=>{
            const chatTitle = chat.name || formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).untitledChat);
            const chatWithTitle = {
                ...chat,
                name: chatTitle
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: chat.id,
                xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.spaceChatItem, index > 0 && $f46e57de210714b9$var$styles.spaceChatItemDivider),
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.spaceChatContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.spaceChatIcon,
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dovdS))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon, #292A2E)"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f46e57de210714b9$var$styles.spaceChatItemContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
                conversation: chatWithTitle,
                onConversationSelect: ()=>onSelectSpaceChat?.(chatWithTitle),
                isSpinnerOverlayConversationIconEnabled: false,
                hideActions: true,
                hasParentHoverBackground: true,
                cloudId: cloudId,
                testId: "browse-spaces-fullscreen-space-chat-item",
                ariaLabel: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).openChatLabel, {
                    name: chatTitle
                })
            }))));
        }));
        $[64] = chats;
        $[65] = chatsRegionId;
        $[66] = cloudId;
        $[67] = formatMessage;
        $[68] = isChatsLoading;
        $[69] = isExpanded;
        $[70] = isWaitingForChats;
        $[71] = onSelectSpaceChat;
        $[72] = shouldRenderChats;
        $[73] = shouldShowChatsLoadError;
        $[74] = shouldShowNoChats;
        $[75] = space.id;
        $[76] = t14;
    } else t14 = $[76];
    let t15;
    if ($[77] !== t13 || $[78] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t13, t14);
        $[77] = t13;
        $[78] = t14;
        $[79] = t15;
    } else t15 = $[79];
    return t15;
} : ({ space: space, emojiProvider: emojiProvider, renameSpace: renameSpace, onDeleteSpace: onDeleteSpace, onSelectSpace: onSelectSpace, onSelectSpaceChat: onSelectSpaceChat, localSpaceConversations: localSpaceConversations, activeSpaceId: activeSpaceId, activeConversationId: activeConversationId, cloudId: cloudId, product: product, experienceId: experienceId, isSearchResult: isSearchResult = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { formRef: formRef, inputRef: inputRef, isEditing: isEditing, localSpaceName: localSpaceName, hasRenameError: hasRenameError, isRenaming: isRenaming, onCancelRename: onCancelRename, onRenameBtnClicked: onRenameBtnClicked, onSubmitRename: onSubmitRename } = (0, $6028e15caa415103$export$6b07a1eaaaddb91b)({
        space: space,
        renameSpace: renameSpace
    });
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelectSpace(space);
    }, [
        space,
        onSelectSpace
    ]);
    const handleToggleChats = (0, $cozmU.useCallback)(()=>{
        setIsExpanded((current)=>!current);
    }, []);
    const sourceCount = space.sources?.length ?? 0;
    const chatsRegionId = `browse-spaces-fullscreen-row-chats-${space.id}`; // Prefetch the default conversations page as soon as the Browse spaces row
    // mounts. This gives the collapsed metadata an authoritative totalCount and
    // warms the expanded chat list before the user clicks the row arrow.
    const { conversationPage: conversationPage, isLoading: isChatsLoading, error: spaceChatsError } = (0, $00719b79ddea4cb7$export$fa8943ec3a6d0129)({
        spaceId: space.id,
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        enabled: true
    });
    const fetchedChats = (0, $cozmU.useMemo)(()=>conversationPage?.conversations ?? [], [
        conversationPage?.conversations
    ]);
    const chats = (0, $cozmU.useMemo)(()=>$f46e57de210714b9$var$mergeFetchedAndLocalSpaceConversations({
            spaceId: space.id,
            fetchedConversations: fetchedChats,
            localSpaceConversations: localSpaceConversations,
            activeSpaceId: activeSpaceId,
            activeConversationId: activeConversationId
        }), [
        space.id,
        fetchedChats,
        localSpaceConversations,
        activeSpaceId,
        activeConversationId
    ]);
    const fetchedChatCount = $f46e57de210714b9$var$getFetchedSpaceConversationCount({
        spaceId: space.id,
        fetchedConversationCount: conversationPage?.totalCount,
        fetchedConversations: fetchedChats,
        localSpaceConversations: localSpaceConversations,
        activeSpaceId: activeSpaceId,
        activeConversationId: activeConversationId
    });
    const isChatCountLoading = fetchedChatCount === undefined && !spaceChatsError;
    const chatCount = fetchedChatCount !== undefined ? Math.max(fetchedChatCount, chats.length) : $f46e57de210714b9$var$getSpaceConversationCount(space);
    const chatCountText = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).chatCount, {
        count: chatCount
    });
    const sourceCountText = formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).sourceCount, {
        count: sourceCount
    });
    const isWaitingForChats = isExpanded && isChatCountLoading;
    const hasExpandedChatsMismatch = isExpanded && chatCount > 0 && chats.length === 0;
    const shouldShowChatsLoadError = !isChatsLoading && !isWaitingForChats && (Boolean(spaceChatsError) || hasExpandedChatsMismatch);
    const shouldShowNoChats = !isChatsLoading && !isWaitingForChats && !spaceChatsError && !hasExpandedChatsMismatch && chats.length === 0;
    const shouldRenderChats = !isChatsLoading && !isWaitingForChats && !spaceChatsError && !hasExpandedChatsMismatch;
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e3ffb46cea88f04$export$6fecef72e09fc5cc), {
        spaceId: space.id,
        formRef: formRef,
        inputRef: inputRef,
        formXcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.rowLayout, $f46e57de210714b9$var$styles.rowInlinePadding, $f46e57de210714b9$var$styles.rowBlockPadding, $f46e57de210714b9$var$styles.renameForm),
        hasRenameError: hasRenameError,
        isRenaming: isRenaming,
        localSpaceName: localSpaceName,
        onCancelRename: onCancelRename,
        onSubmitRename: onSubmitRename
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34d6a3e5a14abc2e$export$f222c0d10838fe9d), {
        space: space,
        onRename: onRenameBtnClicked,
        onDeleteSpace: onDeleteSpace
    }, ({ rowInteractionProps: rowInteractionProps, actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.rowLayout, $f46e57de210714b9$var$styles.rowContainerGap, $f46e57de210714b9$var$styles.rowInlinePadding, $f46e57de210714b9$var$styles.row, isSearchResult && $f46e57de210714b9$var$styles.searchResultRow),
            ...rowInteractionProps,
            testId: `browse-spaces-fullscreen-row-container-${space.id}`
        }, !isChatCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).spaceChatsToggleLabel, {
                spaceName: space.name
            }),
            "aria-expanded": isExpanded,
            "aria-controls": isExpanded ? chatsRegionId : undefined,
            onClick: handleToggleChats,
            testId: `browse-spaces-fullscreen-row-toggle-${space.id}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.rowTogglePlaceholder,
            "aria-hidden": "true",
            testId: `browse-spaces-fullscreen-row-toggle-placeholder-${space.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.rowLayout, $f46e57de210714b9$var$styles.rowContentGap, $f46e57de210714b9$var$styles.rowBlockPadding, $f46e57de210714b9$var$styles.rowButton),
            onClick: handleClick,
            testId: `browse-spaces-fullscreen-row-${space.id}`
        }, space.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.emojiTile,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: {
                id: space.emoji,
                shortName: space.emoji
            },
            emojiProvider: emojiProvider,
            fitToHeight: 16
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
            label: "",
            appearance: "gray",
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.rowText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.rowName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium"
        }, space.name)), isChatCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.rowMetadataSkeleton,
            testId: `browse-spaces-fullscreen-row-metadata-skeleton-${space.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: 14,
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.rowMetadata
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, chatCountText, " \u2022 ", sourceCountText)))), actions)), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: chatsRegionId,
        xcss: $f46e57de210714b9$var$styles.spaceChats,
        role: "list",
        testId: `browse-spaces-fullscreen-row-chats-${space.id}`
    }, (isChatsLoading || isWaitingForChats) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.spaceChatsState,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).loadingChatsLabel)
    })), shouldShowChatsLoadError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.spaceChatsState,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).chatsErrorTitle))), shouldShowNoChats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.spaceChatsState,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.disabled"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).noChatsTitle))), shouldRenderChats && chats.map((chat, index)=>{
        const chatTitle = chat.name || formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).untitledChat);
        const chatWithTitle = {
            ...chat,
            name: chatTitle
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: chat.id,
            xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.spaceChatItem, index > 0 && $f46e57de210714b9$var$styles.spaceChatItemDivider),
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.spaceChatContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.spaceChatIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dovdS))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon, #292A2E)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.spaceChatItemContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
            conversation: chatWithTitle,
            onConversationSelect: ()=>onSelectSpaceChat?.(chatWithTitle),
            isSpinnerOverlayConversationIconEnabled: false,
            hideActions: true,
            hasParentHoverBackground: true,
            cloudId: cloudId,
            testId: "browse-spaces-fullscreen-space-chat-item",
            ariaLabel: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).openChatLabel, {
                name: chatTitle
            })
        }))));
    })));
};
const $f46e57de210714b9$export$fa4316bad98ca0eb = ({ cloudId: cloudId, product: product, experienceId: experienceId, assistanceServiceParams: assistanceServiceParams, onSelectSpace: onSelectSpace, onSelectSpaceChat: onSelectSpaceChat, localSpaceConversations: localSpaceConversations, activeSpaceId: activeSpaceId, activeConversationId: activeConversationId, onSpaceCreated: onSpaceCreated, onViewRecommendedSpaces: onViewRecommendedSpaces, chatRefreshHeader: chatRefreshHeader, layout: layout = 'sidebar' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { fireSpaceSearched: fireSpaceSearched } = (0, $7CqGl.useSpacesAnalytics)(); // Blank query shows the full list; non-blank query switches to server-side search.
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const [isCreateSpaceModalOpen, setIsCreateSpaceModalOpen] = (0, $cozmU.useState)(false);
    const [spaceToDelete, setSpaceToDelete] = (0, $cozmU.useState)(undefined);
    const { deleteSpace: deleteSpace } = (0, $caa0451413d57c80$export$fb4d1ac6bee39cfb)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId
    });
    const { renameSpace: renameSpace } = (0, $09fc8399fb744e1c$export$3a6d3c054cf6f88d)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId
    }); // Defence-in-depth: skip the fetch entirely when the experiment is off, even
    // though hosts should not render this component in that case.
    const isSpacesFEEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const trimmedSearchQuery = searchQuery.trim();
    const isSearchQueryEmpty = trimmedSearchQuery.length === 0;
    const listResult = (0, $9dT53.useListSpaces)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        skip: !isSpacesFEEnabled
    });
    const searchResult = (0, $ff1a6e6cc93a8de4$export$1e7662bb7b25ce15)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        searchQuery: searchQuery,
        skip: !isSpacesFEEnabled || isSearchQueryEmpty
    }); // Fire the screen-view event once on mount. Mirrors `agentsFullPageView`.
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatBrowseSpaces',
            attributes: {
                touchpointSource: assistanceServiceParams?.touchpointSource
            }
        }); // Intentional once-on-mount fire — see also BrowseAgentsFullscreenNew.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fire one `searched` event per distinct completed search — once results
    // resolve for a non-blank query, not on every keystroke.
    const lastSearchedQueryRef = (0, $cozmU.useRef)('');
    (0, $cozmU.useEffect)(()=>{
        const trimmed = searchQuery.trim();
        if (!trimmed) {
            // Reset so returning to the same term later logs a fresh search.
            lastSearchedQueryRef.current = '';
            return;
        }
        if (searchResult.isLoading || lastSearchedQueryRef.current === trimmed) return;
        lastSearchedQueryRef.current = trimmed;
        fireSpaceSearched({
            queryLength: trimmed.length,
            resultCount: searchResult.spaces?.length
        });
    }, [
        searchQuery,
        searchResult.isLoading,
        searchResult.spaces,
        fireSpaceSearched
    ]);
    const openCreateSpaceModal = (0, $cozmU.useCallback)(()=>{
        setIsCreateSpaceModalOpen(true);
    }, []);
    const closeCreateSpaceModal = (0, $cozmU.useCallback)(()=>{
        setIsCreateSpaceModalOpen(false);
    }, []);
    const openDeleteSpaceModal = (0, $cozmU.useCallback)((space)=>{
        setSpaceToDelete(space);
    }, []);
    const closeDeleteSpaceModal = (0, $cozmU.useCallback)(()=>{
        setSpaceToDelete(undefined);
    }, []); // Single shared emoji provider for every row. The provider only depends
    // on `cloudId` (which is constant across this view), so creating it once
    // here avoids instantiating N providers when rendering N rows.
    const sharedEmojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProvider)(cloudId), [
        cloudId
    ]); // Mirror the host-level optimistic-add pattern used in `main.tsx` (line
    // ~638) and `rovo-side-navigation/index.tsx` (which explicitly defers to
    // the host for this very reason). The shared `SpaceStore` is the single
    // source of truth for both the side-nav list and our list (both render via
    // `useListSpaces` → `spaceStore`); pushing the new space into the store
    // makes it appear here AND in the side nav instantly, with no extra
    // network round-trip.
    const { addSpace: addSpace } = (0, $12shJ.useSpaceStoreActions)();
    const handleSpaceCreated = (0, $cozmU.useCallback)((space, emojiId)=>{
        setIsCreateSpaceModalOpen(false);
        addSpace(space, emojiId);
        onSpaceCreated?.(space, emojiId);
    }, [
        addSpace,
        onSpaceCreated
    ]);
    const isFullscreenLayout = layout === 'fullscreen';
    const localSpaceConversationsBySpaceId = (0, $cozmU.useMemo)(()=>{
        const conversationsBySpaceId = new Map();
        localSpaceConversations?.forEach((conversation)=>{
            const conversationSpaceId = conversation.rovoSpaceId ?? (activeSpaceId !== undefined && conversation.id === activeConversationId ? activeSpaceId : undefined);
            if (conversationSpaceId === undefined) return;
            const conversationsForSpace = conversationsBySpaceId.get(conversationSpaceId);
            if (conversationsForSpace !== undefined) {
                conversationsForSpace.push(conversation);
                return;
            }
            conversationsBySpaceId.set(conversationSpaceId, [
                conversation
            ]);
        });
        return conversationsBySpaceId;
    }, [
        localSpaceConversations,
        activeSpaceId,
        activeConversationId
    ]);
    const listSpaceIds = (0, $cozmU.useMemo)(()=>listResult.spaces.map((space)=>space.id), [
        listResult.spaces
    ]);
    const { conversationsBySpaceId: searchSpaceConversationsBySpaceId, isLoading: isSearchChatsLoading } = (0, $dd8bb6bbfdd7eb11$export$12eb92daee0cfdf4)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        spaceIds: listSpaceIds,
        enabled: !isSearchQueryEmpty
    });
    const matchingLocalChats = (0, $cozmU.useMemo)(()=>{
        if (isSearchQueryEmpty) return [];
        const results = [];
        listResult.spaces.forEach((space)=>{
            const conversations = $f46e57de210714b9$var$mergeFetchedAndLocalSpaceConversations({
                spaceId: space.id,
                fetchedConversations: searchSpaceConversationsBySpaceId.get(space.id) ?? [],
                localSpaceConversations: localSpaceConversationsBySpaceId.get(space.id),
                activeSpaceId: activeSpaceId,
                activeConversationId: activeConversationId
            });
            conversations.forEach((conversation)=>{
                if ($f46e57de210714b9$var$doesConversationMatchSearch(conversation, trimmedSearchQuery)) results.push({
                    conversation: conversation,
                    space: space
                });
            });
        });
        return results;
    }, [
        activeConversationId,
        activeSpaceId,
        isSearchQueryEmpty,
        listResult.spaces,
        localSpaceConversationsBySpaceId,
        searchSpaceConversationsBySpaceId,
        trimmedSearchQuery
    ]);
    const spaces = (0, $cozmU.useMemo)(()=>isSearchQueryEmpty ? listResult.spaces : searchResult.spaces, [
        isSearchQueryEmpty,
        listResult.spaces,
        searchResult.spaces
    ]);
    const isLoading = isSearchQueryEmpty ? listResult.isLoading : searchResult.isLoading || listResult.isLoading;
    const error = isSearchQueryEmpty ? listResult.error : searchResult.error;
    const hasResults = spaces.length > 0 || matchingLocalChats.length > 0 || !isSearchQueryEmpty && isSearchChatsLoading;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.headerContainerBase, !isFullscreenLayout && $f46e57de210714b9$var$styles.sidebarHeaderContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f46e57de210714b9$var$styles.header,
        alignBlock: isFullscreenLayout ? 'start' : 'center'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "default",
        onClick: openCreateSpaceModal,
        testId: "rovo-spaces-browse-spaces-fullscreen-create-space-button"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).createSpaceButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.searchBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        placeholderText: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).searchPlaceholder),
        onSearch: setSearchQuery,
        isCompact: true
    }))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).loadingLabel)
    })), !isLoading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).errorTitle))), !isLoading && !error && !hasResults && // Branch on whether a search query is active so we don't
    // conflate "user has no spaces at all" with "search returned
    // no results".
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !isSearchQueryEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $f46e57de210714b9$var$styles.noResultsWrapper,
        alignInline: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a8ea7eeeb0f6216$exports))),
        alt: "",
        role: "presentation",
        width: 160,
        height: 160,
        "data-testid": "rovo-spaces-browse-spaces-fullscreen-no-results-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).searchEmptyStateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large"
    }, formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).searchEmptyStateQuery, {
        query: trimmedSearchQuery
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f19171fcb4ea0e73$export$d32bea11b1082c07), {
        isFullscreenLayout: isFullscreenLayout,
        onCreateSpace: openCreateSpaceModal,
        onViewRecommendedSpaces: onViewRecommendedSpaces
    })), !isLoading && !error && hasResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.listContainerBase, !isSearchQueryEmpty && $f46e57de210714b9$var$styles.searchResultsContainer, !isFullscreenLayout && $f46e57de210714b9$var$styles.sidebarListContainer),
        role: "list",
        testId: "rovo-spaces-browse-spaces-fullscreen-list"
    }, spaces.map((space, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "listitem",
            key: space.id,
            xcss: !isSearchQueryEmpty ? $f46e57de210714b9$var$styles.searchResultItem : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f46e57de210714b9$var$SpaceRow, {
            space: space,
            emojiProvider: sharedEmojiProvider,
            renameSpace: renameSpace,
            onDeleteSpace: openDeleteSpaceModal,
            onSelectSpace: onSelectSpace,
            onSelectSpaceChat: onSelectSpaceChat,
            localSpaceConversations: localSpaceConversationsBySpaceId.get(space.id),
            activeSpaceId: activeSpaceId,
            activeConversationId: activeConversationId,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId,
            isSearchResult: !isSearchQueryEmpty
        }), isSearchQueryEmpty && index < spaces.length - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.rowDivider,
            testId: `browse-spaces-fullscreen-row-divider-${space.id}`
        }) : null)), matchingLocalChats.map(({ conversation: conversation, space: space }, index)=>{
        const chatTitle = conversation.name || formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).untitledChat);
        const chatWithTitle = {
            ...conversation,
            name: chatTitle
        };
        const spaceTitle = space.name.trim();
        const chatAriaLabel = spaceTitle ? formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).openChatInSpaceLabel, {
            name: chatTitle,
            spaceName: spaceTitle
        }) : formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).openChatLabel, {
            name: chatTitle
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "listitem",
            key: `${space.id}-${conversation.id}`,
            xcss: $f46e57de210714b9$var$styles.searchResultItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.searchChatItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f46e57de210714b9$var$styles.searchChatItemContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
            conversation: chatWithTitle,
            onConversationSelect: ()=>onSelectSpaceChat?.(chatWithTitle),
            isSpinnerOverlayConversationIconEnabled: false,
            hideActions: true,
            hasParentHoverBackground: true,
            cloudId: cloudId,
            testId: "browse-spaces-fullscreen-search-chat-item",
            ariaLabel: chatAriaLabel,
            footerPrefix: spaceTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050",
                xcss: $f46e57de210714b9$var$styles.searchChatSpaceMetadata
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $f46e57de210714b9$var$styles.searchChatSpaceMetadataName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "span",
                size: "small",
                weight: "regular",
                maxLines: 1,
                align: "start",
                color: "color.text.subtlest"
            }, spaceTitle))) : undefined
        }))));
    }), !isSearchQueryEmpty && isSearchChatsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "listitem",
        xcss: $f46e57de210714b9$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        label: formatMessage((0, $460025aacd94cc45$export$2e2bcd8739ae039).loadingChatsLabel)
    })) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($f46e57de210714b9$var$styles.wrapper, isFullscreenLayout ? $f46e57de210714b9$var$styles.fullscreenWrapper : $f46e57de210714b9$var$styles.sidebarWrapper),
        testId: "rovo-spaces-browse-spaces-fullscreen",
        alignBlock: "start"
    }, !isFullscreenLayout && chatRefreshHeader && chatRefreshHeader, isFullscreenLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f46e57de210714b9$var$styles.fullscreenContentContainer,
        testId: "rovo-spaces-browse-spaces-fullscreen-content"
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gh5g4.CreateSpaceModal), {
        isOpen: isCreateSpaceModalOpen,
        onClose: closeCreateSpaceModal,
        cloudId: cloudId,
        assistanceServiceParams: assistanceServiceParams,
        onCreated: handleSpaceCreated
    }), spaceToDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47b3db5602ad731d$export$8df669469ae96f03), {
        space: spaceToDelete,
        isOpen: true,
        onClose: closeDeleteSpaceModal,
        onDeleteConfirm: deleteSpace
    }) : null);
};
function $f46e57de210714b9$var$_temp(current) {
    return !current;
}


















const $167331d2b384157c$var$toRovoNavigationConversation = (conversation)=>({
        ...conversation,
        isEmpty: !conversation.lastMessage?.trim()
    });
const $167331d2b384157c$export$90ac96cb16b3a797 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { chatRefreshHeader: chatRefreshHeader } = t0;
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            touchpointSource: "browse-spaces-panel"
        };
        $[0] = t1;
    } else t1 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t1);
    (0, $bGNkz.useUIStoreSubscription)();
    const { clearSelectedSpace: clearSelectedSpace, setSelectedSpace: setSelectedSpace, setActiveMenu: setActiveMenu, setActiveTabId: setActiveTabId, setEmptyChatLaunch: setEmptyChatLaunch } = (0, $bGNkz.useUIStoreActions)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const [t2] = (0, $bGNkz.useSelectedSpaceSelector)();
    const { selectedSpace: selectedSpace } = t2;
    const [t3] = (0, $n71o5.useChatStore)();
    const { conversations: conversations, currentConversationId: currentConversationId } = t3;
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    let t4;
    if ($[1] !== conversations) {
        t4 = Object.values(conversations).map($167331d2b384157c$var$toRovoNavigationConversation);
        $[1] = conversations;
        $[2] = t4;
    } else t4 = $[2];
    const localSpaceConversations = t4;
    let t5;
    if ($[3] !== publish || $[4] !== setAIFeatureContext || $[5] !== setActiveMenu || $[6] !== setActiveTabId || $[7] !== setEmptyChatLaunch || $[8] !== setSelectedConversation || $[9] !== setSelectedSpace) {
        t5 = (space)=>{
            setSelectedSpace({
                id: space.id,
                name: space.name,
                emoji: space.emoji ?? undefined,
                entryPoint: "sidebar"
            });
            setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
            setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
            });
            const projectContext = {
                projectId: space.id,
                projectName: space.name,
                projectUrl: "",
                spaceId: space.id
            };
            setAIFeatureContext({
                contextKey: "projectContext",
                setContext: (_)=>projectContext
            });
            setEmptyChatLaunch({
                replaceProviderActions: true,
                projectContext: projectContext
            });
            publish({
                type: "space-selected",
                source: "browse-spaces-view",
                data: {
                    spaceId: space.id,
                    title: space.name,
                    emoji: space.emoji ?? "",
                    entryPoint: "sidebar"
                }
            });
            setActiveMenu("none");
        };
        $[3] = publish;
        $[4] = setAIFeatureContext;
        $[5] = setActiveMenu;
        $[6] = setActiveTabId;
        $[7] = setEmptyChatLaunch;
        $[8] = setSelectedConversation;
        $[9] = setSelectedSpace;
        $[10] = t5;
    } else t5 = $[10];
    const handleSelectSpace = t5;
    let t6;
    if ($[11] !== clearSelectedSpace || $[12] !== setActiveMenu || $[13] !== setSelectedConversation) {
        t6 = (chat)=>{
            clearSelectedSpace();
            setSelectedConversation({
                conversationId: chat.id,
                conversationMetadata: chat
            });
            setActiveMenu("none");
        };
        $[11] = clearSelectedSpace;
        $[12] = setActiveMenu;
        $[13] = setSelectedConversation;
        $[14] = t6;
    } else t6 = $[14];
    const handleSelectSpaceChat = t6;
    let t7;
    if ($[15] !== setActiveMenu || $[16] !== setSelectedConversation) {
        t7 = ()=>{
            setActiveMenu("recommended-spaces");
            setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
            });
        };
        $[15] = setActiveMenu;
        $[16] = setSelectedConversation;
        $[17] = t7;
    } else t7 = $[17];
    const handleViewRecommendedSpaces = t7;
    const layout = fullScreen ? "fullscreen" : "sidebar";
    const t8 = fullScreen ? undefined : chatRefreshHeader;
    const t9 = assistanceServiceParams.product ?? "rovo";
    const t10 = assistanceServiceParams.experienceId ?? "ai-mate";
    const t11 = selectedSpace?.id;
    let t12;
    if ($[18] !== assistanceServiceParams || $[19] !== currentConversationId || $[20] !== handleSelectSpace || $[21] !== handleSelectSpaceChat || $[22] !== handleViewRecommendedSpaces || $[23] !== layout || $[24] !== localSpaceConversations || $[25] !== siteId || $[26] !== t10 || $[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f46e57de210714b9$export$fa4316bad98ca0eb), {
            chatRefreshHeader: t8,
            layout: layout,
            cloudId: siteId,
            product: t9,
            experienceId: t10,
            assistanceServiceParams: assistanceServiceParams,
            onSelectSpace: handleSelectSpace,
            onSelectSpaceChat: handleSelectSpaceChat,
            onViewRecommendedSpaces: handleViewRecommendedSpaces,
            localSpaceConversations: localSpaceConversations,
            activeSpaceId: t11,
            activeConversationId: currentConversationId
        });
        $[18] = assistanceServiceParams;
        $[19] = currentConversationId;
        $[20] = handleSelectSpace;
        $[21] = handleSelectSpaceChat;
        $[22] = handleViewRecommendedSpaces;
        $[23] = layout;
        $[24] = localSpaceConversations;
        $[25] = siteId;
        $[26] = t10;
        $[27] = t11;
        $[28] = t8;
        $[29] = t9;
        $[30] = t12;
    } else t12 = $[30];
    return t12;
} : ({ chatRefreshHeader: chatRefreshHeader })=>{
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'browse-spaces-panel'
    });
    (0, $bGNkz.useUIStoreSubscription)();
    const { clearSelectedSpace: clearSelectedSpace, setSelectedSpace: setSelectedSpace, setActiveMenu: setActiveMenu, setActiveTabId: setActiveTabId, setEmptyChatLaunch: setEmptyChatLaunch } = (0, $bGNkz.useUIStoreActions)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    const [{ conversations: conversations, currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const localSpaceConversations = (0, $cozmU.useMemo)(()=>Object.values(conversations).map($167331d2b384157c$var$toRovoNavigationConversation), [
        conversations
    ]);
    const handleSelectSpace = (0, $cozmU.useCallback)((space)=>{
        // Mirrors `handleSelectSpace` in `rovo-side-navigation/index.tsx`
        // (without the `closeNav` branch — this view is rendered inside the
        // chat panel itself, so there's nothing to close).
        setSelectedSpace({
            id: space.id,
            name: space.name,
            emoji: space.emoji ?? undefined,
            entryPoint: 'sidebar'
        });
        setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        const projectContext = {
            projectId: space.id,
            projectName: space.name,
            // projectUrl is intentionally empty — Rovo Spaces do not have
            // a canonical URL. Matches the established pattern in
            // `rovo-side-navigation/handleSelectSpace` (line ~184) and
            // `chat-history/index.tsx` (line ~233 / 356). Downstream
            // consumers (e.g. `pickContextBannerUrl`) already treat an
            // empty string as "no URL available" and fall back gracefully.
            projectUrl: '',
            spaceId: space.id
        };
        setAIFeatureContext({
            contextKey: 'projectContext',
            setContext: (_)=>projectContext
        });
        setEmptyChatLaunch({
            replaceProviderActions: true,
            projectContext: projectContext
        });
        publish({
            type: 'space-selected',
            source: 'browse-spaces-view',
            data: {
                spaceId: space.id,
                title: space.name,
                emoji: space.emoji ?? '',
                entryPoint: 'sidebar'
            }
        });
        // Close the browse view by flipping activeMenu back to 'none' — this
        // hands focus back to the regular chat surface, which now shows the
        // selected space's empty chat with starters.
        setActiveMenu('none');
    }, [
        setSelectedSpace,
        setActiveTabId,
        setSelectedConversation,
        setAIFeatureContext,
        setEmptyChatLaunch,
        publish,
        setActiveMenu
    ]);
    const handleSelectSpaceChat = (0, $cozmU.useCallback)((chat)=>{
        clearSelectedSpace();
        setSelectedConversation({
            conversationId: chat.id,
            conversationMetadata: chat
        });
        setActiveMenu('none');
    }, [
        clearSelectedSpace,
        setActiveMenu,
        setSelectedConversation
    ]);
    const handleViewRecommendedSpaces = (0, $cozmU.useCallback)(()=>{
        setActiveMenu('recommended-spaces');
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
    }, [
        setActiveMenu,
        setSelectedConversation
    ]);
    const layout = fullScreen ? 'fullscreen' : 'sidebar';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f46e57de210714b9$export$fa4316bad98ca0eb), {
        chatRefreshHeader: fullScreen ? undefined : chatRefreshHeader,
        layout: layout,
        cloudId: siteId,
        product: assistanceServiceParams.product ?? 'rovo',
        experienceId: assistanceServiceParams.experienceId ?? 'ai-mate',
        assistanceServiceParams: assistanceServiceParams,
        onSelectSpace: handleSelectSpace,
        onSelectSpaceChat: handleSelectSpaceChat,
        onViewRecommendedSpaces: handleViewRecommendedSpaces,
        localSpaceConversations: localSpaceConversations,
        activeSpaceId: selectedSpace?.id,
        activeConversationId: currentConversationId
    });
};



























var $7TSZS = parcelRequire("7TSZS");


var $bh4C9 = parcelRequire("bh4C9");























var $isp1U = parcelRequire("isp1U");










/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






























var $1VhsF = parcelRequire("1VhsF");








const $3e6ff74860adf659$var$message = (0, $kSwu1.defineMessages)({
    deleteConversationTitle: {
        id: "ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final",
        defaultMessage: "Delete Conversation \"{name}\"?"
    },
    modalBody: {
        id: "ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final",
        defaultMessage: "Are you sure you want to delete this conversation? This action cannot be undone."
    },
    deleteButtonLabel: {
        id: "ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final",
        defaultMessage: "Delete"
    },
    cancelButtonLabel: {
        id: "ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final",
        defaultMessage: "Cancel"
    },
    genericErrorMessage: {
        id: "ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final",
        defaultMessage: "An error occurred while deleting the conversation. Please try again."
    },
    conversationNotFoundErrorMessage: {
        id: "ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final",
        defaultMessage: "The conversation you are trying to delete does not exist."
    }
});
var $3e6ff74860adf659$export$2e2bcd8739ae039 = $3e6ff74860adf659$var$message;


const $09227ba992b2f51d$var$styles = {
    errorContainer: "_3138425zaO"
};
const $09227ba992b2f51d$export$47cf2b6f3b49166a = ({ onDeleteConfirm: onDeleteConfirm, analyticsAttributes: { touchpointSource: touchpointSource } = {} })=>{
    (0, $6cFsl.di)((0, $08aaee4c987ae451$export$3b5a3be90f35989a));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)();
    const { isOpen: isOpen, mode: mode, conversation: conversation, closeModal: closeModal } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const isModalOpen = isOpen && mode === 'delete';
    const onDeleteClick = async (e)=>{
        sendAnalyticsEvent(e.update({
            actionSubjectId: 'deleteConversationModalConfirmButton',
            attributes: {
                conversationId: conversation.id,
                touchpointSource: touchpointSource
            }
        }));
        setIsSubmitting(true);
        try {
            const result = await onDeleteConfirm();
            if (result?.error) setError(result.error);
            else {
                closeModal();
                setError(undefined);
            }
        } catch (e_0) {
            setError(formatMessage((0, $3e6ff74860adf659$export$2e2bcd8739ae039).genericErrorMessage));
        } finally{
            setIsSubmitting(false);
        }
    };
    const onCancelClick = (e_1)=>{
        sendAnalyticsEvent(e_1.update({
            actionSubjectId: 'deleteConversationModalCancelButton',
            attributes: {
                conversationId: conversation.id,
                touchpointSource: touchpointSource
            }
        }));
        setError(undefined);
        closeModal();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isModalOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: (_, e_2)=>onCancelClick(e_2),
        width: "small",
        testId: "deleteConversationModal"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $3e6ff74860adf659$export$2e2bcd8739ae039).deleteConversationTitle, {
        name: conversation.name
    }))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, formatMessage((0, $3e6ff74860adf659$export$2e2bcd8739ae039).modalBody)), !!error?.length && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $09227ba992b2f51d$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
        appearance: "error"
    }, error)))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: (__0, e_3)=>onCancelClick(e_3)
    }, formatMessage((0, $3e6ff74860adf659$export$2e2bcd8739ae039).cancelButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        isLoading: isSubmitting,
        appearance: "danger",
        onClick: (__1, e_4)=>onDeleteClick(e_4)
    }, formatMessage((0, $3e6ff74860adf659$export$2e2bcd8739ae039).deleteButtonLabel)))));
};

















var $7BfeF = parcelRequire("7BfeF");



var $dQLwo = parcelRequire("dQLwo");















var $4yg9g = parcelRequire("4yg9g");








const $945e2cdc7b1fce8c$var$message = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final",
        defaultMessage: "Edit Conversation"
    },
    editNameLabel: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final",
        defaultMessage: "Name"
    },
    cancelButtonLabel: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final",
        defaultMessage: "Cancel"
    },
    saveButtonLabel: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final",
        defaultMessage: "Save"
    },
    nameIsSameErrorMessage: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final",
        defaultMessage: "The name is the same as the current name."
    },
    channelNotFoundError: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final",
        defaultMessage: "The channel you are trying to edit does not exist."
    },
    genericError: {
        id: "ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final",
        defaultMessage: "An error occurred while editing the conversation. Please try again."
    }
});
var $945e2cdc7b1fce8c$export$2e2bcd8739ae039 = $945e2cdc7b1fce8c$var$message;


const $f2b858d9959a74e7$export$ad3d70e3310e31db = ({ onEditConfirm: onEditConfirm })=>{
    (0, $6cFsl.di)((0, $08aaee4c987ae451$export$3b5a3be90f35989a));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOpen: isOpen, conversation: conversation, mode: mode, closeModal: closeModal } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const isModalOpen = isOpen && mode === 'edit';
    const nameInputRef = (0, $cozmU.useRef)(null);
    const onSubmit = async (fields)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editConversationModalSaveButton',
            attributes: {
                conversationId: conversation.id
            }
        });
        if (fields.name?.toLocaleLowerCase().trim() === conversation.name.toLocaleLowerCase().trim()) return {
            name: formatMessage((0, $945e2cdc7b1fce8c$export$2e2bcd8739ae039).nameIsSameErrorMessage)
        };
        try {
            const result = await onEditConfirm(fields.name.trim());
            if (result?.error) return {
                name: result.error
            };
            closeModal();
        } catch  {
            return {
                name: formatMessage((0, $945e2cdc7b1fce8c$export$2e2bcd8739ae039).genericError)
            };
        }
    };
    const onCancel = (e)=>{
        sendAnalyticsEvent(e.update({
            actionSubjectId: 'editConversationModalCancelButton',
            attributes: {
                conversationId: conversation.id
            }
        }));
        closeModal();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        autoFocus: nameInputRef,
        shouldCloseOnEscapePress: false,
        onClose: (_, e_0)=>onCancel(e_0),
        width: "small",
        testId: "editConversationModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $945e2cdc7b1fce8c$export$2e2bcd8739ae039).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            label: formatMessage((0, $945e2cdc7b1fce8c$export$2e2bcd8739ae039).editNameLabel),
            isRequired: true,
            defaultValue: conversation?.name
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                defaultValue: conversation.name,
                ...fieldProps,
                ref: nameInputRef
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: (__0, e_1)=>onCancel(e_1)
        }, formatMessage((0, $945e2cdc7b1fce8c$export$2e2bcd8739ae039).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isLoading: submitting,
            appearance: "primary",
            type: "submit"
        }, formatMessage((0, $945e2cdc7b1fce8c$export$2e2bcd8739ae039).saveButtonLabel)))))));
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $47bbw = parcelRequire("47bbw");


var $iRqYE = parcelRequire("iRqYE");


var $mfdwv = parcelRequire("mfdwv");


var $6spAz = parcelRequire("6spAz");








var $gVrmv = parcelRequire("gVrmv");


var $kyJuy = parcelRequire("kyJuy");


var $4HbMh = parcelRequire("4HbMh");


var $11OF7 = parcelRequire("11OF7");








var $4o0zT = parcelRequire("4o0zT");








var $hSR6U = parcelRequire("hSR6U");




const $85810b69489172e7$var$chatHeaderTestIdPrefix = 'rovo-chat-header';
const $85810b69489172e7$export$cad53202c09accc9 = {
    container: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-container`,
    backButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-back-button`,
    menuButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-menu-button`,
    newChatButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-new-chat-button`,
    moreMenuPopup: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-more-menu-popup`,
    switchModeButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-switch-mode-button`,
    splitLayoutButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-split-layout-button`,
    fullScreenButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-fullscreen-button`,
    feedbackButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-feedback-button`,
    getHelpButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-get-help-button`,
    debugButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-debug-button`,
    renameButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-rename-button`,
    deleteButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-delete-button`,
    miniModalButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-mini-modal-button`,
    sidebarButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-sidebar-button`,
    fullScreenModalButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-full-screen-modal-button`,
    moreMenuButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-more-menu-button`,
    closeButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-close-button`,
    desktopAppButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-desktop-app-button`,
    slackAppButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-slack-app-button`,
    teamsAppButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-teams-app-button`,
    chromeExtensionButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-chrome-extension-button`,
    cliButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-cli-button`,
    mobileAppButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-mobile-app-button`,
    moreMenuBackButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-more-menu-back-button`,
    storeMessagesCheckbox: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-store-messages-checkbox`,
    sitePickerMenuItem: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-site-picker-menu-item`,
    settingsButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-settings-button`,
    whatsNewButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-whats-new-button`,
    shareButton: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-share-button`,
    moreMenuPostOfficeSpotlightWrapper: `${$85810b69489172e7$var$chatHeaderTestIdPrefix}-more-menu-post-office-spotlight-wrapper`
};



var $1Rgab = parcelRequire("1Rgab");


var $jW2nL = parcelRequire("jW2nL");











var $2uDbg = parcelRequire("2uDbg");













const $2aa2e7d477e414e4$var$styles = {
    checkboxMenuItem: "_2mHwu8gVvo _0bjKvDKTcp _39xV02N91d _3iDTPbQ4SZ _0aFT5v1qpb _4kiQYAUofl _0hPCNLchRC _2fwxA5ecOK _0wOv4Q7zJH _0KLXru66of _0Of8r21Y8M _2Zuz6QgVvo _1wydGW1Y8M",
    checkboxContent: "_2mHwu8gVvo _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39xV02N91d _3iDTPbQ4SZ _0hPCNLchRC _4ouGXIdnbC",
    checkboxIcon: "_3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    checkboxLabelContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    lozengeContainer: "_39xV02E6Kk"
};
const $2aa2e7d477e414e4$export$ca91d36e38e6cc2e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { name: name, isChecked: isChecked, label: label, lozengeText: lozengeText, testId: t1, onChange: onChange, isStacked: t2 } = t0;
    const testId = t1 === undefined ? "checkbox-menu-item-container" : t1;
    const isStacked = t2 === undefined ? true : t2;
    let t3;
    if ($[0] !== isChecked || $[1] !== onChange) {
        t3 = ()=>{
            onChange(!isChecked);
        };
        $[0] = isChecked;
        $[1] = onChange;
        $[2] = t3;
    } else t3 = $[2];
    const handleClick = t3;
    let t4;
    if ($[3] !== onChange) {
        t4 = (e)=>onChange(e.target.checked);
        $[3] = onChange;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== isChecked || $[6] !== name || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2aa2e7d477e414e4$var$styles.checkboxIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            name: name,
            isChecked: isChecked,
            onChange: t4,
            tabIndex: -1
        }));
        $[5] = isChecked;
        $[6] = name;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = isStacked ? "column" : "row";
    const t7 = isStacked ? "start" : "center";
    let t8;
    if ($[9] !== label) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, label);
        $[9] = label;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== lozengeText) {
        t9 = lozengeText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2aa2e7d477e414e4$var$styles.lozengeContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "neutral"
        }, lozengeText));
        $[11] = lozengeText;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2aa2e7d477e414e4$var$styles.checkboxLabelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: t6,
            alignItems: t7,
            columnGap: "space.050",
            rowGap: "space.050"
        }, t8, t9));
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2aa2e7d477e414e4$var$styles.checkboxContent
        }, t5, t10);
        $[18] = t10;
        $[19] = t5;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== handleClick || $[22] !== t11 || $[23] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $2aa2e7d477e414e4$var$styles.checkboxMenuItem,
            onClick: handleClick,
            testId: testId
        }, t11);
        $[21] = handleClick;
        $[22] = t11;
        $[23] = testId;
        $[24] = t12;
    } else t12 = $[24];
    return t12;
} : ({ name: name, isChecked: isChecked, label: label, lozengeText: lozengeText, testId: testId = 'checkbox-menu-item-container', onChange: onChange, isStacked: isStacked = true })=>{
    const handleClick = ()=>{
        onChange(!isChecked);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $2aa2e7d477e414e4$var$styles.checkboxMenuItem,
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2aa2e7d477e414e4$var$styles.checkboxContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2aa2e7d477e414e4$var$styles.checkboxIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        name: name,
        isChecked: isChecked,
        onChange: (e)=>onChange(e.target.checked),
        tabIndex: -1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2aa2e7d477e414e4$var$styles.checkboxLabelContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: isStacked ? 'column' : 'row',
        alignItems: isStacked ? 'start' : 'center',
        columnGap: "space.050",
        rowGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, label), lozengeText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2aa2e7d477e414e4$var$styles.lozengeContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, lozengeText))))));
};



var $87k0g = parcelRequire("87k0g");


















const $7c2e9f5a26e8d07c$var$styles = {
    menuItem: "_2mHwu8gVvo _0bjKvDKTcp _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAUofl _0hPCNLchRC _0KLXru66of",
    menuItemDisabled: "_0wOv4Qsyl5 _1UtDYzot27 _1YKVNsVx3j",
    menuItemIcon: "_2mHwu8gVvo _3iDTPbQ4SZ _39xV02N91d _0jFU0VoWWg _0hPCNLDIqT _37wbyu7p2s",
    menuItemLabel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d _1ANEUSLRg7 _39HuIbz8Lp",
    sitePickerContainer: "_39xV02N91d"
};
const $7c2e9f5a26e8d07c$export$a85bf20b5cefe7da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { label: label, icon: icon, selectComponent: selectComponent, isEnabled: t1, testId: testId } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== icon) {
        t2 = typeof icon === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, icon) : icon;
        $[0] = icon;
        $[1] = t2;
    } else t2 = $[1];
    const iconElement = t2;
    const t3 = !isEnabled && $7c2e9f5a26e8d07c$var$styles.menuItemDisabled;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $w6R6I.cx)($7c2e9f5a26e8d07c$var$styles.menuItem, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = testId || "selector-menu-item-container";
    let t6;
    if ($[4] !== icon || $[5] !== iconElement || $[6] !== label) {
        t6 = (icon != null || label != null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7c2e9f5a26e8d07c$var$styles.menuItemIcon
        }, icon != null && iconElement, label != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7c2e9f5a26e8d07c$var$styles.menuItemLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            "data-test-id": "selector-menu-item-label"
        }, label)));
        $[4] = icon;
        $[5] = iconElement;
        $[6] = label;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== selectComponent) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7c2e9f5a26e8d07c$var$styles.sitePickerContainer
        }, selectComponent);
        $[8] = selectComponent;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4,
            testId: t5
        }, t6, t7);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ label: label, icon: icon, selectComponent: selectComponent, isEnabled: isEnabled = true, testId: testId })=>{
    const iconElement = typeof icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, icon) : icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($7c2e9f5a26e8d07c$var$styles.menuItem, !isEnabled && $7c2e9f5a26e8d07c$var$styles.menuItemDisabled),
        testId: testId || 'selector-menu-item-container'
    }, (icon != null || label != null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7c2e9f5a26e8d07c$var$styles.menuItemIcon
    }, icon != null && iconElement, label != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7c2e9f5a26e8d07c$var$styles.menuItemLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        "data-test-id": "selector-menu-item-label"
    }, label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7c2e9f5a26e8d07c$var$styles.sitePickerContainer
    }, selectComponent));
};


















var $kdlgT = parcelRequire("kdlgT");








var $af2Fp = parcelRequire("af2Fp");

const $afbd6db40d4f648f$export$4a0f0a004c6f6bfc = {
    withStoreMessages: '280px',
    withoutStoreMessages: '215px'
};
const $afbd6db40d4f648f$var$subMenuSlidingStyles = {
    slidingViewport: "_4bt5LAnQyn _2WAcuGnQyn",
    widthWithStore: "_39xV02ehCh",
    widthWithoutStore: "_39xV02EKjk",
    slidingContainer: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHwCiZ _3iDTPbQ4SZ _0aFT5v1qpb",
    listPanel: "_2mHwu8FQfX _3iDTPbccYA _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0aFT5vbt8w _0hPCNLDIqT _0KLXrulfZc _3YEZNOdnbC",
    subMenuPanel: "_3iDTPbQ4SZ _0aFT5vbt8w _3YEZNOdnbC _0KLXrulfZc",
    subMenuHeader: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r22ADO _1Znuxb2ADO _1wydGWdnbC _2Zuz6Q2ADO",
    subMenuContent: "_0Of8r21Y8M _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO"
};
const $afbd6db40d4f648f$export$76dd9158bcb05279 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { showStoreMessages: showStoreMessages, openSubMenuKey: openSubMenuKey, subMenuItems: subMenuItems, sections: sections, onBackClick: onBackClick, backButtonLabel: backButtonLabel } = t0;
    const listWidth = showStoreMessages ? $afbd6db40d4f648f$export$4a0f0a004c6f6bfc.withStoreMessages : $afbd6db40d4f648f$export$4a0f0a004c6f6bfc.withoutStoreMessages;
    let t1;
    if ($[0] !== openSubMenuKey || $[1] !== subMenuItems) {
        t1 = openSubMenuKey !== "list" ? subMenuItems.find((i)=>i.key === openSubMenuKey) : undefined;
        $[0] = openSubMenuKey;
        $[1] = subMenuItems;
        $[2] = t1;
    } else t1 = $[2];
    const visibleSubMenu = t1;
    const isSubMenuVisible = visibleSubMenu !== undefined;
    const t2 = showStoreMessages ? $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithStore : $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithoutStore;
    let t3;
    if ($[3] !== t2) {
        t3 = (0, $w6R6I.cx)($afbd6db40d4f648f$var$subMenuSlidingStyles.slidingViewport, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = `calc(${listWidth} * 2)`;
    const t5 = isSubMenuVisible ? `translateX(-${listWidth})` : "translateX(0)";
    let t6;
    if ($[5] !== t4 || $[6] !== t5) {
        t6 = {
            width: t4,
            transform: t5
        };
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const t7 = showStoreMessages ? $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithStore : $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithoutStore;
    let t8;
    if ($[8] !== t7) {
        t8 = (0, $w6R6I.cx)($afbd6db40d4f648f$var$subMenuSlidingStyles.listPanel, t7);
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== sections) {
        let t10;
        if ($[12] !== sections.length) {
            t10 = (section, sectionIndex)=>section.items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: sectionIndex
                }, section.items, sectionIndex !== sections.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2Fp.Divider), {
                    isThin: true,
                    withMargin: true
                }));
            $[12] = sections.length;
            $[13] = t10;
        } else t10 = $[13];
        t9 = sections.map(t10);
        $[10] = sections;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[14] !== isSubMenuVisible || $[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t8,
            "aria-hidden": isSubMenuVisible
        }, t9);
        $[14] = isSubMenuVisible;
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    const t11 = showStoreMessages ? $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithStore : $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithoutStore;
    let t12;
    if ($[18] !== t11) {
        t12 = (0, $w6R6I.cx)($afbd6db40d4f648f$var$subMenuSlidingStyles.subMenuPanel, t11);
        $[18] = t11;
        $[19] = t12;
    } else t12 = $[19];
    const t13 = !isSubMenuVisible;
    let t14;
    if ($[20] !== backButtonLabel || $[21] !== isSubMenuVisible || $[22] !== onBackClick || $[23] !== visibleSubMenu) {
        t14 = isSubMenuVisible && visibleSubMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afbd6db40d4f648f$var$subMenuSlidingStyles.subMenuHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).moreMenuBackButton,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            label: backButtonLabel,
            onClick: onBackClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            weight: "medium"
        }, visibleSubMenu.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afbd6db40d4f648f$var$subMenuSlidingStyles.subMenuContent
        }, visibleSubMenu.content));
        $[20] = backButtonLabel;
        $[21] = isSubMenuVisible;
        $[22] = onBackClick;
        $[23] = visibleSubMenu;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t12,
            "aria-hidden": t13
        }, t14);
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== t10 || $[30] !== t15 || $[31] !== t6) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afbd6db40d4f648f$var$subMenuSlidingStyles.slidingContainer,
            style: t6
        }, t10, t15);
        $[29] = t10;
        $[30] = t15;
        $[31] = t6;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== t16 || $[34] !== t3) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t16);
        $[33] = t16;
        $[34] = t3;
        $[35] = t17;
    } else t17 = $[35];
    return t17;
} : ({ showStoreMessages: showStoreMessages, openSubMenuKey: openSubMenuKey, subMenuItems: subMenuItems, sections: sections, onBackClick: onBackClick, backButtonLabel: backButtonLabel })=>{
    const listWidth = showStoreMessages ? $afbd6db40d4f648f$export$4a0f0a004c6f6bfc.withStoreMessages : $afbd6db40d4f648f$export$4a0f0a004c6f6bfc.withoutStoreMessages;
    const visibleSubMenu = openSubMenuKey !== 'list' ? subMenuItems.find((i)=>i.key === openSubMenuKey) : undefined;
    const isSubMenuVisible = visibleSubMenu !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($afbd6db40d4f648f$var$subMenuSlidingStyles.slidingViewport, showStoreMessages ? $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithStore : $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithoutStore)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afbd6db40d4f648f$var$subMenuSlidingStyles.slidingContainer,
        style: {
            width: `calc(${listWidth} * 2)`,
            transform: isSubMenuVisible ? `translateX(-${listWidth})` : 'translateX(0)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($afbd6db40d4f648f$var$subMenuSlidingStyles.listPanel, showStoreMessages ? $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithStore : $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithoutStore),
        "aria-hidden": isSubMenuVisible
    }, sections.map((section, sectionIndex)=>section.items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: sectionIndex
        }, section.items, sectionIndex !== sections.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2Fp.Divider), {
            isThin: true,
            withMargin: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($afbd6db40d4f648f$var$subMenuSlidingStyles.subMenuPanel, showStoreMessages ? $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithStore : $afbd6db40d4f648f$var$subMenuSlidingStyles.widthWithoutStore),
        "aria-hidden": !isSubMenuVisible
    }, isSubMenuVisible && visibleSubMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afbd6db40d4f648f$var$subMenuSlidingStyles.subMenuHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).moreMenuBackButton,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: backButtonLabel,
        onClick: onBackClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "medium"
    }, visibleSubMenu.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afbd6db40d4f648f$var$subMenuSlidingStyles.subMenuContent
    }, visibleSubMenu.content)))));
};



var $eQC44 = parcelRequire("eQC44");







function $b1c2fd3344eb63d0$export$c582108f3d3ed12a({ subMenuItems: subMenuItems, onOpenSubMenu: onOpenSubMenu }) {
    return subMenuItems.map((entry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
            key: entry.key,
            testId: entry.testId ?? `rovo-chat-header-${entry.key}-button`,
            label: entry.label,
            icon: entry.icon,
            onClick: ()=>{
                entry.onOpen?.();
                onOpenSubMenu(entry.key);
            },
            isSubMenu: true
        }));
}















var $4CKZe = parcelRequire("4CKZe");














const $74eed762ac9826f0$var$shakeKeyframes = null;
const $74eed762ac9826f0$var$styles = {
    shakeIconWrapper: "_2fBhteSLUR _3iDTPbccYA _39Ohv4YbGa"
};
const $74eed762ac9826f0$export$6904a2ff05bd36c0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { onToggleOptionsMenu: onToggleOptionsMenu } = t0;
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== fm) {
        t1 = fm((0, $eQC44.chatHeaderMessages).chatHeaderWhatsNewButtonText);
        $[0] = fm;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== fm) {
        t2 = fm((0, $eQC44.chatHeaderMessages).chatHeaderWhatsNewIconLabel);
        $[2] = fm;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $iDrrr.fg)("ai_mate_whats_new_has_update") ? $74eed762ac9826f0$var$styles.shakeIconWrapper : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CKZe))), {
            label: t2,
            color: (0, $iDrrr.fg)("ai_mate_whats_new_has_update") ? "var(--ds-icon-discovery, #AF59E1)" : "var(--ds-icon-subtle, #505258)"
        }));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onToggleOptionsMenu) {
        t4 = ()=>{
            window.open("https://www.atlassian.com/software/rovo/features/whats-new", "_blank", "noopener,noreferrer");
            onToggleOptionsMenu();
        };
        $[6] = onToggleOptionsMenu;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).whatsNewButton,
            label: t1,
            icon: t3,
            onClick: t4,
            isExternalLink: true,
            componentName: "chatHeaderWhatsNewMenuItem"
        });
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ onToggleOptionsMenu: onToggleOptionsMenu })=>{
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).whatsNewButton,
        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderWhatsNewButtonText),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $iDrrr.fg)('ai_mate_whats_new_has_update') ? $74eed762ac9826f0$var$styles.shakeIconWrapper : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CKZe))), {
            label: fm((0, $eQC44.chatHeaderMessages).chatHeaderWhatsNewIconLabel),
            color: (0, $iDrrr.fg)('ai_mate_whats_new_has_update') ? "var(--ds-icon-discovery, #AF59E1)" : "var(--ds-icon-subtle, #505258)"
        })),
        onClick: ()=>{
            window.open('https://www.atlassian.com/software/rovo/features/whats-new', '_blank', 'noopener,noreferrer');
            onToggleOptionsMenu();
        },
        isExternalLink: true,
        componentName: "chatHeaderWhatsNewMenuItem"
    });
};


const $f6295ee3a8d83389$var$styles = {
    moreMenuPostOfficeSpotlightWrapper: "_1mT5xdRAKS"
};
const $f6295ee3a8d83389$export$523b08430e600b5 = (props)=>{
    (0, $6cFsl.di)((0, $lTU4O.useUserPreferences), (0, $hSR6U.useStoreUserMessagesPreference), (0, $iDrrr.fg));
    if (props.assistanceServiceParams && (0, $iDrrr.fg)('ai_mate_store_messages_be_driven')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6295ee3a8d83389$var$ChatHeaderMoreMenuWithBackendPreference, {
        ...props,
        assistanceServiceParams: props.assistanceServiceParams
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6295ee3a8d83389$var$ChatHeaderMoreMenuWithLocalPreference, props);
};
const $f6295ee3a8d83389$var$ChatHeaderMoreMenuWithBackendPreference = ({ assistanceServiceParams: assistanceServiceParams, ...props })=>{
    (0, $6cFsl.di)((0, $hSR6U.useStoreUserMessagesPreference));
    const { storeUserMessages: storeUserMessages, storeUserMessagesEligible: storeUserMessagesEligible, setStoreUserMessages: setStoreUserMessages } = (0, $hSR6U.useStoreUserMessagesPreference)({
        assistanceServiceParams: assistanceServiceParams
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6295ee3a8d83389$var$ChatHeaderMoreMenuContent, {
        ...props,
        assistanceServiceParams: assistanceServiceParams,
        storeUserMessages: storeUserMessages,
        storeUserMessagesEligible: storeUserMessagesEligible,
        setStoreUserMessages: setStoreUserMessages
    });
};
const $f6295ee3a8d83389$var$ChatHeaderMoreMenuWithLocalPreference = (props)=>{
    (0, $6cFsl.di)((0, $lTU4O.useUserPreferences), (0, $iDrrr.fg));
    const { preferences: preferences, setStoreUserMessages: setStoreUserMessages } = (0, $lTU4O.useUserPreferences)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6295ee3a8d83389$var$ChatHeaderMoreMenuContent, {
        ...props,
        storeUserMessages: preferences.storeUserMessages,
        storeUserMessagesEligible: (0, $iDrrr.fg)('ai_mate_show_store_messages'),
        setStoreUserMessages: setStoreUserMessages
    });
};
const $f6295ee3a8d83389$var$ChatHeaderMoreMenuContent = ({ onFeedbackClick: onFeedbackClick, onDebugClick: onDebugClick, onConversationDelete: onConversationDelete, onConversationRename: onConversationRename, onDesktopAppClick: onDesktopAppClick, onSlackAppClick: onSlackAppClick, onTeamsAppClick: onTeamsAppClick, onChromeExtensionClick: onChromeExtensionClick, onCliClick: onCliClick, onSettingsClick: onSettingsClick, onShareClick: onShareClick, isShareDisabled: isShareDisabled, sitePickerRender: sitePickerRender, subMenuItems: subMenuItems = [], onMenuOpen: onMenuOpen, storeUserMessages: storeUserMessages, storeUserMessagesEligible: storeUserMessagesEligible, setStoreUserMessages: setStoreUserMessages })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics), (0, $iDrrr.fg));
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const showStoreMessages = storeUserMessagesEligible;
    const showRovoDesktopAppMenuButton = (0, $iDrrr.fg)('ai_mate_show_rovo_desktop_app_menu_button');
    const showRovoMobileQrSubMenu = (0, $iDrrr.fg)('ai_mate_show_rovo_mobile_qr_menu_button') && subMenuItems.length > 0;
    const [isOptionsMenuOpen, setIsOptionsMenuOpen] = (0, $cozmU.useState)(false);
    const [openSubMenuKey, setOpenSubMenuKey] = (0, $cozmU.useState)('list');
    const canShowSitePicker = sitePickerRender !== undefined;
    const shouldShowShareButton = typeof onShareClick === 'function' && (0, $4o0zT.isExperimentEnabled)('rovo_conversation_sharing');
    const canShowOptionsMenu = onConversationDelete !== undefined || onConversationRename !== undefined || onFeedbackClick !== undefined || onDebugClick !== undefined || showRovoDesktopAppMenuButton && onDesktopAppClick !== undefined || onSlackAppClick !== undefined || onTeamsAppClick !== undefined || showRovoMobileQrSubMenu || onChromeExtensionClick !== undefined || onCliClick !== undefined && (0, $iDrrr.fg)('ai_mate_show_rovo_cli_menu_button') || onSettingsClick !== undefined || shouldShowShareButton || canShowSitePicker;
    const handleToggleOptionsMenu = (0, $cozmU.useCallback)(()=>{
        const willBeOpen = !isOptionsMenuOpen;
        setIsOptionsMenuOpen(willBeOpen); // Fire onMenuOpen callback when menu is opening (button is clicked)
        if (willBeOpen && onMenuOpen) onMenuOpen();
    }, [
        isOptionsMenuOpen,
        setIsOptionsMenuOpen,
        onMenuOpen
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setOpenSubMenuKey('list');
        handleToggleOptionsMenu();
    }, [
        handleToggleOptionsMenu
    ]);
    const shouldShowFeedbackButton = typeof onFeedbackClick === 'function';
    const shouldShowDebugButton = typeof onDebugClick === 'function';
    const shouldShowDeleteConversationButton = typeof onConversationDelete === 'function';
    const shouldShowRenameConversationButton = typeof onConversationRename === 'function';
    const shouldShowDesktopAppButton = showRovoDesktopAppMenuButton && typeof onDesktopAppClick === 'function';
    const shouldShowSlackAppButton = typeof onSlackAppClick === 'function';
    const shouldShowTeamsAppButton = typeof onTeamsAppClick === 'function';
    const shouldShowChromeExtensionButton = typeof onChromeExtensionClick === 'function';
    const shouldShowCliButton = typeof onCliClick === 'function' && (0, $iDrrr.fg)('ai_mate_show_rovo_cli_menu_button');
    const shouldShowSettingsButton = typeof onSettingsClick === 'function';
    const isShareButtonDisabled = Boolean(isShareDisabled);
    const shareDisabledTooltip = isShareDisabled ? (0, $eQC44.getShareButtonLabel)(isShareDisabled, fm) : undefined;
    if (!canShowOptionsMenu) return null;
    const sections = [
        {
            items: canShowSitePicker ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c2e9f5a26e8d07c$export$a85bf20b5cefe7da), {
                    testId: (0, $85810b69489172e7$export$cad53202c09accc9).sitePickerMenuItem,
                    label: fm((0, $eQC44.chatHeaderMessages).chatHeaderSwitchSiteButtonText),
                    selectComponent: sitePickerRender
                })
            ] : []
        },
        {
            items: [
                ...shouldShowRenameConversationButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).renameButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderRenameButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onConversationRename?.();
                            handleToggleOptionsMenu();
                        }
                    })
                ] : [],
                ...shouldShowDeleteConversationButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).deleteButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderDeleteButtonText),
                        labelColor: 'color.text.danger',
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                            label: "",
                            color: "var(--ds-icon-danger, #C9372C)"
                        }),
                        onClick: ()=>{
                            onConversationDelete?.();
                            handleToggleOptionsMenu();
                        }
                    })
                ] : []
            ]
        },
        {
            items: [
                ...shouldShowSettingsButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).settingsButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderSettingsButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            sendAnalyticsEvent({
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'settingsAndMemoryButton'
                            });
                            onSettingsClick?.();
                            handleToggleOptionsMenu();
                        }
                    })
                ] : [],
                ...shouldShowShareButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).shareButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderShareButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        isDisabled: isShareButtonDisabled,
                        tooltip: shareDisabledTooltip,
                        onClick: ()=>{
                            sendAnalyticsEvent({
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'shareChatButton'
                            });
                            onShareClick?.();
                            handleToggleOptionsMenu();
                        }
                    })
                ] : []
            ]
        },
        {
            items: [
                ...shouldShowDesktopAppButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).desktopAppButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderDesktopAppButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HbMh))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onDesktopAppClick?.();
                            handleToggleOptionsMenu();
                        },
                        isExternalLink: true
                    })
                ] : [],
                ...shouldShowSlackAppButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).slackAppButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderSlackAppButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onSlackAppClick?.();
                            handleToggleOptionsMenu();
                        },
                        isExternalLink: true
                    })
                ] : [],
                ...shouldShowTeamsAppButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).teamsAppButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderTeamsAppButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onTeamsAppClick?.();
                            handleToggleOptionsMenu();
                        },
                        isExternalLink: true
                    })
                ] : [],
                ...showRovoMobileQrSubMenu ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1c2fd3344eb63d0$export$c582108f3d3ed12a), {
                        key: "rovo-mobile-qr-submenu",
                        subMenuItems: subMenuItems,
                        onOpenSubMenu: (key)=>setOpenSubMenuKey(key)
                    })
                ] : [],
                ...shouldShowChromeExtensionButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).chromeExtensionButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderChromeExtensionButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($47bbw))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onChromeExtensionClick?.();
                            handleToggleOptionsMenu();
                        },
                        isExternalLink: true
                    })
                ] : [],
                ...shouldShowCliButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).cliButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderCliButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRqYE))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onCliClick?.();
                            handleToggleOptionsMenu();
                        },
                        isExternalLink: true
                    })
                ] : []
            ]
        },
        {
            items: [
                ...(0, $iDrrr.fg)('ai_mate_show_whats_new_menu_item') ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74eed762ac9826f0$export$6904a2ff05bd36c0), {
                        onToggleOptionsMenu: handleToggleOptionsMenu
                    })
                ] : [],
                ...shouldShowFeedbackButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).feedbackButton,
                        label: fm((0, $eQC44.chatHeaderMessages).chatHeaderFeedbackButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>{
                            onFeedbackClick?.();
                            handleToggleOptionsMenu();
                        }
                    })
                ] : [],
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                    testId: (0, $85810b69489172e7$export$cad53202c09accc9).getHelpButton,
                    label: fm((0, $eQC44.chatHeaderMessages).chatHeaderGetHelpButtonText),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    onClick: ()=>{
                        window.open('https://support.atlassian.com/rovo/docs/using-rovo/', '_blank', 'noopener, noreferrer');
                        handleToggleOptionsMenu();
                    },
                    isExternalLink: true
                })
            ]
        },
        ...shouldShowDebugButton || showStoreMessages ? [
            {
                items: [
                    ...shouldShowDebugButton ? [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                            testId: (0, $85810b69489172e7$export$cad53202c09accc9).debugButton,
                            label: fm((0, $eQC44.chatHeaderMessages).chatHeaderDebugButtonText),
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6spAz))), {
                                label: "",
                                color: "var(--ds-icon-subtle, #505258)"
                            }),
                            onClick: ()=>{
                                onDebugClick?.();
                                handleToggleOptionsMenu();
                            }
                        })
                    ] : [],
                    ...showStoreMessages ? [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2aa2e7d477e414e4$export$ca91d36e38e6cc2e), {
                            key: "store-messages",
                            name: "storeUserMessages",
                            isChecked: storeUserMessages,
                            label: fm((0, $eQC44.chatHeaderMessages).chatStoreUserMessagesLabel),
                            lozengeText: "INTERNAL ONLY",
                            testId: (0, $85810b69489172e7$export$cad53202c09accc9).storeMessagesCheckbox,
                            onChange: (enabled)=>{
                                setStoreUserMessages(enabled);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'checkbox',
                                    actionSubjectId: 'storeUserMessages',
                                    attributes: {
                                        checked: enabled
                                    }
                                });
                            }
                        })
                    ] : []
                ]
            }
        ] : []
    ];
    const listWidth = showStoreMessages ? (0, $afbd6db40d4f648f$export$4a0f0a004c6f6bfc).withStoreMessages : (0, $afbd6db40d4f648f$export$4a0f0a004c6f6bfc).withoutStoreMessages;
    const menuContent = showRovoMobileQrSubMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afbd6db40d4f648f$export$76dd9158bcb05279), {
        showStoreMessages: showStoreMessages,
        openSubMenuKey: openSubMenuKey,
        subMenuItems: subMenuItems,
        sections: sections,
        onBackClick: ()=>setOpenSubMenuKey('list'),
        backButtonLabel: fm((0, $eQC44.chatHeaderMessages).chatHeaderMoreMenuBackButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jW2nL.ChatHeaderMenuList), {
        sections: sections
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": (0, $85810b69489172e7$export$cad53202c09accc9).moreMenuPostOfficeSpotlightWrapper,
        className: (0, $hekY6.default)([
            $f6295ee3a8d83389$var$styles.moreMenuPostOfficeSpotlightWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Rgab.ChatHeaderMenu), {
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).moreMenuPopup,
        sections: sections,
        isOpen: isOptionsMenuOpen,
        onClose: showRovoMobileQrSubMenu ? handleClose : handleToggleOptionsMenu,
        placement: "bottom-end",
        width: listWidth,
        maxWidth: listWidth,
        content: menuContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                isSelected: isOptionsMenuOpen,
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).moreMenuButton,
                appearance: "subtle",
                isTooltipDisabled: false,
                label: fm((0, $eQC44.chatHeaderMessages).chatHeaderMoreMenuButtonLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                onClick: handleToggleOptionsMenu
            })
    }));
};




















var $23b23c7731531ae9$exports = {};
$23b23c7731531ae9$exports = new URL("rovo-mobile-app-onelink.4e56e554.svg", import.meta.url).toString();


const $337e46603946e0d3$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "ai-mate.chat-header.mobile-app-name",
        defaultMessage: "Rovo app"
    },
    description: {
        id: "ai-mate.chat-header.mobile-app-scan-description",
        defaultMessage: "Scan QR code to use Rovo on the go"
    },
    qrCodeAlt: {
        id: "ai-mate.chat-header.mobile-app-qr-code-alt",
        defaultMessage: "QR code to open Rovo mobile app"
    }
});
const $337e46603946e0d3$var$styles = {
    container: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _0Of8r22ADO _1Znuxb5zaO _1wydGW2ADO _2Zuz6Q5zaO",
    qrCodeWrapper: "_39xV02oaux _3YEZNOdnbC",
    titleAndDescription: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _3138421Y8M _1DCdHi1Y8M",
    title: "_2sNsIgmnOE _1kk5Tkf7mX _1UtDYzZpcK _2fwxA5DIqT _313842dnbC",
    description: "_2sNsIg7NXe _1UtDYzKGUX _2fwxA5DIqT _313842dnbC"
};
const $337e46603946e0d3$export$a28cff4286b9b3c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(18);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($337e46603946e0d3$var$messages.qrCodeAlt);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $337e46603946e0d3$var$styles.qrCodeWrapper,
            as: "img",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($23b23c7731531ae9$exports))),
            alt: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage($337e46603946e0d3$var$messages.title);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "p",
            xcss: $337e46603946e0d3$var$styles.title
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== formatMessage) {
        t4 = formatMessage($337e46603946e0d3$var$messages.description);
        $[8] = formatMessage;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "p",
            xcss: $337e46603946e0d3$var$styles.description
        }, t4);
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t3 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $337e46603946e0d3$var$styles.titleAndDescription
        }, t3, t5);
        $[12] = t3;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t1 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $337e46603946e0d3$var$styles.container
        }, t1, t6);
        $[15] = t1;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $337e46603946e0d3$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $337e46603946e0d3$var$styles.qrCodeWrapper,
        as: "img",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($23b23c7731531ae9$exports))),
        alt: formatMessage($337e46603946e0d3$var$messages.qrCodeAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $337e46603946e0d3$var$styles.titleAndDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "p",
        xcss: $337e46603946e0d3$var$styles.title
    }, formatMessage($337e46603946e0d3$var$messages.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "p",
        xcss: $337e46603946e0d3$var$styles.description
    }, formatMessage($337e46603946e0d3$var$messages.description))));
};



























var $7Mix9 = parcelRequire("7Mix9");


var $iODl6 = parcelRequire("iODl6");

var $j72ee = parcelRequire("j72ee");










const $11e404fc484cabc9$export$896a5b4bd59d107a = (0, $kSwu1.defineMessages)({
    chatHeaderBackButtonLabel: {
        id: "ai-mate.rovo-chat-header.back-home-button-label",
        defaultMessage: "Go back to Rovo chat"
    },
    chatHeaderMenuButtonLabel: {
        id: "ai-mate.rovo-chat-header.menu-button-label",
        defaultMessage: "Menu"
    },
    chatHeaderNewChatButtonLabel: {
        id: "ai-mate.rovo-chat-header.new-chat-button-label",
        defaultMessage: "New chat"
    },
    chatHeaderNewAgentChatButtonLabel: {
        id: "ai-mate.rovo-chat-header.new-agent-chat-button-label",
        defaultMessage: "New chat with {agentName}"
    },
    chatHeaderMoreMenuButtonLabel: {
        id: "ai-mate.rovo-chat-header.more-menu-button-label",
        defaultMessage: "More"
    },
    chatHeaderFeedbackButtonText: {
        id: "ai-mate.rovo-chat-header.feedback-button-text",
        defaultMessage: "Feedback"
    },
    chatHeaderDebugButtonText: {
        id: "ai-mate.rovo-chat-header.debug-button-label",
        defaultMessage: "Debug"
    },
    chatHeaderFeedbackIconLabel: {
        id: "ai-mate.rovo-chat-header.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    chatHeaderGetHelpButtonText: {
        id: "ai-mate.rovo-chat-header.get-help-button-text",
        defaultMessage: "Get help"
    },
    chatHeaderGetHelpIconLabel: {
        id: "ai-mate.rovo-chat-header.get-help-icon-label",
        defaultMessage: "Get help"
    },
    chatHeaderCloseButton: {
        id: "ai-mate.rovo-chat-header.close-chat-header-button-label",
        defaultMessage: "Close"
    },
    chatHeaderRenameButtonText: {
        id: "ai-mate.rovo-chat-header.rename-button-text",
        defaultMessage: "Rename"
    },
    chatHeaderRenameIconLabel: {
        id: "ai-mate.rovo-chat-header.rename-icon-label",
        defaultMessage: "Rename"
    },
    chatHeaderDeleteButtonText: {
        id: "ai-mate.rovo-chat-header.delete-button-text",
        defaultMessage: "Delete"
    },
    chatHeaderDeleteIconLabel: {
        id: "ai-mate.rovo-chat-header.delete-icon-label",
        defaultMessage: "Delete"
    }
});


const $fb8eca56e1c1148d$var$styles = {
    container: "_0bjKvDOLYo _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _39xV02N91d _1mT5xdRAKS _2IhTonPgdg",
    leftContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0hPCNLDIqT _37wbyuchRC _4ouGXIdnbC",
    inlineContainer: "_1EqgXlN91d",
    rightContainer: "_0hPCNLDIqT _37wbyuz9WS"
};
const $fb8eca56e1c1148d$export$1263ff8fe28ec69f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { selectedAgent: selectedAgent, agentTitleComponent: agentTitleComponent, splitLayoutToggleComponent: splitLayoutToggleComponent, switchModeComponent: switchModeComponent, moreMenuComponent: moreMenuComponent, onMenuClick: onMenuClick, menuButtonRef: menuButtonRef, onNewChatClick: onNewChatClick, onCloseClick: onCloseClick, onBackClick: onBackClick, autoFocusBackButton: autoFocusBackButton, backButtonLabel: backButtonLabel, isNewChatButtonDisabled: t1 } = t0;
    const isNewChatButtonDisabled = t1 === undefined ? false : t1;
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    const isDefaultAgent = !selectedAgent || selectedAgent.is_default;
    const shouldShowMenuButton = typeof onMenuClick === "function";
    const shouldShowNewChatButton = typeof onNewChatClick === "function";
    const shouldShowCloseButton = typeof onCloseClick === "function";
    const shouldShowBackButton = typeof onBackClick === "function";
    let t2;
    if ($[0] !== autoFocusBackButton || $[1] !== backButtonLabel || $[2] !== fm || $[3] !== onBackClick || $[4] !== shouldShowBackButton) {
        t2 = shouldShowBackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "left",
            exitTo: "left",
            fade: "in",
            animationTimingFunction: "ease-out",
            duration: "medium"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", animationProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).backButton,
                appearance: "subtle",
                isTooltipDisabled: false,
                autoFocus: autoFocusBackButton,
                label: backButtonLabel ?? fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderBackButtonLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                onClick: onBackClick
            })));
        $[0] = autoFocusBackButton;
        $[1] = backButtonLabel;
        $[2] = fm;
        $[3] = onBackClick;
        $[4] = shouldShowBackButton;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== fm || $[9] !== menuButtonRef || $[10] !== onMenuClick || $[11] !== shouldShowMenuButton) {
        t4 = shouldShowMenuButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).menuButton,
            appearance: "subtle",
            isTooltipDisabled: false,
            ref: menuButtonRef,
            label: fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderMenuButtonLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))),
            onClick: onMenuClick
        });
        $[8] = fm;
        $[9] = menuButtonRef;
        $[10] = onMenuClick;
        $[11] = shouldShowMenuButton;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== agentTitleComponent || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $fb8eca56e1c1148d$var$styles.leftContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            xcss: $fb8eca56e1c1148d$var$styles.inlineContainer
        }, t3, t4, agentTitleComponent));
        $[13] = agentTitleComponent;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== fm || $[18] !== isDefaultAgent || $[19] !== isNewChatButtonDisabled || $[20] !== onNewChatClick || $[21] !== selectedAgent || $[22] !== shouldShowNewChatButton) {
        t6 = shouldShowNewChatButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).newChatButton,
            appearance: "subtle",
            isTooltipDisabled: false,
            label: isDefaultAgent ? fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderNewChatButtonLabel) : fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderNewAgentChatButtonLabel, {
                agentName: selectedAgent.name
            }),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            onClick: onNewChatClick,
            isDisabled: isNewChatButtonDisabled
        });
        $[17] = fm;
        $[18] = isDefaultAgent;
        $[19] = isNewChatButtonDisabled;
        $[20] = onNewChatClick;
        $[21] = selectedAgent;
        $[22] = shouldShowNewChatButton;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== fm || $[25] !== onCloseClick || $[26] !== shouldShowCloseButton) {
        t7 = shouldShowCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).closeButton,
            appearance: "subtle",
            isTooltipDisabled: false,
            label: fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderCloseButton),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            onClick: onCloseClick
        });
        $[24] = fm;
        $[25] = onCloseClick;
        $[26] = shouldShowCloseButton;
        $[27] = t7;
    } else t7 = $[27];
    let t8;
    if ($[28] !== moreMenuComponent || $[29] !== splitLayoutToggleComponent || $[30] !== switchModeComponent || $[31] !== t6 || $[32] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $fb8eca56e1c1148d$var$styles.rightContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, t6, splitLayoutToggleComponent, switchModeComponent, moreMenuComponent, t7));
        $[28] = moreMenuComponent;
        $[29] = splitLayoutToggleComponent;
        $[30] = switchModeComponent;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
    } else t8 = $[33];
    let t9;
    if ($[34] !== t5 || $[35] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $fb8eca56e1c1148d$var$styles.container,
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).container,
            direction: "row",
            role: "banner"
        }, t5, t8);
        $[34] = t5;
        $[35] = t8;
        $[36] = t9;
    } else t9 = $[36];
    return t9;
} : ({ selectedAgent: selectedAgent, agentTitleComponent: agentTitleComponent, splitLayoutToggleComponent: splitLayoutToggleComponent, switchModeComponent: switchModeComponent, moreMenuComponent: moreMenuComponent, onMenuClick: onMenuClick, menuButtonRef: menuButtonRef, onNewChatClick: onNewChatClick, onCloseClick: onCloseClick, onBackClick: onBackClick, autoFocusBackButton: autoFocusBackButton, backButtonLabel: backButtonLabel, isNewChatButtonDisabled: isNewChatButtonDisabled = false })=>{
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    const isDefaultAgent = !selectedAgent || selectedAgent.is_default;
    const shouldShowMenuButton = typeof onMenuClick === 'function';
    const shouldShowNewChatButton = typeof onNewChatClick === 'function';
    const shouldShowCloseButton = typeof onCloseClick === 'function';
    const shouldShowBackButton = typeof onBackClick === 'function';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $fb8eca56e1c1148d$var$styles.container,
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).container,
        direction: "row",
        role: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $fb8eca56e1c1148d$var$styles.leftContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050",
        xcss: $fb8eca56e1c1148d$var$styles.inlineContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, shouldShowBackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: "left",
        exitTo: "left",
        fade: "in",
        animationTimingFunction: "ease-out",
        duration: "medium"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", animationProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).backButton,
            appearance: "subtle",
            isTooltipDisabled: false,
            autoFocus: autoFocusBackButton,
            label: backButtonLabel ?? fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderBackButtonLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            onClick: onBackClick
        })))), shouldShowMenuButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).menuButton,
        appearance: "subtle",
        isTooltipDisabled: false,
        ref: menuButtonRef,
        label: fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderMenuButtonLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))),
        onClick: onMenuClick
    }), agentTitleComponent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $fb8eca56e1c1148d$var$styles.rightContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, shouldShowNewChatButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).newChatButton,
        appearance: "subtle",
        isTooltipDisabled: false,
        label: isDefaultAgent ? fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderNewChatButtonLabel) : fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderNewAgentChatButtonLabel, {
            agentName: selectedAgent.name
        }),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        onClick: onNewChatClick,
        isDisabled: isNewChatButtonDisabled
    }), splitLayoutToggleComponent, switchModeComponent, moreMenuComponent, shouldShowCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).closeButton,
        appearance: "subtle",
        isTooltipDisabled: false,
        label: fm((0, $11e404fc484cabc9$export$896a5b4bd59d107a).chatHeaderCloseButton),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        onClick: onCloseClick
    }))));
};


















var $2x0Nk = parcelRequire("2x0Nk");


var $8VfSP = parcelRequire("8VfSP");


var $gDx2k = parcelRequire("gDx2k");


var $foj7F = parcelRequire("foj7F");

















const $3b18adfeb13ca63b$var$message = (0, $kSwu1.defineMessages)({
    chatHeaderFloatingIconLabel: {
        id: "ai-mate.rovo-chat-header.floating-icon-label",
        defaultMessage: "Floating"
    },
    chatHeaderFloatingButtonText: {
        id: "ai-mate.rovo-chat-header.floating-button-text",
        defaultMessage: "Floating"
    },
    chatHeaderSidebarIconLabel: {
        id: "ai-mate.rovo-chat-header.sidebar-icon-label",
        defaultMessage: "Sidebar"
    },
    chatHeaderSidebarButtonText: {
        id: "ai-mate.rovo-chat-header.sidebar-button-text",
        defaultMessage: "Sidebar"
    },
    chatHeaderSwitchModeSectionText: {
        id: "ai-mate.rovo-chat-header.switch-mode-section-text",
        defaultMessage: "Switch to"
    },
    chatHeaderSwitchModeButtonLabel: {
        id: "ai-mate.rovo-chat-header.switch-mode-button-label",
        defaultMessage: "Switch to"
    },
    chatHeaderFullscreenIconLabel: {
        id: "ai-mate.rovo-chat-header.fullscreen-icon-label",
        defaultMessage: "Full screen"
    },
    chatHeaderFullscreenButtonText: {
        id: "ai-mate.rovo-chat-header.fullscreen-button-text",
        defaultMessage: "Full screen"
    },
    chatHeaderFullscreenInHomeIconLabel: {
        id: "ai-mate.rovo-chat-header.fullscreen-in-home-icon-label.non-final",
        defaultMessage: "Open in Home"
    },
    chatHeaderFullscreenInHomeButtonText: {
        id: "ai-mate.rovo-chat-header.fullscreen-in-home-button-text.non-final",
        defaultMessage: "Open in Home"
    }
});
var $3b18adfeb13ca63b$export$2e2bcd8739ae039 = $3b18adfeb13ca63b$var$message;


const $c7f75bd8d7e75d3f$export$6066428d3ab3a284 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(73);
    const { mode: t1, disableModeChange: t2, onModeChange: onModeChange, isSwitchModeDropdownOpen: isSwitchModeDropdownOpen, setIsSwitchModeDropdownOpen: setIsSwitchModeDropdownOpen, onFullscreenClick: onFullscreenClick, isFullScreenModalAvailable: t3 } = t0;
    const mode = t1 === undefined ? "sidebar" : t1;
    const disableModeChange = t2 === undefined ? false : t2;
    const isFullScreenModalAvailable = t3 === undefined ? false : t3;
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    const canSwitchMode = onModeChange !== undefined;
    let t4;
    if ($[0] !== isSwitchModeDropdownOpen || $[1] !== setIsSwitchModeDropdownOpen) {
        t4 = ()=>{
            setIsSwitchModeDropdownOpen(!isSwitchModeDropdownOpen);
        };
        $[0] = isSwitchModeDropdownOpen;
        $[1] = setIsSwitchModeDropdownOpen;
        $[2] = t4;
    } else t4 = $[2];
    const handleToggleSwitchModeDropdown = t4;
    let t5;
    if ($[3] !== handleToggleSwitchModeDropdown || $[4] !== onFullscreenClick) {
        t5 = ()=>{
            if (!onFullscreenClick) return;
            onFullscreenClick();
            handleToggleSwitchModeDropdown();
        };
        $[3] = handleToggleSwitchModeDropdown;
        $[4] = onFullscreenClick;
        $[5] = t5;
    } else t5 = $[5];
    const handleOnFullscreenClick = t5;
    let t6;
    if ($[6] !== canSwitchMode || $[7] !== handleToggleSwitchModeDropdown || $[8] !== onModeChange) {
        t6 = (requested)=>{
            if (!canSwitchMode) return;
            handleToggleSwitchModeDropdown();
            onModeChange({
                requested: requested
            });
        };
        $[6] = canSwitchMode;
        $[7] = handleToggleSwitchModeDropdown;
        $[8] = onModeChange;
        $[9] = t6;
    } else t6 = $[9];
    const handleModeChange = t6;
    const shouldShowFullScreenButton = typeof onFullscreenClick === "function";
    let t7;
    if ($[10] !== isFullScreenModalAvailable) {
        t7 = isFullScreenModalAvailable && (0, $iDrrr.fg)("agent_session_experience_fg");
        $[10] = isFullScreenModalAvailable;
        $[11] = t7;
    } else t7 = $[11];
    const shouldShowFullScreenModalButton = t7;
    if (!canSwitchMode) {
        let t8;
        if ($[12] !== fm || $[13] !== handleOnFullscreenClick || $[14] !== shouldShowFullScreenButton || $[15] !== shouldShowFullScreenModalButton) {
            t8 = shouldShowFullScreenButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                isTooltipDisabled: false,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))),
                onClick: handleOnFullscreenClick,
                label: fm(shouldShowFullScreenModalButton ? (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenInHomeButtonText : (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenButtonText),
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).fullScreenButton,
                role: "link"
            }) : null;
            $[12] = fm;
            $[13] = handleOnFullscreenClick;
            $[14] = shouldShowFullScreenButton;
            $[15] = shouldShowFullScreenModalButton;
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    let t8;
    if ($[17] !== fm) {
        t8 = fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSwitchModeSectionText);
        $[17] = fm;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== canSwitchMode || $[20] !== disableModeChange || $[21] !== fm || $[22] !== handleModeChange || $[23] !== mode) {
        t9 = canSwitchMode ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).miniModalButton,
                label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFloatingButtonText),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foj7F))), {
                    label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFloatingIconLabel),
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                onClick: ()=>handleModeChange("mini-modal"),
                isDisabled: disableModeChange,
                interactionName: "rovo-change-mode-floating",
                isActive: mode === "mini-modal"
            })
        ] : [];
        $[19] = canSwitchMode;
        $[20] = disableModeChange;
        $[21] = fm;
        $[22] = handleModeChange;
        $[23] = mode;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== fm) {
        t10 = fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSidebarButtonText);
        $[25] = fm;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== fm) {
        t11 = fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSidebarIconLabel);
        $[27] = fm;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            label: t11,
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[29] = t11;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== handleModeChange) {
        t13 = ()=>handleModeChange("sidebar");
        $[31] = handleModeChange;
        $[32] = t13;
    } else t13 = $[32];
    const t14 = mode === "sidebar";
    let t15;
    if ($[33] !== disableModeChange || $[34] !== t10 || $[35] !== t12 || $[36] !== t13 || $[37] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).sidebarButton,
            label: t10,
            icon: t12,
            onClick: t13,
            isDisabled: disableModeChange,
            interactionName: "rovo-change-mode-sidebar",
            isActive: t14
        });
        $[33] = disableModeChange;
        $[34] = t10;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== disableModeChange || $[40] !== fm || $[41] !== handleModeChange || $[42] !== mode || $[43] !== shouldShowFullScreenModalButton) {
        t16 = shouldShowFullScreenModalButton ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).fullScreenModalButton,
                label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenButtonText),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
                    label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenIconLabel),
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                onClick: ()=>handleModeChange("full-screen-modal"),
                isDisabled: disableModeChange,
                interactionName: "rovo-change-mode-full-screen-modal",
                isActive: mode === "full-screen-modal"
            })
        ] : [];
        $[39] = disableModeChange;
        $[40] = fm;
        $[41] = handleModeChange;
        $[42] = mode;
        $[43] = shouldShowFullScreenModalButton;
        $[44] = t16;
    } else t16 = $[44];
    let t17;
    if ($[45] !== fm || $[46] !== handleOnFullscreenClick || $[47] !== shouldShowFullScreenButton || $[48] !== shouldShowFullScreenModalButton) {
        t17 = shouldShowFullScreenButton ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).fullScreenButton,
                label: fm(shouldShowFullScreenModalButton ? (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenInHomeButtonText : (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenButtonText),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))), {
                    label: fm(shouldShowFullScreenModalButton ? (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenInHomeIconLabel : (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenIconLabel),
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                onClick: handleOnFullscreenClick,
                isExternalLink: true
            })
        ] : [];
        $[45] = fm;
        $[46] = handleOnFullscreenClick;
        $[47] = shouldShowFullScreenButton;
        $[48] = shouldShowFullScreenModalButton;
        $[49] = t17;
    } else t17 = $[49];
    let t18;
    if ($[50] !== t15 || $[51] !== t16 || $[52] !== t17 || $[53] !== t9) {
        t18 = [
            ...t9,
            t15,
            ...t16,
            ...t17
        ];
        $[50] = t15;
        $[51] = t16;
        $[52] = t17;
        $[53] = t9;
        $[54] = t18;
    } else t18 = $[54];
    let t19;
    if ($[55] !== t18 || $[56] !== t8) {
        t19 = [
            {
                title: t8,
                items: t18
            }
        ];
        $[55] = t18;
        $[56] = t8;
        $[57] = t19;
    } else t19 = $[57];
    const sections = t19;
    let t20;
    if ($[58] !== sections) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jW2nL.ChatHeaderMenuList), {
            sections: sections
        });
        $[58] = sections;
        $[59] = t20;
    } else t20 = $[59];
    let t21;
    if ($[60] !== setIsSwitchModeDropdownOpen) {
        t21 = ()=>setIsSwitchModeDropdownOpen(false);
        $[60] = setIsSwitchModeDropdownOpen;
        $[61] = t21;
    } else t21 = $[61];
    let t22;
    if ($[62] !== fm || $[63] !== isSwitchModeDropdownOpen || $[64] !== mode || $[65] !== setIsSwitchModeDropdownOpen) {
        t22 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                isSelected: isSwitchModeDropdownOpen,
                appearance: "subtle",
                isTooltipDisabled: false,
                label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSwitchModeButtonLabel),
                icon: mode === "mini-modal" ? (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))) : mode === "full-screen-modal" ? (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))) : (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
                onClick: ()=>setIsSwitchModeDropdownOpen(!isSwitchModeDropdownOpen),
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).switchModeButton
            });
        $[62] = fm;
        $[63] = isSwitchModeDropdownOpen;
        $[64] = mode;
        $[65] = setIsSwitchModeDropdownOpen;
        $[66] = t22;
    } else t22 = $[66];
    let t23;
    if ($[67] !== isSwitchModeDropdownOpen || $[68] !== sections || $[69] !== t20 || $[70] !== t21 || $[71] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Rgab.ChatHeaderMenu), {
            sections: sections,
            content: t20,
            isOpen: isSwitchModeDropdownOpen,
            onClose: t21,
            placement: "bottom-end",
            width: "200px",
            maxWidth: "200px",
            trigger: t22
        });
        $[67] = isSwitchModeDropdownOpen;
        $[68] = sections;
        $[69] = t20;
        $[70] = t21;
        $[71] = t22;
        $[72] = t23;
    } else t23 = $[72];
    return t23;
} : ({ mode: mode = 'sidebar', disableModeChange: disableModeChange = false, onModeChange: onModeChange, isSwitchModeDropdownOpen: isSwitchModeDropdownOpen, setIsSwitchModeDropdownOpen: setIsSwitchModeDropdownOpen, onFullscreenClick: onFullscreenClick, isFullScreenModalAvailable: isFullScreenModalAvailable = false })=>{
    const { formatMessage: fm } = (0, $kSwu1.useIntl)();
    const canSwitchMode = onModeChange !== undefined;
    const handleToggleSwitchModeDropdown = (0, $cozmU.useCallback)(()=>{
        setIsSwitchModeDropdownOpen(!isSwitchModeDropdownOpen);
    }, [
        isSwitchModeDropdownOpen,
        setIsSwitchModeDropdownOpen
    ]);
    const handleOnFullscreenClick = (0, $cozmU.useCallback)(()=>{
        if (!onFullscreenClick) return;
        onFullscreenClick();
        handleToggleSwitchModeDropdown();
    }, [
        onFullscreenClick,
        handleToggleSwitchModeDropdown
    ]);
    const handleModeChange = (0, $cozmU.useCallback)((requested)=>{
        if (!canSwitchMode) return;
        handleToggleSwitchModeDropdown();
        onModeChange({
            requested: requested
        });
    }, [
        onModeChange,
        handleToggleSwitchModeDropdown,
        canSwitchMode
    ]);
    const shouldShowFullScreenButton = typeof onFullscreenClick === 'function';
    const shouldShowFullScreenModalButton = isFullScreenModalAvailable && (0, $iDrrr.fg)('agent_session_experience_fg');
    if (!canSwitchMode) return shouldShowFullScreenButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        isTooltipDisabled: false,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))),
        onClick: handleOnFullscreenClick,
        label: fm(shouldShowFullScreenModalButton ? (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenInHomeButtonText : (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenButtonText),
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).fullScreenButton,
        role: "link"
    }) : null;
    const sections = [
        {
            title: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSwitchModeSectionText),
            items: [
                ...canSwitchMode ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).miniModalButton,
                        label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFloatingButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foj7F))), {
                            label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFloatingIconLabel),
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>handleModeChange('mini-modal'),
                        isDisabled: disableModeChange,
                        interactionName: "rovo-change-mode-floating",
                        isActive: mode === 'mini-modal'
                    })
                ] : [],
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                    testId: (0, $85810b69489172e7$export$cad53202c09accc9).sidebarButton,
                    label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSidebarButtonText),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
                        label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSidebarIconLabel),
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    onClick: ()=>handleModeChange('sidebar'),
                    isDisabled: disableModeChange,
                    interactionName: "rovo-change-mode-sidebar",
                    isActive: mode === 'sidebar'
                }),
                ...shouldShowFullScreenModalButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).fullScreenModalButton,
                        label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
                            label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenIconLabel),
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: ()=>handleModeChange('full-screen-modal'),
                        isDisabled: disableModeChange,
                        interactionName: "rovo-change-mode-full-screen-modal",
                        isActive: mode === 'full-screen-modal'
                    })
                ] : [],
                ...shouldShowFullScreenButton ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        testId: (0, $85810b69489172e7$export$cad53202c09accc9).fullScreenButton,
                        label: fm(shouldShowFullScreenModalButton ? (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenInHomeButtonText : (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenButtonText),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))), {
                            label: fm(shouldShowFullScreenModalButton ? (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenInHomeIconLabel : (0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderFullscreenIconLabel),
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: handleOnFullscreenClick,
                        isExternalLink: true
                    })
                ] : []
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Rgab.ChatHeaderMenu), {
        sections: sections,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jW2nL.ChatHeaderMenuList), {
            sections: sections
        }),
        isOpen: isSwitchModeDropdownOpen,
        onClose: ()=>setIsSwitchModeDropdownOpen(false),
        placement: "bottom-end",
        width: "200px",
        maxWidth: "200px",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                isSelected: isSwitchModeDropdownOpen,
                appearance: "subtle",
                isTooltipDisabled: false,
                label: fm((0, $3b18adfeb13ca63b$export$2e2bcd8739ae039).chatHeaderSwitchModeButtonLabel),
                icon: mode === 'mini-modal' ? (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))) : mode === 'full-screen-modal' ? (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))) : (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
                onClick: ()=>setIsSwitchModeDropdownOpen(!isSwitchModeDropdownOpen),
                testId: (0, $85810b69489172e7$export$cad53202c09accc9).switchModeButton
            })
    });
};



var $8VLb5 = parcelRequire("8VLb5");


var $iWk4y = parcelRequire("iWk4y");














const $da5182b95ddf40e8$export$ff4d08873f7aa3d2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { testId: t1 } = t0;
    const testId = t1 === undefined ? "generative-indicator" : t1;
    let t2;
    if ($[0] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2562d2031211559c$exports))),
            alt: "",
            testId: testId,
            width: 20,
            height: 20
        });
        $[0] = testId;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ testId: testId = 'generative-indicator' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2562d2031211559c$exports))),
        alt: "",
        testId: testId,
        width: 20,
        height: 20
    });
};



var $hsq9U = parcelRequire("hsq9U");











var $7cQjw = parcelRequire("7cQjw");




const $ef5a1d3f9c0316fa$export$8a1abb7c176bd202 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { siteId: siteId, orgId: orgId } = (0, $eKjv9.useGlobalConfig)();
    let t0;
    if ($[0] !== orgId || $[1] !== siteId) {
        t0 = (path)=>(0, $7cQjw.getAtlasURL)(siteId, path, orgId);
        $[0] = orgId;
        $[1] = siteId;
        $[2] = t0;
    } else t0 = $[2];
    const atlasURL = t0;
    let t1;
    if ($[3] !== atlasURL) {
        t1 = {
            atlasURL: atlasURL
        };
        $[3] = atlasURL;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { siteId: siteId, orgId: orgId } = (0, $eKjv9.useGlobalConfig)();
    const atlasURL = (0, $cozmU.useCallback)((path)=>(0, $7cQjw.getAtlasURL)(siteId, path, orgId), [
        orgId,
        siteId
    ]);
    return {
        atlasURL: atlasURL
    };
};











const $361b218e381d7d4d$export$13aeeb8b8abbc191 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBackBehaviorOverride() {
    return (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext)).override;
} : function useBackBehaviorOverride() {
    return (0, $cozmU.useContext)((0, $20Kr8.BackBehaviorOverrideContext)).override;
};











const $cea34cae6ceea4d1$export$33b4cc4e9f7f2fb6 = (state)=>{
    return 'currentViewSubtype' in state && state.currentViewSubtype === 'empty';
};








const $25e6e1d7dbe71e10$export$a87e70211dfb97f5 = (screenType, activeMenu)=>{
    (0, $6cFsl.di)((0, $9aRNV.useConversationActionsStore));
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    if (activeMenu !== 'none') return {
        currentViewType: 'menu',
        currentViewSubtype: activeMenu
    };
    if (activeAction) return {
        currentViewType: 'action',
        action: {
            id: activeAction.id
        } // just grabbing ID for now
    };
    // If it's not an activeAction or activeMenu, it's guaranteed to be one of the screenType cases
    return {
        currentViewType: 'chat',
        currentViewSubtype: screenType
    };
};






var $6iQ4q = parcelRequire("6iQ4q");





var $bWJgt = parcelRequire("bWJgt");

const $bdf9a49f6f07cdda$export$494eeb2e4648bc96 = (0, $kBr4q.createHook)((0, $bWJgt.store), {
    selector: (state)=>{
        return Object.values(state).some((messageResearch)=>{
            if (!messageResearch) return false;
            const isInProgress = !!(messageResearch.currentProgress && messageResearch.currentProgress > 0);
            const isErrored = !!messageResearch.errored;
            const isCompleted = !!messageResearch.researchCompleted;
            const isCompletedOrErrored = isCompleted || isErrored;
            const isDeepResearch = messageResearch.isDeepResearch;
            return isInProgress && !isCompletedOrErrored && isDeepResearch;
        });
    }
});















var $dQbwX = parcelRequire("dQbwX");















const $5f9e937904d8d9c3$var$store = (0, $8s9DV.createStore)({
    initialState: {
        isOpen: false
    },
    name: 'DebugModalStore',
    actions: {
        openDebugModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        closeDebugModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    }
});
const $5f9e937904d8d9c3$var$useStore = (0, $kBr4q.createHook)($5f9e937904d8d9c3$var$store);
const $5f9e937904d8d9c3$export$cbb5096309445c3b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const [t0, t1] = $5f9e937904d8d9c3$var$useStore();
    const { isOpen: isOpen } = t0;
    const { openDebugModal: openDebugModal, closeDebugModal: closeDebugModal } = t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $iDrrr.fg)("ai_mate_debug_enabled");
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== closeDebugModal || $[2] !== isOpen || $[3] !== openDebugModal) {
        t3 = {
            isDebugEnabled: t2,
            isDebugModalOpen: isOpen,
            openDebugModal: openDebugModal,
            closeDebugModal: closeDebugModal
        };
        $[1] = closeDebugModal;
        $[2] = isOpen;
        $[3] = openDebugModal;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [{ isOpen: isOpen }, { openDebugModal: openDebugModal, closeDebugModal: closeDebugModal }] = $5f9e937904d8d9c3$var$useStore();
    return {
        isDebugEnabled: (0, $iDrrr.fg)('ai_mate_debug_enabled'),
        isDebugModalOpen: isOpen,
        openDebugModal: openDebugModal,
        closeDebugModal: closeDebugModal
    };
};






const $418a0a565f43a3ce$export$4be696be8a3bff13 = (0, $kBr4q.createHook)((0, $edfbad14347f2caa$export$6f57813fe9f31bf9));


/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */ 









var $88DFk = parcelRequire("88DFk");


var $fa8WQ = parcelRequire("fa8WQ");


var $bpVtj = parcelRequire("bpVtj");


var $3z1p5 = parcelRequire("3z1p5");


var $eP6A1 = parcelRequire("eP6A1");











var $bjY3F = parcelRequire("bjY3F");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");

















var $3jESw = parcelRequire("3jESw");















var $j26HD = parcelRequire("j26HD");







const $37b84e1fa5ee17cc$export$2e7cdd1b32819313 = (conversation)=>{
    return {
        id: conversation.id,
        name: conversation.name,
        lastMessageTimestamp: conversation.lastMessageTimestamp,
        isEmpty: (0, $1IZrU.isEmptyConversation)(conversation.id)
    };
};










var $hd4Ag = parcelRequire("hd4Ag");


var $2BEJj = parcelRequire("2BEJj");





































const $4926bb42e7912d08$export$325b6e88f398f098 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const [{ conversations: conversations, currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { removeConversationFromStore: removeConversationFromStore, setConversationData: setConversationData, setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const { removeTasksForConversation: unifiedRemoveTasksForConversation } = (0, $9qJ1N.useTasksStoreActions)();
    const deleteConversationWithAssistanceService = async ({ conversationId: conversationId })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).CLEAR_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        conversations?.[conversationId]?.storeAbortController?.abort();
        try {
            await assistanceService.deleteChat(conversationId);
        } catch (error) {
            if ((0, $bxkJA.isChannelNotFoundError)(error)) {
                removeConversationFromStore({
                    conversationId: conversationId
                });
                if (currentConversationId === conversationId) setSelectedConversation({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                });
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).CLEAR_CHAT,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
        removeConversationFromStore({
            conversationId: conversationId
        });
        unifiedRemoveTasksForConversation(conversationId);
        if (currentConversationId === conversationId) // reset the selected conversation to the empty conversation id
        // this is stop gap solution until we start to use the new conversation store actions,
        // without this the user will be stuck on the deleted conversation as that is the last selected conversation
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).CLEAR_CHAT
        });
    };
    const updateConversationWithAssistanceService = async ({ conversationId: conversationId, data: data })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        let updatedConversation;
        try {
            updatedConversation = await assistanceService.updateConversationChannel(conversationId, data);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
        const nextData = {
            ...data
        };
        if (updatedConversation) {
            if (updatedConversation.name !== undefined) nextData.name = updatedConversation.name;
            if (updatedConversation.readStatus !== undefined) nextData.readStatus = updatedConversation.readStatus;
            if (typeof updatedConversation.isPinned === 'boolean') nextData.isPinned = updatedConversation.isPinned;
            if (updatedConversation.pinnedAt !== undefined) nextData.pinnedAt = updatedConversation.pinnedAt;
        }
        setConversationData({
            conversationId: conversationId,
            data: nextData
        });
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL
        });
    };
    return {
        deleteConversation: deleteConversationWithAssistanceService,
        updateConversation: updateConversationWithAssistanceService
    };
});


const $c2e50244e69d336a$var$CONVERSATION_LIMIT = 25;
const $c2e50244e69d336a$export$ff0cc4f0d3c9ae80 = (0, $lJ6db.createHookWithAssistanceService)(({ conversationLimit: conversationLimit = $c2e50244e69d336a$var$CONVERSATION_LIMIT, assistanceServiceInjectedParams: assistanceServiceInjectedParams, onConversationStarterClick: onConversationStarterClick, isTasksEnabled: isTasksEnabledProp, isNavOpen: isNavOpen, onViewAllSpacesClick: onViewAllSpacesClick })=>{
    (0, $6cFsl.di)((0, $bpVtj.useUserSitePermissions), (0, $3TxKn.useChatStoreActions), (0, $eKjv9.useGlobalConfig), (0, $3z1p5.useRecommendedAgents), (0, $n71o5.useChatStore), (0, $3TxKn.useChatStoreActions), (0, $bGNkz.useUIStore), (0, $dSCNl.useUIConfig));
    const { siteId: siteId, touchpointSource: touchpointSource, assistanceService: assistanceService } = assistanceServiceInjectedParams;
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const [{ conversations: conversations, isConversationsInitialized: isConversationsInitialized, conversationPagination: conversationPagination }, // warning: do not use actions from Chat Store that require assistance service without extracting them and wrapping in createHookWithAssistanceService
    { setSelectedConversation: setSelectedConversation, loadMoreConversationChannelsData: loadMoreConversationChannelsData }] = (0, $n71o5.useChatStore)();
    const { setConversationData: setConversationData } = (0, $3TxKn.useChatStoreActions)();
    const { removeConversationFromSpaceConversations: removeConversationFromSpaceConversations } = (0, $12shJ.useSpaceStoreActions)();
    const { deleteConversation: deleteConversation, updateConversation: updateConversation } = (0, $4926bb42e7912d08$export$325b6e88f398f098)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    // Authoritative pinned-conversation count (space + non-space) used to gate the pinned-limit
    // popup. Seeded once on mount and refreshed after pin toggles. Left undefined when the backend
    // endpoint is unavailable so the UI falls back to the local (partial) count.
    const [pinnedConversationSummary, setPinnedConversationSummary] = (0, $cozmU.useState)(undefined);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Read the latest assistanceService via a ref so the seed effect below can key off the stable
    // `siteId` instead of the service identity, which is recreated whenever upstream params churn.
    const assistanceServiceRef = (0, $cozmU.useRef)(assistanceService);
    assistanceServiceRef.current = assistanceService;
    const refetchPinnedConversationSummary = (0, $cozmU.useCallback)(async ()=>{
        if (!(0, $iDrrr.fg)('rovo_chat_pinned_fe')) return;
        try {
            const summary = await assistanceServiceRef.current.getPinnedConversationSummary?.();
            if (summary && isMountedRef.current) setPinnedConversationSummary(summary);
        } catch  {
            // Best-effort background fetch — the pinned-limit gate falls back to the local count, so
            // a failure shouldn't disrupt the user. Report it for observability rather than swallow
            // it silently.
            sendAnalyticsEvent({
                action: 'failed',
                actionSubject: 'operation',
                actionSubjectId: 'fetchPinnedConversationSummary',
                attributes: {
                    touchpointSource: touchpointSource
                }
            });
        }
    }, [
        sendAnalyticsEvent,
        touchpointSource
    ]);
    // Seed once per site. Keying on the `assistanceService` identity would refetch on every render
    // where upstream params (e.g. an unstable cloudId) recreate the service, spamming the endpoint.
    // Guarded by a killswitch: when disabled, fall back to keying on the service identity (previous
    // behaviour) so the fix can be turned off in production if needed.
    const pinnedSummarySeedKey = (0, $iDrrr.fg)('rovo_chat_infinite_load_townsquare_fix_killswitch') ? siteId : assistanceService;
    (0, $cozmU.useEffect)(()=>{
        refetchPinnedConversationSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally keyed on siteId (or service identity when the killswitch is off)
    }, [
        pinnedSummarySeedKey
    ]);
    const [rovoAgentCSID, { trackCreateSessionStart: trackCreateSessionStart }] = (0, $88DFk.useRovoAgentCreateAnalytics)({
        touchPoint: touchpointSource
    });
    const { email: email } = (0, $isp1U.useProfileController)();
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const { openModal: openModal } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const { clearActiveAction: clearActiveAction } = (0, $5BOJB.useActiveAction)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const { deleteAgentLocally: deleteAgentLocally } = (0, $3z1p5.useAgentsPaginatedActionsWithOptimistic)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const { activeMenu: activeMenu, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStore)();
    const exitSpace = (0, $2BEJj.useExitSpace)();
    const { setSideNavOpen: setSideNavOpen } = (0, $ecef698430401e91$export$8323ee170f55f743)();
    const { isAbleToCreateAgents: isAbleToCreateAgents } = (0, $bpVtj.useUserSitePermissions)({
        siteId: siteId,
        touchpointSource: 'rovoNavigation'
    });
    const pageUrl = (0, $hd4Ag.useWindowLocation)();
    const { recommendedAgents: recommendedAgents, isFetching: isFetchingRecommendedAgents } = (0, $3z1p5.useRecommendedAgents)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        pageUrl: pageUrl
    });
    const [conversationToBeDeleted, setConversationToBeDeleted] = (0, $cozmU.useState)(undefined);
    const [conversationToBeEdited, setConversationToBeEdited] = (0, $cozmU.useState)(undefined);
    const [conversationToMoveToNewSpace, setConversationToMoveToNewSpace] = (0, $cozmU.useState)(undefined);
    const sendClickEvent = (0, $cozmU.useCallback)((actionSubjectId, attributes, actionSubject)=>sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject || 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                touchpointSource: touchpointSource,
                ...attributes
            }
        }), [
        sendAnalyticsEvent,
        touchpointSource
    ]);
    const canLoadMoreConversations = conversationPagination.hasMore && !conversationPagination.isLoadingMore && Boolean(conversationPagination.nextCursor);
    const handleConversationClick = (0, $cozmU.useCallback)((conversation, isADSNavigationEnabled)=>{
        sendClickEvent('chatViewChatItemClick', {
            conversationId: conversation.id
        });
        // Exit any active space when explicitly switching to a conversation — the selected
        // conversation may not belong to any space, so previous space state (selectedSpace,
        // empty-chat launch state, and aiFeatureContext.projectContext) must not carry
        // over into the new conversation.
        exitSpace();
        setSelectedConversation({
            conversationId: conversation.id,
            conversationMetadata: conversation
        });
        if (!isADSNavigationEnabled) {
            setSideNavOpen(false);
            clearActiveAction();
        }
        if (activeMenu !== 'none') setActiveMenu('none');
    }, [
        activeMenu,
        exitSpace,
        setActiveMenu,
        clearActiveAction,
        setSelectedConversation,
        setSideNavOpen,
        sendClickEvent
    ]);
    const handleSelectAgent = (0, $cozmU.useCallback)((agent, isADSNavigationEnabled)=>{
        sendClickEvent('browseAgentsSelectAgentOption', {
            agentId: agent.id,
            interactionSource: touchpointSource,
            isDefaultAgent: agent.is_default
        });
        if (activeMenu !== 'none') setActiveMenu('none');
        // Exit any active space so the Back button works correctly when an agent
        // is selected on top of an active space chat, and so the agent's fresh
        // empty conversation doesn't inherit stale space quick actions or
        // aiFeatureContext.projectContext.
        exitSpace();
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
            sourceAgentId: agent.id
        });
        if (!isADSNavigationEnabled) setSideNavOpen(false);
    }, [
        setSelectedConversation,
        activeMenu,
        setActiveMenu,
        exitSpace,
        setSideNavOpen,
        sendClickEvent,
        touchpointSource
    ]);
    const handleEditConversationConfirm = (0, $cozmU.useCallback)(async (conversation, newName)=>{
        sendClickEvent('rovoSideNavEditConversationConfirmButton');
        try {
            await updateConversation({
                conversationId: conversation.id,
                data: {
                    name: newName.trim()
                }
            });
        } catch (error) {
            if (error instanceof (0, $8A2GO.ApiError) && (0, $bxkJA.isChannelNotFoundError)(error)) return {
                error: error.message
            };
            throw error;
        }
    }, [
        updateConversation,
        sendClickEvent
    ]);
    const handleConversationPinToggle = (0, $cozmU.useCallback)(async (conversation, isPinned)=>{
        sendClickEvent(isPinned ? 'pinConversationButton' : 'unpinConversationButton');
        try {
            await updateConversation({
                conversationId: conversation.id,
                data: {
                    isPinned: isPinned
                }
            });
        } finally{
            // Reconcile the authoritative count after a toggle (success or backend rejection),
            // so the popup gate reflects the true server-side pinned total. Fire-and-forget: the
            // refetch handles its own errors and never rejects.
            refetchPinnedConversationSummary();
        }
    }, [
        sendClickEvent,
        updateConversation,
        refetchPinnedConversationSummary
    ]);
    const openDeleteModal = (0, $cozmU.useCallback)(async (target)=>{
        sendClickEvent('deleteConversationButton');
        setConversationToBeDeleted(target);
        openModal((0, $37b84e1fa5ee17cc$export$2e7cdd1b32819313)(target), 'delete');
    }, [
        setConversationToBeDeleted,
        openModal,
        sendClickEvent
    ]);
    const openEditModal = (0, $cozmU.useCallback)(async (target)=>{
        sendClickEvent('rovoSideNavEditConversation');
        setConversationToBeEdited(target);
        openModal((0, $37b84e1fa5ee17cc$export$2e7cdd1b32819313)(target), 'edit');
    }, [
        setConversationToBeEdited,
        openModal,
        sendClickEvent
    ]);
    const handleNewChatClick = (0, $cozmU.useCallback)((isADSNavigationEnabled)=>{
        sendClickEvent('chatViewNewChatButton');
        // Exit any active space when starting a new chat — a fresh conversation has no
        // space context, so previous space state must not carry over.
        exitSpace();
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        if (!isADSNavigationEnabled) {
            setSideNavOpen(false);
            clearActiveAction();
        }
        if (activeMenu !== 'none') setActiveMenu('none');
    }, [
        activeMenu,
        exitSpace,
        setActiveMenu,
        clearActiveAction,
        setSelectedConversation,
        setSideNavOpen,
        sendClickEvent
    ]);
    const handleDeleteConfirm = (0, $cozmU.useCallback)(async (conversationId)=>{
        try {
            await deleteConversation({
                conversationId: conversationId
            });
            const backendConversationId = conversationToBeDeleted?.backendConversationId;
            removeConversationFromSpaceConversations(backendConversationId ? [
                conversationId,
                backendConversationId
            ] : [
                conversationId
            ]);
        } catch (error) {
            if (error instanceof (0, $8A2GO.ApiError) && (0, $bxkJA.isChannelNotFoundError)(error)) return {
                error: error.message
            };
            throw error;
        } finally{
            setConversationToBeDeleted(undefined);
        }
    }, [
        conversationToBeDeleted,
        deleteConversation,
        removeConversationFromSpaceConversations
    ]);
    const handleCreateAgentClick = (0, $cozmU.useCallback)(()=>{
        sendClickEvent('browseAgentsCreateAgentButton', {
            interactionSource: touchpointSource
        }, 'link');
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackCreateSessionStart();
        window.open((0, $fa8WQ.getAtlassianStudioNLCreateUrl)(siteId, touchpointSource, rovoAgentCSID, email), '_blank', 'noopener, noreferrer');
    }, [
        siteId,
        sendClickEvent,
        touchpointSource,
        trackCreateSessionStart,
        rovoAgentCSID,
        email
    ]);
    const handleViewAllAgentsClick = (0, $cozmU.useCallback)(()=>{
        sendClickEvent('browseAgentsNavigate', {
            interactionSource: touchpointSource
        });
        if (activeMenu !== 'agents') setActiveMenu('agents');
        setSideNavOpen(false);
    }, [
        sendClickEvent,
        setSideNavOpen,
        activeMenu,
        setActiveMenu,
        touchpointSource
    ]);
    const handleViewAllSpacesClick = (0, $cozmU.useCallback)(()=>{
        // Always emit the analytics click event so we can measure intent even
        // before the destination route exists in every host. Mirrors
        // `handleViewAllAgentsClick`.
        sendClickEvent('browseSpacesNavigate', {
            interactionSource: touchpointSource
        });
        // Allow hosts to override / augment the default behaviour by passing
        // a callback (e.g. Townsquare will navigate to its standalone route).
        // When the host provides one, we DEFER to it entirely and skip
        // flipping `activeMenu` — otherwise we'd leave stale store state
        // pointing at `'browse-spaces'` after the host routes away.
        if (onViewAllSpacesClick) onViewAllSpacesClick();
        else // In-app default: flip the activeMenu to `'browse-spaces'` so
        // `conversation-assistant`'s `main.tsx` renders the
        // `BrowseSpacesView` panel (mirroring how `handleViewAllAgentsClick`
        // flips to `'agents'` to show `BrowseAgentsView`). This makes the
        // link work out-of-the-box for every host that mounts
        // `conversation-assistant` (e.g. Confluence) without needing a
        // host-level route. FE-B5b will register a real Townsquare route +
        // FE-B5c will wire Confluence/Jira embed flows; until then this
        // in-panel view is the canonical destination.
        if (activeMenu !== 'browse-spaces') setActiveMenu('browse-spaces');
        setSideNavOpen(false);
    }, [
        sendClickEvent,
        setSideNavOpen,
        touchpointSource,
        onViewAllSpacesClick,
        activeMenu,
        setActiveMenu
    ]);
    const handleViewAllConversationsClick = (0, $cozmU.useCallback)(()=>{
        sendClickEvent('rovoSideNavViewAllConversations');
        if (activeMenu !== 'conversation-list') setActiveMenu('conversation-list');
        if (canLoadMoreConversations) loadMoreConversationChannelsData();
        setSideNavOpen(false);
    }, [
        activeMenu,
        canLoadMoreConversations,
        loadMoreConversationChannelsData,
        setActiveMenu,
        sendClickEvent,
        setSideNavOpen
    ]);
    const handlePulseClick = (0, $cozmU.useCallback)(()=>{
        if (activeMenu !== 'pulse') setActiveMenu('pulse');
        setSideNavOpen(false);
    }, [
        activeMenu,
        setActiveMenu,
        setSideNavOpen
    ]);
    const handleTasksClick = (0, $cozmU.useCallback)(()=>{
        if (activeMenu !== 'tasks') setActiveMenu('tasks');
        setSideNavOpen(false);
    }, [
        activeMenu,
        setActiveMenu,
        setSideNavOpen
    ]);
    const handleScheduledChatsClick = (0, $cozmU.useCallback)(()=>{
        if (activeMenu !== 'scheduled') setActiveMenu('scheduled');
        setSideNavOpen(false);
    }, [
        activeMenu,
        setActiveMenu,
        setSideNavOpen
    ]);
    const handleSelectRecommendedSpacesClick = (0, $cozmU.useCallback)(()=>{
        if (activeMenu !== 'recommended-spaces') {
            // Start the perceived-load experience at click. It ends when the
            // RecommendedSpacesPanel finishes loading — capturing click→render
            // (which the ROVOFE-3252 prefetch shortens when the cache is warm).
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES,
                name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES
            });
            setActiveMenu('recommended-spaces');
        }
        setSideNavOpen(false);
    }, [
        activeMenu,
        setActiveMenu,
        setSideNavOpen,
        experienceTracker
    ]);
    const handleConversationStarterClick = (0, $cozmU.useCallback)((agent, starter, isADSNavigationEnabled)=>{
        sendClickEvent('rovoSideNavProfileCardStarter', {
            agentId: agent.id
        });
        if (!isADSNavigationEnabled) setSideNavOpen(false);
        onConversationStarterClick?.({
            name: starter.message,
            prompt: (0, $6rwn6.encodeAdf)(starter.message),
            agent: agent,
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages,
            messageSources: {
                interactionSource: 'profileCardConversationStarters',
                followUpSource: 'none'
            }
        });
    }, [
        storeUserMessages,
        setSideNavOpen,
        sendClickEvent,
        onConversationStarterClick
    ]);
    // Initialise SSE connection for live task updates when tasks are enabled and nav is open.
    (0, $3jESw.useUnifiedTasksSSESubscription)({
        enabled: !!isTasksEnabledProp && isNavOpen !== false,
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Single batched hook for active tasks across all conversations + the current one.
    // Sweet-state re-runs the selector on every state change but the resulting Map is
    // only structurally re-derived when an active task in this set actually changes.
    const visibleConvIds = (0, $cozmU.useMemo)(()=>{
        const ids = Object.keys(conversations);
        if (conversation && !ids.includes(conversation.id)) ids.push(conversation.id);
        return ids;
    }, [
        conversations,
        conversation
    ]);
    const [activeTasksByConvId] = (0, $9qJ1N.useActiveTasksForConversations)(visibleConvIds);
    const transformedConversationsForPinnedCount = (0, $cozmU.useMemo)(()=>Object.values(conversations)// Note: conversations with `rovoSpaceId` set are intentionally NOT filtered out
        // here so that `SpaceMenuItems` can render the optimistic chat-store conversation
        // under the correct space immediately on send. The regular conversation list
        // (`ChatListMenuItems`) is responsible for filtering out space-scoped conversations.
        .map((conversation)=>{
            const activeTask = activeTasksByConvId.get(conversation.id);
            return {
                ...conversation,
                currentTask: activeTask ? (0, $9qJ1N.unifiedTaskToApiSSE)(activeTask) : null,
                isEmpty: (0, $1IZrU.isEmptyConversation)(conversation.id)
            };
        }).sort((a, b)=>{
            if (!a.lastMessageTimestamp) return 1;
            if (!b.lastMessageTimestamp) return -1;
            return new Date(b.lastMessageTimestamp).getTime() - new Date(a.lastMessageTimestamp).getTime();
        }), [
        conversations,
        activeTasksByConvId
    ]);
    const transformedConversations = (0, $cozmU.useMemo)(()=>transformedConversationsForPinnedCount.slice(0, conversationLimit), [
        conversationLimit,
        transformedConversationsForPinnedCount
    ]);
    const currentConversation = (0, $cozmU.useMemo)(()=>{
        if (!conversation) return undefined;
        const activeTask = activeTasksByConvId.get(conversation.id);
        return {
            ...conversation,
            currentTask: activeTask ? (0, $9qJ1N.unifiedTaskToApiSSE)(activeTask) : null,
            isEmpty: (0, $1IZrU.isEmptyConversation)(conversation.id),
            id: conversation.id
        };
    }, [
        conversation,
        activeTasksByConvId
    ]);
    const agents = (0, $cozmU.useMemo)(()=>(0, $eP6A1.getDisplayedAgents)({
            recommendedAgents: recommendedAgents,
            agentsByCategoryAllAgents: [],
            agentsByCategoryFavoriteAgents: [],
            selectedAgent: selectedAgent,
            moveSelectedAgentToTop: false
        }), [
        recommendedAgents,
        selectedAgent
    ]);
    const handleMoveConversationToSpace = (0, $cozmU.useCallback)(async (conversation, spaceId)=>{
        sendClickEvent('rovoSideNavMoveConversationToSpace', {
            spaceId: spaceId
        });
        // Optimistically move the conversation into the target space so the
        // UI updates immediately without requiring a page refresh.
        const previousSpaceId = conversation.rovoSpaceId;
        setConversationData({
            conversationId: conversation.id,
            data: {
                rovoSpaceId: spaceId
            }
        });
        try {
            await (0, $j26HD.addConversationToSpaceFetchAction)({
                request: {
                    spaceId: spaceId,
                    conversationId: conversation.id
                },
                cloudId: siteId,
                product: assistanceServiceInjectedParams.product ?? 'rovo',
                experienceId: assistanceServiceInjectedParams.experienceId ?? 'ai-mate'
            });
            const loadPreferenceKey = (0, $hsq9U.getChatLoadPreferenceKey)(siteId);
            const storedConversationId = (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                return localStorage?.getItem(loadPreferenceKey);
            });
            if (storedConversationId === conversation.id || storedConversationId === conversation.backendConversationId) (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                localStorage?.setItem(loadPreferenceKey, (0, $4m5jb.EMPTY_CONVERSATION_ID));
            });
        } catch (error) {
            // Roll back the optimistic update if the API call fails.
            setConversationData({
                conversationId: conversation.id,
                data: {
                    rovoSpaceId: previousSpaceId
                }
            });
            throw error;
        }
    }, [
        sendClickEvent,
        siteId,
        assistanceServiceInjectedParams,
        setConversationData
    ]);
    const handleMoveConversationToNewSpace = (0, $cozmU.useCallback)((conversation)=>{
        sendClickEvent('rovoSideNavMoveConversationToNewSpace');
        setConversationToMoveToNewSpace(conversation);
    }, [
        sendClickEvent
    ]);
    const clearConversationToMoveToNewSpace = (0, $cozmU.useCallback)(()=>{
        setConversationToMoveToNewSpace(undefined);
    }, []);
    return {
        siteId: siteId,
        conversations: transformedConversations,
        pinnedCountConversations: transformedConversationsForPinnedCount,
        pinnedConversationSummary: pinnedConversationSummary,
        currentConversation: currentConversation,
        agents: agents,
        recommendedAgents: recommendedAgents,
        selectedAgent: selectedAgent,
        isAbleToCreateAgents: isAbleToCreateAgents,
        isFetchingRecommendedAgents: isFetchingRecommendedAgents,
        isConversationsInitialized: isConversationsInitialized,
        handleConversationClick: handleConversationClick,
        handleCreateAgentClick: handleCreateAgentClick,
        handleNewChatClick: handleNewChatClick,
        handleSelectAgent: handleSelectAgent,
        handleViewAllAgentsClick: handleViewAllAgentsClick,
        handleViewAllSpacesClick: handleViewAllSpacesClick,
        handleViewAllConversationsClick: handleViewAllConversationsClick,
        handlePulseClick: handlePulseClick,
        handleTasksClick: handleTasksClick,
        handleScheduledChatsClick: handleScheduledChatsClick,
        handleSelectRecommendedSpacesClick: handleSelectRecommendedSpacesClick,
        handleConversationStarterClick: handleConversationStarterClick,
        handleConversationPinToggle: handleConversationPinToggle,
        deleteAgentLocally: deleteAgentLocally,
        deleteConversation: {
            conversationToBeDeleted: conversationToBeDeleted,
            openDeleteModal: openDeleteModal,
            handleDeleteConfirm: handleDeleteConfirm
        },
        editConversation: {
            handleEditConversationConfirm: handleEditConversationConfirm,
            openEditModal: openEditModal,
            conversationToBeEdited: conversationToBeEdited
        },
        moveToSpace: {
            handleMoveConversationToSpace: handleMoveConversationToSpace,
            handleMoveConversationToNewSpace: handleMoveConversationToNewSpace,
            conversationToMoveToNewSpace: conversationToMoveToNewSpace,
            clearConversationToMoveToNewSpace: clearConversationToMoveToNewSpace
        }
    };
});















const $4f4ec7923c508b72$export$558d819e93cfc429 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $8bfedffef2e76c2c$export$1f821a7525912239));
} : ()=>{
    return (0, $cozmU.useContext)((0, $8bfedffef2e76c2c$export$1f821a7525912239));
};




























var $iiDOK = parcelRequire("iiDOK");




const $fa97f42a67044031$var$messages = (0, $kSwu1.defineMessages)({
    splitLayoutExpandButtonLabel: {
        id: "conversation-assistant.split-layout.split-layout-toggle.splitLayoutExpandButtonLabel.non-final",
        defaultMessage: "View context"
    },
    splitLayoutCollapseButtonLabel: {
        id: "conversation-assistant.split-layout.split-layout-toggle.splitLayoutCollapseButtonLabel.non-final",
        defaultMessage: "Hide context"
    }
});
var $fa97f42a67044031$export$2e2bcd8739ae039 = $fa97f42a67044031$var$messages;


/** Viewport-width fraction to expand to; ≥ 0.5 clamps to the panel's 50% cap. */ const $eaa38ceae368727c$export$7151fa74e5c1211 = 0.51;
const $eaa38ceae368727c$export$9026c26c84d4e2c = 400;



const $a824a72437133b16$export$e69847c86def7de3 = ()=>Math.ceil((0, $eaa38ceae368727c$export$7151fa74e5c1211) * window.innerWidth);


/** Clamps `targetWidth` to the range input's `min`/`max` bounds (when finite/positive). */ const $b45a4cc6c1fceed4$export$211d5c50d92885a4 = (input, targetWidth)=>{
    const min = Number(input.min);
    const max = Number(input.max);
    let clamped = targetWidth;
    if (Number.isFinite(min)) clamped = Math.max(clamped, min);
    if (Number.isFinite(max) && max > 0) clamped = Math.min(clamped, max);
    return clamped;
};


/**
 * Finds the Nav 4 panel's range `input` that the splitter uses to resize the
 * enclosing layout slot, starting from an element inside the panel. Returns
 * `null` when the element is not inside a resizable panel section.
 */ const $cf9ef681e9746dc4$export$ddbadfeb5fd60ea1 = (fromElement)=>{
    if (!fromElement) return null;
    const panelSection = fromElement.closest('section[data-layout-slot]');
    if (!panelSection) return null;
    return panelSection.querySelector('input[type="range"]');
};


/** Sets the value via the native setter (bypassing React's value tracking) and dispatches `input` + `change` so React's synthetic `onChange` still fires. */ const $0340f5c68a03d5c0$var$setInputValueAndDispatch = (input, value)=>{
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
    if (nativeInputValueSetter) nativeInputValueSetter.call(input, String(value));
    else input.value = String(value);
    input.dispatchEvent(new Event('input', {
        bubbles: true
    }));
    input.dispatchEvent(new Event('change', {
        bubbles: true
    }));
};
const $0340f5c68a03d5c0$export$4a23a2e3983b8bd7 = (fromElement, targetWidth)=>{
    const input = (0, $cf9ef681e9746dc4$export$ddbadfeb5fd60ea1)(fromElement);
    if (!input) return false;
    input.focus();
    const applyResize = ()=>{
        $0340f5c68a03d5c0$var$setInputValueAndDispatch(input, (0, $b45a4cc6c1fceed4$export$211d5c50d92885a4)(input, targetWidth));
    };
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(applyResize);
    else applyResize();
    return true;
};


const $6fa6cf0325943475$export$a1cb04121e1ba5f5 = (fromElement)=>{
    if (typeof window === 'undefined') return false;
    return (0, $0340f5c68a03d5c0$export$4a23a2e3983b8bd7)(fromElement, (0, $a824a72437133b16$export$e69847c86def7de3)());
};



const $d8c215c1ff57f609$export$336fe110420dd461 = (fromElement)=>{
    const input = (0, $cf9ef681e9746dc4$export$ddbadfeb5fd60ea1)(fromElement);
    if (!input) return null;
    // Focus so the splitter refreshes the input's value/bounds before we read.
    input.focus();
    const value = Number(input.value);
    return Number.isFinite(value) ? value : null;
};





const $3a044bab708e23ca$export$da1dd9d5964275c8 = (fromElement, onWidthReady)=>{
    if (typeof window === 'undefined') {
        onWidthReady(null);
        return;
    }
    const input = (0, $cf9ef681e9746dc4$export$ddbadfeb5fd60ea1)(fromElement);
    if (!input) {
        onWidthReady(null);
        return;
    }
    input.focus();
    const readRefreshedWidth = ()=>{
        onWidthReady((0, $b45a4cc6c1fceed4$export$211d5c50d92885a4)(input, (0, $a824a72437133b16$export$e69847c86def7de3)()));
    };
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(readRefreshedWidth);
    else readRefreshedWidth();
};



const $3f67b4420feee1b1$export$450e8e271e4a0001 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { onToggle: onToggle } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const buttonRef = (0, $cozmU.useRef)(null);
    const preExpandWidthRef = (0, $cozmU.useRef)(null);
    const { closeSessionContext: closeSessionContext, openSessionContext: openSessionContext, presentation: presentation, rightPanelExitHandlerRef: rightPanelExitHandlerRef } = (0, $iiDOK.useSplitView)();
    const isOpen = presentation !== null;
    let t1;
    if ($[0] !== closeSessionContext || $[1] !== isOpen || $[2] !== onToggle || $[3] !== openSessionContext || $[4] !== presentation || $[5] !== rightPanelExitHandlerRef || $[6] !== sendAnalyticsEvent) {
        t1 = ()=>{
            if (!isOpen) {
                if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                (0, $3a044bab708e23ca$export$da1dd9d5964275c8)(buttonRef.current, (expandedPanelWidth)=>{
                    const requestedPresentation = expandedPanelWidth !== null && expandedPanelWidth >= (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH) ? "split" : "drawer";
                    const resolvedPresentation = openSessionContext(requestedPresentation);
                    if (resolvedPresentation === "split") {
                        preExpandWidthRef.current = (0, $d8c215c1ff57f609$export$336fe110420dd461)(buttonRef.current);
                        (0, $6fa6cf0325943475$export$a1cb04121e1ba5f5)(buttonRef.current);
                    }
                    sendAnalyticsEvent({
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "viewContextButton",
                        attributes: {
                            isOpen: true,
                            presentation: resolvedPresentation
                        }
                    });
                    onToggle?.(true);
                });
                return;
            }
            if (presentation === "split") {
                const button = buttonRef.current;
                const targetWidth = preExpandWidthRef.current ?? (0, $eaa38ceae368727c$export$9026c26c84d4e2c);
                if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = ()=>(0, $0340f5c68a03d5c0$export$4a23a2e3983b8bd7)(button, targetWidth);
                else (0, $0340f5c68a03d5c0$export$4a23a2e3983b8bd7)(button, targetWidth);
            }
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "viewContextButton",
                attributes: {
                    isOpen: false,
                    presentation: presentation
                }
            });
            closeSessionContext();
            onToggle?.(false);
        };
        $[0] = closeSessionContext;
        $[1] = isOpen;
        $[2] = onToggle;
        $[3] = openSessionContext;
        $[4] = presentation;
        $[5] = rightPanelExitHandlerRef;
        $[6] = sendAnalyticsEvent;
        $[7] = t1;
    } else t1 = $[7];
    const handleClick = t1;
    let t2;
    if ($[8] !== formatMessage || $[9] !== isOpen) {
        t2 = isOpen ? formatMessage((0, $fa97f42a67044031$export$2e2bcd8739ae039).splitLayoutCollapseButtonLabel) : formatMessage((0, $fa97f42a67044031$export$2e2bcd8739ae039).splitLayoutExpandButtonLabel);
        $[8] = formatMessage;
        $[9] = isOpen;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== handleClick || $[12] !== isOpen || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ref: buttonRef,
            testId: (0, $85810b69489172e7$export$cad53202c09accc9).splitLayoutButton,
            appearance: "subtle",
            isSelected: isOpen,
            isTooltipDisabled: false,
            label: t2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            onClick: handleClick
        });
        $[11] = handleClick;
        $[12] = isOpen;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : ({ onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const buttonRef = (0, $cozmU.useRef)(null);
    const preExpandWidthRef = (0, $cozmU.useRef)(null);
    const { closeSessionContext: closeSessionContext, openSessionContext: openSessionContext, presentation: presentation, rightPanelExitHandlerRef: rightPanelExitHandlerRef } = (0, $iiDOK.useSplitView)();
    const isOpen = presentation !== null;
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!isOpen) {
            if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
            (0, $3a044bab708e23ca$export$da1dd9d5964275c8)(buttonRef.current, (expandedPanelWidth)=>{
                const requestedPresentation = expandedPanelWidth !== null && expandedPanelWidth >= (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH) ? 'split' : 'drawer';
                const resolvedPresentation = openSessionContext(requestedPresentation);
                if (resolvedPresentation === 'split') {
                    preExpandWidthRef.current = (0, $d8c215c1ff57f609$export$336fe110420dd461)(buttonRef.current);
                    (0, $6fa6cf0325943475$export$a1cb04121e1ba5f5)(buttonRef.current);
                }
                sendAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'viewContextButton',
                    attributes: {
                        isOpen: true,
                        presentation: resolvedPresentation
                    }
                });
                onToggle?.(true);
            });
            return;
        }
        if (presentation === 'split') {
            // Only the split expands the panel, so only the split needs its width restored. Defer the
            // restore until the right pane has finished animating out (SplitLayout fires the exit handler).
            const button = buttonRef.current;
            const targetWidth = preExpandWidthRef.current ?? (0, $eaa38ceae368727c$export$9026c26c84d4e2c);
            if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = ()=>(0, $0340f5c68a03d5c0$export$4a23a2e3983b8bd7)(button, targetWidth);
            else (0, $0340f5c68a03d5c0$export$4a23a2e3983b8bd7)(button, targetWidth);
        }
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'viewContextButton',
            attributes: {
                isOpen: false,
                presentation: presentation
            }
        });
        closeSessionContext();
        onToggle?.(false);
    }, [
        closeSessionContext,
        isOpen,
        onToggle,
        openSessionContext,
        presentation,
        rightPanelExitHandlerRef,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        ref: buttonRef,
        testId: (0, $85810b69489172e7$export$cad53202c09accc9).splitLayoutButton,
        appearance: "subtle",
        isSelected: isOpen,
        isTooltipDisabled: false,
        label: isOpen ? formatMessage((0, $fa97f42a67044031$export$2e2bcd8739ae039).splitLayoutCollapseButtonLabel) : formatMessage((0, $fa97f42a67044031$export$2e2bcd8739ae039).splitLayoutExpandButtonLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        onClick: handleClick
    });
};








































var $eKpjD = parcelRequire("eKpjD");




var $b8pma = parcelRequire("b8pma");


var $fWd0x = parcelRequire("fWd0x");











var $1EipK = parcelRequire("1EipK");


var $ji12t = parcelRequire("ji12t");


var $iscQS = parcelRequire("iscQS");














var $2yWJZ = parcelRequire("2yWJZ");


var $9qjJ9 = parcelRequire("9qjJ9");



















/**
 * @generated SignedSource<<2b652781c8a4f2c663fcf08b7cf9e024>>
 * @relayHash 1c7c7e056d97fe61d9efa818479110a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 994caab6d298efe9c86fe6f6b1299c3f3e986cd09a4bd4a6d5a9c64e0993171e
const $17f31e899a9d7448$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "agentAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "identityAccountId"
            }
        ],
        "type": "AgentStudioAssistant"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentIdentityAccountDisplayAgentQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentIdentityAccountDisplayAgentQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "994caab6d298efe9c86fe6f6b1299c3f3e986cd09a4bd4a6d5a9c64e0993171e",
            "metadata": {},
            "name": "agentIdentityAccountDisplayAgentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$17f31e899a9d7448$var$node.hash = "f425ce6033269983abd1c7fd93a90842";
var $17f31e899a9d7448$export$2e2bcd8739ae039 = $17f31e899a9d7448$var$node;


/**
 * @generated SignedSource<<6ef4c731cd196dbbe18b90f84bcb9c2a>>
 * @relayHash 3f773ceaa3eb1b67a566743585cc26f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a258f330f15843a404b1bf54f75c5c4994e9460635f03d3848903db1077d81d1
const $b1ec811b9a9f5662$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "identityAccountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "identityAccountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentIdentityAccountDisplayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "avatarRelay_user"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentIdentityAccountDisplayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a258f330f15843a404b1bf54f75c5c4994e9460635f03d3848903db1077d81d1",
            "metadata": {},
            "name": "agentIdentityAccountDisplayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b1ec811b9a9f5662$var$node.hash = "f1ba64296889ddd0eaa29e3040e21802";
var $b1ec811b9a9f5662$export$2e2bcd8739ae039 = $b1ec811b9a9f5662$var$node;















var $eFbDl = parcelRequire("eFbDl");











var $4Sb8b = parcelRequire("4Sb8b");


var $bwd6H = parcelRequire("bwd6H");




const $378441c36b652603$var$AgentIdentityAccountDisplayFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { size: size, testId: testId, textXcss: textXcss } = t0;
    const isLarge = size === "large";
    const t1 = isLarge ? "large" : "small";
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isLarge ? "160px" : "72px";
    const t4 = isLarge ? "24px" : "12px";
    let t5;
    if ($[2] !== t3 || $[3] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: t3,
            height: t4,
            borderRadius: "var(--ds-radius-xsmall, 2px)",
            isShimmering: true
        });
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t5 || $[6] !== testId || $[7] !== textXcss) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: testId,
            xcss: textXcss
        }, t5);
        $[5] = t5;
        $[6] = testId;
        $[7] = textXcss;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t2 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t6);
        $[9] = t2;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ size: size, testId: testId, textXcss: textXcss })=>{
    const isLarge = size === 'large';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
        appearance: "hexagon",
        size: isLarge ? 'large' : 'small'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: textXcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: isLarge ? '160px' : '72px',
        height: isLarge ? '24px' : '12px',
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    })));
};
const $378441c36b652603$var$AgentIdentityAccountDisplayContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { identityAccount: identityAccount, onNameResolved: onNameResolved, size: size, testId: testId, textXcss: textXcss } = t0;
    let t1;
    if ($[0] !== identityAccount.name) {
        t1 = identityAccount.name?.trim();
        $[0] = identityAccount.name;
        $[1] = t1;
    } else t1 = $[1];
    const relayName = t1;
    let t2;
    let t3;
    if ($[2] !== onNameResolved || $[3] !== relayName) {
        t2 = ()=>{
            if (relayName) onNameResolved?.(relayName);
        };
        t3 = [
            onNameResolved,
            relayName
        ];
        $[2] = onNameResolved;
        $[3] = relayName;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t2, t3);
    if (!relayName) return null;
    const avatarSize = size === "large" ? "large" : "small";
    if (size === "large") {
        let t4;
        if ($[6] !== avatarSize || $[7] !== identityAccount || $[8] !== relayName) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
                userFragment: identityAccount,
                size: avatarSize,
                name: relayName
            });
            $[6] = avatarSize;
            $[7] = identityAccount;
            $[8] = relayName;
            $[9] = t4;
        } else t4 = $[9];
        let t5;
        if ($[10] !== relayName || $[11] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "large",
                testId: testId
            }, relayName);
            $[10] = relayName;
            $[11] = testId;
            $[12] = t5;
        } else t5 = $[12];
        let t6;
        if ($[13] !== t4 || $[14] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
            $[13] = t4;
            $[14] = t5;
            $[15] = t6;
        } else t6 = $[15];
        return t6;
    }
    let t4;
    if ($[16] !== avatarSize || $[17] !== identityAccount || $[18] !== relayName) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
            userFragment: identityAccount,
            size: avatarSize,
            name: relayName
        });
        $[16] = avatarSize;
        $[17] = identityAccount;
        $[18] = relayName;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== relayName || $[21] !== testId || $[22] !== textXcss) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: testId,
            xcss: textXcss
        }, relayName);
        $[20] = relayName;
        $[21] = testId;
        $[22] = textXcss;
        $[23] = t5;
    } else t5 = $[23];
    let t6;
    if ($[24] !== t4 || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[24] = t4;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
} : ({ identityAccount: identityAccount, onNameResolved: onNameResolved, size: size, testId: testId, textXcss: textXcss })=>{
    const relayName = identityAccount.name?.trim();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (relayName) onNameResolved?.(relayName);
    }, [
        onNameResolved,
        relayName
    ]);
    if (!relayName) return null;
    const avatarSize = size === 'large' ? 'large' : 'small';
    if (size === 'large') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
        userFragment: identityAccount,
        size: avatarSize,
        name: relayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        testId: testId
    }, relayName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
        userFragment: identityAccount,
        size: avatarSize,
        name: relayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: textXcss
    }, relayName));
};
const $378441c36b652603$var$AgentIdentityAccountDisplayFromRelay = ({ accountId: accountId, onNameResolved: onNameResolved, size: size, testId: testId, textXcss: textXcss })=>{
    (0, $6cFsl.di)((0, $6SsN4.useLazyLoadQuery));
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $b1ec811b9a9f5662$export$2e2bcd8739ae039), {
        identityAccountId: accountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    if (!data.user) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayContent, {
        identityAccount: data.user,
        onNameResolved: onNameResolved,
        size: size,
        testId: testId,
        textXcss: textXcss
    });
};
const $378441c36b652603$var$AgentIdentityAccountDisplayFromAgentRelay = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    let agentId;
    let cloudId;
    let existingAgentAri;
    let presentationProps;
    if ($[0] !== t0) {
        ({ agentAri: existingAgentAri, agentId: agentId, cloudId: cloudId, ...presentationProps } = t0);
        $[0] = t0;
        $[1] = agentId;
        $[2] = cloudId;
        $[3] = existingAgentAri;
        $[4] = presentationProps;
    } else {
        agentId = $[1];
        cloudId = $[2];
        existingAgentAri = $[3];
        presentationProps = $[4];
    }
    let t1;
    if ($[5] !== agentId || $[6] !== cloudId || $[7] !== existingAgentAri) {
        t1 = {
            agentId: agentId,
            existingAgentAri: existingAgentAri,
            cloudId: cloudId
        };
        $[5] = agentId;
        $[6] = cloudId;
        $[7] = existingAgentAri;
        $[8] = t1;
    } else t1 = $[8];
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)(t1);
    const t2 = agentAri ?? "";
    const t3 = !agentAri;
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = {
            agentAri: t2,
            skip: t3
        };
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            fetchPolicy: "store-or-network"
        };
        $[12] = t5;
    } else t5 = $[12];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $17f31e899a9d7448$export$2e2bcd8739ae039), t4, t5);
    const identityAccountId = data.agentStudio_agentById?.__typename === "AgentStudioAssistant" ? data.agentStudio_agentById.identityAccountId : undefined;
    let t6;
    if ($[13] !== identityAccountId) {
        t6 = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(identityAccountId);
        $[13] = identityAccountId;
        $[14] = t6;
    } else t6 = $[14];
    const accountId = t6;
    if (!accountId) return null;
    let t7;
    if ($[15] !== accountId || $[16] !== presentationProps) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFromRelay, {
            accountId: accountId,
            ...presentationProps
        });
        $[15] = accountId;
        $[16] = presentationProps;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ agentAri: existingAgentAri, agentId: agentId, cloudId: cloudId, ...presentationProps })=>{
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)({
        agentId: agentId,
        existingAgentAri: existingAgentAri,
        cloudId: cloudId
    });
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $17f31e899a9d7448$export$2e2bcd8739ae039), {
        agentAri: agentAri ?? '',
        skip: !agentAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const identityAccountId = data.agentStudio_agentById?.__typename === 'AgentStudioAssistant' ? data.agentStudio_agentById.identityAccountId : undefined;
    const accountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(identityAccountId);
    if (!accountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFromRelay, {
        accountId: accountId,
        ...presentationProps
    });
};
const $378441c36b652603$export$24659eec65ce025d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { agentAri: agentAri, agentId: agentId, cloudId: cloudId, identityAccountId: identityAccountId, onNameResolved: onNameResolved, size: size, testId: testId, textXcss: textXcss } = t0;
    let t1;
    if ($[0] !== identityAccountId) {
        t1 = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(identityAccountId);
        $[0] = identityAccountId;
        $[1] = t1;
    } else t1 = $[1];
    const accountId = t1;
    const canHydrateIdentityFromAgent = Boolean(agentId && cloudId);
    if (!accountId && !canHydrateIdentityFromAgent) return null;
    let t2;
    if ($[2] !== accountId || $[3] !== agentAri || $[4] !== agentId || $[5] !== cloudId) {
        t2 = [
            accountId,
            agentAri,
            agentId,
            cloudId
        ];
        $[2] = accountId;
        $[3] = agentAri;
        $[4] = agentId;
        $[5] = cloudId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== size || $[8] !== testId || $[9] !== textXcss) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFallback, {
            size: size,
            testId: testId,
            textXcss: textXcss
        });
        $[7] = size;
        $[8] = testId;
        $[9] = textXcss;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== accountId || $[12] !== agentAri || $[13] !== agentId || $[14] !== cloudId || $[15] !== onNameResolved || $[16] !== size || $[17] !== testId || $[18] !== textXcss) {
        t4 = accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFromRelay, {
            accountId: accountId,
            onNameResolved: onNameResolved,
            size: size,
            testId: testId,
            textXcss: textXcss
        }) : agentId && cloudId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFromAgentRelay, {
            agentAri: agentAri,
            agentId: agentId,
            cloudId: cloudId,
            onNameResolved: onNameResolved,
            size: size,
            testId: testId,
            textXcss: textXcss
        }) : null;
        $[11] = accountId;
        $[12] = agentAri;
        $[13] = agentId;
        $[14] = cloudId;
        $[15] = onNameResolved;
        $[16] = size;
        $[17] = testId;
        $[18] = textXcss;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== t3 || $[21] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: t3
        }, t4);
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== t2 || $[24] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: null,
            resetKeys: t2
        }, t5);
        $[23] = t2;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ agentAri: agentAri, agentId: agentId, cloudId: cloudId, identityAccountId: identityAccountId, onNameResolved: onNameResolved, size: size, testId: testId, textXcss: textXcss })=>{
    const accountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(identityAccountId);
    const canHydrateIdentityFromAgent = Boolean(agentId && cloudId);
    if (!accountId && !canHydrateIdentityFromAgent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: null,
        resetKeys: [
            accountId,
            agentAri,
            agentId,
            cloudId
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFallback, {
            size: size,
            testId: testId,
            textXcss: textXcss
        })
    }, accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFromRelay, {
        accountId: accountId,
        onNameResolved: onNameResolved,
        size: size,
        testId: testId,
        textXcss: textXcss
    }) : agentId && cloudId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($378441c36b652603$var$AgentIdentityAccountDisplayFromAgentRelay, {
        agentAri: agentAri,
        agentId: agentId,
        cloudId: cloudId,
        onNameResolved: onNameResolved,
        size: size,
        testId: testId,
        textXcss: textXcss
    }) : null));
};





const $c7b4e8294b0fef3a$var$message = (0, $kSwu1.defineMessages)({
    browseAgentsMenuTitle: {
        id: "ai-mate.chat-header.browse-agents-title",
        defaultMessage: "Browse agents"
    },
    chatHistoryMenuTitle: {
        id: "ai-mate.chat-header.chat-history-title",
        defaultMessage: "Chat History"
    },
    pulseMenuTitle: {
        id: "ai-mate.chat-header.insights-title",
        defaultMessage: "Insights"
    },
    tasksMenuTitle: {
        id: "ai-mate.chat-header.tasks-title",
        defaultMessage: "Tasks"
    },
    scheduledChatsMenuTitle: {
        id: "ai-mate.chat-header.scheduled-chats-title",
        defaultMessage: "Scheduled chats"
    },
    searchWorkMenuTitle: {
        id: "ai-mate.chat-header.search-work-title",
        defaultMessage: "Search work"
    },
    allChatsMenuTitle: {
        id: "ai-mate.chat-header.all-chats-menu-title",
        defaultMessage: "All chats"
    },
    recommendedSpacesMenuTitle: {
        id: "ai-mate.chat-header.recommended-spaces-title",
        defaultMessage: "Recommended Rovo spaces"
    },
    defaultAgentName: {
        id: "ai-mate.chat-header.default-agent-name",
        defaultMessage: "Rovo"
    },
    changeAgent: {
        id: "ai-mate.chat-header.change-agent",
        defaultMessage: "Change agent - {agentName}"
    }
});
var $c7b4e8294b0fef3a$export$2e2bcd8739ae039 = $c7b4e8294b0fef3a$var$message;




















const $d0349f9915ed8149$var$messages = (0, $kSwu1.defineMessages)({
    draftVersion: {
        id: "ai-mate.chat-header.version-lozenge.draft-version",
        defaultMessage: "Draft"
    },
    liveVersion: {
        id: "ai-mate.chat-header.version-lozenge.live-version",
        defaultMessage: "Live"
    },
    versionNumber: {
        id: "ai-mate.chat-header.version-lozenge.version-number",
        defaultMessage: "V{versionNumber}"
    }
});
var $d0349f9915ed8149$export$2e2bcd8739ae039 = $d0349f9915ed8149$var$messages;


const $39a696e01b702820$export$ecb7d61a44ed0b79 = ()=>{
    (0, $6cFsl.di)((0, $5wAPd.useConversation));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { agentVersion: agentVersion } = (0, $5wAPd.useConversation)();
    const versionType = agentVersion?.versionType;
    if (versionType === 'DRAFT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, formatMessage((0, $d0349f9915ed8149$export$2e2bcd8739ae039).draftVersion));
    // Don't render a LIVE lozenge: by default, sending a message to an agent
    // without an explicit version targets the LIVE version, so showing the
    // lozenge in this case is redundant and inconsistent with the "no lozenge
    // when nothing is selected" behaviour for the default case.
    if (versionType === 'LIVE') return null;
    // For other version types (e.g. superseded), show the version number
    if (agentVersion?.versionNumber != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, formatMessage((0, $d0349f9915ed8149$export$2e2bcd8739ae039).versionNumber, {
        versionNumber: agentVersion.versionNumber
    }));
    return null;
};


const $44dd79506b6f65c7$var$styles = {
    agentTitlePressable: "_30huDKjg0e _0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _0KLXru66of _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6QgVvo _1eOmH6o126 _3gzVzLN4oS",
    agentIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    agentTitleSelected: "_3vBAKHQvmT _0KLXruY9q9 _1UtDYzM7Tp _1eOmH6sumd _0clgaMM7Tp",
    agentTitleWrapper: "_4ouGXIdnbC",
    agentTitleInline: "_2sNsIgEqul _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _2fwxA5ecOK _1ANEUSLRg7 _39HuIbz8Lp",
    agentTitleInlineSelected: "_1UtDYzjTy9"
};
const $44dd79506b6f65c7$var$AgentTitle = ({ agent: agent, defaultAgentName: defaultAgentName, isDropdownOpen: isDropdownOpen, onPress: onPress, triggerProps: triggerProps, formatMessage: formatMessage, cloudId: cloudId, agentProfileCardProps: agentProfileCardProps })=>{
    const agentName = agent?.name ?? defaultAgentName;
    const identityAccountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(agent?.identity_account_id);
    const identityDisplayKey = identityAccountId ?? agent?.id;
    const [resolvedIdentityName, setResolvedIdentityName] = (0, $cozmU.useState)();
    const mentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const shouldUseRelayAgentIdentityDisplay = Boolean(agent) && mentionAgentsExperimentEnabled;
    const accessibleAgentName = resolvedIdentityName && resolvedIdentityName.identityKey === identityDisplayKey ? resolvedIdentityName.name : agentName;
    const handleIdentityNameResolved = (0, $cozmU.useCallback)((name)=>{
        if (!identityDisplayKey) return;
        setResolvedIdentityName((currentName)=>currentName?.identityKey === identityDisplayKey && currentName.name === name ? currentName : {
                identityKey: identityDisplayKey,
                name: name
            });
    }, [
        identityDisplayKey
    ]); // Only show version lozenge when the agent is loaded to avoid showing it next to the default 'Rovo' name
    const showVersionLozenge = !!agent && (0, $iDrrr.fg)('rovo_agent_versioning_enabled');
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.100"
    }, shouldUseRelayAgentIdentityDisplay && agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $378441c36b652603$export$24659eec65ce025d), {
        agentAri: agent.agentAri,
        agentId: agent.id,
        cloudId: cloudId,
        identityAccountId: agent.identity_account_id,
        onNameResolved: handleIdentityNameResolved,
        size: "small",
        testId: "agent-title-relay-name",
        textXcss: (0, $w6R6I.cx)($44dd79506b6f65c7$var$styles.agentTitleInline, isDropdownOpen && $44dd79506b6f65c7$var$styles.agentTitleInlineSelected)
    }), agent.is_verified && (0, $iDrrr.fg)('rovo_agents_agent_verification') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), null) : null, showVersionLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39a696e01b702820$export$ecb7d61a44ed0b79), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        size: "small",
        agentId: agent.id,
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentIdentityAccountId: agent.identity_account_id,
        imageUrl: agent.placeholderAvatarUrl,
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent),
        forgeAgentIconUrl: agent.icon
    }) : mentionAgentsExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qjJ9.DefaultRovoAvatar), {
        name: agentName,
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44dd79506b6f65c7$var$styles.agentIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
        label: "",
        shouldUseHexLogo: true,
        size: "xsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        xcss: $44dd79506b6f65c7$var$styles.agentTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($44dd79506b6f65c7$var$styles.agentTitleInline, isDropdownOpen && $44dd79506b6f65c7$var$styles.agentTitleInlineSelected)
    }, agentName), agent?.is_verified && (0, $iDrrr.fg)('rovo_agents_agent_verification') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), null) : null, showVersionLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39a696e01b702820$export$ecb7d61a44ed0b79), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    })); // Offsets the pressable's padding and border
    const hoverCardOffset = [
        -7,
        12
    ];
    const handlePressableClick = (0, $cozmU.useCallback)((event)=>{
        const target = event.target; // Check if the click originates from the agent title pressable area
        // This prevents clicks in the agent profile card from triggering the dropdown
        const isWithinAgentPressable = target.closest('[data-testid="agent-title-pressable"]');
        if (isWithinAgentPressable) onPress();
    }, [
        onPress
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...triggerProps,
        xcss: (0, $w6R6I.cx)($44dd79506b6f65c7$var$styles.agentTitlePressable, isDropdownOpen && $44dd79506b6f65c7$var$styles.agentTitleSelected),
        onClick: handlePressableClick,
        testId: "agent-title-pressable",
        "aria-label": formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).changeAgent, {
            agentName: accessibleAgentName
        })
    }, agentProfileCardProps ? (0, $iDrrr.fg)('rovo_agent_profile_card_relay') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1EipK.AgentProfileCardWithTrigger), {
        key: isDropdownOpen ? 'menu-open' : 'menu-closed',
        placement: "bottom-end",
        trigger: isDropdownOpen ? [] : 'hover',
        identityAccountId: agentProfileCardProps.identityAccountId,
        cloudId: agentProfileCardProps.cloudId,
        onConversationStarterClick: (prompt)=>{
            agentProfileCardProps.onConversationStartersClick({
                message: prompt,
                type: 'static'
            });
        }
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKpjD.AgentProfileCardTrigger), {
        ref: agentProfileCardProps.profileCardRef,
        placement: "bottom-start",
        offset: hoverCardOffset,
        trigger: "hover",
        agentId: agentProfileCardProps.agentId,
        resourceClient: agentProfileCardProps.resourceClient,
        onConversationStartersClick: (starter)=>{
            agentProfileCardProps.onConversationStartersClick(starter);
        },
        cloudId: agentProfileCardProps.cloudId,
        viewingUserId: agentProfileCardProps.viewingUserId
    }, content) : content);
};
const $44dd79506b6f65c7$export$e2f8ce13516c6854 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { titleOverride: titleOverride, isSelectedAgentFetching: isSelectedAgentFetching, selectedAgent: selectedAgent, isAgentDropdownOpen: isAgentDropdownOpen, setIsAgentDropdownOpen: setIsAgentDropdownOpen, onBrowseAgentClick: onBrowseAgentClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { createConversationOptimistically: createConversationOptimistically } = (0, $3TxKn.useChatStoreActions)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            touchpointSource: "chat-header-agent-popup-menu"
        };
        $[0] = t1;
    } else t1 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t1);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { preferences: t2 } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = t2;
    const { aaid: userId } = (0, $isp1U.useProfileController)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    const profileCardRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[1] !== siteId) {
        t3 = new (0, $5hJlu.default)({
            url: "/gateway/api/directory/graphql",
            productIdentifier: "rovo",
            cloudId: siteId
        });
        $[1] = siteId;
        $[2] = t3;
    } else t3 = $[2];
    const profileClient = t3;
    let t4;
    if ($[3] !== isAgentDropdownOpen || $[4] !== setIsAgentDropdownOpen) {
        t4 = ()=>{
            if (!isAgentDropdownOpen) profileCardRef.current?.hideProfilecard();
            setIsAgentDropdownOpen(!isAgentDropdownOpen);
        };
        $[3] = isAgentDropdownOpen;
        $[4] = setIsAgentDropdownOpen;
        $[5] = t4;
    } else t4 = $[5];
    const handleAgentTitlePress = t4;
    let t5;
    if ($[6] !== sendAnalyticsEvent || $[7] !== sendMessage || $[8] !== storeUserMessages) {
        t5 = (agent, starter)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "agentSelectorProfileCardStarter",
                attributes: {
                    agentId: agent.id
                }
            });
            sendMessage({
                prompt: (0, $6rwn6.encodeAdf)(starter.message),
                agent: agent,
                storeUserMessages: storeUserMessages,
                messageSources: {
                    interactionSource: "profileCardConversationStarters",
                    followUpSource: "none"
                }
            });
            profileCardRef.current?.hideProfilecard();
        };
        $[6] = sendAnalyticsEvent;
        $[7] = sendMessage;
        $[8] = storeUserMessages;
        $[9] = t5;
    } else t5 = $[9];
    const handleConversationStarterClick = t5;
    if (titleOverride) {
        let t6;
        if ($[10] !== titleOverride) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                as: "h2",
                size: "xsmall"
            }, titleOverride);
            $[10] = titleOverride;
            $[11] = t6;
        } else t6 = $[11];
        return t6;
    }
    if (isSelectedAgentFetching) {
        let t6;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "rovo-chat-agent-header"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                height: 34,
                width: 150,
                isShimmering: true,
                borderRadius: "var(--ds-radius-medium, 6px)"
            }));
            $[12] = t6;
        } else t6 = $[12];
        return t6;
    }
    let t6;
    if ($[13] !== selectedAgent) {
        t6 = !selectedAgent || selectedAgent.is_default || (0, $2yWJZ.isDefaultRovoChat)({
            agentId: selectedAgent.id,
            agentNamedId: selectedAgent.named_id
        });
        $[13] = selectedAgent;
        $[14] = t6;
    } else t6 = $[14];
    const isDefaultAgent = t6;
    let t7;
    if ($[15] !== formatMessage || $[16] !== handleAgentTitlePress || $[17] !== handleConversationStarterClick || $[18] !== isAgentDropdownOpen || $[19] !== isDefaultAgent || $[20] !== profileClient || $[21] !== selectedAgent || $[22] !== siteId || $[23] !== userId) {
        t7 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44dd79506b6f65c7$var$AgentTitle, {
                agent: isDefaultAgent ? undefined : selectedAgent,
                defaultAgentName: isDefaultAgent ? formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).defaultAgentName) : undefined,
                isDropdownOpen: isAgentDropdownOpen,
                onPress: handleAgentTitlePress,
                triggerProps: triggerProps,
                formatMessage: formatMessage,
                cloudId: siteId,
                agentProfileCardProps: !isDefaultAgent && selectedAgent?.identity_account_id ? {
                    profileCardRef: profileCardRef,
                    agentId: selectedAgent.id,
                    identityAccountId: selectedAgent.identity_account_id,
                    resourceClient: profileClient,
                    onConversationStartersClick: (starter_0)=>handleConversationStarterClick(selectedAgent, starter_0),
                    cloudId: siteId,
                    viewingUserId: userId
                } : undefined
            });
        $[15] = formatMessage;
        $[16] = handleAgentTitlePress;
        $[17] = handleConversationStarterClick;
        $[18] = isAgentDropdownOpen;
        $[19] = isDefaultAgent;
        $[20] = profileClient;
        $[21] = selectedAgent;
        $[22] = siteId;
        $[23] = userId;
        $[24] = t7;
    } else t7 = $[24];
    const renderAgentTitle = t7;
    const t8 = isDefaultAgent ? undefined : selectedAgent;
    let t9;
    if ($[25] !== setIsAgentDropdownOpen) {
        t9 = ()=>setIsAgentDropdownOpen(false);
        $[25] = setIsAgentDropdownOpen;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== elements?.browseAgentsButton) {
        t10 = elements?.browseAgentsButton !== false && !(0, $iDrrr.fg)("rovo_chat_hide_browse_agents_and_search");
        $[27] = elements?.browseAgentsButton;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== elements?.createAgentButton) {
        t11 = elements?.createAgentButton !== false && !(0, $iDrrr.fg)("rovo_chat_hide_browse_agents_and_search");
        $[29] = elements?.createAgentButton;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== elements?.agentsMenu) {
        t12 = elements?.agentsMenu !== false && !(0, $iDrrr.fg)("rovo_chat_hide_browse_agents_and_search");
        $[31] = elements?.agentsMenu;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] !== assistanceServiceParams || $[34] !== createConversationOptimistically || $[35] !== isAgentDropdownOpen || $[36] !== onBrowseAgentClick || $[37] !== renderAgentTitle || $[38] !== setIsAgentDropdownOpen || $[39] !== siteId || $[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t8 || $[44] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iscQS.AgentMenu), {
            selectedAgent: t8,
            isAgentDropdownOpen: isAgentDropdownOpen,
            setIsAgentDropdownOpen: setIsAgentDropdownOpen,
            trigger: renderAgentTitle,
            placement: "bottom-start",
            onClose: t9,
            siteId: siteId,
            createConversationOptimistically: createConversationOptimistically,
            assistanceServiceParams: assistanceServiceParams,
            touchpointSource: "chat-header-agent-popup-menu",
            onBrowseAgentClick: onBrowseAgentClick,
            showBrowseAgents: t10,
            showCreateAgent: t11,
            showSearchAgents: t12
        });
        $[33] = assistanceServiceParams;
        $[34] = createConversationOptimistically;
        $[35] = isAgentDropdownOpen;
        $[36] = onBrowseAgentClick;
        $[37] = renderAgentTitle;
        $[38] = setIsAgentDropdownOpen;
        $[39] = siteId;
        $[40] = t10;
        $[41] = t11;
        $[42] = t12;
        $[43] = t8;
        $[44] = t9;
        $[45] = t13;
    } else t13 = $[45];
    return t13;
} : ({ titleOverride: titleOverride, isSelectedAgentFetching: isSelectedAgentFetching, selectedAgent: selectedAgent, isAgentDropdownOpen: isAgentDropdownOpen, setIsAgentDropdownOpen: setIsAgentDropdownOpen, onBrowseAgentClick: onBrowseAgentClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { createConversationOptimistically: createConversationOptimistically } = (0, $3TxKn.useChatStoreActions)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        // This is only used in AgentMenu component,
        // so touchpointSource is set to identify the agent popup menu location
        touchpointSource: 'chat-header-agent-popup-menu'
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const { aaid: userId } = (0, $isp1U.useProfileController)();
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    const profileCardRef = (0, $cozmU.useRef)(null);
    const profileClient = (0, $cozmU.useMemo)(()=>new (0, $5hJlu.default)({
            url: '/gateway/api/directory/graphql',
            productIdentifier: 'rovo',
            cloudId: siteId
        }), [
        siteId
    ]);
    const handleAgentTitlePress = (0, $cozmU.useCallback)(()=>{
        if (!isAgentDropdownOpen) profileCardRef.current?.hideProfilecard(); // prevent the agent profile card from covering the dropdown
        setIsAgentDropdownOpen(!isAgentDropdownOpen);
    }, [
        isAgentDropdownOpen,
        setIsAgentDropdownOpen
    ]);
    const handleConversationStarterClick = (0, $cozmU.useCallback)((agent, starter)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'agentSelectorProfileCardStarter',
            attributes: {
                agentId: agent.id
            }
        });
        sendMessage({
            prompt: (0, $6rwn6.encodeAdf)(starter.message),
            agent: agent,
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages,
            messageSources: {
                interactionSource: 'profileCardConversationStarters',
                followUpSource: 'none'
            }
        });
        profileCardRef.current?.hideProfilecard();
    }, [
        sendAnalyticsEvent,
        sendMessage,
        storeUserMessages
    ]);
    if (titleOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, titleOverride);
    if (isSelectedAgentFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "rovo-chat-agent-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 34,
        width: 150,
        isShimmering: true,
        borderRadius: "var(--ds-radius-medium, 6px)"
    }));
    const isDefaultAgent = !selectedAgent || selectedAgent.is_default || (0, $2yWJZ.isDefaultRovoChat)({
        agentId: selectedAgent.id,
        agentNamedId: selectedAgent.named_id
    });
    const renderAgentTitle = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44dd79506b6f65c7$var$AgentTitle, {
            agent: isDefaultAgent ? undefined : selectedAgent,
            defaultAgentName: isDefaultAgent ? formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).defaultAgentName) : undefined,
            isDropdownOpen: isAgentDropdownOpen,
            onPress: handleAgentTitlePress,
            triggerProps: triggerProps,
            formatMessage: formatMessage,
            cloudId: siteId,
            agentProfileCardProps: !isDefaultAgent && selectedAgent?.identity_account_id ? {
                profileCardRef: profileCardRef,
                agentId: selectedAgent.id,
                identityAccountId: selectedAgent.identity_account_id,
                resourceClient: profileClient,
                onConversationStartersClick: (starter_0)=>handleConversationStarterClick(selectedAgent, starter_0),
                cloudId: siteId,
                viewingUserId: userId
            } : undefined
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iscQS.AgentMenu), {
        selectedAgent: isDefaultAgent ? undefined : selectedAgent,
        isAgentDropdownOpen: isAgentDropdownOpen,
        setIsAgentDropdownOpen: setIsAgentDropdownOpen,
        trigger: renderAgentTitle,
        placement: "bottom-start",
        onClose: ()=>setIsAgentDropdownOpen(false),
        siteId: siteId,
        createConversationOptimistically: createConversationOptimistically,
        assistanceServiceParams: assistanceServiceParams,
        touchpointSource: "chat-header-agent-popup-menu",
        onBrowseAgentClick: onBrowseAgentClick,
        showBrowseAgents: elements?.browseAgentsButton !== false && !(0, $iDrrr.fg)('rovo_chat_hide_browse_agents_and_search'),
        showCreateAgent: elements?.createAgentButton !== false && !(0, $iDrrr.fg)('rovo_chat_hide_browse_agents_and_search'),
        showSearchAgents: elements?.agentsMenu !== false && !(0, $iDrrr.fg)('rovo_chat_hide_browse_agents_and_search')
    });
};



const $0e37dd0446a514a8$var$ROVO_CLI_URL = 'https://support.atlassian.com/rovo/docs/install-and-run-rovo-dev-cli-on-your-device/';
const $0e37dd0446a514a8$var$ChatMainHeaderInner = ({ mode: mode, switchToMode: switchToMode, onMenuButtonClick: onMenuButtonClick, menuButtonRef: menuButtonRef, screenType: screenType, previousView: previousView, backButtonLabel: backButtonLabel, sitePickerRender: sitePickerRender, onSettingsClick: onSettingsClick, onResetEmptyStateTab: onResetEmptyStateTab, onBrowseAgentClick: onBrowseAgentClick, onShareClick: onShareClick, isShareDisabled: isShareDisabled, currentConversationId: currentConversationId, conversationData: conversationData, isFullScreenModalAvailable: isFullScreenModalAvailable, activeMenu: activeMenu, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, isAgentDropdownOpen: isAgentDropdownOpen, selectedSpace: selectedSpace, conversationHeader: conversationHeader })=>{
    (0, $6cFsl.di)((0, $dSCNl.useUIConfig), (0, $3TxKn.useChatStoreActions), (0, $5f9e937904d8d9c3$export$cbb5096309445c3b), (0, $eKjv9.useGlobalConfig), (0, $bGNkz.useUIStore), (0, $bGNkz.useUIStoreActions), (0, $dQbwX.useChatConversation), (0, $Ou0Zz.useAnalytics), (0, $isp1U.useProfileController), (0, $lTU4O.useUserPreferences), (0, $5BOJB.useActiveAction), (0, $2BEJj.useExitSpace), (0, $4f4ec7923c508b72$export$558d819e93cfc429), (0, $bGNkz.useSelectedPinnedItemSelector));
    const backBehaviorOverride = (0, $361b218e381d7d4d$export$13aeeb8b8abbc191)();
    const effectivePreviousView = backBehaviorOverride?.previousView ?? previousView;
    const effectiveBackButtonLabel = backBehaviorOverride?.backButtonLabel ?? backButtonLabel;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSwitchModeDropdownOpen, setIsSwitchModeDropdownOpen] = (0, $cozmU.useState)(false);
    const { isFetching: isSelectedAgentFetching, agentIdForNewChat: agentIdForNewChat, agentVersionForNewChat: agentVersionForNewChat } = conversationData;
    const { closeChat: closeChat, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { elements: elements, fullScreen: fullScreen, isContextPanelEnabled: isContextPanelEnabled } = (0, $dSCNl.useUIConfig)();
    const [{ customGreeting: runtimeCustomGreeting }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const { setEmptyChatLaunch: setEmptyChatLaunch, setActiveMenu: setActiveMenu, setIsAgentSelectorMenuOpen: setIsAgentDropdownOpen, setSelectedSpace: setSelectedSpace, clearSelectedPinnedItem: clearSelectedPinnedItem } = (0, $bGNkz.useUIStoreActions)();
    const exitSpace = (0, $2BEJj.useExitSpace)();
    const [{ selectedPinnedItem: selectedPinnedItem }] = (0, $bGNkz.useSelectedPinnedItemSelector)();
    const { resetToPreviousTab: resetToPreviousTab } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    const isEmptyChatLaunchActive = Boolean(runtimeCustomGreeting);
    const screenState = (0, $25e6e1d7dbe71e10$export$a87e70211dfb97f5)(screenType, activeMenu);
    const { atlasURL: atlasURL } = (0, $ef5a1d3f9c0316fa$export$8a1abb7c176bd202)();
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: currentConversationId
    });
    const [isDeepResearchInProgress] = (0, $bdf9a49f6f07cdda$export$494eeb2e4648bc96)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { createConversationOptimistically: createConversationOptimistically, sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { setConversationError: setConversationError } = (0, $k4g8h.useChatSignalsActions)();
    const [{ status: chatStatus }] = (0, $k4g8h.useChatSignals)();
    const [{ isOpen: isFeedbackModalOpen }, { open: openFeedbackModal }] = (0, $418a0a565f43a3ce$export$4be696be8a3bff13)();
    const { activeAction: activeAction, clearActiveAction: clearActiveAction } = (0, $5BOJB.useActiveAction)();
    const { isDebugEnabled: shouldShowDebugButton, openDebugModal: openDebugModal } = (0, $5f9e937904d8d9c3$export$cbb5096309445c3b)();
    const touchpointSource = 'rovo-header';
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: touchpointSource
    });
    const { resetStagingArea: resetStagingArea } = (0, $8akfd.useStagingAreaActions)();
    const { selectedAgent: selectedAgent, currentConversation: currentConversation, editConversation: { handleEditConversationConfirm: handleEditConversationConfirm, openEditModal: openEditModal, conversationToBeEdited: conversationToBeEdited }, deleteConversation: { conversationToBeDeleted: conversationToBeDeleted, openDeleteModal: openDeleteModal, handleDeleteConfirm: handleDeleteConfirm } } = (0, $c2e50244e69d336a$export$ff0cc4f0d3c9ae80)({
        assistanceServiceParams: assistanceServiceParams,
        onConversationStarterClick: (params)=>{
            sendMessage(params);
        }
    });
    const selectedAgentIsDefault = selectedAgent?.named_id === (0, $6iQ4q.DEFAULT_AGENT).named_id;
    const isDefaultAgent = selectedAgent === undefined || selectedAgentIsDefault;
    const isNewConversation = (0, $1IZrU.isEmptyConversation)(currentConversation?.id);
    // if we are on a menu other than 'none' use this map to override the title
    const MENU_TO_TITLE_OVERRIDE_MAP = (0, $cozmU.useMemo)(()=>({
            none: null,
            'conversation-list': (0, $iDrrr.fg)('rovo_chat_chat_history_refresh') ? formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).allChatsMenuTitle) : formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).chatHistoryMenuTitle),
            agents: formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).browseAgentsMenuTitle),
            pulse: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                as: "span",
                alignBlock: "center",
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da5182b95ddf40e8$export$ff4d08873f7aa3d2), null), formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).pulseMenuTitle)),
            tasks: null,
            scheduled: null,
            'search-work': formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).searchWorkMenuTitle),
            'recommended-spaces': activeMenu === 'recommended-spaces' && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).recommendedSpacesMenuTitle) : null,
            'browse-spaces': null,
            'space-landing': null
        }), [
        activeMenu,
        formatMessage
    ]);
    let stagingAreaTitle;
    if (elements?.stagingAreaEnabled === true) {
        if (isDefaultAgent) stagingAreaTitle = formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).defaultAgentName);
        else stagingAreaTitle = selectedAgent?.name ?? formatMessage((0, $c7b4e8294b0fef3a$export$2e2bcd8739ae039).defaultAgentName);
    }
    const headerTitleOverride = MENU_TO_TITLE_OVERRIDE_MAP[activeMenu] || stagingAreaTitle;
    const handleCloseChat = (0, $cozmU.useCallback)(()=>{
        // For space-scoped conversations, store EMPTY_CONVERSATION_ID instead of the
        // client-generated UUID. The client UUID is never returned by the backend /conversations
        // API, so restoring it on refresh creates an orphaned optimistic entry — causing a ghost
        // item to appear in the regular conversation list. See setSelectedConversation for the
        // same guard applied to the normal selection path.
        const isSpaceScopedConversation = Boolean(currentConversation?.rovoSpaceId) && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
        const targetConversationId = (0, $1IZrU.isEmptyConversation)(currentConversationId) || isSpaceScopedConversation ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : currentConversationId;
        (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage?.setItem((0, $hsq9U.getChatLoadPreferenceKey)(siteId), targetConversationId);
        });
        closeChat();
        clearActiveAction();
    }, [
        closeChat,
        currentConversation?.rovoSpaceId,
        currentConversationId,
        clearActiveAction,
        siteId
    ]);
    const handleCloseChatClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'closeChatButton',
            attributes: {
                isDeepResearchInProgress: isDeepResearchInProgress,
                ...activeAction ? {
                    actionId: activeAction?.id,
                    actionType: activeAction?.handleType,
                    isNested: activeAction?.isChild ?? false
                } : {}
            }
        });
        handleCloseChat();
    }, [
        isDeepResearchInProgress,
        handleCloseChat,
        sendAnalyticsEvent,
        activeAction
    ]);
    const handleFullScreen = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'conversationAssistantUIMode',
            action: 'switched',
            attributes: {
                requestedMode: 'fullscreen'
            }
        });
        window.open((0, $dTEBe.addRovoParamsToUrl)(atlasURL('/chat'), {
            pathway: 'chat',
            conversationId: !(0, $1IZrU.isEmptyConversation)(currentConversation?.id) ? currentConversation?.id : undefined,
            agentId: !isDefaultAgent && selectedAgent ? selectedAgent?.id : undefined
        }), '_blank', 'noopener, noreferrer');
    }, [
        atlasURL,
        currentConversation,
        sendAnalyticsEvent,
        isDefaultAgent,
        selectedAgent
    ]);
    const resetStateAndCreateConversation = (0, $cozmU.useCallback)((agentId, rovoSpaceId)=>{
        setConversationError(undefined);
        clearActiveAction();
        createConversationOptimistically({
            sourceAgentId: agentId,
            ...agentVersionForNewChat ? {
                agentVersion: agentVersionForNewChat
            } : {},
            ...rovoSpaceId ? {
                rovoSpaceId: rovoSpaceId
            } : {}
        });
        const shouldOpenSpaceLandingPage = !!rovoSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
        const nextActiveMenu = shouldOpenSpaceLandingPage ? 'space-landing' : 'none';
        if (shouldOpenSpaceLandingPage) setSelectedSpace({
            id: rovoSpaceId,
            name: selectedSpace?.name ?? '',
            emoji: selectedSpace?.emoji,
            sources: selectedSpace?.sources,
            entryPoint: selectedSpace?.entryPoint
        });
        if (activeMenu !== nextActiveMenu) setActiveMenu(nextActiveMenu);
        resetStagingArea();
    }, [
        createConversationOptimistically,
        clearActiveAction,
        activeMenu,
        selectedSpace,
        setActiveMenu,
        setSelectedSpace,
        setConversationError,
        resetStagingArea,
        agentVersionForNewChat
    ]);
    const handleNewChatClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'newChatButton',
            attributes: {
                ...screenState,
                mode: !!fullScreen ? 'fullscreen' : mode
            }
        }); // When a space is active (either explicitly selected or from the current conversation),
        // start a new chat scoped to that same space.
        const activeSpaceId = selectedSpace?.id ?? currentConversation?.rovoSpaceId;
        if (activeSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) {
            resetStateAndCreateConversation(undefined, activeSpaceId);
            return;
        }
        resetStateAndCreateConversation((0, $iDrrr.fg)('convo-ai-enable-agents-use-permission') ? agentIdForNewChat : selectedAgent?.id);
    }, [
        agentIdForNewChat,
        selectedAgent?.id,
        selectedSpace,
        currentConversation,
        screenState,
        sendAnalyticsEvent,
        mode,
        fullScreen,
        resetStateAndCreateConversation
    ]);
    const handleDebugButtonClick = (0, $cozmU.useCallback)(()=>{
        if (shouldShowDebugButton) openDebugModal();
    }, [
        shouldShowDebugButton,
        openDebugModal
    ]);
    const handleModeChange = (0, $cozmU.useCallback)(({ requested: requested })=>{
        if (!switchToMode) return;
        switchToMode(requested);
        sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'conversationAssistantUIMode',
            action: 'switched',
            attributes: {
                requestedMode: requested
            }
        });
    }, [
        switchToMode,
        sendAnalyticsEvent
    ]);
    const handleFeedback = (0, $cozmU.useCallback)(()=>{
        if (isFeedbackModalOpen) return;
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewSubmitFeedbackButton'
        });
        openFeedbackModal({
            answerQuality: 'general',
            assistantResponseId: (0, $3Cuhs.getLastAgentMessageID)(chatMessages)
        });
    }, [
        isFeedbackModalOpen,
        openFeedbackModal,
        sendAnalyticsEvent,
        chatMessages
    ]);
    const handleMoreMenuOpen = (0, $cozmU.useCallback)(()=>{
        // Fire exposure event when more menu button is clicked
        (0, $cXtTj.default).manuallyLogExperimentExposure('memory_management_ux');
    }, []);
    const handleFullScreenShareClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'shareChatButton'
        });
        onShareClick?.();
    }, [
        onShareClick,
        sendAnalyticsEvent
    ]);
    const handleBackClick = (0, $cozmU.useCallback)(()=>{
        // Compute entity-context first so both branches below can share the same value.
        const isInSpaceContext = Boolean(selectedSpace ?? currentConversation?.rovoSpaceId) && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false); // A pinned Jira Epic/Atlas Goal/Atlas Project launch (see chat-history/handleChatEmptyLaunch)
        // — mutually exclusive with isInSpaceContext.
        const isInPinnedEntityContext = Boolean(selectedPinnedItem);
        const isInEntityContext = isInSpaceContext || isInPinnedEntityContext;
        if (isEmptyChatLaunchActive) {
            // Clear the empty chat launch state so tabs become visible again
            setEmptyChatLaunch({
                customGreeting: undefined,
                customConversationActions: undefined,
                projectContext: undefined
            });
            onResetEmptyStateTab?.(); // Fall through to the entity-exit branch below so combined
            // (customGreeting + selectedSpace/selectedPinnedItem) state is fully cleared in a
            // single back-click. Defends against any future launcher that reintroduces the
            // combined state (producer parity is enforced in
            // `chat-history/handleChatEmptyLaunch`).
            if (!isInEntityContext) return;
        } // When viewing an entity-scoped chat (a Rovo Space, via selectedSpace in ui-store or via
        // rovoSpaceId on the current conversation, or a pinned Epic/Goal/Project, via
        // selectedPinnedItem), the back arrow exits it and starts a new unscoped conversation.
        // exitSpace resets every store slice touched by either launch flow (aiFeatureContext.
        // projectContext + emptyChatLaunch clearing are entity-agnostic — its own
        // clearSelectedSpace() call is a no-op when there's no space to clear);
        // clearSelectedPinnedItem additionally clears the pinned-entity bar, which exitSpace
        // doesn't know about.
        if (isInEntityContext) {
            exitSpace();
            if (isInPinnedEntityContext) clearSelectedPinnedItem();
            resetStateAndCreateConversation(undefined); // Restore the pre-launch tab (Suggestions for nav / browse-spaces
            // launches, For You for For-You-launched space/pin chats).
            resetToPreviousTab();
            return;
        }
        if (effectivePreviousView) effectivePreviousView();
        else {
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiMateActionViewBackButton',
                attributes: {
                    actionId: activeAction?.id,
                    actionType: activeAction?.handleType,
                    isNested: activeAction?.isChild ?? false
                }
            });
            resetStateAndCreateConversation(undefined);
        }
        onResetEmptyStateTab?.();
    }, [
        isEmptyChatLaunchActive,
        setEmptyChatLaunch,
        selectedSpace,
        selectedPinnedItem,
        currentConversation,
        exitSpace,
        clearSelectedPinnedItem,
        resetToPreviousTab,
        effectivePreviousView,
        resetStateAndCreateConversation,
        activeAction,
        sendAnalyticsEvent,
        onResetEmptyStateTab
    ]);
    const onHandleDesktopAppClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewDesktopAppButton'
        });
        window.open('https://support.atlassian.com/rovo/docs/get-started-with-rovo-desktop/', '_blank', 'noopener, noreferrer');
    }, [
        sendAnalyticsEvent
    ]);
    const onHandleChromeExtensionClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewChromeExtensionButton'
        });
        window.open('https://chromewebstore.google.com/detail/rovo-search-chat-and-more/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=chat-menu&utm_medium=permanent-settings&utm_campaign=rovo_extension_chatmenu_cta', '_blank', 'noopener, noreferrer');
    }, [
        sendAnalyticsEvent
    ]);
    const onHandleSlackAppClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewSlackAppButton'
        });
        window.open('https://atlassian.slack.com/marketplace/A08B0EYMUPR-atlassian-rovo', '_blank', 'noopener, noreferrer');
    }, [
        sendAnalyticsEvent
    ]);
    const onHandleTeamsAppClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewTeamsAppButton'
        });
        window.open('https://support.atlassian.com/rovo/docs/using-rovo-for-microsoft-teams/', '_blank', 'noopener, noreferrer');
    }, [
        sendAnalyticsEvent
    ]);
    const onHandleCliClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatViewCliButton'
        });
        window.open($0e37dd0446a514a8$var$ROVO_CLI_URL, '_blank', 'noopener, noreferrer');
    }, [
        sendAnalyticsEvent
    ]);
    const moreMenuSubMenuItems = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('ai_mate_show_rovo_mobile_qr_menu_button') ? [
            {
                key: 'mobile-app',
                label: formatMessage((0, $eQC44.chatHeaderMessages).mobileAppSubMenuLabel),
                title: formatMessage((0, $eQC44.chatHeaderMessages).mobileAppSubMenuTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7TSZS))), {
                    label: formatMessage((0, $eQC44.chatHeaderMessages).mobileAppSubMenuLabel),
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $337e46603946e0d3$export$a28cff4286b9b3c3), null),
                testId: 'rovo-chat-header-mobile-app-button',
                onOpen: ()=>sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'chatViewHeaderSubmenuButton',
                        attributes: {
                            menuKey: 'mobile-app'
                        }
                    })
            }
        ] : [], [
        formatMessage,
        sendAnalyticsEvent
    ]);
    const shouldShowModeChangeButton = typeof switchToMode === 'function';
    const shouldShowMenuButton = typeof onMenuButtonClick === 'function' && elements?.navbar;
    const shouldShowFullScreenButton = !!elements?.fullscreenButton;
    const shouldShowNewChatButton = !!elements?.newChatButton && !isChatOnboardingMiniModalOpen;
    const shouldShowCloseButton = !!elements?.closeButton;
    const isInStagingArea = !!elements?.stagingAreaEnabled; // activeMenu === 'pulse' is set by rovo-growth-pulse (gated upstream).
    // backBehaviorOverride?.source === 'pulse' is set via setBackBehaviorOverride in main.tsx,
    // called only from within the Pulse insights navigation flow (also gated upstream).
    const isInsightsView = activeMenu === 'pulse' || backBehaviorOverride?.source === 'pulse';
    const isFullPageInsightsView = fullScreen && isInsightsView;
    const isSpaceSelected = Boolean(selectedSpace ?? currentConversation?.rovoSpaceId) && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const isPinnedEntitySelected = Boolean(selectedPinnedItem);
    const shouldShowBackButton = !isInStagingArea && !(fullScreen && activeMenu === 'pulse') && (!!effectivePreviousView || isEmptyChatLaunchActive || isSpaceSelected || isPinnedEntitySelected || chatStatus !== 'launching' && !(0, $cea34cae6ceea4d1$export$33b4cc4e9f7f2fb6)(screenState) || !isDefaultAgent);
    const previousActiveMenuRef = (0, $cozmU.useRef)('none');
    const shouldAutoFocusBackButton = shouldShowBackButton && activeMenu === 'conversation-list' && previousActiveMenuRef.current !== 'conversation-list';
    (0, $cozmU.useEffect)(()=>{
        previousActiveMenuRef.current = activeMenu;
    }, [
        activeMenu
    ]); // For sidebar insights detail view, reuse the pulse title from the map.
    // For sidebar insights feed, headerTitleOverride already picks it up via activeMenu === 'pulse'.
    // For full page insights (feed + detail), hide the title entirely.
    const insightsDetailViewTitleOverride = conversationHeader?.source === 'pulse' ? MENU_TO_TITLE_OVERRIDE_MAP.pulse : undefined;
    const shouldShowRenameConversation = !isInsightsView && currentConversation && !(0, $1IZrU.isEmptyConversation)(currentConversation.id);
    const shouldShowDeleteConversation = !isInsightsView && currentConversation && !(0, $1IZrU.isEmptyConversation)(currentConversation.id) && !isInStagingArea;
    const shouldShowSwitchModeButton = !fullScreen && !isChatOnboardingMiniModalOpen;
    const isFullScreenHeader = !!fullScreen || mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL;
    const shouldShowFullScreenShareButton = isFullScreenHeader && typeof onShareClick === 'function' && (0, $cXtTj.default).getExperimentValue('rovo_conversation_sharing', 'isEnabled', false);
    const fullScreenShareButtonLabel = (0, $eQC44.getShareButtonLabel)(isShareDisabled, formatMessage); // The split-layout button expands the panel to its 50% cap, which reveals the
    // chat's split-view right pane. Only relevant when the split-layout experience
    // is enabled and the chat is not already full screen.
    const shouldShowSplitLayoutButton = !fullScreen && mode !== (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && !isChatOnboardingMiniModalOpen && isContextPanelEnabled && (0, $iDrrr.fg)('agent_session_experience_fg');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb8eca56e1c1148d$export$1263ff8fe28ec69f), {
        agentTitleComponent: isFullPageInsightsView ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44dd79506b6f65c7$export$e2f8ce13516c6854), {
            titleOverride: insightsDetailViewTitleOverride ?? headerTitleOverride,
            isSelectedAgentFetching: isSelectedAgentFetching,
            selectedAgent: selectedAgent,
            isAgentDropdownOpen: isAgentDropdownOpen,
            setIsAgentDropdownOpen: setIsAgentDropdownOpen,
            onBrowseAgentClick: onBrowseAgentClick
        }),
        splitLayoutToggleComponent: shouldShowSplitLayoutButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3f67b4420feee1b1$export$450e8e271e4a0001), null),
        switchModeComponent: shouldShowSwitchModeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c7f75bd8d7e75d3f$export$6066428d3ab3a284), {
            mode: mode,
            isSwitchModeDropdownOpen: isSwitchModeDropdownOpen,
            setIsSwitchModeDropdownOpen: setIsSwitchModeDropdownOpen,
            onModeChange: shouldShowModeChangeButton ? handleModeChange : undefined,
            onFullscreenClick: shouldShowFullScreenButton ? handleFullScreen : undefined,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        }),
        moreMenuComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldShowFullScreenShareButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))),
            isDisabled: Boolean(isShareDisabled),
            isTooltipDisabled: false,
            label: fullScreenShareButtonLabel,
            onClick: handleFullScreenShareClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6295ee3a8d83389$export$523b08430e600b5), {
            onFeedbackClick: handleFeedback,
            onDebugClick: shouldShowDebugButton ? handleDebugButtonClick : undefined,
            onConversationDelete: shouldShowDeleteConversation ? ()=>openDeleteModal(currentConversation) : undefined,
            onConversationRename: shouldShowRenameConversation ? ()=>openEditModal(currentConversation) : undefined,
            subMenuItems: moreMenuSubMenuItems,
            onDesktopAppClick: (0, $iDrrr.fg)('ai_mate_show_rovo_desktop_app_menu_button') ? onHandleDesktopAppClick : undefined,
            onSlackAppClick: (0, $iDrrr.fg)('ai_mate_show_rovo_slack_teams_menu_buttons') ? onHandleSlackAppClick : undefined,
            onTeamsAppClick: (0, $iDrrr.fg)('ai_mate_show_rovo_slack_teams_menu_buttons') ? onHandleTeamsAppClick : undefined,
            onChromeExtensionClick: onHandleChromeExtensionClick,
            onCliClick: (0, $iDrrr.fg)('ai_mate_show_rovo_cli_menu_button') ? onHandleCliClick : undefined,
            onSettingsClick: onSettingsClick,
            onShareClick: isFullScreenHeader ? undefined : onShareClick,
            isShareDisabled: isShareDisabled,
            sitePickerRender: sitePickerRender,
            onMenuOpen: handleMoreMenuOpen,
            assistanceServiceParams: assistanceServiceParams
        })),
        selectedAgent: selectedAgent,
        onNewChatClick: shouldShowNewChatButton ? handleNewChatClick : undefined,
        onCloseClick: shouldShowCloseButton ? handleCloseChatClick : undefined,
        onMenuClick: shouldShowMenuButton ? onMenuButtonClick : undefined,
        menuButtonRef: menuButtonRef,
        onBackClick: shouldShowBackButton ? handleBackClick : undefined,
        autoFocusBackButton: shouldAutoFocusBackButton,
        ...effectiveBackButtonLabel && {
            backButtonLabel: effectiveBackButtonLabel
        },
        isNewChatButtonDisabled: isNewConversation
    }), conversationToBeDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
        onDeleteConfirm: ()=>handleDeleteConfirm(conversationToBeDeleted.id)
    }), conversationToBeEdited && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
        onEditConfirm: (newName)=>handleEditConversationConfirm(conversationToBeEdited, newName)
    }));
};
const $0e37dd0446a514a8$var$ChatMainHeaderComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    let t0;
    if ($[0] !== currentConversationId) {
        t0 = {
            conversationId: currentConversationId
        };
        $[0] = currentConversationId;
        $[1] = t0;
    } else t0 = $[1];
    const conversationData = (0, $dQbwX.useChatConversation)(t0);
    let t1;
    if ($[2] !== conversationData || $[3] !== currentConversationId || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderInner, {
            ...props,
            currentConversationId: currentConversationId,
            conversationData: conversationData
        });
        $[2] = conversationData;
        $[3] = currentConversationId;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : (props)=>{
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    const conversationData = (0, $dQbwX.useChatConversation)({
        conversationId: currentConversationId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderInner, {
        ...props,
        currentConversationId: currentConversationId,
        conversationData: conversationData
    });
}; // rovo_ttai_segment_render_stabilization: absorb parent render waves when chat header props are stable.
const $0e37dd0446a514a8$var$MemoizedChatMainHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($0e37dd0446a514a8$var$ChatMainHeaderComponent, (0, $dqxOF.shallowEqualObjects)); // rovo_ttai_segment_render_stabilization ON: subscribe to only the four UI-store fields
// the header reads via the narrow selector, so the header (and its memo boundary)
// re-renders only when one of those fields changes rather than on every UI-store state change.
const $0e37dd0446a514a8$var$ChatMainHeaderWithUISelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useChatHeaderUISelector), (0, $bGNkz.useConversationHeaderSelector));
    const [{ activeMenu: activeMenu, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, selectedSpace: selectedSpace }] = (0, $bGNkz.useChatHeaderUISelector)();
    const [{ conversationHeader: conversationHeader }] = (0, $bGNkz.useConversationHeaderSelector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$MemoizedChatMainHeader, {
        ...props,
        activeMenu: activeMenu,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        isAgentDropdownOpen: isAgentSelectorMenuOpen,
        selectedSpace: selectedSpace,
        conversationHeader: conversationHeader
    });
}; // rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI store,
// matching the prior behaviour where the header re-rendered on any UI-store state change.
const $0e37dd0446a514a8$var$ChatMainHeaderWithBroadUIStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { activeMenu: activeMenu, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, selectedSpace: selectedSpace, conversationHeader: conversationHeader } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderComponent, {
        ...props,
        activeMenu: activeMenu,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        isAgentDropdownOpen: isAgentSelectorMenuOpen,
        selectedSpace: selectedSpace,
        conversationHeader: conversationHeader
    });
};
const $0e37dd0446a514a8$export$2633258f29aae55e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderWithUISelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderWithBroadUIStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderWithUISelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e37dd0446a514a8$var$ChatMainHeaderWithBroadUIStore, props);
};










































var $gBjHb = parcelRequire("gBjHb");











var $57p4j = parcelRequire("57p4j");































// Registers all A2UI component renderers into the component registry.
// Call ensureComponentsRegistered() to guarantee registration has run.
// Static map: A2UI component type name → React component
const $176500affb65f278$var$registry = new Map();
const $176500affb65f278$export$d74092cddf07c0aa = (type, component)=>{
    $176500affb65f278$var$registry.set(type, component);
};
const $176500affb65f278$export$21a8719ce41a1de2 = (type)=>{
    return $176500affb65f278$var$registry.get(type);
};
const $176500affb65f278$export$825fce918ac105f = (components)=>{
    for (const [type, component] of Object.entries(components))$176500affb65f278$var$registry.set(type, component);
};

























const $baaab813a53ae29e$export$58d75f9829cbe158 = /*#__PURE__*/ (0, $cozmU.createContext)({
    basePath: ''
});
function $baaab813a53ae29e$export$8888116feeffccb7() {
    return (0, $cozmU.useContext)($baaab813a53ae29e$export$58d75f9829cbe158);
}





const $a79b866aed66492f$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $cozmU.createContext)(null);
function $a79b866aed66492f$export$a20f8e9fdc2641f2() {
    const context = (0, $cozmU.useContext)($a79b866aed66492f$export$1ca2a26fecb070ae);
    if (!context) throw new Error('useSurfaceContext must be used within A2UISurface');
    return context;
}


// A2UI v0.9 Common Types — DynamicValue, DataBinding, FunctionCall, Action, ChildList
const $5fc37a5c0ab89261$export$687a57249f85e9d6 = (value)=>typeof value === 'object' && value !== null && 'path' in value && typeof value.path === 'string' && !('call' in value);
const $5fc37a5c0ab89261$export$36b315c6e35a6f4e = (value)=>typeof value === 'object' && value !== null && 'call' in value && typeof value.call === 'string';
const $5fc37a5c0ab89261$export$5b2d2f9a9b935189 = (value)=>typeof value === 'object' && value !== null && 'componentId' in value && 'path' in value;


// RFC 6901 JSON Pointer — get / set / remove
function $3518e48f06d57e36$var$deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $3518e48f06d57e36$var$parseTokens(pointer) {
    if (pointer === '' || pointer === '/') return pointer === '/' ? [
        ''
    ] : [];
    if (!pointer.startsWith('/')) throw new Error(`Invalid JSON Pointer: "${pointer}" \u{2014} must start with "/"`);
    return pointer.slice(1).split('/').map((t)=>t.replace(/~1/g, '/').replace(/~0/g, '~'));
}
function $3518e48f06d57e36$export$884a23bfca63cd9e(obj, pointer) {
    const tokens = $3518e48f06d57e36$var$parseTokens(pointer);
    let current = obj;
    for (const token of tokens){
        if (current === null || current === undefined) return undefined;
        if (Array.isArray(current)) {
            const idx = token === '-' ? current.length : Number(token);
            current = current[idx];
        } else if (typeof current === 'object') current = current[token];
        else return undefined;
    }
    return current;
}
function $3518e48f06d57e36$export$cdccb0ccb22298cb(obj, pointer, value) {
    if (pointer === '') {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) return value;
        return obj;
    }
    const tokens = $3518e48f06d57e36$var$parseTokens(pointer);
    const result = $3518e48f06d57e36$var$deepClone(obj);
    let current = result;
    for(let i = 0; i < tokens.length - 1; i++){
        const token = tokens[i];
        if (Array.isArray(current)) {
            const idx = Number(token);
            if (current[idx] === undefined || current[idx] === null || typeof current[idx] !== 'object') current[idx] = {};
            current = current[idx];
        } else {
            const rec = current;
            if (rec[token] === undefined || rec[token] === null || typeof rec[token] !== 'object') rec[token] = {};
            current = rec[token];
        }
    }
    const lastToken = tokens[tokens.length - 1];
    if (Array.isArray(current)) {
        const idx = lastToken === '-' ? current.length : Number(lastToken);
        current[idx] = value;
    } else current[lastToken] = value;
    return result;
}
function $3518e48f06d57e36$export$ed753d721d7b171(obj, pointer) {
    if (pointer === '') return {};
    const tokens = $3518e48f06d57e36$var$parseTokens(pointer);
    const result = $3518e48f06d57e36$var$deepClone(obj);
    let current = result;
    for(let i = 0; i < tokens.length - 1; i++){
        const token = tokens[i];
        if (Array.isArray(current)) current = current[Number(token)];
        else current = current[token];
        if (current === undefined || current === null) return result;
    }
    const lastToken = tokens[tokens.length - 1];
    if (Array.isArray(current)) current.splice(Number(lastToken), 1);
    else delete current[lastToken];
    return result;
}
function $3518e48f06d57e36$export$1b610c29c9eeb0e1(basePath, path) {
    if (path.startsWith('/')) return path;
    const base = basePath.endsWith('/') ? basePath : basePath + '/';
    return base + path;
}


// Forward declaration — TreeBuilder will register itself to avoid circular imports
let $520d5d995c5e1183$var$ComponentRendererRef = null;
function $520d5d995c5e1183$export$cb0d9965b2bc5783(renderer) {
    $520d5d995c5e1183$var$ComponentRendererRef = renderer;
}
function $520d5d995c5e1183$var$encodeJsonPointerToken(token) {
    return token.replace(/~/g, '~0').replace(/\//g, '~1');
}
function $520d5d995c5e1183$export$223e18e38a98b3a5(children, visited) {
    const { state: state } = (0, $a79b866aed66492f$export$a20f8e9fdc2641f2)();
    const { basePath: basePath } = (0, $baaab813a53ae29e$export$8888116feeffccb7)();
    const { dataModel: dataModel } = state;
    const ComponentRenderer = $520d5d995c5e1183$var$ComponentRendererRef;
    if (!children || !ComponentRenderer) return null;
    // Static child list — array of component IDs
    if (Array.isArray(children) && !(0, $5fc37a5c0ab89261$export$5b2d2f9a9b935189)(children)) return children.map((childId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentRenderer, {
            key: childId,
            componentId: childId,
            visited: visited
        }));
    // Template child list — { componentId, path }
    if ((0, $5fc37a5c0ab89261$export$5b2d2f9a9b935189)(children)) {
        const resolvedPath = (0, $3518e48f06d57e36$export$1b610c29c9eeb0e1)(basePath, children.path);
        const items = dataModel.get(resolvedPath);
        if (Array.isArray(items)) return items.map((_item, index)=>{
            const itemBasePath = `${resolvedPath}/${index}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baaab813a53ae29e$export$58d75f9829cbe158).Provider, {
                key: index,
                value: {
                    basePath: itemBasePath
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentRenderer, {
                componentId: children.componentId,
                visited: visited
            }));
        });
        if (items && typeof items === 'object') {
            const entries = Object.entries(items);
            return entries.map(([itemKey])=>{
                const encodedKey = $520d5d995c5e1183$var$encodeJsonPointerToken(itemKey);
                const itemBasePath = `${resolvedPath}/${encodedKey}`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baaab813a53ae29e$export$58d75f9829cbe158).Provider, {
                    key: itemKey,
                    value: {
                        basePath: itemBasePath
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentRenderer, {
                    componentId: children.componentId,
                    visited: visited
                }));
            });
        }
        const actualType = items === null ? 'null' : typeof items;
        throw new Error(`Template children binding at "${resolvedPath}" must resolve to an array or object map, received ${actualType}`);
    }
    return null;
}
function $520d5d995c5e1183$export$516bf11d34989404(childId, visited) {
    const ComponentRenderer = $520d5d995c5e1183$var$ComponentRendererRef;
    if (!childId || !ComponentRenderer) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentRenderer, {
        componentId: childId,
        visited: visited
    });
}


const $cde9c41dde6edca0$export$9ef33d0cdeb528e5 = ({ definition: definition, visited: visited })=>{
    const def = definition;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const triggerContent = (0, $520d5d995c5e1183$export$516bf11d34989404)(def.trigger, visited);
    const modalContent = (0, $520d5d995c5e1183$export$516bf11d34989404)(def.content, visited);
    const label = def.accessibility?.label ?? 'Dialog';
    const handleOpen = (0, $cozmU.useCallback)(()=>setIsOpen(true), []);
    const handleClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onClick: handleOpen,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e)=>e.key === 'Enter' && handleOpen()
    }, triggerContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && // eslint-disable-next-line @atlaskit/design-system/no-modal-label
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: handleClose,
        label: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, modalContent))));
};






var $hMjUh = parcelRequire("hMjUh");

var $bxtKM = parcelRequire("bxtKM");

var $dkVNA = parcelRequire("dkVNA");

var $gRGWz = parcelRequire("gRGWz");







// Resolves DynamicValue → concrete value (literal | binding | function call)


// All 14 built-in A2UI functions
// -- Validation functions --
function $c7196003281a224c$var$required(args) {
    const { value: value } = args;
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    return true;
}
function $c7196003281a224c$var$regex(args) {
    const { value: value, pattern: pattern } = args;
    if (typeof value !== 'string' || typeof pattern !== 'string') return false;
    return new RegExp(pattern).test(value);
}
function $c7196003281a224c$var$length(args) {
    const { value: value, min: min, max: max } = args;
    const str = typeof value === 'string' ? value : String(value ?? '');
    const len = str.length;
    if (typeof min === 'number' && len < min) return false;
    if (typeof max === 'number' && len > max) return false;
    return true;
}
function $c7196003281a224c$var$numeric(args) {
    const { value: value, min: min, max: max } = args;
    const num = typeof value === 'number' ? value : Number(value);
    if (isNaN(num)) return false;
    if (typeof min === 'number' && num < min) return false;
    if (typeof max === 'number' && num > max) return false;
    return true;
}
function $c7196003281a224c$var$email(args) {
    const { value: value } = args;
    if (typeof value !== 'string') return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
// -- Formatting functions --
function $c7196003281a224c$var$formatString(args) {
    const { value: value } = args;
    if (typeof value !== 'string') return String(value ?? '');
    // Simple ${key} interpolation from remaining args
    return value.replace(/\$\{(\w+)\}/g, (_, key)=>{
        const replacement = args[key];
        return replacement != null ? String(replacement) : '';
    });
}
function $c7196003281a224c$var$formatNumber(args) {
    const { value: value, decimals: decimals, grouping: grouping } = args;
    const num = typeof value === 'number' ? value : Number(value);
    if (isNaN(num)) return String(value ?? '');
    const opts = {};
    if (typeof decimals === 'number') {
        opts.minimumFractionDigits = decimals;
        opts.maximumFractionDigits = decimals;
    }
    if (grouping === false) opts.useGrouping = false;
    return new Intl.NumberFormat(undefined, opts).format(num);
}
function $c7196003281a224c$var$formatCurrency(args) {
    const { value: value, currency: currency, decimals: decimals, grouping: grouping } = args;
    const num = typeof value === 'number' ? value : Number(value);
    if (isNaN(num) || typeof currency !== 'string') return String(value ?? '');
    const opts = {
        style: 'currency',
        currency: currency
    };
    if (typeof decimals === 'number') {
        opts.minimumFractionDigits = decimals;
        opts.maximumFractionDigits = decimals;
    }
    if (grouping === false) opts.useGrouping = false;
    return new Intl.NumberFormat(undefined, opts).format(num);
}
function $c7196003281a224c$var$formatDate(args) {
    const { value: value, format: format } = args;
    if (typeof value !== 'string') return String(value ?? '');
    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    // Map common Unicode TR35 patterns to Intl.DateTimeFormat options
    if (typeof format === 'string') {
        const opts = {};
        if (format.includes('yyyy') || format.includes('YYYY')) opts.year = 'numeric';
        if (format.includes('MM')) opts.month = '2-digit';
        else if (format.includes('MMM')) opts.month = 'short';
        else if (format.includes('MMMM')) opts.month = 'long';
        if (format.includes('dd') || format.includes('DD')) opts.day = '2-digit';
        if (format.includes('HH') || format.includes('hh')) opts.hour = '2-digit';
        if (format.includes('mm')) opts.minute = '2-digit';
        if (format.includes('ss')) opts.second = '2-digit';
        if (Object.keys(opts).length > 0) return new Intl.DateTimeFormat(undefined, opts).format(date);
    }
    return date.toLocaleDateString();
}
function $c7196003281a224c$var$pluralize(args) {
    const { value: value } = args;
    const num = typeof value === 'number' ? value : Number(value);
    const rules = new Intl.PluralRules();
    const category = rules.select(num);
    const result = args[category] ?? args['other'];
    return typeof result === 'string' ? result.replace('{value}', String(num)) : String(result ?? num);
}
// -- Logic functions --
function $c7196003281a224c$var$and(args) {
    const { values: values } = args;
    if (!Array.isArray(values)) return Boolean(values);
    return values.every(Boolean);
}
function $c7196003281a224c$var$or(args) {
    const { values: values } = args;
    if (!Array.isArray(values)) return Boolean(values);
    return values.some(Boolean);
}
function $c7196003281a224c$var$not(args) {
    return !args.value;
}
// -- Action functions --
function $c7196003281a224c$var$openUrl(args) {
    const { url: url } = args;
    if (typeof url === 'string') window.open(url, '_blank', 'noopener,noreferrer');
}
// -- Registry --
const $c7196003281a224c$var$builtinFunctions = {
    required: $c7196003281a224c$var$required,
    regex: $c7196003281a224c$var$regex,
    length: $c7196003281a224c$var$length,
    numeric: $c7196003281a224c$var$numeric,
    email: $c7196003281a224c$var$email,
    formatString: $c7196003281a224c$var$formatString,
    formatNumber: $c7196003281a224c$var$formatNumber,
    formatCurrency: $c7196003281a224c$var$formatCurrency,
    formatDate: $c7196003281a224c$var$formatDate,
    pluralize: $c7196003281a224c$var$pluralize,
    and: $c7196003281a224c$var$and,
    or: $c7196003281a224c$var$or,
    not: $c7196003281a224c$var$not,
    openUrl: $c7196003281a224c$var$openUrl
};
function $c7196003281a224c$export$a9bd0e0d7f7536b8(name, args, customFunctions) {
    // Check custom functions first (allows overriding builtins)
    if (customFunctions?.[name]) return customFunctions[name](args);
    const fn = $c7196003281a224c$var$builtinFunctions[name];
    if (!fn) return undefined;
    return fn(args);
}


function $c4040e957c622274$export$615d0d7e9f9cf4b6(basePath, bindingPath) {
    const primaryPath = (0, $3518e48f06d57e36$export$1b610c29c9eeb0e1)(basePath, bindingPath);
    if (!basePath || !bindingPath.startsWith('/')) return [
        primaryPath
    ];
    const contextualPath = (0, $3518e48f06d57e36$export$1b610c29c9eeb0e1)(basePath, bindingPath.slice(1));
    if (contextualPath === primaryPath) return [
        primaryPath
    ];
    return [
        primaryPath,
        contextualPath
    ];
}
function $c4040e957c622274$export$26b190a0bb91f7b8(dataModel, basePath, bindingPath) {
    const candidatePaths = $c4040e957c622274$export$615d0d7e9f9cf4b6(basePath, bindingPath);
    for (const candidatePath of candidatePaths){
        const value = dataModel.get(candidatePath);
        if (value !== undefined) return value;
    }
    return dataModel.get(candidatePaths[0]);
}
function $c4040e957c622274$export$efe74d4ce38a1c59(value, context) {
    // Literal — return as-is
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    // Array literal (string[])
    if (Array.isArray(value)) return value;
    // DataBinding — read from data model
    if ((0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(value)) {
        const binding = value;
        return $c4040e957c622274$export$26b190a0bb91f7b8(context.dataModel, context.basePath, binding.path);
    }
    // FunctionCall — execute with recursively resolved args
    if ((0, $5fc37a5c0ab89261$export$36b315c6e35a6f4e)(value)) {
        const fn = value;
        const resolvedArgs = {};
        for (const [key, argValue] of Object.entries(fn.args))resolvedArgs[key] = $c4040e957c622274$export$efe74d4ce38a1c59(argValue, context);
        return (0, $c7196003281a224c$export$a9bd0e0d7f7536b8)(fn.call, resolvedArgs, context.customFunctions);
    }
    return value;
}
function $c4040e957c622274$export$7d66502656eea4ed(value, context) {
    const resolved = $c4040e957c622274$export$efe74d4ce38a1c59(value, context);
    return resolved != null ? String(resolved) : '';
}
function $c4040e957c622274$export$f9da9bfba99ddc3a(value, context) {
    const resolved = $c4040e957c622274$export$efe74d4ce38a1c59(value, context);
    return typeof resolved === 'number' ? resolved : Number(resolved) || 0;
}
function $c4040e957c622274$export$42e46c8769e6c91a(value, context) {
    const resolved = $c4040e957c622274$export$efe74d4ce38a1c59(value, context);
    return Boolean(resolved);
}
function $c4040e957c622274$export$5cdb3c4dd3c15170(value, context) {
    const resolved = $c4040e957c622274$export$efe74d4ce38a1c59(value, context);
    if (Array.isArray(resolved)) return resolved.map(String);
    if (typeof resolved === 'string') return [
        resolved
    ];
    return [];
}



function $86dd6fb9e78108ca$export$149fe2c34970dee0(value) {
    const { state: state, customFunctions: customFunctions } = (0, $a79b866aed66492f$export$a20f8e9fdc2641f2)();
    const { basePath: basePath } = (0, $baaab813a53ae29e$export$8888116feeffccb7)();
    const { dataModel: dataModel } = state;
    const getResolverContext = (0, $cozmU.useCallback)(()=>({
            dataModel: dataModel,
            basePath: basePath,
            customFunctions: customFunctions
        }), [
        dataModel,
        basePath,
        customFunctions
    ]);
    const [resolved, setResolved] = (0, $cozmU.useState)(()=>{
        if (value === undefined) return undefined;
        return (0, $c4040e957c622274$export$efe74d4ce38a1c59)(value, getResolverContext());
    });
    (0, $cozmU.useEffect)(()=>{
        if (value === undefined) {
            setResolved(undefined);
            return;
        }
        // For literals, just set once
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || Array.isArray(value)) {
            setResolved(value);
            return;
        }
        // For data bindings, subscribe to path changes
        if ((0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(value)) {
            const candidatePaths = (0, $c4040e957c622274$export$615d0d7e9f9cf4b6)(basePath, value.path);
            setResolved((0, $c4040e957c622274$export$26b190a0bb91f7b8)(dataModel, basePath, value.path));
            const unsubscribes = candidatePaths.map((candidatePath)=>dataModel.subscribe(candidatePath, ()=>{
                    setResolved((0, $c4040e957c622274$export$26b190a0bb91f7b8)(dataModel, basePath, value.path));
                }));
            return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
        }
        // For function calls, resolve and subscribe to all binding args
        if ((0, $5fc37a5c0ab89261$export$36b315c6e35a6f4e)(value)) {
            const resolve = ()=>(0, $c4040e957c622274$export$efe74d4ce38a1c59)(value, getResolverContext());
            setResolved(resolve());
            // Subscribe to any data bindings in args
            const unsubscribes = [];
            for (const argValue of Object.values(value.args))if ((0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(argValue)) {
                const candidatePaths = (0, $c4040e957c622274$export$615d0d7e9f9cf4b6)(basePath, argValue.path);
                for (const candidatePath of candidatePaths)unsubscribes.push(dataModel.subscribe(candidatePath, ()=>{
                    setResolved(resolve());
                }));
            }
            if (unsubscribes.length > 0) return ()=>unsubscribes.forEach((unsub)=>unsub());
        }
    }, [
        value,
        dataModel,
        basePath,
        getResolverContext
    ]);
    return resolved;
}
function $86dd6fb9e78108ca$export$6f742a1d461bdde4(value, fallback = '') {
    const resolved = $86dd6fb9e78108ca$export$149fe2c34970dee0(value);
    return resolved != null ? String(resolved) : fallback;
}
function $86dd6fb9e78108ca$export$8977c7fb51a9b6a(value, fallback = 0) {
    const resolved = $86dd6fb9e78108ca$export$149fe2c34970dee0(value);
    return typeof resolved === 'number' ? resolved : Number(resolved) || fallback;
}
function $86dd6fb9e78108ca$export$c329a15d2bd49f74(value, fallback = false) {
    const resolved = $86dd6fb9e78108ca$export$149fe2c34970dee0(value);
    return resolved != null ? Boolean(resolved) : fallback;
}


const $5c1b27936e74abba$var$TabHeader = ({ title: title })=>{
    const text = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, text);
};
const $5c1b27936e74abba$var$TabContent = ({ childId: childId, visited: visited })=>{
    const child = (0, $520d5d995c5e1183$export$516bf11d34989404)(childId, visited);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, child);
};
const $5c1b27936e74abba$export$bb9f62daac6db18f = ({ definition: definition, visited: visited })=>{
    const def = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        id: `a2ui-tabs-${def.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, def.tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c1b27936e74abba$var$TabHeader, {
            key: index,
            title: tab.title
        }))), def.tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c1b27936e74abba$var$TabContent, {
            key: index,
            childId: tab.child,
            visited: visited
        })));
};











const $cadd6dd6331f7d16$export$3eca960ed83730d = ({ definition: definition })=>{
    const def = definition;
    const url = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.url);
    const description = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.description);
    const label = def.accessibility?.label ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span"
    }, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("audio", {
        src: url,
        controls: true,
        "aria-label": label
    }));
};





// 57 A2UI icon names → ADS icon component imports
// Using @atlaskit/icon/core/* new icon imports

var $gFEZF = parcelRequire("gFEZF");





var $aRvnq = parcelRequire("aRvnq");


var $gxI48 = parcelRequire("gxI48");


var $824lD = parcelRequire("824lD");


var $cJHJd = parcelRequire("cJHJd");





var $5E5tg = parcelRequire("5E5tg");








var $6Fmj3 = parcelRequire("6Fmj3");





var $ldb9Z = parcelRequire("ldb9Z");





var $untPk = parcelRequire("untPk");





var $hS5Ee = parcelRequire("hS5Ee");


var $4efpo = parcelRequire("4efpo");


var $3cW6b = parcelRequire("3cW6b");





var $dDJT6 = parcelRequire("dDJT6");


var $g9ioO = parcelRequire("g9ioO");


var $fDwuI = parcelRequire("fDwuI");


var $c7ANI = parcelRequire("c7ANI");





var $1WMy0 = parcelRequire("1WMy0");


var $hAgam = parcelRequire("hAgam");


var $blZUD = parcelRequire("blZUD");





var $dmZMN = parcelRequire("dmZMN");





var $dPtX5 = parcelRequire("dPtX5");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");














var $k5vii = parcelRequire("k5vii");


var $fZ6J4 = parcelRequire("fZ6J4");

const $39f18674baf2044e$export$6d49a893c897b0cc = {
    accountCircle: (0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))),
    add: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
    arrowBack: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
    arrowForward: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
    attachFile: (0, (/*@__PURE__*/$parcel$interopDefault($gxI48))),
    calendarToday: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
    call: (0, (/*@__PURE__*/$parcel$interopDefault($fDwuI))),
    camera: (0, (/*@__PURE__*/$parcel$interopDefault($cJHJd))),
    check: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
    close: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
    delete: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
    download: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
    edit: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
    event: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
    favorite: (0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))),
    favoriteOff: (0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))),
    folder: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
    help: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
    home: (0, (/*@__PURE__*/$parcel$interopDefault($untPk))),
    info: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
    locationOn: (0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))),
    lock: (0, (/*@__PURE__*/$parcel$interopDefault($4efpo))),
    lockOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3cW6b))),
    mail: (0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))),
    menu: (0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))),
    moreVert: (0, (/*@__PURE__*/$parcel$interopDefault($dPtX5))),
    moreHoriz: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
    notifications: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
    notificationsOff: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
    pause: (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
    payment: (0, (/*@__PURE__*/$parcel$interopDefault($5E5tg))),
    person: (0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))),
    phone: (0, (/*@__PURE__*/$parcel$interopDefault($fDwuI))),
    photo: (0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))),
    play: (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))),
    print: (0, (/*@__PURE__*/$parcel$interopDefault($c7ANI))),
    refresh: (0, (/*@__PURE__*/$parcel$interopDefault($1WMy0))),
    search: (0, (/*@__PURE__*/$parcel$interopDefault($hAgam))),
    send: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
    settings: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
    share: (0, (/*@__PURE__*/$parcel$interopDefault($dmZMN))),
    star: (0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))),
    starOff: (0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))),
    starHalf: (0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))),
    stop: (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
    upload: (0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))),
    visibility: (0, (/*@__PURE__*/$parcel$interopDefault($hAgam))),
    visibilityOff: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
    volumeUp: (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))),
    volumeDown: (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))),
    volumeMute: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
    volumeOff: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
    warning: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1)))
};


const $3f5e19ac806cb49f$export$af88d666bbf8674a = ({ definition: definition })=>{
    const def = definition;
    const label = def.accessibility?.label ?? '';
    // Custom SVG path
    if (typeof def.name === 'object' && def.name.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: def.name.path,
        fill: "currentColor"
    }));
    // Predefined icon name
    if (typeof def.name === 'string') {
        const IconComponent = (0, $39f18674baf2044e$export$6d49a893c897b0cc)[def.name];
        if (IconComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            label: label
        });
    // Fallback: render nothing for unknown icons
    }
    return null;
};






var $arQY7 = parcelRequire("arQY7");


const $cef973e75e008507$var$variantSizeMap = {
    icon: 24,
    smallFeature: 80,
    mediumFeature: 200,
    largeFeature: 400
};
const $cef973e75e008507$var$fitToCss = {
    contain: 'contain',
    cover: 'cover',
    fill: 'fill',
    none: 'none',
    scaleDown: 'scale-down'
};
const $cef973e75e008507$export$1eca950af2101e6e = ({ definition: definition })=>{
    const def = definition;
    const url = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.url);
    const variant = def.variant;
    const fit = def.fit;
    const label = def.accessibility?.label ?? '';
    // Avatar variant
    if (variant === 'avatar') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: url,
        name: label,
        size: "medium"
    });
    // Sized variants
    const size = variant ? $cef973e75e008507$var$variantSizeMap[variant] : undefined;
    const style = {};
    style.maxWidth = '100%';
    style.height = 'auto';
    style.display = 'block';
    if (size) {
        style.width = size;
        style.height = size;
    }
    if (fit) style.objectFit = $cef973e75e008507$var$fitToCss[fit];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: url,
        alt: label,
        style: style
    });
};












// Lightweight Markdown → React nodes (bold, italic, code, links, line breaks)








function $2d977098e4bdd3b5$var$tokenize(text) {
    const nodes = [];
    // Match: **bold**, *italic*, `code`, [text](url)
    const pattern = /(\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`|\[(.+?)\]\((.+?)\))/g;
    let lastIndex = 0;
    let match;
    while((match = pattern.exec(text)) !== null){
        // Text before match
        if (match.index > lastIndex) nodes.push({
            type: 'text',
            content: text.slice(lastIndex, match.index)
        });
        if (match[2]) nodes.push({
            type: 'bold',
            content: match[2]
        });
        else if (match[3]) nodes.push({
            type: 'italic',
            content: match[3]
        });
        else if (match[4]) nodes.push({
            type: 'code',
            content: match[4]
        });
        else if (match[5] && match[6]) nodes.push({
            type: 'link',
            content: match[5],
            href: match[6]
        });
        lastIndex = match.index + match[0].length;
    }
    // Remaining text
    if (lastIndex < text.length) nodes.push({
        type: 'text',
        content: text.slice(lastIndex)
    });
    return nodes;
}
function $2d977098e4bdd3b5$export$bd27f0c8b4b4eabc(text) {
    const nodes = $2d977098e4bdd3b5$var$tokenize(text);
    if (nodes.length === 0) return text;
    if (nodes.length === 1 && nodes[0].type === 'text') return text;
    return nodes.map((node, index)=>{
        switch(node.type){
            case 'bold':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    key: index,
                    as: "span",
                    weight: "bold"
                }, node.content);
            case 'italic':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    key: index,
                    as: "em"
                }, node.content);
            case 'code':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", {
                    key: index
                }, node.content);
            case 'link':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                    key: index,
                    href: node.href ?? '',
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, node.content);
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: index
                }, node.content);
        }
    });
}


const $c3cd6e7933fa9c65$var$headingSizeMap = {
    h1: 'xxlarge',
    h2: 'xlarge',
    h3: 'large',
    h4: 'medium',
    h5: 'small'
};
const $c3cd6e7933fa9c65$var$headingAsMap = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5'
};
const $c3cd6e7933fa9c65$export$b7da9429c9c6117f = ({ definition: definition })=>{
    const def = definition;
    const text = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.text);
    const variant = def.variant ?? 'body';
    const content = (0, $2d977098e4bdd3b5$export$bd27f0c8b4b4eabc)(text);
    // Heading variants
    if (variant in $c3cd6e7933fa9c65$var$headingSizeMap) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: $c3cd6e7933fa9c65$var$headingSizeMap[variant],
        as: $c3cd6e7933fa9c65$var$headingAsMap[variant]
    }, content);
    // Caption variant
    if (variant === 'caption') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        as: "span"
    }, content);
    // Default body
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span"
    }, content);
};






const $413919622226ebed$export$542376c138e921e2 = ({ definition: definition })=>{
    const def = definition;
    const url = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.url);
    const label = def.accessibility?.label ?? '';
    return(// eslint-disable-next-line jsx-a11y/media-has-caption, @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("video", {
        src: url,
        controls: true,
        "aria-label": label,
        style: {
            maxWidth: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("track", {
        kind: "captions"
    })));
};


/* A2UIButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $7ZB0A = parcelRequire("7ZB0A");












const $c62046e9700ba106$var$variantMap = {
    primary: 'primary',
    borderless: 'subtle'
};
const $c62046e9700ba106$var$styles = {
    wrapper: "_3iDTPbvbI6"
};
const $c62046e9700ba106$export$b4a55b30023d7caf = ({ definition: definition, visited: visited })=>{
    const def = definition;
    const child = (0, $520d5d995c5e1183$export$516bf11d34989404)(def.child, visited);
    const { state: state, onAction: onAction, customFunctions: customFunctions } = (0, $a79b866aed66492f$export$a20f8e9fdc2641f2)();
    const { basePath: basePath } = (0, $baaab813a53ae29e$export$8888116feeffccb7)();
    const { dataModel: dataModel } = state;
    const appearance = def.variant ? $c62046e9700ba106$var$variantMap[def.variant] : 'default';
    const label = def.accessibility?.label;
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!def.action) return;
        const resolverContext = {
            dataModel: dataModel,
            basePath: basePath,
            customFunctions: customFunctions
        };
        // FunctionCall action — execute client-side
        if ('functionCall' in def.action) {
            const { call: call, args: args } = def.action.functionCall;
            const resolvedArgs = {};
            for (const [key, argValue] of Object.entries(args))resolvedArgs[key] = (0, $c4040e957c622274$export$efe74d4ce38a1c59)(argValue, resolverContext);
            (0, $c7196003281a224c$export$a9bd0e0d7f7536b8)(call, resolvedArgs, customFunctions);
            return;
        }
        // Event action — dispatch to host
        if ('event' in def.action) {
            const actionEvent = def.action;
            const resolvedContext = {};
            if (actionEvent.context) for (const [key, val] of Object.entries(actionEvent.context))resolvedContext[key] = (0, $c4040e957c622274$export$efe74d4ce38a1c59)(val, resolverContext);
            onAction({
                surfaceId: state.surfaceId,
                eventName: actionEvent.event,
                context: resolvedContext,
                dataModel: dataModel.snapshot()
            });
        }
    }, [
        def.action,
        dataModel,
        basePath,
        customFunctions,
        onAction,
        state.surfaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c62046e9700ba106$var$styles.wrapper)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: appearance,
        onClick: handleClick,
        "aria-label": label
    }, child));
};














function $696adc9a471cc95e$export$ff928fab68734d91(path) {
    const { state: state } = (0, $a79b866aed66492f$export$a20f8e9fdc2641f2)();
    const { basePath: basePath } = (0, $baaab813a53ae29e$export$8888116feeffccb7)();
    const { dataModel: dataModel } = state;
    const candidatePaths = (0, $cozmU.useMemo)(()=>(0, $c4040e957c622274$export$615d0d7e9f9cf4b6)(basePath, path), [
        basePath,
        path
    ]);
    const resolvedPath = candidatePaths[0];
    const [value, setValue] = (0, $cozmU.useState)(()=>(0, $c4040e957c622274$export$26b190a0bb91f7b8)(dataModel, basePath, path));
    (0, $cozmU.useEffect)(()=>{
        setValue((0, $c4040e957c622274$export$26b190a0bb91f7b8)(dataModel, basePath, path));
        const unsubscribes = candidatePaths.map((candidatePath)=>dataModel.subscribe(candidatePath, ()=>{
                setValue((0, $c4040e957c622274$export$26b190a0bb91f7b8)(dataModel, basePath, path));
            }));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        dataModel,
        basePath,
        path,
        candidatePaths
    ]);
    const setDataValue = (0, $cozmU.useCallback)((newValue)=>{
        dataModel.set(resolvedPath, newValue);
    }, [
        dataModel,
        resolvedPath
    ]);
    return [
        value,
        setDataValue
    ];
}








// Evaluates checks[] → { isInvalid, errorMessages }

function $703a52bc9ae8411b$export$cef296e290af2f60(checks, context) {
    if (!checks || checks.length === 0) return {
        isInvalid: false,
        errorMessages: []
    };
    const errorMessages = [];
    for (const check of checks){
        const conditionMet = (0, $c4040e957c622274$export$42e46c8769e6c91a)(check.condition, context);
        // In A2UI, condition resolves to true when valid, false when invalid
        if (!conditionMet) errorMessages.push(check.message);
    }
    return {
        isInvalid: errorMessages.length > 0,
        errorMessages: errorMessages
    };
}


function $431e37c723fe6f6f$export$87fe492f99f25a20(checks) {
    const { state: state, customFunctions: customFunctions } = (0, $a79b866aed66492f$export$a20f8e9fdc2641f2)();
    const { basePath: basePath } = (0, $baaab813a53ae29e$export$8888116feeffccb7)();
    const { dataModel: dataModel } = state;
    return (0, $cozmU.useMemo)(()=>(0, $703a52bc9ae8411b$export$cef296e290af2f60)(checks, {
            dataModel: dataModel,
            basePath: basePath,
            customFunctions: customFunctions
        }), [
        checks,
        dataModel,
        basePath,
        customFunctions
    ]);
}



const $384d7fddd4cdce04$export$7d2c9a6b3a0506ca = ({ definition: definition })=>{
    const def = definition;
    const label = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.label);
    const { isInvalid: isInvalid } = (0, $431e37c723fe6f6f$export$87fe492f99f25a20)(def.checks);
    // Two-way binding for boolean value
    const bindingPath = (0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(def.value) ? def.value.path : null;
    const [boundValue, setBoundValue] = (0, $696adc9a471cc95e$export$ff928fab68734d91)(bindingPath ?? '/___noop');
    const staticValue = (0, $86dd6fb9e78108ca$export$c329a15d2bd49f74)(def.value);
    const isChecked = bindingPath ? Boolean(boundValue) : staticValue;
    const handleChange = (0, $cozmU.useCallback)((e)=>{
        if (bindingPath) setBoundValue(e.target.checked);
    }, [
        bindingPath,
        setBoundValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        label: label,
        isChecked: isChecked,
        onChange: handleChange,
        isInvalid: isInvalid,
        name: def.id
    });
};
















var $1hHRQ = parcelRequire("1hHRQ");


var $6wGOF = parcelRequire("6wGOF");





const $52e053e1909b925b$export$83591287a09041c = ({ definition: definition })=>{
    const def = definition;
    const label = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.label);
    const variant = def.variant ?? 'mutuallyExclusive';
    const displayStyle = def.displayStyle;
    const filterable = def.filterable ?? false;
    const { isInvalid: isInvalid } = (0, $431e37c723fe6f6f$export$87fe492f99f25a20)(def.checks);
    // Two-way binding
    const bindingPath = (0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(def.value) ? def.value.path : null;
    const [boundValue, setBoundValue] = (0, $696adc9a471cc95e$export$ff928fab68734d91)(bindingPath ?? '/___noop');
    const selectedValues = bindingPath ? boundValue ?? [] : [];
    const selectedValuesRef = (0, $cozmU.useRef)(selectedValues);
    selectedValuesRef.current = selectedValues;
    const handleRadioChange = (0, $cozmU.useCallback)((e)=>{
        if (bindingPath) setBoundValue([
            e.target.value
        ]);
    }, [
        bindingPath,
        setBoundValue
    ]);
    const handleCheckboxChange = (0, $cozmU.useCallback)((optionValue, checked)=>{
        if (!bindingPath) return;
        const current = new Set(selectedValuesRef.current);
        if (checked) current.add(optionValue);
        else current.delete(optionValue);
        setBoundValue(Array.from(current));
    }, [
        bindingPath,
        setBoundValue
    ]);
    const handleSelectChange = (0, $cozmU.useCallback)((newValue)=>{
        if (!bindingPath) return;
        if (Array.isArray(newValue)) setBoundValue(newValue.map((v)=>v.value));
        else if (newValue && typeof newValue === 'object' && 'value' in newValue) setBoundValue([
            newValue.value
        ]);
        else setBoundValue([]);
    }, [
        bindingPath,
        setBoundValue
    ]);
    // -- Mutually Exclusive → RadioGroup --
    if (variant === 'mutuallyExclusive') {
        const radioOptions = def.options.map((opt)=>({
                name: def.id,
                label: opt.label,
                value: opt.value
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            weight: "semibold"
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1hHRQ.default), {
            options: radioOptions,
            value: selectedValues[0] ?? null,
            onChange: handleRadioChange,
            isInvalid: isInvalid
        }));
    }
    // -- Multiple Selection with checkbox display --
    if (variant === 'multipleSelection' && displayStyle === 'checkbox') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, def.options.map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            key: opt.value,
            label: opt.label,
            isChecked: selectedValues.includes(opt.value),
            onChange: (e)=>handleCheckboxChange(opt.value, e.target.checked),
            isInvalid: isInvalid,
            name: `${def.id}-${opt.value}`
        }))));
    // -- Multiple Selection with chips / filterable → multi Select --
    const selectOptions = def.options.map((opt)=>({
            label: opt.label,
            value: opt.value
        }));
    const selectValue = selectOptions.filter((opt)=>selectedValues.includes(opt.value));
    const isMulti = variant === 'multipleSelection';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        options: selectOptions,
        value: isMulti ? selectValue : selectValue[0] ?? null,
        onChange: handleSelectChange,
        isMulti: isMulti,
        isSearchable: filterable,
        inputId: `a2ui-choice-${def.id}`
    }));
};






var $lF9wS = parcelRequire("lF9wS");

var $57alK = parcelRequire("57alK");

var $3sqHc = parcelRequire("3sqHc");










const $622b55f0f44d5da3$export$19e52ee4bad2f05f = ({ definition: definition })=>{
    const def = definition;
    const label = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.label);
    const minValue = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.min);
    const maxValue = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.max);
    const { isInvalid: isInvalid } = (0, $431e37c723fe6f6f$export$87fe492f99f25a20)(def.checks);
    const enableDate = def.enableDate !== false;
    const enableTime = def.enableTime !== false;
    // Two-way binding
    const bindingPath = (0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(def.value) ? def.value.path : null;
    const [boundValue, setBoundValue] = (0, $696adc9a471cc95e$export$ff928fab68734d91)(bindingPath ?? '/___noop');
    const staticValue = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.value);
    const value = bindingPath ? boundValue ?? '' : staticValue;
    const handleChange = (0, $cozmU.useCallback)((newValue)=>{
        if (bindingPath) setBoundValue(newValue);
    }, [
        bindingPath,
        setBoundValue
    ]);
    const fieldId = `a2ui-datetime-${def.id}`;
    const ariaLabel = def.accessibility?.label ?? label;
    // Date only
    if (enableDate && !enableTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
        id: fieldId,
        value: value,
        onChange: handleChange,
        isInvalid: isInvalid,
        minDate: minValue || undefined,
        maxDate: maxValue || undefined,
        label: ariaLabel
    }));
    // Time only
    if (!enableDate && enableTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sqHc.default), {
        id: fieldId,
        value: value,
        onChange: handleChange,
        isInvalid: isInvalid,
        label: ariaLabel
    }));
    // Date + Time (default)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57alK.default), {
        id: fieldId,
        value: value,
        onChange: handleChange,
        isInvalid: isInvalid
    }));
};











var $1nAzh = parcelRequire("1nAzh");




const $e35eacd481b7a99c$export$f09a9f1ea4527e92 = ({ definition: definition })=>{
    const def = definition;
    const label = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.label);
    // Two-way binding for number value
    const bindingPath = (0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(def.value) ? def.value.path : null;
    const [boundValue, setBoundValue] = (0, $696adc9a471cc95e$export$ff928fab68734d91)(bindingPath ?? '/___noop');
    const staticValue = (0, $86dd6fb9e78108ca$export$8977c7fb51a9b6a)(def.value);
    const value = bindingPath ? boundValue ?? def.min : staticValue;
    const handleChange = (0, $cozmU.useCallback)((newValue)=>{
        if (bindingPath) setBoundValue(newValue);
    }, [
        bindingPath,
        setBoundValue
    ]);
    const fieldId = `a2ui-slider-${def.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1nAzh.default), {
        id: fieldId,
        min: def.min,
        max: def.max,
        value: value,
        onChange: handleChange,
        "aria-label": def.accessibility?.label ?? label
    }));
};











var $e3Wrf = parcelRequire("e3Wrf");








const $fd518ce2e9ccea98$var$variantToType = {
    shortText: 'text',
    longText: 'text',
    number: 'number',
    obscured: 'password'
};
const $fd518ce2e9ccea98$export$6e81669538f38873 = ({ definition: definition })=>{
    const def = definition;
    const label = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(def.label);
    const legacyVariant = def.type;
    const variant = def.variant ?? (legacyVariant && legacyVariant in $fd518ce2e9ccea98$var$variantToType ? legacyVariant : undefined) ?? 'shortText';
    const { isInvalid: isInvalid, errorMessages: errorMessages } = (0, $431e37c723fe6f6f$export$87fe492f99f25a20)(def.checks);
    const valueSource = def.value ?? def.text;
    // Two-way binding: if value is a DataBinding, use useDataBinding
    const bindingPath = (0, $5fc37a5c0ab89261$export$687a57249f85e9d6)(valueSource) ? valueSource.path : null;
    const [boundValue, setBoundValue] = (0, $696adc9a471cc95e$export$ff928fab68734d91)(bindingPath ?? '/___noop');
    const staticValue = (0, $86dd6fb9e78108ca$export$6f742a1d461bdde4)(valueSource);
    const value = bindingPath ? boundValue ?? '' : staticValue;
    const handleChange = (0, $cozmU.useCallback)((e)=>{
        if (bindingPath) setBoundValue(e.currentTarget.value);
    }, [
        bindingPath,
        setBoundValue
    ]);
    const fieldId = `a2ui-field-${def.id}`;
    // Long text → Textarea
    if (variant === 'longText') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        id: fieldId,
        value: value,
        onChange: handleChange,
        isInvalid: isInvalid,
        "aria-label": def.accessibility?.label ?? label
    }), isInvalid && errorMessages.map((msg, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: i,
            as: "span",
            size: "small"
        }, msg)));
    // Short text, number, obscured → Textfield
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "semibold"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: fieldId,
        type: $fd518ce2e9ccea98$var$variantToType[variant],
        value: value,
        onChange: handleChange,
        isInvalid: isInvalid,
        "aria-label": def.accessibility?.label ?? label
    }), isInvalid && errorMessages.map((msg, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: i,
            as: "span",
            size: "small"
        }, msg)));
};


/* A2UICard.tsx generated by @compiled/babel-plugin v2.0.0 */ 









const $37715c86000442c2$var$styles = {
    card: "_0bjKvD8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXrulfZc _2OUyjtzwhj"
};
const $37715c86000442c2$export$560c519926ea66bf = ({ definition: definition, visited: visited })=>{
    const def = definition;
    const child = (0, $520d5d995c5e1183$export$516bf11d34989404)(def.child, visited);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($37715c86000442c2$var$styles.card)
    }, child);
};









const $f766483bc57ef81f$var$mapJustify = (justify)=>{
    switch(justify){
        case 'start':
        case 'center':
        case 'end':
        case 'stretch':
            return {
                alignBlock: justify
            };
        case 'spaceBetween':
            return {
                spread: 'space-between'
            };
        case 'spaceAround':
            return {
                xcssKey: 'spaceAround'
            };
        case 'spaceEvenly':
            return {
                xcssKey: 'spaceEvenly'
            };
        default:
            return {};
    }
};
const $f766483bc57ef81f$var$mapAlign = (align)=>{
    return align;
};
const $f766483bc57ef81f$export$ee767104f87c909 = ({ definition: definition, visited: visited })=>{
    const def = definition;
    const children = (0, $520d5d995c5e1183$export$223e18e38a98b3a5)(def.children, visited);
    const { alignBlock: alignBlock, spread: spread } = $f766483bc57ef81f$var$mapJustify(def.justify);
    const alignInline = $f766483bc57ef81f$var$mapAlign(def.align);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignBlock: alignBlock,
        alignInline: alignInline,
        spread: spread
    }, children);
};


/* A2UIDivider.tsx generated by @compiled/babel-plugin v2.0.0 */ 








const $71615220816338ea$var$styles = {
    horizontal: "_2R4pr3OeNX _39xV02N91d",
    vertical: "_1VfddaOeNX _4xdlr0FlnN"
};
const $71615220816338ea$export$2b5103a51d64a713 = ({ definition: definition })=>{
    const def = definition;
    const axis = def.axis ?? 'horizontal';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($71615220816338ea$var$styles[axis]),
        role: "separator"
    });
};











const $8aa0012e8ed53cb7$export$e6545e587216784a = ({ definition: definition, visited: visited })=>{
    const def = definition;
    const children = (0, $520d5d995c5e1183$export$223e18e38a98b3a5)(def.children, visited);
    const direction = def.direction ?? 'vertical';
    const align = def.align;
    if (direction === 'horizontal') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: align
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        alignInline: align ?? 'stretch'
    }, children);
};









const $03605120617c6405$var$mapJustify = (justify)=>{
    switch(justify){
        case 'start':
        case 'center':
        case 'end':
        case 'stretch':
            return {
                alignInline: justify
            };
        case 'spaceBetween':
            return {
                spread: 'space-between'
            };
        case 'spaceAround':
            return {
                xcssKey: 'spaceAround'
            };
        case 'spaceEvenly':
            return {
                xcssKey: 'spaceEvenly'
            };
        default:
            return {};
    }
};
const $03605120617c6405$var$mapAlign = (align)=>{
    return align;
};
const $03605120617c6405$export$fdadaee57fbf38c6 = ({ definition: definition, visited: visited })=>{
    const def = definition;
    const children = (0, $520d5d995c5e1183$export$223e18e38a98b3a5)(def.children, visited);
    const { alignInline: alignInline, spread: spread } = $03605120617c6405$var$mapJustify(def.justify);
    const alignBlock = $03605120617c6405$var$mapAlign(def.align);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignInline: alignInline,
        alignBlock: alignBlock,
        spread: spread,
        shouldWrap: true
    }, children);
};


const $63ca1ad235916b5f$var$allComponents = {
    Text: (0, $c3cd6e7933fa9c65$export$b7da9429c9c6117f),
    Image: (0, $cef973e75e008507$export$1eca950af2101e6e),
    Icon: (0, $3f5e19ac806cb49f$export$af88d666bbf8674a),
    Video: (0, $413919622226ebed$export$542376c138e921e2),
    AudioPlayer: (0, $cadd6dd6331f7d16$export$3eca960ed83730d),
    Row: (0, $03605120617c6405$export$fdadaee57fbf38c6),
    Column: (0, $f766483bc57ef81f$export$ee767104f87c909),
    List: (0, $8aa0012e8ed53cb7$export$e6545e587216784a),
    Card: (0, $37715c86000442c2$export$560c519926ea66bf),
    Divider: (0, $71615220816338ea$export$2b5103a51d64a713),
    Button: (0, $c62046e9700ba106$export$b4a55b30023d7caf),
    TextField: (0, $fd518ce2e9ccea98$export$6e81669538f38873),
    CheckBox: (0, $384d7fddd4cdce04$export$7d2c9a6b3a0506ca),
    ChoicePicker: (0, $52e053e1909b925b$export$83591287a09041c),
    Slider: (0, $e35eacd481b7a99c$export$f09a9f1ea4527e92),
    DateTimeInput: (0, $622b55f0f44d5da3$export$19e52ee4bad2f05f),
    Tabs: (0, $5c1b27936e74abba$export$bb9f62daac6db18f),
    Modal: (0, $cde9c41dde6edca0$export$9ef33d0cdeb528e5)
};
let $63ca1ad235916b5f$var$registered = false;
const $63ca1ad235916b5f$export$d252b6a36f07590 = ()=>{
    if (!$63ca1ad235916b5f$var$registered) {
        (0, $176500affb65f278$export$825fce918ac105f)($63ca1ad235916b5f$var$allComponents);
        $63ca1ad235916b5f$var$registered = true;
    }
};




// Routes A2UI protocol messages (v0.8 and v0.9) to reducer dispatch
/**
 * Normalizes v0.8 A2UI protocol messages, components, and data model entries
 * into the v0.9-compatible internal format used by the renderer.
 *
 * v0.8 differences handled:
 * - Component format: { id, component: { "Text": { text: { literalString: "Hi" } } } }
 *   → { id, type: "Text", text: "Hi" }
 * - BoundValues: { literalString: "x" } → "x", { path: "/y" } → { path: "/y" }
 * - Children: { explicitList: [...] } → [...], { template: { dataBinding, componentId } } → { path, componentId }
 * - Data model: typed key-value entries → direct JSON
 * - Messages: surfaceUpdate, beginRendering → UPDATE_COMPONENTS, INIT_SURFACE
 */ function $8bff0b51cc8157b1$export$b11b426a983f48e(value) {
    if (value === null || value === undefined) return value;
    // Already a primitive — pass through (handles direct v0.9-style literals)
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    // Array — pass through (v0.9 literal arrays)
    if (Array.isArray(value)) return value;
    if (typeof value !== 'object') return value;
    const obj = value;
    // If it has a `path`, it's a binding (path takes precedence over literal)
    if ('path' in obj && typeof obj.path === 'string') return {
        path: obj.path
    };
    // v0.8 typed literals
    if ('literalString' in obj && obj.literalString !== undefined) return obj.literalString;
    if ('literalNumber' in obj && obj.literalNumber !== undefined) return obj.literalNumber;
    if ('literalBoolean' in obj && obj.literalBoolean !== undefined) return obj.literalBoolean;
    if ('literalArray' in obj && obj.literalArray !== undefined) return obj.literalArray;
    // If it looks like a v0.9 FunctionCall ({ call, args }), pass through
    if ('call' in obj) return value;
    // If it looks like a v0.9 DataBinding ({ path }), pass through
    // (already handled above, but just in case)
    // Unknown shape — return as-is
    return value;
}
function $8bff0b51cc8157b1$export$495e021797507ed2(children) {
    if (children === null || children === undefined) return children;
    // Already v0.9 format — array of IDs
    if (Array.isArray(children)) return children;
    if (typeof children !== 'object') return children;
    const obj = children;
    // v0.8 explicit list
    if ('explicitList' in obj && Array.isArray(obj.explicitList)) return obj.explicitList;
    // v0.8 template
    if ('template' in obj && obj.template) {
        const dataBinding = obj.template.dataBinding;
        const normalizedPath = typeof dataBinding === 'string' ? dataBinding : typeof dataBinding?.path === 'string' ? dataBinding.path : obj.template.componentId;
        return {
            componentId: obj.template.componentId,
            path: normalizedPath
        };
    }
    // Already v0.9 ChildTemplate format ({ componentId, path })
    if ('componentId' in obj && 'path' in obj) return children;
    return children;
}
// ── Component normalization ─────────────────────────────────────────────
/**
 * Properties that are known to hold BoundValue/DynamicValue references.
 * These need recursive normalization from v0.8 to v0.9 format.
 */ const $8bff0b51cc8157b1$var$BOUND_VALUE_PROPS = new Set([
    'text',
    'url',
    'label',
    'value',
    'description',
    'min',
    'max',
    'title'
]);
const $8bff0b51cc8157b1$var$CHILDREN_PROPS = new Set([
    'children'
]);
const $8bff0b51cc8157b1$var$CHILD_REF_PROPS = new Set([
    'child',
    'content',
    'trigger'
]);
/**
 * v0.8 property renames → v0.9 property names.
 * Keys that exist in v0.8 wire format but were renamed in v0.9.
 */ const $8bff0b51cc8157b1$var$PROP_RENAMES = {
    usageHint: 'variant',
    tabItems: 'tabs'
};
/**
 * Recursively normalize component properties from v0.8 BoundValue format to v0.9 DynamicValue.
 */ function $8bff0b51cc8157b1$var$normalizeComponentProps(props) {
    const result = {};
    for (const [key, value] of Object.entries(props)){
        const outputKey = $8bff0b51cc8157b1$var$PROP_RENAMES[key] ?? key;
        if ($8bff0b51cc8157b1$var$BOUND_VALUE_PROPS.has(key)) result[outputKey] = $8bff0b51cc8157b1$export$b11b426a983f48e(value);
        else if ($8bff0b51cc8157b1$var$CHILDREN_PROPS.has(key)) result[outputKey] = $8bff0b51cc8157b1$export$495e021797507ed2(value);
        else if ($8bff0b51cc8157b1$var$CHILD_REF_PROPS.has(key)) // child references are plain strings in both versions
        result[outputKey] = value;
        else if (key === 'action') result[outputKey] = $8bff0b51cc8157b1$var$normalizeAction(value);
        else if (key === 'checks') result[outputKey] = $8bff0b51cc8157b1$var$normalizeChecks(value);
        else if (key === 'tabs' || key === 'tabItems') result[outputKey] = $8bff0b51cc8157b1$var$normalizeTabs(value);
        else if (key === 'options') result[outputKey] = $8bff0b51cc8157b1$var$normalizeOptions(value);
        else result[outputKey] = value;
    }
    return result;
}
/**
 * Normalize a v0.8 action.
 * v0.8 actions have: { name: "...", context: [{ key: "k", value: BoundValue }] }
 * v0.9 actions have: { event: "...", context: { k: DynamicValue } }
 * or: { functionCall: { call: "...", args: {...} } }
 */ function $8bff0b51cc8157b1$var$normalizeAction(action) {
    if (!action || typeof action !== 'object') return action;
    const obj = action;
    // Already v0.9 format (has `event` or `functionCall`)
    if ('event' in obj || 'functionCall' in obj) {
        // Still normalize context values
        if ('context' in obj && typeof obj.context === 'object' && obj.context !== null) {
            if (Array.isArray(obj.context)) {
                // v0.8 context format: [{ key, value }] → { key: value }
                const normalizedContext = {};
                for (const entry of obj.context)if (entry && typeof entry === 'object' && 'key' in entry && 'value' in entry) normalizedContext[entry.key] = $8bff0b51cc8157b1$export$b11b426a983f48e(entry.value);
                return {
                    ...obj,
                    context: normalizedContext
                };
            }
            // v0.9 context format: { key: DynamicValue } — normalize values
            const ctx = obj.context;
            const normalizedContext = {};
            for (const [k, v] of Object.entries(ctx))normalizedContext[k] = $8bff0b51cc8157b1$export$b11b426a983f48e(v);
            return {
                ...obj,
                context: normalizedContext
            };
        }
        return action;
    }
    // v0.8 format: { name: "...", context: [...] }
    if ('name' in obj) {
        const normalizedContext = {};
        if (Array.isArray(obj.context)) {
            for (const entry of obj.context)if (entry && typeof entry === 'object' && 'key' in entry && 'value' in entry) normalizedContext[entry.key] = $8bff0b51cc8157b1$export$b11b426a983f48e(entry.value);
        }
        return {
            event: obj.name,
            ...Object.keys(normalizedContext).length > 0 ? {
                context: normalizedContext
            } : {}
        };
    }
    return action;
}
/**
 * Normalize v0.8 check rules.
 */ function $8bff0b51cc8157b1$var$normalizeChecks(checks) {
    if (!Array.isArray(checks)) return checks;
    return checks.map((check)=>{
        if (!check || typeof check !== 'object') return check;
        const c = check;
        return {
            ...c,
            condition: c.condition ? $8bff0b51cc8157b1$export$b11b426a983f48e(c.condition) : c.condition
        };
    });
}
/**
 * Normalize tab definitions.
 */ function $8bff0b51cc8157b1$var$normalizeTabs(tabs) {
    if (!Array.isArray(tabs)) return tabs;
    return tabs.map((tab)=>{
        if (!tab || typeof tab !== 'object') return tab;
        const t = tab;
        return {
            ...t,
            title: t.title ? $8bff0b51cc8157b1$export$b11b426a983f48e(t.title) : t.title
        };
    });
}
/**
 * Normalize choice picker options.
 */ function $8bff0b51cc8157b1$var$normalizeOptions(options) {
    if (!Array.isArray(options)) return options;
    return options.map((opt)=>{
        if (!opt || typeof opt !== 'object') return opt;
        const o = opt;
        return {
            ...o,
            label: typeof o.label === 'object' ? $8bff0b51cc8157b1$export$b11b426a983f48e(o.label) : o.label,
            value: typeof o.value === 'object' ? $8bff0b51cc8157b1$export$b11b426a983f48e(o.value) : o.value
        };
    });
}
function $8bff0b51cc8157b1$export$ed9795e7a940350e(wireComponent) {
    const { id: id, component: component, weight: weight } = wireComponent;
    // The component wrapper has exactly one key — the component type
    const componentType = Object.keys(component)[0];
    const rawProps = component[componentType] ?? {};
    const normalizedProps = $8bff0b51cc8157b1$var$normalizeComponentProps(rawProps);
    return {
        id: id,
        type: componentType,
        ...weight != null ? {
            weight: weight
        } : {},
        ...normalizedProps
    };
}
function $8bff0b51cc8157b1$export$41f7352e02ad93cd(wireComponents) {
    return wireComponents.map($8bff0b51cc8157b1$export$ed9795e7a940350e);
}
function $8bff0b51cc8157b1$export$cf4d9dc32d51a2a(entries) {
    const result = {};
    for (const entry of entries){
        const { key: key } = entry;
        if (entry.valueString !== undefined) result[key] = entry.valueString;
        else if (entry.valueNumber !== undefined) result[key] = entry.valueNumber;
        else if (entry.valueBoolean !== undefined) result[key] = entry.valueBoolean;
        else if (entry.valueMap !== undefined) result[key] = $8bff0b51cc8157b1$export$cf4d9dc32d51a2a(entry.valueMap);
        else if (entry.valueList !== undefined) result[key] = $8bff0b51cc8157b1$var$normalizeV08DataList(entry.valueList);
        else // No typed value — set to null
        result[key] = null;
    }
    return result;
}
/**
 * Convert a v0.8 valueList (array of entries) to a JSON array.
 * Each entry in the list is itself a set of key-value entries forming an object.
 */ function $8bff0b51cc8157b1$var$normalizeV08DataList(entries) {
    // Each entry at the top level of a list represents an item.
    // If items have keys, they're objects; otherwise treat as flat values.
    return entries.map((entry)=>{
        if (entry.valueMap !== undefined) return $8bff0b51cc8157b1$export$cf4d9dc32d51a2a(entry.valueMap);
        if (entry.valueString !== undefined) return entry.valueString;
        if (entry.valueNumber !== undefined) return entry.valueNumber;
        if (entry.valueBoolean !== undefined) return entry.valueBoolean;
        if (entry.valueList !== undefined) return $8bff0b51cc8157b1$var$normalizeV08DataList(entry.valueList);
        return null;
    });
}
function $8bff0b51cc8157b1$export$b2b6c2e8eac9253(contents) {
    if (Array.isArray(contents)) return $8bff0b51cc8157b1$export$cf4d9dc32d51a2a(contents);
    // Already a plain object
    return contents;
}
function $8bff0b51cc8157b1$export$74f6813e514f958d(message) {
    if (!message || typeof message !== 'object') return false;
    const msg = message;
    return 'surfaceUpdate' in msg || 'beginRendering' in msg || 'dataModelUpdate' in msg;
}
function $8bff0b51cc8157b1$export$b64ddcd0f2a4d4e1(component) {
    if (!component || typeof component !== 'object') return false;
    const obj = component;
    return 'component' in obj && typeof obj.component === 'object' && obj.component !== null && !Array.isArray(obj.component);
}


// ── v0.9 message processing ────────────────────────────────────────────
function $0f13090a4f991832$var$processV09Message(message) {
    if ('type' in message && message.type === 'createSurface') return {
        type: 'CREATE_SURFACE',
        surfaceId: message.surfaceId,
        catalogId: message.catalogId,
        rootId: message.rootId,
        components: message.components,
        dataModel: message.dataModel
    };
    if ('updateComponents' in message) return {
        type: 'UPDATE_COMPONENTS',
        components: message.updateComponents.components
    };
    if ('updateDataModel' in message) {
        const { path: path, value: value } = message.updateDataModel;
        if (!path) return {
            type: 'UPDATE_DATA_MODEL',
            operations: []
        };
        return {
            type: 'UPDATE_DATA_MODEL',
            operations: [
                value === undefined ? {
                    op: 'remove',
                    path: path
                } : {
                    op: 'replace',
                    path: path,
                    value: value
                }
            ]
        };
    }
    if ('deleteSurface' in message) return {
        type: 'DELETE_SURFACE'
    };
    throw new Error('Unknown A2UI v0.9 message shape');
}
// ── v0.8 message processing ────────────────────────────────────────────
function $0f13090a4f991832$var$processV08Message(message) {
    const msg = message;
    // surfaceUpdate → UPDATE_COMPONENTS (with normalized components)
    if ('surfaceUpdate' in msg) {
        const surfaceUpdate = msg.surfaceUpdate;
        const normalizedComponents = (0, $8bff0b51cc8157b1$export$41f7352e02ad93cd)(surfaceUpdate.components);
        return {
            type: 'UPDATE_COMPONENTS',
            components: normalizedComponents
        };
    }
    // beginRendering → INIT_SURFACE (sets surface metadata, triggers render)
    if ('beginRendering' in msg) {
        const beginRendering = msg.beginRendering;
        return {
            type: 'INIT_SURFACE',
            surfaceId: beginRendering.surfaceId ?? 'default',
            catalogId: beginRendering.catalogId,
            rootId: beginRendering.root
        };
    }
    // dataModelUpdate → UPDATE_DATA_MODEL
    if ('dataModelUpdate' in msg) {
        const dataModelUpdate = msg.dataModelUpdate;
        const normalizedData = (0, $8bff0b51cc8157b1$export$b2b6c2e8eac9253)(dataModelUpdate.contents);
        // v0.8 path may or may not start with '/'
        const basePath = dataModelUpdate.path ? dataModelUpdate.path.startsWith('/') ? dataModelUpdate.path : `/${dataModelUpdate.path}` : '';
        const isRootPath = basePath === '' || basePath === '/';
        if (isRootPath) {
            // Root replacement — set each top-level key
            const operations = Object.entries(normalizedData).map(([key, value])=>({
                    op: 'replace',
                    path: `/${key}`,
                    value: value
                }));
            return {
                type: 'UPDATE_DATA_MODEL',
                operations: operations
            };
        }
        return {
            type: 'UPDATE_DATA_MODEL',
            operations: [
                {
                    op: 'replace',
                    path: basePath,
                    value: normalizedData
                }
            ]
        };
    }
    // deleteSurface — same format in both versions
    if ('deleteSurface' in msg) return {
        type: 'DELETE_SURFACE'
    };
    throw new Error('Unknown A2UI v0.8 message shape');
}
function $0f13090a4f991832$export$23012ff6b17999d5(message) {
    if ((0, $8bff0b51cc8157b1$export$74f6813e514f958d)(message)) return $0f13090a4f991832$var$processV08Message(message);
    return $0f13090a4f991832$var$processV09Message(message);
}
function $0f13090a4f991832$export$d2e92820f98a2592(messages) {
    return messages.map($0f13090a4f991832$export$23012ff6b17999d5);
}


/* TreeBuilder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
















const $e54ccf8d527e4ff3$var$styles = {
    errorFallback: "_30huDKH3V3 _1UtDYzAyGJ _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _3138421Y8M _0adFHs1Y8M _1DCdHi1Y8M _2XsHFM1Y8M"
};
const $e54ccf8d527e4ff3$export$b2bae32360e4c19f = ({ componentId: componentId, visited: visited = new Set() })=>{
    const { state: state } = (0, $a79b866aed66492f$export$a20f8e9fdc2641f2)();
    const { componentMap: componentMap } = state; // Cycle detection
    if (visited.has(componentId)) return null;
    const definition = componentMap.get(componentId);
    if (!definition) return null;
    const Component = (0, $176500affb65f278$export$21a8719ce41a1de2)(definition.type);
    if (!Component) return null;
    const nextVisited = new Set(visited);
    nextVisited.add(componentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e54ccf8d527e4ff3$var$A2UIComponentErrorBoundary, {
        componentId: componentId,
        type: definition.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        definition: definition,
        visited: nextVisited
    }));
};
// Register self for useChildren hook
(0, $520d5d995c5e1183$export$cb0d9965b2bc5783)($e54ccf8d527e4ff3$export$b2bae32360e4c19f); // Per-component error boundary
const $e54ccf8d527e4ff3$var$A2UIComponentErrorBoundary = ({ children: children, componentId: componentId, type: type })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ({ error: error })=>{
            const errorMessage = error instanceof Error ? error.message : String(error);
            const renderErrorTitle = `${type} (${componentId}) failed to render:`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e54ccf8d527e4ff3$var$styles.errorFallback)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "span",
                weight: "bold"
            }, renderErrorTitle), ' ', errorMessage);
        },
        resetKeys: [
            componentId,
            type
        ]
    }, children);
};
const $e54ccf8d527e4ff3$export$dffab5a81d5c7692 = ({ rootId: rootId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e54ccf8d527e4ff3$export$b2bae32360e4c19f, {
        componentId: rootId
    });
}; // Hook to ensure component renderer is registered (call once in Surface)
function $e54ccf8d527e4ff3$export$c8942dce5887b9f7() {
    (0, $cozmU.useEffect)(()=>{
        (0, $520d5d995c5e1183$export$cb0d9965b2bc5783)($e54ccf8d527e4ff3$export$b2bae32360e4c19f);
    }, []);
}


// useReducer-based surface state: component map + data model
// Reactive data store with JSON Pointer-based path subscriptions

function $25da086a3b969bfb$var$deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $25da086a3b969bfb$export$8231b3dacf8346df(initialData = {}) {
    let data = $25da086a3b969bfb$var$deepClone(initialData);
    const listeners = new Map();
    function notifyListeners(changedPath, value) {
        // Notify exact match
        const exact = listeners.get(changedPath);
        if (exact) for (const listener of exact)listener(changedPath, value);
        // Notify ancestor paths (parent data changed)
        for (const [subscribedPath, subs] of listeners){
            if (subscribedPath === changedPath) continue;
            // If the changed path is a parent of the subscribed path, notify with the sub-value
            if (subscribedPath.startsWith(changedPath + '/') || changedPath === '') {
                const subValue = (0, $3518e48f06d57e36$export$884a23bfca63cd9e)(data, subscribedPath);
                for (const listener of subs)listener(subscribedPath, subValue);
            }
            // If the changed path is a child of the subscribed path, notify the parent
            if (changedPath.startsWith(subscribedPath + '/') || subscribedPath === '') {
                const parentValue = (0, $3518e48f06d57e36$export$884a23bfca63cd9e)(data, subscribedPath);
                for (const listener of subs)listener(subscribedPath, parentValue);
            }
        }
    }
    return {
        get (path) {
            if (path === '' || path === '/') return path === '' ? data : data;
            return (0, $3518e48f06d57e36$export$884a23bfca63cd9e)(data, path);
        },
        set (path, value) {
            data = (0, $3518e48f06d57e36$export$cdccb0ccb22298cb)(data, path, value);
            notifyListeners(path, value);
        },
        remove (path) {
            data = (0, $3518e48f06d57e36$export$ed753d721d7b171)(data, path);
            notifyListeners(path, undefined);
        },
        subscribe (path, listener) {
            if (!listeners.has(path)) listeners.set(path, new Set());
            listeners.get(path).add(listener);
            return ()=>{
                const subs = listeners.get(path);
                if (subs) {
                    subs.delete(listener);
                    if (subs.size === 0) listeners.delete(path);
                }
            };
        },
        snapshot () {
            return $25da086a3b969bfb$var$deepClone(data);
        },
        reset (newData) {
            data = $25da086a3b969bfb$var$deepClone(newData);
            notifyListeners('', data);
        }
    };
}


function $99260d0c6fb7d3a5$export$e62e706159782679() {
    return {
        surfaceId: null,
        catalogId: null,
        rootId: null,
        componentMap: new Map(),
        dataModel: (0, $25da086a3b969bfb$export$8231b3dacf8346df)()
    };
}
function $99260d0c6fb7d3a5$export$323d5bcaa0431930(state, action) {
    switch(action.type){
        case 'CREATE_SURFACE':
            {
                const componentMap = new Map();
                for (const component of action.components)componentMap.set(component.id, component);
                const dataModel = (0, $25da086a3b969bfb$export$8231b3dacf8346df)(action.dataModel ?? {});
                return {
                    surfaceId: action.surfaceId,
                    catalogId: action.catalogId,
                    rootId: action.rootId,
                    componentMap: componentMap,
                    dataModel: dataModel
                };
            }
        case 'INIT_SURFACE':
            // v0.8 beginRendering — set surface metadata without replacing componentMap or dataModel
            return {
                ...state,
                surfaceId: action.surfaceId,
                catalogId: action.catalogId ?? state.catalogId,
                rootId: action.rootId
            };
        case 'UPDATE_COMPONENTS':
            {
                const componentMap = new Map(state.componentMap);
                for (const component of action.components)componentMap.set(component.id, component);
                return {
                    ...state,
                    componentMap: componentMap
                };
            }
        case 'UPDATE_DATA_MODEL':
            for (const op of action.operations)if (op.op === 'remove') state.dataModel.remove(op.path);
            else state.dataModel.set(op.path, op.value);
            // Return same state ref — dataModel is mutable, components re-render via subscriptions
            return state;
        case 'DELETE_SURFACE':
            return $99260d0c6fb7d3a5$export$e62e706159782679();
        default:
            return state;
    }
}


const $283776c660887d3a$export$8a30297eac7fdf0f = ({ messages: messages, onAction: onAction, testId: testId })=>{
    // Ensure component renderers are registered before first render
    (0, $63ca1ad235916b5f$export$d252b6a36f07590)();
    const [state, dispatch] = (0, $cozmU.useReducer)((0, $99260d0c6fb7d3a5$export$323d5bcaa0431930), undefined, (0, $99260d0c6fb7d3a5$export$e62e706159782679));
    const [processingError, setProcessingError] = (0, $cozmU.useState)(null);
    const processedCountRef = (0, $cozmU.useRef)(0);
    // Process new messages incrementally
    (0, $cozmU.useEffect)(()=>{
        setProcessingError(null);
        const startIndex = processedCountRef.current;
        for(let i = startIndex; i < messages.length; i++)try {
            const action = (0, $0f13090a4f991832$export$23012ff6b17999d5)(messages[i]);
            dispatch(action);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            setProcessingError(`Failed to process message #${i}: ${message}`);
            break;
        }
        processedCountRef.current = messages.length;
    }, [
        messages
    ]);
    if (processingError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `${testId ?? 'a2ui-surface'}-processing-error`
    }, processingError);
    // Don't render until we have a surface
    if (!state.surfaceId || !state.rootId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a79b866aed66492f$export$1ca2a26fecb070ae).Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            onAction: onAction
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baaab813a53ae29e$export$58d75f9829cbe158).Provider, {
        value: {
            basePath: ''
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e54ccf8d527e4ff3$export$dffab5a81d5c7692), {
        rootId: state.rootId
    }))));
};












var $fIbhb = parcelRequire("fIbhb");


var $gj7Xh = parcelRequire("gj7Xh");

// In the connected-state variant each row derives its Connect/Connected state
// from the connectors store (`isUserOAuthed`), so there is nothing to do on a
// successful connect here. A stable module-level no-op satisfies the required
// prop without changing identity per render (which would churn the row's OAuth
// handler memo).
const $149e037899563e0b$var$noop = ()=>{};
const $149e037899563e0b$export$b06928cc12e793b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { apps: apps } = t0;
    const { hideBanner: hideBanner } = (0, $fIbhb.useAppConnectionBannerActions)();
    if (apps.length === 0) return null;
    let t1;
    if ($[0] !== apps || $[1] !== hideBanner) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj7Xh.AppConnectionBanner), {
            unconnectedApps: apps,
            showConnectedState: true,
            onConnect: $149e037899563e0b$var$noop,
            onDismiss: hideBanner
        });
        $[0] = apps;
        $[1] = hideBanner;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ apps: apps })=>{
    const { hideBanner: hideBanner } = (0, $fIbhb.useAppConnectionBannerActions)();
    if (apps.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj7Xh.AppConnectionBanner), {
        unconnectedApps: apps,
        showConnectedState: true,
        onConnect: $149e037899563e0b$var$noop,
        onDismiss: hideBanner
    });
};



var $aQWBL = parcelRequire("aQWBL");





var $lTaB7 = parcelRequire("lTaB7");



















const $29db3342b7552f6d$export$e119872ad3ffc5 = (agent)=>{
    if (!(0, $iDrrr.fg)('rovo_marathon_as_agent_enabled')) return false;
    return agent?.execution_config?.execution_tier === 'TIER_2' || false;
};












var $foVqg = parcelRequire("foVqg");






















// Offset to keep the last line of the user message visible when scrolling to assistant message
const $64475aea4a0133e9$var$USER_MESSAGE_VISIBLE_OFFSET = 48;
const $64475aea4a0133e9$var$setMinHeight = (element, minHeight, messageElementRef)=>{
    element.style.setProperty('--smooth-scroll-min-height', `${minHeight}px`);
    element.style.minHeight = `var(--smooth-scroll-min-height)`;
    element.setAttribute('data-smooth-scroll-min-height', 'true');
    if (messageElementRef) messageElementRef.current = element;
};
const $64475aea4a0133e9$var$removeMinHeight = (element, messageElementRef)=>{
    element.style.removeProperty('--smooth-scroll-min-height');
    element.style.removeProperty('min-height');
    element.removeAttribute('data-smooth-scroll-min-height');
    if (messageElementRef?.current === element) messageElementRef.current = null;
};
const $64475aea4a0133e9$export$c2131e938c7a933c = ({ containerRef: containerRef })=>{
    const messageElementRef = (0, $cozmU.useRef)(null);
    const container = containerRef.current;
    // Automatically remove min-height as content grows naturally
    (0, $cozmU.useEffect)(()=>{
        if (!container) return;
        const resizeObserver = new ResizeObserver(()=>{
            const messageElement = container.querySelector('[data-smooth-scroll-min-height]');
            if (!messageElement) return;
            const requiredHeight = messageElement.offsetTop + container.clientHeight;
            if (container.scrollHeight >= requiredHeight) $64475aea4a0133e9$var$removeMinHeight(messageElement, messageElementRef);
        });
        resizeObserver.observe(container);
        return ()=>resizeObserver.disconnect();
    }, [
        container
    ]);
    const scrollToBottom = (0, $cozmU.useCallback)(({ smooth: smooth })=>{
        requestAnimationFrame(()=>{
            if (container) container.scrollTo({
                top: container.scrollHeight,
                behavior: smooth ? 'smooth' : 'instant'
            });
        });
    }, [
        container
    ]);
    const scrollToLatestMessage = (0, $cozmU.useCallback)(({ smooth: smooth_0 })=>{
        requestAnimationFrame(()=>{
            if (!container) return;
            const messages = container.querySelectorAll('[data-scroll-anchor="assistant-message"]');
            const assistantMessage = messages[messages.length - 1];
            if (!assistantMessage) return;
            // Calculate scroll position to align element with top of container, offset to show the last line of the user message
            const containerRect = container.getBoundingClientRect();
            const elementRect = assistantMessage.getBoundingClientRect();
            const targetScrollTop = container.scrollTop + (elementRect.top - containerRect.top) - $64475aea4a0133e9$var$USER_MESSAGE_VISIBLE_OFFSET;
            // Calculate required content height and adjust min-height if needed
            const requiredHeight_0 = targetScrollTop + container.clientHeight;
            const currentHeight = container.scrollHeight;
            if (requiredHeight_0 > currentHeight) {
                const additionalSpace = requiredHeight_0 - currentHeight;
                $64475aea4a0133e9$var$setMinHeight(assistantMessage, assistantMessage.offsetHeight + additionalSpace, messageElementRef);
            } else if (messageElementRef.current === assistantMessage && assistantMessage.hasAttribute('data-smooth-scroll-min-height')) $64475aea4a0133e9$var$removeMinHeight(assistantMessage, messageElementRef);
            container.scrollTo({
                top: targetScrollTop,
                behavior: smooth_0 ? 'smooth' : 'instant'
            });
        });
    }, [
        container
    ]);
    const maintainScrollHeight = (0, $cozmU.useCallback)(()=>{
        requestAnimationFrame(()=>{
            if (!container) return;
            const messageElement_0 = container.querySelector('[data-smooth-scroll-min-height]');
            if (!messageElement_0) return;
            // Calculate the height difference before and after removing min-height on the
            // message element to apply to either the follow up or error message element
            const heightBefore = container.scrollHeight;
            const afterMessageElement = container.querySelector('[data-scroll-anchor="follow-up-message"], [data-scroll-anchor="error-message"]');
            $64475aea4a0133e9$var$removeMinHeight(messageElement_0);
            const heightAfter = container.scrollHeight;
            const heightDifference = heightBefore - heightAfter;
            if (afterMessageElement && heightDifference > 0) {
                const currentHeight_0 = afterMessageElement.offsetHeight;
                $64475aea4a0133e9$var$setMinHeight(afterMessageElement, currentHeight_0 + heightDifference, messageElementRef);
            } else if (messageElementRef.current === messageElement_0) messageElementRef.current = afterMessageElement || null;
        });
    }, [
        container
    ]);
    return {
        scrollToBottom: scrollToBottom,
        scrollToLatestMessage: scrollToLatestMessage,
        maintainScrollHeight: maintainScrollHeight
    };
};



var $dftWP = parcelRequire("dftWP");





var $dplZo = parcelRequire("dplZo");




const $878c332809fd002c$export$64b659acaa4349f2 = (0, $kSwu1.defineMessages)({
    rovoDefault1: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault1",
        defaultMessage: "Thinking"
    },
    rovoDefault2: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault2",
        defaultMessage: "Connecting dots"
    },
    rovoDefault3: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault3",
        defaultMessage: "Pulling threads"
    },
    rovoDefault4: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault4",
        defaultMessage: "Dialing in"
    },
    rovoDefault5: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault5",
        defaultMessage: "Spooling thoughts"
    },
    rovoDefault6: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault6",
        defaultMessage: "Preparing"
    },
    rovoDefault7: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault7",
        defaultMessage: "Humming"
    },
    rovoDefault8: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault8",
        defaultMessage: "Crystallizing"
    },
    rovoDefault9: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault9",
        defaultMessage: "Coalescing"
    },
    rovoDefault10: {
        id: "rovo-personalization.personality-thinking-verb.rovoDefault10",
        defaultMessage: "Gathering context"
    },
    professional1: {
        id: "rovo-personalization.personality-thinking-verb.professional1",
        defaultMessage: "Reviewing"
    },
    professional2: {
        id: "rovo-personalization.personality-thinking-verb.professional2",
        defaultMessage: "Checking sources"
    },
    professional3: {
        id: "rovo-personalization.personality-thinking-verb.professional3",
        defaultMessage: "Analyzing"
    },
    professional4: {
        id: "rovo-personalization.personality-thinking-verb.professional4",
        defaultMessage: "Organizing"
    },
    professional5: {
        id: "rovo-personalization.personality-thinking-verb.professional5",
        defaultMessage: "Evaluating"
    },
    professional6: {
        id: "rovo-personalization.personality-thinking-verb.professional6",
        defaultMessage: "Verifying"
    },
    professional7: {
        id: "rovo-personalization.personality-thinking-verb.professional7",
        defaultMessage: "Prioritizing"
    },
    professional8: {
        id: "rovo-personalization.personality-thinking-verb.professional8",
        defaultMessage: "Refining"
    },
    professional9: {
        id: "rovo-personalization.personality-thinking-verb.professional9",
        defaultMessage: "Assessing"
    },
    professional10: {
        id: "rovo-personalization.personality-thinking-verb.professional10",
        defaultMessage: "Validating"
    },
    professional11: {
        id: "rovo-personalization.personality-thinking-verb.professional11",
        defaultMessage: "Synthesizing"
    },
    professional12: {
        id: "rovo-personalization.personality-thinking-verb.professional12",
        defaultMessage: "Preparing"
    },
    empathetic1: {
        id: "rovo-personalization.personality-thinking-verb.empathetic1",
        defaultMessage: "Considering"
    },
    empathetic2: {
        id: "rovo-personalization.personality-thinking-verb.empathetic2",
        defaultMessage: "Clarifying"
    },
    empathetic3: {
        id: "rovo-personalization.personality-thinking-verb.empathetic3",
        defaultMessage: "Getting clarity"
    },
    empathetic4: {
        id: "rovo-personalization.personality-thinking-verb.empathetic4",
        defaultMessage: "Reframing"
    },
    empathetic5: {
        id: "rovo-personalization.personality-thinking-verb.empathetic5",
        defaultMessage: "Balancing"
    },
    empathetic6: {
        id: "rovo-personalization.personality-thinking-verb.empathetic6",
        defaultMessage: "Guiding"
    },
    empathetic7: {
        id: "rovo-personalization.personality-thinking-verb.empathetic7",
        defaultMessage: "Grounding"
    },
    empathetic8: {
        id: "rovo-personalization.personality-thinking-verb.empathetic8",
        defaultMessage: "Untangling"
    },
    creative1: {
        id: "rovo-personalization.personality-thinking-verb.creative1",
        defaultMessage: "Discombobulating"
    },
    creative2: {
        id: "rovo-personalization.personality-thinking-verb.creative2",
        defaultMessage: "Shimmering"
    },
    creative3: {
        id: "rovo-personalization.personality-thinking-verb.creative3",
        defaultMessage: "Spindling"
    },
    creative4: {
        id: "rovo-personalization.personality-thinking-verb.creative4",
        defaultMessage: "Thinking brilliantly"
    },
    creative5: {
        id: "rovo-personalization.personality-thinking-verb.creative5",
        defaultMessage: "Nudging neurons"
    },
    creative6: {
        id: "rovo-personalization.personality-thinking-verb.creative6",
        defaultMessage: "Sparking ideas"
    },
    creative7: {
        id: "rovo-personalization.personality-thinking-verb.creative7",
        defaultMessage: "Percolating"
    },
    creative8: {
        id: "rovo-personalization.personality-thinking-verb.creative8",
        defaultMessage: "Ruminating"
    },
    creative9: {
        id: "rovo-personalization.personality-thinking-verb.creative9",
        defaultMessage: "Weaving solutions"
    },
    creative10: {
        id: "rovo-personalization.personality-thinking-verb.creative10",
        defaultMessage: "Juggling options"
    },
    creative11: {
        id: "rovo-personalization.personality-thinking-verb.creative11",
        defaultMessage: "Peeking ahead"
    }
});


// Message keys are `<tonePrefix><n>`; grouping by prefix yields each set. The
// tone prefixes are mutually non-overlapping, so `startsWith` is unambiguous.
const $2d441aec87016aa7$var$pick = (prefix)=>Object.entries((0, $878c332809fd002c$export$64b659acaa4349f2)).filter(([key])=>key.startsWith(prefix)).map(([, descriptor])=>descriptor);
const $2d441aec87016aa7$export$5b59304cc75bafee = {
    rovo_default: $2d441aec87016aa7$var$pick('rovoDefault'),
    professional: $2d441aec87016aa7$var$pick('professional'),
    creative: $2d441aec87016aa7$var$pick('creative'),
    empathetic: $2d441aec87016aa7$var$pick('empathetic')
};


/** Stable, well-distributed string hash (djb2). Used to pick a verb per spell. */ const $c85048001c25be99$var$hashString = (value)=>{
    let hash = 5381;
    for(let i = 0; i < value.length; i++)hash = hash * 33 ^ value.charCodeAt(i);
    // Coerce to a non-negative 32-bit integer.
    return hash >>> 0;
};
const $c85048001c25be99$export$5ff880ed6740bd17 = ({ enabled: enabled, spellId: spellId, assistanceServiceParams: assistanceServiceParams })=>{
    // Double-gated: the feature-level Personality Presets experiment AND the
    // surface-specific thinking-verb experiment. Read each once — repeat calls
    // double-count exposure. The surface experiment stays last in the `&&`
    // (no-preconditioning): its exposure fires only for the presets-eligible
    // population.
    const gateEnabled = enabled && spellId !== undefined && (0, $4o0zT.isExperimentEnabled)('rovo_chat_personality_presets') && (0, $4o0zT.isExperimentEnabled)('rovo_chat_personality_thinking_verb');
    const { responseStyle: responseStyle, isLoading: isLoading } = (0, $dplZo.useResponseStyleSettings)({
        assistanceServiceParams: assistanceServiceParams
    });
    if (!gateEnabled || isLoading || spellId === undefined) return {
        verbMessage: undefined
    };
    const set = (0, $2d441aec87016aa7$export$5b59304cc75bafee)[responseStyle.responseTone] ?? [];
    if (set.length === 0) return {
        verbMessage: undefined
    };
    return {
        verbMessage: set[$c85048001c25be99$var$hashString(spellId) % set.length]
    };
};
















































































const $6446b8cbdc9a5da7$var$styles = {
    root: "_2sNsIgmnOE _39xV02N91d _17lj8p1Y8M _37wbyuchRC _1UtDYzZpcK",
    titleContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0bjKvDKTcp _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r22ADO _1Znuxb2ADO _2Zuz6Q2ADO _1wydGW2ADO",
    iconContainer: "_0Of8r22ADO _313842FQfX _3iDTPbQ4SZ _0aFT5vbt8w",
    contentContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0aFT5vbt8w",
    verticalRule: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _39xV02dnbC _4kiQYAxpxF _3iDTPbQ4SZ _2XsHFM2ADO _0adFHs2ADO _3138422ADO",
    loadingStepIconPlaceholder: "_39xV02SPN1"
};
const $6446b8cbdc9a5da7$export$6e706d1f753e28ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { testId: testId, children: children, xcss: xcss, status: status, isLastItem: isLastItem } = t0;
    let t1;
    if ($[0] !== xcss) {
        t1 = (0, $w6R6I.cx)($6446b8cbdc9a5da7$var$styles.root, xcss);
        $[0] = xcss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== status) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16197e1e18275c50$export$b4f88f0ca5784eef), {
            status: status
        });
        $[2] = status;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isLastItem) {
        t3 = !isLastItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6446b8cbdc9a5da7$var$styles.verticalRule
        });
        $[4] = isLastItem;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6446b8cbdc9a5da7$var$styles.iconContainer
        }, t2, t3);
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== children) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6446b8cbdc9a5da7$var$styles.contentContainer
        }, children);
        $[9] = children;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t1 || $[12] !== t4 || $[13] !== t5 || $[14] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: t1,
            testId: testId
        }, t4, t5);
        $[11] = t1;
        $[12] = t4;
        $[13] = t5;
        $[14] = testId;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ testId: testId, children: children, xcss: xcss, status: status, isLastItem: isLastItem })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($6446b8cbdc9a5da7$var$styles.root, xcss),
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6446b8cbdc9a5da7$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16197e1e18275c50$export$b4f88f0ca5784eef), {
        status: status
    }), !isLastItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6446b8cbdc9a5da7$var$styles.verticalRule
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6446b8cbdc9a5da7$var$styles.contentContainer
    }, children));
};
const $6446b8cbdc9a5da7$export$179b516a1b61c27 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { title: title } = t0;
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6446b8cbdc9a5da7$var$styles.titleContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text.subtle"
        }, title));
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6446b8cbdc9a5da7$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, title));
};
const $6446b8cbdc9a5da7$export$ed7124825ced7ddc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { title: title, testId: t1, isLastItem: t2, status: status, placeholder: placeholder } = t0;
    const testId = t1 === undefined ? "rovo-loading-step" : t1;
    const isLastItem = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== isLastItem || $[1] !== placeholder || $[2] !== status || $[3] !== testId || $[4] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            duration: "large",
            entranceDirection: "bottom"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6446b8cbdc9a5da7$export$6e706d1f753e28ed, {
                testId: testId,
                status: status,
                isLastItem: isLastItem
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "row"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6446b8cbdc9a5da7$export$179b516a1b61c27, {
                title: title
            }), placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $6446b8cbdc9a5da7$var$styles.loadingStepIconPlaceholder
            })))));
        $[0] = isLastItem;
        $[1] = placeholder;
        $[2] = status;
        $[3] = testId;
        $[4] = title;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ title: title, testId: testId = 'rovo-loading-step', isLastItem: isLastItem = false, status: status, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        duration: "large",
        entranceDirection: "bottom"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6446b8cbdc9a5da7$export$6e706d1f753e28ed, {
            testId: testId,
            status: status,
            isLastItem: isLastItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6446b8cbdc9a5da7$export$179b516a1b61c27, {
            title: title
        }), placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6446b8cbdc9a5da7$var$styles.loadingStepIconPlaceholder
        })))));
};





const $25923c54d43f9af5$var$message = (0, $kSwu1.defineMessages)({
    expandIconLabel: {
        id: "ai-mate.chat-history.loading-state.expand-icon",
        defaultMessage: "Expand"
    },
    collapseIconLabel: {
        id: "ai-mate.chat-history.loading-state.collapse-icon",
        defaultMessage: "Collapse"
    }
});
var $25923c54d43f9af5$export$2e2bcd8739ae039 = $25923c54d43f9af5$var$message;


const $c6f97aa215ca88dd$var$styles = {
    titleContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0bjKvDKTcp _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d _0KLXrujOvk _2fwxA5ecOK",
    expandablePressable: "_23rrnHNQBp _4kiQYAUofl _1eOmH6o126 _0ReiIH7zJH",
    chevronContainer: "_0adFHs2ADO",
    expandedContent: "_39xV02N91d _0Of8r22ADO _1Znuxb2ADO _1wydGW1Y8M _2Zuz6Q2ADO _3W2Oc8wPeg"
};
const $c6f97aa215ca88dd$export$aa6e6454f6f47e48 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { title: title, onClick: onClick, testId: t1, isExpanded: t2, isLastItem: t3, status: status, children: children, onExpand: onExpand } = t0;
    const testId = t1 === undefined ? "rovo-expandable-step" : t1;
    const isExpanded = t2 === undefined ? false : t2;
    const isLastItem = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $w6R6I.cx)($c6f97aa215ca88dd$var$styles.titleContainer, $c6f97aa215ca88dd$var$styles.expandablePressable);
        $[0] = t4;
    } else t4 = $[0];
    let t5;
    if ($[1] !== isExpanded || $[2] !== onClick || $[3] !== onExpand) {
        t5 = ()=>{
            onClick();
            onExpand?.(!isExpanded);
        };
        $[1] = isExpanded;
        $[2] = onClick;
        $[3] = onExpand;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== title) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $6446b8cbdc9a5da7$export$179b516a1b61c27), {
            title: title
        }));
        $[5] = title;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== formatMessage || $[8] !== isExpanded) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c6f97aa215ca88dd$var$styles.chevronContainer
        }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $25923c54d43f9af5$export$2e2bcd8739ae039).collapseIconLabel),
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: formatMessage((0, $25923c54d43f9af5$export$2e2bcd8739ae039).expandIconLabel),
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[7] = formatMessage;
        $[8] = isExpanded;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== isExpanded || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== testId) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: t4,
            testId: testId,
            onClick: t5,
            "data-expanded": isExpanded
        }, t6, t7);
        $[10] = isExpanded;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = testId;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== children || $[17] !== isExpanded) {
        t9 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: "top",
            exitDirection: "top",
            duration: "medium"
        }, (motionProps)=>/*#__PURE__*/ $cozmU.createElement("div", motionProps, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c6f97aa215ca88dd$var$styles.expandedContent
            }, children)));
        $[16] = children;
        $[17] = isExpanded;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, t9);
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isLastItem || $[22] !== status || $[23] !== t10 || $[24] !== t8 || $[25] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $6446b8cbdc9a5da7$export$6e706d1f753e28ed), {
            testId: testId,
            status: status,
            isLastItem: isLastItem
        }, t8, t10);
        $[21] = isLastItem;
        $[22] = status;
        $[23] = t10;
        $[24] = t8;
        $[25] = testId;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ({ title: title, onClick: onClick, testId: testId = 'rovo-expandable-step', isExpanded: isExpanded = false, isLastItem: isLastItem = false, status: status, children: children, onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $6446b8cbdc9a5da7$export$6e706d1f753e28ed), {
        testId: testId,
        status: status,
        isLastItem: isLastItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($c6f97aa215ca88dd$var$styles.titleContainer, $c6f97aa215ca88dd$var$styles.expandablePressable),
        testId: testId,
        onClick: ()=>{
            onClick();
            onExpand?.(!isExpanded);
        },
        "data-expanded": isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $6446b8cbdc9a5da7$export$179b516a1b61c27), {
        title: title
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c6f97aa215ca88dd$var$styles.chevronContainer
    }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $25923c54d43f9af5$export$2e2bcd8739ae039).collapseIconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $25923c54d43f9af5$export$2e2bcd8739ae039).expandIconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: "top",
        exitDirection: "top",
        duration: "medium"
    }, (motionProps)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", motionProps, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c6f97aa215ca88dd$var$styles.expandedContent
        }, children));
    })));
};




var $2diYd = parcelRequire("2diYd");

const $dbe369e2a348fc0c$var$isForgeAgent = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar');
const $dbe369e2a348fc0c$var$styles = {
    container: "",
    stepContainerWithIndicator: "_2XsHFMS40j",
    stepContainerWithoutIndicator: "_2XsHFM2ADO"
};
const $dbe369e2a348fc0c$var$ExpandableTraceItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { trace: trace, isLastItem: isLastItem, placeholder: t1, onTraceInteraction: onTraceInteraction } = t0;
    const placeholder = t1 === undefined ? false : t1;
    const { title: title, defaultExpanded: t2, content: t3, status: status } = trace;
    const defaultExpanded = t2 === undefined ? false : t2;
    const content = t3 === undefined ? null : t3;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsExpanded($dbe369e2a348fc0c$var$_temp);
        };
        $[0] = t4;
    } else t4 = $[0];
    const setIsExpandedValue = t4;
    let t5;
    if ($[1] !== isLastItem || $[2] !== status || $[3] !== title) {
        t5 = {
            title: title,
            isLastItem: isLastItem,
            status: status
        };
        $[1] = isLastItem;
        $[2] = status;
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    const commonProps = t5;
    let t6;
    if ($[5] !== commonProps || $[6] !== content || $[7] !== isExpanded || $[8] !== onTraceInteraction || $[9] !== placeholder) {
        t6 = content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6f97aa215ca88dd$export$aa6e6454f6f47e48), {
            isExpanded: isExpanded,
            onClick: setIsExpandedValue,
            onExpand: (expanded)=>onTraceInteraction?.({
                    type: "singleTraceExpandable",
                    expanded: expanded
                }),
            ...commonProps
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6446b8cbdc9a5da7$export$ed7124825ced7ddc), {
            ...commonProps,
            placeholder: placeholder
        });
        $[5] = commonProps;
        $[6] = content;
        $[7] = isExpanded;
        $[8] = onTraceInteraction;
        $[9] = placeholder;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ trace: trace, isLastItem: isLastItem, placeholder: placeholder = false, onTraceInteraction: onTraceInteraction })=>{
    const { title: title, defaultExpanded: defaultExpanded = false, content: content = null, status: status } = trace;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const setIsExpandedValue = (0, $cozmU.useCallback)(()=>{
        setIsExpanded((prev)=>!prev);
    }, [
        setIsExpanded
    ]);
    const commonProps = {
        title: title,
        isLastItem: isLastItem,
        status: status
    };
    return content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6f97aa215ca88dd$export$aa6e6454f6f47e48), {
        isExpanded: isExpanded,
        onClick: setIsExpandedValue,
        onExpand: (expanded)=>onTraceInteraction?.({
                type: 'singleTraceExpandable',
                expanded: expanded
            }),
        ...commonProps
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6446b8cbdc9a5da7$export$ed7124825ced7ddc), {
        ...commonProps,
        placeholder: placeholder
    });
};
const $dbe369e2a348fc0c$export$1e7724c434f1ba76 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    let agent;
    let disableAnimation;
    let onTraceInteraction;
    let props;
    let showDefaultIconProp;
    let t1;
    let t2;
    let traces;
    if ($[0] !== t0) {
        ({ traces: traces, disableAnimation: disableAnimation, agent: agent, hideThinkingIndicator: t1, showDefaultIcon: showDefaultIconProp, animation: t2, onTraceInteraction: onTraceInteraction, ...props } = t0);
        $[0] = t0;
        $[1] = agent;
        $[2] = disableAnimation;
        $[3] = onTraceInteraction;
        $[4] = props;
        $[5] = showDefaultIconProp;
        $[6] = t1;
        $[7] = t2;
        $[8] = traces;
    } else {
        agent = $[1];
        disableAnimation = $[2];
        onTraceInteraction = $[3];
        props = $[4];
        showDefaultIconProp = $[5];
        t1 = $[6];
        t2 = $[7];
        traces = $[8];
    }
    const hideThinkingIndicator = t1 === undefined ? false : t1;
    const animation = t2 === undefined ? false : t2;
    const thinkingText = props.thinkingText ?? "";
    const showDefaultIcon = showDefaultIconProp ?? animation;
    let t3;
    if ($[9] !== agent || $[10] !== showDefaultIcon) {
        t3 = agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            agentId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "small",
            showBorder: false,
            isForgeAgent: (0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : $dbe369e2a348fc0c$var$isForgeAgent(agent),
            forgeAgentIconUrl: agent.icon
        }) : showDefaultIcon;
        $[9] = agent;
        $[10] = showDefaultIcon;
        $[11] = t3;
    } else t3 = $[11];
    const agentAvatarOrHiddenOrDefault = t3;
    let t4;
    if ($[12] !== traces) {
        t4 = traces?.some($dbe369e2a348fc0c$var$_temp2);
        $[12] = traces;
        $[13] = t4;
    } else t4 = $[13];
    const needsPlaceholder = t4;
    const showThinkingIndicator = props.thinkingText && !hideThinkingIndicator;
    let t5;
    if ($[14] !== agentAvatarOrHiddenOrDefault || $[15] !== animation || $[16] !== disableAnimation || $[17] !== showThinkingIndicator || $[18] !== thinkingText) {
        t5 = showThinkingIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2diYd.RovoThinkingIndicator), {
            title: thinkingText,
            isAnimated: !disableAnimation,
            icon: agentAvatarOrHiddenOrDefault,
            animation: animation
        }) : null;
        $[14] = agentAvatarOrHiddenOrDefault;
        $[15] = animation;
        $[16] = disableAnimation;
        $[17] = showThinkingIndicator;
        $[18] = thinkingText;
        $[19] = t5;
    } else t5 = $[19];
    const t6 = !!showThinkingIndicator ? $dbe369e2a348fc0c$var$styles.stepContainerWithIndicator : $dbe369e2a348fc0c$var$styles.stepContainerWithoutIndicator;
    let t7;
    if ($[20] !== t6) {
        t7 = (0, $w6R6I.cx)(t6);
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== needsPlaceholder || $[23] !== onTraceInteraction || $[24] !== traces) {
        t8 = traces ? traces.map((trace, i)=>{
            const isLastItem = i === traces.length - 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dbe369e2a348fc0c$var$ExpandableTraceItem, {
                key: `${trace.title}-${trace.status}`,
                trace: trace,
                isLastItem: isLastItem,
                placeholder: needsPlaceholder,
                onTraceInteraction: onTraceInteraction
            });
        }) : null;
        $[22] = needsPlaceholder;
        $[23] = onTraceInteraction;
        $[24] = traces;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== t7 || $[27] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t7
        }, t8);
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== t5 || $[30] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dbe369e2a348fc0c$var$styles.container
        }, t5, t9);
        $[29] = t5;
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : ({ traces: traces, disableAnimation: disableAnimation, agent: agent, hideThinkingIndicator: hideThinkingIndicator = false, showDefaultIcon: showDefaultIconProp, animation: animation = false, onTraceInteraction: onTraceInteraction, ...props })=>{
    const thinkingText = props.thinkingText ?? ''; // When animation is enabled and no explicit showDefaultIcon was provided,
    // default to showing the icon so the morphing animation icon renders.
    const showDefaultIcon = showDefaultIconProp ?? animation;
    const agentAvatarOrHiddenOrDefault = agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : $dbe369e2a348fc0c$var$isForgeAgent(agent),
        forgeAgentIconUrl: agent.icon
    }) : showDefaultIcon;
    const needsPlaceholder = traces?.some((t)=>t.content);
    const showThinkingIndicator = props.thinkingText && !hideThinkingIndicator;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $dbe369e2a348fc0c$var$styles.container
    }, showThinkingIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2diYd.RovoThinkingIndicator), {
        title: thinkingText,
        isAnimated: !disableAnimation,
        icon: agentAvatarOrHiddenOrDefault,
        animation: animation
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!!showThinkingIndicator ? $dbe369e2a348fc0c$var$styles.stepContainerWithIndicator : $dbe369e2a348fc0c$var$styles.stepContainerWithoutIndicator)
    }, traces ? traces.map((trace, i)=>{
        const isLastItem = i === traces.length - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dbe369e2a348fc0c$var$ExpandableTraceItem, {
            key: `${trace.title}-${trace.status}`,
            trace: trace,
            isLastItem: isLastItem,
            placeholder: needsPlaceholder,
            onTraceInteraction: onTraceInteraction
        });
    }) : null));
};
function $dbe369e2a348fc0c$var$_temp(prev) {
    return !prev;
}
function $dbe369e2a348fc0c$var$_temp2(t) {
    return t.content;
}


/**
 * Skill registry tag used to fetch skills that appear in the Rovo prompt library / empty state actions.
 * Skills tagged with this in the integrations config registry will appear as skill actions with hover cards.
 */ const $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe = 'rovo-chat-prompt-gallery';















var $kyTdj = parcelRequire("kyTdj");

const $9b87174eb88b5e91$export$27d9050dbd34f414 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    const $ = (0, $bDgLe.c)(5);
    const [t0] = (0, $kyTdj.useAppConnectionBannerStore)();
    const { unconnectedApps: unconnectedApps, showConnectedState: showConnectedState } = t0;
    const [pinned, setPinned] = (0, $cozmU.useState)(null);
    let t1;
    let t2;
    if ($[0] !== conversationId || $[1] !== showConnectedState || $[2] !== unconnectedApps) {
        t1 = ()=>{
            if (!showConnectedState || unconnectedApps.length === 0) return;
            setPinned((previous)=>previous?.conversationId === conversationId ? previous : {
                    conversationId: conversationId,
                    apps: unconnectedApps
                });
        };
        t2 = [
            conversationId,
            showConnectedState,
            unconnectedApps
        ];
        $[0] = conversationId;
        $[1] = showConnectedState;
        $[2] = unconnectedApps;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return pinned?.conversationId === conversationId ? pinned.apps : null;
} : (conversationId)=>{
    const [{ unconnectedApps: unconnectedApps, showConnectedState: showConnectedState }] = (0, $kyTdj.useAppConnectionBannerStore)();
    const [pinned, setPinned] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!showConnectedState || unconnectedApps.length === 0) return;
        setPinned((previous)=>previous?.conversationId === conversationId ? previous : {
                conversationId: conversationId,
                apps: unconnectedApps
            });
    }, [
        conversationId,
        showConnectedState,
        unconnectedApps
    ]);
    return pinned?.conversationId === conversationId ? pinned.apps : null;
};


















var $7pCWA = parcelRequire("7pCWA");







const $6283699142f02f4d$var$messages = (0, $kSwu1.defineMessages)({
    connectorConnectedConfirmationLead: {
        id: "ai-mate.conversation-assistant.connection-prompt.connector-connected-confirmation-lead",
        defaultMessage: "{appName} is connected!"
    },
    connectorConnectedConfirmationBody: {
        id: "ai-mate.conversation-assistant.connection-prompt.connector-connected-confirmation-body",
        defaultMessage: "I am indexing your team\u2019s data so context can flow into your new docs automatically. This usually takes a few hours to fully set up. Need something right now? Paste a direct link and I\u2019ll use it instantly."
    }
});
const $6283699142f02f4d$export$f754cb3a41a8893e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { conversationId: conversationId, apps: apps } = t0;
    const [connectors] = (0, $7pCWA.useConnectors)();
    const { addAgentMessage: addAgentMessage } = (0, $3TxKn.useChatStoreActions)();
    const { addAppFilter: addAppFilter } = (0, $aJU2k.useChatModeStoreActions)();
    let t1;
    if ($[0] !== conversationId) {
        t1 = {
            conversationId: conversationId
        };
        $[0] = conversationId;
        $[1] = t1;
    } else t1 = $[1];
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)(t1);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[2] = t2;
    } else t2 = $[2];
    const prevOAuthedRef = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            prevOAuthedRef.current = {};
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== conversationId) {
        t4 = [
            conversationId
        ];
        $[4] = conversationId;
        $[5] = t4;
    } else t4 = $[5];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[6] !== addAgentMessage || $[7] !== addAppFilter || $[8] !== apps || $[9] !== connectors || $[10] !== conversation || $[11] !== conversationId || $[12] !== formatMessage || $[13] !== selectedAgent) {
        t5 = ()=>{
            if (apps.length === 0 || !conversation || !selectedAgent) return;
            for (const app of apps){
                const isOAuthed = Boolean(connectors[app.source]?.isUserOAuthed);
                const seenBefore = Object.prototype.hasOwnProperty.call(prevOAuthedRef.current, app.source);
                const wasOAuthed = Boolean(prevOAuthedRef.current[app.source]);
                if (seenBefore && isOAuthed && !wasOAuthed) {
                    const content = {
                        version: 1,
                        type: "doc",
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        type: "text",
                                        text: formatMessage($6283699142f02f4d$var$messages.connectorConnectedConfirmationLead, {
                                            appName: app.friendlyName
                                        }),
                                        marks: [
                                            {
                                                type: "strong"
                                            }
                                        ]
                                    },
                                    {
                                        type: "text",
                                        text: ` ${formatMessage($6283699142f02f4d$var$messages.connectorConnectedConfirmationBody)}`
                                    }
                                ]
                            }
                        ]
                    };
                    addAgentMessage({
                        conversationId: conversation.id,
                        agentNamedId: selectedAgent.named_id,
                        content: content
                    });
                    addAppFilter(conversationId, {
                        source: app.source,
                        friendlyName: app.friendlyName,
                        iconUrl: app.iconUrl
                    });
                }
            }
            const snapshot = {};
            for (const app_0 of apps)snapshot[app_0.source] = Boolean(connectors[app_0.source]?.isUserOAuthed);
            prevOAuthedRef.current = snapshot;
        };
        t6 = [
            conversationId,
            apps,
            connectors,
            conversation,
            selectedAgent,
            addAgentMessage,
            addAppFilter,
            formatMessage
        ];
        $[6] = addAgentMessage;
        $[7] = addAppFilter;
        $[8] = apps;
        $[9] = connectors;
        $[10] = conversation;
        $[11] = conversationId;
        $[12] = formatMessage;
        $[13] = selectedAgent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
} : ({ conversationId: conversationId, apps: apps })=>{
    const [connectors] = (0, $7pCWA.useConnectors)();
    const { addAgentMessage: addAgentMessage } = (0, $3TxKn.useChatStoreActions)();
    const { addAppFilter: addAppFilter } = (0, $aJU2k.useChatModeStoreActions)();
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Last-seen OAuth state per app source; presence of a key means "observed
    // before", so we can distinguish an initial reading from a real transition.
    const prevOAuthedRef = (0, $cozmU.useRef)({});
    // Drop the transition history when the conversation changes.
    (0, $cozmU.useEffect)(()=>{
        prevOAuthedRef.current = {};
    }, [
        conversationId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (apps.length === 0 || !conversation || !selectedAgent) return;
        for (const app of apps){
            const isOAuthed = Boolean(connectors[app.source]?.isUserOAuthed);
            const seenBefore = Object.prototype.hasOwnProperty.call(prevOAuthedRef.current, app.source);
            const wasOAuthed = Boolean(prevOAuthedRef.current[app.source]);
            if (seenBefore && isOAuthed && !wasOAuthed) {
                // ADF (not a plain string) so the lead sentence can be bold.
                const content = {
                    version: 1,
                    type: 'doc',
                    content: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: formatMessage($6283699142f02f4d$var$messages.connectorConnectedConfirmationLead, {
                                        appName: app.friendlyName
                                    }),
                                    marks: [
                                        {
                                            type: 'strong'
                                        }
                                    ]
                                },
                                {
                                    type: 'text',
                                    text: ` ${formatMessage($6283699142f02f4d$var$messages.connectorConnectedConfirmationBody)}`
                                }
                            ]
                        }
                    ]
                };
                addAgentMessage({
                    conversationId: conversation.id,
                    agentNamedId: selectedAgent.named_id,
                    content: content
                });
                // Keyed by `conversationId` (the prompt-input key the mode store uses),
                // not `conversation.id` above (the chat store's key). They match once the
                // conversation is persisted, which it always is here — the prompt only
                // renders after the first assistant response completes.
                addAppFilter(conversationId, {
                    source: app.source,
                    friendlyName: app.friendlyName,
                    iconUrl: app.iconUrl
                });
            }
        }
        const snapshot = {};
        for (const app_0 of apps)snapshot[app_0.source] = Boolean(connectors[app_0.source]?.isUserOAuthed);
        prevOAuthedRef.current = snapshot;
    }, [
        conversationId,
        apps,
        connectors,
        conversation,
        selectedAgent,
        addAgentMessage,
        addAppFilter,
        formatMessage
    ]);
};



var $gyWKg = parcelRequire("gyWKg");


var $idzM5 = parcelRequire("idzM5");

/** Display name used when the default Rovo Chat agent metadata is not available. */ const $d3ced1e712e9d684$export$e799f6dbcac057ae = 'Rovo';















var $3uG5w = parcelRequire("3uG5w");


var $jAQW4 = parcelRequire("jAQW4");

const $29a7474eaece6ae8$export$2f0833d20bbf4b1c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (onStaggeringAnimationTimeout)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== onStaggeringAnimationTimeout) {
        t0 = {
            delay: (0, $3uG5w.ANIMATION_TIMINGS).sidebarActions,
            onStaggeringAnimationTimeout: onStaggeringAnimationTimeout
        };
        $[0] = onStaggeringAnimationTimeout;
        $[1] = t0;
    } else t0 = $[1];
    return (0, $jAQW4.useStaggerAnimation)(t0);
} : (onStaggeringAnimationTimeout)=>{
    return (0, $jAQW4.useStaggerAnimation)({
        delay: (0, $3uG5w.ANIMATION_TIMINGS).sidebarActions,
        onStaggeringAnimationTimeout: onStaggeringAnimationTimeout
    });
};












var $guRLk = parcelRequire("guRLk");




const $9ea03bba7e791f40$export$3f094c9829c0e0cb = (research)=>!!research && (Object.keys(research.steps ?? {}).length > 0 || Object.keys(research.researchPlans ?? {}).length > 0);





/**
 * Returns the set of message IDs that have research data (steps or researchPlans).
 * This is a cheap O(n) derivation done once per store update rather than per-message
 * per-render, allowing chat-history to use a Set.has() lookup instead of calling
 * getMessageResearchById for every assistant message on every render.
 */ // Module-level cache so the selector can return a stable Set reference when
// membership is unchanged — react-sweet-state uses referential equality on selector
// output, so returning a new Set on every store update (e.g. a new streamed step for
// an existing message) would trigger a full ChatHistory re-render for every chunk.
let $82bc06d315ddae83$var$previousIds = new Set();
const $82bc06d315ddae83$export$629bc20f8bcb03d1 = (0, $kBr4q.createStateHook)((0, $bWJgt.store), {
    selector: (state)=>{
        // Iterate Object.keys to avoid the [key, value] tuple allocation from Object.entries.
        const keys = Object.keys(state);
        let changed = keys.length !== $82bc06d315ddae83$var$previousIds.size;
        const next = new Set();
        for (const messageId of keys)if ((0, $9ea03bba7e791f40$export$3f094c9829c0e0cb)(state[messageId])) {
            next.add(messageId);
            if (!$82bc06d315ddae83$var$previousIds.has(messageId)) changed = true;
        }
        // Also detect removals: a message ID was in previousIds but has no research data now.
        // This can happen if steps are emptied without deleting the store entry — in that case
        // keys.length === previousIds.size so the initial check doesn't catch it, and the loop
        // only detects additions (new IDs in next not in previousIds), not removals.
        if (!changed && $82bc06d315ddae83$var$previousIds.size !== next.size) changed = true;
        if (!changed) return $82bc06d315ddae83$var$previousIds;
        $82bc06d315ddae83$var$previousIds = next;
        return next;
    }
});











const $1f42c1717e380b47$export$38a52cc74adbed57 = (state, messageId)=>state[messageId];





const $0da647f75270b377$export$b5a7f8d4b73e48e1 = (0, $kBr4q.createHook)((0, $bWJgt.store), {
    selector: (0, $1f42c1717e380b47$export$38a52cc74adbed57)
});


const $2556adf63acd29a5$export$8ffe29bbe1f25b54 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { messageId: messageId } = t0;
    const [state] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    let t1;
    if ($[0] !== state?.researchPlans) {
        t1 = state?.researchPlans ?? {};
        $[0] = state?.researchPlans;
        $[1] = t1;
    } else t1 = $[1];
    const researchPlans = t1;
    let t2;
    if ($[2] !== state?.steps) {
        const steps = Object.values(state?.steps ?? {});
        t2 = steps.reduce($2556adf63acd29a5$var$_temp, {});
        $[2] = state?.steps;
        $[3] = t2;
    } else t2 = $[3];
    const stepsByRound = t2;
    let t3;
    let t4;
    let t5;
    if ($[4] !== researchPlans || $[5] !== state?.errored || $[6] !== state?.researchCompleted || $[7] !== stepsByRound) {
        const allRoundIds = [
            ...new Set([
                ...Object.keys(researchPlans).map(Number),
                ...Object.keys(stepsByRound).map(Number)
            ])
        ].sort($2556adf63acd29a5$var$_temp2);
        let t6;
        if ($[11] !== researchPlans || $[12] !== stepsByRound) {
            t6 = (roundId)=>({
                    roundId: roundId,
                    content: researchPlans[roundId]?.content,
                    hasRounds: stepsByRound[roundId]?.length > 0
                });
            $[11] = researchPlans;
            $[12] = stepsByRound;
            $[13] = t6;
        } else t6 = $[13];
        const rounds = allRoundIds.map(t6);
        t3 = rounds.length > 0 && !state?.errored && !state?.researchCompleted;
        t4 = rounds;
        t5 = allRoundIds.at(-1);
        $[4] = researchPlans;
        $[5] = state?.errored;
        $[6] = state?.researchCompleted;
        $[7] = stepsByRound;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = {
            isThinkingDeeperRunning: t3,
            rounds: t4,
            maxRoundId: t5
        };
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ messageId: messageId })=>{
    const [state] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    const researchPlans = state?.researchPlans ?? {};
    const steps = Object.values(state?.steps ?? {});
    const stepsByRound = steps.reduce((acc, step)=>{
        if (!acc[step.roundId]) acc[step.roundId] = [];
        acc[step.roundId].push(step);
        return acc;
    }, {});
    const allRoundIds = [
        ...new Set([
            ...Object.keys(researchPlans).map(Number),
            ...Object.keys(stepsByRound).map(Number)
        ])
    ].sort((a, b)=>a - b);
    const rounds = allRoundIds.map((roundId)=>{
        return {
            roundId: roundId,
            content: researchPlans[roundId]?.content,
            hasRounds: stepsByRound[roundId]?.length > 0
        };
    });
    return {
        isThinkingDeeperRunning: rounds.length > 0 && !state?.errored && !state?.researchCompleted,
        rounds: rounds,
        maxRoundId: allRoundIds.at(-1)
    };
};
function $2556adf63acd29a5$var$_temp(acc, step) {
    if (!acc[step.roundId]) acc[step.roundId] = [];
    acc[step.roundId].push(step);
    return acc;
}
function $2556adf63acd29a5$var$_temp2(a, b) {
    return a - b;
}



var $jcJSP = parcelRequire("jcJSP");


var $bFeyZ = parcelRequire("bFeyZ");


var $iEKWu = parcelRequire("iEKWu");




















var $i7OAD = parcelRequire("i7OAD");




const $c0615b1dc7201798$export$25e70ece93417f09 = (message)=>Boolean(message && (0, $igOtY.isStoreAssistant)(message) && message.content.message.message.actions?.some((action)=>action.status?.toLowerCase() === 'streaming' && (0, $i7OAD.isAIFCAction)(action)) && (0, $iDrrr.fg)('aifc_trace_text_updates'));








// Filter that removes "Action executed" messages from being displayed to users (by leveraging message metadata, not content)
const $f6db5428181909aa$var$aifcActionExecutionMessageFilter = (msg)=>{
    const assistantMessageMetadata = ('content' in msg ? msg.content : undefined)?.message?.message?.message_metadata;
    const actionKey = assistantMessageMetadata?.key;
    const shouldFilterOut = (0, $igOtY.isStoreAssistant)(msg) && assistantMessageMetadata?.is_action_execution === true && actionKey && (0, $i7OAD.isAIFCAction)({
        key: actionKey
    });
    return !shouldFilterOut;
};
// FOR DEVELOPERS: Add message filter functions to this array. Functions should return true to keep the message, false to filter it out.
const $f6db5428181909aa$var$MESSAGE_FILTERS = [
    $f6db5428181909aa$var$aifcActionExecutionMessageFilter
];
const $f6db5428181909aa$export$c9b026fc0258459 = (messages)=>{
    return messages.filter((message)=>{
        return $f6db5428181909aa$var$MESSAGE_FILTERS.every((filter)=>{
            const result = filter(message);
            // Only filter out if explicitly false; undefined/missing return defaults to keeping the message
            return result !== false;
        });
    });
};



var $aBUXY = parcelRequire("aBUXY");















































const $5690aaf32bc2dea6$var$styles = {
    stickyTopBase: "_0bjKvDOLYo _39xV02N91d _3YEZNOdnbC _1mT5xdRAKS _0KLXrunmFW _3hhsrrNvrM _3BoeID6wH8 _3XVgLMjOvk _4dzD1B7dHp _02TURZqU8D",
    stickyTop: "_46hvQmVa5s _03SyCP5zaO _0xmtko5zaO _0LQT5E5zaO",
    stickyTopFullScreen: "_46hvQm5zaO _03SyCP5zaO _0xmtko5zaO _0LQT5E5zaO",
    row: "_2mHwu82ADO _0hPCNLchRC _4ouGXIdnbC",
    titleText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
};
const $5690aaf32bc2dea6$export$ac012dfd84c1c03e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoConversationTitleBlock(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { title: title, icon: icon, iconAppearance: t1, isFullScreen: t2, testId: t3 } = t0;
    const iconAppearance = t1 === undefined ? "blue" : t1;
    const isFullScreen = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "rovo-conversation-title-block" : t3;
    const t4 = isFullScreen ? $5690aaf32bc2dea6$var$styles.stickyTopFullScreen : $5690aaf32bc2dea6$var$styles.stickyTop;
    let t5;
    if ($[0] !== t4) {
        t5 = (0, $w6R6I.cx)($5690aaf32bc2dea6$var$styles.stickyTopBase, t4);
        $[0] = t4;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== icon || $[3] !== iconAppearance || $[4] !== title) {
        t6 = icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-title-block",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: icon,
            label: title,
            appearance: iconAppearance,
            size: "small"
        }));
        $[2] = icon;
        $[3] = iconAppearance;
        $[4] = title;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== title) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5690aaf32bc2dea6$var$styles.titleText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "large",
            maxLines: 2
        }, title));
        $[6] = title;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $5690aaf32bc2dea6$var$styles.row
        }, t6, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== t5 || $[12] !== t8 || $[13] !== testId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t5,
            testId: testId
        }, t8);
        $[11] = t5;
        $[12] = t8;
        $[13] = testId;
        $[14] = t9;
    } else t9 = $[14];
    return t9;
} : function RovoConversationTitleBlock({ title: title, icon: icon, iconAppearance: iconAppearance = 'blue', isFullScreen: isFullScreen = false, testId: testId = 'rovo-conversation-title-block' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5690aaf32bc2dea6$var$styles.stickyTopBase, isFullScreen ? $5690aaf32bc2dea6$var$styles.stickyTopFullScreen : $5690aaf32bc2dea6$var$styles.stickyTop),
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $5690aaf32bc2dea6$var$styles.row
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-title-block",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: icon,
        label: title,
        appearance: iconAppearance,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5690aaf32bc2dea6$var$styles.titleText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        maxLines: 2
    }, title))));
};














const $3908b4de7933a21d$var$TAGS_ELIGIBLE_FOR_TITLE_BLOCK = [
    (0, $fqtnH.TAGS).INSIGHTS
];
const $3908b4de7933a21d$var$ConversationTitleBlockContainerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConversationTitleBlockContainerInner(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { currentConversationId: currentConversationId, conversation: conversation, conversationHeader: conversationHeader } = t0;
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { setConversationHeader: setConversationHeader } = (0, $bGNkz.useUIStoreActions)();
    const header = conversationHeader ?? null;
    const headerForThisChat = header?.conversationId === currentConversationId;
    let t1;
    if ($[0] !== conversation?.tags) {
        t1 = conversation?.tags?.some($3908b4de7933a21d$var$_temp) ?? false;
        $[0] = conversation?.tags;
        $[1] = t1;
    } else t1 = $[1];
    const hasEligibleTag = t1;
    let t2;
    if ($[2] !== conversation?.name || $[3] !== hasEligibleTag) {
        t2 = hasEligibleTag ? conversation?.name?.trim() ?? "" : "";
        $[2] = conversation?.name;
        $[3] = hasEligibleTag;
        $[4] = t2;
    } else t2 = $[4];
    const persistedTitle = t2;
    let t3;
    if ($[5] !== header?.title || $[6] !== headerForThisChat) {
        t3 = headerForThisChat ? header?.title?.trim() ?? "" : "";
        $[5] = header?.title;
        $[6] = headerForThisChat;
        $[7] = t3;
    } else t3 = $[7];
    const headerTitle = t3;
    const title = persistedTitle || headerTitle;
    const showTitleBlock = hasEligibleTag && persistedTitle.length > 0 || headerTitle.length > 0;
    let t4;
    let t5;
    if ($[8] !== currentConversationId || $[9] !== header || $[10] !== setConversationHeader) {
        t4 = ()=>{
            if (header && header.conversationId !== currentConversationId) setConversationHeader(null);
        };
        t5 = [
            header,
            currentConversationId,
            setConversationHeader
        ];
        $[8] = currentConversationId;
        $[9] = header;
        $[10] = setConversationHeader;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (!showTitleBlock) return null;
    const t6 = headerForThisChat ? header?.icon : undefined;
    const t7 = headerForThisChat ? header?.iconAppearance : undefined;
    let t8;
    if ($[13] !== fullScreen || $[14] !== t6 || $[15] !== t7 || $[16] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5690aaf32bc2dea6$export$ac012dfd84c1c03e), {
            title: title,
            icon: t6,
            iconAppearance: t7,
            isFullScreen: fullScreen
        });
        $[13] = fullScreen;
        $[14] = t6;
        $[15] = t7;
        $[16] = title;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : function ConversationTitleBlockContainerInner({ currentConversationId: currentConversationId, conversation: conversation, conversationHeader: conversationHeader }) {
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { setConversationHeader: setConversationHeader } = (0, $bGNkz.useUIStoreActions)();
    const header = conversationHeader ?? null;
    const headerForThisChat = header?.conversationId === currentConversationId;
    const hasEligibleTag = conversation?.tags?.some((tag)=>$3908b4de7933a21d$var$TAGS_ELIGIBLE_FOR_TITLE_BLOCK.includes(tag)) ?? false;
    // title for when an insights is viewed in persisted state (conversation was initiated)
    const persistedTitle = hasEligibleTag ? conversation?.name?.trim() ?? '' : '';
    // title for when insights is viewed in the preview state
    const headerTitle = headerForThisChat ? header?.title?.trim() ?? '' : '';
    const title = persistedTitle || headerTitle;
    const showTitleBlock = hasEligibleTag && persistedTitle.length > 0 || headerTitle.length > 0;
    (0, $cozmU.useEffect)(()=>{
        if (header && header.conversationId !== currentConversationId) setConversationHeader(null);
    }, [
        header,
        currentConversationId,
        setConversationHeader
    ]);
    if (!showTitleBlock) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5690aaf32bc2dea6$export$ac012dfd84c1c03e), {
        title: title,
        icon: headerForThisChat ? header?.icon : undefined,
        iconAppearance: headerForThisChat ? header?.iconAppearance : undefined,
        isFullScreen: fullScreen
    });
};
function $3908b4de7933a21d$var$_temp(tag) {
    return $3908b4de7933a21d$var$TAGS_ELIGIBLE_FOR_TITLE_BLOCK.includes(tag);
}
// rovo_ttai_segment_render_stabilization: absorb parent render waves when props are stable.
const $3908b4de7933a21d$var$MemoizedConversationTitleBlockContainerInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($3908b4de7933a21d$var$ConversationTitleBlockContainerInner, (0, $dqxOF.shallowEqualObjects));
// rovo_ttai_segment_render_stabilization ON: subscribe to `conversationHeader` via
// the narrow selector so the component only re-renders when `conversationHeader`
// changes, rather than on every UI-store state change.
const $3908b4de7933a21d$var$ConversationTitleBlockWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useConversationHeaderSelector));
    const [{ conversationHeader: conversationHeader }] = (0, $bGNkz.useConversationHeaderSelector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$MemoizedConversationTitleBlockContainerInner, {
        ...props,
        conversationHeader: conversationHeader
    });
};
// rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $3908b4de7933a21d$var$ConversationTitleBlockWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { conversationHeader: conversationHeader } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockContainerInner, {
        ...props,
        conversationHeader: conversationHeader
    });
};
const $3908b4de7933a21d$var$ConversationTitleBlockUI = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockWithBroadStore, props);
};
const $3908b4de7933a21d$export$95326f479f919118 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConversationTitleBlockContainer() {
    const $ = (0, $bDgLe.c)(3);
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    const conversation = (0, $e8YqO.useCurrentConversation)();
    let t0;
    if ($[0] !== conversation || $[1] !== currentConversationId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockUI, {
            currentConversationId: currentConversationId,
            conversation: conversation
        });
        $[0] = conversation;
        $[1] = currentConversationId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function ConversationTitleBlockContainer() {
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    const conversation = (0, $e8YqO.useCurrentConversation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3908b4de7933a21d$var$ConversationTitleBlockUI, {
        currentConversationId: currentConversationId,
        conversation: conversation
    });
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































var $3BY7M = parcelRequire("3BY7M");





var $jsad9 = parcelRequire("jsad9");





var $4NbSC = parcelRequire("4NbSC");























var $eQZgt = parcelRequire("eQZgt");





var $jCBG9 = parcelRequire("jCBG9");


var $jQDPt = parcelRequire("jQDPt");


var $ednap = parcelRequire("ednap");
















var $hc9K5 = parcelRequire("hc9K5");



















const $789287b84dcfdfc9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResults: {
        id: "ai-mate.inline-browse.no-results",
        defaultMessage: "No results found"
    }
});


const $678586c219416993$var$styles = {
    wrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0jFU0VN91d _39xV02N91d _4bt5LAnQyn",
    browseItemsContainer: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    browseItemsList: "_1LMyvKYbGa _2WAcuGIZbP _1qyfxmyhct _2Zuz6QkG2W _1ZnuxbgVvo _0Of8r22ADO _313842Pgdg",
    listFooterSpinner: "_4c065U2ADO _3iDTPbQ4SZ _37wbyuDIqT",
    browseItemButton: "_39xV02N91d _0jFU0VmdCj _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r2gVvo _1wydGWgVvo _0KLXru66of _2fwxA5ecOK _0Am33zKxmn _1eOmH6o126 _3gzVzLN4oS",
    browseItemInner: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d",
    browseItemIconContainer: "_0bjKvDKTcp _30huDKOeNX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1UtDYzZpcK _0KLXrulfZc",
    descriptionExpandable: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHVWD4 _3iDTPbgBM8",
    descriptionExpandableInner: "_4bt5LAnQyn _2WAcuGnQyn _4kiQYAdnbC"
};
const $678586c219416993$var$isSafariBrowser = ()=>typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $678586c219416993$var$BrowseItemIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { iconName: iconName, iconColor: iconColor, iconMap: iconMap, defaultIcon: defaultIcon } = t0;
    const IconComponent = iconName && iconMap && iconName in iconMap ? iconMap[iconName] : defaultIcon;
    if (!IconComponent) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== iconColor) {
        t2 = iconColor && {
            color: iconColor
        };
        $[1] = iconColor;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== IconComponent || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            label: "",
            ...t2
        }));
        $[3] = IconComponent;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ iconName: iconName, iconColor: iconColor, iconMap: iconMap, defaultIcon: defaultIcon })=>{
    const IconComponent = iconName && iconMap && iconName in iconMap ? iconMap[iconName] : defaultIcon;
    if (!IconComponent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        label: "",
        ...iconColor && {
            color: iconColor
        }
    }));
};
const $678586c219416993$var$BrowseItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { browseItem: browseItem, onClick: onClick, onHover: onHover, testId: testId, iconMap: iconMap, defaultIcon: defaultIcon, renderHoverCardContent: renderHoverCardContent } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== browseItem || $[1] !== onHover) {
        t1 = ()=>{
            setIsHovered(true);
            onHover?.(browseItem);
        };
        $[0] = browseItem;
        $[1] = onHover;
        $[2] = t1;
    } else t1 = $[2];
    const handleMouseEnter = t1;
    let t2;
    if ($[3] !== onHover) {
        t2 = ()=>{
            setIsHovered(false);
            onHover?.(null);
        };
        $[3] = onHover;
        $[4] = t2;
    } else t2 = $[4];
    const handleMouseLeave = t2;
    let t3;
    if ($[5] !== browseItem.description) {
        t3 = Boolean(browseItem.description) && !$678586c219416993$var$isSafariBrowser();
        $[5] = browseItem.description;
        $[6] = t3;
    } else t3 = $[6];
    const shouldRenderInlineDescription = t3;
    let t4;
    if ($[7] !== browseItem.iconColor || $[8] !== browseItem.iconName || $[9] !== defaultIcon || $[10] !== iconMap) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $678586c219416993$var$styles.browseItemIconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($678586c219416993$var$BrowseItemIcon, {
            iconName: browseItem.iconName,
            iconColor: browseItem.iconColor,
            iconMap: iconMap,
            defaultIcon: defaultIcon
        }));
        $[7] = browseItem.iconColor;
        $[8] = browseItem.iconName;
        $[9] = defaultIcon;
        $[10] = iconMap;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== browseItem.name) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, browseItem.name);
        $[12] = browseItem.name;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== browseItem.description || $[15] !== isHovered || $[16] !== shouldRenderInlineDescription) {
        t6 = shouldRenderInlineDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $678586c219416993$var$styles.descriptionExpandable,
            style: {
                gridTemplateRows: isHovered ? "1fr" : "0fr"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $678586c219416993$var$styles.descriptionExpandableInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            maxLines: 1
        }, browseItem.description)));
        $[14] = browseItem.description;
        $[15] = isHovered;
        $[16] = shouldRenderInlineDescription;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, t5, t6);
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t4 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $678586c219416993$var$styles.browseItemInner
        }, t4, t7);
        $[21] = t4;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    const innerContent = t8;
    let t9;
    if ($[24] !== browseItem || $[25] !== innerContent || $[26] !== renderHoverCardContent || $[27] !== testId) {
        t9 = renderHoverCardContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGEnS.HoverCard), {
            content: renderHoverCardContent(browseItem),
            placement: "right",
            fallbackPlacements: [
                "left",
                "bottom",
                "top"
            ],
            testId: testId ? `${testId}--hovercard` : undefined
        }, innerContent) : innerContent;
        $[24] = browseItem;
        $[25] = innerContent;
        $[26] = renderHoverCardContent;
        $[27] = testId;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== handleMouseEnter || $[30] !== handleMouseLeave || $[31] !== onClick || $[32] !== t9 || $[33] !== testId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $678586c219416993$var$styles.browseItemButton,
            onClick: onClick,
            testId: testId,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave
        }, t9);
        $[29] = handleMouseEnter;
        $[30] = handleMouseLeave;
        $[31] = onClick;
        $[32] = t9;
        $[33] = testId;
        $[34] = t10;
    } else t10 = $[34];
    return t10;
} : ({ browseItem: browseItem, onClick: onClick, onHover: onHover, testId: testId, iconMap: iconMap, defaultIcon: defaultIcon, renderHoverCardContent: renderHoverCardContent })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHovered(true);
        onHover?.(browseItem);
    }, [
        browseItem,
        onHover
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
        onHover?.(null);
    }, [
        onHover
    ]);
    const shouldRenderInlineDescription = Boolean(browseItem.description) && !$678586c219416993$var$isSafariBrowser();
    const innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $678586c219416993$var$styles.browseItemInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $678586c219416993$var$styles.browseItemIconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($678586c219416993$var$BrowseItemIcon, {
        iconName: browseItem.iconName,
        iconColor: browseItem.iconColor,
        iconMap: iconMap,
        defaultIcon: defaultIcon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, browseItem.name), shouldRenderInlineDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $678586c219416993$var$styles.descriptionExpandable,
        style: {
            gridTemplateRows: isHovered ? '1fr' : '0fr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $678586c219416993$var$styles.descriptionExpandableInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, browseItem.description)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $678586c219416993$var$styles.browseItemButton,
        onClick: onClick,
        testId: testId,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave
    }, renderHoverCardContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGEnS.HoverCard), {
        content: renderHoverCardContent(browseItem),
        placement: "right",
        fallbackPlacements: [
            'left',
            'bottom',
            'top'
        ],
        testId: testId ? `${testId}--hovercard` : undefined
    }, innerContent) : innerContent);
};
const $678586c219416993$export$11ba40b18e18cea6 = (browseItems, searchValue)=>{
    if (!searchValue) return browseItems;
    const search = searchValue.toLowerCase();
    return browseItems.filter((browseItem)=>browseItem.name.toLowerCase().includes(search) || browseItem.description?.toLowerCase().includes(search) || browseItem.product?.toLowerCase().includes(search) || browseItem.appIds?.some((appId)=>appId.toLowerCase().includes(search)) || browseItem.roles?.some((role)=>role.toLowerCase().includes(search)));
};
const $678586c219416993$export$f8d717582a5e730e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { browseItems: t1, onSelectBrowseItem: onSelectBrowseItem, onBrowseItemHover: onBrowseItemHover, onClose: onClose, iconMap: iconMap, defaultIcon: defaultIcon, renderHoverCardContent: renderHoverCardContent, listEndRef: listEndRef, listFooterLoading: listFooterLoading } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const browseItems = t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[2] !== onClose || $[3] !== onSelectBrowseItem) {
        t3 = (browseItem)=>{
            onSelectBrowseItem(browseItem);
            onClose?.();
        };
        $[2] = onClose;
        $[3] = onSelectBrowseItem;
        $[4] = t3;
    } else t3 = $[4];
    const handleBrowseItemSelect = t3;
    let t4;
    if ($[5] !== browseItems.length || $[6] !== listFooterLoading) {
        t4 = browseItems.length === 0 && listFooterLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $678586c219416993$var$styles.listFooterSpinner,
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium"
        }));
        $[5] = browseItems.length;
        $[6] = listFooterLoading;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== browseItems.length || $[9] !== formatMessage || $[10] !== listFooterLoading) {
        t5 = browseItems.length === 0 && !listFooterLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.200",
            as: "li"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            align: "center",
            color: "color.text.subtle"
        }, formatMessage((0, $789287b84dcfdfc9$export$defe85febe8b728c).noResults)));
        $[8] = browseItems.length;
        $[9] = formatMessage;
        $[10] = listFooterLoading;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== browseItems || $[13] !== defaultIcon || $[14] !== handleBrowseItemSelect || $[15] !== iconMap || $[16] !== onBrowseItemHover || $[17] !== renderHoverCardContent) {
        t6 = browseItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), null, browseItems.map((browseItem_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: browseItem_0.id
            }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($678586c219416993$var$BrowseItem, {
                    browseItem: browseItem_0,
                    onClick: ()=>handleBrowseItemSelect(browseItem_0),
                    onHover: onBrowseItemHover,
                    testId: `browse-item-${browseItem_0.id}`,
                    iconMap: iconMap,
                    defaultIcon: defaultIcon,
                    renderHoverCardContent: renderHoverCardContent
                })))));
        $[12] = browseItems;
        $[13] = defaultIcon;
        $[14] = handleBrowseItemSelect;
        $[15] = iconMap;
        $[16] = onBrowseItemHover;
        $[17] = renderHoverCardContent;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== browseItems.length || $[20] !== listFooterLoading) {
        t7 = listFooterLoading && browseItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $678586c219416993$var$styles.listFooterSpinner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium"
        }));
        $[19] = browseItems.length;
        $[20] = listFooterLoading;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== browseItems.length || $[23] !== listEndRef) {
        t8 = listEndRef && browseItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            paddingBlockStart: "space.0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: (el)=>listEndRef(el)
        }));
        $[22] = browseItems.length;
        $[23] = listEndRef;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $678586c219416993$var$styles.wrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $678586c219416993$var$styles.browseItemsContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $678586c219416993$var$styles.browseItemsList,
            as: "ul"
        }, t4, t5, t6, t7, t8)));
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
} : ({ browseItems: browseItems = [], onSelectBrowseItem: onSelectBrowseItem, onBrowseItemHover: onBrowseItemHover, onClose: onClose, iconMap: iconMap, defaultIcon: defaultIcon, renderHoverCardContent: renderHoverCardContent, listEndRef: listEndRef, listFooterLoading: listFooterLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleBrowseItemSelect = (0, $cozmU.useCallback)((browseItem)=>{
        onSelectBrowseItem(browseItem);
        onClose?.();
    }, [
        onSelectBrowseItem,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $678586c219416993$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $678586c219416993$var$styles.browseItemsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $678586c219416993$var$styles.browseItemsList,
        as: "ul"
    }, browseItems.length === 0 && listFooterLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $678586c219416993$var$styles.listFooterSpinner,
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium"
    })), browseItems.length === 0 && !listFooterLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200",
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "center",
        color: "color.text.subtle"
    }, formatMessage((0, $789287b84dcfdfc9$export$defe85febe8b728c).noResults))), browseItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), null, browseItems.map((browseItem_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: browseItem_0.id
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($678586c219416993$var$BrowseItem, {
                browseItem: browseItem_0,
                onClick: ()=>handleBrowseItemSelect(browseItem_0),
                onHover: onBrowseItemHover,
                testId: `browse-item-${browseItem_0.id}`,
                iconMap: iconMap,
                defaultIcon: defaultIcon,
                renderHoverCardContent: renderHoverCardContent
            }))))), listFooterLoading && browseItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $678586c219416993$var$styles.listFooterSpinner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium"
    })), listEndRef && browseItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        paddingBlockStart: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: (el)=>listEndRef(el)
    })))));
};



















const $9f2eb5e4bb867e3b$var$SKELETON_ROW_COUNT = 6;
const $9f2eb5e4bb867e3b$var$styles = {
    listWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1LMyvKYbGa _4kiQYAdnbC _2WAcuGIZbP _1qyfxmyhct _2Zuz6QkG2W _1ZnuxbgVvo _0Of8r22ADO _313842Pgdg",
    browseItemRow: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0jFU0VmdCj _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r2gVvo _1wydGWgVvo",
    iconContainer: "_0bjKvDKxmn _30huDKOeNX _39xV02Uofl _0jFU0VUofl _4ouGXIUofl _3YEZNOdnbC _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    textStack: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
};
const $9f2eb5e4bb867e3b$export$69eeb649a3550caa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { rowCount: t1, testId: t2 } = t0;
    const rowCount = t1 === undefined ? $9f2eb5e4bb867e3b$var$SKELETON_ROW_COUNT : t1;
    const testId = t2 === undefined ? "inline-browse-skeleton" : t2;
    let t3;
    if ($[0] !== rowCount) {
        t3 = Array.from({
            length: rowCount
        }).map($9f2eb5e4bb867e3b$var$_temp);
        $[0] = rowCount;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== t3 || $[3] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050",
            xcss: $9f2eb5e4bb867e3b$var$styles.listWrapper,
            as: "ul",
            testId: testId
        }, t3);
        $[2] = t3;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : ({ rowCount: rowCount = $9f2eb5e4bb867e3b$var$SKELETON_ROW_COUNT, testId: testId = 'inline-browse-skeleton' })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $9f2eb5e4bb867e3b$var$styles.listWrapper,
        as: "ul",
        testId: testId
    }, Array.from({
        length: rowCount
    }).map((_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: index,
            as: "li",
            xcss: $9f2eb5e4bb867e3b$var$styles.browseItemRow
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9f2eb5e4bb867e3b$var$styles.iconContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: 20,
            height: 20,
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.025",
            xcss: $9f2eb5e4bb867e3b$var$styles.textStack
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "70%",
            height: 16,
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "50%",
            height: 12,
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        })))));
};
function $9f2eb5e4bb867e3b$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        key: index,
        as: "li",
        xcss: $9f2eb5e4bb867e3b$var$styles.browseItemRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9f2eb5e4bb867e3b$var$styles.iconContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: 20,
        height: 20,
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.025",
        xcss: $9f2eb5e4bb867e3b$var$styles.textStack
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "70%",
        height: 16,
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "50%",
        height: 12,
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
}






var $7sEW2 = parcelRequire("7sEW2");


var $eU4FB = parcelRequire("eU4FB");





var $jmZRX = parcelRequire("jmZRX");


var $8kqBU = parcelRequire("8kqBU");


var $dJo3Q = parcelRequire("dJo3Q");


var $9jj3s = parcelRequire("9jj3s");


var $4Aef9 = parcelRequire("4Aef9");


var $dTXmz = parcelRequire("dTXmz");


var $j4Mju = parcelRequire("j4Mju");


var $c1lhH = parcelRequire("c1lhH");

















var $3yAls = parcelRequire("3yAls");


var $cDs9S = parcelRequire("cDs9S");

















var $its7R = parcelRequire("its7R");


var $4zuSK = parcelRequire("4zuSK");


var $4be0A = parcelRequire("4be0A");




const $6b78a780fac408b2$var$styles = {
    modalBodyContent: "_0xmtkoNHnM",
    headerContentFullWidth: "_39xV02N91d",
    connectorLogoWrapper: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _0jFU0V70UD _39xV0270UD _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuDIqT"
};
const $6b78a780fac408b2$export$3077e8ed68ace78c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { isOpen: isOpen, onClose: onClose, promptCards: promptCards, myPromptCards: myPromptCards, onCardSelect: onCardSelect, onCreatePromptClick: onCreatePromptClick, onDeletePrompt: onDeletePrompt, onEditPrompt: onEditPrompt, onDuplicatePrompt: onDuplicatePrompt, onFavoriteToggle: onFavoriteToggle, onBulkFavorite: onBulkFavorite, onBulkDelete: onBulkDelete, onBulkShare: onBulkShare, onSharePrompt: onSharePrompt, assistanceServiceParams: assistanceServiceParams, skillMetadata: skillMetadata, appOptions: appOptions, onEmptyStateViewed: onEmptyStateViewed, isLoading: isLoading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const promptLibraryFilters = (0, $4zuSK.usePromptLibraryFilters)(promptCards, myPromptCards);
    let t1;
    if ($[0] !== appOptions) {
        t1 = appOptions?.map($6b78a780fac408b2$var$_temp) ?? [];
        $[0] = appOptions;
        $[1] = t1;
    } else t1 = $[1];
    const connectorFilterOptions = t1;
    const renderConnectorOptionIcon = $6b78a780fac408b2$var$_temp2;
    let t2;
    if ($[2] !== assistanceServiceParams || $[3] !== connectorFilterOptions || $[4] !== formatMessage || $[5] !== isLoading || $[6] !== isOpen || $[7] !== onBulkDelete || $[8] !== onBulkFavorite || $[9] !== onBulkShare || $[10] !== onCardSelect || $[11] !== onClose || $[12] !== onCreatePromptClick || $[13] !== onDeletePrompt || $[14] !== onDuplicatePrompt || $[15] !== onEditPrompt || $[16] !== onEmptyStateViewed || $[17] !== onFavoriteToggle || $[18] !== onSharePrompt || $[19] !== promptLibraryFilters || $[20] !== skillMetadata) {
        t2 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            width: "838px",
            onClose: onClose,
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6b78a780fac408b2$var$styles.headerContentFullWidth
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            shouldWrap: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $j4Mju.default).headerTitle)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3yAls))),
            onClick: onCreatePromptClick
        }, formatMessage((0, $j4Mju.default).createPrompt)), /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
            onClick: onClose
        }))))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6b78a780fac408b2$var$styles.modalBodyContent
        }, /*#__PURE__*/ $cozmU.createElement((0, $4be0A.PromptLibraryContent), {
            searchablePrompts: promptLibraryFilters.searchablePrompts,
            onSearchChange: promptLibraryFilters.handleSearchChange,
            selectedCategory: promptLibraryFilters.selectedCategory,
            selectedCategoryFilters: promptLibraryFilters.selectedCategoryFilters,
            onMyPromptsClick: promptLibraryFilters.handleMyPromptsClick,
            onFavoritesClick: promptLibraryFilters.handleFavoritesClick,
            showMyPromptsButton: true,
            showFavoritesButton: true,
            selectedUseCases: promptLibraryFilters.selectedUseCases,
            onUseCaseFilterChange: promptLibraryFilters.handleUseCaseFilterChange,
            selectedRoles: promptLibraryFilters.selectedRoles,
            onRoleFilterChange: promptLibraryFilters.handleRoleFilterChange,
            resultCount: promptLibraryFilters.resultCount,
            hasActiveFilters: promptLibraryFilters.hasActiveFilters,
            onClearFilters: promptLibraryFilters.handleClearFilters,
            cardsToShow: promptLibraryFilters.cardsToShow,
            onCardClick: onCardSelect,
            onDeletePrompt: onDeletePrompt,
            onBulkDelete: onBulkDelete,
            onEditPrompt: onEditPrompt,
            onDuplicatePrompt: onDuplicatePrompt,
            onFavoriteToggle: onFavoriteToggle,
            onBulkFavorite: onBulkFavorite,
            onBulkShare: onBulkShare,
            onSharePrompt: onSharePrompt,
            assistanceServiceParams: assistanceServiceParams,
            skillMetadata: skillMetadata,
            connectorFilter: connectorFilterOptions.length > 0 ? {
                options: connectorFilterOptions,
                selected: promptLibraryFilters.selectedConnectors,
                onChange: promptLibraryFilters.handleConnectorFilterChange,
                renderIcon: renderConnectorOptionIcon
            } : undefined,
            onEmptyStateViewed: onEmptyStateViewed,
            isLoading: isLoading
        }))));
        $[2] = assistanceServiceParams;
        $[3] = connectorFilterOptions;
        $[4] = formatMessage;
        $[5] = isLoading;
        $[6] = isOpen;
        $[7] = onBulkDelete;
        $[8] = onBulkFavorite;
        $[9] = onBulkShare;
        $[10] = onCardSelect;
        $[11] = onClose;
        $[12] = onCreatePromptClick;
        $[13] = onDeletePrompt;
        $[14] = onDuplicatePrompt;
        $[15] = onEditPrompt;
        $[16] = onEmptyStateViewed;
        $[17] = onFavoriteToggle;
        $[18] = onSharePrompt;
        $[19] = promptLibraryFilters;
        $[20] = skillMetadata;
        $[21] = t2;
    } else t2 = $[21];
    let t3;
    if ($[22] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t2);
        $[22] = t2;
        $[23] = t3;
    } else t3 = $[23];
    return t3;
} : ({ isOpen: isOpen, onClose: onClose, promptCards: promptCards, myPromptCards: myPromptCards, onCardSelect: onCardSelect, onCreatePromptClick: onCreatePromptClick, onDeletePrompt: onDeletePrompt, onEditPrompt: onEditPrompt, onDuplicatePrompt: onDuplicatePrompt, onFavoriteToggle: onFavoriteToggle, onBulkFavorite: onBulkFavorite, onBulkDelete: onBulkDelete, onBulkShare: onBulkShare, onSharePrompt: onSharePrompt, assistanceServiceParams: assistanceServiceParams, skillMetadata: skillMetadata, appOptions: appOptions, onEmptyStateViewed: onEmptyStateViewed, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const promptLibraryFilters = (0, $4zuSK.usePromptLibraryFilters)(promptCards, myPromptCards);
    const connectorFilterOptions = (0, $cozmU.useMemo)(()=>appOptions?.map((o)=>({
                id: o.value,
                label: o.label
            })) ?? [], [
        appOptions
    ]);
    const renderConnectorOptionIcon = (0, $cozmU.useCallback)((option)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6b78a780fac408b2$var$styles.connectorLogoWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: option.id,
            rovoLogoProps: {
                size: 'xsmall'
            }
        })), []);
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        width: "838px",
        onClose: onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6b78a780fac408b2$var$styles.headerContentFullWidth
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        shouldWrap: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $j4Mju.default).headerTitle)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3yAls))),
        onClick: onCreatePromptClick
    }, formatMessage((0, $j4Mju.default).createPrompt)), /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
        onClick: onClose
    }))))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6b78a780fac408b2$var$styles.modalBodyContent
    }, /*#__PURE__*/ $cozmU.createElement((0, $4be0A.PromptLibraryContent), {
        searchablePrompts: promptLibraryFilters.searchablePrompts,
        onSearchChange: promptLibraryFilters.handleSearchChange,
        selectedCategory: promptLibraryFilters.selectedCategory,
        selectedCategoryFilters: promptLibraryFilters.selectedCategoryFilters,
        onMyPromptsClick: promptLibraryFilters.handleMyPromptsClick,
        onFavoritesClick: promptLibraryFilters.handleFavoritesClick,
        showMyPromptsButton: true,
        showFavoritesButton: true,
        selectedUseCases: promptLibraryFilters.selectedUseCases,
        onUseCaseFilterChange: promptLibraryFilters.handleUseCaseFilterChange,
        selectedRoles: promptLibraryFilters.selectedRoles,
        onRoleFilterChange: promptLibraryFilters.handleRoleFilterChange,
        resultCount: promptLibraryFilters.resultCount,
        hasActiveFilters: promptLibraryFilters.hasActiveFilters,
        onClearFilters: promptLibraryFilters.handleClearFilters,
        cardsToShow: promptLibraryFilters.cardsToShow,
        onCardClick: onCardSelect,
        onDeletePrompt: onDeletePrompt,
        onBulkDelete: onBulkDelete,
        onEditPrompt: onEditPrompt,
        onDuplicatePrompt: onDuplicatePrompt,
        onFavoriteToggle: onFavoriteToggle,
        onBulkFavorite: onBulkFavorite,
        onBulkShare: onBulkShare,
        onSharePrompt: onSharePrompt,
        assistanceServiceParams: assistanceServiceParams,
        skillMetadata: skillMetadata,
        connectorFilter: connectorFilterOptions.length > 0 ? {
            options: connectorFilterOptions,
            selected: promptLibraryFilters.selectedConnectors,
            onChange: promptLibraryFilters.handleConnectorFilterChange,
            renderIcon: renderConnectorOptionIcon
        } : undefined,
        onEmptyStateViewed: onEmptyStateViewed,
        isLoading: isLoading
    })))));
};
function $6b78a780fac408b2$var$_temp(o) {
    return {
        id: o.value,
        label: o.label
    };
}
function $6b78a780fac408b2$var$_temp2(option) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6b78a780fac408b2$var$styles.connectorLogoWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $its7R.RovoLogoForAppSource), {
        appSource: option.id,
        rovoLogoProps: {
            size: "xsmall"
        }
    }));
}


const $4263a5e3dcbfc278$var$styles = {
    overlay: "_49OCfRdnbC _1mT5xdWVPG _42Yu6B7dHp _0KLXrulfZc",
    overlayHidden: "_3iDTPbYbGa",
    hoverCardContent: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _39xV02sz7G _2fwxA5ecOK",
    hoverCardHeader: "_0hPCNLDIqT",
    promptIcon: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    hoverCardAppsRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
    seeAllHeaderActions: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    browseWrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _39xV02N91d _4bt5LAnQyn",
    browseHeaderContainer: "_0Of8r2kG2W _1ZnuxbkG2W _1wydGWkG2W _2Zuz6QkG2W",
    browseHeaderRow: "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _39xV02N91d",
    browseSearchBar: "_2Zuz6QkG2W _1ZnuxbkG2W"
}; /** Wrap use-case icon (no props) so it accepts InlineBrowseIconProps and render at smaller size */ 
const $4263a5e3dcbfc278$var$wrapUseCaseIcon = (IconComponent)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            style: {
                width: 20,
                height: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent)); /** Reuse the mapping from rovo-conversation-actions, wrapped for InlineBrowse and smaller size */ 
const $4263a5e3dcbfc278$var$useCaseIconMap = Object.fromEntries(Object.entries((0, $jQDPt.promptUseCaseIconMap)).map(([cat, Icon])=>[
        cat,
        $4263a5e3dcbfc278$var$wrapUseCaseIcon(Icon)
    ]));
const $4263a5e3dcbfc278$var$defaultPromptIcon = $4263a5e3dcbfc278$var$wrapUseCaseIcon((0, $jQDPt.defaultPromptUseCaseIcon));
const $4263a5e3dcbfc278$var$promptParagraphNodeComponents = {
    paragraph: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, children)
};
function $4263a5e3dcbfc278$var$getRawPromptsFromResponse(response) {
    if (!response || typeof response !== 'object') return [];
    const r = response;
    return r.prompts ?? r.items ?? [];
}
const $4263a5e3dcbfc278$export$133d85460c257b8e = ({ screenType: screenType, conversationId: conversationId, closeInlineBrowse: closeInlineBrowse })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { promptCards: defaultPromptCards } = (0, $ZKswU.usePromptCards)();
    const { insertPlaceholder: insertPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    const { setPromptCardSource: setPromptCardSource } = (0, $jmZRX.usePromptCardSendTrackingActions)();
    const { setReasoningMode: setReasoningMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { organization: organization } = (0, $isp1U.useProfileController)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'sidebarPromptInlineBrowse'
    });
    const { handlePromptAppConnectors: handlePromptAppConnectors } = (0, $7sEW2.usePromptAppConnectors)({
        conversationId: conversationId,
        assistanceServiceParams: assistanceServiceParams
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { options: appOptions } = (0, $jsad9.useAppOptionsForSelect)(assistanceServiceParams);
    const { data: promptsResponse, isFetching: isFetching, refetch: refetchPrompts, updatePromptFavoriteInCache: updatePromptFavoriteInCache, bulkUpdatePromptFavoritesInCache: bulkUpdatePromptFavoritesInCache } = (0, $4Aef9.usePromptsController)({
        assistanceServiceParams: assistanceServiceParams,
        enabled: (0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false)
    }); // Show skeleton while My Prompts are loading
    const hasSettledRef = (0, $cozmU.useRef)(false);
    if (!isFetching) hasSettledRef.current = true;
    const isPromptsLoading = !hasSettledRef.current;
    const { handleCreatePrompt: handleCreatePrompt } = (0, $8kqBU.useCreatePrompt)({
        assistanceServiceParams: assistanceServiceParams,
        refetchPrompts: refetchPrompts
    });
    const { deletePrompt: deletePrompt } = (0, $dJo3Q.useDeletePromptController)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { handleFavoriteToggle: handleModalFavoriteToggle, handleBulkFavorite: handleModalBulkFavorite, handleBulkDelete: handleModalBulkDelete, handleBulkShare: handleModalBulkShare } = (0, $9jj3s.usePromptActions)({
        assistanceServiceParams: assistanceServiceParams,
        showErrorFlag: true,
        deletePrompt: deletePrompt,
        refetchPrompts: refetchPrompts,
        updatePromptFavoriteInCache: updatePromptFavoriteInCache,
        bulkUpdatePromptFavoritesInCache: bulkUpdatePromptFavoritesInCache
    });
    const providerMetadata = (0, $7dHQW.useSkillMetadata)();
    const skillMetadataMap = (0, $cozmU.useMemo)(()=>providerMetadata?.skillMetadataMap ?? {}, [
        providerMetadata
    ]);
    const [isCreatePromptModalOpen, setIsCreatePromptModalOpen] = (0, $cozmU.useState)(false);
    const [isSeeAllModalOpen, setIsSeeAllModalOpen] = (0, $cozmU.useState)(false);
    const [isSharePromptModalOpen, setIsSharePromptModalOpen] = (0, $cozmU.useState)(false);
    const [createdPromptData, setCreatedPromptData] = (0, $cozmU.useState)(null);
    const [editingPromptCard, setEditingPromptCard] = (0, $cozmU.useState)(null);
    const [duplicatingPromptCard, setDuplicatingPromptCard] = (0, $cozmU.useState)(null);
    const [createModalIntent, setCreateModalIntent] = (0, $cozmU.useState)(null);
    const handleCreatePromptSubmit = (0, $cozmU.useCallback)(async (data)=>{
        const cardToDeleteAfterCreate = editingPromptCard;
        const result = await handleCreatePrompt(data);
        if (cardToDeleteAfterCreate) {
            await deletePrompt(cardToDeleteAfterCreate.id);
            await refetchPrompts();
            setEditingPromptCard(null);
        }
        setDuplicatingPromptCard(null);
        return {
            ...data,
            shareId: result.id,
            ownerName: undefined
        };
    }, [
        handleCreatePrompt,
        editingPromptCard,
        deletePrompt,
        refetchPrompts
    ]);
    const handleCreateSuccess = (0, $cozmU.useCallback)((promptData)=>{
        if (createModalIntent === 'create') sendAnalyticsEvent({
            action: 'created',
            actionSubject: 'prompt',
            actionSubjectId: 'promptCreated'
        });
        else if (createModalIntent === 'edit') sendAnalyticsEvent({
            action: 'edited',
            actionSubject: 'prompt',
            actionSubjectId: 'promptEdited',
            attributes: {
                isSystemPrompt: (0, $eU4FB.getIsSystemPromptForAnalytics)(editingPromptCard?.isUserGenerated)
            }
        });
        else if (createModalIntent === 'duplicate') sendAnalyticsEvent({
            action: 'duplicated',
            actionSubject: 'prompt',
            actionSubjectId: 'promptDuplicated',
            attributes: {
                isSystemPrompt: (0, $eU4FB.getIsSystemPromptForAnalytics)(duplicatingPromptCard?.isUserGenerated)
            }
        });
        setCreateModalIntent(null);
        setCreatedPromptData(promptData);
        setIsCreatePromptModalOpen(false);
        setIsSharePromptModalOpen(true);
    }, [
        createModalIntent,
        sendAnalyticsEvent,
        editingPromptCard,
        duplicatingPromptCard
    ]);
    const handleCloseShare = (0, $cozmU.useCallback)(()=>{
        setIsSharePromptModalOpen(false);
        setCreatedPromptData(null);
    }, []);
    const handleSharePrompt = (0, $cozmU.useCallback)((card)=>{
        // Convert useCase string to SelectOption
        const useCaseOption = card.useCase ? {
            label: card.useCase,
            value: card.useCase
        } : null; // Convert roles to SelectOption[]
        const roleSelectOptions = (card.roles || []).map((role)=>({
                label: role,
                value: role
            })); // Convert appIds to SelectOption[] using appOptions
        const appSelectOptions = (card.appIds || []).map((id)=>{
            const found = appOptions?.find((opt)=>opt.value === id);
            return found || {
                label: id,
                value: id
            };
        });
        setCreatedPromptData({
            title: card.title,
            prompt: card.prompt,
            shareId: card.id,
            ownerName: undefined,
            useCase: useCaseOption,
            role: roleSelectOptions,
            app: appSelectOptions
        });
        setIsSharePromptModalOpen(true);
    }, [
        appOptions
    ]);
    const handleEditPrompt = (0, $cozmU.useCallback)((card_0)=>{
        setIsSeeAllModalOpen(false);
        setCreateModalIntent('edit');
        setEditingPromptCard(card_0);
        setDuplicatingPromptCard(null); // setTimeout(0) allows the "See All" modal to close before opening the create modal,
        // preventing modal stacking/layering issues in the Atlassian modal system.
        setTimeout(()=>setIsCreatePromptModalOpen(true), 0);
    }, []);
    const handleDuplicatePrompt = (0, $cozmU.useCallback)((card_1)=>{
        setIsSeeAllModalOpen(false);
        setCreateModalIntent('duplicate');
        setDuplicatingPromptCard(card_1);
        setEditingPromptCard(null); // setTimeout(0) allows the "See All" modal to close before opening the create modal,
        // preventing modal stacking/layering issues in the Atlassian modal system.
        setTimeout(()=>setIsCreatePromptModalOpen(true), 0);
    }, []);
    const createPromptInitialData = (0, $eQZgt.useCreatePromptInitialData)({
        editingPromptCard: editingPromptCard,
        duplicatingPromptCard: duplicatingPromptCard,
        appOptions: appOptions ?? []
    });
    const handleCreatePromptModalClose = (0, $cozmU.useCallback)(()=>{
        setIsCreatePromptModalOpen(false);
        setEditingPromptCard(null);
        setDuplicatingPromptCard(null);
        setCreateModalIntent(null);
    }, []);
    const handleOpenCreatePromptModal = (0, $cozmU.useCallback)(()=>{
        setCreateModalIntent('create');
        setIsCreatePromptModalOpen(true);
    }, []);
    const handleOpenSeeAllModal = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'seeAllModal'
        });
        setIsSeeAllModalOpen(true);
    }, [
        sendAnalyticsEvent
    ]);
    const handleEmptyStateViewed = (0, $cozmU.useCallback)((emptyStateType)=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'emptyState',
            actionSubjectId: 'promptLibraryEmptyState',
            attributes: {
                emptyStateType: emptyStateType
            }
        });
    }, [
        sendAnalyticsEvent
    ]); // Order: (1) favorited prompts, (2) my prompts, (3) default prompts, (4) 3p app prompts
    // Use stable ordering to prevent list from jumping when favoriting
    const rawPrompts = (0, $cozmU.useMemo)(()=>$4263a5e3dcbfc278$var$getRawPromptsFromResponse(promptsResponse), [
        promptsResponse
    ]);
    const allPromptsFromApi = (0, $c1lhH.useStablePromptOrder)(rawPrompts);
    const myPromptCards = (0, $cozmU.useMemo)(()=>allPromptsFromApi.filter((card_2)=>card_2.isUserGenerated === true), [
        allPromptsFromApi
    ]);
    const promptCards = (0, $cozmU.useMemo)(()=>[
            ...allPromptsFromApi,
            // In v2, default prompts are pre-seeded in the database and returned via the API,
            // so we don't need to include the hardcoded prompts to avoid duplication
            ...(0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) ? [] : defaultPromptCards
        ], [
        allPromptsFromApi,
        defaultPromptCards
    ]);
    const cardById = (0, $cozmU.useMemo)(()=>new Map(promptCards.map((card_3)=>[
                card_3.id,
                card_3
            ])), [
        promptCards
    ]);
    const handlePromptSelect = (0, $cozmU.useCallback)((card_4)=>{
        const promptSource = myPromptCards.some((c)=>c.id === card_4.id) && card_4.isUserGenerated ? 'myPrompts' : 'default';
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'promptCardClick',
            attributes: {
                cardId: card_4.id,
                useCase: card_4.useCase,
                roles: card_4.roles,
                enableDeepResearch: card_4.enableDeepResearch,
                isFavorited: card_4.isFavorited ?? false,
                promptSource: promptSource
            }
        });
        if (card_4.enableDeepResearch) setReasoningMode(conversationId, 'deep-research');
        else setReasoningMode(conversationId, 'auto');
        setPromptCardSource({
            cardId: card_4.id,
            prompt: card_4.prompt,
            promptSource: promptSource,
            isFavorited: card_4.isFavorited
        });
        handlePromptAppConnectors(card_4.appIds, {
            forceMultiline: true
        });
        (0, $dTXmz.insertPromptPlaceholder)(card_4.prompt, insertPlaceholder, skillMetadataMap);
    }, [
        conversationId,
        handlePromptAppConnectors,
        insertPlaceholder,
        myPromptCards,
        sendAnalyticsEvent,
        setPromptCardSource,
        setReasoningMode,
        skillMetadataMap
    ]);
    const browseItems = (0, $cozmU.useMemo)(()=>promptCards.map((card_5)=>({
                id: card_5.id,
                name: card_5.title,
                description: card_5.prompt,
                product: card_5.useCase,
                iconName: card_5.useCase,
                appIds: card_5.appIds,
                roles: card_5.roles
            })), [
        promptCards
    ]);
    const [searchValue, setSearchValue] = (0, $cozmU.useState)('');
    const filteredBrowseItems = (0, $cozmU.useMemo)(()=>(0, $678586c219416993$export$11ba40b18e18cea6)(browseItems, searchValue), [
        browseItems,
        searchValue
    ]);
    const handleSelectBrowseItem = (0, $cozmU.useCallback)((browseItem)=>{
        const card_6 = cardById.get(browseItem.id);
        if (!card_6) return;
        handlePromptSelect(card_6);
        closeInlineBrowse();
    }, [
        cardById,
        closeInlineBrowse,
        handlePromptSelect
    ]);
    const handleModalCardClick = (0, $cozmU.useCallback)((card_7)=>{
        handlePromptSelect(card_7);
        setIsSeeAllModalOpen(false);
        closeInlineBrowse();
    }, [
        closeInlineBrowse,
        handlePromptSelect
    ]);
    const handleModalDeletePrompt = (0, $cozmU.useCallback)(async (promptId)=>{
        // Look up the card to get isUserGenerated for analytics before deleting
        const card_8 = promptCards.find((c_0)=>c_0.id === promptId);
        await deletePrompt(promptId);
        await refetchPrompts();
        sendAnalyticsEvent({
            action: 'deleted',
            actionSubject: 'prompt',
            actionSubjectId: 'promptDeleted',
            attributes: {
                isSystemPrompt: (0, $eU4FB.getIsSystemPromptForAnalytics)(card_8?.isUserGenerated)
            }
        });
    }, [
        deletePrompt,
        refetchPrompts,
        sendAnalyticsEvent,
        promptCards
    ]);
    const renderHoverCardContent = (0, $cozmU.useCallback)((browseItem_0)=>{
        const card_9 = cardById.get(browseItem_0.id);
        if (!card_9) return null;
        const Icon = (0, $jQDPt.getUseCaseIcon)(card_9.useCase);
        const effectiveAppIds = card_9.appIds ?? [];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4263a5e3dcbfc278$var$styles.hoverCardContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            xcss: $4263a5e3dcbfc278$var$styles.hoverCardHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4263a5e3dcbfc278$var$styles.promptIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, browseItem_0.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: (0, $6rwn6.encodePromptToAdf)(browseItem_0.description ?? '', skillMetadataMap).adf,
            extensionHandlers: (0, $jCBG9.skillExtensionHandlers),
            nodeComponents: $4263a5e3dcbfc278$var$promptParagraphNodeComponents
        })), effectiveAppIds.length > 0 && assistanceServiceParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4263a5e3dcbfc278$var$styles.hoverCardAppsRow,
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NbSC.AssignedAppsIcons), {
            appIds: effectiveAppIds,
            assistanceServiceParams: assistanceServiceParams
        }))));
    }, [
        cardById,
        assistanceServiceParams,
        skillMetadataMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($4263a5e3dcbfc278$var$styles.overlay, screenType !== 'prompt-library' && $4263a5e3dcbfc278$var$styles.overlayHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-prompt-library-inline-browse",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
                errorType: "generic"
            }),
        onError: (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: 'sidebarPromptInlineBrowse',
                tags: {
                    conversationId: conversationId
                }
            });
        }
    }, isPromptsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseHeaderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseHeaderRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xlarge"
    }, formatMessage((0, $j4Mju.default).headerTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $4263a5e3dcbfc278$var$styles.seeAllHeaderActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleOpenCreatePromptModal
    }, formatMessage((0, $j4Mju.default).createPrompt)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleOpenSeeAllModal
    }, formatMessage((0, $j4Mju.default).seeAll))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseSearchBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        placeholderText: formatMessage((0, $j4Mju.default).browseSearchPlaceholder),
        onSearch: ()=>{},
        isCompact: true,
        isDisabled: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f2eb5e4bb867e3b$export$69eeb649a3550caa), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseHeaderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseHeaderRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xlarge"
    }, formatMessage((0, $j4Mju.default).headerTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $4263a5e3dcbfc278$var$styles.seeAllHeaderActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleOpenCreatePromptModal
    }, formatMessage((0, $j4Mju.default).createPrompt)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleOpenSeeAllModal
    }, formatMessage((0, $j4Mju.default).seeAll))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4263a5e3dcbfc278$var$styles.browseSearchBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        placeholderText: formatMessage((0, $j4Mju.default).browseSearchPlaceholder),
        onSearch: setSearchValue,
        isCompact: true,
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $678586c219416993$export$f8d717582a5e730e), {
        browseItems: filteredBrowseItems,
        onSelectBrowseItem: handleSelectBrowseItem,
        onClose: closeInlineBrowse,
        iconMap: $4263a5e3dcbfc278$var$useCaseIconMap,
        defaultIcon: $4263a5e3dcbfc278$var$defaultPromptIcon,
        renderHoverCardContent: renderHoverCardContent
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQZgt.CreatePromptModal), {
        appOptions: appOptions?.length ? appOptions : undefined,
        initialData: createPromptInitialData,
        isEditMode: !!editingPromptCard,
        isOpen: isCreatePromptModalOpen,
        onClose: handleCreatePromptModalClose,
        onCreate: handleCreatePromptSubmit,
        onCreateSuccess: handleCreateSuccess
    }), createdPromptData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ednap.SharePromptModal), {
        isOpen: isSharePromptModalOpen,
        onClose: handleCloseShare,
        promptData: createdPromptData,
        organizationName: organization
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b78a780fac408b2$export$3077e8ed68ace78c), {
        isOpen: isSeeAllModalOpen,
        onClose: ()=>setIsSeeAllModalOpen(false),
        promptCards: promptCards,
        myPromptCards: myPromptCards,
        onCardSelect: handleModalCardClick,
        isLoading: isPromptsLoading,
        onCreatePromptClick: ()=>{
            setIsSeeAllModalOpen(false);
            setEditingPromptCard(null);
            setDuplicatingPromptCard(null);
            setCreateModalIntent('create'); // setTimeout(0) allows the "See All" modal to close before opening the create modal,
            // preventing modal stacking/layering issues in the Atlassian modal system.
            setTimeout(()=>setIsCreatePromptModalOpen(true), 0);
        },
        onDeletePrompt: handleModalDeletePrompt,
        onBulkDelete: handleModalBulkDelete,
        onEditPrompt: handleEditPrompt,
        onDuplicatePrompt: handleDuplicatePrompt,
        onFavoriteToggle: handleModalFavoriteToggle,
        onBulkFavorite: handleModalBulkFavorite,
        onBulkShare: handleModalBulkShare,
        onSharePrompt: handleSharePrompt,
        assistanceServiceParams: assistanceServiceParams,
        skillMetadata: skillMetadataMap,
        appOptions: appOptions,
        onEmptyStateViewed: handleEmptyStateViewed
    }))));
};





const $3617fdb62236701e$export$8d7d1f2543f67b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(false);















var $O96nq = parcelRequire("O96nq");

let $ef8883bd884fedd1$var$hasLoggedNullContext = false;
function $ef8883bd884fedd1$var$useViewDeadAirContextInternal() {
    const context = (0, $cozmU.useContext)((0, $O96nq.ViewDeadAirContext));
    if (context === null && !$ef8883bd884fedd1$var$hasLoggedNullContext) {
        $ef8883bd884fedd1$var$hasLoggedNullContext = true;
        (0, $hlvTd.addSentryBreadcrumb)('ViewDeadAirTracker: context is null, tracking disabled');
    }
    return context;
}
const $ef8883bd884fedd1$export$a4761dc3d9967545 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useViewDeadAirContext() {
    const isEnabled = (0, $iDrrr.fg)("rovo_chat_track_view_dead_air");
    const broker = $ef8883bd884fedd1$var$useViewDeadAirContextInternal();
    return isEnabled ? broker : null;
} : function useViewDeadAirContext() {
    const isEnabled = (0, $iDrrr.fg)('rovo_chat_track_view_dead_air');
    const broker = $ef8883bd884fedd1$var$useViewDeadAirContextInternal();
    return isEnabled ? broker : null;
};














const $a6ab52421b090de9$export$79177233ead60764 = 'data-dead-air-tracker';
const $a6ab52421b090de9$export$865b50f6578fb126 = 'data-dead-air-zone';
const $a6ab52421b090de9$export$ec286b319a16492b = 'data-dead-air-zone-type';



const $bf730b8cd03304d8$export$afe1efab2fc7cff2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewDeadAirTracker(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { id: id, contentType: contentType, children: children } = t0;
    if (!(0, $iDrrr.fg)("rovo_chat_track_view_dead_air")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== contentType || $[4] !== id) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bf730b8cd03304d8$var$ViewDeadAirTrackerInner, {
            id: id,
            contentType: contentType
        }, children);
        $[2] = children;
        $[3] = contentType;
        $[4] = id;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : function ViewDeadAirTracker({ id: id, contentType: contentType, children: children }) {
    if (!(0, $iDrrr.fg)('rovo_chat_track_view_dead_air')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bf730b8cd03304d8$var$ViewDeadAirTrackerInner, {
        id: id,
        contentType: contentType
    }, children);
};
const $bf730b8cd03304d8$var$ViewDeadAirTrackerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewDeadAirTrackerInner(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { id: id, contentType: contentType, children: children } = t0;
    const broker = (0, $ef8883bd884fedd1$export$a4761dc3d9967545)();
    const containerRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== broker || $[1] !== contentType || $[2] !== id) {
        t1 = ()=>{
            const el = containerRef.current;
            if (!el || !broker) return;
            const observer = new MutationObserver((mutations)=>{
                for (const mutation of mutations){
                    const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
                    const closestTracker = target?.closest(`[${(0, $a6ab52421b090de9$export$79177233ead60764)}]`);
                    if (closestTracker && closestTracker !== el) continue;
                    const zone = target?.closest(`[${(0, $a6ab52421b090de9$export$865b50f6578fb126)}]`);
                    if (zone) {
                        const zoneId = zone.getAttribute((0, $a6ab52421b090de9$export$865b50f6578fb126));
                        const zoneType = zone.getAttribute((0, $a6ab52421b090de9$export$ec286b319a16492b)) || "stream";
                        if (zoneId) {
                            broker.mark({
                                id: zoneId,
                                contentType: zoneType
                            });
                            return;
                        }
                    }
                    broker.mark({
                        id: id,
                        contentType: contentType
                    });
                    return;
                }
            });
            observer.observe(el, {
                childList: true,
                characterData: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        };
        t2 = [
            id,
            contentType,
            broker
        ];
        $[0] = broker;
        $[1] = contentType;
        $[2] = id;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            [(0, $a6ab52421b090de9$export$79177233ead60764)]: true
        };
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            ...t3
        }, children);
        $[6] = children;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function ViewDeadAirTrackerInner({ id: id, contentType: contentType, children: children }) {
    const broker = (0, $ef8883bd884fedd1$export$a4761dc3d9967545)();
    const containerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el || !broker) return;
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations){
                const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
                // Skip if mutation is inside a nested tracker (handled by inner tracker)
                const closestTracker = target?.closest(`[${(0, $a6ab52421b090de9$export$79177233ead60764)}]`);
                if (closestTracker && closestTracker !== el) continue;
                // Check if mutation is inside a zone
                const zone = target?.closest(`[${(0, $a6ab52421b090de9$export$865b50f6578fb126)}]`);
                if (zone) {
                    const zoneId = zone.getAttribute((0, $a6ab52421b090de9$export$865b50f6578fb126));
                    const zoneType = zone.getAttribute((0, $a6ab52421b090de9$export$ec286b319a16492b)) || 'stream';
                    if (zoneId) {
                        broker.mark({
                            id: zoneId,
                            contentType: zoneType
                        });
                        return;
                    }
                }
                // Normal mutation in the tracker's own area
                broker.mark({
                    id: id,
                    contentType: contentType
                });
                return;
            }
        });
        observer.observe(el, {
            childList: true,
            characterData: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, [
        id,
        contentType,
        broker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        [(0, $a6ab52421b090de9$export$79177233ead60764)]: true
    }, children);
};















var $bPFqZ = parcelRequire("bPFqZ");





var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


const $29b8fcc2c490454a$export$71fc9852e6ce4cb4 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("40PcG")), {
        moduleId: "9c99f5e2",
        moduleName: "A2uiSurfaceAdapterRovoEntryPointComponent",
        priority: "interaction",
        moduleId: 'conversation-assistant-a2ui-surface-adapter-rovo-entrypoint'
    }),
    getPreloadProps: ()=>({})
});


const $0128c9298f048ac6$var$ENTRY_POINT_ID = 'a2ui-surface-adapter-rovo';
const $0128c9298f048ac6$var$A2uiSurfaceEntryPointContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { messages: messages, onAction: onAction } = t0;
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    let t1;
    if ($[0] !== relayEnvironment) {
        t1 = (0, $6SsN4.loadEntryPoint)({
            getEnvironment: ()=>relayEnvironment
        }, (0, $29b8fcc2c490454a$export$71fc9852e6ce4cb4), {});
        $[0] = relayEnvironment;
        $[1] = t1;
    } else t1 = $[1];
    const entryPointReference = t1;
    let t2;
    if ($[2] !== messages || $[3] !== onAction) {
        t2 = {
            messages: messages,
            onAction: onAction
        };
        $[2] = messages;
        $[3] = onAction;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== entryPointReference || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
            id: $0128c9298f048ac6$var$ENTRY_POINT_ID,
            entryPointReference: entryPointReference,
            runtimeProps: t2,
            fallback: null
        });
        $[5] = entryPointReference;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ messages: messages, onAction: onAction })=>{
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    // The renderer has no queries, so the reference only depends on the
    // environment — `messages`/`onAction` flow through as runtime props below.
    const entryPointReference = (0, $cozmU.useMemo)(()=>(0, $6SsN4.loadEntryPoint)({
            getEnvironment: ()=>relayEnvironment
        }, (0, $29b8fcc2c490454a$export$71fc9852e6ce4cb4), {}), [
        relayEnvironment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0128c9298f048ac6$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        runtimeProps: {
            messages: messages,
            onAction: onAction
        },
        fallback: null
    });
};
const $0128c9298f048ac6$export$eba9f589c47b4bf1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0128c9298f048ac6$var$A2uiSurfaceEntryPointContainer, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0128c9298f048ac6$var$A2uiSurfaceEntryPointContainer, props));
};








const $fd834c58c02fb2c6$export$e81ab47967df822d = (conversationMessages, enabled)=>{
    const map = new Map();
    if (!enabled) return map;
    let pendingHumanId;
    for (const message of conversationMessages){
        if ((0, $igOtY.isStoreHuman)(message)) pendingHumanId = String(message.content.id);
        else if ((0, $igOtY.isStoreAssistant)(message) && pendingHumanId) {
            const author = message.content.message.message.author;
            const respondedAgentId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(author?.identity_account_id) ?? (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(author?.ari);
            if (respondedAgentId) map.set(pendingHumanId, respondedAgentId);
            pendingHumanId = undefined;
        }
    }
    return map;
};






















































const $ed60785bf15662c7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    conversationNotFoundTitle: {
        id: "ai-mate.chat-error-banner.title",
        defaultMessage: "Start new chat"
    },
    conversationNotFoundDescription: {
        id: "ai-mate.chat-error-banner.description",
        defaultMessage: "Your chat history is saved up to 30 days."
    }
});


const $f9e4c6c89a8fe101$export$cb1f298a93bf82c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $ed60785bf15662c7$export$defe85febe8b728c).conversationNotFoundTitle);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage((0, $ed60785bf15662c7$export$defe85febe8b728c).conversationNotFoundDescription);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t0,
            appearance: "information"
        }, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: formatMessage((0, $ed60785bf15662c7$export$defe85febe8b728c).conversationNotFoundTitle),
        appearance: "information"
    }, formatMessage((0, $ed60785bf15662c7$export$defe85febe8b728c).conversationNotFoundDescription));
};



var $4NVkH = parcelRequire("4NVkH");

































var $bg8wx = parcelRequire("bg8wx");


var $fhR3q = parcelRequire("fhR3q");


var $cCZyl = parcelRequire("cCZyl");


const $97f4c0391f0f698b$var$VirtualizedMessageGroupsLazyComponent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("a0EA0")).then((module)=>({
            default: module.VirtualizedMessageGroups
        })));
Object.assign($97f4c0391f0f698b$var$VirtualizedMessageGroupsLazyComponent, {
    displayName: 'lazy(VirtualizedMessageGroups)'
});

const $97f4c0391f0f698b$var$VirtualizedMessageGroupsLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "8UtRc",
    name: "VirtualizedMessageGroupsLoadableComponent",
    loader: ()=>(parcelRequire("a0EA0")).then((module)=>module.VirtualizedMessageGroups),
    loading: ()=>null
});
const $97f4c0391f0f698b$var$VirtualizedMessageGroupsWithSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function VirtualizedMessageGroupsWithSuspense(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroupsLazyComponent, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function VirtualizedMessageGroupsWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroupsLazyComponent, props));
};
const $97f4c0391f0f698b$var$VirtualizedMessageGroups = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("nike_r19_react_loadable") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroupsWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroupsLoadableComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $iDrrr.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroupsWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroupsLoadableComponent, props);
const $97f4c0391f0f698b$var$OlderMessageGroupContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { group: group, renderMessage: renderMessage } = t0;
    let t1;
    if ($[0] !== group || $[1] !== renderMessage) {
        let t2;
        if ($[3] !== renderMessage) {
            t2 = (msg, index)=>renderMessage(msg, index);
            $[3] = renderMessage;
            $[4] = t2;
        } else t2 = $[4];
        t1 = group.map(t2);
        $[0] = group;
        $[1] = renderMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "rovo-chat-message-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, t1));
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ conversationId: _conversationId, group: group, renderMessage: renderMessage, renderMessageVersion: _renderMessageVersion })=>{
    // extra <div> to prevent re-creation, see https://atlassian.slack.com/archives/C0677M19GU9/p1725849002478889
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "rovo-chat-message-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, group.map((msg, index)=>renderMessage(msg, index))));
};
const $97f4c0391f0f698b$var$MemoizedOlderMessageGroupContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($97f4c0391f0f698b$var$OlderMessageGroupContent, (previousProps, nextProps)=>previousProps.conversationId === nextProps.conversationId && (0, $bg8wx.areMessageGroupsEqual)(previousProps.group, nextProps.group) && // Keep a behavior version in the comparator for closure safety. Function identity
    // changes during streaming can be unrelated to already-rendered older groups.
    (0, $cCZyl.areRenderVersionsEqual)(previousProps.renderMessageVersion, nextProps.renderMessageVersion));
const $97f4c0391f0f698b$var$LatestMessageGroupMessages = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { group: group, renderMessage: renderMessage } = t0;
    let t1;
    if ($[0] !== group) {
        t1 = (0, $jcJSP.findLastIndex)(group, $97f4c0391f0f698b$var$_temp);
        $[0] = group;
        $[1] = t1;
    } else t1 = $[1];
    const lastAssistantMessageInGroupIndex = t1;
    let t2;
    if ($[2] !== group || $[3] !== lastAssistantMessageInGroupIndex || $[4] !== renderMessage) {
        let t3;
        if ($[6] !== lastAssistantMessageInGroupIndex || $[7] !== renderMessage) {
            t3 = (msg_0, index)=>renderMessage(msg_0, index, lastAssistantMessageInGroupIndex === index);
            $[6] = lastAssistantMessageInGroupIndex;
            $[7] = renderMessage;
            $[8] = t3;
        } else t3 = $[8];
        t2 = group.map(t3);
        $[2] = group;
        $[3] = lastAssistantMessageInGroupIndex;
        $[4] = renderMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, t2);
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ conversationId: _conversationId, group: group, groupIndex: _groupIndex, renderMessage: renderMessage, renderMessageVersion: _renderMessageVersion, totalGroups: _totalGroups })=>{
    const lastAssistantMessageInGroupIndex = (0, $jcJSP.findLastIndex)(group, (msg)=>(0, $igOtY.isStoreAssistant)(msg));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, group.map((msg_0, index)=>{
        return renderMessage(msg_0, index, lastAssistantMessageInGroupIndex === index);
    }));
};
const $97f4c0391f0f698b$var$MemoizedLatestMessageGroupMessages = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($97f4c0391f0f698b$var$LatestMessageGroupMessages, (previousProps, nextProps)=>previousProps.conversationId === nextProps.conversationId && (0, $bg8wx.areMessageGroupsEqual)(previousProps.group, nextProps.group) && previousProps.groupIndex === nextProps.groupIndex && previousProps.totalGroups === nextProps.totalGroups && (0, $cCZyl.areRenderVersionsEqual)(previousProps.renderMessageVersion, nextProps.renderMessageVersion));
const $97f4c0391f0f698b$var$LatestMessageGroupContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { conversationId: conversationId, group: group, groupIndex: groupIndex, lastMessageGroupRef: lastMessageGroupRef, minHeight: minHeight, renderMessage: renderMessage, renderMessageVersion: renderMessageVersion, totalGroups: totalGroups } = t0;
    let t1;
    if ($[0] !== minHeight) {
        t1 = minHeight !== undefined ? {
            minHeight: minHeight
        } : {};
        $[0] = minHeight;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== conversationId || $[3] !== group || $[4] !== groupIndex || $[5] !== renderMessage || $[6] !== renderMessageVersion || $[7] !== totalGroups) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$MemoizedLatestMessageGroupMessages, {
            conversationId: conversationId,
            group: group,
            groupIndex: groupIndex,
            renderMessage: renderMessage,
            renderMessageVersion: renderMessageVersion,
            totalGroups: totalGroups
        });
        $[2] = conversationId;
        $[3] = group;
        $[4] = groupIndex;
        $[5] = renderMessage;
        $[6] = renderMessageVersion;
        $[7] = totalGroups;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== lastMessageGroupRef || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: lastMessageGroupRef,
            style: t1,
            testId: "rovo-chat-message-group"
        }, t2);
        $[9] = lastMessageGroupRef;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ conversationId: conversationId, group: group, groupIndex: groupIndex, lastMessageGroupRef: lastMessageGroupRef, minHeight: minHeight, renderMessage: renderMessage, renderMessageVersion: renderMessageVersion, totalGroups: totalGroups })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: lastMessageGroupRef,
        style: minHeight !== undefined ? {
            minHeight: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            minHeight
        } : {},
        testId: "rovo-chat-message-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$MemoizedLatestMessageGroupMessages, {
        conversationId: conversationId,
        group: group,
        groupIndex: groupIndex,
        renderMessage: renderMessage,
        renderMessageVersion: renderMessageVersion,
        totalGroups: totalGroups
    }));
};
const $97f4c0391f0f698b$var$MemoizedLatestMessageGroupContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($97f4c0391f0f698b$var$LatestMessageGroupContent, (previousProps, nextProps)=>previousProps.conversationId === nextProps.conversationId && (0, $bg8wx.areMessageGroupsEqual)(previousProps.group, nextProps.group) && previousProps.groupIndex === nextProps.groupIndex && previousProps.totalGroups === nextProps.totalGroups && previousProps.minHeight === nextProps.minHeight && (0, $cCZyl.areRenderVersionsEqual)(previousProps.renderMessageVersion, nextProps.renderMessageVersion));
const $97f4c0391f0f698b$export$e8c41b08267e517d = ({ conversationId: conversationId, messageGroups: messageGroups, olderMessageGroups: olderMessageGroups, isVirtualizationEnabled: isVirtualizationEnabled, isRenderStabilizationEnabled: isRenderStabilizationEnabled, chatHistoryContainerRef: chatHistoryContainerRef, isScrollPending: isScrollPending, lastMessageGroupRef: lastMessageGroupRef, renderLatestMessage: renderLatestMessage, renderLatestMessageVersion: renderLatestMessageVersion, renderOlderMessage: renderOlderMessage, renderOlderMessageVersion: renderOlderMessageVersion, renderMessage: renderMessage, scrollToBottomGeneration: scrollToBottomGeneration })=>{
    const [chatHistoryContainerHeight, setChatHistoryContainerHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const resolvedRenderOlderMessage = renderOlderMessage ?? ((msg, index)=>renderMessage(msg, index, false));
    const resolvedRenderOlderMessageVersion = renderOlderMessageVersion ?? renderMessage;
    const resolvedRenderLatestMessage = renderLatestMessage ?? renderMessage;
    const resolvedRenderLatestMessageVersion = renderLatestMessageVersion ?? renderMessage;
    const chatHistoryContainerElement = chatHistoryContainerRef.current;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const element = chatHistoryContainerRef.current;
        if (!element) {
            setChatHistoryContainerHeight(undefined);
            return;
        }
        const updateHeight = ()=>{
            const nextHeight = element.clientHeight || undefined;
            setChatHistoryContainerHeight((previousHeight)=>previousHeight === nextHeight ? previousHeight : nextHeight);
        };
        updateHeight();
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
        return (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: updateHeight
        });
    }, [
        chatHistoryContainerElement,
        chatHistoryContainerRef
    ]);
    const latestGroupMinHeight = chatHistoryContainerHeight && !isScrollPending ? (0, $fhR3q.getLastMessageGroupMinHeight)(chatHistoryContainerHeight) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: 'message-groups'
    }, isVirtualizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$VirtualizedMessageGroups, {
        conversationId: conversationId,
        messageGroups: messageGroups,
        olderMessageGroups: olderMessageGroups,
        chatHistoryContainerRef: chatHistoryContainerRef,
        isRenderStabilizationEnabled: isRenderStabilizationEnabled,
        isScrollPending: isScrollPending,
        lastMessageGroupRef: lastMessageGroupRef,
        renderLatestMessage: resolvedRenderLatestMessage,
        renderLatestMessageVersion: resolvedRenderLatestMessageVersion,
        renderOlderMessage: resolvedRenderOlderMessage,
        renderOlderMessageVersion: resolvedRenderOlderMessageVersion,
        renderMessage: renderMessage,
        scrollToBottomGeneration: scrollToBottomGeneration
    }) : messageGroups.map((group, i)=>{
        const isLastGroup = i === messageGroups.length - 1;
        if (!isLastGroup) return isRenderStabilizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$MemoizedOlderMessageGroupContent, {
            key: i,
            conversationId: conversationId,
            group: group,
            renderMessage: resolvedRenderOlderMessage,
            renderMessageVersion: resolvedRenderOlderMessageVersion
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$OlderMessageGroupContent, {
            key: i,
            conversationId: conversationId,
            group: group,
            renderMessage: (msg_0, index_0)=>renderMessage(msg_0, index_0, false),
            renderMessageVersion: renderMessage
        });
        return isRenderStabilizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$MemoizedLatestMessageGroupContent, {
            key: i,
            conversationId: conversationId,
            group: group,
            groupIndex: i,
            lastMessageGroupRef: lastMessageGroupRef,
            minHeight: latestGroupMinHeight,
            renderMessage: resolvedRenderLatestMessage,
            renderMessageVersion: resolvedRenderLatestMessageVersion,
            totalGroups: messageGroups.length
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97f4c0391f0f698b$var$LatestMessageGroupContent, {
            key: i,
            conversationId: conversationId,
            group: group,
            groupIndex: i,
            lastMessageGroupRef: lastMessageGroupRef,
            minHeight: latestGroupMinHeight,
            renderMessage: renderMessage,
            renderMessageVersion: renderMessage,
            totalGroups: messageGroups.length
        });
    }));
};
function $97f4c0391f0f698b$var$_temp(msg) {
    return (0, $igOtY.isStoreAssistant)(msg);
}


const $9ab6beeeefe24fcf$var$renderChatHistoryMessage = ({ storeChatItem: storeChatItem, context: context, renderers: renderers })=>{
    switch(storeChatItem.type){
        case 'HUMAN':
            return renderers.human(storeChatItem, context);
        case 'ASSISTANT':
            return renderers.assistant(storeChatItem, context);
        case 'FOLLOW_UP':
            return renderers.followUp(storeChatItem, context);
        case 'GUARD_BLOCK':
            return renderers.guardBlock(storeChatItem, context);
        case 'ERROR':
            return renderers.error(storeChatItem, context);
        case 'LIVE_CHAT':
        case 'TWILIO_LIVE_CHAT_AGENT':
        case 'PHOTO_CARD_PREVIEW':
        case 'MEMORY_UPDATE':
        case 'ACTION_PREPARE':
        case 'ACTION_COMPLETE':
        case 'USAGE_HINT':
            return null;
        default:
            {
                const exhaustiveStoreChatItem = storeChatItem;
                return exhaustiveStoreChatItem;
            }
    }
};
const $9ab6beeeefe24fcf$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _1mT5xdRAKS",
    scrollingDiv: "_4bt5LAIZbP _2WAcuGIZbP _39xV02N91d _0Of8r2Pgdg _1wydGW5zaO _2Zuz6Q5zaO _1Znuxb5zaO",
    containerFlex: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $9ab6beeeefe24fcf$var$stylesCompiled = {
    fsCentered: "_2YLqiKIZbP _1EqgXlflcy"
};
const $9ab6beeeefe24fcf$export$e9cbb50bcfcf2776 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { fullScreen: fullScreen, isFullScreenErrorState: isFullScreenErrorState, isPulseExperimentEnabled: isPulseExperimentEnabled, liveRegionText: liveRegionText, mode: mode, shouldShowConversationHistoryWarning: shouldShowConversationHistoryWarning, conversationMessagesResponseCount: conversationMessagesResponseCount, conversationHistoryWarningMessage: conversationHistoryWarningMessage, showSkills: showSkills, showPromptLibrary: showPromptLibrary, chatHistoryContainerRef: chatHistoryContainerRef, messageGroupsContentProps: messageGroupsContentProps, messagePresentation: messagePresentation } = t0;
    let t1;
    if ($[0] !== messagePresentation) {
        t1 = (storeChatItem, index, isLastAssistant, configuration)=>{
            const renderedMessage = $9ab6beeeefe24fcf$var$renderChatHistoryMessage({
                storeChatItem: storeChatItem,
                context: {
                    index: index,
                    isLastAssistant: isLastAssistant,
                    shouldRenderLiveAssistantAffordances: configuration.shouldRenderLiveAssistantAffordances
                },
                renderers: messagePresentation.renderers
            });
            return messagePresentation.decorateMessage ? messagePresentation.decorateMessage(storeChatItem, index, renderedMessage) : renderedMessage;
        };
        $[0] = messagePresentation;
        $[1] = t1;
    } else t1 = $[1];
    const renderMessageWithConfiguration = t1;
    let t2;
    if ($[2] !== messagePresentation.default || $[3] !== renderMessageWithConfiguration) {
        t2 = (storeChatItem_0, index_0, isLastAssistant_0)=>renderMessageWithConfiguration(storeChatItem_0, index_0, isLastAssistant_0, messagePresentation.default);
        $[2] = messagePresentation.default;
        $[3] = renderMessageWithConfiguration;
        $[4] = t2;
    } else t2 = $[4];
    const renderMessage = t2;
    const latestMessageConfiguration = messagePresentation.latest;
    const olderMessageConfiguration = messagePresentation.older;
    let t3;
    if ($[5] !== latestMessageConfiguration || $[6] !== renderMessageWithConfiguration) {
        t3 = latestMessageConfiguration ? (storeChatItem_1, index_1, isLastAssistant_1)=>renderMessageWithConfiguration(storeChatItem_1, index_1, isLastAssistant_1, latestMessageConfiguration) : undefined;
        $[5] = latestMessageConfiguration;
        $[6] = renderMessageWithConfiguration;
        $[7] = t3;
    } else t3 = $[7];
    const renderLatestMessage = t3;
    let t4;
    if ($[8] !== olderMessageConfiguration || $[9] !== renderMessageWithConfiguration) {
        t4 = olderMessageConfiguration ? (storeChatItem_2, index_2)=>renderMessageWithConfiguration(storeChatItem_2, index_2, false, olderMessageConfiguration) : undefined;
        $[8] = olderMessageConfiguration;
        $[9] = renderMessageWithConfiguration;
        $[10] = t4;
    } else t4 = $[10];
    const renderOlderMessage = t4;
    let t5;
    if ($[11] !== latestMessageConfiguration?.renderVersion || $[12] !== renderLatestMessage) {
        t5 = renderLatestMessage ? {
            renderLatestMessage: renderLatestMessage,
            renderLatestMessageVersion: latestMessageConfiguration?.renderVersion ?? renderLatestMessage
        } : {};
        $[11] = latestMessageConfiguration?.renderVersion;
        $[12] = renderLatestMessage;
        $[13] = t5;
    } else t5 = $[13];
    const latestMessageRendererProps = t5;
    let t6;
    if ($[14] !== olderMessageConfiguration?.renderVersion || $[15] !== renderOlderMessage) {
        t6 = renderOlderMessage ? {
            renderOlderMessage: renderOlderMessage,
            renderOlderMessageVersion: olderMessageConfiguration?.renderVersion ?? renderOlderMessage
        } : {};
        $[14] = olderMessageConfiguration?.renderVersion;
        $[15] = renderOlderMessage;
        $[16] = t6;
    } else t6 = $[16];
    const olderMessageRendererProps = t6;
    let t7;
    if ($[17] !== latestMessageRendererProps || $[18] !== messageGroupsContentProps || $[19] !== olderMessageRendererProps || $[20] !== renderMessage) {
        t7 = {
            ...messageGroupsContentProps,
            renderMessage: renderMessage,
            ...latestMessageRendererProps,
            ...olderMessageRendererProps
        };
        $[17] = latestMessageRendererProps;
        $[18] = messageGroupsContentProps;
        $[19] = olderMessageRendererProps;
        $[20] = renderMessage;
        $[21] = t7;
    } else t7 = $[21];
    const resolvedMessageGroupsContentProps = t7;
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $w6R6I.cx)($9ab6beeeefe24fcf$var$styles.container, (0, $iDrrr.fg)("rovo_skills_directory_ui") && $9ab6beeeefe24fcf$var$styles.containerFlex);
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== liveRegionText) {
        t9 = (0, $iDrrr.fg)("rovo_chat_trace_aria_live_updates") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            testId: "chat-history-status-live-region",
            role: "status"
        }, liveRegionText);
        $[23] = liveRegionText;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== isPulseExperimentEnabled) {
        t10 = isPulseExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3908b4de7933a21d$export$95326f479f919118), null) : null;
        $[25] = isPulseExperimentEnabled;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== isFullScreenErrorState) {
        t11 = isFullScreenErrorState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9e4c6c89a8fe101$export$cb1f298a93bf82c7), null);
        $[27] = isFullScreenErrorState;
        $[28] = t11;
    } else t11 = $[28];
    const t12 = fullScreen && $9ab6beeeefe24fcf$var$stylesCompiled.fsCentered;
    let t13;
    if ($[29] !== t12) {
        t13 = (0, $hekY6.default)([
            t12
        ]);
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== conversationHistoryWarningMessage || $[32] !== mode || $[33] !== shouldShowConversationHistoryWarning) {
        t14 = shouldShowConversationHistoryWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
            variant: "neutral",
            mode: mode?.toString().toLowerCase()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: "",
            color: "var(--ds-icon-information, #357DE8)",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold",
            size: "medium"
        }, conversationHistoryWarningMessage)));
        $[31] = conversationHistoryWarningMessage;
        $[32] = mode;
        $[33] = shouldShowConversationHistoryWarning;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== resolvedMessageGroupsContentProps) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97f4c0391f0f698b$export$e8c41b08267e517d), resolvedMessageGroupsContentProps);
        $[35] = resolvedMessageGroupsContentProps;
        $[36] = t15;
    } else t15 = $[36];
    let t16;
    if ($[37] !== t13 || $[38] !== t14 || $[39] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t13
        }, t14, t15);
        $[37] = t13;
        $[38] = t14;
        $[39] = t15;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== chatHistoryContainerRef || $[42] !== t11 || $[43] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: chatHistoryContainerRef,
            xcss: $9ab6beeeefe24fcf$var$styles.scrollingDiv,
            testId: "chat-history-container"
        }, t11, t16);
        $[41] = chatHistoryContainerRef;
        $[42] = t11;
        $[43] = t16;
        $[44] = t17;
    } else t17 = $[44];
    let t18;
    if ($[45] !== conversationMessagesResponseCount || $[46] !== messageGroupsContentProps.messageGroups.length || $[47] !== messageGroupsContentProps.olderMessageGroups.length) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                conversationHistorySubScreen: "messages-screen",
                conversationMessagesResponseCount: conversationMessagesResponseCount,
                messageGroupsCount: messageGroupsContentProps.messageGroups.length,
                olderMessageGroupsCount: messageGroupsContentProps.olderMessageGroups.length
            }
        });
        $[45] = conversationMessagesResponseCount;
        $[46] = messageGroupsContentProps.messageGroups.length;
        $[47] = messageGroupsContentProps.olderMessageGroups.length;
        $[48] = t18;
    } else t18 = $[48];
    let t19;
    if ($[49] !== showPromptLibrary || $[50] !== showSkills || $[51] !== t10 || $[52] !== t17 || $[53] !== t18 || $[54] !== t9) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t8
        }, t9, t10, t17, showSkills, showPromptLibrary, t18);
        $[49] = showPromptLibrary;
        $[50] = showSkills;
        $[51] = t10;
        $[52] = t17;
        $[53] = t18;
        $[54] = t9;
        $[55] = t19;
    } else t19 = $[55];
    return t19;
} : ({ fullScreen: fullScreen, isFullScreenErrorState: isFullScreenErrorState, isPulseExperimentEnabled: isPulseExperimentEnabled, liveRegionText: liveRegionText, mode: mode, shouldShowConversationHistoryWarning: shouldShowConversationHistoryWarning, conversationMessagesResponseCount: conversationMessagesResponseCount, conversationHistoryWarningMessage: conversationHistoryWarningMessage, showSkills: showSkills, showPromptLibrary: showPromptLibrary, chatHistoryContainerRef: chatHistoryContainerRef, messageGroupsContentProps: messageGroupsContentProps, messagePresentation: messagePresentation })=>{
    const renderMessageWithConfiguration = (storeChatItem, index, isLastAssistant, configuration)=>{
        const renderedMessage = $9ab6beeeefe24fcf$var$renderChatHistoryMessage({
            storeChatItem: storeChatItem,
            context: {
                index: index,
                isLastAssistant: isLastAssistant,
                shouldRenderLiveAssistantAffordances: configuration.shouldRenderLiveAssistantAffordances
            },
            renderers: messagePresentation.renderers
        });
        return messagePresentation.decorateMessage ? messagePresentation.decorateMessage(storeChatItem, index, renderedMessage) : renderedMessage;
    };
    const renderMessage = (storeChatItem_0, index_0, isLastAssistant_0)=>renderMessageWithConfiguration(storeChatItem_0, index_0, isLastAssistant_0, messagePresentation.default);
    const latestMessageConfiguration = messagePresentation.latest;
    const olderMessageConfiguration = messagePresentation.older;
    const renderLatestMessage = latestMessageConfiguration ? (storeChatItem_1, index_1, isLastAssistant_1)=>renderMessageWithConfiguration(storeChatItem_1, index_1, isLastAssistant_1, latestMessageConfiguration) : undefined;
    const renderOlderMessage = olderMessageConfiguration ? (storeChatItem_2, index_2)=>renderMessageWithConfiguration(storeChatItem_2, index_2, false, olderMessageConfiguration) : undefined;
    const latestMessageRendererProps = renderLatestMessage ? {
        renderLatestMessage: renderLatestMessage,
        renderLatestMessageVersion: latestMessageConfiguration?.renderVersion ?? renderLatestMessage
    } : {};
    const olderMessageRendererProps = renderOlderMessage ? {
        renderOlderMessage: renderOlderMessage,
        renderOlderMessageVersion: olderMessageConfiguration?.renderVersion ?? renderOlderMessage
    } : {};
    const resolvedMessageGroupsContentProps = {
        ...messageGroupsContentProps,
        renderMessage: renderMessage,
        ...latestMessageRendererProps,
        ...olderMessageRendererProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($9ab6beeeefe24fcf$var$styles.container, (0, $iDrrr.fg)('rovo_skills_directory_ui') && $9ab6beeeefe24fcf$var$styles.containerFlex)
    }, (0, $iDrrr.fg)('rovo_chat_trace_aria_live_updates') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        testId: "chat-history-status-live-region",
        role: "status"
    }, liveRegionText), isPulseExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3908b4de7933a21d$export$95326f479f919118), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: chatHistoryContainerRef,
        xcss: $9ab6beeeefe24fcf$var$styles.scrollingDiv,
        testId: "chat-history-container"
    }, isFullScreenErrorState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9e4c6c89a8fe101$export$cb1f298a93bf82c7), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            fullScreen && $9ab6beeeefe24fcf$var$stylesCompiled.fsCentered
        ])
    }, shouldShowConversationHistoryWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
        variant: "neutral",
        mode: mode?.toString().toLowerCase()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-information, #357DE8)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "medium"
    }, conversationHistoryWarningMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97f4c0391f0f698b$export$e8c41b08267e517d), resolvedMessageGroupsContentProps))), showSkills, showPromptLibrary, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            conversationHistorySubScreen: 'messages-screen',
            conversationMessagesResponseCount: conversationMessagesResponseCount,
            messageGroupsCount: messageGroupsContentProps.messageGroups.length,
            olderMessageGroupsCount: messageGroupsContentProps.olderMessageGroups.length
        }
    }));
};


/* ConversationActionContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 






















var $bQupv = parcelRequire("bQupv");

const $06e06793fd7485e7$export$c31f962be9ed3f35 = async ({ action: action, dialogues: dialogues, createSeededConversation: createSeededConversation, fallbackName: fallbackName, sourceId: sourceId, id: id, defaultFollowUpSource: defaultFollowUpSource, agentId: agentId })=>{
    const seededConversationOptions = (0, $bQupv.getActionSeededConversationOptions)(action);
    const newConversationId = await createSeededConversation({
        name: seededConversationOptions?.name ?? fallbackName,
        dialogues: dialogues,
        ...sourceId ? {
            sourceId: sourceId
        } : {},
        ...id ? {
            id: id
        } : {},
        followUpSource: seededConversationOptions?.followUpSource ?? defaultFollowUpSource,
        ...agentId ? {
            agentId: agentId
        } : {},
        ...seededConversationOptions?.tags ? {
            tags: seededConversationOptions.tags
        } : {},
        ...seededConversationOptions?.skipNextFetch ? {
            skipNextFetch: seededConversationOptions.skipNextFetch
        } : {}
    });
    if (!newConversationId) return undefined;
    seededConversationOptions?.onCreated?.(newConversationId);
    return newConversationId;
};





const $482639a6cae155db$export$278ad0e86e72f07b = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.followUps ?? [];





const $d701f0955d4384b4$export$a90bb5fb0bd72e89 = ({ activeAction: activeAction, agent: agent, storeUserMessages: storeUserMessages, webSearchEnabled: webSearchEnabled, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, appFilters: appFilters })=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $5BOJB.useActiveAction));
    const { createSeededConversation: createSeededConversation, sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const canSeedConversation = activeAction?.customFollowUpContext?.available === true;
    const followUp = (0, $cozmU.useMemo)(()=>{
        if (!canSeedConversation) return undefined;
        const followUps = (0, $482639a6cae155db$export$278ad0e86e72f07b)(activeAction);
        if (followUps.length === 0) return undefined;
        return {
            type: 'FOLLOW_UP',
            content: {
                type: 'FOLLOW_UP_QUERIES',
                message: {
                    follow_ups: followUps.map((text)=>({
                            type: 'SYNTHETIC',
                            text: text
                        }))
                },
                millisOffset: 0
            },
            id: -1
        };
    }, [
        activeAction,
        canSeedConversation
    ]);
    const onFollowUpClick = (0, $cozmU.useCallback)(async (prompt)=>{
        const customFollowUpContext = activeAction?.customFollowUpContext;
        if (!canSeedConversation || !customFollowUpContext?.available) return;
        const dialogues = await customFollowUpContext.fetch();
        if (!dialogues) return;
        const newConversationId = await (0, $06e06793fd7485e7$export$c31f962be9ed3f35)({
            action: activeAction,
            dialogues: dialogues,
            createSeededConversation: createSeededConversation,
            fallbackName: activeAction.title?.trim() || undefined,
            defaultFollowUpSource: 'ai-smart-button-dynamic-surface',
            agentId: agent?.id
        });
        if (!newConversationId) return;
        // Engage succeeds via `onCreated`; only remove the view, not dismiss state.
        setActiveAction(undefined);
        sendMessage({
            agent: agent,
            prompt: (0, $6rwn6.encodeAdf)(prompt),
            conversationId: newConversationId,
            storeUserMessages: storeUserMessages,
            messageSources: {
                interactionSource: 'followUps',
                followUpSource: 'ai-mate'
            },
            webSearchEnabled: webSearchEnabled,
            addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference,
            appFilters: appFilters
        });
    }, [
        activeAction,
        agent,
        appFilters,
        addCurrentPageAsContextUserPreference,
        canSeedConversation,
        createSeededConversation,
        sendMessage,
        setActiveAction,
        storeUserMessages,
        webSearchEnabled
    ]);
    return {
        followUp: followUp,
        onFollowUpClick: onFollowUpClick
    };
};

































const $468832809baddf05$var$styles = {
    actionViewContainer: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    actionViewHeader: "_4xdlr0z9WS _3138428HPE _1DCdHi8HPE",
    actionViewHeaderContent: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $468832809baddf05$export$3252d34b88dec43f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { action: action, footer: footer, hideActionHeader: t1 } = t0;
    const hideActionHeader = t1 === undefined ? false : t1;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const Icon = action.icon;
    const actionId = action.id;
    const renderActionView = action.viewConfig?.render;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[0] = t2;
    } else t2 = $[0];
    const isRenderStabilizationEnabled = t2 === true;
    let t3;
    if ($[1] !== renderActionView) {
        t3 = isRenderStabilizationEnabled ? renderActionView?.() : undefined;
        $[1] = renderActionView;
        $[2] = t3;
    } else t3 = $[2];
    const memoizedActionView = t3;
    let t4;
    if ($[3] !== memoizedActionView || $[4] !== renderActionView) {
        t4 = isRenderStabilizationEnabled ? memoizedActionView : renderActionView?.();
        $[3] = memoizedActionView;
        $[4] = renderActionView;
        $[5] = t4;
    } else t4 = $[5];
    const actionView = t4;
    const analyticsActionIdentity = isRenderStabilizationEnabled ? actionId : action;
    const showActionViewHeader = !hideActionHeader && !("closePanelOnSelection" in action && action.closePanelOnSelection);
    let t5;
    let t6;
    if ($[6] !== analyticsActionIdentity || $[7] !== sendAnalyticsEvent) {
        t5 = ()=>{
            const analyticsActionId = typeof analyticsActionIdentity === "string" ? analyticsActionIdentity : analyticsActionIdentity.id;
            sendAnalyticsEvent({
                eventType: "screen",
                name: "aiMateActionView",
                attributes: {
                    actionId: analyticsActionId
                }
            });
        };
        t6 = [
            analyticsActionIdentity,
            sendAnalyticsEvent
        ];
        $[6] = analyticsActionIdentity;
        $[7] = sendAnalyticsEvent;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[10] !== Icon || $[11] !== action.title || $[12] !== showActionViewHeader) {
        t7 = showActionViewHeader && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $468832809baddf05$var$styles.actionViewHeader
        }, /*#__PURE__*/ $cozmU.createElement((0, $4NVkH.Paper), {
            variant: "accent",
            verticalSpace: false,
            pinchCorner: "bottomRight"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $468832809baddf05$var$styles.actionViewHeaderContent
        }, /*#__PURE__*/ $cozmU.createElement(Icon, {
            label: "",
            primaryColor: "var(--ds-icon-subtlest, #6B6E76)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, action.title))));
        $[10] = Icon;
        $[11] = action.title;
        $[12] = showActionViewHeader;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== action.title) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
            data: {
                conversationActionTitle: action.title
            }
        });
        $[14] = action.title;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== actionView) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $468832809baddf05$var$styles.actionViewContainer
        }, actionView);
        $[16] = actionView;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t8 || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $a1L5E.default), {
            name: "conversation-action"
        }, t8, t9);
        $[18] = t8;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== footer || $[22] !== t10 || $[23] !== t7) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t7, t10, footer);
        $[21] = footer;
        $[22] = t10;
        $[23] = t7;
        $[24] = t11;
    } else t11 = $[24];
    return t11;
} : ({ action: action, mode: _mode, footer: footer, hideActionHeader: hideActionHeader = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const Icon = action.icon;
    const actionId = action.id;
    const renderActionView = action.viewConfig?.render;
    const isRenderStabilizationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true; // `viewConfig.render` is a pure render function by contract; the treatment caches
    // its output only while the render function identity is unchanged.
    const memoizedActionView = (0, $cozmU.useMemo)(()=>isRenderStabilizationEnabled ? renderActionView?.() : undefined, [
        isRenderStabilizationEnabled,
        renderActionView
    ]);
    const actionView = isRenderStabilizationEnabled ? memoizedActionView : renderActionView?.();
    const analyticsActionIdentity = isRenderStabilizationEnabled ? actionId : action;
    const showActionViewHeader = !hideActionHeader && !('closePanelOnSelection' in action && action.closePanelOnSelection);
    (0, $cozmU.useEffect)(()=>{
        const analyticsActionId = typeof analyticsActionIdentity === 'string' ? analyticsActionIdentity : analyticsActionIdentity.id;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'aiMateActionView',
            attributes: {
                actionId: analyticsActionId
            }
        });
    }, [
        analyticsActionIdentity,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, showActionViewHeader && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $468832809baddf05$var$styles.actionViewHeader
    }, /*#__PURE__*/ $cozmU.createElement((0, $4NVkH.Paper), {
        variant: "accent",
        verticalSpace: false,
        pinchCorner: "bottomRight"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $468832809baddf05$var$styles.actionViewHeaderContent
    }, /*#__PURE__*/ $cozmU.createElement(Icon, {
        label: "",
        primaryColor: "var(--ds-icon-subtlest, #6B6E76)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, action.title)))), /*#__PURE__*/ $cozmU.createElement((0, $a1L5E.default), {
        name: 'conversation-action'
    }, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
        data: {
            conversationActionTitle: action.title
        }
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $468832809baddf05$var$styles.actionViewContainer
    }, actionView)), footer);
};





























var $eHdk6 = parcelRequire("eHdk6");

/** Prompt sent on click — asks the backend to reproduce the previous response verbatim, not regenerate it. */ const $c80ab7e5bf0c7035$export$9f870233a176c1a0 = 'Create a Confluence page with the exact, verbatim text of your previous response.';



var $gulpi = parcelRequire("gulpi");




const $6e4df427ffe2545c$var$message = (0, $kSwu1.defineMessages)({
    createConfluencePageFollowUp: {
        id: "rovo-chat.store-follow-up.create-confluence-page",
        defaultMessage: "Create a Confluence page from this response"
    }
});
var $6e4df427ffe2545c$export$2e2bcd8739ae039 = $6e4df427ffe2545c$var$message;


const $84c9e0ccda110612$var$styles = {
    queryContainer: "_313842NHnM"
};
const $84c9e0ccda110612$var$FollowUpPresentation = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { followUp: followUp, onFollowUpClick: onFollowUpClick } = t0;
    const followUps = followUp.content.message.follow_ups;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ieeJu.expValEquals)("confluence_fe_create_page_suggestion", "isEnabled", true);
        $[0] = t1;
    } else t1 = $[0];
    const isCreatePageExperimentEnabled = t1;
    let t2;
    if ($[1] !== followUps) {
        t2 = followUps?.some($84c9e0ccda110612$var$_temp) ?? false;
        $[1] = followUps;
        $[2] = t2;
    } else t2 = $[2];
    const hasCreatePageSuggestion = t2;
    let t3;
    let t4;
    if ($[3] !== hasCreatePageSuggestion || $[4] !== sendAnalyticsEvent) {
        t3 = ()=>{
            if (isCreatePageExperimentEnabled && hasCreatePageSuggestion) sendAnalyticsEvent({
                eventType: "screen",
                name: "createConfluencePageSuggestion"
            });
        };
        t4 = [
            isCreatePageExperimentEnabled,
            hasCreatePageSuggestion,
            sendAnalyticsEvent
        ];
        $[3] = hasCreatePageSuggestion;
        $[4] = sendAnalyticsEvent;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!followUps || followUps.length === 0) return null;
    let t5;
    if ($[7] !== followUps || $[8] !== formatMessage || $[9] !== onFollowUpClick || $[10] !== sendAnalyticsEvent) {
        let t6;
        if ($[12] !== formatMessage || $[13] !== onFollowUpClick || $[14] !== sendAnalyticsEvent) {
            t6 = (followUp_0, index)=>{
                const isSyntheticCreatePage = followUp_0.text === (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT);
                const displayText = isSyntheticCreatePage ? formatMessage((0, $6e4df427ffe2545c$export$2e2bcd8739ae039).createConfluencePageFollowUp) : followUp_0.text;
                return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
                    key: index,
                    entranceDirection: "bottom",
                    duration: "large"
                }, (props)=>/*#__PURE__*/ $cozmU.createElement("div", props, /*#__PURE__*/ $cozmU.createElement((0, $eHdk6.FollowUpButton), {
                        ...props,
                        followUpIndex: index,
                        followUpType: followUp_0.type,
                        followUpText: displayText,
                        onClick: ()=>{
                            if (isCreatePageExperimentEnabled && isSyntheticCreatePage) sendAnalyticsEvent({
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "createConfluencePageSuggestion"
                            });
                            onFollowUpClick(isSyntheticCreatePage ? (0, $c80ab7e5bf0c7035$export$9f870233a176c1a0) : followUp_0.text);
                        }
                    })));
            };
            $[12] = formatMessage;
            $[13] = onFollowUpClick;
            $[14] = sendAnalyticsEvent;
            $[15] = t6;
        } else t6 = $[15];
        t5 = followUps.map(t6);
        $[7] = followUps;
        $[8] = formatMessage;
        $[9] = onFollowUpClick;
        $[10] = sendAnalyticsEvent;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[16] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hc9K5.default), {
            columns: 1
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: $84c9e0ccda110612$var$styles.queryContainer
        }, t5));
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ followUp: followUp, onFollowUpClick: onFollowUpClick })=>{
    const followUps = followUp.content.message.follow_ups;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const isCreatePageExperimentEnabled = (0, $ieeJu.expValEquals)('confluence_fe_create_page_suggestion', 'isEnabled', true);
    const hasCreatePageSuggestion = (0, $cozmU.useMemo)(()=>followUps?.some((f)=>f.text === (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT)) ?? false, [
        followUps
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isCreatePageExperimentEnabled && hasCreatePageSuggestion) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'createConfluencePageSuggestion'
        });
    }, [
        isCreatePageExperimentEnabled,
        hasCreatePageSuggestion,
        sendAnalyticsEvent
    ]);
    if (!followUps || followUps.length === 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $hc9K5.default), {
        columns: 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $84c9e0ccda110612$var$styles.queryContainer
    }, followUps.map((followUp_0, index)=>{
        const isSyntheticCreatePage = followUp_0.text === (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT);
        const displayText = isSyntheticCreatePage ? formatMessage((0, $6e4df427ffe2545c$export$2e2bcd8739ae039).createConfluencePageFollowUp) : followUp_0.text;
        return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            key: index,
            entranceDirection: "bottom",
            duration: "large"
        }, (props)=>/*#__PURE__*/ $cozmU.createElement("div", props, /*#__PURE__*/ $cozmU.createElement((0, $eHdk6.FollowUpButton), {
                ...props,
                followUpIndex: index,
                followUpType: followUp_0.type,
                followUpText: displayText,
                onClick: ()=>{
                    if (isCreatePageExperimentEnabled && isSyntheticCreatePage) sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'createConfluencePageSuggestion'
                    });
                     // Send the verbatim-reproduction prompt, not the user-facing label.
                    onFollowUpClick(isSyntheticCreatePage ? (0, $c80ab7e5bf0c7035$export$9f870233a176c1a0) : followUp_0.text);
                }
            })));
    })));
};
const $84c9e0ccda110612$export$b345d27ca502af7c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    if (props.interactionMode === "read-only") return null;
    let t0;
    if ($[0] !== props.followUp || $[1] !== props.onFollowUpClick) {
        t0 = /*#__PURE__*/ $cozmU.createElement($84c9e0ccda110612$var$FollowUpPresentation, {
            followUp: props.followUp,
            onFollowUpClick: props.onFollowUpClick
        });
        $[0] = props.followUp;
        $[1] = props.onFollowUpClick;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    if (props.interactionMode === 'read-only') return null;
    return /*#__PURE__*/ $cozmU.createElement($84c9e0ccda110612$var$FollowUpPresentation, {
        followUp: props.followUp,
        onFollowUpClick: props.onFollowUpClick
    });
};
function $84c9e0ccda110612$var$_temp(f) {
    return f.text === (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT);
}


const $20f2c57f81df62c5$var$styles = {
    fullScreenCentered: "_2YLqiKIZbP _1EqgXlflcy"
};
const $20f2c57f81df62c5$export$7b4b430b0cd5aed8 = ({ action: action, mode: mode, fullScreen: fullScreen, agent: agent, storeUserMessages: storeUserMessages, webSearchEnabled: webSearchEnabled, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, appFilters: appFilters })=>{
    (0, $6cFsl.di)((0, $468832809baddf05$export$3252d34b88dec43f), (0, $d701f0955d4384b4$export$a90bb5fb0bd72e89));
    const actionPresentation = (0, $d7d494c6f701221a$export$686d2858de1a6c61)(action);
    const shouldCenterAction = Boolean(fullScreen && actionPresentation.centerInFullScreen);
    const { followUp: followUp, onFollowUpClick: onFollowUpClick } = (0, $d701f0955d4384b4$export$a90bb5fb0bd72e89)({
        activeAction: action,
        agent: agent,
        storeUserMessages: storeUserMessages,
        webSearchEnabled: webSearchEnabled,
        addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference,
        appFilters: appFilters
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            shouldCenterAction && $20f2c57f81df62c5$var$styles.fullScreenCentered
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $468832809baddf05$export$3252d34b88dec43f), {
        action: action,
        mode: mode,
        hideActionHeader: actionPresentation.hideActionHeader,
        footer: followUp ? /*#__PURE__*/ $cozmU.createElement((0, $84c9e0ccda110612$export$b345d27ca502af7c), {
            followUp: followUp,
            onFollowUpClick: onFollowUpClick
        }) : null
    }));
};


const $fd913f2789212bc1$export$eea91cf823ba359c = (lastHumanMessageContent)=>{
    if (lastHumanMessageContent === undefined) return undefined;
    if (typeof lastHumanMessageContent === 'string') return lastHumanMessageContent;
    try {
        return JSON.stringify(lastHumanMessageContent);
    } catch  {
        return null;
    }
};




















var $1PVOM = parcelRequire("1PVOM");

































const $e66e8ee9b98ae2ae$var$styles = {
    summary: "_2mHwu81Y8M _20VacPYbGa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuecOK _39xV02IZbP _4kiQYAoWWg _0wOv4Q7zJH _3138421Y8M _1DCdHi1Y8M _1UtDYzKGUX",
    pressable: "_0KLXrujOvk",
    animationContainer: "_4bt5LAnQyn _2WAcuGnQyn",
    children: "_46hvQm1Y8M",
    expandIcons: "_2XsHFM5UaJ _2Zuz6Q1Y8M"
};
const $e66e8ee9b98ae2ae$export$a4ab8eca652f645c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, showText: showText, hideText: hideText, onClick: onClick, isExpanded: isExpanded, xcss: xcss } = t0;
    if (!children) return null;
    const t1 = xcss;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($e66e8ee9b98ae2ae$var$styles.summary, $e66e8ee9b98ae2ae$var$styles.pressable, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isExpanded ? hideText ?? showText : showText;
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== isExpanded) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e66e8ee9b98ae2ae$var$styles.expandIcons
        }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }));
        $[4] = isExpanded;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== onClick || $[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: t2,
            onClick: onClick
        }, t4, t5);
        $[6] = onClick;
        $[7] = t2;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== children || $[12] !== isExpanded) {
        t7 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: "top",
            exitDirection: "top",
            duration: "medium"
        }, (motionProps)=>/*#__PURE__*/ $cozmU.createElement("div", motionProps, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $e66e8ee9b98ae2ae$var$styles.children
            }, children)));
        $[11] = children;
        $[12] = isExpanded;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e66e8ee9b98ae2ae$var$styles.animationContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, t7));
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t6 || $[17] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t6, t8);
        $[16] = t6;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children, showText: showText, hideText: hideText, onClick: onClick, isExpanded: isExpanded, xcss: xcss })=>{
    // Prevent expand from displaying if there is no content
    if (!children) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($e66e8ee9b98ae2ae$var$styles.summary, $e66e8ee9b98ae2ae$var$styles.pressable, // the type defined above is correct, typescript yells when passed to xcss
        xcss),
        onClick: onClick
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, isExpanded ? hideText ?? showText : showText), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e66e8ee9b98ae2ae$var$styles.expandIcons
    }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        size: "small"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e66e8ee9b98ae2ae$var$styles.animationContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: "top",
        exitDirection: "top",
        duration: "medium"
    }, (motionProps)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", motionProps, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e66e8ee9b98ae2ae$var$styles.children
        }, children));
    }))));
};



















var $iZMIZ = parcelRequire("iZMIZ");














var $e12351c22be5af2c$exports = {};
$e12351c22be5af2c$exports = new URL("rovo.b06223c6.png", import.meta.url).toString();





const $dd94acd4c614af5c$var$message = (0, $kSwu1.defineMessages)({
    researchCompletedNotificationTitle: {
        id: "ai-mate.chat-history.message-research.research-completed-notification-title",
        defaultMessage: "Rovo Chat completed research"
    },
    researchCompletedNotificationBody: {
        id: "ai-mate.chat-history.message-research.research-completed-notification-body",
        defaultMessage: "Your research has been completed and is ready to view."
    },
    deepResearchNotificationPanelText: {
        id: "ai-mate.chat-history.message-research-notification-text",
        defaultMessage: "Deep research can take a few minutes, but the results are worth the wait. You can continue working, just keep this chat window open."
    },
    deepResearchNotificationButtonText: {
        id: "ai-mate.chat-history.message-research-notification-button-text",
        defaultMessage: "Notify me when it\u2019s done"
    },
    deepResearchNotificationConfirmationLabelText: {
        id: "ai-mate.chat-history.message-research-notification-confirmation-label-text",
        defaultMessage: "We\u2019ll notify you when it\u2019s done"
    }
});
var $dd94acd4c614af5c$export$2e2bcd8739ae039 = $dd94acd4c614af5c$var$message;


const $8a8aeca63878a971$export$ee16229b36f5c8f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { researchCompleted: researchCompleted, researchErrored: researchErrored, hasReceivedAnswerPart: hasReceivedAnswerPart } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [notificationSupported, setNotificationSupported] = (0, $cozmU.useState)(true);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] !== sendAnalyticsEvent) {
        t1 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "deepResearchNotifyWhenDoneButton"
            });
            try {
                Notification.requestPermission();
            } catch (t2) {
                setNotificationSupported(false);
            }
        };
        $[0] = sendAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const onNotificationRequestClicked = t1;
    let t2;
    if ($[2] !== sendAnalyticsEvent) {
        t2 = (title, body)=>{
            try {
                sendAnalyticsEvent({
                    action: "fired",
                    actionSubject: "notification",
                    actionSubjectId: "deepResearchCompletedNotification"
                });
                const notifier = new Notification(title, {
                    body: body,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($e12351c22be5af2c$exports)))
                });
                notifier.onclick = ()=>{
                    window.focus();
                    notifier?.close();
                };
            } catch (t3) {
                setNotificationSupported(false);
            }
        };
        $[2] = sendAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const fireNotification = t2;
    let t3;
    let t4;
    if ($[4] !== fireNotification || $[5] !== formatMessage || $[6] !== researchCompleted) {
        t3 = ()=>{
            if (Notification.permission === "granted" && researchCompleted) {
                if (researchCompleted) {
                    const title_0 = formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).researchCompletedNotificationTitle);
                    const body_0 = formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).researchCompletedNotificationBody);
                    if (document.visibilityState !== "visible") try {
                        fireNotification(title_0, body_0);
                    } catch (t5) {
                        const error_1 = t5;
                    }
                }
            }
        };
        t4 = [
            fireNotification,
            formatMessage,
            researchCompleted
        ];
        $[4] = fireNotification;
        $[5] = formatMessage;
        $[6] = researchCompleted;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof Notification === "undefined" || typeof Notification.permission === "undefined") {
        let t5;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null);
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    const notificationPermission = Notification.permission;
    const isNotificationPermissionDenied = notificationPermission === "denied";
    const isNotificationPermissionGranted = notificationPermission === "granted";
    let t5;
    if ($[10] !== formatMessage || $[11] !== hasReceivedAnswerPart || $[12] !== notificationSupported || $[13] !== onNotificationRequestClicked || $[14] !== researchCompleted || $[15] !== researchErrored) {
        t5 = !researchCompleted && !researchErrored && !hasReceivedAnswerPart && notificationSupported && !isNotificationPermissionDenied && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150",
            alignInline: "start"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "regular"
        }, formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).deepResearchNotificationPanelText)), isNotificationPermissionGranted ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium",
            color: "color.text.subtle",
            maxLines: 1
        }, formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).deepResearchNotificationConfirmationLabelText))) : /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
            onClick: onNotificationRequestClicked,
            shouldFitContainer: false
        }, formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).deepResearchNotificationButtonText)));
        $[10] = formatMessage;
        $[11] = hasReceivedAnswerPart;
        $[12] = notificationSupported;
        $[13] = onNotificationRequestClicked;
        $[14] = researchCompleted;
        $[15] = researchErrored;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ researchCompleted: researchCompleted, researchErrored: researchErrored, hasReceivedAnswerPart: hasReceivedAnswerPart })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [notificationSupported, setNotificationSupported] = (0, $cozmU.useState)(true);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const onNotificationRequestClicked = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'deepResearchNotifyWhenDoneButton'
        });
        try {
            // eslint-disable-next-line compat/compat
            Notification.requestPermission();
        } catch (error) {
            // Silently fail if notifications aren't supported
            setNotificationSupported(false);
        }
    }, [
        setNotificationSupported,
        sendAnalyticsEvent
    ]);
    const fireNotification = (0, $cozmU.useCallback)((title, body)=>{
        try {
            sendAnalyticsEvent({
                action: 'fired',
                actionSubject: 'notification',
                actionSubjectId: 'deepResearchCompletedNotification'
            }); // eslint-disable-next-line compat/compat
            const notifier = new Notification(title, {
                body: body,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($e12351c22be5af2c$exports)))
            });
            notifier.onclick = ()=>{
                window.focus();
                notifier?.close();
            };
        } catch (error_0) {
            // Silently fail if notifications aren't supported
            setNotificationSupported(false);
        }
    }, [
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (Notification.permission === 'granted' && researchCompleted) {
            if (researchCompleted) {
                const title_0 = formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).researchCompletedNotificationTitle);
                const body_0 = formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).researchCompletedNotificationBody);
                if (document.visibilityState !== 'visible') try {
                    fireNotification(title_0, body_0);
                } catch (error_1) {}
            }
        }
    }, [
        fireNotification,
        formatMessage,
        researchCompleted
    ]);
    if (typeof Notification === 'undefined' || typeof Notification.permission === 'undefined') return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null);
     // eslint-disable-next-line compat/compat
    const notificationPermission = Notification.permission;
    const isNotificationPermissionDenied = notificationPermission === 'denied';
    const isNotificationPermissionGranted = notificationPermission === 'granted';
    return !researchCompleted && !researchErrored && !hasReceivedAnswerPart && notificationSupported && !isNotificationPermissionDenied && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150",
        alignInline: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "regular"
    }, formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).deepResearchNotificationPanelText)), isNotificationPermissionGranted ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        color: "color.text.subtle",
        maxLines: 1
    }, formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).deepResearchNotificationConfirmationLabelText))) : /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
        onClick: onNotificationRequestClicked,
        shouldFitContainer: false
    }, formatMessage((0, $dd94acd4c614af5c$export$2e2bcd8739ae039).deepResearchNotificationButtonText)));
};


















const $170ecee6f6285862$var$ARTIFICIAL_PROGRESS_UPDATE_DELAY = 2000;
const $170ecee6f6285862$var$useArtificiallyProgressedSteps = ({ messageId: messageId, steps: steps, message: message, actions: actions })=>{
    // the getArtificiallyProgressingSteps is only executed on state change,
    // so we trigger artificial progress updates from the last state update,
    // the last state update could be from here or from active stream
    (0, $cozmU.useEffect)(()=>{
        let timeout;
        if (message?.currentProgress && !message?.researchCompleted && !message?.errored) timeout = setTimeout(()=>{
            actions.incrementProgressArtificially({
                messageId: messageId
            });
        }, $170ecee6f6285862$var$ARTIFICIAL_PROGRESS_UPDATE_DELAY);
        if (message?.researchCompleted || message?.errored) clearTimeout(timeout);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        message?.currentProgress,
        message?.errored,
        actions,
        messageId,
        message?.researchCompleted
    ]);
    // return only the ordered steps that are completed or have their predecessors completed
    const stepToCompletionTime = (0, $cozmU.useRef)({});
    // Stagger reveals by MIN_WAIT_THRESHOLD so steps don't all pop at once during live streaming.
    // When the store already marks a step completed (including reconnect/replay), skip the wait
    // so checkmarks appear immediately instead of waiting 200ms after the previous step.
    const MIN_WAIT_THRESHOLD = 200;
    const artificiallyProgressingSteps = (0, $cozmU.useMemo)(()=>{
        const currentStepsTraversalTime = Date.now();
        try {
            const mappedSteps = steps.sort((a, b)=>a.order - b.order).reduce((accumulator, step, currentIndex, array)=>{
                const allPreviousCompleted = currentIndex > 0 ? accumulator[currentIndex - 1].allPreviousAndCurrentCompleted : true;
                const timeSincePreviousCompleted = currentIndex > 0 ? currentStepsTraversalTime - stepToCompletionTime.current[array[currentIndex - 1].stepId] : MIN_WAIT_THRESHOLD;
                const canRevealCompletedStep = timeSincePreviousCompleted >= MIN_WAIT_THRESHOLD || step.completed;
                if (message?.researchCompleted || allPreviousCompleted && step.completed && canRevealCompletedStep) {
                    if (!stepToCompletionTime.current[step.stepId]) stepToCompletionTime.current[step.stepId] = currentStepsTraversalTime;
                } else delete stepToCompletionTime.current[step.stepId];
                const currentCompleted = step.stepId in stepToCompletionTime.current;
                // Logic that uses both currentValue and accumulator
                accumulator.push({
                    step: {
                        ...step,
                        completed: allPreviousCompleted && currentCompleted
                    },
                    allPreviousAndCurrentCompleted: allPreviousCompleted && currentCompleted
                });
                return accumulator;
            }, []);
            // Show all arrived steps with a title. Sliding window capping
            // is applied at the UI layer for the collapsed view only, so the
            // expanded view can show all steps.
            return mappedSteps.filter((mappedStep)=>{
                if (mappedStep.step.immediate) return true;
                return !!mappedStep.step.title;
            }).map((mappedStep)=>mappedStep.step);
        } catch  {
            // fallback in case of an unexpected error
            (0, $hlvTd.logException)({
                exception: new Error(`Failed to generate artificiallyProgressingSteps`),
                name: 'MessageResearchArtificialStepProgressFailed'
            });
            return steps;
        }
    }, // current progress is not used in memo
    // but that is what is intended to evaluate the stream again to validate time since last completed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        steps,
        message?.researchCompleted,
        message?.currentProgress
    ]);
    return {
        artificiallyProgressingSteps: artificiallyProgressingSteps
    };
};
const $170ecee6f6285862$export$472cc7856f114c2c = ({ messageId: messageId })=>{
    (0, $6cFsl.di)((0, $0da647f75270b377$export$b5a7f8d4b73e48e1));
    const [state, actions] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    const steps = (0, $cozmU.useMemo)(()=>{
        return state?.steps ? Object.values(state.steps) : [];
    }, [
        state?.steps
    ]);
    const getSteps = (0, $cozmU.useCallback)(()=>steps, [
        steps
    ]);
    const accumulatedSources = (0, $cozmU.useMemo)(()=>{
        const seen = new Set();
        return Object.values(steps).map((s)=>s.sources).flat().filter((source)=>!!source?.url).filter((source_0)=>{
            if (seen.has(source_0.ari)) return false;
            seen.add(source_0.ari);
            return true;
        });
    }, [
        steps
    ]);
    const isLastRound = (0, $cozmU.useCallback)((roundId)=>{
        if (steps.filter((step)=>step.roundId === roundId).length === steps.length) return true;
        const uniqueRoundIds = [
            ...new Set(steps.map((step_0)=>step_0.roundId))
        ].sort((a, b)=>a - b);
        return uniqueRoundIds.length > 0 && roundId === uniqueRoundIds[uniqueRoundIds.length - 1];
    }, [
        steps
    ]);
    const isRoundComplete = (0, $cozmU.useCallback)((roundId_0)=>{
        return steps.filter((step_1)=>step_1.roundId === roundId_0)?.every((step_2)=>step_2.completed);
    }, [
        steps
    ]);
    const isPreviousRoundComplete = (0, $cozmU.useCallback)((roundId_1)=>{
        return steps.filter((step_3)=>step_3.roundId === roundId_1 - 1)?.every((step_4)=>step_4.completed);
    }, [
        steps
    ]);
    const isNextRoundComplete = (0, $cozmU.useCallback)((roundId_2)=>{
        const nextRoundSteps = steps.filter((step_5)=>step_5.roundId === roundId_2 + 1);
        if (nextRoundSteps.length === 0) return true;
        return nextRoundSteps.every((step_6)=>step_6.completed);
    }, [
        steps
    ]);
    const { artificiallyProgressingSteps: artificiallyProgressingSteps } = $170ecee6f6285862$var$useArtificiallyProgressedSteps({
        messageId: messageId,
        steps: steps,
        message: state,
        actions: actions
    });
    return {
        ...state,
        ...actions,
        getSteps: getSteps,
        artificiallyProgressingSteps: artificiallyProgressingSteps,
        realtimeProgressingSteps: steps,
        accumulatedSources: accumulatedSources,
        isRoundComplete: isRoundComplete,
        isPreviousRoundComplete: isPreviousRoundComplete,
        isNextRoundComplete: isNextRoundComplete,
        isLastRound: isLastRound
    };
};








const $143786e7cbd99263$var$message = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "ai-mate.chat-history.message-research-refresh.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    agentIsThinking: {
        id: "ai-mate.chat-history.message-research-refresh.agent-is-thinking",
        defaultMessage: "{agentName} is thinking"
    },
    steps: {
        id: "ai-mate.chat-history.message-research-refresh.steps",
        defaultMessage: "Steps {count}/{count}"
    },
    researchStepTitlePlaceholder: {
        id: "ai-mate.chat-history.message-research-refresh.research-step-title-placeholder",
        defaultMessage: "Searching for relevant information..."
    }
});
var $143786e7cbd99263$export$2e2bcd8739ae039 = $143786e7cbd99263$var$message;


const $e28f01433a379fa9$var$useResearchStepsAsExpandableTrace = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { researchSteps: researchSteps } = t0;
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const { productKey: productKey, siteId: siteId, profileData: t1 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t1;
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    conversation?.id;
    customHandlers?.handleDeepLinkClick;
    let t2;
    if ($[0] !== aaid || $[1] !== conversation?.id || $[2] !== customHandlers?.handleDeepLinkClick || $[3] !== formatMessage || $[4] !== productKey || $[5] !== researchSteps || $[6] !== siteId) {
        let t3;
        if ($[8] !== aaid || $[9] !== conversation?.id || $[10] !== customHandlers?.handleDeepLinkClick || $[11] !== formatMessage || $[12] !== productKey || $[13] !== siteId) {
            t3 = (step)=>{
                const content = step.content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                    content: step.content,
                    smallerFont: true,
                    productKey: productKey,
                    siteId: siteId,
                    aaid: aaid,
                    conversationId: conversation?.id,
                    onDeepLinkClick: customHandlers?.handleDeepLinkClick,
                    shouldOverrideCardAsInline: true
                });
                return {
                    title: step.title ?? formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).researchStepTitlePlaceholder),
                    status: step.completed ? "success" : "loading",
                    defaultExpanded: false,
                    content: content
                };
            };
            $[8] = aaid;
            $[9] = conversation?.id;
            $[10] = customHandlers?.handleDeepLinkClick;
            $[11] = formatMessage;
            $[12] = productKey;
            $[13] = siteId;
            $[14] = t3;
        } else t3 = $[14];
        t2 = researchSteps.map(t3);
        $[0] = aaid;
        $[1] = conversation?.id;
        $[2] = customHandlers?.handleDeepLinkClick;
        $[3] = formatMessage;
        $[4] = productKey;
        $[5] = researchSteps;
        $[6] = siteId;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ researchSteps: researchSteps })=>{
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const { productKey: productKey, siteId: siteId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>researchSteps.map((step)=>{
            const content = step.content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                content: step.content,
                smallerFont: true,
                productKey: productKey,
                siteId: siteId,
                aaid: aaid,
                conversationId: conversation?.id,
                onDeepLinkClick: customHandlers?.handleDeepLinkClick,
                shouldOverrideCardAsInline: true
            });
            return {
                title: step.title ?? formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).researchStepTitlePlaceholder),
                status: step.completed ? 'success' : 'loading',
                defaultExpanded: false,
                content: content
            };
        }), [
        researchSteps,
        productKey,
        siteId,
        aaid,
        conversation?.id,
        formatMessage,
        customHandlers?.handleDeepLinkClick
    ]);
};
const $e28f01433a379fa9$var$ResearchTraces = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { expandableTraces: expandableTraces, researchCompleted: researchCompleted, hasReceivedAnswerPart: hasReceivedAnswerPart, hideLiveThinkingIndicator: hideLiveThinkingIndicator, agent: agent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, onTraceInteraction: onTraceInteraction } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== personalityThinkingText) {
        t1 = personalityThinkingText ?? formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).rovoIsThinking);
        $[0] = formatMessage;
        $[1] = personalityThinkingText;
        $[2] = t1;
    } else t1 = $[2];
    let thinkingText = t1;
    if (agent) {
        let t2;
        if ($[3] !== agent.name || $[4] !== formatMessage) {
            t2 = formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).agentIsThinking, {
                agentName: agent.name
            });
            $[3] = agent.name;
            $[4] = formatMessage;
            $[5] = t2;
        } else t2 = $[5];
        thinkingText = t2;
    }
    if (generatingText) thinkingText = generatingText;
    const t2 = hideLiveThinkingIndicator || hasReceivedAnswerPart || researchCompleted;
    let t3;
    if ($[6] !== agent || $[7] !== expandableTraces || $[8] !== onTraceInteraction || $[9] !== t2 || $[10] !== thinkingText) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "research-step-list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbe369e2a348fc0c$export$1e7724c434f1ba76), {
            hideThinkingIndicator: t2,
            traces: expandableTraces,
            thinkingText: thinkingText,
            agent: agent,
            animation: true,
            onTraceInteraction: onTraceInteraction
        }));
        $[6] = agent;
        $[7] = expandableTraces;
        $[8] = onTraceInteraction;
        $[9] = t2;
        $[10] = thinkingText;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ expandableTraces: expandableTraces, researchCompleted: researchCompleted, hasReceivedAnswerPart: hasReceivedAnswerPart, hideLiveThinkingIndicator: hideLiveThinkingIndicator, agent: agent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, onTraceInteraction: onTraceInteraction })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let thinkingText = personalityThinkingText ?? formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).rovoIsThinking);
    if (agent) thinkingText = formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).agentIsThinking, {
        agentName: agent.name
    });
    if (generatingText) thinkingText = generatingText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "research-step-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbe369e2a348fc0c$export$1e7724c434f1ba76), {
        hideThinkingIndicator: hideLiveThinkingIndicator || hasReceivedAnswerPart || researchCompleted,
        traces: expandableTraces,
        thinkingText: thinkingText,
        agent: agent,
        animation: true,
        onTraceInteraction: onTraceInteraction
    }));
};
const $e28f01433a379fa9$var$MessageDeepResearchProgress = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { researchCompleted: researchCompleted, researchErrored: researchErrored, researchSteps: researchSteps, hasReceivedAnswerPart: hasReceivedAnswerPart, hideLiveThinkingIndicator: hideLiveThinkingIndicator, agent: agent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, onTraceInteraction: onTraceInteraction } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [panelExpanded, setPanelExpanded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== researchSteps) {
        t1 = {
            researchSteps: researchSteps
        };
        $[0] = researchSteps;
        $[1] = t1;
    } else t1 = $[1];
    const expandableTraces = $e28f01433a379fa9$var$useResearchStepsAsExpandableTrace(t1);
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)();
    let t2;
    if ($[2] !== selectedAgent) {
        t2 = (0, $29db3342b7552f6d$export$e119872ad3ffc5)(selectedAgent);
        $[2] = selectedAgent;
        $[3] = t2;
    } else t2 = $[3];
    const hideResearchNotification = t2;
    let t3;
    if ($[4] !== hasReceivedAnswerPart || $[5] !== hideResearchNotification || $[6] !== researchCompleted || $[7] !== researchErrored) {
        t3 = !hideResearchNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a8aeca63878a971$export$ee16229b36f5c8f7), {
            researchCompleted: researchCompleted,
            researchErrored: researchErrored,
            hasReceivedAnswerPart: hasReceivedAnswerPart
        });
        $[4] = hasReceivedAnswerPart;
        $[5] = hideResearchNotification;
        $[6] = researchCompleted;
        $[7] = researchErrored;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== agent || $[10] !== expandableTraces || $[11] !== formatMessage || $[12] !== generatingText || $[13] !== hasReceivedAnswerPart || $[14] !== hideLiveThinkingIndicator || $[15] !== onTraceInteraction || $[16] !== panelExpanded || $[17] !== personalityThinkingText || $[18] !== researchCompleted || $[19] !== researchSteps) {
        t4 = researchCompleted || hasReceivedAnswerPart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e66e8ee9b98ae2ae$export$a4ab8eca652f645c), {
            isExpanded: panelExpanded,
            showText: formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).steps, {
                count: researchSteps.length
            }),
            onClick: ()=>setPanelExpanded(!panelExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28f01433a379fa9$var$ResearchTraces, {
            expandableTraces: expandableTraces,
            researchCompleted: researchCompleted,
            hasReceivedAnswerPart: hasReceivedAnswerPart,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator,
            agent: agent,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            onTraceInteraction: onTraceInteraction
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28f01433a379fa9$var$ResearchTraces, {
            expandableTraces: expandableTraces,
            researchCompleted: researchCompleted,
            hasReceivedAnswerPart: hasReceivedAnswerPart,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator,
            agent: agent,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            onTraceInteraction: onTraceInteraction
        });
        $[9] = agent;
        $[10] = expandableTraces;
        $[11] = formatMessage;
        $[12] = generatingText;
        $[13] = hasReceivedAnswerPart;
        $[14] = hideLiveThinkingIndicator;
        $[15] = onTraceInteraction;
        $[16] = panelExpanded;
        $[17] = personalityThinkingText;
        $[18] = researchCompleted;
        $[19] = researchSteps;
        $[20] = t4;
    } else t4 = $[20];
    let t5;
    if ($[21] !== t3 || $[22] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t3, t4);
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
    } else t5 = $[23];
    return t5;
} : ({ researchCompleted: researchCompleted, researchErrored: researchErrored, researchSteps: researchSteps, hasReceivedAnswerPart: hasReceivedAnswerPart, hideLiveThinkingIndicator: hideLiveThinkingIndicator, agent: agent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, onTraceInteraction: onTraceInteraction })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [panelExpanded, setPanelExpanded] = (0, $cozmU.useState)(false);
    const expandableTraces = $e28f01433a379fa9$var$useResearchStepsAsExpandableTrace({
        researchSteps: researchSteps
    }); // Marathon agents should never see the "Deep research can take a few
    // minutes..." banner because they aren't doing deep research.
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)();
    const hideResearchNotification = (0, $29db3342b7552f6d$export$e119872ad3ffc5)(selectedAgent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, !hideResearchNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a8aeca63878a971$export$ee16229b36f5c8f7), {
        researchCompleted: researchCompleted,
        researchErrored: researchErrored,
        hasReceivedAnswerPart: hasReceivedAnswerPart
    }), researchCompleted || hasReceivedAnswerPart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e66e8ee9b98ae2ae$export$a4ab8eca652f645c), {
        isExpanded: panelExpanded,
        showText: formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).steps, {
            count: researchSteps.length
        }),
        onClick: ()=>setPanelExpanded(!panelExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28f01433a379fa9$var$ResearchTraces, {
        expandableTraces: expandableTraces,
        researchCompleted: researchCompleted,
        hasReceivedAnswerPart: hasReceivedAnswerPart,
        hideLiveThinkingIndicator: hideLiveThinkingIndicator,
        agent: agent,
        generatingText: generatingText,
        personalityThinkingText: personalityThinkingText,
        onTraceInteraction: onTraceInteraction
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28f01433a379fa9$var$ResearchTraces, {
        expandableTraces: expandableTraces,
        researchCompleted: researchCompleted,
        hasReceivedAnswerPart: hasReceivedAnswerPart,
        hideLiveThinkingIndicator: hideLiveThinkingIndicator,
        agent: agent,
        generatingText: generatingText,
        personalityThinkingText: personalityThinkingText,
        onTraceInteraction: onTraceInteraction
    }));
};
const $e28f01433a379fa9$export$c90b1dea2397805f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { messageId: messageId, agent: agent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, hideLiveThinkingIndicator: hideLiveThinkingIndicator } = t0;
    let t1;
    if ($[0] !== messageId) {
        t1 = {
            messageId: messageId
        };
        $[0] = messageId;
        $[1] = t1;
    } else t1 = $[1];
    const { artificiallyProgressingSteps: artificiallyProgressingSteps, errored: errored, currentProgress: currentProgress, researchCompleted: researchCompleted, hasReceivedAnswerPart: hasReceivedAnswerPart } = (0, $170ecee6f6285862$export$472cc7856f114c2c)(t1);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const hasVisibleArtificialResearchSteps = !errored && (artificiallyProgressingSteps?.length > 0 || !!currentProgress);
    if (!hasVisibleArtificialResearchSteps) return;
    const t2 = !!researchCompleted;
    let t3;
    if ($[2] !== messageId || $[3] !== sendAnalyticsEvent) {
        t3 = (t4)=>{
            const { type: type, expanded: expanded } = t4;
            sendAnalyticsEvent({
                eventType: "ui",
                action: expanded ? "expanded" : "collapsed",
                actionSubject: "trace",
                actionSubjectId: type,
                attributes: {
                    messageId: messageId
                }
            });
        };
        $[2] = messageId;
        $[3] = sendAnalyticsEvent;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== agent || $[6] !== artificiallyProgressingSteps || $[7] !== errored || $[8] !== generatingText || $[9] !== hasReceivedAnswerPart || $[10] !== hideLiveThinkingIndicator || $[11] !== personalityThinkingText || $[12] !== t2 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28f01433a379fa9$var$MessageDeepResearchProgress, {
            researchCompleted: t2,
            researchErrored: errored,
            researchSteps: artificiallyProgressingSteps,
            hasReceivedAnswerPart: hasReceivedAnswerPart,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator,
            agent: agent,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            onTraceInteraction: t3
        });
        $[5] = agent;
        $[6] = artificiallyProgressingSteps;
        $[7] = errored;
        $[8] = generatingText;
        $[9] = hasReceivedAnswerPart;
        $[10] = hideLiveThinkingIndicator;
        $[11] = personalityThinkingText;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ messageId: messageId, agent: agent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, hideLiveThinkingIndicator: hideLiveThinkingIndicator })=>{
    const { artificiallyProgressingSteps: artificiallyProgressingSteps, errored: errored, currentProgress: currentProgress, researchCompleted: researchCompleted, hasReceivedAnswerPart: hasReceivedAnswerPart } = (0, $170ecee6f6285862$export$472cc7856f114c2c)({
        messageId: messageId
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const hasVisibleArtificialResearchSteps = !errored && (artificiallyProgressingSteps?.length > 0 || !!currentProgress);
    if (!hasVisibleArtificialResearchSteps) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28f01433a379fa9$var$MessageDeepResearchProgress, {
        researchCompleted: !!researchCompleted,
        researchErrored: errored,
        researchSteps: artificiallyProgressingSteps,
        hasReceivedAnswerPart: hasReceivedAnswerPart,
        hideLiveThinkingIndicator: hideLiveThinkingIndicator,
        agent: agent,
        generatingText: generatingText,
        personalityThinkingText: personalityThinkingText,
        onTraceInteraction: ({ type: type, expanded: expanded })=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: expanded ? 'expanded' : 'collapsed',
                actionSubject: 'trace',
                actionSubjectId: type,
                attributes: {
                    messageId: messageId
                }
            });
        }
    });
};














const $501c3704274e8ca7$export$b7b8c16424783afd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.150"
    }, children);
};


























/* CompactResearchSteps.tsx generated by @compiled/babel-plugin v2.0.0 */ 



































var $j6vyT = parcelRequire("j6vyT");
















const $9a789a1e808994c2$var$message = (0, $kSwu1.defineMessages)({
    expand: {
        id: "ai-mate.chat-history.message-research.research-expandable.expand",
        defaultMessage: "Expand"
    },
    collapse: {
        id: "ai-mate.chat-history.message-research.research-expandable.collapse",
        defaultMessage: "Collapse"
    }
});
var $9a789a1e808994c2$export$2e2bcd8739ae039 = $9a789a1e808994c2$var$message;


const $22faee5074b66dbd$var$titleRowStyles = {
    fixedHeight: "_4kiQYAoWWg",
    clickableTitle: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _0KLXrujOvk _2fwxA5ecOK _4ouGXIdnbC",
    afterExpandIconSlotWrapper: "_2XsHFMIZbP",
    inlineIconWrapper: "_3iDTPbccYA _1RrJLit2nV _0GTcwR1Y8M",
    inlineIconWrapperHidden: "_3iDTPbccYA _1RrJLit2nV _0GTcwR1Y8M _0fKRyPnQyn"
};
const $22faee5074b66dbd$export$5b346f7d85a51eb5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { children: children, title: title, defaultExpanded: t1, showExpandIcon: t2, showExpandAtEnd: t3, onExpandChanged: t4, iconSpacing: iconSpacing, fixedTitleRowHeight: t5, showDownRightIcons: t6, afterExpandIconSlot: afterExpandIconSlot, alignExpandIcon: t7, onExpandClick: onExpandClick, layout: t8, hideExpandIcon: t9 } = t0;
    const defaultExpanded = t1 === undefined ? true : t1;
    const showExpandIcon = t2 === undefined ? true : t2;
    const showExpandAtEnd = t3 === undefined ? true : t3;
    const onExpandChanged = t4 === undefined ? undefined : t4;
    const fixedTitleRowHeight = t5 === undefined ? false : t5;
    const showDownRightIcons = t6 === undefined ? false : t6;
    const alignExpandIcon = t7 === undefined ? "center" : t7;
    const layout = t8 === undefined ? "block" : t8;
    const hideExpandIcon = t9 === undefined ? false : t9;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    let t10;
    let t11;
    if ($[0] !== defaultExpanded) {
        t10 = ()=>{
            setIsExpanded(defaultExpanded);
        };
        t11 = [
            defaultExpanded
        ];
        $[0] = defaultExpanded;
        $[1] = t10;
        $[2] = t11;
    } else {
        t10 = $[1];
        t11 = $[2];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[3] !== onExpandChanged) {
        t12 = (value)=>{
            setIsExpanded(value);
            onExpandChanged?.(value);
        };
        $[3] = onExpandChanged;
        $[4] = t12;
    } else t12 = $[4];
    const setIsExpandedValue = t12;
    let t13;
    if ($[5] !== isExpanded || $[6] !== onExpandClick || $[7] !== setIsExpandedValue) {
        t13 = ()=>{
            const newValue = !isExpanded;
            setIsExpandedValue(newValue);
            onExpandClick?.(newValue);
        };
        $[5] = isExpanded;
        $[6] = onExpandClick;
        $[7] = setIsExpandedValue;
        $[8] = t13;
    } else t13 = $[8];
    const handleExpandClick = t13;
    let t14;
    bb0: {
        if (showDownRightIcons) {
            let t15;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)))
                ];
                $[9] = t15;
            } else t15 = $[9];
            t14 = t15;
            break bb0;
        }
        if (showExpandAtEnd) {
            let t15;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)))
                ];
                $[10] = t15;
            } else t15 = $[10];
            t14 = t15;
            break bb0;
        }
        let t15;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t15 = [
                (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
                (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)))
            ];
            $[11] = t15;
        } else t15 = $[11];
        t14 = t15;
    }
    const [ExpandedIcon, CollapsedIcon] = t14;
    let t15;
    if ($[12] !== CollapsedIcon || $[13] !== ExpandedIcon || $[14] !== afterExpandIconSlot || $[15] !== alignExpandIcon || $[16] !== fixedTitleRowHeight || $[17] !== formatMessage || $[18] !== handleExpandClick || $[19] !== hideExpandIcon || $[20] !== iconSpacing || $[21] !== isExpanded || $[22] !== layout || $[23] !== showExpandAtEnd || $[24] !== showExpandIcon || $[25] !== title) {
        t15 = layout === "inline" ? /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: handleExpandClick,
            "aria-expanded": isExpanded,
            "aria-label": isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand),
            xcss: $22faee5074b66dbd$var$titleRowStyles.clickableTitle
        }, title, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: hideExpandIcon ? $22faee5074b66dbd$var$titleRowStyles.inlineIconWrapperHidden : $22faee5074b66dbd$var$titleRowStyles.inlineIconWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            shape: "circle",
            appearance: "subtle",
            spacing: "compact",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement(ExpandedIcon, {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement(CollapsedIcon, {
                    ...iconProps,
                    size: "small"
                }),
            label: isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand)
        }))) : /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            spread: showExpandAtEnd ? "space-between" : undefined,
            alignBlock: alignExpandIcon,
            space: "space.050",
            xcss: fixedTitleRowHeight ? $22faee5074b66dbd$var$titleRowStyles.fixedHeight : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: handleExpandClick,
            "aria-expanded": isExpanded,
            "aria-label": isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand),
            xcss: $22faee5074b66dbd$var$titleRowStyles.clickableTitle
        }, title), showExpandIcon && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            shape: "circle",
            appearance: "subtle",
            ...iconSpacing && {
                spacing: iconSpacing
            },
            icon: (iconProps_0)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement(ExpandedIcon, {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement(CollapsedIcon, {
                    ...iconProps_0,
                    size: "small"
                }),
            label: isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand),
            onClick: handleExpandClick
        }), afterExpandIconSlot && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $22faee5074b66dbd$var$titleRowStyles.afterExpandIconSlotWrapper
        }, afterExpandIconSlot));
        $[12] = CollapsedIcon;
        $[13] = ExpandedIcon;
        $[14] = afterExpandIconSlot;
        $[15] = alignExpandIcon;
        $[16] = fixedTitleRowHeight;
        $[17] = formatMessage;
        $[18] = handleExpandClick;
        $[19] = hideExpandIcon;
        $[20] = iconSpacing;
        $[21] = isExpanded;
        $[22] = layout;
        $[23] = showExpandAtEnd;
        $[24] = showExpandIcon;
        $[25] = title;
        $[26] = t15;
    } else t15 = $[26];
    let t16;
    if ($[27] !== children || $[28] !== isExpanded) {
        t16 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: "top",
            exitDirection: "top",
            duration: "medium"
        }, (motionProps)=>/*#__PURE__*/ $cozmU.createElement("div", motionProps, children));
        $[27] = children;
        $[28] = isExpanded;
        $[29] = t16;
    } else t16 = $[29];
    let t17;
    if ($[30] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, t16);
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== isExpanded || $[33] !== t15 || $[34] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            "data-expanded": isExpanded,
            testId: "research-expandable"
        }, t15, t17);
        $[32] = isExpanded;
        $[33] = t15;
        $[34] = t17;
        $[35] = t18;
    } else t18 = $[35];
    return t18;
} : ({ children: children, title: title, defaultExpanded: defaultExpanded = true, showExpandIcon: showExpandIcon = true, showExpandAtEnd: showExpandAtEnd = true, onExpandChanged: onExpandChanged, iconSpacing: iconSpacing, fixedTitleRowHeight: fixedTitleRowHeight = false, showDownRightIcons: showDownRightIcons = false, afterExpandIconSlot: afterExpandIconSlot, alignExpandIcon: alignExpandIcon = 'center', onExpandClick: onExpandClick, layout: layout = 'block', hideExpandIcon: hideExpandIcon = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded); // Override any user interaction that might have changed the expanded state when the prop changes so we have control over it
    (0, $cozmU.useEffect)(()=>{
        setIsExpanded(defaultExpanded);
    }, [
        defaultExpanded
    ]);
    const setIsExpandedValue = (0, $cozmU.useCallback)((value)=>{
        setIsExpanded(value);
        onExpandChanged?.(value);
    }, [
        setIsExpanded,
        onExpandChanged
    ]);
    const handleExpandClick = (0, $cozmU.useCallback)(()=>{
        const newValue = !isExpanded;
        setIsExpandedValue(newValue);
        onExpandClick?.(newValue);
    }, [
        isExpanded,
        setIsExpandedValue,
        onExpandClick
    ]);
    const [ExpandedIcon, CollapsedIcon] = (0, $cozmU.useMemo)(()=>{
        if (showDownRightIcons) return [
            (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
            (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)))
        ];
         // Original behavior: when showExpandAtEnd is true, use up/down; otherwise use down/right
        if (showExpandAtEnd) return [
            (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)))
        ];
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
            (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)))
        ];
    }, [
        showExpandAtEnd,
        showDownRightIcons
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "data-expanded": isExpanded,
        testId: "research-expandable"
    }, layout === 'inline' ? /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: handleExpandClick,
        "aria-expanded": isExpanded,
        "aria-label": isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand),
        xcss: $22faee5074b66dbd$var$titleRowStyles.clickableTitle
    }, title, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: hideExpandIcon ? $22faee5074b66dbd$var$titleRowStyles.inlineIconWrapperHidden : $22faee5074b66dbd$var$titleRowStyles.inlineIconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement(ExpandedIcon, {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement(CollapsedIcon, {
                ...iconProps,
                size: "small"
            }),
        label: isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand)
    }))) : /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: showExpandAtEnd ? 'space-between' : undefined,
        alignBlock: alignExpandIcon,
        space: "space.050",
        xcss: fixedTitleRowHeight ? $22faee5074b66dbd$var$titleRowStyles.fixedHeight : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: handleExpandClick,
        "aria-expanded": isExpanded,
        "aria-label": isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand),
        xcss: $22faee5074b66dbd$var$titleRowStyles.clickableTitle
    }, title), showExpandIcon && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        ...iconSpacing && {
            spacing: iconSpacing
        },
        icon: (iconProps_0)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement(ExpandedIcon, {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement(CollapsedIcon, {
                ...iconProps_0,
                size: "small"
            }),
        label: isExpanded ? formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).collapse) : formatMessage((0, $9a789a1e808994c2$export$2e2bcd8739ae039).expand),
        onClick: handleExpandClick
    }), afterExpandIconSlot && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $22faee5074b66dbd$var$titleRowStyles.afterExpandIconSlotWrapper
    }, afterExpandIconSlot)), /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: "top",
        exitDirection: "top",
        duration: "medium"
    }, (motionProps)=>/*#__PURE__*/ $cozmU.createElement("div", motionProps, children))));
};





const $0efef966bd6ba92a$var$message = (0, $kSwu1.defineMessages)({
    stepsSummary: {
        id: "ai-mate.rovo-platform-ui-components.compact-research-steps.steps-summary",
        defaultMessage: "Completed {total} steps"
    },
    thinkingCompleted: {
        id: "ai-mate.rovo-platform-ui-components.compact-research-steps.thinking-completed",
        defaultMessage: "Thinking completed"
    },
    rovoIsThinking: {
        id: "ai-mate.rovo-platform-ui-components.compact-research-steps.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    collapse: {
        id: "ai-mate.rovo-platform-ui-components.compact-research-steps.collapse",
        defaultMessage: "Collapse"
    },
    thinkDeeperThinking: {
        id: "ai-mate.rovo-platform-ui-components.compact-research-steps.think-deeper-thinking",
        defaultMessage: "Thinking deeply and analyzing"
    },
    executeBashSubstep: {
        id: "ai-mate.rovo-platform-ui-components.compact-research-steps.execute-bash-substep",
        defaultMessage: "Writing and executing code"
    }
});
var $0efef966bd6ba92a$export$2e2bcd8739ae039 = $0efef966bd6ba92a$var$message;


/* ResearchStepItemListRefresh.tsx generated by @compiled/babel-plugin v2.0.0 */ 























var $3GWdi = parcelRequire("3GWdi");

const $2249edee9d5e9bc4$var$md = (0, $3GWdi.default)('zero', {
    html: false
});
$2249edee9d5e9bc4$var$md.enable([
    'fence',
    'code',
    'emphasis',
    'backticks',
    'link',
    'image',
    'strikethrough',
    'escape',
    'entity',
    'newline'
]);
const $2249edee9d5e9bc4$var$collectText = (tokens)=>{
    let result = '';
    for (const token of tokens){
        if (token.children && token.children.length > 0) result += $2249edee9d5e9bc4$var$collectText(token.children);
        else if (token.type === 'text' || token.type === 'code_inline' || token.type === 'fence' || token.type === 'code_block') result += token.content;
        else if (token.type === 'softbreak' || token.type === 'hardbreak') result += ' ';
    }
    return result;
};
const $2249edee9d5e9bc4$export$c470c39bf64377a2 = (input)=>{
    const tokens = $2249edee9d5e9bc4$var$md.parse(input, {});
    return $2249edee9d5e9bc4$var$collectText(tokens).trim();
};











const $d14c06e75415c482$var$CYCLING_INTERVAL_MS = 900;
const $d14c06e75415c482$export$cb0798de2d68813b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCyclingIcon(icons, isActive) {
    const $ = (0, $bDgLe.c)(4);
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const intervalRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== icons || $[1] !== isActive) {
        t0 = ()=>{
            if (!isActive || !icons || icons.length === 0) {
                if (intervalRef.current !== null) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                setCurrentIndex(0);
                return;
            }
            setCurrentIndex(0);
            intervalRef.current = setInterval(()=>{
                setCurrentIndex((prev)=>(prev + 1) % icons.length);
            }, $d14c06e75415c482$var$CYCLING_INTERVAL_MS);
            return ()=>{
                if (intervalRef.current !== null) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
            };
        };
        t1 = [
            icons,
            isActive
        ];
        $[0] = icons;
        $[1] = isActive;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    if (!isActive || !icons || icons.length === 0) return;
    return icons[currentIndex];
} : function useCyclingIcon(icons, isActive) {
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const intervalRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isActive || !icons || icons.length === 0) {
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            setCurrentIndex(0);
            return;
        }
        // Reset to first icon when icons change or isActive becomes true
        setCurrentIndex(0);
        intervalRef.current = setInterval(()=>{
            setCurrentIndex((prev)=>(prev + 1) % icons.length);
        }, $d14c06e75415c482$var$CYCLING_INTERVAL_MS);
        return ()=>{
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [
        icons,
        isActive
    ]);
    if (!isActive || !icons || icons.length === 0) return undefined;
    return icons[currentIndex];
};








/* SourceIconsFan.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $87b3b642758339c3$var$STAGGER_DELAY_MS = 300;
const $87b3b642758339c3$var$iconFanIn = null;
const $87b3b642758339c3$var$fanContainerStyle = null;
const $87b3b642758339c3$var$iconWrapperBaseStyle = null;
const $87b3b642758339c3$var$iconWrapperAnimatedStyle = null;
const $87b3b642758339c3$var$firstIconStyle = null;
const $87b3b642758339c3$var$imgStyle = null;
const $87b3b642758339c3$var$overflowPillBaseStyle = null;
const $87b3b642758339c3$var$overflowPillAnimatedStyle = null; // Max icons to display before showing overflow pill
const $87b3b642758339c3$var$MAX_ICONS = 4; // Rotation pattern per icon position: 0, -6, 0, 8
const $87b3b642758339c3$var$rotationAngles = [
    '0deg',
    '-6deg',
    '0deg',
    '8deg'
]; // Module-level state to persist across mount/unmount cycles (e.g. when toggling between
const $87b3b642758339c3$var$fanStateByStepId = new Map();
const $87b3b642758339c3$var$getFanState = (stepId)=>{
    let state = $87b3b642758339c3$var$fanStateByStepId.get(stepId);
    if (!state) {
        state = {
            revealed: new Set(),
            revealedOverflow: false,
            animated: new Set(),
            animatedOverflow: false
        };
        $87b3b642758339c3$var$fanStateByStepId.set(stepId, state);
    }
    return state;
};
const $87b3b642758339c3$export$118d8860340048c = ({ icons: icons, isInProgress: isInProgress, stepId: stepId })=>{
    const targetIcons = icons ? icons.slice(0, $87b3b642758339c3$var$MAX_ICONS) : [];
    const targetOverflowCount = icons ? icons.length - $87b3b642758339c3$var$MAX_ICONS : 0; // Persist animation state at the module level (keyed by stepId) so that
    // toggling between the collapsed preview and expanded view doesn't replay the animation.
    const fanState = $87b3b642758339c3$var$getFanState(stepId); // Force re-render when we add to the revealed sets.
    const [, forceUpdate] = (0, $cozmU.useState)(0); // Use a tick counter that grows after each reveal — this is what the effect actually depends on.
    const [revealTick, setRevealTick] = (0, $cozmU.useState)(0);
    const targetIconsKey = targetIcons.join('|'); // Stagger reveal: every STAGGER_DELAY_MS, add the next not-yet-revealed icon.
    (0, $cozmU.useEffect)(()=>{
        // Find the next icon URL that hasn't been revealed yet.
        const nextIcon = targetIcons.find((url)=>!fanState.revealed.has(url));
        const allIconsRevealed = !nextIcon;
        const overflowNeeded = targetOverflowCount > 0 && !fanState.revealedOverflow;
        if (!nextIcon && !overflowNeeded) return;
        const timeout = setTimeout(()=>{
            if (nextIcon) fanState.revealed.add(nextIcon);
            else if (allIconsRevealed && overflowNeeded) fanState.revealedOverflow = true;
            setRevealTick((n)=>n + 1);
        }, $87b3b642758339c3$var$STAGGER_DELAY_MS);
        return ()=>clearTimeout(timeout); // targetIcons is recomputed each render but its content is captured via targetIconsKey.
    // revealTick triggers a re-run after each successful reveal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        targetIconsKey,
        targetOverflowCount,
        revealTick
    ]);
    if (!icons || icons.length === 0) return null;
     // Visible icons: only those that have been revealed
    const visibleIcons = targetIcons.filter((url)=>fanState.revealed.has(url));
    const showOverflowPill = targetOverflowCount > 0 && fanState.revealedOverflow;
    const overflowCount = targetOverflowCount;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _3YEZNOdnbC"
        ])
    }, visibleIcons.map((iconUrl, index)=>{
        const rotation = $87b3b642758339c3$var$rotationAngles[index % $87b3b642758339c3$var$rotationAngles.length];
        const hasAnimated = fanState.animated.has(iconUrl);
        const iconStyle = {
            transform: `rotate(${rotation})`
        };
        return /*#__PURE__*/ $cozmU.createElement("div", {
            key: iconUrl,
            onAnimationEnd: ()=>{
                fanState.animated.add(iconUrl);
                forceUpdate((n)=>n + 1);
            },
            style: iconStyle,
            className: (0, $hekY6.default)([
                "_0bjKvDZimw _4bt5LAnQyn _2WAcuGnQyn _30huDKkqlI _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _2XsHFMVo9d",
                index === 0 && "_2XsHFMdnbC",
                !hasAnimated && "",
                !hasAnimated && "_2fBhtedhrm"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("img", {
            src: iconUrl,
            alt: "",
            width: 24,
            height: 24,
            className: (0, $hekY6.default)([
                "_3iDTPbvLZJ"
            ])
        }));
    }), showOverflowPill && /*#__PURE__*/ $cozmU.createElement("div", {
        onAnimationEnd: ()=>{
            fanState.animatedOverflow = true;
            forceUpdate((n)=>n + 1);
        },
        className: (0, $hekY6.default)([
            "_0bjKvDZimw _30huDK1ULg _2sNsIg7NXe _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _2XsHFMVo9d _0KLXrut28M _1UtDYzmfdn _1mT5xdRAKS",
            !fanState.animatedOverflow && "",
            !fanState.animatedOverflow && "_2fBhtedhrm"
        ])
    }, `+${overflowCount}`));
};












var $9Bssi = parcelRequire("9Bssi");










// 3.5 items visible ≈ 168px
const $d0dfe1e2e8452854$var$ITEM_HEIGHT = 48;
const $d0dfe1e2e8452854$var$VISIBLE_ITEMS = 3.5;
const $d0dfe1e2e8452854$var$styles = {
    container: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0NUa3reSJV _2WAcuGIZbP _4bt5LAnQyn _39xV02N91d _4ouGXIdnbC",
    sourceItem: "_2mHwu88HPE _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065U2ADO _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT",
    iconWrapper: "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg",
    title: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC"
};
const $d0dfe1e2e8452854$var$SourceIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { iconUrl: iconUrl } = t0;
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setHasError(true);
        $[0] = t1;
    } else t1 = $[0];
    const handleError = t1;
    const showFallback = !iconUrl || hasError;
    let t2;
    if ($[1] !== iconUrl || $[2] !== showFallback) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $d0dfe1e2e8452854$var$styles.iconWrapper
        }, showFallback ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Bssi))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ $cozmU.createElement("img", {
            src: iconUrl,
            alt: "",
            width: 24,
            height: 24,
            onError: handleError
        }));
        $[1] = iconUrl;
        $[2] = showFallback;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ iconUrl: iconUrl })=>{
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const handleError = (0, $cozmU.useCallback)(()=>setHasError(true), []);
    const showFallback = !iconUrl || hasError;
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $d0dfe1e2e8452854$var$styles.iconWrapper
    }, showFallback ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Bssi))), {
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ $cozmU.createElement("img", {
        src: iconUrl,
        alt: "",
        width: 24,
        height: 24,
        onError: handleError
    }));
};
const $d0dfe1e2e8452854$export$b3ebd135320cfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { sources: sources, xpcWrapUrl: xpcWrapUrl } = t0;
    if (!sources || sources.length === 0) return null;
    let t1;
    if ($[0] !== sources || $[1] !== xpcWrapUrl) {
        let t2;
        if ($[3] !== xpcWrapUrl) {
            t2 = (source, index)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
                    key: `${source.url}-${index}`,
                    href: xpcWrapUrl ? xpcWrapUrl(source.url, false) : source.url,
                    target: "_blank",
                    xcss: $d0dfe1e2e8452854$var$styles.sourceItem,
                    testId: "sources-list-item"
                }, /*#__PURE__*/ $cozmU.createElement($d0dfe1e2e8452854$var$SourceIcon, {
                    iconUrl: source.iconUrl
                }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $d0dfe1e2e8452854$var$styles.title
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    size: "small",
                    maxLines: 1
                }, source.title)));
            $[3] = xpcWrapUrl;
            $[4] = t2;
        } else t2 = $[4];
        t1 = sources.map(t2);
        $[0] = sources;
        $[1] = xpcWrapUrl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d0dfe1e2e8452854$var$styles.container,
            testId: "sources-list"
        }, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ sources: sources, xpcWrapUrl: xpcWrapUrl })=>{
    if (!sources || sources.length === 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d0dfe1e2e8452854$var$styles.container,
        testId: "sources-list"
    }, sources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            key: `${source.url}-${index}`,
            href: xpcWrapUrl ? xpcWrapUrl(source.url, false) : source.url,
            target: "_blank",
            xcss: $d0dfe1e2e8452854$var$styles.sourceItem,
            testId: "sources-list-item"
        }, /*#__PURE__*/ $cozmU.createElement($d0dfe1e2e8452854$var$SourceIcon, {
            iconUrl: source.iconUrl
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d0dfe1e2e8452854$var$styles.title
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            maxLines: 1
        }, source.title)))));
};




















var $19fc3480ef3ca486$exports = {};
$19fc3480ef3ca486$exports = new URL("default-fallback-icon.f348cee4.svg", import.meta.url).toString();


var $6df25a547a605602$exports = {};
$6df25a547a605602$exports = new URL("TWG.b4e1e4d8.svg", import.meta.url).toString();














const $21d06d00df76b0c3$var$shimmerAnimation = null;
const $21d06d00df76b0c3$var$shimmerIconStyle = null;
const $21d06d00df76b0c3$export$27d332fa9b5d24d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2fBhteG8ri _3iDTPbccYA _4vaMcNkEYx _3X9j4qkEYx _1NLcUSzGaF _45s7WmzGaF"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2fBhteG8ri _3iDTPbccYA _4vaMcNkEYx _3X9j4qkEYx _1NLcUSzGaF _45s7WmzGaF"
        ])
    }, children);
};


const $c3a8b920bb800b7a$var$toolIconStyle = null;
const $c3a8b920bb800b7a$var$iconMaskStyle = null;
const $c3a8b920bb800b7a$var$styles = {
    stepIconContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _3YEZNOdnbC"
};
const $c3a8b920bb800b7a$export$e595d572fa6434f3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { isInProgress: isInProgress, toolIcon: toolIcon, isTwg: isTwg, activeLoadingIcon: activeLoadingIcon, iconError: iconError, onIconError: onIconError } = t0;
    let t1;
    if ($[0] !== iconError || $[1] !== isTwg || $[2] !== onIconError) {
        t1 = (iconSrc)=>{
            if (isTwg) return /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6df25a547a605602$exports))),
                alt: "",
                width: 16,
                height: 16
            });
            if (iconSrc && !iconError) return /*#__PURE__*/ $cozmU.createElement("img", {
                src: iconSrc,
                alt: "",
                width: 16,
                height: 16,
                onError: onIconError,
                className: (0, $hekY6.default)([
                    "_39xV02ey7F _0jFU0Vey7F _3iDTPbvLZJ _00EA0egIor"
                ])
            });
            return /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($19fc3480ef3ca486$exports))),
                alt: "",
                width: 16,
                height: 16
            });
        };
        $[0] = iconError;
        $[1] = isTwg;
        $[2] = onIconError;
        $[3] = t1;
    } else t1 = $[3];
    const renderIcon = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc _39xV02cM5X _0jFU0VUofl _1mT5xdRAKS _42Yu6B7dHp"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== activeLoadingIcon || $[6] !== isInProgress || $[7] !== renderIcon || $[8] !== toolIcon) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c3a8b920bb800b7a$var$styles.stepIconContainer
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, isInProgress ? /*#__PURE__*/ $cozmU.createElement((0, $21d06d00df76b0c3$export$27d332fa9b5d24d6), null, renderIcon(activeLoadingIcon)) : renderIcon(toolIcon)));
        $[5] = activeLoadingIcon;
        $[6] = isInProgress;
        $[7] = renderIcon;
        $[8] = toolIcon;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ isInProgress: isInProgress, toolIcon: toolIcon, isTwg: isTwg, activeLoadingIcon: activeLoadingIcon, iconError: iconError, onIconError: onIconError })=>{
    const renderIcon = (iconSrc)=>{
        if (isTwg) return /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6df25a547a605602$exports))),
            alt: "",
            width: 16,
            height: 16
        });
        if (iconSrc && !iconError) return /*#__PURE__*/ $cozmU.createElement("img", {
            src: iconSrc,
            alt: "",
            width: 16,
            height: 16,
            onError: onIconError,
            className: (0, $hekY6.default)([
                "_39xV02ey7F _0jFU0Vey7F _3iDTPbvLZJ _00EA0egIor"
            ])
        });
        return /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($19fc3480ef3ca486$exports))),
            alt: "",
            width: 16,
            height: 16
        });
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c3a8b920bb800b7a$var$styles.stepIconContainer
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc _39xV02cM5X _0jFU0VUofl _1mT5xdRAKS _42Yu6B7dHp"
        ])
    }, isInProgress ? /*#__PURE__*/ $cozmU.createElement((0, $21d06d00df76b0c3$export$27d332fa9b5d24d6), null, renderIcon(activeLoadingIcon)) : renderIcon(toolIcon)));
};


const $ddf14005673d18e5$var$EXECUTE_BASH_TOOL_NAME = 'execute_bash';
const $ddf14005673d18e5$var$substepIconMaskStyle = null;
const $ddf14005673d18e5$var$TWG_TOOL_NAME = 'TeamworkAgent'; // Absolutely-positioned div that renders the TWG grid background across the full step height
// Using a real DOM element (not ::before/::after) since cssMap doesn't support pseudo-elements
// Left offset of 32px skips the icon column (24px icon + 8px gap) so grid only shows on content side
// Uses CSS repeating-linear-gradient with design tokens instead of an SVG file so that
// grid lines adapt to dark mode automatically.
const $ddf14005673d18e5$var$twgGridStyle = null;
const $ddf14005673d18e5$var$styles = {
    stepListItem: "_1LMyvKYbGa _313842Pgdg",
    twgStepListItem: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _2YgrGrP0S5",
    substepIconContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _0Of8r2FQfX _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    substepIconContainerStretch: "_0Of8r2Pgdg",
    verticalRuleContinuation: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _313842Pgdg _39xV02dnbC",
    verticalRuleShort: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3138421Y8M _39xV02dnbC _4kiQYAJg58",
    stepContentWrapper: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _1mT5xdRAKS",
    substepRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _1EqgXlpNyl _17lj8p2ADO _0hPCNLFlnN _1mT5xdRAKS",
    stepTitleContainer: "_0Of8r22ADO _1DCdHi2ADO _39xV02N91d _1EqgXlpNyl",
    stepTitleContainerWithIcons: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
    twgTitleContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp",
    twgIconFanContainer: "_3YEZNOdnbC _2XsHFM2ADO _1Znuxb2ADO",
    substepContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC _1wydGW1Y8M",
    sourcesContent: "_1DCdHi2ADO"
};
const $ddf14005673d18e5$export$2f0c0aff0f64227c = ({ step: step, isLastItem: isLastItem, isInProgress: isInProgress, hideIcon: hideIcon = false, disableShimmer: disableShimmer = false, forceSubstepCollapsed: forceSubstepCollapsed = false, previewSubstep: previewSubstep, titleSize: titleSize = 'medium', previewSubstepSize: previewSubstepSize = 'small', titleWeight: titleWeight = 'regular', expandRequest: expandRequest, onUserExpandToggle: onUserExpandToggle, renderSubstep: renderSubstep, onTraceInteraction: onTraceInteraction, xpcWrapUrl: xpcWrapUrl })=>{
    const [isSubstepExpanded, setIsSubstepExpanded] = (0, $cozmU.useState)(false); // Consume the expand request token: if `.current` is true, auto-expand
    // and mark as consumed. Mutation of `.current` is silent (no re-render),
    // and spent tokens (`.current === false`) are naturally ignored on remount.
    (0, $cozmU.useEffect)(()=>{
        if (expandRequest?.current) {
            expandRequest.current = false;
            setIsSubstepExpanded(true);
        }
    }, [
        expandRequest
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [iconError, setIconError] = (0, $cozmU.useState)(false);
    const isTWGIconEnabled = (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26');
    const cyclingIcon = (0, $d14c06e75415c482$export$cb0798de2d68813b)(isTWGIconEnabled ? undefined : step.sourceIcons, isInProgress);
    const activeLoadingIcon = cyclingIcon ?? step.toolIcon;
    const title = step.title; // For execute_bash steps: replace the raw command/output snippet with a friendlier
    // label, both in the collapsed preview row and as the FIRST substep when expanded.
    const isExecuteBash = step.toolName === $ddf14005673d18e5$var$EXECUTE_BASH_TOOL_NAME;
    const isTwgStep = isTWGIconEnabled && step.toolName === $ddf14005673d18e5$var$TWG_TOOL_NAME;
    const executeBashSubstepLabel = formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).executeBashSubstep);
    const effectivePreviewSubstep = isExecuteBash ? executeBashSubstepLabel : previewSubstep;
    const effectiveSeparatedContent = isExecuteBash ? [
        executeBashSubstepLabel,
        ...step.separatedContent
    ] : step.separatedContent;
    const hasSubsteps = effectiveSeparatedContent.length > 0 || step.documents !== undefined && step.documents.length > 0;
    const stepTitleShimmer = typeof title === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
        weight: titleWeight
    }, title) : title;
    const stepTitleNormal = typeof title === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: titleSize,
        weight: titleWeight,
        color: "color.text.subtlest"
    }, title) : title;
    const showSubsteps = hasSubsteps && isSubstepExpanded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: (0, $w6R6I.cx)($ddf14005673d18e5$var$styles.stepListItem, isTwgStep && $ddf14005673d18e5$var$styles.twgStepListItem),
        testId: "research-step-list-item"
    }, isTwgStep && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _0bjKvD8fU6 _1mT5xdWVPG _3OE6xYUofl _0KLXrunmFW _3OqcjTHxI3 _1DJ2rVkhuJ _3CkH9oO8Pm _4vaMcNhped _3X9j4qhped _1pp6NdYbGa _1EqgXlpNyl _42Yu6BdnbC"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.stepContentWrapper,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3a8b920bb800b7a$export$e595d572fa6434f3), {
        isInProgress: isInProgress,
        toolIcon: step.toolIcon,
        isTwg: isTwgStep,
        activeLoadingIcon: activeLoadingIcon,
        iconError: iconError,
        onIconError: ()=>setIconError(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddf14005673d18e5$var$styles.stepTitleContainer, isTwgStep && $ddf14005673d18e5$var$styles.stepTitleContainerWithIcons)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isTwgStep ? $ddf14005673d18e5$var$styles.twgTitleContent : undefined
    }, hasSubsteps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22faee5074b66dbd$export$5b346f7d85a51eb5), {
        defaultExpanded: isSubstepExpanded || (forceSubstepCollapsed ? false : isInProgress),
        showDownRightIcons: true,
        layout: "inline",
        hideExpandIcon: !isHovered,
        title: isInProgress && !disableShimmer ? stepTitleShimmer : stepTitleNormal,
        onExpandChanged: (expanded)=>setIsSubstepExpanded(expanded),
        onExpandClick: (expanded_0)=>{
            onTraceInteraction?.({
                type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).SINGLE_TRACE,
                expanded: expanded_0
            });
            onUserExpandToggle?.(step.stepId, expanded_0);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)), forceSubstepCollapsed && effectivePreviewSubstep && !isSubstepExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: previewSubstepSize,
        color: "color.text.subtlest",
        maxLines: 1
    }, (0, $2249edee9d5e9bc4$export$c470c39bf64377a2)(effectivePreviewSubstep))) : isInProgress && !disableShimmer ? stepTitleShimmer : stepTitleNormal), isTwgStep && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.twgIconFanContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87b3b642758339c3$export$118d8860340048c), {
        icons: step.sourceIcons,
        isInProgress: isInProgress,
        stepId: step.stepId
    })))), showSubsteps && isLastItem && !hideIcon && !(step.documents && step.documents.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.substepRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddf14005673d18e5$var$styles.substepIconContainer, $ddf14005673d18e5$var$styles.substepIconContainerStretch)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.verticalRuleContinuation
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.substepContent
    })), step.documents && step.documents.length > 0 && showSubsteps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.substepRow
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddf14005673d18e5$var$styles.substepIconContainer, $ddf14005673d18e5$var$styles.substepIconContainerStretch)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ddf14005673d18e5$var$styles.verticalRuleContinuation
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddf14005673d18e5$var$styles.substepContent, $ddf14005673d18e5$var$styles.sourcesContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d0dfe1e2e8452854$export$b3ebd135320cfc), {
        sources: step.documents.map((doc)=>({
                title: doc.title,
                url: doc.url,
                iconUrl: doc.product || undefined
            })),
        xpcWrapUrl: xpcWrapUrl
    }))), showSubsteps && effectiveSeparatedContent.map((sub, index)=>{
        const isLastSubstep = index === effectiveSeparatedContent.length - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `${step.stepId}-substep-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ddf14005673d18e5$var$styles.substepRow
        }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ddf14005673d18e5$var$styles.substepIconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc _0Of8r2FQfX _1wydGWFQfX _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dovdS))), {
            label: ""
        })), (!isLastSubstep || !isLastItem) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ddf14005673d18e5$var$styles.verticalRuleShort
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ddf14005673d18e5$var$styles.substepContent
        }, renderSubstep(sub, step.isStreamed ?? false))));
    }));
};










































































const $a1a41e400a3ae0ca$var$DEFAULT_INITIAL_DELAY_MS = 3000;
const $a1a41e400a3ae0ca$var$DEFAULT_INTERVAL_MS = 1800;
/**
 * Fisher-Yates shuffle — returns a new shuffled copy of the array.
 */ function $a1a41e400a3ae0ca$var$shuffle(array) {
    const result = [
        ...array
    ];
    for(let i = result.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [
            result[j],
            result[i]
        ];
    }
    return result;
}
function $a1a41e400a3ae0ca$export$34dbd4d7b7e2b982(config) {
    const { texts: texts, initialDelayMs: initialDelayMs = $a1a41e400a3ae0ca$var$DEFAULT_INITIAL_DELAY_MS, intervalMs: intervalMs = $a1a41e400a3ae0ca$var$DEFAULT_INTERVAL_MS } = config;
    const initialText = texts[0] ?? '';
    const [currentText, setCurrentText] = (0, $cozmU.useState)(initialText);
    // ── refs for mutable state that must survive across closures ──────────
    const poolRef = (0, $cozmU.useRef)([]);
    const indexRef = (0, $cozmU.useRef)(0);
    const timeoutRef = (0, $cozmU.useRef)(null);
    const intervalRef = (0, $cozmU.useRef)(null);
    // Keep latest config values in refs so `startCycle` always reads fresh
    // values without needing to be recreated on every config change.
    const textsRef = (0, $cozmU.useRef)(texts);
    textsRef.current = texts;
    const initialDelayRef = (0, $cozmU.useRef)(initialDelayMs);
    initialDelayRef.current = initialDelayMs;
    const intervalMsRef = (0, $cozmU.useRef)(intervalMs);
    intervalMsRef.current = intervalMs;
    const initialTextRef = (0, $cozmU.useRef)(initialText);
    initialTextRef.current = initialText;
    // ── timer helpers ─────────────────────────────────────────────────────
    const clearTimers = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    /**
   * Starts the full cycle:
   * 1. Show `initialText` immediately.
   * 2. After `initialDelayMs`, build a shuffled pool and begin rotating.
   */ const startCycle = (0, $cozmU.useCallback)(()=>{
        clearTimers();
        const currentTexts = textsRef.current;
        setCurrentText(initialTextRef.current);
        poolRef.current = [];
        indexRef.current = 0;
        if (currentTexts.length <= 1) return;
        timeoutRef.current = setTimeout(()=>{
            // Build initial shuffled pool (excluding the first/initial text to avoid repetition)
            poolRef.current = $a1a41e400a3ae0ca$var$shuffle(currentTexts.slice(1));
            indexRef.current = 0;
            // Show first rotating text immediately
            setCurrentText(poolRef.current[0]);
            intervalRef.current = setInterval(()=>{
                indexRef.current += 1;
                // Rebuild pool when exhausted
                if (indexRef.current >= poolRef.current.length) {
                    poolRef.current = $a1a41e400a3ae0ca$var$shuffle(textsRef.current.slice(1));
                    indexRef.current = 0;
                }
                setCurrentText(poolRef.current[indexRef.current]);
            }, intervalMsRef.current);
        }, initialDelayRef.current);
    }, [
        clearTimers
    ]);
    // ── start on mount, clean up on unmount ───────────────────────────────
    (0, $cozmU.useEffect)(()=>{
        startCycle();
        return clearTimers;
    }, [
        startCycle,
        clearTimers
    ]);
    // ── public API ────────────────────────────────────────────────────────
    // `reset` has a stable identity (only depends on `startCycle` which only
    // depends on `clearTimers` — both produced by useCallback with [] deps).
    const reset = startCycle;
    return {
        text: currentText,
        reset: reset
    };
}


const $47027e2fe5c7ba39$export$b2c6b01c41796fb2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function RotatingThinkingIndicator(t0, ref) {
    const $ = (0, $bDgLe.c)(18);
    const { title: title, rotatingTitleConfig: rotatingTitleConfig, isAnimated: isAnimated, icon: icon, animation: animation, disableMorphingAnimation: disableMorphingAnimation, showEllipsis: showEllipsis, testId: testId } = t0;
    let t1;
    if ($[0] !== rotatingTitleConfig.texts || $[1] !== title) {
        t1 = [
            title,
            ...rotatingTitleConfig.texts
        ];
        $[0] = rotatingTitleConfig.texts;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    const textsWithTitle = t1;
    let t2;
    if ($[3] !== rotatingTitleConfig.initialDelayMs || $[4] !== rotatingTitleConfig.intervalMs || $[5] !== textsWithTitle) {
        t2 = {
            texts: textsWithTitle,
            initialDelayMs: rotatingTitleConfig.initialDelayMs,
            intervalMs: rotatingTitleConfig.intervalMs
        };
        $[3] = rotatingTitleConfig.initialDelayMs;
        $[4] = rotatingTitleConfig.intervalMs;
        $[5] = textsWithTitle;
        $[6] = t2;
    } else t2 = $[6];
    const { text: text, reset: reset } = (0, $a1a41e400a3ae0ca$export$34dbd4d7b7e2b982)(t2);
    let t3;
    let t4;
    if ($[7] !== reset) {
        t3 = ()=>({
                resetRotation: reset
            });
        t4 = [
            reset
        ];
        $[7] = reset;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useImperativeHandle)(ref, t3, t4);
    let t5;
    if ($[10] !== animation || $[11] !== disableMorphingAnimation || $[12] !== icon || $[13] !== isAnimated || $[14] !== showEllipsis || $[15] !== testId || $[16] !== text) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2diYd.RovoThinkingIndicator), {
            title: text,
            isAnimated: isAnimated,
            icon: icon,
            animation: animation,
            disableMorphingAnimation: disableMorphingAnimation,
            showEllipsis: showEllipsis,
            testId: testId
        });
        $[10] = animation;
        $[11] = disableMorphingAnimation;
        $[12] = icon;
        $[13] = isAnimated;
        $[14] = showEllipsis;
        $[15] = testId;
        $[16] = text;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : function RotatingThinkingIndicator({ title: title, rotatingTitleConfig: rotatingTitleConfig, isAnimated: isAnimated, icon: icon, animation: animation, disableMorphingAnimation: disableMorphingAnimation, showEllipsis: showEllipsis, testId: testId }, ref) {
    // Prepend the static title so it's displayed during the initial delay
    const textsWithTitle = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>[
            title,
            ...rotatingTitleConfig.texts
        ], [
        title,
        rotatingTitleConfig.texts
    ]);
    const { text: text, reset: reset } = (0, $a1a41e400a3ae0ca$export$34dbd4d7b7e2b982)({
        texts: textsWithTitle,
        initialDelayMs: rotatingTitleConfig.initialDelayMs,
        intervalMs: rotatingTitleConfig.intervalMs
    });
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            resetRotation: reset
        }), [
        reset
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2diYd.RovoThinkingIndicator), {
        title: text,
        isAnimated: isAnimated,
        icon: icon,
        animation: animation,
        disableMorphingAnimation: disableMorphingAnimation,
        showEllipsis: showEllipsis,
        testId: testId
    });
});








const $764ec94c03911219$export$d54e8765479668b6 = (0, $kSwu1.defineMessages)({
    connectingDots: {
        id: "ai-mate.chat-history.rotating-thinking.connecting-dots",
        defaultMessage: "Connecting dots"
    },
    pullingThreads: {
        id: "ai-mate.chat-history.rotating-thinking.pulling-threads",
        defaultMessage: "Pulling threads"
    },
    dialingIn: {
        id: "ai-mate.chat-history.rotating-thinking.dialing-in",
        defaultMessage: "Dialing in"
    },
    spoolingThoughts: {
        id: "ai-mate.chat-history.rotating-thinking.spooling-thoughts",
        defaultMessage: "Spooling thoughts"
    },
    sparkingIdeas: {
        id: "ai-mate.chat-history.rotating-thinking.sparking-ideas",
        defaultMessage: "Sparking ideas"
    },
    percolating: {
        id: "ai-mate.chat-history.rotating-thinking.percolating",
        defaultMessage: "Percolating"
    },
    ruminating: {
        id: "ai-mate.chat-history.rotating-thinking.ruminating",
        defaultMessage: "Ruminating"
    },
    weavingSolutions: {
        id: "ai-mate.chat-history.rotating-thinking.weaving-solutions",
        defaultMessage: "Weaving solutions"
    },
    jugglingOptions: {
        id: "ai-mate.chat-history.rotating-thinking.juggling-options",
        defaultMessage: "Juggling options"
    },
    peekingAhead: {
        id: "ai-mate.chat-history.rotating-thinking.peeking-ahead",
        defaultMessage: "Peeking ahead"
    },
    preparing: {
        id: "ai-mate.chat-history.rotating-thinking.preparing",
        defaultMessage: "Preparing"
    },
    humming: {
        id: "ai-mate.chat-history.rotating-thinking.humming",
        defaultMessage: "Humming"
    },
    coalescing: {
        id: "ai-mate.chat-history.rotating-thinking.coalescing",
        defaultMessage: "Coalescing"
    },
    gatheringThoughts: {
        id: "ai-mate.chat-history.rotating-thinking.gathering-thoughts",
        defaultMessage: "Gathering thoughts"
    }
});
const $764ec94c03911219$export$7d3d87b0d202cb5c = (0, $kSwu1.defineMessages)({
    discombobulating: {
        id: "ai-mate.chat-history.rotating-thinking.discombobulating",
        defaultMessage: "Discombobulating"
    },
    shimmering: {
        id: "ai-mate.chat-history.rotating-thinking.shimmering",
        defaultMessage: "Shimmering"
    },
    spindling: {
        id: "ai-mate.chat-history.rotating-thinking.spindling",
        defaultMessage: "Spindling"
    },
    combobulating: {
        id: "ai-mate.chat-history.rotating-thinking.combobulating",
        defaultMessage: "Combobulating"
    },
    thinkingBrilliantly: {
        id: "ai-mate.chat-history.rotating-thinking.thinking-brilliantly",
        defaultMessage: "Thinking brilliantly"
    },
    nudgingNeurons: {
        id: "ai-mate.chat-history.rotating-thinking.nudging-neurons",
        defaultMessage: "Nudging neurons"
    }
});
const $764ec94c03911219$export$e5ad37f92ed0b78a = 2;


function $b1de2455f93e9ad0$var$shuffle(array) {
    const result = [
        ...array
    ];
    for(let i = result.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [
            result[j],
            result[i]
        ];
    }
    return result;
}
const $b1de2455f93e9ad0$export$28650ce4c6dd31cd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { steps: steps, researchCompleted: researchCompleted, thinkDeeperTriggered: thinkDeeperTriggered, isAnimated: isAnimated, icon: icon, animation: animation, disableMorphingAnimation: disableMorphingAnimation, showEllipsis: showEllipsis, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = thinkDeeperTriggered ? (0, $0efef966bd6ba92a$export$2e2bcd8739ae039).thinkDeeperThinking : (0, $0efef966bd6ba92a$export$2e2bcd8739ae039).rovoIsThinking;
    let t2;
    if ($[0] !== formatMessage || $[1] !== t1) {
        t2 = formatMessage(t1);
        $[0] = formatMessage;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const staticTitle = t2;
    let t3;
    if ($[3] !== formatMessage) {
        t3 = Object.values((0, $764ec94c03911219$export$d54e8765479668b6)).map((msg)=>formatMessage(msg));
        $[3] = formatMessage;
        $[4] = t3;
    } else t3 = $[4];
    const core = t3;
    let t4;
    if ($[5] !== core || $[6] !== formatMessage) {
        const rare = Object.values((0, $764ec94c03911219$export$7d3d87b0d202cb5c)).map((msg_0)=>formatMessage(msg_0));
        const selectedRare = $b1de2455f93e9ad0$var$shuffle(rare).slice(0, (0, $764ec94c03911219$export$e5ad37f92ed0b78a));
        t4 = [
            ...core,
            ...selectedRare
        ];
        $[5] = core;
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    const rotatingTexts = t4;
    const rotatingRef = (0, $cozmU.useRef)(null);
    let t5;
    if ($[8] !== steps) {
        t5 = steps.map($b1de2455f93e9ad0$var$_temp).join("|");
        $[8] = steps;
        $[9] = t5;
    } else t5 = $[9];
    const stepFingerprint = t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            rotatingRef.current?.resetRotation();
        };
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== stepFingerprint) {
        t7 = [
            stepFingerprint
        ];
        $[11] = stepFingerprint;
        $[12] = t7;
    } else t7 = $[12];
    (0, $cozmU.useEffect)(t6, t7);
    const hasInProgressSteps = steps.some($b1de2455f93e9ad0$var$_temp2);
    if (researchCompleted || hasInProgressSteps) {
        let t8;
        if ($[13] !== animation || $[14] !== disableMorphingAnimation || $[15] !== icon || $[16] !== isAnimated || $[17] !== showEllipsis || $[18] !== staticTitle || $[19] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2diYd.RovoThinkingIndicator), {
                title: staticTitle,
                isAnimated: isAnimated,
                icon: icon,
                animation: animation,
                disableMorphingAnimation: disableMorphingAnimation,
                showEllipsis: showEllipsis,
                testId: testId
            });
            $[13] = animation;
            $[14] = disableMorphingAnimation;
            $[15] = icon;
            $[16] = isAnimated;
            $[17] = showEllipsis;
            $[18] = staticTitle;
            $[19] = testId;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    let t8;
    if ($[21] !== rotatingTexts) {
        t8 = {
            texts: rotatingTexts
        };
        $[21] = rotatingTexts;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== animation || $[24] !== disableMorphingAnimation || $[25] !== icon || $[26] !== isAnimated || $[27] !== showEllipsis || $[28] !== staticTitle || $[29] !== t8 || $[30] !== testId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47027e2fe5c7ba39$export$b2c6b01c41796fb2), {
            ref: rotatingRef,
            title: staticTitle,
            rotatingTitleConfig: t8,
            isAnimated: isAnimated,
            icon: icon,
            animation: animation,
            disableMorphingAnimation: disableMorphingAnimation,
            showEllipsis: showEllipsis,
            testId: testId
        });
        $[23] = animation;
        $[24] = disableMorphingAnimation;
        $[25] = icon;
        $[26] = isAnimated;
        $[27] = showEllipsis;
        $[28] = staticTitle;
        $[29] = t8;
        $[30] = testId;
        $[31] = t9;
    } else t9 = $[31];
    return t9;
} : ({ steps: steps, researchCompleted: researchCompleted, thinkDeeperTriggered: thinkDeeperTriggered, isAnimated: isAnimated, icon: icon, animation: animation, disableMorphingAnimation: disableMorphingAnimation, showEllipsis: showEllipsis, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // ── Static title (shown during initial delay / when rotation is off) ──
    const staticTitle = formatMessage(thinkDeeperTriggered ? (0, $0efef966bd6ba92a$export$2e2bcd8739ae039).thinkDeeperThinking : (0, $0efef966bd6ba92a$export$2e2bcd8739ae039).rovoIsThinking); // ── Build the weighted rotating text pool ─────────────────────────────
    // Memoised so the array identity is stable across renders.
    const rotatingTexts = (0, $cozmU.useMemo)(()=>{
        const core = Object.values((0, $764ec94c03911219$export$d54e8765479668b6)).map((msg)=>formatMessage(msg));
        const rare = Object.values((0, $764ec94c03911219$export$7d3d87b0d202cb5c)).map((msg_0)=>formatMessage(msg_0)); // Pick a random subset of rare messages to mix in
        const selectedRare = $b1de2455f93e9ad0$var$shuffle(rare).slice(0, (0, $764ec94c03911219$export$e5ad37f92ed0b78a));
        return [
            ...core,
            ...selectedRare
        ];
    }, [
        formatMessage
    ]);
    const rotatingRef = (0, $cozmU.useRef)(null); // ── Reset rotation whenever the step landscape changes ────────────────
    // A fingerprint derived from each step's full state (id, completion,
    // streaming status, and actual content) ensures we reset on any
    // meaningful change — including content streaming into a step.
    const stepFingerprint = (0, $cozmU.useMemo)(()=>{
        return steps.map((s)=>`${s.stepId}:${s.completed ?? false}:${s.isStreamed ?? false}:${s.separatedContent.join(',')}`).join('|');
    }, [
        steps
    ]);
    (0, $cozmU.useEffect)(()=>{
        rotatingRef.current?.resetRotation();
    }, [
        stepFingerprint
    ]); // ── Suppress rotation when research is complete or any step is still in progress ──
    // Rotation only kicks in when all visible steps are completed but we're
    // waiting for the next step or the final answer.
    const hasInProgressSteps = steps.some((s_0)=>!s_0.completed);
    if (researchCompleted || hasInProgressSteps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2diYd.RovoThinkingIndicator), {
        title: staticTitle,
        isAnimated: isAnimated,
        icon: icon,
        animation: animation,
        disableMorphingAnimation: disableMorphingAnimation,
        showEllipsis: showEllipsis,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47027e2fe5c7ba39$export$b2c6b01c41796fb2), {
        ref: rotatingRef,
        title: staticTitle,
        rotatingTitleConfig: {
            texts: rotatingTexts
        },
        isAnimated: isAnimated,
        icon: icon,
        animation: animation,
        disableMorphingAnimation: disableMorphingAnimation,
        showEllipsis: showEllipsis,
        testId: testId
    });
};
function $b1de2455f93e9ad0$var$_temp(s) {
    return `${s.stepId}:${s.completed ?? false}:${s.isStreamed ?? false}:${s.separatedContent.join(",")}`;
}
function $b1de2455f93e9ad0$var$_temp2(s_0) {
    return !s_0.completed;
}






const $a6ff1dd45bf7b635$var$timelineConnectorLineStyle = null;
const $a6ff1dd45bf7b635$var$timelineConnectorLineExpandedStyle = null;
const $a6ff1dd45bf7b635$var$styles = {
    researchStepList: "_4bt5LAYvD1 _2WAcuGYvD1 _2Y7lL4Pgdg _3SamIHPgdg _0aNu0LYbGa _1mT5xdRAKS",
    thinkingListItem: "_1LMyvKYbGa _1DCdHiFQfX",
    stepTitleContainer: "_1DCdHiPgdg _39xV02N91d",
    clickableThinkingText: "_4bt5LAnQyn _2WAcuGnQyn _0wOv4Q7zJH _0KLXrujOvk _2fwxA5ecOK _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _4ouGXIdnbC",
    unstyledPressable: "_30huDKYbGa _0KLXrujOvk _0Of8r28HPE _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _39xV02N91d _2fwxA5ecOK _37wbyuchRC _0hPCNLchRC",
    collapsedExpandable: ""
};
const $a6ff1dd45bf7b635$var$MAX_VISIBLE_STEPS = 3; /**
                              * Multi-trace compact preview for think deeper traces.
                              * Shows a sliding window of up to 3 traces (prioritising loading ones),
                              * with animations as traces arrive and complete.
                              */ 
const $a6ff1dd45bf7b635$export$d867c592855137bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { steps: t1, renderSubstep: renderSubstep, researchCompleted: t2, thinkDeeperTriggered: t3, answerNowSlot: answerNowSlot, onTraceInteraction: onTraceInteraction, onUserExpandToggle: onUserExpandToggle, onPreviewExpandChanged: onPreviewExpandChanged } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const steps = t4;
    const _researchCompleted = t2 === undefined ? false : t2;
    const thinkDeeperTriggered = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [previewExpandRequest, setPreviewExpandRequest] = (0, $cozmU.useState)(null);
    let t5;
    if ($[2] !== onPreviewExpandChanged || $[3] !== onUserExpandToggle) {
        t5 = (stepId, expanded)=>{
            if (expanded) {
                setPreviewExpandRequest({
                    stepId: stepId,
                    token: {
                        current: true
                    }
                });
                setIsExpanded(true);
                onPreviewExpandChanged?.(true);
            } else setPreviewExpandRequest(null);
            onUserExpandToggle?.(stepId, expanded);
        };
        $[2] = onPreviewExpandChanged;
        $[3] = onUserExpandToggle;
        $[4] = t5;
    } else t5 = $[4];
    const handleWindowedUserExpandToggle = t5;
    let t6;
    if ($[5] !== onPreviewExpandChanged || $[6] !== onTraceInteraction) {
        t6 = ()=>{
            setIsExpanded(false);
            setPreviewExpandRequest(null);
            onPreviewExpandChanged?.(false);
            onTraceInteraction?.({
                type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).ALL_TRACES,
                expanded: false
            });
        };
        $[5] = onPreviewExpandChanged;
        $[6] = onTraceInteraction;
        $[7] = t6;
    } else t6 = $[7];
    const handleMainExpandableCollapsed = t6;
    const hasSteps = steps.length > 0;
    let t7;
    if ($[8] !== steps) {
        const loading = steps.filter($a6ff1dd45bf7b635$var$_temp);
        const completed = steps.filter($a6ff1dd45bf7b635$var$_temp2);
        const selectedLoading = loading.slice(-$a6ff1dd45bf7b635$var$MAX_VISIBLE_STEPS);
        const remainingSlots = $a6ff1dd45bf7b635$var$MAX_VISIBLE_STEPS - selectedLoading.length;
        const selectedCompleted = remainingSlots > 0 ? completed.slice(-remainingSlots) : [];
        const selected = [
            ...selectedLoading,
            ...selectedCompleted
        ];
        t7 = selected.sort((a, b)=>steps.indexOf(a) - steps.indexOf(b));
        $[8] = steps;
        $[9] = t7;
    } else t7 = $[9];
    const windowedSteps = t7;
    let t8;
    if ($[10] !== _researchCompleted || $[11] !== answerNowSlot || $[12] !== formatMessage || $[13] !== handleMainExpandableCollapsed || $[14] !== hasSteps || $[15] !== isExpanded || $[16] !== onPreviewExpandChanged || $[17] !== onTraceInteraction || $[18] !== onUserExpandToggle || $[19] !== previewExpandRequest || $[20] !== renderSubstep || $[21] !== steps || $[22] !== thinkDeeperTriggered) {
        t8 = hasSteps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: !isExpanded ? $a6ff1dd45bf7b635$var$styles.collapsedExpandable : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22faee5074b66dbd$export$5b346f7d85a51eb5), {
            defaultExpanded: isExpanded,
            showExpandIcon: !isExpanded,
            showExpandAtEnd: false,
            showDownRightIcons: true,
            iconSpacing: "compact",
            onExpandChanged: (expanded_0)=>setIsExpanded(expanded_0),
            onExpandClick: (expanded_1)=>{
                onTraceInteraction?.({
                    type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).ALL_TRACES,
                    expanded: expanded_1
                });
                onPreviewExpandChanged?.(expanded_1);
            },
            title: isExpanded ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1de2455f93e9ad0$export$28650ce4c6dd31cd), {
                steps: steps,
                researchCompleted: _researchCompleted,
                thinkDeeperTriggered: thinkDeeperTriggered,
                isAnimated: false,
                icon: false,
                animation: true,
                showEllipsis: true
            }),
            afterExpandIconSlot: !isExpanded ? answerNowSlot : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $a6ff1dd45bf7b635$var$styles.researchStepList,
            testId: "research-step-list"
        }, steps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xYdLIE _2IhToncM5X _0Bm75GNHnM _39xV024Jdh _0KLXru9r67 _42Yu6BdnbC"
            ])
        }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $a6ff1dd45bf7b635$var$styles.thinkingListItem,
            testId: "research-step-thinking-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a6ff1dd45bf7b635$var$styles.stepTitleContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            onClick: handleMainExpandableCollapsed,
            "aria-label": formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).collapse),
            xcss: $a6ff1dd45bf7b635$var$styles.clickableThinkingText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1de2455f93e9ad0$export$28650ce4c6dd31cd), {
            steps: steps,
            researchCompleted: _researchCompleted,
            thinkDeeperTriggered: thinkDeeperTriggered,
            isAnimated: false,
            icon: false,
            animation: true,
            showEllipsis: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            appearance: "subtle",
            icon: $a6ff1dd45bf7b635$var$_temp3,
            label: formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).collapse),
            onClick: handleMainExpandableCollapsed
        }), answerNowSlot)))), steps.map((step, index)=>{
            const isLastStep = index === steps.length - 1;
            const isInProgress = !step.completed;
            const lastSubstepForStep = step.separatedContent.length > 0 ? step.separatedContent[step.separatedContent.length - 1] : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddf14005673d18e5$export$2f0c0aff0f64227c), {
                key: step.stepId,
                step: step,
                isLastItem: isLastStep,
                isInProgress: isInProgress,
                hideIcon: false,
                disableShimmer: true,
                forceSubstepCollapsed: true,
                previewSubstep: lastSubstepForStep,
                titleSize: "small",
                titleWeight: "medium",
                expandRequest: previewExpandRequest?.stepId === step.stepId ? previewExpandRequest.token : null,
                onUserExpandToggle: onUserExpandToggle,
                renderSubstep: renderSubstep,
                onTraceInteraction: onTraceInteraction
            });
        })))) : null;
        $[10] = _researchCompleted;
        $[11] = answerNowSlot;
        $[12] = formatMessage;
        $[13] = handleMainExpandableCollapsed;
        $[14] = hasSteps;
        $[15] = isExpanded;
        $[16] = onPreviewExpandChanged;
        $[17] = onTraceInteraction;
        $[18] = onUserExpandToggle;
        $[19] = previewExpandRequest;
        $[20] = renderSubstep;
        $[21] = steps;
        $[22] = thinkDeeperTriggered;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== handleWindowedUserExpandToggle || $[25] !== hasSteps || $[26] !== isExpanded || $[27] !== onPreviewExpandChanged || $[28] !== onTraceInteraction || $[29] !== renderSubstep || $[30] !== windowedSteps) {
        t9 = !isExpanded && hasSteps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $a6ff1dd45bf7b635$var$styles.unstyledPressable,
            onClick: (e)=>{
                if (e.target instanceof Element) {
                    if (e.target.closest("button")) return;
                    if (e.target.closest("a[href]")) return;
                }
                setIsExpanded(true);
                onPreviewExpandChanged?.(true);
                onTraceInteraction?.({
                    type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).ALL_TRACES,
                    expanded: true
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $a6ff1dd45bf7b635$var$styles.researchStepList
        }, windowedSteps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xYdLIE _2IhTon8ija _0Bm75GNHnM _39xV024Jdh _0KLXru9r67 _42Yu6BdnbC"
            ])
        }), windowedSteps.map((step_0, index_0)=>{
            const isLastStep_0 = index_0 === windowedSteps.length - 1;
            const isInProgress_0 = !step_0.completed;
            const lastSubstep = step_0.separatedContent.length > 0 ? step_0.separatedContent[step_0.separatedContent.length - 1] : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                key: step_0.stepId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                entranceDirection: "bottom",
                exitDirection: "top",
                duration: "medium"
            }, (fadeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", fadeProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddf14005673d18e5$export$2f0c0aff0f64227c), {
                    step: step_0,
                    isLastItem: isLastStep_0,
                    isInProgress: isInProgress_0,
                    hideIcon: false,
                    disableShimmer: true,
                    forceSubstepCollapsed: true,
                    previewSubstep: lastSubstep,
                    titleSize: "small",
                    titleWeight: "medium",
                    onUserExpandToggle: handleWindowedUserExpandToggle,
                    renderSubstep: renderSubstep,
                    onTraceInteraction: onTraceInteraction
                }))));
        })));
        $[24] = handleWindowedUserExpandToggle;
        $[25] = hasSteps;
        $[26] = isExpanded;
        $[27] = onPreviewExpandChanged;
        $[28] = onTraceInteraction;
        $[29] = renderSubstep;
        $[30] = windowedSteps;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== t8 || $[33] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0",
            grow: "fill"
        }, t8, t9));
        $[32] = t8;
        $[33] = t9;
        $[34] = t10;
    } else t10 = $[34];
    return t10;
} : ({ steps: steps = [], renderSubstep: renderSubstep, researchCompleted: _researchCompleted = false, thinkDeeperTriggered: thinkDeeperTriggered = false, answerNowSlot: answerNowSlot, onTraceInteraction: onTraceInteraction, onUserExpandToggle: onUserExpandToggle, onPreviewExpandChanged: onPreviewExpandChanged })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false); // Single preview-local expand request: when the user expands a step in the
    // windowed (collapsed) section, we create a token so the same step
    // auto-expands inside the main expandable. Only one is needed because the
    // main expandable opens immediately and the token is consumed right away.
    const [previewExpandRequest, setPreviewExpandRequest] = (0, $cozmU.useState)(null); // When a step is manually toggled from the windowed preview, open the
    // main expandable so the user immediately sees the expanded step.
    const handleWindowedUserExpandToggle = (0, $cozmU.useCallback)((stepId, expanded)=>{
        if (expanded) {
            setPreviewExpandRequest({
                stepId: stepId,
                token: {
                    current: true
                }
            });
            setIsExpanded(true);
            onPreviewExpandChanged?.(true);
        } else setPreviewExpandRequest(null);
         // Propagate to parent (CompactResearchSteps) for the completed-phase tokens
        onUserExpandToggle?.(stepId, expanded);
    }, [
        onUserExpandToggle,
        onPreviewExpandChanged
    ]); // When the user collapses the main expandable, clear the preview token
    // and notify the parent to clear all accumulated expand requests.
    const handleMainExpandableCollapsed = (0, $cozmU.useCallback)(()=>{
        setIsExpanded(false);
        setPreviewExpandRequest(null);
        onPreviewExpandChanged?.(false);
        onTraceInteraction?.({
            type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).ALL_TRACES,
            expanded: false
        });
    }, [
        onTraceInteraction,
        onPreviewExpandChanged
    ]);
    const hasSteps = steps.length > 0; // Priority-based sliding window: always show latest loading traces, fill remaining with recent completed
    const windowedSteps = (0, $cozmU.useMemo)(()=>{
        const loading = steps.filter((s)=>!s.completed);
        const completed = steps.filter((s_0)=>s_0.completed); // Take the most recent loading traces (up to MAX_VISIBLE_STEPS)
        const selectedLoading = loading.slice(-$a6ff1dd45bf7b635$var$MAX_VISIBLE_STEPS); // Fill remaining slots with most recent completed traces
        const remainingSlots = $a6ff1dd45bf7b635$var$MAX_VISIBLE_STEPS - selectedLoading.length;
        const selectedCompleted = remainingSlots > 0 ? completed.slice(-remainingSlots) : []; // Combine and sort back to original order
        const selected = [
            ...selectedLoading,
            ...selectedCompleted
        ];
        return selected.sort((a, b)=>steps.indexOf(a) - steps.indexOf(b));
    }, [
        steps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0",
        grow: "fill"
    }, hasSteps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: !isExpanded ? $a6ff1dd45bf7b635$var$styles.collapsedExpandable : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22faee5074b66dbd$export$5b346f7d85a51eb5), {
        defaultExpanded: isExpanded,
        showExpandIcon: !isExpanded,
        showExpandAtEnd: false,
        showDownRightIcons: true,
        iconSpacing: "compact",
        onExpandChanged: (expanded_0)=>setIsExpanded(expanded_0),
        onExpandClick: (expanded_1)=>{
            onTraceInteraction?.({
                type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).ALL_TRACES,
                expanded: expanded_1
            });
            onPreviewExpandChanged?.(expanded_1);
        },
        title: isExpanded ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1de2455f93e9ad0$export$28650ce4c6dd31cd), {
            steps: steps,
            researchCompleted: _researchCompleted,
            thinkDeeperTriggered: thinkDeeperTriggered,
            isAnimated: false,
            icon: false,
            animation: true,
            showEllipsis: true
        }),
        afterExpandIconSlot: !isExpanded ? answerNowSlot : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $a6ff1dd45bf7b635$var$styles.researchStepList,
        testId: "research-step-list"
    }, steps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3OE6xYdLIE _2IhToncM5X _0Bm75GNHnM _39xV024Jdh _0KLXru9r67 _42Yu6BdnbC"
        ])
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $a6ff1dd45bf7b635$var$styles.thinkingListItem,
        testId: "research-step-thinking-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a6ff1dd45bf7b635$var$styles.stepTitleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: handleMainExpandableCollapsed,
        "aria-label": formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).collapse),
        xcss: $a6ff1dd45bf7b635$var$styles.clickableThinkingText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1de2455f93e9ad0$export$28650ce4c6dd31cd), {
        steps: steps,
        researchCompleted: _researchCompleted,
        thinkDeeperTriggered: thinkDeeperTriggered,
        isAnimated: false,
        icon: false,
        animation: true,
        showEllipsis: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).collapse),
        onClick: handleMainExpandableCollapsed
    }), answerNowSlot)))), steps.map((step, index)=>{
        const isLastStep = index === steps.length - 1; // Use individual step completion status: completed → NodeIcon, loading → Spinner
        const isInProgress = !step.completed;
        const lastSubstepForStep = step.separatedContent.length > 0 ? step.separatedContent[step.separatedContent.length - 1] : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddf14005673d18e5$export$2f0c0aff0f64227c), {
            key: step.stepId,
            step: step,
            isLastItem: isLastStep,
            isInProgress: isInProgress,
            hideIcon: false,
            disableShimmer: true,
            forceSubstepCollapsed: true,
            previewSubstep: lastSubstepForStep,
            titleSize: "small",
            titleWeight: "medium",
            expandRequest: previewExpandRequest?.stepId === step.stepId ? previewExpandRequest.token : null,
            onUserExpandToggle: onUserExpandToggle,
            renderSubstep: renderSubstep,
            onTraceInteraction: onTraceInteraction
        });
    })))) : null, !isExpanded && hasSteps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $a6ff1dd45bf7b635$var$styles.unstyledPressable,
        onClick: (e)=>{
            if (e.target instanceof Element) {
                // Don't expand all when clicking an individual substep expand button
                if (e.target.closest('button')) return;
                 // Don't hijack clicks on actual links within the substep
                if (e.target.closest('a[href]')) return;
            }
            setIsExpanded(true);
            onPreviewExpandChanged?.(true);
            onTraceInteraction?.({
                type: (0, $fa16ecabae882ffa$export$5467f403379dc48c).ALL_TRACES,
                expanded: true
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $a6ff1dd45bf7b635$var$styles.researchStepList
    }, windowedSteps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3OE6xYdLIE _2IhTon8ija _0Bm75GNHnM _39xV024Jdh _0KLXru9r67 _42Yu6BdnbC"
        ])
    }), windowedSteps.map((step_0, index_0)=>{
        const isLastStep_0 = index_0 === windowedSteps.length - 1; // Use individual step completion status: completed → NodeIcon, loading → Spinner
        const isInProgress_0 = !step_0.completed;
        const lastSubstep = step_0.separatedContent.length > 0 ? step_0.separatedContent[step_0.separatedContent.length - 1] : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            key: step_0.stepId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "bottom",
            exitDirection: "top",
            duration: "medium"
        }, (fadeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", fadeProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddf14005673d18e5$export$2f0c0aff0f64227c), {
                step: step_0,
                isLastItem: isLastStep_0,
                isInProgress: isInProgress_0,
                hideIcon: false,
                disableShimmer: true,
                forceSubstepCollapsed: true,
                previewSubstep: lastSubstep,
                titleSize: "small",
                titleWeight: "medium",
                onUserExpandToggle: handleWindowedUserExpandToggle,
                renderSubstep: renderSubstep,
                onTraceInteraction: onTraceInteraction
            }))));
    })))));
};
function $a6ff1dd45bf7b635$var$_temp(s) {
    return !s.completed;
}
function $a6ff1dd45bf7b635$var$_temp2(s_0) {
    return s_0.completed;
}
function $a6ff1dd45bf7b635$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}


const $dea946298127f36c$export$46df6818b1a0eef6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6ff1dd45bf7b635$export$d867c592855137bf), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6ff1dd45bf7b635$export$d867c592855137bf), props);


const $fa16ecabae882ffa$export$5467f403379dc48c = {
    ALL_TRACES: 'allTracesExpandable',
    SINGLE_TRACE: 'singleTraceExpandable'
};
const $fa16ecabae882ffa$var$timelineConnectorLineStyle = null;
const $fa16ecabae882ffa$var$styles = {
    researchStepList: "_2Y7lL4Pgdg _0aNu0LYbGa _1mT5xdRAKS"
};
const $fa16ecabae882ffa$export$f25a0a30b714e7bf = ({ steps: steps = [], researchCompleted: researchCompleted = false, responseStreaming: responseStreaming = false, renderSubstep: renderSubstep, thinkDeeperTriggered: thinkDeeperTriggered = false, answerNowSlot: answerNowSlot, onTraceInteraction: onTraceInteraction, xpcWrapUrl: xpcWrapUrl })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const lastStep = steps.at(-1); // Expand request tokens keyed by step id. Each token is a
    // MutableRefObject<boolean> — `.current === true` means "expand needed".
    // When a child item consumes the token it sets `.current = false` (no
    // re-render). The map survives the preview → completed branch switch so
    // the completed-phase items can honour unmet requests on mount.
    // Consumed (spent) tokens remain in the map so the outer steps-summary
    // expandable stays open; the map is only cleared when the user explicitly
    // collapses the outer expandable.
    const [expandRequests, setExpandRequests] = (0, $cozmU.useState)({});
    const shouldShowStepsSummary = responseStreaming || researchCompleted && steps.length > 0; // Called by preview children when the user clicks expand/collapse.
    const handleUserExpandToggle = (0, $cozmU.useCallback)((stepId, expanded)=>{
        if (expanded) setExpandRequests((prev)=>({
                ...prev,
                [stepId]: {
                    current: true
                }
            }));
        else setExpandRequests((prev_0)=>{
            const { [stepId]: _, ...rest } = prev_0;
            return rest;
        });
    }, []); // Called when the preview's main expandable is opened or collapsed.
    // On expand: add a sentinel token so the outer steps-summary auto-opens
    // post-streaming (the sentinel won't match any real step.stepId).
    // On collapse: clear ALL accumulated requests — the user explicitly
    // closed the preview, so nothing should carry over to the completed phase.
    const handlePreviewExpandChanged = (0, $cozmU.useCallback)((expanded_0)=>{
        if (expanded_0) setExpandRequests((prev_1)=>({
                ...prev_1,
                __parent__: {
                    current: true
                }
            }));
        else setExpandRequests({});
    }, []); // When there are expand requests (met or unmet), the outer "steps summary"
    // expandable should auto-open so the persisted expansion is visible without
    // an extra user click.
    const stepsSummaryDefaultExpanded = Object.keys(expandRequests).length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, shouldShowStepsSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22faee5074b66dbd$export$5b346f7d85a51eb5), {
        defaultExpanded: stepsSummaryDefaultExpanded,
        showExpandIcon: true,
        showExpandAtEnd: false,
        onExpandClick: (expanded_1)=>{
            onTraceInteraction?.({
                type: $fa16ecabae882ffa$export$5467f403379dc48c.ALL_TRACES,
                expanded: expanded_1
            }); // When the user explicitly collapses the steps-summary expandable,
            // clear all expand requests so it won't auto-reopen.
            if (!expanded_1) setExpandRequests({});
        },
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "regular",
            color: "color.text.subtlest"
        }, steps.length === 1 ? formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).thinkingCompleted) : formatMessage((0, $0efef966bd6ba92a$export$2e2bcd8739ae039).stepsSummary, {
            total: steps.length
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $fa16ecabae882ffa$var$styles.researchStepList,
        testId: "research-step-list"
    }, steps.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3OE6xYdLIE _2IhTonNHnM _0Bm75GNHnM _39xV024Jdh _0KLXru9r67 _42Yu6BdnbC"
        ])
    }), steps.map((step, index)=>{
        const isLastStep = index === steps.length - 1;
        const isInProgress = step.completed === false || !researchCompleted; // Always show the step icon — never hide it even when there's only one step
        // and research is completed.
        const shouldHideIcon = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddf14005673d18e5$export$2f0c0aff0f64227c), {
            key: step.stepId,
            step: step,
            isLastItem: isLastStep,
            isInProgress: isInProgress,
            hideIcon: shouldHideIcon,
            renderSubstep: renderSubstep,
            disableShimmer: true,
            forceSubstepCollapsed: true,
            previewSubstep: step.toolName === 'execute_bash' ? undefined : step.separatedContent[0],
            titleSize: "small",
            titleWeight: "medium",
            expandRequest: expandRequests[step.stepId] ?? null,
            onTraceInteraction: onTraceInteraction,
            xpcWrapUrl: xpcWrapUrl
        });
    }))) : lastStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dea946298127f36c$export$46df6818b1a0eef6), {
        title: lastStep.title,
        separatedContent: lastStep.separatedContent,
        steps: steps,
        renderSubstep: renderSubstep,
        researchCompleted: researchCompleted,
        thinkDeeperTriggered: thinkDeeperTriggered,
        isLastStepStreamed: lastStep.isStreamed,
        answerNowSlot: answerNowSlot,
        onTraceInteraction: onTraceInteraction,
        onUserExpandToggle: handleUserExpandToggle,
        onPreviewExpandChanged: handlePreviewExpandChanged
    }) : null);
};




var $fdZYN = parcelRequire("fdZYN");








var $SJycm = parcelRequire("SJycm");





const $a5766a668c90fc8d$export$f0f65e90a009d079 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { messageId: messageId } = t0;
    const [state] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    return state?.hasThinkDeeperTriggered ?? false;
} : ({ messageId: messageId })=>{
    const [state] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    return state?.hasThinkDeeperTriggered ?? false;
};









const $fc6bad2d555b9bf7$export$b8d26e35d91305d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { messageId: messageId, roundId: roundId } = t0;
    const [state, actions] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    let t1;
    if ($[0] !== state?.steps) {
        t1 = Object.values(state?.steps ?? {});
        $[0] = state?.steps;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== roundId || $[3] !== t1) {
        t2 = t1.filter((step)=>step.roundId === roundId);
        $[2] = roundId;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const steps = t2;
    const isAllStepsCompleted = steps.every($fc6bad2d555b9bf7$var$_temp);
    const t3 = state?.researchCompleted;
    const t4 = state?.errored;
    let t5;
    if ($[5] !== actions || $[6] !== isAllStepsCompleted || $[7] !== state || $[8] !== steps || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            ...state,
            ...actions,
            artificiallyProgressingSteps: steps,
            isAllStepsCompleted: isAllStepsCompleted,
            researchCompleted: t3,
            errored: t4
        };
        $[5] = actions;
        $[6] = isAllStepsCompleted;
        $[7] = state;
        $[8] = steps;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ messageId: messageId, roundId: roundId })=>{
    const [state, actions] = (0, $0da647f75270b377$export$b5a7f8d4b73e48e1)(messageId);
    const steps = Object.values(state?.steps ?? {}).filter((step)=>step.roundId === roundId);
    const isAllStepsCompleted = steps.every((step_0)=>!!step_0.completed);
    return {
        ...state,
        ...actions,
        artificiallyProgressingSteps: steps,
        isAllStepsCompleted: isAllStepsCompleted,
        researchCompleted: state?.researchCompleted,
        errored: state?.errored
    };
};
function $fc6bad2d555b9bf7$var$_temp(step_0) {
    return !!step_0.completed;
}



























const $37f482631d9ec837$var$message = (0, $kSwu1.defineMessages)({
    answerNowButtonLabel: {
        id: "ai-mate.answer-now-button.label",
        defaultMessage: "Answer now"
    },
    answerNowButtonLoadingLabel: {
        id: "ai-mate.answer-now-button.loading-label",
        defaultMessage: "Switching to fast mode..."
    }
});
var $37f482631d9ec837$export$2e2bcd8739ae039 = $37f482631d9ec837$var$message;


const $a2cbc94901a6881d$export$ab765d22c78a61ad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { onClick: onClick, isLoading: t1, isDisabled: t2, testId: testId, spacing: spacing } = t0;
    const isLoading = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t3;
    if ($[0] !== isDisabled || $[1] !== isLoading || $[2] !== onClick || $[3] !== sendAnalyticsEvent) {
        t3 = ()=>{
            if (!isLoading && !isDisabled) {
                onClick();
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "answerNowButton",
                    attributes: {
                        is_loading: isLoading,
                        is_disabled: isDisabled
                    }
                });
            }
        };
        $[0] = isDisabled;
        $[1] = isLoading;
        $[2] = onClick;
        $[3] = sendAnalyticsEvent;
        $[4] = t3;
    } else t3 = $[4];
    const handleClick = t3;
    let t4;
    if ($[5] !== spacing) {
        t4 = spacing && {
            spacing: spacing
        };
        $[5] = spacing;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = testId ?? "answer-now-button";
    const t6 = isLoading ? (0, $37f482631d9ec837$export$2e2bcd8739ae039).answerNowButtonLoadingLabel : (0, $37f482631d9ec837$export$2e2bcd8739ae039).answerNowButtonLabel;
    let t7;
    if ($[7] !== formatMessage || $[8] !== t6) {
        t7 = formatMessage(t6);
        $[7] = formatMessage;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== handleClick || $[11] !== isDisabled || $[12] !== isLoading || $[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            ...t4,
            onClick: handleClick,
            isLoading: isLoading,
            isDisabled: isDisabled,
            testId: t5
        }, t7);
        $[10] = handleClick;
        $[11] = isDisabled;
        $[12] = isLoading;
        $[13] = t4;
        $[14] = t5;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
} : ({ onClick: onClick, isLoading: isLoading = false, isDisabled: isDisabled = false, testId: testId, spacing: spacing })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!isLoading && !isDisabled) {
            onClick();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'answerNowButton',
                attributes: {
                    is_loading: isLoading,
                    is_disabled: isDisabled
                }
            });
        }
    }, [
        onClick,
        isLoading,
        isDisabled,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        ...spacing && {
            spacing: spacing
        },
        onClick: handleClick,
        isLoading: isLoading,
        isDisabled: isDisabled,
        testId: testId ?? 'answer-now-button'
    }, formatMessage(isLoading ? (0, $37f482631d9ec837$export$2e2bcd8739ae039).answerNowButtonLoadingLabel : (0, $37f482631d9ec837$export$2e2bcd8739ae039).answerNowButtonLabel));
};
















const $1dd37d93a28f68b1$export$935f3d4204deb221 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewDeadAirZone(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { id: id, contentType: contentType, children: children } = t0;
    if (!(0, $iDrrr.fg)("rovo_chat_track_view_dead_air")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== contentType || $[3] !== id) {
        t1 = {
            [(0, $a6ab52421b090de9$export$865b50f6578fb126)]: id,
            [(0, $a6ab52421b090de9$export$ec286b319a16492b)]: contentType
        };
        $[2] = contentType;
        $[3] = id;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== children || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", t1, children);
        $[5] = children;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function ViewDeadAirZone({ id: id, contentType: contentType, children: children }) {
    if (!(0, $iDrrr.fg)('rovo_chat_track_view_dead_air')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        [(0, $a6ab52421b090de9$export$865b50f6578fb126)]: id,
        [(0, $a6ab52421b090de9$export$ec286b319a16492b)]: contentType
    }, children);
};





const $ebff89a7bfb56a72$var$message = (0, $kSwu1.defineMessages)({
    conversationLimit: {
        id: "ai-mate.chat-history.conversationLimit",
        defaultMessage: "Looking for an old chat? We clear out chat history after 30 days to keep our AI running smoothly."
    },
    infoIconLabel: {
        id: "ai-mate.chat-history.empty-state.message",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    },
    rovoIsThinking: {
        id: "ai-mate.chat-history.loading-state.agent-is-thinking",
        defaultMessage: "{name} is thinking"
    },
    agentIsGenerating: {
        id: "ai-mate.chat-history.loading-state.agent-is-generating",
        defaultMessage: "{name} is generating"
    },
    thinkDeeperThinking: {
        id: "ai-mate.chat-history.loading-state.think-deeper-thinking",
        defaultMessage: "Thinking deeply and analyzing"
    },
    responseComplete: {
        id: "ai-mate.chat-history.loading-state.response-complete",
        defaultMessage: "Response complete"
    }
});
var $ebff89a7bfb56a72$export$2e2bcd8739ae039 = $ebff89a7bfb56a72$var$message;




const $291236cc3beb1bd7$var$roundSeparatorStyles = {
    root: "_0rIjyk5zaO"
};
const $291236cc3beb1bd7$var$ThinkDeeperResearchRoundCompact = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { roundId: roundId, messageId: messageId, hasStreamedContent: hasStreamedContent, isLastRound: isLastRound, generatingText: generatingText, personalityThinkingText: personalityThinkingText, answerNowSlot: answerNowSlot, hideLiveThinkingIndicator: hideLiveThinkingIndicator } = t0;
    let t1;
    if ($[0] !== messageId || $[1] !== roundId) {
        t1 = {
            roundId: roundId,
            messageId: messageId
        };
        $[0] = messageId;
        $[1] = roundId;
        $[2] = t1;
    } else t1 = $[2];
    const { artificiallyProgressingSteps: artificiallyProgressingSteps, errored: errored, researchCompleted: researchCompleted, isAllStepsCompleted: isAllStepsCompleted } = (0, $fc6bad2d555b9bf7$export$b8d26e35d91305d)(t1);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { productKey: productKey, siteId: siteId, profileData: t2 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t2;
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const t3 = messageId ?? "";
    let t4;
    if ($[3] !== t3) {
        t4 = {
            messageId: t3
        };
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const hasThinkDeeperTriggered = (0, $a5766a668c90fc8d$export$f0f65e90a009d079)(t4);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const xpcWrapUrl = (0, $SJycm.useXpcLinkWrapper)();
    if (errored) return null;
    const allArtificialStepsCompleted = isAllStepsCompleted;
    const isCompleted = researchCompleted || allArtificialStepsCompleted && (hasStreamedContent || !isLastRound);
    let t5;
    if ($[5] !== aaid || $[6] !== conversation?.id || $[7] !== customHandlers?.handleDeepLinkClick || $[8] !== messageId || $[9] !== productKey || $[10] !== roundId || $[11] !== siteId) {
        t5 = (substep, isStreamed)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1dd37d93a28f68b1$export$935f3d4204deb221), {
                id: `substep-${messageId}-${roundId}`,
                contentType: isStreamed ? "stream" : "discrete"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                content: substep,
                smallerFont: true,
                subtlestText: true,
                productKey: productKey,
                siteId: siteId,
                aaid: aaid,
                conversationId: conversation?.id,
                onDeepLinkClick: customHandlers?.handleDeepLinkClick,
                shouldOverrideCardAsInline: true
            }));
        $[5] = aaid;
        $[6] = conversation?.id;
        $[7] = customHandlers?.handleDeepLinkClick;
        $[8] = messageId;
        $[9] = productKey;
        $[10] = roundId;
        $[11] = siteId;
        $[12] = t5;
    } else t5 = $[12];
    const renderSubstep = t5;
    if (artificiallyProgressingSteps.length === 0) {
        if (hasStreamedContent) return null;
        if (!isLastRound) return null;
        if (!allArtificialStepsCompleted && !hideLiveThinkingIndicator) {
            let t6;
            if ($[13] !== formatMessage || $[14] !== generatingText || $[15] !== hasThinkDeeperTriggered || $[16] !== personalityThinkingText) {
                t6 = generatingText ?? personalityThinkingText ?? (hasThinkDeeperTriggered ? formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).thinkDeeperThinking) : formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).rovoIsThinking));
                $[13] = formatMessage;
                $[14] = generatingText;
                $[15] = hasThinkDeeperTriggered;
                $[16] = personalityThinkingText;
                $[17] = t6;
            } else t6 = $[17];
            const thinkingText = t6;
            let t7;
            if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
                t7 = [];
                $[18] = t7;
            } else t7 = $[18];
            let t8;
            if ($[19] !== thinkingText) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbe369e2a348fc0c$export$1e7724c434f1ba76), {
                    traces: t7,
                    hideThinkingIndicator: false,
                    thinkingText: thinkingText,
                    animation: true
                });
                $[19] = thinkingText;
                $[20] = t8;
            } else t8 = $[20];
            return t8;
        }
        return null;
    }
    let t6;
    if ($[21] !== artificiallyProgressingSteps || $[22] !== siteId) {
        let t7;
        if ($[24] !== siteId) {
            t7 = (step)=>{
                if (step.isSkill) return {
                    ...step,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdZYN.ConnectedSkillTag), {
                        slug: step.title,
                        shimmer: !step.completed,
                        siteId: siteId ?? ""
                    })
                };
                return step;
            };
            $[24] = siteId;
            $[25] = t7;
        } else t7 = $[25];
        t6 = artificiallyProgressingSteps.map(t7);
        $[21] = artificiallyProgressingSteps;
        $[22] = siteId;
        $[23] = t6;
    } else t6 = $[23];
    const artificiallyProgressingStepsWithSkills = t6;
    const t7 = `research-steps-${messageId}-${roundId}`;
    let t8;
    if ($[26] !== messageId || $[27] !== roundId || $[28] !== sendAnalyticsEvent) {
        t8 = (t9)=>{
            const { type: type, expanded: expanded } = t9;
            sendAnalyticsEvent({
                eventType: "ui",
                action: expanded ? "expanded" : "collapsed",
                actionSubject: "trace",
                actionSubjectId: type,
                attributes: {
                    messageId: messageId,
                    roundId: roundId
                }
            });
        };
        $[26] = messageId;
        $[27] = roundId;
        $[28] = sendAnalyticsEvent;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== answerNowSlot || $[31] !== artificiallyProgressingStepsWithSkills || $[32] !== hasStreamedContent || $[33] !== hasThinkDeeperTriggered || $[34] !== isCompleted || $[35] !== renderSubstep || $[36] !== t8 || $[37] !== xpcWrapUrl) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa16ecabae882ffa$export$f25a0a30b714e7bf), {
            steps: artificiallyProgressingStepsWithSkills,
            researchCompleted: isCompleted,
            responseStreaming: hasStreamedContent,
            renderSubstep: renderSubstep,
            thinkDeeperTriggered: hasThinkDeeperTriggered,
            answerNowSlot: answerNowSlot,
            xpcWrapUrl: xpcWrapUrl,
            onTraceInteraction: t8
        });
        $[30] = answerNowSlot;
        $[31] = artificiallyProgressingStepsWithSkills;
        $[32] = hasStreamedContent;
        $[33] = hasThinkDeeperTriggered;
        $[34] = isCompleted;
        $[35] = renderSubstep;
        $[36] = t8;
        $[37] = xpcWrapUrl;
        $[38] = t9;
    } else t9 = $[38];
    let t10;
    if ($[39] !== t7 || $[40] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf730b8cd03304d8$export$afe1efab2fc7cff2), {
            id: t7,
            contentType: "discrete"
        }, t9);
        $[39] = t7;
        $[40] = t9;
        $[41] = t10;
    } else t10 = $[41];
    return t10;
} : ({ roundId: roundId, messageId: messageId, hasStreamedContent: hasStreamedContent, isLastRound: isLastRound, generatingText: generatingText, personalityThinkingText: personalityThinkingText, answerNowSlot: answerNowSlot, hideLiveThinkingIndicator: hideLiveThinkingIndicator })=>{
    const { artificiallyProgressingSteps: artificiallyProgressingSteps, errored: errored, researchCompleted: researchCompleted, isAllStepsCompleted: isAllStepsCompleted } = (0, $fc6bad2d555b9bf7$export$b8d26e35d91305d)({
        roundId: roundId,
        messageId: messageId
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { productKey: productKey, siteId: siteId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const hasThinkDeeperTriggered = (0, $a5766a668c90fc8d$export$f0f65e90a009d079)({
        messageId: messageId ?? ''
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const xpcWrapUrl = (0, $SJycm.useXpcLinkWrapper)();
    if (errored) return null;
     // Use isAllStepsCompleted from the hook — it returns true when steps is empty (length === 0),
    // preventing a flash where the thinking indicator re-appears during a momentary empty steps state
    // (e.g. between updateResearchMessageId and the new store entry being populated).
    const allArtificialStepsCompleted = isAllStepsCompleted;
    const isCompleted = researchCompleted || allArtificialStepsCompleted && (hasStreamedContent || !isLastRound);
    const renderSubstep = (substep, isStreamed)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1dd37d93a28f68b1$export$935f3d4204deb221), {
            id: `substep-${messageId}-${roundId}`,
            contentType: isStreamed ? 'stream' : 'discrete'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: substep,
            smallerFont: true,
            subtlestText: true,
            productKey: productKey,
            siteId: siteId,
            aaid: aaid,
            conversationId: conversation?.id,
            onDeepLinkClick: customHandlers?.handleDeepLinkClick,
            shouldOverrideCardAsInline: true
        }));
    };
    if (artificiallyProgressingSteps.length === 0) {
        // If the answer has already started streaming in, there are no traces to show
        // and we should not render the thinking indicator at all — this handles the case
        // where ANSWER_PART arrives before any RESEARCH_STEP_TITLE/trace.
        if (hasStreamedContent) return null;
         // If this is not the last round, a later round already has steps. This empty round
        // is just an implicit plan header — do not render a thinking indicator for it,
        // as that would duplicate the global indicator from renderTracesAndErrors.
        if (!isLastRound) return null;
         // hideLiveThinkingIndicator is set when the answer has started streaming (hasReceivedAnswerPart)
        // or when streamingComplete is true. Guard here to avoid a flash where steps have emptied
        // but hasStreamedContent hasn't updated yet.
        if (!allArtificialStepsCompleted && !hideLiveThinkingIndicator) {
            // Use the hook value instead of manually iterating traces
            const thinkingText = generatingText ?? personalityThinkingText ?? (hasThinkDeeperTriggered ? formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).thinkDeeperThinking) : formatMessage((0, $143786e7cbd99263$export$2e2bcd8739ae039).rovoIsThinking));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbe369e2a348fc0c$export$1e7724c434f1ba76), {
                traces: [],
                hideThinkingIndicator: false,
                thinkingText: thinkingText,
                animation: true
            });
        }
        return null;
    }
    const artificiallyProgressingStepsWithSkills = artificiallyProgressingSteps.map((step)=>{
        if (step.isSkill) return {
            ...step,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdZYN.ConnectedSkillTag), {
                slug: step.title,
                shimmer: !step.completed,
                siteId: siteId ?? ''
            })
        };
        return step;
    }); // Use the hook value instead of manually iterating traces
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf730b8cd03304d8$export$afe1efab2fc7cff2), {
        id: `research-steps-${messageId}-${roundId}`,
        contentType: "discrete"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa16ecabae882ffa$export$f25a0a30b714e7bf), {
        steps: artificiallyProgressingStepsWithSkills,
        researchCompleted: isCompleted,
        responseStreaming: hasStreamedContent,
        renderSubstep: renderSubstep,
        thinkDeeperTriggered: hasThinkDeeperTriggered,
        answerNowSlot: answerNowSlot,
        xpcWrapUrl: xpcWrapUrl,
        onTraceInteraction: ({ type: type, expanded: expanded })=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: expanded ? 'expanded' : 'collapsed',
                actionSubject: 'trace',
                actionSubjectId: type,
                attributes: {
                    messageId: messageId,
                    roundId: roundId
                }
            });
        }
    }));
};
const $291236cc3beb1bd7$var$ThinkDeeperResearchRound = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { roundId: roundId, messageId: messageId, hasStreamedContent: hasStreamedContent, isLastRound: isLastRound, generatingText: generatingText, personalityThinkingText: personalityThinkingText, answerNowStatus: answerNowStatus, onAnswerNowClick: onAnswerNowClick, hideLiveThinkingIndicator: hideLiveThinkingIndicator } = t0;
    const showAnswerNow = isLastRound && onAnswerNowClick && (answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).AVAILABLE || answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING);
    let t1;
    if ($[0] !== answerNowStatus?.type || $[1] !== onAnswerNowClick || $[2] !== showAnswerNow) {
        t1 = showAnswerNow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2cbc94901a6881d$export$ab765d22c78a61ad), {
            onClick: onAnswerNowClick,
            isLoading: answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING,
            isDisabled: answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING,
            testId: "think-deeper-answer-now-button",
            spacing: "compact"
        }) : undefined;
        $[0] = answerNowStatus?.type;
        $[1] = onAnswerNowClick;
        $[2] = showAnswerNow;
        $[3] = t1;
    } else t1 = $[3];
    const answerNowButton = t1;
    let t2;
    if ($[4] !== answerNowButton || $[5] !== generatingText || $[6] !== hasStreamedContent || $[7] !== hideLiveThinkingIndicator || $[8] !== isLastRound || $[9] !== messageId || $[10] !== personalityThinkingText || $[11] !== roundId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($291236cc3beb1bd7$var$ThinkDeeperResearchRoundCompact, {
            roundId: roundId,
            messageId: messageId,
            hasStreamedContent: hasStreamedContent,
            isLastRound: isLastRound,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            answerNowSlot: answerNowButton,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator
        });
        $[4] = answerNowButton;
        $[5] = generatingText;
        $[6] = hasStreamedContent;
        $[7] = hideLiveThinkingIndicator;
        $[8] = isLastRound;
        $[9] = messageId;
        $[10] = personalityThinkingText;
        $[11] = roundId;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ roundId: roundId, messageId: messageId, hasStreamedContent: hasStreamedContent, isLastRound: isLastRound, generatingText: generatingText, personalityThinkingText: personalityThinkingText, answerNowStatus: answerNowStatus, onAnswerNowClick: onAnswerNowClick, hideLiveThinkingIndicator: hideLiveThinkingIndicator })=>{
    const showAnswerNow = isLastRound && onAnswerNowClick && (answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).AVAILABLE || answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING);
    const answerNowButton = showAnswerNow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2cbc94901a6881d$export$ab765d22c78a61ad), {
        onClick: onAnswerNowClick,
        isLoading: answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING,
        isDisabled: answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING,
        testId: "think-deeper-answer-now-button",
        spacing: "compact"
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($291236cc3beb1bd7$var$ThinkDeeperResearchRoundCompact, {
        roundId: roundId,
        messageId: messageId,
        hasStreamedContent: hasStreamedContent,
        isLastRound: isLastRound,
        generatingText: generatingText,
        personalityThinkingText: personalityThinkingText,
        answerNowSlot: answerNowButton,
        hideLiveThinkingIndicator: hideLiveThinkingIndicator
    });
};
const $291236cc3beb1bd7$export$e72705189d92c3b5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { messageId: messageId, streamedContent: streamedContent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, answerNowStatus: answerNowStatus, onAnswerNowClick: onAnswerNowClick, hideLiveThinkingIndicator: hideLiveThinkingIndicator } = t0;
    let t1;
    if ($[0] !== messageId) {
        t1 = {
            messageId: messageId
        };
        $[0] = messageId;
        $[1] = t1;
    } else t1 = $[1];
    const { rounds: rounds, maxRoundId: maxRoundId } = (0, $2556adf63acd29a5$export$8ffe29bbe1f25b54)(t1);
    const { productKey: productKey, siteId: siteId, profileData: t2 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t2;
    if (rounds.length === 0) return;
    let t3;
    if ($[2] !== aaid || $[3] !== answerNowStatus || $[4] !== generatingText || $[5] !== hideLiveThinkingIndicator || $[6] !== maxRoundId || $[7] !== messageId || $[8] !== onAnswerNowClick || $[9] !== personalityThinkingText || $[10] !== productKey || $[11] !== rounds || $[12] !== siteId || $[13] !== streamedContent) {
        let t4;
        if ($[15] !== aaid || $[16] !== answerNowStatus || $[17] !== generatingText || $[18] !== hideLiveThinkingIndicator || $[19] !== maxRoundId || $[20] !== messageId || $[21] !== onAnswerNowClick || $[22] !== personalityThinkingText || $[23] !== productKey || $[24] !== rounds.length || $[25] !== siteId || $[26] !== streamedContent) {
            t4 = (t5)=>{
                const { roundId: roundId, content: content } = t5;
                const isResearchPlanContentEqualToStreamedContent = content === streamedContent;
                const isLastRound = roundId === maxRoundId;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: `think-deeper-research-round-${roundId}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($291236cc3beb1bd7$var$ThinkDeeperResearchRound, {
                    roundId: roundId,
                    messageId: messageId,
                    isLastRound: roundId === maxRoundId,
                    hasStreamedContent: !!streamedContent,
                    generatingText: generatingText,
                    personalityThinkingText: personalityThinkingText,
                    answerNowStatus: answerNowStatus,
                    onAnswerNowClick: onAnswerNowClick,
                    hideLiveThinkingIndicator: hideLiveThinkingIndicator
                }), content && !isResearchPlanContentEqualToStreamedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $501c3704274e8ca7$export$b7b8c16424783afd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf730b8cd03304d8$export$afe1efab2fc7cff2), {
                    id: `content-${messageId}-${roundId}`,
                    contentType: "stream"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                    content: content,
                    smallerFont: true,
                    productKey: productKey,
                    siteId: siteId,
                    aaid: aaid,
                    shouldOverrideCardAsInline: true
                }))), !isLastRound && rounds.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $291236cc3beb1bd7$var$roundSeparatorStyles.root
                }));
            };
            $[15] = aaid;
            $[16] = answerNowStatus;
            $[17] = generatingText;
            $[18] = hideLiveThinkingIndicator;
            $[19] = maxRoundId;
            $[20] = messageId;
            $[21] = onAnswerNowClick;
            $[22] = personalityThinkingText;
            $[23] = productKey;
            $[24] = rounds.length;
            $[25] = siteId;
            $[26] = streamedContent;
            $[27] = t4;
        } else t4 = $[27];
        t3 = rounds.map(t4);
        $[2] = aaid;
        $[3] = answerNowStatus;
        $[4] = generatingText;
        $[5] = hideLiveThinkingIndicator;
        $[6] = maxRoundId;
        $[7] = messageId;
        $[8] = onAnswerNowClick;
        $[9] = personalityThinkingText;
        $[10] = productKey;
        $[11] = rounds;
        $[12] = siteId;
        $[13] = streamedContent;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : ({ messageId: messageId, streamedContent: streamedContent, generatingText: generatingText, personalityThinkingText: personalityThinkingText, answerNowStatus: answerNowStatus, onAnswerNowClick: onAnswerNowClick, hideLiveThinkingIndicator: hideLiveThinkingIndicator })=>{
    const { rounds: rounds, maxRoundId: maxRoundId } = (0, $2556adf63acd29a5$export$8ffe29bbe1f25b54)({
        messageId: messageId
    });
    const { productKey: productKey, siteId: siteId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    if (rounds.length === 0) return undefined;
    return rounds.map(({ roundId: roundId, content: content })=>{
        // Prevents duplicate research plans in chat history during concurrent store updates
        // Chat history uses ResearchStore and MessagesStore which update asynchronously
        // During RESEARCH_PLAN flow:
        // 1. New plan created in ResearchStore
        // 2. Streamed content cleared from MessagesStore
        // 3. Plan rendered as regular message for proper ordering
        // React 18 concurrency can cause ResearchMessage to render before stream clears
        // This check prevents showing duplicate plans by comparing content equality
        // Misc other hackes were attempted, without using a single store: flushSync, component re-structuring
        const isResearchPlanContentEqualToStreamedContent = content === streamedContent;
        const isLastRound = roundId === maxRoundId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `think-deeper-research-round-${roundId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($291236cc3beb1bd7$var$ThinkDeeperResearchRound, {
            roundId: roundId,
            messageId: messageId,
            isLastRound: roundId === maxRoundId,
            hasStreamedContent: !!streamedContent,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            answerNowStatus: answerNowStatus,
            onAnswerNowClick: onAnswerNowClick,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator
        }), content && !isResearchPlanContentEqualToStreamedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $501c3704274e8ca7$export$b7b8c16424783afd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf730b8cd03304d8$export$afe1efab2fc7cff2), {
            id: `content-${messageId}-${roundId}`,
            contentType: "stream"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: content,
            smallerFont: true,
            productKey: productKey,
            siteId: siteId,
            aaid: aaid,
            shouldOverrideCardAsInline: true
        }))), !isLastRound && rounds.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $291236cc3beb1bd7$var$roundSeparatorStyles.root
        }));
    });
};




















const $91e4408a300abe15$var$styles = {
    container: "_0jFU0VN91d _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _37wbyuz9WS",
    greetingsContainer: "_39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _3138425zaO _1DCdHi5zaO",
    actionsContainer: "_2mHwu82ADO _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _2Zuz6QNHnM _1ZnuxbNHnM"
};
const $91e4408a300abe15$export$88793db575c316c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { testId: testId, showActions: t0, showGreeting: t1, actionSize: t2 } = props;
    const showActions = t0 === undefined ? true : t0;
    const showGreeting = t1 === undefined ? true : t1;
    const actionSize = t2 === undefined ? 3 : t2;
    let t3;
    if ($[0] !== showGreeting) {
        t3 = showGreeting && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $91e4408a300abe15$var$styles.greetingsContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            isShimmering: true,
            width: "306px",
            height: "120px"
        }));
        $[0] = showGreeting;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== actionSize || $[3] !== showActions) {
        t4 = showActions && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $91e4408a300abe15$var$styles.actionsContainer
        }, Array.from({
            length: actionSize
        }).map($91e4408a300abe15$var$_temp));
        $[2] = actionSize;
        $[3] = showActions;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3 || $[6] !== t4 || $[7] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: testId,
            alignBlock: "center",
            alignInline: "center",
            xcss: $91e4408a300abe15$var$styles.container
        }, t3, t4);
        $[5] = t3;
        $[6] = t4;
        $[7] = testId;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : (props)=>{
    const { testId: testId, showActions: showActions = true, showGreeting: showGreeting = true, actionSize: actionSize = 3 } = props;
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: testId,
        alignBlock: "center",
        alignInline: "center",
        xcss: $91e4408a300abe15$var$styles.container
    }, showGreeting && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $91e4408a300abe15$var$styles.greetingsContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: "306px",
        height: "120px"
    })), showActions && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $91e4408a300abe15$var$styles.actionsContainer
    }, Array.from({
        length: actionSize
    }).map((_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            key: index,
            isShimmering: true,
            width: "100%",
            height: "32px"
        }))));
};
function $91e4408a300abe15$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        key: index,
        isShimmering: true,
        width: "100%",
        height: "32px"
    });
}











































const $ad2d9dec612e9b7a$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $ad2d9dec612e9b7a$export$3f91b0466c5e5f77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { message: message, isSuccessMessage: t1, showIcon: t2 } = t0;
    const isSuccessMessage = t1 === undefined ? true : t1;
    const showIcon = t2 === undefined ? true : t2;
    let t3;
    if ($[0] !== isSuccessMessage || $[1] !== showIcon) {
        t3 = showIcon && (isSuccessMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[0] = isSuccessMessage;
        $[1] = showIcon;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== message) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, message);
        $[3] = message;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $ad2d9dec612e9b7a$var$styles.explainerContainer,
            alignItems: "center",
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $ad2d9dec612e9b7a$var$styles.explainer,
            alignBlock: "center",
            alignInline: "center"
        }, t3, t4));
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ message: message, isSuccessMessage: isSuccessMessage = true, showIcon: showIcon = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $ad2d9dec612e9b7a$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $ad2d9dec612e9b7a$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, showIcon && (isSuccessMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, message)));
};





const $0dc4fb9b05ea9628$var$messages = (0, $kSwu1.defineMessages)({
    sharedChatContinuationPill: {
        id: "conversation-assistant.chat-history.shared-chat-continuation-pill.SharedChatContinuationPill.messages.sharedChatContinuationPill",
        defaultMessage: "You continued in a new chat"
    }
});
var $0dc4fb9b05ea9628$export$2e2bcd8739ae039 = $0dc4fb9b05ea9628$var$messages;


const $4baca647668a1bde$var$isSharedSnapshotAssistantMessage = (message)=>(0, $igOtY.isStoreAssistant)(message) && Boolean(message.content.message.message.message_metadata?.sharedFromMessageId);
const $4baca647668a1bde$var$getSharedChatContinuationPillTarget = (conversationMessages)=>{
    for(let i = conversationMessages.length - 1; i >= 0; i--){
        const message = conversationMessages[i];
        if (message && $4baca647668a1bde$var$isSharedSnapshotAssistantMessage(message)) return message;
    }
    return undefined;
};
const $4baca647668a1bde$var$SharedChatContinuationPillComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $0dc4fb9b05ea9628$export$2e2bcd8739ae039).sharedChatContinuationPill);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "shared-chat-continuation-pill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad2d9dec612e9b7a$export$3f91b0466c5e5f77), {
            message: t0,
            showIcon: false
        }));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "shared-chat-continuation-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad2d9dec612e9b7a$export$3f91b0466c5e5f77), {
        message: formatMessage((0, $0dc4fb9b05ea9628$export$2e2bcd8739ae039).sharedChatContinuationPill),
        showIcon: false
    }));
};
const $4baca647668a1bde$export$5b5fcd2c25501720 = Object.assign($4baca647668a1bde$var$SharedChatContinuationPillComponent, {
    getTarget: $4baca647668a1bde$var$getSharedChatContinuationPillTarget
});


/**
 * Determines whether the live thinking indicator should be hidden for an assistant message.
 *
 * Returns true when:
 * - Virtualization is active and the message is not actively
 *   generating (prevents a flash of the indicator when reopening a completed conversation), OR
 * - The message's streaming is already complete (prevents the indicator from briefly re-appearing
 *   between when traces are cleared on FINAL_RESPONSE and when the store status transitions to idle), OR
 * - The message has already received an answer part (traces are done, answer is streaming in —
 *   prevents the thinking indicator from reappearing during the answer streaming phase).
 */ const $575cafe00d20f089$export$3b3611d6ffec2b15 = ({ isVirtualizationEnabled: isVirtualizationEnabled, isAssistantActivelyGenerating: isAssistantActivelyGenerating, streamingComplete: streamingComplete, hasReceivedAnswerPart: hasReceivedAnswerPart })=>(isVirtualizationEnabled ? !isAssistantActivelyGenerating : false) || streamingComplete === true || hasReceivedAnswerPart === true;






















































/**
 * @generated SignedSource<<c821c6fe8f7cc0946a93449d83b26ed5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<8717c2cc029c3ba89c7c421f114ba27c>>
 * @relayHash b7c110fee25ad08a800acb8d1785010d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ed34092e73d412113398461f3063acc590ca71d26453733d46198e528d3d8e1
const $5c9db3a1a044e5af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchKeyword"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "searchKeyword",
            "variableName": "searchKeyword"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "browseSkillsUnifiedPaginationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "browseSkillsUnifiedPaginationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConvoAiAvailableSkillsResult",
                    "kind": "LinkedField",
                    "name": "convoai_availableSkills",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConvoAiSkillEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConvoAiSkill",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "slashCommand"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "iconKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "color"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "helpText"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "source"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "tags"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integrationKeys"
                                        },
                                        {
                                            "concreteType": "ConvoAiSkillIntegration",
                                            "kind": "LinkedField",
                                            "name": "integrations",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "version"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "ConvoAiSkillListMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "anthropicCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stratusCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDegraded"
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "searchKeyword"
                    ],
                    "handle": "connection",
                    "key": "browseSkills__convoai_availableSkills",
                    "kind": "LinkedHandle",
                    "name": "convoai_availableSkills"
                }
            ]
        },
        "params": {
            "id": "0ed34092e73d412113398461f3063acc590ca71d26453733d46198e528d3d8e1",
            "metadata": {},
            "name": "browseSkillsUnifiedPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5c9db3a1a044e5af$var$node.hash = "6c35cc4125ef7d7282e5c0de48a97f2e";
var $5c9db3a1a044e5af$export$2e2bcd8739ae039 = $5c9db3a1a044e5af$var$node;


const $6c088e18824f2166$var$node = function() {
    var v0 = [
        "convoai_availableSkills"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": 30,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchKeyword"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $5c9db3a1a044e5af$export$2e2bcd8739ae039)
            }
        },
        "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef",
        "selections": [
            {
                "alias": "convoai_availableSkills",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchKeyword",
                        "variableName": "searchKeyword"
                    }
                ],
                "concreteType": "ConvoAiAvailableSkillsResult",
                "kind": "LinkedField",
                "name": "__browseSkills__convoai_availableSkills_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConvoAiSkillEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConvoAiSkill",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "slashCommand"
                                    },
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconKey"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "color"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "helpText"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "source"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "tags"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "category"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "integrationKeys"
                                    },
                                    {
                                        "concreteType": "ConvoAiSkillIntegration",
                                        "kind": "LinkedField",
                                        "name": "integrations",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "version"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "ConvoAiSkillListMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "anthropicCount"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "stratusCount"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isDegraded"
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$6c088e18824f2166$var$node.hash = "6c35cc4125ef7d7282e5c0de48a97f2e";
var $6c088e18824f2166$export$2e2bcd8739ae039 = $6c088e18824f2166$var$node;


/**
 * @generated SignedSource<<3c33b0ae4e34ef56e1075f259e246d90>>
 * @relayHash 09c0cc6c07ae78116fbd3cbd8c880c1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5aec69753597050a3de61a3a8ecaf0250bb3d1004b26d23f19dcbcd7463ac331
const $c651f99bad72176e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchKeyword"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "searchKeyword",
            "variableName": "searchKeyword"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "browseSkills_UnifiedQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "browseSkills_UnifiedQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConvoAiAvailableSkillsResult",
                    "kind": "LinkedField",
                    "name": "convoai_availableSkills",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConvoAiSkillEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConvoAiSkill",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "slashCommand"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "iconKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "color"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "helpText"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "source"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "tags"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integrationKeys"
                                        },
                                        {
                                            "concreteType": "ConvoAiSkillIntegration",
                                            "kind": "LinkedField",
                                            "name": "integrations",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "version"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "ConvoAiSkillListMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "anthropicCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stratusCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDegraded"
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "searchKeyword"
                    ],
                    "handle": "connection",
                    "key": "browseSkills__convoai_availableSkills",
                    "kind": "LinkedHandle",
                    "name": "convoai_availableSkills"
                }
            ]
        },
        "params": {
            "id": "5aec69753597050a3de61a3a8ecaf0250bb3d1004b26d23f19dcbcd7463ac331",
            "metadata": {},
            "name": "browseSkills_UnifiedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c651f99bad72176e$var$node.hash = "d8d784ea495ad17459bfaf5cf2b08903";
var $c651f99bad72176e$export$2e2bcd8739ae039 = $c651f99bad72176e$var$node;


/**
 * @generated SignedSource<<daad714e8efef50164988ca207c26ace>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<973dd3b5e1a8c14646a2f7c2a35327e2>>
 * @relayHash c961593b2653a761fa4992768548dfb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed6b8d346223035e604e40e82532e8e8d1e64c303096108d9ab092b6944568cd
const $5ba1071e20219d5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "dimensionIds"
        },
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": [
                "SKILL"
            ],
            "kind": "LocalArgument",
            "name": "relevantFor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchKeyword"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "surface"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "dimensionIds",
            "variableName": "dimensionIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "relevantFor",
            "variableName": "relevantFor"
        },
        {
            "kind": "Variable",
            "name": "searchKeyword",
            "variableName": "searchKeyword"
        },
        {
            "kind": "Variable",
            "name": "surface",
            "variableName": "surface"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v5 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "browseSkillsPaginationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "browseSkillsPaginationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphIntegrationDirectoryItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "slashCommand"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                    "kind": "LinkedField",
                                                    "name": "integrationKey",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "color"
                                                }
                                            ],
                                            "type": "GraphIntegrationSkillDirectoryItem"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v5 /*: any*/ ,
                                            "type": "GraphIntegrationActionDirectoryItem"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v5 /*: any*/ ,
                                            "type": "GraphIntegrationMcpServer"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v5 /*: any*/ ,
                                            "type": "GraphIntegrationMcpTool"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v5 /*: any*/ ,
                                            "type": "GraphIntegrationSkillItem"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "error",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "filters": [
                        "dimensionIds",
                        "searchKeyword",
                        "relevantFor",
                        "cloudId",
                        "surface"
                    ],
                    "handle": "connection",
                    "key": "browseSkills_graphIntegration_componentDirectoryItems",
                    "kind": "LinkedHandle",
                    "name": "graphIntegration_componentDirectoryItems"
                }
            ]
        },
        "params": {
            "id": "ed6b8d346223035e604e40e82532e8e8d1e64c303096108d9ab092b6944568cd",
            "metadata": {},
            "name": "browseSkillsPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5ba1071e20219d5f$var$node.hash = "f1550383dab3fd9239986448282e14e9";
var $5ba1071e20219d5f$export$2e2bcd8739ae039 = $5ba1071e20219d5f$var$node;


const $9c7e1514a5eb5c4b$var$node = function() {
    var v0 = [
        "graphIntegration_componentDirectoryItems"
    ], v1 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "dimensionIds"
            },
            {
                "defaultValue": 30,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": [
                    "SKILL"
                ],
                "kind": "LocalArgument",
                "name": "relevantFor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchKeyword"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "surface"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $5ba1071e20219d5f$export$2e2bcd8739ae039)
            }
        },
        "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef",
        "selections": [
            {
                "alias": "graphIntegration_componentDirectoryItems",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Variable",
                        "name": "dimensionIds",
                        "variableName": "dimensionIds"
                    },
                    {
                        "kind": "Variable",
                        "name": "relevantFor",
                        "variableName": "relevantFor"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchKeyword",
                        "variableName": "searchKeyword"
                    },
                    {
                        "kind": "Variable",
                        "name": "surface",
                        "variableName": "surface"
                    }
                ],
                "concreteType": "GraphIntegrationDirectoryItemConnection",
                "kind": "LinkedField",
                "name": "__browseSkills_graphIntegration_componentDirectoryItems_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphIntegrationDirectoryItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "slashCommand"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            v1 /*: any*/ ,
                                            {
                                                "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                "kind": "LinkedField",
                                                "name": "integrationKey",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "displayName"
                                                    },
                                                    v1 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "color"
                                            }
                                        ],
                                        "type": "GraphIntegrationSkillDirectoryItem"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "extensions",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "statusCode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "errorType"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$9c7e1514a5eb5c4b$var$node.hash = "f1550383dab3fd9239986448282e14e9";
var $9c7e1514a5eb5c4b$export$2e2bcd8739ae039 = $9c7e1514a5eb5c4b$var$node;


/**
 * @generated SignedSource<<8ccdcfb6b4e550249986143c9520bc8e>>
 * @relayHash ec572469dc7cb396c2c3ddb94f82a68e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf5d569536e3a040af0c422a9b3c4e844ecc1d9c3da79e3cd26f685259e5a950
const $8172ba940868b6e1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dimensionIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": [
            "SKILL"
        ],
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchKeyword"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "dimensionIds",
            "variableName": "dimensionIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "relevantFor",
            "variableName": "relevantFor"
        },
        {
            "kind": "Variable",
            "name": "searchKeyword",
            "variableName": "searchKeyword"
        },
        {
            "kind": "Variable",
            "name": "surface",
            "variableName": "surface"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v11 = [
        v9 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "browseSkills_Query",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "browseSkills_Query",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphIntegrationDirectoryItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "slashCommand"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                    "kind": "LinkedField",
                                                    "name": "integrationKey",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "color"
                                                }
                                            ],
                                            "type": "GraphIntegrationSkillDirectoryItem"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "GraphIntegrationActionDirectoryItem"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "GraphIntegrationMcpServer"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "GraphIntegrationMcpTool"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "GraphIntegrationSkillItem"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "error",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "filters": [
                        "dimensionIds",
                        "searchKeyword",
                        "relevantFor",
                        "cloudId",
                        "surface"
                    ],
                    "handle": "connection",
                    "key": "browseSkills_graphIntegration_componentDirectoryItems",
                    "kind": "LinkedHandle",
                    "name": "graphIntegration_componentDirectoryItems"
                }
            ]
        },
        "params": {
            "id": "bf5d569536e3a040af0c422a9b3c4e844ecc1d9c3da79e3cd26f685259e5a950",
            "metadata": {},
            "name": "browseSkills_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8172ba940868b6e1$var$node.hash = "9bb9c55d0593497c8865eb24fcc4a2eb";
var $8172ba940868b6e1$export$2e2bcd8739ae039 = $8172ba940868b6e1$var$node;






























const $837e2bdf2015312e$export$a973cef5093a8d22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { onScrollTo: onScrollTo, rootMargin: t1, threshold: t2 } = t0;
    const rootMargin = t1 === undefined ? "0px 0px 100px 0px" : t1;
    const threshold = t2 === undefined ? 0 : t2;
    const observerRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[0] !== onScrollTo || $[1] !== rootMargin || $[2] !== threshold) {
        t3 = (element)=>{
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
            if (!element) return;
            observerRef.current = new IntersectionObserver((entries)=>{
                const [entry] = entries;
                if (entry.isIntersecting) onScrollTo();
            }, {
                rootMargin: rootMargin,
                threshold: threshold
            });
            observerRef.current.observe(element);
        };
        $[0] = onScrollTo;
        $[1] = rootMargin;
        $[2] = threshold;
        $[3] = t3;
    } else t3 = $[3];
    const refCallback = t3;
    return refCallback;
} : ({ onScrollTo: onScrollTo, rootMargin: rootMargin = '0px 0px 100px 0px', threshold: // Trigger 100px before element comes into view
threshold = 0 })=>{
    const observerRef = (0, $cozmU.useRef)(null);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        // Cleanup previous observer
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (!element) return;
        // Create new observer
        observerRef.current = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (entry.isIntersecting) onScrollTo();
        }, {
            rootMargin: rootMargin,
            threshold: threshold
        });
        observerRef.current.observe(element);
    }, [
        onScrollTo,
        rootMargin,
        threshold
    ]);
    return refCallback;
};








const $6e0e4654cba47971$var$PAGE_SIZE = 30;
const $6e0e4654cba47971$var$BrowseSkillsView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { skills: skills, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext, closeInlineBrowse: closeInlineBrowse, onSelectSkill: onSelectSkill, onSkillHover: onSkillHover } = t0;
    let t1;
    if ($[0] !== skills) {
        t1 = new Map(skills.map($6e0e4654cba47971$var$_temp));
        $[0] = skills;
        $[1] = t1;
    } else t1 = $[1];
    const skillSlug = t1;
    let t2;
    if ($[2] !== skills) {
        t2 = skills.map($6e0e4654cba47971$var$_temp2);
        $[2] = skills;
        $[3] = t2;
    } else t2 = $[3];
    const browseItems = t2;
    let t3;
    if ($[4] !== skillSlug) {
        t3 = (browseItem)=>{
            const skill_0 = skillSlug.get(browseItem.id);
            if (!skill_0) return null;
            const { slug: _slug, ...skillContentProps } = skill_0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80Hjq.SkillHoverCardContent), skillContentProps);
        };
        $[4] = skillSlug;
        $[5] = t3;
    } else t3 = $[5];
    const renderSkillHoverCardContent = t3;
    let t4;
    if ($[6] !== hasNext || $[7] !== isLoadingNext || $[8] !== loadNext) {
        t4 = ()=>{
            if (isLoadingNext || !hasNext) return;
            loadNext($6e0e4654cba47971$var$PAGE_SIZE);
        };
        $[6] = hasNext;
        $[7] = isLoadingNext;
        $[8] = loadNext;
        $[9] = t4;
    } else t4 = $[9];
    const handleLoadMore = t4;
    let t5;
    if ($[10] !== handleLoadMore) {
        t5 = {
            onScrollTo: handleLoadMore
        };
        $[10] = handleLoadMore;
        $[11] = t5;
    } else t5 = $[11];
    const listEndRef = (0, $837e2bdf2015312e$export$a973cef5093a8d22)(t5);
    let t6;
    if ($[12] !== onSelectSkill || $[13] !== skillSlug) {
        t6 = (browseItem_0)=>{
            const skill_1 = skillSlug.get(browseItem_0.id);
            if (skill_1) onSelectSkill(skill_1);
        };
        $[12] = onSelectSkill;
        $[13] = skillSlug;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== onSkillHover) {
        t7 = (browseItem_1)=>{
            onSkillHover?.(browseItem_1 ? browseItem_1.name : null);
        };
        $[15] = onSkillHover;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = hasNext ? listEndRef : undefined;
    let t9;
    if ($[17] !== browseItems || $[18] !== closeInlineBrowse || $[19] !== isLoadingNext || $[20] !== renderSkillHoverCardContent || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $678586c219416993$export$f8d717582a5e730e), {
            browseItems: browseItems,
            onSelectBrowseItem: t6,
            onBrowseItemHover: t7,
            onClose: closeInlineBrowse,
            iconMap: (0, $9MCKh.skillIconMap),
            defaultIcon: (0, $9MCKh.DefaultSkillIcon),
            renderHoverCardContent: renderSkillHoverCardContent,
            listFooterLoading: isLoadingNext,
            listEndRef: t8
        });
        $[17] = browseItems;
        $[18] = closeInlineBrowse;
        $[19] = isLoadingNext;
        $[20] = renderSkillHoverCardContent;
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ skills: skills, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext, closeInlineBrowse: closeInlineBrowse, onSelectSkill: onSelectSkill, onSkillHover: onSkillHover })=>{
    const skillSlug = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>new Map(skills.map((s)=>[
                s.slug,
                s
            ])), [
        skills
    ]);
    const browseItems = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>skills.map((skill)=>({
                id: skill.slug,
                name: skill.name,
                description: skill.description,
                iconName: skill.iconName,
                iconColor: (0, $9OqBj.getIconColor)(skill.color),
                product: skill.product
            })), [
        skills
    ]);
    const renderSkillHoverCardContent = (browseItem)=>{
        const skill_0 = skillSlug.get(browseItem.id);
        if (!skill_0) return null;
        const { slug: _slug, ...skillContentProps } = skill_0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80Hjq.SkillHoverCardContent), skillContentProps);
    };
    const handleLoadMore = (0, $cozmU.useCallback)(()=>{
        if (isLoadingNext || !hasNext) return;
        loadNext($6e0e4654cba47971$var$PAGE_SIZE);
    }, [
        isLoadingNext,
        hasNext,
        loadNext
    ]);
    const listEndRef = (0, $837e2bdf2015312e$export$a973cef5093a8d22)({
        onScrollTo: handleLoadMore
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $678586c219416993$export$f8d717582a5e730e), {
        browseItems: browseItems,
        onSelectBrowseItem: (browseItem_0)=>{
            const skill_1 = skillSlug.get(browseItem_0.id);
            if (skill_1) onSelectSkill(skill_1);
        },
        onBrowseItemHover: (browseItem_1)=>{
            onSkillHover?.(browseItem_1 ? browseItem_1.name : null);
        },
        onClose: closeInlineBrowse,
        iconMap: (0, $9MCKh.skillIconMap),
        defaultIcon: (0, $9MCKh.DefaultSkillIcon),
        renderHoverCardContent: renderSkillHoverCardContent,
        listFooterLoading: isLoadingNext,
        listEndRef: hasNext ? listEndRef : undefined
    });
};
const $6e0e4654cba47971$var$BrowseSkillsLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(22);
    const { siteId: siteId, searchKeyword: searchKeyword } = props;
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "SKILL"
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== siteId) {
        t1 = {
            first: $6e0e4654cba47971$var$PAGE_SIZE,
            cloudId: siteId,
            surface: "ROVO",
            relevantFor: t0,
            searchKeyword: null
        };
        $[1] = siteId;
        $[2] = t1;
    } else t1 = $[2];
    const preloadedRef = (0, $6SsN4.useLazyLoadQuery)((0, $8172ba940868b6e1$export$2e2bcd8739ae039), t1);
    const skipSearchRefetchOnMount = (0, $cozmU.useRef)(true);
    const latestSearchKeywordRef = (0, $cozmU.useRef)(searchKeyword);
    let t2;
    let t3;
    if ($[3] !== searchKeyword) {
        t2 = ()=>{
            latestSearchKeywordRef.current = searchKeyword;
        };
        t3 = [
            searchKeyword
        ];
        $[3] = searchKeyword;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const { data: data, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext, refetch: refetch } = (0, $6SsN4.usePaginationFragment)((0, $9c7e1514a5eb5c4b$export$2e2bcd8739ae039), preloadedRef);
    let t4;
    let t5;
    if ($[6] !== refetch || $[7] !== searchKeyword) {
        t4 = ()=>{
            if (skipSearchRefetchOnMount.current) {
                skipSearchRefetchOnMount.current = false;
                return;
            }
            const trimmed = searchKeyword.trim();
            const variables = {
                searchKeyword: trimmed.length > 0 ? trimmed : null
            };
            refetch(variables);
        };
        t5 = [
            searchKeyword,
            refetch
        ];
        $[6] = refetch;
        $[7] = searchKeyword;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[10] !== refetch || $[11] !== skillsRevision) {
        t6 = ()=>{
            if (skillsRevision === 0) return;
            const trimmed_0 = latestSearchKeywordRef.current.trim();
            const variables_0 = {
                searchKeyword: trimmed_0.length > 0 ? trimmed_0 : null
            };
            refetch(variables_0, {
                fetchPolicy: "network-only"
            });
        };
        t7 = [
            refetch,
            skillsRevision
        ];
        $[10] = refetch;
        $[11] = skillsRevision;
        $[12] = t6;
        $[13] = t7;
    } else {
        t6 = $[12];
        t7 = $[13];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const skillsResponse = data?.graphIntegration_componentDirectoryItems;
    if (skillsResponse && "error" in skillsResponse && skillsResponse.error) {
        const err = skillsResponse.error;
        const errExtensions = err.extensions ? `[${err.extensions?.map($6e0e4654cba47971$var$_temp3)?.join(", ")}] ` : "";
        throw new Error(err.message || errExtensions ? `${errExtensions}${err.message}` : "Failed to load skills");
    }
    skillsResponse?.edges;
    const t8 = skillsResponse?.edges ?? null;
    let t9;
    if ($[14] !== t8) {
        t9 = (0, $f6VI9.parseUniversalSkillEdges)(t8);
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    const skills = t9;
    let t10;
    if ($[16] !== hasNext || $[17] !== isLoadingNext || $[18] !== loadNext || $[19] !== props || $[20] !== skills) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsView, {
            ...props,
            skills: skills,
            hasNext: hasNext,
            isLoadingNext: isLoadingNext,
            loadNext: loadNext
        });
        $[16] = hasNext;
        $[17] = isLoadingNext;
        $[18] = loadNext;
        $[19] = props;
        $[20] = skills;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : (props)=>{
    const { siteId: siteId, searchKeyword: searchKeyword } = props;
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    const preloadedRef = (0, $6SsN4.useLazyLoadQuery)((0, $8172ba940868b6e1$export$2e2bcd8739ae039), {
        first: $6e0e4654cba47971$var$PAGE_SIZE,
        cloudId: siteId,
        surface: 'ROVO',
        relevantFor: [
            'SKILL'
        ],
        searchKeyword: null
    });
    const skipSearchRefetchOnMount = (0, $cozmU.useRef)(true);
    const latestSearchKeywordRef = (0, $cozmU.useRef)(searchKeyword);
    (0, $cozmU.useEffect)(()=>{
        latestSearchKeywordRef.current = searchKeyword;
    }, [
        searchKeyword
    ]);
    // Use pagination fragment for infinite loading
    const { data: data, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext, refetch: refetch } = (0, $6SsN4.usePaginationFragment)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseSkillEdges */ (0, $9c7e1514a5eb5c4b$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ preloadedRef);
    (0, $cozmU.useEffect)(()=>{
        if (skipSearchRefetchOnMount.current) {
            skipSearchRefetchOnMount.current = false;
            return;
        }
        const trimmed = searchKeyword.trim();
        const variables = {
            searchKeyword: trimmed.length > 0 ? trimmed : null
        };
        refetch(variables);
    }, [
        searchKeyword,
        refetch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skillsRevision === 0) return;
        const trimmed_0 = latestSearchKeywordRef.current.trim();
        const variables_0 = {
            searchKeyword: trimmed_0.length > 0 ? trimmed_0 : null
        };
        refetch(variables_0, {
            fetchPolicy: 'network-only'
        });
    }, [
        refetch,
        skillsRevision
    ]);
    const skillsResponse = data?.graphIntegration_componentDirectoryItems;
    if (skillsResponse && 'error' in skillsResponse && skillsResponse.error) {
        const err = skillsResponse.error;
        const errExtensions = err.extensions ? `[${err.extensions?.map((ext)=>`${ext?.statusCode} - ${ext?.errorType}`)?.join(', ')}] ` : '';
        throw new Error(err.message || errExtensions ? `${errExtensions}${err.message}` : 'Failed to load skills');
    }
    const skills = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $f6VI9.parseUniversalSkillEdges)(skillsResponse?.edges ?? null), [
        skillsResponse?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsView, {
        ...props,
        skills: skills,
        hasNext: hasNext,
        isLoadingNext: isLoadingNext,
        loadNext: loadNext
    });
};
const $6e0e4654cba47971$var$BrowseSkillsUnified = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(20);
    const { siteId: siteId, searchKeyword: searchKeyword } = props;
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    let t0;
    if ($[0] !== searchKeyword) {
        t0 = searchKeyword.trim();
        $[0] = searchKeyword;
        $[1] = t0;
    } else t0 = $[1];
    const trimmedSearch = t0;
    const latestSearchKeywordRef = (0, $cozmU.useRef)(searchKeyword);
    let t1;
    let t2;
    if ($[2] !== searchKeyword) {
        t1 = ()=>{
            latestSearchKeywordRef.current = searchKeyword;
        };
        t2 = [
            searchKeyword
        ];
        $[2] = searchKeyword;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const t3 = trimmedSearch.length > 0 ? trimmedSearch : null;
    let t4;
    if ($[5] !== siteId || $[6] !== t3) {
        t4 = {
            first: $6e0e4654cba47971$var$PAGE_SIZE,
            cloudId: siteId,
            searchKeyword: t3
        };
        $[5] = siteId;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const preloadedRef = (0, $6SsN4.useLazyLoadQuery)((0, $c651f99bad72176e$export$2e2bcd8739ae039), t4);
    const { data: data, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext, refetch: refetch } = (0, $6SsN4.usePaginationFragment)((0, $6c088e18824f2166$export$2e2bcd8739ae039), preloadedRef);
    let t5;
    let t6;
    if ($[8] !== refetch || $[9] !== skillsRevision) {
        t5 = ()=>{
            if (skillsRevision === 0) return;
            const trimmed = latestSearchKeywordRef.current.trim();
            const variables = {
                searchKeyword: trimmed.length > 0 ? trimmed : null
            };
            refetch(variables, {
                fetchPolicy: "network-only"
            });
        };
        t6 = [
            refetch,
            skillsRevision
        ];
        $[8] = refetch;
        $[9] = skillsRevision;
        $[10] = t5;
        $[11] = t6;
    } else {
        t5 = $[10];
        t6 = $[11];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const skillsResponse = data?.convoai_availableSkills;
    if (skillsResponse && "errors" in skillsResponse && skillsResponse.errors && skillsResponse.errors.length > 0) {
        const errorMessages = skillsResponse.errors.map($6e0e4654cba47971$var$_temp4).join(", ");
        throw new Error(errorMessages || "Failed to load skills");
    }
    skillsResponse?.edges;
    const t7 = skillsResponse?.edges ?? null;
    let t8;
    if ($[12] !== t7) {
        t8 = (0, $f6VI9.parseUniversalSkillEdges)(t7);
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    const skills = t8;
    let t9;
    if ($[14] !== hasNext || $[15] !== isLoadingNext || $[16] !== loadNext || $[17] !== props || $[18] !== skills) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsView, {
            ...props,
            skills: skills,
            hasNext: hasNext,
            isLoadingNext: isLoadingNext,
            loadNext: loadNext
        });
        $[14] = hasNext;
        $[15] = isLoadingNext;
        $[16] = loadNext;
        $[17] = props;
        $[18] = skills;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : (props)=>{
    const { siteId: siteId, searchKeyword: searchKeyword } = props;
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    const trimmedSearch = searchKeyword.trim();
    const latestSearchKeywordRef = (0, $cozmU.useRef)(searchKeyword);
    (0, $cozmU.useEffect)(()=>{
        latestSearchKeywordRef.current = searchKeyword;
    }, [
        searchKeyword
    ]);
    const preloadedRef = (0, $6SsN4.useLazyLoadQuery)((0, $c651f99bad72176e$export$2e2bcd8739ae039), {
        first: $6e0e4654cba47971$var$PAGE_SIZE,
        cloudId: siteId,
        searchKeyword: trimmedSearch.length > 0 ? trimmedSearch : null
    });
    const { data: data, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext, refetch: refetch } = (0, $6SsN4.usePaginationFragment)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseUniversalSkillEdges */ (0, $6c088e18824f2166$export$2e2bcd8739ae039), preloadedRef);
    (0, $cozmU.useEffect)(()=>{
        if (skillsRevision === 0) return;
        const trimmed = latestSearchKeywordRef.current.trim();
        const variables = {
            searchKeyword: trimmed.length > 0 ? trimmed : null
        };
        refetch(variables, {
            fetchPolicy: 'network-only'
        });
    }, [
        refetch,
        skillsRevision
    ]);
    const skillsResponse = data?.convoai_availableSkills;
    if (skillsResponse && 'errors' in skillsResponse && skillsResponse.errors && skillsResponse.errors.length > 0) {
        const errorMessages = skillsResponse.errors.map((err)=>err?.message).join(', ');
        throw new Error(errorMessages || 'Failed to load skills');
    }
    const skills = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $f6VI9.parseUniversalSkillEdges)(skillsResponse?.edges ?? null), [
        skillsResponse?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsView, {
        ...props,
        skills: skills,
        hasNext: hasNext,
        isLoadingNext: isLoadingNext,
        loadNext: loadNext
    });
};
const $6e0e4654cba47971$export$bd05faaeed0d0130 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if ((0, $iDrrr.fg)("rovo_chat_unified_skills_agg")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsUnified, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsLegacy, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    if ((0, $iDrrr.fg)('rovo_chat_unified_skills_agg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsUnified, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e0e4654cba47971$var$BrowseSkillsLegacy, props);
};
function $6e0e4654cba47971$var$_temp(s) {
    return [
        s.slug,
        s
    ];
}
function $6e0e4654cba47971$var$_temp2(skill) {
    return {
        id: skill.slug,
        name: skill.name,
        description: skill.description,
        iconName: skill.iconName,
        iconColor: (0, $9OqBj.getIconColor)(skill.color),
        product: skill.product
    };
}
function $6e0e4654cba47971$var$_temp3(ext) {
    return `${ext?.statusCode} - ${ext?.errorType}`;
}
function $6e0e4654cba47971$var$_temp4(err) {
    return err?.message;
}









var $lfXuJ = parcelRequire("lfXuJ");


const $19edd2ef54ed6c70$var$SeeAllSkillsButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("iLIUb")).then((module)=>({
            default: module.SeeAllSkillsButton
        })));
const $19edd2ef54ed6c70$var$styles = {
    overlay: "_49OCfRdnbC _1mT5xdWVPG _0KLXrulfZc _42Yu6BgtVO",
    overlayHidden: "_3iDTPbYbGa",
    browseWrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _39xV02N91d _4bt5LAnQyn",
    browseHeaderContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0Of8r2kG2W _1ZnuxbkG2W _1wydGWkG2W _2Zuz6QkG2W",
    browseSearchBar: "_2Zuz6QkG2W _1ZnuxbkG2W",
    listSuspenseFallback: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $19edd2ef54ed6c70$export$4a163bc5333928f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { screenType: screenType, closeInlineBrowse: closeInlineBrowse, onSelectSkill: onSelectSkill } = t0;
    (0, $6cFsl.di)((0, $d5gEx.AtlassianRelayEnvironmentProvider));
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const setChatInputPlaceholderOverride = (0, $aBUXY.usePlaceholderOverrideDispatch)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [searchKeyword, setSearchKeyword] = (0, $cozmU.useState)("");
    const [isBrowseErrored, setIsBrowseErrored] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_skills_library");
        $[0] = t1;
    } else t1 = $[0];
    const isSeeAllSkillsButtonEnabled = t1;
    let t2;
    if ($[1] !== setChatInputPlaceholderOverride) {
        t2 = (skillName)=>{
            setChatInputPlaceholderOverride(skillName ?? "");
        };
        $[1] = setChatInputPlaceholderOverride;
        $[2] = t2;
    } else t2 = $[2];
    const handleSkillHover = t2;
    const t3 = screenType !== "skills" && $19edd2ef54ed6c70$var$styles.overlayHidden;
    let t4;
    if ($[3] !== t3) {
        t4 = (0, $w6R6I.cx)($19edd2ef54ed6c70$var$styles.overlay, t3);
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== formatMessage) {
        t5 = formatMessage((0, $lfXuJ.messages).headerTitle);
        $[5] = formatMessage;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xlarge",
            as: "h2"
        }, t5);
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== siteId) {
        t7 = isSeeAllSkillsButtonEnabled && siteId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-see-all-skills-button",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($19edd2ef54ed6c70$var$SeeAllSkillsButton, {
            cloudId: siteId
        }));
        $[9] = siteId;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t6 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $19edd2ef54ed6c70$var$styles.browseHeaderContainer
        }, t6, t7);
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== formatMessage) {
        t9 = formatMessage((0, $lfXuJ.messages).searchPlaceholder);
        $[14] = formatMessage;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== isBrowseErrored || $[17] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $19edd2ef54ed6c70$var$styles.browseSearchBar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
            placeholderText: t9,
            onSearch: setSearchKeyword,
            isCompact: true,
            autoFocus: true,
            isDisabled: isBrowseErrored
        }));
        $[16] = isBrowseErrored;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== siteId) {
        t11 = (error)=>{
            setIsBrowseErrored(true);
            (0, $hlvTd.logException)({
                exception: error,
                name: "skillsBrowseRelay",
                tags: {
                    siteId: siteId
                }
            });
        };
        $[19] = siteId;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $19edd2ef54ed6c70$var$styles.listSuspenseFallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f2eb5e4bb867e3b$export$69eeb649a3550caa), null));
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== closeInlineBrowse || $[23] !== handleSkillHover || $[24] !== onSelectSkill || $[25] !== searchKeyword || $[26] !== siteId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-skills-inline-browse",
            fallback: t12
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6e0e4654cba47971$export$bd05faaeed0d0130), {
            siteId: siteId,
            searchKeyword: searchKeyword,
            closeInlineBrowse: closeInlineBrowse,
            onSelectSkill: onSelectSkill,
            onSkillHover: handleSkillHover
        })));
        $[22] = closeInlineBrowse;
        $[23] = handleSkillHover;
        $[24] = onSelectSkill;
        $[25] = searchKeyword;
        $[26] = siteId;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== t11 || $[29] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: $19edd2ef54ed6c70$var$_temp,
            onError: t11
        }, t13);
        $[28] = t11;
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== t10 || $[32] !== t14 || $[33] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $19edd2ef54ed6c70$var$styles.browseWrapper
        }, t8, t10, t14);
        $[31] = t10;
        $[32] = t14;
        $[33] = t8;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== t15 || $[36] !== t4) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "skills-inline-browse-overlay",
            xcss: t4
        }, t15);
        $[35] = t15;
        $[36] = t4;
        $[37] = t16;
    } else t16 = $[37];
    return t16;
} : ({ screenType: screenType, closeInlineBrowse: closeInlineBrowse, onSelectSkill: onSelectSkill })=>{
    (0, $6cFsl.di)((0, $d5gEx.AtlassianRelayEnvironmentProvider));
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const setChatInputPlaceholderOverride = (0, $aBUXY.usePlaceholderOverrideDispatch)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [searchKeyword, setSearchKeyword] = (0, $cozmU.useState)('');
    const [isBrowseErrored, setIsBrowseErrored] = (0, $cozmU.useState)(false);
    const isSeeAllSkillsButtonEnabled = (0, $iDrrr.fg)('rovo_chat_skills_library');
    const handleSkillHover = (0, $cozmU.useCallback)((skillName)=>{
        setChatInputPlaceholderOverride(skillName ?? '');
    }, [
        setChatInputPlaceholderOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "skills-inline-browse-overlay",
        xcss: (0, $w6R6I.cx)($19edd2ef54ed6c70$var$styles.overlay, screenType !== 'skills' && $19edd2ef54ed6c70$var$styles.overlayHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $19edd2ef54ed6c70$var$styles.browseWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $19edd2ef54ed6c70$var$styles.browseHeaderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xlarge",
        as: "h2"
    }, formatMessage((0, $lfXuJ.messages).headerTitle)), isSeeAllSkillsButtonEnabled && siteId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-see-all-skills-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($19edd2ef54ed6c70$var$SeeAllSkillsButton, {
        cloudId: siteId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $19edd2ef54ed6c70$var$styles.browseSearchBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        placeholderText: formatMessage((0, $lfXuJ.messages).searchPlaceholder),
        onSearch: setSearchKeyword,
        isCompact: true,
        autoFocus: true,
        isDisabled: isBrowseErrored
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
                errorType: "generic"
            }),
        onError: (error)=>{
            setIsBrowseErrored(true);
            (0, $hlvTd.logException)({
                exception: error,
                name: 'skillsBrowseRelay',
                tags: {
                    siteId: siteId
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-skills-inline-browse",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $19edd2ef54ed6c70$var$styles.listSuspenseFallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f2eb5e4bb867e3b$export$69eeb649a3550caa), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6e0e4654cba47971$export$bd05faaeed0d0130), {
        siteId: siteId,
        searchKeyword: searchKeyword,
        closeInlineBrowse: closeInlineBrowse,
        onSelectSkill: onSelectSkill,
        onSkillHover: handleSkillHover
    }))))));
};
function $19edd2ef54ed6c70$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
        errorType: "generic"
    });
}



var $6hUo1 = parcelRequire("6hUo1");


var $aGWMb = parcelRequire("aGWMb");


var $k43Ke = parcelRequire("k43Ke");


var $3UaYh = parcelRequire("3UaYh");
































var $kQMBL = parcelRequire("kQMBL");











var $2LyZS = parcelRequire("2LyZS");













const $a247f97e082e0081$var$messages = (0, $kSwu1.defineMessages)({
    expandButton: {
        id: "rovo-platform-ui-components.store-memory-update.expandButton",
        defaultMessage: "Memory updated"
    },
    openSettingsButton: {
        id: "rovo-platform-ui-components.store-memory-update.openSettingsButton",
        defaultMessage: "Manage memories"
    },
    betaLabel: {
        id: "rovo-platform-ui-components.store-memory-update.betaLabel",
        defaultMessage: "BETA"
    }
});
var $a247f97e082e0081$export$2e2bcd8739ae039 = $a247f97e082e0081$var$messages;


const $3133b22bb722df35$var$styles = {
    container: "_2XsHFM4F84 _3138428HPE",
    expandedContent: "_2Zuz6Q2ADO _1UtDYzy7kJ",
    reviewMemory: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1oM3wRFQfX",
    button: "_2mHwu8gVvo _0bjKvDKxmn _1UtDYzKGUX _1kk5Tkmb2E _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO _0KLXru66of _1eOmH6o126 _3gzVzLN4oS"
};
const $3133b22bb722df35$export$b439ca110cf5781 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { storeMemoryUpdate: storeMemoryUpdate, onExpandedChange: onExpandedChange, onManageMemoriesClick: onManageMemoriesClick, onOpenMemoryManagement: onOpenMemoryManagement, onView: onView, showBetaLabel: t1 } = t0;
    const showBetaLabel = t1 === undefined ? false : t1;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const hasTrackedView = (0, $cozmU.useRef)(false);
    const useResizingHeightProps = (0, $2LyZS.useResizingHeight)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    let t3;
    if ($[0] !== onView) {
        t2 = ()=>{
            if (!hasTrackedView.current) {
                onView?.();
                hasTrackedView.current = true;
            }
        };
        t3 = [
            onView
        ];
        $[0] = onView;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] !== isExpanded || $[4] !== onExpandedChange) {
        t4 = ()=>{
            const nextExpandedState = !isExpanded;
            setIsExpanded(nextExpandedState);
            onExpandedChange?.(nextExpandedState);
        };
        $[3] = isExpanded;
        $[4] = onExpandedChange;
        $[5] = t4;
    } else t4 = $[5];
    const handleExpandToggle = t4;
    let t5;
    if ($[6] !== onManageMemoriesClick || $[7] !== onOpenMemoryManagement) {
        t5 = ()=>{
            onManageMemoriesClick?.();
            onOpenMemoryManagement?.();
        };
        $[6] = onManageMemoriesClick;
        $[7] = onOpenMemoryManagement;
        $[8] = t5;
    } else t5 = $[8];
    const handleOpenMemoryManagement = t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kQMBL))), {
            label: "",
            color: "currentColor"
        });
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== formatMessage) {
        t7 = formatMessage((0, $a247f97e082e0081$export$2e2bcd8739ae039).expandButton);
        $[10] = formatMessage;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "bold",
            color: "color.text.subtlest",
            size: "small"
        }, t7);
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== formatMessage || $[15] !== showBetaLabel) {
        t9 = showBetaLabel && /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, formatMessage((0, $a247f97e082e0081$export$2e2bcd8739ae039).betaLabel));
        $[14] = formatMessage;
        $[15] = showBetaLabel;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== isExpanded) {
        t10 = isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: "",
            color: "currentColor",
            size: "small"
        });
        $[17] = isExpanded;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== handleExpandToggle || $[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $3133b22bb722df35$var$styles.button,
            onClick: handleExpandToggle
        }, t6, t8, t9, t10);
        $[19] = handleExpandToggle;
        $[20] = t10;
        $[21] = t8;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== formatMessage || $[25] !== handleOpenMemoryManagement || $[26] !== isExpanded || $[27] !== storeMemoryUpdate) {
        t12 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050",
            alignInline: "start"
        }, storeMemoryUpdate.content && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $3133b22bb722df35$var$styles.expandedContent
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small"
        }, storeMemoryUpdate.content)), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($3133b22bb722df35$var$styles.button, $3133b22bb722df35$var$styles.reviewMemory),
            onClick: handleOpenMemoryManagement
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "regular",
            size: "small"
        }, formatMessage((0, $a247f97e082e0081$export$2e2bcd8739ae039).openSettingsButton))));
        $[24] = formatMessage;
        $[25] = handleOpenMemoryManagement;
        $[26] = isExpanded;
        $[27] = storeMemoryUpdate;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t12);
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== t11 || $[32] !== t13 || $[33] !== useResizingHeightProps) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $3133b22bb722df35$var$styles.container,
            alignInline: "start",
            space: "space.050",
            ...useResizingHeightProps
        }, t11, t13);
        $[31] = t11;
        $[32] = t13;
        $[33] = useResizingHeightProps;
        $[34] = t14;
    } else t14 = $[34];
    return t14;
} : ({ storeMemoryUpdate: storeMemoryUpdate, onExpandedChange: onExpandedChange, onManageMemoriesClick: onManageMemoriesClick, onOpenMemoryManagement: onOpenMemoryManagement, onView: onView, showBetaLabel: showBetaLabel = false })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const hasTrackedView = (0, $cozmU.useRef)(false);
    const useResizingHeightProps = (0, $2LyZS.useResizingHeight)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (!hasTrackedView.current) {
            onView?.();
            hasTrackedView.current = true;
        }
    }, [
        onView
    ]);
    const handleExpandToggle = ()=>{
        const nextExpandedState = !isExpanded;
        setIsExpanded(nextExpandedState);
        onExpandedChange?.(nextExpandedState);
    };
    const handleOpenMemoryManagement = ()=>{
        onManageMemoriesClick?.();
        onOpenMemoryManagement?.();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $3133b22bb722df35$var$styles.container,
        alignInline: "start",
        space: "space.050",
        ...useResizingHeightProps
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $3133b22bb722df35$var$styles.button,
        onClick: handleExpandToggle
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kQMBL))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage((0, $a247f97e082e0081$export$2e2bcd8739ae039).expandButton)), showBetaLabel && /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, formatMessage((0, $a247f97e082e0081$export$2e2bcd8739ae039).betaLabel)), isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "currentColor",
        size: "small"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        label: "",
        color: "currentColor",
        size: "small"
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050",
        alignInline: "start"
    }, storeMemoryUpdate.content && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $3133b22bb722df35$var$styles.expandedContent
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small"
    }, storeMemoryUpdate.content)), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($3133b22bb722df35$var$styles.button, $3133b22bb722df35$var$styles.reviewMemory),
        onClick: handleOpenMemoryManagement
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "regular",
        size: "small"
    }, formatMessage((0, $a247f97e082e0081$export$2e2bcd8739ae039).openSettingsButton))))));
});


const $a7eac2f2453a693d$export$b439ca110cf5781 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { storeMemoryUpdate: storeMemoryUpdate, onOpenMemoryManagement: onOpenMemoryManagement } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_memory_beta_label");
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    let t3;
    let t4;
    if ($[1] !== sendAnalyticsEvent) {
        t2 = ()=>{
            sendAnalyticsEvent({
                action: "viewed",
                actionSubject: "memoryUpdate",
                actionSubjectId: "memoryUpdateDisclosure"
            });
        };
        t3 = (isExpanded)=>{
            sendAnalyticsEvent({
                action: isExpanded ? "expanded" : "collapsed",
                actionSubject: "memoryUpdate",
                actionSubjectId: "memoryUpdateToggle"
            });
        };
        t4 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "manageMemoriesButton"
            });
        };
        $[1] = sendAnalyticsEvent;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else {
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] !== onOpenMemoryManagement || $[6] !== storeMemoryUpdate || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $3133b22bb722df35$export$b439ca110cf5781), {
            storeMemoryUpdate: storeMemoryUpdate,
            showBetaLabel: t1,
            onView: t2,
            onExpandedChange: t3,
            onManageMemoriesClick: t4,
            onOpenMemoryManagement: onOpenMemoryManagement
        });
        $[5] = onOpenMemoryManagement;
        $[6] = storeMemoryUpdate;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ storeMemoryUpdate: storeMemoryUpdate, onOpenMemoryManagement: onOpenMemoryManagement })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    return /*#__PURE__*/ $cozmU.createElement((0, $3133b22bb722df35$export$b439ca110cf5781), {
        storeMemoryUpdate: storeMemoryUpdate,
        showBetaLabel: (0, $iDrrr.fg)('rovo_memory_beta_label'),
        onView: ()=>{
            sendAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'memoryUpdate',
                actionSubjectId: 'memoryUpdateDisclosure'
            });
        },
        onExpandedChange: (isExpanded)=>{
            sendAnalyticsEvent({
                action: isExpanded ? 'expanded' : 'collapsed',
                actionSubject: 'memoryUpdate',
                actionSubjectId: 'memoryUpdateToggle'
            });
        },
        onManageMemoriesClick: ()=>{
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'manageMemoriesButton'
            });
        },
        onOpenMemoryManagement: onOpenMemoryManagement
    });
});



var $b6ezN = parcelRequire("b6ezN");

/* StoreConnectorRecommendation.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $4M6Ac = parcelRequire("4M6Ac");





























const $b5b620df1b3aa765$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unconnectedTitle: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.title",
        defaultMessage: "Connect {appName}"
    },
    unconnectedDescription: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.description",
        defaultMessage: "Your results may be missing info from {appName}. Connect to get more complete answers."
    },
    connectButton: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.connect-button",
        defaultMessage: "Connect"
    },
    connectedTitle: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.connected-title",
        defaultMessage: "{appName} is connected \uD83C\uDF89"
    },
    connectedRerunDescription: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.connected-description",
        defaultMessage: "Rovo can now search your {appName} for answers. Re-send your last message to see better results."
    },
    rerunPromptButton: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.rerun-prompt-button",
        defaultMessage: "Re-send message"
    },
    connectedDescription: {
        id: "ai-mate.conversation-assistant-ui-components.connector-recommendation.connected-simple-description",
        defaultMessage: "Your answers now include results from {appName}."
    }
});


const $086abdfc88764410$var$styles = {
    card: "_0bjKvDuMRm _4c065U5zaO _2Y7lL45zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _43nrzT8HPE _0KLXruqi9L _2OUyjtzwhj",
    icon: "_00EA0egIor _39xV02oWWg _0jFU0VoWWg"
};
const $086abdfc88764410$export$b9fdb81af1c6ffb9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    const { friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, iconUrl: iconUrl, onConnect: onConnect, isConnected: isConnected, canRerunPrompt: canRerunPrompt, onRerunPrompt: onRerunPrompt } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== appSource || $[1] !== friendlyName || $[2] !== onConnect || $[3] !== outboundAuthUrl) {
        t1 = ()=>{
            onConnect({
                appSource: appSource,
                friendlyName: friendlyName,
                outboundAuthUrl: outboundAuthUrl
            });
        };
        $[0] = appSource;
        $[1] = friendlyName;
        $[2] = onConnect;
        $[3] = outboundAuthUrl;
        $[4] = t1;
    } else t1 = $[4];
    const handleConnect = t1;
    let t2;
    bb0: {
        const appName = friendlyName;
        if (!isConnected) {
            let t3;
            if ($[5] !== appName || $[6] !== formatMessage) {
                t3 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).unconnectedTitle, {
                    appName: appName
                });
                $[5] = appName;
                $[6] = formatMessage;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== appName || $[9] !== formatMessage) {
                t4 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).unconnectedDescription, {
                    appName: appName
                });
                $[8] = appName;
                $[9] = formatMessage;
                $[10] = t4;
            } else t4 = $[10];
            let t5;
            if ($[11] !== formatMessage) {
                t5 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectButton);
                $[11] = formatMessage;
                $[12] = t5;
            } else t5 = $[12];
            let t6;
            if ($[13] !== handleConnect || $[14] !== t5) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    appearance: "default",
                    onClick: handleConnect,
                    testId: "connector-recommendation-connect-button"
                }, t5);
                $[13] = handleConnect;
                $[14] = t5;
                $[15] = t6;
            } else t6 = $[15];
            let t7;
            if ($[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
                t7 = {
                    title: t3,
                    description: t4,
                    cta: t6
                };
                $[16] = t3;
                $[17] = t4;
                $[18] = t6;
                $[19] = t7;
            } else t7 = $[19];
            t2 = t7;
            break bb0;
        }
        if (canRerunPrompt) {
            let t3;
            if ($[20] !== appName || $[21] !== formatMessage) {
                t3 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedTitle, {
                    appName: appName
                });
                $[20] = appName;
                $[21] = formatMessage;
                $[22] = t3;
            } else t3 = $[22];
            let t4;
            if ($[23] !== appName || $[24] !== formatMessage) {
                t4 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedRerunDescription, {
                    appName: appName
                });
                $[23] = appName;
                $[24] = formatMessage;
                $[25] = t4;
            } else t4 = $[25];
            let t5;
            if ($[26] !== formatMessage) {
                t5 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).rerunPromptButton);
                $[26] = formatMessage;
                $[27] = t5;
            } else t5 = $[27];
            let t6;
            if ($[28] !== onRerunPrompt || $[29] !== t5) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    appearance: "default",
                    onClick: onRerunPrompt,
                    testId: "connector-recommendation-rerun-button"
                }, t5);
                $[28] = onRerunPrompt;
                $[29] = t5;
                $[30] = t6;
            } else t6 = $[30];
            let t7;
            if ($[31] !== t3 || $[32] !== t4 || $[33] !== t6) {
                t7 = {
                    title: t3,
                    description: t4,
                    cta: t6
                };
                $[31] = t3;
                $[32] = t4;
                $[33] = t6;
                $[34] = t7;
            } else t7 = $[34];
            t2 = t7;
            break bb0;
        }
        let t3;
        if ($[35] !== appName || $[36] !== formatMessage) {
            t3 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedTitle, {
                appName: appName
            });
            $[35] = appName;
            $[36] = formatMessage;
            $[37] = t3;
        } else t3 = $[37];
        let t4;
        if ($[38] !== appName || $[39] !== formatMessage) {
            t4 = formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedDescription, {
                appName: appName
            });
            $[38] = appName;
            $[39] = formatMessage;
            $[40] = t4;
        } else t4 = $[40];
        let t5;
        if ($[41] !== t3 || $[42] !== t4) {
            t5 = {
                title: t3,
                description: t4
            };
            $[41] = t3;
            $[42] = t4;
            $[43] = t5;
        } else t5 = $[43];
        t2 = t5;
    }
    const { title: title, description: description, cta: cta } = t2;
    let t3;
    if ($[44] !== iconUrl) {
        t3 = iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "img",
            src: iconUrl,
            alt: "",
            xcss: $086abdfc88764410$var$styles.icon,
            testId: "connector-recommendation-icon"
        });
        $[44] = iconUrl;
        $[45] = t3;
    } else t3 = $[45];
    let t4;
    if ($[46] !== title) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "semibold",
            color: "color.text"
        }, title);
        $[46] = title;
        $[47] = t4;
    } else t4 = $[47];
    let t5;
    if ($[48] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, description);
        $[48] = description;
        $[49] = t5;
    } else t5 = $[49];
    let t6;
    if ($[50] !== cta || $[51] !== t3 || $[52] !== t4 || $[53] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $086abdfc88764410$var$styles.card,
            testId: "connector-recommendation-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "start"
        }, t3, t4, t5, cta));
        $[50] = cta;
        $[51] = t3;
        $[52] = t4;
        $[53] = t5;
        $[54] = t6;
    } else t6 = $[54];
    return t6;
} : ({ friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, iconUrl: iconUrl, onConnect: onConnect, isConnected: isConnected, canRerunPrompt: canRerunPrompt, onRerunPrompt: onRerunPrompt })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleConnect = (0, $cozmU.useCallback)(()=>{
        onConnect({
            appSource: appSource,
            friendlyName: friendlyName,
            outboundAuthUrl: outboundAuthUrl
        });
    }, [
        onConnect,
        appSource,
        friendlyName,
        outboundAuthUrl
    ]); // Derive the card state and all state-dependent content in one memo so
    // that (a) the state logic lives in one place, and (b) formatMessage is
    // only called for the active state.
    const { title: title, description: description, cta: cta } = (0, $cozmU.useMemo)(()=>{
        const appName = friendlyName;
        if (!isConnected) return {
            title: formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).unconnectedTitle, {
                appName: appName
            }),
            description: formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).unconnectedDescription, {
                appName: appName
            }),
            cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: handleConnect,
                testId: "connector-recommendation-connect-button"
            }, formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectButton))
        };
        if (canRerunPrompt) return {
            title: formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedTitle, {
                appName: appName
            }),
            description: formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedRerunDescription, {
                appName: appName
            }),
            cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: onRerunPrompt,
                testId: "connector-recommendation-rerun-button"
            }, formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).rerunPromptButton))
        };
        return {
            title: formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedTitle, {
                appName: appName
            }),
            description: formatMessage((0, $b5b620df1b3aa765$export$defe85febe8b728c).connectedDescription, {
                appName: appName
            })
        };
    }, [
        isConnected,
        canRerunPrompt,
        friendlyName,
        formatMessage,
        handleConnect,
        onRerunPrompt
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $086abdfc88764410$var$styles.card,
        testId: "connector-recommendation-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "start"
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "img",
        src: iconUrl,
        alt: "",
        xcss: $086abdfc88764410$var$styles.icon,
        testId: "connector-recommendation-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "semibold",
        color: "color.text"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, description), cta));
};


const $c16027dbba9c3023$export$94b3a3615e137529 = ({ connector: connector, lastHumanMessage: lastHumanMessage, handleResendMessage: handleResendMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)(); // Whether the user has successfully completed OAuth for this connector.
    const [isConnected, setIsConnected] = (0, $cozmU.useState)(false); // Capture the id of the last human message at mount so we can detect
    // whether a new prompt was sent before the user clicks "Connect".
    const humanMessageIdAtRenderRef = (0, $cozmU.useRef)(lastHumanMessage?.id); // Keep a ref to the latest prop value so the re-run handler sees the
    // current message rather than a stale closure.
    const latestHumanMessageRef = (0, $cozmU.useRef)(lastHumanMessage);
    latestHumanMessageRef.current = lastHumanMessage; // Tracks whether the user has attempted OAuth at least once (used to
    // distinguish a retry click from a first attempt in analytics).
    const hasAttemptedConnectRef = (0, $cozmU.useRef)(false); // Analytics guards — each fires its event exactly once.
    const cardViewedLoggedRef = (0, $cozmU.useRef)(false);
    const connectedConfirmationLoggedRef = (0, $cozmU.useRef)(false); // The user can re-run their original prompt only if they haven't sent a new
    // one since the card was shown.
    const canRerunPrompt = isConnected && humanMessageIdAtRenderRef.current !== undefined && humanMessageIdAtRenderRef.current === lastHumanMessage?.id;
    const handleOAuthCompleted = (0, $cozmU.useCallback)(()=>{
        setIsConnected(true);
    }, []);
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)({
        friendlyName: connector.friendlyName,
        appSource: connector.source,
        outboundAuthUrl: connector.outboundAuthUrl,
        analyticsAttributes: {
            source: 'responseConnectorRecommendation'
        },
        onCompletedAction: handleOAuthCompleted
    });
    const handleConnect = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connectButton',
            attributes: {
                source: 'responseConnectorRecommendation',
                appSource: connector.source,
                isRetry: hasAttemptedConnectRef.current
            }
        });
        hasAttemptedConnectRef.current = true;
        onAuthorize();
    }, [
        onAuthorize,
        sendAnalyticsEvent,
        connector.source
    ]);
    const handleRerunPrompt = (0, $cozmU.useCallback)(()=>{
        const latest = latestHumanMessageRef.current;
        if (latest === undefined) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rerunPromptButton',
            attributes: {
                source: 'responseConnectorRecommendation',
                appSource: connector.source
            }
        });
        handleResendMessage(latest.content);
    }, [
        handleResendMessage,
        sendAnalyticsEvent,
        connector.source
    ]);
    // Fire "card shown" once on mount.
    (0, $cozmU.useEffect)(()=>{
        if (!cardViewedLoggedRef.current) {
            cardViewedLoggedRef.current = true;
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: 'connectorRecommendation',
                attributes: {
                    source: 'responseConnectorRecommendation',
                    appSource: connector.source
                }
            });
        }
    }, [
        sendAnalyticsEvent,
        connector.source
    ]);
    // Fire "connected confirmation" once when the user first connects.
    (0, $cozmU.useEffect)(()=>{
        if (isConnected && !connectedConfirmationLoggedRef.current) {
            connectedConfirmationLoggedRef.current = true;
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: 'connectorRecommendation',
                actionSubjectId: 'connectedConfirmation',
                attributes: {
                    source: 'responseConnectorRecommendation',
                    appSource: connector.source,
                    withRerunPromptCTA: canRerunPrompt
                }
            });
        }
    }, [
        isConnected,
        canRerunPrompt,
        sendAnalyticsEvent,
        connector.source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $086abdfc88764410$export$b9fdb81af1c6ffb9), {
        friendlyName: connector.friendlyName,
        appSource: connector.source,
        outboundAuthUrl: connector.outboundAuthUrl,
        iconUrl: connector.iconUrl,
        onConnect: handleConnect,
        isConnected: isConnected,
        canRerunPrompt: canRerunPrompt,
        onRerunPrompt: handleRerunPrompt
    });
};















var $lvJqX = parcelRequire("lvJqX");







const $a7ffbd40f9e2b37c$var$message = (0, $kSwu1.defineMessages)({
    deepResearchRateLimitWarning: {
        id: "chat-history.deep-research-rate-limit-warning",
        defaultMessage: "Please try again in 24 hours."
    },
    deepResearchRateLimitWarningDescription: {
        id: "chat-history.deep-research-rate-limit-warning-description",
        defaultMessage: "You have exceeded the rate limit for deep research. Please try again in 24 hours."
    }
});
var $a7ffbd40f9e2b37c$export$2e2bcd8739ae039 = $a7ffbd40f9e2b37c$var$message;


const $267b28dff33574d8$var$styles = {
    content: "_2Y7lL42ADO _0Of8r22ADO"
};
const $267b28dff33574d8$var$DISPLAY_DURATION_IN_SECONDS = 30;
const $267b28dff33574d8$export$1cf0423885dd4927 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { removeRateLimiting: removeRateLimiting } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const timeoutRef = (0, $cozmU.useRef)();
    let t1;
    let t2;
    if ($[0] !== removeRateLimiting) {
        t1 = ()=>{
            timeoutRef.current = setTimeout(()=>{
                removeRateLimiting();
            }, $267b28dff33574d8$var$DISPLAY_DURATION_IN_SECONDS * 1000);
            return ()=>{
                clearTimeout(timeoutRef.current);
            };
        };
        t2 = [
            removeRateLimiting
        ];
        $[0] = removeRateLimiting;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== formatMessage) {
        t3 = formatMessage((0, $a7ffbd40f9e2b37c$export$2e2bcd8739ae039).deepResearchRateLimitWarning);
        $[3] = formatMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage((0, $a7ffbd40f9e2b37c$export$2e2bcd8739ae039).deepResearchRateLimitWarningDescription);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $267b28dff33574d8$var$styles.content,
            testId: "conversation-assistant.store-rate-limit-warning"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: t3
        }, t4));
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ removeRateLimiting: removeRateLimiting })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const timeoutRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        timeoutRef.current = setTimeout(()=>{
            removeRateLimiting();
        }, $267b28dff33574d8$var$DISPLAY_DURATION_IN_SECONDS * 1000);
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, [
        removeRateLimiting
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $267b28dff33574d8$var$styles.content,
        testId: "conversation-assistant.store-rate-limit-warning"
    }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
        appearance: "warning",
        secondaryText: formatMessage((0, $a7ffbd40f9e2b37c$export$2e2bcd8739ae039).deepResearchRateLimitWarning)
    }, formatMessage((0, $a7ffbd40f9e2b37c$export$2e2bcd8739ae039).deepResearchRateLimitWarningDescription)));
};


























var $7MfQo = parcelRequire("7MfQo");


var $lqtHz = parcelRequire("lqtHz");





var $i1t43 = parcelRequire("i1t43");












var $anBbz = parcelRequire("anBbz");




















var $j9QuA = parcelRequire("j9QuA");


var $75YqA = parcelRequire("75YqA");
























var $hpa99 = parcelRequire("hpa99");































var $l3d45 = parcelRequire("l3d45");




const $abc11b9f023598d9$var$message = (0, $kSwu1.defineMessages)({
    incorrectFlagTitle: {
        id: "ai-mate.aup-feedback-banner.incorrect-flag-title",
        defaultMessage: "Did we flag your input incorrectly?"
    },
    incorrectFlagLabel: {
        id: "ai-mate.aup-feedback-banner.incorrect-flag-label",
        defaultMessage: "Additional feedback"
    },
    incorrectFlagTextareaLabel: {
        id: "ai-mate.aup-feedback-banner.incorrect-flag-textarea-label",
        defaultMessage: "Tell us more"
    },
    includeInputCheckbox: {
        id: "ai-mate.aup-feedback-banner.include-input-checkbox",
        defaultMessage: "Yes, include recent messages from this conversation to help Atlassian debug issues. Atlassian may contact me in order to debug the reported issue."
    },
    enrollInResearchCheckbox: {
        id: "ai-mate.aup-feedback-banner.enroll-in-research-checkbox",
        defaultMessage: "Yes, Atlassian may contact me to learn more about my experience and improve Atlassian apps and services. I acknowledge the {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "ai-mate.aup-feedback-banner.privacy-policy-link",
        defaultMessage: "Atlassian Privacy Policy"
    },
    submitButton: {
        id: "ai-mate.aup-feedback-banner.submit-button",
        defaultMessage: "Submit feedback"
    },
    thankYouMessage: {
        id: "ai-mate.aup-feedback-banner.thank-you-message",
        defaultMessage: "Thank you for your feedback!"
    },
    dismissBanner: {
        id: "ai-mate.aup-feedback-banner.dismiss-banner",
        defaultMessage: "Dismiss"
    },
    feedbackTextRequired: {
        id: "ai-mate.aup-feedback-banner.feedback-text-required",
        defaultMessage: "Please provide feedback before submitting"
    }
});
var $abc11b9f023598d9$export$2e2bcd8739ae039 = $abc11b9f023598d9$var$message;


const $ea5ed1f5786572e9$var$styles = {
    bannerContainer: "_0bjKvD8fU6 _30huDKOeNX _3138425zaO _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $ea5ed1f5786572e9$var$PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy';
const $ea5ed1f5786572e9$var$ThankYouMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { onDismiss: onDismiss } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).thankYouMessage);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            color: "color.text.subtle"
        }, t2));
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).dismissBanner);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== onDismiss || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t4,
            onClick: onDismiss,
            spacing: "compact",
            isTooltipDisabled: false
        });
        $[7] = onDismiss;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, t3, t5);
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).thankYouMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).dismissBanner),
        onClick: onDismiss,
        spacing: "compact",
        isTooltipDisabled: false
    }));
};
const $ea5ed1f5786572e9$export$57b8f6c1f0e22d09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(20);
    const { isVisible: isVisible, onSubmit: onSubmit, onDismiss: onDismiss, userEmail: userEmail, shouldHideCheckboxes: shouldHideCheckboxes } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [feedbackText, setFeedbackText] = (0, $cozmU.useState)("");
    const hideCheckboxes = shouldHideCheckboxes ?? false;
    let t0;
    if ($[0] !== userEmail) {
        t0 = (0, $l3d45.isAtlassianEmployee)(userEmail);
        $[0] = userEmail;
        $[1] = t0;
    } else t0 = $[1];
    const [includeInput, setIncludeInput] = (0, $cozmU.useState)(t0);
    const [enrollInResearch, setEnrollInResearch] = (0, $cozmU.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $cozmU.useState)(false);
    const [showValidationError, setShowValidationError] = (0, $cozmU.useState)(false);
    let t1;
    if ($[2] !== enrollInResearch || $[3] !== feedbackText || $[4] !== includeInput || $[5] !== onSubmit) {
        t1 = ()=>{
            if (!feedbackText.trim()) {
                setShowValidationError(true);
                return;
            }
            onSubmit({
                feedbackText: feedbackText,
                includeInput: includeInput,
                enrollInResearch: enrollInResearch
            });
            setHasSubmitted(true);
        };
        $[2] = enrollInResearch;
        $[3] = feedbackText;
        $[4] = includeInput;
        $[5] = onSubmit;
        $[6] = t1;
    } else t1 = $[6];
    const handleSubmit = t1;
    let t2;
    if ($[7] !== enrollInResearch || $[8] !== feedbackText || $[9] !== formatMessage || $[10] !== handleSubmit || $[11] !== hasSubmitted || $[12] !== hideCheckboxes || $[13] !== includeInput || $[14] !== isVisible || $[15] !== onDismiss || $[16] !== showValidationError) {
        t2 = isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            exitDirection: "top",
            duration: "large"
        }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true"
            }, hasSubmitted && formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).thankYouMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $ea5ed1f5786572e9$var$styles.bannerContainer
            }, hasSubmitted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea5ed1f5786572e9$var$ThankYouMessage, {
                onDismiss: onDismiss
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.100",
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).dismissBanner),
                onClick: onDismiss,
                spacing: "compact",
                isTooltipDisabled: false
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest",
                weight: "bold"
            }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagLabel), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                placeholder: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagTextareaLabel),
                value: feedbackText,
                onChange: (e)=>{
                    setFeedbackText(e.target.value);
                    setShowValidationError(false);
                },
                minimumRows: 2,
                "aria-label": formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagTextareaLabel),
                "aria-required": true,
                "aria-invalid": showValidationError
            }), showValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).feedbackTextRequired))), !hideCheckboxes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                label: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).includeInputCheckbox),
                isChecked: includeInput,
                onChange: (e_0)=>setIncludeInput(e_0.target.checked)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).enrollInResearchCheckbox, {
                    privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: $ea5ed1f5786572e9$var$PRIVACY_POLICY_URL,
                        target: "_blank"
                    }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).privacyPolicyLink))
                })),
                isChecked: enrollInResearch,
                onChange: (e_1)=>setEnrollInResearch(e_1.target.checked)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: handleSubmit,
                shouldFitContainer: true
            }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).submitButton))))));
        $[7] = enrollInResearch;
        $[8] = feedbackText;
        $[9] = formatMessage;
        $[10] = handleSubmit;
        $[11] = hasSubmitted;
        $[12] = hideCheckboxes;
        $[13] = includeInput;
        $[14] = isVisible;
        $[15] = onDismiss;
        $[16] = showValidationError;
        $[17] = t2;
    } else t2 = $[17];
    let t3;
    if ($[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, t2);
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : (props)=>{
    const { isVisible: isVisible, onSubmit: onSubmit, onDismiss: onDismiss, userEmail: userEmail, shouldHideCheckboxes: shouldHideCheckboxes } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [feedbackText, setFeedbackText] = (0, $cozmU.useState)('');
    const hideCheckboxes = shouldHideCheckboxes ?? false;
    const [includeInput, setIncludeInput] = (0, $cozmU.useState)((0, $l3d45.isAtlassianEmployee)(userEmail));
    const [enrollInResearch, setEnrollInResearch] = (0, $cozmU.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $cozmU.useState)(false);
    const [showValidationError, setShowValidationError] = (0, $cozmU.useState)(false);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if (!feedbackText.trim()) {
            setShowValidationError(true);
            return;
        }
        onSubmit({
            feedbackText: feedbackText,
            includeInput: includeInput,
            enrollInResearch: enrollInResearch
        });
        setHasSubmitted(true);
    }, [
        onSubmit,
        feedbackText,
        includeInput,
        enrollInResearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        exitDirection: "top",
        duration: "large"
    }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true"
        }, hasSubmitted && formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).thankYouMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ea5ed1f5786572e9$var$styles.bannerContainer
        }, hasSubmitted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea5ed1f5786572e9$var$ThankYouMessage, {
            onDismiss: onDismiss
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).dismissBanner),
            onClick: onDismiss,
            spacing: "compact",
            isTooltipDisabled: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold"
        }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagLabel), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            placeholder: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagTextareaLabel),
            value: feedbackText,
            onChange: (e)=>{
                setFeedbackText(e.target.value);
                setShowValidationError(false);
            },
            minimumRows: 2,
            "aria-label": formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).incorrectFlagTextareaLabel),
            "aria-required": true,
            "aria-invalid": showValidationError
        }), showValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).feedbackTextRequired))), !hideCheckboxes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).includeInputCheckbox),
            isChecked: includeInput,
            onChange: (e_0)=>setIncludeInput(e_0.target.checked)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).enrollInResearchCheckbox, {
                privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $ea5ed1f5786572e9$var$PRIVACY_POLICY_URL,
                    target: "_blank"
                }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).privacyPolicyLink))
            })),
            isChecked: enrollInResearch,
            onChange: (e_1)=>setEnrollInResearch(e_1.target.checked)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleSubmit,
            shouldFitContainer: true
        }, formatMessage((0, $abc11b9f023598d9$export$2e2bcd8739ae039).submitButton)))))));
};


/**
 * Categories shown in the AUP (Acceptable Use Policy) feedback flow when a
 * user reports a positive-side AUP issue.
 */ const $1e350535b54646f5$export$426b62157ef515db = [
    'helpful',
    'other'
];



var $3hnlP = parcelRequire("3hnlP");














const $1fdd24f25ced1cdc$export$dfb2ee2d9e73fa48 = (0, $kBr4q.createActionsHook)((0, $edfbad14347f2caa$export$6f57813fe9f31bf9));



var $5l24t = parcelRequire("5l24t");


var $3Ofxv = parcelRequire("3Ofxv");


var $4JJQd = parcelRequire("4JJQd");




const $e5d8cea29fc03f66$var$message = (0, $kSwu1.defineMessages)({
    reload: {
        id: "ai-mate.agent-message.error",
        defaultMessage: "Reload chat"
    },
    traceIdMessage: {
        id: "ai-mate.agent-message.error.trace-id",
        defaultMessage: "Trace ID: {traceId}"
    },
    copyTraceId: {
        id: "ai-mate.agent-message.error.copy-trace-id",
        defaultMessage: "Copy trace ID"
    },
    resend: {
        id: "ai-mate.agent-message.error.resend",
        defaultMessage: "Resend the message"
    },
    aupErrorMessagePartOne: {
        id: "ai-mate.agent-message.error.aup-one",
        defaultMessage: "We can\u2019t respond to that prompt."
    },
    aupErrorMessagePartTwo: {
        id: "ai-mate.agent-message.error.aup-two",
        defaultMessage: "Your prompt might not comply with our {link}. Try a different prompt."
    },
    aupLinkText: {
        id: "ai-mate.agent-message.error.aup-link-text",
        defaultMessage: "Acceptable Use Policy"
    },
    networkErrorMessage: {
        id: "ai-mate.agent-message.error.network-error",
        defaultMessage: "There seems to be a network problem."
    },
    clientNetworkErrorMessage: {
        id: "ai-mate.agent-message.error.client-network-error",
        defaultMessage: "Unable to connect to Rovo. Please check your network connection or VPN and try again."
    },
    productNotActiveErrorMessage: {
        id: "ai-mate.agent-message.error.product-not-active",
        defaultMessage: "Rovo is not enabled for your organization. Please contact your Atlassian admin to enable Rovo."
    },
    authErrorMessage: {
        id: "ai-mate.agent-message.error.auth-error",
        defaultMessage: "Your session has expired. Please sign out and sign back in to continue."
    },
    permissionErrorMessage: {
        id: "ai-mate.agent-message.error.permission-error",
        defaultMessage: "You don't have permission to use Rovo on this site. Please contact your Atlassian admin."
    },
    serverErrorMessage: {
        id: "conversation-assistant.chat-history.store-error.serverErrorMessage",
        defaultMessage: "Something went wrong. Please try again."
    },
    chatStreamTimeoutError: {
        id: "ai-mate.agent-message.error.stream-timeout",
        defaultMessage: "The response took too long and timed out."
    },
    // The same message id, English string, and translator description
    // are intentionally duplicated in
    // `@atlassian/rovo-platform-ui-components/src/ui/confluence-object-finalize-popup/messages.ts`
    // so the Rovo Chat error surface and the finalize-popup surface
    // share one translation entry. The English text must be inlined
    // as a string literal here (rather than referenced from a shared
    // constant) because babel-plugin-formatjs requires every value
    // inside a `defineMessages({...})` call to be a string literal at
    // extraction time — identifier references crash the plugin. Keep
    // both copies of this message block in sync.
    // See CCIMPORTER-3221 / CCIMPORTER-3249.
    approvalRequiredForFirstPublishErrorMessage: {
        id: "rovo-platform-ui-components.shared.error.approval-required-for-first-publish",
        defaultMessage: "This space requires approval before publishing new pages. Please submit the page for review."
    }
});
var $e5d8cea29fc03f66$export$2e2bcd8739ae039 = $e5d8cea29fc03f66$var$message;


const $b9daec6aed55b471$var$TraceIdViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { traceId: traceId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    let t2;
    if ($[0] !== sendAnalyticsEvent) {
        t1 = ()=>{
            sendAnalyticsEvent({
                eventType: "screen",
                name: "rovoErrorTraceIdViewer"
            });
        };
        t2 = [
            sendAnalyticsEvent
        ];
        $[0] = sendAnalyticsEvent;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== formatMessage || $[4] !== traceId) {
        t3 = formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).traceIdMessage, {
            traceId: traceId
        });
        $[3] = formatMessage;
        $[4] = traceId;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "semibold"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).copyTraceId);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== sendAnalyticsEvent || $[11] !== traceId) {
        t6 = (_, event)=>{
            sendAnalyticsEvent(event.update({
                actionSubjectId: "copyTraceIdButton"
            }));
            navigator.clipboard.writeText(traceId);
        };
        $[10] = sendAnalyticsEvent;
        $[11] = traceId;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t5 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            label: t5,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            onClick: t6
        });
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t4 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, t4, t7);
        $[16] = t4;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ traceId: traceId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoErrorTraceIdViewer'
        });
    }, [
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "semibold"
    }, formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).traceIdMessage, {
        traceId: traceId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        label: formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).copyTraceId),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
        onClick: (_, event)=>{
            sendAnalyticsEvent(event.update({
                actionSubjectId: 'copyTraceIdButton'
            }));
            navigator.clipboard.writeText(traceId);
        }
    }));
};
// Known client-side fetch error message patterns (browser-generated, never reach Atlassian servers)
const $b9daec6aed55b471$var$CLIENT_FETCH_ERROR_PATTERNS = [
    'Failed to fetch',
    'Load failed',
    'NetworkError',
    'Network request failed',
    'fetch is not defined'
];
const $b9daec6aed55b471$var$getErrorMessage = (content, status_code, message_template, errorType, formatMessage)=>{
    if (errorType === 'RovoChatStreamTimeoutError') return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).chatStreamTimeoutError);
    if ($b9daec6aed55b471$var$CLIENT_FETCH_ERROR_PATTERNS.some((pattern)=>content.includes(pattern))) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).clientNetworkErrorMessage);
    if (message_template === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).productNotActiveErrorMessage);
    if (status_code === 401) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).authErrorMessage);
    if (status_code === 403) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).permissionErrorMessage);
    if (content.includes('network error')) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).networkErrorMessage);
    // CCIMPORTER-3221: when the destination Confluence space requires approval
    // before publishing new pages for the first time, the convo-ai BE surfaces
    // HTTP 409 + the APPROVAL_REQUIRED_FOR_FIRST_PUBLISH token in the response
    // body (see CCIMPORTER-3249). The actionable copy remains controlled by
    // confluence_approvals_eap (experiment, isEnabled=true).
    if (status_code === 409 && content.includes((0, $j9QuA.APPROVAL_REQUIRED_FOR_FIRST_PUBLISH))) {
        // TODO CCIMPORTER-3221: register `confluence_approvals_eap` in
        // `@atlaskit/tmp-editor-statsig` (`experiments-config.ts`) so the
        // experiment id is known to TypeScript and this cast can be
        // removed. The experiment exists on the backend (CCIMPORTER-2017).
        if ((0, $anBbz.expValEqualsNoExposure)('confluence_approvals_eap', 'isEnabled', true)) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).approvalRequiredForFirstPublishErrorMessage);
    }
    if (status_code !== undefined && status_code >= 500) return formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).serverErrorMessage);
    return content;
};
const $b9daec6aed55b471$var$LiveStoreErrorView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(110);
    const { error: t1, onResendMessage: onResendMessage } = t0;
    const { id: id, content: content, traceId: traceId, message_template: message_template, status_code: status_code, errorType: errorType } = t1;
    (0, $6cFsl.di)((0, $iDrrr.fg));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const { profileData: t2, feedbackCollector: t3, productKey: productKey, assistanceServiceConfig: assistanceServiceConfig, siteId: siteId, experienceId: experienceId, productHeader: productHeader } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid, name: name, email: email } = t2;
    const { entryPointId: entryPointId } = t3;
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const feedbackTrigger = (0, $3Ofxv.useFeedbackTrigger)();
    let t4;
    if ($[0] !== content || $[1] !== errorType || $[2] !== formatMessage || $[3] !== message_template || $[4] !== status_code) {
        t4 = $b9daec6aed55b471$var$getErrorMessage(content, status_code, message_template, errorType, formatMessage);
        $[0] = content;
        $[1] = errorType;
        $[2] = formatMessage;
        $[3] = message_template;
        $[4] = status_code;
        $[5] = t4;
    } else t4 = $[5];
    const messageContent = t4;
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const feedbackActions = (0, $1fdd24f25ced1cdc$export$dfb2ee2d9e73fa48)();
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            touchpointSource: "error-message"
        };
        $[6] = t5;
    } else t5 = $[6];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t5);
    const { preferences: t6, setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt } = (0, $lTU4O.useUserPreferences)();
    const { hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt } = t6;
    let t7;
    if ($[7] !== assistanceServiceParams) {
        t7 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[7] = assistanceServiceParams;
        $[8] = t7;
    } else t7 = $[8];
    const { storeUserMessages: storeUserMessages, setStoreUserMessages: setStoreUserMessages } = (0, $hSR6U.useStoreUserMessagesPreference)(t7);
    const isAUPError = message_template === (0, $bxkJA.ACCEPTABLE_USE_VIOLATIONS_ERROR);
    const showResendMessage = !!onResendMessage;
    let t8;
    if ($[9] !== id) {
        t8 = {
            canAttachMessages: true,
            answerId: id
        };
        $[9] = id;
        $[10] = t8;
    } else t8 = $[10];
    const history = (0, $4JJQd.useMessageHistory)(t8);
    const thumbTriggerRef = (0, $cozmU.useRef)(null);
    const t9 = aaid ?? "unknown";
    const t10 = conversation?.id;
    const t11 = assistanceServiceConfig?.minionAlias;
    const t12 = assistanceServiceConfig?.channelId;
    let t13;
    if ($[11] !== email || $[12] !== entryPointId || $[13] !== experienceId || $[14] !== feedbackTrigger || $[15] !== history || $[16] !== id || $[17] !== isAUPError || $[18] !== name || $[19] !== productHeader || $[20] !== productKey || $[21] !== setStoreUserMessages || $[22] !== siteId || $[23] !== storeUserMessages || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t9 || $[28] !== traceId) {
        t13 = {
            entryPointId: entryPointId,
            aaid: t9,
            name: name,
            email: email,
            productKey: productKey,
            agentMessageId: id,
            conversationId: t10,
            history: history,
            traceId: traceId,
            isAUPError: isAUPError,
            minionAlias: t11,
            channelId: t12,
            storeUserMessages: storeUserMessages,
            siteId: siteId,
            experienceId: experienceId,
            productHeader: productHeader,
            setStoreUserMessages: setStoreUserMessages,
            feedbackTrigger: feedbackTrigger
        };
        $[11] = email;
        $[12] = entryPointId;
        $[13] = experienceId;
        $[14] = feedbackTrigger;
        $[15] = history;
        $[16] = id;
        $[17] = isAUPError;
        $[18] = name;
        $[19] = productHeader;
        $[20] = productKey;
        $[21] = setStoreUserMessages;
        $[22] = siteId;
        $[23] = storeUserMessages;
        $[24] = t10;
        $[25] = t11;
        $[26] = t12;
        $[27] = t9;
        $[28] = traceId;
        $[29] = t13;
    } else t13 = $[29];
    const { feedbackType: feedbackTypeV2, isBannerVisible: isBannerVisible, shouldHideCheckboxes: shouldHideCheckboxes, handleThumbClick: handleV2ThumbClick, handleProvideAdditionalFeedback: handleProvideAdditionalFeedback, handleFeedbackSubmit: handleFeedbackSubmit, handleDismissBanner: handleDismissBanner, handleIncludeMessagesChecked: handleIncludeMessagesChecked, handleOptIn: handleOptIn, isOptedIn: isOptedIn, isAUPThumbsDownBannerVisible: isAUPThumbsDownBannerVisible, showAUPThumbsDownBanner: showAUPThumbsDownBanner, hideAUPThumbsDownBanner: hideAUPThumbsDownBanner, handleAUPIncorrectFlagSubmit: handleAUPIncorrectFlagSubmit } = (0, $5l24t.useFeedbackV2)(t13);
    let t14;
    if ($[30] !== feedbackActions || $[31] !== handleV2ThumbClick || $[32] !== hideAUPThumbsDownBanner || $[33] !== id || $[34] !== isAUPError || $[35] !== showAUPThumbsDownBanner || $[36] !== trackAIMAUEvent) {
        t14 = (isLike)=>{
            thumbTriggerRef.current = (0, $1hQ0e.getDocument)()?.activeElement ?? null;
            if (isAUPError) {
                if (isLike) {
                    hideAUPThumbsDownBanner();
                    handleV2ThumbClick(true);
                } else {
                    handleV2ThumbClick(false);
                    showAUPThumbsDownBanner();
                }
                return;
            }
            feedbackActions.open({
                answerQuality: isLike ? "good" : "bad",
                feedbackSource: "errorMessageFeedback"
            });
            trackAIMAUEvent({
                type: "feedback",
                feedbackResult: isLike ? "up" : "down",
                proactive: false,
                singleInstrumentationID: id
            });
        };
        $[30] = feedbackActions;
        $[31] = handleV2ThumbClick;
        $[32] = hideAUPThumbsDownBanner;
        $[33] = id;
        $[34] = isAUPError;
        $[35] = showAUPThumbsDownBanner;
        $[36] = trackAIMAUEvent;
        $[37] = t14;
    } else t14 = $[37];
    const onThumbClick = t14;
    let t15;
    if ($[38] !== id || $[39] !== messageContent || $[40] !== trackAIMAUEvent) {
        t15 = ()=>{
            navigator.clipboard.writeText(messageContent.toString());
            trackAIMAUEvent({
                type: "actioned",
                actionResult: "copyButtonClicked",
                proactive: false,
                singleInstrumentationID: id
            });
        };
        $[38] = id;
        $[39] = messageContent;
        $[40] = trackAIMAUEvent;
        $[41] = t15;
    } else t15 = $[41];
    const onCopyClick = t15;
    let t16;
    if ($[42] !== id || $[43] !== trackAIMAUEvent) {
        t16 = (mode)=>{
            trackAIMAUEvent({
                type: "actioned",
                actionResult: mode,
                subjectId: "insertReplaceButton",
                proactive: false,
                singleInstrumentationID: id
            });
        };
        $[42] = id;
        $[43] = trackAIMAUEvent;
        $[44] = t16;
    } else t16 = $[44];
    const onClickInsertReplace = t16;
    let t17;
    if ($[45] !== formatMessage) {
        t17 = formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).aupLinkText);
        $[45] = formatMessage;
        $[46] = t17;
    } else t17 = $[46];
    let t18;
    if ($[47] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/acceptable-use-policy"
        }, t17);
        $[47] = t17;
        $[48] = t18;
    } else t18 = $[48];
    const aupLink = t18;
    let t19;
    if ($[49] !== formatMessage) {
        t19 = formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).aupErrorMessagePartOne);
        $[49] = formatMessage;
        $[50] = t19;
    } else t19 = $[50];
    let t20;
    if ($[51] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t19, " ");
        $[51] = t19;
        $[52] = t20;
    } else t20 = $[52];
    let t21;
    if ($[53] !== aupLink || $[54] !== formatMessage) {
        t21 = formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).aupErrorMessagePartTwo, {
            link: aupLink
        });
        $[53] = aupLink;
        $[54] = formatMessage;
        $[55] = t21;
    } else t21 = $[55];
    let t22;
    if ($[56] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t21);
        $[56] = t21;
        $[57] = t22;
    } else t22 = $[57];
    let t23;
    if ($[58] !== t20 || $[59] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t20, t22);
        $[58] = t20;
        $[59] = t22;
        $[60] = t23;
    } else t23 = $[60];
    const aupErrorMessage = t23;
    const t24 = isAUPError ? aupErrorMessage : messageContent;
    let t25;
    if ($[61] !== traceId) {
        t25 = !!traceId && (0, $iDrrr.fg)("rovo_chat_show_error_trace_id") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9daec6aed55b471$var$TraceIdViewer, {
            traceId: traceId
        });
        $[61] = traceId;
        $[62] = t25;
    } else t25 = $[62];
    let t26;
    if ($[63] !== formatMessage || $[64] !== isAUPError || $[65] !== onResendMessage || $[66] !== sendAnalyticsEvent || $[67] !== showResendMessage) {
        t26 = showResendMessage && !isAUPError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: (_, event)=>{
                sendAnalyticsEvent(event.update({
                    actionSubjectId: "resendMessageButton"
                }));
                onResendMessage();
            }
        }, formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).resend)));
        $[63] = formatMessage;
        $[64] = isAUPError;
        $[65] = onResendMessage;
        $[66] = sendAnalyticsEvent;
        $[67] = showResendMessage;
        $[68] = t26;
    } else t26 = $[68];
    const t27 = selectedAgent?.id;
    const t28 = isAUPError ? feedbackTypeV2 : undefined;
    let t29;
    if ($[69] !== messageContent || $[70] !== onClickInsertReplace || $[71] !== onCopyClick || $[72] !== onThumbClick || $[73] !== t27 || $[74] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75YqA.MessageFooterButtons), {
            hideThumbs: false,
            onThumbClick: onThumbClick,
            onCopyClick: onCopyClick,
            insertReplaceContent: messageContent,
            selectedAgentId: t27,
            onClickInsertReplace: onClickInsertReplace,
            feedbackType: t28
        });
        $[69] = messageContent;
        $[70] = onClickInsertReplace;
        $[71] = onCopyClick;
        $[72] = onThumbClick;
        $[73] = t27;
        $[74] = t28;
        $[75] = t29;
    } else t29 = $[75];
    let t30;
    if ($[76] !== feedbackTypeV2 || $[77] !== handleDismissBanner || $[78] !== handleFeedbackSubmit || $[79] !== handleIncludeMessagesChecked || $[80] !== handleOptIn || $[81] !== handleProvideAdditionalFeedback || $[82] !== hasSeenFeedbackOptInPrompt || $[83] !== isAUPError || $[84] !== isBannerVisible || $[85] !== isOptedIn || $[86] !== setHasSeenFeedbackOptInPrompt) {
        t30 = isAUPError && feedbackTypeV2 === "like" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3hnlP.FeedbackConfirmationBanner), {
            isVisible: isBannerVisible,
            feedbackType: "like",
            onProvideAdditionalFeedback: handleProvideAdditionalFeedback,
            onDismiss: ()=>{
                handleDismissBanner();
                thumbTriggerRef.current?.focus();
            },
            onSubmit: handleFeedbackSubmit,
            onIncludeMessagesChecked: handleIncludeMessagesChecked,
            customCategories: (0, $1e350535b54646f5$export$426b62157ef515db),
            onOptIn: handleOptIn,
            isOptedIn: isOptedIn,
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt,
            onOptInPromptActioned: setHasSeenFeedbackOptInPrompt ? ()=>setHasSeenFeedbackOptInPrompt(true) : undefined
        });
        $[76] = feedbackTypeV2;
        $[77] = handleDismissBanner;
        $[78] = handleFeedbackSubmit;
        $[79] = handleIncludeMessagesChecked;
        $[80] = handleOptIn;
        $[81] = handleProvideAdditionalFeedback;
        $[82] = hasSeenFeedbackOptInPrompt;
        $[83] = isAUPError;
        $[84] = isBannerVisible;
        $[85] = isOptedIn;
        $[86] = setHasSeenFeedbackOptInPrompt;
        $[87] = t30;
    } else t30 = $[87];
    let t31;
    if ($[88] !== email || $[89] !== handleAUPIncorrectFlagSubmit || $[90] !== hideAUPThumbsDownBanner || $[91] !== isAUPError || $[92] !== isAUPThumbsDownBannerVisible || $[93] !== shouldHideCheckboxes) {
        t31 = isAUPError && isAUPThumbsDownBannerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea5ed1f5786572e9$export$57b8f6c1f0e22d09), {
            isVisible: isAUPThumbsDownBannerVisible,
            onSubmit: handleAUPIncorrectFlagSubmit,
            onDismiss: ()=>{
                hideAUPThumbsDownBanner();
                thumbTriggerRef.current?.focus();
            },
            userEmail: email,
            shouldHideCheckboxes: shouldHideCheckboxes
        });
        $[88] = email;
        $[89] = handleAUPIncorrectFlagSubmit;
        $[90] = hideAUPThumbsDownBanner;
        $[91] = isAUPError;
        $[92] = isAUPThumbsDownBannerVisible;
        $[93] = shouldHideCheckboxes;
        $[94] = t31;
    } else t31 = $[94];
    let t32;
    if ($[95] !== t25 || $[96] !== t26 || $[97] !== t29 || $[98] !== t30 || $[99] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t25, t26, t29, t30, t31);
        $[95] = t25;
        $[96] = t26;
        $[97] = t29;
        $[98] = t30;
        $[99] = t31;
        $[100] = t32;
    } else t32 = $[100];
    let t33;
    if ($[101] !== isAUPError || $[102] !== t24 || $[103] !== t32) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.PaperErrorMessage), {
            hideIcon: isAUPError,
            message: t24,
            variant: "neutral",
            pinchCorner: "bottomLeft",
            contentUnder: t32
        });
        $[101] = isAUPError;
        $[102] = t24;
        $[103] = t32;
        $[104] = t33;
    } else t33 = $[104];
    let t34;
    if ($[105] !== displayFlag) {
        t34 = displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
            onDismissed: ()=>setDisplayFlag(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7MfQo.default), null));
        $[105] = displayFlag;
        $[106] = t34;
    } else t34 = $[106];
    let t35;
    if ($[107] !== t33 || $[108] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t33, t34);
        $[107] = t33;
        $[108] = t34;
        $[109] = t35;
    } else t35 = $[109];
    return t35;
} : ({ error: { id: id, content: content, traceId: traceId, message_template: message_template, status_code: status_code, errorType: errorType }, onResendMessage: onResendMessage })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const { profileData: { aaid: aaid, name: name, email: email }, feedbackCollector: { entryPointId: entryPointId }, productKey: productKey, assistanceServiceConfig: assistanceServiceConfig, siteId: siteId, experienceId: experienceId, productHeader: productHeader } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const feedbackTrigger = (0, $3Ofxv.useFeedbackTrigger)();
    const messageContent = $b9daec6aed55b471$var$getErrorMessage(content, status_code, message_template, errorType, formatMessage);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const feedbackActions = (0, $1fdd24f25ced1cdc$export$dfb2ee2d9e73fa48)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'error-message'
    });
    const { preferences: { hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt }, setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages, setStoreUserMessages: setStoreUserMessages } = (0, $hSR6U.useStoreUserMessagesPreference)({
        assistanceServiceParams: assistanceServiceParams
    });
    const isAUPError = message_template === (0, $bxkJA.ACCEPTABLE_USE_VIOLATIONS_ERROR);
    const showResendMessage = !!onResendMessage;
    const history = (0, $4JJQd.useMessageHistory)({
        canAttachMessages: true,
        answerId: id
    });
    const thumbTriggerRef = (0, $cozmU.useRef)(null);
    const { feedbackType: feedbackTypeV2, isBannerVisible: isBannerVisible, shouldHideCheckboxes: shouldHideCheckboxes, handleThumbClick: handleV2ThumbClick, handleProvideAdditionalFeedback: handleProvideAdditionalFeedback, handleFeedbackSubmit: handleFeedbackSubmit, handleDismissBanner: handleDismissBanner, handleIncludeMessagesChecked: handleIncludeMessagesChecked, handleOptIn: handleOptIn, isOptedIn: isOptedIn, isAUPThumbsDownBannerVisible: isAUPThumbsDownBannerVisible, showAUPThumbsDownBanner: showAUPThumbsDownBanner, hideAUPThumbsDownBanner: hideAUPThumbsDownBanner, handleAUPIncorrectFlagSubmit: handleAUPIncorrectFlagSubmit } = (0, $5l24t.useFeedbackV2)({
        entryPointId: entryPointId,
        aaid: aaid ?? 'unknown',
        name: name,
        email: email,
        productKey: productKey,
        agentMessageId: id,
        conversationId: conversation?.id,
        history: history,
        traceId: traceId,
        isAUPError: isAUPError,
        minionAlias: assistanceServiceConfig?.minionAlias,
        channelId: assistanceServiceConfig?.channelId,
        storeUserMessages: storeUserMessages,
        siteId: siteId,
        experienceId: experienceId,
        productHeader: productHeader,
        setStoreUserMessages: setStoreUserMessages,
        feedbackTrigger: feedbackTrigger
    });
    const onThumbClick = (isLike)=>{
        thumbTriggerRef.current = (0, $1hQ0e.getDocument)()?.activeElement ?? null;
        if (isAUPError) {
            if (isLike) {
                hideAUPThumbsDownBanner();
                handleV2ThumbClick(true);
            } else {
                handleV2ThumbClick(false);
                showAUPThumbsDownBanner();
            }
            return;
        }
        feedbackActions.open({
            answerQuality: isLike ? 'good' : 'bad',
            feedbackSource: 'errorMessageFeedback'
        });
        trackAIMAUEvent({
            type: 'feedback',
            feedbackResult: isLike ? 'up' : 'down',
            proactive: false,
            singleInstrumentationID: id
        });
    };
    const onCopyClick = (0, $cozmU.useCallback)(()=>{
        navigator.clipboard.writeText(messageContent.toString());
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'copyButtonClicked',
            proactive: false,
            singleInstrumentationID: id
        });
    }, [
        messageContent,
        trackAIMAUEvent,
        id
    ]);
    const onClickInsertReplace = (0, $cozmU.useCallback)((mode)=>{
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: mode,
            subjectId: 'insertReplaceButton',
            proactive: false,
            singleInstrumentationID: id
        });
    }, [
        id,
        trackAIMAUEvent
    ]);
    const aupLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://www.atlassian.com/legal/acceptable-use-policy"
    }, formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).aupLinkText));
    const aupErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).aupErrorMessagePartOne), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).aupErrorMessagePartTwo, {
        link: aupLink
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.PaperErrorMessage), {
        hideIcon: isAUPError,
        message: isAUPError ? aupErrorMessage : messageContent,
        variant: "neutral",
        pinchCorner: "bottomLeft",
        contentUnder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, !!traceId && (0, $iDrrr.fg)('rovo_chat_show_error_trace_id') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9daec6aed55b471$var$TraceIdViewer, {
            traceId: traceId
        }), showResendMessage && !isAUPError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: (_, event)=>{
                sendAnalyticsEvent(event.update({
                    actionSubjectId: 'resendMessageButton'
                }));
                onResendMessage();
            }
        }, formatMessage((0, $e5d8cea29fc03f66$export$2e2bcd8739ae039).resend))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75YqA.MessageFooterButtons), {
            hideThumbs: false,
            onThumbClick: onThumbClick,
            onCopyClick: onCopyClick,
            insertReplaceContent: messageContent,
            selectedAgentId: selectedAgent?.id,
            onClickInsertReplace: onClickInsertReplace,
            feedbackType: isAUPError ? feedbackTypeV2 : undefined
        }), isAUPError && feedbackTypeV2 === 'like' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3hnlP.FeedbackConfirmationBanner), {
            isVisible: isBannerVisible,
            feedbackType: "like",
            onProvideAdditionalFeedback: handleProvideAdditionalFeedback,
            onDismiss: ()=>{
                handleDismissBanner();
                thumbTriggerRef.current?.focus();
            },
            onSubmit: handleFeedbackSubmit,
            onIncludeMessagesChecked: handleIncludeMessagesChecked,
            customCategories: (0, $1e350535b54646f5$export$426b62157ef515db),
            onOptIn: handleOptIn,
            isOptedIn: isOptedIn,
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt,
            onOptInPromptActioned: setHasSeenFeedbackOptInPrompt ? ()=>setHasSeenFeedbackOptInPrompt(true) : undefined
        }), isAUPError && isAUPThumbsDownBannerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea5ed1f5786572e9$export$57b8f6c1f0e22d09), {
            isVisible: isAUPThumbsDownBannerVisible,
            onSubmit: handleAUPIncorrectFlagSubmit,
            onDismiss: ()=>{
                hideAUPThumbsDownBanner();
                thumbTriggerRef.current?.focus();
            },
            userEmail: email,
            shouldHideCheckboxes: shouldHideCheckboxes
        }))
    }), displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7MfQo.default), null)));
};
const $b9daec6aed55b471$export$6a7b965325ceca4e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    if (props.interactionMode === "read-only") return null;
    let t0;
    if ($[0] !== props.error || $[1] !== props.onResendMessage) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9daec6aed55b471$var$LiveStoreErrorView, {
            error: props.error,
            onResendMessage: props.onResendMessage
        });
        $[0] = props.error;
        $[1] = props.onResendMessage;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    if (props.interactionMode === 'read-only') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9daec6aed55b471$var$LiveStoreErrorView, {
        error: props.error,
        onResendMessage: props.onResendMessage
    });
};






























const $717428f3bbae34de$var$message = (0, $kSwu1.defineMessages)({
    enforcementMessage: {
        id: "conversation-assistant.guard-block.enforcement-message-nonfinal",
        defaultMessage: "Blocked by your organization"
    },
    blockedResponseBody: {
        id: "conversation-assistant.guard-block.blocked-response-body-nonfinal",
        defaultMessage: "This prompt was blocked because it may conflict with your organization's AI or data use policies."
    },
    blockedResponseBodyResponseBlocked: {
        id: "conversation-assistant.guard-block.blocked-response-body-response-blocked-nonfinal",
        defaultMessage: "This response was blocked because it may conflict with your organization's AI or data use policies."
    },
    traceId: {
        id: "conversation-assistant.guard-block.trace-id-nonfinal",
        defaultMessage: "Trace ID: {traceId}"
    }
});
var $717428f3bbae34de$export$2e2bcd8739ae039 = $717428f3bbae34de$var$message;


const $97afedb3df0dd34f$var$styles = {
    container: "_4c065U8HPE",
    enforcementRow: "_2sNsIg7NXe _1UtDYzZpcK",
    bodyText: "_2sNsIg7NXe _1UtDYzZpcK",
    traceIdRow: "_2sNsIg7NXe _1UtDYzKGUX"
}; /**
    * Renders the Guard block experience — shown when a user's prompt is blocked
    * by an Atlassian Guard data protection policy.
    */ 
const $97afedb3df0dd34f$var$GuardBlockPresentation = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { traceId: traceId, blockType: blockType } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== blockType || $[1] !== formatMessage) {
        t1 = blockType === "RESPONSE_BLOCKED" ? formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).blockedResponseBodyResponseBlocked) : formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).blockedResponseBody);
        $[0] = blockType;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const bodyMessage = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.GuardIcon), {
            appearance: "brand",
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).enforcementMessage);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            xcss: $97afedb3df0dd34f$var$styles.enforcementRow
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== bodyMessage) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97afedb3df0dd34f$var$styles.bodyText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, bodyMessage));
        $[8] = bodyMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== formatMessage || $[11] !== traceId) {
        t6 = traceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97afedb3df0dd34f$var$styles.traceIdRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).traceId, {
            traceId: traceId
        })));
        $[10] = formatMessage;
        $[11] = traceId;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97afedb3df0dd34f$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t4, t5, t6));
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ traceId: traceId, blockType: blockType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const bodyMessage = blockType === 'RESPONSE_BLOCKED' ? formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).blockedResponseBodyResponseBlocked) : formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).blockedResponseBody);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $97afedb3df0dd34f$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        xcss: $97afedb3df0dd34f$var$styles.enforcementRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.GuardIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).enforcementMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $97afedb3df0dd34f$var$styles.bodyText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, bodyMessage)), traceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $97afedb3df0dd34f$var$styles.traceIdRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $717428f3bbae34de$export$2e2bcd8739ae039).traceId, {
        traceId: traceId
    })))));
};
const $97afedb3df0dd34f$export$b746be8a0467c8eb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    if (props.interactionMode === "read-only") return null;
    let t0;
    if ($[0] !== props.blockType || $[1] !== props.traceId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97afedb3df0dd34f$var$GuardBlockPresentation, {
            traceId: props.traceId,
            blockType: props.blockType
        });
        $[0] = props.blockType;
        $[1] = props.traceId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    if (props.interactionMode === 'read-only') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97afedb3df0dd34f$var$GuardBlockPresentation, {
        traceId: props.traceId,
        blockType: props.blockType
    });
};



var $ari4I = parcelRequire("ari4I");





























var $cUElk = parcelRequire("cUElk");





























var $3xwCI = parcelRequire("3xwCI");













var $l65d3 = parcelRequire("l65d3");




const $eeaf13fd74233d52$var$messages = (0, $kSwu1.defineMessages)({
    createPromptLabel: {
        id: "ai-mate.conversation-assistant.store-human.content-container.createPromptLabel",
        defaultMessage: "Save prompt"
    },
    rewriteTooltip: {
        id: "ai-mate.conversation-assistant.store-human.content-container.rewriteTooltip",
        defaultMessage: "Re-write"
    }
});
var $eeaf13fd74233d52$export$2e2bcd8739ae039 = $eeaf13fd74233d52$var$messages;


const $73fbbc842809c373$var$styles = {
    wrapper: "_39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLz9WS _0Of8r28HPE",
    wrapperWithButtonOverflow: "_1wydGW2ADO",
    contentWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _39xV02N91d",
    paper: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbvbI6 _3W2Oc8wPeg _4ouGXIdnbC _1ANEUSLRg7 _1EqgXlN91d",
    actionButtons: "_23rrnH0bPn _4bt5LAYvD1 _2WAcuGYvD1 _1YKVNsdnbC _0jFU0VdnbC _0Of8r21Y8M _1wydGW1Y8M",
    copyIconLeft: "_23rrnH0bPn _0adFHs1Y8M _1YKVNsdnbC"
};
const $73fbbc842809c373$export$9d2b4227a95687cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { children: children, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onContentCopy: onContentCopy, onCreatePrompt: onCreatePrompt, onEditClick: onEditClick, shareSlot: shareSlot } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasOverflowActions = !!(onCreatePrompt || onEditClick);
    const t1 = hasOverflowActions && $73fbbc842809c373$var$styles.wrapperWithButtonOverflow;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($73fbbc842809c373$var$styles.wrapper, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== onMouseEnter) {
        t3 = ()=>{
            setIsHovered(true);
            onMouseEnter?.();
        };
        $[2] = onMouseEnter;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== onMouseLeave) {
        t4 = ()=>{
            setIsHovered(false);
            onMouseLeave?.();
        };
        $[4] = onMouseLeave;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== isHovered || $[7] !== onContentCopy || $[8] !== onCreatePrompt || $[9] !== onEditClick || $[10] !== shareSlot) {
        t5 = onContentCopy && !onCreatePrompt && !onEditClick && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $73fbbc842809c373$var$styles.copyIconLeft,
            style: {
                opacity: isHovered ? 1 : 0
            }
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $l65d3.CopyResponse), {
            onClick: onContentCopy,
            appearance: "subtle",
            spacing: "default",
            shape: "default"
        }), shareSlot));
        $[6] = isHovered;
        $[7] = onContentCopy;
        $[8] = onCreatePrompt;
        $[9] = onEditClick;
        $[10] = shareSlot;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== children || $[13] !== isHovered) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $73fbbc842809c373$var$styles.paper
        }, /*#__PURE__*/ $cozmU.createElement((0, $4NVkH.Paper), {
            variant: "accentV2",
            verticalSpace: false,
            pinchCorner: "bottomRight",
            isHovered: isHovered
        }, children));
        $[12] = children;
        $[13] = isHovered;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $73fbbc842809c373$var$styles.contentWrapper
        }, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== formatMessage || $[19] !== hasOverflowActions || $[20] !== isHovered || $[21] !== onContentCopy || $[22] !== onCreatePrompt || $[23] !== onEditClick || $[24] !== shareSlot) {
        t8 = hasOverflowActions && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $73fbbc842809c373$var$styles.actionButtons,
            style: {
                opacity: isHovered ? 1 : 0
            }
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, onEditClick && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            type: "button",
            onClick: onEditClick,
            icon: $73fbbc842809c373$var$_temp,
            appearance: "subtle",
            spacing: "default",
            label: formatMessage((0, $eeaf13fd74233d52$export$2e2bcd8739ae039).rewriteTooltip),
            shape: "default"
        }), onContentCopy && /*#__PURE__*/ $cozmU.createElement((0, $l65d3.CopyResponse), {
            onClick: onContentCopy,
            appearance: "subtle",
            spacing: "default",
            shape: "default"
        }), shareSlot, onCreatePrompt && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            type: "button",
            onClick: onCreatePrompt,
            icon: $73fbbc842809c373$var$_temp2,
            appearance: "subtle",
            spacing: "default",
            label: formatMessage((0, $eeaf13fd74233d52$export$2e2bcd8739ae039).createPromptLabel),
            shape: "default"
        })));
        $[18] = formatMessage;
        $[19] = hasOverflowActions;
        $[20] = isHovered;
        $[21] = onContentCopy;
        $[22] = onCreatePrompt;
        $[23] = onEditClick;
        $[24] = shareSlot;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t7 || $[30] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t2,
            onMouseEnter: t3,
            onMouseLeave: t4
        }, t7, t8);
        $[26] = t2;
        $[27] = t3;
        $[28] = t4;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    return t9;
} : ({ children: children, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onContentCopy: onContentCopy, onCreatePrompt: onCreatePrompt, onEditClick: onEditClick, shareSlot: shareSlot })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasOverflowActions = !!(onCreatePrompt || onEditClick);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($73fbbc842809c373$var$styles.wrapper, hasOverflowActions && $73fbbc842809c373$var$styles.wrapperWithButtonOverflow),
        onMouseEnter: ()=>{
            setIsHovered(true);
            onMouseEnter?.();
        },
        onMouseLeave: ()=>{
            setIsHovered(false);
            onMouseLeave?.();
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $73fbbc842809c373$var$styles.contentWrapper
    }, onContentCopy && !onCreatePrompt && !onEditClick && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $73fbbc842809c373$var$styles.copyIconLeft,
        style: {
            opacity: isHovered ? 1 : 0
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $l65d3.CopyResponse), {
        onClick: onContentCopy,
        appearance: 'subtle',
        spacing: 'default',
        shape: 'default'
    }), shareSlot)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $73fbbc842809c373$var$styles.paper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4NVkH.Paper), {
        variant: "accentV2",
        verticalSpace: false,
        pinchCorner: "bottomRight",
        isHovered: isHovered
    }, children))), hasOverflowActions && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $73fbbc842809c373$var$styles.actionButtons,
        style: {
            opacity: isHovered ? 1 : 0
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, onEditClick && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        type: "button",
        onClick: onEditClick,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #505258)"
            }),
        appearance: "subtle",
        spacing: "default",
        label: formatMessage((0, $eeaf13fd74233d52$export$2e2bcd8739ae039).rewriteTooltip),
        shape: "default"
    }), onContentCopy && /*#__PURE__*/ $cozmU.createElement((0, $l65d3.CopyResponse), {
        onClick: onContentCopy,
        appearance: 'subtle',
        spacing: 'default',
        shape: 'default'
    }), shareSlot, onCreatePrompt && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        type: "button",
        onClick: onCreatePrompt,
        icon: (iconProps_0)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yAls))), {
                ...iconProps_0,
                color: "var(--ds-icon-subtle, #505258)"
            }),
        appearance: "subtle",
        spacing: "default",
        label: formatMessage((0, $eeaf13fd74233d52$export$2e2bcd8739ae039).createPromptLabel),
        shape: "default"
    }))));
};
function $73fbbc842809c373$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
        ...iconProps,
        color: "var(--ds-icon-subtle, #505258)"
    });
}
function $73fbbc842809c373$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yAls))), {
        ...iconProps_0,
        color: "var(--ds-icon-subtle, #505258)"
    });
}















var $4kL8d = parcelRequire("4kL8d");


var $dTzKN = parcelRequire("dTzKN");

const $4fa645e3854b09bd$var$styles = {
    listWrapper: "_2mHwu81Y8M _1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNL7p2s _37wbyuz9WS _0xmtko1Y8M"
};
const $4fa645e3854b09bd$export$e9c72be02fdc486 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { files: files } = t0;
    const { blobUrls: blobUrls, isLoading: isLoading, fileObjects: fileObjects } = (0, $dTzKN.useFileThumbnails)(files);
    let t1;
    if ($[0] !== blobUrls || $[1] !== fileObjects || $[2] !== files || $[3] !== isLoading) {
        let t2;
        if ($[5] !== blobUrls || $[6] !== fileObjects || $[7] !== isLoading) {
            t2 = (file)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    as: "li",
                    key: file.id
                }, /*#__PURE__*/ $cozmU.createElement((0, $4kL8d.FileCard), {
                    fileName: file.name,
                    previewBlobUrl: file.id ? blobUrls[file.id] : undefined,
                    isPreviewLoading: file.id ? isLoading[file.id] : false,
                    fileObject: file.id ? fileObjects[file.id] : undefined
                }));
            $[5] = blobUrls;
            $[6] = fileObjects;
            $[7] = isLoading;
            $[8] = t2;
        } else t2 = $[8];
        t1 = files.map(t2);
        $[0] = blobUrls;
        $[1] = fileObjects;
        $[2] = files;
        $[3] = isLoading;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[9] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $4fa645e3854b09bd$var$styles.listWrapper
        }, t1);
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ files: files })=>{
    const { blobUrls: blobUrls, isLoading: isLoading, fileObjects: fileObjects } = (0, $dTzKN.useFileThumbnails)(files);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $4fa645e3854b09bd$var$styles.listWrapper
    }, files.map((file)=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            key: file.id
        }, /*#__PURE__*/ $cozmU.createElement((0, $4kL8d.FileCard), {
            fileName: file.name,
            previewBlobUrl: file.id ? blobUrls[file.id] : undefined,
            isPreviewLoading: file.id ? isLoading[file.id] : false,
            fileObject: file.id ? fileObjects[file.id] : undefined
        }));
    }));
};





























const $47064abfa2ad39d7$export$3f1805dae3712357 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { initialPromptText: initialPromptText, onClose: onClose } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            touchpointSource: "createPromptFromChatMessage"
        };
        $[0] = t1;
    } else t1 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t1);
    const { options: appOptions } = (0, $jsad9.useAppOptionsForSelect)(assistanceServiceParams);
    let t2;
    if ($[1] !== assistanceServiceParams) {
        t2 = {
            assistanceServiceParams: assistanceServiceParams,
            enabled: false
        };
        $[1] = assistanceServiceParams;
        $[2] = t2;
    } else t2 = $[2];
    const { refetch: refetchPrompts } = (0, $4Aef9.usePromptsController)(t2);
    let t3;
    if ($[3] !== assistanceServiceParams || $[4] !== refetchPrompts) {
        t3 = {
            assistanceServiceParams: assistanceServiceParams,
            refetchPrompts: refetchPrompts
        };
        $[3] = assistanceServiceParams;
        $[4] = refetchPrompts;
        $[5] = t3;
    } else t3 = $[5];
    const { handleCreatePrompt: handleCreatePrompt } = (0, $8kqBU.useCreatePrompt)(t3);
    let t4;
    if ($[6] !== onClose || $[7] !== sendAnalyticsEvent) {
        t4 = ()=>{
            sendAnalyticsEvent({
                action: "created",
                actionSubject: "prompt",
                actionSubjectId: "promptCreatedFromChatMessage"
            });
            onClose();
        };
        $[6] = onClose;
        $[7] = sendAnalyticsEvent;
        $[8] = t4;
    } else t4 = $[8];
    const handleCreateSuccess = t4;
    let t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        t6 = [];
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== initialPromptText) {
        t7 = {
            title: "",
            prompt: initialPromptText,
            useCase: null,
            role: t5,
            app: t6
        };
        $[11] = initialPromptText;
        $[12] = t7;
    } else t7 = $[12];
    const initialPromptData = t7;
    const t8 = appOptions.length > 0 ? appOptions : undefined;
    let t9;
    if ($[13] !== handleCreatePrompt) {
        t9 = async (data)=>{
            const result = await handleCreatePrompt(data);
            return {
                ...data,
                shareId: result.id,
                ownerName: result.creator?.name
            };
        };
        $[13] = handleCreatePrompt;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== handleCreateSuccess || $[16] !== initialPromptData || $[17] !== onClose || $[18] !== t8 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQZgt.CreatePromptModal), {
            appOptions: t8,
            initialData: initialPromptData,
            isOpen: true,
            onClose: onClose,
            onCreate: t9,
            onCreateSuccess: handleCreateSuccess
        });
        $[15] = handleCreateSuccess;
        $[16] = initialPromptData;
        $[17] = onClose;
        $[18] = t8;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
} : ({ initialPromptText: initialPromptText, onClose: onClose })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'createPromptFromChatMessage'
    });
    const { options: appOptions } = (0, $jsad9.useAppOptionsForSelect)(assistanceServiceParams);
    const { refetch: refetchPrompts } = (0, $4Aef9.usePromptsController)({
        assistanceServiceParams: assistanceServiceParams,
        enabled: false
    });
    const { handleCreatePrompt: handleCreatePrompt } = (0, $8kqBU.useCreatePrompt)({
        assistanceServiceParams: assistanceServiceParams,
        refetchPrompts: refetchPrompts
    });
    const handleCreateSuccess = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'created',
            actionSubject: 'prompt',
            actionSubjectId: 'promptCreatedFromChatMessage'
        });
        onClose();
    }, [
        sendAnalyticsEvent,
        onClose
    ]);
    const initialPromptData = (0, $cozmU.useMemo)(()=>({
            title: '',
            prompt: initialPromptText,
            useCase: null,
            role: [],
            app: []
        }), [
        initialPromptText
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQZgt.CreatePromptModal), {
        appOptions: appOptions.length > 0 ? appOptions : undefined,
        initialData: initialPromptData,
        isOpen: true,
        onClose: onClose,
        onCreate: async (data)=>{
            const result = await handleCreatePrompt(data);
            return {
                ...data,
                shareId: result.id,
                ownerName: result.creator?.name
            };
        },
        onCreateSuccess: handleCreateSuccess
    });
};








const $e9f9f93412be66bf$export$bbc0343203048a72 = (node)=>{
    if (!node) return '';
    if (node.type === 'text') return node.text || '';
    if (node.type === 'inlineExtension' && node.attrs && (0, $8lhhf.isSkillTagExtension)(node.attrs?.extensionType, node.attrs?.extensionKey)) return node.attrs?.parameters?.slug || '';
    // Smart-link cards carry no text node but ContentRenderer can render them.
    // Surface the URL so `isMessageEmpty` keeps the bubble; a missing URL still
    // returns a non-empty sentinel so a malformed-but-renderable card isn't dropped.
    if ((0, $cXtTj.default).getExperimentValue('rovo_chat_render_card_only_human_messages', 'isEnabled', false) && (node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard')) {
        const url = typeof node.attrs?.url === 'string' ? node.attrs.url : '';
        return url || ' ';
    }
    if (Array.isArray(node.content)) return node.content.map($e9f9f93412be66bf$export$bbc0343203048a72).join('');
    return '';
};


/* InlineEditPromptEditor.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $3u5lg = parcelRequire("3u5lg");















var $3eqaf = parcelRequire("3eqaf");





var $j4TFB = parcelRequire("j4TFB");

















const $69ee7e56f5c6e957$var$messages = (0, $kSwu1.defineMessages)({
    updatePromptHint: {
        id: "ai-mate.conversation-assistant.store-human.inline-edit.updatePromptHint",
        defaultMessage: "Rovo will rewrite its response based on your update."
    },
    cancelLabel: {
        id: "ai-mate.conversation-assistant.store-human.inline-edit.cancelLabel",
        defaultMessage: "Cancel"
    },
    updateLabel: {
        id: "ai-mate.conversation-assistant.store-human.inline-edit.updateLabel",
        defaultMessage: "Update"
    }
});
var $69ee7e56f5c6e957$export$2e2bcd8739ae039 = $69ee7e56f5c6e957$var$messages;


const $2d6913a784557ac9$var$NOOP = ()=>{};
const $2d6913a784557ac9$var$styles = {
    wrapper: "_0bjKvDyzSk _39xV02N91d _0KLXrunmFW _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    editorContainer: "_3FJdHB8fU6 _47fESI2ADO _0wfTsvYbGa _3mjvYCIZbP _4xl0sI7Cj1 _3zFdeb2ADO _3hAf5ZPgdg _1W7PupPgdg _43HV2ePgdg _17l6pcPgdg _1bai7xPgdg _1VNMKDPgdg _0Lkh6hoWWg _38L5hvYbGa _4bMpaeLylE",
    updatePromptHint: "_2sNsIg7NXe _1UtDYzKGUX",
    actionRow: "_0LQT5E2ADO",
    updateButtonRadius: "_2mpnYbKTcp"
};
const $2d6913a784557ac9$export$e9e976b9a476e38d = ({ conversationId: conversationId, initialContent: initialContent, onCancel: onCancel, onUpdate: onUpdate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { productKey: productKey, siteId: siteId, orgId: orgId } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    });
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'chatInput'
    }); // Normalize the prop once: callers may pass either an ADF DocNode (the
    // common case — content captured by the composer) or a plain string
    // (legacy / server-restored history).
    const initialPrompt = (0, $cozmU.useMemo)(()=>(0, $6rwn6.encodeAdf)(initialContent), [
        initialContent
    ]);
    const [currentPrompt, setCurrentPrompt] = (0, $cozmU.useState)(initialPrompt);
    const isPromptSubmittable = (0, $cozmU.useCallback)((prompt)=>{
        if (!prompt) return false;
        if ((0, $e9f9f93412be66bf$export$bbc0343203048a72)(prompt).trim().length === 0) return false;
        return !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prompt, initialPrompt);
    }, [
        initialPrompt
    ]);
    const isSubmitDisabled = (0, $cozmU.useMemo)(()=>!isPromptSubmittable(currentPrompt), [
        currentPrompt,
        isPromptSubmittable
    ]);
    const sessionId = (0, $cozmU.useId)();
    const promptDraftAndModeKey = `${conversationId}-inline-edit-${sessionId}`;
    const hasSeededRef = (0, $cozmU.useRef)(false);
    if (!hasSeededRef.current) {
        hasSeededRef.current = true;
        (0, $j4TFB.setDraftMessage)(promptDraftAndModeKey, initialPrompt);
    } // Clear our entry on unmount; `promptDraftAndModeKey` is unique per edit
    // session (`useId`), so without cleanup the drafts store would leak.
    (0, $cozmU.useEffect)(()=>{
        return ()=>(0, $j4TFB.setDraftMessage)(promptDraftAndModeKey, null);
    }, [
        promptDraftAndModeKey
    ]);
    const handleSubmit = (0, $cozmU.useCallback)((prompt_0)=>{
        if (isPromptSubmittable(prompt_0)) onUpdate(prompt_0);
    }, [
        isPromptSubmittable,
        onUpdate
    ]);
    const handleUpdateClick = (0, $cozmU.useCallback)(()=>{
        if (currentPrompt && isPromptSubmittable(currentPrompt)) onUpdate(currentPrompt);
    }, [
        currentPrompt,
        isPromptSubmittable,
        onUpdate
    ]);
    const handleWrapperKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Escape') {
            event.stopPropagation();
            onCancel();
        }
    }, [
        onCancel
    ]);
    const isConversationAgentic = !!selectedAgent && selectedAgent.named_id !== (0, $6iQ4q.DEFAULT_AGENT).named_id;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2d6913a784557ac9$var$styles.wrapper,
        onKeyDown: handleWrapperKeyDown
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2d6913a784557ac9$var$styles.editorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $3eqaf.RovoChatPromptInput), {
        productKey: productKey,
        siteId: siteId,
        orgId: orgId,
        assistanceServiceParams: assistanceServiceParams,
        arrowKeyPluginConfigMessages: [],
        promptDraftAndModeKey: promptDraftAndModeKey,
        isConversationAgentic: isConversationAgentic,
        isAgentTyping: false,
        onPromptChange: setCurrentPrompt,
        onSubmit: handleSubmit,
        onAbort: $2d6913a784557ac9$var$NOOP,
        showActionsButton: false,
        showChatModeMenu: false,
        showConnectorTip: false,
        useCurrentPageContext: false,
        enableBrowserContextBanner: false,
        isSpaceScopedConversation: false,
        enableVoiceDictation: false,
        disableWrapperMarginStyles: true,
        minHeight: 24
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.150",
        xcss: $2d6913a784557ac9$var$styles.actionRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2d6913a784557ac9$var$styles.updatePromptHint
    }, formatMessage((0, $69ee7e56f5c6e957$export$2e2bcd8739ae039).updatePromptHint)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onCancel,
        type: "button"
    }, formatMessage((0, $69ee7e56f5c6e957$export$2e2bcd8739ae039).cancelLabel)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2d6913a784557ac9$var$styles.updateButtonRadius
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleUpdateClick,
        isDisabled: isSubmitDisabled,
        type: "button"
    }, formatMessage((0, $69ee7e56f5c6e957$export$2e2bcd8739ae039).updateLabel)))))));
};



const $371af20e9bd45b7f$export$f4610a88b89838b = (message)=>{
    const { content: content, file_uploads: file_uploads } = message.content;
    if (file_uploads?.length) return false;
    if (content == null || content === '') return true;
    if (typeof content === 'object' && content.type === 'doc' && (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content) === '') return true;
    return false;
};


/* RedactedPromptContent.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $ic2nu = parcelRequire("ic2nu");


var $8dMxJ = parcelRequire("8dMxJ");


var $h8IcZ = parcelRequire("h8IcZ");

const $72163e6ddb737bfc$var$styles = {
    promptText: "_1UtDYze5R3 _1ANEUSzUZr _3W2Oc8wPeg",
    promptTextOnLight: "_1UtDYzy7kJ _1ANEUSzUZr _3W2Oc8wPeg",
    paragraph: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC"
}; // Backend may send either [REDACTED] or [REDACT] as the redaction placeholder.
const $72163e6ddb737bfc$var$REDACTED_TOKEN_PATTERN = /(\[REDACTED\]|\[REDACT\])/g;
const $72163e6ddb737bfc$export$1d1938d7eb6fd5f6 = ({ redactedPrompt: redactedPrompt, background: background = 'dark' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const ariaLabel = formatMessage((0, $ic2nu.messages).redactedAriaLabel);
    const processedLines = (0, $cozmU.useMemo)(()=>{
        let tokenIndex = 0;
        return redactedPrompt.split('\n').map((line)=>line.split($72163e6ddb737bfc$var$REDACTED_TOKEN_PATTERN).map((part)=>{
                if (/^\[REDACT(ED)?\]$/.test(part)) {
                    const delay = (0, $8dMxJ.PARAMS).delay + tokenIndex * ((0, $8dMxJ.PARAMS).duration + (0, $8dMxJ.PARAMS).cascadeOffset);
                    tokenIndex++;
                    return {
                        kind: 'scribble',
                        delay: delay
                    };
                }
                return {
                    kind: 'text',
                    text: part
                };
            }));
    }, [
        redactedPrompt
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: background === 'light' ? $72163e6ddb737bfc$var$styles.promptTextOnLight : $72163e6ddb737bfc$var$styles.promptText
    }, processedLines.map((parts, lineIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: lineIdx,
            as: "p",
            xcss: $72163e6ddb737bfc$var$styles.paragraph
        }, parts.map((part_0, partIdx)=>part_0.kind === 'scribble' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h8IcZ.RedactedToken), {
                key: partIdx,
                ariaLabel: ariaLabel,
                delay: part_0.delay
            }) : part_0.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                key: partIdx
            }, part_0.text)))));
};





const $9bad3f59ef13b10c$var$styles = {
    fileUploadWrapper: "_3iDTPbQ4SZ _37wbyuz9WS"
};
const $9bad3f59ef13b10c$var$HumanMessagePresentation = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { storeHuman: storeHuman, respondedAgentId: respondedAgentId, conversationId: conversationId, onMouseEnter: onMouseEnter, onContentCopy: onContentCopy, shareSlot: shareSlot, onCreatePrompt: onCreatePrompt, onEditClick: onEditClick, renderedContentRef: renderedContentRef, shouldRenderRedactionEnforcementMessage: shouldRenderRedactionEnforcementMessage } = t0;
    const { content: t1, redactedPrompt: redactedPrompt } = storeHuman;
    const { content: content, file_uploads: file_uploads } = t1;
    const { productKey: productKey, siteId: siteId, profileData: t2 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t2;
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    let t3;
    if ($[0] !== content) {
        t3 = ()=>{
            const plainText = typeof content === "object" && content.type === "doc" ? (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content) : content?.toString() ?? "";
            navigator.clipboard?.writeText(plainText);
        };
        $[0] = content;
        $[1] = t3;
    } else t3 = $[1];
    const copyContent = t3;
    if ((0, $371af20e9bd45b7f$export$f4610a88b89838b)(storeHuman)) return null;
    if (redactedPrompt && (0, $iDrrr.fg)("rovo-guard-ui-redaction-and-blocking")) {
        let t4;
        if ($[2] !== redactedPrompt) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72163e6ddb737bfc$export$1d1938d7eb6fd5f6), {
                redactedPrompt: redactedPrompt
            }));
            $[2] = redactedPrompt;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== shouldRenderRedactionEnforcementMessage) {
            t5 = shouldRenderRedactionEnforcementMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), null);
            $[4] = shouldRenderRedactionEnforcementMessage;
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] !== t4 || $[7] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
            $[6] = t4;
            $[7] = t5;
            $[8] = t6;
        } else t6 = $[8];
        return t6;
    }
    const t4 = onContentCopy ?? copyContent;
    const t5 = customHandlers?.handleDeepLinkClick;
    let t6;
    if ($[9] !== aaid || $[10] !== content || $[11] !== conversationId || $[12] !== productKey || $[13] !== respondedAgentId || $[14] !== siteId || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: content,
            productKey: productKey,
            siteId: siteId,
            aaid: aaid,
            theme: "inverse",
            conversationId: conversationId,
            onDeepLinkClick: t5,
            respondedAgentId: respondedAgentId
        });
        $[9] = aaid;
        $[10] = content;
        $[11] = conversationId;
        $[12] = productKey;
        $[13] = respondedAgentId;
        $[14] = siteId;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== renderedContentRef || $[18] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: renderedContentRef
        }, t6);
        $[17] = renderedContentRef;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== onCreatePrompt || $[21] !== onEditClick || $[22] !== onMouseEnter || $[23] !== shareSlot || $[24] !== t4 || $[25] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), {
            onMouseEnter: onMouseEnter,
            onContentCopy: t4,
            shareSlot: shareSlot,
            onCreatePrompt: onCreatePrompt,
            onEditClick: onEditClick
        }, t7);
        $[20] = onCreatePrompt;
        $[21] = onEditClick;
        $[22] = onMouseEnter;
        $[23] = shareSlot;
        $[24] = t4;
        $[25] = t7;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== file_uploads) {
        t9 = !!file_uploads?.length && (0, $iDrrr.fg)("rovo_enable_file_upload") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.400",
            xcss: $9bad3f59ef13b10c$var$styles.fileUploadWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fa645e3854b09bd$export$e9c72be02fdc486), {
            files: file_uploads
        }));
        $[27] = file_uploads;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== t8 || $[30] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[29] = t8;
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : ({ storeHuman: storeHuman, respondedAgentId: respondedAgentId, conversationId: conversationId, onMouseEnter: onMouseEnter, onContentCopy: onContentCopy, shareSlot: shareSlot, onCreatePrompt: onCreatePrompt, onEditClick: onEditClick, renderedContentRef: renderedContentRef, shouldRenderRedactionEnforcementMessage: shouldRenderRedactionEnforcementMessage })=>{
    const { content: { content: content, file_uploads: file_uploads }, redactedPrompt: redactedPrompt } = storeHuman;
    const { productKey: productKey, siteId: siteId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const copyContent = (0, $cozmU.useCallback)(()=>{
        const plainText = typeof content === 'object' && content.type === 'doc' ? (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content) : content?.toString() ?? '';
        navigator.clipboard?.writeText(plainText);
    }, [
        content
    ]);
    if ((0, $371af20e9bd45b7f$export$f4610a88b89838b)(storeHuman)) return null;
    if (redactedPrompt && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72163e6ddb737bfc$export$1d1938d7eb6fd5f6), {
        redactedPrompt: redactedPrompt
    })), shouldRenderRedactionEnforcementMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), {
        onMouseEnter: onMouseEnter,
        onContentCopy: onContentCopy ?? copyContent,
        shareSlot: shareSlot,
        onCreatePrompt: onCreatePrompt,
        onEditClick: onEditClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: content,
        productKey: productKey,
        siteId: siteId,
        aaid: aaid,
        theme: "inverse",
        conversationId: conversationId,
        onDeepLinkClick: customHandlers?.handleDeepLinkClick,
        respondedAgentId: respondedAgentId
    }))), !!file_uploads?.length && (0, $iDrrr.fg)('rovo_enable_file_upload') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.400",
        xcss: $9bad3f59ef13b10c$var$styles.fileUploadWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fa645e3854b09bd$export$e9c72be02fdc486), {
        files: file_uploads
    })));
};
const $9bad3f59ef13b10c$var$LiveHumanMessageBindings = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(66);
    const { storeHuman: storeHuman, onEditAndResend: onEditAndResend, respondedAgentId: respondedAgentId, shouldRenderRedactionEnforcementMessage: shouldRenderRedactionEnforcementMessage } = props;
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const [isCreatePromptModalOpen, setIsCreatePromptModalOpen] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const { content: content } = storeHuman.content;
    const { productKey: productKey, siteId: siteId, profileData: t0 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t0;
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const conversationId = conversation?.id ?? "";
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const isEditDisabled = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
    let t1;
    if ($[0] !== content) {
        t1 = ()=>{
            if (typeof content === "object" && content.type === "doc") return (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content);
            return content?.toString() ?? "";
        };
        $[0] = content;
        $[1] = t1;
    } else t1 = $[1];
    const getPlainTextClipboardContent = t1;
    let t2;
    if ($[2] !== aaid || $[3] !== productKey || $[4] !== sendAnalyticsEvent || $[5] !== siteId || $[6] !== storeHuman.content.id) {
        t2 = ()=>{
            sendAnalyticsEvent({
                action: "hovered",
                actionSubject: "button",
                actionSubjectId: "copyUserMessageButton",
                attributes: {
                    productKey: productKey,
                    siteId: siteId,
                    userId: aaid,
                    messageId: storeHuman.content.id
                }
            });
        };
        $[2] = aaid;
        $[3] = productKey;
        $[4] = sendAnalyticsEvent;
        $[5] = siteId;
        $[6] = storeHuman.content.id;
        $[7] = t2;
    } else t2 = $[7];
    const handleCopyButtonAppear = t2;
    let t3;
    if ($[8] !== aaid || $[9] !== getPlainTextClipboardContent || $[10] !== productKey || $[11] !== sendAnalyticsEvent || $[12] !== siteId || $[13] !== storeHuman.content.id) {
        t3 = async ()=>{
            let node = null;
            if (renderedContentRef.current) node = renderedContentRef.current;
            const plainTextClipboardContent = getPlainTextClipboardContent();
            const messageLength = plainTextClipboardContent.length;
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "copyUserMessageButton",
                attributes: {
                    productKey: productKey,
                    siteId: siteId,
                    userId: aaid,
                    messageId: storeHuman.content.id,
                    messageLength: messageLength
                }
            });
            try {
                if (node) {
                    const cleanedHTML = node.innerHTML.replace(/<p[^>]*>/g, "").replace(/<\/p>/g, "");
                    const htmlBlob = new Blob([
                        cleanedHTML
                    ], {
                        type: "text/html"
                    });
                    const textBlob = new Blob([
                        plainTextClipboardContent
                    ], {
                        type: "text/plain"
                    });
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            "text/html": htmlBlob,
                            "text/plain": textBlob
                        })
                    ]);
                } else await navigator.clipboard.writeText(plainTextClipboardContent);
            } catch  {
                await navigator.clipboard.writeText(plainTextClipboardContent);
            }
        };
        $[8] = aaid;
        $[9] = getPlainTextClipboardContent;
        $[10] = productKey;
        $[11] = sendAnalyticsEvent;
        $[12] = siteId;
        $[13] = storeHuman.content.id;
        $[14] = t3;
    } else t3 = $[14];
    const handleCopyClick = t3;
    let t4;
    if ($[15] !== getPlainTextClipboardContent) {
        t4 = getPlainTextClipboardContent();
        $[15] = getPlainTextClipboardContent;
        $[16] = t4;
    } else t4 = $[16];
    const messageText = t4;
    let t5;
    if ($[17] !== aaid || $[18] !== conversationId || $[19] !== productKey || $[20] !== sendAnalyticsEvent || $[21] !== siteId || $[22] !== storeHuman.content.id) {
        t5 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "editUserMessageButton",
                attributes: {
                    productKey: productKey,
                    siteId: siteId,
                    userId: aaid,
                    conversationId: conversationId,
                    messageId: storeHuman.content.id
                }
            });
            setIsEditing(true);
        };
        $[17] = aaid;
        $[18] = conversationId;
        $[19] = productKey;
        $[20] = sendAnalyticsEvent;
        $[21] = siteId;
        $[22] = storeHuman.content.id;
        $[23] = t5;
    } else t5 = $[23];
    const handleEditClick = t5;
    let t6;
    if ($[24] !== aaid || $[25] !== conversationId || $[26] !== productKey || $[27] !== sendAnalyticsEvent || $[28] !== siteId || $[29] !== storeHuman.content.id) {
        t6 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "cancelEditUserMessageButton",
                attributes: {
                    productKey: productKey,
                    siteId: siteId,
                    userId: aaid,
                    conversationId: conversationId,
                    messageId: storeHuman.content.id
                }
            });
            setIsEditing(false);
        };
        $[24] = aaid;
        $[25] = conversationId;
        $[26] = productKey;
        $[27] = sendAnalyticsEvent;
        $[28] = siteId;
        $[29] = storeHuman.content.id;
        $[30] = t6;
    } else t6 = $[30];
    const handleEditCancel = t6;
    let t7;
    let t8;
    if ($[31] !== isEditing || $[32] !== onEditAndResend) {
        t7 = ()=>{
            if (isEditing && !onEditAndResend) setIsEditing(false);
        };
        t8 = [
            isEditing,
            onEditAndResend
        ];
        $[31] = isEditing;
        $[32] = onEditAndResend;
        $[33] = t7;
        $[34] = t8;
    } else {
        t7 = $[33];
        t8 = $[34];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[35] !== aaid || $[36] !== conversationId || $[37] !== onEditAndResend || $[38] !== productKey || $[39] !== sendAnalyticsEvent || $[40] !== siteId || $[41] !== storeHuman.content.id) {
        t9 = (newPrompt)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "saveEditUserMessageButton",
                attributes: {
                    productKey: productKey,
                    siteId: siteId,
                    userId: aaid,
                    conversationId: conversationId,
                    messageId: storeHuman.content.id
                }
            });
            setIsEditing(false);
            onEditAndResend?.(newPrompt);
        };
        $[35] = aaid;
        $[36] = conversationId;
        $[37] = onEditAndResend;
        $[38] = productKey;
        $[39] = sendAnalyticsEvent;
        $[40] = siteId;
        $[41] = storeHuman.content.id;
        $[42] = t9;
    } else t9 = $[42];
    const handleEditUpdate = t9;
    if (isEditing && onEditAndResend) {
        const t10 = content;
        let t11;
        if ($[43] !== conversationId || $[44] !== handleEditCancel || $[45] !== handleEditUpdate || $[46] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d6913a784557ac9$export$e9e976b9a476e38d), {
                conversationId: conversationId,
                initialContent: t10,
                onCancel: handleEditCancel,
                onUpdate: handleEditUpdate
            });
            $[43] = conversationId;
            $[44] = handleEditCancel;
            $[45] = handleEditUpdate;
            $[46] = t10;
            $[47] = t11;
        } else t11 = $[47];
        return t11;
    }
    const t10 = conversation?.id;
    let t11;
    if ($[48] !== storeHuman.content.id) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cUElk.ShareUpToMessageButton), {
            messageId: storeHuman.content.id
        });
        $[48] = storeHuman.content.id;
        $[49] = t11;
    } else t11 = $[49];
    let t12;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $cXtTj.default).getExperimentValue("rovo_chat_prompt_library_v2_exp", "isEnabled", false) ? ()=>setIsCreatePromptModalOpen(true) : undefined;
        $[50] = t12;
    } else t12 = $[50];
    const t13 = onEditAndResend && !isEditDisabled ? handleEditClick : undefined;
    let t14;
    if ($[51] !== handleCopyButtonAppear || $[52] !== handleCopyClick || $[53] !== respondedAgentId || $[54] !== shouldRenderRedactionEnforcementMessage || $[55] !== storeHuman || $[56] !== t10 || $[57] !== t11 || $[58] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$HumanMessagePresentation, {
            storeHuman: storeHuman,
            respondedAgentId: respondedAgentId,
            conversationId: t10,
            onMouseEnter: handleCopyButtonAppear,
            onContentCopy: handleCopyClick,
            shareSlot: t11,
            onCreatePrompt: t12,
            onEditClick: t13,
            renderedContentRef: renderedContentRef,
            shouldRenderRedactionEnforcementMessage: shouldRenderRedactionEnforcementMessage
        });
        $[51] = handleCopyButtonAppear;
        $[52] = handleCopyClick;
        $[53] = respondedAgentId;
        $[54] = shouldRenderRedactionEnforcementMessage;
        $[55] = storeHuman;
        $[56] = t10;
        $[57] = t11;
        $[58] = t13;
        $[59] = t14;
    } else t14 = $[59];
    let t15;
    if ($[60] !== isCreatePromptModalOpen || $[61] !== messageText) {
        t15 = isCreatePromptModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47064abfa2ad39d7$export$3f1805dae3712357), {
            initialPromptText: messageText,
            onClose: ()=>setIsCreatePromptModalOpen(false)
        });
        $[60] = isCreatePromptModalOpen;
        $[61] = messageText;
        $[62] = t15;
    } else t15 = $[62];
    let t16;
    if ($[63] !== t14 || $[64] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t14, t15);
        $[63] = t14;
        $[64] = t15;
        $[65] = t16;
    } else t16 = $[65];
    return t16;
} : (props)=>{
    const { storeHuman: storeHuman, onEditAndResend: onEditAndResend, respondedAgentId: respondedAgentId, shouldRenderRedactionEnforcementMessage: shouldRenderRedactionEnforcementMessage } = props;
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const [isCreatePromptModalOpen, setIsCreatePromptModalOpen] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const { content: content } = storeHuman.content;
    const { productKey: productKey, siteId: siteId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const conversationId = conversation?.id ?? '';
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)(); // Edit pencil is disabled while the assistant is mid-stream; it re-enables
    // when status returns to idle (stream completed, user cancelled, or error).
    const isEditDisabled = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
    const getPlainTextClipboardContent = (0, $cozmU.useCallback)(()=>{
        if (typeof content === 'object' && content.type === 'doc') return (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content);
        return content?.toString() ?? '';
    }, [
        content
    ]);
    const handleCopyButtonAppear = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'copyUserMessageButton',
            attributes: {
                productKey: productKey,
                siteId: siteId,
                userId: aaid,
                messageId: storeHuman.content.id
            }
        });
    }, [
        productKey,
        siteId,
        aaid,
        storeHuman.content.id,
        sendAnalyticsEvent
    ]);
    const handleCopyClick = (0, $cozmU.useCallback)(async ()=>{
        let node = null;
        if (renderedContentRef.current) node = renderedContentRef.current;
        const plainTextClipboardContent = getPlainTextClipboardContent();
        const messageLength = plainTextClipboardContent.length;
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'copyUserMessageButton',
            attributes: {
                productKey: productKey,
                siteId: siteId,
                userId: aaid,
                messageId: storeHuman.content.id,
                messageLength: messageLength
            }
        });
        try {
            if (node) {
                let cleanedHTML = node.innerHTML.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '');
                const htmlBlob = new Blob([
                    cleanedHTML
                ], {
                    type: 'text/html'
                });
                const textBlob = new Blob([
                    plainTextClipboardContent
                ], {
                    type: 'text/plain'
                });
                await navigator.clipboard.write([
                    new ClipboardItem({
                        'text/html': htmlBlob,
                        'text/plain': textBlob
                    })
                ]);
            } else await navigator.clipboard.writeText(plainTextClipboardContent);
        } catch  {
            await navigator.clipboard.writeText(plainTextClipboardContent);
        }
    }, [
        getPlainTextClipboardContent,
        productKey,
        siteId,
        aaid,
        storeHuman.content.id,
        sendAnalyticsEvent
    ]);
    const messageText = (0, $cozmU.useMemo)(()=>getPlainTextClipboardContent(), [
        getPlainTextClipboardContent
    ]);
    const handleEditClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editUserMessageButton',
            attributes: {
                productKey: productKey,
                siteId: siteId,
                userId: aaid,
                conversationId: conversationId,
                messageId: storeHuman.content.id
            }
        });
        setIsEditing(true);
    }, [
        productKey,
        siteId,
        aaid,
        conversationId,
        storeHuman.content.id,
        sendAnalyticsEvent
    ]);
    const handleEditCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancelEditUserMessageButton',
            attributes: {
                productKey: productKey,
                siteId: siteId,
                userId: aaid,
                conversationId: conversationId,
                messageId: storeHuman.content.id
            }
        });
        setIsEditing(false);
    }, [
        productKey,
        siteId,
        aaid,
        conversationId,
        storeHuman.content.id,
        sendAnalyticsEvent
    ]); // If the bubble loses its edit affordance while editing (e.g. user sends a new
    // message from the main composer, so this is no longer the last human), flip
    // `isEditing` back to false so local state matches the now-unmounted editor.
    // This is a programmatic dismissal (not a user click), so we bypass
    // `handleEditCancel` to avoid emitting a misleading `clicked` analytics event.
    (0, $cozmU.useEffect)(()=>{
        if (isEditing && !onEditAndResend) setIsEditing(false);
    }, [
        isEditing,
        onEditAndResend
    ]);
    const handleEditUpdate = (0, $cozmU.useCallback)((newPrompt)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'saveEditUserMessageButton',
            attributes: {
                productKey: productKey,
                siteId: siteId,
                userId: aaid,
                conversationId: conversationId,
                messageId: storeHuman.content.id
            }
        });
        setIsEditing(false);
        onEditAndResend?.(newPrompt);
    }, [
        productKey,
        siteId,
        aaid,
        conversationId,
        storeHuman.content.id,
        sendAnalyticsEvent,
        onEditAndResend
    ]);
    if (isEditing && onEditAndResend) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d6913a784557ac9$export$e9e976b9a476e38d), {
        conversationId: conversationId,
        initialContent: content,
        onCancel: handleEditCancel,
        onUpdate: handleEditUpdate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$HumanMessagePresentation, {
        storeHuman: storeHuman,
        respondedAgentId: respondedAgentId,
        conversationId: conversation?.id,
        onMouseEnter: handleCopyButtonAppear,
        onContentCopy: handleCopyClick,
        shareSlot: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cUElk.ShareUpToMessageButton), {
            messageId: storeHuman.content.id
        }),
        onCreatePrompt: (0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) ? ()=>setIsCreatePromptModalOpen(true) : undefined,
        onEditClick: onEditAndResend && !isEditDisabled ? handleEditClick : undefined,
        renderedContentRef: renderedContentRef,
        shouldRenderRedactionEnforcementMessage: shouldRenderRedactionEnforcementMessage
    }), isCreatePromptModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47064abfa2ad39d7$export$3f1805dae3712357), {
        initialPromptText: messageText,
        onClose: ()=>setIsCreatePromptModalOpen(false)
    }));
};
const $9bad3f59ef13b10c$export$12d255d5177ce7be = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    if (!props.interactionMode) {
        let t0;
        if ($[0] !== props.onEditAndResend || $[1] !== props.respondedAgentId || $[2] !== props.storeHuman) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$LiveHumanMessageBindings, {
                storeHuman: props.storeHuman,
                onEditAndResend: props.onEditAndResend,
                respondedAgentId: props.respondedAgentId,
                shouldRenderRedactionEnforcementMessage: false
            });
            $[0] = props.onEditAndResend;
            $[1] = props.respondedAgentId;
            $[2] = props.storeHuman;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    const { interactionMode: interactionMode } = props;
    switch(interactionMode){
        case "live":
            {
                let t0;
                if ($[4] !== props.onEditAndResend || $[5] !== props.respondedAgentId || $[6] !== props.storeHuman) {
                    t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$LiveHumanMessageBindings, {
                        storeHuman: props.storeHuman,
                        onEditAndResend: props.onEditAndResend,
                        respondedAgentId: props.respondedAgentId,
                        shouldRenderRedactionEnforcementMessage: true
                    });
                    $[4] = props.onEditAndResend;
                    $[5] = props.respondedAgentId;
                    $[6] = props.storeHuman;
                    $[7] = t0;
                } else t0 = $[7];
                return t0;
            }
        case "read-only":
            {
                let t0;
                if ($[8] !== props.respondedAgentId || $[9] !== props.storeHuman) {
                    t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$HumanMessagePresentation, {
                        storeHuman: props.storeHuman,
                        respondedAgentId: props.respondedAgentId,
                        shouldRenderRedactionEnforcementMessage: true
                    });
                    $[8] = props.respondedAgentId;
                    $[9] = props.storeHuman;
                    $[10] = t0;
                } else t0 = $[10];
                return t0;
            }
        default:
            {
                const exhaustiveInteractionMode = interactionMode;
                return exhaustiveInteractionMode;
            }
    }
} : (props)=>{
    if (!props.interactionMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$LiveHumanMessageBindings, {
        storeHuman: props.storeHuman,
        onEditAndResend: props.onEditAndResend,
        respondedAgentId: props.respondedAgentId,
        shouldRenderRedactionEnforcementMessage: false
    });
    const { interactionMode: interactionMode } = props;
    switch(interactionMode){
        case 'live':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$LiveHumanMessageBindings, {
                storeHuman: props.storeHuman,
                onEditAndResend: props.onEditAndResend,
                respondedAgentId: props.respondedAgentId,
                shouldRenderRedactionEnforcementMessage: true
            });
        case 'read-only':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bad3f59ef13b10c$var$HumanMessagePresentation, {
                storeHuman: props.storeHuman,
                respondedAgentId: props.respondedAgentId,
                shouldRenderRedactionEnforcementMessage: true
            });
        default:
            {
                const exhaustiveInteractionMode = interactionMode;
                return exhaustiveInteractionMode;
            }
    }
});























const $01d21d7047cde703$var$message = (0, $kSwu1.defineMessages)({
    rateLimitWarning: {
        id: "chat-history.rate-limit-warning",
        defaultMessage: "Please wait {secondsRemaining, plural, one {# second} other {# seconds}}"
    },
    rateLimitWarningDescription: {
        id: "chat-history.rate-limit-warning-description",
        defaultMessage: "Messages are being sent too fast, please wait."
    }
});
var $01d21d7047cde703$export$2e2bcd8739ae039 = $01d21d7047cde703$var$message;


const $f7ea52eeb328a797$var$styles = {
    content: "_2Y7lL42ADO _0Of8r22ADO"
};
const $f7ea52eeb328a797$var$DISPLAY_DURATION_IN_SECONDS = 30;
const $f7ea52eeb328a797$export$f022303a2948cf96 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { removeRateLimiting: removeRateLimiting } = t0;
    const [secondsRemaining, setSecondsRemaining] = (0, $cozmU.useState)($f7ea52eeb328a797$var$DISPLAY_DURATION_IN_SECONDS);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const intervalRef = (0, $cozmU.useRef)();
    const timeoutRef = (0, $cozmU.useRef)();
    let t1;
    let t2;
    if ($[0] !== removeRateLimiting) {
        t1 = ()=>{
            timeoutRef.current = setTimeout(()=>{
                removeRateLimiting();
            }, $f7ea52eeb328a797$var$DISPLAY_DURATION_IN_SECONDS * 1000);
            intervalRef.current = setInterval(()=>{
                setSecondsRemaining($f7ea52eeb328a797$var$_temp);
            }, 1000);
            return ()=>{
                clearTimeout(timeoutRef.current);
                clearInterval(intervalRef.current);
            };
        };
        t2 = [
            removeRateLimiting
        ];
        $[0] = removeRateLimiting;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== formatMessage || $[4] !== secondsRemaining) {
        t3 = formatMessage((0, $01d21d7047cde703$export$2e2bcd8739ae039).rateLimitWarning, {
            secondsRemaining: secondsRemaining
        });
        $[3] = formatMessage;
        $[4] = secondsRemaining;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $01d21d7047cde703$export$2e2bcd8739ae039).rateLimitWarningDescription);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $f7ea52eeb328a797$var$styles.content,
            testId: "conversation-assistant.store-rate-limit-warning"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: t3
        }, t4));
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ removeRateLimiting: removeRateLimiting })=>{
    const [secondsRemaining, setSecondsRemaining] = (0, $cozmU.useState)($f7ea52eeb328a797$var$DISPLAY_DURATION_IN_SECONDS);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const intervalRef = (0, $cozmU.useRef)();
    const timeoutRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        timeoutRef.current = setTimeout(()=>{
            removeRateLimiting();
        }, $f7ea52eeb328a797$var$DISPLAY_DURATION_IN_SECONDS * 1000);
        intervalRef.current = setInterval(()=>{
            setSecondsRemaining((state)=>state - 1);
        }, 1000);
        return ()=>{
            clearTimeout(timeoutRef.current);
            clearInterval(intervalRef.current);
        };
    }, [
        removeRateLimiting
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f7ea52eeb328a797$var$styles.content,
        testId: "conversation-assistant.store-rate-limit-warning"
    }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
        appearance: "warning",
        secondaryText: formatMessage((0, $01d21d7047cde703$export$2e2bcd8739ae039).rateLimitWarning, {
            secondsRemaining: secondsRemaining
        })
    }, formatMessage((0, $01d21d7047cde703$export$2e2bcd8739ae039).rateLimitWarningDescription)));
};
function $f7ea52eeb328a797$var$_temp(state) {
    return state - 1;
}


















var $coqKO = parcelRequire("coqKO");





var $fjUOt = parcelRequire("fjUOt");

const $508054bea15a2c6a$export$41f43752e3744795 = (messages, messageId, text)=>{
    return messages.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) {
            const currentContent = chatItem.content?.message?.message?.content ?? '';
            return {
                ...chatItem,
                content: {
                    ...chatItem.content,
                    message: {
                        ...chatItem.content.message,
                        message: {
                            ...chatItem.content.message.message,
                            content: currentContent + text
                        }
                    }
                }
            };
        }
        return chatItem;
    });
};


const $75a2162b9fe8b765$var$useIsomorphicLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $75a2162b9fe8b765$var$consumeA2UIActionStream = async ({ generator: generator, onAgenticUi: onAgenticUi, onTextPart: onTextPart })=>{
    while(true){
        const { value: value, done: done } = await generator.next();
        if (done) return;
        if ((0, $bxkJA.isStreamAgenticUi)(value)) onAgenticUi({
            ...value.data,
            type: 'AGENTIC_UI'
        });
        else {
            // Unwrap SSE messages to check for text content (ANSWER_PART)
            const streamMessage = (0, $bxkJA.isSSEMessage)(value) ? value.data : value;
            if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) onTextPart(streamMessage.message.content);
        }
    }
};
const $75a2162b9fe8b765$var$toStructuredActionContent = (action, assistantMessageId)=>{
    const userActionContext = action.context ?? action.dataModel ?? {};
    return {
        data_parts_mime_type: 'application/json+a2ui',
        structured: true,
        data_parts: [
            {
                userAction: {
                    actionName: action.eventName,
                    context: {
                        ...userActionContext,
                        assistantMessageId: assistantMessageId
                    }
                }
            }
        ]
    };
};
const $75a2162b9fe8b765$export$5c1893b49d2a8870 = ({ conversationId: conversationId, agentId: agentId, webSearchEnabled: webSearchEnabled, useCurrentBrowsingContext: useCurrentBrowsingContext, appFilters: appFilters })=>{
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    const { getMessages: getMessages, setMessages: setMessages } = (0, $iW40i.useChatMessagesActions)();
    const latestActionStateRef = (0, $cozmU.useRef)(undefined);
    $75a2162b9fe8b765$var$useIsomorphicLayoutEffect(()=>{
        latestActionStateRef.current = {
            conversationId: conversationId,
            agentId: agentId,
            webSearchEnabled: webSearchEnabled,
            useCurrentBrowsingContext: useCurrentBrowsingContext,
            appFilters: appFilters,
            assistanceService: assistanceService,
            getMessages: getMessages,
            setMessages: setMessages
        };
    }, [
        agentId,
        appFilters,
        assistanceService,
        conversationId,
        getMessages,
        setMessages,
        useCurrentBrowsingContext,
        webSearchEnabled
    ]);
    const handleA2UIAction = (0, $cozmU.useCallback)(async (action, assistantMessageId)=>{
        try {
            if (!(0, $iDrrr.fg)('jira_ai_rendering_a2ui')) return;
            const latestActionState = latestActionStateRef.current;
            if (!latestActionState) return;
            const { conversationId: conversationId_0, assistanceService: assistanceService_0, agentId: agentId_0, webSearchEnabled: webSearchEnabled_0, useCurrentBrowsingContext: useCurrentBrowsingContext_0, appFilters: appFilters_0 } = latestActionState;
            if (!conversationId_0 || !assistantMessageId) return;
            const getActiveActionState = ()=>{
                const activeActionState = latestActionStateRef.current;
                return activeActionState?.conversationId === conversationId_0 ? activeActionState : undefined;
            };
            const { generator: generator } = await assistanceService_0.sendMessageStream({
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing A2UI baseline: structured action content is adapted to the assistance service stream message type.
                message: $75a2162b9fe8b765$var$toStructuredActionContent(action, assistantMessageId),
                mimeType: 'text/json',
                agentId: agentId_0,
                conversationId: conversationId_0,
                storeMessage: false,
                citationsEnabled: true,
                webSearchEnabled: webSearchEnabled_0,
                useCurrentBrowsingContext: useCurrentBrowsingContext_0,
                appFilters: appFilters_0?.map((app)=>app.source),
                optInSSEStream: true
            });
            await $75a2162b9fe8b765$var$consumeA2UIActionStream({
                generator: generator,
                onAgenticUi: (streamMessage)=>{
                    const activeActionState_0 = getActiveActionState();
                    if (!activeActionState_0) return;
                    activeActionState_0.setMessages(conversationId_0, (0, $coqKO.addAgenticUiMessage)(activeActionState_0.getMessages(conversationId_0), assistantMessageId, streamMessage));
                },
                onTextPart: (text)=>{
                    const activeActionState_1 = getActiveActionState();
                    if (!activeActionState_1) return;
                    activeActionState_1.setMessages(conversationId_0, (0, $508054bea15a2c6a$export$41f43752e3744795)(activeActionState_1.getMessages(conversationId_0), assistantMessageId, text));
                }
            });
        } catch  {
            return;
        }
    }, []);
    return {
        handleA2UIAction: handleA2UIAction
    };
};
























































































/**
 * Pure decision function for whether the Rovo Insights entry-point banner is shown,
 * and — when it is not — the single reason why. Kept free of React/analytics so both
 * banner surfaces (For You tab, Rovo empty state) resolve visibility identically and
 * report the same `reason` taxonomy.
 */ const $e9a8cd2302c70256$export$24b465079af9616a = {
    SHOWN: 'shown',
    // Status fetch never ran.
    NO_PRODUCT: 'noProduct',
    OFF_SCHEDULE: 'offSchedule',
    // Status fetch ran but the banner is still suppressed.
    FETCH_ERROR: 'fetchError',
    STATUS_UNAVAILABLE: 'statusUnavailable',
    SPACE_SELECTED: 'spaceSelected',
    STALE: 'stale'
};
const $e9a8cd2302c70256$export$c0de5347a823e3cf = (input)=>{
    if (!input.pulseEnabled) return {
        shown: false,
        reason: null
    };
    if (input.requiresProduct && !input.hasProduct) return {
        shown: false,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.NO_PRODUCT
    };
    if (!input.scheduleOk) return {
        shown: false,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.OFF_SCHEDULE
    };
    if (input.statusFetchState === 'disabled' || input.statusFetchState === 'loading') return {
        shown: false,
        reason: null
    };
    if (input.statusFetchState === 'error') return {
        shown: false,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.FETCH_ERROR
    };
    if (!input.isInsightsAvailable) return {
        shown: false,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.STATUS_UNAVAILABLE
    };
    if (input.hasSelectedSpace) return {
        shown: false,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.SPACE_SELECTED
    };
    if (input.requiresFresh && !input.isFresh) return {
        shown: false,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.STALE
    };
    return {
        shown: true,
        reason: $e9a8cd2302c70256$export$24b465079af9616a.SHOWN
    };
};



const $a8cc5669d925fa6c$export$dc8676c7370a9cf5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (input)=>{
    const $ = (0, $bDgLe.c)(16);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    const reportedRef = (0, $cozmU.useRef)(false);
    let t0;
    if ($[0] !== input) {
        t0 = (0, $e9a8cd2302c70256$export$c0de5347a823e3cf)(input);
        $[0] = input;
        $[1] = t0;
    } else t0 = $[1];
    const resolution = t0;
    const { shown: shown, reason: reason } = resolution;
    const { surface: surface, scheduleOk: scheduleOk, hasProduct: hasProduct, isInsightsAvailable: isInsightsAvailable, isFresh: isFresh, requiresFresh: requiresFresh, hasSelectedSpace: hasSelectedSpace, statusFetchState: statusFetchState, generatedAt: generatedAt } = input;
    let t1;
    let t2;
    if ($[2] !== fireAnalyticsEvent || $[3] !== generatedAt || $[4] !== hasProduct || $[5] !== hasSelectedSpace || $[6] !== isFresh || $[7] !== isInsightsAvailable || $[8] !== reason || $[9] !== requiresFresh || $[10] !== scheduleOk || $[11] !== shown || $[12] !== statusFetchState || $[13] !== surface) {
        t1 = ()=>{
            if (reportedRef.current || reason === null) return;
            reportedRef.current = true;
            fireAnalyticsEvent({
                eventType: "operational",
                actionSubject: "insightsBanner",
                action: "resolved",
                attributes: {
                    shown: shown,
                    reason: reason,
                    surface: surface,
                    scheduleOk: scheduleOk,
                    hasProduct: hasProduct,
                    insightsAvailable: isInsightsAvailable,
                    isFresh: isFresh,
                    requiresFresh: requiresFresh,
                    hasSelectedSpace: hasSelectedSpace,
                    statusFetchState: statusFetchState,
                    generatedAt: generatedAt ?? null
                }
            });
        };
        t2 = [
            shown,
            reason,
            surface,
            scheduleOk,
            hasProduct,
            isInsightsAvailable,
            isFresh,
            requiresFresh,
            hasSelectedSpace,
            statusFetchState,
            generatedAt,
            fireAnalyticsEvent
        ];
        $[2] = fireAnalyticsEvent;
        $[3] = generatedAt;
        $[4] = hasProduct;
        $[5] = hasSelectedSpace;
        $[6] = isFresh;
        $[7] = isInsightsAvailable;
        $[8] = reason;
        $[9] = requiresFresh;
        $[10] = scheduleOk;
        $[11] = shown;
        $[12] = statusFetchState;
        $[13] = surface;
        $[14] = t1;
        $[15] = t2;
    } else {
        t1 = $[14];
        t2 = $[15];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return resolution;
} : (input)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    const reportedRef = (0, $cozmU.useRef)(false);
    const resolution = (0, $e9a8cd2302c70256$export$c0de5347a823e3cf)(input);
    const { shown: shown, reason: reason } = resolution;
    const { surface: surface, scheduleOk: scheduleOk, hasProduct: hasProduct, isInsightsAvailable: isInsightsAvailable, isFresh: isFresh, requiresFresh: requiresFresh, hasSelectedSpace: hasSelectedSpace, statusFetchState: statusFetchState, generatedAt: generatedAt } = input;
    (0, $cozmU.useEffect)(()=>{
        if (reportedRef.current || reason === null) return;
        reportedRef.current = true;
        fireAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'insightsBanner',
            action: 'resolved',
            attributes: {
                shown: shown,
                reason: reason,
                surface: surface,
                scheduleOk: scheduleOk,
                hasProduct: hasProduct,
                insightsAvailable: isInsightsAvailable,
                isFresh: isFresh,
                requiresFresh: requiresFresh,
                hasSelectedSpace: hasSelectedSpace,
                statusFetchState: statusFetchState,
                generatedAt: generatedAt ?? null
            }
        });
    }, [
        shown,
        reason,
        surface,
        scheduleOk,
        hasProduct,
        isInsightsAvailable,
        isFresh,
        requiresFresh,
        hasSelectedSpace,
        statusFetchState,
        generatedAt,
        fireAnalyticsEvent
    ]);
    return resolution;
};


/**
 * Returns true if today is Monday (1) or Tuesday (2) in local time.
 * The insights banner is only shown on these days.
 */ const $b1faed5da83dea83$export$200db2820880abd6 = (date = new Date())=>{
    const day = date.getDay();
    return day === 1 || day === 2; // 1 = Monday, 2 = Tuesday
};



var $bY61u = parcelRequire("bY61u");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Renders the Rovo insights banner card.
 * Displays a Rovo hex icon, generated date, title, and a chevron-right indicator.
 * Invokes a callback when clicked.
 */ 


























const $2477042352304684$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    insightsBannerTitle: {
        id: "rovo-growth-pulse.insights-banner.title.V3",
        defaultMessage: "Your weekly insights"
    },
    insightsBannerAriaLabel: {
        id: "rovo-growth-pulse.insights-banner.aria-label.V3",
        defaultMessage: "View your weekly insights"
    }
});


const $6bdb37ec7796f6ed$var$styles = {
    cardWrapper: "_0bjKvDyzSk _39xV02N91d _0KLXrunmFW _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _1eOmH6d1Zr",
    pressable: "_0KLXrujOvk _39xV02N91d _0wOv4Q7zJH _2fwxA57p2s",
    pressableWithExtraPadding: "_0KLXrujOvk _39xV02N91d _0wOv4Q7zJH _2fwxA57p2s _0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO",
    textContainer: "_2O5Vij7dHp _4ouGXIdnbC",
    iconTileSurface: "_0bjKvD0O7w _0KLXrulfZc _3YEZNOdnbC",
    chevron: "_3YEZNOdnbC"
};
const $6bdb37ec7796f6ed$export$c03a8cd6181f4965 = ({ onClick: onClick, extraPadding: extraPadding = false, appearance: appearance = 'yourWork', generatedAt: generatedAt })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    const fireAnalyticsEventRef = (0, $cozmU.useRef)(fireAnalyticsEvent);
    fireAnalyticsEventRef.current = fireAnalyticsEvent;
    const formattedGeneratedAt = (0, $13854e22d2f33375$export$8c68a43a9bc19046)(generatedAt, intl.formatMessage, (0, $004abc2094aee036$export$822cdd78febe6c96).generatedAt, intl.locale);
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEventRef.current({
            eventType: 'ui',
            actionSubject: 'insightsBanner',
            action: 'shown'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'insightsBanner',
            action: 'clicked'
        });
        onClick();
    }, [
        fireAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $6bdb37ec7796f6ed$var$styles.cardWrapper,
        onClick: handleClick,
        "aria-label": intl.formatMessage((0, $2477042352304684$export$defe85febe8b728c).insightsBannerAriaLabel),
        testId: "rovo-insights-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: extraPadding ? $6bdb37ec7796f6ed$var$styles.pressableWithExtraPadding : $6bdb37ec7796f6ed$var$styles.pressable,
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $6bdb37ec7796f6ed$var$styles.iconTileSurface,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92db9dd378ea9422$export$b2ab96b128cdb752), {
        size: "medium",
        appearance: appearance === 'quickActions' ? 'monochrome' : 'colorful',
        backgroundColor: "transparent",
        hasBorder: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6bdb37ec7796f6ed$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, formattedGeneratedAt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        testId: "rovo-insights-banner-generated-date"
    }, formattedGeneratedAt) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, intl.formatMessage((0, $2477042352304684$export$defe85febe8b728c).insightsBannerTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $6bdb37ec7796f6ed$var$styles.chevron,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }))));
};


/* PinnedWorkSection.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























var $59613de26d06af57$exports = {};
$59613de26d06af57$exports = new URL("pin-empty-state-dark.d2bc4d1e.svg", import.meta.url).toString();


var $3e6244c3386e9761$exports = {};
$3e6244c3386e9761$exports = new URL("pin-empty-state.108cde83.svg", import.meta.url).toString();



var $59lLN = parcelRequire("59lLN");

/* PinnedItemRow.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $j9ljO = parcelRequire("j9ljO");





var $V3JOP = parcelRequire("V3JOP");


















var $ieYVG = parcelRequire("ieYVG");

const $27b544352f82f0f2$export$ad8f8fc3bcd61b4a = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { icon: Icon, color: color, label: label } = (0, $ieYVG.TYPE_ICON_CONFIG)[type];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: formatMessage(label),
        color: color
    });
};
































const $bb17824b5a8ce36f$var$messages = (0, $kSwu1.defineMessages)({
    unpinConfirmModalTitle: {
        id: "rovo-pins.unpin-confirm-modal.title",
        defaultMessage: "Unpin this item?"
    },
    unpinConfirmModalBody: {
        id: "rovo-pins.unpin-confirm-modal.body",
        defaultMessage: "You can pin it again anytime."
    },
    unpinConfirmModalCancelLabel: {
        id: "rovo-pins.unpin-confirm-modal.cancel-label",
        defaultMessage: "Cancel"
    },
    unpinConfirmModalConfirmLabel: {
        id: "rovo-pins.unpin-confirm-modal.confirm-label",
        defaultMessage: "Confirm"
    }
});
var $bb17824b5a8ce36f$export$2e2bcd8739ae039 = $bb17824b5a8ce36f$var$messages;


const $264ae037b1e9675a$export$159a589430d235a9 = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "small",
        testId: "rovo-for-you-unpin-confirm-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $bb17824b5a8ce36f$export$2e2bcd8739ae039).unpinConfirmModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, formatMessage((0, $bb17824b5a8ce36f$export$2e2bcd8739ae039).unpinConfirmModalBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "rovo-for-you-unpin-confirm-modal-cancel-button"
    }, formatMessage((0, $bb17824b5a8ce36f$export$2e2bcd8739ae039).unpinConfirmModalCancelLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onConfirm,
        testId: "rovo-for-you-unpin-confirm-modal-confirm-button"
    }, formatMessage((0, $bb17824b5a8ce36f$export$2e2bcd8739ae039).unpinConfirmModalConfirmLabel)))));
};





const $602757cd81efc82c$var$messages = (0, $kSwu1.defineMessages)({
    pinnedItemRowOpenLabel: {
        id: "rovo-pins.pinned-item-row.open-label",
        defaultMessage: "Open"
    },
    pinnedItemRowStartChatLabel: {
        id: "rovo-pins.pinned-item-row.start-chat-label",
        defaultMessage: "Start chat"
    },
    pinnedItemRowUnpinLabel: {
        id: "rovo-pins.pinned-item-row.unpin-label",
        defaultMessage: "Unpin"
    }
});
var $602757cd81efc82c$export$2e2bcd8739ae039 = $602757cd81efc82c$var$messages;


const $31d97d569fbb63b6$var$styles = {
    container: "_0bjKvD8fU6 _4c065U2ADO _2Y7lL42ADO _1mT5xdRAKS _39xV02N91d _3MoE6WWgmT _063Ij4dnbC _4q3ZX27dHp _2sWvrL7dHp _1eOmH6o126",
    icon: "_3YEZNOdnbC",
    title: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    actions: "_0bjKvDKTcp _1mT5xdWVPG _1OKFqY2ADO _2I62gzdnbC _1ZB6UydnbC _0LQT5E8HPE _0KLXrulfZc _3CkH9oYPCr"
};
const $31d97d569fbb63b6$export$71f11b168dc1f38b = ({ type: type, title: title, onOpen: onOpen, onStartChat: onStartChat, onUnpin: onUnpin })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const titleRef = (0, $cozmU.useRef)(null);
    const [isTitleTruncated, setIsTitleTruncated] = (0, $cozmU.useState)(false);
    const [isUnpinModalOpen, setIsUnpinModalOpen] = (0, $cozmU.useState)(false); // Re-checked on hover rather than on mount/resize — the row's width can settle after
    // mount (e.g. panel animating open), so a fresh measurement on hover avoids acting on a
    // stale layout. `Text` truncates via `-webkit-line-clamp` (a vertical box), so overflow
    // shows up as extra scrollHeight against clientHeight, not scrollWidth/clientWidth.
    const checkTitleTruncation = ()=>{
        const element = titleRef.current;
        if (element) setIsTitleTruncated(element.scrollHeight > element.clientHeight);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $31d97d569fbb63b6$var$styles.container,
        alignItems: "center",
        gap: "space.150",
        testId: "rovo-for-you-pinned-item-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $31d97d569fbb63b6$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27b544352f82f0f2$export$ad8f8fc3bcd61b4a), {
        type: type
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isTitleTruncated ? title : '',
        testId: "rovo-for-you-pinned-item-row-title-tooltip"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $31d97d569fbb63b6$var$styles.title,
            ...tooltipProps,
            onMouseOver: (event)=>{
                checkTitleTruncation();
                tooltipProps.onMouseOver(event);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            ref: titleRef,
            maxLines: 1
        }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $31d97d569fbb63b6$var$styles.actions,
        alignItems: "center",
        gap: "space.050",
        testId: "rovo-for-you-pinned-item-row-actions-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))),
        label: formatMessage((0, $602757cd81efc82c$export$2e2bcd8739ae039).pinnedItemRowStartChatLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: onStartChat,
        testId: "rovo-for-you-pinned-item-row-start-chat-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: formatMessage((0, $602757cd81efc82c$export$2e2bcd8739ae039).pinnedItemRowOpenLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: onOpen,
        testId: "rovo-for-you-pinned-item-row-open-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j9ljO))),
        label: formatMessage((0, $602757cd81efc82c$export$2e2bcd8739ae039).pinnedItemRowUnpinLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsUnpinModalOpen(true),
        testId: "rovo-for-you-pinned-item-row-unpin-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $264ae037b1e9675a$export$159a589430d235a9), {
        isOpen: isUnpinModalOpen,
        onClose: ()=>setIsUnpinModalOpen(false),
        onConfirm: ()=>{
            setIsUnpinModalOpen(false);
            onUnpin?.();
        }
    }));
};





const $a032b9bb8f3a66cd$var$messages = (0, $kSwu1.defineMessages)({
    pinnedWorkLoadingLabel: {
        id: "rovo-pins.pinned-work-section.pinnedWorkLoadingLabel",
        defaultMessage: "Loading pinned work"
    },
    pinnedWorkHeading: {
        id: "rovo-pins.pinned-work.heading",
        defaultMessage: "Pinned work"
    },
    pinnedWorkAddButtonLabel: {
        id: "rovo-pins.pinned-work.add-button-label",
        defaultMessage: "Add pinned work"
    },
    pinnedWorkEmptyStateMessage: {
        id: "rovo-pins.pinned-work.empty-state-message",
        defaultMessage: "Pin epics, projects, and goals here for one-tap chat access."
    },
    pinnedWorkPinButtonLabel: {
        id: "rovo-pins.pinned-work.pin-button-label",
        defaultMessage: "Pin work"
    }
});
var $a032b9bb8f3a66cd$export$2e2bcd8739ae039 = $a032b9bb8f3a66cd$var$messages;


/* PinnedWorkSkeleton.tsx generated by @compiled/babel-plugin v2.0.0 */ 














const $da4d3b9f27eca690$var$styles = {
    container: "_0bjKvDuMRm _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    message: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $da4d3b9f27eca690$export$b8c620eb8ee00baa = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $da4d3b9f27eca690$var$styles.container,
        role: "group",
        "aria-label": intl.formatMessage((0, $a032b9bb8f3a66cd$export$2e2bcd8739ae039).pinnedWorkLoadingLabel),
        testId: "rovo-for-you-pinned-work-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $da4d3b9f27eca690$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "70%",
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 80,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })));
};


const $9cf6d22946fd7d4e$var$styles = {
    emptyState: "_0bjKvDuMRm _3hxITisurO _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    message: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
}; /**
    * Intrinsic size of the empty-state illustration, matching the asset's cropped viewBox so it
    * renders 1:1 in the chat mini-modal — the default surface for this section. In wider containers
    * (fullscreen chat) it deliberately keeps this size and stays left-aligned rather than
    * stretching, per the design.
    */ 
const $9cf6d22946fd7d4e$var$EMPTY_STATE_IMAGE_WIDTH = 340;
const $9cf6d22946fd7d4e$var$EMPTY_STATE_IMAGE_HEIGHT = 80;
const $9cf6d22946fd7d4e$export$e592500ec5456788 = ({ cloudId: cloudId, product: product, onPinWorkClick: onPinWorkClick, onStartChat: onStartChat })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { items: items, isLoading: isLoading, unpin: unpin } = (0, $59lLN.usePinnedItems)({
        cloudId: cloudId,
        product: product
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "rovo-for-you-pinned-work-section",
        space: "space.150"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da4d3b9f27eca690$export$b8c620eb8ee00baa), null) : items.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9cf6d22946fd7d4e$var$styles.emptyState,
        testId: "rovo-for-you-pinned-work-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9cf6d22946fd7d4e$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, intl.formatMessage((0, $a032b9bb8f3a66cd$export$2e2bcd8739ae039).pinnedWorkEmptyStateMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onPinWorkClick,
        testId: "rovo-for-you-pinned-work-pin-button"
    }, intl.formatMessage((0, $a032b9bb8f3a66cd$export$2e2bcd8739ae039).pinnedWorkPinButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3e6244c3386e9761$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($59613de26d06af57$exports))),
        alt: "",
        width: $9cf6d22946fd7d4e$var$EMPTY_STATE_IMAGE_WIDTH,
        height: $9cf6d22946fd7d4e$var$EMPTY_STATE_IMAGE_HEIGHT,
        testId: "rovo-for-you-pinned-work-empty-state-image"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xxsmall",
        as: "h4"
    }, intl.formatMessage((0, $a032b9bb8f3a66cd$export$2e2bcd8739ae039).pinnedWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        label: intl.formatMessage((0, $a032b9bb8f3a66cd$export$2e2bcd8739ae039).pinnedWorkAddButtonLabel),
        appearance: "subtle",
        onClick: onPinWorkClick,
        testId: "rovo-for-you-pinned-work-add-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "rovo-for-you-pinned-work-list"
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31d97d569fbb63b6$export$71f11b168dc1f38b), {
            key: item.id,
            type: item.pinType,
            title: item.name,
            onOpen: ()=>window.open(item.url, '_blank', 'noopener,noreferrer'),
            onStartChat: ()=>onStartChat(item),
            onUnpin: ()=>unpin(item.ari)
        })))));
};



/**
 * Shared starter prompt definitions used by the Rovo Space landing page
 * (fullscreen), the Rovo chat sidebar, and the For You panel space cards.
 *
 * The 4 starters here match the canonical "green dot" (🟢) spec from:
 * https://hello.atlassian.net/wiki/spaces/proai/pages/6680743926/Starter+prompts+for+Projects+Spaces
 *
 * All consumers (rovo-for-you space cards, conversation-assistant side navigation,
 * and the SpaceLandingPage) import from this single canonical file so that a user
 * sees the same suggestions regardless of entry point.
 */ 






var $dQeg1 = parcelRequire("dQeg1");


var $jXbuX = parcelRequire("jXbuX");







/**
 * i18n messages for the shared Rovo Space starter prompts
 * Consumed via `buildSpaceStarters` / `useSpaceStarters` in `../starters`.
 */ const $e364031f5adc71fe$var$messages = (0, $kSwu1.defineMessages)({
    // --- Skills ---
    getDailyBriefTitle: {
        id: "ai-mate.rovo-spaces.starters.get-daily-brief-title.v2.nonFinal",
        defaultMessage: "Get workstream brief"
    },
    getProjectOverviewTitle: {
        id: "ai-mate.rovo-spaces.starters.get-workstream-overview-title.nonFinal",
        defaultMessage: "Get workstream overview"
    },
    // --- Chat prompts ---
    findMyActionItemsTitle: {
        id: "ai-mate.rovo-spaces.starters.find-my-action-items-title.nonFinal",
        defaultMessage: "Find my action items"
    },
    findMyActionItemsPrompt: {
        id: "ai-mate.rovo-spaces.starters.find-my-action-items-prompt",
        defaultMessage: "Write a list of Reminders for me for this workstream capturing what's new from the last few days. Scope & relevance rules:\n- Consider all 1P & 3P resources as context associated to this project, even if not explicitly linked.\n- Start from this object as the root. You may follow at most one hop of links from these pages (e.g., linked Jira issues, Confluence pages, JPD ideas, or Slack threads) only if the linked resource clearly refers back to this project (by name, ID, or direct context)\n- A reminder qualifies only if it directly advances this workstream. Exclude items from other workstreams that merely share a meeting or author. Formatting rules: Format it for fast scanability\n- H2. Reminders\n- List only action items I am responsible for, if any.\n- Find any actions I need to follow up on. Could be actual tasks assigned to me, comments I'm tagged in but haven't responded to, or things I said I would do in a conversation or meeting.\n- Each reminder MUST start with the ballot box with tick emoji (\u2611\uFE0F) and MUST NOT be a bulleted list.\n- For each reminder, use:\n\u2611\uFE0F Action (short)\nWhen: (date/timeframe if known)\nContext: (1 sentence)\nLink: (URL) General rules:\n- Use markdown headings and bolding for structure.\n- Include links wherever relevant.\n- If there are no reminders, write \"No new reminders.\""
    },
    prepForCheckinTitle: {
        id: "ai-mate.rovo-spaces.starters.prep-for-checkin-title.nonFinal",
        defaultMessage: "Prep for check-in meeting"
    },
    prepForCheckinPrompt: {
        id: "ai-mate.rovo-spaces.starters.prep-for-checkin-prompt",
        defaultMessage: "I have a weekly sync starting soon for this workstream. Prep a brief agenda, including:\n1. Highlights from the last week. Include 1-4. Can cover momentum, milestones, decisions, risks, learnings. Use emoji for each.\n2. Open items or discussion topics that need to be closed out. Use emoji to mark priority.\n3. An empty section to capture notes, action items, and decisions. Add a table with one empty row to get the user started."
    }
});
var $e364031f5adc71fe$export$2e2bcd8739ae039 = $e364031f5adc71fe$var$messages;


const $469e3ce09396ad62$export$670f88557775636a = (intl, // Params accepted for forwards-compatibility; currently unused.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_params = {})=>{
    const { formatMessage: formatMessage } = intl;
    return [
        {
            id: 'get-daily-brief',
            title: formatMessage((0, $e364031f5adc71fe$export$2e2bcd8739ae039).getDailyBriefTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))), {
                    label: ""
                }),
            handleType: 'Skill',
            type: 'skill-action',
            staticPrompt: '/get-workstream-brief '
        },
        {
            id: 'get-project-overview',
            title: formatMessage((0, $e364031f5adc71fe$export$2e2bcd8739ae039).getProjectOverviewTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))), {
                    label: ""
                }),
            handleType: 'Skill',
            type: 'skill-action',
            staticPrompt: '/get-project-details '
        },
        {
            id: 'find-my-action-items',
            title: formatMessage((0, $e364031f5adc71fe$export$2e2bcd8739ae039).findMyActionItemsTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: ""
                }),
            handleType: 'Chat',
            type: 'convo-starter-action',
            staticPrompt: formatMessage((0, $e364031f5adc71fe$export$2e2bcd8739ae039).findMyActionItemsPrompt)
        },
        {
            id: 'prep-for-checkin',
            title: formatMessage((0, $e364031f5adc71fe$export$2e2bcd8739ae039).prepForCheckinTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: ""
                }),
            handleType: 'Chat',
            type: 'convo-starter-action',
            staticPrompt: formatMessage((0, $e364031f5adc71fe$export$2e2bcd8739ae039).prepForCheckinPrompt)
        }
    ];
};
const $469e3ce09396ad62$export$1d903f8c25999b1a = (params = {})=>{
    const intl = (0, $kSwu1.useIntl)();
    const { spaceId: spaceId, spaceName: spaceName } = params;
    return (0, $cozmU.useMemo)(()=>$469e3ce09396ad62$export$670f88557775636a(intl, {
            spaceId: spaceId,
            spaceName: spaceName
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        intl.formatMessage,
        spaceId,
        spaceName
    ]);
};






















var $9f0604c03e78f39b$exports = {};
$9f0604c03e78f39b$exports = new URL("scorecard-illustration.af333c78.svg", import.meta.url).toString();





















const $464d719025726fea$var$styles = {
    container: "_46hvQm8HPE"
};
const $464d719025726fea$export$7c34fbaae8d281c1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { illustrationUrl: illustrationUrl, title: title, subtitle: subtitle, testId: testId } = t0;
    let t1;
    if ($[0] !== illustrationUrl) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: illustrationUrl,
            alt: "",
            width: 75,
            height: 75
        });
        $[0] = illustrationUrl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            align: "center"
        }, title);
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== subtitle) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            align: "center"
        }, subtitle);
        $[4] = subtitle;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "center"
        }, t2, t3);
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.300",
            alignInline: "center"
        }, t1, t4);
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t5 || $[13] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $464d719025726fea$var$styles.container,
            testId: testId
        }, t5);
        $[12] = t5;
        $[13] = testId;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ illustrationUrl: illustrationUrl, title: title, subtitle: subtitle, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $464d719025726fea$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: illustrationUrl,
        alt: "",
        width: 75,
        height: 75
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        align: "center"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        align: "center"
    }, subtitle))));
};





const $20a234e719281cd3$var$messages = (0, $kSwu1.defineMessages)({
    emptyStateTitle: {
        id: "rovo-for-you.empty-state.title",
        defaultMessage: "Nothing to see here...yet."
    },
    emptyStateSubtitle: {
        id: "rovo-for-you.empty-state.subtitle",
        defaultMessage: "There's nothing for us to highlight here right now. Check back later as new work comes in."
    }
});
var $20a234e719281cd3$export$2e2bcd8739ae039 = $20a234e719281cd3$var$messages;


const $b3d6c2188dbc8155$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $20a234e719281cd3$export$2e2bcd8739ae039).emptyStateTitle);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage((0, $20a234e719281cd3$export$2e2bcd8739ae039).emptyStateSubtitle);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $464d719025726fea$export$7c34fbaae8d281c1), {
            illustrationUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9f0604c03e78f39b$exports))),
            title: t0,
            subtitle: t1,
            testId: "rovo-for-you-empty-state"
        });
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $464d719025726fea$export$7c34fbaae8d281c1), {
        illustrationUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9f0604c03e78f39b$exports))),
        title: intl.formatMessage((0, $20a234e719281cd3$export$2e2bcd8739ae039).emptyStateTitle),
        subtitle: intl.formatMessage((0, $20a234e719281cd3$export$2e2bcd8739ae039).emptyStateSubtitle),
        testId: "rovo-for-you-empty-state"
    });
};



















const $e6c6f8a63bd6156a$var$messages = (0, $kSwu1.defineMessages)({
    errorStateTitle: {
        id: "rovo-for-you.error-state.title",
        defaultMessage: "Something went wrong loading this page."
    },
    errorStateSubtitle: {
        id: "rovo-for-you.error-state.subtitle",
        defaultMessage: "Please try again later."
    }
});
var $e6c6f8a63bd6156a$export$2e2bcd8739ae039 = $e6c6f8a63bd6156a$var$messages;


const $82eb67a8de13c942$export$c1ed4f415b9e7023 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $e6c6f8a63bd6156a$export$2e2bcd8739ae039).errorStateTitle);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage((0, $e6c6f8a63bd6156a$export$2e2bcd8739ae039).errorStateSubtitle);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $464d719025726fea$export$7c34fbaae8d281c1), {
            illustrationUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9f0604c03e78f39b$exports))),
            title: t0,
            subtitle: t1,
            testId: "rovo-for-you-error-state"
        });
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $464d719025726fea$export$7c34fbaae8d281c1), {
        illustrationUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9f0604c03e78f39b$exports))),
        title: intl.formatMessage((0, $e6c6f8a63bd6156a$export$2e2bcd8739ae039).errorStateTitle),
        subtitle: intl.formatMessage((0, $e6c6f8a63bd6156a$export$2e2bcd8739ae039).errorStateSubtitle),
        testId: "rovo-for-you-error-state"
    });
};





const $2e491f5bc322938a$var$messages = (0, $kSwu1.defineMessages)({
    mySpacesListLabel: {
        id: "rovo-for-you.my-spaces-list.rovo-spaces-label",
        defaultMessage: "Rovo spaces"
    },
    mySpacesSectionHeading: {
        id: "rovo-for-you.my-spaces-list.rovo-spaces-section-heading",
        defaultMessage: "Rovo spaces"
    },
    dailyBriefChatName: {
        id: "rovo-for-you.my-projects-list.daily-brief-chat-name",
        defaultMessage: "Daily Brief: {spaceName}"
    },
    linkedResourcesSection: {
        id: "rovo-for-you.my-projects-list.linked-resources-section",
        defaultMessage: " The following linked resources are associated with this Rovo space and should be prioritised as primary sources: {links}."
    },
    chatGreeting: {
        id: "rovo-for-you.my-projects-list.chat-greeting",
        defaultMessage: "Chat about anything in this Rovo space"
    }
});
var $2e491f5bc322938a$export$2e2bcd8739ae039 = $2e491f5bc322938a$var$messages;





























const $7fcd0e7aa607fe5f$var$messages = (0, $kSwu1.defineMessages)({
    loadingSpacesLabel: {
        id: "rovo-for-you.my-spaces-skeleton.loading-spaces-label",
        defaultMessage: "Loading spaces"
    }
});
var $7fcd0e7aa607fe5f$export$2e2bcd8739ae039 = $7fcd0e7aa607fe5f$var$messages;


const $ff43df5b2db7b526$var$SKELETON_CARD_COUNT = 3;
const $ff43df5b2db7b526$var$styles = {
    container: "_39xV02N91d",
    card: "_0bjKvD8fU6 _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headerRow: "_39xV02N91d"
};
/** Renders a single placeholder project card skeleton. */ const $ff43df5b2db7b526$var$SpaceCardSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ff43df5b2db7b526$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $ff43df5b2db7b526$var$styles.headerRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-tile, 25%)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 120,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "80%",
            height: 14,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60%",
            height: 14,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ff43df5b2db7b526$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $ff43df5b2db7b526$var$styles.headerRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-tile, 25%)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 120,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "80%",
        height: 14,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "60%",
        height: 14,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })));
}; /**
    * Shimmer/skeleton loading state rendered as the Suspense fallback for MySpacesList.
    * Renders placeholder space cards that match the ThreadCard layout dimensions.
    */ 
const $ff43df5b2db7b526$export$e58168d515763c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $7fcd0e7aa607fe5f$export$2e2bcd8739ae039).loadingSpacesLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, Array.from({
            length: $ff43df5b2db7b526$var$SKELETON_CARD_COUNT
        }, $ff43df5b2db7b526$var$_temp));
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ff43df5b2db7b526$var$styles.container,
            role: "group",
            "aria-label": t0
        }, t1);
        $[3] = t0;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ff43df5b2db7b526$var$styles.container,
        role: "group",
        "aria-label": intl.formatMessage((0, $7fcd0e7aa607fe5f$export$2e2bcd8739ae039).loadingSpacesLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, Array.from({
        length: $ff43df5b2db7b526$var$SKELETON_CARD_COUNT
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff43df5b2db7b526$var$SpaceCardSkeleton, {
            key: index
        }))));
};
function $ff43df5b2db7b526$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff43df5b2db7b526$var$SpaceCardSkeleton, {
        key: index
    });
}


/**
 * Renders a list of Rovo Spaces for the current user.
 * Spaces data is owned by the parent (`ForYouPanelContent`) so that refetches triggered by
 * sibling components (e.g. creating a space from `ThreadsList`) refresh this list too.
 * Each space card includes "Chat" and "Daily Brief" CTAs.
 */ 





























const $5fb0e87a487b8b7b$export$a6818377be660b14 = 'suggestions';
const $5fb0e87a487b8b7b$export$4e2d22a4f1ea8ef3 = 'for-you';






















































var $8V8zt = parcelRequire("8V8zt");











var $jXXTm = parcelRequire("jXXTm");




const $f89244bd434c32b4$var$styles = {
    iconBackground: "_0bjKvD0O7w _3YEZNOdnbC _0KLXrumhAQ _39xV02Uofl _0jFU0VUofl"
};
const $f89244bd434c32b4$export$70844c87c892e091 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f89244bd434c32b4$var$styles.iconBackground,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXXTm))), {
            label: "",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f89244bd434c32b4$var$styles.iconBackground,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXXTm))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }));
};





const $08c26370afa81833$var$messages = (0, $kSwu1.defineMessages)({
    dailyBriefLabel: {
        id: "rovo-platform-ui-components.thread-card.daily-brief-label.v2",
        defaultMessage: "Workstream brief"
    },
    dailyBriefAriaLabel: {
        id: "rovo-platform-ui-components.thread-card.daily-brief-aria-label",
        defaultMessage: "Get daily brief for {threadTitle}"
    },
    chatLabel: {
        id: "rovo-platform-ui-components.thread-card.chat-label",
        defaultMessage: "Chat"
    },
    chatAriaLabel: {
        id: "rovo-platform-ui-components.thread-card.chat-aria-label",
        defaultMessage: "Chat about {threadTitle}"
    },
    createProjectLabel: {
        id: "rovo-platform-ui-components.thread-card.create-project-label",
        defaultMessage: "Create space"
    },
    createProjectAriaLabel: {
        id: "rovo-platform-ui-components.thread-card.create-project-aria-label",
        defaultMessage: "Create space from {threadTitle}"
    }
});
var $08c26370afa81833$export$2e2bcd8739ae039 = $08c26370afa81833$var$messages;


const $f8942bc8ecc07882$var$styles = {
    cardWrapper: "_0bjKvDyzSk _0KLXrunmFW",
    staticBody: "_0KLXrujOvk _39xV02N91d _0wOv4Q18ZR _2fwxA57p2s",
    threadContainer: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    sourcesWrapper: "_2Zuz6Q5zaO _1Znuxb5zaO _1wydGW5zaO",
    actionsRowSpacer: "_2XsHFMIZbP"
};
const $f8942bc8ecc07882$var$ThreadCardComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { threadId: threadId, title: title, subtitle: subtitle, sourceUrls: sourceUrls, renderSources: renderSources, renderIcon: renderIcon, onDailyBriefClick: onDailyBriefClick, onCreateProjectClick: onCreateProjectClick, isCreateProjectDisabled: isCreateProjectDisabled, onChatClick: onChatClick } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onDailyBriefClick || $[1] !== threadId || $[2] !== title) {
        t1 = ()=>{
            onDailyBriefClick?.(threadId, title);
        };
        $[0] = onDailyBriefClick;
        $[1] = threadId;
        $[2] = title;
        $[3] = t1;
    } else t1 = $[3];
    const handleDailyBriefClick = t1;
    let t2;
    if ($[4] !== onCreateProjectClick || $[5] !== threadId || $[6] !== title) {
        t2 = ()=>{
            onCreateProjectClick?.(threadId, title);
        };
        $[4] = onCreateProjectClick;
        $[5] = threadId;
        $[6] = title;
        $[7] = t2;
    } else t2 = $[7];
    const handleCreateProjectClick = t2;
    let t3;
    if ($[8] !== onChatClick || $[9] !== threadId || $[10] !== title) {
        t3 = ()=>{
            onChatClick?.(threadId, title);
        };
        $[8] = onChatClick;
        $[9] = threadId;
        $[10] = title;
        $[11] = t3;
    } else t3 = $[11];
    const handleChatClick = t3;
    const hasActions = onCreateProjectClick != null || onDailyBriefClick != null || onChatClick != null;
    const hasInlineSourceLogos = !renderSources && sourceUrls && sourceUrls.length > 0;
    const hasInlineRenderSources = renderSources != null && hasActions;
    let t4;
    if ($[12] !== renderIcon) {
        t4 = renderIcon !== undefined ? renderIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f89244bd434c32b4$export$70844c87c892e091), null);
        $[12] = renderIcon;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, title);
        $[14] = title;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t4, t5));
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== subtitle) {
        t7 = subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, subtitle) : null;
        $[19] = subtitle;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== hasActions || $[22] !== hasInlineSourceLogos || $[23] !== renderSources || $[24] !== sourceUrls) {
        t8 = !hasInlineSourceLogos && !hasActions && !renderSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
            sources: sourceUrls ?? []
        }) : null;
        $[21] = hasActions;
        $[22] = hasInlineSourceLogos;
        $[23] = renderSources;
        $[24] = sourceUrls;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, t7, t8);
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    const cardHeader = t9;
    let t10;
    if ($[30] !== handleChatClick || $[31] !== handleCreateProjectClick || $[32] !== handleDailyBriefClick || $[33] !== hasActions || $[34] !== hasInlineRenderSources || $[35] !== hasInlineSourceLogos || $[36] !== intl || $[37] !== isCreateProjectDisabled || $[38] !== onChatClick || $[39] !== onCreateProjectClick || $[40] !== onDailyBriefClick || $[41] !== renderSources || $[42] !== sourceUrls || $[43] !== threadId || $[44] !== title) {
        t10 = hasInlineSourceLogos || hasInlineRenderSources || hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, onChatClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))),
            label: intl.formatMessage((0, $08c26370afa81833$export$2e2bcd8739ae039).chatAriaLabel, {
                threadTitle: title
            }),
            onClick: handleChatClick,
            appearance: "default",
            spacing: "default",
            testId: `chat-button-${threadId}`
        }) : null, onDailyBriefClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))),
            onClick: handleDailyBriefClick,
            appearance: "default",
            spacing: "default",
            testId: `daily-brief-button-${threadId}`
        }, intl.formatMessage((0, $08c26370afa81833$export$2e2bcd8739ae039).dailyBriefLabel)) : null, onCreateProjectClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleCreateProjectClick,
            appearance: "default",
            spacing: "default",
            isDisabled: isCreateProjectDisabled,
            testId: `create-project-button-${threadId}`
        }, intl.formatMessage((0, $08c26370afa81833$export$2e2bcd8739ae039).createProjectLabel)) : null), hasInlineRenderSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.actionsRowSpacer
        }, renderSources) : hasInlineSourceLogos ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.actionsRowSpacer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
            sources: sourceUrls ?? []
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.actionsRowSpacer
        })) : null;
        $[30] = handleChatClick;
        $[31] = handleCreateProjectClick;
        $[32] = handleDailyBriefClick;
        $[33] = hasActions;
        $[34] = hasInlineRenderSources;
        $[35] = hasInlineSourceLogos;
        $[36] = intl;
        $[37] = isCreateProjectDisabled;
        $[38] = onChatClick;
        $[39] = onCreateProjectClick;
        $[40] = onDailyBriefClick;
        $[41] = renderSources;
        $[42] = sourceUrls;
        $[43] = threadId;
        $[44] = title;
        $[45] = t10;
    } else t10 = $[45];
    const actionsRow = t10;
    const t11 = `thread-card-${threadId}`;
    let t12;
    if ($[46] !== cardHeader || $[47] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.staticBody,
            testId: t11
        }, cardHeader);
        $[46] = cardHeader;
        $[47] = t11;
        $[48] = t12;
    } else t12 = $[48];
    let t13;
    if ($[49] !== hasInlineRenderSources || $[50] !== renderSources) {
        t13 = renderSources && !hasInlineRenderSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.sourcesWrapper
        }, renderSources) : null;
        $[49] = hasInlineRenderSources;
        $[50] = renderSources;
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== actionsRow || $[53] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span"
        }, actionsRow, t13);
        $[52] = actionsRow;
        $[53] = t13;
        $[54] = t14;
    } else t14 = $[54];
    let t15;
    if ($[55] !== t12 || $[56] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.cardWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8942bc8ecc07882$var$styles.threadContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.250"
        }, t12, t14)));
        $[55] = t12;
        $[56] = t14;
        $[57] = t15;
    } else t15 = $[57];
    return t15;
} : ({ threadId: threadId, title: title, subtitle: subtitle, sourceUrls: sourceUrls, renderSources: renderSources, renderIcon: renderIcon, onDailyBriefClick: onDailyBriefClick, onCreateProjectClick: onCreateProjectClick, isCreateProjectDisabled: isCreateProjectDisabled, onChatClick: onChatClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleDailyBriefClick = ()=>{
        onDailyBriefClick?.(threadId, title);
    };
    const handleCreateProjectClick = ()=>{
        onCreateProjectClick?.(threadId, title);
    };
    const handleChatClick = ()=>{
        onChatClick?.(threadId, title);
    };
    const hasActions = onCreateProjectClick != null || onDailyBriefClick != null || onChatClick != null;
    const hasInlineSourceLogos = !renderSources && sourceUrls && sourceUrls.length > 0; // When renderSources is provided alongside actions, render sources inline in the actions row
    const hasInlineRenderSources = renderSources != null && hasActions; // Card header: only the icon, title, subtitle — rendered inside the Pressable
    const cardHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, renderIcon !== undefined ? renderIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f89244bd434c32b4$export$70844c87c892e091), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, title))), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, subtitle) : null, !hasInlineSourceLogos && !hasActions && !renderSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
        sources: sourceUrls ?? []
    }) : null); // Actions row: rendered OUTSIDE the Pressable to avoid nested interactive elements
    const actionsRow = hasInlineSourceLogos || hasInlineRenderSources || hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, onChatClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))),
        label: intl.formatMessage((0, $08c26370afa81833$export$2e2bcd8739ae039).chatAriaLabel, {
            threadTitle: title
        }),
        onClick: handleChatClick,
        appearance: "default",
        spacing: "default",
        testId: `chat-button-${threadId}`
    }) : null, onDailyBriefClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))),
        onClick: handleDailyBriefClick,
        appearance: "default",
        spacing: "default",
        testId: `daily-brief-button-${threadId}`
    }, intl.formatMessage((0, $08c26370afa81833$export$2e2bcd8739ae039).dailyBriefLabel)) : null, onCreateProjectClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleCreateProjectClick,
        appearance: "default",
        spacing: "default",
        isDisabled: isCreateProjectDisabled,
        testId: `create-project-button-${threadId}`
    }, intl.formatMessage((0, $08c26370afa81833$export$2e2bcd8739ae039).createProjectLabel)) : null), hasInlineRenderSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.actionsRowSpacer
    }, renderSources) : hasInlineSourceLogos ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.actionsRowSpacer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
        sources: sourceUrls ?? []
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.actionsRowSpacer
    })) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.cardWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.threadContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.staticBody,
        testId: `thread-card-${threadId}`
    }, cardHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span"
    }, actionsRow, renderSources && !hasInlineRenderSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8942bc8ecc07882$var$styles.sourcesWrapper
    }, renderSources) : null))));
};
const $f8942bc8ecc07882$export$7323721b3bab604f = /*#__PURE__*/ (0, $cozmU.memo)($f8942bc8ecc07882$var$ThreadCardComponent);



















var $5wHqn = parcelRequire("5wHqn");





var $kh0hi = parcelRequire("kh0hi");


var $bSXpv = parcelRequire("bSXpv");







const $9010c21b6cf94f93$var$messages = (0, $kSwu1.defineMessages)({
    sourcesButtonLabel: {
        id: "rovo-for-you.sources.sources-button-label",
        defaultMessage: "Show sources"
    }
});
var $9010c21b6cf94f93$export$2e2bcd8739ae039 = $9010c21b6cf94f93$var$messages;


const $51d101e934ecb577$var$ANALYTICS_CHANNEL = 'aiMate';
const $51d101e934ecb577$var$styles = {
    triggerWrapper: "_4xdlr07p2s",
    pressable: "_0bjKvDKTcp _30huDKYbGa _4c065UPgdg _0KLXrujOvk _0LQT5EFQfX _03SyCPPgdg _0wOv4Q7zJH _0Am33zKTcp _1eOmH6o126",
    selectedPressable: "_0bjKvDKTcp _30huDKmcMy _4c065UPgdg _0KLXruXsxn _0LQT5EFQfX _03SyCPPgdg _0wOv4Q7zJH"
};
const $51d101e934ecb577$export$8ab41367baa2859a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { sources: sources, testId: t1 } = t0;
    const testId = t1 === undefined ? "rovo-for-you-sources-button" : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[0] !== createAnalyticsEvent) {
        t2 = (type, ari)=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "sourceLink",
                attributes: {
                    is3pLink: !ari,
                    sourceType: type
                }
            }).fire($51d101e934ecb577$var$ANALYTICS_CHANNEL);
        };
        $[0] = createAnalyticsEvent;
        $[1] = t2;
    } else t2 = $[1];
    const handleSourceLinkClick = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setIsOpen(false);
        };
        $[2] = t3;
    } else t3 = $[2];
    const handleClose = t3;
    let t4;
    if ($[3] !== createAnalyticsEvent || $[4] !== isOpen) {
        t4 = (event)=>{
            event.stopPropagation();
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "sources",
                attributes: {
                    state: isOpen ? "closed" : "open"
                }
            }).fire($51d101e934ecb577$var$ANALYTICS_CHANNEL);
            setIsOpen($51d101e934ecb577$var$_temp);
        };
        $[3] = createAnalyticsEvent;
        $[4] = isOpen;
        $[5] = t4;
    } else t4 = $[5];
    const handleToggle = t4;
    if (sources.length === 0) return null;
    let t5;
    if ($[6] !== sources) {
        t5 = sources.map($51d101e934ecb577$var$_temp2);
        $[6] = sources;
        $[7] = t5;
    } else t5 = $[7];
    const sourceUrls = t5;
    let t6;
    if ($[8] !== handleSourceLinkClick || $[9] !== sources) {
        t6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bSXpv.SourcesPopupContent), {
                sources: sources,
                onClickSourceHandler: handleSourceLinkClick,
                onClose: handleClose
            });
        $[8] = handleSourceLinkClick;
        $[9] = sources;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== handleToggle || $[12] !== intl || $[13] !== isOpen || $[14] !== sourceUrls || $[15] !== testId) {
        t7 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                ...triggerProps,
                xcss: isOpen ? $51d101e934ecb577$var$styles.selectedPressable : $51d101e934ecb577$var$styles.pressable,
                testId: testId,
                "aria-label": intl.formatMessage((0, $9010c21b6cf94f93$export$2e2bcd8739ae039).sourcesButtonLabel),
                onClick: handleToggle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
                sources: sourceUrls
            }));
        $[11] = handleToggle;
        $[12] = intl;
        $[13] = isOpen;
        $[14] = sourceUrls;
        $[15] = testId;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== isOpen || $[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $51d101e934ecb577$var$styles.triggerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            placement: "bottom-start",
            isOpen: isOpen,
            onClose: handleClose,
            content: t6,
            trigger: t7
        }));
        $[17] = isOpen;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ sources: sources, testId: testId = 'rovo-for-you-sources-button' })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleSourceLinkClick = (0, $cozmU.useCallback)((type, ari)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'sourceLink',
            attributes: {
                is3pLink: !ari,
                sourceType: type
            }
        }).fire($51d101e934ecb577$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const handleToggle = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sources',
            attributes: {
                state: isOpen ? 'closed' : 'open'
            }
        }).fire($51d101e934ecb577$var$ANALYTICS_CHANNEL);
        setIsOpen((previousState)=>!previousState);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    if (sources.length === 0) return null;
    const sourceUrls = sources.map((source)=>source.url);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $51d101e934ecb577$var$styles.triggerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: handleClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bSXpv.SourcesPopupContent), {
                sources: sources,
                onClickSourceHandler: handleSourceLinkClick,
                onClose: handleClose
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                ...triggerProps,
                xcss: isOpen ? $51d101e934ecb577$var$styles.selectedPressable : $51d101e934ecb577$var$styles.pressable,
                testId: testId,
                "aria-label": intl.formatMessage((0, $9010c21b6cf94f93$export$2e2bcd8739ae039).sourcesButtonLabel),
                onClick: handleToggle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
                sources: sourceUrls
            }))
    }));
};
function $51d101e934ecb577$var$_temp(previousState) {
    return !previousState;
}
function $51d101e934ecb577$var$_temp2(source) {
    return source.url;
}


const $e44a07302b76a3a1$var$SOURCE_TYPE_MAP = {
    ConvoAiHomeThreadsConfluenceSourceData: 'ConfluencePage',
    ConvoAiHomeThreadsJiraSourceData: 'JiraIssue',
    ConvoAiHomeThreadsBitbucketSourceData: 'BitbucketRepository',
    ConvoAiHomeThreadsLoomSourceData: 'LoomVideo'
};
const $e44a07302b76a3a1$export$270ac04ebec7a40c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { space: space, sources: sources, emojiProvider: emojiProvider, onChatClick: onChatClick, onDailyBriefClick: onDailyBriefClick } = t0;
    let t1;
    if ($[0] !== space.id || $[1] !== space.name) {
        t1 = {
            spaceId: space.id,
            spaceName: space.name
        };
        $[0] = space.id;
        $[1] = space.name;
        $[2] = t1;
    } else t1 = $[2];
    const emptyChatActions = (0, $469e3ce09396ad62$export$1d903f8c25999b1a)(t1);
    let t2;
    bb0: {
        if (!sources.length) {
            let t3;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = [];
                $[3] = t3;
            } else t3 = $[3];
            t2 = t3;
            break bb0;
        }
        let t3;
        if ($[4] !== sources) {
            t3 = sources.map($e44a07302b76a3a1$var$_temp);
            $[4] = sources;
            $[5] = t3;
        } else t3 = $[5];
        t2 = t3;
    }
    const mappedSources = t2;
    let t3;
    if ($[6] !== emojiProvider || $[7] !== space.emoji) {
        t3 = space.emoji && emojiProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: {
                id: space.emoji,
                shortName: ""
            },
            emojiProvider: emojiProvider,
            fitToHeight: 16,
            showTooltip: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)"
        });
        $[6] = emojiProvider;
        $[7] = space.emoji;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== mappedSources) {
        t4 = mappedSources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51d101e934ecb577$export$8ab41367baa2859a), {
            sources: mappedSources,
            testId: "rovo-for-you-space-sources-button"
        }) : undefined;
        $[9] = mappedSources;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== onDailyBriefClick || $[12] !== space.emoji) {
        t5 = (id, name)=>onDailyBriefClick(id, name, space.emoji ?? "");
        $[11] = onDailyBriefClick;
        $[12] = space.emoji;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== emptyChatActions || $[15] !== onChatClick || $[16] !== space.emoji) {
        t6 = (id_0, name_0)=>onChatClick(id_0, name_0, space.emoji ?? "", emptyChatActions);
        $[14] = emptyChatActions;
        $[15] = onChatClick;
        $[16] = space.emoji;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== space.id || $[19] !== space.name || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8942bc8ecc07882$export$7323721b3bab604f), {
            threadId: space.id,
            title: space.name,
            renderIcon: t3,
            renderSources: t4,
            onDailyBriefClick: t5,
            onChatClick: t6
        });
        $[18] = space.id;
        $[19] = space.name;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
    } else t7 = $[24];
    return t7;
} : ({ space: space, sources: sources, emojiProvider: emojiProvider, onChatClick: onChatClick, onDailyBriefClick: onDailyBriefClick })=>{
    const emptyChatActions = (0, $469e3ce09396ad62$export$1d903f8c25999b1a)({
        spaceId: space.id,
        spaceName: space.name
    });
    const mappedSources = (0, $cozmU.useMemo)(()=>{
        if (!sources.length) return [];
        return sources.map((source)=>({
                ari: source.ari ?? '',
                title: source.name ?? source.url ?? '',
                type: $e44a07302b76a3a1$var$SOURCE_TYPE_MAP[source.sourceType ?? ''] ?? 'TownsquareLink',
                url: source.url ?? '',
                lastModified: ''
            }));
    }, [
        sources
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8942bc8ecc07882$export$7323721b3bab604f), {
        threadId: space.id,
        title: space.name,
        renderIcon: space.emoji && emojiProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: {
                id: space.emoji,
                shortName: ''
            },
            emojiProvider: emojiProvider,
            fitToHeight: 16,
            showTooltip: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)"
        }),
        renderSources: mappedSources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51d101e934ecb577$export$8ab41367baa2859a), {
            sources: mappedSources,
            testId: "rovo-for-you-space-sources-button"
        }) : undefined,
        onDailyBriefClick: (id, name)=>onDailyBriefClick(id, name, space.emoji ?? ''),
        onChatClick: (id_0, name_0)=>onChatClick(id_0, name_0, space.emoji ?? '', emptyChatActions)
    });
};
function $e44a07302b76a3a1$var$_temp(source) {
    return {
        ari: source.ari ?? "",
        title: source.name ?? source.url ?? "",
        type: $e44a07302b76a3a1$var$SOURCE_TYPE_MAP[source.sourceType ?? ""] ?? "TownsquareLink",
        url: source.url ?? "",
        lastModified: ""
    };
}


const $385bb391f95fd8fd$export$ea55ef727c032eee = ({ cloudId: cloudId, spaces: spaces, isLoading: isLoading, hasFetched: hasFetched, error: error, onChatEmptyLaunch: onChatEmptyLaunch })=>{
    const intl = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProvider)(cloudId), [
        cloudId
    ]);
    // Only pass the emoji provider to SpaceCard once it has resolved — prevents
    // ResourcedEmoji's loading placeholder from bleeding outside the panel bounds.
    const [isEmojiProviderReady, setIsEmojiProviderReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        emojiProvider.then(()=>setIsEmojiProviderReady(true));
    }, [
        emojiProvider
    ]);
    // Track spaces load outcome when loading completes.
    // Fire the fetch analytics event exactly once — when hasFetched first becomes true.
    // hasFetched is managed by the store and only ever transitions false → true,
    // so it naturally prevents double-firing on re-renders or background refetches.
    (0, $cozmU.useEffect)(()=>{
        if (!hasFetched) return;
        if (error) sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'mySpaces',
            action: 'failed'
        });
        else sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'mySpaces',
            action: 'fetched',
            attributes: {
                spaceCount: spaces?.length ?? 0
            }
        });
    // hasFetched only ever goes false → true so this effect fires exactly once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasFetched
    ]);
    /** Opens chat in empty-state mode with the selected space as context and a custom greeting. */ const handleChatClick = (0, $cozmU.useCallback)((spaceId, spaceName, spaceEmoji, customConversationActions)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'spaceCard',
            action: 'clicked',
            actionSubjectId: 'chat',
            attributes: {
                spaceId: spaceId,
                spaceName: spaceName
            }
        });
        onChatEmptyLaunch?.({
            spaceId: spaceId,
            spaceName: spaceName,
            spaceEmoji: spaceEmoji,
            greetingTitle: intl.formatMessage((0, $2e491f5bc322938a$export$2e2bcd8739ae039).chatGreeting),
            customConversationActions: customConversationActions,
            replaceProviderActions: true,
            skillRegistryTags: [
                (0, $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe)
            ],
            launchTabId: (0, $5fb0e87a487b8b7b$export$4e2d22a4f1ea8ef3)
        });
    }, [
        onChatEmptyLaunch,
        intl,
        sendAnalyticsEvent
    ]);
    /** Opens Rovo Chat with a daily brief prompt for the given space. */ const handleDailyBriefClick = (0, $cozmU.useCallback)((spaceId, spaceName, spaceEmoji)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'spaceCard',
            action: 'clicked',
            actionSubjectId: 'dailyBrief',
            attributes: {
                spaceId: spaceId
            }
        });
        const payload = {
            type: 'chat-new',
            source: 'my-spaces-daily-brief',
            openChat: false,
            openChatMode: 'mini-modal',
            data: {
                name: intl.formatMessage((0, $2e491f5bc322938a$export$2e2bcd8739ae039).dailyBriefChatName, {
                    spaceName: spaceName
                }),
                dialogues: [],
                prompt: '/get-workstream-brief ',
                selectedSpace: {
                    id: spaceId,
                    name: spaceName,
                    emoji: spaceEmoji
                },
                aiFeatureContext: {
                    projectContext: {
                        projectId: spaceId,
                        projectName: spaceName,
                        projectUrl: ''
                    }
                }
            }
        };
        publish(payload);
    }, [
        publish,
        intl,
        sendAnalyticsEvent
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).MY_PROJECTS_LIST_QUERY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff43df5b2db7b526$export$e58168d515763c4), null));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
        name: (0, $irnO2.ExperienceName).MY_PROJECTS_LIST_QUERY,
        error: error
    });
    if (!spaces || spaces.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).MY_PROJECTS_LIST_QUERY
    });
    const displayedSpaces = spaces.slice(0, 5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).MY_PROJECTS_LIST_QUERY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xxsmall",
        as: "h4"
    }, intl.formatMessage((0, $2e491f5bc322938a$export$2e2bcd8739ae039).mySpacesSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "group",
        "aria-label": intl.formatMessage((0, $2e491f5bc322938a$export$2e2bcd8739ae039).mySpacesListLabel),
        testId: "my-spaces-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, displayedSpaces.map((space)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e44a07302b76a3a1$export$270ac04ebec7a40c), {
            key: space.id,
            space: space,
            sources: space.sources ?? [],
            emojiProvider: isEmojiProviderReady ? emojiProvider : null,
            onChatClick: handleChatClick,
            onDailyBriefClick: handleDailyBriefClick
        })))));
};





























const $310f67728893b043$var$messages = (0, $kSwu1.defineMessages)({
    loadingThreadsLabel: {
        id: "rovo-for-you.threads-list-skeleton.loading-threads-label",
        defaultMessage: "Loading threads"
    }
});
var $310f67728893b043$export$2e2bcd8739ae039 = $310f67728893b043$var$messages;


const $39ff0a764a380560$var$SKELETON_CARD_COUNT = 3;
const $39ff0a764a380560$var$styles = {
    container: "_39xV02N91d",
    card: "_0bjKvD8fU6 _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headerRow: "_39xV02N91d",
    sourceIconsRow: "_3iDTPbQ4SZ _0hPCNLDIqT",
    overlappingIcon: "_2XsHFM5UaJ"
};
/** Renders a single placeholder thread card skeleton */ const $39ff0a764a380560$var$ThreadCardSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { showBadge: showBadge } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-tile, 25%)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 120,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== showBadge) {
        t2 = showBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 24,
            height: 20,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        });
        $[1] = showBadge;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $39ff0a764a380560$var$styles.headerRow
        }, t1, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60%",
            height: 14,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        });
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 20,
            height: 20,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        });
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $39ff0a764a380560$var$styles.overlappingIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 20,
            height: 20,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }));
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $39ff0a764a380560$var$styles.sourceIconsRow
        }, t5, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $39ff0a764a380560$var$styles.overlappingIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 20,
            height: 20,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 24,
            height: 14,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t3) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $39ff0a764a380560$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t3, t4, t7));
        $[9] = t3;
        $[10] = t8;
    } else t8 = $[10];
    return t8;
} : ({ showBadge: showBadge })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39ff0a764a380560$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $39ff0a764a380560$var$styles.headerRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-tile, 25%)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 120,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), showBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 24,
        height: 20,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "60%",
        height: 14,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39ff0a764a380560$var$styles.sourceIconsRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 20,
        height: 20,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39ff0a764a380560$var$styles.overlappingIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 20,
        height: 20,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39ff0a764a380560$var$styles.overlappingIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 20,
        height: 20,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 24,
        height: 14,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }))));
};
const $39ff0a764a380560$export$aaa96717a0548da9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $310f67728893b043$export$2e2bcd8739ae039).loadingThreadsLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, Array.from({
            length: $39ff0a764a380560$var$SKELETON_CARD_COUNT
        }, $39ff0a764a380560$var$_temp));
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $39ff0a764a380560$var$styles.container,
            role: "group",
            "aria-label": t0
        }, t1);
        $[3] = t0;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39ff0a764a380560$var$styles.container,
        role: "group",
        "aria-label": intl.formatMessage((0, $310f67728893b043$export$2e2bcd8739ae039).loadingThreadsLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, Array.from({
        length: $39ff0a764a380560$var$SKELETON_CARD_COUNT
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($39ff0a764a380560$var$ThreadCardSkeleton, {
            key: index,
            showBadge: index === 1
        }))));
};
function $39ff0a764a380560$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($39ff0a764a380560$var$ThreadCardSkeleton, {
        key: index,
        showBadge: index === 1
    });
}








/**
 * @generated SignedSource<<083018f15dfafe95ddcdd879b68deb3f>>
 * @relayHash 76c0cf917603f55f5d533f0e415e3d87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c36dc0f282e96a851567f6917fdb2f959aaf6d8b1fe52afdb4cb7d99675049e5
const $7fbaeaf8b488d3c6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "experience"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "homeThreadsInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "homeThreadsInput",
            "variableName": "homeThreadsInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "ConvoAiHomeThreadsThirdPartySource"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThreadsListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConvoAiHomeThreadsResult",
                    "kind": "LinkedField",
                    "name": "convoai_homeThreads",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConvoAiHomeThreadsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConvoAiHomeThread",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "sources",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThreadsListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConvoAiHomeThreadsResult",
                    "kind": "LinkedField",
                    "name": "convoai_homeThreads",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConvoAiHomeThreadsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConvoAiHomeThread",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "sources",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v2 /*: any*/ 
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c36dc0f282e96a851567f6917fdb2f959aaf6d8b1fe52afdb4cb7d99675049e5",
            "metadata": {},
            "name": "ThreadsListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7fbaeaf8b488d3c6$var$node.hash = "70706c4b0fd1f08fc48a18ca5c13086f";
var $7fbaeaf8b488d3c6$export$2e2bcd8739ae039 = $7fbaeaf8b488d3c6$var$node;






var $55fM8 = parcelRequire("55fM8");



























/**
 * Shared helpers for processing thread recommendations from the convoai_homeThreads
 * GraphQL endpoint.
 */ const $536ed46cc0a55681$export$b16299009b75b91c = (dataTypename)=>{
    if (!dataTypename) return 'unknown';
    // ConvoAiHomeThreadsConfluenceData → confluence, ConvoAiHomeThreadsJiraData → jira, etc.
    const match = dataTypename.match(/ConvoAiHomeThreads(\w+)Data/);
    return match ? match[1].toLowerCase() : dataTypename.toLowerCase();
};
const $536ed46cc0a55681$export$b0562f9d297f9fcd = (url)=>{
    try {
        const hostname = new URL(url).hostname;
        if (hostname.includes('atlassian.net') && url.includes('/browse/')) return 'jira';
        if (hostname.includes('atlassian.net') && url.includes('/wiki/')) return 'confluence';
        if (hostname.includes('bitbucket')) return 'bitbucket';
        if (hostname.includes('loom')) return 'loom';
        if (hostname.includes('github')) return 'github';
    } catch  {
    // fall through
    }
    return 'unknown';
};
const $536ed46cc0a55681$export$694f639fbcdd3f35 = (url, sourceType)=>{
    try {
        const urlObj = new URL(url);
        const path = urlObj.pathname;
        if (sourceType === 'jira') {
            const match = path.match(/\/browse\/([A-Z]+-\d+)/);
            return match ? match[1] : 'Jira issue';
        }
        if (sourceType === 'confluence') {
            const parts = path.split('/');
            const lastPart = parts[parts.length - 1];
            return lastPart ? decodeURIComponent(lastPart.replace(/\+/g, ' ')) : 'Confluence page';
        }
        if (sourceType === 'loom') {
            // Loom URLs look like /share/my-video-title-UUID or /share/UUID
            // Only extract a title if the slug has hyphens (i.e. it's a title slug, not a bare ID)
            const match = path.match(/\/share\/(.+)$/);
            if (match) {
                const slug = match[1];
                // Remove trailing 32-char hex UUID segment (e.g. "-abc123def456...")
                const withoutUuid = slug.replace(/-[a-f0-9]{32}$/, '');
                // Only use as a title if it still contains hyphens after UUID removal
                if (withoutUuid.includes('-')) {
                    const title = withoutUuid.replace(/-/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
                    return title || 'Loom video';
                }
            }
            return 'Loom video';
        }
        if (sourceType === 'bitbucket') {
            // Bitbucket PR URLs look like /workspace/repo/pull-requests/123
            const prMatch = path.match(/\/([^/]+)\/([^/]+)\/pull-requests\/(\d+)/);
            if (prMatch) return `${prMatch[2]}#${prMatch[3]}`;
            // Bitbucket repo URLs look like /workspace/repo
            const repoMatch = path.match(/\/([^/]+)\/([^/]+)\/?$/);
            if (repoMatch) return repoMatch[2];
            return 'Bitbucket';
        }
    } catch  {
    // fall through
    }
    return url;
};
const $536ed46cc0a55681$export$37aba3066a765a03 = (sources)=>{
    const sourceUrls = [];
    const spaceSources = [];
    sources.forEach((source)=>{
        const url = source.__typename === 'ConvoAiHomeThreadsFirstPartySource' || source.__typename === 'ConvoAiHomeThreadsThirdPartySource' ? source.url ?? '' : '';
        if (url) sourceUrls.push(url);
        if (source.__typename === 'ConvoAiHomeThreadsFirstPartySource' && source.ari) {
            const sourceType = $536ed46cc0a55681$export$b16299009b75b91c(source.data?.__typename);
            spaceSources.push({
                ari: source.ari,
                url: url,
                sourceType: sourceType,
                conversationIds: [],
                name: $536ed46cc0a55681$export$694f639fbcdd3f35(url, sourceType)
            });
        } else if (source.__typename === 'ConvoAiHomeThreadsThirdPartySource' && url) {
            const sourceType = $536ed46cc0a55681$export$b0562f9d297f9fcd(url);
            spaceSources.push({
                ari: url,
                url: url,
                sourceType: sourceType,
                conversationIds: [],
                name: $536ed46cc0a55681$export$694f639fbcdd3f35(url, sourceType)
            });
        }
    });
    return {
        sourceUrls: sourceUrls,
        spaceSources: spaceSources
    };
};




var $72Oi6 = parcelRequire("72Oi6");







const $1ba3501019c9bc9a$var$messages = (0, $kSwu1.defineMessages)({
    threadsListLabel: {
        id: "rovo-for-you.threads-list.label",
        defaultMessage: "Threads"
    },
    suggestedSpacesSectionHeading: {
        id: "rovo-for-you.threads-list.recommended-rovo-spaces-section-heading",
        defaultMessage: "Recommended Rovo spaces"
    }
});
var $1ba3501019c9bc9a$export$2e2bcd8739ae039 = $1ba3501019c9bc9a$var$messages;












const $68f16f61aed3355e$export$40467b362aa82ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { sources: sources, testId: testId } = t0;
    let t1;
    if ($[0] !== sources) {
        t1 = sources.filter($68f16f61aed3355e$var$_temp).map($68f16f61aed3355e$var$_temp2);
        $[0] = sources;
        $[1] = t1;
    } else t1 = $[1];
    const mappedSources = t1;
    if (mappedSources.length === 0) return null;
    let t2;
    if ($[2] !== mappedSources || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51d101e934ecb577$export$8ab41367baa2859a), {
            sources: mappedSources,
            testId: testId
        });
        $[2] = mappedSources;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ sources: sources, testId: testId })=>{
    const mappedSources = sources.filter((source)=>source.__typename === 'ConvoAiHomeThreadsFirstPartySource' || source.__typename === 'ConvoAiHomeThreadsThirdPartySource').map((source_0)=>({
            ari: source_0.__typename === 'ConvoAiHomeThreadsFirstPartySource' ? source_0.ari ?? '' : '',
            title: '',
            type: source_0.__typename === 'ConvoAiHomeThreadsFirstPartySource' && source_0.data?.__typename ? source_0.data.__typename : source_0.__typename ?? '',
            url: source_0.url ?? '',
            lastModified: ''
        }));
    if (mappedSources.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51d101e934ecb577$export$8ab41367baa2859a), {
        sources: mappedSources,
        testId: testId
    });
};
function $68f16f61aed3355e$var$_temp(source) {
    return source.__typename === "ConvoAiHomeThreadsFirstPartySource" || source.__typename === "ConvoAiHomeThreadsThirdPartySource";
}
function $68f16f61aed3355e$var$_temp2(source_0) {
    return {
        ari: source_0.__typename === "ConvoAiHomeThreadsFirstPartySource" ? source_0.ari ?? "" : "",
        title: "",
        type: source_0.__typename === "ConvoAiHomeThreadsFirstPartySource" && source_0.data?.__typename ? source_0.data.__typename : source_0.__typename ?? "",
        url: source_0.url ?? "",
        lastModified: ""
    };
}



/** Touchpoint identifier reported for spaces created from the For You tab. */ const $d8001d7f45735a37$var$FOR_YOU_TOUCHPOINT_SOURCE = 'rovo-for-you-tab';
/** Experience id for the ai-mate surface, forwarded to recommendation and create requests. */ const $d8001d7f45735a37$var$AI_MATE_EXPERIENCE_ID = 'ai-mate';
/** Delay in milliseconds before a hover event is fired, to filter out accidental hovers. */ const $d8001d7f45735a37$var$HOVER_DEBOUNCE_DELAY_MS = 200;
/**
 * Shared renderer for recommendation threads returned by either REST or GraphQL.
 *
 * Threads are filtered to hide any thread whose `id` is already present as a `conversationId`
 * on any source of any space — the user has already organized that thread, so it shouldn't
 * appear as a suggestion to create a new space from.
 */ const $d8001d7f45735a37$var$ThreadsListRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(65);
    const { cloudId: cloudId, spacesConversationIds: spacesConversationIds, onSpaceCreated: onSpaceCreated, onEmpty: onEmpty, product: product, threads: threads, onRecommendationsChanged: onRecommendationsChanged } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] !== cloudId || $[1] !== product) {
        t1 = {
            touchpointSource: $d8001d7f45735a37$var$FOR_YOU_TOUCHPOINT_SOURCE,
            product: product,
            experienceId: $d8001d7f45735a37$var$AI_MATE_EXPERIENCE_ID,
            siteId: cloudId
        };
        $[0] = cloudId;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    const assistanceServiceParams = t1;
    let t2;
    if ($[3] !== spacesConversationIds) {
        t2 = new Set(spacesConversationIds);
        $[3] = spacesConversationIds;
        $[4] = t2;
    } else t2 = $[4];
    const threadIdsInSpaces = t2;
    let t3;
    if ($[5] !== threadIdsInSpaces || $[6] !== threads) {
        let t4;
        if ($[8] !== threadIdsInSpaces) {
            t4 = (thread)=>!threadIdsInSpaces.has(thread.id);
            $[8] = threadIdsInSpaces;
            $[9] = t4;
        } else t4 = $[9];
        t3 = threads.filter(t4);
        $[5] = threadIdsInSpaces;
        $[6] = threads;
        $[7] = t3;
    } else t3 = $[7];
    const visibleThreads = t3;
    const isEmpty = visibleThreads.length === 0;
    let t4;
    let t5;
    if ($[10] !== isEmpty || $[11] !== onEmpty) {
        t4 = ()=>{
            onEmpty?.(isEmpty);
        };
        t5 = [
            isEmpty,
            onEmpty
        ];
        $[10] = isEmpty;
        $[11] = onEmpty;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[14] !== sendAnalyticsEvent) {
        t6 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((threadId)=>{
            sendAnalyticsEvent({
                actionSubject: "threadCard",
                action: "hovered",
                eventType: "ui",
                attributes: {
                    threadId: threadId
                }
            });
        }, $d8001d7f45735a37$var$HOVER_DEBOUNCE_DELAY_MS);
        $[14] = sendAnalyticsEvent;
        $[15] = t6;
    } else t6 = $[15];
    const debouncedSendHoverEvent = t6;
    let t7;
    let t8;
    if ($[16] !== debouncedSendHoverEvent) {
        t7 = ()=>()=>{
                debouncedSendHoverEvent.cancel();
            };
        t8 = [
            debouncedSendHoverEvent
        ];
        $[16] = debouncedSendHoverEvent;
        $[17] = t7;
        $[18] = t8;
    } else {
        t7 = $[17];
        t8 = $[18];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[19] !== debouncedSendHoverEvent) {
        t9 = (threadId_0)=>{
            debouncedSendHoverEvent(threadId_0);
        };
        $[19] = debouncedSendHoverEvent;
        $[20] = t9;
    } else t9 = $[20];
    const handleThreadHover = t9;
    let t10;
    if ($[21] !== debouncedSendHoverEvent) {
        t10 = ()=>{
            debouncedSendHoverEvent.cancel();
        };
        $[21] = debouncedSendHoverEvent;
        $[22] = t10;
    } else t10 = $[22];
    const handleThreadHoverLeave = t10;
    const [isCreateSpaceModalOpen, setIsCreateSpaceModalOpen] = (0, $cozmU.useState)(false);
    const [createSpaceInitialName, setCreateSpaceInitialName] = (0, $cozmU.useState)(undefined);
    const [createSpaceInitialThreadId, setCreateSpaceInitialThreadId] = (0, $cozmU.useState)(undefined);
    const [createSpaceInitialSources, setCreateSpaceInitialSources] = (0, $cozmU.useState)(undefined);
    let t11;
    if ($[23] !== sendAnalyticsEvent) {
        t11 = (threadId_1, threadTitle, sources)=>{
            sendAnalyticsEvent({
                actionSubject: "createSpaceButton",
                action: "clicked",
                eventType: "ui",
                attributes: {
                    threadId: threadId_1
                }
            });
            setCreateSpaceInitialName(threadTitle);
            setCreateSpaceInitialThreadId(threadId_1);
            setCreateSpaceInitialSources(sources);
            setIsCreateSpaceModalOpen(true);
        };
        $[23] = sendAnalyticsEvent;
        $[24] = t11;
    } else t11 = $[24];
    const handleCreateSpaceClick = t11;
    if (isEmpty) {
        let t12;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
                name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
            }));
            $[25] = t12;
        } else t12 = $[25];
        return t12;
    }
    let t12;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
        });
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== intl) {
        t13 = intl.formatMessage((0, $1ba3501019c9bc9a$export$2e2bcd8739ae039).suggestedSpacesSectionHeading);
        $[27] = intl;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xxsmall",
            as: "h4"
        }, t13);
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== intl) {
        t15 = intl.formatMessage((0, $1ba3501019c9bc9a$export$2e2bcd8739ae039).threadsListLabel);
        $[31] = intl;
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] !== handleCreateSpaceClick || $[34] !== handleThreadHover || $[35] !== handleThreadHoverLeave || $[36] !== visibleThreads) {
        let t17;
        if ($[38] !== handleCreateSpaceClick || $[39] !== handleThreadHover || $[40] !== handleThreadHoverLeave) {
            t17 = (thread_0)=>{
                const threadId_2 = thread_0.id;
                const sources_0 = thread_0.sources ?? [];
                const spaceSources = sources_0.length > 0 ? (0, $536ed46cc0a55681$export$37aba3066a765a03)(sources_0).spaceSources : undefined;
                const modalSources = spaceSources && spaceSources.length > 0 ? spaceSources : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: threadId_2,
                    onMouseEnter: ()=>handleThreadHover(threadId_2),
                    onMouseLeave: handleThreadHoverLeave,
                    onFocus: ()=>handleThreadHover(threadId_2),
                    onBlur: handleThreadHoverLeave
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8942bc8ecc07882$export$7323721b3bab604f), {
                    threadId: threadId_2,
                    title: thread_0.title,
                    renderIcon: null,
                    renderSources: sources_0.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68f16f61aed3355e$export$40467b362aa82ae), {
                        sources: sources_0,
                        testId: "rovo-for-you-brief-sources-button"
                    }) : undefined,
                    onCreateProjectClick: (id, title)=>handleCreateSpaceClick(id, title, modalSources)
                }));
            };
            $[38] = handleCreateSpaceClick;
            $[39] = handleThreadHover;
            $[40] = handleThreadHoverLeave;
            $[41] = t17;
        } else t17 = $[41];
        t16 = visibleThreads.map(t17);
        $[33] = handleCreateSpaceClick;
        $[34] = handleThreadHover;
        $[35] = handleThreadHoverLeave;
        $[36] = visibleThreads;
        $[37] = t16;
    } else t16 = $[37];
    let t17;
    if ($[42] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t16);
        $[42] = t16;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t15 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "group",
            "aria-label": t15,
            testId: "threads-list"
        }, t17);
        $[44] = t15;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
        });
        $[47] = t19;
    } else t19 = $[47];
    let t20;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = ()=>{
            setIsCreateSpaceModalOpen(false);
            setCreateSpaceInitialName(undefined);
            setCreateSpaceInitialThreadId(undefined);
            setCreateSpaceInitialSources(undefined);
        };
        $[48] = t20;
    } else t20 = $[48];
    let t21;
    if ($[49] !== createSpaceInitialSources || $[50] !== onRecommendationsChanged || $[51] !== onSpaceCreated) {
        t21 = (space, emojiId, attachedConversationId)=>{
            onSpaceCreated(space, emojiId, attachedConversationId, createSpaceInitialSources);
            onRecommendationsChanged?.();
        };
        $[49] = createSpaceInitialSources;
        $[50] = onRecommendationsChanged;
        $[51] = onSpaceCreated;
        $[52] = t21;
    } else t21 = $[52];
    let t22;
    if ($[53] !== assistanceServiceParams || $[54] !== cloudId || $[55] !== createSpaceInitialName || $[56] !== createSpaceInitialSources || $[57] !== createSpaceInitialThreadId || $[58] !== isCreateSpaceModalOpen || $[59] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gh5g4.CreateSpaceModal), {
            isOpen: isCreateSpaceModalOpen,
            assistanceServiceParams: assistanceServiceParams,
            onClose: t20,
            onCreated: t21,
            cloudId: cloudId,
            initialName: createSpaceInitialName,
            initialConversationId: createSpaceInitialThreadId,
            initialSources: createSpaceInitialSources
        });
        $[53] = assistanceServiceParams;
        $[54] = cloudId;
        $[55] = createSpaceInitialName;
        $[56] = createSpaceInitialSources;
        $[57] = createSpaceInitialThreadId;
        $[58] = isCreateSpaceModalOpen;
        $[59] = t21;
        $[60] = t22;
    } else t22 = $[60];
    let t23;
    if ($[61] !== t14 || $[62] !== t18 || $[63] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t12, t14, t18, t19, t22);
        $[61] = t14;
        $[62] = t18;
        $[63] = t22;
        $[64] = t23;
    } else t23 = $[64];
    return t23;
} : ({ cloudId: cloudId, spacesConversationIds: spacesConversationIds, onSpaceCreated: onSpaceCreated, onEmpty: onEmpty, product: product, threads: threads, onRecommendationsChanged: onRecommendationsChanged })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const assistanceServiceParams = (0, $cozmU.useMemo)(()=>({
            touchpointSource: $d8001d7f45735a37$var$FOR_YOU_TOUCHPOINT_SOURCE,
            product: product,
            experienceId: $d8001d7f45735a37$var$AI_MATE_EXPERIENCE_ID,
            siteId: cloudId
        }), [
        product,
        cloudId
    ]);
    // Keep this client-side filter even on the REST path. The endpoint filters converted threads
    // server-side, while this filter hides a newly created space immediately from optimistic store
    // state without waiting for backend propagation or another recommendation request.
    const threadIdsInSpaces = (0, $cozmU.useMemo)(()=>new Set(spacesConversationIds), [
        spacesConversationIds
    ]);
    const visibleThreads = (0, $cozmU.useMemo)(()=>threads.filter((thread)=>!threadIdsInSpaces.has(thread.id)), [
        threads,
        threadIdsInSpaces
    ]);
    const isEmpty = visibleThreads.length === 0;
    (0, $cozmU.useEffect)(()=>{
        onEmpty?.(isEmpty);
    }, [
        isEmpty,
        onEmpty
    ]);
    const debouncedSendHoverEvent = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((threadId)=>{
            sendAnalyticsEvent({
                actionSubject: 'threadCard',
                action: 'hovered',
                eventType: 'ui',
                attributes: {
                    threadId: threadId
                }
            });
        }, $d8001d7f45735a37$var$HOVER_DEBOUNCE_DELAY_MS), [
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            debouncedSendHoverEvent.cancel();
        };
    }, [
        debouncedSendHoverEvent
    ]);
    const handleThreadHover = (0, $cozmU.useCallback)((threadId_0)=>{
        debouncedSendHoverEvent(threadId_0);
    }, [
        debouncedSendHoverEvent
    ]);
    const handleThreadHoverLeave = (0, $cozmU.useCallback)(()=>{
        debouncedSendHoverEvent.cancel();
    }, [
        debouncedSendHoverEvent
    ]);
    const [isCreateSpaceModalOpen, setIsCreateSpaceModalOpen] = (0, $cozmU.useState)(false);
    const [createSpaceInitialName, setCreateSpaceInitialName] = (0, $cozmU.useState)(undefined);
    const [createSpaceInitialThreadId, setCreateSpaceInitialThreadId] = (0, $cozmU.useState)(undefined);
    const [createSpaceInitialSources, setCreateSpaceInitialSources] = (0, $cozmU.useState)(undefined);
    const handleCreateSpaceClick = (0, $cozmU.useCallback)((threadId_1, threadTitle, sources)=>{
        sendAnalyticsEvent({
            actionSubject: 'createSpaceButton',
            action: 'clicked',
            eventType: 'ui',
            attributes: {
                threadId: threadId_1
            }
        });
        setCreateSpaceInitialName(threadTitle);
        setCreateSpaceInitialThreadId(threadId_1);
        setCreateSpaceInitialSources(sources);
        setIsCreateSpaceModalOpen(true);
    }, [
        sendAnalyticsEvent
    ]);
    if (isEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xxsmall",
        as: "h4"
    }, intl.formatMessage((0, $1ba3501019c9bc9a$export$2e2bcd8739ae039).suggestedSpacesSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "group",
        "aria-label": intl.formatMessage((0, $1ba3501019c9bc9a$export$2e2bcd8739ae039).threadsListLabel),
        testId: "threads-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, visibleThreads.map((thread_0)=>{
        const threadId_2 = thread_0.id;
        const sources_0 = thread_0.sources ?? [];
        // Build the create-space sources using the shared helper (also used by the
        // Recommended Spaces panel and the side-nav recommended card) so first-party
        // sources keep their real ARI, third-party sources fall back to the URL, and
        // `sourceType`/`name`/`conversationIds` are resolved identically.
        const spaceSources = sources_0.length > 0 ? (0, $536ed46cc0a55681$export$37aba3066a765a03)(sources_0).spaceSources : undefined;
        const modalSources = spaceSources && spaceSources.length > 0 ? spaceSources : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: threadId_2,
            onMouseEnter: ()=>handleThreadHover(threadId_2),
            onMouseLeave: handleThreadHoverLeave,
            onFocus: ()=>handleThreadHover(threadId_2),
            onBlur: handleThreadHoverLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8942bc8ecc07882$export$7323721b3bab604f), {
            threadId: threadId_2,
            title: thread_0.title,
            renderIcon: null,
            renderSources: sources_0.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68f16f61aed3355e$export$40467b362aa82ae), {
                sources: sources_0,
                testId: "rovo-for-you-brief-sources-button"
            }) : undefined,
            onCreateProjectClick: (id, title)=>handleCreateSpaceClick(id, title, modalSources)
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gh5g4.CreateSpaceModal), {
        isOpen: isCreateSpaceModalOpen,
        assistanceServiceParams: assistanceServiceParams,
        onClose: ()=>{
            setIsCreateSpaceModalOpen(false);
            setCreateSpaceInitialName(undefined);
            setCreateSpaceInitialThreadId(undefined);
            setCreateSpaceInitialSources(undefined);
        },
        onCreated: (space, emojiId, attachedConversationId)=>{
            onSpaceCreated(space, emojiId, attachedConversationId, createSpaceInitialSources);
            onRecommendationsChanged?.();
        },
        cloudId: cloudId,
        initialName: createSpaceInitialName,
        initialConversationId: createSpaceInitialThreadId,
        initialSources: createSpaceInitialSources
    }));
};
/** Legacy GraphQL data source retained as the `rovo_space_recommended` fallback. */ const $d8001d7f45735a37$var$GraphQLThreadsList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(15);
    const [threadsFetchKey, setThreadsFetchKey] = (0, $cozmU.useState)(0);
    let t0;
    if ($[0] !== props.userId) {
        t0 = {
            userId: props.userId
        };
        $[0] = props.userId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.cloudId || $[3] !== t0) {
        t1 = {
            cloudId: props.cloudId,
            experience: "home-threads",
            homeThreadsInput: t0
        };
        $[2] = props.cloudId;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== threadsFetchKey) {
        t2 = {
            fetchPolicy: "store-or-network",
            fetchKey: threadsFetchKey
        };
        $[5] = threadsFetchKey;
        $[6] = t2;
    } else t2 = $[6];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $7fbaeaf8b488d3c6$export$2e2bcd8739ae039), t1, t2);
    let t3;
    if ($[7] !== data.convoai_homeThreads?.edges) {
        t3 = data.convoai_homeThreads?.edges ?? [];
        $[7] = data.convoai_homeThreads?.edges;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = t3.flatMap($d8001d7f45735a37$var$_temp2);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const threads = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setThreadsFetchKey($d8001d7f45735a37$var$_temp3);
        };
        $[11] = t5;
    } else t5 = $[11];
    const handleRecommendationsChanged = t5;
    let t6;
    if ($[12] !== props || $[13] !== threads) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$ThreadsListRenderer, {
            ...props,
            threads: threads,
            onRecommendationsChanged: handleRecommendationsChanged
        });
        $[12] = props;
        $[13] = threads;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : (props)=>{
    const [threadsFetchKey, setThreadsFetchKey] = (0, $cozmU.useState)(0);
    const data = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- source fields consumed structurally by Sources and extractSourcesFromThread */ (0, $7fbaeaf8b488d3c6$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        cloudId: props.cloudId,
        experience: 'home-threads',
        homeThreadsInput: {
            userId: props.userId
        }
    }, {
        fetchPolicy: 'store-or-network',
        fetchKey: threadsFetchKey
    });
    const threads = (0, $cozmU.useMemo)(()=>(data.convoai_homeThreads?.edges ?? []).flatMap((edge)=>{
            const node = edge.node;
            if (!node?.id || !node.title) return [];
            return [
                {
                    id: node.id,
                    title: node.title,
                    sources: node.sources?.filter((source)=>source != null) ?? null
                }
            ];
        }), [
        data
    ]);
    const handleRecommendationsChanged = (0, $cozmU.useCallback)(()=>{
        setThreadsFetchKey((previousKey)=>previousKey + 1);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$ThreadsListRenderer, {
        ...props,
        threads: threads,
        onRecommendationsChanged: handleRecommendationsChanged
    });
};
/** REST data source used when `rovo_space_recommended` is enabled. */ const $d8001d7f45735a37$var$RESTThreadsList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== props.cloudId) {
        t0 = {
            cloudId: props.cloudId,
            product: "rovo",
            experienceId: $d8001d7f45735a37$var$AI_MATE_EXPERIENCE_ID
        };
        $[0] = props.cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { threads: threads, isLoading: isLoading, error: error } = (0, $72Oi6.useRecommendedSpaces)(t0);
    if (error) throw error;
    if (isLoading) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39ff0a764a380560$export$aaa96717a0548da9), null);
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== props || $[4] !== threads) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$ThreadsListRenderer, {
            ...props,
            threads: threads
        });
        $[3] = props;
        $[4] = threads;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : (props)=>{
    const { threads: threads, isLoading: isLoading, error: error } = (0, $72Oi6.useRecommendedSpaces)({
        cloudId: props.cloudId,
        product: 'rovo',
        experienceId: $d8001d7f45735a37$var$AI_MATE_EXPERIENCE_ID
    });
    if (error) throw error;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39ff0a764a380560$export$aaa96717a0548da9), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$ThreadsListRenderer, {
        ...props,
        threads: threads
    });
};
const $d8001d7f45735a37$export$ae4aa9d74faeeaeb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("rovo_space_recommended") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$RESTThreadsList, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$GraphQLThreadsList, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $iDrrr.fg)('rovo_space_recommended') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$RESTThreadsList, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8001d7f45735a37$var$GraphQLThreadsList, props);
function $d8001d7f45735a37$var$_temp(source) {
    return source != null;
}
function $d8001d7f45735a37$var$_temp2(edge) {
    const node = edge.node;
    if (!node?.id || !node.title) return [];
    return [
        {
            id: node.id,
            title: node.title,
            sources: node.sources?.filter($d8001d7f45735a37$var$_temp) ?? null
        }
    ];
}
function $d8001d7f45735a37$var$_temp3(previousKey) {
    return previousKey + 1;
}



const $a40f11736e2ea035$var$messages = (0, $kSwu1.defineMessages)({
    insightsSectionHeading: {
        id: "rovo-for-you.for-you-panel.insightsSectionHeading",
        defaultMessage: "Insights"
    }
}); /** ErrorBoundary fallback for ThreadsList — renders the error state and marks the UFO experience as failed. */ 
const $a40f11736e2ea035$var$ThreadsListErrorFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { error: error } = t0;
    let t1;
    if ($[0] !== error) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
            name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY,
            error: error
        });
        $[0] = error;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82eb67a8de13c942$export$c1ed4f415b9e7023), null);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
        name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY,
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82eb67a8de13c942$export$c1ed4f415b9e7023), null));
const $a40f11736e2ea035$var$styles = {
    container: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39xV02N91d _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0Of8r25zaO _1wydGW5zaO _2Zuz6Q5zaO _1Znuxb5zaO",
    contentWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    emptyStateWrapper: "_4kiQYAatoo _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
}; /**
    * Renders the "Your Rovo insights" entry-point banner at the top of the For You tab.
    * On click, navigates the Rovo side panel to the pulse menu so the user can read their full Rovo insights.
    * Mirrors the gating used by `RovoEmptyState`.
    */ 
const $a40f11736e2ea035$var$InsightsBannerSection = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { cloudId: cloudId, product: product } = t0;
    const intl = (0, $kSwu1.useIntl)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_growth_chat_pulse", "isEnabled", false);
        $[0] = t1;
    } else t1 = $[0];
    const pulseEnabled = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = pulseEnabled ? (0, $iDrrr.fg)("rovo_growth_insights_banner_ignore_schedule") || (0, $b1faed5da83dea83$export$200db2820880abd6)() : false;
        $[1] = t2;
    } else t2 = $[1];
    const scheduleOk = t2;
    const statusEnabled = !!product && pulseEnabled && scheduleOk;
    const t3 = product;
    let t4;
    if ($[2] !== cloudId || $[3] !== t3) {
        t4 = {
            touchpointSource: "rovo-for-you-tab",
            product: t3,
            experienceId: "ai-mate",
            siteId: cloudId
        };
        $[2] = cloudId;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== statusEnabled || $[6] !== t4) {
        t5 = {
            enabled: statusEnabled,
            assistanceServiceParams: t4
        };
        $[5] = statusEnabled;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { isInsightsAvailable: isInsightsAvailable, generatedAt: generatedAt, isFresh: isFresh, statusFetchState: statusFetchState } = (0, $bY61u.useInsightsStatus)(t5);
    const t6 = !!product;
    let t7;
    if ($[8] !== generatedAt || $[9] !== isFresh || $[10] !== isInsightsAvailable || $[11] !== statusFetchState || $[12] !== t6) {
        t7 = {
            surface: "yourWork",
            pulseEnabled: pulseEnabled,
            requiresProduct: true,
            hasProduct: t6,
            scheduleOk: scheduleOk,
            statusFetchState: statusFetchState,
            isInsightsAvailable: isInsightsAvailable,
            requiresFresh: false,
            isFresh: isFresh,
            hasSelectedSpace: false,
            generatedAt: generatedAt
        };
        $[8] = generatedAt;
        $[9] = isFresh;
        $[10] = isInsightsAvailable;
        $[11] = statusFetchState;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    (0, $a8cc5669d925fa6c$export$dc8676c7370a9cf5)(t7);
    let t8;
    if ($[14] !== setActiveMenu) {
        t8 = ()=>{
            setActiveMenu("pulse");
        };
        $[14] = setActiveMenu;
        $[15] = t8;
    } else t8 = $[15];
    const handleClick = t8;
    if (!isInsightsAvailable) return null;
    let t9;
    if ($[16] !== intl) {
        t9 = intl.formatMessage($a40f11736e2ea035$var$messages.insightsSectionHeading);
        $[16] = intl;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xxsmall",
            as: "h4"
        }, t9);
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== generatedAt || $[21] !== handleClick) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bdb37ec7796f6ed$export$c03a8cd6181f4965), {
            onClick: handleClick,
            appearance: "yourWork",
            generatedAt: generatedAt
        });
        $[20] = generatedAt;
        $[21] = handleClick;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t10 || $[24] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "for-you-insights-banner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t10, t11));
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
    } else t12 = $[25];
    return t12;
} : ({ cloudId: cloudId, product: product })=>{
    const intl = (0, $kSwu1.useIntl)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const pulseEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
    const scheduleOk = pulseEnabled ? (0, $iDrrr.fg)('rovo_growth_insights_banner_ignore_schedule') || (0, $b1faed5da83dea83$export$200db2820880abd6)() : false; // Without a host product we can't attribute the backend call correctly, so
    // skip fetching insights status entirely in that case.
    const statusEnabled = !!product && pulseEnabled && scheduleOk;
    const { isInsightsAvailable: isInsightsAvailable, generatedAt: generatedAt, isFresh: isFresh, statusFetchState: statusFetchState } = (0, $bY61u.useInsightsStatus)({
        enabled: statusEnabled,
        assistanceServiceParams: {
            touchpointSource: 'rovo-for-you-tab',
            product: product,
            experienceId: 'ai-mate',
            siteId: cloudId
        }
    }); // Report how the insights entry point resolved (shown, or why not) for per-user diagnosis.
    (0, $a8cc5669d925fa6c$export$dc8676c7370a9cf5)({
        surface: 'yourWork',
        pulseEnabled: pulseEnabled,
        requiresProduct: true,
        hasProduct: !!product,
        scheduleOk: scheduleOk,
        statusFetchState: statusFetchState,
        isInsightsAvailable: isInsightsAvailable,
        requiresFresh: false,
        isFresh: isFresh,
        hasSelectedSpace: false,
        generatedAt: generatedAt
    });
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setActiveMenu('pulse');
    }, [
        setActiveMenu
    ]);
    if (!isInsightsAvailable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: 'for-you-insights-banner'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xxsmall",
        as: "h4"
    }, intl.formatMessage($a40f11736e2ea035$var$messages.insightsSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bdb37ec7796f6ed$export$c03a8cd6181f4965), {
        onClick: handleClick,
        appearance: "yourWork",
        generatedAt: generatedAt
    })));
};
const $a40f11736e2ea035$var$ForYouPanelContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { cloudId: cloudId, userId: userId, product: product, isActive: isActive, onChatEmptyLaunch: onChatEmptyLaunch } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { resetNavigation: resetNavigation } = (0, $a2dc017075ecc27d$export$ff19d21aed959849)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_your_work_tab_pin_objects", "isEnabled", false);
        $[0] = t1;
    } else t1 = $[0];
    const pinnedWorkEnabled = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false);
        $[1] = t2;
    } else t2 = $[1];
    const spacesExperimentEnabled = t2;
    let t3;
    if ($[2] !== sendAnalyticsEvent || $[3] !== setActiveMenu) {
        t3 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                actionSubject: "pinWork",
                action: "clicked"
            });
            setActiveMenu("search-work");
        };
        $[2] = sendAnalyticsEvent;
        $[3] = setActiveMenu;
        $[4] = t3;
    } else t3 = $[4];
    const handlePinWorkClick = t3;
    let t4;
    if ($[5] !== intl || $[6] !== onChatEmptyLaunch || $[7] !== sendAnalyticsEvent) {
        t4 = (item)=>{
            sendAnalyticsEvent({
                eventType: "ui",
                actionSubject: "pinnedItem",
                action: "clicked",
                actionSubjectId: "startChat",
                attributes: {
                    pinType: item.pinType
                }
            });
            onChatEmptyLaunch?.({
                spaceId: "",
                spaceName: "",
                spaceEmoji: "",
                greetingTitle: "",
                selectedPinnedItem: {
                    entityType: item.pinType,
                    ari: item.ari,
                    name: item.name,
                    url: item.url
                },
                customConversationActions: (0, $469e3ce09396ad62$export$670f88557775636a)(intl, {
                    spaceName: item.name
                }),
                replaceProviderActions: true,
                skillRegistryTags: [
                    (0, $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe)
                ],
                launchTabId: (0, $5fb0e87a487b8b7b$export$4e2d22a4f1ea8ef3)
            });
        };
        $[5] = intl;
        $[6] = onChatEmptyLaunch;
        $[7] = sendAnalyticsEvent;
        $[8] = t4;
    } else t4 = $[8];
    const handlePinStartChat = t4;
    let t5;
    if ($[9] !== cloudId) {
        t5 = {
            cloudId: cloudId,
            product: "rovo",
            experienceId: "ai-mate",
            skip: !spacesExperimentEnabled
        };
        $[9] = cloudId;
        $[10] = t5;
    } else t5 = $[10];
    const { spaces: spaces, isLoading: isLoadingSpaces, error: spacesError, hasFetched: spacesFetched, conversationIds: spacesConversationIds } = (0, $9dT53.useListSpaces)(t5);
    const { addSpace: addSpace, patchSpace: patchSpace } = (0, $12shJ.useSpaceStoreActions)();
    let t6;
    if ($[11] !== addSpace || $[12] !== intl || $[13] !== onChatEmptyLaunch || $[14] !== patchSpace) {
        t6 = (space, emojiId, attachedConversationId, sources)=>{
            addSpace(space, emojiId);
            if (attachedConversationId && sources && sources.length > 0) patchSpace(space.id, {
                sources: (0, $e690d34cff371f6d$export$561111ab539b745)(sources, [
                    attachedConversationId
                ])
            });
            onChatEmptyLaunch?.({
                spaceId: space.id,
                spaceName: space.name,
                spaceEmoji: emojiId ?? "",
                greetingTitle: intl.formatMessage((0, $2e491f5bc322938a$export$2e2bcd8739ae039).chatGreeting),
                replaceProviderActions: true,
                skillRegistryTags: [
                    (0, $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe)
                ],
                launchTabId: (0, $5fb0e87a487b8b7b$export$4e2d22a4f1ea8ef3),
                sources: sources?.map($a40f11736e2ea035$var$_temp)
            });
        };
        $[11] = addSpace;
        $[12] = intl;
        $[13] = onChatEmptyLaunch;
        $[14] = patchSpace;
        $[15] = t6;
    } else t6 = $[15];
    const handleSpaceCreated = t6;
    let t7;
    let t8;
    if ($[16] !== isActive || $[17] !== resetNavigation || $[18] !== sendAnalyticsEvent) {
        t7 = ()=>{
            if (isActive) sendAnalyticsEvent({
                eventType: "screen",
                name: "forYouTab"
            });
            else resetNavigation();
        };
        t8 = [
            isActive,
            sendAnalyticsEvent,
            resetNavigation
        ];
        $[16] = isActive;
        $[17] = resetNavigation;
        $[18] = sendAnalyticsEvent;
        $[19] = t7;
        $[20] = t8;
    } else {
        t7 = $[19];
        t8 = $[20];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const isSpacesEmpty = spacesFetched && (!!spacesError || !spaces || spaces.length === 0);
    const [isThreadsEmpty, setIsThreadsEmpty] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (isEmpty)=>{
            setIsThreadsEmpty(isEmpty);
        };
        $[21] = t9;
    } else t9 = $[21];
    const handleThreadsEmpty = t9;
    const bothEmpty = spacesExperimentEnabled && isSpacesEmpty && isThreadsEmpty;
    let t10;
    let t11;
    if ($[22] !== bothEmpty || $[23] !== isActive || $[24] !== sendAnalyticsEvent) {
        t10 = ()=>{
            if (bothEmpty && isActive) sendAnalyticsEvent({
                eventType: "screen",
                name: "forYouEmptyState"
            });
        };
        t11 = [
            bothEmpty,
            isActive,
            sendAnalyticsEvent
        ];
        $[22] = bothEmpty;
        $[23] = isActive;
        $[24] = sendAnalyticsEvent;
        $[25] = t10;
        $[26] = t11;
    } else {
        t10 = $[25];
        t11 = $[26];
    }
    (0, $cozmU.useEffect)(t10, t11);
    if (!cloudId || !userId) {
        let t12;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.300"
            }, spacesExperimentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff43df5b2db7b526$export$e58168d515763c4), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39ff0a764a380560$export$aaa96717a0548da9), null)));
            $[27] = t12;
        } else t12 = $[27];
        return t12;
    }
    let t12;
    if ($[28] !== cloudId || $[29] !== product) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            FallbackComponent: (0, $82eb67a8de13c942$export$c1ed4f415b9e7023)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a40f11736e2ea035$var$InsightsBannerSection, {
            cloudId: cloudId,
            product: product
        }));
        $[28] = cloudId;
        $[29] = product;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== cloudId || $[32] !== handlePinStartChat || $[33] !== handlePinWorkClick || $[34] !== product) {
        t13 = pinnedWorkEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            FallbackComponent: (0, $82eb67a8de13c942$export$c1ed4f415b9e7023)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9cf6d22946fd7d4e$export$e592500ec5456788), {
            cloudId: cloudId,
            product: product,
            onPinWorkClick: handlePinWorkClick,
            onStartChat: handlePinStartChat
        }));
        $[31] = cloudId;
        $[32] = handlePinStartChat;
        $[33] = handlePinWorkClick;
        $[34] = product;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== bothEmpty || $[37] !== cloudId || $[38] !== handleSpaceCreated || $[39] !== isLoadingSpaces || $[40] !== onChatEmptyLaunch || $[41] !== product || $[42] !== spaces || $[43] !== spacesConversationIds || $[44] !== spacesError || $[45] !== spacesFetched || $[46] !== userId) {
        t14 = spacesExperimentEnabled && (bothEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a40f11736e2ea035$var$styles.emptyStateWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3d6c2188dbc8155$export$fddf379e22a74b00), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            FallbackComponent: (0, $82eb67a8de13c942$export$c1ed4f415b9e7023)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $385bb391f95fd8fd$export$ea55ef727c032eee), {
            cloudId: cloudId,
            spaces: spaces,
            isLoading: isLoadingSpaces,
            hasFetched: spacesFetched,
            error: spacesError,
            onChatEmptyLaunch: onChatEmptyLaunch
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            FallbackComponent: $a40f11736e2ea035$var$ThreadsListErrorFallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39ff0a764a380560$export$aaa96717a0548da9), null),
            interactionName: "for-you-threads-list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8001d7f45735a37$export$ae4aa9d74faeeaeb), {
            cloudId: cloudId,
            userId: userId,
            spacesConversationIds: spacesConversationIds,
            onSpaceCreated: handleSpaceCreated,
            onEmpty: handleThreadsEmpty,
            product: product ?? "rovo"
        })))));
        $[36] = bothEmpty;
        $[37] = cloudId;
        $[38] = handleSpaceCreated;
        $[39] = isLoadingSpaces;
        $[40] = onChatEmptyLaunch;
        $[41] = product;
        $[42] = spaces;
        $[43] = spacesConversationIds;
        $[44] = spacesError;
        $[45] = spacesFetched;
        $[46] = userId;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] !== t12 || $[49] !== t13 || $[50] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.300"
        }, t12, t13, t14);
        $[48] = t12;
        $[49] = t13;
        $[50] = t14;
        $[51] = t15;
    } else t15 = $[51];
    return t15;
} : ({ cloudId: cloudId, userId: userId, product: product, isActive: isActive, onChatEmptyLaunch: onChatEmptyLaunch })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { resetNavigation: resetNavigation } = (0, $a2dc017075ecc27d$export$ff19d21aed959849)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const pinnedWorkEnabled = (0, $cXtTj.default).getExperimentValue('rovo_your_work_tab_pin_objects', 'isEnabled', false); // Spaces and pins are independent features sharing this panel. Gated here (not just at
    // the parent RovoTabs level) so enabling pins alone doesn't leak spaces-specific content
    // (MySpacesList/ThreadsList) when the spaces experiment itself is off.
    const spacesExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const handlePinWorkClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'pinWork',
            action: 'clicked'
        });
        setActiveMenu('search-work');
    }, [
        sendAnalyticsEvent,
        setActiveMenu
    ]); // Reuses the same onChatEmptyLaunch path as the "Chat" button on a space card, scoped to a
    // non-space item via `selectedPinnedItem` — no space pill, no RAG scoping, no
    // space-landing navigation (see handleChatEmptyLaunch). No custom greeting either — the
    // item's title bar (once built) is the identity, and the default greeting + these
    // starters are the content.
    const handlePinStartChat = (0, $cozmU.useCallback)((item)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'pinnedItem',
            action: 'clicked',
            actionSubjectId: 'startChat',
            attributes: {
                pinType: item.pinType
            }
        });
        onChatEmptyLaunch?.({
            spaceId: '',
            spaceName: '',
            spaceEmoji: '',
            greetingTitle: '',
            selectedPinnedItem: {
                entityType: item.pinType,
                ari: item.ari,
                name: item.name,
                url: item.url
            },
            // Reuses the same canonical starter prompts a space launch gets — see
            // packages/ai-mate/rovo-spaces/src/common/starters.tsx.
            customConversationActions: (0, $469e3ce09396ad62$export$670f88557775636a)(intl, {
                spaceName: item.name
            }),
            replaceProviderActions: true,
            skillRegistryTags: [
                (0, $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe)
            ],
            launchTabId: (0, $5fb0e87a487b8b7b$export$4e2d22a4f1ea8ef3)
        });
    }, [
        onChatEmptyLaunch,
        intl,
        sendAnalyticsEvent
    ]); // Spaces data is fetched here (rather than inside `MySpacesList`) so the same data — and
    // the optimistic-insert callback below — can be shared with `ThreadsList`. `ThreadsList`
    // needs the spaces' aggregated conversationIds to filter out threads that have already been
    // organized into a space, and needs a way to add the just-created space to the store so My
    // Spaces reflects it immediately without an extra `GET /spaces` round-trip.
    const { spaces: spaces, isLoading: isLoadingSpaces, error: spacesError, hasFetched: spacesFetched, conversationIds: spacesConversationIds } = (0, $9dT53.useListSpaces)({
        cloudId: cloudId,
        product: 'rovo',
        experienceId: 'ai-mate',
        skip: !spacesExperimentEnabled
    });
    const { addSpace: addSpace, patchSpace: patchSpace } = (0, $12shJ.useSpaceStoreActions)(); // When a space is created from the create-space modal (launched from a thread card in
    // `ThreadsList`), do two things:
    //   1. Optimistically insert the new space into the SpaceStore so My Spaces reflects it
    //      immediately (existing behaviour).
    //   2. Navigate the user into the new space's empty-state Chat via the canonical
    //      `onChatEmptyLaunch` path — the same launch used by the "Chat" button on a space card.
    //      This tears down the For You panel and lands the user on the space landing page.
    // The optimistic insert runs first so the space-landing surface renders against a store that
    // already contains the new space.
    const handleSpaceCreated = (0, $cozmU.useCallback)((space, emojiId, attachedConversationId, sources)=>{
        addSpace(space, emojiId); // Seed the just-organized thread's conversationId onto the optimistic space's sources so
        // the SpaceStore `conversationIds` rollup (which `ThreadsList` filters on) includes it
        // immediately — hiding the thread from suggestions without waiting for a `GET /spaces`
        // refetch, and surviving the For You panel remount that the launch below triggers. Mirrors
        // the side-nav/Recommended create flow (`addSpace` + `patchSpace`); the one divergence is
        // injecting `attachedConversationId` because `extractSourcesFromThread` zeroes source
        // conversationIds. When `attachedConversationId` is absent (the modal's conversation
        // attach failed), we skip the patch and fall back to the refetch.
        if (attachedConversationId && sources && sources.length > 0) patchSpace(space.id, {
            sources: (0, $e690d34cff371f6d$export$561111ab539b745)(sources, [
                attachedConversationId
            ])
        });
        onChatEmptyLaunch?.({
            spaceId: space.id,
            spaceName: space.name,
            spaceEmoji: emojiId ?? '',
            greetingTitle: intl.formatMessage((0, $2e491f5bc322938a$export$2e2bcd8739ae039).chatGreeting),
            replaceProviderActions: true,
            skillRegistryTags: [
                (0, $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe)
            ],
            launchTabId: (0, $5fb0e87a487b8b7b$export$4e2d22a4f1ea8ef3),
            sources: sources?.map((s)=>({
                    ari: s.ari,
                    url: s.url,
                    sourceType: s.sourceType,
                    name: s.name
                }))
        });
    }, [
        addSpace,
        patchSpace,
        onChatEmptyLaunch,
        intl
    ]); // When the tab becomes active, fire the screen analytics event.
    // When it becomes inactive, reset navigation so returning starts fresh at threads-list.
    (0, $cozmU.useEffect)(()=>{
        if (isActive) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'forYouTab'
        });
        else resetNavigation();
    }, [
        isActive,
        sendAnalyticsEvent,
        resetNavigation
    ]); // Empty determination is derived directly from the store data (not from child callbacks).
    // This eliminates the previous cascade of `onEmpty` callbacks writing to parent state,
    // which caused an isEmpty flap `true → false → true` on every mount and 2-3 wasted
    // panel re-renders per settled state.
    //
    // Threads emptiness is derived from the same rule ThreadsList uses (edges filtered by
    // spacesConversationIds), but only *after* both queries have resolved — we cannot know
    // threads' emptiness pre-Suspense-resolve at this level without lifting the query. We
    // therefore keep an onEmpty callback for threads (the only remaining child callback)
    // and default `bothEmpty` to false until both signals are available.
    const isSpacesEmpty = spacesFetched && (!!spacesError || !spaces || spaces.length === 0);
    const [isThreadsEmpty, setIsThreadsEmpty] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const handleThreadsEmpty = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((isEmpty)=>{
        setIsThreadsEmpty(isEmpty);
    }, []);
    const bothEmpty = spacesExperimentEnabled && isSpacesEmpty && isThreadsEmpty; // Track when the combined empty state is shown (both sections have no data).
    (0, $cozmU.useEffect)(()=>{
        if (bothEmpty && isActive) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'forYouEmptyState'
        });
    }, [
        bothEmpty,
        isActive,
        sendAnalyticsEvent
    ]);
    if (!cloudId || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, spacesExperimentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff43df5b2db7b526$export$e58168d515763c4), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39ff0a764a380560$export$aaa96717a0548da9), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: (0, $82eb67a8de13c942$export$c1ed4f415b9e7023)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a40f11736e2ea035$var$InsightsBannerSection, {
        cloudId: cloudId,
        product: product
    })), pinnedWorkEnabled && // `usePinnedItems` (inside PinnedWorkSection) shares its cache with the Search
    // page by cloudId/product, not by a common provider ancestor — this only gates
    // whether the section renders at all.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: (0, $82eb67a8de13c942$export$c1ed4f415b9e7023)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9cf6d22946fd7d4e$export$e592500ec5456788), {
        cloudId: cloudId,
        product: product,
        onPinWorkClick: handlePinWorkClick,
        onStartChat: handlePinStartChat
    })), spacesExperimentEnabled && (bothEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a40f11736e2ea035$var$styles.emptyStateWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3d6c2188dbc8155$export$fddf379e22a74b00), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: (0, $82eb67a8de13c942$export$c1ed4f415b9e7023)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $385bb391f95fd8fd$export$ea55ef727c032eee), {
        cloudId: cloudId,
        spaces: spaces,
        isLoading: isLoadingSpaces,
        hasFetched: spacesFetched,
        error: spacesError,
        onChatEmptyLaunch: onChatEmptyLaunch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: $a40f11736e2ea035$var$ThreadsListErrorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).THREADS_LIST_QUERY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39ff0a764a380560$export$aaa96717a0548da9), null),
        interactionName: "for-you-threads-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8001d7f45735a37$export$ae4aa9d74faeeaeb), {
        cloudId: cloudId,
        userId: userId,
        spacesConversationIds: spacesConversationIds,
        onSpaceCreated: handleSpaceCreated,
        onEmpty: handleThreadsEmpty,
        product: product ?? 'rovo'
    }))))));
};
const $a40f11736e2ea035$export$241c63312adc3a1b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "for-you-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a40f11736e2ea035$var$styles.container,
            testId: "for-you-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a40f11736e2ea035$var$styles.contentWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a40f11736e2ea035$var$ForYouPanelContent, props))));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "for-you-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a40f11736e2ea035$var$styles.container,
        testId: "for-you-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a40f11736e2ea035$var$styles.contentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a40f11736e2ea035$var$ForYouPanelContent, props))));
};
function $a40f11736e2ea035$var$_temp(s) {
    return {
        ari: s.ari,
        url: s.url,
        sourceType: s.sourceType,
        name: s.name
    };
}






/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $bLfHG = parcelRequire("bLfHG");










var $8nzB4 = parcelRequire("8nzB4");





































































const $7c9906e0ffa65ec7$export$34228be725c432b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80Hjq.SkillHoverCardContent), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGEnS.HoverCard), {
            ...props,
            content: t0
        }, props.children);
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGEnS.HoverCard), {
        ...props,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80Hjq.SkillHoverCardContent), props)
    }, props.children);
};








function $322e4c3f72b3c59e$export$905653b9e5e1420(action, skillMetadataMap) {
    if (!action || !skillMetadataMap || action.handleType !== (0, $6iWVH.HandleActionType).Skill || !('staticPrompt' in action) || !action.staticPrompt) return undefined;
    // Extract slash command from staticPrompt (first token)
    // e.g., "/create-plan-release Create a release" -> "create-plan-release"
    const firstToken = action.staticPrompt.trim().split(/\s+/, 1)[0];
    if (!firstToken) return undefined;
    const skillSlug = firstToken.startsWith('/') ? firstToken.slice(1) : null;
    return skillSlug ? skillMetadataMap[skillSlug] : undefined;
}





const $bb92e05193f7107e$var$_default_1 = (0, $kSwu1.defineMessages)({
    byAgentText: {
        id: "rovo-conversation-actions.actions.by-agent-text",
        defaultMessage: "By {agentName}"
    }
});
var $bb92e05193f7107e$export$2e2bcd8739ae039 = $bb92e05193f7107e$var$_default_1;


const $53d65580d6d66766$var$styles = {
    buttonContentStyles: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT",
    secondaryButtonContentStyles: "_2mHwu88HPE _0hPCNL7p2s _3iDTPbQ4SZ",
    inlineItemStyles: "_2mHwu82ADO _1UtDYzZpcK",
    iconBoxStyles: "_0bjKvD8fU6 _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02Uofl _0jFU0VUofl _4ouGXIUofl",
    skillActionStackStyles: "_4kiQYAR4us _37wbyuDIqT",
    pressableStyles: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0KLXru66of _39xV02N91d _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r2gVvo _1wydGWgVvo _1UtDYzZpcK _0Am33zKxmn _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _0clgaMZpcK _46ILVRWHit",
    actionTitleStyles: "_1UtDYzZpcK _0WKd3G4z3T _2l4i3rzUZr _1kk5Tkf7mX _2fwxA57p2s",
    secondaryActionTitleStyles: "_2sNsIg7NXe _1UtDYzZpcK _0WKd3G4z3T _2l4i3rzUZr _1kk5Tkf7mX _2fwxA57p2s",
    secondaryDescriptionStyles: "_2sNsIg7NXe _1UtDYzZpcK _0WKd3G4z3T _2l4i3rzUZr _1kk5Tku7m9 _2fwxA57p2s _0Of8r21Y8M",
    secondaryIconStyles: "_1wydGW1Y8M",
    rollingStripDescriptionExpandable: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHAOxi _3iDTPbgBM8",
    rollingStripDescriptionExpandableInner: "_4bt5LAnQyn _2WAcuGnQyn _4kiQYAdnbC"
};
// Override the paragraph component used by the ReactRenderer to use the subtle text color
const $53d65580d6d66766$var$paragraphOverride = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, children); // Helper component to render title with consistent styling
const $53d65580d6d66766$var$TitleRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { title: title, variant: t1 } = t0;
    const variant = t1 === undefined ? "default" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            paragraph: $53d65580d6d66766$var$paragraphOverride
        };
        $[0] = t2;
    } else t2 = $[0];
    const nodeComponents = t2;
    const t3 = variant === "secondary" ? $53d65580d6d66766$var$styles.secondaryActionTitleStyles : $53d65580d6d66766$var$styles.actionTitleStyles;
    let t4;
    if ($[1] !== title) {
        t4 = (0, $6rwn6.encodeAdf)(title);
        $[1] = title;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: t4,
            nodeComponents: nodeComponents
        });
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t5);
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
} : ({ title: title, variant: variant = 'default' })=>{
    const nodeComponents = {
        paragraph: $53d65580d6d66766$var$paragraphOverride
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: variant === 'secondary' ? $53d65580d6d66766$var$styles.secondaryActionTitleStyles : $53d65580d6d66766$var$styles.actionTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: (0, $6rwn6.encodeAdf)(title),
        nodeComponents: nodeComponents
    }));
}; // Component for rendering action with secondary icon/description
const $53d65580d6d66766$var$SecondaryActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { action: action, title: title, isHovered: isHovered, getSecondaryDescription: getSecondaryDescription } = t0;
    let t1;
    if ($[0] !== action || $[1] !== getSecondaryDescription) {
        t1 = getSecondaryDescription(action);
        $[0] = action;
        $[1] = getSecondaryDescription;
        $[2] = t1;
    } else t1 = $[2];
    const description = t1;
    const SecondaryIcon = action?.secondaryIcon;
    const alwaysShowSecondaryText = !!action?.alwaysShowSecondaryText;
    const showSecondaryText = alwaysShowSecondaryText || isHovered;
    let t2;
    if ($[3] !== SecondaryIcon) {
        t2 = SecondaryIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53d65580d6d66766$var$styles.secondaryIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SecondaryIcon, {
            label: ""
        }));
        $[3] = SecondaryIcon;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = isHovered ? "secondary" : "default";
    let t4;
    if ($[5] !== t3 || $[6] !== title) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$TitleRenderer, {
            title: title,
            variant: t3
        });
        $[5] = t3;
        $[6] = title;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== description || $[9] !== showSecondaryText) {
        t5 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53d65580d6d66766$var$styles.rollingStripDescriptionExpandable,
            style: {
                gridTemplateRows: showSecondaryText ? "1fr" : "0fr"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53d65580d6d66766$var$styles.rollingStripDescriptionExpandableInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53d65580d6d66766$var$styles.secondaryDescriptionStyles
        }, description)));
        $[8] = description;
        $[9] = showSecondaryText;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t4, t5);
        $[11] = t2;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ action: action, title: title, isHovered: isHovered, getSecondaryDescription: getSecondaryDescription })=>{
    const description = getSecondaryDescription(action);
    const SecondaryIcon = action?.secondaryIcon;
    const alwaysShowSecondaryText = !!action?.alwaysShowSecondaryText;
    const showSecondaryText = alwaysShowSecondaryText || isHovered;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, SecondaryIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $53d65580d6d66766$var$styles.secondaryIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SecondaryIcon, {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$TitleRenderer, {
        title: title,
        variant: isHovered ? 'secondary' : 'default'
    }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $53d65580d6d66766$var$styles.rollingStripDescriptionExpandable,
        style: {
            gridTemplateRows: showSecondaryText ? '1fr' : '0fr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $53d65580d6d66766$var$styles.rollingStripDescriptionExpandableInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $53d65580d6d66766$var$styles.secondaryDescriptionStyles
    }, description))));
}; // Component for rendering skill action content
const $53d65580d6d66766$var$SkillActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { action: action, isHovered: isHovered } = t0;
    if (!(0, $2TzCj.isSkillAction)(action) || !action.name) return null;
    const showDescription = (isHovered || action.alwaysShowSecondaryText) && !!action.description;
    let t1;
    if ($[0] !== action.name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            align: "start"
        }, action.name);
        $[0] = action.name;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== action.description || $[3] !== showDescription) {
        t2 = showDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            maxLines: 1
        }, action.description);
        $[2] = action.description;
        $[3] = showDescription;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025",
            alignInline: "start",
            xcss: $53d65580d6d66766$var$styles.skillActionStackStyles
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ action: action, isHovered: isHovered })=>{
    if (!(0, $2TzCj.isSkillAction)(action) || !action.name) return null;
    const showDescription = (isHovered || action.alwaysShowSecondaryText) && !!action.description;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025",
        alignInline: "start",
        xcss: $53d65580d6d66766$var$styles.skillActionStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "start"
    }, action.name), showDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, action.description));
};
const $53d65580d6d66766$var$BaseActionItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { title: title, icon: icon, action: action, isHovered: isHovered, badge: badge } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const Icon = icon;
    let t1;
    if ($[0] !== formatMessage) {
        t1 = (action_0)=>{
            if (!action_0) return;
            if ((0, $2TzCj.isChatAction)(action_0) && action_0.agent) return formatMessage((0, $bb92e05193f7107e$export$2e2bcd8739ae039).byAgentText, {
                agentName: action_0.agent.name
            });
            if (action_0.secondaryDescription) return action_0.secondaryDescription;
        };
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const getSecondaryDescription = t1;
    const t2 = getSecondaryDescription(action) || action?.secondaryIcon ? $53d65580d6d66766$var$styles.secondaryButtonContentStyles : $53d65580d6d66766$var$styles.buttonContentStyles;
    let t3;
    if ($[2] !== Icon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center",
            xcss: $53d65580d6d66766$var$styles.iconBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "action-item-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            primaryColor: "var(--ds-icon-subtle, #505258)"
        })));
        $[2] = Icon;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== action || $[5] !== getSecondaryDescription || $[6] !== isHovered || $[7] !== title) {
        t4 = getSecondaryDescription(action) || action?.secondaryIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$SecondaryActionContent, {
            action: action,
            title: title,
            isHovered: isHovered,
            getSecondaryDescription: getSecondaryDescription
        })) : action && (0, $2TzCj.isSkillAction)(action) && action.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$SkillActionContent, {
            action: action,
            isHovered: isHovered
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$TitleRenderer, {
            title: title
        });
        $[4] = action;
        $[5] = getSecondaryDescription;
        $[6] = isHovered;
        $[7] = title;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== badge || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $53d65580d6d66766$var$styles.inlineItemStyles,
            alignBlock: "center"
        }, t4, badge);
        $[9] = badge;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, t3, t5);
        $[12] = t2;
        $[13] = t3;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ title: title, icon: icon, action: action, isHovered: isHovered, badge: badge })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const Icon = icon;
    const getSecondaryDescription = (0, $cozmU.useCallback)((action_0)=>{
        if (!action_0) return undefined;
        if ((0, $2TzCj.isChatAction)(action_0) && action_0.agent) return formatMessage((0, $bb92e05193f7107e$export$2e2bcd8739ae039).byAgentText, {
            agentName: action_0.agent.name
        });
        if (action_0.secondaryDescription) return action_0.secondaryDescription;
        return undefined;
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: getSecondaryDescription(action) || action?.secondaryIcon ? $53d65580d6d66766$var$styles.secondaryButtonContentStyles : $53d65580d6d66766$var$styles.buttonContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $53d65580d6d66766$var$styles.iconBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "action-item-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        primaryColor: "var(--ds-icon-subtle, #505258)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $53d65580d6d66766$var$styles.inlineItemStyles,
        alignBlock: "center"
    }, getSecondaryDescription(action) || action?.secondaryIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$SecondaryActionContent, {
        action: action,
        title: title,
        isHovered: isHovered,
        getSecondaryDescription: getSecondaryDescription
    })) : action && (0, $2TzCj.isSkillAction)(action) && action.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$SkillActionContent, {
        action: action,
        isHovered: isHovered
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$TitleRenderer, {
        title: title
    }), badge));
};
const $53d65580d6d66766$export$d4f9d1fefcbcface = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(37);
    const { title: title, icon: icon, testId: testId, onClick: onClick, href: href, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, action: action, skillMetadataMap: skillMetadataMap, badge: badge } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== action) {
        t1 = action ? (0, $2TzCj.isNestedAction)(action) : false;
        $[0] = action;
        $[1] = t1;
    } else t1 = $[1];
    const isNestedAction = t1;
    let t2;
    if ($[2] !== onMouseEnter) {
        t2 = ()=>{
            setIsHovered(true);
            onMouseEnter?.();
        };
        $[2] = onMouseEnter;
        $[3] = t2;
    } else t2 = $[3];
    const onPressableMouseEnter = t2;
    let t3;
    if ($[4] !== onMouseLeave) {
        t3 = ()=>{
            setIsHovered(false);
            onMouseLeave?.();
        };
        $[4] = onMouseLeave;
        $[5] = t3;
    } else t3 = $[5];
    const onPressableMouseLeave = t3;
    let t4;
    if ($[6] !== action || $[7] !== skillMetadataMap) {
        t4 = (0, $322e4c3f72b3c59e$export$905653b9e5e1420)(action, skillMetadataMap);
        $[6] = action;
        $[7] = skillMetadataMap;
        $[8] = t4;
    } else t4 = $[8];
    const skillMetadataForSlashCommand = t4;
    let t5;
    if ($[9] !== action || $[10] !== skillMetadataForSlashCommand) {
        t5 = action && (0, $2TzCj.isSkillAction)(action) && skillMetadataForSlashCommand;
        $[9] = action;
        $[10] = skillMetadataForSlashCommand;
        $[11] = t5;
    } else t5 = $[11];
    const shouldShowSkillHoverCard = t5;
    let t6;
    if ($[12] !== action || $[13] !== shouldShowSkillHoverCard || $[14] !== skillMetadataForSlashCommand || $[15] !== title) {
        t6 = shouldShowSkillHoverCard ? {
            ...action,
            name: title,
            description: skillMetadataForSlashCommand.description
        } : action;
        $[12] = action;
        $[13] = shouldShowSkillHoverCard;
        $[14] = skillMetadataForSlashCommand;
        $[15] = title;
        $[16] = t6;
    } else t6 = $[16];
    const enhancedAction = t6;
    const resolvedIcon = shouldShowSkillHoverCard && skillMetadataForSlashCommand.iconName ? (0, $9MCKh.skillIconMap)[skillMetadataForSlashCommand.iconName] ?? icon : icon;
    let t7;
    if ($[17] !== badge || $[18] !== enhancedAction || $[19] !== isHovered || $[20] !== resolvedIcon || $[21] !== title) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$BaseActionItem, {
            title: title,
            icon: resolvedIcon,
            action: enhancedAction,
            isHovered: isHovered,
            badge: badge
        });
        $[17] = badge;
        $[18] = enhancedAction;
        $[19] = isHovered;
        $[20] = resolvedIcon;
        $[21] = title;
        $[22] = t7;
    } else t7 = $[22];
    const baseActionItem = t7;
    let t8;
    if ($[23] !== baseActionItem || $[24] !== shouldShowSkillHoverCard || $[25] !== skillMetadataForSlashCommand) {
        t8 = shouldShowSkillHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c9906e0ffa65ec7$export$34228be725c432b), {
            name: skillMetadataForSlashCommand.name,
            iconName: skillMetadataForSlashCommand?.iconName,
            description: skillMetadataForSlashCommand?.description || "",
            product: skillMetadataForSlashCommand?.product,
            productIconUrl: skillMetadataForSlashCommand?.productIconUrl,
            shouldRenderToParent: true
        }, baseActionItem) : baseActionItem;
        $[23] = baseActionItem;
        $[24] = shouldShowSkillHoverCard;
        $[25] = skillMetadataForSlashCommand;
        $[26] = t8;
    } else t8 = $[26];
    const item = t8;
    let t9;
    if ($[27] !== href || $[28] !== isHovered || $[29] !== isNestedAction || $[30] !== item || $[31] !== onClick || $[32] !== onPressableMouseEnter || $[33] !== onPressableMouseLeave || $[34] !== ref || $[35] !== testId) {
        t9 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: href,
            target: "_blank",
            onClick: onClick,
            xcss: $53d65580d6d66766$var$styles.pressableStyles,
            onMouseEnter: onPressableMouseEnter,
            onMouseLeave: onPressableMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            grow: "fill"
        }, item, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: isHovered
        }, isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "left",
            exitTo: "left",
            fade: "in",
            animationTimingFunction: "ease-out",
            duration: "medium"
        }, $53d65580d6d66766$var$_temp)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            onClick: onClick,
            onMouseEnter: onPressableMouseEnter,
            onMouseLeave: onPressableMouseLeave,
            ref: ref,
            testId: testId,
            xcss: $53d65580d6d66766$var$styles.pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: isNestedAction ? "space-between" : undefined,
            grow: isNestedAction ? "fill" : undefined
        }, item, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: isNestedAction && isHovered
        }, isNestedAction && isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "left",
            exitTo: "left",
            fade: "in",
            animationTimingFunction: "ease-out",
            duration: "medium"
        }, $53d65580d6d66766$var$_temp2))));
        $[27] = href;
        $[28] = isHovered;
        $[29] = isNestedAction;
        $[30] = item;
        $[31] = onClick;
        $[32] = onPressableMouseEnter;
        $[33] = onPressableMouseLeave;
        $[34] = ref;
        $[35] = testId;
        $[36] = t9;
    } else t9 = $[36];
    return t9;
} : ({ title: title, icon: icon, testId: testId, onClick: onClick, href: href, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, action: action, skillMetadataMap: skillMetadataMap, badge: badge }, ref)=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const isNestedAction = action ? (0, $2TzCj.isNestedAction)(action) : false;
    const onPressableMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHovered(true);
        onMouseEnter?.();
    }, [
        onMouseEnter
    ]);
    const onPressableMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
        onMouseLeave?.();
    }, [
        onMouseLeave
    ]);
    const skillMetadataForSlashCommand = (0, $322e4c3f72b3c59e$export$905653b9e5e1420)(action, skillMetadataMap);
    const shouldShowSkillHoverCard = action && (0, $2TzCj.isSkillAction)(action) && skillMetadataForSlashCommand;
    const enhancedAction = shouldShowSkillHoverCard ? {
        ...action,
        name: title,
        description: skillMetadataForSlashCommand.description
    } : action;
    const resolvedIcon = shouldShowSkillHoverCard && skillMetadataForSlashCommand.iconName ? (0, $9MCKh.skillIconMap)[skillMetadataForSlashCommand.iconName] ?? icon : icon;
    const baseActionItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53d65580d6d66766$var$BaseActionItem, {
        title: title,
        icon: resolvedIcon,
        action: enhancedAction,
        isHovered: isHovered,
        badge: badge
    });
    const item = shouldShowSkillHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c9906e0ffa65ec7$export$34228be725c432b), {
        name: skillMetadataForSlashCommand.name,
        iconName: skillMetadataForSlashCommand?.iconName,
        description: skillMetadataForSlashCommand?.description || '',
        product: skillMetadataForSlashCommand?.product,
        productIconUrl: skillMetadataForSlashCommand?.productIconUrl,
        shouldRenderToParent: true
    }, baseActionItem) : baseActionItem;
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: href,
        target: "_blank",
        onClick: onClick,
        xcss: $53d65580d6d66766$var$styles.pressableStyles,
        onMouseEnter: onPressableMouseEnter,
        onMouseLeave: onPressableMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        grow: "fill"
    }, item, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: isHovered
    }, isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: "left",
        exitTo: "left",
        fade: "in",
        animationTimingFunction: "ease-out",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: ""
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onClick,
        onMouseEnter: onPressableMouseEnter,
        onMouseLeave: onPressableMouseLeave,
        ref: ref,
        testId: testId,
        xcss: $53d65580d6d66766$var$styles.pressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: isNestedAction ? 'space-between' : undefined,
        grow: isNestedAction ? 'fill' : undefined
    }, item, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: isNestedAction && isHovered
    }, isNestedAction && isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: "left",
        exitTo: "left",
        fade: "in",
        animationTimingFunction: "ease-out",
        duration: "medium"
    }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props_0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            label: ""
        }))))));
});
function $53d65580d6d66766$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: ""
    }));
}
function $53d65580d6d66766$var$_temp2(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props_0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        label: ""
    }));
}


const $699ad632582ba79d$var$styles = {
    startersContainer: "_39xV02N91d"
};
const $699ad632582ba79d$export$175af43b96607140 = ({ agentId: agentId, conversationStarters: userDefinedConversationStarters, onConversationStarterClick: onConversationStarterClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const conversationStarters = (0, $cozmU.useMemo)(()=>{
        return (0, $8nzB4.getConversationStarters)({
            userDefinedConversationStarters: userDefinedConversationStarters?.map((starter)=>{
                return {
                    message: starter,
                    type: 'user-defined'
                };
            }),
            isAgentDefault: false
        }).combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            });
    }, [
        formatMessage,
        userDefinedConversationStarters
    ]);
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'newRovoChatAgentConversation',
            attributes: {
                agentId: agentId
            }
        });
    // Should only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $699ad632582ba79d$var$styles.startersContainer,
        space: "space.050"
    }, conversationStarters.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), {
        columns: 1
    }, conversationStarters.map((starter, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: `conversation-starter-${index}`
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                title: starter.message,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
                        label: ""
                    }),
                onClick: ()=>onConversationStarterClick(starter),
                testId: `rovo-agent-conversation-starter-${index}`
            }))))));
};


const $d6b8e275f7d05956$export$678a67b7aa4dcdd5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { agent: agent, onConversationStarterClick: onConversationStarterClick } = t0;
    let t1;
    if ($[0] !== agent.id || $[1] !== agent.user_defined_conversation_starters || $[2] !== onConversationStarterClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $699ad632582ba79d$export$175af43b96607140), {
            agentId: agent.id,
            conversationStarters: agent.user_defined_conversation_starters,
            onConversationStarterClick: onConversationStarterClick
        });
        $[0] = agent.id;
        $[1] = agent.user_defined_conversation_starters;
        $[2] = onConversationStarterClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ agent: agent, onConversationStarterClick: onConversationStarterClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $699ad632582ba79d$export$175af43b96607140), {
        agentId: agent.id,
        conversationStarters: agent.user_defined_conversation_starters,
        onConversationStarterClick: onConversationStarterClick
    });






var $gn6Jj = parcelRequire("gn6Jj");


































const $d6223f0e84cd647d$var$LoadingFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            height: "var(--ds-space-400, 32px)",
            width: "120px",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: "var(--ds-space-400, 32px)",
        width: "120px",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
const $d6223f0e84cd647d$export$e497040a58cd9fee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d6223f0e84cd647d$var$LoadingFallback, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-agent-version-picker",
            fallback: t1
        }, children)));
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-agent-version-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d6223f0e84cd647d$var$LoadingFallback, null)
    }, children)));



const $38c30b11f97c703e$var$AgentVersionPickerLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("klllb")).then((m)=>({
            default: m.AgentVersionPickerInternal
        })));
const $38c30b11f97c703e$export$e61e42b493865f52 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { agentAri: agentAri, canManage: canManage } = t0;
    let t1;
    if ($[0] !== agentAri || $[1] !== canManage) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6223f0e84cd647d$export$e497040a58cd9fee), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($38c30b11f97c703e$var$AgentVersionPickerLazy, {
            agentAri: agentAri,
            canManage: canManage
        }));
        $[0] = agentAri;
        $[1] = canManage;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ agentAri: agentAri, canManage: canManage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6223f0e84cd647d$export$e497040a58cd9fee), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($38c30b11f97c703e$var$AgentVersionPickerLazy, {
        agentAri: agentAri,
        canManage: canManage
    }));








/**
 * @generated SignedSource<<ca2d6f43195a47099ac5a1f7496c99dd>>
 * @relayHash 9080ca31fb5bdb44cc97bcb74b4f099e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ca0841fada77c40401477370e014774ed7f5d4e7a2aeae45beef0331884d302
const $d79685dfadf51d24$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "LinkedField",
            "name": "agentStudio_hasVersionCapability",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasVersionCapability"
                        }
                    ],
                    "type": "AgentStudioHasVersionCapability"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LegacyAgentVersionPickerWithCapabilityQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LegacyAgentVersionPickerWithCapabilityQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3ca0841fada77c40401477370e014774ed7f5d4e7a2aeae45beef0331884d302",
            "metadata": {},
            "name": "LegacyAgentVersionPickerWithCapabilityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d79685dfadf51d24$var$node.hash = "5826a94e8fbd05b6add121e789c65883";
var $d79685dfadf51d24$export$2e2bcd8739ae039 = $d79685dfadf51d24$var$node;






















const $971f0cfbc30ba88d$var$LegacyAgentVersionPickerLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fT6bY")).then((m)=>({
            default: m.LegacyAgentVersionPickerInternal
        })));
const $971f0cfbc30ba88d$export$531d2d1263141bf1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6223f0e84cd647d$export$e497040a58cd9fee), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($971f0cfbc30ba88d$var$LegacyAgentVersionPickerLazy, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6223f0e84cd647d$export$e497040a58cd9fee), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($971f0cfbc30ba88d$var$LegacyAgentVersionPickerLazy, null));


const $9bdac407046d5c61$export$b1143d8f4b64ce80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    let t0;
    if ($[0] !== siteId) {
        t0 = {
            cloudId: siteId
        };
        $[0] = siteId;
        $[1] = t0;
    } else t0 = $[1];
    const versioningData = (0, $6SsN4.useLazyLoadQuery)((0, $d79685dfadf51d24$export$2e2bcd8739ae039), t0);
    const hasVersionCapability = versioningData?.agentStudio_hasVersionCapability?.__typename === "AgentStudioHasVersionCapability" && Boolean(versioningData.agentStudio_hasVersionCapability.hasVersionCapability);
    let t1;
    if ($[2] !== hasVersionCapability) {
        t1 = hasVersionCapability ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $971f0cfbc30ba88d$export$531d2d1263141bf1), null) : null;
        $[2] = hasVersionCapability;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const versioningData = (0, $6SsN4.useLazyLoadQuery)((0, $d79685dfadf51d24$export$2e2bcd8739ae039), {
        cloudId: siteId
    });
    const hasVersionCapability = versioningData?.agentStudio_hasVersionCapability?.__typename === 'AgentStudioHasVersionCapability' && Boolean(versioningData.agentStudio_hasVersionCapability.hasVersionCapability);
    return hasVersionCapability ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $971f0cfbc30ba88d$export$531d2d1263141bf1), null) : null;
};



/**
 * @generated SignedSource<<51f21c6dc8ee88daeee443c123f286f6>>
 * @relayHash 46be7f02df08847e281c99176282b9c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f58d7e9be0dbe4f96706e361d58212d55b412b74952fb8aeee0d8c85f9a18c6c
const $d047c931f4a56326$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "agentAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AgentStudioAgentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canManage"
                    }
                ]
            }
        ],
        "type": "AgentStudioAssistant"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentVersionResolverPermissionsQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentVersionResolverPermissionsQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f58d7e9be0dbe4f96706e361d58212d55b412b74952fb8aeee0d8c85f9a18c6c",
            "metadata": {},
            "name": "AgentVersionResolverPermissionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d047c931f4a56326$var$node.hash = "dd6c1358d27b1346dc20db110cb2a836";
var $d047c931f4a56326$export$2e2bcd8739ae039 = $d047c931f4a56326$var$node;


/**
 * @generated SignedSource<<5acf8f72ac1375ab9aff5a223e2a711e>>
 * @relayHash c856108458bf22634635bceda74a3661
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5acb48f3ca59b87c27c2f058750aca9531236d1d335bafbf39c601cb6c7affa2
const $d722f57379731ac3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "LinkedField",
            "name": "agentStudio_hasVersionCapability",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasVersionCapability"
                        }
                    ],
                    "type": "AgentStudioHasVersionCapability"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentVersionResolverVersionCapabilityQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentVersionResolverVersionCapabilityQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5acb48f3ca59b87c27c2f058750aca9531236d1d335bafbf39c601cb6c7affa2",
            "metadata": {},
            "name": "AgentVersionResolverVersionCapabilityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d722f57379731ac3$var$node.hash = "2baa716bec911bf5b0db251fc2165a49";
var $d722f57379731ac3$export$2e2bcd8739ae039 = $d722f57379731ac3$var$node;
























var $onDaH = parcelRequire("onDaH");

const $ee3387252bff9e35$export$374fb73288a22588 = ({ agentId: agentId, agentAri: existingAgentAri, children: children, fallback: fallback })=>{
    (0, $6cFsl.di)((0, $bwd6H.useResolveAgentAri), (0, $eKjv9.useGlobalConfig), (0, $3TxKn.useChatStoreActions), (0, $6GT8L.useCurrentConversationId), (0, $onDaH.useCurrentChatConversation));
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    const { agentVersion: agentVersion } = (0, $onDaH.useCurrentChatConversation)();
    const { setConversationData: setConversationData } = (0, $3TxKn.useChatStoreActions)();
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)({
        agentId: agentId,
        existingAgentAri: existingAgentAri,
        cloudId: siteId
    });
    const versionCapabilityData = (0, $6SsN4.useLazyLoadQuery)((0, $d722f57379731ac3$export$2e2bcd8739ae039), {
        cloudId: siteId
    });
    const hasVersionCapability = versionCapabilityData?.agentStudio_hasVersionCapability?.__typename === 'AgentStudioHasVersionCapability' && Boolean(versionCapabilityData.agentStudio_hasVersionCapability.hasVersionCapability);
    const permissionsData = (0, $6SsN4.useLazyLoadQuery)((0, $d047c931f4a56326$export$2e2bcd8739ae039), {
        agentAri: agentAri ?? '',
        skip: !agentAri || !hasVersionCapability
    });
    const canManage = permissionsData?.agentStudio_agentById?.__typename === 'AgentStudioAssistant' && permissionsData.agentStudio_agentById.permissions?.canManage === true;
    (0, $cozmU.useEffect)(()=>{
        if (agentVersion || !currentConversationId) return;
        setConversationData({
            conversationId: currentConversationId,
            data: {
                agentVersion: {
                    versionType: hasVersionCapability && canManage ? 'DRAFT' : 'LIVE'
                }
            }
        });
    }, [
        agentVersion,
        canManage,
        currentConversationId,
        hasVersionCapability,
        setConversationData
    ]);
    return agentVersion || !currentConversationId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        agentAri: agentAri ?? null,
        canManage: canManage,
        hasVersionCapability: hasVersionCapability
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback);
};















var $j78zM = parcelRequire("j78zM");






































const $af7a2627e953fc2b$var$styles = {
    container: "_2Y7lL4S40j"
};
const $af7a2627e953fc2b$export$aa805006997874d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { agent: agent, versionPicker: versionPicker } = t0;
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    let t1;
    if ($[0] !== agent.id || $[1] !== agent.is_default || $[2] !== agent.named_id) {
        t1 = agent.is_default || (0, $2yWJZ.isDefaultRovoChat)({
            agentId: agent.id,
            agentNamedId: agent.named_id
        });
        $[0] = agent.id;
        $[1] = agent.is_default;
        $[2] = agent.named_id;
        $[3] = t1;
    } else t1 = $[3];
    const isDefaultRovoAgent = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents");
        $[4] = t2;
    } else t2 = $[4];
    const mentionAgentsEnabled = t2;
    const shouldUseRelayAgentIdentityDisplay = mentionAgentsEnabled && !isDefaultRovoAgent;
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    let t3;
    if ($[5] !== agent.agentAri || $[6] !== agent.creator_type || $[7] !== agent.description || $[8] !== agent.external_config_reference || $[9] !== agent.icon || $[10] !== agent.id || $[11] !== agent.identity_account_id || $[12] !== agent.is_verified || $[13] !== agent.name || $[14] !== agent.named_id || $[15] !== fullScreen || $[16] !== isDefaultRovoAgent || $[17] !== shouldUseRelayAgentIdentityDisplay || $[18] !== siteId || $[19] !== versionPicker) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true,
            exitThenEnter: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            duration: "large",
            entranceDirection: "bottom",
            exitDirection: "top"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                alignBlock: "center",
                alignInline: "center",
                space: "space.100",
                xcss: fullScreen ? undefined : $af7a2627e953fc2b$var$styles.container
            }, mentionAgentsEnabled && isDefaultRovoAgent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j78zM.RovoHexIcon), {
                label: "",
                size: "large"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "large"
            }, "Rovo")) : shouldUseRelayAgentIdentityDisplay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $378441c36b652603$export$24659eec65ce025d), {
                agentAri: agent.agentAri,
                agentId: agent.id,
                cloudId: siteId,
                identityAccountId: agent.identity_account_id,
                size: "large",
                testId: "rovo-agent-header-relay-name"
            }), agent.is_verified && (0, $iDrrr.fg)("rovo_agents_agent_verification") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), {
                adjacentTextSize: "headingLarge"
            }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                agentId: agent.id,
                agentNamedId: agent.external_config_reference ?? agent.named_id,
                agentIdentityAccountId: agent.identity_account_id,
                size: "large",
                isForgeAgent: (0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : undefined,
                forgeAgentIconUrl: (0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? agent.icon : undefined
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "large"
            }, agent.name), agent.is_verified && (0, $iDrrr.fg)("rovo_agents_agent_verification") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), {
                adjacentTextSize: "headingLarge"
            }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                align: "center"
            }, agent.description), versionPicker))));
        $[5] = agent.agentAri;
        $[6] = agent.creator_type;
        $[7] = agent.description;
        $[8] = agent.external_config_reference;
        $[9] = agent.icon;
        $[10] = agent.id;
        $[11] = agent.identity_account_id;
        $[12] = agent.is_verified;
        $[13] = agent.name;
        $[14] = agent.named_id;
        $[15] = fullScreen;
        $[16] = isDefaultRovoAgent;
        $[17] = shouldUseRelayAgentIdentityDisplay;
        $[18] = siteId;
        $[19] = versionPicker;
        $[20] = t3;
    } else t3 = $[20];
    return t3;
} : ({ agent: agent, versionPicker: versionPicker })=>{
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const isDefaultRovoAgent = agent.is_default || (0, $2yWJZ.isDefaultRovoChat)({
        agentId: agent.id,
        agentNamedId: agent.named_id
    });
    const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const shouldUseRelayAgentIdentityDisplay = mentionAgentsEnabled && !isDefaultRovoAgent;
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true,
        exitThenEnter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        duration: "large",
        entranceDirection: "bottom",
        exitDirection: "top"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignBlock: "center",
            alignInline: "center",
            space: "space.100",
            xcss: fullScreen ? undefined : $af7a2627e953fc2b$var$styles.container
        }, mentionAgentsEnabled && isDefaultRovoAgent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j78zM.RovoHexIcon), {
            label: "",
            size: "large"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "large"
        }, "Rovo")) : shouldUseRelayAgentIdentityDisplay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $378441c36b652603$export$24659eec65ce025d), {
            agentAri: agent.agentAri,
            agentId: agent.id,
            cloudId: siteId,
            identityAccountId: agent.identity_account_id,
            size: "large",
            testId: "rovo-agent-header-relay-name"
        }), agent.is_verified && (0, $iDrrr.fg)('rovo_agents_agent_verification') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), {
            adjacentTextSize: "headingLarge"
        }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "large",
            isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : undefined,
            forgeAgentIconUrl: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? agent.icon : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "large"
        }, agent.name), agent.is_verified && (0, $iDrrr.fg)('rovo_agents_agent_verification') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), {
            adjacentTextSize: "headingLarge"
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            align: "center"
        }, agent.description), versionPicker))));
};








/**
 * @generated SignedSource<<65df707e1f49c07b8ea76b1bfe1c696b>>
 * @relayHash d8de358e3ef63c4152f7fea5503e8f93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06524de9ce4b4e56e9bd120142e8735c122070b54be0c0ac8445cdc13e310aaf
const $510776d1d9328107$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionType"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "versionId",
                    "variableName": "versionId"
                },
                {
                    "kind": "Variable",
                    "name": "versionType",
                    "variableName": "versionType"
                }
            ],
            "kind": "ObjectValue",
            "name": "version"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "conversationStarters"
            },
            {
                "concreteType": "AgentStudioAgentVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    }
                ]
            }
        ],
        "type": "AgentStudioAssistant"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RovoAgentConversationStartersNewQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentById",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RovoAgentConversationStartersNewQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentById",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ 
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "06524de9ce4b4e56e9bd120142e8735c122070b54be0c0ac8445cdc13e310aaf",
            "metadata": {},
            "name": "RovoAgentConversationStartersNewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$510776d1d9328107$var$node.hash = "a250e08978d272de06629d57c8146948";
var $510776d1d9328107$export$2e2bcd8739ae039 = $510776d1d9328107$var$node;





























const $95be91314b46c4d4$var$styles = {
    skeletonRow: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYAOYQB _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $95be91314b46c4d4$var$ConversationStartersSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            testId: "rovo-agent-conversation-starters-skeleton"
        }, [
            "55%",
            "70%",
            "65%"
        ].map($95be91314b46c4d4$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        testId: "rovo-agent-conversation-starters-skeleton"
    }, [
        '55%',
        '70%',
        '65%'
    ].map((width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: width,
            xcss: $95be91314b46c4d4$var$styles.skeletonRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: width,
            height: 14,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }))));
const $95be91314b46c4d4$var$getVersionVariables = ({ agentAri: agentAri, agentVersion: agentVersion })=>({
        agentAri: agentAri,
        versionId: agentVersion?.versionId ?? null,
        versionType: agentVersion?.versionId ? null : agentVersion?.versionType ?? 'LIVE'
    });
const $95be91314b46c4d4$var$getStateCacheKey = ({ agentAri: agentAri, versionId: versionId, versionType: versionType })=>`${agentAri}:${versionId ?? versionType ?? 'LIVE'}`;
const $95be91314b46c4d4$var$getVersionMatchingRelayAgent = ({ relayAgent: relayAgent, versionId: versionId, versionType: versionType })=>{
    if (relayAgent?.__typename !== 'AgentStudioAssistant') return null;
    if (versionId) return relayAgent.version?.id === versionId ? relayAgent : null;
    return relayAgent.version?.type === versionType ? relayAgent : null;
}; /**
    * Keeps Chat conversation starters aligned with its selected Agent version:
    * - Reuses Relay data only when its version matches Chat
    * - Fetches mismatches without normalization and caches raw strings by Agent/version
    * - Shows a skeleton while the selected version loads, avoiding starters from another version
    *
    * Agent versions share one Relay record ID, so normalizing a mismatch would overwrite Studio data.
    * Remove this workaround when RAGE-4123 is resolved:
    * https://product-fabric.atlassian.net/browse/RAGE-4123
    */ 
const $95be91314b46c4d4$export$3fb185b5d1cb7bdd = ({ agentId: agentId, agentAri: existingAgentAri, onConversationStarterClick: onConversationStarterClick })=>{
    (0, $6cFsl.di)((0, $bwd6H.useResolveAgentAri), (0, $eKjv9.useGlobalConfig), (0, $onDaH.useCurrentChatConversation));
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { agentVersion: agentVersion } = (0, $onDaH.useCurrentChatConversation)();
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)({
        agentId: agentId,
        existingAgentAri: existingAgentAri,
        cloudId: siteId
    });
    const variables = (0, $cozmU.useMemo)(()=>$95be91314b46c4d4$var$getVersionVariables({
            agentAri: agentAri ?? '',
            agentVersion: agentVersion
        }), [
        agentAri,
        agentVersion
    ]);
    const stateCacheKey = $95be91314b46c4d4$var$getStateCacheKey(variables);
    const relayCache = (0, $6SsN4.useLazyLoadQuery)((0, $510776d1d9328107$export$2e2bcd8739ae039), variables, {
        fetchPolicy: 'store-only'
    });
    const [stateCache, setStateCache] = (0, $cozmU.useState)({});
    const matchingRelayCacheAgent = (0, $cozmU.useMemo)(()=>$95be91314b46c4d4$var$getVersionMatchingRelayAgent({
            relayAgent: relayCache?.agentStudio_agentById,
            versionId: variables.versionId,
            versionType: variables.versionType
        }), [
        relayCache?.agentStudio_agentById,
        variables.versionId,
        variables.versionType
    ]);
    const stateCachedConversationStarters = stateCache[stateCacheKey];
    (0, $cozmU.useEffect)(()=>{
        if (!matchingRelayCacheAgent) return;
        setStateCache((current)=>({
                ...current,
                [stateCacheKey]: matchingRelayCacheAgent.conversationStarters ?? []
            }));
    }, [
        matchingRelayCacheAgent,
        stateCacheKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!agentAri || matchingRelayCacheAgent || stateCachedConversationStarters !== undefined) return;
         // Calling the network layer directly returns the raw response without Relay normalization,
        // so this version cannot overwrite the shared Agent record in the Relay cache.
        const subscription = environment.getNetwork().execute((0, $510776d1d9328107$export$2e2bcd8739ae039).params, variables, {
            force: true
        }).subscribe({
            next: (response)=>{
                if (!('data' in response)) return;
                const data = response.data;
                if (data?.agentStudio_agentById?.__typename !== 'AgentStudioAssistant') return;
                const conversationStarters = data.agentStudio_agentById.conversationStarters ?? [];
                setStateCache((current_0)=>({
                        ...current_0,
                        [stateCacheKey]: conversationStarters
                    }));
            }
        });
        return ()=>subscription.unsubscribe();
    }, [
        agentAri,
        environment,
        stateCachedConversationStarters,
        stateCacheKey,
        variables,
        matchingRelayCacheAgent
    ]);
    const getConversationStarters = ()=>{
        if (matchingRelayCacheAgent) return matchingRelayCacheAgent.conversationStarters ?? [];
        if (stateCachedConversationStarters !== undefined) return stateCachedConversationStarters;
        if (!agentAri) return [];
        return null;
    };
    const conversationStarters_0 = getConversationStarters();
    if (conversationStarters_0 === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95be91314b46c4d4$var$ConversationStartersSkeleton, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $699ad632582ba79d$export$175af43b96607140), {
        agentId: agentId,
        conversationStarters: conversationStarters_0,
        onConversationStarterClick: onConversationStarterClick
    });
};
function $95be91314b46c4d4$var$_temp(width) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: width,
        xcss: $95be91314b46c4d4$var$styles.skeletonRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: width,
        height: 14,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }));
}


const $506b74a7df7281b7$var$styles = {
    wrapper: "_2Y7lL45zaO _0jFU0VN91d _39xV02N91d _313842IZbP _1wydGW5zaO",
    wrapperFullscreen: "_2YLqiKIZbP _2Y7lL4Pgdg _0jFU0VN91d _39xV02OFxT _313842IZbP _1wydGW5zaO",
    conversationStarters: "_2Y7lL45zaO _1wydGW5zaO _39xV02N91d",
    conversationStartersFullscreen: "_39xV02N91d"
};
const $506b74a7df7281b7$var$RovoAgentEmptyStateWithRelay = ({ agent: agent, fullScreen: fullScreen, onConversationStarterClick: onConversationStarterClick })=>{
    (0, $6cFsl.di)((0, $gn6Jj.useAgentVersioningConfig), (0, $ee3387252bff9e35$export$374fb73288a22588), (0, $38c30b11f97c703e$export$e61e42b493865f52), (0, $af7a2627e953fc2b$export$aa805006997874d8), (0, $95be91314b46c4d4$export$3fb185b5d1cb7bdd), (0, $91e4408a300abe15$export$88793db575c316c3));
    const showVersionPicker = (0, $gn6Jj.useAgentVersioningConfig)()?.showVersionPicker ?? false;
    const renderRelayContent = (resolvedAgentVersionAccess)=>{
        const versionPicker = showVersionPicker && resolvedAgentVersionAccess?.hasVersionCapability && resolvedAgentVersionAccess.canManage && resolvedAgentVersionAccess.agentAri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38c30b11f97c703e$export$e61e42b493865f52), {
            agentAri: resolvedAgentVersionAccess.agentAri,
            canManage: resolvedAgentVersionAccess.canManage
        }) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignBlock: "end",
            alignInline: "center",
            xcss: fullScreen ? $506b74a7df7281b7$var$styles.wrapperFullscreen : $506b74a7df7281b7$var$styles.wrapper,
            testId: "rovo-agent-empty-state",
            space: "space.400"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af7a2627e953fc2b$export$aa805006997874d8), {
            agent: agent,
            versionPicker: versionPicker
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: fullScreen ? $506b74a7df7281b7$var$styles.conversationStartersFullscreen : $506b74a7df7281b7$var$styles.conversationStarters
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95be91314b46c4d4$export$3fb185b5d1cb7bdd), {
            agentId: agent.id,
            agentAri: agent.agentAri,
            onConversationStarterClick: onConversationStarterClick
        })));
    };
    const relayFallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "end",
        alignInline: "center",
        xcss: fullScreen ? $506b74a7df7281b7$var$styles.wrapperFullscreen : $506b74a7df7281b7$var$styles.wrapper,
        testId: "rovo-agent-empty-state",
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af7a2627e953fc2b$export$aa805006997874d8), {
        agent: agent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: fullScreen ? $506b74a7df7281b7$var$styles.conversationStartersFullscreen : $506b74a7df7281b7$var$styles.conversationStarters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91e4408a300abe15$export$88793db575c316c3), {
        showGreeting: false
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: relayFallback
    }, showVersionPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee3387252bff9e35$export$374fb73288a22588), {
        agentId: agent.id,
        agentAri: agent.agentAri,
        fallback: relayFallback
    }, renderRelayContent) : renderRelayContent());
};
const $506b74a7df7281b7$export$3bafafbc17b0f410 = ({ agent: agent, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg), (0, $iDlFY.useEditorPlaceholder), (0, $dSCNl.useUIConfig), (0, $gn6Jj.useAgentVersioningConfig), (0, $3TxKn.useChatStoreActions), (0, $9bdac407046d5c61$export$b1143d8f4b64ce80), (0, $af7a2627e953fc2b$export$aa805006997874d8), (0, $d6b8e275f7d05956$export$678a67b7aa4dcdd5), (0, $91e4408a300abe15$export$88793db575c316c3));
    const { insertPlaceholder: insertPlaceholder, isPromptWithPlaceholder: isPromptWithPlaceholder, clearPlaceholder: clearPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    const { sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const showLegacyVersionPicker = (0, $gn6Jj.useAgentVersioningConfig)()?.showVersionPicker ?? false;
    const onConversationStarterClick = (0, $cozmU.useCallback)(async (conversationStarter)=>{
        clearPlaceholder();
        if (isPromptWithPlaceholder(conversationStarter.message)) {
            insertPlaceholder(conversationStarter.message);
            return;
        }
        await sendMessage({
            prompt: (0, $6rwn6.encodeAdf)(conversationStarter.message),
            storeUserMessages: false,
            agent: agent,
            messageSources: {
                interactionSource: 'emptyStateSuggestions',
                followUpSource: 'ai-mate'
            },
            ...(0, $iDrrr.fg)('rovo_agent_conversation_starter_context_preference') ? {} : {
                addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference
            }
        });
    }, [
        clearPlaceholder,
        insertPlaceholder,
        isPromptWithPlaceholder,
        agent,
        sendMessage,
        addCurrentPageAsContextUserPreference
    ]);
    if (!(0, $iDrrr.fg)('rovo_agent_conversation_starters_relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91e4408a300abe15$export$88793db575c316c3), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "end",
        alignInline: "center",
        xcss: fullScreen ? $506b74a7df7281b7$var$styles.wrapperFullscreen : $506b74a7df7281b7$var$styles.wrapper,
        testId: "rovo-agent-empty-state",
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af7a2627e953fc2b$export$aa805006997874d8), {
        agent: agent,
        versionPicker: showLegacyVersionPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bdac407046d5c61$export$b1143d8f4b64ce80), null) : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: fullScreen ? $506b74a7df7281b7$var$styles.conversationStartersFullscreen : $506b74a7df7281b7$var$styles.conversationStarters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6b8e275f7d05956$export$678a67b7aa4dcdd5), {
        agent: agent,
        onConversationStarterClick: onConversationStarterClick
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($506b74a7df7281b7$var$RovoAgentEmptyStateWithRelay, {
        agent: agent,
        fullScreen: Boolean(fullScreen),
        onConversationStarterClick: onConversationStarterClick
    });
};











































































var $fde29cfecadfc772$exports = {};
$fde29cfecadfc772$exports = new URL("rovo-chat-bubbles.ad8ad13a.svg", import.meta.url).toString();





const $f509560d36e3eca2$var$message = (0, $kSwu1.defineMessages)({
    defaultGreetingText: {
        id: "rovo-chat.greeting-card.default-greeting-text",
        defaultMessage: "How can I help, {name}?"
    }
});
var $f509560d36e3eca2$export$2e2bcd8739ae039 = $f509560d36e3eca2$var$message;


const $a853efd6070d89d8$var$MAX_TITLE_LENGTH = 50;
const $a853efd6070d89d8$var$styles = {
    wrapper: "_3SamIH5zaO _39xV02N91d",
    icon: "_23rrnHttJb _1YKVNsdnbC",
    animatedContainer: "_23rrnHpQYX _4bt5LAnQyn _2WAcuGnQyn _39Ohv4YbGa _1SdfoHYbGa",
    animatedContainerShown: "_1YKVNs7dHp _0NUa3rgZxp",
    animatedContainerHidden: "_1YKVNsdnbC _0NUa3rdnbC",
    heading: "_2YLqiKNHnM _2fwxA5DIqT",
    subtitle: "_2sNsIgmnOE _2YLqiKNHnM _2fwxA5DIqT _1UtDYzZpcK"
};
const $a853efd6070d89d8$export$949ed0d2d58c2b53 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { src: src, srcDark: srcDark, title: title, subtitle: subtitle, testId: testId, animationDuration: t1, entranceDirection: t2, exitDirection: t3, animationKey: t4, headingSize: t5, isRevealedByResize: isRevealedByResize, isRevealedByDefault: t6, firstName: firstName, truncateGreeting: t7, headingPaddingInline: headingPaddingInline, imageHeight: t8, imageWidth: imageWidth } = t0;
    const animationDuration = t1 === undefined ? "large" : t1;
    const entranceDirection = t2 === undefined ? "bottom" : t2;
    const exitDirection = t3 === undefined ? "top" : t3;
    const animationKey = t4 === undefined ? "custom-greeting" : t4;
    const headingSize = t5 === undefined ? "xlarge" : t5;
    const isRevealedByDefault = t6 === undefined ? true : t6;
    const truncateGreeting = t7 === undefined ? true : t7;
    const imageHeight = t8 === undefined ? 80 : t8;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [imageLoaded, setImageLoaded] = (0, $cozmU.useState)(false);
    let t9;
    if ($[0] !== firstName || $[1] !== formatMessage || $[2] !== title) {
        t9 = title ?? formatMessage((0, $f509560d36e3eca2$export$2e2bcd8739ae039).defaultGreetingText, {
            name: firstName
        });
        $[0] = firstName;
        $[1] = formatMessage;
        $[2] = title;
        $[3] = t9;
    } else t9 = $[3];
    const titleToDisplay = t9;
    let t10;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            setImageLoaded(true);
        };
        $[4] = t10;
    } else t10 = $[4];
    const handleImageLoad = t10;
    let t11;
    if ($[5] !== titleToDisplay || $[6] !== truncateGreeting) {
        t11 = titleToDisplay.length > $a853efd6070d89d8$var$MAX_TITLE_LENGTH && truncateGreeting ? `${titleToDisplay.slice(0, $a853efd6070d89d8$var$MAX_TITLE_LENGTH)}\u{2026}` : titleToDisplay;
        $[5] = titleToDisplay;
        $[6] = truncateGreeting;
        $[7] = t11;
    } else t11 = $[7];
    const displayTitle = t11;
    let t12;
    if ($[8] !== testId) {
        t12 = testId ? {
            testId: `custom-rovo-greeting-${testId}`
        } : {};
        $[8] = testId;
        $[9] = t12;
    } else t12 = $[9];
    const t13 = src ?? (0, (/*@__PURE__*/$parcel$interopDefault($fde29cfecadfc772$exports)));
    const t14 = imageLoaded ? 1 : 0;
    let t15;
    if ($[10] !== t14) {
        t15 = {
            opacity: t14
        };
        $[10] = t14;
        $[11] = t15;
    } else t15 = $[11];
    let t16;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $hekY6.default)([
            $a853efd6070d89d8$var$styles.icon
        ]);
        $[12] = t16;
    } else t16 = $[12];
    let t17;
    if ($[13] !== imageHeight || $[14] !== imageWidth || $[15] !== srcDark || $[16] !== t13 || $[17] !== t15) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: t13,
            srcDark: srcDark,
            alt: "",
            height: imageHeight,
            width: imageWidth,
            style: t15,
            onLoad: handleImageLoad,
            className: t16
        });
        $[13] = imageHeight;
        $[14] = imageWidth;
        $[15] = srcDark;
        $[16] = t13;
        $[17] = t15;
        $[18] = t17;
    } else t17 = $[18];
    let t18;
    if ($[19] !== displayTitle || $[20] !== headingSize) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: headingSize
        }, displayTitle);
        $[19] = displayTitle;
        $[20] = headingSize;
        $[21] = t18;
    } else t18 = $[21];
    let t19;
    if ($[22] !== headingPaddingInline || $[23] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $a853efd6070d89d8$var$styles.heading,
            paddingInline: headingPaddingInline
        }, t18);
        $[22] = headingPaddingInline;
        $[23] = t18;
        $[24] = t19;
    } else t19 = $[24];
    let t20;
    if ($[25] !== headingPaddingInline || $[26] !== subtitle) {
        t20 = subtitle && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $a853efd6070d89d8$var$styles.subtitle,
            paddingInline: headingPaddingInline
        }, subtitle);
        $[25] = headingPaddingInline;
        $[26] = subtitle;
        $[27] = t20;
    } else t20 = $[27];
    let t21;
    if ($[28] !== t12 || $[29] !== t17 || $[30] !== t19 || $[31] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $a853efd6070d89d8$var$styles.wrapper,
            space: "space.100",
            alignBlock: "center",
            alignInline: "center",
            ...t12
        }, t17, t19, t20);
        $[28] = t12;
        $[29] = t17;
        $[30] = t19;
        $[31] = t20;
        $[32] = t21;
    } else t21 = $[32];
    const greetingContent = t21;
    if (isRevealedByResize !== undefined) {
        const isVisible = isRevealedByResize === null ? isRevealedByDefault : isRevealedByResize;
        const t22 = isVisible ? $a853efd6070d89d8$var$styles.animatedContainerShown : $a853efd6070d89d8$var$styles.animatedContainerHidden;
        let t23;
        if ($[33] !== t22) {
            t23 = (0, $w6R6I.cx)($a853efd6070d89d8$var$styles.animatedContainer, t22);
            $[33] = t22;
            $[34] = t23;
        } else t23 = $[34];
        let t24;
        if ($[35] !== greetingContent || $[36] !== t23) {
            t24 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: t23
            }, greetingContent);
            $[35] = greetingContent;
            $[36] = t23;
            $[37] = t24;
        } else t24 = $[37];
        return t24;
    }
    let t22;
    if ($[38] !== greetingContent) {
        t22 = (fadeInProps)=>/*#__PURE__*/ $cozmU.createElement("div", fadeInProps, greetingContent);
        $[38] = greetingContent;
        $[39] = t22;
    } else t22 = $[39];
    let t23;
    if ($[40] !== animationDuration || $[41] !== animationKey || $[42] !== entranceDirection || $[43] !== exitDirection || $[44] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            appear: true,
            exitThenEnter: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            key: animationKey,
            duration: animationDuration,
            entranceDirection: entranceDirection,
            exitDirection: exitDirection
        }, t22));
        $[40] = animationDuration;
        $[41] = animationKey;
        $[42] = entranceDirection;
        $[43] = exitDirection;
        $[44] = t22;
        $[45] = t23;
    } else t23 = $[45];
    return t23;
} : ({ src: src, srcDark: srcDark, title: title, subtitle: subtitle, testId: testId, animationDuration: animationDuration = 'large', entranceDirection: entranceDirection = 'bottom', exitDirection: exitDirection = 'top', animationKey: animationKey = 'custom-greeting', headingSize: headingSize = 'xlarge', isRevealedByResize: isRevealedByResize, isRevealedByDefault: isRevealedByDefault = true, firstName: firstName, truncateGreeting: truncateGreeting = true, headingPaddingInline: headingPaddingInline, imageHeight: imageHeight = 80, imageWidth: imageWidth })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [imageLoaded, setImageLoaded] = (0, $cozmU.useState)(false);
    const titleToDisplay = title ?? formatMessage((0, $f509560d36e3eca2$export$2e2bcd8739ae039).defaultGreetingText, {
        name: firstName
    });
    const handleImageLoad = ()=>{
        setImageLoaded(true);
    };
    const displayTitle = titleToDisplay.length > $a853efd6070d89d8$var$MAX_TITLE_LENGTH && truncateGreeting ? `${titleToDisplay.slice(0, $a853efd6070d89d8$var$MAX_TITLE_LENGTH)}\u{2026}` : titleToDisplay;
    const greetingContent = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $a853efd6070d89d8$var$styles.wrapper,
        space: "space.100",
        alignBlock: "center",
        alignInline: "center",
        ...testId ? {
            testId: `custom-rovo-greeting-${testId}`
        } : {}
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: src ?? (0, (/*@__PURE__*/$parcel$interopDefault($fde29cfecadfc772$exports))),
        srcDark: srcDark,
        alt: "",
        height: imageHeight,
        width: imageWidth,
        style: {
            opacity: imageLoaded ? 1 : 0
        },
        onLoad: handleImageLoad,
        className: (0, $hekY6.default)([
            $a853efd6070d89d8$var$styles.icon
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a853efd6070d89d8$var$styles.heading,
        paddingInline: headingPaddingInline
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: headingSize
    }, displayTitle)), subtitle && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a853efd6070d89d8$var$styles.subtitle,
        paddingInline: headingPaddingInline
    }, subtitle)); // Resize mode: use CSS transitions for smooth fade + height collapse without layout jumps
    if (isRevealedByResize !== undefined) {
        // If user hasn't resized yet (null), use the default visibility
        // Otherwise, use the resize-controlled visibility
        const isVisible = isRevealedByResize === null ? isRevealedByDefault : isRevealedByResize;
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($a853efd6070d89d8$var$styles.animatedContainer, isVisible ? $a853efd6070d89d8$var$styles.animatedContainerShown : $a853efd6070d89d8$var$styles.animatedContainerHidden)
        }, greetingContent);
    } // Normal mode: use @atlaskit/motion for directional entrance animation
    return /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
        appear: true,
        exitThenEnter: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        key: animationKey,
        duration: animationDuration,
        entranceDirection: entranceDirection,
        exitDirection: exitDirection
    }, (fadeInProps)=>/*#__PURE__*/ $cozmU.createElement("div", fadeInProps, greetingContent)));
};


















var $IQ4Dz = parcelRequire("IQ4Dz");

var $6a63abc19b5678af$exports = {};
$6a63abc19b5678af$exports = new URL("deep-research-icon-dark-mode.184ef24b.svg", import.meta.url).toString();


var $a88f50aa460fb27b$exports = {};
$a88f50aa460fb27b$exports = new URL("deep-research-icon-light-mode.626661c3.svg", import.meta.url).toString();


var $1114ad2a9e6901b7$exports = {};
$1114ad2a9e6901b7$exports = new URL("max-atom-optimized.ca2ba615.gif", import.meta.url).toString();


var $e8a9bd0547228812$exports = {};
$e8a9bd0547228812$exports = new URL("max-atom-white-optimized.0420b840.gif", import.meta.url).toString();



var $6d995b833ec1dc9b$exports = {};
$6d995b833ec1dc9b$exports = new URL("task-done.18e34ddc.svg", import.meta.url).toString();



const $4973a43f7b3c85d7$export$3d054339ac59aa25 = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled = false, taskModeEnabled: taskModeEnabled })=>{
    if (deepResearchEnabled) return {
        presentationMode: 'deepResearch',
        personalityMode: 'normal'
    };
    if (taskModeEnabled) return {
        presentationMode: 'taskMode',
        personalityMode: 'taskMode'
    };
    if (thinkDeeperEnabled) return {
        presentationMode: 'normal',
        personalityMode: 'thinkDeeper'
    };
    return {
        presentationMode: 'normal',
        personalityMode: 'normal'
    };
};





const $8308dd435f6f299a$var$message = (0, $kSwu1.defineMessages)({
    defaultGreetingText: {
        id: "rovo-chat.rovo-greeting.default-greeting-text",
        defaultMessage: "How can I help, {name}?"
    },
    deepResearchGreetingText: {
        id: "rovo-chat.rovo-greeting.deep-research-greeting-text",
        defaultMessage: "Let's go in-depth"
    },
    taskModeGreetingText: {
        id: "rovo-chat.rovo-greeting.task-mode-greeting-text",
        defaultMessage: "Let's check something off your list"
    },
    taskModeDesignRefreshGreetingText: {
        id: "rovo-chat.rovo-greeting.task-mode-design-refresh-greeting-text",
        defaultMessage: "Let's plan your next move"
    }
});
var $8308dd435f6f299a$export$2e2bcd8739ae039 = $8308dd435f6f299a$var$message;


const $24e0ffdb3d2e36e9$export$576fcda7744d6b09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { firstName: firstName, isDeepResearchEnabled: isDeepResearchEnabled, isTaskModeEnabled: isTaskModeEnabled, greetingMode: greetingMode, greetingText: greetingText, illustrationSrc: illustrationSrc, illustrationSrcDark: illustrationSrcDark, headingSize: headingSize, isRevealedByResize: isRevealedByResize, isRevealedByDefault: isRevealedByDefault } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t1;
    if ($[0] !== greetingMode || $[1] !== isDeepResearchEnabled || $[2] !== isTaskModeEnabled) {
        t1 = greetingMode ?? (0, $4973a43f7b3c85d7$export$3d054339ac59aa25)({
            deepResearchEnabled: isDeepResearchEnabled,
            taskModeEnabled: Boolean(isTaskModeEnabled)
        }).presentationMode;
        $[0] = greetingMode;
        $[1] = isDeepResearchEnabled;
        $[2] = isTaskModeEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const presentationMode = t1;
    let t2;
    if ($[4] !== presentationMode) {
        t2 = presentationMode === "taskMode" && (0, $iDrrr.fg)("rovo_chat_task_mode_design_refresh");
        $[4] = presentationMode;
        $[5] = t2;
    } else t2 = $[5];
    const isDesignRefresh = t2;
    const maxModeAnimationSrc = colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($e8a9bd0547228812$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1114ad2a9e6901b7$exports)));
    let t3;
    if ($[6] !== firstName || $[7] !== formatMessage) {
        t3 = formatMessage((0, $8308dd435f6f299a$export$2e2bcd8739ae039).defaultGreetingText, {
            name: firstName
        });
        $[6] = firstName;
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    const defaultGreeting = t3;
    const displayGreeting = greetingText || defaultGreeting;
    const customGreetingAnimationSuffix = greetingText === undefined ? "" : "-custom";
    if (presentationMode === "deepResearch") {
        const t4 = illustrationSrc ?? (0, (/*@__PURE__*/$parcel$interopDefault($a88f50aa460fb27b$exports)));
        const t5 = illustrationSrcDark ?? (0, (/*@__PURE__*/$parcel$interopDefault($6a63abc19b5678af$exports)));
        let t6;
        if ($[9] !== formatMessage || $[10] !== greetingText) {
            t6 = greetingText ?? formatMessage((0, $8308dd435f6f299a$export$2e2bcd8739ae039).deepResearchGreetingText);
            $[9] = formatMessage;
            $[10] = greetingText;
            $[11] = t6;
        } else t6 = $[11];
        const t7 = `deep-research${customGreetingAnimationSuffix}`;
        let t8;
        if ($[12] !== firstName || $[13] !== headingSize || $[14] !== isRevealedByDefault || $[15] !== isRevealedByResize || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
                src: t4,
                srcDark: t5,
                title: t6,
                animationKey: t7,
                entranceDirection: "top",
                exitDirection: "top",
                headingSize: headingSize,
                isRevealedByResize: isRevealedByResize,
                isRevealedByDefault: isRevealedByDefault,
                firstName: firstName
            });
            $[12] = firstName;
            $[13] = headingSize;
            $[14] = isRevealedByDefault;
            $[15] = isRevealedByResize;
            $[16] = t4;
            $[17] = t5;
            $[18] = t6;
            $[19] = t7;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    if (presentationMode === "taskMode") {
        const t4 = illustrationSrc ?? (isDesignRefresh ? maxModeAnimationSrc : (0, (/*@__PURE__*/$parcel$interopDefault($6d995b833ec1dc9b$exports))));
        let t5;
        if ($[21] !== formatMessage || $[22] !== greetingText || $[23] !== isDesignRefresh) {
            t5 = greetingText ?? formatMessage(isDesignRefresh ? (0, $8308dd435f6f299a$export$2e2bcd8739ae039).taskModeDesignRefreshGreetingText : (0, $8308dd435f6f299a$export$2e2bcd8739ae039).taskModeGreetingText);
            $[21] = formatMessage;
            $[22] = greetingText;
            $[23] = isDesignRefresh;
            $[24] = t5;
        } else t5 = $[24];
        const t6 = `task-mode${customGreetingAnimationSuffix}`;
        let t7;
        if ($[25] !== isDesignRefresh) {
            t7 = isDesignRefresh ? {
                imageHeight: 67,
                imageWidth: 67
            } : {};
            $[25] = isDesignRefresh;
            $[26] = t7;
        } else t7 = $[26];
        let t8;
        if ($[27] !== firstName || $[28] !== headingSize || $[29] !== illustrationSrcDark || $[30] !== isRevealedByDefault || $[31] !== isRevealedByResize || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
                src: t4,
                srcDark: illustrationSrcDark,
                title: t5,
                animationKey: t6,
                entranceDirection: "top",
                exitDirection: "top",
                headingSize: headingSize,
                headingPaddingInline: "space.400",
                isRevealedByResize: isRevealedByResize,
                isRevealedByDefault: isRevealedByDefault,
                firstName: firstName,
                ...t7
            });
            $[27] = firstName;
            $[28] = headingSize;
            $[29] = illustrationSrcDark;
            $[30] = isRevealedByDefault;
            $[31] = isRevealedByResize;
            $[32] = t4;
            $[33] = t5;
            $[34] = t6;
            $[35] = t7;
            $[36] = t8;
        } else t8 = $[36];
        return t8;
    }
    const t4 = illustrationSrc ?? (0, (/*@__PURE__*/$parcel$interopDefault($fde29cfecadfc772$exports)));
    const t5 = `normal-chat${customGreetingAnimationSuffix}`;
    let t6;
    if ($[37] !== displayGreeting || $[38] !== firstName || $[39] !== headingSize || $[40] !== illustrationSrcDark || $[41] !== isRevealedByDefault || $[42] !== isRevealedByResize || $[43] !== t4 || $[44] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
            src: t4,
            srcDark: illustrationSrcDark,
            title: displayGreeting,
            firstName: firstName,
            animationKey: t5,
            entranceDirection: "bottom",
            exitDirection: "top",
            headingSize: headingSize,
            isRevealedByResize: isRevealedByResize,
            isRevealedByDefault: isRevealedByDefault
        });
        $[37] = displayGreeting;
        $[38] = firstName;
        $[39] = headingSize;
        $[40] = illustrationSrcDark;
        $[41] = isRevealedByDefault;
        $[42] = isRevealedByResize;
        $[43] = t4;
        $[44] = t5;
        $[45] = t6;
    } else t6 = $[45];
    return t6;
} : ({ firstName: firstName, isDeepResearchEnabled: isDeepResearchEnabled, isTaskModeEnabled: isTaskModeEnabled, greetingMode: greetingMode, greetingText: greetingText, illustrationSrc: illustrationSrc, illustrationSrcDark: illustrationSrcDark, headingSize: headingSize, isRevealedByResize: isRevealedByResize, isRevealedByDefault: isRevealedByDefault })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const presentationMode = greetingMode ?? (0, $4973a43f7b3c85d7$export$3d054339ac59aa25)({
        deepResearchEnabled: isDeepResearchEnabled,
        taskModeEnabled: Boolean(isTaskModeEnabled)
    }).presentationMode;
    const isDesignRefresh = presentationMode === 'taskMode' && (0, $iDrrr.fg)('rovo_chat_task_mode_design_refresh');
    const maxModeAnimationSrc = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($e8a9bd0547228812$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1114ad2a9e6901b7$exports)));
    const defaultGreeting = formatMessage((0, $8308dd435f6f299a$export$2e2bcd8739ae039).defaultGreetingText, {
        name: firstName
    });
    const displayGreeting = greetingText || defaultGreeting;
    // Changing the key lets the default greeting exit and the custom greeting enter
    const customGreetingAnimationSuffix = greetingText === undefined ? '' : '-custom';
    if (presentationMode === 'deepResearch') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
        src: illustrationSrc ?? (0, (/*@__PURE__*/$parcel$interopDefault($a88f50aa460fb27b$exports))),
        srcDark: illustrationSrcDark ?? (0, (/*@__PURE__*/$parcel$interopDefault($6a63abc19b5678af$exports))),
        title: greetingText ?? formatMessage((0, $8308dd435f6f299a$export$2e2bcd8739ae039).deepResearchGreetingText),
        animationKey: `deep-research${customGreetingAnimationSuffix}`,
        entranceDirection: "top",
        exitDirection: "top",
        headingSize: headingSize,
        isRevealedByResize: isRevealedByResize,
        isRevealedByDefault: isRevealedByDefault,
        firstName: firstName
    });
    if (presentationMode === 'taskMode') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
        src: illustrationSrc ?? (isDesignRefresh ? maxModeAnimationSrc : (0, (/*@__PURE__*/$parcel$interopDefault($6d995b833ec1dc9b$exports)))),
        srcDark: illustrationSrcDark,
        title: greetingText ?? formatMessage(isDesignRefresh ? (0, $8308dd435f6f299a$export$2e2bcd8739ae039).taskModeDesignRefreshGreetingText : (0, $8308dd435f6f299a$export$2e2bcd8739ae039).taskModeGreetingText),
        animationKey: `task-mode${customGreetingAnimationSuffix}`,
        entranceDirection: "top",
        exitDirection: "top",
        headingSize: headingSize,
        headingPaddingInline: "space.400",
        isRevealedByResize: isRevealedByResize,
        isRevealedByDefault: isRevealedByDefault,
        firstName: firstName,
        ...isDesignRefresh ? {
            imageHeight: 67,
            imageWidth: 67
        } : {}
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
        src: illustrationSrc ?? (0, (/*@__PURE__*/$parcel$interopDefault($fde29cfecadfc772$exports))),
        srcDark: illustrationSrcDark,
        title: displayGreeting,
        firstName: firstName,
        animationKey: `normal-chat${customGreetingAnimationSuffix}`,
        entranceDirection: "bottom",
        exitDirection: "top",
        headingSize: headingSize,
        isRevealedByResize: isRevealedByResize,
        isRevealedByDefault: isRevealedByDefault
    });
};






















































var $1KLPb = parcelRequire("1KLPb");




























const $5704573f70fbdaf0$var$PLACEHOLDER_ACTION_ID_PREFIX = 'dynamic-placeholder-';
const $5704573f70fbdaf0$export$3a1fbd6869e5de1b = (index, handleType)=>({
        id: `${$5704573f70fbdaf0$var$PLACEHOLDER_ACTION_ID_PREFIX}${index}`,
        // id to identify placeholder actions
        title: '',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        handleType: handleType ?? (0, $6iWVH.HandleActionType).Chat
    });
const $5704573f70fbdaf0$export$4419de7988ab3b2f = (action)=>{
    return action.id.startsWith($5704573f70fbdaf0$var$PLACEHOLDER_ACTION_ID_PREFIX);
};



var $5uiWK = parcelRequire("5uiWK");


var $bQmvI = parcelRequire("bQmvI");




const $0e03c87c9fa9183e$export$caa54e3423620b5f = (dynamicConvoActions)=>dynamicConvoActions.reduce((map, action)=>{
        if (!(0, $2TzCj.isChatAction)(action) || !action.jtbdCategory) return map;
        if (!map[action.jtbdCategory]) map[action.jtbdCategory] = 1;
        else map[action.jtbdCategory] += 1;
        return map;
    }, {});





const $bbeffc38eecb4c2c$var$supportedPageContextTypes = [
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW
];
const $bbeffc38eecb4c2c$export$7deab7cde6bca734 = (pageContextType)=>{
    return $bbeffc38eecb4c2c$var$supportedPageContextTypes.includes(pageContextType);
};


const $f14fabf2782a2f4c$var$DEFAULT_MAX_PLACEHOLDER_LENGTH = 90;
function $f14fabf2782a2f4c$export$aea266c07c1b2cbb(text, maxLength = $f14fabf2782a2f4c$var$DEFAULT_MAX_PLACEHOLDER_LENGTH) {
    if (text.length <= maxLength) return text;
    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    const breakPoint = lastSpaceIndex > 0 ? lastSpaceIndex : maxLength;
    return text.substring(0, breakPoint) + '...';
}



var $lFQjm = parcelRequire("lFQjm");



















var $csz0J = parcelRequire("csz0J");

const $ca23910def64ea3b$export$9c53a6cb2cea6fed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { pageContextType: pageContextType, location: location, assistanceServiceParams: assistanceServiceParams, pageContextSupportedForDynamicStarters: pageContextSupportedForDynamicStarters } = t0;
    const { setConversationActions: setConversationActions } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { actions: actionsFromStore, jiraIssueViewActions: jiraIssueViewActionsFromStore, convoStarterActionPrompt: convoStarterActionPrompt } = (0, $9aRNV.useConversationActionsStoreState)();
    const { getActions: getActions, prioritizeCustomActionResults: t1, numStartersToShow: t2 } = (0, $2ea50d39fb584b32$export$4a3b04775eb5de55)();
    const prioritizeCustomActionResults = t1 === undefined ? false : t1;
    const numStartersToShow = t2 === undefined ? 3 : t2;
    let t3;
    if ($[0] !== pageContextSupportedForDynamicStarters) {
        t3 = {
            enabled: pageContextSupportedForDynamicStarters
        };
        $[0] = pageContextSupportedForDynamicStarters;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== assistanceServiceParams || $[3] !== t3) {
        t4 = {
            dynamicStartersConfig: t3,
            assistanceServiceParams: assistanceServiceParams
        };
        $[2] = assistanceServiceParams;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { conversationStarterActions: conversationStarterActions, isDynamicStarterActionsLoading: isDynamicStarterActionsLoading, numDynamicStarterActionsLoading: numDynamicStarterActionsLoading } = (0, $csz0J.useRovoConversationStarters)(t4);
    let t5;
    if ($[5] !== numDynamicStarterActionsLoading) {
        t5 = Array(numDynamicStarterActionsLoading).fill(null).map($ca23910def64ea3b$var$_temp);
        $[5] = numDynamicStarterActionsLoading;
        $[6] = t5;
    } else t5 = $[6];
    const placeholderActions = t5;
    let t6;
    if ($[7] !== getActions) {
        t6 = async ()=>{
            if (!getActions) return [];
            const aiActions = await getActions() ?? [];
            return aiActions;
        };
        $[7] = getActions;
        $[8] = t6;
    } else t6 = $[8];
    const fetchActionsFromProvider = t6;
    let t7;
    if ($[9] !== conversationStarterActions || $[10] !== convoStarterActionPrompt || $[11] !== fetchActionsFromProvider || $[12] !== isDynamicStarterActionsLoading || $[13] !== jiraIssueViewActionsFromStore || $[14] !== numStartersToShow || $[15] !== pageContextSupportedForDynamicStarters || $[16] !== pageContextType || $[17] !== placeholderActions || $[18] !== prioritizeCustomActionResults) {
        t7 = async (t8)=>{
            const { isJiraIssueView: isJiraIssueView } = t8;
            const aiActionsFromProvider = isJiraIssueView && !prioritizeCustomActionResults ? jiraIssueViewActionsFromStore ?? [] : await fetchActionsFromProvider();
            const baseNumConvoStartersDisplayed = pageContextType === (0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST ? 4 : numStartersToShow;
            const matchedNudgeStarter = convoStarterActionPrompt ? conversationStarterActions.find((s)=>"staticPrompt" in s && s.staticPrompt === convoStarterActionPrompt) : undefined;
            const numConvoStartersDisplayed = matchedNudgeStarter ? Math.max(0, baseNumConvoStartersDisplayed - 1) : baseNumConvoStartersDisplayed;
            const updatedActions = pageContextSupportedForDynamicStarters && isDynamicStarterActionsLoading ? [
                ...placeholderActions
            ] : conversationStarterActions.filter((s_0)=>!("staticPrompt" in s_0) || s_0.staticPrompt !== convoStarterActionPrompt).slice(0, numConvoStartersDisplayed);
            updatedActions.unshift(...aiActionsFromProvider);
            if (prioritizeCustomActionResults) {
                const customActionsWithBackups = aiActionsFromProvider.concat(conversationStarterActions).slice(0, baseNumConvoStartersDisplayed);
                return customActionsWithBackups;
            }
            if (matchedNudgeStarter) updatedActions.unshift(matchedNudgeStarter);
            return updatedActions;
        };
        $[9] = conversationStarterActions;
        $[10] = convoStarterActionPrompt;
        $[11] = fetchActionsFromProvider;
        $[12] = isDynamicStarterActionsLoading;
        $[13] = jiraIssueViewActionsFromStore;
        $[14] = numStartersToShow;
        $[15] = pageContextSupportedForDynamicStarters;
        $[16] = pageContextType;
        $[17] = placeholderActions;
        $[18] = prioritizeCustomActionResults;
        $[19] = t7;
    } else t7 = $[19];
    const getActionsToStoreInState = t7;
    let t8;
    if ($[20] !== getActionsToStoreInState || $[21] !== pageContextType || $[22] !== setConversationActions) {
        t8 = ()=>{
            const initializeActions = async (t9)=>{
                const { isJiraIssueView: isJiraIssueView_0 } = t9;
                const baseActions = await getActionsToStoreInState({
                    isJiraIssueView: isJiraIssueView_0
                });
                setConversationActions(baseActions);
            };
            initializeActions({
                isJiraIssueView: pageContextType === (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW
            });
        };
        $[20] = getActionsToStoreInState;
        $[21] = pageContextType;
        $[22] = setConversationActions;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== getActions || $[25] !== getActionsToStoreInState || $[26] !== jiraIssueViewActionsFromStore || $[27] !== location || $[28] !== pageContextType || $[29] !== setConversationActions) {
        t9 = [
            pageContextType,
            location,
            getActions,
            getActionsToStoreInState,
            setConversationActions,
            jiraIssueViewActionsFromStore
        ];
        $[24] = getActions;
        $[25] = getActionsToStoreInState;
        $[26] = jiraIssueViewActionsFromStore;
        $[27] = location;
        $[28] = pageContextType;
        $[29] = setConversationActions;
        $[30] = t9;
    } else t9 = $[30];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[31] !== actionsFromStore || $[32] !== isDynamicStarterActionsLoading) {
        t10 = {
            actions: actionsFromStore,
            isDynamicStarterActionsLoading: isDynamicStarterActionsLoading
        };
        $[31] = actionsFromStore;
        $[32] = isDynamicStarterActionsLoading;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ pageContextType: pageContextType, location: location, assistanceServiceParams: assistanceServiceParams, pageContextSupportedForDynamicStarters: pageContextSupportedForDynamicStarters })=>{
    const { setConversationActions: setConversationActions } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { actions: actionsFromStore, jiraIssueViewActions: jiraIssueViewActionsFromStore, convoStarterActionPrompt: convoStarterActionPrompt } = (0, $9aRNV.useConversationActionsStoreState)();
    const { getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults = false, numStartersToShow: numStartersToShow = 3 } = (0, $2ea50d39fb584b32$export$4a3b04775eb5de55)();
    const { conversationStarterActions: conversationStarterActions, isDynamicStarterActionsLoading: isDynamicStarterActionsLoading, numDynamicStarterActionsLoading: numDynamicStarterActionsLoading } = (0, $csz0J.useRovoConversationStarters)({
        dynamicStartersConfig: {
            enabled: pageContextSupportedForDynamicStarters
        },
        assistanceServiceParams: assistanceServiceParams
    });
    const placeholderActions = (0, $cozmU.useMemo)(()=>{
        return Array(numDynamicStarterActionsLoading).fill(null).map((_, i)=>(0, $5704573f70fbdaf0$export$3a1fbd6869e5de1b)(i));
    }, [
        numDynamicStarterActionsLoading
    ]);
    const fetchActionsFromProvider = (0, $cozmU.useCallback)(async ()=>{
        if (!getActions) return [];
        const aiActions = await getActions() ?? [];
        return aiActions;
    }, [
        getActions
    ]);
    const getActionsToStoreInState = (0, $cozmU.useCallback)(async ({ isJiraIssueView: isJiraIssueView })=>{
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this logic.
     *
     * However, when prioritizeCustomActionResults is true, a caller has explicitly requested to replace
     * all actions (e.g. via setEmptyChatLaunch with replaceProviderActions=true). In that case we must
     * call fetchActionsFromProvider() so their custom actions flow through correctly, even on Jira Issue View.
     */ const aiActionsFromProvider = isJiraIssueView && !prioritizeCustomActionResults ? jiraIssueViewActionsFromStore ?? [] : await fetchActionsFromProvider();
        // Show all 4 starters for Bitbucket pull request page, 3 for all other pages
        const baseNumConvoStartersDisplayed = pageContextType === (0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST ? 4 : numStartersToShow;
        // Find the matching starter from the actions panel list by prompt
        const matchedNudgeStarter = convoStarterActionPrompt ? conversationStarterActions.find((s)=>'staticPrompt' in s && s.staticPrompt === convoStarterActionPrompt) : undefined;
        // When the nudge convo starter is pinned at position 0, reduce the dynamic starter
        // count by 1 so the total visible actions stays at the expected limit.
        const numConvoStartersDisplayed = matchedNudgeStarter ? Math.max(0, baseNumConvoStartersDisplayed - 1) : baseNumConvoStartersDisplayed;
        const updatedActions = pageContextSupportedForDynamicStarters && isDynamicStarterActionsLoading ? [
            ...placeholderActions
        ] : conversationStarterActions.filter((s_0)=>!('staticPrompt' in s_0) || s_0.staticPrompt !== convoStarterActionPrompt).slice(0, numConvoStartersDisplayed);
        updatedActions.unshift(...aiActionsFromProvider);
        if (prioritizeCustomActionResults) {
            /**
       * Display ONLY the actions fetched from the provider when prioritizeCustomActionResults is true.
       * This is to allow for custom implementations to fully control the actions displayed.
       *
       * HOWEVER, we still backfill with static starters if fewer than numConvoStartersDisplayed actions are provided by the custom implementation.
       */ const customActionsWithBackups = aiActionsFromProvider.concat(conversationStarterActions).slice(0, baseNumConvoStartersDisplayed);
            return customActionsWithBackups;
        }
        // Pin the matched nudge starter at position 0.
        if (matchedNudgeStarter) updatedActions.unshift(matchedNudgeStarter);
        return updatedActions;
    }, [
        isDynamicStarterActionsLoading,
        conversationStarterActions,
        fetchActionsFromProvider,
        placeholderActions,
        pageContextSupportedForDynamicStarters,
        jiraIssueViewActionsFromStore,
        prioritizeCustomActionResults,
        pageContextType,
        numStartersToShow,
        convoStarterActionPrompt
    ]);
    (0, $cozmU.useEffect)(()=>{
        const initializeActions = async ({ isJiraIssueView: isJiraIssueView_0 })=>{
            const baseActions = await getActionsToStoreInState({
                isJiraIssueView: isJiraIssueView_0
            });
            setConversationActions(baseActions);
        };
        initializeActions({
            isJiraIssueView: pageContextType === (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW
        });
    }, [
        pageContextType,
        location,
        getActions,
        getActionsToStoreInState,
        setConversationActions,
        jiraIssueViewActionsFromStore
    ]);
    return (0, $cozmU.useMemo)(()=>({
            actions: actionsFromStore,
            isDynamicStarterActionsLoading: isDynamicStarterActionsLoading
        }), [
        actionsFromStore,
        isDynamicStarterActionsLoading
    ]);
};
function $ca23910def64ea3b$var$_temp(_, i) {
    return (0, $5704573f70fbdaf0$export$3a1fbd6869e5de1b)(i);
}














const $279b2ee0c7573e36$var$ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_FEATURE_RECOMMENDATION';
const $279b2ee0c7573e36$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $279b2ee0c7573e36$export$65d2e8bcf91cdfe4 = async ({ triggerId: triggerId, siteId: siteId, featureView: featureView })=>{
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {
                        feature_view: featureView
                    },
                    trigger_type: $279b2ee0c7573e36$var$ROVO_BUTTON_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($279b2ee0c7573e36$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': 'confluence',
            'X-Experience-Id': 'proactive-ai-ranked-actions',
            user_id: triggerId,
            cloud_id: siteId,
            product: 'confluence'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching action rankings: ${response.statusText}`);
    const data = await response.json();
    const content = data?.ai_feature_output;
    if (!content) return undefined;
    return content;
};


const $a318c00bb791d89b$export$7257aaa01a48b961 = (triggerId, siteId, featureEnabled, featureView)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [rankings, setRankings] = (0, $cozmU.useState)(null);
    const timingRef = (0, $cozmU.useRef)(null);
    const makeRankedActionsRequest = (0, $cozmU.useCallback)(async ()=>{
        if (!featureEnabled) {
            setLoading(false);
            setRankings(null);
            return;
        }
        if (!featureView) {
            setError(new Error('No feature view provided'));
            setLoading(false);
            setRankings(null);
            return;
        }
        // Initialize timing tracking
        timingRef.current = {
            startTime: performance.now(),
            sent: false
        };
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'started',
            actionSubject: 'fetchRankedActions'
        });
        try {
            const suggestedRankedActionsResponse = await (0, $279b2ee0c7573e36$export$65d2e8bcf91cdfe4)({
                triggerId: triggerId,
                siteId: siteId,
                featureView: featureView
            });
            if (!suggestedRankedActionsResponse) {
                const error_1 = new Error('No ranked actions found');
                if (timingRef.current && !timingRef.current.sent) {
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'failed',
                        actionSubject: 'fetchRankedActions',
                        attributes: {
                            duration: performance.now() - timingRef.current.startTime,
                            errorMessage: error_1.message
                        }
                    });
                    timingRef.current.sent = true;
                }
                setError(error_1);
                setLoading(false);
                setRankings(null);
                return;
            }
            if (!suggestedRankedActionsResponse.triggers[0].recommendations[0].recommendation_details?.features) {
                const error_2 = new Error('No actions property found in response');
                if (timingRef.current && !timingRef.current.sent) {
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'failed',
                        actionSubject: 'fetchRankedActions',
                        attributes: {
                            duration: performance.now() - timingRef.current.startTime,
                            errorMessage: error_2.message
                        }
                    });
                    timingRef.current.sent = true;
                }
                setError(error_2);
                setLoading(false);
                setRankings(null);
                return;
            }
            const rankings_0 = suggestedRankedActionsResponse.triggers[0].recommendations[0].recommendation_details?.features;
            const rankedActionTypes = rankings_0.map((action)=>action.type);
            // Success tracking
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'succeeded',
                    actionSubject: 'fetchRankedActions',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        actionsReturned: rankedActionTypes.join(',')
                    }
                });
                timingRef.current.sent = true;
            }
            setRankings(rankedActionTypes);
            setLoading(false);
        } catch (err) {
            const error_0 = err instanceof Error ? err : new Error('Unknown error');
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'fetchRankedActions',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        errorMessage: error_0.message
                    }
                });
                timingRef.current.sent = true;
            }
            setError(error_0);
            setLoading(false);
        }
    }, [
        triggerId,
        siteId,
        featureView,
        featureEnabled,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'called',
            actionSubject: 'useFetchRankedActions',
            attributes: {
                isFeatureEnabled: featureEnabled,
                isPageContextTypeSupported: !!featureView
            }
        });
    }, [
        featureEnabled,
        featureView,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        makeRankedActionsRequest();
    }, [
        makeRankedActionsRequest
    ]);
    // Track cancellations when component unmounts during fetch
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'cancelled',
                    actionSubject: 'fetchRankedActions',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime
                    }
                });
                timingRef.current.sent = true;
            }
        };
    }, [
        sendAnalyticsEvent
    ]);
    // Recompute ranking order whenever rankings change
    const rankedActions = (0, $cozmU.useMemo)(()=>{
        if (rankings && rankings.length === 0) return null;
        return rankings;
    }, [
        rankings
    ]);
    return (0, $cozmU.useMemo)(()=>({
            rankedActions: rankedActions,
            isLoading: loading,
            error: error
        }), [
        rankedActions,
        loading,
        error
    ]);
};






















const $399557c223893111$var$styles = {
    headingStyles: "_0Of8r2gVvo _1wydGWgVvo _2Zuz6QNHnM _39xV02Hakr",
    headingTextStyles: "_2sNsIgd8bj _1UtDYzKGUX _0WKd3GDG5a _2l4i3rzUZr _1kk5Tk7GSX _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $399557c223893111$export$802a32a15e87011e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, handleBack: handleBack, handleBackHover: handleBackHover, handleBackLeave: handleBackLeave } = t0;
    let t1;
    if ($[0] !== handleBack || $[1] !== handleBackHover || $[2] !== handleBackLeave) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            label: "",
            onClick: handleBack,
            onMouseEnter: handleBackHover,
            onMouseLeave: handleBackLeave,
            appearance: "subtle"
        });
        $[0] = handleBack;
        $[1] = handleBackHover;
        $[2] = handleBackLeave;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $399557c223893111$var$styles.headingTextStyles
        }, heading);
        $[4] = heading;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $399557c223893111$var$styles.headingStyles
        }, t1, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ heading: heading, handleBack: handleBack, handleBackHover: handleBackHover, handleBackLeave: handleBackLeave })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $399557c223893111$var$styles.headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: "",
        onClick: handleBack,
        onMouseEnter: handleBackHover,
        onMouseLeave: handleBackLeave,
        appearance: "subtle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $399557c223893111$var$styles.headingTextStyles
    }, heading));
};




























var $jdw9n = parcelRequire("jdw9n");
























const $7d0e13f491b76f46$var$styles = {
    containerStyles: "_0bjKvDKxmn _0KLXru66of _39xV02N91d _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r2gVvo _1wydGWgVvo",
    buttonContentStyles: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT",
    iconBoxStyles: "_0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02Uofl _0jFU0VUofl _4ouGXIUofl _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    inlineItemStyles: "_2mHwu82ADO"
};
const $7d0e13f491b76f46$export$2468f54f9943e87f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { action: action, isShimmering: t1 } = t0;
    const isShimmering = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== action) {
        t2 = action ? (0, $2TzCj.isNestedAction)(action) : false;
        $[0] = action;
        $[1] = t2;
    } else t2 = $[1];
    const isNestedAction = t2;
    const t3 = isNestedAction ? "space-between" : undefined;
    const t4 = isNestedAction ? "fill" : undefined;
    let t5;
    if ($[2] !== isShimmering) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center",
            xcss: $7d0e13f491b76f46$var$styles.iconBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 20,
            height: 20,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: isShimmering
        }));
        $[2] = isShimmering;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== isShimmering) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $7d0e13f491b76f46$var$styles.inlineItemStyles,
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 280,
            height: 20,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: isShimmering
        }));
        $[4] = isShimmering;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t5 || $[7] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7d0e13f491b76f46$var$styles.buttonContentStyles
        }, t5, t6);
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== isNestedAction || $[10] !== isShimmering) {
        t8 = isNestedAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: isShimmering
        });
        $[9] = isNestedAction;
        $[10] = isShimmering;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t3 || $[13] !== t4 || $[14] !== t7 || $[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7d0e13f491b76f46$var$styles.containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: t3,
            grow: t4
        }, t7, t8));
        $[12] = t3;
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ action: action, isShimmering: isShimmering = true })=>{
    const isNestedAction = action ? (0, $2TzCj.isNestedAction)(action) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7d0e13f491b76f46$var$styles.containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: isNestedAction ? 'space-between' : undefined,
        grow: isNestedAction ? 'fill' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7d0e13f491b76f46$var$styles.buttonContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $7d0e13f491b76f46$var$styles.iconBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 20,
        height: 20,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: isShimmering
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $7d0e13f491b76f46$var$styles.inlineItemStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 280,
        height: 20,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: isShimmering
    }))), isNestedAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: isShimmering
    })));
};






const $044de991308cb482$export$e538c85242408c4d = (actionRankingOrder, actions)=>{
    const remainingActions = [
        ...actions
    ];
    const rerankedActions = actionRankingOrder.map((rankedActionType)=>{
        const actionIndex = remainingActions.findIndex((action)=>action.id === rankedActionType);
        if (actionIndex !== -1) {
            const [foundAction] = remainingActions.splice(actionIndex, 1);
            return foundAction;
        }
        return null;
    }).filter(Boolean);
    // Handle 'prompt-of-the-day' action placement when not already re-ranked
    const promptOfTheDayIndex = remainingActions.findIndex((action)=>action.id === (0, $6iWVH.PROMPT_OF_DAY_ACTION_ID));
    const convoStarterIndex = rerankedActions.findIndex((action)=>action.id === 'convo-starter');
    if (promptOfTheDayIndex !== -1) {
        const [promptOfTheDayAction] = remainingActions.splice(promptOfTheDayIndex, 1);
        if (convoStarterIndex !== -1) {
            // Replace 'convo-starter' with 'prompt-of-the-day' at the same position and push 'convo-starter' to bottom
            const [convoStarterAction] = rerankedActions.splice(convoStarterIndex, 1, promptOfTheDayAction);
            rerankedActions.push(convoStarterAction);
        } else // Just add 'prompt-of-the-day' to the bottom
        rerankedActions.push(promptOfTheDayAction);
    }
    return [
        ...rerankedActions,
        ...remainingActions
    ];
};


const $e1f582a080f1d624$var$styles = {
    actionContainerStyles: "_2Zuz6Q5zaO _1Znuxb5zaO _1wydGW1Y8M _0Of8r21Y8M _39xV02N91d"
};
const $e1f582a080f1d624$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    showMoreActionText: {
        id: "rovo-conversation-actions.actions.show-more-action-text",
        defaultMessage: "Show more"
    }
});
const $e1f582a080f1d624$var$ErrorFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
const $e1f582a080f1d624$export$e4419d590f2c1274 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { actions: actions, showMoreButton: showMoreButton, handleShowMore: handleShowMore, handleShowMoreHover: handleShowMoreHover, handleShowMoreLeave: handleShowMoreLeave, actionRankingOrder: actionRankingOrder, handleAction: handleAction, handleActionHover: handleActionHover, handleActionLeave: handleActionLeave, skillMetadataMap: skillMetadataMap, discoverPromptLibraryButton: discoverPromptLibraryButton } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { PostOfficePlacement: PostOfficePlacement } = (0, $jdw9n.usePostOfficePlacement)();
    let t1;
    bb0: {
        if (actionRankingOrder && actionRankingOrder.length > 0) {
            let t2;
            if ($[0] !== actionRankingOrder || $[1] !== actions || $[2] !== showMoreButton) {
                t2 = showMoreButton ? (0, $044de991308cb482$export$e538c85242408c4d)(actionRankingOrder, actions).slice(0, 4) : (0, $044de991308cb482$export$e538c85242408c4d)(actionRankingOrder, actions);
                $[0] = actionRankingOrder;
                $[1] = actions;
                $[2] = showMoreButton;
                $[3] = t2;
            } else t2 = $[3];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[4] !== actions || $[5] !== showMoreButton) {
            t2 = showMoreButton ? actions.slice(0, 4) : actions;
            $[4] = actions;
            $[5] = showMoreButton;
            $[6] = t2;
        } else t2 = $[6];
        t1 = t2;
    }
    const orderedActions = t1;
    let t2;
    if ($[7] !== discoverPromptLibraryButton || $[8] !== formatMessage || $[9] !== handleAction || $[10] !== handleActionHover || $[11] !== handleActionLeave || $[12] !== handleShowMore || $[13] !== handleShowMoreHover || $[14] !== handleShowMoreLeave || $[15] !== orderedActions || $[16] !== showMoreButton || $[17] !== skillMetadataMap) {
        t2 = orderedActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), {
            columns: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, orderedActions.map((action, index)=>{
            if ((0, $5704573f70fbdaf0$export$4419de7988ab3b2f)(action)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e13f491b76f46$export$2468f54f9943e87f), {
                key: action.id,
                action: action
            });
            const actionItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: `action-item-compact-view-${index}`,
                duration: "large"
            }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    ...props,
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                    key: action.id,
                    title: action.title,
                    icon: action.icon,
                    onClick: ()=>handleAction(action, index),
                    onMouseEnter: ()=>handleActionHover(action, index),
                    onMouseLeave: handleActionLeave,
                    ref: action.ref,
                    href: action.href,
                    action: action,
                    skillMetadataMap: skillMetadataMap,
                    badge: action.badge
                })));
            if (showMoreButton && index === orderedActions.length - 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                key: `compact-actions-with-show-more-${index}`
            }, actionItem, discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: "discover-prompt-library-button",
                duration: "large"
            }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    ...props_0,
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-spotlight-target": "rovo-chat-browse-prompt-gallery"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                    key: "discover-prompt-library",
                    title: discoverPromptLibraryButton.title,
                    icon: discoverPromptLibraryButton.icon,
                    onClick: discoverPromptLibraryButton.onClick,
                    badge: discoverPromptLibraryButton.badge
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: "show-more-button",
                duration: "large"
            }, (props_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    ...props_1,
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                    key: "show-more-ai-action",
                    title: formatMessage($e1f582a080f1d624$export$a7357cdd1f0b0168.showMoreActionText),
                    icon: $e1f582a080f1d624$var$_temp,
                    onClick: handleShowMore,
                    onMouseEnter: handleShowMoreHover,
                    onMouseLeave: handleShowMoreLeave
                }))));
            return actionItem;
        }), !showMoreButton && discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: "discover-prompt-library-button",
            duration: "large"
        }, (props_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props_2,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-spotlight-target": "rovo-chat-browse-prompt-gallery"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: "discover-prompt-library",
                title: discoverPromptLibraryButton.title,
                icon: discoverPromptLibraryButton.icon,
                onClick: discoverPromptLibraryButton.onClick,
                badge: discoverPromptLibraryButton.badge
            })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)));
        $[7] = discoverPromptLibraryButton;
        $[8] = formatMessage;
        $[9] = handleAction;
        $[10] = handleActionHover;
        $[11] = handleActionLeave;
        $[12] = handleShowMore;
        $[13] = handleShowMoreHover;
        $[14] = handleShowMoreLeave;
        $[15] = orderedActions;
        $[16] = showMoreButton;
        $[17] = skillMetadataMap;
        $[18] = t2;
    } else t2 = $[18];
    let t3;
    if ($[19] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            role: "list"
        }, t2);
        $[19] = t2;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== PostOfficePlacement || $[22] !== discoverPromptLibraryButton) {
        t4 = discoverPromptLibraryButton && PostOfficePlacement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
            placementId: "rovo-chat-browse-prompt-gallery",
            ErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e1f582a080f1d624$var$ErrorFallback, null)
        });
        $[21] = PostOfficePlacement;
        $[22] = discoverPromptLibraryButton;
        $[23] = t4;
    } else t4 = $[23];
    let t5;
    if ($[24] !== t3 || $[25] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e1f582a080f1d624$var$styles.actionContainerStyles
        }, t3, t4);
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
} : ({ actions: actions, showMoreButton: showMoreButton, handleShowMore: handleShowMore, handleShowMoreHover: handleShowMoreHover, handleShowMoreLeave: handleShowMoreLeave, actionRankingOrder: actionRankingOrder, handleAction: handleAction, handleActionHover: handleActionHover, handleActionLeave: handleActionLeave, skillMetadataMap: skillMetadataMap, discoverPromptLibraryButton: discoverPromptLibraryButton })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { PostOfficePlacement: PostOfficePlacement } = (0, $jdw9n.usePostOfficePlacement)();
    const MAX_VISIBLE_ACTIONS = 4;
    const orderedActions = (0, $cozmU.useMemo)(()=>{
        if (actionRankingOrder && actionRankingOrder.length > 0) return showMoreButton ? (0, $044de991308cb482$export$e538c85242408c4d)(actionRankingOrder, actions).slice(0, MAX_VISIBLE_ACTIONS) : (0, $044de991308cb482$export$e538c85242408c4d)(actionRankingOrder, actions);
         // If no valid ranking order, apply the same slicing logic based on showMoreButton
        return showMoreButton ? actions.slice(0, MAX_VISIBLE_ACTIONS) : actions;
    }, [
        actionRankingOrder,
        actions,
        showMoreButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e1f582a080f1d624$var$styles.actionContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        role: "list"
    }, orderedActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), {
        columns: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, orderedActions.map((action, index)=>{
        if ((0, $5704573f70fbdaf0$export$4419de7988ab3b2f)(action)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e13f491b76f46$export$2468f54f9943e87f), {
            key: action.id,
            action: action
        });
        const actionItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: `action-item-compact-view-${index}`,
            duration: "large"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: action.id,
                title: action.title,
                icon: action.icon,
                onClick: ()=>handleAction(action, index),
                onMouseEnter: ()=>handleActionHover(action, index),
                onMouseLeave: handleActionLeave,
                ref: action.ref,
                href: action.href,
                action: action,
                skillMetadataMap: skillMetadataMap,
                badge: action.badge
            })));
        if (showMoreButton && index === orderedActions.length - 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `compact-actions-with-show-more-${index}`
        }, actionItem, discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: "discover-prompt-library-button",
            duration: "large"
        }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props_0,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-spotlight-target": "rovo-chat-browse-prompt-gallery"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: "discover-prompt-library",
                title: discoverPromptLibraryButton.title,
                icon: discoverPromptLibraryButton.icon,
                onClick: discoverPromptLibraryButton.onClick,
                badge: discoverPromptLibraryButton.badge
            })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: `show-more-button`,
            duration: "large"
        }, (props_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props_1,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: 'show-more-ai-action',
                title: formatMessage($e1f582a080f1d624$export$a7357cdd1f0b0168.showMoreActionText),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: "",
                        color: "var(--ds-icon-subtlest, #6B6E76)"
                    }),
                onClick: handleShowMore,
                onMouseEnter: handleShowMoreHover,
                onMouseLeave: handleShowMoreLeave
            }))));
        return actionItem;
    }), !showMoreButton && discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        key: "discover-prompt-library-button",
        duration: "large"
    }, (props_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props_2,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-spotlight-target": "rovo-chat-browse-prompt-gallery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
            key: "discover-prompt-library",
            title: discoverPromptLibraryButton.title,
            icon: discoverPromptLibraryButton.icon,
            onClick: discoverPromptLibraryButton.onClick,
            badge: discoverPromptLibraryButton.badge
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)))), discoverPromptLibraryButton && PostOfficePlacement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
        placementId: "rovo-chat-browse-prompt-gallery",
        ErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e1f582a080f1d624$var$ErrorFallback, null)
    }));
};
function $e1f582a080f1d624$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
}

















const $938ebbe76e8886ff$var$styles = {
    actionContainerStyles: "_2Zuz6Q5zaO _1Znuxb5zaO _39xV02N91d"
};
const $938ebbe76e8886ff$export$e6766d1138e8f141 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { testId: testId, actionSize: t0 } = props;
    const actionSize = t0 === undefined ? 3 : t0;
    if (actionSize === 0) return null;
    let t1;
    if ($[0] !== actionSize) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, Array.from({
            length: actionSize
        }, $938ebbe76e8886ff$var$_temp));
        $[0] = actionSize;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $938ebbe76e8886ff$var$styles.actionContainerStyles,
            testId: testId
        }, t1);
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (props)=>{
    const { testId: testId, actionSize: actionSize = 3 } = props;
    if (actionSize === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $938ebbe76e8886ff$var$styles.actionContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, Array.from({
        length: actionSize
    }, (_, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e13f491b76f46$export$2468f54f9943e87f), {
            key: index
        });
    })));
};
function $938ebbe76e8886ff$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e13f491b76f46$export$2468f54f9943e87f), {
        key: index
    });
}


































const $e18d67317a5c527e$var$styles = {
    actionContainerStyles: "_2Zuz6Q5zaO _1Znuxb5zaO _1wydGW1Y8M _0Of8r21Y8M _39xV02N91d _3iDTPbQ4SZ",
    sideBarActionContainerStyles: "_0NUa3r0xhY",
    actionStackStyles: "_39xV02N91d",
    sideBarActionStackStyles: "_2WAcuGIZbP"
};
const $e18d67317a5c527e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    showLessActionText: {
        id: "rovo-conversation-actions.actions.show-less-action-text",
        defaultMessage: "Show less"
    }
});
const $e18d67317a5c527e$export$3e8918440d2dcc20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { actions: actions, showLessButton: showLessButton, handleShowLess: handleShowLess, handleShowLessHover: handleShowLessHover, handleShowLessLeave: handleShowLessLeave, isInSideBar: isInSideBar, actionRankingOrder: actionRankingOrder, handleAction: handleAction, handleActionHover: handleActionHover, handleActionLeave: handleActionLeave, skillMetadataMap: skillMetadataMap, discoverPromptLibraryButton: discoverPromptLibraryButton } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    bb0: {
        if (actionRankingOrder) {
            let t2;
            if ($[0] !== actionRankingOrder || $[1] !== actions) {
                t2 = (0, $044de991308cb482$export$e538c85242408c4d)(actionRankingOrder, actions);
                $[0] = actionRankingOrder;
                $[1] = actions;
                $[2] = t2;
            } else t2 = $[2];
            t1 = t2;
            break bb0;
        }
        t1 = actions;
    }
    const orderedActions = t1;
    const t2 = isInSideBar && $e18d67317a5c527e$var$styles.sideBarActionContainerStyles;
    let t3;
    if ($[3] !== t2) {
        t3 = (0, $w6R6I.cx)($e18d67317a5c527e$var$styles.actionContainerStyles, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = isInSideBar && $e18d67317a5c527e$var$styles.sideBarActionStackStyles;
    let t5;
    if ($[5] !== t4) {
        t5 = (0, $w6R6I.cx)($e18d67317a5c527e$var$styles.actionStackStyles, t4);
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== discoverPromptLibraryButton || $[8] !== formatMessage || $[9] !== handleAction || $[10] !== handleActionHover || $[11] !== handleActionLeave || $[12] !== handleShowLess || $[13] !== handleShowLessHover || $[14] !== handleShowLessLeave || $[15] !== orderedActions || $[16] !== showLessButton || $[17] !== skillMetadataMap) {
        t6 = orderedActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), {
            columns: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, orderedActions.map((action, index)=>{
            if ((0, $5704573f70fbdaf0$export$4419de7988ab3b2f)(action)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e13f491b76f46$export$2468f54f9943e87f), {
                key: action.id,
                action: action
            });
            const actionItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: `action-item-expanded-view-${index}`,
                duration: "medium"
            }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    ...props,
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                    key: action.id,
                    title: action.title,
                    icon: action.icon,
                    onClick: ()=>handleAction(action, index),
                    onMouseEnter: ()=>handleActionHover(action, index),
                    onMouseLeave: handleActionLeave,
                    ref: action.ref,
                    href: action.href,
                    action: action,
                    skillMetadataMap: skillMetadataMap,
                    badge: action.badge
                })));
            if (showLessButton && index === orderedActions.length - 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                key: `expanded-actions-with-show-less-${index}`
            }, actionItem, discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: "discover-prompt-library-button",
                duration: "large"
            }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    ...props_0,
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                    key: "discover-prompt-library",
                    title: discoverPromptLibraryButton.title,
                    icon: discoverPromptLibraryButton.icon,
                    onClick: discoverPromptLibraryButton.onClick,
                    badge: discoverPromptLibraryButton.badge
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: "show-less-button",
                duration: "large"
            }, (props_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    ...props_1,
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                    key: "show-less-ai-action",
                    title: formatMessage($e18d67317a5c527e$export$a7357cdd1f0b0168.showLessActionText),
                    icon: $e18d67317a5c527e$var$_temp,
                    onClick: handleShowLess,
                    onMouseEnter: handleShowLessHover,
                    onMouseLeave: handleShowLessLeave
                }))));
            return actionItem;
        }), !showLessButton && discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: "discover-prompt-library-button",
            duration: "large"
        }, (props_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props_2,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: "discover-prompt-library",
                title: discoverPromptLibraryButton.title,
                icon: discoverPromptLibraryButton.icon,
                onClick: discoverPromptLibraryButton.onClick,
                badge: discoverPromptLibraryButton.badge
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)));
        $[7] = discoverPromptLibraryButton;
        $[8] = formatMessage;
        $[9] = handleAction;
        $[10] = handleActionHover;
        $[11] = handleActionLeave;
        $[12] = handleShowLess;
        $[13] = handleShowLessHover;
        $[14] = handleShowLessLeave;
        $[15] = orderedActions;
        $[16] = showLessButton;
        $[17] = skillMetadataMap;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            role: "list",
            xcss: t5
        }, t6);
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== t3 || $[23] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t7);
        $[22] = t3;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ actions: actions, showLessButton: showLessButton, handleShowLess: handleShowLess, handleShowLessHover: handleShowLessHover, handleShowLessLeave: handleShowLessLeave, isInSideBar: isInSideBar, actionRankingOrder: actionRankingOrder, handleAction: handleAction, handleActionHover: handleActionHover, handleActionLeave: handleActionLeave, skillMetadataMap: skillMetadataMap, discoverPromptLibraryButton: discoverPromptLibraryButton })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const orderedActions = (0, $cozmU.useMemo)(()=>{
        if (actionRankingOrder) return (0, $044de991308cb482$export$e538c85242408c4d)(actionRankingOrder, actions);
        return actions;
    }, [
        actionRankingOrder,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e18d67317a5c527e$var$styles.actionContainerStyles, isInSideBar && $e18d67317a5c527e$var$styles.sideBarActionContainerStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        role: "list",
        xcss: (0, $w6R6I.cx)($e18d67317a5c527e$var$styles.actionStackStyles, isInSideBar && $e18d67317a5c527e$var$styles.sideBarActionStackStyles)
    }, orderedActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), {
        columns: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, orderedActions.map((action, index)=>{
        if ((0, $5704573f70fbdaf0$export$4419de7988ab3b2f)(action)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0e13f491b76f46$export$2468f54f9943e87f), {
            key: action.id,
            action: action
        });
        const actionItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: `action-item-expanded-view-${index}`,
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: action.id,
                title: action.title,
                icon: action.icon,
                onClick: ()=>handleAction(action, index),
                onMouseEnter: ()=>handleActionHover(action, index),
                onMouseLeave: handleActionLeave,
                ref: action.ref,
                href: action.href,
                action: action,
                skillMetadataMap: skillMetadataMap,
                badge: action.badge
            })));
        if (showLessButton && index === orderedActions.length - 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `expanded-actions-with-show-less-${index}`
        }, actionItem, discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: "discover-prompt-library-button",
            duration: "large"
        }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props_0,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: "discover-prompt-library",
                title: discoverPromptLibraryButton.title,
                icon: discoverPromptLibraryButton.icon,
                onClick: discoverPromptLibraryButton.onClick,
                badge: discoverPromptLibraryButton.badge
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: `show-less-button`,
            duration: "large"
        }, (props_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props_1,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
                key: 'show-less-ai-action',
                title: formatMessage($e18d67317a5c527e$export$a7357cdd1f0b0168.showLessActionText),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                        label: "",
                        color: "var(--ds-icon-subtlest, #6B6E76)"
                    }),
                onClick: handleShowLess,
                onMouseEnter: handleShowLessHover,
                onMouseLeave: handleShowLessLeave
            }))));
        return actionItem;
    }), !showLessButton && discoverPromptLibraryButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        key: "discover-prompt-library-button",
        duration: "large"
    }, (props_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props_2,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53d65580d6d66766$export$d4f9d1fefcbcface), {
            key: "discover-prompt-library",
            title: discoverPromptLibraryButton.title,
            icon: discoverPromptLibraryButton.icon,
            onClick: discoverPromptLibraryButton.onClick,
            badge: discoverPromptLibraryButton.badge
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)))));
};
function $e18d67317a5c527e$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
}


const $dcdc2a870487c71e$var$CONFLUENCE_FEATURE_SURFACE = 'CONFLUENCE_PAGE_VIEW';
const $dcdc2a870487c71e$var$styles = {
    conversationActionsContainerStyles: "_39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $dcdc2a870487c71e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    actionsSectionText: {
        id: "rovo-conversation-actions.actions.action-section-text",
        defaultMessage: "Actions"
    },
    discoverPromptLibraryButtonLabel: {
        id: "rovo-conversation-actions.actions.discover-prompt-library-button",
        defaultMessage: "Discover prompt library"
    }
});
function $dcdc2a870487c71e$var$RovoConversationActionsInner({ closeChat: closeChat, setChatInputPlaceholderOverride: setChatInputPlaceholderOverride, handleClickDynamicPrompt: handleClickDynamicPrompt, sendMessage: sendMessage, isInSideBar: isInSideBar, assistanceServiceParams: assistanceServiceParams, setActiveAction: setActiveAction, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, analyticsAttributes: analyticsAttributes, onNestedViewChange: onNestedViewChange }) {
    const [showExpandedView, setShowExpandedView] = (0, $cozmU.useState)(false);
    const [nestedHeading, setNestedHeading] = (0, $cozmU.useState)('');
    const [nestedParent, setNestedParent] = (0, $cozmU.useState)(null);
    const location = (0, $lFQjm.useWindowLocation)(true);
    const [triggerId] = (0, $cozmU.useState)(()=>crypto.randomUUID());
    const [safeToDisplayRankedActions, setSafeToDisplayRankedActions] = (0, $cozmU.useState)(false);
    const pageContextType = (0, $csz0J.usePageContextType)();
    const pageContextSupportedForDynamicStarters = (0, $5uiWK.isPageContextTypeSupportedForDynamicStarters)(pageContextType); // Get the current store state to use as initial value for actionsToRender
    // This prevents showing a skeleton flash when the component remounts (e.g., mode switch)
    const { buttonClickedTimestamp: buttonClickedTimestamp, actions: actionsFromStore } = (0, $9aRNV.useConversationActionsStoreState)();
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    const { actions: actions, isDynamicStarterActionsLoading: isDynamicStarterActionsLoading } = (0, $ca23910def64ea3b$export$9c53a6cb2cea6fed)({
        pageContextType: pageContextType,
        assistanceServiceParams: assistanceServiceParams,
        location: location,
        pageContextSupportedForDynamicStarters: pageContextSupportedForDynamicStarters
    }); // Initialize with store value to prevent flash of skeleton when component remounts
    const [actionsToRender, setActionsToRender] = (0, $cozmU.useState)(actionsFromStore);
    (0, $cozmU.useEffect)(()=>{
        if (nestedParent === null) setActionsToRender(actions);
    }, [
        actions,
        nestedParent
    ]);
    const pageContextSupportedForRankedActions = (0, $bbeffc38eecb4c2c$export$7deab7cde6bca734)(pageContextType);
    const enableRankedActions = pageContextSupportedForRankedActions ? (0, $cXtTj.default).checkGate('trex-282_ranked-actions-route-to-backend-api') : false;
    const { rankedActions: rankedActions, isLoading: isRankedActionsLoading } = (0, $a318c00bb791d89b$export$7257aaa01a48b961)(triggerId, assistanceServiceParams?.siteId ?? '', enableRankedActions, pageContextSupportedForRankedActions ? $dcdc2a870487c71e$var$CONFLUENCE_FEATURE_SURFACE : undefined);
    const hoverTimerRef = (0, $cozmU.useRef)(null); // Prevent analytics events from firing multiple times as actionsToRender changes (e.g., when dynamic starters load)
    const hasLoggedActionScreenAnalyticsRef = (0, $cozmU.useRef)(false);
    const hasLoggedActionScreenWithLoadedStartersAnalyticsRef = (0, $cozmU.useRef)(false);
    const hasLoggedExpandedScreenRef = (0, $cozmU.useRef)(false);
    const hasLoggedExpandedScreenWithLoadedStartersRef = (0, $cozmU.useRef)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contentAri = (0, $cozmU.useMemo)(()=>{
        return (0, $bQmvI.getContentAri)(assistanceServiceParams?.siteId ?? '', location, pageContextType);
    }, [
        assistanceServiceParams?.siteId,
        location,
        pageContextType
    ]);
    const pageContextAnalyticsAttributes = (0, $cozmU.useMemo)(()=>({
            pageContextType: String(pageContextType)
        }), [
        pageContextType
    ]);
    (0, $cozmU.useEffect)(()=>{
        // if ranked actions are still loading or dynamic convo starters are still loading, do not display ranked actions
        if (isRankedActionsLoading || isDynamicStarterActionsLoading || actionsToRender.length === 0) {
            setSafeToDisplayRankedActions(false);
            return;
        }
        setSafeToDisplayRankedActions(true);
    }, [
        isRankedActionsLoading,
        isDynamicStarterActionsLoading,
        actionsToRender.length
    ]);
    const shouldShowExpandCollapseButton = (0, $cozmU.useMemo)(()=>{
        return actionsToRender.length > 5;
    }, [
        actionsToRender.length
    ]);
    const hasPlaceholders = (0, $cozmU.useMemo)(()=>{
        return actionsToRender.some((0, $5704573f70fbdaf0$export$4419de7988ab3b2f));
    }, [
        actionsToRender
    ]);
    const visibleActions = (0, $cozmU.useMemo)(()=>{
        if (showExpandedView) return actionsToRender;
         // Compact view logic: show 4 if there's a "show more" button, otherwise 5
        return shouldShowExpandCollapseButton ? actionsToRender.slice(0, 4) : actionsToRender.slice(0, 5);
    }, [
        showExpandedView,
        actionsToRender,
        shouldShowExpandCollapseButton
    ]); // Reset analytics refs when pathname changes
    (0, $cozmU.useEffect)(()=>{
        hasLoggedActionScreenAnalyticsRef.current = false;
        hasLoggedActionScreenWithLoadedStartersAnalyticsRef.current = false;
        hasLoggedExpandedScreenRef.current = false;
        hasLoggedExpandedScreenWithLoadedStartersRef.current = false;
    }, [
        location
    ]); // Fire when base action view is shown
    (0, $cozmU.useEffect)(()=>{
        // don't fire if already logged or no actions are available yet
        if (hasLoggedActionScreenAnalyticsRef.current || actionsToRender.length === 0) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'aiMateActions',
            attributes: {
                ...analyticsAttributes,
                ...pageContextAnalyticsAttributes,
                actionTypesRendered: actionsToRender.map((action)=>action.handleType).join(','),
                numActions: actionsToRender.length,
                isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
                contentAri: contentAri
            }
        });
        hasLoggedActionScreenAnalyticsRef.current = true;
    }, [
        sendAnalyticsEvent,
        actionsToRender,
        isDynamicStarterActionsLoading,
        contentAri,
        analyticsAttributes,
        pageContextAnalyticsAttributes
    ]); // Fire when action screen is shown, and convo starters are loaded
    (0, $cozmU.useEffect)(()=>{
        if (hasLoggedActionScreenWithLoadedStartersAnalyticsRef.current || actionsToRender.length === 0 || isDynamicStarterActionsLoading) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'convoStartersLoaded',
            actionSubject: 'aiMateActions',
            attributes: {
                ...analyticsAttributes,
                ...pageContextAnalyticsAttributes,
                actionTypesRendered: actionsToRender.map((action_0)=>action_0.handleType).join(','),
                numActions: actionsToRender.length,
                numConvoStarters: {
                    total: actionsToRender.filter((action_1)=>action_1.type === 'convo-starter-action').length,
                    dynamic: actionsToRender.filter((action_2)=>action_2.type === 'convo-starter-action' && (0, $2TzCj.isChatAction)(action_2) && action_2.starterType === 'dynamic').length,
                    static: actionsToRender.filter((action_3)=>action_3.type === 'convo-starter-action' && (0, $2TzCj.isChatAction)(action_3) && action_3.starterType === 'static').length
                },
                contentAri: contentAri
            }
        });
        hasLoggedActionScreenWithLoadedStartersAnalyticsRef.current = true;
    }, [
        sendAnalyticsEvent,
        actionsToRender,
        isDynamicStarterActionsLoading,
        contentAri,
        analyticsAttributes,
        pageContextAnalyticsAttributes
    ]); // Fire when expanded view is shown
    (0, $cozmU.useEffect)(()=>{
        if (!showExpandedView) {
            hasLoggedExpandedScreenRef.current = false;
            return;
        } // don't fire if already logged, if no actions are available yet, or if in nested view
        if (hasLoggedExpandedScreenRef.current || actionsToRender.length === 0 || nestedHeading !== '') return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'aiMateActionsExpanded',
            attributes: {
                ...analyticsAttributes,
                ...pageContextAnalyticsAttributes,
                actionTypesRendered: actionsToRender.map((action_4)=>action_4.handleType).join(','),
                numActions: actionsToRender.length,
                isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
                contentAri: contentAri
            }
        });
        hasLoggedExpandedScreenRef.current = true;
    }, [
        sendAnalyticsEvent,
        showExpandedView,
        actionsToRender,
        isDynamicStarterActionsLoading,
        nestedHeading,
        contentAri,
        analyticsAttributes,
        pageContextAnalyticsAttributes
    ]); // Fire when expanded view is shown, and convo starters are loaded
    (0, $cozmU.useEffect)(()=>{
        if (!showExpandedView) {
            hasLoggedExpandedScreenWithLoadedStartersRef.current = false;
            return;
        } // don't fire if already logged, if no actions are available yet, if in nested view, or if convo starters are still loading
        if (hasLoggedExpandedScreenWithLoadedStartersRef.current || actionsToRender.length === 0 || nestedHeading !== '' || isDynamicStarterActionsLoading) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'convoStartersLoaded',
            actionSubject: 'aiMateActionsExpanded',
            attributes: {
                ...analyticsAttributes,
                ...pageContextAnalyticsAttributes,
                actionTypesRendered: actionsToRender.map((action_5)=>action_5.handleType).join(','),
                numActions: actionsToRender.length,
                numConvoStarters: {
                    total: actionsToRender.filter((action_6)=>action_6.type === 'convo-starter-action').length,
                    dynamic: actionsToRender.filter((action_7)=>action_7.type === 'convo-starter-action' && (0, $2TzCj.isChatAction)(action_7) && action_7.starterType === 'dynamic').length,
                    static: actionsToRender.filter((action_8)=>action_8.type === 'convo-starter-action' && (0, $2TzCj.isChatAction)(action_8) && action_8.starterType === 'static').length
                },
                contentAri: contentAri
            }
        });
        hasLoggedExpandedScreenWithLoadedStartersRef.current = true;
    }, [
        sendAnalyticsEvent,
        showExpandedView,
        actionsToRender,
        isDynamicStarterActionsLoading,
        nestedHeading,
        contentAri,
        analyticsAttributes,
        pageContextAnalyticsAttributes
    ]); //if we are in nested view (indicated by a non-empty nested heading), fire an analytics event
    (0, $cozmU.useEffect)(()=>{
        if (nestedHeading !== '') sendAnalyticsEvent({
            eventType: 'screen',
            name: 'aiMateActionsNested',
            attributes: {
                ...pageContextAnalyticsAttributes,
                actionTypesRendered: actionsToRender.map((action_9)=>action_9.handleType).join(','),
                numActions: actionsToRender.length,
                contentAri: contentAri
            }
        });
    }, [
        nestedHeading,
        actionsToRender,
        sendAnalyticsEvent,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Don't fire analytics while dynamic starters are still loading
        // to avoid capturing intermediate state with static starters
        if (pageContextSupportedForDynamicStarters && isDynamicStarterActionsLoading) return;
        const convoStarterVisibleActions = visibleActions.filter((action_10)=>action_10.type === 'convo-starter-action');
        const staticConvoStarterVisibleActions = convoStarterVisibleActions.filter((action_11)=>(0, $2TzCj.isChatAction)(action_11) && action_11.starterType === 'static');
        const dynamicConvoStarterVisibleActions = convoStarterVisibleActions.filter((action_12)=>(0, $2TzCj.isChatAction)(action_12) && action_12.starterType === 'dynamic');
        const convoStartersJtbd = (0, $0e03c87c9fa9183e$export$caa54e3423620b5f)(dynamicConvoStarterVisibleActions);
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'displayed',
            actionSubject: 'aiMateActions',
            attributes: {
                ...pageContextAnalyticsAttributes,
                numVisibleActions: visibleActions.length,
                areConvoStartersVisible: convoStarterVisibleActions.length > 0,
                areStaticConvoStartersVisible: staticConvoStarterVisibleActions.length > 0,
                areDynamicConvoStartersVisible: dynamicConvoStarterVisibleActions.length > 0,
                numVisibleConvoStarters: convoStarterVisibleActions.length,
                numVisibleStaticConvoStarters: staticConvoStarterVisibleActions.length,
                numVisibleDynamicConvoStarters: dynamicConvoStarterVisibleActions.length,
                isPageContextTypeSupportedForDynamicStarters: pageContextSupportedForDynamicStarters,
                convoStartersJtbd: convoStartersJtbd,
                hasPlaceholders: hasPlaceholders,
                contentAri: contentAri,
                timeToDisplayActions: buttonClickedTimestamp ? Date.now() - buttonClickedTimestamp : undefined
            }
        });
    }, [
        visibleActions,
        pageContextSupportedForDynamicStarters,
        hasPlaceholders,
        isDynamicStarterActionsLoading,
        sendAnalyticsEvent,
        contentAri,
        buttonClickedTimestamp,
        pageContextAnalyticsAttributes
    ]);
    const handleShowMore = (0, $cozmU.useCallback)(()=>{
        setShowExpandedView(true);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'emptyStateSuggestionsExpand',
            attributes: {
                ...pageContextAnalyticsAttributes,
                numActions: actionsToRender.length,
                isPageContextTypeSupportedForDynamicStarters: pageContextSupportedForDynamicStarters,
                hasPlaceholders: hasPlaceholders,
                contentAri: contentAri
            }
        });
    }, [
        sendAnalyticsEvent,
        actionsToRender.length,
        pageContextSupportedForDynamicStarters,
        hasPlaceholders,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    const handleShowMoreHover = (0, $cozmU.useCallback)(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            sendAnalyticsEvent({
                action: 'hovered',
                actionSubject: 'button',
                actionSubjectId: 'emptyStateSuggestionsExpand',
                attributes: {
                    ...pageContextAnalyticsAttributes,
                    numActions: actionsToRender.length,
                    isPageContextTypeSupportedForDynamicStarters: pageContextSupportedForDynamicStarters,
                    hasPlaceholders: hasPlaceholders,
                    contentAri: contentAri
                }
            });
        }, 1000);
    }, [
        sendAnalyticsEvent,
        actionsToRender.length,
        pageContextSupportedForDynamicStarters,
        hasPlaceholders,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    const handleShowMoreLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, [
        hoverTimerRef
    ]);
    const handleShowLess = (0, $cozmU.useCallback)(()=>{
        setShowExpandedView(false);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'emptyStateSuggestionsCollapse',
            attributes: {
                ...pageContextAnalyticsAttributes,
                numActions: actionsToRender.length,
                contentAri: contentAri
            }
        });
    }, [
        sendAnalyticsEvent,
        actionsToRender.length,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    const handleShowLessHover = (0, $cozmU.useCallback)(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            sendAnalyticsEvent({
                action: 'hovered',
                actionSubject: 'button',
                actionSubjectId: 'emptyStateSuggestionsCollapse',
                attributes: {
                    ...pageContextAnalyticsAttributes,
                    numActions: actionsToRender.length,
                    contentAri: contentAri
                }
            });
        }, 1000);
    }, [
        sendAnalyticsEvent,
        actionsToRender.length,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    const handleShowLessLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, [
        hoverTimerRef
    ]);
    const executeAction = (0, $cozmU.useCallback)((action_13)=>{
        //handle nested action
        if ((0, $2TzCj.isNestedAction)(action_13)) {
            setActionsToRender(action_13.children); //go to expanded view if not already there
            if (!showExpandedView) setShowExpandedView(true);
            setNestedHeading(action_13.actionHeading ?? action_13.title);
            setNestedParent(action_13);
            onNestedViewChange?.(true);
            return;
        } //handle chat action
        if ((0, $2TzCj.isChatAction)(action_13) || (0, $2TzCj.isSkillAction)(action_13)) {
            //if dynamic, handle with handler (only allowed for ChatActions or legacy adminhub skill actions)
            if ('dynamicPrompt' in action_13 && action_13.dynamicPrompt && ((0, $2TzCj.isChatAction)(action_13) || (0, $6iWVH.LEGACY_DYNAMIC_SKILL_IDS).has(action_13.id))) {
                if ((0, $iDrrr.fg)('rovo_static_prompt_onclick_enabled')) try {
                    handleClickDynamicPrompt?.(action_13);
                } finally{
                    action_13.onClick?.();
                }
                else handleClickDynamicPrompt?.(action_13);
                return;
            } //if static, send conversation starter to chat
            if (action_13.staticPrompt) {
                const agent = 'agent' in action_13 ? action_13.agent : undefined;
                if ((0, $iDrrr.fg)('rovo_static_prompt_onclick_enabled')) try {
                    sendMessage(action_13.staticPrompt, action_13.handleType, agent);
                } finally{
                    action_13.onClick?.();
                }
                else sendMessage(action_13.staticPrompt, action_13.handleType, agent);
                return;
            }
        } //handle basic action
        if ('children' in action_13 && action_13.children && action_13.children.length > 0) setActionsToRender(action_13.children);
        if (action_13.onClick) action_13.onClick();
        if ('closePanelOnSelection' in action_13 && action_13.closePanelOnSelection) {
            closeChat();
            setActiveAction(undefined);
            return;
        }
        if ('viewConfig' in action_13 && action_13.viewConfig) {
            //set active action in state store
            setActiveAction(action_13);
            return;
        }
    }, [
        sendMessage,
        setActiveAction,
        showExpandedView,
        closeChat,
        handleClickDynamicPrompt,
        onNestedViewChange
    ]); // Subscribe to select-action event to execute an action programmatically
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate-actions'
    }, (payload)=>{
        if (!(0, $cXtTj.default).checkGate('rovo_chat_select_action_subscriber')) return;
        if (payload.type === 'select-action' && actions.length > 0) {
            const action_14 = actions.find((a)=>a.id === payload.data.actionId);
            if (action_14) executeAction(action_14);
        }
    });
    const handleActionClick = (0, $cozmU.useCallback)((action_15, index)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'emptyStateSuggestions',
            attributes: {
                ...analyticsAttributes,
                ...pageContextAnalyticsAttributes,
                actionId: action_15.id,
                actionType: action_15.type,
                actionHandleType: action_15.handleType,
                isNested: action_15.isChild ?? false,
                rendered: action_15.type === 'ai-action' ? action_15.closePanelOnSelection ? 'in-product' : 'in-panel' : undefined,
                starterType: (0, $2TzCj.isChatAction)(action_15) ? action_15.starterType : undefined,
                jtbdCategory: (0, $2TzCj.isChatAction)(action_15) ? action_15.jtbdCategory : undefined,
                isPageContextTypeSupportedForDynamicStarters: pageContextSupportedForDynamicStarters,
                visibleActionIds: visibleActions.map((a_0)=>a_0.id).join(','),
                visibleActionTypes: visibleActions.map((a_1)=>a_1.type).join(','),
                visibleActionHandleTypes: visibleActions.map((a_2)=>a_2.handleType).join(','),
                hasPlaceholders: hasPlaceholders,
                contentAri: contentAri,
                displayOrder: index
            }
        });
        executeAction(action_15);
    }, [
        executeAction,
        sendAnalyticsEvent,
        pageContextSupportedForDynamicStarters,
        hasPlaceholders,
        contentAri,
        visibleActions,
        analyticsAttributes,
        pageContextAnalyticsAttributes
    ]);
    const handleActionHover = (0, $cozmU.useCallback)((action_16, index_0)=>{
        hoverTimerRef.current = setTimeout(()=>{
            sendAnalyticsEvent({
                action: 'hovered',
                actionSubject: 'button',
                actionSubjectId: 'emptyStateSuggestions',
                attributes: {
                    ...pageContextAnalyticsAttributes,
                    actionId: action_16.id,
                    actionType: action_16.type,
                    actionHandleType: action_16.handleType,
                    starterType: (0, $2TzCj.isChatAction)(action_16) ? action_16.starterType : undefined,
                    jtbdCategory: (0, $2TzCj.isChatAction)(action_16) ? action_16.jtbdCategory : undefined,
                    isNested: action_16.isChild ?? false,
                    contentAri: contentAri,
                    displayOrder: index_0
                }
            });
        }, 1000);
        if (!(0, $2TzCj.isChatAction)(action_16) && !(0, $2TzCj.isSkillAction)(action_16) || !setChatInputPlaceholderOverride) return;
        if ((0, $2TzCj.isSkillAction)(action_16) && action_16.staticPrompt) {
            setChatInputPlaceholderOverride((0, $f14fabf2782a2f4c$export$aea266c07c1b2cbb)(action_16.staticPrompt));
            return;
        }
        const placeholderText = 'dynamicPrompt' in action_16 ? action_16.dynamicPrompt : action_16.staticPrompt;
        if (placeholderText) setChatInputPlaceholderOverride((0, $f14fabf2782a2f4c$export$aea266c07c1b2cbb)(placeholderText));
    }, [
        sendAnalyticsEvent,
        setChatInputPlaceholderOverride,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    const handleActionLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
        setChatInputPlaceholderOverride?.('');
    }, [
        hoverTimerRef,
        setChatInputPlaceholderOverride
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        setShowExpandedView(false);
        setNestedHeading('');
        setActionsToRender(actions);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'emptyStateSuggestionsNestedBackButton',
            attributes: {
                ...pageContextAnalyticsAttributes,
                parent: nestedParent?.id,
                numActions: actionsToRender.length,
                contentAri: contentAri
            }
        });
        setNestedParent(null);
        onNestedViewChange?.(false);
    }, [
        setActionsToRender,
        actions,
        sendAnalyticsEvent,
        actionsToRender.length,
        nestedParent,
        contentAri,
        onNestedViewChange,
        pageContextAnalyticsAttributes
    ]);
    const handleBackHover = (0, $cozmU.useCallback)(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            sendAnalyticsEvent({
                action: 'hovered',
                actionSubject: 'button',
                actionSubjectId: 'emptyStateSuggestionsNestedBackButton',
                attributes: {
                    ...pageContextAnalyticsAttributes,
                    parent: nestedParent?.id,
                    numActions: actionsToRender.length,
                    contentAri: contentAri
                }
            });
        }, 1000);
    }, [
        sendAnalyticsEvent,
        nestedParent,
        actionsToRender.length,
        contentAri,
        pageContextAnalyticsAttributes
    ]);
    const handleBackLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, [
        hoverTimerRef
    ]);
    const handleDiscoverPromptLibraryClick = (0, $cozmU.useCallback)(()=>{
        onDiscoverPromptLibraryClick?.();
    }, [
        onDiscoverPromptLibraryClick
    ]);
    const isRenderStabilizationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const canRenderDiscoverPromptLibraryButton = isInSideBar && Boolean(onDiscoverPromptLibraryClick) && (0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false);
    const renderDiscoverPromptLibraryIcon = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1KLPb))), {
            label: ""
        }), []);
    const stabilizedDiscoverPromptLibraryButton = (0, $cozmU.useMemo)(()=>{
        if (!isRenderStabilizationEnabled || !canRenderDiscoverPromptLibraryButton) return undefined;
        return {
            title: formatMessage($dcdc2a870487c71e$export$a7357cdd1f0b0168.discoverPromptLibraryButtonLabel),
            icon: renderDiscoverPromptLibraryIcon,
            onClick: handleDiscoverPromptLibraryClick
        };
    }, [
        isRenderStabilizationEnabled,
        canRenderDiscoverPromptLibraryButton,
        formatMessage,
        renderDiscoverPromptLibraryIcon,
        handleDiscoverPromptLibraryClick
    ]);
    const legacyDiscoverPromptLibraryButton = !isRenderStabilizationEnabled && canRenderDiscoverPromptLibraryButton ? {
        title: formatMessage($dcdc2a870487c71e$export$a7357cdd1f0b0168.discoverPromptLibraryButtonLabel),
        icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1KLPb))), {
                label: ""
            }),
        onClick: handleDiscoverPromptLibraryClick
    } : undefined;
    const discoverPromptLibraryButton = isRenderStabilizationEnabled ? stabilizedDiscoverPromptLibraryButton : legacyDiscoverPromptLibraryButton;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "rovo-conversation-actions",
        xcss: $dcdc2a870487c71e$var$styles.conversationActionsContainerStyles
    }, enableRankedActions && !safeToDisplayRankedActions || !enableRankedActions && actionsToRender.length === 0 ? /*#__PURE__*/ $cozmU.createElement((0, $938ebbe76e8886ff$export$e6766d1138e8f141), {
        actionSize: 3
    }) : /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, nestedHeading !== '' && /*#__PURE__*/ $cozmU.createElement((0, $399557c223893111$export$802a32a15e87011e), {
        heading: nestedHeading,
        handleBack: handleBack,
        handleBackHover: handleBackHover,
        handleBackLeave: handleBackLeave
    }), showExpandedView ? /*#__PURE__*/ $cozmU.createElement((0, $e18d67317a5c527e$export$3e8918440d2dcc20), {
        isInSideBar: isInSideBar,
        actions: visibleActions,
        actionRankingOrder: enableRankedActions ? rankedActions : undefined,
        showLessButton: shouldShowExpandCollapseButton,
        handleShowLess: handleShowLess,
        handleShowLessHover: handleShowLessHover,
        handleShowLessLeave: handleShowLessLeave,
        handleAction: handleActionClick,
        handleActionHover: handleActionHover,
        handleActionLeave: handleActionLeave,
        skillMetadataMap: skillMetadata?.skillMetadataMap,
        discoverPromptLibraryButton: discoverPromptLibraryButton
    }) : /*#__PURE__*/ $cozmU.createElement((0, $e1f582a080f1d624$export$e4419d590f2c1274), {
        actions: enableRankedActions ? actionsToRender : visibleActions,
        showMoreButton: shouldShowExpandCollapseButton,
        handleShowMore: handleShowMore,
        handleShowMoreHover: handleShowMoreHover,
        handleShowMoreLeave: handleShowMoreLeave,
        handleAction: handleActionClick,
        actionRankingOrder: enableRankedActions ? rankedActions : undefined,
        handleActionHover: handleActionHover,
        handleActionLeave: handleActionLeave,
        skillMetadataMap: skillMetadata?.skillMetadataMap,
        discoverPromptLibraryButton: discoverPromptLibraryButton
    })));
}
const $dcdc2a870487c71e$var$RovoConversationActions = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoConversationActions(props) {
    const $ = (0, $bDgLe.c)(5);
    const t0 = props.assistanceServiceParams?.siteId ?? "";
    let t1;
    if ($[0] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($dcdc2a870487c71e$var$RovoConversationActionsInner, props);
        $[0] = props;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $7dHQW.SkillMetadataProvider), {
            siteId: t0
        }, t1);
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function RovoConversationActions(props) {
    return /*#__PURE__*/ $cozmU.createElement((0, $7dHQW.SkillMetadataProvider), {
        siteId: props.assistanceServiceParams?.siteId ?? ''
    }, /*#__PURE__*/ $cozmU.createElement($dcdc2a870487c71e$var$RovoConversationActionsInner, props));
};
var $dcdc2a870487c71e$export$2e2bcd8739ae039 = $dcdc2a870487c71e$var$RovoConversationActions;









const $599066d9ca0ac86c$var$RovoConversationActionsWithDi = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    (0, $6cFsl.di)((0, $dcdc2a870487c71e$export$2e2bcd8739ae039));
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcdc2a870487c71e$export$2e2bcd8739ae039), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    (0, $6cFsl.di)((0, $dcdc2a870487c71e$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcdc2a870487c71e$export$2e2bcd8739ae039), props);
};
const $599066d9ca0ac86c$var$MemoizedRovoConversationActions = /*#__PURE__*/ (0, $cozmU.memo)($599066d9ca0ac86c$var$RovoConversationActionsWithDi);
const $599066d9ca0ac86c$var$RovoConversationActionsSkillsConfigProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, skillRegistryTags: skillRegistryTags } = t0;
    let t1;
    if ($[0] !== skillRegistryTags) {
        t1 = {
            tags: {
                skillRegistryTags: skillRegistryTags
            }
        };
        $[0] = skillRegistryTags;
        $[1] = t1;
    } else t1 = $[1];
    const rovoSkillsConfig = (0, $9b053e82e6486083$export$40c152105e92ac90)(t1);
    let t2;
    if ($[2] !== children || $[3] !== rovoSkillsConfig) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Bxlw.RovoSkillsConfigProvider), {
            config: rovoSkillsConfig
        }, children);
        $[2] = children;
        $[3] = rovoSkillsConfig;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, skillRegistryTags: skillRegistryTags })=>{
    const rovoSkillsConfig = (0, $9b053e82e6486083$export$40c152105e92ac90)({
        tags: {
            skillRegistryTags: skillRegistryTags
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Bxlw.RovoSkillsConfigProvider), {
        config: rovoSkillsConfig
    }, children);
};
const $599066d9ca0ac86c$var$StabilizedConversationActions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { closeChat: closeChat, sendMessage: sendMessage, setChatInputPlaceholderOverride: setChatInputPlaceholderOverride, handleClickDynamicPrompt: handleClickDynamicPrompt, isInSideBar: isInSideBar, assistanceServiceParams: assistanceServiceParams, setActiveAction: setActiveAction, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, analyticsAttributes: analyticsAttributes, onNestedViewChange: onNestedViewChange, skillRegistryTags: skillRegistryTags } = t0;
    let t1;
    if ($[0] !== analyticsAttributes || $[1] !== assistanceServiceParams || $[2] !== closeChat || $[3] !== handleClickDynamicPrompt || $[4] !== isInSideBar || $[5] !== onDiscoverPromptLibraryClick || $[6] !== onNestedViewChange || $[7] !== sendMessage || $[8] !== setActiveAction || $[9] !== setChatInputPlaceholderOverride) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$MemoizedRovoConversationActions, {
            closeChat: closeChat,
            sendMessage: sendMessage,
            setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
            handleClickDynamicPrompt: handleClickDynamicPrompt,
            isInSideBar: isInSideBar,
            assistanceServiceParams: assistanceServiceParams,
            setActiveAction: setActiveAction,
            onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
            analyticsAttributes: analyticsAttributes,
            onNestedViewChange: onNestedViewChange
        });
        $[0] = analyticsAttributes;
        $[1] = assistanceServiceParams;
        $[2] = closeChat;
        $[3] = handleClickDynamicPrompt;
        $[4] = isInSideBar;
        $[5] = onDiscoverPromptLibraryClick;
        $[6] = onNestedViewChange;
        $[7] = sendMessage;
        $[8] = setActiveAction;
        $[9] = setChatInputPlaceholderOverride;
        $[10] = t1;
    } else t1 = $[10];
    const conversationActions = t1;
    if (skillRegistryTags) {
        let t2;
        if ($[11] !== conversationActions || $[12] !== skillRegistryTags) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$RovoConversationActionsSkillsConfigProvider, {
                skillRegistryTags: skillRegistryTags
            }, conversationActions);
            $[11] = conversationActions;
            $[12] = skillRegistryTags;
            $[13] = t2;
        } else t2 = $[13];
        return t2;
    }
    return conversationActions;
} : ({ closeChat: closeChat, sendMessage: sendMessage, setChatInputPlaceholderOverride: setChatInputPlaceholderOverride, handleClickDynamicPrompt: handleClickDynamicPrompt, isInSideBar: isInSideBar, assistanceServiceParams: assistanceServiceParams, setActiveAction: setActiveAction, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, analyticsAttributes: analyticsAttributes, onNestedViewChange: onNestedViewChange, skillRegistryTags: skillRegistryTags })=>{
    const conversationActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$MemoizedRovoConversationActions, {
        closeChat: closeChat,
        sendMessage: sendMessage,
        setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
        handleClickDynamicPrompt: handleClickDynamicPrompt,
        isInSideBar: isInSideBar,
        assistanceServiceParams: assistanceServiceParams,
        setActiveAction: setActiveAction,
        onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
        analyticsAttributes: analyticsAttributes,
        onNestedViewChange: onNestedViewChange
    });
    if (skillRegistryTags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$RovoConversationActionsSkillsConfigProvider, {
        skillRegistryTags: skillRegistryTags
    }, conversationActions);
    return conversationActions;
};
const $599066d9ca0ac86c$export$e9cbe40006ce4ca7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { closeChat: closeChat, sendMessage: sendMessage, setChatInputPlaceholderOverride: setChatInputPlaceholderOverride, handleClickDynamicPrompt: handleClickDynamicPrompt, mode: mode, assistanceServiceParams: assistanceServiceParams, setActiveAction: setActiveAction, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, analyticsAttributes: analyticsAttributes, onNestedViewChange: onNestedViewChange, skillRegistryTags: skillRegistryTags, isRenderStabilizationEnabled: isRenderStabilizationEnabled } = t0;
    (0, $6cFsl.di)((0, $dcdc2a870487c71e$export$2e2bcd8739ae039));
    if (isRenderStabilizationEnabled) {
        const t1 = mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR;
        let t2;
        if ($[0] !== analyticsAttributes || $[1] !== assistanceServiceParams || $[2] !== closeChat || $[3] !== handleClickDynamicPrompt || $[4] !== onDiscoverPromptLibraryClick || $[5] !== onNestedViewChange || $[6] !== sendMessage || $[7] !== setActiveAction || $[8] !== setChatInputPlaceholderOverride || $[9] !== skillRegistryTags || $[10] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$StabilizedConversationActions, {
                closeChat: closeChat,
                sendMessage: sendMessage,
                setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
                handleClickDynamicPrompt: handleClickDynamicPrompt,
                isInSideBar: t1,
                assistanceServiceParams: assistanceServiceParams,
                setActiveAction: setActiveAction,
                onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
                analyticsAttributes: analyticsAttributes,
                onNestedViewChange: onNestedViewChange,
                skillRegistryTags: skillRegistryTags
            });
            $[0] = analyticsAttributes;
            $[1] = assistanceServiceParams;
            $[2] = closeChat;
            $[3] = handleClickDynamicPrompt;
            $[4] = onDiscoverPromptLibraryClick;
            $[5] = onNestedViewChange;
            $[6] = sendMessage;
            $[7] = setActiveAction;
            $[8] = setChatInputPlaceholderOverride;
            $[9] = skillRegistryTags;
            $[10] = t1;
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    const t1 = mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR;
    let t2;
    if ($[12] !== analyticsAttributes || $[13] !== assistanceServiceParams || $[14] !== closeChat || $[15] !== handleClickDynamicPrompt || $[16] !== onDiscoverPromptLibraryClick || $[17] !== onNestedViewChange || $[18] !== sendMessage || $[19] !== setActiveAction || $[20] !== setChatInputPlaceholderOverride || $[21] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcdc2a870487c71e$export$2e2bcd8739ae039), {
            closeChat: closeChat,
            sendMessage: sendMessage,
            setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
            handleClickDynamicPrompt: handleClickDynamicPrompt,
            isInSideBar: t1,
            assistanceServiceParams: assistanceServiceParams,
            setActiveAction: setActiveAction,
            onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
            analyticsAttributes: analyticsAttributes,
            onNestedViewChange: onNestedViewChange
        });
        $[12] = analyticsAttributes;
        $[13] = assistanceServiceParams;
        $[14] = closeChat;
        $[15] = handleClickDynamicPrompt;
        $[16] = onDiscoverPromptLibraryClick;
        $[17] = onNestedViewChange;
        $[18] = sendMessage;
        $[19] = setActiveAction;
        $[20] = setChatInputPlaceholderOverride;
        $[21] = t1;
        $[22] = t2;
    } else t2 = $[22];
    const legacyConversationActionsElement = t2;
    if (skillRegistryTags) {
        let t3;
        if ($[23] !== legacyConversationActionsElement || $[24] !== skillRegistryTags) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$RovoConversationActionsSkillsConfigProvider, {
                skillRegistryTags: skillRegistryTags
            }, legacyConversationActionsElement);
            $[23] = legacyConversationActionsElement;
            $[24] = skillRegistryTags;
            $[25] = t3;
        } else t3 = $[25];
        return t3;
    }
    return legacyConversationActionsElement;
} : ({ closeChat: closeChat, sendMessage: sendMessage, setChatInputPlaceholderOverride: setChatInputPlaceholderOverride, handleClickDynamicPrompt: handleClickDynamicPrompt, mode: mode, assistanceServiceParams: assistanceServiceParams, setActiveAction: setActiveAction, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, analyticsAttributes: analyticsAttributes, onNestedViewChange: onNestedViewChange, skillRegistryTags: skillRegistryTags, isRenderStabilizationEnabled: isRenderStabilizationEnabled })=>{
    (0, $6cFsl.di)((0, $dcdc2a870487c71e$export$2e2bcd8739ae039));
    if (isRenderStabilizationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$StabilizedConversationActions, {
        closeChat: closeChat,
        sendMessage: sendMessage,
        setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
        handleClickDynamicPrompt: handleClickDynamicPrompt,
        isInSideBar: mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        assistanceServiceParams: assistanceServiceParams,
        setActiveAction: setActiveAction,
        onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
        analyticsAttributes: analyticsAttributes,
        onNestedViewChange: onNestedViewChange,
        skillRegistryTags: skillRegistryTags
    });
    const legacyConversationActionsElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcdc2a870487c71e$export$2e2bcd8739ae039), {
        closeChat: closeChat,
        sendMessage: sendMessage,
        setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
        handleClickDynamicPrompt: handleClickDynamicPrompt,
        isInSideBar: mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        assistanceServiceParams: assistanceServiceParams,
        setActiveAction: setActiveAction,
        onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
        analyticsAttributes: analyticsAttributes,
        onNestedViewChange: onNestedViewChange
    });
    if (skillRegistryTags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($599066d9ca0ac86c$var$RovoConversationActionsSkillsConfigProvider, {
        skillRegistryTags: skillRegistryTags
    }, legacyConversationActionsElement);
    return legacyConversationActionsElement;
};

























var $2f3b725d29647863$exports = {};
$2f3b725d29647863$exports = new URL("collaborative.52ff03fe.svg", import.meta.url).toString();


var $e3139509522b4502$exports = {};
$e3139509522b4502$exports = new URL("creative.5b56e7a5.svg", import.meta.url).toString();


var $081a3731a71a5e87$exports = {};
$081a3731a71a5e87$exports = new URL("empathetic.17b31de7.svg", import.meta.url).toString();


var $e86dc58a55e5bf9e$exports = {};
$e86dc58a55e5bf9e$exports = new URL("professional.d5f93c71.svg", import.meta.url).toString();


const $60e61da3c49ac2f2$export$6e3425ffb0124fe6 = {
    rovo_default: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2f3b725d29647863$exports)))
    },
    professional: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e86dc58a55e5bf9e$exports)))
    },
    creative: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e3139509522b4502$exports)))
    },
    empathetic: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($081a3731a71a5e87$exports)))
    }
};


/**
 * In-session greeting rotation. For each (mode, tone) key it holds a shuffled
 * order and a cursor; each request returns the next index and advances, and
 * reshuffles (avoiding an immediate repeat) when the set is exhausted.
 */ const $72e93bae4d1990b7$var$rotationState = new Map();
/** Fisher-Yates shuffle over `[0, length)`, using the supplied RNG. */ const $72e93bae4d1990b7$var$shuffledRange = (length, rng)=>{
    const order = Array.from({
        length: length
    }, (_, i)=>i);
    for(let i = order.length - 1; i > 0; i--){
        const j = Math.floor(rng() * (i + 1));
        [order[i], order[j]] = [
            order[j],
            order[i]
        ];
    }
    return order;
};
/**
 * Returns the next index to show for `key` within a set of `length` items, and
 * advances the rotation. Returns -1 for an empty set.
 */ const $72e93bae4d1990b7$var$next = (key, length, rng = Math.random)=>{
    if (length <= 0) return -1;
    if (length === 1) return 0;
    let entry = $72e93bae4d1990b7$var$rotationState.get(key);
    if (!entry || entry.cursor >= entry.order.length) {
        const order = $72e93bae4d1990b7$var$shuffledRange(length, rng);
        // Avoid showing the same greeting twice in a row across a reshuffle.
        if (entry && order[0] === entry.last) {
            const swapWith = 1 + Math.floor(rng() * (order.length - 1));
            [order[0], order[swapWith]] = [
                order[swapWith],
                order[0]
            ];
        }
        entry = {
            order: order,
            cursor: 0,
            last: entry?.last ?? -1
        };
    }
    const index = entry.order[entry.cursor];
    $72e93bae4d1990b7$var$rotationState.set(key, {
        order: entry.order,
        cursor: entry.cursor + 1,
        last: index
    });
    return index;
};
/** Test-only: clear all rotation state so cases start from a known point. */ const $72e93bae4d1990b7$var$reset = ()=>{
    $72e93bae4d1990b7$var$rotationState.clear();
};
const $72e93bae4d1990b7$export$e75539638363a335 = {
    next: $72e93bae4d1990b7$var$next,
    reset: $72e93bae4d1990b7$var$reset
};





const $121a96964d0675dc$var$uniquePersonalityGreetingMessages = (0, $kSwu1.defineMessages)({
    collaborativeNormal1: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal1",
        defaultMessage: "Let's get to work, {name}"
    },
    collaborativeNormal2: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal2",
        defaultMessage: "What's your top priority, {name}?"
    },
    collaborativeNormal3: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal3",
        defaultMessage: "What should we unblock today?"
    },
    collaborativeNormal4: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal4",
        defaultMessage: "Where should we focus first, {name}?"
    },
    collaborativeNormal5: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal5",
        defaultMessage: "What's top of mind, {name}?"
    },
    collaborativeNormal6: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal6",
        defaultMessage: "Let's get things organized"
    },
    collaborativeNormal7: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal7",
        defaultMessage: "How can I help, {name}?"
    },
    collaborativeNormal8: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal8",
        defaultMessage: "Let's dive into your work together, {name}"
    },
    collaborativeNormal9: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal9",
        defaultMessage: "Let's tackle your tasks together, {name}"
    },
    collaborativeNormal10: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal10",
        defaultMessage: "What needs organizing, {name}?"
    },
    collaborativeNormal11: {
        id: "rovo-personalization.personality-greeting.collaborativeNormal11",
        defaultMessage: "Let's find what matters most, {name}"
    },
    collaborativeThinkDeeper1: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper1",
        defaultMessage: "Let's put your work into context"
    },
    collaborativeThinkDeeper2: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper2",
        defaultMessage: "Let's plan things out, {name}"
    },
    collaborativeThinkDeeper6: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper6",
        defaultMessage: "What should we unpack together?"
    },
    collaborativeThinkDeeper7: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper7",
        defaultMessage: "What needs a deeper look today?"
    },
    collaborativeThinkDeeper8: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper8",
        defaultMessage: "Let's connect all the dots, {name}"
    },
    collaborativeThinkDeeper9: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper9",
        defaultMessage: "What should we investigate first?"
    },
    collaborativeThinkDeeper10: {
        id: "rovo-personalization.personality-greeting.collaborativeThinkDeeper10",
        defaultMessage: "Let's reason through things together, {name}"
    },
    collaborativeTask1: {
        id: "rovo-personalization.personality-greeting.collaborativeTask1",
        defaultMessage: "Let's build a plan together, {name}"
    },
    collaborativeTask2: {
        id: "rovo-personalization.personality-greeting.collaborativeTask2",
        defaultMessage: "What should we create today?"
    },
    collaborativeTask3: {
        id: "rovo-personalization.personality-greeting.collaborativeTask3",
        defaultMessage: "Let's map things out step by step"
    },
    collaborativeTask4: {
        id: "rovo-personalization.personality-greeting.collaborativeTask4",
        defaultMessage: "Let's come up with a plan"
    },
    collaborativeTask5: {
        id: "rovo-personalization.personality-greeting.collaborativeTask5",
        defaultMessage: "Let's develop some ideas together, {name}"
    },
    collaborativeTask6: {
        id: "rovo-personalization.personality-greeting.collaborativeTask6",
        defaultMessage: "Ready to turn your ideas into action?"
    },
    collaborativeTask7: {
        id: "rovo-personalization.personality-greeting.collaborativeTask7",
        defaultMessage: "Let's organize a path forward"
    },
    professionalNormal1: {
        id: "rovo-personalization.personality-greeting.professionalNormal1",
        defaultMessage: "Ready to get to work, {name}?"
    },
    professionalNormal2: {
        id: "rovo-personalization.personality-greeting.professionalNormal2",
        defaultMessage: "What are we working on today?"
    },
    professionalNormal3: {
        id: "rovo-personalization.personality-greeting.professionalNormal3",
        defaultMessage: "Let's get the team aligned, {name}"
    },
    professionalNormal4: {
        id: "rovo-personalization.personality-greeting.professionalNormal4",
        defaultMessage: "What's on your to-do list, {name}?"
    },
    professionalNormal5: {
        id: "rovo-personalization.personality-greeting.professionalNormal5",
        defaultMessage: "What should we work through first?"
    },
    professionalNormal6: {
        id: "rovo-personalization.personality-greeting.professionalNormal6",
        defaultMessage: "What are we focusing on today, {name}?"
    },
    professionalThinkDeeper1: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper1",
        defaultMessage: "What should we analyze first?"
    },
    professionalThinkDeeper2: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper2",
        defaultMessage: "Ready for a deeper assessment, {name}?"
    },
    professionalThinkDeeper3: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper3",
        defaultMessage: "What needs deeper analysis, {name}?"
    },
    professionalThinkDeeper4: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper4",
        defaultMessage: "Ready to investigate deeper?"
    },
    professionalThinkDeeper5: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper5",
        defaultMessage: "What needs a deeper review?"
    },
    professionalThinkDeeper6: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper6",
        defaultMessage: "Let's think through things systematically"
    },
    professionalThinkDeeper7: {
        id: "rovo-personalization.personality-greeting.professionalThinkDeeper7",
        defaultMessage: "Which details should we work through, {name}?"
    },
    professionalTask1: {
        id: "rovo-personalization.personality-greeting.professionalTask1",
        defaultMessage: "What should we plan out, {name}?"
    },
    professionalTask2: {
        id: "rovo-personalization.personality-greeting.professionalTask2",
        defaultMessage: "Let's work through things together, {name}"
    },
    professionalTask3: {
        id: "rovo-personalization.personality-greeting.professionalTask3",
        defaultMessage: "Let's build out a plan"
    },
    professionalTask4: {
        id: "rovo-personalization.personality-greeting.professionalTask4",
        defaultMessage: "Let's break something complex down"
    },
    professionalTask5: {
        id: "rovo-personalization.personality-greeting.professionalTask5",
        defaultMessage: "What requirements should we capture?"
    },
    professionalTask7: {
        id: "rovo-personalization.personality-greeting.professionalTask7",
        defaultMessage: "Let's create a path forward, {name}"
    },
    professionalTask8: {
        id: "rovo-personalization.personality-greeting.professionalTask8",
        defaultMessage: "Ready to create a clear plan?"
    },
    creativeNormal1: {
        id: "rovo-personalization.personality-greeting.creativeNormal1",
        defaultMessage: "Let's explore some new ideas"
    },
    creativeNormal2: {
        id: "rovo-personalization.personality-greeting.creativeNormal2",
        defaultMessage: "What should we rethink today, {name}?"
    },
    creativeNormal3: {
        id: "rovo-personalization.personality-greeting.creativeNormal3",
        defaultMessage: "What do you want to tackle first?"
    },
    creativeNormal4: {
        id: "rovo-personalization.personality-greeting.creativeNormal4",
        defaultMessage: "Ready to plan things out?"
    },
    creativeNormal5: {
        id: "rovo-personalization.personality-greeting.creativeNormal5",
        defaultMessage: "What ideas should we flesh out, {name}?"
    },
    creativeNormal6: {
        id: "rovo-personalization.personality-greeting.creativeNormal6",
        defaultMessage: "What possibilities should we explore, {name}?"
    },
    creativeNormal7: {
        id: "rovo-personalization.personality-greeting.creativeNormal7",
        defaultMessage: "Let's spark some new ideas together, {name}"
    },
    creativeNormal8: {
        id: "rovo-personalization.personality-greeting.creativeNormal8",
        defaultMessage: "Let's explore your next move"
    },
    creativeNormal9: {
        id: "rovo-personalization.personality-greeting.creativeNormal9",
        defaultMessage: "Let's create something spectacular, {name}"
    },
    creativeThinkDeeper1: {
        id: "rovo-personalization.personality-greeting.creativeThinkDeeper1",
        defaultMessage: "What should we explore deeper, {name}?"
    },
    creativeThinkDeeper2: {
        id: "rovo-personalization.personality-greeting.creativeThinkDeeper2",
        defaultMessage: "What assumptions could we reframe?"
    },
    creativeThinkDeeper3: {
        id: "rovo-personalization.personality-greeting.creativeThinkDeeper3",
        defaultMessage: "Let's uncover some new angles, {name}"
    },
    creativeThinkDeeper5: {
        id: "rovo-personalization.personality-greeting.creativeThinkDeeper5",
        defaultMessage: "Let's think through things together, {name}"
    },
    creativeThinkDeeper6: {
        id: "rovo-personalization.personality-greeting.creativeThinkDeeper6",
        defaultMessage: "Which ideas should we push further?"
    },
    creativeTask1: {
        id: "rovo-personalization.personality-greeting.creativeTask1",
        defaultMessage: "What should we work through, {name}?"
    },
    creativeTask2: {
        id: "rovo-personalization.personality-greeting.creativeTask2",
        defaultMessage: "What are we creating today, {name}?"
    },
    creativeTask3: {
        id: "rovo-personalization.personality-greeting.creativeTask3",
        defaultMessage: "What idea should we develop today?"
    },
    creativeTask4: {
        id: "rovo-personalization.personality-greeting.creativeTask4",
        defaultMessage: "Let's stub out a plan, {name}"
    },
    creativeTask5: {
        id: "rovo-personalization.personality-greeting.creativeTask5",
        defaultMessage: "Ready to make your ideas concrete, {name}?"
    },
    creativeTask6: {
        id: "rovo-personalization.personality-greeting.creativeTask6",
        defaultMessage: "Let's build something amazing, {name}"
    },
    empatheticNormal1: {
        id: "rovo-personalization.personality-greeting.empatheticNormal1",
        defaultMessage: "What feels most pressing today?"
    },
    empatheticNormal2: {
        id: "rovo-personalization.personality-greeting.empatheticNormal2",
        defaultMessage: "Let's tackle something step-by-step"
    },
    empatheticNormal3: {
        id: "rovo-personalization.personality-greeting.empatheticNormal3",
        defaultMessage: "Where should we start today, {name}?"
    },
    empatheticNormal4: {
        id: "rovo-personalization.personality-greeting.empatheticNormal4",
        defaultMessage: "What's top of mind today?"
    },
    empatheticNormal6: {
        id: "rovo-personalization.personality-greeting.empatheticNormal6",
        defaultMessage: "Let's take something off your plate"
    },
    empatheticNormal7: {
        id: "rovo-personalization.personality-greeting.empatheticNormal7",
        defaultMessage: "Let's get you unblocked, {name}"
    },
    empatheticThinkDeeper1: {
        id: "rovo-personalization.personality-greeting.empatheticThinkDeeper1",
        defaultMessage: "Let's look at the full picture, {name}"
    },
    empatheticThinkDeeper2: {
        id: "rovo-personalization.personality-greeting.empatheticThinkDeeper2",
        defaultMessage: "What should we think through first, {name}?"
    },
    empatheticThinkDeeper3: {
        id: "rovo-personalization.personality-greeting.empatheticThinkDeeper3",
        defaultMessage: "Let's think through something complex together"
    },
    empatheticThinkDeeper4: {
        id: "rovo-personalization.personality-greeting.empatheticThinkDeeper4",
        defaultMessage: "Which concern should we examine first?"
    },
    empatheticThinkDeeper5: {
        id: "rovo-personalization.personality-greeting.empatheticThinkDeeper5",
        defaultMessage: "Let's look closer at things together, {name}"
    },
    empatheticThinkDeeper6: {
        id: "rovo-personalization.personality-greeting.empatheticThinkDeeper6",
        defaultMessage: "What should we untangle together?"
    },
    empatheticTask1: {
        id: "rovo-personalization.personality-greeting.empatheticTask1",
        defaultMessage: "Let's find a path forward, {name}"
    },
    empatheticTask2: {
        id: "rovo-personalization.personality-greeting.empatheticTask2",
        defaultMessage: "Let's take things step by step, {name}"
    },
    empatheticTask3: {
        id: "rovo-personalization.personality-greeting.empatheticTask3",
        defaultMessage: "Let's turn your ideas into a plan, {name}"
    },
    empatheticTask4: {
        id: "rovo-personalization.personality-greeting.empatheticTask4",
        defaultMessage: "Let's break things into smaller steps, {name}"
    },
    empatheticTask5: {
        id: "rovo-personalization.personality-greeting.empatheticTask5",
        defaultMessage: "What can I help you think through today?"
    },
    empatheticTask6: {
        id: "rovo-personalization.personality-greeting.empatheticTask6",
        defaultMessage: "Let's shape a practical way forward"
    },
    empatheticTask7: {
        id: "rovo-personalization.personality-greeting.empatheticTask7",
        defaultMessage: "What should we tackle first, {name}?"
    },
    empatheticTask8: {
        id: "rovo-personalization.personality-greeting.empatheticTask8",
        defaultMessage: "Ready to work through things together?"
    }
});
const $121a96964d0675dc$export$2da6687ae5d86637 = {
    ...$121a96964d0675dc$var$uniquePersonalityGreetingMessages,
    collaborativeThinkDeeper3: $121a96964d0675dc$var$uniquePersonalityGreetingMessages.collaborativeNormal6,
    collaborativeThinkDeeper4: $121a96964d0675dc$var$uniquePersonalityGreetingMessages.collaborativeNormal8,
    collaborativeThinkDeeper5: $121a96964d0675dc$var$uniquePersonalityGreetingMessages.collaborativeNormal9,
    professionalTask6: $121a96964d0675dc$var$uniquePersonalityGreetingMessages.collaborativeTask2,
    creativeThinkDeeper4: $121a96964d0675dc$var$uniquePersonalityGreetingMessages.collaborativeThinkDeeper8,
    empatheticNormal5: $121a96964d0675dc$var$uniquePersonalityGreetingMessages.professionalTask2
};


const $fdc162138c3954de$var$GREETING_BUCKET_BY_PREFIX = {
    collaborativeNormal: [
        'normal',
        'rovo_default'
    ],
    professionalNormal: [
        'normal',
        'professional'
    ],
    creativeNormal: [
        'normal',
        'creative'
    ],
    empatheticNormal: [
        'normal',
        'empathetic'
    ],
    collaborativeThinkDeeper: [
        'thinkDeeper',
        'rovo_default'
    ],
    professionalThinkDeeper: [
        'thinkDeeper',
        'professional'
    ],
    creativeThinkDeeper: [
        'thinkDeeper',
        'creative'
    ],
    empatheticThinkDeeper: [
        'thinkDeeper',
        'empathetic'
    ],
    collaborativeTask: [
        'taskMode',
        'rovo_default'
    ],
    professionalTask: [
        'taskMode',
        'professional'
    ],
    creativeTask: [
        'taskMode',
        'creative'
    ],
    empatheticTask: [
        'taskMode',
        'empathetic'
    ]
};
/**
 * Curated greeting sets keyed by (mode, tone). Selection shuffles within the set
 * for the active pair; see `greetingRotation`.
 */ const $fdc162138c3954de$var$greetingSets = {
    normal: {
        rovo_default: [],
        professional: [],
        creative: [],
        empathetic: []
    },
    thinkDeeper: {
        rovo_default: [],
        professional: [],
        creative: [],
        empathetic: []
    },
    taskMode: {
        rovo_default: [],
        professional: [],
        creative: [],
        empathetic: []
    }
};
for (const [key, descriptor] of Object.entries((0, $121a96964d0675dc$export$2da6687ae5d86637))){
    const prefix = key.replace(/\d+$/, '');
    const bucket = $fdc162138c3954de$var$GREETING_BUCKET_BY_PREFIX[prefix];
    if (!bucket) throw new Error(`Unknown personality greeting prefix: ${prefix}`);
    const [mode, tone] = bucket;
    $fdc162138c3954de$var$greetingSets[mode][tone].push(descriptor);
}
const $fdc162138c3954de$export$a5d27dbab01740b0 = $fdc162138c3954de$var$greetingSets;


const $00366c38eeb4745c$var$preventOrphanedLastWord = (greeting)=>greeting.replace(/ (?=\S+$)/u, '\u00A0');
const $00366c38eeb4745c$export$273fbe357cd161f0 = ({ mode: mode, firstName: firstName, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { responseStyle: responseStyle, isLoading: isLoading } = (0, $dplZo.useResponseStyleSettings)({
        assistanceServiceParams: assistanceServiceParams
    });
    const tone = responseStyle.responseTone;
    const set = (0, $fdc162138c3954de$export$a5d27dbab01740b0)[mode][tone];
    const key = `${mode}:${tone}`;
    const canSelect = !isLoading && set.length > 0;
    const selectedKeysRef = (0, $cozmU.useRef)(new Set());
    const [selected, setSelected] = (0, $cozmU.useState)({});
    (0, $cozmU.useEffect)(()=>{
        if (!canSelect || selectedKeysRef.current.has(key)) return;
        selectedKeysRef.current.add(key);
        const index = (0, $72e93bae4d1990b7$export$e75539638363a335).next(key, set.length);
        setSelected((previous)=>({
                ...previous,
                [key]: index
            }));
    }, [
        canSelect,
        key,
        set.length
    ]);
    const result = (0, $cozmU.useMemo)(()=>{
        if (set.length === 0) return {
            greeting: null,
            isPending: false
        };
        if (isLoading) return {
            greeting: null,
            isPending: true
        };
        const index = selected[key];
        if (index === undefined || index < 0) return {
            greeting: null,
            isPending: true
        };
        const illustration = (0, $60e61da3c49ac2f2$export$6e3425ffb0124fe6)[tone];
        const title = formatMessage(set[index], {
            name: firstName
        });
        return {
            greeting: {
                title: $00366c38eeb4745c$var$preventOrphanedLastWord(title),
                src: illustration?.src,
                srcDark: illustration?.srcDark
            },
            isPending: false
        };
    }, [
        isLoading,
        selected,
        key,
        set,
        tone,
        formatMessage,
        firstName
    ]);
    return result;
};


const $f609a197ba24d594$export$9fe26c3eab41dad7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { firstName: firstName, conversationId: conversationId, headingSize: headingSize, isRevealedByResize: isRevealedByResize, isRevealedByDefault: isRevealedByDefault, assistanceServiceParams: assistanceServiceParams } = t0;
    const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled } = (0, $aQWBL.useChatModeState)(conversationId);
    let t1;
    if ($[0] !== deepResearchEnabled || $[1] !== taskModeEnabled || $[2] !== thinkDeeperEnabled) {
        t1 = (0, $4973a43f7b3c85d7$export$3d054339ac59aa25)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            taskModeEnabled: taskModeEnabled
        });
        $[0] = deepResearchEnabled;
        $[1] = taskModeEnabled;
        $[2] = thinkDeeperEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const { personalityMode: personalityMode, presentationMode: presentationMode } = t1;
    let t2;
    if ($[4] !== assistanceServiceParams || $[5] !== firstName || $[6] !== personalityMode) {
        t2 = {
            mode: personalityMode,
            firstName: firstName,
            assistanceServiceParams: assistanceServiceParams
        };
        $[4] = assistanceServiceParams;
        $[5] = firstName;
        $[6] = personalityMode;
        $[7] = t2;
    } else t2 = $[7];
    const { greeting: greeting, isPending: isPending } = (0, $00366c38eeb4745c$export$273fbe357cd161f0)(t2);
    const t3 = isPending ? undefined : greeting?.title;
    const t4 = isPending ? undefined : greeting?.src;
    const t5 = isPending ? undefined : greeting?.srcDark;
    let t6;
    if ($[8] !== deepResearchEnabled || $[9] !== firstName || $[10] !== headingSize || $[11] !== isRevealedByDefault || $[12] !== isRevealedByResize || $[13] !== presentationMode || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== taskModeEnabled) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24e0ffdb3d2e36e9$export$576fcda7744d6b09), {
            firstName: firstName,
            isDeepResearchEnabled: deepResearchEnabled,
            isTaskModeEnabled: taskModeEnabled,
            greetingMode: presentationMode,
            headingSize: headingSize,
            isRevealedByResize: isRevealedByResize,
            isRevealedByDefault: isRevealedByDefault,
            greetingText: t3,
            illustrationSrc: t4,
            illustrationSrcDark: t5
        });
        $[8] = deepResearchEnabled;
        $[9] = firstName;
        $[10] = headingSize;
        $[11] = isRevealedByDefault;
        $[12] = isRevealedByResize;
        $[13] = presentationMode;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = taskModeEnabled;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ firstName: firstName, conversationId: conversationId, headingSize: headingSize, isRevealedByResize: isRevealedByResize, isRevealedByDefault: isRevealedByDefault, assistanceServiceParams: assistanceServiceParams })=>{
    const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled } = (0, $aQWBL.useChatModeState)(conversationId);
    const { personalityMode: personalityMode, presentationMode: presentationMode } = (0, $4973a43f7b3c85d7$export$3d054339ac59aa25)({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        taskModeEnabled: taskModeEnabled
    });
    const { greeting: greeting, isPending: isPending } = (0, $00366c38eeb4745c$export$273fbe357cd161f0)({
        mode: personalityMode,
        firstName: firstName,
        assistanceServiceParams: assistanceServiceParams
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24e0ffdb3d2e36e9$export$576fcda7744d6b09), {
        firstName: firstName,
        isDeepResearchEnabled: deepResearchEnabled,
        isTaskModeEnabled: taskModeEnabled,
        greetingMode: presentationMode,
        headingSize: headingSize,
        isRevealedByResize: isRevealedByResize,
        isRevealedByDefault: isRevealedByDefault,
        greetingText: isPending ? undefined : greeting?.title,
        illustrationSrc: isPending ? undefined : greeting?.src,
        illustrationSrcDark: isPending ? undefined : greeting?.srcDark
    });
};


const $25dff19b7a11bf99$var$styles = {
    wrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuz9WS _0jFU0VN91d _39xV02N91d _313842IZbP",
    wrapperMiniModal: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuz9WS _4kiQYAN91d _39xV02N91d",
    wrapperQuickActionsTab: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuchRC _0jFU0VN91d _39xV02N91d",
    fsWrapper: "_0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _0Of8r25zaO _1wydGW2ADO",
    insightsBannerWrapperMiniModal: "_0Of8r22ADO _2Zuz6Q8HPE _1Znuxb8HPE _1wydGW8HPE _39xV02N91d",
    insightsBannerWrapperMiniModalQuickActions: "_0Of8r22ADO _2Zuz6Q8HPE _1Znuxb8HPE _1wydGW2ADO _39xV02N91d",
    insightsBannerWrapperSidebar: "_2Zuz6Q5zaO _1Znuxb5zaO _0Of8r28HPE _1wydGW8HPE _39xV02N91d"
};
const $25dff19b7a11bf99$var$RovoEmptyStateComponent = ({ mode: mode, conversationId: conversationId, handleClickDynamicPrompt: handleClickDynamicPrompt, sendMessage: sendMessage, isResizeEnabled: isResizeEnabled = false, isResizeHeaderThresholdReached: isResizeHeaderThresholdReached = null, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, layout: layout = 'default', selectedSpace: selectedSpace, onNestedViewChange: onNestedViewChange })=>{
    (0, $6cFsl.di)((0, $bY61u.useInsightsStatus));
    const setChatInputPlaceholderOverride = (0, $aBUXY.usePlaceholderOverrideDispatch)();
    const { closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const { deepResearchEnabled: deepResearchEnabled, taskModeEnabled: taskModeEnabled } = (0, $aQWBL.useChatModeState)((0, $4m5jb.EMPTY_CONVERSATION_ID));
    const { name: name } = (0, $isp1U.useProfileController)();
    const [{ customGreeting: runtimeCustomGreeting, skillRegistryTags: skillRegistryTags, projectContext: projectContext }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const hasRuntimeCustomGreeting = Boolean(runtimeCustomGreeting);
    const { fullScreen: fullScreen, elements: elements, customGreeting: uiConfigCustomGreeting } = (0, $dSCNl.useUIConfig)();
    const customGreeting = runtimeCustomGreeting ?? uiConfigCustomGreeting;
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const [isInNestedActionView, setIsInNestedActionView] = (0, $cozmU.useState)(false);
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'rovo-empty-state'
    });
    const isRenderStabilizationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const personalityGreetingsEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_personality_presets', 'isEnabled', false) && (0, $cXtTj.default).getExperimentValue('rovo_chat_personality_greeting', 'isEnabled', false);
    const isPulseExperimentEnabled = !fullScreen && (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
    const scheduleOk = isPulseExperimentEnabled ? (0, $cXtTj.default).checkGate('rovo_growth_insights_banner_ignore_schedule') || (0, $b1faed5da83dea83$export$200db2820880abd6)() : false;
    const { isInsightsAvailable: isInsightsAvailable, generatedAt: generatedAt, isFresh: isFresh, statusFetchState: statusFetchState } = (0, $bY61u.useInsightsStatus)({
        enabled: isPulseExperimentEnabled && scheduleOk,
        assistanceServiceParams: assistanceServiceParams
    }); // Report how the insights entry point resolved (shown, or why not) for per-user diagnosis.
    (0, $a8cc5669d925fa6c$export$dc8676c7370a9cf5)({
        surface: 'quickActions',
        pulseEnabled: isPulseExperimentEnabled,
        requiresProduct: false,
        hasProduct: !!assistanceServiceParams.product,
        scheduleOk: scheduleOk,
        statusFetchState: statusFetchState,
        isInsightsAvailable: isInsightsAvailable,
        requiresFresh: layout === 'quickActionsTab',
        isFresh: isFresh,
        hasSelectedSpace: !!selectedSpace,
        generatedAt: generatedAt
    });
    const handleInsightsBannerClick = (0, $cozmU.useCallback)(()=>{
        setActiveMenu('pulse');
    }, [
        setActiveMenu
    ]); // Chain the local nested-view setter (used by the greeting-hide guard below)
    // with the parent-lifted callback (used by useEmptyStateRender to hide the
    // RovoTabs tab strip while in a nested action).
    const handleNestedViewChange = (0, $cozmU.useCallback)((isNested)=>{
        setIsInNestedActionView(isNested);
        onNestedViewChange?.(isNested);
    }, [
        onNestedViewChange
    ]);
    const spaceAnalyticsAttributes = (0, $cozmU.useMemo)(()=>projectContext?.spaceId ? {
            spaceId: projectContext.spaceId,
            spaceName: projectContext.projectName
        } : undefined, [
        projectContext?.spaceId,
        projectContext?.projectName
    ]);
    const firstName = name.split(' ')[0];
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const isQuickActionsTab = layout === 'quickActionsTab';
    const isQuickActionsTabMiniModal = isQuickActionsTab && isMiniModal;
    const greetingHeadingSize = customGreeting?.titleSize ?? (isMiniModal ? 'small' : 'xlarge');
    const renderGreeting = (isRevealedByResize, isRevealedByDefault)=>{
        if (customGreeting && !deepResearchEnabled && !taskModeEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $a853efd6070d89d8$export$949ed0d2d58c2b53), {
            src: customGreeting.iconSrc,
            srcDark: customGreeting.iconSrcDark,
            title: customGreeting.title,
            subtitle: customGreeting.subtitle,
            testId: customGreeting.testId,
            animationDuration: customGreeting.animationDuration,
            entranceDirection: customGreeting.entranceDirection,
            exitDirection: customGreeting.exitDirection,
            animationKey: customGreeting.animationKey,
            headingSize: greetingHeadingSize,
            isRevealedByResize: isRevealedByResize,
            isRevealedByDefault: isRevealedByDefault,
            firstName: firstName,
            truncateGreeting: customGreeting.truncateGreeting,
            imageHeight: customGreeting.imageHeight
        });
        if (personalityGreetingsEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $f609a197ba24d594$export$9fe26c3eab41dad7), {
            firstName: firstName,
            conversationId: conversationId ?? (0, $4m5jb.EMPTY_CONVERSATION_ID),
            headingSize: greetingHeadingSize,
            isRevealedByResize: isRevealedByResize,
            isRevealedByDefault: isRevealedByDefault,
            assistanceServiceParams: assistanceServiceParams
        });
        return /*#__PURE__*/ $cozmU.createElement((0, $24e0ffdb3d2e36e9$export$576fcda7744d6b09), {
            firstName: firstName,
            isDeepResearchEnabled: deepResearchEnabled,
            isTaskModeEnabled: taskModeEnabled,
            headingSize: greetingHeadingSize,
            isRevealedByResize: isRevealedByResize,
            isRevealedByDefault: isRevealedByDefault
        });
    };
    if (fullScreen) {
        const shouldShowFullScreenGreeting = elements?.shouldShowGreeting !== false;
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "rovo-empty-state-fullscreen",
            className: (0, $hekY6.default)([
                $25dff19b7a11bf99$var$styles.fsWrapper
            ])
        }, shouldShowFullScreenGreeting && renderGreeting());
    }
    const shouldShowGreeting = !(isMiniModal && deepResearchEnabled) && // Don't show greeting in mini modal if deep research is enabled
    (hasRuntimeCustomGreeting || elements?.shouldShowGreeting !== false && (elements?.shouldShowGreeting === true || !isMiniModal));
    const isMiniModalResizeEnabled = isMiniModal && isResizeEnabled;
    const isGreetingControlledByResize = isMiniModalResizeEnabled && !shouldShowGreeting; // There are two modes:
    // 1. "Visible by default" (FF on): Greeting shows initially, user can hide by resizing down
    // 2. "Controlled by resize" (FF off): Greeting hidden initially, user can reveal by resizing up
    const shouldRenderGreeting = shouldShowGreeting || isGreetingControlledByResize;
    const visibleByDefault = shouldShowGreeting;
    const shouldShowConversationActions = elements?.shouldShowConversationActions !== false; // In the tabbed Quick Actions layout, only show fresh insights. The legacy no-tabs empty
    // state keeps showing the banner whenever insights are available.
    const showInsightsBanner = isPulseExperimentEnabled && isInsightsAvailable && !selectedSpace && (!isQuickActionsTab || isFresh);
    const resizeVisibility = isMiniModalResizeEnabled ? isResizeHeaderThresholdReached : undefined;
    const useQuickActionsTabMiniModalLayout = isQuickActionsTabMiniModal && showInsightsBanner;
    const insightsBanner = showInsightsBanner ? /*#__PURE__*/ $cozmU.createElement((0, $a1L5E.default), {
        name: 'insights-banner'
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isQuickActionsTabMiniModal ? $25dff19b7a11bf99$var$styles.insightsBannerWrapperMiniModalQuickActions : isMiniModal ? $25dff19b7a11bf99$var$styles.insightsBannerWrapperMiniModal : $25dff19b7a11bf99$var$styles.insightsBannerWrapperSidebar
    }, /*#__PURE__*/ $cozmU.createElement((0, $6bdb37ec7796f6ed$export$c03a8cd6181f4965), {
        onClick: handleInsightsBannerClick,
        appearance: "quickActions",
        generatedAt: generatedAt
    }))) : null;
    const conversationActions = /*#__PURE__*/ $cozmU.createElement((0, $599066d9ca0ac86c$export$e9cbe40006ce4ca7), {
        closeChat: closeChat,
        sendMessage: sendMessage,
        setChatInputPlaceholderOverride: setChatInputPlaceholderOverride,
        handleClickDynamicPrompt: handleClickDynamicPrompt,
        mode: mode,
        assistanceServiceParams: assistanceServiceParams,
        setActiveAction: setActiveAction,
        onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
        analyticsAttributes: spaceAnalyticsAttributes,
        onNestedViewChange: handleNestedViewChange,
        skillRegistryTags: skillRegistryTags,
        isRenderStabilizationEnabled: isRenderStabilizationEnabled
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "rovo-empty-state",
        className: (0, $hekY6.default)([
            useQuickActionsTabMiniModalLayout ? $25dff19b7a11bf99$var$styles.wrapperQuickActionsTab : isMiniModalResizeEnabled ? $25dff19b7a11bf99$var$styles.wrapperMiniModal : $25dff19b7a11bf99$var$styles.wrapper
        ])
    }, shouldRenderGreeting && !isInNestedActionView && renderGreeting(resizeVisibility, visibleByDefault), insightsBanner, /*#__PURE__*/ $cozmU.createElement((0, $a1L5E.default), {
        name: "rovo-conversation-actions"
    }, shouldShowConversationActions && conversationActions));
};
// rovo_ttai_segment_render_stabilization: absorb parent render waves when props are stable.
const $25dff19b7a11bf99$var$MemoizedRovoEmptyState = /*#__PURE__*/ (0, $cozmU.memo)($25dff19b7a11bf99$var$RovoEmptyStateComponent, (0, $dqxOF.shallowEqualObjects)); // rovo_ttai_segment_render_stabilization ON: subscribe to `selectedSpace` via the
// narrow selector so the component only re-renders when `selectedSpace` changes,
// rather than on every UI-store state change.
const $25dff19b7a11bf99$var$RovoEmptyStateWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useSelectedSpaceSelector));
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    return /*#__PURE__*/ $cozmU.createElement($25dff19b7a11bf99$var$MemoizedRovoEmptyState, {
        ...props,
        selectedSpace: selectedSpace
    });
}; // rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $25dff19b7a11bf99$var$RovoEmptyStateWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { selectedSpace: selectedSpace } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ $cozmU.createElement($25dff19b7a11bf99$var$RovoEmptyStateComponent, {
        ...props,
        selectedSpace: selectedSpace
    });
};
const $25dff19b7a11bf99$export$19eeab93b3b79fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) === true ? /*#__PURE__*/ $cozmU.createElement($25dff19b7a11bf99$var$RovoEmptyStateWithSelector, props) : /*#__PURE__*/ $cozmU.createElement($25dff19b7a11bf99$var$RovoEmptyStateWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true ? /*#__PURE__*/ $cozmU.createElement($25dff19b7a11bf99$var$RovoEmptyStateWithSelector, props) : /*#__PURE__*/ $cozmU.createElement($25dff19b7a11bf99$var$RovoEmptyStateWithBroadStore, props);
};






const $b5102ff63ab21a48$var$message = (0, $kSwu1.defineMessages)({
    suggestionsTabLabel: {
        id: "ai-mate.rovo-tabs.suggestions-tab-label",
        defaultMessage: "Quick actions"
    },
    forYouTabLabel: {
        id: "ai-mate.rovo-tabs.for-you-tab-label",
        defaultMessage: "Your work"
    },
    quickActionsTabLabel: {
        id: "ai-mate.rovo-tabs.quick-actions-tab-label",
        defaultMessage: "Quick actions"
    },
    yourWorkTabLabel: {
        id: "ai-mate.rovo-tabs.your-work-tab-label",
        defaultMessage: "Your work"
    }
});
var $b5102ff63ab21a48$export$2e2bcd8739ae039 = $b5102ff63ab21a48$var$message;






















const $9b35088d9023a1dc$var$styles = {
    tabsContainer: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w",
    tabListWrapper: "_3iDTPbQ4SZ _37wbyuDIqT _39xV02N91d _0Of8r22ADO _1wydGW2ADO",
    tabListContainer: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS",
    tabIndicator: "_0bjKvDS5Zs _23rrnH5sNQ _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d _0KLXruDMqu",
    tab: "_0bjKvDS5Zs _30huDKYbGa _4c065UgVvo _2Zuz6Q8HPE _1Znuxb8HPE _0KLXrujOvk _0wOv4Q7zJH",
    tabContentWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4kiQYAdnbC _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w",
    primaryPanel: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP _4kiQYAdnbC _39xV02N91d _0Fz5g5G6SO _1qyfxmIZbP _3oUqlsUzH9",
    panelHidden: "_0fKRyPnQyn _1pp6NdYbGa",
    panelDisplayNone: "_3iDTPbYbGa",
    overlayPanel: "_4bt5LAIZbP _2WAcuGIZbP _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _0Fz5g5G6SO _1qyfxmIZbP _3oUqlsUzH9"
};
const $9b35088d9023a1dc$export$4dba4f04ea4f19e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { tabs: tabs, selectedTab: selectedTab, onTabChange: onTabChange, hideTabStrip: t1 } = t0;
    const hideTabStrip = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== onTabChange) {
        t2 = (tabId)=>{
            onTabChange(tabId);
        };
        $[0] = onTabChange;
        $[1] = t2;
    } else t2 = $[1];
    const onSelectTab = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Map();
        $[2] = t3;
    } else t3 = $[2];
    const tabRefsMap = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            width: 0,
            transform: "translateX(0)"
        };
        $[3] = t4;
    } else t4 = $[3];
    const [indicatorStyle, setIndicatorStyle] = (0, $cozmU.useState)(t4);
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (id, el)=>{
            if (el) tabRefsMap.current.set(id, el);
            else tabRefsMap.current.delete(id);
        };
        $[4] = t5;
    } else t5 = $[4];
    const setTabRef = t5;
    let t6;
    if ($[5] !== onSelectTab || $[6] !== selectedTab || $[7] !== tabs) {
        t6 = (e)=>{
            if (tabs.length === 0) return;
            const currentIndex = tabs.findIndex((t)=>t.id === selectedTab);
            if (currentIndex === -1) return;
            let nextIndex = null;
            if (e.key === "ArrowRight") nextIndex = (currentIndex + 1) % tabs.length;
            else if (e.key === "ArrowLeft") nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            if (nextIndex !== null) {
                e.preventDefault();
                const nextTab = tabs[nextIndex];
                onSelectTab(nextTab.id);
                tabRefsMap.current.get(nextTab.id)?.focus();
            }
        };
        $[5] = onSelectTab;
        $[6] = selectedTab;
        $[7] = tabs;
        $[8] = t6;
    } else t6 = $[8];
    const handleKeyDown = t6;
    let t7;
    let t8;
    if ($[9] !== selectedTab) {
        t7 = ()=>{
            const selectedRef = tabRefsMap.current.get(selectedTab);
            if (selectedRef) setIndicatorStyle({
                width: `${selectedRef.offsetWidth}px`,
                transform: `translateX(${selectedRef.offsetLeft}px)`
            });
        };
        t8 = [
            selectedTab
        ];
        $[9] = selectedTab;
        $[10] = t7;
        $[11] = t8;
    } else {
        t7 = $[10];
        t8 = $[11];
    }
    (0, $cozmU.useLayoutEffect)(t7, t8);
    let t9;
    if ($[12] !== selectedTab) {
        t9 = ()=>new Set([
                selectedTab
            ]);
        $[12] = selectedTab;
        $[13] = t9;
    } else t9 = $[13];
    const [visitedTabs, setVisitedTabs] = (0, $cozmU.useState)(t9);
    if (!visitedTabs.has(selectedTab)) setVisitedTabs((prev)=>new Set([
            ...prev,
            selectedTab
        ]));
    const primaryTab = tabs[0];
    let t10;
    if ($[14] !== tabs) {
        t10 = tabs.find($9b35088d9023a1dc$var$_temp);
        $[14] = tabs;
        $[15] = t10;
    } else t10 = $[15];
    const forYouTab = t10;
    const isForYouSelected = selectedTab === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3);
    const flowTab = isForYouSelected && forYouTab ? forYouTab : primaryTab;
    let T0;
    let T1;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    if ($[16] !== flowTab || $[17] !== forYouTab || $[18] !== handleKeyDown || $[19] !== hideTabStrip || $[20] !== indicatorStyle || $[21] !== isForYouSelected || $[22] !== onSelectTab || $[23] !== selectedTab || $[24] !== tabs || $[25] !== visitedTabs) {
        const overlayTabs = isForYouSelected && forYouTab ? tabs.filter($9b35088d9023a1dc$var$_temp2) : tabs.slice(1);
        T1 = (0, $iMnC5.Box);
        t14 = $9b35088d9023a1dc$var$styles.tabsContainer;
        if ($[33] !== handleKeyDown || $[34] !== hideTabStrip || $[35] !== indicatorStyle || $[36] !== onSelectTab || $[37] !== selectedTab || $[38] !== tabs) {
            t15 = !hideTabStrip && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $9b35088d9023a1dc$var$styles.tabListWrapper
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $9b35088d9023a1dc$var$styles.tabListContainer,
                role: "tablist",
                onKeyDown: handleKeyDown
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $9b35088d9023a1dc$var$styles.tabIndicator,
                style: indicatorStyle,
                "aria-hidden": "true"
            }), tabs.map((tab)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                    key: tab.id,
                    xcss: $9b35088d9023a1dc$var$styles.tab,
                    role: "tab",
                    "aria-selected": selectedTab === tab.id,
                    "aria-controls": `panel-${tab.id}`,
                    id: `rovo-tab-${tab.id}`,
                    tabIndex: 0,
                    onClick: ()=>onSelectTab(tab.id),
                    testId: `rovo-tab-${tab.id}`,
                    ref: (el_0)=>setTabRef(tab.id, el_0)
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    weight: "medium",
                    color: selectedTab === tab.id ? "color.text" : "color.text.subtlest"
                }, tab.label)))));
            $[33] = handleKeyDown;
            $[34] = hideTabStrip;
            $[35] = indicatorStyle;
            $[36] = onSelectTab;
            $[37] = selectedTab;
            $[38] = tabs;
            $[39] = t15;
        } else t15 = $[39];
        T0 = (0, $iMnC5.Box);
        t11 = $9b35088d9023a1dc$var$styles.tabContentWrapper;
        if ($[40] !== flowTab || $[41] !== selectedTab || $[42] !== visitedTabs) {
            t12 = flowTab && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($9b35088d9023a1dc$var$styles.primaryPanel, selectedTab !== flowTab.id && $9b35088d9023a1dc$var$styles.panelHidden),
                role: "tabpanel",
                id: `panel-${flowTab.id}`,
                testId: `panel-${flowTab.id}`,
                "aria-labelledby": `rovo-tab-${flowTab.id}`,
                "aria-hidden": selectedTab !== flowTab.id
            }, visitedTabs.has(flowTab.id) ? flowTab.content : null);
            $[40] = flowTab;
            $[41] = selectedTab;
            $[42] = visitedTabs;
            $[43] = t12;
        } else t12 = $[43];
        let t16;
        if ($[44] !== selectedTab || $[45] !== visitedTabs) {
            t16 = (tab_0)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    key: tab_0.id,
                    xcss: (0, $w6R6I.cx)($9b35088d9023a1dc$var$styles.overlayPanel, selectedTab !== tab_0.id && $9b35088d9023a1dc$var$styles.panelDisplayNone),
                    role: "tabpanel",
                    id: `panel-${tab_0.id}`,
                    testId: `panel-${tab_0.id}`,
                    "aria-labelledby": `rovo-tab-${tab_0.id}`,
                    "aria-hidden": selectedTab !== tab_0.id
                }, visitedTabs.has(tab_0.id) ? tab_0.content : null);
            $[44] = selectedTab;
            $[45] = visitedTabs;
            $[46] = t16;
        } else t16 = $[46];
        t13 = overlayTabs.map(t16);
        $[16] = flowTab;
        $[17] = forYouTab;
        $[18] = handleKeyDown;
        $[19] = hideTabStrip;
        $[20] = indicatorStyle;
        $[21] = isForYouSelected;
        $[22] = onSelectTab;
        $[23] = selectedTab;
        $[24] = tabs;
        $[25] = visitedTabs;
        $[26] = T0;
        $[27] = T1;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
        $[31] = t14;
        $[32] = t15;
    } else {
        T0 = $[26];
        T1 = $[27];
        t11 = $[28];
        t12 = $[29];
        t13 = $[30];
        t14 = $[31];
        t15 = $[32];
    }
    let t16;
    if ($[47] !== T0 || $[48] !== t11 || $[49] !== t12 || $[50] !== t13) {
        t16 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t11
        }, t12, t13);
        $[47] = T0;
        $[48] = t11;
        $[49] = t12;
        $[50] = t13;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== T1 || $[53] !== t14 || $[54] !== t15 || $[55] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement(T1, {
            xcss: t14
        }, t15, t16);
        $[52] = T1;
        $[53] = t14;
        $[54] = t15;
        $[55] = t16;
        $[56] = t17;
    } else t17 = $[56];
    return t17;
} : ({ tabs: tabs, selectedTab: selectedTab, onTabChange: onTabChange, hideTabStrip: hideTabStrip = false })=>{
    const onSelectTab = (0, $cozmU.useCallback)((tabId)=>{
        onTabChange(tabId);
    }, [
        onTabChange
    ]);
    const tabRefsMap = (0, $cozmU.useRef)(new Map());
    const [indicatorStyle, setIndicatorStyle] = (0, $cozmU.useState)({
        width: 0,
        transform: 'translateX(0)'
    });
    const setTabRef = (0, $cozmU.useCallback)((id, el)=>{
        if (el) tabRefsMap.current.set(id, el);
        else tabRefsMap.current.delete(id);
    }, []);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (tabs.length === 0) return;
        const currentIndex = tabs.findIndex((t)=>t.id === selectedTab);
        if (currentIndex === -1) return;
        let nextIndex = null;
        if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (nextIndex !== null) {
            e.preventDefault();
            const nextTab = tabs[nextIndex];
            onSelectTab(nextTab.id);
            tabRefsMap.current.get(nextTab.id)?.focus();
        }
    }, [
        tabs,
        selectedTab,
        onSelectTab
    ]); // Calculate indicator position and width after DOM updates
    (0, $cozmU.useLayoutEffect)(()=>{
        const selectedRef = tabRefsMap.current.get(selectedTab);
        if (selectedRef) setIndicatorStyle({
            width: `${selectedRef.offsetWidth}px`,
            transform: `translateX(${selectedRef.offsetLeft}px)`
        });
    }, [
        selectedTab
    ]); // Lazily mount tab content: a tab's content is only rendered after it has first been selected.
    // This prevents expensive data fetches (e.g. For You GraphQL/REST calls) from firing before
    // the user has actually opened that tab. The initial `selectedTab` is seeded so its content
    // renders immediately. When `selectedTab` changes to a new (unvisited) tab, calling setState
    // during render causes React to re-render synchronously without painting the intermediate
    // null state — this is the React-recommended "store information from previous renders" pattern.
    const [visitedTabs, setVisitedTabs] = (0, $cozmU.useState)(()=>new Set([
            selectedTab
        ]));
    if (!visitedTabs.has(selectedTab)) setVisitedTabs((prev)=>new Set([
            ...prev,
            selectedTab
        ]));
    const primaryTab = tabs[0];
    const forYouTab = tabs.find((t_0)=>t_0.id === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3));
    const isForYouSelected = selectedTab === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3); // When For You is selected, render it as the in-flow primary panel so it fills the modal height.
    // Otherwise the overlay (position:absolute) can fail to inherit height from a visibility:hidden primary.
    const flowTab = isForYouSelected && forYouTab ? forYouTab : primaryTab;
    const overlayTabs = isForYouSelected && forYouTab ? tabs.filter((t_1)=>t_1.id !== (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3)) : tabs.slice(1);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9b35088d9023a1dc$var$styles.tabsContainer
    }, !hideTabStrip && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9b35088d9023a1dc$var$styles.tabListWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9b35088d9023a1dc$var$styles.tabListContainer,
        role: "tablist",
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9b35088d9023a1dc$var$styles.tabIndicator,
        style: indicatorStyle,
        "aria-hidden": "true"
    }), tabs.map((tab)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            key: tab.id,
            xcss: $9b35088d9023a1dc$var$styles.tab,
            role: "tab",
            "aria-selected": selectedTab === tab.id,
            "aria-controls": `panel-${tab.id}`,
            id: `rovo-tab-${tab.id}`,
            tabIndex: 0,
            onClick: ()=>onSelectTab(tab.id),
            testId: `rovo-tab-${tab.id}`,
            ref: (el_0)=>setTabRef(tab.id, el_0)
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "medium",
            color: selectedTab === tab.id ? 'color.text' : 'color.text.subtlest'
        }, tab.label))))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9b35088d9023a1dc$var$styles.tabContentWrapper
    }, flowTab && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($9b35088d9023a1dc$var$styles.primaryPanel, selectedTab !== flowTab.id && $9b35088d9023a1dc$var$styles.panelHidden),
        role: "tabpanel",
        id: `panel-${flowTab.id}`,
        testId: `panel-${flowTab.id}`,
        "aria-labelledby": `rovo-tab-${flowTab.id}`,
        "aria-hidden": selectedTab !== flowTab.id
    }, visitedTabs.has(flowTab.id) ? flowTab.content : null), overlayTabs.map((tab_0)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: tab_0.id,
            xcss: (0, $w6R6I.cx)($9b35088d9023a1dc$var$styles.overlayPanel, selectedTab !== tab_0.id && $9b35088d9023a1dc$var$styles.panelDisplayNone),
            role: "tabpanel",
            id: `panel-${tab_0.id}`,
            testId: `panel-${tab_0.id}`,
            "aria-labelledby": `rovo-tab-${tab_0.id}`,
            "aria-hidden": selectedTab !== tab_0.id
        }, visitedTabs.has(tab_0.id) ? tab_0.content : null))));
};
function $9b35088d9023a1dc$var$_temp(t_0) {
    return t_0.id === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3);
}
function $9b35088d9023a1dc$var$_temp2(t_1) {
    return t_1.id !== (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3);
}


const $cb077d0482df7dfa$var$sendEmptyStateMessage = ({ agent: agent, conversationId: conversationId, appFilters: appFilters, handleType: handleType, prompt: prompt, resolvedSpaceId: resolvedSpaceId, sendMessage: sendMessage, storeUserMessages: storeUserMessages, useCurrentPageContext: useCurrentPageContext, webSearchEnabled: webSearchEnabled })=>{
    const spaceContext = resolvedSpaceId ? {
        spaceId: resolvedSpaceId
    } : {};
    sendMessage({
        agent: agent ?? undefined,
        prompt: handleType === (0, $6iWVH.HandleActionType).Skill ? (0, $6rwn6.encodeSkillPromptToAdf)(prompt).adf : (0, $6rwn6.encodeAdf)(prompt),
        conversationId: conversationId,
        storeUserMessages: storeUserMessages ?? false,
        messageSources: {
            // TODO: align on interaction source keys.
            followUpSource: 'aiMate'
        },
        deepResearchEnabled: undefined,
        thinkDeeperEnabled: undefined,
        fastModeEnabled: undefined,
        taskModeEnabled: undefined,
        webSearchEnabled: webSearchEnabled,
        addCurrentPageAsContextUserPreference: useCurrentPageContext,
        appFilters: appFilters,
        ...spaceContext
    });
};
const $cb077d0482df7dfa$export$be828b35b34a02be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { activeTabId: activeTabId, conversation: conversation, conversationAgent: conversationAgent, conversationId: conversationId, conversationMessagesResponseCount: conversationMessagesResponseCount, currentChatMode: currentChatMode, elements: elements, formatMessage: formatMessage, handleChatEmptyLaunch: handleChatEmptyLaunch, handleClickDynamicPrompt: handleClickDynamicPrompt, isConversationAgentDefault: isConversationAgentDefault, isRenderStabilizationEnabled: isRenderStabilizationEnabled, isResizeEnabled: isResizeEnabled, isResizeHeaderThresholdReached: isResizeHeaderThresholdReached, mode: mode, onActiveTabChange: onActiveTabChange, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, product: product, profileData: profileData, runtimeCustomGreeting: runtimeCustomGreeting, selectedPinnedItem: selectedPinnedItem, selectedSpace: selectedSpace, sendMessage: sendMessage, siteId: siteId, storeUserMessages: storeUserMessages } = t0;
    (0, $6cFsl.di)((0, $iDrrr.fg));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)();
        $[0] = t1;
    } else t1 = $[0];
    const isFypTabsEnabled = t1;
    const [isInNestedActionView, setIsInNestedActionView] = (0, $cozmU.useState)(false);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsInNestedActionView(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== activeTabId || $[3] !== conversationId || $[4] !== mode) {
        t3 = [
            mode,
            activeTabId,
            conversationId
        ];
        $[2] = activeTabId;
        $[3] = conversationId;
        $[4] = mode;
        $[5] = t3;
    } else t3 = $[5];
    (0, $cozmU.useEffect)(t2, t3);
    const webSearchEnabled = currentChatMode.webSearchEnabled;
    const useCurrentPageContext = currentChatMode.useCurrentPageContext;
    const appFilters = currentChatMode.appFilters;
    const selectedSpaceId = selectedSpace?.id;
    const conversationRovoSpaceId = conversation?.rovoSpaceId;
    let t4;
    if ($[6] !== appFilters || $[7] !== conversationId || $[8] !== conversationRovoSpaceId || $[9] !== selectedSpaceId || $[10] !== sendMessage || $[11] !== storeUserMessages || $[12] !== useCurrentPageContext || $[13] !== webSearchEnabled) {
        t4 = (prompt, handleType, agent)=>{
            $cb077d0482df7dfa$var$sendEmptyStateMessage({
                agent: agent,
                appFilters: appFilters,
                conversationId: conversationId,
                handleType: handleType,
                prompt: prompt,
                resolvedSpaceId: (selectedSpaceId ?? conversationRovoSpaceId) && (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? selectedSpaceId ?? conversationRovoSpaceId : undefined,
                sendMessage: sendMessage,
                storeUserMessages: storeUserMessages,
                useCurrentPageContext: useCurrentPageContext,
                webSearchEnabled: webSearchEnabled
            });
        };
        $[6] = appFilters;
        $[7] = conversationId;
        $[8] = conversationRovoSpaceId;
        $[9] = selectedSpaceId;
        $[10] = sendMessage;
        $[11] = storeUserMessages;
        $[12] = useCurrentPageContext;
        $[13] = webSearchEnabled;
        $[14] = t4;
    } else t4 = $[14];
    const handleStabilizedSendMessage = t4;
    let t5;
    if ($[15] !== activeTabId || $[16] !== conversationAgent || $[17] !== conversationId || $[18] !== conversationMessagesResponseCount || $[19] !== elements?.shouldShowConversationActions || $[20] !== formatMessage || $[21] !== handleChatEmptyLaunch || $[22] !== handleClickDynamicPrompt || $[23] !== isConversationAgentDefault || $[24] !== isInNestedActionView || $[25] !== isResizeEnabled || $[26] !== isResizeHeaderThresholdReached || $[27] !== mode || $[28] !== onActiveTabChange || $[29] !== onDiscoverPromptLibraryClick || $[30] !== product || $[31] !== profileData || $[32] !== runtimeCustomGreeting || $[33] !== selectedPinnedItem || $[34] !== selectedSpace || $[35] !== siteId || $[36] !== useCurrentPageContext) {
        t5 = (emptyStateSendMessage)=>{
            const shouldBypassTabsForEmptyLaunch = conversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID) && Boolean(runtimeCustomGreeting);
            const emptyStateContent = !isConversationAgentDefault && conversationAgent ? /*#__PURE__*/ $cozmU.createElement((0, $506b74a7df7281b7$export$3bafafbc17b0f410), {
                agent: conversationAgent,
                addCurrentPageAsContextUserPreference: useCurrentPageContext
            }) : /*#__PURE__*/ $cozmU.createElement((0, $25dff19b7a11bf99$export$19eeab93b3b79fe), {
                mode: mode || (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
                conversationId: conversationId,
                sendMessage: emptyStateSendMessage,
                handleClickDynamicPrompt: handleClickDynamicPrompt,
                isResizeEnabled: isResizeEnabled,
                isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
                onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick
            });
            if (shouldBypassTabsForEmptyLaunch) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
                data: {
                    conversationHistorySubScreen: "empty-state",
                    conversationMessagesResponseCount: conversationMessagesResponseCount
                }
            }), emptyStateContent);
            if ((mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL || mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR) && activeTabId !== undefined && onActiveTabChange && !selectedSpace && !selectedPinnedItem && isConversationAgentDefault && elements?.shouldShowConversationActions !== false && isFypTabsEnabled) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
                data: {
                    conversationHistorySubScreen: "empty-state-tabs",
                    conversationMessagesResponseCount: conversationMessagesResponseCount
                }
            }), /*#__PURE__*/ $cozmU.createElement((0, $9b35088d9023a1dc$export$4dba4f04ea4f19e1), {
                tabs: [
                    {
                        id: (0, $eef113145ca4ccce$export$a6818377be660b14),
                        label: formatMessage((0, $b5102ff63ab21a48$export$2e2bcd8739ae039).quickActionsTabLabel),
                        content: /*#__PURE__*/ $cozmU.createElement((0, $25dff19b7a11bf99$export$19eeab93b3b79fe), {
                            mode: mode || (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
                            conversationId: conversationId,
                            sendMessage: emptyStateSendMessage,
                            handleClickDynamicPrompt: handleClickDynamicPrompt,
                            isResizeEnabled: isResizeEnabled,
                            isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
                            onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
                            layout: "quickActionsTab",
                            onNestedViewChange: setIsInNestedActionView
                        })
                    },
                    {
                        id: (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3),
                        label: formatMessage((0, $b5102ff63ab21a48$export$2e2bcd8739ae039).yourWorkTabLabel),
                        content: /*#__PURE__*/ $cozmU.createElement((0, $a40f11736e2ea035$export$241c63312adc3a1b), {
                            cloudId: siteId,
                            userId: profileData.aaid ?? "",
                            product: product,
                            isActive: activeTabId === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3),
                            onChatEmptyLaunch: handleChatEmptyLaunch
                        })
                    }
                ],
                selectedTab: activeTabId,
                onTabChange: onActiveTabChange,
                hideTabStrip: isInNestedActionView
            }));
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
                data: {
                    conversationHistorySubScreen: "empty-state",
                    conversationMessagesResponseCount: conversationMessagesResponseCount
                }
            }), emptyStateContent);
        };
        $[15] = activeTabId;
        $[16] = conversationAgent;
        $[17] = conversationId;
        $[18] = conversationMessagesResponseCount;
        $[19] = elements?.shouldShowConversationActions;
        $[20] = formatMessage;
        $[21] = handleChatEmptyLaunch;
        $[22] = handleClickDynamicPrompt;
        $[23] = isConversationAgentDefault;
        $[24] = isInNestedActionView;
        $[25] = isResizeEnabled;
        $[26] = isResizeHeaderThresholdReached;
        $[27] = mode;
        $[28] = onActiveTabChange;
        $[29] = onDiscoverPromptLibraryClick;
        $[30] = product;
        $[31] = profileData;
        $[32] = runtimeCustomGreeting;
        $[33] = selectedPinnedItem;
        $[34] = selectedSpace;
        $[35] = siteId;
        $[36] = useCurrentPageContext;
        $[37] = t5;
    } else t5 = $[37];
    elements?.shouldShowConversationActions;
    const renderEmptyStateContent = t5;
    let t6;
    if ($[38] !== handleStabilizedSendMessage || $[39] !== isRenderStabilizationEnabled || $[40] !== renderEmptyStateContent) {
        t6 = isRenderStabilizationEnabled ? renderEmptyStateContent(handleStabilizedSendMessage) : null;
        $[38] = handleStabilizedSendMessage;
        $[39] = isRenderStabilizationEnabled;
        $[40] = renderEmptyStateContent;
        $[41] = t6;
    } else t6 = $[41];
    const stabilizedRenderEmptyState = t6;
    let t7;
    bb0: {
        if (isRenderStabilizationEnabled) {
            t7 = null;
            break bb0;
        }
        let t8;
        if ($[42] !== conversation?.rovoSpaceId || $[43] !== conversationId || $[44] !== currentChatMode.appFilters || $[45] !== currentChatMode.useCurrentPageContext || $[46] !== currentChatMode.webSearchEnabled || $[47] !== selectedSpace?.id || $[48] !== sendMessage || $[49] !== storeUserMessages) {
            t8 = (prompt_0, handleType_0, agent_0)=>{
                $cb077d0482df7dfa$var$sendEmptyStateMessage({
                    agent: agent_0,
                    appFilters: currentChatMode.appFilters,
                    conversationId: conversationId,
                    handleType: handleType_0,
                    prompt: prompt_0,
                    resolvedSpaceId: (selectedSpace?.id ?? conversation?.rovoSpaceId) && (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined,
                    sendMessage: sendMessage,
                    storeUserMessages: storeUserMessages,
                    useCurrentPageContext: currentChatMode.useCurrentPageContext,
                    webSearchEnabled: currentChatMode.webSearchEnabled
                });
            };
            $[42] = conversation?.rovoSpaceId;
            $[43] = conversationId;
            $[44] = currentChatMode.appFilters;
            $[45] = currentChatMode.useCurrentPageContext;
            $[46] = currentChatMode.webSearchEnabled;
            $[47] = selectedSpace?.id;
            $[48] = sendMessage;
            $[49] = storeUserMessages;
            $[50] = t8;
        } else t8 = $[50];
        const handleSendMessage = t8;
        let t9;
        if ($[51] !== handleSendMessage || $[52] !== renderEmptyStateContent) {
            t9 = renderEmptyStateContent(handleSendMessage);
            $[51] = handleSendMessage;
            $[52] = renderEmptyStateContent;
            $[53] = t9;
        } else t9 = $[53];
        t7 = t9;
    }
    const legacyRenderEmptyState = t7;
    return isRenderStabilizationEnabled ? stabilizedRenderEmptyState : legacyRenderEmptyState;
} : ({ activeTabId: activeTabId, conversation: conversation, conversationAgent: conversationAgent, conversationId: conversationId, conversationMessagesResponseCount: conversationMessagesResponseCount, currentChatMode: currentChatMode, elements: elements, formatMessage: formatMessage, handleChatEmptyLaunch: handleChatEmptyLaunch, handleClickDynamicPrompt: handleClickDynamicPrompt, isConversationAgentDefault: isConversationAgentDefault, isRenderStabilizationEnabled: isRenderStabilizationEnabled, isResizeEnabled: isResizeEnabled, isResizeHeaderThresholdReached: isResizeHeaderThresholdReached, mode: mode, onActiveTabChange: onActiveTabChange, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, product: product, profileData: profileData, runtimeCustomGreeting: runtimeCustomGreeting, selectedPinnedItem: selectedPinnedItem, selectedSpace: selectedSpace, sendMessage: sendMessage, siteId: siteId, storeUserMessages: storeUserMessages })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg)); // Shell-level gate: the tab strip belongs to both spaces and pins, so it renders when
    // either experiment is on. Spaces-specific content is gated inside `ForYouPanel`.
    const isFypTabsEnabled = (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)(); // Lifted from RovoEmptyState so the RovoTabs strip can hide while a nested
    // action menu is open. Reset on surface change to avoid a stuck hidden state.
    const [isInNestedActionView, setIsInNestedActionView] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsInNestedActionView(false);
    }, [
        mode,
        activeTabId,
        conversationId
    ]);
    const webSearchEnabled = currentChatMode.webSearchEnabled;
    const useCurrentPageContext = currentChatMode.useCurrentPageContext;
    const appFilters = currentChatMode.appFilters;
    const selectedSpaceId = selectedSpace?.id;
    const conversationRovoSpaceId = conversation?.rovoSpaceId;
    const handleStabilizedSendMessage = (0, $cozmU.useCallback)((prompt, handleType, agent)=>{
        $cb077d0482df7dfa$var$sendEmptyStateMessage({
            agent: agent,
            appFilters: appFilters,
            conversationId: conversationId,
            handleType: handleType,
            prompt: prompt,
            resolvedSpaceId: (selectedSpaceId ?? conversationRovoSpaceId) && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? selectedSpaceId ?? conversationRovoSpaceId : undefined,
            sendMessage: sendMessage,
            storeUserMessages: storeUserMessages,
            useCurrentPageContext: useCurrentPageContext,
            webSearchEnabled: webSearchEnabled
        });
    }, [
        appFilters,
        conversationRovoSpaceId,
        conversationId,
        selectedSpaceId,
        sendMessage,
        storeUserMessages,
        useCurrentPageContext,
        webSearchEnabled
    ]);
    const renderEmptyStateContent = (0, $cozmU.useCallback)((emptyStateSendMessage)=>{
        const shouldBypassTabsForEmptyLaunch = conversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID) && Boolean(runtimeCustomGreeting);
        const emptyStateContent = !isConversationAgentDefault && conversationAgent ? /*#__PURE__*/ $cozmU.createElement((0, $506b74a7df7281b7$export$3bafafbc17b0f410), {
            agent: conversationAgent,
            addCurrentPageAsContextUserPreference: useCurrentPageContext
        }) : /*#__PURE__*/ $cozmU.createElement((0, $25dff19b7a11bf99$export$19eeab93b3b79fe), {
            mode: mode || (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            conversationId: conversationId,
            sendMessage: emptyStateSendMessage,
            handleClickDynamicPrompt: handleClickDynamicPrompt,
            isResizeEnabled: isResizeEnabled,
            isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
            onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick
        });
        if (shouldBypassTabsForEmptyLaunch) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
            data: {
                conversationHistorySubScreen: 'empty-state',
                conversationMessagesResponseCount: conversationMessagesResponseCount
            }
        }), emptyStateContent);
        if ((mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL || mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR) && activeTabId !== undefined && onActiveTabChange && !selectedSpace && !selectedPinnedItem && isConversationAgentDefault && elements?.shouldShowConversationActions !== false && isFypTabsEnabled) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
            data: {
                conversationHistorySubScreen: 'empty-state-tabs',
                conversationMessagesResponseCount: conversationMessagesResponseCount
            }
        }), /*#__PURE__*/ $cozmU.createElement((0, $9b35088d9023a1dc$export$4dba4f04ea4f19e1), {
            tabs: [
                {
                    id: (0, $eef113145ca4ccce$export$a6818377be660b14),
                    label: formatMessage((0, $b5102ff63ab21a48$export$2e2bcd8739ae039).quickActionsTabLabel),
                    content: /*#__PURE__*/ $cozmU.createElement((0, $25dff19b7a11bf99$export$19eeab93b3b79fe), {
                        mode: mode || (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
                        conversationId: conversationId,
                        sendMessage: emptyStateSendMessage,
                        handleClickDynamicPrompt: handleClickDynamicPrompt,
                        isResizeEnabled: isResizeEnabled,
                        isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
                        onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
                        layout: "quickActionsTab",
                        onNestedViewChange: setIsInNestedActionView
                    })
                },
                {
                    id: (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3),
                    label: formatMessage((0, $b5102ff63ab21a48$export$2e2bcd8739ae039).yourWorkTabLabel),
                    content: /*#__PURE__*/ $cozmU.createElement((0, $a40f11736e2ea035$export$241c63312adc3a1b), {
                        cloudId: siteId,
                        userId: profileData.aaid ?? '',
                        product: product,
                        isActive: activeTabId === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3),
                        onChatEmptyLaunch: handleChatEmptyLaunch
                    })
                }
            ],
            selectedTab: activeTabId,
            onTabChange: onActiveTabChange,
            hideTabStrip: isInNestedActionView
        }));
        return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
            data: {
                conversationHistorySubScreen: 'empty-state',
                conversationMessagesResponseCount: conversationMessagesResponseCount
            }
        }), emptyStateContent);
    }, [
        conversationId,
        handleClickDynamicPrompt,
        conversationAgent,
        isConversationAgentDefault,
        mode,
        isResizeEnabled,
        isResizeHeaderThresholdReached,
        onDiscoverPromptLibraryClick,
        formatMessage,
        siteId,
        profileData,
        activeTabId,
        onActiveTabChange,
        runtimeCustomGreeting,
        handleChatEmptyLaunch,
        isFypTabsEnabled,
        selectedSpace,
        selectedPinnedItem,
        product,
        elements?.shouldShowConversationActions,
        conversationMessagesResponseCount,
        isInNestedActionView,
        useCurrentPageContext
    ]);
    const stabilizedRenderEmptyState = (0, $cozmU.useMemo)(()=>isRenderStabilizationEnabled ? renderEmptyStateContent(handleStabilizedSendMessage) : null, [
        isRenderStabilizationEnabled,
        renderEmptyStateContent,
        handleStabilizedSendMessage
    ]);
    const legacyRenderEmptyState = (0, $cozmU.useMemo)(()=>{
        if (isRenderStabilizationEnabled) return null;
        const handleSendMessage = (prompt_0, handleType_0, agent_0)=>{
            $cb077d0482df7dfa$var$sendEmptyStateMessage({
                agent: agent_0,
                appFilters: currentChatMode.appFilters,
                conversationId: conversationId,
                handleType: handleType_0,
                prompt: prompt_0,
                resolvedSpaceId: (selectedSpace?.id ?? conversation?.rovoSpaceId) && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined,
                sendMessage: sendMessage,
                storeUserMessages: storeUserMessages,
                useCurrentPageContext: currentChatMode.useCurrentPageContext,
                webSearchEnabled: currentChatMode.webSearchEnabled
            });
        };
        return renderEmptyStateContent(handleSendMessage);
    }, [
        isRenderStabilizationEnabled,
        renderEmptyStateContent,
        sendMessage,
        conversationId,
        storeUserMessages,
        currentChatMode,
        selectedSpace,
        conversation
    ]);
    return isRenderStabilizationEnabled ? stabilizedRenderEmptyState : legacyRenderEmptyState;
};














const $64a4e219261b5c3c$export$e063035c51c986b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { conversation: conversation, isRateLimitedState: isRateLimitedState, isThinkingAgentHydrating: isThinkingAgentHydrating, rateLimitedActionType: rateLimitedActionType, shouldUseStableOlderMessageRenderer: shouldUseStableOlderMessageRenderer, stableOlderMessageRenderVersion: stableOlderMessageRenderVersion } = t0;
    const conversationStatus = conversation?.status;
    const conversationTracesCount = conversation?.traces?.length ?? 0;
    const isConversationActivelyGenerating = conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
    let t1;
    if ($[0] !== conversationStatus || $[1] !== conversationTracesCount || $[2] !== isRateLimitedState || $[3] !== isThinkingAgentHydrating || $[4] !== rateLimitedActionType || $[5] !== stableOlderMessageRenderVersion) {
        t1 = {
            conversationStatus: conversationStatus,
            conversationTracesCount: conversationTracesCount,
            isRateLimitedState: isRateLimitedState,
            isThinkingAgentHydrating: isThinkingAgentHydrating,
            olderMessageRenderVersion: stableOlderMessageRenderVersion,
            rateLimitedActionType: rateLimitedActionType
        };
        $[0] = conversationStatus;
        $[1] = conversationTracesCount;
        $[2] = isRateLimitedState;
        $[3] = isThinkingAgentHydrating;
        $[4] = rateLimitedActionType;
        $[5] = stableOlderMessageRenderVersion;
        $[6] = t1;
    } else t1 = $[6];
    const stableLatestMessageRenderVersion = t1;
    const shouldUseStableLatestMessageRenderer = shouldUseStableOlderMessageRenderer && !isConversationActivelyGenerating && conversationTracesCount === 0 && !isThinkingAgentHydrating && !isRateLimitedState;
    let t2;
    if ($[7] !== conversationStatus || $[8] !== conversationTracesCount || $[9] !== isConversationActivelyGenerating || $[10] !== shouldUseStableLatestMessageRenderer || $[11] !== stableLatestMessageRenderVersion) {
        t2 = {
            conversationStatus: conversationStatus,
            conversationTracesCount: conversationTracesCount,
            isConversationActivelyGenerating: isConversationActivelyGenerating,
            shouldUseStableLatestMessageRenderer: shouldUseStableLatestMessageRenderer,
            stableLatestMessageRenderVersion: stableLatestMessageRenderVersion
        };
        $[7] = conversationStatus;
        $[8] = conversationTracesCount;
        $[9] = isConversationActivelyGenerating;
        $[10] = shouldUseStableLatestMessageRenderer;
        $[11] = stableLatestMessageRenderVersion;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ conversation: conversation, isRateLimitedState: isRateLimitedState, isThinkingAgentHydrating: isThinkingAgentHydrating, rateLimitedActionType: rateLimitedActionType, shouldUseStableOlderMessageRenderer: shouldUseStableOlderMessageRenderer, stableOlderMessageRenderVersion: stableOlderMessageRenderVersion })=>{
    const conversationStatus = conversation?.status;
    const conversationTracesCount = conversation?.traces?.length ?? 0;
    const isConversationActivelyGenerating = conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
    const stableLatestMessageRenderVersion = (0, $cozmU.useMemo)(()=>({
            conversationStatus: conversationStatus,
            conversationTracesCount: conversationTracesCount,
            isRateLimitedState: isRateLimitedState,
            isThinkingAgentHydrating: isThinkingAgentHydrating,
            olderMessageRenderVersion: stableOlderMessageRenderVersion,
            rateLimitedActionType: rateLimitedActionType
        }), [
        conversationStatus,
        conversationTracesCount,
        isRateLimitedState,
        isThinkingAgentHydrating,
        rateLimitedActionType,
        stableOlderMessageRenderVersion
    ]);
    const shouldUseStableLatestMessageRenderer = shouldUseStableOlderMessageRenderer && !isConversationActivelyGenerating && conversationTracesCount === 0 && !isThinkingAgentHydrating && !isRateLimitedState;
    return {
        conversationStatus: conversationStatus,
        conversationTracesCount: conversationTracesCount,
        isConversationActivelyGenerating: isConversationActivelyGenerating,
        shouldUseStableLatestMessageRenderer: shouldUseStableLatestMessageRenderer,
        stableLatestMessageRenderVersion: stableLatestMessageRenderVersion
    };
};











const $a77c139a3bfb5661$export$b0a3540e90ea9054 = (conversationMessages, preserveStableGroupIdentity = false)=>{
    const previousGroupsRef = (0, $cozmU.useRef)([]);
    const groups = (0, $cozmU.useMemo)(()=>{
        const nextGroups = [];
        for (const msg of conversationMessages){
            if ((0, $igOtY.isStoreHuman)(msg)) {
                nextGroups.push([
                    msg
                ]);
                continue;
            }
            if (nextGroups.length === 0) nextGroups.push([
                msg
            ]);
            else nextGroups[nextGroups.length - 1].push(msg);
        }
        return nextGroups;
    }, [
        conversationMessages
    ]);
    const messageGroups = (0, $cozmU.useMemo)(()=>{
        if (!preserveStableGroupIdentity) return groups;
        let allGroupsPreserved = groups.length === previousGroupsRef.current.length;
        const nextGroups_0 = groups.map((group, index)=>{
            const previousGroup = previousGroupsRef.current[index];
            if ((0, $bg8wx.areMessageGroupsEqual)(previousGroup, group)) return previousGroup;
            allGroupsPreserved = false;
            return group;
        });
        return allGroupsPreserved ? previousGroupsRef.current : nextGroups_0;
    }, [
        groups,
        preserveStableGroupIdentity
    ]);
    (0, $cozmU.useEffect)(()=>{
        previousGroupsRef.current = messageGroups;
    }, [
        messageGroups
    ]);
    return messageGroups;
};


























const $3bdbec81d09c44df$export$3b1aab3d9e419f7b = ({ conversation: conversation, conversationMessages: conversationMessages })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg), (0, $3z1p5.useAgentsPaginatedByAgentId), (0, $6YdPR.useAssistanceServiceParams));
    // Per-turn agent for the "{agent} is thinking" indicator (text + avatar).
    //
    // The thinking agent is the author of the currently streaming assistant
    // message. The optimistic assistant message is authored with the same agent id
    // the turn was routed to, so the indicator does not need to know whether that
    // author came from the conversation agent or a per-turn override.
    const thinkingAuthorIdentity = (0, $cozmU.useMemo)(()=>{
        if (!(0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) return undefined;
        if (conversation?.lastAgentMessageStatus !== 'IN_PROGRESS') return undefined;
        // Use findLast (not getLastMessageOfType) to avoid allocating an intermediate
        // array on every streaming chunk in this hot-path memo.
        const lastAssistantMessage = (0, $2g97a.findLast)(conversationMessages, (item)=>item.type === 'ASSISTANT');
        if (!lastAssistantMessage) return undefined;
        return (0, $3UaYh.deriveResponseAuthorIdentity)(lastAssistantMessage);
    }, [
        conversation?.lastAgentMessageStatus,
        conversationMessages
    ]);
    const thinkingAuthorAgentId = thinkingAuthorIdentity?.id;
    const thinkingFallbackServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'chatHistoryThinkingAgent'
    });
    const { agent: resolvedThinkingAgent } = (0, $3z1p5.useAgentsPaginatedByAgentId)({
        agentId: thinkingAuthorAgentId,
        assistanceServiceParams: thinkingFallbackServiceParams
    });
    const thinkingAgent = thinkingAuthorIdentity?.isDefault ? undefined : resolvedThinkingAgent;
    return {
        thinkingAgent: thinkingAgent,
        isThinkingAgentHydrating: !!thinkingAuthorAgentId && !thinkingAgent
    };
};






var $5JcMj = parcelRequire("5JcMj");

const $a44cb2e0e577c7e8$export$477a83a98e14f4a4 = ({ olderMessageGroupsCount: olderMessageGroupsCount, isDeepLinkPending: isDeepLinkPending })=>{
    if (isDeepLinkPending || olderMessageGroupsCount === 0) return {
        isVirtualizationEnabled: false
    };
    return {
        isVirtualizationEnabled: olderMessageGroupsCount >= (0, $5JcMj.MINIMUM_OLDER_MESSAGE_GROUPS_TO_VIRTUALIZE)
    };
};


const $c569c29498e22d2e$export$b486b98129efc1c2 = ({ conversationId: conversationId, conversationMessagesCount: conversationMessagesCount, conversationMessagesResponseCount: conversationMessagesResponseCount, isDeepLinkPending: isDeepLinkPending, olderMessageGroupsCount: olderMessageGroupsCount })=>{
    const virtualizationStateRef = (0, $cozmU.useRef)(null);
    const shouldLockVirtualizationState = conversationMessagesResponseCount !== null && conversationMessagesCount > 0;
    if (virtualizationStateRef.current?.conversationId !== conversationId) virtualizationStateRef.current = null;
    if (shouldLockVirtualizationState && virtualizationStateRef.current === null) virtualizationStateRef.current = {
        conversationId: conversationId,
        isVirtualizationEnabled: (0, $a44cb2e0e577c7e8$export$477a83a98e14f4a4)({
            olderMessageGroupsCount: olderMessageGroupsCount,
            isDeepLinkPending: isDeepLinkPending
        }).isVirtualizationEnabled
    };
    const lockedVirtualizationState = virtualizationStateRef.current;
    const isVirtualizationEnabled = lockedVirtualizationState !== null && lockedVirtualizationState.conversationId === conversationId ? lockedVirtualizationState.isVirtualizationEnabled : false;
    return {
        isVirtualizationEnabled: isVirtualizationEnabled
    };
};



var $cvKZ9 = parcelRequire("cvKZ9");

// 3P connection prompt is pinned.
const $309b4ab67835e7fc$var$NO_APP_CONNECTION_PROMPT_APPS = [];
const $309b4ab67835e7fc$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _1mT5xdRAKS",
    scrollingDiv: "_4bt5LAIZbP _2WAcuGIZbP _39xV02N91d _0Of8r2Pgdg _1wydGW5zaO _2Zuz6Q5zaO _1Znuxb5zaO",
    animationTransitionContainerFS: "_39xV02N91d",
    animationTransitionContainer: "_39xV02N91d _0jFU0VN91d",
    animationTransitionContainerMiniModal: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w",
    containerFlex: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $309b4ab67835e7fc$var$HideWhenThinkDeeperInProgress = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { messageId: messageId, children: children } = t0;
    let t1;
    if ($[0] !== messageId) {
        t1 = {
            messageId: messageId
        };
        $[0] = messageId;
        $[1] = t1;
    } else t1 = $[1];
    const { isThinkingDeeperRunning: isThinkingDeeperRunning } = (0, $2556adf63acd29a5$export$8ffe29bbe1f25b54)(t1);
    if (isThinkingDeeperRunning) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $501c3704274e8ca7$export$b7b8c16424783afd), null);
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    let t2;
    if ($[3] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ messageId: messageId, children: children })=>{
    const { isThinkingDeeperRunning: isThinkingDeeperRunning } = (0, $2556adf63acd29a5$export$8ffe29bbe1f25b54)({
        messageId: messageId
    });
    if (isThinkingDeeperRunning) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $501c3704274e8ca7$export$b7b8c16424783afd), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $309b4ab67835e7fc$var$ActiveResponseHatHandoff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { storeAssistant: storeAssistant, previousAssistantAuthor: previousAssistantAuthor, shouldEnableAgentResponseHat: shouldEnableAgentResponseHat, isConversationActivelyGenerating: isConversationActivelyGenerating, canRenderAfterThinking: canRenderAfterThinking, hasAnswerContent: hasAnswerContent } = t0;
    const { assistanceServiceConfig: assistanceServiceConfig, experienceId: experienceId, productHeader: productHeader, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    assistanceServiceConfig?.baseUrl;
    assistanceServiceConfig?.headers;
    assistanceServiceConfig?.channelId;
    const t1 = assistanceServiceConfig?.baseUrl;
    const t2 = assistanceServiceConfig?.headers;
    const t3 = assistanceServiceConfig?.channelId;
    let t4;
    if ($[0] !== experienceId || $[1] !== productHeader || $[2] !== siteId || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
        t4 = {
            baseUrl: t1,
            headers: t2,
            channelId: t3,
            experienceId: experienceId,
            product: productHeader,
            siteId: siteId,
            touchpointSource: productHeader
        };
        $[0] = experienceId;
        $[1] = productHeader;
        $[2] = siteId;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const assistanceServiceParams = t4;
    const t5 = shouldEnableAgentResponseHat && isConversationActivelyGenerating;
    let t6;
    if ($[7] !== assistanceServiceParams || $[8] !== canRenderAfterThinking || $[9] !== hasAnswerContent || $[10] !== isConversationActivelyGenerating || $[11] !== previousAssistantAuthor || $[12] !== storeAssistant || $[13] !== t5) {
        t6 = {
            storeAssistant: storeAssistant,
            previousAssistantAuthor: previousAssistantAuthor,
            shouldEnableAgentResponseHat: t5,
            isConversationActivelyGenerating: isConversationActivelyGenerating,
            canRenderAfterThinking: canRenderAfterThinking,
            hasAnswerContent: hasAnswerContent,
            assistanceServiceParams: assistanceServiceParams
        };
        $[7] = assistanceServiceParams;
        $[8] = canRenderAfterThinking;
        $[9] = hasAnswerContent;
        $[10] = isConversationActivelyGenerating;
        $[11] = previousAssistantAuthor;
        $[12] = storeAssistant;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    const responseHatState = (0, $b6ezN.useResponseHatState)(t6);
    if (!responseHatState.shouldRender) return null;
    let t7;
    if ($[15] !== responseHatState.identityAccountId || $[16] !== responseHatState.isDefaultRovo || $[17] !== responseHatState.isHydrating) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGWMb.AgentResponseHat), {
            testId: "active-response-hat-handoff",
            isDefaultRovo: responseHatState.isDefaultRovo,
            agentIdentityAccountId: responseHatState.identityAccountId,
            isIdentityHydrating: responseHatState.isHydrating
        });
        $[15] = responseHatState.identityAccountId;
        $[16] = responseHatState.isDefaultRovo;
        $[17] = responseHatState.isHydrating;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ storeAssistant: storeAssistant, previousAssistantAuthor: previousAssistantAuthor, shouldEnableAgentResponseHat: shouldEnableAgentResponseHat, isConversationActivelyGenerating: isConversationActivelyGenerating, canRenderAfterThinking: canRenderAfterThinking, hasAnswerContent: hasAnswerContent })=>{
    const { assistanceServiceConfig: assistanceServiceConfig, experienceId: experienceId, productHeader: productHeader, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const assistanceServiceParams = (0, $cozmU.useMemo)(()=>({
            baseUrl: assistanceServiceConfig?.baseUrl,
            headers: assistanceServiceConfig?.headers,
            channelId: assistanceServiceConfig?.channelId,
            experienceId: experienceId,
            product: productHeader,
            siteId: siteId,
            touchpointSource: productHeader
        }), [
        assistanceServiceConfig?.baseUrl,
        assistanceServiceConfig?.headers,
        assistanceServiceConfig?.channelId,
        experienceId,
        productHeader,
        siteId
    ]);
    const responseHatState = (0, $b6ezN.useResponseHatState)({
        storeAssistant: storeAssistant,
        previousAssistantAuthor: previousAssistantAuthor,
        shouldEnableAgentResponseHat: shouldEnableAgentResponseHat && isConversationActivelyGenerating,
        isConversationActivelyGenerating: isConversationActivelyGenerating,
        canRenderAfterThinking: canRenderAfterThinking,
        hasAnswerContent: hasAnswerContent,
        assistanceServiceParams: assistanceServiceParams
    });
    if (!responseHatState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGWMb.AgentResponseHat), {
        testId: "active-response-hat-handoff",
        isDefaultRovo: responseHatState.isDefaultRovo,
        agentIdentityAccountId: responseHatState.identityAccountId,
        isIdentityHydrating: responseHatState.isHydrating
    });
};
function $309b4ab67835e7fc$var$isValidProjectContext(value) {
    if (value == null || typeof value !== 'object') return false;
    const obj = value; // A valid context requires a non-empty ID and name.
    // projectUrl is optional — Rovo Spaces do not have a URL.
    return typeof obj.projectId === 'string' && obj.projectId !== '' && typeof obj.projectName === 'string' && obj.projectName !== '';
}
const $309b4ab67835e7fc$export$a87d4bb9f70db482 = ({ conversationId: conversationId, mode: mode, handleClickDynamicPrompt: handleClickDynamicPrompt, screenType: screenType, closeInlineBrowse: closeInlineBrowse, isResizeEnabled: isResizeEnabled = false, isResizeHeaderThresholdReached: isResizeHeaderThresholdReached = false, onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick, product: product, onOpenMemoryManagement: onOpenMemoryManagement, onActiveTabChange: onActiveTabChange, activeTabId: activeTabIdProp, showFlag: showFlag, selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg), (0, $5wAPd.useConversation), (0, $n71o5.useChatStore), (0, $lTU4O.useUserPreferences), (0, $aQWBL.useChatModeState), (0, $6hUo1.StoreAssistantView), (0, $b9daec6aed55b471$export$6a7b965325ceca4e), (0, $9bad3f59ef13b10c$export$12d255d5177ce7be), (0, $iW40i.useChatMessages), (0, $e28f01433a379fa9$export$c90b1dea2397805f));
    const setChatInputPlaceholderOverride = (0, $aBUXY.usePlaceholderOverrideDispatch)();
    const { siteId: siteId, profileData: profileData } = (0, $eKjv9.useGlobalConfig)();
    const [{ customGreeting: runtimeCustomGreeting }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const [{ activeTabId: currentActiveTabId }] = (0, $bGNkz.useActiveTabSelector)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const { setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setEmptyChatLaunch: setEmptyChatLaunch, setSelectedSpace: setSelectedSpace, setSelectedPinnedItem: setSelectedPinnedItem, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { setChatMode: setChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { fullScreen: fullScreen, elements: elements } = (0, $dSCNl.useUIConfig)(); // Cheap store read — used together with the streaming + experiment gate
    // checks below to decide whether to mount the connector recommendation card.
    // Only when all conditions pass do we instantiate StoreConnectorRecommendation,
    // which sets up the OAuth flow.
    const recommendationConnector = (0, $lTaB7.useSmartLinkConnector)();
    const { conversation: conversation, selectedAgent: conversationAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    }); // Clear placeholder override when a message is sent
    (0, $cozmU.useEffect)(()=>{
        if (conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse) setChatInputPlaceholderOverride(undefined);
    }, [
        conversation?.status,
        setChatInputPlaceholderOverride
    ]);
    const [, { setPlaceholder: setPlaceholder }] = (0, $iDlFY.usePlaceholderStore)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleSkillSelect = (0, $cozmU.useCallback)((skill)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoChatSkillSelected',
            attributes: {
                slashCommand: skill.slug,
                skillProductKey: skill.product,
                skillSelectionSource: 'inlineBrowse'
            }
        }); // Record the selection source on the AnalyticsPropertiesContext so the chat
        // input can attach it to the next `aiResult viewed` event.
        setAnalyticsPropertiesWithoutRerender({
            skillSelectionSource: 'inlineBrowse'
        });
        setPlaceholder({
            prompt: '',
            adfDocument: (0, $8lhhf.createSkillAdf)(skill),
            type: 'generic',
            selectionStartIndex: 1,
            selectionEndIndex: 1,
            insertAtCursor: true
        });
        closeInlineBrowse();
    }, [
        setPlaceholder,
        setAnalyticsPropertiesWithoutRerender,
        closeInlineBrowse,
        sendAnalyticsEvent
    ]);
    const { getChat: getChat, sendMessage: sendMessage, answerNow: answerNow, setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)(); /** Handles "Chat" click on a space card, or on a pinned Jira Epic/Atlas Goal/Atlas Project —
                              * writes entity context to stores and, for spaces only, navigates to the space landing page. */ 
    const handleChatEmptyLaunch = (0, $cozmU.useCallback)((params)=>{
        const projectContext = params.selectedPinnedItem ? {
            projectId: params.selectedPinnedItem.ari,
            projectName: params.selectedPinnedItem.name,
            projectUrl: params.selectedPinnedItem.url
        } : {
            projectId: params.spaceId,
            projectName: params.spaceName,
            projectUrl: '',
            spaceId: params.spaceId
        };
        const validProjectContext = $309b4ab67835e7fc$var$isValidProjectContext(projectContext) ? projectContext : undefined; // Space-scoped launches suppress `customGreeting` to match `handleSelectSpace`
        // in `rovo-side-navigation` / `browse-spaces-view`. Otherwise the chat-header
        // back button short-circuits on `isEmptyChatLaunchActive` and forces users to
        // click back twice — once to clear the greeting, once to exit the space.
        const isSpaceScopedLaunch = !params.selectedPinnedItem && Boolean(params.spaceId); // Write project context to the chat-context store so that
        // sendMessage includes it in the backend request payload
        setAIFeatureContext({
            contextKey: 'projectContext',
            setContext: (_)=>validProjectContext ?? {}
        }); // Set the space bar in the chat input — same state as clicking a space in the nav menu.
        // `sources` is forwarded so create-space-from-thread launches seed the originating
        // thread's sources onto the space immediately (for display), matching the side-nav
        // create flow (`rovo-side-navigation` → `handleSelectSpace`). For a pinned Epic/Goal/
        // Project, set the pinned-entity slot instead — the two are mutually exclusive, so
        // each branch clears the other to avoid stale state from a prior launch.
        if (params.selectedPinnedItem) {
            setSelectedPinnedItem(params.selectedPinnedItem);
            setSelectedSpace(undefined);
        } else {
            setSelectedSpace({
                id: params.spaceId,
                name: params.spaceName,
                emoji: params.spaceEmoji,
                sources: params.sources,
                entryPoint: 'zeroQuery'
            });
            setSelectedPinnedItem(undefined);
        }
        setEmptyChatLaunch({
            ...!isSpaceScopedLaunch && params.greetingTitle ? {
                customGreeting: {
                    title: params.greetingTitle,
                    iconSrc: params.iconSrc,
                    iconSrcDark: params.iconSrcDark
                }
            } : {},
            customConversationActions: params.customConversationActions ?? [],
            replaceProviderActions: params.replaceProviderActions,
            projectContext: validProjectContext,
            skillRegistryTags: params.skillRegistryTags
        });
        if (isSpaceScopedLaunch && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) {
            // Save the tab the user was actually on so `resetToPreviousTab()` (the
            // header back button) returns them there. Then render the launched chat on
            // Suggestions (matching `handleSelectSpace`) so the composer isn't hidden by
            // MiniModalForYouThreadsListHidesInput on the For You tab.
            setPreviousTabId(currentActiveTabId);
            setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
            setActiveMenu('space-landing');
        } else {
            if (params.selectedPinnedItem) {
                // A pinned-entity launch stays on activeMenu: 'none' (no dedicated landing
                // page), but still needs activeTabId reset to Suggestions — otherwise it's
                // left on whatever tab was active before the click (e.g. For You), RovoTabs
                // renders that stale tab instead of the Suggestions tab actions render under,
                // and the starter cards are unclickable / the composer is hidden.
                setPreviousTabId(currentActiveTabId);
                setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
            }
            setActiveMenu('none');
        } // Set the context banner preference for this conversation.
        setChatMode((0, $4m5jb.EMPTY_CONVERSATION_ID), {
            useCurrentPageContext: elements?.shouldShowContextBanner !== false
        });
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
    }, [
        elements?.shouldShowContextBanner,
        currentActiveTabId,
        setAIFeatureContext,
        setSelectedSpace,
        setSelectedPinnedItem,
        setActiveTabId,
        setPreviousTabId,
        setEmptyChatLaunch,
        setActiveMenu,
        setChatMode,
        setSelectedConversation
    ]);
    const sidebarActionsStaggerAnimation = (0, $29a7474eaece6ae8$export$2f0833d20bbf4b1c)(); // Apply mini modal resize styles when in mini modal mode and resize experiment is enabled
    const useMiniModalStyles = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL && isResizeEnabled;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [{ conversationError: conversationError }] = (0, $k4g8h.useChatSignals)();
    const isFullScreenErrorState = (0, $k4g8h.isFullScreenError)(conversationError);
    const isRateLimitedState = (0, $k4g8h.isRateLimited)(conversationError);
    const rateLimitedActionType = (0, $k4g8h.getRateLimitedActionType)(conversationError);
    const { setConversationError: setConversationError } = (0, $k4g8h.useChatSignalsActions)();
    const [rawConversationMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    }); // Apply message filters to remove unwanted messages (e.g. "Action executed")
    const conversationMessages = (0, $cozmU.useMemo)(()=>{
        return (0, $f6db5428181909aa$export$c9b026fc0258459)(rawConversationMessages);
    }, [
        rawConversationMessages
    ]);
    const conversationMessagesResponseCount = !conversation || !Array.isArray(rawConversationMessages) || conversation.status === (0, $igOtY.CHAT_STORE_STATUS).loadingChat && rawConversationMessages.length === 0 ? null : rawConversationMessages.length;
    const currentChatMode = (0, $aQWBL.useChatModeState)(conversationId);
    const { activeAction: activeAction, clearActiveAction: clearActiveAction } = (0, $5BOJB.useActiveAction)();
    const currentLocation = (0, $hd4Ag.useWindowLocation)();
    const isConversationAgentDefault = !conversationAgent || Boolean(conversationAgent.is_default);
    const { thinkingAgent: thinkingAgent, isThinkingAgentHydrating: isThinkingAgentHydrating } = (0, $3bdbec81d09c44df$export$3b1aab3d9e419f7b)({
        conversation: conversation,
        conversationMessages: conversationMessages
    });
    const isThinkingAgentDefault = !thinkingAgent || thinkingAgent?.is_default;
    const { messageIdSelectedForPreview: messageIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const { clearTargetTaskMessageId: clearTargetTaskMessageId } = (0, $3TxKn.useChatStoreActions)();
    const targetTaskMessageId = conversation?.targetTaskMessageId ?? null;
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const { getMessageResearchById: getMessageResearchById } = (0, $guRLk.useChatMessageResearchActions)(); // Cheap Set<messageId> derived once per store update — avoids N× getMessageResearchById
    // calls in renderMessage for long conversation histories.
    const messageIdsWithResearchData = (0, $82bc06d315ddae83$export$629bc20f8bcb03d1)();
    const chatHistoryContainerRef = (0, $cozmU.useRef)(null);
    const { scrollToBottom: scrollToBottom, scrollToLatestMessage: scrollToLatestMessage, maintainScrollHeight: maintainScrollHeight } = (0, $64475aea4a0133e9$export$c2131e938c7a933c)({
        containerRef: chatHistoryContainerRef
    });
    const lastMessageGroupRef = (0, $cozmU.useRef)(null);
    const hasMounted = (0, $cozmU.useRef)(false);
    const isRenderStabilizationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    const shouldUseStableOlderMessageRenderer = isRenderStabilizationEnabled; // A Rovodal-embedded chat shares the global store with the main chat, so re-fetching the
    // already-loaded conversation on mount just blanks the list and flashes a "Reloading chat"
    // spinner — skip it.
    const isInsideRovodal = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $3617fdb62236701e$export$8d7d1f2543f67b)) && (0, $cXtTj.default).getExperimentValue('rovo_jira_skip_refetch_embedded_rovodal_chat', 'isEnabled', false) === true;
    const isSharedChatContinuationPillEnabled = (0, $cXtTj.default).getExperimentValue('rovo_conversation_sharing', 'isEnabled', false);
    const messageGroups = (0, $a77c139a3bfb5661$export$b0a3540e90ea9054)(conversationMessages, isRenderStabilizationEnabled);
    const sharedChatContinuationPillTarget = (0, $cozmU.useMemo)(()=>isSharedChatContinuationPillEnabled ? (0, $4baca647668a1bde$export$5b5fcd2c25501720).getTarget(conversationMessages) : undefined, [
        conversationMessages,
        isSharedChatContinuationPillEnabled
    ]);
    const olderMessageGroupsCount = Math.max(0, messageGroups.length - 1);
    const olderMessageGroups = (0, $cozmU.useMemo)(()=>messageGroups.length > 1 ? messageGroups.slice(0, -1) : [], [
        messageGroups
    ]);
    const pendingScrollToMessageIdRef = (0, $cozmU.useRef)(null);
    const isDeepLinkPending = !!targetTaskMessageId || !!pendingScrollToMessageIdRef.current;
    const [scrollToBottomGeneration, setScrollToBottomGeneration] = (0, $cozmU.useState)(0);
    const [liveRegionText, setLiveRegionText] = (0, $cozmU.useState)((0, $iDrrr.fg)('rovo_chat_trace_aria_live_updates') ? '' : undefined);
    const { isVirtualizationEnabled: isVirtualizationEnabled } = (0, $c569c29498e22d2e$export$b486b98129efc1c2)({
        conversationId: conversationId,
        conversationMessagesCount: conversationMessages.length,
        conversationMessagesResponseCount: conversationMessagesResponseCount,
        isDeepLinkPending: isDeepLinkPending,
        olderMessageGroupsCount: olderMessageGroupsCount
    });
    (0, $cvKZ9.useLayoutInitialBottomAnchor)({
        enabled: !isVirtualizationEnabled && messageGroups.length > 0 && !isDeepLinkPending,
        conversationId: conversationId,
        totalSize: conversationMessages.length,
        containerRef: chatHistoryContainerRef,
        scrollToBottomGeneration: scrollToBottomGeneration
    }); // Keep track of whether the skills screen has been opened once to avoid re-rendering the skills component
    const hasOpenedSkillsOnceRef = (0, $cozmU.useRef)(false);
    if (screenType === 'skills') hasOpenedSkillsOnceRef.current = true;
     // Keep track of whether the prompt library screen has been opened once
    const hasOpenedPromptLibraryOnceRef = (0, $cozmU.useRef)(false);
    if (screenType === 'prompt-library') hasOpenedPromptLibraryOnceRef.current = true;
    const humanMessages = (0, $cozmU.useMemo)(()=>conversationMessages.filter((msg)=>(0, $igOtY.isStoreHuman)(msg)), [
        conversationMessages
    ]);
    const lastHumanMessage = humanMessages && humanMessages.length > 0 ? humanMessages[humanMessages.length - 1] : undefined;
    const lastHumanMessageId = lastHumanMessage?.content?.id ? String(lastHumanMessage?.content?.id) : 'NO_HUMAN_MESSAGE';
    const lastHumanMessageContent = lastHumanMessage?.content?.content;
    const lastHumanMessageContentRenderVersion = (0, $cozmU.useMemo)(()=>(0, $fd913f2789212bc1$export$eea91cf823ba359c)(lastHumanMessageContent), [
        lastHumanMessageContent
    ]); // Constant for the whole render; used by the edit-pencil gate below to extend
    // the affordance to "send didn't complete" terminal states (user Stop,
    // network/server error, browser-killed background request).
    const lastSendWasInterrupted = conversation?.lastAgentMessageStatus === 'CANCELLED' || conversation?.lastAgentMessageStatus === 'FAILED';
    const firstSessionAssistantMessage = (0, $cozmU.useMemo)(()=>conversationMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && !msg.isHistorical), [
        conversationMessages
    ]);
    const firstSessionAssistantMessageId = firstSessionAssistantMessage?.content?.message?.message?.id;
    const shouldEnableAgentResponseHat = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents'); // Gate-on uses the routed streaming author from `useStreamingThinkingAgent`.
    // Gate-off preserves the previous conversation/header-agent label behavior.
    const thinkingLabelAgent = shouldEnableAgentResponseHat ? thinkingAgent : conversationAgent;
    const isThinkingLabelAgentDefault = !thinkingLabelAgent || thinkingLabelAgent.is_default; // The mention-agent experiment controls both response hats and greying out
    // inactive agent @mentions in sent prompts.
    const shouldEnableInactiveMentionGreying = shouldEnableAgentResponseHat; // Read once per render (not once per message inside renderMessage) so the Statsig exposure event fires at most once per ChatHistory render.
    const isEditLastUserPromptEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_edit_last_user_prompt_exp', 'isEnabled', false); // Response hats mark author transitions between assistant messages. The first
    // assistant response has no previous assistant author and therefore no hat.
    const tracesForLoading = (0, $cozmU.useMemo)(()=>conversation?.traces?.map((trace)=>({
                title: trace.messageContent,
                status: trace?.status ?? 'success'
            })) ?? [], [
        conversation?.traces
    ]); // The assistant message the live thinking indicator is rendered for. Used to
    // announce the same dynamic thinking text via the ARIA live region below.
    const lastAssistantMessage = (0, $cozmU.useMemo)(()=>{
        const lastAssistantIndex = (0, $jcJSP.findLastIndex)(conversationMessages, (0, $igOtY.isStoreAssistant));
        return lastAssistantIndex >= 0 ? conversationMessages[lastAssistantIndex] : undefined;
    }, [
        conversationMessages
    ]);
    const previousAssistantAuthorByMessageId = (0, $cozmU.useMemo)(()=>{
        const previousByMessageId = new Map();
        if (!shouldEnableAgentResponseHat) return previousByMessageId;
        let previousAssistantAuthor;
        for (const message of conversationMessages){
            if (!(0, $igOtY.isStoreAssistant)(message)) continue;
            if (previousAssistantAuthor) previousByMessageId.set(message.content.message.message.id, previousAssistantAuthor);
            previousAssistantAuthor = (0, $3UaYh.deriveResponseAuthorIdentity)(message);
        }
        return previousByMessageId;
    }, [
        conversationMessages,
        shouldEnableAgentResponseHat
    ]); // Maps each human message to the agent that responded to it, paired by
    // document order. Used to grey out inactive agent @mentions in sent prompts.
    // Gated behind the `rovo_chat_mention_agents` experiment via
    // `shouldEnableInactiveMentionGreying`.
    const respondedAgentIdByHumanMessageId = (0, $cozmU.useMemo)(()=>(0, $fd834c58c02fb2c6$export$e81ab47967df822d)(conversationMessages, shouldEnableInactiveMentionGreying), [
        conversationMessages,
        shouldEnableInactiveMentionGreying
    ]); // Personality thinking-verb, gated by the `rovo_chat_personality_presets` and
    // `rovo_chat_personality_thinking_verb` experiments. One verb is chosen per turn
    // (keyed off the human message being answered) and rendered by both the main
    // thinking indicator (`getRovoThinkingState`) and the research paths, so the label
    // stays consistent within a spell and across reasoning modes. Gate-off or no
    // preset resolves to `undefined`, and every path keeps its existing fallback.
    const personalityThinkingServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'chat-history'
    });
    const isPersonalityThinkingVerbEligible = (conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse) && !isThinkingAgentHydrating && isThinkingLabelAgentDefault;
    const { verbMessage: personalityThinkingVerb } = (0, $c85048001c25be99$export$5ff880ed6740bd17)({
        enabled: isPersonalityThinkingVerbEligible,
        spellId: lastHumanMessageId === 'NO_HUMAN_MESSAGE' ? undefined : lastHumanMessageId,
        assistanceServiceParams: personalityThinkingServiceParams
    }); // Pre-resolved for the research path, which renders the default Rovo verb only.
    const personalityThinkingText = personalityThinkingVerb ? formatMessage(personalityThinkingVerb) : undefined;
    const getRovoThinkingState = (message, messageResearch)=>{
        const messageId = message.content?.message?.message?.id; // When messageResearch is explicitly null the caller already confirmed no data exists —
        // skip the store lookup. When undefined, fall back to fetching (thinkingText call site).
        const resolvedMessageResearch = messageResearch !== undefined ? messageResearch : messageId ? getMessageResearchById({
            messageId: messageId
        }) : undefined;
        const hasThinkDeeperTriggered = resolvedMessageResearch?.hasThinkDeeperTriggered ?? false;
        const isResearchStoreInitialized = Object.keys(resolvedMessageResearch?.researchPlans ?? {}).length > 0 || Object.keys(resolvedMessageResearch?.steps ?? {}).length > 0;
        const thinkDeeperTriggered = hasThinkDeeperTriggered || currentChatMode.reasoningMode === 'think-deeper';
        let thinkingAgentName = (0, $d3ced1e712e9d684$export$e799f6dbcac057ae);
        if (!isThinkingLabelAgentDefault) thinkingAgentName = thinkingLabelAgent.name?.trim() || (0, $d3ced1e712e9d684$export$e799f6dbcac057ae);
        let thinkingText = '';
        if (!isThinkingAgentHydrating) {
            if (isThinkingLabelAgentDefault && personalityThinkingText) // Personality flavors the default Rovo verb only; custom agents keep
            // "{agentName} is thinking".
            thinkingText = personalityThinkingText;
            else if (thinkDeeperTriggered) thinkingText = formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).thinkDeeperThinking);
            else thinkingText = formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).rovoIsThinking, {
                name: thinkingAgentName
            });
        }
        return {
            hasThinkDeeperTriggered: hasThinkDeeperTriggered,
            isResearchStoreInitialized: isResearchStoreInitialized,
            thinkingText: thinkingText,
            researchCompleted: resolvedMessageResearch?.researchCompleted ?? false
        };
    };
    const viewDeadAirBroker = (0, $ef8883bd884fedd1$export$a4761dc3d9967545)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            viewDeadAirBroker?.finish('unmounted');
        };
    }, [
        viewDeadAirBroker
    ]);
    const previousLastHumanMessageId = (0, $cozmU.useRef)(null);
    const previousChatStatus = (0, $cozmU.useRef)(undefined);
    const previousMessagesLength = (0, $cozmU.useRef)(0);
    const lastConversationIdThatHasChatLoaded = (0, $cozmU.useRef)(undefined); // The connector recommendation pinned for this chat-history render. Set on
    // the first non-null connector for the current conversation so the card
    // can't unmount on success, swap apps, or appear later in the render
    // lifecycle.
    const [pinnedRecommendationConnector, setPinnedRecommendationConnector] = (0, $cozmU.useState)(null);
    const recommendationConnectorForRender = pinnedRecommendationConnector?.conversationId === conversationId ? pinnedRecommendationConnector.connector : null; // Pin the first non-null connector recommendation seen during this render
    // lifecycle (see state declaration above for full rationale).
    (0, $cozmU.useEffect)(()=>{
        if (!recommendationConnector) return;
        setPinnedRecommendationConnector((previousConnector)=>previousConnector?.conversationId === conversationId ? previousConnector : {
                conversationId: conversationId,
                connector: recommendationConnector
            });
    }, [
        conversationId,
        recommendationConnector
    ]); // The 3P suggested-prompts connection prompt's apps, latched per conversation
    // so the in-thread prompt survives new messages and can't render in another
    // conversation (see the hook for the full rationale).
    const appConnectionPromptAppsForRender = (0, $9b87174eb88b5e91$export$27d9050dbd34f414)(conversationId); // Post-connect effects (confirmation message + enabling the app in the sources
    // filter), keyed off the same latched apps so they keep firing after the banner
    // store is cleared.
    (0, $6283699142f02f4d$export$f754cb3a41a8893e)({
        conversationId: conversationId,
        apps: appConnectionPromptAppsForRender ?? $309b4ab67835e7fc$var$NO_APP_CONNECTION_PROMPT_APPS
    });
    (0, $cozmU.useEffect)(()=>{
        if (conversationId) {
            lastConversationIdThatHasChatLoaded.current = conversationId;
            if (targetTaskMessageId) {
                pendingScrollToMessageIdRef.current = targetTaskMessageId;
                clearTargetTaskMessageId({
                    conversationId: conversationId
                });
            }
            getChat({
                conversationId: conversationId,
                messageIdSelectedForPreview: messageIdSelectedForPreview,
                ...(isRenderStabilizationEnabled || isInsideRovodal) && !targetTaskMessageId && !messageIdSelectedForPreview ? {
                    skipIfConversationAlreadyLoaded: true
                } : {}
            });
        }
    }, [
        conversationId,
        getChat,
        isRenderStabilizationEnabled,
        isInsideRovodal,
        messageIdSelectedForPreview,
        targetTaskMessageId,
        clearTargetTaskMessageId
    ]);
    let finalScreenType = screenType;
    if (!conversation || !conversationMessages.length) {
        if (// even though the chat status is not loading yet, if there is a change in conversationId,
        // we know we are going to be in loading state because of chat loading effect above,
        // so stick to loading state to begin with instead of starting with empty and then jumping to loading
        lastConversationIdThatHasChatLoaded.current !== conversationId && conversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) finalScreenType = 'loading';
    }
    (0, $cozmU.useEffect)(()=>{
        // Scroll when user enter the new message in the same conversation
        const shouldScrollToNextMessage = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse && previousLastHumanMessageId.current !== lastHumanMessageId; // Scroll to bottom when user enter the conversation for the first time,
        // unless we have a specific target message to scroll to.
        const isTransitioningToIdle = previousChatStatus.current === (0, $igOtY.CHAT_STORE_STATUS).loadingChat && conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle;
        const shouldScrollToBottom = isTransitioningToIdle && !pendingScrollToMessageIdRef.current;
        previousLastHumanMessageId.current = lastHumanMessageId;
        previousChatStatus.current = conversation?.status;
        if (isTransitioningToIdle && pendingScrollToMessageIdRef.current) {
            const targetId = pendingScrollToMessageIdRef.current;
            pendingScrollToMessageIdRef.current = null;
            setTimeout(()=>{
                const el = chatHistoryContainerRef.current?.querySelector(`[data-message-id="${targetId}"]`);
                if (el) el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                else scrollToBottom({
                    smooth: false
                });
            }, 0);
            return;
        }
        if (!shouldScrollToNextMessage && !shouldScrollToBottom) return;
        if (isVirtualizationEnabled) setScrollToBottomGeneration((prev)=>prev + 1);
        scrollToBottom({
            smooth: shouldScrollToNextMessage
        });
    }, [
        conversationId,
        lastHumanMessageId,
        conversation?.status,
        scrollToBottom,
        isVirtualizationEnabled
    ]); // Scroll to the top of latest message when status changes to typingResponse
    (0, $cozmU.useEffect)(()=>{
        if (conversation?.status !== (0, $igOtY.CHAT_STORE_STATUS).typingResponse) return;
        scrollToLatestMessage({
            smooth: true
        });
    }, [
        conversation?.status,
        scrollToLatestMessage
    ]); // The dynamic thinking text shown on screen for the last assistant message
    // (e.g. "Thinking deeply and analyzing" or "{agent} is thinking"). Kept in a
    // ref so the live-region effect can announce the same text on the start
    // transition without re-running (and re-announcing) on every render.
    //
    // When a last assistant message exists we mirror exactly what
    // `getRovoThinkingState` renders — including the intentionally empty string
    // while the thinking agent is hydrating, so we never misattribute the turn to
    // the default "Rovo" name. Only when there is no assistant message yet (the
    // indicator is not derived from any message) do we fall back to the default
    // so the start of a turn is still announced.
    const thinkingText = lastAssistantMessage && (0, $iDrrr.fg)('rovo_chat_trace_aria_live_updates') ? getRovoThinkingState(lastAssistantMessage).thinkingText : formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).rovoIsThinking, {
        name: (0, $d3ced1e712e9d684$export$e799f6dbcac057ae)
    });
    const thinkingTextRef = (0, $cozmU.useRef)(thinkingText);
    thinkingTextRef.current = thinkingText; // Announce AI response generation status to screen readers via an ARIA live region.
    // Only two transitions are announced (start and finish) to avoid overloading
    // screen readers during streaming. Focus is never moved here.
    const isGeneratingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo_chat_trace_aria_live_updates')) return;
        const isGenerating = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
        if (isGenerating && !isGeneratingRef.current) // Announce the thinking text rendered on screen, falling back to a generic
        // message if the agent name hasn't hydrated yet (which would produce an
        // empty string and silently drop the screen reader announcement).
        setLiveRegionText(thinkingTextRef.current || formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).rovoIsThinking, {
            name: (0, $d3ced1e712e9d684$export$e799f6dbcac057ae)
        }));
        else if (!isGenerating && isGeneratingRef.current) setLiveRegionText(formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).responseComplete));
        isGeneratingRef.current = isGenerating;
    }, [
        conversation?.status,
        formatMessage
    ]); // Maintain scroll position when a follow-up message is rendered
    (0, $cozmU.useEffect)(()=>{
        const currentLength = conversationMessages.length;
        if (currentLength > previousMessagesLength.current) maintainScrollHeight();
        previousMessagesLength.current = currentLength;
    }, [
        conversationMessages,
        maintainScrollHeight
    ]);
    (0, $cozmU.useEffect)(()=>{
        //Only run action reset on location change, not first mount
        if (hasMounted.current) clearActiveAction();
        else hasMounted.current = true;
        return ()=>{
            clearActiveAction();
        };
    }, [
        currentLocation,
        clearActiveAction
    ]);
    const handleResendMessage = (0, $bCuI8.useResendMessage)(conversationId);
    const handleEditAndResendMessage = (0, $bCuI8.useResendMessage)(conversationId, {
        mode: 'edit'
    });
    const { handleA2UIAction: handleA2UIAction } = (0, $75a2162b9fe8b765$export$5c1893b49d2a8870)({
        conversationId: conversationId,
        agentId: !conversationAgent ? undefined : conversationAgent?.id,
        webSearchEnabled: currentChatMode.webSearchEnabled,
        useCurrentBrowsingContext: currentChatMode.useCurrentPageContext,
        appFilters: currentChatMode.appFilters
    });
    const handleAuthLinkClicked = (0, $cozmU.useCallback)((authType, messageId)=>{
        const messageIndex = conversationMessages.findIndex((msg)=>(0, $bxkJA.isAssistantMessage)(msg) && msg.id === messageId);
        const lastAgentMessageIndex = (0, $jcJSP.findLastIndex)(conversationMessages, (0, $bxkJA.isAssistantMessage));
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'actionAuthLink',
            attributes: {
                authType: authType,
                agentMessageIndex: messageIndex,
                lastAgentMessageIndex: lastAgentMessageIndex
            }
        });
    }, [
        conversationMessages,
        sendAnalyticsEvent
    ]);
    const reportFollowUpAgentUnavailable = (0, $cozmU.useCallback)((agentMessageId)=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: 'followUp',
            actionSubjectId: 'rovoChatFollowUp',
            attributes: {
                failureReason: 'originatingAgentUnavailable',
                ...agentMessageId ? {
                    originatingAgentMessageId: agentMessageId
                } : {}
            }
        });
        showFlag?.((0, $idzM5.StoreErrorFlagId).FOLLOW_UP_AGENT_UNAVAILABLE);
    }, [
        sendAnalyticsEvent,
        showFlag
    ]);
    const getFollowUpSendAgentParams = (0, $cozmU.useCallback)((originatingAgentIdentity, agentMessageId)=>{
        if (!originatingAgentIdentity) {
            reportFollowUpAgentUnavailable(agentMessageId);
            return undefined;
        }
        return {
            agentId: originatingAgentIdentity.id,
            messageAgentIdentity: {
                agentId: originatingAgentIdentity.id,
                ...originatingAgentIdentity.identityAccountId ? {
                    identityAccountId: originatingAgentIdentity.identityAccountId
                } : {}
            },
            followUpAgentIdentity: originatingAgentIdentity
        };
    }, [
        reportFollowUpAgentUnavailable
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (finalScreenType === 'conversation') sendAnalyticsEvent({
            eventType: 'screen',
            name: 'existingRovoChatConversation'
        });
         // Should only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Inline actionable follow-ups (parsed from the `◈` marker in the assistant
    // response) are not `StoreFollowUp` items, so they submit via this lighter
    // handler rather than `onFollowUpClicked`. Chat-mode inheritance mirrors the
    // store follow-up behaviour (deep research / think-deeper are not inherited).
    const onInlineFollowUpClicked = (0, $cozmU.useCallback)((storeAssistant, prompt)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoChatActionableFollowUpClicked',
            attributes: {
                interactionSource: 'followUps',
                followUpSource: 'ai-mate'
            }
        });
        const followUpAgentParams = shouldEnableAgentResponseHat ? getFollowUpSendAgentParams((0, $foVqg.deriveFollowUpSendAgentIdentity)(storeAssistant), storeAssistant.content.message.message.id) : {
            agent: conversationAgent
        };
        if (!followUpAgentParams) return;
        sendMessage({
            ...followUpAgentParams,
            prompt: (0, $6rwn6.encodeAdf)(prompt),
            conversationId: conversationId,
            storeUserMessages: storeUserMessages,
            messageSources: {
                interactionSource: 'followUps',
                followUpSource: 'ai-mate'
            },
            deepResearchEnabled: undefined,
            thinkDeeperEnabled: undefined,
            fastModeEnabled: undefined,
            taskModeEnabled: undefined,
            webSearchEnabled: currentChatMode.webSearchEnabled,
            addCurrentPageAsContextUserPreference: currentChatMode.useCurrentPageContext,
            appFilters: currentChatMode.appFilters
        });
    }, [
        conversationId,
        conversationAgent,
        storeUserMessages,
        sendMessage,
        currentChatMode,
        sendAnalyticsEvent,
        getFollowUpSendAgentParams,
        shouldEnableAgentResponseHat
    ]);
    const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
    const onFollowUpClicked = (0, $cozmU.useCallback)((storeChatItem, prompt)=>{
        let webSearchEnabled;
        let deepResearchEnabled;
        let thinkDeeperEnabled;
        let fastModeEnabled;
        let taskModeEnabled;
        let useCurrentPageContext;
        let appFilters;
        webSearchEnabled = currentChatMode.webSearchEnabled; // current deep research mode is not inherited to follow ups as recommended by the product
        deepResearchEnabled = undefined;
        thinkDeeperEnabled = undefined;
        fastModeEnabled = undefined;
        taskModeEnabled = undefined;
        useCurrentPageContext = currentChatMode.useCurrentPageContext;
        appFilters = currentChatMode.appFilters; // Resolve provenance before sending only for the gate-on routing path. The
        // gate-off path must preserve the baseline send and analytics ordering.
        const originatingAssistantMessageForRouting = shouldEnableAgentResponseHat && storeChatItem.agentMessageId ? rawConversationMessages.find((item)=>(0, $igOtY.isStoreAssistant)(item) && item.content?.message?.message?.id === storeChatItem.agentMessageId) : undefined;
        const originatingAgentIdentity = shouldEnableAgentResponseHat ? storeChatItem.originatingAgentIdentity ?? (originatingAssistantMessageForRouting ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistantMessageForRouting) : undefined) : undefined;
        const followUpAgentParams = shouldEnableAgentResponseHat ? getFollowUpSendAgentParams(originatingAgentIdentity, storeChatItem.agentMessageId) : {
            agent: conversationAgent
        };
        if (followUpAgentParams) sendMessage({
            ...followUpAgentParams,
            prompt: (0, $6rwn6.encodeAdf)(prompt),
            conversationId: conversationId,
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages,
            messageSources: {
                interactionSource: 'followUps',
                followUpSource: 'ai-mate'
            },
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled,
            webSearchEnabled: webSearchEnabled,
            addCurrentPageAsContextUserPreference: useCurrentPageContext,
            appFilters: appFilters
        });
         // Gate-off keeps the baseline lookup after send for interaction-mode analytics.
        const originatingAssistantMessage = shouldEnableAgentResponseHat ? originatingAssistantMessageForRouting : storeChatItem.agentMessageId ? conversationMessages.find((item)=>(0, $igOtY.isStoreAssistant)(item) && item.content?.message?.message?.id === storeChatItem.agentMessageId) : undefined; // The follow-up button is rendered after the originating assistant message has
        // finished streaming, so we can read the executed interaction mode from the
        // stored assistant message via the follow-up's `agentMessageId`.
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'followUpQueryButtonClicked',
            proactive: false,
            subjectId: 'followUpQueryButton',
            messageId: storeChatItem.agentMessageId,
            singleInstrumentationID: storeChatItem.agentMessageId,
            webSearchEnabled: currentChatMode.webSearchEnabled,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)((0, $bFeyZ.getInteractionModeExecutedFromStoreAssistant)(originatingAssistantMessage))
            }
        });
    }, [
        conversationId,
        conversationAgent,
        storeUserMessages,
        sendMessage,
        currentChatMode,
        trackAIMAUEvent,
        conversationMessages,
        rawConversationMessages,
        getFollowUpSendAgentParams,
        shouldEnableAgentResponseHat
    ]);
    const renderLoadingState = (0, $cozmU.useMemo)(()=>{
        const shouldShowGreetingLoading = elements?.shouldShowGreeting !== false && (elements?.shouldShowGreeting === true || mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR);
        return !fullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91e4408a300abe15$export$88793db575c316c3), {
            showGreeting: shouldShowGreetingLoading,
            showActions: mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR || mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), null);
    }, [
        fullScreen,
        mode,
        elements?.shouldShowGreeting
    ]);
    const renderEmptyState = (0, $cb077d0482df7dfa$export$be828b35b34a02be)({
        activeTabId: activeTabIdProp,
        conversation: conversation,
        conversationAgent: conversationAgent,
        conversationId: conversationId,
        conversationMessagesResponseCount: conversationMessagesResponseCount,
        currentChatMode: currentChatMode,
        elements: elements,
        formatMessage: formatMessage,
        handleChatEmptyLaunch: handleChatEmptyLaunch,
        handleClickDynamicPrompt: handleClickDynamicPrompt,
        isConversationAgentDefault: isConversationAgentDefault,
        isRenderStabilizationEnabled: isRenderStabilizationEnabled,
        isResizeEnabled: isResizeEnabled,
        isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
        mode: mode,
        onActiveTabChange: onActiveTabChange,
        onDiscoverPromptLibraryClick: onDiscoverPromptLibraryClick,
        product: product,
        profileData: profileData,
        runtimeCustomGreeting: runtimeCustomGreeting,
        selectedSpace: selectedSpace,
        selectedPinnedItem: selectedPinnedItem,
        sendMessage: sendMessage,
        siteId: siteId,
        storeUserMessages: storeUserMessages
    });
    const isCustomAgentResearch = (0, $cozmU.useCallback)((messageId)=>{
        const messageResearch = getMessageResearchById({
            messageId: messageId
        });
        if ((0, $29db3342b7552f6d$export$e119872ad3ffc5)(conversationAgent) && !messageResearch?.isDeepResearch) return false;
        return !isConversationAgentDefault && !!messageResearch && (0, $iDrrr.fg)('rovo_agent_default_scenario_deep_research_validate');
    }, [
        getMessageResearchById,
        isConversationAgentDefault,
        conversationAgent
    ]);
    const renderResearch = (0, $cozmU.useCallback)(({ streamedContent: streamedContent, messageId: messageId, messageHasContent: _messageHasContent, forceDeepResearch: forceDeepResearch, generatingText: generatingText, answerNowStatus: answerNowStatus, onAnswerNowClick: onAnswerNowClick, hideLiveThinkingIndicator: hideLiveThinkingIndicator, personalityThinkingText: personalityThinkingText })=>{
        if (currentChatMode.reasoningMode === 'deep-research' || forceDeepResearch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e28f01433a379fa9$export$c90b1dea2397805f), {
            messageId: messageId,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator
        });
        if (isCustomAgentResearch(messageId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e28f01433a379fa9$export$c90b1dea2397805f), {
            messageId: messageId,
            agent: thinkingAgent,
            generatingText: generatingText,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $291236cc3beb1bd7$export$e72705189d92c3b5), {
            messageId: messageId,
            streamedContent: streamedContent,
            generatingText: generatingText,
            personalityThinkingText: personalityThinkingText,
            answerNowStatus: answerNowStatus,
            onAnswerNowClick: onAnswerNowClick,
            hideLiveThinkingIndicator: hideLiveThinkingIndicator
        });
    }, [
        currentChatMode.reasoningMode,
        isCustomAgentResearch,
        thinkingAgent
    ]);
    const renderAgenticUi = (0, $cozmU.useCallback)((storeChatItem)=>{
        if (!(0, $iDrrr.fg)('jira_ai_rendering_a2ui')) return null;
        const assistantMessageId = storeChatItem.content.message.message.id;
        const agenticUiMessages = storeChatItem.agenticUiMessages;
        if (!agenticUiMessages || agenticUiMessages.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyWKg.ErrorBoundary), null, (0, $iDrrr.fg)('jira_ai_replace_custom_a2ui_renderer') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0128c9298f048ac6$export$eba9f589c47b4bf1), {
            messages: agenticUiMessages,
            onAction: (action)=>{
                handleA2UIAction({
                    eventName: action.name,
                    context: action.context
                }, assistantMessageId);
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $283776c660887d3a$export$8a30297eac7fdf0f), {
            messages: agenticUiMessages,
            onAction: (action)=>{
                handleA2UIAction({
                    eventName: action.eventName,
                    context: action.context
                }, assistantMessageId);
            }
        }));
    }, [
        handleA2UIAction
    ]);
    const stableOlderMessageRenderVersion = (0, $cozmU.useMemo)(()=>({
            chatMode: {
                deepResearchEnabled: currentChatMode.deepResearchEnabled,
                fastModeEnabled: currentChatMode.fastModeEnabled,
                reasoningMode: currentChatMode.reasoningMode,
                taskModeEnabled: currentChatMode.taskModeEnabled,
                thinkDeeperEnabled: currentChatMode.thinkDeeperEnabled,
                useCurrentPageContext: currentChatMode.useCurrentPageContext,
                webSearchEnabled: currentChatMode.webSearchEnabled
            },
            conversationId: conversationId,
            firstSessionAssistantMessageId: firstSessionAssistantMessageId,
            isConversationAgentDefault: isConversationAgentDefault,
            lastHumanMessageContentRenderVersion: lastHumanMessageContentRenderVersion,
            lastHumanMessageId: lastHumanMessageId,
            lastSendWasInterrupted: lastSendWasInterrupted,
            mode: mode,
            product: product,
            recommendationConnectorForRender: recommendationConnectorForRender,
            renderAgenticUi: renderAgenticUi,
            sharedChatContinuationPillTarget: sharedChatContinuationPillTarget,
            shouldEnableAgentResponseHat: shouldEnableAgentResponseHat,
            storeUserMessages: storeUserMessages,
            thinkingAgentId: thinkingAgent?.id,
            thinkingAgentIsDefault: thinkingAgent?.is_default,
            thinkingAgentName: thinkingAgent?.name
        }), [
        conversationId,
        currentChatMode.deepResearchEnabled,
        currentChatMode.fastModeEnabled,
        currentChatMode.reasoningMode,
        currentChatMode.taskModeEnabled,
        currentChatMode.thinkDeeperEnabled,
        currentChatMode.useCurrentPageContext,
        currentChatMode.webSearchEnabled,
        firstSessionAssistantMessageId,
        isConversationAgentDefault,
        lastHumanMessageContentRenderVersion,
        lastHumanMessageId,
        lastSendWasInterrupted,
        mode,
        product,
        recommendationConnectorForRender,
        renderAgenticUi,
        sharedChatContinuationPillTarget,
        shouldEnableAgentResponseHat,
        storeUserMessages,
        thinkingAgent?.id,
        thinkingAgent?.is_default,
        thinkingAgent?.name
    ]);
    const { isConversationActivelyGenerating: isConversationActivelyGenerating, shouldUseStableLatestMessageRenderer: shouldUseStableLatestMessageRenderer, stableLatestMessageRenderVersion: stableLatestMessageRenderVersion } = (0, $64a4e219261b5c3c$export$e063035c51c986b3)({
        conversation: conversation,
        isRateLimitedState: isRateLimitedState,
        isThinkingAgentHydrating: isThinkingAgentHydrating,
        rateLimitedActionType: rateLimitedActionType,
        shouldUseStableOlderMessageRenderer: shouldUseStableOlderMessageRenderer,
        stableOlderMessageRenderVersion: stableOlderMessageRenderVersion
    });
    const showSkills = hasOpenedSkillsOnceRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $19edd2ef54ed6c70$export$4a163bc5333928f2), {
        screenType: screenType,
        closeInlineBrowse: closeInlineBrowse,
        onSelectSkill: handleSkillSelect
    }) : null;
    const showPromptLibrary = hasOpenedPromptLibraryOnceRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null),
        interactionName: "skill-metadata-sidebar-prompt-library"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7dHQW.SkillMetadataProvider), {
        siteId: siteId,
        tags: {
            skillRegistryTags: [
                (0, $be1fceb090e4a62f$export$1ac99e1b5b1a8cfe)
            ]
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4263a5e3dcbfc278$export$133d85460c257b8e), {
        screenType: screenType,
        conversationId: conversationId,
        closeInlineBrowse: closeInlineBrowse
    }))) : null;
    if (finalScreenType === 'loading' || finalScreenType === 'empty') {
        if (finalScreenType === 'empty' && activeAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($309b4ab67835e7fc$var$styles.container, (0, $iDrrr.fg)('rovo_skills_directory_ui') && $309b4ab67835e7fc$var$styles.containerFlex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                conversationHistorySubScreen: 'active-action',
                conversationMessagesResponseCount: conversationMessagesResponseCount
            }
        }), isPulseExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3908b4de7933a21d$export$95326f479f919118), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: chatHistoryContainerRef,
            xcss: $309b4ab67835e7fc$var$styles.scrollingDiv,
            testId: "chat-history-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20f2c57f81df62c5$export$7b4b430b0cd5aed8), {
            action: activeAction,
            mode: mode || (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            fullScreen: Boolean(fullScreen),
            agent: conversationAgent,
            storeUserMessages: storeUserMessages,
            webSearchEnabled: currentChatMode.webSearchEnabled,
            addCurrentPageAsContextUserPreference: currentChatMode.useCurrentPageContext,
            appFilters: currentChatMode.appFilters
        })), showSkills, showPromptLibrary);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true,
            exitThenEnter: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: finalScreenType,
            duration: "large",
            entranceDirection: "bottom",
            exitDirection: "bottom",
            isPaused: !sidebarActionsStaggerAnimation.shouldAnimate && finalScreenType === 'empty'
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                className: (0, $hekY6.default)([
                    fullScreen ? $309b4ab67835e7fc$var$styles.animationTransitionContainerFS : useMiniModalStyles ? $309b4ab67835e7fc$var$styles.animationTransitionContainerMiniModal : $309b4ab67835e7fc$var$styles.animationTransitionContainer
                ])
            }, finalScreenType === 'loading' ? renderLoadingState : renderEmptyState))), finalScreenType === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "rovo-chat-history"
        }), showSkills, showPromptLibrary);
    }
    if (!conversation) return null;
    const { traces: traces, status: status } = conversation; // Declared before the render callbacks (`renderMessage`, `renderTracesAndErrors`)
    // that consume it. `const` is not hoisted, so keeping this above its callers avoids
    // a temporal-dead-zone ReferenceError if a caller is ever invoked synchronously.
    const getThinkingIndicatorHasHandedOff = ({ hasThinkDeeperTriggered: hasThinkDeeperTriggered, isResearchStoreInitialized: isResearchStoreInitialized, researchCompleted: researchCompleted = false })=>!traces?.length && (!hasThinkDeeperTriggered || researchCompleted) && (isResearchStoreInitialized || status === (0, $igOtY.CHAT_STORE_STATUS).idle);
    const shouldShowConversationHistoryWarning = Math.floor((Date.now().valueOf() - new Date(conversation.timeCreated).valueOf()) / 86400000) > 28;
    const renderTracesAndErrors = (hasThinkDeeperTriggered, isResearchStoreInitialized, thinkingText, researchCompleted = false, forceHideThinkingIndicator = false)=>{
        const shouldHideThinkingWhenNoTraces = getThinkingIndicatorHasHandedOff({
            hasThinkDeeperTriggered: hasThinkDeeperTriggered,
            isResearchStoreInitialized: isResearchStoreInitialized,
            researchCompleted: researchCompleted
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $501c3704274e8ca7$export$b7b8c16424783afd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbe369e2a348fc0c$export$1e7724c434f1ba76), {
            agent: !isThinkingAgentDefault ? thinkingAgent : undefined,
            traces: tracesForLoading,
            thinkingText: thinkingText,
            hideThinkingIndicator: forceHideThinkingIndicator || isThinkingAgentHydrating || shouldHideThinkingWhenNoTraces,
            animation: true
        })), isRateLimitedState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            fade: "in",
            animationTimingFunction: "ease-out",
            enterFrom: 'top',
            duration: "medium"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), animationProps, rateLimitedActionType === 'deep-research' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $267b28dff33574d8$export$1cf0423885dd4927), {
                removeRateLimiting: ()=>setConversationError(undefined)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7ea52eeb328a797$export$f022303a2948cf96), {
                removeRateLimiting: ()=>setConversationError(undefined)
            }))));
    };
    const messageRenderers = {
        human: (storeChatItem, { index: index })=>{
            const key = `history-message-${index}`;
            const isEditableHumanMessage = String(storeChatItem.content.id) === lastHumanMessageId && (storeChatItem.content.parent_message_id || lastSendWasInterrupted) && isEditLastUserPromptEnabled; // Only the editable human bubble (the last one with a parent id, or after
            // a send that didn't complete - user Stop, network error, or
            // browser-killed - when the flag is on) gets the edit affordance.
            // Earlier bubbles in history pass `undefined`.
            const onEditAndResend = isEditableHumanMessage ? handleEditAndResendMessage : undefined;
            const respondedAgentId = respondedAgentIdByHumanMessageId.get(String(storeChatItem.content.id));
            if ((0, $iDrrr.fg)('rovo_chat_history_lift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bad3f59ef13b10c$export$12d255d5177ce7be), {
                key: key,
                interactionMode: "live",
                storeHuman: storeChatItem,
                onEditAndResend: onEditAndResend,
                respondedAgentId: respondedAgentId
            });
            if (storeChatItem.redactedPrompt && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bad3f59ef13b10c$export$12d255d5177ce7be), {
                key: key,
                storeHuman: storeChatItem,
                onEditAndResend: onEditAndResend,
                respondedAgentId: respondedAgentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), null));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bad3f59ef13b10c$export$12d255d5177ce7be), {
                key: key,
                storeHuman: storeChatItem,
                onEditAndResend: onEditAndResend,
                respondedAgentId: respondedAgentId
            });
        },
        assistant: (storeChatItem, { index: index, isLastAssistant: isLastAssistant, shouldRenderLiveAssistantAffordances: shouldRenderLiveAssistantAffordances })=>{
            const key = `history-message-${index}`;
            const messageId = storeChatItem.content.message.message.id;
            const shouldRenderLiveAssistantState = shouldRenderLiveAssistantAffordances && isLastAssistant; // `getRovoThinkingState` runs `getMessageResearchById`, `formatMessage` and
            // feature-gate checks, and every consumer below (the thinking indicator and
            // `traceRender`) is only relevant for the last assistant message. Skip the work
            // entirely for earlier messages so long conversations don't recompute it for
            // every assistant bubble on each render.
            // A non-last-assistant message should still render its research traces if
            // the research store has data for it (think-deeper / implicit research steps).
            // Use the memoized Set for a cheap O(1) existence check, then only call
            // getMessageResearchById (full record) when we actually need to render state.
            const hasResearchStoreData = messageIdsWithResearchData.has(messageId);
            const shouldComputeThinkingState = isLastAssistant || hasResearchStoreData;
            const messageResearchData = shouldComputeThinkingState ? getMessageResearchById({
                messageId: messageId
            }) : null;
            const rovoThinkingState = shouldComputeThinkingState ? getRovoThinkingState(storeChatItem, messageResearchData) : undefined;
            const isAssistantActivelyGenerating = shouldRenderLiveAssistantState && isConversationActivelyGenerating && storeChatItem.content.streamingComplete !== true; // Hide the live thinking indicator when:
            // 1. Virtualization is active and the message is not actively generating
            //    (prevents a flash of the thinking indicator when reopening a completed conversation), OR
            // 2. The message's streaming is already complete — this prevents the thinking indicator
            //    from briefly re-appearing between when traces are cleared (on FINAL_RESPONSE) and
            //    when the store status transitions to idle.
            // Read hasReceivedAnswerPart from the chat store message — set atomically with
            // clearTracesIfNotEmpty so both flags update in the same store dispatch, preventing
            // the cross-store render gap that caused the thinking indicator to briefly reappear.
            const shouldHideLiveThinkingIndicator = (0, $575cafe00d20f089$export$3b3611d6ffec2b15)({
                isVirtualizationEnabled: isVirtualizationEnabled,
                isAssistantActivelyGenerating: isAssistantActivelyGenerating,
                streamingComplete: storeChatItem.content.streamingComplete,
                hasReceivedAnswerPart: storeChatItem.hasReceivedAnswerPart
            }); // The response hat succeeds the "{agent} is thinking" indicator: it is shown only
            // once the thinking traces have handed off (even while the answer text is still
            // streaming), so there is no gap or overlap between the two affordances. Earlier
            // messages have no live thinking indicator, so they are treated as already handed
            // off and keep their author-transition hats.
            const shouldShowThinkingTraces = Boolean(shouldRenderLiveAssistantState && rovoThinkingState && !shouldHideLiveThinkingIndicator);
            const canRenderAfterThinking = !shouldShowThinkingTraces;
            const previousAssistantAuthorFromHistory = shouldEnableAgentResponseHat ? previousAssistantAuthorByMessageId.get(messageId) : undefined; // The first streamed assistant row has no previous assistant message yet, but
            // it still needs a baseline to decide whether a selected-agent response hat is
            // meaningful before the first answer token arrives. Use the conversation agent
            // only for the actively generating row so completed first responses keep the
            // historical "no previous assistant" behaviour.
            const previousAssistantAuthor = previousAssistantAuthorFromHistory ?? (shouldEnableAgentResponseHat && isAssistantActivelyGenerating ? (0, $k43Ke.deriveBaselineAuthorIdentity)(conversationAgent) : undefined);
            const messageHasContent = Boolean(storeChatItem.content.message.message.content?.toString().trim());
            const isDeepResearchInProgress = storeChatItem.content.message.message.message_metadata?.deep_research;
            const generatingText = (0, $c0615b1dc7201798$export$25e70ece93417f09)(storeChatItem) ? formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).agentIsGenerating, {
                name: (0, $d3ced1e712e9d684$export$e799f6dbcac057ae)
            }) : undefined; // Compute trace render only for the last assistant message in the group
            // (`rovoThinkingState` is only defined when `isLastAssistant`).
            const traceRender = rovoThinkingState ? (()=>{
                const thinkingDisplayText = generatingText ?? rovoThinkingState.thinkingText;
                return renderTracesAndErrors(rovoThinkingState.hasThinkDeeperTriggered, rovoThinkingState.isResearchStoreInitialized, thinkingDisplayText, rovoThinkingState.researchCompleted, shouldHideLiveThinkingIndicator);
            })() : null;
            const shouldRenderActiveResponseHatHandoff = shouldEnableAgentResponseHat && isAssistantActivelyGenerating;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: key,
                "data-scroll-anchor": "assistant-message",
                "data-message-id": messageId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: {
                    source: 'AIMate',
                    attributes: {
                        messageId: messageId,
                        conversationId: conversationId
                    }
                }
            }, shouldRenderLiveAssistantAffordances ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($309b4ab67835e7fc$var$HideWhenThinkDeeperInProgress, {
                messageId: messageId
            }, traceRender) : null, shouldRenderActiveResponseHatHandoff ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($309b4ab67835e7fc$var$ActiveResponseHatHandoff, {
                storeAssistant: storeChatItem,
                previousAssistantAuthor: previousAssistantAuthor,
                shouldEnableAgentResponseHat: shouldEnableAgentResponseHat,
                isConversationActivelyGenerating: isConversationActivelyGenerating,
                canRenderAfterThinking: canRenderAfterThinking,
                hasAnswerContent: messageHasContent
            }) : null, storeChatItem.memory && (0, $cXtTj.default).getExperimentValue('memory_management_ux', 'isEnabled', false, {
                fireExperimentExposure: false
            }) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a7eac2f2453a693d$export$b439ca110cf5781), {
                storeMemoryUpdate: storeChatItem.memory,
                onOpenMemoryManagement: ()=>{
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'reviewMemoryButton'
                    });
                    onOpenMemoryManagement?.();
                }
            }), renderResearch({
                streamedContent: storeChatItem.content.message.message.content?.toString(),
                messageId: messageId,
                messageHasContent: messageHasContent,
                forceDeepResearch: isDeepResearchInProgress,
                generatingText: generatingText,
                personalityThinkingText: personalityThinkingText,
                answerNowStatus: shouldRenderLiveAssistantState && !storeChatItem.content.streamingComplete ? storeChatItem.answerNowStatus : undefined,
                hideLiveThinkingIndicator: shouldHideLiveThinkingIndicator,
                onAnswerNowClick: shouldRenderLiveAssistantState && !storeChatItem.content.streamingComplete && (0, $igOtY.isAnswerNowAvailable)(storeChatItem.answerNowStatus) && conversation ? ()=>{
                    const status = storeChatItem.answerNowStatus;
                    if ((0, $igOtY.isAnswerNowAvailable)(status)) answerNow({
                        conversationId: conversation.id,
                        tmpMessageId: status.tmpMessageId,
                        remoteMessageId: status.remoteMessageId
                    });
                } : undefined
            }), renderAgenticUi(storeChatItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf730b8cd03304d8$export$afe1efab2fc7cff2), {
                id: `answer-${messageId}`,
                contentType: "stream"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6hUo1.StoreAssistantView), {
                storeAssistant: storeChatItem,
                previousAssistantAuthor: previousAssistantAuthor,
                isConversationActivelyGenerating: isConversationActivelyGenerating,
                thinkingIndicatorHasHandedOff: canRenderAfterThinking,
                suppressInternalResponseHat: shouldRenderActiveResponseHatHandoff,
                onAuthLinkClicked: (authType)=>handleAuthLinkClicked(authType, messageId),
                onFollowUpClick: (question)=>{
                    onInlineFollowUpClicked(storeChatItem, question);
                },
                ...(0, $iDrrr.fg)('rovo_chat_history_lift') && {
                    interactionMode: 'live'
                },
                mode: mode,
                product: product,
                ...(0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') && {
                    isLastMessage: isLastAssistant
                },
                ...(0, $iDrrr.fg)('jsm-kb-action-message-prop') && {
                    isLastActionMessage: isLastAssistant
                }
            })), storeChatItem.content.message.message.id === firstSessionAssistantMessageId && storeChatItem.content.streamingComplete && recommendationConnectorForRender !== null && // Use the latched connector so the card stays mounted (and pinned to
            // the same connector) for the rest of this render lifecycle.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c16027dbba9c3023$export$94b3a3615e137529), {
                connector: recommendationConnectorForRender,
                lastHumanMessage: lastHumanMessage?.content,
                handleResendMessage: handleResendMessage
            }), storeChatItem.content.message.message.id === firstSessionAssistantMessageId && storeChatItem.content.streamingComplete && appConnectionPromptAppsForRender !== null && // 3P suggested-prompts connection prompt (CCINT-8723), rendered inline
            // after the first response completes. Uses the latched apps so it stays
            // mounted across new messages (mirrors StoreConnectorRecommendation).
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $149e037899563e0b$export$b06928cc12e793b7), {
                apps: appConnectionPromptAppsForRender
            })));
        },
        followUp: (storeChatItem, { index: index })=>{
            const key = `history-message-${index}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: key,
                "data-scroll-anchor": "follow-up-message"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84c9e0ccda110612$export$b345d27ca502af7c), {
                followUp: storeChatItem,
                ...(0, $iDrrr.fg)('rovo_chat_history_lift') && {
                    interactionMode: 'live'
                },
                onFollowUpClick: (prompt)=>{
                    onFollowUpClicked(storeChatItem, prompt);
                }
            }));
        },
        guardBlock: (storeChatItem, { index: index })=>{
            const key = `history-message-${index}`;
            return (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: key,
                "data-scroll-anchor": "guard-block-message"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97afedb3df0dd34f$export$b746be8a0467c8eb), {
                ...(0, $iDrrr.fg)('rovo_chat_history_lift') && {
                    interactionMode: 'live'
                },
                traceId: storeChatItem.traceId,
                blockType: storeChatItem.blockType
            })) : null;
        },
        error: (storeChatItem, { index: index })=>{
            const key = `history-message-${index}`;
            const lastSentMessage = lastHumanMessage?.content.content;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: key,
                "data-scroll-anchor": "error-message"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9daec6aed55b471$export$6a7b965325ceca4e), {
                ...(0, $iDrrr.fg)('rovo_chat_history_lift') && {
                    interactionMode: 'live'
                },
                error: storeChatItem,
                onResendMessage: lastSentMessage ? ()=>handleResendMessage(lastSentMessage, storeChatItem) : undefined
            }));
        }
    };
    const renderMessageWithSharedChatContinuationPill = (storeChatItem, i, renderedMessage)=>{
        if (!renderedMessage || storeChatItem !== sharedChatContinuationPillTarget) return renderedMessage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `history-message-${i}`
        }, renderedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4baca647668a1bde$export$5b5fcd2c25501720), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ab6beeeefe24fcf$export$e9cbb50bcfcf2776), {
        fullScreen: fullScreen,
        isFullScreenErrorState: isFullScreenErrorState,
        isPulseExperimentEnabled: isPulseExperimentEnabled,
        liveRegionText: liveRegionText,
        mode: mode,
        shouldShowConversationHistoryWarning: shouldShowConversationHistoryWarning,
        conversationMessagesResponseCount: conversationMessagesResponseCount,
        conversationHistoryWarningMessage: formatMessage((0, $ebff89a7bfb56a72$export$2e2bcd8739ae039).conversationLimit),
        showSkills: showSkills,
        showPromptLibrary: showPromptLibrary,
        chatHistoryContainerRef: chatHistoryContainerRef,
        messagePresentation: {
            renderers: messageRenderers,
            decorateMessage: renderMessageWithSharedChatContinuationPill,
            default: {
                shouldRenderLiveAssistantAffordances: true
            },
            latest: {
                shouldRenderLiveAssistantAffordances: true,
                ...shouldUseStableLatestMessageRenderer && {
                    renderVersion: stableLatestMessageRenderVersion
                }
            },
            older: {
                shouldRenderLiveAssistantAffordances: !shouldUseStableOlderMessageRenderer,
                ...shouldUseStableOlderMessageRenderer && {
                    renderVersion: stableOlderMessageRenderVersion
                }
            }
        },
        messageGroupsContentProps: {
            conversationId: conversationId,
            messageGroups: messageGroups,
            olderMessageGroups: olderMessageGroups,
            isVirtualizationEnabled: isVirtualizationEnabled,
            isRenderStabilizationEnabled: isRenderStabilizationEnabled,
            chatHistoryContainerRef: chatHistoryContainerRef,
            isScrollPending: !!pendingScrollToMessageIdRef.current,
            lastMessageGroupRef: lastMessageGroupRef,
            scrollToBottomGeneration: scrollToBottomGeneration
        }
    }));
};





































var $jqovE = parcelRequire("jqovE");





var $637t4 = parcelRequire("637t4");
























var $9qyl6 = parcelRequire("9qyl6");


var $e02Sx = parcelRequire("e02Sx");

const $4626886a8037cb26$var$messages = (0, $kSwu1.defineMessages)({
    fallbackTitle: {
        id: "conversation-assistant-message-actions.controllers.message-actions.ReadOnlyDefaultActionCards.fallbackTitle",
        defaultMessage: "Action unavailable"
    },
    unavailableMessage: {
        id: "conversation-assistant-message-actions.controllers.message-actions.ReadOnlyDefaultActionCards.unavailableMessage",
        defaultMessage: "This action is not available in this read-only view."
    }
});
const $4626886a8037cb26$var$styles = {
    card: "_1EqgXl4DOi"
};
const $4626886a8037cb26$export$53fd813e30497b37 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { actions: actions, ContentRenderer: ContentRenderer, productKey: productKey, cloudId: cloudId, conversationId: conversationId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!actions.length) return null;
    let t1;
    if ($[0] !== ContentRenderer || $[1] !== actions || $[2] !== cloudId || $[3] !== conversationId || $[4] !== formatMessage || $[5] !== messageId || $[6] !== productKey) {
        let t2;
        if ($[8] !== ContentRenderer || $[9] !== cloudId || $[10] !== conversationId || $[11] !== formatMessage || $[12] !== messageId || $[13] !== productKey) {
            t2 = (action)=>{
                const readonlyTitle = (0, $e02Sx.getReadonlyActionTitle)(action.key);
                const ReadOnlyRenderer = (0, $e02Sx.getReadonlyActionRenderer)(action);
                const defaultCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: action.invocationId,
                    xcss: $4626886a8037cb26$var$styles.card
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
                    title: formatMessage(readonlyTitle ?? $4626886a8037cb26$var$messages.fallbackTitle),
                    product: (0, $e02Sx.getReadonlyActionProduct)(action.key)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($4626886a8037cb26$var$messages.unavailableMessage))));
                if (ReadOnlyRenderer && ContentRenderer && productKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                    key: action.invocationId,
                    fallback: defaultCard,
                    interactionName: "readonly-action-card-renderer"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReadOnlyRenderer, {
                    actions: [
                        action
                    ],
                    ContentRenderer: ContentRenderer,
                    productKey: productKey,
                    cloudId: cloudId ?? "",
                    conversationId: conversationId,
                    messageId: messageId ?? action.invocationId
                }));
                return defaultCard;
            };
            $[8] = ContentRenderer;
            $[9] = cloudId;
            $[10] = conversationId;
            $[11] = formatMessage;
            $[12] = messageId;
            $[13] = productKey;
            $[14] = t2;
        } else t2 = $[14];
        t1 = actions.map(t2);
        $[0] = ContentRenderer;
        $[1] = actions;
        $[2] = cloudId;
        $[3] = conversationId;
        $[4] = formatMessage;
        $[5] = messageId;
        $[6] = productKey;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[15] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t1);
        $[15] = t1;
        $[16] = t2;
    } else t2 = $[16];
    return t2;
} : ({ actions: actions, ContentRenderer: ContentRenderer, productKey: productKey, cloudId: cloudId, conversationId: conversationId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!actions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action)=>{
        const readonlyTitle = (0, $e02Sx.getReadonlyActionTitle)(action.key);
        const ReadOnlyRenderer = (0, $e02Sx.getReadonlyActionRenderer)(action);
        const defaultCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: action.invocationId,
            xcss: $4626886a8037cb26$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: formatMessage(readonlyTitle ?? $4626886a8037cb26$var$messages.fallbackTitle),
            product: (0, $e02Sx.getReadonlyActionProduct)(action.key)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($4626886a8037cb26$var$messages.unavailableMessage))));
        if (ReadOnlyRenderer && ContentRenderer && productKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            key: action.invocationId,
            fallback: defaultCard,
            interactionName: "readonly-action-card-renderer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReadOnlyRenderer, {
            actions: [
                action
            ],
            ContentRenderer: ContentRenderer,
            productKey: productKey,
            cloudId: cloudId ?? '',
            conversationId: conversationId,
            messageId: messageId ?? action.invocationId
        }));
        return defaultCard;
    }));
};









var $lCO2g = parcelRequire("lCO2g");








var $bJKB2 = parcelRequire("bJKB2");


var $cOOC6 = parcelRequire("cOOC6");


var $8bsmP = parcelRequire("8bsmP");




var $eAl7N = parcelRequire("eAl7N");


var $6j4UZ = parcelRequire("6j4UZ");













const $d75c10cb45d1f040$var$READ_ONLY_CHAT_HISTORY_ID = 'read-only-chat-history';
const $d75c10cb45d1f040$var$CONFLUENCE_SUGGESTION_KEY = 'Confluence-Suggestion-Plugin';
const $d75c10cb45d1f040$var$actionUnavailableMessage = (0, $kSwu1.defineMessage)({
    id: "rovo-chat.read-only-history.action-unavailable.ai-non-final",
    defaultMessage: "Action unavailable in this read-only view"
});
const $d75c10cb45d1f040$var$styles = {
    actionPlaceholder: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _46hvQmgVvo _03SyCP8HPE _0xmtkogVvo _0LQT5E8HPE",
    fileList: "_2mHwu81Y8M _1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuz9WS _46hvQm2ADO",
    fileName: "_3W2Oc8wPeg"
};
const $d75c10cb45d1f040$var$ReadOnlyStoreHumanView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { storeHuman: storeHuman, respondedAgentId: respondedAgentId } = t0;
    const { content: t1, redactedPrompt: redactedPrompt } = storeHuman;
    const { content: content, file_uploads: file_uploads } = t1;
    const { productKey: productKey, siteId: siteId, profileData: t2 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t2;
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    let t3;
    if ($[0] !== content) {
        t3 = ()=>{
            const plainText = typeof content === "object" && content.type === "doc" ? (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content) : content?.toString() ?? "";
            navigator.clipboard?.writeText(plainText);
        };
        $[0] = content;
        $[1] = t3;
    } else t3 = $[1];
    const copyContent = t3;
    if ((0, $371af20e9bd45b7f$export$f4610a88b89838b)(storeHuman)) return null;
    if (redactedPrompt && (0, $iDrrr.fg)("rovo-guard-ui-redaction-and-blocking")) {
        let t4;
        if ($[2] !== redactedPrompt) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72163e6ddb737bfc$export$1d1938d7eb6fd5f6), {
                redactedPrompt: redactedPrompt
            }));
            $[2] = redactedPrompt;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), null);
            $[4] = t5;
        } else t5 = $[4];
        let t6;
        if ($[5] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
            $[5] = t4;
            $[6] = t6;
        } else t6 = $[6];
        return t6;
    }
    const t4 = customHandlers?.handleDeepLinkClick;
    let t5;
    if ($[7] !== aaid || $[8] !== content || $[9] !== productKey || $[10] !== respondedAgentId || $[11] !== siteId || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: content,
            productKey: productKey,
            siteId: siteId,
            aaid: aaid,
            theme: "inverse",
            onDeepLinkClick: t4,
            respondedAgentId: respondedAgentId
        });
        $[7] = aaid;
        $[8] = content;
        $[9] = productKey;
        $[10] = respondedAgentId;
        $[11] = siteId;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== copyContent || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), {
            onContentCopy: copyContent
        }, t5);
        $[14] = copyContent;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== file_uploads) {
        t7 = !!file_uploads?.length && (0, $iDrrr.fg)("rovo_enable_file_upload") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $d75c10cb45d1f040$var$styles.fileList
        }, file_uploads.map($d75c10cb45d1f040$var$_temp));
        $[17] = file_uploads;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t6 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t7);
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
} : ({ storeHuman: storeHuman, respondedAgentId: respondedAgentId })=>{
    const { content: { content: content, file_uploads: file_uploads }, redactedPrompt: redactedPrompt } = storeHuman;
    const { productKey: productKey, siteId: siteId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const copyContent = (0, $cozmU.useCallback)(()=>{
        const plainText = typeof content === 'object' && content.type === 'doc' ? (0, $e9f9f93412be66bf$export$bbc0343203048a72)(content) : content?.toString() ?? '';
        navigator.clipboard?.writeText(plainText);
    }, [
        content
    ]);
    if ((0, $371af20e9bd45b7f$export$f4610a88b89838b)(storeHuman)) return null;
    if (redactedPrompt && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72163e6ddb737bfc$export$1d1938d7eb6fd5f6), {
        redactedPrompt: redactedPrompt
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73fbbc842809c373$export$9d2b4227a95687cc), {
        onContentCopy: copyContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: content,
        productKey: productKey,
        siteId: siteId,
        aaid: aaid,
        theme: "inverse",
        onDeepLinkClick: customHandlers?.handleDeepLinkClick,
        respondedAgentId: respondedAgentId
    })), !!file_uploads?.length && (0, $iDrrr.fg)('rovo_enable_file_upload') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $d75c10cb45d1f040$var$styles.fileList
    }, file_uploads.map((file)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: file.id,
            xcss: $d75c10cb45d1f040$var$styles.fileName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, file.name)))));
};
const $d75c10cb45d1f040$var$ReadOnlyMessageActions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { actions: actions, ContentRenderer: ContentRenderer, productKey: productKey, cloudId: cloudId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!actions.length) return null;
    if ((0, $iDrrr.fg)("rovo_chat_readonly_default_action_cards")) {
        let t1;
        if ($[0] !== ContentRenderer || $[1] !== actions || $[2] !== cloudId || $[3] !== messageId || $[4] !== productKey) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                paddingBlockStart: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4626886a8037cb26$export$53fd813e30497b37), {
                actions: actions,
                ContentRenderer: ContentRenderer,
                productKey: productKey,
                cloudId: cloudId,
                messageId: messageId
            }));
            $[0] = ContentRenderer;
            $[1] = actions;
            $[2] = cloudId;
            $[3] = messageId;
            $[4] = productKey;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    let t1;
    if ($[6] !== formatMessage) {
        t1 = formatMessage($d75c10cb45d1f040$var$actionUnavailableMessage);
        $[6] = formatMessage;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[8] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d75c10cb45d1f040$var$styles.actionPlaceholder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.disabled"
        }, t1)));
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ actions: actions, ContentRenderer: ContentRenderer, productKey: productKey, cloudId: cloudId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!actions.length) return null;
    if ((0, $iDrrr.fg)('rovo_chat_readonly_default_action_cards')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4626886a8037cb26$export$53fd813e30497b37), {
        actions: actions,
        ContentRenderer: ContentRenderer,
        productKey: productKey,
        cloudId: cloudId,
        messageId: messageId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d75c10cb45d1f040$var$styles.actionPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.disabled"
    }, formatMessage($d75c10cb45d1f040$var$actionUnavailableMessage))));
};
const $d75c10cb45d1f040$var$ReadOnlyStoreAssistantView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { storeAssistant: storeAssistant } = t0;
    const { productKey: productKey, siteId: siteId, orgId: orgId, profileData: t1 } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t1;
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const { content: t2, markdownData: markdownData, redactedResponse: redactedResponse } = storeAssistant;
    const { message: assistantResponse } = t2;
    const { actions: actions, content: content, id: messageId } = assistantResponse.message;
    let t3;
    if ($[0] !== actions) {
        t3 = actions?.find($d75c10cb45d1f040$var$_temp2);
        $[0] = actions;
        $[1] = t3;
    } else t3 = $[1];
    const confluenceSuggestion = t3;
    let t4;
    if ($[2] !== actions) {
        t4 = actions?.filter($d75c10cb45d1f040$var$_temp3);
        $[2] = actions;
        $[3] = t4;
    } else t4 = $[3];
    const filteredActions = t4;
    const suggestionContent = confluenceSuggestion?.data?.content;
    let t5;
    if ($[4] !== assistantResponse.message || $[5] !== content || $[6] !== suggestionContent) {
        t5 = suggestionContent ? {
            ...assistantResponse.message,
            content: (0, $6rwn6.appendContent)(content, `---\n\n ${suggestionContent}`)
        } : assistantResponse.message;
        $[4] = assistantResponse.message;
        $[5] = content;
        $[6] = suggestionContent;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== filteredActions || $[9] !== t5) {
        t6 = {
            filteredActions: filteredActions,
            message: t5
        };
        $[8] = filteredActions;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const { filteredActions: filteredActions_0, message: message } = t6;
    if (redactedResponse && (0, $iDrrr.fg)("rovo-guard-ui-redaction-and-blocking")) {
        let t7;
        if ($[11] !== productKey || $[12] !== redactedResponse || $[13] !== siteId) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
                showPadding: false,
                variant: "neutral",
                pinchCorner: "topLeft"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                content: redactedResponse,
                productKey: productKey,
                siteId: siteId,
                adfTransformer: (0, $eAl7N.injectRedactScribbles),
                extensionComponent: (0, $6j4UZ.RedactScribbleExtension)
            }));
            $[11] = productKey;
            $[12] = redactedResponse;
            $[13] = siteId;
            $[14] = t7;
        } else t7 = $[14];
        let t8;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), {
                alignInline: "start"
            });
            $[15] = t8;
        } else t8 = $[15];
        let t9;
        if ($[16] !== t7) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.050"
            }, t7, t8);
            $[16] = t7;
            $[17] = t9;
        } else t9 = $[17];
        return t9;
    }
    if (!content && !filteredActions_0?.length) return null;
    let t7;
    if ($[18] !== filteredActions_0) {
        t7 = filteredActions_0?.some((0, $637t4.shouldNotRenderLLMContentForAction));
        $[18] = filteredActions_0;
        $[19] = t7;
    } else t7 = $[19];
    const shouldRenderContent = !t7;
    let t8;
    if ($[20] !== aaid || $[21] !== customHandlers?.handleDeepLinkClick || $[22] !== markdownData || $[23] !== message || $[24] !== orgId || $[25] !== productKey || $[26] !== shouldRenderContent || $[27] !== siteId) {
        t8 = shouldRenderContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jqovE.MessageRenderer), {
            message: message,
            allowDownloadCodeBlock: true,
            markdownData: markdownData,
            productKey: productKey,
            siteId: siteId,
            orgId: orgId,
            aaid: aaid,
            onDeepLinkClick: customHandlers?.handleDeepLinkClick,
            isExperimentEnabled: $d75c10cb45d1f040$var$_temp4,
            adfTransformer: (0, $lCO2g.adfSmartlinksPlugin),
            ...(0, $iDrrr.fg)("rovo_chat_history_lift") && {
                interactionMode: "read-only"
            }
        });
        $[20] = aaid;
        $[21] = customHandlers?.handleDeepLinkClick;
        $[22] = markdownData;
        $[23] = message;
        $[24] = orgId;
        $[25] = productKey;
        $[26] = shouldRenderContent;
        $[27] = siteId;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== filteredActions_0) {
        t9 = filteredActions_0 ?? [];
        $[29] = filteredActions_0;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== messageId || $[32] !== productKey || $[33] !== siteId || $[34] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyMessageActions, {
            actions: t9,
            ContentRenderer: (0, $1PVOM.ContentRenderer),
            productKey: productKey,
            cloudId: siteId,
            messageId: messageId
        });
        $[31] = messageId;
        $[32] = productKey;
        $[33] = siteId;
        $[34] = t9;
        $[35] = t10;
    } else t10 = $[35];
    let t11;
    if ($[36] !== t10 || $[37] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
            showPadding: false,
            variant: "neutral",
            pinchCorner: "topLeft"
        }, t8, t10);
        $[36] = t10;
        $[37] = t8;
        $[38] = t11;
    } else t11 = $[38];
    return t11;
} : ({ storeAssistant: storeAssistant })=>{
    const { productKey: productKey, siteId: siteId, orgId: orgId, profileData: { aaid: aaid } } = (0, $eKjv9.useGlobalConfig)();
    const { customHandlers: customHandlers } = (0, $dSCNl.useUIConfig)();
    const { content: { message: assistantResponse }, markdownData: markdownData, redactedResponse: redactedResponse } = storeAssistant;
    const { actions: actions, content: content, id: messageId } = assistantResponse.message;
    const { filteredActions: filteredActions_0, message: message } = (0, $cozmU.useMemo)(()=>{
        const confluenceSuggestion = actions?.find((action)=>action.key === $d75c10cb45d1f040$var$CONFLUENCE_SUGGESTION_KEY);
        const filteredActions = actions?.filter((action_0)=>action_0.key !== $d75c10cb45d1f040$var$CONFLUENCE_SUGGESTION_KEY);
        const suggestionContent = confluenceSuggestion?.data?.content;
        return {
            filteredActions: filteredActions,
            message: suggestionContent ? {
                ...assistantResponse.message,
                content: (0, $6rwn6.appendContent)(content, `---\n\n ${suggestionContent}`)
            } : assistantResponse.message
        };
    }, [
        actions,
        assistantResponse.message,
        content
    ]);
    if (redactedResponse && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
        showPadding: false,
        variant: "neutral",
        pinchCorner: "topLeft"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: redactedResponse,
        productKey: productKey,
        siteId: siteId,
        adfTransformer: (0, $eAl7N.injectRedactScribbles),
        extensionComponent: (0, $6j4UZ.RedactScribbleExtension)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), {
        alignInline: "start"
    }));
    if (!content && !filteredActions_0?.length) return null;
    const shouldRenderContent = !filteredActions_0?.some((0, $637t4.shouldNotRenderLLMContentForAction));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
        showPadding: false,
        variant: "neutral",
        pinchCorner: "topLeft"
    }, shouldRenderContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jqovE.MessageRenderer), {
        message: message,
        allowDownloadCodeBlock: true,
        markdownData: markdownData,
        productKey: productKey,
        siteId: siteId,
        orgId: orgId,
        aaid: aaid,
        onDeepLinkClick: customHandlers?.handleDeepLinkClick,
        isExperimentEnabled: (experimentName, needsExposure)=>(0, $cXtTj.default).getExperimentValue(experimentName, 'isEnabled', false, {
                fireExperimentExposure: needsExposure ?? true
            }),
        adfTransformer: (0, $lCO2g.adfSmartlinksPlugin),
        ...(0, $iDrrr.fg)('rovo_chat_history_lift') && {
            interactionMode: 'read-only'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyMessageActions, {
        actions: filteredActions_0 ?? [],
        ContentRenderer: (0, $1PVOM.ContentRenderer),
        productKey: productKey,
        cloudId: siteId,
        messageId: messageId
    }));
};
const $d75c10cb45d1f040$var$ReadOnlyStoreErrorView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { error: error } = t0;
    let t1;
    if ($[0] !== error.content) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.PaperErrorMessage), {
            message: error.content,
            variant: "neutral",
            pinchCorner: "bottomLeft"
        });
        $[0] = error.content;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.PaperErrorMessage), {
        message: error.content,
        variant: "neutral",
        pinchCorner: "bottomLeft"
    });
const $d75c10cb45d1f040$var$normalizeReadOnlyMessages = (messages)=>{
    const normalizedMessages = [];
    for (const message of messages){
        if ((0, $bxkJA.isHumanMessage)(message)) {
            normalizedMessages.push((0, $cOOC6.createStoreHumanWithContent)(message));
            continue;
        }
        if (!(0, $bxkJA.isStreamResponse)(message)) continue;
        const creatorType = message.message.message.author?.creator_type;
        const normalizedPresentation = (0, $8bsmP.normalizeFinalizedMessagePresentation)({
            message: message,
            options: {
                shouldExtractA2UI: (0, $iDrrr.fg)('jira_ai_rendering_a2ui'),
                shouldExtractActionableFollowUps: (0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled'),
                shouldExtractDataSculptor: (0, $iDrrr.fg)('rovo_enable_data_sculptor'),
                shouldExtractInlineLumina: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina'),
                shouldExtractLegacyChartBoundaries: true,
                shouldPreprocessDetails: !!creatorType && (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType)
            }
        });
        const storeAssistant = (0, $bJKB2.createStoreAssistantWithContent)(normalizedPresentation.message);
        if (Object.keys(normalizedPresentation.markdownData).length > 0) storeAssistant.markdownData = normalizedPresentation.markdownData;
        if (normalizedPresentation.agenticUiMessages) storeAssistant.agenticUiMessages = normalizedPresentation.agenticUiMessages;
        storeAssistant.isHistorical = true;
        normalizedMessages.push(storeAssistant);
    }
    return normalizedMessages;
}; /**
    * This props object intentionally starts with source-adapted finalized messages
    * only. Keeping a named object boundary allows optional conversation-level
    * context to be added later without changing existing callers.
    */ 
const $d75c10cb45d1f040$export$7962d52a2fd74b40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { messages: messages } = t0;
    const chatHistoryContainerRef = (0, $cozmU.useRef)(null);
    const lastMessageGroupRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== messages) {
        t1 = $d75c10cb45d1f040$var$normalizeReadOnlyMessages(messages);
        $[0] = messages;
        $[1] = t1;
    } else t1 = $[1];
    const normalizedMessages = t1;
    const messageGroups = (0, $a77c139a3bfb5661$export$b0a3540e90ea9054)(normalizedMessages);
    let t2;
    if ($[2] !== normalizedMessages) {
        t2 = (0, $fd834c58c02fb2c6$export$e81ab47967df822d)(normalizedMessages, (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents"));
        $[2] = normalizedMessages;
        $[3] = t2;
    } else t2 = $[3];
    const respondedAgentIdByHumanMessageId = t2;
    let t3;
    if ($[4] !== respondedAgentIdByHumanMessageId) {
        t3 = {
            human: (storeHuman, t4)=>{
                const { index: index } = t4;
                const key = `read-only-history-message-${index}`;
                const respondedAgentId = respondedAgentIdByHumanMessageId.get(String(storeHuman.content.id));
                if ((0, $iDrrr.fg)("rovo_chat_history_lift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bad3f59ef13b10c$export$12d255d5177ce7be), {
                    key: key,
                    interactionMode: "read-only",
                    storeHuman: storeHuman,
                    respondedAgentId: respondedAgentId
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyStoreHumanView, {
                    key: key,
                    storeHuman: storeHuman,
                    respondedAgentId: respondedAgentId
                });
            },
            assistant: $d75c10cb45d1f040$var$_temp5,
            followUp: $d75c10cb45d1f040$var$_temp6,
            guardBlock: $d75c10cb45d1f040$var$_temp7,
            error: $d75c10cb45d1f040$var$_temp8
        };
        $[4] = respondedAgentIdByHumanMessageId;
        $[5] = t3;
    } else t3 = $[5];
    const messageRenderers = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            shouldRenderLiveAssistantAffordances: false
        };
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== messageRenderers) {
        t5 = {
            renderers: messageRenderers,
            default: t4
        };
        $[7] = messageRenderers;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== messageGroups) {
        t7 = {
            conversationId: $d75c10cb45d1f040$var$READ_ONLY_CHAT_HISTORY_ID,
            messageGroups: messageGroups,
            olderMessageGroups: t6,
            isVirtualizationEnabled: false,
            isRenderStabilizationEnabled: false,
            chatHistoryContainerRef: chatHistoryContainerRef,
            isScrollPending: false,
            lastMessageGroupRef: lastMessageGroupRef,
            scrollToBottomGeneration: 0
        };
        $[10] = messageGroups;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== normalizedMessages.length || $[13] !== t5 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ab6beeeefe24fcf$export$e9cbb50bcfcf2776), {
            isFullScreenErrorState: false,
            isPulseExperimentEnabled: false,
            shouldShowConversationHistoryWarning: false,
            conversationMessagesResponseCount: normalizedMessages.length,
            conversationHistoryWarningMessage: null,
            showSkills: null,
            showPromptLibrary: null,
            chatHistoryContainerRef: chatHistoryContainerRef,
            messagePresentation: t5,
            messageGroupsContentProps: t7
        });
        $[12] = normalizedMessages.length;
        $[13] = t5;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ messages: messages })=>{
    const chatHistoryContainerRef = (0, $cozmU.useRef)(null);
    const lastMessageGroupRef = (0, $cozmU.useRef)(null);
    const normalizedMessages = (0, $cozmU.useMemo)(()=>$d75c10cb45d1f040$var$normalizeReadOnlyMessages(messages), [
        messages
    ]);
    const messageGroups = (0, $a77c139a3bfb5661$export$b0a3540e90ea9054)(normalizedMessages);
    const respondedAgentIdByHumanMessageId = (0, $cozmU.useMemo)(()=>(0, $fd834c58c02fb2c6$export$e81ab47967df822d)(normalizedMessages, (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')), [
        normalizedMessages
    ]);
    const messageRenderers = (0, $cozmU.useMemo)(()=>({
            human: (storeHuman, { index: index })=>{
                const key = `read-only-history-message-${index}`;
                const respondedAgentId = respondedAgentIdByHumanMessageId.get(String(storeHuman.content.id));
                if ((0, $iDrrr.fg)('rovo_chat_history_lift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bad3f59ef13b10c$export$12d255d5177ce7be), {
                    key: key,
                    interactionMode: "read-only",
                    storeHuman: storeHuman,
                    respondedAgentId: respondedAgentId
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyStoreHumanView, {
                    key: key,
                    storeHuman: storeHuman,
                    respondedAgentId: respondedAgentId
                });
            },
            assistant: (storeAssistant, { index: index_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `read-only-history-message-${index_0}`,
                    "data-scroll-anchor": "assistant-message",
                    "data-message-id": storeAssistant.content.message.message.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyStoreAssistantView, {
                    storeAssistant: storeAssistant
                })),
            followUp: (storeFollowUp, { index: index_1 })=>(0, $iDrrr.fg)('rovo_chat_history_lift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `read-only-history-message-${index_1}`,
                    "data-scroll-anchor": "follow-up-message"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84c9e0ccda110612$export$b345d27ca502af7c), {
                    interactionMode: "read-only",
                    followUp: storeFollowUp
                })) : null,
            guardBlock: (storeGuardBlock, { index: index_2 })=>(0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `read-only-history-message-${index_2}`,
                    "data-scroll-anchor": "guard-block-message"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97afedb3df0dd34f$export$b746be8a0467c8eb), {
                    ...(0, $iDrrr.fg)('rovo_chat_history_lift') && {
                        interactionMode: 'read-only'
                    },
                    traceId: storeGuardBlock.traceId,
                    blockType: storeGuardBlock.blockType
                })) : null,
            error: (storeError, { index: index_3 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `read-only-history-message-${index_3}`,
                    "data-scroll-anchor": "error-message"
                }, (0, $iDrrr.fg)('rovo_chat_history_lift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9daec6aed55b471$export$6a7b965325ceca4e), {
                    interactionMode: "read-only",
                    error: storeError
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyStoreErrorView, {
                    error: storeError
                }))
        }), [
        respondedAgentIdByHumanMessageId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ab6beeeefe24fcf$export$e9cbb50bcfcf2776), {
        isFullScreenErrorState: false,
        isPulseExperimentEnabled: false,
        shouldShowConversationHistoryWarning: false,
        conversationMessagesResponseCount: normalizedMessages.length,
        conversationHistoryWarningMessage: null,
        showSkills: null,
        showPromptLibrary: null,
        chatHistoryContainerRef: chatHistoryContainerRef,
        messagePresentation: {
            renderers: messageRenderers,
            default: {
                shouldRenderLiveAssistantAffordances: false
            }
        },
        messageGroupsContentProps: {
            conversationId: $d75c10cb45d1f040$var$READ_ONLY_CHAT_HISTORY_ID,
            messageGroups: messageGroups,
            olderMessageGroups: [],
            isVirtualizationEnabled: false,
            isRenderStabilizationEnabled: false,
            chatHistoryContainerRef: chatHistoryContainerRef,
            isScrollPending: false,
            lastMessageGroupRef: lastMessageGroupRef,
            scrollToBottomGeneration: 0
        }
    });
};
function $d75c10cb45d1f040$var$_temp(file) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        key: file.id,
        xcss: $d75c10cb45d1f040$var$styles.fileName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, file.name));
}
function $d75c10cb45d1f040$var$_temp2(action) {
    return action.key === $d75c10cb45d1f040$var$CONFLUENCE_SUGGESTION_KEY;
}
function $d75c10cb45d1f040$var$_temp3(action_0) {
    return action_0.key !== $d75c10cb45d1f040$var$CONFLUENCE_SUGGESTION_KEY;
}
function $d75c10cb45d1f040$var$_temp4(experimentName, needsExposure) {
    return (0, $cXtTj.default).getExperimentValue(experimentName, "isEnabled", false, {
        fireExperimentExposure: needsExposure ?? true
    });
}
function $d75c10cb45d1f040$var$_temp5(storeAssistant, t0) {
    const { index: index_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: `read-only-history-message-${index_0}`,
        "data-scroll-anchor": "assistant-message",
        "data-message-id": storeAssistant.content.message.message.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyStoreAssistantView, {
        storeAssistant: storeAssistant
    }));
}
function $d75c10cb45d1f040$var$_temp6(storeFollowUp, t0) {
    const { index: index_1 } = t0;
    return (0, $iDrrr.fg)("rovo_chat_history_lift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: `read-only-history-message-${index_1}`,
        "data-scroll-anchor": "follow-up-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84c9e0ccda110612$export$b345d27ca502af7c), {
        interactionMode: "read-only",
        followUp: storeFollowUp
    })) : null;
}
function $d75c10cb45d1f040$var$_temp7(storeGuardBlock, t0) {
    const { index: index_2 } = t0;
    return (0, $iDrrr.fg)("rovo-guard-ui-redaction-and-blocking") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: `read-only-history-message-${index_2}`,
        "data-scroll-anchor": "guard-block-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97afedb3df0dd34f$export$b746be8a0467c8eb), {
        ...(0, $iDrrr.fg)("rovo_chat_history_lift") && {
            interactionMode: "read-only"
        },
        traceId: storeGuardBlock.traceId,
        blockType: storeGuardBlock.blockType
    })) : null;
}
function $d75c10cb45d1f040$var$_temp8(storeError, t0) {
    const { index: index_3 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: `read-only-history-message-${index_3}`,
        "data-scroll-anchor": "error-message"
    }, (0, $iDrrr.fg)("rovo_chat_history_lift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9daec6aed55b471$export$6a7b965325ceca4e), {
        interactionMode: "read-only",
        error: storeError
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75c10cb45d1f040$var$ReadOnlyStoreErrorView, {
        error: storeError
    }));
}


// rovo_ttai_segment_render_stabilization: absorb parent render waves when ChatHistory props are stable.
const $a4401f94f223733d$var$MemoizedChatHistory = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $309b4ab67835e7fc$export$a87d4bb9f70db482), (0, $dqxOF.shallowEqualObjects));
// rovo_ttai_segment_render_stabilization ON: subscribe to `selectedSpace` via the
// narrow selector so the component (and its memo boundary) only re-renders when
// `selectedSpace` changes, rather than on every UI-store state change.
const $a4401f94f223733d$var$ChatHistoryWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useSelectedSpaceSelector), (0, $bGNkz.useSelectedPinnedItemSelector));
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    const [{ selectedPinnedItem: selectedPinnedItem }] = (0, $bGNkz.useSelectedPinnedItemSelector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$MemoizedChatHistory, {
        ...props,
        selectedSpace: selectedSpace,
        selectedPinnedItem: selectedPinnedItem
    });
};
// rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad
// UI store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $a4401f94f223733d$var$ChatHistoryWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $309b4ab67835e7fc$export$a87d4bb9f70db482), {
        ...props,
        selectedSpace: selectedSpace,
        selectedPinnedItem: selectedPinnedItem
    });
};
const $a4401f94f223733d$var$LiveChatHistory = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    let props;
    if ($[0] !== t0) {
        const { interactionMode: _interactionMode, ...t1 } = t0;
        props = t1;
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[2] = t1;
    } else t1 = $[2];
    const isRenderStabilizationEnabled = t1 === true;
    let t2;
    if ($[3] !== props) {
        t2 = isRenderStabilizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$ChatHistoryWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$ChatHistoryWithBroadStore, props);
        $[3] = props;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ interactionMode: _interactionMode, ...props })=>{
    const isRenderStabilizationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;
    return isRenderStabilizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$ChatHistoryWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$ChatHistoryWithBroadStore, props);
};
const $a4401f94f223733d$var$ReadOnlyChatHistory = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let props;
    if ($[0] !== t0) {
        const { interactionMode: _interactionMode, ...t1 } = t0;
        props = t1;
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d75c10cb45d1f040$export$7962d52a2fd74b40), props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ interactionMode: _interactionMode, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d75c10cb45d1f040$export$7962d52a2fd74b40), props);
const $a4401f94f223733d$export$23974c6ecceedade = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if (props.interactionMode === "read-only") {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$ReadOnlyChatHistory, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$LiveChatHistory, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    if (props.interactionMode === 'read-only') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$ReadOnlyChatHistory, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4401f94f223733d$var$LiveChatHistory, props);
};









































var $eudbX = parcelRequire("eudbX");

const $e6a8d8e11364938c$export$1856b84e88d8afb7 = (0, $kBr4q.createHook)((0, $eudbX.store));





const $d81ce825fa414bce$var$message = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "rovo-chat.data-sculptor-modal.title",
        defaultMessage: "Analysis"
    },
    modalCancelButton: {
        id: "rovo-chat.data-sculptor-modal.cancel",
        defaultMessage: "Cancel"
    },
    noData: {
        id: "rovo-chat.data-sculptor-modal.no-data",
        defaultMessage: "No data"
    }
});
var $d81ce825fa414bce$export$2e2bcd8739ae039 = $d81ce825fa414bce$var$message;


const $5e0ffd601ddc9a25$export$cad9f82b03ad556f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t0, t1] = (0, $e6a8d8e11364938c$export$1856b84e88d8afb7)();
    const { isOpen: isOpen, data: data } = t0;
    const { closeModal: closeModal } = t1;
    let t2;
    bb0: {
        if (!data) {
            t2 = null;
            break bb0;
        }
        let t3;
        if ($[0] !== data) {
            t3 = (0, $6rwn6.encodeAdf)(data);
            $[0] = data;
            $[1] = t3;
        } else t3 = $[1];
        t2 = t3;
    }
    const document = t2;
    let t3;
    if ($[2] !== closeModal || $[3] !== document || $[4] !== formatMessage || $[5] !== isOpen) {
        t3 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: true,
            onClose: closeModal
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $d81ce825fa414bce$export$2e2bcd8739ae039).modalTitle)), " "), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, document ? /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default), {
            document: document,
            allowCopyToClipboard: true
        }) : /*#__PURE__*/ $cozmU.createElement("div", null, formatMessage((0, $d81ce825fa414bce$export$2e2bcd8739ae039).noData))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: closeModal
        }, formatMessage((0, $d81ce825fa414bce$export$2e2bcd8739ae039).modalCancelButton))));
        $[2] = closeModal;
        $[3] = document;
        $[4] = formatMessage;
        $[5] = isOpen;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t3);
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [{ isOpen: isOpen, data: data }, { closeModal: closeModal }] = (0, $e6a8d8e11364938c$export$1856b84e88d8afb7)();
    const document = (0, $cozmU.useMemo)(()=>{
        if (!data) return null;
        return (0, $6rwn6.encodeAdf)(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        onClose: closeModal
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $d81ce825fa414bce$export$2e2bcd8739ae039).modalTitle)), ' '), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, document ? /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default), {
        document: document,
        allowCopyToClipboard: true
    }) : /*#__PURE__*/ $cozmU.createElement("div", null, formatMessage((0, $d81ce825fa414bce$export$2e2bcd8739ae039).noData))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeModal
    }, formatMessage((0, $d81ce825fa414bce$export$2e2bcd8739ae039).modalCancelButton)))));
};















































const $3c4f0794e5b63717$var$BLOCK_NODE_TYPES = new Set([
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'codeBlock'
]);
const $3c4f0794e5b63717$var$getStringValue = (value)=>typeof value === 'string' ? value : '';
const $3c4f0794e5b63717$var$getLinkHref = (marks)=>{
    const linkMark = marks?.find((mark)=>mark.type === 'link');
    return $3c4f0794e5b63717$var$getStringValue(linkMark?.attrs?.href);
};
const $3c4f0794e5b63717$var$getExtensionPromptText = (attrs)=>{
    const parameters = attrs?.parameters;
    if (!parameters || typeof parameters !== 'object') return '';
    const parameterMap = parameters;
    const skillName = $3c4f0794e5b63717$var$getStringValue(parameterMap.slug) || $3c4f0794e5b63717$var$getStringValue(parameterMap.name);
    return skillName ? `/${skillName}` : '';
};
const $3c4f0794e5b63717$var$escapeMarkdownLinkText = (text)=>text.replace(/\\/g, '\\\\').replace(/]/g, '\\]');
const $3c4f0794e5b63717$var$escapeMarkdownLinkHref = (href)=>href.replace(/\\/g, '\\\\').replace(/\)/g, '\\)');
const $3c4f0794e5b63717$var$getTextNodePromptText = (node)=>{
    const text = node.text ?? '';
    const href = $3c4f0794e5b63717$var$getLinkHref(node.marks);
    if (!text && href) return href;
    if (!href || text === href) return text;
    return `[${$3c4f0794e5b63717$var$escapeMarkdownLinkText(text)}](${$3c4f0794e5b63717$var$escapeMarkdownLinkHref(href)})`;
};
const $3c4f0794e5b63717$var$extractFromNode = (node)=>{
    if (node.type === 'text') return $3c4f0794e5b63717$var$getTextNodePromptText(node);
    if (node.type === 'hardBreak') return '\n';
    if (node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard') return $3c4f0794e5b63717$var$getStringValue(node.attrs?.url);
    if (node.type === 'mention') return $3c4f0794e5b63717$var$getStringValue(node.attrs?.text);
    if (node.type === 'emoji') return $3c4f0794e5b63717$var$getStringValue(node.attrs?.text) || $3c4f0794e5b63717$var$getStringValue(node.attrs?.shortName);
    if (node.type === 'inlineExtension') return $3c4f0794e5b63717$var$getExtensionPromptText(node.attrs);
    const childText = Array.isArray(node.content) ? node.content.map($3c4f0794e5b63717$var$extractFromNode).join('') : '';
    if (node.type && $3c4f0794e5b63717$var$BLOCK_NODE_TYPES.has(node.type) && childText) return `${childText}\n`;
    return childText;
};
const $3c4f0794e5b63717$export$18874949654c5a1d = (adf)=>$3c4f0794e5b63717$var$extractFromNode(adf).trim();








const $458f03913651d155$export$195c23619b8f2f2c = ()=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { stopTask: stopTask } = (0, $3TxKn.useChatStoreActions)();
    const chatMode = (0, $aQWBL.useChatModeState)(currentConversationId);
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: currentConversationId
    });
    const publish = (0, $hdBxM.usePublish)('ai-mate-actions');
    const [lastTask] = (0, $9qJ1N.useActiveTaskForConversation)(currentConversationId);
    const todoSnapshot = lastTask?.todoSnapshot;
    const executionSegments = lastTask?.executionSegments;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning -- enable_tasks is the umbrella gate for task updates.
    const isTasksEnabled = (0, $iDrrr.fg)('rovo_chat_enable_tasks');
    const unifiedTasksActions = (0, $9qJ1N.useTasksStoreActions)();
    const dispatchTaskProgressUpdate = (0, $cozmU.useCallback)((args)=>{
        if (!chatMode.taskModeEnabled) return;
        unifiedTasksActions.setTaskProgressState({
            conversationId: args.conversationId,
            progressState: args.progressState,
            title: args.title,
            updatedAt: args.updatedAt,
            executionSegments: args.executionSegments
        });
    }, [
        chatMode.taskModeEnabled,
        unifiedTasksActions
    ]);
    // ── Local UI state ──────────────────────────────────────────────────
    const activeInvocationIdRef = (0, $cozmU.useRef)(undefined);
    const modifyInvocationIdRef = (0, $cozmU.useRef)(undefined);
    const [isModifyingPlan, setIsModifyingPlan] = (0, $cozmU.useState)(false);
    const [showCompletedView, setShowCompletedView] = (0, $cozmU.useState)(false);
    const messageCountAtCompletionRef = (0, $cozmU.useRef)(undefined);
    // Reset completed view when conversation changes
    (0, $cozmU.useEffect)(()=>{
        if (!isTasksEnabled) return;
        setShowCompletedView(false);
        messageCountAtCompletionRef.current = undefined;
    }, [
        currentConversationId,
        isTasksEnabled
    ]);
    // ── Pubsub event handling ───────────────────────────────────────────
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate-chat-input-overlay',
        triggerLatest: true
    }, (payload)=>{
        if (!isTasksEnabled) return;
        if (payload.type === 'task-plan-confirmed') {
            const { conversationId: conversationId, planTitle: planTitle } = payload.data;
            activeInvocationIdRef.current = undefined;
            modifyInvocationIdRef.current = undefined;
            setIsModifyingPlan(false);
            const now = new Date().toISOString();
            dispatchTaskProgressUpdate({
                conversationId: conversationId,
                progressState: 'Running',
                title: planTitle,
                updatedAt: now,
                executionSegments: [
                    {
                        startedAt: now
                    }
                ]
            });
        }
        if (payload.type === 'task-ask-question-rendered') {
            const { conversationId: conversationId_0, invocationId: invocationId } = payload.data;
            activeInvocationIdRef.current = invocationId;
            dispatchTaskProgressUpdate({
                conversationId: conversationId_0,
                progressState: 'AwaitingDisambiguation',
                updatedAt: new Date().toISOString()
            });
        }
        if (payload.type === 'task-ask-question-confirmed') {
            const { conversationId: conversationId_1 } = payload.data;
            activeInvocationIdRef.current = undefined;
            dispatchTaskProgressUpdate({
                conversationId: conversationId_1,
                progressState: 'Draft',
                updatedAt: new Date().toISOString()
            });
        }
        if (payload.type === 'task-plan-rendered') {
            const { conversationId: conversationId_2, invocationId: invocationId_0 } = payload.data;
            activeInvocationIdRef.current = invocationId_0;
            modifyInvocationIdRef.current = undefined;
            setIsModifyingPlan(false);
            dispatchTaskProgressUpdate({
                conversationId: conversationId_2,
                progressState: 'AwaitingPlanConfirmation',
                updatedAt: new Date().toISOString()
            });
        }
        if (payload.type === 'task-modify-plan-requested') {
            const { conversationId: conversationId_3, invocationId: invocationId_1 } = payload.data;
            if (conversationId_3 === currentConversationId) {
                modifyInvocationIdRef.current = invocationId_1;
                setIsModifyingPlan(true);
            }
        }
    });
    // ── Completed‑view effects ──────────────────────────────────────────
    (0, $cozmU.useEffect)(()=>{
        if (!isTasksEnabled) return;
        if (lastTask?.progressState === 'Completed' && lastTask?.seekingCompletedAck) {
            setShowCompletedView(true);
            messageCountAtCompletionRef.current = messages?.length;
            const taskId = lastTask?.taskId;
            if (taskId) unifiedTasksActions.ackTaskCompleted({
                taskId: taskId
            });
        }
    }, [
        lastTask?.progressState,
        lastTask?.seekingCompletedAck,
        lastTask?.taskId,
        messages?.length,
        isTasksEnabled,
        unifiedTasksActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isTasksEnabled) return;
        if (showCompletedView && messageCountAtCompletionRef.current !== undefined && messages && messages.length > messageCountAtCompletionRef.current) {
            setShowCompletedView(false);
            messageCountAtCompletionRef.current = undefined;
        }
    }, [
        showCompletedView,
        messages,
        isTasksEnabled
    ]);
    // ── Callbacks ───────────────────────────────────────────────────────
    const handleStopTask = (0, $cozmU.useCallback)(()=>{
        stopTask({
            conversationId: currentConversationId
        });
    }, [
        stopTask,
        currentConversationId
    ]);
    const handleDoneClicked = (0, $cozmU.useCallback)(()=>{
        setShowCompletedView(false);
        messageCountAtCompletionRef.current = undefined;
    }, []);
    const onSubmitOverride = (0, $cozmU.useCallback)((prompt)=>{
        const promptText = (0, $3c4f0794e5b63717$export$18874949654c5a1d)(prompt);
        if (promptText.trim() && modifyInvocationIdRef.current) {
            publish({
                type: 'task-modify-plan-submitted',
                source: 'chatInputOverlay',
                data: {
                    conversationId: currentConversationId,
                    invocationId: modifyInvocationIdRef.current,
                    prompt: prompt
                }
            });
            dispatchTaskProgressUpdate({
                conversationId: currentConversationId,
                progressState: 'Draft'
            });
        }
        modifyInvocationIdRef.current = undefined;
        setIsModifyingPlan(false);
    }, [
        currentConversationId,
        publish,
        dispatchTaskProgressUpdate
    ]);
    // ── Derive screen ───────────────────────────────────────────────────
    const progressState = lastTask?.progressState;
    const taskTitle = lastTask?.title;
    const noneResult = {
        screen: {
            type: 'none'
        },
        handleStopTask: handleStopTask,
        handleDoneClicked: handleDoneClicked,
        onSubmitOverride: onSubmitOverride
    };
    // Completed view is shown even when task mode is no longer active (reasoning
    // mode resets to 'auto' on completion). The one-time display is already
    // guarded by seekingCompletedAck / showCompletedView state.
    if (isTasksEnabled && lastTask && (lastTask.progressState === 'Completed' && lastTask.seekingCompletedAck || showCompletedView)) return {
        screen: {
            type: 'completed',
            taskTitle: taskTitle
        },
        handleStopTask: handleStopTask,
        handleDoneClicked: handleDoneClicked,
        onSubmitOverride: onSubmitOverride
    };
    // Gate: tasks must be enabled and task mode active
    if (!isTasksEnabled || !chatMode.taskModeEnabled || !lastTask) return noneResult;
    if (progressState === 'Running' || progressState === 'AwaitingActionConfirmation') return {
        screen: {
            type: 'executing',
            todoSnapshot: todoSnapshot,
            taskTitle: taskTitle,
            executionSegments: executionSegments,
            isPaused: progressState === 'AwaitingActionConfirmation'
        },
        handleStopTask: handleStopTask,
        handleDoneClicked: handleDoneClicked,
        onSubmitOverride: onSubmitOverride
    };
    if (progressState === 'AwaitingPlanConfirmation' && activeInvocationIdRef.current) return {
        screen: {
            type: 'awaiting-plan-confirmation',
            invocationId: activeInvocationIdRef.current,
            isModifying: isModifyingPlan,
            taskTitle: taskTitle
        },
        handleStopTask: handleStopTask,
        handleDoneClicked: handleDoneClicked,
        onSubmitOverride: onSubmitOverride
    };
    if (progressState === 'AwaitingDisambiguation' && activeInvocationIdRef.current) return {
        screen: {
            type: 'awaiting-disambiguation',
            invocationId: activeInvocationIdRef.current,
            taskTitle: taskTitle
        },
        handleStopTask: handleStopTask,
        handleDoneClicked: handleDoneClicked,
        onSubmitOverride: onSubmitOverride
    };
    return noneResult;
};




















var $1pTZX = parcelRequire("1pTZX");





















const $c79c67901f4a9f07$var$message = (0, $kSwu1.defineMessages)({
    defaultTitle: {
        id: "conversation-assistant.task-progress-view.default-title",
        defaultMessage: "Task in progress"
    },
    stopTaskLabel: {
        id: "conversation-assistant.task-progress-view.stop-task-label",
        defaultMessage: "Stop task"
    },
    doneButtonLabel: {
        id: "conversation-assistant.task-progress-view.done-button-label",
        defaultMessage: "Done"
    },
    progressBarLabel: {
        id: "conversation-assistant.task-progress-view.progress-bar-label",
        defaultMessage: "Task progress"
    },
    awaitingUserResponseTitle: {
        id: "conversation-assistant.task-progress-view.awaiting-user-response.title",
        defaultMessage: "Awaiting your response"
    },
    skipAllButton: {
        id: "conversation-assistant.task-progress-view.awaiting-user-response.skip-all",
        defaultMessage: "Skip all"
    },
    awaitingPlanAcceptanceTitle: {
        id: "conversation-assistant.task-progress-view.awaiting-plan-acceptance.title",
        defaultMessage: "Awaiting your response"
    },
    cancelPlanButton: {
        id: "conversation-assistant.task-progress-view.awaiting-plan-acceptance.cancel-plan",
        defaultMessage: "Cancel plan"
    },
    sendButtonSpinnerLabel: {
        id: "conversation-assistant.task-progress-view.send-button-spinner-label",
        defaultMessage: "Waiting"
    },
    modifyPlanPlaceholder: {
        id: "conversation-assistant.task-progress-view.modify-plan.placeholder",
        defaultMessage: "Describe how to modify the plan..."
    },
    todoStepInProgressLabel: {
        id: "conversation-assistant.task-progress-view.todo-step-in-progress-label",
        defaultMessage: "Step in progress"
    },
    todoListLabel: {
        id: "conversation-assistant.task-progress-view.todo-list-label",
        defaultMessage: "Task steps"
    },
    taskElapsedTimeLabel: {
        id: "conversation-assistant.task-progress-view.elapsed-time-label",
        defaultMessage: "Elapsed time: {time}"
    }
});
var $c79c67901f4a9f07$export$2e2bcd8739ae039 = $c79c67901f4a9f07$var$message;


const $eddd441989199d0e$var$styles = {
    container: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0KLXru7Cj1 _2OUyjtETSP",
    inputArea: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _2Y7lL4gVvo _4ouGXIdnbC",
    sendArea: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl"
};
const $eddd441989199d0e$export$bdece0e1a87778e3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { conversationId: conversationId, actionInvocationId: actionInvocationId, onStopTask: onStopTask } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)("ai-mate-actions");
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== actionInvocationId || $[1] !== conversationId || $[2] !== publish || $[3] !== sendAnalyticsEvent) {
        t1 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "AwaitingPlanAcceptanceView",
                actionSubjectId: "cancelPlan",
                attributes: {
                    conversationId: conversationId,
                    invocationId: actionInvocationId
                }
            });
            publish({
                type: "task-cancel-plan",
                source: "chatInputOverlay",
                data: {
                    conversationId: conversationId,
                    invocationId: actionInvocationId
                }
            });
        };
        $[0] = actionInvocationId;
        $[1] = conversationId;
        $[2] = publish;
        $[3] = sendAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const handleCancelPlan = t1;
    let t2;
    if ($[5] !== formatMessage) {
        t2 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).awaitingPlanAcceptanceTitle);
        $[5] = formatMessage;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $eddd441989199d0e$var$styles.inputArea
        }, /*#__PURE__*/ $cozmU.createElement((0, $6wOvs.ShimmerText), null, t2));
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).cancelPlanButton);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== handleCancelPlan || $[12] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleCancelPlan
        }, t4);
        $[11] = handleCancelPlan;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsHovered(true);
        t7 = ()=>setIsHovered(false);
        t8 = ()=>setIsHovered(true);
        t9 = ()=>setIsHovered(false);
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
    } else {
        t6 = $[14];
        t7 = $[15];
        t8 = $[16];
        t9 = $[17];
    }
    let t10;
    if ($[18] !== formatMessage || $[19] !== isHovered || $[20] !== onStopTask) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            onMouseEnter: t6,
            onMouseLeave: t7,
            onFocus: t8,
            onBlur: t9
        }, isHovered ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            onClick: onStopTask,
            icon: $eddd441989199d0e$var$_temp,
            label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).stopTaskLabel)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $eddd441989199d0e$var$styles.sendArea
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: 16,
            label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).sendButtonSpinnerLabel)
        })));
        $[18] = formatMessage;
        $[19] = isHovered;
        $[20] = onStopTask;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t5) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, t5, t10);
        $[22] = t10;
        $[23] = t5;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t3) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $eddd441989199d0e$var$styles.container,
            testId: "awaiting-plan-acceptance-view"
        }, t3, t11);
        $[25] = t11;
        $[26] = t3;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ conversationId: conversationId, actionInvocationId: actionInvocationId, onStopTask: onStopTask })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate-actions');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const handleCancelPlan = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'AwaitingPlanAcceptanceView',
            actionSubjectId: 'cancelPlan',
            attributes: {
                conversationId: conversationId,
                invocationId: actionInvocationId
            }
        });
        publish({
            type: 'task-cancel-plan',
            source: 'chatInputOverlay',
            data: {
                conversationId: conversationId,
                invocationId: actionInvocationId
            }
        });
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $eddd441989199d0e$var$styles.container,
        testId: "awaiting-plan-acceptance-view"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $eddd441989199d0e$var$styles.inputArea
    }, /*#__PURE__*/ $cozmU.createElement((0, $6wOvs.ShimmerText), null, formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).awaitingPlanAcceptanceTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancelPlan
    }, formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).cancelPlanButton)), /*#__PURE__*/ $cozmU.createElement("div", {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false)
    }, isHovered ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        onClick: onStopTask,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).stopTaskLabel)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $eddd441989199d0e$var$styles.sendArea
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: 16,
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).sendButtonSpinnerLabel)
    })))));
};
function $eddd441989199d0e$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}








































const $71f54a9be6f18bb5$var$styles = {
    container: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0KLXru7Cj1 _2OUyjtETSP",
    inputArea: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _2Y7lL4gVvo _4ouGXIdnbC",
    sendArea: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl"
};
const $71f54a9be6f18bb5$export$346a846118c2777a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { conversationId: conversationId, actionInvocationId: actionInvocationId, onStopTask: onStopTask } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)("ai-mate-actions");
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== actionInvocationId || $[1] !== conversationId || $[2] !== publish || $[3] !== sendAnalyticsEvent) {
        t1 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "taskQuestionCardSkipAll",
                attributes: {
                    source: "taskStatusBar",
                    conversationId: conversationId,
                    invocationId: actionInvocationId
                }
            });
            publish({
                type: "task-skip-all-questions",
                source: "chatInputOverlay",
                data: {
                    conversationId: conversationId,
                    invocationId: actionInvocationId
                }
            });
        };
        $[0] = actionInvocationId;
        $[1] = conversationId;
        $[2] = publish;
        $[3] = sendAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const handleSkipAll = t1;
    let t2;
    if ($[5] !== formatMessage) {
        t2 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).awaitingUserResponseTitle);
        $[5] = formatMessage;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $71f54a9be6f18bb5$var$styles.inputArea
        }, /*#__PURE__*/ $cozmU.createElement((0, $6wOvs.ShimmerText), null, t2));
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).skipAllButton);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== handleSkipAll || $[12] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleSkipAll
        }, t4);
        $[11] = handleSkipAll;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsHovered(true);
        t7 = ()=>setIsHovered(false);
        t8 = ()=>setIsHovered(true);
        t9 = ()=>setIsHovered(false);
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
    } else {
        t6 = $[14];
        t7 = $[15];
        t8 = $[16];
        t9 = $[17];
    }
    let t10;
    if ($[18] !== formatMessage || $[19] !== isHovered || $[20] !== onStopTask) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            onMouseEnter: t6,
            onMouseLeave: t7,
            onFocus: t8,
            onBlur: t9
        }, isHovered ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            onClick: onStopTask,
            icon: $71f54a9be6f18bb5$var$_temp,
            label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).stopTaskLabel)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $71f54a9be6f18bb5$var$styles.sendArea
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: 16,
            label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).sendButtonSpinnerLabel)
        })));
        $[18] = formatMessage;
        $[19] = isHovered;
        $[20] = onStopTask;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t5) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, t5, t10);
        $[22] = t10;
        $[23] = t5;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t3) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $71f54a9be6f18bb5$var$styles.container,
            testId: "awaiting-user-response-view"
        }, t3, t11);
        $[25] = t11;
        $[26] = t3;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ conversationId: conversationId, actionInvocationId: actionInvocationId, onStopTask: onStopTask })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate-actions');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const handleSkipAll = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'taskQuestionCardSkipAll',
            attributes: {
                source: 'taskStatusBar',
                conversationId: conversationId,
                invocationId: actionInvocationId
            }
        });
        publish({
            type: 'task-skip-all-questions',
            source: 'chatInputOverlay',
            data: {
                conversationId: conversationId,
                invocationId: actionInvocationId
            }
        });
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $71f54a9be6f18bb5$var$styles.container,
        testId: "awaiting-user-response-view"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $71f54a9be6f18bb5$var$styles.inputArea
    }, /*#__PURE__*/ $cozmU.createElement((0, $6wOvs.ShimmerText), null, formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).awaitingUserResponseTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleSkipAll
    }, formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).skipAllButton)), /*#__PURE__*/ $cozmU.createElement("div", {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false)
    }, isHovered ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        onClick: onStopTask,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).stopTaskLabel)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $71f54a9be6f18bb5$var$styles.sendArea
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: 16,
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).sendButtonSpinnerLabel)
    })))));
};
function $71f54a9be6f18bb5$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}






















var $iQVBK = parcelRequire("iQVBK");










var $33DXp = parcelRequire("33DXp");


var $1kxki = parcelRequire("1kxki");


const $617ca8b49ddda288$var$styles = {
    container: "_0bjKvDyzSk _4bt5LAoWuR _2WAcuGoWuR _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq _39xV02N91d _0KLXrulfZc",
    header: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    titleArea: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _4ouGXIdnbC"
}; // ── Main component ──────────────────────────────────────────────────────
const $617ca8b49ddda288$export$5e94abcaa1277877 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { title: title, onDoneClicked: onDoneClicked } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $617ca8b49ddda288$var$styles.container
        ]);
        t2 = (0, $hekY6.default)([
            $617ca8b49ddda288$var$styles.header
        ]);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== formatMessage || $[3] !== title) {
        t3 = title || formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).defaultTitle);
        $[2] = formatMessage;
        $[3] = title;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = (0, $33DXp.getAppearanceFromId)(t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))),
            label: "",
            appearance: t4,
            size: "medium"
        });
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $617ca8b49ddda288$var$styles.titleArea
        ]);
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== formatMessage || $[11] !== title) {
        t7 = title || formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).defaultTitle);
        $[10] = formatMessage;
        $[11] = title;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "semibold",
            maxLines: 1,
            as: "span"
        }, t7));
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== formatMessage) {
        t9 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).progressBarLabel);
        $[15] = formatMessage;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            status: "complete",
            label: t9
        });
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== t10 || $[20] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t6
        }, t8, t10);
        $[19] = t10;
        $[20] = t8;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== formatMessage) {
        t12 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).doneButtonLabel);
        $[22] = formatMessage;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== onDoneClicked || $[25] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: onDoneClicked
        }, t12);
        $[24] = onDoneClicked;
        $[25] = t12;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t11 || $[28] !== t13 || $[29] !== t5) {
        t14 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, t5, t11, t13));
        $[27] = t11;
        $[28] = t13;
        $[29] = t5;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
} : ({ title: title, onDoneClicked: onDoneClicked })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $617ca8b49ddda288$var$styles.container
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $617ca8b49ddda288$var$styles.header
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))),
        label: "",
        appearance: (0, $33DXp.getAppearanceFromId)(title || formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).defaultTitle)),
        size: "medium"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $617ca8b49ddda288$var$styles.titleArea
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "semibold",
        maxLines: 1,
        as: "span"
    }, title || formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).defaultTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
        status: "complete",
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).progressBarLabel)
    })), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onDoneClicked
    }, formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).doneButtonLabel))));
};




















































const $1846764f82693c69$var$formatElapsedTime = (seconds)=>{
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins === 0) return `${secs}s`;
    return `${mins}m ${secs}s`;
}; /**
    * Computes the total elapsed seconds from execution segments.
    *
    * Segments are parsed to epoch-ms once, sorted by start time, and their
    * durations summed to produce a base elapsed value. Open-ended segments
    * (no `endedAt`) use `Date.now()` for their end boundary.
    *
    * When `isPaused` is false the counter ticks every second (+1) from the
    * computed base. When `isPaused` is true the display freezes at the base.
    *
    * Falls back to a simple wall-clock counter when no segments are provided.
    */ 
const $1846764f82693c69$var$computeBaseSeconds = (segments)=>{
    const parsed = segments.map((seg)=>({
            start: new Date(seg.startedAt).getTime(),
            end: seg.endedAt ? new Date(seg.endedAt).getTime() : Date.now()
        })).sort((a, b)=>a.start - b.start);
    let totalMs = 0;
    for (const { start: start, end: end } of parsed)totalMs += Math.max(0, end - start);
    return Math.floor(totalMs / 1000);
};
const $1846764f82693c69$var$useElapsedSeconds = (0, $gtMdU.isReactCompilerActivePlatform)() ? (executionSegments, isPaused)=>{
    const $ = (0, $bDgLe.c)(10);
    const hasSegments = executionSegments && executionSegments.length > 0;
    let t0;
    if ($[0] !== executionSegments || $[1] !== hasSegments) {
        t0 = ()=>hasSegments ? $1846764f82693c69$var$computeBaseSeconds(executionSegments) : 0;
        $[0] = executionSegments;
        $[1] = hasSegments;
        $[2] = t0;
    } else t0 = $[2];
    const [elapsedSeconds, setElapsedSeconds] = (0, $cozmU.useState)(t0);
    const intervalRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[3] !== executionSegments || $[4] !== hasSegments) {
        t1 = ()=>{
            if (hasSegments) setElapsedSeconds($1846764f82693c69$var$computeBaseSeconds(executionSegments));
        };
        t2 = [
            executionSegments,
            hasSegments
        ];
        $[3] = executionSegments;
        $[4] = hasSegments;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[7] !== isPaused) {
        t3 = ()=>{
            if (isPaused) {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                return;
            }
            intervalRef.current = setInterval(()=>{
                setElapsedSeconds($1846764f82693c69$var$_temp);
            }, 1000);
            return ()=>{
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
            };
        };
        t4 = [
            isPaused
        ];
        $[7] = isPaused;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useEffect)(t3, t4);
    return elapsedSeconds;
} : (executionSegments, isPaused)=>{
    const hasSegments = executionSegments && executionSegments.length > 0;
    const [elapsedSeconds, setElapsedSeconds] = (0, $cozmU.useState)(()=>hasSegments ? $1846764f82693c69$var$computeBaseSeconds(executionSegments) : 0);
    const intervalRef = (0, $cozmU.useRef)(null); // When segments change, recompute the base elapsed time
    (0, $cozmU.useEffect)(()=>{
        if (hasSegments) setElapsedSeconds($1846764f82693c69$var$computeBaseSeconds(executionSegments));
    }, [
        executionSegments,
        hasSegments
    ]); // Manage the ticking interval — cancel and early-return when paused
    (0, $cozmU.useEffect)(()=>{
        if (isPaused) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }
        intervalRef.current = setInterval(()=>{
            setElapsedSeconds((s)=>s + 1);
        }, 1000);
        return ()=>{
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [
        isPaused
    ]);
    return elapsedSeconds;
};
/**
 * Computes a progress percentage (0–95) from a todo snapshot.
 * Progress never goes backwards — the returned value is the max of the
 * previously computed value and the newly derived one.
 */ const $1846764f82693c69$var$useTaskProgress = (0, $gtMdU.isReactCompilerActivePlatform)() ? (todoSnapshot)=>{
    const $ = (0, $bDgLe.c)(3);
    const progressRef = (0, $cozmU.useRef)(10);
    const [progress, setProgress] = (0, $cozmU.useState)(10);
    let t0;
    let t1;
    if ($[0] !== todoSnapshot) {
        t0 = ()=>{
            let computed;
            if (!todoSnapshot || todoSnapshot.todos.length === 0) computed = 10;
            else {
                const total = todoSnapshot.todos.length;
                const completed = todoSnapshot.todos.filter($1846764f82693c69$var$_temp2).length;
                computed = Math.max(10, Math.min(95, Math.round(completed / total * 95)));
            }
            const next = Math.max(progressRef.current, computed);
            if (next !== progressRef.current) {
                progressRef.current = next;
                setProgress(next);
            }
        };
        t1 = [
            todoSnapshot
        ];
        $[0] = todoSnapshot;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return progress;
} : (todoSnapshot)=>{
    const progressRef = (0, $cozmU.useRef)(10);
    const [progress, setProgress] = (0, $cozmU.useState)(10);
    (0, $cozmU.useEffect)(()=>{
        let computed;
        if (!todoSnapshot || todoSnapshot.todos.length === 0) computed = 10;
        else {
            const total = todoSnapshot.todos.length;
            const completed = todoSnapshot.todos.filter((t)=>t.status === 'completed').length;
            computed = Math.max(10, Math.min(95, Math.round(completed / total * 95)));
        }
        const next = Math.max(progressRef.current, computed);
        if (next !== progressRef.current) {
            progressRef.current = next;
            setProgress(next);
        }
    }, [
        todoSnapshot
    ]);
    return progress;
}; // ── Layout ──────────────────────────────────────────────────────────────
const $1846764f82693c69$var$styles = {
    shadowWrapper: "_0bjKvDyzSk _2OUyjtETSP",
    container: "_0bjKvDyzSk _4bt5LAoWuR _2WAcuGoWuR _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _0KLXrulfZc",
    header: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    headerBorder: "_3vBAKH9r67 _3hhsrrNvrM _3BoeID6wH8",
    titleArea: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _4ouGXIdnbC",
    todoContainer: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHNc5y",
    todoExpanded: "_0NUa3r4DOi _1YKVNs7dHp",
    todoCollapsed: "_0NUa3rdnbC _1YKVNsdnbC",
    todoInner: "_2Y7lL45zaO _4c065U8HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    todoRow: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d",
    todoIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    todoTextBase: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _4ouGXIdnbC",
    connector: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VJg58",
    connectorLine: "_39xV02HZdu _0jFU0VJg58 _0KLXruDMqu",
    elapsedTime: "_1ANEUSLRg7 _3YEZNOdnbC",
    todoList: "_1LMyvKYbGa _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg"
}; // ── Sub-components ──────────────────────────────────────────────────────
const $1846764f82693c69$var$TodoStatusIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { status: status, inProgressLabel: inProgressLabel } = t0;
    switch(status){
        case "completed":
            {
                let t1;
                if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                        label: "",
                        color: "var(--ds-icon-success, #6A9A23)"
                    });
                    $[0] = t1;
                } else t1 = $[0];
                return t1;
            }
        case "in_progress":
            {
                let t1;
                if ($[1] !== inProgressLabel) {
                    t1 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                        size: 16,
                        label: inProgressLabel
                    });
                    $[1] = inProgressLabel;
                    $[2] = t1;
                } else t1 = $[2];
                return t1;
            }
        case "pending":
        default:
            {
                let t1;
                if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kRZje))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    });
                    $[3] = t1;
                } else t1 = $[3];
                return t1;
            }
    }
} : ({ status: status, inProgressLabel: inProgressLabel })=>{
    switch(status){
        case 'completed':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            });
        case 'in_progress':
            return /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: 16,
                label: inProgressLabel
            });
        case 'pending':
        default:
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kRZje))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            });
    }
}; // ── Main component ──────────────────────────────────────────────────────
const $1846764f82693c69$export$b8646389426cb89d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(86);
    const { todoSnapshot: todoSnapshot, title: title, executionSegments: executionSegments, isPaused: isPaused, onStopTask: onStopTask } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const elapsedSeconds = $1846764f82693c69$var$useElapsedSeconds(executionSegments, isPaused);
    const progress = $1846764f82693c69$var$useTaskProgress(todoSnapshot);
    const hasTodos = !!(todoSnapshot && todoSnapshot.todos.length > 0);
    let t1;
    if ($[0] !== formatMessage || $[1] !== title) {
        t1 = title || formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).defaultTitle);
        $[0] = formatMessage;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    const taskTitle = t1;
    let T0;
    let T1;
    let elapsedTimeFormatted;
    let t10;
    let t11;
    let t12;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[3] !== elapsedSeconds || $[4] !== formatMessage || $[5] !== hasTodos || $[6] !== taskTitle) {
        elapsedTimeFormatted = $1846764f82693c69$var$formatElapsedTime(elapsedSeconds);
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = (0, $hekY6.default)([
                $1846764f82693c69$var$styles.shadowWrapper
            ]);
            t11 = (0, $hekY6.default)([
                $1846764f82693c69$var$styles.container
            ]);
            $[21] = t11;
            $[22] = t12;
        } else {
            t11 = $[21];
            t12 = $[22];
        }
        const t13 = hasTodos && $1846764f82693c69$var$styles.headerBorder;
        if ($[23] !== t13) {
            t9 = (0, $hekY6.default)([
                $1846764f82693c69$var$styles.header,
                t13
            ]);
            $[23] = t13;
            $[24] = t9;
        } else t9 = $[24];
        let t14;
        if ($[25] !== taskTitle) {
            t14 = (0, $33DXp.getAppearanceFromId)(taskTitle);
            $[25] = taskTitle;
            $[26] = t14;
        } else t14 = $[26];
        if ($[27] !== t14 || $[28] !== taskTitle) {
            t10 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))),
                label: taskTitle,
                appearance: t14,
                size: "medium"
            });
            $[27] = t14;
            $[28] = taskTitle;
            $[29] = t10;
        } else t10 = $[29];
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = (0, $hekY6.default)([
                $1846764f82693c69$var$styles.titleArea
            ]);
            $[30] = t8;
        } else t8 = $[30];
        T1 = (0, $1l0kj.Inline);
        t4 = "center";
        t5 = "space.050";
        if ($[31] !== taskTitle) {
            t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "semibold",
                maxLines: 1,
                as: "span"
            }, taskTitle);
            $[31] = taskTitle;
            $[32] = t6;
        } else t6 = $[32];
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest",
                as: "span"
            }, "\u2022");
            $[33] = t7;
        } else t7 = $[33];
        T0 = (0, $iMnC5.Box);
        t2 = $1846764f82693c69$var$styles.elapsedTime;
        t3 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).taskElapsedTimeLabel, {
            time: elapsedTimeFormatted
        });
        $[3] = elapsedSeconds;
        $[4] = formatMessage;
        $[5] = hasTodos;
        $[6] = taskTitle;
        $[7] = T0;
        $[8] = T1;
        $[9] = elapsedTimeFormatted;
        $[10] = t10;
        $[11] = t11;
        $[12] = t12;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else {
        T0 = $[7];
        T1 = $[8];
        elapsedTimeFormatted = $[9];
        t10 = $[10];
        t11 = $[11];
        t12 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        t7 = $[18];
        t8 = $[19];
        t9 = $[20];
    }
    let t13;
    if ($[34] !== elapsedTimeFormatted) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            as: "span",
            "aria-hidden": true
        }, elapsedTimeFormatted);
        $[34] = elapsedTimeFormatted;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== T0 || $[37] !== t13 || $[38] !== t2 || $[39] !== t3) {
        t14 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t2,
            "aria-label": t3,
            "aria-live": "polite",
            "aria-atomic": "true"
        }, t13);
        $[36] = T0;
        $[37] = t13;
        $[38] = t2;
        $[39] = t3;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== T1 || $[42] !== t14 || $[43] !== t4 || $[44] !== t5 || $[45] !== t6 || $[46] !== t7) {
        t15 = /*#__PURE__*/ $cozmU.createElement(T1, {
            alignBlock: t4,
            space: t5
        }, t6, t7, t14);
        $[41] = T1;
        $[42] = t14;
        $[43] = t4;
        $[44] = t5;
        $[45] = t6;
        $[46] = t7;
        $[47] = t15;
    } else t15 = $[47];
    let t16;
    if ($[48] !== formatMessage) {
        t16 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).progressBarLabel);
        $[48] = formatMessage;
        $[49] = t16;
    } else t16 = $[49];
    let t17;
    if ($[50] !== progress || $[51] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            status: "running",
            label: t16,
            progress: progress
        });
        $[50] = progress;
        $[51] = t16;
        $[52] = t17;
    } else t17 = $[52];
    let t18;
    if ($[53] !== t15 || $[54] !== t17 || $[55] !== t8) {
        t18 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t8
        }, t15, t17);
        $[53] = t15;
        $[54] = t17;
        $[55] = t8;
        $[56] = t18;
    } else t18 = $[56];
    let t19;
    if ($[57] !== formatMessage) {
        t19 = formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).stopTaskLabel);
        $[57] = formatMessage;
        $[58] = t19;
    } else t19 = $[58];
    let t20;
    if ($[59] !== onStopTask || $[60] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "default",
            onClick: onStopTask,
            icon: $1846764f82693c69$var$_temp3,
            label: t19
        });
        $[59] = onStopTask;
        $[60] = t19;
        $[61] = t20;
    } else t20 = $[61];
    let t21;
    if ($[62] !== t10 || $[63] !== t18 || $[64] !== t20 || $[65] !== t9) {
        t21 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t9
        }, t10, t18, t20);
        $[62] = t10;
        $[63] = t18;
        $[64] = t20;
        $[65] = t9;
        $[66] = t21;
    } else t21 = $[66];
    const t22 = hasTodos ? $1846764f82693c69$var$styles.todoExpanded : $1846764f82693c69$var$styles.todoCollapsed;
    let t23;
    if ($[67] !== t22) {
        t23 = (0, $hekY6.default)([
            $1846764f82693c69$var$styles.todoContainer,
            t22
        ]);
        $[67] = t22;
        $[68] = t23;
    } else t23 = $[68];
    let t24;
    if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = (0, $hekY6.default)([
            $1846764f82693c69$var$styles.todoInner
        ]);
        $[69] = t24;
    } else t24 = $[69];
    let t25;
    if ($[70] !== formatMessage || $[71] !== hasTodos || $[72] !== todoSnapshot) {
        t25 = hasTodos && /*#__PURE__*/ $cozmU.createElement("ul", {
            "aria-label": formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).todoListLabel),
            className: (0, $hekY6.default)([
                $1846764f82693c69$var$styles.todoList
            ])
        }, todoSnapshot.todos.map((todo, index)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                key: todo.id
            }, /*#__PURE__*/ $cozmU.createElement("li", {
                className: (0, $hekY6.default)([
                    $1846764f82693c69$var$styles.todoRow
                ])
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $1846764f82693c69$var$styles.todoIcon
                ])
            }, /*#__PURE__*/ $cozmU.createElement($1846764f82693c69$var$TodoStatusIcon, {
                status: todo.status,
                inProgressLabel: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).todoStepInProgressLabel)
            })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $1846764f82693c69$var$styles.todoTextBase
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                color: todo.status === "completed" ? "color.text.disabled" : "color.text"
            }, todo.content))), index < todoSnapshot.todos.length - 1 && /*#__PURE__*/ $cozmU.createElement("li", {
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $1846764f82693c69$var$styles.connector
                ])
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $1846764f82693c69$var$styles.connectorLine
                ])
            })))));
        $[70] = formatMessage;
        $[71] = hasTodos;
        $[72] = todoSnapshot;
        $[73] = t25;
    } else t25 = $[73];
    let t26;
    if ($[74] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t24
        }, t25);
        $[74] = t25;
        $[75] = t26;
    } else t26 = $[75];
    let t27;
    if ($[76] !== t23 || $[77] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t23
        }, t26);
        $[76] = t23;
        $[77] = t26;
        $[78] = t27;
    } else t27 = $[78];
    let t28;
    if ($[79] !== t11 || $[80] !== t21 || $[81] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t11
        }, t21, t27);
        $[79] = t11;
        $[80] = t21;
        $[81] = t27;
        $[82] = t28;
    } else t28 = $[82];
    let t29;
    if ($[83] !== t12 || $[84] !== t28) {
        t29 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t12
        }, t28);
        $[83] = t12;
        $[84] = t28;
        $[85] = t29;
    } else t29 = $[85];
    return t29;
} : ({ todoSnapshot: todoSnapshot, title: title, executionSegments: executionSegments, isPaused: isPaused, onStopTask: onStopTask })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const elapsedSeconds = $1846764f82693c69$var$useElapsedSeconds(executionSegments, isPaused);
    const progress = $1846764f82693c69$var$useTaskProgress(todoSnapshot);
    const hasTodos = !!(todoSnapshot && todoSnapshot.todos.length > 0);
    const taskTitle = title || formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).defaultTitle);
    const elapsedTimeFormatted = $1846764f82693c69$var$formatElapsedTime(elapsedSeconds);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.shadowWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.container
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.header,
            hasTodos && $1846764f82693c69$var$styles.headerBorder
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))),
        label: taskTitle,
        appearance: (0, $33DXp.getAppearanceFromId)(taskTitle),
        size: "medium"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.titleArea
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "semibold",
        maxLines: 1,
        as: "span"
    }, taskTitle), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        as: "span"
    }, "\u2022"), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $1846764f82693c69$var$styles.elapsedTime,
        "aria-label": formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).taskElapsedTimeLabel, {
            time: elapsedTimeFormatted
        }),
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        as: "span",
        "aria-hidden": true
    }, elapsedTimeFormatted))), /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
        status: "running",
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).progressBarLabel),
        progress: progress
    })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "default",
        onClick: onStopTask,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
        label: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).stopTaskLabel)
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.todoContainer,
            hasTodos ? $1846764f82693c69$var$styles.todoExpanded : $1846764f82693c69$var$styles.todoCollapsed
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.todoInner
        ])
    }, hasTodos && /*#__PURE__*/ $cozmU.createElement("ul", {
        "aria-label": formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).todoListLabel),
        className: (0, $hekY6.default)([
            $1846764f82693c69$var$styles.todoList
        ])
    }, todoSnapshot.todos.map((todo, index)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
            key: todo.id
        }, /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                $1846764f82693c69$var$styles.todoRow
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $1846764f82693c69$var$styles.todoIcon
            ])
        }, /*#__PURE__*/ $cozmU.createElement($1846764f82693c69$var$TodoStatusIcon, {
            status: todo.status,
            inProgressLabel: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).todoStepInProgressLabel)
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $1846764f82693c69$var$styles.todoTextBase
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: todo.status === 'completed' ? 'color.text.disabled' : 'color.text'
        }, todo.content))), index < todoSnapshot.todos.length - 1 && /*#__PURE__*/ $cozmU.createElement("li", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $1846764f82693c69$var$styles.connector
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $1846764f82693c69$var$styles.connectorLine
            ])
        })))))))));
};
function $1846764f82693c69$var$_temp(s) {
    return s + 1;
}
function $1846764f82693c69$var$_temp2(t) {
    return t.status === "completed";
}
function $1846764f82693c69$var$_temp3(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}


const $a03bf8a72b4b7f8f$var$styles = {
    overlayMargin: "_2YLqiK5zaO _43nrzT5zaO",
    fullscreenCentered: "_2YLqiKIZbP _39xV02YGVw"
};
const $a03bf8a72b4b7f8f$var$ChatInputOverlayInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { children: children, currentConversationId: currentConversationId } = t0;
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { screen: screen, handleStopTask: handleStopTask, handleDoneClicked: handleDoneClicked, onSubmitOverride: onSubmitOverride } = (0, $458f03913651d155$export$195c23619b8f2f2c)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            executing: "TaskExecutingView",
            "awaiting-plan-confirmation": "AwaitingPlanAcceptanceView",
            "awaiting-disambiguation": "AwaitingUserResponseView"
        };
        $[0] = t1;
    } else t1 = $[0];
    const screenTypeToComponentName = t1;
    let t2;
    if ($[1] !== currentConversationId || $[2] !== handleStopTask || $[3] !== screen || $[4] !== sendAnalyticsEvent) {
        t2 = ()=>{
            const invocationId = "invocationId" in screen ? screen.invocationId : undefined;
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: screenTypeToComponentName[screen.type] ?? screen.type,
                actionSubjectId: "cancelPlan",
                attributes: {
                    source: "taskStatusBar",
                    conversationId: currentConversationId ?? "",
                    invocationId: invocationId
                }
            });
            handleStopTask();
        };
        $[1] = currentConversationId;
        $[2] = handleStopTask;
        $[3] = screen;
        $[4] = sendAnalyticsEvent;
        $[5] = t2;
    } else t2 = $[5];
    const handleStopTaskWithAnalytics = t2;
    let t3;
    if ($[6] !== currentConversationId || $[7] !== handleDoneClicked || $[8] !== sendAnalyticsEvent) {
        t3 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "taskProgressBarDoneButton",
                attributes: {
                    source: "taskStatusBar",
                    conversationId: currentConversationId ?? ""
                }
            });
            handleDoneClicked();
        };
        $[6] = currentConversationId;
        $[7] = handleDoneClicked;
        $[8] = sendAnalyticsEvent;
        $[9] = t3;
    } else t3 = $[9];
    const handleDoneClickedWithAnalytics = t3;
    if (screen.type === "awaiting-plan-confirmation" && screen.isModifying) {
        let t4;
        if ($[10] !== children || $[11] !== formatMessage || $[12] !== onSubmitOverride) {
            t4 = children({
                onSubmitOverride: onSubmitOverride,
                placeholderOverride: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).modifyPlanPlaceholder)
            });
            $[10] = children;
            $[11] = formatMessage;
            $[12] = onSubmitOverride;
            $[13] = t4;
        } else t4 = $[13];
        let t5;
        if ($[14] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4);
            $[14] = t4;
            $[15] = t5;
        } else t5 = $[15];
        return t5;
    }
    if (screen.type === "awaiting-disambiguation") {
        const t4 = fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered;
        let t5;
        if ($[16] !== t4) {
            t5 = (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, t4);
            $[16] = t4;
            $[17] = t5;
        } else t5 = $[17];
        let t6;
        if ($[18] !== currentConversationId || $[19] !== handleStopTaskWithAnalytics || $[20] !== screen.invocationId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71f54a9be6f18bb5$export$346a846118c2777a), {
                conversationId: currentConversationId,
                actionInvocationId: screen.invocationId,
                onStopTask: handleStopTaskWithAnalytics
            });
            $[18] = currentConversationId;
            $[19] = handleStopTaskWithAnalytics;
            $[20] = screen.invocationId;
            $[21] = t6;
        } else t6 = $[21];
        let t7;
        if ($[22] !== t5 || $[23] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t5
            }, t6);
            $[22] = t5;
            $[23] = t6;
            $[24] = t7;
        } else t7 = $[24];
        return t7;
    }
    if (screen.type === "awaiting-plan-confirmation") {
        const t4 = fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered;
        let t5;
        if ($[25] !== t4) {
            t5 = (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, t4);
            $[25] = t4;
            $[26] = t5;
        } else t5 = $[26];
        let t6;
        if ($[27] !== currentConversationId || $[28] !== handleStopTaskWithAnalytics || $[29] !== screen.invocationId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eddd441989199d0e$export$bdece0e1a87778e3), {
                conversationId: currentConversationId,
                actionInvocationId: screen.invocationId,
                onStopTask: handleStopTaskWithAnalytics
            });
            $[27] = currentConversationId;
            $[28] = handleStopTaskWithAnalytics;
            $[29] = screen.invocationId;
            $[30] = t6;
        } else t6 = $[30];
        let t7;
        if ($[31] !== t5 || $[32] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t5
            }, t6);
            $[31] = t5;
            $[32] = t6;
            $[33] = t7;
        } else t7 = $[33];
        return t7;
    }
    if (screen.type === "executing") {
        const t4 = fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered;
        let t5;
        if ($[34] !== t4) {
            t5 = (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, t4);
            $[34] = t4;
            $[35] = t5;
        } else t5 = $[35];
        let t6;
        if ($[36] !== handleStopTaskWithAnalytics || $[37] !== screen.executionSegments || $[38] !== screen.isPaused || $[39] !== screen.taskTitle || $[40] !== screen.todoSnapshot) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1846764f82693c69$export$b8646389426cb89d), {
                todoSnapshot: screen.todoSnapshot,
                title: screen.taskTitle,
                executionSegments: screen.executionSegments,
                isPaused: screen.isPaused,
                onStopTask: handleStopTaskWithAnalytics
            });
            $[36] = handleStopTaskWithAnalytics;
            $[37] = screen.executionSegments;
            $[38] = screen.isPaused;
            $[39] = screen.taskTitle;
            $[40] = screen.todoSnapshot;
            $[41] = t6;
        } else t6 = $[41];
        let t7;
        if ($[42] !== t5 || $[43] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t5
            }, t6);
            $[42] = t5;
            $[43] = t6;
            $[44] = t7;
        } else t7 = $[44];
        return t7;
    }
    if (screen.type === "completed") {
        const t4 = fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered;
        let t5;
        if ($[45] !== t4) {
            t5 = (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, t4);
            $[45] = t4;
            $[46] = t5;
        } else t5 = $[46];
        let t6;
        if ($[47] !== handleDoneClickedWithAnalytics || $[48] !== screen.taskTitle) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $617ca8b49ddda288$export$5e94abcaa1277877), {
                title: screen.taskTitle,
                onDoneClicked: handleDoneClickedWithAnalytics
            });
            $[47] = handleDoneClickedWithAnalytics;
            $[48] = screen.taskTitle;
            $[49] = t6;
        } else t6 = $[49];
        let t7;
        if ($[50] !== t5 || $[51] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t5
            }, t6);
            $[50] = t5;
            $[51] = t6;
            $[52] = t7;
        } else t7 = $[52];
        let t8;
        if ($[53] !== children) {
            t8 = children({});
            $[53] = children;
            $[54] = t8;
        } else t8 = $[54];
        let t9;
        if ($[55] !== t7 || $[56] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t7, t8);
            $[55] = t7;
            $[56] = t8;
            $[57] = t9;
        } else t9 = $[57];
        return t9;
    }
    let t4;
    if ($[58] !== children) {
        t4 = children({});
        $[58] = children;
        $[59] = t4;
    } else t4 = $[59];
    let t5;
    if ($[60] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4);
        $[60] = t4;
        $[61] = t5;
    } else t5 = $[61];
    return t5;
} : ({ children: children, currentConversationId: currentConversationId })=>{
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { screen: screen, handleStopTask: handleStopTask, handleDoneClicked: handleDoneClicked, onSubmitOverride: onSubmitOverride } = (0, $458f03913651d155$export$195c23619b8f2f2c)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const screenTypeToComponentName = {
        executing: 'TaskExecutingView',
        'awaiting-plan-confirmation': 'AwaitingPlanAcceptanceView',
        'awaiting-disambiguation': 'AwaitingUserResponseView'
    };
    const handleStopTaskWithAnalytics = ()=>{
        const invocationId = 'invocationId' in screen ? screen.invocationId : undefined;
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: screenTypeToComponentName[screen.type] ?? screen.type,
            actionSubjectId: 'cancelPlan',
            attributes: {
                source: 'taskStatusBar',
                conversationId: currentConversationId ?? '',
                invocationId: invocationId
            }
        });
        handleStopTask();
    };
    const handleDoneClickedWithAnalytics = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'taskProgressBarDoneButton',
            attributes: {
                source: 'taskStatusBar',
                conversationId: currentConversationId ?? ''
            }
        });
        handleDoneClicked();
    };
    if (screen.type === 'awaiting-plan-confirmation' && screen.isModifying) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        onSubmitOverride: onSubmitOverride,
        placeholderOverride: formatMessage((0, $c79c67901f4a9f07$export$2e2bcd8739ae039).modifyPlanPlaceholder)
    }));
    if (screen.type === 'awaiting-disambiguation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71f54a9be6f18bb5$export$346a846118c2777a), {
        conversationId: currentConversationId,
        actionInvocationId: screen.invocationId,
        onStopTask: handleStopTaskWithAnalytics
    }));
    if (screen.type === 'awaiting-plan-confirmation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eddd441989199d0e$export$bdece0e1a87778e3), {
        conversationId: currentConversationId,
        actionInvocationId: screen.invocationId,
        onStopTask: handleStopTaskWithAnalytics
    }));
    if (screen.type === 'executing') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1846764f82693c69$export$b8646389426cb89d), {
        todoSnapshot: screen.todoSnapshot,
        title: screen.taskTitle,
        executionSegments: screen.executionSegments,
        isPaused: screen.isPaused,
        onStopTask: handleStopTaskWithAnalytics
    }));
    if (screen.type === 'completed') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a03bf8a72b4b7f8f$var$styles.overlayMargin, fullScreen && $a03bf8a72b4b7f8f$var$styles.fullscreenCentered)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $617ca8b49ddda288$export$5e94abcaa1277877), {
        title: screen.taskTitle,
        onDoneClicked: handleDoneClickedWithAnalytics
    })), children({}));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({}));
};
const $a03bf8a72b4b7f8f$export$904dba9c3c34a451 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    let t0;
    if ($[0] !== currentConversationId || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a03bf8a72b4b7f8f$var$ChatInputOverlayInner, {
            ...props,
            currentConversationId: currentConversationId
        });
        $[0] = currentConversationId;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const currentConversationId = (0, $6GT8L.useCurrentConversationId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a03bf8a72b4b7f8f$var$ChatInputOverlayInner, {
        ...props,
        currentConversationId: currentConversationId
    });
};












var $brN3F = parcelRequire("brN3F");




const $14a71f978b3cf1ee$export$9d2115fa90a3c2ff = (0, $cozmU.createContext)(null);


const $41cd1043dd850903$export$a75616a52ed93687 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const [placeholderOverride, setChatInputPlaceholderOverride] = (0, $cozmU.useState)();
    let t1;
    if ($[0] !== children || $[1] !== placeholderOverride) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brN3F.PlaceholderOverrideDispatchContext).Provider, {
            value: setChatInputPlaceholderOverride
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14a71f978b3cf1ee$export$9d2115fa90a3c2ff).Provider, {
            value: placeholderOverride
        }, children));
        $[0] = children;
        $[1] = placeholderOverride;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const [placeholderOverride, setChatInputPlaceholderOverride] = (0, $cozmU.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brN3F.PlaceholderOverrideDispatchContext).Provider, {
        value: setChatInputPlaceholderOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14a71f978b3cf1ee$export$9d2115fa90a3c2ff).Provider, {
        value: placeholderOverride
    }, children));
};



























var $cnobl = parcelRequire("cnobl");









































var $7ieQR = parcelRequire("7ieQR");




const $bccf4b4a33a703d6$var$TEMPLATE_ID = 'rovo-chat-input-banner-3p-connector-nudge';
const $bccf4b4a33a703d6$export$dd82205be8d7098c = ()=>{
    const newlyEnabledConnectors = (0, $7pCWA.useNewlyEnabledConnectors)();
    const createOAuthHandler = (0, $7ieQR.useOAuthHandlerFactory)();
    // Keep a ref to createOAuthHandler so onConnect callbacks can always call
    // the latest version without being listed as a dependency of apps.
    // createOAuthHandler is recreated on every render due to instability in
    // useFlags/useAnalytics, but its behaviour is functionally equivalent each
    // time — the ref pattern avoids propagating that churn downstream.
    const createOAuthHandlerRef = (0, $cozmU.useRef)(createOAuthHandler);
    createOAuthHandlerRef.current = createOAuthHandler;
    // apps is memoized only on newlyEnabledConnectors — the connector set.
    // onConnect reads createOAuthHandlerRef.current at call time so it always
    // uses the latest handler without making apps depend on createOAuthHandler.
    const apps = (0, $cozmU.useMemo)(()=>newlyEnabledConnectors.filter((connector)=>Boolean(connector.outboundAuthUrl) && Boolean(connector.iconUrl) && Boolean(connector.friendlyName)).map((connector_0)=>({
                connectorId: connector_0.source,
                appName: connector_0.friendlyName,
                logoUrl: connector_0.iconUrl,
                onConnect: ()=>createOAuthHandlerRef.current({
                        friendlyName: connector_0.friendlyName,
                        appSource: connector_0.source,
                        outboundAuthUrl: connector_0.outboundAuthUrl,
                        analyticsAttributes: {
                            source: $bccf4b4a33a703d6$var$TEMPLATE_ID,
                            isNewlyEnabled: true
                        }
                    }).onAuthorize()
            })), [
        newlyEnabledConnectors
    ]);
    // isEligible and connectorNudgeMessageProps depend only on apps, so they
    // only change when newlyEnabledConnectors changes — not on every render.
    const isEligible = (0, $cozmU.useCallback)((message)=>{
        const raw = message['dismissedConnectorIds'];
        const dismissedConnectorIds = typeof raw === 'string' ? raw : '';
        const dismissed = dismissedConnectorIds ? dismissedConnectorIds.split(',') : [];
        return apps.some((app)=>!dismissed.includes(app.connectorId));
    }, [
        apps
    ]);
    const connectorNudgeMessageProps = (0, $cozmU.useMemo)(()=>({
            apps: apps
        }), [
        apps
    ]);
    return {
        templateId: $bccf4b4a33a703d6$var$TEMPLATE_ID,
        isEligible: isEligible,
        connectorNudgeMessageProps: connectorNudgeMessageProps
    };
};





























const $c2836440adf0afe9$var$TEMPLATE_ID = 'rovo-chat-long-running-task-spotlight';
const $c2836440adf0afe9$var$FULL_PAGE_TEMPLATE_ID = 'rovo-chat-long-running-task-fullpage-banner';
const $c2836440adf0afe9$export$2132f089de931ac7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(13);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const { conversation: conversation } = (0, $5wAPd.useConversation)(t0);
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const conversationId = conversation?.id ?? "";
    const isEmptyConversation = conversation?.id === (0, $4m5jb.EMPTY_CONVERSATION_ID);
    const { taskModeEnabled: taskModeEnabled } = (0, $aQWBL.useChatModeState)(conversationId);
    const { setReasoningMode: setReasoningMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { insertPlaceholder: insertPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    let t1;
    if ($[1] !== isEmptyConversation || $[2] !== taskModeEnabled) {
        t1 = ()=>!taskModeEnabled && isEmptyConversation;
        $[1] = isEmptyConversation;
        $[2] = taskModeEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const isEligible = t1;
    let t2;
    if ($[4] !== insertPlaceholder || $[5] !== setReasoningMode || $[6] !== setSelectedConversation) {
        t2 = ()=>{
            setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
            });
            setReasoningMode((0, $4m5jb.EMPTY_CONVERSATION_ID), "task");
            insertPlaceholder("Summarize my team's recent activity across Jira and Confluence and generate a beautiful html report");
        };
        $[4] = insertPlaceholder;
        $[5] = setReasoningMode;
        $[6] = setSelectedConversation;
        $[7] = t2;
    } else t2 = $[7];
    const onTryMax = t2;
    let t3;
    if ($[8] !== onTryMax) {
        t3 = {
            onTryMax: onTryMax
        };
        $[8] = onTryMax;
        $[9] = t3;
    } else t3 = $[9];
    const maxSideNavBannerMessageProps = t3;
    let t4;
    if ($[10] !== isEligible || $[11] !== maxSideNavBannerMessageProps) {
        t4 = {
            templateId: $c2836440adf0afe9$var$TEMPLATE_ID,
            fullPageTemplateId: $c2836440adf0afe9$var$FULL_PAGE_TEMPLATE_ID,
            isEligible: isEligible,
            maxSideNavBannerMessageProps: maxSideNavBannerMessageProps
        };
        $[10] = isEligible;
        $[11] = maxSideNavBannerMessageProps;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ()=>{
    const { conversation: conversation } = (0, $5wAPd.useConversation)({});
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const conversationId = conversation?.id ?? '';
    const isEmptyConversation = conversation?.id === (0, $4m5jb.EMPTY_CONVERSATION_ID);
    const { taskModeEnabled: taskModeEnabled } = (0, $aQWBL.useChatModeState)(conversationId);
    const { setReasoningMode: setReasoningMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { insertPlaceholder: insertPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    const isEligible = (0, $cozmU.useCallback)(()=>!taskModeEnabled && isEmptyConversation, [
        taskModeEnabled,
        isEmptyConversation
    ]);
    const onTryMax = (0, $cozmU.useCallback)(()=>{
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        setReasoningMode((0, $4m5jb.EMPTY_CONVERSATION_ID), 'task');
        insertPlaceholder("Summarize my team's recent activity across Jira and Confluence and generate a beautiful html report");
    }, [
        insertPlaceholder,
        setReasoningMode,
        setSelectedConversation
    ]);
    const maxSideNavBannerMessageProps = (0, $cozmU.useMemo)(()=>({
            onTryMax: onTryMax
        }), [
        onTryMax
    ]);
    return {
        templateId: $c2836440adf0afe9$var$TEMPLATE_ID,
        fullPageTemplateId: $c2836440adf0afe9$var$FULL_PAGE_TEMPLATE_ID,
        isEligible: isEligible,
        maxSideNavBannerMessageProps: maxSideNavBannerMessageProps
    };
};


const $4741d2a7866ada8b$export$6cbfc4d320f9e6b4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    const { templateId: nudgeTemplateId, isEligible: nudgeIsEligible, connectorNudgeMessageProps: connectorNudgeMessageProps } = (0, $bccf4b4a33a703d6$export$dd82205be8d7098c)();
    const { templateId: maxTemplateId, fullPageTemplateId: maxFullPageTemplateId, isEligible: maxIsEligible, maxSideNavBannerMessageProps: maxSideNavBannerMessageProps } = (0, $c2836440adf0afe9$export$2132f089de931ac7)();
    let t0;
    if ($[0] !== maxFullPageTemplateId || $[1] !== maxIsEligible || $[2] !== maxTemplateId || $[3] !== nudgeIsEligible || $[4] !== nudgeTemplateId) {
        t0 = {
            [nudgeTemplateId]: nudgeIsEligible,
            [maxTemplateId]: maxIsEligible,
            [maxFullPageTemplateId]: maxIsEligible
        };
        $[0] = maxFullPageTemplateId;
        $[1] = maxIsEligible;
        $[2] = maxTemplateId;
        $[3] = nudgeIsEligible;
        $[4] = nudgeTemplateId;
        $[5] = t0;
    } else t0 = $[5];
    const messageEligibility = t0;
    let t1;
    if ($[6] !== connectorNudgeMessageProps || $[7] !== maxSideNavBannerMessageProps || $[8] !== messageEligibility || $[9] !== productKey) {
        t1 = {
            productSource: productKey,
            messageEligibility: messageEligibility,
            connectorNudgeMessageProps: connectorNudgeMessageProps,
            maxSideNavBannerMessageProps: maxSideNavBannerMessageProps
        };
        $[6] = connectorNudgeMessageProps;
        $[7] = maxSideNavBannerMessageProps;
        $[8] = messageEligibility;
        $[9] = productKey;
        $[10] = t1;
    } else t1 = $[10];
    const placementProps = t1;
    return placementProps;
} : ()=>{
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    // To add a new message: create a hook returning { templateId, isEligible, ...messageProps }.
    // - isEligible is optional but should be referentially stable (useCallback) to avoid unnecessary downstream updates.
    // - Destructure with an alias (e.g. nudgeIsEligible) so multiple hooks can coexist.
    // - Add [aliasedTemplateId]: aliasedIsEligible to messageEligibility.
    // - Add message-specific props to placementProps under their own namespace.
    const { templateId: nudgeTemplateId, isEligible: nudgeIsEligible, connectorNudgeMessageProps: connectorNudgeMessageProps } = (0, $bccf4b4a33a703d6$export$dd82205be8d7098c)();
    const { templateId: maxTemplateId, fullPageTemplateId: maxFullPageTemplateId, isEligible: maxIsEligible, maxSideNavBannerMessageProps: maxSideNavBannerMessageProps } = (0, $c2836440adf0afe9$export$2132f089de931ac7)();
    const messageEligibility = (0, $cozmU.useMemo)(()=>({
            // Add new entries here: [newTemplateId]: newIsEligible
            [nudgeTemplateId]: nudgeIsEligible,
            [maxTemplateId]: maxIsEligible,
            [maxFullPageTemplateId]: maxIsEligible
        }), [
        nudgeTemplateId,
        nudgeIsEligible,
        maxTemplateId,
        maxFullPageTemplateId,
        maxIsEligible
    ]);
    const placementProps = (0, $cozmU.useMemo)(()=>({
            productSource: productKey,
            messageEligibility: messageEligibility,
            connectorNudgeMessageProps: // Add new message-specific props here under their own namespace
            connectorNudgeMessageProps,
            maxSideNavBannerMessageProps: maxSideNavBannerMessageProps
        }), [
        productKey,
        connectorNudgeMessageProps,
        maxSideNavBannerMessageProps,
        messageEligibility
    ]);
    return placementProps;
};


const $8bd96f2fcdc78b58$var$styles = {
    sidePanel: "_2XsHFM5zaO _0adFHs5zaO",
    fullScreen: "_2YLqiKIZbP _39xV02YGVw _2Zuz6Q5zaO _1Znuxb5zaO"
};
const $8bd96f2fcdc78b58$var$RemoteChatInputPlacementComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { placementId: placementId, fullScreen: fullScreen } = t0;
    const placementProps = (0, $4741d2a7866ada8b$export$6cbfc4d320f9e6b4)();
    const { PostOfficePlacement: PostOfficePlacement } = (0, $jdw9n.usePostOfficePlacement)();
    if (!PostOfficePlacement) return null;
    const t1 = fullScreen ? $8bd96f2fcdc78b58$var$styles.fullScreen : $8bd96f2fcdc78b58$var$styles.sidePanel;
    let t2;
    if ($[0] !== PostOfficePlacement || $[1] !== placementId || $[2] !== placementProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
            placementId: placementId,
            placementProps: placementProps
        });
        $[0] = PostOfficePlacement;
        $[1] = placementId;
        $[2] = placementProps;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "chat-input-placement"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t1
        }, t2));
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ placementId: placementId, fullScreen: fullScreen })=>{
    const placementProps = (0, $4741d2a7866ada8b$export$6cbfc4d320f9e6b4)();
    const { PostOfficePlacement: PostOfficePlacement } = (0, $jdw9n.usePostOfficePlacement)();
    if (!PostOfficePlacement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "chat-input-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: fullScreen ? $8bd96f2fcdc78b58$var$styles.fullScreen : $8bd96f2fcdc78b58$var$styles.sidePanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
        placementId: placementId,
        placementProps: placementProps
    })));
};
// Experiment-only: absorb parent render waves when remote placement props are stable.
const $8bd96f2fcdc78b58$var$MemoizedRemoteChatInputPlacement = /*#__PURE__*/ (0, $cozmU.memo)($8bd96f2fcdc78b58$var$RemoteChatInputPlacementComponent, (0, $dqxOF.shallowEqualObjects));
const $8bd96f2fcdc78b58$export$7b752483c3ab08fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bd96f2fcdc78b58$var$MemoizedRemoteChatInputPlacement, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bd96f2fcdc78b58$var$RemoteChatInputPlacementComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bd96f2fcdc78b58$var$MemoizedRemoteChatInputPlacement, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bd96f2fcdc78b58$var$RemoteChatInputPlacementComponent, props);
};


const $94d96d2f0d665618$var$renderRemotePlacement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bd96f2fcdc78b58$export$7b752483c3ab08fb), {
        placementId: "rovo-chat-input-side-panel"
    });
const $94d96d2f0d665618$var$ufoCustomDataKeys = {
    result: 'chatInputPlacementHeadlessProbeResult',
    responseMessageCount: 'chatInputPlacementHeadlessProbeResponseMessageCount',
    nonDismissedMessageCount: 'chatInputPlacementHeadlessProbeNonDismissedMessageCount'
};
const $94d96d2f0d665618$export$d7e986de501bda86 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnobl.LoadableHeadlessProbePostOfficePlacement), {
            placementId: "rovo-chat-input-side-panel",
            renderRemotePlacement: $94d96d2f0d665618$var$renderRemotePlacement,
            ufoCustomDataKeys: $94d96d2f0d665618$var$ufoCustomDataKeys
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnobl.LoadableHeadlessProbePostOfficePlacement), {
        placementId: "rovo-chat-input-side-panel",
        renderRemotePlacement: $94d96d2f0d665618$var$renderRemotePlacement,
        ufoCustomDataKeys: $94d96d2f0d665618$var$ufoCustomDataKeys
    });
};



const $ac8f43e0f5eb3ebe$var$ClientSideOnly = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = typeof window !== "undefined" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>typeof window !== 'undefined' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
const $ac8f43e0f5eb3ebe$var$ChatInputPlacementContainerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { shouldShow: shouldShow, fullScreen: fullScreen } = t0;
    if (!shouldShow) return null;
    let t1;
    if ($[0] !== fullScreen) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac8f43e0f5eb3ebe$var$ClientSideOnly, null, fullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bd96f2fcdc78b58$export$7b752483c3ab08fb), {
            placementId: "rovo-chat-input-full-page",
            fullScreen: fullScreen
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94d96d2f0d665618$export$d7e986de501bda86), null));
        $[0] = fullScreen;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ shouldShow: shouldShow, fullScreen: fullScreen })=>{
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac8f43e0f5eb3ebe$var$ClientSideOnly, null, fullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bd96f2fcdc78b58$export$7b752483c3ab08fb), {
        placementId: "rovo-chat-input-full-page",
        fullScreen: fullScreen
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94d96d2f0d665618$export$d7e986de501bda86), null));
};
// Experiment-only: absorb parent render waves when placement props are stable.
const $ac8f43e0f5eb3ebe$var$MemoizedChatInputPlacementContainer = /*#__PURE__*/ (0, $cozmU.memo)($ac8f43e0f5eb3ebe$var$ChatInputPlacementContainerComponent, (0, $dqxOF.shallowEqualObjects));
const $ac8f43e0f5eb3ebe$export$a112554c09de95e4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac8f43e0f5eb3ebe$var$MemoizedChatInputPlacementContainer, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac8f43e0f5eb3ebe$var$ChatInputPlacementContainerComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac8f43e0f5eb3ebe$var$MemoizedChatInputPlacementContainer, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac8f43e0f5eb3ebe$var$ChatInputPlacementContainerComponent, props);
};
















































var $7685l = parcelRequire("7685l");





var $1jIs1 = parcelRequire("1jIs1");


























var $jqWbJ = parcelRequire("jqWbJ");


var $1aCne = parcelRequire("1aCne");

/* SourceLinkPickerPopup.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $8Svrc = parcelRequire("8Svrc");


var $1F2YI = parcelRequire("1F2YI");











var $814i2 = parcelRequire("814i2");


const $c75163609085e392$var$RovoLinkPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("lLexe")).then((mod)=>({
            default: mod.default
        })));
const $c75163609085e392$var$messages = (0, $kSwu1.defineMessages)({
    duplicateSourceError: {
        id: "rovo.spaces.sourceLinkPicker.duplicateSourceError",
        defaultMessage: "This source is already added."
    }
});
const $c75163609085e392$var$errorContentStyles = {
    root: "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzAyGJ"
};
const $c75163609085e392$var$styles = {
    rovoLinkPickerPopup: "_39xV020xhY",
    rovoLinkPickerWrapper: "_39xV020xhY _4kiQYAaVF6 _0NUa3raVF6 _2WAcuGIZbP"
};
const $c75163609085e392$export$43b333124c26a133 = ({ trigger: trigger, plugins: plugins, cloudId: cloudId, onSourceAdded: onSourceAdded, sources: sources = [] })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isDuplicateError, setIsDuplicateError] = (0, $cozmU.useState)(false);
    const duplicateSourceErrorNode = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $c75163609085e392$var$errorContentStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "currentColor",
            size: "small"
        }), intl.formatMessage($c75163609085e392$var$messages.duplicateSourceError)), [
        intl
    ]); // Keep stable refs so the submit handler doesn't go stale.
    const onSourceAddedRef = (0, $cozmU.useRef)(onSourceAdded);
    onSourceAddedRef.current = onSourceAdded;
    const sourcesRef = (0, $cozmU.useRef)(sources);
    sourcesRef.current = sources;
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setIsDuplicateError(false);
    }, []);
    const handleLegacyCancel = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const handleSubmit = (0, $cozmU.useCallback)(({ url: url, displayText: displayText, title: title })=>{
        // Block submission if this URL is already in the sources list.
        // Normalise both sides to catch variations like trailing slashes, protocol
        // casing, or http vs https before comparing.
        const normalizedUrl = (0, $1F2YI.normalizeUrl)(url);
        const isDuplicate = sourcesRef.current.some((s)=>(0, $1F2YI.normalizeUrl)(s.url) === normalizedUrl);
        if (isDuplicate) {
            setIsDuplicateError(true);
            return;
        }
        setIsDuplicateError(false);
        const trimmedDisplayText = displayText?.trim() || undefined;
        const resolvedTitle = title?.trim() || undefined; // Only treat `displayText` as a user override when it differs from the
        // resolved title (the link picker pre-fills display-text with the title).
        const userDisplayText = trimmedDisplayText && trimmedDisplayText !== resolvedTitle ? trimmedDisplayText : undefined;
        onSourceAddedRef.current({
            id: `optimistic-${url}`,
            url: url,
            title: userDisplayText ?? resolvedTitle ?? url,
            sourceType: (0, $814i2.detectSourceType)(url)
        });
        setIsOpen(false);
    }, []);
    const isRovoLinkPickerEnabled = (0, $iDrrr.fg)('rovo_spaces_use_rovo_link_picker');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        xcss: isRovoLinkPickerEnabled ? $c75163609085e392$var$styles.rovoLinkPickerPopup : undefined,
        zIndex: 510,
        content: ()=>isRovoLinkPickerEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $c75163609085e392$var$styles.rovoLinkPickerWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c75163609085e392$var$RovoLinkPicker, {
                cloudId: cloudId,
                onSubmit: handleSubmit,
                onCancel: handleClose,
                footerError: isDuplicateError ? duplicateSourceErrorNode : undefined
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Svrc.DeprecatedLazyLinkPickerExport), {
                plugins: plugins,
                onSubmit: handleSubmit,
                onCancel: handleLegacyCancel,
                adaptiveHeight: true,
                recentSearchListSize: 3
            }),
        trigger: (triggerProps)=>trigger({
                ...triggerProps,
                onClick: ()=>setIsOpen((prev)=>!prev)
            })
    });
};












var $b4vCW = parcelRequire("b4vCW");

var $69Kfj = parcelRequire("69Kfj");

const $d4397f8d51eab4c7$export$7ba3849109541ac3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSpaceSourcePlugins(cloudId) {
    const $ = (0, $bDgLe.c)(21);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            tabKey: "confluence",
            tabTitle: "Confluence"
        };
        t1 = [
            "confluence"
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] !== cloudId) {
        t2 = {
            tabConfig: t0,
            products: t1,
            scope: (0, $b4vCW.Scope).ConfluenceContentType,
            cloudId: cloudId
        };
        $[2] = cloudId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            tabKey: "jira",
            tabTitle: "Jira"
        };
        t4 = [
            "jira"
        ];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    let t5;
    if ($[6] !== cloudId) {
        t5 = {
            tabConfig: t3,
            products: t4,
            scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter,
            cloudId: cloudId
        };
        $[6] = cloudId;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            tabKey: "atlas",
            tabTitle: "Atlas"
        };
        t7 = [
            "townsquare"
        ];
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    let t8;
    if ($[10] !== cloudId) {
        t8 = {
            tabConfig: t6,
            products: t7,
            scope: (0, $b4vCW.Scope).TownsquareProject,
            cloudId: cloudId
        };
        $[10] = cloudId;
        $[11] = t8;
    } else t8 = $[11];
    let t10;
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            tabKey: "loom",
            tabTitle: "Loom"
        };
        t10 = [
            "loom"
        ];
        $[12] = t10;
        $[13] = t9;
    } else {
        t10 = $[12];
        t9 = $[13];
    }
    let t11;
    if ($[14] !== cloudId) {
        t11 = {
            tabConfig: t9,
            products: t10,
            scope: (0, $b4vCW.Scope).Loom,
            cloudId: cloudId,
            disableActivityClient: true
        };
        $[14] = cloudId;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11 || $[17] !== t2 || $[18] !== t5 || $[19] !== t8) {
        t12 = [
            t2,
            t5,
            t8,
            t11
        ];
        $[16] = t11;
        $[17] = t2;
        $[18] = t5;
        $[19] = t8;
        $[20] = t12;
    } else t12 = $[20];
    const configs = t12;
    return (0, $69Kfj.useAtlassianPlugins)(configs);
} : function useSpaceSourcePlugins(cloudId) {
    const configs = (0, $cozmU.useMemo)(()=>[
            {
                tabConfig: {
                    tabKey: 'confluence',
                    tabTitle: 'Confluence'
                },
                products: [
                    'confluence'
                ],
                scope: (0, $b4vCW.Scope).ConfluenceContentType,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'jira',
                    tabTitle: 'Jira'
                },
                products: [
                    'jira'
                ],
                scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'atlas',
                    tabTitle: 'Atlas'
                },
                products: [
                    'townsquare'
                ],
                scope: (0, $b4vCW.Scope).TownsquareProject,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'loom',
                    tabTitle: 'Loom'
                },
                products: [
                    'loom'
                ],
                scope: (0, $b4vCW.Scope).Loom,
                cloudId: cloudId,
                disableActivityClient: true
            }
        ], [
        cloudId
    ]);
    return (0, $69Kfj.useAtlassianPlugins)(configs);
};









var $4tJut = parcelRequire("4tJut");


var $lNd2W = parcelRequire("lNd2W");

/**
 * Backtick-wrapped placeholders in prompt cards (e.g. `document`, `person`) are meant to be replaced by the user.
 * When comparing sent text to the card prompt, we treat these as variable and only require fixed segments to match.
 */ const $3181a0281282e23e$var$BACKTICK_PLACEHOLDER_REGEX = /`[^`]*`/g;
const $3181a0281282e23e$export$2def72d3ef808307 = (normalizedSentText, normalizedOriginalPrompt)=>{
    if (normalizedSentText === normalizedOriginalPrompt) return 'asIs';
    if (normalizedOriginalPrompt.length === 0) return null;
    const fixedSegments = normalizedOriginalPrompt.split($3181a0281282e23e$var$BACKTICK_PLACEHOLDER_REGEX);
    const hasPlaceholders = fixedSegments.length > 1;
    if (hasPlaceholders) {
        let searchFrom = 0;
        let firstSegmentMatchedAtStart = true;
        for (const segment of fixedSegments){
            const trimmed = segment.trim();
            if (trimmed.length === 0) continue;
            const idx = normalizedSentText.indexOf(trimmed, searchFrom);
            if (idx === -1) {
                // User truncated or edited after matching some of the card — if we matched at least one
                // fixed segment, they started from the card so treat as tweaked
                if (searchFrom > 0) return 'tweaked';
                // No segment matched yet; check containment (strip placeholders so "on `x`" vs "on x" match)
                const originalWithoutPlaceholders = normalizedOriginalPrompt.replace($3181a0281282e23e$var$BACKTICK_PLACEHOLDER_REGEX, ' ').replace(/\s+/g, ' ').trim();
                if (normalizedOriginalPrompt.includes(normalizedSentText) || normalizedSentText.includes(normalizedOriginalPrompt) || originalWithoutPlaceholders.includes(normalizedSentText) || normalizedSentText.includes(originalWithoutPlaceholders) || originalWithoutPlaceholders.startsWith(normalizedSentText) || normalizedSentText.startsWith(originalWithoutPlaceholders)) return 'tweaked';
                return null;
            }
            if (searchFrom === 0 && idx !== 0) firstSegmentMatchedAtStart = false;
            searchFrom = idx + trimmed.length;
        }
        // Trailing content after the last fixed segment
        if (normalizedSentText.length > searchFrom) return 'tweaked';
        return firstSegmentMatchedAtStart ? 'placeholdersFilled' : 'tweaked';
    }
    if (normalizedSentText.includes(normalizedOriginalPrompt) || normalizedOriginalPrompt.includes(normalizedSentText)) return 'tweaked';
    return null;
};




















const $2a625a6048690629$export$883113c618365faf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (onStaggeringAnimationTimeout)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== onStaggeringAnimationTimeout) {
        t0 = {
            delay: (0, $3uG5w.ANIMATION_TIMINGS).fullscreenInput,
            onStaggeringAnimationTimeout: onStaggeringAnimationTimeout
        };
        $[0] = onStaggeringAnimationTimeout;
        $[1] = t0;
    } else t0 = $[1];
    return (0, $jAQW4.useStaggerAnimation)(t0);
} : (onStaggeringAnimationTimeout)=>{
    return (0, $jAQW4.useStaggerAnimation)({
        delay: (0, $3uG5w.ANIMATION_TIMINGS).fullscreenInput,
        onStaggeringAnimationTimeout: onStaggeringAnimationTimeout
    });
};































const $b35e3870bfb518f6$export$db09a53b5263bafa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const value = (0, $cozmU.useContext)((0, $14a71f978b3cf1ee$export$9d2115fa90a3c2ff));
    if (value === null) throw new Error("usePlaceholderOverrideValue must be used within ChatInputPlaceholderOverrideProvider");
    return value;
} : ()=>{
    const value = (0, $cozmU.useContext)((0, $14a71f978b3cf1ee$export$9d2115fa90a3c2ff));
    if (value === null) throw new Error('usePlaceholderOverrideValue must be used within ChatInputPlaceholderOverrideProvider');
    return value;
};





const $d52048b56da6323b$export$5669c83493cfd44 = (agent)=>!agent || agent.is_default === true || agent.id === (0, $6iQ4q.DEFAULT_AGENT).id || agent.named_id === (0, $6iQ4q.DEFAULT_AGENT).named_id;





const $8a6f44cdd8572770$var$message = (0, $kSwu1.defineMessages)({
    chatInputContinueAssistiveLabel: {
        id: "ai-mate.chat-input.chat-input-continue-assistive-label",
        defaultMessage: "Ask follow up"
    },
    chatInputContinueConversationPlaceholder: {
        id: "ai-mate.chat-input.chat-input-continue-conversation-placeholder",
        defaultMessage: "Describe what you want to know or do next"
    },
    chatInputDefaultPlaceholder: {
        id: "ai-mate.chat-input.chat-input-default-placeholder",
        defaultMessage: "Ask, @mention, or / for actions"
    },
    chatInputDefaultPlaceholderUpdated: {
        id: "ai-mate.chat-input.chat-input-default-placeholder.updated",
        defaultMessage: "Write a prompt, @mentions someone, or use / for actions"
    },
    chatInputTaskModePlaceholder: {
        id: "ai-mate.chat-input.chat-input-task-mode-placeholder",
        defaultMessage: "Help me create..."
    },
    chatInputDisabledAgentTooltip: {
        id: "ai-mate.chat-input.chat-input-disabled-agent-tooltip",
        defaultMessage: "Only one agent can be active at a time"
    },
    chatInputAddSourcesButton: {
        id: "ai-mate.chat-input.add-sources-button",
        defaultMessage: "Add sources"
    },
    deepResearchPlaceholder: {
        id: "ai-mate.chat-input.deep-research-placeholder",
        defaultMessage: "Get a detailed report"
    },
    queuedHeaderLabel: {
        id: "ai-mate.chat-input.queued-header-label",
        defaultMessage: "{count, plural, one {# queued message} other {# queued messages}}"
    },
    queuedMessageEmptyPreview: {
        id: "ai-mate.chat-input.queued-message-empty-preview",
        defaultMessage: "Empty message"
    },
    queuedMessageRemoveLabel: {
        id: "ai-mate.chat-input.queued-message-remove-label",
        defaultMessage: "Remove queued message: {preview}"
    }
});
var $8a6f44cdd8572770$export$2e2bcd8739ae039 = $8a6f44cdd8572770$var$message;






































const $a933791f4ee04942$var$styles = {
    queueContainer: "_4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _3vBAKH9r67 _43nrzT5zaO _0rIjyk5UaJ _0GTcwRkG2W _2xTnZxkG2W _1mT5xdRAKS _0KLXrunmFW _2C2kUQyzSk _1Lz9loyzSk _22sfPnNvrM _1aEeYeNvrM _3hhsrrdnbC _1Vs123NvrM _46hvQmgVvo _0xmtkogVvo _0LQT5E8HPE _03SyCP8HPE",
    headerButton: "_2mHwu81Y8M _2V7sgOdnbC _0wOv4Q7zJH _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg _0KLXrunmFW _2fwxA5ecOK",
    messageList: "_46hvQm1Y8M",
    messageRow: "_46hvQmFQfX _0xmtkoFQfX",
    previewText: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC"
};
const $a933791f4ee04942$var$QueuedMessageRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { item: item, preview: preview, removeLabel: removeLabel } = t0;
    let t1;
    if ($[0] !== preview) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a933791f4ee04942$var$styles.previewText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, preview));
        $[0] = preview;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== item.onRemove || $[3] !== removeLabel) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $a933791f4ee04942$var$_temp,
            label: removeLabel,
            appearance: "subtle",
            spacing: "compact",
            onClick: item.onRemove
        });
        $[2] = item.onRemove;
        $[3] = removeLabel;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a933791f4ee04942$var$styles.messageRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            spread: "space-between"
        }, t1, t2));
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ item: item, preview: preview, removeLabel: removeLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a933791f4ee04942$var$styles.messageRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a933791f4ee04942$var$styles.previewText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, preview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                ...iconProps,
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            }),
        label: removeLabel,
        appearance: "subtle",
        spacing: "compact",
        onClick: item.onRemove
    })));
};
const $a933791f4ee04942$export$3ca7a30f7f19d80d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { items: items } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const messageListId = (0, $cozmU.useId)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== isExpanded || $[2] !== items || $[3] !== messageListId) {
        const emptyPreviewLabel = formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).queuedMessageEmptyPreview);
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = ()=>setIsExpanded($a933791f4ee04942$var$_temp2);
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] !== isExpanded) {
            t3 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            });
            $[6] = isExpanded;
            $[7] = t3;
        } else t3 = $[7];
        let t4;
        if ($[8] !== formatMessage || $[9] !== items.length) {
            t4 = formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).queuedHeaderLabel, {
                count: items.length
            });
            $[8] = formatMessage;
            $[9] = items.length;
            $[10] = t4;
        } else t4 = $[10];
        let t5;
        if ($[11] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest",
                weight: "semibold"
            }, t4);
            $[11] = t4;
            $[12] = t5;
        } else t5 = $[12];
        let t6;
        if ($[13] !== isExpanded || $[14] !== messageListId || $[15] !== t3 || $[16] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: $a933791f4ee04942$var$styles.headerButton,
                onClick: t2,
                "aria-expanded": isExpanded,
                "aria-controls": messageListId
            }, t3, t5);
            $[13] = isExpanded;
            $[14] = messageListId;
            $[15] = t3;
            $[16] = t5;
            $[17] = t6;
        } else t6 = $[17];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a933791f4ee04942$var$styles.queueContainer
        }, t6, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            id: messageListId,
            xcss: $a933791f4ee04942$var$styles.messageList
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, items.map((item)=>{
            const preview = item.preview || emptyPreviewLabel;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a933791f4ee04942$var$QueuedMessageRow, {
                key: item.id,
                item: item,
                preview: preview,
                removeLabel: formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).queuedMessageRemoveLabel, {
                    preview: preview
                })
            });
        }))));
        $[0] = formatMessage;
        $[1] = isExpanded;
        $[2] = items;
        $[3] = messageListId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ items: items })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const messageListId = (0, $cozmU.useId)();
    const emptyPreviewLabel = formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).queuedMessageEmptyPreview);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a933791f4ee04942$var$styles.queueContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $a933791f4ee04942$var$styles.headerButton,
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded,
        "aria-controls": messageListId
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        weight: "semibold"
    }, formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).queuedHeaderLabel, {
        count: items.length
    }))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: messageListId,
        xcss: $a933791f4ee04942$var$styles.messageList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, items.map((item)=>{
        const preview = item.preview || emptyPreviewLabel;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a933791f4ee04942$var$QueuedMessageRow, {
            key: item.id,
            item: item,
            preview: preview,
            removeLabel: formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).queuedMessageRemoveLabel, {
                preview: preview
            })
        });
    }))));
};
function $a933791f4ee04942$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
        ...iconProps,
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    });
}
function $a933791f4ee04942$var$_temp2(prev) {
    return !prev;
}


/**
 * SBSTriggerEffect — a thin wrapper component that calls useSBSTrigger so
 * the hook (and its side effects) only run when the component is mounted.
 *
 * Render this behind a feature flag check so that non-SBS users never pay
 * the cost of the hook's fetch / event listeners.
 *
 * This component renders nothing — it only exists to own the hook lifecycle
 * and expose a single `interceptSubmit` function to the parent via ref.
 */ 









var $fItNb = parcelRequire("fItNb");

function $17d036b7e40c9d7a$export$c5df045f791f45da(doc) {
    if (!doc || !doc.content) return '';
    return $17d036b7e40c9d7a$var$extractFromNodes(doc.content).trim();
}
function $17d036b7e40c9d7a$var$extractFromNodes(nodes) {
    if (!Array.isArray(nodes)) return '';
    return nodes.map((node)=>{
        if (node.type === 'text') return node.text || '';
        // Smart links: URLs auto-converted by the editor to inline/block/embed cards
        if (node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard') return node.attrs?.url || '';
        // Rovo skill/action tags: e.g. /get-project-details typed as a slash command
        if (node.type === 'inlineExtension') {
            const skillName = node.attrs?.parameters?.slug || node.attrs?.parameters?.name;
            return skillName ? `/${skillName}` : '';
        }
        // @-mentions
        if (node.type === 'mention') return node.attrs?.text || '';
        if (node.content) {
            const childText = $17d036b7e40c9d7a$var$extractFromNodes(node.content);
            // Add newline after block-level nodes
            if (node.type && [
                'paragraph',
                'heading',
                'bulletList',
                'orderedList',
                'listItem',
                'blockquote',
                'codeBlock'
            ].includes(node.type)) return childText + '\n';
            return childText;
        }
        if (node.type === 'hardBreak') return '\n';
        return '';
    }).join('');
}


/** The custom event name fired by the consent modal when it becomes visible. */ const $64324e0b83987d58$var$SBS_MODAL_SHOWN_EVENT_NAME = 'rovo-sbs-modal-shown';
/**
 * Timeout for the modal appearance fail-safe.
 * If the consent modal hasn't appeared within this time after the SBS trigger fires,
 * something went wrong (service worker crash, message lost, render failure).
 * Release the held query so the user's message isn't silently swallowed.
 *
 * This is NOT a timeout for user response — once the modal is visible, this timeout
 * is cancelled and the user can take as long as they need.
 */ const $64324e0b83987d58$var$SBS_MODAL_APPEARANCE_TIMEOUT_MS = 10000;
function $64324e0b83987d58$var$isRovoExtensionLikelyAvailable() {
    return typeof window.rovoExtension?.openChat === 'function';
}
/**
 * Determines the SBS chat mode from the submit mode flags.
 * Maps the boolean flags to the string enum used by the SBS system.
 */ function $64324e0b83987d58$var$getSBSChatMode({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled }) {
    if (deepResearchEnabled) return 'deep_research';
    if (thinkDeeperEnabled) return 'deep_thinking';
    return 'auto';
}
/**
 * Extracts knowledge source names from the app filters.
 * Returns an array of friendly names or source identifiers.
 */ function $64324e0b83987d58$var$extractKnowledgeSources({ appFilters: appFilters }) {
    if (!appFilters) return [];
    return appFilters.map((app)=>{
        if ('friendlyName' in app && typeof app.friendlyName === 'string') return app.friendlyName;
        if ('source' in app && typeof app.source === 'string') return app.source;
        return String(app);
    });
}
function $64324e0b83987d58$export$d68c35abf5bae145({ productKey: productKey, experienceId: experienceId, siteId: siteId }) {
    // Track whether an evaluation is already in progress to prevent duplicate triggers
    const evaluationInProgressRef = (0, $cozmU.useRef)(false);
    const resetTimeoutRef = (0, $cozmU.useRef)(null);
    // Stores the callback that releases the held query (calls sendMessage)
    const queryReleaseCallbackRef = (0, $cozmU.useRef)(null);
    // Generation counter to prevent stale timeouts from releasing queries for newer evaluations
    const evaluationGenerationRef = (0, $cozmU.useRef)(0);
    // Cached list of all connectors enabled on the Rovo tenant.
    // Fetched eagerly on mount so it's ready before the first evaluation triggers.
    const rovoConnectorsRef = (0, $cozmU.useRef)([]);
    // Fetch Rovo-enabled connectors on mount (fire-and-forget, cached in ref)
    (0, $cozmU.useEffect)(()=>{
        if (!productKey) return;
        fetch('/gateway/api/assist/rovo/v1/agents/configuration/knowledge', {
            headers: {
                'x-product': productKey,
                'x-experience-id': experienceId,
                'x-cloudid': siteId
            }
        }).then((res)=>res.json()).then((data)=>{
            rovoConnectorsRef.current = (data.knowledgeSources ?? []).map((s)=>s.friendlyName || s.source || '');
        }).catch(()=>{
        // Fail silently — rovoEnabledConnectors will default to []
        });
    }, [
        productKey,
        experienceId,
        siteId
    ]);
    const releaseHeldQuery = (0, $cozmU.useCallback)(()=>{
        if (queryReleaseCallbackRef.current) {
            queryReleaseCallbackRef.current();
            queryReleaseCallbackRef.current = null;
        }
        evaluationInProgressRef.current = false;
        if (resetTimeoutRef.current !== null) {
            clearTimeout(resetTimeoutRef.current);
            resetTimeoutRef.current = null;
        }
    }, []);
    const setQueryReleaseCallback = (0, $cozmU.useCallback)((callback)=>{
        queryReleaseCallbackRef.current = callback;
    }, []);
    const triggerSbsEvaluation = (0, $cozmU.useCallback)(({ prompt: prompt, mode: mode, conversationId: conversationId, siteId: siteId_0, productKey: productKey_0, existingMessageCount: existingMessageCount, implicitContextUrl: implicitContextUrl })=>{
        try {
            // Don't trigger if an evaluation is already in progress
            if (evaluationInProgressRef.current) return {
                shouldHoldQuery: false
            };
            if (!(0, $iDrrr.fg)('rovo-ext_sbs_enabled')) return {
                shouldHoldQuery: false
            };
            // The Rovo extension injects window.rovoExtension.openChat from rovo-window-triggers.js.
            // If it is absent, the extension is likely disabled/not injected, so do not hold chat for SBS.
            if (!$64324e0b83987d58$var$isRovoExtensionLikelyAvailable()) return {
                shouldHoldQuery: false
            };
            const plainTextQuery = (0, $17d036b7e40c9d7a$export$c5df045f791f45da)(prompt);
            // Don't trigger for empty queries
            if (!plainTextQuery || plainTextQuery.trim().length === 0) return {
                shouldHoldQuery: false
            };
            // First-message guard: only trigger SBS on the first message in a conversation.
            if (existingMessageCount > 0) return {
                shouldHoldQuery: false
            };
            const chatMode = $64324e0b83987d58$var$getSBSChatMode({
                deepResearchEnabled: mode.deepResearchEnabled,
                thinkDeeperEnabled: mode.thinkDeeperEnabled
            });
            const knowledgeSources = $64324e0b83987d58$var$extractKnowledgeSources({
                appFilters: mode.appFilters
            });
            const isChatGPTEligible = (0, $iDrrr.fg)('rovo-ext_sbs_chatgpt_eligible');
            // Prepend implicit context (e.g. the Confluence page shown in the context banner)
            // so that competitors and the Rovo Chrome Extension receive the same page context
            // as Rovo. Format: "Context: <url>\n<original query>"
            const queryWithContext = implicitContextUrl && implicitContextUrl.trim() ? `Context: ${implicitContextUrl.trim()}\n${plainTextQuery}` : plainTextQuery;
            evaluationInProgressRef.current = true;
            window.dispatchEvent(new CustomEvent((0, $fItNb.SBS_TRIGGER_EVENT_NAME), {
                detail: {
                    query: queryWithContext,
                    chatMode: chatMode,
                    knowledgeSources: knowledgeSources,
                    rovoEnabledConnectors: rovoConnectorsRef.current,
                    conversationId: conversationId,
                    siteId: siteId_0,
                    product: productKey_0,
                    isChatGPTEligible: isChatGPTEligible
                }
            }));
            // Modal appearance fail-safe
            if (resetTimeoutRef.current !== null) clearTimeout(resetTimeoutRef.current);
            evaluationGenerationRef.current += 1;
            const thisGeneration = evaluationGenerationRef.current;
            resetTimeoutRef.current = setTimeout(()=>{
                if (evaluationGenerationRef.current !== thisGeneration) return;
                // eslint-disable-next-line no-console
                console.warn("[SBS] Modal appearance timeout fired \u2014 consent modal did not appear within", $64324e0b83987d58$var$SBS_MODAL_APPEARANCE_TIMEOUT_MS, 'ms. Releasing held query.');
                releaseHeldQuery();
            }, $64324e0b83987d58$var$SBS_MODAL_APPEARANCE_TIMEOUT_MS);
            return {
                shouldHoldQuery: true
            };
        } catch  {
            // SBS must never break normal Rovo Chat — silently ignore all errors
            evaluationInProgressRef.current = false;
            return {
                shouldHoldQuery: false
            };
        }
    }, [
        releaseHeldQuery
    ]);
    // Cancel the modal-appearance timeout when the modal becomes visible
    (0, $cozmU.useEffect)(()=>{
        const handleModalShown = ()=>{
            if (resetTimeoutRef.current !== null) {
                clearTimeout(resetTimeoutRef.current);
                resetTimeoutRef.current = null;
            }
        };
        const unbind = (0, $cbY7C.bind)(window, {
            type: $64324e0b83987d58$var$SBS_MODAL_SHOWN_EVENT_NAME,
            listener: handleModalShown
        });
        return unbind;
    }, []);
    // Listen for consent response events to release the held query
    (0, $cozmU.useEffect)(()=>{
        const handleConsentReceived = ()=>{
            releaseHeldQuery();
        };
        const unbind_0 = (0, $cbY7C.bind)(window, {
            type: (0, $fItNb.SBS_CONSENT_RECEIVED_EVENT_NAME),
            listener: handleConsentReceived
        });
        return unbind_0;
    }, [
        releaseHeldQuery
    ]);
    // Cleanup on unmount: release any held query
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            releaseHeldQuery();
        };
    }, [
        releaseHeldQuery
    ]);
    return {
        triggerSbsEvaluation: triggerSbsEvaluation,
        releaseHeldQuery: releaseHeldQuery,
        setQueryReleaseCallback: setQueryReleaseCallback
    };
}


function $61497a805f31bc51$export$141da6742e7e62a1({ productKey: productKey, experienceId: experienceId, siteId: siteId, interceptSubmitRef: interceptSubmitRef }) {
    const { triggerSbsEvaluation: triggerSbsEvaluation, setQueryReleaseCallback: setQueryReleaseCallback } = (0, $64324e0b83987d58$export$d68c35abf5bae145)({
        productKey: productKey,
        experienceId: experienceId,
        siteId: siteId
    });
    // Keep the ref in sync with the latest hook values.
    interceptSubmitRef.current = (params, doSendMessage)=>{
        const { shouldHoldQuery: shouldHoldQuery } = triggerSbsEvaluation(params);
        if (shouldHoldQuery) {
            setQueryReleaseCallback(doSendMessage);
            return true;
        }
        return false;
    };
    return null;
}











const $619d72f6a6eaa701$export$38b8b360f01c9f9b = (storeMessages)=>{
    const messages = [];
    const keyParts = [];
    for (const message of storeMessages){
        if ((0, $igOtY.isStoreHuman)(message)) {
            const contextMessage = {
                id: message.content.id,
                content: message.content.content
            };
            messages.push(contextMessage);
            keyParts.push(`human:${contextMessage.id}`);
            continue;
        }
        if ((0, $igOtY.isStoreAssistant)(message) && message.content.streamingComplete) {
            // Keep ADF responses too; getContext flattens them like human messages.
            const contextMessage = {
                id: message.content.message.message.id,
                content: message.content.message.message.content
            };
            messages.push(contextMessage);
            keyParts.push(`assistant:${contextMessage.id}`);
        }
    }
    return {
        key: keyParts.join('|'),
        messages: messages
    };
};


const $13257b7e4ebec8a2$export$e46ad00c414fe0cd = (storeMessages)=>{
    const { key: key, messages: messages } = (0, $cozmU.useMemo)(()=>(0, $619d72f6a6eaa701$export$38b8b360f01c9f9b)(storeMessages), [
        storeMessages
    ]);
    const messagesRef = (0, $cozmU.useRef)(messages);
    messagesRef.current = messages;
    const listenersRef = (0, $cozmU.useRef)(new Set());
    const getContext = (0, $cozmU.useCallback)(async ()=>{
        const siblingCommentsContents = [];
        for (const { content: content } of messagesRef.current){
            const messageContent = (typeof content === 'string' ? content : (0, $lNd2W.extractPlainTextFromAdf)(content)).trim();
            if (messageContent) siblingCommentsContents.push(messageContent);
        }
        if (siblingCommentsContents.length === 0) return undefined;
        return {
            siblingCommentsContents: siblingCommentsContents
        };
    }, []);
    const subscribeToContextUpdates = (0, $cozmU.useCallback)((listener)=>{
        listenersRef.current.add(listener);
        return ()=>{
            listenersRef.current.delete(listener);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Empty key = no eligible context yet; skip notify to avoid a spurious getContext().
        if (!key) return;
        listenersRef.current.forEach((listener_0)=>{
            listener_0();
        });
    }, [
        key
    ]);
    (0, $cozmU.useEffect)(()=>{
        const listeners = listenersRef.current;
        return ()=>{
            listeners.clear();
        };
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            getContext: getContext,
            subscribeToContextUpdates: subscribeToContextUpdates,
            useLocalModel: true
        }), [
        getContext,
        subscribeToContextUpdates
    ]);
};
























const $30653238b859d3a7$export$df1b8ff3f5ef2b16 = (selectedAgentCandidate, activeSelectedAgentId, currentAgent)=>{
    if (!activeSelectedAgentId) return undefined;
    if (selectedAgentCandidate?.id !== activeSelectedAgentId) return undefined;
    if ((0, $d52048b56da6323b$export$5669c83493cfd44)(selectedAgentCandidate)) // Selecting the default Rovo agent ("Switch to Rovo") is a meaningful override only in an
    // agentic (dedicated-agent) chat, where it switches the next message away from the
    // conversation's agent — so surface it as a dismissable hat there. In a standard Rovo chat
    // the baseline is already the default agent, so the hat would be a redundant no-op.
    return (0, $d52048b56da6323b$export$5669c83493cfd44)(currentAgent) ? undefined : selectedAgentCandidate;
    return selectedAgentCandidate.id === currentAgent?.id ? undefined : selectedAgentCandidate;
};


const $d4b999848982a7c8$export$e1a98299af461ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { conversationId: conversationId, activeSelectedAgentId: activeSelectedAgentId, selectedAgentIdentityAccountId: selectedAgentIdentityAccountId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents");
        $[0] = t1;
    } else t1 = $[0];
    const isAgentSelectionEnabled = t1;
    let t2;
    if ($[1] !== activeSelectedAgentId) {
        t2 = isAgentSelectionEnabled && (0, $2yWJZ.isDefaultRovoChat)({
            agentId: activeSelectedAgentId
        });
        $[1] = activeSelectedAgentId;
        $[2] = t2;
    } else t2 = $[2];
    const isDefaultAgentSelected = t2;
    const selectedAgentCandidateForInputHat = isDefaultAgentSelected ? {
        ...(0, $6iQ4q.DEFAULT_AGENT),
        id: (0, $2yWJZ.DEFAULT_AGENT_UUID),
        name: "Rovo"
    } : activeSelectedAgentId && selectedAgentIdentityAccountId ? {
        id: activeSelectedAgentId,
        name: "",
        identity_account_id: selectedAgentIdentityAccountId
    } : undefined;
    let t3;
    if ($[3] !== conversationId) {
        t3 = {
            conversationId: conversationId
        };
        $[3] = conversationId;
        $[4] = t3;
    } else t3 = $[4];
    const { selectedAgent: currentAgent } = (0, $5wAPd.useConversation)(t3);
    const inputHatSelectedAgent = isAgentSelectionEnabled ? (0, $30653238b859d3a7$export$df1b8ff3f5ef2b16)(selectedAgentCandidateForInputHat, activeSelectedAgentId, currentAgent) : undefined;
    const id = inputHatSelectedAgent?.id;
    const resolvedName = inputHatSelectedAgent?.name;
    const resolvedIdentityAccountId = inputHatSelectedAgent?.identity_account_id ?? undefined;
    const isDefault = isDefaultAgentSelected || undefined;
    let t4;
    if ($[5] !== id || $[6] !== isDefault || $[7] !== resolvedIdentityAccountId || $[8] !== resolvedName) {
        t4 = id && (isDefault || resolvedIdentityAccountId) ? {
            id: id,
            name: resolvedName,
            identityAccountId: resolvedIdentityAccountId,
            isDefault: isDefault
        } : undefined;
        $[5] = id;
        $[6] = isDefault;
        $[7] = resolvedIdentityAccountId;
        $[8] = resolvedName;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ conversationId: conversationId, activeSelectedAgentId: activeSelectedAgentId, selectedAgentIdentityAccountId: selectedAgentIdentityAccountId })=>{
    const isAgentSelectionEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    // The default Rovo agent is a client-side sentinel with no backend record, so hydrating it via
    // the agents API would 404. Use the local DEFAULT_AGENT constant for it instead.
    const isDefaultAgentSelected = isAgentSelectionEnabled && (0, $2yWJZ.isDefaultRovoChat)({
        agentId: activeSelectedAgentId
    });
    const selectedAgentCandidateForInputHat = isDefaultAgentSelected ? {
        ...(0, $6iQ4q.DEFAULT_AGENT),
        id: (0, $2yWJZ.DEFAULT_AGENT_UUID),
        name: 'Rovo'
    } : activeSelectedAgentId && selectedAgentIdentityAccountId ? {
        id: activeSelectedAgentId,
        name: '',
        identity_account_id: selectedAgentIdentityAccountId
    } : undefined;
    const { selectedAgent: currentAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    });
    const inputHatSelectedAgent = isAgentSelectionEnabled ? (0, $30653238b859d3a7$export$df1b8ff3f5ef2b16)(selectedAgentCandidateForInputHat, activeSelectedAgentId, currentAgent) : undefined;
    const id = inputHatSelectedAgent?.id;
    const resolvedName = inputHatSelectedAgent?.name;
    const resolvedIdentityAccountId = inputHatSelectedAgent?.identity_account_id ?? undefined;
    const isDefault = isDefaultAgentSelected || undefined;
    return (0, $cozmU.useMemo)(()=>id && (isDefault || resolvedIdentityAccountId) ? {
            id: id,
            name: resolvedName,
            identityAccountId: resolvedIdentityAccountId,
            isDefault: isDefault
        } : undefined, [
        id,
        resolvedName,
        resolvedIdentityAccountId,
        isDefault
    ]);
};


const $bce24d6530bd077f$export$122ba66a2f61ebdf = (fetchContext)=>{
    const getCustomFollowUpContext = async ()=>{
        if (fetchContext) try {
            const customFollowUpContext = await fetchContext() ?? [];
            return customFollowUpContext;
        } catch  {
            return [];
        }
    };
    return {
        getCustomFollowUpContext: getCustomFollowUpContext
    };
};


const $a33c889c756d4321$var$INPUT_TYPING_SESSION_MAX_DURATION = 120000; // Stable empty list so unenrolled users skip the per-render message scan.
const $a33c889c756d4321$var$NO_AUTOCOMPLETE_MESSAGES = [];
const $a33c889c756d4321$var$CHAT_INPUT_INTERACTION_SOURCE = 'chatInput';
const $a33c889c756d4321$var$getSelectedAgentOverrideId = ({ nextMessageSelectedAgentId: nextMessageSelectedAgentId, currentAgent: currentAgent })=>{
    if (!nextMessageSelectedAgentId) return undefined;
    if (nextMessageSelectedAgentId === currentAgent?.id || nextMessageSelectedAgentId === (0, $6iQ4q.DEFAULT_AGENT).id) return undefined;
    return nextMessageSelectedAgentId;
};
const $a33c889c756d4321$var$getSendMessageAgentParam = ({ selectedAgentOverrideId: selectedAgentOverrideId, currentAgent: currentAgent })=>{
    if (selectedAgentOverrideId) return {
        agentId: selectedAgentOverrideId
    };
    return {
        agent: currentAgent
    };
};
const $a33c889c756d4321$var$ChatInputComponent = (props)=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $5wAPd.useConversation), (0, $lTU4O.useUserPreferences), (0, $3z1p5.useAgentsPaginatedByAgentId));
    const fullscreenInputStaggerAnimation = (0, $2a625a6048690629$export$883113c618365faf)();
    const { conversationId: conversationId, activeAction: activeAction, onSubmitOverride: onSubmitOverride, placeholderOverride: propPlaceholderOverride, suppressInitialFocus: suppressInitialFocus, initialPromptText: initialPromptText, shouldSeedInitialPromptText: shouldSeedInitialPromptText, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, selectedSpace: selectedSpace, smartLink3PPostAuth: smartLink3PPostAuth } = props;
    const { productKey: productKey, productHeader: productHeader, siteId: siteId, orgId: orgId, experienceId: experienceId } = (0, $eKjv9.useGlobalConfig)();
    const { setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStoreActions)();
    const { fullScreen: fullScreen, elements: elements, promptInputDroppableUrls: promptInputDroppableUrls, enableBrowserContextBanner: enableBrowserContextBanner, browserContextSanitizer: browserContextSanitizer } = (0, $dSCNl.useUIConfig)(); // Derive entity context override from Smart Link post-auth or empty-launch store for
    // entity-driven launches. When present, the context banner shows this entity instead of
    // the current page and sends only entity context to the backend.
    const [{ projectContext: emptyLaunchProjectContext, interactionSource: emptyLaunchInteractionSource, invokedFrom: emptyLaunchInvokedFrom }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const smartLink3PPostAuthIsActive = (0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg') && smartLink3PPostAuth?.isActive;
    const smartLink3PPostAuthProjectContext = smartLink3PPostAuthIsActive ? smartLink3PPostAuth.projectContext : undefined;
    const aiFeatureContextOverride = (0, $cozmU.useMemo)(()=>{
        const projectContext = smartLink3PPostAuthProjectContext ?? emptyLaunchProjectContext;
        const override = projectContext ? {
            entityContext: {
                url: projectContext.projectUrl,
                name: projectContext.projectName
            }
        } : undefined;
        return override;
    }, [
        emptyLaunchProjectContext,
        smartLink3PPostAuthProjectContext
    ]);
    const useCurrentPageContextForInput = elements?.shouldShowContextBanner !== false && !elements?.stagingAreaEnabled && !isChatOnboardingMiniModalOpen && !smartLink3PPostAuthIsActive;
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        conversationId: props.conversationId
    });
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'chatInput'
    });
    const [activeSelectedAgentState, setActiveSelectedAgentState] = (0, $cozmU.useState)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendMessage: sendMessage, abortRequests: abortRequests, createSeededConversation: createSeededConversation } = (0, $3TxKn.useChatStoreActions)();
    const isSpaceScopedConversation = Boolean(conversation?.rovoSpaceId || selectedSpace);
    const spaces = (0, $12shJ.useSpaces)();
    const activeRovoSpace = spaces.find((s)=>[
            conversation?.rovoSpaceId,
            selectedSpace?.id
        ].includes(s.id)); // The active space ID is derived directly from the conversation or selected space — not from
    // the store — because the SpaceStore may still be loading when this component first renders
    // (e.g. on reload with a space already selected), meaning activeRovoSpace would be undefined
    // even though a space IS selected.
    const activeSpaceId = conversation?.rovoSpaceId ?? selectedSpace?.id ?? ''; // Fetch individual space details when the store doesn't yet have sources for the active space.
    // This ensures SpaceContextBanner shows the correct source count on reload, before
    // the space list fetch completes and populates the store.
    const { space: fetchedSpace } = (0, $1aCne.useGetSpace)({
        spaceId: activeSpaceId,
        cloudId: siteId,
        product: productKey,
        experienceId: experienceId,
        enabled: Boolean(activeSpaceId) && (activeRovoSpace === undefined || activeRovoSpace.sources === undefined)
    });
    const activeSpaceSources = (0, $cozmU.useMemo)(()=>activeRovoSpace?.sources ?? fetchedSpace?.sources, [
        activeRovoSpace?.sources,
        fetchedSpace?.sources
    ]);
    const areActiveSpaceSourcesKnown = activeSpaceSources !== undefined;
    const activeSpaceSourceOptions = (0, $cozmU.useMemo)(()=>(activeSpaceSources ?? []).map((source)=>({
                id: source.id,
                url: source.url,
                title: source.name ?? source.url,
                sourceType: source.sourceType
            })), [
        activeSpaceSources
    ]);
    const spaceSourcePlugins = (0, $d4397f8d51eab4c7$export$7ba3849109541ac3)(siteId);
    const { addSource: addSource } = (0, $jqWbJ.useAddSpaceSource)({
        spaceId: activeSpaceId,
        cloudId: siteId,
        product: productKey,
        experienceId: experienceId
    });
    const handleZeroSourcesSourceAdded = (0, $cozmU.useCallback)((source)=>{
        addSource({
            url: source.url,
            ari: source.id,
            name: source.title,
            sourceType: source.sourceType
        });
    }, [
        addSource
    ]);
    const zeroSourcesAction = (0, $cozmU.useMemo)(()=>isSpaceScopedConversation && areActiveSpaceSourcesKnown && activeSpaceSources.length === 0 ? /*#__PURE__*/ $cozmU.createElement((0, $c75163609085e392$export$43b333124c26a133), {
            plugins: spaceSourcePlugins,
            cloudId: siteId,
            sources: activeSpaceSourceOptions,
            onSourceAdded: handleZeroSourcesSourceAdded,
            trigger: ({ ref: ref, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement("span", {
                    ref: ref,
                    ...triggerProps
                }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                    appearance: "primary",
                    onClick: onClick,
                    testId: "zero-sources-banner-add-sources-button",
                    shouldFitContainer: true
                }, formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputAddSourcesButton)))
        }) : undefined, [
        activeSpaceSourceOptions,
        areActiveSpaceSourcesKnown,
        activeSpaceSources,
        formatMessage,
        handleZeroSourcesSourceAdded,
        isSpaceScopedConversation,
        siteId,
        spaceSourcePlugins
    ]);
    const sbsInterceptSubmitRef = (0, $cozmU.useRef)(null);
    const windowLocation = (0, $hd4Ag.useWindowLocation)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { takePromptCardSource: takePromptCardSource } = (0, $jmZRX.usePromptCardSendTrackingActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { getCustomFollowUpContext: getCustomFollowUpContext } = (0, $bce24d6530bd077f$export$122ba66a2f61ebdf)(activeAction?.customFollowUpContext?.fetch);
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const { stagingAreaMode: stagingAreaMode, promptAppConnectorSources: promptAppConnectorSources } = (0, $8akfd.useStagingAreaState)();
    const { setPromptAppConnectorSources: setPromptAppConnectorSources } = (0, $8akfd.useStagingAreaActions)();
    const { handlePromptAppConnectors: handlePromptAppConnectors } = (0, $7sEW2.usePromptAppConnectors)({
        conversationId: conversationId,
        assistanceServiceParams: assistanceServiceParams
    }); // A 3P suggested prompt staged from the Create-with-Rovo modal carries its
    // connector sources here; surface the app-connection banner for them (with the
    // per-row Connected state on), then clear so it fires once per staged prompt.
    (0, $cozmU.useEffect)(()=>{
        if (promptAppConnectorSources.length === 0) return;
        handlePromptAppConnectors(promptAppConnectorSources, {
            showConnectedState: true
        });
        setPromptAppConnectorSources([]);
    }, [
        promptAppConnectorSources,
        handlePromptAppConnectors,
        setPromptAppConnectorSources
    ]);
    const [promptInputMetricsState, setPromptInputMetricsState] = (0, $cozmU.useState)({
        lastInteractionTime: null,
        isFirstInitiation: true
    });
    const { cacheFiles: cacheFiles } = (0, $dTzKN.useFileThumbnails)([]);
    const [messageQueue, setMessageQueue] = (0, $cozmU.useState)([]);
    const queueIdCounterRef = (0, $cozmU.useRef)(0);
    const isAgentTyping = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
    const shouldMinimizeInputHeight = props.isExpanded && conversation?.id === (0, $4m5jb.EMPTY_CONVERSATION_ID);
    const contentContext = elements?.stagingAreaEnabled ? 'staging-area' : 'global';
    const isStudioSkillsInStagingAreaEnabled = productHeader === 'atlassian-studio' && (0, $iDrrr.fg)('rovo_chat_studio_skills_in_staging_area');
    const resolvedEnableSkills = isStudioSkillsInStagingAreaEnabled ? true : props.enableSkills;
    const isDefaultAgent = (0, $d52048b56da6323b$export$5669c83493cfd44)(selectedAgent);
    const [storeMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const shouldEvaluateTypeaheadExperiment = !storeMessages.length || !conversation;
    const shouldUseTypeahead = shouldEvaluateTypeaheadExperiment && (0, $cXtTj.default).getExperimentValue('rovo_chat_typeahead', 'isEnabled', false);
    const userMessagesForEditor = (0, $cozmU.useMemo)(()=>{
        return storeMessages.filter((0, $igOtY.isStoreHuman)).map((message)=>({
                id: message.content.id,
                content: message.content.content
            }));
    }, [
        storeMessages
    ]); // Store-backed human messages are the completed user turns. The prompt is
    // therefore on the next one-indexed turn, without counting assistant/system
    // items or the current unsent draft. While an existing conversation is in its
    // explicit loading state, the empty message list is not yet a known turn.
    const isNewConversation = conversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID);
    const isChatTurnKnown = isNewConversation || conversation !== undefined && conversation.status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat;
    const chatTurnNumber = isChatTurnKnown ? userMessagesForEditor.length + 1 : undefined; // The empty-chat sentinel is a UI workspace, not a chat session. For every
    // real conversation, reuse the store id used by the shared analytics context
    // so mention events remain joinable with header and chat-quality events.
    const chatSessionId = isNewConversation ? undefined : conversationId; // Exposure is fired by the preset's gate read; suppress here to avoid double-counting.
    const isAutocompleteEnabled = (0, $cXtTj.default).getExperimentValue('platform_editor_ai_autocomplete_rovo_chat_editor', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const autocompleteContext = (0, $13257b7e4ebec8a2$export$e46ad00c414fe0cd)(isAutocompleteEnabled ? storeMessages : $a33c889c756d4321$var$NO_AUTOCOMPLETE_MESSAGES);
    const contextPlaceholderOverride = (0, $b35e3870bfb518f6$export$db09a53b5263bafa)();
    const [chatModeState] = (0, $7685l.useChatModeStore)(conversationId);
    const { setSourceMode: setSourceMode } = (0, $aJU2k.useChatModeStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo_chat_space_source_mode') || !conversation?.rovoSpaceId || conversation.sourceMode === undefined) return;
        setSourceMode(conversationId, conversation.sourceMode);
    }, [
        conversation?.rovoSpaceId,
        conversation?.sourceMode,
        conversationId,
        setSourceMode
    ]);
    const enableMaxMode = elements?.maxModeButton ?? true;
    const isTaskModeEnabled = enableMaxMode && chatModeState.taskModeEnabled;
    const placeholderOverride = (0, $cozmU.useMemo)(()=>{
        if (propPlaceholderOverride) return propPlaceholderOverride;
        if (isTaskModeEnabled) return formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputTaskModePlaceholder);
        if (chatModeState.deepResearchEnabled && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) return formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).deepResearchPlaceholder);
        const isNotEmptyConversation = conversationId && conversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID);
        if (contextPlaceholderOverride) return contextPlaceholderOverride;
        if (isNotEmptyConversation) return formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputContinueConversationPlaceholder);
        return (0, $cXtTj.default).getExperimentValue('rovo-chat-input-placeholder-updated', 'isEnabled', false) ? formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputDefaultPlaceholderUpdated) : formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputDefaultPlaceholder);
    }, [
        conversationId,
        formatMessage,
        contextPlaceholderOverride,
        propPlaceholderOverride,
        isTaskModeEnabled,
        chatModeState.deepResearchEnabled
    ]);
    const sendSeededConversationAndCleanup = (0, $cozmU.useCallback)(async (dialogues)=>{
        const newConversationId = await (0, $06e06793fd7485e7$export$c31f962be9ed3f35)({
            action: activeAction,
            dialogues: dialogues,
            createSeededConversation: createSeededConversation,
            fallbackName: dialogues[0].human_message.content,
            // leverage the canned prompt from the action
            sourceId: conversation?.sourceId,
            id: conversationId,
            defaultFollowUpSource: 'ai-smart-button-dynamic-surface',
            agentId: selectedAgent?.id
        });
        if (!newConversationId) return;
         // Engage succeeds via `onCreated`; only remove the view, not dismiss state.
        setActiveAction(undefined);
    }, [
        activeAction,
        conversation?.sourceId,
        conversationId,
        createSeededConversation,
        selectedAgent?.id,
        setActiveAction
    ]);
    const onPromptChange = (0, $cozmU.useCallback)(()=>{
        //Setting up ai-mate.message-composition-time interaction metric
        const { isFirstInitiation: isFirstInitiation, lastInteractionTime: lastInteractionTime } = promptInputMetricsState;
        const now = Date.now();
        const isInactive = !lastInteractionTime || now - lastInteractionTime > $a33c889c756d4321$var$INPUT_TYPING_SESSION_MAX_DURATION;
        if (isInactive) {
            (0, $4tJut.interactionMetrics).messageCompositionTime.cancel();
            setPromptInputMetricsState({
                lastInteractionTime: now,
                isFirstInitiation: true
            });
            return;
        }
        if (isFirstInitiation) {
            (0, $4tJut.interactionMetrics).messageCompositionTime.start();
            setPromptInputMetricsState((prevState)=>({
                    ...prevState,
                    isFirstInitiation: false
                }));
        }
    }, [
        promptInputMetricsState,
        setPromptInputMetricsState
    ]);
    const normalizePromptText = (0, $cozmU.useCallback)((text)=>text.trim().replace(/\s+/g, ' '), []);
    const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const isMentionAgentsExperimentEligible = props.enableAgentMentions !== false; // Preserve the old gate-derived default for integrations that omit the prop,
    // while allowing an explicit false to opt out of agent mentions.
    const isAgentSelectionEnabled = isMentionAgentsExperimentEligible && isMentionAgentsExperimentEnabled;
    const activeSelectedAgentId = activeSelectedAgentState?.conversationId === conversationId ? activeSelectedAgentState.id : undefined;
    const handleSelectedAgentChange = (0, $cozmU.useCallback)((agent)=>{
        setActiveSelectedAgentState(agent ? {
            conversationId: conversationId,
            id: agent.id,
            identityAccountId: agent.identityAccountId
        } : {
            conversationId: conversationId
        });
    }, [
        conversationId
    ]);
    const selectedAgentForInputHat = (0, $d4b999848982a7c8$export$e1a98299af461ab)({
        conversationId: conversationId,
        activeSelectedAgentId: activeSelectedAgentId,
        selectedAgentIdentityAccountId: activeSelectedAgentState?.conversationId === conversationId ? activeSelectedAgentState.identityAccountId : undefined
    });
    const getSelectedAgentOverrideForId = (0, $cozmU.useCallback)((inputSelectedAgentId)=>isAgentSelectionEnabled ? $a33c889c756d4321$var$getSelectedAgentOverrideId({
            nextMessageSelectedAgentId: inputSelectedAgentId,
            currentAgent: selectedAgent
        }) : undefined, [
        isAgentSelectionEnabled,
        selectedAgent
    ]);
    const selectedAgentOverrideId = getSelectedAgentOverrideForId(activeSelectedAgentId);
    const onSubmit = (0, $cozmU.useCallback)(async (prompt, mode, files)=>{
        if (onSubmitOverride) {
            onSubmitOverride(prompt);
            return;
        }
        if (isChatOnboardingMiniModalOpen) setIsChatOnboardingMiniModalOpen(false);
        const promptCardSource = takePromptCardSource();
        if (isAgentTyping && !activeAction?.customFollowUpContext?.available && (0, $iDrrr.fg)('rovo_chat_message_queue')) {
            const preview = (0, $lNd2W.extractPlainTextFromAdf)(prompt).trim();
            const nextId = queueIdCounterRef.current += 1;
            setMessageQueue((prev)=>[
                    ...prev,
                    {
                        id: nextId,
                        prompt: prompt,
                        mode: mode,
                        files: files,
                        preview: preview
                    }
                ]);
            return;
        }
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sendMessageButton',
            attributes: {
                agentId: selectedAgentOverrideId ?? selectedAgent?.id
            }
        });
        if (activeAction?.customFollowUpContext?.available) {
            const dialogues = await getCustomFollowUpContext();
            dialogues && await sendSeededConversationAndCleanup(dialogues);
        }
        if (files) cacheFiles(files.filter((file)=>file.fileObject && file.id).map((file)=>({
                id: file.id,
                fileObject: file.fileObject
            })));
        const submittedSelectedAgentId = mode.inputSelectedAgentId;
        const submittedMessageAgentIdentity = mode.messageAgentIdentity;
        const submittedSelectedAgentOverrideId = getSelectedAgentOverrideForId(submittedSelectedAgentId);
        const submittedSendMessageAgentParam = $a33c889c756d4321$var$getSendMessageAgentParam({
            selectedAgentOverrideId: submittedSelectedAgentOverrideId,
            currentAgent: selectedAgent
        });
        const doSendMessage = ()=>{
            // `mode.skillSelectionSource` was captured by the chat-prompt-input from
            // the AnalyticsPropertiesContext at submit time and cleared there as well,
            // so this layer can simply forward the value without any additional cleanup.
            // When the chat is scoped to a Rovo Space, include the spaceId in every
            // sendMessage call so the backend can contextualise the conversation.
            const activeSpaceId = selectedSpace?.id ?? conversation?.rovoSpaceId;
            const resolvedSpaceId = activeSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? activeSpaceId : undefined;
            const spaceContext = resolvedSpaceId ? {
                spaceId: resolvedSpaceId
            } : {};
            sendMessage({
                prompt: prompt,
                ...submittedSendMessageAgentParam,
                ...isAgentSelectionEnabled && submittedSelectedAgentId ? {
                    inputSelectedAgentIds: [
                        submittedSelectedAgentId
                    ],
                    messageAgentIdentity: submittedMessageAgentIdentity
                } : {},
                // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                storeUserMessages: preferences.storeUserMessages,
                messageSources: {
                    interactionSource: emptyLaunchInteractionSource ?? $a33c889c756d4321$var$CHAT_INPUT_INTERACTION_SOURCE,
                    invokedFrom: emptyLaunchInvokedFrom
                },
                files: files,
                thinkDeeperEnabled: mode.thinkDeeperEnabled,
                alphaExtendedThinkingMode: mode.alphaExtendedThinkingMode,
                deepResearchEnabled: mode.deepResearchEnabled,
                fastModeEnabled: mode.fastModeEnabled,
                taskModeEnabled: mode.taskModeEnabled,
                webSearchEnabled: mode.webSearchEnabled,
                sourceMode: mode.sourceMode,
                appFilters: mode.appFilters,
                // Suppress current page context during entity-driven launches so the
                // backend only receives the entity's project context, not the current page.
                addCurrentPageAsContextUserPreference: aiFeatureContextOverride ? false : mode.addCurrentPageAsContext,
                productKey: productKey,
                shouldExtractConversationScopes: mode.shouldExtractConversationScopes,
                skillSelectionSource: mode.skillSelectionSource,
                ...spaceContext
            });
        }; // SBS evaluation trigger — checks if this query should be held for SBS consent.
        // If SBS triggers, the query is held until the user responds to the consent modal.
        // On consent/decline/opt-out, the held query is released and doSendMessage is called.
        const queryHeld = sbsInterceptSubmitRef.current?.({
            prompt: prompt,
            mode: mode,
            conversationId: conversationId,
            siteId: siteId,
            productKey: productKey,
            existingMessageCount: storeMessages.length,
            // Pass the current page URL as implicit context when the user has "add current page
            // as context" enabled. This allows the SBS system to prepend "Context: <url>" to
            // the query sent to competitors and the Rovo Chrome Extension, giving them the same
            // page context that Rovo receives implicitly via the AI feature context system.
            implicitContextUrl: mode.addCurrentPageAsContext ? windowLocation : undefined
        }, doSendMessage);
        if (!queryHeld) // Normal flow — no SBS, submit immediately
        doSendMessage();
        if (promptCardSource) {
            const sentText = normalizePromptText((0, $lNd2W.extractPlainTextFromAdf)(prompt));
            const originalText = normalizePromptText(promptCardSource.prompt);
            const sendType = (0, $3181a0281282e23e$export$2def72d3ef808307)(sentText, originalText);
            if (sendType !== null) {
                const actionSubjectId = sendType === 'asIs' ? 'promptCardSentAsIs' : sendType === 'placeholdersFilled' ? 'promptCardSentWithPlaceholdersFilled' : 'promptCardSentTweaked';
                sendAnalyticsEvent({
                    action: 'sent',
                    actionSubject: 'prompt',
                    actionSubjectId: actionSubjectId,
                    attributes: {
                        cardId: promptCardSource.cardId,
                        sendType: sendType,
                        ...promptCardSource.promptSource != null && {
                            promptSource: promptCardSource.promptSource
                        },
                        ...promptCardSource.isFavorited != null && {
                            isFavorited: promptCardSource.isFavorited
                        }
                    }
                });
            }
        }
        const now = Date.now();
        const isInactive = !promptInputMetricsState.lastInteractionTime || now - promptInputMetricsState.lastInteractionTime > $a33c889c756d4321$var$INPUT_TYPING_SESSION_MAX_DURATION; //In the edge case that someone waits over two minutes to submit their prompt after not typing
        if (!isInactive) {
            (0, $4tJut.interactionMetrics).messageCompositionTime.stop();
            setPromptInputMetricsState((prevState)=>({
                    ...prevState,
                    isFirstInitiation: true
                }));
        }
    }, [
        selectedAgentOverrideId,
        selectedAgent,
        getSelectedAgentOverrideForId,
        isAgentSelectionEnabled,
        preferences.storeUserMessages,
        sendAnalyticsEvent,
        sendMessage,
        productKey,
        siteId,
        conversationId,
        activeAction?.customFollowUpContext,
        getCustomFollowUpContext,
        sendSeededConversationAndCleanup,
        cacheFiles,
        promptInputMetricsState.lastInteractionTime,
        setPromptInputMetricsState,
        takePromptCardSource,
        normalizePromptText,
        setIsChatOnboardingMiniModalOpen,
        storeMessages.length,
        aiFeatureContextOverride,
        windowLocation,
        onSubmitOverride,
        selectedSpace,
        conversation?.rovoSpaceId,
        isAgentTyping,
        emptyLaunchInteractionSource,
        emptyLaunchInvokedFrom,
        isChatOnboardingMiniModalOpen
    ]);
    const onAbort = (0, $cozmU.useCallback)((mode, analyticsEvent)=>{
        if (analyticsEvent) sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'abortRequestsButton'
        }));
        abortRequests({
            conversationId: conversationId,
            deepResearchEnabled: mode.deepResearchEnabled,
            thinkDeeperEnabled: mode.thinkDeeperEnabled,
            taskModeEnabled: mode.taskModeEnabled
        });
    }, [
        abortRequests,
        conversationId,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        setMessageQueue([]);
    }, [
        conversation?.id
    ]);
    const prevIsAgentTypingRef = (0, $cozmU.useRef)(isAgentTyping);
    (0, $cozmU.useEffect)(()=>{
        const wasTyping = prevIsAgentTypingRef.current;
        prevIsAgentTypingRef.current = isAgentTyping;
        if (!(0, $iDrrr.fg)('rovo_chat_message_queue')) return;
        if (wasTyping && !isAgentTyping && messageQueue.length > 0) {
            const [next, ...rest] = messageQueue;
            setMessageQueue(rest);
            onSubmit(next.prompt, next.mode, next.files);
        }
    }, [
        isAgentTyping,
        messageQueue,
        onSubmit
    ]);
    const chatInputRef = (0, $cozmU.useRef)(null);
    const suppressInitialFocusRef = (0, $cozmU.useRef)(suppressInitialFocus);
    suppressInitialFocusRef.current = suppressInitialFocus; // Trigger refocus on the chat input when changing conversations (e.g. route change while modal is open).
    // Reads suppressInitialFocus via ref to avoid stale closure without adding it as a dep.
    (0, $cozmU.useEffect)(()=>{
        if (!suppressInitialFocusRef.current) chatInputRef.current?.focus();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        conversationId
    ]);
    const shouldBeCentered = fullScreen && stagingAreaMode !== 'inline';
    const chatPromptInput = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $3eqaf.RovoChatPromptInput), {
            key: isAgentSelectionEnabled ? conversationId : 'selected-agent-ga-enhancements-disabled',
            ref: chatInputRef,
            enableSkills: resolvedEnableSkills,
            enableSkillsInStagingArea: isStudioSkillsInStagingAreaEnabled,
            enableSkillsInSpecialistPromptInput: isStudioSkillsInStagingAreaEnabled,
            browserContextSanitizer: browserContextSanitizer,
            editorPopupsMountPoint: props.editorPopupsMountPoint,
            editorPopupsBoundariesElement: props.editorPopupsBoundariesElement,
            shouldRenderQuickActionsInPortal: props.shouldRenderQuickActionsInPortal,
            isConversationAgentic: !isDefaultAgent,
            conversationAgentId: selectedAgent?.id,
            chatSessionId: chatSessionId,
            chatTurnNumber: chatTurnNumber,
            selectedAgentForInputHat: isAgentSelectionEnabled ? selectedAgentForInputHat : undefined,
            isSpaceScopedConversation: isSpaceScopedConversation,
            spaceSourceCount: areActiveSpaceSourcesKnown ? activeSpaceSources.length : undefined,
            spaceSources: activeSpaceSources,
            zeroSourcesAction: zeroSourcesAction,
            onSubmit: onSubmit,
            onAbort: onAbort,
            onSelectedAgentChange: handleSelectedAgentChange,
            enableAgentMentions: isMentionAgentsExperimentEligible,
            disabledAgentTooltip: isAgentSelectionEnabled ? formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputDisabledAgentTooltip) : undefined,
            useCurrentPageContext: useCurrentPageContextForInput,
            contentContext: contentContext,
            isDisabled: !!activeAction?.customFollowUpContext ? !activeAction?.customFollowUpContext?.available : props.isDisabled,
            isAgentTyping: isAgentTyping,
            hasQueuedMessages: messageQueue.length > 0 && (0, $iDrrr.fg)('rovo_chat_message_queue'),
            arrowKeyPluginConfigMessages: userMessagesForEditor,
            autocompleteContext: autocompleteContext,
            placeholderOverride: placeholderOverride,
            initialPromptText: initialPromptText,
            shouldSeedInitialPromptText: shouldSeedInitialPromptText,
            promptDraftAndModeKey: conversationId,
            clearModeOnSubmit: conversation?.id === (0, $4m5jb.EMPTY_CONVERSATION_ID),
            productKey: productKey,
            siteId: siteId,
            orgId: orgId,
            assistanceServiceParams: assistanceServiceParams,
            shouldBeCentered: shouldBeCentered,
            onPromptChange: onPromptChange,
            minHeight: shouldMinimizeInputHeight ? 95 : fullScreen ? 86 : 56,
            maxHeight: shouldMinimizeInputHeight ? 95 : undefined,
            enableVoiceDictation: props.enableVoiceDictation,
            dictationOverlayBackground: props.dictationOverlayBackground,
            entryPoint: $a33c889c756d4321$var$CHAT_INPUT_INTERACTION_SOURCE,
            mode: props.mode,
            showChatModeMenu: elements?.chatModeMenuButton,
            enableMaxMode: enableMaxMode,
            // ConversationAssistantRender, e.g. the CwR staging-area chat panel)
            // into apps discovery UI (limited unconnected apps, "Discover more
            // apps" footer). Other surfaces that mount RovoChatPromptInput
            // directly (embedded studio chat, blank object experience, AIFC
            // onboarding, etc.) opt in individually at their own call sites.
            enableAppsDiscoveryUi: true,
            autoSuggestConfig: shouldUseTypeahead ? {
                source: (0, $1jIs1.AUTOSUGGEST_SOURCE).ROVO_CHAT,
                position: 'top'
            } : undefined,
            urlValidationConfig: promptInputDroppableUrls,
            enableBrowserContextBanner: enableBrowserContextBanner,
            aiFeatureContextOverride: aiFeatureContextOverride,
            showContextBannerForEntityContextOverride: smartLink3PPostAuthIsActive,
            actionsMenuItemsVisibility: {
                fileUpload: elements?.fileUploadButton
            },
            onDiscoverSkillsClick: fullScreen || !isDefaultAgent ? undefined : props.onDiscoverSkillsClick,
            onBrowsePromptLibraryClick: fullScreen ? undefined : props.onBrowsePromptLibraryClick,
            onCreateSpaceClick: props.onCreateSpaceClick,
            onAutoSuggestQueryChange: shouldEvaluateTypeaheadExperiment && isDefaultAgent && !activeAction ? props.onAutoSuggestQueryChange : undefined,
            showActionsButton: props.showActionsButton,
            shouldFocusOnMount: !suppressInitialFocus
        }), [
        aiFeatureContextOverride,
        smartLink3PPostAuthIsActive,
        props.isDisabled,
        props.enableVoiceDictation,
        props.dictationOverlayBackground,
        props.editorPopupsMountPoint,
        props.editorPopupsBoundariesElement,
        props.shouldRenderQuickActionsInPortal,
        props.onDiscoverSkillsClick,
        props.onBrowsePromptLibraryClick,
        props.onCreateSpaceClick,
        props.onAutoSuggestQueryChange,
        isDefaultAgent,
        selectedAgent?.id,
        isAgentSelectionEnabled,
        isMentionAgentsExperimentEligible,
        selectedAgentForInputHat,
        handleSelectedAgentChange,
        onSubmit,
        onAbort,
        elements?.chatModeMenuButton,
        enableMaxMode,
        contentContext,
        isAgentTyping,
        userMessagesForEditor,
        chatTurnNumber,
        chatSessionId,
        autocompleteContext,
        placeholderOverride,
        conversationId,
        conversation?.id,
        formatMessage,
        productKey,
        siteId,
        orgId,
        assistanceServiceParams,
        onPromptChange,
        shouldUseTypeahead,
        shouldBeCentered,
        shouldMinimizeInputHeight,
        promptInputDroppableUrls,
        enableBrowserContextBanner,
        browserContextSanitizer,
        initialPromptText,
        shouldSeedInitialPromptText,
        elements?.fileUploadButton,
        fullScreen,
        shouldEvaluateTypeaheadExperiment,
        activeAction,
        isSpaceScopedConversation,
        areActiveSpaceSourcesKnown,
        activeSpaceSources,
        zeroSourcesAction,
        suppressInitialFocus,
        messageQueue.length,
        isStudioSkillsInStagingAreaEnabled,
        resolvedEnableSkills,
        props.showActionsButton,
        props.mode,
        useCurrentPageContextForInput
    ]);
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
        data: {
            isConversationAgentic: !isDefaultAgent
        }
    }), (0, $iDrrr.fg)('rovo-ext_sbs_enabled') && /*#__PURE__*/ $cozmU.createElement((0, $61497a805f31bc51$export$141da6742e7e62a1), {
        productKey: productKey,
        experienceId: experienceId,
        siteId: siteId,
        interceptSubmitRef: sbsInterceptSubmitRef
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, messageQueue.length > 0 && (0, $iDrrr.fg)('rovo_chat_message_queue') && /*#__PURE__*/ $cozmU.createElement((0, $a933791f4ee04942$export$3ca7a30f7f19d80d), {
        items: messageQueue.map((queuedMessage)=>({
                id: queuedMessage.id,
                preview: queuedMessage.preview,
                onRemove: ()=>{
                    setMessageQueue((prev)=>prev.filter((message)=>message.id !== queuedMessage.id));
                }
            }))
    }), fullScreen && conversation?.id === (0, $4m5jb.EMPTY_CONVERSATION_ID) ? /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        key: "chat-input",
        duration: "large",
        entranceDirection: "bottom",
        exitDirection: "bottom",
        isPaused: !fullscreenInputStaggerAnimation.shouldAnimate
    }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("div", animationProps, chatPromptInput)) : chatPromptInput));
};
// rovo_ttai_segment_render_stabilization: absorb parent render waves when props are stable.
const $a33c889c756d4321$var$MemoizedChatInput = /*#__PURE__*/ (0, $cozmU.memo)($a33c889c756d4321$var$ChatInputComponent, (0, $dqxOF.shallowEqualObjects)); // rovo_ttai_segment_render_stabilization ON: subscribe to the chat-input UI fields
// via the narrow composite selector so the component only re-renders when one of
// those fields changes, rather than on every UI-store state change.
const $a33c889c756d4321$var$ChatInputWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useChatInputUISelector));
    const [{ selectedSpace: selectedSpace, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, smartLink3PPostAuth: smartLink3PPostAuth }] = (0, $bGNkz.useChatInputUISelector)();
    return /*#__PURE__*/ $cozmU.createElement($a33c889c756d4321$var$MemoizedChatInput, {
        ...props,
        selectedSpace: selectedSpace,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        smartLink3PPostAuth: smartLink3PPostAuth
    });
}; // rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $a33c889c756d4321$var$ChatInputWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { selectedSpace: selectedSpace, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, smartLink3PPostAuth: smartLink3PPostAuth } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ $cozmU.createElement($a33c889c756d4321$var$ChatInputComponent, {
        ...props,
        selectedSpace: selectedSpace,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        smartLink3PPostAuth: smartLink3PPostAuth
    });
};
const $a33c889c756d4321$export$19b903fd083c557c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ $cozmU.createElement($a33c889c756d4321$var$ChatInputWithSelector, props) : /*#__PURE__*/ $cozmU.createElement($a33c889c756d4321$var$ChatInputWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ $cozmU.createElement($a33c889c756d4321$var$ChatInputWithSelector, props) : /*#__PURE__*/ $cozmU.createElement($a33c889c756d4321$var$ChatInputWithBroadStore, props);
};















var $31le2 = parcelRequire("31le2");



















const $b3c71c82d3ba80b3$var$message = (0, $kSwu1.defineMessages)({
    deletedAgentIconLabel: {
        id: "ai-mate.chat-input.deleted-agent-icon-label",
        defaultMessage: "Agent deleted"
    },
    deletedAgent: {
        id: "ai-mate.chat-input.deleted-agent-warning",
        defaultMessage: "This Agent has been deleted."
    },
    unavailableAgentStartNewChatButton: {
        id: "ai-mate.chat-input.deleted-agent-start-new-chat",
        defaultMessage: "Start new chat"
    },
    noAgentPermissionIconLabel: {
        id: "ai-mate.chat-input.no-agent-permission-icon-label",
        defaultMessage: "No agent permission"
    },
    noAgentPermission: {
        id: "ai-mate.chat-input.no-agent-permission-warning",
        defaultMessage: "You don't have permission to use this Agent."
    }
});
var $b3c71c82d3ba80b3$export$2e2bcd8739ae039 = $b3c71c82d3ba80b3$var$message;


const $04bba84c1b5bc9f5$var$styles = {
    archiveMessage: "_0bjKvDKxmn",
    startNewChatPressable: "_2sNsIgmnOE _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0KLXrujOvk _1kk5Tkf7mX _1UtDYzy7kJ"
};
const $04bba84c1b5bc9f5$var$ERROR_CODE_CONFIG = {
    [(0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN]: {
        iconLabel: (0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).noAgentPermissionIconLabel,
        message: (0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).noAgentPermission,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4efpo)))
    },
    [(0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED]: {
        iconLabel: (0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).deletedAgentIconLabel,
        message: (0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).deletedAgent,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($31le2)))
    }
};
const $04bba84c1b5bc9f5$var$DEFAULT_ERROR_CONFIG = {
    iconLabel: (0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).deletedAgentIconLabel,
    message: (0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).deletedAgent,
    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($31le2)))
}; // TODO rename this to UnavailableAgentError with the file name
const $04bba84c1b5bc9f5$export$3bc7aab542bd0518 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { handleNewChatClick: handleNewChatClick, errorCode: errorCode } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorConfig = errorCode && $04bba84c1b5bc9f5$var$ERROR_CODE_CONFIG[errorCode] || $04bba84c1b5bc9f5$var$DEFAULT_ERROR_CONFIG;
    const T0 = errorConfig.IconComponent;
    let t1;
    if ($[0] !== errorConfig.iconLabel || $[1] !== formatMessage) {
        t1 = formatMessage(errorConfig.iconLabel);
        $[0] = errorConfig.iconLabel;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== errorConfig.IconComponent || $[4] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement(T0, {
            label: t1,
            color: "var(--ds-icon, #292A2E)"
        });
        $[3] = errorConfig.IconComponent;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== errorConfig.message || $[7] !== formatMessage) {
        t3 = formatMessage(errorConfig.message);
        $[6] = errorConfig.message;
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "medium"
        }, t3);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== formatMessage) {
        t5 = formatMessage((0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).unavailableAgentStartNewChatButton);
        $[11] = formatMessage;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== handleNewChatClick || $[14] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: handleNewChatClick,
            xcss: $04bba84c1b5bc9f5$var$styles.startNewChatPressable
        }, t5);
        $[13] = handleNewChatClick;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t2 || $[17] !== t4 || $[18] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            padding: "space.200"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingInline: "space.150",
            paddingBlock: "space.200",
            xcss: $04bba84c1b5bc9f5$var$styles.archiveMessage,
            backgroundColor: "elevation.surface.sunken"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center"
        }, t2, t4, t6)));
        $[16] = t2;
        $[17] = t4;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
} : ({ handleNewChatClick: handleNewChatClick, errorCode: errorCode })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorConfig = errorCode && $04bba84c1b5bc9f5$var$ERROR_CODE_CONFIG[errorCode] || $04bba84c1b5bc9f5$var$DEFAULT_ERROR_CONFIG;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        paddingInline: "space.150",
        paddingBlock: "space.200",
        xcss: $04bba84c1b5bc9f5$var$styles.archiveMessage,
        backgroundColor: "elevation.surface.sunken"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement(errorConfig.IconComponent, {
        label: formatMessage(errorConfig.iconLabel),
        color: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(errorConfig.message)), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: handleNewChatClick,
        xcss: $04bba84c1b5bc9f5$var$styles.startNewChatPressable
    }, formatMessage((0, $b3c71c82d3ba80b3$export$2e2bcd8739ae039).unavailableAgentStartNewChatButton)))));
};



































































const $7700b2bb919574d0$var$LazyRovoOnboardingGifLight = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("j1wsN")));
const $7700b2bb919574d0$export$1a313398f5c9f462 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? 352 : t3;
    const height = t4 === undefined ? 196 : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-onboarding-gif-primary",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifLight, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = 352, height: height = 196 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-onboarding-gif-primary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifLight, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});

const $7700b2bb919574d0$var$LazyRovoOnboardingGifDark = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("6nI6v")));
const $7700b2bb919574d0$export$c91bacfe4ed5241a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? 352 : t3;
    const height = t4 === undefined ? 196 : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-onboarding-gif-secondary",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifDark, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = 352, height: height = 196 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-onboarding-gif-secondary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifDark, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});

const $7700b2bb919574d0$var$LazyRovoOnboardingGifLightConfluence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("lNheA")));
const $7700b2bb919574d0$export$66b22468c2659825 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? 352 : t3;
    const height = t4 === undefined ? 196 : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-onboarding-gif-primary",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifLightConfluence, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = 352, height: height = 196 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-onboarding-gif-primary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifLightConfluence, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});

const $7700b2bb919574d0$var$LazyRovoOnboardingGifDarkConfluence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("etmuJ")));
const $7700b2bb919574d0$export$6db91bf7e3b2f352 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? 352 : t3;
    const height = t4 === undefined ? 196 : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-onboarding-gif-secondary",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifDarkConfluence, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = 352, height: height = 196 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-onboarding-gif-secondary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7700b2bb919574d0$var$LazyRovoOnboardingGifDarkConfluence, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});





const $5d033543b55ba7e1$var$message = (0, $kSwu1.defineMessages)({
    headingForGreetings: {
        id: "rovo-chat.rovo-onboarding-greetings.heading",
        defaultMessage: "Meet Rovo, your AI teammate."
    },
    descriptionForGreetings: {
        id: "rovo-chat.rovo-onboarding-greetings.description",
        defaultMessage: "AI that understands your Jira work so you can move faster, securely."
    },
    button: {
        id: "rovo-chat.rovo-onboarding-greetings.button",
        defaultMessage: "Continue"
    },
    descriptionForGreetingsConnie: {
        id: "rovo-chat.rovo-onboarding-greetings.description.connie",
        defaultMessage: "AI that understands your Confluence work so you can move faster, securely."
    }
});
var $5d033543b55ba7e1$export$2e2bcd8739ae039 = $5d033543b55ba7e1$var$message;


const $0fefbad7cabf41ea$var$styles = {
    container: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _2O5Vij7dHp _0aFT5vbt8w _1wydGW8HPE _37wbyuI7V3",
    wrapper: "_39xV02N91d _0jFU0VN91d _2O5Vij7dHp _0Of8r2NHnM _1ZnuxbNHnM _2Zuz6QNHnM",
    videoContainer: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKTcp _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _07XDTD4rZt",
    buttonContainer: "_39xV02N91d _0jFU0V9LX5 _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLz9WS _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $0fefbad7cabf41ea$export$efa7e1177c04ee36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onNext: onNext, onStepViewed: onStepViewed, product: product } = t0;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const hasClickedRef = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== colorMode || $[1] !== onStepViewed) {
        t1 = ()=>{
            onStepViewed({
                colorMode: colorMode
            });
        };
        t2 = [
            onStepViewed,
            colorMode
        ];
        $[0] = colorMode;
        $[1] = onStepViewed;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== colorMode || $[5] !== onNext) {
        t3 = ()=>{
            if (!hasClickedRef.current) {
                hasClickedRef.current = true;
                onNext("continue", {
                    colorMode: colorMode
                });
            }
        };
        $[4] = colorMode;
        $[5] = onNext;
        $[6] = t3;
    } else t3 = $[6];
    const handleOnClick = t3;
    let t4;
    bb0: {
        if (product === "confluence") {
            let t5;
            if ($[7] !== colorMode) {
                t5 = colorMode === "light" ? /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$66b22468c2659825), {
                    alt: "Onboarding Video",
                    width: 352,
                    height: 196
                }) : /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$6db91bf7e3b2f352), {
                    alt: "Onboarding Video",
                    width: 352,
                    height: 196
                });
                $[7] = colorMode;
                $[8] = t5;
            } else t5 = $[8];
            t4 = t5;
            break bb0;
        } else if (product === "jira") {
            let t5;
            if ($[9] !== colorMode) {
                t5 = colorMode === "light" ? /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$1a313398f5c9f462), {
                    alt: "Onboarding Video",
                    width: 352,
                    height: 196
                }) : /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$c91bacfe4ed5241a), {
                    alt: "Onboarding Video",
                    width: 352,
                    height: 196
                });
                $[9] = colorMode;
                $[10] = t5;
            } else t5 = $[10];
            t4 = t5;
            break bb0;
        }
        t4 = undefined;
    }
    const getRovoOnboardingGif = t4;
    let t5;
    if ($[11] !== getRovoOnboardingGif) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0fefbad7cabf41ea$var$styles.videoContainer
        }, getRovoOnboardingGif);
        $[11] = getRovoOnboardingGif;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "medium"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).headingForGreetings));
        $[13] = t6;
    } else t6 = $[13];
    const t7 = product === "confluence" ? (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).descriptionForGreetingsConnie : (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).descriptionForGreetings;
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            as: "p"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), t7));
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t5 || $[17] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $0fefbad7cabf41ea$var$styles.wrapper,
            space: "space.200"
        }, t5, t6, t8);
        $[16] = t5;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).button);
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== handleOnClick) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0fefbad7cabf41ea$var$styles.buttonContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleOnClick
        }, t10));
        $[20] = handleOnClick;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== t11 || $[23] !== t9) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $0fefbad7cabf41ea$var$styles.container
        }, t9, t11);
        $[22] = t11;
        $[23] = t9;
        $[24] = t12;
    } else t12 = $[24];
    return t12;
} : ({ onNext: onNext, onStepViewed: onStepViewed, product: product })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const hasClickedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        onStepViewed({
            colorMode: colorMode
        });
    }, [
        onStepViewed,
        colorMode
    ]);
    const handleOnClick = ()=>{
        if (!hasClickedRef.current) {
            hasClickedRef.current = true;
            onNext('continue', {
                colorMode: colorMode
            });
        }
    };
    const getRovoOnboardingGif = (0, $cozmU.useMemo)(()=>{
        if (product === 'confluence') return colorMode === 'light' ? /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$66b22468c2659825), {
            alt: "Onboarding Video",
            width: 352,
            height: 196
        }) : /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$6db91bf7e3b2f352), {
            alt: "Onboarding Video",
            width: 352,
            height: 196
        });
        else if (product === 'jira') return colorMode === 'light' ? /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$1a313398f5c9f462), {
            alt: "Onboarding Video",
            width: 352,
            height: 196
        }) : /*#__PURE__*/ $cozmU.createElement((0, $7700b2bb919574d0$export$c91bacfe4ed5241a), {
            alt: "Onboarding Video",
            width: 352,
            height: 196
        });
    }, [
        colorMode,
        product
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $0fefbad7cabf41ea$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $0fefbad7cabf41ea$var$styles.wrapper,
        space: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0fefbad7cabf41ea$var$styles.videoContainer
    }, getRovoOnboardingGif), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "medium"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).headingForGreetings)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        as: "p"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), product === 'confluence' ? (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).descriptionForGreetingsConnie : (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).descriptionForGreetings))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0fefbad7cabf41ea$var$styles.buttonContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleOnClick
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $5d033543b55ba7e1$export$2e2bcd8739ae039).button))));
};



























var $4313a8ea77f34bb0$exports = {};
$4313a8ea77f34bb0$exports = new URL("break-down-complex-issues-icon-dark-mode.3637919d.svg", import.meta.url).toString();


var $7fd6a8bad8c5cbfa$exports = {};
$7fd6a8bad8c5cbfa$exports = new URL("break-down-complex-issues-icon-light-mode.e8413fb5.svg", import.meta.url).toString();


var $3fcb6f7bf475b4b7$exports = {};
$3fcb6f7bf475b4b7$exports = new URL("catchup-after-time-away-icon-dark-mode.f2e7a9cc.svg", import.meta.url).toString();


var $80b5206800f577be$exports = {};
$80b5206800f577be$exports = new URL("catchup-after-time-away-icon-light-mode.b504f053.svg", import.meta.url).toString();


var $27e2c980f6e20c3d$exports = {};
$27e2c980f6e20c3d$exports = new URL("create-issue-icon-dark-mode.75867f58.svg", import.meta.url).toString();


var $b87087dfdcd7b3be$exports = {};
$b87087dfdcd7b3be$exports = new URL("create-issue-icon-light-mode.69e10720.svg", import.meta.url).toString();


var $b27762f4ef5941cf$exports = {};
$b27762f4ef5941cf$exports = new URL("draft-helpful-comments-or-updates-icon-dark-mode.5795c228.svg", import.meta.url).toString();


var $f58b9ec1e83f47f6$exports = {};
$f58b9ec1e83f47f6$exports = new URL("draft-helpful-comments-or-updates-icon-light-mode.3c50255e.svg", import.meta.url).toString();


var $8d88833de8880be4$exports = {};
$8d88833de8880be4$exports = new URL("make-my-issues-clearer-icon-dark-mode.9e7e9a04.svg", import.meta.url).toString();


var $191a92b4ae85cf99$exports = {};
$191a92b4ae85cf99$exports = new URL("make-my-issues-clearer-icon-light-mode.34de1b99.svg", import.meta.url).toString();


var $517b11d63057b046$exports = {};
$517b11d63057b046$exports = new URL("share-my-work-with-stakeholders-icon-dark-mode.d3e80c8a.svg", import.meta.url).toString();


var $d9c862c11c414d1e$exports = {};
$d9c862c11c414d1e$exports = new URL("share-my-work-with-stakeholders-icon-light-mode.5035c548.svg", import.meta.url).toString();





const $548d830fb6296467$var$message = (0, $kSwu1.defineMessages)({
    headingForPrompts: {
        id: "rovo-chat.rovo-onboarding-prompts.heading",
        defaultMessage: "What do you want to use Rovo for today?"
    },
    descriptionForPrompts: {
        id: "rovo-chat.rovo-onboarding-prompts.description",
        defaultMessage: "Pick one to personalize your experience. You can always explore more later."
    }
});
var $548d830fb6296467$export$2e2bcd8739ae039 = $548d830fb6296467$var$message;
const $548d830fb6296467$export$7f7016b8eafc33b0 = (0, $kSwu1.defineMessages)({
    createNewIssuesQuicklyStub: {
        id: "rovo-chat.creator-prompts.create-new-issues-quickly",
        defaultMessage: "Create new issues quickly"
    },
    breakDownComplexIssuesStub: {
        id: "rovo-chat.creator-prompts.break-down-complex-issues",
        defaultMessage: "Break down complex issues"
    },
    makeMyIssuesClearerStub: {
        id: "rovo-chat.creator-prompts.make-my-issues-clearer",
        defaultMessage: "Make my issues clearer"
    }
});
const $548d830fb6296467$export$140fa3f65e1330fb = (0, $kSwu1.defineMessages)({
    catchupAfterTimeAwayStub: {
        id: "rovo-chat.consumer-prompts.catchup-after-time-away",
        defaultMessage: "Catch up after time away"
    },
    draftHelpfulCommentsOrUpdatesStub: {
        id: "rovo-chat.consumer-prompts.draft-helpful-comments-or-updates",
        defaultMessage: "Draft helpful comments or updates"
    },
    shareMyWorkWithStakeholdersStub: {
        id: "rovo-chat.consumer-prompts.share-my-work-with-stakeholders",
        defaultMessage: "Share my work with stakeholders"
    }
});
const $548d830fb6296467$export$efb249e3a74bf8 = (0, $kSwu1.defineMessages)({
    createNewIssuesQuicklyPrompt: {
        id: "rovo-chat.creator-prompts.create-new-issues-quickly-prompt",
        defaultMessage: "Suggest a few concrete issues or subtasks my team might be missing. Start with a brief overview of your reasoning, then list 3 work items, each with a clear title and one\u2011line description. Keep response under 300 words."
    },
    breakDownComplexIssuesPrompt: {
        id: "rovo-chat.creator-prompts.break-down-complex-issues-prompt",
        defaultMessage: "Identify my team\u2019s most complex work item, and suggest 3 subtasks to track separately. Start with a brief overview of your reasoning, then list 3 subtasks, each with a clear title and one\u2011line description. Keep response under 300 words."
    },
    makeMyIssuesClearerPrompt: {
        id: "rovo-chat.creator-prompts.make-my-issues-clearer-prompt",
        defaultMessage: "Identify an issue that seems unclear, outdated, or hard to act on. Start with a brief overview of your reasoning, then share 3 concrete ideas to help my team improve, progress, or close it quickly and confidently. Keep response under 300 words."
    },
    catchupAfterTimeAwayPrompt: {
        id: "rovo-chat.consumer-prompts.catchup-after-time-away-prompt",
        defaultMessage: "Based on the work items you can see, give me a high-level summary of what\u2019s changed over the past two weeks. Focus on items that changed, are delayed or blocked, and anything else that needs my attention. Keep response under 300 words."
    },
    draftHelpfulCommentsOrUpdatesPrompt: {
        id: "rovo-chat.consumer-prompts.stay-on-top-of-my-work-prompt",
        defaultMessage: "Identify an important or recently updated work item. Start with a brief overview of your reasoning, then draft a succinct and friendly comment I can post to the team. Include key questions, flagged risks, and clear next steps. Keep response under 300 words."
    },
    shareMyWorkWithStakeholdersPrompt: {
        id: "rovo-chat.consumer-prompts.prep-for-meeting-prompt",
        defaultMessage: "Identify an important or recently updated work item. Start with a brief overview of your reasoning, then write a short memo that I can share with stakeholders. Include a one-sentence overview and a few bullets for progress, risks, and next steps. Keep the response under 300 words."
    },
    catchupAfterTimeAwayConfluencePrompt: {
        id: "rovo-chat.consumer-prompts.confluence.catchup-after-time-away-prompt",
        defaultMessage: "Based on the Confluence Pages related to me, give me a high-level summary of what\u2019s changed over the past two weeks. Focus on pages that have been created, changed, and anything else that needs my attention. Keep response under 300 words."
    },
    draftHelpfulCommentsOrUpdatesConfluencePrompt: {
        id: "rovo-chat.consumer-prompts.confluence.stay-on-top-of-my-work-prompt",
        defaultMessage: "Identify an important or recently updated Confluence Page. Start with a brief overview of your reasoning, then draft a succinct and friendly comment I can post to the team. Include key questions, flagged risks, and clear next steps. Keep response under 300 words."
    },
    shareMyWorkWithStakeholdersConfluencePrompt: {
        id: "rovo-chat.consumer-prompts.confluence.prep-for-meeting-prompt",
        defaultMessage: "Identify an important or recently updated Confluence Page. Start with a brief overview of your reasoning, then write a short memo that I can share with stakeholders. Include a one-sentence overview and a few bullets for progress, risks, and next steps. Keep the response under 300 words."
    }
});


const $c48af6d38336eefe$export$7082389acb6917d4 = [
    {
        message: (0, $548d830fb6296467$export$7f7016b8eafc33b0).createNewIssuesQuicklyStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($b87087dfdcd7b3be$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($27e2c980f6e20c3d$exports))),
        promptId: 'createNewIssuesQuicklyPrompt'
    },
    {
        message: (0, $548d830fb6296467$export$7f7016b8eafc33b0).breakDownComplexIssuesStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($7fd6a8bad8c5cbfa$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($4313a8ea77f34bb0$exports))),
        promptId: 'breakDownComplexIssuesPrompt'
    },
    {
        message: (0, $548d830fb6296467$export$7f7016b8eafc33b0).makeMyIssuesClearerStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($191a92b4ae85cf99$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($8d88833de8880be4$exports))),
        promptId: 'makeMyIssuesClearerPrompt'
    }
];
const $c48af6d38336eefe$export$a816cc3623b3fc48 = [
    {
        message: (0, $548d830fb6296467$export$140fa3f65e1330fb).catchupAfterTimeAwayStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($80b5206800f577be$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($3fcb6f7bf475b4b7$exports))),
        promptId: 'catchupAfterTimeAwayPrompt'
    },
    {
        message: (0, $548d830fb6296467$export$140fa3f65e1330fb).draftHelpfulCommentsOrUpdatesStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($f58b9ec1e83f47f6$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($b27762f4ef5941cf$exports))),
        promptId: 'draftHelpfulCommentsOrUpdatesPrompt'
    },
    {
        message: (0, $548d830fb6296467$export$140fa3f65e1330fb).shareMyWorkWithStakeholdersStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($d9c862c11c414d1e$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($517b11d63057b046$exports))),
        promptId: 'shareMyWorkWithStakeholdersPrompt'
    }
];
const $c48af6d38336eefe$export$390076b3aa4137ea = [
    {
        message: (0, $548d830fb6296467$export$140fa3f65e1330fb).catchupAfterTimeAwayStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($80b5206800f577be$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($3fcb6f7bf475b4b7$exports))),
        promptId: 'catchupAfterTimeAwayConfluencePrompt'
    },
    {
        message: (0, $548d830fb6296467$export$140fa3f65e1330fb).draftHelpfulCommentsOrUpdatesStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($f58b9ec1e83f47f6$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($b27762f4ef5941cf$exports))),
        promptId: 'draftHelpfulCommentsOrUpdatesConfluencePrompt'
    },
    {
        message: (0, $548d830fb6296467$export$140fa3f65e1330fb).shareMyWorkWithStakeholdersStub,
        iconLight: (0, (/*@__PURE__*/$parcel$interopDefault($d9c862c11c414d1e$exports))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($517b11d63057b046$exports))),
        promptId: 'shareMyWorkWithStakeholdersConfluencePrompt'
    }
];



const $f50e6d16a91500e7$var$styles = {
    container: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _2O5Vij7dHp _0aFT5vbt8w _1wydGW8HPE _37wbyuI7V3",
    wrapper: "_39xV02N91d _0jFU0VN91d _2O5Vij7dHp _0Of8r2NHnM _1ZnuxbNHnM _2Zuz6QNHnM _1wydGWyFLW",
    promptsContainer: "_0bjKvDyzSk _2YLqiK5zaO _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuz9WS _2fwxA5ecOK _0KLXru7Cj1 _2OUyjtFYNq",
    promptButtonStyles: "_2mHwu82ADO _0bjKvDKTcp _39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuchRC _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _2fwxA5ecOK _0KLXru7Cj1 _1UtDYzy7kJ _0wOv4Q7zJH _1eOmH6o126 _3gzVzLN4oS"
};
const $f50e6d16a91500e7$var$getPrompts = (userPersona, product)=>{
    if (product === 'confluence') return 0, $c48af6d38336eefe$export$390076b3aa4137ea;
    return userPersona === 'creator' ? (0, $c48af6d38336eefe$export$7082389acb6917d4) : (0, $c48af6d38336eefe$export$a816cc3623b3fc48);
};
const $f50e6d16a91500e7$export$1bc8db60be51b1f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { userPersona: userPersona, onNext: onNext, onStepViewed: onStepViewed, product: product } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasClickedRef = (0, $cozmU.useRef)(false);
    const prompts = $f50e6d16a91500e7$var$getPrompts(userPersona, product);
    let t1;
    let t2;
    if ($[0] !== onStepViewed) {
        t1 = ()=>{
            onStepViewed();
        };
        t2 = [
            onStepViewed
        ];
        $[0] = onStepViewed;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const handleOnClick = (promptId)=>{
        if (!hasClickedRef.current) {
            hasClickedRef.current = true;
            const promptMessage = formatMessage((0, $548d830fb6296467$export$efb249e3a74bf8)[promptId]);
            onNext("prompt", {
                promptId: promptId,
                promptMessage: promptMessage
            });
        }
    };
    const T0 = (0, $dinVW.Stack);
    const t3 = $f50e6d16a91500e7$var$styles;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $548d830fb6296467$export$2e2bcd8739ae039).headingForPrompts));
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $f50e6d16a91500e7$var$styles.wrapper,
            space: "space.200"
        }, t4, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            as: "p"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $548d830fb6296467$export$2e2bcd8739ae039).descriptionForPrompts)));
        $[4] = t5;
    } else t5 = $[4];
    const T1 = (0, $dinVW.Stack);
    const t6 = $f50e6d16a91500e7$var$styles;
    const t7 = "chat-onboarding-prompts-container";
    const t8 = prompts.map((prompt, index)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            key: index,
            onClick: ()=>handleOnClick(prompt.promptId),
            xcss: $f50e6d16a91500e7$var$styles.promptButtonStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: prompt.iconLight,
            srcDark: prompt.iconDark,
            alt: "",
            width: 24,
            height: 24
        }), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), prompt.message)));
    let t9;
    if ($[5] !== T1 || $[6] !== t6.promptsContainer || $[7] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement(T1, {
            xcss: t6.promptsContainer,
            testId: t7
        }, t8);
        $[5] = T1;
        $[6] = t6.promptsContainer;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== T0 || $[10] !== t3.container || $[11] !== t5 || $[12] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t3.container
        }, t5, t9);
        $[9] = T0;
        $[10] = t3.container;
        $[11] = t5;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
} : ({ userPersona: userPersona, onNext: onNext, onStepViewed: onStepViewed, product: product })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasClickedRef = (0, $cozmU.useRef)(false);
    const prompts = $f50e6d16a91500e7$var$getPrompts(userPersona, product);
    (0, $cozmU.useEffect)(()=>{
        onStepViewed();
    }, [
        onStepViewed
    ]);
    const handleOnClick = (promptId)=>{
        if (!hasClickedRef.current) {
            hasClickedRef.current = true;
            const promptMessage = formatMessage((0, $548d830fb6296467$export$efb249e3a74bf8)[promptId]);
            onNext('prompt', {
                promptId: promptId,
                promptMessage: promptMessage
            });
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $f50e6d16a91500e7$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $f50e6d16a91500e7$var$styles.wrapper,
        space: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $548d830fb6296467$export$2e2bcd8739ae039).headingForPrompts)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        as: "p"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $548d830fb6296467$export$2e2bcd8739ae039).descriptionForPrompts))), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $f50e6d16a91500e7$var$styles.promptsContainer,
        testId: "chat-onboarding-prompts-container"
    }, prompts.map((prompt, index)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            key: index,
            onClick: ()=>handleOnClick(prompt.promptId),
            xcss: $f50e6d16a91500e7$var$styles.promptButtonStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: prompt.iconLight,
            srcDark: prompt.iconDark,
            alt: "",
            width: 24,
            height: 24
        }), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), prompt.message)))));
};



var $gxmD5 = parcelRequire("gxmD5");


var $advdT = parcelRequire("advdT");


var $3LpEG = parcelRequire("3LpEG");

function $5f898ef876d431ab$export$f6d2bc57e324a079() {
    const state = (0, $advdT.getOnboardingHoldoutState)() ?? (0, $gxmD5.DEFAULT_HOLDOUT_STATE);
    (0, $3LpEG.persistState)({
        ...state,
        lastSeenAt: Date.now(),
        onboardingCompleted: true
    });
}


const $5682c3d43d78116c$var$styles = {
    container: "_39xV02N91d _0jFU0VN91d _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC"
};
const $5682c3d43d78116c$var$OnboardingStep = {
    greetings: 'greetings',
    prompts: 'prompts'
};
const $5682c3d43d78116c$var$onboardingSubScreenByStep = {
    [$5682c3d43d78116c$var$OnboardingStep.greetings]: 'onboarding-greetings',
    [$5682c3d43d78116c$var$OnboardingStep.prompts]: 'onboarding-prompts'
};
const $5682c3d43d78116c$var$ChatOnboardingImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { product: product } = t0;
    const [onboardingStep, setOnboardingStep] = (0, $cozmU.useState)($5682c3d43d78116c$var$OnboardingStep.greetings);
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const userPersona = "consumer";
    let t1;
    if ($[0] !== publish) {
        t1 = (promptMessage)=>{
            publish({
                type: "chat-new",
                source: "ai-mate-onboarding",
                openChat: false,
                data: {
                    name: promptMessage,
                    prompt: promptMessage,
                    sourceId: "ai-mate-onboarding",
                    dialogues: []
                }
            });
            (0, $5f898ef876d431ab$export$f6d2bc57e324a079)();
        };
        $[0] = publish;
        $[1] = t1;
    } else t1 = $[1];
    const handleOnboardingComplete = t1;
    let t2;
    if ($[2] !== handleOnboardingComplete || $[3] !== onboardingStep || $[4] !== sendAnalyticsEvent) {
        t2 = (buttonName, t3)=>{
            const additionalAttributes = t3 === undefined ? {} : t3;
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "chatOnboardingButton",
                attributes: {
                    mode: "mini-modal",
                    buttonName: buttonName,
                    persona: "consumer",
                    step: onboardingStep,
                    ...additionalAttributes
                }
            });
            bb7: switch(onboardingStep){
                case $5682c3d43d78116c$var$OnboardingStep.prompts:
                    handleOnboardingComplete(additionalAttributes.promptMessage);
                    break bb7;
                case $5682c3d43d78116c$var$OnboardingStep.greetings:
                    setOnboardingStep($5682c3d43d78116c$var$OnboardingStep.prompts);
                    break bb7;
                default:
                    setOnboardingStep($5682c3d43d78116c$var$OnboardingStep.greetings);
            }
        };
        $[2] = handleOnboardingComplete;
        $[3] = onboardingStep;
        $[4] = sendAnalyticsEvent;
        $[5] = t2;
    } else t2 = $[5];
    const handleOnboardingStepChange = t2;
    let t3;
    if ($[6] !== onboardingStep || $[7] !== sendAnalyticsEvent) {
        t3 = (t4)=>{
            const additionalAttributes_0 = t4 === undefined ? {} : t4;
            sendAnalyticsEvent({
                eventType: "screen",
                name: "chatOnboardingScreen",
                attributes: {
                    mode: "mini-modal",
                    persona: "consumer",
                    step: onboardingStep,
                    ...additionalAttributes_0
                }
            });
        };
        $[6] = onboardingStep;
        $[7] = sendAnalyticsEvent;
        $[8] = t3;
    } else t3 = $[8];
    const handleStepViewed = t3;
    const t4 = $5682c3d43d78116c$var$onboardingSubScreenByStep[onboardingStep];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
            data: {
                conversationHistorySubScreen: t4,
                conversationMessagesResponseCount: 0
            }
        });
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== handleOnboardingStepChange || $[12] !== handleStepViewed || $[13] !== onboardingStep || $[14] !== product) {
        t6 = onboardingStep === $5682c3d43d78116c$var$OnboardingStep.greetings && /*#__PURE__*/ $cozmU.createElement((0, $0fefbad7cabf41ea$export$efa7e1177c04ee36), {
            onNext: handleOnboardingStepChange,
            onStepViewed: handleStepViewed,
            product: product
        });
        $[11] = handleOnboardingStepChange;
        $[12] = handleStepViewed;
        $[13] = onboardingStep;
        $[14] = product;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== handleOnboardingStepChange || $[17] !== handleStepViewed || $[18] !== onboardingStep || $[19] !== product) {
        t7 = onboardingStep === $5682c3d43d78116c$var$OnboardingStep.prompts && /*#__PURE__*/ $cozmU.createElement((0, $f50e6d16a91500e7$export$1bc8db60be51b1f7), {
            userPersona: "consumer",
            onNext: handleOnboardingStepChange,
            onStepViewed: handleStepViewed,
            product: product
        });
        $[16] = handleOnboardingStepChange;
        $[17] = handleStepViewed;
        $[18] = onboardingStep;
        $[19] = product;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $5682c3d43d78116c$var$styles.container
        }, t5, t6, t7);
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ product: product })=>{
    const [onboardingStep, setOnboardingStep] = (0, $cozmU.useState)($5682c3d43d78116c$var$OnboardingStep.greetings);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const userPersona = 'consumer'; // TODO: add user persona from the store
    const handleOnboardingComplete = (0, $cozmU.useCallback)((promptMessage)=>{
        publish({
            type: 'chat-new',
            source: 'ai-mate-onboarding',
            openChat: false,
            // If users is seeing Onboarding, Chat is already open
            data: {
                name: promptMessage,
                prompt: promptMessage,
                sourceId: 'ai-mate-onboarding',
                dialogues: []
            }
        });
        (0, $5f898ef876d431ab$export$f6d2bc57e324a079)();
    }, [
        publish
    ]);
    const handleOnboardingStepChange = (0, $cozmU.useCallback)((buttonName, additionalAttributes = {})=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatOnboardingButton',
            attributes: {
                mode: 'mini-modal',
                buttonName: buttonName,
                persona: userPersona,
                step: onboardingStep,
                ...additionalAttributes
            }
        });
        switch(onboardingStep){
            case $5682c3d43d78116c$var$OnboardingStep.prompts:
                handleOnboardingComplete(additionalAttributes.promptMessage);
                break;
            case $5682c3d43d78116c$var$OnboardingStep.greetings:
                setOnboardingStep($5682c3d43d78116c$var$OnboardingStep.prompts);
                break;
            default:
                // always show greetings step on first visit
                setOnboardingStep($5682c3d43d78116c$var$OnboardingStep.greetings);
        }
    }, [
        sendAnalyticsEvent,
        userPersona,
        onboardingStep,
        handleOnboardingComplete
    ]);
    const handleStepViewed = (0, $cozmU.useCallback)((additionalAttributes_0 = {})=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'chatOnboardingScreen',
            attributes: {
                mode: 'mini-modal',
                persona: userPersona,
                step: onboardingStep,
                ...additionalAttributes_0
            }
        });
    }, [
        sendAnalyticsEvent,
        userPersona,
        onboardingStep
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5682c3d43d78116c$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
        data: {
            conversationHistorySubScreen: $5682c3d43d78116c$var$onboardingSubScreenByStep[onboardingStep],
            conversationMessagesResponseCount: 0
        }
    }), onboardingStep === $5682c3d43d78116c$var$OnboardingStep.greetings && /*#__PURE__*/ $cozmU.createElement((0, $0fefbad7cabf41ea$export$efa7e1177c04ee36), {
        onNext: handleOnboardingStepChange,
        onStepViewed: handleStepViewed,
        product: product
    }), onboardingStep === $5682c3d43d78116c$var$OnboardingStep.prompts && /*#__PURE__*/ $cozmU.createElement((0, $f50e6d16a91500e7$export$1bc8db60be51b1f7), {
        userPersona: userPersona,
        onNext: handleOnboardingStepChange,
        onStepViewed: handleStepViewed,
        product: product
    }));
};
const $5682c3d43d78116c$export$d598eeaac373af22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { product: product } = t0;
    if (product === "confluence" && (0, $iDrrr.fg)("rovo_onboarding_modal_confluence_chat_fg") || product === "jira" && (0, $iDrrr.fg)("rovo_onboarding_modal_jira_chat_filter_fg")) {
        const t1 = product;
        let t2;
        if ($[0] !== t1) {
            t2 = /*#__PURE__*/ $cozmU.createElement($5682c3d43d78116c$var$ChatOnboardingImpl, {
                product: t1
            });
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    return null;
} : ({ product: product })=>{
    if (product === 'confluence' && (0, $iDrrr.fg)('rovo_onboarding_modal_confluence_chat_fg') || product === 'jira' && (0, $iDrrr.fg)('rovo_onboarding_modal_jira_chat_filter_fg')) return /*#__PURE__*/ $cozmU.createElement($5682c3d43d78116c$var$ChatOnboardingImpl, {
        product: product
    });
    return null;
};


























var $d7zDK = parcelRequire("d7zDK");


var $gaafy = parcelRequire("gaafy");








var $ekfm7 = parcelRequire("ekfm7");


var $licx9 = parcelRequire("licx9");

const $7d0779453ccb4169$var$messages = (0, $kSwu1.defineMessages)({
    connectSlack: {
        id: "rovo-settings-modal.connect-app-button.ConnectAppButton.connectSlack",
        defaultMessage: "Connect Slack"
    },
    connectGoogleCalendar: {
        id: "rovo-settings-modal.connect-app-button.ConnectAppButton.connectGoogleCalendar",
        defaultMessage: "Connect Google Cal"
    }
});
const $7d0779453ccb4169$var$PRODUCT_CONFIGS = {
    slack: {
        label: $7d0779453ccb4169$var$messages.connectSlack,
        resourceTypes: [
            'slack-connector'
        ],
        sources: [
            'slack'
        ],
        testId: 'insights-connect-slack-button',
        Icon: (0, $gaafy.SlackIconBorderless)
    },
    'google-calendar': {
        label: $7d0779453ccb4169$var$messages.connectGoogleCalendar,
        resourceTypes: [
            'google-calendar-connector'
        ],
        sources: [
            'google-calendar',
            'google_calendar'
        ],
        testId: 'insights-connect-google-calendar-button',
        Icon: (0, $d7zDK.GoogleCalendarIconBorderless)
    }
};
const $7d0779453ccb4169$var$matchesProduct = (connector, { resourceTypes: resourceTypes, sources: sources })=>resourceTypes.includes(connector.resourceType ?? '') || sources.includes(connector.source);
const $7d0779453ccb4169$export$f317ae6760bfcde = ({ product: product, isCompact: isCompact = false, analyticsSource: analyticsSource, analyticsSurface: analyticsSurface, onVisibilityChange: onVisibilityChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [knowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const createOAuthHandler = (0, $7ieQR.useOAuthHandlerFactory)();
    const assistanceServiceParams = (0, $licx9.useAssistanceServiceParams)({
        touchpointSource: analyticsSource
    });
    // Tracks the product the user just connected via OAuth, so we can optimistically hide its button.
    // Keying by product (instead of a boolean + reset effect) keeps the state correct when `product`
    // changes without an extra post-render reset.
    const [locallyConnectedProduct, setLocallyConnectedProduct] = (0, $cozmU.useState)(null);
    const productConfig = $7d0779453ccb4169$var$PRODUCT_CONFIGS[product];
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const connector = (0, $cozmU.useMemo)(()=>knowledgeSources.find((source)=>$7d0779453ccb4169$var$matchesProduct(source, productConfig) && !source.isUserOAuthed && Boolean(source.outboundAuthUrl) && locallyConnectedProduct !== product), [
        locallyConnectedProduct,
        product,
        knowledgeSources,
        productConfig
    ]);
    (0, $cozmU.useEffect)(()=>{
        onVisibilityChange?.(Boolean(connector));
    }, [
        connector,
        onVisibilityChange
    ]);
    const handleConnect = (0, $cozmU.useCallback)(()=>{
        if (!connector) return;
        const { onAuthorize: onAuthorize } = createOAuthHandler({
            friendlyName: connector.friendlyName,
            appSource: connector.source,
            outboundAuthUrl: connector.outboundAuthUrl,
            onCompletedAction: ()=>{
                setLocallyConnectedProduct(product);
            },
            analyticsAttributes: {
                source: analyticsSource,
                surface: analyticsSurface
            }
        });
        onAuthorize();
    }, [
        analyticsSource,
        analyticsSurface,
        connector,
        createOAuthHandler,
        product
    ]);
    if (!connector) return null;
    const { Icon: Icon } = productConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: isCompact ? 'default' : 'subtle',
        spacing: "default",
        iconBefore: Icon,
        onClick: handleConnect,
        testId: productConfig.testId
    }, formatMessage(productConfig.label));
};


const $897decab909b74ff$var$INSIGHTS_CONNECT_APP_PRODUCT_IDS = [
    'slack',
    'google-calendar'
];
const $897decab909b74ff$export$806f337943385db7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { isCompact: isCompact, onVisibilityChange: onVisibilityChange } = t0;
    const [visibleProducts, setVisibleProducts] = (0, $cozmU.useState)($897decab909b74ff$var$_temp);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (product, isVisible)=>{
            setVisibleProducts((currentProducts)=>{
                if (currentProducts.has(product) === isVisible) return currentProducts;
                const nextProducts = new Set(currentProducts);
                if (isVisible) nextProducts.add(product);
                else nextProducts.delete(product);
                return nextProducts;
            });
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleProductVisibilityChange = t1;
    let t2;
    if ($[1] !== onVisibilityChange || $[2] !== visibleProducts.size) {
        t2 = ()=>{
            onVisibilityChange(visibleProducts.size > 0);
        };
        $[1] = onVisibilityChange;
        $[2] = visibleProducts.size;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onVisibilityChange || $[5] !== visibleProducts) {
        t3 = [
            onVisibilityChange,
            visibleProducts
        ];
        $[4] = onVisibilityChange;
        $[5] = visibleProducts;
        $[6] = t3;
    } else t3 = $[6];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = new Map($897decab909b74ff$var$INSIGHTS_CONNECT_APP_PRODUCT_IDS.map((product_0)=>[
                product_0,
                (isVisible_0)=>handleProductVisibilityChange(product_0, isVisible_0)
            ]));
        $[7] = t4;
    } else t4 = $[7];
    const productVisibilityHandlers = t4;
    let t5;
    if ($[8] !== isCompact) {
        t5 = $897decab909b74ff$var$INSIGHTS_CONNECT_APP_PRODUCT_IDS.map((product_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0779453ccb4169$export$f317ae6760bfcde), {
                key: product_1,
                product: product_1,
                isCompact: isCompact,
                analyticsSource: "insightsFeed",
                analyticsSurface: "chat",
                onVisibilityChange: productVisibilityHandlers.get(product_1)
            }));
        $[8] = isCompact;
        $[9] = t5;
    } else t5 = $[9];
    const buttons = t5;
    let t6;
    if ($[10] !== buttons || $[11] !== isCompact) {
        t6 = isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            shouldWrap: true
        }, buttons) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            alignInline: "end"
        }, buttons);
        $[10] = buttons;
        $[11] = isCompact;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ isCompact: isCompact, onVisibilityChange: onVisibilityChange })=>{
    const [visibleProducts, setVisibleProducts] = (0, $cozmU.useState)(()=>new Set());
    const handleProductVisibilityChange = (0, $cozmU.useCallback)((product, isVisible)=>{
        setVisibleProducts((currentProducts)=>{
            if (currentProducts.has(product) === isVisible) return currentProducts;
            const nextProducts = new Set(currentProducts);
            if (isVisible) nextProducts.add(product);
            else nextProducts.delete(product);
            return nextProducts;
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        onVisibilityChange(visibleProducts.size > 0);
    }, [
        onVisibilityChange,
        visibleProducts
    ]);
    // Stable per-product callbacks to keep ConnectAppButton's visibility effect from re-firing.
    const productVisibilityHandlers = (0, $cozmU.useMemo)(()=>new Map($897decab909b74ff$var$INSIGHTS_CONNECT_APP_PRODUCT_IDS.map((product_0)=>[
                product_0,
                (isVisible_0)=>handleProductVisibilityChange(product_0, isVisible_0)
            ])), [
        handleProductVisibilityChange
    ]);
    const buttons = $897decab909b74ff$var$INSIGHTS_CONNECT_APP_PRODUCT_IDS.map((product_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d0779453ccb4169$export$f317ae6760bfcde), {
            key: product_1,
            product: product_1,
            isCompact: isCompact,
            analyticsSource: "insightsFeed",
            analyticsSurface: "chat",
            onVisibilityChange: productVisibilityHandlers.get(product_1)
        }));
    return isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        shouldWrap: true
    }, buttons) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        alignInline: "end"
    }, buttons);
};
function $897decab909b74ff$var$_temp() {
    return new Set();
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























































var $8hfTK = parcelRequire("8hfTK");

/**
 * Fuse.js configuration for conversation search
 * Aligned with existing AFM patterns (command palette, template search)
 */ const $396cca9939d548bf$var$FUSE_CONVERSATION_SEARCH_OPTIONS = {
    // 0.3 threshold for better fuzzy matching (30% similarity required)
    threshold: 0.3,
    // Search fields with weights (higher weight = more important)
    keys: [
        {
            name: 'name',
            weight: Math.pow(2, 5) // 32 - conversation title is most important
        },
        {
            name: 'agent.agent_name',
            weight: Math.pow(2, 4) // 16 - agent name is important
        },
        {
            name: 'lastMessage',
            weight: Math.pow(2, 3) // 8 - last message is secondary
        }
    ],
    // Include score for sorting by relevance
    includeScore: true,
    // Allow sorting by relevance score
    shouldSort: true,
    // Distance for fuzzy matching
    distance: 1000,
    // Ignore field length normalization for better results
    ignoreFieldNorm: true
};
let $396cca9939d548bf$var$cachedFuseIndex = null;
let $396cca9939d548bf$var$cachedConversationIds = [];
/**
 * Creates or returns cached Fuse index if the conversations haven't changed
 */ const $396cca9939d548bf$var$getFuseIndex = (conversations)=>{
    const currentIds = conversations.map((c)=>c.id);
    const idsChanged = currentIds.length !== $396cca9939d548bf$var$cachedConversationIds.length || currentIds.some((id, i)=>id !== $396cca9939d548bf$var$cachedConversationIds[i]);
    if (!$396cca9939d548bf$var$cachedFuseIndex || idsChanged) {
        $396cca9939d548bf$var$cachedFuseIndex = new (0, $8hfTK.default)(conversations, $396cca9939d548bf$var$FUSE_CONVERSATION_SEARCH_OPTIONS);
        $396cca9939d548bf$var$cachedConversationIds = currentIds;
    }
    return $396cca9939d548bf$var$cachedFuseIndex;
};
const $396cca9939d548bf$export$d3e945efe4e24cc1 = (conversations, filters)=>{
    const trimmedSearchValue = filters.searchValue.trim();
    const sortPinned = filters.sortPinned === true;
    const getTimestamp = (timestamp)=>{
        if (!timestamp) return undefined;
        const time = new Date(timestamp).getTime();
        return Number.isNaN(time) ? undefined : time;
    };
    const compareTimestamps = (aTimestamp, bTimestamp, direction)=>{
        const aTime = getTimestamp(aTimestamp);
        const bTime = getTimestamp(bTimestamp);
        if (aTime === undefined && bTime === undefined) return 0;
        if (aTime === undefined) return 1;
        if (bTime === undefined) return -1;
        return direction === 'asc' ? aTime - bTime : bTime - aTime;
    };
    const sortByPinnedThenTime = (a, b)=>{
        const aIsPinned = Boolean(a.isPinned);
        const bIsPinned = Boolean(b.isPinned);
        if (sortPinned && aIsPinned !== bIsPinned) return aIsPinned ? -1 : 1;
        if (sortPinned && aIsPinned && bIsPinned) {
            const pinnedSort = compareTimestamps(a.pinnedAt, b.pinnedAt, 'desc');
            if (pinnedSort !== 0) return pinnedSort;
        }
        return compareTimestamps(a.lastMessageTimestamp, b.lastMessageTimestamp, filters.direction);
    };
    const sortByPinnedOnly = (a, b)=>{
        if (!sortPinned) return 0;
        if (a.isPinned === b.isPinned) return 0;
        return a.isPinned ? -1 : 1;
    };
    // Return all non-empty conversations if no search term
    if (!trimmedSearchValue) return conversations.filter((c)=>!!c && !c.isEmpty).sort(sortByPinnedThenTime);
    // Filter out empty conversations
    const nonEmptyConversations = conversations.filter((c)=>!!c && !c.isEmpty);
    // Get or create Fuse index (cached if conversations haven't changed)
    const fuse = $396cca9939d548bf$var$getFuseIndex(nonEmptyConversations);
    const results = fuse.search(trimmedSearchValue);
    // Extract conversation objects from Fuse results. Keep Fuse relevance within pinned/unpinned groups.
    return results.map((result)=>result.item).sort(sortByPinnedOnly);
};























const $9061e6913249a80b$var$message = (0, $kSwu1.defineMessages)({
    closeChatPanelButtonLabel: {
        id: "ai-mate.main-chat.close-chat-panel-button-label",
        defaultMessage: "Close chat"
    }
});
var $9061e6913249a80b$export$2e2bcd8739ae039 = $9061e6913249a80b$var$message;


const $a042b2f9ad231a48$export$c3e9c9a123921ea6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $9061e6913249a80b$export$2e2bcd8739ae039).closeChatPanelButtonLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClick || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            icon: $a042b2f9ad231a48$var$_temp,
            appearance: "subtle",
            onClick: onClick,
            label: t1,
            testId: "rovo-chat-close-chat-button"
        });
        $[2] = onClick;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...props,
                color: "var(--ds-icon)",
                size: "small"
            }),
        appearance: "subtle",
        onClick: onClick,
        label: formatMessage((0, $9061e6913249a80b$export$2e2bcd8739ae039).closeChatPanelButtonLabel),
        testId: "rovo-chat-close-chat-button"
    });
};
function $a042b2f9ad231a48$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...props,
        color: "var(--ds-icon)",
        size: "small"
    });
}























const $296f0d0b9541cf51$var$message = (0, $kSwu1.defineMessages)({
    maximizeChatButtonLabel: {
        id: "ai-mate.main-chat.maximize-chat-button-label",
        defaultMessage: "Full screen"
    },
    minimizeChatButtonLabel: {
        id: "ai-mate.main-chat.minimize-chat-button-label",
        defaultMessage: "Restore view"
    }
});
var $296f0d0b9541cf51$export$2e2bcd8739ae039 = $296f0d0b9541cf51$var$message;


const $4d8db3c0aae5f684$export$73febb3d65f164db = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $296f0d0b9541cf51$export$2e2bcd8739ae039).maximizeChatButtonLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClick || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-chat-full-screen-button",
            isTooltipDisabled: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))),
            appearance: "subtle",
            onClick: onClick,
            label: t1
        });
        $[2] = onClick;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "rovo-chat-full-screen-button",
        isTooltipDisabled: false,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))),
        appearance: "subtle",
        onClick: onClick,
        label: formatMessage((0, $296f0d0b9541cf51$export$2e2bcd8739ae039).maximizeChatButtonLabel)
    });
};























const $9d95fb0b5ca22037$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    HAMBURGER_MENU_BUTTON: 'rovo-chat-hamburger-menu-button'
};





const $7c297eb97f7eecab$var$message = (0, $kSwu1.defineMessages)({
    newChatButtonLabel: {
        id: "ai-mate.main-chat.new-chat-button-label",
        defaultMessage: "New"
    },
    newChatButtonLabelFullScreen: {
        id: "ai-mate.main-chat.new-chat-button-label-full-screen",
        defaultMessage: "New chat"
    }
});
var $7c297eb97f7eecab$export$2e2bcd8739ae039 = $7c297eb97f7eecab$var$message;


const $124321fa93a6f712$export$47617210fbc06121 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { onClick: onClick, isDisabled: isDisabled, isFullScreen: isFullScreen } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $7c297eb97f7eecab$export$2e2bcd8739ae039).newChatButtonLabelFullScreen);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            color: "currentColor",
            label: ""
        });
        $[2] = t2;
    } else t2 = $[2];
    const t3 = isFullScreen ? (0, $7c297eb97f7eecab$export$2e2bcd8739ae039).newChatButtonLabelFullScreen : (0, $7c297eb97f7eecab$export$2e2bcd8739ae039).newChatButtonLabel;
    let t4;
    if ($[3] !== formatMessage || $[4] !== t3) {
        t4 = formatMessage(t3);
        $[3] = formatMessage;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, t2, t4);
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== isDisabled || $[9] !== isFullScreen || $[10] !== onClick || $[11] !== t1 || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onClick,
            isDisabled: isDisabled,
            shouldFitContainer: isFullScreen,
            testId: (0, $9d95fb0b5ca22037$export$900371d5fadf47e7).NEW_CHAT_BUTTON,
            "aria-label": t1
        }, t5);
        $[8] = isDisabled;
        $[9] = isFullScreen;
        $[10] = onClick;
        $[11] = t1;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ onClick: onClick, isDisabled: isDisabled, isFullScreen: isFullScreen })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // This button uses `Inline` and the icon directly to account for a centered icon + label
    // combo when `isFullScreen` is true. Simply using `shouldFitContainer` would not center the icon.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        shouldFitContainer: isFullScreen,
        testId: (0, $9d95fb0b5ca22037$export$900371d5fadf47e7).NEW_CHAT_BUTTON,
        "aria-label": formatMessage((0, $7c297eb97f7eecab$export$2e2bcd8739ae039).newChatButtonLabelFullScreen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        color: "currentColor",
        label: ""
    }), formatMessage(isFullScreen ? (0, $7c297eb97f7eecab$export$2e2bcd8739ae039).newChatButtonLabelFullScreen : (0, $7c297eb97f7eecab$export$2e2bcd8739ae039).newChatButtonLabel)));
};






/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 

























var $22YX5 = parcelRequire("22YX5");
















const $acc650fb0b4bc07c$var$message = (0, $kSwu1.defineMessages)({
    chatOptionsForConversationButtonLabel: {
        id: "ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label",
        defaultMessage: "Chat options for {conversationName}"
    },
    chatRenameLabel: {
        id: "ai-mate.chat-view.chat-item.chat-rename-label",
        defaultMessage: "Rename"
    },
    chatDeleteLabel: {
        id: "ai-mate.chat-view.chat-item.chat-delete-label",
        defaultMessage: "Delete"
    }
});
var $acc650fb0b4bc07c$export$2e2bcd8739ae039 = $acc650fb0b4bc07c$var$message;



const $20e111cb83976d07$var$styles = {
    wrapper: "_2Y7lL45zaO _4c065U2ADO _3iDTPbQ4SZ _37wbyuF05b _0hPCNLDIqT _0wOv4Q7zJH _1eOmH6o126",
    wrapperSelected: "_0KLXruY9q9",
    pressableChatItem: "_0bjKvD8fU6 _0KLXrujOvk _39xV02N91d _0jFU0VN91d _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg",
    chatItemWrapper: "_30huDKYbGa _0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _39xV02N91d _0jFU0VN91d _1mT5xdRAKS _0ReiIH7zJH",
    dropdownButton: "_1mT5xdWVPG",
    buttonText: "_1EqgXlE1Ft",
    hidden: "_1YKVNsdnbC"
};
const $20e111cb83976d07$export$86e6771ca9311520 = ({ conversation: conversation, isSelected: isSelected, onSelectConversation: onSelectConversation, isFullScreen: isFullScreen })=>{
    (0, $6cFsl.di)((0, $08aaee4c987ae451$export$3b5a3be90f35989a));
    const [isFocusedOrHovered, setIsFocusedOrHovered] = (0, $cozmU.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const lastMessageTime = (0, $de4d3154ef5b0570$export$6feb2ea55018719b)({
        isoDate: conversation.lastMessageTimestamp
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { openModal: openModal } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleItemClick = (0, $cozmU.useCallback)(()=>{
        onSelectConversation(conversation.id);
    }, [
        conversation.id,
        onSelectConversation
    ]);
    const setIsHoveredTrue = (0, $cozmU.useCallback)(()=>setIsFocusedOrHovered(true), []);
    const setIsHoveredFalse = (0, $cozmU.useCallback)(()=>setIsFocusedOrHovered(false), []);
    const handleDropdownToggle = (0, $cozmU.useCallback)((openMenuArgs)=>setIsDropdownOpen(openMenuArgs.isOpen), []);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $20e111cb83976d07$var$styles.chatItemWrapper,
        onMouseEnter: setIsHoveredTrue,
        onMouseLeave: setIsHoveredFalse,
        onFocus: setIsHoveredTrue,
        onBlur: setIsHoveredFalse
    }, /*#__PURE__*/ $cozmU.createElement((0, $22YX5.Bleed), {
        inline: "space.150",
        xcss: (0, $w6R6I.cx)($20e111cb83976d07$var$styles.wrapper, isSelected && $20e111cb83976d07$var$styles.wrapperSelected)
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $20e111cb83976d07$var$styles.pressableChatItem,
        onClick: (e, analyticsEvent)=>{
            sendAnalyticsEvent(analyticsEvent.update({
                actionSubjectId: 'chatViewChatItemClick'
            }));
            handleItemClick();
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.025",
        alignBlock: "start",
        alignInline: "start",
        xcss: $20e111cb83976d07$var$styles.buttonText
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        align: "start",
        weight: isSelected ? 'medium' : undefined
    }, conversation.name), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, lastMessageTime))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($20e111cb83976d07$var$styles.dropdownButton, !isFocusedOrHovered && !isDropdownOpen && $20e111cb83976d07$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        shouldRenderToParent: true,
        onOpenChange: handleDropdownToggle,
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...rest })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...rest,
                label: formatMessage((0, $acc650fb0b4bc07c$export$2e2bcd8739ae039).chatOptionsForConversationButtonLabel, {
                    conversationName: conversation.name
                }),
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                onClick: (e_0, analyticsEvent_0)=>{
                    sendAnalyticsEvent(analyticsEvent_0.update({
                        actionSubjectId: 'chatViewChatOptionsTrigger'
                    }));
                    e_0.stopPropagation();
                    onClick?.(e_0);
                }
            })
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        onClick: (e_1)=>{
            e_1.stopPropagation();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'renameConversationButton'
            });
            openModal(conversation, 'edit');
        }
    }, formatMessage((0, $acc650fb0b4bc07c$export$2e2bcd8739ae039).chatRenameLabel)), /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        onClick: (e_2)=>{
            e_2.stopPropagation();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'deleteConversationButton'
            });
            openModal(conversation, 'delete');
        }
    }, formatMessage((0, $acc650fb0b4bc07c$export$2e2bcd8739ae039).chatDeleteLabel)))))));
};



























const $bf8fae34ea011d72$var$messages = (0, $kSwu1.defineMessages)({
    loadMoreError: {
        id: "conversation-assistant-ui-components.common.chat-conversation-list.conversation-pagination-controls.loadMoreError",
        defaultMessage: "Failed to load more chats."
    },
    loadMoreRetry: {
        id: "conversation-assistant-ui-components.common.chat-conversation-list.conversation-pagination-controls.loadMoreRetry",
        defaultMessage: "Try again"
    },
    loadingMoreLabel: {
        id: "conversation-assistant-ui-components.common.chat-conversation-list.conversation-pagination-controls.loadingMoreLabel",
        defaultMessage: "Loading more chats"
    }
});
const $bf8fae34ea011d72$var$styles = {
    loadMoreSpinner: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VpJKa _13XEGNYbGa",
    loadMoreError: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0Of8r25zaO _1wydGW5zaO _13XEGNYbGa"
};
const $bf8fae34ea011d72$export$1799add816684dda = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { as: t1, role: role, hasMoreConversations: t2, isLoadingMoreConversations: t3, hasLoadMoreConversationsError: t4, onLoadMoreConversations: onLoadMoreConversations, testIdPrefix: testIdPrefix } = t0;
    const as = t1 === undefined ? "li" : t1;
    const hasMoreConversations = t2 === undefined ? false : t2;
    const isLoadingMoreConversations = t3 === undefined ? false : t3;
    const hasLoadMoreConversationsError = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [hasPendingRetry, setHasPendingRetry] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const wasLoadingMoreRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(isLoadingMoreConversations);
    let t5;
    let t6;
    if ($[0] !== isLoadingMoreConversations) {
        t5 = ()=>{
            if (wasLoadingMoreRef.current && !isLoadingMoreConversations) setHasPendingRetry(false);
            wasLoadingMoreRef.current = isLoadingMoreConversations;
        };
        t6 = [
            isLoadingMoreConversations
        ];
        $[0] = isLoadingMoreConversations;
        $[1] = t5;
        $[2] = t6;
    } else {
        t5 = $[1];
        t6 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t5, t6);
    let t7;
    if ($[3] !== hasPendingRetry || $[4] !== isLoadingMoreConversations || $[5] !== onLoadMoreConversations) {
        t7 = ()=>{
            if (isLoadingMoreConversations || hasPendingRetry || !onLoadMoreConversations) return;
            setHasPendingRetry(true);
            onLoadMoreConversations();
        };
        $[3] = hasPendingRetry;
        $[4] = isLoadingMoreConversations;
        $[5] = onLoadMoreConversations;
        $[6] = t7;
    } else t7 = $[6];
    const handleRetry = t7;
    if (!hasMoreConversations) return null;
    if (hasLoadMoreConversationsError) {
        const t8 = `${testIdPrefix}-load-more-error`;
        let t9;
        if ($[7] !== formatMessage) {
            t9 = formatMessage($bf8fae34ea011d72$var$messages.loadMoreError);
            $[7] = formatMessage;
            $[8] = t9;
        } else t9 = $[8];
        let t10;
        if ($[9] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.danger"
            }, t9);
            $[9] = t9;
            $[10] = t10;
        } else t10 = $[10];
        const t11 = isLoadingMoreConversations || hasPendingRetry;
        let t12;
        if ($[11] !== formatMessage) {
            t12 = formatMessage($bf8fae34ea011d72$var$messages.loadMoreRetry);
            $[11] = formatMessage;
            $[12] = t12;
        } else t12 = $[12];
        let t13;
        if ($[13] !== handleRetry || $[14] !== t11 || $[15] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                spacing: "compact",
                isDisabled: t11,
                onClick: handleRetry
            }, t12);
            $[13] = handleRetry;
            $[14] = t11;
            $[15] = t12;
            $[16] = t13;
        } else t13 = $[16];
        let t14;
        if ($[17] !== as || $[18] !== role || $[19] !== t10 || $[20] !== t13 || $[21] !== t8) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: as,
                role: role,
                xcss: $bf8fae34ea011d72$var$styles.loadMoreError,
                testId: t8
            }, t10, t13);
            $[17] = as;
            $[18] = role;
            $[19] = t10;
            $[20] = t13;
            $[21] = t8;
            $[22] = t14;
        } else t14 = $[22];
        return t14;
    }
    if (isLoadingMoreConversations) {
        const t8 = `${testIdPrefix}-load-more-loading`;
        let t9;
        if ($[23] !== formatMessage) {
            t9 = formatMessage($bf8fae34ea011d72$var$messages.loadingMoreLabel);
            $[23] = formatMessage;
            $[24] = t9;
        } else t9 = $[24];
        let t10;
        if ($[25] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small",
                label: t9
            });
            $[25] = t9;
            $[26] = t10;
        } else t10 = $[26];
        let t11;
        if ($[27] !== as || $[28] !== role || $[29] !== t10 || $[30] !== t8) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: as,
                role: role,
                xcss: $bf8fae34ea011d72$var$styles.loadMoreSpinner,
                testId: t8
            }, t10);
            $[27] = as;
            $[28] = role;
            $[29] = t10;
            $[30] = t8;
            $[31] = t11;
        } else t11 = $[31];
        return t11;
    }
    return null;
} : ({ as: as = 'li', role: role, hasMoreConversations: hasMoreConversations = false, isLoadingMoreConversations: isLoadingMoreConversations = false, hasLoadMoreConversationsError: hasLoadMoreConversationsError = false, onLoadMoreConversations: onLoadMoreConversations, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [hasPendingRetry, setHasPendingRetry] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const wasLoadingMoreRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(isLoadingMoreConversations);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (wasLoadingMoreRef.current && !isLoadingMoreConversations) setHasPendingRetry(false);
        wasLoadingMoreRef.current = isLoadingMoreConversations;
    }, [
        isLoadingMoreConversations
    ]);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (isLoadingMoreConversations || hasPendingRetry || !onLoadMoreConversations) return;
        setHasPendingRetry(true);
        onLoadMoreConversations();
    }, [
        hasPendingRetry,
        isLoadingMoreConversations,
        onLoadMoreConversations
    ]);
    if (!hasMoreConversations) return null;
    if (hasLoadMoreConversationsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: as,
        role: role,
        xcss: $bf8fae34ea011d72$var$styles.loadMoreError,
        testId: `${testIdPrefix}-load-more-error`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, formatMessage($bf8fae34ea011d72$var$messages.loadMoreError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLoadingMoreConversations || hasPendingRetry,
        onClick: handleRetry
    }, formatMessage($bf8fae34ea011d72$var$messages.loadMoreRetry)));
    if (isLoadingMoreConversations) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: as,
        role: role,
        xcss: $bf8fae34ea011d72$var$styles.loadMoreSpinner,
        testId: `${testIdPrefix}-load-more-loading`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        label: formatMessage($bf8fae34ea011d72$var$messages.loadingMoreLabel)
    }));
    return null;
};





const $dd72dd9b47878ac6$var$message = (0, $kSwu1.defineMessages)({
    backButtonLabel: {
        id: "ai-mate.conversation-list-view.back-button.label",
        defaultMessage: "Back"
    },
    headerTitle: {
        id: "ai-mate.conversation-list-view.header-title",
        defaultMessage: "Chat History"
    },
    newChatButtonLabel: {
        id: "ai-mate.conversation-list-view.new-chat-button.label",
        defaultMessage: "New chat"
    },
    closeChatButtonLabel: {
        id: "ai-mate.conversation-list-view.close-chat-button.label",
        defaultMessage: "Close chat"
    },
    noResults: {
        id: "ai-mate.conversation-list-view.no-chat",
        defaultMessage: "No results"
    },
    searchPlaceholder: {
        id: "ai-mate.conversation-list-view.search-input.placeholder",
        defaultMessage: "Search chats"
    },
    accessibleSearchResults: {
        id: "ai-mate.conversation-list-view.accessible-search-results",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{results, plural, =1 {1 result found} other {# results found}}"
    }
});
var $dd72dd9b47878ac6$export$2e2bcd8739ae039 = $dd72dd9b47878ac6$var$message;


const $ceaa21ca4b3ca439$var$styles = {
    wrapper: "_4bt5LAnQyn _0jFU0VN91d _39xV02N91d",
    recentChat: "_4bt5LAnQyn _2WAcuGnQyn",
    conversationList: "_1LMyvKYbGa _2Y7lL48HPE _2WAcuGIZbP _313842Pgdg",
    searchBar: "_2Y7lL48HPE _1mT5xdHE3j _0Of8r22ADO _1wydGW5zaO",
    accessibleSearchResults: "_1YKVNsdnbC _1mT5xdWVPG",
    chatItem: "_313842Pgdg"
};
const $ceaa21ca4b3ca439$export$669ee3986ec57b9c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { conversations: conversations, currentConversationId: currentConversationId, onSelectConversation: onSelectConversation, onNewConversation: onNewConversation, onCloseChat: onCloseChat, onMaximizeChat: onMaximizeChat, isFullScreen: isFullScreen, onConfirmEditConversation: onConfirmEditConversation, onConfirmDeleteConversation: onConfirmDeleteConversation, hasMoreConversations: hasMoreConversations, isLoadingMoreConversations: isLoadingMoreConversations, hasLoadMoreConversationsError: hasLoadMoreConversationsError, onLoadMoreConversations: onLoadMoreConversations, chatRefreshHeader: chatRefreshHeader } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [searchValue, setSearchValue] = (0, $cozmU.useState)("");
    const { conversation: conversation } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_pinned_fe");
        $[0] = t1;
    } else t1 = $[0];
    const isPinnedChatsEnabled = t1;
    let t2;
    if ($[1] !== conversations || $[2] !== searchValue) {
        t2 = (0, $396cca9939d548bf$export$d3e945efe4e24cc1)(conversations, {
            direction: "desc",
            searchValue: searchValue,
            sortPinned: isPinnedChatsEnabled
        });
        $[1] = conversations;
        $[2] = searchValue;
        $[3] = t2;
    } else t2 = $[3];
    const sortedConversations = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (searchValue_0)=>{
            setSearchValue(searchValue_0);
        };
        $[4] = t3;
    } else t3 = $[4];
    const handleSearchChange = t3;
    let t4;
    if ($[5] !== searchValue) {
        t4 = searchValue.trim();
        $[5] = searchValue;
        $[6] = t4;
    } else t4 = $[6];
    const isSearchActive = t4.length > 0;
    let t5;
    if ($[7] !== formatMessage || $[8] !== isFullScreen || $[9] !== onCloseChat || $[10] !== onMaximizeChat || $[11] !== onNewConversation || $[12] !== sendAnalyticsEvent) {
        t5 = !isFullScreen ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            padding: "space.200"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            as: "h2",
            size: "small"
        }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).headerTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $124321fa93a6f712$export$47617210fbc06121), {
            onClick: (_, e)=>{
                sendAnalyticsEvent(e.update({
                    actionSubjectId: "chatViewNewChatButton"
                }));
                onNewConversation();
            }
        }), !!onMaximizeChat && /*#__PURE__*/ $cozmU.createElement((0, $4d8db3c0aae5f684$export$73febb3d65f164db), {
            onClick: (__0, e_0)=>{
                sendAnalyticsEvent(e_0.update({
                    actionSubjectId: "maximizeChatButton"
                }));
                onMaximizeChat();
            }
        }), !!onCloseChat && /*#__PURE__*/ $cozmU.createElement((0, $a042b2f9ad231a48$export$c3e9c9a123921ea6), {
            onClick: (__1, e_1)=>{
                sendAnalyticsEvent(e_1.update({
                    actionSubjectId: "chatViewCloseChatButton"
                }));
                onCloseChat();
            }
        })))) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingBlockEnd: "space.300",
            paddingInline: "space.200",
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "medium"
        }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).headerTitle)), !!onCloseChat && /*#__PURE__*/ $cozmU.createElement((0, $a042b2f9ad231a48$export$c3e9c9a123921ea6), {
            onClick: (__2, e_2)=>{
                sendAnalyticsEvent(e_2.update({
                    actionSubjectId: "chatViewCloseChatButton"
                }));
                onCloseChat();
            }
        })));
        $[7] = formatMessage;
        $[8] = isFullScreen;
        $[9] = onCloseChat;
        $[10] = onMaximizeChat;
        $[11] = onNewConversation;
        $[12] = sendAnalyticsEvent;
        $[13] = t5;
    } else t5 = $[13];
    const header = t5;
    const t6 = chatRefreshHeader ? chatRefreshHeader : header;
    let t7;
    if ($[14] !== formatMessage) {
        t7 = formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).searchPlaceholder);
        $[14] = formatMessage;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $ceaa21ca4b3ca439$var$styles.searchBar
        }, /*#__PURE__*/ $cozmU.createElement((0, $gitiq.SearchInput), {
            placeholderText: t7,
            onSearch: handleSearchChange
        }));
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== formatMessage || $[19] !== sortedConversations.length) {
        t9 = formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).accessibleSearchResults, {
            results: sortedConversations.length
        });
        $[18] = formatMessage;
        $[19] = sortedConversations.length;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $ceaa21ca4b3ca439$var$styles.accessibleSearchResults,
            role: "status",
            "aria-atomic": true
        }, t9);
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== formatMessage || $[24] !== sortedConversations.length) {
        t11 = sortedConversations.length === 0 && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.200",
            as: "li",
            xcss: $ceaa21ca4b3ca439$var$styles.chatItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            align: "center",
            color: "color.text.subtle"
        }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).noResults)));
        $[23] = formatMessage;
        $[24] = sortedConversations.length;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== currentConversationId || $[27] !== isFullScreen || $[28] !== onSelectConversation || $[29] !== sortedConversations) {
        t12 = sortedConversations.length > 0 && sortedConversations.map((conversation_0)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                key: conversation_0.id,
                as: "li",
                xcss: $ceaa21ca4b3ca439$var$styles.chatItem
            }, /*#__PURE__*/ $cozmU.createElement((0, $20e111cb83976d07$export$86e6771ca9311520), {
                conversation: conversation_0,
                isSelected: currentConversationId === conversation_0.id,
                onSelectConversation: onSelectConversation,
                isFullScreen: isFullScreen
            })));
        $[26] = currentConversationId;
        $[27] = isFullScreen;
        $[28] = onSelectConversation;
        $[29] = sortedConversations;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== hasLoadMoreConversationsError || $[32] !== hasMoreConversations || $[33] !== isLoadingMoreConversations || $[34] !== isSearchActive || $[35] !== onLoadMoreConversations) {
        t13 = !isSearchActive && /*#__PURE__*/ $cozmU.createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
            hasMoreConversations: hasMoreConversations,
            isLoadingMoreConversations: isLoadingMoreConversations,
            hasLoadMoreConversationsError: hasLoadMoreConversationsError,
            onLoadMoreConversations: onLoadMoreConversations,
            testIdPrefix: "chat-conversation-list"
        });
        $[31] = hasLoadMoreConversationsError;
        $[32] = hasMoreConversations;
        $[33] = isLoadingMoreConversations;
        $[34] = isSearchActive;
        $[35] = onLoadMoreConversations;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== t11 || $[38] !== t12 || $[39] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $ceaa21ca4b3ca439$var$styles.conversationList,
            as: "ul"
        }, t11, t12, t13);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== t10 || $[42] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $ceaa21ca4b3ca439$var$styles.recentChat
        }, t10, t14);
        $[41] = t10;
        $[42] = t14;
        $[43] = t15;
    } else t15 = $[43];
    let t16;
    if ($[44] !== conversation.id || $[45] !== onConfirmEditConversation) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
            onEditConfirm: (name)=>onConfirmEditConversation(conversation.id, name)
        });
        $[44] = conversation.id;
        $[45] = onConfirmEditConversation;
        $[46] = t16;
    } else t16 = $[46];
    let t17;
    if ($[47] !== conversation.id || $[48] !== onConfirmDeleteConversation) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
            onDeleteConfirm: ()=>onConfirmDeleteConversation(conversation.id)
        });
        $[47] = conversation.id;
        $[48] = onConfirmDeleteConversation;
        $[49] = t17;
    } else t17 = $[49];
    let t18;
    if ($[50] !== t15 || $[51] !== t16 || $[52] !== t17 || $[53] !== t6 || $[54] !== t8) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $ceaa21ca4b3ca439$var$styles.wrapper,
            testId: "ai-mate-conversation-list-view",
            alignBlock: "start"
        }, t6, t8, t15, t16, t17);
        $[50] = t15;
        $[51] = t16;
        $[52] = t17;
        $[53] = t6;
        $[54] = t8;
        $[55] = t18;
    } else t18 = $[55];
    return t18;
} : ({ conversations: conversations, currentConversationId: currentConversationId, onSelectConversation: onSelectConversation, onNewConversation: onNewConversation, onCloseChat: onCloseChat, onMaximizeChat: onMaximizeChat, isFullScreen: isFullScreen, onConfirmEditConversation: onConfirmEditConversation, onConfirmDeleteConversation: onConfirmDeleteConversation, hasMoreConversations: hasMoreConversations, isLoadingMoreConversations: isLoadingMoreConversations, hasLoadMoreConversationsError: hasLoadMoreConversationsError, onLoadMoreConversations: onLoadMoreConversations, chatRefreshHeader: chatRefreshHeader })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [searchValue, setSearchValue] = (0, $cozmU.useState)('');
    const { conversation: conversation } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const isPinnedChatsEnabled = (0, $iDrrr.fg)('rovo_chat_pinned_fe');
    const sortedConversations = (0, $cozmU.useMemo)(()=>(0, $396cca9939d548bf$export$d3e945efe4e24cc1)(conversations, {
            direction: 'desc',
            searchValue: searchValue,
            sortPinned: isPinnedChatsEnabled
        }), [
        conversations,
        isPinnedChatsEnabled,
        searchValue
    ]);
    const handleSearchChange = (0, $cozmU.useCallback)((searchValue_0)=>{
        setSearchValue(searchValue_0);
    }, []);
    const isSearchActive = searchValue.trim().length > 0;
    const header = !isFullScreen ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).headerTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $124321fa93a6f712$export$47617210fbc06121), {
        onClick: (_, e)=>{
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'chatViewNewChatButton'
            }));
            onNewConversation();
        }
    }), !!onMaximizeChat && /*#__PURE__*/ $cozmU.createElement((0, $4d8db3c0aae5f684$export$73febb3d65f164db), {
        onClick: (__0, e_0)=>{
            sendAnalyticsEvent(e_0.update({
                actionSubjectId: 'maximizeChatButton'
            }));
            onMaximizeChat();
        }
    }), !!onCloseChat && /*#__PURE__*/ $cozmU.createElement((0, $a042b2f9ad231a48$export$c3e9c9a123921ea6), {
        onClick: (__1, e_1)=>{
            sendAnalyticsEvent(e_1.update({
                actionSubjectId: 'chatViewCloseChatButton'
            }));
            onCloseChat();
        }
    })))) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        paddingBlockEnd: "space.300",
        paddingInline: "space.200",
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "medium"
    }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).headerTitle)), !!onCloseChat && /*#__PURE__*/ $cozmU.createElement((0, $a042b2f9ad231a48$export$c3e9c9a123921ea6), {
        onClick: (__2, e_2)=>{
            sendAnalyticsEvent(e_2.update({
                actionSubjectId: 'chatViewCloseChatButton'
            }));
            onCloseChat();
        }
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $ceaa21ca4b3ca439$var$styles.wrapper,
        testId: "ai-mate-conversation-list-view",
        alignBlock: "start"
    }, chatRefreshHeader ? chatRefreshHeader : header, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ceaa21ca4b3ca439$var$styles.searchBar
    }, /*#__PURE__*/ $cozmU.createElement((0, $gitiq.SearchInput), {
        placeholderText: formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).searchPlaceholder),
        onSearch: handleSearchChange
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $ceaa21ca4b3ca439$var$styles.recentChat
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ceaa21ca4b3ca439$var$styles.accessibleSearchResults,
        role: "status",
        "aria-atomic": true
    }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).accessibleSearchResults, {
        results: sortedConversations.length
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $ceaa21ca4b3ca439$var$styles.conversationList,
        as: "ul"
    }, sortedConversations.length === 0 && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200",
        as: "li",
        xcss: $ceaa21ca4b3ca439$var$styles.chatItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        align: "center",
        color: "color.text.subtle"
    }, formatMessage((0, $dd72dd9b47878ac6$export$2e2bcd8739ae039).noResults))), sortedConversations.length > 0 && sortedConversations.map((conversation_0)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: conversation_0.id,
            as: "li",
            xcss: $ceaa21ca4b3ca439$var$styles.chatItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $20e111cb83976d07$export$86e6771ca9311520), {
            conversation: conversation_0,
            isSelected: currentConversationId === conversation_0.id,
            onSelectConversation: onSelectConversation,
            isFullScreen: isFullScreen
        }))), !isSearchActive && /*#__PURE__*/ $cozmU.createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
        hasMoreConversations: hasMoreConversations,
        isLoadingMoreConversations: isLoadingMoreConversations,
        hasLoadMoreConversationsError: hasLoadMoreConversationsError,
        onLoadMoreConversations: onLoadMoreConversations,
        testIdPrefix: "chat-conversation-list"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
        onEditConfirm: (name)=>onConfirmEditConversation(conversation.id, name)
    }), /*#__PURE__*/ $cozmU.createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
        onDeleteConfirm: ()=>onConfirmDeleteConversation(conversation.id)
    }));
};


















const $5c026e9a93c43806$export$c84be89e9a4c6ea7 = ({ chatRefreshHeader: chatRefreshHeader })=>{
    (0, $6cFsl.di)((0, $eKjv9.useGlobalConfig), (0, $n71o5.useChatStore), (0, $bGNkz.useUIStoreActions), (0, $dSCNl.useUIConfig), (0, $8akfd.useStagingAreaActions));
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { resetStagingArea: resetStagingArea } = (0, $8akfd.useStagingAreaActions)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [{ conversations: conversationsStore, currentConversationId: currentConversationId, conversationPagination: conversationPagination }, { setSelectedConversation: setSelectedConversation, updateConversation: updateConversation, deleteConversation: deleteConversation, loadMoreConversationChannelsData: loadMoreConversationChannelsData, setConversationListMounted: setConversationListMounted }] = (0, $n71o5.useChatStore)();
    const { closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const { atlasURL: atlasURL } = (0, $ef5a1d3f9c0316fa$export$8a1abb7c176bd202)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatConversationHistory'
        });
    // Should only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setConversationListMounted(true);
        return ()=>{
            setConversationListMounted(false);
        };
    }, [
        setConversationListMounted
    ]);
    const handleItemClick = (0, $cozmU.useCallback)((conversationId)=>{
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) resetStagingArea();
        setSelectedConversation({
            conversationId: conversationId
        });
        setActiveMenu('none');
    }, [
        resetStagingArea,
        setActiveMenu,
        setSelectedConversation
    ]);
    const handleNewChatClick = (0, $cozmU.useCallback)(()=>{
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) resetStagingArea();
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        if (!fullScreen) setActiveMenu('none');
    }, [
        resetStagingArea,
        setActiveMenu,
        setSelectedConversation,
        fullScreen
    ]);
    const handleEditConfirm = (0, $cozmU.useCallback)(async (conversationId, newName)=>{
        try {
            await updateConversation({
                conversationId: conversationId,
                data: {
                    name: newName.trim()
                }
            });
        } catch (error) {
            if (error instanceof (0, $8A2GO.ApiError) && (0, $bxkJA.isChannelNotFoundError)(error)) return {
                error: error.message
            };
            throw error;
        }
    }, [
        updateConversation
    ]);
    const handleDeleteConfirm = (0, $cozmU.useCallback)(async (conversationId)=>{
        try {
            await deleteConversation({
                conversationId: conversationId
            });
        } catch (error) {
            if (error instanceof (0, $8A2GO.ApiError) && (0, $bxkJA.isChannelNotFoundError)(error)) return {
                error: error.message
            };
            throw error;
        }
    }, [
        deleteConversation
    ]);
    const handleCloseChat = (0, $cozmU.useCallback)(()=>{
        if (fullScreen) setActiveMenu('none');
        else closeChat();
    }, [
        fullScreen,
        closeChat,
        setActiveMenu
    ]);
    const conversations = (0, $cozmU.useMemo)(()=>Object.values(conversationsStore).map((conversation)=>({
                ...conversation,
                isEmpty: (0, $1IZrU.isEmptyConversation)(conversation.id)
            })), [
        conversationsStore
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $ceaa21ca4b3ca439$export$669ee3986ec57b9c), {
        conversations: conversations,
        isFullScreen: !!fullScreen,
        currentConversationId: currentConversationId,
        onSelectConversation: handleItemClick,
        onNewConversation: handleNewChatClick,
        onCloseChat: handleCloseChat,
        onMaximizeChat: ()=>{
            window.open((0, $dTEBe.addRovoParamsToUrl)(atlasURL('/chat'), {
                pathway: 'chat',
                conversationId: !(0, $1IZrU.isEmptyConversation)(conversation?.id) ? conversation?.id : undefined
            }), '_blank', 'noopener, noreferrer');
        },
        onConfirmEditConversation: handleEditConfirm,
        onConfirmDeleteConversation: handleDeleteConfirm,
        chatRefreshHeader: chatRefreshHeader,
        hasMoreConversations: conversationPagination.hasMore,
        isLoadingMoreConversations: conversationPagination.isLoadingMore,
        hasLoadMoreConversationsError: Boolean(conversationPagination.loadMoreError),
        onLoadMoreConversations: loadMoreConversationChannelsData
    });
};

























































































const $afe9abe71a349ab1$var$message = (0, $kSwu1.defineMessages)({
    newChatButtonLabel: {
        id: "ai-mate.all-chats-view.new-chat-button-label",
        defaultMessage: "New chat"
    },
    noResults: {
        id: "ai-mate.all-chats-view.no-results",
        defaultMessage: "No results"
    },
    accessibleSearchResults: {
        id: "conversation-assistant-ui-components.common.chat-conversation-list-refresh.accessibleSearchResults",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{results, plural, =1 {1 result found} other {# results found}}"
    }
});
var $afe9abe71a349ab1$export$2e2bcd8739ae039 = $afe9abe71a349ab1$var$message;


const $05705f898282ed37$var$fsStyles = {
    wrapper: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _39xV02N91d _2Zuz6QVa5s _1ZnuxbVa5s",
    redesignWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _39xV02N91d _2Zuz6QPgdg _1ZnuxbPgdg",
    contentContainer: "_24h04i2Njc _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0jFU0VN91d _39xV02N91d _1EqgXlOAqP _0GTcwRIZbP _2xTnZxIZbP _0Of8r2S40j _1wydGWVa5s",
    legacyContentContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0jFU0VN91d _39xV02N91d",
    headerContainer: "_2mHwu85zaO _0Of8r2kG2W _1wydGWkG2W",
    redesignHeaderContainer: "_0Of8r2Pgdg _1wydGWPgdg",
    header: "_37wbyuI7V3",
    searchBarContainer: "_3iDTPbQ4SZ _3138425zaO",
    conversationsContainer: "_2mHwu82ADO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2WAcuGIZbP _4kiQYAdnbC",
    redesignConversationsContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _313842NHnM _4bt5LAnQyn _2WAcuGnQyn _0KLXrulfZc",
    redesignSearchResultsContainer: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAIZbP _313842NHnM _4bt5LAnQyn _2WAcuGnQyn _0KLXrulfZc",
    redesignConversationList: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1LMyvKYbGa _4bt5LAnQyn _2WAcuGIZbP _4kiQYAdnbC _43nrzTPgdg _0rIjykPgdg _0LQT5EPgdg",
    conversationRow: "_1LMyvKYbGa _43nrzTPgdg _0KLXrulfZc"
};
const $05705f898282ed37$var$styles = {
    wrapper: "_4bt5LAnQyn _0jFU0VN91d _39xV02N91d",
    recentChat: "_4bt5LAnQyn _2WAcuGnQyn",
    conversationList: "_1LMyvKYbGa _2Y7lL48HPE _2WAcuGIZbP _313842Pgdg",
    searchBar: "_2Y7lL48HPE _1mT5xdHE3j _0Of8r22ADO _1wydGW5zaO",
    accessibleSearchResults: "_1YKVNsdnbC _1mT5xdWVPG",
    chatItem: "_1LMyvKYbGa _313842Pgdg"
};
const $05705f898282ed37$export$f061bcb5e2cbb129 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { conversations: conversations, searchQuery: searchQuery, title: title, searchPlaceholderText: searchPlaceholderText, onNewChatClick: onNewChatClick, onSearchQueryChange: onSearchQueryChange, onConversationSelect: onConversationSelect, onConversationDelete: onConversationDelete, onConversationEdit: onConversationEdit, onConversationPinToggle: onConversationPinToggle, isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled, isFullScreen: isFullScreen, chatRefreshHeader: chatRefreshHeader, cloudId: cloudId, hasMoreConversations: hasMoreConversations, isLoadingMoreConversations: isLoadingMoreConversations, hasLoadMoreConversationsError: hasLoadMoreConversationsError, onLoadMoreConversations: onLoadMoreConversations } = t0;
    const { conversation: conversation } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_pinned_fe");
        $[0] = t1;
    } else t1 = $[0];
    const isPinnedChatsEnabled = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $iDrrr.fg)("rovo_chat_redesign_all_chats_page");
        $[1] = t2;
    } else t2 = $[1];
    const isAllChatsPageRedesignEnabled = t2;
    const gatedConversationPinToggle = isPinnedChatsEnabled ? onConversationPinToggle : undefined;
    let t3;
    if ($[2] !== conversations || $[3] !== searchQuery) {
        t3 = (0, $396cca9939d548bf$export$d3e945efe4e24cc1)(conversations, {
            direction: "desc",
            searchValue: searchQuery,
            sortPinned: isPinnedChatsEnabled
        });
        $[2] = conversations;
        $[3] = searchQuery;
        $[4] = t3;
    } else t3 = $[4];
    const sortedConversations = t3;
    let t4;
    if ($[5] !== searchQuery) {
        t4 = searchQuery.trim();
        $[5] = searchQuery;
        $[6] = t4;
    } else t4 = $[6];
    const isSearchActive = t4.length > 0;
    let t5;
    if ($[7] !== formatMessage || $[8] !== isSearchActive || $[9] !== sortedConversations.length) {
        t5 = isSearchActive ? formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).accessibleSearchResults, {
            results: sortedConversations.length
        }) : null;
        $[7] = formatMessage;
        $[8] = isSearchActive;
        $[9] = sortedConversations.length;
        $[10] = t5;
    } else t5 = $[10];
    const searchResultsAnnouncement = t5;
    let t6;
    if ($[11] !== chatRefreshHeader || $[12] !== cloudId || $[13] !== conversation.id || $[14] !== formatMessage || $[15] !== gatedConversationPinToggle || $[16] !== hasLoadMoreConversationsError || $[17] !== hasMoreConversations || $[18] !== isFullScreen || $[19] !== isLoadingMoreConversations || $[20] !== isSearchActive || $[21] !== isSpinnerOverlayConversationIconEnabled || $[22] !== onConversationDelete || $[23] !== onConversationEdit || $[24] !== onConversationSelect || $[25] !== onLoadMoreConversations || $[26] !== onNewChatClick || $[27] !== onSearchQueryChange || $[28] !== searchPlaceholderText || $[29] !== searchResultsAnnouncement || $[30] !== sortedConversations || $[31] !== title) {
        t6 = isFullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: (0, $w6R6I.cx)($05705f898282ed37$var$fsStyles.wrapper, isAllChatsPageRedesignEnabled ? $05705f898282ed37$var$fsStyles.redesignWrapper : undefined),
            testId: "ai-mate-conversation-list-refresh-view",
            alignBlock: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isAllChatsPageRedesignEnabled ? $05705f898282ed37$var$fsStyles.contentContainer : $05705f898282ed37$var$fsStyles.legacyContentContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($05705f898282ed37$var$fsStyles.headerContainer, isAllChatsPageRedesignEnabled ? $05705f898282ed37$var$fsStyles.redesignHeaderContainer : undefined)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $05705f898282ed37$var$fsStyles.header
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "large"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            appearance: "default",
            spacing: "default",
            onClick: onNewChatClick
        }, formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).newChatButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $05705f898282ed37$var$fsStyles.searchBarContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
            labelText: searchPlaceholderText,
            placeholderText: isAllChatsPageRedesignEnabled ? undefined : searchPlaceholderText,
            onSearch: onSearchQueryChange,
            isCompact: isAllChatsPageRedesignEnabled
        }))), isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $05705f898282ed37$var$styles.accessibleSearchResults,
            role: "status",
            "aria-atomic": true
        }, searchResultsAnnouncement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isAllChatsPageRedesignEnabled ? isSearchActive ? $05705f898282ed37$var$fsStyles.redesignSearchResultsContainer : $05705f898282ed37$var$fsStyles.redesignConversationsContainer : $05705f898282ed37$var$fsStyles.conversationsContainer,
            role: isAllChatsPageRedesignEnabled ? undefined : "list"
        }, isAllChatsPageRedesignEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $05705f898282ed37$var$fsStyles.redesignConversationList,
            as: "ul"
        }, sortedConversations.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.200",
            as: "li",
            xcss: $05705f898282ed37$var$styles.chatItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            align: "center",
            color: "color.text.subtle"
        }, formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).noResults))), sortedConversations.map((conversation_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: conversation_0.id,
                as: "li",
                xcss: $05705f898282ed37$var$fsStyles.conversationRow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
                conversation: conversation_0,
                onConversationSelect: onConversationSelect,
                onConversationPinToggle: gatedConversationPinToggle,
                isPinnedChatsEnabled: isPinnedChatsEnabled,
                isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
                cloudId: cloudId
            }))), !isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $05705f898282ed37$var$fsStyles.conversationRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
            as: "div",
            hasMoreConversations: hasMoreConversations,
            isLoadingMoreConversations: isLoadingMoreConversations,
            hasLoadMoreConversationsError: hasLoadMoreConversationsError,
            onLoadMoreConversations: onLoadMoreConversations,
            testIdPrefix: "chat-conversation-list-refresh"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, sortedConversations.map((conversation_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: conversation_1.id,
                role: "listitem"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
                conversation: conversation_1,
                onConversationSelect: onConversationSelect,
                onConversationPinToggle: gatedConversationPinToggle,
                isPinnedChatsEnabled: isPinnedChatsEnabled,
                isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
                cloudId: cloudId
            }))), !isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
            as: "div",
            role: "listitem",
            hasMoreConversations: hasMoreConversations,
            isLoadingMoreConversations: isLoadingMoreConversations,
            hasLoadMoreConversationsError: hasLoadMoreConversationsError,
            onLoadMoreConversations: onLoadMoreConversations,
            testIdPrefix: "chat-conversation-list-refresh"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
            onEditConfirm: (name)=>onConversationEdit(conversation.id, name)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
            onDeleteConfirm: ()=>onConversationDelete(conversation.id)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $05705f898282ed37$var$styles.wrapper,
            testId: "ai-mate-conversation-list-view",
            alignBlock: "start"
        }, chatRefreshHeader && chatRefreshHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $05705f898282ed37$var$styles.searchBar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
            placeholderText: searchPlaceholderText,
            onSearch: onSearchQueryChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $05705f898282ed37$var$styles.recentChat
        }, isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $05705f898282ed37$var$styles.accessibleSearchResults,
            role: "status",
            "aria-atomic": true
        }, searchResultsAnnouncement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $05705f898282ed37$var$styles.conversationList,
            as: "ul"
        }, sortedConversations.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.200",
            as: "li",
            xcss: $05705f898282ed37$var$styles.chatItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            align: "center",
            color: "color.text.subtle"
        }, formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).noResults))), sortedConversations.length > 0 && sortedConversations.map((conversation_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: conversation_2.id,
                as: "li",
                xcss: $05705f898282ed37$var$styles.chatItem
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
                conversation: conversation_2,
                onConversationSelect: onConversationSelect,
                onConversationPinToggle: gatedConversationPinToggle,
                isPinnedChatsEnabled: isPinnedChatsEnabled,
                isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
                cloudId: cloudId
            }))), !isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
            as: "li",
            hasMoreConversations: hasMoreConversations,
            isLoadingMoreConversations: isLoadingMoreConversations,
            hasLoadMoreConversationsError: hasLoadMoreConversationsError,
            onLoadMoreConversations: onLoadMoreConversations,
            testIdPrefix: "chat-conversation-list-refresh"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
            onEditConfirm: (name_0)=>onConversationEdit(conversation.id, name_0)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
            onDeleteConfirm: ()=>onConversationDelete(conversation.id)
        }));
        $[11] = chatRefreshHeader;
        $[12] = cloudId;
        $[13] = conversation.id;
        $[14] = formatMessage;
        $[15] = gatedConversationPinToggle;
        $[16] = hasLoadMoreConversationsError;
        $[17] = hasMoreConversations;
        $[18] = isFullScreen;
        $[19] = isLoadingMoreConversations;
        $[20] = isSearchActive;
        $[21] = isSpinnerOverlayConversationIconEnabled;
        $[22] = onConversationDelete;
        $[23] = onConversationEdit;
        $[24] = onConversationSelect;
        $[25] = onLoadMoreConversations;
        $[26] = onNewChatClick;
        $[27] = onSearchQueryChange;
        $[28] = searchPlaceholderText;
        $[29] = searchResultsAnnouncement;
        $[30] = sortedConversations;
        $[31] = title;
        $[32] = t6;
    } else t6 = $[32];
    return t6;
} : ({ conversations: conversations, searchQuery: searchQuery, title: title, searchPlaceholderText: searchPlaceholderText, onNewChatClick: onNewChatClick, onSearchQueryChange: onSearchQueryChange, onConversationSelect: onConversationSelect, onConversationDelete: onConversationDelete, onConversationEdit: onConversationEdit, onConversationPinToggle: onConversationPinToggle, isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled, isFullScreen: isFullScreen, chatRefreshHeader: chatRefreshHeader, cloudId: cloudId, hasMoreConversations: hasMoreConversations, isLoadingMoreConversations: isLoadingMoreConversations, hasLoadMoreConversationsError: hasLoadMoreConversationsError, onLoadMoreConversations: onLoadMoreConversations })=>{
    // conversation to edit / delete.
    const { conversation: conversation } = (0, $08aaee4c987ae451$export$3b5a3be90f35989a)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isPinnedChatsEnabled = (0, $iDrrr.fg)('rovo_chat_pinned_fe');
    const isAllChatsPageRedesignEnabled = (0, $iDrrr.fg)('rovo_chat_redesign_all_chats_page');
    const gatedConversationPinToggle = isPinnedChatsEnabled ? onConversationPinToggle : undefined;
    const sortedConversations = (0, $cozmU.useMemo)(()=>(0, $396cca9939d548bf$export$d3e945efe4e24cc1)(conversations, {
            direction: 'desc',
            searchValue: searchQuery,
            sortPinned: isPinnedChatsEnabled
        }), [
        conversations,
        isPinnedChatsEnabled,
        searchQuery
    ]);
    const isSearchActive = searchQuery.trim().length > 0;
    const searchResultsAnnouncement = isSearchActive ? formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).accessibleSearchResults, {
        results: sortedConversations.length
    }) : null;
    return isFullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($05705f898282ed37$var$fsStyles.wrapper, isAllChatsPageRedesignEnabled ? $05705f898282ed37$var$fsStyles.redesignWrapper : undefined),
        testId: "ai-mate-conversation-list-refresh-view",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAllChatsPageRedesignEnabled ? $05705f898282ed37$var$fsStyles.contentContainer : $05705f898282ed37$var$fsStyles.legacyContentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($05705f898282ed37$var$fsStyles.headerContainer, isAllChatsPageRedesignEnabled ? $05705f898282ed37$var$fsStyles.redesignHeaderContainer : undefined)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $05705f898282ed37$var$fsStyles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        appearance: "default",
        spacing: "default",
        onClick: onNewChatClick
    }, formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).newChatButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $05705f898282ed37$var$fsStyles.searchBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        labelText: searchPlaceholderText,
        placeholderText: isAllChatsPageRedesignEnabled ? undefined : searchPlaceholderText,
        onSearch: onSearchQueryChange,
        isCompact: isAllChatsPageRedesignEnabled
    }))), isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $05705f898282ed37$var$styles.accessibleSearchResults,
        role: "status",
        "aria-atomic": true
    }, searchResultsAnnouncement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAllChatsPageRedesignEnabled ? isSearchActive ? $05705f898282ed37$var$fsStyles.redesignSearchResultsContainer : $05705f898282ed37$var$fsStyles.redesignConversationsContainer : $05705f898282ed37$var$fsStyles.conversationsContainer,
        role: isAllChatsPageRedesignEnabled ? undefined : 'list'
    }, isAllChatsPageRedesignEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $05705f898282ed37$var$fsStyles.redesignConversationList,
        as: "ul"
    }, sortedConversations.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200",
        as: "li",
        xcss: $05705f898282ed37$var$styles.chatItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "center",
        color: "color.text.subtle"
    }, formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).noResults))), sortedConversations.map((conversation_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: conversation_0.id,
            as: "li",
            xcss: $05705f898282ed37$var$fsStyles.conversationRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
            conversation: conversation_0,
            onConversationSelect: onConversationSelect,
            onConversationPinToggle: gatedConversationPinToggle,
            isPinnedChatsEnabled: isPinnedChatsEnabled,
            isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
            cloudId: cloudId
        }))), !isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $05705f898282ed37$var$fsStyles.conversationRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
        as: "div",
        hasMoreConversations: hasMoreConversations,
        isLoadingMoreConversations: isLoadingMoreConversations,
        hasLoadMoreConversationsError: hasLoadMoreConversationsError,
        onLoadMoreConversations: onLoadMoreConversations,
        testIdPrefix: "chat-conversation-list-refresh"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, sortedConversations.map((conversation_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: conversation_1.id,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
            conversation: conversation_1,
            onConversationSelect: onConversationSelect,
            onConversationPinToggle: gatedConversationPinToggle,
            isPinnedChatsEnabled: isPinnedChatsEnabled,
            isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
            cloudId: cloudId
        }))), !isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
        as: "div",
        role: "listitem",
        hasMoreConversations: hasMoreConversations,
        isLoadingMoreConversations: isLoadingMoreConversations,
        hasLoadMoreConversationsError: hasLoadMoreConversationsError,
        onLoadMoreConversations: onLoadMoreConversations,
        testIdPrefix: "chat-conversation-list-refresh"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
        onEditConfirm: (name)=>onConversationEdit(conversation.id, name)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
        onDeleteConfirm: ()=>onConversationDelete(conversation.id)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $05705f898282ed37$var$styles.wrapper,
        testId: "ai-mate-conversation-list-view",
        alignBlock: "start"
    }, chatRefreshHeader && chatRefreshHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $05705f898282ed37$var$styles.searchBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        placeholderText: searchPlaceholderText,
        onSearch: onSearchQueryChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $05705f898282ed37$var$styles.recentChat
    }, isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $05705f898282ed37$var$styles.accessibleSearchResults,
        role: "status",
        "aria-atomic": true
    }, searchResultsAnnouncement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $05705f898282ed37$var$styles.conversationList,
        as: "ul"
    }, sortedConversations.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200",
        as: "li",
        xcss: $05705f898282ed37$var$styles.chatItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "center",
        color: "color.text.subtle"
    }, formatMessage((0, $afe9abe71a349ab1$export$2e2bcd8739ae039).noResults))), sortedConversations.length > 0 && sortedConversations.map((conversation_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: conversation_2.id,
            as: "li",
            xcss: $05705f898282ed37$var$styles.chatItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
            conversation: conversation_2,
            onConversationSelect: onConversationSelect,
            onConversationPinToggle: gatedConversationPinToggle,
            isPinnedChatsEnabled: isPinnedChatsEnabled,
            isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
            cloudId: cloudId
        }))), !isSearchActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf8fae34ea011d72$export$1799add816684dda), {
        as: "li",
        hasMoreConversations: hasMoreConversations,
        isLoadingMoreConversations: isLoadingMoreConversations,
        hasLoadMoreConversationsError: hasLoadMoreConversationsError,
        onLoadMoreConversations: onLoadMoreConversations,
        testIdPrefix: "chat-conversation-list-refresh"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b858d9959a74e7$export$ad3d70e3310e31db), {
        onEditConfirm: (name_0)=>onConversationEdit(conversation.id, name_0)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
        onDeleteConfirm: ()=>onConversationDelete(conversation.id)
    }));
};




















const $00aa88f02eb03eb9$var$message = (0, $kSwu1.defineMessages)({
    titleLabel: {
        id: "ai-mate.conversation-list-refresh.title.label",
        defaultMessage: "All chats"
    },
    searchInputPlaceholderLabel: {
        id: "ai-mate.conversation-list-refresh.search-input-placeholder.label",
        defaultMessage: "Search all chats..."
    }
});
var $00aa88f02eb03eb9$export$2e2bcd8739ae039 = $00aa88f02eb03eb9$var$message;


const $aa275117239ad784$export$c84be89e9a4c6ea7 = ({ chatRefreshHeader: chatRefreshHeader })=>{
    (0, $6cFsl.di)((0, $eKjv9.useGlobalConfig), (0, $n71o5.useChatStore), (0, $bGNkz.useUIStoreActions), (0, $bGNkz.useUIStoreSubscription), (0, $dSCNl.useUIConfig), (0, $8akfd.useStagingAreaActions), (0, $6YdPR.useAssistanceServiceParams), (0, $3jESw.useUnifiedTasksSSESubscription), (0, $9qJ1N.useActiveTasksForConversations), (0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'ConversationList'
    });
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { resetStagingArea: resetStagingArea } = (0, $8akfd.useStagingAreaActions)();
    const isPinnedChatsEnabled = (0, $iDrrr.fg)('rovo_chat_pinned_fe');
    const [{ conversations: conversationsStore, conversationPagination: conversationPagination }, { setSelectedConversation: setSelectedConversation, updateConversation: updateConversation, deleteConversation: deleteConversation, loadMoreConversationChannelsData: loadMoreConversationChannelsData, setConversationListMounted: setConversationListMounted }] = (0, $n71o5.useChatStore)();
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    /** Live task rows need SSE only while this list is mounted (not at assistant root). */ (0, $3jESw.useUnifiedTasksSSESubscription)({
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning -- enable_tasks is the umbrella gate for task updates.
        enabled: (0, $iDrrr.fg)('rovo_chat_enable_tasks'),
        assistanceServiceParams: assistanceServiceParams
    });
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatConversationHistory'
        });
    // Should only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setConversationListMounted(true);
        return ()=>{
            setConversationListMounted(false);
        };
    }, [
        setConversationListMounted
    ]);
    const visibleConvIds = (0, $cozmU.useMemo)(()=>Object.keys(conversationsStore), [
        conversationsStore
    ]);
    const [activeTasksByConvId] = (0, $9qJ1N.useActiveTasksForConversations)(visibleConvIds);
    const conversations = (0, $cozmU.useMemo)(()=>Object.values(conversationsStore).map((conversation)=>{
            const activeTask = activeTasksByConvId.get(conversation.id);
            return {
                ...conversation,
                currentTask: activeTask ? (0, $9qJ1N.unifiedTaskToApiSSE)(activeTask) : null,
                isEmpty: (0, $1IZrU.isEmptyConversation)(conversation.id)
            };
        }), [
        conversationsStore,
        activeTasksByConvId
    ]);
    const onNewChatClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) resetStagingArea();
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        setActiveMenu('none');
    }, [
        resetStagingArea,
        setActiveMenu,
        setSelectedConversation
    ]);
    const onConversationSelect = (0, $cozmU.useCallback)((conversationId)=>{
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) resetStagingArea();
        setSelectedConversation({
            conversationId: conversationId
        });
        setActiveMenu('none');
    }, [
        resetStagingArea,
        setActiveMenu,
        setSelectedConversation
    ]);
    const onConversationEdit = (0, $cozmU.useCallback)(async (conversationId, newName)=>{
        try {
            await updateConversation({
                conversationId: conversationId,
                data: {
                    name: newName.trim()
                }
            });
        } catch (error) {
            if (error instanceof (0, $8A2GO.ApiError) && (0, $bxkJA.isChannelNotFoundError)(error)) return {
                error: error.message
            };
            throw error;
        }
    }, [
        updateConversation
    ]);
    const onConversationDelete = (0, $cozmU.useCallback)(async (conversationId)=>{
        try {
            await deleteConversation({
                conversationId: conversationId
            });
        } catch (error) {
            if (error instanceof (0, $8A2GO.ApiError) && (0, $bxkJA.isChannelNotFoundError)(error)) return {
                error: error.message
            };
            throw error;
        }
    }, [
        deleteConversation
    ]);
    const onConversationPinToggle = (0, $cozmU.useCallback)(async (conversationId, isPinned)=>{
        await updateConversation({
            conversationId: conversationId,
            data: {
                isPinned: isPinned
            }
        });
    }, [
        updateConversation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05705f898282ed37$export$f061bcb5e2cbb129), {
        title: formatMessage((0, $00aa88f02eb03eb9$export$2e2bcd8739ae039).titleLabel),
        searchPlaceholderText: formatMessage((0, $00aa88f02eb03eb9$export$2e2bcd8739ae039).searchInputPlaceholderLabel),
        conversations: conversations,
        searchQuery: searchQuery,
        onNewChatClick: onNewChatClick,
        onSearchQueryChange: setSearchQuery,
        onConversationSelect: onConversationSelect,
        onConversationDelete: onConversationDelete,
        onConversationEdit: onConversationEdit,
        onConversationPinToggle: isPinnedChatsEnabled ? onConversationPinToggle : undefined,
        isSpinnerOverlayConversationIconEnabled: (0, $iDrrr.fg)('rovo_chat_chat_history_refresh'),
        isFullScreen: !!fullScreen,
        chatRefreshHeader: chatRefreshHeader,
        cloudId: siteId,
        hasMoreConversations: conversationPagination.hasMore,
        isLoadingMoreConversations: conversationPagination.isLoadingMore,
        hasLoadMoreConversationsError: Boolean(conversationPagination.loadMoreError),
        onLoadMoreConversations: loadMoreConversationChannelsData
    });
};


































const $afb09f564225627a$var$InformationModalLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bp6jG")));
const $afb09f564225627a$export$8f52bee981971c2c = ({ isOpen: isOpen, onClose: onClose, assistanceServiceParams: assistanceServiceParams, conversationId: conversationId, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afb09f564225627a$var$InformationModalLazy, {
        isOpen: isOpen,
        onClose: onClose,
        assistanceServiceParams: assistanceServiceParams,
        conversationId: conversationId,
        testId: testId
    }));
};













































/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */ const $2d992320553429c2$var$stringify = (obj)=>{
    try {
        return JSON.stringify(obj, null, 2);
    } catch (e) {
        return 'Error parsing JSON object';
    }
};
/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */ const $2d992320553429c2$var$createAdfDocument = (codeContent)=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'codeBlock',
                attrs: {
                    language: 'json'
                },
                content: [
                    {
                        type: 'text',
                        text: $2d992320553429c2$var$stringify(codeContent)
                    }
                ]
            }
        ]
    }); // TODO: Fix this casting
/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */ const $2d992320553429c2$var$HeadingTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { title: title } = t0;
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.400"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, title));
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, title));
/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */ const $2d992320553429c2$var$useDebugLogs = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { data: data, error: error, isFetching: isFetching, refetch: refetch } = (0, $5SS4O.useQuery)({
        queryKey: [
            'debugLogs',
            conversation?.id ?? ''
        ],
        queryFn: async ()=>{
            const response = await assistanceService.getConversationDebugLogs(conversation?.id ?? '');
            return response;
        },
        enabled: false
    });
    (0, $cozmU.useEffect)(()=>{
        if (conversation?.id !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) refetch();
    }, [
        conversation?.id,
        refetch
    ]);
    return {
        data: data,
        error: error,
        isFetching: isFetching
    };
});
const $2d992320553429c2$export$27b1af1f8df070ea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            touchpointSource: "debug-modal-contents"
        };
        $[0] = t0;
    } else t0 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t0);
    let t1;
    if ($[1] !== assistanceServiceParams) {
        t1 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[1] = assistanceServiceParams;
        $[2] = t1;
    } else t1 = $[2];
    const { data: messages, error: debugLogError, isFetching: isDebugFetching } = $2d992320553429c2$var$useDebugLogs(t1);
    let t2;
    if ($[3] !== debugLogError || $[4] !== isDebugFetching || $[5] !== messages) {
        t2 = ()=>{
            if (debugLogError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", null, "Failed to fetch chat list: "), debugLogError.message);
            if (isDebugFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
                document: $2d992320553429c2$var$createAdfDocument(messages ?? []),
                allowCopyToClipboard: true
            });
        };
        $[3] = debugLogError;
        $[4] = isDebugFetching;
        $[5] = messages;
        $[6] = t2;
    } else t2 = $[6];
    const renderDebugLogs = t2;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d992320553429c2$var$HeadingTitle, {
            title: "Chat List"
        });
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== renderDebugLogs) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t3, renderDebugLogs());
        $[8] = renderDebugLogs;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ()=>{
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'debug-modal-contents'
    });
    const { data: messages, error: debugLogError, isFetching: isDebugFetching } = $2d992320553429c2$var$useDebugLogs({
        assistanceServiceParams: assistanceServiceParams
    });
    const renderDebugLogs = ()=>{
        if (debugLogError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", null, "Failed to fetch chat list: "), debugLogError.message);
        if (isDebugFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: $2d992320553429c2$var$createAdfDocument(messages ?? []),
            allowCopyToClipboard: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d992320553429c2$var$HeadingTitle, {
        title: "Chat List"
    }), renderDebugLogs());
};


/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */ const $2596613472daa71a$var$DebugModalOld = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { isDebugModalOpen: isDebugModalOpen, closeDebugModal: closeDebugModal } = (0, $5f9e937904d8d9c3$export$cbb5096309445c3b)();
    let t0;
    if ($[0] !== closeDebugModal || $[1] !== isDebugModalOpen) {
        t0 = isDebugModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: closeDebugModal,
            width: "x-large"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", null, "Debug Information"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d992320553429c2$export$27b1af1f8df070ea), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: closeDebugModal
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", null, "Close"))));
        $[0] = closeDebugModal;
        $[1] = isDebugModalOpen;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t0);
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { isDebugModalOpen: isDebugModalOpen, closeDebugModal: closeDebugModal } = (0, $5f9e937904d8d9c3$export$cbb5096309445c3b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isDebugModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeDebugModal,
        width: "x-large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", null, "Debug Information"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d992320553429c2$export$27b1af1f8df070ea), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeDebugModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", null, "Close")))));
};
const $2596613472daa71a$var$DebugModalNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isDebugModalOpen: isDebugModalOpen, closeDebugModal: closeDebugModal } = (0, $5f9e937904d8d9c3$export$cbb5096309445c3b)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            touchpointSource: "debug-modal-contents"
        };
        $[0] = t0;
    } else t0 = $[0];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t0);
    const t1 = conversation?.id;
    let t2;
    if ($[1] !== assistanceServiceParams || $[2] !== closeDebugModal || $[3] !== isDebugModalOpen || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afb09f564225627a$export$8f52bee981971c2c), {
            isOpen: isDebugModalOpen,
            onClose: closeDebugModal,
            assistanceServiceParams: assistanceServiceParams,
            conversationId: t1
        });
        $[1] = assistanceServiceParams;
        $[2] = closeDebugModal;
        $[3] = isDebugModalOpen;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ()=>{
    const { isDebugModalOpen: isDebugModalOpen, closeDebugModal: closeDebugModal } = (0, $5f9e937904d8d9c3$export$cbb5096309445c3b)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'debug-modal-contents'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afb09f564225627a$export$8f52bee981971c2c), {
        isOpen: isDebugModalOpen,
        onClose: closeDebugModal,
        assistanceServiceParams: assistanceServiceParams,
        conversationId: conversation?.id
    });
};
const $2596613472daa71a$export$c7e04f1826d84216 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    if ((0, $iDrrr.fg)("graphyte_rovo_debug_enhancement")) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2596613472daa71a$var$DebugModalNew, null);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2596613472daa71a$var$DebugModalOld, null);
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    if ((0, $iDrrr.fg)('graphyte_rovo_debug_enhancement')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2596613472daa71a$var$DebugModalNew, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2596613472daa71a$var$DebugModalOld, null);
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $8Xvwd = parcelRequire("8Xvwd");



















var $2knbJ = parcelRequire("2knbJ");


var $gKxUw = parcelRequire("gKxUw");


var $kEjXh = parcelRequire("kEjXh");


var $aiNUD = parcelRequire("aiNUD");














/**
 * Maps answerQuality to Convo AI feedback value
 */ const $5d30100116c5dff7$export$23b8d25fad6c3f34 = (answerQuality)=>{
    return answerQuality === 'good' ? 'LIKE' : 'DISLIKE';
};



var $gg9X0 = parcelRequire("gg9X0");













// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));


const $61c021e59ae17a82$var$LazyFeedbackFlagComponent = (0, $cozmU.lazy)(()=>(0, $e837e744ff2037be$export$1eafe3a5df99a0a0)().then((module)=>({
            default: module.FeedbackFlagComponent
        })));
const $61c021e59ae17a82$var$LoadableFeedbackFlagComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QnYxv",
    name: "LoadableFeedbackFlagComponent",
    loader: ()=>(0, $e837e744ff2037be$export$1eafe3a5df99a0a0)().then(({ FeedbackFlagComponent: FeedbackFlagComponent })=>FeedbackFlagComponent),
    loading: ()=>null
});
const $61c021e59ae17a82$export$dd8b5c212404f45a = (props)=>{
    if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: 'rovo-conversation-assistant-feedback-flag',
        children: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61c021e59ae17a82$var$LazyFeedbackFlagComponent, props)
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61c021e59ae17a82$var$LoadableFeedbackFlagComponent, props);
};





const $66fafccc16ba5c87$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    consentMessageHistoryCheckboxLabel: {
        id: "ai-mate.feedback-collector.consent-message-history-checkbox-label",
        defaultMessage: "Share this and 5 previous messages to Rovo in your feedback. We'll remove any sensitive data."
    },
    feedbackTextAreaLabel: {
        id: "ai-mate.feedback-collector.share-thoughts-label",
        defaultMessage: "Summary"
    },
    feedbackTextAreaPlaceholder: {
        id: "ai-mate.feedback-collector.share-thoughts-placeholder",
        defaultMessage: "Let us know what's on your mind"
    }
});



const $bd7f1c1de1bb802e$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("hUVfy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $bd7f1c1de1bb802e$export$fa63c8dd87ea8148 = ()=>{
    (0, $6cFsl.di)((0, $418a0a565f43a3ce$export$4be696be8a3bff13));
    const initialCanAttachMessages = (0, $iDrrr.fg)('rovo_can_attach_user_messages_enabled');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { profileData: { name: name, aaid: aaid, email: email }, feedbackCollector: { entryPointId: entryPointId, displaySubmitFlag: displaySubmitFlag }, productKey: productKey, productHeader: productHeader, experienceId: experienceId, assistanceServiceConfig: assistanceServiceConfig, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const [description, setDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState('');
    const [displayFlag, setDisplayFlag] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [canAttachMessages, setCanAttachMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(initialCanAttachMessages);
    const { elements: elements } = (0, $dSCNl.useUIConfig)();
    const isInStagingArea = !!elements?.stagingAreaEnabled;
    const [{ isOpen: isOpen, feedbackData: { answerQuality: answerQuality, assistantResponseId: assistantResponseId, messageRequestId: messageRequestId, feedbackSource: feedbackSource } }, { close: close }] = (0, $418a0a565f43a3ce$export$4be696be8a3bff13)();
    const isGoodFeedback = answerQuality === 'good';
    const setFeedbackSent = (0, $2knbJ.useSetMessageFeedbackSent)();
    const retrievedHistory = (0, $4JJQd.useMessageHistory)({
        canAttachMessages: canAttachMessages,
        answerId: assistantResponseId
    });
    // pass only selected agent id when in private mode,
    // this is needed for sales360 team to filter feedback issues given an agentId
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const conversationId = conversation?.id;
    const selectedAgentId = selectedAgent?.id;
    const selectedAgentExternalConfigReference = selectedAgent?.external_config_reference;
    const selectedAgentMeta = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            author_id: selectedAgentId,
            agent_external_config_reference: selectedAgentExternalConfigReference
        }), [
        selectedAgentId,
        selectedAgentExternalConfigReference
    ]);
    const history = canAttachMessages ? retrievedHistory : 'private';
    const sendMetadata = {
        aaid: aaid,
        answerQuality: answerQuality,
        assistantResponseId: assistantResponseId,
        request_id: messageRequestId || 'not-found',
        origin: (0, $aiNUD.getCurrentOrigin)(),
        history: history,
        feedbackSource: feedbackSource ?? (0, $iDrrr.fg)('aifc_create_enabled') ? `${productKey}-v1${elements?.stagingAreaEnabled ? '-staging' : ''}` : undefined,
        selected_agent: selectedAgentMeta,
        minionAlias: assistanceServiceConfig?.minionAlias
    };
    const resetForm = ()=>{
        setDescription('');
        setCanAttachMessages(initialCanAttachMessages);
    };
    const onSubmit = ()=>{
        sendAnalyticsEvent({
            action: 'submit',
            actionSubject: 'button',
            actionSubjectId: 'feedbackCollectorSubmitButton',
            eventType: 'ui',
            attributes: {
                canAttachMessages: canAttachMessages
            }
        });
        setDisplayFlag(true);
        if (assistantResponseId) {
            setFeedbackSent(assistantResponseId); // Send feedback to Convo AI
            if (conversationId && !(0, $iDrrr.fg)('service_agent_send_feedback_to_convo_ai_on_thumb')) (0, $gg9X0.sendConvoAIFeedback)({
                conversationId: conversationId,
                messageId: assistantResponseId,
                feedbackValue: (0, $5d30100116c5dff7$export$23b8d25fad6c3f34)(answerQuality),
                productHeader: productHeader,
                experienceId: experienceId,
                channelId: assistanceServiceConfig?.channelId ?? 'rovo-chat',
                cloudId: siteId
            }).catch(()=>{});
        }
    };
    const onClose = ()=>{
        sendAnalyticsEvent({
            action: 'close',
            actionSubject: 'button',
            actionSubjectId: 'feedbackCollectorCloseButton',
            eventType: 'ui'
        }); // This is needed due to a bug in the component
        // Error: Can't perform a React state update on an unmounted component.
        // https://bitbucket.org/atlassian/atlassian-frontend/src/14852d9dc3bac13a97ff29899516a6af6f6e91e1/packages/web-platform/feedback-collector/src/components/FeedbackCollector.tsx#lines-448:460
        setTimeout(()=>{
            close();
            resetForm();
        }, 0);
    };
    const historyCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Xvwd.CheckboxField), {
        name: "conversation-assistant-feedback-attach-messages",
        defaultIsChecked: canAttachMessages
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            label: formatMessage((0, $66fafccc16ba5c87$export$defe85febe8b728c).consentMessageHistoryCheckboxLabel),
            onChange: (event)=>setCanAttachMessages(event.target.checked)
        }));
    const feedbackTextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "feedback-summary",
        label: formatMessage((0, $66fafccc16ba5c87$export$defe85febe8b728c).feedbackTextAreaLabel),
        isRequired: !isGoodFeedback,
        defaultValue: ""
    }, ({ fieldProps: fieldProps_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps_0,
            name: "feedback-collector-description",
            minimumRows: 6,
            placeholder: formatMessage((0, $66fafccc16ba5c87$export$defe85febe8b728c).feedbackTextAreaPlaceholder),
            onChange: (e)=>setDescription(e.target.value),
            value: description
        }));
    const getDescriptionWithMetadata = ()=>`
      ${description}

      \`\`\`
      ${JSON.stringify(sendMetadata, null, 2)}
      \`\`\`
    `;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isOpen && isInStagingArea && (0, $ieeJu.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gKxUw.SmartCreateFeedback), {
        variant: (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO,
        onClose: onClose,
        onSubmit: onSubmit,
        tenantId: siteId,
        showDefaultTextFields: false,
        summaryDefaultValue: description,
        descriptionDefaultValue: getDescriptionWithMetadata(),
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, feedbackTextArea, historyCheckbox)
    }), isOpen && (!isInStagingArea || !(0, $ieeJu.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-feedback-collector-suspense",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd7f1c1de1bb802e$var$AkFeedbackCollector, {
        entrypointId: entryPointId,
        onClose: onClose,
        onSubmit: onSubmit,
        atlassianAccountId: aaid,
        name: name,
        email: email,
        showTypeField: false,
        descriptionDefaultValue: getDescriptionWithMetadata(),
        summaryDefaultValue: description,
        showDefaultTextFields: false,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, feedbackTextArea, historyCheckbox)
    })), displaySubmitFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61c021e59ae17a82$export$dd8b5c212404f45a), {
        displayFlag: displayFlag,
        setDisplayFlag: setDisplayFlag
    }));
};
























































const $113655db773a21a2$var$message = (0, $kSwu1.defineMessages)({
    footerMessage: {
        id: "ai-mate.footer.footer-message",
        defaultMessage: "Uses AI. Verify results."
    },
    recordingDisclaimerMessage: {
        id: "ai-mate.footer.recording-disclaimer-message",
        defaultMessage: "Conversations in this agent are visible to people that manage this agent."
    },
    recordingDisclaimerTooltip: {
        id: "ai-mate.footer.recording-disclaimer-tooltip",
        defaultMessage: "The people who manage this agent can see your conversation. Inactive conversations are deleted from storage 30 days after the most recent message."
    },
    recordingDisclaimerIconLabel: {
        id: "ai-mate.footer.recording-disclaimer-icon-label",
        defaultMessage: "Conversation review information"
    },
    rovoBrandingLabel: {
        id: "ai-mate.footer.rovo-branding-label",
        defaultMessage: "{logo} Rovo"
    },
    rovoBrandingLabelUpdated: {
        id: "ai-mate.footer.rovo-branding-label-updated",
        defaultMessage: "Rovo {logo}"
    },
    rovoBetaLabel: {
        id: "ai-mate.footer.rovo-beta-label",
        defaultMessage: "Beta"
    }
});
var $113655db773a21a2$export$2e2bcd8739ae039 = $113655db773a21a2$var$message;


/**
 * @generated SignedSource<<0133b5641280f07cb4c49bc2957efc8f>>
 * @relayHash ff1f87da40139e7cb97568284d738116
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18ec07f0382b9640ed7eece3e79d5a9fac2ebaced1e0e3e67ff91104dd4fe371
const $6ada8b7740bc6f82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldFetch"
        }
    ], v1 = [
        {
            "condition": "shouldFetch",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "containerId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "agentStudio_conversationConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isEnabled"
                                }
                            ],
                            "type": "AgentStudioConversationConfig"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RecordingDisclaimer_conversationConfigurationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RecordingDisclaimer_conversationConfigurationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "18ec07f0382b9640ed7eece3e79d5a9fac2ebaced1e0e3e67ff91104dd4fe371",
            "metadata": {},
            "name": "RecordingDisclaimer_conversationConfigurationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6ada8b7740bc6f82$var$node.hash = "010d57bf97f55b15bec1a8d69c471703";
var $6ada8b7740bc6f82$export$2e2bcd8739ae039 = $6ada8b7740bc6f82$var$node;
























var $h6BA0 = parcelRequire("h6BA0");

















const $8b5ffd207c880130$var$INTERACTION_NAME = 'rovo-conversation-assistant-footer-recording-disclaimer';
const $8b5ffd207c880130$var$RecordingDisclaimerContent = ()=>{
    (0, $6cFsl.di)((0, $eKjv9.useGlobalConfig), (0, $bwd6H.useResolveAgentAri));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)();
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)({
        agentId: selectedAgent?.id ?? '',
        existingAgentAri: selectedAgent?.agentAri,
        cloudId: siteId
    });
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $6ada8b7740bc6f82$export$2e2bcd8739ae039), {
        cloudId: siteId,
        containerId: agentAri ?? '',
        shouldFetch: Boolean(selectedAgent?.id && agentAri)
    });
    const config = data.agentStudio_conversationConfiguration;
    if (config?.__typename === 'QueryError') throw new Error(`RecordingDisclaimer_conversationConfigurationQuery returns QueryError: ${config.message}`);
    const isEnabled = config?.__typename === 'AgentStudioConversationConfig' ? Boolean(config.isEnabled) : false;
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        align: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).recordingDisclaimerTooltip),
        position: "left",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
        color: "currentColor",
        label: formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).recordingDisclaimerIconLabel),
        size: "small"
    })), ' ', formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).recordingDisclaimerMessage));
};
const $8b5ffd207c880130$export$ad39127376eb73be = ()=>{
    (0, $6cFsl.di)((0, $h6BA0.useUFOReportError));
    const reportError = (0, $h6BA0.useUFOReportError)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: $8b5ffd207c880130$var$INTERACTION_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null,
        onError: (error)=>{
            reportError({
                name: $8b5ffd207c880130$var$INTERACTION_NAME,
                errorMessage: error.message,
                errorStack: error.stack
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8b5ffd207c880130$var$RecordingDisclaimerContent, null)));
};


const $e00f1e475114aa33$var$styles = {
    root: "_2sNsIg7NXe _2Y7lL45zaO _4c065U2ADO _1UtDYzKGUX",
    flexContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d",
    leftMargin: "_2XsHFMkG2W",
    autoMargins: "_2XsHFMIZbP _0adFHskG2W"
};
const $e00f1e475114aa33$var$stylesCompiled = {
    fsCentered: "_2YLqiKIZbP _4ouGXIflcy",
    fsBottom: "_1mT5xdHE3j _0Bm75GdnbC",
    fsTopPad: "_0Of8r2kG2W"
};

const $e00f1e475114aa33$var$LocalComponents = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "NWo4I",
    name: "LocalComponents",
    loader: ()=>(parcelRequire("af8pL")).then((module)=>module.LocalFrontendComponents),
    loading: ()=>null
});

const $e00f1e475114aa33$var$LazyLocalComponents = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("af8pL")).then((module)=>{
        return {
            default: module.LocalFrontendComponents
        };
    }));
function $e00f1e475114aa33$var$getFinalLocalComponents() {
    if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: 'rovo-conversation-assistant-footer-local-components',
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e00f1e475114aa33$var$LazyLocalComponents)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e00f1e475114aa33$var$LocalComponents);
}
const $e00f1e475114aa33$export$d3ae2425e57e22bb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { isRefreshVersion: t1 } = t0;
    const isRefreshVersion = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fullScreen: fullScreen, isBitbucketBetaEnabled: isBitbucketBetaEnabled } = (0, $dSCNl.useUIConfig)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $iDrrr.fg)("rovo_chat_beta_tag");
        $[0] = t2;
    } else t2 = $[0];
    const isAdminHubBetaTagEnabled = t2;
    const shouldShowBetaLozenge = isBitbucketBetaEnabled || isAdminHubBetaTagEnabled;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("rovo_chat_show_new_lozenge");
        $[1] = t3;
    } else t3 = $[1];
    const showNewLozenge = t3;
    let t4;
    if ($[2] !== sendAnalyticsEvent) {
        t4 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "contentQualityLink"
            });
        };
        $[2] = sendAnalyticsEvent;
        $[3] = t4;
    } else t4 = $[3];
    const handleContentQualityClick = t4;
    const isRefreshButNotFullScreen = isRefreshVersion && !fullScreen;
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    const t5 = fullScreen && stagingAreaMode !== "inline" && $e00f1e475114aa33$var$stylesCompiled.fsCentered;
    const t6 = fullScreen && $e00f1e475114aa33$var$stylesCompiled.fsBottom;
    const t7 = fullScreen && $e00f1e475114aa33$var$stylesCompiled.fsTopPad;
    let t8;
    if ($[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
        t8 = (0, $hekY6.default)([
            $e00f1e475114aa33$var$styles.root,
            t5,
            t6,
            t7
        ]);
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    const t9 = isRefreshButNotFullScreen ? undefined : fullScreen ? undefined : "space-between";
    const t10 = fullScreen ? "center" : isRefreshButNotFullScreen ? "center" : undefined;
    let t11;
    if ($[8] !== formatMessage || $[9] !== handleContentQualityClick || $[10] !== shouldShowBetaLozenge) {
        t11 = showNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "div",
            xcss: $e00f1e475114aa33$var$styles.flexContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e00f1e475114aa33$var$styles.leftMargin
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            color: "currentColor",
            label: "",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            appearance: "subtle",
            href: "https://www.atlassian.com/trust/atlassian-intelligence",
            onClick: handleContentQualityClick,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).footerMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b5ffd207c880130$export$ad39127376eb73be), null)))), shouldShowBetaLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e00f1e475114aa33$var$styles.autoMargins
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).rovoBetaLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, shouldShowBetaLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).rovoBetaLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            color: "currentColor",
            label: "",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            appearance: "subtle",
            href: "https://www.atlassian.com/trust/atlassian-intelligence",
            onClick: handleContentQualityClick,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).footerMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b5ffd207c880130$export$ad39127376eb73be), null)));
        $[8] = formatMessage;
        $[9] = handleContentQualityClick;
        $[10] = shouldShowBetaLozenge;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $iDrrr.fg)("rovo_chat_show_local_frontend_components") && $e00f1e475114aa33$var$getFinalLocalComponents();
        $[12] = t12;
    } else t12 = $[12];
    let t13;
    if ($[13] !== t10 || $[14] !== t11 || $[15] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: t9,
            alignBlock: "center",
            alignInline: t10
        }, t11, t12);
        $[13] = t10;
        $[14] = t11;
        $[15] = t9;
        $[16] = t13;
    } else t13 = $[16];
    let t14;
    if ($[17] !== t13 || $[18] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, t13);
        $[17] = t13;
        $[18] = t8;
        $[19] = t14;
    } else t14 = $[19];
    return t14;
} : ({ isRefreshVersion: isRefreshVersion = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fullScreen: fullScreen, isBitbucketBetaEnabled: isBitbucketBetaEnabled } = (0, $dSCNl.useUIConfig)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const isAdminHubBetaTagEnabled = (0, $iDrrr.fg)('rovo_chat_beta_tag');
    const shouldShowBetaLozenge = isBitbucketBetaEnabled || isAdminHubBetaTagEnabled;
    const showNewLozenge = (0, $iDrrr.fg)('rovo_chat_show_new_lozenge');
    const handleContentQualityClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'contentQualityLink'
        });
    }, [
        sendAnalyticsEvent
    ]);
    const isRefreshButNotFullScreen = isRefreshVersion && !fullScreen;
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $e00f1e475114aa33$var$styles.root,
            fullScreen && stagingAreaMode !== 'inline' && $e00f1e475114aa33$var$stylesCompiled.fsCentered,
            fullScreen && $e00f1e475114aa33$var$stylesCompiled.fsBottom,
            fullScreen && $e00f1e475114aa33$var$stylesCompiled.fsTopPad
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: isRefreshButNotFullScreen ? undefined : fullScreen ? undefined : 'space-between',
        alignBlock: 'center',
        alignInline: fullScreen ? 'center' : isRefreshButNotFullScreen ? 'center' : undefined
    }, showNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "div",
        xcss: $e00f1e475114aa33$var$styles.flexContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e00f1e475114aa33$var$styles.leftMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        onClick: handleContentQualityClick,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).footerMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b5ffd207c880130$export$ad39127376eb73be), null)))), shouldShowBetaLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e00f1e475114aa33$var$styles.autoMargins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).rovoBetaLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, shouldShowBetaLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).rovoBetaLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        onClick: handleContentQualityClick,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $113655db773a21a2$export$2e2bcd8739ae039).footerMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b5ffd207c880130$export$ad39127376eb73be), null))), (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components') && $e00f1e475114aa33$var$getFinalLocalComponents()));
};





















var $5WvJi = parcelRequire("5WvJi");









var $7o2Oy = parcelRequire("7o2Oy");

const $d7e1a96faeace911$var$messages = (0, $kSwu1.defineMessages)({
    defaultModalTitle: {
        id: "ai-mate.conversation-assistant.full-screen-modal.default-modal-title-non-final",
        defaultMessage: "Rovo chat"
    }
});
const $d7e1a96faeace911$var$styles = {
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLFlnN _4kiQYAdnbC _4ouGXIdnbC _0jFU0VN91d _39xV02N91d"
};
const $d7e1a96faeace911$export$f79759b47a91f0e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isOpen: isOpen, onOpenChange: onOpenChange, modalContent: modalContent, chatHeaderProps: chatHeaderProps, title: title, headerContent: headerContent, onClose: onClose, shouldReturnFocus: t1 } = t0;
    const shouldReturnFocus = t1 === undefined ? true : t1;
    (0, $6cFsl.di)((0, $0e37dd0446a514a8$export$2633258f29aae55e));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== onClose || $[1] !== onOpenChange) {
        t2 = ()=>{
            onOpenChange(false);
            onClose?.();
        };
        $[0] = onClose;
        $[1] = onOpenChange;
        $[2] = t2;
    } else t2 = $[2];
    const handleClose = t2;
    let t3;
    if ($[3] !== formatMessage || $[4] !== title) {
        t3 = title ?? formatMessage($d7e1a96faeace911$var$messages.defaultModalTitle);
        $[3] = formatMessage;
        $[4] = title;
        $[5] = t3;
    } else t3 = $[5];
    const resolvedTitle = t3;
    const shouldUseChatHeader = Boolean(chatHeaderProps);
    const resolvedChatHeaderProps = chatHeaderProps;
    const hasCloseButton = !shouldUseChatHeader && !headerContent;
    let t4;
    if ($[6] !== handleClose || $[7] !== hasCloseButton || $[8] !== headerContent || $[9] !== isOpen || $[10] !== modalContent || $[11] !== resolvedChatHeaderProps || $[12] !== resolvedTitle || $[13] !== shouldReturnFocus) {
        t4 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $5WvJi.FullScreenModalDialog), {
            onClose: handleClose,
            shouldReturnFocus: shouldReturnFocus,
            testId: "conversation-assistant-full-screen-modal-dialog"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
            hasCloseButton: hasCloseButton
        }, resolvedChatHeaderProps ? /*#__PURE__*/ $cozmU.createElement((0, $0e37dd0446a514a8$export$2633258f29aae55e), resolvedChatHeaderProps) : headerContent ?? /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, resolvedTitle)), /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "conversation-assistant-full-screen-modal-body",
            className: (0, $hekY6.default)([
                $d7e1a96faeace911$var$styles.body
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), null, modalContent)));
        $[6] = handleClose;
        $[7] = hasCloseButton;
        $[8] = headerContent;
        $[9] = isOpen;
        $[10] = modalContent;
        $[11] = resolvedChatHeaderProps;
        $[12] = resolvedTitle;
        $[13] = shouldReturnFocus;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t4);
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ isOpen: isOpen, onOpenChange: onOpenChange, modalContent: modalContent, chatHeaderProps: chatHeaderProps, title: title, headerContent: headerContent, onClose: onClose, shouldReturnFocus: shouldReturnFocus = true })=>{
    (0, $6cFsl.di)((0, $0e37dd0446a514a8$export$2633258f29aae55e));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClose = (0, $cozmU.useCallback)(()=>{
        onOpenChange(false);
        onClose?.();
    }, [
        onOpenChange,
        onClose
    ]);
    const resolvedTitle = title ?? formatMessage($d7e1a96faeace911$var$messages.defaultModalTitle);
    const shouldUseChatHeader = Boolean(chatHeaderProps);
    const resolvedChatHeaderProps = chatHeaderProps;
    const hasCloseButton = !shouldUseChatHeader && !headerContent;
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $5WvJi.FullScreenModalDialog), {
        onClose: handleClose,
        shouldReturnFocus: shouldReturnFocus,
        testId: "conversation-assistant-full-screen-modal-dialog"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: hasCloseButton
    }, resolvedChatHeaderProps ? /*#__PURE__*/ $cozmU.createElement((0, $0e37dd0446a514a8$export$2633258f29aae55e), resolvedChatHeaderProps) : headerContent ?? /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, resolvedTitle)), /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "conversation-assistant-full-screen-modal-body",
        className: (0, $hekY6.default)([
            $d7e1a96faeace911$var$styles.body
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), null, modalContent))));
};



var $fBd2O = parcelRequire("fBd2O");































/**
 * Renders ChatMainHeaderRefresh with tab-aware onResetEmptyStateTab.
 * Must be rendered inside ActiveTabProvider.
 */ const $043d7c8a3f5ba806$var$ActiveTabAwareChatHeaderComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    (0, $6cFsl.di)((0, $0e37dd0446a514a8$export$2633258f29aae55e), (0, $iDrrr.fg));
    const { resetToPreviousTab: resetToPreviousTab } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const { clearSelectedSpace: clearSelectedSpace, clearEmptyChatLaunchAll: clearEmptyChatLaunchAll } = (0, $bGNkz.useUIStoreActions)();
    let t0;
    if ($[0] !== clearEmptyChatLaunchAll || $[1] !== clearSelectedSpace || $[2] !== resetToPreviousTab || $[3] !== setAIFeatureContext) {
        t0 = ()=>{
            resetToPreviousTab();
            setAIFeatureContext({
                contextKey: "projectContext",
                setContext: $043d7c8a3f5ba806$var$_temp
            });
            clearSelectedSpace();
            clearEmptyChatLaunchAll();
        };
        $[0] = clearEmptyChatLaunchAll;
        $[1] = clearSelectedSpace;
        $[2] = resetToPreviousTab;
        $[3] = setAIFeatureContext;
        $[4] = t0;
    } else t0 = $[4];
    const handleResetEmptyStateTab = t0;
    let t1;
    if ($[5] !== handleResetEmptyStateTab) {
        t1 = (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)() ? handleResetEmptyStateTab : undefined;
        $[5] = handleResetEmptyStateTab;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== props || $[8] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e37dd0446a514a8$export$2633258f29aae55e), {
            ...props,
            onResetEmptyStateTab: t1
        });
        $[7] = props;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (props)=>{
    (0, $6cFsl.di)((0, $0e37dd0446a514a8$export$2633258f29aae55e), (0, $iDrrr.fg));
    const { resetToPreviousTab: resetToPreviousTab } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const { clearSelectedSpace: clearSelectedSpace, clearEmptyChatLaunchAll: clearEmptyChatLaunchAll } = (0, $bGNkz.useUIStoreActions)();
    const handleResetEmptyStateTab = (0, $cozmU.useCallback)(()=>{
        // Return to the tab the user launched from. `previousTabId` is captured at launch
        // time from the live `activeTabId` (in `handleChatEmptyLaunch` / `handleSelectSpace`),
        // so this restores the correct origin without hardcoding a tab.
        resetToPreviousTab();
        // Clear project context so the banner resets to default URL-based behavior
        setAIFeatureContext({
            contextKey: 'projectContext',
            setContext: (_)=>({})
        });
        // Clear the SpaceBar and empty launch state so they don't persist after navigating back
        clearSelectedSpace();
        clearEmptyChatLaunchAll();
    }, [
        resetToPreviousTab,
        setAIFeatureContext,
        clearSelectedSpace,
        clearEmptyChatLaunchAll
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e37dd0446a514a8$export$2633258f29aae55e), {
        ...props,
        onResetEmptyStateTab: // Shell-level gate: this handler performs the chat/context teardown when leaving
        // the For You tab (clears project context, selected space and empty-chat launch
        // state). It must be wired whenever the tab can render — otherwise a pins-only
        // user navigates away with stale chat context.
        (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)() ? handleResetEmptyStateTab : undefined
    });
};
// Experiment-only: absorb parent render waves when header props are stable.
const $043d7c8a3f5ba806$var$MemoizedActiveTabAwareChatHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($043d7c8a3f5ba806$var$ActiveTabAwareChatHeaderComponent, (0, $dqxOF.shallowEqualObjects));
const $043d7c8a3f5ba806$export$5e92f7adeab8be8b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($043d7c8a3f5ba806$var$MemoizedActiveTabAwareChatHeader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($043d7c8a3f5ba806$var$ActiveTabAwareChatHeaderComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($043d7c8a3f5ba806$var$MemoizedActiveTabAwareChatHeader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($043d7c8a3f5ba806$var$ActiveTabAwareChatHeaderComponent, props);
};
function $043d7c8a3f5ba806$var$_temp(_) {
    return {};
}































/**
 * Renders ChatHistory with tab state from ActiveTabProvider.
 * Must be rendered inside ActiveTabProvider.
 */ const $fe56c1cce3607138$var$ActiveTabAwareChatHistoryComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    (0, $6cFsl.di)((0, $a4401f94f223733d$export$23974c6ecceedade));
    const { activeTabId: activeTabId, handleActiveTabChange: handleActiveTabChange } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                activeMenu: "conversation-history"
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== activeTabId || $[3] !== handleActiveTabChange || $[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "chat-history"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: t1,
            interactionName: "active-tab-aware-chat-history"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4401f94f223733d$export$23974c6ecceedade), {
            ...props,
            onActiveTabChange: handleActiveTabChange,
            activeTabId: activeTabId
        }))));
        $[2] = activeTabId;
        $[3] = handleActiveTabChange;
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (props)=>{
    (0, $6cFsl.di)((0, $a4401f94f223733d$export$23974c6ecceedade));
    const { activeTabId: activeTabId, handleActiveTabChange: handleActiveTabChange } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: 'chat-history'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            activeMenu: 'conversation-history'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        interactionName: "active-tab-aware-chat-history"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4401f94f223733d$export$23974c6ecceedade), {
        ...props,
        onActiveTabChange: handleActiveTabChange,
        activeTabId: activeTabId
    }))));
};
// Experiment-only: absorb parent render waves when history props are stable.
const $fe56c1cce3607138$var$MemoizedActiveTabAwareChatHistory = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($fe56c1cce3607138$var$ActiveTabAwareChatHistoryComponent, (0, $dqxOF.shallowEqualObjects));
const $fe56c1cce3607138$export$314152ebdd7f8aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe56c1cce3607138$var$MemoizedActiveTabAwareChatHistory, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe56c1cce3607138$var$ActiveTabAwareChatHistoryComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe56c1cce3607138$var$MemoizedActiveTabAwareChatHistory, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe56c1cce3607138$var$ActiveTabAwareChatHistoryComponent, props);
};


























const $0a08719d23b3b060$export$893f67fd2a4ac2b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    const { activeTabId: activeTabId } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    const { currentView: currentView } = (0, $a2dc017075ecc27d$export$30ffc6f2dc2c1cf5)();
    const [t1] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const { isEmptyChatLaunchActive: isEmptyChatLaunchActive } = t1;
    const shouldHide = !isEmptyChatLaunchActive && activeTabId === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3) && currentView.type === "threads-list";
    if (shouldHide) return null;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ children: children })=>{
    const { activeTabId: activeTabId } = (0, $4f4ec7923c508b72$export$558d819e93cfc429)();
    const { currentView: currentView } = (0, $a2dc017075ecc27d$export$30ffc6f2dc2c1cf5)();
    const [{ isEmptyChatLaunchActive: isEmptyChatLaunchActive }] = (0, $bGNkz.useEmptyChatLaunchSelector)();
    const shouldHide = !isEmptyChatLaunchActive && activeTabId === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3) && currentView.type === 'threads-list';
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};


const $83eda829c7fe234d$export$eba27d0a7754d4d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { hasTabsView: hasTabsView, children: children } = t0;
    if (!hasTabsView) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a08719d23b3b060$export$893f67fd2a4ac2b8), null, children);
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ hasTabsView: hasTabsView, children: children })=>{
    if (!hasTabsView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a08719d23b3b060$export$893f67fd2a4ac2b8), null, children);
};















var $bC9Xc = parcelRequire("bC9Xc");











var $jI4Q0 = parcelRequire("jI4Q0");


var $hKlzx = parcelRequire("hKlzx");












































const $2a9ea0184d76290b$export$afbf2ed5ba866956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    let t0;
    if ($[0] !== fireAnalyticsEvent) {
        t0 = (insightCategory)=>{
            fireAnalyticsEvent({
                eventType: "ui",
                actionSubject: "insightCard",
                action: "clicked",
                attributes: {
                    insightCategory: insightCategory
                }
            });
        };
        $[0] = fireAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireInsightCardClicked = t0;
    let t1;
    if ($[2] !== fireInsightCardClicked) {
        t1 = {
            fireInsightCardClicked: fireInsightCardClicked
        };
        $[2] = fireInsightCardClicked;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b4766f9d5329f065$export$eed8c476984ddfad)();
    const fireInsightCardClicked = (0, $cozmU.useCallback)((insightCategory)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'insightCard',
            action: 'clicked',
            attributes: {
                insightCategory: insightCategory
            }
        });
    }, [
        fireAnalyticsEvent
    ]);
    return {
        fireInsightCardClicked: fireInsightCardClicked
    };
};




var $2c3E0 = parcelRequire("2c3E0");
















const $a2960463e8b854f6$export$6cfd2a7f6d757a99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let restProps;
    let touchpointSource;
    if ($[0] !== props) {
        ({ touchpointSource: touchpointSource, ...restProps } = props);
        $[0] = props;
        $[1] = restProps;
        $[2] = touchpointSource;
    } else {
        restProps = $[1];
        touchpointSource = $[2];
    }
    let t0;
    if ($[3] !== touchpointSource) {
        t0 = {
            touchpointSource: touchpointSource
        };
        $[3] = touchpointSource;
        $[4] = t0;
    } else t0 = $[4];
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)(t0);
    let t1;
    if ($[5] !== assistanceServiceParams || $[6] !== restProps) {
        t1 = {
            ...restProps,
            assistanceServiceParams: assistanceServiceParams
        };
        $[5] = assistanceServiceParams;
        $[6] = restProps;
        $[7] = t1;
    } else t1 = $[7];
    return (0, $3z1p5.usePaginatedAgentByConfigReference)(t1);
} : (props)=>{
    const { touchpointSource: touchpointSource, ...restProps } = props;
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: touchpointSource
    });
    return (0, $3z1p5.usePaginatedAgentByConfigReference)({
        ...restProps,
        assistanceServiceParams: assistanceServiceParams
    });
};






const $2ae2e230d1d63d50$export$dd192c4c90e15f6f = (0, $kBr4q.createActionsHook)((0, $3084e29142635054$export$6f57813fe9f31bf9));



var $5odSY = parcelRequire("5odSY");
















































const $dce0d3b749c3811d$var$messages = (0, $kSwu1.defineMessages)({
    forgeAuthFailureMessage: {
        id: "ai-mate.pubsub-listener.forge-auth-faiure-message",
        defaultMessage: "Confirmation failed, try again in a moment."
    },
    forgeAuthMessageCompleted: {
        id: "ai-mate.pubsub-listener.forge-auth-completed-message",
        defaultMessage: "Authentication was successfully completed for the request in message {agentMessageId}. Please continue with the action from that message."
    },
    forgeAuthCompletedMessageWithUnknownSource: {
        id: "ai-mate.pubsub-listener.forge-auth-completed-message-with-unknown-source",
        defaultMessage: "Authenticated. You\u2019ve logged in, but we couldn\u2019t identify where the request came from. Continue with your action."
    },
    forgeAuthLinkLabel: {
        id: "ai-mate.pubsub-listener.forge-auth-link-label",
        defaultMessage: "auth link"
    }
});
/**
 * Builds an ADF document containing a text message with an optional hyperlink.
 * When an authUrl is provided, the link label is appended as a separate inline text node
 * with a link mark so the raw URL is not directly visible.
 */ const $dce0d3b749c3811d$var$buildAuthNotificationAdf = (text, linkLabel, authUrl)=>{
    const contentNodes = [
        {
            type: 'text',
            text: text
        }
    ];
    if (authUrl && linkLabel) contentNodes.push({
        type: 'text',
        text: ` ${linkLabel}`,
        marks: [
            {
                type: 'link',
                attrs: {
                    href: authUrl
                }
            }
        ]
    });
    return {
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: contentNodes
            }
        ]
    };
};
const $dce0d3b749c3811d$export$a8f9e4b54dd45faa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(20);
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)();
    const conversationId = conversation?.id ?? (0, $4m5jb.EMPTY_CONVERSATION_ID);
    let t0;
    if ($[0] !== conversationId) {
        t0 = {
            conversationId: conversationId
        };
        $[0] = conversationId;
        $[1] = t0;
    } else t0 = $[1];
    const [chatMessages] = (0, $iW40i.useChatMessages)(t0);
    const { addAgentMessage: addAgentMessage, resolveConversationAction: resolveConversationAction, sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { preferences: t1 } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = t1;
    const currentChatMode = (0, $aQWBL.useChatModeState)(conversationId);
    let t2;
    if ($[2] !== chatMessages || $[3] !== conversationId || $[4] !== currentChatMode || $[5] !== formatMessage || $[6] !== resolveConversationAction || $[7] !== selectedAgent?.id || $[8] !== selectedAgent?.named_id || $[9] !== sendMessage || $[10] !== storeUserMessages) {
        t2 = (agentMessageId, authUrl)=>{
            if ((0, $iDrrr.fg)("rovo_chat_fix_oauth_from_message_agent_ack")) {
                const authNotificationText = agentMessageId ? formatMessage($dce0d3b749c3811d$var$messages.forgeAuthMessageCompleted, {
                    agentMessageId: agentMessageId
                }) : formatMessage($dce0d3b749c3811d$var$messages.forgeAuthCompletedMessageWithUnknownSource);
                const linkLabel = formatMessage($dce0d3b749c3811d$var$messages.forgeAuthLinkLabel);
                const prompt = $dce0d3b749c3811d$var$buildAuthNotificationAdf(authNotificationText, linkLabel, authUrl);
                sendMessage({
                    conversationId: conversationId,
                    prompt: prompt,
                    storeUserMessages: storeUserMessages,
                    agentId: selectedAgent?.id,
                    deepResearchEnabled: currentChatMode.deepResearchEnabled,
                    thinkDeeperEnabled: currentChatMode.thinkDeeperEnabled,
                    fastModeEnabled: currentChatMode.fastModeEnabled,
                    taskModeEnabled: currentChatMode.taskModeEnabled,
                    webSearchEnabled: currentChatMode.webSearchEnabled,
                    alphaExtendedThinkingMode: currentChatMode.alphaExtendedThinkingMode,
                    appFilters: currentChatMode.appFilters
                });
                return;
            }
            const lastAgentMessage = (0, $2g97a.findLast)(chatMessages, (0, $igOtY.isStoreAssistant));
            const lastAgentMessageActions = lastAgentMessage?.content.message.message.actions;
            if (!lastAgentMessage) return;
            if (!lastAgentMessageActions?.length) {
                const lastHumanMessage = (0, $2g97a.findLast)(chatMessages, (0, $igOtY.isStoreHuman));
                if (!lastHumanMessage) return;
                sendMessage({
                    conversationId: conversationId,
                    prompt: (0, $6rwn6.encodeAdf)(lastHumanMessage.content.content),
                    storeUserMessages: false,
                    agentId: selectedAgent?.id
                });
                return;
            }
            const action = lastAgentMessageActions[lastAgentMessageActions.length - 1];
            resolveConversationAction({
                conversationId: conversationId,
                messageId: lastAgentMessage.content.message.message.id,
                payload: {
                    context: {
                        ...action,
                        resolution: {
                            type: "confirm"
                        },
                        messageId: lastAgentMessage.content.message.message.id,
                        recipient_agent_named_id: selectedAgent?.named_id
                    }
                }
            });
        };
        $[2] = chatMessages;
        $[3] = conversationId;
        $[4] = currentChatMode;
        $[5] = formatMessage;
        $[6] = resolveConversationAction;
        $[7] = selectedAgent?.id;
        $[8] = selectedAgent?.named_id;
        $[9] = sendMessage;
        $[10] = storeUserMessages;
        $[11] = t2;
    } else t2 = $[11];
    selectedAgent?.id;
    selectedAgent?.named_id;
    const handle3pActionAuth = t2;
    let t3;
    if ($[12] !== addAgentMessage || $[13] !== conversation || $[14] !== formatMessage || $[15] !== selectedAgent) {
        t3 = (_errorMessage)=>{
            if (!conversation || !selectedAgent) return;
            addAgentMessage({
                conversationId: conversation.id,
                agentNamedId: selectedAgent?.named_id,
                content: formatMessage($dce0d3b749c3811d$var$messages.forgeAuthFailureMessage)
            });
        };
        $[12] = addAgentMessage;
        $[13] = conversation;
        $[14] = formatMessage;
        $[15] = selectedAgent;
        $[16] = t3;
    } else t3 = $[16];
    const addForgeFailureMessage = t3;
    let t4;
    if ($[17] !== addForgeFailureMessage || $[18] !== handle3pActionAuth) {
        t4 = {
            addForgeFailureMessage: addForgeFailureMessage,
            handle3pActionAuth: handle3pActionAuth
        };
        $[17] = addForgeFailureMessage;
        $[18] = handle3pActionAuth;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ()=>{
    const { conversation: conversation, selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)();
    const conversationId = conversation?.id ?? (0, $4m5jb.EMPTY_CONVERSATION_ID);
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const { addAgentMessage: addAgentMessage, resolveConversationAction: resolveConversationAction, sendMessage: sendMessage } = (0, $3TxKn.useChatStoreActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const currentChatMode = (0, $aQWBL.useChatModeState)(conversationId);
    const handle3pActionAuth = (0, $cozmU.useCallback)((agentMessageId, authUrl)=>{
        if ((0, $iDrrr.fg)('rovo_chat_fix_oauth_from_message_agent_ack')) {
            const authNotificationText = agentMessageId ? formatMessage($dce0d3b749c3811d$var$messages.forgeAuthMessageCompleted, {
                agentMessageId: agentMessageId
            }) : formatMessage($dce0d3b749c3811d$var$messages.forgeAuthCompletedMessageWithUnknownSource);
            const linkLabel = formatMessage($dce0d3b749c3811d$var$messages.forgeAuthLinkLabel);
            const prompt = $dce0d3b749c3811d$var$buildAuthNotificationAdf(authNotificationText, linkLabel, authUrl);
            sendMessage({
                conversationId: conversationId,
                prompt: prompt,
                storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                storeUserMessages,
                agentId: selectedAgent?.id,
                deepResearchEnabled: currentChatMode.deepResearchEnabled,
                thinkDeeperEnabled: currentChatMode.thinkDeeperEnabled,
                fastModeEnabled: currentChatMode.fastModeEnabled,
                taskModeEnabled: currentChatMode.taskModeEnabled,
                webSearchEnabled: currentChatMode.webSearchEnabled,
                alphaExtendedThinkingMode: currentChatMode.alphaExtendedThinkingMode,
                appFilters: currentChatMode.appFilters
            });
            return;
        }
        const lastAgentMessage = (0, $2g97a.findLast)(chatMessages, (0, $igOtY.isStoreAssistant));
        const lastAgentMessageActions = lastAgentMessage?.content.message.message.actions;
        if (!lastAgentMessage) return;
        // If the last message doesn't have actions, it means the auth url came before an action was planned
        // So we resend the prompt
        if (!lastAgentMessageActions?.length) {
            const lastHumanMessage = (0, $2g97a.findLast)(chatMessages, (0, $igOtY.isStoreHuman));
            if (!lastHumanMessage) return;
            sendMessage({
                conversationId: conversationId,
                prompt: (0, $6rwn6.encodeAdf)(lastHumanMessage.content.content),
                storeUserMessages: false,
                agentId: selectedAgent?.id
            });
            return;
        }
        // If the last message has actions, it means the auth url came after an action was planned
        // So we resolve the action, because we are now authenticated
        const action = lastAgentMessageActions[lastAgentMessageActions.length - 1];
        resolveConversationAction({
            conversationId: conversationId,
            messageId: lastAgentMessage.content.message.message.id,
            payload: {
                context: {
                    ...action,
                    resolution: {
                        type: 'confirm'
                    },
                    messageId: lastAgentMessage.content.message.message.id,
                    recipient_agent_named_id: selectedAgent?.named_id
                }
            }
        });
    }, [
        chatMessages,
        conversationId,
        currentChatMode,
        formatMessage,
        resolveConversationAction,
        selectedAgent?.id,
        selectedAgent?.named_id,
        sendMessage,
        storeUserMessages
    ]);
    const addForgeFailureMessage = (0, $cozmU.useCallback)((_errorMessage)=>{
        if (!conversation || !selectedAgent) return;
        addAgentMessage({
            conversationId: conversation.id,
            agentNamedId: selectedAgent?.named_id,
            content: formatMessage($dce0d3b749c3811d$var$messages.forgeAuthFailureMessage)
        });
    }, [
        conversation,
        selectedAgent,
        addAgentMessage,
        formatMessage
    ]);
    return {
        addForgeFailureMessage: addForgeFailureMessage,
        handle3pActionAuth: handle3pActionAuth
    };
};



const $d332ee77d3a9bec2$var$getAgentFromParams = async ({ agentId: agentId, agentExternalConfigReference: agentExternalConfigReference, getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference })=>{
    // Short-circuit: agentId already known, no network call needed
    if (agentId) return {
        agentId: agentId,
        agentIdentityAccountId: undefined
    };
    if (agentExternalConfigReference) {
        const agent = await getAndStoreAgentByExternalConfigReference({
            externalConfigReference: agentExternalConfigReference
        });
        return {
            agentId: agent?.id,
            agentIdentityAccountId: agent?.identity_account_id ?? undefined
        };
    }
    return {
        agentId: undefined,
        agentIdentityAccountId: undefined
    };
};
/**
 * Lightweight runtime guard for chat-new prompts carrying ADF.
 * This only confirms the value looks like a doc node; it is not full ADF schema validation.
 */ const $d332ee77d3a9bec2$var$EMPTY_CHAT_INPUT_ADF = {
    type: 'doc',
    version: 1,
    content: [
        {
            type: 'paragraph'
        }
    ]
};
const $d332ee77d3a9bec2$var$isAdfDocPrompt = (prompt)=>{
    if (typeof prompt !== 'object' || prompt === null) return false;
    const maybeDoc = prompt;
    return maybeDoc.type === 'doc' && Array.isArray(maybeDoc.content);
};
const $d332ee77d3a9bec2$var$isEditorAgentMentionsExperimentEnabled = ()=>(0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true);
const $d332ee77d3a9bec2$var$isChatEntryPoint = (value)=>Object.values((0, $bC9Xc.ChatEntryPoint)).includes(value);
const $d332ee77d3a9bec2$export$7cb7ab7fc40fc5e1 = ()=>{
    (0, $6cFsl.di)((0, $iDrrr.fg), (0, $hdBxM.Subscriber), (0, $k4g8h.useChatSignals), (0, $n71o5.useChatStore), (0, $5f9e937904d8d9c3$export$cbb5096309445c3b), (0, $418a0a565f43a3ce$export$4be696be8a3bff13), (0, $iDlFY.useEditorPlaceholder));
    const [{ conversations: conversations, currentConversationId: currentConversationId, checkActiveConversationMatchesSource: checkActiveConversationMatchesSource }, { sendMessage: sendMessage, createSeededConversation: createSeededConversation, setSelectedConversation: setSelectedConversation, handleChatOpenPubsubAction: handleChatOpenPubsubAction, createConversationOptimistically: createConversationOptimistically }] = (0, $n71o5.useChatStore)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const { openAgentModal: openAgentModal } = (0, $2ae2e230d1d63d50$export$dd192c4c90e15f6f)();
    const { setPlaceholderAgent: setPlaceholderAgent } = (0, $3z1p5.useAgentsPaginatedStoreActions)();
    const { addForgeFailureMessage: addForgeFailureMessage, handle3pActionAuth: handle3pActionAuth } = (0, $dce0d3b749c3811d$export$a8f9e4b54dd45faa)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { clearPlaceholder: clearPlaceholder, isPromptWithPlaceholder: isPromptWithPlaceholder, insertPlaceholder: insertPlaceholder, insertPlaceholderWithAdf: insertPlaceholderWithAdf } = (0, $iDlFY.useEditorPlaceholder)();
    const [, { addFiles: addFilesToAttachmentStore }] = (0, $jI4Q0.useFileAttachmentsStore)((0, $4m5jb.EMPTY_CONVERSATION_ID));
    const [{ status: status }] = (0, $k4g8h.useChatSignals)();
    const { closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setEmptyChatLaunch: setEmptyChatLaunch, setSelectedSpace: setSelectedSpace, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth } = (0, $bGNkz.useUIStoreActions)();
    const { getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference } = (0, $a2960463e8b854f6$export$6cfd2a7f6d757a99)({
        touchpointSource: 'pubsub-listener'
    });
    const { openDebugModal: openDebugModal } = (0, $5f9e937904d8d9c3$export$cbb5096309445c3b)();
    const [, { open: openFeedbackModal }] = (0, $418a0a565f43a3ce$export$4be696be8a3bff13)();
    const seedInsightConversation = (0, $e5d1fdf7ab29ba5c$export$3edf947a58c1a4fc)();
    const { fireInsightCardClicked: fireInsightCardClicked } = (0, $2a9ea0184d76290b$export$afbf2ed5ba866956)();
    /**
   * Conditional subscriptions
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, status === 'online' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        topic: "ai-mate",
        triggerLatest: true,
        flushQueueOnUnmount: true,
        consumeOnceKey: "conversation-assistant-pubsub-listener",
        onEvent: async (payload)=>{
            (0, $hlvTd.addSentryBreadcrumb)(`PubSubListener onEvent: ${payload.type}`);
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).PUBSUB_LISTENER,
                name: (0, $irnO2.ExperienceName).PUBSUB_LISTENER,
                attributes: {
                    taskId: payload.type
                }
            });
            try {
                if (payload.type === 'insights-open-in-chat' && (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false)) {
                    // Icons arrive as raw string keys (React components can't cross the
                    // event bus) and are re-resolved here; the back-button label is
                    // supplied panel-side by the seeding hook.
                    const { adf: adf, conversationTitle: conversationTitle, iconKey: iconKey, iconColor: iconColor, insightCategory: insightCategory, followUps: followUps } = payload.data;
                    // Mirror the in-panel feed's click analytics so external surfaces
                    // (e.g. the home insights carousel) aren't behaviorally divergent.
                    // Fired before seeding, matching the feed's onInsightCardClicked order.
                    fireInsightCardClicked(insightCategory);
                    await seedInsightConversation(adf, {
                        conversationTitle: conversationTitle,
                        conversationIcon: (0, $47f35143d0efa6a5$export$2449f7dd7c6cf072)(iconKey),
                        conversationIconAppearance: (0, $47f35143d0efa6a5$export$4298f62f89b93bab)(iconColor),
                        followUps: followUps ?? []
                    });
                }
                if (payload.type === 'chat-smartlink-3p-post-auth-launch' && (0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg')) {
                    setIsChatOnboardingMiniModalOpen(false);
                    setActiveMenu('none');
                    setIsAgentSelectorMenuOpen(false);
                    setSmartLink3PPostAuth({
                        isActive: true,
                        extensionKey: payload.data.extensionKey,
                        provider: payload.data.provider,
                        projectContext: payload.data.projectContext
                    });
                    if (payload.openChat) handleChatOpenPubsubAction({
                        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                    });
                }
                if (payload.type === 'message-send') {
                    const { prompt: prompt, productKey: productKey, minionAlias: minionAlias, files: files } = payload.data;
                    const messageSource = payload.interactionSource ? {
                        interactionSource: payload.interactionSource,
                        followUpSource: payload.source
                    } : {
                        interactionSource: 'movedOver',
                        followUpSource: payload.source
                    };
                    await sendMessage({
                        prompt: (0, $6rwn6.encodeAdf)(prompt),
                        storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                        // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                        storeUserMessages,
                        messageSources: messageSource,
                        productKey: productKey,
                        minionAlias: minionAlias,
                        files: files
                    });
                }
                if (payload.type === 'chat-close') {
                    if ((0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg')) clearSmartLink3PPostAuth();
                    closeChat();
                }
                if (payload.type === 'chat-new') {
                    if ((0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg')) clearSmartLink3PPostAuth();
                    // Set project context from payload if provided, otherwise clear stale context.
                    const payloadAIFeatureContext = payload.data.aiFeatureContext;
                    setAIFeatureContext({
                        contextKey: 'projectContext',
                        setContext: (_)=>payloadAIFeatureContext?.projectContext ?? {}
                    });
                    const smartLinkRovoInvokedFrom = payload.interactionSource === (0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE) ? payload.interactionSource : undefined;
                    // When a project context is present (e.g. Daily Brief), set it in the
                    // UI store so the context panel shows the project URL instead of the Confluence page.
                    // This mirrors what handleChatEmptyLaunch does for the Chat button path.
                    if (payloadAIFeatureContext?.projectContext) setEmptyChatLaunch({
                        projectContext: payloadAIFeatureContext?.projectContext,
                        ...smartLinkRovoInvokedFrom ? {
                            invokedFrom: smartLinkRovoInvokedFrom
                        } : {}
                    });
                    else if (smartLinkRovoInvokedFrom) setEmptyChatLaunch({
                        invokedFrom: smartLinkRovoInvokedFrom
                    });
                    // When a selectedSpace is present, set the SpaceBar in the chat input.
                    // This mirrors what handleChatEmptyLaunch does for the Chat button path.
                    if (payload.data.selectedSpace) setSelectedSpace(payload.data.selectedSpace);
                    const { name: name, dialogues: dialogues = [], prompt: prompt_0, sourceId: sourceId, contentContext: contentContext, files: files_0, isPromptPlaceholder: isPromptPlaceholder, overrideAutoSend: overrideAutoSend, skipCreatingSeededConversation: skipCreatingSeededConversation, resetActiveMenu: resetActiveMenu, agentVersion: agentVersion, resultAttributionContext: resultAttributionContext, searchArtifact: searchArtifact } = payload.data;
                    const mode = payload.data.mode;
                    const isEditorAgentMentionsEnabled = $d332ee77d3a9bec2$var$isEditorAgentMentionsExperimentEnabled();
                    if (isEditorAgentMentionsEnabled && prompt_0) {
                        // Clear the visible input before seeding so stale text is not shown while the
                        // seeded conversation backend call is pending. The drop1 fixes path avoids
                        // replaceDocument, which can blur the editor while the mini-modal opens.
                        if ((0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes')) insertPlaceholderWithAdf('', $d332ee77d3a9bec2$var$EMPTY_CHAT_INPUT_ADF, {
                            shouldFocus: false
                        });
                        else insertPlaceholderWithAdf('', $d332ee77d3a9bec2$var$EMPTY_CHAT_INPUT_ADF);
                    }
                    const { agentId: agentIdFromPayload, agentExternalConfigReference: agentExternalConfigReference, agentIdentityAccountId: agentIdentityAccountIdFromPayload } = payload.data;
                    const { agentId: agentId, agentIdentityAccountId: resolvedIdentityAccountId } = await $d332ee77d3a9bec2$var$getAgentFromParams({
                        agentId: agentIdFromPayload,
                        agentExternalConfigReference: agentExternalConfigReference,
                        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
                    });
                    // Only forward launchSource when it is in the closed analytics allowlist,
                    // so a free-form string can never reach aiResult actioned/adopted payloads.
                    const launchSource = resultAttributionContext?.launchSource;
                    const conversationResultAttributionContext = (0, $1jIs1.isAllowedLaunchSource)(launchSource) ? {
                        launchSource: launchSource,
                        ...agentId ? {
                            sourceAgentId: agentId
                        } : {}
                    } : undefined;
                    // Stored on the conversation so attribution also covers launches with no
                    // `prompt` and continues past the first turn.
                    const requestedChatEntryPoint = payload.data.chatEntryPoint;
                    const conversationChatEntryPoint = $d332ee77d3a9bec2$var$isChatEntryPoint(requestedChatEntryPoint) ? requestedChatEntryPoint : undefined;
                    if (resetActiveMenu) setActiveMenu('none');
                    // When the chat-new originates from a Rovo Space surface (the
                    // SpaceLandingPage chat input or a space starter card), capture the
                    // spaceId so the optimistic / seeded conversation can be scoped to
                    // the space immediately. Without this the new conversation briefly
                    // appears in the regular conversation list before the backend
                    // response catches up.
                    const isSpaceLandingNewChatSource = payload.source === 'space-landing-chat-input' || payload.source === 'space-landing-starter';
                    const newChatSpaceId = payload.data.spaceId;
                    const rovoSpaceIdForNewChat = isSpaceLandingNewChatSource && newChatSpaceId ? newChatSpaceId : undefined;
                    const spaceScopedSourceMode = (0, $5odSY.getSpaceScopedSourceMode)({
                        isEnabled: (0, $iDrrr.fg)('rovo_chat_space_source_mode'),
                        sourceMode: mode?.sourceMode,
                        spaceId: rovoSpaceIdForNewChat
                    });
                    // Skip conversation creation if the current active conversation
                    // matches the sourceId. This indicates the conversation was created
                    // by a similar prior action and already contextually present to the user
                    if (!checkActiveConversationMatchesSource(sourceId)) {
                        const conversationTags = payload.data.tags;
                        if (skipCreatingSeededConversation) createConversationOptimistically({
                            sourceAgentId: agentId,
                            chatEntryPoint: conversationChatEntryPoint,
                            ...conversationResultAttributionContext ? {
                                resultAttributionContext: conversationResultAttributionContext
                            } : {},
                            ...agentVersion ? {
                                agentVersion: agentVersion
                            } : {},
                            ...rovoSpaceIdForNewChat ? {
                                rovoSpaceId: rovoSpaceIdForNewChat
                            } : {}
                        });
                        else await createSeededConversation({
                            name: name,
                            dialogues: dialogues,
                            sourceId: sourceId,
                            followUpSource: payload.source,
                            agentId: agentId,
                            chatEntryPoint: conversationChatEntryPoint,
                            ...conversationResultAttributionContext ? {
                                resultAttributionContext: conversationResultAttributionContext
                            } : {},
                            ...agentVersion ? {
                                agentVersion: agentVersion
                            } : {},
                            ...rovoSpaceIdForNewChat ? {
                                rovoSpaceId: rovoSpaceIdForNewChat
                            } : {},
                            ...conversationTags ? {
                                tags: conversationTags
                            } : {},
                            ...mode && {
                                mode: {
                                    deepResearchEnabled: mode.deepResearchEnabled,
                                    thinkDeeperEnabled: mode.thinkDeeperEnabled,
                                    fastModeEnabled: mode.fastModeEnabled,
                                    taskModeEnabled: mode.taskModeEnabled,
                                    webSearchEnabled: mode.webSearchEnabled,
                                    sourceMode: spaceScopedSourceMode,
                                    useCurrentPageContext: mode.useCurrentPageContext,
                                    appFilters: mode.appFilters
                                }
                            }
                        });
                    }
                    if (payload.source === 'ai-mate-onboarding') setIsChatOnboardingMiniModalOpen(false);
                    // skip the chat onboarding for aifc onboarding flow
                    // https://switcheroo.atlassian.com/ui/gates/8d540664-7539-4425-9b90-922bcfaaf054/key/cfind-5139-confluence-aifc-onboarding
                    // Also skip for the CWR nth-user onboarding flow so the mini-modal is
                    // dismissed when a CWR-seeded chat arrives.
                    if (sourceId === 'aifc-onboarding-confluence' || sourceId === 'cwr-nth-user-onboarding-confluence') setIsChatOnboardingMiniModalOpen(false);
                    if (payload.source === 'smartLink-3p-post-auth-chip') clearSmartLink3PPostAuth();
                    // Follow up with a prompt after creating a seeded conversation
                    if (prompt_0) {
                        const isAdfPromptContent = $d332ee77d3a9bec2$var$isAdfDocPrompt(prompt_0);
                        const shouldInsertStringPrompt = typeof prompt_0 === 'string' && // Insert the prompt as an editable draft (instead of sending it) when it is a
                        // placeholder template, or when the publisher explicitly opts into drafting via
                        // `overrideAutoSend`.
                        (!!isPromptPlaceholder && isPromptWithPlaceholder(prompt_0) || overrideAutoSend);
                        const isDraftInsert = isAdfPromptContent && overrideAutoSend || shouldInsertStringPrompt;
                        if (isAdfPromptContent && overrideAutoSend) // The ADF document is the rendered input content.
                        insertPlaceholderWithAdf('', prompt_0);
                        else if (shouldInsertStringPrompt) insertPlaceholder(prompt_0, payload.data.placeholderType);
                        if (isDraftInsert && payload.interactionSource && (0, $iDrrr.fg)('add_interactionsource_to_draft_chat_analytics')) setEmptyChatLaunch({
                            interactionSource: payload.interactionSource,
                            ...smartLinkRovoInvokedFrom ? {
                                invokedFrom: smartLinkRovoInvokedFrom
                            } : {}
                        });
                        if (!isDraftInsert) {
                            // Populate file cache for thumbnail previews (same as chat-input-refresh onSubmit)
                            if (files_0?.length) files_0.forEach((file)=>{
                                if (file.id && file.fileObject && (file.fileObject.type.startsWith('image/') || file.fileObject.type === 'application/pdf' || (0, $hKlzx.isTextFile)(file.fileObject.type, file.fileObject.name))) (0, $2c3E0.fileCache).set(file.id, file.fileObject);
                            });
                            const isSkillPrompt = payload.data.placeholderType === 'skill';
                            const isSmartLink3PPostAuthChip = payload.source === 'smartLink-3p-post-auth-chip';
                            await sendMessage({
                                prompt: typeof prompt_0 === 'string' && !!isPromptPlaceholder && isSkillPrompt ? (0, $6rwn6.encodeSkillPromptToAdf)(prompt_0).adf : (0, $6rwn6.encodeAdf)(prompt_0),
                                storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                                storeUserMessages,
                                messageSources: {
                                    interactionSource: payload.interactionSource ?? 'followUps',
                                    followUpSource: payload.source
                                },
                                agentId: agentId,
                                ...agentIdentityAccountIdFromPayload ?? resolvedIdentityAccountId ? {
                                    agentIdentityAccountId: agentIdentityAccountIdFromPayload ?? resolvedIdentityAccountId ?? undefined
                                } : {},
                                source: payload.source,
                                contentContext: contentContext,
                                minionAlias: payload.data.minionAlias,
                                files: files_0,
                                skillSelectionSource: isSkillPrompt ? 'rovoChatAction' : undefined,
                                ...searchArtifact ? {
                                    searchArtifact: searchArtifact
                                } : {},
                                ...rovoSpaceIdForNewChat ? {
                                    spaceId: rovoSpaceIdForNewChat
                                } : {},
                                ...mode ? {
                                    deepResearchEnabled: mode.deepResearchEnabled,
                                    thinkDeeperEnabled: mode.thinkDeeperEnabled,
                                    fastModeEnabled: mode.fastModeEnabled,
                                    taskModeEnabled: mode.taskModeEnabled,
                                    webSearchEnabled: mode.webSearchEnabled,
                                    sourceMode: spaceScopedSourceMode,
                                    appFilters: mode.appFilters
                                } : {},
                                addCurrentPageAsContextUserPreference: isSmartLink3PPostAuthChip ? false : mode?.useCurrentPageContext
                            });
                        }
                    }
                }
                if (payload.type === 'chat-draft') setSelectedConversation({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                });
                if (payload.type === 'open-browse-agent-modal') openAgentModal();
                if (payload.type === 'open-browse-agent-sidebar') setActiveMenu('agents');
                if (payload.type === 'chat-open') {
                    if ((0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg')) clearSmartLink3PPostAuth();
                    const { resetActiveMenu: resetActiveMenu_0, agentId: agentId_0, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, avatarUrl: avatarUrl, openAgentSelector: openAgentSelector } = payload.data;
                    if (resetActiveMenu_0) setActiveMenu('none');
                    // Set placeholder agent in the agent store for immediate header rendering
                    // with name, avatar, and identity data from the Jira session
                    // The full agent details will be fetched by useAgentsPaginatedByAgentId
                    if (agentId_0 && agentName) setPlaceholderAgent(agentId_0, {
                        name: agentName,
                        ...agentIdentityAccountId && avatarUrl ? {
                            identity_account_id: agentIdentityAccountId,
                            placeholderAvatarUrl: avatarUrl
                        } : {}
                    });
                    handleChatOpenPubsubAction({
                        conversationId: payload.data.channelId,
                        ...agentId_0 ? {
                            agentId: agentId_0
                        } : {}
                    });
                    if (openAgentSelector) setIsAgentSelectorMenuOpen(true);
                }
                if (payload.type === 'forge-auth-success') handle3pActionAuth(payload.data?.agentMessageId, payload.data?.authUrl);
                if (payload.type === 'forge-auth-failure') addForgeFailureMessage(payload.data.errorMessage);
                if (payload.type === 'insert-prompt') {
                    clearPlaceholder();
                    const { channelId: channelId, agentId: overrideAgentId, agentName: agentName_0, agentIdentityAccountId: agentIdentityAccountId_0, avatarUrl: avatarUrl_0 } = payload.data;
                    if (overrideAgentId && agentName_0 && (0, $iDrrr.fg)('ai_agent_sessions_refinement')) setPlaceholderAgent(overrideAgentId, {
                        name: agentName_0,
                        ...agentIdentityAccountId_0 && avatarUrl_0 ? {
                            identity_account_id: agentIdentityAccountId_0,
                            placeholderAvatarUrl: avatarUrl_0
                        } : {}
                    });
                    if (overrideAgentId && channelId && (0, $iDrrr.fg)('ai_agent_sessions_refinement')) setSelectedConversation({
                        conversationId: channelId,
                        sourceAgentId: overrideAgentId
                    });
                    if (isPromptWithPlaceholder(payload.data.prompt) || payload.data.overrideAutoSend && (0, $iDrrr.fg)('fix_dynamic_prompts_in_rovo_action_trigger')) {
                        const { prompt: prompt_1, placeholderType: placeholderType, promptAdf: promptAdf } = payload.data;
                        if (promptAdf) insertPlaceholderWithAdf(prompt_1, promptAdf);
                        else insertPlaceholder(prompt_1, placeholderType);
                        if (payload.data.files?.length) addFilesToAttachmentStore((0, $4m5jb.EMPTY_CONVERSATION_ID), payload.data.files.map((f)=>({
                                ...f,
                                isLoading: false
                            })), ()=>{});
                    } else {
                        const { prompt: prompt_2, placeholderType: placeholderType_0 } = payload.data;
                        const currentAgentId = conversations[currentConversationId]?.sourceAgentId;
                        const agentId_1 = overrideAgentId && (0, $iDrrr.fg)('ai_agent_sessions_refinement') ? overrideAgentId : currentAgentId;
                        const isSkillPlaceholder = placeholderType_0 === 'skill';
                        await sendMessage({
                            prompt: typeof prompt_2 === 'string' && isSkillPlaceholder ? (0, $6rwn6.encodeSkillPromptToAdf)(prompt_2).adf : (0, $6rwn6.encodeAdf)(prompt_2),
                            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                            storeUserMessages,
                            messageSources: {
                                interactionSource: payload.interactionSource ?? 'followUps',
                                followUpSource: payload.source
                            },
                            agentId: agentId_1,
                            ...channelId ? {
                                conversationId: channelId
                            } : {},
                            skillSelectionSource: isSkillPlaceholder ? 'rovoChatAction' : undefined
                        });
                    }
                }
                if (payload.type === 'open-chat-debug-modal') openDebugModal();
                if (payload.type === 'open-chat-feedback-modal') openFeedbackModal({
                    answerQuality: payload.data.answerQuality
                });
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).PUBSUB_LISTENER,
                    error: error,
                    attributes: {
                        taskId: payload.type,
                        payloadSource: payload.source
                    }
                });
            }
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).PUBSUB_LISTENER,
                attributes: {
                    taskId: payload.type
                }
            });
        }
    }));
};








/**
 * @generated SignedSource<<81f75deeec6a3769a4bdff5aaf443cd5>>
 * @relayHash 6d43cdcde683ec3e0605a8b337324697
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f42c74c83bf4f7dfa18d707903ff8b49525e303e6c43e8d5fc8c682707cbb799
const $28c72a19a0152143$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "experience"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "homeThreadsInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "homeThreadsInput",
            "variableName": "homeThreadsInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "ConvoAiHomeThreadsThirdPartySource"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RecommendedSpacesPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConvoAiHomeThreadsResult",
                    "kind": "LinkedField",
                    "name": "convoai_homeThreads",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConvoAiHomeThreadsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConvoAiHomeThread",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "sources",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RecommendedSpacesPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConvoAiHomeThreadsResult",
                    "kind": "LinkedField",
                    "name": "convoai_homeThreads",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConvoAiHomeThreadsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConvoAiHomeThread",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "sources",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v2 /*: any*/ 
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f42c74c83bf4f7dfa18d707903ff8b49525e303e6c43e8d5fc8c682707cbb799",
            "metadata": {},
            "name": "RecommendedSpacesPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$28c72a19a0152143$var$node.hash = "ec44e6d020cdac85dbdc2e6743d6b65f";
var $28c72a19a0152143$export$2e2bcd8739ae039 = $28c72a19a0152143$var$node;






















































































const $dfc449a972b46f40$var$styles = {
    container: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _46hvQmVa5s _0xmtkoVa5s _2fwxA5DIqT",
    illustration: "_0rIjykNHnM"
};
const $dfc449a972b46f40$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        id: "rovo-spaces.recommended-spaces-empty-state.heading",
        defaultMessage: "There's nothing to review right now"
    },
    body: {
        id: "rovo-spaces.recommended-spaces-empty-state.body",
        defaultMessage: "Check again later for new recommendations."
    },
    createSpace: {
        id: "rovo-spaces.recommended-spaces-empty-state.create-space",
        defaultMessage: "Create space"
    }
});
const $dfc449a972b46f40$var$DoneIllustration = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "138",
            height: "138",
            viewBox: "0 0 138 138",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M105.615 79.3795C106.195 76.1295 106.495 72.6845 106.495 69.0245C106.495 65.3645 106.185 61.8245 105.595 58.5345C102.085 38.9645 88.485 26.9045 69.42 23.7995C66.165 23.2745 62.755 22.9995 59.21 22.9995C55.665 22.9995 51.955 23.2895 48.575 23.8595C29.5 27.0445 15.93 39.0795 12.405 58.5345C11.81 61.8195 11.5 65.3195 11.5 69.0245C11.5 72.7295 11.805 76.1295 12.385 79.3795C15.88 98.8145 29.465 110.87 48.57 114.055C51.95 114.62 55.505 114.915 59.205 114.915C62.905 114.915 66.165 114.645 69.415 114.115C88.51 111.015 102.115 98.9245 105.605 79.3795H105.615Z",
            fill: "#82B536"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M75.5152 68.6841L112.075 30.5991L125.595 43.1191L72.4902 88.7041L47.4902 65.6691L60.4902 50.6591L75.5102 68.6891L75.5152 68.6841Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M105.605 58.5395C104.565 52.7695 102.65 47.6395 99.975 43.2095L75.52 68.6845L60.5 50.6545L47.5 65.6645L72.5 88.6995L105.86 60.0645C105.785 59.5495 105.705 59.0395 105.615 58.5345L105.605 58.5395Z",
            fill: "#09326C"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "138",
        height: "138",
        viewBox: "0 0 138 138",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M105.615 79.3795C106.195 76.1295 106.495 72.6845 106.495 69.0245C106.495 65.3645 106.185 61.8245 105.595 58.5345C102.085 38.9645 88.485 26.9045 69.42 23.7995C66.165 23.2745 62.755 22.9995 59.21 22.9995C55.665 22.9995 51.955 23.2895 48.575 23.8595C29.5 27.0445 15.93 39.0795 12.405 58.5345C11.81 61.8195 11.5 65.3195 11.5 69.0245C11.5 72.7295 11.805 76.1295 12.385 79.3795C15.88 98.8145 29.465 110.87 48.57 114.055C51.95 114.62 55.505 114.915 59.205 114.915C62.905 114.915 66.165 114.645 69.415 114.115C88.51 111.015 102.115 98.9245 105.605 79.3795H105.615Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M75.5152 68.6841L112.075 30.5991L125.595 43.1191L72.4902 88.7041L47.4902 65.6691L60.4902 50.6591L75.5102 68.6891L75.5152 68.6841Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M105.605 58.5395C104.565 52.7695 102.65 47.6395 99.975 43.2095L75.52 68.6845L60.5 50.6545L47.5 65.6645L72.5 88.6995L105.86 60.0645C105.785 59.5495 105.705 59.0395 105.615 58.5345L105.605 58.5395Z",
        fill: "#09326C"
    }));
const $dfc449a972b46f40$export$484f16a61f137a91 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { testId: testId, onCreateSpace: onCreateSpace } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dfc449a972b46f40$var$styles.illustration
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfc449a972b46f40$var$DoneIllustration, null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage($dfc449a972b46f40$var$messages.heading);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage($dfc449a972b46f40$var$messages.body);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            align: "center"
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage || $[10] !== onCreateSpace) {
        t6 = onCreateSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
            onClick: onCreateSpace
        }, formatMessage($dfc449a972b46f40$var$messages.createSpace));
        $[9] = formatMessage;
        $[10] = onCreateSpace;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t5 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "center",
            space: "space.150"
        }, t1, t3, t5, t6);
        $[12] = t3;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t7 || $[17] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dfc449a972b46f40$var$styles.container,
            testId: testId
        }, t7);
        $[16] = t7;
        $[17] = testId;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ testId: testId, onCreateSpace: onCreateSpace })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $dfc449a972b46f40$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $dfc449a972b46f40$var$styles.illustration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfc449a972b46f40$var$DoneIllustration, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, formatMessage($dfc449a972b46f40$var$messages.heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        align: "center"
    }, formatMessage($dfc449a972b46f40$var$messages.body)), onCreateSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        onClick: onCreateSpace
    }, formatMessage($dfc449a972b46f40$var$messages.createSpace))));
};


/* RecommendedSpacesSourcesTrigger.tsx generated by @compiled/babel-plugin v2.0.0 */ 

























var $ivSJV = parcelRequire("ivSJV");

const $8b021d45fea2c7b7$var$ANALYTICS_CHANNEL = 'aiMate';
const $8b021d45fea2c7b7$var$messages = (0, $kSwu1.defineMessages)({
    overflowSourceCount: {
        id: "rovo-spaces.recommended-spaces-sources-trigger.overflow-source-count",
        defaultMessage: "+{count} Sources"
    },
    viewSourcesLabel: {
        id: "rovo-spaces.recommended-spaces-sources-trigger.view-sources-label",
        defaultMessage: "View {count, plural, one {# source} other {# sources}} for {spaceTitle}"
    }
});
const $8b021d45fea2c7b7$var$styles = {
    triggerWrapper: "_4xdlr07p2s",
    pressable: "_2mHwu8gVvo _0bjKvDKTcp _3vBAKHjOvk _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _4kiQYAUofl _46hvQmPgdg _0xmtkoPgdg _0LQT5E8HPE _03SyCP8HPE _37wbyuDIqT _0hPCNLDIqT _0KLXrujOvk _24h04i2Njc _0wOv4Q7zJH _1eOmH6o126",
    selectedPressable: "_2mHwu8gVvo _0bjKvDKTcp _3vBAKHrzt2 _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _4kiQYAUofl _46hvQmPgdg _0xmtkoPgdg _0LQT5E8HPE _03SyCP8HPE _37wbyuDIqT _0hPCNLDIqT _0KLXruXsxn _24h04i2Njc _0wOv4Q7zJH"
};
const $8b021d45fea2c7b7$var$mapSourcesForPopup = (sources)=>sources.filter((source)=>source.url).map((source)=>({
            ari: source.ari === source.url ? '' : source.ari,
            title: source.name ?? source.url,
            type: source.sourceType,
            url: source.url,
            lastModified: '',
            product: source.sourceType
        }));
const $8b021d45fea2c7b7$export$ae7a51db5c09eb7 = ({ sources: sources, sourceUrls: sourceUrls, spaceTitle: spaceTitle, sourceCount: sourceCount = sourceUrls.length, testId: testId = 'recommended-spaces-sources-trigger' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const popupSources = (0, $cozmU.useMemo)(()=>$8b021d45fea2c7b7$var$mapSourcesForPopup(sources), [
        sources
    ]);
    const fireTriggerAnalytics = (0, $cozmU.useCallback)((state)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sources',
            attributes: {
                source: 'recommendedSpaces',
                state: state
            }
        }).fire($8b021d45fea2c7b7$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const handleSourceLinkClick = (0, $cozmU.useCallback)((type, ari, product, index)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'sourceLink',
            attributes: {
                index: index,
                is3pLink: !ari,
                product: product,
                source: 'recommendedSpaces',
                sourceType: type
            }
        }).fire($8b021d45fea2c7b7$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        if (isOpen) fireTriggerAnalytics('closed');
        setIsOpen(false);
    }, [
        fireTriggerAnalytics,
        isOpen
    ]);
    const handleToggle = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        const nextIsOpen = !isOpen;
        fireTriggerAnalytics(nextIsOpen ? 'open' : 'closed');
        setIsOpen(nextIsOpen);
    }, [
        fireTriggerAnalytics,
        isOpen
    ]);
    if (popupSources.length === 0 || sourceUrls.length === 0) return null;
    const visibleLogoCount = Math.min(new Set(sourceUrls.map((0, $ivSJV.getSourceType))).size, (0, $8V8zt.MAX_VISIBLE_LOGOS));
    const sourceOverflowCount = Math.max(0, sourceCount - visibleLogoCount);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8b021d45fea2c7b7$var$styles.triggerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: handleClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bSXpv.SourcesPopupContent), {
                sources: popupSources,
                onClickSourceHandler: handleSourceLinkClick,
                onClose: handleClose
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: isOpen ? $8b021d45fea2c7b7$var$styles.selectedPressable : $8b021d45fea2c7b7$var$styles.pressable,
                testId: testId,
                "aria-expanded": isOpen,
                "aria-haspopup": "dialog",
                "aria-label": formatMessage($8b021d45fea2c7b7$var$messages.viewSourcesLabel, {
                    count: sourceCount,
                    spaceTitle: spaceTitle
                }),
                onClick: handleToggle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
                sources: sourceUrls,
                hideOverflowCount: true
            }), sourceOverflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($8b021d45fea2c7b7$var$messages.overflowSourceCount, {
                count: sourceOverflowCount
            })))
    }));
};
























var $bapzw = parcelRequire("bapzw");

const $1e0cd7b862856403$var$messages = (0, $kSwu1.defineMessages)({
    loading: {
        id: "conversation-assistant.recommended-spaces-panel.RecommendedSpacesPanelSkeleton.loading",
        defaultMessage: "Loading recommendations\u2026"
    }
});
const $1e0cd7b862856403$var$styles = {
    panel: "_4bt5LAnQyn _2WAcuGnQyn _2K49XhN91d _3L9DPXN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQmNHnM _0xmtkoNHnM _0LQT5ENHnM _03SyCPNHnM"
};
const $1e0cd7b862856403$export$8935fb34437eb195 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { testId: t1 } = t0;
    const testId = t1 === undefined ? "recommended-spaces-panel-skeleton" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($1e0cd7b862856403$var$messages.loading);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = `${testId}-loader`;
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            "aria-hidden": "true"
        }, /*#__PURE__*/ $cozmU.createElement((0, $bapzw.LazyAnimatedCreateWithRovoIcon), {
            testId: t3,
            width: "148px",
            height: "88px"
        }));
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t2 || $[5] !== t4 || $[6] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $1e0cd7b862856403$var$styles.panel,
            testId: testId,
            role: "status",
            "aria-label": t2
        }, t4);
        $[4] = t2;
        $[5] = t4;
        $[6] = testId;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ testId: testId = 'recommended-spaces-panel-skeleton' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $1e0cd7b862856403$var$styles.panel,
        testId: testId,
        role: "status",
        "aria-label": formatMessage($1e0cd7b862856403$var$messages.loading)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "aria-hidden": "true"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bapzw.LazyAnimatedCreateWithRovoIcon), {
        testId: `${testId}-loader`,
        width: "148px",
        height: "88px"
    })));
};


const $653dba30399a167b$var$messages = (0, $kSwu1.defineMessages)({
    panelTitle: {
        id: "conversation-assistant.recommended-spaces-panel.RecommendedSpacesPanelRenderer.panelTitle",
        defaultMessage: "Recommended Rovo spaces"
    },
    panelSubtitle: {
        id: "conversation-assistant.recommended-spaces-panel.RecommendedSpacesPanelRenderer.panelSubtitle",
        defaultMessage: "Based on your recent activity, these suggested Rovo spaces can help you group related documents and keep your project organized."
    },
    createSpace: {
        id: "conversation-assistant.recommended-spaces-panel.RecommendedSpacesPanelRenderer.createSpace",
        defaultMessage: "Create space"
    },
    newSpace: {
        id: "conversation-assistant.recommended-spaces-panel.RecommendedSpacesPanelRenderer.newSpace",
        defaultMessage: "New space"
    }
});
const $653dba30399a167b$var$styles = {
    wrapper: "_4bt5LAnQyn _2WAcuGnQyn _2K49XhN91d _3L9DPXN91d _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC",
    headerWrapper: "_3YEZNOdnbC",
    scrollableContent: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _2WAcuGIZbP _4bt5LAnQyn _4kiQYAdnbC",
    emptyStateContainer: "_3iDTPbQ4SZ _2O5Vij7dHp _0hPCNLDIqT _37wbyuDIqT",
    panel: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _2K49XhN91d _20H5YkN91d _46hvQmNHnM _0xmtkoNHnM _0LQT5ENHnM _03SyCPNHnM",
    panelFullscreen: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _2K49XhN91d _20H5YkN91d _46hvQmS40j _0xmtkoS40j _0LQT5Ep0Oa _03SyCPp0Oa",
    subtitle: "_0rIjyk5zaO",
    card: "_2mHwu85zaO _0bjKvDyzSk _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO _0rIjyk8HPE _0KLXrunmFW"
}; /**
    * Shared renderer that takes pre-fetched threads and renders the recommendation
    * cards. Both the GraphQL and REST data-fetching wrappers delegate to this.
    */ 
const $653dba30399a167b$export$7c60c10db424fa63 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { threads: threads, onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader, isLoading: t1 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fullScreen: fullScreen, elements: elements } = (0, $dSCNl.useUIConfig)();
    const { closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const viewedRecommendationIdsRef = (0, $cozmU.useRef)(null);
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const shouldShowCloseButton = !!elements?.closeButton;
    let t2;
    let t3;
    if ($[0] !== isLoading || $[1] !== sendAnalyticsEvent || $[2] !== threads) {
        t2 = ()=>{
            if (isLoading) return;
            const recommendationIds = threads.map($653dba30399a167b$var$_temp).join(",");
            if (viewedRecommendationIdsRef.current === recommendationIds) return;
            viewedRecommendationIdsRef.current = recommendationIds;
            sendAnalyticsEvent({
                action: "viewed",
                actionSubject: "recommendedSpaces",
                attributes: {
                    recommendationCount: threads.length
                }
            });
        };
        t3 = [
            isLoading,
            sendAnalyticsEvent,
            threads
        ];
        $[0] = isLoading;
        $[1] = sendAnalyticsEvent;
        $[2] = threads;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[5] !== onCreateSpace || $[6] !== sendAnalyticsEvent) {
        t4 = (title, spaceSources)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "recommendedSpaceCreateSpaceButton"
            });
            onCreateSpace(title, spaceSources);
        };
        $[5] = onCreateSpace;
        $[6] = sendAnalyticsEvent;
        $[7] = t4;
    } else t4 = $[7];
    const handleCreateRecommendedSpace = t4;
    let t5;
    if ($[8] !== onCreateSpace) {
        t5 = ()=>onCreateSpace("", []);
        $[8] = onCreateSpace;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== formatMessage) {
        t6 = formatMessage($653dba30399a167b$var$messages.newSpace);
        $[10] = formatMessage;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
            onClick: t5,
            testId: "recommended-spaces-panel-new-space-button"
        }, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const newSpaceButton = t7;
    let t8;
    if ($[15] !== chatRefreshHeader || $[16] !== fullScreen) {
        t8 = !fullScreen && chatRefreshHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $653dba30399a167b$var$styles.headerWrapper
        }, chatRefreshHeader);
        $[15] = chatRefreshHeader;
        $[16] = fullScreen;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== closeChat || $[19] !== formatMessage || $[20] !== fullScreen || $[21] !== isLoading || $[22] !== newSpaceButton || $[23] !== setActiveMenu || $[24] !== shouldShowCloseButton || $[25] !== threads) {
        t9 = fullScreen && (isLoading || threads.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb8eca56e1c1148d$export$1263ff8fe28ec69f), {
            agentTitleComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "medium"
            }, formatMessage($653dba30399a167b$var$messages.panelTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($653dba30399a167b$var$messages.panelSubtitle))),
            moreMenuComponent: newSpaceButton,
            onBackClick: ()=>setActiveMenu("none"),
            onCloseClick: shouldShowCloseButton ? closeChat : undefined
        });
        $[18] = closeChat;
        $[19] = formatMessage;
        $[20] = fullScreen;
        $[21] = isLoading;
        $[22] = newSpaceButton;
        $[23] = setActiveMenu;
        $[24] = shouldShowCloseButton;
        $[25] = threads;
        $[26] = t9;
    } else t9 = $[26];
    const t10 = fullScreen ? $653dba30399a167b$var$styles.panelFullscreen : $653dba30399a167b$var$styles.panel;
    let t11;
    if ($[27] !== formatMessage || $[28] !== fullScreen || $[29] !== threads) {
        t11 = !fullScreen && threads.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $653dba30399a167b$var$styles.subtitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage($653dba30399a167b$var$messages.panelSubtitle)));
        $[27] = formatMessage;
        $[28] = fullScreen;
        $[29] = threads;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== formatMessage || $[32] !== fullScreen || $[33] !== handleCreateRecommendedSpace || $[34] !== isLoading || $[35] !== onCreateSpace || $[36] !== threads) {
        t12 = isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e0cd7b862856403$export$8935fb34437eb195), null) : threads.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $653dba30399a167b$var$styles.emptyStateContainer,
            style: {
                paddingBlockEnd: fullScreen ? "33%" : "66%"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfc449a972b46f40$export$484f16a61f137a91), {
            onCreateSpace: ()=>onCreateSpace("", [])
        })) : threads.map((thread_0)=>{
            const sources = (thread_0.sources ?? []).filter($653dba30399a167b$var$_temp2);
            const { sourceUrls: sourceUrls, spaceSources: spaceSources_0 } = (0, $536ed46cc0a55681$export$37aba3066a765a03)(sources);
            const sourceCount = sources.length;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: thread_0.id,
                xcss: $653dba30399a167b$var$styles.card
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.200",
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, thread_0.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "row",
                gap: "space.100",
                alignItems: "center",
                justifyContent: fullScreen ? "start" : "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: ()=>handleCreateRecommendedSpace(thread_0.title, spaceSources_0)
            }, formatMessage($653dba30399a167b$var$messages.createSpace)), sourceCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b021d45fea2c7b7$export$ae7a51db5c09eb7), {
                sources: spaceSources_0,
                sourceUrls: sourceUrls,
                sourceCount: sourceCount,
                spaceTitle: thread_0.title
            }))));
        });
        $[31] = formatMessage;
        $[32] = fullScreen;
        $[33] = handleCreateRecommendedSpace;
        $[34] = isLoading;
        $[35] = onCreateSpace;
        $[36] = threads;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t10
        }, t11, t12);
        $[38] = t10;
        $[39] = t11;
        $[40] = t12;
        $[41] = t13;
    } else t13 = $[41];
    let t14;
    if ($[42] !== t13 || $[43] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $653dba30399a167b$var$styles.scrollableContent
        }, t9, t13);
        $[42] = t13;
        $[43] = t9;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== t14 || $[46] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $653dba30399a167b$var$styles.wrapper
        }, t8, t14);
        $[45] = t14;
        $[46] = t8;
        $[47] = t15;
    } else t15 = $[47];
    return t15;
} : ({ threads: threads, onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader, isLoading: isLoading = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fullScreen: fullScreen, elements: elements } = (0, $dSCNl.useUIConfig)();
    const { closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const viewedRecommendationIdsRef = (0, $cozmU.useRef)(null);
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const shouldShowCloseButton = !!elements?.closeButton;
    (0, $cozmU.useEffect)(()=>{
        if (isLoading) return;
        const recommendationIds = threads.map((thread)=>thread.id).join(',');
        if (viewedRecommendationIdsRef.current === recommendationIds) return;
        viewedRecommendationIdsRef.current = recommendationIds;
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'recommendedSpaces',
            attributes: {
                recommendationCount: threads.length
            }
        });
    }, [
        isLoading,
        sendAnalyticsEvent,
        threads
    ]);
    const handleCreateRecommendedSpace = (title, spaceSources)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'recommendedSpaceCreateSpaceButton'
        });
        onCreateSpace(title, spaceSources);
    };
    const newSpaceButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        onClick: ()=>onCreateSpace('', []),
        testId: "recommended-spaces-panel-new-space-button"
    }, formatMessage($653dba30399a167b$var$messages.newSpace));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $653dba30399a167b$var$styles.wrapper
    }, !fullScreen && chatRefreshHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $653dba30399a167b$var$styles.headerWrapper
    }, chatRefreshHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $653dba30399a167b$var$styles.scrollableContent
    }, fullScreen && (isLoading || threads.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb8eca56e1c1148d$export$1263ff8fe28ec69f), {
        agentTitleComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, formatMessage($653dba30399a167b$var$messages.panelTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage($653dba30399a167b$var$messages.panelSubtitle))),
        moreMenuComponent: newSpaceButton,
        onBackClick: ()=>setActiveMenu('none'),
        onCloseClick: shouldShowCloseButton ? closeChat : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: fullScreen ? $653dba30399a167b$var$styles.panelFullscreen : $653dba30399a167b$var$styles.panel
    }, !fullScreen && threads.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $653dba30399a167b$var$styles.subtitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($653dba30399a167b$var$messages.panelSubtitle))), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e0cd7b862856403$export$8935fb34437eb195), null) : threads.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $653dba30399a167b$var$styles.emptyStateContainer,
        style: {
            paddingBlockEnd: fullScreen ? '33%' : '66%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfc449a972b46f40$export$484f16a61f137a91), {
        onCreateSpace: ()=>onCreateSpace('', [])
    })) : threads.map((thread_0)=>{
        const sources = (thread_0.sources ?? []).filter((s)=>s != null);
        const { sourceUrls: sourceUrls, spaceSources: spaceSources_0 } = (0, $536ed46cc0a55681$export$37aba3066a765a03)(sources);
        const sourceCount = sources.length; // TODO ROVOFE-2869: render an emoji/icon next to the title once the backend
        // surfaces a recommendation icon for each thread.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: thread_0.id,
            xcss: $653dba30399a167b$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, thread_0.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "row",
            gap: "space.100",
            alignItems: "center",
            justifyContent: fullScreen ? 'start' : 'space-between'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: ()=>handleCreateRecommendedSpace(thread_0.title, spaceSources_0)
        }, formatMessage($653dba30399a167b$var$messages.createSpace)), sourceCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b021d45fea2c7b7$export$ae7a51db5c09eb7), {
            sources: spaceSources_0,
            sourceUrls: sourceUrls,
            sourceCount: sourceCount,
            spaceTitle: thread_0.title
        }))));
    }))));
};
function $653dba30399a167b$var$_temp(thread) {
    return thread.id;
}
function $653dba30399a167b$var$_temp2(s) {
    return s != null;
}


const $9a58e9968f397924$var$ROVO_AGENTS_FE_TEAM_NAME = 'rovo-agents-fe';
const $9a58e9968f397924$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
// A HIPAA-disabled product returns an expected error, not a real failure — treat
// it as a successful (empty) load so it doesn't pollute the failure SLO. Mirrors
// the handling in usePrefetchRecommendedSpacesOnOpenIntent.
const $9a58e9968f397924$var$isHipaaError = (error)=>typeof error === 'object' && error !== null && error.errorAttributes?.errorCode === $9a58e9968f397924$var$HIPAA_ERROR_CODE;
/**
 * GraphQL-based data fetcher (legacy path, used when `rovo_space_recommended` gate is off).
 */ const $9a58e9968f397924$var$RecommendedSpacesPanelGraphQL = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { cloudId: cloudId, userId: userId, onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader } = t0;
    const t1 = userId ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            userId: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== cloudId || $[3] !== t2) {
        t3 = {
            cloudId: cloudId,
            experience: "home-threads",
            homeThreadsInput: t2
        };
        $[2] = cloudId;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $28c72a19a0152143$export$2e2bcd8739ae039), t3);
    let t4;
    if ($[5] !== data?.convoai_homeThreads?.edges) {
        const edges = data?.convoai_homeThreads?.edges ?? [];
        t4 = edges.map($9a58e9968f397924$var$_temp).filter($9a58e9968f397924$var$_temp2).map($9a58e9968f397924$var$_temp3);
        $[5] = data?.convoai_homeThreads?.edges;
        $[6] = t4;
    } else t4 = $[6];
    const threads = t4;
    let t5;
    if ($[7] !== chatRefreshHeader || $[8] !== onCreateSpace || $[9] !== threads) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $653dba30399a167b$export$7c60c10db424fa63), {
            threads: threads,
            onCreateSpace: onCreateSpace,
            chatRefreshHeader: chatRefreshHeader
        });
        $[7] = chatRefreshHeader;
        $[8] = onCreateSpace;
        $[9] = threads;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ cloudId: cloudId, userId: userId, onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by extractSourcesFromThread */ (0, $28c72a19a0152143$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        cloudId: cloudId,
        experience: 'home-threads',
        homeThreadsInput: {
            userId: userId ?? ''
        }
    });
    const threads = (0, $cozmU.useMemo)(()=>{
        const edges = data?.convoai_homeThreads?.edges ?? [];
        return edges.map((edge)=>edge?.node).filter((node)=>node?.id != null && node?.title != null).map((node_0)=>({
                id: node_0.id,
                title: node_0.title,
                sources: node_0.sources ?? null
            }));
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $653dba30399a167b$export$7c60c10db424fa63), {
        threads: threads,
        onCreateSpace: onCreateSpace,
        chatRefreshHeader: chatRefreshHeader
    });
};
/**
 * REST-based data fetcher (new path, used when `rovo_space_recommended` gate is on).
 * Calls `GET /api/rovo/v1/spaces/recommended` which returns threads with
 * server-side filtering of threads already converted to spaces.
 */ const $9a58e9968f397924$var$RecommendedSpacesPanelREST = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader } = t0;
    let t1;
    if ($[0] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            product: "rovo",
            experienceId: "ai-mate"
        };
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const { threads: threads, isLoading: isLoading, error: error } = (0, $72Oi6.useRecommendedSpaces)(t1);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const settledRef = (0, $cozmU.useRef)(false);
    let t2;
    let t3;
    if ($[2] !== error || $[3] !== experienceTracker || $[4] !== isLoading) {
        t2 = ()=>{
            if (settledRef.current) return;
            if (error) {
                settledRef.current = true;
                if ($9a58e9968f397924$var$isHipaaError(error)) experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES
                });
                else experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES,
                    error: error,
                    teamName: $9a58e9968f397924$var$ROVO_AGENTS_FE_TEAM_NAME
                });
                return;
            }
            if (!isLoading) {
                settledRef.current = true;
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES
                });
            }
        };
        t3 = [
            isLoading,
            error,
            experienceTracker
        ];
        $[2] = error;
        $[3] = experienceTracker;
        $[4] = isLoading;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[7] !== experienceTracker) {
        t4 = ()=>()=>{
                if (!settledRef.current) experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES,
                    reason: "Recommended spaces panel closed before load settled"
                });
            };
        t5 = [
            experienceTracker
        ];
        $[7] = experienceTracker;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[10] !== chatRefreshHeader || $[11] !== isLoading || $[12] !== onCreateSpace || $[13] !== threads) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $653dba30399a167b$export$7c60c10db424fa63), {
            threads: threads,
            onCreateSpace: onCreateSpace,
            chatRefreshHeader: chatRefreshHeader,
            isLoading: isLoading
        });
        $[10] = chatRefreshHeader;
        $[11] = isLoading;
        $[12] = onCreateSpace;
        $[13] = threads;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ cloudId: cloudId, onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader })=>{
    const { threads: threads, isLoading: isLoading, error: error } = (0, $72Oi6.useRecommendedSpaces)({
        cloudId: cloudId,
        product: 'rovo',
        experienceId: 'ai-mate'
    });
    // End the perceived-load experience started at click (see rovo-navigation's
    // handleSelectRecommendedSpacesClick). Succeed once loading settles — which is
    // immediate when the ROVOFE-3252 prefetch has already warmed the cache — so the
    // recorded duration reflects perceived click→render time. `succeed`/`fail`/`abort`
    // are no-ops when no experience is active (e.g. the panel shown without a click).
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const settledRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (settledRef.current) return;
        if (error) {
            settledRef.current = true;
            if ($9a58e9968f397924$var$isHipaaError(error)) experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES
            });
            else experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES,
                error: error,
                teamName: $9a58e9968f397924$var$ROVO_AGENTS_FE_TEAM_NAME
            });
            return;
        }
        if (!isLoading) {
            settledRef.current = true;
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES
            });
        }
    }, [
        isLoading,
        error,
        experienceTracker
    ]);
    // If the user leaves before the panel settles, abandon the experience so it
    // isn't left dangling (and doesn't skew the perceived-load timing).
    (0, $cozmU.useEffect)(()=>()=>{
            if (!settledRef.current) experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).OPEN_RECOMMENDED_SPACES,
                reason: 'Recommended spaces panel closed before load settled'
            });
        }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $653dba30399a167b$export$7c60c10db424fa63), {
        threads: threads,
        onCreateSpace: onCreateSpace,
        chatRefreshHeader: chatRefreshHeader,
        isLoading: isLoading
    });
};
const $9a58e9968f397924$export$c354b3edb6dc2c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if (!props.userId) return null;
    if ((0, $iDrrr.fg)("rovo_space_recommended")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9a58e9968f397924$var$RecommendedSpacesPanelREST, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9a58e9968f397924$var$RecommendedSpacesPanelGraphQL, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    if (!props.userId) return null;
    if ((0, $iDrrr.fg)('rovo_space_recommended')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9a58e9968f397924$var$RecommendedSpacesPanelREST, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9a58e9968f397924$var$RecommendedSpacesPanelGraphQL, props);
};
function $9a58e9968f397924$var$_temp(edge) {
    return edge?.node;
}
function $9a58e9968f397924$var$_temp2(node) {
    return node?.id != null && node?.title != null;
}
function $9a58e9968f397924$var$_temp3(node_0) {
    return {
        id: node_0.id,
        title: node_0.title,
        sources: node_0.sources ?? null
    };
}












const $150497341f74b797$export$e1e48cca2c330187 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== chatRefreshHeader || $[2] !== onCreateSpace) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $653dba30399a167b$export$7c60c10db424fa63), {
            threads: t1,
            onCreateSpace: onCreateSpace,
            chatRefreshHeader: chatRefreshHeader,
            isLoading: true
        });
        $[1] = chatRefreshHeader;
        $[2] = onCreateSpace;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ onCreateSpace: onCreateSpace, chatRefreshHeader: chatRefreshHeader })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $653dba30399a167b$export$7c60c10db424fa63), {
        threads: [],
        onCreateSpace: onCreateSpace,
        chatRefreshHeader: chatRefreshHeader,
        isLoading: true
    });



































































var $fxbF1 = parcelRequire("fxbF1");





var $jC4nA = parcelRequire("jC4nA");





var $1TvTa = parcelRequire("1TvTa");


























var $iDdJP = parcelRequire("iDdJP");


var $gmhHk = parcelRequire("gmhHk");

var $4X3mP = parcelRequire("4X3mP");








var $j4cgb = parcelRequire("j4cgb");














var $145zT = parcelRequire("145zT");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 


function $9dc22ed829da39ea$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
} /**
   * __List item__
   *
   * A [list item](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/li) with visual styles removed.
   */ 
const $9dc22ed829da39ea$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $cozmU.forwardRef)($9dc22ed829da39ea$var$_ListItem);















var $k12R1 = parcelRequire("k12R1");













// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $17a118af00cd097a$export$cae56ba9f387896e = '--expandable-chevron-display';
const $17a118af00cd097a$export$fa7812ef46f11806 = '--expandable-provided-elembefore-display';
const $17a118af00cd097a$export$d492445a79a49b48 = '12px';
const $17a118af00cd097a$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');
const $17a118af00cd097a$export$a279d2044f48fbcb = 810;
const $17a118af00cd097a$export$6da3aaba6bb6f609 = 820;
const $17a118af00cd097a$export$6e5abe1fde535897 = 'rovo-navigation';
// Time calculation constants
const $17a118af00cd097a$var$HOURS_IN_DAY = 24;
const $17a118af00cd097a$var$MINUTES_IN_HOUR = 60;
const $17a118af00cd097a$var$SECONDS_IN_MINUTE = 60;
const $17a118af00cd097a$var$MILLISECONDS_IN_SECOND = 1000;
const $17a118af00cd097a$export$750abf5956643c1a = $17a118af00cd097a$var$HOURS_IN_DAY * $17a118af00cd097a$var$MINUTES_IN_HOUR * $17a118af00cd097a$var$SECONDS_IN_MINUTE * $17a118af00cd097a$var$MILLISECONDS_IN_SECOND;
const $17a118af00cd097a$export$5c2fd9a7561b5ec = 1;
const $17a118af00cd097a$export$a7851db961bee92d = 7;
const $17a118af00cd097a$export$b0dc530ecdd4b82b = 14;
const $17a118af00cd097a$export$2f58959d6b4c4102 = 30;
const $17a118af00cd097a$export$18c04e21aa077ce9 = 0;
const $17a118af00cd097a$export$666507e3d0a8e6da = 1;
const $17a118af00cd097a$export$766879a84c091f09 = 2;
const $17a118af00cd097a$export$135b054211051d49 = 3;
const $17a118af00cd097a$export$6ce742aaaff529a4 = 4;





const $876a097c74c317c3$export$8ab756e06c5d9001 = (0, $cozmU.forwardRef);


function $6e70fa93f252879b$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}


const $f079422b0c2e0ccb$var$tooltipStyles = {
    root: "_0bjKvDKxmn _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _4kiQYAUofl _1EqgXlgs9g _24h04i2Njc _46hvQmFQfX _03SyCPgVvo _0xmtkoFQfX _0LQT5EgVvo _0KLXrugozt _1UtDYze5R3 _2I62gzPgdg _3iC0zdPgdg _3zvHkHwPeg _1T2N03wPeg"
};
const $f079422b0c2e0ccb$var$MenuItemTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuItemTooltip(t0, ref) {
    const $ = (0, $bDgLe.c)(11);
    let children;
    let className;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = rest;
    } else {
        children = $[1];
        className = $[2];
        rest = $[3];
    }
    let t1;
    if ($[4] !== className) {
        t1 = (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$tooltipStyles.root,
            className
        ]);
        $[4] = className;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
            ...rest,
            className: t1,
            ref: ref
        }, children);
        $[6] = children;
        $[7] = ref;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$tooltipStyles.root,
            className
        ]),
        ref: ref
    }, children);
});
function $f079422b0c2e0ccb$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $f079422b0c2e0ccb$var$elemAfterDisplayVar = '--elem-after-display';
const $f079422b0c2e0ccb$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $f079422b0c2e0ccb$var$notchColorVar = '--notch-color'; /**
                                        * ## 🤹 `position:relative`
                                        *
                                        * We need `position:relative` on an element that takes
                                        * up the full size of the interactive element so we
                                        * can correctly use `position:absolute` to place:
                                        * 1. the notch for links
                                        * 2. drop indicators for drag and drop
                                        * 3. a child of button / anchor to stretch it out to
                                        *    increase it's pressable area.
                                        *
                                        * ⛔️ We cannot add `position:relative` _only_ on the
                                        * button / anchor as that will cause sibling elements
                                        * to be rendered under the button / anchor when setting
                                        * a background color on the button / anchor.
                                        *
                                        * 📖 Note: `position:relative` elements are painted after
                                        * elements with `position:static` (the default)
                                        * https://drafts.csswg.org/css-position-4/#painting-order
                                        *
                                        * ⛔️ We cannot add `position:relative` to the container
                                        * element, as then the `:focus` ring styles on the
                                        * button / anchor can be cut off by the next sibling if it has
                                        * has a background color set (eg when selected)
                                        *
                                        * ✅ Add `position:relative` to all first level descendants
                                        * of the container element so that we don't impact DOM ordered
                                        * paint ordering within the item and the button / anchor focus
                                        * ring can still bleed over siblings
                                        *
                                        * 📖 We could use `> * { position: relative; }` on the container,
                                        * but that would violate our styling standard.
                                        */ 
const $f079422b0c2e0ccb$var$topLevelSiblingStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * All slots on the menu item (eg `elemBefore`) are rendered as siblings
    * of our main button / anchor element and they are visually placed on
    * top of the main button / anchor.
    *
    * 📖 This is done so that we don't nest interactive elements in our markup.
    *
    * ✅ This is great when element in the slot is an interactive element
    * as we don't want the main menu item button / anchor to be triggered
    * when interacting with the element in the slot.
    *
    * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
    * prevent the main button / anchor (that is visually behind the element in
    * the slot) from being clicked. The element in the slot is a sibling of our
    * main button / anchor (not a child of it) so clicking on the element in the
    * slot will not bubble up to the button / anchor.
    *
    * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
    * element so that static content in a slot does not prevent clicking on the main
    * button / anchor.
    */ 
const $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles = {
    root: "_2XwD3GYbGa"
}; /**
    * This is being _internally_ exported so it can be used in other menu item wrapper components, like
    * ExpandableMenuItemTrigger.
    *
    * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
    * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
    * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
    * outside the menu item, e.g. if rendered in a portal.
    *
    * An alternative solution might involve wrapping it with a popup context and listening to the popup
    * events through it (and applying the hover style when the popup is open). Exploring this has been
    * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
    */ 
const $f079422b0c2e0ccb$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $f079422b0c2e0ccb$var$containerStyles = {
    root: "_0bjKvDKTcp _24h04i2Njc _3iDTPbgBM8 _2iEGP2dBcB _0ca6V7UfmU _3NN0tOjIhD _4ouGXIL04q _0jFU0VZ49V _0hPCNLDIqT _20VacPYbGa _1UtDYzZpcK _0XA9qCYbGa _4Gpka1jOvk _0B0jWhQ4SZ _4hDavfo126 _3ZMGdpQ4SZ _1eOmH6o126 _39tYIhQ4SZ _2orrW2Q4SZ",
    large: "_24h04i2Njc _4kiQYAs7ue _46hvQm8HPE _0xmtko8HPE _03SyCP5zaO",
    small: "_24h04i2Njc _4kiQYA7hsp _46hvQmgVvo _0xmtkogVvo _03SyCPgVvo",
    removeElemAfter: "_0B0jWhYbGa",
    showHoverActions: "_0XA9qCQ4SZ",
    removeElemAfterOnHoverOrOpenNestedPopup: "_3gMmAmYbGa _3R5mzfYbGa _4g9hZtYbGa",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _4Gpka1kLmD _4hDavfsumd _0clgaMjTy9 _1eOmH6sumd",
    suppressNotch: "_4Gpka1jOvk _0LQT5EgVvo",
    disabled: "_1UtDYzot27 _1eOmH6ZqHV",
    hasDescription: "_0jFU0VDuDI"
};
const $f079422b0c2e0ccb$var$buttonOrAnchorStyles = {
    root: "_0bjKvDKxmn _2j3gqAg8pm _3B2K2Q7dHp _3iDTPbgBM8 _2iEGP2qccN _0ca6V7qccN _03SyCP1Y8M _0LQT5E1Y8M _46hvQm1Y8M _0xmtko1Y8M _0KLXrujOvk _1UtDYzZpcK _0hPCNLDIqT _2fwxA57p2s _2FPiMbJNoT",
    large: "_46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg",
    small: "_46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg",
    selected: "_1UtDYzjTy9 _2FPiMbXsxn",
    noActiveBackground: "_2FPiMbjOvk"
};
const $f079422b0c2e0ccb$var$extendButtonOrAnchorStyles = {
    root: "_49OCfRPgdg _1mT5xdWVPG"
};
const $f079422b0c2e0ccb$var$notchStyles = {
    root: "_1mT5xdWVPG _2I62gz715P _3iC0zdPgdg _39xV024Jdh _0jFU0VxpxF _1VJPcakruI _0KLXruzNEo"
};
const $f079422b0c2e0ccb$var$actionStyles = {
    root: "_2mHwu81Y8M _1xC2CJnO1v _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
};
const $f079422b0c2e0ccb$var$actionsOnHoverStyles = {
    root: "_1xC2CJoUfk _2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _3iDTPbS8hL _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
};
const $f079422b0c2e0ccb$var$textStyles = {
    root: "_2mHwu8FQfX _4bt5LAnQyn _2WAcuGnQyn _03SyCP1Y8M _0LQT5E1Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIw0fc _3uh4XpyL8i _2yI6tSyL8i",
    noElemBeforeIndent: "_0LQT5EgVvo"
};
const $f079422b0c2e0ccb$var$elemBeforeStyles = {
    root: "_1xC2CJZyOa _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT _0LQT5E1Y8M _24h04iPvdi _3uh4XpyL8i _2yI6tSyL8i",
    large: "_39xV02Uofl _0jFU0VUofl _0LQT5E5zaO _2xTnZx8HPE"
};
const $f079422b0c2e0ccb$var$elemAfterStyles = {
    root: "_1xC2CJoUfk _4bt5LAnQyn _2WAcuGnQyn _3iDTPbx0Ks _3YEZNOdnbC _0jFU0VoWWg _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i",
    large: "_4xdlr07p2s",
    small: "_4xdlr0DIqT"
}; /**
    * We are using a wrapping element for our interactive content
    * even though only the `Text` element is the only thing not using `position:absolute`
    *
    * Rationale:
    * - Super clear that everything inside the interactive content should be in a specific slot in the grid
    * - To work around a browser bug in Safari where it does not work well with `position:absolute`
    *   on a subgrid child.
    *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
    */ 
const $f079422b0c2e0ccb$var$interactiveContentStyles = {
    root: "_1xC2CJxFwi _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXDIqT _4ouGXIdnbC"
};
const $f079422b0c2e0ccb$var$descriptionStyles = {
    rich: "_4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _3iDTPbccYA _0hPCNLDIqT _4ouGXIdnbC _1ANEUSLRg7"
};
function $f079422b0c2e0ccb$var$getTextColor(isDisabled) {
    if (isDisabled) return 'color.text.disabled';
    return 'color.text';
} /**
   * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
   *
   * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
   * expanded content for ExpandableMenuItem.
   */ 
const $f079422b0c2e0ccb$var$MenuItemBaseNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(88);
    const { id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, level: t1, size: t2, noActiveBackground: noActiveBackground } = t0;
    const level = t1 === undefined ? 0 : t1;
    const size = t2 === undefined ? "default" : t2;
    const isLink = typeof href !== "undefined";
    const labelRef = (0, $cozmU.useRef)(null);
    const descriptionRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (node)=>{
            descriptionRef.current = node;
        };
        $[0] = t3;
    } else t3 = $[0];
    const setDescriptionRef = t3;
    const tooltipOnClick = (0, $cozmU.useRef)(null);
    const isRichDescription = typeof description !== "string";
    let t4;
    if ($[1] !== onClick) {
        t4 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            tooltipOnClick.current?.(event);
        };
        $[1] = onClick;
        $[2] = t4;
    } else t4 = $[2];
    const handleClick = t4;
    let t5;
    if ($[3] !== isContentTooltipDisabled) {
        t5 = ()=>{
            if (isContentTooltipDisabled) return false;
            const label = labelRef.current;
            const description_0 = descriptionRef.current;
            if (label && $f079422b0c2e0ccb$var$isTextClamped(label)) return true;
            return Boolean(description_0 && $f079422b0c2e0ccb$var$isTextClamped(description_0));
        };
        $[3] = isContentTooltipDisabled;
        $[4] = t5;
    } else t5 = $[4];
    const canTooltipAppear = t5;
    const showElemBefore = elemBefore !== (0, $17a118af00cd097a$export$f4b8e24fae579c6f);
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$interactiveContentStyles.root
        ]);
        $[5] = t6;
    } else t6 = $[5];
    const t7 = `calc(-1 * ${level} * ${(0, $17a118af00cd097a$export$d492445a79a49b48)})`;
    let t8;
    if ($[6] !== t7) {
        t8 = {
            insetInlineStart: t7
        };
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$extendButtonOrAnchorStyles.root
        ]);
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t8,
            "aria-hidden": "true",
            className: t9
        });
        $[9] = t8;
        $[10] = t10;
    } else t10 = $[10];
    const t11 = !showElemBefore && $f079422b0c2e0ccb$var$textStyles.noElemBeforeIndent;
    let t12;
    if ($[11] !== t11) {
        t12 = (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$textStyles.root,
            t11
        ]);
        $[11] = t11;
        $[12] = t12;
    } else t12 = $[12];
    let t13;
    if ($[13] !== isDisabled) {
        t13 = $f079422b0c2e0ccb$var$getTextColor(isDisabled);
        $[13] = isDisabled;
        $[14] = t13;
    } else t13 = $[14];
    let t14;
    if ($[15] !== children || $[16] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            maxLines: 1,
            color: t13,
            ref: labelRef
        }, children);
        $[15] = children;
        $[16] = t13;
        $[17] = t14;
    } else t14 = $[17];
    let t15;
    if ($[18] !== description || $[19] !== isRichDescription) {
        t15 = description && isRichDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: setDescriptionRef,
            className: (0, $hekY6.default)([
                $f079422b0c2e0ccb$var$descriptionStyles.rich
            ])
        }, description) : null;
        $[18] = description;
        $[19] = isRichDescription;
        $[20] = t15;
    } else t15 = $[20];
    let t16;
    if ($[21] !== description || $[22] !== isDisabled || $[23] !== isRichDescription) {
        t16 = description && !isRichDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: isDisabled ? "color.text.disabled" : "color.text.subtle",
            size: "small",
            maxLines: 1,
            ref: setDescriptionRef
        }, description) : null;
        $[21] = description;
        $[22] = isDisabled;
        $[23] = isRichDescription;
        $[24] = t16;
    } else t16 = $[24];
    let t17;
    if ($[25] !== t12 || $[26] !== t14 || $[27] !== t15 || $[28] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t12
        }, t14, t15, t16);
        $[25] = t12;
        $[26] = t14;
        $[27] = t15;
        $[28] = t16;
        $[29] = t17;
    } else t17 = $[29];
    let t18;
    if ($[30] !== t10 || $[31] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, t10, t17);
        $[30] = t10;
        $[31] = t17;
        $[32] = t18;
    } else t18 = $[32];
    const interactiveElemContent = t18;
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    const isLarge = size === "large";
    const isSmall = size === "small";
    const t19 = testId ? `${testId}-container` : undefined;
    const t20 = isLarge && $f079422b0c2e0ccb$var$containerStyles.large;
    const t21 = isSmall && $f079422b0c2e0ccb$var$containerStyles.small;
    const t22 = isSelected && $f079422b0c2e0ccb$var$containerStyles.selected;
    const t23 = description && !isLarge && $f079422b0c2e0ccb$var$containerStyles.hasDescription;
    const t24 = showHoverActionsWhenNotHovered && $f079422b0c2e0ccb$var$containerStyles.showHoverActions;
    const t25 = showHoverActionsWhenNotHovered && elemAfter && $f079422b0c2e0ccb$var$containerStyles.removeElemAfter;
    const t26 = actionsOnHover && elemAfter && $f079422b0c2e0ccb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup;
    const t27 = isDisabled && $f079422b0c2e0ccb$var$containerStyles.disabled;
    let t28;
    if ($[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23 || $[37] !== t24 || $[38] !== t25 || $[39] !== t26 || $[40] !== t27) {
        t28 = (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$containerStyles.root,
            t20,
            t21,
            t22,
            $f079422b0c2e0ccb$var$containerStyles.suppressNotch,
            t23,
            t24,
            t25,
            t26,
            t27
        ]);
        $[33] = t20;
        $[34] = t21;
        $[35] = t22;
        $[36] = t23;
        $[37] = t24;
        $[38] = t25;
        $[39] = t26;
        $[40] = t27;
        $[41] = t28;
    } else t28 = $[41];
    let t29;
    if ($[42] !== children || $[43] !== description) {
        t29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, description) : null);
        $[42] = children;
        $[43] = description;
        $[44] = t29;
    } else t29 = $[44];
    let t30;
    if ($[45] !== ariaControls || $[46] !== ariaExpanded || $[47] !== ariaHasPopup || $[48] !== forwardedRef || $[49] !== handleClick || $[50] !== href || $[51] !== id || $[52] !== interactionName || $[53] !== interactiveElemContent || $[54] !== isDisabled || $[55] !== isLarge || $[56] !== isLink || $[57] !== isSelected || $[58] !== isSmall || $[59] !== noActiveBackground || $[60] !== target || $[61] !== testId) {
        t30 = (tooltipProps)=>{
            tooltipOnClick.current = tooltipProps.onClick;
            const sharedProps = {
                ...tooltipProps,
                "aria-controls": ariaControls,
                "aria-haspopup": ariaHasPopup,
                ref: (0, $6e70fa93f252879b$export$2e2bcd8739ae039)([
                    forwardedRef,
                    tooltipProps.ref
                ]),
                id: id,
                testId: testId,
                interactionName: interactionName
            };
            return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $k12R1.cx)($f079422b0c2e0ccb$var$buttonOrAnchorStyles.root, isLarge && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.large, isSmall && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.small, $f079422b0c2e0ccb$var$topLevelSiblingStyles.root, isSelected && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.selected, noActiveBackground && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.noActiveBackground),
                style: {
                    textDecoration: "none"
                },
                "aria-current": isSelected ? "page" : undefined,
                href: href,
                target: target,
                draggable: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $f079422b0c2e0ccb$var$notchStyles.root
                ])
            }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $k12R1.cx)($f079422b0c2e0ccb$var$buttonOrAnchorStyles.root, isLarge && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.large, isSmall && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.small, $f079422b0c2e0ccb$var$topLevelSiblingStyles.root, isSelected && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.selected, noActiveBackground && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.noActiveBackground),
                "aria-expanded": ariaExpanded,
                isDisabled: isDisabled
            }, interactiveElemContent);
        };
        $[45] = ariaControls;
        $[46] = ariaExpanded;
        $[47] = ariaHasPopup;
        $[48] = forwardedRef;
        $[49] = handleClick;
        $[50] = href;
        $[51] = id;
        $[52] = interactionName;
        $[53] = interactiveElemContent;
        $[54] = isDisabled;
        $[55] = isLarge;
        $[56] = isLink;
        $[57] = isSelected;
        $[58] = isSmall;
        $[59] = noActiveBackground;
        $[60] = target;
        $[61] = testId;
        $[62] = t30;
    } else t30 = $[62];
    let t31;
    if ($[63] !== canTooltipAppear || $[64] !== t29 || $[65] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t29,
            position: "right",
            component: $f079422b0c2e0ccb$var$MenuItemTooltip,
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, t30);
        $[63] = canTooltipAppear;
        $[64] = t29;
        $[65] = t30;
        $[66] = t31;
    } else t31 = $[66];
    let t32;
    if ($[67] !== elemBefore || $[68] !== isLarge || $[69] !== showElemBefore) {
        t32 = showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $f079422b0c2e0ccb$var$elemBeforeStyles.root,
                isLarge && $f079422b0c2e0ccb$var$elemBeforeStyles.large,
                $f079422b0c2e0ccb$var$topLevelSiblingStyles.root,
                $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemBefore);
        $[67] = elemBefore;
        $[68] = isLarge;
        $[69] = showElemBefore;
        $[70] = t32;
    } else t32 = $[70];
    let t33;
    if ($[71] !== actionsOnHover) {
        t33 = actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $f079422b0c2e0ccb$var$actionsOnHoverStyles.root
            ])
        }, actionsOnHover);
        $[71] = actionsOnHover;
        $[72] = t33;
    } else t33 = $[72];
    let t34;
    if ($[73] !== elemAfter || $[74] !== size) {
        t34 = elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $f079422b0c2e0ccb$var$elemAfterStyles.root,
                size === "large" && $f079422b0c2e0ccb$var$elemAfterStyles.large,
                size === "small" && $f079422b0c2e0ccb$var$elemAfterStyles.small,
                $f079422b0c2e0ccb$var$topLevelSiblingStyles.root,
                $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemAfter);
        $[73] = elemAfter;
        $[74] = size;
        $[75] = t34;
    } else t34 = $[75];
    let t35;
    if ($[76] !== actions) {
        t35 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $f079422b0c2e0ccb$var$actionStyles.root,
                $f079422b0c2e0ccb$var$topLevelSiblingStyles.root,
                $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, actions);
        $[76] = actions;
        $[77] = t35;
    } else t35 = $[77];
    let t36;
    if ($[78] !== isSelected || $[79] !== t19 || $[80] !== t28 || $[81] !== t31 || $[82] !== t32 || $[83] !== t33 || $[84] !== t34 || $[85] !== t35 || $[86] !== visualContentRef) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: visualContentRef,
            "data-testid": t19,
            "data-selected": isSelected,
            className: t28
        }, t31, t32, t33, t34, t35);
        $[78] = isSelected;
        $[79] = t19;
        $[80] = t28;
        $[81] = t31;
        $[82] = t32;
        $[83] = t33;
        $[84] = t34;
        $[85] = t35;
        $[86] = visualContentRef;
        $[87] = t36;
    } else t36 = $[87];
    return t36;
} : ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, level: level = 0, size: size = 'default', noActiveBackground: noActiveBackground }, forwardedRef)=>{
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $cozmU.useRef)(null);
    const descriptionRef = (0, $cozmU.useRef)(null);
    const setDescriptionRef = (0, $cozmU.useCallback)((node)=>{
        descriptionRef.current = node;
    }, []);
    const tooltipOnClick = (0, $cozmU.useRef)(null);
    const isRichDescription = typeof description !== 'string';
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        tooltipOnClick.current?.(event);
    }, [
        onClick
    ]); /**
                  * Show the tooltip if _either_ label or description is truncated
                  */ 
    const canTooltipAppear = (0, $cozmU.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
         // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description_0 = descriptionRef.current;
        if (label && $f079422b0c2e0ccb$var$isTextClamped(label)) return true;
        return Boolean(description_0 && $f079422b0c2e0ccb$var$isTextClamped(description_0));
    }, [
        isContentTooltipDisabled
    ]); // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $17a118af00cd097a$export$f4b8e24fae579c6f);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // This extends the clickable area of nested menu items to the width
    , {
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: `calc(-1 * ${level} * ${(0, $17a118af00cd097a$export$d492445a79a49b48)})`
        },
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$textStyles.root,
            !showElemBefore && $f079422b0c2e0ccb$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1,
        color: $f079422b0c2e0ccb$var$getTextColor(isDisabled),
        ref: labelRef
    }, children), description && isRichDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: setDescriptionRef,
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$descriptionStyles.rich
        ])
    }, description) : null, description && !isRichDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
        size: "small",
        maxLines: 1,
        ref: setDescriptionRef
    }, description) : null)); /**
           *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
           *
           * Note: we also remove the `elemAfter` when showing `actionsOnHover`
           */ 
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    const isLarge = size === 'large';
    const isSmall = size === 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$containerStyles.root,
            isLarge && $f079422b0c2e0ccb$var$containerStyles.large,
            isSmall && $f079422b0c2e0ccb$var$containerStyles.small,
            isSelected && $f079422b0c2e0ccb$var$containerStyles.selected,
            $f079422b0c2e0ccb$var$containerStyles.suppressNotch,
            description && !isLarge && $f079422b0c2e0ccb$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $f079422b0c2e0ccb$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $f079422b0c2e0ccb$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $f079422b0c2e0ccb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $f079422b0c2e0ccb$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, description) : null),
        position: "right",
        component: $f079422b0c2e0ccb$var$MenuItemTooltip,
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered for the menu item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>{
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
            ...tooltipProps,
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, $6e70fa93f252879b$export$2e2bcd8739ae039)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        };
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $k12R1.cx)($f079422b0c2e0ccb$var$buttonOrAnchorStyles.root, isLarge && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.large, isSmall && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.small, $f079422b0c2e0ccb$var$topLevelSiblingStyles.root, isSelected && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.selected, noActiveBackground && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.noActiveBackground),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                textDecoration: 'none'
            },
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            draggable: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $f079422b0c2e0ccb$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $k12R1.cx)($f079422b0c2e0ccb$var$buttonOrAnchorStyles.root, isLarge && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.large, isSmall && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.small, $f079422b0c2e0ccb$var$topLevelSiblingStyles.root, isSelected && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.selected, noActiveBackground && $f079422b0c2e0ccb$var$buttonOrAnchorStyles.noActiveBackground),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }, interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$elemBeforeStyles.root,
            isLarge && $f079422b0c2e0ccb$var$elemBeforeStyles.large,
            $f079422b0c2e0ccb$var$topLevelSiblingStyles.root,
            $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$elemAfterStyles.root,
            size === 'large' && $f079422b0c2e0ccb$var$elemAfterStyles.large,
            size === 'small' && $f079422b0c2e0ccb$var$elemAfterStyles.small,
            $f079422b0c2e0ccb$var$topLevelSiblingStyles.root,
            $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $f079422b0c2e0ccb$var$actionStyles.root,
            $f079422b0c2e0ccb$var$topLevelSiblingStyles.root,
            $f079422b0c2e0ccb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions));
}; /**
    * __MenuItemBase__
    *
    * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
    *
    * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
    * This can be inferred from the type of the `onClick` prop.
    */ 
const $f079422b0c2e0ccb$export$859b390bf71e044e = (0, $876a097c74c317c3$export$8ab756e06c5d9001)($f079422b0c2e0ccb$var$MenuItemBaseNoRef);


const $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(20);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, level: t1, isADSNavigationEnabled: isADSNavigationEnabled } = t0;
    const level = t1 === undefined ? 0 : t1;
    const t2 = isDisabled ? undefined : actions;
    const t3 = isDisabled ? undefined : actionsOnHover;
    let t4;
    if ($[0] !== description || $[1] !== elemAfter || $[2] !== forwardedRef || $[3] !== interactionName || $[4] !== isContentTooltipDisabled || $[5] !== isDisabled || $[6] !== onClick || $[7] !== t2 || $[8] !== t3 || $[9] !== testId || $[10] !== visualContentRef) {
        t4 = {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            isDisabled: isDisabled,
            actions: t2,
            actionsOnHover: t3,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled
        };
        $[0] = description;
        $[1] = elemAfter;
        $[2] = forwardedRef;
        $[3] = interactionName;
        $[4] = isContentTooltipDisabled;
        $[5] = isDisabled;
        $[6] = onClick;
        $[7] = t2;
        $[8] = t3;
        $[9] = testId;
        $[10] = visualContentRef;
        $[11] = t4;
    } else t4 = $[11];
    const commonProps = t4;
    let t5;
    if ($[12] !== children || $[13] !== commonProps || $[14] !== description || $[15] !== elemBefore || $[16] !== isADSNavigationEnabled || $[17] !== level || $[18] !== listItemRef) {
        t5 = isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            ...commonProps,
            description: typeof description === "string" ? description : undefined,
            elemBefore: elemBefore
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
            ref: listItemRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
            ...commonProps,
            level: level,
            elemBefore: elemBefore
        }, children));
        $[12] = children;
        $[13] = commonProps;
        $[14] = description;
        $[15] = elemBefore;
        $[16] = isADSNavigationEnabled;
        $[17] = level;
        $[18] = listItemRef;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, level: level = 0, isADSNavigationEnabled: isADSNavigationEnabled }, forwardedRef)=>{
    const commonProps = {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        isDisabled: isDisabled,
        actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled
    };
    return isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
        ...commonProps,
        description: typeof description === 'string' ? description : undefined,
        elemBefore: elemBefore
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
        ...commonProps,
        level: level,
        elemBefore: elemBefore
    }, children));
});


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 


function $dd28783e110ce440$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $cozmU.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $dd28783e110ce440$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)($dd28783e110ce440$var$_List);



















const $9906da00f54d5fc5$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $9906da00f54d5fc5$export$8100cda602411810 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($9906da00f54d5fc5$export$728ac99b9c7eea8a);
    if (!context) throw new Error("useMenuSectionContext must be used within a MenuSection");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($9906da00f54d5fc5$export$728ac99b9c7eea8a);
    if (!context) throw new Error('useMenuSectionContext must be used within a MenuSection');
    return context;
};


const $5ac90360b1975343$export$4b1545b4f2016d26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, testId: testId, isMenuListItem: t1 } = t0;
    const isMenuListItem = t1 === undefined ? false : t1;
    const id = (0, $cozmU.useId)();
    const t2 = `${id}-heading`;
    let t3;
    if ($[0] !== children || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "group",
            "aria-labelledby": t2
        }, children);
        $[0] = children;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== id || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9906da00f54d5fc5$export$728ac99b9c7eea8a).Provider, {
            value: id
        }, t3);
        $[3] = id;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const content = t4;
    if (isMenuListItem) {
        let t5;
        if ($[6] !== content || $[7] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
                testId: testId
            }, content);
            $[6] = content;
            $[7] = testId;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    return content;
} : ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $cozmU.useId)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9906da00f54d5fc5$export$728ac99b9c7eea8a).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "group",
        "aria-labelledby": `${id}-heading`
    }, children));
    if (isMenuListItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
        testId: testId
    }, content);
    // Legacy. isMenuListItem should become default.
    return content;
};















const $d04b687461f45ce4$var$styles = {
    root: "_2sNsIgd8bj _4c065U2ADO _1UtDYzKGUX _0LQT5EgVvo"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $d04b687461f45ce4$export$5d3acdbf9237a364 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, label: label } = t0;
    const id = (0, $9906da00f54d5fc5$export$8100cda602411810)();
    const t1 = `${id}-heading`;
    let t2;
    if ($[0] !== children || $[1] !== label || $[2] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            role: "heading",
            "aria-label": label,
            "aria-level": 2,
            xcss: $d04b687461f45ce4$var$styles.root,
            id: t1
        }, children);
        $[0] = children;
        $[1] = label;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, label: label })=>{
    const id = (0, $9906da00f54d5fc5$export$8100cda602411810)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        role: "heading",
        "aria-label": label,
        "aria-level": 2,
        xcss: $d04b687461f45ce4$var$styles.root,
        id: `${id}-heading`
    }, children);
};















var $f922E = parcelRequire("f922E");
























// behavior in the ADS 'LinkMenuItem' component.
// More info: https://atlassian.slack.com/archives/C09FTFN0APN/p1770606423849489
const $28a419b1dbe61981$var$agentNameStyles = null;
const $28a419b1dbe61981$export$5489daa5a87f6f37 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, name: name } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbkfkE _2iEGP2MUDv _0hPCNLDIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== name) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, name);
        $[1] = name;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, t2, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbkfkE _2iEGP2MUDv _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, name), children);












var $34cCm = parcelRequire("34cCm");














var $huaOC = parcelRequire("huaOC");





const $b6db993145b117bf$var$listItemStyles = {
    root: "_2pQraJ0Qmj"
};
const $b6db993145b117bf$var$LinkMenuItemNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(27);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, level: t1, isADSNavigationEnabled: isADSNavigationEnabled, size: size, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled, noActiveBackground: noActiveBackground } = t0;
    const level = t1 === undefined ? 0 : t1;
    const itemRef = (0, $cozmU.useRef)(null);
    const t2 = listItemRef ?? null;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $6e70fa93f252879b$export$2e2bcd8739ae039)([
            itemRef,
            t2
        ]);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const ref = t3;
    let t4;
    if ($[2] !== actions || $[3] !== actionsOnHover || $[4] !== description || $[5] !== elemAfter || $[6] !== forwardedRef || $[7] !== href || $[8] !== interactionName || $[9] !== isContentTooltipDisabled || $[10] !== isSelected || $[11] !== onClick || $[12] !== target || $[13] !== testId || $[14] !== visualContentRef) {
        t4 = {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled
        };
        $[2] = actions;
        $[3] = actionsOnHover;
        $[4] = description;
        $[5] = elemAfter;
        $[6] = forwardedRef;
        $[7] = href;
        $[8] = interactionName;
        $[9] = isContentTooltipDisabled;
        $[10] = isSelected;
        $[11] = onClick;
        $[12] = target;
        $[13] = testId;
        $[14] = visualContentRef;
        $[15] = t4;
    } else t4 = $[15];
    const commonProps = t4;
    let t5;
    if ($[16] !== children || $[17] !== commonProps || $[18] !== description || $[19] !== elemBefore || $[20] !== isADSNavigationEnabled || $[21] !== isNewAllConversationScreenEnabled || $[22] !== level || $[23] !== noActiveBackground || $[24] !== ref || $[25] !== size) {
        t5 = isNewAllConversationScreenEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
            ref: ref,
            xcss: $b6db993145b117bf$var$listItemStyles.root
        }, /*#__PURE__*/ $cozmU.createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
            ...commonProps,
            level: level,
            size: size,
            elemBefore: elemBefore,
            noActiveBackground: noActiveBackground
        }, children)) : isADSNavigationEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $huaOC.LinkMenuItem), {
            ...commonProps,
            description: typeof description === "string" ? description : undefined,
            elemBefore: elemBefore
        }, children) : /*#__PURE__*/ $cozmU.createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
            ref: ref,
            xcss: $b6db993145b117bf$var$listItemStyles.root
        }, /*#__PURE__*/ $cozmU.createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
            ...commonProps,
            level: level,
            elemBefore: elemBefore
        }, children));
        $[16] = children;
        $[17] = commonProps;
        $[18] = description;
        $[19] = elemBefore;
        $[20] = isADSNavigationEnabled;
        $[21] = isNewAllConversationScreenEnabled;
        $[22] = level;
        $[23] = noActiveBackground;
        $[24] = ref;
        $[25] = size;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, level: level = 0, isADSNavigationEnabled: isADSNavigationEnabled, size: size, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled, noActiveBackground: noActiveBackground }, forwardedRef)=>{
    const itemRef = (0, $cozmU.useRef)(null);
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $6e70fa93f252879b$export$2e2bcd8739ae039)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    const commonProps = {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled
    };
    return isNewAllConversationScreenEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
        ref: ref,
        xcss: $b6db993145b117bf$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
        ...commonProps,
        level: level,
        size: size,
        elemBefore: elemBefore,
        noActiveBackground: noActiveBackground
    }, children)) : isADSNavigationEnabled ? //We must pass the elemBefore prop separately and cast it because the forked type definition and
    // ADS type definition COLLAPSE_ELEM_BEFORE_TYPE are each created using unique symbols
    /*#__PURE__*/ $cozmU.createElement((0, $huaOC.LinkMenuItem), {
        ...commonProps,
        description: typeof description === 'string' ? description : undefined,
        elemBefore: elemBefore
    }, children) : /*#__PURE__*/ $cozmU.createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), {
        ref: ref,
        xcss: $b6db993145b117bf$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
        ...commonProps,
        level: level,
        elemBefore: elemBefore
    }, children));
};
const $b6db993145b117bf$export$d2cad7a1cce7b35f = (0, $876a097c74c317c3$export$8ab756e06c5d9001)($b6db993145b117bf$var$LinkMenuItemNoRef);







const $c2776a64c92a83de$var$message = (0, $kSwu1.defineMessages)({
    addAgentLabel: {
        id: "ai-mate.rovo-navigation.agents-items.add-agent",
        defaultMessage: "Create agent"
    },
    viewAllAgentsLabel: {
        id: "ai-mate.rovo-navigation.agents-items.view-all",
        defaultMessage: "View all agents"
    }
});
var $c2776a64c92a83de$export$2e2bcd8739ae039 = $c2776a64c92a83de$var$message;


const $c65245c1473cf96e$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $c65245c1473cf96e$var$AGENTS_LIMIT = 5;
const $c65245c1473cf96e$export$51f0bc576d5599bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    let isFetchingRecommendedAgents;
    let onViewAllAgentsClick;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ agents: t1, isFetchingRecommendedAgents: isFetchingRecommendedAgents, onViewAllAgentsClick: onViewAllAgentsClick, showBrowseAgents: t2, ...props } = t0);
        $[0] = t0;
        $[1] = isFetchingRecommendedAgents;
        $[2] = onViewAllAgentsClick;
        $[3] = props;
        $[4] = t1;
        $[5] = t2;
    } else {
        isFetchingRecommendedAgents = $[1];
        onViewAllAgentsClick = $[2];
        props = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    const agents = t1 === undefined ? [] : t1;
    const showBrowseAgents = t2 === undefined ? true : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasAgents = agents.length > 0;
    const limitedAgents = agents.slice(0, $c65245c1473cf96e$var$AGENTS_LIMIT);
    let t3;
    if ($[6] !== onViewAllAgentsClick) {
        t3 = (e)=>{
            e.preventDefault();
            onViewAllAgentsClick?.();
        };
        $[6] = onViewAllAgentsClick;
        $[7] = t3;
    } else t3 = $[7];
    const onViewAll = t3;
    const t4 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
    const t5 = hasAgents ? limitedAgents.map((agent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c65245c1473cf96e$var$AgentMenuItem, {
            ...props,
            agent: agent,
            key: agent.id
        })) : null;
    let t6;
    if ($[8] !== isFetchingRecommendedAgents || $[9] !== limitedAgents) {
        t6 = isFetchingRecommendedAgents && Array(Math.max(0, $c65245c1473cf96e$var$AGENTS_LIMIT - limitedAgents.length)).fill(null).map($c65245c1473cf96e$var$_temp);
        $[8] = isFetchingRecommendedAgents;
        $[9] = limitedAgents;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== formatMessage || $[12] !== onViewAll || $[13] !== props || $[14] !== showBrowseAgents) {
        t7 = showBrowseAgents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
            isADSNavigationEnabled: props.isADSNavigationEnabled,
            onClick: onViewAll,
            href: "#",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: ""
            })
        }, formatMessage((0, $c2776a64c92a83de$export$2e2bcd8739ae039).viewAllAgentsLabel));
        $[11] = formatMessage;
        $[12] = onViewAll;
        $[13] = props;
        $[14] = showBrowseAgents;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t4.Fragment || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(t4.Fragment, null, t5, t6, t7);
        $[16] = t4.Fragment;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ agents: agents = [], isFetchingRecommendedAgents: isFetchingRecommendedAgents, onViewAllAgentsClick: onViewAllAgentsClick, showBrowseAgents: showBrowseAgents = true, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasAgents = agents.length > 0;
    const limitedAgents = agents.slice(0, $c65245c1473cf96e$var$AGENTS_LIMIT);
    const onViewAll = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        onViewAllAgentsClick?.();
    }, [
        onViewAllAgentsClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasAgents ? limitedAgents.map((agent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c65245c1473cf96e$var$AgentMenuItem, {
            ...props,
            agent: agent,
            key: agent.id
        })) : null, isFetchingRecommendedAgents && Array(Math.max(0, $c65245c1473cf96e$var$AGENTS_LIMIT - limitedAgents.length)).fill(null).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34cCm.AgentMenuItemSkeleton), {
            index: index,
            skeletonAvatarSize: "small",
            paddingHorizontal: "var(--ds-space-050, 4px)"
        })), showBrowseAgents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
        isADSNavigationEnabled: props.isADSNavigationEnabled,
        onClick: onViewAll,
        href: "#",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        })
    }, formatMessage((0, $c2776a64c92a83de$export$2e2bcd8739ae039).viewAllAgentsLabel)));
};
const $c65245c1473cf96e$var$AgentMenuItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { agent: agent, onSelectAgent: onSelectAgent, selectedAgent: selectedAgent, cloudId: cloudId, isADSNavigationEnabled: isADSNavigationEnabled, onConversationStarterClick: onConversationStarterClick, onDeleteAgent: onDeleteAgent } = t0;
    let t1;
    if ($[0] !== cloudId) {
        t1 = new (0, $5hJlu.default)({
            url: "/gateway/api/directory/graphql",
            productIdentifier: "rovo",
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const profileClient = t1;
    let t2;
    if ($[2] !== agent || $[3] !== isADSNavigationEnabled || $[4] !== onSelectAgent) {
        t2 = (event)=>{
            event.preventDefault();
            onSelectAgent(agent, isADSNavigationEnabled);
        };
        $[2] = agent;
        $[3] = isADSNavigationEnabled;
        $[4] = onSelectAgent;
        $[5] = t2;
    } else t2 = $[5];
    const onAgentItemClick = t2;
    const isSelected = agent.id === selectedAgent?.id;
    const t3 = agent.identity_account_id && (0, $iDrrr.fg)("rovo_agent_profile_card_relay") ? agent.identity_account_id : "";
    let t4;
    if ($[6] !== agent || $[7] !== isADSNavigationEnabled || $[8] !== onConversationStarterClick) {
        t4 = onConversationStarterClick ? (starter)=>onConversationStarterClick(agent, starter, isADSNavigationEnabled) : undefined;
        $[6] = agent;
        $[7] = isADSNavigationEnabled;
        $[8] = onConversationStarterClick;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== agent.id || $[11] !== cloudId || $[12] !== onAgentItemClick || $[13] !== onDeleteAgent || $[14] !== profileClient || $[15] !== t3 || $[16] !== t4) {
        t5 = {
            trigger: "hover",
            agentId: agent.id,
            identityAccountId: t3,
            placement: (0, $iDrrr.fg)("rovo_agent_profile_card_relay") ? "left" : undefined,
            resourceClient: profileClient,
            onConversationStartersClick: t4,
            onChatClick: onAgentItemClick,
            cloudId: cloudId,
            onDeleteAgent: onDeleteAgent
        };
        $[10] = agent.id;
        $[11] = cloudId;
        $[12] = onAgentItemClick;
        $[13] = onDeleteAgent;
        $[14] = profileClient;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    const profileCardTriggerProps = t5;
    const AgentProfileCardTrigger = (0, $iDrrr.fg)("rovo_agent_profile_card_relay") ? (0, $1EipK.AgentProfileCardWithTrigger) : (0, $eKpjD.AgentProfileCardTrigger);
    const t6 = agent.external_config_reference ?? agent.named_id;
    let t7;
    if ($[18] !== agent) {
        t7 = (0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : $c65245c1473cf96e$export$2149adda3d8a5807(agent);
        $[18] = agent;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== agent.icon || $[21] !== agent.id || $[22] !== agent.identity_account_id || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentNamedId: t6,
            agentId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "small",
            showBorder: false,
            isForgeAgent: t7,
            forgeAgentIconUrl: agent.icon
        });
        $[20] = agent.icon;
        $[21] = agent.id;
        $[22] = agent.identity_account_id;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    const elemBefore = t8;
    if (isADSNavigationEnabled) {
        let t9;
        if ($[26] !== agent) {
            t9 = (0, $iDrrr.fg)("rovo_agents_agent_verification") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c65245c1473cf96e$var$AgentName, {
                agent: agent
            }) : agent.name;
            $[26] = agent;
            $[27] = t9;
        } else t9 = $[27];
        let t10;
        if ($[28] !== agent.id || $[29] !== elemBefore || $[30] !== isADSNavigationEnabled || $[31] !== isSelected || $[32] !== onAgentItemClick || $[33] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
                isADSNavigationEnabled: isADSNavigationEnabled,
                key: agent.id,
                href: "#",
                isSelected: isSelected,
                onClick: onAgentItemClick,
                elemBefore: elemBefore
            }, t9);
            $[28] = agent.id;
            $[29] = elemBefore;
            $[30] = isADSNavigationEnabled;
            $[31] = isSelected;
            $[32] = onAgentItemClick;
            $[33] = t9;
            $[34] = t10;
        } else t10 = $[34];
        let t11;
        if ($[35] !== profileCardTriggerProps || $[36] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AgentProfileCardTrigger, profileCardTriggerProps, t10);
            $[35] = profileCardTriggerProps;
            $[36] = t10;
            $[37] = t11;
        } else t11 = $[37];
        return t11;
    }
    let t9;
    if ($[38] !== agent) {
        t9 = (0, $iDrrr.fg)("rovo_agents_agent_verification") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c65245c1473cf96e$var$AgentName, {
            agent: agent
        }) : agent.name;
        $[38] = agent;
        $[39] = t9;
    } else t9 = $[39];
    let t10;
    if ($[40] !== elemBefore || $[41] !== isSelected || $[42] !== onAgentItemClick || $[43] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
            href: "#",
            isSelected: isSelected,
            onClick: onAgentItemClick,
            elemBefore: elemBefore,
            level: 1
        }, t9);
        $[40] = elemBefore;
        $[41] = isSelected;
        $[42] = onAgentItemClick;
        $[43] = t9;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] !== profileCardTriggerProps || $[46] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AgentProfileCardTrigger, {
            ...profileCardTriggerProps,
            disabledAriaAttributes: true
        }, t10));
        $[45] = profileCardTriggerProps;
        $[46] = t10;
        $[47] = t11;
    } else t11 = $[47];
    return t11;
} : ({ agent: agent, onSelectAgent: onSelectAgent, selectedAgent: selectedAgent, cloudId: cloudId, isADSNavigationEnabled: isADSNavigationEnabled, onConversationStarterClick: onConversationStarterClick, onDeleteAgent: onDeleteAgent })=>{
    const profileClient = (0, $cozmU.useMemo)(()=>new (0, $5hJlu.default)({
            url: '/gateway/api/directory/graphql',
            productIdentifier: 'rovo',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const onAgentItemClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        onSelectAgent(agent, isADSNavigationEnabled);
    }, [
        onSelectAgent,
        agent,
        isADSNavigationEnabled
    ]);
    const isSelected = agent.id === selectedAgent?.id;
    const profileCardTriggerProps = {
        trigger: 'hover',
        agentId: agent.id,
        identityAccountId: agent.identity_account_id && (0, $iDrrr.fg)('rovo_agent_profile_card_relay') ? agent.identity_account_id : '',
        placement: (0, $iDrrr.fg)('rovo_agent_profile_card_relay') ? 'left' : undefined,
        resourceClient: profileClient,
        onConversationStartersClick: onConversationStarterClick ? (starter)=>onConversationStarterClick(agent, starter, isADSNavigationEnabled) : undefined,
        onChatClick: onAgentItemClick,
        cloudId: cloudId,
        onDeleteAgent: onDeleteAgent
    };
    const AgentProfileCardTrigger = (0, $iDrrr.fg)('rovo_agent_profile_card_relay') ? (0, $1EipK.AgentProfileCardWithTrigger) : (0, $eKpjD.AgentProfileCardTrigger);
    const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : $c65245c1473cf96e$export$2149adda3d8a5807(agent),
        forgeAgentIconUrl: agent.icon
    }); // When ADS navigation is enabled, use the standard LinkMenuItem structure
    if (isADSNavigationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AgentProfileCardTrigger, profileCardTriggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        key: agent.id,
        href: "#",
        isSelected: isSelected,
        onClick: onAgentItemClick,
        elemBefore: elemBefore
    }, (0, $iDrrr.fg)('rovo_agents_agent_verification') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c65245c1473cf96e$var$AgentName, {
        agent: agent
    }) : agent.name));
     // When not using ADS navigation, wrap AgentProfileCardTrigger inside ListItem
    // to ensure the profile card trigger's wrapper span is inside the listitem,
    // not a direct child of the list (which would violate ARIA list semantics).
    // We also disable ARIA attributes on the trigger's wrapper span because
    // aria-expanded is not allowed on span elements.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AgentProfileCardTrigger, {
        ...profileCardTriggerProps,
        disabledAriaAttributes: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
        href: "#",
        isSelected: isSelected,
        onClick: onAgentItemClick,
        elemBefore: elemBefore,
        level: 1
    }, (0, $iDrrr.fg)('rovo_agents_agent_verification') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c65245c1473cf96e$var$AgentName, {
        agent: agent
    }) : agent.name)));
};
const $c65245c1473cf96e$var$AgentName = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { agent: agent } = t0;
    let t1;
    if ($[0] !== agent.is_verified) {
        t1 = agent.is_verified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), null) : null;
        $[0] = agent.is_verified;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== agent.name || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28a419b1dbe61981$export$5489daa5a87f6f37), {
            name: agent.name
        }, t1);
        $[2] = agent.name;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ agent: agent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28a419b1dbe61981$export$5489daa5a87f6f37), {
        name: agent.name
    }, agent.is_verified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), null) : null);
function $c65245c1473cf96e$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34cCm.AgentMenuItemSkeleton), {
        index: index,
        skeletonAvatarSize: "small",
        paddingHorizontal: "var(--ds-space-050, 4px)"
    });
}
























var $4MnFz = parcelRequire("4MnFz");





var $lW3nu = parcelRequire("lW3nu");


var $5P5VV = parcelRequire("5P5VV");





var $9d7Pd = parcelRequire("9d7Pd");



































































































var $6IL1T = parcelRequire("6IL1T");










const $0f12690f4014ce16$var$messages = (0, $kSwu1.defineMessages)({
    moreMenuRenameLabel: {
        id: "rovo-platform-ui-components.chat-list.moreMenuRenameLabel",
        defaultMessage: "Rename"
    },
    moreMenuDeleteLabel: {
        id: "rovo-platform-ui-components.chat-list.moreMenuDeleteLabel",
        defaultMessage: "Delete"
    },
    moreBtnLabel: {
        id: "rovo-platform-ui-components.chat-list.moreBtnLabel",
        defaultMessage: "More actions"
    },
    renameInputLabel: {
        id: "rovo-platform-ui-components.chat-list.renameInputLabel",
        defaultMessage: "Edit chat name"
    },
    confirmRenameLabel: {
        id: "rovo-platform-ui-components.chat-list.confirmRenameLabel",
        defaultMessage: "Confirm rename"
    },
    cancelRenameLabel: {
        id: "rovo-platform-ui-components.chat-list.cancelRenameLabel",
        defaultMessage: "Cancel rename"
    }
});
var $0f12690f4014ce16$export$2e2bcd8739ae039 = $0f12690f4014ce16$var$messages;


const $197635bcddff2f9b$var$POPUP_Z_INDEX = 600;
const $197635bcddff2f9b$var$styles = {
    renameForm: "_30huDKjg0e _3iDTPbQ4SZ",
    innerForm: "_2mHwu81Y8M _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT",
    textFieldContainer: "_2O5Vij7dHp _3138424F84",
    textField: "_2sNsIgmnOE _30huDKS6k6 _0bjKvDKxmn _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _24h04i2Njc _1kk5Tkf7mX _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6Q1Y8M _0xkEdpnXvL _0ui43C2Bgz"
};
const $197635bcddff2f9b$export$8a74b6c2b6abee5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(106);
    const { name: name, elemBefore: elemBefore, description: description, elemAfter: elemAfter, isSelected: isSelected, size: size, onSelect: onSelect, onRename: onRename, onDelete: onDelete, moreMenuItems: moreMenuItems, isMoreMenuOpen: isMoreMenuOpenProp, onMoreMenuOpenChange: onMoreMenuOpenChange, renderContainer: renderContainer, afterContent: afterContent, testId: t1, renameLabel: renameLabelProp, deleteLabel: deleteLabelProp, moreButtonLabel: moreButtonLabelProp, renameInputLabel: renameInputLabelProp, confirmRenameLabel: confirmRenameLabelProp, cancelRenameLabel: cancelRenameLabelProp } = t0;
    const testId = t1 === undefined ? "chat-list-item" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [uncontrolledIsMoreMenuOpen, setUncontrolledIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [localName, setLocalName] = (0, $cozmU.useState)(name);
    const [usingLocalName, setUsingLocalName] = (0, $cozmU.useState)(false);
    const [shouldRestoreFocusToMoreButton, setShouldRestoreFocusToMoreButton] = (0, $cozmU.useState)(false);
    const formRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useRef)(null);
    const isMoreMenuOpen = isMoreMenuOpenProp ?? uncontrolledIsMoreMenuOpen;
    const wasMoreMenuOpenRef = (0, $cozmU.useRef)(isMoreMenuOpen);
    let t2;
    if ($[0] !== isMoreMenuOpenProp || $[1] !== onMoreMenuOpenChange) {
        t2 = (nextIsOpen)=>{
            if (isMoreMenuOpenProp === undefined) setUncontrolledIsMoreMenuOpen(nextIsOpen);
            onMoreMenuOpenChange?.(nextIsOpen);
        };
        $[0] = isMoreMenuOpenProp;
        $[1] = onMoreMenuOpenChange;
        $[2] = t2;
    } else t2 = $[2];
    const setIsMoreMenuOpen = t2;
    let t3;
    if ($[3] !== formatMessage || $[4] !== renameLabelProp) {
        t3 = renameLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).moreMenuRenameLabel);
        $[3] = formatMessage;
        $[4] = renameLabelProp;
        $[5] = t3;
    } else t3 = $[5];
    const resolvedRenameLabel = t3;
    let t4;
    if ($[6] !== deleteLabelProp || $[7] !== formatMessage) {
        t4 = deleteLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).moreMenuDeleteLabel);
        $[6] = deleteLabelProp;
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    const resolvedDeleteLabel = t4;
    let t5;
    if ($[9] !== formatMessage || $[10] !== moreButtonLabelProp) {
        t5 = moreButtonLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).moreBtnLabel);
        $[9] = formatMessage;
        $[10] = moreButtonLabelProp;
        $[11] = t5;
    } else t5 = $[11];
    const resolvedMoreBtnLabel = t5;
    let t6;
    if ($[12] !== formatMessage || $[13] !== renameInputLabelProp) {
        t6 = renameInputLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).renameInputLabel);
        $[12] = formatMessage;
        $[13] = renameInputLabelProp;
        $[14] = t6;
    } else t6 = $[14];
    const resolvedRenameInputLabel = t6;
    let t7;
    if ($[15] !== confirmRenameLabelProp || $[16] !== formatMessage) {
        t7 = confirmRenameLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).confirmRenameLabel);
        $[15] = confirmRenameLabelProp;
        $[16] = formatMessage;
        $[17] = t7;
    } else t7 = $[17];
    const resolvedConfirmRenameLabel = t7;
    let t8;
    if ($[18] !== cancelRenameLabelProp || $[19] !== formatMessage) {
        t8 = cancelRenameLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).cancelRenameLabel);
        $[18] = cancelRenameLabelProp;
        $[19] = formatMessage;
        $[20] = t8;
    } else t8 = $[20];
    const resolvedCancelRenameLabel = t8;
    let t9;
    if ($[21] !== isMoreMenuOpen || $[22] !== setIsMoreMenuOpen) {
        t9 = (event)=>{
            moreButtonRef.current = event.currentTarget;
            setIsMoreMenuOpen(!isMoreMenuOpen);
        };
        $[21] = isMoreMenuOpen;
        $[22] = setIsMoreMenuOpen;
        $[23] = t9;
    } else t9 = $[23];
    const handleToggleMoreMenu = t9;
    let t10;
    if ($[24] !== setIsMoreMenuOpen) {
        t10 = ()=>{
            setIsMoreMenuOpen(false);
        };
        $[24] = setIsMoreMenuOpen;
        $[25] = t10;
    } else t10 = $[25];
    const handleCloseMoreMenu = t10;
    let t11;
    let t12;
    if ($[26] !== isMoreMenuOpen) {
        t11 = ()=>{
            const wasMoreMenuOpen = wasMoreMenuOpenRef.current;
            wasMoreMenuOpenRef.current = isMoreMenuOpen;
            if (wasMoreMenuOpen && !isMoreMenuOpen && document.activeElement === document.body) moreButtonRef.current?.focus();
        };
        t12 = [
            isMoreMenuOpen
        ];
        $[26] = isMoreMenuOpen;
        $[27] = t11;
        $[28] = t12;
    } else {
        t11 = $[27];
        t12 = $[28];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[29] !== name || $[30] !== setIsMoreMenuOpen) {
        t13 = ()=>{
            setIsMoreMenuOpen(false);
            setLocalName(name);
            setIsEditing(true);
        };
        $[29] = name;
        $[30] = setIsMoreMenuOpen;
        $[31] = t13;
    } else t13 = $[31];
    const onRenameBtnClicked = t13;
    let t14;
    if ($[32] !== onDelete || $[33] !== setIsMoreMenuOpen) {
        t14 = ()=>{
            setIsMoreMenuOpen(false);
            moreButtonRef.current?.focus();
            onDelete?.();
        };
        $[32] = onDelete;
        $[33] = setIsMoreMenuOpen;
        $[34] = t14;
    } else t14 = $[34];
    const onDeleteBtnClicked = t14;
    const isMountedRef = (0, $cozmU.useRef)(true);
    let t15;
    let t16;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            isMountedRef.current = true;
            return ()=>{
                isMountedRef.current = false;
            };
        };
        t16 = [];
        $[35] = t15;
        $[36] = t16;
    } else {
        t15 = $[35];
        t16 = $[36];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    if ($[37] !== localName || $[38] !== onRename) {
        t17 = async (value)=>{
            const prevName = localName;
            setIsEditing(false);
            setLocalName(value);
            setUsingLocalName(true);
            const result = await onRename?.(value);
            if (!isMountedRef.current) return;
            if (result && "error" in result) {
                setLocalName(prevName);
                setUsingLocalName(false);
            }
        };
        $[37] = localName;
        $[38] = onRename;
        $[39] = t17;
    } else t17 = $[39];
    const onSubmitRename = t17;
    let t18;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = ()=>{
            setShouldRestoreFocusToMoreButton(true);
            setIsEditing(false);
        };
        $[40] = t18;
    } else t18 = $[40];
    const onCancelRename = t18;
    let t19;
    let t20;
    if ($[41] !== localName || $[42] !== name || $[43] !== usingLocalName) {
        t19 = ()=>{
            if (!usingLocalName) setLocalName(name);
            else if (name === localName) setUsingLocalName(false);
        };
        t20 = [
            name,
            usingLocalName,
            localName
        ];
        $[41] = localName;
        $[42] = name;
        $[43] = usingLocalName;
        $[44] = t19;
        $[45] = t20;
    } else {
        t19 = $[44];
        t20 = $[45];
    }
    (0, $cozmU.useEffect)(t19, t20);
    let t21;
    let t22;
    if ($[46] !== isEditing) {
        t21 = ()=>{
            if (!isEditing) return;
            inputRef.current?.focus();
        };
        t22 = [
            isEditing
        ];
        $[46] = isEditing;
        $[47] = t21;
        $[48] = t22;
    } else {
        t21 = $[47];
        t22 = $[48];
    }
    (0, $cozmU.useEffect)(t21, t22);
    let t23;
    let t24;
    if ($[49] !== isEditing || $[50] !== shouldRestoreFocusToMoreButton) {
        t23 = ()=>{
            if (isEditing || !shouldRestoreFocusToMoreButton) return;
            setShouldRestoreFocusToMoreButton(false);
            moreButtonRef.current?.focus();
        };
        t24 = [
            isEditing,
            shouldRestoreFocusToMoreButton
        ];
        $[49] = isEditing;
        $[50] = shouldRestoreFocusToMoreButton;
        $[51] = t23;
        $[52] = t24;
    } else {
        t23 = $[51];
        t24 = $[52];
    }
    (0, $cozmU.useEffect)(t23, t24);
    let t25;
    let t26;
    if ($[53] !== isEditing) {
        t25 = ()=>{
            if (!isEditing) return;
            const handleClickOutside = (event_0)=>{
                if (formRef.current && !formRef.current.contains(event_0.target)) onCancelRename();
            };
            const unbind = (0, $cbY7C.bind)(window, {
                type: "mousedown",
                listener: handleClickOutside,
                options: {
                    capture: true
                }
            });
            return unbind;
        };
        t26 = [
            isEditing,
            onCancelRename
        ];
        $[53] = isEditing;
        $[54] = t25;
        $[55] = t26;
    } else {
        t25 = $[54];
        t26 = $[55];
    }
    (0, $cozmU.useEffect)(t25, t26);
    const hasMoreMenu = Boolean(onRename || onDelete || moreMenuItems);
    let t27;
    if ($[56] !== handleCloseMoreMenu || $[57] !== handleToggleMoreMenu || $[58] !== hasMoreMenu || $[59] !== isMoreMenuOpen || $[60] !== moreMenuItems || $[61] !== onDelete || $[62] !== onDeleteBtnClicked || $[63] !== onRename || $[64] !== onRenameBtnClicked || $[65] !== resolvedDeleteLabel || $[66] !== resolvedMoreBtnLabel || $[67] !== resolvedRenameLabel || $[68] !== shouldRestoreFocusToMoreButton || $[69] !== testId) {
        t27 = hasMoreMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            testId: `${testId}-more-popup`,
            isOpen: isMoreMenuOpen,
            onClose: handleCloseMoreMenu,
            zIndex: $197635bcddff2f9b$var$POPUP_Z_INDEX,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, onRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    testId: `${testId}-rename`,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                        label: ""
                    }),
                    onClick: onRenameBtnClicked
                }, resolvedRenameLabel), moreMenuItems, onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    testId: `${testId}-delete`,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                        label: "",
                        color: "var(--ds-icon-danger, #C9372C)"
                    }),
                    onClick: onDeleteBtnClicked
                }, resolvedDeleteLabel)),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    ...triggerProps,
                    autoFocus: shouldRestoreFocusToMoreButton,
                    testId: `${testId}-more`,
                    icon: $197635bcddff2f9b$var$_temp,
                    appearance: "subtle",
                    spacing: "compact",
                    onClick: handleToggleMoreMenu,
                    label: resolvedMoreBtnLabel
                }),
            placement: "bottom-end"
        }) : null;
        $[56] = handleCloseMoreMenu;
        $[57] = handleToggleMoreMenu;
        $[58] = hasMoreMenu;
        $[59] = isMoreMenuOpen;
        $[60] = moreMenuItems;
        $[61] = onDelete;
        $[62] = onDeleteBtnClicked;
        $[63] = onRename;
        $[64] = onRenameBtnClicked;
        $[65] = resolvedDeleteLabel;
        $[66] = resolvedMoreBtnLabel;
        $[67] = resolvedRenameLabel;
        $[68] = shouldRestoreFocusToMoreButton;
        $[69] = testId;
        $[70] = t27;
    } else t27 = $[70];
    const moreMenu = t27;
    let t28;
    if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = (0, $hekY6.default)([
            $197635bcddff2f9b$var$styles.renameForm
        ]);
        $[71] = t28;
    } else t28 = $[71];
    let t29;
    if ($[72] !== onSubmitRename) {
        t29 = (data)=>{
            onSubmitRename(data.chatName);
        };
        $[72] = onSubmitRename;
        $[73] = t29;
    } else t29 = $[73];
    let t30;
    if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = {
            class: $197635bcddff2f9b$var$styles.innerForm
        };
        $[74] = t30;
    } else t30 = $[74];
    let t31;
    if ($[75] !== resolvedRenameInputLabel || $[76] !== testId) {
        t31 = (t32)=>{
            const { fieldProps: fieldProps } = t32;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
                ...fieldProps,
                ref: inputRef,
                "aria-label": resolvedRenameInputLabel,
                onKeyDown: (e)=>{
                    if (e.key === "Escape") onCancelRename();
                },
                "data-testid": `${testId}-name-edit`,
                className: (0, $hekY6.default)([
                    $197635bcddff2f9b$var$styles.textField
                ])
            });
        };
        $[75] = resolvedRenameInputLabel;
        $[76] = testId;
        $[77] = t31;
    } else t31 = $[77];
    let t32;
    if ($[78] !== localName || $[79] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $197635bcddff2f9b$var$styles.textFieldContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "chatName",
            defaultValue: localName
        }, t31));
        $[78] = localName;
        $[79] = t31;
        $[80] = t32;
    } else t32 = $[80];
    const t33 = `${testId}-rename-confirm`;
    let t34;
    if ($[81] !== resolvedConfirmRenameLabel || $[82] !== t33) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $197635bcddff2f9b$var$_temp2,
            type: "submit",
            appearance: "subtle",
            shape: "circle",
            spacing: "compact",
            label: resolvedConfirmRenameLabel,
            testId: t33
        });
        $[81] = resolvedConfirmRenameLabel;
        $[82] = t33;
        $[83] = t34;
    } else t34 = $[83];
    const t35 = `${testId}-rename-cancel`;
    let t36;
    if ($[84] !== resolvedCancelRenameLabel || $[85] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $197635bcddff2f9b$var$_temp3,
            type: "button",
            onClick: onCancelRename,
            appearance: "subtle",
            shape: "circle",
            spacing: "compact",
            label: resolvedCancelRenameLabel,
            testId: t35
        });
        $[84] = resolvedCancelRenameLabel;
        $[85] = t35;
        $[86] = t36;
    } else t36 = $[86];
    let t37;
    if ($[87] !== t29 || $[88] !== t32 || $[89] !== t34 || $[90] !== t36) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: formRef,
            className: t28
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: t29,
            formProps: t30
        }, t32, t34, t36));
        $[87] = t29;
        $[88] = t32;
        $[89] = t34;
        $[90] = t36;
        $[91] = t37;
    } else t37 = $[91];
    const renameForm = t37;
    if (isEditing) return renameForm;
    const displayName = usingLocalName ? localName : name;
    const t38 = moreMenu ?? undefined;
    let t39;
    if ($[92] !== description || $[93] !== displayName || $[94] !== elemAfter || $[95] !== elemBefore || $[96] !== isSelected || $[97] !== onSelect || $[98] !== renderContainer || $[99] !== size || $[100] !== t38 || $[101] !== testId) {
        t39 = renderContainer({
            children: displayName,
            elemBefore: elemBefore,
            description: description,
            elemAfter: elemAfter,
            actionsOnHover: t38,
            isSelected: isSelected,
            onClick: onSelect,
            size: size,
            testId: testId
        });
        $[92] = description;
        $[93] = displayName;
        $[94] = elemAfter;
        $[95] = elemBefore;
        $[96] = isSelected;
        $[97] = onSelect;
        $[98] = renderContainer;
        $[99] = size;
        $[100] = t38;
        $[101] = testId;
        $[102] = t39;
    } else t39 = $[102];
    let t40;
    if ($[103] !== afterContent || $[104] !== t39) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t39, afterContent);
        $[103] = afterContent;
        $[104] = t39;
        $[105] = t40;
    } else t40 = $[105];
    return t40;
} : ({ id: id, name: name, elemBefore: elemBefore, description: description, elemAfter: elemAfter, isSelected: isSelected, size: size, onSelect: onSelect, onRename: onRename, onDelete: onDelete, moreMenuItems: moreMenuItems, isMoreMenuOpen: isMoreMenuOpenProp, onMoreMenuOpenChange: onMoreMenuOpenChange, renderContainer: renderContainer, afterContent: afterContent, testId: testId = 'chat-list-item', renameLabel: renameLabelProp, deleteLabel: deleteLabelProp, moreButtonLabel: moreButtonLabelProp, renameInputLabel: renameInputLabelProp, confirmRenameLabel: confirmRenameLabelProp, cancelRenameLabel: cancelRenameLabelProp })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [uncontrolledIsMoreMenuOpen, setUncontrolledIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [localName, setLocalName] = (0, $cozmU.useState)(name);
    const [usingLocalName, setUsingLocalName] = (0, $cozmU.useState)(false);
    const [shouldRestoreFocusToMoreButton, setShouldRestoreFocusToMoreButton] = (0, $cozmU.useState)(false);
    const formRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useRef)(null);
    const isMoreMenuOpen = isMoreMenuOpenProp ?? uncontrolledIsMoreMenuOpen;
    const wasMoreMenuOpenRef = (0, $cozmU.useRef)(isMoreMenuOpen);
    const setIsMoreMenuOpen = (0, $cozmU.useCallback)((nextIsOpen)=>{
        if (isMoreMenuOpenProp === undefined) setUncontrolledIsMoreMenuOpen(nextIsOpen);
        onMoreMenuOpenChange?.(nextIsOpen);
    }, [
        isMoreMenuOpenProp,
        onMoreMenuOpenChange
    ]); // ── Resolved labels ──────────────────────────────────────────────────
    const resolvedRenameLabel = renameLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).moreMenuRenameLabel);
    const resolvedDeleteLabel = deleteLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).moreMenuDeleteLabel);
    const resolvedMoreBtnLabel = moreButtonLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).moreBtnLabel);
    const resolvedRenameInputLabel = renameInputLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).renameInputLabel);
    const resolvedConfirmRenameLabel = confirmRenameLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).confirmRenameLabel);
    const resolvedCancelRenameLabel = cancelRenameLabelProp ?? formatMessage((0, $0f12690f4014ce16$export$2e2bcd8739ae039).cancelRenameLabel); // ── More-menu handlers ───────────────────────────────────────────────
    const handleToggleMoreMenu = (0, $cozmU.useCallback)((event)=>{
        moreButtonRef.current = event.currentTarget;
        setIsMoreMenuOpen(!isMoreMenuOpen);
    }, [
        isMoreMenuOpen,
        setIsMoreMenuOpen
    ]);
    const handleCloseMoreMenu = (0, $cozmU.useCallback)(()=>{
        setIsMoreMenuOpen(false);
    }, [
        setIsMoreMenuOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const wasMoreMenuOpen = wasMoreMenuOpenRef.current;
        wasMoreMenuOpenRef.current = isMoreMenuOpen;
        if (wasMoreMenuOpen && !isMoreMenuOpen && document.activeElement === document.body) moreButtonRef.current?.focus();
    }, [
        isMoreMenuOpen
    ]);
    const onRenameBtnClicked = (0, $cozmU.useCallback)(()=>{
        setIsMoreMenuOpen(false);
        setLocalName(name);
        setIsEditing(true);
    }, [
        name,
        setIsMoreMenuOpen
    ]);
    const onDeleteBtnClicked = (0, $cozmU.useCallback)(()=>{
        setIsMoreMenuOpen(false); // Seed modal return-focus target with the originating "More" trigger.
        moreButtonRef.current?.focus();
        onDelete?.();
    }, [
        onDelete,
        setIsMoreMenuOpen
    ]); // ── Rename handlers ──────────────────────────────────────────────────
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const onSubmitRename = (0, $cozmU.useCallback)(async (value)=>{
        const prevName = localName;
        setIsEditing(false);
        setLocalName(value);
        setUsingLocalName(true);
        const result = await onRename?.(value);
        if (!isMountedRef.current) return;
        if (result && 'error' in result) {
            // On error, revert and return authority to the parent prop immediately
            setLocalName(prevName);
            setUsingLocalName(false);
        }
    }, [
        localName,
        onRename
    ]);
    const onCancelRename = (0, $cozmU.useCallback)(()=>{
        setShouldRestoreFocusToMoreButton(true);
        setIsEditing(false);
    }, []); // Sync external name prop changes → localName.
    // While usingLocalName is true (optimistic rename in flight), we trust our local value.
    // Once the parent prop catches up to our local value, we hand authority back to the parent.
    (0, $cozmU.useEffect)(()=>{
        if (!usingLocalName) setLocalName(name);
        else if (name === localName) // Parent confirmed the rename — hand authority back
        setUsingLocalName(false);
    }, [
        name,
        usingLocalName,
        localName
    ]); // Focus the input when editing starts
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) return;
        inputRef.current?.focus();
    }, [
        isEditing
    ]); // Restore focus to the more button after rename cancel
    (0, $cozmU.useEffect)(()=>{
        if (isEditing || !shouldRestoreFocusToMoreButton) return;
        setShouldRestoreFocusToMoreButton(false); // Explicitly call .focus() — autoFocus alone is not reliable across all
        // IconButton implementations.
        moreButtonRef.current?.focus();
    }, [
        isEditing,
        shouldRestoreFocusToMoreButton
    ]); // Close the rename form when the user clicks outside
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) return;
        const handleClickOutside = (event_0)=>{
            if (formRef.current && !formRef.current.contains(event_0.target)) onCancelRename();
        };
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'mousedown',
            listener: handleClickOutside,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isEditing,
        onCancelRename
    ]); // ── Determine if more menu should show ───────────────────────────────
    const hasMoreMenu = Boolean(onRename || onDelete || moreMenuItems); // ── More-menu popup ──────────────────────────────────────────────────
    const moreMenu = hasMoreMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        testId: `${testId}-more-popup`,
        isOpen: isMoreMenuOpen,
        onClose: handleCloseMoreMenu,
        zIndex: $197635bcddff2f9b$var$POPUP_Z_INDEX,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, onRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${testId}-rename`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: ""
                }),
                onClick: onRenameBtnClicked
            }, resolvedRenameLabel), moreMenuItems, onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${testId}-delete`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                onClick: onDeleteBtnClicked
            }, resolvedDeleteLabel)),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                autoFocus: shouldRestoreFocusToMoreButton,
                testId: `${testId}-more`,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        label: "",
                        size: "small"
                    }),
                appearance: "subtle",
                spacing: "compact",
                onClick: handleToggleMoreMenu,
                label: resolvedMoreBtnLabel
            }),
        placement: "bottom-end"
    }) : null; // ── Rename form ──────────────────────────────────────────────────────
    const renameForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: formRef,
        className: (0, $hekY6.default)([
            $197635bcddff2f9b$var$styles.renameForm
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: (data)=>{
            onSubmitRename(data.chatName);
        },
        formProps: {
            class: $197635bcddff2f9b$var$styles.innerForm
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $197635bcddff2f9b$var$styles.textFieldContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "chatName",
        defaultValue: localName
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            ...fieldProps,
            ref: inputRef,
            "aria-label": resolvedRenameInputLabel,
            onKeyDown: (e)=>{
                if (e.key === 'Escape') onCancelRename();
            },
            "data-testid": `${testId}-name-edit`,
            className: (0, $hekY6.default)([
                $197635bcddff2f9b$var$styles.textField
            ])
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                ...iconProps,
                color: "var(--ds-icon-accent-green, #22A06B)"
            }),
        type: "submit",
        appearance: "subtle",
        shape: "circle",
        spacing: "compact",
        label: resolvedConfirmRenameLabel,
        testId: `${testId}-rename-confirm`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                color: "var(--ds-icon-accent-red, #C9372C)"
            }),
        type: "button",
        onClick: onCancelRename,
        appearance: "subtle",
        shape: "circle",
        spacing: "compact",
        label: resolvedCancelRenameLabel,
        testId: `${testId}-rename-cancel`
    }))); // ── Render ────────────────────────────────────────────────────────────
    if (isEditing) return renameForm;
    const displayName = usingLocalName ? localName : name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderContainer({
        children: displayName,
        elemBefore: elemBefore,
        description: description,
        elemAfter: elemAfter,
        actionsOnHover: moreMenu ?? undefined,
        isSelected: isSelected,
        onClick: onSelect,
        size: size,
        testId: testId
    }), afterContent);
};
function $197635bcddff2f9b$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "",
        size: "small"
    });
}
function $197635bcddff2f9b$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        ...iconProps,
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}
function $197635bcddff2f9b$var$_temp3(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}


















// Stable error code the backend returns for a pin-limit rejection (see
// ConversationChannelPinnedLimitExceededException). Detection keys off this rather than the
// human-readable message, which is brittle.
const $dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_ERROR_CODE = 'convoai.rest.pinned.conversation.limit.exceeded';
const $dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_VALUE_PATTERN = /\b(\d+)\b/g;
const $dda2afeb0cbe58b3$var$PIN_LIMIT_POPUP_AUTO_DISMISS_MS = 5000;
const $dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_CONFIG = 'convo_ai_pinned_conversation_limit';
const $dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_CONFIG_VALUE_FIELD = 'value';
const $dda2afeb0cbe58b3$var$DEFAULT_MAX_PINNED_CONVERSATIONS = 10;
const $dda2afeb0cbe58b3$var$MIN_PINNED_CONVERSATIONS_LIMIT = 1;
const $dda2afeb0cbe58b3$var$MAX_PINNED_CONVERSATIONS_LIMIT = 10;
const $dda2afeb0cbe58b3$export$fdcfe20cc5094d0a = (error)=>{
    const errorAttributes = error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes : typeof error === 'object' && error !== null && 'errorAttributes' in error ? error.errorAttributes : undefined;
    if (errorAttributes?.errorCode !== $dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_ERROR_CODE) return undefined;
    // Best-effort: pull the limit out of the message for display only. Detection does not depend
    // on it, so a message change can't break the popup.
    const matches = (errorAttributes.rawErrorMessage ?? '').match($dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_VALUE_PATTERN);
    const limitValue = matches?.[matches.length - 1];
    const limit = limitValue !== undefined ? Number(limitValue) : Number.NaN;
    return Number.isFinite(limit) ? {
        maxPinnedConversations: limit
    } : {};
};
/**
 * Resolves the effective pinned state for a conversation, preferring an in-flight optimistic toggle
 * while it is still based on the current server value, otherwise using the server value.
 */ const $dda2afeb0cbe58b3$var$resolveIsPinned = (conversation, optimisticState)=>{
    const serverPinned = conversation.isPinned === true;
    if (optimisticState && optimisticState.basedOnServerPinned === serverPinned) return optimisticState.isPinned;
    return serverPinned;
};
const $dda2afeb0cbe58b3$var$getConversationTimestamp = (timestamp)=>{
    if (!timestamp) return undefined;
    const time = new Date(timestamp).getTime();
    return Number.isNaN(time) ? undefined : time;
};
const $dda2afeb0cbe58b3$var$compareConversationsByPinnedAt = (a, b)=>{
    const aPinnedAt = $dda2afeb0cbe58b3$var$getConversationTimestamp(a.pinnedAt);
    const bPinnedAt = $dda2afeb0cbe58b3$var$getConversationTimestamp(b.pinnedAt);
    if (aPinnedAt === undefined && bPinnedAt === undefined) return 0;
    if (aPinnedAt === undefined) return 1;
    if (bPinnedAt === undefined) return -1;
    return bPinnedAt - aPinnedAt;
};
const $dda2afeb0cbe58b3$var$compareConversationsByPinnedState = (a, b)=>{
    if (a.isPinned === b.isPinned) {
        if (a.isPinned && b.isPinned) return $dda2afeb0cbe58b3$var$compareConversationsByPinnedAt(a, b);
        return 0;
    }
    return a.isPinned ? -1 : 1;
};
const $dda2afeb0cbe58b3$var$getOptimisticPinnedAt = (conversations)=>{
    const newestKnownPinnedAt = conversations.reduce((newestPinnedAt, conversation)=>{
        const pinnedAt = $dda2afeb0cbe58b3$var$getConversationTimestamp(conversation.pinnedAt);
        if (pinnedAt === undefined) return newestPinnedAt;
        return Math.max(newestPinnedAt, pinnedAt);
    }, 0);
    return new Date(Math.max(Date.now(), newestKnownPinnedAt + 1)).toISOString();
};
const $dda2afeb0cbe58b3$var$clampPinnedConversationLimit = (limit)=>Number.isFinite(limit) ? Math.min($dda2afeb0cbe58b3$var$MAX_PINNED_CONVERSATIONS_LIMIT, Math.max($dda2afeb0cbe58b3$var$MIN_PINNED_CONVERSATIONS_LIMIT, limit)) : $dda2afeb0cbe58b3$var$DEFAULT_MAX_PINNED_CONVERSATIONS;
const $dda2afeb0cbe58b3$var$getMaxPinnedConversations = ()=>$dda2afeb0cbe58b3$var$clampPinnedConversationLimit((0, $cXtTj.default).getExperimentValue($dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_CONFIG, $dda2afeb0cbe58b3$var$PINNED_CONVERSATION_LIMIT_CONFIG_VALUE_FIELD, $dda2afeb0cbe58b3$var$DEFAULT_MAX_PINNED_CONVERSATIONS));
const $dda2afeb0cbe58b3$var$getPinnedConversationCount = (conversations, optimisticPinnedByConversationId)=>{
    const pinnedStateByLogicalConversationId = new Map();
    for (const conversation of conversations)pinnedStateByLogicalConversationId.set(conversation.backendConversationId ?? conversation.id, $dda2afeb0cbe58b3$var$resolveIsPinned(conversation, optimisticPinnedByConversationId[conversation.id]));
    return Array.from(pinnedStateByLogicalConversationId.values()).filter(Boolean).length;
};
/**
 * Net change in the pinned count implied by in-flight optimistic toggles, relative to the
 * server-synced state of the locally-known conversations. Layered on top of the backend's
 * authoritative count so the pinned-limit gate reflects toggles that haven't been reconciled yet.
 */ const $dda2afeb0cbe58b3$var$getOptimisticPinnedDelta = (conversations, optimisticPinnedByConversationId)=>{
    let delta = 0;
    for (const conversation of conversations){
        const optimisticState = optimisticPinnedByConversationId[conversation.id];
        if (!optimisticState) continue;
        const serverPinned = conversation.isPinned === true;
        // Ignore stale optimistic entries whose basis no longer matches the server.
        if (optimisticState.basedOnServerPinned !== serverPinned) continue;
        if (optimisticState.isPinned && !serverPinned) delta += 1;
        else if (!optimisticState.isPinned && serverPinned) delta -= 1;
    }
    return delta;
};
const $dda2afeb0cbe58b3$export$8ff043454eb02908 = ({ conversations: conversations, pinnedCountConversations: pinnedCountConversations, pinnedConversationSummary: pinnedConversationSummary, isPinnedChatsEnabled: isPinnedChatsEnabled, onConversationPinToggle: onConversationPinToggle, onBeforeOptimisticStateChange: onBeforeOptimisticStateChange, getConversationForPinToggle: getConversationForPinToggle })=>{
    const [optimisticPinnedByConversationId, setOptimisticPinnedByConversationId] = (0, $cozmU.useState)({});
    const [pinLimitError, setPinLimitError] = (0, $cozmU.useState)(null);
    const isConversationPinned = (0, $cozmU.useCallback)((conversation)=>isPinnedChatsEnabled && $dda2afeb0cbe58b3$var$resolveIsPinned(conversation, optimisticPinnedByConversationId[conversation.id]), [
        isPinnedChatsEnabled,
        optimisticPinnedByConversationId
    ]);
    const handleConversationPinToggle = (0, $cozmU.useCallback)((conversation_0, isPinned)=>{
        if (!isPinnedChatsEnabled) return false;
        // The `conversation` from a rendered row may already reflect an optimistic value; resolve
        // the server-truth entry so the optimistic state is based on the real server value.
        const serverConversation = conversations.find((candidate)=>candidate.id === conversation_0.id) ?? conversation_0;
        const serverPinned = serverConversation.isPinned === true;
        const previousPinnedValue = $dda2afeb0cbe58b3$var$resolveIsPinned(serverConversation, optimisticPinnedByConversationId[conversation_0.id]);
        if (isPinned && !previousPinnedValue) {
            // Prefer the backend's authoritative count + limit (spans space and non-space pins).
            // Fall back to the local count only when the summary is unavailable.
            const maxPinnedConversations = pinnedConversationSummary?.maxPinnedConversations ?? $dda2afeb0cbe58b3$var$getMaxPinnedConversations();
            const visiblePinnedConversationCount = pinnedConversationSummary ? pinnedConversationSummary.pinnedCount + $dda2afeb0cbe58b3$var$getOptimisticPinnedDelta(conversations, optimisticPinnedByConversationId) : $dda2afeb0cbe58b3$var$getPinnedConversationCount(pinnedCountConversations ?? conversations, optimisticPinnedByConversationId);
            if (visiblePinnedConversationCount >= maxPinnedConversations) {
                setPinLimitError({
                    conversationId: conversation_0.id,
                    maxPinnedConversations: maxPinnedConversations
                });
                return false;
            }
        }
        setPinLimitError(null);
        onBeforeOptimisticStateChange?.();
        setOptimisticPinnedByConversationId((prev)=>({
                ...prev,
                [conversation_0.id]: {
                    isPinned: isPinned,
                    pinnedAt: isPinned ? $dda2afeb0cbe58b3$var$getOptimisticPinnedAt(conversations) : null,
                    basedOnServerPinned: serverPinned
                }
            }));
        // Fire-and-forget: the optimistic update above already reflects the toggle, so we don't
        // block the event handler on the request; the catch reverts it if the request fails.
        (async ()=>{
            try {
                await onConversationPinToggle?.(getConversationForPinToggle?.(conversation_0) ?? conversation_0, isPinned);
            } catch (error) {
                const pinLimitError_0 = isPinned ? $dda2afeb0cbe58b3$export$fdcfe20cc5094d0a(error) : undefined;
                // Roll back by dropping the optimistic entry: the toggle failed so the server value
                // is unchanged, and resolveIsPinned falls back to it.
                onBeforeOptimisticStateChange?.();
                setOptimisticPinnedByConversationId((prev_0)=>{
                    if (!Object.prototype.hasOwnProperty.call(prev_0, conversation_0.id)) return prev_0;
                    const next = {
                        ...prev_0
                    };
                    delete next[conversation_0.id];
                    return next;
                });
                if (pinLimitError_0 !== undefined) setPinLimitError({
                    conversationId: conversation_0.id,
                    maxPinnedConversations: pinLimitError_0.maxPinnedConversations
                });
            }
        })();
        return true;
    }, [
        isPinnedChatsEnabled,
        conversations,
        getConversationForPinToggle,
        optimisticPinnedByConversationId,
        onBeforeOptimisticStateChange,
        onConversationPinToggle,
        pinnedCountConversations,
        pinnedConversationSummary
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!pinLimitError) return;
        const timeoutId = setTimeout(()=>{
            setPinLimitError((current)=>current?.conversationId === pinLimitError.conversationId ? null : current);
        }, $dda2afeb0cbe58b3$var$PIN_LIMIT_POPUP_AUTO_DISMISS_MS);
        return ()=>clearTimeout(timeoutId);
    }, [
        pinLimitError
    ]);
    // Note: optimistic entries are reconciled during render via `resolveIsPinned` (an entry is
    // ignored once the server value diverges from what it was based on), so no effect is needed to
    // prune them, and nothing needs to run when the feature is disabled.
    const applyOptimisticPinnedState = (0, $cozmU.useCallback)((conversation_1)=>{
        const optimisticPinnedState = optimisticPinnedByConversationId[conversation_1.id];
        const isPinned_0 = isConversationPinned(conversation_1);
        if (isPinned_0 === (conversation_1.isPinned === true)) return conversation_1;
        return {
            ...conversation_1,
            isPinned: isPinned_0,
            pinnedAt: optimisticPinnedState?.pinnedAt ?? conversation_1.pinnedAt
        };
    }, [
        isConversationPinned,
        optimisticPinnedByConversationId
    ]);
    const dismissPinLimitError = (0, $cozmU.useCallback)((conversationId)=>{
        setPinLimitError((current_0)=>current_0?.conversationId === conversationId ? null : current_0);
    }, []);
    return {
        applyOptimisticPinnedState: applyOptimisticPinnedState,
        compareConversationsByPinnedState: $dda2afeb0cbe58b3$var$compareConversationsByPinnedState,
        handleConversationPinToggle: handleConversationPinToggle,
        pinLimitError: pinLimitError,
        dismissPinLimitError: dismissPinLimitError
    };
};





const $64737d6851b9a149$var$message = (0, $kSwu1.defineMessages)({
    moreBtnLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.more-btn",
        defaultMessage: "More"
    }
});
var $64737d6851b9a149$export$2e2bcd8739ae039 = $64737d6851b9a149$var$message;











const $22325cc8bf5c892b$var$message = (0, $kSwu1.defineMessages)({
    today: {
        id: "ai-mate.rovo-navigation.side-navigation.time.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "ai-mate.rovo-navigation.side-navigation.time.yesterday",
        defaultMessage: "Yesterday"
    },
    thisWeek: {
        id: "ai-mate.rovo-navigation.side-navigation.time.this-week",
        defaultMessage: "This past week"
    },
    thisMonth: {
        id: "ai-mate.rovo-navigation.side-navigation.time.this-month",
        defaultMessage: "This past month"
    },
    furtherBack: {
        id: "ai-mate.rovo-navigation.side-navigation.time.further-back",
        defaultMessage: "Further back"
    },
    now: {
        id: "ai-mate.rovo-navigation.side-navigation.time.now",
        defaultMessage: "Just now"
    }
});
var $22325cc8bf5c892b$export$2e2bcd8739ae039 = $22325cc8bf5c892b$var$message;


const $b2c44d37af3ec21e$export$99ff128bd67e6b2a = (conversations, formatMessage)=>{
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today.getTime() + 1 * (0, $17a118af00cd097a$export$750abf5956643c1a));
    const yesterday = new Date(today.getTime() - (0, $17a118af00cd097a$export$5c2fd9a7561b5ec) * (0, $17a118af00cd097a$export$750abf5956643c1a));
    const sevenDaysAgo = new Date(today.getTime() - (0, $17a118af00cd097a$export$a7851db961bee92d) * (0, $17a118af00cd097a$export$750abf5956643c1a));
    const thirtyDaysAgo = new Date(today.getTime() - (0, $17a118af00cd097a$export$2f58959d6b4c4102) * (0, $17a118af00cd097a$export$750abf5956643c1a));
    const groups = [
        {
            label: formatMessage((0, $22325cc8bf5c892b$export$2e2bcd8739ae039).today),
            conversations: []
        },
        {
            label: formatMessage((0, $22325cc8bf5c892b$export$2e2bcd8739ae039).yesterday),
            conversations: []
        },
        {
            label: formatMessage((0, $22325cc8bf5c892b$export$2e2bcd8739ae039).thisWeek),
            conversations: []
        },
        {
            label: formatMessage((0, $22325cc8bf5c892b$export$2e2bcd8739ae039).thisMonth),
            conversations: []
        },
        {
            label: formatMessage((0, $22325cc8bf5c892b$export$2e2bcd8739ae039).furtherBack),
            conversations: []
        }
    ];
    const sortedConversations = conversations.sort((a, b)=>{
        if (!a.lastMessageTimestamp && !b.lastMessageTimestamp) return 0;
        if (!a.lastMessageTimestamp) return 1;
        if (!b.lastMessageTimestamp) return -1;
        // Sort by timestamp descending
        const dateA = new Date(a.lastMessageTimestamp);
        const dateB = new Date(b.lastMessageTimestamp);
        return dateB.getTime() - dateA.getTime();
    });
    sortedConversations.forEach((conversation)=>{
        if (conversation.lastMessageTimestamp) {
            const messageDate = new Date(conversation.lastMessageTimestamp);
            // Exclude future dates (which shouldn't happen)
            if (messageDate < tomorrow) {
                if (messageDate >= today) groups[0, $17a118af00cd097a$export$18c04e21aa077ce9].conversations.push(conversation); // Today
                else if (messageDate >= yesterday) groups[0, $17a118af00cd097a$export$666507e3d0a8e6da].conversations.push(conversation); // Yesterday
                else if (messageDate >= sevenDaysAgo) groups[0, $17a118af00cd097a$export$766879a84c091f09].conversations.push(conversation); // This past week
                else if (messageDate >= thirtyDaysAgo) groups[0, $17a118af00cd097a$export$135b054211051d49].conversations.push(conversation); // This past month
                else groups[0, $17a118af00cd097a$export$6ce742aaaff529a4].conversations.push(conversation); // Further back than this month
            // Conversations older than 30 days are excluded (no else clause)
            }
        }
    });
    // Return only groups that have conversations
    return groups.filter((group)=>group.conversations.length > 0);
};








/**
 * @generated SignedSource<<690ebda96db0b85b1573f3f7a2cb3b01>>
 * @relayHash 22b3a08a1d1b334ad3a352d3e5fe06b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d1a71f35abd47c744598712c297fbc813c370680804419fece29b5a9527db42
const $75fd655bb4cb7833$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "agentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentParticipants_agentByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentById",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "identityAccount",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "avatarRelay_user"
                                        }
                                    ]
                                }
                            ],
                            "type": "AgentStudioAssistant"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentParticipants_agentByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentById",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "identityAccount",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isUser"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appType"
                                                }
                                            ],
                                            "type": "AppUser"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "AgentStudioAssistant"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ 
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2d1a71f35abd47c744598712c297fbc813c370680804419fece29b5a9527db42",
            "metadata": {},
            "name": "agentParticipants_agentByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$75fd655bb4cb7833$var$node.hash = "0992fd3d08b0ab379cf5ae7de9b6d997";
var $75fd655bb4cb7833$export$2e2bcd8739ae039 = $75fd655bb4cb7833$var$node;


/**
 * @generated SignedSource<<f4c94da5204bc4a12a8d17331c7e777e>>
 * @relayHash 4703530605aad8f15a20eb92a7bfd03e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d1b8eb3d1aea963ac9c19994ad57fac69745460ec127a58b2dac5bac8ffe0eb
const $88415e26d40319fe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentParticipants_userByAccountIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "avatarRelay_user"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentParticipants_userByAccountIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0d1b8eb3d1aea963ac9c19994ad57fac69745460ec127a58b2dac5bac8ffe0eb",
            "metadata": {},
            "name": "agentParticipants_userByAccountIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$88415e26d40319fe$var$node.hash = "9f900fccc76d073b5e395347c9a8c176";
var $88415e26d40319fe$export$2e2bcd8739ae039 = $88415e26d40319fe$var$node;







































const $af0ff7e9652e4f45$var$message = (0, $kSwu1.defineMessages)({
    moreMenuDeleteLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.more-menu.delete",
        defaultMessage: "Delete"
    },
    moreMenuPinLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.more-menu.pin",
        defaultMessage: "Pin"
    },
    moreMenuUnpinLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.more-menu.unpin",
        defaultMessage: "Unpin"
    },
    pinnedConversationsLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.pinned",
        defaultMessage: "Pinned"
    },
    pinLimitPopupTitle: {
        id: "ai-mate.rovo-navigation.chat-history-items.pin-limit-popup.title",
        defaultMessage: "You've reached your pin limit"
    },
    pinLimitPopupDescription: {
        id: "ai-mate.rovo-navigation.chat-history-items.pin-limit-popup.description",
        defaultMessage: "To pin a new chat, unpin an old one."
    },
    pinLimitPopupDescriptionWithLimit: {
        id: "ai-mate.rovo-navigation.chat-history-items.pin-limit-popup.description-with-limit",
        defaultMessage: "Up to {limit, plural, one {# chat} other {# chats}} can be pinned at a time. To pin a new chat, unpin an old one."
    },
    moreMenuRenameLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.more-menu.rename",
        defaultMessage: "Rename"
    },
    moreMenuMoveToSpaceLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.more-menu.move-to-space",
        defaultMessage: "Move to Rovo Space"
    },
    moveToSpaceCreateNewLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.move-to-space.create-new",
        defaultMessage: "Create new Rovo Space"
    },
    moveToSpaceLoadingLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.move-to-space.loading",
        defaultMessage: "Loading Rovo spaces\u2026"
    },
    moveToSpaceNoSpacesLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.move-to-space.no-spaces",
        defaultMessage: "No Rovo spaces yet"
    },
    moveToSpaceNoMatchesLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.move-to-space.no-matches",
        defaultMessage: "No Rovo spaces match \u201C{query}\u201D"
    },
    moveToSpaceSearchInputLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.move-to-space.search-input-label",
        defaultMessage: "Search Rovo spaces"
    },
    moveToSpaceSearchPlaceholder: {
        id: "ai-mate.rovo-navigation.chat-history-items.move-to-space.search-placeholder",
        defaultMessage: "Search Rovo spaces"
    },
    viewAllConversationsLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.view-all-conversations",
        defaultMessage: "View all conversations"
    },
    agentDescriptionLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.agent-description",
        defaultMessage: "{agentName} \xB7 {relativeTime}"
    },
    runningLozengeLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.conversation-status-lozenge",
        defaultMessage: "Running"
    },
    footerSeparator: {
        id: "ai-mate.rovo-navigation.chat-history-items.footer-separator",
        defaultMessage: "\xB7"
    },
    scopesOverflowCount: {
        id: "ai-mate.rovo-navigation.chat-history-items.scopes-overflow-count",
        defaultMessage: "+{count}"
    },
    agentOverflowCount: {
        id: "ai-mate.rovo-navigation.chat-history-items.agent-overflow-count",
        defaultMessage: "{count, plural, one {# more agent} other {# more agents}}"
    },
    renameInputLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.rename-input.label",
        defaultMessage: "Edit chat name"
    },
    confirmRenameLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.rename-confirm.label",
        defaultMessage: "Confirm rename"
    },
    cancelRenameLabel: {
        id: "ai-mate.rovo-navigation.chat-history-items.rename-cancel.label",
        defaultMessage: "Cancel rename"
    },
    filePreviewFallbackDescription: {
        id: "ai-mate.rovo-navigation.chat-history-items.file-preview-fallback",
        defaultMessage: "Preview is not available for this file type."
    },
    rovoAgentName: {
        id: "rovo-navigation.side-navigation.chat-list-items.rovoAgentName",
        defaultMessage: "Rovo"
    }
});
var $af0ff7e9652e4f45$export$2e2bcd8739ae039 = $af0ff7e9652e4f45$var$message;


const $b0be9dddf1032155$var$MAX_VISIBLE_AGENT_AVATARS = 3;
// because that module bundles ~44 icon data-URIs and does not tree-shake here, which would add ~9kB
// to critical page-load routes (Jira Issue View, Confluence Edit Page). Keep this in sync with
// `rovo-switch-back-mention.ts`, which uses the same data URI for default Rovo mention rows.
const $b0be9dddf1032155$var$ROVO_HEX_LOGO_DATA_URI = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $b0be9dddf1032155$var$NAME_SKELETON_WIDTH = '72px';
const $b0be9dddf1032155$var$NAME_SKELETON_HEIGHT = '12px';
const $b0be9dddf1032155$var$AgentNameSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: $b0be9dddf1032155$var$NAME_SKELETON_WIDTH,
            height: $b0be9dddf1032155$var$NAME_SKELETON_HEIGHT,
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: $b0be9dddf1032155$var$NAME_SKELETON_WIDTH,
        height: $b0be9dddf1032155$var$NAME_SKELETON_HEIGHT,
        isShimmering: true
    });
const $b0be9dddf1032155$var$AgentName = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { name: name, textColor: textColor } = t0;
    let t1;
    if ($[0] !== name || $[1] !== textColor) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            color: textColor,
            size: "small",
            weight: "regular"
        }, name);
        $[0] = name;
        $[1] = textColor;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ name: name, textColor: textColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        color: textColor,
        size: "small",
        weight: "regular"
    }, name);
const $b0be9dddf1032155$var$DefaultRovoAvatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { name: name } = t0;
    let t1;
    if ($[0] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            size: "xxsmall",
            name: name,
            src: $b0be9dddf1032155$var$ROVO_HEX_LOGO_DATA_URI
        });
        $[0] = name;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        size: "xxsmall",
        name: name,
        src: $b0be9dddf1032155$var$ROVO_HEX_LOGO_DATA_URI
    });
const $b0be9dddf1032155$var$styles = {
    avatarStack: "_2mHwu8Pgdg _3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC"
};
const $b0be9dddf1032155$var$getParticipantIdentity = (participant)=>{
    if (participant.type !== 'AGENT') return undefined;
    const agentId = (0, $2yWJZ.trimToUndefined)(participant.agent?.agent_id);
    if (!agentId) return undefined;
    return {
        agentId: agentId,
        isDefaultRovo: (0, $2yWJZ.isDefaultRovoChat)({
            agentId: agentId
        })
    };
};
const $b0be9dddf1032155$export$8e6c13c968b9621b = (participants)=>{
    const result = []; // The backend sends the conversation agent as the first participant. The UI already
    // starts from the richer conversation.agent record, so skip the duplicate first
    // participant and append any additional agents after it.
    for (const participant of participants?.slice(1) ?? []){
        const identity = $b0be9dddf1032155$var$getParticipantIdentity(participant);
        if (identity) result.push(identity);
    }
    return result;
};
const $b0be9dddf1032155$var$getConversationAgentIdentity = (agent)=>{
    const agentId = (0, $2yWJZ.trimToUndefined)(agent?.agent_id);
    if (!agentId) return undefined;
    const agentIdentityAccountId = (0, $2yWJZ.trimToUndefined)(agent?.identity_account_id);
    return {
        agentId: agentId,
        ...agentIdentityAccountId ? {
            agentIdentityAccountId: agentIdentityAccountId
        } : {},
        isDefaultRovo: (0, $2yWJZ.isDefaultRovoChat)({
            agentId: agentId
        })
    };
};
const $b0be9dddf1032155$export$2c07ca97a306aa5a = ({ participants: participants, conversationAgent: conversationAgent })=>{
    // Apply the same participant policy after the conversation state is resolved. The agent may
    // have been seeded optimistically or supplied by the API; its provenance must not affect the
    // ordered identities rendered in the chat list.
    const conversationAgentIdentity = $b0be9dddf1032155$var$getConversationAgentIdentity(conversationAgent);
    const participantIdentities = $b0be9dddf1032155$export$8e6c13c968b9621b(participants);
    if (participantIdentities.length === 0) return conversationAgentIdentity && !conversationAgentIdentity.isDefaultRovo ? [
        conversationAgentIdentity
    ] : [];
    const firstParticipant = participants?.[0];
    const firstParticipantIdentity = firstParticipant ? $b0be9dddf1032155$var$getParticipantIdentity(firstParticipant) : undefined;
    const firstParticipantMatchesConversationAgent = Boolean(firstParticipantIdentity && conversationAgentIdentity) && firstParticipantIdentity?.agentId === conversationAgentIdentity?.agentId;
    const primaryIdentity = firstParticipantMatchesConversationAgent ? conversationAgentIdentity : firstParticipantIdentity ?? conversationAgentIdentity;
    return [
        primaryIdentity,
        ...participantIdentities
    ].filter((identity)=>Boolean(identity));
};
const $b0be9dddf1032155$var$AgentMetadataFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { showName: showName } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: "xxsmall"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== showName) {
        t2 = showName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentNameSkeleton, null) : null;
        $[1] = showName;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            alignBlock: "center",
            space: "space.050"
        }, t1, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ showName: showName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
        appearance: "hexagon",
        size: "xxsmall"
    }), showName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentNameSkeleton, null) : null);
const $b0be9dddf1032155$var$HydratedAgentParticipantMetadataFromIdentityAccountId = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { accountId: accountId, showName: showName, textColor: textColor } = t0;
    let t1;
    if ($[0] !== accountId) {
        t1 = {
            accountId: accountId
        };
        $[0] = accountId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $88415e26d40319fe$export$2e2bcd8739ae039), t1, t2);
    const user = data.user ?? null;
    const relayName = user?.name;
    let t3;
    if ($[3] !== relayName || $[4] !== user) {
        t3 = user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
            userFragment: user,
            size: "xxsmall",
            name: relayName
        }) : null;
        $[3] = relayName;
        $[4] = user;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== relayName || $[7] !== showName || $[8] !== textColor) {
        t4 = showName && relayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentName, {
            name: relayName,
            textColor: textColor
        }) : null;
        $[6] = relayName;
        $[7] = showName;
        $[8] = textColor;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            alignBlock: "center",
            space: "space.050"
        }, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ accountId: accountId, showName: showName, textColor: textColor })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $88415e26d40319fe$export$2e2bcd8739ae039), {
        accountId: accountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const user = data.user ?? null;
    const relayName = user?.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        alignBlock: "center",
        space: "space.050"
    }, user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
        userFragment: user,
        size: "xxsmall",
        name: relayName
    }) : null, showName && relayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentName, {
        name: relayName,
        textColor: textColor
    }) : null);
};
const $b0be9dddf1032155$var$HydratedAgentParticipantMetadata = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { agentAri: agentAri, showName: showName, textColor: textColor } = t0;
    const t1 = agentAri ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            agentId: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t3;
    } else t3 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $75fd655bb4cb7833$export$2e2bcd8739ae039), t2, t3);
    const identityAccount = data.agentStudio_agentById?.identityAccount ?? null;
    const relayName = identityAccount?.name;
    let t4;
    if ($[3] !== identityAccount) {
        t4 = identityAccount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
            userFragment: identityAccount,
            size: "xxsmall"
        }) : null;
        $[3] = identityAccount;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== relayName || $[6] !== showName || $[7] !== textColor) {
        t5 = showName && relayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentName, {
            name: relayName,
            textColor: textColor
        }) : null;
        $[5] = relayName;
        $[6] = showName;
        $[7] = textColor;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            alignBlock: "center",
            space: "space.050"
        }, t4, t5);
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ agentAri: agentAri, showName: showName, textColor: textColor })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $75fd655bb4cb7833$export$2e2bcd8739ae039), {
        agentId: agentAri ?? ''
    }, {
        fetchPolicy: 'store-or-network'
    });
    const identityAccount = data.agentStudio_agentById?.identityAccount ?? null;
    const relayName = identityAccount?.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        alignBlock: "center",
        space: "space.050"
    }, identityAccount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
        userFragment: identityAccount,
        size: "xxsmall"
    }) : null, showName && relayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentName, {
        name: relayName,
        textColor: textColor
    }) : null);
};
const $b0be9dddf1032155$var$ResolvedAgentMetadataRelayFromAgentId = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { cloudId: cloudId, identity: identity, showName: showName, textColor: textColor } = t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== identity.agentId) {
        t1 = {
            agentId: identity.agentId,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = identity.agentId;
        $[2] = t1;
    } else t1 = $[2];
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)(t1);
    if (!agentAri) {
        let t2;
        if ($[3] !== showName) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
                showName: showName
            });
            $[3] = showName;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t2;
    if ($[5] !== showName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
            showName: showName
        });
        $[5] = showName;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== agentAri || $[8] !== showName || $[9] !== textColor) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$HydratedAgentParticipantMetadata, {
            agentAri: agentAri,
            showName: showName,
            textColor: textColor
        });
        $[7] = agentAri;
        $[8] = showName;
        $[9] = textColor;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: t2
        }, t3);
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ cloudId: cloudId, identity: identity, showName: showName, textColor: textColor })=>{
    const { agentAri: agentAri } = (0, $bwd6H.useResolveAgentAri)({
        agentId: identity.agentId,
        cloudId: cloudId
    });
    if (!agentAri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
        showName: showName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
            showName: showName
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$HydratedAgentParticipantMetadata, {
        agentAri: agentAri,
        showName: showName,
        textColor: textColor
    }));
};
const $b0be9dddf1032155$var$AgentMetadataRelayFromIdentity = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(22);
    if (props.identity.isDefaultRovo) {
        let t0;
        if ($[0] !== props.rovoAgentName) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$DefaultRovoAvatar, {
                name: props.rovoAgentName
            });
            $[0] = props.rovoAgentName;
            $[1] = t0;
        } else t0 = $[1];
        let t1;
        if ($[2] !== props.rovoAgentName || $[3] !== props.showName || $[4] !== props.textColor) {
            t1 = props.showName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentName, {
                name: props.rovoAgentName,
                textColor: props.textColor
            }) : null;
            $[2] = props.rovoAgentName;
            $[3] = props.showName;
            $[4] = props.textColor;
            $[5] = t1;
        } else t1 = $[5];
        let t2;
        if ($[6] !== t0 || $[7] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                as: "span",
                alignBlock: "center",
                space: "space.050"
            }, t0, t1);
            $[6] = t0;
            $[7] = t1;
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    let t0;
    if ($[9] !== props.identity.agentIdentityAccountId) {
        t0 = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(props.identity.agentIdentityAccountId);
        $[9] = props.identity.agentIdentityAccountId;
        $[10] = t0;
    } else t0 = $[10];
    const accountId = t0;
    if (accountId) {
        let t1;
        if ($[11] !== props.showName) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
                showName: props.showName
            });
            $[11] = props.showName;
            $[12] = t1;
        } else t1 = $[12];
        let t2;
        if ($[13] !== accountId || $[14] !== props.showName || $[15] !== props.textColor) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$HydratedAgentParticipantMetadataFromIdentityAccountId, {
                accountId: accountId,
                showName: props.showName,
                textColor: props.textColor
            });
            $[13] = accountId;
            $[14] = props.showName;
            $[15] = props.textColor;
            $[16] = t2;
        } else t2 = $[16];
        let t3;
        if ($[17] !== t1 || $[18] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: t1
            }, t2);
            $[17] = t1;
            $[18] = t2;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    let t1;
    if ($[20] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataRelayFromAgentId, props);
        $[20] = props;
        $[21] = t1;
    } else t1 = $[21];
    return t1;
} : (props)=>{
    if (props.identity.isDefaultRovo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$DefaultRovoAvatar, {
        name: props.rovoAgentName
    }), props.showName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentName, {
        name: props.rovoAgentName,
        textColor: props.textColor
    }) : null);
    const accountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(props.identity.agentIdentityAccountId);
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
            showName: props.showName
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$HydratedAgentParticipantMetadataFromIdentityAccountId, {
        accountId: accountId,
        showName: props.showName,
        textColor: props.textColor
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataRelayFromAgentId, props);
};
const $b0be9dddf1032155$var$AgentMetadataRelayFromAgentId = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const [shouldResolveAgentAri, setShouldResolveAgentAri] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            setShouldResolveAgentAri(false);
            (0, $cozmU.startTransition)(()=>{
                setShouldResolveAgentAri(true);
            });
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.identity.agentId) {
        t1 = [
            props.identity.agentId
        ];
        $[1] = props.identity.agentId;
        $[2] = t1;
    } else t1 = $[2];
    (0, $cozmU.useEffect)(t0, t1);
    if (!shouldResolveAgentAri) {
        let t2;
        if ($[3] !== props.showName) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
                showName: props.showName
            });
            $[3] = props.showName;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$ResolvedAgentMetadataRelayFromAgentId, props);
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const [shouldResolveAgentAri, setShouldResolveAgentAri] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setShouldResolveAgentAri(false);
        (0, $cozmU.startTransition)(()=>{
            setShouldResolveAgentAri(true);
        });
    }, [
        props.identity.agentId
    ]);
    if (!shouldResolveAgentAri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataFallback, {
        showName: props.showName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$ResolvedAgentMetadataRelayFromAgentId, props);
};
const $b0be9dddf1032155$export$ed4a0f979ae805b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { identities: identities, cloudId: cloudId, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!cloudId || identities.length === 0) return null;
    if (identities.length === 1) {
        const t1 = identities[0];
        let t2;
        if ($[0] !== formatMessage) {
            t2 = formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).rovoAgentName);
            $[0] = formatMessage;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== cloudId || $[3] !== identities[0] || $[4] !== t2 || $[5] !== textColor) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataRelayFromIdentity, {
                identity: t1,
                cloudId: cloudId,
                showName: true,
                textColor: textColor,
                rovoAgentName: t2
            });
            $[2] = cloudId;
            $[3] = identities[0];
            $[4] = t2;
            $[5] = textColor;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let T0;
    let T1;
    let overflowCount;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[7] !== cloudId || $[8] !== formatMessage || $[9] !== identities || $[10] !== textColor) {
        const visibleIdentities = identities.slice(0, $b0be9dddf1032155$var$MAX_VISIBLE_AGENT_AVATARS);
        overflowCount = identities.length - visibleIdentities.length;
        T1 = (0, $1l0kj.Inline);
        t4 = "center";
        t5 = "space.050";
        T0 = (0, $iMnC5.Box);
        t1 = "span";
        t2 = $b0be9dddf1032155$var$styles.avatarStack;
        let t6;
        if ($[19] !== cloudId || $[20] !== formatMessage || $[21] !== textColor) {
            t6 = (identity)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataRelayFromIdentity, {
                    key: identity.agentId,
                    identity: identity,
                    cloudId: cloudId,
                    textColor: textColor,
                    rovoAgentName: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).rovoAgentName)
                });
            $[19] = cloudId;
            $[20] = formatMessage;
            $[21] = textColor;
            $[22] = t6;
        } else t6 = $[22];
        t3 = visibleIdentities.map(t6);
        $[7] = cloudId;
        $[8] = formatMessage;
        $[9] = identities;
        $[10] = textColor;
        $[11] = T0;
        $[12] = T1;
        $[13] = overflowCount;
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
    } else {
        T0 = $[11];
        T1 = $[12];
        overflowCount = $[13];
        t1 = $[14];
        t2 = $[15];
        t3 = $[16];
        t4 = $[17];
        t5 = $[18];
    }
    let t6;
    if ($[23] !== T0 || $[24] !== t1 || $[25] !== t2 || $[26] !== t3) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t1,
            xcss: t2
        }, t3);
        $[23] = T0;
        $[24] = t1;
        $[25] = t2;
        $[26] = t3;
        $[27] = t6;
    } else t6 = $[27];
    let t7;
    if ($[28] !== formatMessage || $[29] !== overflowCount || $[30] !== textColor) {
        t7 = overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            "aria-label": formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).agentOverflowCount, {
                count: overflowCount
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "regular",
            color: textColor
        }, "+", overflowCount));
        $[28] = formatMessage;
        $[29] = overflowCount;
        $[30] = textColor;
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== T1 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6 || $[36] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            alignBlock: t4,
            space: t5
        }, t6, t7);
        $[32] = T1;
        $[33] = t4;
        $[34] = t5;
        $[35] = t6;
        $[36] = t7;
        $[37] = t8;
    } else t8 = $[37];
    return t8;
} : ({ identities: identities, cloudId: cloudId, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!cloudId || identities.length === 0) return null;
    if (identities.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataRelayFromIdentity, {
        identity: identities[0],
        cloudId: cloudId,
        showName: true,
        textColor: textColor,
        rovoAgentName: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).rovoAgentName)
    });
    const visibleIdentities = identities.slice(0, $b0be9dddf1032155$var$MAX_VISIBLE_AGENT_AVATARS);
    const overflowCount = identities.length - visibleIdentities.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $b0be9dddf1032155$var$styles.avatarStack
    }, visibleIdentities.map((identity)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0be9dddf1032155$var$AgentMetadataRelayFromIdentity, {
            key: identity.agentId,
            identity: identity,
            cloudId: cloudId,
            textColor: textColor,
            rovoAgentName: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).rovoAgentName)
        }))), overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-label": formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).agentOverflowCount, {
            count: overflowCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        color: textColor
    }, "+", overflowCount)));
};



















var $2rEBE = parcelRequire("2rEBE");















var $8FgJC = parcelRequire("8FgJC");

















const $0170fa3e3879ed84$var$styles = {
    searchContainer: "_0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO",
    searchIconContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EgVvo",
    scrollableList: "_0NUa3rGVdc _2WAcuGIZbP",
    emptyState: "_0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE"
};
const $0170fa3e3879ed84$export$9ee63a73ceca6213 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { testIdDisambiguator: testIdDisambiguator, conversation: conversation, spaces: spaces, isLoadingSpaces: isLoadingSpaces, spaceEmojiProvider: spaceEmojiProvider, onConversationMoveToSpace: onConversationMoveToSpace, onConversationMoveToNewSpace: onConversationMoveToNewSpace, onClose: onClose } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [query, setQuery] = (0, $cozmU.useState)("");
    const inputRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== isOpen) {
        t1 = ()=>{
            if (!isOpen) {
                setQuery("");
                return;
            }
            const id = requestAnimationFrame(()=>{
                inputRef.current?.focus();
            });
            return ()=>cancelAnimationFrame(id);
        };
        t2 = [
            isOpen
        ];
        $[0] = isOpen;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setIsOpen(false);
        };
        $[3] = t3;
    } else t3 = $[3];
    const handleClose = t3;
    let t4;
    if ($[4] !== query || $[5] !== spaces) {
        bb0: {
            const normalized = query.trim().toLocaleLowerCase();
            if (!normalized) {
                t4 = spaces;
                break bb0;
            }
            t4 = spaces.filter((space)=>space.name.toLocaleLowerCase().includes(normalized));
        }
        $[4] = query;
        $[5] = spaces;
        $[6] = t4;
    } else t4 = $[6];
    const filteredSpaces = t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event)=>{
            setQuery(event.target.value);
        };
        $[7] = t5;
    } else t5 = $[7];
    const handleQueryChange = t5;
    let t6;
    if ($[8] !== conversation || $[9] !== onClose || $[10] !== onConversationMoveToSpace) {
        t6 = (spaceId)=>{
            setIsOpen(false);
            onClose();
            onConversationMoveToSpace?.(conversation, spaceId);
        };
        $[8] = conversation;
        $[9] = onClose;
        $[10] = onConversationMoveToSpace;
        $[11] = t6;
    } else t6 = $[11];
    const handleSpaceClick = t6;
    let t7;
    if ($[12] !== conversation || $[13] !== onClose || $[14] !== onConversationMoveToNewSpace) {
        t7 = ()=>{
            setIsOpen(false);
            onClose();
            onConversationMoveToNewSpace?.(conversation);
        };
        $[12] = conversation;
        $[13] = onClose;
        $[14] = onConversationMoveToNewSpace;
        $[15] = t7;
    } else t7 = $[15];
    const handleCreateNewSpace = t7;
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>setIsOpen($0170fa3e3879ed84$var$_temp);
        $[16] = t8;
    } else t8 = $[16];
    const handleToggleOpen = t8;
    if (!onConversationMoveToSpace && !onConversationMoveToNewSpace) return null;
    const hasSpaces = spaces.length > 0;
    const hasMatches = filteredSpaces.length > 0;
    let t9;
    if ($[17] !== filteredSpaces || $[18] !== formatMessage || $[19] !== handleSpaceClick || $[20] !== hasMatches || $[21] !== hasSpaces || $[22] !== isLoadingSpaces || $[23] !== query || $[24] !== spaceEmojiProvider || $[25] !== testIdDisambiguator) {
        t9 = ()=>{
            if (isLoadingSpaces) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                isDisabled: true,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                    size: "small",
                    label: ""
                })
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceLoadingLabel));
            if (!hasSpaces) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                isDisabled: true
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceNoSpacesLabel));
            if (!hasMatches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $0170fa3e3879ed84$var$styles.emptyState,
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-no-matches-${testIdDisambiguator}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle",
                size: "small"
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceNoMatchesLabel, {
                query: query.trim()
            })));
            return filteredSpaces.map((space_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: space_0.id,
                    testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-item-${space_0.id}-${testIdDisambiguator}`,
                    iconBefore: space_0.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                        emojiId: {
                            id: space_0.emoji,
                            shortName: ""
                        },
                        emojiProvider: spaceEmojiProvider,
                        fitToHeight: 16
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                        label: ""
                    }),
                    onClick: ()=>handleSpaceClick(space_0.id)
                }, space_0.name));
        };
        $[17] = filteredSpaces;
        $[18] = formatMessage;
        $[19] = handleSpaceClick;
        $[20] = hasMatches;
        $[21] = hasSpaces;
        $[22] = isLoadingSpaces;
        $[23] = query;
        $[24] = spaceEmojiProvider;
        $[25] = testIdDisambiguator;
        $[26] = t9;
    } else t9 = $[26];
    const renderListContents = t9;
    const t10 = `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-popup-${testIdDisambiguator}`;
    let t11;
    if ($[27] !== formatMessage || $[28] !== handleCreateNewSpace || $[29] !== hasSpaces || $[30] !== onConversationMoveToNewSpace || $[31] !== query || $[32] !== renderListContents || $[33] !== testIdDisambiguator) {
        t11 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, hasSpaces && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $0170fa3e3879ed84$var$styles.searchContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ref: inputRef,
                value: query,
                onChange: handleQueryChange,
                placeholder: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceSearchPlaceholder),
                "aria-label": formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceSearchInputLabel),
                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $0170fa3e3879ed84$var$styles.searchIconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                })),
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-search-${testIdDisambiguator}`
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: hasSpaces ? $0170fa3e3879ed84$var$styles.scrollableList : undefined
            }, renderListContents())), onConversationMoveToNewSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-new-space-${testIdDisambiguator}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2rEBE))), {
                    label: ""
                }),
                onClick: handleCreateNewSpace
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceCreateNewLabel))));
        $[27] = formatMessage;
        $[28] = handleCreateNewSpace;
        $[29] = hasSpaces;
        $[30] = onConversationMoveToNewSpace;
        $[31] = query;
        $[32] = renderListContents;
        $[33] = testIdDisambiguator;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== formatMessage || $[36] !== testIdDisambiguator) {
        t12 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                ...triggerProps,
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-move-to-space-${testIdDisambiguator}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: ""
                }),
                onClick: handleToggleOpen
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuMoveToSpaceLabel));
        $[35] = formatMessage;
        $[36] = testIdDisambiguator;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== isOpen || $[39] !== t10 || $[40] !== t11 || $[41] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            testId: t10,
            isOpen: isOpen,
            onClose: handleClose,
            zIndex: (0, $17a118af00cd097a$export$6da3aaba6bb6f609) + 1,
            placement: "right-start",
            content: t11,
            trigger: t12
        });
        $[38] = isOpen;
        $[39] = t10;
        $[40] = t11;
        $[41] = t12;
        $[42] = t13;
    } else t13 = $[42];
    return t13;
} : ({ testIdDisambiguator: testIdDisambiguator, conversation: conversation, spaces: spaces, isLoadingSpaces: isLoadingSpaces, spaceEmojiProvider: spaceEmojiProvider, onConversationMoveToSpace: onConversationMoveToSpace, onConversationMoveToNewSpace: onConversationMoveToNewSpace, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [query, setQuery] = (0, $cozmU.useState)('');
    const inputRef = (0, $cozmU.useRef)(null); // Auto-focus the search input every time the submenu opens so keyboard users
    // can start filtering immediately, and reset the query so stale filter state
    // doesn't bleed across opens.
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            setQuery('');
            return;
        } // `requestAnimationFrame` waits for the popup contents to mount before
        // attempting to focus.
        const id = requestAnimationFrame(()=>{
            inputRef.current?.focus();
        });
        return ()=>cancelAnimationFrame(id);
    }, [
        isOpen
    ]); // Closing the submenu via outside click or Escape only dismisses the
    // submenu itself — the parent "..." menu stays open so the user can pick
    // a different action (rename/delete). `onClose` from the parent is only
    // called when the user actually completes a move/create action.
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const filteredSpaces = (0, $cozmU.useMemo)(()=>{
        const normalized = query.trim().toLocaleLowerCase();
        if (!normalized) return spaces;
        return spaces.filter((space)=>space.name.toLocaleLowerCase().includes(normalized));
    }, [
        spaces,
        query
    ]);
    const handleQueryChange = (0, $cozmU.useCallback)((event)=>{
        setQuery(event.target.value);
    }, []); // Fire-and-forget the move action — the same pattern the original inline
    // submenu used. Errors are surfaced by the caller's own toasts / analytics.
    const handleSpaceClick = (0, $cozmU.useCallback)((spaceId)=>{
        setIsOpen(false);
        onClose();
        onConversationMoveToSpace?.(conversation, spaceId);
    }, [
        conversation,
        onClose,
        onConversationMoveToSpace
    ]);
    const handleCreateNewSpace = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        onClose();
        onConversationMoveToNewSpace?.(conversation);
    }, [
        conversation,
        onClose,
        onConversationMoveToNewSpace
    ]);
    const handleToggleOpen = (0, $cozmU.useCallback)(()=>setIsOpen((prev)=>!prev), []);
    if (!onConversationMoveToSpace && !onConversationMoveToNewSpace) return null;
    const hasSpaces = spaces.length > 0;
    const hasMatches = filteredSpaces.length > 0; // Centralised renderer for the four mutually-exclusive list states:
    // loading → no-spaces (zero total) → no-matches (filtered to zero) → list.
    const renderListContents = ()=>{
        if (isLoadingSpaces) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            isDisabled: true,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small",
                label: ""
            })
        }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceLoadingLabel));
        if (!hasSpaces) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            isDisabled: true
        }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceNoSpacesLabel));
        if (!hasMatches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0170fa3e3879ed84$var$styles.emptyState,
            testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-no-matches-${testIdDisambiguator}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceNoMatchesLabel, {
            query: query.trim()
        })));
        return filteredSpaces.map((space_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                key: space_0.id,
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-item-${space_0.id}-${testIdDisambiguator}`,
                iconBefore: space_0.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                    emojiId: {
                        id: space_0.emoji,
                        shortName: ''
                    },
                    emojiProvider: spaceEmojiProvider,
                    fitToHeight: 16
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                    label: ""
                }),
                onClick: ()=>handleSpaceClick(space_0.id)
            }, space_0.name));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-popup-${testIdDisambiguator}`,
        isOpen: isOpen,
        onClose: handleClose,
        zIndex: (0, $17a118af00cd097a$export$6da3aaba6bb6f609) + 1,
        placement: "right-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, hasSpaces && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $0170fa3e3879ed84$var$styles.searchContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ref: inputRef,
                value: query,
                onChange: handleQueryChange,
                placeholder: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceSearchPlaceholder),
                "aria-label": formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceSearchInputLabel),
                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $0170fa3e3879ed84$var$styles.searchIconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                })),
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-space-search-${testIdDisambiguator}`
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: hasSpaces ? $0170fa3e3879ed84$var$styles.scrollableList : undefined
            }, renderListContents())), onConversationMoveToNewSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-move-to-new-space-${testIdDisambiguator}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2rEBE))), {
                    label: ""
                }),
                onClick: handleCreateNewSpace
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moveToSpaceCreateNewLabel)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                ...triggerProps,
                testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-move-to-space-${testIdDisambiguator}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: ""
                }),
                onClick: handleToggleOpen
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuMoveToSpaceLabel))
    });
};
function $0170fa3e3879ed84$var$_temp(prev) {
    return !prev;
}


const $6a5007b6f001db50$var$styles = {
    notificationDot: "_0bjKvDS5Zs _39xV02Jg58 _0jFU0VJg58 _0KLXrukLmD",
    statusContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _3YEZNOdnbC",
    trailingStatusSlot: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _0jFU0VQAma _3YEZNOdnbC",
    pinnedIndicator: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _1UtDYzZpcK _3YEZNOdnbC",
    pinnedIndicatorIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _1VJPcagSbW _0yKXXaDIqT",
    scopeOverflowCount: "_3YEZNOdnbC _1ANEUSLRg7 _0GTcwRLl21",
    firstScopeTooltipTrigger: "_1mT5xdRAKS _42Yu6B7dHp _3iDTPbccYA _0hPCNLDIqT _1EqgXlN91d _4ouGXIdnbC",
    firstScopeTooltipClickableTrigger: "_0wOv4Q7zJH",
    scopeTooltipContent: "_0bjKvDKxmn _2sNsIg7NXe _4c065U1Y8M _2Y7lL4gVvo _24h04i2Njc _1EqgXlGVdc _0KLXrugozt _1UtDYze5R3 _3zvHkHwPeg _1T2N03wPeg",
    scopeNameWrapper: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    scopeNameClickableWrapper: "_0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    elemAfterStyles: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuDIqT _0jFU0VbKFA _4xdlr07p2s"
};
const $6a5007b6f001db50$export$8a74b6c2b6abee5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(136);
    const { testIdDisambiguator: testIdDisambiguator, conversation: conversation, onSelectConversation: onSelectConversation, onConversationRename: onConversationRename, onConversationDelete: onConversationDelete, onConversationMoveToSpace: onConversationMoveToSpace, onConversationMoveToNewSpace: onConversationMoveToNewSpace, isSelected: isSelected, level: t1, isADSNavigationEnabled: isADSNavigationEnabled, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled, spaces: spaces, isLoadingSpaces: isLoadingSpaces, spaceEmojiProvider: spaceEmojiProvider, cloudId: cloudId, onConversationPinToggle: onConversationPinToggle, isPinnedChatsEnabled: t2, pinLimitError: pinLimitError, onDismissPinLimitError: onDismissPinLimitError, listItemRef: listItemRef } = t0;
    const level = t1 === undefined ? 1 : t1;
    const isPinnedChatsEnabled = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { setStagingAreaMode: setStagingAreaMode } = (0, $8akfd.useStagingAreaActions)();
    const [fileScopePreview, setFileScopePreview] = (0, $cozmU.useState)(null);
    const [isScopeTooltipOpen, setIsScopeTooltipOpen] = (0, $cozmU.useState)(false);
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] !== conversation.lastMessageTimestamp) {
        t3 = {
            isoDate: conversation.lastMessageTimestamp,
            relativeTimeStyle: "long"
        };
        $[0] = conversation.lastMessageTimestamp;
        $[1] = t3;
    } else t3 = $[1];
    const relativeTime = (0, $de4d3154ef5b0570$export$6feb2ea55018719b)(t3);
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents");
        $[2] = t4;
    } else t4 = $[2];
    const mentionAgentsExperimentEnabled = t4;
    let t5;
    bb0: {
        if (!mentionAgentsExperimentEnabled) {
            let t6;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = [];
                $[3] = t6;
            } else t6 = $[3];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[4] !== conversation.agent || $[5] !== conversation.participants) {
            t6 = (0, $b0be9dddf1032155$export$2c07ca97a306aa5a)({
                participants: conversation.participants,
                conversationAgent: conversation.agent
            });
            $[4] = conversation.agent;
            $[5] = conversation.participants;
            $[6] = t6;
        } else t6 = $[6];
        t5 = t6;
    }
    const agentFooterIdentities = t5;
    const shouldUseParticipantAgentInfo = agentFooterIdentities.length > 0;
    const agentName = conversation.agent?.agent_name;
    let t6;
    if ($[7] !== conversation.agent?.agent_id || $[8] !== conversation.agent?.is_default || $[9] !== shouldUseParticipantAgentInfo) {
        t6 = mentionAgentsExperimentEnabled ? !shouldUseParticipantAgentInfo && !conversation.agent?.is_default && !(0, $2yWJZ.isDefaultRovoChat)({
            agentId: conversation.agent?.agent_id
        }) : !conversation.agent?.is_default;
        $[7] = conversation.agent?.agent_id;
        $[8] = conversation.agent?.is_default;
        $[9] = shouldUseParticipantAgentInfo;
        $[10] = t6;
    } else t6 = $[10];
    const shouldShowAgentInfo = t6;
    const scopes = conversation.scopes;
    const firstScope = scopes?.[0];
    const scopesOverflowCount = scopes && scopes.length > 1 ? scopes.length - 1 : 0;
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $iDrrr.fg)("rovo_chat_clickable_scope_tooltips");
        $[11] = t7;
    } else t7 = $[11];
    const isClickableScopeTooltipsEnabled = t7;
    let t8;
    if ($[12] !== conversation) {
        t8 = (0, $c5fb9783c4b6e9b4$export$f13ad37e3a27f791)(conversation);
        $[12] = conversation;
        $[13] = t8;
    } else t8 = $[13];
    const showTaskStatusFooterRow = t8;
    const shouldShowUnreadStatus = conversation.readStatus === false;
    const testId = `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-${testIdDisambiguator}`;
    let t9;
    if ($[14] !== sendAnalyticsEvent) {
        t9 = (variant)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "scopeLink",
                attributes: {
                    isTooltip: variant === "tooltip"
                }
            });
        };
        $[14] = sendAnalyticsEvent;
        $[15] = t9;
    } else t9 = $[15];
    const handleScopeLinkClicked = t9;
    let t10;
    if ($[16] !== scopes?.length || $[17] !== sendAnalyticsEvent) {
        t10 = ()=>{
            sendAnalyticsEvent({
                action: "hovered",
                actionSubject: "link",
                actionSubjectId: "scopeLink",
                attributes: {
                    scopeCount: scopes?.length ?? 0
                }
            });
        };
        $[16] = scopes?.length;
        $[17] = sendAnalyticsEvent;
        $[18] = t10;
    } else t10 = $[18];
    const handleScopeLinkHovered = t10;
    let t11;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>{
            setIsScopeTooltipOpen(false);
        };
        $[19] = t11;
    } else t11 = $[19];
    const handleScopeTooltipClose = t11;
    let t12;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            setIsScopeTooltipOpen($6a5007b6f001db50$var$_temp);
        };
        $[20] = t12;
    } else t12 = $[20];
    const handleScopeTooltipTriggerClick = t12;
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (event_0)=>{
            if (event_0.key === "Enter" || event_0.key === " ") {
                event_0.preventDefault();
                event_0.stopPropagation();
                setIsScopeTooltipOpen($6a5007b6f001db50$var$_temp2);
            }
        };
        $[21] = t13;
    } else t13 = $[21];
    const handleScopeTooltipTriggerKeyDown = t13;
    let t14;
    if ($[22] !== agentFooterIdentities || $[23] !== agentName || $[24] !== cloudId || $[25] !== conversation || $[26] !== firstScope || $[27] !== formatMessage || $[28] !== handleScopeLinkClicked || $[29] !== handleScopeLinkHovered || $[30] !== isNewAllConversationScreenEnabled || $[31] !== isScopeTooltipOpen || $[32] !== relativeTime || $[33] !== scopes || $[34] !== scopesOverflowCount || $[35] !== shouldShowAgentInfo || $[36] !== shouldUseParticipantAgentInfo || $[37] !== showTaskStatusFooterRow) {
        t14 = isNewAllConversationScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, showTaskStatusFooterRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5fb9783c4b6e9b4$export$80b5b1a1eb299c96), {
            conversation: conversation,
            showStatusIcon: false
        }), !showTaskStatusFooterRow && shouldUseParticipantAgentInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0be9dddf1032155$export$ed4a0f979ae805b), {
            identities: agentFooterIdentities,
            cloudId: cloudId,
            textColor: "color.text.subtlest"
        }), !showTaskStatusFooterRow && shouldShowAgentInfo && conversation.agent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentNamedId: conversation.agent.agent_named_id,
            agentId: conversation.agent.agent_id,
            agentIdentityAccountId: conversation.agent.identity_account_id,
            size: "xxsmall",
            showBorder: false,
            isForgeAgent: (0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(conversation.agent.creator_type) : conversation.agent.creator_type === "THIRD_PARTY" || conversation.agent.creator_type === "FORGE",
            forgeAgentIconUrl: conversation.agent.forge_url
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "regular",
            maxLines: 1,
            align: "start",
            color: "color.text.subtlest"
        }, agentName)), !showTaskStatusFooterRow && firstScope && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (shouldUseParticipantAgentInfo || shouldShowAgentInfo && conversation.agent) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).footerSeparator)), isClickableScopeTooltipsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isScopeTooltipOpen,
            onClose: handleScopeTooltipClose,
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
                    placement: "bottom",
                    role: "tooltip"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $6a5007b6f001db50$var$styles.scopeTooltipContent
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    space: "space.100"
                }, (scopes ?? []).map((scope, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        key: `${scope.link ?? "scope"}-${index}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                        scope: scope,
                        variant: "tooltip",
                        maxLines: 2,
                        onFilePreview: (link, name)=>setFileScopePreview({
                                link: link,
                                name: name
                            }),
                        onScopeLinkClick: handleScopeLinkClicked
                    })))))),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    as: "span",
                    role: "button",
                    tabIndex: 0,
                    xcss: (0, $w6R6I.cx)($6a5007b6f001db50$var$styles.firstScopeTooltipTrigger, $6a5007b6f001db50$var$styles.firstScopeTooltipClickableTrigger),
                    ...triggerProps,
                    onClick: handleScopeTooltipTriggerClick,
                    onKeyDown: handleScopeTooltipTriggerKeyDown
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: (0, $w6R6I.cx)($6a5007b6f001db50$var$styles.scopeNameWrapper, $6a5007b6f001db50$var$styles.scopeNameClickableWrapper)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                    scope: {
                        ...firstScope,
                        link: undefined
                    },
                    variant: "default",
                    maxLines: 1,
                    onScopeLinkHover: handleScopeLinkHovered
                })), scopesOverflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $6a5007b6f001db50$var$styles.scopeOverflowCount
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "span",
                    size: "small",
                    weight: "regular",
                    align: "start",
                    color: "color.text.subtlest"
                }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).scopesOverflowCount, {
                    count: scopesOverflowCount
                })))))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, (scopes ?? []).map((scope_0, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `${scope_0.link ?? "scope"}-${index_0}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                    scope: scope_0,
                    variant: "tooltip",
                    maxLines: 2,
                    onFilePreview: (link_0, name_0)=>setFileScopePreview({
                            link: link_0,
                            name: name_0
                        }),
                    onScopeLinkClick: handleScopeLinkClicked
                })))),
            delay: 0,
            position: "bottom",
            tag: "span"
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $6a5007b6f001db50$var$styles.firstScopeTooltipTrigger,
                ...tooltipProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $6a5007b6f001db50$var$styles.scopeNameWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                scope: firstScope,
                variant: "default",
                maxLines: 1,
                onFilePreview: (link_1, name_1)=>setFileScopePreview({
                        link: link_1,
                        name: name_1
                    }),
                onScopeLinkClick: handleScopeLinkClicked,
                onScopeLinkHover: handleScopeLinkHovered
            })), scopesOverflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $6a5007b6f001db50$var$styles.scopeOverflowCount
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "span",
                size: "small",
                weight: "regular",
                align: "start",
                color: "color.text.subtlest"
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).scopesOverflowCount, {
                count: scopesOverflowCount
            }))))))), relativeTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (shouldUseParticipantAgentInfo || shouldShowAgentInfo && conversation.agent || firstScope || showTaskStatusFooterRow) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).footerSeparator)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "regular",
            maxLines: 1,
            align: "start",
            color: "color.text.subtlest"
        }, relativeTime))) : undefined;
        $[22] = agentFooterIdentities;
        $[23] = agentName;
        $[24] = cloudId;
        $[25] = conversation;
        $[26] = firstScope;
        $[27] = formatMessage;
        $[28] = handleScopeLinkClicked;
        $[29] = handleScopeLinkHovered;
        $[30] = isNewAllConversationScreenEnabled;
        $[31] = isScopeTooltipOpen;
        $[32] = relativeTime;
        $[33] = scopes;
        $[34] = scopesOverflowCount;
        $[35] = shouldShowAgentInfo;
        $[36] = shouldUseParticipantAgentInfo;
        $[37] = showTaskStatusFooterRow;
        $[38] = t14;
    } else t14 = $[38];
    const description = t14;
    let t15;
    if ($[39] !== conversation || $[40] !== onConversationPinToggle) {
        t15 = (event_1)=>{
            event_1?.preventDefault();
            event_1?.stopPropagation();
            onConversationPinToggle?.(conversation, !conversation.isPinned);
            setIsMoreMenuOpen(false);
        };
        $[39] = conversation;
        $[40] = onConversationPinToggle;
        $[41] = t15;
    } else t15 = $[41];
    const onPinToggleClicked = t15;
    let t16;
    if ($[42] !== formatMessage || $[43] !== pinLimitError) {
        t16 = pinLimitError?.maxPinnedConversations !== undefined ? formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinLimitPopupDescriptionWithLimit, {
            limit: pinLimitError.maxPinnedConversations
        }) : formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinLimitPopupDescription);
        $[42] = formatMessage;
        $[43] = pinLimitError;
        $[44] = t16;
    } else t16 = $[44];
    const pinLimitDescription = t16;
    let t17;
    let t18;
    if ($[45] !== formatMessage || $[46] !== onDismissPinLimitError || $[47] !== pinLimitDescription || $[48] !== pinLimitError || $[49] !== showFlag) {
        t17 = ()=>{
            if (!pinLimitError) return;
            showFlag({
                id: "rovo-navigation.pin-limit",
                title: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinLimitPopupTitle),
                description: pinLimitDescription,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: "",
                    color: "var(--ds-icon-information, #357DE8)"
                }),
                isAutoDismiss: true,
                autoDismissSeconds: 5
            });
            onDismissPinLimitError?.();
        };
        t18 = [
            formatMessage,
            onDismissPinLimitError,
            pinLimitDescription,
            pinLimitError,
            showFlag
        ];
        $[45] = formatMessage;
        $[46] = onDismissPinLimitError;
        $[47] = pinLimitDescription;
        $[48] = pinLimitError;
        $[49] = showFlag;
        $[50] = t17;
        $[51] = t18;
    } else {
        t17 = $[50];
        t18 = $[51];
    }
    (0, $cozmU.useEffect)(t17, t18);
    let t19;
    if ($[52] !== conversation.isPinned || $[53] !== isPinnedChatsEnabled || $[54] !== testIdDisambiguator) {
        t19 = isPinnedChatsEnabled && conversation.isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6a5007b6f001db50$var$styles.pinnedIndicator,
            testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-pinned-indicator-${testIdDisambiguator}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6a5007b6f001db50$var$styles.pinnedIndicatorIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
            label: "",
            color: "currentColor",
            size: "small"
        }))) : null;
        $[52] = conversation.isPinned;
        $[53] = isPinnedChatsEnabled;
        $[54] = testIdDisambiguator;
        $[55] = t19;
    } else t19 = $[55];
    const pinnedIndicator = t19;
    let t20;
    if ($[56] !== conversation || $[57] !== shouldShowUnreadStatus) {
        t20 = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, shouldShowUnreadStatus);
        $[56] = conversation;
        $[57] = shouldShowUnreadStatus;
        $[58] = t20;
    } else t20 = $[58];
    const conversationListRowStatus = t20;
    const shouldShowTrailingStatusSlot = isNewAllConversationScreenEnabled && (conversationListRowStatus !== undefined || shouldShowUnreadStatus);
    const shouldReserveTrailingStatusSlot = isNewAllConversationScreenEnabled && (shouldShowTrailingStatusSlot || isPinnedChatsEnabled && conversation.isPinned);
    let t21;
    if ($[59] !== conversation || $[60] !== shouldReserveTrailingStatusSlot || $[61] !== shouldShowUnreadStatus || $[62] !== testIdDisambiguator) {
        t21 = shouldReserveTrailingStatusSlot ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6a5007b6f001db50$var$styles.statusContainer,
            testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-status-slot-${testIdDisambiguator}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5fb9783c4b6e9b4$export$88ead18fb18a2576), {
            conversation: conversation,
            testId: shouldShowUnreadStatus ? `${0, $17a118af00cd097a$export$6e5abe1fde535897}-history-item-unread-indicator-${testIdDisambiguator}` : undefined
        })) : null;
        $[59] = conversation;
        $[60] = shouldReserveTrailingStatusSlot;
        $[61] = shouldShowUnreadStatus;
        $[62] = testIdDisambiguator;
        $[63] = t21;
    } else t21 = $[63];
    let t22;
    if ($[64] !== pinnedIndicator || $[65] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6a5007b6f001db50$var$styles.elemAfterStyles
        }, t21, pinnedIndicator);
        $[64] = pinnedIndicator;
        $[65] = t21;
        $[66] = t22;
    } else t22 = $[66];
    const elemAfter = t22;
    let t23;
    if ($[67] !== conversation || $[68] !== isADSNavigationEnabled || $[69] !== onSelectConversation || $[70] !== setStagingAreaMode) {
        t23 = (event_2)=>{
            event_2.preventDefault();
            onSelectConversation(conversation, isADSNavigationEnabled);
            setStagingAreaMode(undefined, undefined);
        };
        $[67] = conversation;
        $[68] = isADSNavigationEnabled;
        $[69] = onSelectConversation;
        $[70] = setStagingAreaMode;
        $[71] = t23;
    } else t23 = $[71];
    const onSelect = t23;
    let t24;
    bb1: {
        if (!onConversationRename) {
            t24 = undefined;
            break bb1;
        }
        let t25;
        if ($[72] !== conversation || $[73] !== onConversationRename) {
            t25 = async (newName)=>{
                const result = await onConversationRename(conversation, newName);
                if (result?.hasError) return {
                    error: "Rename failed"
                };
            };
            $[72] = conversation;
            $[73] = onConversationRename;
            $[74] = t25;
        } else t25 = $[74];
        t24 = t25;
    }
    const onRename = t24;
    let t25;
    bb2: {
        if (!onConversationDelete) {
            t25 = undefined;
            break bb2;
        }
        let t26;
        if ($[75] !== conversation || $[76] !== onConversationDelete) {
            t26 = ()=>{
                onConversationDelete(conversation);
            };
            $[75] = conversation;
            $[76] = onConversationDelete;
            $[77] = t26;
        } else t26 = $[77];
        t25 = t26;
    }
    const onDelete = t25;
    let t26;
    if ($[78] !== conversation.isPinned || $[79] !== formatMessage || $[80] !== onConversationPinToggle || $[81] !== onPinToggleClicked || $[82] !== testIdDisambiguator) {
        t26 = onConversationPinToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-pin-menu-${testIdDisambiguator}`,
            iconBefore: conversation.isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW3nu))), {
                label: ""
            }),
            onClick: ()=>onPinToggleClicked()
        }, formatMessage(conversation.isPinned ? (0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuUnpinLabel : (0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuPinLabel)) : undefined;
        $[78] = conversation.isPinned;
        $[79] = formatMessage;
        $[80] = onConversationPinToggle;
        $[81] = onPinToggleClicked;
        $[82] = testIdDisambiguator;
        $[83] = t26;
    } else t26 = $[83];
    const pinMenuItem = t26;
    let t27;
    if ($[84] !== conversation || $[85] !== isLoadingSpaces || $[86] !== onConversationMoveToNewSpace || $[87] !== onConversationMoveToSpace || $[88] !== spaceEmojiProvider || $[89] !== spaces || $[90] !== testIdDisambiguator) {
        t27 = (onConversationMoveToSpace || onConversationMoveToNewSpace) && (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0170fa3e3879ed84$export$9ee63a73ceca6213), {
            testIdDisambiguator: testIdDisambiguator,
            conversation: conversation,
            spaces: spaces,
            isLoadingSpaces: isLoadingSpaces,
            spaceEmojiProvider: spaceEmojiProvider,
            onConversationMoveToSpace: onConversationMoveToSpace,
            onConversationMoveToNewSpace: onConversationMoveToNewSpace,
            onClose: $6a5007b6f001db50$var$_temp3
        }) : undefined;
        $[84] = conversation;
        $[85] = isLoadingSpaces;
        $[86] = onConversationMoveToNewSpace;
        $[87] = onConversationMoveToSpace;
        $[88] = spaceEmojiProvider;
        $[89] = spaces;
        $[90] = testIdDisambiguator;
        $[91] = t27;
    } else t27 = $[91];
    const moveToSpaceMenuItem = t27;
    let t28;
    if ($[92] !== moveToSpaceMenuItem || $[93] !== pinMenuItem) {
        t28 = pinMenuItem || moveToSpaceMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, pinMenuItem, moveToSpaceMenuItem) : undefined;
        $[92] = moveToSpaceMenuItem;
        $[93] = pinMenuItem;
        $[94] = t28;
    } else t28 = $[94];
    const moreMenuItems = t28;
    let t29;
    if ($[95] !== cloudId || $[96] !== fileScopePreview || $[97] !== formatMessage) {
        t29 = fileScopePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcfb7982faac66d1$export$298d258c84f7f125), {
            isOpen: true,
            onClose: ()=>setFileScopePreview(null),
            fileUrl: fileScopePreview.link,
            fileName: fileScopePreview.name,
            formatMessage: formatMessage,
            filePreviewFallbackDescription: (0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).filePreviewFallbackDescription,
            cloudId: cloudId
        }) : null;
        $[95] = cloudId;
        $[96] = fileScopePreview;
        $[97] = formatMessage;
        $[98] = t29;
    } else t29 = $[98];
    const afterContent = t29;
    let t30;
    if ($[99] !== isADSNavigationEnabled || $[100] !== isNewAllConversationScreenEnabled || $[101] !== level || $[102] !== listItemRef) {
        t30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
                isADSNavigationEnabled: isADSNavigationEnabled,
                isContentTooltipDisabled: true,
                href: "#",
                testId: props.testId,
                level: level,
                onClick: props.onClick,
                listItemRef: listItemRef,
                actionsOnHover: props.actionsOnHover,
                isSelected: props.isSelected,
                isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
                size: props.size,
                elemBefore: (0, $17a118af00cd097a$export$f4b8e24fae579c6f),
                noActiveBackground: true,
                description: isNewAllConversationScreenEnabled ? props.description : undefined,
                elemAfter: props.elemAfter
            }, props.children);
        $[99] = isADSNavigationEnabled;
        $[100] = isNewAllConversationScreenEnabled;
        $[101] = level;
        $[102] = listItemRef;
        $[103] = t30;
    } else t30 = $[103];
    const renderContainer = t30;
    const t31 = conversation.id;
    const t32 = conversation.name;
    let t33;
    if ($[104] !== formatMessage) {
        t33 = formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuRenameLabel);
        $[104] = formatMessage;
        $[105] = t33;
    } else t33 = $[105];
    let t34;
    if ($[106] !== formatMessage) {
        t34 = formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuDeleteLabel);
        $[106] = formatMessage;
        $[107] = t34;
    } else t34 = $[107];
    let t35;
    if ($[108] !== formatMessage) {
        t35 = formatMessage((0, $64737d6851b9a149$export$2e2bcd8739ae039).moreBtnLabel);
        $[108] = formatMessage;
        $[109] = t35;
    } else t35 = $[109];
    let t36;
    if ($[110] !== formatMessage) {
        t36 = formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).renameInputLabel);
        $[110] = formatMessage;
        $[111] = t36;
    } else t36 = $[111];
    let t37;
    if ($[112] !== formatMessage) {
        t37 = formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).confirmRenameLabel);
        $[112] = formatMessage;
        $[113] = t37;
    } else t37 = $[113];
    let t38;
    if ($[114] !== formatMessage) {
        t38 = formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).cancelRenameLabel);
        $[114] = formatMessage;
        $[115] = t38;
    } else t38 = $[115];
    let t39;
    if ($[116] !== afterContent || $[117] !== conversation.id || $[118] !== conversation.name || $[119] !== description || $[120] !== elemAfter || $[121] !== isMoreMenuOpen || $[122] !== isSelected || $[123] !== moreMenuItems || $[124] !== onDelete || $[125] !== onRename || $[126] !== onSelect || $[127] !== renderContainer || $[128] !== t33 || $[129] !== t34 || $[130] !== t35 || $[131] !== t36 || $[132] !== t37 || $[133] !== t38 || $[134] !== testId) {
        t39 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $197635bcddff2f9b$export$8a74b6c2b6abee5c), {
            id: t31,
            name: t32,
            description: description,
            elemAfter: elemAfter,
            isSelected: isSelected,
            size: "small",
            onSelect: onSelect,
            onRename: onRename,
            onDelete: onDelete,
            moreMenuItems: moreMenuItems,
            isMoreMenuOpen: isMoreMenuOpen,
            onMoreMenuOpenChange: setIsMoreMenuOpen,
            renderContainer: renderContainer,
            afterContent: afterContent,
            testId: testId,
            renameLabel: t33,
            deleteLabel: t34,
            moreButtonLabel: t35,
            renameInputLabel: t36,
            confirmRenameLabel: t37,
            cancelRenameLabel: t38
        });
        $[116] = afterContent;
        $[117] = conversation.id;
        $[118] = conversation.name;
        $[119] = description;
        $[120] = elemAfter;
        $[121] = isMoreMenuOpen;
        $[122] = isSelected;
        $[123] = moreMenuItems;
        $[124] = onDelete;
        $[125] = onRename;
        $[126] = onSelect;
        $[127] = renderContainer;
        $[128] = t33;
        $[129] = t34;
        $[130] = t35;
        $[131] = t36;
        $[132] = t37;
        $[133] = t38;
        $[134] = testId;
        $[135] = t39;
    } else t39 = $[135];
    return t39;
} : ({ testIdDisambiguator: testIdDisambiguator, conversation: conversation, onSelectConversation: onSelectConversation, onConversationRename: onConversationRename, onConversationDelete: onConversationDelete, onConversationMoveToSpace: onConversationMoveToSpace, onConversationMoveToNewSpace: onConversationMoveToNewSpace, isSelected: isSelected, level: level = 1, isADSNavigationEnabled: isADSNavigationEnabled, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled, isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled, spaces: spaces, isLoadingSpaces: isLoadingSpaces, spaceEmojiProvider: spaceEmojiProvider, cloudId: cloudId, onConversationPinToggle: onConversationPinToggle, isPinnedChatsEnabled: isPinnedChatsEnabled = false, pinLimitError: pinLimitError, onDismissPinLimitError: onDismissPinLimitError, listItemRef: listItemRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { setStagingAreaMode: setStagingAreaMode } = (0, $8akfd.useStagingAreaActions)();
    const [fileScopePreview, setFileScopePreview] = (0, $cozmU.useState)(null);
    const [isScopeTooltipOpen, setIsScopeTooltipOpen] = (0, $cozmU.useState)(false);
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const relativeTime = (0, $de4d3154ef5b0570$export$6feb2ea55018719b)({
        isoDate: conversation.lastMessageTimestamp,
        relativeTimeStyle: 'long'
    });
    const mentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const agentFooterIdentities = (0, $cozmU.useMemo)(()=>{
        if (!mentionAgentsExperimentEnabled) return [];
        return (0, $b0be9dddf1032155$export$2c07ca97a306aa5a)({
            participants: conversation.participants,
            conversationAgent: conversation.agent
        });
    }, [
        conversation.agent,
        conversation.participants,
        mentionAgentsExperimentEnabled
    ]);
    const shouldUseParticipantAgentInfo = agentFooterIdentities.length > 0;
    const agentName = conversation.agent?.agent_name;
    const shouldShowAgentInfo = mentionAgentsExperimentEnabled ? !shouldUseParticipantAgentInfo && !conversation.agent?.is_default && !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: conversation.agent?.agent_id
    }) : !conversation.agent?.is_default;
    const scopes = conversation.scopes;
    const firstScope = scopes?.[0];
    const scopesOverflowCount = scopes && scopes.length > 1 ? scopes.length - 1 : 0;
    const isClickableScopeTooltipsEnabled = (0, $iDrrr.fg)('rovo_chat_clickable_scope_tooltips');
    const showTaskStatusFooterRow = (0, $c5fb9783c4b6e9b4$export$f13ad37e3a27f791)(conversation);
    const shouldShowUnreadStatus = conversation.readStatus === false;
    const testId = `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-${testIdDisambiguator}`; // ── Computed visual slots ─────────────────────────────────────────────
    const footerTextColor = 'color.text.subtlest';
    const handleScopeLinkClicked = (0, $cozmU.useCallback)((variant)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'scopeLink',
            attributes: {
                isTooltip: variant === 'tooltip'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const handleScopeLinkHovered = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'link',
            actionSubjectId: 'scopeLink',
            attributes: {
                scopeCount: scopes?.length ?? 0
            }
        });
    }, [
        sendAnalyticsEvent,
        scopes
    ]);
    const handleScopeTooltipClose = (0, $cozmU.useCallback)(()=>{
        setIsScopeTooltipOpen(false);
    }, []);
    const handleScopeTooltipTriggerClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        setIsScopeTooltipOpen((isOpen)=>!isOpen);
    }, []);
    const handleScopeTooltipTriggerKeyDown = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.key === 'Enter' || event_0.key === ' ') {
            event_0.preventDefault();
            event_0.stopPropagation();
            setIsScopeTooltipOpen((isOpen_0)=>!isOpen_0);
        }
    }, []);
    const description = isNewAllConversationScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, showTaskStatusFooterRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5fb9783c4b6e9b4$export$80b5b1a1eb299c96), {
        conversation: conversation,
        showStatusIcon: false
    }), !showTaskStatusFooterRow && shouldUseParticipantAgentInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0be9dddf1032155$export$ed4a0f979ae805b), {
        identities: agentFooterIdentities,
        cloudId: cloudId,
        textColor: footerTextColor
    }), !showTaskStatusFooterRow && shouldShowAgentInfo && conversation.agent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentNamedId: conversation.agent.agent_named_id,
        agentId: conversation.agent.agent_id,
        agentIdentityAccountId: conversation.agent.identity_account_id,
        size: "xxsmall",
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(conversation.agent.creator_type) : conversation.agent.creator_type === 'THIRD_PARTY' || conversation.agent.creator_type === 'FORGE',
        forgeAgentIconUrl: conversation.agent.forge_url
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        maxLines: 1,
        align: "start",
        color: footerTextColor
    }, agentName)), !showTaskStatusFooterRow && firstScope && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (shouldUseParticipantAgentInfo || shouldShowAgentInfo && conversation.agent) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: footerTextColor
    }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).footerSeparator)), isClickableScopeTooltipsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isScopeTooltipOpen,
        onClose: handleScopeTooltipClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
                placement: "bottom",
                role: "tooltip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $6a5007b6f001db50$var$styles.scopeTooltipContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, (scopes ?? []).map((scope, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: `${scope.link ?? 'scope'}-${index}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                    scope: scope,
                    variant: "tooltip",
                    maxLines: 2,
                    onFilePreview: (link, name)=>setFileScopePreview({
                            link: link,
                            name: name
                        }),
                    onScopeLinkClick: handleScopeLinkClicked
                })))))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                role: "button",
                tabIndex: 0,
                xcss: (0, $w6R6I.cx)($6a5007b6f001db50$var$styles.firstScopeTooltipTrigger, $6a5007b6f001db50$var$styles.firstScopeTooltipClickableTrigger),
                ...triggerProps,
                onClick: handleScopeTooltipTriggerClick,
                onKeyDown: handleScopeTooltipTriggerKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($6a5007b6f001db50$var$styles.scopeNameWrapper, $6a5007b6f001db50$var$styles.scopeNameClickableWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                scope: {
                    ...firstScope,
                    link: undefined
                },
                variant: "default",
                maxLines: 1,
                onScopeLinkHover: handleScopeLinkHovered
            })), scopesOverflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $6a5007b6f001db50$var$styles.scopeOverflowCount
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "span",
                size: "small",
                weight: "regular",
                align: "start",
                color: footerTextColor
            }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).scopesOverflowCount, {
                count: scopesOverflowCount
            })))))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, (scopes ?? []).map((scope_0, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: `${scope_0.link ?? 'scope'}-${index_0}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
                scope: scope_0,
                variant: "tooltip",
                maxLines: 2,
                onFilePreview: (link_0, name_0)=>setFileScopePreview({
                        link: link_0,
                        name: name_0
                    }),
                onScopeLinkClick: handleScopeLinkClicked
            })))),
        delay: 0,
        position: "bottom",
        tag: "span"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $6a5007b6f001db50$var$styles.firstScopeTooltipTrigger,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6a5007b6f001db50$var$styles.scopeNameWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eee1fcf3aa6b759$export$85b4c654d12206aa), {
            scope: firstScope,
            variant: "default",
            maxLines: 1,
            onFilePreview: (link_1, name_1)=>setFileScopePreview({
                    link: link_1,
                    name: name_1
                }),
            onScopeLinkClick: handleScopeLinkClicked,
            onScopeLinkHover: handleScopeLinkHovered
        })), scopesOverflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $6a5007b6f001db50$var$styles.scopeOverflowCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            size: "small",
            weight: "regular",
            align: "start",
            color: footerTextColor
        }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).scopesOverflowCount, {
            count: scopesOverflowCount
        }))))))), relativeTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (shouldUseParticipantAgentInfo || shouldShowAgentInfo && conversation.agent || firstScope || showTaskStatusFooterRow) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: footerTextColor
    }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).footerSeparator)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        maxLines: 1,
        align: "start",
        color: footerTextColor
    }, relativeTime))) : undefined;
    const onPinToggleClicked = (0, $cozmU.useCallback)((event_1)=>{
        event_1?.preventDefault();
        event_1?.stopPropagation();
        onConversationPinToggle?.(conversation, !conversation.isPinned);
        setIsMoreMenuOpen(false);
    }, [
        conversation,
        onConversationPinToggle
    ]);
    const pinLimitDescription = pinLimitError?.maxPinnedConversations !== undefined ? formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinLimitPopupDescriptionWithLimit, {
        limit: pinLimitError.maxPinnedConversations
    }) : formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinLimitPopupDescription);
    (0, $cozmU.useEffect)(()=>{
        if (!pinLimitError) return;
        showFlag({
            id: 'rovo-navigation.pin-limit',
            title: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinLimitPopupTitle),
            description: pinLimitDescription,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: "",
                color: "var(--ds-icon-information, #357DE8)"
            }),
            isAutoDismiss: true,
            autoDismissSeconds: 5
        });
        onDismissPinLimitError?.();
    }, [
        formatMessage,
        onDismissPinLimitError,
        pinLimitDescription,
        pinLimitError,
        showFlag
    ]);
    const pinnedIndicator = isPinnedChatsEnabled && conversation.isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6a5007b6f001db50$var$styles.pinnedIndicator,
        testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-pinned-indicator-${testIdDisambiguator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6a5007b6f001db50$var$styles.pinnedIndicatorIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
        label: "",
        color: "currentColor",
        size: "small"
    }))) : null;
    const conversationListRowStatus = (0, $39042d5343910bf7$export$c3ada257199e2c2a)(conversation, shouldShowUnreadStatus);
    const shouldShowTrailingStatusSlot = isNewAllConversationScreenEnabled && (conversationListRowStatus !== undefined || shouldShowUnreadStatus);
    const shouldReserveTrailingStatusSlot = isNewAllConversationScreenEnabled && (shouldShowTrailingStatusSlot || isPinnedChatsEnabled && conversation.isPinned);
    const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6a5007b6f001db50$var$styles.elemAfterStyles
    }, shouldReserveTrailingStatusSlot ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6a5007b6f001db50$var$styles.statusContainer,
        testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-status-slot-${testIdDisambiguator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5fb9783c4b6e9b4$export$88ead18fb18a2576), {
        conversation: conversation,
        testId: shouldShowUnreadStatus ? `${0, $17a118af00cd097a$export$6e5abe1fde535897}-history-item-unread-indicator-${testIdDisambiguator}` : undefined
    })) : null, pinnedIndicator);
    const size = 'small'; // ── Callbacks ─────────────────────────────────────────────────────────
    const onSelect = (0, $cozmU.useCallback)((event_2)=>{
        event_2.preventDefault();
        onSelectConversation(conversation, isADSNavigationEnabled);
        setStagingAreaMode(undefined, undefined);
    }, [
        onSelectConversation,
        conversation,
        isADSNavigationEnabled,
        setStagingAreaMode
    ]);
    const onRename = (0, $cozmU.useMemo)(()=>{
        if (!onConversationRename) return undefined;
        return async (newName)=>{
            const result = await onConversationRename(conversation, newName);
            if (result?.hasError) return {
                error: 'Rename failed'
            };
            return undefined;
        };
    }, [
        onConversationRename,
        conversation
    ]);
    const onDelete = (0, $cozmU.useMemo)(()=>{
        if (!onConversationDelete) return undefined;
        return ()=>{
            onConversationDelete(conversation);
        };
    }, [
        onConversationDelete,
        conversation
    ]); // ── More-menu items (product-specific) ────────────────────────────────
    const pinMenuItem = onConversationPinToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-item-pin-menu-${testIdDisambiguator}`,
        iconBefore: conversation.isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW3nu))), {
            label: ""
        }),
        onClick: ()=>onPinToggleClicked()
    }, formatMessage(conversation.isPinned ? (0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuUnpinLabel : (0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuPinLabel)) : undefined;
    const moveToSpaceMenuItem = (onConversationMoveToSpace || onConversationMoveToNewSpace) && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0170fa3e3879ed84$export$9ee63a73ceca6213), {
        testIdDisambiguator: testIdDisambiguator,
        conversation: conversation,
        spaces: spaces,
        isLoadingSpaces: isLoadingSpaces,
        spaceEmojiProvider: spaceEmojiProvider,
        onConversationMoveToSpace: onConversationMoveToSpace,
        onConversationMoveToNewSpace: onConversationMoveToNewSpace,
        onClose: ()=>{}
    }) : undefined;
    const moreMenuItems = pinMenuItem || moveToSpaceMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, pinMenuItem, moveToSpaceMenuItem) : undefined; // ── After content (modals) ────────────────────────────────────────────
    const afterContent = fileScopePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcfb7982faac66d1$export$298d258c84f7f125), {
        isOpen: true,
        onClose: ()=>setFileScopePreview(null),
        fileUrl: fileScopePreview.link,
        fileName: fileScopePreview.name,
        formatMessage: formatMessage,
        filePreviewFallbackDescription: (0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).filePreviewFallbackDescription,
        cloudId: cloudId
    }) : null; // ── renderContainer ───────────────────────────────────────────────────
    const renderContainer = (0, $cozmU.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            isContentTooltipDisabled: true,
            href: "#",
            testId: props.testId,
            level: level,
            onClick: props.onClick,
            listItemRef: listItemRef,
            actionsOnHover: props.actionsOnHover,
            isSelected: props.isSelected,
            isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
            size: props.size,
            elemBefore: (0, $17a118af00cd097a$export$f4b8e24fae579c6f),
            noActiveBackground: true,
            description: isNewAllConversationScreenEnabled ? props.description : undefined,
            elemAfter: props.elemAfter
        }, props.children), [
        isADSNavigationEnabled,
        isNewAllConversationScreenEnabled,
        level,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $197635bcddff2f9b$export$8a74b6c2b6abee5c), {
        id: conversation.id,
        name: conversation.name,
        description: description,
        elemAfter: elemAfter,
        isSelected: isSelected,
        size: size,
        onSelect: onSelect,
        onRename: onRename,
        onDelete: onDelete,
        moreMenuItems: moreMenuItems,
        isMoreMenuOpen: isMoreMenuOpen,
        onMoreMenuOpenChange: setIsMoreMenuOpen,
        renderContainer: renderContainer,
        afterContent: afterContent,
        testId: testId,
        renameLabel: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuRenameLabel),
        deleteLabel: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).moreMenuDeleteLabel),
        moreButtonLabel: formatMessage((0, $64737d6851b9a149$export$2e2bcd8739ae039).moreBtnLabel),
        renameInputLabel: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).renameInputLabel),
        confirmRenameLabel: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).confirmRenameLabel),
        cancelRenameLabel: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).cancelRenameLabel)
    });
};
const $6a5007b6f001db50$var$listStyles = {
    noPaddingInlineStart: "_0LQT5EPgdg"
};
const $6a5007b6f001db50$var$prefersReducedMotionQuery = '(prefers-reduced-motion: reduce)';
const $6a5007b6f001db50$var$pinReorderAnimatingAttribute = 'data-pin-reorder-animating';
const $6a5007b6f001db50$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
const $6a5007b6f001db50$var$pinReorderAnimationTransition = `transform ${"var(--ds-duration-medium, 200ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`;
const $6a5007b6f001db50$var$shouldReduceMotion = ()=>typeof window !== 'undefined' && window.matchMedia?.($6a5007b6f001db50$var$prefersReducedMotionQuery).matches === true;
const $6a5007b6f001db50$export$df7dcd72c7c1c33f = ({ conversations: conversations = [], pinnedCountConversations: pinnedCountConversations, pinnedConversationSummary: pinnedConversationSummary, currentConversation: currentConversation, onViewAllConversations: onViewAllConversations, onConversationPinToggle: onConversationPinToggle, isADSNavigationEnabled: isADSNavigationEnabled, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled = false, isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled = false, cloudId: cloudId = '', ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isPinnedChatsEnabled = (0, $iDrrr.fg)('rovo_chat_pinned_fe');
    const conversationRowRefs = (0, $cozmU.useRef)(new Map());
    const previousRowRectsForPinReorder = (0, $cozmU.useRef)(null);
    const shouldAnimateNextPinReorder = (0, $cozmU.useRef)(false);
    const activePinReorderAnimationCleanups = (0, $cozmU.useRef)([]);
    const clearPinReorderAnimations = (0, $cozmU.useCallback)(()=>{
        for (const cleanup of activePinReorderAnimationCleanups.current)cleanup();
        activePinReorderAnimationCleanups.current = [];
    }, []);
    const captureConversationRowRects = (0, $cozmU.useCallback)(()=>{
        const rowRects = new Map();
        for (const [conversationId, element] of conversationRowRefs.current)rowRects.set(conversationId, element.getBoundingClientRect());
        return rowRects;
    }, []);
    const captureRowsForPinReorder = (0, $cozmU.useCallback)(()=>{
        previousRowRectsForPinReorder.current = captureConversationRowRects();
        shouldAnimateNextPinReorder.current = true;
    }, [
        captureConversationRowRects
    ]);
    const { applyOptimisticPinnedState: applyOptimisticPinnedState, compareConversationsByPinnedState: compareConversationsByPinnedState, handleConversationPinToggle: handleConversationPinToggle, pinLimitError: pinLimitError, dismissPinLimitError: dismissPinLimitError } = (0, $dda2afeb0cbe58b3$export$8ff043454eb02908)({
        conversations: conversations,
        pinnedCountConversations: pinnedCountConversations,
        pinnedConversationSummary: pinnedConversationSummary,
        isPinnedChatsEnabled: isPinnedChatsEnabled,
        onConversationPinToggle: onConversationPinToggle,
        onBeforeOptimisticStateChange: captureRowsForPinReorder
    });
    const filteredConversations = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const visibleConversations = conversations.filter((convo)=>!convo.isEmpty && // Exclude space-scoped conversations from the regular list — they are
            // rendered inside `SpaceMenuItems` instead.
            (!convo.rovoSpaceId || !(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)));
        if (!isPinnedChatsEnabled) return visibleConversations;
        return visibleConversations.map((conversation)=>{
            return applyOptimisticPinnedState(conversation);
        });
    }, [
        applyOptimisticPinnedState,
        conversations,
        isPinnedChatsEnabled
    ]);
    const conversationsOrderedByPinnedState = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>isPinnedChatsEnabled ? [
            ...filteredConversations
        ].sort(compareConversationsByPinnedState) : filteredConversations, [
        compareConversationsByPinnedState,
        filteredConversations,
        isPinnedChatsEnabled
    ]);
    $6a5007b6f001db50$var$useIsomorphicLayoutEffect(()=>{
        if (!shouldAnimateNextPinReorder.current) return;
        shouldAnimateNextPinReorder.current = false;
        const previousRowRects = previousRowRectsForPinReorder.current;
        previousRowRectsForPinReorder.current = null;
        if (!previousRowRects) {
            clearPinReorderAnimations();
            return;
        }
        clearPinReorderAnimations();
        if ($6a5007b6f001db50$var$shouldReduceMotion()) return;
        const movedRows = [];
        for (const [conversationId_0, element_0] of conversationRowRefs.current){
            const previousRect = previousRowRects.get(conversationId_0);
            if (!previousRect) continue;
            const currentRect = element_0.getBoundingClientRect();
            const deltaY = previousRect.top - currentRect.top;
            if (deltaY === 0) continue;
            element_0.style.transform = `translateY(${deltaY}px)`;
            element_0.style.transition = 'none';
            element_0.setAttribute($6a5007b6f001db50$var$pinReorderAnimatingAttribute, 'true');
            movedRows.push(element_0);
        }
        const startAnimation = ()=>{
            activePinReorderAnimationCleanups.current = movedRows.map((element_1)=>{
                element_1.style.transform = '';
                element_1.style.transition = $6a5007b6f001db50$var$pinReorderAnimationTransition;
                const cleanup_0 = (0, $cbY7C.bind)(element_1, {
                    type: 'transitionend',
                    listener: ()=>{
                        element_1.style.transition = '';
                        element_1.removeAttribute($6a5007b6f001db50$var$pinReorderAnimatingAttribute);
                        cleanup_0();
                    }
                });
                return cleanup_0;
            });
        };
        if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(startAnimation);
        else window.setTimeout(startAnimation, 0);
    }, [
        clearPinReorderAnimations,
        conversationsOrderedByPinnedState
    ]);
    (0, $cozmU.useEffect)(()=>clearPinReorderAnimations, [
        clearPinReorderAnimations
    ]);
    const groupedConversations = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!isPinnedChatsEnabled) return (0, $b2c44d37af3ec21e$export$99ff128bd67e6b2a)(filteredConversations, formatMessage);
        const pinnedConversations = filteredConversations.filter((conversation_0)=>conversation_0.isPinned).sort(compareConversationsByPinnedState);
        const unpinnedConversations = filteredConversations.filter((conversation_1)=>!conversation_1.isPinned);
        const timeGroups = (0, $b2c44d37af3ec21e$export$99ff128bd67e6b2a)(unpinnedConversations, formatMessage);
        if (pinnedConversations.length === 0) return timeGroups;
        return [
            {
                label: formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).pinnedConversationsLabel),
                conversations: pinnedConversations
            },
            ...timeGroups
        ];
    }, [
        compareConversationsByPinnedState,
        filteredConversations,
        formatMessage,
        isPinnedChatsEnabled
    ]);
    const onViewAllConversationsClick = (0, $cozmU.useCallback)(()=>{
        onViewAllConversations();
    }, [
        onViewAllConversations
    ]);
    const spaces = (0, $12shJ.useSpaces)();
    const isLoadingSpaces = (0, $12shJ.useSpacesLoading)();
    const spaceEmojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProvider)(cloudId), [
        cloudId
    ]);
    const renderConversationList = (group, groupIndex)=>{
        const listItems = group.conversations.map((convo_0, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6a5007b6f001db50$export$8a74b6c2b6abee5c, {
                isADSNavigationEnabled: isADSNavigationEnabled,
                key: convo_0.id,
                testIdDisambiguator: `${groupIndex}-${i}`,
                conversation: convo_0,
                isSelected: convo_0.id === currentConversation?.id,
                isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
                isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
                spaces: spaces,
                isLoadingSpaces: isLoadingSpaces,
                spaceEmojiProvider: spaceEmojiProvider,
                cloudId: cloudId,
                isPinnedChatsEnabled: isPinnedChatsEnabled,
                listItemRef: (element_2)=>{
                    if (element_2) conversationRowRefs.current.set(convo_0.id, element_2);
                    else conversationRowRefs.current.delete(convo_0.id);
                },
                ...props,
                onConversationPinToggle: isPinnedChatsEnabled && onConversationPinToggle ? handleConversationPinToggle : undefined,
                pinLimitError: pinLimitError?.conversationId === convo_0.id ? {
                    maxPinnedConversations: pinLimitError.maxPinnedConversations
                } : undefined,
                onDismissPinLimitError: ()=>{
                    dismissPinLimitError(convo_0.id);
                }
            }));
        if (isADSNavigationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), {
            testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-items-${groupIndex}`
        }, listItems);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), {
            testId: `${(0, $17a118af00cd097a$export$6e5abe1fde535897)}-history-items-${groupIndex}`,
            xcss: $6a5007b6f001db50$var$listStyles.noPaddingInlineStart
        }, listItems);
    };
    const grouped = groupedConversations.map((group_0, groupIndex_0)=>{
        const conversationList = renderConversationList(group_0, groupIndex_0);
        const MenuSectionComponent = isADSNavigationEnabled ? (0, $gmhHk.MenuSection) : (0, $5ac90360b1975343$export$4b1545b4f2016d26);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MenuSectionComponent, {
            key: group_0.label,
            isMenuListItem: true
        }, isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4X3mP.MenuSectionHeading), null, group_0.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d04b687461f45ce4$export$5d3acdbf9237a364), {
            label: group_0.label
        }, group_0.label), conversationList);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isNewAllConversationScreenEnabled ? renderConversationList({
        label: '',
        conversations: conversationsOrderedByPinnedState
    }, 0) : grouped, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        }),
        onClick: onViewAllConversationsClick
    }, formatMessage((0, $af0ff7e9652e4f45$export$2e2bcd8739ae039).viewAllConversationsLabel)));
};
function $6a5007b6f001db50$var$_temp(isOpen) {
    return !isOpen;
}
function $6a5007b6f001db50$var$_temp2(isOpen_0) {
    return !isOpen_0;
}
function $6a5007b6f001db50$var$_temp3() {}



























var $k1EQf = parcelRequire("k1EQf");




const $90544712b2798143$export$2a0d25937a8f377 = (0, $kSwu1.defineMessages)({
    title: {
        id: "side-nav.chat-error.title",
        defaultMessage: "We're not sure what went wrong"
    },
    description: {
        id: "side-nav.chat-error.description",
        defaultMessage: "Return to chat"
    }
});


function $cf792a29e2cd7485$var$_defineProperty(e, r, t) {
    return (r = $cf792a29e2cd7485$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cf792a29e2cd7485$var$_toPropertyKey(t) {
    var i = $cf792a29e2cd7485$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cf792a29e2cd7485$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $cf792a29e2cd7485$var$styles = {
    button: "_30huDKYbGa _0KLXru66of _3iDTPbS8kF _1UtDYzM7Tp _0wOv4Q7zJH _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg",
    wrapper: "_2Y7lL4Va5s _0jFU0VN91d",
    marginTop: "_313842NHnM"
};
const $cf792a29e2cd7485$var$ErrorView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { onClose: onClose } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== onClose) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: $cf792a29e2cd7485$var$styles.button,
                onClick: onClose
            }, formatMessage((0, $90544712b2798143$export$2a0d25937a8f377).description));
        $[0] = formatMessage;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const getDescriptionRender = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k1EQf.WarningIllustration), null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $90544712b2798143$export$2a0d25937a8f377).title);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== getDescriptionRender) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, getDescriptionRender());
        $[8] = getDescriptionRender;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            columnGap: "space.100",
            alignItems: "center",
            justifyContent: "center",
            direction: "column",
            xcss: $cf792a29e2cd7485$var$styles.wrapper,
            testId: "ai-mate-generic-error"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $cf792a29e2cd7485$var$styles.marginTop,
            space: "space.150",
            alignInline: "center"
        }, t4, t5));
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ error: error, experienceName: experienceName, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getDescriptionRender = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $cf792a29e2cd7485$var$styles.button,
            onClick: onClose
        }, formatMessage((0, $90544712b2798143$export$2a0d25937a8f377).description));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        columnGap: "space.100",
        alignItems: "center",
        justifyContent: "center",
        direction: "column",
        xcss: $cf792a29e2cd7485$var$styles.wrapper,
        testId: "ai-mate-generic-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k1EQf.WarningIllustration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $cf792a29e2cd7485$var$styles.marginTop,
        space: "space.150",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, formatMessage((0, $90544712b2798143$export$2a0d25937a8f377).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, getDescriptionRender())));
};
class $cf792a29e2cd7485$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        if (this.props.rethrowErrors) throw error;
    }
    render() {
        const { error: error } = this.state;
        const { children: children, experienceName: experienceName, onClose: onClose } = this.props;
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf792a29e2cd7485$var$ErrorView, {
            error: error,
            experienceName: experienceName,
            onClose: onClose
        });
        return children;
    }
    constructor(...args){
        super(...args);
        $cf792a29e2cd7485$var$_defineProperty(this, "state", {});
        $cf792a29e2cd7485$var$_defineProperty(this, "resetError", ()=>{
            this.setState({
                error: undefined
            });
        });
    }
}
$cf792a29e2cd7485$var$_defineProperty($cf792a29e2cd7485$export$e926676385687eaf, "displayName", 'RovoNavigationErrorBoundary');





















var $d5um7 = parcelRequire("d5um7");

var $jZuGB = parcelRequire("jZuGB");

var $gMhPZ = parcelRequire("gMhPZ");






















const $c26b9871f2cfcd92$var$iconStyles = {
    chevron: "_3iDTPbismd _4lYzgRyz1h",
    providedElemBefore: "_3iDTPbC5M9",
    providedElemBeforeSelected: "_1UtDYzrFwf"
};
const $c26b9871f2cfcd92$export$af3ee08a0a9ad325 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore } = t0;
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const t1 = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    let t2;
    if ($[0] !== ChevronIcon || $[1] !== iconProps || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
            ...iconProps,
            label: "",
            color: t1,
            size: "small"
        });
        $[0] = ChevronIcon;
        $[1] = iconProps;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const chevronElem = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $c26b9871f2cfcd92$var$iconStyles.chevron
        ]);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== chevronElem) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, chevronElem);
        $[5] = chevronElem;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isSelected || $[8] !== providedElemBefore) {
        t5 = providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $c26b9871f2cfcd92$var$iconStyles.providedElemBefore,
                isSelected && $c26b9871f2cfcd92$var$iconStyles.providedElemBeforeSelected
            ])
        }, providedElemBefore);
        $[7] = isSelected;
        $[8] = providedElemBefore;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $c26b9871f2cfcd92$var$iconStyles.chevron
        ])
    }, chevronElem), providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $c26b9871f2cfcd92$var$iconStyles.providedElemBefore,
            isSelected && $c26b9871f2cfcd92$var$iconStyles.providedElemBeforeSelected
        ])
    }, providedElemBefore));
};


const $3dd18f20883d939a$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $3dd18f20883d939a$var$wrapperStyles = {
    root: "_3RTSTAQ4SZ _2MvGBxYbGa",
    showProvidedElemBefore: "_3RTSTAYbGa _2MvGBxcK7c _23YlFVQ4SZ _065GkbYbGa _0Jml7pQ4SZ _4sQNN8Q4SZ _2zl65PYbGa _1FfrqxYbGa"
};
const $3dd18f20883d939a$var$listContentStyles = {
    noPadding: "_0LQT5EdnbC",
    content: "_0LQT5ExpxF",
    collapsedContent: "_3iDTPbYbGa"
}; /** support 1 level of nesting. For now, all expandable side nav items are at level 0 */ 
const $3dd18f20883d939a$var$LEVEL = 0; /**
                  * An expandable button menu item which holds expandable logic and styles
                  *
                  * rovo-navigation
                  * This component combines ExpandableMenuItem, ExpandableMenuItemTrigger, and ExpandableMenuItemContent
                  * from design-system/navigation system. This is to reduce complexity and for our side panel use-case.
                  */ 
const $3dd18f20883d939a$export$341dea48c30b36ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, onExpansionToggle: onExpansionToggleProp, children: children, testId: testId, interactionName: interactionName, title: title, defaultExpanded: t1, shouldExpand: t2, isADSNavigationEnabled: isADSNavigationEnabled, suppressListPadding: suppressListPadding } = t0;
    const defaultExpanded = t1 === undefined ? false : t1;
    const shouldExpand = t2 === undefined ? false : t2;
    const id = (0, $cozmU.useId)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const itemRef = (0, $cozmU.useRef)(null);
    const prevShouldExpandRef = (0, $cozmU.useRef)(false);
    let t3;
    let t4;
    if ($[0] !== shouldExpand) {
        t3 = ()=>{
            if (shouldExpand && !prevShouldExpandRef.current) setIsExpanded(true);
            prevShouldExpandRef.current = shouldExpand;
        };
        t4 = [
            shouldExpand
        ];
        $[0] = shouldExpand;
        $[1] = t3;
        $[2] = t4;
    } else {
        t3 = $[1];
        t4 = $[2];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[3] !== onExpansionToggleProp) {
        t5 = ()=>{
            setIsExpanded($3dd18f20883d939a$var$_temp);
            onExpansionToggleProp?.();
        };
        $[3] = onExpansionToggleProp;
        $[4] = t5;
    } else t5 = $[4];
    const onExpansionToggle = t5;
    let t6;
    if ($[5] !== isExpanded || $[6] !== onClick) {
        t6 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent, {
                isExpanded: !isExpanded
            });
            setIsExpanded($3dd18f20883d939a$var$_temp2);
        };
        $[5] = isExpanded;
        $[6] = onClick;
        $[7] = t6;
    } else t6 = $[7];
    const handleMenuContentClick = t6;
    let t7;
    if ($[8] !== isExpanded || $[9] !== isSelected || $[10] !== providedElemBefore) {
        t7 = (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c26b9871f2cfcd92$export$af3ee08a0a9ad325), {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            });
        $[8] = isExpanded;
        $[9] = isSelected;
        $[10] = providedElemBefore;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = testId ? `${testId}--elem-before-button` : undefined;
    const t9 = href ? 0 : -1;
    const t10 = href ? undefined : true;
    let t11;
    if ($[12] !== id || $[13] !== interactionName || $[14] !== isExpanded || $[15] !== onExpansionToggle || $[16] !== t10 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: t7,
            "aria-expanded": isExpanded,
            "aria-labelledby": id,
            label: "",
            appearance: "subtle",
            spacing: "compact",
            onClick: onExpansionToggle,
            interactionName: interactionName,
            testId: t8,
            tabIndex: t9,
            "aria-hidden": t10
        });
        $[12] = id;
        $[13] = interactionName;
        $[14] = isExpanded;
        $[15] = onExpansionToggle;
        $[16] = t10;
        $[17] = t7;
        $[18] = t8;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    const elemBefore = t11;
    let t12;
    if ($[21] !== actions || $[22] !== actionsOnHover || $[23] !== children || $[24] !== defaultExpanded || $[25] !== elemAfter || $[26] !== elemBefore || $[27] !== handleMenuContentClick || $[28] !== href || $[29] !== id || $[30] !== interactionName || $[31] !== isADSNavigationEnabled || $[32] !== isExpanded || $[33] !== isSelected || $[34] !== onExpansionToggle || $[35] !== providedElemBefore || $[36] !== suppressListPadding || $[37] !== testId || $[38] !== title) {
        t12 = isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
            isExpanded: isExpanded,
            isDefaultExpanded: defaultExpanded,
            onExpansionToggle: onExpansionToggle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemAfter: elemAfter,
            elemBefore: providedElemBefore,
            href: href,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            onClick: handleMenuContentClick
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: itemRef,
            className: (0, $hekY6.default)([
                $3dd18f20883d939a$var$wrapperStyles.root,
                providedElemBefore && $3dd18f20883d939a$var$wrapperStyles.showProvidedElemBefore
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            testId: testId,
            interactionName: interactionName,
            level: $3dd18f20883d939a$var$LEVEL
        }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), {
            xcss: (0, $k12R1.cx)($3dd18f20883d939a$var$listContentStyles.content, !isExpanded && $3dd18f20883d939a$var$listContentStyles.collapsedContent, suppressListPadding && $3dd18f20883d939a$var$listContentStyles.noPadding)
        }, children));
        $[21] = actions;
        $[22] = actionsOnHover;
        $[23] = children;
        $[24] = defaultExpanded;
        $[25] = elemAfter;
        $[26] = elemBefore;
        $[27] = handleMenuContentClick;
        $[28] = href;
        $[29] = id;
        $[30] = interactionName;
        $[31] = isADSNavigationEnabled;
        $[32] = isExpanded;
        $[33] = isSelected;
        $[34] = onExpansionToggle;
        $[35] = providedElemBefore;
        $[36] = suppressListPadding;
        $[37] = testId;
        $[38] = title;
        $[39] = t12;
    } else t12 = $[39];
    return t12;
} : ({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, onExpansionToggle: onExpansionToggleProp, children: children, testId: testId, interactionName: interactionName, title: title, defaultExpanded: defaultExpanded = false, shouldExpand: shouldExpand = false, isADSNavigationEnabled: isADSNavigationEnabled, suppressListPadding: suppressListPadding })=>{
    const id = (0, $cozmU.useId)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const itemRef = (0, $cozmU.useRef)(null); // Open on each false -> true transition of `shouldExpand` (initial ref is false so a mount with
    // `shouldExpand` already true also opens). Only opens, never collapses, so manual collapse sticks.
    const prevShouldExpandRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (shouldExpand && !prevShouldExpandRef.current) setIsExpanded(true);
        prevShouldExpandRef.current = shouldExpand;
    }, [
        shouldExpand
    ]);
    const onExpansionToggle = (0, $cozmU.useCallback)(()=>{
        setIsExpanded((prevExpanded)=>!prevExpanded);
        onExpansionToggleProp?.();
    }, [
        setIsExpanded,
        onExpansionToggleProp
    ]);
    const handleMenuContentClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isExpanded: !isExpanded
        });
        setIsExpanded((prevExpanded_0)=>!prevExpanded_0);
    }, [
        onClick,
        setIsExpanded,
        isExpanded
    ]); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c26b9871f2cfcd92$export$af3ee08a0a9ad325), {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: onExpansionToggle,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined,
        // and already exposes its own aria-expanded state. Without these props the chevron would
        // be a duplicate tab stop and would announce the expanded state twice to screen readers
        // (since aria-labelledby and aria-expanded above would still expose it in virtual mode).
        tabIndex: href ? 0 : -1,
        "aria-hidden": href ? undefined : true
    });
    return isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
        isExpanded: isExpanded,
        isDefaultExpanded: defaultExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemAfter: elemAfter,
        elemBefore: providedElemBefore,
        href: href,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        onClick: handleMenuContentClick
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: itemRef,
        className: (0, $hekY6.default)([
            $3dd18f20883d939a$var$wrapperStyles.root,
            providedElemBefore && $3dd18f20883d939a$var$wrapperStyles.showProvidedElemBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f079422b0c2e0ccb$export$859b390bf71e044e), {
        id: id,
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: elemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        testId: testId,
        interactionName: interactionName,
        level: $3dd18f20883d939a$var$LEVEL
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), {
        xcss: (0, $k12R1.cx)($3dd18f20883d939a$var$listContentStyles.content, !isExpanded && $3dd18f20883d939a$var$listContentStyles.collapsedContent, suppressListPadding && $3dd18f20883d939a$var$listContentStyles.noPadding)
    }, children));
};
function $3dd18f20883d939a$var$_temp(prevExpanded) {
    return !prevExpanded;
}
function $3dd18f20883d939a$var$_temp2(prevExpanded_0) {
    return !prevExpanded_0;
}





const $5d280d9e682edacd$var$message = (0, $kSwu1.defineMessages)({
    newChatLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.new-chat",
        defaultMessage: "New chat"
    },
    agentListLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.agent-list",
        defaultMessage: "Agents"
    },
    createAgentLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.create-agent-label",
        defaultMessage: "Create Agent"
    },
    chatListLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.chat-list",
        defaultMessage: "Chats"
    },
    closeSideNavLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.close-side-nav",
        defaultMessage: "Close"
    },
    giveFeedbackLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.give-feedback",
        defaultMessage: "Give feedback"
    },
    pulseLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.pulse",
        defaultMessage: "Insights"
    },
    tasksLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.tasks",
        defaultMessage: "Tasks"
    },
    spacesSectionLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.spaces-section",
        defaultMessage: "Rovo spaces"
    },
    createSpaceLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.create-rovo-space",
        defaultMessage: "Create Rovo space"
    },
    recommendedSpaces: {
        id: "ai-mate.rovo-navigation.side-navigation.recommended-spaces",
        defaultMessage: "Recommended Rovo spaces"
    },
    recommendedSpacesLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.recommended-spaces-label",
        defaultMessage: "Recommended Rovo spaces"
    }
});
var $5d280d9e682edacd$export$2e2bcd8739ae039 = $5d280d9e682edacd$var$message;


















var $jsuJ9 = parcelRequire("jsuJ9");

var $eCqXP = parcelRequire("eCqXP");




const $399e940a29a5270a$var$message = (0, $kSwu1.defineMessages)({
    resizeSideNavLabel: {
        id: "ai-mate.rovo-navigation.side-navigation.container.resize",
        defaultMessage: "Resize side navigation"
    }
});
var $399e940a29a5270a$export$2e2bcd8739ae039 = $399e940a29a5270a$var$message;


const $96dd730eb6425cb7$var$styles = {
    root: "_4bt5LAIZbP _2WAcuGIZbP _24h04i2Njc _0jFU0VN91d _39xV02OLYo _0KLXrulfZc",
    rootMiniModal: "_0bjKvDuMRm _0KLXruqi9L",
    flexContainer: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3"
};
const $96dd730eb6425cb7$export$8fcb66c67faddd65 = 'is-rovo-sidenav-collapsed';
const $96dd730eb6425cb7$var$NAV_WIDTH_KEY = 'rovo-sidenav-width';
const $96dd730eb6425cb7$var$DEFAULT_SIDE_NAV_WIDTH = 320;
const $96dd730eb6425cb7$var$getSideNavWidth = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const width = window.localStorage.getItem($96dd730eb6425cb7$var$NAV_WIDTH_KEY);
    return width && Number.parseInt(width) || $96dd730eb6425cb7$var$DEFAULT_SIDE_NAV_WIDTH;
}; // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
const $96dd730eb6425cb7$var$isSideNavCollapsed = ()=>window.localStorage.getItem($96dd730eb6425cb7$export$8fcb66c67faddd65) === 'true';
const $96dd730eb6425cb7$export$f83856b077b0513d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { testId: testId, children: children, maxWidth: maxWidth, maxHeight: maxHeight, zIndex: zIndex, isMiniModal: t1, isADSNavigationEnabled: isADSNavigationEnabled } = t0;
    const isMiniModal = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = $96dd730eb6425cb7$var$getSideNavWidth();
        $[0] = t2;
    } else t2 = $[0];
    const defaultWidth = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = $96dd730eb6425cb7$var$isSideNavCollapsed();
        $[1] = t3;
    } else t3 = $[1];
    const defaultCollapsed = t3;
    const onToggle = $96dd730eb6425cb7$var$_temp;
    const onResize = $96dd730eb6425cb7$var$_temp2;
    let t4;
    if ($[2] !== children || $[3] !== formatMessage || $[4] !== isADSNavigationEnabled || $[5] !== isMiniModal || $[6] !== maxHeight || $[7] !== maxWidth || $[8] !== testId || $[9] !== zIndex) {
        t4 = isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCqXP.SideNav), {
            defaultWidth: defaultWidth,
            onCollapse: ()=>onToggle(true),
            onExpand: ()=>onToggle(false),
            defaultCollapsed: defaultCollapsed,
            testId: testId
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
            label: formatMessage((0, $399e940a29a5270a$export$2e2bcd8739ae039).resizeSideNavLabel),
            onResizeEnd: onResize
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            style: {
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                zIndex: zIndex
            },
            className: (0, $hekY6.default)([
                $96dd730eb6425cb7$var$styles.root,
                isMiniModal && $96dd730eb6425cb7$var$styles.rootMiniModal
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $96dd730eb6425cb7$var$styles.flexContainer
            ])
        }, children));
        $[2] = children;
        $[3] = formatMessage;
        $[4] = isADSNavigationEnabled;
        $[5] = isMiniModal;
        $[6] = maxHeight;
        $[7] = maxWidth;
        $[8] = testId;
        $[9] = zIndex;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ testId: testId, children: children, maxWidth: maxWidth, maxHeight: maxHeight, zIndex: zIndex, isMiniModal: isMiniModal = false, isADSNavigationEnabled: isADSNavigationEnabled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const defaultWidth = $96dd730eb6425cb7$var$getSideNavWidth();
    const defaultCollapsed = $96dd730eb6425cb7$var$isSideNavCollapsed();
    const onToggle = (isCollapsed)=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem($96dd730eb6425cb7$export$8fcb66c67faddd65, isCollapsed.toString());
    };
    const onResize = (options)=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem($96dd730eb6425cb7$var$NAV_WIDTH_KEY, String(options.finalWidth));
    };
    return isADSNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCqXP.SideNav), {
        defaultWidth: defaultWidth,
        onCollapse: ()=>onToggle(true),
        onExpand: ()=>onToggle(false),
        defaultCollapsed: defaultCollapsed,
        testId: testId
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
        label: formatMessage((0, $399e940a29a5270a$export$2e2bcd8739ae039).resizeSideNavLabel),
        onResizeEnd: onResize
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        style: {
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            zIndex: zIndex
        },
        className: (0, $hekY6.default)([
            $96dd730eb6425cb7$var$styles.root,
            isMiniModal && $96dd730eb6425cb7$var$styles.rootMiniModal
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $96dd730eb6425cb7$var$styles.flexContainer
        ])
    }, children));
};
function $96dd730eb6425cb7$var$_temp(isCollapsed) {
    window.localStorage.setItem($96dd730eb6425cb7$export$8fcb66c67faddd65, isCollapsed.toString());
}
function $96dd730eb6425cb7$var$_temp2(options) {
    window.localStorage.setItem($96dd730eb6425cb7$var$NAV_WIDTH_KEY, String(options.finalWidth));
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $4oUV5 = parcelRequire("4oUV5");


const $beb818796d9fb44a$export$babe3c784778f3ba = /*#__PURE__*/ (0, $cozmU.forwardRef)($beb818796d9fb44a$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $beb818796d9fb44a$var$styles = {
    scrollContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2WAcuGIZbP",
    paddingContainer: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
};
function $beb818796d9fb44a$var$_SideNavContent({ children: children, testId: testId, isADSNavigationEnabled: isADSNavigationEnabled }, ref) {
    return isADSNavigationEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $4oUV5.SideNavBody), {
        ref: ref,
        testId: testId
    }, children) : /*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $beb818796d9fb44a$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $beb818796d9fb44a$var$styles.paddingContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), null, children)));
}





























































































const $36ca9e0df2729bf2$export$87352277df45d72e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            focusable: "false"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0.999756 13V3C0.999756 1.89543 1.89519 1 2.99976 1H6.5603L8.3103 2.75H12.9998C14.1043 2.75 14.9998 3.64543 14.9998 4.75V7.5H2.49976V13C2.49976 13.2761 2.72361 13.5 2.99976 13.5H7.49976V15H2.99976C1.89519 15 0.999756 14.1046 0.999756 13ZM2.49976 6H13.4998V4.75C13.4998 4.47386 13.2759 4.25 12.9998 4.25H7.68921L5.93921 2.5H2.99976C2.72361 2.5 2.49976 2.72386 2.49976 3V6Z",
            fill: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.6162 9.00879C12.8828 9.05042 13.1106 9.23402 13.2051 9.49316L13.8193 11.1797L15.5068 11.7949C15.8029 11.9029 16 12.1849 16 12.5L15.9912 12.6162C15.9496 12.8828 15.766 13.1106 15.5068 13.2051L13.8193 13.8193L13.2051 15.5068C13.1106 15.766 12.8828 15.9496 12.6162 15.9912L12.5 16C12.1849 16 11.9029 15.8029 11.7949 15.5068L11.1797 13.8193L9.49316 13.2051C9.23402 13.1106 9.05042 12.8828 9.00879 12.6162L9 12.5C9 12.1849 9.19714 11.9029 9.49316 11.7949L11.1797 11.1797L11.7949 9.49316L11.8438 9.38672C11.9557 9.1844 12.1553 9.04447 12.3838 9.00879L12.5 9L12.6162 9.00879Z",
            fill: "currentColor"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": testId
        }, t1);
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0.999756 13V3C0.999756 1.89543 1.89519 1 2.99976 1H6.5603L8.3103 2.75H12.9998C14.1043 2.75 14.9998 3.64543 14.9998 4.75V7.5H2.49976V13C2.49976 13.2761 2.72361 13.5 2.99976 13.5H7.49976V15H2.99976C1.89519 15 0.999756 14.1046 0.999756 13ZM2.49976 6H13.4998V4.75C13.4998 4.47386 13.2759 4.25 12.9998 4.25H7.68921L5.93921 2.5H2.99976C2.72361 2.5 2.49976 2.72386 2.49976 3V6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.6162 9.00879C12.8828 9.05042 13.1106 9.23402 13.2051 9.49316L13.8193 11.1797L15.5068 11.7949C15.8029 11.9029 16 12.1849 16 12.5L15.9912 12.6162C15.9496 12.8828 15.766 13.1106 15.5068 13.2051L13.8193 13.8193L13.2051 15.5068C13.1106 15.766 12.8828 15.9496 12.6162 15.9912L12.5 16C12.1849 16 11.9029 15.8029 11.7949 15.5068L11.1797 13.8193L9.49316 13.2051C9.23402 13.1106 9.05042 12.8828 9.00879 12.6162L9 12.5C9 12.1849 9.19714 11.9029 9.49316 11.7949L11.1797 11.1797L11.7949 9.49316L11.8438 9.38672C11.9557 9.1844 12.1553 9.04447 12.3838 9.00879L12.5 9L12.6162 9.00879Z",
        fill: "currentColor"
    })));





const $b444bf107ac01689$var$message = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "ai-mate.rovo-navigation.space-items.loading",
        defaultMessage: "Loading Rovo spaces\u2026"
    },
    recommendedSpaces: {
        id: "ai-mate.rovo-navigation.space-items.recommended-spaces",
        defaultMessage: "Recommended Rovo spaces"
    },
    moreMenuDeleteLabel: {
        id: "ai-mate.rovo-navigation.space-items.more-menu.delete",
        defaultMessage: "Delete"
    },
    moreMenuRenameLabel: {
        id: "ai-mate.rovo-navigation.space-items.more-menu.rename",
        defaultMessage: "Rename"
    },
    moreMenuLabel: {
        id: "ai-mate.rovo-navigation.space-items.more-menu.label",
        defaultMessage: "More options"
    },
    cancelRenameLabel: {
        id: "ai-mate.rovo-navigation.space-items.more-menu.cancel-rename",
        defaultMessage: "Cancel rename"
    },
    confirmRenameLabel: {
        id: "ai-mate.rovo-navigation.space-items.more-menu.confirm-rename",
        defaultMessage: "Confirm rename"
    },
    viewAllSpacesLabel: {
        id: "rovo-navigation.side-navigation.space-items.viewAllSpacesLabel",
        defaultMessage: "View all Rovo spaces"
    }
});
var $b444bf107ac01689$export$2e2bcd8739ae039 = $b444bf107ac01689$var$message;


const $33a5f27508fb8f75$var$SPACES_LIMIT = 5;
const $33a5f27508fb8f75$export$b669316dadef19fd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { cloudId: cloudId, isADSNavigationEnabled: isADSNavigationEnabled, onSelectSpace: onSelectSpace, selectedSpaceId: selectedSpaceId, product: product, experienceId: experienceId, onSelectRecommendedSpaces: onSelectRecommendedSpaces, isRecommendedSpacesSelected: t1, onSpaceDelete: onSpaceDelete, onSpaceRename: onSpaceRename, onNewChatButtonClick: onNewChatButtonClick, onViewAllSpacesClick: onViewAllSpacesClick, renderRecommendedSpacesItem: renderRecommendedSpacesItem } = t0;
    const isRecommendedSpacesSelected = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product) {
        t2 = {
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        };
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = t2;
    } else t2 = $[3];
    const { spaces: spaces, isLoading: isLoading } = (0, $9dT53.useListSpaces)(t2);
    let t3;
    if ($[4] !== cloudId) {
        t3 = (0, $d26Wq.createEmojiProvider)(cloudId);
        $[4] = cloudId;
        $[5] = t3;
    } else t3 = $[5];
    const emojiProvider = t3;
    let T0;
    let t4;
    let t5;
    let t6;
    if ($[6] !== cloudId || $[7] !== emojiProvider || $[8] !== experienceId || $[9] !== formatMessage || $[10] !== isADSNavigationEnabled || $[11] !== isLoading || $[12] !== isRecommendedSpacesSelected || $[13] !== onNewChatButtonClick || $[14] !== onSelectRecommendedSpaces || $[15] !== onSelectSpace || $[16] !== onSpaceDelete || $[17] !== onSpaceRename || $[18] !== product || $[19] !== renderRecommendedSpacesItem || $[20] !== selectedSpaceId || $[21] !== spaces) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const limitedSpaces = spaces.slice(0, $33a5f27508fb8f75$var$SPACES_LIMIT);
            if (isLoading) {
                let t7;
                if ($[26] !== formatMessage) {
                    t7 = formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).loadingLabel);
                    $[26] = formatMessage;
                    $[27] = t7;
                } else t7 = $[27];
                let t8;
                if ($[28] !== t7) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                        size: "small",
                        label: t7
                    }));
                    $[28] = t7;
                    $[29] = t8;
                } else t8 = $[29];
                t6 = t8;
                break bb0;
            }
            let t7;
            if ($[30] !== onSelectRecommendedSpaces) {
                t7 = (e)=>{
                    e.preventDefault();
                    onSelectRecommendedSpaces?.();
                };
                $[30] = onSelectRecommendedSpaces;
                $[31] = t7;
            } else t7 = $[31];
            let t8;
            if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36ca9e0df2729bf2$export$87352277df45d72e), null);
                $[32] = t8;
            } else t8 = $[32];
            let t9;
            if ($[33] !== formatMessage) {
                t9 = formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).recommendedSpaces);
                $[33] = formatMessage;
                $[34] = t9;
            } else t9 = $[34];
            let t10;
            if ($[35] !== isADSNavigationEnabled || $[36] !== isRecommendedSpacesSelected || $[37] !== t7 || $[38] !== t9) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
                    isADSNavigationEnabled: isADSNavigationEnabled,
                    href: "#",
                    isSelected: isRecommendedSpacesSelected,
                    testId: "rovo-chat-sidenav-recommended-spaces",
                    onClick: t7,
                    elemBefore: t8
                }, t9);
                $[35] = isADSNavigationEnabled;
                $[36] = isRecommendedSpacesSelected;
                $[37] = t7;
                $[38] = t9;
                $[39] = t10;
            } else t10 = $[39];
            const recommendedSpacesItem = t10;
            let t11;
            if ($[40] !== recommendedSpacesItem || $[41] !== renderRecommendedSpacesItem) {
                t11 = renderRecommendedSpacesItem ? renderRecommendedSpacesItem(recommendedSpacesItem) : recommendedSpacesItem;
                $[40] = recommendedSpacesItem;
                $[41] = renderRecommendedSpacesItem;
                $[42] = t11;
            } else t11 = $[42];
            const renderedRecommendedSpacesItem = t11;
            T0 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
            t4 = renderedRecommendedSpacesItem;
            let t12;
            if ($[43] !== cloudId || $[44] !== emojiProvider || $[45] !== experienceId || $[46] !== isADSNavigationEnabled || $[47] !== onNewChatButtonClick || $[48] !== onSelectSpace || $[49] !== onSpaceDelete || $[50] !== onSpaceRename || $[51] !== product || $[52] !== selectedSpaceId) {
                t12 = (space)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33a5f27508fb8f75$var$SpaceMenuItem, {
                        key: space.id,
                        space: space,
                        cloudId: cloudId,
                        product: product,
                        experienceId: experienceId,
                        isSelected: space.id === selectedSpaceId,
                        isADSNavigationEnabled: isADSNavigationEnabled,
                        onSelectSpace: onSelectSpace,
                        emojiProvider: emojiProvider,
                        onSpaceDelete: onSpaceDelete,
                        onSpaceRename: onSpaceRename,
                        onNewChatButtonClick: onNewChatButtonClick
                    });
                $[43] = cloudId;
                $[44] = emojiProvider;
                $[45] = experienceId;
                $[46] = isADSNavigationEnabled;
                $[47] = onNewChatButtonClick;
                $[48] = onSelectSpace;
                $[49] = onSpaceDelete;
                $[50] = onSpaceRename;
                $[51] = product;
                $[52] = selectedSpaceId;
                $[53] = t12;
            } else t12 = $[53];
            t5 = limitedSpaces.map(t12);
        }
        $[6] = cloudId;
        $[7] = emojiProvider;
        $[8] = experienceId;
        $[9] = formatMessage;
        $[10] = isADSNavigationEnabled;
        $[11] = isLoading;
        $[12] = isRecommendedSpacesSelected;
        $[13] = onNewChatButtonClick;
        $[14] = onSelectRecommendedSpaces;
        $[15] = onSelectSpace;
        $[16] = onSpaceDelete;
        $[17] = onSpaceRename;
        $[18] = product;
        $[19] = renderRecommendedSpacesItem;
        $[20] = selectedSpaceId;
        $[21] = spaces;
        $[22] = T0;
        $[23] = t4;
        $[24] = t5;
        $[25] = t6;
    } else {
        T0 = $[22];
        t4 = $[23];
        t5 = $[24];
        t6 = $[25];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    let t7;
    if ($[54] !== formatMessage || $[55] !== isADSNavigationEnabled || $[56] !== onViewAllSpacesClick) {
        t7 = onViewAllSpacesClick && (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            onClick: ()=>{
                onViewAllSpacesClick();
            },
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: ""
            })
        }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).viewAllSpacesLabel));
        $[54] = formatMessage;
        $[55] = isADSNavigationEnabled;
        $[56] = onViewAllSpacesClick;
        $[57] = t7;
    } else t7 = $[57];
    let t8;
    if ($[58] !== T0 || $[59] !== t4 || $[60] !== t5 || $[61] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, null, t4, t5, t7);
        $[58] = T0;
        $[59] = t4;
        $[60] = t5;
        $[61] = t7;
        $[62] = t8;
    } else t8 = $[62];
    return t8;
} : ({ cloudId: cloudId, isADSNavigationEnabled: isADSNavigationEnabled, onSelectSpace: onSelectSpace, selectedSpaceId: selectedSpaceId, product: product, experienceId: experienceId, onSelectRecommendedSpaces: onSelectRecommendedSpaces, isRecommendedSpacesSelected: isRecommendedSpacesSelected = false, onSpaceDelete: onSpaceDelete, onSpaceRename: onSpaceRename, onNewChatButtonClick: onNewChatButtonClick, onViewAllSpacesClick: onViewAllSpacesClick, renderRecommendedSpacesItem: renderRecommendedSpacesItem })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { spaces: spaces, isLoading: isLoading } = (0, $9dT53.useListSpaces)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId
    });
    const emojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProvider)(cloudId), [
        cloudId
    ]);
    const limitedSpaces = spaces.slice(0, $33a5f27508fb8f75$var$SPACES_LIMIT);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        label: formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).loadingLabel)
    }));
    const recommendedSpacesItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        href: "#",
        isSelected: isRecommendedSpacesSelected,
        testId: "rovo-chat-sidenav-recommended-spaces",
        onClick: (e)=>{
            e.preventDefault();
            onSelectRecommendedSpaces?.();
        },
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36ca9e0df2729bf2$export$87352277df45d72e), null)
    }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).recommendedSpaces));
    const renderedRecommendedSpacesItem = renderRecommendedSpacesItem ? renderRecommendedSpacesItem(recommendedSpacesItem) : recommendedSpacesItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderedRecommendedSpacesItem, limitedSpaces.map((space)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33a5f27508fb8f75$var$SpaceMenuItem, {
            key: space.id,
            space: space,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId,
            isSelected: space.id === selectedSpaceId,
            isADSNavigationEnabled: isADSNavigationEnabled,
            onSelectSpace: onSelectSpace,
            emojiProvider: emojiProvider,
            onSpaceDelete: onSpaceDelete,
            onSpaceRename: onSpaceRename,
            onNewChatButtonClick: onNewChatButtonClick
        })), onViewAllSpacesClick && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        onClick: ()=>{
            onViewAllSpacesClick();
        },
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        })
    }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).viewAllSpacesLabel)));
};
const $33a5f27508fb8f75$var$SPACE_TESTID_PREFIX = 'rovo-nav-space-item';
const $33a5f27508fb8f75$var$renameStyles = {
    renameForm: "_30huDKjg0e _3iDTPbQ4SZ",
    innerForm: "_2mHwu81Y8M _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT",
    textFieldContainer: "_2O5Vij7dHp _3138424F84",
    textField: "_2sNsIgmnOE _30huDKS6k6 _0bjKvDKxmn _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _24h04i2Njc _1kk5Tkf7mX _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6Q1Y8M _0xkEdpnXvL _0ui43C2Bgz"
};
const $33a5f27508fb8f75$var$spaceItemStyles = {
    emojiTile: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F"
};
const $33a5f27508fb8f75$var$SpaceMenuItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(93);
    const { space: space, cloudId: cloudId, product: product, experienceId: experienceId, isSelected: isSelected, isADSNavigationEnabled: isADSNavigationEnabled, onSelectSpace: onSelectSpace, emojiProvider: emojiProvider, onSpaceDelete: onSpaceDelete, onSpaceRename: onSpaceRename, onNewChatButtonClick: onNewChatButtonClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [localSpaceName, setLocalSpaceName] = (0, $cozmU.useState)(space.name);
    const formRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== isSelected || $[1] !== onNewChatButtonClick || $[2] !== onSpaceDelete || $[3] !== space) {
        t1 = ()=>{
            onSpaceDelete?.(space);
            if (isSelected) onNewChatButtonClick?.();
        };
        $[0] = isSelected;
        $[1] = onNewChatButtonClick;
        $[2] = onSpaceDelete;
        $[3] = space;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== cloudId || $[6] !== experienceId || $[7] !== product || $[8] !== t1) {
        t2 = {
            cloudId: cloudId,
            product: product,
            experienceId: experienceId,
            onSuccess: t1
        };
        $[5] = cloudId;
        $[6] = experienceId;
        $[7] = product;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    const { deleteSpace: deleteSpace } = (0, $caa0451413d57c80$export$fb4d1ac6bee39cfb)(t2);
    let t3;
    if ($[10] !== onSpaceRename) {
        t3 = (updatedSpace, newName)=>onSpaceRename?.(updatedSpace, newName);
        $[10] = onSpaceRename;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== cloudId || $[13] !== experienceId || $[14] !== product || $[15] !== t3) {
        t4 = {
            cloudId: cloudId,
            product: product,
            experienceId: experienceId,
            onSuccess: t3
        };
        $[12] = cloudId;
        $[13] = experienceId;
        $[14] = product;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    const { renameSpace: renameSpace } = (0, $09fc8399fb744e1c$export$3a6d3c054cf6f88d)(t4);
    let t5;
    if ($[17] !== space.name) {
        t5 = ()=>{
            setIsMoreMenuOpen(false);
            setLocalSpaceName(space.name);
            setIsEditing(true);
        };
        $[17] = space.name;
        $[18] = t5;
    } else t5 = $[18];
    const onRenameBtnClicked = t5;
    let t6;
    if ($[19] !== renameSpace || $[20] !== space.id) {
        t6 = (value)=>{
            const trimmed = value.trim();
            if (!trimmed) {
                setIsEditing(false);
                return;
            }
            setIsEditing(false);
            renameSpace(space.id, trimmed);
        };
        $[19] = renameSpace;
        $[20] = space.id;
        $[21] = t6;
    } else t6 = $[21];
    const onSubmitRename = t6;
    let t7;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsEditing(false);
        };
        $[22] = t7;
    } else t7 = $[22];
    const onCancelRename = t7;
    let t8;
    let t9;
    if ($[23] !== isEditing || $[24] !== space.name) {
        t8 = ()=>{
            if (!isEditing) setLocalSpaceName(space.name);
        };
        t9 = [
            isEditing,
            space.name
        ];
        $[23] = isEditing;
        $[24] = space.name;
        $[25] = t8;
        $[26] = t9;
    } else {
        t8 = $[25];
        t9 = $[26];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    let t11;
    if ($[27] !== isEditing) {
        t10 = ()=>{
            if (isEditing) inputRef.current?.focus();
        };
        t11 = [
            isEditing
        ];
        $[27] = isEditing;
        $[28] = t10;
        $[29] = t11;
    } else {
        t10 = $[28];
        t11 = $[29];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[30] !== isEditing) {
        t12 = ()=>{
            if (!isEditing) return;
            const handleClickOutside = (event)=>{
                if (formRef.current && !formRef.current.contains(event.target)) onCancelRename();
            };
            const unbind = (0, $cbY7C.bind)(window, {
                type: "mousedown",
                listener: handleClickOutside,
                options: {
                    capture: true
                }
            });
            return unbind;
        };
        t13 = [
            isEditing,
            onCancelRename
        ];
        $[30] = isEditing;
        $[31] = t12;
        $[32] = t13;
    } else {
        t12 = $[31];
        t13 = $[32];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    if ($[33] !== onSelectSpace || $[34] !== space) {
        t14 = (event_0)=>{
            event_0.preventDefault();
            onSelectSpace?.(space);
        };
        $[33] = onSelectSpace;
        $[34] = space;
        $[35] = t14;
    } else t14 = $[35];
    const onSpaceItemClick = t14;
    let t15;
    if ($[36] !== emojiProvider || $[37] !== space.emoji) {
        t15 = space.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $33a5f27508fb8f75$var$spaceItemStyles.emojiTile,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: {
                id: space.emoji,
                shortName: ""
            },
            emojiProvider: emojiProvider,
            fitToHeight: 16
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: ""
        });
        $[36] = emojiProvider;
        $[37] = space.emoji;
        $[38] = t15;
    } else t15 = $[38];
    const icon = t15;
    const t16 = `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-more-popup-${space.id}`;
    let t17;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>setIsMoreMenuOpen(false);
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== formatMessage || $[41] !== onRenameBtnClicked || $[42] !== space.id) {
        t18 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-rename-${space.id}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: ""
                }),
                onClick: onRenameBtnClicked
            }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuRenameLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-delete-${space.id}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                onClick: ()=>{
                    setIsMoreMenuOpen(false);
                    setIsDeleteModalOpen(true);
                }
            }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuDeleteLabel)));
        $[40] = formatMessage;
        $[41] = onRenameBtnClicked;
        $[42] = space.id;
        $[43] = t18;
    } else t18 = $[43];
    let t19;
    if ($[44] !== formatMessage || $[45] !== space.id) {
        t19 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-more-${space.id}`,
                icon: $33a5f27508fb8f75$var$_temp,
                appearance: "subtle",
                spacing: "compact",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setIsMoreMenuOpen($33a5f27508fb8f75$var$_temp2);
                },
                label: formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuLabel)
            });
        $[44] = formatMessage;
        $[45] = space.id;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    if ($[47] !== isMoreMenuOpen || $[48] !== t16 || $[49] !== t18 || $[50] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            testId: t16,
            isOpen: isMoreMenuOpen,
            onClose: t17,
            zIndex: (0, $17a118af00cd097a$export$6da3aaba6bb6f609),
            placement: "bottom-end",
            content: t18,
            trigger: t19
        });
        $[47] = isMoreMenuOpen;
        $[48] = t16;
        $[49] = t18;
        $[50] = t19;
        $[51] = t20;
    } else t20 = $[51];
    const moreButton = t20;
    let t21;
    if ($[52] !== formatMessage || $[53] !== space.id) {
        t21 = (t22)=>{
            const { fieldProps: fieldProps } = t22;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
                ...fieldProps,
                ref: inputRef,
                "aria-label": formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuRenameLabel),
                onKeyDown: (e_0)=>{
                    if (e_0.key === "Escape") onCancelRename();
                },
                "data-testid": `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-name-edit-${space.id}`,
                className: (0, $hekY6.default)([
                    $33a5f27508fb8f75$var$renameStyles.textField
                ])
            });
        };
        $[52] = formatMessage;
        $[53] = space.id;
        $[54] = t21;
    } else t21 = $[54];
    let t22;
    if ($[55] !== localSpaceName || $[56] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $33a5f27508fb8f75$var$renameStyles.textFieldContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "spaceName",
            defaultValue: localSpaceName
        }, t21));
        $[55] = localSpaceName;
        $[56] = t21;
        $[57] = t22;
    } else t22 = $[57];
    let t23;
    if ($[58] !== formatMessage) {
        t23 = formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).confirmRenameLabel);
        $[58] = formatMessage;
        $[59] = t23;
    } else t23 = $[59];
    const t24 = `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-rename-confirm-${space.id}`;
    let t25;
    if ($[60] !== t23 || $[61] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $33a5f27508fb8f75$var$_temp3,
            type: "submit",
            appearance: "subtle",
            shape: "circle",
            spacing: "compact",
            label: t23,
            testId: t24
        });
        $[60] = t23;
        $[61] = t24;
        $[62] = t25;
    } else t25 = $[62];
    let t26;
    if ($[63] !== formatMessage) {
        t26 = formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).cancelRenameLabel);
        $[63] = formatMessage;
        $[64] = t26;
    } else t26 = $[64];
    const t27 = `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-rename-cancel-${space.id}`;
    let t28;
    if ($[65] !== t26 || $[66] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $33a5f27508fb8f75$var$_temp4,
            type: "button",
            onClick: onCancelRename,
            appearance: "subtle",
            shape: "circle",
            spacing: "compact",
            label: t26,
            testId: t27
        });
        $[65] = t26;
        $[66] = t27;
        $[67] = t28;
    } else t28 = $[67];
    let t29;
    if ($[68] !== t22 || $[69] !== t25 || $[70] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t22, t25, t28);
        $[68] = t22;
        $[69] = t25;
        $[70] = t28;
        $[71] = t29;
    } else t29 = $[71];
    const renameFormInner = t29;
    let t30;
    if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = (0, $hekY6.default)([
            $33a5f27508fb8f75$var$renameStyles.renameForm
        ]);
        $[72] = t30;
    } else t30 = $[72];
    let t31;
    if ($[73] !== onSubmitRename || $[74] !== renameFormInner) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: formRef,
            className: t30
        }, (0, $iDrrr.fg)("platform-design_system_team-form_conversion") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: (data)=>{
                onSubmitRename(data.spaceName);
            },
            formProps: {
                class: $33a5f27508fb8f75$var$renameStyles.innerForm
            }
        }, renameFormInner) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: (data_0)=>{
                onSubmitRename(data_0.spaceName);
            }
        }, (t32)=>{
            const { formProps: formProps } = t32;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
                ...formProps,
                className: (0, $hekY6.default)([
                    $33a5f27508fb8f75$var$renameStyles.innerForm
                ])
            }, renameFormInner);
        }));
        $[73] = onSubmitRename;
        $[74] = renameFormInner;
        $[75] = t31;
    } else t31 = $[75];
    const renameForm = t31;
    let t32;
    if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = ()=>setIsDeleteModalOpen(false);
        $[76] = t32;
    } else t32 = $[76];
    let t33;
    if ($[77] !== deleteSpace || $[78] !== isDeleteModalOpen || $[79] !== space) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47b3db5602ad731d$export$8df669469ae96f03), {
            space: space,
            isOpen: isDeleteModalOpen,
            onClose: t32,
            onDeleteConfirm: deleteSpace
        });
        $[77] = deleteSpace;
        $[78] = isDeleteModalOpen;
        $[79] = space;
        $[80] = t33;
    } else t33 = $[80];
    let t34;
    if ($[81] !== icon || $[82] !== isADSNavigationEnabled || $[83] !== isEditing || $[84] !== isSelected || $[85] !== localSpaceName || $[86] !== moreButton || $[87] !== onSpaceItemClick || $[88] !== renameForm) {
        t34 = isEditing ? renameForm : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            href: "#",
            isSelected: isSelected,
            onClick: onSpaceItemClick,
            elemBefore: icon,
            actionsOnHover: moreButton
        }, localSpaceName));
        $[81] = icon;
        $[82] = isADSNavigationEnabled;
        $[83] = isEditing;
        $[84] = isSelected;
        $[85] = localSpaceName;
        $[86] = moreButton;
        $[87] = onSpaceItemClick;
        $[88] = renameForm;
        $[89] = t34;
    } else t34 = $[89];
    let t35;
    if ($[90] !== t33 || $[91] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t33, t34);
        $[90] = t33;
        $[91] = t34;
        $[92] = t35;
    } else t35 = $[92];
    return t35;
} : ({ space: space, cloudId: cloudId, product: product, experienceId: experienceId, isSelected: isSelected, isADSNavigationEnabled: isADSNavigationEnabled, onSelectSpace: onSelectSpace, emojiProvider: emojiProvider, onSpaceDelete: onSpaceDelete, onSpaceRename: onSpaceRename, onNewChatButtonClick: onNewChatButtonClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [localSpaceName, setLocalSpaceName] = (0, $cozmU.useState)(space.name);
    const formRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    const { deleteSpace: deleteSpace } = (0, $caa0451413d57c80$export$fb4d1ac6bee39cfb)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        onSuccess: ()=>{
            // Notify the host first so any host-side bookkeeping (analytics,
            // pubsub, etc.) runs before we trigger the navigation reset below.
            onSpaceDelete?.(space); // If the user just deleted the space they were viewing, return them
            // to a fresh chat using the host's existing new-chat handler. This
            // reuses whatever side-effects the host already implements for the
            // new-chat button (e.g. publishing `space-deselected`, navigating
            // to the chat root, etc.) so each host gets the right UX without
            // having to wire any additional callback.
            if (isSelected) onNewChatButtonClick?.();
        }
    });
    const { renameSpace: renameSpace } = (0, $09fc8399fb744e1c$export$3a6d3c054cf6f88d)({
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        onSuccess: (updatedSpace, newName)=>onSpaceRename?.(updatedSpace, newName)
    });
    const onRenameBtnClicked = (0, $cozmU.useCallback)(()=>{
        setIsMoreMenuOpen(false);
        setLocalSpaceName(space.name);
        setIsEditing(true);
    }, [
        space.name
    ]);
    const onSubmitRename = (0, $cozmU.useCallback)((value)=>{
        const trimmed = value.trim();
        if (!trimmed) {
            setIsEditing(false);
            return;
        }
        setIsEditing(false);
        renameSpace(space.id, trimmed);
    }, [
        space.id,
        renameSpace
    ]);
    const onCancelRename = (0, $cozmU.useCallback)(()=>{
        setIsEditing(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) setLocalSpaceName(space.name);
    }, [
        isEditing,
        space.name
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isEditing) inputRef.current?.focus();
    }, [
        isEditing
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) return;
        const handleClickOutside = (event)=>{
            if (formRef.current && !formRef.current.contains(event.target)) onCancelRename();
        };
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'mousedown',
            listener: handleClickOutside,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isEditing,
        onCancelRename
    ]);
    const onSpaceItemClick = (0, $cozmU.useCallback)((event_0)=>{
        event_0.preventDefault();
        onSelectSpace?.(space);
    }, [
        onSelectSpace,
        space
    ]);
    const icon = space.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $33a5f27508fb8f75$var$spaceItemStyles.emojiTile,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiId: {
            id: space.emoji,
            shortName: ''
        },
        emojiProvider: emojiProvider,
        fitToHeight: 16
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
        label: ""
    });
    const moreButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-more-popup-${space.id}`,
        isOpen: isMoreMenuOpen,
        onClose: ()=>setIsMoreMenuOpen(false),
        zIndex: (0, $17a118af00cd097a$export$6da3aaba6bb6f609),
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-rename-${space.id}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: ""
                }),
                onClick: onRenameBtnClicked
            }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuRenameLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-delete-${space.id}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                onClick: ()=>{
                    setIsMoreMenuOpen(false);
                    setIsDeleteModalOpen(true);
                }
            }, formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuDeleteLabel))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-more-${space.id}`,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        label: "",
                        size: "small"
                    }),
                appearance: "subtle",
                spacing: "compact",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setIsMoreMenuOpen((prev)=>!prev);
                },
                label: formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuLabel)
            })
    }); // Shared inner content for both form variants
    const renameFormInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $33a5f27508fb8f75$var$renameStyles.textFieldContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "spaceName",
        defaultValue: localSpaceName
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            ...fieldProps,
            ref: inputRef,
            "aria-label": formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).moreMenuRenameLabel),
            onKeyDown: (e_0)=>{
                if (e_0.key === 'Escape') onCancelRename();
            },
            "data-testid": `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-name-edit-${space.id}`,
            className: (0, $hekY6.default)([
                $33a5f27508fb8f75$var$renameStyles.textField
            ])
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                ...iconProps,
                color: "var(--ds-icon-accent-green, #22A06B)"
            }),
        type: "submit",
        appearance: "subtle",
        shape: "circle",
        spacing: "compact",
        label: formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).confirmRenameLabel),
        testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-rename-confirm-${space.id}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                color: "var(--ds-icon-accent-red, #C9372C)"
            }),
        type: "button",
        onClick: onCancelRename,
        appearance: "subtle",
        shape: "circle",
        spacing: "compact",
        label: formatMessage((0, $b444bf107ac01689$export$2e2bcd8739ae039).cancelRenameLabel),
        testId: `${$33a5f27508fb8f75$var$SPACE_TESTID_PREFIX}-rename-cancel-${space.id}`
    }));
    const renameForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: formRef,
        className: (0, $hekY6.default)([
            $33a5f27508fb8f75$var$renameStyles.renameForm
        ])
    }, (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: (data)=>{
            onSubmitRename(data.spaceName);
        },
        formProps: {
            class: $33a5f27508fb8f75$var$renameStyles.innerForm
        }
    }, renameFormInner) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: (data_0)=>{
            onSubmitRename(data_0.spaceName);
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            ...formProps,
            className: (0, $hekY6.default)([
                $33a5f27508fb8f75$var$renameStyles.innerForm
            ])
        }, renameFormInner)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47b3db5602ad731d$export$8df669469ae96f03), {
        space: space,
        isOpen: isDeleteModalOpen,
        onClose: ()=>setIsDeleteModalOpen(false),
        onDeleteConfirm: deleteSpace
    }), isEditing ? renameForm : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6db993145b117bf$export$d2cad7a1cce7b35f), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        href: "#",
        isSelected: isSelected,
        onClick: onSpaceItemClick,
        elemBefore: icon,
        actionsOnHover: moreButton
    }, localSpaceName)));
};
function $33a5f27508fb8f75$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "",
        size: "small"
    });
}
function $33a5f27508fb8f75$var$_temp2(prev) {
    return !prev;
}
function $33a5f27508fb8f75$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        ...iconProps,
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}
function $33a5f27508fb8f75$var$_temp4(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}


const $7d3ce15ead7ad577$export$50a08bd246739b2f = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULLSCREEN: 'fullscreen'
};








const $c2134da9c53d9bb5$var$uiConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $c2134da9c53d9bb5$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c2134da9c53d9bb5$var$uiConfigContext);
} : ()=>(0, $cozmU.useContext)($c2134da9c53d9bb5$var$uiConfigContext);
const $c2134da9c53d9bb5$export$3063519296e335bf = $c2134da9c53d9bb5$var$uiConfigContext.Provider;


// TODO: revisit this value during integration
const $26f896fac969a05b$var$NAV_Z_INDEX = 510;
const $26f896fac969a05b$var$RECOMMENDED_SPACES_ID = 'recommended';
const $26f896fac969a05b$var$SmallAddIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: "",
            size: "small"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        label: "",
        size: "small"
    });
const $26f896fac969a05b$var$renderRecommendedSpacesItem = (item, isSpacesSpotlightEnabled)=>{
    return isSpacesSpotlightEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: item
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoChatSpacesSpotlight, null, item)) : item;
};

const $26f896fac969a05b$var$RovoChatSpacesSpotlightPlacement = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "oeh3z",
    name: "RovoChatSpacesSpotlightPlacement",
    loader: ()=>(parcelRequire("gRMSv")).then((m)=>m.RovoChatSpacesSpotlightPlacement),
    loading: ()=>null
});

const $26f896fac969a05b$var$RovoChatSpacesSpotlight = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "MXFtl",
    name: "RovoChatSpacesSpotlight",
    loader: ()=>(parcelRequire("jJev0")).then((m)=>m.RovoChatSpacesSpotlight),
    loading: ()=>null
});
const $26f896fac969a05b$var$styles = {
    sideNavTrayNonFullscreen: "_1EqgXlE1Ft",
    sideNavTrayFullscreen: "_1EqgXl715P",
    sideNavContent: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _42Yu6BFIQA _4bt5LAnQyn",
    adsSubsectionFlush: "_0GTcwR8ija",
    spacesSubsectionHeadingRow: "_03SyCP1Y8M"
};
const $26f896fac969a05b$var$backdropStyles = null;
const $26f896fac969a05b$var$RovoSideNavigationInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(104);
    const { onClose: onClose, onNewChatButtonClick: onNewChatButtonClick, onPulseClick: onPulseClick, onTasksClick: onTasksClick, conversationListProps: conversationListProps, agentsListProps: agentsListProps, canCreateAgents: canCreateAgents, mode: mode, cloudId: cloudId, orgId: orgId, workspaceAri: workspaceAri, assistanceServiceParams: assistanceServiceParams, isADSNavigationEnabled: t1, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled, isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled, isTasksEnabled: t2, selectedAgent: selectedAgent, selectedConversation: selectedConversation, onSelectAgent: onSelectAgent, onSelectConversation: onSelectConversation, onCreateSpaceClick: onCreateSpaceClick, onSelectSpace: onSelectSpace, selectedSpaceId: selectedSpaceId, isRecommendedSpacesSelected: isRecommendedSpacesSelected, isViewAllSpacesSelected: isViewAllSpacesSelected, onSelectRecommendedSpaces: onSelectRecommendedSpaces, onSpaceDelete: onSpaceDelete, onSpaceRename: onSpaceRename, onSpaceCreated: onSpaceCreated, onViewAllSpacesClick: onViewAllSpacesClick } = t0;
    const isADSNavigationEnabled = t1 === undefined ? false : t1;
    const isTasksEnabled = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const uiConfig = (0, $c2134da9c53d9bb5$export$e83755c3ab7a4493)();
    const isFullscreen = mode === (0, $7d3ce15ead7ad577$export$50a08bd246739b2f).FULLSCREEN;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("rovo_chat_spaces_spotlight");
        $[0] = t3;
    } else t3 = $[0];
    const isSpacesSpotlightEnabled = t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (item)=>$26f896fac969a05b$var$renderRecommendedSpacesItem(item, isSpacesSpotlightEnabled);
        $[1] = t4;
    } else t4 = $[1];
    const renderRecommendedSpacesItemBound = t4;
    let t5;
    if ($[2] !== formatMessage) {
        t5 = formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).closeSideNavLabel);
        $[2] = formatMessage;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== onClose || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-chat-sidenav-close-button",
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            appearance: "subtle",
            onClick: onClose,
            label: t5,
            isTooltipDisabled: false
        }));
        $[4] = onClose;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const closeButton = t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== formatMessage) {
        t8 = formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).newChatLabel);
        $[8] = formatMessage;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== isADSNavigationEnabled || $[11] !== onNewChatButtonClick || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            elemBefore: t7,
            onClick: onNewChatButtonClick
        }, t8);
        $[10] = isADSNavigationEnabled;
        $[11] = onNewChatButtonClick;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    const newChatButton = t9;
    let t10;
    if ($[14] !== formatMessage || $[15] !== isADSNavigationEnabled || $[16] !== onPulseClick) {
        t10 = onPulseClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            testId: "rovo-chat-insights-nav-button",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                label: ""
            }),
            onClick: onPulseClick
        }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).pulseLabel)) : null;
        $[14] = formatMessage;
        $[15] = isADSNavigationEnabled;
        $[16] = onPulseClick;
        $[17] = t10;
    } else t10 = $[17];
    const pulseButton = t10;
    let t11;
    if ($[18] !== formatMessage || $[19] !== isADSNavigationEnabled || $[20] !== onTasksClick) {
        t11 = onTasksClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))), {
                label: ""
            }),
            onClick: onTasksClick
        }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).tasksLabel)) : null;
        $[18] = formatMessage;
        $[19] = isADSNavigationEnabled;
        $[20] = onTasksClick;
        $[21] = t11;
    } else t11 = $[21];
    const tasksButton = t11;
    const t12 = !isFullscreen && closeButton;
    let t13;
    if ($[22] !== newChatButton || $[23] !== pulseButton || $[24] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            role: "list"
        }, t12, newChatButton, pulseButton));
        $[22] = newChatButton;
        $[23] = pulseButton;
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] !== agentsListProps || $[27] !== canCreateAgents || $[28] !== cloudId || $[29] !== formatMessage || $[30] !== isADSNavigationEnabled || $[31] !== isTasksEnabled || $[32] !== onSelectAgent || $[33] !== selectedAgent || $[34] !== uiConfig.elements?.agentsMenu || $[35] !== uiConfig.elements?.browseAgentsButton || $[36] !== uiConfig.elements?.createAgentButton) {
        t14 = uiConfig.elements?.agentsMenu !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dd18f20883d939a$export$341dea48c30b36ff), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                label: ""
            }),
            title: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).agentListLabel),
            defaultExpanded: !isTasksEnabled,
            suppressListPadding: isTasksEnabled,
            actions: canCreateAgents && uiConfig.elements?.createAgentButton !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                testId: "rovo-chat-sidenav-agent-create",
                icon: $26f896fac969a05b$var$SmallAddIcon,
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).createAgentLabel),
                onClick: agentsListProps.onCreateAgentClick,
                isTooltipDisabled: false,
                role: "link"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c65245c1473cf96e$export$51f0bc576d5599bf), {
            ...agentsListProps,
            selectedAgent: selectedAgent,
            onSelectAgent: onSelectAgent,
            cloudId: cloudId,
            isADSNavigationEnabled: isADSNavigationEnabled,
            showBrowseAgents: uiConfig.elements?.browseAgentsButton !== false && !(0, $iDrrr.fg)("rovo_chat_hide_browse_agents_and_search")
        }));
        $[26] = agentsListProps;
        $[27] = canCreateAgents;
        $[28] = cloudId;
        $[29] = formatMessage;
        $[30] = isADSNavigationEnabled;
        $[31] = isTasksEnabled;
        $[32] = onSelectAgent;
        $[33] = selectedAgent;
        $[34] = uiConfig.elements?.agentsMenu;
        $[35] = uiConfig.elements?.browseAgentsButton;
        $[36] = uiConfig.elements?.createAgentButton;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== isNewAllConversationScreenEnabled) {
        t15 = isNewAllConversationScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
            label: ""
        });
        $[38] = isNewAllConversationScreenEnabled;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== formatMessage) {
        t16 = formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel);
        $[40] = formatMessage;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== isTasksEnabled) {
        t17 = isTasksEnabled || (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false);
        $[42] = isTasksEnabled;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== formatMessage) {
        t18 = formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).newChatLabel);
        $[44] = formatMessage;
        $[45] = t18;
    } else t18 = $[45];
    let t19;
    if ($[46] !== onNewChatButtonClick || $[47] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-chat-sidenav-chat-create",
            icon: $26f896fac969a05b$var$SmallAddIcon,
            appearance: "subtle",
            spacing: "compact",
            label: t18,
            onClick: onNewChatButtonClick,
            isTooltipDisabled: false
        });
        $[46] = onNewChatButtonClick;
        $[47] = t18;
        $[48] = t19;
    } else t19 = $[48];
    let t20;
    if ($[49] !== assistanceServiceParams?.experienceId || $[50] !== assistanceServiceParams?.product || $[51] !== cloudId || $[52] !== conversationListProps || $[53] !== formatMessage || $[54] !== isADSNavigationEnabled || $[55] !== isNewAllConversationScreenEnabled || $[56] !== isRecommendedSpacesSelected || $[57] !== isSpinnerOverlayConversationIconEnabled || $[58] !== isViewAllSpacesSelected || $[59] !== onCreateSpaceClick || $[60] !== onNewChatButtonClick || $[61] !== onSelectConversation || $[62] !== onSelectRecommendedSpaces || $[63] !== onSelectSpace || $[64] !== onSpaceCreated || $[65] !== onSpaceDelete || $[66] !== onSpaceRename || $[67] !== onViewAllSpacesClick || $[68] !== selectedConversation || $[69] !== selectedSpaceId) {
        t20 = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ac90360b1975343$export$4b1545b4f2016d26), {
            isMenuListItem: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            xcss: $26f896fac969a05b$var$styles.spacesSubsectionHeadingRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d04b687461f45ce4$export$5d3acdbf9237a364), {
            label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).spacesSectionLabel)
        }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).spacesSectionLabel)), onCreateSpaceClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-chat-sidenav-spaces-create-space",
            icon: $26f896fac969a05b$var$SmallAddIcon,
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).createSpaceLabel),
            onClick: onCreateSpaceClick,
            isTooltipDisabled: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33a5f27508fb8f75$export$b669316dadef19fd), {
            ...conversationListProps,
            onSelectConversation: onSelectConversation,
            currentConversation: selectedConversation,
            cloudId: cloudId,
            isADSNavigationEnabled: isADSNavigationEnabled,
            product: assistanceServiceParams?.product ?? "rovo",
            experienceId: assistanceServiceParams?.experienceId ?? "ai-mate",
            isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
            isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
            onSelectSpace: onSelectSpace,
            selectedSpaceId: selectedSpaceId,
            onSelectRecommendedSpaces: onSelectRecommendedSpaces,
            isRecommendedSpacesSelected: isRecommendedSpacesSelected,
            isViewAllSpacesSelected: isViewAllSpacesSelected,
            onSpaceDelete: onSpaceDelete,
            onSpaceRename: onSpaceRename,
            onNewChatButtonClick: onNewChatButtonClick,
            onSpaceCreated: onSpaceCreated,
            onViewAllSpacesClick: onViewAllSpacesClick,
            renderRecommendedSpacesItem: renderRecommendedSpacesItemBound
        })));
        $[49] = assistanceServiceParams?.experienceId;
        $[50] = assistanceServiceParams?.product;
        $[51] = cloudId;
        $[52] = conversationListProps;
        $[53] = formatMessage;
        $[54] = isADSNavigationEnabled;
        $[55] = isNewAllConversationScreenEnabled;
        $[56] = isRecommendedSpacesSelected;
        $[57] = isSpinnerOverlayConversationIconEnabled;
        $[58] = isViewAllSpacesSelected;
        $[59] = onCreateSpaceClick;
        $[60] = onNewChatButtonClick;
        $[61] = onSelectConversation;
        $[62] = onSelectRecommendedSpaces;
        $[63] = onSelectSpace;
        $[64] = onSpaceCreated;
        $[65] = onSpaceDelete;
        $[66] = onSpaceRename;
        $[67] = onViewAllSpacesClick;
        $[68] = selectedConversation;
        $[69] = selectedSpaceId;
        $[70] = t20;
    } else t20 = $[70];
    let t21;
    if ($[71] !== cloudId || $[72] !== conversationListProps || $[73] !== formatMessage || $[74] !== isADSNavigationEnabled || $[75] !== isNewAllConversationScreenEnabled || $[76] !== isSpinnerOverlayConversationIconEnabled || $[77] !== onSelectConversation || $[78] !== selectedConversation) {
        t21 = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ac90360b1975343$export$4b1545b4f2016d26), {
            isMenuListItem: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d04b687461f45ce4$export$5d3acdbf9237a364), {
            label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel)
        }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a5007b6f001db50$export$df7dcd72c7c1c33f), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            ...conversationListProps,
            currentConversation: selectedConversation,
            onSelectConversation: onSelectConversation,
            isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
            isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
            cloudId: cloudId
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a5007b6f001db50$export$df7dcd72c7c1c33f), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            ...conversationListProps,
            currentConversation: selectedConversation,
            onSelectConversation: onSelectConversation,
            isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
            isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
            cloudId: cloudId
        });
        $[71] = cloudId;
        $[72] = conversationListProps;
        $[73] = formatMessage;
        $[74] = isADSNavigationEnabled;
        $[75] = isNewAllConversationScreenEnabled;
        $[76] = isSpinnerOverlayConversationIconEnabled;
        $[77] = onSelectConversation;
        $[78] = selectedConversation;
        $[79] = t21;
    } else t21 = $[79];
    let t22;
    if ($[80] !== isADSNavigationEnabled || $[81] !== t15 || $[82] !== t16 || $[83] !== t17 || $[84] !== t19 || $[85] !== t20 || $[86] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dd18f20883d939a$export$341dea48c30b36ff), {
            isADSNavigationEnabled: isADSNavigationEnabled,
            elemBefore: t15,
            title: t16,
            defaultExpanded: true,
            suppressListPadding: t17,
            actions: t19
        }, t20, t21);
        $[80] = isADSNavigationEnabled;
        $[81] = t15;
        $[82] = t16;
        $[83] = t17;
        $[84] = t19;
        $[85] = t20;
        $[86] = t21;
        $[87] = t22;
    } else t22 = $[87];
    let t23;
    if ($[88] !== isADSNavigationEnabled || $[89] !== t13 || $[90] !== t14 || $[91] !== t22 || $[92] !== tasksButton) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beb818796d9fb44a$export$babe3c784778f3ba), {
            isADSNavigationEnabled: isADSNavigationEnabled
        }, t13, t14, tasksButton, t22);
        $[88] = isADSNavigationEnabled;
        $[89] = t13;
        $[90] = t14;
        $[91] = t22;
        $[92] = tasksButton;
        $[93] = t23;
    } else t23 = $[93];
    const sideNavContent = t23;
    if (!isSpacesSpotlightEnabled) return sideNavContent;
    const t24 = assistanceServiceParams?.product ?? "rovo";
    let t25;
    if ($[94] !== cloudId || $[95] !== locale || $[96] !== orgId || $[97] !== sideNavContent || $[98] !== t24 || $[99] !== workspaceAri) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoChatSpacesSpotlightPlacement, {
            product: t24,
            locale: locale,
            orgId: orgId,
            tenantId: cloudId,
            workspaceAri: workspaceAri
        }, sideNavContent);
        $[94] = cloudId;
        $[95] = locale;
        $[96] = orgId;
        $[97] = sideNavContent;
        $[98] = t24;
        $[99] = workspaceAri;
        $[100] = t25;
    } else t25 = $[100];
    let t26;
    if ($[101] !== sideNavContent || $[102] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: sideNavContent
        }, t25);
        $[101] = sideNavContent;
        $[102] = t25;
        $[103] = t26;
    } else t26 = $[103];
    return t26;
} : ({ onClose: onClose, onNewChatButtonClick: onNewChatButtonClick, onPulseClick: onPulseClick, onTasksClick: onTasksClick, conversationListProps: conversationListProps, agentsListProps: agentsListProps, canCreateAgents: canCreateAgents, mode: mode, cloudId: cloudId, orgId: orgId, workspaceAri: workspaceAri, assistanceServiceParams: assistanceServiceParams, isADSNavigationEnabled: isADSNavigationEnabled = false, isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled, isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled, isTasksEnabled: isTasksEnabled = false, selectedAgent: selectedAgent, selectedConversation: selectedConversation, onSelectAgent: onSelectAgent, onSelectConversation: onSelectConversation, onCreateSpaceClick: onCreateSpaceClick, onSelectSpace: onSelectSpace, selectedSpaceId: selectedSpaceId, isRecommendedSpacesSelected: isRecommendedSpacesSelected, isViewAllSpacesSelected: isViewAllSpacesSelected, onSelectRecommendedSpaces: onSelectRecommendedSpaces, onSpaceDelete: onSpaceDelete, onSpaceRename: onSpaceRename, onSpaceCreated: onSpaceCreated, onViewAllSpacesClick: onViewAllSpacesClick })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const uiConfig = (0, $c2134da9c53d9bb5$export$e83755c3ab7a4493)();
    const isFullscreen = mode === (0, $7d3ce15ead7ad577$export$50a08bd246739b2f).FULLSCREEN;
    const isSpacesSpotlightEnabled = (0, $iDrrr.fg)('rovo_chat_spaces_spotlight');
    const renderRecommendedSpacesItemBound = (0, $cozmU.useCallback)((item)=>$26f896fac969a05b$var$renderRecommendedSpacesItem(item, isSpacesSpotlightEnabled), [
        isSpacesSpotlightEnabled
    ]); // must be wrapped in ListItem to prevent a11y violations
    const closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "rovo-chat-sidenav-close-button",
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).closeSideNavLabel),
        isTooltipDisabled: false
    }));
    const newChatButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        }),
        onClick: onNewChatButtonClick
    }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).newChatLabel));
    const pulseButton = onPulseClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        testId: "rovo-chat-insights-nav-button",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
            label: ""
        }),
        onClick: onPulseClick
    }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).pulseLabel)) : null;
    const tasksButton = onTasksClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e1ba3f3f58242de$export$6dc09b7c0ec1dfcd), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))), {
            label: ""
        }),
        onClick: onTasksClick
    }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).tasksLabel)) : null;
    const sideNavContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beb818796d9fb44a$export$babe3c784778f3ba), {
        isADSNavigationEnabled: isADSNavigationEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9dc22ed829da39ea$export$a7b06bfba60a8a78), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        role: "list"
    }, !isFullscreen && closeButton, newChatButton, pulseButton)), uiConfig.elements?.agentsMenu !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dd18f20883d939a$export$341dea48c30b36ff), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
            label: ""
        }),
        title: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).agentListLabel),
        defaultExpanded: !isTasksEnabled,
        suppressListPadding: isTasksEnabled,
        actions: canCreateAgents && uiConfig.elements?.createAgentButton !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-chat-sidenav-agent-create",
            icon: $26f896fac969a05b$var$SmallAddIcon,
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).createAgentLabel),
            onClick: agentsListProps.onCreateAgentClick,
            isTooltipDisabled: false,
            role: "link"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c65245c1473cf96e$export$51f0bc576d5599bf), {
        ...agentsListProps,
        selectedAgent: selectedAgent,
        onSelectAgent: onSelectAgent,
        cloudId: cloudId,
        isADSNavigationEnabled: isADSNavigationEnabled,
        showBrowseAgents: uiConfig.elements?.browseAgentsButton !== false && !(0, $iDrrr.fg)('rovo_chat_hide_browse_agents_and_search')
    })), tasksButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dd18f20883d939a$export$341dea48c30b36ff), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        elemBefore: isNewAllConversationScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
            label: ""
        }),
        title: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel),
        defaultExpanded: true // When Spaces is enabled, suppress the children's inline-start padding so the inner
        ,
        // Spaces / Chats subsection headings sit left-flush with the parent's clock icon
        // (matching the Figma design). The tasks behaviour is unchanged.
        suppressListPadding: isTasksEnabled || (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-chat-sidenav-chat-create",
            icon: $26f896fac969a05b$var$SmallAddIcon,
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).newChatLabel),
            onClick: onNewChatButtonClick,
            isTooltipDisabled: false
        })
    }, (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ac90360b1975343$export$4b1545b4f2016d26), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $26f896fac969a05b$var$styles.spacesSubsectionHeadingRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d04b687461f45ce4$export$5d3acdbf9237a364), {
        label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).spacesSectionLabel)
    }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).spacesSectionLabel)), onCreateSpaceClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "rovo-chat-sidenav-spaces-create-space",
        icon: $26f896fac969a05b$var$SmallAddIcon,
        appearance: "subtle",
        spacing: "compact",
        label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).createSpaceLabel),
        onClick: onCreateSpaceClick,
        isTooltipDisabled: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33a5f27508fb8f75$export$b669316dadef19fd), {
        ...conversationListProps,
        onSelectConversation: onSelectConversation,
        currentConversation: selectedConversation,
        cloudId: cloudId,
        isADSNavigationEnabled: isADSNavigationEnabled,
        product: assistanceServiceParams?.product ?? 'rovo',
        experienceId: assistanceServiceParams?.experienceId ?? 'ai-mate',
        isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
        isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
        onSelectSpace: onSelectSpace,
        selectedSpaceId: selectedSpaceId,
        onSelectRecommendedSpaces: onSelectRecommendedSpaces,
        isRecommendedSpacesSelected: isRecommendedSpacesSelected,
        isViewAllSpacesSelected: isViewAllSpacesSelected,
        onSpaceDelete: onSpaceDelete,
        onSpaceRename: onSpaceRename,
        onNewChatButtonClick: onNewChatButtonClick,
        onSpaceCreated: onSpaceCreated,
        onViewAllSpacesClick: onViewAllSpacesClick,
        renderRecommendedSpacesItem: renderRecommendedSpacesItemBound
    }))), (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ac90360b1975343$export$4b1545b4f2016d26), {
        isMenuListItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d04b687461f45ce4$export$5d3acdbf9237a364), {
        label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel)
    }, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd28783e110ce440$export$54c2e3dc7acea9f5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a5007b6f001db50$export$df7dcd72c7c1c33f), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        ...conversationListProps,
        currentConversation: selectedConversation,
        onSelectConversation: onSelectConversation,
        isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
        isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
        cloudId: cloudId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a5007b6f001db50$export$df7dcd72c7c1c33f), {
        isADSNavigationEnabled: isADSNavigationEnabled,
        ...conversationListProps,
        currentConversation: selectedConversation,
        onSelectConversation: onSelectConversation,
        isNewAllConversationScreenEnabled: isNewAllConversationScreenEnabled,
        isSpinnerOverlayConversationIconEnabled: isSpinnerOverlayConversationIconEnabled,
        cloudId: cloudId
    })));
    if (!isSpacesSpotlightEnabled) return sideNavContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: sideNavContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoChatSpacesSpotlightPlacement, {
        product: assistanceServiceParams?.product ?? 'rovo',
        locale: locale,
        orgId: orgId,
        tenantId: cloudId,
        workspaceAri: workspaceAri
    }, sideNavContent));
};
const $26f896fac969a05b$var$RovoSideNavigationWithStore = (props)=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const uiConfig = (0, $c2134da9c53d9bb5$export$e83755c3ab7a4493)();
    const isMiniModal = props.mode === (0, $7d3ce15ead7ad577$export$50a08bd246739b2f).MINI_MODAL;
    const isSidebar = props.mode === (0, $7d3ce15ead7ad577$export$50a08bd246739b2f).SIDEBAR;
    const shouldSkipAnimation = props.isADSNavigationEnabled || props.shouldSkipAnimation;
    const shouldRenderGlobalSideNavigation = props.isADSNavigationEnabled;
    const isSpacesSpotlightEnabled = (0, $iDrrr.fg)('rovo_chat_spaces_spotlight');
    const renderRecommendedSpacesItemBound = (0, $cozmU.useCallback)((item)=>$26f896fac969a05b$var$renderRecommendedSpacesItem(item, isSpacesSpotlightEnabled), [
        isSpacesSpotlightEnabled
    ]);
    const [selectedAgent, setSelectedAgent] = (0, $cozmU.useState)(props.agentsListProps.selectedAgent);
    const [selectedConversation, setSelectedConveration] = (0, $cozmU.useState)(props.conversationListProps.currentConversation);
    const [selectedSpaceId, setSelectedSpaceId] = (0, $cozmU.useState)(props.selectedSpaceId);
    const [isViewAllSpacesSelected, setIsViewAllSpacesSelected] = (0, $cozmU.useState)(false);
    const { onNewChatButtonClick: onNewChatButtonClick, onViewAllSpacesClick: onViewAllSpacesClick } = props;
    const onNewChat = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (selectedAgent) setSelectedAgent(undefined);
        if (selectedConversation) setSelectedConveration(undefined);
        if (selectedSpaceId) setSelectedSpaceId(undefined);
        setIsViewAllSpacesSelected(false);
        onNewChatButtonClick?.(event, analyticsEvent);
    }, [
        selectedAgent,
        selectedConversation,
        selectedSpaceId,
        onNewChatButtonClick
    ]); // sync external props with internal state
    (0, $cozmU.useEffect)(()=>{
        if (selectedAgent) setSelectedAgent(undefined);
        setSelectedConveration(props.conversationListProps.currentConversation);
    }, [
        props.conversationListProps.currentConversation,
        selectedAgent
    ]);
    (0, $cozmU.useEffect)(()=>{
        setSelectedSpaceId(props.selectedSpaceId);
        setIsViewAllSpacesSelected(false);
    }, [
        props.selectedSpaceId
    ]);
    const onSelectAgent = (0, $cozmU.useCallback)((a)=>{
        setIsViewAllSpacesSelected(false);
        if (selectedConversation) setSelectedConveration(undefined);
        if (selectedSpaceId) setSelectedSpaceId(undefined);
        setSelectedAgent(a);
        props.agentsListProps.onSelectAgent(a, !!props.isADSNavigationEnabled);
    }, [
        selectedConversation,
        selectedSpaceId,
        props.agentsListProps,
        props.isADSNavigationEnabled
    ]);
    const onSelectConversation = (0, $cozmU.useCallback)((c)=>{
        setIsViewAllSpacesSelected(false);
        if (selectedAgent) setSelectedAgent(undefined);
        if (selectedSpaceId) setSelectedSpaceId(undefined);
        setSelectedConveration(c);
        props.conversationListProps.onSelectConversation(c, !!props.isADSNavigationEnabled);
    }, [
        selectedAgent,
        selectedSpaceId,
        props.conversationListProps,
        props.isADSNavigationEnabled
    ]);
    const { onSelectSpace: onSelectSpaceProp, onSelectRecommendedSpaces: onSelectRecommendedSpacesProp, onClose: onClose, isADSNavigationEnabled: isADSNavigationEnabled } = props;
    const handleSpaceCreated = (0, $cozmU.useCallback)((space, emojiId)=>{
        props.onSpaceCreated?.(space, emojiId);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.onSpaceCreated
    ]);
    const onSelectSpace = (0, $cozmU.useCallback)((space)=>{
        setIsViewAllSpacesSelected(false);
        if (selectedAgent) setSelectedAgent(undefined);
        if (selectedConversation) setSelectedConveration(undefined);
        setSelectedSpaceId(space.id);
        onSelectSpaceProp?.(space);
        if (!isADSNavigationEnabled) onClose();
    }, [
        selectedAgent,
        selectedConversation,
        onSelectSpaceProp,
        isADSNavigationEnabled,
        onClose
    ]);
    const onSelectRecommendedSpaces = (0, $cozmU.useCallback)(()=>{
        setIsViewAllSpacesSelected(false);
        if (selectedAgent) setSelectedAgent(undefined);
        if (selectedConversation) setSelectedConveration(undefined);
        setSelectedSpaceId($26f896fac969a05b$var$RECOMMENDED_SPACES_ID);
        onSelectRecommendedSpacesProp?.();
        if (!isADSNavigationEnabled) onClose();
    }, [
        selectedAgent,
        selectedConversation,
        onSelectRecommendedSpacesProp,
        isADSNavigationEnabled,
        onClose
    ]);
    const onViewAllSpaces = (0, $cozmU.useCallback)(()=>{
        if (selectedAgent) setSelectedAgent(undefined);
        if (selectedConversation) setSelectedConveration(undefined);
        if (selectedSpaceId) setSelectedSpaceId(undefined);
        setIsViewAllSpacesSelected(true);
        onViewAllSpacesClick?.();
    }, [
        selectedAgent,
        selectedConversation,
        selectedSpaceId,
        onViewAllSpacesClick
    ]); // Derive which conversation to highlight from the same UI-store routing signal the main content
    // area uses, rather than from stored local selection state. The main area renders a conversation
    // only when `activeMenu` is a chat menu and no space is selected, or when the open conversation
    // belongs to the currently-selected space; on every other surface (browsing spaces, a selected
    // space with no chat open, recommended spaces, agents, tasks, pulse, ...) no chat is highlighted.
    // Deriving at render (instead of syncing to stored state) means there is no stale highlight to
    // fall out of sync when the surface changes or the host re-sends currentConversation (e.g. on
    // window refocus refetch).
    const [{ activeMenu: activeMenu }] = (0, $bGNkz.useActiveMenuSelector)();
    const currentConversationForHighlight = props.conversationListProps.currentConversation;
    const isChatMenu = activeMenu === 'conversation-list' || activeMenu === 'none'; // A chat is highlighted only when a chat is the active surface AND no space row is selected.
    // The space row and the chat highlight are mutually exclusive by construction: selecting a
    // space sets `selectedSpaceId`, while opening a chat (including a space's own child chat)
    // clears it via `onSelectConversation`. So whenever a space row is highlighted, no chat is.
    const isShowingAConversation = isChatMenu && !selectedSpaceId;
    const derivedHighlightedConversation = isShowingAConversation ? currentConversationForHighlight : undefined; // Recommended-spaces is highlighted whenever the recommended-spaces surface is active. Derive it
    // from `activeMenu` rather than the local `selectedSpaceId` pseudo-value: the host does not model
    // "recommended" as a space id, so the `props.selectedSpaceId` sync effect would otherwise clobber
    // the locally-set value back to undefined when navigating from a real space to recommended.
    const isRecommendedSpacesSelected = activeMenu === 'recommended-spaces';
    const sideNavContent = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96dd730eb6425cb7$export$f83856b077b0513d), {
            isADSNavigationEnabled: props.isADSNavigationEnabled ?? false,
            testId: props.testId,
            maxHeight: props.overrideBoundingBox?.maxHeight,
            maxWidth: props.overrideBoundingBox?.maxWidth,
            zIndex: $26f896fac969a05b$var$NAV_Z_INDEX,
            isMiniModal: isMiniModal
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf792a29e2cd7485$export$e926676385687eaf), {
            experienceName: (0, $irnO2.ExperienceName).LOAD_PANEL,
            onClose: props.onClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoSideNavigationInternal, {
            ...props,
            onNewChatButtonClick: onNewChat,
            onSelectAgent: onSelectAgent,
            onSelectConversation: onSelectConversation,
            selectedAgent: selectedAgent,
            selectedConversation: derivedHighlightedConversation,
            onSelectSpace: onSelectSpace,
            onSelectRecommendedSpaces: onSelectRecommendedSpaces,
            selectedSpaceId: selectedSpaceId,
            isRecommendedSpacesSelected: isRecommendedSpacesSelected,
            isViewAllSpacesSelected: isViewAllSpacesSelected,
            onCreateSpaceClick: props.onCreateSpaceClick,
            onSpaceCreated: handleSpaceCreated,
            onViewAllSpacesClick: onViewAllSpaces
        }))), [
        props,
        selectedAgent,
        derivedHighlightedConversation,
        selectedSpaceId,
        isRecommendedSpacesSelected,
        isViewAllSpacesSelected,
        onNewChat,
        onSelectAgent,
        onSelectConversation,
        onSelectSpace,
        onSelectRecommendedSpaces,
        onViewAllSpaces,
        handleSpaceCreated,
        isMiniModal
    ]);
    const globalNavContent = (0, $cozmU.useMemo)(()=>{
        const items = {
            'chat.sidebar.button': {
                type: 'button',
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: ""
                }),
                label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).newChatLabel),
                onClick: onNewChat
            },
            ...props.onPulseClick && {
                'pulse.sidebar.button': {
                    type: 'button',
                    testId: 'rovo-chat-insights-nav-button',
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                        label: ""
                    }),
                    label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).pulseLabel),
                    onClick: props.onPulseClick
                }
            },
            ...uiConfig.elements?.agentsMenu !== false && {
                'chat-agents.sidebar.expand': {
                    type: 'expand',
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                        label: ""
                    }),
                    isDefaultExpanded: !props.isTasksEnabled,
                    onExpansionToggle: (isExpanded)=>!isExpanded,
                    label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).agentListLabel),
                    ...props.canCreateAgents && uiConfig.elements?.createAgentButton !== false && {
                        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                            testId: "rovo-chat-sidenav-agent-create",
                            icon: $26f896fac969a05b$var$SmallAddIcon,
                            appearance: "subtle",
                            spacing: "compact",
                            label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).createAgentLabel),
                            onClick: props.agentsListProps.onCreateAgentClick,
                            isTooltipDisabled: false,
                            role: "link"
                        })
                    },
                    children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c65245c1473cf96e$export$51f0bc576d5599bf), {
                        ...props.agentsListProps,
                        selectedAgent: selectedAgent,
                        onSelectAgent: onSelectAgent,
                        cloudId: props.cloudId,
                        isADSNavigationEnabled: true,
                        showBrowseAgents: uiConfig.elements?.browseAgentsButton !== false && !(0, $iDrrr.fg)('rovo_chat_hide_browse_agents_and_search')
                    })
                }
            },
            ...props.onTasksClick && {
                'tasks.sidebar.button': {
                    type: 'button',
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))), {
                        label: ""
                    }),
                    label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).tasksLabel),
                    onClick: props.onTasksClick
                }
            },
            'chat-history.sidebar.expand': {
                type: 'expand',
                elemBefore: props.isNewAllConversationScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                    label: ""
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: ""
                }),
                isDefaultExpanded: true,
                onExpansionToggle: (isExpanded)=>!isExpanded,
                label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    testId: "rovo-chat-sidenav-chat-create",
                    icon: $26f896fac969a05b$var$SmallAddIcon,
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).newChatLabel),
                    onClick: onNewChat,
                    isTooltipDisabled: false
                }),
                children: (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $26f896fac969a05b$var$styles.adsSubsectionFlush
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmhHk.MenuSection), {
                    isMenuListItem: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    spread: "space-between"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4X3mP.MenuSectionHeading), null, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).spacesSectionLabel)), props.onCreateSpaceClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    testId: "rovo-chat-sidenav-spaces-create-space",
                    icon: $26f896fac969a05b$var$SmallAddIcon,
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).createSpaceLabel),
                    onClick: props.onCreateSpaceClick,
                    isTooltipDisabled: false
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33a5f27508fb8f75$export$b669316dadef19fd), {
                    ...props.conversationListProps,
                    onSelectConversation: onSelectConversation,
                    currentConversation: derivedHighlightedConversation,
                    cloudId: props.cloudId,
                    isADSNavigationEnabled: true,
                    product: props.assistanceServiceParams?.product ?? 'rovo',
                    experienceId: props.assistanceServiceParams?.experienceId ?? 'ai-mate',
                    isNewAllConversationScreenEnabled: props.isNewAllConversationScreenEnabled,
                    isSpinnerOverlayConversationIconEnabled: props.isSpinnerOverlayConversationIconEnabled,
                    onSelectSpace: onSelectSpace,
                    selectedSpaceId: selectedSpaceId,
                    onSelectRecommendedSpaces: onSelectRecommendedSpaces,
                    isRecommendedSpacesSelected: isRecommendedSpacesSelected,
                    onSpaceDelete: props.onSpaceDelete,
                    onSpaceRename: props.onSpaceRename,
                    onNewChatButtonClick: onNewChat,
                    onSpaceCreated: handleSpaceCreated,
                    onViewAllSpacesClick: onViewAllSpaces,
                    isViewAllSpacesSelected: isViewAllSpacesSelected,
                    renderRecommendedSpacesItem: renderRecommendedSpacesItemBound
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmhHk.MenuSection), {
                    isMenuListItem: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4X3mP.MenuSectionHeading), null, formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).chatListLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a5007b6f001db50$export$df7dcd72c7c1c33f), {
                    ...props.conversationListProps,
                    isADSNavigationEnabled: true,
                    currentConversation: derivedHighlightedConversation,
                    onSelectConversation: onSelectConversation,
                    isNewAllConversationScreenEnabled: props.isNewAllConversationScreenEnabled,
                    isSpinnerOverlayConversationIconEnabled: props.isSpinnerOverlayConversationIconEnabled,
                    cloudId: props.cloudId
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a5007b6f001db50$export$df7dcd72c7c1c33f), {
                    ...props.conversationListProps,
                    isADSNavigationEnabled: true,
                    currentConversation: derivedHighlightedConversation,
                    onSelectConversation: onSelectConversation,
                    isNewAllConversationScreenEnabled: props.isNewAllConversationScreenEnabled,
                    isSpinnerOverlayConversationIconEnabled: props.isSpinnerOverlayConversationIconEnabled,
                    cloudId: props.cloudId
                })
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j4cgb.GlobalSideNavigation), {
            app: "rovoChat",
            appLabel: "Rovo Chat",
            forYou: {},
            items: items,
            disableMenuCustomization: true
        }));
    }, [
        formatMessage,
        props,
        selectedAgent,
        derivedHighlightedConversation,
        selectedSpaceId,
        isRecommendedSpacesSelected,
        isViewAllSpacesSelected,
        onNewChat,
        onSelectAgent,
        onSelectConversation,
        onSelectSpace,
        onSelectRecommendedSpaces,
        onViewAllSpaces,
        handleSpaceCreated,
        renderRecommendedSpacesItemBound,
        uiConfig
    ]);
    if (shouldRenderGlobalSideNavigation) {
        if (!isSpacesSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, globalNavContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: globalNavContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoChatSpacesSpotlightPlacement, {
            product: props.assistanceServiceParams?.product ?? 'rovo',
            locale: locale,
            tenantId: props.cloudId
        }, globalNavContent));
    }
    if (shouldSkipAnimation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, sideNavContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, props.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        "aria-label": formatMessage((0, $5d280d9e682edacd$export$2e2bcd8739ae039).closeSideNavLabel),
        onClick: props.onClose,
        className: (0, $hekY6.default)([
            $26f896fac969a05b$var$styles.sideNavContent,
            "_30huDKdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrushJp _0wOv4Q7zJH",
            isMiniModal && $26f896fac969a05b$var$styles.borderRadiusMiniModal
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($26f896fac969a05b$var$styles.sideNavContent, isMiniModal || isSidebar ? $26f896fac969a05b$var$styles.sideNavTrayNonFullscreen : $26f896fac969a05b$var$styles.sideNavTrayFullscreen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        fade: "inout",
        enterFrom: "left",
        exitTo: "left",
        duration: "medium"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...animationProps,
            style: {
                ...animationProps.style,
                height: '100%'
            }
        }, sideNavContent))))));
};
const $26f896fac969a05b$export$831c51bb03eeaaed = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoSideNavigation(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoSideNavigationWithStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function RovoSideNavigation(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($26f896fac969a05b$var$RovoSideNavigationWithStore, props);
};























const $88362faacf0f9024$var$RovoSideNavigationInner = ({ isOpen: isOpen, onClose: onClose, chatMode: chatMode, onSpaceCreated: onSpaceCreated, onViewAllSpacesClick: onViewAllSpacesClick, disableInPackageSpaceLandingPage: disableInPackageSpaceLandingPage = false, activeMenu: activeMenu, selectedSpace: selectedSpace })=>{
    (0, $6cFsl.di)((0, $bY61u.useInsightsStatus));
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { profileData: profileData } = (0, $eKjv9.useGlobalConfig)();
    const touchpointSource = 'rovo-sidenav';
    const assistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: touchpointSource
    });
    const { sendMessage: sendMessage, setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const TASKS_ENABLED = (0, $iDrrr.fg)('rovo_chat_enable_tasks');
    const PINNED_CHATS_ENABLED = (0, $iDrrr.fg)('rovo_chat_pinned_fe');
    const { siteId: siteId, agents: agents, selectedAgent: selectedAgent, conversations: conversations, pinnedCountConversations: pinnedCountConversations, pinnedConversationSummary: pinnedConversationSummary, currentConversation: currentConversation, isAbleToCreateAgents: isAbleToCreateAgents, isFetchingRecommendedAgents: isFetchingRecommendedAgents, handleNewChatClick: handleNewChatClick, handleConversationClick: handleConversationClick, handleCreateAgentClick: handleCreateAgentClick, handleSelectAgent: handleSelectAgent, handleViewAllAgentsClick: handleViewAllAgentsClick, handleViewAllSpacesClick: handleViewAllSpacesClick, handleViewAllConversationsClick: handleViewAllConversationsClick, handlePulseClick: handlePulseClick, handleTasksClick: handleTasksClick, handleScheduledChatsClick: handleScheduledChatsClick, handleConversationStarterClick: handleConversationStarterClick, handleConversationPinToggle: handleConversationPinToggle, deleteAgentLocally: deleteAgentLocally, deleteConversation: { conversationToBeDeleted: conversationToBeDeleted, openDeleteModal: openDeleteModal, handleDeleteConfirm: handleDeleteConfirm }, editConversation: { handleEditConversationConfirm: handleEditConversationConfirm }, moveToSpace: { handleMoveConversationToSpace: handleMoveConversationToSpace, handleMoveConversationToNewSpace: handleMoveConversationToNewSpace, conversationToMoveToNewSpace: conversationToMoveToNewSpace, clearConversationToMoveToNewSpace: clearConversationToMoveToNewSpace } } = (0, $c2e50244e69d336a$export$ff0cc4f0d3c9ae80)({
        assistanceServiceParams: assistanceServiceParams,
        onConversationStarterClick: (params)=>{
            sendMessage(params);
        },
        isTasksEnabled: TASKS_ENABLED,
        isNavOpen: isOpen,
        onViewAllSpacesClick: onViewAllSpacesClick
    });
    const mode = fullScreen || chatMode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL ? 'fullscreen' : chatMode;
    const { setActiveMenu: setActiveMenu, setSelectedSpace: setSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setEmptyChatLaunch: setEmptyChatLaunch } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeTabId: activeTabId }] = (0, $bGNkz.useActiveTabSelector)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const intl = (0, $kSwu1.useIntl)();
    // Only enabled when ADS navigation should be used (only true for townsquare which uses rovo-navigation directly)
    const isADSNavigationEnabled = false;
    const SCHEDULED_CHATS_ENABLED = (0, $cXtTj.default).getExperimentValue('rovo_chat_scheduled_chat', 'isEnabled', false);
    // Check if pulse experiment is enabled (exclude fullScreen, matching the empty state banner behavior)
    const isPulseExperimentEnabled = !fullScreen && (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
    const { isInsightsAvailable: isInsightsAvailable } = (0, $bY61u.useInsightsStatus)({
        enabled: isPulseExperimentEnabled,
        assistanceServiceParams: assistanceServiceParams
    });
    const showInsightsMenu = isPulseExperimentEnabled && isInsightsAvailable;
    const isMoveConversationCreateSpaceModalOpen = conversationToMoveToNewSpace !== undefined;
    const [isStandaloneCreateSpaceModalOpen, setIsStandaloneCreateSpaceModalOpen] = (0, $cozmU.useState)(false); // Capture sources from onCreate (fires locally before BE call) so we can
    // include them in the store when onCreated fires (after BE confirms creation).
    const pendingSourcesRef = (0, $cozmU.useRef)([]);
    const handleCreate = (0, $cozmU.useCallback)((payload)=>{
        pendingSourcesRef.current = (payload.sources ?? []).map((s)=>({
                ari: s.ari,
                url: s.url,
                sourceType: s.sourceType,
                name: s.name
            }));
    }, []);
    const handleSelectSpace = (0, $cozmU.useCallback)((space, sources, closeNav)=>{
        setSelectedSpace({
            id: space.id,
            name: space.name,
            emoji: space.emoji,
            sources: sources,
            entryPoint: 'sidebar'
        });
        // Save the tab the user launched from so the header back button
        // (`resetToPreviousTab()`) returns them there. Then switch to Suggestions
        // so the chat input isn't hidden by MiniModalForYouThreadsListHidesInput.
        setPreviousTabId(activeTabId);
        setActiveTabId((0, $eef113145ca4ccce$export$a6818377be660b14));
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        // Replace any default conversation actions with the shared space
        // starters so the empty chat shows space-relevant suggestions.
        // This is gated by the Rovo spaces experiment (matching the rest of the Spaces UI)
        // for defense-in-depth, even though `handleSelectSpace` itself is only reachable
        // from gated entry points.
        if ((0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) {
            // Build a project context so that the resulting conversation is
            // scoped to this space. Without this, sendMessage would resolve
            // `spaceId` from `aiFeatureContext.projectContext.spaceId` (see
            // `send-message-action.ts`) and find nothing — meaning the new
            // conversation would not be created in the selected space.
            // Mirrors the wiring used by `handleChatEmptyLaunch` in
            // `chat-history/index.tsx` (which is invoked from the For You
            // space cards) so both entry points behave identically.
            const projectContext = {
                projectId: space.id,
                projectName: space.name,
                projectUrl: '',
                spaceId: space.id
            };
            // Write project context into the chat-context store so that
            // sendMessage includes `space_id` in the backend request payload
            // for any message launched from this empty chat (including the
            // space starter prompts below).
            setAIFeatureContext({
                contextKey: 'projectContext',
                setContext: (_)=>projectContext
            });
            setEmptyChatLaunch({
                // Build the starters imperatively here so the freshly-selected
                // space's name is interpolated into the prompts (rather than
                // the previously-selected space, which is what `selectedSpace`
                // would still hold at this point).
                customConversationActions: (0, $469e3ce09396ad62$export$670f88557775636a)(intl, {
                    spaceName: space.name
                }),
                replaceProviderActions: true,
                projectContext: projectContext
            });
        }
        if (!disableInPackageSpaceLandingPage && chatMode !== (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) setActiveMenu('space-landing');
        else if (activeMenu !== 'none') setActiveMenu('none');
        if (closeNav) onClose();
    }, [
        setSelectedSpace,
        setActiveTabId,
        setPreviousTabId,
        activeTabId,
        setSelectedConversation,
        setAIFeatureContext,
        setEmptyChatLaunch,
        intl,
        activeMenu,
        chatMode,
        setActiveMenu,
        disableInPackageSpaceLandingPage,
        onClose
    ]);
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, isMoveConversationCreateSpaceModalOpen && /*#__PURE__*/ $cozmU.createElement((0, $gh5g4.CreateSpaceModal), {
        isOpen: isMoveConversationCreateSpaceModalOpen,
        onClose: clearConversationToMoveToNewSpace,
        cloudId: siteId,
        assistanceServiceParams: assistanceServiceParams,
        initialConversationId: conversationToMoveToNewSpace?.id,
        onCreate: handleCreate,
        onCreated: (space_0, emojiId)=>{
            // Do NOT call `addSpace` here — the host's `onSpaceCreated` callback owns the optimistic update.
            const sources_0 = pendingSourcesRef.current;
            clearConversationToMoveToNewSpace();
            handleSelectSpace({
                id: space_0.id,
                name: space_0.name,
                emoji: emojiId ?? null
            }, sources_0, true);
            onSpaceCreated?.(space_0, sources_0, emojiId);
            pendingSourcesRef.current = [];
        }
    }), isStandaloneCreateSpaceModalOpen && /*#__PURE__*/ $cozmU.createElement((0, $gh5g4.CreateSpaceModal), {
        isOpen: isStandaloneCreateSpaceModalOpen,
        onClose: ()=>setIsStandaloneCreateSpaceModalOpen(false),
        cloudId: siteId,
        assistanceServiceParams: assistanceServiceParams,
        onCreate: handleCreate,
        onCreated: (space_1, emojiId_0)=>{
            // See the move-conversation modal above — host owns
            // the optimistic add via `onSpaceCreated`.
            const sources_1 = pendingSourcesRef.current;
            setIsStandaloneCreateSpaceModalOpen(false);
            handleSelectSpace({
                id: space_1.id,
                name: space_1.name,
                emoji: emojiId_0 ?? null
            }, sources_1, true);
            onSpaceCreated?.(space_1, sources_1, emojiId_0);
            pendingSourcesRef.current = [];
        }
    }), /*#__PURE__*/ $cozmU.createElement((0, $26f896fac969a05b$export$831c51bb03eeaaed), {
        cloudId: siteId,
        userId: profileData.aaid ?? undefined,
        assistanceServiceParams: assistanceServiceParams,
        mode: mode,
        isADSNavigationEnabled: isADSNavigationEnabled,
        onCreateSpaceClick: ()=>setIsStandaloneCreateSpaceModalOpen(true),
        onViewAllSpacesClick: // Show the "View all Rovo spaces" link whenever Rovo spaces is enabled: the controller
        // handler defaults to flipping the
        // in-app activeMenu to `'browse-spaces'`, and additionally
        // invokes the optional host callback if one is provided.
        // Mirrors the agents equivalent but does not require host
        // wiring to surface a destination.
        (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? handleViewAllSpacesClick : undefined,
        onSelectRecommendedSpaces: ()=>{
            setActiveMenu('recommended-spaces');
            setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
            });
        },
        onSelectSpace: handleSelectSpace,
        selectedSpaceId: selectedSpace?.id ?? (activeMenu === 'recommended-spaces' ? 'recommended' : undefined),
        isNewAllConversationScreenEnabled: (0, $iDrrr.fg)('rovo_chat_chat_history_refresh'),
        isSpinnerOverlayConversationIconEnabled: (0, $iDrrr.fg)('rovo_chat_chat_history_refresh'),
        isOpen: isOpen,
        onClose: onClose,
        canCreateAgents: isAbleToCreateAgents,
        onPulseClick: showInsightsMenu ? handlePulseClick : undefined,
        onTasksClick: TASKS_ENABLED ? handleTasksClick : undefined,
        onScheduledChatsClick: SCHEDULED_CHATS_ENABLED ? handleScheduledChatsClick : undefined,
        isTasksEnabled: TASKS_ENABLED,
        conversationListProps: {
            conversations: conversations,
            pinnedCountConversations: pinnedCountConversations,
            pinnedConversationSummary: pinnedConversationSummary,
            currentConversation: currentConversation,
            onSelectConversation: handleConversationClick,
            onConversationDelete: openDeleteModal,
            onConversationRename: handleEditConversationConfirm,
            onConversationPinToggle: PINNED_CHATS_ENABLED ? handleConversationPinToggle : undefined,
            onViewAllConversations: handleViewAllConversationsClick,
            onConversationMoveToSpace: handleMoveConversationToSpace,
            onConversationMoveToNewSpace: handleMoveConversationToNewSpace
        },
        onNewChatButtonClick: ()=>handleNewChatClick(isADSNavigationEnabled),
        agentsListProps: {
            agents: agents,
            isFetchingRecommendedAgents: isFetchingRecommendedAgents,
            onSelectAgent: handleSelectAgent,
            onCreateAgentClick: handleCreateAgentClick,
            onViewAllAgentsClick: handleViewAllAgentsClick,
            selectedAgent: selectedAgent,
            onConversationStarterClick: handleConversationStarterClick,
            onDeleteAgent: deleteAgentLocally
        }
    }), conversationToBeDeleted && /*#__PURE__*/ $cozmU.createElement((0, $09227ba992b2f51d$export$47cf2b6f3b49166a), {
        onDeleteConfirm: ()=>handleDeleteConfirm(conversationToBeDeleted.id),
        analyticsAttributes: {
            touchpointSource: touchpointSource
        }
    }));
};
// rovo_ttai_segment_render_stabilization: absorb parent render waves when props are stable.
const $88362faacf0f9024$var$MemoizedRovoSideNavigationInner = /*#__PURE__*/ (0, $cozmU.memo)($88362faacf0f9024$var$RovoSideNavigationInner, (0, $dqxOF.shallowEqualObjects)); // rovo_ttai_segment_render_stabilization ON: subscribe to `activeMenu` and
// `selectedSpace` via the narrow composite selector so the component only
// re-renders when one of those fields changes, rather than on every UI-store
// state change.
const $88362faacf0f9024$var$RovoSideNavigationWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useSideNavUISelector));
    const [{ activeMenu: activeMenu, selectedSpace: selectedSpace }] = (0, $bGNkz.useSideNavUISelector)();
    return /*#__PURE__*/ $cozmU.createElement($88362faacf0f9024$var$MemoizedRovoSideNavigationInner, {
        ...props,
        activeMenu: activeMenu,
        selectedSpace: selectedSpace
    });
}; // rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $88362faacf0f9024$var$RovoSideNavigationWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { activeMenu: activeMenu, selectedSpace: selectedSpace } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ $cozmU.createElement($88362faacf0f9024$var$RovoSideNavigationInner, {
        ...props,
        activeMenu: activeMenu,
        selectedSpace: selectedSpace
    });
};
const $88362faacf0f9024$export$831c51bb03eeaaed = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoSideNavigation(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ $cozmU.createElement($88362faacf0f9024$var$RovoSideNavigationWithSelector, props) : /*#__PURE__*/ $cozmU.createElement($88362faacf0f9024$var$RovoSideNavigationWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function RovoSideNavigation(props) {
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ $cozmU.createElement($88362faacf0f9024$var$RovoSideNavigationWithSelector, props) : /*#__PURE__*/ $cozmU.createElement($88362faacf0f9024$var$RovoSideNavigationWithBroadStore, props);
};















var $4teLb = parcelRequire("4teLb");

const $d767123d2fe5b450$export$259ee31710351d2d = (0, $kBr4q.createStateHook)((0, $4teLb.RovodalStore));



















var $5sRAM = parcelRequire("5sRAM");


var $iuVKP = parcelRequire("iuVKP");





const $836715a331005893$export$9c4c5c037a514608 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "0nZh6",
    name: "AsyncBlastRadiusCanvas",
    loader: ()=>(parcelRequire("3DdwQ")).then((m)=>m.BlastRadiusCanvas),
    loading: ()=>null
});



var $cLuNh = parcelRequire("cLuNh");

const $889951014a49809f$export$966198ae26c835a9 = {
    [(0, $cLuNh.RovodalCanvasKeys).jiraAdminAgentBlastRadiusCanvas]: (0, $836715a331005893$export$9c4c5c037a514608)
};






const $70743103f074047d$export$b3e7b72b48fd0b98 = ({ onLoaded: onLoaded })=>{
    const onLoadedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(onLoaded);
    onLoadedRef.current = onLoaded;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        onLoadedRef.current();
    }, []);
    return null;
};


















var $5avUB = parcelRequire("5avUB");














var $gKKIc = parcelRequire("gKKIc");


var $pFqKC = parcelRequire("pFqKC");


var $kaPN1 = parcelRequire("kaPN1");


var $gPDwp = parcelRequire("gPDwp");

const $c24b3e114aa08a47$var$acceptAllMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.AcceptAllRemainingButton.acceptAll.non-final",
    defaultMessage: "Apply all remaining changes"
});
const $c24b3e114aa08a47$var$acceptPlanMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.AcceptAllRemainingButton.acceptPlan.non-final",
    defaultMessage: "Apply changes"
});
const $c24b3e114aa08a47$var$completedMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.AcceptAllRemainingButton.completed.non-final",
    defaultMessage: "Done"
});
const $c24b3e114aa08a47$var$failedMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.AcceptAllRemainingButton.failed.non-final",
    defaultMessage: "Couldn't apply"
});
const $c24b3e114aa08a47$var$retryMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.AcceptAllRemainingButton.retry.non-final",
    defaultMessage: "Retry"
});
const $c24b3e114aa08a47$export$3533b08af9c7a788 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [entry] = (0, $5sRAM.useRovodal)((0, $gKKIc.RovodalStoreKeys).jiraAdminAgentCanvas);
    const state = entry?.state;
    // Only step actions are applyable; the plan action is a container.
    const stepActions = (0, $cozmU.useMemo)(()=>(state?.actions ?? []).filter((action)=>action.data.actionType === 'step'), [
        state?.actions
    ]);
    const invocationIds = (0, $cozmU.useMemo)(()=>stepActions.map((action)=>action.invocationId), [
        stepActions
    ]);
    const statuses = (0, $pFqKC.useActionInvocationStatuses)(state?.conversationId, invocationIds);
    // `useActionPlanApplyState` requires a `conversationId` string; the open canvas may not have
    // one yet, so fall back to `''` the same way `useActionInvocationStatuses` does internally.
    const { perStep: perStep, runApply: runApply } = (0, $gPDwp.useActionPlanApplyState)(state?.conversationId ?? '', invocationIds);
    // "Remaining" = steps still valid to apply: stored status still `planned` and live status
    // `idle`. Anything already terminal (`finished`/`cancelled`/`errored`) or in-flight is excluded.
    const remainingActions = (0, $cozmU.useMemo)(()=>stepActions.filter((action)=>(action.status ?? 'planned') === 'planned' && statuses[action.invocationId] === 'idle'), [
        stepActions,
        statuses
    ]);
    const renderMode = (0, $cozmU.useMemo)(()=>(0, $kaPN1.getRenderMode)(stepActions.map((action)=>({
                storedStatus: action.status ?? 'planned',
                currentStatus: statuses[action.invocationId] ?? 'idle',
                inProgress: perStep[action.invocationId]?.inProgress ?? false,
                error: perStep[action.invocationId]?.error
            }))), [
        stepActions,
        statuses,
        perStep
    ]);
    const onAcceptAll = (0, $cozmU.useCallback)(async ()=>{
        const { sendMessageConfirmedTools: sendMessageConfirmedTools, messageId: messageId, conversationId: conversationId, recipientAgentId: recipientAgentId } = state ?? {};
        if (!sendMessageConfirmedTools || !messageId) return;
        const idsToApply = remainingActions.map((action)=>action.invocationId);
        await runApply(idsToApply, async ()=>{
            await sendMessageConfirmedTools({
                agentId: recipientAgentId,
                confirmed_tools: {
                    message_id: messageId,
                    tools: remainingActions.map((action)=>({
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            resolution: {
                                type: 'confirmed'
                            },
                            data: {
                                human_message_id: action.humanMessageId ?? '',
                                arguments: action.data
                            }
                        }))
                },
                conversationId: conversationId
            });
        });
    }, [
        state,
        remainingActions,
        runApply
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderMode === 'IN_PROGRESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "load"
    }), renderMode === 'ERROR' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.danger"
    }, formatMessage($c24b3e114aa08a47$var$failedMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onAcceptAll
    }, formatMessage($c24b3e114aa08a47$var$retryMessage))), renderMode === 'COMPLETE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
        isDisabled: true
    }, formatMessage($c24b3e114aa08a47$var$completedMessage)), renderMode === 'IDLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onAcceptAll
    }, formatMessage(remainingActions.length === stepActions.length ? $c24b3e114aa08a47$var$acceptPlanMessage : $c24b3e114aa08a47$var$acceptAllMessage)));
};





const $1cb0766dfad2f50f$export$646bee3b9d3e446f = {
    [(0, $cLuNh.RovodalCanvasKeys).jiraAdminAgentBlastRadiusCanvas]: {
        // Primary canvas-bar action mirroring the chat card's "Accept plan": applies
        // every plan step still pending. The button reads the open canvas from the
        // rovodal store, so it needs nothing from the actions context.
        canvasBarActions: ()=>/*#__PURE__*/ (0, $cozmU.createElement)((0, $c24b3e114aa08a47$export$3533b08af9c7a788))
    }
};



const $51c2da51587d2bd8$var$RovodalLazyComponent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("bKJ8C")).then((m)=>({
            default: m.Rovodal
        })));
Object.assign($51c2da51587d2bd8$var$RovodalLazyComponent, {
    displayName: 'lazy(Rovodal)'
});

const $51c2da51587d2bd8$var$RovodalLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "-S16h",
    name: "RovodalLoadableComponent",
    loader: ()=>(parcelRequire("bKJ8C")).then((m)=>m.Rovodal),
    loading: ()=>null
});
const $51c2da51587d2bd8$var$RovodalWithSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovodalWithSuspense(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$RovodalLazyComponent, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function RovodalWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$RovodalLazyComponent, props));
};
const $51c2da51587d2bd8$var$LoadableRovodal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("nike_r19_react_loadable") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$RovodalWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$RovodalLoadableComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $iDrrr.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$RovodalWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$RovodalLoadableComponent, props);
const $51c2da51587d2bd8$export$eb25c89b30356db2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(69);
    const { rovodalKey: rovodalKey, instanceId: instanceId, config: config } = t0;
    const [entry, t1] = (0, $5sRAM.useRovodal)(rovodalKey, instanceId);
    const { close: close, setState: setState } = t1;
    let t2;
    if ($[0] !== entry?.state || $[1] !== setState) {
        t2 = ()=>{
            if (!entry?.state?.loaded) setState({
                ...entry?.state,
                loaded: true
            });
        };
        $[0] = entry?.state;
        $[1] = setState;
        $[2] = t2;
    } else t2 = $[2];
    entry?.state;
    const markLoaded = t2;
    if (!entry?.isOpen) return null;
    const canvasKey = entry.state?.canvasKey ?? entry.key;
    const Canvas = (0, $889951014a49809f$export$966198ae26c835a9)[canvasKey];
    const actions = (0, $1cb0766dfad2f50f$export$646bee3b9d3e446f)[canvasKey];
    let t3;
    if ($[3] !== entry.state?.chatOverrides) {
        t3 = entry.state?.chatOverrides ?? {};
        $[3] = entry.state?.chatOverrides;
        $[4] = t3;
    } else t3 = $[4];
    let chatOverridesRest;
    let uiConfigOverride;
    if ($[5] !== t3) {
        ({ uiConfig: uiConfigOverride, ...chatOverridesRest } = t3);
        $[5] = t3;
        $[6] = chatOverridesRest;
        $[7] = uiConfigOverride;
    } else {
        chatOverridesRest = $[6];
        uiConfigOverride = $[7];
    }
    let t4;
    if ($[8] !== close) {
        t4 = ()=>close();
        $[8] = close;
        $[9] = t4;
    } else t4 = $[9];
    const onClose = t4;
    let T0;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[10] !== actions || $[11] !== entry.state?.backLabel || $[12] !== entry.state?.closeLabel || $[13] !== entry.state?.fullSizeModal || $[14] !== entry.state?.label || $[15] !== entry.state?.readOnlyAgentHeader || $[16] !== entry.state?.showBackButton || $[17] !== entry.state?.title || $[18] !== onClose || $[19] !== rovodalKey) {
        const actionsContext = {
            close: onClose
        };
        T0 = $51c2da51587d2bd8$var$LoadableRovodal;
        t5 = rovodalKey;
        t6 = true;
        t7 = entry.state?.fullSizeModal;
        t8 = onClose;
        t9 = entry.state?.title;
        t10 = entry.state?.readOnlyAgentHeader;
        t11 = entry.state?.showBackButton;
        t12 = entry.state?.backLabel;
        t13 = entry.state?.closeLabel;
        t14 = entry.state?.label;
        t15 = actions?.topBarActions?.(actionsContext);
        t16 = actions?.bottomBarActions?.(actionsContext);
        t17 = actions?.canvasBarActions?.(actionsContext);
        $[10] = actions;
        $[11] = entry.state?.backLabel;
        $[12] = entry.state?.closeLabel;
        $[13] = entry.state?.fullSizeModal;
        $[14] = entry.state?.label;
        $[15] = entry.state?.readOnlyAgentHeader;
        $[16] = entry.state?.showBackButton;
        $[17] = entry.state?.title;
        $[18] = onClose;
        $[19] = rovodalKey;
        $[20] = T0;
        $[21] = t10;
        $[22] = t11;
        $[23] = t12;
        $[24] = t13;
        $[25] = t14;
        $[26] = t15;
        $[27] = t16;
        $[28] = t17;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
        $[32] = t8;
        $[33] = t9;
    } else {
        T0 = $[20];
        t10 = $[21];
        t11 = $[22];
        t12 = $[23];
        t13 = $[24];
        t14 = $[25];
        t15 = $[26];
        t16 = $[27];
        t17 = $[28];
        t5 = $[29];
        t6 = $[30];
        t7 = $[31];
        t8 = $[32];
        t9 = $[33];
    }
    let t18;
    if ($[34] !== Canvas || $[35] !== entry.state || $[36] !== rovodalKey) {
        t18 = Canvas ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Canvas, {
            rovodalKey: rovodalKey,
            state: entry.state
        }) : null;
        $[34] = Canvas;
        $[35] = entry.state;
        $[36] = rovodalKey;
        $[37] = t18;
    } else t18 = $[37];
    let t19;
    if ($[38] !== markLoaded) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70743103f074047d$export$b3e7b72b48fd0b98), {
            onLoaded: markLoaded
        });
        $[38] = markLoaded;
        $[39] = t19;
    } else t19 = $[39];
    const t20 = uiConfigOverride?.elements;
    let t21;
    if ($[40] !== t20) {
        t21 = {
            ...t20
        };
        $[40] = t20;
        $[41] = t21;
    } else t21 = $[41];
    let t22;
    if ($[42] !== t21 || $[43] !== uiConfigOverride) {
        t22 = {
            externalEmbed: true,
            ...uiConfigOverride,
            elements: t21
        };
        $[42] = t21;
        $[43] = uiConfigOverride;
        $[44] = t22;
    } else t22 = $[44];
    let t23;
    if ($[45] !== chatOverridesRest || $[46] !== config || $[47] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuVKP.ConversationAssistant), {
            config: config,
            testId: "rovodal-host-conversation-assistant",
            ...chatOverridesRest,
            uiConfig: t22
        });
        $[45] = chatOverridesRest;
        $[46] = config;
        $[47] = t22;
        $[48] = t23;
    } else t23 = $[48];
    let t24;
    if ($[49] !== t19 || $[50] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3617fdb62236701e$export$8d7d1f2543f67b).Provider, {
            value: true
        }, t19, t23);
        $[49] = t19;
        $[50] = t23;
        $[51] = t24;
    } else t24 = $[51];
    let t25;
    if ($[52] !== T0 || $[53] !== t10 || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17 || $[61] !== t18 || $[62] !== t24 || $[63] !== t5 || $[64] !== t6 || $[65] !== t7 || $[66] !== t8 || $[67] !== t9) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            id: t5,
            isOpen: t6,
            fullSizeModal: t7,
            onClose: t8,
            title: t9,
            readOnlyAgentHeader: t10,
            showBackButton: t11,
            backLabel: t12,
            closeLabel: t13,
            label: t14,
            topBarActions: t15,
            bottomBarActions: t16,
            canvasBarActions: t17,
            canvas: t18,
            chat: t24
        });
        $[52] = T0;
        $[53] = t10;
        $[54] = t11;
        $[55] = t12;
        $[56] = t13;
        $[57] = t14;
        $[58] = t15;
        $[59] = t16;
        $[60] = t17;
        $[61] = t18;
        $[62] = t24;
        $[63] = t5;
        $[64] = t6;
        $[65] = t7;
        $[66] = t8;
        $[67] = t9;
        $[68] = t25;
    } else t25 = $[68];
    return t25;
} : ({ rovodalKey: rovodalKey, instanceId: instanceId, config: config })=>{
    const [entry, { close: close, setState: setState }] = (0, $5sRAM.useRovodal)(rovodalKey, instanceId);
    const markLoaded = (0, $cozmU.useCallback)(()=>{
        if (!entry?.state?.loaded) setState({
            ...entry?.state,
            loaded: true
        });
    }, [
        entry?.state,
        setState
    ]);
    if (!entry?.isOpen) return null;
    const canvasKey = entry.state?.canvasKey ?? entry.key;
    const Canvas = (0, $889951014a49809f$export$966198ae26c835a9)[canvasKey];
    const actions = (0, $1cb0766dfad2f50f$export$646bee3b9d3e446f)[canvasKey];
    const { uiConfig: uiConfigOverride, ...chatOverridesRest } = entry.state?.chatOverrides ?? {};
    const onClose = ()=>close();
    const actionsContext = {
        close: onClose
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51c2da51587d2bd8$var$LoadableRovodal, {
        id: rovodalKey,
        isOpen: true,
        fullSizeModal: entry.state?.fullSizeModal,
        onClose: onClose,
        title: entry.state?.title,
        readOnlyAgentHeader: entry.state?.readOnlyAgentHeader,
        showBackButton: entry.state?.showBackButton,
        backLabel: entry.state?.backLabel,
        closeLabel: entry.state?.closeLabel,
        label: entry.state?.label,
        topBarActions: actions?.topBarActions?.(actionsContext),
        bottomBarActions: actions?.bottomBarActions?.(actionsContext),
        canvasBarActions: actions?.canvasBarActions?.(actionsContext),
        canvas: Canvas ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Canvas, {
            rovodalKey: rovodalKey,
            state: entry.state
        }) : null,
        chat: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3617fdb62236701e$export$8d7d1f2543f67b).Provider, {
            value: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70743103f074047d$export$b3e7b72b48fd0b98), {
            onLoaded: markLoaded
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuVKP.ConversationAssistant), {
            config: config,
            testId: "rovodal-host-conversation-assistant",
            ...chatOverridesRest,
            uiConfig: {
                externalEmbed: true,
                ...uiConfigOverride,
                elements: {
                    ...uiConfigOverride?.elements
                }
            }
        }))
    });
};


const $ee059fb9892e5b7d$export$15582ee5bba2c5a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { config: config } = t0;
    const insideRovodal = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $3617fdb62236701e$export$8d7d1f2543f67b));
    const { byKey: byKey } = (0, $d767123d2fe5b450$export$259ee31710351d2d)();
    let t1;
    if ($[0] !== byKey) {
        t1 = Object.values(byKey).flatMap($ee059fb9892e5b7d$var$_temp).find($ee059fb9892e5b7d$var$_temp2);
        $[0] = byKey;
        $[1] = t1;
    } else t1 = $[1];
    const openEntry = t1;
    if (insideRovodal || !openEntry) return null;
    let t2;
    if ($[2] !== config || $[3] !== openEntry.instanceId || $[4] !== openEntry.key) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51c2da51587d2bd8$export$eb25c89b30356db2), {
            rovodalKey: openEntry.key,
            instanceId: openEntry.instanceId,
            config: config
        });
        $[2] = config;
        $[3] = openEntry.instanceId;
        $[4] = openEntry.key;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ config: config })=>{
    const insideRovodal = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $3617fdb62236701e$export$8d7d1f2543f67b));
    const { byKey: byKey } = (0, $d767123d2fe5b450$export$259ee31710351d2d)();
    const openEntry = Object.values(byKey).flatMap((instances)=>Object.values(instances)).find((entry)=>entry.isOpen);
    if (insideRovodal || !openEntry) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51c2da51587d2bd8$export$eb25c89b30356db2), {
        rovodalKey: openEntry.key,
        instanceId: openEntry.instanceId,
        config: config
    });
};
function $ee059fb9892e5b7d$var$_temp(instances) {
    return Object.values(instances);
}
function $ee059fb9892e5b7d$var$_temp2(entry) {
    return entry.isOpen;
}




















/** Publishes the selected agent to the AI Mate channel. */ const $a386c8c1bbc50551$var$SelectedAgentPublisherInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { selectedAgent: selectedAgent } = t0;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    let t1;
    if ($[0] !== publish || $[1] !== selectedAgent) {
        t1 = ()=>{
            if (selectedAgent?.id && selectedAgent?.name && !selectedAgent?.is_default) {
                publish({
                    type: "agent-changed",
                    source: "ai-mate",
                    data: {
                        agent: {
                            id: selectedAgent.id,
                            name: selectedAgent.name,
                            identityAccountId: selectedAgent.identity_account_id
                        }
                    }
                });
                return ()=>{
                    publish({
                        type: "agent-changed",
                        source: "ai-mate",
                        data: {
                            agent: null
                        }
                    });
                };
            }
        };
        $[0] = publish;
        $[1] = selectedAgent;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = selectedAgent?.id;
    const t3 = selectedAgent?.name;
    const t4 = selectedAgent?.identity_account_id;
    const t5 = selectedAgent?.is_default;
    let t6;
    if ($[3] !== publish || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = [
            t2,
            t3,
            t4,
            t5,
            publish
        ];
        $[3] = publish;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    (0, $cozmU.useEffect)(t1, t6);
    return null;
} : ({ selectedAgent: selectedAgent })=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        if (selectedAgent?.id && selectedAgent?.name && !selectedAgent?.is_default) {
            publish({
                type: 'agent-changed',
                source: 'ai-mate',
                data: {
                    agent: {
                        id: selectedAgent.id,
                        name: selectedAgent.name,
                        identityAccountId: selectedAgent.identity_account_id
                    }
                }
            });
            return ()=>{
                publish({
                    type: 'agent-changed',
                    source: 'ai-mate',
                    data: {
                        agent: null
                    }
                });
            };
        }
    }, [
        selectedAgent?.id,
        selectedAgent?.name,
        selectedAgent?.identity_account_id,
        selectedAgent?.is_default,
        publish
    ]);
    return null;
};
const $a386c8c1bbc50551$export$c55e2c0e0e9abdf2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    let t0;
    if ($[0] !== conversationId) {
        t0 = {
            conversationId: conversationId
        };
        $[0] = conversationId;
        $[1] = t0;
    } else t0 = $[1];
    const { selectedAgent: selectedAgent } = (0, $dQbwX.useChatConversation)(t0);
    let t1;
    if ($[2] !== selectedAgent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a386c8c1bbc50551$var$SelectedAgentPublisherInner, {
            selectedAgent: selectedAgent
        });
        $[2] = selectedAgent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    const { selectedAgent: selectedAgent } = (0, $dQbwX.useChatConversation)({
        conversationId: conversationId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a386c8c1bbc50551$var$SelectedAgentPublisherInner, {
        selectedAgent: selectedAgent
    });
};




















































/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- fixed pixel sizes and raw font-feature-settings */ const $8a4c2083ac2f10e3$var$styles = {
    spaceContent: "_2mHwu8gVvo _3iDTPbccYA _0hPCNLDIqT _4ouGXIdnbC _2O5Vij7dHp",
    emojiWrapper: "_3YEZNOdnbC",
    spaceName: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzZpcK _3C14nsjBF4 _1kk5Tkf7mX _2l4i3rzUZr",
    container: "_0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPUhQC5 _3hhsrrNvrM _3BoeID6wH8 _3XVgLMhQC5",
    clickableContainer: "_0wOv4Q7zJH _0KLXrulfZc _1eOmH6d1Zr"
};
const $8a4c2083ac2f10e3$var$SpaceBarComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { emoji: emoji, name: name, cloudId: cloudId, emojiProvider: emojiProviderProp, onClick: onClick, testId: t1 } = t0;
    const testId = t1 === undefined ? "space-bar" : t1;
    let t2;
    if ($[0] !== cloudId) {
        t2 = (0, $d26Wq.createEmojiProvider)(cloudId);
        $[0] = cloudId;
        $[1] = t2;
    } else t2 = $[1];
    const internalEmojiProvider = t2;
    const emojiProvider = emojiProviderProp ?? internalEmojiProvider;
    let t3;
    if ($[2] !== emoji || $[3] !== emojiProvider || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8a4c2083ac2f10e3$var$styles.emojiWrapper
        }, emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: {
                id: emoji,
                shortName: emoji
            },
            emojiProvider: emojiProvider,
            fitToHeight: 16
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: `${testId}-folder-icon`
        }));
        $[2] = emoji;
        $[3] = emojiProvider;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== name) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8a4c2083ac2f10e3$var$styles.spaceName
        }, name);
        $[6] = name;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8a4c2083ac2f10e3$var$styles.spaceContent
        }, t3, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    const content = t5;
    if (onClick) {
        let t6;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $w6R6I.cx)($8a4c2083ac2f10e3$var$styles.container, $8a4c2083ac2f10e3$var$styles.clickableContainer);
            $[11] = t6;
        } else t6 = $[11];
        let t7;
        if ($[12] !== content || $[13] !== name || $[14] !== onClick || $[15] !== testId) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: t6,
                testId: testId,
                onClick: onClick,
                "aria-label": name
            }, content);
            $[12] = content;
            $[13] = name;
            $[14] = onClick;
            $[15] = testId;
            $[16] = t7;
        } else t7 = $[16];
        return t7;
    }
    let t6;
    if ($[17] !== content || $[18] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8a4c2083ac2f10e3$var$styles.container,
            testId: testId
        }, content);
        $[17] = content;
        $[18] = testId;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
} : ({ emoji: emoji, name: name, cloudId: cloudId, emojiProvider: emojiProviderProp, onClick: onClick, testId: testId = 'space-bar' })=>{
    const internalEmojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProvider)(cloudId), [
        cloudId
    ]);
    const emojiProvider = emojiProviderProp ?? internalEmojiProvider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a4c2083ac2f10e3$var$styles.spaceContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a4c2083ac2f10e3$var$styles.emojiWrapper
    }, emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiId: {
            id: emoji,
            shortName: emoji
        },
        emojiProvider: emojiProvider,
        fitToHeight: 16
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)",
        testId: `${testId}-folder-icon`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a4c2083ac2f10e3$var$styles.spaceName
    }, name));
    if (onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($8a4c2083ac2f10e3$var$styles.container, $8a4c2083ac2f10e3$var$styles.clickableContainer),
        testId: testId,
        onClick: onClick,
        "aria-label": name
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a4c2083ac2f10e3$var$styles.container,
        testId: testId
    }, content);
};
const $8a4c2083ac2f10e3$export$9cfe5cef70cf9f9b = /*#__PURE__*/ (0, $cozmU.memo)($8a4c2083ac2f10e3$var$SpaceBarComponent);





const $f4f1472a3b3f2f7b$var$SelectedSpaceBarComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { cloudId: cloudId, emojiProvider: emojiProvider, selectedSpace: selectedSpace } = t0;
    const { setActiveMenu: setActiveMenu, setSelectedSpace: setSelectedSpace } = (0, $bGNkz.useUIStoreActions)();
    const currentConversation = (0, $e8YqO.useCurrentConversation)();
    const spaces = (0, $12shJ.useSpaces)();
    let t1;
    if ($[0] !== currentConversation || $[1] !== selectedSpace || $[2] !== spaces) {
        t1 = selectedSpace ?? (currentConversation?.rovoSpaceId ? spaces.find((s)=>s.id === currentConversation.rovoSpaceId) : undefined);
        $[0] = currentConversation;
        $[1] = selectedSpace;
        $[2] = spaces;
        $[3] = t1;
    } else t1 = $[3];
    const activeSpace = t1;
    if (!activeSpace || !(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return null;
    let t2;
    if ($[4] !== activeSpace.emoji || $[5] !== activeSpace.id || $[6] !== activeSpace.name || $[7] !== selectedSpace?.entryPoint || $[8] !== setActiveMenu || $[9] !== setSelectedSpace) {
        t2 = ()=>{
            setSelectedSpace({
                id: activeSpace.id,
                name: activeSpace.name,
                emoji: activeSpace.emoji,
                entryPoint: selectedSpace?.entryPoint
            });
            setActiveMenu("space-landing");
        };
        $[4] = activeSpace.emoji;
        $[5] = activeSpace.id;
        $[6] = activeSpace.name;
        $[7] = selectedSpace?.entryPoint;
        $[8] = setActiveMenu;
        $[9] = setSelectedSpace;
        $[10] = t2;
    } else t2 = $[10];
    const handleOpenSpace = t2;
    let t3;
    if ($[11] !== activeSpace.emoji || $[12] !== activeSpace.name || $[13] !== cloudId || $[14] !== emojiProvider || $[15] !== handleOpenSpace) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4c2083ac2f10e3$export$9cfe5cef70cf9f9b), {
            emoji: activeSpace.emoji,
            emojiProvider: emojiProvider,
            name: activeSpace.name,
            cloudId: cloudId,
            onClick: handleOpenSpace
        });
        $[11] = activeSpace.emoji;
        $[12] = activeSpace.name;
        $[13] = cloudId;
        $[14] = emojiProvider;
        $[15] = handleOpenSpace;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ cloudId: cloudId, emojiProvider: emojiProvider, selectedSpace: selectedSpace })=>{
    const { setActiveMenu: setActiveMenu, setSelectedSpace: setSelectedSpace } = (0, $bGNkz.useUIStoreActions)();
    const currentConversation = (0, $e8YqO.useCurrentConversation)();
    const spaces = (0, $12shJ.useSpaces)();
    // Prefer the explicitly-selected space from the ui-store (new chat flow).
    // Fall back to looking up the space by rovoSpaceId on the current conversation
    // so the bar remains visible when navigating into an existing space-scoped conversation.
    const activeSpace = selectedSpace ?? (currentConversation?.rovoSpaceId ? spaces.find((s)=>s.id === currentConversation.rovoSpaceId) : undefined);
    if (!activeSpace || !(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return null;
    const handleOpenSpace = ()=>{
        setSelectedSpace({
            id: activeSpace.id,
            name: activeSpace.name,
            emoji: activeSpace.emoji,
            entryPoint: selectedSpace?.entryPoint
        });
        setActiveMenu('space-landing');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4c2083ac2f10e3$export$9cfe5cef70cf9f9b), {
        emoji: activeSpace.emoji,
        emojiProvider: emojiProvider,
        name: activeSpace.name,
        cloudId: cloudId,
        onClick: handleOpenSpace
    });
};
// rovo_ttai_segment_render_stabilization: absorb parent render waves when props are stable.
const $f4f1472a3b3f2f7b$var$MemoizedSelectedSpaceBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($f4f1472a3b3f2f7b$var$SelectedSpaceBarComponent, (0, $dqxOF.shallowEqualObjects));
// rovo_ttai_segment_render_stabilization ON: subscribe to `selectedSpace` via the
// narrow selector so the component only re-renders when `selectedSpace` changes,
// rather than on every UI-store state change.
const $f4f1472a3b3f2f7b$var$SelectedSpaceBarWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useSelectedSpaceSelector));
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4f1472a3b3f2f7b$var$MemoizedSelectedSpaceBar, {
        ...props,
        selectedSpace: selectedSpace
    });
};
// rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $f4f1472a3b3f2f7b$var$SelectedSpaceBarWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { selectedSpace: selectedSpace } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4f1472a3b3f2f7b$var$SelectedSpaceBarComponent, {
        ...props,
        selectedSpace: selectedSpace
    });
};
const $f4f1472a3b3f2f7b$export$d81bbbede7744e29 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4f1472a3b3f2f7b$var$SelectedSpaceBarWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4f1472a3b3f2f7b$var$SelectedSpaceBarWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4f1472a3b3f2f7b$var$SelectedSpaceBarWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4f1472a3b3f2f7b$var$SelectedSpaceBarWithBroadStore, props);
};









const $da9f45b1174b6927$export$1ab8e89d32246657 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cio5w")).then((module)=>({
            default: module.ShareConversationModal
        })));


const $2d811609c19623d6$export$75fe342a4899ab80 = ({ state: state, organizationName: organizationName, cloudId: cloudId, productKey: productKey, principalId: principalId })=>{
    // Defer mounting the lazy boundary (and therefore the chunk
    // download) until the user actually opens the modal for the first
    // time. Once it has been opened at least once we keep the boundary
    // mounted so the modal's own `<ModalTransition>` exit animation
    // runs on close — and so subsequent opens are fully synchronous
    // against the already-loaded chunk.
    const hasEverOpenedRef = (0, $cozmU.useRef)(false);
    if (state.isOpen) hasEverOpenedRef.current = true;
    if (!hasEverOpenedRef.current) return null;
    // `Suspense` fallback is `null` because the modal is invisible
    // until open anyway — there is nothing for the user to perceive
    // during the one-shot chunk fetch on first open.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da9f45b1174b6927$export$1ab8e89d32246657), {
        isOpen: state.isOpen,
        onClose: state.close,
        organizationName: organizationName,
        cloudId: cloudId,
        productKey: productKey,
        principalId: principalId,
        isSubmitting: state.isSubmitting,
        isLoadingInitialState: state.isLoadingInitialState,
        errorMessage: state.errorMessage,
        errorCode: state.errorCode,
        onSubmit: state.handleCopyLink,
        canGenerate: state.canGenerate,
        seeWhatOthersCanSeeHref: state.seeWhatOthersCanSeeHref,
        shareUrl: state.shareUrl,
        copyLinkCreatesShare: true,
        autoSaveShareAccess: state.autoSaveShareAccess,
        isSavingShareAccess: state.isSavingShareAccess,
        onShareAccessChange: state.handleShareAccessChange,
        onBeforeCopyLink: state.flushShareAccessChanges,
        initialShareType: state.initialShareType,
        initialSelectedUsers: state.initialSelectedUsers,
        initialOwnerUser: state.initialOwnerUser,
        allowEmptySpecificUsers: true,
        showSpecificPeopleAccessList: true
    }));
};












var $f4V7N = parcelRequire("f4V7N");

const $d90d7faee342c7f7$export$ca3858b1f32a3a21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, shareUpToMessage: shareUpToMessage, isMessageShareable: isMessageShareable, shareDisabledReason: shareDisabledReason } = t0;
    let t1;
    if ($[0] !== isMessageShareable || $[1] !== shareDisabledReason || $[2] !== shareUpToMessage) {
        t1 = {
            shareUpToMessage: shareUpToMessage,
            isMessageShareable: isMessageShareable,
            shareDisabledReason: shareDisabledReason
        };
        $[0] = isMessageShareable;
        $[1] = shareDisabledReason;
        $[2] = shareUpToMessage;
        $[3] = t1;
    } else t1 = $[3];
    const value = t1;
    let t2;
    if ($[4] !== children || $[5] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4V7N.ShareUpToMessageContext).Provider, {
            value: value
        }, children);
        $[4] = children;
        $[5] = value;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, shareUpToMessage: shareUpToMessage, isMessageShareable: isMessageShareable, shareDisabledReason: shareDisabledReason })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            shareUpToMessage: shareUpToMessage,
            isMessageShareable: isMessageShareable,
            shareDisabledReason: shareDisabledReason
        }), [
        shareUpToMessage,
        isMessageShareable,
        shareDisabledReason
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4V7N.ShareUpToMessageContext).Provider, {
        value: value
    }, children);
};


















var $eS3l0 = parcelRequire("eS3l0");

const $10588f0c20b74dca$var$USER_ARI_PREFIX = 'ari:cloud:identity::user/';
const $10588f0c20b74dca$var$toUserAri = (accountId)=>`${$10588f0c20b74dca$var$USER_ARI_PREFIX}${accountId}`;
const $10588f0c20b74dca$var$getAccountIdFromUserAri = (userAri)=>userAri.startsWith($10588f0c20b74dca$var$USER_ARI_PREFIX) ? userAri.slice($10588f0c20b74dca$var$USER_ARI_PREFIX.length) : userAri;
const $10588f0c20b74dca$var$isCurrentUserAri = (userAri, currentUserId)=>Boolean(currentUserId && $10588f0c20b74dca$var$getAccountIdFromUserAri(userAri) === currentUserId);
const $10588f0c20b74dca$var$withoutCurrentUserAri = (userAris, currentUserId)=>userAris.filter((userAri)=>!$10588f0c20b74dca$var$isCurrentUserAri(userAri, currentUserId));
const $10588f0c20b74dca$var$toShareConversationUser = (userAri)=>{
    const accountId = $10588f0c20b74dca$var$getAccountIdFromUserAri(userAri);
    return {
        id: accountId,
        name: accountId
    };
};
const $10588f0c20b74dca$var$toInitialShareType = (shareType)=>shareType === 'ORG' ? 'organization' : 'specific-users';
const $10588f0c20b74dca$var$toShareAccessPayload = (response, currentUserId)=>{
    const shareType = $10588f0c20b74dca$var$toInitialShareType(response.shareType);
    return {
        shareType: shareType,
        addUserAris: shareType === 'specific-users' ? $10588f0c20b74dca$var$withoutCurrentUserAri(response.allowedUserAris ?? [], currentUserId) : []
    };
};
const $10588f0c20b74dca$var$accessPayloadsEqual = (left, right)=>{
    if (!left || !right) return left === right;
    if (left.shareType !== right.shareType || left.addUserAris.length !== right.addUserAris.length) return false;
    return left.addUserAris.every((userAri, index)=>userAri === right.addUserAris[index]);
};
const $10588f0c20b74dca$var$isNotFoundError = (err)=>err?.errorAttributes?.statusCode === 404;
const $10588f0c20b74dca$var$isUuidMessageId = (id)=>typeof id === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
const $10588f0c20b74dca$var$hasAssistantResponseContent = (content)=>typeof content === 'string' ? content.trim().length > 0 : content != null;
/**
 * Returns the snapshot boundary id for a single message, or `undefined` when
 * the message cannot be used as a share boundary.
 *
 * This is the single source of truth for "can this message be shared": both
 * the latest-message boundary and per-message ("share chat up to this point") shares run
 * through it, so a per-message share is only ever offered/sent for a message
 * that would also be a valid latest boundary. Assistant messages need both a
 * backend UUID and response content because cancelled turns can leave an empty
 * FINAL_RESPONSE with a UUID that the share API does not accept.
 */ const $10588f0c20b74dca$var$getShareableBoundaryId = (message)=>{
    if ((0, $igOtY.isStoreAssistant)(message)) {
        const assistantMessage = message.content?.message?.message;
        const id = assistantMessage?.id;
        if ($10588f0c20b74dca$var$isUuidMessageId(id) && $10588f0c20b74dca$var$hasAssistantResponseContent(assistantMessage?.content)) return id;
        return undefined;
    }
    if ((0, $igOtY.isStoreHuman)(message)) {
        const id = message.content.id;
        if ($10588f0c20b74dca$var$isUuidMessageId(id)) return id;
    }
    return undefined;
};
const $10588f0c20b74dca$export$17a4f5cbbaa4f032 = ({ conversationId: conversationId, orgId: orgId, siteId: siteId, conversationStatus: conversationStatus, currentUserId: currentUserId, onSubmit: onSubmit, shareBaseUrl: shareBaseUrl } = {})=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const [isLoadingInitialState, setIsLoadingInitialState] = (0, $cozmU.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)(undefined);
    const [errorCode, setErrorCode] = (0, $cozmU.useState)(undefined);
    const [shareUrl, setShareUrl] = (0, $cozmU.useState)(undefined);
    const [seeWhatOthersCanSeeHref, setSeeWhatOthersCanSeeHref] = (0, $cozmU.useState)(undefined);
    const [initialShareType, setInitialShareType] = (0, $cozmU.useState)(undefined);
    const [initialSelectedUsers, setInitialSelectedUsers] = (0, $cozmU.useState)(undefined);
    const [initialOwnerUser, setInitialOwnerUser] = (0, $cozmU.useState)(undefined);
    const [isSavingShareAccess, setIsSavingShareAccess] = (0, $cozmU.useState)(false);
    const shareDetailsRequestIdRef = (0, $cozmU.useRef)(0);
    const confirmedShareAccessRef = (0, $cozmU.useRef)(undefined);
    const desiredShareAccessRef = (0, $cozmU.useRef)(undefined);
    const pendingShareAccessRef = (0, $cozmU.useRef)(undefined);
    const shareAccessSavePromiseRef = (0, $cozmU.useRef)(undefined);
    // When the modal is opened from a specific message's share button, that
    // message id is held here and used as the snapshot boundary instead of
    // the conversation's latest shareable message. Cleared on open()/close()
    // so the header share reverts to the whole-conversation boundary.
    const [overrideMessageId, setOverrideMessageId] = (0, $cozmU.useState)(undefined);
    /** Records a failed share request for the modal to present. */ const applyShareError = (0, $cozmU.useCallback)((err)=>{
        const errorCode_0 = err?.errorAttributes?.errorCode;
        setErrorCode(typeof errorCode_0 === 'string' ? errorCode_0 : undefined);
        setErrorMessage(err instanceof Error ? err.message : String(err));
    }, []);
    const clearShareError = (0, $cozmU.useCallback)(()=>{
        setErrorCode(undefined);
        setErrorMessage(undefined);
    }, []);
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    // `useChatMessages` requires a string; pass `EMPTY_CONVERSATION_ID` when
    // the caller has no active conversation so the selector still returns
    // an (empty) array and we don't violate Rules of Hooks.
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId ?? (0, $4m5jb.EMPTY_CONVERSATION_ID)
    });
    const latestMessageId = (0, $cozmU.useMemo)(()=>{
        // Walk backward to find the newest shareable snapshot boundary, using
        // the same per-message shareability rule applied to per-message shares.
        for(let i = messages.length - 1; i >= 0; i -= 1){
            const id = $10588f0c20b74dca$var$getShareableBoundaryId(messages[i]);
            if (id) return id;
        }
        return undefined;
    }, [
        messages
    ]);
    // Set of message ids in the current conversation that are valid snapshot
    // boundaries, derived from the same shareability rule as `latestMessageId`.
    // Used to validate a caller-supplied `overrideMessageId` so a message that
    // is not shareable (or no longer present) cannot be sent to the share API —
    // in that case we fall back to the latest boundary.
    const validBoundaryMessageIds = (0, $cozmU.useMemo)(()=>{
        const ids = new Set();
        for (const message of messages){
            const id_0 = $10588f0c20b74dca$var$getShareableBoundaryId(message);
            if (id_0) ids.add(id_0);
        }
        return ids;
    }, [
        messages
    ]);
    // The snapshot boundary actually sent to the share API. A per-message
    // override wins only when it passes the same shareability check as
    // `latestMessageId`; otherwise we anchor to the conversation's latest
    // shareable message (the whole-conversation share used by the chat header).
    const boundaryMessageId = overrideMessageId && validBoundaryMessageIds.has(overrideMessageId) ? overrideMessageId : latestMessageId;
    const hasActiveConversation = Boolean(conversationId && conversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID));
    const isRovoResponseInProgress = conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || conversationStatus === (0, $igOtY.CHAT_STORE_STATUS).typingResponse;
    const resolvedOrgId = orgId || (0, $eS3l0.getOrgIdFromLocation)();
    const canGenerate = hasActiveConversation && Boolean(latestMessageId) && !isRovoResponseInProgress;
    const shareDisabledReason = isRovoResponseInProgress ? 'rovo-response-in-progress' : hasActiveConversation && !latestMessageId ? 'missing-valid-response' : undefined;
    const applyConfirmedShareAccess = (0, $cozmU.useCallback)((payload, options = {})=>{
        const { resetDesiredAccess: resetDesiredAccess = true, updateInitialState: updateInitialState = true } = options;
        confirmedShareAccessRef.current = payload;
        if (resetDesiredAccess) {
            desiredShareAccessRef.current = payload;
            pendingShareAccessRef.current = undefined;
        }
        if (!updateInitialState) return;
        if (!payload) {
            setInitialShareType(undefined);
            setInitialSelectedUsers(undefined);
            setInitialOwnerUser(undefined);
            return;
        }
        setInitialShareType(payload.shareType);
        setInitialSelectedUsers(payload.shareType === 'specific-users' ? payload.addUserAris.map($10588f0c20b74dca$var$toShareConversationUser) : []);
    }, []);
    const applyShareDetailsResponse = (0, $cozmU.useCallback)((response, options_0 = {})=>{
        const { resetDesiredAccess: resetDesiredAccess_0 = true, updateInitialState: updateInitialState_0 = true } = options_0;
        const confirmedPayload = $10588f0c20b74dca$var$toShareAccessPayload(response, currentUserId);
        const shareType = confirmedPayload.shareType;
        const allowedUserAris = $10588f0c20b74dca$var$withoutCurrentUserAri(response.allowedUserAris ?? [], currentUserId);
        const ownerAri = response.creatorAri ?? (currentUserId ? $10588f0c20b74dca$var$toUserAri(currentUserId) : undefined);
        confirmedShareAccessRef.current = confirmedPayload;
        if (resetDesiredAccess_0) {
            desiredShareAccessRef.current = confirmedPayload;
            pendingShareAccessRef.current = undefined;
        }
        if (!updateInitialState_0) return (0, $eS3l0.buildShareConversationUrl)(response.shareToken, shareBaseUrl, resolvedOrgId, siteId);
        const nextInitialSelectedUsers = allowedUserAris.map($10588f0c20b74dca$var$toShareConversationUser);
        const nextInitialOwnerUser = ownerAri ? $10588f0c20b74dca$var$toShareConversationUser(ownerAri) : undefined;
        setInitialShareType(shareType);
        setInitialSelectedUsers(nextInitialSelectedUsers);
        setInitialOwnerUser(nextInitialOwnerUser);
        return (0, $eS3l0.buildShareConversationUrl)(response.shareToken, shareBaseUrl, resolvedOrgId, siteId);
    }, [
        currentUserId,
        resolvedOrgId,
        shareBaseUrl,
        siteId
    ]);
    const buildPreviewHref = (0, $cozmU.useCallback)((boundaryOverride)=>{
        const previewBoundaryMessageId = boundaryOverride ?? boundaryMessageId;
        if (!hasActiveConversation || !conversationId || !previewBoundaryMessageId || isRovoResponseInProgress) return undefined;
        return (0, $eS3l0.buildShareConversationPreviewUrl)({
            conversationId: conversationId,
            messageId: previewBoundaryMessageId,
            baseUrl: shareBaseUrl,
            orgId: resolvedOrgId,
            siteId: siteId
        });
    }, [
        boundaryMessageId,
        conversationId,
        hasActiveConversation,
        isRovoResponseInProgress,
        resolvedOrgId,
        shareBaseUrl,
        siteId
    ]);
    const hydrateShareDetails = (0, $cozmU.useCallback)(async (boundaryOverride_0)=>{
        // Callers can pass the boundary explicitly to avoid a
        // not-yet-committed `overrideMessageId` state update.
        const hydrateBoundaryMessageId = boundaryOverride_0 ?? boundaryMessageId;
        if (!hasActiveConversation || !conversationId || !hydrateBoundaryMessageId || isRovoResponseInProgress) return;
        const requestId = shareDetailsRequestIdRef.current + 1;
        shareDetailsRequestIdRef.current = requestId;
        setIsLoadingInitialState(true);
        try {
            const response_0 = await assistanceService.getConversationShareMetadata({
                conversationId: conversationId,
                messageId: hydrateBoundaryMessageId
            });
            if (shareDetailsRequestIdRef.current === requestId) {
                const linkUrl = applyShareDetailsResponse(response_0);
                setShareUrl(linkUrl);
                setSeeWhatOthersCanSeeHref(buildPreviewHref(hydrateBoundaryMessageId));
            }
        } catch (err_0) {
            if (shareDetailsRequestIdRef.current === requestId) {
                if ($10588f0c20b74dca$var$isNotFoundError(err_0)) {
                    applyConfirmedShareAccess(undefined);
                    setShareUrl(undefined);
                    setSeeWhatOthersCanSeeHref(buildPreviewHref(hydrateBoundaryMessageId));
                } else {
                    setSeeWhatOthersCanSeeHref(undefined);
                    applyShareError(err_0);
                }
            }
        } finally{
            if (shareDetailsRequestIdRef.current === requestId) setIsLoadingInitialState(false);
        }
    }, [
        assistanceService,
        applyConfirmedShareAccess,
        applyShareDetailsResponse,
        applyShareError,
        buildPreviewHref,
        conversationId,
        hasActiveConversation,
        isRovoResponseInProgress,
        boundaryMessageId
    ]);
    const open = (0, $cozmU.useCallback)((messageId)=>{
        clearShareError();
        setShareUrl(undefined);
        setSeeWhatOthersCanSeeHref(undefined);
        setInitialShareType(undefined);
        setInitialSelectedUsers(undefined);
        setInitialOwnerUser(undefined);
        setIsSavingShareAccess(false);
        setIsLoadingInitialState(false);
        confirmedShareAccessRef.current = undefined;
        desiredShareAccessRef.current = undefined;
        pendingShareAccessRef.current = undefined;
        shareAccessSavePromiseRef.current = undefined;
        // A per-message share anchors the snapshot to `messageId`; opening
        // without one (e.g. from the chat header) shares the whole
        // conversation, so clear any previous override.
        setOverrideMessageId(messageId);
        setIsOpen(true);
        // Pass the just-selected boundary explicitly: the `overrideMessageId`
        // state update above has not committed yet, so the callbacks would
        // otherwise capture the previous boundary from closure.
        const requestedBoundary = messageId && validBoundaryMessageIds.has(messageId) ? messageId : latestMessageId;
        setSeeWhatOthersCanSeeHref(buildPreviewHref(requestedBoundary));
        hydrateShareDetails(requestedBoundary);
    }, [
        buildPreviewHref,
        clearShareError,
        hydrateShareDetails,
        latestMessageId,
        validBoundaryMessageIds
    ]);
    const close = (0, $cozmU.useCallback)(()=>{
        shareDetailsRequestIdRef.current += 1;
        clearShareError();
        setShareUrl(undefined);
        setSeeWhatOthersCanSeeHref(undefined);
        setInitialShareType(undefined);
        setInitialSelectedUsers(undefined);
        setInitialOwnerUser(undefined);
        setIsSavingShareAccess(false);
        setIsLoadingInitialState(false);
        confirmedShareAccessRef.current = undefined;
        desiredShareAccessRef.current = undefined;
        pendingShareAccessRef.current = undefined;
        shareAccessSavePromiseRef.current = undefined;
        setOverrideMessageId(undefined);
        setIsOpen(false);
    }, [
        clearShareError
    ]);
    const replaceShareAccess = (0, $cozmU.useCallback)(async (payload_0)=>{
        if (!hasActiveConversation || !conversationId) throw new Error('No active conversation to share.');
        if (isRovoResponseInProgress || !boundaryMessageId) throw new Error('Wait for Rovo to finish before sharing this chat.');
        const isOrg = payload_0.shareType === 'organization';
        const allowedUserAris_0 = $10588f0c20b74dca$var$withoutCurrentUserAri(payload_0.addUserAris, currentUserId);
        return assistanceService.replaceConversationShare({
            conversationId: conversationId,
            // Use the resolved boundary (a valid per-message override,
            // otherwise the latest shareable message) so "share up to
            // here" is honoured on the share-details API path too.
            messageId: boundaryMessageId,
            shareType: isOrg ? 'ORG' : 'SPECIFIC_USERS',
            ...isOrg ? {} : {
                allowedUserAris: allowedUserAris_0
            }
        });
    }, [
        assistanceService,
        boundaryMessageId,
        conversationId,
        currentUserId,
        hasActiveConversation,
        isRovoResponseInProgress
    ]);
    const defaultOnSubmit = (0, $cozmU.useCallback)(async (payload_1)=>{
        if (!hasActiveConversation || !conversationId) // Should be unreachable because Copy link is
        // disabled in this state, but guard anyway so a misuse
        // surfaces as an inline error instead of a 400 from the
        // backend.
        throw new Error('No active conversation to share.');
        if (isRovoResponseInProgress || !boundaryMessageId) throw new Error('Wait for Rovo to finish before sharing this chat.');
        try {
            const response_1 = await replaceShareAccess(payload_1);
            return applyShareDetailsResponse(response_1, {
                updateInitialState: false
            });
        } catch (err_1) {
            await hydrateShareDetails();
            throw err_1;
        }
    }, [
        applyShareDetailsResponse,
        replaceShareAccess,
        conversationId,
        hasActiveConversation,
        hydrateShareDetails,
        isRovoResponseInProgress,
        boundaryMessageId
    ]);
    const isMessageShareable = (0, $cozmU.useCallback)((messageId_0)=>// Sharing is only possible while there is an active conversation
        // that is not mid-response; beyond that, the message itself must be
        // a valid boundary under the shared shareability rule.
        hasActiveConversation && !isRovoResponseInProgress && $10588f0c20b74dca$var$isUuidMessageId(messageId_0) && validBoundaryMessageIds.has(messageId_0), [
        hasActiveConversation,
        isRovoResponseInProgress,
        validBoundaryMessageIds
    ]);
    const submitShareAccessChange = (0, $cozmU.useCallback)(async (payload_2)=>{
        if (!onSubmit) {
            const response_2 = await replaceShareAccess(payload_2);
            const confirmedPayload_0 = $10588f0c20b74dca$var$toShareAccessPayload(response_2, currentUserId);
            const shouldUpdateInitialState = $10588f0c20b74dca$var$accessPayloadsEqual(confirmedPayload_0, desiredShareAccessRef.current);
            const resultUrl = applyShareDetailsResponse(response_2, {
                resetDesiredAccess: shouldUpdateInitialState,
                updateInitialState: shouldUpdateInitialState
            });
            setShareUrl(resultUrl);
            setSeeWhatOthersCanSeeHref(buildPreviewHref());
            return;
        }
        const resultUrl_0 = await onSubmit(payload_2);
        if (resultUrl_0) {
            setShareUrl(resultUrl_0);
            setSeeWhatOthersCanSeeHref(buildPreviewHref());
        }
        const shouldUpdateInitialState_0 = $10588f0c20b74dca$var$accessPayloadsEqual(payload_2, desiredShareAccessRef.current);
        applyConfirmedShareAccess(payload_2, {
            resetDesiredAccess: shouldUpdateInitialState_0,
            updateInitialState: shouldUpdateInitialState_0
        });
    }, [
        applyConfirmedShareAccess,
        applyShareDetailsResponse,
        currentUserId,
        buildPreviewHref,
        onSubmit,
        replaceShareAccess
    ]);
    const drainShareAccessQueue = (0, $cozmU.useCallback)(()=>{
        if (shareAccessSavePromiseRef.current) return shareAccessSavePromiseRef.current;
        const savePromise = Promise.resolve().then(async ()=>{
            setIsSavingShareAccess(true);
            try {
                let nextPayload = pendingShareAccessRef.current;
                while(nextPayload && !$10588f0c20b74dca$var$accessPayloadsEqual(nextPayload, confirmedShareAccessRef.current)){
                    pendingShareAccessRef.current = undefined;
                    try {
                        await submitShareAccessChange(nextPayload);
                    } catch (err) {
                        const confirmedShareAccess = confirmedShareAccessRef.current;
                        desiredShareAccessRef.current = confirmedShareAccess;
                        pendingShareAccessRef.current = undefined;
                        applyConfirmedShareAccess(confirmedShareAccess);
                        applyShareError(err);
                        throw err;
                    }
                    nextPayload = pendingShareAccessRef.current;
                }
                pendingShareAccessRef.current = undefined;
            } finally{
                shareAccessSavePromiseRef.current = undefined;
                setIsSavingShareAccess(false);
            }
        });
        shareAccessSavePromiseRef.current = savePromise;
        return savePromise;
    }, [
        applyConfirmedShareAccess,
        applyShareError,
        submitShareAccessChange
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(async (payload_3)=>{
        const submit = onSubmit ?? defaultOnSubmit;
        setIsSubmitting(true);
        clearShareError();
        try {
            const resultUrl_1 = await submit(payload_3);
            if (resultUrl_1) {
                // Keep the modal open and hand the link to the "link
                // view" (State 2).
                setShareUrl(resultUrl_1);
                setSeeWhatOthersCanSeeHref(buildPreviewHref());
                return resultUrl_1;
            } else // No link returned (e.g. a custom override that closes
            // on success) — fall back to closing the modal.
            setIsOpen(false);
        } catch (err_2) {
            applyShareError(err_2);
        } finally{
            setIsSubmitting(false);
        }
        return undefined;
    }, [
        applyShareError,
        buildPreviewHref,
        clearShareError,
        defaultOnSubmit,
        onSubmit
    ]);
    const handleCopyLink = (0, $cozmU.useCallback)(async (payload_4)=>{
        const submit_0 = onSubmit ?? defaultOnSubmit;
        clearShareError();
        try {
            const resultUrl_2 = await submit_0(payload_4);
            if (resultUrl_2) {
                setShareUrl(resultUrl_2);
                setSeeWhatOthersCanSeeHref(buildPreviewHref());
                return resultUrl_2;
            }
            setIsOpen(false);
        } catch (err_3) {
            applyShareError(err_3);
        }
        return undefined;
    }, [
        applyShareError,
        buildPreviewHref,
        clearShareError,
        defaultOnSubmit,
        onSubmit
    ]);
    const handleShareAccessChange = (0, $cozmU.useCallback)((payload_5)=>{
        desiredShareAccessRef.current = payload_5;
        pendingShareAccessRef.current = payload_5;
        clearShareError();
        return drainShareAccessQueue().then(()=>true).catch(()=>false);
    }, [
        clearShareError,
        drainShareAccessQueue
    ]);
    const flushShareAccessChanges = (0, $cozmU.useCallback)(async ()=>{
        const desiredShareAccess = desiredShareAccessRef.current;
        if (desiredShareAccess && !$10588f0c20b74dca$var$accessPayloadsEqual(desiredShareAccess, confirmedShareAccessRef.current)) pendingShareAccessRef.current = desiredShareAccess;
        await drainShareAccessQueue();
    }, [
        drainShareAccessQueue
    ]);
    return {
        isOpen: isOpen,
        isSubmitting: isSubmitting,
        isLoadingInitialState: isLoadingInitialState,
        errorMessage: errorMessage,
        errorCode: errorCode,
        canGenerate: canGenerate,
        shareDisabledReason: shareDisabledReason,
        shareUrl: shareUrl,
        seeWhatOthersCanSeeHref: seeWhatOthersCanSeeHref,
        initialShareType: initialShareType,
        initialSelectedUsers: initialSelectedUsers,
        initialOwnerUser: initialOwnerUser,
        autoSaveShareAccess: Boolean(shareUrl),
        isSavingShareAccess: isSavingShareAccess,
        allowEmptySpecificUsers: true,
        showSpecificPeopleAccessList: true,
        open: open,
        close: close,
        handleShareAccessChange: handleShareAccessChange,
        flushShareAccessChanges: flushShareAccessChanges,
        handleSubmit: handleSubmit,
        handleCopyLink: handleCopyLink,
        isMessageShareable: isMessageShareable
    };
};



var $jv1SC = parcelRequire("jv1SC");

















































var $b1E2G = parcelRequire("b1E2G");






var $lchoD = parcelRequire("lchoD");

























var $af2XZ = parcelRequire("af2XZ");











var $kfRNa = parcelRequire("kfRNa");


























































function $6f9ddc0be56240f7$export$905653b9e5e1420(action, skillMetadataMap) {
    if (!action || !skillMetadataMap || action.handleType !== 'Skill' || !action.staticPrompt) return undefined;
    const firstToken = action.staticPrompt.trim().split(/\s+/, 1)[0];
    if (!firstToken || !firstToken.startsWith('/')) return undefined;
    return skillMetadataMap[firstToken.slice(1)];
}


















/**
 * Hook returning recommended past conversations for a Rovo Space.
 *
 * 🚧 ROVOFE-3042 — temporary stub.
 *
 * The real implementation will call the recommendations backend (see follow-up
 * ticket) and return the user's most-relevant past conversations for the given
 * `spaceId`. For now this hook returns deterministic dummy data so the banner
 * can be visually verified end-to-end without backend wiring.
 *
 * When the real endpoint is ready, replace the body of this hook (keep the
 * signature) so consumers don't have to change.
 */ /**
 * 🚧 Dummy data — the feature is not yet released, so we ship the scaffolding
 * with placeholder recommendations so internal users/teammates can see the
 * banner end-to-end. Swap this list out for a real backend call (and remove
 * this constant) in the follow-up ticket.
 */ const $c4f706723085471c$var$DUMMY_RECOMMENDATIONS = [
    {
        conversationId: 'dummy-1',
        title: 'Implement caching to decrease server load'
    },
    {
        conversationId: 'dummy-2',
        title: 'Optimize database queries for faster reads'
    },
    {
        conversationId: 'dummy-3',
        title: 'Refactor code for better readability'
    },
    {
        conversationId: 'dummy-4',
        title: 'Refactor the API to reduce latency'
    },
    {
        conversationId: 'dummy-5',
        title: 'Use asynchronous calls for smoother UX'
    },
    {
        conversationId: 'dummy-6',
        title: 'Enhance database indexing for quick lookups'
    },
    {
        conversationId: 'dummy-7',
        title: 'Memory beta spec review'
    },
    {
        conversationId: 'dummy-8',
        title: 'Rovo Q4 roadmap context'
    }
];
const $c4f706723085471c$export$3df8a3de6597771a = (_options)=>{
    return {
        recommendations: $c4f706723085471c$var$DUMMY_RECOMMENDATIONS,
        count: $c4f706723085471c$var$DUMMY_RECOMMENDATIONS.length,
        isLoading: false,
        error: null
    };
};











const $312148fd866e6c87$export$9a7c6df39e4e5fd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $bDgLe.c)(2);
    const recommendations = (0, $12shJ.useSmartContextLinkRecommendations)(options.spaceId);
    let t0;
    if ($[0] !== recommendations) {
        t0 = {
            recommendations: recommendations,
            count: recommendations.length,
            isLoading: false,
            error: null
        };
        $[0] = recommendations;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (options)=>{
    const recommendations = (0, $12shJ.useSmartContextLinkRecommendations)(options.spaceId);
    return {
        recommendations: recommendations,
        count: recommendations.length,
        isLoading: false,
        error: null
    };
};











const $43dcb62dc2633ccc$export$3c3a3177721340ad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { color: t1 } = t0;
    const color = t1 === undefined ? "var(--ds-icon, #292A2E)" : t1;
    let t2;
    if ($[0] !== color) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: color,
            fillRule: "evenodd",
            d: "M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z",
            clipRule: "evenodd"
        }));
        $[0] = color;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ color: color = "var(--ds-icon, #292A2E)" })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: color,
        fillRule: "evenodd",
        d: "M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z",
        clipRule: "evenodd"
    }));















var $7Jde4 = parcelRequire("7Jde4");
































const $b3a5ba72246cdb51$var$styles = {
    bannerWrapper: "_0bjKvDyzSk _2Y7lL48HPE _4c065U2ADO _0KLXrunmFW _0rIjyk8HPE",
    iconCell: "_3YEZNOdnbC",
    textBlock: "_4ouGXIdnbC",
    actions: "_3YEZNOdnbC",
    stackedAction: "_39xV02N91d"
};
const $b3a5ba72246cdb51$var$RecommendationBannerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { icon: icon, title: title, description: description, primaryActionLabel: primaryActionLabel, onPrimaryAction: onPrimaryAction, onDismiss: onDismiss, dismissLabel: dismissLabel, variant: t1, testId: t2 } = t0;
    const variant = t1 === undefined ? "inline" : t1;
    const testId = t2 === undefined ? "recommendation-banner" : t2;
    if (variant === "stacked") {
        let t3;
        if ($[0] !== icon) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b3a5ba72246cdb51$var$styles.iconCell,
                "aria-hidden": "true"
            }, icon);
            $[0] = icon;
            $[1] = t3;
        } else t3 = $[1];
        let t4;
        if ($[2] !== title) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold",
                color: "color.text"
            }, title);
            $[2] = title;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== description) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, description);
            $[4] = description;
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] !== t4 || $[7] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b3a5ba72246cdb51$var$styles.textBlock
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.025"
            }, t4, t5));
            $[6] = t4;
            $[7] = t5;
            $[8] = t6;
        } else t6 = $[8];
        let t7;
        if ($[9] !== t3 || $[10] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                alignItems: "start",
                gap: "space.150"
            }, t3, t6);
            $[9] = t3;
            $[10] = t6;
            $[11] = t7;
        } else t7 = $[11];
        const t8 = `${testId}-primary-action`;
        let t9;
        if ($[12] !== onPrimaryAction || $[13] !== primaryActionLabel || $[14] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b3a5ba72246cdb51$var$styles.stackedAction
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: onPrimaryAction,
                testId: t8,
                shouldFitContainer: true
            }, primaryActionLabel));
            $[12] = onPrimaryAction;
            $[13] = primaryActionLabel;
            $[14] = t8;
            $[15] = t9;
        } else t9 = $[15];
        let t10;
        if ($[16] !== dismissLabel || $[17] !== onDismiss || $[18] !== testId) {
            t10 = onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b3a5ba72246cdb51$var$styles.stackedAction
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: onDismiss,
                testId: `${testId}-dismiss`,
                shouldFitContainer: true
            }, dismissLabel));
            $[16] = dismissLabel;
            $[17] = onDismiss;
            $[18] = testId;
            $[19] = t10;
        } else t10 = $[19];
        let t11;
        if ($[20] !== t10 || $[21] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, t9, t10);
            $[20] = t10;
            $[21] = t9;
            $[22] = t11;
        } else t11 = $[22];
        let t12;
        if ($[23] !== t11 || $[24] !== t7) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150"
            }, t7, t11);
            $[23] = t11;
            $[24] = t7;
            $[25] = t12;
        } else t12 = $[25];
        let t13;
        if ($[26] !== t12 || $[27] !== testId) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b3a5ba72246cdb51$var$styles.bannerWrapper,
                testId: testId
            }, t12);
            $[26] = t12;
            $[27] = testId;
            $[28] = t13;
        } else t13 = $[28];
        return t13;
    }
    let t3;
    if ($[29] !== icon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b3a5ba72246cdb51$var$styles.iconCell,
            "aria-hidden": "true"
        }, icon);
        $[29] = icon;
        $[30] = t3;
    } else t3 = $[30];
    let t4;
    if ($[31] !== title) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            color: "color.text"
        }, title);
        $[31] = title;
        $[32] = t4;
    } else t4 = $[32];
    let t5;
    if ($[33] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, description);
        $[33] = description;
        $[34] = t5;
    } else t5 = $[34];
    let t6;
    if ($[35] !== t4 || $[36] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b3a5ba72246cdb51$var$styles.textBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, t4, t5));
        $[35] = t4;
        $[36] = t5;
        $[37] = t6;
    } else t6 = $[37];
    const t7 = `${testId}-primary-action`;
    let t8;
    if ($[38] !== onPrimaryAction || $[39] !== primaryActionLabel || $[40] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onPrimaryAction,
            testId: t7
        }, primaryActionLabel);
        $[38] = onPrimaryAction;
        $[39] = primaryActionLabel;
        $[40] = t7;
        $[41] = t8;
    } else t8 = $[41];
    let t9;
    if ($[42] !== dismissLabel || $[43] !== onDismiss || $[44] !== testId) {
        t9 = onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $b3a5ba72246cdb51$var$_temp,
            label: dismissLabel,
            onClick: onDismiss,
            testId: `${testId}-dismiss`
        });
        $[42] = dismissLabel;
        $[43] = onDismiss;
        $[44] = testId;
        $[45] = t9;
    } else t9 = $[45];
    let t10;
    if ($[46] !== t8 || $[47] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $b3a5ba72246cdb51$var$styles.actions,
            space: "space.100",
            alignBlock: "center"
        }, t8, t9);
        $[46] = t8;
        $[47] = t9;
        $[48] = t10;
    } else t10 = $[48];
    let t11;
    if ($[49] !== t10 || $[50] !== t3 || $[51] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.150"
        }, t3, t6, t10);
        $[49] = t10;
        $[50] = t3;
        $[51] = t6;
        $[52] = t11;
    } else t11 = $[52];
    let t12;
    if ($[53] !== t11 || $[54] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b3a5ba72246cdb51$var$styles.bannerWrapper,
            testId: testId
        }, t11);
        $[53] = t11;
        $[54] = testId;
        $[55] = t12;
    } else t12 = $[55];
    return t12;
} : ({ icon: icon, title: title, description: description, primaryActionLabel: primaryActionLabel, onPrimaryAction: onPrimaryAction, onDismiss: onDismiss, dismissLabel: dismissLabel, variant: variant = 'inline', testId: testId = 'recommendation-banner' })=>{
    if (variant === 'stacked') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.bannerWrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "start",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.iconCell,
        "aria-hidden": "true"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.textBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, description)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.stackedAction
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onPrimaryAction,
        testId: `${testId}-primary-action`,
        shouldFitContainer: true
    }, primaryActionLabel)), onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.stackedAction
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onDismiss,
        testId: `${testId}-dismiss`,
        shouldFitContainer: true
    }, dismissLabel)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.bannerWrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.iconCell,
        "aria-hidden": "true"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3a5ba72246cdb51$var$styles.textBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $b3a5ba72246cdb51$var$styles.actions,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onPrimaryAction,
        testId: `${testId}-primary-action`
    }, primaryActionLabel), onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }),
        // `onDismiss` is set, so it is guaranteed to be a translated
        // string here.
        label: dismissLabel,
        onClick: onDismiss,
        testId: `${testId}-dismiss`
    }))));
};
const $b3a5ba72246cdb51$export$960cc9c55ba0c9b3 = /*#__PURE__*/ (0, $cozmU.memo)($b3a5ba72246cdb51$var$RecommendationBannerComponent);
function $b3a5ba72246cdb51$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    });
}





const $9cb24bca2dcc2da6$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "rovo-spaces.past-conversations-banner.title",
        defaultMessage: "Bring past conversations into this Rovo space"
    },
    sidebarTitle: {
        id: "rovo-spaces.past-conversations-banner.sidebarTitle",
        defaultMessage: "Bring conversations into this Rovo space"
    },
    description: {
        id: "rovo-spaces.past-conversations-banner.description",
        defaultMessage: "{count, plural, one {We found # relevant chat from your history. Add it to this Rovo space for better context and continuity.} other {We found # relevant chats from your history. Add them to this Rovo space for better context and continuity.}}"
    },
    addChatsCta: {
        id: "rovo-spaces.past-conversations-banner.addChatsCta",
        defaultMessage: "Add chats"
    },
    dismissLabel: {
        id: "rovo-spaces.past-conversations-banner.dismissLabel",
        defaultMessage: "Dismiss past conversations recommendation"
    },
    dismissButtonLabel: {
        id: "rovo-spaces.past-conversations-banner.dismissButtonLabel",
        defaultMessage: "Dismiss"
    }
});
var $9cb24bca2dcc2da6$export$2e2bcd8739ae039 = $9cb24bca2dcc2da6$var$messages;


const $77d0f5d368cec1ee$var$styles = {
    iconTile: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02UF4f _0jFU0VUF4f _3YEZNOdnbC _0KLXrulfZc",
    iconScaler: "_3iDTPbccYA _0yKXXaDIqT _1VJPcarmOg"
}; // Hoisted to module-level constants so the JSX references are stable across
// renders. Inline `<AiGenerativeCleanupIcon … />` would create a new
// ReactNode each render and defeat `RecommendationBanner`'s `memo()`
// optimisation.
//
// Both variants render the design-system canonical `AiGenerativeCleanup`
// glyph from `@atlaskit/icon-lab` inside the same spec-compliant framed
// tile (see `iconTile` styles above), so fullscreen and sidebar banners
// share the same "icon on a card" treatment.
const $77d0f5d368cec1ee$var$ICON_TILE = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
    xcss: $77d0f5d368cec1ee$var$styles.iconTile,
    "aria-hidden": "true",
    testId: "past-conversations-banner-icon-tile"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
    xcss: $77d0f5d368cec1ee$var$styles.iconScaler
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))), {
    label: "",
    color: "var(--ds-icon, #292A2E)"
})));
const $77d0f5d368cec1ee$var$PastConversationsBannerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { conversationCount: conversationCount, onAddChats: onAddChats, onDismiss: onDismiss, variant: t1, testId: t2 } = t0;
    const variant = t1 === undefined ? "inline" : t1;
    const testId = t2 === undefined ? "past-conversations-banner" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (conversationCount <= 0) return null;
    const isStacked = variant === "stacked";
    const t3 = isStacked ? (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).sidebarTitle : (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).title;
    let t4;
    if ($[0] !== formatMessage || $[1] !== t3) {
        t4 = formatMessage(t3);
        $[0] = formatMessage;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    const title = t4;
    let t5;
    if ($[3] !== conversationCount || $[4] !== formatMessage) {
        t5 = formatMessage((0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).description, {
            count: conversationCount
        });
        $[3] = conversationCount;
        $[4] = formatMessage;
        $[5] = t5;
    } else t5 = $[5];
    const description = t5;
    let t6;
    if ($[6] !== formatMessage) {
        t6 = formatMessage((0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).addChatsCta);
        $[6] = formatMessage;
        $[7] = t6;
    } else t6 = $[7];
    const primaryActionLabel = t6;
    let t7;
    if ($[8] !== formatMessage || $[9] !== isStacked || $[10] !== onDismiss) {
        t7 = onDismiss ? {
            onDismiss: onDismiss,
            dismissLabel: formatMessage(isStacked ? (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).dismissButtonLabel : (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).dismissLabel)
        } : {};
        $[8] = formatMessage;
        $[9] = isStacked;
        $[10] = onDismiss;
        $[11] = t7;
    } else t7 = $[11];
    const dismissProps = t7;
    let t8;
    if ($[12] !== description || $[13] !== dismissProps || $[14] !== onAddChats || $[15] !== primaryActionLabel || $[16] !== testId || $[17] !== title || $[18] !== variant) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3a5ba72246cdb51$export$960cc9c55ba0c9b3), {
            testId: testId,
            icon: $77d0f5d368cec1ee$var$ICON_TILE,
            title: title,
            description: description,
            primaryActionLabel: primaryActionLabel,
            onPrimaryAction: onAddChats,
            variant: variant,
            ...dismissProps
        });
        $[12] = description;
        $[13] = dismissProps;
        $[14] = onAddChats;
        $[15] = primaryActionLabel;
        $[16] = testId;
        $[17] = title;
        $[18] = variant;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ conversationCount: conversationCount, onAddChats: onAddChats, onDismiss: onDismiss, variant: variant = 'inline', testId: testId = 'past-conversations-banner' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (conversationCount <= 0) return null;
    const isStacked = variant === 'stacked';
    const title = formatMessage(isStacked ? (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).sidebarTitle : (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).title);
    const description = formatMessage((0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).description, {
        count: conversationCount
    });
    const primaryActionLabel = formatMessage((0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).addChatsCta); // Spread the dismiss pair conditionally so both keys land together. This
    // keeps the discriminated union on `RecommendationBannerProps` satisfied
    // without duplicating the JSX between dismissible / non-dismissible
    // branches.
    //
    // The stacked variant renders `dismissLabel` as the *visible* button text
    // (per the design — full-width "Dismiss" button below the primary CTA),
    // so we use the shorter `dismissButtonLabel` copy there. The inline
    // variant uses the longer descriptive copy as an accessible name for the
    // icon-only `×` button.
    const dismissProps = onDismiss ? {
        onDismiss: onDismiss,
        dismissLabel: formatMessage(isStacked ? (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).dismissButtonLabel : (0, $9cb24bca2dcc2da6$export$2e2bcd8739ae039).dismissLabel)
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3a5ba72246cdb51$export$960cc9c55ba0c9b3), {
        testId: testId,
        icon: $77d0f5d368cec1ee$var$ICON_TILE,
        title: title,
        description: description,
        primaryActionLabel: primaryActionLabel,
        onPrimaryAction: onAddChats,
        variant: variant,
        ...dismissProps
    });
};
const $77d0f5d368cec1ee$export$bc4c85e6087c9fdf = /*#__PURE__*/ (0, $cozmU.memo)($77d0f5d368cec1ee$var$PastConversationsBannerComponent);
























const $38dacedf031911bf$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.title",
        defaultMessage: "Bring your sources into this Rovo space"
    },
    sidebarTitle: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.sidebarTitle",
        defaultMessage: "Keep your sources in one place"
    },
    description: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.description",
        defaultMessage: "{count, plural, one {We found # source from your previous chats. Add it here so your team can easily find and reuse it.} other {We found # sources from your previous chats. Add them here so your team can easily find and reuse them.}}"
    },
    sidebarDescription: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.sidebarDescription",
        defaultMessage: "Bring together the sources used in this Rovo space to help your team work faster and stay on the same page."
    },
    addLinksCta: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.addLinksCta",
        defaultMessage: "Add sources"
    },
    dismissLabel: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.dismissLabel",
        defaultMessage: "Dismiss sources recommendation"
    },
    dismissButtonLabel: {
        id: "ai-mate.rovo-spaces.smart-context-links-banner.dismissButtonLabel",
        defaultMessage: "Dismiss"
    }
});
var $38dacedf031911bf$export$2e2bcd8739ae039 = $38dacedf031911bf$var$messages;


const $46d9ab99f381a4cb$var$styles = {
    iconTile: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _46hvQmFQfX _0xmtkoFQfX _0LQT5EFQfX _03SyCPFQfX _3YEZNOdnbC _0KLXrulfZc",
    iconScaler: "_3iDTPbccYA _0yKXXaDIqT _1VJPcaPrS9"
};
const $46d9ab99f381a4cb$var$ICON_TILE = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
    xcss: $46d9ab99f381a4cb$var$styles.iconTile,
    "aria-hidden": "true",
    testId: "smart-context-links-banner-icon-tile"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
    xcss: $46d9ab99f381a4cb$var$styles.iconScaler
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
    label: "",
    color: "var(--ds-icon, #292A2E)"
})));
const $46d9ab99f381a4cb$var$SmartContextLinksBannerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { recommendationCount: recommendationCount, onAddLinks: onAddLinks, onDismiss: onDismiss, variant: t1, testId: t2 } = t0;
    const variant = t1 === undefined ? "inline" : t1;
    const testId = t2 === undefined ? "smart-context-links-banner" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (recommendationCount <= 0) return null;
    const isStacked = variant === "stacked";
    let t3;
    if ($[0] !== formatMessage || $[1] !== isStacked || $[2] !== onDismiss) {
        t3 = onDismiss ? {
            onDismiss: onDismiss,
            dismissLabel: formatMessage(isStacked ? (0, $38dacedf031911bf$export$2e2bcd8739ae039).dismissButtonLabel : (0, $38dacedf031911bf$export$2e2bcd8739ae039).dismissLabel)
        } : {};
        $[0] = formatMessage;
        $[1] = isStacked;
        $[2] = onDismiss;
        $[3] = t3;
    } else t3 = $[3];
    const dismissProps = t3;
    const t4 = isStacked ? (0, $38dacedf031911bf$export$2e2bcd8739ae039).sidebarTitle : (0, $38dacedf031911bf$export$2e2bcd8739ae039).title;
    let t5;
    if ($[4] !== formatMessage || $[5] !== t4) {
        t5 = formatMessage(t4);
        $[4] = formatMessage;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = isStacked ? (0, $38dacedf031911bf$export$2e2bcd8739ae039).sidebarDescription : (0, $38dacedf031911bf$export$2e2bcd8739ae039).description;
    let t7;
    if ($[7] !== formatMessage || $[8] !== recommendationCount || $[9] !== t6) {
        t7 = formatMessage(t6, {
            count: recommendationCount
        });
        $[7] = formatMessage;
        $[8] = recommendationCount;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== formatMessage) {
        t8 = formatMessage((0, $38dacedf031911bf$export$2e2bcd8739ae039).addLinksCta);
        $[11] = formatMessage;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== dismissProps || $[14] !== onAddLinks || $[15] !== t5 || $[16] !== t7 || $[17] !== t8 || $[18] !== testId || $[19] !== variant) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3a5ba72246cdb51$export$960cc9c55ba0c9b3), {
            testId: testId,
            icon: $46d9ab99f381a4cb$var$ICON_TILE,
            title: t5,
            description: t7,
            primaryActionLabel: t8,
            onPrimaryAction: onAddLinks,
            variant: variant,
            ...dismissProps
        });
        $[13] = dismissProps;
        $[14] = onAddLinks;
        $[15] = t5;
        $[16] = t7;
        $[17] = t8;
        $[18] = testId;
        $[19] = variant;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
} : ({ recommendationCount: recommendationCount, onAddLinks: onAddLinks, onDismiss: onDismiss, variant: variant = 'inline', testId: testId = 'smart-context-links-banner' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (recommendationCount <= 0) return null;
    const isStacked = variant === 'stacked';
    const dismissProps = onDismiss ? {
        onDismiss: onDismiss,
        dismissLabel: formatMessage(isStacked ? (0, $38dacedf031911bf$export$2e2bcd8739ae039).dismissButtonLabel : (0, $38dacedf031911bf$export$2e2bcd8739ae039).dismissLabel)
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3a5ba72246cdb51$export$960cc9c55ba0c9b3), {
        testId: testId,
        icon: $46d9ab99f381a4cb$var$ICON_TILE,
        title: formatMessage(isStacked ? (0, $38dacedf031911bf$export$2e2bcd8739ae039).sidebarTitle : (0, $38dacedf031911bf$export$2e2bcd8739ae039).title),
        description: formatMessage(isStacked ? (0, $38dacedf031911bf$export$2e2bcd8739ae039).sidebarDescription : (0, $38dacedf031911bf$export$2e2bcd8739ae039).description, {
            count: recommendationCount
        }),
        primaryActionLabel: formatMessage((0, $38dacedf031911bf$export$2e2bcd8739ae039).addLinksCta),
        onPrimaryAction: onAddLinks,
        variant: variant,
        ...dismissProps
    });
};
const $46d9ab99f381a4cb$export$7e1a4c17becc168b = /*#__PURE__*/ (0, $cozmU.memo)($46d9ab99f381a4cb$var$SmartContextLinksBannerComponent);


var $a6731d346b10a0d2$exports = {};
$a6731d346b10a0d2$exports = new URL("chat-avatars.50a6f7d6.svg", import.meta.url).toString();











const $b7529bceb40a7c7b$export$59d2ea8d0018ce0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "73",
            height: "52",
            viewBox: "0 0 73 52",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.3899 13.4917H20.8721V52.0001H59.3805V13.4917H59.3899ZM29.1326 25.8731H51.1388V21.7428H29.1326V25.8731ZM29.1326 34.811H51.1388V30.6808H29.1326V34.811ZM42.8876 43.749H29.1326V39.6187H42.8876V43.749Z",
            fill: "#BF63F3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M51.8072 27.0584L43.3867 29.4199L45.7482 20.9995L66.7477 0L72.8067 6.05898L51.8072 27.0584Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.2561 13.4917L45.7482 20.9996L45.5412 21.7428H51.1392V25.8731H44.384L43.3867 29.4201L51.8072 27.0586L59.3903 19.4754V13.4917H53.2561Z",
            fill: "#09326C"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M1.94262 38.0187C0.597221 38.6114 -0.0613646 39.0066 0.00449389 39.3077C0.0515357 39.5805 0.926513 39.731 2.41303 39.2042C4.5111 38.4515 6.52449 37.4072 8.55669 36.0336C9.57279 35.3373 10.5889 34.5564 11.5862 33.5968C12.0848 33.117 12.5647 32.5807 13.0163 31.9409C13.2421 31.621 13.449 31.2635 13.6184 30.8307C13.7783 30.4074 13.9195 29.8429 13.7595 29.1843C13.5525 28.4128 12.9222 27.9518 12.4612 27.7448C11.9907 27.5378 11.5391 27.4437 11.1158 27.4061C10.269 27.3402 9.54457 27.4814 8.88598 27.7072C8.23681 27.9424 7.65349 28.2811 7.19248 28.8079C6.73147 29.316 6.46804 30.0593 6.5433 30.7178L6.57153 30.9625L6.60916 31.1318L6.69384 31.4705C6.75029 31.6869 6.80674 31.9127 6.85378 32.1291C6.93845 32.5713 7.11721 32.9947 7.26775 33.4369C7.56881 34.3212 8.02982 35.2244 8.69782 36.2311C9.33759 37.0214 10.0997 37.887 11.1628 38.4515C12.1977 39.0442 13.402 39.4112 14.6439 39.5335C17.1371 39.731 19.6586 39.0819 21.7754 38.0375C22.8386 37.5295 23.8265 36.9274 24.692 36.2594C25.567 35.6102 26.3197 34.8951 26.9312 34.1707C28.1731 32.7406 28.7941 31.2071 28.907 30.2474C28.9822 29.6923 29.0011 29.109 28.8505 28.5257C28.8129 28.2623 28.7094 27.9612 28.5495 27.6225C28.4271 27.265 28.1825 26.9357 27.9097 26.5688C27.7874 26.3712 27.6086 26.2301 27.4393 26.0513C27.2981 25.9384 27.0253 25.5809 26.6396 25.4209C25.9339 24.9599 24.8708 25.2704 24.2592 25.9102C23.77 26.3994 23.4501 26.9263 23.1773 27.5002C22.9138 28.0647 22.6598 28.7233 22.5751 29.4289C22.3399 30.7272 22.3493 32.3361 23.0926 33.8226C23.817 35.3091 25.2001 36.4475 26.696 37.1155C28.2108 37.7741 29.8478 38.0658 31.4849 38.1504C33.1219 38.2257 34.7778 38.0846 36.396 37.7365C38.0049 37.3978 39.5855 36.8521 41.0249 36.0336C42.041 35.4596 42.9631 34.7446 43.6687 33.8602C44.3837 32.9853 44.8635 31.9127 44.9764 30.8401C45.1082 29.7488 44.8165 28.7797 44.506 27.9236C44.0827 26.898 43.1042 26.1642 42.1351 26.0231C41.1661 25.8443 40.2064 26.1172 39.529 26.6722C39.1903 26.9545 38.9175 27.2838 38.7387 27.6413C38.5317 28.0082 38.4753 28.2999 38.3718 28.6198C38.0707 29.9181 38.4 31.0659 38.7857 31.7904C39.736 33.5498 41.1661 34.5376 42.4926 35.3373C43.8474 36.1182 45.2022 36.6545 46.5288 37.0497C49.1914 37.8023 51.7787 38.0846 54.319 37.5953C55.7302 37.2943 56.2665 36.6733 56.1536 36.4663C56.0313 36.2123 55.3727 36.3252 54.1308 36.4663C51.8351 36.7204 49.436 36.3158 46.9992 35.5161C45.7856 35.1021 44.5437 34.5753 43.3582 33.8508C42.1916 33.1358 40.9873 32.2044 40.3475 30.9719C40.0935 30.5014 39.9336 29.8617 40.0935 29.1372C40.1123 28.9585 40.2158 28.7703 40.2817 28.5821C40.3664 28.4316 40.451 28.2905 40.5827 28.1776C40.818 27.9424 41.1849 27.8107 41.58 27.8389C41.9658 27.8765 42.3515 28.0647 42.5585 28.4128C42.6244 28.4975 42.6526 28.5821 42.6996 28.7139C42.7467 28.8644 42.7843 29.0149 42.8313 29.1655C42.9537 29.4665 42.9254 29.777 42.9913 30.0875C42.9913 30.7084 42.8407 31.32 42.5115 31.9221C42.1728 32.5242 41.6177 33.0793 40.9685 33.578C40.1029 34.2272 39.0962 34.754 38.0425 35.1868C35.7657 36.0994 32.9996 36.5134 30.4217 36.2311C29.1328 36.09 27.8909 35.7513 26.8559 35.1962C25.821 34.6411 25.0213 33.8508 24.6168 32.9288C24.1934 32.0162 24.1746 31.0189 24.2686 30.1439C24.2969 29.9275 24.3251 29.7111 24.3533 29.5042C24.391 29.3254 24.4474 29.1372 24.5039 28.9585C24.6262 28.601 24.7767 28.2717 24.9366 28.0082C25.2377 27.4625 25.614 27.105 25.6329 27.1333C25.7269 27.0862 25.7928 27.105 25.7928 27.105C25.7928 27.105 25.8116 27.105 25.8493 27.1238C25.9057 27.1615 25.8681 27.1238 26.0751 27.3308C26.442 27.6507 26.8371 28.2152 26.9877 28.9961C27.1382 29.777 26.9312 30.8307 26.3103 31.8751C25.6893 32.9194 24.7391 33.9637 23.5912 34.8669C21.3144 36.6639 18.1909 38.0187 15.3119 37.9623C13.8818 37.9435 12.5552 37.5483 11.5391 36.8709C10.5136 36.1935 9.83623 35.2621 9.34699 34.4247C8.63196 33.1264 8.35912 31.7622 8.13332 30.6614C8.0016 30.0404 8.76368 29.4947 9.4693 29.2878C10.1843 29.062 10.8617 29.0714 11.3416 29.2031C11.5862 29.2595 11.7649 29.363 11.8872 29.4383C11.9625 29.5324 12.0284 29.57 12.0284 29.6453C12.1131 29.8523 11.8872 30.4732 11.5391 30.953C11.2004 31.4517 10.7771 31.9315 10.3443 32.3643C9.45989 33.2393 8.51906 34.0108 7.58763 34.6976C5.70596 36.0712 3.8337 37.172 1.91439 38.0187H1.94262Z",
            fill: "var(--ds-text, #292A2E)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "73",
        height: "52",
        viewBox: "0 0 73 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M59.3899 13.4917H20.8721V52.0001H59.3805V13.4917H59.3899ZM29.1326 25.8731H51.1388V21.7428H29.1326V25.8731ZM29.1326 34.811H51.1388V30.6808H29.1326V34.811ZM42.8876 43.749H29.1326V39.6187H42.8876V43.749Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M51.8072 27.0584L43.3867 29.4199L45.7482 20.9995L66.7477 0L72.8067 6.05898L51.8072 27.0584Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M53.2561 13.4917L45.7482 20.9996L45.5412 21.7428H51.1392V25.8731H44.384L43.3867 29.4201L51.8072 27.0586L59.3903 19.4754V13.4917H53.2561Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M1.94262 38.0187C0.597221 38.6114 -0.0613646 39.0066 0.00449389 39.3077C0.0515357 39.5805 0.926513 39.731 2.41303 39.2042C4.5111 38.4515 6.52449 37.4072 8.55669 36.0336C9.57279 35.3373 10.5889 34.5564 11.5862 33.5968C12.0848 33.117 12.5647 32.5807 13.0163 31.9409C13.2421 31.621 13.449 31.2635 13.6184 30.8307C13.7783 30.4074 13.9195 29.8429 13.7595 29.1843C13.5525 28.4128 12.9222 27.9518 12.4612 27.7448C11.9907 27.5378 11.5391 27.4437 11.1158 27.4061C10.269 27.3402 9.54457 27.4814 8.88598 27.7072C8.23681 27.9424 7.65349 28.2811 7.19248 28.8079C6.73147 29.316 6.46804 30.0593 6.5433 30.7178L6.57153 30.9625L6.60916 31.1318L6.69384 31.4705C6.75029 31.6869 6.80674 31.9127 6.85378 32.1291C6.93845 32.5713 7.11721 32.9947 7.26775 33.4369C7.56881 34.3212 8.02982 35.2244 8.69782 36.2311C9.33759 37.0214 10.0997 37.887 11.1628 38.4515C12.1977 39.0442 13.402 39.4112 14.6439 39.5335C17.1371 39.731 19.6586 39.0819 21.7754 38.0375C22.8386 37.5295 23.8265 36.9274 24.692 36.2594C25.567 35.6102 26.3197 34.8951 26.9312 34.1707C28.1731 32.7406 28.7941 31.2071 28.907 30.2474C28.9822 29.6923 29.0011 29.109 28.8505 28.5257C28.8129 28.2623 28.7094 27.9612 28.5495 27.6225C28.4271 27.265 28.1825 26.9357 27.9097 26.5688C27.7874 26.3712 27.6086 26.2301 27.4393 26.0513C27.2981 25.9384 27.0253 25.5809 26.6396 25.4209C25.9339 24.9599 24.8708 25.2704 24.2592 25.9102C23.77 26.3994 23.4501 26.9263 23.1773 27.5002C22.9138 28.0647 22.6598 28.7233 22.5751 29.4289C22.3399 30.7272 22.3493 32.3361 23.0926 33.8226C23.817 35.3091 25.2001 36.4475 26.696 37.1155C28.2108 37.7741 29.8478 38.0658 31.4849 38.1504C33.1219 38.2257 34.7778 38.0846 36.396 37.7365C38.0049 37.3978 39.5855 36.8521 41.0249 36.0336C42.041 35.4596 42.9631 34.7446 43.6687 33.8602C44.3837 32.9853 44.8635 31.9127 44.9764 30.8401C45.1082 29.7488 44.8165 28.7797 44.506 27.9236C44.0827 26.898 43.1042 26.1642 42.1351 26.0231C41.1661 25.8443 40.2064 26.1172 39.529 26.6722C39.1903 26.9545 38.9175 27.2838 38.7387 27.6413C38.5317 28.0082 38.4753 28.2999 38.3718 28.6198C38.0707 29.9181 38.4 31.0659 38.7857 31.7904C39.736 33.5498 41.1661 34.5376 42.4926 35.3373C43.8474 36.1182 45.2022 36.6545 46.5288 37.0497C49.1914 37.8023 51.7787 38.0846 54.319 37.5953C55.7302 37.2943 56.2665 36.6733 56.1536 36.4663C56.0313 36.2123 55.3727 36.3252 54.1308 36.4663C51.8351 36.7204 49.436 36.3158 46.9992 35.5161C45.7856 35.1021 44.5437 34.5753 43.3582 33.8508C42.1916 33.1358 40.9873 32.2044 40.3475 30.9719C40.0935 30.5014 39.9336 29.8617 40.0935 29.1372C40.1123 28.9585 40.2158 28.7703 40.2817 28.5821C40.3664 28.4316 40.451 28.2905 40.5827 28.1776C40.818 27.9424 41.1849 27.8107 41.58 27.8389C41.9658 27.8765 42.3515 28.0647 42.5585 28.4128C42.6244 28.4975 42.6526 28.5821 42.6996 28.7139C42.7467 28.8644 42.7843 29.0149 42.8313 29.1655C42.9537 29.4665 42.9254 29.777 42.9913 30.0875C42.9913 30.7084 42.8407 31.32 42.5115 31.9221C42.1728 32.5242 41.6177 33.0793 40.9685 33.578C40.1029 34.2272 39.0962 34.754 38.0425 35.1868C35.7657 36.0994 32.9996 36.5134 30.4217 36.2311C29.1328 36.09 27.8909 35.7513 26.8559 35.1962C25.821 34.6411 25.0213 33.8508 24.6168 32.9288C24.1934 32.0162 24.1746 31.0189 24.2686 30.1439C24.2969 29.9275 24.3251 29.7111 24.3533 29.5042C24.391 29.3254 24.4474 29.1372 24.5039 28.9585C24.6262 28.601 24.7767 28.2717 24.9366 28.0082C25.2377 27.4625 25.614 27.105 25.6329 27.1333C25.7269 27.0862 25.7928 27.105 25.7928 27.105C25.7928 27.105 25.8116 27.105 25.8493 27.1238C25.9057 27.1615 25.8681 27.1238 26.0751 27.3308C26.442 27.6507 26.8371 28.2152 26.9877 28.9961C27.1382 29.777 26.9312 30.8307 26.3103 31.8751C25.6893 32.9194 24.7391 33.9637 23.5912 34.8669C21.3144 36.6639 18.1909 38.0187 15.3119 37.9623C13.8818 37.9435 12.5552 37.5483 11.5391 36.8709C10.5136 36.1935 9.83623 35.2621 9.34699 34.4247C8.63196 33.1264 8.35912 31.7622 8.13332 30.6614C8.0016 30.0404 8.76368 29.4947 9.4693 29.2878C10.1843 29.062 10.8617 29.0714 11.3416 29.2031C11.5862 29.2595 11.7649 29.363 11.8872 29.4383C11.9625 29.5324 12.0284 29.57 12.0284 29.6453C12.1131 29.8523 11.8872 30.4732 11.5391 30.953C11.2004 31.4517 10.7771 31.9315 10.3443 32.3643C9.45989 33.2393 8.51906 34.0108 7.58763 34.6976C5.70596 36.0712 3.8337 37.172 1.91439 38.0187H1.94262Z",
        fill: "var(--ds-text, #292A2E)"
    }));



var $9ZZOa = parcelRequire("9ZZOa");




const $2a8c4b56e08e8f01$var$message = (0, $kSwu1.defineMessages)({
    startersTab: {
        id: "ai-mate.rovo-spaces.space-landing-page.starters-tab",
        defaultMessage: "Starters"
    },
    chatsTab: {
        id: "ai-mate.rovo-spaces.space-landing-page.chats-tab",
        defaultMessage: "Chats"
    },
    sourcesTab: {
        id: "ai-mate.rovo-spaces.space-landing-page.sources-tab",
        defaultMessage: "Sources"
    },
    memoryTab: {
        id: "ai-mate.rovo-spaces.space-landing-page.memory-tab",
        defaultMessage: "Memory"
    },
    noChatsTitle: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-chats-title",
        defaultMessage: "No chats yet"
    },
    noChats: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-chats",
        defaultMessage: "Chats in {spaceName} will live here."
    },
    untitledChat: {
        id: "ai-mate.rovo-spaces.space-landing-page.untitled-chat",
        defaultMessage: "Untitled chat"
    },
    openChatLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.open-chat-label",
        defaultMessage: "Open chat {name}"
    },
    loadingChatsLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.loading-chats-label",
        defaultMessage: "Loading chats"
    },
    deleteMemoryLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.delete-memory-label",
        defaultMessage: "Delete {text}"
    },
    deleteMemoryError: {
        id: "ai-mate.rovo-spaces.space-landing-page.delete-memory-error",
        defaultMessage: "Failed to delete memory. Please try again."
    },
    loadMemoriesError: {
        id: "rovo-spaces.space-landing-page.loadMemoriesError",
        defaultMessage: "We\u2019re having trouble loading memories. Try refreshing the page."
    },
    addMemoryButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.add-new-memory-button",
        defaultMessage: "Add new memory"
    },
    noStarters: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-starters",
        defaultMessage: "No starters yet."
    },
    noSources: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-sources",
        defaultMessage: "Upload relevant sources and add useful links to help bring your project into focus. The more context you provide, the better Rovo can understand your work and offer thoughtful, tailored support."
    },
    noSourcesTitle: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-sources-title",
        defaultMessage: "Give your Rovo space more context"
    },
    addSourcesButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.add-sources",
        defaultMessage: "Add sources"
    },
    tabListLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.tab-list-label",
        defaultMessage: "Space content"
    },
    aiDisclaimer: {
        id: "ai-mate.rovo-spaces.space-landing-page.ai-disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    deleteSourceLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.delete-source-label",
        defaultMessage: "Remove source {name}"
    },
    noMemoriesTitle: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-memories-title",
        defaultMessage: "Let's build some memories"
    },
    noMemories: {
        id: "ai-mate.rovo-spaces.space-landing-page.no-memories",
        defaultMessage: "Add memories to help this Rovo space remember what matters. Preferences, goals, context, and decisions will carry across chats."
    },
    submitNewMemory: {
        id: "ai-mate.rovo-spaces.space-landing-page.submit-new-memory",
        defaultMessage: "Create"
    },
    editTitleLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.edit-title-label",
        defaultMessage: "Edit Rovo space title"
    },
    editDescriptionLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.edit-description-label",
        defaultMessage: "Edit Rovo space description"
    },
    changeEmojiLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.change-emoji-label",
        defaultMessage: "Change emoji"
    },
    addDescriptionButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.add-description-button",
        defaultMessage: "Add description"
    },
    titleInputLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.title-input-label",
        defaultMessage: "Rovo space title"
    },
    descriptionInputLabel: {
        id: "ai-mate.rovo-spaces.space-landing-page.description-input-label",
        defaultMessage: "Rovo space description"
    },
    saveTitleButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.save-title-button",
        defaultMessage: "Save Rovo space title"
    },
    cancelTitleButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.cancel-title-button",
        defaultMessage: "Cancel editing Rovo space title"
    },
    saveDescriptionButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.save-description-button",
        defaultMessage: "Save Rovo space description"
    },
    cancelDescriptionButton: {
        id: "ai-mate.rovo-spaces.space-landing-page.cancel-description-button",
        defaultMessage: "Cancel editing Rovo space description"
    },
    titleRequired: {
        id: "ai-mate.rovo-spaces.space-landing-page.title-required",
        defaultMessage: "Enter a Rovo space title."
    },
    saveDetailsError: {
        id: "ai-mate.rovo-spaces.space-landing-page.save-details-error",
        defaultMessage: "We couldn't save your changes. Try again."
    },
    addLinksInvalidDataError: {
        id: "ai-mate.rovo-spaces.space-landing-page.add-links-invalid-data-error",
        defaultMessage: "Could not add source \u2014 invalid data"
    }
});
var $2a8c4b56e08e8f01$export$2e2bcd8739ae039 = $2a8c4b56e08e8f01$var$message;



var $5tuwK = parcelRequire("5tuwK");




const $fb2ff6d69701fe65$var$SmartContextRecommendationsModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(async ()=>{
    const { SmartContextRecommendationsModal: SmartContextRecommendationsModal } = await (parcelRequire("c9Pnc"));
    return {
        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartContextRecommendationsModal, props)
    };
});
const $fb2ff6d69701fe65$var$styles = {
    page: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d",
    pageMiniModal: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0jFU0VIZbP",
    scrollArea: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2WAcuGIZbP _46hvQmS40j _0xmtkoS40j _0LQT5E5zaO _03SyCP5zaO",
    scrollAreaFullScreen: "_0LQT5EPgdg _03SyCPPgdg",
    inner: "_1EqgXlOAqP _39xV02N91d _0GTcwRIZbP _2xTnZxIZbP",
    header: "_0rIjyk5zaO",
    titleRow: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    inlineEditReadViewButton: "_2mHwu82ADO _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d _4ouGXIdnbC _46hvQm1Y8M _0xmtko1Y8M _0LQT5E2ADO _03SyCP2ADO _43nrzT5UaJ _0rIjyk5UaJ _0GTcwR4F84 _2xTnZx4F84 _1UtDYzy7kJ _0KLXrujOvk _2fwxA57p2s _4EiLyUujt8 _34b3D2FQfX _1eOmH6o126 _3gzVzLN4oS",
    descriptionInlineEditReadViewButton: "_0hPCNL7p2s",
    hiddenEditButton: "_23rrnH5ZrZ _1YKVNsdnbC",
    visibleEditButton: "_1YKVNs7dHp",
    titleEditForm: "_0rIjyk5zaO",
    descriptionEditForm: "_0rIjykNHnM",
    editField: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    editControls: "_3YEZNOdnbC",
    editIcon: "_3YEZNOdnbC _1UtDYzZpcK",
    fieldError: "_43nrzTgVvo",
    emoji: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    emojiPickerTrigger: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02UF4f _0jFU0VUF4f _0KLXrujOvk _4EiLyUujt8 _34b3D2FQfX _1eOmH6o126 _3gzVzLN4oS",
    description: "_0rIjykNHnM",
    tabBar: "_2mHwu81Y8M _0bjKvDKTcp _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbccYA _0rIjykNHnM _46hvQm1Y8M _0xmtko1Y8M _0LQT5E1Y8M _03SyCP1Y8M _0hPCNLDIqT _0KLXrulfZc",
    tabButtonBase: "_0bjKvDKxmn _2sNsIgmnOE _4c065UPgdg _2Y7lL48HPE _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAoWWg _0wOv4Q7zJH _37wbyuDIqT _0hPCNLDIqT _3jVsArnQyn _0MiLUPnQyn _0GBAIrdfJf _23Zxlp7GSX _47eTBtdnbC _22EsJjnQyn _2Oqz2qYbGa _2tbAUcYbGa",
    tabButtonActive: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHrzt2 _0KLXruY9q9 _1UtDYzjTy9 _1kk5Tk7GSX",
    tabButtonInactive: "_3hxITiYbGa _2V7sgOdnbC _3vBAKHjOvk _0KLXrujOvk _1UtDYzZpcK _1kk5Tku7m9 _1eOmH6o126 _0clgaMy7kJ",
    sourceList: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _4xdlr0FlnN _0KLXrulfZc",
    emptySourcesCard: "_0bjKvDyzSk _3hxITisurO _2V7sgONvrM _3vBAKH9r67 _46hvQmp0Oa _0xmtkop0Oa _0LQT5Ep0Oa _03SyCPp0Oa _4xdlr0FlnN",
    starterList: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    starterCard: "_2mHwu88HPE _0bjKvDKxmn _30huDKYbGa _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _46hvQmgVvo _0xmtkogVvo _0LQT5EgVvo _03SyCPgVvo _4xdlr0FlnN _0KLXrulfZc _0wOv4Q7zJH _39xV02N91d _2fwxA57p2s _4EiLyUujt8 _34b3D2FQfX _1eOmH6o126",
    starterIconWrapper: "_0bjKvD0O7w _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _0KLXrulfZc _3YEZNOdnbC",
    starterText: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzy7kJ _1kk5Tku7m9",
    chatList: "_3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d",
    emptyChatsCard: "_0bjKvDyzSk _3hxITisurO _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _4kiQYAGVdc _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _46hvQmp0Oa _0xmtkop0Oa _0LQT5Ep0Oa _03SyCPp0Oa",
    emptyChatsIcon: "_39xV02QEt6 _0jFU0VQEt6 _3YEZNOdnbC",
    emptyChatsText: "_2mHwu81Y8M _39xV02N91d _1EqgXlUsnK _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _2fwxA5DIqT",
    chatsLoading: "_3iDTPbQ4SZ _37wbyuDIqT _46hvQmp0Oa _0xmtkop0Oa",
    sourceCard: "_2mHwu88HPE _4c065U2ADO _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5E5zaO _03SyCP2ADO _2yjt2x6wH8 _4auqkJNvrM _3mHaMX9r67",
    noBorderEnd: "_4auqkJdnbC _2yjt2xYbGa _3mHaMXjOvk",
    sourceLink: "_4bt5LAnQyn _2WAcuGnQyn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbQ4SZ _2O5Vij7dHp _3YEZNO7dHp _1bHrqEB6f5 _0hPCNLDIqT _4ouGXIdnbC _1UtDYzy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    deleteButtonWrapper: "_0bjKvDKxmn _0GTcwRIZbP _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQmgVvo _0xmtkogVvo _0LQT5EgVvo _03SyCPgVvo _1UtDYzZpcK _0KLXrujOvk _4EiLyUujt8 _34b3D2FQfX _1eOmH6KcZT _0clgaMAyGJ",
    chatInputArea: "_3YEZNOdnbC _46hvQm5zaO _0xmtko2ADO _0LQT5EPgdg _03SyCPPgdg _0KLXrulfZc",
    chatInputAreaFullScreen: "_0LQT5EVa5s _03SyCPVa5s",
    chatInputInner: "_1EqgXlOAqP _39xV02N91d _0GTcwRIZbP _2xTnZxIZbP",
    spaceContextBannerWrapper: "_0LQT5E5zaO _03SyCP5zaO",
    aiDisclaimer: "_2fwxA5DIqT _43nrzT2ADO",
    aiDisclaimerAnchor: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX",
    emptyMemoriesCard: "_2mHwu88HPE _0bjKvDyzSk _3hxITisurO _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _46hvQmp0Oa _0xmtkop0Oa _0LQT5Ep0Oa _03SyCPp0Oa",
    emptyMemoriesText: "_2fwxA5DIqT"
};
const $fb2ff6d69701fe65$var$StarterCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { starter: starter, onClick: onClick, icon: icon, title: title } = t0;
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    const skillMetadataMap = skillMetadata?.skillMetadataMap;
    let t1;
    if ($[0] !== skillMetadataMap || $[1] !== starter) {
        t1 = (0, $6f9ddc0be56240f7$export$905653b9e5e1420)(starter, skillMetadataMap);
        $[0] = skillMetadataMap;
        $[1] = starter;
        $[2] = t1;
    } else t1 = $[2];
    const metadata = t1;
    let t2;
    if ($[3] !== onClick || $[4] !== starter) {
        t2 = ()=>onClick(starter);
        $[3] = onClick;
        $[4] = starter;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== icon) {
        t3 = icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb2ff6d69701fe65$var$styles.starterIconWrapper,
            "aria-hidden": "true"
        }, icon);
        $[6] = icon;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = title ?? starter.text;
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb2ff6d69701fe65$var$styles.starterText
        }, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $fb2ff6d69701fe65$var$styles.starterCard,
            onClick: t2,
            testId: "space-starter-card"
        }, t3, t5);
        $[10] = t2;
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const card = t6;
    if (!metadata) return card;
    const t7 = metadata.description ?? "";
    let t8;
    if ($[14] !== card || $[15] !== metadata.iconName || $[16] !== metadata.name || $[17] !== metadata.product || $[18] !== metadata.productIconUrl || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c9906e0ffa65ec7$export$34228be725c432b), {
            name: metadata.name,
            iconName: metadata.iconName,
            description: t7,
            product: metadata.product,
            productIconUrl: metadata.productIconUrl,
            shouldRenderToParent: true
        }, card);
        $[14] = card;
        $[15] = metadata.iconName;
        $[16] = metadata.name;
        $[17] = metadata.product;
        $[18] = metadata.productIconUrl;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ starter: starter, onClick: onClick, icon: icon, title: title })=>{
    // Look up skill metadata for the starter's slash command to render SkillHoverCard
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    const skillMetadataMap = skillMetadata?.skillMetadataMap;
    const metadata = (0, $6f9ddc0be56240f7$export$905653b9e5e1420)(starter, skillMetadataMap);
    const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $fb2ff6d69701fe65$var$styles.starterCard,
        onClick: ()=>onClick(starter),
        testId: "space-starter-card"
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.starterIconWrapper,
        "aria-hidden": "true"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.starterText
    }, title ?? starter.text));
    if (!metadata) return card;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c9906e0ffa65ec7$export$34228be725c432b), {
        name: metadata.name,
        iconName: metadata.iconName,
        description: metadata.description ?? '',
        product: metadata.product,
        productIconUrl: metadata.productIconUrl,
        shouldRenderToParent: true
    }, card);
};
const $fb2ff6d69701fe65$var$SourceCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { source: source, onDelete: onDelete, deleteLabel: deleteLabel, isLast: isLast } = t0;
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const t1 = isLast ? $fb2ff6d69701fe65$var$styles.noBorderEnd : undefined;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.sourceCard, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = source.title !== source.url ? source.title : undefined;
    let t4;
    if ($[2] !== source.title || $[3] !== source.url || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tuwK.SmartLinkSourceRow), {
            url: source.url,
            fallback: source.title,
            displayTextOverride: t3,
            onLoadingChange: setIsLoading
        });
        $[2] = source.title;
        $[3] = source.url;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== source.url || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: source.url,
            target: "_blank",
            xcss: $fb2ff6d69701fe65$var$styles.sourceLink
        }, t4);
        $[6] = source.url;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== deleteLabel || $[10] !== isLoading || $[11] !== onDelete || $[12] !== source) {
        t6 = onDelete && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $fb2ff6d69701fe65$var$styles.deleteButtonWrapper,
            onClick: ()=>onDelete(source),
            testId: "source-delete-button",
            "aria-label": deleteLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: ""
        }));
        $[9] = deleteLabel;
        $[10] = isLoading;
        $[11] = onDelete;
        $[12] = source;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            testId: "space-source-item"
        }, t5, t6);
        $[14] = t2;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ source: source, onDelete: onDelete, deleteLabel: deleteLabel, isLast: isLast })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.sourceCard, isLast ? $fb2ff6d69701fe65$var$styles.noBorderEnd : undefined),
        testId: "space-source-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: source.url,
        target: "_blank",
        xcss: $fb2ff6d69701fe65$var$styles.sourceLink
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tuwK.SmartLinkSourceRow), {
        url: source.url,
        fallback: source.title,
        displayTextOverride: source.title !== source.url ? source.title : undefined,
        onLoadingChange: setIsLoading
    })), onDelete && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $fb2ff6d69701fe65$var$styles.deleteButtonWrapper,
        onClick: ()=>onDelete(source),
        testId: "source-delete-button",
        "aria-label": deleteLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
        label: ""
    })));
};
const $fb2ff6d69701fe65$var$MemoryCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { memory: memory, onDelete: onDelete, deleteLabel: deleteLabel, isLast: isLast } = t0;
    const t1 = isLast ? $fb2ff6d69701fe65$var$styles.noBorderEnd : undefined;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.sourceCard, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== memory.text) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, memory.text);
        $[2] = memory.text;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== deleteLabel || $[5] !== memory || $[6] !== onDelete) {
        t4 = onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $fb2ff6d69701fe65$var$styles.deleteButtonWrapper,
            onClick: ()=>onDelete(memory),
            testId: "memory-delete-button",
            "aria-label": deleteLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: ""
        }));
        $[4] = deleteLabel;
        $[5] = memory;
        $[6] = onDelete;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            testId: "space-memory-item"
        }, t3, t4);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ memory: memory, onDelete: onDelete, deleteLabel: deleteLabel, isLast: isLast })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.sourceCard, isLast ? $fb2ff6d69701fe65$var$styles.noBorderEnd : undefined),
        testId: "space-memory-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, memory.text), onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $fb2ff6d69701fe65$var$styles.deleteButtonWrapper,
        onClick: ()=>onDelete(memory),
        testId: "memory-delete-button",
        "aria-label": deleteLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
        label: ""
    })));
const $fb2ff6d69701fe65$var$chatInputFocusableSelector = [
    'button:not([disabled])',
    'a[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $fb2ff6d69701fe65$var$toModalLinkRecommendation = (recommendation)=>({
        type: 'link',
        recommendationId: recommendation.recommendationId,
        url: recommendation.url,
        ari: recommendation.ari,
        sourceType: recommendation.sourceType,
        name: recommendation.name
    });
const $fb2ff6d69701fe65$var$getErrorStatusCode = (error)=>{
    if (error && typeof error === 'object' && 'errorAttributes' in error) {
        const { errorAttributes: errorAttributes } = error;
        return errorAttributes?.statusCode;
    }
    return undefined;
};
const $fb2ff6d69701fe65$var$isLinkRecommendation = (recommendation)=>recommendation.type === 'link';
const $fb2ff6d69701fe65$var$DismissibleRecommendationBannerSlot = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { shouldRender: shouldRender, onDismissFocusTarget: onDismissFocusTarget, children: children } = t0;
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== onDismissFocusTarget) {
        t1 = ()=>{
            onDismissFocusTarget?.();
            setIsDismissed(true);
        };
        $[0] = onDismissFocusTarget;
        $[1] = t1;
    } else t1 = $[1];
    const dismiss = t1;
    if (!shouldRender || isDismissed) return null;
    let t2;
    if ($[2] !== children || $[3] !== dismiss) {
        t2 = children({
            dismiss: dismiss
        });
        $[2] = children;
        $[3] = dismiss;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb2ff6d69701fe65$var$styles.spaceContextBannerWrapper
        }, t2);
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ shouldRender: shouldRender, onDismissFocusTarget: onDismissFocusTarget, children: children })=>{
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    const dismiss = (0, $cozmU.useCallback)(()=>{
        onDismissFocusTarget?.();
        setIsDismissed(true);
    }, [
        onDismissFocusTarget
    ]);
    if (!shouldRender || isDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.spaceContextBannerWrapper
    }, children({
        dismiss: dismiss
    }));
}; /**
    * Wraps the {@link PastConversationsBanner} together with its data-fetching
    * hook so that the recommendations query is *only* executed when this slot is
    * actually rendered.
    *
    * The slot also owns its own visual wrapper (`spaceContextBannerWrapper`) so
    * that when the hook returns `count <= 0` the *entire* DOM subtree (wrapper
    * `<Box>` included) is removed \u2014 not just the inner banner. This avoids
    * leaving an empty padded `<Box>` in the layout.
    *
    * Critical: the parent must render `<PastConversationsBannerSlot />` inside
    * the spaces and smart-context feature flag guards. Today the stub hook does
    * no I/O so either rendering pattern would work, but once the hook is wired to
    * a real backend call in a follow-up ticket, gating the slot here prevents
    * requests being fired for users without the gates.
    */ 
const $fb2ff6d69701fe65$var$PastConversationsBannerSlot = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { spaceId: spaceId, variant: variant, onDismissFocusTarget: onDismissFocusTarget } = t0;
    let t1;
    if ($[0] !== spaceId) {
        t1 = {
            spaceId: spaceId
        };
        $[0] = spaceId;
        $[1] = t1;
    } else t1 = $[1];
    const { count: pastConversationsCount } = (0, $c4f706723085471c$export$3df8a3de6597771a)(t1);
    const t2 = pastConversationsCount > 0;
    let t3;
    if ($[2] !== pastConversationsCount || $[3] !== variant) {
        t3 = (t4)=>{
            const { dismiss: dismiss } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77d0f5d368cec1ee$export$bc4c85e6087c9fdf), {
                conversationCount: pastConversationsCount,
                onAddChats: $fb2ff6d69701fe65$var$_temp,
                onDismiss: dismiss,
                variant: variant
            });
        };
        $[2] = pastConversationsCount;
        $[3] = variant;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onDismissFocusTarget || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$DismissibleRecommendationBannerSlot, {
            shouldRender: t2,
            onDismissFocusTarget: onDismissFocusTarget
        }, t3);
        $[5] = onDismissFocusTarget;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ spaceId: spaceId, variant: variant, onDismissFocusTarget: onDismissFocusTarget })=>{
    const { count: pastConversationsCount } = (0, $c4f706723085471c$export$3df8a3de6597771a)({
        spaceId: spaceId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$DismissibleRecommendationBannerSlot, {
        shouldRender: pastConversationsCount > 0,
        onDismissFocusTarget: onDismissFocusTarget
    }, ({ dismiss: dismiss })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77d0f5d368cec1ee$export$bc4c85e6087c9fdf), {
            conversationCount: pastConversationsCount,
            onAddChats: ()=>{},
            onDismiss: dismiss,
            variant: variant
        }));
};
const $fb2ff6d69701fe65$var$SmartContextLinksBannerContent = ({ spaceId: spaceId, cloudId: cloudId, recommendations: recommendations, variant: variant, dismiss: dismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { addSource: addSource, isAdding: isAdding } = (0, $jqWbJ.useAddSpaceSource)({
        spaceId: spaceId,
        cloudId: cloudId
    });
    const { removeSmartContextLinkRecommendation: removeSmartContextLinkRecommendation, clearSmartContextLinkRecommendations: clearSmartContextLinkRecommendations } = (0, $12shJ.useSpaceStoreActions)();
    const { fireSourceAdded: fireSourceAdded, fireSourceRecommendationsViewed: fireSourceRecommendationsViewed } = (0, $7CqGl.useSpacesAnalytics)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [isBatchAdding, setIsBatchAdding] = (0, $cozmU.useState)(false);
    const [selectedRecommendationIds, setSelectedRecommendationIds] = (0, $cozmU.useState)([]);
    const [completedRecommendationIds, setCompletedRecommendationIds] = (0, $cozmU.useState)([]);
    const [submitErrorMessage, setSubmitErrorMessage] = (0, $cozmU.useState)(); // This content only renders when there are recommendations (the slot guards
    // on `recommendations.length > 0`), so mount == the recommendations were
    // shown. Fires the impression that forms the CTR denominator.
    (0, $cozmU.useEffect)(()=>{
        fireSourceRecommendationsViewed({
            spaceId: spaceId,
            recommendationCount: recommendations.length
        }); // Impression fires once when the recommendations banner is shown.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const modalRecommendations = (0, $cozmU.useMemo)(()=>recommendations.map($fb2ff6d69701fe65$var$toModalLinkRecommendation), [
        recommendations
    ]);
    const openModal = (0, $cozmU.useCallback)(()=>{
        const completedIds = new Set(completedRecommendationIds);
        setSubmitErrorMessage(undefined);
        setSelectedRecommendationIds(recommendations.filter((recommendation)=>!completedIds.has(recommendation.recommendationId)).map((recommendation)=>recommendation.recommendationId));
        setIsModalOpen(true);
    }, [
        completedRecommendationIds,
        recommendations
    ]);
    const closeModal = (0, $cozmU.useCallback)(()=>{
        setSubmitErrorMessage(undefined);
        setIsModalOpen(false);
    }, []);
    const markRecommendationCompleted = (0, $cozmU.useCallback)((recommendationId)=>{
        setCompletedRecommendationIds((currentIds)=>currentIds.includes(recommendationId) ? currentIds : [
                ...currentIds,
                recommendationId
            ]);
        setSelectedRecommendationIds((currentIds)=>currentIds.filter((id)=>id !== recommendationId));
    }, []);
    const dismissRecommendations = (0, $cozmU.useCallback)(()=>{
        clearSmartContextLinkRecommendations(spaceId);
        dismiss();
    }, [
        clearSmartContextLinkRecommendations,
        dismiss,
        spaceId
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(async (selectedRecommendations)=>{
        const selectedLinks = selectedRecommendations.filter($fb2ff6d69701fe65$var$isLinkRecommendation);
        let didNotFoundError = false;
        let didNonNotFoundError = false; // Track the items actually added to the space so we can drop exactly those
        // from the store, even if the batch fails partway through.
        const addedRecommendationIds = [];
        setSubmitErrorMessage(undefined);
        setIsBatchAdding(true);
        try {
            for (const recommendation of selectedLinks){
                let addSourceError;
                await addSource({
                    ari: recommendation.ari,
                    url: recommendation.url,
                    sourceType: recommendation.sourceType,
                    name: recommendation.name
                }, {
                    onError: (error)=>{
                        addSourceError = error;
                    }
                });
                if (addSourceError) {
                    const statusCode = $fb2ff6d69701fe65$var$getErrorStatusCode(addSourceError);
                    if (statusCode === 404) {
                        didNotFoundError = true;
                        markRecommendationCompleted(recommendation.recommendationId);
                    } else didNonNotFoundError = true;
                } else {
                    fireSourceAdded({
                        spaceId: spaceId,
                        sourceType: recommendation.sourceType,
                        addMethod: 'recommendation',
                        recommendationId: recommendation.recommendationId
                    });
                    markRecommendationCompleted(recommendation.recommendationId);
                    addedRecommendationIds.push(recommendation.recommendationId);
                }
            }
        } finally{
            setIsBatchAdding(false);
        } // Always remove the recommendations that were actually added to the space so a
        // retry can't re-submit them as duplicate sources, even on a partial failure.
        addedRecommendationIds.forEach((recommendationId)=>{
            removeSmartContextLinkRecommendation(spaceId, recommendationId);
        });
        if (didNonNotFoundError) {
            setSubmitErrorMessage(formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addLinksInvalidDataError));
            return;
        }
        if (didNotFoundError || selectedLinks.length === 0) {
            setIsModalOpen(false);
            clearSmartContextLinkRecommendations(spaceId);
            dismiss();
            return;
        }
        setIsModalOpen(false);
        dismiss();
    }, [
        addSource,
        clearSmartContextLinkRecommendations,
        dismiss,
        formatMessage,
        markRecommendationCompleted,
        removeSmartContextLinkRecommendation,
        spaceId,
        fireSourceAdded
    ]);
    const submitSelectedRecommendations = (0, $cozmU.useCallback)((selectedRecommendations)=>{
        handleSubmit(selectedRecommendations).catch(()=>{
            setIsBatchAdding(false);
            setSubmitErrorMessage(formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addLinksInvalidDataError));
        });
    }, [
        formatMessage,
        handleSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46d9ab99f381a4cb$export$7e1a4c17becc168b), {
        recommendationCount: recommendations.length,
        onAddLinks: openModal,
        onDismiss: dismissRecommendations,
        variant: variant
    }), isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SmartContextRecommendationsModal, {
        isOpen: isModalOpen,
        recommendationType: "link",
        recommendations: modalRecommendations,
        selectedRecommendationIds: selectedRecommendationIds,
        onSelectionChange: setSelectedRecommendationIds,
        onClose: closeModal,
        onSubmit: submitSelectedRecommendations,
        isSubmitting: isAdding || isBatchAdding,
        errorMessage: submitErrorMessage
    })));
};
const $fb2ff6d69701fe65$var$SmartContextLinksBannerSlot = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { spaceId: spaceId, cloudId: cloudId, recommendations: recommendations, variant: variant, onDismissFocusTarget: onDismissFocusTarget } = t0;
    const t1 = recommendations.length > 0;
    let t2;
    if ($[0] !== cloudId || $[1] !== recommendations || $[2] !== spaceId || $[3] !== variant) {
        t2 = (t3)=>{
            const { dismiss: dismiss } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SmartContextLinksBannerContent, {
                spaceId: spaceId,
                cloudId: cloudId,
                recommendations: recommendations,
                variant: variant,
                dismiss: dismiss
            });
        };
        $[0] = cloudId;
        $[1] = recommendations;
        $[2] = spaceId;
        $[3] = variant;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== onDismissFocusTarget || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$DismissibleRecommendationBannerSlot, {
            shouldRender: t1,
            onDismissFocusTarget: onDismissFocusTarget
        }, t2);
        $[5] = onDismissFocusTarget;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ spaceId: spaceId, cloudId: cloudId, recommendations: recommendations, variant: variant, onDismissFocusTarget: onDismissFocusTarget })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$DismissibleRecommendationBannerSlot, {
        shouldRender: recommendations.length > 0,
        onDismissFocusTarget: onDismissFocusTarget
    }, ({ dismiss: dismiss })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SmartContextLinksBannerContent, {
            spaceId: spaceId,
            cloudId: cloudId,
            recommendations: recommendations,
            variant: variant,
            dismiss: dismiss
        }));
};
const $fb2ff6d69701fe65$var$SmartContextRecommendationsBannerSlot = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { spaceId: spaceId, cloudId: cloudId, variant: variant, onDismissFocusTarget: onDismissFocusTarget } = t0;
    const { clearSmartContextLinkRecommendations: clearSmartContextLinkRecommendations } = (0, $12shJ.useSpaceStoreActions)();
    let t1;
    if ($[0] !== spaceId) {
        t1 = {
            spaceId: spaceId
        };
        $[0] = spaceId;
        $[1] = t1;
    } else t1 = $[1];
    const { recommendations: linkRecommendations, count: linkRecommendationsCount } = (0, $312148fd866e6c87$export$9a7c6df39e4e5fd4)(t1);
    let t2;
    let t3;
    if ($[2] !== clearSmartContextLinkRecommendations || $[3] !== spaceId) {
        t2 = ()=>()=>{
                clearSmartContextLinkRecommendations(spaceId);
            };
        t3 = [
            clearSmartContextLinkRecommendations,
            spaceId
        ];
        $[2] = clearSmartContextLinkRecommendations;
        $[3] = spaceId;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    if (linkRecommendationsCount > 0) {
        let t4;
        if ($[6] !== cloudId || $[7] !== linkRecommendations || $[8] !== onDismissFocusTarget || $[9] !== spaceId || $[10] !== variant) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SmartContextLinksBannerSlot, {
                spaceId: spaceId,
                cloudId: cloudId,
                recommendations: linkRecommendations,
                variant: variant,
                onDismissFocusTarget: onDismissFocusTarget
            });
            $[6] = cloudId;
            $[7] = linkRecommendations;
            $[8] = onDismissFocusTarget;
            $[9] = spaceId;
            $[10] = variant;
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    }
    let t4;
    if ($[12] !== onDismissFocusTarget || $[13] !== spaceId || $[14] !== variant) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$PastConversationsBannerSlot, {
            spaceId: spaceId,
            variant: variant,
            onDismissFocusTarget: onDismissFocusTarget
        });
        $[12] = onDismissFocusTarget;
        $[13] = spaceId;
        $[14] = variant;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : ({ spaceId: spaceId, cloudId: cloudId, variant: variant, onDismissFocusTarget: onDismissFocusTarget })=>{
    const { clearSmartContextLinkRecommendations: clearSmartContextLinkRecommendations } = (0, $12shJ.useSpaceStoreActions)();
    const { recommendations: linkRecommendations, count: linkRecommendationsCount } = (0, $312148fd866e6c87$export$9a7c6df39e4e5fd4)({
        spaceId: spaceId
    }); // Clear this space's stream-pushed recommendations when leaving it. The slot is
    // keyed by spaceId, so this fires on space change/unmount and stops the store from
    // accumulating stale recommendations across visited spaces.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            clearSmartContextLinkRecommendations(spaceId);
        };
    }, [
        clearSmartContextLinkRecommendations,
        spaceId
    ]);
    if (linkRecommendationsCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SmartContextLinksBannerSlot, {
        spaceId: spaceId,
        cloudId: cloudId,
        recommendations: linkRecommendations,
        variant: variant,
        onDismissFocusTarget: onDismissFocusTarget
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$PastConversationsBannerSlot, {
        spaceId: spaceId,
        variant: variant,
        onDismissFocusTarget: onDismissFocusTarget
    });
};
const $fb2ff6d69701fe65$var$InlineEditActionButtons = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { saveLabel: saveLabel, cancelLabel: cancelLabel, isSaving: isSaving, onCancel: onCancel } = t0;
    const preventFocusSteal = $fb2ff6d69701fe65$var$_temp2;
    let t1;
    if ($[0] !== isSaving || $[1] !== saveLabel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            type: "submit",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
            appearance: "primary",
            spacing: "compact",
            label: saveLabel,
            isLoading: isSaving,
            isDisabled: isSaving,
            onMouseDown: preventFocusSteal,
            testId: "space-details-save-button"
        });
        $[0] = isSaving;
        $[1] = saveLabel;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== cancelLabel || $[4] !== isSaving || $[5] !== onCancel) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            type: "button",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            appearance: "subtle",
            spacing: "compact",
            label: cancelLabel,
            isDisabled: isSaving,
            onClick: onCancel,
            onMouseDown: preventFocusSteal,
            testId: "space-details-cancel-button"
        });
        $[3] = cancelLabel;
        $[4] = isSaving;
        $[5] = onCancel;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $fb2ff6d69701fe65$var$styles.editControls,
            space: "space.050",
            alignBlock: "center"
        }, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ saveLabel: saveLabel, cancelLabel: cancelLabel, isSaving: isSaving, onCancel: onCancel })=>{
    const preventFocusSteal = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $fb2ff6d69701fe65$var$styles.editControls,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "submit",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
        appearance: "primary",
        spacing: "compact",
        label: saveLabel,
        isLoading: isSaving,
        isDisabled: isSaving,
        onMouseDown: preventFocusSteal,
        testId: "space-details-save-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        appearance: "subtle",
        spacing: "compact",
        label: cancelLabel,
        isDisabled: isSaving,
        onClick: onCancel,
        onMouseDown: preventFocusSteal,
        testId: "space-details-cancel-button"
    }));
};
const $fb2ff6d69701fe65$var$TabButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { label: label, isActive: isActive, testId: testId, onClick: onClick } = t0;
    const t1 = isActive ? $fb2ff6d69701fe65$var$styles.tabButtonActive : $fb2ff6d69701fe65$var$styles.tabButtonInactive;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.tabButtonBase, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== isActive || $[3] !== label || $[4] !== onClick || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            "aria-selected": isActive,
            testId: testId,
            onClick: onClick,
            role: "tab",
            "data-label": label,
            xcss: t2
        }, label);
        $[2] = isActive;
        $[3] = label;
        $[4] = onClick;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ label: label, isActive: isActive, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        "aria-selected": isActive,
        testId: testId,
        onClick: onClick,
        role: "tab",
        "data-label": label,
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.tabButtonBase, isActive ? $fb2ff6d69701fe65$var$styles.tabButtonActive : $fb2ff6d69701fe65$var$styles.tabButtonInactive)
    }, label);
const $fb2ff6d69701fe65$var$SpaceLandingPageComponent = ({ spaceId: spaceId, cloudId: cloudId, emoji: emoji, title: title, description: description, isDescriptionLoading: isDescriptionLoading = false, starters: starters, sources: sources, chats: chats = [], isChatsLoading: isChatsLoading = false, onStarterClick: onStarterClick, onChatClick: onChatClick, onChatSubmit: onChatSubmit, onSpaceDetailsSave: onSpaceDetailsSave, renderChatInput: renderChatInput, onDeleteSource: onDeleteSource, onSourceAdded: onSourceAdded, emojiProvider: emojiProviderProp, fullScreen: fullScreen = false, entryPoint: entryPoint })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [activeTab, setActiveTab] = (0, $cozmU.useState)('starters');
    const spaceStarters = (0, $469e3ce09396ad62$export$1d903f8c25999b1a)({
        spaceName: title
    });
    const isSpacesEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const isSmartContextRecommendationsEnabled = (0, $iDrrr.fg)('rovo_chat_spaces_smart_context_recommendations'); // eslint-disable-next-line @atlaskit/platform/no-preconditioning -- This banner is part of Spaces but also has its own smart-context rollout gate; remove the layering when either rollout gate is cleaned up.
    const shouldRenderSmartContextRecommendations = isSpacesEnabled && isSmartContextRecommendationsEnabled; // Reset to the default tab whenever the user navigates to a different space
    (0, $cozmU.useEffect)(()=>{
        setActiveTab('starters');
    }, [
        spaceId
    ]); // Fire a screen-view event per space viewed (adoption / return-visit metric).
    // Keyed on spaceId so navigating between spaces logs a distinct view; source
    // and chat counts are best-effort at view time.
    const { fireSpaceViewed: fireSpaceViewed, fireSourceAdded: fireSourceAdded, fireSourceRemoved: fireSourceRemoved, fireStarterClicked: fireStarterClicked, fireMemoryCreated: fireMemoryCreated, fireMemoriesViewed: fireMemoriesViewed } = (0, $7CqGl.useSpacesAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        // NOTE: `sources` and `chats` are fetched asynchronously by the host and
        // are typically still empty at the moment `spaceId` changes, so their
        // lengths would be a misleading `0` on every navigation. Counts are
        // intentionally omitted here — the accurate per-space totals are captured
        // on the `created`/`added` events instead.
        fireSpaceViewed({
            spaceId: spaceId,
            fullScreen: fullScreen,
            entryPoint: entryPoint
        }); // Intentionally fire only when the viewed space changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceId
    ]);
    const plugins = (0, $d4397f8d51eab4c7$export$7ba3849109541ac3)(cloudId);
    const [editingSpaceField, setEditingSpaceField] = (0, $cozmU.useState)(null);
    const [draftTitle, setDraftTitle] = (0, $cozmU.useState)(title);
    const [draftDescription, setDraftDescription] = (0, $cozmU.useState)(description ?? '');
    const [spaceDetailsError, setSpaceDetailsError] = (0, $cozmU.useState)(null);
    const [isSavingSpaceDetails, setIsSavingSpaceDetails] = (0, $cozmU.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const [isTitleEditButtonVisible, setIsTitleEditButtonVisible] = (0, $cozmU.useState)(false);
    const [isDescriptionEditButtonVisible, setIsDescriptionEditButtonVisible] = (0, $cozmU.useState)(false);
    const spaceDetailsErrorId = spaceDetailsError && editingSpaceField ? `space-${editingSpaceField}-inline-edit-error` : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (!editingSpaceField) setDraftTitle(title);
    }, [
        editingSpaceField,
        title
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!editingSpaceField) setDraftDescription(description ?? '');
    }, [
        description,
        editingSpaceField
    ]);
    const startEditingTitle = (0, $cozmU.useCallback)(()=>{
        setDraftTitle(title);
        setSpaceDetailsError(null);
        setEditingSpaceField('title');
    }, [
        title
    ]);
    const startEditingDescription = (0, $cozmU.useCallback)(()=>{
        setDraftDescription(description ?? '');
        setSpaceDetailsError(null);
        setEditingSpaceField('description');
    }, [
        description
    ]);
    const cancelEditingSpaceDetails = (0, $cozmU.useCallback)(()=>{
        setDraftTitle(title);
        setDraftDescription(description ?? '');
        setSpaceDetailsError(null);
        setEditingSpaceField(null);
    }, [
        description,
        title
    ]);
    const closeEmojiPicker = (0, $cozmU.useCallback)(()=>{
        setIsEmojiPickerOpen(false);
    }, []);
    const toggleEmojiPicker = (0, $cozmU.useCallback)(()=>{
        setIsEmojiPickerOpen((isOpen)=>!isOpen);
    }, []);
    const hideTitleEditButtonOnBlur = (0, $cozmU.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) setIsTitleEditButtonVisible(false);
    }, []);
    const hideDescriptionEditButtonOnBlur = (0, $cozmU.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) setIsDescriptionEditButtonVisible(false);
    }, []);
    const saveSpaceDetails = (0, $cozmU.useCallback)(async (event)=>{
        event?.preventDefault();
        if (!onSpaceDetailsSave || isSavingSpaceDetails) return;
        const nextDetails = {
            title: draftTitle.trim(),
            description: draftDescription.trim() || undefined,
            emoji: emoji
        };
        if (!nextDetails.title) {
            setSpaceDetailsError(formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).titleRequired));
            return;
        }
        setSpaceDetailsError(null);
        setIsSavingSpaceDetails(true);
        try {
            await onSpaceDetailsSave(nextDetails);
            setEditingSpaceField(null);
        } catch  {
            setSpaceDetailsError(formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).saveDetailsError));
        } finally{
            setIsSavingSpaceDetails(false);
        }
    }, [
        draftDescription,
        draftTitle,
        emoji,
        formatMessage,
        isSavingSpaceDetails,
        onSpaceDetailsSave
    ]);
    const saveSpaceEmoji = (0, $cozmU.useCallback)(async (selectedEmojiId)=>{
        if (!onSpaceDetailsSave || isSavingSpaceDetails) return;
        setSpaceDetailsError(null);
        setIsSavingSpaceDetails(true);
        try {
            await onSpaceDetailsSave({
                title: title,
                description: description,
                emoji: selectedEmojiId.id
            });
            setIsEmojiPickerOpen(false);
        } catch  {
            setSpaceDetailsError(formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).saveDetailsError));
        } finally{
            setIsSavingSpaceDetails(false);
        }
    }, [
        description,
        formatMessage,
        isSavingSpaceDetails,
        onSpaceDetailsSave,
        title
    ]); // Memory store state and actions.
    const storeActions = (0, $12shJ.useSpaceStoreActions)();
    const memories = (0, $12shJ.useSpaceMemories)(spaceId);
    const isMemoriesLoading = (0, $12shJ.useSpaceMemoriesLoading)(spaceId);
    const memoriesStoreError = (0, $12shJ.useSpaceMemoriesError)(spaceId);
    const [memoryDeleteErrorSpaceId, setMemoryDeleteErrorSpaceId] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        setMemoryDeleteErrorSpaceId(null);
    }, [
        spaceId
    ]);
    const handleDeleteMemory = (0, $cozmU.useCallback)(async (memory)=>{
        setMemoryDeleteErrorSpaceId(null);
        try {
            await storeActions.removeSpaceMemory(spaceId, memory.id, cloudId, 'rovo', 'ai-mate');
        } catch  {
            setMemoryDeleteErrorSpaceId(spaceId);
        }
    }, [
        storeActions,
        spaceId,
        cloudId
    ]); // Lazily fetch memories when the memory tab is first opened.
    // fetchSpaceMemories is idempotent — it skips if already loading or fetched.
    (0, $cozmU.useEffect)(()=>{
        if (activeTab === 'memory') storeActions.fetchSpaceMemories({
            spaceId: spaceId,
            cloudId: cloudId,
            product: 'rovo',
            experienceId: 'ai-mate'
        });
    }, [
        activeTab,
        spaceId,
        cloudId,
        storeActions
    ]); // Fire a "memories retrieved" signal once per space when the memory tab is
    // opened and the load settles (retrieval metric — memories shown per space).
    const memoriesViewedForSpaceRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (activeTab !== 'memory' || isMemoriesLoading) return;
        if (memoriesViewedForSpaceRef.current === spaceId) return;
        memoriesViewedForSpaceRef.current = spaceId;
        fireMemoriesViewed({
            spaceId: spaceId,
            count: memories.length
        });
    }, [
        activeTab,
        isMemoriesLoading,
        spaceId,
        memories.length,
        fireMemoriesViewed
    ]); // Manual source add via the Sources-tab link picker. Fires the analytics
    // event with `addMethod: 'manual'` (vs the recommendation path) then forwards
    // to the host-provided `onSourceAdded` which performs the persistence.
    const handleManualSourceAdded = (0, $cozmU.useCallback)((source)=>{
        fireSourceAdded({
            spaceId: spaceId,
            sourceType: source.sourceType,
            addMethod: 'manual'
        });
        onSourceAdded?.(source);
    }, [
        fireSourceAdded,
        spaceId,
        onSourceAdded
    ]);
    const zeroSourcesBannerAction = (0, $cozmU.useMemo)(()=>onSourceAdded && sources.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c75163609085e392$export$43b333124c26a133), {
            plugins: plugins,
            cloudId: cloudId,
            sources: sources,
            onSourceAdded: handleManualSourceAdded,
            trigger: ({ ref: ref, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    ref: ref,
                    ...triggerProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    appearance: "primary",
                    onClick: onClick,
                    testId: "zero-sources-banner-add-sources-button",
                    shouldFitContainer: true
                }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addSourcesButton)))
        }) : undefined, [
        onSourceAdded,
        sources,
        plugins,
        cloudId,
        handleManualSourceAdded,
        formatMessage
    ]); // Fire the source-removed analytics event, then forward to the host-provided
    // `onDeleteSource` which performs the removal. Only defined when the host
    // supports deletion, so the delete affordance stays gated on `onDeleteSource`.
    const handleDeleteSource = (0, $cozmU.useMemo)(()=>onDeleteSource ? (source)=>{
            fireSourceRemoved({
                spaceId: spaceId,
                sourceType: source.sourceType
            });
            onDeleteSource(source);
        } : undefined, [
        fireSourceRemoved,
        spaceId,
        onDeleteSource
    ]); // Fire the starter-clicked analytics event (which starter drove engagement),
    // then forward to the host-provided `onStarterClick`.
    const handleStarterClick = (0, $cozmU.useCallback)((starter)=>{
        fireStarterClicked({
            spaceId: spaceId,
            starterId: starter.id
        });
        onStarterClick(starter);
    }, [
        fireStarterClicked,
        spaceId,
        onStarterClick
    ]);
    const [emptyChatLaunch] = (0, $bGNkz.useEmptyChatLaunchSelector)(); // Memoize to isolate re-renders to `skillRegistryTags` changes rather than any
    // change on the empty-chat-launch slice (customGreeting, projectContext, etc.).
    const skillRegistryTags = (0, $cozmU.useMemo)(()=>emptyChatLaunch.skillRegistryTags, [
        emptyChatLaunch.skillRegistryTags
    ]); // Memoized so `action.icon?.()` (and the whole `.map`) only runs when the
    // starters tab is active AND the starter list actually changes — not on
    // every render (which would defeat the icon-lazy pattern). Returns `null`
    // when a different tab is active so the JSX is never constructed.
    const starterCardList = (0, $cozmU.useMemo)(()=>activeTab === 'starters' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb2ff6d69701fe65$var$styles.starterList,
            role: "tabpanel",
            testId: "starters-list"
        }, spaceStarters.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$StarterCard, {
                key: action.id,
                starter: {
                    id: action.id,
                    text: action.staticPrompt ?? '',
                    handleType: action.handleType,
                    staticPrompt: action.staticPrompt
                },
                onClick: handleStarterClick,
                icon: action.icon?.(),
                title: action.title
            }))) : null, [
        activeTab,
        spaceStarters,
        handleStarterClick
    ]);
    const starterCardWithSkillTags = skillRegistryTags && skillRegistryTags.length > 0 && !fullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7dHQW.SkillMetadataProvider), {
        siteId: cloudId,
        tags: {
            skillRegistryTags: skillRegistryTags
        }
    }, starterCardList) : starterCardList; // Inline "create memory" input state.
    const [isAddingMemory, setIsAddingMemory] = (0, $cozmU.useState)(false);
    const [newMemoryText, setNewMemoryText] = (0, $cozmU.useState)('');
    const [memorySubmitError, setMemorySubmitError] = (0, $cozmU.useState)(null);
    const [isSubmittingMemory, setIsSubmittingMemory] = (0, $cozmU.useState)(false);
    const openAddMemory = (0, $cozmU.useCallback)(()=>{
        setNewMemoryText('');
        setMemorySubmitError(null);
        setIsAddingMemory(true);
    }, []);
    const handleSubmitMemory = (0, $cozmU.useCallback)(async ()=>{
        const text = newMemoryText.trim();
        if (!text || isSubmittingMemory) return;
        setMemorySubmitError(null);
        setIsSubmittingMemory(true);
        try {
            await storeActions.createSpaceMemory({
                spaceId: spaceId,
                cloudId: cloudId,
                content: text,
                product: 'rovo',
                experienceId: 'ai-mate'
            });
            fireMemoryCreated({
                spaceId: spaceId
            }); // Only clear the input after the store action succeeds so the user
            // can retry if something throws.
            setIsAddingMemory(false);
            setNewMemoryText('');
        } catch (error) {
            setMemorySubmitError(error instanceof Error ? error : new Error(String(error)));
        } finally{
            setIsSubmittingMemory(false);
        }
    }, [
        storeActions,
        spaceId,
        cloudId,
        newMemoryText,
        isSubmittingMemory,
        fireMemoryCreated
    ]);
    const emojiProvider = (0, $cozmU.useMemo)(()=>emojiProviderProp ?? (0, $d26Wq.createEmojiProvider)(cloudId), [
        emojiProviderProp,
        cloudId
    ]);
    const spaceEmoji = emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiId: {
            id: emoji,
            shortName: ''
        },
        emojiProvider: emojiProvider,
        fitToHeight: 24
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43dcb62dc2633ccc$export$3c3a3177721340ad), {
        color: "var(--ds-text-subtlest, #6B6E76)"
    });
    const spaceEmojiTrigger = onSpaceDetailsSave ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isEmojiPickerOpen,
        onClose: closeEmojiPicker,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: saveSpaceEmoji
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                "aria-label": formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).changeEmojiLabel),
                isDisabled: isSavingSpaceDetails,
                onClick: toggleEmojiPicker,
                testId: "space-emoji-picker-trigger",
                xcss: $fb2ff6d69701fe65$var$styles.emojiPickerTrigger
            }, spaceEmoji)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.emoji,
        "aria-hidden": "true"
    }, spaceEmoji); // Stable submit handler forwarded to the host-provided chat input render-prop.
    const handleSubmit = (0, $cozmU.useCallback)((params)=>{
        onChatSubmit?.(params);
    }, [
        onChatSubmit
    ]);
    const chatInputFocusTargetRef = (0, $cozmU.useRef)(null);
    const focusChatInput = (0, $cozmU.useCallback)(()=>{
        chatInputFocusTargetRef.current?.querySelector($fb2ff6d69701fe65$var$chatInputFocusableSelector)?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.page, !fullScreen && $fb2ff6d69701fe65$var$styles.pageMiniModal),
        testId: "space-landing-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.scrollArea, fullScreen && $fb2ff6d69701fe65$var$styles.scrollAreaFullScreen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.inner
    }, editingSpaceField === 'title' && onSpaceDetailsSave ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
        onSubmit: saveSpaceDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.titleEditForm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.200"
    }, spaceEmojiTrigger, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.editField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.editField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        "aria-label": formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).titleInputLabel),
        "aria-describedby": spaceDetailsErrorId,
        autoFocus: true,
        maxLength: (0, $98i9C.SPACE_NAME_MAX_LENGTH),
        value: draftTitle,
        onChange: (event)=>setDraftTitle(event.currentTarget.value),
        onKeyDown: (event)=>{
            if (event.key === 'Escape') cancelEditingSpaceDetails();
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$InlineEditActionButtons, {
        saveLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).saveTitleButton),
        cancelLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).cancelTitleButton),
        isSaving: isSavingSpaceDetails,
        onCancel: cancelEditingSpaceDetails
    })), spaceDetailsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.fieldError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: spaceDetailsErrorId,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, spaceDetailsError))))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $fb2ff6d69701fe65$var$styles.header,
        gap: "space.200"
    }, spaceEmojiTrigger, onSpaceDetailsSave ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $fb2ff6d69701fe65$var$styles.inlineEditReadViewButton,
        "aria-label": formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).editTitleLabel),
        onClick: startEditingTitle,
        onMouseEnter: ()=>setIsTitleEditButtonVisible(true),
        onMouseLeave: ()=>setIsTitleEditButtonVisible(false),
        onFocus: ()=>setIsTitleEditButtonVisible(true),
        onBlur: hideTitleEditButtonOnBlur,
        testId: "space-title-edit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.editIcon, $fb2ff6d69701fe65$var$styles.hiddenEditButton, isTitleEditButtonVisible && $fb2ff6d69701fe65$var$styles.visibleEditButton),
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, title))), spaceDetailsError && !editingSpaceField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.fieldError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, spaceDetailsError))), editingSpaceField === 'description' && onSpaceDetailsSave ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
        onSubmit: saveSpaceDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.descriptionEditForm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "start",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.editField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        "aria-label": formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).descriptionInputLabel),
        "aria-describedby": spaceDetailsErrorId,
        autoFocus: true,
        maxLength: (0, $98i9C.SPACE_ABOUT_MAX_LENGTH),
        value: draftDescription,
        onChange: (event)=>setDraftDescription(event.currentTarget.value),
        onKeyDown: (event)=>{
            if (event.key === 'Escape') cancelEditingSpaceDetails();
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$InlineEditActionButtons, {
        saveLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).saveDescriptionButton),
        cancelLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).cancelDescriptionButton),
        isSaving: isSavingSpaceDetails,
        onCancel: cancelEditingSpaceDetails
    })), spaceDetailsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.fieldError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: spaceDetailsErrorId,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, spaceDetailsError))))) : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.description
    }, onSpaceDetailsSave ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.inlineEditReadViewButton, $fb2ff6d69701fe65$var$styles.descriptionInlineEditReadViewButton),
        "aria-label": formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).editDescriptionLabel),
        onClick: startEditingDescription,
        onMouseEnter: ()=>setIsDescriptionEditButtonVisible(true),
        onMouseLeave: ()=>setIsDescriptionEditButtonVisible(false),
        onFocus: ()=>setIsDescriptionEditButtonVisible(true),
        onBlur: hideDescriptionEditButtonOnBlur,
        testId: "space-description-edit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.editField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.editIcon, $fb2ff6d69701fe65$var$styles.hiddenEditButton, isDescriptionEditButtonVisible && $fb2ff6d69701fe65$var$styles.visibleEditButton),
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, description)) : isDescriptionLoading ? null : onSpaceDetailsSave ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        onClick: startEditingDescription,
        testId: "space-description-add-button"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addDescriptionButton))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        role: "tablist",
        "aria-label": formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).tabListLabel),
        xcss: $fb2ff6d69701fe65$var$styles.tabBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$TabButton, {
        isActive: activeTab === 'starters',
        label: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).startersTab),
        onClick: ()=>setActiveTab('starters'),
        testId: "tab-starters"
    }), isSpacesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$TabButton, {
        isActive: activeTab === 'chats',
        label: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).chatsTab),
        onClick: ()=>setActiveTab('chats'),
        testId: "tab-chats"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$TabButton, {
        isActive: activeTab === 'sources',
        label: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).sourcesTab),
        onClick: ()=>setActiveTab('sources'),
        testId: "tab-sources"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$TabButton, {
        isActive: activeTab === 'memory',
        label: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).memoryTab),
        onClick: ()=>setActiveTab('memory'),
        testId: "tab-memory"
    })), activeTab === 'starters' && starterCardWithSkillTags, isSpacesEnabled && activeTab === 'chats' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "tabpanel",
        testId: "chats-list"
    }, isChatsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.chatsLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).loadingChatsLabel)
    })) : chats.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.emptyChatsCard,
        testId: "empty-chats-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "img",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a6731d346b10a0d2$exports))),
        alt: "",
        "aria-hidden": "true",
        xcss: $fb2ff6d69701fe65$var$styles.emptyChatsIcon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.emptyChatsText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).noChatsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).noChats, {
        spaceName: title
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.chatList
    }, chats.map((chat)=>{
        const chatTitle = chat.name || formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).untitledChat);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deb50bf6f27fb3b7$export$86e6771ca9311520), {
            key: chat.id,
            conversation: {
                ...chat,
                name: chatTitle
            },
            onConversationSelect: ()=>onChatClick?.(chat),
            isSpinnerOverlayConversationIconEnabled: false,
            hideActions: true,
            cloudId: cloudId,
            testId: "space-chat-item",
            ariaLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).openChatLabel, {
                name: chatTitle
            })
        });
    }))), activeTab === 'sources' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "tabpanel",
        testId: "sources-list"
    }, sources.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.emptySourcesCard,
        testId: "empty-sources-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ZZOa.EmptySourcesState), {
        title: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).noSourcesTitle),
        description: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).noSources),
        headingSize: "medium",
        action: onSourceAdded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c75163609085e392$export$43b333124c26a133), {
            plugins: plugins,
            cloudId: cloudId,
            sources: sources,
            onSourceAdded: handleManualSourceAdded,
            trigger: ({ ref: ref, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    ref: ref,
                    ...triggerProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    appearance: "primary",
                    onClick: onClick,
                    iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
                    testId: "add-sources-button"
                }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addSourcesButton)))
        })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.200",
        alignItems: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.sourceList
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SourceCard, {
            key: source.id,
            source: source,
            onDelete: handleDeleteSource,
            deleteLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).deleteSourceLabel, {
                name: source.title
            }),
            isLast: index === sources.length - 1
        }))), onSourceAdded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c75163609085e392$export$43b333124c26a133), {
        plugins: plugins,
        sources: sources,
        cloudId: cloudId,
        onSourceAdded: handleManualSourceAdded,
        trigger: ({ ref: ref, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ref: ref,
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onClick,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
                testId: "add-sources-button"
            }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addSourcesButton)))
    })))), activeTab === 'memory' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "tabpanel",
        testId: "memory-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.200",
        alignItems: "stretch"
    }, memoriesStoreError !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger",
        testId: "memory-fetch-error"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).loadMemoriesError)), isMemoriesLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.sourceList,
        testId: "memory-loading-skeleton"
    }, [
        0,
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: i,
            xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.sourceCard, i < 2 ? undefined : $fb2ff6d69701fe65$var$styles.noBorderEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px",
            isShimmering: true
        })))) : !memories.length && !isAddingMemory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.emptyMemoriesCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7529bceb40a7c7b$export$59d2ea8d0018ce0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.emptyMemoriesText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).noMemoriesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).noMemories))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: openAddMemory,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        testId: "add-memory-button-empty-state"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addMemoryButton))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, memoryDeleteErrorSpaceId === spaceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger",
        testId: "memory-delete-error"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).deleteMemoryError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.sourceList
    }, memories.map((memory, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$MemoryCard, {
            key: memory.id,
            memory: memory,
            onDelete: handleDeleteMemory,
            deleteLabel: formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).deleteMemoryLabel, {
                text: memory.text
            }),
            isLast: index === arr.length - 1
        }))), isAddingMemory ? // Submission is driven by the native <form> rather than a
    // keydown handler on the input. Form submit is dispatched by
    // the browser to whichever input has focus, so it stays
    // reliable across re-opens of the input (a keydown handler bound
    // to a specific node can become stale when the input is
    // collapsed and re-opened).
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            handleSubmitMemory();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        autoFocus: true,
        value: newMemoryText,
        isInvalid: memorySubmitError !== null,
        onChange: (e)=>{
            setMemorySubmitError(null);
            setNewMemoryText(e.target.value);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Escape') {
                setIsAddingMemory(false);
                setNewMemoryText('');
                setMemorySubmitError(null);
            }
        },
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInline: "space.100",
            paddingBlock: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "submit",
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($kfRNa))),
            appearance: "primary",
            isDisabled: isSubmittingMemory
        }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).submitNewMemory))),
        testId: "new-memory-input"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: openAddMemory,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        testId: "add-memory-button"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).addMemoryButton)))))))), renderChatInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fb2ff6d69701fe65$var$styles.chatInputArea, fullScreen && $fb2ff6d69701fe65$var$styles.chatInputAreaFullScreen)
    }, shouldRenderSmartContextRecommendations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.chatInputInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2ff6d69701fe65$var$SmartContextRecommendationsBannerSlot, {
        key: spaceId,
        spaceId: spaceId,
        cloudId: cloudId,
        variant: fullScreen ? 'inline' : 'stacked',
        onDismissFocusTarget: focusChatInput
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.chatInputInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: chatInputFocusTargetRef
    }, renderChatInput({
        sources: sources,
        onSubmit: handleSubmit,
        zeroSourcesBannerAction: zeroSourcesBannerAction
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.chatInputInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb2ff6d69701fe65$var$styles.aiDisclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: "https://www.atlassian.com/trust/ai",
        xcss: $fb2ff6d69701fe65$var$styles.aiDisclaimerAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $2a8c4b56e08e8f01$export$2e2bcd8739ae039).aiDisclaimer)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        size: "small"
    })))))));
};
const $fb2ff6d69701fe65$export$3308879048226631 = /*#__PURE__*/ (0, $cozmU.memo)($fb2ff6d69701fe65$var$SpaceLandingPageComponent);
function $fb2ff6d69701fe65$var$_temp() {}
function $fb2ff6d69701fe65$var$_temp2(event) {
    event.preventDefault();
}
















const $097f92b99f9e3bb3$var$toSpaceConversation = (conversation, spaceId)=>({
        ...conversation,
        rovoSpaceId: conversation.rovoSpaceId ?? spaceId,
        isEmpty: conversation.isEmpty ?? !conversation.lastMessage?.trim()
    });
const $097f92b99f9e3bb3$var$getTimestamp = (conversation)=>{
    const timestamp = conversation.lastMessageTimestamp ? new Date(conversation.lastMessageTimestamp).getTime() : 0;
    return Number.isNaN(timestamp) ? 0 : timestamp;
};
const $097f92b99f9e3bb3$export$2774f916fd4f7aec = ({ apiConversations: apiConversations, localConversations: localConversations, spaceId: spaceId })=>{
    const localSpaceConversations = localConversations.filter((conversation)=>conversation.rovoSpaceId === spaceId).map((conversation)=>$097f92b99f9e3bb3$var$toSpaceConversation(conversation, spaceId));
    const localById = new Map(localSpaceConversations.map((conversation)=>[
            conversation.id,
            conversation
        ]));
    const localByBackendId = new Map(localSpaceConversations.filter((conversation)=>Boolean(conversation.backendConversationId)).map((conversation)=>[
            conversation.backendConversationId,
            conversation
        ]));
    const consumedLocalIds = new Set();
    const mergedFromApi = apiConversations.map((apiConversation)=>{
        const local = localById.get(apiConversation.id) ?? localByBackendId.get(apiConversation.id);
        if (!local) return apiConversation;
        consumedLocalIds.add(local.id);
        const localLastMessage = local.lastMessage?.trim() ? local.lastMessage : undefined;
        return {
            ...apiConversation,
            name: local.name ?? apiConversation.name,
            lastMessage: localLastMessage ?? apiConversation.lastMessage,
            lastMessageType: local.lastMessageType ?? apiConversation.lastMessageType,
            lastMessageTimestamp: localLastMessage ? local.lastMessageTimestamp ?? apiConversation.lastMessageTimestamp : apiConversation.lastMessageTimestamp,
            lastAgentMessageStatus: local.lastAgentMessageStatus ?? apiConversation.lastAgentMessageStatus,
            agent: local.agent ?? apiConversation.agent,
            readStatus: local.readStatus ?? apiConversation.readStatus,
            scopes: local.scopes ?? apiConversation.scopes,
            tags: local.tags ?? apiConversation.tags,
            currentTask: local.currentTask ?? apiConversation.currentTask
        };
    });
    const localOnly = localSpaceConversations.filter((conversation)=>!consumedLocalIds.has(conversation.id));
    return [
        ...localOnly,
        ...mergedFromApi
    ].sort((a, b)=>$097f92b99f9e3bb3$var$getTimestamp(b) - $097f92b99f9e3bb3$var$getTimestamp(a));
};


const $9445c0a1a0d5ddc5$var$styles = {
    wrapper: "_4bt5LAnQyn _2WAcuGnQyn _2K49XhN91d _3L9DPXN91d _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC",
    wrapperModal: "_3L9DPXIZbP _2O5Vij7dHp _4kiQYAdnbC",
    headerWrapper: "_3YEZNOdnbC",
    scrollableContent: "_2O5Vij7dHp _2WAcuGIZbP _4bt5LAnQyn _4kiQYAdnbC",
    scrollableContentModal: "_2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC",
    spaceContextInputWrapper: "_2YLqiK5zaO"
};
const $9445c0a1a0d5ddc5$var$SpaceLandingPageContainerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(119);
    const { chatRefreshHeader: chatRefreshHeader, selectedSpace: selectedSpace } = t0;
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { siteId: siteId, experienceId: experienceId, productHeader: productHeader, emojiProvider: emojiProvider, orgId: orgId } = (0, $eKjv9.useGlobalConfig)();
    const { clearSelectedSpace: clearSelectedSpace, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [t1] = (0, $n71o5.useChatStore)();
    const { conversations: localConversations } = t1;
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const spaceId = selectedSpace?.id ?? "";
    const [selectedAgentPayload, setSelectedAgentPayload] = (0, $cozmU.useState)(undefined);
    const activeSelectedAgentId = selectedAgentPayload?.id;
    const t2 = selectedAgentPayload?.identityAccountId;
    let t3;
    if ($[0] !== activeSelectedAgentId || $[1] !== spaceId || $[2] !== t2) {
        t3 = {
            conversationId: spaceId,
            activeSelectedAgentId: activeSelectedAgentId,
            selectedAgentIdentityAccountId: t2
        };
        $[0] = activeSelectedAgentId;
        $[1] = spaceId;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const selectedAgentForInputHat = (0, $d4b999848982a7c8$export$e1a98299af461ab)(t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false);
        $[4] = t4;
    } else t4 = $[4];
    const isSpacesEnabled = t4;
    const enabled = isSpacesEnabled && !!selectedSpace?.id;
    let t5;
    if ($[5] !== enabled || $[6] !== experienceId || $[7] !== productHeader || $[8] !== siteId || $[9] !== spaceId) {
        t5 = {
            spaceId: spaceId,
            cloudId: siteId,
            product: productHeader,
            experienceId: experienceId,
            enabled: enabled
        };
        $[5] = enabled;
        $[6] = experienceId;
        $[7] = productHeader;
        $[8] = siteId;
        $[9] = spaceId;
        $[10] = t5;
    } else t5 = $[10];
    const { space: spaceData, isLoading: isSpaceLoading, refetch: refetchSpace } = (0, $1aCne.useGetSpace)(t5);
    const displayedSpaceName = spaceData?.name ?? selectedSpace?.name ?? "";
    const displayedSpaceEmoji = spaceData?.emoji ?? selectedSpace?.emoji ?? "";
    const displayedSpaceDescription = spaceData?.description ?? undefined;
    const t6 = productHeader ?? "rovo";
    const t7 = experienceId ?? "ai-mate";
    let t8;
    if ($[11] !== enabled || $[12] !== siteId || $[13] !== spaceId || $[14] !== t6 || $[15] !== t7) {
        t8 = {
            spaceId: spaceId,
            cloudId: siteId,
            product: t6,
            experienceId: t7,
            enabled: enabled
        };
        $[11] = enabled;
        $[12] = siteId;
        $[13] = spaceId;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    const { conversationPage: conversationPage, isLoading: isChatsLoading } = (0, $00719b79ddea4cb7$export$fa8943ec3a6d0129)(t8);
    let t9;
    if ($[17] !== experienceId || $[18] !== productHeader || $[19] !== siteId || $[20] !== spaceId) {
        t9 = {
            spaceId: spaceId,
            cloudId: siteId,
            product: productHeader,
            experienceId: experienceId
        };
        $[17] = experienceId;
        $[18] = productHeader;
        $[19] = siteId;
        $[20] = spaceId;
        $[21] = t9;
    } else t9 = $[21];
    const { addSource: addSource } = (0, $jqWbJ.useAddSpaceSource)(t9);
    let t10;
    if ($[22] !== experienceId || $[23] !== productHeader || $[24] !== siteId || $[25] !== spaceId) {
        t10 = {
            spaceId: spaceId,
            cloudId: siteId,
            product: productHeader,
            experienceId: experienceId
        };
        $[22] = experienceId;
        $[23] = productHeader;
        $[24] = siteId;
        $[25] = spaceId;
        $[26] = t10;
    } else t10 = $[26];
    const { deleteSource: deleteSource } = (0, $b1E2G.useDeleteSpaceSource)(t10);
    const t11 = productHeader ?? "rovo";
    const t12 = experienceId ?? "ai-mate";
    let t13;
    if ($[27] !== siteId || $[28] !== spaceId || $[29] !== t11 || $[30] !== t12) {
        t13 = {
            spaceId: spaceId,
            cloudId: siteId,
            product: t11,
            experienceId: t12
        };
        $[27] = siteId;
        $[28] = spaceId;
        $[29] = t11;
        $[30] = t12;
        $[31] = t13;
    } else t13 = $[31];
    const { mutate: updateSpace } = (0, $lchoD.useUpdateSpace)(t13);
    let t14;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = [];
        $[32] = t14;
    } else t14 = $[32];
    const [optimisticSources, setOptimisticSources] = (0, $cozmU.useState)(t14);
    let t15;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = new Set();
        $[33] = t15;
    } else t15 = $[33];
    const [optimisticDeletedSourceIds, setOptimisticDeletedSourceIds] = (0, $cozmU.useState)(t15);
    let t16;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setOptimisticSources([]);
            setOptimisticDeletedSourceIds(new Set());
            setSelectedAgentPayload(undefined);
        };
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== spaceId) {
        t17 = [
            spaceId
        ];
        $[35] = spaceId;
        $[36] = t17;
    } else t17 = $[36];
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    let t19;
    if ($[37] !== spaceData) {
        t18 = ()=>{
            if (!spaceData?.sources) return;
            const serverUrls = new Set(spaceData.sources.map($9445c0a1a0d5ddc5$var$_temp));
            setOptimisticSources((prev)=>prev.filter((s_0)=>!serverUrls.has(s_0.url)));
        };
        t19 = [
            spaceData
        ];
        $[37] = spaceData;
        $[38] = t18;
        $[39] = t19;
    } else {
        t18 = $[38];
        t19 = $[39];
    }
    (0, $cozmU.useEffect)(t18, t19);
    let t20;
    if ($[40] !== spaceData?.starters) {
        t20 = spaceData?.starters?.map($9445c0a1a0d5ddc5$var$_temp2) ?? [];
        $[40] = spaceData?.starters;
        $[41] = t20;
    } else t20 = $[41];
    const starters = t20;
    let t21;
    if ($[42] !== optimisticDeletedSourceIds || $[43] !== optimisticSources || $[44] !== spaceData?.sources) {
        let t22;
        if ($[46] !== optimisticDeletedSourceIds) {
            t22 = (s_4)=>!optimisticDeletedSourceIds.has(s_4.id) && !optimisticDeletedSourceIds.has(s_4.url);
            $[46] = optimisticDeletedSourceIds;
            $[47] = t22;
        } else t22 = $[47];
        t21 = [
            ...spaceData?.sources?.filter((s_2)=>!optimisticDeletedSourceIds.has(s_2.id)).map($9445c0a1a0d5ddc5$var$_temp3) ?? [],
            ...optimisticSources.filter(t22)
        ];
        $[42] = optimisticDeletedSourceIds;
        $[43] = optimisticSources;
        $[44] = spaceData?.sources;
        $[45] = t21;
    } else t21 = $[45];
    const sources = t21;
    const areSourcesKnown = !isSpaceLoading && Boolean(spaceData) || optimisticSources.length > 0;
    let t22;
    if ($[48] !== conversationPage?.conversations || $[49] !== localConversations || $[50] !== spaceId) {
        t22 = (0, $097f92b99f9e3bb3$export$2774f916fd4f7aec)({
            apiConversations: conversationPage?.conversations ?? [],
            localConversations: Object.values(localConversations),
            spaceId: spaceId
        });
        $[48] = conversationPage?.conversations;
        $[49] = localConversations;
        $[50] = spaceId;
        $[51] = t22;
    } else t22 = $[51];
    const chats = t22;
    let t23;
    if ($[52] !== publish || $[53] !== selectedSpace) {
        t23 = (starter)=>{
            if (!selectedSpace) return;
            publish({
                type: "chat-new",
                source: "space-landing-starter",
                data: {
                    prompt: starter.text,
                    dialogues: [],
                    resetActiveMenu: true,
                    spaceId: selectedSpace.id,
                    isPromptPlaceholder: true,
                    placeholderType: "skill"
                }
            });
        };
        $[52] = publish;
        $[53] = selectedSpace;
        $[54] = t23;
    } else t23 = $[54];
    const handleStarterClick = t23;
    let t24;
    if ($[55] !== publish || $[56] !== selectedSpace) {
        t24 = (params)=>{
            if (!selectedSpace) return;
            publish({
                type: "chat-new",
                source: "space-landing-chat-input",
                data: {
                    prompt: params.prompt,
                    dialogues: [],
                    resetActiveMenu: true,
                    spaceId: selectedSpace.id,
                    ...params.agentId ? {
                        agentId: params.agentId
                    } : {},
                    mode: {
                        deepResearchEnabled: params.deepResearchEnabled,
                        thinkDeeperEnabled: params.thinkDeeperEnabled,
                        fastModeEnabled: params.fastModeEnabled,
                        webSearchEnabled: params.webSearchEnabled,
                        sourceMode: params.sourceMode
                    }
                }
            });
        };
        $[55] = publish;
        $[56] = selectedSpace;
        $[57] = t24;
    } else t24 = $[57];
    const handleChatSubmit = t24;
    let t25;
    if ($[58] !== clearSelectedSpace || $[59] !== setActiveMenu || $[60] !== setSelectedConversation) {
        t25 = (chat)=>{
            clearSelectedSpace();
            setSelectedConversation({
                conversationId: chat.id,
                conversationMetadata: chat
            });
            setActiveMenu("none");
        };
        $[58] = clearSelectedSpace;
        $[59] = setActiveMenu;
        $[60] = setSelectedConversation;
        $[61] = t25;
    } else t25 = $[61];
    const handleChatClick = t25;
    let t26;
    if ($[62] !== displayedSpaceEmoji || $[63] !== refetchSpace || $[64] !== updateSpace) {
        t26 = async (t27)=>{
            const { title: nextTitle, description: nextDescription, emoji: nextEmoji } = t27;
            let updateError;
            await updateSpace({
                name: nextTitle,
                description: nextDescription,
                emoji: (nextEmoji ?? displayedSpaceEmoji) || null
            }, {
                onError: (error)=>{
                    updateError = error;
                }
            });
            if (updateError) throw updateError instanceof Error ? updateError : new Error(String(updateError));
            try {
                await refetchSpace();
            } catch  {}
        };
        $[62] = displayedSpaceEmoji;
        $[63] = refetchSpace;
        $[64] = updateSpace;
        $[65] = t26;
    } else t26 = $[65];
    const handleSpaceDetailsSave = t26;
    const t27 = productHeader ?? "rovo";
    const t28 = siteId ?? "";
    let t29;
    if ($[66] !== t27 || $[67] !== t28) {
        t29 = {
            product: t27,
            experienceId: "rovo-spaces",
            touchpointSource: "space-landing-page",
            siteId: t28
        };
        $[66] = t27;
        $[67] = t28;
        $[68] = t29;
    } else t29 = $[68];
    const assistanceServiceParams = t29;
    let t30;
    if ($[69] !== areSourcesKnown || $[70] !== assistanceServiceParams || $[71] !== formatMessage || $[72] !== orgId || $[73] !== productHeader || $[74] !== selectedAgentForInputHat || $[75] !== siteId || $[76] !== spaceId) {
        t30 = (t31)=>{
            const { sources: chatInputSources, onSubmit: onSubmit, zeroSourcesBannerAction: zeroSourcesBannerAction } = t31;
            const handlePromptSubmit = (prompt, mode)=>onSubmit({
                    prompt: prompt,
                    deepResearchEnabled: mode.deepResearchEnabled,
                    thinkDeeperEnabled: mode.thinkDeeperEnabled,
                    fastModeEnabled: mode.fastModeEnabled,
                    webSearchEnabled: mode.webSearchEnabled,
                    sourceMode: mode.sourceMode,
                    agentId: mode.inputSelectedAgentId
                });
            const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $9445c0a1a0d5ddc5$var$styles.spaceContextInputWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eqaf.RovoChatPromptInput), {
                ref: null,
                isConversationAgentic: false,
                assistanceServiceParams: assistanceServiceParams,
                arrowKeyPluginConfigMessages: [],
                productKey: productHeader ?? "rovo",
                siteId: siteId ?? "",
                orgId: orgId,
                isAgentTyping: false,
                promptDraftAndModeKey: spaceId,
                isSpaceScopedConversation: true,
                spaceSourceCount: areSourcesKnown ? chatInputSources.length : undefined,
                spaceSources: chatInputSources.map($9445c0a1a0d5ddc5$var$_temp4),
                zeroSourcesAction: zeroSourcesBannerAction,
                clearModeOnSubmit: true,
                onSubmit: handlePromptSubmit,
                onAbort: $9445c0a1a0d5ddc5$var$_temp5,
                adaptiveHeight: true,
                enableAgentMentions: isMentionAgentsExperimentEnabled,
                onSelectedAgentChange: setSelectedAgentPayload,
                selectedAgentForInputHat: selectedAgentForInputHat,
                disabledAgentTooltip: isMentionAgentsExperimentEnabled ? formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputDisabledAgentTooltip) : undefined,
                disableWrapperMarginStyles: true,
                enableAppsDiscoveryUi: true
            }));
        };
        $[69] = areSourcesKnown;
        $[70] = assistanceServiceParams;
        $[71] = formatMessage;
        $[72] = orgId;
        $[73] = productHeader;
        $[74] = selectedAgentForInputHat;
        $[75] = siteId;
        $[76] = spaceId;
        $[77] = t30;
    } else t30 = $[77];
    const renderChatInput = t30;
    let t31;
    if ($[78] !== deleteSource || $[79] !== refetchSpace) {
        t31 = async (source)=>{
            setOptimisticDeletedSourceIds((prev_0)=>new Set([
                    ...prev_0,
                    source.id
                ]));
            try {
                await deleteSource(source.id);
                setOptimisticSources((prev_2)=>prev_2.filter((s_6)=>s_6.id !== source.id && s_6.url !== source.url));
                try {
                    await refetchSpace();
                } catch  {}
                setOptimisticDeletedSourceIds((prev_3)=>{
                    const next_0 = new Set(prev_3);
                    next_0.delete(source.id);
                    return next_0;
                });
            } catch (t32) {
                const error_0 = t32;
                setOptimisticDeletedSourceIds((prev_1)=>{
                    const next = new Set(prev_1);
                    next.delete(source.id);
                    return next;
                });
                (0, $hlvTd.logSentryConsoleError)("Failed to delete source from space", error_0);
            }
        };
        $[78] = deleteSource;
        $[79] = refetchSpace;
        $[80] = t31;
    } else t31 = $[80];
    const handleDeleteSource = t31;
    let t32;
    if ($[81] !== addSource || $[82] !== refetchSpace) {
        t32 = async (source_0)=>{
            setOptimisticSources((prev_4)=>[
                    ...prev_4,
                    source_0
                ]);
            try {
                await addSource({
                    url: source_0.url,
                    name: source_0.title,
                    sourceType: source_0.sourceType
                });
            } catch (t33) {
                const error_1 = t33;
                setOptimisticSources((prev_5)=>prev_5.filter((s_7)=>s_7.id !== source_0.id));
                (0, $hlvTd.logSentryConsoleError)("Failed to add source to space", error_1);
                return;
            }
            try {
                await refetchSpace();
            } catch  {}
        };
        $[81] = addSource;
        $[82] = refetchSpace;
        $[83] = t32;
    } else t32 = $[83];
    const handleSourceAdded = t32;
    if (!isSpacesEnabled || !selectedSpace) return null;
    const t33 = !fullScreen && $9445c0a1a0d5ddc5$var$styles.wrapperModal;
    let t34;
    if ($[84] !== t33) {
        t34 = (0, $w6R6I.cx)($9445c0a1a0d5ddc5$var$styles.wrapper, t33);
        $[84] = t33;
        $[85] = t34;
    } else t34 = $[85];
    let t35;
    if ($[86] !== chatRefreshHeader || $[87] !== fullScreen) {
        t35 = !fullScreen && chatRefreshHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9445c0a1a0d5ddc5$var$styles.headerWrapper
        }, chatRefreshHeader);
        $[86] = chatRefreshHeader;
        $[87] = fullScreen;
        $[88] = t35;
    } else t35 = $[88];
    const t36 = !fullScreen && $9445c0a1a0d5ddc5$var$styles.scrollableContentModal;
    let t37;
    if ($[89] !== t36) {
        t37 = (0, $w6R6I.cx)($9445c0a1a0d5ddc5$var$styles.scrollableContent, t36);
        $[89] = t36;
        $[90] = t37;
    } else t37 = $[90];
    const t38 = isSpaceLoading && !displayedSpaceDescription;
    let t39;
    if ($[91] !== chats || $[92] !== displayedSpaceDescription || $[93] !== displayedSpaceEmoji || $[94] !== displayedSpaceName || $[95] !== emojiProvider || $[96] !== fullScreen || $[97] !== handleChatClick || $[98] !== handleChatSubmit || $[99] !== handleDeleteSource || $[100] !== handleSourceAdded || $[101] !== handleSpaceDetailsSave || $[102] !== handleStarterClick || $[103] !== isChatsLoading || $[104] !== renderChatInput || $[105] !== selectedSpace.entryPoint || $[106] !== selectedSpace.id || $[107] !== siteId || $[108] !== sources || $[109] !== starters || $[110] !== t38) {
        t39 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb2ff6d69701fe65$export$3308879048226631), {
            fullScreen: fullScreen,
            spaceId: selectedSpace.id,
            cloudId: siteId,
            emojiProvider: emojiProvider,
            emoji: displayedSpaceEmoji,
            title: displayedSpaceName,
            entryPoint: selectedSpace.entryPoint,
            description: displayedSpaceDescription,
            isDescriptionLoading: t38,
            onSpaceDetailsSave: handleSpaceDetailsSave,
            starters: starters,
            sources: sources,
            chats: chats,
            isChatsLoading: isChatsLoading,
            onStarterClick: handleStarterClick,
            onChatClick: handleChatClick,
            onChatSubmit: handleChatSubmit,
            renderChatInput: renderChatInput,
            onDeleteSource: handleDeleteSource,
            onSourceAdded: handleSourceAdded
        });
        $[91] = chats;
        $[92] = displayedSpaceDescription;
        $[93] = displayedSpaceEmoji;
        $[94] = displayedSpaceName;
        $[95] = emojiProvider;
        $[96] = fullScreen;
        $[97] = handleChatClick;
        $[98] = handleChatSubmit;
        $[99] = handleDeleteSource;
        $[100] = handleSourceAdded;
        $[101] = handleSpaceDetailsSave;
        $[102] = handleStarterClick;
        $[103] = isChatsLoading;
        $[104] = renderChatInput;
        $[105] = selectedSpace.entryPoint;
        $[106] = selectedSpace.id;
        $[107] = siteId;
        $[108] = sources;
        $[109] = starters;
        $[110] = t38;
        $[111] = t39;
    } else t39 = $[111];
    let t40;
    if ($[112] !== t37 || $[113] !== t39) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t37
        }, t39);
        $[112] = t37;
        $[113] = t39;
        $[114] = t40;
    } else t40 = $[114];
    let t41;
    if ($[115] !== t34 || $[116] !== t35 || $[117] !== t40) {
        t41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: t34
        }, t35, t40);
        $[115] = t34;
        $[116] = t35;
        $[117] = t40;
        $[118] = t41;
    } else t41 = $[118];
    return t41;
} : ({ chatRefreshHeader: chatRefreshHeader, selectedSpace: selectedSpace })=>{
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const { siteId: siteId, experienceId: experienceId, productHeader: productHeader, emojiProvider: emojiProvider, orgId: orgId } = (0, $eKjv9.useGlobalConfig)();
    const { clearSelectedSpace: clearSelectedSpace, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ conversations: localConversations }] = (0, $n71o5.useChatStore)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const spaceId = selectedSpace?.id ?? '';
    const [selectedAgentPayload, setSelectedAgentPayload] = (0, $cozmU.useState)(undefined);
    const activeSelectedAgentId = selectedAgentPayload?.id;
    const selectedAgentForInputHat = (0, $d4b999848982a7c8$export$e1a98299af461ab)({
        conversationId: spaceId,
        activeSelectedAgentId: activeSelectedAgentId,
        selectedAgentIdentityAccountId: selectedAgentPayload?.identityAccountId
    });
    const isSpacesEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false);
    const enabled = isSpacesEnabled && !!selectedSpace?.id;
    const { space: spaceData, isLoading: isSpaceLoading, refetch: refetchSpace } = (0, $1aCne.useGetSpace)({
        spaceId: spaceId,
        cloudId: siteId,
        product: productHeader,
        experienceId: experienceId,
        enabled: enabled
    });
    const displayedSpaceName = spaceData?.name ?? selectedSpace?.name ?? '';
    const displayedSpaceEmoji = spaceData?.emoji ?? selectedSpace?.emoji ?? '';
    const displayedSpaceDescription = spaceData?.description ?? undefined;
    const { conversationPage: conversationPage, isLoading: isChatsLoading } = (0, $00719b79ddea4cb7$export$fa8943ec3a6d0129)({
        spaceId: spaceId,
        cloudId: siteId,
        product: productHeader ?? 'rovo',
        experienceId: experienceId ?? 'ai-mate',
        enabled: enabled
    });
    const { addSource: addSource } = (0, $jqWbJ.useAddSpaceSource)({
        spaceId: spaceId,
        cloudId: siteId,
        product: productHeader,
        experienceId: experienceId
    });
    const { deleteSource: deleteSource } = (0, $b1E2G.useDeleteSpaceSource)({
        spaceId: spaceId,
        cloudId: siteId,
        product: productHeader,
        experienceId: experienceId
    });
    const { mutate: updateSpace } = (0, $lchoD.useUpdateSpace)({
        spaceId: spaceId,
        cloudId: siteId,
        product: productHeader ?? 'rovo',
        experienceId: experienceId ?? 'ai-mate'
    });
    const [optimisticSources, setOptimisticSources] = (0, $cozmU.useState)([]);
    const [optimisticDeletedSourceIds, setOptimisticDeletedSourceIds] = (0, $cozmU.useState)(new Set());
    (0, $cozmU.useEffect)(()=>{
        setOptimisticSources([]);
        setOptimisticDeletedSourceIds(new Set());
        setSelectedAgentPayload(undefined);
    }, [
        spaceId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!spaceData?.sources) return;
        const serverUrls = new Set(spaceData.sources.map((s)=>s.url));
        setOptimisticSources((prev)=>prev.filter((s_0)=>!serverUrls.has(s_0.url)));
    }, [
        spaceData
    ]);
    const starters = (0, $cozmU.useMemo)(()=>spaceData?.starters?.map((s_1)=>({
                id: s_1.id,
                text: s_1.text
            })) ?? [], [
        spaceData
    ]);
    const sources = (0, $cozmU.useMemo)(()=>[
            ...spaceData?.sources?.filter((s_2)=>!optimisticDeletedSourceIds.has(s_2.id)).map((s_3)=>({
                    id: s_3.id,
                    title: s_3.name ?? s_3.url,
                    url: s_3.url,
                    sourceType: s_3.sourceType
                })) ?? [],
            ...optimisticSources.filter((s_4)=>!optimisticDeletedSourceIds.has(s_4.id) && !optimisticDeletedSourceIds.has(s_4.url))
        ], [
        spaceData,
        optimisticSources,
        optimisticDeletedSourceIds
    ]);
    const areSourcesKnown = !isSpaceLoading && Boolean(spaceData) || optimisticSources.length > 0;
    const chats = (0, $cozmU.useMemo)(()=>(0, $097f92b99f9e3bb3$export$2774f916fd4f7aec)({
            apiConversations: conversationPage?.conversations ?? [],
            localConversations: Object.values(localConversations),
            spaceId: spaceId
        }), [
        conversationPage,
        localConversations,
        spaceId
    ]);
    const handleStarterClick = (0, $cozmU.useCallback)((starter)=>{
        if (!selectedSpace) return;
        publish({
            type: 'chat-new',
            source: 'space-landing-starter',
            data: {
                prompt: starter.text,
                dialogues: [],
                resetActiveMenu: true,
                spaceId: selectedSpace.id,
                isPromptPlaceholder: true,
                placeholderType: 'skill'
            }
        });
    }, [
        publish,
        selectedSpace
    ]);
    const handleChatSubmit = (0, $cozmU.useCallback)((params)=>{
        if (!selectedSpace) return;
        publish({
            type: 'chat-new',
            source: 'space-landing-chat-input',
            data: {
                prompt: params.prompt,
                dialogues: [],
                resetActiveMenu: true,
                spaceId: selectedSpace.id,
                ...params.agentId ? {
                    agentId: params.agentId
                } : {},
                mode: {
                    deepResearchEnabled: params.deepResearchEnabled,
                    thinkDeeperEnabled: params.thinkDeeperEnabled,
                    fastModeEnabled: params.fastModeEnabled,
                    webSearchEnabled: params.webSearchEnabled,
                    sourceMode: params.sourceMode
                }
            }
        });
    }, [
        publish,
        selectedSpace
    ]);
    const handleChatClick = (0, $cozmU.useCallback)((chat)=>{
        clearSelectedSpace();
        setSelectedConversation({
            conversationId: chat.id,
            conversationMetadata: chat
        });
        setActiveMenu('none');
    }, [
        clearSelectedSpace,
        setActiveMenu,
        setSelectedConversation
    ]);
    const handleSpaceDetailsSave = (0, $cozmU.useCallback)(async ({ title: nextTitle, description: nextDescription, emoji: nextEmoji })=>{
        let updateError;
        await updateSpace({
            name: nextTitle,
            description: nextDescription,
            emoji: (nextEmoji ?? displayedSpaceEmoji) || null
        }, {
            onError: (error)=>{
                updateError = error;
            }
        });
        if (updateError) throw updateError instanceof Error ? updateError : new Error(String(updateError));
        try {
            await refetchSpace();
        } catch  {
        // make a successful inline edit look failed.
        }
    }, [
        displayedSpaceEmoji,
        refetchSpace,
        updateSpace
    ]); // Builds the chat prompt input that SpaceLandingPage embeds below the page
    // content. Hosted here (rather than inside SpaceLandingPage itself) to keep
    // `rovo-spaces` independent of `conversation-assistant-chat-prompt-input`
    // and avoid the package dependency cycle.
    const assistanceServiceParams = (0, $cozmU.useMemo)(()=>({
            product: productHeader ?? 'rovo',
            experienceId: 'rovo-spaces',
            touchpointSource: 'space-landing-page',
            siteId: siteId ?? ''
        }), [
        productHeader,
        siteId
    ]);
    const renderChatInput = (0, $cozmU.useCallback)(({ sources: chatInputSources, onSubmit: onSubmit, zeroSourcesBannerAction: zeroSourcesBannerAction })=>{
        const handlePromptSubmit = (prompt, mode)=>onSubmit({
                prompt: prompt,
                deepResearchEnabled: mode.deepResearchEnabled,
                thinkDeeperEnabled: mode.thinkDeeperEnabled,
                fastModeEnabled: mode.fastModeEnabled,
                webSearchEnabled: mode.webSearchEnabled,
                sourceMode: mode.sourceMode,
                agentId: mode.inputSelectedAgentId
            });
        const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9445c0a1a0d5ddc5$var$styles.spaceContextInputWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eqaf.RovoChatPromptInput), {
            ref: null,
            isConversationAgentic: false,
            assistanceServiceParams: assistanceServiceParams,
            arrowKeyPluginConfigMessages: [],
            productKey: productHeader ?? 'rovo',
            siteId: siteId ?? '',
            orgId: orgId,
            isAgentTyping: false,
            promptDraftAndModeKey: spaceId,
            isSpaceScopedConversation: true,
            spaceSourceCount: areSourcesKnown ? chatInputSources.length : undefined,
            spaceSources: chatInputSources.map((s_5)=>({
                    id: s_5.id,
                    ari: s_5.url,
                    url: s_5.url,
                    sourceType: s_5.sourceType ?? '',
                    name: s_5.title
                })),
            zeroSourcesAction: zeroSourcesBannerAction,
            clearModeOnSubmit: true,
            onSubmit: handlePromptSubmit,
            onAbort: ()=>{},
            adaptiveHeight: true,
            enableAgentMentions: isMentionAgentsExperimentEnabled,
            onSelectedAgentChange: setSelectedAgentPayload,
            selectedAgentForInputHat: selectedAgentForInputHat,
            disabledAgentTooltip: isMentionAgentsExperimentEnabled ? formatMessage((0, $8a6f44cdd8572770$export$2e2bcd8739ae039).chatInputDisabledAgentTooltip) : undefined,
            disableWrapperMarginStyles: true // Opt the Rovo Spaces landing page chat input into apps discovery UI
            ,
            // (limited unconnected apps, "Discover more apps" footer).
            enableAppsDiscoveryUi: true
        }));
    }, [
        assistanceServiceParams,
        areSourcesKnown,
        productHeader,
        siteId,
        orgId,
        formatMessage,
        selectedAgentForInputHat,
        spaceId,
        setSelectedAgentPayload
    ]);
    const handleDeleteSource = (0, $cozmU.useCallback)(async (source)=>{
        setOptimisticDeletedSourceIds((prev_0)=>new Set([
                ...prev_0,
                source.id
            ]));
        try {
            await deleteSource(source.id);
            setOptimisticSources((prev_2)=>prev_2.filter((s_6)=>s_6.id !== source.id && s_6.url !== source.url));
            try {
                await refetchSpace();
            } catch  {}
            setOptimisticDeletedSourceIds((prev_3)=>{
                const next_0 = new Set(prev_3);
                next_0.delete(source.id);
                return next_0;
            });
        } catch (error_0) {
            setOptimisticDeletedSourceIds((prev_1)=>{
                const next = new Set(prev_1);
                next.delete(source.id);
                return next;
            });
            (0, $hlvTd.logSentryConsoleError)('Failed to delete source from space', error_0);
        }
    }, [
        deleteSource,
        refetchSpace
    ]);
    const handleSourceAdded = (0, $cozmU.useCallback)(async (source_0)=>{
        setOptimisticSources((prev_4)=>[
                ...prev_4,
                source_0
            ]);
        try {
            await addSource({
                url: source_0.url,
                name: source_0.title,
                sourceType: source_0.sourceType
            });
        } catch (error_1) {
            setOptimisticSources((prev_5)=>prev_5.filter((s_7)=>s_7.id !== source_0.id));
            (0, $hlvTd.logSentryConsoleError)('Failed to add source to space', error_1);
            return;
        }
        try {
            await refetchSpace();
        } catch  {
        // and the optimistic copy keeps the UI in sync until the next refetch.
        }
    }, [
        addSource,
        refetchSpace
    ]);
    if (!isSpacesEnabled || !selectedSpace) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($9445c0a1a0d5ddc5$var$styles.wrapper, !fullScreen && $9445c0a1a0d5ddc5$var$styles.wrapperModal)
    }, !fullScreen && chatRefreshHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9445c0a1a0d5ddc5$var$styles.headerWrapper
    }, chatRefreshHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($9445c0a1a0d5ddc5$var$styles.scrollableContent, !fullScreen && $9445c0a1a0d5ddc5$var$styles.scrollableContentModal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb2ff6d69701fe65$export$3308879048226631), {
        fullScreen: fullScreen,
        spaceId: selectedSpace.id,
        cloudId: siteId,
        emojiProvider: emojiProvider,
        emoji: displayedSpaceEmoji,
        title: displayedSpaceName,
        entryPoint: selectedSpace.entryPoint,
        description: displayedSpaceDescription,
        isDescriptionLoading: isSpaceLoading && !displayedSpaceDescription,
        onSpaceDetailsSave: handleSpaceDetailsSave,
        starters: starters,
        sources: sources,
        chats: chats,
        isChatsLoading: isChatsLoading,
        onStarterClick: handleStarterClick,
        onChatClick: handleChatClick,
        onChatSubmit: handleChatSubmit,
        renderChatInput: renderChatInput,
        onDeleteSource: handleDeleteSource,
        onSourceAdded: handleSourceAdded
    })));
};
// rovo_ttai_segment_render_stabilization: absorb parent render waves when props are stable.
const $9445c0a1a0d5ddc5$var$MemoizedSpaceLandingPageContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($9445c0a1a0d5ddc5$var$SpaceLandingPageContainerComponent, (0, $dqxOF.shallowEqualObjects)); // rovo_ttai_segment_render_stabilization ON: subscribe to `selectedSpace` via the
// narrow selector so the component only re-renders when `selectedSpace` changes,
// rather than on every UI-store state change.
const $9445c0a1a0d5ddc5$var$SpaceLandingPageContainerWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useSelectedSpaceSelector));
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9445c0a1a0d5ddc5$var$MemoizedSpaceLandingPageContainer, {
        ...props,
        selectedSpace: selectedSpace
    });
}; // rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the component re-rendered on any
// UI-store state change.
const $9445c0a1a0d5ddc5$var$SpaceLandingPageContainerWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { selectedSpace: selectedSpace } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9445c0a1a0d5ddc5$var$SpaceLandingPageContainerComponent, {
        ...props,
        selectedSpace: selectedSpace
    });
};
const $9445c0a1a0d5ddc5$export$308b812199c62019 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9445c0a1a0d5ddc5$var$SpaceLandingPageContainerWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9445c0a1a0d5ddc5$var$SpaceLandingPageContainerWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9445c0a1a0d5ddc5$var$SpaceLandingPageContainerWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9445c0a1a0d5ddc5$var$SpaceLandingPageContainerWithBroadStore, props);
};
function $9445c0a1a0d5ddc5$var$_temp(s) {
    return s.url;
}
function $9445c0a1a0d5ddc5$var$_temp2(s_1) {
    return {
        id: s_1.id,
        text: s_1.text
    };
}
function $9445c0a1a0d5ddc5$var$_temp3(s_3) {
    return {
        id: s_3.id,
        title: s_3.name ?? s_3.url,
        url: s_3.url,
        sourceType: s_3.sourceType
    };
}
function $9445c0a1a0d5ddc5$var$_temp4(s_5) {
    return {
        id: s_5.id,
        ari: s_5.url,
        url: s_5.url,
        sourceType: s_5.sourceType ?? "",
        name: s_5.title
    };
}
function $9445c0a1a0d5ddc5$var$_temp5() {}












var $jTt8P = parcelRequire("jTt8P");




























const $b09eb397c6c150a2$var$getSkillSlug = ()=>(0, $iDrrr.fg)('sltns-1160-rename-to-build-agent') ? 'build-agent' : 'build-rovo-agent';
const $b09eb397c6c150a2$var$getSkillPrompt = ()=>`/${$b09eb397c6c150a2$var$getSkillSlug()}`;
// clearPlaceholder() only clears pending placeholder state, not content already
// applied to the editor — clearing the input requires replacing it with this instead.
const $b09eb397c6c150a2$var$EMPTY_CHAT_INPUT_ADF = {
    type: 'doc',
    version: 1,
    content: [
        {
            type: 'paragraph'
        }
    ]
};
const $b09eb397c6c150a2$var$adfHasSkill = (adfValue)=>{
    let hasSkill = false;
    const skillSlug = $b09eb397c6c150a2$var$getSkillSlug();
    (0, $jTt8P.traverse)(adfValue, {
        text: (node)=>{
            if (hasSkill) return false;
            if ($b09eb397c6c150a2$var$textHasSkill(node.text)) {
                hasSkill = true;
                return false;
            }
        },
        inlineExtension: (node)=>{
            if (hasSkill) return false;
            if (node.attrs?.extensionKey === (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.extensionType === (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE) && node.attrs?.parameters?.slug === skillSlug) {
                hasSkill = true;
                return false;
            }
        }
    });
    return hasSkill;
};
const $b09eb397c6c150a2$var$textHasSkill = (text)=>{
    if (!text) return false;
    const skillPrompt = $b09eb397c6c150a2$var$getSkillPrompt();
    const index = text.indexOf(skillPrompt);
    if (index === -1) return false;
    return text[index + skillPrompt.length] === ' ' || index + skillPrompt.length === text.length;
};
function $b09eb397c6c150a2$var$getMessageHasSkill(message) {
    if (!(0, $igOtY.isStoreHuman)(message)) return false;
    const { content: content } = message.content;
    if (typeof content === 'string') return $b09eb397c6c150a2$var$textHasSkill(content);
    else return $b09eb397c6c150a2$var$adfHasSkill(content);
}
const $b09eb397c6c150a2$var$isDraftMessageEmpty = (draftMessage)=>{
    if (draftMessage === null || draftMessage === undefined) return true;
    return !draftMessage.content || draftMessage.content.length === 0;
};
const $b09eb397c6c150a2$var$StickySkillListenerInner = ({ conversationId: conversationId })=>{
    const skillPrompt = $b09eb397c6c150a2$var$getSkillPrompt();
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId
    });
    const firstMessage = messages.at(0);
    const { draftMessage: draftMessage } = (0, $j4TFB.useDraftsController)(conversationId);
    const { insertPlaceholder: insertPlaceholder, insertPlaceholderWithAdf: insertPlaceholderWithAdf } = (0, $iDlFY.useEditorPlaceholder)();
    const [lastInsertMessageCount, setLastInsertMessageCount] = (0, $cozmU.useState)(-1);
    const messageCount = (0, $cozmU.useMemo)(()=>{
        return messages.filter((m)=>m.type === 'HUMAN').length;
    }, [
        messages
    ]);
    const messageHasSkill = (0, $cozmU.useMemo)(()=>{
        if (!firstMessage) return false;
        return $b09eb397c6c150a2$var$getMessageHasSkill(firstMessage);
    }, [
        firstMessage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!messageHasSkill) return;
        if (lastInsertMessageCount === messageCount) return;
        if (!$b09eb397c6c150a2$var$isDraftMessageEmpty(draftMessage)) return;
        setLastInsertMessageCount(messageCount);
        insertPlaceholder(`${skillPrompt} `, 'skill');
    }, [
        draftMessage,
        messageHasSkill,
        lastInsertMessageCount,
        messageCount,
        insertPlaceholder,
        skillPrompt
    ]);
    // Read by the unmount cleanup below, which must only run once (on unmount).
    const latestRef = (0, $cozmU.useRef)({
        messageHasSkill: messageHasSkill,
        draftMessage: draftMessage
    });
    latestRef.current = {
        messageHasSkill: messageHasSkill,
        draftMessage: draftMessage
    };
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo_chat_clear_sticky_skill_on_unmount')) return;
        // On unmount (leaving this conversation), clear a still-untouched sticky
        // skill prompt so it doesn't carry over into the next conversation.
        return ()=>{
            const { messageHasSkill: messageHasSkill_0, draftMessage: draftMessage_0 } = latestRef.current;
            if (!messageHasSkill_0 || !draftMessage_0) return;
            if (!$b09eb397c6c150a2$var$adfHasSkill(draftMessage_0)) return;
            insertPlaceholderWithAdf('', $b09eb397c6c150a2$var$EMPTY_CHAT_INPUT_ADF);
        };
    }, [
        insertPlaceholderWithAdf
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).LOAD_STICKY_SKILL_LISTENER
    });
};
const $b09eb397c6c150a2$var$EmptyFallback = ()=>null;
const $b09eb397c6c150a2$export$124401e4557bee1f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { conversationId: conversationId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b09eb397c6c150a2$var$EmptyFallback, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).LOAD_STICKY_SKILL_LISTENER
        });
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== conversationId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyWKg.ErrorBoundary), {
            fallback: t1,
            experienceName: (0, $irnO2.ExperienceName).LOAD_STICKY_SKILL_LISTENER
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b09eb397c6c150a2$var$StickySkillListenerInner, {
            conversationId: conversationId
        }));
        $[2] = conversationId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ conversationId: conversationId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyWKg.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b09eb397c6c150a2$var$EmptyFallback, null),
        experienceName: (0, $irnO2.ExperienceName).LOAD_STICKY_SKILL_LISTENER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).LOAD_STICKY_SKILL_LISTENER
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b09eb397c6c150a2$var$StickySkillListenerInner, {
        conversationId: conversationId
    }));
};





























const $1e517d02efc5dbf2$var$StreamingStatusDispatcherInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { conversationId: conversationId, conversation: conversation } = t0;
    const { setStreamingStatus: setStreamingStatus } = (0, $bGNkz.useUIStoreActions)();
    const { updateConversation: updateConversation } = (0, $3TxKn.useChatStoreActions)();
    const wasStreamingRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            wasStreamingRef.current = false;
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== conversationId) {
        t2 = [
            conversationId
        ];
        $[1] = conversationId;
        $[2] = t2;
    } else t2 = $[2];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== conversation || $[4] !== setStreamingStatus) {
        t3 = ()=>{
            if (conversation) {
                const loading = [
                    (0, $igOtY.CHAT_STORE_STATUS).typingResponse,
                    (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse
                ].includes(conversation?.status);
                if (loading) setStreamingStatus(true);
                else setStreamingStatus(false);
            }
            return ()=>{
                setStreamingStatus(false);
            };
        };
        t4 = [
            conversation,
            setStreamingStatus
        ];
        $[3] = conversation;
        $[4] = setStreamingStatus;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== conversation?.readStatus || $[8] !== conversation?.status || $[9] !== conversationId || $[10] !== updateConversation) {
        t5 = ()=>{
            if (!(0, $iDrrr.fg)("rovo_chat_chat_history_refresh")) return;
            const isNowIdle = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle;
            const isStreaming = [
                (0, $igOtY.CHAT_STORE_STATUS).typingResponse,
                (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse
            ].includes(conversation?.status);
            const conversationNeedsMarkingRead = conversation?.readStatus !== true;
            const explicitlyUnread = conversation?.readStatus === false;
            const streamJustCompleted = wasStreamingRef.current && isNowIdle;
            const shouldMarkAsRead = (streamJustCompleted || isNowIdle && explicitlyUnread) && conversationNeedsMarkingRead;
            if (isStreaming) wasStreamingRef.current = true;
            if (shouldMarkAsRead && conversationId) {
                wasStreamingRef.current = false;
                (async ()=>{
                    await Promise.resolve(updateConversation({
                        conversationId: conversationId,
                        data: {
                            readStatus: true
                        }
                    }));
                })();
            }
        };
        $[7] = conversation?.readStatus;
        $[8] = conversation?.status;
        $[9] = conversationId;
        $[10] = updateConversation;
        $[11] = t5;
    } else t5 = $[11];
    const t6 = conversation?.status;
    const t7 = conversation?.readStatus;
    let t8;
    if ($[12] !== conversationId || $[13] !== t6 || $[14] !== t7 || $[15] !== updateConversation) {
        t8 = [
            t6,
            t7,
            conversationId,
            updateConversation
        ];
        $[12] = conversationId;
        $[13] = t6;
        $[14] = t7;
        $[15] = updateConversation;
        $[16] = t8;
    } else t8 = $[16];
    (0, $cozmU.useEffect)(t5, t8);
    return null;
} : ({ conversationId: conversationId, conversation: conversation })=>{
    const { setStreamingStatus: setStreamingStatus } = (0, $bGNkz.useUIStoreActions)();
    const { updateConversation: updateConversation } = (0, $3TxKn.useChatStoreActions)();
    // Track whether the conversation was previously in a streaming/loading state
    // so we only mark as read when a stream actually completed (not on initial page load)
    const wasStreamingRef = (0, $cozmU.useRef)(false);
    // Reset wasStreamingRef when the conversation changes so we don't carry over
    // streaming state from a previous conversation
    (0, $cozmU.useEffect)(()=>{
        wasStreamingRef.current = false;
    }, [
        conversationId
    ]);
    // ROVOFE-385 - Sync conversation load/streaming state with the UIStore for consumers to make decisions about their own implementations
    (0, $cozmU.useEffect)(()=>{
        if (conversation) {
            const loading = [
                (0, $igOtY.CHAT_STORE_STATUS).typingResponse,
                (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse
            ].includes(conversation?.status);
            if (loading) setStreamingStatus(true);
            else setStreamingStatus(false);
        }
        return ()=>{
            setStreamingStatus(false);
        };
    }, [
        conversation,
        setStreamingStatus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) return;
        const isNowIdle = conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle;
        const isStreaming = [
            (0, $igOtY.CHAT_STORE_STATUS).typingResponse,
            (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse
        ].includes(conversation?.status);
        // readStatus === false: optimistically set as unread (user was on a different conversation)
        // readStatus === undefined: not yet explicitly marked (user was on this conversation during streaming)
        // We gate on wasStreamingRef so we don't fire on initial page load when status starts idle
        // (where readStatus is undefined and the conversation was never in a streaming state for us).
        // However, if readStatus === false it means the server/another client explicitly marked this
        // conversation as unread while we were away, so we should mark it as read immediately once
        // it is idle — even if we never observed the streaming phase ourselves.
        const conversationNeedsMarkingRead = conversation?.readStatus !== true;
        const explicitlyUnread = conversation?.readStatus === false;
        const streamJustCompleted = wasStreamingRef.current && isNowIdle;
        // Mark as read if: stream just completed for us, OR we navigated to an already-idle
        // conversation that was explicitly marked unread (readStatus === false).
        const shouldMarkAsRead = (streamJustCompleted || isNowIdle && explicitlyUnread) && conversationNeedsMarkingRead;
        if (isStreaming) wasStreamingRef.current = true;
        if (shouldMarkAsRead && conversationId) {
            wasStreamingRef.current = false;
            (async ()=>{
                await Promise.resolve(updateConversation({
                    conversationId: conversationId,
                    data: {
                        readStatus: true
                    }
                }));
            })();
        }
    }, [
        conversation?.status,
        conversation?.readStatus,
        conversationId,
        updateConversation
    ]);
    return null;
};
const $1e517d02efc5dbf2$export$6bf0bb7de015afa9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    let t0;
    if ($[0] !== conversationId) {
        t0 = {
            conversationId: conversationId
        };
        $[0] = conversationId;
        $[1] = t0;
    } else t0 = $[1];
    const { conversation: conversation } = (0, $dQbwX.useChatConversation)(t0);
    let t1;
    if ($[2] !== conversation || $[3] !== conversationId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e517d02efc5dbf2$var$StreamingStatusDispatcherInner, {
            conversationId: conversationId,
            conversation: conversation
        });
        $[2] = conversation;
        $[3] = conversationId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    const { conversation: conversation } = (0, $dQbwX.useChatConversation)({
        conversationId: conversationId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e517d02efc5dbf2$var$StreamingStatusDispatcherInner, {
        conversationId: conversationId,
        conversation: conversation
    });
};


const $007fd63f6f2d0d8e$var$styles = {
    mainContent: "_0jFU0VN91d _39xV02N91d",
    navBarWrapper: "_0jFU0VN91d _39xV02N91d",
    contentWrapper: "_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _39xV02N91d",
    contentFooter: "_3YEZNOdnbC",
    contentWrapperCentered: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0jFU0VN91d _39xV02N91d _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS",
    contentWrapperCenteredPromptLibraryExpanded: "_37wbyuchRC",
    fullscreenPromptContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _39xV02N91d _4kiQYAdnbC",
    fullscreenPromptContainerWithStagingAreaRef: "_0hPCNLFlnN",
    fullscreenPromptArea: "_1mT5xdRAKS _4xdlr0FlnN _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4kiQYAdnbC",
    miniModalMainContainer: "_0bjKvDKxmn _39xV02Hakr _0KLXruqi9L _2OUyjtGk8v _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _1mT5xdRAKS",
    miniModalHeaderContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _3YEZNOdnbC",
    miniModalBodyContainer: "_2O5Vij7dHp _4kiQYAdnbC _2WAcuGIZbP _4bt5LAnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0Fz5g5G6SO _1qyfxmIZbP _3oUqlsUzH9",
    chatWithOverlayWrapper: "_1mT5xdRAKS _2O5Vij7dHp _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    miniModalFooterContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _3YEZNOdnbC _1mT5xdHE3j _0Bm75GdnbC",
    miniModalMainActivePanelContainer: "_0bjKvDKxmn _39xV02Hakr _2WAcuGIZbP _4bt5LAnQyn _0KLXruqi9L _2OUyjtGk8v _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0aNu0LYbGa _1mT5xdRAKS"
};
const $007fd63f6f2d0d8e$var$LazySmartCreationWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(0, $jv1SC.importSmartCreationWrapper)().then((module)=>{
        return {
            default: module.SmartCreationWrapper
        };
    })); // Lazy-loaded conditionally-rendered pages. These are only loaded on demand

// when the user navigates to them via the sidebar menu.
const $007fd63f6f2d0d8e$var$LazyPromptLibrary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("19Vqd")).then((m)=>({
            default: m.PromptLibrary
        })));

const $007fd63f6f2d0d8e$var$LazyScheduledChatListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("3hkHS")).then((m)=>({
            default: m.ScheduledChatListPage
        })));

const $007fd63f6f2d0d8e$var$LazyTasksListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("enLuU")).then((m)=>({
            default: m.TasksListPage
        })));

const $007fd63f6f2d0d8e$var$LazySearchWorkPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2KBjj")).then((m)=>({
            default: m.SearchWorkPage
        })));

const $007fd63f6f2d0d8e$var$LazySmartLink3PPostAuthActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2S1Ct")).then(({ SmartLink3PPostAuthActions: SmartLink3PPostAuthActions })=>({
            default: SmartLink3PPostAuthActions
        }))); /**
       * Wrapper component that provides mini modal resize functionality.
       * Wraps the useMiniModalResize hook and passes results to renderMiniModalMainView.
       * Only rendered when mode === MINI_MODAL.
       *
       * @param renderMiniModalMainView - Render function that receives resize props
       * @param greetingHeight - Height of the greeting header (used to adjust min height calculation
       *                         so users can resize below the initial height when greeting is visible)
       * @param greetingKey - Unique identifier for the current greeting context (e.g., 'custom', 'default').
       *                      When this changes, resize state resets so the greeting can show with its default visibility.
       */ 
const $007fd63f6f2d0d8e$var$MiniModalViewWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { renderMiniModalMainView: renderMiniModalMainView, greetingHeight: t1, greetingKey: greetingKey, topOffset: t2, enableMiniModalResize: enableMiniModalResize } = t0;
    const greetingHeight = t1 === undefined ? 0 : t1;
    const topOffset = t2 === undefined ? 0 : t2;
    let t3;
    if ($[0] !== enableMiniModalResize || $[1] !== greetingHeight || $[2] !== greetingKey || $[3] !== topOffset) {
        t3 = {
            minHeight: (0, $kQqCc.CONVERSATION_ASSISTANT_MINIMUM_HEIGHT),
            greetingHeight: greetingHeight,
            greetingKey: greetingKey,
            topOffset: topOffset,
            enableMiniModalResize: enableMiniModalResize,
            bottomOffset: 0
        };
        $[0] = enableMiniModalResize;
        $[1] = greetingHeight;
        $[2] = greetingKey;
        $[3] = topOffset;
        $[4] = t3;
    } else t3 = $[4];
    const props = (0, $a5f47f4537efba60$export$7de9561ff806a5a9)(t3);
    let t4;
    if ($[5] !== props.isResizeEnabled || $[6] !== props.setSize) {
        t4 = {
            setSize: props.setSize,
            isResizeEnabled: props.isResizeEnabled
        };
        $[5] = props.isResizeEnabled;
        $[6] = props.setSize;
        $[7] = t4;
    } else t4 = $[7];
    (0, $028d4bac1398707f$export$37d36887304d381f)(t4);
    let t5;
    if ($[8] !== props || $[9] !== renderMiniModalMainView) {
        t5 = renderMiniModalMainView(props);
        $[8] = props;
        $[9] = renderMiniModalMainView;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ renderMiniModalMainView: renderMiniModalMainView, greetingHeight: greetingHeight = 0, greetingKey: greetingKey, topOffset: topOffset = 0, enableMiniModalResize: enableMiniModalResize })=>{
    const props = (0, $a5f47f4537efba60$export$7de9561ff806a5a9)({
        minHeight: (0, $kQqCc.CONVERSATION_ASSISTANT_MINIMUM_HEIGHT),
        greetingHeight: greetingHeight,
        greetingKey: greetingKey,
        topOffset: topOffset,
        enableMiniModalResize: enableMiniModalResize,
        // No bottom clearance: the modal is anchored at the bottom and grows upward.
        bottomOffset: 0
    }); // Auto-expand the mini-modal when a chat begins (TREX-1422).
    (0, $028d4bac1398707f$export$37d36887304d381f)({
        setSize: props.setSize,
        isResizeEnabled: props.isResizeEnabled
    });
    return renderMiniModalMainView(props);
}; /**
    * New component for the new Rovo Chat Framework.
    * Will replace ConversationAssistantRender in the future.
    * Please use this component for AIFC chat refresh work.
    */ 
const $007fd63f6f2d0d8e$var$FeedbackCollectorContainerWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = (0, $ieeJu.expValEquals)("cc-mui-slides-experiment", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b102523dfc9f7a6e$export$d75860f72b50dfd), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>(0, $ieeJu.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b102523dfc9f7a6e$export$d75860f72b50dfd), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children); /**
                                                                                                                                                            * Mounts the per-message share context only when a share entry point exists.
                                                                                                                                                            * When `shareUpToMessage` is undefined (feature gated off, or no active
                                                                                                                                                            * conversation) the children render without the provider, so per-message
                                                                                                                                                            * share buttons see no context and hide themselves — avoiding a dead
                                                                                                                                                            * affordance without hoisting the whole render tree into a conditional.
                                                                                                                                                            */ 
const $007fd63f6f2d0d8e$var$ShareUpToMessageProviderWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { shareUpToMessage: shareUpToMessage, isMessageShareable: isMessageShareable, shareDisabledReason: shareDisabledReason, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isMessageShareable || $[2] !== shareDisabledReason || $[3] !== shareUpToMessage) {
        t1 = shareUpToMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d90d7faee342c7f7$export$ca3858b1f32a3a21), {
            shareUpToMessage: shareUpToMessage,
            isMessageShareable: isMessageShareable,
            shareDisabledReason: shareDisabledReason
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = isMessageShareable;
        $[2] = shareDisabledReason;
        $[3] = shareUpToMessage;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ shareUpToMessage: shareUpToMessage, isMessageShareable: isMessageShareable, shareDisabledReason: shareDisabledReason, children: children })=>shareUpToMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d90d7faee342c7f7$export$ca3858b1f32a3a21), {
        shareUpToMessage: shareUpToMessage,
        isMessageShareable: isMessageShareable,
        shareDisabledReason: shareDisabledReason
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
const $007fd63f6f2d0d8e$var$SpaceModalsWithStore = ({ cloudId: cloudId, isCreateSpaceModalOpen: isCreateSpaceModalOpen, onCloseCreateSpace: onCloseCreateSpace, recommendedSpaceModal: recommendedSpaceModal, onCloseRecommendedSpace: onCloseRecommendedSpace, sideNavSpaceCreatedRef: sideNavSpaceCreatedRef, isManageSpaceModalOpen: isManageSpaceModalOpen, onCloseManageSpace: onCloseManageSpace, selectedSpace: selectedSpace, activeMenu: activeMenu, assistanceServiceParams: assistanceServiceParams })=>{
    const { addSpace: addSpace, patchSpace: patchSpace } = (0, $12shJ.useSpaceStoreActions)(); // Keep the broad UI-store subscription while the experiment is off so this
    // action-only consumer re-renders on any UI-store change exactly as it did
    // when it read useUIStore() directly; when the experiment is on it subscribes
    // to nothing and the narrowed props drive re-renders instead.
    (0, $bGNkz.useUIStoreSubscription)();
    const { setSelectedSpace: setSelectedSpace, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const pendingSourcesRef = (0, $cozmU.useRef)([]);
    const handleCreate = (0, $cozmU.useCallback)((payload)=>{
        pendingSourcesRef.current = payload.sources ?? [];
    }, []);
    const handleCreated = (0, $cozmU.useCallback)((space, emojiId)=>{
        addSpace(space, emojiId);
        const mappedSources = (0, $e690d34cff371f6d$export$561111ab539b745)(pendingSourcesRef.current);
        patchSpace(space.id, {
            sources: mappedSources
        });
        setSelectedSpace({
            id: space.id,
            name: space.name,
            emoji: emojiId ?? null,
            sources: mappedSources,
            entryPoint: recommendedSpaceModal.isOpen ? 'inChatRecommendation' : 'sidebar'
        });
        pendingSourcesRef.current = [];
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        });
        if (activeMenu !== 'none') setActiveMenu('none');
    }, [
        addSpace,
        patchSpace,
        setSelectedSpace,
        setSelectedConversation,
        activeMenu,
        setActiveMenu,
        recommendedSpaceModal.isOpen
    ]); // Stable ref callback so RovoSideNavigation (outside provider) can trigger addSpace + patchSpace.
    sideNavSpaceCreatedRef.current = (0, $cozmU.useCallback)((space_0, sources, emojiId_0)=>{
        addSpace(space_0, emojiId_0);
        patchSpace(space_0.id, {
            sources: (0, $e690d34cff371f6d$export$561111ab539b745)(sources)
        });
    }, [
        addSpace,
        patchSpace
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gh5g4.CreateSpaceModal), {
        isOpen: isCreateSpaceModalOpen,
        onClose: onCloseCreateSpace,
        onCreate: handleCreate,
        onCreated: handleCreated,
        cloudId: cloudId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gh5g4.CreateSpaceModal), {
        isOpen: recommendedSpaceModal.isOpen,
        onClose: onCloseRecommendedSpace,
        onCreate: handleCreate,
        onCreated: handleCreated,
        cloudId: cloudId,
        initialName: recommendedSpaceModal.initialName,
        initialSources: recommendedSpaceModal.initialSources
    }), selectedSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxAn2.ManageSpaceModal), {
        isOpen: isManageSpaceModalOpen,
        onClose: onCloseManageSpace,
        spaceId: selectedSpace.id,
        cloudId: cloudId,
        initialName: selectedSpace.name,
        initialEmoji: selectedSpace.emoji,
        assistanceServiceParams: assistanceServiceParams,
        onSuccess: (updated, sources_0)=>{
            const m = (0, $e690d34cff371f6d$export$561111ab539b745)(sources_0);
            setSelectedSpace({
                id: updated.id,
                name: updated.name,
                emoji: updated.emoji,
                sources: m,
                entryPoint: selectedSpace.entryPoint
            });
            patchSpace(updated.id, {
                name: updated.name,
                emoji: updated.emoji,
                sources: m
            });
        }
    }));
};
const $007fd63f6f2d0d8e$var$ConversationAssistantRenderComponent = ({ testId: testId, isNav4Enabled: isNav4Enabled, sitePickerRender: sitePickerRender, modeConfig: modeConfig, getActions: getActions, prioritizeCustomActionResults: prioritizeCustomActionResults, numStartersToShow: numStartersToShow, topOffset: topOffset = 0, isInPreviewModal: isInPreviewModal, config: config, setSharedFeaturesInstrumentationId: setSharedFeaturesInstrumentationId, tags: tags, suppressInitialFocus: suppressInitialFocus, showActionsButton: showActionsButton = true, activeMenu: activeMenu, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, selectedSpace: selectedSpace, smartLink3PPostAuth: smartLink3PPostAuth })=>{
    (0, $6cFsl.di)((0, $n71o5.useChatStore), (0, $Ou0Zz.useAnalytics), (0, $a4401f94f223733d$export$23974c6ecceedade), (0, $hMLWD.ChatGenericError), (0, $bGNkz.useUIStore), (0, $dSCNl.useUIConfig), (0, $5c026e9a93c43806$export$c84be89e9a4c6ea7), (0, $e4186f3d50a4f7ba$export$9e01ca19610ab51c), (0, $bd7f1c1de1bb802e$export$fa63c8dd87ea8148), (0, $lTU4O.useUserPreferences), (0, $iDrrr.fg), (0, $5wAPd.useConversation), (0, $k4g8h.useChatSignals), (0, $eKjv9.useGlobalConfig), (0, $0e37dd0446a514a8$export$2633258f29aae55e));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const showFlag = (0, $0226839d0b5ae712$export$2fee09931cf10a53)();
    const isSmartLink3PPostAuthEnabled = (0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg');
    const [editorPopupsMountPoint, setEditorPopupsMountPoint] = (0, $cozmU.useState)(null);
    const handleUnhandledError = (0, $8efb636d62a22c96$export$25945d84bef50db1)(sendAnalyticsEvent, 'ConversationAssistantRender');
    const { conversation: conversation, selectedAgent: selectedAgent, agentErrorCode: agentErrorCode, agentIdForNewChat: agentIdForNewChat } = (0, $5wAPd.useConversation)(); // Undefined for the default Rovo agent — used to suppress tabs and reset tab state.
    const selectedAgentId = selectedAgent?.is_default ? undefined : selectedAgent?.id;
    const { abortRequests: abortRequests, setSelectedConversation: setSelectedConversation, fetchConversationChannelsData: fetchConversationChannelsData } = (0, $3TxKn.useChatStoreActions)();
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const rovoSkillsConfig = (0, $9b053e82e6486083$export$40c152105e92ac90)({
        tags: tags
    });
    if ((0, $iDrrr.fg)('convo-ai-enable-agents-use-permission')) // Sync agent error state to conversation status (AGENT_FORBIDDEN or AGENT_DEACTIVATED)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3a01bf6f140b15bf$export$e4594b7cd3624f07)({
        agentErrorCode: agentErrorCode,
        conversationId: currentConversationId
    });
    const { setActiveMenu: setActiveMenu, setMounted: setMounted } = (0, $bGNkz.useUIStoreActions)(); // Prefer the emoji provider passed in via config (e.g. from townsquare's cached
    // getEmojiProviderForCloudId) to avoid duplicate network requests. Fall back to
    // creating one locally only if no provider was supplied.
    const spaceEmojiProvider = (0, $cozmU.useMemo)(()=>config.emojiProvider ?? (config.siteId ? (0, $d26Wq.createEmojiProvider)(config.siteId) : undefined), [
        config.emojiProvider,
        config.siteId
    ]);
    const insightsFeedAssistanceServiceParams = (0, $6YdPR.useAssistanceServiceParams)({
        touchpointSource: 'rovo-insights-feed'
    }); // Stable-by-content assistanceServiceParams for the memoized InsightsFeed.
    const insightsFeedAssistanceServiceParamsKey = JSON.stringify(insightsFeedAssistanceServiceParams);
    const stableInsightsFeedAssistanceServiceParams = (0, $cozmU.useMemo)(()=>JSON.parse(insightsFeedAssistanceServiceParamsKey), [
        insightsFeedAssistanceServiceParamsKey
    ]);
    (0, $ddcfc9463ea1b073$export$f0a74a1c06d4e66)();
    const { fullScreen: fullScreen, externalEmbed: externalEmbed, elements: elements, customHandlers: customHandlers, customGreeting: customGreeting, hideBrowserTabTitle: hideBrowserTabTitle, hideBrowserTabFavicon: hideBrowserTabFavicon, stagingAreaRef: stagingAreaRef, disableSettingsModal: disableSettingsModal, enableSkills: enableSkills, enableAgentMentions: enableAgentMentions, enableAutoSuggest: enableAutoSuggest, enableMiniModalResize: enableMiniModalResize, initialPromptText: initialPromptText, shouldSeedInitialPromptText: shouldSeedInitialPromptText } = (0, $dSCNl.useUIConfig)();
    const [{ conversationError: conversationError, status: chatStatus }] = (0, $k4g8h.useChatSignals)();
    const isFullScreenErrorState = (0, $k4g8h.isFullScreenError)(conversationError);
    const isRateLimitedState = (0, $k4g8h.isRateLimited)(conversationError);
    const rateLimitedActionType = (0, $k4g8h.getRateLimitedActionType)(conversationError);
    const { insertPlaceholder: insertPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    const { preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose, profileData: profileData, closeChat: closeChat } = (0, $eKjv9.useGlobalConfig)();
    const chatLoading = (0, $fb5a7b7fdd168f1b$export$3902b208060a7183)(chatStatus, conversation?.status);
    const isEmptyConvo = (0, $1IZrU.isEmptyConversation)(currentConversationId);
    const { activeAction: activeAction, clearActiveAction: clearActiveAction } = (0, $5BOJB.useActiveAction)(); // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
    const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false); // Profile-trigger renderer injected into the ai-mate render cluster (rovo-growth-pulse /
    // rovo-platform-ui-components). Those packages must NOT import @atlassian/user-profile-card
    // directly (doing so forms a package dependency cycle), so this renderer is supplied here —
    // conversation-assistant sits above that cluster and safely depends on user-profile-card.
    // Mounted high enough to wrap BOTH the InsightsFeed and the message content-renderer surfaces.
    // Gated on the migration experiment; when disabled, consumers fall back to legacy profile cards.
    const viewerId = profileData?.aaid;
    const renderProfileTrigger = (0, $cozmU.useMemo)(()=>{
        if ((0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false)) return ({ userId: userId, cloudId: cloudId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
                userId: userId,
                cloudId: cloudId,
                orgId: config.orgId ?? '',
                viewerId: viewerId ?? '',
                trigger: "hover"
            }, children);
        return undefined;
    }, [
        config.orgId,
        viewerId
    ]);
    const activeActionPresentation = (0, $d7d494c6f701221a$export$686d2858de1a6c61)(activeAction);
    const shouldSuppressPromptLibrary = Boolean(activeActionPresentation.suppressPromptLibrary);
    const shouldRenderPromptLibrary = fullScreen && isEmptyConvo && !chatLoading && !shouldSuppressPromptLibrary;
    const { isSideNavOpen: isSideNavOpen, setSideNavOpen: setSideNavOpen } = (0, $ecef698430401e91$export$8323ee170f55f743)();
    const menuButtonRef = (0, $cozmU.useRef)(null);
    const [autoSuggestSearchQuery, setAutoSuggestSearchQuery] = (0, $cozmU.useState)('');
    const [isAutoSuggestSkillsVisible, setIsAutoSuggestSkillsVisible] = (0, $cozmU.useState)(false);
    const autoSuggestSkillsControllerRef = (0, $cozmU.useRef)(null);
    const onAutoSuggestSkillsDismissHandle = (0, $cozmU.useCallback)((handle)=>{
        autoSuggestSkillsControllerRef.current = handle;
    }, []);
    const [showInput, setShowInput] = (0, $cozmU.useState)(true);
    const [isPromptLibraryExpanded, setIsPromptLibraryExpanded] = (0, $cozmU.useState)(false);
    const smartLinkPostAuthProps = smartLink3PPostAuth?.isActive && isSmartLink3PPostAuthEnabled && smartLink3PPostAuth.extensionKey && smartLink3PPostAuth.provider && smartLink3PPostAuth.projectContext ? {
        extensionKey: smartLink3PPostAuth.extensionKey,
        provider: smartLink3PPostAuth.provider,
        projectContext: smartLink3PPostAuth.projectContext
    } : undefined;
    const { open: openRovoSettingsModal } = (0, $7bLo5.useRovoSettingsModal)();
    const onOpenMemoryManagement = (0, $cozmU.useCallback)(()=>openRovoSettingsModal({
            defaultTab: 'manage-memory'
        }), [
        openRovoSettingsModal
    ]); // Listen for custom event from post-office memory settings spotlight to open memory management modal
    (0, $cozmU.useEffect)(()=>(0, $cbY7C.bind)(window, {
            type: 'memory-settings-onboarding-spotlight-primary-action-click',
            listener: ()=>onOpenMemoryManagement()
        }), [
        onOpenMemoryManagement
    ]);
    const handlePromptLibraryExpandedChange = (0, $cozmU.useCallback)((expanded)=>{
        setIsPromptLibraryExpanded(expanded);
    }, []);
    const { resetStagingArea: resetStagingArea } = (0, $8akfd.useStagingAreaActions)();
    const { stagingAreaMode: stagingAreaMode, stagingAreaEntryPoint: stagingAreaEntryPoint } = (0, $8akfd.useStagingAreaState)();
    const isAifcOnboardingConfluence = stagingAreaEntryPoint === 'aifc-onboarding-confluence';
    const { screenType: screenType, openInlineBrowse: openInlineBrowse, closeInlineBrowse: closeInlineBrowse } = (0, $6a3a2f991f4c8b17$export$d4a1aceb2518d83a)(currentConversationId);
    const { mode: mode, switchToMode: switchToMode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable = true, isFullScreenModalAvailable: isFullScreenModalAvailable } = modeConfig ?? {
        mode: (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
        isMiniModalAvailable: undefined,
        switchToMode: undefined,
        isSidebarAvailable: true,
        isFullScreenModalAvailable: undefined
    };
    (0, $55dbad1906719e56$export$66a5dbe4271b0de3)(currentConversationId);
    const { mergedGetActions: mergedGetActions, replaceProviderActions: replaceProviderActions, numStartersToShow: customNumStartersToShow } = (0, $0ec3851bfc318f14$export$667744853b9051e4)(getActions);
    (0, $cozmU.useEffect)(()=>{
        if (elements?.stagingAreaEnabled) setActiveMenu('none');
    }, [
        elements?.stagingAreaEnabled,
        setActiveMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!elements?.stagingAreaEnabled && stagingAreaMode === 'inline' && (0, $iDrrr.fg)('aifc_create_enabled')) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        setSharedFeaturesInstrumentationId((0, $kHija.v4)());
        else setSharedFeaturesInstrumentationId(undefined);
    }, [
        elements?.stagingAreaEnabled,
        stagingAreaMode,
        setSharedFeaturesInstrumentationId
    ]); // Open prompt library when rovoPromptLibraryOpen param is present in the URL
    const hasOpenedPromptLibraryFromParamsRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRenderPromptLibrary || hasOpenedPromptLibraryFromParamsRef.current) return;
        const rovoParams = (0, $dTEBe.getRovoParams)();
        if (rovoParams.promptLibraryOpen) {
            setIsPromptLibraryExpanded(true);
            hasOpenedPromptLibraryFromParamsRef.current = true;
        }
    }, [
        shouldRenderPromptLibrary
    ]); // Open pulse menu when rovoChatPathway=pulse param is present in the URL
    const hasOpenedPulseFromParamsRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasOpenedPulseFromParamsRef.current) return;
        const rovoParams = (0, $dTEBe.getRovoParams)();
        if (rovoParams.pathway === 'pulse') {
            // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
            const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
            if (isPulseExperimentEnabled) {
                setActiveMenu('pulse');
                hasOpenedPulseFromParamsRef.current = true;
            }
        }
    }, [
        setActiveMenu
    ]);
    const handleNewChatClick = (0, $cozmU.useCallback)(()=>{
        setSelectedConversation({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
            sourceAgentId: (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission') ? agentIdForNewChat : selectedAgent?.id
        });
        if (!fullScreen) setActiveMenu('none');
        clearActiveAction();
    }, [
        setSelectedConversation,
        fullScreen,
        setActiveMenu,
        clearActiveAction,
        agentIdForNewChat,
        selectedAgent?.id
    ]);
    const handleDiscoverSkillsClick = (0, $cozmU.useCallback)(()=>{
        openInlineBrowse('skills');
    }, [
        openInlineBrowse
    ]);
    const handleDiscoverPromptLibraryClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'libraryOpenedFromSidebar',
            attributes: {
                source: 'discoverActionButton'
            }
        });
        openInlineBrowse('prompt-library');
    }, [
        openInlineBrowse,
        sendAnalyticsEvent
    ]);
    const handleBrowsePromptLibraryFromMenuClick = (0, $cozmU.useCallback)(()=>{
        openInlineBrowse('prompt-library');
    }, [
        openInlineBrowse
    ]);
    const [isCreateSpaceModalOpen, setIsCreateSpaceModalOpen] = (0, $cozmU.useState)(false);
    const [isManageSpaceModalOpen, setIsManageSpaceModalOpen] = (0, $cozmU.useState)(false);
    const [recommendedSpaceModal, setRecommendedSpaceModal] = (0, $cozmU.useState)({
        isOpen: false
    });
    const handleCreateRecommendedSpace = (0, $cozmU.useCallback)((title, sources)=>{
        setRecommendedSpaceModal({
            isOpen: true,
            initialName: title,
            initialSources: sources
        });
    }, []);
    const handleCreateSpaceClick = (0, $cozmU.useCallback)(()=>{
        setIsCreateSpaceModalOpen(true);
    }, []);
    const handleAutoSuggestQueryChange = (0, $cozmU.useCallback)((query)=>{
        setAutoSuggestSearchQuery(query);
        if (query.trim() === '') setIsAutoSuggestSkillsVisible(false);
    }, []);
    const handleViewAllSkillsFromAutoSuggest = (0, $cozmU.useCallback)(()=>{
        autoSuggestSkillsControllerRef.current?.dismiss();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoChatDiscoverSkillsButton'
        });
        openInlineBrowse('skills');
    }, [
        openInlineBrowse,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (screenType === 'loading' && fullScreen) {
            setShowInput(false);
            return;
        }
        if (!activeAction) {
            setShowInput(true);
            return;
        }
        setShowInput('customFollowUpContext' in activeAction);
    }, [
        activeAction,
        screenType,
        fullScreen
    ]); // Refetch the conversations by resetting the search value
    (0, $cozmU.useEffect)(()=>{
        const focusWindowHandler = (0, $cbY7C.bind)(window, {
            // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
            type: 'visibilitychange',
            listener: ()=>{
                if ((0, $1hQ0e.getDocument)()?.visibilityState === 'visible') fetchConversationChannelsData({
                    reconcileFirstPage: true,
                    onError: ()=>{}
                });
            }
        });
        return ()=>{
            focusWindowHandler();
        };
    }, [
        fetchConversationChannelsData
    ]); // Useful for integrators to know when Rovo is mounted and ready
    (0, $cozmU.useEffect)(()=>{
        setMounted(true);
        return ()=>setMounted(false);
    }, [
        setMounted
    ]); // Use stable refs to keep track of updates after mount
    const changingMode = (0, $cozmU.useRef)(false); // Declared in the parent (not in AutoConversationEvaluator) so the guard persists across
    // unmount/remount cycles of the child — which happen when isEmptyConvo toggles during navigation.
    // A ref local to the child would reset on every remount, defeating the guard.
    const autoConversationFiredRef = (0, $cozmU.useRef)(false);
    const preventAbortRequestsOnStagingModalCloseRef = (0, $cozmU.useRef)(preventAbortRequestsOnStagingModalClose);
    const preventAbortRequestsOnStandaloneChatCloseRef = (0, $cozmU.useRef)(preventAbortRequestsOnStandaloneChatClose);
    const isInPreviewModalRef = (0, $cozmU.useRef)(isInPreviewModal);
    (0, $cozmU.useEffect)(()=>{
        preventAbortRequestsOnStagingModalCloseRef.current = preventAbortRequestsOnStagingModalClose;
    }, [
        preventAbortRequestsOnStagingModalClose
    ]);
    (0, $cozmU.useEffect)(()=>{
        preventAbortRequestsOnStandaloneChatCloseRef.current = preventAbortRequestsOnStandaloneChatClose;
    }, [
        preventAbortRequestsOnStandaloneChatClose
    ]);
    (0, $cozmU.useEffect)(()=>{
        isInPreviewModalRef.current = isInPreviewModal;
    }, [
        isInPreviewModal
    ]); // AI MAU - When to fire dismissed event when component unmounts
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // do not abort requests when switching modes
            if (changingMode.current) {
                // just a safety if we are no unmounting the component
                // for whatever reason on changing mode, then on next natural
                // unmount we still want to abort requests
                changingMode.current = false;
                return;
            } // Do not abort requests when closing the staging modal (if requested by caller)
            if (preventAbortRequestsOnStagingModalCloseRef.current && isInPreviewModalRef.current) return;
             // Do not abort requests when closing standalone chat (if requested by caller)
            if (preventAbortRequestsOnStandaloneChatCloseRef.current && !isInPreviewModalRef.current) return;
             //TODO FIX THIS
            abortRequests({
                deepResearchEnabled: undefined
            });
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const switchToModeCallbackInterceptor = (0, $cozmU.useCallback)((mode)=>{
        if (switchToMode) {
            changingMode.current = true;
            switchToMode(mode);
        }
    }, [
        switchToMode
    ]); // Switching UI is enabled when at least two modes are available.
    const canSwitch = isFullScreenModalAvailable && (0, $iDrrr.fg)('agent_session_experience_fg') ? [
        isSidebarAvailable,
        isMiniModalAvailable,
        isFullScreenModalAvailable
    ].filter(Boolean).length >= 2 : Boolean(isMiniModalAvailable && isSidebarAvailable);
    const isInlineBrowseScreen = screenType === 'skills' || screenType === 'prompt-library'; // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
    const isMemoryManagementEnabled = (0, $cXtTj.default).getExperimentValue('memory_management_ux', 'isEnabled', false, {
        fireExperimentExposure: false
    }); // Settings menu item is shown when any settings-related feature is enabled
    // and the settings modal is not disabled (e.g. Chrome extension sidebar)
    const isSettingsEnabled = isMemoryManagementEnabled && !disableSettingsModal;
    const onSettingsClick = isSettingsEnabled ? onOpenMemoryManagement : undefined;
    const onChatHeaderMenuButtonClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoSideNavMenuButton'
        });
        setSideNavOpen(true);
    }, [
        sendAnalyticsEvent,
        setSideNavOpen
    ]); // Local state for the share-snapshot modal that opens from the chat
    // header's more menu. The container is always mounted; the modal
    // itself only renders when `state.open()` is called.
    const shareConversationModalState = (0, $10588f0c20b74dca$export$17a4f5cbbaa4f032)({
        conversationId: currentConversationId,
        orgId: config.orgId,
        siteId: config.siteId,
        conversationStatus: conversation?.status,
        currentUserId: config.userId,
        // Optional override; when unset the share link defaults to the Home host
        // selected from the current origin.
        shareBaseUrl: config.shareBaseUrl
    });
    const onSideNavClose = (0, $cozmU.useCallback)(()=>{
        setSideNavOpen(false);
        requestAnimationFrame(()=>{
            menuButtonRef.current?.focus();
        });
    }, [
        setSideNavOpen
    ]); // A host-supplied `onShareClick` always wins — embedders may have
    // their own share UX or their own definition of "shareable", so we
    // never override or gate their handler. When the host does not
    // supply one we fall back to opening the local share-snapshot modal,
    // but only when there is an active conversation to share. Resolving
    // to `undefined` causes `ChatHeaderMoreMenu` to hide the share menu
    // entry entirely (see its `typeof onShareClick === 'function'` check).
    const onShareClick = (0, $cozmU.useMemo)(()=>{
        if (customHandlers?.onShareClick) return customHandlers.onShareClick;
        if (currentConversationId && currentConversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID)) return shareConversationModalState.open;
        return undefined;
    }, [
        customHandlers?.onShareClick,
        currentConversationId,
        shareConversationModalState.open
    ]); // Per-message "share chat up to this point" reuses the exact resolution as the header
    // `onShareClick` above (host handler → active-conversation → open, all of
    // which already accept an optional message id) — it is simply that same
    // callback controlled by the conversation-sharing experiment. Deriving it here rather
    // than re-implementing the branching keeps the two in lock-step.
    //
    // Per-message sharing builds on the wider conversation-sharing feature and
    // must never appear without it. When the experiment is disabled this resolves
    // to `undefined`, so the provider is not mounted and the buttons stay hidden.
    //
    // The experiment is evaluated inside the memo so its exposure fires only
    // when the memo re-computes, not on every render.
    const shareUpToMessage = (0, $cozmU.useMemo)(()=>{
        const isPerMessageShareEnabled = (0, $cXtTj.default).getExperimentValue('rovo_conversation_sharing', 'isEnabled', false);
        return isPerMessageShareEnabled ? onShareClick : undefined;
    }, [
        onShareClick
    ]);
    const chatHeaderProps = (0, $cozmU.useMemo)(()=>({
            mode: mode,
            switchToMode: canSwitch ? switchToModeCallbackInterceptor : undefined,
            onMenuButtonClick: onChatHeaderMenuButtonClick,
            menuButtonRef: menuButtonRef,
            screenType: screenType,
            previousView: isInlineBrowseScreen ? closeInlineBrowse : undefined,
            sitePickerRender: sitePickerRender,
            onSettingsClick: onSettingsClick,
            onBrowseAgentClick: customHandlers?.onBrowseAgentClick,
            onShareClick: onShareClick,
            isShareDisabled: shareConversationModalState.shareDisabledReason,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        }), [
        mode,
        canSwitch,
        switchToModeCallbackInterceptor,
        onChatHeaderMenuButtonClick,
        menuButtonRef,
        screenType,
        isInlineBrowseScreen,
        closeInlineBrowse,
        sitePickerRender,
        onSettingsClick,
        customHandlers?.onBrowseAgentClick,
        onShareClick,
        shareConversationModalState.shareDisabledReason,
        isFullScreenModalAvailable
    ]);
    const chatRefreshHeader = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e37dd0446a514a8$export$2633258f29aae55e), chatHeaderProps), [
        chatHeaderProps
    ]);
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'aiMatePanel',
            mode: fullScreen ? 'fullscreen' : mode,
            attributes: {
                ...suppressInitialFocus && {
                    wasAutoOpened: true
                }
            }
        }); // Should only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSideNavSpaceCreatedRef = (0, $cozmU.useRef)(null);
    const navigationRefreshOrNull = elements?.navbar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88362faacf0f9024$export$831c51bb03eeaaed), {
        isOpen: isSideNavOpen,
        onClose: onSideNavClose,
        chatMode: mode,
        onSpaceCreated: (space, sources, emojiId)=>onSideNavSpaceCreatedRef.current?.(space, sources, emojiId)
    }) : null; // render rovo-navigation regardless of which menu we are on, but do not render it if navbar is disabled
    const renderNavAndActivePanelMenu = ()=>{
        let menu = null;
        const header = chatRefreshHeader;
        if (activeMenu === 'conversation-list') {
            if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa275117239ad784$export$c84be89e9a4c6ea7), {
                chatRefreshHeader: header
            });
            else menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c026e9a93c43806$export$c84be89e9a4c6ea7), {
                chatRefreshHeader: header
            });
        } else if (activeMenu === 'tasks') menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fullScreen && externalEmbed ? header : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$LazyTasksListPage, {
            chatRefreshHeader: header
        })));
        else if (activeMenu === 'agents') menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e7f717cb93b2c30$export$aa7b1f2c2cce452b), {
            chatRefreshHeader: header
        });
        else if (activeMenu === 'browse-spaces' && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $167331d2b384157c$export$90ac96cb16b3a797), {
            chatRefreshHeader: header
        });
        else if (activeMenu === 'scheduled') menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$LazyScheduledChatListPage, {
            chatRefreshHeader: header
        }));
        else if (activeMenu === 'search-work' && (0, $cXtTj.default).getExperimentValue('rovo_your_work_tab_pin_objects', 'isEnabled', false, {
            fireExperimentExposure: false
        })) menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$LazySearchWorkPage, {
            cloudId: config.siteId,
            product: config.product,
            fullScreen: fullScreen,
            chatRefreshHeader: header
        }));
        else if (activeMenu === 'recommended-spaces' && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $150497341f74b797$export$e1e48cca2c330187), {
                onCreateSpace: handleCreateRecommendedSpace,
                chatRefreshHeader: header
            }),
            interactionName: "recommended-spaces-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9a58e9968f397924$export$c354b3edb6dc2c8), {
            cloudId: config.siteId,
            userId: profileData?.aaid ?? undefined,
            onCreateSpace: handleCreateRecommendedSpace,
            chatRefreshHeader: header
        }));
        else if (activeMenu === 'space-landing' && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "space-landing-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9445c0a1a0d5ddc5$export$308b812199c62019), {
            chatRefreshHeader: header
        }));
        else if (activeMenu === 'pulse') menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc4876b59268118a$export$fe20473522563107), {
            chatRefreshHeader: header,
            conversationId: currentConversationId,
            assistanceServiceParams: stableInsightsFeedAssistanceServiceParams,
            onInsightReady: onInsightReady,
            isFullScreen: fullScreen,
            connectAppsAction: ({ onVisibilityChange: onVisibilityChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $897decab909b74ff$export$806f337943385db7), {
                    isCompact: !fullScreen,
                    onVisibilityChange: onVisibilityChange
                })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, navigationRefreshOrNull, menu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                activeMenu: activeMenu
            }
        }), menu) : undefined);
    };
    const handleClickStarter = (0, $cozmU.useCallback)((starter)=>{
        if (fullScreen) {
            insertPlaceholder(starter.title);
            return;
        }
        if ('dynamicPrompt' in starter) {
            const shouldBeSkillAction = (0, $2TzCj.isSkillAction)(starter) || (0, $2TzCj.isChatAction)(starter) && starter.encodeDynamicPromptAsSkill;
            insertPlaceholder(starter.dynamicPrompt ?? starter.title, shouldBeSkillAction ? 'skill' : undefined);
            return;
        }
    }, [
        insertPlaceholder,
        fullScreen
    ]); // Ref shared between ActiveTabProvider and the mini-modal outer container so that
    // captureShellHeight can read the real rendered height before tab switches.
    const miniModalShellRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { hasTabsView: hasTabsView, getDynamicContainerStyle: getDynamicContainerStyle, setTabShellHeightPx: setTabShellHeightPx, setForYouShellHeightPx: setForYouShellHeightPx } = (0, $e0357dee8bc8185f$export$b8fb44be361a2c5d)({
        isEmptyConvo: isEmptyConvo,
        activeAction: activeAction,
        screenType: screenType,
        isAutoSuggestSkillsVisible: isAutoSuggestSkillsVisible,
        topOffset: topOffset
    }); // Routes the captured shell height to the correct setter based on which tab we're leaving.
    // Suggestions height → tabShellHeightPx, For You height → forYouShellHeightPx.
    const handleShellHeightCapture = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((fromTabId, heightPx)=>{
        if (fromTabId === (0, $eef113145ca4ccce$export$4e2d22a4f1ea8ef3)) setForYouShellHeightPx(heightPx);
        else setTabShellHeightPx(heightPx);
    }, [
        setTabShellHeightPx,
        setForYouShellHeightPx
    ]);
    const safeMaxHeight = `min(${(0, $oV0CU.MINI_MODAL_EXPANDED_HEIGHT)}, calc(100vh - ${topOffset}px))`;
    const onInsightReady = (0, $e5d1fdf7ab29ba5c$export$3edf947a58c1a4fc)();
    const renderMiniModalMainView = ({ wrapperRef: wrapperRef, ResizeHandlers: ResizeHandlers, wrapperStyle: wrapperStyle, isResizeEnabled: isResizeEnabled, isResizeHeaderThresholdReached: isResizeHeaderThresholdReached })=>{
        const dynamicContainerStyle = getDynamicContainerStyle(wrapperStyle);
        miniModalShellRef.current = wrapperRef.current;
        const mainContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $41cd1043dd850903$export$a75616a52ed93687), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $007fd63f6f2d0d8e$var$styles.miniModalMainContainer,
            style: dynamicContainerStyle,
            ref: wrapperRef
        }, navigationRefreshOrNull, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-header-container",
            xcss: $007fd63f6f2d0d8e$var$styles.miniModalHeaderContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $043d7c8a3f5ba806$export$5e92f7adeab8be8b), chatHeaderProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4f1472a3b3f2f7b$export$d81bbbede7744e29), {
            cloudId: config.siteId,
            emojiProvider: spaceEmojiProvider
        }), isFullScreenErrorState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: (0, $c3a833363cbb29f5$export$42e0acafa7afe658)(conversationError.underlyingError)
        }), !isFullScreenErrorState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isChatOnboardingMiniModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5682c3d43d78116c$export$d598eeaac373af22), {
            product: config.product
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-body-container",
            xcss: $007fd63f6f2d0d8e$var$styles.miniModalBodyContainer
        }, smartLinkPostAuthProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "smartlink-3p-post-auth-mini-modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$LazySmartLink3PPostAuthActions, smartLinkPostAuthProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $007fd63f6f2d0d8e$var$styles.chatWithOverlayWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe56c1cce3607138$export$314152ebdd7f8aa0), {
            conversationId: currentConversationId,
            mode: mode,
            handleClickDynamicPrompt: handleClickStarter,
            screenType: screenType,
            closeInlineBrowse: closeInlineBrowse,
            isResizeEnabled: isResizeEnabled,
            isResizeHeaderThresholdReached: isResizeHeaderThresholdReached,
            onDiscoverPromptLibraryClick: handleDiscoverPromptLibraryClick,
            product: config.product,
            onOpenMemoryManagement: onSettingsClick,
            showFlag: showFlag
        }), enableAutoSuggest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6935ff72f1e18294$export$688cd78731269cac), {
            onDismissHandle: onAutoSuggestSkillsDismissHandle,
            searchQuery: autoSuggestSearchQuery,
            siteId: config.siteId,
            product: config.product,
            experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
            emojiProvider: spaceEmojiProvider,
            onViewAllSkills: handleViewAllSkillsFromAutoSuggest,
            onVisibleChange: setIsAutoSuggestSkillsVisible
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-footer-container",
            xcss: $007fd63f6f2d0d8e$var$styles.miniModalFooterContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83eda829c7fe234d$export$eba27d0a7754d4d3), {
            hasTabsView: hasTabsView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            onError: handleUnhandledError,
            fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
                    errorType: "generic"
                })
        }, conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04bba84c1b5bc9f5$export$3bc7aab542bd0518), {
            handleNewChatClick: handleNewChatClick,
            errorCode: conversation?.errorCode
        }) : showInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a03bf8a72b4b7f8f$export$904dba9c3c34a451), null, (overrideProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a33c889c756d4321$export$19b903fd083c557c), {
                ...overrideProps,
                initialPromptText: initialPromptText,
                shouldSeedInitialPromptText: shouldSeedInitialPromptText,
                suppressInitialFocus: suppressInitialFocus,
                mode: mode,
                editorPopupsMountPoint: editorPopupsMountPoint || undefined,
                shouldRenderQuickActionsInPortal: mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
                isDisabled: isRateLimitedState && rateLimitedActionType !== 'deep-research',
                conversationId: currentConversationId,
                enableVoiceDictation: elements?.voiceDictationButton,
                dictationOverlayBackground: (0, $55KWY.getDictationOverlayBackground)('mini-chat'),
                isExpanded: isPromptLibraryExpanded,
                activeAction: activeAction,
                onDiscoverSkillsClick: handleDiscoverSkillsClick,
                onBrowsePromptLibraryClick: handleBrowsePromptLibraryFromMenuClick,
                onCreateSpaceClick: handleCreateSpaceClick,
                onAutoSuggestQueryChange: handleAutoSuggestQueryChange,
                enableSkills: enableSkills,
                enableAgentMentions: enableAgentMentions,
                showActionsButton: showActionsButton
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: 'main-footer'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e00f1e475114aa33$export$d3ae2425e57e22bb), {
            isRefreshVersion: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResizeHandlers, null)));
        const activeMenuContent = isPulseExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-main-active-panel-container",
            xcss: $007fd63f6f2d0d8e$var$styles.miniModalMainActivePanelContainer,
            style: dynamicContainerStyle,
            ref: wrapperRef
        }, renderNavAndActivePanelMenu(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResizeHandlers, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-main-active-panel-container",
            xcss: $007fd63f6f2d0d8e$var$styles.miniModalMainActivePanelContainer,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- runtime-dynamic resize dimensions
                maxHeight: safeMaxHeight
            }
        }, renderNavAndActivePanelMenu());
        return activeMenu === 'none' ? mainContent : activeMenuContent;
    };
    const renderMainView = (options = {})=>{
        const resolvedElements = {
            ...elements,
            ...options.elements
        }; // Shell-level gate: drives the sidebar's tab wiring (tab-aware header/history/input).
        // Must follow the tab itself, not spaces — otherwise a pins-only user gets the plain
        // ChatHistory, which never supplies `activeTabId`, so the tab strip cannot render.
        const isSidebarWithTabs = mode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR && !fullScreen && (0, $fc5ecfceab3714cd$export$4f04c281a7e57c7d)();
        const mainContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $41cd1043dd850903$export$a75616a52ed93687), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $007fd63f6f2d0d8e$var$styles.mainContent
        }, navigationRefreshOrNull, resolvedElements?.mainChatHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: 'chat-header'
        }, isSidebarWithTabs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $043d7c8a3f5ba806$export$5e92f7adeab8be8b), {
            ...chatHeaderProps,
            onMenuButtonClick: !resolvedElements?.stagingAreaEnabled ? onChatHeaderMenuButtonClick : undefined
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e37dd0446a514a8$export$2633258f29aae55e), {
            ...chatHeaderProps,
            onMenuButtonClick: !resolvedElements?.stagingAreaEnabled ? onChatHeaderMenuButtonClick : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4f1472a3b3f2f7b$export$d81bbbede7744e29), {
            cloudId: config.siteId,
            emojiProvider: spaceEmojiProvider
        }), isFullScreenErrorState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: (0, $c3a833363cbb29f5$export$42e0acafa7afe658)(conversationError.underlyingError)
        }), !isFullScreenErrorState && (()=>{
            const chatInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
                name: 'chat-input-outer'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                onError: handleUnhandledError,
                fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
                        errorType: "generic"
                    })
            }, conversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04bba84c1b5bc9f5$export$3bc7aab542bd0518), {
                handleNewChatClick: handleNewChatClick,
                errorCode: conversation?.errorCode
            }) : showInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac8f43e0f5eb3ebe$export$a112554c09de95e4), {
                shouldShow: chatStatus !== 'launching' && !isAifcOnboardingConfluence,
                fullScreen: fullScreen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a03bf8a72b4b7f8f$export$904dba9c3c34a451), null, (overrideProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a33c889c756d4321$export$19b903fd083c557c), {
                    ...overrideProps,
                    initialPromptText: initialPromptText,
                    shouldSeedInitialPromptText: shouldSeedInitialPromptText,
                    suppressInitialFocus: suppressInitialFocus,
                    // (was incorrectly 'sidebar'). Telemetry-only, no behavior change.
                    // Killswitch (default ON) as a safety net for analytics consumers.
                    mode: fullScreen && (0, $iDrrr.fg)('ai_speech_to_text_fullscreen_mode_killswitch') ? (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL : mode,
                    isDisabled: isRateLimitedState && rateLimitedActionType !== 'deep-research',
                    conversationId: currentConversationId,
                    enableVoiceDictation: elements?.voiceDictationButton,
                    isExpanded: isPromptLibraryExpanded,
                    activeAction: activeAction,
                    onDiscoverSkillsClick: handleDiscoverSkillsClick,
                    onBrowsePromptLibraryClick: handleBrowsePromptLibraryFromMenuClick,
                    onCreateSpaceClick: handleCreateSpaceClick,
                    editorPopupsMountPoint: editorPopupsMountPoint || undefined,
                    onAutoSuggestQueryChange: handleAutoSuggestQueryChange,
                    enableSkills: enableSkills,
                    enableAgentMentions: enableAgentMentions,
                    showActionsButton: showActionsButton
                })))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    fullScreen && isEmptyConvo && !shouldSuppressPromptLibrary ? $007fd63f6f2d0d8e$var$styles.contentWrapperCentered : $007fd63f6f2d0d8e$var$styles.contentWrapper,
                    fullScreen && isEmptyConvo && !shouldSuppressPromptLibrary && isPromptLibraryExpanded && $007fd63f6f2d0d8e$var$styles.contentWrapperCenteredPromptLibraryExpanded,
                    !fullScreen && $007fd63f6f2d0d8e$var$styles.chatWithOverlayWrapper
                ])
            }, isSidebarWithTabs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
                name: 'chat-history'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
                data: {
                    activeMenu: 'conversation-history'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe56c1cce3607138$export$314152ebdd7f8aa0), {
                conversationId: currentConversationId,
                mode: mode,
                handleClickDynamicPrompt: handleClickStarter,
                screenType: screenType,
                closeInlineBrowse: closeInlineBrowse,
                onDiscoverPromptLibraryClick: handleDiscoverPromptLibraryClick,
                product: config.product,
                onOpenMemoryManagement: onSettingsClick,
                showFlag: showFlag
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
                name: 'chat-history'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
                data: {
                    activeMenu: 'conversation-history'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4401f94f223733d$export$23974c6ecceedade), {
                conversationId: currentConversationId,
                mode: mode,
                handleClickDynamicPrompt: handleClickStarter,
                screenType: screenType,
                closeInlineBrowse: closeInlineBrowse,
                onDiscoverPromptLibraryClick: handleDiscoverPromptLibraryClick,
                product: config.product,
                onOpenMemoryManagement: onSettingsClick,
                showFlag: showFlag
            }))), !fullScreen && stagingAreaMode !== 'inline' && enableAutoSuggest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6935ff72f1e18294$export$688cd78731269cac), {
                onDismissHandle: onAutoSuggestSkillsDismissHandle,
                searchQuery: autoSuggestSearchQuery,
                siteId: config.siteId,
                product: config.product,
                experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
                emojiProvider: spaceEmojiProvider,
                onViewAllSkills: handleViewAllSkillsFromAutoSuggest,
                onVisibleChange: setIsAutoSuggestSkillsVisible
            }), fullScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $007fd63f6f2d0d8e$var$styles.fullscreenPromptContainer,
                    stagingAreaRef && $007fd63f6f2d0d8e$var$styles.fullscreenPromptContainerWithStagingAreaRef
                ])
            }, chatInput, shouldRenderPromptLibrary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $007fd63f6f2d0d8e$var$styles.fullscreenPromptArea
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
                interactionName: "skill-metadata-prompt-library"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7dHQW.SkillMetadataProvider), {
                siteId: config.siteId,
                tags: {
                    skillRegistryTags: [
                        (0, $ZKswU.PROMPT_LIBRARY_SKILL_TAG)
                    ]
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$LazyPromptLibrary, {
                isExpanded: isPromptLibraryExpanded,
                onExpandedChange: handlePromptLibraryExpandedChange,
                conversationId: currentConversationId
            }))), stagingAreaMode !== 'inline' && enableAutoSuggest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6935ff72f1e18294$export$688cd78731269cac), {
                layout: "fullscreen",
                onDismissHandle: onAutoSuggestSkillsDismissHandle,
                searchQuery: autoSuggestSearchQuery,
                siteId: config.siteId,
                product: config.product,
                experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
                emojiProvider: spaceEmojiProvider,
                onViewAllSkills: handleViewAllSkillsFromAutoSuggest,
                onVisibleChange: setIsAutoSuggestSkillsVisible
            })))), !fullScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $007fd63f6f2d0d8e$var$styles.contentFooter
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83eda829c7fe234d$export$eba27d0a7754d4d3), {
                hasTabsView: isSidebarWithTabs
            }, chatInput)));
        })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: 'main-footer'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e00f1e475114aa33$export$d3ae2425e57e22bb), {
            isRefreshVersion: true
        })))); // TEMP FIX since we can't rely on config for single source of truth for full screen experience
        // TODO to cleanup this implementation once we can accurately rely on the config as a single source of truth for full screen experience
        return activeMenu === 'none' ? mainContent : renderNavAndActivePanelMenu();
    };
    const isMinimodalExperience = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModalExperience = mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && isFullScreenModalAvailable && (0, $iDrrr.fg)('agent_session_experience_fg'); // TEMP FIX since we can't rely on config for single source of truth for full screen experience
    // TODO to cleanup this implementation once we can accurately rely on the config as a single source of truth for full screen experience
    const isFullScreenExperience = !!fullScreen;
    const pageTitle = (0, $3681f9f0278ae1e7$export$2417674bdeeeee0a)(selectedAgent?.name, selectedAgent?.is_default, currentConversationId, conversation?.name);
    const greetingHeight = elements?.shouldShowGreeting ? (0, $oV0CU.MINI_MODAL_GREETING_HEIGHT) : 0;
    const greetingKey = customGreeting ? 'custom' : 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d811609c19623d6$export$75fe342a4899ab80), {
        state: shareConversationModalState,
        cloudId: config.siteId,
        principalId: config.userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$FeedbackCollectorContainerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$ShareUpToMessageProviderWrapper, {
        shareUpToMessage: shareUpToMessage,
        isMessageShareable: shareConversationModalState.isMessageShareable,
        shareDisabledReason: shareConversationModalState.shareDisabledReason
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33LwY.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jjhH6.ProfileTriggerProvider), {
        renderProfileTrigger: renderProfileTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3d69e952650eeff$export$dc569ceb34d86e76), null), isPulseExperimentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aaf05328afc9c75c$export$81d79b770bf609f2), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Bxlw.RovoSkillsConfigProvider), {
        config: rovoSkillsConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ea50d39fb584b32$export$94bf5e4fee4a62be), {
        getActions: mergedGetActions,
        prioritizeCustomActionResults: replaceProviderActions || prioritizeCustomActionResults,
        numStartersToShow: customNumStartersToShow ?? numStartersToShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fBd2O.MainWrapper), {
        testId: testId,
        isNav4Enabled: isNav4Enabled,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            isEmptyConversation: isEmptyConvo
        }
    }), !!fullScreen && isEmptyConvo && config.userId && (0, $iDrrr.fg)('rovo-chat-auto-conversation-evaluator-killswitch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a19df5316a59c71$export$ff48c21c5b9b5257), {
        userId: config.userId,
        firedRef: autoConversationFiredRef
    }), isFullScreenExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderMainView(), !hideBrowserTabTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0ddd4a030c9463c6$export$155581e8dc02007a), {
        title: pageTitle
    }), !hideBrowserTabFavicon && (0, $iDrrr.fg)('rovo_chat_selected_agent_favicon_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e70d543a73f5bd2d$export$7550661a55336d56), {
        selectedAgent: selectedAgent,
        currentConversationId: currentConversationId
    })) : isFullScreenModalExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f18edf7c8a3493e$export$ab0974fd6d9a834e), {
        currentConversationId: currentConversationId,
        selectedAgentId: selectedAgentId,
        miniModalShellRef: miniModalShellRef,
        captureShellHeightOnTabChange: hasTabsView,
        onShellHeightCapture: handleShellHeightCapture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2dc017075ecc27d$export$ae12f5af34ff779c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7e1a96faeace911$export$f79759b47a91f0e7), {
        isOpen: true,
        onOpenChange: (isOpen)=>{
            if (!isOpen) closeChat();
        },
        chatHeaderProps: chatHeaderProps,
        modalContent: renderMainView({
            elements: {
                mainChatHeader: false
            }
        })
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f18edf7c8a3493e$export$ab0974fd6d9a834e), {
        currentConversationId: currentConversationId,
        selectedAgentId: selectedAgentId,
        miniModalShellRef: miniModalShellRef,
        captureShellHeightOnTabChange: hasTabsView,
        onShellHeightCapture: handleShellHeightCapture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2dc017075ecc27d$export$ae12f5af34ff779c), null, isMinimodalExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$MiniModalViewWrapper, {
        renderMiniModalMainView: renderMiniModalMainView,
        greetingHeight: greetingHeight,
        greetingKey: greetingKey,
        topOffset: topOffset,
        enableMiniModalResize: enableMiniModalResize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $007fd63f6f2d0d8e$var$styles.navBarWrapper
    }, renderMainView()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28da84cb48823e6d$export$c774df50165feb42), {
        userId: config.userId ?? '',
        siteId: config.siteId,
        product: config.product,
        conversationId: currentConversationId,
        conversationStatus: conversation?.status
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2596613472daa71a$export$c7e04f1826d84216), null), (0, $iDrrr.fg)('rovo_agents_chat_debug_mode_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7b9d3550aa1d7ec$export$5e9fd08c176f87fa), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d332ee77d3a9bec2$export$7cb7ab7fc40fc5e1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b660a9aa617f7771$export$4593c8e703770407), null), (0, $iDrrr.fg)('build_rovo_agent_sticky_skill') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b09eb397c6c150a2$export$124401e4557bee1f), {
        key: currentConversationId,
        conversationId: currentConversationId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd7f1c1de1bb802e$export$fa63c8dd87ea8148), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4186f3d50a4f7ba$export$9e01ca19610ab51c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e0ffd601ddc9a25$export$cad9f82b03ad556f), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j180q.AnalyticsPropertiesUpdater), {
        mode: mode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e517d02efc5dbf2$export$6bf0bb7de015afa9), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a386c8c1bbc50551$export$c55e2c0e0e9abdf2), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).LOAD_PANEL
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: setEditorPopupsMountPoint,
        "data-testid": "rovo-chat-input-popups-mount-point"
    }), !elements?.stagingAreaEnabled && (0, $iDrrr.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-smart-creation-suspense",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$LazySmartCreationWrapper, {
        config: config,
        handleSubmit: customHandlers?.handleSubmitSmartCreate ?? (()=>{}),
        handleClose: ()=>{
            customHandlers?.handleCloseSmartCreate?.({
                currentConversationId: currentConversationId
            });
            resetStagingArea();
        },
        shouldShowBackButton: false,
        useResendMessage: (0, $bCuI8.useResendMessage),
        enableVoiceDictation: elements?.voiceDictationButton
    })), (0, $iDrrr.fg)('fe_jira_admin_agent_eap') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee059fb9892e5b7d$export$15582ee5bba2c5a9), {
        config: config
    })))), (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$SpaceModalsWithStore, {
        cloudId: config.siteId,
        isCreateSpaceModalOpen: isCreateSpaceModalOpen,
        onCloseCreateSpace: ()=>setIsCreateSpaceModalOpen(false),
        recommendedSpaceModal: recommendedSpaceModal,
        onCloseRecommendedSpace: ()=>setRecommendedSpaceModal({
                isOpen: false
            }),
        sideNavSpaceCreatedRef: onSideNavSpaceCreatedRef,
        isManageSpaceModalOpen: isManageSpaceModalOpen,
        onCloseManageSpace: ()=>setIsManageSpaceModalOpen(false),
        selectedSpace: selectedSpace,
        activeMenu: activeMenu,
        assistanceServiceParams: {
            touchpointSource: 'rovo-chat',
            product: config.product,
            experienceId: config.experienceId ?? (0, $oV0CU.AI_MATE_EXPERIENCE_ID),
            siteId: config.siteId
        }
    }))))));
};
// segment's props are stable.
const $007fd63f6f2d0d8e$var$MemoizedConversationAssistantRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($007fd63f6f2d0d8e$var$ConversationAssistantRenderComponent, (0, $dqxOF.shallowEqualObjects)); // rovo_ttai_segment_render_stabilization ON: subscribe to only the four UI-store
// fields the root segment reads via the narrow composite selector, so the root
// re-renders only when one of those fields changes rather than on every UI-store
// state change.
const $007fd63f6f2d0d8e$var$ConversationAssistantRenderWithSelector = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useRootUISelector));
    const [{ activeMenu: activeMenu, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, selectedSpace: selectedSpace, smartLink3PPostAuth: smartLink3PPostAuth }] = (0, $bGNkz.useRootUISelector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$MemoizedConversationAssistantRender, {
        ...props,
        activeMenu: activeMenu,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        selectedSpace: selectedSpace,
        smartLink3PPostAuth: smartLink3PPostAuth
    });
}; // rovo_ttai_segment_render_stabilization OFF/control: subscribe to the broad UI
// store, matching the prior behaviour where the root re-rendered on any UI-store
// state change.
const $007fd63f6f2d0d8e$var$ConversationAssistantRenderWithBroadStore = (props)=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStore));
    const { activeMenu: activeMenu, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, selectedSpace: selectedSpace, smartLink3PPostAuth: smartLink3PPostAuth } = (0, $bGNkz.useUIStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$ConversationAssistantRenderComponent, {
        ...props,
        activeMenu: activeMenu,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        selectedSpace: selectedSpace,
        smartLink3PPostAuth: smartLink3PPostAuth
    });
};
const $007fd63f6f2d0d8e$export$1cd0cac123e432c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$ConversationAssistantRenderWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$ConversationAssistantRenderWithBroadStore, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$ConversationAssistantRenderWithSelector, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($007fd63f6f2d0d8e$var$ConversationAssistantRenderWithBroadStore, props);
};
module.exports["ConversationAssistantRender"] = $007fd63f6f2d0d8e$export$1cd0cac123e432c2;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("jXPru", function(module, exports) {
$parcel$export(module.exports, "default", () => $e88b6e60b91fc00f$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $5Sv3D = parcelRequire("5Sv3D");

function $e88b6e60b91fc00f$var$valueEquality(left, right) {
    return left === right;
}
function $e88b6e60b91fc00f$export$2e2bcd8739ae039(value, delay, options) {
    var eq = options && options.equalityFn ? options.equalityFn : $e88b6e60b91fc00f$var$valueEquality;
    var _a = (0, $cozmU.useState)(value), state = _a[0], dispatch = _a[1];
    var _b = (0, $5Sv3D.default)((0, $cozmU.useCallback)(function(value) {
        return dispatch(value);
    }, []), delay, options), callback = _b[0], cancel = _b[1], callPending = _b[2];
    var previousValue = (0, $cozmU.useRef)(value);
    (0, $cozmU.useEffect)(function() {
        // We need to use this condition otherwise we will run debounce timer for the first render (including maxWait option)
        if (!eq(previousValue.current, value)) {
            callback(value);
            previousValue.current = value;
        }
    }, [
        value,
        callback,
        eq
    ]);
    return [
        state,
        cancel,
        callPending
    ];
}

});

parcelRegister("5Sv3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $447a164f7d0faf6b$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $447a164f7d0faf6b$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $cozmU.useRef)(null);
    var maxWaitArgs = (0, $cozmU.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $cozmU.useRef)(false);
    var functionTimeoutHandler = (0, $cozmU.useRef)(null);
    var isComponentUnmounted = (0, $cozmU.useRef)(false);
    var debouncedFunction = (0, $cozmU.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $cozmU.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $cozmU.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $cozmU.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $cozmU.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("9OqBj", function(module, exports) {
const $e3eab036398f830e$export$3056677f7f7d8f5d = {
    LIME: {
        default: "var(--ds-border-accent-lime, #6A9A23)",
        icon: "var(--ds-icon-accent-lime, #6A9A23)"
    },
    RED: {
        default: "var(--ds-border-accent-red, #E2483D)",
        icon: "var(--ds-icon-accent-red, #C9372C)"
    },
    ORANGE: {
        default: "var(--ds-border-accent-orange, #E06C00)",
        icon: "var(--ds-icon-accent-orange, #E06C00)"
    },
    YELLOW: {
        default: "var(--ds-border-accent-yellow, #B38600)",
        icon: "var(--ds-icon-accent-yellow, #B38600)"
    },
    GREEN: {
        default: "var(--ds-border-accent-green, #22A06B)",
        icon: "var(--ds-icon-accent-green, #22A06B)"
    },
    TEAL: {
        default: "var(--ds-border-accent-teal, #2898BD)",
        icon: "var(--ds-icon-accent-teal, #2898BD)"
    },
    BLUE: {
        default: "var(--ds-border-accent-blue, #357DE8)",
        icon: "var(--ds-icon-accent-blue, #357DE8)"
    },
    PURPLE: {
        default: "var(--ds-border-accent-purple, #AF59E1)",
        icon: "var(--ds-icon-accent-purple, #AF59E1)"
    },
    MAGENTA: {
        default: "var(--ds-border-accent-magenta, #CD519D)",
        icon: "var(--ds-icon-accent-magenta, #CD519D)"
    },
    GRAY: {
        default: "var(--ds-border-accent-gray, #7D818A)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    DEFAULT: {
        default: "var(--ds-border, #0B120E24)",
        inverse: "var(--ds-border-inverse, #FFFFFF)",
        icon: "var(--ds-icon-subtle, #505258)"
    }
};
const $e3eab036398f830e$export$dbc6cfecd630bcea = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        const colorType = invertColors ? 'inverse' : 'default';
        return colorObject?.[colorType] ?? colorObject?.default ?? "var(--ds-border, #0B120E24)";
    }
    return invertColors ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border, #0B120E24)";
};
const $e3eab036398f830e$export$bb417e0702eb86b5 = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        if (invertColors && color === 'DEFAULT') return "var(--ds-icon-inverse, #FFFFFF)";
        return colorObject?.icon ?? "var(--ds-icon-subtle, #505258)";
    }
    return invertColors ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
};
module.exports["SKILL_COLOR_MAP"] = $e3eab036398f830e$export$3056677f7f7d8f5d;
module.exports["getBorderColor"] = $e3eab036398f830e$export$dbc6cfecd630bcea;
module.exports["getIconColor"] = $e3eab036398f830e$export$bb417e0702eb86b5;

});

parcelRegister("9MCKh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");






































const $d0265bb51b10f57e$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("d7YwR")),
    assets: ()=>(parcelRequire("69A4I")),
    add: ()=>Promise.resolve((parcelRequire("gFEZF"))),
    'chart-bar-line': ()=>(parcelRequire("kU1Yt")),
    'ai-generative-text': ()=>(parcelRequire("44fpQ")),
    'work-item': ()=>Promise.resolve((parcelRequire("iRFKG"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("4efpo"))),
    'chart-pie': ()=>(parcelRequire("e8Ghu")),
    plan: ()=>(parcelRequire("fhtzK")),
    settings: ()=>Promise.resolve((parcelRequire("11OF7"))),
    'project-status': ()=>(parcelRequire("duNV8")),
    'merge-success': ()=>(parcelRequire("3pUsI")),
    'person-add': ()=>(parcelRequire("1ORsb")),
    'people-group': ()=>Promise.resolve((parcelRequire("fBqzD"))),
    'person-added': ()=>(parcelRequire("1VVw9")),
    login: ()=>(parcelRequire("lp0Ka")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("f0b2F"))),
    transition: ()=>(parcelRequire("lPrvY")),
    board: ()=>Promise.resolve((parcelRequire("4MdqE"))),
    release: ()=>Promise.resolve((parcelRequire("2F2yY"))),
    'app-switcher': ()=>(parcelRequire("gfpxd")),
    search: ()=>Promise.resolve((parcelRequire("hAgam"))),
    'playlist-add': ()=>(parcelRequire("lJQ5X")),
    'playlist-remove': ()=>(parcelRequire("bYXrx")),
    summary: ()=>Promise.resolve((parcelRequire("f0b2F"))),
    clock: ()=>Promise.resolve((parcelRequire("5ZtfK"))),
    'ai-generative-chapters': ()=>(parcelRequire("62FON")),
    talent: ()=>(parcelRequire("j74pS")),
    incident: ()=>Promise.resolve((parcelRequire("ipvL3"))),
    form: ()=>(parcelRequire("e3rWd")),
    ticket: ()=>(parcelRequire("fS7mD")),
    alert: ()=>(parcelRequire("hBRNG")),
    pulse: ()=>(parcelRequire("4SYP6")),
    'text-lengthen': ()=>(parcelRequire("4Rd0H")),
    'ai-generative-cleanup': ()=>(parcelRequire("ivYfD")),
    survey: ()=>(parcelRequire("eNJEs")),
    'text-review': ()=>(parcelRequire("9ImZK"))
};
const $d0265bb51b10f57e$export$ca2f546e21dcce87 = $d0265bb51b10f57e$export$dce8bc0f04f0d915.skill;
const $d0265bb51b10f57e$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($d0265bb51b10f57e$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $cozmU.lazy)(loader)
    ]));
const $d0265bb51b10f57e$export$78596fa6083c04d1 = $d0265bb51b10f57e$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $d0265bb51b10f57e$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $d0265bb51b10f57e$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $d0265bb51b10f57e$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $d0265bb51b10f57e$export$78596fa6083c04d1;

});

parcelRegister("d7YwR", function(module, exports) {

let $98eae1a14b896567$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98eae1a14b896567$var$load("ji2ex").then(()=>parcelRequire('h5LaW'));

});

parcelRegister("69A4I", function(module, exports) {

let $47af911cf9753809$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47af911cf9753809$var$load("69hvJ").then(()=>parcelRequire('437ur'));

});

parcelRegister("kU1Yt", function(module, exports) {

let $f37a91b0c5a24fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a91b0c5a24fd5$var$load("hrkGn").then(()=>parcelRequire('5kuIA'));

});

parcelRegister("44fpQ", function(module, exports) {

let $2f637e6c42f731d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f637e6c42f731d0$var$load("5k22f").then(()=>parcelRequire('9V507'));

});

parcelRegister("e8Ghu", function(module, exports) {

let $a4b29c33d05c1a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4b29c33d05c1a9b$var$load("c6nMJ").then(()=>parcelRequire('eVhjN'));

});

parcelRegister("fhtzK", function(module, exports) {

let $b1ff629eca57471a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1ff629eca57471a$var$load("i1I18").then(()=>parcelRequire('dIT3V'));

});

parcelRegister("duNV8", function(module, exports) {

let $9d34ccdd49f0003a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d34ccdd49f0003a$var$load("bSZcP").then(()=>parcelRequire('6fcYF'));

});

parcelRegister("3pUsI", function(module, exports) {

let $27cf81197ca52259$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27cf81197ca52259$var$load("3GLMP").then(()=>parcelRequire('bAdTB'));

});

parcelRegister("1ORsb", function(module, exports) {

let $1533ecb52c97b893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1533ecb52c97b893$var$load("kBatH").then(()=>parcelRequire('am3XR'));

});

parcelRegister("1VVw9", function(module, exports) {

let $1687bb1e68c06fb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687bb1e68c06fb7$var$load("iN26T").then(()=>parcelRequire('4s4Os'));

});

parcelRegister("lp0Ka", function(module, exports) {

let $f94c827133a4a8ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94c827133a4a8ea$var$load("85Ack").then(()=>parcelRequire('hPGQU'));

});

parcelRegister("lPrvY", function(module, exports) {

let $fe43b4375d61c3d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe43b4375d61c3d3$var$load("jjuzw").then(()=>parcelRequire('iJGPY'));

});

parcelRegister("gfpxd", function(module, exports) {

let $bd41dab43722c8d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd41dab43722c8d5$var$load("dnVmf").then(()=>parcelRequire('9ib3C'));

});

parcelRegister("lJQ5X", function(module, exports) {

let $fd3635f2e5aabac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd3635f2e5aabac0$var$load("glmO2").then(()=>parcelRequire('3yAls'));

});

parcelRegister("bYXrx", function(module, exports) {

let $8b93687e70d55260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b93687e70d55260$var$load("32NHR").then(()=>parcelRequire('e3DmL'));

});

parcelRegister("62FON", function(module, exports) {

let $46635e3aa0f21791$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46635e3aa0f21791$var$load("8GFi1").then(()=>parcelRequire('dQeg1'));

});

parcelRegister("j74pS", function(module, exports) {

let $dea218c262683901$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dea218c262683901$var$load("iWYx4").then(()=>parcelRequire('f1G8J'));

});

parcelRegister("e3rWd", function(module, exports) {

let $a3b7046b3b58e574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b7046b3b58e574$var$load("cXTJH").then(()=>parcelRequire('bFnmR'));

});

parcelRegister("fS7mD", function(module, exports) {

let $b8e19c809ca15790$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8e19c809ca15790$var$load("kMmm1").then(()=>parcelRequire('2ZUqo'));

});

parcelRegister("hBRNG", function(module, exports) {

let $cd1f9ffc4306ed9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd1f9ffc4306ed9a$var$load("k25pB").then(()=>parcelRequire('QrYx2'));

});

parcelRegister("4SYP6", function(module, exports) {

let $38eb62ceae487952$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38eb62ceae487952$var$load("aWKP7").then(()=>parcelRequire('dK3CB'));

});

parcelRegister("4Rd0H", function(module, exports) {

let $3896343509561fa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3896343509561fa9$var$load("kfhZM").then(()=>parcelRequire('2xJ2w'));

});

parcelRegister("ivYfD", function(module, exports) {

let $d7a9dbdfd2c52ad4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7a9dbdfd2c52ad4$var$load("2bJoN").then(()=>parcelRequire('7Jde4'));

});

parcelRegister("eNJEs", function(module, exports) {

let $ac690dbfdd63bd67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac690dbfdd63bd67$var$load("bGOwY").then(()=>parcelRequire('2WCju'));

});

parcelRegister("9ImZK", function(module, exports) {

let $712a0f72ca3115b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $712a0f72ca3115b0$var$load("k6TzV").then(()=>parcelRequire('4u3xL'));

});

parcelRegister("80Hjq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $91ZZN = parcelRequire("91ZZN");


var $9OqBj = parcelRequire("9OqBj");


var $9MCKh = parcelRequire("9MCKh");

const $31cabecc30b48f33$var$hovercardStyles = {
    container: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _39xV02sz7G _2fwxA5ecOK",
    containerScrollable: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _39xV02sz7G _2fwxA5ecOK _2WAcuGIZbP",
    skillName: "_1kk5Tkmb2E _1DCdHi2ADO _0hPCNLDIqT",
    product: "_3138428HPE _1UtDYzZpcK _0hPCNLDIqT _41LZZBMRGa"
};
const $31cabecc30b48f33$export$8582aebd1d6355d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    let T0;
    let T1;
    let T2;
    let product;
    let props;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] !== t0) {
        const { product: t7, iconName: iconName, maxHeight: maxHeight, ...t8 } = t0;
        product = t7;
        props = t8;
        const IconComponent = iconName ? (0, $9MCKh.skillIconMap)[iconName] : undefined;
        T2 = (0, $iMnC5.Box);
        t4 = "skill-hovercard-content";
        t5 = maxHeight !== undefined ? $31cabecc30b48f33$var$hovercardStyles.containerScrollable : $31cabecc30b48f33$var$hovercardStyles.container;
        if ($[12] !== maxHeight) {
            t6 = {
                maxHeight: maxHeight
            };
            $[12] = maxHeight;
            $[13] = t6;
        } else t6 = $[13];
        T1 = (0, $dinVW.Stack);
        T0 = (0, $1l0kj.Inline);
        t1 = $31cabecc30b48f33$var$hovercardStyles.skillName;
        t2 = "space.100";
        t3 = IconComponent && /*#__PURE__*/ $cozmU.createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "skill-tag-hovercard-icon"
        }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
            label: "",
            size: "medium",
            color: (0, $9OqBj.getIconColor)(props?.color, props?.invertColors)
        }));
        $[0] = t0;
        $[1] = T0;
        $[2] = T1;
        $[3] = T2;
        $[4] = product;
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else {
        T0 = $[1];
        T1 = $[2];
        T2 = $[3];
        product = $[4];
        props = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
    }
    let t7;
    if ($[14] !== props.name) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, props.name);
        $[14] = props.name;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== T0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t1,
            space: t2
        }, t3, t7);
        $[16] = T0;
        $[17] = t1;
        $[18] = t2;
        $[19] = t3;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== props.description) {
        t9 = props.description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text"
        }, props.description));
        $[22] = props.description;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== product || $[25] !== props.productIconUrl) {
        t10 = product && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $31cabecc30b48f33$var$hovercardStyles.product,
            space: "space.075"
        }, props.productIconUrl && /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: props.productIconUrl,
            testId: `${product}-icon`,
            alt: "",
            width: 16,
            height: 16
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, product));
        $[24] = product;
        $[25] = props.productIconUrl;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== T1 || $[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement(T1, null, t8, t9, t10);
        $[27] = T1;
        $[28] = t10;
        $[29] = t8;
        $[30] = t9;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== T2 || $[33] !== t11 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6) {
        t12 = /*#__PURE__*/ $cozmU.createElement(T2, {
            testId: t4,
            xcss: t5,
            style: t6
        }, t11);
        $[32] = T2;
        $[33] = t11;
        $[34] = t4;
        $[35] = t5;
        $[36] = t6;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : ({ product: product, iconName: iconName, maxHeight: maxHeight, ...props })=>{
    const IconComponent = iconName ? (0, $9MCKh.skillIconMap)[iconName] : undefined;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "skill-hovercard-content",
        xcss: maxHeight !== undefined ? $31cabecc30b48f33$var$hovercardStyles.containerScrollable : $31cabecc30b48f33$var$hovercardStyles.container,
        style: {
            maxHeight: maxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $31cabecc30b48f33$var$hovercardStyles.skillName,
        space: "space.100"
    }, IconComponent && /*#__PURE__*/ $cozmU.createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "skill-tag-hovercard-icon"
    }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
        label: "",
        size: "medium",
        color: (0, $9OqBj.getIconColor)(props?.color, props?.invertColors)
    })), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, props.name)), props.description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text"
    }, props.description)), product && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $31cabecc30b48f33$var$hovercardStyles.product,
        space: "space.075"
    }, props.productIconUrl && /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: props.productIconUrl,
        testId: `${product}-icon`,
        alt: "",
        width: 16,
        height: 16
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, product))));
};
module.exports["SkillHoverCardContent"] = $31cabecc30b48f33$export$8582aebd1d6355d8;

});

parcelRegister("f6VI9", function(module, exports) {
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $ae2233479ab8cd62$export$2cffb029ea623d71;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("d26Wq", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $f720e28b5e390709$var$EMOJI_URL = '/gateway/api/emoji';
// Module-level caches keyed by cloudId — ensures a single EmojiResource (and therefore
// a single set of 3 network requests) is created per cloud, regardless of how many
// components call createEmojiProvider with the same cloudId.
const $f720e28b5e390709$var$emojiProviderCache = new Map();
const $f720e28b5e390709$var$emojiProviderWithUploadCache = new Map();
function $f720e28b5e390709$export$7ebac39e9c0c57ba(cloudId) {
    const cached = $f720e28b5e390709$var$emojiProviderCache.get(cloudId);
    if (cached) return cached;
    const provider = new (0, $kwzZh.default)({
        providers: [
            {
                url: `${$f720e28b5e390709$var$EMOJI_URL}/standard`
            },
            {
                url: `${$f720e28b5e390709$var$EMOJI_URL}/atlassian`
            },
            {
                url: `${$f720e28b5e390709$var$EMOJI_URL}/${cloudId}/site`
            }
        ]
    }).getEmojiProvider();
    $f720e28b5e390709$var$emojiProviderCache.set(cloudId, provider);
    return provider;
}
function $f720e28b5e390709$export$a3db772651192701(cloudId) {
    const cached = $f720e28b5e390709$var$emojiProviderWithUploadCache.get(cloudId);
    if (cached) return cached;
    const provider = new (0, $kwzZh.default)({
        providers: [
            {
                url: `${$f720e28b5e390709$var$EMOJI_URL}/standard`
            },
            {
                url: `${$f720e28b5e390709$var$EMOJI_URL}/atlassian`
            },
            {
                url: `${$f720e28b5e390709$var$EMOJI_URL}/${cloudId}/site`
            }
        ],
        allowUpload: true
    }).getEmojiProvider();
    $f720e28b5e390709$var$emojiProviderWithUploadCache.set(cloudId, provider);
    return provider;
}
module.exports["createEmojiProvider"] = $f720e28b5e390709$export$7ebac39e9c0c57ba;
module.exports["createEmojiProviderWithUpload"] = $f720e28b5e390709$export$a3db772651192701;

});

parcelRegister("h5LaW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab3e94a0351617220fd3a9ec43bebd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7177f5d9d65cd37$var$_react = $c7177f5d9d65cd37$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c7177f5d9d65cd37$var$_baseNew = $c7177f5d9d65cd37$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c7177f5d9d65cd37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Skill".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/skill
 * Usage guidance:
 * Reserved for skill functionality. Skills are a combination of tools and a prompt to allow an agent to perform a multistep process.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7177f5d9d65cd37$var$SkillIcon = (props)=>/*#__PURE__*/ $c7177f5d9d65cd37$var$_react.default.createElement($c7177f5d9d65cd37$var$_baseNew.default, Object.assign({
        name: "SkillIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="m11.11 4.934-5 7-1.22-.871 5-7z"/>`
    }, props));
$c7177f5d9d65cd37$var$SkillIcon.displayName = 'SkillIcon';
var $c7177f5d9d65cd37$var$_default = module.exports.default = $c7177f5d9d65cd37$var$SkillIcon;

});

parcelRegister("fGEnS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5Sv3D = parcelRequire("5Sv3D");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

const $939b94e7bf382323$var$hovercardStyles = {
    trigger: "_39xV02N91d"
};
const $939b94e7bf382323$export$57a077cc9fbe653e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { content: content, children: children, placement: t1, autoFocus: t2, fallbackPlacements: t3, disabled: t4, hoverCardDelay: t5, testId: testId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: t6 } = t0;
    const placement = t1 === undefined ? "left" : t1;
    const autoFocus = t2 === undefined ? false : t2;
    let t7;
    if ($[0] !== t3) {
        t7 = t3 === undefined ? [
            "bottom",
            "left",
            "right"
        ] : t3;
        $[0] = t3;
        $[1] = t7;
    } else t7 = $[1];
    const fallbackPlacements = t7;
    const disabled = t4 === undefined ? false : t4;
    const hoverCardDelay = t5 === undefined ? 200 : t5;
    const shouldRenderToParent = t6 === undefined ? true : t6;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t8;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (open)=>{
            setIsOpen(open);
        };
        $[2] = t8;
    } else t8 = $[2];
    const [setIsOpenDebounced, cancelSetIsOpen] = (0, $5Sv3D.default)(t8, hoverCardDelay);
    const contentId = (0, $cozmU.useId)();
    if (disabled) return children;
    let t9;
    if ($[3] !== cancelSetIsOpen || $[4] !== content || $[5] !== contentId || $[6] !== setIsOpenDebounced || $[7] !== testId) {
        t9 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                id: contentId,
                as: "span",
                onMouseEnter: ()=>cancelSetIsOpen(),
                onMouseLeave: ()=>setIsOpenDebounced(false),
                testId: testId ? `${testId}--content` : undefined
            }, content);
        $[3] = cancelSetIsOpen;
        $[4] = content;
        $[5] = contentId;
        $[6] = setIsOpenDebounced;
        $[7] = testId;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== children || $[10] !== contentId || $[11] !== onMouseEnter || $[12] !== onMouseLeave || $[13] !== setIsOpenDebounced || $[14] !== testId) {
        t10 = (triggerProps)=>{
            const { "aria-expanded": _ariaExpanded, ...restTriggerProps } = triggerProps;
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "span",
                ...restTriggerProps,
                "aria-describedby": contentId,
                testId: testId ? `${testId}--trigger` : undefined,
                xcss: $939b94e7bf382323$var$hovercardStyles.trigger,
                onMouseEnter: ()=>{
                    setIsOpenDebounced(true);
                    onMouseEnter?.();
                },
                onMouseLeave: ()=>{
                    setIsOpenDebounced(false);
                    onMouseLeave?.();
                }
            }, children);
        };
        $[9] = children;
        $[10] = contentId;
        $[11] = onMouseEnter;
        $[12] = onMouseLeave;
        $[13] = setIsOpenDebounced;
        $[14] = testId;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== autoFocus || $[17] !== fallbackPlacements || $[18] !== isOpen || $[19] !== placement || $[20] !== shouldRenderToParent || $[21] !== t10 || $[22] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            autoFocus: autoFocus,
            isOpen: isOpen,
            shouldRenderToParent: shouldRenderToParent,
            content: t9,
            trigger: t10
        });
        $[16] = autoFocus;
        $[17] = fallbackPlacements;
        $[18] = isOpen;
        $[19] = placement;
        $[20] = shouldRenderToParent;
        $[21] = t10;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : ({ content: content, children: children, placement: placement = 'left', autoFocus: autoFocus = false, fallbackPlacements: fallbackPlacements = [
    'bottom',
    'left',
    'right'
], disabled: disabled = false, hoverCardDelay: hoverCardDelay = 200, testId: testId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent = true })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [setIsOpenDebounced, cancelSetIsOpen] = (0, $5Sv3D.default)((open)=>{
        setIsOpen(open);
    }, hoverCardDelay);
    const contentId = (0, $cozmU.useId)();
    if (disabled) return children;
    return /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        autoFocus: autoFocus,
        isOpen: isOpen,
        shouldRenderToParent: shouldRenderToParent,
        content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                id: contentId,
                as: "span",
                onMouseEnter: ()=>cancelSetIsOpen(),
                onMouseLeave: ()=>setIsOpenDebounced(false),
                testId: testId ? `${testId}--content` : undefined
            }, content),
        trigger: (triggerProps)=>{
            // Filter out aria-expanded - it's invalid on non-interactive elements like <span>
            // aria-expanded is only valid on interactive elements (e.g., button, menuitem)
            // Use aria-describedby instead to link the trigger to the content for screen readers
            const { 'aria-expanded': _ariaExpanded, ...restTriggerProps } = triggerProps;
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "span",
                ...restTriggerProps,
                "aria-describedby": contentId,
                testId: testId ? `${testId}--trigger` : undefined,
                xcss: $939b94e7bf382323$var$hovercardStyles.trigger,
                onMouseEnter: ()=>{
                    setIsOpenDebounced(true);
                    onMouseEnter?.();
                },
                onMouseLeave: ()=>{
                    setIsOpenDebounced(false);
                    onMouseLeave?.();
                }
            }, children);
        }
    });
};
module.exports["HoverCard"] = $939b94e7bf382323$export$57a077cc9fbe653e;

});

parcelRegister("l0ley", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $af1517f9f6c663e4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "ai-mate.auto-suggest-skills-browse.title",
        defaultMessage: "Suggested skills"
    },
    viewAllSkills: {
        id: "ai-mate.auto-suggest-skills-browse.view-all-skills",
        defaultMessage: "View all skills"
    },
    skillsSectionTitle: {
        id: "ai-mate.auto-suggest-floating-menu.skills-section-title",
        defaultMessage: "Skills"
    },
    spacesSectionTitle: {
        id: "ai-mate.auto-suggest-floating-menu.spaces-section-title",
        defaultMessage: "Go to space"
    },
    floatingMenuLabel: {
        id: "ai-mate.auto-suggest-floating-menu.listbox-label",
        defaultMessage: "Suggestions"
    }
});
module.exports["messages"] = $af1517f9f6c663e4$export$defe85febe8b728c;

});

parcelRegister("gJYG3", function(module, exports) {

let $c2ffea8ffedc7df7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2ffea8ffedc7df7$var$load("ftVX2").then(()=>parcelRequire('iA4W4'));

});

parcelRegister("33LwY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aRGok = parcelRequire("aRGok");


var $lBLkF = parcelRequire("lBLkF");

const $f5ab76195383586f$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $cozmU.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $cozmU.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $f5ab76195383586f$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $cozmU.useRef)(1);
    const [modals, setModals] = (0, $cozmU.useState)([]);
    const modalContext = (0, $cozmU.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lBLkF.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ab76195383586f$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}
module.exports["ModalContextProvider"] = $f5ab76195383586f$export$7c9538f5f3c365e9;

});

parcelRegister("lBLkF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c322ca8bb35efad1$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
});
module.exports["ModalContext"] = $c322ca8bb35efad1$export$ab57792b9b6974a6;

});

parcelRegister("ZKswU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $8lhhf = parcelRequire("8lhhf");


var $7dHQW = parcelRequire("7dHQW");

const $326b9cee4ac976c2$var$PROMPT_CATEGORIES = [
    'Analyze',
    'Brainstorm',
    'Review',
    'Summarize',
    'Create',
    'Execute',
    'Find',
    'Learn'
];
const $326b9cee4ac976c2$var$PROMPT_ROLES = [
    'General',
    'Engineering',
    'Product',
    'Program Management',
    'Design',
    'Marketing',
    'IT Ops',
    'Sales',
    'Customer Support',
    'Helpdesk Support',
    'Security'
];
const $326b9cee4ac976c2$var$createFilterOptions = (values)=>values.map((value)=>({
            id: value,
            label: value
        }));
const $326b9cee4ac976c2$export$9fa6e712ef03097f = $326b9cee4ac976c2$var$createFilterOptions($326b9cee4ac976c2$var$PROMPT_CATEGORIES);
const $326b9cee4ac976c2$export$9472c6a87dde5170 = $326b9cee4ac976c2$var$createFilterOptions($326b9cee4ac976c2$var$PROMPT_ROLES);
const $326b9cee4ac976c2$export$1ac99e1b5b1a8cfe = 'rovo-chat-prompt-gallery';
const $326b9cee4ac976c2$export$bee44b12dce7b448 = (prompt)=>{
    const slugs = [];
    const slashSkillPattern = new RegExp((0, $8lhhf.ROVO_SKILL_TAG_PATTERN).source, 'g');
    for (const m of prompt.matchAll(slashSkillPattern))slugs.push(m[1]);
    return slugs;
};
// Prompts with multiple placeholders are commented out until they are supported by this
// PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/217105
const $326b9cee4ac976c2$var$staticPrompts = [
    {
        id: 'analyze-customer-feedback-trends',
        title: 'Analyze customer feedback trends',
        prompt: 'Gather and synthesize customer feedback on `product/feature` from various channels such as emails, calls, surveys, support tickets to identify key themes, pain points, opportunities such as upsell and adoption, and organize findings into actionable recommendations. If relevant, map them to stages of the customer journey.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Program Management',
            'Customer Support',
            'Sales'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'analyze-it-support-trends',
    // 	title: 'Analyze Trends in IT Support Requests',
    // 	prompt:
    // 		'Examine all IT support requests related to `request type` from the past `number of months` months. Break down the request type by identifying the most common sub-categories and providing counts for each. Investigate resolution notes or agent comments to uncover recurring root causes behind these issues. Identify any time-based patterns, such as spikes in requests during specific times of day, days of the week, or months. Based on your findings, recommend actionable strategies to effectively reduce the volume of this request type.',
    // 	useCase: 'Analyze',
    // 	roles: ['Helpdesk Support', 'IT Ops', 'Customer Support', 'Program Management'],
    // },
    {
        id: 'brainstorm-project-ideas',
        title: 'Brainstorm ideas for project',
        prompt: "We're running a brainstorming session on `topic/problem/goal`. Generate a diverse list of creative ideas, solutions, and/or approaches. For each idea, include a brief description, potential benefits, and any risks or challenges. Organize the ideas by theme or category if possible.",
        useCase: 'Brainstorm',
        roles: [
            'General'
        ]
    },
    {
        id: 'send-slack-weekly-progress',
        title: 'Send Slack message of weekly progress',
        prompt: 'Draft a summary of the key updates and additions I made over the past week. Send this summary in Slack to `Teams channel link`. Confirm the draft with me before sending.',
        useCase: 'Execute',
        roles: [
            'General'
        ]
    },
    {
        id: 'compare-jira-support-article',
        title: 'Compare Jira work item to support article',
        prompt: 'Review the summary, description, and comments of the current request `work item ID`. Based on this information and considering common themes from recently resolved requests, determine if this issue points to a recurring problem that currently lacks a dedicated knowledge base article. If so, propose a concise title for a new knowledge base article and 2-3 key topics or resolution steps it should cover. This should be a distinct problem, not a minor variation of an existing knowledge base article.',
        useCase: 'Review',
        roles: [
            'Helpdesk Support',
            'Customer Support',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'conduct-competitive-research',
    // 	title: 'Conduct competitive research',
    // 	prompt:
    // 		'Analyze the competitive landscape for `product` against `Competitor A, B, C, and D` by comparing features, pricing, market positioning, and strengths. Identify market gaps for `product` to explore. Summarize findings in a narrative, including a comparison matrix.',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management', 'Marketing', 'Sales'],
    // },
    {
        id: 'convert-request-jql-query',
        title: 'Convert request into JQL query',
        prompt: 'Write a JQL query to find all unresolved bugs assigned to my team in the last 30 days.',
        useCase: 'Execute',
        roles: [
            'Engineering',
            'Product',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'create-jira-work-item-summaries',
    // 	title: 'Create a document of Jira work item summaries',
    // 	prompt:
    // 		'Generate a Confluence page summarizing information in these work items: `work item ID(s)`.',
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Program Management', 'Engineering', 'Customer Support'],
    // },
    // {
    // 	id: 'create-new-sprint',
    // 	title: 'Create a new sprint',
    // 	prompt:
    // 		'Create a new sprint named `sprint name` on the board: `board key`. Set the sprint goal to `sprint goal`, start date to `YYYY-MM-DD`, and end date to `YYYY-MM-DD`.',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'create-ab-testing-plan',
        title: 'Create A/B testing plan',
        prompt: 'Create a detailed A/B testing plan for `project/feature`. Start by defining the hypothesis and primary goal, specifying the variants to be tested, and identifying the key metric(s) for success. Outline the target audience and sample size, describe how users will be randomly assigned to each group, and set the test duration and timeline. Include steps for implementation, data collection, and analysis, and note any tools or platforms to be used. Finally, add placeholders for documenting results, learnings, and next steps, ensuring the plan is clear, actionable, and easy to adapt for different experiments, with space for users to add or modify details as needed.',
        useCase: 'Create',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Design'
        ]
    },
    // {
    // 	id: 'create-effective-okr',
    // 	title: 'Create an effective OKR',
    // 	prompt: 'Help me create an effective OKR for my team.',
    // 	useCase: 'Create',
    // 	roles: ['General', 'Product', 'Program Management'],
    // },
    {
        id: 'create-background-research-plan',
        title: 'Create background research plan',
        prompt: 'Create a first draft or conduct background research on `topic/work item`. Summarise key points, relevant history, and provide links to supporting documents.',
        useCase: 'Summarize',
        roles: [
            'Product',
            'Program Management',
            'Engineering',
            'Design'
        ]
    },
    {
        id: 'create-customer-onboarding-strategy',
        title: 'Create customer onboarding strategy',
        prompt: 'As a customer success lead, outline a clear customer onboarding strategy for `product or service`, including key objectives, main onboarding steps, communication touchpoints, and success metrics; highlight best practices for activation and engagement, and provide space for users to add project-specific details or adapt the strategy for different customer segments, ensuring the plan is concise, actionable, and easy to share with stakeholders.',
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Sales',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'create-jira-work-item',
    // 	title: 'Create Jira work item',
    // 	prompt:
    // 		'Create a Jira work item in project `project key` with work type as `bug/task/story/epic`, status as TO DO, classification level as project default, and the summary "`summary`."',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'IT Ops', 'Customer Support'],
    // },
    // {
    // 	id: 'create-meeting-agenda',
    // 	title: 'Create meeting agenda',
    // 	prompt:
    // 		'Create a `number of minutes/hours` meeting agenda with `person/team/department` on `meeting topic` to discuss `objectives for the meeting`. Based on these objectives, suggest key topics, allocate appropriate time for each, and list any supporting materials needed.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-personalized-onboarding-plan',
    // 	title: 'Create personalized onboarding plan',
    // 	prompt:
    // 		'Create a 30-day plan to help me get up to speed. I am onboarding onto `team` as a `role`. Include learning resources, team priorities, key contacts, and engagement strategies.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-presentation-outline',
    // 	title: 'Create presentation outline',
    // 	prompt:
    // 		'Outline a talk track for a presentation targeting `company/product` clients in the `sector` to educate them on the `solution`. Ensure the talk track is clear, informative, and formatted with timestamps in a table.',
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    // {
    // 	id: 'create-pricing-model-customers',
    // 	title: 'Create pricing model for customers',
    // 	prompt:
    // 		'Generate a pricing model for `customer/product` using the latest customer data. Include scenario analysis and pricing plan comparisons.',
    // 	useCase: 'Create',
    // 	roles: ['Sales', 'Product', 'Marketing'],
    // },
    {
        id: 'create-product-requirements-document',
        title: 'Create product requirements document',
        prompt: 'Draft a PRD for `project/feature`. Depending on context such as OKRs, PRD, A/B test, retrospective, include objectives, hypotheses, requirements, metrics, learnings, and next steps.',
        useCase: 'Create',
        roles: [
            'Program Management',
            'Design',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'create-recurring-calendar-meeting',
    // 	title: 'Create recurring calendar meeting',
    // 	prompt:
    // 		'Create a `number of minutes` recurring calendar meeting every `day` at `HH:MM am/pm` `timezone` for `project` with `person`.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-release-notes',
    // 	title: 'Create release notes',
    // 	prompt:
    // 		'Create clear release documentation for `project/product`. Include release date, features, fixes, known issues, and Jira work items/references if found. Provide output in multiple formats such as Confluence, PDF, Markdown as needed.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'Customer Support'],
    // },
    // {
    // 	id: 'create-resolution-notes',
    // 	title: 'Create resolution notes',
    // 	prompt:
    // 		'Create resolution notes for future reference suitable for other agents and team leads to quickly understand the following work item and its resolution: `work item link`. Include a brief and clear description of the problem, the identified root cause, and a summary of the diagnostic steps and actions performed. Clearly state the exact resolution that was implemented. Specify the total time from ticket creation to resolution using HH:MM format, or days/hours if longer.',
    // 	useCase: 'Create',
    // 	roles: ['Helpdesk Support', 'Customer Support', 'IT Ops'],
    // },
    // {
    // 	id: 'draft-blog-post',
    // 	title: 'Draft a blog post',
    // 	prompt:
    // 		'Draft a blog post or marketing collateral for `product/feature`. Highlight key benefits, use cases, and include customer testimonials if available.',
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Product', 'Sales'],
    // },
    // {
    // 	id: 'draft-usability-testing-script',
    // 	title: 'Draft a usability testing script',
    // 	prompt:
    // 		'Draft a detailed usability testing script for the following feature/product `Confluence page link`. The script should be suitable for a moderated session and include the following sections: Introduction for the participant (Reassure the participant that the focus is on the product, not their performance), Warm-up/background questions, Scenario setup, Task instructions, and Wrap-up questions. For each task, specify what a successful outcome looks like and, if appropriate, include a rating scale for ease of use. Throughout, use accessible, concise, and clear language, avoid jargon and directional UI language, keep instructions and questions short and focused, and ensure the script is easy to follow for both moderator and participant, formatting it as a template that can be easily adapted for different products or features',
    // 	useCase: 'Create',
    // 	roles: ['Design', 'Product'],
    // },
    // {
    // 	id: 'draft-and-send-email',
    // 	title: 'Draft and send email',
    // 	prompt:
    // 		"Draft an email to `email address` with the subject `Subject` with a message regarding `topic/purpose`. Once I've confirmed, send this email.",
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'edit-confluence-page-status',
        title: 'Edit Confluence page status',
        prompt: "Update this page's status to Ready for Review: `Confluence page link`",
        useCase: 'Execute',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'explain-acronym',
    // 	title: 'Explain an acronym',
    // 	prompt:
    // 		"Explain the meaning of the acronym '`acronym`' in this context: `context`. Provide its full form and a brief definition.",
    // 	useCase: 'Learn',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'explain-end-to-end-service-flow',
    // 	title: 'Explain End-to-End Service Flow',
    // 	prompt:
    // 		'Explain the `process/system flow` for `feature` as experienced by `end-user/customer`. Include each step from `start event` to `end event`. Highlight any system interactions, notifications, and common issues or exceptions. Provide diagrams or documentation links if available.',
    // 	useCase: 'Learn',
    // 	roles: [
    // 		'Sales',
    // 		'IT Ops',
    // 		'Program Management',
    // 		'Customer Support',
    // 		'Product',
    // 		'Security',
    // 		'Helpdesk Support',
    // 		'Engineering',
    // 	],
    // },
    {
        id: 'explain-code',
        title: 'Explain this code',
        prompt: 'Explain what the code below does, describing its purpose, how it works, and any important details or logic involved. Use clear, concise language suitable for someone with basic programming knowledge. `Insert code snippet`.',
        useCase: 'Learn',
        roles: [
            'Engineering'
        ]
    },
    {
        id: 'extract-key-insights-datasets',
        title: 'Extract key insights from datasets',
        prompt: '`Upload dataset file(s)` Based on the provided dataset, please analyze and present the top 5 most interesting observations, highlights, or trends, identifying segments that were more likely to respond in a certain way, significant patterns, or unexpected insights from the data.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-analyze-customer-contracts',
    // 	title: 'Find and analyze information from customer contracts',
    // 	prompt:
    // 		'Analyze all existing contracts for `project/customer segment/time period` and extract information on response times, maintenance obligations, and product rates. Present findings in a comparative table, highlighting any variations between customers. If available, include contract names (`Contract name/ID`), customer names (`Customer A, Customer B]), and any relevant contract dates (`Effective Date, Expiry Date`).',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management'],
    // },
    {
        id: 'find-prioritize-open-pull-requests',
        title: 'Find and prioritize open pull requests',
        prompt: "Summarize all my open pull requests in across all repositories I have access to in Bitbucket, as well as all pull requests where I'm assigned as a reviewer. Clearly indicate the number of pull requests pending my review and the total number of open PRs involving me. Group the results by repository and include key details such as PR title, status, author, and last updated date.",
        useCase: 'Summarize',
        roles: [
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-hr-policies',
    // 	title: 'Find HR policies',
    // 	prompt:
    // 		'Find all the HR policies that a new hire joining the `location` office would need during onboarding. Reference the latest HR policy resources. Organize results in a table and check if all required policies and contacts are included.',
    // 	useCase: 'Find',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'find-information-3p-sources',
    // 	title: 'Find information from 3P sources',
    // 	prompt: 'Find the latest `topic` presentation in our Google Drive or other 3rd party sources.',
    // 	useCase: 'Find',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    {
        id: 'find-overdue-jira-work-items',
        title: 'Find overdue Jira work items for my team',
        prompt: 'Show all overdue work items for my team, including links to them and how long they have been overdue.',
        useCase: 'Find',
        roles: [
            'Engineering',
            'IT Ops',
            'Helpdesk Support',
            'Program Management'
        ]
    },
    // {
    // 	id: 'find-potential-security-vulnerabilities',
    // 	title: 'Find potential security vulnerabilities',
    // 	prompt:
    // 		'For this pull request `pull request ID`, identify and summarize any changes that were made that have potential security vulnerabilities.',
    // 	useCase: 'Find',
    // 	roles: ['Security', 'IT Ops'],
    // },
    // {
    // 	id: 'find-related-jira-projects',
    // 	title: 'Find related Jira projects',
    // 	prompt: 'What Jira projects have ongoing work that relates to this decision: `description`?',
    // 	useCase: 'Find',
    // 	roles: ['Program Management', 'Product', 'Engineering'],
    // },
    {
        id: 'find-relevant-confluence-pages',
        title: 'Find relevant Confluence pages',
        prompt: 'For `work item ID/project/feature`, find and list any related Confluence pages or reference work items. Include links and a brief summary of how each is relevant.',
        useCase: 'Find',
        roles: [
            'Program Management',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-requirements-jira-work-item',
    // 	title: 'Find requirements for a Jira work item',
    // 	prompt:
    // 		'Identify and document the requirements for work item `work item ID`. Ensure all necessary details are captured, including dependencies and acceptance criteria.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'find-subject-matter-expertise',
    // 	title: 'Find subject-matter expertise',
    // 	prompt:
    // 		'Find the subject matter expert for `topic`. I need to contact them for `purpose, e.g., advice, review, collaboration`. Confirm the recommended person is the most relevant and available expert.',
    // 	useCase: 'Find',
    // 	roles: ['General', 'Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'draft-it-support-response',
    // 	title: 'Draft IT Support response',
    // 	prompt:
    // 		'Draft a reply to a user who is experiencing `topic` issues. Provide clear, empathetic guidance and suggest next steps for resolving the problem using this guide/playbook [Confluence page link]. Here is the user request: `User request`.',
    // 	useCase: 'Create',
    // 	roles: ['Customer Support', 'Helpdesk Support'],
    // },
    {
        id: 'find-latest-company-policies',
        title: 'Find the latest company policies',
        prompt: 'How do I request reimbursements for my travels?',
        useCase: 'Learn',
        roles: [
            'General'
        ]
    },
    {
        id: 'generate-faq',
        title: 'Generate an FAQ',
        prompt: "Map out the typical customer journey for `product/service`, from initial discovery through onboarding, usage, and support. Then, generate top FAQs that customers most frequently ask at each stage\u2014covering how to get started, feature usage, troubleshooting, billing, and best practices\u2014with concise, step-by-step answers formatted for a chatbot.",
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Program Management',
            'Product',
            'Marketing'
        ]
    },
    {
        id: 'generate-post-project-surveys',
        title: 'Generate post-project surveys',
        prompt: "Create a comprehensive evaluation survey for `project` to assess the project's performance, including successes, challenges, areas for improvement, and lessons learned. Include questions such as scale, multiple choice, and open answer covering: objectives and outcomes, budget and resources, team performance and collaboration, challenges and problem-solving, stakeholder satisfaction, and recommendations for future projects.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Product',
            'General'
        ]
    },
    // {
    // 	id: 'identify-upsell-opportunities',
    // 	title: 'Identify upsell opportunities',
    // 	prompt:
    // 		"Analyze the provided call transcript `link to call transcript` with the customer `customer name` and identify all instances where the customer expresses interest in additional features or services. For each instance, include relevant background context, the exact customer quote indicating interest, and a brief explanation of why it represents a potential upsell opportunity. Additionally, recommend the most suitable upsell product or service based on the customer's expressed needs or goals.",
    // 	useCase: 'Analyze',
    // 	roles: ['Sales', 'Product', 'Customer Support', 'Marketing'],
    // },
    {
        id: 'learn-company-procedure-information',
        title: 'Learn about company procedure information',
        prompt: 'Summarize the standard procedures for `process/activity` across the company. Include step-by-step instructions and reference documents.',
        useCase: 'Summarize',
        roles: [
            'General',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'plan-sprint-tasks',
    // 	title: 'Plan sprint tasks',
    // 	prompt:
    // 		'Generate a detailed task list for our upcoming sprint using the information provided in `project poster`. For each task, include the task name, a brief description, the responsible team member, and estimated completion time. Organize the tasks by priority level and group them according to their related user stories to ensure clarity and alignment with sprint goals. Flag any missing details needed to finalize sprint planning.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'IT Ops'],
    // },
    // {
    // 	id: 'prepare-performance-review',
    // 	title: 'Prepare for your performance review',
    // 	prompt:
    // 		'Prepare talking points for an upcoming growth conversation with my manager, summarizing my work between `dates`, organized by key projects. The points should facilitate a productive discussion about my performance, achievements, and areas for improvement. They should be clear, concise, and backed by specific examples and evidence. Organize into sections for each major project, including: project overview, my specific contributions, and relevant links.',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'retrieve-pull-request-insights-jira',
    // 	title: 'Retrieve pull request insights from Jira',
    // 	prompt:
    // 		'For the given Jira work item Jira work item `link to Jira work item`, retrieve all linked pull requests across repositories. Include each pull request number, title, current review status such as Draft, Open, Approved, Merged, or Rejected, the associated reviewers, and the merge date if applicable. Output a structured table with the columns PR Number, Title, Status, Reviewers, and Merge Date.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering'],
    // },
    // {
    // 	id: 'review-improve-presentation',
    // 	title: 'Review and improve presentation',
    // 	prompt:
    // 		'Review this presentation `upload or link presentation slides/script` and provide me with suggestions on how to improve it. Please consider the following context: the audience consists of [audience, e.g., senior executives, students, clients], the primary goal is [goal, e.g., to persuade, to inform, to inspire], and the desired outcome is `outcome, e.g., increased engagement, clear understanding, actionable next steps`. Focus your feedback on the overall structure, flow, clarity, and impact, and tailor your suggestions to maximize effectiveness for this specific audience and goal.',
    // 	useCase: 'Review',
    // 	roles: ['General'],
    // },
    {
        id: 'review-improve-writing',
        title: 'Review and improve writing',
        prompt: 'Rewrite the following message to make it more clear, concise, and professional while retaining all key details: `Insert message here`.',
        useCase: 'Review',
        roles: [
            'General',
            'Sales',
            'Customer Support'
        ]
    },
    {
        id: 'search-policies-questionnaires',
        title: 'Search policies related to questionnaires',
        prompt: 'Search all internal security and compliance policies and provide answers to the following questionnaire. Reference policy documents and highlight relevant sections for each answer.',
        useCase: 'Find',
        roles: [
            'Security',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'send-ms-teams-weekly-progress',
    // 	title: 'Send MS Teams message of weekly progress',
    // 	prompt:
    // 		'Draft a summary of the key updates and additions I made over the past week. Send this summary in MS Teams to `Teams channel link`. Confirm the draft with me before sending.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'suggest-process-streamlining',
        title: 'Suggest process streamlining',
        prompt: 'Suggest ways to streamline the process for `process/task`. Identify steps that can be automated or simplified to reduce manual work and produce more succinct outputs.',
        useCase: 'Learn',
        roles: [
            'Program Management',
            'IT Ops',
            'Engineering'
        ]
    },
    {
        id: 'summarize-track-project-updates',
        title: 'Summarize and track project updates',
        prompt: 'Summarize the status and history of `project/topic/feature`. Include key initiatives, progress made, stakeholders, decisions, timelines, and relevant documents. Highlight upcoming milestones or blockers.',
        useCase: 'Summarize',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'summarize-confluence-page-google-doc',
    // 	title: 'Summarize Confluence page and add to Google doc',
    // 	prompt:
    // 		'Summarize key points and any action items/next steps in this Confluence page: `Confluence page link` and add this summary to a new Google doc titled "`title`" under the folder "`folder`."',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'summarize-engineering-requests',
    // 	title: 'Summarize engineering requests',
    // 	prompt: 'Review and summarize recent Engineering Requests (ERs) for my team.',
    // 	useCase: 'Review',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'summarize-meeting-notes',
        title: 'Summarize meeting notes',
        prompt: 'Summarize the meeting with the transcript `attach file or paste transcript`, including main topics discussed, key decisions, and action items.',
        useCase: 'Summarize',
        roles: [
            'General'
        ]
    },
    {
        id: 'synthesize-user-testing-findings',
        title: 'Synthesize findings from user testing',
        prompt: 'Synthesize key insights from my user testing: `Confluence page link/transcript`. Identify the top pain points or issues that users faced during the testing. Categorize these issues by severity and impact on user experience.',
        useCase: 'Analyze',
        roles: [
            'Design'
        ]
    },
    {
        id: 'visualize-data-charts',
        title: 'Visualize your data into charts',
        prompt: '`Upload your dataset file(s)` Based on the uploaded dataset file, determine the most effective way to visualize the data. Identify the key structure and variables within the dataset and the most likely user goals for this data, to suggest and describe the most appropriate type of visualization.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Engineering',
            'Marketing'
        ]
    }
];
const $326b9cee4ac976c2$export$802094cfe9873dbe = [
    // Salesforce
    {
        id: '3p-salesforce-recommend-next-steps-deals',
        title: 'Recommend next steps for my deals',
        prompt: 'Recommend next steps for my deals',
        useCase: 'Execute',
        roles: [
            'Sales'
        ],
        appIds: [
            'salesforce'
        ]
    },
    // SharePoint & One Drive & Google Drive
    {
        id: '3p-onboarding-guide',
        title: 'Create onboarding guide',
        prompt: 'Create an onboarding guide for new hires using documents in `product` folder',
        useCase: 'Create',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-find-product-specs-last-month',
        title: 'Find product specs from last month',
        prompt: 'Find product specs in `Google Drive/Sharepoint/Onedrive` that were created in the last month',
        useCase: 'Find',
        roles: [
            'Product',
            'Engineering',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-callout-risks-fy27',
        title: 'Callout the risks in Strategy doc',
        prompt: 'Callout the risks you see in the FY27 Strategy doc shared with me.',
        useCase: 'Review',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    }
];
const $326b9cee4ac976c2$var$staticPromptsWithSkill = [
    // {
    // 	id: 'summarize-release',
    // 	title: 'Summarize release',
    // 	prompt:
    // 		"/summarize-release this `Jira release` for `product` to generate an executive snapshot. Include: 1) key changes grouped by epic or component, 2) risks and blockers with owners and dates, 3) quality signals (open bugs, regressions, flaky tests), 4) planned rollout and key dates, and 5) clear next steps for stakeholders.",
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'create-release',
        title: 'Create release',
        prompt: "/create-release in this `Jira space` to create a new release with start and release dates. Include completed work items and summarize what's included by epic or team.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Engineering'
        ],
        tags: [
            'jira-releases'
        ]
    },
    // {
    // 	id: 'draft-release-notes',
    // 	title: 'Draft release notes',
    // 	prompt:
    // 		"/draft-release-notes for this `Jira release` and related `Confluence page` to generate customer-facing release notes. Organize into \"What's new\", \"Improvements\", \"Fixes\", and \"Known issues\" with clear, non-technical language.",
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'create-work-items',
    // 	title: 'Create work items',
    // 	prompt:
    // 		"/create-work-items from this `Confluence page` (feature spec) in this `Jira space`. Break the feature into epics, stories, and tasks with summaries, descriptions, and estimates. List everything created, grouped by epic.",
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'write-status-update',
    // 	title: 'Write status update',
    // 	prompt:
    // 		"/write-status-update with this `Jira space` and these `Confluence pages` to draft a status update for `project/initiative` over the last `time period`. Include overall RAG, key achievements, major risks/blockers with owners, and next steps.",
    // 	useCase: 'Create',
    // 	roles: ['Program Management', 'Product'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'page-catchup',
    // 	title: 'Page catchup',
    // 	prompt:
    // 		"/page-catchup this `Confluence page` to summarize what changed in the last `time period`. Highlight new sections, major edits, important comments, and open tasks or questions.",
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'update-work-items',
    // 	title: 'Update work items',
    // 	prompt:
    // 		"/update-work-items for these `Jira work items` in this `Jira space` to bulk update: set assignee, add label, and move items to a new status if no blockers. Show a summary of planned changes first.",
    // 	useCase: 'Execute',
    // 	roles: ['Program Management', 'Engineering'],
    // },
    // {
    // 	id: 'manage-jira-permissions',
    // 	title: 'Manage Jira permissions',
    // 	prompt:
    // 		"/manage-jira-permissions for this `Jira work item` or `Jira space` to diagnose permission issues, explain missing permissions, and provide admin guidance to resolve.",
    // 	useCase: 'Execute',
    // 	roles: ['IT Ops', 'Security'],
    // },
    // {
    // 	id: 'find-jira-settings',
    // 	title: 'Find Jira settings',
    // 	prompt:
    // 		"/find-jira-settings for this `Jira space` and my goal \"`desired behavior`\". Tell me which settings to change, where to find them, and any trade-offs.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'manage-jira-workflows',
        title: 'Manage Jira workflows',
        prompt: '/manage-jira-workflows for this `Jira space` to analyze its workflow: explain statuses, transitions, top workflow rules, and propose simplifications.',
        useCase: 'Execute',
        roles: [
            'IT Ops',
            'Program Management'
        ],
        tags: [
            'jira-workflows'
        ]
    },
    // {
    // 	id: 'search-assets',
    // 	title: 'Search Assets',
    // 	prompt:
    // 		"/search-assets in this `JSM project` for \"`asset search criteria`\" and highlight any related to this `JSM incident` or `Jira work item`. Return a table of matching assets.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    // {
    // 	id: 'create-pir',
    // 	title: 'Create PIR',
    // 	prompt:
    // 		"/create-pir for this `JSM incident` and related `Confluence pages` to draft a complete Post Incident Review with all standard sections.",
    // 	useCase: 'Create',
    // 	roles: ['IT Ops'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'analyze-incident-root-cause',
        title: 'Find root cause of an incident (RCA)',
        prompt: '/analyze-incident-root-cause for this `JSM incident` to analyze details, linked alerts, changes, assets, and similar incidents. Propose likely root cause and investigation steps.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'find-incident-root-cause',
        title: 'Find incident root cause',
        prompt: '/find-incident-root-cause for this `JSM incident` to infer the most likely root cause and provide a stakeholder-friendly summary.',
        useCase: 'Find',
        roles: [
            'IT Ops',
            'General'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'find-incidents',
    // 	title: 'Find incidents',
    // 	prompt:
    // 		"/find-incidents in this `JSM project` for incidents from the last `time period` matching \"`criteria`\". Group by status or service, show counts, and surface the most impactful incidents.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'find-similar-incidents',
        title: 'Find similar incidents',
        prompt: '/find-similar-incidents for this `JSM incident` to find the most similar historical incidents, how they were resolved, and any recurring patterns.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'suggest-problem-ticket',
        title: 'Suggest problem ticket',
        prompt: '/suggest-problem-ticket for this `JSM incident` to check for similar incidents and, if recurring, propose a problem ticket with all key details and links.',
        useCase: 'Create',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-fields',
        title: 'Suggest incident fields',
        prompt: '/suggest-incident-fields for this `JSM incident` to propose values for service, component, priority, impact, urgency, and major incident flag, with justifications.',
        useCase: 'Execute',
        roles: [
            'Helpdesk Support',
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-sme',
        title: 'Suggest incident SME',
        prompt: '/suggest-incident-expert for this `JSM incident` to recommend the best people or teams to involve, with reasons and suggested actions.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'summarize-incident',
        title: 'Summarize incident',
        prompt: '/summarize-incident for this `JSM incident` to create an executive summary with impact, timeline, root cause, mitigation, and next steps.',
        useCase: 'Summarize',
        roles: [
            'IT Ops',
            'General'
        ]
    },
    // {
    // 	id: 'find-alerts',
    // 	title: 'Find alerts',
    // 	prompt:
    // 		"/find-alerts in this `JSM project` for alerts from the last `time period`. Group by service and severity, highlight recurring alerts, and relate to incidents or changes.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    // {
    // 	id: 'recommend-playbook',
    // 	title: 'Recommend playbook',
    // 	prompt:
    // 		"/recommend-playbook for this `alert` or `JSM incident` to suggest the best runbooks or playbooks, with links and first steps.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    {
        id: 'assess-change-risk-insights',
        title: 'Assess change risk insights',
        prompt: '/assess-change-risk for this `JSM change request` to assess risk, explain drivers, and suggest safeguards like canary deployments or extra approvals.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'get-data-insights',
        title: 'Get data insights',
        prompt: '/get-data-insights for this `Jira space` to create charts (throughput, cycle time, WIP) and interpret trends, bottlenecks, and recommendations.',
        useCase: 'Analyze',
        roles: [
            'Engineering',
            'Program Management'
        ],
        enableDeepResearch: true
    }
];
// Filters out prompt cards that reference skills but have no skill metadata.
// This will also act as an entitlement check for the user.
const $326b9cee4ac976c2$var$filterCardsBySkillMetadata = (cards, skillMetadataMap)=>{
    if (skillMetadataMap === undefined) return cards;
    return cards.filter((card)=>{
        const slugs = $326b9cee4ac976c2$export$bee44b12dce7b448(card.prompt);
        if (slugs.length === 0) return true;
        return slugs.every((slug)=>slug in skillMetadataMap);
    });
};
const $326b9cee4ac976c2$export$47aa2ee75b720c2e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    let t0;
    if ($[0] !== skillMetadata?.skillMetadataMap) {
        const first3Prompts = $326b9cee4ac976c2$var$staticPrompts.slice(0, 3);
        const remainingPrompts = $326b9cee4ac976c2$var$staticPrompts.slice(3);
        const skillsPrompts = $326b9cee4ac976c2$var$filterCardsBySkillMetadata($326b9cee4ac976c2$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
        const promptCards = [
            ...first3Prompts,
            ...skillsPrompts,
            ...remainingPrompts
        ];
        t0 = {
            promptCards: promptCards
        };
        $[0] = skillMetadata?.skillMetadataMap;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    // First 3 curated prompts, then skills prompts, then the rest
    const first3Prompts = $326b9cee4ac976c2$var$staticPrompts.slice(0, 3);
    const remainingPrompts = $326b9cee4ac976c2$var$staticPrompts.slice(3);
    const skillsPrompts = $326b9cee4ac976c2$var$filterCardsBySkillMetadata($326b9cee4ac976c2$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
    const promptCards = [
        ...first3Prompts,
        ...skillsPrompts,
        ...remainingPrompts
    ];
    return {
        promptCards: promptCards
    };
};
module.exports["useCaseOptions"] = $326b9cee4ac976c2$export$9fa6e712ef03097f;
module.exports["roleOptions"] = $326b9cee4ac976c2$export$9472c6a87dde5170;
module.exports["PROMPT_LIBRARY_SKILL_TAG"] = $326b9cee4ac976c2$export$1ac99e1b5b1a8cfe;
module.exports["usePromptCards"] = $326b9cee4ac976c2$export$47aa2ee75b720c2e;

});

parcelRegister("7dHQW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $aAQ8R = parcelRequire("aAQ8R");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $f6VI9 = parcelRequire("f6VI9");


var $1Bxlw = parcelRequire("1Bxlw");

function $5446c5acb3eaf46c$export$70de0c6012582ca5(skillsResponse) {
    if (!skillsResponse?.edges) return {};
    const metadataMap = {};
    skillsResponse.edges.forEach((edge)=>{
        const node = edge?.node;
        if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return;
        const skill = (0, $f6VI9.parseSkillNode)(node);
        if (!skill || !skill.slug) return;
        metadataMap[skill.slug] = {
            id: skill.id,
            name: skill.name,
            description: skill.description ?? '',
            iconName: skill.iconName,
            product: skill.product,
            productIconUrl: skill.productIconUrl,
            color: skill.color
        };
    });
    return metadataMap;
}
/**
 * Context for skill metadata
 */ const $5446c5acb3eaf46c$var$SkillMetadataContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $5446c5acb3eaf46c$export$6c7e4f3dd3ea4213 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSkillMetadata() {
    return (0, $cozmU.useContext)($5446c5acb3eaf46c$var$SkillMetadataContext);
} : function useSkillMetadata() {
    return (0, $cozmU.useContext)($5446c5acb3eaf46c$var$SkillMetadataContext);
};
function $5446c5acb3eaf46c$export$54587e1184069f96({ children: children, siteId: siteId, tags: tagsProp, fetchWithoutTags: fetchWithoutTags = false }) {
    const config = (0, $1Bxlw.useRovoSkillsConfig)();
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    // Use tags from prop if provided, otherwise fallback to context
    const tags = tagsProp ?? config?.tags;
    const shouldFetch = !!tags?.skillRegistryTags && tags.skillRegistryTags.length > 0 || fetchWithoutTags;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by transformSkillMetadataResponse in this file */ (0, $aAQ8R.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: 100,
        relevantFor: [
            'SKILL'
        ],
        cloudId: siteId,
        surface: 'ROVO',
        shouldSkip: !shouldFetch,
        tags: fetchWithoutTags ? undefined : tags?.skillRegistryTags ?? []
    }, {
        fetchKey: skillsRevision,
        fetchPolicy: skillsRevision === 0 ? 'store-or-network' : 'network-only'
    })?.graphIntegration_componentDirectoryItems;
    const skillMetadataMap = (0, $cozmU.useMemo)(()=>{
        if (!shouldFetch) return {};
        return $5446c5acb3eaf46c$export$70de0c6012582ca5(skillsResponse);
    }, [
        shouldFetch,
        skillsResponse
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            skillMetadataMap: skillMetadataMap
        }), [
        skillMetadataMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5446c5acb3eaf46c$var$SkillMetadataContext.Provider, {
        value: value
    }, children);
}
module.exports["useSkillMetadata"] = $5446c5acb3eaf46c$export$6c7e4f3dd3ea4213;
module.exports["SkillMetadataProvider"] = $5446c5acb3eaf46c$export$54587e1184069f96;

});

parcelRegister("aAQ8R", function(module, exports) {
/**
 * @generated SignedSource<<2e0d68bf66f01dede289e18e54bbc3ad>>
 * @relayHash 2b65d1bc6af8a5b24528e315a236250f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f
const $442a06332da1bb4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tags"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "relevantFor",
            "variableName": "relevantFor"
        },
        {
            "kind": "Variable",
            "name": "surface",
            "variableName": "surface"
        },
        {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "slashCommand"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "color"
    }, v15 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v16 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationActionDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpServer"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpTool"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationSkillItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f",
            "metadata": {},
            "name": "skillMetadataProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$442a06332da1bb4d$var$node.hash = "a886cc1a7f4cca0c76a7569f4eaae42e";
var $442a06332da1bb4d$export$2e2bcd8739ae039 = $442a06332da1bb4d$var$node;
module.exports["default"] = $442a06332da1bb4d$export$2e2bcd8739ae039;

});

parcelRegister("1Bxlw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aJNFh = parcelRequire("aJNFh");

const $350692d982fcc44a$var$RovoSkillsConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $350692d982fcc44a$var$fallbackInvalidation = {
    skillsRevision: 0,
    // Outside RovoSkillsConfigProvider there is no revision state to bump, so this only clears
    // the vanilla insert-menu cache. Relay consumers need the provider to refetch by revision.
    invalidateSkillLibrary: (0, $aJNFh.clearSkillsCache)
};
const $350692d982fcc44a$var$RovoSkillsInvalidationContext = /*#__PURE__*/ (0, $cozmU.createContext)($350692d982fcc44a$var$fallbackInvalidation); /**
                                                                                                    * Hook to access Rovo Skills configuration.
                                                                                                    *
                                                                                                    * @returns The Rovo Skills configuration, or undefined if used outside of RovoSkillsConfigProvider
                                                                                                    *
                                                                                                    * @example
                                                                                                    * ```tsx
                                                                                                    * function MyComponent() {
                                                                                                    *   const config = useRovoSkillsConfig();
                                                                                                    *   const tags = config?.tags;
                                                                                                    * }
                                                                                                    * ```
                                                                                                    */ 
const $350692d982fcc44a$export$8f887a582517d0da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoSkillsConfig() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsConfigContext);
} : function useRovoSkillsConfig() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsConfigContext);
};
const $350692d982fcc44a$export$4347872345a66163 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoSkillsInvalidation() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsInvalidationContext);
} : function useRovoSkillsInvalidation() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsInvalidationContext);
};
const $350692d982fcc44a$export$4967709cc8a6f044 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoSkillsConfigProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { config: config, children: children } = t0;
    const value = config;
    const [skillsRevision, setSkillsRevision] = (0, $cozmU.useState)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            (0, $aJNFh.clearSkillsCache)();
            (0, $cozmU.startTransition)(()=>{
                setSkillsRevision($350692d982fcc44a$var$_temp);
            });
        };
        $[0] = t1;
    } else t1 = $[0];
    const invalidateSkillLibrary = t1;
    let t2;
    if ($[1] !== skillsRevision) {
        t2 = {
            skillsRevision: skillsRevision,
            invalidateSkillLibrary: invalidateSkillLibrary
        };
        $[1] = skillsRevision;
        $[2] = t2;
    } else t2 = $[2];
    const invalidationValue = t2;
    let t3;
    if ($[3] !== children || $[4] !== invalidationValue) {
        t3 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsInvalidationContext.Provider, {
            value: invalidationValue
        }, children);
        $[3] = children;
        $[4] = invalidationValue;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3 || $[7] !== value) {
        t4 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsConfigContext.Provider, {
            value: value
        }, t3);
        $[6] = t3;
        $[7] = value;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function RovoSkillsConfigProvider({ config: config, children: children }) {
    const value = (0, $cozmU.useMemo)(()=>config, [
        config
    ]);
    const [skillsRevision, setSkillsRevision] = (0, $cozmU.useState)(0);
    const invalidateSkillLibrary = (0, $cozmU.useCallback)(()=>{
        (0, $aJNFh.clearSkillsCache)();
        (0, $cozmU.startTransition)(()=>{
            setSkillsRevision((revision)=>revision + 1);
        });
    }, []);
    const invalidationValue = (0, $cozmU.useMemo)(()=>({
            skillsRevision: skillsRevision,
            invalidateSkillLibrary: invalidateSkillLibrary
        }), [
        invalidateSkillLibrary,
        skillsRevision
    ]);
    return /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsConfigContext.Provider, {
        value: value
    }, /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsInvalidationContext.Provider, {
        value: invalidationValue
    }, children));
};
function $350692d982fcc44a$var$_temp(revision) {
    return revision + 1;
}
module.exports["useRovoSkillsConfig"] = $350692d982fcc44a$export$8f887a582517d0da;
module.exports["useRovoSkillsInvalidation"] = $350692d982fcc44a$export$4347872345a66163;
module.exports["RovoSkillsConfigProvider"] = $350692d982fcc44a$export$4967709cc8a6f044;

});

parcelRegister("aJNFh", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Legacy GraphQL query — graphIntegration_componentDirectoryItems.
 * Returns user-facing descriptions (not AI model instructions).
 * Used when rovo_chat_unified_skills_agg is OFF.
 */ const $71f78acdff7635c4$var$LEGACY_SKILLS_QUERY = `
  query GraphIntegrationItemsQuery(
    $first: Int
    $cloudId: ID!
    $surface: GraphIntegrationSurface
    $relevantFor: [GraphIntegrationDirectoryItemType!]
  ) {
    graphIntegration_componentDirectoryItems(
      first: $first
      cloudId: $cloudId
      surface: $surface
      relevantFor: $relevantFor
    )
    @optIn(to: "GraphIntegrationItemsQuery")
    {
      edges {
        node {
          __typename
          ... on GraphIntegrationSkillDirectoryItem {
            id
            slashCommand
            name
            description
            iconUrl
            integrationKey {
              displayName
              iconUrl
            }
            color
            tags {
              displayName
            }
          }
        }
      }
    }
  }
`;
/**
 * New unified GraphQL query — convoai_availableSkills.
 * Used when rovo_chat_unified_skills_agg is ON.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}:${graphqlEndpoint}:${useUnified}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
/**
 * Fetch skills using the legacy graphIntegration_componentDirectoryItems endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsLegacy(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$LEGACY_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 100,
                surface: 'ROVO',
                relevantFor: [
                    'SKILL'
                ]
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length) return [];
    const edges = json.data?.graphIntegration_componentDirectoryItems?.edges;
    return (0, $f6VI9.parseSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const useUnified = (0, $iDrrr.fg)('rovo_chat_unified_skills_agg');
    const cacheKey = `${cloudId}:${useUnified}`;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = useUnified ? await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) : await $71f78acdff7635c4$var$fetchSkillsLegacy(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("2TzCj", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

function $c594f0c4919c867d$export$f50ba6ebca86afae(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Chat;
}
function $c594f0c4919c867d$export$e0faf22bf5023c5e(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Nested;
}
function $c594f0c4919c867d$export$ce07703e397785f3(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Skill;
}
function $c594f0c4919c867d$export$38d6fa0daaae0008(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Skill && 'dynamicPrompt' in action && (0, $6iWVH.LEGACY_DYNAMIC_SKILL_IDS).has(action.id);
}
function $c594f0c4919c867d$export$426fd22b878fe58d(action) {
    return $c594f0c4919c867d$export$f50ba6ebca86afae(action) || $c594f0c4919c867d$export$e0faf22bf5023c5e(action) || $c594f0c4919c867d$export$ce07703e397785f3(action);
}
module.exports["isChatAction"] = $c594f0c4919c867d$export$f50ba6ebca86afae;
module.exports["isNestedAction"] = $c594f0c4919c867d$export$e0faf22bf5023c5e;
module.exports["isSkillAction"] = $c594f0c4919c867d$export$ce07703e397785f3;

});

parcelRegister("6iWVH", function(module, exports) {
var $b76a5cfcb2493fac$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $b76a5cfcb2493fac$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'manage-user-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $b76a5cfcb2493fac$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["STUDIO_AGENT_BUILDER"] = "studio-agent-builder";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $b76a5cfcb2493fac$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $b76a5cfcb2493fac$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $b76a5cfcb2493fac$export$c91e07269f22915a;
module.exports["PageContextType"] = $b76a5cfcb2493fac$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $b76a5cfcb2493fac$export$4f757e7d9540e8f9;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("2pOgk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $l8wPz = parcelRequire("l8wPz");

var $4yYAm = parcelRequire("4yYAm");

var $jdA6O = parcelRequire("jdA6O");


var $fZS57 = parcelRequire("fZS57");


var $lSHQh = parcelRequire("lSHQh");


var $8o9Ak = parcelRequire("8o9Ak");

const $f2c4eb146495e13d$var$FULLSCREEN_CARD_MAX_WIDTH = '336px';
const $f2c4eb146495e13d$var$styles = {
    grid: "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _3138428HPE",
    gridFullScreen: "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _3138425zaO",
    detailListContainer: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3138422ADO _0KLXrulfZc",
    detailRow: "_3iDTPbvLZJ _0wOv4Q7zJH",
    detailRowWithDivider: "_3iDTPbvLZJ _0wOv4Q7zJH _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    compactCard: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEN91d _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _0wOv4Q7zJH _4ouGXIdnbC _1EqgXlN91d",
    compactCardFullScreen: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _0wOv4Q7zJH _4ouGXIdnbC _39xV02E6Kk _1EqgXlax1H",
    cardTwoColumn: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEvNmc _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _0wOv4Q7zJH _4ouGXIdnbC _1EqgXlN91d",
    detailGridCard: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEvNmc _4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbvLZJ _0wOv4Q7zJH _4ouGXIdnbC _1EqgXlN91d _24h04i2Njc _0KLXrulfZc"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
// SmartCard internal overrides require nested data-attribute selectors and !important to override inline styles
const $f2c4eb146495e13d$var$smartCardSingleLineTitleOverrides = null;
const $f2c4eb146495e13d$var$compactCardStyleOverrides = null;
const $f2c4eb146495e13d$var$detailCardStyleOverrides = null;
const $f2c4eb146495e13d$var$detailCardFullScreenStyleOverrides = null;
const $f2c4eb146495e13d$var$detailMetadataStyleOverrides = null; /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
const $f2c4eb146495e13d$var$TWO_COLUMN_BREAKPOINT = 480;
const $f2c4eb146495e13d$var$MAX_SINGLE_COLUMN_CARDS = 3;
const $f2c4eb146495e13d$var$CompactCard = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { url: url, isTwoColumn: isTwoColumn, isFullScreen: t1, variant: t2, isFirstItem: t3, onLinkClick: onLinkClick } = t0;
    const isFullScreen = t1 === undefined ? false : t1;
    const variant = t2 === undefined ? "compact" : t2;
    const isFirstItem = t3 === undefined ? true : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] !== onLinkClick || $[1] !== url) {
        t4 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onLinkClick?.(url);
            window.open(url, "_blank", "noopener,noreferrer");
        };
        $[0] = onLinkClick;
        $[1] = url;
        $[2] = t4;
    } else t4 = $[2];
    const openLink = t4;
    let t5;
    if ($[3] !== openLink) {
        t5 = (event_0)=>{
            if (event_0.key === "Enter" || event_0.key === " ") openLink(event_0);
        };
        $[3] = openLink;
        $[4] = t5;
    } else t5 = $[4];
    const handleKeyDown = t5;
    let t6;
    if ($[5] !== url) {
        t6 = (0, $fZS57.isGoogleCalendarUrl)(url);
        $[5] = url;
        $[6] = t6;
    } else t6 = $[6];
    const isGoogleCalendarCard = t6;
    let t7;
    if ($[7] !== isGoogleCalendarCard || $[8] !== openLink || $[9] !== url || $[10] !== variant) {
        t7 = isGoogleCalendarCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSHQh.GoogleCalendarCard), {
            url: url,
            hideSubtitle: variant === "compact",
            titleAppearance: variant === "detail" ? "detail" : "default"
        }) : variant === "detail" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "block",
            url: url,
            onClick: openLink,
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            size: (0, $4yYAm.SmartLinkSize).Medium,
            position: (0, $4yYAm.SmartLinkPosition).Center,
            maxLines: 1,
            hideRetry: true,
            subtitle: [
                {
                    name: (0, $4yYAm.ElementName).Provider,
                    hideIcon: true
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn,
                    hideDatePrefix: true
                }
            ]
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "block",
            url: url,
            onClick: openLink,
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            size: (0, $4yYAm.SmartLinkSize).Medium,
            position: (0, $4yYAm.SmartLinkPosition).Center,
            maxLines: 1,
            hideRetry: true
        }));
        $[7] = isGoogleCalendarCard;
        $[8] = openLink;
        $[9] = url;
        $[10] = variant;
        $[11] = t7;
    } else t7 = $[11];
    const cardContent = t7;
    let t8;
    if ($[12] !== formatMessage) {
        t8 = formatMessage((0, $8o9Ak.default).openLinkInNewTab);
        $[12] = formatMessage;
        $[13] = t8;
    } else t8 = $[13];
    const t9 = variant === "detail" ? isTwoColumn ? isGoogleCalendarCard ? $f2c4eb146495e13d$var$styles.cardTwoColumn : $f2c4eb146495e13d$var$styles.detailGridCard : isFirstItem ? $f2c4eb146495e13d$var$styles.detailRow : $f2c4eb146495e13d$var$styles.detailRowWithDivider : isTwoColumn ? $f2c4eb146495e13d$var$styles.cardTwoColumn : isFullScreen ? $f2c4eb146495e13d$var$styles.compactCardFullScreen : $f2c4eb146495e13d$var$styles.compactCard;
    let t10;
    if ($[14] !== cardContent || $[15] !== isFullScreen || $[16] !== variant) {
        t10 = variant === "detail" ? isFullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1sIVoznQyn _3etZRDnQyn _0RCcpmdnbC _3MqlIVN91d _4p1HkMnQyn _0TIXjGnQyn _3nfFujdnbC _3dctXDN91d _3kpzZhz8Lp _0u8O6aLRg7 _3CP7T3dnbC _3bmp6mdnbC _3pR86sN91d _2kVVg4YbGa",
                "_0S37dNnQyn _3lUx2CnQyn _27RpC5dnbC _3EaC2pPgdg _4As0diPgdg _32pET3Pgdg _45BbYN8HPE _3k9bKc8HPE _0ocaBdYbGa _2ENxAxN91d _3EirLtjOvk _0hm1kUd1Zr _1yGKpdnQyn _1sMYuYnQyn _3nODYi8HPE _3obSBXDIqT _3bmp6mdnbC _2oxzi18fU6 _3iToP96wH8 _49wE3DNvrM _4t59b49r67 _2AWMXjVa5s _39mK1CVa5s _0Q0aYmQ4SZ _31kCwSDIqT _4vNzJjDIqT _3wKy9Bd8bj _0c6yoiy7kJ _1xVeaty7kJ _16W1m6QB1h _291gMDQB1h",
                "_0vtJI5dnbC _4oL9o9dnbC _0y413sdnbC _0ZYDGTdnbC _0pvpIY7NXe _1wRw1A7NXe _2nTLqRPgdg _03UhFgbQDk _1l3Xrg1Y8M _4Fa80E1Y8M _1sBl3Y7NXe _0IyFICKGUX _04hdQqKGUX _1YOhcC7NXe _2jKqy9FQfX _15IzMUHZdu _3WcLIOdnbC"
            ])
        }, cardContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1sIVoznQyn _3etZRDnQyn _0RCcpmdnbC _3MqlIVN91d _4p1HkMnQyn _0TIXjGnQyn _3nfFujdnbC _3dctXDN91d _3kpzZhz8Lp _0u8O6aLRg7 _3CP7T3dnbC _3bmp6mdnbC _3pR86sN91d _2kVVg4YbGa",
                "_0S37dNnQyn _3lUx2CnQyn _27RpC5dnbC _3EaC2pPgdg _4As0diPgdg _32pET3Pgdg _45BbYN8HPE _3k9bKc8HPE _0ocaBdYbGa _2ENxAxN91d _3EirLtjOvk _0hm1kUd1Zr _1yGKpdnQyn _1sMYuYnQyn _3nODYi2ADO _3obSBXDIqT _3bmp6mdnbC _2oxzi18fU6 _3iToP96wH8 _49wE3DNvrM _4t59b49r67 _2AWMXjVa5s _39mK1CVa5s _0Q0aYmQ4SZ _31kCwSDIqT _4vNzJjDIqT _3wKy9Bd8bj _0c6yoiy7kJ _1xVeaty7kJ _16W1m6QB1h _291gMDQB1h",
                "_0vtJI5dnbC _4oL9o9dnbC _0y413sdnbC _0ZYDGTdnbC _0pvpIY7NXe _1wRw1A7NXe _2nTLqRPgdg _03UhFgbQDk _1l3Xrg1Y8M _4Fa80E1Y8M _1sBl3Y7NXe _0IyFICKGUX _04hdQqKGUX _1YOhcC7NXe _2jKqy9FQfX _15IzMUHZdu _3WcLIOdnbC"
            ])
        }, cardContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1sIVoznQyn _3etZRDnQyn _0RCcpmdnbC _3MqlIVN91d _4p1HkMnQyn _0TIXjGnQyn _3nfFujdnbC _3dctXDN91d _3kpzZhz8Lp _0u8O6aLRg7 _3CP7T3dnbC _3bmp6mdnbC _3pR86sN91d _2kVVg4YbGa",
                "_0S37dNnQyn _3lUx2CnQyn _27RpC58fU6 _3EaC2pPgdg _4As0diPgdg _32pET3Pgdg _45BbYN2ADO _3k9bKc2ADO _2ENxAxN91d _3EirLtjOvk _0hm1kUBee8 _1yGKpdnQyn _1sMYuYnQyn _3nODYi2ADO _3obSBXDIqT _3bmp6mdnbC _2oxzi1KTcp _3iToP96wH8 _49wE3DNvrM _4t59b49r67 _2AWMXjNHnM _39mK1CNHnM _0Q0aYmQ4SZ _31kCwSDIqT _4vNzJjDIqT _3wKy9B7NXe _0c6yoiy7kJ _2C9dkJf7mX _1xVeaty7kJ _16W1m6t5zC _291gMDt5zC"
            ])
        }, cardContent);
        $[14] = cardContent;
        $[15] = isFullScreen;
        $[16] = variant;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== handleKeyDown || $[19] !== openLink || $[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "link",
            "aria-label": t8,
            tabIndex: 0,
            onClick: openLink,
            onKeyDown: handleKeyDown,
            xcss: t9
        }, t10);
        $[18] = handleKeyDown;
        $[19] = openLink;
        $[20] = t10;
        $[21] = t8;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : ({ url: url, isTwoColumn: isTwoColumn, isFullScreen: isFullScreen = false, variant: variant = 'compact', isFirstItem: isFirstItem = true, onLinkClick: onLinkClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // stopPropagation prevents a duplicate tab when the SmartCard's inner <a> is
    // clicked and the event also bubbles up to the outer clickable Box.
    const openLink = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        onLinkClick?.(url);
        window.open(url, '_blank', 'noopener,noreferrer');
    }, [
        url,
        onLinkClick
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.key === 'Enter' || event_0.key === ' ') openLink(event_0);
    }, [
        openLink
    ]);
    const isGoogleCalendarCard = (0, $fZS57.isGoogleCalendarUrl)(url);
    const cardContent = isGoogleCalendarCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSHQh.GoogleCalendarCard), {
        url: url,
        hideSubtitle: variant === 'compact',
        titleAppearance: variant === 'detail' ? 'detail' : 'default'
    }) : variant === 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        url: url,
        onClick: openLink,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        maxLines: 1,
        hideRetry: true,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedOn,
                hideDatePrefix: true
            }
        ]
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        url: url,
        onClick: openLink,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        maxLines: 1,
        hideRetry: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "link",
        "aria-label": formatMessage((0, $8o9Ak.default).openLinkInNewTab),
        tabIndex: 0,
        onClick: openLink,
        onKeyDown: handleKeyDown,
        xcss: variant === 'detail' ? isTwoColumn ? isGoogleCalendarCard ? $f2c4eb146495e13d$var$styles.cardTwoColumn : $f2c4eb146495e13d$var$styles.detailGridCard : isFirstItem ? $f2c4eb146495e13d$var$styles.detailRow : $f2c4eb146495e13d$var$styles.detailRowWithDivider : isTwoColumn ? $f2c4eb146495e13d$var$styles.cardTwoColumn : isFullScreen ? $f2c4eb146495e13d$var$styles.compactCardFullScreen : $f2c4eb146495e13d$var$styles.compactCard
    }, variant === 'detail' ? isFullScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1sIVoznQyn _3etZRDnQyn _0RCcpmdnbC _3MqlIVN91d _4p1HkMnQyn _0TIXjGnQyn _3nfFujdnbC _3dctXDN91d _3kpzZhz8Lp _0u8O6aLRg7 _3CP7T3dnbC _3bmp6mdnbC _3pR86sN91d _2kVVg4YbGa",
            "_0S37dNnQyn _3lUx2CnQyn _27RpC5dnbC _3EaC2pPgdg _4As0diPgdg _32pET3Pgdg _45BbYN8HPE _3k9bKc8HPE _0ocaBdYbGa _2ENxAxN91d _3EirLtjOvk _0hm1kUd1Zr _1yGKpdnQyn _1sMYuYnQyn _3nODYi8HPE _3obSBXDIqT _3bmp6mdnbC _2oxzi18fU6 _3iToP96wH8 _49wE3DNvrM _4t59b49r67 _2AWMXjVa5s _39mK1CVa5s _0Q0aYmQ4SZ _31kCwSDIqT _4vNzJjDIqT _3wKy9Bd8bj _0c6yoiy7kJ _1xVeaty7kJ _16W1m6QB1h _291gMDQB1h",
            "_0vtJI5dnbC _4oL9o9dnbC _0y413sdnbC _0ZYDGTdnbC _0pvpIY7NXe _1wRw1A7NXe _2nTLqRPgdg _03UhFgbQDk _1l3Xrg1Y8M _4Fa80E1Y8M _1sBl3Y7NXe _0IyFICKGUX _04hdQqKGUX _1YOhcC7NXe _2jKqy9FQfX _15IzMUHZdu _3WcLIOdnbC"
        ])
    }, cardContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1sIVoznQyn _3etZRDnQyn _0RCcpmdnbC _3MqlIVN91d _4p1HkMnQyn _0TIXjGnQyn _3nfFujdnbC _3dctXDN91d _3kpzZhz8Lp _0u8O6aLRg7 _3CP7T3dnbC _3bmp6mdnbC _3pR86sN91d _2kVVg4YbGa",
            "_0S37dNnQyn _3lUx2CnQyn _27RpC5dnbC _3EaC2pPgdg _4As0diPgdg _32pET3Pgdg _45BbYN8HPE _3k9bKc8HPE _0ocaBdYbGa _2ENxAxN91d _3EirLtjOvk _0hm1kUd1Zr _1yGKpdnQyn _1sMYuYnQyn _3nODYi2ADO _3obSBXDIqT _3bmp6mdnbC _2oxzi18fU6 _3iToP96wH8 _49wE3DNvrM _4t59b49r67 _2AWMXjVa5s _39mK1CVa5s _0Q0aYmQ4SZ _31kCwSDIqT _4vNzJjDIqT _3wKy9Bd8bj _0c6yoiy7kJ _1xVeaty7kJ _16W1m6QB1h _291gMDQB1h",
            "_0vtJI5dnbC _4oL9o9dnbC _0y413sdnbC _0ZYDGTdnbC _0pvpIY7NXe _1wRw1A7NXe _2nTLqRPgdg _03UhFgbQDk _1l3Xrg1Y8M _4Fa80E1Y8M _1sBl3Y7NXe _0IyFICKGUX _04hdQqKGUX _1YOhcC7NXe _2jKqy9FQfX _15IzMUHZdu _3WcLIOdnbC"
        ])
    }, cardContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1sIVoznQyn _3etZRDnQyn _0RCcpmdnbC _3MqlIVN91d _4p1HkMnQyn _0TIXjGnQyn _3nfFujdnbC _3dctXDN91d _3kpzZhz8Lp _0u8O6aLRg7 _3CP7T3dnbC _3bmp6mdnbC _3pR86sN91d _2kVVg4YbGa",
            "_0S37dNnQyn _3lUx2CnQyn _27RpC58fU6 _3EaC2pPgdg _4As0diPgdg _32pET3Pgdg _45BbYN2ADO _3k9bKc2ADO _2ENxAxN91d _3EirLtjOvk _0hm1kUBee8 _1yGKpdnQyn _1sMYuYnQyn _3nODYi2ADO _3obSBXDIqT _3bmp6mdnbC _2oxzi1KTcp _3iToP96wH8 _49wE3DNvrM _4t59b49r67 _2AWMXjNHnM _39mK1CNHnM _0Q0aYmQ4SZ _31kCwSDIqT _4vNzJjDIqT _3wKy9B7NXe _0c6yoiy7kJ _2C9dkJf7mX _1xVeaty7kJ _16W1m6t5zC _291gMDt5zC"
        ])
    }, cardContent));
});
const $f2c4eb146495e13d$var$InsightLinkCardGroupBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { urls: urls, isFullScreen: t1, variant: t2, onLinkClick: onLinkClick } = t0;
    const isFullScreen = t1 === undefined ? false : t1;
    const variant = t2 === undefined ? "compact" : t2;
    const containerRef = (0, $cozmU.useRef)(null);
    const [isTwoColumn, setIsTwoColumn] = (0, $cozmU.useState)(false);
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const element = containerRef.current;
            if (!element) return;
            const observer = new ResizeObserver((entries)=>{
                for (const entry of entries)setIsTwoColumn(entry.contentRect.width >= $f2c4eb146495e13d$var$TWO_COLUMN_BREAKPOINT);
            });
            observer.observe(element);
            return ()=>observer.disconnect();
        };
        t4 = [];
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const showTwoColumnLayout = variant !== "detail" && isTwoColumn && urls.length > 1;
    const showFullScreenDetailGrid = variant === "detail" && isFullScreen && isTwoColumn;
    let t5;
    if ($[2] !== showTwoColumnLayout || $[3] !== urls || $[4] !== variant) {
        t5 = showTwoColumnLayout || variant === "detail" ? urls : urls.slice(0, $f2c4eb146495e13d$var$MAX_SINGLE_COLUMN_CARDS);
        $[2] = showTwoColumnLayout;
        $[3] = urls;
        $[4] = variant;
        $[5] = t5;
    } else t5 = $[5];
    const visibleUrls = t5;
    if (variant === "detail") {
        if (visibleUrls.length === 0) {
            let t6;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    ref: containerRef,
                    xcss: $f2c4eb146495e13d$var$styles.grid
                });
                $[6] = t6;
            } else t6 = $[6];
            return t6;
        }
        if (showFullScreenDetailGrid) {
            let t6;
            if ($[7] !== isFullScreen || $[8] !== onLinkClick || $[9] !== visibleUrls) {
                let t7;
                if ($[11] !== isFullScreen || $[12] !== onLinkClick) {
                    t7 = (url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2c4eb146495e13d$var$CompactCard, {
                            key: url,
                            url: url,
                            isTwoColumn: true,
                            isFullScreen: isFullScreen,
                            variant: "detail",
                            onLinkClick: onLinkClick
                        });
                    $[11] = isFullScreen;
                    $[12] = onLinkClick;
                    $[13] = t7;
                } else t7 = $[13];
                t6 = visibleUrls.map(t7);
                $[7] = isFullScreen;
                $[8] = onLinkClick;
                $[9] = visibleUrls;
                $[10] = t6;
            } else t6 = $[10];
            let t7;
            if ($[14] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    ref: containerRef,
                    xcss: $f2c4eb146495e13d$var$styles.gridFullScreen
                }, t6);
                $[14] = t6;
                $[15] = t7;
            } else t7 = $[15];
            return t7;
        }
        let t6;
        if ($[16] !== isFullScreen || $[17] !== onLinkClick || $[18] !== visibleUrls) {
            let t7;
            if ($[20] !== isFullScreen || $[21] !== onLinkClick) {
                t7 = (url_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2c4eb146495e13d$var$CompactCard, {
                        key: url_0,
                        url: url_0,
                        isTwoColumn: false,
                        isFullScreen: isFullScreen,
                        variant: "detail",
                        isFirstItem: index === 0,
                        onLinkClick: onLinkClick
                    });
                $[20] = isFullScreen;
                $[21] = onLinkClick;
                $[22] = t7;
            } else t7 = $[22];
            t6 = visibleUrls.map(t7);
            $[16] = isFullScreen;
            $[17] = onLinkClick;
            $[18] = visibleUrls;
            $[19] = t6;
        } else t6 = $[19];
        let t7;
        if ($[23] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: containerRef,
                xcss: $f2c4eb146495e13d$var$styles.detailListContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, t6));
            $[23] = t6;
            $[24] = t7;
        } else t7 = $[24];
        return t7;
    }
    const t6 = isFullScreen ? $f2c4eb146495e13d$var$styles.gridFullScreen : $f2c4eb146495e13d$var$styles.grid;
    let t7;
    if ($[25] !== isFullScreen || $[26] !== onLinkClick || $[27] !== showTwoColumnLayout || $[28] !== visibleUrls) {
        let t8;
        if ($[30] !== isFullScreen || $[31] !== onLinkClick || $[32] !== showTwoColumnLayout) {
            t8 = (url_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2c4eb146495e13d$var$CompactCard, {
                    key: url_1,
                    url: url_1,
                    isTwoColumn: showTwoColumnLayout,
                    isFullScreen: isFullScreen,
                    variant: "compact",
                    onLinkClick: onLinkClick
                });
            $[30] = isFullScreen;
            $[31] = onLinkClick;
            $[32] = showTwoColumnLayout;
            $[33] = t8;
        } else t8 = $[33];
        t7 = visibleUrls.map(t8);
        $[25] = isFullScreen;
        $[26] = onLinkClick;
        $[27] = showTwoColumnLayout;
        $[28] = visibleUrls;
        $[29] = t7;
    } else t7 = $[29];
    let t8;
    if ($[34] !== t6 || $[35] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: containerRef,
            xcss: t6
        }, t7);
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
    } else t8 = $[36];
    return t8;
} : ({ urls: urls, isFullScreen: isFullScreen = false, variant: variant = 'compact', onLinkClick: onLinkClick })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [isTwoColumn, setIsTwoColumn] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const element = containerRef.current;
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries)setIsTwoColumn(entry.contentRect.width >= $f2c4eb146495e13d$var$TWO_COLUMN_BREAKPOINT);
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, []);
    const showTwoColumnLayout = variant !== 'detail' && isTwoColumn && urls.length > 1;
    const showFullScreenDetailGrid = variant === 'detail' && isFullScreen && isTwoColumn;
    const visibleUrls = showTwoColumnLayout || variant === 'detail' ? urls : urls.slice(0, $f2c4eb146495e13d$var$MAX_SINGLE_COLUMN_CARDS); // Detail variant: sidebar renders as a contiguous stack; full screen can use separated grid cards.
    if (variant === 'detail') {
        if (visibleUrls.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: containerRef,
            xcss: $f2c4eb146495e13d$var$styles.grid
        });
        if (showFullScreenDetailGrid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: containerRef,
            xcss: $f2c4eb146495e13d$var$styles.gridFullScreen
        }, visibleUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2c4eb146495e13d$var$CompactCard, {
                key: url,
                url: url,
                isTwoColumn: true,
                isFullScreen: isFullScreen,
                variant: "detail",
                onLinkClick: onLinkClick
            })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: containerRef,
            xcss: $f2c4eb146495e13d$var$styles.detailListContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, visibleUrls.map((url_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2c4eb146495e13d$var$CompactCard, {
                key: url_0,
                url: url_0,
                isTwoColumn: false,
                isFullScreen: isFullScreen,
                variant: "detail",
                isFirstItem: index === 0,
                onLinkClick: onLinkClick
            }))));
    } // Compact variant: individual cards in a flex grid (like original)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        xcss: isFullScreen ? $f2c4eb146495e13d$var$styles.gridFullScreen : $f2c4eb146495e13d$var$styles.grid
    }, visibleUrls.map((url_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2c4eb146495e13d$var$CompactCard, {
            key: url_1,
            url: url_1,
            isTwoColumn: showTwoColumnLayout,
            isFullScreen: isFullScreen,
            variant: "compact",
            onLinkClick: onLinkClick
        })));
};
const $f2c4eb146495e13d$export$a709ad096b071dd5 = /*#__PURE__*/ (0, $cozmU.memo)($f2c4eb146495e13d$var$InsightLinkCardGroupBase);
module.exports["InsightLinkCardGroup"] = $f2c4eb146495e13d$export$a709ad096b071dd5;

});

parcelRegister("fZS57", function(module, exports) {
/**
 * Parses a Google Calendar event URL of the canonical form:
 *
 *     https://www.google.com/calendar/event?eid=<base64-blob>[&...]
 *
 * Returns `null` for any other shape.
 */ 
var $e9nC3 = parcelRequire("e9nC3");

var $934fcc629839f9a3$require$Buffer = $e9nC3.Buffer;
const $934fcc629839f9a3$var$EVENT_ID_TIME_SUFFIX = /_(\d{8}T\d{6}Z)$/;
const $934fcc629839f9a3$var$decodeBase64Loose = (raw)=>{
    try {
        return $934fcc629839f9a3$require$Buffer.from(raw, 'base64').toString('utf-8');
    } catch  {
        return null;
    }
};
const $934fcc629839f9a3$var$toIsoStartTime = (eventId)=>{
    const match = eventId.match($934fcc629839f9a3$var$EVENT_ID_TIME_SUFFIX);
    if (!match) return undefined;
    const t = match[1];
    return `${t.slice(0, 4)}-${t.slice(4, 6)}-${t.slice(6, 11)}:${t.slice(11, 13)}:${t.slice(13, 15)}Z`;
};
const $934fcc629839f9a3$var$CANONICAL_HOSTNAME = 'www.google.com';
const $934fcc629839f9a3$var$CANONICAL_PATHNAME = '/calendar/event';
const $934fcc629839f9a3$var$matchesCanonicalShape = (parsed)=>parsed.protocol === 'https:' && parsed.hostname === $934fcc629839f9a3$var$CANONICAL_HOSTNAME && parsed.pathname === $934fcc629839f9a3$var$CANONICAL_PATHNAME;
const $934fcc629839f9a3$export$3d161d0be3bfed5 = (url)=>{
    let parsed;
    try {
        parsed = new URL(url);
    } catch  {
        return null;
    }
    if (!$934fcc629839f9a3$var$matchesCanonicalShape(parsed)) return null;
    const eidBlob = parsed.searchParams.get('eid');
    if (!eidBlob) return null;
    const decoded = $934fcc629839f9a3$var$decodeBase64Loose(eidBlob);
    if (!decoded) return null;
    const [eventId, ownerEmail] = decoded.split(' ');
    if (!eventId || !ownerEmail) return null;
    return {
        eventId: eventId,
        calendarId: ownerEmail,
        startTimeIso: $934fcc629839f9a3$var$toIsoStartTime(eventId)
    };
};
const $934fcc629839f9a3$export$ee4c9b3c1e520bbe = (url)=>{
    try {
        const parsed = new URL(url);
        return $934fcc629839f9a3$var$matchesCanonicalShape(parsed) && parsed.searchParams.has('eid');
    } catch  {
        return false;
    }
};
module.exports["parseGoogleCalendarUrl"] = $934fcc629839f9a3$export$3d161d0be3bfed5;
module.exports["isGoogleCalendarUrl"] = $934fcc629839f9a3$export$ee4c9b3c1e520bbe;

});

parcelRegister("lSHQh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<9cc173edd86d5753afe810260bf48288>>
 * @relayHash 4527ae63a2cf917389b3f2d0667f7b24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 213cf4460d384977dd9e050ec432ad80bf1f3f2802c23ff15094e75716d2c1c6
const $31d60349ac3e0f84$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "orgId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoogleCalendarCardTenantContextQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoogleCalendarCardTenantContextQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "213cf4460d384977dd9e050ec432ad80bf1f3f2802c23ff15094e75716d2c1c6",
            "metadata": {},
            "name": "GoogleCalendarCardTenantContextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$31d60349ac3e0f84$var$node.hash = "8d1a33c3833b62914f392aaf53e4a2f3";
var $31d60349ac3e0f84$export$2e2bcd8739ae039 = $31d60349ac3e0f84$var$node;


/**
 * @generated SignedSource<<d828ba3c0c4fd982fe6cafb1d012a542>>
 * @relayHash a2a6906dfa64f3ad881b40d8376718e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84ee4509b1df44eab6590551c21969b49e6bb5be78d6da8b92ac10cf943a91f2
const $3434d6b51461dea8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "accountId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "GoogleCalendarCardCurrentUserQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "GoogleCalendarCardCurrentUserQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "84ee4509b1df44eab6590551c21969b49e6bb5be78d6da8b92ac10cf943a91f2",
            "metadata": {},
            "name": "GoogleCalendarCardCurrentUserQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3434d6b51461dea8$var$node.hash = "5d2f0452f0c6dd917bd2ecdcfd264df1";
var $3434d6b51461dea8$export$2e2bcd8739ae039 = $3434d6b51461dea8$var$node;


/**
 * @generated SignedSource<<5c56b95148086b340ab3f058c4c8bc3c>>
 * @relayHash 05cda8a2a1e48dc779f5ed46514d2689
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f3249d2bbce6a7408b7321dd0b20e126aa0a56b12b39c8a9a1fc53d249ffd9a
const $7e307df941d437f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "params"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "queryContext"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "params",
            "variableName": "params"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        },
        {
            "kind": "Variable",
            "name": "queryContext",
            "variableName": "queryContext"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "displayName"
            },
            {
                "kind": "ScalarField",
                "name": "eventStartTime"
            },
            {
                "kind": "ScalarField",
                "name": "eventEndTime"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalCalendarEvent"
    }, v5 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoogleCalendarCardEventsQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreCypherQueryV2Connection",
                            "kind": "LinkedField",
                            "name": "cypherQueryV2",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Edge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Node",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreCypherQueryV2Column",
                                                    "kind": "LinkedField",
                                                    "name": "columns",
                                                    "plural": true,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "GraphStoreCypherQueryV2AriNode"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoogleCalendarCardEventsQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreCypherQueryV2Connection",
                            "kind": "LinkedField",
                            "name": "cypherQueryV2",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Edge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Node",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreCypherQueryV2Column",
                                                    "kind": "LinkedField",
                                                    "name": "columns",
                                                    "plural": true,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "AppUser"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "AtlassianAccountUser"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "CustomerUser"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsFeatureFlag"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsOperationsComponentDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsOperationsIncidentDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsProjectDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsPullRequestDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsRepository"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "JiraAutodevJob"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "JiraConfluenceRemoteIssueLink"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "JiraCustomRemoteIssueLink"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "JiraIssueRemoteIssueLink"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "JiraWebRemoteIssueLink"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "TeamCustomFieldValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "TeamType"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v5 /*: any*/ ,
                                                                                    "type": "ThirdPartyUser"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ],
                                                                    "type": "GraphStoreCypherQueryV2AriNode"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9f3249d2bbce6a7408b7321dd0b20e126aa0a56b12b39c8a9a1fc53d249ffd9a",
            "metadata": {},
            "name": "GoogleCalendarCardEventsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7e307df941d437f8$var$node.hash = "47e82e32da1ecf504cfaa2e776136d56";
var $7e307df941d437f8$export$2e2bcd8739ae039 = $7e307df941d437f8$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $hlvTd = parcelRequire("hlvTd");


var $fZS57 = parcelRequire("fZS57");


var $7hgf7 = parcelRequire("7hgf7");


var $8o9Ak = parcelRequire("8o9Ak");


var $1hQ0e = parcelRequire("1hQ0e");

const $488cd1392b3467c9$export$5442ab63c430a19b = 2592000000; // ±30 days
const $488cd1392b3467c9$export$c288a57024a06db7 = (targetTimeIso, now = new Date())=>{
    if (targetTimeIso) return Date.parse(targetTimeIso);
    return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
};
const $488cd1392b3467c9$export$525f5d3bedd34791 = `
	MATCH (user:IdentityUser {ari: $me})
		-[:user_linked_third_party_user]->(tpu:IdentityThirdPartyUser)
		-[:user_attended_calendar_event]->(event:ExternalCalendarEvent)
	WHERE event.eventStartTime >= datetime($startMin)
		AND event.eventStartTime <= datetime($startMax)
	RETURN event
	LIMIT 100
`;
const $488cd1392b3467c9$export$cd2e39b2daf4e7bb = ()=>{
    const doc = (0, $1hQ0e.getDocument)();
    if (typeof window === 'undefined' || !doc) return '';
    const metaCloudId = doc.querySelector('meta[name="ajs-cloud-id"]')?.getAttribute('content');
    if (metaCloudId) return metaCloudId;
    return new URLSearchParams(window.location.search).get('cloudId') ?? '';
};
const $488cd1392b3467c9$export$bf172ab600d8c432 = (data)=>{
    const edges = data?.graphStore?.cypherQueryV2?.edges ?? [];
    return edges.flatMap((edge)=>edge?.node?.columns ?? []).map((column)=>{
        if (!column || column.value?.__typename !== 'GraphStoreCypherQueryV2AriNode') return null;
        const entity = column.value.data;
        if (entity?.__typename !== 'ExternalCalendarEvent' || !entity.id) return null;
        return {
            id: entity.id,
            url: entity.url ?? null,
            title: entity.displayName ?? '',
            startTimeIso: entity.eventStartTime ?? null,
            endTimeIso: entity.eventEndTime ?? null
        };
    }).filter((event)=>event !== null);
};









var $7pCWA = parcelRequire("7pCWA");

const $7465ebed39c2f667$var$GOOGLE_CALENDAR_RESOURCE_TYPE = 'google-calendar-connector';
const $7465ebed39c2f667$var$GOOGLE_CALENDAR_SOURCES = new Set([
    'google-calendar',
    'google_calendar'
]);
const $7465ebed39c2f667$export$6d6ac81eb30ecea5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [sources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    let t0;
    if ($[0] !== sources) {
        t0 = sources.find($7465ebed39c2f667$var$_temp) ?? null;
        $[0] = sources;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [sources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    return sources.find((c)=>c.resourceType === $7465ebed39c2f667$var$GOOGLE_CALENDAR_RESOURCE_TYPE || $7465ebed39c2f667$var$GOOGLE_CALENDAR_SOURCES.has(c.source)) ?? null;
};
function $7465ebed39c2f667$var$_temp(c) {
    return c.resourceType === $7465ebed39c2f667$var$GOOGLE_CALENDAR_RESOURCE_TYPE || $7465ebed39c2f667$var$GOOGLE_CALENDAR_SOURCES.has(c.source);
}


const $9fb6a41fe280438f$var$containerStyles = null;
const $9fb6a41fe280438f$var$containerVariantStyles = {
    default: "",
    detail: "_0bjKvDyzSk"
};
const $9fb6a41fe280438f$var$titleStyles = null;
const $9fb6a41fe280438f$var$blockStyles = null;
const $9fb6a41fe280438f$var$blockAlignCenterStyles = null;
const $9fb6a41fe280438f$var$groupColumnStyles = null;
const $9fb6a41fe280438f$var$metadataStyles = null;
const $9fb6a41fe280438f$var$renderDateSubtitle = (eventDate)=>eventDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-smart-element": "EventDate",
        "data-smart-element-text": "true",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbvLZJ _4ouGXIdnbC _1ANEUSLRg7 _39HuIbz8Lp _1UtDYzKGUX"
        ])
    }, eventDate) : null;
const $9fb6a41fe280438f$var$formatEventDate = (formatDate, startIso)=>{
    if (!startIso) return undefined;
    const startMs = Date.parse(startIso);
    if (Number.isNaN(startMs)) return undefined;
    const startDate = new Date(startMs);
    return formatDate(startDate, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
const $9fb6a41fe280438f$var$GoogleCalendarCardLayout = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { title: title, subtitle: subtitle, hideSubtitle: t1, titleAppearance: t2 } = t0;
    const hideSubtitle = t1 === undefined ? false : t1;
    const titleAppearance = t2 === undefined ? "default" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t3 = $9fb6a41fe280438f$var$containerVariantStyles[titleAppearance];
    let t4;
    if ($[0] !== t3) {
        t4 = (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvD8fU6 _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _1EqgXlN91d _4ouGXIdnbC _24h04i2Njc",
            t3
        ]);
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const t5 = !hideSubtitle && "_0hPCNLDIqT";
    let t6;
    if ($[2] !== t5) {
        t6 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4ouGXIdnbC",
            t5
        ]);
        $[2] = t5;
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== formatMessage) {
        t7 = formatMessage((0, $8o9Ak.default).googleCalendarProvider);
        $[4] = formatMessage;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-smart-element-icon": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hgf7.GoogleCalendarIcon), {
            label: t7
        }));
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC"
        ]);
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            "_3iDTPbvLZJ _4ouGXIdnbC _1mT5xdRAKS _0Bm75GFQfX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
        ]);
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== title || $[11] !== titleAppearance) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-smart-element": "Title",
            className: t10
        }, titleAppearance === "detail" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            maxLines: 1,
            weight: "bold"
        }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            maxLines: 1,
            weight: "medium"
        }, title));
        $[10] = title;
        $[11] = titleAppearance;
        $[12] = t11;
    } else t11 = $[12];
    const t12 = hideSubtitle ? null : subtitle;
    let t13;
    if ($[13] !== t11 || $[14] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-smart-element-group": "true",
            className: t9
        }, t11, t12);
        $[13] = t11;
        $[14] = t12;
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== t13 || $[17] !== t6 || $[18] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-smart-block": "true",
            className: t6
        }, t8, t13);
        $[16] = t13;
        $[17] = t6;
        $[18] = t8;
        $[19] = t14;
    } else t14 = $[19];
    let t15;
    if ($[20] !== t14 || $[21] !== t4) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-smart-link-container": "true",
            className: t4
        }, t14);
        $[20] = t14;
        $[21] = t4;
        $[22] = t15;
    } else t15 = $[22];
    return t15;
} : ({ title: title, subtitle: subtitle, hideSubtitle: hideSubtitle = false, titleAppearance: titleAppearance = 'default' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-link-container": "true",
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvD8fU6 _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _1EqgXlN91d _4ouGXIdnbC _24h04i2Njc",
            $9fb6a41fe280438f$var$containerVariantStyles[titleAppearance]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-block": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4ouGXIdnbC",
            !hideSubtitle && "_0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-element-icon": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hgf7.GoogleCalendarIcon), {
        label: formatMessage((0, $8o9Ak.default).googleCalendarProvider)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-element-group": "true",
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-smart-element": "Title",
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _4ouGXIdnbC _1mT5xdRAKS _0Bm75GFQfX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
        ])
    }, titleAppearance === 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: 1,
        weight: "bold"
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: 1,
        weight: "medium"
    }, title)), hideSubtitle ? null : subtitle)));
}; // URL-only render: title = URL, snippet = parsed start/end if any.
const $9fb6a41fe280438f$var$FallbackVariant = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance } = t0;
    const { formatDate: formatDate } = (0, $kSwu1.useIntl)();
    let T0;
    let t1;
    let t2;
    if ($[0] !== formatDate || $[1] !== url) {
        const parsed = (0, $fZS57.parseGoogleCalendarUrl)(url);
        const eventDate = $9fb6a41fe280438f$var$formatEventDate(formatDate, parsed?.startTimeIso);
        T0 = $9fb6a41fe280438f$var$GoogleCalendarCardLayout;
        t1 = url;
        t2 = $9fb6a41fe280438f$var$renderDateSubtitle(eventDate);
        $[0] = formatDate;
        $[1] = url;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    let t3;
    if ($[5] !== T0 || $[6] !== hideSubtitle || $[7] !== t1 || $[8] !== t2 || $[9] !== titleAppearance) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            title: t1,
            subtitle: t2,
            hideSubtitle: hideSubtitle,
            titleAppearance: titleAppearance
        });
        $[5] = T0;
        $[6] = hideSubtitle;
        $[7] = t1;
        $[8] = t2;
        $[9] = titleAppearance;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance })=>{
    const { formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const parsed = (0, $fZS57.parseGoogleCalendarUrl)(url);
    const eventDate = $9fb6a41fe280438f$var$formatEventDate(formatDate, parsed?.startTimeIso);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$GoogleCalendarCardLayout, {
        title: url,
        subtitle: $9fb6a41fe280438f$var$renderDateSubtitle(eventDate),
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    });
}; // Suspense reader: matches the user's calendar events against `url`; falls back to URL-only.
const $9fb6a41fe280438f$var$FetchedVariant = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance, userAri: userAri, queryContext: queryContext } = t0;
    const { formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const targetTimeIso = (0, $fZS57.parseGoogleCalendarUrl)(url)?.startTimeIso;
    const targetMs = (0, $488cd1392b3467c9$export$c288a57024a06db7)(targetTimeIso);
    let t1;
    if ($[0] !== targetMs) {
        t1 = new Date(targetMs - (0, $488cd1392b3467c9$export$5442ab63c430a19b)).toISOString();
        $[0] = targetMs;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== targetMs) {
        t2 = new Date(targetMs + (0, $488cd1392b3467c9$export$5442ab63c430a19b)).toISOString();
        $[2] = targetMs;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = {
            startMin: t1,
            startMax: t2
        };
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { startMin: startMin, startMax: startMax } = t3;
    let t4;
    if ($[7] !== startMax || $[8] !== startMin || $[9] !== userAri) {
        t4 = {
            me: userAri,
            startMin: startMin,
            startMax: startMax
        };
        $[7] = startMax;
        $[8] = startMin;
        $[9] = userAri;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== queryContext || $[12] !== t4) {
        t5 = {
            cypherQuery: (0, $488cd1392b3467c9$export$525f5d3bedd34791),
            params: t4,
            queryContext: queryContext
        };
        $[11] = queryContext;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            fetchPolicy: "store-or-network",
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "X-Force-Flock": "false",
                        "X-Force-Dynamo": "true"
                    }
                }
            }
        };
        $[14] = t6;
    } else t6 = $[14];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $7e307df941d437f8$export$2e2bcd8739ae039), t5, t6);
    let T0;
    let t7;
    let t8;
    let t9;
    if ($[15] !== data?.graphStore?.cypherQueryV2?.edges || $[16] !== formatDate || $[17] !== hideSubtitle || $[18] !== titleAppearance || $[19] !== url) {
        t9 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const events = (data?.graphStore?.cypherQueryV2?.edges ?? []).flatMap($9fb6a41fe280438f$var$_temp).map($9fb6a41fe280438f$var$_temp2).filter($9fb6a41fe280438f$var$_temp3);
            let seriesIdOf;
            let t10;
            if ($[24] !== url) {
                const parsed = (0, $fZS57.parseGoogleCalendarUrl)(url);
                seriesIdOf = $9fb6a41fe280438f$var$_temp4;
                t10 = seriesIdOf(parsed?.eventId);
                $[24] = url;
                $[25] = seriesIdOf;
                $[26] = t10;
            } else {
                seriesIdOf = $[25];
                t10 = $[26];
            }
            const targetSeriesId = t10;
            const matched = targetSeriesId ? events.find((event_0)=>{
                const candidateSeriesId = event_0.url ? seriesIdOf((0, $fZS57.parseGoogleCalendarUrl)(event_0.url)?.eventId) : null;
                return candidateSeriesId === targetSeriesId;
            }) : undefined;
            if (!matched) {
                let t11;
                if ($[27] !== hideSubtitle || $[28] !== titleAppearance || $[29] !== url) {
                    t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
                        url: url,
                        hideSubtitle: hideSubtitle,
                        titleAppearance: titleAppearance
                    });
                    $[27] = hideSubtitle;
                    $[28] = titleAppearance;
                    $[29] = url;
                    $[30] = t11;
                } else t11 = $[30];
                t9 = t11;
                break bb0;
            }
            const eventDate = $9fb6a41fe280438f$var$formatEventDate(formatDate, matched.startTimeIso ?? undefined);
            T0 = $9fb6a41fe280438f$var$GoogleCalendarCardLayout;
            t7 = matched.title || url;
            t8 = $9fb6a41fe280438f$var$renderDateSubtitle(eventDate);
        }
        $[15] = data?.graphStore?.cypherQueryV2?.edges;
        $[16] = formatDate;
        $[17] = hideSubtitle;
        $[18] = titleAppearance;
        $[19] = url;
        $[20] = T0;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else {
        T0 = $[20];
        t7 = $[21];
        t8 = $[22];
        t9 = $[23];
    }
    if (t9 !== Symbol.for("react.early_return_sentinel")) return t9;
    let t10;
    if ($[31] !== T0 || $[32] !== hideSubtitle || $[33] !== t7 || $[34] !== t8 || $[35] !== titleAppearance) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            title: t7,
            subtitle: t8,
            hideSubtitle: hideSubtitle,
            titleAppearance: titleAppearance
        });
        $[31] = T0;
        $[32] = hideSubtitle;
        $[33] = t7;
        $[34] = t8;
        $[35] = titleAppearance;
        $[36] = t10;
    } else t10 = $[36];
    return t10;
} : ({ url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance, userAri: userAri, queryContext: queryContext })=>{
    const { formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const targetTimeIso = (0, $fZS57.parseGoogleCalendarUrl)(url)?.startTimeIso;
    const { startMin: startMin, startMax: startMax } = (0, $cozmU.useMemo)(()=>{
        const targetMs = (0, $488cd1392b3467c9$export$c288a57024a06db7)(targetTimeIso);
        return {
            startMin: new Date(targetMs - (0, $488cd1392b3467c9$export$5442ab63c430a19b)).toISOString(),
            startMax: new Date(targetMs + (0, $488cd1392b3467c9$export$5442ab63c430a19b)).toISOString()
        };
    }, [
        targetTimeIso
    ]);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $7e307df941d437f8$export$2e2bcd8739ae039), {
        cypherQuery: (0, $488cd1392b3467c9$export$525f5d3bedd34791),
        params: {
            me: userAri,
            startMin: startMin,
            startMax: startMax
        },
        queryContext: queryContext
    }, {
        fetchPolicy: 'store-or-network',
        networkCacheConfig: {
            metadata: {
                headers: {
                    'X-Force-Flock': 'false',
                    'X-Force-Dynamo': 'true'
                }
            }
        }
    }); // Inline the mapping so each Relay-tracked field is consumed in this file
    // (satisfies @atlassian/relay/unused-fields, which only inspects the file
    // containing the graphql document).
    const events = (data?.graphStore?.cypherQueryV2?.edges ?? []).flatMap((edge)=>edge?.node?.columns ?? []).map((column)=>{
        if (!column || column.value?.__typename !== 'GraphStoreCypherQueryV2AriNode') return null;
        const entity = column.value.data;
        if (entity?.__typename !== 'ExternalCalendarEvent' || !entity.id) return null;
        return {
            id: entity.id,
            url: entity.url ?? null,
            title: entity.displayName ?? '',
            startTimeIso: entity.eventStartTime ?? null,
            endTimeIso: entity.eventEndTime ?? null
        };
    }).filter((event)=>event !== null);
    const parsed = (0, $fZS57.parseGoogleCalendarUrl)(url); // Match by series id (prefix before `_<timestamp>`) to cover recurring/cross-attendee shares.
    const seriesIdOf = (eventId)=>eventId ? eventId.split('_')[0] ?? null : null;
    const targetSeriesId = seriesIdOf(parsed?.eventId);
    const matched = targetSeriesId ? events.find((event_0)=>{
        const candidateSeriesId = event_0.url ? seriesIdOf((0, $fZS57.parseGoogleCalendarUrl)(event_0.url)?.eventId) : null;
        return candidateSeriesId === targetSeriesId;
    }) : undefined;
    if (!matched) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
        url: url,
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    });
    const eventDate = $9fb6a41fe280438f$var$formatEventDate(formatDate, matched.startTimeIso ?? undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$GoogleCalendarCardLayout, {
        title: matched.title || url,
        subtitle: $9fb6a41fe280438f$var$renderDateSubtitle(eventDate),
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    });
};
const $9fb6a41fe280438f$var$FetchedVariantHost = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    const currentUser = (0, $6SsN4.useLazyLoadQuery)((0, $3434d6b51461dea8$export$2e2bcd8739ae039), t1, t2);
    const accountId = currentUser?.me?.user?.accountId ?? null;
    const userAri = accountId ? `ari:cloud:identity::user/${accountId}` : null;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $488cd1392b3467c9$export$cd2e39b2daf4e7bb)();
        $[2] = t3;
    } else t3 = $[2];
    const cloudId = t3;
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            cloudIds: cloudId ? [
                cloudId
            ] : []
        };
        t5 = {
            fetchPolicy: "store-or-network"
        };
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    const tenantContext = (0, $6SsN4.useLazyLoadQuery)((0, $31d60349ac3e0f84$export$2e2bcd8739ae039), t4, t5);
    const orgId = tenantContext?.tenantContexts?.[0]?.orgId ?? null;
    const queryContext = orgId ? `ari:cloud:platform::org/${orgId}` : null;
    if (!userAri || !queryContext) {
        let t6;
        if ($[5] !== hideSubtitle || $[6] !== titleAppearance || $[7] !== url) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
                url: url,
                hideSubtitle: hideSubtitle,
                titleAppearance: titleAppearance
            });
            $[5] = hideSubtitle;
            $[6] = titleAppearance;
            $[7] = url;
            $[8] = t6;
        } else t6 = $[8];
        return t6;
    }
    let t6;
    if ($[9] !== hideSubtitle || $[10] !== queryContext || $[11] !== titleAppearance || $[12] !== url || $[13] !== userAri) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FetchedVariant, {
            url: url,
            hideSubtitle: hideSubtitle,
            titleAppearance: titleAppearance,
            userAri: userAri,
            queryContext: queryContext
        });
        $[9] = hideSubtitle;
        $[10] = queryContext;
        $[11] = titleAppearance;
        $[12] = url;
        $[13] = userAri;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance })=>{
    const currentUser = (0, $6SsN4.useLazyLoadQuery)((0, $3434d6b51461dea8$export$2e2bcd8739ae039), {}, {
        fetchPolicy: 'store-or-network'
    });
    const accountId = currentUser?.me?.user?.accountId ?? null;
    const userAri = accountId ? `ari:cloud:identity::user/${accountId}` : null;
    const cloudId = (0, $488cd1392b3467c9$export$cd2e39b2daf4e7bb)();
    const tenantContext = (0, $6SsN4.useLazyLoadQuery)((0, $31d60349ac3e0f84$export$2e2bcd8739ae039), {
        cloudIds: cloudId ? [
            cloudId
        ] : []
    }, {
        fetchPolicy: 'store-or-network'
    });
    const orgId = tenantContext?.tenantContexts?.[0]?.orgId ?? null;
    const queryContext = orgId ? `ari:cloud:platform::org/${orgId}` : null;
    if (!userAri || !queryContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
        url: url,
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FetchedVariant, {
        url: url,
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance,
        userAri: userAri,
        queryContext: queryContext
    });
};
const $9fb6a41fe280438f$var$GoogleCalendarCardBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance } = t0;
    const connector = (0, $7465ebed39c2f667$export$6d6ac81eb30ecea5)();
    const isConnected = Boolean(connector?.isUserOAuthed);
    if (!isConnected) {
        let t1;
        if ($[0] !== hideSubtitle || $[1] !== titleAppearance || $[2] !== url) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
                url: url,
                hideSubtitle: hideSubtitle,
                titleAppearance: titleAppearance
            });
            $[0] = hideSubtitle;
            $[1] = titleAppearance;
            $[2] = url;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    let t1;
    if ($[4] !== hideSubtitle || $[5] !== titleAppearance || $[6] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
            url: url,
            hideSubtitle: hideSubtitle,
            titleAppearance: titleAppearance
        });
        $[4] = hideSubtitle;
        $[5] = titleAppearance;
        $[6] = url;
        $[7] = t1;
    } else t1 = $[7];
    const fallback = t1;
    let t2;
    if ($[8] !== url) {
        t2 = [
            url
        ];
        $[8] = url;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== hideSubtitle || $[11] !== titleAppearance || $[12] !== url) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FetchedVariantHost, {
            url: url,
            hideSubtitle: hideSubtitle,
            titleAppearance: titleAppearance
        });
        $[10] = hideSubtitle;
        $[11] = titleAppearance;
        $[12] = url;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== fallback || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: fallback
        }, t3);
        $[14] = fallback;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== fallback || $[18] !== t2 || $[19] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: fallback,
            resetKeys: t2,
            onError: $9fb6a41fe280438f$var$_temp5
        }, t4);
        $[17] = fallback;
        $[18] = t2;
        $[19] = t4;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ url: url, hideSubtitle: hideSubtitle, titleAppearance: titleAppearance })=>{
    const connector = (0, $7465ebed39c2f667$export$6d6ac81eb30ecea5)();
    const isConnected = Boolean(connector?.isUserOAuthed);
    if (!isConnected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
        url: url,
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    });
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FallbackVariant, {
        url: url,
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    }); // Degrade to URL-only on both pending and error states. Errors are
    // reported to Sentry so the silent fallback stays observable.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: fallback,
        resetKeys: [
            url
        ],
        onError: (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: 'googleCalendarCardRelay'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9fb6a41fe280438f$var$FetchedVariantHost, {
        url: url,
        hideSubtitle: hideSubtitle,
        titleAppearance: titleAppearance
    })));
};
const $9fb6a41fe280438f$export$b3d691e275fc81a = /*#__PURE__*/ (0, $cozmU.memo)($9fb6a41fe280438f$var$GoogleCalendarCardBase);
function $9fb6a41fe280438f$var$_temp(edge) {
    return edge?.node?.columns ?? [];
}
function $9fb6a41fe280438f$var$_temp2(column) {
    if (!column || column.value?.__typename !== "GraphStoreCypherQueryV2AriNode") return null;
    const entity = column.value.data;
    if (entity?.__typename !== "ExternalCalendarEvent" || !entity.id) return null;
    return {
        id: entity.id,
        url: entity.url ?? null,
        title: entity.displayName ?? "",
        startTimeIso: entity.eventStartTime ?? null,
        endTimeIso: entity.eventEndTime ?? null
    };
}
function $9fb6a41fe280438f$var$_temp3(event) {
    return event !== null;
}
function $9fb6a41fe280438f$var$_temp4(eventId) {
    return eventId ? eventId.split("_")[0] ?? null : null;
}
function $9fb6a41fe280438f$var$_temp5(error) {
    (0, $hlvTd.logException)({
        exception: error,
        name: "googleCalendarCardRelay"
    });
}
module.exports["GoogleCalendarCard"] = $9fb6a41fe280438f$export$b3d691e275fc81a;

});

parcelRegister("7hgf7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a8abba00fc800a43$export$73d71809eb86c017 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(59);
    const t0 = (0, $cozmU.useId)();
    let t1;
    if ($[0] !== t0) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /:/g;
            $[2] = t2;
        } else t2 = $[2];
        t1 = t0.replace(t2, "");
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const id = t1;
    const clipId = `new-google-calendar-clip-${id}`;
    const bodyMaskId = `new-google-calendar-body-mask-${id}`;
    const highlightMaskId = `new-google-calendar-highlight-mask-${id}`;
    const highlightGradientId = `new-google-calendar-highlight-gradient-${id}`;
    const topGradientId = `new-google-calendar-top-gradient-${id}`;
    const topBlurId = `new-google-calendar-top-blur-${id}`;
    const t2 = `url(#${clipId})`;
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.86583 5.47534C7.1287 3.3375 9.07481 1.81759 11.2126 2.08046L20.6747 3.24393C22.8125 3.5068 24.3325 5.45291 24.0696 7.59074L23.5672 11.6766C23.3043 13.8145 21.3582 15.3344 19.2204 15.0715L9.7583 13.908C7.62047 13.6452 6.10055 11.6991 6.36342 9.56123L6.86583 5.47534Z",
            fill: "#BBE2FF"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.0271 6.96783C5.00906 4.84102 6.8667 3.18389 8.97753 3.44344L22.5134 5.10783C24.6244 5.3674 26.0251 7.42518 25.4923 9.48427L23.8977 15.6472L23.9518 22.0129C23.9698 24.1397 22.1123 25.7969 20.0014 25.5373L6.46548 23.8729C4.35453 23.6133 2.95381 21.5556 3.48656 19.4965L5.08113 13.3335L5.0271 6.96783Z",
            fill: "#3C90FF"
        });
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            maskType: "alpha"
        };
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.0271 6.96783C5.00906 4.84102 6.8667 3.18389 8.97753 3.44344L22.5134 5.10783C24.6244 5.3674 26.0251 7.42518 25.4923 9.48427L23.8977 15.6472L23.9518 22.0129C23.9698 24.1397 22.1123 25.7969 20.0014 25.5373L6.46548 23.8729C4.35453 23.6133 2.95381 21.5556 3.48656 19.4965L5.08113 13.3335L5.0271 6.96783Z",
            fill: "#3C90FF"
        });
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    let t7;
    if ($[7] !== bodyMaskId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: bodyMaskId,
            maskUnits: "userSpaceOnUse",
            x: "3",
            y: "3",
            width: "23",
            height: "23",
            style: t5
        }, t6);
        $[7] = bodyMaskId;
        $[8] = t7;
    } else t7 = $[8];
    const t8 = `url(#${bodyMaskId})`;
    const t9 = `url(#${highlightGradientId})`;
    let t10;
    if ($[9] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M2.07861 23.333L24.3897 26.0764L25.6458 15.8617L3.33463 13.1183L2.07861 23.333Z",
            fill: t9
        });
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== t10 || $[12] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: t8
        }, t10);
        $[11] = t10;
        $[12] = t8;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    let t13;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            maskType: "alpha"
        };
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.0271 6.96783C5.00906 4.84102 6.8667 3.18389 8.97753 3.44344L22.5134 5.10783C24.6244 5.3674 26.0251 7.42518 25.4923 9.48427L23.8977 15.6472L23.9518 22.0129C23.9698 24.1397 22.1123 25.7969 20.0014 25.5373L6.46548 23.8729C4.35453 23.6133 2.95381 21.5556 3.48656 19.4965L5.08113 13.3335L5.0271 6.96783Z",
            fill: "#3186FF"
        });
        $[14] = t12;
        $[15] = t13;
    } else {
        t12 = $[14];
        t13 = $[15];
    }
    let t14;
    if ($[16] !== highlightMaskId) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: highlightMaskId,
            maskUnits: "userSpaceOnUse",
            x: "3",
            y: "3",
            width: "23",
            height: "23",
            style: t12
        }, t13);
        $[16] = highlightMaskId;
        $[17] = t14;
    } else t14 = $[17];
    const t15 = `url(#${highlightMaskId})`;
    const t16 = `url(#${topBlurId})`;
    const t17 = `url(#${topGradientId})`;
    let t18;
    if ($[18] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M7.02449 4.18603C7.19973 2.76081 8.49714 1.74753 9.92236 1.92278L21.965 3.40356C23.3902 3.57881 24.4035 4.87621 24.2282 6.30144L23.0912 15.5485L5.88746 13.4331L7.02449 4.18603Z",
            fill: t17
        });
        $[18] = t17;
        $[19] = t18;
    } else t18 = $[19];
    let t19;
    if ($[20] !== t16 || $[21] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            filter: t16
        }, t18);
        $[20] = t16;
        $[21] = t18;
        $[22] = t19;
    } else t19 = $[22];
    let t20;
    if ($[23] !== t15 || $[24] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: t15
        }, t19);
        $[23] = t15;
        $[24] = t19;
        $[25] = t20;
    } else t20 = $[25];
    let t21;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.0966 19.1675C10.5337 19.0983 10.0622 18.9474 9.6819 18.7148C9.30165 18.4822 8.99081 18.1955 8.7494 17.8545C8.51304 17.5095 8.35594 17.1812 8.27808 16.8698C8.20023 16.5583 8.17671 16.3719 8.20754 16.3106C8.2406 16.2477 8.29629 16.1998 8.36334 16.1764L9.16255 15.9681C9.23046 15.944 9.29509 15.9473 9.35644 15.978C9.41816 16.0041 9.48072 16.1187 9.54409 16.3216C9.61203 16.525 9.71512 16.7444 9.85335 16.9798C9.9927 17.2069 10.1774 17.4028 10.3959 17.5552C10.6148 17.7029 10.8957 17.7978 11.2388 17.84C11.7926 17.9081 12.2516 17.802 12.616 17.5216C12.9849 17.2418 13.1997 16.8547 13.2605 16.3605C13.3263 15.825 13.203 15.3917 12.8907 15.0606C12.5789 14.725 12.137 14.5219 11.5649 14.4516L10.8442 14.363C10.7779 14.356 10.717 14.3235 10.6742 14.2725C10.6346 14.2165 10.6188 14.1565 10.6266 14.0924L10.7169 13.3579C10.7253 13.2892 10.7552 13.2348 10.8065 13.1947C10.8326 13.1734 10.8626 13.1577 10.895 13.1485C10.9273 13.1393 10.9611 13.1368 10.9945 13.1411L11.619 13.2179C12.1316 13.2809 12.5607 13.192 12.9062 12.951C13.2518 12.7101 13.4518 12.3677 13.5064 11.9238C13.5604 11.4846 13.4644 11.1128 13.2184 10.8084C12.9724 10.504 12.6046 10.3217 12.115 10.2615C11.8404 10.2277 11.5968 10.2442 11.3842 10.311C11.174 10.3764 10.9801 10.4855 10.8152 10.6313C10.6529 10.7695 10.5054 10.9242 10.3752 11.0929C10.2486 11.2539 10.1521 11.3396 10.0857 11.35C10.02 11.3558 9.95965 11.3368 9.90455 11.2929L9.22679 10.8541C9.17124 10.8148 9.13855 10.7596 9.12871 10.6887C9.11887 10.6178 9.19349 10.4644 9.35257 10.2285C9.51678 9.98855 9.7502 9.75243 10.0528 9.52013C10.3566 9.28567 10.7047 9.11513 11.0762 9.01877C11.4558 8.91673 11.8858 8.89529 12.3663 8.95447C13.2588 9.06421 13.9369 9.3868 14.4006 9.92226C14.8649 10.4532 15.0498 11.1032 14.9553 11.8721C14.89 12.403 14.7053 12.8471 14.4012 13.2046C14.1016 13.5625 13.7109 13.7932 13.229 13.8968L13.2256 13.9242C13.7637 14.1576 14.1659 14.5136 14.4322 14.9923C14.7037 15.4671 14.8023 16.0065 14.7279 16.6105C14.6216 17.4755 14.2323 18.1478 13.5601 18.6273C12.8881 19.1067 12.067 19.2868 11.0966 19.1675ZM18.0043 19.8566C17.9265 19.847 17.8615 19.8088 17.8092 19.742C17.7621 19.6779 17.742 19.5979 17.7531 19.5191L18.6917 11.8855L17.0104 12.8076C16.9503 12.8421 16.8845 12.848 16.813 12.8252C16.7485 12.805 16.6942 12.761 16.661 12.702L16.2925 12.0155C16.2591 11.9551 16.2504 11.8841 16.268 11.8174C16.2907 11.7459 16.3343 11.6933 16.3989 11.6594L19.3785 10.0396C19.4037 10.0242 19.4306 10.0136 19.4591 10.0078C19.4883 9.99747 19.5212 9.99455 19.5577 9.99905L20.1345 10.07C20.2122 10.0795 20.2706 10.1146 20.3097 10.1751C20.3539 10.2315 20.3712 10.2987 20.3616 10.3766L19.2153 19.6989C19.2051 19.7814 19.1667 19.8486 19.0999 19.9007C19.0704 19.9264 19.0358 19.9454 18.9984 19.9564C18.9609 19.9674 18.9215 19.9702 18.8829 19.9646L18.0043 19.8566Z",
            fill: "white"
        });
        $[26] = t21;
    } else t21 = $[26];
    let t22;
    if ($[27] !== t11 || $[28] !== t14 || $[29] !== t20 || $[30] !== t7) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            transform: "rotate(-7.01 14.49 14.49)"
        }, t3, t4, t7, t11, t14, t20, t21);
        $[27] = t11;
        $[28] = t14;
        $[29] = t20;
        $[30] = t7;
        $[31] = t22;
    } else t22 = $[31];
    let t23;
    if ($[32] !== t2 || $[33] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: t2
        }, t22);
        $[32] = t2;
        $[33] = t22;
        $[34] = t23;
    } else t23 = $[34];
    let t24;
    let t25;
    let t26;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
        });
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "BackgroundImageFix",
            result: "shape"
        });
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
            stdDeviation: "0.8125",
            result: "effect1_foregroundBlur"
        });
        $[35] = t24;
        $[36] = t25;
        $[37] = t26;
    } else {
        t24 = $[35];
        t25 = $[36];
        t26 = $[37];
    }
    let t27;
    if ($[38] !== topBlurId) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: topBlurId,
            x: "4.2627",
            y: "0.27832",
            width: "21.6104",
            height: "16.8955",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB"
        }, t24, t25, t26);
        $[38] = topBlurId;
        $[39] = t27;
    } else t27 = $[39];
    let t28;
    let t29;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#4FA0FF"
        });
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#3186FF"
        });
        $[40] = t28;
        $[41] = t29;
    } else {
        t28 = $[40];
        t29 = $[41];
    }
    let t30;
    if ($[42] !== highlightGradientId) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: highlightGradientId,
            x1: "14.4902",
            y1: "14.49",
            x2: "13.2342",
            y2: "24.7047",
            gradientUnits: "userSpaceOnUse"
        }, t28, t29);
        $[42] = highlightGradientId;
        $[43] = t30;
    } else t30 = $[43];
    let t31;
    let t32;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#A9A8FF"
        });
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.8",
            stopColor: "#3C90FF"
        });
        $[44] = t31;
        $[45] = t32;
    } else {
        t31 = $[44];
        t32 = $[45];
    }
    let t33;
    if ($[46] !== topGradientId) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: topGradientId,
            x1: "14.7837",
            y1: "4.39654",
            x2: "13.5501",
            y2: "14.4285",
            gradientUnits: "userSpaceOnUse"
        }, t31, t32);
        $[46] = topGradientId;
        $[47] = t33;
    } else t33 = $[47];
    let t34;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "29",
            height: "29",
            fill: "white"
        });
        $[48] = t34;
    } else t34 = $[48];
    let t35;
    if ($[49] !== clipId) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipId
        }, t34);
        $[49] = clipId;
        $[50] = t35;
    } else t35 = $[50];
    let t36;
    if ($[51] !== t27 || $[52] !== t30 || $[53] !== t33 || $[54] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t27, t30, t33, t35);
        $[51] = t27;
        $[52] = t30;
        $[53] = t33;
        $[54] = t35;
        $[55] = t36;
    } else t36 = $[55];
    let t37;
    if ($[56] !== t23 || $[57] !== t36) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t23, t36);
        $[56] = t23;
        $[57] = t36;
        $[58] = t37;
    } else t37 = $[58];
    return t37;
} : ()=>{
    const id = (0, $cozmU.useId)().replace(/:/g, '');
    const clipId = `new-google-calendar-clip-${id}`;
    const bodyMaskId = `new-google-calendar-body-mask-${id}`;
    const highlightMaskId = `new-google-calendar-highlight-mask-${id}`;
    const highlightGradientId = `new-google-calendar-highlight-gradient-${id}`;
    const topGradientId = `new-google-calendar-top-gradient-${id}`;
    const topBlurId = `new-google-calendar-top-blur-${id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: "rotate(-7.01 14.49 14.49)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.86583 5.47534C7.1287 3.3375 9.07481 1.81759 11.2126 2.08046L20.6747 3.24393C22.8125 3.5068 24.3325 5.45291 24.0696 7.59074L23.5672 11.6766C23.3043 13.8145 21.3582 15.3344 19.2204 15.0715L9.7583 13.908C7.62047 13.6452 6.10055 11.6991 6.36342 9.56123L6.86583 5.47534Z",
        fill: "#BBE2FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.0271 6.96783C5.00906 4.84102 6.8667 3.18389 8.97753 3.44344L22.5134 5.10783C24.6244 5.3674 26.0251 7.42518 25.4923 9.48427L23.8977 15.6472L23.9518 22.0129C23.9698 24.1397 22.1123 25.7969 20.0014 25.5373L6.46548 23.8729C4.35453 23.6133 2.95381 21.5556 3.48656 19.4965L5.08113 13.3335L5.0271 6.96783Z",
        fill: "#3C90FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: bodyMaskId,
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "3",
        width: "23",
        height: "23",
        style: {
            maskType: 'alpha'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.0271 6.96783C5.00906 4.84102 6.8667 3.18389 8.97753 3.44344L22.5134 5.10783C24.6244 5.3674 26.0251 7.42518 25.4923 9.48427L23.8977 15.6472L23.9518 22.0129C23.9698 24.1397 22.1123 25.7969 20.0014 25.5373L6.46548 23.8729C4.35453 23.6133 2.95381 21.5556 3.48656 19.4965L5.08113 13.3335L5.0271 6.96783Z",
        fill: "#3C90FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: `url(#${bodyMaskId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M2.07861 23.333L24.3897 26.0764L25.6458 15.8617L3.33463 13.1183L2.07861 23.333Z",
        fill: `url(#${highlightGradientId})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: highlightMaskId,
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "3",
        width: "23",
        height: "23",
        style: {
            maskType: 'alpha'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.0271 6.96783C5.00906 4.84102 6.8667 3.18389 8.97753 3.44344L22.5134 5.10783C24.6244 5.3674 26.0251 7.42518 25.4923 9.48427L23.8977 15.6472L23.9518 22.0129C23.9698 24.1397 22.1123 25.7969 20.0014 25.5373L6.46548 23.8729C4.35453 23.6133 2.95381 21.5556 3.48656 19.4965L5.08113 13.3335L5.0271 6.96783Z",
        fill: "#3186FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: `url(#${highlightMaskId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: `url(#${topBlurId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.02449 4.18603C7.19973 2.76081 8.49714 1.74753 9.92236 1.92278L21.965 3.40356C23.3902 3.57881 24.4035 4.87621 24.2282 6.30144L23.0912 15.5485L5.88746 13.4331L7.02449 4.18603Z",
        fill: `url(#${topGradientId})`
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.0966 19.1675C10.5337 19.0983 10.0622 18.9474 9.6819 18.7148C9.30165 18.4822 8.99081 18.1955 8.7494 17.8545C8.51304 17.5095 8.35594 17.1812 8.27808 16.8698C8.20023 16.5583 8.17671 16.3719 8.20754 16.3106C8.2406 16.2477 8.29629 16.1998 8.36334 16.1764L9.16255 15.9681C9.23046 15.944 9.29509 15.9473 9.35644 15.978C9.41816 16.0041 9.48072 16.1187 9.54409 16.3216C9.61203 16.525 9.71512 16.7444 9.85335 16.9798C9.9927 17.2069 10.1774 17.4028 10.3959 17.5552C10.6148 17.7029 10.8957 17.7978 11.2388 17.84C11.7926 17.9081 12.2516 17.802 12.616 17.5216C12.9849 17.2418 13.1997 16.8547 13.2605 16.3605C13.3263 15.825 13.203 15.3917 12.8907 15.0606C12.5789 14.725 12.137 14.5219 11.5649 14.4516L10.8442 14.363C10.7779 14.356 10.717 14.3235 10.6742 14.2725C10.6346 14.2165 10.6188 14.1565 10.6266 14.0924L10.7169 13.3579C10.7253 13.2892 10.7552 13.2348 10.8065 13.1947C10.8326 13.1734 10.8626 13.1577 10.895 13.1485C10.9273 13.1393 10.9611 13.1368 10.9945 13.1411L11.619 13.2179C12.1316 13.2809 12.5607 13.192 12.9062 12.951C13.2518 12.7101 13.4518 12.3677 13.5064 11.9238C13.5604 11.4846 13.4644 11.1128 13.2184 10.8084C12.9724 10.504 12.6046 10.3217 12.115 10.2615C11.8404 10.2277 11.5968 10.2442 11.3842 10.311C11.174 10.3764 10.9801 10.4855 10.8152 10.6313C10.6529 10.7695 10.5054 10.9242 10.3752 11.0929C10.2486 11.2539 10.1521 11.3396 10.0857 11.35C10.02 11.3558 9.95965 11.3368 9.90455 11.2929L9.22679 10.8541C9.17124 10.8148 9.13855 10.7596 9.12871 10.6887C9.11887 10.6178 9.19349 10.4644 9.35257 10.2285C9.51678 9.98855 9.7502 9.75243 10.0528 9.52013C10.3566 9.28567 10.7047 9.11513 11.0762 9.01877C11.4558 8.91673 11.8858 8.89529 12.3663 8.95447C13.2588 9.06421 13.9369 9.3868 14.4006 9.92226C14.8649 10.4532 15.0498 11.1032 14.9553 11.8721C14.89 12.403 14.7053 12.8471 14.4012 13.2046C14.1016 13.5625 13.7109 13.7932 13.229 13.8968L13.2256 13.9242C13.7637 14.1576 14.1659 14.5136 14.4322 14.9923C14.7037 15.4671 14.8023 16.0065 14.7279 16.6105C14.6216 17.4755 14.2323 18.1478 13.5601 18.6273C12.8881 19.1067 12.067 19.2868 11.0966 19.1675ZM18.0043 19.8566C17.9265 19.847 17.8615 19.8088 17.8092 19.742C17.7621 19.6779 17.742 19.5979 17.7531 19.5191L18.6917 11.8855L17.0104 12.8076C16.9503 12.8421 16.8845 12.848 16.813 12.8252C16.7485 12.805 16.6942 12.761 16.661 12.702L16.2925 12.0155C16.2591 11.9551 16.2504 11.8841 16.268 11.8174C16.2907 11.7459 16.3343 11.6933 16.3989 11.6594L19.3785 10.0396C19.4037 10.0242 19.4306 10.0136 19.4591 10.0078C19.4883 9.99747 19.5212 9.99455 19.5577 9.99905L20.1345 10.07C20.2122 10.0795 20.2706 10.1146 20.3097 10.1751C20.3539 10.2315 20.3712 10.2987 20.3616 10.3766L19.2153 19.6989C19.2051 19.7814 19.1667 19.8486 19.0999 19.9007C19.0704 19.9264 19.0358 19.9454 18.9984 19.9564C18.9609 19.9674 18.9215 19.9702 18.8829 19.9646L18.0043 19.8566Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: topBlurId,
        x: "4.2627",
        y: "0.27832",
        width: "21.6104",
        height: "16.8955",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: "0.8125",
        result: "effect1_foregroundBlur"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: highlightGradientId,
        x1: "14.4902",
        y1: "14.49",
        x2: "13.2342",
        y2: "24.7047",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#4FA0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#3186FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: topGradientId,
        x1: "14.7837",
        y1: "4.39654",
        x2: "13.5501",
        y2: "14.4285",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#A9A8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8",
        stopColor: "#3C90FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "29",
        height: "29",
        fill: "white"
    }))));
};
const $a8abba00fc800a43$var$GoogleCalendarIconBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { label: label, size: t1, testId: testId } = t0;
    const size = t1 === undefined ? 29 : t1;
    const isLabelled = typeof label === "string" && label.length > 0;
    let t2;
    if ($[0] !== isLabelled || $[1] !== label) {
        t2 = isLabelled ? {
            role: "img",
            "aria-label": label
        } : {
            role: "presentation",
            "aria-hidden": true
        };
        $[0] = isLabelled;
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    const a11yProps = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8abba00fc800a43$export$73d71809eb86c017, null);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== a11yProps || $[5] !== size || $[6] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: size,
            height: size,
            viewBox: "0 0 29 29",
            fill: "none",
            "data-testid": testId,
            ...a11yProps
        }, t3);
        $[4] = a11yProps;
        $[5] = size;
        $[6] = testId;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ label: label, size: size = 29, testId: testId })=>{
    const isLabelled = typeof label === 'string' && label.length > 0;
    const a11yProps = isLabelled ? {
        role: 'img',
        'aria-label': label
    } : {
        role: 'presentation',
        'aria-hidden': true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 29 29",
        fill: "none",
        "data-testid": testId,
        ...a11yProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8abba00fc800a43$export$73d71809eb86c017, null));
};
const $a8abba00fc800a43$export$5d128e0a6ffc0558 = /*#__PURE__*/ (0, $cozmU.memo)($a8abba00fc800a43$var$GoogleCalendarIconBase);
module.exports["GoogleCalendarIconContent"] = $a8abba00fc800a43$export$73d71809eb86c017;
module.exports["GoogleCalendarIcon"] = $a8abba00fc800a43$export$5d128e0a6ffc0558;

});

parcelRegister("8o9Ak", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $92342334252dc9a4$var$messages = (0, $kSwu1.defineMessages)({
    openLinkInNewTab: {
        id: "rovo-platform-ui-components.insight-link-card.open-link-in-new-tab",
        defaultMessage: "Open link in a new tab"
    },
    googleCalendarProvider: {
        id: "rovo-platform-ui-components.insight-link-card.google-calendar-provider",
        defaultMessage: "Calendar"
    }
});
var $92342334252dc9a4$export$2e2bcd8739ae039 = $92342334252dc9a4$var$messages;
module.exports["default"] = $92342334252dc9a4$export$2e2bcd8739ae039;

});

parcelRegister("bcDqz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $arQY7 = parcelRequire("arQY7");


var $fM984 = parcelRequire("fM984");


var $dpsRj = parcelRequire("dpsRj");


var $aRyr7 = parcelRequire("aRyr7");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $lpNn5 = parcelRequire("lpNn5");


var $flNGL = parcelRequire("flNGL");


var $j9iLd = parcelRequire("j9iLd");


var $91JJR = parcelRequire("91JJR");


var $f4ONb = parcelRequire("f4ONb");


var $6oFjM = parcelRequire("6oFjM");


var $eyQF5 = parcelRequire("eyQF5");


var $942TG = parcelRequire("942TG");


var $68jmg = parcelRequire("68jmg");


var $g2o3j = parcelRequire("g2o3j");

const $6574fd66b51c7dea$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $6574fd66b51c7dea$var$AvatarGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, avatar: t2, borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: t3, size: t4, testId: testId, label: t5, moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: t6, shouldPopupRenderToParent: t7 } = t0;
    const appearance = t1 === undefined ? "stack" : t1;
    const avatar = t2 === undefined ? (0, $arQY7.default) : t2;
    const showMoreButtonProps = t3 === undefined ? {} : t3;
    const size = t4 === undefined ? "medium" : t4;
    const label = t5 === undefined ? "avatar group" : t5;
    const tooltipPosition = t6 === undefined ? "bottom" : t6;
    const shouldPopupRenderToParent = t7 === undefined ? false : t7;
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>setIsOpen(false);
        $[0] = t8;
    } else t8 = $[0];
    const onClose = t8;
    let t9;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (event)=>{
            const { clientX: clientX, clientY: clientY, type: type } = event;
            if (type === "keydown" || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            setIsOpen($6574fd66b51c7dea$var$_temp);
        };
        $[1] = t9;
    } else t9 = $[1];
    const handleTriggerClicked = t9;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $91JJR.getOverrides)(overrides);
    let t10;
    let t11;
    if ($[2] !== isFocused || $[3] !== isOpen) {
        t10 = ()=>{
            if (!isOpen) setTriggeredUsingKeyboard(false);
            if ((0, $iDrrr.fg)("platform-dst-top-layer")) return 0, $dpsRj.default;
            if (!isFocused) return 0, $dpsRj.default;
            if (isOpen) return 0, $dpsRj.default;
            (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $fM984.KEY_DOWN)) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
            const unbind = ()=>{
                (0, $cbY7C.bind)(window, {
                    type: "keydown",
                    listener: function openOnKeyDown(e_0) {
                        if (e_0.key === (0, $fM984.KEY_DOWN)) {
                            e_0.preventDefault();
                            handleTriggerClicked(e_0);
                        }
                    }
                });
            };
            return unbind;
        };
        t11 = [
            isFocused,
            isOpen,
            handleTriggerClicked
        ];
        $[2] = isFocused;
        $[3] = isOpen;
        $[4] = t10;
        $[5] = t11;
    } else {
        t10 = $[4];
        t11 = $[5];
    }
    (0, $cozmU.useEffect)(t10, t11);
    const renderMoreDropdown = function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = (t12)=>{
            const { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, onClick: onClick, ...props } = t12;
            return moreIndicatorOverrides.render((0, $942TG.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                onClick: onClick,
                ...props
            });
        };
        if (typeof onMoreClick === "function") return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $iDrrr.fg)("platform-dst-top-layer")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9iLd.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        const boundary = boundariesElement === "scrollParent" ? "clippingParents" : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === "scrollParent") return;
            return boundariesElement === "window" ? "document" : "viewport";
        })();
        const avatarComponent = avatar ?? undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: (t13)=>{
                const { setInitialFocusRef: setInitialFocusRef } = t13;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6oFjM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eyQF5.default), {
                    onClick: $6574fd66b51c7dea$var$_temp2,
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                    titleId: labelId,
                    testId: `${testId}--section`
                }, data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $flNGL.default), {
                        avatar: avatarData,
                        avatarComponent: avatarComponent,
                        onAvatarClick: onAvatarClick,
                        avatarOverrides: avatarOverrides,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, index + max)))));
            },
            trigger: (triggerProps)=>(0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
                }, renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                })) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    };
    const max_0 = maxCount === undefined || maxCount === 0 ? $6574fd66b51c7dea$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $6JrSr.useId)();
    return appearance === "stack" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68jmg.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size
    }, data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
        const callback = avatarData_0.onClick || onAvatarClick;
        const finalAvatar = avatarOverrides.render(avatar, {
            ...avatarData_0,
            size: size,
            borderColor: borderColor || avatarData_0.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event_0, analyticsEvent)=>{
                callback(event_0, analyticsEvent, idx);
            } : undefined,
            stackIndex: max_0 - idx
        }, idx);
        if ((0, $iDrrr.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx)
        }, !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar);
        else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx),
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4ONb.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
        const callback_0 = avatarData_1.onClick || onAvatarClick;
        const finalAvatar_0 = avatarOverrides.render(avatar, {
            ...avatarData_1,
            size: size,
            borderColor: borderColor || avatarData_1.borderColor,
            testId: testId && `${testId}--avatar-${idx_0}`,
            onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                callback_0(event_1, analyticsEvent_0, idx_0);
            } : undefined,
            stackIndex: max_0 - idx_0
        }, idx_0);
        if ((0, $iDrrr.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0)
        }, !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0);
        else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0),
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId));
} : ({ appearance: appearance = 'stack', avatar: avatar = (0, $arQY7.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen_0)=>!isOpen_0);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $91JJR.getOverrides)(overrides);
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow.
    // Skipped when top-layer is enabled — DropdownMenu/top-layer handles
    // ArrowDown-to-open and arrow key navigation internally.
    (0, $cozmU.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Top-layer path: ArrowDown-to-open is handled by the menu's
        // own focus management, so skip the parent's ArrowDown handler.
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return 0, $dpsRj.default;
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $dpsRj.default;
        (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e_0) {
                    if (e_0.key === (0, $fM984.KEY_DOWN)) {
                        // prevent page scroll
                        e_0.preventDefault();
                        handleTriggerClicked(e_0);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>moreIndicatorOverrides.render((0, $942TG.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9iLd.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        const avatarComponent = avatar ?? undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6oFjM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eyQF5.default), {
                    onClick: (e_1)=>e_1.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                    titleId: labelId,
                    testId: `${testId}--section`
                }, data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $flNGL.default), {
                        avatar: avatarData,
                        avatarComponent: avatarComponent,
                        onAvatarClick: onAvatarClick,
                        avatarOverrides: avatarOverrides,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>(0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
                }, renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                })) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max_0 = maxCount === undefined || maxCount === 0 ? $6574fd66b51c7dea$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $6JrSr.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68jmg.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size
    }, data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
        const callback = avatarData_0.onClick || onAvatarClick;
        const finalAvatar = avatarOverrides.render(avatar, {
            ...avatarData_0,
            size: size,
            borderColor: borderColor || avatarData_0.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event_0, analyticsEvent)=>{
                callback(event_0, analyticsEvent, idx);
            } : undefined,
            stackIndex: max_0 - idx
        }, idx);
        if ((0, $iDrrr.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx)
        }, !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar);
        else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx),
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4ONb.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
        const callback_0 = avatarData_1.onClick || onAvatarClick;
        const finalAvatar_0 = avatarOverrides.render(avatar, {
            ...avatarData_1,
            size: size,
            borderColor: borderColor || avatarData_1.borderColor,
            testId: testId && `${testId}--avatar-${idx_0}`,
            onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                callback_0(event_1, analyticsEvent_0, idx_0);
            } : undefined,
            stackIndex: max_0 - idx_0
        }, idx_0);
        if ((0, $iDrrr.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0)
        }, !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0);
        else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0),
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId));
};
var $6574fd66b51c7dea$export$2e2bcd8739ae039 = $6574fd66b51c7dea$var$AvatarGroup;
function $6574fd66b51c7dea$var$_temp(isOpen_0) {
    return !isOpen_0;
}
function $6574fd66b51c7dea$var$_temp2(e_1) {
    return e_1.stopPropagation();
}
module.exports["default"] = $6574fd66b51c7dea$export$2e2bcd8739ae039;

});

parcelRegister("aRyr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $09649a4f36a12f35$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $09649a4f36a12f35$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $cozmU.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $cozmU.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("flNGL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");

var $kD4eB = parcelRequire("kD4eB");

var $8oBbn = parcelRequire("8oBbn");


var $81Xw1 = parcelRequire("81Xw1");

const $74934c00a5cc9b19$var$AvatarGroupItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $81Xw1.default)();
    let t0;
    if ($[0] !== role) {
        t0 = (t1)=>{
            const { children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, "data-testid": testId_0, ...props_0 } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                type: "button",
                className: className,
                disabled: disabled,
                draggable: draggable,
                onClick: onClick_0,
                onDragStart: onDragStart,
                onMouseDown: onMouseDown,
                ref: ref_0,
                tabIndex: tabIndex_0,
                "data-testid": testId_0,
                role: role,
                ...props_0
            }, children_0);
        };
        $[0] = role;
        $[1] = t0;
    } else t0 = $[1];
    const CustomComponent = t0;
    const AvatarComponent = avatarComponent ?? (0, $arQY7.default);
    const AvatarIcon = avatarOverrides ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    const callback = onClick || onAvatarClick;
    let t1;
    if ($[2] !== AvatarIcon || $[3] !== callback || $[4] !== href || $[5] !== index || $[6] !== itemRef || $[7] !== name || $[8] !== ref || $[9] !== role || $[10] !== target || $[11] !== testId) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            if (href) {
                let t2;
                if ($[13] !== callback || $[14] !== index) {
                    t2 = (event)=>callback && callback(event, undefined, index);
                    $[13] = callback;
                    $[14] = index;
                    $[15] = t2;
                } else t2 = $[15];
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
                    ref: (0, $lmzCg.default)([
                        ref,
                        itemRef
                    ]),
                    href: href,
                    target: target,
                    rel: target === "_blank" ? "noopener noreferrer" : undefined,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role,
                    onClick: t2
                }, name);
                break bb0;
            }
            if (typeof callback === "function") {
                let t2;
                if ($[16] !== callback || $[17] !== index) {
                    t2 = (event_0)=>callback && callback(event_0, undefined, index);
                    $[16] = callback;
                    $[17] = index;
                    $[18] = t2;
                } else t2 = $[18];
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    ref: (0, $lmzCg.default)([
                        ref,
                        itemRef
                    ]),
                    onClick: t2,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role
                }, name);
                break bb0;
            }
        }
        $[2] = AvatarIcon;
        $[3] = callback;
        $[4] = href;
        $[5] = index;
        $[6] = itemRef;
        $[7] = name;
        $[8] = ref;
        $[9] = role;
        $[10] = target;
        $[11] = testId;
        $[12] = t1;
    } else t1 = $[12];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    let t2;
    if ($[19] !== AvatarIcon || $[20] !== CustomComponent || $[21] !== name || $[22] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kD4eB.default), {
            iconBefore: AvatarIcon,
            component: CustomComponent,
            testId: testId
        }, name);
        $[19] = AvatarIcon;
        $[20] = CustomComponent;
        $[21] = name;
        $[22] = testId;
        $[23] = t2;
    } else t2 = $[23];
    return t2;
} : (props, ref)=>{
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $81Xw1.default)();
    const CustomComponent = ({ children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, 'data-testid': testId_0, ...props_0 })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick_0,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref_0,
            tabIndex: tabIndex_0,
            "data-testid": testId_0,
            role: role,
            ...props_0
        }, children_0);
    };
    const AvatarComponent = avatarComponent ?? (0, $arQY7.default);
    const AvatarIcon = avatarOverrides ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: 'transparent',
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: '',
        presence: presence,
        size: 'small',
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        onClick: (event_0)=>callback && callback(event_0, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        role: role
    }, name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kD4eB.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$74934c00a5cc9b19$export$2e2bcd8739ae039 = $74934c00a5cc9b19$var$AvatarGroupItem;
module.exports["default"] = $74934c00a5cc9b19$export$2e2bcd8739ae039;

});

parcelRegister("81Xw1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kVHjt = parcelRequire("kVHjt");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
const $f5ac5fe41e50defd$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager() {
    const $ = (0, $bDgLe.c)(3);
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== registerRef) {
        t0 = ()=>{
            if (itemRef.current !== null) registerRef(itemRef.current);
        };
        t1 = [
            registerRef
        ];
        $[0] = registerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return itemRef;
} : function useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
};
var $f5ac5fe41e50defd$export$2e2bcd8739ae039 = $f5ac5fe41e50defd$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f5ac5fe41e50defd$export$2e2bcd8739ae039;

});

parcelRegister("kVHjt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $b95dd4fa661016c8$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $b95dd4fa661016c8$export$f18c1d4fc7326096;

});

parcelRegister("j9iLd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $fM984 = parcelRequire("fM984");


var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");


var $lBMxH = parcelRequire("lBMxH");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");


var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $flNGL = parcelRequire("flNGL");

const $d2c81e37a1471dd1$var$topLayerPlacement = (0, $aRDbl.fromLegacyPlacement)({
    legacy: 'bottom-end'
});
function $d2c81e37a1471dd1$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    key: index,
                    ...props
                }),
            ...overrides?.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    key: index,
                    ...props
                }),
            ...overrides?.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props),
            ...overrides?.MoreIndicator
        }
    };
}
function $d2c81e37a1471dd1$export$36ea40361987a72d({ isOpen: isOpen, onClose: onClose, isTriggeredUsingKeyboard: _isTriggeredUsingKeyboard, data: data, max: max, overrides: overrides, onAvatarClick: onAvatarClick, testId: testId, labelId: labelId, renderMoreButton: renderMoreButton, handleTriggerClicked: handleTriggerClicked, bindFocus: _bindFocus }) {
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: _reason })=>{
        onClose();
    }, [
        onClose
    ]);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const menuRef = (0, $cozmU.useRef)(null);
    const overflowMenuTestId = testId ? `${testId}--overflow-menu` : undefined;
    const popoverId = (0, $1unCm.usePopoverId)();
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $d2c81e37a1471dd1$var$topLayerPlacement,
        isOpen: isOpen
    });
    // Arrow key navigation inside the open menu
    (0, $iNWdN.useArrowNavigation)({
        containerRef: menuRef,
        onClose: onClose,
        isEnabled: isOpen
    });
    // ArrowDown-to-open: when the trigger is focused and the menu is closed,
    // pressing ArrowDown opens the menu (WAI-ARIA menu button pattern).
    //
    // Bind the keydown listener directly to the trigger element via its ref so
    // that opening the menu does not trigger a focus-driven re-render of the
    // host component, which would unmount and remount the menu items and drop
    // menuitem focus.
    (0, $cozmU.useEffect)(()=>{
        const trigger = triggerRef.current;
        if (!trigger || isOpen) return;
        return (0, $cbY7C.bind)(trigger, {
            type: 'keydown',
            listener: function openOnArrowDown(event) {
                if (event.key === (0, $fM984.KEY_DOWN)) {
                    // Prevent page scroll when opening the menu via ArrowDown.
                    event.preventDefault();
                    handleTriggerClicked(event);
                }
            }
        });
    }, [
        isOpen,
        handleTriggerClicked
    ]);
    const triggerAria = (0, $lBMxH.getAriaForTrigger)({
        role: 'menu',
        isOpen: isOpen,
        popoverId: popoverId
    });
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderMoreButton({
        ref: setTriggerRef,
        ...triggerAria,
        onClick: handleTriggerClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: "avatar group",
        isOpen: isOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: $d2c81e37a1471dd1$var$topLayerPlacement,
        testId: overflowMenuTestId ? `${overflowMenuTestId}--content` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $juXYb.PopoverSurface), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: menuRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        minWidth: 250,
        maxHeight: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        titleId: labelId,
        testId: testId ? `${testId}--section` : undefined
    }, data.slice(max).map((avatar, index)=>$d2c81e37a1471dd1$var$getOverrides(overrides).AvatarGroupItem.render((0, $flNGL.default), {
            avatar: avatar,
            onAvatarClick: onAvatarClick,
            testId: testId ? `${testId}--avatar-group-item-${index + max}` : undefined,
            index: index + max,
            role: 'menuitem'
        }, index + max))))))));
}
module.exports["MoreDropdownTopLayer"] = $d2c81e37a1471dd1$export$36ea40361987a72d;

});

parcelRegister("iNWdN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $fM984 = parcelRequire("fM984");


var $3hJ5V = parcelRequire("3hJ5V");


var $7MWxP = parcelRequire("7MWxP");


var $jzRXW = parcelRequire("jzRXW");

const $341d868aa0ec42f2$var$menuScope = '[role="menu"]';
const $341d868aa0ec42f2$export$23dfbae28e0cc453 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useArrowNavigation(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: t1, filter: filter } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== containerRef || $[1] !== filter || $[2] !== onClose || $[3] !== onNestedClose || $[4] !== onNestedOpen) {
        t2 = (event)=>{
            const container = containerRef.current;
            if (!container) return;
            const focused = (0, $1hQ0e.getDocument)()?.activeElement;
            if (focused instanceof HTMLElement) {
                if (filter) {
                    if (!filter(focused, container)) return;
                }
                if (!filter && container.getAttribute("role") === "menu" && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
            }
            if (event.key === (0, $fM984.KEY_DOWN)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "forwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_UP)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "backwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_HOME)) {
                event.preventDefault();
                (0, $3hJ5V.getFirstFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_END)) {
                event.preventDefault();
                (0, $7MWxP.getLastFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_TAB)) {
                onClose();
                return;
            }
            if (event.key === "ArrowRight") {
                if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute("aria-haspopup")) {
                    event.preventDefault();
                    onNestedOpen({
                        trigger: focused
                    });
                }
                return;
            }
            if (event.key === "ArrowLeft") {
                if (onNestedClose) {
                    const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                    if (isNested) {
                        event.preventDefault();
                        onNestedClose();
                    }
                }
                return;
            }
        };
        $[0] = containerRef;
        $[1] = filter;
        $[2] = onClose;
        $[3] = onNestedClose;
        $[4] = onNestedOpen;
        $[5] = t2;
    } else t2 = $[5];
    const handleKeyDown = t2;
    let t3;
    let t4;
    if ($[6] !== containerRef || $[7] !== handleKeyDown || $[8] !== isEnabled) {
        t3 = ()=>{
            const container_0 = containerRef.current;
            if (!container_0 || !isEnabled) return;
            return (0, $cbY7C.bind)(container_0, {
                type: "keydown",
                listener: handleKeyDown
            });
        };
        t4 = [
            containerRef,
            handleKeyDown,
            isEnabled
        ];
        $[6] = containerRef;
        $[7] = handleKeyDown;
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : function useArrowNavigation({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $1hQ0e.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
        }
        if (event.key === (0, $fM984.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $3hJ5V.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $7MWxP.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $cozmU.useEffect)(()=>{
        const container_0 = containerRef.current;
        if (!container_0 || !isEnabled) return;
        return (0, $cbY7C.bind)(container_0, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
};
module.exports["useArrowNavigation"] = $341d868aa0ec42f2$export$23dfbae28e0cc453;

});

parcelRegister("91JJR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g2o3j = parcelRequire("g2o3j");

function $5c29a548ea0a79f9$export$f525cc57d37ca574(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...props,
                    key: (0, $g2o3j.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...props,
                    key: (0, $g2o3j.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props),
            ...overrides && overrides.MoreIndicator
        }
    };
}
module.exports["getOverrides"] = $5c29a548ea0a79f9$export$f525cc57d37ca574;

});

parcelRegister("g2o3j", function(module, exports) {
const $c51da9a7df49a1b0$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $c51da9a7df49a1b0$export$b067756944994c79;

});

parcelRegister("f4ONb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");

const $1c9c95ebce1b3e9c$var$gutter = "var(--ds-space-negative-050, -4px)";
const $1c9c95ebce1b3e9c$var$listStyles = null;
const $1c9c95ebce1b3e9c$var$listStylesFlagged = null;
const $1c9c95ebce1b3e9c$var$listItemStyles = null;
const $1c9c95ebce1b3e9c$var$Grid = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { id: id, children: children, testId: testId, "aria-label": label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _3TGfC9HnLE _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            (0, $iDrrr.fg)("platform-avatar-group-spacing-fix") && "_0rIjyk1Y8M _03SyCPFQfX _0LQT5EFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = (0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            exitThenEnter: true
        }, (0, $cozmU.Children).map(children, $1c9c95ebce1b3e9c$var$_temp)) : (0, $cozmU.Children).map(children, $1c9c95ebce1b3e9c$var$_temp2);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== id || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1
        }, t2);
        $[3] = id;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ $cozmU.createElement("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _3TGfC9HnLE _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            (0, $iDrrr.fg)('platform-avatar-group-spacing-fix') && "_0rIjyk1Y8M _03SyCPFQfX _0LQT5EFQfX"
        ])
    }, (0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
        exitThenEnter: true
    }, (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
            ])
        }, child))) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
            ])
        }, child_0))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1c9c95ebce1b3e9c$export$2e2bcd8739ae039 = $1c9c95ebce1b3e9c$var$Grid;
function $1c9c95ebce1b3e9c$var$_temp(child) {
    return child && /*#__PURE__*/ $cozmU.createElement("li", {
        className: (0, $hekY6.default)([
            "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
        ])
    }, child);
}
function $1c9c95ebce1b3e9c$var$_temp2(child_0) {
    return child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
        className: (0, $hekY6.default)([
            "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
        ])
    }, child_0);
}
module.exports["default"] = $1c9c95ebce1b3e9c$export$2e2bcd8739ae039;

});

parcelRegister("6oFjM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $7Dop9 = parcelRequire("7Dop9");


var $kVHjt = parcelRequire("kVHjt");

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $c01bf7a5c9b76ffa$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $cozmU.useEffect)(()=>{
        (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $7Dop9.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: (0, $7Dop9.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kVHjt.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $c01bf7a5c9b76ffa$export$2e2bcd8739ae039 = $c01bf7a5c9b76ffa$var$FocusManager;
module.exports["default"] = $c01bf7a5c9b76ffa$export$2e2bcd8739ae039;

});

parcelRegister("7Dop9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b50f6255090ed60$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");

const $7b50f6255090ed60$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $7b50f6255090ed60$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $7b50f6255090ed60$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $7b50f6255090ed60$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $7b50f6255090ed60$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $7b50f6255090ed60$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $7b50f6255090ed60$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $7b50f6255090ed60$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $7b50f6255090ed60$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eyQF5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $kVHjt = parcelRequire("kVHjt");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $949efbfeb67fe748$var$PopupAvatarGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    let children;
    let isLoading;
    let maxHeight;
    let minHeight;
    let onClick;
    let rest;
    let role;
    let setInitialFocusRef;
    let spacing;
    let t1;
    let t2;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: t1, minHeight: minHeight, minWidth: t2, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = maxHeight;
        $[4] = minHeight;
        $[5] = onClick;
        $[6] = rest;
        $[7] = role;
        $[8] = setInitialFocusRef;
        $[9] = spacing;
        $[10] = t1;
        $[11] = t2;
        $[12] = testId;
    } else {
        children = $[1];
        isLoading = $[2];
        maxHeight = $[3];
        minHeight = $[4];
        onClick = $[5];
        rest = $[6];
        role = $[7];
        setInitialFocusRef = $[8];
        spacing = $[9];
        t1 = $[10];
        t2 = $[11];
        testId = $[12];
    }
    const maxWidth = t1 === undefined ? 800 : t1;
    const minWidth = t2 === undefined ? 320 : t2;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    let t3;
    let t4;
    if ($[13] !== menuItemRefs || $[14] !== setInitialFocusRef) {
        t3 = ()=>{
            setInitialFocusRef?.(menuItemRefs[0]);
        };
        t4 = [
            menuItemRefs,
            setInitialFocusRef
        ];
        $[13] = menuItemRefs;
        $[14] = setInitialFocusRef;
        $[15] = t3;
        $[16] = t4;
    } else {
        t3 = $[15];
        t4 = $[16];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[17] !== children || $[18] !== isLoading || $[19] !== maxHeight || $[20] !== maxWidth || $[21] !== minHeight || $[22] !== minWidth || $[23] !== onClick || $[24] !== rest || $[25] !== role || $[26] !== spacing || $[27] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minHeight: minHeight,
            minWidth: minWidth,
            onClick: onClick,
            role: role,
            spacing: spacing,
            testId: testId,
            ...rest
        }, children);
        $[17] = children;
        $[18] = isLoading;
        $[19] = maxHeight;
        $[20] = maxWidth;
        $[21] = minHeight;
        $[22] = minWidth;
        $[23] = onClick;
        $[24] = rest;
        $[25] = role;
        $[26] = spacing;
        $[27] = testId;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    (0, $cozmU.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest
    }, children);
};
var $949efbfeb67fe748$export$2e2bcd8739ae039 = $949efbfeb67fe748$var$PopupAvatarGroup;
module.exports["default"] = $949efbfeb67fe748$export$2e2bcd8739ae039;

});

parcelRegister("942TG", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $de57968bf9fddf7d$var$boxShadowCssVar = '--avatar-box-shadow';
const $de57968bf9fddf7d$var$styles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _24h04iPvdi _43nrzTFQfX _2xTnZxFQfX _0rIjykFQfX _0GTcwRFQfX _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4Q7zJH _0KLXruDMqu _1UtDYzy7kJ _2OUyjtrcoi _1VJPcaeKTE _3kPd40YbGa _1ubuxonXvL _1NDpvb6wH8 _34b3D24Jdh _2wtOC94Jdh _1eOmH6KcZT _0clgaMy7kJ _3gzVzLnpTK _0CMRbky7kJ _1if2KaHZdu",
    circle: "_0bjKvDaaQb",
    active: "_0KLXruY9q9 _2OUyjt0hf4 _1UtDYzjTy9 _1eOmH6sumd _0clgaMjTy9 _3gzVzLXsxn _0CMRbkjTy9",
    disabled: "_0wOv4Qsyl5 _43i6GSVx3j _3wEj0XlfZc"
};
const $de57968bf9fddf7d$var$widthHeightMap = {
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
const $de57968bf9fddf7d$var$borderRadiusMap = {
    xsmall: "_0bjKvDcjp5 _2Gfj6icjp5",
    small: "_0bjKvDcjp5 _2Gfj6icjp5",
    medium: "_0bjKvDzXzM _2Gfj6izXzM",
    large: "_0bjKvDzXzM _2Gfj6izXzM",
    xlarge: "_0bjKvDKTcp _2Gfj6iKTcp",
    xxlarge: "_0bjKvDyzSk _2Gfj6iyzSk"
};
const $de57968bf9fddf7d$var$fontMap = {
    small: "_2sNsIg7NXe",
    medium: "_2sNsIg7NXe",
    large: "_2sNsIg7NXe",
    xlarge: "_2sNsIg20Hp",
    xxlarge: "_2sNsIg20Hp"
};
const $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT = 99;
const $de57968bf9fddf7d$var$MoreIndicator = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT ? $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ $cozmU.createElement("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$de57968bf9fddf7d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $hekY6.default)([
            $de57968bf9fddf7d$var$styles.root,
            $de57968bf9fddf7d$var$borderRadiusMap[size],
            appearance === 'circle' && $de57968bf9fddf7d$var$styles.circle,
            $de57968bf9fddf7d$var$widthHeightMap[size],
            $de57968bf9fddf7d$var$fontMap[size],
            isActive && $de57968bf9fddf7d$var$styles.active
        ])
    }, "+", displayCount);
});
$de57968bf9fddf7d$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $de57968bf9fddf7d$export$2e2bcd8739ae039 = $de57968bf9fddf7d$var$MoreIndicator;
module.exports["default"] = $de57968bf9fddf7d$export$2e2bcd8739ae039;

});

parcelRegister("68jmg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");

const $ca3d6afcd04eeed9$var$listStyles = null;
const $ca3d6afcd04eeed9$var$listSmallStyles = null;
const $ca3d6afcd04eeed9$var$listItemStyles = null;
const $ca3d6afcd04eeed9$var$listItemSmallStyles = null;
const $ca3d6afcd04eeed9$var$Stack = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { id: id, children: children, testId: testId, "aria-label": label, size: size } = t0;
    let t1;
    if ($[0] !== size) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx2ADO _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            size === "small" && (0, $iDrrr.fg)("platform-avatar-group-spacing-fix") && "_2xTnZx1Y8M"
        ]);
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== size) {
        t2 = (0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            exitThenEnter: true
        }, (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
                className: (0, $hekY6.default)([
                    "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                    size === "small" && (0, $iDrrr.fg)("platform-avatar-group-spacing-fix") && "_2xTnZx5UaJ"
                ])
            }, child))) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
                className: (0, $hekY6.default)([
                    "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                    size === "small" && (0, $iDrrr.fg)("platform-avatar-group-spacing-fix") && "_2xTnZx5UaJ"
                ])
            }, child_0));
        $[2] = children;
        $[3] = size;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== id || $[6] !== label || $[7] !== t1 || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1
        }, t2);
        $[5] = id;
        $[6] = label;
        $[7] = t1;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ $cozmU.createElement("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx2ADO _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            size === 'small' && (0, $iDrrr.fg)('platform-avatar-group-spacing-fix') && "_2xTnZx1Y8M"
        ])
    }, (0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
        exitThenEnter: true
    }, (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                size === 'small' && (0, $iDrrr.fg)('platform-avatar-group-spacing-fix') && "_2xTnZx5UaJ"
            ])
        }, child))) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                size === 'small' && (0, $iDrrr.fg)('platform-avatar-group-spacing-fix') && "_2xTnZx5UaJ"
            ])
        }, child_0))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $ca3d6afcd04eeed9$export$2e2bcd8739ae039 = $ca3d6afcd04eeed9$var$Stack;
module.exports["default"] = $ca3d6afcd04eeed9$export$2e2bcd8739ae039;

});

parcelRegister("jjhH6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $fa48c027efe0a08c$var$ProfileTriggerContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $fa48c027efe0a08c$export$87e35e0803bee131 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { renderProfileTrigger: renderProfileTrigger, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== renderProfileTrigger) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa48c027efe0a08c$var$ProfileTriggerContext.Provider, {
            value: renderProfileTrigger
        }, children);
        $[0] = children;
        $[1] = renderProfileTrigger;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ renderProfileTrigger: renderProfileTrigger, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa48c027efe0a08c$var$ProfileTriggerContext.Provider, {
        value: renderProfileTrigger
    }, children);
const $fa48c027efe0a08c$export$2c67cae7c41804d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($fa48c027efe0a08c$var$ProfileTriggerContext);
} : ()=>(0, $cozmU.useContext)($fa48c027efe0a08c$var$ProfileTriggerContext);
module.exports["ProfileTriggerProvider"] = $fa48c027efe0a08c$export$87e35e0803bee131;
module.exports["useProfileTrigger"] = $fa48c027efe0a08c$export$2c67cae7c41804d0;

});

parcelRegister("9HdWb", function(module, exports) {
parcelRequire("cozmU");


var $5lkNm = parcelRequire("5lkNm");


var $6YXrY = parcelRequire("6YXrY");


var $8UJqr = parcelRequire("8UJqr");

const $f18afab737b32ba9$export$68f3db7f6af48bcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8UJqr.ConfluenceIcon), (0, $5lkNm.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $f18afab737b32ba9$export$68f3db7f6af48bcb;

});

parcelRegister("7wqCp", function(module, exports) {
parcelRequire("cozmU");


var $ldJ1U = parcelRequire("ldJ1U");


var $6YXrY = parcelRequire("6YXrY");


var $aK5FI = parcelRequire("aK5FI");

const $08585521afd685aa$export$c4b5b1f965d8b3eb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $aK5FI.JiraIcon), (0, $ldJ1U.JiraIcon));
module.exports["JiraIcon"] = $08585521afd685aa$export$c4b5b1f965d8b3eb;

});

parcelRegister("edkvd", function(module, exports) {
parcelRequire("cozmU");


var $lb2PL = parcelRequire("lb2PL");


var $6YXrY = parcelRequire("6YXrY");


var $lfEjj = parcelRequire("lfEjj");

const $c60640d378da37aa$export$8d789f76fde3e05 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $lfEjj.LoomIcon), (0, $lb2PL.LoomIcon));
module.exports["LoomIcon"] = $c60640d378da37aa$export$8d789f76fde3e05;

});

parcelRegister("90c8o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::395f8acc4b624f0ed53caa935da2d86c>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $bf284ad647b8c636$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#1d2022" d="M23.464 9h1.062c.25.044.607.037.872.061q.87.083 1.724.263c3.622.77 6.83 2.853 9.008 5.846a14.9 14.9 0 0 1 2.817 7.54c.01.12.034.652.053.74v1.118c-.026.12-.044.629-.058.795a15 15 0 0 1-3.77 8.653 15 15 0 0 1-5.437 3.86c-.31.13-.645.265-.969.354-.25.069-.596.023-.79-.156-.28-.26-.229-.653-.226-.998l.006-.812c.008-.999.02-2.018.008-3.016-.013-.996-.278-1.925-1.01-2.632.31-.026.708-.09 1.016-.145 1.372-.245 2.74-.71 3.793-1.657 1.44-1.297 1.914-3.084 2.02-4.954.101-1.817-.286-3.305-1.523-4.677.512-1.32.328-2.686-.148-3.978-1.246-.24-3.129.874-4.12 1.539-2.52-.66-4.979-.692-7.502.003-1.01-.668-2.857-1.762-4.121-1.542-.53 1.184-.614 2.759-.152 3.98a5.78 5.78 0 0 0-1.511 3.43c-.172 1.874.247 4.173 1.473 5.649 1.283 1.544 3.398 2.173 5.325 2.35-.605.582-.831 1.195-.958 2.013-.467.197-.849.323-1.363.375-1.127.114-2.08-.325-2.754-1.232-.139-.187-.257-.39-.39-.582a4 4 0 0 0-.707-.766c-.5-.41-1.041-.626-1.691-.558-.449.047-.618.241-.264.608.248.256.57.358.818.608.45.443.799 1.01 1.087 1.568.1.19.168.39.256.58.19.416.488.772.862 1.035 1.138.8 2.77.689 4.072.46-.011.245 0 .569.002.819l.007 1.311c.002.203.038.642-.007.82-.238.937-1.213.505-1.745.296a15 15 0 0 1-3.514-1.957 14.97 14.97 0 0 1-5.95-10.574c-.022-.248-.029-.645-.063-.87L9 24.553v-1.078c.022-.112.036-.544.047-.69q.049-.614.148-1.22a14.9 14.9 0 0 1 2.691-6.418A15 15 0 0 1 22.57 9.065c.273-.026.635-.02.894-.065"/></svg>';
function $bf284ad647b8c636$export$e8e65f186ccd8749({ size: size, label: label = 'Github', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $bf284ad647b8c636$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GithubIcon"] = $bf284ad647b8c636$export$e8e65f186ccd8749;

});

parcelRegister("84256", function(module, exports) {
/* wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

const $b2cdc17c5a772991$var$glyphStyles = null;
const $b2cdc17c5a772991$var$hexagonSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $b2cdc17c5a772991$var$hexagonRootStyles = null;
const $b2cdc17c5a772991$var$hexagonStyles = null;
const $b2cdc17c5a772991$var$hexagonBorderStyles = null;
const $b2cdc17c5a772991$var$hexagonContentStyles = null;
const $b2cdc17c5a772991$var$svgIdAttributePattern = /\sid=(["'])([^"']+)\1/g;
const $b2cdc17c5a772991$var$getSvgIdNamespace = (instanceId)=>`third-party-logo-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '-')}`; /**
                                                                                                                             * Third-party SVGs can contain gradients, masks, and clipPaths with document-wide IDs.
                                                                                                                             * Namespacing each render keeps repeated logos from resolving `url(#id)` references to the
                                                                                                                             * first matching SVG definition elsewhere on the page.
                                                                                                                             */ 
const $b2cdc17c5a772991$var$namespaceSvgIds = (markup, namespace)=>{
    const ids = Array.from(markup.matchAll($b2cdc17c5a772991$var$svgIdAttributePattern), ([, , id])=>id);
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.reduce((updatedMarkup, id)=>{
        const namespacedId = `${namespace}-${id}`;
        const escapedId = $b2cdc17c5a772991$var$escapeRegExp(id);
        return updatedMarkup.replace(new RegExp(`\\sid=(["'])${escapedId}\\1`, 'g'), ` id=$1${namespacedId}$1`).replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${namespacedId})`).replace(new RegExp(`(\\s(?:href|xlink:href)=["'])#${escapedId}(["'])`, 'g'), `$1#${namespacedId}$2`);
    }, markup);
};
const $b2cdc17c5a772991$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $b2cdc17c5a772991$export$96b07167eb29fb14({ markup: markup, size: size = 'medium', label: label = '', testId: testId, type: type = 'app' }) {
    const instanceId = (0, $cozmU.useId)();
    const namespacedMarkup = (0, $cozmU.useMemo)(()=>$b2cdc17c5a772991$var$namespaceSvgIds(markup, $b2cdc17c5a772991$var$getSvgIdNamespace(instanceId)), [
        markup,
        instanceId
    ]);
    const glyph = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
            __html: namespacedMarkup
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d"
        ])
    });
    if (type === 'agent') return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1RrJLit2nV",
            $b2cdc17c5a772991$var$hexagonSizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _24h04i2Njc _39xV02N91d _0jFU0VN91d _1uo2ZfTcEg",
                "_4c065UNvrM _2Y7lL4NvrM _0KLXruIDZ8"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _0KLXrulfZc _1uo2ZfOLYo"
                ]),
                children: glyph
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Tile's backgroundColor API accepts the semantic `white` value.
    ), {
        backgroundColor: "white",
        label: label,
        size: size,
        testId: testId,
        hasBorder: true,
        isInset: false,
        children: glyph
    });
}
module.exports["ThirdPartyLogoWrapper"] = $b2cdc17c5a772991$export$96b07167eb29fb14;

});

parcelRegister("aMsxt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf4bc7217f58b5ef916be3252e86e461>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $828d22d75c7e0400$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5589" width="32" height="28" x="8" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#b43333" d="M18.03 12.455c2.659-4.606 9.307-4.607 11.967 0l8.187 14.181C40.844 31.242 37.52 37 32.201 37H15.825c-5.318 0-8.642-5.758-5.983-10.364z"/></mask><g mask="url(#mask0_118280_5589)"><path fill="url(#paint0_linear_118280_5589)" d="M44.178 37.004H27.47l-3.457-5.988 8.353-14.47z"/><path fill="url(#paint1_linear_118280_5589)" d="m3.846 37.004 11.811-20.457-3.456 5.987h6.913l8.354 14.47z"/><path fill="url(#paint2_linear_118280_5589)" d="m24.015 2.074 8.354 14.47-3.457 5.987H12.204z"/></g><defs><linearGradient id="paint0_linear_118280_5589" x1="41.759" x2="25.302" y1="35.836" y2="25.947" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#ffe921"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint1_linear_118280_5589" x1="27.359" x2="9.383" y1="38.75" y2="27.875" gradientUnits="userSpaceOnUse"><stop offset=".15" stop-color="#a9a8ff"/><stop offset=".33" stop-color="#6d97ff"/><stop offset=".48" stop-color="#3186ff"/></linearGradient><linearGradient id="paint2_linear_118280_5589" x1="29.992" x2="11.777" y1="12.613" y2="21.115" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#0ebc5f"/><stop offset=".85" stop-color="#78c9ff"/></linearGradient></defs></svg>';
function $828d22d75c7e0400$export$e16bd899bb4eebf9({ size: size, label: label = 'Google Drive', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $828d22d75c7e0400$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GoogleDriveIcon"] = $828d22d75c7e0400$export$e16bd899bb4eebf9;

});

parcelRegister("lp1F5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1069d04804a2ae0ab9d0c6315e1cb5f4>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $bfe1716349f0e396$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint1_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint2_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint3_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint4_linear_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint5_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint6_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint7_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint8_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint9_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="url(#paint10_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="#fff" d="m14.689 31.445 1.31-.683q.221.447.579.659.36.211.79.212.476 0 .726-.193.25-.198.25-.591a.67.67 0 0 0-.24-.52q-.24-.216-.853-.327-1.166-.212-1.695-.74-.525-.53-.525-1.318 0-.981.694-1.569.694-.585 1.83-.586.765 0 1.349.313.583.312.925.894l-1.281.66a1.4 1.4 0 0 0-.457-.472q-.247-.15-.617-.15-.443 0-.675.193a.63.63 0 0 0-.226.5q0 .265.217.467.222.197.886.322 1.117.212 1.666.77.555.553.554 1.4 0 1.03-.66 1.63t-1.883.6q-.886 0-1.599-.384a2.54 2.54 0 0 1-1.064-1.087z"/><defs><radialGradient id="paint1_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.32263 -12.8627 -23.1621 9.55567 25.665 29.882)" gradientUnits="userSpaceOnUse"><stop offset=".29" stop-color="#003b5d" stop-opacity=".2"/><stop offset=".61" stop-color="#004a6c" stop-opacity=".138"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.41835 -10.8865 -19.5798 7.9222 24.391 24.611)" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#002a42" stop-opacity=".31"/><stop offset=".61" stop-color="#004261" stop-opacity=".214"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.56759 8.10392 8.11617 5.55934 27.893 10.686)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint5_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(3.0738 -8.81188 -15.9013 -5.52951 26.098 31.084)" gradientUnits="userSpaceOnUse"><stop stop-color="#003b5d" stop-opacity=".502"/><stop offset=".49" stop-color="#004c6c" stop-opacity=".362"/><stop offset=".97" stop-color="#007a86" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.6396 6.75319 6.76325 4.63263 34.97 19.304)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(12.1028 12.086 12.105 -12.0839 13.08 23.761)" gradientUnits="userSpaceOnUse"><stop offset=".06" stop-color="#00b6bd"/><stop offset=".89" stop-color="#00495c"/></radialGradient><radialGradient id="paint10_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.45945 -9.64483 0 17.124 30.643)" gradientUnits="userSpaceOnUse"><stop offset=".57" stop-color="#1e8581" stop-opacity="0"/><stop offset=".97" stop-color="#1ecbe6" stop-opacity=".6"/></radialGradient><linearGradient id="paint0_linear_118280_5862" x1="16.812" x2="28.885" y1="10.479" y2="26.325" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".41" stop-color="#0097a8"/><stop offset="1" stop-color="#007791"/></linearGradient><linearGradient id="paint4_linear_118280_5862" x1="26.04" x2="36.102" y1="19.279" y2="32.485" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".48" stop-color="#00a2b8"/><stop offset=".95" stop-color="#00637c"/></linearGradient><linearGradient id="paint7_linear_118280_5862" x1="20.506" x2="26.919" y1="26.346" y2="39.17" gradientUnits="userSpaceOnUse"><stop offset=".05" stop-color="#75fff6"/><stop offset=".51" stop-color="#00c7d1"/><stop offset=".96" stop-color="#0096ad"/></linearGradient><linearGradient id="paint8_linear_118280_5862" x1="28.894" x2="25.466" y1="40.029" y2="35.22" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#0e5a5d" stop-opacity=".322"/><stop offset=".54" stop-color="#126c6b" stop-opacity=".222"/><stop offset=".97" stop-color="#1c948a" stop-opacity="0"/></linearGradient></defs></svg>';
function $bfe1716349f0e396$export$18737550276ca4ad({ size: size, label: label = 'Microsoft SharePoint', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $bfe1716349f0e396$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftSharePointIcon"] = $bfe1716349f0e396$export$18737550276ca4ad;

});

parcelRegister("4pKRH", function(module, exports) {

var $lJ6db = parcelRequire("lJ6db");

const $f2bc8c41368b5e1f$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $f2bc8c41368b5e1f$var$PRODUCT_HEADER = 'x-product';
const $f2bc8c41368b5e1f$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $f2bc8c41368b5e1f$export$2687a6d505a87cc5 extends (0, $lJ6db.AssistanceServiceBase) {
    /**
   * Check whether Rovo Insights is available for the current user.
   */ async getInsightsStatus() {
        return this.fetchJson({
            path: '/rovo/v1/insights/status',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$f2bc8c41368b5e1f$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$f2bc8c41368b5e1f$var$PRODUCT_HEADER]: 'rovo',
                    [$f2bc8c41368b5e1f$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify({})
            },
            holdName: 'rovo-v1-insights-status'
        });
    }
    /**
   * Fetch the Rovo Insights feed for the current user.
   * @param options.debugInfo — When true, include debug_info in the response.
   */ async getInsightsFeed(options) {
        const overrides = {};
        if (options?.debugInfo) overrides.debug_info = true;
        if (typeof localStorage !== 'undefined') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const promptVariation = localStorage.getItem('DEBUG_rovo_insights_prompt_variation');
            if (promptVariation) overrides.prompt_variation = promptVariation;
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const generate = localStorage.getItem('DEBUG_rovo_insights_generate');
            if (generate) overrides.generate = generate === 'true';
        }
        return this.fetchJson({
            path: '/rovo/v1/insights/fetch',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$f2bc8c41368b5e1f$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$f2bc8c41368b5e1f$var$PRODUCT_HEADER]: 'rovo',
                    [$f2bc8c41368b5e1f$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify(overrides)
            },
            holdName: 'rovo-v1-insights-fetch'
        });
    }
    constructor(config){
        super(config);
    }
}
module.exports["RovoInsightsService"] = $f2bc8c41368b5e1f$export$2687a6d505a87cc5;

});

parcelRegister("eKZMd", function(module, exports) {

let $abe54823db96e512$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $abe54823db96e512$var$load("eOkWq").then(()=>parcelRequire('gznGh'));

});

parcelRegister("8tRtw", function(module, exports) {

let $62ca83350a21c709$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62ca83350a21c709$var$load("bGwrD").then(()=>parcelRequire('31BVM'));

});

parcelRegister("kjQn1", function(module, exports) {

let $ecae34a7b9b879e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecae34a7b9b879e5$var$load("e00ow").then(()=>parcelRequire('itpo2'));

});

parcelRegister("9htuM", function(module, exports) {

let $6c1c94c6f9f4bfc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c1c94c6f9f4bfc2$var$load("9RiRQ").then(()=>parcelRequire('aMCB9'));

});

parcelRegister("7iLdD", function(module, exports) {

let $015f3506460033a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $015f3506460033a4$var$load("bOwpR").then(()=>parcelRequire('6C8eU'));

});

parcelRegister("kkvW6", function(module, exports) {

let $ecce72c264347231$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecce72c264347231$var$load("exCSw").then(()=>parcelRequire('1tj8s'));

});

parcelRegister("bbbIY", function(module, exports) {

let $8239d0fdfd69144a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8239d0fdfd69144a$var$load("BKxAI").then(()=>parcelRequire('jerDQ'));

});

parcelRegister("bw9C4", function(module, exports) {

let $862a23d0d5a9a8e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $862a23d0d5a9a8e2$var$load("iVkAx").then(()=>parcelRequire('eU4qe'));

});

parcelRegister("kF94T", function(module, exports) {

let $f0aeada83bc9da59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0aeada83bc9da59$var$load("i3hKX").then(()=>parcelRequire('h7CNN'));

});

parcelRegister("gh5g4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $6OpMl = parcelRequire("6OpMl");


var $af2XZ = parcelRequire("af2XZ");


var $dTHYM = parcelRequire("dTHYM");

var $dUI0h = parcelRequire("dUI0h");

var $hpa99 = parcelRequire("hpa99");


var $I7hWB = parcelRequire("I7hWB");


var $gFEZF = parcelRequire("gFEZF");


var $7sJoX = parcelRequire("7sJoX");


var $iDfTs = parcelRequire("iDfTs");


var $b35Wv = parcelRequire("b35Wv");


var $8Svrc = parcelRequire("8Svrc");


var $5HApy = parcelRequire("5HApy");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $b4vCW = parcelRequire("b4vCW");

var $69Kfj = parcelRequire("69Kfj");


var $7CqGl = parcelRequire("7CqGl");


var $98i9C = parcelRequire("98i9C");


var $d26Wq = parcelRequire("d26Wq");


var $evuMX = parcelRequire("evuMX");


var $eHUtn = parcelRequire("eHUtn");


var $9S8qu = parcelRequire("9S8qu");


var $lfiBc = parcelRequire("lfiBc");


var $9TKdb = parcelRequire("9TKdb");


const $53ab1bf034506aeb$var$RovoLinkPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("lLexe")).then((mod)=>({
            default: mod.default
        })));
const $53ab1bf034506aeb$var$useSpaceSourcePlugins = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSpaceSourcePlugins(cloudId) {
    const $ = (0, $bDgLe.c)(21);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            tabKey: "confluence",
            tabTitle: "Confluence"
        };
        t1 = [
            "confluence"
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] !== cloudId) {
        t2 = {
            tabConfig: t0,
            products: t1,
            scope: (0, $b4vCW.Scope).ConfluenceContentType,
            cloudId: cloudId
        };
        $[2] = cloudId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            tabKey: "jira",
            tabTitle: "Jira"
        };
        t4 = [
            "jira"
        ];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    let t5;
    if ($[6] !== cloudId) {
        t5 = {
            tabConfig: t3,
            products: t4,
            scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter,
            cloudId: cloudId
        };
        $[6] = cloudId;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            tabKey: "atlas",
            tabTitle: "Atlas"
        };
        t7 = [
            "townsquare"
        ];
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    let t8;
    if ($[10] !== cloudId) {
        t8 = {
            tabConfig: t6,
            products: t7,
            scope: (0, $b4vCW.Scope).TownsquareProject,
            cloudId: cloudId
        };
        $[10] = cloudId;
        $[11] = t8;
    } else t8 = $[11];
    let t10;
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            tabKey: "loom",
            tabTitle: "Loom"
        };
        t10 = [
            "loom"
        ];
        $[12] = t10;
        $[13] = t9;
    } else {
        t10 = $[12];
        t9 = $[13];
    }
    let t11;
    if ($[14] !== cloudId) {
        t11 = {
            tabConfig: t9,
            products: t10,
            scope: (0, $b4vCW.Scope).Loom,
            cloudId: cloudId,
            disableActivityClient: true
        };
        $[14] = cloudId;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11 || $[17] !== t2 || $[18] !== t5 || $[19] !== t8) {
        t12 = [
            t2,
            t5,
            t8,
            t11
        ];
        $[16] = t11;
        $[17] = t2;
        $[18] = t5;
        $[19] = t8;
        $[20] = t12;
    } else t12 = $[20];
    const configs = t12;
    return (0, $69Kfj.useAtlassianPlugins)(configs);
} : function useSpaceSourcePlugins(cloudId) {
    const configs = (0, $cozmU.useMemo)(()=>[
            {
                tabConfig: {
                    tabKey: 'confluence',
                    tabTitle: 'Confluence'
                },
                products: [
                    'confluence'
                ],
                scope: (0, $b4vCW.Scope).ConfluenceContentType,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'jira',
                    tabTitle: 'Jira'
                },
                products: [
                    'jira'
                ],
                scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'atlas',
                    tabTitle: 'Atlas'
                },
                products: [
                    'townsquare'
                ],
                scope: (0, $b4vCW.Scope).TownsquareProject,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'loom',
                    tabTitle: 'Loom'
                },
                products: [
                    'loom'
                ],
                scope: (0, $b4vCW.Scope).Loom,
                cloudId: cloudId,
                disableActivityClient: true
            }
        ], [
        cloudId
    ]);
    return (0, $69Kfj.useAtlassianPlugins)(configs);
};
const $53ab1bf034506aeb$var$styles = {
    rovoLinkPickerWrapper: "_0NUa3raVF6 _2WAcuGIZbP",
    sourceRow: "_4c065UgVvo",
    sourceRowLast: "_4c065UgVvo",
    sourceTitleRow: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    sourcesContainer: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r21Y8M _1Znuxb8HPE _1wydGW1Y8M _2Zuz6Q8HPE",
    requiredFieldsHint: "_0Of8r28HPE _1wydGW1Y8M",
    iconPickerField: "_0Of8r28HPE",
    descriptionField: "_0Of8r22ADO",
    knowledgeField: "_0Of8r22ADO",
    iconPickerButtonContent: "_4kiQYAoWWg _1VJPcaTCo3",
    iconPickerEmojiSlot: "_39xV0270UD _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconPickerSelectedEmoji: "_1VJPcav4qQ",
    iconPickerChevronSlot: "_39xV02uFDC _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $53ab1bf034506aeb$var$CREATE_SPACE_FORM_ID = 'create-space-form';
const $53ab1bf034506aeb$var$SpaceSourcesLayout = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { sources: sources, onRemove: onRemove, formatMessage: formatMessage, addSourcesTrigger: addSourcesTrigger } = t0;
    let t1;
    if ($[0] !== formatMessage || $[1] !== onRemove || $[2] !== sources) {
        t1 = sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53ab1bf034506aeb$var$styles.sourcesContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                key: source.ari,
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                xcss: index < sources.length - 1 ? $53ab1bf034506aeb$var$styles.sourceRow : $53ab1bf034506aeb$var$styles.sourceRowLast
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "row",
                alignItems: "center",
                gap: "space.100",
                xcss: $53ab1bf034506aeb$var$styles.sourceTitleRow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfiBc.SmartLinkSourceRow), {
                url: source.url,
                fallback: source.name ?? "",
                displayTextOverride: source.displayText
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $9S8qu.default).createSpaceRemoveSource, {
                    name: source.name
                }),
                onClick: ()=>onRemove(source.ari),
                testId: `create-space-remove-source-${source.ari}`
            }))))) : null;
        $[0] = formatMessage;
        $[1] = onRemove;
        $[2] = sources;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $9S8qu.default).createSpaceSourcesHelperMessage);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "small",
            color: "color.text.subtlest"
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== addSourcesTrigger) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, addSourcesTrigger);
        $[8] = addSourcesTrigger;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t1, t3, t4);
        $[10] = t1;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ sources: sources, onRemove: onRemove, formatMessage: formatMessage, addSourcesTrigger: addSourcesTrigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $53ab1bf034506aeb$var$styles.sourcesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            key: source.ari,
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            xcss: index < sources.length - 1 ? $53ab1bf034506aeb$var$styles.sourceRow : $53ab1bf034506aeb$var$styles.sourceRowLast
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "row",
            alignItems: "center",
            gap: "space.100",
            xcss: $53ab1bf034506aeb$var$styles.sourceTitleRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfiBc.SmartLinkSourceRow), {
            url: source.url,
            fallback: source.name ?? '',
            displayTextOverride: source.displayText
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $9S8qu.default).createSpaceRemoveSource, {
                name: source.name
            }),
            onClick: ()=>onRemove(source.ari),
            testId: `create-space-remove-source-${source.ari}`
        }))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $9S8qu.default).createSpaceSourcesHelperMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, addSourcesTrigger));
const $53ab1bf034506aeb$var$IconPickerField = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { isEmojiPickerOpen: isEmojiPickerOpen, onClose: onClose, onToggle: onToggle, emojiProvider: emojiProvider, onSelection: onSelection, selectedEmoji: selectedEmoji, formatMessage: formatMessage } = t0;
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $9S8qu.default).createSpaceIconLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "small",
            weight: "semibold"
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== emojiProvider || $[5] !== onSelection) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: onSelection
            });
        $[4] = emojiProvider;
        $[5] = onSelection;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== emojiProvider || $[8] !== formatMessage || $[9] !== onToggle || $[10] !== selectedEmoji) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                appearance: "default",
                "aria-label": formatMessage((0, $9S8qu.default).createSpaceEmojiPickerLabel),
                onClick: onToggle,
                testId: "create-space-emoji-picker-trigger"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "row",
                alignItems: "center",
                gap: "space.050",
                xcss: $53ab1bf034506aeb$var$styles.iconPickerButtonContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.iconPickerEmojiSlot
            }, selectedEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.iconPickerSelectedEmoji
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                emojiId: selectedEmoji,
                emojiProvider: emojiProvider,
                showTooltip: true,
                fitToHeight: 16
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                label: ""
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.iconPickerChevronSlot
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small"
            })))));
        $[7] = emojiProvider;
        $[8] = formatMessage;
        $[9] = onToggle;
        $[10] = selectedEmoji;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isEmojiPickerOpen || $[13] !== onClose || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            zIndex: 510,
            isOpen: isEmojiPickerOpen,
            onClose: onClose,
            placement: "bottom-start",
            content: t3,
            trigger: t4
        });
        $[12] = isEmojiPickerOpen;
        $[13] = onClose;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== formatMessage) {
        t6 = formatMessage((0, $9S8qu.default).createSpaceIconHelperMessage);
        $[17] = formatMessage;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "small",
            color: "color.text.subtlest"
        }, t6);
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t2 || $[22] !== t5 || $[23] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            xcss: $53ab1bf034506aeb$var$styles.iconPickerField
        }, t2, t5, t7);
        $[21] = t2;
        $[22] = t5;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ isEmojiPickerOpen: isEmojiPickerOpen, onClose: onClose, onToggle: onToggle, emojiProvider: emojiProvider, onSelection: onSelection, selectedEmoji: selectedEmoji, formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $53ab1bf034506aeb$var$styles.iconPickerField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        size: "small",
        weight: "semibold"
    }, formatMessage((0, $9S8qu.default).createSpaceIconLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        zIndex: 510,
        isOpen: isEmojiPickerOpen,
        onClose: onClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: onSelection
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                appearance: "default",
                "aria-label": formatMessage((0, $9S8qu.default).createSpaceEmojiPickerLabel),
                onClick: onToggle,
                testId: "create-space-emoji-picker-trigger"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "row",
                alignItems: "center",
                gap: "space.050",
                xcss: $53ab1bf034506aeb$var$styles.iconPickerButtonContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.iconPickerEmojiSlot
            }, selectedEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.iconPickerSelectedEmoji
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                emojiId: selectedEmoji,
                emojiProvider: emojiProvider,
                showTooltip: true,
                fitToHeight: 16
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                label: ""
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.iconPickerChevronSlot
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small"
            })))))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $9S8qu.default).createSpaceIconHelperMessage)));
const $53ab1bf034506aeb$var$SpaceSourcesFieldBody = ({ fieldProps: fieldProps, formatMessage: formatMessage, cloudId: cloudId, plugins: plugins })=>{
    const [isPickerOpen, setPickerOpen] = (0, $cozmU.useState)(false);
    const sources = fieldProps.value ?? []; // `fieldProps` is a new object each render from Form; keep a ref so the link-picker callback stays stable.
    const fieldPropsRef = (0, $cozmU.useRef)(fieldProps);
    fieldPropsRef.current = fieldProps;
    const handleSubmit = (0, $cozmU.useCallback)(({ url: url, displayText: displayText, title: title })=>{
        const { onChange: onChange, value: value } = fieldPropsRef.current;
        const current = value ?? []; // Treat `displayText` as a user override only when it differs from the
        // link picker's pre-filled `title`; otherwise keep using the live SmartLink title.
        const trimmedDisplayText = displayText?.trim() || undefined;
        const resolvedTitle = title?.trim() || undefined;
        const userDisplayText = trimmedDisplayText && trimmedDisplayText !== resolvedTitle ? trimmedDisplayText : undefined;
        onChange([
            ...current,
            {
                ari: url,
                url: url,
                name: trimmedDisplayText ?? resolvedTitle ?? url,
                displayText: userDisplayText,
                sourceType: $53ab1bf034506aeb$var$detectSourceType(url),
                conversationIds: []
            }
        ]);
        setPickerOpen(false);
    }, []);
    const addSourcesTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        isOpen: isPickerOpen,
        onClose: ()=>setPickerOpen(false),
        placement: "bottom-start",
        zIndex: 510,
        content: ()=>(0, $iDrrr.fg)('rovo_spaces_use_rovo_link_picker') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.rovoLinkPickerWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$RovoLinkPicker, {
                cloudId: cloudId,
                onSubmit: handleSubmit,
                onCancel: ()=>setPickerOpen(false)
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Svrc.DeprecatedLazyLinkPickerExport), {
                plugins: plugins,
                onSubmit: handleSubmit,
                onCancel: ()=>setPickerOpen(false),
                adaptiveHeight: true,
                recentSearchListSize: 3
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                appearance: "default",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
                type: "button",
                onClick: ()=>setPickerOpen((prev)=>!prev),
                testId: "create-space-add-sources"
            }, formatMessage((0, $9S8qu.default).createSpaceAddSources))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$SpaceSourcesLayout, {
        sources: sources,
        onRemove: (ari)=>fieldProps.onChange(sources.filter((s)=>s.ari !== ari)),
        formatMessage: formatMessage,
        addSourcesTrigger: addSourcesTrigger
    });
};
function $53ab1bf034506aeb$var$detectSourceType(url) {
    if (/confluence/i.test(url)) return 'confluence';
    if (/jira/i.test(url)) return 'jira';
    return 'confluence';
} // Only mounted when isOpen=true.
const $53ab1bf034506aeb$var$CreateSpaceModalContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { onClose: onClose, cloudId: cloudId, emojiProvider: emojiProvider, assistanceServiceParams: assistanceServiceParams, onCreate: onCreate, onCreated: onCreated, initialName: initialName, initialSources: initialSources, initialConversationId: initialConversationId, createdFrom: t1 } = t0;
    const createdFrom = t1 === undefined ? "manual" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== cloudId) {
        t2 = (0, $d26Wq.createEmojiProviderWithUpload)(cloudId);
        $[0] = cloudId;
        $[1] = t2;
    } else t2 = $[1];
    const defaultEmojiProvider = t2;
    const resolvedEmojiProvider = emojiProvider ?? defaultEmojiProvider;
    const [isEmojiPickerOpen, setEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const [selectedEmoji, setSelectedEmoji] = (0, $cozmU.useState)(undefined);
    const submittedSourceCountRef = (0, $cozmU.useRef)(0);
    const { fireSpaceCreated: fireSpaceCreated, fireConversationAdded: fireConversationAdded } = (0, $7CqGl.useSpacesAnalytics)();
    const plugins = $53ab1bf034506aeb$var$useSpaceSourcePlugins(cloudId);
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $9S8qu.default).createSpaceNameRequired);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    const nameRequiredMessage = t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (emojiId)=>{
            setSelectedEmoji(emojiId);
            setEmojiPickerOpen(false);
        };
        $[4] = t4;
    } else t4 = $[4];
    const handleEmojiSelection = t4;
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setEmojiPickerOpen(false);
            setSelectedEmoji(undefined);
        };
        $[5] = t5;
    } else t5 = $[5];
    const reset = t5;
    let t6;
    if ($[6] !== onClose) {
        t6 = ()=>{
            reset();
            onClose();
        };
        $[6] = onClose;
        $[7] = t6;
    } else t6 = $[7];
    const handleClose = t6;
    const t7 = assistanceServiceParams?.product ?? "rovo";
    const t8 = assistanceServiceParams?.experienceId ?? "ai-mate";
    let t9;
    if ($[8] !== cloudId || $[9] !== t7 || $[10] !== t8) {
        t9 = {
            cloudId: cloudId,
            product: t7,
            experienceId: t8
        };
        $[8] = cloudId;
        $[9] = t7;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    const { addConversation: addConversation } = (0, $evuMX.useAddConversationToSpace)(t9);
    let t10;
    if ($[12] !== addConversation || $[13] !== createdFrom || $[14] !== fireConversationAdded || $[15] !== fireSpaceCreated || $[16] !== handleClose || $[17] !== initialConversationId || $[18] !== onCreated || $[19] !== selectedEmoji?.id) {
        t10 = async (space)=>{
            fireSpaceCreated({
                spaceId: space?.id,
                sourceCount: submittedSourceCountRef.current,
                hasInitialConversation: Boolean(initialConversationId),
                createdFrom: createdFrom
            });
            let attachedConversationId;
            if (initialConversationId && space?.id) try {
                await addConversation({
                    spaceId: space.id,
                    conversationId: initialConversationId
                });
                attachedConversationId = initialConversationId;
                fireConversationAdded({
                    spaceId: space.id,
                    addedFrom: "createSpace"
                });
            } catch (t11) {
                const e = t11;
                console.error("[CreateSpaceModal] failed to attach conversation to new space", e);
            }
            onCreated?.(space, selectedEmoji?.id, attachedConversationId);
            handleClose();
        };
        $[12] = addConversation;
        $[13] = createdFrom;
        $[14] = fireConversationAdded;
        $[15] = fireSpaceCreated;
        $[16] = handleClose;
        $[17] = initialConversationId;
        $[18] = onCreated;
        $[19] = selectedEmoji?.id;
        $[20] = t10;
    } else t10 = $[20];
    const handleCreated = t10;
    const t11 = assistanceServiceParams?.product ?? "rovo";
    const t12 = assistanceServiceParams?.experienceId ?? "ai-mate";
    let t13;
    if ($[21] !== cloudId || $[22] !== handleCreated || $[23] !== t11 || $[24] !== t12) {
        t13 = {
            cloudId: cloudId,
            product: t11,
            experienceId: t12,
            onSuccess: handleCreated
        };
        $[21] = cloudId;
        $[22] = handleCreated;
        $[23] = t11;
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    const { mutate: createSpace, isSubmitting: isSubmitting } = (0, $eHUtn.useCreateSpace)(t13);
    let t14;
    if ($[26] !== createSpace || $[27] !== onCreate || $[28] !== selectedEmoji) {
        t14 = (values)=>{
            const trimmed = values.name.trim();
            if (!trimmed) return;
            const sourcesForSubmission = values.sources.map((0, $9TKdb.toSpaceSource));
            submittedSourceCountRef.current = sourcesForSubmission.length;
            onCreate?.({
                name: trimmed,
                about: values.about.trim(),
                emoji: selectedEmoji,
                sources: sourcesForSubmission
            });
            createSpace({
                name: trimmed,
                description: values.about.trim() || undefined,
                sources: sourcesForSubmission,
                emoji: selectedEmoji?.id
            });
        };
        $[26] = createSpace;
        $[27] = onCreate;
        $[28] = selectedEmoji;
        $[29] = t14;
    } else t14 = $[29];
    const handleFormSubmit = t14;
    let t15;
    if ($[30] !== formatMessage) {
        t15 = formatMessage((0, $9S8qu.default).createSpaceModalTitle);
        $[30] = formatMessage;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, t15));
        $[32] = t15;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== assistanceServiceParams || $[35] !== cloudId || $[36] !== formatMessage || $[37] !== initialName || $[38] !== initialSources || $[39] !== isEmojiPickerOpen || $[40] !== nameRequiredMessage || $[41] !== plugins || $[42] !== resolvedEmojiProvider || $[43] !== selectedEmoji) {
        t17 = (t18)=>{
            const { formProps: formProps } = t18;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
                ...formProps,
                id: $53ab1bf034506aeb$var$CREATE_SPACE_FORM_ID,
                name: "create-space"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p"
            }, formatMessage((0, $9S8qu.default).createSpaceIntro)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.requiredFieldsHint
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p",
                "aria-hidden": "true",
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage((0, $9S8qu.default).createSpaceRequiredFieldsHint, {
                asterisk: $53ab1bf034506aeb$var$_temp
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "name",
                label: formatMessage((0, $9S8qu.default).createSpaceNameLabel),
                isRequired: true,
                defaultValue: initialName ?? "",
                validate: (value)=>value && String(value).trim() ? undefined : nameRequiredMessage,
                helperMessage: formatMessage((0, $9S8qu.default).createSpaceNameHelperMessage),
                component: $53ab1bf034506aeb$var$_temp2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$IconPickerField, {
                isEmojiPickerOpen: isEmojiPickerOpen,
                onClose: ()=>setEmojiPickerOpen(false),
                onToggle: ()=>setEmojiPickerOpen(!isEmojiPickerOpen),
                emojiProvider: resolvedEmojiProvider,
                onSelection: handleEmojiSelection,
                selectedEmoji: selectedEmoji,
                formatMessage: formatMessage
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.descriptionField
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "about",
                label: formatMessage((0, $9S8qu.default).createSpaceAboutLabel),
                defaultValue: "",
                component: $53ab1bf034506aeb$var$_temp3
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $53ab1bf034506aeb$var$styles.knowledgeField
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "sources",
                label: formatMessage((0, $9S8qu.default).createSpaceSourcesLabel),
                defaultValue: initialSources ?? []
            }, (t19)=>{
                const { fieldProps: fieldProps_1 } = t19;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$SpaceSourcesFieldBody, {
                    fieldProps: fieldProps_1,
                    formatMessage: formatMessage,
                    cloudId: cloudId,
                    plugins: plugins,
                    assistanceServiceParams: assistanceServiceParams
                });
            })));
        };
        $[34] = assistanceServiceParams;
        $[35] = cloudId;
        $[36] = formatMessage;
        $[37] = initialName;
        $[38] = initialSources;
        $[39] = isEmojiPickerOpen;
        $[40] = nameRequiredMessage;
        $[41] = plugins;
        $[42] = resolvedEmojiProvider;
        $[43] = selectedEmoji;
        $[44] = t17;
    } else t17 = $[44];
    let t18;
    if ($[45] !== handleFormSubmit || $[46] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: handleFormSubmit
        }, t17))));
        $[45] = handleFormSubmit;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    let t19;
    if ($[48] !== formatMessage) {
        t19 = formatMessage((0, $9S8qu.default).createSpaceCancel);
        $[48] = formatMessage;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== handleClose || $[51] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleClose
        }, t19);
        $[50] = handleClose;
        $[51] = t19;
        $[52] = t20;
    } else t20 = $[52];
    let t21;
    if ($[53] !== formatMessage) {
        t21 = formatMessage((0, $9S8qu.default).createSpaceSubmit);
        $[53] = formatMessage;
        $[54] = t21;
    } else t21 = $[54];
    let t22;
    if ($[55] !== isSubmitting || $[56] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            type: "submit",
            form: $53ab1bf034506aeb$var$CREATE_SPACE_FORM_ID,
            testId: "create-space-submit",
            isDisabled: isSubmitting,
            isLoading: isSubmitting
        }, t21);
        $[55] = isSubmitting;
        $[56] = t21;
        $[57] = t22;
    } else t22 = $[57];
    let t23;
    if ($[58] !== t20 || $[59] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, t20, t22);
        $[58] = t20;
        $[59] = t22;
        $[60] = t23;
    } else t23 = $[60];
    let t24;
    if ($[61] !== handleClose || $[62] !== t16 || $[63] !== t18 || $[64] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: handleClose,
            width: "medium",
            testId: "create-space-modal"
        }, t16, t18, t23));
        $[61] = handleClose;
        $[62] = t16;
        $[63] = t18;
        $[64] = t23;
        $[65] = t24;
    } else t24 = $[65];
    return t24;
} : ({ onClose: onClose, cloudId: cloudId, emojiProvider: emojiProvider, assistanceServiceParams: assistanceServiceParams, onCreate: onCreate, onCreated: onCreated, initialName: initialName, initialSources: initialSources, initialConversationId: initialConversationId, createdFrom: createdFrom = 'manual' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const defaultEmojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProviderWithUpload)(cloudId), [
        cloudId
    ]);
    const resolvedEmojiProvider = emojiProvider ?? defaultEmojiProvider;
    const [isEmojiPickerOpen, setEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const [selectedEmoji, setSelectedEmoji] = (0, $cozmU.useState)(undefined); // Number of sources on the just-submitted form, captured so the
    // space-created event can report `sourceCount` from the async success path.
    const submittedSourceCountRef = (0, $cozmU.useRef)(0);
    const { fireSpaceCreated: fireSpaceCreated, fireConversationAdded: fireConversationAdded } = (0, $7CqGl.useSpacesAnalytics)();
    const plugins = $53ab1bf034506aeb$var$useSpaceSourcePlugins(cloudId);
    const nameRequiredMessage = (0, $cozmU.useMemo)(()=>formatMessage((0, $9S8qu.default).createSpaceNameRequired), [
        formatMessage
    ]);
    const handleEmojiSelection = (0, $cozmU.useCallback)((emojiId)=>{
        setSelectedEmoji(emojiId);
        setEmojiPickerOpen(false);
    }, []);
    const reset = (0, $cozmU.useCallback)(()=>{
        setEmojiPickerOpen(false);
        setSelectedEmoji(undefined);
    }, []);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        reset();
        onClose();
    }, [
        onClose,
        reset
    ]);
    const { addConversation: addConversation } = (0, $evuMX.useAddConversationToSpace)({
        cloudId: cloudId,
        product: assistanceServiceParams?.product ?? 'rovo',
        experienceId: assistanceServiceParams?.experienceId ?? 'ai-mate'
    });
    const handleCreated = (0, $cozmU.useCallback)(async (space)=>{
        fireSpaceCreated({
            spaceId: space?.id,
            sourceCount: submittedSourceCountRef.current,
            hasInitialConversation: Boolean(initialConversationId),
            createdFrom: createdFrom
        });
        let attachedConversationId; // If a conversation id was provided, attach it to the newly created space
        if (initialConversationId && space?.id) try {
            await addConversation({
                spaceId: space.id,
                conversationId: initialConversationId
            });
            attachedConversationId = initialConversationId;
            fireConversationAdded({
                spaceId: space.id,
                addedFrom: 'createSpace'
            });
        } catch (e) {
            // Surface the failure but don't block closing the modal
            // eslint-disable-next-line no-console
            console.error('[CreateSpaceModal] failed to attach conversation to new space', e);
        }
         // Forward the attached conversation id so callers can stitch it into the optimistic
        // SpaceStore update — the create-space response itself doesn't echo back sources.
        onCreated?.(space, selectedEmoji?.id, attachedConversationId);
        handleClose();
    }, [
        onCreated,
        handleClose,
        selectedEmoji,
        initialConversationId,
        addConversation,
        fireSpaceCreated,
        fireConversationAdded,
        createdFrom
    ]);
    const { mutate: createSpace, isSubmitting: isSubmitting } = (0, $eHUtn.useCreateSpace)({
        cloudId: cloudId,
        product: assistanceServiceParams?.product ?? 'rovo',
        experienceId: assistanceServiceParams?.experienceId ?? 'ai-mate',
        onSuccess: handleCreated
    });
    const handleFormSubmit = (0, $cozmU.useCallback)((values)=>{
        const trimmed = values.name.trim();
        if (!trimmed) return;
         // Strip client-only `displayText` before handing to BE / consumers (see toSpaceSource).
        const sourcesForSubmission = values.sources.map((0, $9TKdb.toSpaceSource));
        submittedSourceCountRef.current = sourcesForSubmission.length; // Fire the local callback (non-BE) if provided
        onCreate?.({
            name: trimmed,
            about: values.about.trim(),
            emoji: selectedEmoji,
            sources: sourcesForSubmission
        }); // Create the space; `initialConversationId` is attached in `handleCreated`.
        createSpace({
            name: trimmed,
            description: values.about.trim() || undefined,
            sources: sourcesForSubmission,
            emoji: selectedEmoji?.id
        });
    }, [
        createSpace,
        onCreate,
        selectedEmoji
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: handleClose,
        width: "medium",
        testId: "create-space-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, formatMessage((0, $9S8qu.default).createSpaceModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleFormSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            ...formProps,
            id: $53ab1bf034506aeb$var$CREATE_SPACE_FORM_ID,
            name: "create-space"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, formatMessage((0, $9S8qu.default).createSpaceIntro)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53ab1bf034506aeb$var$styles.requiredFieldsHint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            "aria-hidden": "true",
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $9S8qu.default).createSpaceRequiredFieldsHint, {
            asterisk: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            label: formatMessage((0, $9S8qu.default).createSpaceNameLabel),
            isRequired: true,
            defaultValue: initialName ?? '',
            validate: (value)=>value && String(value).trim() ? undefined : nameRequiredMessage,
            helperMessage: formatMessage((0, $9S8qu.default).createSpaceNameHelperMessage),
            component: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                    ...fieldProps,
                    maxLength: (0, $98i9C.SPACE_NAME_MAX_LENGTH)
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$IconPickerField, {
            isEmojiPickerOpen: isEmojiPickerOpen,
            onClose: ()=>setEmojiPickerOpen(false),
            onToggle: ()=>setEmojiPickerOpen(!isEmojiPickerOpen),
            emojiProvider: resolvedEmojiProvider,
            onSelection: handleEmojiSelection,
            selectedEmoji: selectedEmoji,
            formatMessage: formatMessage
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53ab1bf034506aeb$var$styles.descriptionField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "about",
            label: formatMessage((0, $9S8qu.default).createSpaceAboutLabel),
            defaultValue: "",
            component: ({ fieldProps: fieldProps_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                    ...fieldProps_0,
                    maxLength: (0, $98i9C.SPACE_ABOUT_MAX_LENGTH)
                })
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $53ab1bf034506aeb$var$styles.knowledgeField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "sources",
            label: formatMessage((0, $9S8qu.default).createSpaceSourcesLabel),
            defaultValue: initialSources ?? []
        }, ({ fieldProps: fieldProps_1 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$SpaceSourcesFieldBody, {
                fieldProps: fieldProps_1,
                formatMessage: formatMessage,
                cloudId: cloudId,
                plugins: plugins,
                assistanceServiceParams: assistanceServiceParams
            })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClose
    }, formatMessage((0, $9S8qu.default).createSpaceCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        type: "submit",
        form: $53ab1bf034506aeb$var$CREATE_SPACE_FORM_ID,
        testId: "create-space-submit",
        isDisabled: isSubmitting,
        isLoading: isSubmitting
    }, formatMessage((0, $9S8qu.default).createSpaceSubmit)))));
};
const $53ab1bf034506aeb$export$b8625ef6388b2e60 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    let isOpen;
    let rest;
    if ($[0] !== t0) {
        ({ isOpen: isOpen, ...rest } = t0);
        $[0] = t0;
        $[1] = isOpen;
        $[2] = rest;
    } else {
        isOpen = $[1];
        rest = $[2];
    }
    if (!isOpen) return null;
    let t1;
    if ($[3] !== rest) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$CreateSpaceModalContent, rest);
        $[3] = rest;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ isOpen: isOpen, ...rest })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53ab1bf034506aeb$var$CreateSpaceModalContent, rest);
};
function $53ab1bf034506aeb$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null);
}
function $53ab1bf034506aeb$var$_temp2(t0) {
    const { fieldProps: fieldProps } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        ...fieldProps,
        maxLength: (0, $98i9C.SPACE_NAME_MAX_LENGTH)
    });
}
function $53ab1bf034506aeb$var$_temp3(t0) {
    const { fieldProps: fieldProps_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        ...fieldProps_0,
        maxLength: (0, $98i9C.SPACE_ABOUT_MAX_LENGTH)
    });
}
module.exports["CreateSpaceModal"] = $53ab1bf034506aeb$export$b8625ef6388b2e60;

});

parcelRegister("8Svrc", function(module, exports) {

var $fuSOM = parcelRequire("fuSOM");


var $8mHp9 = parcelRequire("8mHp9");


var $lA6N5 = parcelRequire("lA6N5");

const $0d528dd54de2f317$export$23942968e751dbea = (0, $fuSOM.default);
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $0d528dd54de2f317$var$_default_1 = (0, $lA6N5.composeLinkPicker)((0, $8mHp9.LinkPicker));
var $0d528dd54de2f317$export$2e2bcd8739ae039 = $0d528dd54de2f317$var$_default_1;
module.exports["DeprecatedLazyLinkPickerExport"] = $0d528dd54de2f317$export$23942968e751dbea;
module.exports["default"] = $0d528dd54de2f317$export$2e2bcd8739ae039;

});

parcelRegister("fuSOM", function(module, exports) {
parcelRequire("eRn3r");
var $9aUDG = parcelRequire("9aUDG");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $9aUDG.lazyForPaint)(()=>(parcelRequire("eOXKE")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("9aUDG")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("8r5Wf")).useLazyPhase);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("8r5Wf")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $6245739e6eaab8ef$export$1dc361b277327f88;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6ae0fb8adbd87448$export$291dd592399bdafa;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

parcelRequire("eRn3r");
var $3QYdZ = parcelRequire("3QYdZ");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02oEu0"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02oEu0"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $kHija.v4)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $iDrrr = parcelRequire("iDrrr");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_0Of8r2NHnM _1Znuxbp0Oa _2Zuz6Qp0Oa _1wydGWS40j _2fwxA5DIqT",
    whiteSpaceNormal: "_1ANEUSzUZr"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, (0, $iDrrr.fg)("platform_link_picker_fix_error_state_text_overflow") && $abc7c062eda24665$var$styles.whiteSpaceNormal);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== renderImage) {
        t2 = renderImage?.();
        $[1] = renderImage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[3] = header;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== description) {
        t4 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            color: "color.text"
        }, description);
        $[5] = description;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = action && action;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: t1,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, (0, $iDrrr.fg)('platform_link_picker_fix_error_state_text_overflow') && $abc7c062eda24665$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLFlnN _37wbyuDIqT _4kiQYAjtAN",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("8xpUG")),
    da: ()=>(parcelRequire("ZDEny")),
    de: ()=>(parcelRequire("dhENg")),
    en_GB: ()=>(parcelRequire("10Huk")),
    en_ZZ: ()=>(parcelRequire("b8fyv")),
    en: ()=>(parcelRequire("2UyJI")),
    es: ()=>(parcelRequire("kviqL")),
    fi: ()=>(parcelRequire("kEGGx")),
    fr: ()=>(parcelRequire("3I7Hw")),
    hu: ()=>(parcelRequire("8VE62")),
    it: ()=>(parcelRequire("l8IkB")),
    ja: ()=>(parcelRequire("1kFuU")),
    ko: ()=>(parcelRequire("luWhw")),
    nb: ()=>(parcelRequire("fMQtL")),
    nl: ()=>(parcelRequire("7GM7G")),
    pl: ()=>(parcelRequire("1LETb")),
    pt_BR: ()=>(parcelRequire("4th1C")),
    ru: ()=>(parcelRequire("unThT")),
    sv: ()=>(parcelRequire("hXIzt")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("cB9tL")),
    zh: ()=>(parcelRequire("kA90v"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("8xpUG", function(module, exports) {

let $637581a007704468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $637581a007704468$var$load("1JYrd"),
    $637581a007704468$var$load("cip6w"),
    $637581a007704468$var$load("gAG2n"),
    $637581a007704468$var$load("hFpP9"),
    $637581a007704468$var$load("3feYV"),
    $637581a007704468$var$load("cwjU2"),
    $637581a007704468$var$load("3Ff1R"),
    $637581a007704468$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("ZDEny", function(module, exports) {

let $0b9474569ed7489d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0b9474569ed7489d$var$load("30242"),
    $0b9474569ed7489d$var$load("3qBwQ"),
    $0b9474569ed7489d$var$load("cYGDU"),
    $0b9474569ed7489d$var$load("ddSTH"),
    $0b9474569ed7489d$var$load("7Q1SM"),
    $0b9474569ed7489d$var$load("33Iaa"),
    $0b9474569ed7489d$var$load("blA7x"),
    $0b9474569ed7489d$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("dhENg", function(module, exports) {

let $9abc819fdf737828$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9abc819fdf737828$var$load("15aAJ"),
    $9abc819fdf737828$var$load("8rREG"),
    $9abc819fdf737828$var$load("dgXJL"),
    $9abc819fdf737828$var$load("9d8JZ"),
    $9abc819fdf737828$var$load("7JdzX"),
    $9abc819fdf737828$var$load("6681T"),
    $9abc819fdf737828$var$load("3dn3H"),
    $9abc819fdf737828$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("10Huk", function(module, exports) {

let $0bc7865c2a7d50be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0bc7865c2a7d50be$var$load("l5BBd"),
    $0bc7865c2a7d50be$var$load("93ASN"),
    $0bc7865c2a7d50be$var$load("htu5t"),
    $0bc7865c2a7d50be$var$load("1A450"),
    $0bc7865c2a7d50be$var$load("24LNf"),
    $0bc7865c2a7d50be$var$load("iYQCc"),
    $0bc7865c2a7d50be$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("b8fyv", function(module, exports) {

let $81ac821635a16fcc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $81ac821635a16fcc$var$load("bbv9t"),
    $81ac821635a16fcc$var$load("9fQoJ"),
    $81ac821635a16fcc$var$load("lTboH"),
    $81ac821635a16fcc$var$load("gBDXQ"),
    $81ac821635a16fcc$var$load("cnlNg"),
    $81ac821635a16fcc$var$load("d3Phe"),
    $81ac821635a16fcc$var$load("lASLx"),
    $81ac821635a16fcc$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("2UyJI", function(module, exports) {

let $21ebc1a7a4257462$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21ebc1a7a4257462$var$load("hUbK8").then(()=>parcelRequire('935R1'));

});

parcelRegister("kviqL", function(module, exports) {

let $03da2528a320066d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03da2528a320066d$var$load("7p4je"),
    $03da2528a320066d$var$load("8SZbD"),
    $03da2528a320066d$var$load("iE05k"),
    $03da2528a320066d$var$load("lv5aU"),
    $03da2528a320066d$var$load("9Uf61"),
    $03da2528a320066d$var$load("3Yk1e"),
    $03da2528a320066d$var$load("5lJyy"),
    $03da2528a320066d$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("kEGGx", function(module, exports) {

let $f098a771ad5da940$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f098a771ad5da940$var$load("1jQRQ"),
    $f098a771ad5da940$var$load("5pOQA"),
    $f098a771ad5da940$var$load("5GSny"),
    $f098a771ad5da940$var$load("cQump"),
    $f098a771ad5da940$var$load("fJSEb"),
    $f098a771ad5da940$var$load("ajzkj"),
    $f098a771ad5da940$var$load("eyysG"),
    $f098a771ad5da940$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("3I7Hw", function(module, exports) {

let $2b3b746f45ad8ded$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b3b746f45ad8ded$var$load("km37l"),
    $2b3b746f45ad8ded$var$load("gbksI"),
    $2b3b746f45ad8ded$var$load("j2X7f"),
    $2b3b746f45ad8ded$var$load("fE8pi"),
    $2b3b746f45ad8ded$var$load("9TeWr"),
    $2b3b746f45ad8ded$var$load("kUZ7k"),
    $2b3b746f45ad8ded$var$load("dJQL7"),
    $2b3b746f45ad8ded$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("8VE62", function(module, exports) {

let $6802bfe54235dc57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6802bfe54235dc57$var$load("lTbXI"),
    $6802bfe54235dc57$var$load("a98cw"),
    $6802bfe54235dc57$var$load("e40mE"),
    $6802bfe54235dc57$var$load("btBGI"),
    $6802bfe54235dc57$var$load("fOGnR"),
    $6802bfe54235dc57$var$load("cDQOq"),
    $6802bfe54235dc57$var$load("8upye"),
    $6802bfe54235dc57$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("l8IkB", function(module, exports) {

let $f63cbb96448b4116$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f63cbb96448b4116$var$load("iUyZj"),
    $f63cbb96448b4116$var$load("4PDaO"),
    $f63cbb96448b4116$var$load("lMhbw"),
    $f63cbb96448b4116$var$load("amTTV"),
    $f63cbb96448b4116$var$load("8nEeY"),
    $f63cbb96448b4116$var$load("kLZKK"),
    $f63cbb96448b4116$var$load("c7GMc"),
    $f63cbb96448b4116$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("1kFuU", function(module, exports) {

let $0f87d939a93b0ed6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f87d939a93b0ed6$var$load("kPlMQ"),
    $0f87d939a93b0ed6$var$load("ervs7"),
    $0f87d939a93b0ed6$var$load("8CX31"),
    $0f87d939a93b0ed6$var$load("kYd4i"),
    $0f87d939a93b0ed6$var$load("fzzMQ"),
    $0f87d939a93b0ed6$var$load("33S6H"),
    $0f87d939a93b0ed6$var$load("kFae4"),
    $0f87d939a93b0ed6$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("luWhw", function(module, exports) {

let $fa699bd45bb3ceae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fa699bd45bb3ceae$var$load("iT2sv"),
    $fa699bd45bb3ceae$var$load("iMMtn"),
    $fa699bd45bb3ceae$var$load("23VWs"),
    $fa699bd45bb3ceae$var$load("e1KaU"),
    $fa699bd45bb3ceae$var$load("3gNEO"),
    $fa699bd45bb3ceae$var$load("93obY"),
    $fa699bd45bb3ceae$var$load("6Y9jE"),
    $fa699bd45bb3ceae$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("fMQtL", function(module, exports) {

let $b7e40befcab5209b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b7e40befcab5209b$var$load("lyPpF"),
    $b7e40befcab5209b$var$load("eX5n7"),
    $b7e40befcab5209b$var$load("aiYuN"),
    $b7e40befcab5209b$var$load("gqMCT"),
    $b7e40befcab5209b$var$load("gvylW"),
    $b7e40befcab5209b$var$load("bxfRe"),
    $b7e40befcab5209b$var$load("ed6s8"),
    $b7e40befcab5209b$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("7GM7G", function(module, exports) {

let $5991c8dd95c32a4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5991c8dd95c32a4d$var$load("iN3cj"),
    $5991c8dd95c32a4d$var$load("3nHdy"),
    $5991c8dd95c32a4d$var$load("gDEvm"),
    $5991c8dd95c32a4d$var$load("5MwHB"),
    $5991c8dd95c32a4d$var$load("80OLx"),
    $5991c8dd95c32a4d$var$load("1EVcg"),
    $5991c8dd95c32a4d$var$load("96q1k"),
    $5991c8dd95c32a4d$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("1LETb", function(module, exports) {

let $1499e5f0554eb549$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1499e5f0554eb549$var$load("eC1OL"),
    $1499e5f0554eb549$var$load("ilL9c"),
    $1499e5f0554eb549$var$load("64nco"),
    $1499e5f0554eb549$var$load("9cx6P"),
    $1499e5f0554eb549$var$load("e4s0V"),
    $1499e5f0554eb549$var$load("28EXy"),
    $1499e5f0554eb549$var$load("7RZp5"),
    $1499e5f0554eb549$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("4th1C", function(module, exports) {

let $341713af82211ab1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $341713af82211ab1$var$load("4NJ49"),
    $341713af82211ab1$var$load("bfOZL"),
    $341713af82211ab1$var$load("jLbRX"),
    $341713af82211ab1$var$load("5g0HW"),
    $341713af82211ab1$var$load("4dPO1"),
    $341713af82211ab1$var$load("gg8tK"),
    $341713af82211ab1$var$load("eF54W"),
    $341713af82211ab1$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("unThT", function(module, exports) {

let $05b555a8c041f647$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $05b555a8c041f647$var$load("g9gkE"),
    $05b555a8c041f647$var$load("jYdbS"),
    $05b555a8c041f647$var$load("6ncWv"),
    $05b555a8c041f647$var$load("gFneG"),
    $05b555a8c041f647$var$load("ltrgi"),
    $05b555a8c041f647$var$load("fu25G"),
    $05b555a8c041f647$var$load("iQGcz"),
    $05b555a8c041f647$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("hXIzt", function(module, exports) {

let $d13a853c637a3ee8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d13a853c637a3ee8$var$load("jhikU"),
    $d13a853c637a3ee8$var$load("f0i3H"),
    $d13a853c637a3ee8$var$load("bvBAp"),
    $d13a853c637a3ee8$var$load("9kqmW"),
    $d13a853c637a3ee8$var$load("69YlM"),
    $d13a853c637a3ee8$var$load("cyTsc"),
    $d13a853c637a3ee8$var$load("kXCsp"),
    $d13a853c637a3ee8$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("cB9tL", function(module, exports) {

let $92c04b0f0ee0966d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $92c04b0f0ee0966d$var$load("d91RK"),
    $92c04b0f0ee0966d$var$load("f7hfJ"),
    $92c04b0f0ee0966d$var$load("QI1kr"),
    $92c04b0f0ee0966d$var$load("5LvhC"),
    $92c04b0f0ee0966d$var$load("brdRT"),
    $92c04b0f0ee0966d$var$load("lWBlc"),
    $92c04b0f0ee0966d$var$load("s2EmI"),
    $92c04b0f0ee0966d$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("kA90v", function(module, exports) {

let $efbe28143b8faa30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $efbe28143b8faa30$var$load("708J7"),
    $efbe28143b8faa30$var$load("kVqUf"),
    $efbe28143b8faa30$var$load("2IMxh"),
    $efbe28143b8faa30$var$load("98tcg"),
    $efbe28143b8faa30$var$load("j03Pa"),
    $efbe28143b8faa30$var$load("kke1I"),
    $efbe28143b8faa30$var$load("gOwMq"),
    $efbe28143b8faa30$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("eOXKE", function(module, exports) {

let $aca41599c529f405$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aca41599c529f405$var$load("90vep"),
    $aca41599c529f405$var$load("ixrKS"),
    $aca41599c529f405$var$load("fdLC1"),
    $aca41599c529f405$var$load("aAJyu"),
    $aca41599c529f405$var$load("f8Q8b"),
    $aca41599c529f405$var$load("6wr18"),
    $aca41599c529f405$var$load("Wowvf"),
    $aca41599c529f405$var$load("ffEVr"),
    $aca41599c529f405$var$load("7EorR"),
    $aca41599c529f405$var$load("hhss7"),
    $aca41599c529f405$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("8mHp9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2VwyL = parcelRequire("2VwyL");


var $kHija = parcelRequire("kHija");


var $9DHhW = parcelRequire("9DHhW");


var $4yccB = parcelRequire("4yccB");


var $1F2YI = parcelRequire("1F2YI");


var $a3Cph = parcelRequire("a3Cph");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $FCr1g = parcelRequire("FCr1g");


var $9GVkD = parcelRequire("9GVkD");


var $bd5hf = parcelRequire("bd5hf");

var $8KzzK = parcelRequire("8KzzK");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $5eMgQ = parcelRequire("5eMgQ");


var $aqmdv = parcelRequire("aqmdv");


var $gkIGp = parcelRequire("gkIGp");


var $dXtsl = parcelRequire("dXtsl");


var $VrbPk = parcelRequire("VrbPk");


var $5RpEJ = parcelRequire("5RpEJ");


var $t7fjf = parcelRequire("t7fjf");


var $56fCt = parcelRequire("56fCt");


var $6FfWx = parcelRequire("6FfWx");


var $8rd8W = parcelRequire("8rd8W");


var $4jrCy = parcelRequire("4jrCy");


var $h8c6r = parcelRequire("h8c6r");

const $79c0c39119cb5480$var$styles = {
    fullWidthSubmitButton: "_3138425zaO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $79c0c39119cb5480$var$baseRootContainerStyles = null;
const $79c0c39119cb5480$var$formFooterMargin = null;
const $79c0c39119cb5480$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root',
    linkPicker: 'link-picker',
    urlInputField: 'link-url',
    textInputField: 'link-text',
    ...(0, $6FfWx.testIds),
    ...(0, $5RpEJ.testIds),
    ...(0, $8rd8W.testIds)
};
const $79c0c39119cb5480$var$initState = {
    url: '',
    displayText: '',
    activeIndex: -1,
    selectedIndex: -1,
    invalidUrl: false,
    activeTab: 0,
    preventHidingRecents: false,
    hasPreview: true
};
function $79c0c39119cb5480$var$reducer(state, payload) {
    if (payload.url && state.url !== payload.url) return {
        ...state,
        invalidUrl: false,
        hasPreview: true,
        selectedIndex: (0, $1F2YI.isSafeUrl)(payload.url) && payload.url.length ? -1 : state.selectedIndex,
        ...payload
    };
    return {
        ...state,
        ...payload
    };
} /**
   * Bind input fields to analytics tracking
   */ 
const $79c0c39119cb5480$var$getLinkFieldContent = (value)=>{
    if (!Boolean(value)) return null;
    return (0, $1F2YI.isSafeUrl)(value) ? 'url' : 'text_string';
};
const $79c0c39119cb5480$var$LinkInputField = (0, $8KzzK.withInputFieldTracking)((0, $8rd8W.TextInput), 'link', (event, attributes)=>({
        ...attributes,
        linkFieldContent: $79c0c39119cb5480$var$getLinkFieldContent(event.currentTarget.value)
    }));
const $79c0c39119cb5480$var$DisplayTextInputField = (0, $8KzzK.withInputFieldTracking)((0, $8rd8W.TextInput), 'displayText');
const $79c0c39119cb5480$var$client = new (0, $4yccB.default)();
const $79c0c39119cb5480$export$901b688e8da62820 = (0, $bd5hf.withLinkPickerAnalyticsContext)(/*#__PURE__*/ (0, $cozmU.memo)(({ onSubmit: onSubmit, onCancel: onCancel, onContentResize: onContentResize, plugins: plugins, isLoadingPlugins: isLoadingPlugins, url: initUrl, displayText: initDisplayText, hideDisplayText: hideDisplayText, featureFlags: featureFlags, customMessages: customMessages, isSubmitting: isSubmitting = false, adaptiveHeight: adaptiveHeight = false, moveSubmitButton: moveSubmitButton = false, inputRef: inputRef, previewableLinksOnly: previewableLinksOnly = false, additionalError: additionalError, submitOnInputChange: submitOnInputChange = false, recentSearchListSize: recentSearchListSize, shouldRenderNoResultsImage: shouldRenderNoResultsImage, alwaysShowTabs: alwaysShowTabs, disableManualUrlInsert: disableManualUrlInsertProp = false })=>{
    const disableManualUrlInsert = (0, $iDrrr.fg)('add-disable-manual-url-capability-technical') && disableManualUrlInsertProp;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const mergedRefs = (0, $2VwyL.useMergeRefs)(inputRef ? [
        linkInputRef,
        inputRef
    ] : [
        linkInputRef
    ]);
    const [state, dispatch] = (0, $cozmU.useReducer)($79c0c39119cb5480$var$reducer, {
        ...$79c0c39119cb5480$var$initState,
        url: (0, $1F2YI.normalizeUrl)(initUrl) || '',
        displayText: initDisplayText || ''
    });
    const { activeIndex: activeIndex, selectedIndex: selectedIndex, url: url, displayText: displayText, invalidUrl: invalidUrl, activeTab: activeTab, hasPreview: hasPreview } = state;
    const intl = (0, $kSwu1.useIntl)();
    const queryState = (0, $gkIGp.useSearchQuery)(state);
    const { items: items, isLoading: isLoadingResults, isActivePlugin: isActivePlugin, activePlugin: activePlugin, tabs: tabs, error: error, retry: retry, pluginAction: pluginAction } = (0, $aqmdv.usePlugins)(queryState, activeTab, plugins, recentSearchListSize, alwaysShowTabs);
    const isEditing = !!initUrl;
    const selectedItem = items?.[selectedIndex];
    const isSelectedItem = selectedItem?.url === url;
    const { trackAttribute: trackAttribute, getAttributes: getAttributes } = (0, $bd5hf.useLinkPickerAnalytics)(); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const submitMessageId = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))(), []);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (onContentResize) onContentResize();
    }, [
        onContentResize,
        items,
        isLoadingResults,
        isActivePlugin,
        tabs
    ]);
    const handleChangeUrl = (0, $cozmU.useCallback)((e)=>{
        if (isSubmitting) // Prevent changing url while submitting
        return;
         /** Any on change event is triggered by manual input or paste, so source is null */ 
        trackAttribute('linkFieldContentInputSource', null);
        dispatch({
            url: e.currentTarget.value,
            // If the last action was changing tabs, make sure we're now allowing recents to be hidden
            preventHidingRecents: false
        });
    }, [
        dispatch,
        trackAttribute,
        isSubmitting
    ]);
    const handleChangeText = (0, $cozmU.useCallback)((e_0)=>{
        dispatch({
            displayText: e_0.currentTarget.value
        });
    }, [
        dispatch
    ]);
    const handleClear = (0, $cozmU.useCallback)((field)=>{
        dispatch({
            activeIndex: -1,
            selectedIndex: -1,
            [field]: '',
            hasPreview: true
        });
    }, [
        dispatch
    ]);
    const handleUrlClear = (0, $cozmU.useCallback)(()=>{
        if (isSubmitting) // Prevent clearing url while submitting
        return;
        trackAttribute('linkFieldContentInputSource', null);
        handleClear('url');
    }, [
        trackAttribute,
        handleClear,
        isSubmitting
    ]);
    const handleInsert = (0, $cozmU.useCallback)((url_0, title, inputType, data)=>{
        const event = createAnalyticsEvent((0, $779pE.default)('ui.form.submitted.linkPicker', {})); // Clone the event so that it can be emitted for consumer usage
        // This must happen BEFORE the original event is fired!
        const consumerEvent = event.clone(); // Cloned event doesnt have the attributes that are added by
        // the analytics listener in the LinkPickerAnalyticsContext, add them here
        consumerEvent?.update({
            attributes: getAttributes()
        }); // Dispatch the original event to our channel
        event.fire((0, $kJo8F.ANALYTICS_CHANNEL));
        onSubmit({
            url: url_0,
            displayText: displayText || null,
            title: title || null,
            meta: {
                inputMethod: inputType
            },
            data: data,
            ...inputType === 'manual' ? {
                rawUrl: state.url
            } : {}
        }, consumerEvent);
    }, [
        displayText,
        onSubmit,
        state.url,
        createAnalyticsEvent,
        getAttributes
    ]);
    const handleSelected = (0, $cozmU.useCallback)((objectId)=>{
        if (isSubmitting) // Prevent changing selection while submitting
        return;
        const selectedItem_0 = items?.find((item)=>item.objectId === objectId);
        if (selectedItem_0) {
            const { url: url_1, name: name } = selectedItem_0; /**
                           * Manually track that the url has been updated using searchResult method
                           */ 
            dispatchEvent(new Event('submit'));
            trackAttribute('linkFieldContent', $79c0c39119cb5480$var$getLinkFieldContent(url_1));
            trackAttribute('linkFieldContentInputMethod', 'searchResult');
            trackAttribute('linkFieldContentInputSource', (0, $h8c6r.getDataSource)(selectedItem_0, activePlugin));
            handleInsert(url_1, name, 'typeAhead', {
                ...selectedItem_0
            });
        }
    }, [
        handleInsert,
        trackAttribute,
        items,
        activePlugin,
        isSubmitting
    ]);
    const handleClearInvalidUrl = (0, $cozmU.useCallback)(()=>{
        dispatch({
            invalidUrl: false
        });
    }, [
        dispatch
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(async (event_0)=>{
        event_0?.preventDefault();
        if (isSubmitting) // Prevent submit while submitting
        return;
        if (isSelectedItem && selectedItem) return handleInsert(selectedItem.url, selectedItem.name, 'typeAhead');
        const normalized = (0, $1F2YI.normalizeUrl)(url);
        if (normalized) {
            if (previewableLinksOnly) try {
                const urlResponse = await $79c0c39119cb5480$var$client.fetchData(normalized);
                const responseObject = urlResponse?.data;
                if (responseObject && 'preview' in responseObject) return handleInsert(normalized, null, 'manual');
                else return dispatch({
                    invalidUrl: true,
                    hasPreview: false
                });
            } catch  {
                return dispatch({
                    invalidUrl: true
                });
            }
            else return handleInsert(normalized, null, 'manual');
        }
        linkInputRef.current?.focus();
        return dispatch({
            invalidUrl: true
        });
    }, [
        dispatch,
        handleInsert,
        isSelectedItem,
        selectedItem,
        url,
        isSubmitting,
        previewableLinksOnly
    ]);
    const handleTabChange = (0, $cozmU.useCallback)((activeTab_0)=>{
        dispatch({
            // We don't want any selection to exist after changing tab, as the selection
            // wouldn't mean anything.
            activeIndex: -1,
            selectedIndex: -1,
            // We don't want recents to be hidden, even though we don't have a selection
            preventHidingRecents: true,
            invalidUrl: false,
            hasPreview: true,
            activeTab: activeTab_0
        });
        trackAttribute('tab', plugins?.[activeTab_0]?.tabKey ?? null);
    }, [
        dispatch,
        plugins,
        trackAttribute
    ]);
    const handleSearchListOnChange = (id)=>{
        if (isSubmitting) // Prevent changing item while submitting
        return;
        const index = items?.findIndex((item_0)=>item_0.objectId === id);
        if (typeof index === 'number') {
            const item_1 = items?.[index];
            if (item_1) {
                /**
         * Manually track that the url has been updated using searchResult method
         */ trackAttribute('linkFieldContent', $79c0c39119cb5480$var$getLinkFieldContent(item_1.url));
                trackAttribute('linkFieldContentInputMethod', 'searchResult');
                trackAttribute('linkFieldContentInputSource', (0, $h8c6r.getDataSource)(item_1, activePlugin));
                dispatch({
                    activeIndex: index,
                    selectedIndex: index,
                    url: item_1.url,
                    invalidUrl: false,
                    hasPreview: true
                });
            }
        }
    };
    const handleKeyDown = (0, $cozmU.useCallback)((event_1)=>{
        if (!items?.length) return;
        let updatedIndex = activeIndex;
        if (event_1.key === 'Enter') {
            event_1.preventDefault();
            if (selectedItem) handleSelected(selectedItem.objectId);
            else // triggers validation error message
            handleSubmit();
        } else updatedIndex = (0, $5eMgQ.handleNavKeyDown)(event_1, items.length, activeIndex);
        const item_2 = items[updatedIndex];
        if ([
            'Enter',
            'ArrowDown',
            'ArrowUp',
            'Home',
            'End'
        ].includes(event_1.key) && item_2) {
            /**
       * Manually track that the url has been updated using searchResult method
       */ trackAttribute('linkFieldContent', $79c0c39119cb5480$var$getLinkFieldContent(item_2.url));
            trackAttribute('linkFieldContentInputMethod', 'searchResult');
            trackAttribute('linkFieldContentInputSource', (0, $h8c6r.getDataSource)(item_2, activePlugin));
            dispatch({
                activeIndex: updatedIndex,
                selectedIndex: updatedIndex,
                url: item_2.url,
                invalidUrl: false,
                hasPreview: true
            });
        }
    }, [
        items,
        activeIndex,
        selectedItem,
        handleSelected,
        handleSubmit,
        trackAttribute,
        activePlugin
    ]);
    const messages = isActivePlugin ? (0, $56fCt.searchMessages) : (0, $56fCt.linkMessages);
    const screenReaderDescriptionId = 'search-recent-links-field-description';
    const linkSearchListId = 'link-picker-search-list';
    const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
    const a11yList = isActivePlugin || isLoadingPlugins ? {
        role: 'combobox',
        // When a combobox popup is not visible, the element with role combobox has aria-expanded set to false
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded#combobox
        'aria-expanded': !!items?.length,
        'aria-autocomplete': 'list',
        'aria-controls': linkSearchListId,
        'aria-activedescendant': ariaActiveDescendant,
        'aria-describedby': screenReaderDescriptionId
    } : undefined; // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
    // as the Aria design pattern for combobox does not work in this case
    // for details: https://a11y-internal.atlassian.net/browse/AK-740
    const screenReaderText = (0, $a3Cph.browser)().safari && (0, $h8c6r.getScreenReaderText)(items ?? [], selectedIndex, intl);
    const customSubmitButtonLabel = customMessages?.submitButtonLabel ? customMessages.submitButtonLabel : undefined;
    const errorMessage = invalidUrl ? previewableLinksOnly && !hasPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $56fCt.formMessages).noEmbedAvailable,
        values: {
            a: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FCr1g.default), {
                    target: "_blank",
                    href: "https://support.atlassian.com/platform-experiences/docs/smart-links-from-jira-and-other-products/"
                }, chunk)
        }
    }) : intl.formatMessage((0, $56fCt.formMessages).linkInvalid) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
        "data-testid": $79c0c39119cb5480$export$800daf5fbbe96aff.linkPicker,
        onSubmitCapture: handleSubmit,
        noValidate: true,
        className: (0, $hekY6.default)([
            "_2Zuz6QpE59 _1ZnuxbOhNx _0Of8r2YYwB _1wydGWohXU _24h04i2Njc _3iDTPb61cj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4jrCy.TrackMount), null), submitOnInputChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VrbPk.default), {
        url: url,
        isSubmitting: isSubmitting,
        isSelectedItem: isSelectedItem,
        onSubmit: handleSubmit,
        onClearInvalidUrl: handleClearInvalidUrl
    }), isActivePlugin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, screenReaderText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dXtsl.Announcer), {
        ariaLive: "assertive",
        text: screenReaderText,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: screenReaderDescriptionId
    }, customMessages?.linkAriaLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), customMessages.linkAriaLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), messages.linkAriaLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($79c0c39119cb5480$var$LinkInputField, {
        name: "url",
        autoComplete: "off",
        testId: $79c0c39119cb5480$export$800daf5fbbe96aff.urlInputField,
        label: customMessages?.linkLabel ? intl.formatMessage(customMessages.linkLabel) : intl.formatMessage(messages.linkLabel),
        placeholder: customMessages?.linkPlaceholder ? intl.formatMessage(customMessages?.linkPlaceholder) : intl.formatMessage(messages.linkPlaceholder),
        value: url,
        autoFocus: true,
        clearLabel: intl.formatMessage((0, $56fCt.formMessages).clearLink),
        error: errorMessage || additionalError,
        spotlightTargetName: "link-picker-search-field-spotlight-target",
        "aria-readonly": isSubmitting,
        ...a11yList,
        onClear: handleUrlClear,
        onKeyDown: handleKeyDown,
        onChange: handleChangeUrl,
        inputRef: mergedRefs,
        isRequired: true
    }), !hideDisplayText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($79c0c39119cb5480$var$DisplayTextInputField, {
        autoComplete: "off",
        name: "displayText",
        testId: $79c0c39119cb5480$export$800daf5fbbe96aff.textInputField,
        value: displayText,
        label: customMessages?.linkTextLabel ? intl.formatMessage(customMessages.linkTextLabel) : intl.formatMessage((0, $56fCt.linkTextMessages).linkTextLabel),
        placeholder: customMessages?.linkTextPlaceholder ? intl.formatMessage(customMessages?.linkTextPlaceholder) : intl.formatMessage((0, $56fCt.linkTextMessages).linkTextPlaceholder),
        clearLabel: intl.formatMessage((0, $56fCt.linkTextMessages).clearLinkText),
        readOnly: isSubmitting,
        onClear: handleClear,
        onChange: handleChangeText,
        helperMessage: intl.formatMessage(customMessages?.linkHelperTextLabel ?? (0, $56fCt.linkTextMessages).linkHelperTextLabel)
    })), moveSubmitButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79c0c39119cb5480$var$styles.fullWidthSubmitButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $t7fjf.LinkPickerSubmitButton), {
        isEditing: isEditing,
        isLoading: isLoadingResults || !!isLoadingPlugins,
        isSubmitting: isSubmitting,
        customSubmitButtonLabel: customSubmitButtonLabel,
        error: error,
        items: items,
        queryState: queryState,
        submitMessageId: submitMessageId,
        testId: $79c0c39119cb5480$export$800daf5fbbe96aff.insertButton,
        url: url,
        disableManualUrlInsert: disableManualUrlInsert
    })), !!queryState && (isLoadingPlugins || isActivePlugin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfWx.SearchResults), {
        activeTab: activeTab,
        tabs: tabs,
        activePlugin: activePlugin,
        isLoadingResults: isLoadingResults,
        isLoadingPlugins: isLoadingPlugins,
        isSubmitting: isSubmitting,
        linkSearchListId: linkSearchListId,
        error: error,
        featureFlags: featureFlags,
        activeIndex: activeIndex,
        selectedIndex: selectedIndex,
        items: items,
        queryState: queryState,
        handleKeyDown: handleKeyDown,
        handleSelected: handleSelected,
        handleTabChange: handleTabChange,
        handleSearchListOnChange: handleSearchListOnChange,
        adaptiveHeight: adaptiveHeight,
        retry: retry,
        shouldRenderNoResultsImage: shouldRenderNoResultsImage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RpEJ.FormFooter), {
        error: error,
        items: items,
        isLoading: isLoadingResults || !!isLoadingPlugins,
        isSubmitting: isSubmitting,
        queryState: queryState,
        url: url,
        isEditing: isEditing,
        onCancel: onCancel,
        action: pluginAction,
        customSubmitButtonLabel: customSubmitButtonLabel,
        submitMessageId: submitMessageId,
        hideSubmitButton: moveSubmitButton || submitOnInputChange,
        disableManualUrlInsert: disableManualUrlInsert,
        className: (0, $hekY6.default)([
            (!queryState || !plugins?.length) && "_3138425zaO"
        ])
    }));
}));
module.exports["LinkPicker"] = $79c0c39119cb5480$export$901b688e8da62820;

});

parcelRegister("bd5hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $1F2YI = parcelRequire("1F2YI");


var $kJo8F = parcelRequire("kJo8F");

const $07cde93b08de9c2e$var$DEFAULT_CONTEXT_ATTRIBUTES = {
    linkState: 'newLink',
    linkFieldContent: null,
    linkFieldContentInputMethod: null,
    linkFieldContentInputSource: null,
    displayTextFieldContent: null,
    displayTextFieldContentInputMethod: null,
    tab: null
};
const $07cde93b08de9c2e$var$LinkPickerAnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    trackAttribute: ()=>{},
    trackAttributes: ()=>{},
    getAttributes: ()=>$07cde93b08de9c2e$var$DEFAULT_CONTEXT_ATTRIBUTES
});
/**
 * TODO: Should we hook this into the form state/reducer?
 * This function continues to duplicate / assume logic that runs in the picker
 */ const $07cde93b08de9c2e$var$contextAttributesFromIntialProps = (props)=>{
    return {
        linkState: (0, $1F2YI.normalizeUrl)(props.url) ? 'editLink' : 'newLink',
        linkFieldContent: (0, $1F2YI.normalizeUrl)(props.url) ? 'url' : null,
        displayTextFieldContent: Boolean(props.displayText) ? 'text_string' : null,
        // TODO: Assumes we alway load the first plugin as the current tab
        tab: props.plugins?.[0]?.tabKey ?? null
    };
};
/**
 * Context for tracking attributes to deliver at a context-level
 */ const $07cde93b08de9c2e$var$LinkPickerAnalytics = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { initialContext: initialContext, children: children } = t0;
    let t1;
    if ($[0] !== initialContext) {
        t1 = {
            ...$07cde93b08de9c2e$var$DEFAULT_CONTEXT_ATTRIBUTES,
            ...initialContext
        };
        $[0] = initialContext;
        $[1] = t1;
    } else t1 = $[1];
    const dataRef = (0, $cozmU.useRef)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            trackAttribute: (key, value)=>{
                dataRef.current[key] = value;
            },
            trackAttributes: (attributes)=>{
                dataRef.current = {
                    ...dataRef.current,
                    ...attributes
                };
            },
            getAttributes: ()=>dataRef.current
        };
        $[2] = t2;
    } else t2 = $[2];
    const methods = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07cde93b08de9c2e$var$LinkPickerAnalyticsContext.Provider, {
            value: methods
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ initialContext: initialContext, children: children })=>{
    const dataRef = (0, $cozmU.useRef)({
        ...$07cde93b08de9c2e$var$DEFAULT_CONTEXT_ATTRIBUTES,
        ...initialContext
    });
    const methods = (0, $cozmU.useMemo)(()=>({
            trackAttribute: (key, value)=>{
                dataRef.current[key] = value;
            },
            trackAttributes: (attributes)=>{
                dataRef.current = {
                    ...dataRef.current,
                    ...attributes
                };
            },
            getAttributes: ()=>dataRef.current
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07cde93b08de9c2e$var$LinkPickerAnalyticsContext.Provider, {
        value: methods
    }, children);
};
const $07cde93b08de9c2e$export$15407343803f36c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($07cde93b08de9c2e$var$LinkPickerAnalyticsContext);
} : ()=>(0, $cozmU.useContext)($07cde93b08de9c2e$var$LinkPickerAnalyticsContext);
/**
 * Wrap component in "attributes" context store and initialise the initial context attributes from props.
 */ function $07cde93b08de9c2e$var$withLinkPickerAnalytics(WrappedComponent) {
    return (props)=>{
        const [initialContext] = (0, $cozmU.useState)(()=>$07cde93b08de9c2e$var$contextAttributesFromIntialProps(props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07cde93b08de9c2e$var$LinkPickerAnalytics, {
            initialContext: initialContext,
            ...props
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
    };
}
function $07cde93b08de9c2e$export$13f45cdb81bd4384(WrappedComponent) {
    return $07cde93b08de9c2e$var$withLinkPickerAnalytics((props)=>{
        const { getAttributes: getAttributes } = $07cde93b08de9c2e$export$15407343803f36c();
        const onEvent = (0, $cozmU.useCallback)((event)=>{
            event.update({
                attributes: {
                    ...getAttributes(),
                    ...event.payload.attributes ?? {}
                }
            });
        }, [
            getAttributes
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: (0, $kJo8F.ANALYTICS_CHANNEL),
            onEvent: onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
    });
}
module.exports["useLinkPickerAnalytics"] = $07cde93b08de9c2e$export$15407343803f36c;
module.exports["withLinkPickerAnalyticsContext"] = $07cde93b08de9c2e$export$13f45cdb81bd4384;

});

parcelRegister("8KzzK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $779pE = parcelRequire("779pE");


var $kJo8F = parcelRequire("kJo8F");


var $bd5hf = parcelRequire("bd5hf");

const $36288ab94e653ae3$var$isEventWithInputType = (e)=>{
    return typeof e === 'object' && e !== null && 'inputType' in e;
};
const $36288ab94e653ae3$var$getChangeEventInputMethodType = (event)=>{
    if ($36288ab94e653ae3$var$isEventWithInputType(event.nativeEvent) && typeof event.nativeEvent.inputType === 'string' && event.nativeEvent.inputType.includes('insertFromPaste')) return 'paste';
    return 'manual';
};
const $36288ab94e653ae3$export$493cbe8965becd2d = (WrappedComponent, field, filterOnChangeEventAttrs = (_, attributes)=>attributes)=>{
    return (props)=>{
        const { onBlur: onBlur, onChange: onChange, onClear: onClear, onFocus: onFocus } = props;
        const { trackAttribute: trackAttribute, trackAttributes: trackAttributes } = (0, $bd5hf.useLinkPickerAnalytics)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        // Ref to track if the value of the field has changed between focus and blur
        const valueOnFocus = (0, $cozmU.useRef)(null);
        // Track the content and input method on every direct change to the input
        const handleOnChange = (0, $cozmU.useCallback)((event)=>{
            // TODO: See above re template literal, improve typesafety here
            // trackAttribute(`${field}FieldContent`, contentTypeFn(event.currentTarget.value));
            // trackAttribute(`${field}FieldContentInputMethod`, methodTypeFn(event));
            trackAttributes(filterOnChangeEventAttrs(event, {
                [`${field}FieldContent`]: Boolean(event.currentTarget.value) ? 'text_string' : null,
                [`${field}FieldContentInputMethod`]: $36288ab94e653ae3$var$getChangeEventInputMethodType(event)
            }));
            onChange?.(event);
        }, [
            onChange,
            trackAttributes
        ]);
        // Store the value of the field at the time the field is focused so we can know if it changes when the user's focus leaves
        const handleOnFocus = (0, $cozmU.useCallback)((event)=>{
            valueOnFocus.current = event.currentTarget.value;
            onFocus?.(event);
        }, [
            onFocus
        ]);
        // Fire updated events only when the user's focus leaves the field
        const handleOnBlur = (0, $cozmU.useCallback)((event)=>{
            // Only fire if the value has changed since the field was focused (we are only concerned with the net change to the field)
            if (event.currentTarget.value !== valueOnFocus.current) createAnalyticsEvent((0, $779pE.default)(`ui.textField.updated.${field}Field`, {})).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            onBlur?.(event);
        }, [
            onBlur,
            createAnalyticsEvent
        ]);
        // Track the values as null when the text field is cleared
        const handleOnClear = (0, $cozmU.useCallback)((...args)=>{
            trackAttribute(`${field}FieldContent`, null);
            trackAttribute(`${field}FieldContentInputMethod`, null);
            onClear?.(...args);
        }, [
            onClear,
            trackAttribute
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onClear: handleOnClear,
            onFocus: handleOnFocus
        });
    };
};
module.exports["withInputFieldTracking"] = $36288ab94e653ae3$export$493cbe8965becd2d;

});

parcelRegister("5eMgQ", function(module, exports) {
const $977f7b7fa701597a$export$6c8bbb3c4f84f876 = (event, itemsLength, activeIndex)=>{
    let updatedIndex = activeIndex;
    switch(event.key){
        case 'ArrowDown':
            event.preventDefault();
            updatedIndex = (activeIndex + 1) % itemsLength;
            break;
        case 'ArrowUp':
            event.preventDefault();
            updatedIndex = activeIndex > 0 ? activeIndex - 1 : itemsLength - 1;
            break;
        case 'Home':
            event.preventDefault();
            updatedIndex = 0;
            break;
        case 'End':
            event.preventDefault();
            updatedIndex = itemsLength - 1;
            break;
    }
    return updatedIndex;
};
module.exports["handleNavKeyDown"] = $977f7b7fa701597a$export$6c8bbb3c4f84f876;

});

parcelRegister("aqmdv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1HD0w = parcelRequire("1HD0w");


var $iDrrr = parcelRequire("iDrrr");


var $bd5hf = parcelRequire("bd5hf");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $9nQ8x = parcelRequire("9nQ8x");


var $h5CZ1 = parcelRequire("h5CZ1");

function $1d0b35a2ffd2f092$export$c41e96fd89bc6106(state, activeTab, plugins, recentSearchListSize, alwaysShowTabs) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [retries, setRetries] = (0, $cozmU.useState)(0);
    const [pluginState, dispatch] = (0, $9nQ8x.usePluginReducer)();
    const { trackAttribute: trackAttribute } = (0, $bd5hf.useLinkPickerAnalytics)();
    const activePlugin = plugins?.[activeTab];
    trackAttribute('tab', activePlugin?.tabKey ?? null);
    // This useEffect block must be called before any other to ensure onActivation is fired at before resolve
    (0, $cozmU.useEffect)(()=>{
        if (activePlugin && activePlugin.UNSAFE_onActivation) activePlugin.UNSAFE_onActivation();
    }, [
        activePlugin
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!activePlugin) return;
        if (!state) {
            dispatch({
                type: 'CLEAR'
            });
            return;
        }
        dispatch({
            type: 'LOADING'
        });
        const { next: next, cancel: cancel } = (0, $h5CZ1.resolvePluginUpdates)(activePlugin, state);
        const updateResults = async ()=>{
            try {
                let isLoading = true;
                while(isLoading){
                    const { value: value, done: done } = await next();
                    isLoading = !done;
                    dispatch({
                        type: 'SUCCESS',
                        payload: {
                            items: $1d0b35a2ffd2f092$var$limit(value.data, (0, $iDrrr.fg)('aifc_create_enabled') ? recentSearchListSize : undefined),
                            isLoading: !done
                        }
                    });
                }
            } catch (error) {
                if (!(error instanceof (0, $h5CZ1.CancellationError))) {
                    dispatch({
                        type: 'ERROR',
                        payload: error
                    });
                    createAnalyticsEvent((0, $779pE.default)('operational.resultsResolve.failed', {
                        error: (0, $1HD0w.default)(error).toString()
                    })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
                }
            }
        };
        updateResults();
        return cancel;
    }, [
        activePlugin,
        state,
        retries,
        createAnalyticsEvent,
        dispatch,
        recentSearchListSize
    ]);
    const tabs = (0, $cozmU.useMemo)(()=>{
        if (!plugins || !alwaysShowTabs && plugins.length <= 1) return [];
        return plugins.filter((plugin)=>!!plugin.tabTitle).map((plugin_0)=>({
                tabTitle: plugin_0.tabTitle
            }));
    }, [
        plugins,
        alwaysShowTabs
    ]);
    const handleRetry = (0, $cozmU.useCallback)(()=>{
        setRetries((prev)=>++prev);
    }, []);
    const { items: items, isLoading: isLoading_0, error: error_0 } = pluginState;
    return {
        tabs: tabs,
        items: items,
        isLoading: isLoading_0,
        activePlugin: activePlugin,
        isActivePlugin: !!activePlugin,
        error: error_0,
        retry: handleRetry,
        errorFallback: activePlugin?.errorFallback,
        pluginAction: activePlugin?.action
    };
}
function $1d0b35a2ffd2f092$var$limit(items, recentSearchListSize = (0, $kJo8F.RECENT_SEARCH_LIST_SIZE)) {
    return items.slice(0, recentSearchListSize);
}
module.exports["usePlugins"] = $1d0b35a2ffd2f092$export$c41e96fd89bc6106;

});

parcelRegister("1HD0w", function(module, exports) {
const $13c736d6b866110a$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $13c736d6b866110a$export$2e2bcd8739ae039 = $13c736d6b866110a$var$convertToError;
module.exports["default"] = $13c736d6b866110a$export$2e2bcd8739ae039;

});

parcelRegister("9nQ8x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $92395f25a93830b2$export$d80b4deb39f4a4a1 = 'CLEAR';
const $92395f25a93830b2$export$f1146e148fe924c8 = 'LOADING';
const $92395f25a93830b2$export$cee65e9a71e7c6c2 = 'SUCCESS';
const $92395f25a93830b2$export$425634cce7676b34 = 'ERROR';
const $92395f25a93830b2$export$36d128238e6b60f5 = {
    items: null,
    error: null,
    isLoading: false
};
function $92395f25a93830b2$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case $92395f25a93830b2$export$d80b4deb39f4a4a1:
            return {
                ...$92395f25a93830b2$export$36d128238e6b60f5
            };
        case $92395f25a93830b2$export$f1146e148fe924c8:
            return {
                ...$92395f25a93830b2$export$36d128238e6b60f5,
                isLoading: true
            };
        case $92395f25a93830b2$export$cee65e9a71e7c6c2:
            return {
                ...state,
                ...action.payload,
                error: null
            };
        case $92395f25a93830b2$export$425634cce7676b34:
            return {
                ...$92395f25a93830b2$export$36d128238e6b60f5,
                error: action.payload
            };
        default:
            return state;
    }
}
const $92395f25a93830b2$export$d2118aa240a45264 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useReducer)($92395f25a93830b2$export$1650419e431d3ba3, $92395f25a93830b2$export$36d128238e6b60f5);
} : ()=>(0, $cozmU.useReducer)($92395f25a93830b2$export$1650419e431d3ba3, $92395f25a93830b2$export$36d128238e6b60f5);
module.exports["usePluginReducer"] = $92395f25a93830b2$export$d2118aa240a45264;

});

parcelRegister("h5CZ1", function(module, exports) {
class $1a0a7144210fedb2$export$63884d8ee23c8f42 extends Error {
}
const $1a0a7144210fedb2$export$6f8f74cdc4a691c1 = (promise)=>{
    let reject;
    return {
        promise: new Promise((resolve, _reject)=>{
            reject = _reject;
            promise.then(resolve, reject);
        }),
        cancel: ()=>{
            reject(new $1a0a7144210fedb2$export$63884d8ee23c8f42('Promise cancelled'));
        }
    };
};
const $1a0a7144210fedb2$export$e4aab3e7990eda97 = (plugin, state)=>{
    const updates = plugin.resolve(state);
    // Promise plugin
    if (updates instanceof Promise) {
        const { promise: promise, cancel: cancel } = $1a0a7144210fedb2$export$6f8f74cdc4a691c1(updates);
        return {
            cancel: cancel,
            next: async ()=>({
                    value: await promise,
                    done: true
                })
        };
    }
    // Generator plugin
    const cancellationCallbacks = [];
    let cancelled = false;
    return {
        cancel: ()=>{
            cancelled = true;
            cancellationCallbacks.forEach((cb)=>cb());
        },
        next: ()=>{
            const { promise: promise, cancel: cancel } = $1a0a7144210fedb2$export$6f8f74cdc4a691c1(updates.next());
            if (cancelled) cancel();
            else cancellationCallbacks.push(cancel);
            return promise;
        }
    };
};
module.exports["CancellationError"] = $1a0a7144210fedb2$export$63884d8ee23c8f42;
module.exports["resolvePluginUpdates"] = $1a0a7144210fedb2$export$e4aab3e7990eda97;

});

parcelRegister("gkIGp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1F2YI = parcelRequire("1F2YI");

function $fe9d1cc38ebb7079$export$e985158d10c27e34(state) {
    const queryState = (0, $cozmU.useRef)(null);
    /*
   * When state contains a valid url AND is NOT selected from results, and the url was updated
   * from the textbox, queryState should be null to clear the items in plugin state.
   *
   * Checking `lastEditedBy` prevents the items being cleared when the tab is changed.
   */ if ((0, $1F2YI.isSafeUrl)(state.url) && state.selectedIndex === -1 && !state.preventHidingRecents) queryState.current = null;
    /*
   * When state contains a search term e.g. Not a valid url return a query
   */ if (queryState.current?.query !== state.url && !(0, $1F2YI.isSafeUrl)(state.url)) queryState.current = {
        query: state.url
    };
    /*
   * When state contains a valid url and is selected from the list
   * return current state to prevent triger a new plugin search
   */ return queryState.current;
}
module.exports["useSearchQuery"] = $fe9d1cc38ebb7079$export$e985158d10c27e34;

});

parcelRegister("dXtsl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $ef023bf308bb31f2$var$timer;
const $ef023bf308bb31f2$export$356577adb5b194fa = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(15);
    const { ariaAtomic: t1, ariaLive: t2, ariaRelevant: t3, role: t4, text: t5, delay: t6 } = t0;
    const ariaAtomic = t1 === undefined ? "true" : t1;
    const ariaLive = t2 === undefined ? "polite" : t2;
    const ariaRelevant = t3 === undefined ? "all" : t3;
    const role = t4 === undefined ? "status" : t4;
    const text = t5 === undefined ? "" : t5;
    const delay = t6 === undefined ? 0 : t6;
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    let t7;
    if ($[0] !== delay) {
        t7 = ()=>{
            clearTimeout($ef023bf308bb31f2$var$timer);
            setContentRendered(false);
            $ef023bf308bb31f2$var$timer = setTimeout(()=>{
                setContentRendered(true);
            }, delay);
            return $ef023bf308bb31f2$var$_temp;
        };
        $[0] = delay;
        $[1] = t7;
    } else t7 = $[1];
    let t8;
    if ($[2] !== delay || $[3] !== text) {
        t8 = [
            text,
            delay
        ];
        $[2] = delay;
        $[3] = text;
        $[4] = t8;
    } else t8 = $[4];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[5] !== contentRendered || $[6] !== text) {
        t9 = contentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, text);
        $[5] = contentRendered;
        $[6] = text;
        $[7] = t9;
    } else t9 = $[7];
    let t10;
    if ($[8] !== ariaAtomic || $[9] !== ariaLive || $[10] !== ariaRelevant || $[11] !== ref || $[12] !== role || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: "assistive",
            ref: ref,
            role: role,
            "aria-atomic": ariaAtomic,
            "aria-relevant": ariaRelevant,
            "aria-live": ariaLive
        }, t9);
        $[8] = ariaAtomic;
        $[9] = ariaLive;
        $[10] = ariaRelevant;
        $[11] = ref;
        $[12] = role;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    return t10;
} : ({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        clearTimeout($ef023bf308bb31f2$var$timer);
        setContentRendered(false);
        $ef023bf308bb31f2$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($ef023bf308bb31f2$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive
    }, contentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, text));
}));
function $ef023bf308bb31f2$var$_temp() {
    return clearTimeout($ef023bf308bb31f2$var$timer);
}
module.exports["Announcer"] = $ef023bf308bb31f2$export$356577adb5b194fa;

});

parcelRegister("VrbPk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jXPru = parcelRequire("jXPru");


var $1F2YI = parcelRequire("1F2YI");

const $0a86258640efd624$var$AutoSubmitOnChange = ({ url: url, isSubmitting: isSubmitting, isSelectedItem: isSelectedItem, onSubmit: onSubmit, onClearInvalidUrl: onClearInvalidUrl })=>{
    // Debounce the URL to avoid rapid successive submissions during typing
    const [debouncedUrl] = (0, $jXPru.default)(url, 300);
    const isBlank = url === '';
    // Auto-submit when URL changes
    (0, $cozmU.useEffect)(()=>{
        //prevents misalignment between url and debounced url when clear button is clicked
        if (isBlank) {
            onClearInvalidUrl();
            return;
        }
        // Only auto-submit if debouncedUrl is not empty and not already submitting
        if (debouncedUrl.trim() && !isSubmitting && !isSelectedItem) {
            const normalized = (0, $1F2YI.normalizeUrl)(debouncedUrl);
            if (normalized) onSubmit();
        }
    //onSubmit() left out to prevent infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedUrl,
        isSubmitting,
        isSelectedItem,
        onClearInvalidUrl,
        isBlank
    ]);
    // This component renders nothing
    return null;
};
var $0a86258640efd624$export$2e2bcd8739ae039 = $0a86258640efd624$var$AutoSubmitOnChange;
module.exports["default"] = $0a86258640efd624$export$2e2bcd8739ae039;

});

parcelRegister("5RpEJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7joZr = parcelRequire("7joZr");


var $ad7Ou = parcelRequire("ad7Ou");


var $gFEZF = parcelRequire("gFEZF");


var $9GVkD = parcelRequire("9GVkD");


var $5acUe = parcelRequire("5acUe");


var $t7fjf = parcelRequire("t7fjf");

const $0a516f023194146e$var$formFooterStyles = null;
const $0a516f023194146e$var$formFooterActionStyles = null;
const $0a516f023194146e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cancelButton: {
        id: "fabric.linkPicker.button.cancel",
        defaultMessage: "Cancel"
    },
    submittingStatusMessage: {
        id: "fabric.linkPicker.status.submitting",
        defaultMessage: "Submitting"
    }
});
const $0a516f023194146e$export$800daf5fbbe96aff = {
    insertButton: 'link-picker-insert-button',
    cancelButton: 'link-picker-cancel-button',
    actionButton: 'link-picker-action-button',
    submitStatusA11yIndicator: 'link-picker-submit-status-a11y-indicator'
};
const $0a516f023194146e$export$e7277fd05612133d = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    let action;
    let className;
    let customSubmitButtonLabel;
    let disableManualUrlInsert;
    let error;
    let hideSubmitButton;
    let isEditing;
    let isLoading;
    let items;
    let onCancel;
    let queryState;
    let restProps;
    let submitMessageId;
    let t1;
    let url;
    if ($[0] !== t0) {
        ({ isLoading: isLoading, isSubmitting: t1, error: error, url: url, queryState: queryState, items: items, isEditing: isEditing, onCancel: onCancel, action: action, customSubmitButtonLabel: customSubmitButtonLabel, submitMessageId: submitMessageId, hideSubmitButton: hideSubmitButton, disableManualUrlInsert: disableManualUrlInsert, className: className, ...restProps } = t0);
        $[0] = t0;
        $[1] = action;
        $[2] = className;
        $[3] = customSubmitButtonLabel;
        $[4] = disableManualUrlInsert;
        $[5] = error;
        $[6] = hideSubmitButton;
        $[7] = isEditing;
        $[8] = isLoading;
        $[9] = items;
        $[10] = onCancel;
        $[11] = queryState;
        $[12] = restProps;
        $[13] = submitMessageId;
        $[14] = t1;
        $[15] = url;
    } else {
        action = $[1];
        className = $[2];
        customSubmitButtonLabel = $[3];
        disableManualUrlInsert = $[4];
        error = $[5];
        hideSubmitButton = $[6];
        isEditing = $[7];
        isLoading = $[8];
        items = $[9];
        onCancel = $[10];
        queryState = $[11];
        restProps = $[12];
        submitMessageId = $[13];
        t1 = $[14];
        url = $[15];
    }
    const isSubmitting = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    if (error && error instanceof (0, $5acUe.UnauthenticatedError)) return null;
    let t2;
    if ($[16] !== intl || $[17] !== isSubmitting || $[18] !== submitMessageId) {
        t2 = (pluginAction)=>/*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                testId: $0a516f023194146e$export$800daf5fbbe96aff.actionButton,
                onClick: pluginAction.callback,
                appearance: "default",
                iconBefore: $0a516f023194146e$var$_temp,
                isDisabled: isSubmitting,
                "aria-labelledby": isSubmitting ? submitMessageId : undefined
            }, typeof pluginAction.label === "string" ? pluginAction.label : intl.formatMessage(pluginAction.label));
        $[16] = intl;
        $[17] = isSubmitting;
        $[18] = submitMessageId;
        $[19] = t2;
    } else t2 = $[19];
    const createButton = t2;
    let t3;
    if ($[20] !== className) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuz9WS _0Of8r25zaO",
            className
        ]);
        $[20] = className;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== intl || $[23] !== isSubmitting || $[24] !== submitMessageId) {
        t4 = isSubmitting && /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
            role: "status",
            id: submitMessageId,
            testId: $0a516f023194146e$export$800daf5fbbe96aff.submitStatusA11yIndicator
        }, intl.formatMessage($0a516f023194146e$export$defe85febe8b728c.submittingStatusMessage));
        $[22] = intl;
        $[23] = isSubmitting;
        $[24] = submitMessageId;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== action || $[27] !== createButton) {
        t5 = action && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_0adFHsIZbP"
            ])
        }, createButton(action));
        $[26] = action;
        $[27] = createButton;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== intl || $[30] !== isSubmitting || $[31] !== onCancel || $[32] !== submitMessageId) {
        t6 = onCancel && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onCancel,
            testId: $0a516f023194146e$export$800daf5fbbe96aff.cancelButton,
            isDisabled: isSubmitting,
            "aria-labelledby": isSubmitting ? submitMessageId : undefined
        }, intl.formatMessage($0a516f023194146e$export$defe85febe8b728c.cancelButton));
        $[29] = intl;
        $[30] = isSubmitting;
        $[31] = onCancel;
        $[32] = submitMessageId;
        $[33] = t6;
    } else t6 = $[33];
    let t7;
    if ($[34] !== customSubmitButtonLabel || $[35] !== disableManualUrlInsert || $[36] !== error || $[37] !== hideSubmitButton || $[38] !== isEditing || $[39] !== isLoading || $[40] !== isSubmitting || $[41] !== items || $[42] !== queryState || $[43] !== submitMessageId || $[44] !== url) {
        t7 = !hideSubmitButton && /*#__PURE__*/ $cozmU.createElement((0, $t7fjf.LinkPickerSubmitButton), {
            isEditing: isEditing,
            isLoading: isLoading,
            isSubmitting: isSubmitting,
            customSubmitButtonLabel: customSubmitButtonLabel,
            error: error,
            items: items,
            queryState: queryState,
            submitMessageId: submitMessageId,
            testId: $0a516f023194146e$export$800daf5fbbe96aff.insertButton,
            url: url,
            disableManualUrlInsert: disableManualUrlInsert
        });
        $[34] = customSubmitButtonLabel;
        $[35] = disableManualUrlInsert;
        $[36] = error;
        $[37] = hideSubmitButton;
        $[38] = isEditing;
        $[39] = isLoading;
        $[40] = isSubmitting;
        $[41] = items;
        $[42] = queryState;
        $[43] = submitMessageId;
        $[44] = url;
        $[45] = t7;
    } else t7 = $[45];
    let t8;
    if ($[46] !== t6 || $[47] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $7joZr.default), null, t6, t7);
        $[46] = t6;
        $[47] = t7;
        $[48] = t8;
    } else t8 = $[48];
    let t9;
    if ($[49] !== restProps || $[50] !== t3 || $[51] !== t4 || $[52] !== t5 || $[53] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("footer", {
            className: t3,
            ...restProps
        }, t4, t5, t8);
        $[49] = restProps;
        $[50] = t3;
        $[51] = t4;
        $[52] = t5;
        $[53] = t8;
        $[54] = t9;
    } else t9 = $[54];
    return t9;
} : ({ isLoading: isLoading, isSubmitting: isSubmitting = false, error: error, url: url, queryState: queryState, items: items, isEditing: isEditing, onCancel: onCancel, action: action, customSubmitButtonLabel: customSubmitButtonLabel, submitMessageId: submitMessageId, hideSubmitButton: hideSubmitButton, disableManualUrlInsert: disableManualUrlInsert, className: className, ...restProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (error && error instanceof (0, $5acUe.UnauthenticatedError)) return null;
    const createButton = (pluginAction)=>/*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            testId: $0a516f023194146e$export$800daf5fbbe96aff.actionButton,
            onClick: pluginAction.callback,
            appearance: "default",
            iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: "",
                    color: "currentColor",
                    size: "small"
                }),
            isDisabled: isSubmitting,
            "aria-labelledby": isSubmitting ? submitMessageId : undefined
        }, typeof pluginAction.label === 'string' ? pluginAction.label : intl.formatMessage(pluginAction.label));
    return /*#__PURE__*/ $cozmU.createElement("footer" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuz9WS _0Of8r25zaO",
            className
        ]),
        ...restProps
    }, isSubmitting && /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
        role: "status",
        id: submitMessageId,
        testId: $0a516f023194146e$export$800daf5fbbe96aff.submitStatusA11yIndicator
    }, intl.formatMessage($0a516f023194146e$export$defe85febe8b728c.submittingStatusMessage)), action && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0adFHsIZbP"
        ])
    }, createButton(action)), /*#__PURE__*/ $cozmU.createElement((0, $7joZr.default), null, onCancel && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: $0a516f023194146e$export$800daf5fbbe96aff.cancelButton,
        isDisabled: isSubmitting,
        "aria-labelledby": isSubmitting ? submitMessageId : undefined
    }, intl.formatMessage($0a516f023194146e$export$defe85febe8b728c.cancelButton)), !hideSubmitButton && /*#__PURE__*/ $cozmU.createElement((0, $t7fjf.LinkPickerSubmitButton), {
        isEditing: isEditing,
        isLoading: isLoading,
        isSubmitting: isSubmitting,
        customSubmitButtonLabel: customSubmitButtonLabel,
        error: error,
        items: items,
        queryState: queryState,
        submitMessageId: submitMessageId,
        testId: $0a516f023194146e$export$800daf5fbbe96aff.insertButton,
        url: url,
        disableManualUrlInsert: disableManualUrlInsert
    })));
});
function $0a516f023194146e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        label: "",
        color: "currentColor",
        size: "small"
    });
}
module.exports["testIds"] = $0a516f023194146e$export$800daf5fbbe96aff;
module.exports["FormFooter"] = $0a516f023194146e$export$e7277fd05612133d;

});

parcelRegister("5acUe", function(module, exports) {
class $efdeee6e1693f682$export$c7e58b539e03d4b2 extends Error {
    constructor(iconUrl, authUrl, description){
        super('The user is not authenticated'), this.iconUrl = iconUrl, this.authUrl = authUrl, this.description = description;
    }
}
module.exports["UnauthenticatedError"] = $efdeee6e1693f682$export$c7e58b539e03d4b2;

});

parcelRegister("t7fjf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iDrrr = parcelRequire("iDrrr");


var $LcVwK = parcelRequire("LcVwK");

const $090edfa191bbb6e1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    saveButton: {
        id: "fabric.linkPicker.button.save",
        defaultMessage: "Save"
    },
    insertButton: {
        id: "fabric.linkPicker.button.insert",
        defaultMessage: "Insert"
    }
});
const $090edfa191bbb6e1$export$a05513b9b425948d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isEditing: isEditing, isLoading: isLoading, isSubmitting: isSubmitting, customSubmitButtonLabel: customSubmitButtonLabel, error: error, items: items, queryState: queryState, submitMessageId: submitMessageId, testId: testId, url: url, disableManualUrlInsert: disableManualUrlInsert } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const insertButtonMsg = isEditing ? $090edfa191bbb6e1$export$defe85febe8b728c.saveButton : $090edfa191bbb6e1$export$defe85febe8b728c.insertButton;
    const t1 = (0, $iDrrr.fg)("add-disable-manual-url-capability-technical") ? disableManualUrlInsert : undefined;
    let t2;
    if ($[0] !== error || $[1] !== isLoading || $[2] !== isSubmitting || $[3] !== items || $[4] !== queryState || $[5] !== t1 || $[6] !== url) {
        t2 = (0, $LcVwK.checkSubmitDisabled)(isLoading, isSubmitting, error, url, queryState, items, t1);
        $[0] = error;
        $[1] = isLoading;
        $[2] = isSubmitting;
        $[3] = items;
        $[4] = queryState;
        $[5] = t1;
        $[6] = url;
        $[7] = t2;
    } else t2 = $[7];
    const isSubmitDisabled = t2;
    const t3 = isSubmitting ? submitMessageId : undefined;
    let t4;
    if ($[8] !== customSubmitButtonLabel || $[9] !== insertButtonMsg || $[10] !== intl) {
        t4 = customSubmitButtonLabel ? intl.formatMessage(customSubmitButtonLabel) : intl.formatMessage(insertButtonMsg);
        $[8] = customSubmitButtonLabel;
        $[9] = insertButtonMsg;
        $[10] = intl;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isSubmitDisabled || $[13] !== isSubmitting || $[14] !== t3 || $[15] !== t4 || $[16] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "submit",
            appearance: "primary",
            testId: testId,
            isDisabled: isSubmitDisabled,
            "aria-labelledby": t3,
            isLoading: isSubmitting
        }, t4);
        $[12] = isSubmitDisabled;
        $[13] = isSubmitting;
        $[14] = t3;
        $[15] = t4;
        $[16] = testId;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ isEditing: isEditing, isLoading: isLoading, isSubmitting: isSubmitting, customSubmitButtonLabel: customSubmitButtonLabel, error: error, items: items, queryState: queryState, submitMessageId: submitMessageId, testId: testId, url: url, disableManualUrlInsert: disableManualUrlInsert })=>{
    const intl = (0, $kSwu1.useIntl)();
    const insertButtonMsg = isEditing ? $090edfa191bbb6e1$export$defe85febe8b728c.saveButton : $090edfa191bbb6e1$export$defe85febe8b728c.insertButton;
    const isSubmitDisabled = (0, $LcVwK.checkSubmitDisabled)(isLoading, isSubmitting, error, url, queryState, items, (0, $iDrrr.fg)('add-disable-manual-url-capability-technical') ? disableManualUrlInsert : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        type: "submit",
        appearance: "primary",
        testId: testId,
        isDisabled: isSubmitDisabled,
        "aria-labelledby": isSubmitting ? submitMessageId : undefined,
        isLoading: isSubmitting
    }, customSubmitButtonLabel ? intl.formatMessage(customSubmitButtonLabel) : intl.formatMessage(insertButtonMsg));
};
module.exports["LinkPickerSubmitButton"] = $090edfa191bbb6e1$export$a05513b9b425948d;

});

parcelRegister("LcVwK", function(module, exports) {

var $1F2YI = parcelRequire("1F2YI");


var $iDrrr = parcelRequire("iDrrr");

const $49dc6f354c92198f$export$3c2c41558ed676ed = (isLoading, isSubmitting, error, url, queryState, items, disableManualUrlInsert)=>{
    /*
   * Enable insert when search term is a valid url and it can be normalized
   * Need to explicitly enable it here otherwise next condition could meet
   *
   * This should effectively be the validation function for the form, ie if the form
   * could be submitted, then it should not be disabled
   */ if (isSubmitting) return true;
    if ((0, $iDrrr.fg)('add-disable-manual-url-capability-technical')) {
        /*
     * Check isLoading/error before disableManualUrlInsert so that stale items
     * from a previous search do not accidentally enable the button during an
     * in-flight request or an error state.
     */ if (isLoading || error) return true;
        /*
     * When disableManualUrlInsert is true, disable insert unless a result has been
     * selected from the list (i.e. items are present and queryState is set).
     * This prevents the user from manually typing a URL to bypass the restriction.
     */ if (disableManualUrlInsert) return !(queryState && items && items.length > 0);
    }
    /*
   * Enable insert when search term is a valid url and it can be normalized.
   * Need to explicitly enable it here otherwise next condition could meet.
   *
   * This should effectively be the validation function for the form, ie if the form
   * could be submitted, then it should not be disabled.
   */ if (url && (0, $1F2YI.normalizeUrl)(url)) return false;
    /*
   * Disable insert button when plugin returns no results,
   * but not if it is a valid url
   */ if (queryState && items?.length === 0) return true;
    /*
   * Disable insert button when plugin is loading or for any search error.
   * When the gate is on, this is already handled earlier in the function.
   */ if (!(0, $iDrrr.fg)('add-disable-manual-url-capability-technical') && (isLoading || error)) return true;
    return false;
};
module.exports["checkSubmitDisabled"] = $49dc6f354c92198f$export$3c2c41558ed676ed;

});

parcelRegister("56fCt", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $39b8cf1f2a85d83e$export$219f1e8ed9be6c42 = (0, $kSwu1.defineMessages)({
    linkLabel: {
        id: "fabric.linkPicker.search.linkLabel",
        defaultMessage: "Search or paste a link"
    },
    linkAriaLabel: {
        id: "fabric.linkPicker.search.linkAriaLabel",
        defaultMessage: "Suggestions will appear below as you type into the field"
    },
    linkPlaceholder: {
        id: "fabric.linkPicker.search.linkPlaceholder",
        defaultMessage: "Find recent links or paste a new link"
    }
});
const $39b8cf1f2a85d83e$export$4ce3884394d6d9 = (0, $kSwu1.defineMessages)({
    linkLabel: {
        id: "fabric.linkPicker.linkLabel",
        defaultMessage: "Link"
    },
    linkAriaLabel: {
        id: "fabric.linkPicker.linkAriaLabel",
        defaultMessage: "Type or paste a link into the field"
    },
    linkPlaceholder: {
        id: "fabric.linkPicker.linkPlaceholder",
        defaultMessage: "Paste a link"
    }
});
const $39b8cf1f2a85d83e$export$60faecfb75056413 = (0, $kSwu1.defineMessages)({
    linkInvalid: {
        id: "fabric.linkPicker.linkInvalid",
        defaultMessage: "Enter a valid URL."
    },
    clearLink: {
        id: "fabric.linkPicker.clearLink",
        defaultMessage: "Clear"
    },
    noEmbedAvailable: {
        id: "fabric.linkPicker.noEmbed",
        defaultMessage: "Embed view isn't supported for this link. <a>More about why some Smart Links don't display content.</a>"
    }
});
const $39b8cf1f2a85d83e$export$89b842e86ff57fca = (0, $kSwu1.defineMessages)({
    linkTextLabel: {
        id: "fabric.linkPicker.linkTextLabel",
        defaultMessage: "Display text (optional)"
    },
    linkTextAriaLabel: {
        id: "fabric.linkPicker.linkTextAriaLabel",
        defaultMessage: "Link display text"
    },
    linkTextPlaceholder: {
        id: "fabric.linkPicker.linkTextPlaceholder",
        defaultMessage: "Text to display"
    },
    clearLinkText: {
        id: "fabric.linkPicker.clearLinkText",
        defaultMessage: "Clear text"
    },
    linkHelperTextLabel: {
        id: "fabric.linkPicker.linkHelperTextLabel",
        defaultMessage: "Give this link a title or description"
    },
    linkHelperTextAriaLabel: {
        id: "fabric.linkPicker.linkHelperTextAriaLabel",
        defaultMessage: "Link display helper text"
    }
});
const $39b8cf1f2a85d83e$export$c9477bd8c8ba0419 = (0, $kSwu1.defineMessages)({
    updated: {
        id: "fabric.linkPicker.time.message.updated",
        defaultMessage: "Updated {time}"
    },
    viewed: {
        id: "fabric.linkPicker.time.message.viewed",
        defaultMessage: "Viewed {time}"
    }
});
module.exports["searchMessages"] = $39b8cf1f2a85d83e$export$219f1e8ed9be6c42;
module.exports["linkMessages"] = $39b8cf1f2a85d83e$export$4ce3884394d6d9;
module.exports["formMessages"] = $39b8cf1f2a85d83e$export$60faecfb75056413;
module.exports["linkTextMessages"] = $39b8cf1f2a85d83e$export$89b842e86ff57fca;
module.exports["timeMessages"] = $39b8cf1f2a85d83e$export$c9477bd8c8ba0419;

});

parcelRegister("6FfWx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $hMjUh = parcelRequire("hMjUh");

var $bxtKM = parcelRequire("bxtKM");

var $dkVNA = parcelRequire("dkVNA");


var $bYJ6O = parcelRequire("bYJ6O");


var $iNJWf = parcelRequire("iNJWf");


var $4L8R1 = parcelRequire("4L8R1");


var $5Djep = parcelRequire("5Djep");


var $1jyI6 = parcelRequire("1jyI6");

const $793cd343326581e3$var$styles = {
    tabsWrapper: "_3138428HPE"
};
const $793cd343326581e3$var$spinnerContainerStyles = null;
const $793cd343326581e3$export$800daf5fbbe96aff = {
    ...(0, $bYJ6O.testIds),
    ...(0, $iNJWf.testIds),
    tabsLoadingIndicator: 'link-picker.tabs-loading-indicator',
    tabList: 'link-picker-tabs',
    tabItem: 'link-picker-tab'
};
const $793cd343326581e3$export$aee53da69e9839be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { tabs: tabs, activeTab: activeTab, activePlugin: activePlugin, isLoadingPlugins: isLoadingPlugins, isLoadingResults: isLoadingResults, isSubmitting: isSubmitting, handleTabChange: handleTabChange, handleSearchListOnChange: handleSearchListOnChange, featureFlags: featureFlags, linkSearchListId: linkSearchListId, error: error, queryState: queryState, items: items, activeIndex: activeIndex, selectedIndex: selectedIndex, handleSelected: handleSelected, handleKeyDown: handleKeyDown, adaptiveHeight: adaptiveHeight, retry: retry, shouldRenderNoResultsImage: shouldRenderNoResultsImage } = t0;
    const isActivePlugin = !!activePlugin;
    let t1;
    if ($[0] !== tabs) {
        t1 = tabs.map($793cd343326581e3$var$_temp);
        $[0] = tabs;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const tabList = t2;
    let t3;
    if ($[4] !== activeTab || $[5] !== tabs.length) {
        t3 = (t4)=>{
            const { children: children } = t4;
            return !!tabs.length ? /*#__PURE__*/ $cozmU.createElement("div", {
                id: `${$793cd343326581e3$export$800daf5fbbe96aff.tabList}-${activeTab}-tab`
            }, children) : children;
        };
        $[4] = activeTab;
        $[5] = tabs.length;
        $[6] = t3;
    } else t3 = $[6];
    const ErrorWrapper = t3;
    const t4 = !!tabs.length || isLoadingPlugins;
    let t5;
    if ($[7] !== isLoadingPlugins || $[8] !== queryState) {
        t5 = isLoadingPlugins && !!queryState && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_4kiQYAljYU _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _4xdlr0DIqT _2O5Vij7dHp"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: $793cd343326581e3$export$800daf5fbbe96aff.tabsLoadingIndicator,
            interactionName: "link-picker-tabs-loading",
            size: "medium"
        }));
        $[7] = isLoadingPlugins;
        $[8] = queryState;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== ErrorWrapper || $[11] !== activeIndex || $[12] !== activePlugin || $[13] !== activeTab || $[14] !== adaptiveHeight || $[15] !== error || $[16] !== featureFlags?.scrollingTabs || $[17] !== handleKeyDown || $[18] !== handleSearchListOnChange || $[19] !== handleSelected || $[20] !== handleTabChange || $[21] !== isActivePlugin || $[22] !== isLoadingPlugins || $[23] !== isLoadingResults || $[24] !== isSubmitting || $[25] !== items || $[26] !== linkSearchListId || $[27] !== queryState || $[28] !== retry || $[29] !== selectedIndex || $[30] !== shouldRenderNoResultsImage || $[31] !== tabList || $[32] !== tabs.length) {
        t6 = !isLoadingPlugins && isActivePlugin && !!queryState && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, tabs.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $793cd343326581e3$var$styles.tabsWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
            id: $793cd343326581e3$export$800daf5fbbe96aff.tabList,
            testId: $793cd343326581e3$export$800daf5fbbe96aff.tabList,
            selected: activeTab,
            onChange: handleTabChange
        }, featureFlags?.scrollingTabs ? /*#__PURE__*/ $cozmU.createElement((0, $4L8R1.ScrollingTabList), null, tabList) : tabList), /*#__PURE__*/ $cozmU.createElement((0, $1jyI6.TrackTabViewed), {
            activePlugin: activePlugin
        })), !error && /*#__PURE__*/ $cozmU.createElement((0, $iNJWf.LinkSearchList), {
            id: linkSearchListId,
            role: "listbox",
            ariaReadOnly: isSubmitting,
            items: items,
            isLoading: isLoadingResults,
            selectedIndex: selectedIndex,
            activeIndex: activeIndex,
            onSelect: handleSelected,
            onChange: handleSearchListOnChange,
            onKeyDown: handleKeyDown,
            hasSearchTerm: !!queryState?.query.length,
            activePlugin: activePlugin,
            adaptiveHeight: adaptiveHeight,
            tabPanelId: `${$793cd343326581e3$export$800daf5fbbe96aff.tabList}-${activeTab}-tab`,
            shouldRenderNoResultsImage: shouldRenderNoResultsImage
        }), error ? activePlugin?.errorFallback?.(error, retry) ?? /*#__PURE__*/ $cozmU.createElement(ErrorWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $bYJ6O.LinkSearchError), {
            onRetry: retry
        })) : null);
        $[10] = ErrorWrapper;
        $[11] = activeIndex;
        $[12] = activePlugin;
        $[13] = activeTab;
        $[14] = adaptiveHeight;
        $[15] = error;
        $[16] = featureFlags?.scrollingTabs;
        $[17] = handleKeyDown;
        $[18] = handleSearchListOnChange;
        $[19] = handleSelected;
        $[20] = handleTabChange;
        $[21] = isActivePlugin;
        $[22] = isLoadingPlugins;
        $[23] = isLoadingResults;
        $[24] = isSubmitting;
        $[25] = items;
        $[26] = linkSearchListId;
        $[27] = queryState;
        $[28] = retry;
        $[29] = selectedIndex;
        $[30] = shouldRenderNoResultsImage;
        $[31] = tabList;
        $[32] = tabs.length;
        $[33] = t6;
    } else t6 = $[33];
    let t7;
    if ($[34] !== adaptiveHeight || $[35] !== isLoadingResults || $[36] !== t4 || $[37] !== t5 || $[38] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $5Djep.SearchResultsContainer), {
            hasTabs: t4,
            adaptiveHeight: adaptiveHeight,
            isLoadingResults: isLoadingResults
        }, t5, t6);
        $[34] = adaptiveHeight;
        $[35] = isLoadingResults;
        $[36] = t4;
        $[37] = t5;
        $[38] = t6;
        $[39] = t7;
    } else t7 = $[39];
    return t7;
} : ({ tabs: tabs, activeTab: activeTab, activePlugin: activePlugin, isLoadingPlugins: isLoadingPlugins, isLoadingResults: isLoadingResults, isSubmitting: isSubmitting, handleTabChange: handleTabChange, handleSearchListOnChange: handleSearchListOnChange, featureFlags: featureFlags, linkSearchListId: linkSearchListId, error: error, queryState: queryState, items: items, activeIndex: activeIndex, selectedIndex: selectedIndex, handleSelected: handleSelected, handleKeyDown: handleKeyDown, adaptiveHeight: adaptiveHeight, retry: retry, shouldRenderNoResultsImage: shouldRenderNoResultsImage })=>{
    const isActivePlugin = !!activePlugin;
    const tabList = /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, tabs.map((tab)=>/*#__PURE__*/ $cozmU.createElement((0, $bxtKM.default), {
            key: tab.tabTitle,
            testId: $793cd343326581e3$export$800daf5fbbe96aff.tabItem
        }, tab.tabTitle)));
    const ErrorWrapper = ({ children: children })=>!!tabs.length ? /*#__PURE__*/ $cozmU.createElement("div", {
            id: `${$793cd343326581e3$export$800daf5fbbe96aff.tabList}-${activeTab}-tab`
        }, children) : children;
    return /*#__PURE__*/ $cozmU.createElement((0, $5Djep.SearchResultsContainer), {
        hasTabs: !!tabs.length || isLoadingPlugins,
        adaptiveHeight: adaptiveHeight,
        isLoadingResults: isLoadingResults
    }, isLoadingPlugins && !!queryState && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4kiQYAljYU _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _4xdlr0DIqT _2O5Vij7dHp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: $793cd343326581e3$export$800daf5fbbe96aff.tabsLoadingIndicator,
        interactionName: "link-picker-tabs-loading",
        size: "medium"
    })), !isLoadingPlugins && isActivePlugin && !!queryState && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, tabs.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $793cd343326581e3$var$styles.tabsWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
        id: $793cd343326581e3$export$800daf5fbbe96aff.tabList,
        testId: $793cd343326581e3$export$800daf5fbbe96aff.tabList,
        selected: activeTab,
        onChange: handleTabChange
    }, featureFlags?.scrollingTabs ? /*#__PURE__*/ $cozmU.createElement((0, $4L8R1.ScrollingTabList), null, tabList) : tabList), /*#__PURE__*/ $cozmU.createElement((0, $1jyI6.TrackTabViewed), {
        activePlugin: activePlugin
    })), !error && /*#__PURE__*/ $cozmU.createElement((0, $iNJWf.LinkSearchList), {
        id: linkSearchListId,
        role: "listbox",
        ariaReadOnly: isSubmitting,
        items: items,
        isLoading: isLoadingResults,
        selectedIndex: selectedIndex,
        activeIndex: activeIndex,
        onSelect: handleSelected,
        onChange: handleSearchListOnChange,
        onKeyDown: handleKeyDown,
        hasSearchTerm: !!queryState?.query.length,
        activePlugin: activePlugin,
        adaptiveHeight: adaptiveHeight,
        tabPanelId: `${$793cd343326581e3$export$800daf5fbbe96aff.tabList}-${activeTab}-tab`,
        shouldRenderNoResultsImage: shouldRenderNoResultsImage
    }), error ? activePlugin?.errorFallback?.(error, retry) ?? /*#__PURE__*/ $cozmU.createElement(ErrorWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $bYJ6O.LinkSearchError), {
        onRetry: retry
    })) : null));
};
function $793cd343326581e3$var$_temp(tab) {
    return /*#__PURE__*/ $cozmU.createElement((0, $bxtKM.default), {
        key: tab.tabTitle,
        testId: $793cd343326581e3$export$800daf5fbbe96aff.tabItem
    }, tab.tabTitle);
}
module.exports["testIds"] = $793cd343326581e3$export$800daf5fbbe96aff;
module.exports["SearchResults"] = $793cd343326581e3$export$aee53da69e9839be;

});

parcelRegister("bYJ6O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jH9cM = parcelRequire("jH9cM");


var $ad7Ou = parcelRequire("ad7Ou");


var $i1t43 = parcelRequire("i1t43");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");

const $caa8d61047554e79$export$d763cac210faabff = 'https://support.atlassian.com/contact/';
const $caa8d61047554e79$export$ad6f8b23d496abfa = 'https://gcs.atlassian-us-gov-mod.net/servicedesk/customer/portals';
const $caa8d61047554e79$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchErrorHeader: {
        id: "fabric.linkPicker.search.error.heading",
        defaultMessage: "We\u2019re having trouble loading data."
    },
    searchErrorDescription: {
        id: "fabric.linkPicker.search.error.description",
        defaultMessage: "Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening."
    },
    searchErrorAction: {
        id: "fabric.linkPicker.search.error.retry",
        defaultMessage: "Refresh"
    }
});
const $caa8d61047554e79$export$800daf5fbbe96aff = {
    searchError: 'link-search-error'
};
const $caa8d61047554e79$export$a27962a79a9dfbfb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onRetry: onRetry } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($caa8d61047554e79$export$defe85febe8b728c.searchErrorHeader);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$caa8d61047554e79$export$defe85febe8b728c.searchErrorDescription,
            values: {
                a: $caa8d61047554e79$var$_temp
            }
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== onRetry) {
        t3 = onRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $caa8d61047554e79$export$defe85febe8b728c.searchErrorAction)) : null;
        $[3] = onRetry;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k3ncb.EmptyState), {
            testId: $caa8d61047554e79$export$800daf5fbbe96aff.searchError,
            header: t1,
            description: t2,
            action: t3,
            renderImage: $caa8d61047554e79$var$_temp2
        });
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ onRetry: onRetry })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k3ncb.EmptyState), {
        testId: $caa8d61047554e79$export$800daf5fbbe96aff.searchError,
        header: intl.formatMessage($caa8d61047554e79$export$defe85febe8b728c.searchErrorHeader),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$caa8d61047554e79$export$defe85febe8b728c.searchErrorDescription,
            values: {
                a: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: (0, $jH9cM.isFedRamp)() ? $caa8d61047554e79$export$ad6f8b23d496abfa : $caa8d61047554e79$export$d763cac210faabff,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, label)
            }
        }),
        action: onRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $caa8d61047554e79$export$defe85febe8b728c.searchErrorAction)) : null,
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bXDzR.GenericErrorSVG), null)
    });
};
function $caa8d61047554e79$var$_temp(label) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: (0, $jH9cM.isFedRamp)() ? $caa8d61047554e79$export$ad6f8b23d496abfa : $caa8d61047554e79$export$d763cac210faabff,
        target: "_blank",
        rel: "noopener noreferrer"
    }, label);
}
function $caa8d61047554e79$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["testIds"] = $caa8d61047554e79$export$800daf5fbbe96aff;
module.exports["LinkSearchError"] = $caa8d61047554e79$export$a27962a79a9dfbfb;

});

parcelRegister("iNJWf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $9GVkD = parcelRequire("9GVkD");


var $dOXsL = parcelRequire("dOXsL");


var $5eMgQ = parcelRequire("5eMgQ");


var $bRwbX = parcelRequire("bRwbX");


var $41Rsm = parcelRequire("41Rsm");


var $9dHkU = parcelRequire("9dHkU");

const $401fe0c2ed528c33$var$styles = {
    emptyStateNoResultsWrapper: "_4kiQYA5zaO"
};
const $401fe0c2ed528c33$var$listContainerStyles = null;
const $401fe0c2ed528c33$var$spinnerContainerStyles = null;
const $401fe0c2ed528c33$var$listStyles = null;
const $401fe0c2ed528c33$var$listTitleStyles = {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    marginBottom: "var(--ds-space-050, 4px)",
    color: "var(--ds-text-subtle, #505258)"
};
const $401fe0c2ed528c33$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    titleRecentlyViewedFormatted: {
        id: "fabric.linkPicker.listTitle.recentlyViewedFormatted",
        defaultMessage: "Recently viewed"
    },
    titleResults: {
        id: "fabric.linkPicker.listTitle.results",
        defaultMessage: "Results"
    },
    searchLinkResults: {
        id: "fabric.linkPicker.hyperlink.searchLinkResults",
        defaultMessage: "{count, plural, =0 {no results} one {# result} other {# results}} found"
    }
});
const $401fe0c2ed528c33$export$800daf5fbbe96aff = {
    ...(0, $bRwbX.testIds),
    ...(0, $41Rsm.testIds),
    resultListTitle: 'link-picker-list-title',
    searchResultList: 'link-search-list',
    searchResultLoadingIndicator: 'link-picker.results-loading-indicator',
    tabsLoadingIndicator: 'link-picker.tabs-loading-indicator'
};
const $401fe0c2ed528c33$export$b6c5ba19d54350b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(87);
    let activeIndex;
    let activePlugin;
    let adaptiveHeight;
    let ariaReadOnly;
    let className;
    let hasSearchTerm;
    let id;
    let isLoading;
    let items;
    let onChange;
    let onKeyDown;
    let onSelect;
    let restProps;
    let role;
    let selectedIndex;
    let shouldRenderNoResultsImage;
    let tabPanelId;
    if ($[0] !== t0) {
        ({ onChange: onChange, onSelect: onSelect, onKeyDown: onKeyDown, items: items, activeIndex: activeIndex, selectedIndex: selectedIndex, isLoading: isLoading, ariaReadOnly: ariaReadOnly, role: role, id: id, hasSearchTerm: hasSearchTerm, activePlugin: activePlugin, adaptiveHeight: adaptiveHeight, className: className, tabPanelId: tabPanelId, shouldRenderNoResultsImage: shouldRenderNoResultsImage, ...restProps } = t0);
        $[0] = t0;
        $[1] = activeIndex;
        $[2] = activePlugin;
        $[3] = adaptiveHeight;
        $[4] = ariaReadOnly;
        $[5] = className;
        $[6] = hasSearchTerm;
        $[7] = id;
        $[8] = isLoading;
        $[9] = items;
        $[10] = onChange;
        $[11] = onKeyDown;
        $[12] = onSelect;
        $[13] = restProps;
        $[14] = role;
        $[15] = selectedIndex;
        $[16] = shouldRenderNoResultsImage;
        $[17] = tabPanelId;
    } else {
        activeIndex = $[1];
        activePlugin = $[2];
        adaptiveHeight = $[3];
        ariaReadOnly = $[4];
        className = $[5];
        hasSearchTerm = $[6];
        id = $[7];
        isLoading = $[8];
        items = $[9];
        onChange = $[10];
        onKeyDown = $[11];
        onSelect = $[12];
        restProps = $[13];
        role = $[14];
        selectedIndex = $[15];
        shouldRenderNoResultsImage = $[16];
        tabPanelId = $[17];
    }
    let itemsContent;
    let loadingContent;
    const linkListTitle = hasSearchTerm ? $401fe0c2ed528c33$export$defe85febe8b728c.titleResults : $401fe0c2ed528c33$export$defe85febe8b728c.titleRecentlyViewedFormatted;
    (0, $9dHkU.useTrackResultsShown)(isLoading, items, hasSearchTerm);
    let t1;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[18] = t1;
    } else t1 = $[18];
    const itemRefs = (0, $cozmU.useRef)(t1);
    let t2;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (el, id_0)=>{
            if (el === null) delete itemRefs.current[id_0];
            else itemRefs.current[id_0] = el;
        };
        $[19] = t2;
    } else t2 = $[19];
    const itemRefCallback = t2;
    let t3;
    if ($[20] !== selectedIndex) {
        t3 = (index)=>{
            if (selectedIndex > -1) return selectedIndex === index ? 0 : -1;
            if (index === 0) return 0;
            return -1;
        };
        $[20] = selectedIndex;
        $[21] = t3;
    } else t3 = $[21];
    const getTabIndex = t3;
    let t4;
    if ($[22] !== activeIndex || $[23] !== items || $[24] !== onKeyDown) {
        t4 = (event)=>{
            let updatedIndex;
            if (onKeyDown) onKeyDown(event);
            if (!items?.length) return;
            updatedIndex = (0, $5eMgQ.handleNavKeyDown)(event, items.length, activeIndex);
            const item = items?.[updatedIndex];
            if ([
                "ArrowDown",
                "ArrowUp",
                "Home",
                "End"
            ].includes(event.key) && item) {
                if (itemRefs.current) itemRefs.current[item.objectId]?.focus();
            }
        };
        $[22] = activeIndex;
        $[23] = items;
        $[24] = onKeyDown;
        $[25] = t4;
    } else t4 = $[25];
    const handleKeyDown = t4;
    if (items?.length === 0) {
        if (!hasSearchTerm) {
            let t5;
            if ($[26] !== activePlugin) {
                t5 = activePlugin?.emptyStateNoResults?.();
                $[26] = activePlugin;
                $[27] = t5;
            } else t5 = $[27];
            const emptyState = t5;
            if (emptyState) {
                let t6;
                if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
                    t6 = (0, $hekY6.default)([
                        $401fe0c2ed528c33$var$styles.emptyStateNoResultsWrapper
                    ]);
                    $[28] = t6;
                } else t6 = $[28];
                let t7;
                if ($[29] !== emptyState || $[30] !== t6 || $[31] !== tabPanelId) {
                    t7 = /*#__PURE__*/ $cozmU.createElement("div", {
                        id: tabPanelId,
                        className: t6
                    }, emptyState);
                    $[29] = emptyState;
                    $[30] = t6;
                    $[31] = tabPanelId;
                    $[32] = t7;
                } else t7 = $[32];
                return t7;
            }
        }
        let t5;
        if ($[33] !== shouldRenderNoResultsImage) {
            t5 = /*#__PURE__*/ $cozmU.createElement((0, $bRwbX.NoResults), {
                shouldRenderImage: shouldRenderNoResultsImage
            });
            $[33] = shouldRenderNoResultsImage;
            $[34] = t5;
        } else t5 = $[34];
        let t6;
        if ($[35] !== t5 || $[36] !== tabPanelId) {
            t6 = /*#__PURE__*/ $cozmU.createElement("div", {
                id: tabPanelId
            }, t5);
            $[35] = t5;
            $[36] = tabPanelId;
            $[37] = t6;
        } else t6 = $[37];
        return t6;
    }
    const listItemNameMaxLines = activePlugin?.uiOptions?.listItemNameMaxLines;
    if (items && items.length > 0) {
        let t5;
        if ($[38] !== linkListTitle) {
            t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "h3",
                style: $401fe0c2ed528c33$var$listTitleStyles,
                id: $401fe0c2ed528c33$export$800daf5fbbe96aff.resultListTitle,
                testId: $401fe0c2ed528c33$export$800daf5fbbe96aff.resultListTitle
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), linkListTitle));
            $[38] = linkListTitle;
            $[39] = t5;
        } else t5 = $[39];
        let t6;
        if ($[40] !== hasSearchTerm || $[41] !== items.length) {
            t6 = hasSearchTerm && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                ...$401fe0c2ed528c33$export$defe85febe8b728c.searchLinkResults,
                values: {
                    count: items.length
                },
                "aria-live": "polite",
                "aria-atomic": "true"
            });
            $[40] = hasSearchTerm;
            $[41] = items.length;
            $[42] = t6;
        } else t6 = $[42];
        let t7;
        if ($[43] !== t6) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
                id: "fabric.smartcard.linkpicker.suggested.results"
            }, t6);
            $[43] = t6;
            $[44] = t7;
        } else t7 = $[44];
        let t8;
        if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = (0, $hekY6.default)([
                "_1LMyvKYbGa _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _313842Pgdg _1DCdHiPgdg _2XsHFMBXau _0adFHshxaA"
            ]);
            $[45] = t8;
        } else t8 = $[45];
        let t9;
        if ($[46] !== activeIndex || $[47] !== getTabIndex || $[48] !== handleKeyDown || $[49] !== items || $[50] !== listItemNameMaxLines || $[51] !== onChange || $[52] !== onSelect || $[53] !== selectedIndex) {
            let t10;
            if ($[55] !== activeIndex || $[56] !== getTabIndex || $[57] !== handleKeyDown || $[58] !== listItemNameMaxLines || $[59] !== onChange || $[60] !== onSelect || $[61] !== selectedIndex) {
                t10 = (item_0, index_0)=>/*#__PURE__*/ $cozmU.createElement((0, $41Rsm.LinkSearchListItem), {
                        id: `${$401fe0c2ed528c33$export$800daf5fbbe96aff.searchResultItem}-${index_0}`,
                        item: item_0,
                        selected: selectedIndex === index_0,
                        active: activeIndex === index_0,
                        onFocus: ()=>onChange(item_0.objectId),
                        onKeyDown: handleKeyDown,
                        onSelect: onSelect,
                        key: item_0.objectId,
                        tabIndex: getTabIndex(index_0),
                        ref: (el_0)=>itemRefCallback(el_0, item_0.objectId),
                        nameMaxLines: listItemNameMaxLines
                    });
                $[55] = activeIndex;
                $[56] = getTabIndex;
                $[57] = handleKeyDown;
                $[58] = listItemNameMaxLines;
                $[59] = onChange;
                $[60] = onSelect;
                $[61] = selectedIndex;
                $[62] = t10;
            } else t10 = $[62];
            t9 = items.map(t10);
            $[46] = activeIndex;
            $[47] = getTabIndex;
            $[48] = handleKeyDown;
            $[49] = items;
            $[50] = listItemNameMaxLines;
            $[51] = onChange;
            $[52] = onSelect;
            $[53] = selectedIndex;
            $[54] = t9;
        } else t9 = $[54];
        let t10;
        if ($[63] !== ariaReadOnly || $[64] !== id || $[65] !== role || $[66] !== t8 || $[67] !== t9) {
            t10 = /*#__PURE__*/ $cozmU.createElement("ul", {
                id: id,
                role: role,
                "aria-controls": "fabric.smartcard.linkpicker.suggested.results",
                "aria-labelledby": $401fe0c2ed528c33$export$800daf5fbbe96aff.resultListTitle,
                "aria-readonly": ariaReadOnly,
                "data-testid": $401fe0c2ed528c33$export$800daf5fbbe96aff.searchResultList,
                className: t8
            }, t9);
            $[63] = ariaReadOnly;
            $[64] = id;
            $[65] = role;
            $[66] = t8;
            $[67] = t9;
            $[68] = t10;
        } else t10 = $[68];
        let t11;
        if ($[69] !== t10 || $[70] !== t5 || $[71] !== t7) {
            t11 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, t5, t7, t10);
            $[69] = t10;
            $[70] = t5;
            $[71] = t7;
            $[72] = t11;
        } else t11 = $[72];
        itemsContent = t11;
    }
    if (isLoading) {
        const t5 = adaptiveHeight ? "80px" : "50px";
        let t6;
        let t7;
        if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $hekY6.default)([
                "_2O5Vij7dHp _0aFT5vbt8w _0hPCNLDIqT"
            ]);
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                testId: $401fe0c2ed528c33$export$800daf5fbbe96aff.searchResultLoadingIndicator,
                interactionName: "link-picker-search-list-loading",
                size: "medium"
            });
            $[73] = t6;
            $[74] = t7;
        } else {
            t6 = $[73];
            t7 = $[74];
        }
        let t8;
        if ($[75] !== t5 || $[76] !== t6) {
            t8 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
                minHeight: t5,
                className: t6
            }, t7);
            $[75] = t5;
            $[76] = t6;
            $[77] = t8;
        } else t8 = $[77];
        loadingContent = t8;
    }
    let t5;
    if ($[78] !== className) {
        t5 = (0, $hekY6.default)([
            "_39xV02N91d _0Of8r2dnbC _4kiQYAljYU _3138425zaO _1DCdHi5zaO _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w",
            className
        ]);
        $[78] = className;
        $[79] = t5;
    } else t5 = $[79];
    let t6;
    if ($[80] !== itemsContent || $[81] !== loadingContent || $[82] !== ref || $[83] !== restProps || $[84] !== t5 || $[85] !== tabPanelId) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: tabPanelId,
            ref: ref,
            className: t5,
            ...restProps
        }, itemsContent, loadingContent);
        $[80] = itemsContent;
        $[81] = loadingContent;
        $[82] = ref;
        $[83] = restProps;
        $[84] = t5;
        $[85] = tabPanelId;
        $[86] = t6;
    } else t6 = $[86];
    return t6;
} : ({ onChange: onChange, onSelect: onSelect, onKeyDown: onKeyDown, items: items, activeIndex: activeIndex, selectedIndex: selectedIndex, isLoading: isLoading, ariaReadOnly: ariaReadOnly, role: role, id: id, hasSearchTerm: hasSearchTerm, activePlugin: activePlugin, adaptiveHeight: adaptiveHeight, className: className, tabPanelId: tabPanelId, shouldRenderNoResultsImage: shouldRenderNoResultsImage, ...restProps }, ref)=>{
    let itemsContent;
    let loadingContent;
    const linkListTitle = hasSearchTerm ? $401fe0c2ed528c33$export$defe85febe8b728c.titleResults : $401fe0c2ed528c33$export$defe85febe8b728c.titleRecentlyViewedFormatted;
    (0, $9dHkU.useTrackResultsShown)(isLoading, items, hasSearchTerm);
    const itemRefs = (0, $cozmU.useRef)({});
    const itemRefCallback = (0, $cozmU.useCallback)((el, id_0)=>{
        if (el === null) delete itemRefs.current[id_0];
        else itemRefs.current[id_0] = el;
    }, []);
    const getTabIndex = (0, $cozmU.useCallback)((index)=>{
        if (selectedIndex > -1) return selectedIndex === index ? 0 : -1;
        if (index === 0) return 0;
        return -1;
    }, [
        selectedIndex
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        let updatedIndex = activeIndex;
        if (onKeyDown) onKeyDown(event);
        if (!items?.length) return;
        updatedIndex = (0, $5eMgQ.handleNavKeyDown)(event, items.length, activeIndex);
        const item = items?.[updatedIndex];
        if ([
            'ArrowDown',
            'ArrowUp',
            'Home',
            'End'
        ].includes(event.key) && item) {
            if (itemRefs.current) itemRefs.current[item.objectId]?.focus();
        }
    }, [
        activeIndex,
        items,
        onKeyDown
    ]);
    if (items?.length === 0) {
        if (!hasSearchTerm) {
            const emptyState = activePlugin?.emptyStateNoResults?.();
            if (emptyState) return /*#__PURE__*/ $cozmU.createElement("div", {
                id: tabPanelId,
                className: (0, $hekY6.default)([
                    $401fe0c2ed528c33$var$styles.emptyStateNoResultsWrapper
                ])
            }, emptyState);
        }
        return /*#__PURE__*/ $cozmU.createElement("div", {
            id: tabPanelId
        }, /*#__PURE__*/ $cozmU.createElement((0, $bRwbX.NoResults), {
            shouldRenderImage: shouldRenderNoResultsImage
        }));
    }
    const listItemNameMaxLines = activePlugin?.uiOptions?.listItemNameMaxLines;
    if (items && items.length > 0) itemsContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "h3",
        // `.wiki-content h3` css styles in confluence override ADS/native styles here, so inline styles are needed.
        // Should use css or xcss prop when that CSS is removed/fixed by confluence
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $401fe0c2ed528c33$var$listTitleStyles,
        id: $401fe0c2ed528c33$export$800daf5fbbe96aff.resultListTitle,
        testId: $401fe0c2ed528c33$export$800daf5fbbe96aff.resultListTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), linkListTitle)), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
        id: "fabric.smartcard.linkpicker.suggested.results"
    }, hasSearchTerm && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...$401fe0c2ed528c33$export$defe85febe8b728c.searchLinkResults,
        values: {
            count: items.length
        },
        "aria-live": "polite",
        "aria-atomic": "true"
    })), /*#__PURE__*/ $cozmU.createElement("ul", {
        id: id,
        role: role,
        "aria-controls": "fabric.smartcard.linkpicker.suggested.results",
        "aria-labelledby": $401fe0c2ed528c33$export$800daf5fbbe96aff.resultListTitle,
        "aria-readonly": ariaReadOnly,
        "data-testid": $401fe0c2ed528c33$export$800daf5fbbe96aff.searchResultList,
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _313842Pgdg _1DCdHiPgdg _2XsHFMBXau _0adFHshxaA"
        ])
    }, items.map((item_0, index_0)=>/*#__PURE__*/ $cozmU.createElement((0, $41Rsm.LinkSearchListItem), {
            id: `${$401fe0c2ed528c33$export$800daf5fbbe96aff.searchResultItem}-${index_0}`,
            item: item_0,
            selected: selectedIndex === index_0,
            active: activeIndex === index_0,
            onFocus: ()=>onChange(item_0.objectId),
            onKeyDown: handleKeyDown,
            onSelect: onSelect,
            key: item_0.objectId,
            tabIndex: getTabIndex(index_0),
            ref: (el_0)=>itemRefCallback(el_0, item_0.objectId),
            nameMaxLines: listItemNameMaxLines
        }))));
    if (isLoading) loadingContent = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: adaptiveHeight ? '80px' : '50px',
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: $401fe0c2ed528c33$export$800daf5fbbe96aff.searchResultLoadingIndicator,
        interactionName: "link-picker-search-list-loading",
        size: "medium"
    }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: tabPanelId,
        ref: ref,
        className: (0, $hekY6.default)([
            "_39xV02N91d _0Of8r2dnbC _4kiQYAljYU _3138425zaO _1DCdHi5zaO _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w",
            className
        ]),
        ...restProps
    }, itemsContent, loadingContent);
});
module.exports["testIds"] = $401fe0c2ed528c33$export$800daf5fbbe96aff;
module.exports["LinkSearchList"] = $401fe0c2ed528c33$export$b6c5ba19d54350b3;

});

parcelRegister("bRwbX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $k3ncb = parcelRequire("k3ncb");


var $iScCK = parcelRequire("iScCK");

const $e1ddc0170d4a57db$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResults: {
        id: "fabric.linkPicker.search.noResults.heading",
        defaultMessage: "We couldn\u2019t find anything matching your search."
    },
    noResultsDescription: {
        id: "fabric.linkPicker.search.noResults.description",
        defaultMessage: "Try again with a different term."
    }
});
const $e1ddc0170d4a57db$export$800daf5fbbe96aff = {
    emptyResultPage: 'link-search-no-results'
};
const $e1ddc0170d4a57db$export$ef6006467f04ee41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { shouldRenderImage: t1 } = t0;
    const shouldRenderImage = t1 === undefined ? true : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== intl) {
        t2 = intl.formatMessage($e1ddc0170d4a57db$export$defe85febe8b728c.noResults);
        $[0] = intl;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== intl) {
        t3 = intl.formatMessage($e1ddc0170d4a57db$export$defe85febe8b728c.noResultsDescription);
        $[2] = intl;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = !shouldRenderImage && (0, $iDrrr.fg)("aifc_create_enabled") ? undefined : $e1ddc0170d4a57db$var$_temp;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k3ncb.EmptyState), {
            testId: $e1ddc0170d4a57db$export$800daf5fbbe96aff.emptyResultPage,
            header: t2,
            description: t3,
            renderImage: t4
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ shouldRenderImage: shouldRenderImage = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k3ncb.EmptyState), {
        testId: $e1ddc0170d4a57db$export$800daf5fbbe96aff.emptyResultPage,
        header: intl.formatMessage($e1ddc0170d4a57db$export$defe85febe8b728c.noResults),
        description: intl.formatMessage($e1ddc0170d4a57db$export$defe85febe8b728c.noResultsDescription),
        renderImage: !shouldRenderImage && (0, $iDrrr.fg)('aifc_create_enabled') ? undefined : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iScCK.NoResultsSVG), null)
    });
};
function $e1ddc0170d4a57db$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iScCK.NoResultsSVG), null);
}
module.exports["testIds"] = $e1ddc0170d4a57db$export$800daf5fbbe96aff;
module.exports["NoResults"] = $e1ddc0170d4a57db$export$ef6006467f04ee41;

});

parcelRegister("iScCK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $8bdc27a0f1a5d62b$var$SIZE = 96;
const $8bdc27a0f1a5d62b$var$noResultsSVGStyles = null;
const $8bdc27a0f1a5d62b$export$5485715da946f3be = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.747 27.747 0 0 0-2.667-4.133 28.188 28.188 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.246 30.246 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.463a28.103 28.103 0 0 0 2.698 4.192 27.67 27.67 0 0 0 3.33 3.62c6.94 6.267 15.518 6.85 23.596 2.507a30.502 30.502 0 0 0 4.23-2.758 30.071 30.071 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.222 30.222 0 0 1-2.928-4.553c-4.657-8.96-3.247-18.509 3.871-26.192a33.27 33.27 0 0 1 4.025-3.669 32.825 32.825 0 0 1 4.378-2.87c9.209-4.995 18.816-3.951 26.353 2.86a30.96 30.96 0 0 1 3.665 3.98 30.302 30.302 0 0 1 2.898 4.489c4.706 9.003 3.295 18.564-3.868 26.23a32.157 32.157 0 0 1-3.879 3.516 33.436 33.436 0 0 1-4.562 2.974c-3.858 2.073-7.781 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.841-9.274 2.541a28.43 28.43 0 0 0-3.736 2.447 28.058 28.058 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.4 25.4 0 0 0 2.472 3.83 25.297 25.297 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.01 28.01 0 0 0 3.9-2.545 28.04 28.04 0 0 0 3.308-2.999c5.778-6.182 6.885-13.552 3.125-20.75a25.545 25.545 0 0 0-2.44-3.777 25.854 25.854 0 0 0-3.086-3.358c-3.491-3.152-7.443-4.744-11.59-4.744h-.007Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.695c-1.235-1.721-2.562-1.71-3.857-.709-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.173-1.48-1.913Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.158 4.762 11.573 14.969 6.159-4.762L65.334 60.81Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M46.496 47.476h-3.492v-.221c-.119-2.484 1.29-5.174 3.295-6.274l.038-.02c.054-.028.107-.061.157-.095 1.094-.705 1.717-1.92 1.678-3.257-.038-1.326-.722-2.49-1.829-3.117a4.596 4.596 0 0 0-2.256-.605c-2.365 0-4.289 1.938-4.289 4.319h-3.492c0-4.32 3.49-7.835 7.78-7.835 1.375 0 2.747.365 3.967 1.055 2.186 1.237 3.536 3.51 3.61 6.082.074 2.583-1.15 4.943-3.272 6.312-.143.093-.289.18-.433.256-.832.468-1.529 1.907-1.465 3.033l.003.367Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M44.413 49.492a3.465 3.465 0 0 1 1.119-.003c1.138.187 2.064.985 2.289 2.229l.002.009.001.01a3.419 3.419 0 0 1-.001 1.126v.004c-.22 1.256-1.161 2.052-2.295 2.236a3.5 3.5 0 0 1-1.108-.003h-.001c-1.14-.184-2.07-.981-2.296-2.224l-.002-.01-.001-.01a3.37 3.37 0 0 1 0-1.12l.001-.01.002-.01c.227-1.249 1.161-2.034 2.288-2.223h.002Z",
            clipRule: "evenodd"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.747 27.747 0 0 0-2.667-4.133 28.188 28.188 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.246 30.246 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.463a28.103 28.103 0 0 0 2.698 4.192 27.67 27.67 0 0 0 3.33 3.62c6.94 6.267 15.518 6.85 23.596 2.507a30.502 30.502 0 0 0 4.23-2.758 30.071 30.071 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.222 30.222 0 0 1-2.928-4.553c-4.657-8.96-3.247-18.509 3.871-26.192a33.27 33.27 0 0 1 4.025-3.669 32.825 32.825 0 0 1 4.378-2.87c9.209-4.995 18.816-3.951 26.353 2.86a30.96 30.96 0 0 1 3.665 3.98 30.302 30.302 0 0 1 2.898 4.489c4.706 9.003 3.295 18.564-3.868 26.23a32.157 32.157 0 0 1-3.879 3.516 33.436 33.436 0 0 1-4.562 2.974c-3.858 2.073-7.781 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.841-9.274 2.541a28.43 28.43 0 0 0-3.736 2.447 28.058 28.058 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.4 25.4 0 0 0 2.472 3.83 25.297 25.297 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.01 28.01 0 0 0 3.9-2.545 28.04 28.04 0 0 0 3.308-2.999c5.778-6.182 6.885-13.552 3.125-20.75a25.545 25.545 0 0 0-2.44-3.777 25.854 25.854 0 0 0-3.086-3.358c-3.491-3.152-7.443-4.744-11.59-4.744h-.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.695c-1.235-1.721-2.562-1.71-3.857-.709-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.173-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.158 4.762 11.573 14.969 6.159-4.762L65.334 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M46.496 47.476h-3.492v-.221c-.119-2.484 1.29-5.174 3.295-6.274l.038-.02c.054-.028.107-.061.157-.095 1.094-.705 1.717-1.92 1.678-3.257-.038-1.326-.722-2.49-1.829-3.117a4.596 4.596 0 0 0-2.256-.605c-2.365 0-4.289 1.938-4.289 4.319h-3.492c0-4.32 3.49-7.835 7.78-7.835 1.375 0 2.747.365 3.967 1.055 2.186 1.237 3.536 3.51 3.61 6.082.074 2.583-1.15 4.943-3.272 6.312-.143.093-.289.18-.433.256-.832.468-1.529 1.907-1.465 3.033l.003.367Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M44.413 49.492a3.465 3.465 0 0 1 1.119-.003c1.138.187 2.064.985 2.289 2.229l.002.009.001.01a3.419 3.419 0 0 1-.001 1.126v.004c-.22 1.256-1.161 2.052-2.295 2.236a3.5 3.5 0 0 1-1.108-.003h-.001c-1.14-.184-2.07-.981-2.296-2.224l-.002-.01-.001-.01a3.37 3.37 0 0 1 0-1.12l.001-.01.002-.01c.227-1.249 1.161-2.034 2.288-2.223h.002Z",
        clipRule: "evenodd"
    }));
};
module.exports["NoResultsSVG"] = $8bdc27a0f1a5d62b$export$5485715da946f3be;

});

parcelRegister("41Rsm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $bGRaF = parcelRequire("bGRaF");


var $e9nC3 = parcelRequire("e9nC3");

var $2dbac637bbfc0f87$require$Buffer = $e9nC3.Buffer;
const $2dbac637bbfc0f87$export$800daf5fbbe96aff = {
    searchResultItem: 'link-search-list-item',
    searchResultIcon: 'link-search-list-item-icon'
};
const $2dbac637bbfc0f87$var$isSVG = (icon)=>icon.startsWith('<svg') && icon.endsWith('</svg>');
const $2dbac637bbfc0f87$var$base64SVG = (icon)=>`data:image/svg+xml;base64,${$2dbac637bbfc0f87$require$Buffer.from(icon).toString('base64')}`;
const $2dbac637bbfc0f87$var$itemIconStyles = null;
const $2dbac637bbfc0f87$var$listItemContextStyles = null;
const $2dbac637bbfc0f87$var$listItemContainerStyles = null;
const $2dbac637bbfc0f87$var$listItemContainerInnerStylesA11yRefresh = null;
const $2dbac637bbfc0f87$var$listItemContainerInnerStylesSeparatorLinkPickerRefresh = null;
const $2dbac637bbfc0f87$var$itemNameStyles = null;
const $2dbac637bbfc0f87$var$imgStyles = null;
const $2dbac637bbfc0f87$var$listItemBaseStyles = null;
const $2dbac637bbfc0f87$var$ListItemIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(21);
    const { item: item, intl: intl } = props;
    const { icon: icon, iconAlt: iconAlt } = item;
    if (!icon) return null;
    let t0;
    if ($[0] !== iconAlt || $[1] !== intl) {
        t0 = typeof iconAlt === "string" ? iconAlt : intl.formatMessage(iconAlt);
        $[0] = iconAlt;
        $[1] = intl;
        $[2] = t0;
    } else t0 = $[2];
    const alt = t0;
    if (typeof icon !== "string") {
        const Glyph = icon;
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $hekY6.default)([
                "_4ouGXI5zaO _3138421Y8M _0adFHs8HPE"
            ]);
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] !== Glyph || $[5] !== alt) {
            t2 = /*#__PURE__*/ $cozmU.createElement(Glyph, {
                alt: alt,
                "data-testid": $2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultIcon
            });
            $[4] = Glyph;
            $[5] = alt;
            $[6] = t2;
        } else t2 = $[6];
        let t3;
        if ($[7] !== t1 || $[8] !== t2) {
            t3 = /*#__PURE__*/ $cozmU.createElement("span", {
                className: t1
            }, t2);
            $[7] = t1;
            $[8] = t2;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    let t1;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4ouGXI5zaO _3138421Y8M _0adFHs8HPE"
        ]);
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== icon) {
        t2 = $2dbac637bbfc0f87$var$isSVG(icon) ? $2dbac637bbfc0f87$var$base64SVG(icon) : icon;
        $[11] = icon;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_1EqgXl5zaO"
        ]);
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== alt || $[15] !== t2 || $[16] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("img", {
            "data-testid": $2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultIcon,
            src: t2,
            alt: alt,
            className: t3
        });
        $[14] = alt;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    let t5;
    if ($[18] !== t1 || $[19] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, t4);
        $[18] = t1;
        $[19] = t4;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : (props)=>{
    const { item: item, intl: intl } = props;
    const { icon: icon, iconAlt: iconAlt } = item;
    if (!icon) return null;
    const alt = typeof iconAlt === 'string' ? iconAlt : intl.formatMessage(iconAlt);
    if (typeof icon !== 'string') {
        const Glyph = icon;
        return /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_4ouGXI5zaO _3138421Y8M _0adFHs8HPE"
            ])
        }, /*#__PURE__*/ $cozmU.createElement(Glyph, {
            alt: alt,
            "data-testid": $2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultIcon
        }));
    }
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_4ouGXI5zaO _3138421Y8M _0adFHs8HPE"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        "data-testid": $2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultIcon,
        src: $2dbac637bbfc0f87$var$isSVG(icon) ? $2dbac637bbfc0f87$var$base64SVG(icon) : icon,
        alt: alt,
        className: (0, $hekY6.default)([
            "_1EqgXl5zaO"
        ])
    }));
};
const $2dbac637bbfc0f87$var$ListItemSubtitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { items: t1 } = t0;
    const [firstItem, secondItem] = t1;
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzy7kJ _3iDTPbQ4SZ"
        ]);
        t3 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp"
        ]);
        t4 = (0, $hekY6.default)([
            "_1UtDYzZpcK _1ANEUSLRg7"
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else {
        t2 = $[0];
        t3 = $[1];
        t4 = $[2];
    }
    let t5;
    if ($[3] !== firstItem) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: t4
        }, firstItem));
        $[3] = firstItem;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== secondItem) {
        t6 = secondItem && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1UtDYzZpcK _1ANEUSLRg7"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_1UtDYz9r67"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, "\xa0 \u2022\xa0 ")), /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, secondItem));
        $[5] = secondItem;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== t5 || $[8] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": `${$2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultItem}-subtitle`,
            className: t2
        }, t5, t6);
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
} : ({ items: [firstItem, secondItem] })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": `${$2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultItem}-subtitle`,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzy7kJ _3iDTPbQ4SZ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK _1ANEUSLRg7"
        ])
    }, firstItem)), secondItem && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK _1ANEUSLRg7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1UtDYz9r67"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, "\xa0 \u2022\xa0 ")), /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, secondItem)));
};
const $2dbac637bbfc0f87$var$getDefaultSubtitleItems = (item, intl)=>{
    const container = item.container;
    const date = (0, $bGRaF.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
    if (container) {
        if (date) return [
            container,
            date
        ];
        return [
            container
        ];
    }
    if (date) return [
        date
    ];
    return undefined;
};
const $2dbac637bbfc0f87$var$listItemActive = null;
const $2dbac637bbfc0f87$var$listItemSelected = null;
const $2dbac637bbfc0f87$var$listItemFocusStyles = null;
const $2dbac637bbfc0f87$export$42975d65146c61a1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(34);
    const { item: item, selected: selected, id: id, onSelect: onSelect, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, nameMaxLines: t1 } = t0;
    const nameMaxLines = t1 === undefined ? 1 : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== item.objectId || $[1] !== onSelect) {
        t2 = ()=>onSelect(item.objectId);
        $[0] = item.objectId;
        $[1] = onSelect;
        $[2] = t2;
    } else t2 = $[2];
    const handleSelect = t2;
    let t3;
    if ($[3] !== intl || $[4] !== item) {
        t3 = item.subtitleItems || $2dbac637bbfc0f87$var$getDefaultSubtitleItems(item, intl);
        $[3] = intl;
        $[4] = item;
        $[5] = t3;
    } else t3 = $[5];
    const subtitleItems = t3;
    const t4 = !selected && "_1eOmH6o126 _3fSdSTsKwa";
    const t5 = selected && "_0KLXruY9q9 _2OUyjtsKwa";
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0Of8r22ADO _1wydGW2ADO _2Zuz6QsIZQ _1ZnuxbasAi _0wOv4Q7zJH",
            t4,
            t5,
            "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0ui43Codfs"
        ]);
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== intl || $[10] !== item) {
        t7 = /*#__PURE__*/ $cozmU.createElement($2dbac637bbfc0f87$var$ListItemIcon, {
            item: item,
            intl: intl
        });
        $[9] = intl;
        $[10] = item;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0GwItXDIqT _39xV02N91d"
        ]);
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== item.name) {
        t9 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": `${$2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultItem}-title`,
            title: item.name
        }, item.name);
        $[13] = item.name;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== nameMaxLines || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: nameMaxLines
        }, t9);
        $[15] = nameMaxLines;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== subtitleItems) {
        t11 = subtitleItems && /*#__PURE__*/ $cozmU.createElement($2dbac637bbfc0f87$var$ListItemSubtitle, {
            items: subtitleItems
        });
        $[18] = subtitleItems;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== t10 || $[21] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t8
        }, t10, t11);
        $[20] = t10;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== handleSelect || $[24] !== id || $[25] !== onFocus || $[26] !== onKeyDown || $[27] !== ref || $[28] !== selected || $[29] !== t12 || $[30] !== t6 || $[31] !== t7 || $[32] !== tabIndex) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "option",
            id: id,
            "aria-selected": selected,
            "data-testid": $2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultItem,
            onKeyDown: onKeyDown,
            onClick: handleSelect,
            onFocus: onFocus,
            tabIndex: tabIndex,
            ref: ref,
            className: t6
        }, t7, t12);
        $[23] = handleSelect;
        $[24] = id;
        $[25] = onFocus;
        $[26] = onKeyDown;
        $[27] = ref;
        $[28] = selected;
        $[29] = t12;
        $[30] = t6;
        $[31] = t7;
        $[32] = tabIndex;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : ({ item: item, selected: selected, id: id, onSelect: onSelect, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, nameMaxLines: nameMaxLines = 1 }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleSelect = ()=>onSelect(item.objectId);
    const subtitleItems = item.subtitleItems || $2dbac637bbfc0f87$var$getDefaultSubtitleItems(item, intl);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "option",
        id: id,
        "aria-selected": selected,
        "data-testid": $2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultItem,
        onKeyDown: onKeyDown,
        onClick: handleSelect,
        onFocus: onFocus,
        tabIndex: tabIndex,
        ref: ref,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0Of8r22ADO _1wydGW2ADO _2Zuz6QsIZQ _1ZnuxbasAi _0wOv4Q7zJH",
            !selected && "_1eOmH6o126 _3fSdSTsKwa",
            selected && "_0KLXruY9q9 _2OUyjtsKwa",
            "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0ui43Codfs"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($2dbac637bbfc0f87$var$ListItemIcon, {
        item: item,
        intl: intl
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0GwItXDIqT _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: nameMaxLines
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${$2dbac637bbfc0f87$export$800daf5fbbe96aff.searchResultItem}-title`,
        title: item.name
    }, item.name)), subtitleItems && /*#__PURE__*/ $cozmU.createElement($2dbac637bbfc0f87$var$ListItemSubtitle, {
        items: subtitleItems
    })));
});
module.exports["testIds"] = $2dbac637bbfc0f87$export$800daf5fbbe96aff;
module.exports["LinkSearchListItem"] = $2dbac637bbfc0f87$export$42975d65146c61a1;

});

parcelRegister("bGRaF", function(module, exports) {

var $15IyG = parcelRequire("15IyG");


var $2yeee = parcelRequire("2yeee");


var $1cjyH = parcelRequire("1cjyH");


var $56fCt = parcelRequire("56fCt");

const $946a059ef3987bd0$var$formatTime = (timeStamp, intl)=>{
    const isAbsolute = (0, $2yeee.isMoreThanOneWeekAgo)(timeStamp);
    if (isAbsolute) return intl.formatDate(timeStamp, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
    const { value: value, unit: unit } = (0, $1cjyH.selectUnit)(timeStamp, new Date(), {
        day: 7 // treat a week as 7 days (default is 5)
    });
    //formats as 'yesterday' instead of '1 day ago'
    if ((0, $15IyG.default)(timeStamp)) return intl.formatRelativeTime(value, unit, {
        numeric: 'auto'
    });
    return intl.formatRelativeTime(value, unit);
};
const $946a059ef3987bd0$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    return intl.formatMessage((0, $56fCt.timeMessages)[pageAction], {
        time: $946a059ef3987bd0$var$formatTime(timeStamp, intl)
    });
};
const $946a059ef3987bd0$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $946a059ef3987bd0$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $946a059ef3987bd0$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};
module.exports["transformTimeStamp"] = $946a059ef3987bd0$export$439b9bb86eb9f500;

});

parcelRegister("15IyG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cb8d26c32694895$export$2e2bcd8739ae039);

var $nsx26 = parcelRequire("nsx26");


var $1xxT0 = parcelRequire("1xxT0");


var $3yGK6 = parcelRequire("3yGK6");

function $0cb8d26c32694895$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $nsx26.default)(dirtyDate, (0, $1xxT0.default)(Date.now(), 1));
}

});

parcelRegister("nsx26", function(module, exports) {
$parcel$export(module.exports, "default", () => $046847ea799ac561$export$2e2bcd8739ae039);

var $zxlpF = parcelRequire("zxlpF");


var $3yGK6 = parcelRequire("3yGK6");

function $046847ea799ac561$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeftStartOfDay = (0, $zxlpF.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $zxlpF.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("1xxT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f3289e9f8e4176$export$2e2bcd8739ae039);

var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $11f3289e9f8e4176$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $gkHoc.default)(dirtyDate, -amount);
}

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("2yeee", function(module, exports) {

var $mr7nI = parcelRequire("mr7nI");


var $zxlpF = parcelRequire("zxlpF");


var $P1m33 = parcelRequire("P1m33");

function $05f178f08353b11e$export$e873c799b137eec4(date) {
    return (0, $mr7nI.default)(new Date(date), $05f178f08353b11e$var$startOfOneWeekAgo());
}
function $05f178f08353b11e$var$startOfOneWeekAgo() {
    return (0, $zxlpF.default)((0, $P1m33.default)(new Date(), 1));
}
module.exports["isMoreThanOneWeekAgo"] = $05f178f08353b11e$export$e873c799b137eec4;

});

parcelRegister("P1m33", function(module, exports) {
$parcel$export(module.exports, "default", () => $0995d08896a40d30$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $3jKk3 = parcelRequire("3jKk3");


var $3yGK6 = parcelRequire("3yGK6");

function $0995d08896a40d30$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $3jKk3.default)(dirtyDate, -amount);
}

});

parcelRegister("3jKk3", function(module, exports) {
$parcel$export(module.exports, "default", () => $26a7141bcda1f520$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");

function $26a7141bcda1f520$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $gkHoc.default)(dirtyDate, days);
}

});

parcelRegister("1cjyH", function(module, exports) {
//copied from packages/activity-platform/recent-work-ui/src/common/ui/activity-event-type-message/utils.ts
const $319025139ea33549$var$MS_PER_SECOND = 1e3;
const $319025139ea33549$var$SECS_PER_MIN = 60;
const $319025139ea33549$var$SECS_PER_HOUR = $319025139ea33549$var$SECS_PER_MIN * 60;
const $319025139ea33549$var$SECS_PER_DAY = $319025139ea33549$var$SECS_PER_HOUR * 24;
const $319025139ea33549$var$SECS_PER_WEEK = $319025139ea33549$var$SECS_PER_DAY * 7;
function $319025139ea33549$export$b8f7189986dd5395(from, to = Date.now(), thresholds = {}) {
    const resolvedThresholds = {
        ...$319025139ea33549$export$f4fd60e41371f80d,
        ...thresholds || {}
    };
    const secs = (+from - +to) / $319025139ea33549$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    const mins = secs / $319025139ea33549$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    const hours = secs / $319025139ea33549$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    const days = secs / $319025139ea33549$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    const weeks = secs / $319025139ea33549$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
const $319025139ea33549$export$f4fd60e41371f80d = {
    second: 45,
    // seconds to minute
    minute: 45,
    // minutes to hour
    hour: 22,
    // hour to day
    day: 5 // day to week
};
module.exports["selectUnit"] = $319025139ea33549$export$b8f7189986dd5395;

});

parcelRegister("9dHkU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXPru = parcelRequire("jXPru");


var $9DHhW = parcelRequire("9DHhW");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");

const $349e7d14370572d9$var$DEBOUNCE_MS = 400;
const $349e7d14370572d9$export$529828fad68c73fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isLoading, items, hasSearchTerm)=>{
    const $ = (0, $bDgLe.c)(7);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasSearchTermRef = (0, $cozmU.useRef)(hasSearchTerm);
    let t0;
    let t1;
    if ($[0] !== hasSearchTerm) {
        t0 = ()=>{
            hasSearchTermRef.current = hasSearchTerm;
        };
        t1 = [
            hasSearchTerm
        ];
        $[0] = hasSearchTerm;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const finalItems = !isLoading ? items : null;
    const [debouncedItems] = (0, $jXPru.default)(finalItems, $349e7d14370572d9$var$DEBOUNCE_MS);
    let t2;
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== debouncedItems) {
        t2 = ()=>{
            if (debouncedItems) {
                const event = !hasSearchTermRef.current ? "ui.searchResults.shown.preQuerySearchResults" : "ui.searchResults.shown.postQuerySearchResults";
                createAnalyticsEvent((0, $779pE.default)(event, {
                    resultCount: debouncedItems.length
                })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            }
        };
        t3 = [
            debouncedItems,
            createAnalyticsEvent
        ];
        $[3] = createAnalyticsEvent;
        $[4] = debouncedItems;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : (isLoading, items, hasSearchTerm)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasSearchTermRef = (0, $cozmU.useRef)(hasSearchTerm);
    // Using ref so that not required in the dependency array
    // Analytics should be entirely dependent on change of items being viewed
    (0, $cozmU.useEffect)(()=>{
        hasSearchTermRef.current = hasSearchTerm;
    }, [
        hasSearchTerm
    ]);
    // Filters isLoading/items to only return the array of items if no longer loading more items
    // Loading state IS a factor here because some tabs will
    // load intermediate results whilst loading additional results (Atlassian tab)
    // Considered to only have "shown" results once we are in a final state (no longer loading)
    const finalItems = (0, $cozmU.useMemo)(()=>!isLoading ? items : null, [
        isLoading,
        items
    ]);
    // Because Atlassian tab resolves intermediate results on every keystroke (may never be loading)
    // Debounce the items so that we only consider the results to have been shown
    // after they have been stable for DEBOUNCE_MS
    const [debouncedItems] = (0, $jXPru.default)(finalItems, $349e7d14370572d9$var$DEBOUNCE_MS);
    (0, $cozmU.useEffect)(()=>{
        if (debouncedItems) {
            const event = !hasSearchTermRef.current ? 'ui.searchResults.shown.preQuerySearchResults' : 'ui.searchResults.shown.postQuerySearchResults';
            createAnalyticsEvent((0, $779pE.default)(event, {
                resultCount: debouncedItems.length
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        }
    }, [
        debouncedItems,
        createAnalyticsEvent
    ]);
};
module.exports["useTrackResultsShown"] = $349e7d14370572d9$export$529828fad68c73fb;

});

parcelRegister("4L8R1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $iol8g = parcelRequire("iol8g");

function $c4b482aa16f28964$var$isTouchDevice() {
    return 'ontouchstart' in window || // eslint-disable-next-line compat/compat
    navigator.maxTouchPoints > 0;
}
const $c4b482aa16f28964$var$initialConditionalButtonsState = {
    back: false,
    forward: false
};
const $c4b482aa16f28964$var$scrollingContainerStyles = null;
const $c4b482aa16f28964$var$containerStyles = null;
const $c4b482aa16f28964$var$backButtonStyles = null;
const $c4b482aa16f28964$var$nextButtonStyles = null; /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
const $c4b482aa16f28964$export$3f4889bfcd7e2a0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(16);
    const ref = (0, $cozmU.useRef)(null);
    const [conditionalButtons, setConditionalButtons] = (0, $cozmU.useState)($c4b482aa16f28964$var$initialConditionalButtonsState);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iol8g.createGhost)();
        $[0] = t0;
    } else t0 = $[0];
    const ghost = t0;
    const onTabClick = $c4b482aa16f28964$var$_temp;
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const container = ref.current;
            let scrollingContainer;
            let tabs;
            const handleConditionalButtonsChange = ()=>{
                const buttons = (0, $iol8g.calculateConditionalButtons)(scrollingContainer, $c4b482aa16f28964$var$isTouchDevice());
                setConditionalButtons(buttons);
            };
            const observerCallback = (mutationList)=>{
                const tablist = (0, $iol8g.getTabList)(ref);
                for (const mutation of mutationList)if (mutation.type === "childList") {
                    const addedNodes = Array.from(mutation.addedNodes);
                    const found = addedNodes.find($c4b482aa16f28964$var$_temp2);
                    if (found && tablist) {
                        ghost.remove();
                        const tabs_0 = Array.from(tablist.children);
                        tabs_0.forEach((tab)=>{
                            tab.removeEventListener("click", onTabClick);
                            tab.addEventListener("click", onTabClick);
                        });
                        tablist.appendChild(ghost);
                        handleConditionalButtonsChange();
                    }
                }
            };
            const observer = new MutationObserver(observerCallback);
            if (container) {
                const tablist_0 = (0, $iol8g.getTabList)(ref);
                scrollingContainer = tablist_0?.parentElement;
                observer.observe(container, {
                    attributes: false,
                    childList: true,
                    subtree: true
                });
                if (scrollingContainer instanceof HTMLElement && tablist_0) {
                    tablist_0.appendChild(ghost);
                    tabs = Array.from(tablist_0.children);
                    tabs.forEach((tab_0)=>tab_0.addEventListener("click", onTabClick));
                    handleConditionalButtonsChange();
                    scrollingContainer.addEventListener("scroll", handleConditionalButtonsChange);
                }
                return ()=>{
                    if (scrollingContainer) scrollingContainer.removeEventListener("scroll", handleConditionalButtonsChange);
                    if (tabs.length) tabs.forEach((tab_1)=>tab_1.removeEventListener("click", onTabClick));
                };
            }
        };
        t2 = [
            onTabClick,
            ghost,
            ref
        ];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            appearance: "subtle",
            spacing: "compact"
        };
        $[3] = t3;
    } else t3 = $[3];
    const buttonProps = t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _2X2hp0YbGa _0uDr6zS2te _3q9enAS2te _3ixl7MS2te"
        ]);
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== conditionalButtons.back) {
        t5 = conditionalButtons.back && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTon1Y8M _42Yu6B0Le4 _0KLXrulfZc _3OE6xYdnbC",
                "back"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            "data-test-id": "back",
            onClick: ()=>(0, $iol8g.scrollBack)(ref),
            label: "back",
            icon: $c4b482aa16f28964$var$_temp3,
            ...buttonProps
        }));
        $[5] = conditionalButtons.back;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_38gZMsTDcB _4bt5LAIZbP _3h2tDz3EvU _3oUqlsYbGa _1Oimfucjp5 _1FwLP5dnbC _0Xnm3ednbC _2miNbsdnbC _125xK8dnbC _3Ku51Iogpp _31ReDydnbC _3dCYwDWVPG _3ScelFOLYo _1L3m712ADO _1D2b5M2ADO _1lBcDc4Jdh _4diMdq9r67 _3cvhttYbGa"
        ]);
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== props.children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, props.children);
        $[8] = props.children;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== conditionalButtons.forward) {
        t8 = conditionalButtons.forward && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTon1Y8M _42Yu6B0Le4 _0KLXrulfZc _4ApkO2dnbC"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            "data-test-id": "forward",
            onClick: ()=>(0, $iol8g.scrollForward)(ref),
            ...buttonProps,
            label: "forward",
            icon: $c4b482aa16f28964$var$_temp4
        }));
        $[10] = conditionalButtons.forward;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t5 || $[13] !== t7 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            "data-testid": "scrolling-tabs",
            className: t4
        }, t5, t7, t8);
        $[12] = t5;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : (props)=>{
    const ref = (0, $cozmU.useRef)(null);
    const [conditionalButtons, setConditionalButtons] = (0, $cozmU.useState)($c4b482aa16f28964$var$initialConditionalButtonsState);
    const ghost = (0, $cozmU.useMemo)(()=>(0, $iol8g.createGhost)(), []);
    const onTabClick = (0, $cozmU.useCallback)((e)=>{
        const target = e.currentTarget;
        if (target) target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        const container = ref.current;
        let scrollingContainer;
        let tabs;
        const handleConditionalButtonsChange = ()=>{
            const buttons = (0, $iol8g.calculateConditionalButtons)(scrollingContainer, $c4b482aa16f28964$var$isTouchDevice());
            setConditionalButtons(buttons);
        };
        const observerCallback = (mutationList)=>{
            const tablist = (0, $iol8g.getTabList)(ref);
            for (const mutation of mutationList)if (mutation.type === 'childList') {
                const addedNodes = Array.from(mutation.addedNodes);
                const found = addedNodes.find((node)=>node.getAttribute('role') === 'tab');
                if (found && tablist) {
                    ghost.remove();
                    const tabs_0 = Array.from(tablist.children);
                    tabs_0.forEach((tab)=>{
                        tab.removeEventListener('click', onTabClick);
                        tab.addEventListener('click', onTabClick);
                    });
                    tablist.appendChild(ghost);
                    handleConditionalButtonsChange();
                }
            }
        };
        const observer = new MutationObserver(observerCallback);
        if (container) {
            const tablist_0 = (0, $iol8g.getTabList)(ref);
            scrollingContainer = tablist_0?.parentElement;
            observer.observe(container, {
                attributes: false,
                childList: true,
                subtree: true
            });
            if (scrollingContainer instanceof HTMLElement && tablist_0) {
                tablist_0.appendChild(ghost);
                tabs = Array.from(tablist_0.children);
                tabs.forEach((tab_0)=>tab_0.addEventListener('click', onTabClick));
                handleConditionalButtonsChange();
                scrollingContainer.addEventListener('scroll', handleConditionalButtonsChange);
            }
            return ()=>{
                if (scrollingContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollingContainer.removeEventListener('scroll', handleConditionalButtonsChange);
                if (tabs.length) tabs.forEach((tab_1)=>tab_1.removeEventListener('click', onTabClick));
            };
        }
    }, [
        onTabClick,
        ghost,
        ref
    ]);
    const buttonProps = {
        appearance: 'subtle',
        spacing: 'compact'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": "scrolling-tabs",
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _2X2hp0YbGa _0uDr6zS2te _3q9enAS2te _3ixl7MS2te"
        ])
    }, conditionalButtons.back && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon1Y8M _42Yu6B0Le4 _0KLXrulfZc _3OE6xYdnbC",
            "back"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        "data-test-id": "back",
        onClick: ()=>(0, $iol8g.scrollBack)(ref),
        label: "back",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            }),
        ...buttonProps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_38gZMsTDcB _4bt5LAIZbP _3h2tDz3EvU _3oUqlsYbGa _1Oimfucjp5 _1FwLP5dnbC _0Xnm3ednbC _2miNbsdnbC _125xK8dnbC _3Ku51Iogpp _31ReDydnbC _3dCYwDWVPG _3ScelFOLYo _1L3m712ADO _1D2b5M2ADO _1lBcDc4Jdh _4diMdq9r67 _3cvhttYbGa"
        ])
    }, props.children), conditionalButtons.forward && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon1Y8M _42Yu6B0Le4 _0KLXrulfZc _4ApkO2dnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        "data-test-id": "forward",
        onClick: ()=>(0, $iol8g.scrollForward)(ref),
        ...buttonProps,
        label: "forward",
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_0,
                size: "small"
            })
    })));
};
function $c4b482aa16f28964$var$_temp(e) {
    const target = e.currentTarget;
    if (target) target.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
    });
}
function $c4b482aa16f28964$var$_temp2(node) {
    return node.getAttribute("role") === "tab";
}
function $c4b482aa16f28964$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps,
        size: "small"
    });
}
function $c4b482aa16f28964$var$_temp4(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps_0,
        size: "small"
    });
}
module.exports["ScrollingTabList"] = $c4b482aa16f28964$export$3f4889bfcd7e2a0f;

});

parcelRegister("iol8g", function(module, exports) {
const $b95652ddf30a9d29$var$BUTTON_SIZE = 24;
const $b95652ddf30a9d29$var$GUTTER = 48;
const $b95652ddf30a9d29$var$GHOST_WIDTH = 342 - $b95652ddf30a9d29$var$GUTTER - 40;
const $b95652ddf30a9d29$export$78dcacdb9059402 = (ref)=>{
    $b95652ddf30a9d29$var$moveTabsScroll(ref, $b95652ddf30a9d29$var$findPrevious);
};
const $b95652ddf30a9d29$export$aa243477c3593c09 = (ref)=>{
    $b95652ddf30a9d29$var$moveTabsScroll(ref, $b95652ddf30a9d29$var$findNext);
};
const $b95652ddf30a9d29$export$ea1b0fdd88adfa3b = (container, hideButtons)=>{
    const initialState = {
        back: false,
        forward: false
    };
    if (!container || hideButtons) return initialState;
    const maxScrollValue = container.scrollWidth - container.clientWidth;
    return {
        back: container.scrollLeft > 0,
        forward: container.scrollLeft < maxScrollValue - $b95652ddf30a9d29$var$GHOST_WIDTH
    };
};
const $b95652ddf30a9d29$export$570f57abe0c473cb = ()=>{
    const ghost = document.createElement('div');
    ghost.setAttribute('id', 'scrolling-tabs-ghost');
    ghost.style.minWidth = `${$b95652ddf30a9d29$var$GHOST_WIDTH}px`;
    ghost.style.pointerEvents = 'none';
    return ghost;
};
const $b95652ddf30a9d29$var$moveTabsScroll = (ref, findFn)=>{
    const container = $b95652ddf30a9d29$export$49f5bf502122d4f7(ref);
    if (container) {
        const tablist = container.children[0];
        const tabs = Array.from(tablist.children);
        if (tabs.length > 0) {
            const target = findFn(container, tabs);
            if (target) {
                const left = container.scrollLeft + target.getBoundingClientRect().left - container.getBoundingClientRect().left - $b95652ddf30a9d29$var$BUTTON_SIZE;
                $b95652ddf30a9d29$var$scrollTo(container, left);
            }
        }
    }
};
const $b95652ddf30a9d29$var$scrollTo = (container, left)=>{
    container.scrollTo({
        left: left
    });
};
const $b95652ddf30a9d29$export$83daafa4ec439dec = (ref)=>ref.current?.querySelector('[role="tablist"]');
const $b95652ddf30a9d29$export$49f5bf502122d4f7 = (ref)=>$b95652ddf30a9d29$export$83daafa4ec439dec(ref)?.parentElement;
const $b95652ddf30a9d29$var$findPrevious = (container, tabs)=>{
    const previousTabs = tabs.filter((tab)=>{
        const [containerRect, tabRect] = [
            container.getBoundingClientRect(),
            tab.getBoundingClientRect()
        ];
        const [containerArea, tabArea] = [
            containerRect.left + container.scrollLeft - $b95652ddf30a9d29$var$GUTTER,
            container.scrollLeft + tabRect.left + tabRect.width
        ];
        return containerArea > tabArea;
    });
    if (previousTabs.length < 3) return previousTabs[0];
    return previousTabs[previousTabs.length - 1];
};
const $b95652ddf30a9d29$var$findNext = (container, tabs)=>{
    const containerRect = container.getBoundingClientRect();
    return tabs.find((tab)=>{
        const tabRect = tab.getBoundingClientRect();
        const [containerArea, tabArea] = [
            container.clientWidth + containerRect.left - $b95652ddf30a9d29$var$GUTTER,
            tabRect.left + tabRect.width
        ];
        return containerArea < tabArea;
    });
};
module.exports["scrollBack"] = $b95652ddf30a9d29$export$78dcacdb9059402;
module.exports["scrollForward"] = $b95652ddf30a9d29$export$aa243477c3593c09;
module.exports["calculateConditionalButtons"] = $b95652ddf30a9d29$export$ea1b0fdd88adfa3b;
module.exports["createGhost"] = $b95652ddf30a9d29$export$570f57abe0c473cb;
module.exports["getTabList"] = $b95652ddf30a9d29$export$83daafa4ec439dec;

});

parcelRegister("5Djep", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $dOXsL = parcelRequire("dOXsL");

const $ed0814e520f83a4f$var$flexColumn = null;
const $ed0814e520f83a4f$export$e04042801ea527f0 = ({ hasTabs: hasTabs, adaptiveHeight: adaptiveHeight, isLoadingResults: isLoadingResults, children: children })=>{
    const ref = (0, $cozmU.useRef)(null);
    const currentHeight = (0, $cozmU.useRef)(null);
    const fixedMinHeight = hasTabs ? '296px' : '251px';
    const adaptiveMinHeight = isLoadingResults && !!currentHeight.current ? `${currentHeight.current}px` : 'auto';
    const minheight = adaptiveHeight ? adaptiveMinHeight : fixedMinHeight;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (ref.current && adaptiveHeight && !isLoadingResults) currentHeight.current = ref.current.getBoundingClientRect().height;
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        ref: ref,
        minHeight: minheight,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _39xV02N91d"
        ])
    }, children);
};
module.exports["SearchResultsContainer"] = $ed0814e520f83a4f$export$e04042801ea527f0;

});

parcelRegister("1jyI6", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");

function $7746ec5e6a7ada0d$export$e6d7e677c5e4edcf({ activePlugin: activePlugin }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (activePlugin) createAnalyticsEvent((0, $779pE.default)('ui.tab.viewed', {})).fire((0, $kJo8F.ANALYTICS_CHANNEL));
    }, [
        activePlugin,
        createAnalyticsEvent
    ]);
    return null;
}
module.exports["TrackTabViewed"] = $7746ec5e6a7ada0d$export$e6d7e677c5e4edcf;

});

parcelRegister("8rd8W", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $2VwyL = parcelRequire("2VwyL");


var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $9DzWa = parcelRequire("9DzWa");

var $dQLwo = parcelRequire("dQLwo");


var $5avUB = parcelRequire("5avUB");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $7wykp = parcelRequire("7wykp");


var $cMY7a = parcelRequire("cMY7a");

const $6db58277abf0a76e$var$styles = {
    clearTextButton: "_30huDKYbGa _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0adFHs1Y8M _0KLXru66of _1RrJLit2nV",
    requiredIndicatorStyles: "_1UtDYzAyGJ _0WKd3G4z3T _0LQT5EFQfX"
}; /**
    * Overriding text input margin top which design system provides as a default spacer
    * but it gets in the way of our layout
    */ 
const $6db58277abf0a76e$var$baseFieldStyles = null;
const $6db58277abf0a76e$var$newFieldStyles = null;
const $6db58277abf0a76e$var$RequiredAsterisk = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            "aria-hidden": "true",
            xcss: $6db58277abf0a76e$var$styles.requiredIndicatorStyles
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": "true",
        xcss: $6db58277abf0a76e$var$styles.requiredIndicatorStyles
    }, "*");
};
const $6db58277abf0a76e$export$800daf5fbbe96aff = {
    urlError: 'link-error',
    clearUrlButton: 'clear-text',
    linkHelperText: 'link-helper-text'
};
const $6db58277abf0a76e$export$c86715117507e8e5 = ({ name: name, label: label, autoFocus: autoFocus, onRedo: onRedo, onUndo: onUndo, onKeyDown: onKeyDown, onClear: onClear, clearLabel: clearLabel, error: error, spotlightTargetName: spotlightTargetName, inputRef: inputRefProp, isRequired: isRequired = false, helperMessage: helperMessage, ...restProps })=>{
    const inputRef = (0, $cozmU.useRef)(null);
    const handleRef = (0, $cozmU.useCallback)((input)=>{
        if (input) {
            inputRef.current = input;
            if (autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
            input.focus({
                preventScroll: true
            });
        }
    }, [
        autoFocus
    ]);
    const refs = (0, $cozmU.useMemo)(()=>[
            handleRef,
            inputRefProp
        ].filter(Boolean), [
        handleRef,
        inputRefProp
    ]);
    const textfieldRef = (0, $2VwyL.useMergeRefs)(refs);
    const handleKeydown = (0, $cozmU.useCallback)((e)=>{
        if (typeof onUndo === 'function' && (0, $cMY7a.isUndoEvent)(e)) {
            e.preventDefault();
            onUndo();
        } else if (typeof onRedo === 'function' && (0, $cMY7a.isRedoEvent)(e)) {
            e.preventDefault();
            onRedo();
        }
        if (onKeyDown) onKeyDown(e);
    }, [
        onUndo,
        onRedo,
        onKeyDown
    ]);
    const handleClear = (0, $cozmU.useCallback)((e_0)=>{
        e_0.preventDefault();
        e_0.stopPropagation();
        onClear?.(name);
        inputRef.current?.focus();
    }, [
        name,
        onClear
    ]);
    const clearText = restProps.value !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: clearLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $6db58277abf0a76e$var$styles.clearTextButton,
        onClick: handleClear,
        testId: $6db58277abf0a76e$export$800daf5fbbe96aff.clearUrlButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: clearLabel || '',
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "spacious"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0wzsVTdnbC _1CWaDm5zaO",
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: label,
        name: name,
        elementAfterLabel: isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6db58277abf0a76e$var$RequiredAsterisk, null) : undefined
    }, ({ fieldProps: fieldProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7wykp.ConditionalSpotlightTargetWrapper), {
            spotlightTargetName: spotlightTargetName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...fieldProps,
            ...restProps,
            onKeyDown: handleKeydown,
            ref: textfieldRef,
            elemAfterInput: clearText,
            isInvalid: !!error,
            "aria-describedby": `${restProps['aria-describedby']} ${fieldProps.id}-error ${fieldProps.id}-helper`
        }), (0, $iDrrr.fg)('platform_navx_3298_message_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), {
            testId: $6db58277abf0a76e$export$800daf5fbbe96aff.linkHelperText
        }, helperMessage), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), {
            testId: $6db58277abf0a76e$export$800daf5fbbe96aff.urlError
        }, error)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), {
            testId: $6db58277abf0a76e$export$800daf5fbbe96aff.linkHelperText
        }, helperMessage), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), {
            testId: $6db58277abf0a76e$export$800daf5fbbe96aff.urlError
        }, error))));
    }));
};
module.exports["testIds"] = $6db58277abf0a76e$export$800daf5fbbe96aff;
module.exports["TextInput"] = $6db58277abf0a76e$export$c86715117507e8e5;

});

parcelRegister("7wykp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9Zall = parcelRequire("9Zall");


var $8jXZv = parcelRequire("8jXZv");

const $2f75a2ea20fa09f6$export$19a90839c6257c07 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { spotlightTargetName: spotlightTargetName, children: children } = t0;
    if (spotlightTargetName) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return children;
} : ({ spotlightTargetName: spotlightTargetName, children: children })=>{
    if (spotlightTargetName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
    return children;
};
module.exports["ConditionalSpotlightTargetWrapper"] = $2f75a2ea20fa09f6$export$19a90839c6257c07;

});

parcelRegister("cMY7a", function(module, exports) {

var $a3Cph = parcelRequire("a3Cph");

const $b7e6de53b02375f3$var$KeyZCode = 90;
const $b7e6de53b02375f3$var$KeyYCode = 89;
const $b7e6de53b02375f3$export$d0c11e21a5e80c44 = (e)=>{
    const { mac: mac } = (0, $a3Cph.browser)();
    return e.keyCode === $b7e6de53b02375f3$var$KeyZCode && // cmd + z for mac
    (mac && e.metaKey && !e.shiftKey || // ctrl + z for non-mac
    !mac && e.ctrlKey);
};
const $b7e6de53b02375f3$export$83612bb10212ddf3 = (e)=>{
    const { mac: mac } = (0, $a3Cph.browser)();
    return(// ctrl + y for non-mac
    !mac && e.ctrlKey && e.keyCode === $b7e6de53b02375f3$var$KeyYCode || mac && e.metaKey && e.shiftKey && e.keyCode === $b7e6de53b02375f3$var$KeyZCode || e.ctrlKey && e.shiftKey && e.keyCode === $b7e6de53b02375f3$var$KeyZCode);
};
module.exports["isUndoEvent"] = $b7e6de53b02375f3$export$d0c11e21a5e80c44;
module.exports["isRedoEvent"] = $b7e6de53b02375f3$export$83612bb10212ddf3;

});

parcelRegister("4jrCy", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");

function $f94252e2363196e7$export$21b400a8c8ebc91a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    (0, $cozmU.useLayoutEffect)(()=>{
        (0, $gt5Em.succeedUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        linkPickerSessionId
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Anything in here is fired on component mount.
        createAnalyticsEvent((0, $779pE.default)('ui.inlineDialog.viewed.linkPicker', {})).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        return ()=>{
            // Anything in here is fired on component unmount.
            createAnalyticsEvent((0, $779pE.default)('ui.inlineDialog.closed.linkPicker', {})).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        };
    }, [
        createAnalyticsEvent
    ]);
    return null;
}
module.exports["TrackMount"] = $f94252e2363196e7$export$21b400a8c8ebc91a;

});

parcelRegister("h8c6r", function(module, exports) {

var $bGRaF = parcelRequire("bGRaF");

const $67700c280ac85297$export$de16705e2b70ea0f = (item, plugin)=>{
    return item.meta?.source ?? plugin?.meta?.source ?? 'unknown';
};
function $67700c280ac85297$export$3d132448e5b05f93(items, selectedIndex, intl) {
    if (items.length && selectedIndex > -1) {
        const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
        const date = (0, $bGRaF.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
        return [
            name,
            container,
            date
        ].filter(Boolean).join(', ');
    }
}
module.exports["getDataSource"] = $67700c280ac85297$export$de16705e2b70ea0f;
module.exports["getScreenReaderText"] = $67700c280ac85297$export$3d132448e5b05f93;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$transitionDuration = '0.2s';
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$baseStylesT26Shape = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIg20Hp _4kBIzkmnOE",
    monospace: "_2sNsIg20Hp _0WKd3Gfx9v _4kBIzkmnOE _2GdZyqdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(63);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDzXzM _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && "_0bjKvDKTcp",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDzXzM _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_0bjKvDKTcp",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TextArea(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("b4vCW", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $6BYyi = parcelRequire("6BYyi");


var $6Zvcd = parcelRequire("6Zvcd");


var $fJfKO = parcelRequire("fJfKO");


var $7Cfp7 = parcelRequire("7Cfp7");

var $2103cf628600479a$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $2103cf628600479a$export$775b6bb06e53a214 = {
    ...(0, $6BYyi.Scope),
    ...(0, $6Zvcd.Scope),
    ...(0, $7Cfp7.TownsquareScope),
    ...(0, $fJfKO.Scope)
};
module.exports["Scope"] = $2103cf628600479a$export$775b6bb06e53a214;

});

parcelRegister("6BYyi", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $14f7537098ab5b98$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $14f7537098ab5b98$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $14f7537098ab5b98$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $14f7537098ab5b98$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $14f7537098ab5b98$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $14f7537098ab5b98$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $14f7537098ab5b98$export$80a5be864676016b = 'confluence.space';
const $14f7537098ab5b98$export$70542451ad6057d2 = 'urs.user-confluence';
const $14f7537098ab5b98$export$6ec00f56b27cdc1d = 'generic-container-result';
const $14f7537098ab5b98$export$ca1a50bc869949e = 'person-result';
const $14f7537098ab5b98$export$a99961038e9d5471 = 'confluence-object-result';
const $14f7537098ab5b98$export$18c69de2b4aa679c = 'recent-confluence';
const $14f7537098ab5b98$export$dc31f0db54ab1a30 = 'result-confluence';
const $14f7537098ab5b98$export$cb8b6c470492bee8 = 'recent-person';
const $14f7537098ab5b98$export$ebb42dafe7a39a20 = 'result-person';
const $14f7537098ab5b98$export$602b44a55c824e30 = 'advanced-search-confluence';
const $14f7537098ab5b98$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $14f7537098ab5b98$export$bbd1709e62826142 = 'confluence-page';
const $14f7537098ab5b98$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $14f7537098ab5b98$export$b441f0c13fd510b9 = 'confluence-attachment';
const $14f7537098ab5b98$export$8ee8726ca4e2f8bd = 'confluence-space';
const $14f7537098ab5b98$export$d0e824889e01c751 = 'person';
const $14f7537098ab5b98$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $14f7537098ab5b98$export$775b6bb06e53a214;

});

parcelRegister("6Zvcd", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $2f98cc823dddcacd$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $2f98cc823dddcacd$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $2f98cc823dddcacd$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $2f98cc823dddcacd$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $2f98cc823dddcacd$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $2f98cc823dddcacd$export$775b6bb06e53a214;

});

parcelRegister("fJfKO", function(module, exports) {
var $1d3fb901b1492caa$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $1d3fb901b1492caa$export$775b6bb06e53a214;

});

parcelRegister("7Cfp7", function(module, exports) {
var $7ab467722a6086d5$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $7ab467722a6086d5$export$fca43c5c12a4e3fa;

});

parcelRegister("69Kfj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eJXnW = parcelRequire("eJXnW");

const $c29efbee18d37f33$export$679584c8d36ab911 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (configs)=>{
    const $ = (0, $bDgLe.c)(5);
    const [atlassianPlugins] = (0, $cozmU.useState)($c29efbee18d37f33$var$_temp);
    let t0;
    if ($[0] !== atlassianPlugins || $[1] !== configs) {
        let t1;
        if ($[3] !== atlassianPlugins) {
            t1 = (config)=>{
                const existingPlugin = atlassianPlugins.get(config);
                if (existingPlugin) return existingPlugin;
                const newPlugin = new (0, $eJXnW.default)(config);
                atlassianPlugins.set(config, newPlugin);
                return newPlugin;
            };
            $[3] = atlassianPlugins;
            $[4] = t1;
        } else t1 = $[4];
        t0 = configs.map(t1);
        $[0] = atlassianPlugins;
        $[1] = configs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (configs)=>{
    const [atlassianPlugins] = (0, $cozmU.useState)(()=>new WeakMap());
    return (0, $cozmU.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $eJXnW.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};
function $c29efbee18d37f33$var$_temp() {
    return new WeakMap();
}
module.exports["useAtlassianPlugins"] = $c29efbee18d37f33$export$679584c8d36ab911;

});

parcelRegister("eJXnW", function(module, exports) {

var $94kzl = parcelRequire("94kzl");

var $fL4p7 = parcelRequire("fL4p7");


var $iDrrr = parcelRequire("iDrrr");


var $DdJXy = parcelRequire("DdJXy");


var $b4vCW = parcelRequire("b4vCW");


var $4NuaM = parcelRequire("4NuaM");


var $4eTDd = parcelRequire("4eTDd");


var $402Va = parcelRequire("402Va");


var $g6P2L = parcelRequire("g6P2L");


var $jKzTq = parcelRequire("jKzTq");

const $b2d61b552ef6cf58$export$452f1062ecf44be7 = 5;
const $b2d61b552ef6cf58$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $b2d61b552ef6cf58$var$AtlassianLinkPickerPlugin {
    /**
   * Create search provider if config params are provided
   */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $402Va.default)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
   * Filter out fields from recent or search items.
   * @param items The recent items to remove fields from.
   * @returns Items with fields removed.
   */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
   * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
   * @param items The recent Loom items .
   * @returns Items with lastUpdatedDate set.
   */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
   * Retrieve recent items from the activity provider
   */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], // retries
            {
                limit: 100,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $jKzTq.getArisForProducts)(this.products, cloudId)), []) : // If cloudIds array is provided, do not scope activities query
                this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $jKzTq.getArisForProducts)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $jKzTq.mapActivityClientResultToLinkSearchItemData));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
   * Given a query, search the activity provider for recent activity
   */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $4NuaM.filterItems)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $b4vCW.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $4eTDd.mapSearchProviderResultToLinkSearchItemData));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
   * Merge list of recent items and search items, and dedupes
   */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $94kzl.filterUniqueItems)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
    }
    /**
   * Given link picker state yields updates to the list of link picker results
   * The plugin is considered to be in a loading state until the generator returns a final value
   * The plugin can yield intermediate lists of results to present the user with initial results
   * while loading additional results to update the list with.
   */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) return {
            data: this.applyPluginFilter(await this.getRecentItems())
        };
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $b2d61b552ef6cf58$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if ((0, $iDrrr.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $g6P2L.renderEmptyStateNoResults)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
    constructor(config){
        this._tabKey = void 0;
        this._tabTitle = void 0;
        this.products = void 0;
        this.debouncedSearch = void 0;
        this.searchProvider = void 0;
        this.activityClient = void 0;
        this.recentItems = void 0;
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.isMultisiteSearch = void 0;
        this.allowMultiSiteRecents = void 0;
        this._action = void 0;
        this._scope = void 0;
        this._loomRecentItems = void 0;
        this._pluginItemFilter = void 0;
        this._pluginDataFilter = void 0;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        if (!disableActivityClient) this.activityClient = (0, $DdJXy.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $fL4p7.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $b2d61b552ef6cf58$export$452f1062ecf44be7);
        }, $b2d61b552ef6cf58$var$DEBOUNCE_MS);
    }
}
var $b2d61b552ef6cf58$export$2e2bcd8739ae039 = $b2d61b552ef6cf58$var$AtlassianLinkPickerPlugin;
module.exports["default"] = $b2d61b552ef6cf58$export$2e2bcd8739ae039;

});

parcelRegister("94kzl", function(module, exports) {
/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $36f0454c86964c15$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
module.exports["filterUniqueItems"] = $36f0454c86964c15$export$8437fc55448c6e05;

});

parcelRegister("fL4p7", function(module, exports) {
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $154a91127dc95ca2$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}
module.exports["promiseDebounce"] = $154a91127dc95ca2$export$390f1673aa3d5232;

});

parcelRegister("DdJXy", function(module, exports) {

var $eW8fM = parcelRequire("eW8fM");


var $6vFZD = parcelRequire("6vFZD");

let $6a112a84062a731f$var$previousClientVersion;
const $6a112a84062a731f$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch, collabContextId)=>{
    if ($6a112a84062a731f$var$previousClientVersion && $6a112a84062a731f$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $6a112a84062a731f$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $eW8fM.ActivityClientV2)(product, baseUrl, collabContextId);
    return new (0, $6vFZD.ActivityClientV3)(product, baseUrl, logger, configFetch, collabContextId);
};
module.exports["createActivityClient"] = $6a112a84062a731f$export$224367b01f71f2aa;

});

parcelRegister("eW8fM", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $71leB = parcelRequire("71leB");


var $7azIf = parcelRequire("7azIf");


var $1Zjzt = parcelRequire("1Zjzt");

class $5109c156c1c5c718$export$330ab0047f2fb745 extends (0, $7azIf.ActivityClient) {
    constructor(_product, baseUrl, collabContextId){
        super('v2', _product, undefined, baseUrl, collabContextId);
        this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            const filtersWithCollabContext = this.collabContextId && (0, $iDrrr.fg)('platform_recent_work_collab_context_id') ? {
                ...filters,
                collabContextId: this.collabContextId
            } : filters;
            return (0, $71leB.fetchActivitiesWithExperience)((experience)=>(0, $1Zjzt.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filtersWithCollabContext,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        };
        this.setProduct = (product)=>{
            this.product = product;
        };
    }
}
module.exports["ActivityClientV2"] = $5109c156c1c5c718$export$330ab0047f2fb745;

});

parcelRegister("71leB", function(module, exports) {

var $3pZ7I = parcelRequire("3pZ7I");


var $bXw81 = parcelRequire("bXw81");


var $hOkJN = parcelRequire("hOkJN");

async function $1396df9d82dfd491$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $hOkJN.recentWorkClientExperienceV2)() : (0, $hOkJN.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $bXw81.packageName,
            packageVersion: $bXw81.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $1396df9d82dfd491$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $1396df9d82dfd491$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $3pZ7I.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};
module.exports["fetchActivitiesWithExperience"] = $1396df9d82dfd491$export$4a906f16800734f3;

});

parcelRegister("3pZ7I", function(module, exports) {
class $8998fedd348b763f$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.message = void 0;
        this.method = void 0;
        this.path = void 0;
        this.statusCode = void 0;
        this.xRequestId = void 0;
        this.headers = void 0;
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $8998fedd348b763f$export$97b788730ba59845 = (e)=>e instanceof $8998fedd348b763f$export$2e2bcd8739ae039;
module.exports["default"] = $8998fedd348b763f$export$2e2bcd8739ae039;

});

parcelRegister("bXw81", function(module, exports) {
const $284d8e69d74c83d5$export$9345d7360ffe0722 = "platform-pkg";
const $284d8e69d74c83d5$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageName"] = $284d8e69d74c83d5$export$9345d7360ffe0722;
module.exports["packageVersion"] = $284d8e69d74c83d5$export$91546b032799aa40;

});

parcelRegister("hOkJN", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $0ea055bec2445b3a$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $0ea055bec2445b3a$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($0ea055bec2445b3a$var$keyToTiming);
const $0ea055bec2445b3a$export$d7769758f5eaa63b = ()=>{
    return new (0, $34VCg.UFOExperience)('client', {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $0ea055bec2445b3a$var$timings
    });
};
const $0ea055bec2445b3a$export$9e32a4ed888f4717 = ()=>new (0, $34VCg.UFOExperience)('client-v3', {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $0ea055bec2445b3a$var$timings
    });
module.exports["recentWorkClientExperienceV2"] = $0ea055bec2445b3a$export$d7769758f5eaa63b;
module.exports["recentWorkClientExperienceV3"] = $0ea055bec2445b3a$export$9e32a4ed888f4717;

});

parcelRegister("7azIf", function(module, exports) {

var $kRg7a = parcelRequire("kRg7a");

class $2f9626706315fea1$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl, collabContextId){
        this.clientVersion = void 0;
        this.product = 'unknown';
        this.headers = void 0;
        this.baseUrl = (0, $kRg7a.GRAPHQL_GATEWAY_PATH);
        /**
     * An opaque collaboration context identifier that is forwarded as a
     * top-level field on every request body sent to the activity service.
     * Set once at construction time.
     */ this.collabContextId = void 0;
        this.fetchActivities = void 0;
        this.setProduct = void 0;
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
        this.collabContextId = collabContextId;
    }
}
module.exports["ActivityClient"] = $2f9626706315fea1$export$157740f5433f3dbe;

});

parcelRegister("kRg7a", function(module, exports) {
const $63a633f8d6f90ec2$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $63a633f8d6f90ec2$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SMARTLINK_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SMARTLINK_CLICKED"] = "sl-clicked";
    return VIEWED_EVENT;
}({});
var $63a633f8d6f90ec2$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $63a633f8d6f90ec2$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    // 3P Graph types below
    ActivityObjectType["DOCUMENT"] = "document";
    ActivityObjectType["PULL_REQUEST"] = "pull-request";
    ActivityObjectType["REMOTE_LINK"] = "remote-link";
    ActivityObjectType["WORK_ITEM"] = "work-item";
    return ActivityObjectType;
}({});
module.exports["GRAPHQL_GATEWAY_PATH"] = $63a633f8d6f90ec2$export$851c5df667ca24c8;
module.exports["VIEWED_EVENT"] = $63a633f8d6f90ec2$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $63a633f8d6f90ec2$export$eb4e9f525aef1cc3;
module.exports["ActivityObjectType"] = $63a633f8d6f90ec2$export$d02a56686be43f69;

});

parcelRegister("1Zjzt", function(module, exports) {

var $barCt = parcelRequire("barCt");


var $5qNjK = parcelRequire("5qNjK");


var $j34b5 = parcelRequire("j34b5");


var $fKvhW = parcelRequire("fKvhW");

const $4126b524e6cacb9f$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $4126b524e6cacb9f$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $4126b524e6cacb9f$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $4126b524e6cacb9f$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $4126b524e6cacb9f$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $j34b5.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $4126b524e6cacb9f$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $5qNjK.postResource)(baseUrl, {
            operationName: (0, $barCt.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($4126b524e6cacb9f$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $fKvhW.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $fKvhW.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $fKvhW.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $fKvhW.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $fKvhW.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};
module.exports["fetchActivitiesV2"] = $4126b524e6cacb9f$export$750ec7816fdd2f9e;

});

parcelRegister("barCt", function(module, exports) {

var $j4yZr = parcelRequire("j4yZr");

const $dba663cba8374ee1$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(product);
};
const $dba663cba8374ee1$export$41bca9dc6871dd4e = (product)=>{
    return `${$dba663cba8374ee1$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};
module.exports["getOperationName"] = $dba663cba8374ee1$export$41bca9dc6871dd4e;

});

parcelRegister("5qNjK", function(module, exports) {
parcelRequire("aotCl");
var $4ewfC = parcelRequire("4ewfC");
var $aotCl = parcelRequire("aotCl");


var $9didM = parcelRequire("9didM");


var $3pZ7I = parcelRequire("3pZ7I");

const $77ae2bc04c6c17cd$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $9didM.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $4ewfC.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $77ae2bc04c6c17cd$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $3pZ7I.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $77ae2bc04c6c17cd$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $77ae2bc04c6c17cd$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return text ? JSON.parse(text) : {};
};
const $77ae2bc04c6c17cd$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $aotCl.retryOnException)(()=>$77ae2bc04c6c17cd$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $77ae2bc04c6c17cd$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}
module.exports["postResource"] = $77ae2bc04c6c17cd$export$2ff3e1f219ccfad6;

});

parcelRegister("aotCl", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("4ewfC")).default);

var $1HD0w = parcelRequire("1HD0w");


var $40S6S = parcelRequire("40S6S");


var $4ewfC = parcelRequire("4ewfC");

const $fc8c651681b8647e$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $fc8c651681b8647e$var$NO_CALLS_ERROR = 'No calls made';
const $fc8c651681b8647e$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $40S6S.NO_RETRIES), retryOn: retryOn = [
    (0, $4ewfC.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($fc8c651681b8647e$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $fc8c651681b8647e$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $fc8c651681b8647e$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $1HD0w.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};
module.exports["retryOnException"] = $fc8c651681b8647e$export$1d94629c94e7a17f;

});

parcelRegister("40S6S", function(module, exports) {
const $fb23f31c5ca203e1$export$a0a1c8f90becc136 = [];
const $fb23f31c5ca203e1$export$972171517b12aa4 = [
    0,
    0
];
const $fb23f31c5ca203e1$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $fb23f31c5ca203e1$export$f6858378b665f957 = [
    100,
    500,
    1000
];
module.exports["NO_RETRIES"] = $fb23f31c5ca203e1$export$a0a1c8f90becc136;

});

parcelRegister("4ewfC", function(module, exports) {
class $2e21f428048470ea$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.method = void 0;
        this.originalName = void 0;
        this.path = void 0;
        this.stack = void 0;
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
module.exports["default"] = $2e21f428048470ea$export$2e2bcd8739ae039;

});

parcelRegister("9didM", function(module, exports) {
const $87132959cf1a7345$var$urlRegex = new RegExp(/^https?:\/\//);
function $87132959cf1a7345$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($87132959cf1a7345$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}
module.exports["getFullUrl"] = $87132959cf1a7345$export$2414511207262909;

});

parcelRegister("j34b5", function(module, exports) {

var $barCt = parcelRequire("barCt");


var $oLeaD = parcelRequire("oLeaD");

const $4117f82aca55ea3d$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $4117f82aca55ea3d$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$4117f82aca55ea3d$var$ACTIVITIES}
   }
`;
const $4117f82aca55ea3d$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$4117f82aca55ea3d$var$ACTIVITIES}
   }
`;
const $4117f82aca55ea3d$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$4117f82aca55ea3d$var$ACTIVITIES}
    }
`;
const $4117f82aca55ea3d$var$activityQueryMap = new Map([
    [
        'workedOn',
        $4117f82aca55ea3d$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $4117f82aca55ea3d$var$VIEWED__QUERY
    ],
    [
        'all',
        $4117f82aca55ea3d$var$ALL__QUERY
    ]
]);
const $4117f82aca55ea3d$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $4117f82aca55ea3d$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $barCt.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $4117f82aca55ea3d$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $4117f82aca55ea3d$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$4117f82aca55ea3d$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $4117f82aca55ea3d$var$getActivitiesQuery(product, $4117f82aca55ea3d$var$getMyActivitiesQuery(activityQueries.map((query)=>$4117f82aca55ea3d$var$activityQueryMap.get(query)))),
        queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};
module.exports["generateActivityQueryWithFilters"] = $4117f82aca55ea3d$export$855cd08371c65b8c;

});

parcelRegister("oLeaD", function(module, exports) {

var $5VeWw = parcelRequire("5VeWw");


var $fwe17 = parcelRequire("fwe17");

const $cbd198d3254213f2$export$5201d39848130041 = {
    v2: (0, $5VeWw.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $fwe17.ACTIVITY_FILTER_V3_MAP)
};
module.exports["ACTIVITY_FILTER_COLLECTION"] = $cbd198d3254213f2$export$5201d39848130041;

});

parcelRegister("5VeWw", function(module, exports) {

var $aTo36 = parcelRequire("aTo36");


var $dfp5E = parcelRequire("dfp5E");

const $dd1d1c00ac927853$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $dfp5E.default)
    ],
    [
        'activities',
        (0, $aTo36.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V2_MAP"] = $dd1d1c00ac927853$export$1dca7bc1ec360897;

});

parcelRegister("aTo36", function(module, exports) {

var $aRf77 = parcelRequire("aRf77");

/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $aed8fa79eb92573e$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $aRf77.generateActivityFiltersV2)(restFilters);
};
var $aed8fa79eb92573e$export$2e2bcd8739ae039 = $aed8fa79eb92573e$var$generateV2ActivitiesFilters;
module.exports["default"] = $aed8fa79eb92573e$export$2e2bcd8739ae039;

});

parcelRegister("aRf77", function(module, exports) {

var $3JrJF = parcelRequire("3JrJF");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $d39b965b3bbf9d59$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $d39b965b3bbf9d59$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $d39b965b3bbf9d59$export$ebef9c1f1e15c057 = (filters = {})=>(0, $3JrJF.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $d39b965b3bbf9d59$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $d39b965b3bbf9d59$var$KEYS_TO_TRANSFROM.has(originalkey) ? $d39b965b3bbf9d59$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });
module.exports["generateActivityFiltersV2"] = $d39b965b3bbf9d59$export$ebef9c1f1e15c057;

});

parcelRegister("3JrJF", function(module, exports) {
const $feda494bd73f070f$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};
module.exports["generateActivityFilters"] = $feda494bd73f070f$export$23c75313f46dd54e;

});

parcelRegister("dfp5E", function(module, exports) {

var $aRf77 = parcelRequire("aRf77");

/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $a72cc322841ef9e0$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $aRf77.generateActivityFiltersV2)(restFilters);
};
var $a72cc322841ef9e0$export$2e2bcd8739ae039 = $a72cc322841ef9e0$var$generateV2MyActivityFilters;
module.exports["default"] = $a72cc322841ef9e0$export$2e2bcd8739ae039;

});

parcelRegister("fwe17", function(module, exports) {

var $4yd2C = parcelRequire("4yd2C");


var $9nmYv = parcelRequire("9nmYv");

const $5c2d14baa4c9c645$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $9nmYv.default)
    ],
    [
        'activities',
        (0, $4yd2C.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V3_MAP"] = $5c2d14baa4c9c645$export$9a1782843b6e99d2;

});

parcelRegister("4yd2C", function(module, exports) {

var $4MKl9 = parcelRequire("4MKl9");

/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $8c0616ed2bef08db$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $4MKl9.generateActivityFiltersV3)(restFilters);
};
var $8c0616ed2bef08db$export$2e2bcd8739ae039 = $8c0616ed2bef08db$var$generateV3ActivityFilters;
module.exports["default"] = $8c0616ed2bef08db$export$2e2bcd8739ae039;

});

parcelRegister("4MKl9", function(module, exports) {

var $3JrJF = parcelRequire("3JrJF");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $817dbd89421fbc4e$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $817dbd89421fbc4e$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds',
    'collabContextId'
];
const $817dbd89421fbc4e$export$e73fe7ded3fe2664 = (filters = {})=>(0, $3JrJF.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $817dbd89421fbc4e$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $817dbd89421fbc4e$var$ROOT_LEVEL_FILTERS);
module.exports["generateActivityFiltersV3"] = $817dbd89421fbc4e$export$e73fe7ded3fe2664;

});

parcelRegister("9nmYv", function(module, exports) {

var $4MKl9 = parcelRequire("4MKl9");

/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $5e1aa0cbd8c0075b$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $4MKl9.generateActivityFiltersV3)(restFilters);
};
var $5e1aa0cbd8c0075b$export$2e2bcd8739ae039 = $5e1aa0cbd8c0075b$var$generateV3MyActivityFilters;
module.exports["default"] = $5e1aa0cbd8c0075b$export$2e2bcd8739ae039;

});

parcelRegister("fKvhW", function(module, exports) {
const $0c995db33b07948e$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $0c995db33b07948e$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$0c995db33b07948e$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}
module.exports["transformActivitiesItems"] = $0c995db33b07948e$export$306a8b649360ca6f;

});

parcelRegister("6vFZD", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $aotCl = parcelRequire("aotCl");


var $iDrrr = parcelRequire("iDrrr");


var $kRg7a = parcelRequire("kRg7a");


var $bXw81 = parcelRequire("bXw81");


var $71leB = parcelRequire("71leB");


var $5qNjK = parcelRequire("5qNjK");


var $4vnKy = parcelRequire("4vnKy");


var $dN8zB = parcelRequire("dN8zB");


var $389Lj = parcelRequire("389Lj");


var $bBnDU = parcelRequire("bBnDU");


var $9vnYD = parcelRequire("9vnYD");


var $2YNjC = parcelRequire("2YNjC");


var $7azIf = parcelRequire("7azIf");


var $iCy8k = parcelRequire("iCy8k");


var $k4jq6 = parcelRequire("k4jq6");


var $2aFdM = parcelRequire("2aFdM");

const $60eeb98ff0f0ced5$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $60eeb98ff0f0ced5$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $60eeb98ff0f0ced5$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $60eeb98ff0f0ced5$var$DEFAULT_TAGS = {
    source: (0, $bXw81.packageName),
    sourcePackageVersion: (0, $bXw81.packageVersion)
};
class $60eeb98ff0f0ced5$export$3c3c237c92ca1fb9 extends (0, $7azIf.ActivityClient) {
    constructor(_product, baseUrl, logger, configFetch, collabContextId){
        super('v3', _product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl, collabContextId);
        this.hydratorConfigClient = void 0;
        this.clientHandlers = void 0;
        this.setProduct = (product)=>{
            this.product = product;
        };
        this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$60eeb98ff0f0ced5$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$60eeb98ff0f0ced5$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig();
        this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $dN8zB.GraphQLJSError)(err));
                    const invalidFragment = (0, $iCy8k.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        };
        this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $aotCl.retryOnException)(async ()=>{
                    const request = (0, $k4jq6.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $2aFdM.filtersToMetadata)(filters)
                    });
                    const res = await (0, $5qNjK.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $2aFdM.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $4vnKy.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $4vnKy.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$60eeb98ff0f0ced5$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$60eeb98ff0f0ced5$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $2aFdM.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $389Lj.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $60eeb98ff0f0ced5$var$transformActivityItem('workedOn', (0, $2aFdM.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $60eeb98ff0f0ced5$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $60eeb98ff0f0ced5$var$transformActivityItem('all', (0, $2aFdM.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $2aFdM.rollupActivitiesData)(activities) : activities;
        };
        this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            const filtersWithCollabContext = this.collabContextId && (0, $iDrrr.fg)('platform_recent_work_collab_context_id') ? {
                ...filters,
                collabContextId: this.collabContextId
            } : filters;
            return (0, $71leB.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filtersWithCollabContext, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $2YNjC.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, _product, configFetch);
    }
}
const $60eeb98ff0f0ced5$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $9vnYD.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc) return (0, $9vnYD.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    if (object.product === 'graph' && (0, $9vnYD.isThirdPartyARI)(object.id)) {
        const product = (0, $9vnYD.parseThirdPartyProduct)(object.id).split('.').at(1);
        return (0, $9vnYD.hydrate3pIcon)(product, hydratedData.icon, hydratedData.staticFallbacks);
    }
    return $60eeb98ff0f0ced5$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $9vnYD.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $9vnYD.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
const $60eeb98ff0f0ced5$var$setStatusHydration = (hydratedData)=>{
    const value = (0, $9vnYD.hydratedValueToString)(hydratedData.statusValue);
    const score = (0, $9vnYD.hydratedValueToString)(hydratedData.statusScore);
    const color = (0, $9vnYD.hydratedValueToString)(hydratedData.statusColor);
    return value || score || color ? {
        value: value,
        score: score,
        color: color
    } : undefined;
};
function $60eeb98ff0f0ced5$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            let product = object.product;
            if (object.product === 'graph' || object.id.startsWith('ari:cloud:graph::pull-request')) product = (0, $2aFdM.getThirdPartyGraphProvider)(object);
            const isSmartlinkViewedType = item.node.event.eventType === (0, $kRg7a.VIEWED_EVENT).SMARTLINK_VIEWED;
            const isSmartlinkViewedGateEnabled = (0, $iDrrr.fg)('platform_recent_work_enable_sl-viewed_results');
            const isExternalPullRequest = item.node.object.data?.__typename === 'ExternalPullRequest';
            const isGithubRecentsEnabled = (0, $cXtTj.default).getExperimentValue('add-github-activityplatform-recentworkitem', 'isEnabled', false);
            if (isSmartlinkViewedType && !isSmartlinkViewedGateEnabled) // Don't return any `sl-viewed` event results
            return acc;
            if (isExternalPullRequest && product === 'github' && !isGithubRecentsEnabled) // Don't return GitHub pull request results until the feature gate is enabled
            return acc;
            // GitHub work items are intentionally not gated here: gating and exposure happen at
            // render time in `recent-work-ui` so we don't over-expose the experiment on every fetch.
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $bBnDU.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $9vnYD.hydratedValueToString)(hydratedData.key, ' ')
                });
                const displayNameEnabledForAssets = product === 'assets' && (0, $iDrrr.fg)('cdm_display_name');
                const containersValue = displayNameEnabledForAssets ? hydratedData.containersWithDisplayName : hydratedData.containers;
                if (containersValue) containers.push({
                    name: (0, $9vnYD.hydratedValueToString)(containersValue, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $kRg7a.WORKED_EVENT).CREATED ? (0, $kRg7a.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $2aFdM.parseRootContainerARI)(object.rootContainerId),
                        icon: $60eeb98ff0f0ced5$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $9vnYD.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $9vnYD.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $9vnYD.hydratedValueToString)(hydratedData.name, ' '),
                        displayName: product === 'assets' && (0, $iDrrr.fg)('cdm_display_name') ? (0, $9vnYD.hydratedValueToString)(hydratedData.displayName, ' ') : undefined,
                        product: product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: (0, $9vnYD.hydratedValueToString)(hydratedData.subtype) || object.data.subtype,
                        url: (0, $9vnYD.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $9vnYD.hydratedValueToString)(hydratedData.objectTypeName),
                        creator: (0, $9vnYD.hydratedValueToString)(hydratedData.creator),
                        providerId: (0, $9vnYD.hydratedValueToString)(hydratedData.providerId),
                        status: $60eeb98ff0f0ced5$var$setStatusHydration(hydratedData),
                        __typename: object.data.__typename
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}
module.exports["ActivityClientV3"] = $60eeb98ff0f0ced5$export$3c3c237c92ca1fb9;

});

parcelRegister("4vnKy", function(module, exports) {
class $7fa32eb1d6399f85$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}
module.exports["GraphQLFragmentError"] = $7fa32eb1d6399f85$export$2d1b192199788179;

});

parcelRegister("dN8zB", function(module, exports) {
class $606f617edf3be1cb$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.error = void 0;
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}
module.exports["GraphQLJSError"] = $606f617edf3be1cb$export$8d4af49ee2a0fbe2;

});

parcelRegister("389Lj", function(module, exports) {
class $7e2b6bcb7f402b78$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.errors = void 0;
        this.errorMessages = void 0;
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}
module.exports["GraphQLNoResultsError"] = $7e2b6bcb7f402b78$export$3f19ff30d409b70;

});

parcelRegister("bBnDU", function(module, exports) {

var $6QC2Y = parcelRequire("6QC2Y");


var $6uL6y = parcelRequire("6uL6y");

const $79d7a50bad301f11$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $79d7a50bad301f11$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $6uL6y.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $6uL6y.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $6uL6y.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $79d7a50bad301f11$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $79d7a50bad301f11$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
        );
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6QC2Y)))(object, path);
}
function $79d7a50bad301f11$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $79d7a50bad301f11$var$getOrSearch(current, split);
    return current;
}
function $79d7a50bad301f11$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($6QC2Y)))(edge, fieldId) === searchValue);
}
function $79d7a50bad301f11$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$79d7a50bad301f11$var$resolvePath(object, path));
}
const $79d7a50bad301f11$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $79d7a50bad301f11$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};
module.exports["hydratePolymorphicData"] = $79d7a50bad301f11$export$d658049bf1a63492;

});

parcelRegister("6uL6y", function(module, exports) {
class $409b0e64cf76bdf6$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        this.originalName = void 0;
        this.originalMessage = void 0;
        this.stack = void 0;
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}
module.exports["default"] = $409b0e64cf76bdf6$export$2e2bcd8739ae039;

});

parcelRegister("9vnYD", function(module, exports) {
const $8e8e08359d6f51e4$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $8e8e08359d6f51e4$var$isURL(icon) {
    return typeof icon === 'string';
}
function $8e8e08359d6f51e4$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $8e8e08359d6f51e4$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $8e8e08359d6f51e4$export$4578ef3572b21f34 = (ari)=>{
    const result = $8e8e08359d6f51e4$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$8e8e08359d6f51e4$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $8e8e08359d6f51e4$export$fccbae65febb6fd4 = (ari)=>$8e8e08359d6f51e4$var$thirdPartyRegex.test(ari);
const $8e8e08359d6f51e4$export$c60ec7b3c8b44fe1 = (product, icons, fallbacks, fallbackKey = 'icon')=>{
    if (fallbacks?.[fallbackKey] && product) {
        const thirdPartyLogo = fallbacks['thirdPartyIconPath']?.replace('{replaceProductName}', product) ?? fallbacks[fallbackKey];
        return {
            type: 'URL',
            value: thirdPartyLogo,
            fallbackIcon: fallbacks[fallbackKey]
        };
    }
    return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
};
const $8e8e08359d6f51e4$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $8e8e08359d6f51e4$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($8e8e08359d6f51e4$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            // return the first emoji
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($8e8e08359d6f51e4$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $8e8e08359d6f51e4$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks?.[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};
module.exports["hydratedValueToString"] = $8e8e08359d6f51e4$export$c5cea44a1f75b431;
module.exports["parseThirdPartyProduct"] = $8e8e08359d6f51e4$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $8e8e08359d6f51e4$export$fccbae65febb6fd4;
module.exports["hydrate3pIcon"] = $8e8e08359d6f51e4$export$c60ec7b3c8b44fe1;
module.exports["hydrateIcon"] = $8e8e08359d6f51e4$export$a328b2bb0d21d984;
module.exports["hydrateConfluenceIcon"] = $8e8e08359d6f51e4$export$86b9f44277b105a6;

});

parcelRegister("2YNjC", function(module, exports) {

var $hp074 = parcelRequire("hp074");


var $daPrQ = parcelRequire("daPrQ");

const $e9e5d234b62d5830$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $e9e5d234b62d5830$var$FD_ENVIRONMENT = 'prod';
const $e9e5d234b62d5830$export$c270c412a04ff3e6 = {
    name: $e9e5d234b62d5830$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $e9e5d234b62d5830$var$FD_ENVIRONMENT
    }
};
class $e9e5d234b62d5830$export$2e2bcd8739ae039 {
    async fetchArtifact() {
        if (this.artifactFetch) return 0, $daPrQ.default;
        // We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
        // https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
        return 0, $daPrQ.default;
    }
    constructor(handlers, product, artifactFetch){
        this.artifactFetch = artifactFetch;
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        new (0, $hp074.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $e9e5d234b62d5830$var$FD_ENVIRONMENT
                },
                value: (0, $daPrQ.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
}
module.exports["FD_CLIENT_FETCH_PROPS"] = $e9e5d234b62d5830$export$c270c412a04ff3e6;
module.exports["default"] = $e9e5d234b62d5830$export$2e2bcd8739ae039;

});

parcelRegister("hp074", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $aotCl = parcelRequire("aotCl");


var $6YrB3 = parcelRequire("6YrB3");


var $5zSfh = parcelRequire("5zSfh");

var $4fKuX = parcelRequire("4fKuX");


var $gdsgI = parcelRequire("gdsgI");


var $2yexq = parcelRequire("2yexq");


var $jAdLj = parcelRequire("jAdLj");

function $cab4dbef42072eb7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cab4dbef42072eb7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cab4dbef42072eb7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ccS36.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cab4dbef42072eb7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cab4dbef42072eb7$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $cab4dbef42072eb7$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $cab4dbef42072eb7$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $aotCl.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $5zSfh.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $gdsgI.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$cab4dbef42072eb7$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $jAdLj.flightDeckClientExperience)() : new (0, $4fKuX.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $cab4dbef42072eb7$var$_objectSpread($cab4dbef42072eb7$var$_objectSpread({}, artifact), {}, {
                key: (0, $2yexq.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $jAdLj.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $ccS36.default)(this, "fallbackArtifactMap", new Map());
        (0, $ccS36.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $6YrB3.default)($cab4dbef42072eb7$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $2yexq.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}
module.exports["default"] = $cab4dbef42072eb7$export$2e2bcd8739ae039;

});

parcelRegister("6YrB3", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");

const $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $293056f9068f55f6$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $293056f9068f55f6$export$2e2bcd8739ae039;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("5zSfh", function(module, exports) {

var $cUcPn = parcelRequire("cUcPn");


var $aeWVV = parcelRequire("aeWVV");


var $8aTXy = parcelRequire("8aTXy");


var $bMJ95 = parcelRequire("bMJ95");


var $bQyPO = parcelRequire("bQyPO");


var $4fKuX = parcelRequire("4fKuX");


var $9SlG7 = parcelRequire("9SlG7");

/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $40fa4ca95a1436e3$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $40fa4ca95a1436e3$var$defaultPerimeter = "commercial";
async function $40fa4ca95a1436e3$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $40fa4ca95a1436e3$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $40fa4ca95a1436e3$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $40fa4ca95a1436e3$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $cUcPn.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $40fa4ca95a1436e3$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $40fa4ca95a1436e3$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $40fa4ca95a1436e3$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $40fa4ca95a1436e3$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $40fa4ca95a1436e3$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $40fa4ca95a1436e3$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $4fKuX.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $4fKuX.getVersionMetadataFetchExperience)();
    return new (0, $bQyPO.ConfigClient)(new (0, $8aTXy.BifrostDataSource)(new (0, $bMJ95.BifrostHttpClientImpl)(env, perimeter), (0, $aeWVV.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $40fa4ca95a1436e3$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}
module.exports["fetchFlightDeckConfiguration"] = $40fa4ca95a1436e3$export$6026918e023c9101;

});

parcelRegister("aeWVV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $7eeoB = parcelRequire("7eeoB");

Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $7eeoB.Either;
    }
});

var $jQrBD = parcelRequire("jQrBD");

Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $jQrBD.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $jQrBD.tryGetArtifactData;
    }
});

var $dyTdO = parcelRequire("dyTdO");

Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $dyTdO.parseArtifactManifest;
    }
});

var $gjGlh = parcelRequire("gjGlh");

Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $gjGlh.parseVersionMetadata;
    }
});

var $gT9Gg = parcelRequire("gT9Gg");

Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $gT9Gg.checkManifest;
    }
});

var $guUcw = parcelRequire("guUcw");

Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $guUcw.ConfigRegistryDataSource;
    }
});

var $k5C8f = parcelRequire("k5C8f");

Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $k5C8f.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $k5C8f.Versions;
    }
});

});

parcelRegister("7eeoB", function(module, exports) {
"use strict";
var $543501ed1db8f46e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $543501ed1db8f46e$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $543501ed1db8f46e$var$Right(value);
    };
    Either.left = function(error) {
        return new $543501ed1db8f46e$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $543501ed1db8f46e$var$Either;
var $543501ed1db8f46e$var$Right = /** @class */ function(_super) {
    $543501ed1db8f46e$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $543501ed1db8f46e$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $543501ed1db8f46e$var$Either.right(this.right);
    };
    return Right;
}($543501ed1db8f46e$var$Either);
var $543501ed1db8f46e$var$Left = /** @class */ function(_super) {
    $543501ed1db8f46e$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $543501ed1db8f46e$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $543501ed1db8f46e$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $543501ed1db8f46e$var$Either.left(f(this.left));
    };
    return Left;
}($543501ed1db8f46e$var$Either);

});

parcelRegister("jQrBD", function(module, exports) {
"use strict";
var $e728499c70b77bcb$var$__assign = module.exports && module.exports.__assign || function() {
    $e728499c70b77bcb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e728499c70b77bcb$var$__assign.apply(this, arguments);
};
var $e728499c70b77bcb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e728499c70b77bcb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $e728499c70b77bcb$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $e728499c70b77bcb$var$tryGetArtifactData;

var $jgJJ5 = parcelRequire("jgJJ5");


var $aeWVV = parcelRequire("aeWVV");


var $cMB7J = parcelRequire("cMB7J");


var $2zHJj = parcelRequire("2zHJj");


var $hXkGE = parcelRequire("hXkGE");

function $e728499c70b77bcb$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $e728499c70b77bcb$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $e728499c70b77bcb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $e728499c70b77bcb$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $e728499c70b77bcb$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $aeWVV.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $cMB7J.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $e728499c70b77bcb$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $2zHJj.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $e728499c70b77bcb$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $e728499c70b77bcb$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $e728499c70b77bcb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $jgJJ5.interpolateTagScheme)(manifest.tagScheme, $e728499c70b77bcb$var$__assign($e728499c70b77bcb$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $e728499c70b77bcb$var$__awaiter(_this, void 0, void 0, function() {
                                return $e728499c70b77bcb$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $e728499c70b77bcb$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $hXkGE.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $hXkGE.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $2zHJj.assertUnreachable)(artifact);
    }
}

});

parcelRegister("jgJJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $e072fb35963a4646$var$interpolateTagScheme;
module.exports.generateTagScheme = $e072fb35963a4646$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $e072fb35963a4646$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $e072fb35963a4646$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $e072fb35963a4646$var$getVersionMetadataTag;
const $e072fb35963a4646$var$TAG_SCHEME_VERSION = 2;
function $e072fb35963a4646$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($e072fb35963a4646$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $e072fb35963a4646$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $e072fb35963a4646$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $e072fb35963a4646$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $e072fb35963a4646$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $e072fb35963a4646$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $e072fb35963a4646$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $e072fb35963a4646$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("cMB7J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $94e6c3b42757e5ce$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $94e6c3b42757e5ce$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("2zHJj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $1e00c5830a29dfbb$var$assertUnreachable;
function $1e00c5830a29dfbb$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("hXkGE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $d127fe55f4fdd4b4$var$toJson;
module.exports.toPrettyJson = $d127fe55f4fdd4b4$var$toPrettyJson;
function $d127fe55f4fdd4b4$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $d127fe55f4fdd4b4$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("dyTdO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $9df9493c8454073d$var$parseArtifactManifest;

var $ly54O = parcelRequire("ly54O");

function $9df9493c8454073d$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $ly54O.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $ly54O.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $9df9493c8454073d$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $ly54O.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $9df9493c8454073d$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $9df9493c8454073d$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $ly54O.parseUnknownObject)(dimensions);
    var supported = (0, $ly54O.parseArray)(unparsedDimensions.supported).map($ly54O.parseString);
    var fallback = (0, $ly54O.parseUndefinedOr)($ly54O.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $9df9493c8454073d$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $ly54O.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $9df9493c8454073d$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $9df9493c8454073d$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $ly54O.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $ly54O.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $ly54O.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $ly54O.parseUndefinedOr)($ly54O.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $9df9493c8454073d$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $9df9493c8454073d$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});

parcelRegister("ly54O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $fb00b60bef1337cc$var$parseString;
module.exports.parseArray = $fb00b60bef1337cc$var$parseArray;
module.exports.parseBoolean = $fb00b60bef1337cc$var$parseBoolean;
module.exports.parseUnknownObject = $fb00b60bef1337cc$var$parseUnknownObject;
module.exports.parseUndefinedOr = $fb00b60bef1337cc$var$parseUndefinedOr;
function $fb00b60bef1337cc$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $fb00b60bef1337cc$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $fb00b60bef1337cc$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $fb00b60bef1337cc$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $fb00b60bef1337cc$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});

parcelRegister("gjGlh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $be0f43fd800fa9b6$var$parseVersionMetadata;

var $ly54O = parcelRequire("ly54O");

function $be0f43fd800fa9b6$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $ly54O.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $ly54O.parseString)(unknownObject.version);
    var publishTime = new Date((0, $ly54O.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $ly54O.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("gT9Gg", function(module, exports) {
"use strict";
var $c4b94ac600725ff5$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $c4b94ac600725ff5$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $c4b94ac600725ff5$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $c4b94ac600725ff5$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("guUcw", function(module, exports) {
"use strict";
var $c02b0b04c20c8875$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c02b0b04c20c8875$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $jgJJ5 = parcelRequire("jgJJ5");


var $7eeoB = parcelRequire("7eeoB");


var $dyTdO = parcelRequire("dyTdO");


var $gjGlh = parcelRequire("gjGlh");

var $c02b0b04c20c8875$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $c02b0b04c20c8875$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $c02b0b04c20c8875$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $jgJJ5.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($dyTdO.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $7eeoB.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $c02b0b04c20c8875$var$__awaiter(this, void 0, void 0, function() {
            return $c02b0b04c20c8875$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $c02b0b04c20c8875$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $c02b0b04c20c8875$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $jgJJ5.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $gjGlh.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $c02b0b04c20c8875$var$ConfigRegistryDataSource;

});

parcelRegister("k5C8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $ea01da83580d84b4$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $ea01da83580d84b4$var$BaseUrls;
var $ea01da83580d84b4$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $ea01da83580d84b4$var$Versions;

});

parcelRegister("8aTXy", function(module, exports) {

var $aeWVV = parcelRequire("aeWVV");


var $jgJJ5 = parcelRequire("jgJJ5");

class $5f3aaa4ea8255d74$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $jgJJ5.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $aeWVV.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $aeWVV.parseVersionMetadata)(response);
                return (0, $aeWVV.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $aeWVV.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $jgJJ5.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $aeWVV.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $aeWVV.parseArtifactManifest)(response);
                return (0, $aeWVV.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $aeWVV.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}
module.exports["BifrostDataSource"] = $5f3aaa4ea8255d74$export$2cb8d79200775058;

});

parcelRegister("bMJ95", function(module, exports) {

var $aeWVV = parcelRequire("aeWVV");

function $8947325f8c19bf7a$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $8947325f8c19bf7a$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $aeWVV.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $aeWVV.Either).right(json)));
            }).catch((error)=>resolve((0, $aeWVV.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $8947325f8c19bf7a$export$f654b28f82155665(env, perimeter);
    }
}
module.exports["BifrostHttpClientImpl"] = $8947325f8c19bf7a$export$45c6d12ca9c14f83;

});

parcelRegister("bQyPO", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $aeWVV = parcelRequire("aeWVV");


var $bwFbe = parcelRequire("bwFbe");

function $89ff9275db847904$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89ff9275db847904$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89ff9275db847904$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ccS36.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89ff9275db847904$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $89ff9275db847904$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $89ff9275db847904$var$_objectSpread($89ff9275db847904$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $aeWVV.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $aeWVV.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $bwFbe.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}
module.exports["ConfigClient"] = $89ff9275db847904$export$8489e2f039bfcc4c;

});

parcelRegister("bwFbe", function(module, exports) {
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $8642a06690dbc6ec$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}
module.exports["ExperienceDataSourceWrapper"] = $8642a06690dbc6ec$export$1cc944571619e6e8;

});

parcelRegister("4fKuX", function(module, exports) {
const $318ca1bf2a2009e5$var$SAMPLING_RATE = 10;
class $318ca1bf2a2009e5$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $318ca1bf2a2009e5$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $318ca1bf2a2009e5$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $318ca1bf2a2009e5$var$SAMPLING_RATE) return new $318ca1bf2a2009e5$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("3XCN6"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $318ca1bf2a2009e5$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $318ca1bf2a2009e5$export$5e7536cf7bc56fee();
    }
}
const $318ca1bf2a2009e5$export$a3006f8f221c0a3b = ()=>$318ca1bf2a2009e5$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $318ca1bf2a2009e5$export$c3ac7702bfd47c1b = ()=>$318ca1bf2a2009e5$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});
module.exports["MockExperience"] = $318ca1bf2a2009e5$export$5e7536cf7bc56fee;
module.exports["getFlightDeckFetchExperience"] = $318ca1bf2a2009e5$export$a3006f8f221c0a3b;
module.exports["getVersionMetadataFetchExperience"] = $318ca1bf2a2009e5$export$c3ac7702bfd47c1b;

});

parcelRegister("3XCN6", function(module, exports) {

let $2e24f8dbeddacf9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e24f8dbeddacf9a$var$load("bB7PO").then(()=>parcelRequire('97TvQ'));

});

parcelRegister("9SlG7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $8atO2 = parcelRequire("8atO2");

Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $8atO2.parseConfigWithTargeting;
    }
});

var $8kx9w = parcelRequire("8kx9w");

Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $8kx9w.TargetedConfig;
    }
});

});

parcelRegister("8atO2", function(module, exports) {
"use strict";
var $0188e0873c702cc6$var$__assign = module.exports && module.exports.__assign || function() {
    $0188e0873c702cc6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0188e0873c702cc6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $0188e0873c702cc6$var$parseConfigWithTargeting;

var $8kx9w = parcelRequire("8kx9w");

/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $0188e0873c702cc6$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $0188e0873c702cc6$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $8kx9w.TargetedConfig({
                defaultConfig: $0188e0873c702cc6$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $0188e0873c702cc6$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $8kx9w.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $0188e0873c702cc6$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $0188e0873c702cc6$var$__assign($0188e0873c702cc6$var$__assign({}, accObject), (_a = {}, _a[key] = $0188e0873c702cc6$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $0188e0873c702cc6$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $0188e0873c702cc6$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $0188e0873c702cc6$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $0188e0873c702cc6$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $0188e0873c702cc6$var$parseIdentifierList(target.orgIds),
            siteIds: $0188e0873c702cc6$var$parseIdentifierList(target.siteIds),
            userIds: $0188e0873c702cc6$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $0188e0873c702cc6$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});

parcelRegister("8kx9w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $6109e865af3fd97d$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
   * Determines whether to use the targeted configuration value or the default value
   * depending on whether the specified values match any of the target's rules.
   *
   * @param target the values to use to evaluate the config
   * @returns the {@link TargetingResult}, which would be the default value
   *     if the specified target did not match, or the targeted value if there
   *     was a match
   */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $6109e865af3fd97d$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $6109e865af3fd97d$var$TargetedConfig;
function $6109e865af3fd97d$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});

parcelRegister("gdsgI", function(module, exports) {
class $bce3c9ca5adb9c28$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $bce3c9ca5adb9c28$export$1d76d155060824c9 = (e)=>e instanceof $bce3c9ca5adb9c28$export$2e2bcd8739ae039;
module.exports["default"] = $bce3c9ca5adb9c28$export$2e2bcd8739ae039;

});

parcelRegister("2yexq", function(module, exports) {
const $1dba08b64c057f56$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};
module.exports["artifactKey"] = $1dba08b64c057f56$export$e3553dc63541d477;

});

parcelRegister("jAdLj", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

function $e41c0dfe29a2cae9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e41c0dfe29a2cae9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e41c0dfe29a2cae9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ccS36.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e41c0dfe29a2cae9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e41c0dfe29a2cae9$export$1e3a41a51f6457c5 = ()=>new (0, $34VCg.UFOExperience)("retrieve-artifact", {
        type: (0, $gZFfs.ExperienceTypes).Operation,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $e41c0dfe29a2cae9$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $e41c0dfe29a2cae9$var$_objectSpread($e41c0dfe29a2cae9$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};
module.exports["flightDeckClientExperience"] = $e41c0dfe29a2cae9$export$1e3a41a51f6457c5;
module.exports["exceptionToMetadata"] = $e41c0dfe29a2cae9$export$f33622abb5224195;

});

parcelRegister("daPrQ", function(module, exports) {
// This file is auto-generated. Do not edit manually.
/* Update via: cd platform/packages/activity-platform/recent-work-client && yarn update:bundled:config */ const $747d6020adabb978$var$_default_1 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-viewed': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            clicked: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-clicked': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'status.value'
                ],
                statusScore: [
                    'status.score'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'state.value'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceWhiteboard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'whiteboardId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceDatabase: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'databaseId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg'
            }
        },
        ConfluenceEmbed: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'embedId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'key'
                ],
                statusValue: [
                    'fieldsByIdOrAlias(fieldId: "status").status.name'
                ],
                statusColor: [
                    'fieldsByIdOrAlias(fieldId: "status").status.statusCategory.colorName'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        TrelloBoard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'boardName'
                ],
                url: [
                    'boardUrl'
                ],
                containers: [
                    'workspace.displayName'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg'
            }
        },
        TrelloCard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'cardName'
                ],
                url: [
                    'cardUrl'
                ],
                containers: [
                    'list.name',
                    'list.board.name'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg'
            }
        },
        DevOpsDocument: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ],
                icon: [
                    'type.iconUrl'
                ]
            }
        },
        DevOpsPullRequestDetails: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                url: [
                    'url'
                ],
                containers: [
                    'repositoryName'
                ],
                key: [
                    'providerName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg'
            }
        },
        DevOpsDesign: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg'
            }
        },
        ExternalDocument: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'type.category'
                ],
                key: [
                    'parent.displayName'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalWorkItem: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/work-item.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalRemoteLink: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'category'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        MercuryFocusArea: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'focusAreaType.name'
                ],
                icon: [
                    'icon.url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg'
            }
        },
        MercuryPortfolio: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'label'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg'
            }
        },
        RadarPosition: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'worker.preferredName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/position.svg'
            }
        },
        RadarView: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'viewName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/view.svg'
            }
        },
        CompassComponent: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'typeMetadata.iconUrl'
                ],
                key: [
                    'typeMetadata.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg'
            }
        },
        BitbucketPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'pullRequestTitle'
                ],
                url: [
                    'href'
                ],
                key: [
                    'pullRequestTitle'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg'
            }
        },
        LoomVideo: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'loomUrl'
                ],
                key: [
                    'owner.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg'
            }
        },
        AssetsObject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'label'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'avatar.url48'
                ],
                containers: [
                    'objectType.schema.name'
                ],
                containersWithDisplayName: [
                    'objectType.schema.displayName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsObjectType: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsObjectTypeName'
                ],
                displayName: [
                    'assetsObjectTypeDisplayName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'assetsObjectTypeIcon.url48'
                ],
                containers: [
                    'schema.assetsSchemaName'
                ],
                containersWithDisplayName: [
                    'schema.assetsSchemaDisplayName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsSchema: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsSchemaName'
                ],
                displayName: [
                    'assetsSchemaDisplayName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n    status {\n      value\n      score\n    }\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n    state {\n      value\n    }\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n  fieldsByIdOrAlias(idsOrAliases: ["status"]) @optIn(to: "JiraIssueFieldsByIdOrAlias") {\n    __typename\n    fieldId\n    ...jiraStatusField\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\nfragment jiraStatusField on JiraStatusField {\n  status {\n    name\n    statusCategory {\n      colorName\n    }\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphExternalPullRequest on ExternalPullRequest {\n  id\n  displayName\n  url\n  pullRequestStatus: status\n  provider {\n    providerId\n  }\n}\n\n\nfragment graphExternalWorkItem on ExternalWorkItem {\n  id\n  displayName\n  url\n  workItemStatus: status\n  provider {\n    providerId\n  }\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\n    fragment radarPosition on RadarPosition {\n        id\n        worker {\n            preferredName\n        }\n        url\n    }\n    \n\n    fragment radarView on RadarView {\n        id\n        viewName\n        url\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        displayName\n        schema {\n          name\n          displayName\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      assetsObjectTypeDisplayName: displayName\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n        assetsSchemaDisplayName: displayName\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      assetsSchemaDisplayName: displayName\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphExternalPullRequest\n\t...graphExternalWorkItem\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...radarPosition\n\t...radarView\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};
var $747d6020adabb978$export$2e2bcd8739ae039 = $747d6020adabb978$var$_default_1;
module.exports["default"] = $747d6020adabb978$export$2e2bcd8739ae039;

});

parcelRegister("iCy8k", function(module, exports) {

var $fBnBW = parcelRequire("fBnBW");

const $cd82f408e3d8050c$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $fBnBW.default)
    ]
]);
const $cd82f408e3d8050c$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $cd82f408e3d8050c$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $cd82f408e3d8050c$export$2e2bcd8739ae039 = $cd82f408e3d8050c$var$graphQLErrorHandler;
module.exports["default"] = $cd82f408e3d8050c$export$2e2bcd8739ae039;

});

parcelRegister("fBnBW", function(module, exports) {
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $d1e1dc0434ef6f24$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $d1e1dc0434ef6f24$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $d1e1dc0434ef6f24$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $d1e1dc0434ef6f24$export$2e2bcd8739ae039 = $d1e1dc0434ef6f24$var$validationErrorHandler;
module.exports["default"] = $d1e1dc0434ef6f24$export$2e2bcd8739ae039;

});

parcelRegister("k4jq6", function(module, exports) {

var $barCt = parcelRequire("barCt");


var $oLeaD = parcelRequire("oLeaD");

const $4b8cb14a4fd64650$var$ACTIVITIES_LIMIT = 50;
const $4b8cb14a4fd64650$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $4b8cb14a4fd64650$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $4b8cb14a4fd64650$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $4b8cb14a4fd64650$var$activityQueryMap = new Map([
    [
        'workedOn',
        $4b8cb14a4fd64650$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $4b8cb14a4fd64650$var$VIEWED__QUERY
    ],
    [
        'all',
        $4b8cb14a4fd64650$var$ALL__QUERY
    ]
]);
const $4b8cb14a4fd64650$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $4b8cb14a4fd64650$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $barCt.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $4b8cb14a4fd64650$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $4b8cb14a4fd64650$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$4b8cb14a4fd64650$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $4b8cb14a4fd64650$var$getActivitiesQuery(product, $4b8cb14a4fd64650$var$getMyActivitiesQuery(activityQueries.map((query)=>$4b8cb14a4fd64650$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $4b8cb14a4fd64650$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $4b8cb14a4fd64650$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $4b8cb14a4fd64650$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $barCt.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};
module.exports["generateGraphQLRequest"] = $4b8cb14a4fd64650$export$7489a6ef09862e48;

});

parcelRegister("2aFdM", function(module, exports) {

var $eYVId = parcelRequire("eYVId");

function $d3ba7dec68c331b0$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $d3ba7dec68c331b0$var$rollUpActivityItems(all),
        viewed: $d3ba7dec68c331b0$var$rollUpActivityItems(viewed),
        workedOn: $d3ba7dec68c331b0$var$rollUpActivityItems(workedOn)
    };
}
function $d3ba7dec68c331b0$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $d3ba7dec68c331b0$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$d3ba7dec68c331b0$var$fragmentName(key)} on ${$d3ba7dec68c331b0$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $d3ba7dec68c331b0$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $d3ba7dec68c331b0$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $d3ba7dec68c331b0$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $d3ba7dec68c331b0$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $d3ba7dec68c331b0$var$containerMapTypes = new Map([
    [
        $d3ba7dec68c331b0$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $d3ba7dec68c331b0$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $d3ba7dec68c331b0$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $d3ba7dec68c331b0$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $d3ba7dec68c331b0$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $d3ba7dec68c331b0$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$d3ba7dec68c331b0$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($d3ba7dec68c331b0$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $d3ba7dec68c331b0$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $d3ba7dec68c331b0$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$d3ba7dec68c331b0$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $d3ba7dec68c331b0$export$884573c560ed3600(response.data);
}
function $d3ba7dec68c331b0$export$884573c560ed3600(queryData) {
    return !queryData.activity || $d3ba7dec68c331b0$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $d3ba7dec68c331b0$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}
function $d3ba7dec68c331b0$export$618af76292d5645c(object) {
    const ari = object.id;
    let product = 'graph';
    if (ari.startsWith('ari:cloud:graph::pull-request') && object.data?.providerName) product = object.data?.providerName || 'graph';
    else if ((0, $eYVId.isThirdPartyARI)(ari)) product = (0, $eYVId.parseThirdPartyProduct)(ari).split('.')[1];
    return product.toLowerCase();
}
module.exports["rollupActivitiesData"] = $d3ba7dec68c331b0$export$750d93207e30f59a;
module.exports["activityRoot"] = $d3ba7dec68c331b0$export$ea55e8e0446efa94;
module.exports["parseRootContainerARI"] = $d3ba7dec68c331b0$export$788e6013936a6bb4;
module.exports["filtersToMetadata"] = $d3ba7dec68c331b0$export$e8f56bed6776c7ea;
module.exports["filterInvalidFragments"] = $d3ba7dec68c331b0$export$e22863ec502608d2;
module.exports["isEmptyActivitiesWithErrorsResponse"] = $d3ba7dec68c331b0$export$c939d6148e47244a;
module.exports["getThirdPartyGraphProvider"] = $d3ba7dec68c331b0$export$618af76292d5645c;

});

parcelRegister("eYVId", function(module, exports) {
const $e92e795e072a2a50$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $e92e795e072a2a50$export$4578ef3572b21f34 = (ari)=>{
    const result = $e92e795e072a2a50$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$e92e795e072a2a50$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $e92e795e072a2a50$export$fccbae65febb6fd4 = (ari)=>$e92e795e072a2a50$var$thirdPartyRegex.test(ari);
module.exports["parseThirdPartyProduct"] = $e92e795e072a2a50$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $e92e795e072a2a50$export$fccbae65febb6fd4;

});

parcelRegister("4NuaM", function(module, exports) {
const $db5eae801f82341d$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
module.exports["filterItems"] = $db5eae801f82341d$export$16c4c0987c894b8c;

});

parcelRegister("4eTDd", function(module, exports) {

var $g6P2L = parcelRequire("g6P2L");

const $f6487c9b6ab4b005$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// Use the icon url from the quick search result if it exists but still resolve the altText,
        // which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $g6P2L.getIconFromContentType)(contentType, subtype).iconAlt
        } : (0, $g6P2L.getIconFromContentType)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
module.exports["mapSearchProviderResultToLinkSearchItemData"] = $f6487c9b6ab4b005$export$b76efb0c656bea6e;

});

parcelRegister("g6P2L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cSGyR = parcelRequire("cSGyR");


var $bltJZ = parcelRequire("bltJZ");





var $iW3KC = parcelRequire("iW3KC");


var $fHe6f = parcelRequire("fHe6f");


var $hkAs2 = parcelRequire("hkAs2");


var $6MsAF = parcelRequire("6MsAF");


var $2qJQZ = parcelRequire("2qJQZ");


var $7pJjg = parcelRequire("7pJjg");


var $bvjEB = parcelRequire("bvjEB");


var $a5G9M = parcelRequire("a5G9M");


var $dt415 = parcelRequire("dt415");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $izhqE = parcelRequire("izhqE");


var $lghDo = parcelRequire("lghDo");

var $6505997651b2e5f7$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    return LinkContentType;
}($6505997651b2e5f7$var$LinkContentType || {});
const $6505997651b2e5f7$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $izhqE.EmptyStateNoResults), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $6505997651b2e5f7$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($6505997651b2e5f7$var$LinkContentType).includes(contentType));
};
const $6505997651b2e5f7$export$80e948449ec854a9 = {
    'jira.issue': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iW3KC.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dt415.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomIcon), {
                label: alt,
                shouldUseNewLogoDesign: true,
                size: "xxsmall"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkAs2.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconEmbedLabel
    }
};
const $6505997651b2e5f7$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$6505997651b2e5f7$export$f642707b43bbbafc(contentType)) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $iDrrr.fg)('confluence-issue-terminology-refresh')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live') return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7pJjg.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconLiveDocLabel
    };
    return $6505997651b2e5f7$export$80e948449ec854a9[contentType];
};
const $6505997651b2e5f7$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $lghDo.messages).defaultAltText;
    // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $lghDo.messages).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $lghDo.messages).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $lghDo.messages).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $lghDo.messages).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $lghDo.messages).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $lghDo.messages).improvement;
    return alt;
};
const $6505997651b2e5f7$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $6505997651b2e5f7$export$ac1fda7301622804(iconUrl)
    };
};
module.exports["renderEmptyStateNoResults"] = $6505997651b2e5f7$export$74b0c6644317c84d;
module.exports["getIconFromContentType"] = $6505997651b2e5f7$export$d71678bb4eba5b81;
module.exports["getIconFromIconUrl"] = $6505997651b2e5f7$export$fd251dec3e575ea1;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("hkAs2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lBKFk = parcelRequire("lBKFk");


var $4hmAW = parcelRequire("4hmAW");

const $a395f01d1124dfc4$var$DatabaseObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DatabaseObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Database" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function DatabaseObject({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $a395f01d1124dfc4$export$2e2bcd8739ae039 = $a395f01d1124dfc4$var$DatabaseObject;
module.exports["default"] = $a395f01d1124dfc4$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53807950cf9f28638ee48a6f68a59d1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_baseNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("dt415", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bDjVc = parcelRequire("bDjVc");


var $4hmAW = parcelRequire("4hmAW");

const $a250350db8bca8ef$var$WhiteboardObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WhiteboardObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Whiteboard" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
            color: "var(--ds-icon-accent-teal, #2898BD)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WhiteboardObject({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
};
var $a250350db8bca8ef$export$2e2bcd8739ae039 = $a250350db8bca8ef$var$WhiteboardObject;
module.exports["default"] = $a250350db8bca8ef$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("izhqE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $i1t43 = parcelRequire("i1t43");


var $itxfh = parcelRequire("itxfh");


var $ddF74 = parcelRequire("ddF74");


var $iDrrr = parcelRequire("iDrrr");


var $6FvMC = parcelRequire("6FvMC");

const $5baa30569a0602bd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResults: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading",
        defaultMessage: "Get started with {productName}."
    },
    noResultsConfluenceDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription",
        defaultMessage: "Recently viewed pages will appear once you <link>start using Confluence</link>."
    },
    noResultsJiraDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription",
        defaultMessage: "Recently viewed issues will appear once you <link>start using Jira</link>."
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4",
        defaultMessage: "Recently viewed work items will appear once you <link>start using Jira</link>."
    },
    noResultsDefaultDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription",
        defaultMessage: "Recently viewed items will appear once you <link>start using {productName}</link>."
    },
    noResultsConfluenceCreateOption: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description",
        defaultMessage: "You can also create a new page."
    }
});
const $5baa30569a0602bd$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $5baa30569a0602bd$var$emptyStateWrapperStyles = null;
const $5baa30569a0602bd$export$e661eeb828fb7b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { product: product, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { data: data } = (0, $itxfh.useAvailableSites)();
    const isConfluence = product === "confluence";
    let t1;
    if ($[0] !== cloudId || $[1] !== data || $[2] !== intl || $[3] !== isConfluence || $[4] !== isMultisiteSearch || $[5] !== product) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const productDetails = $5baa30569a0602bd$export$dc8a6c8f6bc81cdd(product);
            if (!productDetails) {
                t1 = null;
                break bb0;
            }
            const firstMatchingSite = data.find($5baa30569a0602bd$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
            if (firstMatchingSite) {
                let baseUrl = firstMatchingSite.url;
                if (isConfluence) {
                    baseUrl = baseUrl + "/wiki";
                    baseUrl;
                }
                const intlDescription = intl.formatMessage(productDetails.description, {
                    productName: productDetails.productName,
                    link: (str)=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                            href: baseUrl
                        }, str)
                });
                let t2;
                if ($[7] !== intl || $[8] !== isConfluence) {
                    t2 = isConfluence ? intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResultsConfluenceCreateOption) : "";
                    $[7] = intl;
                    $[8] = isConfluence;
                    $[9] = t2;
                } else t2 = $[9];
                const intlConfCreate = t2;
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = (0, $hekY6.default)([
                        "_1DCdHiUgYP _0PxwN5dnbC _2ukBsMdnbC _1IqrEmdnbC _0NvCJadnbC"
                    ]);
                    $[10] = t3;
                } else t3 = $[10];
                let t4;
                if ($[11] !== intlConfCreate || $[12] !== intlDescription) {
                    t4 = /*#__PURE__*/ $cozmU.createElement("span", null, intlDescription, " ", intlConfCreate);
                    $[11] = intlConfCreate;
                    $[12] = intlDescription;
                    $[13] = t4;
                } else t4 = $[13];
                const t5 = /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
                    testId: $5baa30569a0602bd$export$800daf5fbbe96aff.emptyStateNoResults,
                    header: intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResults, {
                        productName: productDetails.productName
                    }),
                    description: t4,
                    renderImage: $5baa30569a0602bd$var$_temp
                });
                let t6;
                if ($[14] !== t3 || $[15] !== t5) {
                    t6 = /*#__PURE__*/ $cozmU.createElement("div", {
                        className: t3
                    }, t5);
                    $[14] = t3;
                    $[15] = t5;
                    $[16] = t6;
                } else t6 = $[16];
                t1 = t6;
                break bb0;
            }
        }
        $[0] = cloudId;
        $[1] = data;
        $[2] = intl;
        $[3] = isConfluence;
        $[4] = isMultisiteSearch;
        $[5] = product;
        $[6] = t1;
    } else t1 = $[6];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    return null;
} : ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { data: data } = (0, $itxfh.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $5baa30569a0602bd$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
     // find the first matching site for this product
    const firstMatchingSite = data.find($5baa30569a0602bd$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url; // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                    href: baseUrl
                }, str)
        }); // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence ? intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1DCdHiUgYP _0PxwN5dnbC _2ukBsMdnbC _1IqrEmdnbC _0NvCJadnbC"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
            testId: $5baa30569a0602bd$export$800daf5fbbe96aff.emptyStateNoResults,
            header: intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResults, {
                productName: productDetails.productName
            }),
            description: /*#__PURE__*/ $cozmU.createElement("span", null, intlDescription, " ", intlConfCreate),
            renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $6FvMC.EmptyStateNoResultsSVG), null)
        }));
    }
    return null;
};
const $5baa30569a0602bd$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $ddF74.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $5baa30569a0602bd$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $ddF74.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $iDrrr.fg)('jira-issue-terminology-update-m4') ? $5baa30569a0602bd$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $5baa30569a0602bd$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $ddF74.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $5baa30569a0602bd$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $5baa30569a0602bd$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
         // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
         // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
         // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};
function $5baa30569a0602bd$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $6FvMC.EmptyStateNoResultsSVG), null);
}
module.exports["EmptyStateNoResults"] = $5baa30569a0602bd$export$e661eeb828fb7b2;

});

parcelRegister("itxfh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ddF74 = parcelRequire("ddF74");


var $jRVxN = parcelRequire("jRVxN");


var $bwuOg = parcelRequire("bwuOg");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $fQNdm = parcelRequire("fQNdm");


var $97v23 = parcelRequire("97v23");

const $466b025cd737fb7d$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $466b025cd737fb7d$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $466b025cd737fb7d$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $466b025cd737fb7d$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $466b025cd737fb7d$var$defaultProducts = [
    (0, $ddF74.AvailableSitesProductType).WHITEBOARD,
    (0, $ddF74.AvailableSitesProductType).BEACON,
    (0, $ddF74.AvailableSitesProductType).COMPASS,
    (0, $ddF74.AvailableSitesProductType).CONFLUENCE,
    (0, $ddF74.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $ddF74.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $ddF74.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $ddF74.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $ddF74.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $ddF74.AvailableSitesProductType).MERCURY,
    (0, $ddF74.AvailableSitesProductType).OPSGENIE,
    (0, $ddF74.AvailableSitesProductType).STATUS_PAGE,
    (0, $ddF74.AvailableSitesProductType).ATLAS,
    (0, $ddF74.AvailableSitesProductType).LOOM
];
const $466b025cd737fb7d$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $cozmU.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $466b025cd737fb7d$var$getAvailableSites({
                    products: $466b025cd737fb7d$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    // TODO As part of NAVX-5287 (FG cleanup) remove the map and go back to `data: sites`
                    // As isVertigo be removed in same PR it doesn't matter if data will be back again.
                    data: (0, $iDrrr.fg)('platform_lp_kill_isvertigo_and_vortexmode') ? sites.map((site)=>({
                            ...site,
                            isVertigo: undefined
                        })) : sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $jRVxN.default)('operational.getAvailableSitesResolve.failed', (0, $97v23.getOperationFailedAttributes)(err))).fire((0, $bwuOg.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $466b025cd737fb7d$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: (0, $iDrrr.fg)('platform_lp_kill_isvertigo_and_vortexmode') ? undefined : workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $466b025cd737fb7d$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isMounted = (0, $fQNdm.useIsMounted)();
    const [state, setState] = (0, $cozmU.useState)({
        data: [],
        loading: true
    });
    (0, $cozmU.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $466b025cd737fb7d$var$getAccessibleProducts({
                    products: $466b025cd737fb7d$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $466b025cd737fb7d$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $466b025cd737fb7d$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $iDrrr.fg)('linking_platform_site_picker_api_unit_compliant') ? $466b025cd737fb7d$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $466b025cd737fb7d$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $466b025cd737fb7d$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $iDrrr.fg)('linking_platform_site_picker_api_unit_compliant') ? $466b025cd737fb7d$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $466b025cd737fb7d$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $466b025cd737fb7d$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $466b025cd737fb7d$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $466b025cd737fb7d$export$3f59b707a86875c4;

});

parcelRegister("ddF74", function(module, exports) {
var $7db9c4a56f6bda5d$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $7db9c4a56f6bda5d$export$16bdf84263b17cf0;

});

parcelRegister("jRVxN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $62998fd154a225d3$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $62998fd154a225d3$export$2e2bcd8739ae039 = $62998fd154a225d3$var$createEventPayload;
module.exports["default"] = $62998fd154a225d3$export$2e2bcd8739ae039;

});

parcelRegister("bwuOg", function(module, exports) {
const $74d2fe053a191110$export$85183a312807388d = 'media';
const $74d2fe053a191110$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $74d2fe053a191110$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $74d2fe053a191110$export$60efea3f80310017;

});

parcelRegister("fQNdm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fa3920351735de97$export$80c2a3957bcb42ea() {
    const isMounted = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $cozmU.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $fa3920351735de97$export$80c2a3957bcb42ea;

});

parcelRegister("97v23", function(module, exports) {

var $lOgJi = parcelRequire("lOgJi");

const $56421f9b4912d2ef$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $56421f9b4912d2ef$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $lOgJi.getTraceId)(error),
        status: error.status,
        path: $56421f9b4912d2ef$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $56421f9b4912d2ef$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $56421f9b4912d2ef$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$56421f9b4912d2ef$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $56421f9b4912d2ef$export$b2d107ab31565d0b;

});

parcelRegister("lOgJi", function(module, exports) {
function $e9f99b887d228dab$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $e9f99b887d228dab$export$e88cb5bfb57ce9c4;

});

parcelRegister("6FvMC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $de8ab48fa30d5146$var$noResultsSVGStyles = null;
const $de8ab48fa30d5146$export$88f98178b806da03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 96 96",
            className: (0, $hekY6.default)([
                "_39xV02JgOI _0jFU0VJgOI _313842dnbC _0adFHsIZbP _1DCdHi5zaO _2XsHFMIZbP _3iDTPbvLZJ"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#FCA700",
            d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#1868DB",
            d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#101214",
            d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#09326C",
            d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _313842dnbC _0adFHsIZbP _1DCdHi5zaO _2XsHFMIZbP _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#FCA700",
        d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#1868DB",
        d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#101214",
        d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#09326C",
        d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
    }));
};
module.exports["EmptyStateNoResultsSVG"] = $de8ab48fa30d5146$export$88f98178b806da03;

});

parcelRegister("lghDo", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f755c04d07f13e9f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconEpicLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEpicLabel",
        defaultMessage: "Epic"
    },
    hyperlinkIconDashboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel",
        defaultMessage: "Dashboard"
    },
    hyperlinkIconBoardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBoardLabel",
        defaultMessage: "Board"
    },
    hyperlinkIconProjectLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconProjectLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPlanLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPlanLabel",
        defaultMessage: "Plan"
    },
    hyperlinkIconFilterLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconFilterLabel",
        defaultMessage: "Filter"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconWhiteboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel",
        defaultMessage: "Whiteboard"
    },
    hyperlinkIconDatabaseLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel",
        defaultMessage: "Database"
    },
    hyperlinkIconEmbedLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel",
        defaultMessage: "Smart Link"
    },
    hyperlinkIconLoomLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLoomLabel",
        defaultMessage: "Loom"
    },
    hyperlinkIconLiveDocLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel",
        defaultMessage: "Live Doc"
    },
    story: {
        id: "fabric.linkPicker.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.linkPicker.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.linkPicker.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.linkPicker.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.linkPicker.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.linkPicker.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.linkPicker.defaultAltText",
        defaultMessage: "List item"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh",
        defaultMessage: "Work item"
    }
});
module.exports["messages"] = $f755c04d07f13e9f$export$defe85febe8b728c;

});

parcelRegister("402Va", function(module, exports) {

var $9cGsb = parcelRequire("9cGsb");


var $fCd3b = parcelRequire("fCd3b");


var $b4vCW = parcelRequire("b4vCW");

const $805b90bae39ab0c7$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $805b90bae39ab0c7$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $805b90bae39ab0c7$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $9cGsb.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $805b90bae39ab0c7$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $b4vCW.Scope).ConfluencePageBlog || this.scope === (0, $b4vCW.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $b4vCW.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).JiraIssue || this.scope === (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $805b90bae39ab0c7$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $b4vCW.Scope).ConfluencePageBlog:
            case (0, $b4vCW.Scope).ConfluencePageBlogWhiteboard:
            case (0, $b4vCW.Scope).ConfluenceContentType:
            case (0, $b4vCW.Scope).JiraIssue:
            case (0, $b4vCW.Scope).JiraDashboard:
            case (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $b4vCW.Scope).TownsquareProject:
            case (0, $b4vCW.Scope).TownsquareGoal:
            case (0, $b4vCW.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $fCd3b.createClient)(config);
    }
}
module.exports["default"] = $805b90bae39ab0c7$export$2e2bcd8739ae039;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
   * Converts this Ari to a string.
   */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
   * Converts this object to its json representation
   */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("fCd3b", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $iVNH5 = parcelRequire("iVNH5");

const $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY = 3;
const $a663f43e8e7364a7$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY);
};
class $a663f43e8e7364a7$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $a663f43e8e7364a7$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $iVNH5.timed)(this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $gABt9.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $a663f43e8e7364a7$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $a663f43e8e7364a7$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $a663f43e8e7364a7$export$5d730b7aed1a3eb0;

});

parcelRegister("iVNH5", function(module, exports) {
const $7a547b1e741af2d7$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $7a547b1e741af2d7$export$d35186a762cd39c8;

});

parcelRegister("jKzTq", function(module, exports) {

var $g6P2L = parcelRequire("g6P2L");

const $b9531dc073aa2fb5$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' ? (0, $g6P2L.getIconFromContentType)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $g6P2L.getIconFromIconUrl)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $b9531dc073aa2fb5$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $b9531dc073aa2fb5$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $b9531dc073aa2fb5$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
     * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
     */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $b9531dc073aa2fb5$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$b9531dc073aa2fb5$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}
module.exports["mapActivityClientResultToLinkSearchItemData"] = $b9531dc073aa2fb5$export$d82137ca931458ca;
module.exports["getArisForProducts"] = $b9531dc073aa2fb5$export$4b7ffcf66d37c47b;

});

parcelRegister("lLexe", function(module, exports) {

let $fd794316541691fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd794316541691fb$var$load("6lkHg"),
    $fd794316541691fb$var$load("dq8fV"),
    $fd794316541691fb$var$load("6wr18"),
    $fd794316541691fb$var$load("do0Fh"),
    $fd794316541691fb$var$load("1ce1Q"),
    $fd794316541691fb$var$load("l25pP"),
    $fd794316541691fb$var$load("ffEVr"),
    $fd794316541691fb$var$load("gA528"),
    $fd794316541691fb$var$load("gzrfp"),
    $fd794316541691fb$var$load("7EorR"),
    $fd794316541691fb$var$load("ewN9L")
]).then(()=>parcelRequire('h1XR5'));

});

parcelRegister("7CqGl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $a9l0O = parcelRequire("a9l0O");

const $88e9d6c2408f7e5a$export$b924f0f6b5fc4412 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(32);
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    let t0;
    if ($[0] !== sendAnalyticsEvent) {
        t0 = (t1)=>{
            const { spaceId: spaceId, sourceCount: sourceCount, createdFrom: createdFrom, hasInitialConversation: hasInitialConversation } = t1;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "track",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.spaceCreated,
                attributes: {
                    spaceId: spaceId,
                    sourceCount: sourceCount,
                    createdFrom: createdFrom,
                    hasInitialConversation: hasInitialConversation
                }
            });
        };
        $[0] = sendAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireSpaceCreated = t0;
    let t1;
    if ($[2] !== sendAnalyticsEvent) {
        t1 = (t2)=>{
            const { spaceId: spaceId_0, sourceType: sourceType, addMethod: addMethod, recommendationId: recommendationId, sourceCount: sourceCount_0 } = t2;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "track",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.sourceAdded,
                attributes: {
                    spaceId: spaceId_0,
                    sourceType: sourceType,
                    addMethod: addMethod,
                    recommendationId: recommendationId,
                    sourceCount: sourceCount_0
                }
            });
        };
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const fireSourceAdded = t1;
    let t2;
    if ($[4] !== sendAnalyticsEvent) {
        t2 = (t3)=>{
            const { spaceId: spaceId_1, sourceType: sourceType_0 } = t3;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "track",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.sourceRemoved,
                attributes: {
                    spaceId: spaceId_1,
                    sourceType: sourceType_0
                }
            });
        };
        $[4] = sendAnalyticsEvent;
        $[5] = t2;
    } else t2 = $[5];
    const fireSourceRemoved = t2;
    let t3;
    if ($[6] !== sendAnalyticsEvent) {
        t3 = (t4)=>{
            const { spaceId: spaceId_2, recommendationCount: recommendationCount } = t4;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "ui",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.sourceRecommendationsViewed,
                attributes: {
                    spaceId: spaceId_2,
                    recommendationCount: recommendationCount
                }
            });
        };
        $[6] = sendAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const fireSourceRecommendationsViewed = t3;
    let t4;
    if ($[8] !== sendAnalyticsEvent || $[9] !== trackAIMAUEvent) {
        t4 = (t5)=>{
            const { spaceId: spaceId_3, addedFrom: addedFrom, method: method } = t5;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "track",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.conversationAdded,
                attributes: {
                    spaceId: spaceId_3,
                    addedFrom: addedFrom,
                    method: method
                }
            });
            trackAIMAUEvent({
                type: "actioned",
                source: (0, $a9l0O.SPACES_ANALYTICS).mauSource,
                subjectId: (0, $a9l0O.SPACES_ANALYTICS).events.conversationAdded.actionSubject,
                actionResult: "success",
                attributes: {
                    spaceId: spaceId_3,
                    addedFrom: addedFrom,
                    method: method
                }
            });
        };
        $[8] = sendAnalyticsEvent;
        $[9] = trackAIMAUEvent;
        $[10] = t4;
    } else t4 = $[10];
    const fireConversationAdded = t4;
    let t5;
    if ($[11] !== sendAnalyticsEvent) {
        t5 = (t6)=>{
            const { spaceId: spaceId_4, sourceCount: sourceCount_1, chatCount: chatCount, activeTab: activeTab, fullScreen: fullScreen, entryPoint: entryPoint } = t6;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "screen",
                name: (0, $a9l0O.SPACES_ANALYTICS).screens.spaceLandingPage,
                attributes: {
                    spaceId: spaceId_4,
                    sourceCount: sourceCount_1,
                    chatCount: chatCount,
                    activeTab: activeTab,
                    fullScreen: fullScreen,
                    entryPoint: entryPoint
                }
            });
        };
        $[11] = sendAnalyticsEvent;
        $[12] = t5;
    } else t5 = $[12];
    const fireSpaceViewed = t5;
    let t6;
    if ($[13] !== sendAnalyticsEvent) {
        t6 = (t7)=>{
            const { queryLength: queryLength, resultCount: resultCount } = t7;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "track",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.spaceSearched,
                attributes: {
                    queryLength: queryLength,
                    resultCount: resultCount
                }
            });
        };
        $[13] = sendAnalyticsEvent;
        $[14] = t6;
    } else t6 = $[14];
    const fireSpaceSearched = t6;
    let t7;
    if ($[15] !== sendAnalyticsEvent) {
        t7 = (t8)=>{
            const { spaceId: spaceId_5, starterId: starterId } = t8;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "ui",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.starterClicked,
                attributes: {
                    spaceId: spaceId_5,
                    starterId: starterId
                }
            });
        };
        $[15] = sendAnalyticsEvent;
        $[16] = t7;
    } else t7 = $[16];
    const fireStarterClicked = t7;
    let t8;
    if ($[17] !== sendAnalyticsEvent) {
        t8 = (t9)=>{
            const { spaceId: spaceId_6 } = t9;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "track",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.memoryCreated,
                attributes: {
                    spaceId: spaceId_6
                }
            });
        };
        $[17] = sendAnalyticsEvent;
        $[18] = t8;
    } else t8 = $[18];
    const fireMemoryCreated = t8;
    let t9;
    if ($[19] !== sendAnalyticsEvent) {
        t9 = (t10)=>{
            const { spaceId: spaceId_7, count: count } = t10;
            if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false)) return;
            sendAnalyticsEvent({
                eventType: "ui",
                ...(0, $a9l0O.SPACES_ANALYTICS).events.memoriesViewed,
                attributes: {
                    spaceId: spaceId_7,
                    count: count
                }
            });
        };
        $[19] = sendAnalyticsEvent;
        $[20] = t9;
    } else t9 = $[20];
    const fireMemoriesViewed = t9;
    let t10;
    if ($[21] !== fireConversationAdded || $[22] !== fireMemoriesViewed || $[23] !== fireMemoryCreated || $[24] !== fireSourceAdded || $[25] !== fireSourceRecommendationsViewed || $[26] !== fireSourceRemoved || $[27] !== fireSpaceCreated || $[28] !== fireSpaceSearched || $[29] !== fireSpaceViewed || $[30] !== fireStarterClicked) {
        t10 = {
            fireSpaceCreated: fireSpaceCreated,
            fireSourceAdded: fireSourceAdded,
            fireSourceRemoved: fireSourceRemoved,
            fireSourceRecommendationsViewed: fireSourceRecommendationsViewed,
            fireConversationAdded: fireConversationAdded,
            fireSpaceViewed: fireSpaceViewed,
            fireSpaceSearched: fireSpaceSearched,
            fireStarterClicked: fireStarterClicked,
            fireMemoryCreated: fireMemoryCreated,
            fireMemoriesViewed: fireMemoriesViewed
        };
        $[21] = fireConversationAdded;
        $[22] = fireMemoriesViewed;
        $[23] = fireMemoryCreated;
        $[24] = fireSourceAdded;
        $[25] = fireSourceRecommendationsViewed;
        $[26] = fireSourceRemoved;
        $[27] = fireSpaceCreated;
        $[28] = fireSpaceSearched;
        $[29] = fireSpaceViewed;
        $[30] = fireStarterClicked;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const fireSpaceCreated = (0, $cozmU.useCallback)(({ spaceId: spaceId, sourceCount: sourceCount, createdFrom: createdFrom, hasInitialConversation: hasInitialConversation })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.spaceCreated,
            attributes: {
                spaceId: spaceId,
                sourceCount: sourceCount,
                createdFrom: createdFrom,
                hasInitialConversation: hasInitialConversation
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireSourceAdded = (0, $cozmU.useCallback)(({ spaceId: spaceId_0, sourceType: sourceType, addMethod: addMethod, recommendationId: recommendationId, sourceCount: sourceCount_0 })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.sourceAdded,
            attributes: {
                spaceId: spaceId_0,
                sourceType: sourceType,
                addMethod: addMethod,
                recommendationId: recommendationId,
                sourceCount: sourceCount_0
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireSourceRemoved = (0, $cozmU.useCallback)(({ spaceId: spaceId_1, sourceType: sourceType_0 })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.sourceRemoved,
            attributes: {
                spaceId: spaceId_1,
                sourceType: sourceType_0
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireSourceRecommendationsViewed = (0, $cozmU.useCallback)(({ spaceId: spaceId_2, recommendationCount: recommendationCount })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.sourceRecommendationsViewed,
            attributes: {
                spaceId: spaceId_2,
                recommendationCount: recommendationCount
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireConversationAdded = (0, $cozmU.useCallback)(({ spaceId: spaceId_3, addedFrom: addedFrom, method: method })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.conversationAdded,
            attributes: {
                spaceId: spaceId_3,
                addedFrom: addedFrom,
                method: method
            }
        });
        // Value-moment: count this toward Rovo Chat MAU.
        trackAIMAUEvent({
            type: 'actioned',
            source: (0, $a9l0O.SPACES_ANALYTICS).mauSource,
            subjectId: (0, $a9l0O.SPACES_ANALYTICS).events.conversationAdded.actionSubject,
            actionResult: 'success',
            attributes: {
                spaceId: spaceId_3,
                addedFrom: addedFrom,
                method: method
            }
        });
    }, [
        sendAnalyticsEvent,
        trackAIMAUEvent
    ]);
    const fireSpaceViewed = (0, $cozmU.useCallback)(({ spaceId: spaceId_4, sourceCount: sourceCount_1, chatCount: chatCount, activeTab: activeTab, fullScreen: fullScreen, entryPoint: entryPoint })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: (0, $a9l0O.SPACES_ANALYTICS).screens.spaceLandingPage,
            attributes: {
                spaceId: spaceId_4,
                sourceCount: sourceCount_1,
                chatCount: chatCount,
                activeTab: activeTab,
                fullScreen: fullScreen,
                entryPoint: entryPoint
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireSpaceSearched = (0, $cozmU.useCallback)(({ queryLength: queryLength, resultCount: resultCount })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.spaceSearched,
            attributes: {
                queryLength: queryLength,
                resultCount: resultCount
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireStarterClicked = (0, $cozmU.useCallback)(({ spaceId: spaceId_5, starterId: starterId })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.starterClicked,
            attributes: {
                spaceId: spaceId_5,
                starterId: starterId
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireMemoryCreated = (0, $cozmU.useCallback)(({ spaceId: spaceId_6 })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.memoryCreated,
            attributes: {
                spaceId: spaceId_6
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireMemoriesViewed = (0, $cozmU.useCallback)(({ spaceId: spaceId_7, count: count })=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false)) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            ...(0, $a9l0O.SPACES_ANALYTICS).events.memoriesViewed,
            attributes: {
                spaceId: spaceId_7,
                count: count
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            fireSpaceCreated: fireSpaceCreated,
            fireSourceAdded: fireSourceAdded,
            fireSourceRemoved: fireSourceRemoved,
            fireSourceRecommendationsViewed: fireSourceRecommendationsViewed,
            fireConversationAdded: fireConversationAdded,
            fireSpaceViewed: fireSpaceViewed,
            fireSpaceSearched: fireSpaceSearched,
            fireStarterClicked: fireStarterClicked,
            fireMemoryCreated: fireMemoryCreated,
            fireMemoriesViewed: fireMemoriesViewed
        }), [
        fireSpaceCreated,
        fireSourceAdded,
        fireSourceRemoved,
        fireSourceRecommendationsViewed,
        fireConversationAdded,
        fireSpaceViewed,
        fireSpaceSearched,
        fireStarterClicked,
        fireMemoryCreated,
        fireMemoriesViewed
    ]);
};
module.exports["useSpacesAnalytics"] = $88e9d6c2408f7e5a$export$b924f0f6b5fc4412;

});

parcelRegister("a9l0O", function(module, exports) {
/**
 * Analytics constants for Rovo Spaces impact instrumentation.
 *
 * Centralised here so event names / action-subjects don't drift across call
 * sites and are easy to assert in unit tests. See the impact-metrics plan
 * (ROVOFE-2925, Atlas ATLAS-124860).
 *
 * Instrumentation is guarded by the existing `rovo_chat_spaces_experiment`
 * experiment — the same experiment that renders Spaces — inlined at each
 * `FeatureGates.getExperimentValue(...)` call site in `useSpacesAnalytics`.
 */ /**
 * Grouped Spaces analytics vocabulary. A single export keeps event names in one
 * place (one-value-export-per-file) while callers reference stable keys.
 */ const $1eefc8e92b2349ed$export$4157cb919abf7b91 = {
    /**
   * `source` value used on AI MAU events so Spaces value-moments are
   * attributable back to the Spaces surface within Rovo Chat MAU.
   */ mauSource: 'rovoSpace',
    /** GASv3 action / actionSubject vocabulary for Spaces track/ui events. */ events: {
        /** A space was successfully created. */ spaceCreated: {
            action: 'created',
            actionSubject: 'rovoSpace'
        },
        /** A source (Confluence/Jira/etc.) was added to a space. */ sourceAdded: {
            action: 'added',
            actionSubject: 'spaceSource'
        },
        /** A source was removed from a space (net-of-adds for sources-per-space). */ sourceRemoved: {
            action: 'removed',
            actionSubject: 'spaceSource'
        },
        /** Smart-context source recommendations were shown to the user (impression → CTR denominator). */ sourceRecommendationsViewed: {
            action: 'viewed',
            actionSubject: 'spaceSourceRecommendations'
        },
        /** A conversation/chat was attached (pinned) to a space. */ conversationAdded: {
            action: 'added',
            actionSubject: 'spaceConversation'
        },
        /** A memory was created in a space. */ memoryCreated: {
            action: 'created',
            actionSubject: 'spaceMemory'
        },
        /** Space memories were retrieved/shown (retrieval signal). */ memoriesViewed: {
            action: 'viewed',
            actionSubject: 'spaceMemory'
        },
        /** The user searched the spaces list. */ spaceSearched: {
            action: 'searched',
            actionSubject: 'rovoSpace'
        },
        /** A starter prompt on the space landing page was clicked (which starter drove engagement). */ starterClicked: {
            action: 'clicked',
            actionSubject: 'spaceStarter'
        }
    },
    /** Screen-view event names. */ screens: {
        spaceLandingPage: 'rovoSpaceLandingPage'
    }
};
module.exports["SPACES_ANALYTICS"] = $1eefc8e92b2349ed$export$4157cb919abf7b91;

});

parcelRegister("evuMX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kuIhJ = parcelRequire("kuIhJ");


var $j26HD = parcelRequire("j26HD");

const $d42e8c1908e4be5b$export$d857e05a2227ffe5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { cloudId: cloudId, product: t1, experienceId: t2, onSuccess: onSuccess, onError: onError } = t0;
    const product = t1 === undefined ? "rovo" : t1;
    const experienceId = t2 === undefined ? "ai-mate" : t2;
    let t3;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product) {
        t3 = (request)=>(0, $j26HD.addConversationToSpaceFetchAction)({
                request: request,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = t3;
    } else t3 = $[3];
    const mutationFn = t3;
    let t4;
    if ($[4] !== mutationFn || $[5] !== onError || $[6] !== onSuccess) {
        t4 = {
            mutationFn: mutationFn,
            onSuccess: onSuccess,
            onError: onError
        };
        $[4] = mutationFn;
        $[5] = onError;
        $[6] = onSuccess;
        $[7] = t4;
    } else t4 = $[7];
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)(t4);
    let t5;
    if ($[8] !== error || $[9] !== isSubmitting || $[10] !== mutate) {
        t5 = {
            addConversation: mutate,
            isSubmitting: isSubmitting,
            error: error
        };
        $[8] = error;
        $[9] = isSubmitting;
        $[10] = mutate;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ cloudId: cloudId, product: product = 'rovo', experienceId: experienceId = 'ai-mate', onSuccess: onSuccess, onError: onError })=>{
    const mutationFn = (0, $cozmU.useCallback)((request)=>(0, $j26HD.addConversationToSpaceFetchAction)({
            request: request,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        }), [
        cloudId,
        product,
        experienceId
    ]);
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)({
        mutationFn: mutationFn,
        onSuccess: onSuccess,
        onError: onError
    });
    return {
        addConversation: mutate,
        isSubmitting: isSubmitting,
        error: error
    };
};
module.exports["useAddConversationToSpace"] = $d42e8c1908e4be5b$export$d857e05a2227ffe5;

});

parcelRegister("j26HD", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $b77a72878f4989f4$var$getAddConversationPath = (spaceId)=>`${0, $98i9C.SPACES_API_PATH}/${spaceId}/conversations`;
const $b77a72878f4989f4$export$a8b2956e7db96fd9 = async ({ request: request, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    const path = $b77a72878f4989f4$var$getAddConversationPath(request.spaceId);
    let response;
    try {
        response = await fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify({
                conversationId: request.conversationId
            })
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`addConversationToSpaceFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'addConversationToSpaceFetchError'
        });
    }
    if (!response.ok || response.status >= 400) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`addConversationToSpaceFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'addConversationToSpaceFetchError',
            statusCode: response.status
        });
    }
};
module.exports["addConversationToSpaceFetchAction"] = $b77a72878f4989f4$export$a8b2956e7db96fd9;

});

parcelRegister("eHUtn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kuIhJ = parcelRequire("kuIhJ");


var $fbfZC = parcelRequire("fbfZC");

const $aa77d83ccb0f36e2$export$db6cb2a1fd217c2e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { cloudId: cloudId, product: product, experienceId: experienceId, onSuccess: onSuccess, onError: onError } = t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product) {
        t1 = (request)=>(0, $fbfZC.createSpaceFetchAction)({
                request: request,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = t1;
    } else t1 = $[3];
    const mutationFn = t1;
    let t2;
    if ($[4] !== mutationFn || $[5] !== onError || $[6] !== onSuccess) {
        t2 = {
            mutationFn: mutationFn,
            onSuccess: onSuccess,
            onError: onError
        };
        $[4] = mutationFn;
        $[5] = onError;
        $[6] = onSuccess;
        $[7] = t2;
    } else t2 = $[7];
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)(t2);
    let t3;
    if ($[8] !== error || $[9] !== isSubmitting || $[10] !== mutate) {
        t3 = {
            mutate: mutate,
            isSubmitting: isSubmitting,
            error: error
        };
        $[8] = error;
        $[9] = isSubmitting;
        $[10] = mutate;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ cloudId: cloudId, product: product, experienceId: experienceId, onSuccess: onSuccess, onError: onError })=>{
    const mutationFn = (0, $cozmU.useCallback)((request)=>(0, $fbfZC.createSpaceFetchAction)({
            request: request,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        }), [
        cloudId,
        product,
        experienceId
    ]);
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)({
        mutationFn: mutationFn,
        onSuccess: onSuccess,
        onError: onError
    });
    return {
        mutate: mutate,
        isSubmitting: isSubmitting,
        error: error
    };
};
module.exports["useCreateSpace"] = $aa77d83ccb0f36e2$export$db6cb2a1fd217c2e;

});

parcelRegister("fbfZC", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $14eb4b5c6e8e75da$export$8db94bf7c1d9931 = async ({ request: request, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: (0, $98i9C.SPACES_API_PATH),
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }
    });
module.exports["createSpaceFetchAction"] = $14eb4b5c6e8e75da$export$8db94bf7c1d9931;

});

parcelRegister("9S8qu", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $325bc7c6b2d35824$var$message = (0, $kSwu1.defineMessages)({
    createSpaceModalTitle: {
        id: "ai-mate.rovo-spaces.create-space-modal.title",
        defaultMessage: "Create Rovo space"
    },
    createSpaceIntro: {
        id: "ai-mate.rovo-spaces.create-space-modal.intro",
        defaultMessage: "Set up a Rovo space for a project, topic, or team. Give your Rovo space a name, add relevant knowledge sources to receive chat answers based on that context."
    },
    createSpaceNameLabel: {
        id: "ai-mate.rovo-spaces.create-space-modal.name-label",
        defaultMessage: "Name"
    },
    createSpaceNameHelperMessage: {
        id: "ai-mate.rovo-spaces.create-space-modal.name-helper",
        defaultMessage: "Give your Rovo space a clear name so you can identify the project or topic at a glance."
    },
    createSpaceIconLabel: {
        id: "ai-mate.rovo-spaces.create-space-modal.icon-label",
        defaultMessage: "Icon"
    },
    createSpaceIconHelperMessage: {
        id: "ai-mate.rovo-spaces.create-space-modal.icon-helper",
        defaultMessage: "Select an icon to represent your Rovo space"
    },
    createSpaceAboutLabel: {
        id: "ai-mate.rovo-spaces.create-space-modal.about-label",
        defaultMessage: "Description"
    },
    createSpaceSourcesLabel: {
        id: "ai-mate.rovo-spaces.create-space-modal.sources-label",
        defaultMessage: "Knowledge"
    },
    createSpaceSourcesHelperMessage: {
        id: "ai-mate.rovo-spaces.create-space-modal.sources-helper",
        defaultMessage: "Add knowledge such as links to docs, pages, or files that your chat can answer from."
    },
    createSpaceAddSources: {
        id: "ai-mate.rovo-spaces.create-space-modal.add-sources",
        defaultMessage: "Add knowledge"
    },
    createSpaceAddSourcesModalTitle: {
        id: "ai-mate.rovo-spaces.create-space-modal.add-sources-modal-title",
        defaultMessage: "Add sources"
    },
    createSpaceAddSourcesModalPlaceholder: {
        id: "ai-mate.rovo-spaces.create-space-modal.add-sources-placeholder",
        defaultMessage: "Source picker coming soon."
    },
    createSpaceRemoveSource: {
        id: "ai-mate.rovo-spaces.create-space-modal.remove-source",
        defaultMessage: "Remove {name}"
    },
    createSpaceNameRequired: {
        id: "ai-mate.rovo-spaces.create-space-modal.name-required",
        defaultMessage: "Enter a name"
    },
    createSpaceEmojiPickerLabel: {
        id: "ai-mate.rovo-spaces.create-space-modal.emoji-picker",
        defaultMessage: "Choose icon"
    },
    createSpaceCancel: {
        id: "ai-mate.rovo-spaces.create-space-modal.cancel",
        defaultMessage: "Cancel"
    },
    createSpaceSubmit: {
        id: "ai-mate.rovo-spaces.create-space-modal.submit",
        defaultMessage: "Create"
    },
    createSpaceRequiredFieldsHint: {
        id: "ai-mate.rovo-spaces.create-space-modal.required-fields-hint",
        defaultMessage: "Required fields are marked with an asterisk <asterisk></asterisk>"
    }
});
var $325bc7c6b2d35824$export$2e2bcd8739ae039 = $325bc7c6b2d35824$var$message;
module.exports["default"] = $325bc7c6b2d35824$export$2e2bcd8739ae039;

});

parcelRegister("lfiBc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $lmyCc = parcelRequire("lmyCc");


var $gzzWs = parcelRequire("gzzWs");

const $5bc94e1e08192ca8$export$9290cc57346d0ec3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { url: url, fallback: fallback, displayTextOverride: displayTextOverride } = t0;
    const { title: title, providerIcon: providerIcon, status: status } = (0, $gzzWs.useSmartLinkMetadata)(url);
    let t1;
    if ($[0] !== displayTextOverride) {
        t1 = displayTextOverride?.trim();
        $[0] = displayTextOverride;
        $[1] = t1;
    } else t1 = $[1];
    const trimmedOverride = t1;
    if (status === "pending" && !trimmedOverride) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small"
            });
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    const displayedTitle = trimmedOverride || title || fallback;
    let t2;
    if ($[3] !== providerIcon) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmyCc.ProviderIconView), {
            icon: providerIcon
        });
        $[3] = providerIcon;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== displayedTitle) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, displayedTitle);
        $[5] = displayedTitle;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ url: url, fallback: fallback, displayTextOverride: displayTextOverride })=>{
    const { title: title, providerIcon: providerIcon, status: status } = (0, $gzzWs.useSmartLinkMetadata)(url); // While resolving, prefer to show the user-provided display text immediately
    // (with no spinner) - it's already the "right" label and we don't need to
    // wait on the SmartLink response. Only show the spinner when we have nothing
    // to display yet.
    const trimmedOverride = displayTextOverride?.trim();
    if (status === 'pending' && !trimmedOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    });
    const displayedTitle = trimmedOverride || title || fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmyCc.ProviderIconView), {
        icon: providerIcon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, displayedTitle));
};
module.exports["SmartLinkSourceRow"] = $5bc94e1e08192ca8$export$9290cc57346d0ec3;

});

parcelRegister("lmyCc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $64561a3072292e1b$var$providerIconImageStyles = null; /**
                                       * Renders a provider icon, accepting either a ready-to-render React node
                                       * (e.g. the Confluence/Jira logo elements returned by `extractSmartLinkProvider`)
                                       * or a remote image URL (e.g. a third-party provider PNG).
                                       */ 
const $64561a3072292e1b$export$2256645a64c6c05b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { icon: icon } = t0;
    if (!icon) return null;
    if (icon.kind === "url") {
        const t1 = icon.url;
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = (0, $hekY6.default)([
                "_3iDTPbvbI6 _39xV02ey7F _0jFU0Vey7F _00EA0egIor"
            ]);
            $[0] = t2;
        } else t2 = $[0];
        let t3;
        if ($[1] !== icon.url || $[2] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: t1,
                alt: "",
                className: t2
            });
            $[1] = icon.url;
            $[2] = t2;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    let t1;
    if ($[4] !== icon.node) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, icon.node);
        $[4] = icon.node;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ icon: icon })=>{
    if (!icon) return null;
    if (icon.kind === 'url') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: icon.url,
        alt: "",
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _39xV02ey7F _0jFU0Vey7F _00EA0egIor"
        ])
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, icon.node);
};
module.exports["ProviderIconView"] = $64561a3072292e1b$export$2256645a64c6c05b;

});

parcelRegister("gzzWs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hHrlI = parcelRequire("hHrlI");

var $7YvXl = parcelRequire("7YvXl");


var $cMyWi = parcelRequire("cMyWi");

const $434e7863e87b2707$var$PENDING = {
    title: undefined,
    providerIcon: undefined,
    status: 'pending'
};
const $434e7863e87b2707$var$toProviderIcon = (rawIcon, fallbackImage)=>{
    if (typeof rawIcon === 'string' && rawIcon) return {
        kind: 'url',
        url: rawIcon
    };
    if (rawIcon) return {
        kind: 'node',
        node: rawIcon
    };
    if (fallbackImage) return {
        kind: 'url',
        url: fallbackImage
    };
    return undefined;
};
const $434e7863e87b2707$export$cb152f3a5a9230f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (url)=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $cMyWi.useSmartLinkContext)();
    const [metadata, setMetadata] = (0, $cozmU.useState)($434e7863e87b2707$var$PENDING);
    const connections = context?.connections;
    let t0;
    let t1;
    if ($[0] !== connections || $[1] !== url) {
        t0 = ()=>{
            if (!connections) return;
            let cancelled = false;
            setMetadata($434e7863e87b2707$var$PENDING);
            connections.client.fetchData(url).then((response)=>{
                if (cancelled) return;
                const provider = (0, $hHrlI.extractSmartLinkProvider)(response);
                setMetadata({
                    title: (0, $7YvXl.extractSmartLinkTitle)(response),
                    providerIcon: $434e7863e87b2707$var$toProviderIcon(provider?.icon, provider?.image),
                    status: "resolved"
                });
            }).catch(()=>{
                if (!cancelled) setMetadata({
                    title: undefined,
                    providerIcon: undefined,
                    status: "errored"
                });
            });
            return ()=>{
                cancelled = true;
            };
        };
        t1 = [
            url,
            connections
        ];
        $[0] = connections;
        $[1] = url;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return metadata;
} : (url)=>{
    const context = (0, $cMyWi.useSmartLinkContext)();
    const [metadata, setMetadata] = (0, $cozmU.useState)($434e7863e87b2707$var$PENDING);
    const connections = context?.connections;
    (0, $cozmU.useEffect)(()=>{
        if (!connections) // No SmartCardProvider in the tree — leave state as PENDING so callers
        // can handle the "not ready" case gracefully (e.g. render a skeleton).
        return;
        let cancelled = false;
        setMetadata($434e7863e87b2707$var$PENDING);
        connections.client.fetchData(url).then((response)=>{
            if (cancelled) return;
            const provider = (0, $hHrlI.extractSmartLinkProvider)(response);
            setMetadata({
                title: (0, $7YvXl.extractSmartLinkTitle)(response),
                providerIcon: $434e7863e87b2707$var$toProviderIcon(provider?.icon, provider?.image),
                status: 'resolved'
            });
        }).catch(()=>{
            if (!cancelled) setMetadata({
                title: undefined,
                providerIcon: undefined,
                status: 'errored'
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        url,
        connections
    ]);
    return metadata;
};
module.exports["useSmartLinkMetadata"] = $434e7863e87b2707$export$cb152f3a5a9230f0;

});

parcelRegister("9TKdb", function(module, exports) {
const $5c71411206bb4a19$export$8e222b99ab0b86c2 = ({ displayText: _displayText, ...rest })=>rest;
module.exports["toSpaceSource"] = $5c71411206bb4a19$export$8e222b99ab0b86c2;

});

parcelRegister("jxAn2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $5HApy = parcelRequire("5HApy");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $b4vCW = parcelRequire("b4vCW");

var $69Kfj = parcelRequire("69Kfj");


var $d26Wq = parcelRequire("d26Wq");


var $1aCne = parcelRequire("1aCne");


var $lchoD = parcelRequire("lchoD");


var $5tuwK = parcelRequire("5tuwK");


var $9gae3 = parcelRequire("9gae3");


var $bXMt2 = parcelRequire("bXMt2");

const $b8533a3431b8c57b$var$styles = {
    spinnerContainer: "_4c065UVa5s",
    errorText: "_4c065U5zaO"
};
const $b8533a3431b8c57b$var$useSpaceSourcePlugins = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSpaceSourcePlugins(cloudId) {
    const $ = (0, $bDgLe.c)(21);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            tabKey: "confluence",
            tabTitle: "Confluence"
        };
        t1 = [
            "confluence"
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] !== cloudId) {
        t2 = {
            tabConfig: t0,
            products: t1,
            scope: (0, $b4vCW.Scope).ConfluenceContentType,
            cloudId: cloudId
        };
        $[2] = cloudId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            tabKey: "jira",
            tabTitle: "Jira"
        };
        t4 = [
            "jira"
        ];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    let t5;
    if ($[6] !== cloudId) {
        t5 = {
            tabConfig: t3,
            products: t4,
            scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter,
            cloudId: cloudId
        };
        $[6] = cloudId;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            tabKey: "atlas",
            tabTitle: "Atlas"
        };
        t7 = [
            "townsquare"
        ];
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    let t8;
    if ($[10] !== cloudId) {
        t8 = {
            tabConfig: t6,
            products: t7,
            scope: (0, $b4vCW.Scope).TownsquareProject,
            cloudId: cloudId
        };
        $[10] = cloudId;
        $[11] = t8;
    } else t8 = $[11];
    let t10;
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            tabKey: "loom",
            tabTitle: "Loom"
        };
        t10 = [
            "loom"
        ];
        $[12] = t10;
        $[13] = t9;
    } else {
        t10 = $[12];
        t9 = $[13];
    }
    let t11;
    if ($[14] !== cloudId) {
        t11 = {
            tabConfig: t9,
            products: t10,
            scope: (0, $b4vCW.Scope).Loom,
            cloudId: cloudId,
            disableActivityClient: true
        };
        $[14] = cloudId;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11 || $[17] !== t2 || $[18] !== t5 || $[19] !== t8) {
        t12 = [
            t2,
            t5,
            t8,
            t11
        ];
        $[16] = t11;
        $[17] = t2;
        $[18] = t5;
        $[19] = t8;
        $[20] = t12;
    } else t12 = $[20];
    const configs = t12;
    return (0, $69Kfj.useAtlassianPlugins)(configs);
} : function useSpaceSourcePlugins(cloudId) {
    const configs = (0, $cozmU.useMemo)(()=>[
            {
                tabConfig: {
                    tabKey: 'confluence',
                    tabTitle: 'Confluence'
                },
                products: [
                    'confluence'
                ],
                scope: (0, $b4vCW.Scope).ConfluenceContentType,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'jira',
                    tabTitle: 'Jira'
                },
                products: [
                    'jira'
                ],
                scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'atlas',
                    tabTitle: 'Atlas'
                },
                products: [
                    'townsquare'
                ],
                scope: (0, $b4vCW.Scope).TownsquareProject,
                cloudId: cloudId
            },
            {
                tabConfig: {
                    tabKey: 'loom',
                    tabTitle: 'Loom'
                },
                products: [
                    'loom'
                ],
                scope: (0, $b4vCW.Scope).Loom,
                cloudId: cloudId,
                disableActivityClient: true
            }
        ], [
        cloudId
    ]);
    return (0, $69Kfj.useAtlassianPlugins)(configs);
};
const $b8533a3431b8c57b$var$MANAGE_SPACE_FORM_ID = 'manage-space-form';
const $b8533a3431b8c57b$export$17be482eb291414e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(100);
    const { isOpen: isOpen, onClose: onClose, spaceId: spaceId, cloudId: cloudId, initialName: initialName, initialEmoji: initialEmoji, emojiProvider: emojiProvider, assistanceServiceParams: assistanceServiceParams, onSuccess: onSuccess } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== cloudId) {
        t1 = (0, $d26Wq.createEmojiProviderWithUpload)(cloudId);
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const defaultEmojiProvider = t1;
    const resolvedEmojiProvider = emojiProvider ?? defaultEmojiProvider;
    const [isEmojiPickerOpen, setEmojiPickerOpen] = (0, $cozmU.useState)(false);
    let t2;
    if ($[2] !== initialEmoji) {
        t2 = initialEmoji ? {
            id: initialEmoji,
            shortName: "",
            fallback: initialEmoji
        } : undefined;
        $[2] = initialEmoji;
        $[3] = t2;
    } else t2 = $[3];
    const [selectedEmoji, setSelectedEmoji] = (0, $cozmU.useState)(t2);
    const plugins = $b8533a3431b8c57b$var$useSpaceSourcePlugins(cloudId);
    const product = assistanceServiceParams?.product ?? "rovo";
    const experienceId = assistanceServiceParams?.experienceId ?? "ai-mate";
    let t3;
    if ($[4] !== cloudId || $[5] !== experienceId || $[6] !== isOpen || $[7] !== product || $[8] !== spaceId) {
        t3 = {
            spaceId: spaceId,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId,
            enabled: isOpen
        };
        $[4] = cloudId;
        $[5] = experienceId;
        $[6] = isOpen;
        $[7] = product;
        $[8] = spaceId;
        $[9] = t3;
    } else t3 = $[9];
    const { space: space, isLoading: isLoading, error: loadError } = (0, $1aCne.useGetSpace)(t3);
    let t4;
    if ($[10] !== space) {
        t4 = ()=>{
            if (space?.emoji) setSelectedEmoji({
                id: space.emoji,
                shortName: "",
                fallback: space.emoji
            });
        };
        $[10] = space;
        $[11] = t4;
    } else t4 = $[11];
    const t5 = space?.emoji;
    let t6;
    if ($[12] !== t5) {
        t6 = [
            t5
        ];
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    (0, $cozmU.useEffect)(t4, t6);
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (emojiId)=>{
            setSelectedEmoji(emojiId);
            setEmojiPickerOpen(false);
        };
        $[14] = t7;
    } else t7 = $[14];
    const handleEmojiSelection = t7;
    let t8;
    if ($[15] !== initialEmoji) {
        t8 = ()=>{
            setEmojiPickerOpen(false);
            setSelectedEmoji(initialEmoji ? {
                id: initialEmoji,
                shortName: "",
                fallback: initialEmoji
            } : undefined);
        };
        $[15] = initialEmoji;
        $[16] = t8;
    } else t8 = $[16];
    const reset = t8;
    let t10;
    let t9;
    if ($[17] !== isOpen || $[18] !== reset) {
        t9 = ()=>{
            if (!isOpen) reset();
        };
        t10 = [
            isOpen,
            reset
        ];
        $[17] = isOpen;
        $[18] = reset;
        $[19] = t10;
        $[20] = t9;
    } else {
        t10 = $[19];
        t9 = $[20];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[21] !== onClose || $[22] !== reset) {
        t11 = ()=>{
            reset();
            onClose();
        };
        $[21] = onClose;
        $[22] = reset;
        $[23] = t11;
    } else t11 = $[23];
    const handleClose = t11;
    let t12;
    if ($[24] !== cloudId || $[25] !== experienceId || $[26] !== product || $[27] !== spaceId) {
        t12 = {
            spaceId: spaceId,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        };
        $[24] = cloudId;
        $[25] = experienceId;
        $[26] = product;
        $[27] = spaceId;
        $[28] = t12;
    } else t12 = $[28];
    const { mutate: updateSpace } = (0, $lchoD.useUpdateSpace)(t12);
    let t13;
    if ($[29] !== handleClose || $[30] !== onSuccess || $[31] !== selectedEmoji?.id || $[32] !== spaceId || $[33] !== updateSpace) {
        t13 = (values)=>{
            const trimmed = values.name.trim();
            if (!trimmed) return;
            const sources = values.sources.map($b8533a3431b8c57b$var$_temp);
            const optimisticSpace = {
                id: spaceId,
                name: trimmed,
                description: values.about.trim() || undefined,
                emoji: selectedEmoji?.id ?? null,
                owner: "",
                createdAt: "",
                updatedAt: ""
            };
            onSuccess?.(optimisticSpace, sources);
            handleClose();
            updateSpace({
                name: trimmed,
                description: values.about.trim() || undefined,
                emoji: selectedEmoji?.id ?? null,
                sources: sources.map($b8533a3431b8c57b$var$_temp2)
            });
        };
        $[29] = handleClose;
        $[30] = onSuccess;
        $[31] = selectedEmoji?.id;
        $[32] = spaceId;
        $[33] = updateSpace;
        $[34] = t13;
    } else t13 = $[34];
    const handleFormSubmit = t13;
    let t14;
    if ($[35] !== formatMessage) {
        t14 = formatMessage((0, $bXMt2.default).manageSpaceNameLabel);
        $[35] = formatMessage;
        $[36] = t14;
    } else t14 = $[36];
    let t15;
    if ($[37] !== formatMessage) {
        t15 = formatMessage((0, $bXMt2.default).manageSpaceNameRequired);
        $[37] = formatMessage;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== formatMessage) {
        t16 = formatMessage((0, $bXMt2.default).manageSpaceEmojiPickerLabel);
        $[39] = formatMessage;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== formatMessage) {
        t17 = formatMessage((0, $bXMt2.default).manageSpaceAboutLabel);
        $[41] = formatMessage;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== formatMessage) {
        t18 = formatMessage((0, $bXMt2.default).manageSpaceSourcesLabel);
        $[43] = formatMessage;
        $[44] = t18;
    } else t18 = $[44];
    let t19;
    if ($[45] !== formatMessage) {
        t19 = formatMessage((0, $bXMt2.default).manageSpaceAddSources);
        $[45] = formatMessage;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    let t21;
    if ($[47] !== formatMessage) {
        t20 = (name)=>formatMessage((0, $bXMt2.default).manageSpaceRemoveSource, {
                name: name
            });
        t21 = formatMessage((0, $bXMt2.default).manageSpaceNoSourcesTitle);
        $[47] = formatMessage;
        $[48] = t20;
        $[49] = t21;
    } else {
        t20 = $[48];
        t21 = $[49];
    }
    let t22;
    if ($[50] !== formatMessage) {
        t22 = formatMessage((0, $bXMt2.default).manageSpaceNoSources);
        $[50] = formatMessage;
        $[51] = t22;
    } else t22 = $[51];
    let t23;
    if ($[52] !== t14 || $[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== t20 || $[59] !== t21 || $[60] !== t22) {
        t23 = {
            requiredFieldsHint: (0, $bXMt2.default).manageSpaceRequiredFieldsHint,
            nameLabel: t14,
            nameRequired: t15,
            emojiPickerLabel: t16,
            aboutLabel: t17,
            sourcesLabel: t18,
            addSources: t19,
            removeSource: t20,
            noSourcesTitle: t21,
            noSources: t22
        };
        $[52] = t14;
        $[53] = t15;
        $[54] = t16;
        $[55] = t17;
        $[56] = t18;
        $[57] = t19;
        $[58] = t20;
        $[59] = t21;
        $[60] = t22;
        $[61] = t23;
    } else t23 = $[61];
    const formMessages = t23;
    const renderSourceRow = $b8533a3431b8c57b$var$_temp3;
    if (!isOpen) return null;
    let t24;
    if ($[62] !== space?.sources) {
        t24 = space?.sources?.map($b8533a3431b8c57b$var$_temp4) ?? [];
        $[62] = space?.sources;
        $[63] = t24;
    } else t24 = $[63];
    const initialSources = t24;
    const initialAbout = space?.description ?? "";
    const resolvedInitialName = space?.name ?? initialName ?? "";
    let t25;
    if ($[64] !== formatMessage) {
        t25 = formatMessage((0, $bXMt2.default).manageSpaceModalTitle);
        $[64] = formatMessage;
        $[65] = t25;
    } else t25 = $[65];
    let t26;
    if ($[66] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, t25));
        $[66] = t25;
        $[67] = t26;
    } else t26 = $[67];
    let t27;
    if ($[68] !== cloudId || $[69] !== formMessages || $[70] !== formatMessage || $[71] !== handleFormSubmit || $[72] !== initialAbout || $[73] !== initialSources || $[74] !== isEmojiPickerOpen || $[75] !== isLoading || $[76] !== loadError || $[77] !== plugins || $[78] !== resolvedEmojiProvider || $[79] !== resolvedInitialName || $[80] !== selectedEmoji) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            xcss: $b8533a3431b8c57b$var$styles.spinnerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "large"
        })) : loadError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            xcss: $b8533a3431b8c57b$var$styles.errorText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.danger"
        }, formatMessage((0, $bXMt2.default).manageSpaceLoadError))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gae3.SpaceModalForm), {
            formId: $b8533a3431b8c57b$var$MANAGE_SPACE_FORM_ID,
            testId: "manage-space",
            messages: formMessages,
            initialName: resolvedInitialName,
            initialAbout: initialAbout,
            initialSources: initialSources,
            selectedEmoji: selectedEmoji,
            onEmojiSelect: handleEmojiSelection,
            isEmojiPickerOpen: isEmojiPickerOpen,
            onEmojiPickerToggle: ()=>setEmojiPickerOpen($b8533a3431b8c57b$var$_temp5),
            onEmojiPickerClose: ()=>setEmojiPickerOpen(false),
            emojiProvider: resolvedEmojiProvider,
            cloudId: cloudId,
            plugins: plugins,
            onSubmit: handleFormSubmit,
            renderSourceRow: renderSourceRow
        }));
        $[68] = cloudId;
        $[69] = formMessages;
        $[70] = formatMessage;
        $[71] = handleFormSubmit;
        $[72] = initialAbout;
        $[73] = initialSources;
        $[74] = isEmojiPickerOpen;
        $[75] = isLoading;
        $[76] = loadError;
        $[77] = plugins;
        $[78] = resolvedEmojiProvider;
        $[79] = resolvedInitialName;
        $[80] = selectedEmoji;
        $[81] = t27;
    } else t27 = $[81];
    let t28;
    if ($[82] !== formatMessage) {
        t28 = formatMessage((0, $bXMt2.default).manageSpaceCancel);
        $[82] = formatMessage;
        $[83] = t28;
    } else t28 = $[83];
    let t29;
    if ($[84] !== handleClose || $[85] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleClose
        }, t28);
        $[84] = handleClose;
        $[85] = t28;
        $[86] = t29;
    } else t29 = $[86];
    const t30 = isLoading || !!loadError;
    let t31;
    if ($[87] !== formatMessage) {
        t31 = formatMessage((0, $bXMt2.default).manageSpaceSubmit);
        $[87] = formatMessage;
        $[88] = t31;
    } else t31 = $[88];
    let t32;
    if ($[89] !== t30 || $[90] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            type: "submit",
            form: $b8533a3431b8c57b$var$MANAGE_SPACE_FORM_ID,
            testId: "manage-space-submit",
            isDisabled: t30
        }, t31);
        $[89] = t30;
        $[90] = t31;
        $[91] = t32;
    } else t32 = $[91];
    let t33;
    if ($[92] !== t29 || $[93] !== t32) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, t29, t32);
        $[92] = t29;
        $[93] = t32;
        $[94] = t33;
    } else t33 = $[94];
    let t34;
    if ($[95] !== handleClose || $[96] !== t26 || $[97] !== t27 || $[98] !== t33) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: handleClose,
            width: "medium",
            testId: "manage-space-modal"
        }, t26, t27, t33));
        $[95] = handleClose;
        $[96] = t26;
        $[97] = t27;
        $[98] = t33;
        $[99] = t34;
    } else t34 = $[99];
    return t34;
} : ({ isOpen: isOpen, onClose: onClose, spaceId: spaceId, cloudId: cloudId, initialName: initialName, initialEmoji: initialEmoji, emojiProvider: emojiProvider, assistanceServiceParams: assistanceServiceParams, onSuccess: onSuccess })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const defaultEmojiProvider = (0, $cozmU.useMemo)(()=>(0, $d26Wq.createEmojiProviderWithUpload)(cloudId), [
        cloudId
    ]);
    const resolvedEmojiProvider = emojiProvider ?? defaultEmojiProvider;
    const [isEmojiPickerOpen, setEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const [selectedEmoji, setSelectedEmoji] = (0, $cozmU.useState)(initialEmoji ? {
        id: initialEmoji,
        shortName: '',
        fallback: initialEmoji
    } : undefined);
    const plugins = $b8533a3431b8c57b$var$useSpaceSourcePlugins(cloudId);
    const product = assistanceServiceParams?.product ?? 'rovo';
    const experienceId = assistanceServiceParams?.experienceId ?? 'ai-mate';
    const { space: space, isLoading: isLoading, error: loadError } = (0, $1aCne.useGetSpace)({
        spaceId: spaceId,
        cloudId: cloudId,
        product: product,
        experienceId: experienceId,
        enabled: isOpen
    });
    (0, $cozmU.useEffect)(()=>{
        if (space?.emoji) setSelectedEmoji({
            id: space.emoji,
            shortName: '',
            fallback: space.emoji
        });
    }, [
        space?.emoji
    ]);
    const handleEmojiSelection = (0, $cozmU.useCallback)((emojiId)=>{
        setSelectedEmoji(emojiId);
        setEmojiPickerOpen(false);
    }, []);
    const reset = (0, $cozmU.useCallback)(()=>{
        setEmojiPickerOpen(false);
        setSelectedEmoji(initialEmoji ? {
            id: initialEmoji,
            shortName: '',
            fallback: initialEmoji
        } : undefined);
    }, [
        initialEmoji
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) reset();
    }, [
        isOpen,
        reset
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        reset();
        onClose();
    }, [
        onClose,
        reset
    ]);
    const { mutate: updateSpace } = (0, $lchoD.useUpdateSpace)({
        spaceId: spaceId,
        cloudId: cloudId,
        product: product,
        experienceId: experienceId
    });
    const handleFormSubmit = (0, $cozmU.useCallback)((values)=>{
        const trimmed = values.name.trim();
        if (!trimmed) return;
        const sources = values.sources.map((s)=>({
                ari: s.ari,
                url: s.url,
                sourceType: s.sourceType,
                conversationIds: s.conversationIds,
                name: s.name
            }));
        const optimisticSpace = {
            id: spaceId,
            name: trimmed,
            description: values.about.trim() || undefined,
            emoji: selectedEmoji?.id ?? null,
            owner: '',
            createdAt: '',
            updatedAt: ''
        }; // Optimistically close and notify — fire-and-forget the BE call
        onSuccess?.(optimisticSpace, sources);
        handleClose();
        updateSpace({
            name: trimmed,
            description: values.about.trim() || undefined,
            emoji: selectedEmoji?.id ?? null,
            sources: sources.map((s_0)=>({
                    ari: s_0.ari,
                    url: s_0.url,
                    sourceType: s_0.sourceType,
                    name: s_0.name
                }))
        });
    }, [
        updateSpace,
        selectedEmoji,
        spaceId,
        onSuccess,
        handleClose
    ]);
    const formMessages = (0, $cozmU.useMemo)(()=>({
            requiredFieldsHint: (0, $bXMt2.default).manageSpaceRequiredFieldsHint,
            nameLabel: formatMessage((0, $bXMt2.default).manageSpaceNameLabel),
            nameRequired: formatMessage((0, $bXMt2.default).manageSpaceNameRequired),
            emojiPickerLabel: formatMessage((0, $bXMt2.default).manageSpaceEmojiPickerLabel),
            aboutLabel: formatMessage((0, $bXMt2.default).manageSpaceAboutLabel),
            sourcesLabel: formatMessage((0, $bXMt2.default).manageSpaceSourcesLabel),
            addSources: formatMessage((0, $bXMt2.default).manageSpaceAddSources),
            removeSource: (name)=>formatMessage((0, $bXMt2.default).manageSpaceRemoveSource, {
                    name: name
                }),
            noSourcesTitle: formatMessage((0, $bXMt2.default).manageSpaceNoSourcesTitle),
            noSources: formatMessage((0, $bXMt2.default).manageSpaceNoSources)
        }), [
        formatMessage
    ]);
    const renderSourceRow = (0, $cozmU.useCallback)((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tuwK.SmartLinkSourceRow), {
            url: source.url,
            fallback: source.name ?? source.url
        }), []);
    if (!isOpen) return null;
    const initialSources = space?.sources?.map((s_1)=>({
            ari: s_1.ari,
            url: s_1.url,
            sourceType: s_1.sourceType,
            conversationIds: [],
            name: s_1.name
        })) ?? [];
    const initialAbout = space?.description ?? '';
    const resolvedInitialName = space?.name ?? initialName ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: handleClose,
        width: "medium",
        testId: "manage-space-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, formatMessage((0, $bXMt2.default).manageSpaceModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        xcss: $b8533a3431b8c57b$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large"
    })) : loadError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        xcss: $b8533a3431b8c57b$var$styles.errorText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, formatMessage((0, $bXMt2.default).manageSpaceLoadError))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gae3.SpaceModalForm), {
        formId: $b8533a3431b8c57b$var$MANAGE_SPACE_FORM_ID,
        testId: "manage-space",
        messages: formMessages,
        initialName: resolvedInitialName,
        initialAbout: initialAbout,
        initialSources: initialSources,
        selectedEmoji: selectedEmoji,
        onEmojiSelect: handleEmojiSelection,
        isEmojiPickerOpen: isEmojiPickerOpen,
        onEmojiPickerToggle: ()=>setEmojiPickerOpen((v)=>!v),
        onEmojiPickerClose: ()=>setEmojiPickerOpen(false),
        emojiProvider: resolvedEmojiProvider,
        cloudId: cloudId,
        plugins: plugins,
        onSubmit: handleFormSubmit,
        renderSourceRow: renderSourceRow
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClose
    }, formatMessage((0, $bXMt2.default).manageSpaceCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        type: "submit",
        form: $b8533a3431b8c57b$var$MANAGE_SPACE_FORM_ID,
        testId: "manage-space-submit",
        isDisabled: isLoading || !!loadError
    }, formatMessage((0, $bXMt2.default).manageSpaceSubmit)))));
};
function $b8533a3431b8c57b$var$_temp(s) {
    return {
        ari: s.ari,
        url: s.url,
        sourceType: s.sourceType,
        conversationIds: s.conversationIds,
        name: s.name
    };
}
function $b8533a3431b8c57b$var$_temp2(s_0) {
    return {
        ari: s_0.ari,
        url: s_0.url,
        sourceType: s_0.sourceType,
        name: s_0.name
    };
}
function $b8533a3431b8c57b$var$_temp3(source) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tuwK.SmartLinkSourceRow), {
        url: source.url,
        fallback: source.name ?? source.url
    });
}
function $b8533a3431b8c57b$var$_temp4(s_1) {
    return {
        ari: s_1.ari,
        url: s_1.url,
        sourceType: s_1.sourceType,
        conversationIds: [],
        name: s_1.name
    };
}
function $b8533a3431b8c57b$var$_temp5(v) {
    return !v;
}
module.exports["ManageSpaceModal"] = $b8533a3431b8c57b$export$17be482eb291414e;

});

parcelRegister("1aCne", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5SS4O = parcelRequire("5SS4O");


var $12shJ = parcelRequire("12shJ");

const $de26c2eb2dee2a3c$export$1f1d60a7c4f06002 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, enabled: t1 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const { fetchSpace: fetchSpace } = (0, $12shJ.useSpaceStoreActions)();
    const space = (0, $12shJ.useSpaceById)(spaceId);
    const isLoading = (0, $12shJ.useSpaceDetailLoading)(spaceId);
    const error = (0, $12shJ.useSpaceDetailError)(spaceId);
    let t2;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product || $[3] !== spaceId) {
        t2 = [
            "rovo-spaces:getSpace",
            spaceId,
            cloudId,
            product,
            experienceId
        ];
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = spaceId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== cloudId || $[6] !== experienceId || $[7] !== fetchSpace || $[8] !== product || $[9] !== spaceId) {
        t3 = ()=>fetchSpace({
                spaceId: spaceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
        $[5] = cloudId;
        $[6] = experienceId;
        $[7] = fetchSpace;
        $[8] = product;
        $[9] = spaceId;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== enabled || $[12] !== t2 || $[13] !== t3) {
        t4 = {
            queryKey: t2,
            queryFn: t3,
            enabled: enabled
        };
        $[11] = enabled;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    const { refetch: refetchQuery } = (0, $5SS4O.useQuery)(t4);
    let t5;
    if ($[15] !== refetchQuery) {
        t5 = async ()=>{
            await refetchQuery();
        };
        $[15] = refetchQuery;
        $[16] = t5;
    } else t5 = $[16];
    const refetch = t5;
    const t6 = space ?? null;
    let t7;
    if ($[17] !== error || $[18] !== isLoading || $[19] !== refetch || $[20] !== t6) {
        t7 = {
            space: t6,
            isLoading: isLoading,
            error: error,
            refetch: refetch
        };
        $[17] = error;
        $[18] = isLoading;
        $[19] = refetch;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
} : ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, enabled: enabled = true })=>{
    const { fetchSpace: fetchSpace } = (0, $12shJ.useSpaceStoreActions)();
    const space = (0, $12shJ.useSpaceById)(spaceId);
    const isLoading = (0, $12shJ.useSpaceDetailLoading)(spaceId);
    const error = (0, $12shJ.useSpaceDetailError)(spaceId);
    const { refetch: refetchQuery } = (0, $5SS4O.useQuery)({
        queryKey: [
            'rovo-spaces:getSpace',
            spaceId,
            cloudId,
            product,
            experienceId
        ],
        queryFn: ()=>fetchSpace({
                spaceId: spaceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            }),
        enabled: enabled
    });
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        await refetchQuery();
    }, [
        refetchQuery
    ]);
    return {
        space: space ?? null,
        isLoading: isLoading,
        error: error,
        refetch: refetch
    };
};
module.exports["useGetSpace"] = $de26c2eb2dee2a3c$export$1f1d60a7c4f06002;

});

parcelRegister("lchoD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kuIhJ = parcelRequire("kuIhJ");


var $12shJ = parcelRequire("12shJ");


var $2IYpC = parcelRequire("2IYpC");

const $f9a085773413f515$export$f5683955ccea45d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, onSuccess: onSuccess, onError: onError } = t0;
    const { patchSpace: patchSpace } = (0, $12shJ.useSpaceStoreActions)();
    let t1;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== patchSpace || $[3] !== product || $[4] !== spaceId) {
        t1 = async (request)=>{
            const response = await (0, $2IYpC.updateSpaceFetchAction)({
                spaceId: spaceId,
                request: request,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
            patchSpace(spaceId, {
                name: response.name,
                emoji: response.emoji ?? null,
                description: response.description ?? null,
                updatedAt: response.updatedAt
            });
            return response;
        };
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = patchSpace;
        $[3] = product;
        $[4] = spaceId;
        $[5] = t1;
    } else t1 = $[5];
    const mutationFn = t1;
    let t2;
    if ($[6] !== mutationFn || $[7] !== onError || $[8] !== onSuccess) {
        t2 = {
            mutationFn: mutationFn,
            onSuccess: onSuccess,
            onError: onError
        };
        $[6] = mutationFn;
        $[7] = onError;
        $[8] = onSuccess;
        $[9] = t2;
    } else t2 = $[9];
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)(t2);
    let t3;
    if ($[10] !== error || $[11] !== isSubmitting || $[12] !== mutate) {
        t3 = {
            mutate: mutate,
            isSubmitting: isSubmitting,
            error: error
        };
        $[10] = error;
        $[11] = isSubmitting;
        $[12] = mutate;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ spaceId: spaceId, cloudId: cloudId, product: product, experienceId: experienceId, onSuccess: onSuccess, onError: onError })=>{
    const { patchSpace: patchSpace } = (0, $12shJ.useSpaceStoreActions)();
    const mutationFn = (0, $cozmU.useCallback)(async (request)=>{
        const response = await (0, $2IYpC.updateSpaceFetchAction)({
            spaceId: spaceId,
            request: request,
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        });
        // Optimistically patch both list and detail slices so any consumer
        // (side-nav, manage modal, landing page) sees the new fields
        // immediately, without waiting for a list refetch.
        patchSpace(spaceId, {
            name: response.name,
            emoji: response.emoji ?? null,
            description: response.description ?? null,
            updatedAt: response.updatedAt
        });
        return response;
    }, [
        spaceId,
        cloudId,
        product,
        experienceId,
        patchSpace
    ]);
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)({
        mutationFn: mutationFn,
        onSuccess: onSuccess,
        onError: onError
    });
    return {
        mutate: mutate,
        isSubmitting: isSubmitting,
        error: error
    };
};
module.exports["useUpdateSpace"] = $f9a085773413f515$export$f5683955ccea45d9;

});

parcelRegister("5tuwK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $lmyCc = parcelRequire("lmyCc");


var $gzzWs = parcelRequire("gzzWs");

const $01e58e7fca834482$var$providerIconWrapperStyles = null;
const $01e58e7fca834482$var$resolvedRowStyles = null;
const $01e58e7fca834482$var$skeletonRowStyles = null;
const $01e58e7fca834482$var$titleStyles = null; /**
                           * Renders the provider icon and title for a URL by resolving it via the SmartLink store.
                           * Falls back to `fallback` while pending or on error.
                           *
                           * Requires a <SmartCardProvider> in the tree.
                           */ 
const $01e58e7fca834482$export$9290cc57346d0ec3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { url: url, fallback: fallback, displayTextOverride: displayTextOverride, onLoadingChange: onLoadingChange } = t0;
    const { title: title, providerIcon: providerIcon, status: status } = (0, $gzzWs.useSmartLinkMetadata)(url);
    const isLoading = status === "pending";
    let t1;
    let t2;
    if ($[0] !== isLoading || $[1] !== onLoadingChange) {
        t1 = ()=>{
            onLoadingChange?.(isLoading);
        };
        t2 = [
            isLoading,
            onLoadingChange
        ];
        $[0] = isLoading;
        $[1] = onLoadingChange;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t1, t2);
    if (isLoading) {
        let t3;
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEB6f5 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _4ouGXIdnbC"
            ]);
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                width: "100%",
                height: "20px",
                isShimmering: true
            });
            $[4] = t3;
            $[5] = t4;
        } else {
            t3 = $[4];
            t4 = $[5];
        }
        let t5;
        if ($[6] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t3
            }, t4);
            $[6] = t3;
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    const displayedTitle = displayTextOverride || title || fallback;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC"
        ]);
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== providerIcon) {
        t4 = providerIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmyCc.ProviderIconView), {
            icon: providerIcon
        }));
        $[9] = providerIcon;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC"
        ]);
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== displayedTitle) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, displayedTitle);
        $[12] = displayedTitle;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t5
        }, t6);
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t3 || $[18] !== t4 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, t4, t7);
        $[17] = t3;
        $[18] = t4;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ url: url, fallback: fallback, displayTextOverride: displayTextOverride, onLoadingChange: onLoadingChange })=>{
    const { title: title, providerIcon: providerIcon, status: status } = (0, $gzzWs.useSmartLinkMetadata)(url);
    const isLoading = status === 'pending'; // Notify parent of loading state changes
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        onLoadingChange?.(isLoading);
    }, [
        isLoading,
        onLoadingChange
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEB6f5 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _4ouGXIdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "20px",
        isShimmering: true
    }));
     // Priority: user override > resolved SmartLink title > fallback name
    const displayedTitle = displayTextOverride || title || fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC"
        ])
    }, providerIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmyCc.ProviderIconView), {
        icon: providerIcon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, displayedTitle)));
};
module.exports["SmartLinkSourceRow"] = $01e58e7fca834482$export$9290cc57346d0ec3;

});

parcelRegister("9gae3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $6OpMl = parcelRequire("6OpMl");


var $af2XZ = parcelRequire("af2XZ");


var $dTHYM = parcelRequire("dTHYM");

var $dUI0h = parcelRequire("dUI0h");

var $hpa99 = parcelRequire("hpa99");


var $gFEZF = parcelRequire("gFEZF");


var $iDfTs = parcelRequire("iDfTs");


var $b35Wv = parcelRequire("b35Wv");


var $8Svrc = parcelRequire("8Svrc");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $98i9C = parcelRequire("98i9C");


var $9ZZOa = parcelRequire("9ZZOa");


var $814i2 = parcelRequire("814i2");


const $2a719220cb826033$var$RovoLinkPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("lLexe")).then((mod)=>({
            default: mod.default
        })));
const $2a719220cb826033$var$styles = {
    rovoLinkPickerWrapper: "_0NUa3raVF6 _2WAcuGIZbP",
    sourceRow: "_4c065UgVvo",
    sourceTitleRow: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    emojiPickerTrigger: "_0LQT5E2ADO _0KLXrujOvk",
    sourcesContainer: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _4xdlr0FlnN",
    emptySourcesContainer: "_0bjKvDKTcp _3hxITisurO _2V7sgONvrM _3vBAKH9r67 _0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s _4xdlr0FlnN"
};
const $2a719220cb826033$var$SpaceSourcesLayout = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { sources: sources, onRemove: onRemove, renderSourceRow: renderSourceRow, addSourcesTrigger: addSourcesTrigger, addSourcesTriggerPrimary: addSourcesTriggerPrimary, removeSourceLabel: removeSourceLabel, noSourcesTitle: noSourcesTitle, noSources: noSources } = t0;
    let t1;
    if ($[0] !== addSourcesTrigger || $[1] !== addSourcesTriggerPrimary || $[2] !== noSources || $[3] !== noSourcesTitle || $[4] !== onRemove || $[5] !== removeSourceLabel || $[6] !== renderSourceRow || $[7] !== sources) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, sources.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2a719220cb826033$var$styles.emptySourcesContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ZZOa.EmptySourcesState), {
            title: noSourcesTitle,
            description: noSources,
            headingSize: "xsmall",
            action: addSourcesTriggerPrimary
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2a719220cb826033$var$styles.sourcesContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, sources.map((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                key: source.ari,
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                xcss: $2a719220cb826033$var$styles.sourceRow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "row",
                alignItems: "center",
                gap: "space.100",
                xcss: $2a719220cb826033$var$styles.sourceTitleRow
            }, renderSourceRow(source)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                appearance: "subtle",
                spacing: "compact",
                label: removeSourceLabel(source.name),
                onClick: ()=>onRemove(source.ari),
                testId: `space-modal-remove-source-${source.ari}`
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, addSourcesTrigger)));
        $[0] = addSourcesTrigger;
        $[1] = addSourcesTriggerPrimary;
        $[2] = noSources;
        $[3] = noSourcesTitle;
        $[4] = onRemove;
        $[5] = removeSourceLabel;
        $[6] = renderSourceRow;
        $[7] = sources;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : ({ sources: sources, onRemove: onRemove, renderSourceRow: renderSourceRow, addSourcesTrigger: addSourcesTrigger, addSourcesTriggerPrimary: addSourcesTriggerPrimary, removeSourceLabel: removeSourceLabel, noSourcesTitle: noSourcesTitle, noSources: noSources })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, sources.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2a719220cb826033$var$styles.emptySourcesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ZZOa.EmptySourcesState), {
        title: noSourcesTitle,
        description: noSources,
        headingSize: "xsmall",
        action: addSourcesTriggerPrimary
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2a719220cb826033$var$styles.sourcesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, sources.map((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            key: source.ari,
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $2a719220cb826033$var$styles.sourceRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "row",
            alignItems: "center",
            gap: "space.100",
            xcss: $2a719220cb826033$var$styles.sourceTitleRow
        }, renderSourceRow(source)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            appearance: "subtle",
            spacing: "compact",
            label: removeSourceLabel(source.name),
            onClick: ()=>onRemove(source.ari),
            testId: `space-modal-remove-source-${source.ari}`
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, addSourcesTrigger)));
const $2a719220cb826033$var$SpaceSourcesFieldBody = ({ fieldProps: fieldProps, cloudId: cloudId, plugins: plugins, addSourcesLabel: addSourcesLabel, removeSourceLabel: removeSourceLabel, renderSourceRow: renderSourceRow, testId: testId, noSourcesTitle: noSourcesTitle, noSources: noSources })=>{
    const [isPickerOpen, setPickerOpen] = (0, $cozmU.useState)(false);
    const sources = fieldProps.value ?? [];
    const fieldPropsRef = (0, $cozmU.useRef)(fieldProps);
    fieldPropsRef.current = fieldProps;
    const handleSubmit = (0, $cozmU.useCallback)(({ url: url, displayText: displayText, title: title })=>{
        const { onChange: onChange, value: value } = fieldPropsRef.current;
        const current = value ?? [];
        onChange([
            ...current,
            {
                ari: url,
                url: url,
                name: displayText ?? title ?? url,
                sourceType: (0, $814i2.detectSourceType)(url),
                conversationIds: []
            }
        ]);
        setPickerOpen(false);
    }, []);
    const makeAddSourcesTrigger = (appearance)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            isOpen: isPickerOpen,
            onClose: ()=>setPickerOpen(false),
            placement: "bottom-start",
            zIndex: 510,
            content: ()=>(0, $iDrrr.fg)('rovo_spaces_use_rovo_link_picker') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $2a719220cb826033$var$styles.rovoLinkPickerWrapper
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a719220cb826033$var$RovoLinkPicker, {
                    cloudId: cloudId,
                    onSubmit: handleSubmit,
                    onCancel: ()=>setPickerOpen(false)
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Svrc.DeprecatedLazyLinkPickerExport), {
                    plugins: plugins,
                    onSubmit: handleSubmit,
                    onCancel: ()=>setPickerOpen(false),
                    adaptiveHeight: true,
                    recentSearchListSize: 3
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    ...triggerProps,
                    appearance: appearance,
                    iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
                    type: "button",
                    onClick: ()=>setPickerOpen((prev)=>!prev),
                    testId: `${testId}-add-sources`
                }, addSourcesLabel)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a719220cb826033$var$SpaceSourcesLayout, {
        sources: sources,
        onRemove: (ari)=>fieldProps.onChange(sources.filter((s)=>s.ari !== ari)),
        renderSourceRow: renderSourceRow,
        addSourcesTrigger: makeAddSourcesTrigger('default'),
        addSourcesTriggerPrimary: makeAddSourcesTrigger('primary'),
        removeSourceLabel: removeSourceLabel,
        noSourcesTitle: noSourcesTitle,
        noSources: noSources
    });
};
const $2a719220cb826033$export$a6d170aafdfaa48b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { formId: formId, testId: testId, messages: msgs, initialName: t1, initialAbout: t2, initialSources: t3, selectedEmoji: selectedEmoji, onEmojiSelect: onEmojiSelect, isEmojiPickerOpen: isEmojiPickerOpen, onEmojiPickerToggle: onEmojiPickerToggle, onEmojiPickerClose: onEmojiPickerClose, emojiProvider: emojiProvider, cloudId: cloudId, plugins: plugins, onSubmit: onSubmit, renderSourceRow: renderSourceRow } = t0;
    const initialName = t1 === undefined ? "" : t1;
    const initialAbout = t2 === undefined ? "" : t2;
    let t4;
    if ($[0] !== t3) {
        t4 = t3 === undefined ? [] : t3;
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const initialSources = t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [nameLength, setNameLength] = (0, $cozmU.useState)(initialName.length);
    const [aboutLength, setAboutLength] = (0, $cozmU.useState)(initialAbout.length);
    let t5;
    if ($[2] !== aboutLength || $[3] !== cloudId || $[4] !== emojiProvider || $[5] !== formId || $[6] !== formatMessage || $[7] !== initialAbout || $[8] !== initialName || $[9] !== initialSources || $[10] !== isEmojiPickerOpen || $[11] !== msgs.aboutLabel || $[12] !== msgs.addSources || $[13] !== msgs.emojiPickerLabel || $[14] !== msgs.nameLabel || $[15] !== msgs.nameRequired || $[16] !== msgs.noSources || $[17] !== msgs.noSourcesTitle || $[18] !== msgs.removeSource || $[19] !== msgs.requiredFieldsHint || $[20] !== msgs.sourcesLabel || $[21] !== nameLength || $[22] !== onEmojiPickerClose || $[23] !== onEmojiPickerToggle || $[24] !== onEmojiSelect || $[25] !== plugins || $[26] !== renderSourceRow || $[27] !== selectedEmoji || $[28] !== testId) {
        t5 = (t6)=>{
            const { formProps: formProps } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
                ...formProps,
                id: formId,
                name: formId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p",
                "aria-hidden": "true",
                size: "small",
                color: "color.text.subtle"
            }, formatMessage(msgs.requiredFieldsHint, {
                asterisk: $2a719220cb826033$var$_temp
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "name",
                label: msgs.nameLabel,
                isRequired: true,
                defaultValue: initialName,
                validate: (value)=>value && String(value).trim() ? undefined : msgs.nameRequired,
                helperMessage: `${nameLength} / ${(0, $98i9C.SPACE_NAME_MAX_LENGTH)}`,
                component: (t7)=>{
                    const { fieldProps: fieldProps } = t7;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
                        zIndex: 510,
                        isOpen: isEmojiPickerOpen,
                        onClose: onEmojiPickerClose,
                        placement: "bottom-start",
                        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
                                emojiProvider: emojiProvider,
                                onSelection: onEmojiSelect
                            }),
                        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                                ...fieldProps,
                                maxLength: (0, $98i9C.SPACE_NAME_MAX_LENGTH),
                                onChange: (e)=>{
                                    setNameLength(e.currentTarget.value.length);
                                    fieldProps.onChange(e);
                                },
                                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                                    ...triggerProps,
                                    xcss: $2a719220cb826033$var$styles.emojiPickerTrigger,
                                    onClick: onEmojiPickerToggle,
                                    testId: `${testId}-emoji-picker-trigger`
                                }, selectedEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                                    emojiId: selectedEmoji,
                                    emojiProvider: emojiProvider,
                                    showTooltip: true,
                                    fitToHeight: 20
                                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                                    label: msgs.emojiPickerLabel
                                }))
                            })
                    });
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "about",
                label: msgs.aboutLabel,
                defaultValue: initialAbout,
                helperMessage: `${aboutLength} / ${(0, $98i9C.SPACE_ABOUT_MAX_LENGTH)}`,
                component: (t8)=>{
                    const { fieldProps: fieldProps_0 } = t8;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                        ...fieldProps_0,
                        maxLength: (0, $98i9C.SPACE_ABOUT_MAX_LENGTH),
                        onChange: (e_0)=>{
                            setAboutLength(e_0.currentTarget.value.length);
                            fieldProps_0.onChange(e_0);
                        }
                    });
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "sources",
                label: msgs.sourcesLabel,
                defaultValue: initialSources
            }, (t9)=>{
                const { fieldProps: fieldProps_1 } = t9;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a719220cb826033$var$SpaceSourcesFieldBody, {
                    fieldProps: fieldProps_1,
                    cloudId: cloudId,
                    plugins: plugins,
                    addSourcesLabel: msgs.addSources,
                    removeSourceLabel: msgs.removeSource,
                    renderSourceRow: renderSourceRow,
                    testId: testId,
                    noSourcesTitle: msgs.noSourcesTitle,
                    noSources: msgs.noSources
                });
            }));
        };
        $[2] = aboutLength;
        $[3] = cloudId;
        $[4] = emojiProvider;
        $[5] = formId;
        $[6] = formatMessage;
        $[7] = initialAbout;
        $[8] = initialName;
        $[9] = initialSources;
        $[10] = isEmojiPickerOpen;
        $[11] = msgs.aboutLabel;
        $[12] = msgs.addSources;
        $[13] = msgs.emojiPickerLabel;
        $[14] = msgs.nameLabel;
        $[15] = msgs.nameRequired;
        $[16] = msgs.noSources;
        $[17] = msgs.noSourcesTitle;
        $[18] = msgs.removeSource;
        $[19] = msgs.requiredFieldsHint;
        $[20] = msgs.sourcesLabel;
        $[21] = nameLength;
        $[22] = onEmojiPickerClose;
        $[23] = onEmojiPickerToggle;
        $[24] = onEmojiSelect;
        $[25] = plugins;
        $[26] = renderSourceRow;
        $[27] = selectedEmoji;
        $[28] = testId;
        $[29] = t5;
    } else t5 = $[29];
    let t6;
    if ($[30] !== onSubmit || $[31] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: onSubmit
        }, t5)));
        $[30] = onSubmit;
        $[31] = t5;
        $[32] = t6;
    } else t6 = $[32];
    return t6;
} : ({ formId: formId, testId: testId, messages: msgs, initialName: initialName = '', initialAbout: initialAbout = '', initialSources: initialSources = [], selectedEmoji: selectedEmoji, onEmojiSelect: onEmojiSelect, isEmojiPickerOpen: isEmojiPickerOpen, onEmojiPickerToggle: onEmojiPickerToggle, onEmojiPickerClose: onEmojiPickerClose, emojiProvider: emojiProvider, cloudId: cloudId, plugins: plugins, onSubmit: onSubmit, renderSourceRow: renderSourceRow })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [nameLength, setNameLength] = (0, $cozmU.useState)(initialName.length);
    const [aboutLength, setAboutLength] = (0, $cozmU.useState)(initialAbout.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            ...formProps,
            id: formId,
            name: formId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            "aria-hidden": "true",
            size: "small",
            color: "color.text.subtle"
        }, formatMessage(msgs.requiredFieldsHint, {
            asterisk: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            label: msgs.nameLabel,
            isRequired: true,
            defaultValue: initialName,
            validate: (value)=>value && String(value).trim() ? undefined : msgs.nameRequired,
            helperMessage: `${nameLength} / ${(0, $98i9C.SPACE_NAME_MAX_LENGTH)}`,
            component: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
                    zIndex: 510,
                    isOpen: isEmojiPickerOpen,
                    onClose: onEmojiPickerClose,
                    placement: "bottom-start",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
                            emojiProvider: emojiProvider,
                            onSelection: onEmojiSelect
                        }),
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                            ...fieldProps,
                            maxLength: (0, $98i9C.SPACE_NAME_MAX_LENGTH),
                            onChange: (e)=>{
                                setNameLength(e.currentTarget.value.length);
                                fieldProps.onChange(e);
                            },
                            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                                ...triggerProps,
                                xcss: $2a719220cb826033$var$styles.emojiPickerTrigger,
                                onClick: onEmojiPickerToggle,
                                testId: `${testId}-emoji-picker-trigger`
                            }, selectedEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
                                emojiId: selectedEmoji,
                                emojiProvider: emojiProvider,
                                showTooltip: true,
                                fitToHeight: 20
                            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                                label: msgs.emojiPickerLabel
                            }))
                        })
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "about",
            label: msgs.aboutLabel,
            defaultValue: initialAbout,
            helperMessage: `${aboutLength} / ${(0, $98i9C.SPACE_ABOUT_MAX_LENGTH)}`,
            component: ({ fieldProps: fieldProps_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                    ...fieldProps_0,
                    maxLength: (0, $98i9C.SPACE_ABOUT_MAX_LENGTH),
                    onChange: (e_0)=>{
                        setAboutLength(e_0.currentTarget.value.length);
                        fieldProps_0.onChange(e_0);
                    }
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "sources",
            label: msgs.sourcesLabel,
            defaultValue: initialSources
        }, ({ fieldProps: fieldProps_1 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a719220cb826033$var$SpaceSourcesFieldBody, {
                fieldProps: fieldProps_1,
                cloudId: cloudId,
                plugins: plugins,
                addSourcesLabel: msgs.addSources,
                removeSourceLabel: msgs.removeSource,
                renderSourceRow: renderSourceRow,
                testId: testId,
                noSourcesTitle: msgs.noSourcesTitle,
                noSources: msgs.noSources
            }))))));
};
function $2a719220cb826033$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null);
}
module.exports["SpaceModalForm"] = $2a719220cb826033$export$a6d170aafdfaa48b;

});

parcelRegister("9ZZOa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $hjvLL = parcelRequire("hjvLL");

const $76a4fc6c9638d928$var$styles = {
    container: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _4xdlr0FlnN",
    text: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _2fwxA5DIqT"
};
const $76a4fc6c9638d928$export$4834e1e7e47748cb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { title: title, description: description, action: action, headingSize: t1, testId: testId } = t0;
    const headingSize = t1 === undefined ? "medium" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjvLL.EmptySourcesIcon), null);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== headingSize || $[2] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: headingSize
        }, title);
        $[1] = headingSize;
        $[2] = title;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== description) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, description);
        $[4] = description;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $76a4fc6c9638d928$var$styles.text
        }, t3, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== action || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $76a4fc6c9638d928$var$styles.container,
            testId: testId
        }, t2, t5, action);
        $[9] = action;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ title: title, description: description, action: action, headingSize: headingSize = 'medium', testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $76a4fc6c9638d928$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjvLL.EmptySourcesIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $76a4fc6c9638d928$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: headingSize
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, description)), action);
module.exports["EmptySourcesState"] = $76a4fc6c9638d928$export$4834e1e7e47748cb;

});

parcelRegister("hjvLL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7hgf7 = parcelRequire("7hgf7");

const $56d0337a6a37c97a$export$bdce9a0a5b54a0ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 10.8896C0 6.1265 3.86129 2.26521 8.62443 2.26521H26.3756C31.1387 2.26521 35 6.1265 35 10.8896V28.6408C35 33.4039 31.1387 37.2652 26.3756 37.2652H8.62443C3.86129 37.2652 0 33.4039 0 28.6408V10.8896Z",
            fill: "white"
        });
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8.62402 2.81892H26.376C30.833 2.81914 34.4461 6.43226 34.4463 10.8892V28.6412C34.4461 33.0982 30.833 36.7113 26.376 36.7115H8.62402C4.16705 36.7113 0.553929 33.0982 0.553711 28.6412V10.8892C0.553929 6.43226 4.16705 2.81914 8.62402 2.81892Z",
            stroke: "#0B1228",
            strokeOpacity: "0.14",
            strokeWidth: "1.10756"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#empty-sources-clip0)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.8394 23.0665C11.8394 24.3058 10.8378 25.3075 9.59841 25.3075C8.35908 25.3075 7.35742 24.3058 7.35742 23.0665C7.35742 21.8272 8.35908 20.8255 9.59841 20.8255H11.8394V23.0665ZM12.9599 23.0665C12.9599 21.8272 13.9616 20.8255 15.2009 20.8255C16.4402 20.8255 17.4419 21.8272 17.4419 23.0665V28.669C17.4419 29.9083 16.4402 30.91 15.2009 30.91C13.9616 30.91 12.9599 29.9083 12.9599 28.669V23.0665Z",
            fill: "#E01E5A"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.2003 14.0685C13.961 14.0685 12.9593 13.0668 12.9593 11.8275C12.9593 10.5882 13.961 9.5865 15.2003 9.5865C16.4396 9.5865 17.4413 10.5882 17.4413 11.8275V14.0685H15.2003ZM15.2003 15.206C16.4396 15.206 17.4413 16.2076 17.4413 17.447C17.4413 18.6863 16.4396 19.6879 15.2003 19.6879H9.58084C8.3415 19.6879 7.33984 18.6863 7.33984 17.447C7.33984 16.2076 8.3415 15.206 9.58084 15.206H15.2003Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M24.1806 17.447C24.1806 16.2076 25.1823 15.206 26.4216 15.206C27.6609 15.206 28.6626 16.2076 28.6626 17.447C28.6626 18.6863 27.6609 19.6879 26.4216 19.6879H24.1806V17.447ZM23.0601 17.447C23.0601 18.6863 22.0585 19.6879 20.8191 19.6879C19.5798 19.6879 18.5781 18.6863 18.5781 17.447V11.8275C18.5781 10.5882 19.5798 9.5865 20.8191 9.5865C22.0585 9.5865 23.0601 10.5882 23.0601 11.8275V17.447V17.447Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.8191 26.428C22.0585 26.428 23.0601 27.4296 23.0601 28.669C23.0601 29.9083 22.0585 30.91 20.8191 30.91C19.5798 30.91 18.5781 29.9083 18.5781 28.669V26.428H20.8191ZM20.8191 25.3075C19.5798 25.3075 18.5781 24.3058 18.5781 23.0665C18.5781 21.8272 19.5798 20.8255 20.8191 20.8255H26.4386C27.6779 20.8255 28.6796 21.8272 28.6796 23.0665C28.6796 24.3058 27.6779 25.3075 26.4386 25.3075H20.8191Z",
            fill: "#ECB22E"
        }));
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "26.375",
            y: "4.19034",
            width: "35",
            height: "35",
            rx: "8.62443",
            transform: "rotate(-6 26.375 4.19034)",
            fill: "#FFDD33"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M49.2297 11.2153L46.7193 11.4792L49.1976 14.9349L44.2089 11.7431L41.6986 12.0069L44.4719 16.2576L39.1881 12.2708L36.6777 12.5346L39.7892 17.9892L38.4807 29.689L40.9911 29.4251L44.5149 16.6666L43.5016 29.1613L46.0119 28.8974L49.2406 15.344L48.5223 28.6336L51.0327 28.3697L54.1326 13.5903L49.2297 11.2153Z",
            fill: "black"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "56.2188",
            y: "2.26521",
            width: "35",
            height: "35",
            rx: "8.62443",
            fill: "white"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "56.7668",
            y: "2.81321",
            width: "33.904",
            height: "33.904",
            rx: "8.07643",
            stroke: "#0B1228",
            strokeOpacity: "0.14",
            strokeWidth: "1.096"
        });
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else {
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
    }
    let t7;
    let t8;
    let t9;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            transform: "translate(59.2188 5.26521)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hgf7.GoogleCalendarIconContent), null));
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M86.2646 8.5405C86.9275 3.82371 91.2886 0.537387 96.0053 1.20029L113.584 3.67077C118.301 4.33367 121.587 8.69477 120.924 13.4116L118.453 30.9899C117.791 35.7067 113.429 38.9931 108.713 38.3301L91.1343 35.8597C86.4175 35.1968 83.1312 30.8357 83.7941 26.1189L86.2646 8.5405Z",
            fill: "#292A2E"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M103.434 8.52485C97.5383 7.69632 92.0691 11.925 91.2195 17.9704C90.5398 22.8066 93.0221 27.3394 97.0604 29.3829C97.5797 29.5593 97.8232 29.248 97.8639 28.9589C97.9005 28.6979 98.0118 27.8342 98.1358 26.919C95.0727 27.1637 94.7206 25.122 94.7206 25.122C94.4128 23.7886 93.7603 23.3538 93.7603 23.3538C92.8872 22.5383 93.9268 22.6987 93.9268 22.6987C94.988 22.9265 95.4048 24.0566 95.4048 24.0566C96.1218 25.8638 97.7351 25.5972 98.3836 25.4032C98.5788 24.7092 98.9234 24.2652 99.2671 24.0348C96.9348 23.4247 94.574 22.1358 95.1635 17.9417C95.3314 16.7466 95.8857 15.8288 96.6763 15.1582C96.6042 14.867 96.3953 13.7023 97.1868 12.2761C97.1868 12.2761 98.1247 12.1079 99.9657 13.8108C100.851 13.6879 101.782 13.6946 102.69 13.818C103.596 13.9497 104.493 14.1997 105.312 14.5622C107.549 13.4324 108.403 13.8524 108.403 13.8524C108.772 15.4417 108.25 16.5037 108.1 16.7638C108.677 17.6265 108.954 18.6612 108.786 19.8562C108.195 24.0604 105.568 24.6351 103.152 24.5719C103.488 24.9654 103.735 25.6795 103.592 26.7007C103.386 28.1653 103.208 29.3423 103.157 29.7028C103.116 29.9941 103.26 30.3624 103.817 30.331C108.26 29.4778 111.891 25.8056 112.571 20.9711C113.42 14.9257 109.329 9.35345 103.434 8.52485Z",
            fill: "white"
        });
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else {
        t7 = $[7];
        t8 = $[8];
        t9 = $[9];
    }
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "123",
            height: "40",
            viewBox: "0 0 123 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
        }, t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "empty-sources-clip0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "21.5611",
            height: "21.5611",
            fill: "white",
            transform: "translate(7.2207 9.48473)"
        }))));
        $[10] = t10;
    } else t10 = $[10];
    return t10;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "123",
        height: "40",
        viewBox: "0 0 123 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 10.8896C0 6.1265 3.86129 2.26521 8.62443 2.26521H26.3756C31.1387 2.26521 35 6.1265 35 10.8896V28.6408C35 33.4039 31.1387 37.2652 26.3756 37.2652H8.62443C3.86129 37.2652 0 33.4039 0 28.6408V10.8896Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.62402 2.81892H26.376C30.833 2.81914 34.4461 6.43226 34.4463 10.8892V28.6412C34.4461 33.0982 30.833 36.7113 26.376 36.7115H8.62402C4.16705 36.7113 0.553929 33.0982 0.553711 28.6412V10.8892C0.553929 6.43226 4.16705 2.81914 8.62402 2.81892Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.10756"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#empty-sources-clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.8394 23.0665C11.8394 24.3058 10.8378 25.3075 9.59841 25.3075C8.35908 25.3075 7.35742 24.3058 7.35742 23.0665C7.35742 21.8272 8.35908 20.8255 9.59841 20.8255H11.8394V23.0665ZM12.9599 23.0665C12.9599 21.8272 13.9616 20.8255 15.2009 20.8255C16.4402 20.8255 17.4419 21.8272 17.4419 23.0665V28.669C17.4419 29.9083 16.4402 30.91 15.2009 30.91C13.9616 30.91 12.9599 29.9083 12.9599 28.669V23.0665Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.2003 14.0685C13.961 14.0685 12.9593 13.0668 12.9593 11.8275C12.9593 10.5882 13.961 9.5865 15.2003 9.5865C16.4396 9.5865 17.4413 10.5882 17.4413 11.8275V14.0685H15.2003ZM15.2003 15.206C16.4396 15.206 17.4413 16.2076 17.4413 17.447C17.4413 18.6863 16.4396 19.6879 15.2003 19.6879H9.58084C8.3415 19.6879 7.33984 18.6863 7.33984 17.447C7.33984 16.2076 8.3415 15.206 9.58084 15.206H15.2003Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24.1806 17.447C24.1806 16.2076 25.1823 15.206 26.4216 15.206C27.6609 15.206 28.6626 16.2076 28.6626 17.447C28.6626 18.6863 27.6609 19.6879 26.4216 19.6879H24.1806V17.447ZM23.0601 17.447C23.0601 18.6863 22.0585 19.6879 20.8191 19.6879C19.5798 19.6879 18.5781 18.6863 18.5781 17.447V11.8275C18.5781 10.5882 19.5798 9.5865 20.8191 9.5865C22.0585 9.5865 23.0601 10.5882 23.0601 11.8275V17.447V17.447Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.8191 26.428C22.0585 26.428 23.0601 27.4296 23.0601 28.669C23.0601 29.9083 22.0585 30.91 20.8191 30.91C19.5798 30.91 18.5781 29.9083 18.5781 28.669V26.428H20.8191ZM20.8191 25.3075C19.5798 25.3075 18.5781 24.3058 18.5781 23.0665C18.5781 21.8272 19.5798 20.8255 20.8191 20.8255H26.4386C27.6779 20.8255 28.6796 21.8272 28.6796 23.0665C28.6796 24.3058 27.6779 25.3075 26.4386 25.3075H20.8191Z",
        fill: "#ECB22E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "26.375",
        y: "4.19034",
        width: "35",
        height: "35",
        rx: "8.62443",
        transform: "rotate(-6 26.375 4.19034)",
        fill: "#FFDD33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.2297 11.2153L46.7193 11.4792L49.1976 14.9349L44.2089 11.7431L41.6986 12.0069L44.4719 16.2576L39.1881 12.2708L36.6777 12.5346L39.7892 17.9892L38.4807 29.689L40.9911 29.4251L44.5149 16.6666L43.5016 29.1613L46.0119 28.8974L49.2406 15.344L48.5223 28.6336L51.0327 28.3697L54.1326 13.5903L49.2297 11.2153Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "56.2188",
        y: "2.26521",
        width: "35",
        height: "35",
        rx: "8.62443",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "56.7668",
        y: "2.81321",
        width: "33.904",
        height: "33.904",
        rx: "8.07643",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.096"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: "translate(59.2188 5.26521)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hgf7.GoogleCalendarIconContent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M86.2646 8.5405C86.9275 3.82371 91.2886 0.537387 96.0053 1.20029L113.584 3.67077C118.301 4.33367 121.587 8.69477 120.924 13.4116L118.453 30.9899C117.791 35.7067 113.429 38.9931 108.713 38.3301L91.1343 35.8597C86.4175 35.1968 83.1312 30.8357 83.7941 26.1189L86.2646 8.5405Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M103.434 8.52485C97.5383 7.69632 92.0691 11.925 91.2195 17.9704C90.5398 22.8066 93.0221 27.3394 97.0604 29.3829C97.5797 29.5593 97.8232 29.248 97.8639 28.9589C97.9005 28.6979 98.0118 27.8342 98.1358 26.919C95.0727 27.1637 94.7206 25.122 94.7206 25.122C94.4128 23.7886 93.7603 23.3538 93.7603 23.3538C92.8872 22.5383 93.9268 22.6987 93.9268 22.6987C94.988 22.9265 95.4048 24.0566 95.4048 24.0566C96.1218 25.8638 97.7351 25.5972 98.3836 25.4032C98.5788 24.7092 98.9234 24.2652 99.2671 24.0348C96.9348 23.4247 94.574 22.1358 95.1635 17.9417C95.3314 16.7466 95.8857 15.8288 96.6763 15.1582C96.6042 14.867 96.3953 13.7023 97.1868 12.2761C97.1868 12.2761 98.1247 12.1079 99.9657 13.8108C100.851 13.6879 101.782 13.6946 102.69 13.818C103.596 13.9497 104.493 14.1997 105.312 14.5622C107.549 13.4324 108.403 13.8524 108.403 13.8524C108.772 15.4417 108.25 16.5037 108.1 16.7638C108.677 17.6265 108.954 18.6612 108.786 19.8562C108.195 24.0604 105.568 24.6351 103.152 24.5719C103.488 24.9654 103.735 25.6795 103.592 26.7007C103.386 28.1653 103.208 29.3423 103.157 29.7028C103.116 29.9941 103.26 30.3624 103.817 30.331C108.26 29.4778 111.891 25.8056 112.571 20.9711C113.42 14.9257 109.329 9.35345 103.434 8.52485Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "empty-sources-clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "21.5611",
        height: "21.5611",
        fill: "white",
        transform: "translate(7.2207 9.48473)"
    }))));
module.exports["EmptySourcesIcon"] = $56d0337a6a37c97a$export$bdce9a0a5b54a0ac;

});

parcelRegister("814i2", function(module, exports) {

var $4E2Cu = parcelRequire("4E2Cu");

function $ead13820dacc1e68$export$1d7dcc84f65ac3b7(_url) {
    return (0, $4E2Cu.SpaceSourceType).WebPage;
}
module.exports["detectSourceType"] = $ead13820dacc1e68$export$1d7dcc84f65ac3b7;

});

parcelRegister("4E2Cu", function(module, exports) {
/**
 * The type of a source added to a Rovo Space.
 * Must match the values accepted by the ConvoAI spaces API.
 */ var $d4fd9a2f84dba579$export$b3b057dbaceddc40 = /*#__PURE__*/ function(SpaceSourceType) {
    SpaceSourceType["WebPage"] = "WebPage";
    SpaceSourceType["File"] = "File";
    return SpaceSourceType;
}({});
module.exports["SpaceSourceType"] = $d4fd9a2f84dba579$export$b3b057dbaceddc40;

});

parcelRegister("bXMt2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f543cf543581d36c$var$message = (0, $kSwu1.defineMessages)({
    manageSpaceModalTitle: {
        id: "ai-mate.rovo-spaces.manage-space-modal.title",
        defaultMessage: "Manage Rovo space"
    },
    manageSpaceNameLabel: {
        id: "ai-mate.rovo-spaces.manage-space-modal.name-label",
        defaultMessage: "Name"
    },
    manageSpaceNameHelperMessage: {
        id: "ai-mate.rovo-spaces.manage-space-modal.name-helper",
        defaultMessage: "Give your Rovo space a short, clear name that explains what it does"
    },
    manageSpaceAboutLabel: {
        id: "ai-mate.rovo-spaces.manage-space-modal.about-label",
        defaultMessage: "About"
    },
    manageSpaceSourcesLabel: {
        id: "ai-mate.rovo-spaces.manage-space-modal.sources-label",
        defaultMessage: "Sources"
    },
    manageSpaceAddSources: {
        id: "ai-mate.rovo-spaces.manage-space-modal.add-sources",
        defaultMessage: "Add sources"
    },
    manageSpaceRemoveSource: {
        id: "ai-mate.rovo-spaces.manage-space-modal.remove-source",
        defaultMessage: "Remove {name}"
    },
    manageSpaceNameRequired: {
        id: "ai-mate.rovo-spaces.manage-space-modal.name-required",
        defaultMessage: "Enter a name"
    },
    manageSpaceEmojiPickerLabel: {
        id: "ai-mate.rovo-spaces.manage-space-modal.emoji-picker",
        defaultMessage: "Choose emoji"
    },
    manageSpaceCancel: {
        id: "ai-mate.rovo-spaces.manage-space-modal.cancel",
        defaultMessage: "Cancel"
    },
    manageSpaceSubmit: {
        id: "ai-mate.rovo-spaces.manage-space-modal.submit",
        defaultMessage: "Save"
    },
    manageSpaceRequiredFieldsHint: {
        id: "ai-mate.rovo-spaces.manage-space-modal.required-fields-hint",
        defaultMessage: "Required fields are marked with an asterisk <asterisk></asterisk>"
    },
    manageSpaceLoadError: {
        id: "ai-mate.rovo-spaces.manage-space-modal.load-error",
        defaultMessage: "Failed to load space details. Please try again."
    },
    manageSpaceSaveError: {
        id: "ai-mate.rovo-spaces.manage-space-modal.save-error",
        defaultMessage: "Failed to save changes. Please try again."
    },
    manageSpaceNoSourcesTitle: {
        id: "ai-mate.rovo-spaces.manage-space-modal.no-sources-title",
        defaultMessage: "No sources added"
    },
    manageSpaceNoSources: {
        id: "ai-mate.rovo-spaces.manage-space-modal.no-sources",
        defaultMessage: "Add sources to give Rovo context for this Rovo space."
    }
});
var $f543cf543581d36c$export$2e2bcd8739ae039 = $f543cf543581d36c$var$message;
module.exports["default"] = $f543cf543581d36c$export$2e2bcd8739ae039;

});

parcelRegister("ciTZQ", function(module, exports) {

let $8f529a311dd9c1c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8f529a311dd9c1c8$var$load("jzmNv").then(()=>parcelRequire('k8gqO'));

});

parcelRegister("kQqCc", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d52db76b74818184$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d52db76b74818184$export$64aee74ba59709e5 = 439; // px
const $d52db76b74818184$export$1c07393c5bb1bc27 = 439; // px
const $d52db76b74818184$export$aa3478deee7adbeb = 350; // px
const $d52db76b74818184$export$21e515a86cd1733b = 'Chat';
const $d52db76b74818184$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $d52db76b74818184$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $d52db76b74818184$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $d52db76b74818184$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $d52db76b74818184$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $d52db76b74818184$export$e942bf04e23ff966;

});

parcelRegister("e8YqO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $8575448fa98870df$export$69f8a6521b059b65 = (0, $kBr4q.createStateHook)((0, $lx3cN.chatStore), {
    selector: (state)=>state.conversations[state.currentConversationId]
});
module.exports["useCurrentConversation"] = $8575448fa98870df$export$69f8a6521b059b65;

});

parcelRegister("6GT8L", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $5480a605c5d38de7$export$e5fca4e502afbbf1 = (0, $kBr4q.createStateHook)((0, $lx3cN.chatStore), {
    selector: (state)=>state.currentConversationId
});
module.exports["useCurrentConversationId"] = $5480a605c5d38de7$export$e5fca4e502afbbf1;

});

parcelRegister("55KWY", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");

const $5646c864dfaa0c97$export$122df4b893b9354f = (surface)=>{
    if (!(0, $cXtTj.default).getExperimentValue('ai_speech_to_text_minor_bug_fixes', 'isEnabled', false)) return undefined;
    if (surface === 'mini-chat') return 'surface-raised';
    if (surface === 'cwr-staging-area-modal') {
        if ((0, $cXtTj.default).getExperimentValue('cwr-modal-ui-refresh', 'isEnabled', false)) return 'surface-raised';
        return 'surface-sunken';
    }
};
module.exports["getDictationOverlayBackground"] = $5646c864dfaa0c97$export$122df4b893b9354f;

});

parcelRegister("bCuI8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $aQWBL = parcelRequire("aQWBL");


var $6rwn6 = parcelRequire("6rwn6");


var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $lTU4O = parcelRequire("lTU4O");


var $3Cuhs = parcelRequire("3Cuhs");


var $3TxKn = parcelRequire("3TxKn");


var $5wAPd = parcelRequire("5wAPd");

const $4076c6eadf506e51$export$ccfb61c755435148 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId, options)=>{
    const $ = (0, $bDgLe.c)(18);
    const mode = options?.mode ?? "resend";
    const isEditMode = mode === "edit";
    const interactionSource = isEditMode ? "editMessage" : "resendMessage";
    const { sendMessage: sendMessage, truncateFromLastHumanMessage: truncateFromLastHumanMessage } = (0, $3TxKn.useChatStoreActions)();
    let t0;
    if ($[0] !== conversationId) {
        t0 = {
            conversationId: conversationId
        };
        $[0] = conversationId;
        $[1] = t0;
    } else t0 = $[1];
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)(t0);
    const { preferences: t1 } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = t1;
    const currentChatMode = (0, $aQWBL.useChatModeState)(conversationId);
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    let t2;
    if ($[2] !== conversationId || $[3] !== currentChatMode.appFilters || $[4] !== currentChatMode.deepResearchEnabled || $[5] !== currentChatMode.fastModeEnabled || $[6] !== currentChatMode.taskModeEnabled || $[7] !== currentChatMode.thinkDeeperEnabled || $[8] !== currentChatMode.useCurrentPageContext || $[9] !== currentChatMode.webSearchEnabled || $[10] !== getMessages || $[11] !== interactionSource || $[12] !== isEditMode || $[13] !== selectedAgent || $[14] !== sendMessage || $[15] !== storeUserMessages || $[16] !== truncateFromLastHumanMessage) {
        t2 = async (prompt, _errorData)=>{
            let webSearchEnabled;
            let deepResearchEnabled;
            let thinkDeeperEnabled;
            let fastModeEnabled;
            let taskModeEnabled;
            let useCurrentPageContext;
            let appFilters;
            webSearchEnabled = currentChatMode.webSearchEnabled;
            deepResearchEnabled = currentChatMode.deepResearchEnabled;
            thinkDeeperEnabled = currentChatMode.thinkDeeperEnabled;
            fastModeEnabled = currentChatMode.fastModeEnabled;
            taskModeEnabled = currentChatMode.taskModeEnabled;
            useCurrentPageContext = currentChatMode.useCurrentPageContext;
            appFilters = currentChatMode.appFilters;
            const followUpAgentIdentity = (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents") ? [
                ...getMessages(conversationId)
            ].reverse().find((0, $igOtY.isStoreHuman))?.followUpAgentIdentity : undefined;
            const followUpRetryAgentParams = followUpAgentIdentity ? {
                agentId: followUpAgentIdentity.id,
                followUpAgentIdentity: followUpAgentIdentity,
                messageAgentIdentity: {
                    agentId: followUpAgentIdentity.id,
                    ...followUpAgentIdentity.identityAccountId ? {
                        identityAccountId: followUpAgentIdentity.identityAccountId
                    } : {}
                }
            } : {
                agent: selectedAgent
            };
            const truncatedMessages = isEditMode ? await truncateFromLastHumanMessage({
                conversationId: conversationId
            }) : undefined;
            const targetParentMessageId = isEditMode ? (0, $3Cuhs.getLastAgentMessageID)(getMessages(conversationId)) ?? (0, $bkEBw.NO_PARENT_MESSAGE_ID) : undefined;
            sendMessage({
                ...followUpRetryAgentParams,
                prompt: (0, $6rwn6.encodeAdf)(prompt),
                conversationId: conversationId,
                storeUserMessages: storeUserMessages,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                taskModeEnabled: taskModeEnabled,
                fastModeEnabled: fastModeEnabled,
                webSearchEnabled: webSearchEnabled,
                addCurrentPageAsContextUserPreference: useCurrentPageContext,
                appFilters: appFilters,
                messageSources: {
                    interactionSource: interactionSource
                },
                ...isEditMode && targetParentMessageId ? {
                    parentMessageId: targetParentMessageId
                } : {},
                ...truncatedMessages && truncatedMessages.length > 0 ? {
                    editRollback: {
                        restoreMessages: truncatedMessages
                    }
                } : {}
            });
        };
        $[2] = conversationId;
        $[3] = currentChatMode.appFilters;
        $[4] = currentChatMode.deepResearchEnabled;
        $[5] = currentChatMode.fastModeEnabled;
        $[6] = currentChatMode.taskModeEnabled;
        $[7] = currentChatMode.thinkDeeperEnabled;
        $[8] = currentChatMode.useCurrentPageContext;
        $[9] = currentChatMode.webSearchEnabled;
        $[10] = getMessages;
        $[11] = interactionSource;
        $[12] = isEditMode;
        $[13] = selectedAgent;
        $[14] = sendMessage;
        $[15] = storeUserMessages;
        $[16] = truncateFromLastHumanMessage;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : (conversationId, options)=>{
    const mode = options?.mode ?? 'resend';
    const isEditMode = mode === 'edit';
    const interactionSource = isEditMode ? 'editMessage' : 'resendMessage';
    const { sendMessage: sendMessage, truncateFromLastHumanMessage: truncateFromLastHumanMessage } = (0, $3TxKn.useChatStoreActions)();
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    });
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const currentChatMode = (0, $aQWBL.useChatModeState)(conversationId);
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    return (0, $cozmU.useCallback)(async (prompt, _errorData)=>{
        let webSearchEnabled;
        let deepResearchEnabled;
        let thinkDeeperEnabled;
        let fastModeEnabled;
        let taskModeEnabled;
        let useCurrentPageContext;
        let appFilters;
        webSearchEnabled = currentChatMode.webSearchEnabled;
        deepResearchEnabled = currentChatMode.deepResearchEnabled;
        thinkDeeperEnabled = currentChatMode.thinkDeeperEnabled;
        fastModeEnabled = currentChatMode.fastModeEnabled;
        taskModeEnabled = currentChatMode.taskModeEnabled;
        useCurrentPageContext = currentChatMode.useCurrentPageContext;
        appFilters = currentChatMode.appFilters;
        // Capture follow-up provenance before edit mode removes the last human
        // message from the visible store. The metadata must survive that
        // truncation and be attached to the replacement human message.
        const followUpAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? [
            ...getMessages(conversationId)
        ].reverse().find((0, $igOtY.isStoreHuman))?.followUpAgentIdentity : undefined;
        const followUpRetryAgentParams = followUpAgentIdentity ? {
            agentId: followUpAgentIdentity.id,
            followUpAgentIdentity: followUpAgentIdentity,
            messageAgentIdentity: {
                agentId: followUpAgentIdentity.id,
                ...followUpAgentIdentity.identityAccountId ? {
                    identityAccountId: followUpAgentIdentity.identityAccountId
                } : {}
            }
        } : {
            agent: selectedAgent
        };
        // For edits, snapshot the hidden messages so `sendMessage` can
        // restore them via `editRollback` if the send fails terminally.
        const truncatedMessages = isEditMode ? await truncateFromLastHumanMessage({
            conversationId: conversationId
        }) : undefined;
        const targetParentMessageId = isEditMode ? (0, $3Cuhs.getLastAgentMessageID)(getMessages(conversationId)) ?? (0, $bkEBw.NO_PARENT_MESSAGE_ID) : undefined;
        sendMessage({
            ...followUpRetryAgentParams,
            prompt: (0, $6rwn6.encodeAdf)(prompt),
            conversationId: conversationId,
            storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
            // value when BE user settings are fully rolled out; BE overrides it via the capability header.
            storeUserMessages,
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            taskModeEnabled: taskModeEnabled,
            fastModeEnabled: fastModeEnabled,
            webSearchEnabled: webSearchEnabled,
            addCurrentPageAsContextUserPreference: useCurrentPageContext,
            appFilters: appFilters,
            messageSources: {
                interactionSource: interactionSource
            },
            ...isEditMode && targetParentMessageId ? {
                parentMessageId: targetParentMessageId
            } : {},
            ...truncatedMessages && truncatedMessages.length > 0 ? {
                editRollback: {
                    restoreMessages: truncatedMessages
                }
            } : {}
        });
    }, [
        selectedAgent,
        conversationId,
        storeUserMessages,
        sendMessage,
        truncateFromLastHumanMessage,
        currentChatMode,
        isEditMode,
        getMessages,
        interactionSource
    ]);
};
module.exports["useResendMessage"] = $4076c6eadf506e51$export$ccfb61c755435148;

});

parcelRegister("aDqDQ", function(module, exports) {

let $7be2365a90272ff0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7be2365a90272ff0$var$load("8OLQ4").then(()=>parcelRequire('cgTnG'));

});

parcelRegister("dPoYT", function(module, exports) {
const $8dbc220cf14fe789$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $8dbc220cf14fe789$export$bc36ebf73899a71d;

});

parcelRegister("5bVzv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $iA8l9 = parcelRequire("iA8l9");


var $dTEBe = parcelRequire("dTEBe");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $isp1U = parcelRequire("isp1U");


var $fa8WQ = parcelRequire("fa8WQ");


var $yJycJ = parcelRequire("yJycJ");


var $aaPn1 = parcelRequire("aaPn1");


var $4aGa7 = parcelRequire("4aGa7");

const $2462177dca532958$var$noopUseDuplicateAgent = {
    duplicateAgent: ()=>Promise.resolve()
};
const $2462177dca532958$export$56665b80ee272742 = ({ siteId: siteId, source: source, xpcBridge: xpcBridge = 'rovoAgents-agentUrlActions' })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics), (0, $isp1U.useProfileController), (0, $4aGa7.useDuplicateAgent), (0, $yJycJ.useAgentCrossProductUrlWrapper));
    const { email: email } = (0, $isp1U.useProfileController)();
    const { atlasURL: atlasURL } = (0, $aaPn1.useAtlasURL)(siteId);
    const wrapCrossProductUrl = (0, $yJycJ.useAgentCrossProductUrlWrapper)({
        xpcBridge: xpcBridge
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({
        touchPoint: source
    });
    const { duplicateAgent: duplicateAgent } = (0, $iDrrr.fg)('rovo_agent_versioning_enabled') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4aGa7.useDuplicateAgent)({
        siteId: siteId,
        source: source,
        email: email
    }) : $2462177dca532958$var$noopUseDuplicateAgent;
    const onEditAgent = (0, $cozmU.useCallback)((agentId)=>{
        window.open((0, $fa8WQ.getAtlassianStudioAgentEditUrl)(siteId, agentId, source, email));
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editAgentButton',
            // TODO: deduplicate source and interactionSource. source attribute is kept for backwards compatibility.
            attributes: {
                agentId: agentId,
                source: source,
                interactionSource: source
            }
        });
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackAgentEvent({
            action: 'edit',
            actionSubject: 'rovoAgent',
            attributes: {
                agentId: agentId
            }
        });
    }, [
        email,
        sendAnalyticsEvent,
        siteId,
        source,
        trackAgentEvent
    ]);
    const onCopyAgent = (0, $cozmU.useCallback)(({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, shouldCopyProfilePage: shouldCopyProfilePage })=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'copyAgentLinkButton',
            // TODO: deduplicate source and interactionSource. source attribute is kept for backwards compatibility.
            attributes: {
                agentId: agentId,
                source: source,
                interactionSource: source
            }
        });
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackAgentEvent({
            action: 'copyLink',
            actionSubject: 'rovoAgent',
            attributes: {
                agentId: agentId
            }
        });
        if (agentIdentityAccountId || shouldCopyProfilePage) {
            navigator.clipboard.writeText(wrapCrossProductUrl(atlasURL(`/people/agent/${agentId}`)));
            return;
        }
        const rovoParams = (0, $dTEBe.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId
        });
        navigator.clipboard.writeText(wrapCrossProductUrl(atlasURL(`/chat?${rovoParams}`)));
    }, [
        atlasURL,
        sendAnalyticsEvent,
        source,
        trackAgentEvent,
        wrapCrossProductUrl
    ]);
    const onDuplicateAgent = (0, $cozmU.useCallback)(async (agentId, agentAri)=>{
        if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) window.open((0, $fa8WQ.getAtlassianStudioAgentDuplicateUrl)(siteId, agentId, source, email));
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'duplicateAgentButton',
            // TODO: deduplicate source and interactionSource. source attribute is kept for backwards compatibility.
            attributes: {
                agentId: agentId,
                source: source,
                interactionSource: source
            }
        });
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackAgentEvent({
            action: 'duplicate',
            actionSubject: 'rovoAgent',
            attributes: {
                agentId: agentId
            }
        });
        if ((0, $iDrrr.fg)('rovo_agent_versioning_enabled')) await duplicateAgent(agentId, agentAri);
    }, [
        duplicateAgent,
        sendAnalyticsEvent,
        source,
        trackAgentEvent,
        siteId,
        email
    ]);
    const onViewAgentFullProfile = (0, $cozmU.useCallback)((agentId)=>{
        window.open(wrapCrossProductUrl(atlasURL(`/people/agent/${agentId}`)), '_blank', 'noopener, noreferrer');
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'viewAgentFullProfileButton',
            // TODO: deduplicate source and interactionSource. source attribute is kept for backwards compatibility.
            attributes: {
                agentId: agentId,
                source: source,
                interactionSource: source
            }
        });
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackAgentEvent({
            action: 'view',
            actionSubject: 'rovoAgent',
            attributes: {
                agentId: agentId
            }
        });
    }, [
        atlasURL,
        sendAnalyticsEvent,
        source,
        trackAgentEvent,
        wrapCrossProductUrl
    ]);
    const onStartNewChatWindowWithPrompt = (0, $cozmU.useCallback)((agentId, prompt)=>{
        const rovoParams = (0, $dTEBe.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId,
            prompt: prompt
        });
        window.open(wrapCrossProductUrl(atlasURL(`/chat?${rovoParams}`)), '_blank', 'noopener, noreferrer');
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackAgentEvent({
            action: 'chat',
            actionSubject: 'rovoAgent',
            attributes: {
                agentId: agentId
            }
        });
    }, [
        atlasURL,
        trackAgentEvent,
        wrapCrossProductUrl
    ]);
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent,
        onViewAgentFullProfile: onViewAgentFullProfile,
        onStartNewChatWindowWithPrompt: onStartNewChatWindowWithPrompt
    };
};
module.exports["useAgentUrlActions"] = $2462177dca532958$export$56665b80ee272742;

});

parcelRegister("fa8WQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gtQgC = parcelRequire("gtQgC");


var $2J4Io = parcelRequire("2J4Io");

const $7a5b39f110eb7e66$var$STUDIO_PROD_URL = 'https://studio.atlassian.com';
const $7a5b39f110eb7e66$var$STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $7a5b39f110eb7e66$export$72eb188ed9591973 = ()=>{
    return (0, $2J4Io.isStaging)() ? $7a5b39f110eb7e66$var$STUDIO_STAGING_URL : $7a5b39f110eb7e66$var$STUDIO_PROD_URL;
};
const $7a5b39f110eb7e66$var$getStudioEnv = ()=>(0, $2J4Io.isStaging)() ? 'staging' : 'production';
const $7a5b39f110eb7e66$export$372c8de5c124bdc8 = (path, email)=>{
    if (email) return (0, $gtQgC.getStudioSessionSyncUrl)($7a5b39f110eb7e66$var$getStudioEnv(), path, email);
    return `${$7a5b39f110eb7e66$export$72eb188ed9591973()}${path}`;
};
const $7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl = (workspaceId, spaceId, ruleIdUuid)=>{
    const base = `/w/${workspaceId}/spaces/${spaceId}/automation#`;
    return `${base}/rule/${encodeURIComponent(ruleIdUuid)}`;
};
const $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a = (siteId, navigationSource, csid, email, starterText)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', navigationSource);
    if (csid && (0, $iDrrr.fg)('rovo-agents-universal-analytics')) searchParams.set('csid', csid);
    if (starterText) searchParams.set('starterText', starterText);
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/chat${searchParams.size > 0 ? `?${searchParams}` : ''}`, email);
};
const $7a5b39f110eb7e66$export$fe475324c26e3007 = (siteId, email)=>{
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/overview`, email);
};
const $7a5b39f110eb7e66$export$ef221a159d6fa3e8 = (siteId, agentId, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`, email);
const $7a5b39f110eb7e66$export$a20abb994c34f0a4 = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/:agentId/overview')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$36c11ab884b7b2cb = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/create')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$c2d162390af7b91d = (siteId, agentAri, navigationSource, email)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', encodeURIComponent(navigationSource));
    const query = searchParams.size > 0 ? `?${searchParams}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/permissions${query}`, email);
};
const $7a5b39f110eb7e66$export$bae72ef7f23dbede = (workspaceId, spaceId, ruleIdUuid, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8($7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl(workspaceId, spaceId, ruleIdUuid), email);
module.exports["getStudioPath"] = $7a5b39f110eb7e66$export$372c8de5c124bdc8;
module.exports["getAtlassianStudioNLCreateUrl"] = $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a;
module.exports["getAtlassianStudioAgentEditUrl"] = $7a5b39f110eb7e66$export$a20abb994c34f0a4;
module.exports["getAtlassianStudioAgentDuplicateUrl"] = $7a5b39f110eb7e66$export$36c11ab884b7b2cb;
module.exports["getAtlassianStudioAutomationRuleEditUrl"] = $7a5b39f110eb7e66$export$bae72ef7f23dbede;

});

parcelRegister("gtQgC", function(module, exports) {

var $62APY = parcelRequire("62APY");

const $1665c8ad23657fd1$var$getStudioHost = (env)=>env === 'staging' ? (0, $62APY.STUDIO_STAGING_URL) : (0, $62APY.STUDIO_PROD_URL);
const $1665c8ad23657fd1$export$b4a3ce4b99911063 = (env, path, email)=>{
    const studioHost = $1665c8ad23657fd1$var$getStudioHost(env);
    const normalizedPath = path ? path.startsWith('/') ? path : `/${path}` : '';
    const destination = `${studioHost}${normalizedPath}`;
    if (!email) return destination;
    // Merge login_hint into any existing query string.
    const url = new URL(destination);
    url.searchParams.set('login_hint', email);
    return url.toString();
};
module.exports["getStudioSessionSyncUrl"] = $1665c8ad23657fd1$export$b4a3ce4b99911063;

});

parcelRegister("62APY", function(module, exports) {
const $e6043006edffc91a$export$83a42cd6c4b5f72d = 'https://studio.atlassian.com';
const $e6043006edffc91a$export$1b2ea4d616a1810d = 'https://studio.stg.atlassian.com';
module.exports["STUDIO_PROD_URL"] = $e6043006edffc91a$export$83a42cd6c4b5f72d;
module.exports["STUDIO_STAGING_URL"] = $e6043006edffc91a$export$1b2ea4d616a1810d;

});

parcelRegister("4aGa7", function(module, exports) {

var $248Tt = parcelRequire("248Tt");


var $h67Rq = parcelRequire("h67Rq");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4MnFz = parcelRequire("4MnFz");


var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $33DP2 = parcelRequire("33DP2");


var $fa8WQ = parcelRequire("fa8WQ");


var $k6dRn = parcelRequire("k6dRn");

/**
 * Builds the absolute redirect URL for a newly duplicated agent in Agent Studio.
 */ const $126f604c06c5e241$var$getDuplicatedAgentEditUrl = (siteId, agentAri, email)=>(0, $fa8WQ.getStudioPath)(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/v/draft/details`, email);
function $126f604c06c5e241$export$88c1547b9ec035f9({ siteId: siteId, source: source, email: email }) {
    (0, $6cFsl.di)((0, $6SsN4.fetchQuery), (0, $iDrrr.fg));
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const [commitMutation, isMutating] = (0, $6SsN4.useMutation)((0, $h67Rq.default));
    const duplicateAgent = (0, $cozmU.useCallback)(async (agentId, agentAri)=>{
        const legacyDuplicateUrl = (0, $fa8WQ.getAtlassianStudioAgentDuplicateUrl)(siteId, agentId, source, email);
        // When versioning FG is off, use legacy duplicate flow
        if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) {
            window.open(legacyDuplicateUrl);
            return;
        }
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).DUPLICATE_AGENT,
            name: (0, $irnO2.ExperienceName).DUPLICATE_AGENT
        });
        // Check if versioning migration has completed for this site
        // hasVersionCapability will only be true after BE backfill is done
        try {
            const data = await (0, $6SsN4.fetchQuery)(environment, (0, $248Tt.default), {
                cloudId: siteId
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
            const result = data?.agentStudio_hasVersionCapability;
            const hasVersionCapability = result?.__typename === 'AgentStudioHasVersionCapability' ? Boolean(result.hasVersionCapability) : false;
            if (!hasVersionCapability) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).DUPLICATE_AGENT
                });
                // Opening in same tab because, we cannot open in new tab after async operation, because browsers prevent `.open` after certain duration
                window.location.assign(legacyDuplicateUrl);
                return;
            }
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).DUPLICATE_AGENT,
                error: error instanceof Error ? error : new Error(String(error)),
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            // If version capability check fails, fall back to legacy flow
            // Opening in same tab because, we cannot open in new tab after async operation, because browsers prevent `.open` after certain duration
            window.location.assign(legacyDuplicateUrl);
            return;
        }
        // Call BE mutation to duplicate the agent
        await new Promise((resolve, reject)=>{
            commitMutation({
                variables: {
                    agentId: agentAri
                },
                onCompleted: (response)=>{
                    const mutationResult = response.agentStudio_duplicateAgent;
                    if (mutationResult?.success && mutationResult?.agent?.id) {
                        experienceTracker.succeed({
                            name: (0, $irnO2.ExperienceName).DUPLICATE_AGENT
                        });
                        // Opening in same tab because, we cannot open in new tab after async operation, because browsers prevent `.open` after certain duration
                        window.location.assign($126f604c06c5e241$var$getDuplicatedAgentEditUrl(siteId, mutationResult.agent.id, email));
                        resolve();
                    } else {
                        const message = mutationResult?.errors?.[0]?.message ?? formatMessage((0, $k6dRn.default).duplicateAgentErrorDescription);
                        const error_0 = new Error(message);
                        experienceTracker.fail({
                            name: (0, $irnO2.ExperienceName).DUPLICATE_AGENT,
                            error: error_0,
                            teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
                        });
                        showFlag({
                            title: formatMessage((0, $k6dRn.default).duplicateAgentErrorTitle),
                            description: message,
                            appearance: 'error',
                            isAutoDismiss: true
                        });
                        reject(error_0);
                    }
                },
                onError: (error_1)=>{
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).DUPLICATE_AGENT,
                        error: error_1,
                        teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
                    });
                    showFlag({
                        title: formatMessage((0, $k6dRn.default).duplicateAgentErrorTitle),
                        description: error_1.message ?? formatMessage((0, $k6dRn.default).duplicateAgentErrorDescription),
                        appearance: 'error',
                        isAutoDismiss: true
                    });
                    reject(error_1);
                }
            });
        });
    }, [
        commitMutation,
        email,
        environment,
        experienceTracker,
        formatMessage,
        showFlag,
        siteId,
        source
    ]);
    return {
        duplicateAgent: duplicateAgent,
        isMutating: isMutating
    };
}
module.exports["useDuplicateAgent"] = $126f604c06c5e241$export$88c1547b9ec035f9;

});

parcelRegister("248Tt", function(module, exports) {
/**
 * @generated SignedSource<<d112bd38133460e9b1f418d1a0d3d742>>
 * @relayHash 582857242705e01503c7d88b1d38efef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4a495fe774ef9c9f77bc0cdf87ee72298026bea52917b8c128d6a1156eb021aa
const $cf6df82ee97d8d86$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "LinkedField",
            "name": "agentStudio_hasVersionCapability",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasVersionCapability"
                        }
                    ],
                    "type": "AgentStudioHasVersionCapability"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "duplicate_hasVersionCapabilityQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "duplicate_hasVersionCapabilityQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "4a495fe774ef9c9f77bc0cdf87ee72298026bea52917b8c128d6a1156eb021aa",
            "metadata": {},
            "name": "duplicate_hasVersionCapabilityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cf6df82ee97d8d86$var$node.hash = "37de4ac9fc58ea6085ef3eacae3ccfd5";
var $cf6df82ee97d8d86$export$2e2bcd8739ae039 = $cf6df82ee97d8d86$var$node;
module.exports["default"] = $cf6df82ee97d8d86$export$2e2bcd8739ae039;

});

parcelRegister("h67Rq", function(module, exports) {
/**
 * @generated SignedSource<<2836fa3f2fdf6162031d760b5376a56b>>
 * @relayHash c7ace727849b1f0449d560cde95baa44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3086426ea67afdc98331e96a82222a65dcaf1d2fb8268c0ca8842edcdfa15782
const $ae9850d33c50bfb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "agentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "duplicate_duplicateAgentMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioCreateAgentPayload",
                    "kind": "LinkedField",
                    "name": "agentStudio_duplicateAgent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        },
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "duplicate_duplicateAgentMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioCreateAgentPayload",
                    "kind": "LinkedField",
                    "name": "agentStudio_duplicateAgent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "3086426ea67afdc98331e96a82222a65dcaf1d2fb8268c0ca8842edcdfa15782",
            "metadata": {},
            "name": "duplicate_duplicateAgentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ae9850d33c50bfb6$var$node.hash = "d8feac813ad718cc67fca8aac45e97fa";
var $ae9850d33c50bfb6$export$2e2bcd8739ae039 = $ae9850d33c50bfb6$var$node;
module.exports["default"] = $ae9850d33c50bfb6$export$2e2bcd8739ae039;

});

parcelRegister("k6dRn", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c1027e619848d4f7$var$message = (0, $kSwu1.defineMessages)({
    duplicateAgentErrorTitle: {
        id: "rovo-chat.agent-url-actions.duplicate-agent-error-title",
        defaultMessage: "Failed to duplicate agent"
    },
    duplicateAgentErrorDescription: {
        id: "rovo-chat.agent-url-actions.duplicate-agent-error-description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
var $c1027e619848d4f7$export$2e2bcd8739ae039 = $c1027e619848d4f7$var$message;
module.exports["default"] = $c1027e619848d4f7$export$2e2bcd8739ae039;

});

parcelRegister("b68JT", function(module, exports) {

let $814708aa5659b26d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $814708aa5659b26d$var$load("a8glC"),
    $814708aa5659b26d$var$load("kwpbe")
]).then(()=>parcelRequire('2nybJ'));

});

parcelRegister("a2bT0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ekCm6 = parcelRequire("ekCm6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

const $86a4b05b54bce4ef$var$styles = {
    image: "_00EA0eiObl _0jFU0VN91d _39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    banner: "_39xV02N91d",
    bannerFillSpace: "_39xV02N91d _0jFU0VN91d _00EA0eiObl",
    bannerRemoteA2A: "_0KLXruG6qS"
};
const $86a4b05b54bce4ef$var$Observer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onLoad: onLoad } = t0;
    let t1;
    let t2;
    if ($[0] !== onLoad) {
        t1 = ()=>{
            onLoad();
        };
        t2 = [
            onLoad
        ];
        $[0] = onLoad;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ onLoad: onLoad })=>{
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $86a4b05b54bce4ef$var$AutoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kYpKY")));

const $86a4b05b54bce4ef$var$AutoFixAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("feg39")));

const $86a4b05b54bce4ef$var$AutoReviewAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4RJuR")));

const $86a4b05b54bce4ef$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("di1lo")));

const $86a4b05b54bce4ef$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j5vOg")));

const $86a4b05b54bce4ef$var$CultureAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ir4Zs")));

const $86a4b05b54bce4ef$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("huaWP")));

const $86a4b05b54bce4ef$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("e7aux")));

const $86a4b05b54bce4ef$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ef6sM")));

const $86a4b05b54bce4ef$var$GenericAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eMArC")));

const $86a4b05b54bce4ef$var$HireWriterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lLIpI")));

const $86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("guf1O")));

const $86a4b05b54bce4ef$var$MyUserManualAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fqQ0Z")));

const $86a4b05b54bce4ef$var$OkrOracleAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("g5Au7")));

const $86a4b05b54bce4ef$var$OpsAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jduPc")));

const $86a4b05b54bce4ef$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2BsbE")));

const $86a4b05b54bce4ef$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ccwx8")));

const $86a4b05b54bce4ef$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kCYzi")));

const $86a4b05b54bce4ef$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eGpCl")));

const $86a4b05b54bce4ef$var$RovoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("iLJ1v")));

const $86a4b05b54bce4ef$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j6OuY")));

const $86a4b05b54bce4ef$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ddq5w")));

const $86a4b05b54bce4ef$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lnaW2")));

const $86a4b05b54bce4ef$var$TrialGuideAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jMZdA")));

const $86a4b05b54bce4ef$var$JsmRovoServiceAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4Jhm3"))); /**
                                      * OOTB Agents avatars - start
                                      */ 

const $86a4b05b54bce4ef$var$AmplitudeAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1lG7v")));

const $86a4b05b54bce4ef$var$BoxAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cr6cT")));

const $86a4b05b54bce4ef$var$CanvaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("l39Ik")));

const $86a4b05b54bce4ef$var$FigmaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eWJHH")));

const $86a4b05b54bce4ef$var$HubSpotAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hpLK5")));

const $86a4b05b54bce4ef$var$IntercomAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ceWMu")));

const $86a4b05b54bce4ef$var$GammaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5BSGs")));

const $86a4b05b54bce4ef$var$LovableAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dU4PR")));

const $86a4b05b54bce4ef$var$ReplitAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4d0IW")));

const $86a4b05b54bce4ef$var$RovoAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7kGM2")));

const $86a4b05b54bce4ef$var$JiraWorkAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hNwBH")));

const $86a4b05b54bce4ef$var$JiraCodingAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eYFGv")));

const $86a4b05b54bce4ef$var$JiraIntelligentTriageAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUkXO"))); /**
                                             * OOTB Agents avatars - end
                                             */ 
const $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716',
    cover: '#FEF7C8'
};
const $86a4b05b54bce4ef$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7',
    cover: '#F8EEFE'
};
const $86a4b05b54bce4ef$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72',
    cover: '#EFFFD6'
};
const $86a4b05b54bce4ef$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1',
    cover: '#E9F2FE'
};
const $86a4b05b54bce4ef$var$colorList = [
    $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2,
    $86a4b05b54bce4ef$export$3e344798f7855e62,
    $86a4b05b54bce4ef$export$a3d0897f023251ae,
    $86a4b05b54bce4ef$export$d933daaf7b69e6ee
]; /**
                                                                                          * NOTE: DO NOT ADD OOTB AGENTAVATARS TO THIS LIST
                                                                                          */ 
const $86a4b05b54bce4ef$var$avatarList = [
    $86a4b05b54bce4ef$var$CustomerInsightAvatar,
    $86a4b05b54bce4ef$var$BacklogBuddyAvatar,
    $86a4b05b54bce4ef$var$DecisionDirectorAvatar,
    $86a4b05b54bce4ef$var$CommsCrafterAvatar,
    $86a4b05b54bce4ef$var$AutoDevAvatar,
    $86a4b05b54bce4ef$var$OkrOracleAvatar,
    $86a4b05b54bce4ef$var$CultureAvatar,
    $86a4b05b54bce4ef$var$SocialMediaScribeAvatar,
    $86a4b05b54bce4ef$var$TeamConnectionAvatar,
    $86a4b05b54bce4ef$var$HireWriterAvatar,
    $86a4b05b54bce4ef$var$OpsAgentAvatar,
    $86a4b05b54bce4ef$var$ResearchScoutAvatar,
    $86a4b05b54bce4ef$var$ReleaseNotesAvatar,
    $86a4b05b54bce4ef$var$MyUserManualAvatar,
    $86a4b05b54bce4ef$var$PitchPerfectorAvatar,
    $86a4b05b54bce4ef$var$AutoDevAvatar,
    $86a4b05b54bce4ef$var$AutoFixAvatar,
    $86a4b05b54bce4ef$var$AutoReviewAvatar,
    $86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar,
    $86a4b05b54bce4ef$var$FeatureFlagAvatar,
    $86a4b05b54bce4ef$var$ProductRequirementAvatar
];
const $86a4b05b54bce4ef$export$a834793a4d0d739e = $86a4b05b54bce4ef$var$avatarList.length * $86a4b05b54bce4ef$var$colorList.length;
const $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoFixAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ResearchScoutAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$HireWriterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$SocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$FeatureFlagAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$DecisionDirectorAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    planner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.primary,
                secondaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.secondary
            }),
        color: $86a4b05b54bce4ef$export$3e344798f7855e62
    },
    tech_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$SocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ProductRequirementAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$BacklogBuddyAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    discovery_and_feedback_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$CommsCrafterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$WorkflowBuilderAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoReviewAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$TrialGuideAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    daily_brief_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$TrialGuideAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    jira_admin_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoDevAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jsm_rovo_service_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JsmRovoServiceAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    mcp_amplitude_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AmplitudeAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_box_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$BoxAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_canva_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$CanvaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_figma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$FigmaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_hubspot_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$HubSpotAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_intercom_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$IntercomAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_gamma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$GammaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_lovable_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$LovableAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_replit_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ReplitAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    rovo_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jira_work_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraWorkAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jira_intelligent_triage_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraIntelligentTriageAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jira_coding_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraCodingAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $86a4b05b54bce4ef$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $86a4b05b54bce4ef$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $86a4b05b54bce4ef$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, size: size })=>{
    if (isRovoDev) return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoDevAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    };
     //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $86a4b05b54bce4ef$var$ROVO_DEV_AGENT_ID && (0, $iDrrr.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoDevAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $86a4b05b54bce4ef$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $86a4b05b54bce4ef$var$avatarList.length * $86a4b05b54bce4ef$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $86a4b05b54bce4ef$var$colorList.length);
        const colorIndex = combinationIndex % $86a4b05b54bce4ef$var$colorList.length;
        const Avatar = $86a4b05b54bce4ef$var$avatarList[avatarIndex];
        const color = $86a4b05b54bce4ef$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Avatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$GenericAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
            secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
        }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    };
};
const $86a4b05b54bce4ef$export$d30ec808815da53a = (props)=>$86a4b05b54bce4ef$var$getAvatarRender({
        ...props,
        size: 'medium'
    }).color;
const $86a4b05b54bce4ef$export$6efaefb8ad2fba40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, creatorType: creatorType, height: height, fillSpace: fillSpace } = t0;
    let t1;
    if ($[0] !== agentId || $[1] !== agentIdentityAccountId || $[2] !== agentNamedId || $[3] !== isRovoDev) {
        t1 = $86a4b05b54bce4ef$export$d30ec808815da53a({
            agentNamedId: agentNamedId,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            isRovoDev: isRovoDev
        });
        $[0] = agentId;
        $[1] = agentIdentityAccountId;
        $[2] = agentNamedId;
        $[3] = isRovoDev;
        $[4] = t1;
    } else t1 = $[4];
    const color = t1;
    const isRemoteA2A = (0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a") && creatorType === "REMOTE_A2A";
    const t2 = fillSpace ? $86a4b05b54bce4ef$var$styles.bannerFillSpace : undefined;
    const t3 = isRemoteA2A ? $86a4b05b54bce4ef$var$styles.bannerRemoteA2A : undefined;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $w6R6I.cx)($86a4b05b54bce4ef$var$styles.banner, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = isRemoteA2A ? undefined : color.primary;
    const t6 = height ? `${height}px` : undefined;
    let t7;
    if ($[8] !== t5 || $[9] !== t6) {
        t7 = {
            backgroundColor: t5,
            height: t6
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t4 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4,
            style: t7
        });
        $[11] = t4;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, creatorType: creatorType, height: height, fillSpace: fillSpace })=>{
    const color = $86a4b05b54bce4ef$export$d30ec808815da53a({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev
    });
    const isRemoteA2A = (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') && creatorType === 'REMOTE_A2A';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($86a4b05b54bce4ef$var$styles.banner, fillSpace ? $86a4b05b54bce4ef$var$styles.bannerFillSpace : undefined, isRemoteA2A ? $86a4b05b54bce4ef$var$styles.bannerRemoteA2A : undefined),
        style: {
            backgroundColor: isRemoteA2A ? undefined : color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $86a4b05b54bce4ef$export$96bb253b7de22616 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] !== props) {
        t0 = $86a4b05b54bce4ef$var$getAvatarRender(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const { render: render, color: color } = t0;
    const { onLoad: onLoad } = props;
    let t1;
    if ($[2] !== color.primary) {
        t1 = {
            backgroundColor: color.primary
        };
        $[2] = color.primary;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onLoad) {
        t2 = onLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$Observer, {
            onLoad: onLoad
        });
        $[4] = onLoad;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== render || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, t2, render);
        $[6] = render;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $86a4b05b54bce4ef$var$styles.image,
            style: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : (props)=>{
    const { render: render, color: color } = $86a4b05b54bce4ef$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $86a4b05b54bce4ef$var$styles.image,
        style: {
            backgroundColor: color.primary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, onLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$Observer, {
        onLoad: onLoad
    }), render));
};
module.exports["getAgentAvatarColor"] = $86a4b05b54bce4ef$export$d30ec808815da53a;
module.exports["AgentBanner"] = $86a4b05b54bce4ef$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $86a4b05b54bce4ef$export$96bb253b7de22616;

});

parcelRegister("kYpKY", function(module, exports) {

let $f44d63f7a74f8acb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f44d63f7a74f8acb$var$load("iMObC").then(()=>parcelRequire('iXsN7'));

});

parcelRegister("feg39", function(module, exports) {

let $b1649cfe483ec9a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1649cfe483ec9a0$var$load("kstRm").then(()=>parcelRequire('bK6sM'));

});

parcelRegister("4RJuR", function(module, exports) {

let $38af675cb55db454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38af675cb55db454$var$load("llcXv").then(()=>parcelRequire('dCNdL'));

});

parcelRegister("di1lo", function(module, exports) {

let $9acdffb5c59e3f0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9acdffb5c59e3f0d$var$load("b4KKP").then(()=>parcelRequire('20vx6'));

});

parcelRegister("j5vOg", function(module, exports) {

let $de5728acaffb9591$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5728acaffb9591$var$load("407ox").then(()=>parcelRequire('4MOGN'));

});

parcelRegister("ir4Zs", function(module, exports) {

let $d6be9e8e0052869c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6be9e8e0052869c$var$load("48VmB").then(()=>parcelRequire('h7Jie'));

});

parcelRegister("huaWP", function(module, exports) {

let $cbadbb06a0117620$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbadbb06a0117620$var$load("7J2T4").then(()=>parcelRequire('jEDvD'));

});

parcelRegister("e7aux", function(module, exports) {

let $a469db8def0a1348$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a469db8def0a1348$var$load("k8VH8").then(()=>parcelRequire('8DKak'));

});

parcelRegister("ef6sM", function(module, exports) {

let $a5e77ad7ccb3cdb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5e77ad7ccb3cdb5$var$load("73ECg").then(()=>parcelRequire('K1eyd'));

});

parcelRegister("eMArC", function(module, exports) {

let $ac31d1852b44e66b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac31d1852b44e66b$var$load("l7xQ8").then(()=>parcelRequire('8uuyE'));

});

parcelRegister("lLIpI", function(module, exports) {

let $fd907066efd418c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd907066efd418c0$var$load("gZUKs").then(()=>parcelRequire('ky2MY'));

});

parcelRegister("guf1O", function(module, exports) {

let $c00b1afcb70b5574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c00b1afcb70b5574$var$load("iUIIz").then(()=>parcelRequire('gu3EK'));

});

parcelRegister("fqQ0Z", function(module, exports) {

let $b3c1a1ca91afe332$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3c1a1ca91afe332$var$load("4WEyz").then(()=>parcelRequire('gECy4'));

});

parcelRegister("g5Au7", function(module, exports) {

let $bb696a1487973d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb696a1487973d02$var$load("hTrWv").then(()=>parcelRequire('eHp1N'));

});

parcelRegister("jduPc", function(module, exports) {

let $dfd72461b7e5efd7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd72461b7e5efd7$var$load("hgSu9").then(()=>parcelRequire('jGDeV'));

});

parcelRegister("2BsbE", function(module, exports) {

let $1e54e6d15e249ea8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e54e6d15e249ea8$var$load("1Cm5e").then(()=>parcelRequire('1c1x3'));

});

parcelRegister("ccwx8", function(module, exports) {

let $8e1fd77f340721b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e1fd77f340721b6$var$load("gW1VO").then(()=>parcelRequire('jldw7'));

});

parcelRegister("kCYzi", function(module, exports) {

let $f04656d6233e5a5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f04656d6233e5a5c$var$load("2xiJO").then(()=>parcelRequire('kNSgL'));

});

parcelRegister("eGpCl", function(module, exports) {

let $ab08dc039565a58c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab08dc039565a58c$var$load("3s3o5").then(()=>parcelRequire('8eply'));

});

parcelRegister("iLJ1v", function(module, exports) {

let $da9f8a7981ec2ce4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da9f8a7981ec2ce4$var$load("lGvlN").then(()=>parcelRequire('kEjPu'));

});

parcelRegister("j6OuY", function(module, exports) {

let $de95bfd69ede0761$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de95bfd69ede0761$var$load("hdDMK").then(()=>parcelRequire('6bCpe'));

});

parcelRegister("ddq5w", function(module, exports) {

let $99f0b9d3ccdd4a58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f0b9d3ccdd4a58$var$load("3mJV2").then(()=>parcelRequire('7Gb4S'));

});

parcelRegister("lnaW2", function(module, exports) {

let $f8f43a6dc90f9eee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8f43a6dc90f9eee$var$load("cMLT2").then(()=>parcelRequire('5tcSN'));

});

parcelRegister("jMZdA", function(module, exports) {

let $e681fcafe11e5342$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e681fcafe11e5342$var$load("6194k").then(()=>parcelRequire('6LeK2'));

});

parcelRegister("4Jhm3", function(module, exports) {

let $3718d3b36fa5fd70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3718d3b36fa5fd70$var$load("izPy1").then(()=>parcelRequire('hZ7pV'));

});

parcelRegister("1lG7v", function(module, exports) {

let $0fb86cc2c4073147$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fb86cc2c4073147$var$load("i1Et0").then(()=>parcelRequire('kTKKU'));

});

parcelRegister("cr6cT", function(module, exports) {

let $90dcd23c2f2236db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90dcd23c2f2236db$var$load("5OeCI").then(()=>parcelRequire('7ynR8'));

});

parcelRegister("l39Ik", function(module, exports) {

let $f53169c4259cb361$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f53169c4259cb361$var$load("1SMTI").then(()=>parcelRequire('8sDTM'));

});

parcelRegister("eWJHH", function(module, exports) {

let $ae19ef4d540d8f6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae19ef4d540d8f6b$var$load("9UVYf").then(()=>parcelRequire('9KXxY'));

});

parcelRegister("hpLK5", function(module, exports) {

let $cad9ce1adc1d7cd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad9ce1adc1d7cd1$var$load("4wV7K").then(()=>parcelRequire('eW24X'));

});

parcelRegister("ceWMu", function(module, exports) {

let $8e94638544de9830$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e94638544de9830$var$load("4iPF7").then(()=>parcelRequire('dcQg7'));

});

parcelRegister("5BSGs", function(module, exports) {

let $415ad37e6a0ebc27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $415ad37e6a0ebc27$var$load("gwLRR").then(()=>parcelRequire('2T7Fz'));

});

parcelRegister("dU4PR", function(module, exports) {

let $a1f4418b8e7e3f7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1f4418b8e7e3f7b$var$load("8qEhZ").then(()=>parcelRequire('1RnD4'));

});

parcelRegister("4d0IW", function(module, exports) {

let $3108f0168aaf0c49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3108f0168aaf0c49$var$load("8FUME").then(()=>parcelRequire('77zEU'));

});

parcelRegister("7kGM2", function(module, exports) {

let $556b94a300dbe36c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $556b94a300dbe36c$var$load("eOveI").then(()=>parcelRequire('74dGw'));

});

parcelRegister("hNwBH", function(module, exports) {

let $cf504e5f033f5a23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf504e5f033f5a23$var$load("5wdgL").then(()=>parcelRequire('7iDJ1'));

});

parcelRegister("eYFGv", function(module, exports) {

let $ae7700fce28cc575$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae7700fce28cc575$var$load("gfDZQ").then(()=>parcelRequire('eSnga'));

});

parcelRegister("hUkXO", function(module, exports) {

let $d097ed960fc80e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d097ed960fc80e30$var$load("044PY").then(()=>parcelRequire('lUlGx'));

});

parcelRegister("dovdS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd650ff33600fe67e96a64bc56706f09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c05bc74468e32ae$var$_react = $9c05bc74468e32ae$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9c05bc74468e32ae$var$_baseNew = $9c05bc74468e32ae$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9c05bc74468e32ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Node".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/node
 * Usage guidance:
 * Single purpose - Reserved for a non-expandable item in a page tree.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c05bc74468e32ae$var$NodeIcon = (props)=>/*#__PURE__*/ $9c05bc74468e32ae$var$_react.default.createElement($9c05bc74468e32ae$var$_baseNew.default, Object.assign({
        name: "NodeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>`
    }, props));
$9c05bc74468e32ae$var$NodeIcon.displayName = 'NodeIcon';
var $9c05bc74468e32ae$var$_default = module.exports.default = $9c05bc74468e32ae$var$NodeIcon;

});

parcelRegister("3vgx3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $4CEP6 = parcelRequire("4CEP6");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $jp2Q3 = parcelRequire("jp2Q3");


var $eLJVM = parcelRequire("eLJVM");


var $iv7mf = parcelRequire("iv7mf");


var $94Dr9 = parcelRequire("94Dr9");


var $ggC1G = parcelRequire("ggC1G");


var $imIsb = parcelRequire("imIsb");


var $eEek6 = parcelRequire("eEek6");

const $53393d8413cfd6c9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $53393d8413cfd6c9$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $53393d8413cfd6c9$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${crossAxis}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-start`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $53393d8413cfd6c9$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ const $53393d8413cfd6c9$var$DropdownMenuLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropdownMenuLegacy(t0) {
    const $ = (0, $bDgLe.c)(63);
    const { autoFocus: t1, children: children, defaultOpen: t2, isLoading: t3, isOpen: isOpen, onOpenChange: t4, placement: t5, shouldFitContainer: t6, shouldFlip: t7, shouldRenderToParent: t8, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: t9, label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: t10, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const defaultOpen = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const onOpenChange = t4 === undefined ? (0, $dpsRj.default) : t4;
    const placement = t5 === undefined ? "bottom-start" : t5;
    const shouldFitContainer = t6 === undefined ? false : t6;
    const shouldFlip = t7 === undefined ? true : t7;
    const shouldRenderToParent = t8 === undefined ? false : t8;
    let t11;
    if ($[0] !== t9) {
        t11 = t9 === undefined ? (0, $jp2Q3.layers).modal() : t9;
        $[0] = t9;
        $[1] = t11;
    } else t11 = $[1];
    const zIndex = t11;
    const shouldPreventEscapePropagation = t10 === undefined ? false : t10;
    let t12;
    if ($[2] !== defaultOpen) {
        t12 = ()=>defaultOpen;
        $[2] = defaultOpen;
        $[3] = t12;
    } else t12 = $[3];
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, t12);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    let t13;
    if ($[4] !== placement) {
        t13 = $53393d8413cfd6c9$var$getFallbackPlacements(placement);
        $[4] = placement;
        $[5] = t13;
    } else t13 = $[5];
    const fallbackPlacements = t13;
    let t14;
    if ($[6] !== isLocalOpen || $[7] !== itemRef || $[8] !== onOpenChange || $[9] !== setLocalIsOpen) {
        t14 = (event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === "keydown") setTriggeredUsingKeyboard(true);
            else {
                if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
                else if (detail === 0) setTriggeredUsingKeyboard(true);
                else {
                    itemRef?.current?.focus();
                    setTriggeredUsingKeyboard(false);
                }
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        };
        $[6] = isLocalOpen;
        $[7] = itemRef;
        $[8] = onOpenChange;
        $[9] = setLocalIsOpen;
        $[10] = t14;
    } else t14 = $[10];
    const handleTriggerClicked = t14;
    let t15;
    if ($[11] !== itemRef || $[12] !== onOpenChange || $[13] !== returnFocusRef || $[14] !== setLocalIsOpen || $[15] !== shouldPreventEscapePropagation) {
        t15 = (event_0, currentLevel_0)=>{
            const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT));
            if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
            if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`)) {
                if (!currentLevel_0) return;
                const toCloseLevel = itemRef.current?.dataset["ds-Level"];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else {
                if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" && event_0.shiftKey || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
                    itemRef.current?.focus();
                });
                else if (triggerRef.current) {
                    const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.("[role=\"menu\"]") === null;
                    const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body;
                    if (!shouldPreventFocus) requestAnimationFrame(()=>{
                        triggerRef.current?.focus();
                    });
                }
            }
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: event_0
            });
        };
        $[11] = itemRef;
        $[12] = onOpenChange;
        $[13] = returnFocusRef;
        $[14] = setLocalIsOpen;
        $[15] = shouldPreventEscapePropagation;
        $[16] = t15;
    } else t15 = $[16];
    const handleOnClose = t15;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    let t16;
    let t17;
    if ($[17] !== handleOnClose || $[18] !== handleTriggerClicked || $[19] !== isFocused || $[20] !== isLocalOpen) {
        t16 = ()=>{
            if (!isFocused) return 0, $dpsRj.default;
            if (isLocalOpen) return 0, $dpsRj.default;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`);
                    if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else {
                        if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                        else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) handleOnClose(e);
                    }
                }
            });
        };
        t17 = [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ];
        $[17] = handleOnClose;
        $[18] = handleTriggerClicked;
        $[19] = isFocused;
        $[20] = isLocalOpen;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[23] !== shouldFitContainer || $[24] !== shouldRenderToParent || $[25] !== strategy) {
        t18 = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== "fixed" ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        $[23] = shouldFitContainer;
        $[24] = shouldRenderToParent;
        $[25] = strategy;
        $[26] = t18;
    } else t18 = $[26];
    const conditionalProps = t18;
    const t19 = isLocalOpen ? id : undefined;
    const t20 = returnFocusRef === undefined;
    const t21 = shouldRenderToParent && currentLevel > 0 ? "group" : undefined;
    const t22 = testId && `${testId}--content`;
    let t23;
    if ($[27] !== bindFocus || $[28] !== handleTriggerClicked || $[29] !== interactionName || $[30] !== isLocalOpen || $[31] !== itemRef || $[32] !== label || $[33] !== testId || $[34] !== trigger) {
        t23 = (t24)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, ...rest } = t24;
            if (typeof trigger === "function") return trigger({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: $53393d8413cfd6c9$var$_temp,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        };
        $[27] = bindFocus;
        $[28] = handleTriggerClicked;
        $[29] = interactionName;
        $[30] = isLocalOpen;
        $[31] = itemRef;
        $[32] = label;
        $[33] = testId;
        $[34] = trigger;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== autoFocus || $[37] !== children || $[38] !== handleOnClose || $[39] !== isLoading || $[40] !== isTriggeredUsingKeyboard || $[41] !== menuLabel || $[42] !== shouldFitContainer || $[43] !== shouldRenderToParent || $[44] !== spacing || $[45] !== statusLabel || $[46] !== testId) {
        t24 = (t25)=>{
            const { setInitialFocusRef: setInitialFocusRef, update: update } = t25;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iv7mf.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94Dr9.default), {
                spacing: spacing,
                maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children));
        };
        $[36] = autoFocus;
        $[37] = children;
        $[38] = handleOnClose;
        $[39] = isLoading;
        $[40] = isTriggeredUsingKeyboard;
        $[41] = menuLabel;
        $[42] = shouldFitContainer;
        $[43] = shouldRenderToParent;
        $[44] = spacing;
        $[45] = statusLabel;
        $[46] = testId;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== conditionalProps || $[49] !== fallbackPlacements || $[50] !== handleOnClose || $[51] !== isLocalOpen || $[52] !== placement || $[53] !== shouldFlip || $[54] !== shouldIgnoreCloseEvent || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== zIndex) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ggC1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            id: t19,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: t20,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: t21,
            fallbackPlacements: fallbackPlacements,
            testId: t22,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: t23,
            content: t24
        }));
        $[48] = conditionalProps;
        $[49] = fallbackPlacements;
        $[50] = handleOnClose;
        $[51] = isLocalOpen;
        $[52] = placement;
        $[53] = shouldFlip;
        $[54] = shouldIgnoreCloseEvent;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
        $[61] = zIndex;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
} : function DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $jp2Q3.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    const fallbackPlacements = (0, $cozmU.useMemo)(()=>$53393d8413cfd6c9$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $cozmU.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((event_0, currentLevel_0)=>{
        const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
        if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel_0) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' && event_0.shiftKey || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue_0 = false;
        setLocalIsOpen(newValue_0);
        onOpenChange({
            isOpen: newValue_0,
            event: event_0
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $cozmU.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dpsRj.default;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ggC1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iv7mf.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94Dr9.default), {
                spacing: spacing,
                maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children))
    }));
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ function $53393d8413cfd6c9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
const $53393d8413cfd6c9$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { autoFocus: t0, children: children, defaultOpen: t1, isLoading: t2, isOpen: isOpen, onOpenChange: t3, placement: t4, shouldFitContainer: t5, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    const autoFocus = t0 === undefined ? false : t0;
    const defaultOpen = t1 === undefined ? false : t1;
    const isLoading = t2 === undefined ? false : t2;
    const onOpenChange = t3 === undefined ? (0, $dpsRj.default) : t3;
    const placement = t4 === undefined ? "bottom-start" : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    if ((0, $iDrrr.fg)("platform-dst-top-layer")) {
        let t6;
        if ($[0] !== autoFocus || $[1] !== children || $[2] !== defaultOpen || $[3] !== interactionName || $[4] !== isLoading || $[5] !== isOpen || $[6] !== label || $[7] !== menuLabel || $[8] !== onOpenChange || $[9] !== placement || $[10] !== returnFocusRef || $[11] !== shouldFitContainer || $[12] !== spacing || $[13] !== statusLabel || $[14] !== testId || $[15] !== trigger) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJVM.default), {
                autoFocus: autoFocus,
                children: children,
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: placement,
                shouldFitContainer: shouldFitContainer,
                returnFocusRef: returnFocusRef,
                spacing: spacing,
                statusLabel: statusLabel,
                testId: testId,
                trigger: trigger,
                label: label,
                interactionName: interactionName,
                menuLabel: menuLabel
            });
            $[0] = autoFocus;
            $[1] = children;
            $[2] = defaultOpen;
            $[3] = interactionName;
            $[4] = isLoading;
            $[5] = isOpen;
            $[6] = label;
            $[7] = menuLabel;
            $[8] = onOpenChange;
            $[9] = placement;
            $[10] = returnFocusRef;
            $[11] = shouldFitContainer;
            $[12] = spacing;
            $[13] = statusLabel;
            $[14] = testId;
            $[15] = trigger;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    let t6;
    if ($[17] !== props) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53393d8413cfd6c9$var$DropdownMenuLegacy, props);
        $[17] = props;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJVM.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53393d8413cfd6c9$var$DropdownMenuLegacy, props);
};
var $53393d8413cfd6c9$export$2e2bcd8739ae039 = $53393d8413cfd6c9$var$DropdownMenu;
module.exports["default"] = $53393d8413cfd6c9$export$2e2bcd8739ae039;

});

parcelRegister("5Dlqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a527e5bb9222c5e$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4a527e5bb9222c5e$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $cozmU.useState)(getDefaultPropValue);
    const isControlledRef = (0, $cozmU.useRef)(isControlled);
    (0, $cozmU.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $cozmU.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("eLJVM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $6IL1T = parcelRequire("6IL1T");


var $lfoFx = parcelRequire("lfoFx");


var $3hJ5V = parcelRequire("3hJ5V");


var $lBMxH = parcelRequire("lBMxH");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $97Yf0 = parcelRequire("97Yf0");


var $fb8lP = parcelRequire("fb8lP");

var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $hPK4E = parcelRequire("hPK4E");


var $ggC1G = parcelRequire("ggC1G");

const $f516bc94b8de2bc9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $f516bc94b8de2bc9$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W",
    menuContent: "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v"
}; /**
    * Event types produced by trigger interactions.
    *
    * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
    * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
    * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
    */ 
function $f516bc94b8de2bc9$var$isKeyboardTriggered(event) {
    if (event.type === 'keydown') return true;
    if ('clientX' in event && (event.clientX === 0 || event.clientY === 0)) return true;
    if (event.detail === 0) return true;
    return false;
} /**
   * Loading indicator for the dropdown menu.
   */ 
const $f516bc94b8de2bc9$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingIndicator(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== statusLabel || $[2] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "menuitem",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
        $[1] = statusLabel;
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "menuitem",
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $f516bc94b8de2bc9$var$DropdownMenuTopLayer({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const menuRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const popoverId = (0, $1unCm.usePopoverId)();
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $hPK4E.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: _reason })=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const newValue = !isLocalOpen;
        setTriggeredUsingKeyboard($f516bc94b8de2bc9$var$isKeyboardTriggered(event));
        setLocalIsOpen(newValue); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: newValue,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $cozmU.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return 0, $dpsRj.default;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = triggerRef.current?.closest('[role="menu"]') != null;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]); // Arrow navigation.
    // useArrowNavigation handles ArrowUp/Down, Home/End, and Tab-to-close
    // by querying focusable elements in the menu DOM container.
    const handleArrowClose = (0, $cozmU.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    const handleNestedOpen = (0, $cozmU.useCallback)(({ trigger: trigger_0 })=>{
        trigger_0.click();
    }, []);
    const handleNestedClose = (0, $cozmU.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    (0, $iNWdN.useArrowNavigation)({
        containerRef: menuRef,
        onClose: handleArrowClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleNestedClose,
        isEnabled: isLocalOpen,
        filter: (0, $fb8lP.isAtCurrentMenuLevel)
    }); // Auto-focus first item on open.
    (0, $cozmU.useEffect)(()=>{
        if (!isLocalOpen || !isTriggeredUsingKeyboard && !autoFocus) return;
        requestAnimationFrame(()=>{
            const menu = menuRef.current;
            if (!menu) return;
            const firstItem = (0, $3hJ5V.getFirstFocusable)({
                container: menu
            });
            firstItem?.focus();
        });
    }, [
        isLocalOpen,
        isTriggeredUsingKeyboard,
        autoFocus
    ]); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $cozmU.useCallback)((e_0)=>{
        const target = e_0.target;
        const menuItem = target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger_0 = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger_0) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e_0.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $lBMxH.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes;
    const renderTrigger = ()=>{
        const setRef = (node)=>{
            triggerRef.current = node;
        };
        const combinedRef = (0, $lmzCg.default)([
            setRef
        ]);
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            ...bindFocus,
            triggerRef: combinedRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            ...bindFocus,
            ref: combinedRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName
        }, trigger);
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $ggC1G.default), null, renderTrigger(), /*#__PURE__*/ $cozmU.createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && `${testId}--content`
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        ref: menuRef,
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.menuContent
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: $f516bc94b8de2bc9$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-wrapper--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $cozmU.createElement($f516bc94b8de2bc9$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--menu-wrapper--loading-indicator`
    }) : children))));
}
var $f516bc94b8de2bc9$export$2e2bcd8739ae039 = $f516bc94b8de2bc9$var$DropdownMenuTopLayer;
module.exports["default"] = $f516bc94b8de2bc9$export$2e2bcd8739ae039;

});

parcelRegister("fb8lP", function(module, exports) {
const $6bfdddcadf7826ef$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $6bfdddcadf7826ef$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($6bfdddcadf7826ef$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}
module.exports["isAtCurrentMenuLevel"] = $6bfdddcadf7826ef$export$f1bba0ef464d60af;

});

parcelRegister("ggC1G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $885bea270958798f$var$SelectionStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const store = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>store.current[group_2] || {}
        };
        $[1] = t1;
    } else t1 = $[1];
    const context = t1;
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOWpM.SelectionStoreContext).Provider, {
            value: context
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children } = props;
    const store = (0, $cozmU.useRef)({});
    const context = (0, $cozmU.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return undefined;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>{
                return store.current[group_2] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOWpM.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $885bea270958798f$export$2e2bcd8739ae039 = $885bea270958798f$var$SelectionStore;
module.exports["default"] = $885bea270958798f$export$2e2bcd8739ae039;

});

parcelRegister("lOWpM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $db8a5bf4c7b230f3$export$756f795847463ebd = /*#__PURE__*/ (0, $cozmU.createContext)({
    setItemState: (0, $dpsRj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $dpsRj.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $db8a5bf4c7b230f3$export$756f795847463ebd;

});

parcelRegister("iv7mf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $4CEP6 = parcelRequire("4CEP6");


var $2Bag3 = parcelRequire("2Bag3");


var $6nHMa = parcelRequire("6nHMa");

/**
 * Focus manager logic.
 */ const $f5a399746fdfd30b$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $cozmU.useState)(0);
    const registerMode = (0, $cozmU.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $cozmU.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $cozmU.useEffect)(()=>(0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $2Bag3.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6nHMa.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $f5a399746fdfd30b$export$2e2bcd8739ae039 = $f5a399746fdfd30b$var$FocusManager;
module.exports["default"] = $f5a399746fdfd30b$export$2e2bcd8739ae039;

});

parcelRegister("2Bag3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ec80e24a5f4b9$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");


var $iDrrr = parcelRequire("iDrrr");


var $eEek6 = parcelRequire("eEek6");

const $b55ec80e24a5f4b9$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $b55ec80e24a5f4b9$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $iDrrr.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $eEek6.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $fM984.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $fM984.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $b55ec80e24a5f4b9$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eEek6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $bcf8a6c8e532b2af$export$8a682ae47622dbb9 = 'ds--dropdown--';
/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */ const $bcf8a6c8e532b2af$var$useGeneratedId = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
} : function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
};
var $bcf8a6c8e532b2af$export$2e2bcd8739ae039 = $bcf8a6c8e532b2af$var$useGeneratedId;
module.exports["PREFIX"] = $bcf8a6c8e532b2af$export$8a682ae47622dbb9;
module.exports["default"] = $bcf8a6c8e532b2af$export$2e2bcd8739ae039;

});

parcelRegister("6nHMa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $f526bd1b7b92569a$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $f526bd1b7b92569a$export$f18c1d4fc7326096;

});

parcelRegister("94Dr9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $gsYt4 = parcelRequire("gsYt4");


var $2zAfh = parcelRequire("2zAfh");


var $6nHMa = parcelRequire("6nHMa");

const $9c09f45d8ede8a3c$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $9c09f45d8ede8a3c$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] !== statusLabel || $[1] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
            role: "menuitem"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
        $[0] = statusLabel;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    })); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $9c09f45d8ede8a3c$var$MenuWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel } = t0;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    let t1;
    if ($[0] !== menuItemRefs || $[1] !== onClose) {
        t1 = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        $[0] = menuItemRefs;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const closeOnMenuItemClick = t1;
    let t2;
    if ($[3] !== onUpdate) {
        t2 = ()=>{
            onUpdate();
        };
        $[3] = onUpdate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isLoading || $[6] !== onUpdate) {
        t3 = [
            isLoading,
            onUpdate
        ];
        $[5] = isLoading;
        $[6] = onUpdate;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== autoFocus || $[9] !== isTriggeredUsingKeyboard || $[10] !== menuItemRefs || $[11] !== setInitialFocusRef || $[12] !== shouldRenderToParent) {
        t4 = ()=>{
            const firstFocusableRef = menuItemRefs.map($9c09f45d8ede8a3c$var$_temp).find($9c09f45d8ede8a3c$var$_temp2) ?? null;
            if (((0, $iDrrr.fg)("platform_dst_menu_item_focus") || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        };
        t5 = [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ];
        $[8] = autoFocus;
        $[9] = isTriggeredUsingKeyboard;
        $[10] = menuItemRefs;
        $[11] = setInitialFocusRef;
        $[12] = shouldRenderToParent;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = testId && `${testId}--menu-group`;
    let t7;
    if ($[15] !== children || $[16] !== isLoading || $[17] !== statusLabel || $[18] !== testId) {
        t7 = isLoading ? /*#__PURE__*/ $cozmU.createElement($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children;
        $[15] = children;
        $[16] = isLoading;
        $[17] = statusLabel;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== closeOnMenuItemClick || $[21] !== isLoading || $[22] !== maxHeight || $[23] !== maxWidth || $[24] !== menuLabel || $[25] !== spacing || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: t6,
            menuLabel: menuLabel
        }, t7);
        $[20] = closeOnMenuItemClick;
        $[21] = isLoading;
        $[22] = maxHeight;
        $[23] = maxWidth;
        $[24] = menuLabel;
        $[25] = spacing;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $cozmU.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $iDrrr.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $cozmU.createElement($9c09f45d8ede8a3c$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $9c09f45d8ede8a3c$export$2e2bcd8739ae039 = $9c09f45d8ede8a3c$var$MenuWrapper;
function $9c09f45d8ede8a3c$var$_temp(t0) {
    const { current: current } = t0;
    return current;
}
function $9c09f45d8ede8a3c$var$_temp2(el) {
    return !!el && !el.hasAttribute("disabled");
}
module.exports["default"] = $9c09f45d8ede8a3c$export$2e2bcd8739ae039;

});

parcelRegister("gsYt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $363009d7887a30e5$export$2e2bcd8739ae039);
function $363009d7887a30e5$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("2zAfh", function(module, exports) {
$parcel$export(module.exports, "default", () => $364a1a3a4c98073c$export$2e2bcd8739ae039);
function $364a1a3a4c98073c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("imIsb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $6nHMa = parcelRequire("6nHMa");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
const $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager(t0) {
    const $ = (0, $bDgLe.c)(4);
    const hasPopup = t0 === undefined ? false : t0;
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== hasPopup || $[1] !== registerRef) {
        t1 = ()=>{
            if (hasPopup && (0, $iDrrr.fg)("select-avoid-duplicated-registered-ref")) return;
            registerRef(itemRef);
        };
        t2 = [
            registerRef,
            hasPopup
        ];
        $[0] = hasPopup;
        $[1] = registerRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return itemRef;
} : function useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (hasPopup && (0, $iDrrr.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
};
var $ab7ed338ade85dc7$export$2e2bcd8739ae039 = $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager;
module.exports["default"] = $ab7ed338ade85dc7$export$2e2bcd8739ae039;

});

parcelRegister("is1T6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $imIsb = parcelRequire("imIsb");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $94fa0e4252415620$var$DropdownMenuItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $imIsb.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $cozmU.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kD4eB.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
});
var $94fa0e4252415620$export$2e2bcd8739ae039 = $94fa0e4252415620$var$DropdownMenuItem;
module.exports["default"] = $94fa0e4252415620$export$2e2bcd8739ae039;

});

parcelRegister("9erVg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $e544827bc46159a5$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== ref || $[18] !== rest || $[19] !== t1 || $[20] !== t2 || $[21] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = ref;
        $[18] = rest;
        $[19] = t1;
        $[20] = t2;
        $[21] = testId;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
} : ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
        id: titleId,
        title: title
    }), children);
});
var $e544827bc46159a5$export$2e2bcd8739ae039 = $e544827bc46159a5$var$DropdownMenuItemGroup;
module.exports["default"] = $e544827bc46159a5$export$2e2bcd8739ae039;

});

parcelRegister("eiIYc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c2ad6d0f9690e679$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $c2ad6d0f9690e679$var$GroupTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { id: id, title: title } = t0;
    let t1;
    if ($[0] !== id || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $c2ad6d0f9690e679$var$styles.heading
        }, title);
        $[0] = id;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c2ad6d0f9690e679$var$styles.heading
    }, title);
var $c2ad6d0f9690e679$export$2e2bcd8739ae039 = $c2ad6d0f9690e679$var$GroupTitle;
module.exports["default"] = $c2ad6d0f9690e679$export$2e2bcd8739ae039;

});

parcelRegister("6gGPb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ekCm6 = parcelRequire("ekCm6");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $a2bT0 = parcelRequire("a2bT0");


var $iH3wh = parcelRequire("iH3wh");

const $2433037a0219ceb9$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $2433037a0219ceb9$var$styles = {
    agentAvatar: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _1uo2ZfTcEg",
    image: "_00EA0eiObl _0jFU0VN91d _39xV02N91d",
    avatarContentContainer: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
};
const $2433037a0219ceb9$var$stylesCompiled = {
    innerShape: "_0jFU0VwOVE _39xV02wOVE _1uo2ZfTcEg"
};
const $2433037a0219ceb9$export$38b71b080e1832c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { imageUrl: imageUrl, size: t1, label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: t2, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const showBorder = t2 === undefined ? true : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    const t3 = (0, $ekCm6.AVATAR_SIZES)[size];
    const t4 = (0, $ekCm6.AVATAR_SIZES)[size];
    let t5;
    if ($[0] !== showBorder) {
        t5 = showBorder ? {
            backgroundColor: "#fff"
        } : {};
        $[0] = showBorder;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== size) {
        t6 = (0, $iDrrr.fg)("rovo_chat_bugfix_agent_avatar_squish") ? {
            minHeight: (0, $ekCm6.AVATAR_SIZES)[size],
            minWidth: (0, $ekCm6.AVATAR_SIZES)[size]
        } : {};
        $[2] = size;
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
        t7 = {
            height: t3,
            width: t4,
            ...t5,
            ...t6
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            $2433037a0219ceb9$var$stylesCompiled.innerShape
        ]);
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== agentId || $[11] !== agentIdentityAccountId || $[12] !== agentNamedId || $[13] !== formatMessage || $[14] !== imgUrl || $[15] !== isRovoDev || $[16] !== label || $[17] !== name || $[18] !== size) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t8
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2433037a0219ceb9$var$styles.avatarContentContainer
        }, imgUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "img",
            xcss: $2433037a0219ceb9$var$styles.image,
            src: imgUrl,
            alt: name || label || formatMessage((0, $iH3wh.messages).agentAvatarLabel)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $a2bT0.GeneratedAvatar), {
            agentId: agentId,
            agentNamedId: agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            isRovoDev: isRovoDev,
            size: size
        })));
        $[10] = agentId;
        $[11] = agentIdentityAccountId;
        $[12] = agentNamedId;
        $[13] = formatMessage;
        $[14] = imgUrl;
        $[15] = isRovoDev;
        $[16] = label;
        $[17] = name;
        $[18] = size;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== label || $[21] !== t7 || $[22] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            "aria-label": label,
            xcss: $2433037a0219ceb9$var$styles.agentAvatar,
            style: t7
        }, t9);
        $[20] = label;
        $[21] = t7;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
} : ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "aria-label": label,
        xcss: $2433037a0219ceb9$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $iDrrr.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $ekCm6.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $ekCm6.AVATAR_SIZES)[size]
            } : {}
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2433037a0219ceb9$var$stylesCompiled.innerShape
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2433037a0219ceb9$var$styles.avatarContentContainer
    }, imgUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "img",
        xcss: $2433037a0219ceb9$var$styles.image,
        src: imgUrl,
        alt: name || label || formatMessage((0, $iH3wh.messages).agentAvatarLabel)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $a2bT0.GeneratedAvatar), {
        agentId: agentId,
        agentNamedId: agentNamedId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: size
    }))));
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $2433037a0219ceb9$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $2433037a0219ceb9$export$38b71b080e1832c8;

});

parcelRegister("iH3wh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a5c48f60363d438d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $a5c48f60363d438d$export$defe85febe8b728c;

});

parcelRegister("kRZje", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3d1980cd1cd1dd3802bb83bdef4aaecc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f318509c1cb5014a$var$_react = $f318509c1cb5014a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f318509c1cb5014a$var$_baseNew = $f318509c1cb5014a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f318509c1cb5014a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/task-to-do
 * Usage guidance:
 * Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f318509c1cb5014a$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $f318509c1cb5014a$var$_react.default.createElement($f318509c1cb5014a$var$_baseNew.default, Object.assign({
        name: "TaskToDoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$f318509c1cb5014a$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $f318509c1cb5014a$var$_default = module.exports.default = $f318509c1cb5014a$var$TaskToDoIcon;

});

parcelRegister("6wOvs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4aRua = parcelRequire("4aRua");

const $b90e25146b4dbd96$var$shimmerAnimation = null;
const $b90e25146b4dbd96$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $b90e25146b4dbd96$var$truncateSingleLine = null;
const $b90e25146b4dbd96$export$f35c7d979dec8662 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, size: t1, weight: t2, truncate: t3 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const weight = t2 === undefined ? "regular" : t2;
    const truncate = t3 === undefined ? false : t3;
    const t4 = truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d";
    let t5;
    if ($[0] !== t4) {
        t5 = (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            t4
        ]);
        $[0] = t4;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== children || $[3] !== size || $[4] !== weight) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: size,
            weight: weight,
            color: "color.text.subtlest"
        }, children);
        $[2] = children;
        $[3] = size;
        $[4] = weight;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t5 || $[7] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, t6);
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
} : ({ children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: size,
        weight: weight,
        color: "color.text.subtlest"
    }, children));
};
module.exports["ShimmerText"] = $b90e25146b4dbd96$export$f35c7d979dec8662;

});

parcelRegister("ds2zu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45f4d253357e101ffa297ef9c3637fd5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cafe280d0f1b4b2$var$_react = $9cafe280d0f1b4b2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9cafe280d0f1b4b2$var$_baseNew = $9cafe280d0f1b4b2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9cafe280d0f1b4b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pages
 * Usage guidance:
 * Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cafe280d0f1b4b2$var$PagesIcon = (props)=>/*#__PURE__*/ $9cafe280d0f1b4b2$var$_react.default.createElement($9cafe280d0f1b4b2$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$9cafe280d0f1b4b2$var$PagesIcon.displayName = 'PagesIcon';
var $9cafe280d0f1b4b2$var$_default = module.exports.default = $9cafe280d0f1b4b2$var$PagesIcon;

});

parcelRegister("9dT53", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5SS4O = parcelRequire("5SS4O");


var $12shJ = parcelRequire("12shJ");

const $504c8ca0288f237c$export$87a67f0fae3238d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { cloudId: cloudId, product: product, experienceId: experienceId, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    const { fetchSpaces: fetchSpaces } = (0, $12shJ.useSpaceStoreActions)();
    const spaces = (0, $12shJ.useSpaces)();
    const isLoading = (0, $12shJ.useSpacesLoading)();
    const error = (0, $12shJ.useSpacesError)();
    const hasFetched = (0, $12shJ.useHasFetchedSpaces)();
    const conversationIds = (0, $12shJ.useSpaceConversationIds)();
    let t2;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product) {
        t2 = [
            "rovo-spaces:listSpaces",
            cloudId,
            product,
            experienceId
        ];
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== cloudId || $[5] !== experienceId || $[6] !== fetchSpaces || $[7] !== product) {
        t3 = ()=>fetchSpaces({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                force: true
            });
        $[4] = cloudId;
        $[5] = experienceId;
        $[6] = fetchSpaces;
        $[7] = product;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = !skip;
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = {
            queryKey: t2,
            queryFn: t3,
            enabled: t4
        };
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const { refetch: refetchQuery } = (0, $5SS4O.useQuery)(t5);
    let t6;
    if ($[13] !== refetchQuery) {
        t6 = async ()=>{
            await refetchQuery();
        };
        $[13] = refetchQuery;
        $[14] = t6;
    } else t6 = $[14];
    const refetch = t6;
    let t7;
    if ($[15] !== conversationIds || $[16] !== error || $[17] !== hasFetched || $[18] !== isLoading || $[19] !== refetch || $[20] !== spaces) {
        t7 = {
            spaces: spaces,
            isLoading: isLoading,
            error: error,
            hasFetched: hasFetched,
            conversationIds: conversationIds,
            refetch: refetch
        };
        $[15] = conversationIds;
        $[16] = error;
        $[17] = hasFetched;
        $[18] = isLoading;
        $[19] = refetch;
        $[20] = spaces;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
} : ({ cloudId: cloudId, product: product, experienceId: experienceId, skip: skip = false })=>{
    const { fetchSpaces: fetchSpaces } = (0, $12shJ.useSpaceStoreActions)();
    const spaces = (0, $12shJ.useSpaces)();
    const isLoading = (0, $12shJ.useSpacesLoading)();
    const error = (0, $12shJ.useSpacesError)();
    const hasFetched = (0, $12shJ.useHasFetchedSpaces)();
    const conversationIds = (0, $12shJ.useSpaceConversationIds)();
    // `queryFn` returns `undefined` because the canonical state lives in the
    // sweet-state store; `useQuery`'s own cache is only used to drive the
    // fetch lifecycle (mount-trigger, key-change). The store receives the
    // actual response via `setSpaces` inside `fetchSpaces`.
    //
    // We pass `force: true` so the store's own `hasFetchedList` short-circuit
    // never causes the fetch to no-op — `useQuery` already owns the
    // dedupe-by-key behaviour (it only invokes `queryFn` once per key per
    // mount), so the store's separate caching layer is redundant here and
    // can otherwise hide a needed refetch on `queryKey` change.
    const { refetch: refetchQuery } = (0, $5SS4O.useQuery)({
        queryKey: [
            'rovo-spaces:listSpaces',
            cloudId,
            product,
            experienceId
        ],
        queryFn: ()=>fetchSpaces({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId,
                force: true
            }),
        enabled: !skip
    });
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        await refetchQuery();
    }, [
        refetchQuery
    ]);
    return (0, $cozmU.useMemo)(()=>({
            spaces: spaces,
            isLoading: isLoading,
            error: error,
            hasFetched: hasFetched,
            conversationIds: conversationIds,
            refetch: refetch
        }), [
        spaces,
        isLoading,
        error,
        hasFetched,
        conversationIds,
        refetch
    ]);
};
module.exports["useListSpaces"] = $504c8ca0288f237c$export$87a67f0fae3238d8;

});

parcelRegister("7TSZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::764927d76e708b8e7cb2d16ad06509f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c0854b62cd146af$var$_react = $5c0854b62cd146af$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5c0854b62cd146af$var$_baseNew = $5c0854b62cd146af$var$_interopRequireDefault((parcelRequire("gElAV")));
function $5c0854b62cd146af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DeviceMobile".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/device-mobile
 * Usage guidance:
 * Multi purpose - Known uses: call, contact us.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c0854b62cd146af$var$DeviceMobileIcon = (props)=>/*#__PURE__*/ $5c0854b62cd146af$var$_react.default.createElement($5c0854b62cd146af$var$_baseNew.default, Object.assign({
        name: "DeviceMobileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2zm2-.5A.5.5 0 0 0 4 2v12a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5zM10 13H6v-1.5h4z" clip-rule="evenodd"/>`
    }, props));
$5c0854b62cd146af$var$DeviceMobileIcon.displayName = 'DeviceMobileIcon';
var $5c0854b62cd146af$var$_default = module.exports.default = $5c0854b62cd146af$var$DeviceMobileIcon;

});

parcelRegister("47bbw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be9b0431d8ae5c7ded7b7501724b0f1f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff07df1fd0794ca$var$_react = $2ff07df1fd0794ca$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2ff07df1fd0794ca$var$_baseNew = $2ff07df1fd0794ca$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2ff07df1fd0794ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/browser-extension
 * Usage guidance:
 * Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ff07df1fd0794ca$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $2ff07df1fd0794ca$var$_react.default.createElement($2ff07df1fd0794ca$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$2ff07df1fd0794ca$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $2ff07df1fd0794ca$var$_default = module.exports.default = $2ff07df1fd0794ca$var$BrowserExtensionIcon;

});

parcelRegister("iRqYE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be258611bd1f9388921e0735764086cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb21a5762820d00$var$_react = $dbb21a5762820d00$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dbb21a5762820d00$var$_baseNew = $dbb21a5762820d00$var$_interopRequireDefault((parcelRequire("gElAV")));
function $dbb21a5762820d00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Terminal".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/terminal
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb21a5762820d00$var$TerminalIcon = (props)=>/*#__PURE__*/ $dbb21a5762820d00$var$_react.default.createElement($dbb21a5762820d00$var$_baseNew.default, Object.assign({
        name: "TerminalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.4-.49L14 2.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 3z"/><path fill="currentcolor" d="m4.28 4.72 2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L5.44 8 3.22 5.78zM12.5 9.5V11H8V9.5z"/>`
    }, props));
$dbb21a5762820d00$var$TerminalIcon.displayName = 'TerminalIcon';
var $dbb21a5762820d00$var$_default = module.exports.default = $dbb21a5762820d00$var$TerminalIcon;

});

parcelRegister("1Rgab", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

const $76b6b5acc34c76dc$var$styles = {
    menuPopupContainer: "_0bjKvDyzSk _30huDKOeNX _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
    contentBoxTransition: "_23rrnHuOLi"
};
const $76b6b5acc34c76dc$var$PopupComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ...props,
            ref: ref,
            xcss: $76b6b5acc34c76dc$var$styles.menuPopupContainer,
            "data-testid": undefined
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ...props,
        ref: ref,
        xcss: $76b6b5acc34c76dc$var$styles.menuPopupContainer,
        "data-testid": undefined
    }));
const $76b6b5acc34c76dc$export$14a83f9f0297469c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { testId: testId, sections: sections, isOpen: isOpen, onClose: onClose, trigger: trigger, placement: placement, width: width, maxWidth: maxWidth, zIndex: t1, content: content, popoverAutoFocus: popoverAutoFocus, shouldRenderToParent: shouldRenderToParent } = t0;
    const zIndex = t1 === undefined ? 600 : t1;
    if (!sections) return null;
    let t2;
    if ($[0] !== maxWidth || $[1] !== width) {
        t2 = {
            width: width,
            maxWidth: maxWidth
        };
        $[0] = maxWidth;
        $[1] = width;
        $[2] = t2;
    } else t2 = $[2];
    const boxStyle = t2;
    let t3;
    if ($[3] !== boxStyle || $[4] !== content) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $76b6b5acc34c76dc$var$styles.contentBoxTransition,
                style: boxStyle
            }, content);
        $[3] = boxStyle;
        $[4] = content;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isOpen || $[7] !== onClose || $[8] !== placement || $[9] !== popoverAutoFocus || $[10] !== shouldRenderToParent || $[11] !== t3 || $[12] !== testId || $[13] !== trigger || $[14] !== zIndex) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: placement,
            trigger: trigger,
            popupComponent: $76b6b5acc34c76dc$var$PopupComponent,
            zIndex: zIndex,
            autoFocus: popoverAutoFocus,
            shouldRenderToParent: shouldRenderToParent,
            testId: testId,
            content: t3
        });
        $[6] = isOpen;
        $[7] = onClose;
        $[8] = placement;
        $[9] = popoverAutoFocus;
        $[10] = shouldRenderToParent;
        $[11] = t3;
        $[12] = testId;
        $[13] = trigger;
        $[14] = zIndex;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : ({ testId: testId, sections: sections, isOpen: isOpen, onClose: onClose, trigger: trigger, placement: placement, width: width, maxWidth: maxWidth, zIndex: zIndex = 600, content: content, popoverAutoFocus: popoverAutoFocus, shouldRenderToParent: shouldRenderToParent })=>{
    if (!sections) return null;
    const boxStyle = {
        width: width,
        maxWidth: maxWidth
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement,
        trigger: trigger,
        popupComponent: $76b6b5acc34c76dc$var$PopupComponent,
        zIndex: zIndex,
        autoFocus: popoverAutoFocus,
        shouldRenderToParent: shouldRenderToParent,
        testId: testId,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $76b6b5acc34c76dc$var$styles.contentBoxTransition,
                style: boxStyle
            }, content)
    });
};
module.exports["ChatHeaderMenu"] = $76b6b5acc34c76dc$export$14a83f9f0297469c;

});

parcelRegister("jW2nL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $af2Fp = parcelRequire("af2Fp");

const $cce3bab77c56367c$var$styles = {
    menuContainer: "_2mHwu8FQfX _39xV02N91d _3iDTPbccYA _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0aFT5vbt8w _0hPCNLDIqT _0KLXrulfZc",
    menuTextContainer: "_2mHwu88HPE _3iDTPbQ4SZ _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0hPCNLDIqT _4xdlr0FlnN",
    menuText: "_2sNsIgd8bj _1UtDYzKGUX"
};
const $cce3bab77c56367c$export$e3c8d6f66737f40c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { sections: sections } = t0;
    let t1;
    if ($[0] !== sections) {
        let t2;
        if ($[2] !== sections.length) {
            t2 = (section, sectionIndex)=>section.items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: sectionIndex
                }, section.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $cce3bab77c56367c$var$styles.menuTextContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    role: "heading",
                    "aria-level": 2,
                    xcss: $cce3bab77c56367c$var$styles.menuText
                }, section.title)), section.items, sectionIndex !== sections.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2Fp.Divider), {
                    isThin: true,
                    withMargin: true
                }));
            $[2] = sections.length;
            $[3] = t2;
        } else t2 = $[3];
        t1 = sections.map(t2);
        $[0] = sections;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cce3bab77c56367c$var$styles.menuContainer
        }, t1);
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ sections: sections })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cce3bab77c56367c$var$styles.menuContainer
    }, sections.map((section, sectionIndex)=>section.items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: sectionIndex
        }, section.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cce3bab77c56367c$var$styles.menuTextContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "heading",
            "aria-level": 2,
            xcss: $cce3bab77c56367c$var$styles.menuText
        }, section.title)), section.items, sectionIndex !== sections.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2Fp.Divider), {
            isThin: true,
            withMargin: true
        }))));
module.exports["ChatHeaderMenuList"] = $cce3bab77c56367c$export$e3c8d6f66737f40c;

});

parcelRegister("af2Fp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $25b936668dcad52b$var$styles = {
    divider: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d",
    thinDivider: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    dividerMargin: "_3138422ADO _1DCdHi2ADO"
};
const $25b936668dcad52b$export$2e0a83ec2e27ecbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { isThin: t1, withMargin: t2 } = t0;
    const isThin = t1 === undefined ? false : t1;
    const withMargin = t2 === undefined ? false : t2;
    const t3 = !isThin ? $25b936668dcad52b$var$styles.divider : $25b936668dcad52b$var$styles.thinDivider;
    const t4 = withMargin && $25b936668dcad52b$var$styles.dividerMargin;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = (0, $w6R6I.cx)(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t5,
            backgroundColor: "color.background.neutral.subtle",
            role: "separator"
        });
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    return t6;
} : ({ isThin: isThin = false, withMargin: withMargin = false })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!isThin ? $25b936668dcad52b$var$styles.divider : $25b936668dcad52b$var$styles.thinDivider, withMargin && $25b936668dcad52b$var$styles.dividerMargin),
        backgroundColor: "color.background.neutral.subtle",
        role: "separator"
    });
};
module.exports["Divider"] = $25b936668dcad52b$export$2e0a83ec2e27ecbb;

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ $cozmU.createElement("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ $cozmU.createElement((0, $cAK2R.default), null, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $kbRVk.default), null));
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss
        }, t16, t17, t18);
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $cozmU.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $cozmU.createElement((0, $8c6io.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $cozmU.createElement((0, $cAK2R.default), null, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $kbRVk.default), null)));
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $hekY6.default)([
                $ef6550583d45a5c6$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement("g", {
            fillRule: "evenodd"
        }, t3, icon));
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.rect
        ])
    }), icon));
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $cozmU.createElement("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id
        }, children);
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $cozmU.createElement("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ])
    }, children);
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ])
    }, "*");
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("87k0g", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $aRvnq = parcelRequire("aRvnq");


var $eh6Ml = parcelRequire("eh6Ml");


var $V3JOP = parcelRequire("V3JOP");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $fWd0x = parcelRequire("fWd0x");


var $lpNn5 = parcelRequire("lpNn5");


var $4XF4G = parcelRequire("4XF4G");


var $dftWP = parcelRequire("dftWP");


var $bJ1N3 = parcelRequire("bJ1N3");

const $c1f98b070c09a977$var$styles = {
    menuItem: "_2mHwu8gVvo _0bjKvDKTcp _39xV02N91d _3iDTPbQ4SZ _0aFT5v1qpb _4kiQYAUofl _37wbyuI7V3 _0hPCNLDIqT _0wOv4Q7zJH _0KLXru66of _3gzVzLN4oS",
    menuItemActive: "_0KLXruY9q9 _1UtDYzjTy9",
    menuItemHover: "_1eOmH6o126",
    menuItemFocused: "_0KLXruo126",
    menuItemDisabled: "_0wOv4Qsyl5 _1UtDYzot27 _1YKVNsVx3j",
    menuItemContent: "_2mHwu8gVvo _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    menuItemIcon: "_3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    menuItemLabelContainer: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _2fwxA5ecOK _3YEZNO7dHp",
    labelAndVerifiedContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    menuItemLabel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d _1ANEUSLRg7 _39HuIbz8Lp",
    favoriteIconContainer: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _1Znuxb1Y8M _0wOv4Q7zJH _0KLXrujOvk _1eOmH6KcZT _3gzVzLnpTK",
    favoriteIconHidden: "_1YKVNsdnbC _30D6Ku7dHp"
};
const $c1f98b070c09a977$export$2ce376c2cc3355c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { label: label, icon: icon, isVerified: isVerified, onClick: onClick, isActive: isActive, isFocused: isFocused, isFavorite: isFavorite, onFavoriteClick: onFavoriteClick, isLoading: isLoading, isDisabled: isDisabled, tooltip: tooltip, interactionName: interactionName, isExternalLink: isExternalLink, isSubMenu: isSubMenu, labelColor: labelColor, testId: testId, componentName: componentName } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showExternalLinkIcon, setShowExternalLinkIcon] = (0, $cozmU.useState)(false);
    const [showSubMenuIcon, setShowSubMenuIcon] = (0, $cozmU.useState)(false);
    const [showFavoriteIcon, setShowFavoriteIcon] = (0, $cozmU.useState)(false);
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    const textRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const checkOverflow = ()=>{
                if (textRef.current && containerRef.current) {
                    const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                    setShowTooltip(isOverflowing);
                }
            };
            checkOverflow();
            const resizeObserver = new ResizeObserver(checkOverflow);
            if (containerRef.current) resizeObserver.observe(containerRef.current);
            return ()=>resizeObserver.disconnect();
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== label) {
        t2 = [
            label
        ];
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== isExternalLink || $[4] !== isSubMenu || $[5] !== onFavoriteClick) {
        t3 = ()=>{
            if (isExternalLink) setShowExternalLinkIcon(true);
            if (isSubMenu) setShowSubMenuIcon(true);
            if (onFavoriteClick !== undefined) setShowFavoriteIcon(true);
        };
        $[3] = isExternalLink;
        $[4] = isSubMenu;
        $[5] = onFavoriteClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleOnMouseEnter = t3;
    let t4;
    if ($[7] !== isExternalLink || $[8] !== isSubMenu || $[9] !== onFavoriteClick) {
        t4 = ()=>{
            if (isExternalLink) setShowExternalLinkIcon(false);
            if (isSubMenu) setShowSubMenuIcon(false);
            if (onFavoriteClick !== undefined) setShowFavoriteIcon(false);
        };
        $[7] = isExternalLink;
        $[8] = isSubMenu;
        $[9] = onFavoriteClick;
        $[10] = t4;
    } else t4 = $[10];
    const handleOnMouseLeave = t4;
    let t5;
    if ($[11] !== onFavoriteClick) {
        t5 = (e)=>{
            e.stopPropagation();
            onFavoriteClick?.();
        };
        $[11] = onFavoriteClick;
        $[12] = t5;
    } else t5 = $[12];
    const handleFavoriteClick = t5;
    let t6;
    if ($[13] !== componentName || $[14] !== formatMessage || $[15] !== handleFavoriteClick || $[16] !== handleOnMouseEnter || $[17] !== handleOnMouseLeave || $[18] !== icon || $[19] !== interactionName || $[20] !== isActive || $[21] !== isDisabled || $[22] !== isExternalLink || $[23] !== isFavorite || $[24] !== isFocused || $[25] !== isLoading || $[26] !== isSubMenu || $[27] !== isVerified || $[28] !== label || $[29] !== labelColor || $[30] !== onClick || $[31] !== onFavoriteClick || $[32] !== showExternalLinkIcon || $[33] !== showFavoriteIcon || $[34] !== showSubMenuIcon || $[35] !== showTooltip || $[36] !== testId || $[37] !== tooltip) {
        const renderMenuItem = (t7)=>{
            const tooltipProps = t7 === undefined ? {} : t7;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...tooltipProps,
                xcss: (0, $w6R6I.cx)($c1f98b070c09a977$var$styles.menuItem, isActive && $c1f98b070c09a977$var$styles.menuItemActive, isFocused === undefined && $c1f98b070c09a977$var$styles.menuItemHover, isFocused && $c1f98b070c09a977$var$styles.menuItemFocused, isDisabled && $c1f98b070c09a977$var$styles.menuItemDisabled),
                onClick: isDisabled ? undefined : onClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                "aria-disabled": isDisabled,
                testId: testId || "menu-item-container",
                interactionName: interactionName,
                componentName: componentName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $c1f98b070c09a977$var$styles.menuItemContent,
                testId: "menu-item-content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $c1f98b070c09a977$var$styles.menuItemIcon
            }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), {
                size: "small",
                testId: "loading-state"
            }) : isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(icon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(icon, {
                color: "var(--ds-icon-selected, #1868DB)"
            }) : icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                alignItems: "center",
                gap: "space.075",
                xcss: $c1f98b070c09a977$var$styles.labelAndVerifiedContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $c1f98b070c09a977$var$styles.menuItemLabelContainer,
                ref: containerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4XF4G.ConditionalTooltip), {
                withTooltip: showTooltip && !tooltip,
                content: label
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $c1f98b070c09a977$var$styles.menuItemLabel,
                ref: textRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: labelColor ? labelColor : isActive ? "color.text.selected" : "color.text.subtle",
                testId: "menu-item-label"
            }, label)))), isVerified && (0, $iDrrr.fg)("rovo_agents_agent_verification") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), null)), isExternalLink && showExternalLinkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
                label: "link-external",
                color: "var(--ds-icon-subtle, #505258)"
            }), isSubMenu && showSubMenuIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            })), isFavorite !== undefined && onFavoriteClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($c1f98b070c09a977$var$styles.favoriteIconContainer, !isFavorite && !showFavoriteIcon && $c1f98b070c09a977$var$styles.favoriteIconHidden),
                onClick: handleFavoriteClick,
                testId: "favorite-icon-container",
                "aria-label": isFavorite ? formatMessage((0, $bJ1N3.default).removeFromFavouritesLabel, {
                    agentName: label
                }) : formatMessage((0, $bJ1N3.default).addToFavouritesLabel, {
                    agentName: label
                })
            }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                label: "",
                color: "var(--ds-icon-warning, #E06C00)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            })), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                label: "checkmark"
            }));
        };
        t6 = tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltip
        }, renderMenuItem) : renderMenuItem();
        $[13] = componentName;
        $[14] = formatMessage;
        $[15] = handleFavoriteClick;
        $[16] = handleOnMouseEnter;
        $[17] = handleOnMouseLeave;
        $[18] = icon;
        $[19] = interactionName;
        $[20] = isActive;
        $[21] = isDisabled;
        $[22] = isExternalLink;
        $[23] = isFavorite;
        $[24] = isFocused;
        $[25] = isLoading;
        $[26] = isSubMenu;
        $[27] = isVerified;
        $[28] = label;
        $[29] = labelColor;
        $[30] = onClick;
        $[31] = onFavoriteClick;
        $[32] = showExternalLinkIcon;
        $[33] = showFavoriteIcon;
        $[34] = showSubMenuIcon;
        $[35] = showTooltip;
        $[36] = testId;
        $[37] = tooltip;
        $[38] = t6;
    } else t6 = $[38];
    return t6;
} : ({ label: label, icon: icon, isVerified: isVerified, onClick: onClick, isActive: isActive, isFocused: isFocused, isFavorite: isFavorite, onFavoriteClick: onFavoriteClick, isLoading: isLoading, isDisabled: isDisabled, tooltip: tooltip, interactionName: interactionName, isExternalLink: isExternalLink, isSubMenu: isSubMenu, labelColor: labelColor, testId: testId, componentName: componentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showExternalLinkIcon, setShowExternalLinkIcon] = (0, $cozmU.useState)(false);
    const [showSubMenuIcon, setShowSubMenuIcon] = (0, $cozmU.useState)(false);
    const [showFavoriteIcon, setShowFavoriteIcon] = (0, $cozmU.useState)(false);
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    const textRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (textRef.current && containerRef.current) {
                const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };
        checkOverflow();
        const resizeObserver = new ResizeObserver(checkOverflow);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        label
    ]);
    const handleOnMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (isExternalLink) setShowExternalLinkIcon(true);
        if (isSubMenu) setShowSubMenuIcon(true);
        if (onFavoriteClick !== undefined) setShowFavoriteIcon(true);
    }, [
        isExternalLink,
        isSubMenu,
        onFavoriteClick
    ]);
    const handleOnMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (isExternalLink) setShowExternalLinkIcon(false);
        if (isSubMenu) setShowSubMenuIcon(false);
        if (onFavoriteClick !== undefined) setShowFavoriteIcon(false);
    }, [
        isExternalLink,
        isSubMenu,
        onFavoriteClick
    ]);
    const handleFavoriteClick = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        onFavoriteClick?.();
    }, [
        onFavoriteClick
    ]);
    const renderMenuItem = (tooltipProps = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...tooltipProps,
            xcss: (0, $w6R6I.cx)($c1f98b070c09a977$var$styles.menuItem, isActive && $c1f98b070c09a977$var$styles.menuItemActive, // if is focus is defined combobox is controlling hover styles
            isFocused === undefined && $c1f98b070c09a977$var$styles.menuItemHover, isFocused && $c1f98b070c09a977$var$styles.menuItemFocused, isDisabled && $c1f98b070c09a977$var$styles.menuItemDisabled),
            onClick: isDisabled ? undefined : onClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            "aria-disabled": isDisabled,
            testId: testId || 'menu-item-container',
            interactionName: interactionName,
            componentName: componentName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemContent,
            testId: "menu-item-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemIcon
        }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), {
            size: "small",
            testId: "loading-state"
        }) : isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(icon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(icon, {
            color: "var(--ds-icon-selected, #1868DB)"
        }) : icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.075",
            xcss: $c1f98b070c09a977$var$styles.labelAndVerifiedContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemLabelContainer,
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4XF4G.ConditionalTooltip), {
            withTooltip: showTooltip && !tooltip,
            content: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemLabel,
            ref: textRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: labelColor ? labelColor : isActive ? 'color.text.selected' : 'color.text.subtle',
            testId: "menu-item-label"
        }, label)))), isVerified && (0, $iDrrr.fg)('rovo_agents_agent_verification') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWd0x.AgentVerifiedIcon), null)), isExternalLink && showExternalLinkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: "link-external",
            color: "var(--ds-icon-subtle, #505258)"
        }), isSubMenu && showSubMenuIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })), isFavorite !== undefined && onFavoriteClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($c1f98b070c09a977$var$styles.favoriteIconContainer, !isFavorite && !showFavoriteIcon && $c1f98b070c09a977$var$styles.favoriteIconHidden),
            onClick: handleFavoriteClick,
            testId: "favorite-icon-container",
            "aria-label": isFavorite ? formatMessage((0, $bJ1N3.default).removeFromFavouritesLabel, {
                agentName: label
            }) : formatMessage((0, $bJ1N3.default).addToFavouritesLabel, {
                agentName: label
            })
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
            label: "",
            color: "var(--ds-icon-warning, #E06C00)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "checkmark"
        }));
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltip
    }, renderMenuItem) : renderMenuItem();
};
module.exports["MenuItem"] = $c1f98b070c09a977$export$2ce376c2cc3355c8;

});

parcelRegister("fWd0x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $jHV8G = parcelRequire("jHV8G");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $d2UzA = parcelRequire("d2UzA");


var $4ez2K = parcelRequire("4ez2K");


var $lpNn5 = parcelRequire("lpNn5");


var $dkicA = parcelRequire("dkicA");

const $16b3b3b7d507d929$export$9b8703d83f6e657 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { agentRef: agentRef, adjacentTextSize: adjacentTextSize } = t0;
    const data = (0, $6SsN4.useFragment)((0, $jHV8G.default), agentRef);
    if (!data?.isVerified) return null;
    let t1;
    if ($[0] !== adjacentTextSize) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16b3b3b7d507d929$export$842eb53a513553a2, {
            adjacentTextSize: adjacentTextSize
        });
        $[0] = adjacentTextSize;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ agentRef: agentRef, adjacentTextSize: adjacentTextSize })=>{
    const data = (0, $6SsN4.useFragment)((0, $jHV8G.default), agentRef);
    if (!data?.isVerified) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16b3b3b7d507d929$export$842eb53a513553a2, {
        adjacentTextSize: adjacentTextSize
    });
};
const $16b3b3b7d507d929$var$styles = {
    body: "_0jFU0VSPN1",
    textLarge: "_0jFU0VoWWg",
    headingMedium: "_0jFU0VoWWg",
    headingLarge: "_0jFU0VcM5X"
};
const $16b3b3b7d507d929$export$842eb53a513553a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { adjacentTextSize: t1 } = t0;
    const adjacentTextSize = t1 === undefined ? "body" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $dkicA.default).verifiedAgentTooltip);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = adjacentTextSize === "body" && $16b3b3b7d507d929$var$styles.body;
    const t4 = adjacentTextSize === "headingMedium" && $16b3b3b7d507d929$var$styles.headingMedium;
    const t5 = adjacentTextSize === "headingLarge" && $16b3b3b7d507d929$var$styles.headingLarge;
    const t6 = adjacentTextSize === "textLarge" && $16b3b3b7d507d929$var$styles.textLarge;
    let t7;
    if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
        t7 = (0, $w6R6I.cx)(t3, t4, t5, t6);
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== formatMessage) {
        t8 = formatMessage((0, $dkicA.default).verifiedIconLabel);
        $[7] = formatMessage;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: t8,
            size: "small"
        });
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== t7 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center",
            xcss: t7
        }, t9);
        $[11] = t7;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== t10 || $[15] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t2
        }, t10);
        $[14] = t10;
        $[15] = t2;
        $[16] = t11;
    } else t11 = $[16];
    return t11;
} : ({ adjacentTextSize: adjacentTextSize = 'body' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $dkicA.default).verifiedAgentTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        alignItems: "center",
        xcss: (0, $w6R6I.cx)(adjacentTextSize === 'body' && $16b3b3b7d507d929$var$styles['body'], adjacentTextSize === 'headingMedium' && $16b3b3b7d507d929$var$styles['headingMedium'], adjacentTextSize === 'headingLarge' && $16b3b3b7d507d929$var$styles['headingLarge'], adjacentTextSize === 'textLarge' && $16b3b3b7d507d929$var$styles['textLarge'])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        label: formatMessage((0, $dkicA.default).verifiedIconLabel),
        size: "small"
    })));
};
module.exports["AgentVerified"] = $16b3b3b7d507d929$export$9b8703d83f6e657;
module.exports["AgentVerifiedIcon"] = $16b3b3b7d507d929$export$842eb53a513553a2;

});

parcelRegister("jHV8G", function(module, exports) {
/**
 * @generated SignedSource<<fa37ba83ff8562f125b2331fabeb0715>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a80ce20a69aeffc1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "agentVerified_AtlaskitRovoAgentComponents",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isVerified"
        }
    ],
    "type": "AgentStudioAssistant"
};
$a80ce20a69aeffc1$var$node.hash = "7c196c0efd61b63c8a3de1c1b32e11ec";
var $a80ce20a69aeffc1$export$2e2bcd8739ae039 = $a80ce20a69aeffc1$var$node;
module.exports["default"] = $a80ce20a69aeffc1$export$2e2bcd8739ae039;

});

parcelRegister("dkicA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b2e8fd9d19600fe4$var$_default_1 = (0, $kSwu1.defineMessages)({
    verifiedAgentTooltip: {
        id: "agent-studio-ui-components.agent-verified.tooltip",
        defaultMessage: "This agent has been verified by your organization."
    },
    verifiedIconLabel: {
        id: "agent-studio-ui-components.agent-verified.label",
        defaultMessage: "Agent verified"
    }
});
var $b2e8fd9d19600fe4$export$2e2bcd8739ae039 = $b2e8fd9d19600fe4$var$_default_1;
module.exports["default"] = $b2e8fd9d19600fe4$export$2e2bcd8739ae039;

});

parcelRegister("bJ1N3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9cb2ee457af46ff0$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "ai-mate.menu-item.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    addToFavouritesLabel: {
        id: "ai-mate.menu-item.add-to-favourites-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $9cb2ee457af46ff0$export$2e2bcd8739ae039 = $9cb2ee457af46ff0$var$message;
module.exports["default"] = $9cb2ee457af46ff0$export$2e2bcd8739ae039;

});

parcelRegister("4CKZe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52e65c04cd0b6fedd9b81f9d4406e40f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35df289e26a0a5aa$var$_react = $35df289e26a0a5aa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $35df289e26a0a5aa$var$_baseNew = $35df289e26a0a5aa$var$_interopRequireDefault((parcelRequire("gElAV")));
function $35df289e26a0a5aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Gift".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/gift
 * Usage guidance:
 * User-selectable icon choice for calendars
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35df289e26a0a5aa$var$GiftIcon = (props)=>/*#__PURE__*/ $35df289e26a0a5aa$var$_react.default.createElement($35df289e26a0a5aa$var$_baseNew.default, Object.assign({
        name: "GiftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5 1.5a1.25 1.25 0 1 0 0 2.5h1.75c0-1.899-1.12-2.5-1.75-2.5M8 1.379C7.366.472 6.418 0 5.5 0a2.75 2.75 0 0 0-2.45 4h-1.3a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75H2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9h.25a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-1.3a2.75 2.75 0 0 0-2.45-4C9.582 0 8.634.472 8 1.379M7.25 5.5H2.5v2h4.75zm1.5 2v-2h4.75v2zM7.25 9H3.5v4a.5.5 0 0 0 .5.5h3.25zm1.5 4.5V9h3.75v4a.5.5 0 0 1-.5.5zm0-9.5h1.75a1.25 1.25 0 1 0 0-2.5c-.63 0-1.75.601-1.75 2.5" clip-rule="evenodd"/>`
    }, props));
$35df289e26a0a5aa$var$GiftIcon.displayName = 'GiftIcon';
var $35df289e26a0a5aa$var$_default = module.exports.default = $35df289e26a0a5aa$var$GiftIcon;

});

parcelRegister("7Mix9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14328734352f14c46049b58e5c6e9f36>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a9b647a96a0e4d7$var$_react = $5a9b647a96a0e4d7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5a9b647a96a0e4d7$var$_baseNew = $5a9b647a96a0e4d7$var$_interopRequireDefault((parcelRequire("gElAV")));
function $5a9b647a96a0e4d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/menu
 * Usage guidance:
 * Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a9b647a96a0e4d7$var$MenuIcon = (props)=>/*#__PURE__*/ $5a9b647a96a0e4d7$var$_react.default.createElement($5a9b647a96a0e4d7$var$_baseNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$5a9b647a96a0e4d7$var$MenuIcon.displayName = 'MenuIcon';
var $5a9b647a96a0e4d7$var$_default = module.exports.default = $5a9b647a96a0e4d7$var$MenuIcon;

});

parcelRegister("dQbwX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kuGC4 = parcelRequire("kuGC4");


var $i4nJ0 = parcelRequire("i4nJ0");

const $59df345fa6bcad2c$export$f88ffd22b5af5258 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { conversationId: conversationId, assistanceServiceParams: assistanceServiceParams } = t0;
    let t1;
    if ($[0] !== conversationId) {
        t1 = {
            conversationId: conversationId
        };
        $[0] = conversationId;
        $[1] = t1;
    } else t1 = $[1];
    const conversation = (0, $kuGC4.useConversationById)(t1);
    let t2;
    if ($[2] !== assistanceServiceParams || $[3] !== conversation || $[4] !== conversationId) {
        t2 = {
            conversationId: conversationId,
            conversation: conversation,
            assistanceServiceParams: assistanceServiceParams
        };
        $[2] = assistanceServiceParams;
        $[3] = conversation;
        $[4] = conversationId;
        $[5] = t2;
    } else t2 = $[5];
    return (0, $i4nJ0.useConversationData)(t2);
} : ({ conversationId: conversationId, assistanceServiceParams: assistanceServiceParams })=>{
    const conversation = (0, $kuGC4.useConversationById)({
        conversationId: conversationId
    });
    return (0, $i4nJ0.useConversationData)({
        conversationId: conversationId,
        conversation: conversation,
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["useChatConversation"] = $59df345fa6bcad2c$export$f88ffd22b5af5258;

});

parcelRegister("kuGC4", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $d57cf010992105d3$export$409e508fe0e24613 = (0, $kBr4q.createStateHook)((0, $lx3cN.chatStore), {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]
});
module.exports["useConversationById"] = $d57cf010992105d3$export$409e508fe0e24613;

});

parcelRegister("88DFk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");

var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $kXiqf = parcelRequire("kXiqf");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $9d01a40d5c3361ba$var$DefaultActionSubject = 'rovoAgent';
const $9d01a40d5c3361ba$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $9d01a40d5c3361ba$export$b9dc0ab1bce924aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = (0, $kXiqf.useRovoAgentCSID)();
    const { csid: csid, globalCSID: globalCSID } = t0;
    const { refresh: refreshCSID } = t1;
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t2 = (event)=>{
            const referrer = typeof window !== "undefined" ? window.document.referrer : "unknown";
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                ...event.attributes,
                actionGroup: "createFlow",
                referrer: referrer
            };
            createAnalyticsEvent({
                ...$9d01a40d5c3361ba$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const fireAnalyticsEvent = t2;
    let t3;
    if ($[3] !== fireAnalyticsEvent || $[4] !== globalCSID) {
        t3 = (action, attributes_0)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: action,
                attributes: {
                    csid: globalCSID,
                    ...attributes_0
                }
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = globalCSID;
        $[5] = t3;
    } else t3 = $[5];
    const trackCreateSession = t3;
    let t4;
    if ($[6] !== csid || $[7] !== fireAnalyticsEvent || $[8] !== refreshCSID) {
        t4 = (attributes_1)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowStart",
                attributes: {
                    csid: csid,
                    ...attributes_1
                }
            });
            refreshCSID();
        };
        $[6] = csid;
        $[7] = fireAnalyticsEvent;
        $[8] = refreshCSID;
        $[9] = t4;
    } else t4 = $[9];
    const trackCreateSessionStart = t4;
    let t5;
    if ($[10] !== fireAnalyticsEvent || $[11] !== globalCSID) {
        t5 = (error, attributes_2)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowError",
                attributes: {
                    error: {
                        message: error.message
                    },
                    csid: globalCSID,
                    ...attributes_2
                }
            });
        };
        $[10] = fireAnalyticsEvent;
        $[11] = globalCSID;
        $[12] = t5;
    } else t5 = $[12];
    const trackCreateSessionError = t5;
    let t6;
    if ($[13] !== refreshCSID || $[14] !== trackCreateSession || $[15] !== trackCreateSessionError || $[16] !== trackCreateSessionStart) {
        t6 = {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        };
        $[13] = refreshCSID;
        $[14] = trackCreateSession;
        $[15] = trackCreateSessionError;
        $[16] = trackCreateSessionStart;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== csid || $[19] !== t6) {
        t7 = [
            csid,
            t6
        ];
        $[18] = csid;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : (commonAttributes)=>{
    const [{ csid: csid, globalCSID: globalCSID }, { refresh: refreshCSID }] = (0, $kXiqf.useRovoAgentCSID)();
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const referrer = typeof window !== 'undefined' ? window.document.referrer : 'unknown';
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            ...event.attributes,
            actionGroup: 'createFlow',
            referrer: referrer
        };
        createAnalyticsEvent({
            ...$9d01a40d5c3361ba$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fires an analytics event for a step in the create agent flow funnel.
   * Uses the CSID from the URL query parameter.
   */ const trackCreateSession = (0, $cozmU.useCallback)((action, attributes_0)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: action,
            attributes: {
                csid: globalCSID,
                ...attributes_0
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    /**
   * Fires `createFlowStart` with the current CSID (matching the href),
   * then refreshes the CSID for the next session.
   * The component re-renders with the new CSID, updating any href attributes.
   */ const trackCreateSessionStart = (0, $cozmU.useCallback)((attributes_1)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowStart',
            attributes: {
                csid: csid,
                ...attributes_1
            }
        });
        refreshCSID();
    }, [
        fireAnalyticsEvent,
        refreshCSID,
        csid
    ]);
    const trackCreateSessionError = (0, $cozmU.useCallback)((error, attributes_2)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowError',
            attributes: {
                error: {
                    message: error.message
                },
                csid: globalCSID,
                ...attributes_2
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    return [
        csid,
        {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        }
    ];
};
module.exports["useRovoAgentCreateAnalytics"] = $9d01a40d5c3361ba$export$b9dc0ab1bce924aa;

});

parcelRegister("kXiqf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $debAY = parcelRequire("debAY");

let $3de3d827eb32710a$var$CACHED_CSID = null;
const $3de3d827eb32710a$var$generateCSID = ()=>{
    return crypto.randomUUID();
};
const $3de3d827eb32710a$export$2e155615ea28a17b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID();
        $[0] = t0;
    } else t0 = $[0];
    const [csid, setCSID] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        const queryParams = new URLSearchParams(window.location.search);
        t1 = queryParams.get((0, $debAY.CSID_QUERY_PARAM));
        $[1] = t1;
    } else t1 = $[1];
    const globalCSID = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const actions = t2;
    let t3;
    if ($[3] !== csid) {
        t3 = [
            {
                csid: csid,
                globalCSID: globalCSID
            },
            actions
        ];
        $[3] = csid;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [csid, setCSID] = (0, $cozmU.useState)($3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID());
    const globalCSID = (0, $cozmU.useMemo)(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get((0, $debAY.CSID_QUERY_PARAM));
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        return {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
    }, []);
    return [
        {
            csid: csid,
            globalCSID: // generated CSID to be used in href and createFlowStart events
            globalCSID // CSID from the URL query parameter
        },
        actions
    ];
};
module.exports["useRovoAgentCSID"] = $3de3d827eb32710a$export$2e155615ea28a17b;

});

parcelRegister("debAY", function(module, exports) {
const $881ebb84c71795d2$export$61b85fb5d2d632d0 = 'csid';
module.exports["CSID_QUERY_PARAM"] = $881ebb84c71795d2$export$61b85fb5d2d632d0;

});

parcelRegister("bpVtj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $haiCi = parcelRequire("haiCi");


var $33DP2 = parcelRequire("33DP2");


var $jrbLf = parcelRequire("jrbLf");

const $879b7c6c4d98f5aa$var$AgentPermissionsQuery = `
	query AgentPermissions($cloudId: ID!) {
		atlassianStudio_userSiteContext(cloudId: $cloudId) {
			... on AtlassianStudioUserSiteContextOutput {
				userPermissions {
					isAbleToCreateAgents
					isAbleToGovernAgents
				}
			}
		}
	}
`;
const $879b7c6c4d98f5aa$var$fetchAgentSitePermissions = (siteId)=>(0, $haiCi.performGqlFetch)({
        gqlQuery: $879b7c6c4d98f5aa$var$AgentPermissionsQuery,
        variables: {
            cloudId: siteId
        }
    });
const $879b7c6c4d98f5aa$export$d90919d15b1cd6c6 = ({ siteId: siteId, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    (0, $5SS4O.prefetchQuery)({
        queryKey: [
            'fetchSitePermissions',
            siteId
        ],
        queryFn: ()=>$879b7c6c4d98f5aa$var$fetchAgentSitePermissions(siteId),
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
const $879b7c6c4d98f5aa$export$528f308686e597b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { siteId: overrideSiteId, touchpointSource: touchpointSource } = t0;
    const { siteId: siteId } = (0, $jrbLf.useSiteContext)();
    let t1;
    if ($[0] !== touchpointSource) {
        t1 = {
            touchpointSource: touchpointSource
        };
        $[0] = touchpointSource;
        $[1] = t1;
    } else t1 = $[1];
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)(t1);
    const siteIdToUse = overrideSiteId ?? siteId;
    let t2;
    if ($[2] !== siteIdToUse) {
        t2 = [
            "fetchSitePermissions",
            siteIdToUse
        ];
        $[2] = siteIdToUse;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== experienceTracker || $[5] !== siteIdToUse) {
        t3 = async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS
            });
            return await $879b7c6c4d98f5aa$var$fetchAgentSitePermissions(siteIdToUse);
        };
        $[4] = experienceTracker;
        $[5] = siteIdToUse;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    let t5;
    if ($[7] !== experienceTracker) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS
            });
        };
        t5 = (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        };
        $[7] = experienceTracker;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    let t6;
    if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
        t6 = {
            queryKey: t2,
            queryFn: t3,
            onSuccess: t4,
            onError: t5
        };
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    const query = (0, $5SS4O.useQuery)(t6);
    return query;
} : ({ siteId: overrideSiteId, touchpointSource: touchpointSource })=>{
    const { siteId: siteId } = (0, $jrbLf.useSiteContext)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)({
        touchpointSource: touchpointSource
    });
    const siteIdToUse = overrideSiteId ?? siteId;
    const query = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchSitePermissions',
            siteIdToUse
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS
            });
            return await $879b7c6c4d98f5aa$var$fetchAgentSitePermissions(siteIdToUse);
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_SITE_PERMISSIONS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return query;
};
const $879b7c6c4d98f5aa$export$815a1bc00db93188 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { siteId: siteId, touchpointSource: touchpointSource } = t0;
    let t1;
    if ($[0] !== siteId || $[1] !== touchpointSource) {
        t1 = {
            siteId: siteId,
            touchpointSource: touchpointSource
        };
        $[0] = siteId;
        $[1] = touchpointSource;
        $[2] = t1;
    } else t1 = $[2];
    const { data: sitePermissions, isFetching: isFetchingSitePermissions } = $879b7c6c4d98f5aa$export$528f308686e597b0(t1);
    sitePermissions?.data?.atlassianStudio_userSiteContext?.userPermissions;
    const userPermissions = sitePermissions?.data?.atlassianStudio_userSiteContext?.userPermissions;
    const t2 = userPermissions?.isAbleToCreateAgents ?? false;
    const t3 = userPermissions?.isAbleToGovernAgents ?? false;
    let t4;
    if ($[3] !== isFetchingSitePermissions || $[4] !== t2 || $[5] !== t3) {
        t4 = {
            isAbleToCreateAgents: t2,
            isAbleToGovernAgents: t3,
            isFetchingPermissions: isFetchingSitePermissions
        };
        $[3] = isFetchingSitePermissions;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { isAbleToCreateAgents: isAbleToCreateAgents, isAbleToGovernAgents: isAbleToGovernAgents, isFetchingPermissions: isFetchingPermissions } = t4;
    let t5;
    if ($[7] !== isAbleToCreateAgents || $[8] !== isAbleToGovernAgents || $[9] !== isFetchingPermissions) {
        t5 = {
            isAbleToCreateAgents: isAbleToCreateAgents,
            isAbleToGovernAgents: isAbleToGovernAgents,
            isFetchingPermissions: isFetchingPermissions
        };
        $[7] = isAbleToCreateAgents;
        $[8] = isAbleToGovernAgents;
        $[9] = isFetchingPermissions;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ siteId: siteId, touchpointSource: touchpointSource })=>{
    const { data: sitePermissions, isFetching: isFetchingSitePermissions } = $879b7c6c4d98f5aa$export$528f308686e597b0({
        siteId: siteId,
        touchpointSource: touchpointSource
    });
    const { isAbleToCreateAgents: isAbleToCreateAgents, isAbleToGovernAgents: isAbleToGovernAgents, isFetchingPermissions: isFetchingPermissions } = (0, $cozmU.useMemo)(()=>{
        const userPermissions = sitePermissions?.data?.atlassianStudio_userSiteContext?.userPermissions;
        return {
            isAbleToCreateAgents: userPermissions?.isAbleToCreateAgents ?? false,
            isAbleToGovernAgents: userPermissions?.isAbleToGovernAgents ?? false,
            isFetchingPermissions: isFetchingSitePermissions
        };
    }, [
        isFetchingSitePermissions,
        sitePermissions?.data?.atlassianStudio_userSiteContext?.userPermissions
    ]);
    return {
        isAbleToCreateAgents: isAbleToCreateAgents,
        isAbleToGovernAgents: isAbleToGovernAgents,
        isFetchingPermissions: isFetchingPermissions
    };
};
module.exports["useAgentSitePermissions"] = $879b7c6c4d98f5aa$export$528f308686e597b0;
module.exports["useUserSitePermissions"] = $879b7c6c4d98f5aa$export$815a1bc00db93188;

});

parcelRegister("jrbLf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $9ff69d9ac960dda9$export$2cab3982d83485b0 = /*#__PURE__*/ (0, $cozmU.createContext)({
    siteId: ''
});
const $9ff69d9ac960dda9$export$55c0e3cb4fbc46cf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($9ff69d9ac960dda9$export$2cab3982d83485b0);
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($9ff69d9ac960dda9$export$2cab3982d83485b0);
    return context;
};
module.exports["SiteContext"] = $9ff69d9ac960dda9$export$2cab3982d83485b0;
module.exports["useSiteContext"] = $9ff69d9ac960dda9$export$55c0e3cb4fbc46cf;

});

parcelRegister("eP6A1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hq9Cp = parcelRequire("hq9Cp");


var $6gGPb = parcelRequire("6gGPb");


var $ji12t = parcelRequire("ji12t");

const $0bc982fcc00bec10$export$840bfed76f04079b = ({ recommendedAgents: recommendedAgents, agentsByCategoryAllAgents: agentsByCategoryAllAgents, agentsByCategoryFavoriteAgents: agentsByCategoryFavoriteAgents, agentsByCategoryVerifiedAgents: agentsByCategoryVerifiedAgents = [], selectedAgent: selectedAgent, moveSelectedAgentToTop: moveSelectedAgentToTop = true, defaultAgents: defaultAgents = [] })=>{
    const allAgents = [
        ...defaultAgents,
        ...agentsByCategoryFavoriteAgents,
        ...agentsByCategoryVerifiedAgents,
        ...recommendedAgents,
        ...agentsByCategoryAllAgents
    ];
    const seenAgentIds = new Set();
    const allAgentsDeduplicated = allAgents.filter((agent)=>{
        if (seenAgentIds.has(agent.id)) return false;
        seenAgentIds.add(agent.id);
        return true;
    });
    // ensure that the selected agent is at the top of the list
    if (selectedAgent && !selectedAgent.is_default) {
        const index = allAgentsDeduplicated.findIndex((agent)=>agent.id === selectedAgent.id);
        if (moveSelectedAgentToTop) {
            if (index !== -1) allAgentsDeduplicated.splice(index, 1);
            allAgentsDeduplicated.unshift(selectedAgent);
        } else if (index === -1) allAgentsDeduplicated.unshift(selectedAgent);
    }
    return allAgentsDeduplicated;
};
const $0bc982fcc00bec10$export$5fc049a7e27256a7 = (agent)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        size: "small",
        agentId: agent.id,
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentIdentityAccountId: agent.identity_account_id,
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent),
        forgeAgentIconUrl: agent.icon
    });
};
module.exports["getDisplayedAgents"] = $0bc982fcc00bec10$export$840bfed76f04079b;
module.exports["getAgentIcon"] = $0bc982fcc00bec10$export$5fc049a7e27256a7;

});

parcelRegister("3jESw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lJ6db = parcelRequire("lJ6db");


var $9qJ1N = parcelRequire("9qJ1N");

/**
 * Mounts an SSE subscription for the unified tasks store while the caller is mounted.
 *
 * - When `enabled` is true, increments the store's SSE subscriber count on mount,
 *   and decrements it on unmount or when `enabled` becomes false.
 * - The store opens the physical SSE connection when count goes from 0 → 1
 *   and closes it when it drops back to 0 (ref-counted, tab-visibility aware).
 *
 * Wraps an inner hook with `createHookWithAssistanceService` so the assistance
 * service is injected by the shared chat context, instead of relying on consumers
 * to plumb a `getService` through their own params.
 */ const $15e3f0d0159e45c8$var$useUnifiedTasksSSESubscriptionWithAssistanceService = ({ enabled: enabled, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { mountSSESubscriber: mountSSESubscriber, unmountSSESubscriber: unmountSSESubscriber } = (0, $9qJ1N.useTasksStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return undefined;
        mountSSESubscriber(()=>assistanceService);
        return ()=>unmountSSESubscriber();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        assistanceService
    ]);
};
const $15e3f0d0159e45c8$export$10254e4a51076451 = (0, $lJ6db.createHookWithAssistanceService)($15e3f0d0159e45c8$var$useUnifiedTasksSSESubscriptionWithAssistanceService);
module.exports["useUnifiedTasksSSESubscription"] = $15e3f0d0159e45c8$export$10254e4a51076451;

});

parcelRegister("hd4Ag", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $eriCt = parcelRequire("eriCt");

const $1f69189ce877419f$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $1f69189ce877419f$export$6fa751d66e55d2e1;

});

parcelRegister("eriCt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $34391591fc09bf27$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $34391591fc09bf27$export$46133998910543ac;

});

parcelRegister("2BEJj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gzMZq = parcelRequire("gzMZq");


var $bGNkz = parcelRequire("bGNkz");

const $004f02f833a2db8e$export$ce994b8430b2407d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { clearSelectedSpace: clearSelectedSpace, clearEmptyChatLaunchAll: clearEmptyChatLaunchAll } = (0, $bGNkz.useUIStoreActions)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    let t0;
    if ($[0] !== clearEmptyChatLaunchAll || $[1] !== clearSelectedSpace || $[2] !== setAIFeatureContext) {
        t0 = ()=>{
            clearSelectedSpace();
            clearEmptyChatLaunchAll();
            setAIFeatureContext({
                contextKey: "projectContext",
                setContext: $004f02f833a2db8e$var$_temp
            });
        };
        $[0] = clearEmptyChatLaunchAll;
        $[1] = clearSelectedSpace;
        $[2] = setAIFeatureContext;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const { clearSelectedSpace: clearSelectedSpace, clearEmptyChatLaunchAll: clearEmptyChatLaunchAll } = (0, $bGNkz.useUIStoreActions)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    return (0, $cozmU.useCallback)(()=>{
        clearSelectedSpace();
        clearEmptyChatLaunchAll();
        // Clear the projectContext key. The store's setAIFeatureContext writes the
        // return value of setContext under aiFeatureContext[contextKey], and its
        // getAIFeatureContext cleanup then strips any key whose value is `undefined`.
        // The store's setContext signature is `<T>(x: T) => T`, so the `undefined`
        // return needs a narrow cast; we deliberately return undefined rather than
        // forging a same-shape empty object that downstream consumers would
        // misinterpret (see PR review feedback re: `({}) as T` being unsound).
        setAIFeatureContext({
            contextKey: 'projectContext',
            setContext: (_)=>undefined
        });
    }, [
        clearSelectedSpace,
        clearEmptyChatLaunchAll,
        setAIFeatureContext
    ]);
};
function $004f02f833a2db8e$var$_temp(_) {
    return undefined;
}
module.exports["useExitSpace"] = $004f02f833a2db8e$export$ce994b8430b2407d;

});

parcelRegister("iiDOK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iehIX = parcelRequire("iehIX");

const $921dd5c9e20b74d2$export$b97fe97a2a407fce = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $iehIX.SplitViewContext));
} : ()=>(0, $cozmU.useContext)((0, $iehIX.SplitViewContext));
module.exports["useSplitView"] = $921dd5c9e20b74d2$export$b97fe97a2a407fce;

});

parcelRegister("iehIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");

const $d2139e3561c828e8$var$openWithRequestedPresentation = (requestedPresentation)=>requestedPresentation;
const $d2139e3561c828e8$export$9dcf8f238ea334c6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    presentation: null,
    openSessionContext: $d2139e3561c828e8$var$openWithRequestedPresentation,
    closeSessionContext: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
});
module.exports["SplitViewContext"] = $d2139e3561c828e8$export$9dcf8f238ea334c6;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("eKpjD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hq9Cp = parcelRequire("hq9Cp");


var $eW61a = parcelRequire("eW61a");


var $lUcpS = parcelRequire("lUcpS");


var $dRAjC = parcelRequire("dRAjC");


var $7mRGw = parcelRequire("7mRGw");


var $hIwXM = parcelRequire("hIwXM");

const $02fe2f9f47117f75$export$64983741fea6a45d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ ...props }, ref)=>{
    const { footerComponent: footerComponent, ...profileCardTriggerProps } = props;
    const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId, agentIdType: agentIdType = 'agent' } = props;
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    /**
   * @TODO replace with `getAgentCreator` from `@atlassian/rovo-agent-components`
   * @deprecated use `getAgentCreator` from `@atlassian/rovo-agent-components`
   */ const getCreator = async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        if (!creator) return undefined;
        if ((0, $hq9Cp.isForgeAgentByCreatorType)(creator_type) && (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar')) return {
            type: 'THIRD_PARTY',
            name: creator ?? ''
        };
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId_0 = (0, $dRAjC.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId_0 || !cloudId) return undefined;
                    if (authoringTeam) return {
                        type: 'CUSTOMER',
                        name: authoringTeam.displayName ?? '',
                        profileLink: authoringTeam.profileUrl ?? ''
                    };
                    const { href: profileHref } = (0, $eW61a.navigateToTeamsApp)({
                        type: 'USER',
                        payload: {
                            userId: userId_0
                        },
                        cloudId: cloudId
                    });
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId_0, fireEvent);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${userId_0}`,
                        id: userId_0
                    };
                } catch  {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentProfileResult = await resourceClient.getRovoAgentProfile({
            type: agentIdType,
            value: userId
        }, fireEvent);
        const agentInfo = agentProfileResult.restData;
        const agentCreatorInfo = await getCreator({
            creator_type: agentInfo.creator_type,
            creator: agentInfo.creator || undefined,
            authoringTeam: agentProfileResult.aggData?.authoringTeam ?? undefined
        });
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, error: error })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                cloudId: props.cloudId,
                email: props.email,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                onDeleteAgent: props.onDeleteAgent,
                addFlag: props.addFlag,
                hideStarButton: props.hideStarButton,
                footerComponent: footerComponent
            })
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7mRGw.default), {
        ...profileCardTriggerProps,
        ref: ref,
        trigger: props.trigger ?? 'hover',
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalytics: fireEvent,
        profileCardType: "agent"
    });
});
module.exports["AgentProfileCardTrigger"] = $02fe2f9f47117f75$export$64983741fea6a45d;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("7mRGw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5wHqn = parcelRequire("5wHqn");


var $jp2Q3 = parcelRequire("jp2Q3");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");


var $6HFjc = parcelRequire("6HFjc");


var $buXlg = parcelRequire("buXlg");


var $8bTIj = parcelRequire("8bTIj");


var $2Vosv = parcelRequire("2Vosv");

const $e32bd4aabd53e95e$var$DELAY_MS_SHOW = 800;
const $e32bd4aabd53e95e$var$DELAY_MS_HIDE = 200;
const $e32bd4aabd53e95e$var$ProfileCardTriggerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProfileCardTriggerInner(t0, ref) {
    const $ = (0, $bDgLe.c)(55);
    let ariaLabelledBy;
    let children;
    let disabledAriaAttributes;
    let fetchProfile;
    let fireAnalytics;
    let popupProps;
    let profileCardType;
    let renderProfileCard;
    let testId;
    let trigger;
    if ($[0] !== t0) {
        ({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, testId: testId, fireAnalytics: fireAnalytics, ...popupProps } = t0);
        $[0] = t0;
        $[1] = ariaLabelledBy;
        $[2] = children;
        $[3] = disabledAriaAttributes;
        $[4] = fetchProfile;
        $[5] = fireAnalytics;
        $[6] = popupProps;
        $[7] = profileCardType;
        $[8] = renderProfileCard;
        $[9] = testId;
        $[10] = trigger;
    } else {
        ariaLabelledBy = $[1];
        children = $[2];
        disabledAriaAttributes = $[3];
        fetchProfile = $[4];
        fireAnalytics = $[5];
        popupProps = $[6];
        profileCardType = $[7];
        renderProfileCard = $[8];
        testId = $[9];
        trigger = $[10];
    }
    const showDelay = trigger === "click" ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_SHOW;
    const hideDelay = trigger === "click" ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_HIDE;
    const showTimer = (0, $cozmU.useRef)(0);
    const hideTimer = (0, $cozmU.useRef)(0);
    const [visible, setVisible] = (0, $cozmU.useState)(false);
    let t1;
    if ($[11] !== fetchProfile) {
        t1 = {
            fetchUserProfile: fetchProfile
        };
        $[11] = fetchProfile;
        $[12] = t1;
    } else t1 = $[12];
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $6HFjc.useProfileInfo)(t1);
    let t2;
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>()=>{
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        t3 = [];
        $[13] = t2;
        $[14] = t3;
    } else {
        t2 = $[13];
        t3 = $[14];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[15] !== hideDelay) {
        t4 = ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
            }, hideDelay);
        };
        $[15] = hideDelay;
        $[16] = t4;
    } else t4 = $[16];
    const hideProfilecard = t4;
    let t5;
    let t6;
    if ($[17] !== hideProfilecard) {
        t5 = ()=>({
                hideProfilecard: hideProfilecard
            });
        t6 = [
            hideProfilecard
        ];
        $[17] = hideProfilecard;
        $[18] = t5;
        $[19] = t6;
    } else {
        t5 = $[18];
        t6 = $[19];
    }
    (0, $cozmU.useImperativeHandle)(ref, t5, t6);
    let t7;
    if ($[20] !== fireAnalytics || $[21] !== getProfileData || $[22] !== profileCardType || $[23] !== showDelay || $[24] !== trigger || $[25] !== visible) {
        t7 = async ()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    getProfileData?.();
                    setVisible(true);
                    if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileCardType)}.triggered`, {
                        method: trigger,
                        ...(0, $cSSWJ.PACKAGE_META_DATA),
                        firedAt: Math.round((0, $1GhPJ.getPageTime)())
                    });
                }
            }, showDelay);
        };
        $[20] = fireAnalytics;
        $[21] = getProfileData;
        $[22] = profileCardType;
        $[23] = showDelay;
        $[24] = trigger;
        $[25] = visible;
        $[26] = t7;
    } else t7 = $[26];
    const showProfilecard = t7;
    let t8;
    if ($[27] !== showProfilecard) {
        t8 = ()=>{
            showProfilecard();
        };
        $[27] = showProfilecard;
        $[28] = t8;
    } else t8 = $[28];
    const onMouseEnter = t8;
    const t9 = !!visible;
    const t10 = popupProps.autoFocus ?? trigger === "click";
    let t11;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $jp2Q3.layers).modal();
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== ariaLabelledBy || $[31] !== children || $[32] !== disabledAriaAttributes || $[33] !== hideProfilecard || $[34] !== showProfilecard || $[35] !== testId || $[36] !== trigger) {
        t12 = (triggerProps)=>{
            const { "aria-expanded": _, "aria-haspopup": __, "aria-controls": ___, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8bTIj.PopupTrigger), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ref: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger,
                "data-testid": testId
            });
        };
        $[30] = ariaLabelledBy;
        $[31] = children;
        $[32] = disabledAriaAttributes;
        $[33] = hideProfilecard;
        $[34] = showProfilecard;
        $[35] = testId;
        $[36] = trigger;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== error || $[39] !== fireAnalytics || $[40] !== hideProfilecard || $[41] !== isLoading || $[42] !== onMouseEnter || $[43] !== profileCardType || $[44] !== profileData || $[45] !== renderProfileCard || $[46] !== showProfilecard) {
        t13 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                onBlur: hideProfilecard,
                "data-testid": "profile-card--trigger-content",
                children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Vosv.ProfileCardWrapper), {
                    testId: "profilecard.profilecardtrigger.loading",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $buXlg.LoadingState), {
                        fireAnalytics: fireAnalytics,
                        profileType: profileCardType
                    })
                }) : renderProfileCard({
                    profileData: profileData,
                    error: error
                })
            });
        $[38] = error;
        $[39] = fireAnalytics;
        $[40] = hideProfilecard;
        $[41] = isLoading;
        $[42] = onMouseEnter;
        $[43] = profileCardType;
        $[44] = profileData;
        $[45] = renderProfileCard;
        $[46] = showProfilecard;
        $[47] = t13;
    } else t13 = $[47];
    let t14;
    if ($[48] !== hideProfilecard || $[49] !== popupProps || $[50] !== t10 || $[51] !== t12 || $[52] !== t13 || $[53] !== t9) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5wHqn.default), {
            ...popupProps,
            isOpen: t9,
            onClose: hideProfilecard,
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: t10,
            zIndex: t11,
            shouldFitContainer: false,
            trigger: t12,
            content: t13
        });
        $[48] = hideProfilecard;
        $[49] = popupProps;
        $[50] = t10;
        $[51] = t12;
        $[52] = t13;
        $[53] = t9;
        $[54] = t14;
    } else t14 = $[54];
    return t14;
} : function ProfileCardTriggerInner({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, testId: testId, fireAnalytics: fireAnalytics, ...popupProps }, ref) {
    const showDelay = trigger === 'click' ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_HIDE;
    const showTimer = (0, $cozmU.useRef)(0);
    const hideTimer = (0, $cozmU.useRef)(0);
    const [visible, setVisible] = (0, $cozmU.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $6HFjc.useProfileInfo)({
        fetchUserProfile: fetchProfile
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $cozmU.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            hideProfilecard: hideProfilecard
        }), [
        hideProfilecard
    ]);
    const showProfilecard = (0, $cozmU.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                getProfileData?.();
                setVisible(true);
                if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileCardType)}.triggered`, {
                    method: trigger,
                    ...(0, $cSSWJ.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $1GhPJ.getPageTime)())
                });
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger
    ]);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5wHqn.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $jp2Q3.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            const { 'aria-expanded': _, 'aria-haspopup': __, 'aria-controls': ___, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8bTIj.PopupTrigger), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ref: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger,
                "data-testid": testId
            });
        },
        content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                onBlur: hideProfilecard,
                "data-testid": "profile-card--trigger-content",
                children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Vosv.ProfileCardWrapper), {
                    testId: "profilecard.profilecardtrigger.loading",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $buXlg.LoadingState), {
                        fireAnalytics: fireAnalytics,
                        profileType: profileCardType
                    })
                }) : renderProfileCard({
                    profileData: profileData,
                    error: error
                })
            })
    });
};
const $e32bd4aabd53e95e$var$ProfileCardTrigger = /*#__PURE__*/ (0, $cozmU.forwardRef)($e32bd4aabd53e95e$var$ProfileCardTriggerInner);
var $e32bd4aabd53e95e$export$2e2bcd8739ae039 = $e32bd4aabd53e95e$var$ProfileCardTrigger;
module.exports["default"] = $e32bd4aabd53e95e$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {

var $1GhPJ = parcelRequire("1GhPJ");

const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$var$TEAM_SUBJECT = 'teamProfileCard';
const $e8b102093dcaac45$var$USER_SUBJECT = 'profilecard';
const $e8b102093dcaac45$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $e8b102093dcaac45$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $1GhPJ.getPageTime)())
        }
    });
const $e8b102093dcaac45$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $e8b102093dcaac45$var$USER_SUBJECT;
        case 'team':
            return $e8b102093dcaac45$var$TEAM_SUBJECT;
        case 'agent':
            return $e8b102093dcaac45$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $e8b102093dcaac45$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $e8b102093dcaac45$var$createEvent('ui', 'triggered', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $e8b102093dcaac45$export$c9b0e37b229a297b = (action, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$TEAM_SUBJECT, 'request', attributes);
const $e8b102093dcaac45$export$12dae48763368ac9 = (action, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$USER_SUBJECT, 'request', attributes);
const $e8b102093dcaac45$export$41816a317479160b = (type, actionSubjectId, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'rendered', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $e8b102093dcaac45$export$fdcd134fbeb1f921 = (type, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), 'action', attributes);
const $e8b102093dcaac45$export$93260987012593be = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$USER_SUBJECT, 'reportingLines', attributes);
const $e8b102093dcaac45$export$79befd155063a6a7 = (type, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $e8b102093dcaac45$export$2703289b35687fde = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'avatar', attributes);
const $e8b102093dcaac45$export$b4411a7661cf2d3f = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $e8b102093dcaac45$export$c86679da702d560e = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $e8b102093dcaac45$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["getActionSubject"] = $e8b102093dcaac45$export$6f40cdf6d42c018d;

});

parcelRegister("1GhPJ", function(module, exports) {
const $b79121f0bdcafc37$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $b79121f0bdcafc37$var$performanceAvailable = $b79121f0bdcafc37$var$isPerformanceAvailable();
const $b79121f0bdcafc37$var$initialPageTime = Date.now();
const $b79121f0bdcafc37$export$e9faea7c41053334 = ()=>{
    if ($b79121f0bdcafc37$var$performanceAvailable) return performance.now();
    return Date.now() - $b79121f0bdcafc37$var$initialPageTime;
};
module.exports["getPageTime"] = $b79121f0bdcafc37$export$e9faea7c41053334;

});

parcelRegister("6HFjc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2c5cb016ddbec74b$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [profileData, setProfileData] = (0, $cozmU.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData_0 = await fetchUserProfile?.();
            setProfileData(profileData_0);
            setIsLoading(false);
        } catch (error_0) {
            setError(error_0);
            setIsLoading(false);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};
module.exports["useProfileInfo"] = $2c5cb016ddbec74b$export$6cace87f7d7a9738;

});

parcelRegister("buXlg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jyWTZ = parcelRequire("jyWTZ");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");

const $5fb324c8098a6165$export$62aa48085237e36f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fireAnalytics: fireAnalytics, profileType: profileType } = t0;
    let t1;
    let t2;
    if ($[0] !== fireAnalytics || $[1] !== profileType) {
        t1 = ()=>{
            if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileType)}.rendered.spinner`, {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            fireAnalytics,
            profileType
        ];
        $[0] = fireAnalytics;
        $[1] = profileType;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jyWTZ.SpinnerContainer), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
        });
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $cozmU.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileType)}.rendered.spinner`, {
            firedAt: Math.round((0, $1GhPJ.getPageTime)()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jyWTZ.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
    });
};
module.exports["LoadingState"] = $5fb324c8098a6165$export$62aa48085237e36f;

});

parcelRegister("8bTIj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $d9459e83ce60344e$var$PopupTriggerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(25);
    let ariaLabelledBy;
    let children;
    let hideProfilecard;
    let props;
    let showProfilecard;
    let trigger;
    if ($[0] !== t0) {
        ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props } = t0);
        $[0] = t0;
        $[1] = ariaLabelledBy;
        $[2] = children;
        $[3] = hideProfilecard;
        $[4] = props;
        $[5] = showProfilecard;
        $[6] = trigger;
    } else {
        ariaLabelledBy = $[1];
        children = $[2];
        hideProfilecard = $[3];
        props = $[4];
        showProfilecard = $[5];
        trigger = $[6];
    }
    let t1;
    if ($[7] !== showProfilecard) {
        t1 = ()=>{
            showProfilecard();
        };
        $[7] = showProfilecard;
        $[8] = t1;
    } else t1 = $[8];
    const onMouseEnter = t1;
    let t2;
    if ($[9] !== showProfilecard) {
        t2 = (event)=>{
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                showProfilecard();
            }
        };
        $[9] = showProfilecard;
        $[10] = t2;
    } else t2 = $[10];
    const onKeyPress = t2;
    let t3;
    if ($[11] !== showProfilecard) {
        t3 = (event_0)=>{
            event_0.stopPropagation();
            showProfilecard();
        };
        $[11] = showProfilecard;
        $[12] = t3;
    } else t3 = $[12];
    const onClick = t3;
    let t4;
    if ($[13] !== hideProfilecard || $[14] !== onClick || $[15] !== onKeyPress || $[16] !== onMouseEnter || $[17] !== trigger) {
        t4 = trigger === "hover" ? {
            ...(0, $iDrrr.fg)("update_profile_card_to_open_on_mouse_over") ? {
                onMouseOver: onMouseEnter,
                onMouseOut: hideProfilecard
            } : {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard
            },
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        };
        $[13] = hideProfilecard;
        $[14] = onClick;
        $[15] = onKeyPress;
        $[16] = onMouseEnter;
        $[17] = trigger;
        $[18] = t4;
    } else t4 = $[18];
    const containerListeners = t4;
    let t5;
    if ($[19] !== ariaLabelledBy || $[20] !== children || $[21] !== containerListeners || $[22] !== props || $[23] !== ref) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...props,
            ...containerListeners,
            ref: ref,
            "aria-labelledby": ariaLabelledBy,
            children: children
        });
        $[19] = ariaLabelledBy;
        $[20] = children;
        $[21] = containerListeners;
        $[22] = props;
        $[23] = ref;
        $[24] = t5;
    } else t5 = $[24];
    return t5;
} : ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
    // rename to onMouseOver when cleaning up update_profile_card_to_open_on_mouse_over
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $cozmU.useCallback)((event_0)=>{
        // Prevent the click event from propagating to parent containers.
        event_0.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $cozmU.useMemo)(()=>trigger === 'hover' ? {
            ...(0, $iDrrr.fg)('update_profile_card_to_open_on_mouse_over') ? {
                onMouseOver: onMouseEnter,
                onMouseOut: hideProfilecard
            } : {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard
            },
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...props,
        ...containerListeners,
        ref: ref,
        "aria-labelledby": ariaLabelledBy,
        children: children
    });
};
const $d9459e83ce60344e$export$95d4acdbab2fc6ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef($d9459e83ce60344e$var$PopupTriggerInner);
module.exports["PopupTrigger"] = $d9459e83ce60344e$export$95d4acdbab2fc6ef;

});

parcelRegister("2Vosv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $ddd10e9f18035e94$var$styles = {
    wrapper: "_39xV02wBC3"
};
const $ddd10e9f18035e94$export$59abd6feb7dc8540 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $ddd10e9f18035e94$var$styles.wrapper,
            testId: testId,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ddd10e9f18035e94$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["ProfileCardWrapper"] = $ddd10e9f18035e94$export$59abd6feb7dc8540;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6Td9r")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("6Td9r", function(module, exports) {

let $504214b6efe7c58d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $504214b6efe7c58d$var$load("aAJyu"),
    $504214b6efe7c58d$var$load("f8Q8b"),
    $504214b6efe7c58d$var$load("6wr18"),
    $504214b6efe7c58d$var$load("6uvkG"),
    $504214b6efe7c58d$var$load("jqoep"),
    $504214b6efe7c58d$var$load("7EorR"),
    $504214b6efe7c58d$var$load("ea3NB"),
    $504214b6efe7c58d$var$load("ffEVr"),
    $504214b6efe7c58d$var$load("hhss7"),
    $504214b6efe7c58d$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("1EipK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $9DHhW = parcelRequire("9DHhW");


var $cP7Ln = parcelRequire("cP7Ln");


var $jp2Q3 = parcelRequire("jp2Q3");


var $3jT9F = parcelRequire("3jT9F");


var $fWkhK = parcelRequire("fWkhK");

function $af8adcb6f6f86c4a$export$9eae72c857216b70({ children: children, renderTrigger: renderTrigger, trigger: trigger, placement: placement = 'bottom-start', shouldRenderToParent: shouldRenderToParent = false, cloudId: cloudId, hideStarButton: hideStarButton, hideConversationStarters: hideConversationStarters, hideAiDisclaimer: hideAiDisclaimer, onChatClick: onChatClick, onConversationStarterClick: onConversationStarterClick, onViewProfile: onViewProfile, onDuplicate: onDuplicate, onCopyLink: onCopyLink, onEdit: onEdit, onDelete: onDelete, renderCTA: renderCTA, renderMoreActions: renderMoreActions, ...entryPointParams }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const agentAri = 'agentAri' in entryPointParams ? entryPointParams.agentAri : undefined;
    const agentId = 'agentId' in entryPointParams ? entryPointParams.agentId : undefined;
    const identityAccountId = 'identityAccountId' in entryPointParams ? entryPointParams.identityAccountId : undefined;
    const hasAgentRef = agentAri || agentId || identityAccountId;
    const onErrorBoundary = (0, $cozmU.useCallback)((error)=>{
        createAnalyticsEvent({
            action: 'failed',
            actionSubject: 'agentProfileCardWithTrigger',
            eventType: 'operational',
            attributes: {
                source: 'agentProfileCard',
                errorName: error?.name,
                errorMessage: error?.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handlePopupOpen = (0, $cozmU.useCallback)((method)=>{
        createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'agentProfileCardPopup',
            eventType: 'ui',
            attributes: {
                source: 'agentProfileCard',
                triggerMethod: method,
                agentAri: agentAri,
                agentId: agentId,
                identityAccountId: identityAccountId
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        agentAri,
        agentId,
        identityAccountId
    ]);
    const handlePopupClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'agentProfileCardPopup',
            eventType: 'ui',
            attributes: {
                source: 'agentProfileCard',
                agentAri: agentAri,
                agentId: agentId,
                identityAccountId: identityAccountId
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        agentAri,
        agentId,
        identityAccountId
    ]);
    if (!entryPointParams || !cloudId || !hasAgentRef) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: children
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cP7Ln.PopupTriggerWithHover), {
            entryPoint: (0, $3jT9F.agentProfileCardEntryPoint),
            placement: placement,
            fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fWkhK.AgentProfileCardSkeleton), {}),
            entryPointParams: {
                ...entryPointParams,
                cloudId: cloudId
            },
            entryPointProps: {
                cloudId: cloudId,
                identityAccountId: identityAccountId,
                hideStarButton: hideStarButton,
                hideConversationStarters: hideConversationStarters,
                hideAiDisclaimer: hideAiDisclaimer,
                onChatClick: onChatClick,
                onConversationStarterClick: onConversationStarterClick,
                onViewProfile: onViewProfile,
                onDuplicate: onDuplicate,
                onCopyLink: onCopyLink,
                onEdit: onEdit,
                onDelete: onDelete,
                renderCTA: renderCTA,
                renderMoreActions: renderMoreActions
            },
            shouldRenderToParent: shouldRenderToParent,
            shouldUseCaptureOnOutsideClick: true,
            zIndex: (0, $jp2Q3.layers).modal(),
            triggerMode: trigger,
            onOpen: handlePopupOpen,
            onClose: handlePopupClose,
            trigger: (triggerProps)=>renderTrigger ? renderTrigger(triggerProps) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    ...triggerProps,
                    children: children
                })
        })
    });
}
module.exports["AgentProfileCardWithTrigger"] = $af8adcb6f6f86c4a$export$9eae72c857216b70;

});

parcelRegister("iscQS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eLMCt = parcelRequire("eLMCt");


var $hpnSx = parcelRequire("hpnSx");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $5Sv3D = parcelRequire("5Sv3D");


var $cXtTj = parcelRequire("cXtTj");


var $gFEZF = parcelRequire("gFEZF");


var $jC4nA = parcelRequire("jC4nA");


var $fHs3z = parcelRequire("fHs3z");


var $gC2EJ = parcelRequire("gC2EJ");


var $a1ZzW = parcelRequire("a1ZzW");


var $hAgam = parcelRequire("hAgam");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $chu6R = parcelRequire("chu6R");


var $d2UzA = parcelRequire("d2UzA");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $88DFk = parcelRequire("88DFk");


var $hu1eo = parcelRequire("hu1eo");


var $34cCm = parcelRequire("34cCm");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $isp1U = parcelRequire("isp1U");


var $bGNkz = parcelRequire("bGNkz");


var $1Rgab = parcelRequire("1Rgab");


var $jW2nL = parcelRequire("jW2nL");


var $87k0g = parcelRequire("87k0g");


var $dftWP = parcelRequire("dftWP");


var $d5gEx = parcelRequire("d5gEx");


var $awacD = parcelRequire("awacD");


var $bpVtj = parcelRequire("bpVtj");


var $5bVzv = parcelRequire("5bVzv");


var $3z1p5 = parcelRequire("3z1p5");


var $dohLu = parcelRequire("dohLu");


var $eP6A1 = parcelRequire("eP6A1");


var $fa8WQ = parcelRequire("fa8WQ");


var $krDOv = parcelRequire("krDOv");


var $jYv0Q = parcelRequire("jYv0Q");


var $boPeU = parcelRequire("boPeU");

const $f92e3ce7a1107676$var$MAX_AGENT_ITEMS = 6;
const $f92e3ce7a1107676$export$cd3e9a0593d96852 = {
    startCursor: undefined,
    endCursor: undefined,
    hasNextPage: false,
    hasPreviousPage: false
};
const $f92e3ce7a1107676$var$styles = {
    agentsSection: "_2mHwu8FQfX _39xV02N91d _0NUa3rrtRL _2WAcuGIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    searchInputContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0Of8r21Y8M _1ZnuxbgVvo _1wydGW2ADO _2Zuz6QgVvo _0aFT5vbt8w _4xdlr0FlnN",
    loadingStateContainer: "_4c065U2ADO _3iDTPbQ4SZ _37wbyuDIqT",
    createAgentContainer: "_39xV02N91d"
}; // need specific styling for Textfield to match design
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $f92e3ce7a1107676$var$TextfieldInputWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_33a8lP8fU6 _4g2LmmOeNX _3KML0qUofl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_33a8lP8fU6 _4g2LmmOeNX _3KML0qUofl",
            __cmplp.className
        ])
    });
});
const $f92e3ce7a1107676$export$fdadd84869ccd8f5 = ({ selectedAgent: selectedAgent, isAgentDropdownOpen: isAgentDropdownOpen, setIsAgentDropdownOpen: setIsAgentDropdownOpen, trigger: trigger, placement: placement, shouldRenderToParent: shouldRenderToParent, onClose: onClose, siteId: siteId, createConversationOptimistically: createConversationOptimistically, assistanceServiceParams: assistanceServiceParams, touchpointSource: touchpointSource = 'agent-menu', autofocus: inputAutoFocus, onBrowseAgentClick: onBrowseAgentClick, defaultAgents: defaultAgents, onAgentSelect: onAgentSelect, onAgentFavouriteToggle: onAgentFavouriteToggle, showBrowseAgents: showBrowseAgents = true, showCreateAgent: showCreateAgent = true, showSearchAgents: showSearchAgents = true })=>{
    (0, $6cFsl.di)((0, $bGNkz.useUIStoreActions), (0, $bpVtj.useUserSitePermissions), (0, $awacD.useAgentPermissions), (0, $3z1p5.useRecommendedAgents), (0, $3z1p5.usePaginatedAgentsByCategory), (0, $3z1p5.usePaginatedAgentsActions), (0, $3z1p5.useAgentsPaginatedActionsWithOptimistic)); /* eslint-disable-next-line @atlaskit/platform/use-recommended-utils */ 
    const ntpAgentsDropdownTreatment = (0, $cXtTj.default).getExperimentValue('rovo_extension_ntp_agents_dropdown', 'treatment', 'control', {
        fireExperimentExposure: false
    });
    const isComboBoxEnabled = ntpAgentsDropdownTreatment !== 'control';
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [rovoAgentCSID, { trackCreateSessionStart: trackCreateSessionStart }] = (0, $88DFk.useRovoAgentCreateAnalytics)({
        touchPoint: touchpointSource,
        selectedAgentId: selectedAgent?.id
    });
    const { email: email } = (0, $isp1U.useProfileController)();
    const [inputValue, setInputValue] = (0, $cozmU.useState)('');
    const [searchValue, setSearchValue] = (0, $cozmU.useState)(''); // for showing tooltip when agent link is copied
    const [isAgentLinkCopied, setIsAgentLinkCopied] = (0, $cozmU.useState)(false);
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const { onCopyAgent: onCopyAgent, onEditAgent: onEditAgent, onViewAgentFullProfile: onViewAgentFullProfile } = (0, $5bVzv.useAgentUrlActions)({
        siteId: siteId,
        source: touchpointSource
    });
    const { isAbleToCreateAgents: isAbleToCreateAgents, isFetchingPermissions: isFetchingPermissions } = (0, $bpVtj.useUserSitePermissions)({
        siteId: siteId,
        touchpointSource: touchpointSource
    });
    const { data: agentPermissions, isFetching: isFetchingAgentPermissions } = (0, $awacD.useAgentPermissions)({
        agentId: selectedAgent?.id ?? '',
        enabled: !!selectedAgent,
        assistanceServiceParams: assistanceServiceParams
    });
    const { isFetching: isFetching, recommendedAgents: recommendedAgents } = (0, $3z1p5.useRecommendedAgents)({
        assistanceServiceParams: assistanceServiceParams,
        pageUrl: window.location.href
    });
    const { fetchAgentsByCategory: fetchAgentsByCategory, populateAgentCategories: populateAgentCategories } = (0, $3z1p5.usePaginatedAgentsActions)({
        assistanceServiceParams: assistanceServiceParams
    });
    const fetchAgentsByCategoryRef = (0, $cozmU.useRef)(fetchAgentsByCategory);
    (0, $cozmU.useEffect)(()=>{
        fetchAgentsByCategoryRef.current = fetchAgentsByCategory;
    }, [
        fetchAgentsByCategory
    ]);
    const { setFavouriteAgent: setFavouriteAgent, setVerifiedAgent: setVerifiedAgent } = (0, $3z1p5.useAgentsPaginatedActionsWithOptimistic)({
        assistanceServiceParams: assistanceServiceParams
    });
    const [{ agentsByCategory: agentsByCategoryAllAgents, isCategoryLoading: isCategoryLoadingAllAgents, nextPageCursor: nextPageCursorAllAgents, hasNextPage: hasNextPageAllAgents, agentsError: agentsErrorAllAgents }] = (0, $3z1p5.usePaginatedAgentsByCategory)('all-agents');
    const [{ agentsByCategory: agentsByCategoryFavoriteAgents, isCategoryLoading: isCategoryLoadingFavoriteAgents, isCategoryInitialized: isCategoryInitializedFavoriteAgents }] = (0, $3z1p5.usePaginatedAgentsByCategory)('starred-agents');
    const isVerifiedAgentsEnabled = (0, $iDrrr.fg)('rovo-agent-menu-verified-agents');
    const displayedFavoriteAgents = (0, $cozmU.useMemo)(()=>{
        return agentsByCategoryFavoriteAgents.slice(0, isVerifiedAgentsEnabled ? 3 : 5);
    }, [
        agentsByCategoryFavoriteAgents,
        isVerifiedAgentsEnabled
    ]);
    const [{ agentsByCategory: agentsByCategoryVerifiedAgents, isCategoryLoading: isCategoryLoadingVerifiedAgents, isCategoryInitialized: isCategoryInitializedVerifiedAgents }] = (0, $3z1p5.usePaginatedAgentsByCategory)('verified-agents');
    const displayedVerifiedAgents = (0, $cozmU.useMemo)(()=>{
        return agentsByCategoryVerifiedAgents.slice(0, 3);
    }, [
        agentsByCategoryVerifiedAgents
    ]); // clear categories when dropdown closes to avoid stale data flash on reopen
    (0, $cozmU.useEffect)(()=>{
        if (!isAgentDropdownOpen) {
            populateAgentCategories({
                category: 'starred-agents',
                agentsList: [],
                pageInfo: $f92e3ce7a1107676$export$cd3e9a0593d96852
            });
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: $f92e3ce7a1107676$export$cd3e9a0593d96852
            });
            populateAgentCategories({
                category: 'verified-agents',
                agentsList: [],
                pageInfo: $f92e3ce7a1107676$export$cd3e9a0593d96852
            });
        }
    }, [
        isAgentDropdownOpen,
        populateAgentCategories
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isAgentDropdownOpen) return;
        if (!searchValue) {
            fetchAgentsByCategoryRef.current({
                category: 'starred-agents',
                query: ''
            });
            if (isVerifiedAgentsEnabled) fetchAgentsByCategoryRef.current({
                category: 'verified-agents',
                query: ''
            });
        }
        fetchAgentsByCategoryRef.current({
            category: 'all-agents',
            query: searchValue
        });
    }, [
        isAgentDropdownOpen,
        searchValue,
        isVerifiedAgentsEnabled
    ]);
    const handleFavouriteAgent = (0, $cozmU.useCallback)(async (targetAgent, source)=>{
        if (!targetAgent) return;
        const isFavorited = !targetAgent.favourite;
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'browseAgentsFavoriteAgentButton',
            attributes: {
                interactionSource: touchpointSource,
                menuItemType: source,
                isFavorited: isFavorited,
                agentId: targetAgent.id
            }
        });
        onAgentFavouriteToggle?.({
            ...targetAgent,
            favourite: isFavorited
        });
        await setFavouriteAgent(targetAgent.id, isFavorited);
    }, [
        setFavouriteAgent,
        sendAnalyticsEvent,
        touchpointSource,
        onAgentFavouriteToggle
    ]); /**
                                                                                          * Function that updates the verified status of an agent.
                                                                                          * This can be removed once the dropdown has converted over to relay.
                                                                                          */ 
    const handleVerifyAgent = (0, $cozmU.useCallback)((targetAgent_0, verified)=>{
        setVerifiedAgent(targetAgent_0.id, verified);
    }, [
        setVerifiedAgent
    ]);
    const handleLoadMore = (0, $cozmU.useCallback)(async ()=>{
        // Don't load more if already loading, no next page, or there's an error
        if (isCategoryLoadingAllAgents || !hasNextPageAllAgents || agentsErrorAllAgents) return;
        await fetchAgentsByCategory({
            category: 'all-agents',
            query: searchValue,
            after: nextPageCursorAllAgents
        });
    }, [
        searchValue,
        fetchAgentsByCategory,
        isCategoryLoadingAllAgents,
        hasNextPageAllAgents,
        nextPageCursorAllAgents,
        agentsErrorAllAgents
    ]);
    const loadMoreRefCallback = (0, $dohLu.useInfiniteScroll)({
        onScrollTo: ()=>{
            handleLoadMore();
        }
    });
    const [debouncedSearch] = (0, $5Sv3D.default)((value)=>{
        setSearchValue(value);
        sendAnalyticsEvent({
            action: 'searched',
            actionSubject: 'input',
            actionSubjectId: 'browseAgentsSearchInput',
            attributes: {
                interactionSource: touchpointSource,
                searchValueLength: value.length
            }
        });
        setComboBoxFocused(-1);
    }, 800);
    const handleCopy = (0, $cozmU.useCallback)((agent)=>{
        onCopyAgent({
            agentId: agent.id,
            agentIdentityAccountId: agent.identity_account_id
        });
        setIsAgentLinkCopied(true);
        setTimeout(()=>{
            setIsAgentLinkCopied(false);
        }, 2000);
    }, [
        onCopyAgent
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'browseAgentsCreateAgentButton',
            attributes: {
                interactionSource: touchpointSource
            }
        });
        (0, $iDrrr.fg)('rovo-agents-universal-analytics') && trackCreateSessionStart();
        window.open((0, $fa8WQ.getAtlassianStudioNLCreateUrl)(siteId, touchpointSource, rovoAgentCSID, email), '_blank');
    }, [
        siteId,
        sendAnalyticsEvent,
        touchpointSource,
        trackCreateSessionStart,
        rovoAgentCSID,
        email
    ]);
    const handleSelectAgent = (0, $cozmU.useCallback)((agent_0)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'browseAgentsSelectAgentOption',
            attributes: {
                interactionSource: touchpointSource,
                agentId: agent_0?.id,
                isDefaultAgent: !agent_0 // true indicates 'Chat with Rovo' was clicked
            }
        });
        if (onAgentSelect) onAgentSelect(agent_0);
        else createConversationOptimistically({
            sourceAgentId: agent_0?.id
        });
        setIsAgentDropdownOpen(false);
    }, [
        createConversationOptimistically,
        onAgentSelect,
        setIsAgentDropdownOpen,
        sendAnalyticsEvent,
        touchpointSource
    ]);
    const handleBrowseAgentClicked = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'browseAgentsNavigate',
            attributes: {
                interactionSource: touchpointSource
            }
        });
        if (onBrowseAgentClick) onBrowseAgentClick();
        else setActiveMenu('agents');
    }, [
        setActiveMenu,
        onBrowseAgentClick,
        sendAnalyticsEvent,
        touchpointSource
    ]);
    const displayedAgents = (0, $cozmU.useMemo)(()=>{
        // active search, show favorites + all (no recommended, no defaultAgents)
        if (searchValue) return (0, $eP6A1.getDisplayedAgents)({
            recommendedAgents: [],
            agentsByCategoryAllAgents: agentsByCategoryAllAgents,
            agentsByCategoryFavoriteAgents: [],
            agentsByCategoryVerifiedAgents: [],
            selectedAgent: selectedAgent
        });
         // empty search, show default agents + favorite agents + verified agents + all agents + recommended agents
        if (!isCategoryInitializedFavoriteAgents || isVerifiedAgentsEnabled && !isCategoryInitializedVerifiedAgents) // wait for favorites and verified agents to be initialized so we don't have visual layout shift
        return [];
        return (0, $eP6A1.getDisplayedAgents)({
            recommendedAgents: recommendedAgents,
            agentsByCategoryAllAgents: agentsByCategoryAllAgents,
            agentsByCategoryFavoriteAgents: displayedFavoriteAgents,
            agentsByCategoryVerifiedAgents: isVerifiedAgentsEnabled ? displayedVerifiedAgents : [],
            selectedAgent: selectedAgent,
            defaultAgents: defaultAgents
        });
    }, [
        displayedFavoriteAgents,
        displayedVerifiedAgents,
        recommendedAgents,
        agentsByCategoryAllAgents,
        selectedAgent,
        searchValue,
        isCategoryInitializedFavoriteAgents,
        defaultAgents,
        isCategoryInitializedVerifiedAgents,
        isVerifiedAgentsEnabled
    ]);
    const { inputProps: comboBoxInputProps, listBoxProps: comboBoxListBoxProps, getOptionProps: getComboBoxOptionProps, focusedIndex: comboBoxFocusedIndex, setFocused: setComboBoxFocused } = (0, $boPeU.useAgentMenuComboBox)({
        items: displayedAgents,
        isOpen: isAgentDropdownOpen,
        onSelect: handleSelectAgent,
        onClose: onClose,
        enabled: isComboBoxEnabled
    });
    const textFieldComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f92e3ce7a1107676$var$styles.searchInputContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f92e3ce7a1107676$var$TextfieldInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        value: inputValue,
        onChange: (e)=>{
            const newValue = e.currentTarget.value;
            setInputValue(newValue);
            debouncedSearch(newValue);
        },
        placeholder: formatMessage((0, $jYv0Q.default).searchPlaceholder),
        "aria-label": formatMessage((0, $jYv0Q.default).searchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        autoFocus: inputAutoFocus,
        ...comboBoxInputProps
    })));
    const agentsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f92e3ce7a1107676$var$styles.agentsSection,
        as: "ul",
        ...comboBoxListBoxProps
    }, displayedAgents.map((agent_1, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: agent_1.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $krDOv.AgentMenuItem), {
            agent: agent_1,
            renderImmediately: index < $f92e3ce7a1107676$var$MAX_AGENT_ITEMS,
            isSelected: selectedAgent ? agent_1.id === selectedAgent.id : false,
            onSelect: handleSelectAgent,
            onFavoriteToggle: (agent_2)=>handleFavouriteAgent(agent_2, 'agent-menu-item'),
            comboBoxOptionProps: getComboBoxOptionProps(index),
            isFocused: isComboBoxEnabled ? comboBoxFocusedIndex === index : undefined
        }))), (isFetching || isCategoryLoadingAllAgents || isCategoryLoadingFavoriteAgents || isVerifiedAgentsEnabled && isCategoryLoadingVerifiedAgents) && Array(Math.max(0, $f92e3ce7a1107676$var$MAX_AGENT_ITEMS - displayedAgents.length)).fill(null).map((_, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: index_0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34cCm.AgentMenuItemSkeleton), {
            index: index_0
        }))), hasNextPageAllAgents && !agentsErrorAllAgents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: loadMoreRefCallback,
        xcss: $f92e3ce7a1107676$var$styles.loadingStateContainer
    }, isCategoryLoadingAllAgents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), {
        size: "xsmall"
    }))));
    const createAgentComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f92e3ce7a1107676$var$styles.createAgentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $jYv0Q.default).createButtonDisabledTooltip),
        canAppear: ()=>!isAbleToCreateAgents && !isFetchingPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
        label: formatMessage((0, $jYv0Q.default).createAgent),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }),
        onClick: handleCreateAgent,
        isLoading: isFetchingPermissions,
        isDisabled: isFetchingPermissions || !isAbleToCreateAgents,
        isExternalLink: true
    })));
    const sections = [
        {
            items: selectedAgent ? [
                // Hide "Chat with Rovo" when the default Rovo agent (is_default: true)
                // is already present in the defaultAgents list
                ...defaultAgents?.some((agent_3)=>agent_3.is_default) ? [] : [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        label: formatMessage((0, $jYv0Q.default).chatWithRovo),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                            size: "xxsmall"
                        }),
                        onClick: ()=>handleSelectAgent(undefined)
                    })
                ],
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                    label: formatMessage((0, $jYv0Q.default).viewAgentProfile),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                        label: ""
                    }),
                    onClick: ()=>onViewAgentFullProfile(selectedAgent.id)
                }),
                ...!isFetchingAgentPermissions && agentPermissions?.permissions.AGENT_UPDATE?.permitted ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        label: formatMessage((0, $jYv0Q.default).editAgent),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                            label: ""
                        }),
                        onClick: ()=>onEditAgent(selectedAgent.id)
                    })
                ] : [],
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                    label: isAgentLinkCopied ? formatMessage((0, $jYv0Q.default).copyAgentLinkClickedTooltip) : formatMessage((0, $jYv0Q.default).copyLink),
                    icon: isAgentLinkCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: ""
                    }),
                    onClick: ()=>handleCopy(selectedAgent)
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                    label: formatMessage((0, $jYv0Q.default).favoriteAgent),
                    icon: selectedAgent.favourite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                        color: "var(--ds-icon-warning, #E06C00)",
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                        label: ""
                    }),
                    onClick: ()=>handleFavouriteAgent(selectedAgent, 'base-menu-item')
                }),
                ...(0, $iDrrr.fg)('rovo_agents_agent_verification') ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                        fallback: null
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f92e3ce7a1107676$var$AgentMenuVerificationDropdownItem, {
                        agentId: selectedAgent.id,
                        agentAri: selectedAgent.agentAri,
                        cloudId: assistanceServiceParams.siteId,
                        handleVerifyAgent: (verified_0)=>handleVerifyAgent(selectedAgent, verified_0)
                    })))
                ] : []
            ] : []
        },
        ...showSearchAgents ? [
            {
                title: formatMessage((0, $jYv0Q.default).switchAgent),
                items: [
                    textFieldComponent,
                    agentsComponent
                ]
            }
        ] : [],
        {
            items: [
                ...showBrowseAgents ? [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                        label: formatMessage((0, $jYv0Q.default).browseAgents),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)"
                        }),
                        onClick: handleBrowseAgentClicked
                    })
                ] : [],
                ...showCreateAgent ? [
                    createAgentComponent
                ] : []
            ].filter(Boolean)
        }
    ].filter((section)=>section.items.length > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Rgab.ChatHeaderMenu), {
        isOpen: isAgentDropdownOpen,
        placement: placement,
        width: "255px",
        maxWidth: "255px",
        onClose: onClose,
        trigger: trigger,
        sections: sections,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jW2nL.ChatHeaderMenuList), {
            sections: sections
        }),
        popoverAutoFocus: inputAutoFocus ? false : undefined,
        shouldRenderToParent: shouldRenderToParent
    });
};
const $f92e3ce7a1107676$var$AgentMenuVerificationDropdownItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { agentId: agentId, agentAri: agentAriProp, cloudId: cloudId, handleVerifyAgent: handleVerifyAgent } = t0;
    const t1 = Boolean(agentAriProp);
    let t2;
    if ($[0] !== cloudId || $[1] !== t1) {
        t2 = {
            cloudId: cloudId,
            product: "rovo",
            skip: t1
        };
        $[0] = cloudId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const activationResult = (0, $6SsN4.useLazyLoadQuery)((0, $hpnSx.default), t2);
    let t3;
    bb0: {
        if (agentAriProp) {
            t3 = agentAriProp;
            break bb0;
        }
        const activationId = activationResult?.tenantContexts?.[0]?.activationIdByProduct?.active;
        t3 = activationId ? `ari:cloud:rovo::agent/activation/${activationId}/${agentId}` : null;
    }
    const agentAri = t3;
    const t4 = agentAri ?? "";
    const t5 = !agentAri;
    let t6;
    if ($[3] !== cloudId || $[4] !== t4 || $[5] !== t5) {
        t6 = {
            agentAri: t4,
            cloudId: cloudId,
            skip: t5
        };
        $[3] = cloudId;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $eLMCt.default), t6);
    const agentRef = data.agentStudio_agentById;
    const userPermissionsRef = data.atlassianStudio_userSiteContext?.userPermissions;
    if (!agentRef || !userPermissionsRef) return null;
    let t7;
    if ($[7] !== handleVerifyAgent) {
        t7 = (verified)=>handleVerifyAgent(verified);
        $[7] = handleVerifyAgent;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== agentRef || $[10] !== t7 || $[11] !== userPermissionsRef) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu1eo.AgentVerificationDropdownItem), {
            agentRef: agentRef,
            userPermissionsRef: userPermissionsRef,
            onVerificationSuccess: t7,
            renderItem: $f92e3ce7a1107676$var$_temp2
        });
        $[9] = agentRef;
        $[10] = t7;
        $[11] = userPermissionsRef;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : ({ agentId: agentId, agentAri: agentAriProp, cloudId: cloudId, handleVerifyAgent: handleVerifyAgent })=>{
    // TODO: Replace this activation query + ARI construction with useResolveAgentAri from controllers/agent-ari
    // Step 1: Get activation ID if we don't have agentAri
    const activationResult = (0, $6SsN4.useLazyLoadQuery)((0, $hpnSx.default), {
        cloudId: cloudId,
        product: 'rovo',
        skip: Boolean(agentAriProp) // skip if we already have agentAri
    }); // Step 2: Construct agentAri from activation ID + agentId, or use provided agentAri
    const agentAri = (0, $cozmU.useMemo)(()=>{
        if (agentAriProp) return agentAriProp;
        const activationId = activationResult?.tenantContexts?.[0]?.activationIdByProduct?.active;
        return activationId ? `ari:cloud:rovo::agent/activation/${activationId}/${agentId}` : null;
    }, [
        agentAriProp,
        activationResult,
        agentId
    ]); // Step 3: Fetch agent data using the agentAri
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $eLMCt.default), {
        agentAri: agentAri ?? '',
        cloudId: cloudId,
        skip: !agentAri // skip if we couldn't construct agentAri
    });
    const agentRef = data.agentStudio_agentById;
    const userPermissionsRef = data.atlassianStudio_userSiteContext?.userPermissions;
    if (!agentRef || !userPermissionsRef) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu1eo.AgentVerificationDropdownItem), {
        agentRef: agentRef,
        userPermissionsRef: userPermissionsRef,
        onVerificationSuccess: (verified)=>handleVerifyAgent(verified),
        renderItem: ({ labelText: labelText, isVerified: isVerified, onClick: onClick, isPending: isPending })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                label: labelText,
                onClick: isPending ? ()=>null : onClick,
                isLoading: isPending,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                    color: isVerified ? "var(--ds-icon-accent-blue, #357DE8)" : undefined,
                    label: ""
                })
            })
    });
};
function $f92e3ce7a1107676$var$_temp() {
    return null;
}
function $f92e3ce7a1107676$var$_temp2(t0) {
    const { labelText: labelText, isVerified: isVerified, onClick: onClick, isPending: isPending } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
        label: labelText,
        onClick: isPending ? $f92e3ce7a1107676$var$_temp : onClick,
        isLoading: isPending,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: isVerified ? "var(--ds-icon-accent-blue, #357DE8)" : undefined,
            label: ""
        })
    });
}
module.exports["EMPTY_PAGE_INFO"] = $f92e3ce7a1107676$export$cd3e9a0593d96852;
module.exports["AgentMenu"] = $f92e3ce7a1107676$export$fdadd84869ccd8f5;

});

parcelRegister("eLMCt", function(module, exports) {
/**
 * @generated SignedSource<<5656f9cf44bedf2d0ea0ce5954bf0d8a>>
 * @relayHash 14f89ba2d6f0af29699c92366ec6237b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2566183bb10f0288bc20ded5f54afacf2e47a389da7e7aab1371cde72a83988
const $987a76658cf98ad8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "agentAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentMenuVerificationDropdownItemQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef"
                                }
                            ]
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianStudio_userSiteContext",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "AtlassianStudioUserProductPermissions",
                                            "kind": "LinkedField",
                                            "name": "userPermissions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AtlassianStudioUserSiteContextOutput"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentMenuVerificationDropdownItemQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVerified"
                                        }
                                    ],
                                    "type": "AgentStudioAssistant"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianStudio_userSiteContext",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "AtlassianStudioUserProductPermissions",
                                            "kind": "LinkedField",
                                            "name": "userPermissions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAbleToGovernAgents"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AtlassianStudioUserSiteContextOutput"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f2566183bb10f0288bc20ded5f54afacf2e47a389da7e7aab1371cde72a83988",
            "metadata": {},
            "name": "agentMenuVerificationDropdownItemQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$987a76658cf98ad8$var$node.hash = "825bd78a1fc122e2597a01b6fa038a20";
var $987a76658cf98ad8$export$2e2bcd8739ae039 = $987a76658cf98ad8$var$node;
module.exports["default"] = $987a76658cf98ad8$export$2e2bcd8739ae039;

});

parcelRegister("hpnSx", function(module, exports) {
/**
 * @generated SignedSource<<af4dd5cab78570395df5268f6d43053f>>
 * @relayHash 00183e3794ce9ff0eeb9c761070bca7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa25187ac4c98f9510c7a5764fa8e1a4dc35ff0593f08df4bfb2db3c1f72711c
const $97936c9bf1fa64f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "product",
                                    "variableName": "product"
                                }
                            ],
                            "concreteType": "TenantContextActivationId",
                            "kind": "LinkedField",
                            "name": "activationIdByProduct",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "active"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentMenuVerificationDropdownItemQuery_activationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentMenuVerificationDropdownItemQuery_activationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "fa25187ac4c98f9510c7a5764fa8e1a4dc35ff0593f08df4bfb2db3c1f72711c",
            "metadata": {},
            "name": "agentMenuVerificationDropdownItemQuery_activationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97936c9bf1fa64f9$var$node.hash = "fc36e73c50318e24e1dbbb48c3d00068";
var $97936c9bf1fa64f9$export$2e2bcd8739ae039 = $97936c9bf1fa64f9$var$node;
module.exports["default"] = $97936c9bf1fa64f9$export$2e2bcd8739ae039;

});

parcelRegister("hu1eo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $clSfR = parcelRequire("clSfR");


var $61aCN = parcelRequire("61aCN");


var $8zVra = parcelRequire("8zVra");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $is1T6 = parcelRequire("is1T6");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $chu6R = parcelRequire("chu6R");


var $iA8l9 = parcelRequire("iA8l9");


var $8SBHF = parcelRequire("8SBHF");

const $99fa02db3fc77d5f$export$1aae9e11262efee1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { agentRef: agentRef, userPermissionsRef: userPermissionsRef, onClick: onClick, onVerificationSuccess: onVerificationSuccess, testId: testId, renderItem: renderItem } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const agentData = (0, $6SsN4.useFragment)((0, $8zVra.default), agentRef);
    const userPermissions = (0, $6SsN4.useFragment)((0, $61aCN.default), userPermissionsRef);
    const isAbleToGovernAgents = userPermissions?.isAbleToGovernAgents ?? false;
    const isVerified = agentData?.isVerified ?? false;
    const agentId = agentData?.id;
    let t1;
    if ($[0] !== agentId || $[1] !== isAbleToGovernAgents) {
        t1 = {
            touchPoint: "agent-verification-dropdown-item",
            agentId: agentId,
            isAbleToGovernAgents: isAbleToGovernAgents
        };
        $[0] = agentId;
        $[1] = isAbleToGovernAgents;
        $[2] = t1;
    } else t1 = $[2];
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)(t1);
    const [commitUpdateVerification, isPending] = (0, $6SsN4.useMutation)((0, $clSfR.default));
    let t2;
    if ($[3] !== formatMessage || $[4] !== showFlag) {
        t2 = (verified, errorMessage)=>{
            showFlag({
                title: formatMessage(verified ? (0, $8SBHF.default).verifyErrorTitle : (0, $8SBHF.default).unverifyErrorTitle),
                description: formatMessage((0, $8SBHF.default).errorDescription, {
                    errorMessage: errorMessage
                }),
                appearance: "error",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    spacing: "spacious",
                    label: ""
                })
            });
        };
        $[3] = formatMessage;
        $[4] = showFlag;
        $[5] = t2;
    } else t2 = $[5];
    const handleError = t2;
    let t3;
    if ($[6] !== agentId || $[7] !== commitUpdateVerification || $[8] !== formatMessage || $[9] !== handleError || $[10] !== onClick || $[11] !== onVerificationSuccess || $[12] !== showFlag || $[13] !== trackAgentEvent) {
        t3 = (verified_0)=>{
            if (!agentId) return;
            onClick?.();
            commitUpdateVerification({
                variables: {
                    id: agentId,
                    verified: verified_0
                },
                onCompleted: (response)=>{
                    const payload = response?.agentStudio_updateAgentVerification;
                    if (payload?.success) {
                        onVerificationSuccess?.(verified_0);
                        trackAgentEvent({
                            action: verified_0 ? "verify" : "unverify",
                            actionSubject: "rovoAgent",
                            attributes: {}
                        });
                        showFlag({
                            title: formatMessage(verified_0 ? (0, $8SBHF.default).verifySuccessTitle : (0, $8SBHF.default).unverifySuccessTitle),
                            appearance: "success",
                            isAutoDismiss: true,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                                spacing: "spacious",
                                label: ""
                            })
                        });
                    } else {
                        const errorMessage_0 = payload?.errors?.[0]?.message;
                        if (errorMessage_0) {
                            trackAgentEvent({
                                action: verified_0 ? "verify" : "unverify",
                                actionSubject: "rovoAgentError",
                                attributes: {
                                    agentId: agentId,
                                    error: {
                                        message: errorMessage_0
                                    }
                                }
                            });
                            handleError(verified_0, errorMessage_0);
                        }
                    }
                },
                onError: (error)=>{
                    trackAgentEvent({
                        action: verified_0 ? "verify" : "unverify",
                        actionSubject: "rovoAgentError",
                        attributes: {
                            agentId: agentId,
                            error: {
                                message: error.message
                            }
                        }
                    });
                    handleError(verified_0, error.message);
                }
            });
        };
        $[6] = agentId;
        $[7] = commitUpdateVerification;
        $[8] = formatMessage;
        $[9] = handleError;
        $[10] = onClick;
        $[11] = onVerificationSuccess;
        $[12] = showFlag;
        $[13] = trackAgentEvent;
        $[14] = t3;
    } else t3 = $[14];
    const handleUpdateVerification = t3;
    let handleOnClick;
    let labelText;
    let t4;
    if ($[15] !== agentId || $[16] !== formatMessage || $[17] !== handleUpdateVerification || $[18] !== isAbleToGovernAgents || $[19] !== isPending || $[20] !== isVerified || $[21] !== renderItem) {
        t4 = Symbol.for("react.early_return_sentinel");
        bb0: {
            labelText = formatMessage(isVerified ? (0, $8SBHF.default).unverifyAgentLabel : (0, $8SBHF.default).verifyAgentLabel);
            let t5;
            if ($[25] !== handleUpdateVerification || $[26] !== isVerified) {
                t5 = ()=>handleUpdateVerification(!isVerified);
                $[25] = handleUpdateVerification;
                $[26] = isVerified;
                $[27] = t5;
            } else t5 = $[27];
            handleOnClick = t5;
            if (!agentId || !isAbleToGovernAgents) {
                t4 = null;
                break bb0;
            }
            if (renderItem) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderItem({
                    isPending: isPending,
                    isVerified: isVerified,
                    labelText: labelText,
                    onClick: handleOnClick
                }));
                break bb0;
            }
        }
        $[15] = agentId;
        $[16] = formatMessage;
        $[17] = handleUpdateVerification;
        $[18] = isAbleToGovernAgents;
        $[19] = isPending;
        $[20] = isVerified;
        $[21] = renderItem;
        $[22] = handleOnClick;
        $[23] = labelText;
        $[24] = t4;
    } else {
        handleOnClick = $[22];
        labelText = $[23];
        t4 = $[24];
    }
    if (t4 !== Symbol.for("react.early_return_sentinel")) return t4;
    let t5;
    if ($[28] !== handleOnClick || $[29] !== labelText || $[30] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            testId: testId,
            onClick: handleOnClick
        }, labelText);
        $[28] = handleOnClick;
        $[29] = labelText;
        $[30] = testId;
        $[31] = t5;
    } else t5 = $[31];
    return t5;
} : ({ agentRef: agentRef, userPermissionsRef: userPermissionsRef, onClick: onClick, onVerificationSuccess: onVerificationSuccess, testId: testId, renderItem: renderItem })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const agentData = (0, $6SsN4.useFragment)((0, $8zVra.default), agentRef);
    const userPermissions = (0, $6SsN4.useFragment)((0, $61aCN.default), userPermissionsRef);
    const isAbleToGovernAgents = userPermissions?.isAbleToGovernAgents ?? false;
    const isVerified = agentData?.isVerified ?? false;
    const agentId = agentData?.id;
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({
        touchPoint: 'agent-verification-dropdown-item',
        agentId: agentId,
        isAbleToGovernAgents: isAbleToGovernAgents
    });
    const [commitUpdateVerification, isPending] = (0, $6SsN4.useMutation)((0, $clSfR.default));
    const handleError = (0, $cozmU.useCallback)((verified, errorMessage)=>{
        showFlag({
            title: formatMessage(verified ? (0, $8SBHF.default).verifyErrorTitle : (0, $8SBHF.default).unverifyErrorTitle),
            description: formatMessage((0, $8SBHF.default).errorDescription, {
                errorMessage: errorMessage
            }),
            appearance: 'error',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                spacing: "spacious",
                label: ""
            })
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const handleUpdateVerification = (0, $cozmU.useCallback)((verified_0)=>{
        if (!agentId) return;
        onClick?.();
        commitUpdateVerification({
            variables: {
                id: agentId,
                verified: verified_0
            },
            onCompleted: (response)=>{
                const payload = response?.agentStudio_updateAgentVerification;
                if (payload?.success) {
                    onVerificationSuccess?.(verified_0);
                    trackAgentEvent({
                        action: verified_0 ? 'verify' : 'unverify',
                        actionSubject: 'rovoAgent',
                        attributes: {}
                    });
                    showFlag({
                        title: formatMessage(verified_0 ? (0, $8SBHF.default).verifySuccessTitle : (0, $8SBHF.default).unverifySuccessTitle),
                        appearance: 'success',
                        isAutoDismiss: true,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                            spacing: "spacious",
                            label: ""
                        })
                    });
                } else {
                    const errorMessage_0 = payload?.errors?.[0]?.message;
                    if (errorMessage_0) {
                        trackAgentEvent({
                            action: verified_0 ? 'verify' : 'unverify',
                            actionSubject: 'rovoAgentError',
                            attributes: {
                                agentId: agentId,
                                error: {
                                    message: errorMessage_0
                                }
                            }
                        });
                        handleError(verified_0, errorMessage_0);
                    }
                }
            },
            onError: (error)=>{
                trackAgentEvent({
                    action: verified_0 ? 'verify' : 'unverify',
                    actionSubject: 'rovoAgentError',
                    attributes: {
                        agentId: agentId,
                        error: {
                            message: error.message
                        }
                    }
                });
                handleError(verified_0, error.message);
            }
        });
    }, [
        agentId,
        commitUpdateVerification,
        formatMessage,
        handleError,
        onClick,
        onVerificationSuccess,
        showFlag,
        trackAgentEvent
    ]);
    const labelText = formatMessage(isVerified ? (0, $8SBHF.default).unverifyAgentLabel : (0, $8SBHF.default).verifyAgentLabel);
    const handleOnClick = ()=>handleUpdateVerification(!isVerified);
    if (// Don't render if agent ID is not available
    !agentId || // Don't render if user doesn't have permission
    !isAbleToGovernAgents) return null;
    // Use custom render or default to DropdownItem
    if (renderItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderItem({
        isPending: isPending,
        isVerified: isVerified,
        labelText: labelText,
        onClick: handleOnClick
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        testId: testId,
        onClick: handleOnClick
    }, labelText);
};
module.exports["AgentVerificationDropdownItem"] = $99fa02db3fc77d5f$export$1aae9e11262efee1;

});

parcelRegister("clSfR", function(module, exports) {
/**
 * @generated SignedSource<<72cf5b4272bd87e3f60ceea7d096d404>>
 * @relayHash 426410e11638597e4a12069dd5a8be16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3ee432c0fc33e7c2f8bfeac0ba4eaedbab44694541de64c5219ab207398f3c0
const $421081eeed7bbd3a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "verified"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "verified",
            "variableName": "verified"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isVerified"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_updateAgentVerificationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioUpdateAgentVerificationPayload",
                    "kind": "LinkedField",
                    "name": "agentStudio_updateAgentVerification",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "type": "AgentStudioAssistant"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_updateAgentVerificationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioUpdateAgentVerificationPayload",
                    "kind": "LinkedField",
                    "name": "agentStudio_updateAgentVerification",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "AgentStudioAssistant"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e3ee432c0fc33e7c2f8bfeac0ba4eaedbab44694541de64c5219ab207398f3c0",
            "metadata": {},
            "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_updateAgentVerificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$421081eeed7bbd3a$var$node.hash = "215d57ba82c69595cbed5235ec1fec93";
var $421081eeed7bbd3a$export$2e2bcd8739ae039 = $421081eeed7bbd3a$var$node;
module.exports["default"] = $421081eeed7bbd3a$export$2e2bcd8739ae039;

});

parcelRegister("61aCN", function(module, exports) {
/**
 * @generated SignedSource<<2cd48cfc250403043a4faa459ccefe71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dbad3e19b6ccfb7f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isAbleToGovernAgents"
        }
    ],
    "type": "AtlassianStudioUserProductPermissions"
};
$dbad3e19b6ccfb7f$var$node.hash = "5addff9015092fd6e1870a9f51056493";
var $dbad3e19b6ccfb7f$export$2e2bcd8739ae039 = $dbad3e19b6ccfb7f$var$node;
module.exports["default"] = $dbad3e19b6ccfb7f$export$2e2bcd8739ae039;

});

parcelRegister("8zVra", function(module, exports) {
/**
 * @generated SignedSource<<e14499a7efb36d6afac933ab3986b8e1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fdb4b439cc530154$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isVerified"
        }
    ],
    "type": "AgentStudioAssistant"
};
$fdb4b439cc530154$var$node.hash = "176b570bcbf4e92ccef358e70f74443d";
var $fdb4b439cc530154$export$2e2bcd8739ae039 = $fdb4b439cc530154$var$node;
module.exports["default"] = $fdb4b439cc530154$export$2e2bcd8739ae039;

});

parcelRegister("8SBHF", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9bfa5ee66d4443a8$var$message = (0, $kSwu1.defineMessages)({
    verifyAgentLabel: {
        id: "rovo-agent-components.agent-verification-dropdown-item.verify-agent",
        defaultMessage: "Verify agent"
    },
    unverifyAgentLabel: {
        id: "rovo-agent-components.agent-verification-dropdown-item.unverify-agent",
        defaultMessage: "Remove verification"
    },
    verifySuccessTitle: {
        id: "rovo-agent-components.agent-verification-dropdown-item.verify-success-title",
        defaultMessage: "Agent verified"
    },
    unverifySuccessTitle: {
        id: "rovo-agent-components.agent-verification-dropdown-item.unverify-success-title",
        defaultMessage: "Verification removed"
    },
    verifyErrorTitle: {
        id: "rovo-agent-components.agent-verification-dropdown-item.verify-error-title",
        defaultMessage: "Failed to verify agent"
    },
    unverifyErrorTitle: {
        id: "rovo-agent-components.agent-verification-dropdown-item.unverify-error-title",
        defaultMessage: "Failed to remove verification"
    },
    errorDescription: {
        id: "rovo-agent-components.agent-verification-dropdown-item.error-description",
        defaultMessage: "An error occurred while updating agent verification status: {errorMessage}"
    }
});
var $9bfa5ee66d4443a8$export$2e2bcd8739ae039 = $9bfa5ee66d4443a8$var$message;
module.exports["default"] = $9bfa5ee66d4443a8$export$2e2bcd8739ae039;

});

parcelRegister("34cCm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $a9aSv = parcelRequire("a9aSv");


var $bBz57 = parcelRequire("bBz57");

const $bf247d9ac79c8461$var$styles = {
    skeletonContainer: "_2mHwu8gVvo _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $bf247d9ac79c8461$export$b6da7c0687914310 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { index: index, containerHeight: t1, skeletonTextHeight: t2, skeletonTextWidth: t3, skeletonAvatarSize: t4, paddingHorizontal: t5 } = t0;
    const containerHeight = t1 === undefined ? 32 : t1;
    const skeletonTextHeight = t2 === undefined ? 16 : t2;
    const skeletonTextWidth = t3 === undefined ? 170 : t3;
    const skeletonAvatarSize = t4 === undefined ? "small" : t4;
    const paddingHorizontal = t5 === undefined ? "var(--ds-space-075, 6px)" : t5;
    const t6 = `skeleton-container-${index}`;
    const t7 = `skeleton-container-${index}`;
    const t8 = `${containerHeight}px`;
    let t9;
    if ($[0] !== paddingHorizontal || $[1] !== t8) {
        t9 = {
            height: t8,
            paddingLeft: paddingHorizontal,
            paddingRight: paddingHorizontal
        };
        $[0] = paddingHorizontal;
        $[1] = t8;
        $[2] = t9;
    } else t9 = $[2];
    const t10 = `loading-agents-avatar-skeleton-${index}`;
    let t11;
    if ($[3] !== skeletonAvatarSize || $[4] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBz57.AgentAvatarSkeleton), {
            size: skeletonAvatarSize,
            isShimmering: true,
            testId: t10
        });
        $[3] = skeletonAvatarSize;
        $[4] = t10;
        $[5] = t11;
    } else t11 = $[5];
    const t12 = `loading-agents-text-skeleton-${index}`;
    let t13;
    if ($[6] !== skeletonTextHeight || $[7] !== skeletonTextWidth || $[8] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: skeletonTextWidth,
            height: skeletonTextHeight,
            isShimmering: true,
            testId: t12
        });
        $[6] = skeletonTextHeight;
        $[7] = skeletonTextWidth;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    let t14;
    if ($[10] !== t11 || $[11] !== t13 || $[12] !== t6 || $[13] !== t7 || $[14] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: t6,
            testId: t7,
            xcss: $bf247d9ac79c8461$var$styles.skeletonContainer,
            style: t9
        }, t11, t13);
        $[10] = t11;
        $[11] = t13;
        $[12] = t6;
        $[13] = t7;
        $[14] = t9;
        $[15] = t14;
    } else t14 = $[15];
    return t14;
} : ({ index: index, containerHeight: containerHeight = 32, skeletonTextHeight: skeletonTextHeight = 16, skeletonTextWidth: skeletonTextWidth = 170, skeletonAvatarSize: skeletonAvatarSize = 'small', paddingHorizontal: paddingHorizontal = "var(--ds-space-075, 6px)" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: `skeleton-container-${index}`,
        testId: `skeleton-container-${index}`,
        xcss: $bf247d9ac79c8461$var$styles.skeletonContainer,
        style: {
            height: `${containerHeight}px`,
            paddingLeft: paddingHorizontal,
            paddingRight: paddingHorizontal
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBz57.AgentAvatarSkeleton), {
        size: skeletonAvatarSize,
        isShimmering: true,
        testId: `loading-agents-avatar-skeleton-${index}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: skeletonTextWidth,
        height: skeletonTextHeight,
        isShimmering: true,
        testId: `loading-agents-text-skeleton-${index}`
    }));
};
module.exports["AgentMenuItemSkeleton"] = $bf247d9ac79c8461$export$b6da7c0687914310;

});

parcelRegister("bBz57", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ekCm6 = parcelRequire("ekCm6");


var $iMnC5 = parcelRequire("iMnC5");


var $a9aSv = parcelRequire("a9aSv");


var $6gGPb = parcelRequire("6gGPb");

const $f4d5abc87c793cfd$export$e8405b9eeccf0a24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { size: t1, isShimmering: t2, color: color, shimmeringEndColor: shimmeringEndColor, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const isShimmering = t2 === undefined ? true : t2;
    const t3 = (0, $ekCm6.AVATAR_SIZES)[size];
    const t4 = (0, $ekCm6.AVATAR_SIZES)[size];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = {
            width: t3,
            height: t4,
            clipPath: (0, $6gGPb.AGENT_AVATAR_CLIP_PATH)
        };
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = testId ? `${testId}-wrapper` : "agent-avatar-skeleton-wrapper";
    const t7 = testId ?? "agent-avatar-skeleton";
    let t8;
    if ($[3] !== color || $[4] !== isShimmering || $[5] !== shimmeringEndColor || $[6] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "100%",
            borderRadius: 0,
            isShimmering: isShimmering,
            color: color,
            ShimmeringEndColor: shimmeringEndColor,
            testId: t7
        });
        $[3] = color;
        $[4] = isShimmering;
        $[5] = shimmeringEndColor;
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t5 || $[9] !== t6 || $[10] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            style: t5,
            testId: t6
        }, t8);
        $[8] = t5;
        $[9] = t6;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ size: size = 'medium', isShimmering: isShimmering = true, color: color, shimmeringEndColor: shimmeringEndColor, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-unsafe-values
            clipPath: (0, $6gGPb.AGENT_AVATAR_CLIP_PATH)
        },
        testId: testId ? `${testId}-wrapper` : 'agent-avatar-skeleton-wrapper'
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "100%",
        borderRadius: 0,
        isShimmering: isShimmering,
        color: color,
        ShimmeringEndColor: shimmeringEndColor,
        testId: testId ?? 'agent-avatar-skeleton'
    }));
};
module.exports["AgentAvatarSkeleton"] = $f4d5abc87c793cfd$export$e8405b9eeccf0a24;

});

parcelRegister("awacD", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $9bef8196ccf4a57b$export$be862330bf692bad = (0, $lJ6db.createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const query = (0, $5SS4O.useQuery)({
        queryKey: [
            'getAgentPermissions',
            agentId
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).GET_AGENT_PERMISSIONS,
                name: (0, $irnO2.ExperienceName).GET_AGENT_PERMISSIONS
            });
            return await assistanceService.getAgentPermissions(agentId, {
                permission_ids: [
                    'AGENT_CREATE',
                    'AGENT_UPDATE',
                    'AGENT_DELETE',
                    'AGENT_DEACTIVATE',
                    'AGENT_READ'
                ]
            });
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).GET_AGENT_PERMISSIONS
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).GET_AGENT_PERMISSIONS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: enabled
    });
    return query;
});
module.exports["useAgentPermissions"] = $9bef8196ccf4a57b$export$be862330bf692bad;

});

parcelRegister("dohLu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $6bf10d8c635b0451$export$a973cef5093a8d22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInfiniteScroll(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { onScrollTo: onScrollTo } = t0;
    const observerRef = (0, $cozmU.useRef)(null);
    const onScrollToRef = (0, $cozmU.useRef)(onScrollTo);
    const currentNodeRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (loadMoreEntry)=>{
            if (loadMoreEntry.length > 1) loadMoreEntry.shift();
            if (loadMoreEntry?.[0]?.isIntersecting) onScrollToRef.current();
        };
        $[0] = t1;
    } else t1 = $[0];
    const fetchMoreCallback = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (node)=>{
            const prevNode = currentNodeRef.current;
            const observer = observerRef.current;
            currentNodeRef.current = node;
            if (!observer) return;
            if (prevNode) observer.unobserve(prevNode);
            if (node) observer.observe(node);
        };
        $[1] = t2;
    } else t2 = $[1];
    const loadMoreRefCallback = t2;
    let t3;
    let t4;
    if ($[2] !== onScrollTo) {
        t3 = ()=>{
            onScrollToRef.current = onScrollTo;
        };
        t4 = [
            onScrollTo
        ];
        $[2] = onScrollTo;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            observerRef.current = new IntersectionObserver(fetchMoreCallback);
            if (currentNodeRef.current) observerRef.current.observe(currentNodeRef.current);
            return ()=>{
                if (observerRef.current) observerRef.current.disconnect();
            };
        };
        t6 = [
            fetchMoreCallback
        ];
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    (0, $cozmU.useEffect)(t5, t6);
    return loadMoreRefCallback;
} : function useInfiniteScroll({ onScrollTo: onScrollTo }) {
    const observerRef = (0, $cozmU.useRef)(null);
    const onScrollToRef = (0, $cozmU.useRef)(onScrollTo);
    const currentNodeRef = (0, $cozmU.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const fetchMoreCallback = (0, $cozmU.useCallback)((loadMoreEntry)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (loadMoreEntry.length > 1) loadMoreEntry.shift();
        if (loadMoreEntry?.[0]?.isIntersecting) onScrollToRef.current();
    }, []);
    const loadMoreRefCallback = (0, $cozmU.useCallback)((node)=>{
        const prevNode = currentNodeRef.current;
        const observer = observerRef.current;
        currentNodeRef.current = node;
        if (!observer) return;
        if (prevNode) observer.unobserve(prevNode);
        if (node) observer.observe(node);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        onScrollToRef.current = onScrollTo;
    }, [
        onScrollTo
    ]);
    (0, $cozmU.useEffect)(()=>{
        observerRef.current = new IntersectionObserver(fetchMoreCallback);
        // If there's already a node stored, observe it now that the observer exists
        if (currentNodeRef.current) observerRef.current.observe(currentNodeRef.current);
        // cleanup on unmount
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, [
        fetchMoreCallback
    ]);
    return loadMoreRefCallback;
};
module.exports["useInfiniteScroll"] = $6bf10d8c635b0451$export$a973cef5093a8d22;

});

parcelRegister("krDOv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $87k0g = parcelRequire("87k0g");


var $eP6A1 = parcelRequire("eP6A1");


var $jQH2T = parcelRequire("jQH2T");

const $f6245d92c2e4c51f$var$styles = {
    container: "_4kiQYAUofl"
};
const $f6245d92c2e4c51f$export$1f77f7ec171b9f24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { agent: agent, isSelected: isSelected, onSelect: onSelect, onFavoriteToggle: onFavoriteToggle, renderImmediately: renderImmediately, comboBoxOptionProps: comboBoxOptionProps, isFocused: isFocused } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            ref: containerRef
        };
        $[0] = t1;
    } else t1 = $[0];
    const { hasBeenInViewport: hasBeenInViewport } = (0, $jQH2T.useInViewport)(t1);
    const shouldRender = renderImmediately || hasBeenInViewport;
    let t2;
    if ($[1] !== agent || $[2] !== isFocused || $[3] !== isSelected || $[4] !== onFavoriteToggle || $[5] !== onSelect || $[6] !== shouldRender) {
        t2 = shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
            label: agent.name,
            icon: (0, $eP6A1.getAgentIcon)(agent),
            onClick: ()=>onSelect(agent),
            isActive: isSelected,
            isFocused: isFocused,
            isFavorite: agent.favourite,
            isVerified: agent.is_verified,
            onFavoriteClick: onFavoriteToggle ? ()=>onFavoriteToggle(agent) : undefined
        });
        $[1] = agent;
        $[2] = isFocused;
        $[3] = isSelected;
        $[4] = onFavoriteToggle;
        $[5] = onSelect;
        $[6] = shouldRender;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== comboBoxOptionProps || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: containerRef,
            xcss: $f6245d92c2e4c51f$var$styles.container,
            ...comboBoxOptionProps
        }, t2);
        $[8] = comboBoxOptionProps;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ agent: agent, isSelected: isSelected, onSelect: onSelect, onFavoriteToggle: onFavoriteToggle, renderImmediately: renderImmediately, comboBoxOptionProps: comboBoxOptionProps, isFocused: isFocused })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const { hasBeenInViewport: hasBeenInViewport } = (0, $jQH2T.useInViewport)({
        ref: containerRef
    }); // Always render the first N items immediately, use viewport check for items beyond that
    const shouldRender = renderImmediately || hasBeenInViewport;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        xcss: $f6245d92c2e4c51f$var$styles.container,
        ...comboBoxOptionProps
    }, shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
        label: agent.name,
        icon: (0, $eP6A1.getAgentIcon)(agent),
        onClick: ()=>onSelect(agent),
        isActive: isSelected,
        isFocused: isFocused,
        isFavorite: agent.favourite,
        isVerified: agent.is_verified,
        onFavoriteClick: onFavoriteToggle ? ()=>onFavoriteToggle(agent) : undefined
    }));
};
module.exports["AgentMenuItem"] = $f6245d92c2e4c51f$export$1f77f7ec171b9f24;

});

parcelRegister("jQH2T", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $87448aeddb9badd2$export$6215040b989f9b0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { ref: ref } = t0;
    const [hasBeenInViewport, setHasBeenInViewport] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new IntersectionObserver((t2)=>{
            const [entry] = t2;
            if (entry.isIntersecting) setHasBeenInViewport(entry.isIntersecting);
        }, {
            rootMargin: "0px 0px 200px 0px"
        });
        $[0] = t1;
    } else t1 = $[0];
    const observer = t1;
    let t2;
    let t3;
    if ($[1] !== ref) {
        t2 = ()=>{
            if (ref.current) {
                observer.observe(ref.current);
                return ()=>observer.disconnect();
            }
        };
        t3 = [
            observer,
            ref
        ];
        $[1] = ref;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] !== hasBeenInViewport) {
        t4 = {
            hasBeenInViewport: hasBeenInViewport
        };
        $[4] = hasBeenInViewport;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ ref: ref })=>{
    const [hasBeenInViewport, setHasBeenInViewport] = (0, $cozmU.useState)(false);
    const observer = (0, $cozmU.useMemo)(()=>new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasBeenInViewport(entry.isIntersecting);
        }, {
            rootMargin: '0px 0px 200px 0px'
        }), []);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) {
            observer.observe(ref.current);
            return ()=>observer.disconnect();
        }
    }, [
        observer,
        ref
    ]);
    return {
        hasBeenInViewport: hasBeenInViewport
    };
};
module.exports["useInViewport"] = $87448aeddb9badd2$export$6215040b989f9b0f;

});

parcelRegister("jYv0Q", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4e32bc20f7b310a5$var$message = (0, $kSwu1.defineMessages)({
    chatWithRovo: {
        id: "ai-mate.chat-header-agent-menu.chat-with-rovo",
        defaultMessage: "Chat with Rovo"
    },
    viewAgentProfile: {
        id: "ai-mate.chat-header-agent-menu.view-agent-profile",
        defaultMessage: "View agent profile"
    },
    editAgent: {
        id: "ai-mate.chat-header-agent-menu.edit-agent",
        defaultMessage: "Edit agent"
    },
    copyLink: {
        id: "ai-mate.chat-header-agent-menu.copy-link",
        defaultMessage: "Copy link"
    },
    switchAgent: {
        id: "ai-mate.chat-header-agent-menu.switch-agent",
        defaultMessage: "Switch to another agent"
    },
    favoriteAgent: {
        id: "ai-mate.chat-header-agent-menu.favorite-agent",
        defaultMessage: "Favorite"
    },
    searchPlaceholder: {
        id: "ai-mate.chat-header-agent-menu.search-placeholder",
        defaultMessage: "Search agents"
    },
    browseAgents: {
        id: "ai-mate.chat-header-agent-menu.browse-agents",
        defaultMessage: "Browse agents"
    },
    createAgent: {
        id: "ai-mate.chat-header-agent-menu.create-agent",
        defaultMessage: "Create agent"
    },
    copyAgentLinkClickedTooltip: {
        id: "ai-mate.chat-header-agent-menu.copy-agent-link-clicked-tooltip",
        defaultMessage: "Link copied!"
    },
    createButtonDisabledTooltip: {
        id: "ai-mate.chat-header-agent-menu.create-button-disabled-tooltip",
        defaultMessage: "You don't have permission to create agents in this site"
    }
});
var $4e32bc20f7b310a5$export$2e2bcd8739ae039 = $4e32bc20f7b310a5$var$message;
module.exports["default"] = $4e32bc20f7b310a5$export$2e2bcd8739ae039;

});

parcelRegister("boPeU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");

/** scrolls just past item to trigger infinite scroll */ function $28897f9f3e5d3969$var$scrollOptionIntoView(optionId) {
    const el = (0, $1hQ0e.getDocument)()?.getElementById(optionId);
    const scrollParent = el?.closest('[role="listbox"]');
    if (!el || !scrollParent) return;
    const elRect = el.getBoundingClientRect();
    const parentRect = scrollParent.getBoundingClientRect();
    const padding = 4;
    if (elRect.bottom + padding > parentRect.bottom) scrollParent.scrollTop += elRect.bottom - parentRect.bottom + padding;
    else if (elRect.top - padding < parentRect.top) scrollParent.scrollTop -= parentRect.top - elRect.top + padding;
}
const $28897f9f3e5d3969$var$emptyProps = {};
const $28897f9f3e5d3969$var$emptyOptionProps = ()=>$28897f9f3e5d3969$var$emptyProps;
function $28897f9f3e5d3969$export$28204977a5737c66({ items: items, isOpen: isOpen, onSelect: onSelect, onClose: onClose, enabled: enabled }) {
    const listBoxId = `agent-menu-listbox`;
    const getOptionId = (index)=>`agent-menu-option-${index}`;
    const [focusedIndex, setFocusedIndex] = (0, $cozmU.useState)(-1);
    const itemsRef = (0, $cozmU.useRef)(items);
    itemsRef.current = items;
    const setFocused = (0, $cozmU.useCallback)((index_0, { scroll: scroll = true } = {})=>{
        setFocusedIndex(index_0);
        if (scroll && index_0 >= 0) requestAnimationFrame(()=>$28897f9f3e5d3969$var$scrollOptionIntoView(getOptionId(index_0)));
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        if (!isOpen) setFocused(-1);
    }, [
        isOpen,
        enabled,
        setFocused
    ]);
    const onKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (!isOpen) return;
        const count = itemsRef.current.length;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                setFocused(Math.min(focusedIndex + 1, count - 1));
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocused(Math.max(focusedIndex - 1, 0));
                break;
            case 'Enter':
                if (focusedIndex >= 0 && focusedIndex < count) {
                    e.preventDefault();
                    onSelect(itemsRef.current[focusedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                e.stopPropagation();
                onClose();
                break;
        }
    }, [
        isOpen,
        focusedIndex,
        onSelect,
        onClose,
        setFocused
    ]);
    if (!enabled) return {
        inputProps: {},
        listBoxProps: {},
        getOptionProps: $28897f9f3e5d3969$var$emptyOptionProps,
        focusedIndex: -1,
        setFocused: ()=>{}
    };
    const activedescendant = focusedIndex >= 0 ? getOptionId(focusedIndex) : undefined;
    const inputProps = {
        role: 'combobox',
        'aria-expanded': isOpen,
        'aria-controls': listBoxId,
        'aria-activedescendant': activedescendant,
        'aria-autocomplete': 'list',
        'aria-haspopup': 'listbox',
        onKeyDown: onKeyDown
    };
    const listBoxProps = {
        role: 'listbox',
        id: listBoxId,
        'aria-label': 'Agents'
    };
    const getOptionProps = (index_1)=>({
            role: 'option',
            id: getOptionId(index_1),
            'aria-selected': focusedIndex === index_1,
            onMouseMove: ()=>setFocused(index_1, {
                    scroll: false
                })
        });
    return {
        inputProps: inputProps,
        listBoxProps: listBoxProps,
        getOptionProps: getOptionProps,
        focusedIndex: focusedIndex,
        setFocused: setFocused
    };
}
module.exports["useAgentMenuComboBox"] = $28897f9f3e5d3969$export$28204977a5737c66;

});

parcelRegister("2yWJZ", function(module, exports) {

var $as9lu = parcelRequire("as9lu");

const $7f640ed30a5677e6$export$d4e191820de5cb9e = 'ai_mate_agent';
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$cf40b355c500b3f7 || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$d4e191820de5cb9e;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $as9lu.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("4Sb8b", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $l2adO = parcelRequire("l2adO");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $arQY7 = parcelRequire("arQY7");


var $4RIpP = parcelRequire("4RIpP");

const $4c6b4f2790a2f9e1$export$4bc8bcb977dc5ae2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(26);
    const { userFragment: userFragment, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, presence: presence, size: size, status: status, stackIndex: stackIndex, tabIndex: tabIndex, target: target, onClick: onClick, testId: testId, analyticsContext: analyticsContext, as: as, imgLoading: imgLoading, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = t0;
    const user = (0, $6SsN4.useFragment)((0, $l2adO.default), userFragment);
    const t1 = user?.appType;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $4RIpP.getAppearanceForAppType)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const appearance = t2;
    const t3 = user?.picture;
    let t4;
    if ($[2] !== analyticsContext || $[3] !== appearance || $[4] !== ariaControls || $[5] !== ariaExpanded || $[6] !== ariaHasPopup || $[7] !== as || $[8] !== borderColor || $[9] !== children || $[10] !== href || $[11] !== imgLoading || $[12] !== isDisabled || $[13] !== label || $[14] !== name || $[15] !== onClick || $[16] !== presence || $[17] !== ref || $[18] !== size || $[19] !== stackIndex || $[20] !== status || $[21] !== t3 || $[22] !== tabIndex || $[23] !== target || $[24] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            ref: ref,
            src: t3,
            appearance: appearance,
            label: label,
            borderColor: borderColor,
            children: children,
            href: href,
            isDisabled: isDisabled,
            name: name,
            presence: presence,
            size: size,
            status: status,
            stackIndex: stackIndex,
            tabIndex: tabIndex,
            target: target,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            as: as,
            imgLoading: imgLoading,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        });
        $[2] = analyticsContext;
        $[3] = appearance;
        $[4] = ariaControls;
        $[5] = ariaExpanded;
        $[6] = ariaHasPopup;
        $[7] = as;
        $[8] = borderColor;
        $[9] = children;
        $[10] = href;
        $[11] = imgLoading;
        $[12] = isDisabled;
        $[13] = label;
        $[14] = name;
        $[15] = onClick;
        $[16] = presence;
        $[17] = ref;
        $[18] = size;
        $[19] = stackIndex;
        $[20] = status;
        $[21] = t3;
        $[22] = tabIndex;
        $[23] = target;
        $[24] = testId;
        $[25] = t4;
    } else t4 = $[25];
    return t4;
} : ({ userFragment: userFragment, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, presence: presence, size: size, status: status, stackIndex: stackIndex, tabIndex: tabIndex, target: target, onClick: onClick, testId: testId, analyticsContext: analyticsContext, as: as, imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const user = (0, $6SsN4.useFragment)((0, $l2adO.default), userFragment);
    const appearance = (0, $4RIpP.getAppearanceForAppType)(user?.appType);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        ref: ref,
        // from relay fragment
        src: user?.picture,
        appearance: appearance,
        // prop-drill from AvatarRelayProps
        label: label,
        borderColor: borderColor,
        children: children,
        href: href,
        isDisabled: isDisabled,
        name: name,
        presence: presence,
        size: size,
        status: status,
        stackIndex: stackIndex,
        tabIndex: tabIndex,
        target: target,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        as: as,
        imgLoading: imgLoading,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup
    });
});
module.exports["AvatarRelay"] = $4c6b4f2790a2f9e1$export$4bc8bcb977dc5ae2;

});

parcelRegister("l2adO", function(module, exports) {
/**
 * @generated SignedSource<<fc353150c45a4f7c6c9094cc1a2d8fa6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c57c68a29a5fd556$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "avatarRelay_user",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appType"
                }
            ],
            "type": "AppUser"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
$c57c68a29a5fd556$var$node.hash = "507292d34580d58c48df1e1edacc7bad";
var $c57c68a29a5fd556$export$2e2bcd8739ae039 = $c57c68a29a5fd556$var$node;
module.exports["default"] = $c57c68a29a5fd556$export$2e2bcd8739ae039;

});

parcelRegister("4RIpP", function(module, exports) {
function $6df6b3770f22c6bb$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'team':
            // @TODO investigate if team comes from appType or if it is a separate way to detect
            return 'square';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}
module.exports["getAppearanceForAppType"] = $6df6b3770f22c6bb$export$6b45b5bd2259198a;

});

parcelRegister("bwd6H", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dcgxm = parcelRequire("dcgxm");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $hlvTd = parcelRequire("hlvTd");


var $33DP2 = parcelRequire("33DP2");

const $1056434c9af235ea$export$f5af161a31162cd6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { agentId: agentId, existingAgentAri: existingAgentAri, cloudId: cloudId } = t0;
    (0, $6cFsl.di)((0, $hlvTd.logException));
    const t1 = Boolean(existingAgentAri);
    let t2;
    if ($[0] !== cloudId || $[1] !== t1) {
        t2 = {
            cloudId: cloudId,
            product: "rovo",
            skip: t1
        };
        $[0] = cloudId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const activationResult = (0, $6SsN4.useLazyLoadQuery)((0, $dcgxm.default), t2);
    let t3;
    bb0: {
        if (existingAgentAri) {
            t3 = existingAgentAri;
            break bb0;
        }
        const activationId = activationResult?.tenantContexts?.[0]?.activationIdByProduct?.active;
        t3 = activationId ? `ari:cloud:rovo::agent/activation/${activationId}/${agentId}` : null;
    }
    const agentAri = t3;
    const hasAgentAri = Boolean(agentAri);
    let t4;
    let t5;
    if ($[3] !== cloudId || $[4] !== existingAgentAri || $[5] !== hasAgentAri) {
        t4 = ()=>{
            if (!hasAgentAri && !existingAgentAri) (0, $hlvTd.logException)({
                exception: new Error("useResolveAgentAri: failed to resolve activation ID"),
                name: "useResolveAgentAri_activationQuery",
                tags: {
                    cloudId: cloudId,
                    teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
                }
            });
        };
        t5 = [
            hasAgentAri,
            existingAgentAri,
            cloudId
        ];
        $[3] = cloudId;
        $[4] = existingAgentAri;
        $[5] = hasAgentAri;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[8] !== agentAri) {
        t6 = {
            agentAri: agentAri
        };
        $[8] = agentAri;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ agentId: agentId, existingAgentAri: existingAgentAri, cloudId: cloudId })=>{
    (0, $6cFsl.di)((0, $hlvTd.logException));
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const activationResult = (0, $6SsN4.useLazyLoadQuery)((0, $dcgxm.default), {
        cloudId: cloudId,
        product: 'rovo',
        skip: Boolean(existingAgentAri)
    });
    const agentAri = (0, $cozmU.useMemo)(()=>{
        if (existingAgentAri) return existingAgentAri;
        const activationId = activationResult?.tenantContexts?.[0]?.activationIdByProduct?.active;
        return activationId ? `ari:cloud:rovo::agent/activation/${activationId}/${agentId}` : null;
    }, [
        existingAgentAri,
        activationResult,
        agentId
    ]);
    const hasAgentAri = Boolean(agentAri);
    (0, $cozmU.useEffect)(()=>{
        if (!hasAgentAri && !existingAgentAri) (0, $hlvTd.logException)({
            exception: new Error('useResolveAgentAri: failed to resolve activation ID'),
            name: 'useResolveAgentAri_activationQuery',
            tags: {
                cloudId: cloudId,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            }
        });
    }, [
        hasAgentAri,
        existingAgentAri,
        cloudId
    ]);
    return {
        agentAri: agentAri
    };
};
module.exports["useResolveAgentAri"] = $1056434c9af235ea$export$f5af161a31162cd6;

});

parcelRegister("dcgxm", function(module, exports) {
/**
 * @generated SignedSource<<894b5effe6d2369bc35d3ba530af1593>>
 * @relayHash d97baaf1b286a0fcc2e70d29590b878e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 771d1deabc796152bf24ecf54c094188e18e01c4e9c58604be9db5c1635866ca
const $55f4b18ecdbb4102$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "product",
                                    "variableName": "product"
                                }
                            ],
                            "concreteType": "TenantContextActivationId",
                            "kind": "LinkedField",
                            "name": "activationIdByProduct",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "active"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentAri_activationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentAri_activationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "771d1deabc796152bf24ecf54c094188e18e01c4e9c58604be9db5c1635866ca",
            "metadata": {},
            "name": "agentAri_activationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$55f4b18ecdbb4102$var$node.hash = "d7f9c2a47c8c09620aa73c741a51fc31";
var $55f4b18ecdbb4102$export$2e2bcd8739ae039 = $55f4b18ecdbb4102$var$node;
module.exports["default"] = $55f4b18ecdbb4102$export$2e2bcd8739ae039;

});

parcelRegister("gRGWz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8cnlb = parcelRequire("8cnlb");


var $22LbG = parcelRequire("22LbG");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $d5729dd6b31bdc01$var$TabPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId } = t0;
    const { role: role, id: id, hidden: hidden, "aria-labelledby": ariaLabelledBy, tabIndex: tabIndex } = (0, $22LbG.default)();
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== ariaLabelledBy || $[3] !== hidden || $[4] !== id || $[5] !== role || $[6] !== t1 || $[7] !== tabIndex || $[8] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.Focusable), {
            as: "div",
            isInset: true,
            testId: testId,
            role: role,
            id: id,
            hidden: hidden,
            "aria-labelledby": ariaLabelledBy,
            tabIndex: tabIndex
        }, t1);
        $[2] = ariaLabelledBy;
        $[3] = hidden;
        $[4] = id;
        $[5] = role;
        $[6] = t1;
        $[7] = tabIndex;
        $[8] = testId;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $22LbG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.Focusable), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children));
};
var $d5729dd6b31bdc01$export$2e2bcd8739ae039 = $d5729dd6b31bdc01$var$TabPanel;
module.exports["default"] = $d5729dd6b31bdc01$export$2e2bcd8739ae039;

});

parcelRegister("cJHJd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e372b7eb440da78c04bce99c73f56f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $945b9b8753d0d7e9$var$_react = $945b9b8753d0d7e9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $945b9b8753d0d7e9$var$_baseNew = $945b9b8753d0d7e9$var$_interopRequireDefault((parcelRequire("gElAV")));
function $945b9b8753d0d7e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/camera
 * Usage guidance:
 * Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $945b9b8753d0d7e9$var$CameraIcon = (props)=>/*#__PURE__*/ $945b9b8753d0d7e9$var$_react.default.createElement($945b9b8753d0d7e9$var$_baseNew.default, Object.assign({
        name: "CameraIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$945b9b8753d0d7e9$var$CameraIcon.displayName = 'CameraIcon';
var $945b9b8753d0d7e9$var$_default = module.exports.default = $945b9b8753d0d7e9$var$CameraIcon;

});

parcelRegister("5E5tg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaab5f6701aa02491cfdb5d68929a1ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41c4ee9568fab4a8$var$_react = $41c4ee9568fab4a8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $41c4ee9568fab4a8$var$_baseNew = $41c4ee9568fab4a8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $41c4ee9568fab4a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/credit-card
 * Usage guidance:
 * Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41c4ee9568fab4a8$var$CreditCardIcon = (props)=>/*#__PURE__*/ $41c4ee9568fab4a8$var$_react.default.createElement($41c4ee9568fab4a8$var$_baseNew.default, Object.assign({
        name: "CreditCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$41c4ee9568fab4a8$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $41c4ee9568fab4a8$var$_default = module.exports.default = $41c4ee9568fab4a8$var$CreditCardIcon;

});

parcelRegister("untPk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9bf870b3510cd1e7e952e244a89fba9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05b5041c5b068c03$var$_react = $05b5041c5b068c03$var$_interopRequireDefault((parcelRequire("cozmU")));

var $05b5041c5b068c03$var$_baseNew = $05b5041c5b068c03$var$_interopRequireDefault((parcelRequire("gElAV")));
function $05b5041c5b068c03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/home
 * Usage guidance:
 * Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05b5041c5b068c03$var$HomeIcon = (props)=>/*#__PURE__*/ $05b5041c5b068c03$var$_react.default.createElement($05b5041c5b068c03$var$_baseNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$05b5041c5b068c03$var$HomeIcon.displayName = 'HomeIcon';
var $05b5041c5b068c03$var$_default = module.exports.default = $05b5041c5b068c03$var$HomeIcon;

});

parcelRegister("hS5Ee", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05fc9f2c5916fdc31a37b14a3491b3dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d02bdc63cc831cb8$var$_react = $d02bdc63cc831cb8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d02bdc63cc831cb8$var$_baseNew = $d02bdc63cc831cb8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d02bdc63cc831cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/location
 * Usage guidance:
 * Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d02bdc63cc831cb8$var$LocationIcon = (props)=>/*#__PURE__*/ $d02bdc63cc831cb8$var$_react.default.createElement($d02bdc63cc831cb8$var$_baseNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$d02bdc63cc831cb8$var$LocationIcon.displayName = 'LocationIcon';
var $d02bdc63cc831cb8$var$_default = module.exports.default = $d02bdc63cc831cb8$var$LocationIcon;

});

parcelRegister("dDJT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325f6ba365d37e1b844b4841ab828579>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ee283416514adb3$var$_react = $9ee283416514adb3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ee283416514adb3$var$_baseNew = $9ee283416514adb3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9ee283416514adb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/notification
 * Usage guidance:
 * Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ee283416514adb3$var$NotificationIcon = (props)=>/*#__PURE__*/ $9ee283416514adb3$var$_react.default.createElement($9ee283416514adb3$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$9ee283416514adb3$var$NotificationIcon.displayName = 'NotificationIcon';
var $9ee283416514adb3$var$_default = module.exports.default = $9ee283416514adb3$var$NotificationIcon;

});

parcelRegister("fDwuI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f95a338da93454f590a06141dce3364b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b623b43c3c5419ee$var$_react = $b623b43c3c5419ee$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b623b43c3c5419ee$var$_baseNew = $b623b43c3c5419ee$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b623b43c3c5419ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/phone
 * Usage guidance:
 * Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b623b43c3c5419ee$var$PhoneIcon = (props)=>/*#__PURE__*/ $b623b43c3c5419ee$var$_react.default.createElement($b623b43c3c5419ee$var$_baseNew.default, Object.assign({
        name: "PhoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$b623b43c3c5419ee$var$PhoneIcon.displayName = 'PhoneIcon';
var $b623b43c3c5419ee$var$_default = module.exports.default = $b623b43c3c5419ee$var$PhoneIcon;

});

parcelRegister("c7ANI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::322a83b8b3adf4368a1a41af2e0d0e23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d32af5872b9f0fe$var$_react = $8d32af5872b9f0fe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8d32af5872b9f0fe$var$_baseNew = $8d32af5872b9f0fe$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8d32af5872b9f0fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Printer".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/printer
 * Usage guidance:
 * Multi purpose - Known uses: print page, print-friendly view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d32af5872b9f0fe$var$PrinterIcon = (props)=>/*#__PURE__*/ $8d32af5872b9f0fe$var$_react.default.createElement($8d32af5872b9f0fe$var$_baseNew.default, Object.assign({
        name: "PrinterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 .75A.75.75 0 0 1 3.75 0h8.5a.75.75 0 0 1 .75.75V4h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1v2.25a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75V13H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1zM4.5 4h7V1.5h-7zM3 11.5v-1.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 .75.75v1.25h1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5zM11 7h2v1.5h-2zm-6.5 4v3.5h7V11z" clip-rule="evenodd"/>`
    }, props));
$8d32af5872b9f0fe$var$PrinterIcon.displayName = 'PrinterIcon';
var $8d32af5872b9f0fe$var$_default = module.exports.default = $8d32af5872b9f0fe$var$PrinterIcon;

});

parcelRegister("dmZMN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::41f466d719acdd1b0fc1808e85eebf89>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bbd41da1936efd3$var$_react = $9bbd41da1936efd3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9bbd41da1936efd3$var$_baseNew = $9bbd41da1936efd3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9bbd41da1936efd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/share
 * Usage guidance:
 * Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bbd41da1936efd3$var$ShareIcon = (props)=>/*#__PURE__*/ $9bbd41da1936efd3$var$_react.default.createElement($9bbd41da1936efd3$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$9bbd41da1936efd3$var$ShareIcon.displayName = 'ShareIcon';
var $9bbd41da1936efd3$var$_default = module.exports.default = $9bbd41da1936efd3$var$ShareIcon;

});

parcelRegister("dPtX5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5a9f624623a366d4fcd536beae1dbec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a117459a1f17cfe7$var$_react = $a117459a1f17cfe7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a117459a1f17cfe7$var$_baseNew = $a117459a1f17cfe7$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a117459a1f17cfe7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-vertical
 * Usage guidance:
 * Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a117459a1f17cfe7$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $a117459a1f17cfe7$var$_react.default.createElement($a117459a1f17cfe7$var$_baseNew.default, Object.assign({
        name: "ShowMoreVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$a117459a1f17cfe7$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $a117459a1f17cfe7$var$_default = module.exports.default = $a117459a1f17cfe7$var$ShowMoreVerticalIcon;

});

parcelRegister("k5vii", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca0a5510342b444bce1cb5dbd9a2ab69>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9fc8c9ec2597c1b$var$_react = $e9fc8c9ec2597c1b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e9fc8c9ec2597c1b$var$_baseNew = $e9fc8c9ec2597c1b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e9fc8c9ec2597c1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-pause
 * Usage guidance:
 * Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9fc8c9ec2597c1b$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $e9fc8c9ec2597c1b$var$_react.default.createElement($e9fc8c9ec2597c1b$var$_baseNew.default, Object.assign({
        name: "VideoPauseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e9fc8c9ec2597c1b$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $e9fc8c9ec2597c1b$var$_default = module.exports.default = $e9fc8c9ec2597c1b$var$VideoPauseIcon;

});

parcelRegister("1hHRQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b5e5070faf77c51$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $6JrSr = parcelRequire("6JrSr");


var $4ikjJ = parcelRequire("4ikjJ");

const $0b5e5070faf77c51$var$noOptions = [];
function $0b5e5070faf77c51$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $0b5e5070faf77c51$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $dpsRj.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $6JrSr.useId)();
    const [selectedValue, setSelectedValue] = (0, $cozmU.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});

parcelRegister("4ikjJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");

const $f465330fb8737fdd$var$packageName = "platform-pkg";
const $f465330fb8737fdd$var$packageVersion = "0.0.0-use.local";
const $f465330fb8737fdd$var$noop = (0, $dpsRj.default);
const $f465330fb8737fdd$var$labelPaddingStyles = null;
const $f465330fb8737fdd$var$labelStyles = null;
const $f465330fb8737fdd$var$labelDisabledStyles = null;
const $f465330fb8737fdd$var$radioBaseStyles = null;
const $f465330fb8737fdd$var$radioInteractiveStyles = null;
const $f465330fb8737fdd$var$radioDisabledStyles = null;
const $f465330fb8737fdd$var$radioDisabledCheckedStyles = null;
const $f465330fb8737fdd$var$radioInvalidStyles = null;
const $f465330fb8737fdd$var$InnerRadio = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $bDgLe.c)(47);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let isRequired;
    let label;
    let labelId;
    let name;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ ariaLabel: ariaLabel, "aria-labelledby": ariaLabelledBy, isDisabled: t0, isRequired: isRequired, isInvalid: t1, isChecked: t2, label: label, labelId: labelId, name: name, onChange: t3, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props);
        $[0] = props;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = isRequired;
        $[5] = label;
        $[6] = labelId;
        $[7] = name;
        $[8] = rest;
        $[9] = t0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = testId;
        $[14] = value;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        isRequired = $[4];
        label = $[5];
        labelId = $[6];
        name = $[7];
        rest = $[8];
        t0 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        testId = $[13];
        value = $[14];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const isInvalid = t1 === undefined ? false : t1;
    const isChecked = t2 === undefined ? false : t2;
    const onChange = t3 === undefined ? $f465330fb8737fdd$var$noop : t3;
    let t4;
    if ($[15] !== analyticsContext || $[16] !== onChange) {
        t4 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "radio",
            packageName: $f465330fb8737fdd$var$packageName,
            packageVersion: $f465330fb8737fdd$var$packageVersion
        };
        $[15] = analyticsContext;
        $[16] = onChange;
        $[17] = t4;
    } else t4 = $[17];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const t5 = testId && `${testId}--radio-label`;
    const t6 = isDisabled ? "true" : undefined;
    const t7 = isDisabled && "_1UtDYzot27 _0wOv4Qsyl5";
    let t8;
    if ($[18] !== t7) {
        t8 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ",
            t7
        ]);
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const t9 = labelId || ariaLabelledBy;
    const t10 = testId && `${testId}--radio-input`;
    const t11 = isInvalid ? "true" : undefined;
    const t12 = !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM";
    const t13 = isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E";
    const t14 = isDisabled && isChecked && "_1XF9ANHZdu";
    const t15 = isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z";
    let t16;
    if ($[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
        t16 = (0, $hekY6.default)([
            "_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun",
            t12,
            t13,
            t14,
            t15
        ]);
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
        $[24] = t16;
    } else t16 = $[24];
    let t17;
    if ($[25] !== ariaLabel || $[26] !== isChecked || $[27] !== isDisabled || $[28] !== isRequired || $[29] !== name || $[30] !== onChangeAnalytics || $[31] !== ref || $[32] !== rest || $[33] !== t10 || $[34] !== t11 || $[35] !== t16 || $[36] !== t9 || $[37] !== value) {
        t17 = /*#__PURE__*/ $cozmU.createElement("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            "aria-labelledby": t9,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": t10,
            "data-invalid": t11,
            ref: ref,
            className: t16
        });
        $[25] = ariaLabel;
        $[26] = isChecked;
        $[27] = isDisabled;
        $[28] = isRequired;
        $[29] = name;
        $[30] = onChangeAnalytics;
        $[31] = ref;
        $[32] = rest;
        $[33] = t10;
        $[34] = t11;
        $[35] = t16;
        $[36] = t9;
        $[37] = value;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== label) {
        t18 = label ? /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"
            ])
        }, label) : null;
        $[39] = label;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== t17 || $[42] !== t18 || $[43] !== t5 || $[44] !== t6 || $[45] !== t8) {
        t19 = /*#__PURE__*/ $cozmU.createElement("label", {
            "data-testid": t5,
            "data-disabled": t6,
            className: t8
        }, t17, t18);
        $[41] = t17;
        $[42] = t18;
        $[43] = t5;
        $[44] = t6;
        $[45] = t8;
        $[46] = t19;
    } else t19 = $[46];
    return t19;
} : function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $f465330fb8737fdd$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $f465330fb8737fdd$var$packageName,
        packageVersion: $f465330fb8737fdd$var$packageVersion
    });
    return /*#__PURE__*/ $cozmU.createElement("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ",
            isDisabled && "_1UtDYzot27 _0wOv4Qsyl5"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("input", {
        ...rest,
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-labelledby": labelId || ariaLabelledBy,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        ref: ref,
        className: (0, $hekY6.default)([
            "_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun",
            !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM",
            isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E",
            isDisabled && isChecked && "_1XF9ANHZdu",
            isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z"
        ])
    }), label ? /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"
        ])
    }, label) : null);
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $f465330fb8737fdd$var$Radio = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ $cozmU.createElement($f465330fb8737fdd$var$InnerRadio, {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function Radio(props, ref) {
    return /*#__PURE__*/ $cozmU.createElement($f465330fb8737fdd$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $f465330fb8737fdd$export$2e2bcd8739ae039 = $f465330fb8737fdd$var$Radio;
module.exports["default"] = $f465330fb8737fdd$export$2e2bcd8739ae039;

});

parcelRegister("lF9wS", function(module, exports) {
/* date-picker.tsx generated by @compiled/babel-plugin v2.0.0 */ /// <reference types="node" />
// for typing `process`

var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $7r5Hr = parcelRequire("7r5Hr");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6JrSr = parcelRequire("6JrSr");


var $824lD = parcelRequire("824lD");


var $3vMGL = parcelRequire("3vMGL");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $6wGOF = parcelRequire("6wGOF");

var $1TlML = parcelRequire("1TlML");


var $2DcxV = parcelRequire("2DcxV");


var $7P40I = parcelRequire("7P40I");


var $c1tjA = parcelRequire("c1tjA");


var $3YIJ0 = parcelRequire("3YIJ0");


var $jchtB = parcelRequire("jchtB");


var $6bH7j = parcelRequire("6bH7j");


var $dDPKN = parcelRequire("dDPKN");


var $goKry = parcelRequire("goKry");


var $dAzeP = parcelRequire("dAzeP");


var $cME0o = parcelRequire("cME0o");


var $lzTfS = parcelRequire("lzTfS");


var $ep7Ex = parcelRequire("ep7Ex");

const $c67bd6933458bbbd$var$packageName = "platform-pkg";
const $c67bd6933458bbbd$var$packageVersion = "0.0.0-use.local";
const $c67bd6933458bbbd$var$styles = {
    pickerContainerStyle: "_1mT5xdRAKS",
    dropdownIndicatorStyles: "_4ouGXI9DVM _4kiQYA9DVM _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconContainerStyles: "_23rrnHYru2 _3iDTPbQ4SZ _0jFU0VN91d _1mT5xdWVPG _0hPCNLDIqT _1bHrqEOLYo _1UtDYzKGUX _2I62gzPgdg _1OKFqYPgdg _0clgaMZpcK",
    iconSpacingWithClearButtonStyles: "_2xTnZxVa5s",
    iconSpacingWithoutClearButtonStyles: "_2xTnZx1Y8M"
};
const $c67bd6933458bbbd$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $c67bd6933458bbbd$var$packageName,
    packageVersion: $c67bd6933458bbbd$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $c67bd6933458bbbd$var$DatePicker = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const calendarRef = (0, $cozmU.useRef)(null);
    const calendarButtonRef = (0, $cozmU.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($824lD))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event_0)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(defaultIsOpen);
    const [__0, setIsFocused] = (0, $cozmU.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $cozmU.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $cozmU.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $cozmU.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $cozmU.useState)(propValue || defaultValue || (0, $6bH7j.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $cozmU.useState)((0, $3vMGL.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $cozmU.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $cozmU.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $cozmU.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $cozmU.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $cozmU.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$c67bd6933458bbbd$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $3vMGL.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $cozmU.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // When using top-layer, Popup.Content with role='dialog' automatically
            // focuses the first focusable element — no manual focus needed.
            if (!(0, $iDrrr.fg)('platform-dst-top-layer')) // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $c1tjA.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso_0 })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso_0);
        setValue(iso_0);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso_0); // When using top-layer, PopupContent handles focus restoration automatically
        // on close based on the role. Only manually restore focus for the legacy path.
        if (!(0, $iDrrr.fg)('platform-dst-top-layer')) {
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event_0)=>{
        const newlyFocusedElement_0 = event_0.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement_0)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event_1)=>{
        const value_0 = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value_0);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event_1);
    };
    const onTextInput = (event_2)=>{
        const inputValue = event_2.target.value;
        if (inputValue) {
            const parsed = (0, $lzTfS.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $esV19.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6bH7j.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event_3)=>{
        const value_1 = getValue();
        const keyPressed = event_3.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Restore focus on close. Both code paths handle this here:
                // the legacy path because it has no built-in restoration, and
                // the top-layer path because the menu uses `mode="manual"` to
                // avoid the auto-popover light-dismiss closing the menu on the
                // same click that opens it (see internal/menu-top-layer.tsx).
                // `manual` mode disables the browser's native focus return.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox_0 = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox_0?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value_1 && event_3.target instanceof HTMLInputElement && event_3.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event_3.preventDefault();
                if (!(0, $goKry.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $jchtB.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value_1;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e_0)=>{
        setIsOpen((isOpen_0)=>{
            if (isOpen_0) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e_0.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6bH7j.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value_0, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue_0, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue_0, actionMeta);
        setSelectInputValue(selectInputValue_0);
    };
    const getContainerRef = (0, $cozmU.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = (props_0)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c67bd6933458bbbd$var$styles.dropdownIndicatorStyles
        }, /*#__PURE__*/ $cozmU.createElement(Icon, props_0));
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $6JrSr.useId)();
    const SingleValue = (0, $ep7Ex.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $2DcxV.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props_1)=>/*#__PURE__*/ $cozmU.createElement((0, $dDPKN.IndicatorsContainer), {
                    ...props_1,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: (0, $iDrrr.fg)('platform-dst-top-layer') ? (0, $cME0o.MenuTopLayer) : (0, $dAzeP.Menu),
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $2DcxV.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, #080F214A)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6bH7j.getShortISOString)((0, $k5sGX.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $1TlML.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base_0)=>({
                ...base_0,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $7P40I.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $6JrSr.useId)()}`;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hekY6.default)([
            $c67bd6933458bbbd$var$styles.pickerContainerStyle
        ])
    }, /*#__PURE__*/ $cozmU.createElement("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        appearance: appearance,
        "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
        label: label || undefined,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        closeMenuOnSelect: true,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $3YIJ0.getPlaceholder)({
            placeholder: placeholder,
            l10n: l10n
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: mergedStyles,
        value: initialValue,
        ...selectProps,
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        // selectProps or not and what wil be overwritten
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
        menuInnerWrapper: calendarProps.menuInnerWrapper
    }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c67bd6933458bbbd$var$styles.iconContainerStyles, getterValue && !hideIcon ? $c67bd6933458bbbd$var$styles.iconSpacingWithClearButtonStyles : $c67bd6933458bbbd$var$styles.iconSpacingWithoutClearButtonStyles)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
        "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
        id: openCalendarLabelId,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && `${testId}--open-calendar-button`
    })) : null);
});
var $c67bd6933458bbbd$export$2e2bcd8739ae039 = $c67bd6933458bbbd$var$DatePicker;
module.exports["default"] = $c67bd6933458bbbd$export$2e2bcd8739ae039;

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("3vMGL", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $bdgrV = parcelRequire("bdgrV");


var $a7dWT = parcelRequire("a7dWT");

const $a25ace4035d13584$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $bdgrV.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $a25ace4035d13584$export$ea56ca58f08ffa52;

});

parcelRegister("5vwoh", function(module, exports) {
const $f2dacbe0eea831b8$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $f2dacbe0eea831b8$export$dca0327c9b9c6498;

});

parcelRegister("bdgrV", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $kGZoG = parcelRequire("kGZoG");


var $8w4cs = parcelRequire("8w4cs");


var $cafP2 = parcelRequire("cafP2");

const $8d32407758572e3f$var$INVALID_DATE = new Date(NaN);
const $8d32407758572e3f$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $8d32407758572e3f$var$INVARIANT_DATE = (0, $cafP2.toDate)($8d32407758572e3f$var$INVARIANT);
const $8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $8d32407758572e3f$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $8d32407758572e3f$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $8d32407758572e3f$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $8d32407758572e3f$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($8d32407758572e3f$var$INVARIANT_DATE);
    const shortDate = $8d32407758572e3f$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $8d32407758572e3f$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $8d32407758572e3f$var$stripExtras(date).match($8d32407758572e3f$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $8d32407758572e3f$var$INVALID_DATE;
        const dateParts = $8d32407758572e3f$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $8w4cs.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $kGZoG.isValid)(normalizedDate)) return $8d32407758572e3f$var$INVALID_DATE;
        return (0, $cafP2.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $8d32407758572e3f$export$cfa2ef2687faeda2;

});

parcelRegister("kGZoG", function(module, exports) {

var $aDvYS = parcelRequire("aDvYS");

const $8985e2fc067d563b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $aDvYS.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $8985e2fc067d563b$export$1ea939691cdc45b8;

});

parcelRegister("aDvYS", function(module, exports) {

var $6NKSh = parcelRequire("6NKSh");

const $e96e8b0ab312aaba$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $6NKSh.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $e96e8b0ab312aaba$export$f645ddd439eb259d;

});

parcelRegister("6NKSh", function(module, exports) {
const $04f001925dc3d06f$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $04f001925dc3d06f$export$553d7fa8e3805fc0;

});

parcelRegister("8w4cs", function(module, exports) {

var $9tavx = parcelRequire("9tavx");

const $7e5174e81eb823af$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $9tavx.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $7e5174e81eb823af$export$fcc71269590ba0a8;

});

parcelRegister("9tavx", function(module, exports) {
const $4b828859bff16031$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $4b828859bff16031$export$abe96da78d4f59dd;

});

parcelRegister("cafP2", function(module, exports) {
const $70268879eaf1b092$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $70268879eaf1b092$export$e67a095c620b86fe;

});

parcelRegister("a7dWT", function(module, exports) {
const $13d20959c22b69ba$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $13d20959c22b69ba$export$9b7ca29af37c192;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("2DcxV", function(module, exports) {
/**
 * This component is used to hide portions of Select component.
 */ const $15ef0256511c01c4$export$5e30e9a24d6c1203 = ()=>null;
module.exports["EmptyComponent"] = $15ef0256511c01c4$export$5e30e9a24d6c1203;

});

parcelRegister("7P40I", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $f6RxU = parcelRequire("f6RxU");

var $k5sGX = parcelRequire("k5sGX");


var $5NE0I = parcelRequire("5NE0I");


var $78xYN = parcelRequire("78xYN");

const $1320985d4abf5be3$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $5NE0I.defaultDateFormat));
    const date = (0, $k5sGX.default)(value);
    return dateFormat ? (0, $f6RxU.default)(date, (0, $78xYN.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
module.exports["formatDate"] = $1320985d4abf5be3$export$3ae94a2503e890a1;

});

parcelRegister("5NE0I", function(module, exports) {
const $f78c70927ab65aa7$export$75032c84f56650eb = 'YYYY/MM/DD';
module.exports["defaultDateFormat"] = $f78c70927ab65aa7$export$75032c84f56650eb;

});

parcelRegister("78xYN", function(module, exports) {
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $8aa1b22faba44901$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $8aa1b22faba44901$var$v1tokens = Object.keys($8aa1b22faba44901$var$tokensMap).sort().reverse();
const $8aa1b22faba44901$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$8aa1b22faba44901$var$v1tokens.join('|') + '|.)', 'g');
function $8aa1b22faba44901$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($8aa1b22faba44901$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $8aa1b22faba44901$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}
module.exports["convertTokens"] = $8aa1b22faba44901$export$4d5430175be73d45;

});

parcelRegister("c1tjA", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $dFOvD = parcelRequire("dFOvD");


var $dFfyu = parcelRequire("dFfyu");

const $10b2801952722091$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $dFOvD.default)(new Date(parsedYear, parsedMonth - 1 // This needs to be -1, because the Date constructor expects an index of the given month
    )).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $dFfyu.padToTwo)(parsedMonth)}-${(0, $dFfyu.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $dFfyu.padToTwo)(parsedMonth)}-${(0, $dFfyu.padToTwo)(parsedDate)}`;
    return newIso;
};
module.exports["getParsedISO"] = $10b2801952722091$export$38db26406d1a1ee2;

});

parcelRegister("dFOvD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f4648cab1450763$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $9f4648cab1450763$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("dFfyu", function(module, exports) {
function $9f4ac43d2e8abc6a$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
module.exports["padToTwo"] = $9f4ac43d2e8abc6a$export$a7de57e5b672ccdb;

});

parcelRegister("3YIJ0", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $6YTmv = parcelRequire("6YTmv");

const $91124c7d4521d8af$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $6YTmv.placeholderDatetime));
};
module.exports["getPlaceholder"] = $91124c7d4521d8af$export$d3f5c5e0a5023fa0;

});

parcelRegister("6YTmv", function(module, exports) {
// This date was chosen to clearly show date and time formats (day > 12)
// e.g. 18/02/1993 vs. 2/18/1993 and 1:00 PM vs 13:00
const $793e1f5a2758a99c$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
module.exports["placeholderDatetime"] = $793e1f5a2758a99c$export$fff8babee5abe3e2;

});

parcelRegister("jchtB", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $6bH7j = parcelRequire("6bH7j");

function $719f2b69dfc70e7c$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return (0, $6bH7j.getShortISOString)(new Date());
    return calendarValue;
}
module.exports["getSafeCalendarValue"] = $719f2b69dfc70e7c$export$ff525416014fb67d;

});

parcelRegister("6bH7j", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $f6RxU = parcelRequire("f6RxU");


var $78xYN = parcelRequire("78xYN");

function $0854920bdb032d57$export$77d5bc49fed7ef14(date) {
    return (0, $f6RxU.default)(date, (0, $78xYN.convertTokens)('YYYY-MM-DD'));
}
module.exports["getShortISOString"] = $0854920bdb032d57$export$77d5bc49fed7ef14;

});

parcelRegister("dDPKN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l9ukq = parcelRequire("l9ukq");

const $0c8e523c19b51055$var$styles = {
    calendarButtonInclusionStyles: "_0GTcwRVa5s",
    calendarButtonOnlyInclusionStyles: "_0GTcwRNHnM"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $0c8e523c19b51055$export$d0ffd7e649cab6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let rest;
    let showClearIndicator;
    if ($[0] !== t0) {
        ({ showClearIndicator: showClearIndicator, ...rest } = t0);
        $[0] = t0;
        $[1] = rest;
        $[2] = showClearIndicator;
    } else {
        rest = $[1];
        showClearIndicator = $[2];
    }
    const t1 = showClearIndicator ? $0c8e523c19b51055$var$styles.calendarButtonInclusionStyles : $0c8e523c19b51055$var$styles.calendarButtonOnlyInclusionStyles;
    let t2;
    if ($[3] !== t1) {
        t2 = (0, $hekY6.default)([
            t1
        ]);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== rest) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).IndicatorsContainer, rest);
        $[5] = rest;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            showClearIndicator ? $0c8e523c19b51055$var$styles.calendarButtonInclusionStyles : $0c8e523c19b51055$var$styles.calendarButtonOnlyInclusionStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).IndicatorsContainer, rest));
module.exports["IndicatorsContainer"] = $0c8e523c19b51055$export$d0ffd7e649cab6f;

});

parcelRegister("l9ukq", function(module, exports) {

var $eI6di = parcelRequire("eI6di");


var $1OAP8 = parcelRequire("1OAP8");


var $b32SO = parcelRequire("b32SO");


var $bELTt = parcelRequire("bELTt");


var $03igg = parcelRequire("03igg");


var $1qwbX = parcelRequire("1qwbX");


var $dnOPs = parcelRequire("dnOPs");


var $2yNVp = parcelRequire("2yNVp");


var $5sdUI = parcelRequire("5sdUI");


var $g2KPf = parcelRequire("g2KPf");


var $gmd97 = parcelRequire("gmd97");


var $d4756 = parcelRequire("d4756");


var $5sEbf = parcelRequire("5sEbf");


var $4JwrI = parcelRequire("4JwrI");


var $5F6uL = parcelRequire("5F6uL");


var $1aBuU = parcelRequire("1aBuU");


var $jRelA = parcelRequire("jRelA");


var $jxk0F = parcelRequire("jxk0F");


var $idc4a = parcelRequire("idc4a");


var $lzeON = parcelRequire("lzeON");


var $eMtSk = parcelRequire("eMtSk");


var $fb3M0 = parcelRequire("fb3M0");

const $2d42c92553201638$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $2yNVp.ClearIndicator),
    Control: (0, $03igg.default),
    DropdownIndicator: (0, $5sdUI.DropdownIndicator),
    Group: (0, $1qwbX.default),
    GroupHeading: (0, $dnOPs.GroupHeading),
    IndicatorsContainer: (0, $eI6di.IndicatorsContainer),
    Input: (0, $gmd97.default),
    LoadingIndicator: (0, $g2KPf.LoadingIndicator),
    Menu: (0, $d4756.default),
    MenuList: (0, $5sEbf.MenuList),
    MenuPortal: (0, $1aBuU.MenuPortal),
    LoadingMessage: (0, $4JwrI.LoadingMessage),
    NoOptionsMessage: (0, $5F6uL.NoOptionsMessage),
    MultiValue: (0, $jRelA.default),
    MultiValueContainer: (0, $1OAP8.MultiValueContainer),
    MultiValueLabel: (0, $jxk0F.MultiValueLabel),
    MultiValueRemove: (0, $idc4a.MultiValueRemove),
    Option: (0, $lzeON.default),
    Placeholder: (0, $eMtSk.default),
    SelectContainer: (0, $b32SO.SelectContainer),
    SingleValue: (0, $fb3M0.default),
    ValueContainer: (0, $bELTt.ValueContainer)
};
const $2d42c92553201638$export$71abc632aa29e6fe = (props)=>({
        ...$2d42c92553201638$export$9b5ac10f59f76296,
        ...props.components
    });
module.exports["components"] = $2d42c92553201638$export$9b5ac10f59f76296;
module.exports["defaultComponents"] = $2d42c92553201638$export$71abc632aa29e6fe;

});

parcelRegister("eI6di", function(module, exports) {
/* indicators-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $f0e53d9860be0f9c$var$indicatorContainerStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $f0e53d9860be0f9c$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _4xdlr0FlnN _03SyCP1Y8M",
            (0, $k12R1.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};
module.exports["IndicatorsContainer"] = $f0e53d9860be0f9c$export$d0ffd7e649cab6f;

});

parcelRegister("k4Jbz", function(module, exports) {
const $0718c80905572ebe$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
module.exports["getStyleProps"] = $0718c80905572ebe$export$26417cabd806a658;

});

parcelRegister("1OAP8", function(module, exports) {
/* multi-value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");

const $82bd5a0be9dfbcd5$var$multiValueStyles = {
    root: "_0bjKvDKxmn _3vBAKHT3oA _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _4ouGXIPgdg _43nrzTFQfX _2xTnZxFQfX _0rIjykFQfX _0GTcwRFQfX _0KLXru7Cj1 _1EqgXlN91d _1UtDYzy7kJ _0gdQWVYbGa",
    disabled: "_1UtDYzot27 _0KLXruDMqu",
    focused: "_1UtDYzjTy9 _0KLXruY9q9 _2OUyjtUbsb _33VGdrNvrM _0s2BChjOvk _4zUdn16wH8"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $82bd5a0be9dfbcd5$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        className: (0, $hekY6.default)([
            $82bd5a0be9dfbcd5$var$multiValueStyles.root,
            isDisabled && $82bd5a0be9dfbcd5$var$multiValueStyles.disabled,
            isFocused && $82bd5a0be9dfbcd5$var$multiValueStyles.focused,
            (0, $k12R1.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
module.exports["MultiValueContainer"] = $82bd5a0be9dfbcd5$export$cf9cf2a30a59265c;

});

parcelRegister("b32SO", function(module, exports) {
/* select-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $2694c143d6fa36b9$var$containerStyles = {
    default: "_2sNsIg20Hp _1mT5xdRAKS _1pp6NdYsOL _4kBIzkmnOE",
    rtl: "_3kIIylu2Pf",
    disabled: "_0wOv4Qsyl5"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $2694c143d6fa36b9$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $k4Jbz.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $2694c143d6fa36b9$var$containerStyles.default,
            isRtl && $2694c143d6fa36b9$var$containerStyles.rtl,
            isDisabled && $2694c143d6fa36b9$var$containerStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-container')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
};
module.exports["SelectContainer"] = $2694c143d6fa36b9$export$446eebadefe1123b;

});

parcelRegister("bELTt", function(module, exports) {
/* value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");

const $f24b89d672307c2d$var$valueContainerStyles = {
    default: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbgBM8 _3TGfC9HnLE _0xWutCdqJc _1mT5xdRAKS _03SyCPgVvo _0LQT5EgVvo",
    verticalPaddingStandard: "_46hvQmFQfX _0xmtkoFQfX",
    verticalPaddingTagUpliftMulti: "_46hvQm1Y8M _0xmtko1Y8M",
    verticalPaddingTagUpliftCompactMulti: "_46hvQmFQfX _0xmtkoFQfX",
    verticalPaddingCompactNonUplift: "_46hvQmPgdg _0xmtkoPgdg",
    flex: "_3iDTPbQ4SZ",
    flexWithGap: "_2mHwu81Y8M _3iDTPbQ4SZ _3TGfC9HnLE"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $f24b89d672307c2d$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $f24b89d672307c2d$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $f24b89d672307c2d$var$valueContainerStyles.flex,
            tagUpliftChipRow && $f24b89d672307c2d$var$valueContainerStyles.flexWithGap,
            (0, $k12R1.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
};
module.exports["ValueContainer"] = $f24b89d672307c2d$export$4dc9f58ad9a1a000;

});

parcelRegister("03igg", function(module, exports) {
/* control.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");

const $9f1050d22f191849$var$styles = {
    default: "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _0bjKvDzXzM _23rrnH5Vpu _3vBAKHHKt7 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0wOv4Q18ZR _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuI7V3 _1mT5xdRAKS _0KLXru7Cj1 _4kiQYAUF4f _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _2KFbDKJg58 _3ILZpPJg58 _1gVfwBYbGa _4mPnyfjXjE _0hPERGHKt7 _2vSjE56m9C _0ReiIH7zJH _1eOmH6qWX3 _3ZpBalCmBb",
    defaultT26Shape: "_0bjKvDKTcp",
    compact: "_4kiQYAUofl",
    invalid: "_3vBAKHnod9 _2OUyjtFKgL _4mPnyfFKgL _0hPERGnod9",
    focusedInvalid: "_2OUyjtPhRM",
    disabled: "_3vBAKHVrZW _1pp6NdYbGa _0KLXruVrZW _4mPnyfwcEu",
    focused: "_3vBAKHnXvL _0KLXruutHW _2OUyjtPhRM _4mPnyfPhRM _0hPERGnXvL _1eOmH6utHW",
    subtle: "_3vBAKHjOvk _0KLXrujOvk _4mPnyfw5zn",
    subtleFocused: "_0KLXrulfZc",
    none: "_3vBAKHjOvk _0KLXrujOvk _4mPnyfw5zn _0hPERGjOvk _1eOmH6jOvk"
};
const $9f1050d22f191849$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: innerRef,
        className: (0, $hekY6.default)([
            $9f1050d22f191849$var$styles.default,
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $9f1050d22f191849$var$styles.defaultT26Shape,
            isDisabled && $9f1050d22f191849$var$styles.disabled,
            isInvalid && $9f1050d22f191849$var$styles.invalid,
            isCompact && $9f1050d22f191849$var$styles.compact,
            appearance === 'subtle' && $9f1050d22f191849$var$styles.subtle,
            appearance === 'subtle' && isFocused && $9f1050d22f191849$var$styles.subtleFocused,
            isFocused && $9f1050d22f191849$var$styles.focused,
            appearance === 'none' && $9f1050d22f191849$var$styles.none,
            (0, $k12R1.cx)(className, xcss, '-control')
        ]),
        style: css,
        ...innerProps,
        "aria-disabled": (0, $iDrrr.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9f1050d22f191849$export$2e2bcd8739ae039 = $9f1050d22f191849$var$Control;
module.exports["default"] = $9f1050d22f191849$export$2e2bcd8739ae039;

});

parcelRegister("1qwbX", function(module, exports) {
/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $d71fedd0ebda1298$var$styles = {
    root: "_0xmtko2ADO _46hvQm2ADO"
};
const $d71fedd0ebda1298$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        ...innerProps,
        className: (0, $hekY6.default)([
            $d71fedd0ebda1298$var$styles.root,
            (0, $k12R1.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $8aG6j.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                children: children
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d71fedd0ebda1298$export$2e2bcd8739ae039 = $d71fedd0ebda1298$var$Group;
module.exports["default"] = $d71fedd0ebda1298$export$2e2bcd8739ae039;

});

parcelRegister("dnOPs", function(module, exports) {
/* group-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");


var $cUn9l = parcelRequire("cUn9l");

const $83df16e577cd0423$var$headingStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $83df16e577cd0423$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $cUn9l.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbvLZJ _1UtDYzZpcK _0wOv4Q18ZR _1kk5Tkmb2E _0rIjykMKEk _03SyCP8HPE _0LQT5E8HPE _41LZZBYbGa",
            (0, $k12R1.cx)(className, xcss, '-group')
        ]),
        style: css,
        ...innerProps
    });
};
module.exports["GroupHeading"] = $83df16e577cd0423$export$85c8b41a3cd87edc;

});

parcelRegister("cUn9l", function(module, exports) {
// Clean Common Props
// ==============================
const $f2a94cc1b8ddb584$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
module.exports["cleanCommonProps"] = $f2a94cc1b8ddb584$export$8e9fd4287627890c;

});

parcelRegister("2yNVp", function(module, exports) {
/* clear-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $5avUB = parcelRequire("5avUB");


var $hBYtq = parcelRequire("hBYtq");


var $k4Jbz = parcelRequire("k4Jbz");

const $5a5651cd1854e8b7$var$iconContainerStyles = {
    root: "_1mb4UnZqHV _2xIroY98eZ _497WNwDHe6 _2zndICT6kp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQmFQfX _03SyCPFQfX _0xmtkoFQfX _0LQT5EFQfX"
};
const $5a5651cd1854e8b7$var$clearIndicatorStyles = {
    default: "_23rrnHYru2 _3iDTPbQ4SZ _1UtDYzKGUX _46hvQmgVvo _03SyCPFQfX _0xmtkogVvo _0LQT5EFQfX _0clgaMZpcK",
    compact: "_46hvQmdnbC _0xmtkodnbC"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $5a5651cd1854e8b7$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $5a5651cd1854e8b7$var$clearIndicatorStyles.default,
            isCompact && $5a5651cd1854e8b7$var$clearIndicatorStyles.compact,
            (0, $k12R1.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            xcss: $5a5651cd1854e8b7$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};
module.exports["ClearIndicator"] = $5a5651cd1854e8b7$export$ecf9cf59142dd54a;

});

parcelRegister("5sdUI", function(module, exports) {
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $7sJoX = parcelRequire("7sJoX");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $k4Jbz = parcelRequire("k4Jbz");

const $a1cf7e8114f3e508$var$dropdownWrapperStyles = {
    root: "_46hvQmgVvo _03SyCPgVvo _0xmtkogVvo _0LQT5EgVvo"
}; // Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
const $a1cf7e8114f3e508$var$voiceControlPressableStyles = {
    root: "_4c065UdnbC _2Y7lL4dnbC _3SamIHdnbC _2YLqiKdnbC _0KLXrujOvk _3iDTPbQ4SZ _0hPCNLDIqT"
}; // Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
const $a1cf7e8114f3e508$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
const $a1cf7e8114f3e508$var$dropdownStyles = {
    default: "_23rrnHYru2 _3iDTPbQ4SZ _1UtDYzZpcK _46hvQmgVvo _03SyCPFQfX _0xmtkogVvo _0LQT5EFQfX _0clgaMZpcK",
    compact: "_46hvQmdnbC _0xmtkodnbC",
    disabled: "_1UtDYzot27"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $a1cf7e8114f3e508$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps = {}, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    const { 'aria-hidden': ariaHidden, ...restInnerProps } = innerProps;
    const isVoiceControlAccessible = (0, $iDrrr.fg)('platform_dst_select_dropdown_voice_control'); // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    const wrapperTestId = restInnerProps['data-testid'] ? `${restInnerProps['data-testid']}-children` : undefined;
    const voiceControlAccessibleIndicator = children ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId,
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $a1cf7e8114f3e508$var$voiceControlPressableStyles.root,
        style: $a1cf7e8114f3e508$var$voiceControlPressableSizeReset,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            as: "span",
            xcss: $a1cf7e8114f3e508$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $a1cf7e8114f3e508$var$dropdownStyles.default,
            isDisabled && $a1cf7e8114f3e508$var$dropdownStyles.disabled,
            isCompact && $a1cf7e8114f3e508$var$dropdownStyles.compact,
            (0, $k12R1.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...restInnerProps,
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden,
        children: isVoiceControlAccessible ? voiceControlAccessibleIndicator : children ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            as: "span",
            xcss: $a1cf7e8114f3e508$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};
module.exports["DropdownIndicator"] = $a1cf7e8114f3e508$export$ec98719d3db7f2e4;

});

parcelRegister("g2KPf", function(module, exports) {
/* loading-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $lfoFx = parcelRequire("lfoFx");


var $k4Jbz = parcelRequire("k4Jbz");

const $55ae1ff552b4e887$var$loadingIndicatorStyles = {
    default: "_46hvQmgVvo _03SyCP2ADO _0xmtkogVvo _0LQT5E2ADO",
    compact: "_46hvQmdnbC _0xmtkodnbC"
};
const $55ae1ff552b4e887$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $55ae1ff552b4e887$var$loadingIndicatorStyles.default,
            isCompact && $55ae1ff552b4e887$var$loadingIndicatorStyles.compact,
            (0, $k12R1.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small"
        })
    });
};
module.exports["LoadingIndicator"] = $55ae1ff552b4e887$export$7c20be4c1d342248;

});

parcelRegister("gmd97", function(module, exports) {
/* input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");


var $cUn9l = parcelRequire("cUn9l");

const $4f7020a25ebba73d$var$inputStylesOld = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1xC2CJpl7Y _3SamIHFQfX _2YLqiKFQfX _4c065UFQfX _3iDTPbkfkE _2iEGP2uU7u _1UtDYzy7kJ _1gHrEndnbC _35LzqndnbC _3hlIN9dnbC _1G7t7NdnbC _21xcc5dnbC _4bqSyPdnbC _0sKA2cdnbC _3Ico7NdnbC _0YfYpCdnbC _3vZWbIOLYo _0Psg1qIjUK _4z3m3Q98eZ _3W3NEwYbGa _4dPioddnbC _4DX2ez4Jdh _0GBAIrkWHv _22EsJjnQyn _47WczEZYee",
    disabled: "_0fKRyPnQyn",
    labellingFFStyles: "_2sNsIg7NXe _3SamIHPgdg _2YLqiKPgdg _4c065UPgdg"
};
const $4f7020a25ebba73d$var$inputStyles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1xC2CJpl7Y _3SamIHFQfX _2YLqiKFQfX _4c065UFQfX _1mT5xdRAKS _3iDTPbQ4SZ _2iEGP2uU7u _1UtDYzy7kJ _1gHrEndnbC _35LzqndnbC _3hlIN9dnbC _1G7t7NdnbC _21xcc5dnbC _4bqSyPdnbC _0sKA2cdnbC _3Ico7NdnbC _0YfYpCdnbC _3vZWbIOLYo _0Psg1qIjUK _4z3m3Q98eZ _3W3NEwYbGa _4dPioddnbC _4DX2ez4Jdh _0GBAIrkWHv _22EsJjnQyn _47WczEZYee",
    disabled: "_0fKRyPnQyn",
    labellingFFStyles: "_2sNsIg7NXe _3SamIHPgdg _2YLqiKPgdg _4c065UPgdg"
};
const $4f7020a25ebba73d$var$nativeInputStylesOld = null;
const $4f7020a25ebba73d$var$nativeInputStyles = null;
const $4f7020a25ebba73d$var$hidden = null;
const $4f7020a25ebba73d$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $cUn9l.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $iDrrr.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $4f7020a25ebba73d$var$inputStyles.root,
            isMulti && ffTagUplifts && $4f7020a25ebba73d$var$inputStyles.labellingFFStyles,
            isDisabled && $4f7020a25ebba73d$var$inputStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _49OCfRdnbC _2uo31fdnbC _30huDKdnbC _2sNsIgOLYo _1xC2CJIjUK _2xIroY98eZ _497WNwYbGa _2zndICdnbC _39xV02N91d _4ouGXI4Jdh _1mT5xdWVPG _1UtDYzOLYo _1YKVNs7dHp",
                isHidden && "_1YKVNsdnbC",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $4f7020a25ebba73d$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $4f7020a25ebba73d$var$inputStylesOld.labellingFFStyles,
            isDisabled && $4f7020a25ebba73d$var$inputStylesOld.disabled,
            (0, $k12R1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2uo31fdnbC _30huDKdnbC _2sNsIgOLYo _1xC2CJIjUK _2xIroY98eZ _497WNwYbGa _2zndICdnbC _39xV02N91d _4ouGXI4Jdh _1UtDYzOLYo _1YKVNs7dHp",
                isHidden && "_1YKVNsdnbC",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $4f7020a25ebba73d$export$2e2bcd8739ae039 = $4f7020a25ebba73d$var$Input;
module.exports["default"] = $4f7020a25ebba73d$export$2e2bcd8739ae039;

});

parcelRegister("d4756", function(module, exports) {
/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");

const $1b5d001d71e5bc28$var$menuStyles = {
    root: "_0bjKvDKxmn _1mT5xdWVPG _39xV02N91d _42Yu6B7dHp _0rIjyk2ADO _43nrzT2ADO _0KLXruoI2d _2OUyjtGk8v",
    rootT26Shape: "_0bjKvD8fU6",
    bottom: "_2I62gzN91d",
    top: "_1ZB6UyN91d"
};
const $1b5d001d71e5bc28$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $1b5d001d71e5bc28$var$menuStyles.root,
            $1b5d001d71e5bc28$var$menuStyles[placement],
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $1b5d001d71e5bc28$var$menuStyles.rootT26Shape,
            (0, $k12R1.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1b5d001d71e5bc28$export$2e2bcd8739ae039 = $1b5d001d71e5bc28$var$Menu;
module.exports["default"] = $1b5d001d71e5bc28$export$2e2bcd8739ae039;

});

parcelRegister("5sEbf", function(module, exports) {
/* menu-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $49c6cef5c6ffc437$var$menuListStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $49c6cef5c6ffc437$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _2WAcuGIZbP _0xmtko2ADO _46hvQm2ADO _0xWutCdqJc",
            (0, $k12R1.cx)(className, xcss, '-MenuList')
        ]),
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
module.exports["MenuList"] = $49c6cef5c6ffc437$export$d4c4e98c5044dc8;

});

parcelRegister("4JwrI", function(module, exports) {
/* menu-loading-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $4aRua = parcelRequire("4aRua");


var $k4Jbz = parcelRequire("k4Jbz");

const $5eb1baed63c9b197$var$noticeStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $5eb1baed63c9b197$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_0xmtko2ADO _46hvQm2ADO _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT",
            (0, $k12R1.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css,
        ...innerProps,
        role: "option",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};
module.exports["LoadingMessage"] = $5eb1baed63c9b197$export$e928a71d039d3102;

});

parcelRegister("5F6uL", function(module, exports) {
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $4aRua = parcelRequire("4aRua");


var $k4Jbz = parcelRequire("k4Jbz");

const $77e0ef38afccad04$var$noticeStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $77e0ef38afccad04$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_0xmtko2ADO _46hvQm2ADO _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT",
            (0, $k12R1.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};
module.exports["NoOptionsMessage"] = $77e0ef38afccad04$export$d58b72b7d3c4072c;

});

parcelRegister("1aBuU", function(module, exports) {
/* menu-portal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $a4uy1 = parcelRequire("a4uy1");


var $9kbTQ = parcelRequire("9kbTQ");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");


var $310h3 = parcelRequire("310h3");


var $1RR25 = parcelRequire("1RR25");

function $b44269c50c53072b$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $b44269c50c53072b$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b44269c50c53072b$var$menuPortalStyles = {
    root: "_42Yu6B7dHp _3iC0zd8knl _1mT5xdX4tw _2I62gz0MUb _39xV02wtpS"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $b44269c50c53072b$var$MenuPortalLegacy(props) {
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $cozmU.useRef)(null);
    const cleanupRef = (0, $cozmU.useRef)(null);
    const [placement, setPortalPlacement] = (0, $cozmU.useState)($b44269c50c53072b$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $cozmU.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $cozmU.useState)(null);
    const updateComputedPosition = (0, $cozmU.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $b44269c50c53072b$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $cozmU.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $a4uy1.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $cozmU.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]); // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    }); // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $b44269c50c53072b$var$menuPortalStyles.root,
            (0, $k12R1.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $310h3.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $9kbTQ.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
}
const $b44269c50c53072b$export$793392f970497feb = (props)=>{
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1RR25.MenuPortalTopLayer), {
        ...props
    });
     // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b44269c50c53072b$var$MenuPortalLegacy, {
        ...props
    });
};
module.exports["MenuPortal"] = $b44269c50c53072b$export$793392f970497feb;

});

parcelRegister("a4uy1", function(module, exports) {

var $jjzZ3 = parcelRequire("jjzZ3");
var $ihhlg = parcelRequire("ihhlg");





var $3tq6j = parcelRequire("3tq6j");

function $7551f9448d197224$var$getCssDimensions(element) {
    const css = (0, $3tq6j.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $3tq6j.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ihhlg.round)(width) !== offsetWidth || (0, $ihhlg.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $7551f9448d197224$var$unwrapElement(element) {
    return !(0, $3tq6j.isElement)(element) ? element.contextElement : element;
}
function $7551f9448d197224$var$getScale(element) {
    const domElement = $7551f9448d197224$var$unwrapElement(element);
    if (!(0, $3tq6j.isHTMLElement)(domElement)) return (0, $ihhlg.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $7551f9448d197224$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ihhlg.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ihhlg.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $7551f9448d197224$var$noOffsets = /*#__PURE__*/ (0, $ihhlg.createCoords)(0);
function $7551f9448d197224$var$getVisualOffsets(element) {
    const win = (0, $3tq6j.getWindow)(element);
    if (!(0, $3tq6j.isWebKit)() || !win.visualViewport) return $7551f9448d197224$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $7551f9448d197224$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $3tq6j.getWindow)(element)) return false;
    return isFixed;
}
function $7551f9448d197224$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $7551f9448d197224$var$unwrapElement(element);
    let scale = (0, $ihhlg.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $3tq6j.isElement)(offsetParent)) scale = $7551f9448d197224$var$getScale(offsetParent);
        } else scale = $7551f9448d197224$var$getScale(element);
    }
    const visualOffsets = $7551f9448d197224$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $7551f9448d197224$var$getVisualOffsets(domElement) : (0, $ihhlg.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $3tq6j.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $3tq6j.isElement)(offsetParent) ? (0, $3tq6j.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $3tq6j.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $7551f9448d197224$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $3tq6j.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $3tq6j.getWindow)(currentIFrame);
            currentIFrame = (0, $3tq6j.getFrameElement)(currentWin);
        }
    }
    return (0, $ihhlg.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $7551f9448d197224$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $3tq6j.getNodeScroll)(element).scrollLeft;
    if (!rect) return $7551f9448d197224$var$getBoundingClientRect((0, $3tq6j.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $7551f9448d197224$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $7551f9448d197224$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $7551f9448d197224$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $3tq6j.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $3tq6j.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ihhlg.createCoords)(1);
    const offsets = (0, $ihhlg.createCoords)(0);
    const isOffsetParentAnElement = (0, $3tq6j.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3tq6j.getNodeName)(offsetParent) !== 'body' || (0, $3tq6j.isOverflowElement)(documentElement)) scroll = (0, $3tq6j.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $7551f9448d197224$var$getBoundingClientRect(offsetParent);
            scale = $7551f9448d197224$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $7551f9448d197224$var$getHTMLOffset(documentElement, scroll) : (0, $ihhlg.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $7551f9448d197224$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $7551f9448d197224$var$getDocumentRect(element) {
    const html = (0, $3tq6j.getDocumentElement)(element);
    const scroll = (0, $3tq6j.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ihhlg.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ihhlg.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $7551f9448d197224$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $3tq6j.getComputedStyle)(body).direction === 'rtl') x += (0, $ihhlg.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $7551f9448d197224$var$SCROLLBAR_MAX = 25;
function $7551f9448d197224$var$getViewportRect(element, strategy) {
    const win = (0, $3tq6j.getWindow)(element);
    const html = (0, $3tq6j.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $3tq6j.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $7551f9448d197224$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $7551f9448d197224$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $7551f9448d197224$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $7551f9448d197224$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $7551f9448d197224$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $3tq6j.isHTMLElement)(element) ? $7551f9448d197224$var$getScale(element) : (0, $ihhlg.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $7551f9448d197224$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $7551f9448d197224$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $7551f9448d197224$var$getDocumentRect((0, $3tq6j.getDocumentElement)(element));
    else if ((0, $3tq6j.isElement)(clippingAncestor)) rect = $7551f9448d197224$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $7551f9448d197224$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $ihhlg.rectToClientRect)(rect);
}
function $7551f9448d197224$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $3tq6j.getParentNode)(element);
    if (parentNode === stopNode || !(0, $3tq6j.isElement)(parentNode) || (0, $3tq6j.isLastTraversableNode)(parentNode)) return false;
    return (0, $3tq6j.getComputedStyle)(parentNode).position === 'fixed' || $7551f9448d197224$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $7551f9448d197224$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $3tq6j.getOverflowAncestors)(element, [], false).filter((el)=>(0, $3tq6j.isElement)(el) && (0, $3tq6j.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $3tq6j.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $3tq6j.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $3tq6j.isElement)(currentNode) && !(0, $3tq6j.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $3tq6j.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $3tq6j.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $3tq6j.isOverflowElement)(currentNode) && !currentNodeIsContaining && $7551f9448d197224$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $3tq6j.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $7551f9448d197224$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $3tq6j.isTopLayer)(element) ? [] : $7551f9448d197224$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $7551f9448d197224$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $7551f9448d197224$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $ihhlg.max)(rect.top, top);
        right = (0, $ihhlg.min)(rect.right, right);
        bottom = (0, $ihhlg.min)(rect.bottom, bottom);
        left = (0, $ihhlg.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $7551f9448d197224$var$getDimensions(element) {
    const { width: width, height: height } = $7551f9448d197224$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $7551f9448d197224$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $3tq6j.isHTMLElement)(offsetParent);
    const documentElement = (0, $3tq6j.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $7551f9448d197224$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ihhlg.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $7551f9448d197224$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3tq6j.getNodeName)(offsetParent) !== 'body' || (0, $3tq6j.isOverflowElement)(documentElement)) scroll = (0, $3tq6j.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $7551f9448d197224$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $7551f9448d197224$var$getHTMLOffset(documentElement, scroll) : (0, $ihhlg.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $7551f9448d197224$var$isStaticPositioned(element) {
    return (0, $3tq6j.getComputedStyle)(element).position === 'static';
}
function $7551f9448d197224$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $3tq6j.isHTMLElement)(element) || (0, $3tq6j.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $3tq6j.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $7551f9448d197224$var$getOffsetParent(element, polyfill) {
    const win = (0, $3tq6j.getWindow)(element);
    if ((0, $3tq6j.isTopLayer)(element)) return win;
    if (!(0, $3tq6j.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $3tq6j.getParentNode)(element);
        while(svgOffsetParent && !(0, $3tq6j.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $3tq6j.isElement)(svgOffsetParent) && !$7551f9448d197224$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $3tq6j.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $7551f9448d197224$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $3tq6j.isTableElement)(offsetParent) && $7551f9448d197224$var$isStaticPositioned(offsetParent))offsetParent = $7551f9448d197224$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $3tq6j.isLastTraversableNode)(offsetParent) && $7551f9448d197224$var$isStaticPositioned(offsetParent) && !(0, $3tq6j.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $3tq6j.getContainingBlock)(element) || win;
}
const $7551f9448d197224$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $7551f9448d197224$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $7551f9448d197224$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $7551f9448d197224$var$isRTL(element) {
    return (0, $3tq6j.getComputedStyle)(element).direction === 'rtl';
}
const $7551f9448d197224$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $7551f9448d197224$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $3tq6j.getDocumentElement,
    getClippingRect: $7551f9448d197224$var$getClippingRect,
    getOffsetParent: $7551f9448d197224$var$getOffsetParent,
    getElementRects: $7551f9448d197224$var$getElementRects,
    getClientRects: $7551f9448d197224$var$getClientRects,
    getDimensions: $7551f9448d197224$var$getDimensions,
    getScale: $7551f9448d197224$var$getScale,
    isElement: $3tq6j.isElement,
    isRTL: $7551f9448d197224$var$isRTL
};
function $7551f9448d197224$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $7551f9448d197224$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $3tq6j.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ihhlg.floor)(top);
        const insetRight = (0, $ihhlg.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ihhlg.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ihhlg.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ihhlg.max)(0, (0, $ihhlg.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$7551f9448d197224$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $7551f9448d197224$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $7551f9448d197224$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $3tq6j.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $3tq6j.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $7551f9448d197224$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $7551f9448d197224$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $7551f9448d197224$var$getBoundingClientRect(reference);
        if (prevRefRect && !$7551f9448d197224$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $7551f9448d197224$export$37b6bde19b108ecc = (0, $jjzZ3.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $7551f9448d197224$export$cc800923e997bb8 = (0, $jjzZ3.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $7551f9448d197224$export$91fb6ecbd551914 = (0, $jjzZ3.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $7551f9448d197224$export$fba63a578e423eb = (0, $jjzZ3.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $7551f9448d197224$export$8a83211c878a3f1f = (0, $jjzZ3.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $7551f9448d197224$export$346677f925de839c = (0, $jjzZ3.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $7551f9448d197224$export$fe8985bb6374093c = (0, $jjzZ3.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $7551f9448d197224$export$f2120bbfa5450bd2 = (0, $jjzZ3.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $7551f9448d197224$export$18c8ad048e32c7d5 = (0, $jjzZ3.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $7551f9448d197224$export$7bf07e38f3dc4b69 = (0, $jjzZ3.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $7551f9448d197224$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $7551f9448d197224$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $jjzZ3.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};
module.exports["autoUpdate"] = $7551f9448d197224$export$deee3a793edee05f;

});

parcelRegister("jjzZ3", function(module, exports) {
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("ihhlg")).rectToClientRect);

var $ihhlg = parcelRequire("ihhlg");

function $e0fbb449e8f98fd3$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ihhlg.getSideAxis)(placement);
    const alignmentAxis = (0, $ihhlg.getAlignmentAxis)(placement);
    const alignLength = (0, $ihhlg.getAxisLength)(alignmentAxis);
    const side = (0, $ihhlg.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ihhlg.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $e0fbb449e8f98fd3$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ihhlg.evaluate)(options, state);
    const paddingObject = (0, $ihhlg.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ihhlg.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ihhlg.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $e0fbb449e8f98fd3$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $e0fbb449e8f98fd3$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $e0fbb449e8f98fd3$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $e0fbb449e8f98fd3$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $e0fbb449e8f98fd3$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $e0fbb449e8f98fd3$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e0fbb449e8f98fd3$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ihhlg.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ihhlg.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ihhlg.getAlignmentAxis)(placement);
            const length = (0, $ihhlg.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ihhlg.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ihhlg.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ihhlg.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ihhlg.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $e0fbb449e8f98fd3$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ihhlg.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ihhlg.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ihhlg.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ihhlg.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ihhlg.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e0fbb449e8f98fd3$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ihhlg.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ihhlg.placements) ? $e0fbb449e8f98fd3$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ihhlg.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ihhlg.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ihhlg.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ihhlg.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e0fbb449e8f98fd3$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ihhlg.getSide)(placement);
            const initialSideAxis = (0, $ihhlg.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $ihhlg.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ihhlg.getOppositePlacement)(initialPlacement)
            ] : (0, $ihhlg.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $ihhlg.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ihhlg.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $ihhlg.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $ihhlg.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $ihhlg.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $e0fbb449e8f98fd3$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $e0fbb449e8f98fd3$var$isAnySideFullyClipped(overflow) {
    return (0, $ihhlg.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e0fbb449e8f98fd3$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $e0fbb449e8f98fd3$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $e0fbb449e8f98fd3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $e0fbb449e8f98fd3$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $e0fbb449e8f98fd3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $e0fbb449e8f98fd3$var$getBoundingRect(rects) {
    const minX = (0, $ihhlg.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ihhlg.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ihhlg.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ihhlg.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $e0fbb449e8f98fd3$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ihhlg.rectToClientRect)($e0fbb449e8f98fd3$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e0fbb449e8f98fd3$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ihhlg.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $e0fbb449e8f98fd3$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ihhlg.rectToClientRect)($e0fbb449e8f98fd3$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ihhlg.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ihhlg.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ihhlg.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ihhlg.getSide)(placement) === 'left';
                    const maxRight = (0, $ihhlg.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ihhlg.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $e0fbb449e8f98fd3$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $e0fbb449e8f98fd3$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ihhlg.getSide)(placement);
    const alignment = (0, $ihhlg.getAlignment)(placement);
    const isVertical = (0, $ihhlg.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $e0fbb449e8f98fd3$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ihhlg.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e0fbb449e8f98fd3$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $e0fbb449e8f98fd3$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e0fbb449e8f98fd3$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $ihhlg.getSideAxis)((0, $ihhlg.getSide)(placement));
            const mainAxis = (0, $ihhlg.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ihhlg.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ihhlg.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e0fbb449e8f98fd3$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ihhlg.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ihhlg.getSideAxis)(placement);
            const mainAxis = (0, $ihhlg.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ihhlg.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $e0fbb449e8f98fd3$var$originSides.has((0, $ihhlg.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e0fbb449e8f98fd3$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $ihhlg.getSide)(placement);
            const alignment = (0, $ihhlg.getAlignment)(placement);
            const isYAxis = (0, $ihhlg.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $ihhlg.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $ihhlg.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $ihhlg.max)(overflow.left, 0);
                const xMax = (0, $ihhlg.max)(overflow.right, 0);
                const yMin = (0, $ihhlg.max)(overflow.top, 0);
                const yMax = (0, $ihhlg.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ihhlg.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ihhlg.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
module.exports["detectOverflow"] = $e0fbb449e8f98fd3$export$37b6bde19b108ecc;
module.exports["computePosition"] = $e0fbb449e8f98fd3$export$48a53dcb22e581d0;
module.exports["arrow"] = $e0fbb449e8f98fd3$export$f2120bbfa5450bd2;
module.exports["autoPlacement"] = $e0fbb449e8f98fd3$export$91fb6ecbd551914;
module.exports["flip"] = $e0fbb449e8f98fd3$export$8a83211c878a3f1f;
module.exports["hide"] = $e0fbb449e8f98fd3$export$fe8985bb6374093c;
module.exports["inline"] = $e0fbb449e8f98fd3$export$18c8ad048e32c7d5;
module.exports["offset"] = $e0fbb449e8f98fd3$export$cc800923e997bb8;
module.exports["shift"] = $e0fbb449e8f98fd3$export$fba63a578e423eb;
module.exports["limitShift"] = $e0fbb449e8f98fd3$export$7bf07e38f3dc4b69;
module.exports["size"] = $e0fbb449e8f98fd3$export$346677f925de839c;

});

parcelRegister("ihhlg", function(module, exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $036f15bf293a6c04$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $036f15bf293a6c04$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $036f15bf293a6c04$export$803cd8101b6c182b = /*#__PURE__*/ $036f15bf293a6c04$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $036f15bf293a6c04$export$27b07d8a310ed8b5[0], side + "-" + $036f15bf293a6c04$export$27b07d8a310ed8b5[1]), []);
const $036f15bf293a6c04$export$96ec731ed4dcb222 = Math.min;
const $036f15bf293a6c04$export$8960430cfd85939f = Math.max;
const $036f15bf293a6c04$export$2077e0241d6afd3c = Math.round;
const $036f15bf293a6c04$export$a3fe094919f356fd = Math.floor;
const $036f15bf293a6c04$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $036f15bf293a6c04$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $036f15bf293a6c04$export$7d15b64cf5a3a4c4(start, value, end) {
    return $036f15bf293a6c04$export$8960430cfd85939f(start, $036f15bf293a6c04$export$96ec731ed4dcb222(value, end));
}
function $036f15bf293a6c04$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $036f15bf293a6c04$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $036f15bf293a6c04$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $036f15bf293a6c04$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $036f15bf293a6c04$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $036f15bf293a6c04$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $036f15bf293a6c04$export$2b57e0052a6d6d4c(placement) {
    return $036f15bf293a6c04$export$8a000a963141ac32($036f15bf293a6c04$export$f28e8f882010718a(placement));
}
function $036f15bf293a6c04$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $036f15bf293a6c04$export$f0989780f32bfcda(placement);
    const alignmentAxis = $036f15bf293a6c04$export$2b57e0052a6d6d4c(placement);
    const length = $036f15bf293a6c04$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $036f15bf293a6c04$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $036f15bf293a6c04$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $036f15bf293a6c04$export$496432a3699e50b1(placement) {
    const oppositePlacement = $036f15bf293a6c04$export$9c5e28bad23365fa(placement);
    return [
        $036f15bf293a6c04$export$2b182c584985588b(placement),
        oppositePlacement,
        $036f15bf293a6c04$export$2b182c584985588b(oppositePlacement)
    ];
}
function $036f15bf293a6c04$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $036f15bf293a6c04$var$lrPlacement = [
    'left',
    'right'
];
const $036f15bf293a6c04$var$rlPlacement = [
    'right',
    'left'
];
const $036f15bf293a6c04$var$tbPlacement = [
    'top',
    'bottom'
];
const $036f15bf293a6c04$var$btPlacement = [
    'bottom',
    'top'
];
function $036f15bf293a6c04$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $036f15bf293a6c04$var$rlPlacement : $036f15bf293a6c04$var$lrPlacement;
            return isStart ? $036f15bf293a6c04$var$lrPlacement : $036f15bf293a6c04$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $036f15bf293a6c04$var$tbPlacement : $036f15bf293a6c04$var$btPlacement;
        default:
            return [];
    }
}
function $036f15bf293a6c04$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $036f15bf293a6c04$export$f0989780f32bfcda(placement);
    let list = $036f15bf293a6c04$var$getSideList($036f15bf293a6c04$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($036f15bf293a6c04$export$2b182c584985588b));
    }
    return list;
}
function $036f15bf293a6c04$export$9c5e28bad23365fa(placement) {
    const side = $036f15bf293a6c04$export$3c915306cb7fc97a(placement);
    return $036f15bf293a6c04$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $036f15bf293a6c04$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $036f15bf293a6c04$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $036f15bf293a6c04$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $036f15bf293a6c04$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}
module.exports["sides"] = $036f15bf293a6c04$export$832b6fa47fa053d2;
module.exports["placements"] = $036f15bf293a6c04$export$803cd8101b6c182b;
module.exports["min"] = $036f15bf293a6c04$export$96ec731ed4dcb222;
module.exports["max"] = $036f15bf293a6c04$export$8960430cfd85939f;
module.exports["round"] = $036f15bf293a6c04$export$2077e0241d6afd3c;
module.exports["floor"] = $036f15bf293a6c04$export$a3fe094919f356fd;
module.exports["createCoords"] = $036f15bf293a6c04$export$a397704b5e280835;
module.exports["clamp"] = $036f15bf293a6c04$export$7d15b64cf5a3a4c4;
module.exports["evaluate"] = $036f15bf293a6c04$export$fef61f332f2c0afc;
module.exports["getSide"] = $036f15bf293a6c04$export$3c915306cb7fc97a;
module.exports["getAlignment"] = $036f15bf293a6c04$export$f0989780f32bfcda;
module.exports["getOppositeAxis"] = $036f15bf293a6c04$export$8a000a963141ac32;
module.exports["getAxisLength"] = $036f15bf293a6c04$export$320bd9d53520c68a;
module.exports["getSideAxis"] = $036f15bf293a6c04$export$f28e8f882010718a;
module.exports["getAlignmentAxis"] = $036f15bf293a6c04$export$2b57e0052a6d6d4c;
module.exports["getAlignmentSides"] = $036f15bf293a6c04$export$be42861551f17911;
module.exports["getOppositePlacement"] = $036f15bf293a6c04$export$9c5e28bad23365fa;
module.exports["getExpandedPlacements"] = $036f15bf293a6c04$export$496432a3699e50b1;
module.exports["getOppositeAlignmentPlacement"] = $036f15bf293a6c04$export$2b182c584985588b;
module.exports["getOppositeAxisPlacements"] = $036f15bf293a6c04$export$a9b6fb18fd92c3ec;
module.exports["getPaddingObject"] = $036f15bf293a6c04$export$598c291c29bc2e71;
module.exports["rectToClientRect"] = $036f15bf293a6c04$export$ee05aea0aeecbad4;

});

parcelRegister("3tq6j", function(module, exports) {
function $2878539f0586caca$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $2878539f0586caca$export$651544f548703224(node) {
    if ($2878539f0586caca$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $2878539f0586caca$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $2878539f0586caca$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($2878539f0586caca$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $2878539f0586caca$export$8ee0fc9ee280b4ee(value) {
    if (!$2878539f0586caca$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).Node;
}
function $2878539f0586caca$export$45a5e7f76e0caa8d(value) {
    if (!$2878539f0586caca$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).Element;
}
function $2878539f0586caca$export$1b3bfaa9684536aa(value) {
    if (!$2878539f0586caca$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).HTMLElement;
}
function $2878539f0586caca$export$af51f0f06c0f328a(value) {
    if (!$2878539f0586caca$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $2878539f0586caca$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $2878539f0586caca$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $2878539f0586caca$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($2878539f0586caca$export$651544f548703224(element));
}
function $2878539f0586caca$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $2878539f0586caca$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $2878539f0586caca$var$containRe = /paint|layout|strict|content/;
const $2878539f0586caca$var$isNotNone = (value)=>!!value && value !== 'none';
let $2878539f0586caca$var$isWebKitValue;
function $2878539f0586caca$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $2878539f0586caca$export$45a5e7f76e0caa8d(elementOrCss) ? $2878539f0586caca$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $2878539f0586caca$var$isNotNone(css.transform) || $2878539f0586caca$var$isNotNone(css.translate) || $2878539f0586caca$var$isNotNone(css.scale) || $2878539f0586caca$var$isNotNone(css.rotate) || $2878539f0586caca$var$isNotNone(css.perspective) || !$2878539f0586caca$export$78551043582a6a98() && ($2878539f0586caca$var$isNotNone(css.backdropFilter) || $2878539f0586caca$var$isNotNone(css.filter)) || $2878539f0586caca$var$willChangeRe.test(css.willChange || '') || $2878539f0586caca$var$containRe.test(css.contain || '');
}
function $2878539f0586caca$export$940d8225183e1404(element) {
    let currentNode = $2878539f0586caca$export$4e12058fc4d51d56(element);
    while($2878539f0586caca$export$1b3bfaa9684536aa(currentNode) && !$2878539f0586caca$export$d1162fb0b6d4cd51(currentNode)){
        if ($2878539f0586caca$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($2878539f0586caca$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $2878539f0586caca$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $2878539f0586caca$export$78551043582a6a98() {
    if ($2878539f0586caca$var$isWebKitValue == null) $2878539f0586caca$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $2878539f0586caca$var$isWebKitValue;
}
function $2878539f0586caca$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($2878539f0586caca$export$651544f548703224(node));
}
function $2878539f0586caca$export$3735103072e4a80(element) {
    return $2878539f0586caca$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $2878539f0586caca$export$dc8fc79fa2800137(element) {
    if ($2878539f0586caca$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $2878539f0586caca$export$4e12058fc4d51d56(node) {
    if ($2878539f0586caca$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $2878539f0586caca$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $2878539f0586caca$export$e495491855dc5418(node);
    return $2878539f0586caca$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $2878539f0586caca$export$7cd01a57c8ca906c(node) {
    const parentNode = $2878539f0586caca$export$4e12058fc4d51d56(node);
    if ($2878539f0586caca$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($2878539f0586caca$export$1b3bfaa9684536aa(parentNode) && $2878539f0586caca$export$989e911fa9af580a(parentNode)) return parentNode;
    return $2878539f0586caca$export$7cd01a57c8ca906c(parentNode);
}
function $2878539f0586caca$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $2878539f0586caca$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $2878539f0586caca$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $2878539f0586caca$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $2878539f0586caca$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $2878539f0586caca$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $2878539f0586caca$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $2878539f0586caca$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
module.exports["getNodeName"] = $2878539f0586caca$export$651544f548703224;
module.exports["getWindow"] = $2878539f0586caca$export$38b2d434cce3ea22;
module.exports["getDocumentElement"] = $2878539f0586caca$export$e495491855dc5418;
module.exports["isElement"] = $2878539f0586caca$export$45a5e7f76e0caa8d;
module.exports["isHTMLElement"] = $2878539f0586caca$export$1b3bfaa9684536aa;
module.exports["isOverflowElement"] = $2878539f0586caca$export$989e911fa9af580a;
module.exports["getComputedStyle"] = $2878539f0586caca$export$3735103072e4a80;
module.exports["isTableElement"] = $2878539f0586caca$export$71535ffaa902797f;
module.exports["isTopLayer"] = $2878539f0586caca$export$89e651af02346cd4;
module.exports["isContainingBlock"] = $2878539f0586caca$export$d6c4e8150c35fed1;
module.exports["isWebKit"] = $2878539f0586caca$export$78551043582a6a98;
module.exports["getContainingBlock"] = $2878539f0586caca$export$940d8225183e1404;
module.exports["getParentNode"] = $2878539f0586caca$export$4e12058fc4d51d56;
module.exports["isLastTraversableNode"] = $2878539f0586caca$export$d1162fb0b6d4cd51;
module.exports["getNodeScroll"] = $2878539f0586caca$export$dc8fc79fa2800137;
module.exports["getOverflowAncestors"] = $2878539f0586caca$export$3b57c1601291186b;
module.exports["getFrameElement"] = $2878539f0586caca$export$7bf1f8740e3e34af;

});

parcelRegister("310h3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8085fafb706d58da$export$e001f626511a0ead = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["PortalPlacementContext"] = $8085fafb706d58da$export$e001f626511a0ead;

});

parcelRegister("1RR25", function(module, exports) {
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $5Tdig = parcelRequire("5Tdig");


var $kVXS3 = parcelRequire("kVXS3");


var $97Yf0 = parcelRequire("97Yf0");


var $hPK4E = parcelRequire("hPK4E");


var $k4Jbz = parcelRequire("k4Jbz");


var $70HV3 = parcelRequire("70HV3");

function $3e266eed0a999110$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const $3e266eed0a999110$var$menuPortalStyles = {
    root: "_1BYlJIJavW"
}; /**
    * Top-layer host for react-select's menu. Hands positioning, flip, and width
    * to `@atlaskit/top-layer`; ignores `appendTo` / `menuPortalTarget` /
    * `menuPosition`. The browser-dismiss handler is supplied internally by
    * `Select` via `MenuPortalCloseContext`.
    *
    * @example
    * ```tsx
    * <MenuPortalTopLayer controlElement={el} menuPlacement="bottom">
    *   <Menu />
    * </MenuPortalTopLayer>
    * ```
    */ 
function $3e266eed0a999110$export$1f5427c7f5364d0b(props) {
    const { children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props; // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, $cozmU.useContext)((0, $70HV3.MenuPortalCloseContext));
    const popoverRef = (0, $cozmU.useRef)(null); // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, $cozmU.useRef)(null);
    anchorRef.current = controlElement; // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null; // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $3e266eed0a999110$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $hPK4E.useWidthFromAnchor)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    const handlePopoverClose = (0, $cozmU.useCallback)(()=>{
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]); // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }); // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className: className } = (0, $k4Jbz.getStyleProps)({
        ...props,
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }, 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="manual"` opts out of native light-dismiss: react-select already
    // owns outside-click and Escape via its own handlers, and the combobox
    // trigger lives in a separate DOM subtree that the spec algorithm cannot
    // see. Matches the pattern in `@atlaskit/datetime-picker`'s MenuTopLayer.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // `className` carries consumer `styles.menuPortal({...})` output,
            // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
            // is a legacy selector hook kept for parity with MenuPortalLegacy.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
            className: (0, $hekY6.default)([
                $3e266eed0a999110$var$menuPortalStyles.root,
                (0, $k12R1.cx)(className, xcss, '-MenuPortal')
            ]),
            ...innerProps,
            children: children
        })
    });
}
module.exports["MenuPortalTopLayer"] = $3e266eed0a999110$export$1f5427c7f5364d0b;

});

parcelRegister("70HV3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $44c475e003825a89$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["MenuPortalCloseContext"] = $44c475e003825a89$export$a0d5b29fa9affc38;

});

parcelRegister("jRelA", function(module, exports) {
/* multi-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $IOtUu = parcelRequire("IOtUu");


var $k4Jbz = parcelRequire("k4Jbz");


var $lgyeF = parcelRequire("lgyeF");


var $1OAP8 = parcelRequire("1OAP8");


var $jxk0F = parcelRequire("jxk0F");

const $f872b998c5f0f390$var$multiValueTagWrapperStyles = {
    root: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3SamIHPgdg _2YLqiKPgdg _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIPgdg _2kO3ta7dHp _23x1DK7dHp _2C4fi9AEMG _0fdRYlDIqT _0ReY56Q4SZ _412qNSPgdg"
}; // Tag-like color styles
const $f872b998c5f0f390$var$tagLikeColorStyles = {
    gray: "_2ssR4FiXlq",
    blue: "_2ssR4F432W",
    green: "_2ssR4FWIYU",
    red: "_2ssR4FDVsW",
    yellow: "_2ssR4FKuhU",
    purple: "_2ssR4FrKVc",
    lime: "_2ssR4Fb94u",
    magenta: "_2ssR4FULTZ",
    orange: "_2ssR4FPz9H",
    teal: "_2ssR4FMMwr"
};
const $f872b998c5f0f390$var$tagLikeBorderFilterStyles = null; // Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $f872b998c5f0f390$var$multiValueTagLikeStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _2sNsIg7NXe _3hxITi6wH8 _2V7sgONvrM _3SamIHPgdg _2YLqiKPgdg _3iDTPbccYA _24h04i2Njc _1mT5xdRAKS _0hPCNLDIqT _4xdlr0DIqT _4ouGXIPgdg _3YEZNO7dHp _1EqgXl6zFX _0jFU0VbKFA _0KLXru66of _1UtDYzy7kJ _0wOv4Q18ZR _0gdQWVYbGa",
    labelWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIPgdg _4kiQYAdnbC _09lPhhOLYo",
    disabled: "_1UtDYzot27 _0KLXruDMqu",
    focused: "_1UtDYzjTy9 _0KLXruo126 _2OUyjtUbsb _33VGdrNvrM _0s2BChjOvk _4zUdn16wH8"
};
const $f872b998c5f0f390$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data?.label;
    return typeof label === 'string' ? label : '';
};
const $f872b998c5f0f390$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $f872b998c5f0f390$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const { css: containerCss, className: containerClassName } = (0, $k4Jbz.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $k4Jbz.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $k4Jbz.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $jxk0F.MultiValueLabel);
    const hasCustomContainer = Container !== (0, $1OAP8.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean(selectStyles?.multiValue || selectStyles?.multiValueLabel || selectStyles?.multiValueRemove);
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean(selectClassNames?.multiValue || selectClassNames?.multiValueLabel || selectClassNames?.multiValueRemove); // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $lgyeF.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...innerProps,
            className: (0, $hekY6.default)([
                $f872b998c5f0f390$var$multiValueTagWrapperStyles.root,
                (0, $k12R1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: `${labelText}, remove`,
                onBeforeRemoveAction: ()=>{
                    removeProps.onClick?.({});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    } // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        const colorKey = data?.color;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            style: containerCss,
            className: (0, $hekY6.default)([
                $f872b998c5f0f390$var$multiValueTagLikeStyles.root,
                $f872b998c5f0f390$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $f872b998c5f0f390$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $f872b998c5f0f390$var$tagLikeColorStyles.green,
                colorKey === 'red' && $f872b998c5f0f390$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $f872b998c5f0f390$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $f872b998c5f0f390$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $f872b998c5f0f390$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $f872b998c5f0f390$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $f872b998c5f0f390$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $f872b998c5f0f390$var$tagLikeColorStyles.teal,
                "_3vBAKHvQ39",
                isDisabled && $f872b998c5f0f390$var$multiValueTagLikeStyles.disabled,
                isFocused && $f872b998c5f0f390$var$multiValueTagLikeStyles.focused,
                (0, $k12R1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $f872b998c5f0f390$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    } // FF off → default styles
    return /*#__PURE__*/ (0, $8aG6j.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f872b998c5f0f390$export$2e2bcd8739ae039 = $f872b998c5f0f390$var$MultiValue;
module.exports["default"] = $f872b998c5f0f390$export$2e2bcd8739ae039;

});

parcelRegister("lgyeF", function(module, exports) {
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $cozmU = parcelRequire("cozmU");


var $22s7D = parcelRequire("22s7D");

const $b44a4f40086e07f5$export$2a533455c10aa11f = ()=>(0, $cozmU.useContext)((0, $22s7D.SelectGetStylesContext));
module.exports["useSelectGetStyles"] = $b44a4f40086e07f5$export$2a533455c10aa11f;

});

parcelRegister("22s7D", function(module, exports) {
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $cozmU = parcelRequire("cozmU");

const $209eee172d92c14c$export$50727c0a52da4015 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["SelectGetStylesContext"] = $209eee172d92c14c$export$50727c0a52da4015;

});

parcelRegister("jxk0F", function(module, exports) {
/* multi-value-label.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");

const $eb10c4bb8401dbff$var$multiValueLabelStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDcjp5 _2sNsIgmnOE _1ANEUSLRg7 _03SyCPFQfX _0LQT5E1Y8M _1UtDYzOLYo",
    disabled: "_1UtDYzot27",
    ellipsis: "_39HuIbz8Lp"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $eb10c4bb8401dbff$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        className: (0, $hekY6.default)([
            $eb10c4bb8401dbff$var$multiValueLabelStyles.root,
            isDisabled && $eb10c4bb8401dbff$var$multiValueLabelStyles.disabled,
            hasEllipsis && $eb10c4bb8401dbff$var$multiValueLabelStyles.ellipsis,
            (0, $k12R1.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
module.exports["MultiValueLabel"] = $eb10c4bb8401dbff$export$544aeea2a5ce08ee;

});

parcelRegister("idc4a", function(module, exports) {
/* multi-value-remove.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $l3wuH = parcelRequire("l3wuH");

const $f40c950c9b8482e4$var$disabledStyles = null;
const $f40c950c9b8482e4$var$enabledStyles = null;
const $f40c950c9b8482e4$var$multiValueRemoveStyles = {
    focused: "_0KLXrucZWP _1rdFvhjTy9",
    root: "_30huDKYbGa _0bjKvDKxmn _0hPCNLDIqT _37wbyuDIqT _4xdlr0DIqT _034jHtYbGa _0KLXru66of _1UtDYzy7kJ _3iDTPbQ4SZ _1rdFvhy7kJ _46hvQmFQfX _03SyCPFQfX _0xmtkoFQfX _0LQT5EFQfX _2xTnZxFQfX _34b3D2pgTj _1eOmH6o126 _2AVwAQAyGJ _3gzVzLN4oS _1cgZWFAyGJ"
};
function $f40c950c9b8482e4$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        className: (0, $hekY6.default)([
            $f40c950c9b8482e4$var$multiValueRemoveStyles.root,
            isFocused && $f40c950c9b8482e4$var$multiValueRemoveStyles.focused,
            (0, $k12R1.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $hekY6.default)([
                isDisabled && "_3iDTPbYbGa",
                !isDisabled && "_3iDTPbOLYo"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}
module.exports["MultiValueRemove"] = $f40c950c9b8482e4$export$8e1fd1a40e7a2f4a;

});

parcelRegister("lzeON", function(module, exports) {
/* option.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");

const $d398d66bfaec3d5a$var$optionStyles = {
    root: "_4c065UgVvo _2Y7lL48HPE _1UtDYzy7kJ _0wOv4Q18ZR _3iDTPbvLZJ _4ya3eEOLYo _39xV02N91d _20VacPYbGa _2X4BecWrS5 _3gzVzLN4oS",
    disabled: "_1UtDYzot27 _0wOv4Qsyl5 _0KLXrujOvk _2OUyjtYbGa _3gzVzLjOvk _2rG9p6YbGa",
    focused: "_0KLXruo126 _2OUyjtsKwa _2rG9p6TjXh",
    selected: "_1UtDYzjTy9 _0KLXruY9q9 _2OUyjtsKwa _3gzVzLXsxn _2rG9p6TjXh",
    focusedSelected: "_0KLXrusumd",
    motion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const $d398d66bfaec3d5a$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $d398d66bfaec3d5a$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $d398d66bfaec3d5a$var$optionStyles.motion,
            isFocused && $d398d66bfaec3d5a$var$optionStyles.focused,
            isSelected && $d398d66bfaec3d5a$var$optionStyles.selected,
            isFocused && isSelected && $d398d66bfaec3d5a$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $d398d66bfaec3d5a$var$optionStyles.motionSelected,
            isDisabled && $d398d66bfaec3d5a$var$optionStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $d398d66bfaec3d5a$export$2e2bcd8739ae039 = $d398d66bfaec3d5a$var$Option;
module.exports["default"] = $d398d66bfaec3d5a$export$2e2bcd8739ae039;

});

parcelRegister("eMtSk", function(module, exports) {
/* placeholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $16deef2071d68a24$var$placeholderStyles = {
    root: "_1xC2CJpl7Y _43nrzTdnbC _2xTnZxFQfX _0rIjykdnbC _0GTcwRFQfX _1UtDYzKGUX",
    disabled: "_1UtDYzot27"
};
const $16deef2071d68a24$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $16deef2071d68a24$var$placeholderStyles.root,
            isDisabled && $16deef2071d68a24$var$placeholderStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$16deef2071d68a24$export$2e2bcd8739ae039 = $16deef2071d68a24$var$Placeholder;
module.exports["default"] = $16deef2071d68a24$export$2e2bcd8739ae039;

});

parcelRegister("fb3M0", function(module, exports) {
/* single-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $cf350c196e5d2294$var$styles = {
    root: "_1xC2CJpl7Y _4bt5LAnQyn _2WAcuGnQyn _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7 _43nrzTdnbC _2xTnZxFQfX _0rIjykdnbC _0GTcwRFQfX _1UtDYzy7kJ",
    disalbed: "_1UtDYzot27"
};
const $cf350c196e5d2294$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $cf350c196e5d2294$var$styles.root,
            isDisabled && $cf350c196e5d2294$var$styles.disalbed,
            (0, $k12R1.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $cf350c196e5d2294$export$2e2bcd8739ae039 = $cf350c196e5d2294$var$SingleValue;
module.exports["default"] = $cf350c196e5d2294$export$2e2bcd8739ae039;

});

parcelRegister("goKry", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports
const $24a203ae40efce07$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
module.exports["isDateDisabled"] = $24a203ae40efce07$export$d38e7e283938128c;

});

parcelRegister("dAzeP", function(module, exports) {
/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $buG8Z = parcelRequire("buG8Z");


var $1ZDKy = parcelRequire("1ZDKy");


var $iDrrr = parcelRequire("iDrrr");


var $a0UNJ = parcelRequire("a0UNJ");

function $3c56044decc29caa$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $k5sGX.default)(iso);
        return (0, $esV19.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $3c56044decc29caa$var$menuStyles = null;
const $3c56044decc29caa$var$menuStylesT26Shape = null; /**
                                  * This is the menu used in the select of the date picker.
                                  */ 
const $3c56044decc29caa$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $3c56044decc29caa$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $cozmU.Fragment);
    return /*#__PURE__*/ $cozmU.createElement((0, $1ZDKy.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $a0UNJ.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ $cozmU.createElement("div", {
            ...innerProps,
            onMouseDown: onMenuMouseDown,
            className: (0, $hekY6.default)([
                "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _42Yu6BPvK5 _0KLXruoI2d _2OUyjtGk8v",
                (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_0bjKvD8fU6"
            ])
        }, /*#__PURE__*/ $cozmU.createElement(Wrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $buG8Z.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        }))),
        testId: selectProps.testId
    }));
};
module.exports["Menu"] = $3c56044decc29caa$export$d9b273488cd8ce6f;

});

parcelRegister("buG8Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $6JrSr = parcelRequire("6JrSr");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $CIxco = parcelRequire("CIxco");


var $4kl0X = parcelRequire("4kl0X");


var $RzcOF = parcelRequire("RzcOF");


var $2lTKb = parcelRequire("2lTKb");


var $669cn = parcelRequire("669cn");


var $lq3dZ = parcelRequire("lq3dZ");


var $2NGTx = parcelRequire("2NGTx");


var $3f826 = parcelRequire("3f826");


var $dEHey = parcelRequire("dEHey");

const $031e002627f496f2$var$styles = {
    box: "_3iDTPbvbI6 _20VacPYbGa"
};
const $031e002627f496f2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $031e002627f496f2$var$InnerCalendar = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Calendar(t0, ref) {
    const $ = (0, $bDgLe.c)(142);
    const { day: day, defaultDay: t1, defaultMonth: t2, defaultPreviouslySelected: t3, defaultSelected: t4, defaultYear: t5, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: t6, onChange: t7, onFocus: t8, onSelect: t9, previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: t10, today: today, locale: t11, year: year, analyticsContext: analyticsContext, weekStartDay: t12, testId: testId, className: className, style: style, tabIndex: t13 } = t0;
    const defaultDay = t1 === undefined ? 0 : t1;
    const defaultMonth = t2 === undefined ? 0 : t2;
    let t14;
    if ($[0] !== t3) {
        t14 = t3 === undefined ? [] : t3;
        $[0] = t3;
        $[1] = t14;
    } else t14 = $[1];
    const defaultPreviouslySelected = t14;
    let t15;
    if ($[2] !== t4) {
        t15 = t4 === undefined ? [] : t4;
        $[2] = t4;
        $[3] = t15;
    } else t15 = $[3];
    const defaultSelected = t15;
    const defaultYear = t5 === undefined ? 0 : t5;
    const onBlur = t6 === undefined ? (0, $dpsRj.default) : t6;
    const onChange = t7 === undefined ? (0, $dpsRj.default) : t7;
    const onFocus = t8 === undefined ? (0, $dpsRj.default) : t8;
    const onSelect = t9 === undefined ? (0, $dpsRj.default) : t9;
    const shouldSetFocusOnCurrentDay = t10 === undefined ? false : t10;
    const locale = t11 === undefined ? "en-US" : t11;
    const weekStartDay = t12 === undefined ? 0 : t12;
    const tabIndex = t13 === undefined ? 0 : t13;
    let t16;
    if ($[4] !== day || $[5] !== defaultDay || $[6] !== defaultMonth || $[7] !== defaultPreviouslySelected || $[8] !== defaultSelected || $[9] !== defaultYear || $[10] !== month || $[11] !== previouslySelected || $[12] !== selected || $[13] !== today || $[14] !== year) {
        t16 = {
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        };
        $[4] = day;
        $[5] = defaultDay;
        $[6] = defaultMonth;
        $[7] = defaultPreviouslySelected;
        $[8] = defaultSelected;
        $[9] = defaultYear;
        $[10] = month;
        $[11] = previouslySelected;
        $[12] = selected;
        $[13] = today;
        $[14] = year;
        $[15] = t16;
    } else t16 = $[15];
    const { day: t17, month: t18, year: t19, today: t20, selected: t21, previous: t22 } = (0, $2lTKb.default)(t16);
    const [dayValue, setDayValue] = t17;
    const [monthValue, setMonthValue] = t18;
    const [yearValue, setYearValue] = t19;
    const [todayValue] = t20;
    const [selectedValue, setSelectedValue] = t21;
    const [previouslySelectedValue, setPreviouslySelectedValue] = t22;
    const [shouldSetFocus, setShouldSetFocus] = (0, $cozmU.useState)(false);
    let t23;
    if ($[16] !== analyticsContext || $[17] !== onChange) {
        t23 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            ...$031e002627f496f2$var$analyticsAttributes
        };
        $[16] = analyticsContext;
        $[17] = onChange;
        $[18] = t23;
    } else t23 = $[18];
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t23);
    let t24;
    if ($[19] !== dayValue || $[20] !== setDayValue) {
        t24 = [
            dayValue,
            setDayValue
        ];
        $[19] = dayValue;
        $[20] = setDayValue;
        $[21] = t24;
    } else t24 = $[21];
    let t25;
    if ($[22] !== monthValue || $[23] !== setMonthValue) {
        t25 = [
            monthValue,
            setMonthValue
        ];
        $[22] = monthValue;
        $[23] = setMonthValue;
        $[24] = t25;
    } else t25 = $[24];
    let t26;
    if ($[25] !== setYearValue || $[26] !== yearValue) {
        t26 = [
            yearValue,
            setYearValue
        ];
        $[25] = setYearValue;
        $[26] = yearValue;
        $[27] = t26;
    } else t26 = $[27];
    let t27;
    if ($[28] !== shouldSetFocus) {
        t27 = [
            shouldSetFocus,
            setShouldSetFocus
        ];
        $[28] = shouldSetFocus;
        $[29] = t27;
    } else t27 = $[29];
    let t28;
    if ($[30] !== onChangeWithAnalytics || $[31] !== t24 || $[32] !== t25 || $[33] !== t26 || $[34] !== t27) {
        t28 = {
            day: t24,
            month: t25,
            year: t26,
            shouldSetFocus: t27,
            onChange: onChangeWithAnalytics
        };
        $[30] = onChangeWithAnalytics;
        $[31] = t24;
        $[32] = t25;
        $[33] = t26;
        $[34] = t27;
        $[35] = t28;
    } else t28 = $[35];
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2NGTx.default)(t28);
    let t29;
    if ($[36] !== analyticsContext || $[37] !== onSelect) {
        t29 = {
            fn: onSelect,
            action: "selected",
            analyticsData: analyticsContext,
            ...$031e002627f496f2$var$analyticsAttributes
        };
        $[36] = analyticsContext;
        $[37] = onSelect;
        $[38] = t29;
    } else t29 = $[38];
    const onSelectWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t29);
    let t30;
    if ($[39] !== dayValue || $[40] !== setDayValue) {
        t30 = [
            dayValue,
            setDayValue
        ];
        $[39] = dayValue;
        $[40] = setDayValue;
        $[41] = t30;
    } else t30 = $[41];
    let t31;
    if ($[42] !== monthValue || $[43] !== setMonthValue) {
        t31 = [
            monthValue,
            setMonthValue
        ];
        $[42] = monthValue;
        $[43] = setMonthValue;
        $[44] = t31;
    } else t31 = $[44];
    let t32;
    if ($[45] !== setYearValue || $[46] !== yearValue) {
        t32 = [
            yearValue,
            setYearValue
        ];
        $[45] = setYearValue;
        $[46] = yearValue;
        $[47] = t32;
    } else t32 = $[47];
    let t33;
    if ($[48] !== selectedValue || $[49] !== setSelectedValue) {
        t33 = [
            selectedValue,
            setSelectedValue
        ];
        $[48] = selectedValue;
        $[49] = setSelectedValue;
        $[50] = t33;
    } else t33 = $[50];
    let t34;
    if ($[51] !== setPreviouslySelectedValue) {
        t34 = [
            ,
            setPreviouslySelectedValue
        ];
        $[51] = setPreviouslySelectedValue;
        $[52] = t34;
    } else t34 = $[52];
    let t35;
    if ($[53] !== navigate || $[54] !== onSelectWithAnalytics || $[55] !== t30 || $[56] !== t31 || $[57] !== t32 || $[58] !== t33 || $[59] !== t34) {
        t35 = {
            day: t30,
            month: t31,
            year: t32,
            selected: t33,
            previous: t34,
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        };
        $[53] = navigate;
        $[54] = onSelectWithAnalytics;
        $[55] = t30;
        $[56] = t31;
        $[57] = t32;
        $[58] = t33;
        $[59] = t34;
        $[60] = t35;
    } else t35 = $[60];
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $3f826.default)(t35);
    let t36;
    if ($[61] !== onBlur || $[62] !== onFocus) {
        t36 = {
            onFocus: onFocus,
            onBlur: onBlur
        };
        $[61] = onBlur;
        $[62] = onFocus;
        $[63] = t36;
    } else t36 = $[63];
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $669cn.default)(t36);
    let t37;
    if ($[64] !== locale || $[65] !== weekStartDay) {
        t37 = {
            locale: locale,
            weekStartDay: weekStartDay
        };
        $[64] = locale;
        $[65] = weekStartDay;
        $[66] = t37;
    } else t37 = $[66];
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $dEHey.default)(t37);
    let t38;
    if ($[67] !== dayValue || $[68] !== daysLong || $[69] !== disabled || $[70] !== disabledDateFilter || $[71] !== maxDate || $[72] !== minDate || $[73] !== monthValue || $[74] !== previouslySelectedValue || $[75] !== selectedValue || $[76] !== todayValue || $[77] !== weekStartDay || $[78] !== yearValue) {
        t38 = {
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        };
        $[67] = dayValue;
        $[68] = daysLong;
        $[69] = disabled;
        $[70] = disabledDateFilter;
        $[71] = maxDate;
        $[72] = minDate;
        $[73] = monthValue;
        $[74] = previouslySelectedValue;
        $[75] = selectedValue;
        $[76] = todayValue;
        $[77] = weekStartDay;
        $[78] = yearValue;
        $[79] = t38;
    } else t38 = $[79];
    const weeks = (0, $lq3dZ.default)(t38);
    let t39;
    if ($[80] !== monthValue || $[81] !== monthsLong || $[82] !== yearValue) {
        t39 = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        $[80] = monthValue;
        $[81] = monthsLong;
        $[82] = yearValue;
        $[83] = t39;
    } else t39 = $[83];
    const getNextMonthHeading = t39;
    let t40;
    if ($[84] !== monthValue || $[85] !== monthsLong || $[86] !== yearValue) {
        t40 = ()=>{
            const thisMonth = (monthValue - 1) % 12;
            const nextYear = yearValue + 1;
            return `${monthsLong[thisMonth]} ${nextYear}`;
        };
        $[84] = monthValue;
        $[85] = monthsLong;
        $[86] = yearValue;
        $[87] = t40;
    } else t40 = $[87];
    const getNextYearHeading = t40;
    let t41;
    if ($[88] !== monthValue || $[89] !== monthsLong || $[90] !== yearValue) {
        t41 = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        $[88] = monthValue;
        $[89] = monthsLong;
        $[90] = yearValue;
        $[91] = t41;
    } else t41 = $[91];
    const getPreviousMonthHeading = t41;
    let t42;
    if ($[92] !== monthValue || $[93] !== monthsLong || $[94] !== yearValue) {
        t42 = ()=>{
            const thisMonth_0 = (monthValue - 1) % 12;
            const previousYear = yearValue - 1;
            return `${monthsLong[thisMonth_0]} ${previousYear}`;
        };
        $[92] = monthValue;
        $[93] = monthsLong;
        $[94] = yearValue;
        $[95] = t42;
    } else t42 = $[95];
    const getPreviousYearHeading = t42;
    const headerId = (0, $6JrSr.useId)();
    const t43 = testId && `${testId}--container`;
    const t44 = testId && `${testId}--calendar`;
    const t45 = monthsLong[monthValue - 1];
    const t46 = getNextMonthHeading();
    const t47 = getNextYearHeading();
    const t48 = getPreviousMonthHeading();
    const t49 = getPreviousYearHeading();
    let t50;
    if ($[96] !== handleClickNextMonth || $[97] !== handleClickNextYear || $[98] !== handleClickPrevMonth || $[99] !== handleClickPrevYear || $[100] !== headerId || $[101] !== nextMonthLabel || $[102] !== previousMonthLabel || $[103] !== t45 || $[104] !== t46 || $[105] !== t47 || $[106] !== t48 || $[107] !== t49 || $[108] !== tabIndex || $[109] !== testId || $[110] !== yearValue) {
        t50 = /*#__PURE__*/ $cozmU.createElement((0, $CIxco.default), {
            monthLongTitle: t45,
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextMonthHeading: t46,
            nextYearHeading: t47,
            previousMonthHeading: t48,
            previousYearHeading: t49,
            handleClickNextMonth: handleClickNextMonth,
            handleClickNextYear: handleClickNextYear,
            handleClickPrevMonth: handleClickPrevMonth,
            handleClickPrevYear: handleClickPrevYear,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        });
        $[96] = handleClickNextMonth;
        $[97] = handleClickNextYear;
        $[98] = handleClickPrevMonth;
        $[99] = handleClickPrevYear;
        $[100] = headerId;
        $[101] = nextMonthLabel;
        $[102] = previousMonthLabel;
        $[103] = t45;
        $[104] = t46;
        $[105] = t47;
        $[106] = t48;
        $[107] = t49;
        $[108] = tabIndex;
        $[109] = testId;
        $[110] = yearValue;
        $[111] = t50;
    } else t50 = $[111];
    const t51 = testId && `${testId}--calendar-dates`;
    let t52;
    if ($[112] !== daysShort || $[113] !== testId) {
        t52 = /*#__PURE__*/ $cozmU.createElement((0, $RzcOF.default), {
            daysShort: daysShort,
            testId: testId
        });
        $[112] = daysShort;
        $[113] = testId;
        $[114] = t52;
    } else t52 = $[114];
    const t53 = shouldSetFocus || shouldSetFocusOnCurrentDay;
    let t54;
    if ($[115] !== handleClickDay || $[116] !== monthsLong || $[117] !== t53 || $[118] !== tabIndex || $[119] !== testId || $[120] !== weeks) {
        t54 = /*#__PURE__*/ $cozmU.createElement((0, $4kl0X.default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: t53,
            tabIndex: tabIndex,
            testId: testId
        });
        $[115] = handleClickDay;
        $[116] = monthsLong;
        $[117] = t53;
        $[118] = tabIndex;
        $[119] = testId;
        $[120] = weeks;
        $[121] = t54;
    } else t54 = $[121];
    let t55;
    if ($[122] !== handleContainerKeyDown || $[123] !== headerId || $[124] !== t51 || $[125] !== t52 || $[126] !== t54) {
        t55 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: t51
        }, t52, t54);
        $[122] = handleContainerKeyDown;
        $[123] = headerId;
        $[124] = t51;
        $[125] = t52;
        $[126] = t54;
        $[127] = t55;
    } else t55 = $[127];
    let t56;
    if ($[128] !== t50 || $[129] !== t55) {
        t56 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t50, t55);
        $[128] = t50;
        $[129] = t55;
        $[130] = t56;
    } else t56 = $[130];
    let t57;
    if ($[131] !== t44 || $[132] !== t56) {
        t57 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $031e002627f496f2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: t44
        }, t56);
        $[131] = t44;
        $[132] = t56;
        $[133] = t57;
    } else t57 = $[133];
    let t58;
    if ($[134] !== className || $[135] !== handleContainerBlur || $[136] !== handleContainerFocus || $[137] !== ref || $[138] !== style || $[139] !== t43 || $[140] !== t57) {
        t58 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": t43,
            ref: ref
        }, t57);
        $[134] = className;
        $[135] = handleContainerBlur;
        $[136] = handleContainerFocus;
        $[137] = ref;
        $[138] = style;
        $[139] = t43;
        $[140] = t57;
        $[141] = t58;
    } else t58 = $[141];
    return t58;
} : function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = [], defaultSelected: defaultSelected = [], defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $dpsRj.default), onChange: onChange = (0, $dpsRj.default), onFocus: onFocus = (0, $dpsRj.default), onSelect: onSelect = (0, $dpsRj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $2lTKb.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $cozmU.useState)(false);
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$031e002627f496f2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2NGTx.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$031e002627f496f2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $3f826.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $669cn.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $dEHey.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $lq3dZ.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth_0 = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth_0]} ${previousYear}`;
    };
    const headerId = (0, $6JrSr.useId)();
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $031e002627f496f2$var$styles.box,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $CIxco.default // The month number needs to be translated to index in the month
    ), {
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextMonthHeading: getNextMonthHeading(),
        nextYearHeading: getNextYearHeading(),
        previousMonthHeading: getPreviousMonthHeading(),
        previousYearHeading: getPreviousYearHeading(),
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ $cozmU.createElement((0, $RzcOF.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ $cozmU.createElement((0, $4kl0X.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $031e002627f496f2$var$Calendar = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Calendar(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ $cozmU.createElement($031e002627f496f2$var$InnerCalendar, {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function Calendar(props, ref) {
    return /*#__PURE__*/ $cozmU.createElement($031e002627f496f2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$031e002627f496f2$var$Calendar.displayName = 'Calendar';
var $031e002627f496f2$export$2e2bcd8739ae039 = $031e002627f496f2$var$Calendar;
module.exports["default"] = $031e002627f496f2$export$2e2bcd8739ae039;

});

parcelRegister("CIxco", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $6JrSr = parcelRequire("6JrSr");


var $I7hWB = parcelRequire("I7hWB");


var $fvQZz = parcelRequire("fvQZz");


var $jA2WU = parcelRequire("jA2WU");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

// in the return below and always apply these transitions.
const $3cbb052d9d086c02$var$arrowMotionStyles = null;
const $3cbb052d9d086c02$var$Header = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Header(t0) {
    const $ = (0, $bDgLe.c)(51);
    const { monthLongTitle: monthLongTitle, year: year, previousMonthLabel: t1, previousYearLabel: t2, previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: t3, nextYearLabel: t4, nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId } = t0;
    const previousMonthLabel = t1 === undefined ? "Previous month" : t1;
    const previousYearLabel = t2 === undefined ? "Previous year" : t2;
    const nextMonthLabel = t3 === undefined ? "Next month" : t3;
    const nextYearLabel = t4 === undefined ? "Next year" : t4;
    const announceId = (0, $6JrSr.useId)();
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] !== handleClickPrevMonth || $[1] !== hasInteractedWithMonthOrYear) {
        t5 = (e)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickPrevMonth(e);
        };
        $[0] = handleClickPrevMonth;
        $[1] = hasInteractedWithMonthOrYear;
        $[2] = t5;
    } else t5 = $[2];
    const handlePrevMonthInteraction = t5;
    let t6;
    if ($[3] !== handleClickPrevYear || $[4] !== hasInteractedWithMonthOrYear) {
        t6 = (e_0)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickPrevYear(e_0);
        };
        $[3] = handleClickPrevYear;
        $[4] = hasInteractedWithMonthOrYear;
        $[5] = t6;
    } else t6 = $[5];
    const handlePrevYearInteraction = t6;
    let t7;
    if ($[6] !== handleClickNextMonth || $[7] !== hasInteractedWithMonthOrYear) {
        t7 = (e_1)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickNextMonth(e_1);
        };
        $[6] = handleClickNextMonth;
        $[7] = hasInteractedWithMonthOrYear;
        $[8] = t7;
    } else t7 = $[8];
    const handleNextMonthInteraction = t7;
    let t8;
    if ($[9] !== handleClickNextYear || $[10] !== hasInteractedWithMonthOrYear) {
        t8 = (e_2)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickNextYear(e_2);
        };
        $[9] = handleClickNextYear;
        $[10] = hasInteractedWithMonthOrYear;
        $[11] = t8;
    } else t8 = $[11];
    const handleNextYearInteraction = t8;
    const t9 = testId && `${testId}--previous-year`;
    const t10 = `${previousYearLabel}, ${previousYearHeading}`;
    let t11;
    if ($[12] !== handlePrevYearInteraction || $[13] !== t10 || $[14] !== t9 || $[15] !== tabIndex) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevYearInteraction,
            testId: t9,
            icon: $3cbb052d9d086c02$var$_temp,
            label: t10
        });
        $[12] = handlePrevYearInteraction;
        $[13] = t10;
        $[14] = t9;
        $[15] = tabIndex;
        $[16] = t11;
    } else t11 = $[16];
    const t12 = testId && `${testId}--previous-month`;
    const t13 = `${previousMonthLabel}, ${previousMonthHeading}`;
    let t14;
    if ($[17] !== handlePrevMonthInteraction || $[18] !== t12 || $[19] !== t13 || $[20] !== tabIndex) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: t12,
            icon: $3cbb052d9d086c02$var$_temp2,
            label: t13
        });
        $[17] = handlePrevMonthInteraction;
        $[18] = t12;
        $[19] = t13;
        $[20] = tabIndex;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== t11 || $[23] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "start"
        }, t11, t14);
        $[22] = t11;
        $[23] = t14;
        $[24] = t15;
    } else t15 = $[24];
    const t16 = hasInteractedWithMonthOrYear ? "polite" : undefined;
    const t17 = testId && `${testId}--current-month-year--container`;
    const t18 = testId && `${testId}--current-month-year`;
    const t19 = `${monthLongTitle} ${year}`;
    let t20;
    if ($[25] !== headerId || $[26] !== t18 || $[27] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: t18
        }, t19);
        $[25] = headerId;
        $[26] = t18;
        $[27] = t19;
        $[28] = t20;
    } else t20 = $[28];
    let t21;
    if ($[29] !== announceId || $[30] !== t16 || $[31] !== t17 || $[32] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "aria-live": t16,
            id: announceId,
            testId: t17
        }, t20);
        $[29] = announceId;
        $[30] = t16;
        $[31] = t17;
        $[32] = t20;
        $[33] = t21;
    } else t21 = $[33];
    const t22 = testId && `${testId}--next-month`;
    const t23 = `${nextMonthLabel}, ${nextMonthHeading}`;
    let t24;
    if ($[34] !== handleNextMonthInteraction || $[35] !== t22 || $[36] !== t23 || $[37] !== tabIndex) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: t22,
            icon: $3cbb052d9d086c02$var$_temp3,
            label: t23
        });
        $[34] = handleNextMonthInteraction;
        $[35] = t22;
        $[36] = t23;
        $[37] = tabIndex;
        $[38] = t24;
    } else t24 = $[38];
    const t25 = testId && `${testId}--next-year`;
    const t26 = `${nextYearLabel}, ${nextYearHeading}`;
    let t27;
    if ($[39] !== handleNextYearInteraction || $[40] !== t25 || $[41] !== t26 || $[42] !== tabIndex) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextYearInteraction,
            testId: t25,
            icon: $3cbb052d9d086c02$var$_temp4,
            label: t26
        });
        $[39] = handleNextYearInteraction;
        $[40] = t25;
        $[41] = t26;
        $[42] = tabIndex;
        $[43] = t27;
    } else t27 = $[43];
    let t28;
    if ($[44] !== t24 || $[45] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "end"
        }, t24, t27);
        $[44] = t24;
        $[45] = t27;
        $[46] = t28;
    } else t28 = $[46];
    let t29;
    if ($[47] !== t15 || $[48] !== t21 || $[49] !== t28) {
        const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, t15, t21, t28));
        t29 = (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4dF6NMo10F _499rSRo10F _4AHf5IDdj4 _08mev2YbGa"
            ])
        }, header) : header;
        $[47] = t15;
        $[48] = t21;
        $[49] = t28;
        $[50] = t29;
    } else t29 = $[50];
    return t29;
} : function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $6JrSr.useId)(); // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $cozmU.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e_0)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e_0);
    };
    const handleNextMonthInteraction = (e_1)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e_1);
    };
    const handleNextYearInteraction = (e_2)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e_2);
    };
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevYearInteraction,
        testId: testId && `${testId}--previous-year`,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQZz))), {
                ...iconProps,
                size: "small"
            }),
        label: `${previousYearLabel}, ${previousYearHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps_0,
                size: "small"
            }),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_1,
                size: "small"
            }),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextYearInteraction,
        testId: testId && `${testId}--next-year`,
        icon: (iconProps_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jA2WU))), {
                ...iconProps_2,
                size: "small"
            }),
        label: `${nextYearLabel}, ${nextYearHeading}`
    }))));
    return (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4dF6NMo10F _499rSRo10F _4AHf5IDdj4 _08mev2YbGa"
        ])
    }, header) : header;
});
$3cbb052d9d086c02$var$Header.displayName = 'Header'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3cbb052d9d086c02$export$2e2bcd8739ae039 = $3cbb052d9d086c02$var$Header;
function $3cbb052d9d086c02$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQZz))), {
        ...iconProps,
        size: "small"
    });
}
function $3cbb052d9d086c02$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps_0,
        size: "small"
    });
}
function $3cbb052d9d086c02$var$_temp3(iconProps_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps_1,
        size: "small"
    });
}
function $3cbb052d9d086c02$var$_temp4(iconProps_2) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jA2WU))), {
        ...iconProps_2,
        size: "small"
    });
}
module.exports["default"] = $3cbb052d9d086c02$export$2e2bcd8739ae039;

});

parcelRegister("fvQZz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2706a888a095b0bf1d564f3132217284>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b2db60ae791156$var$_react = $b4b2db60ae791156$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4b2db60ae791156$var$_baseNew = $b4b2db60ae791156$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b4b2db60ae791156$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-double-left
 * Usage guidance:
 * Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4b2db60ae791156$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $b4b2db60ae791156$var$_react.default.createElement($b4b2db60ae791156$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$b4b2db60ae791156$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $b4b2db60ae791156$var$_default = module.exports.default = $b4b2db60ae791156$var$ChevronDoubleLeftIcon;

});

parcelRegister("jA2WU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8dd5947dd69d8cedc53cec5847688d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e413aabb142774f3$var$_react = $e413aabb142774f3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e413aabb142774f3$var$_baseNew = $e413aabb142774f3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e413aabb142774f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-double-right
 * Usage guidance:
 * Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e413aabb142774f3$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $e413aabb142774f3$var$_react.default.createElement($e413aabb142774f3$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$e413aabb142774f3$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $e413aabb142774f3$var$_default = module.exports.default = $e413aabb142774f3$var$ChevronDoubleRightIcon;

});

parcelRegister("4kl0X", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $eg4l6 = parcelRequire("eg4l6");


var $4Xsrc = parcelRequire("4Xsrc");

const $d0e1499518f2d7f3$var$WeekDays = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function WeekDays(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId } = t0;
    const t1 = testId && `${testId}--month`;
    let t2;
    if ($[0] !== handleClickDay || $[1] !== monthsLong || $[2] !== shouldSetFocus || $[3] !== tabIndex || $[4] !== testId || $[5] !== weeks) {
        let t3;
        if ($[7] !== handleClickDay || $[8] !== monthsLong || $[9] !== shouldSetFocus || $[10] !== tabIndex || $[11] !== testId) {
            t3 = (week, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Xsrc.default), {
                    key: i,
                    testId: testId && `${testId}--week`
                }, week.values.map((weekDay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg4l6.default), {
                        key: `${week.id}-${weekDay.id}`,
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId
                    }, weekDay.day)));
            $[7] = handleClickDay;
            $[8] = monthsLong;
            $[9] = shouldSetFocus;
            $[10] = tabIndex;
            $[11] = testId;
            $[12] = t3;
        } else t3 = $[12];
        t2 = weeks.map(t3);
        $[0] = handleClickDay;
        $[1] = monthsLong;
        $[2] = shouldSetFocus;
        $[3] = tabIndex;
        $[4] = testId;
        $[5] = weeks;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[13] !== t1 || $[14] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            role: "rowgroup",
            testId: t1
        }, t2);
        $[13] = t1;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Xsrc.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg4l6.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$d0e1499518f2d7f3$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0e1499518f2d7f3$export$2e2bcd8739ae039 = $d0e1499518f2d7f3$var$WeekDays;
module.exports["default"] = $d0e1499518f2d7f3$export$2e2bcd8739ae039;

});

parcelRegister("eg4l6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $3pCca = parcelRequire("3pCca");

const $c1121364af7966f7$var$dateCellSiblingStyle = null;
const $c1121364af7966f7$var$dateCellTodayStyle = null;
const $c1121364af7966f7$var$dateCellPrevSelectedStyle = null;
const $c1121364af7966f7$var$dateCellSelectedStyle = null;
const $c1121364af7966f7$var$dateCellDisabledStyle = null;
const $c1121364af7966f7$var$dateCellStyles = null; // platform-dst-shape-theme-default TODO: Merge into base after rollout
const $c1121364af7966f7$var$dateCellStylesT26Shape = null; // platform-dst-motion-uplift-list-item cleanup: once fully rolled out, fold these
// transitions into the styles above and drop the gate in the `css` array below.
const $c1121364af7966f7$var$dateCellMotionStyles = null;
const $c1121364af7966f7$var$dateCellSelectedMotionStyles = null;
const $c1121364af7966f7$var$Date = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Date(t0, _ref) {
    const $ = (0, $bDgLe.c)(39);
    const { children: day, isDisabled: t1, isFocused: t2, isToday: t3, dayLong: dayLong, month: month, monthLong: monthLong, onClick: t4, isPreviouslySelected: t5, isSelected: t6, isSibling: t7, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isFocused = t2 === undefined ? false : t2;
    const isToday = t3 === undefined ? false : t3;
    const onClick = t4 === undefined ? (0, $dpsRj.default) : t4;
    const isPreviouslySelected = t5 === undefined ? false : t5;
    const isSelected = t6 === undefined ? false : t6;
    const isSibling = t7 === undefined ? false : t7;
    let t8;
    if ($[0] !== day || $[1] !== isDisabled || $[2] !== month || $[3] !== year) {
        t8 = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
        $[0] = day;
        $[1] = isDisabled;
        $[2] = month;
        $[3] = year;
        $[4] = t8;
    } else t8 = $[4];
    const dateRef = (0, $cozmU.useRef)(t8);
    let t10;
    let t9;
    if ($[5] !== day || $[6] !== isDisabled || $[7] !== month || $[8] !== year) {
        t9 = ()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        };
        t10 = [
            day,
            month,
            year,
            isDisabled
        ];
        $[5] = day;
        $[6] = isDisabled;
        $[7] = month;
        $[8] = year;
        $[9] = t10;
        $[10] = t9;
    } else {
        t10 = $[9];
        t9 = $[10];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const focusRef = (0, $cozmU.useRef)(null);
    let t11;
    let t12;
    if ($[11] !== isFocused || $[12] !== shouldSetFocus) {
        t11 = ()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        };
        t12 = [
            isFocused,
            shouldSetFocus
        ];
        $[11] = isFocused;
        $[12] = shouldSetFocus;
        $[13] = t11;
        $[14] = t12;
    } else {
        t11 = $[13];
        t12 = $[14];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[15] !== onClick) {
        t13 = ()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        };
        $[15] = onClick;
        $[16] = t13;
    } else t13 = $[16];
    const handleClick = t13;
    const t14 = isToday ? "date" : undefined;
    const t15 = isDisabled || undefined;
    const t16 = `${day}, ${dayLong} ${monthLong} ${year}`;
    const t17 = isSelected ? "true" : "false";
    const t18 = isFocused ? tabIndex : -1;
    const t19 = isDisabled || undefined;
    const t20 = isFocused || undefined;
    const t21 = isPreviouslySelected || undefined;
    const t22 = isSelected || undefined;
    const t23 = isSibling || undefined;
    const t24 = isToday || undefined;
    const t25 = testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`);
    let t26;
    if ($[17] !== isDisabled || $[18] !== isPreviouslySelected || $[19] !== isSelected || $[20] !== isSibling || $[21] !== isToday) {
        t26 = (0, $hekY6.default)([
            "_1mb4UnZqHV _0bjKvDzXzM _2sNsIgmnOE _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvLZJ _1mT5xdRAKS _2O5Vij7dHp _0KLXrujOvk _1UtDYzy7kJ _0wOv4Q7zJH _0xmtko1Y8M _46hvQm1Y8M _03SyCP2AF2 _0LQT5E2AF2 _2fwxA5DIqT _1H5Ii9nXvL _2pF7Yy6wH8 _4ydpeVvc3e _1eOmH6o126 _0clgaMy7kJ _3gzVzLN4oS _0CMRbky7kJ",
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && "_0bjKvDKTcp",
            isSibling && "_1UtDYzKGUX _0clgaMKGUX",
            isToday && "_1UtDYzjTy9 _1kk5Tkmb2E _4Gb5FivLZJ _47eTBt4Jdh _2WYcYGWVPG _3wEj0X98eZ _0GBAIrogpp _3ufiZDFQfX _3erkSQFQfX _13xWvlFQfX",
            isPreviouslySelected && "_0KLXruY9q9 _1UtDYzZpcK _0clgaMZpcK",
            isSelected && "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _0clgaMjTy9",
            isDisabled && "_1UtDYzot27 _0wOv4Qsyl5 _1eOmH6jOvk _0clgaMot27",
            (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && "_23rrnHo10F _3t4LwpYbGa _1B4rbIo10F _3sFUREDdj4",
            (isSelected || isPreviouslySelected) && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && "_23rrnHWE38"
        ]);
        $[17] = isDisabled;
        $[18] = isPreviouslySelected;
        $[19] = isSelected;
        $[20] = isSibling;
        $[21] = isToday;
        $[22] = t26;
    } else t26 = $[22];
    let t27;
    if ($[23] !== day || $[24] !== handleClick || $[25] !== t14 || $[26] !== t15 || $[27] !== t16 || $[28] !== t17 || $[29] !== t18 || $[30] !== t19 || $[31] !== t20 || $[32] !== t21 || $[33] !== t22 || $[34] !== t23 || $[35] !== t24 || $[36] !== t25 || $[37] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $3pCca.Grid), {
            role: "gridcell",
            alignItems: "center"
        }, /*#__PURE__*/ $cozmU.createElement("button", {
            "aria-current": t14,
            "aria-disabled": t15,
            "aria-label": t16,
            "aria-pressed": t17,
            tabIndex: t18,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": t19,
            "data-focused": t20,
            "data-prev-selected": t21,
            "data-selected": t22,
            "data-sibling": t23,
            "data-today": t24,
            "data-testid": t25,
            className: t26
        }, day));
        $[23] = day;
        $[24] = handleClick;
        $[25] = t14;
        $[26] = t15;
        $[27] = t16;
        $[28] = t17;
        $[29] = t18;
        $[30] = t19;
        $[31] = t20;
        $[32] = t21;
        $[33] = t22;
        $[34] = t23;
        $[35] = t24;
        $[36] = t25;
        $[37] = t26;
        $[38] = t27;
    } else t27 = $[38];
    return t27;
} : function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $dpsRj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $cozmU.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $cozmU.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3pCca.Grid), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement("button", {
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _0bjKvDzXzM _2sNsIgmnOE _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvLZJ _1mT5xdRAKS _2O5Vij7dHp _0KLXrujOvk _1UtDYzy7kJ _0wOv4Q7zJH _0xmtko1Y8M _46hvQm1Y8M _03SyCP2AF2 _0LQT5E2AF2 _2fwxA5DIqT _1H5Ii9nXvL _2pF7Yy6wH8 _4ydpeVvc3e _1eOmH6o126 _0clgaMy7kJ _3gzVzLN4oS _0CMRbky7kJ",
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_0bjKvDKTcp",
            isSibling && "_1UtDYzKGUX _0clgaMKGUX",
            isToday && "_1UtDYzjTy9 _1kk5Tkmb2E _4Gb5FivLZJ _47eTBt4Jdh _2WYcYGWVPG _3wEj0X98eZ _0GBAIrogpp _3ufiZDFQfX _3erkSQFQfX _13xWvlFQfX",
            isPreviouslySelected && "_0KLXruY9q9 _1UtDYzZpcK _0clgaMZpcK",
            isSelected && "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _0clgaMjTy9",
            isDisabled && "_1UtDYzot27 _0wOv4Qsyl5 _1eOmH6jOvk _0clgaMot27",
            (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && "_23rrnHo10F _3t4LwpYbGa _1B4rbIo10F _3sFUREDdj4",
            (isSelected || isPreviouslySelected) && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && "_23rrnHWE38"
        ])
    }, day));
}));
$c1121364af7966f7$var$Date.displayName = 'Date'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c1121364af7966f7$export$2e2bcd8739ae039 = $c1121364af7966f7$var$Date;
module.exports["default"] = $c1121364af7966f7$export$2e2bcd8739ae039;

});

parcelRegister("4Xsrc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3pCca = parcelRequire("3pCca");

const $88589de4c2e0c04f$var$styles = {
    templateColumns: "_2iEGP2HVZM"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $88589de4c2e0c04f$var$WeekDayGrid = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { testId: testId, children: children, isHidden: isHidden } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            testId: testId,
            xcss: $88589de4c2e0c04f$var$styles.templateColumns,
            role: "row"
        }, children);
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    const row = t1;
    let t2;
    if ($[3] !== isHidden || $[4] !== row) {
        t2 = isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": "true"
        }, row) : row;
        $[3] = isHidden;
        $[4] = row;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        testId: testId,
        xcss: $88589de4c2e0c04f$var$styles.templateColumns,
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $88589de4c2e0c04f$export$2e2bcd8739ae039 = $88589de4c2e0c04f$var$WeekDayGrid;
module.exports["default"] = $88589de4c2e0c04f$export$2e2bcd8739ae039;

});

parcelRegister("RzcOF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $4Xsrc = parcelRequire("4Xsrc");

const $ce71262a5653464e$var$styles = {
    columnHeader: "_4ouGXIF6tL _1ANEUSLRg7 _3iDTPbQ4SZ _37wbyuDIqT"
};
const $ce71262a5653464e$var$WeekHeader = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function WeekHeader(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { daysShort: daysShort, testId: testId } = t0;
    const t1 = testId && `${testId}--column-headers`;
    let t2;
    if ($[0] !== daysShort || $[1] !== testId) {
        let t3;
        if ($[3] !== testId) {
            t3 = (shortDay)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    padding: "space.100",
                    xcss: $ce71262a5653464e$var$styles.columnHeader,
                    key: shortDay,
                    role: "columnheader",
                    testId: testId && `${testId}--column-header`
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    weight: "bold",
                    size: "small",
                    align: "center",
                    color: "color.text.subtle"
                }, shortDay));
            $[3] = testId;
            $[4] = t3;
        } else t3 = $[4];
        t2 = daysShort.map(t3);
        $[0] = daysShort;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $4Xsrc.default), {
            isHidden: true,
            testId: t1
        }, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $4Xsrc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            padding: "space.100",
            xcss: $ce71262a5653464e$var$styles.columnHeader,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$ce71262a5653464e$var$WeekHeader.displayName = 'WeekHeader'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $ce71262a5653464e$export$2e2bcd8739ae039 = $ce71262a5653464e$var$WeekHeader;
module.exports["default"] = $ce71262a5653464e$export$2e2bcd8739ae039;

});

parcelRegister("2lTKb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $5Dlqn = parcelRequire("5Dlqn");


var $4U9wy = parcelRequire("4U9wy");


var $5XHJF = parcelRequire("5XHJF");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $30f093e39d878d3b$var$useControlledDateState = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useControlledDateState(t0) {
    const $ = (0, $bDgLe.c)(42);
    const { day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected } = t0;
    const { current: t1 } = (0, $4U9wy.default)($30f093e39d878d3b$var$_temp);
    const { thisDay: thisDay_0, thisMonth: thisMonth_0, thisYear: thisYear_0 } = t1;
    let t2;
    if ($[0] !== defaultDay || $[1] !== thisDay_0) {
        t2 = ()=>defaultDay || thisDay_0;
        $[0] = defaultDay;
        $[1] = thisDay_0;
        $[2] = t2;
    } else t2 = $[2];
    const [dayValue, setDayValue] = (0, $5Dlqn.default)(day, t2);
    let t3;
    if ($[3] !== defaultMonth || $[4] !== thisMonth_0) {
        t3 = ()=>defaultMonth || thisMonth_0;
        $[3] = defaultMonth;
        $[4] = thisMonth_0;
        $[5] = t3;
    } else t3 = $[5];
    const [monthValue, setMonthValue] = (0, $5Dlqn.default)(month, t3);
    let t4;
    if ($[6] !== defaultYear || $[7] !== thisYear_0) {
        t4 = ()=>defaultYear || thisYear_0;
        $[6] = defaultYear;
        $[7] = thisYear_0;
        $[8] = t4;
    } else t4 = $[8];
    const [yearValue, setYearValue] = (0, $5Dlqn.default)(year, t4);
    let t5;
    if ($[9] !== thisDay_0 || $[10] !== thisMonth_0 || $[11] !== thisYear_0 || $[12] !== today) {
        t5 = ()=>today || `${thisYear_0}-${(0, $5XHJF.default)(thisMonth_0)}-${(0, $5XHJF.default)(thisDay_0)}`;
        $[9] = thisDay_0;
        $[10] = thisMonth_0;
        $[11] = thisYear_0;
        $[12] = today;
        $[13] = t5;
    } else t5 = $[13];
    const [todayValue] = (0, $5Dlqn.default)(today, t5);
    let t6;
    if ($[14] !== defaultSelected) {
        t6 = ()=>defaultSelected;
        $[14] = defaultSelected;
        $[15] = t6;
    } else t6 = $[15];
    const [selectedValue, setSelectedValue] = (0, $5Dlqn.default)(selected, t6);
    let t7;
    if ($[16] !== defaultPreviouslySelected) {
        t7 = ()=>defaultPreviouslySelected;
        $[16] = defaultPreviouslySelected;
        $[17] = t7;
    } else t7 = $[17];
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $5Dlqn.default)(previouslySelected, t7);
    let t8;
    if ($[18] !== dayValue || $[19] !== setDayValue) {
        t8 = [
            dayValue,
            setDayValue
        ];
        $[18] = dayValue;
        $[19] = setDayValue;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== monthValue || $[22] !== setMonthValue) {
        t9 = [
            monthValue,
            setMonthValue
        ];
        $[21] = monthValue;
        $[22] = setMonthValue;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== setYearValue || $[25] !== yearValue) {
        t10 = [
            yearValue,
            setYearValue
        ];
        $[24] = setYearValue;
        $[25] = yearValue;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== todayValue) {
        t11 = [
            todayValue
        ];
        $[27] = todayValue;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== selectedValue || $[30] !== setSelectedValue) {
        t12 = [
            selectedValue,
            setSelectedValue
        ];
        $[29] = selectedValue;
        $[30] = setSelectedValue;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== previouslySelectedValue || $[33] !== setPreviouslySelectedValue) {
        t13 = [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ];
        $[32] = previouslySelectedValue;
        $[33] = setPreviouslySelectedValue;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t8 || $[40] !== t9) {
        t14 = {
            day: t8,
            month: t9,
            year: t10,
            today: t11,
            selected: t12,
            previous: t13
        };
        $[35] = t10;
        $[36] = t11;
        $[37] = t12;
        $[38] = t13;
        $[39] = t8;
        $[40] = t9;
        $[41] = t14;
    } else t14 = $[41];
    return t14;
} : function useControlledDateState({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay_0, thisMonth: thisMonth_0, thisYear: thisYear_0 } } = (0, $4U9wy.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $5Dlqn.default)(day, ()=>defaultDay || thisDay_0);
    const [monthValue, setMonthValue] = (0, $5Dlqn.default)(month, ()=>defaultMonth || thisMonth_0);
    const [yearValue, setYearValue] = (0, $5Dlqn.default)(year, ()=>defaultYear || thisYear_0);
    const [todayValue] = (0, $5Dlqn.default)(today, ()=>today || `${thisYear_0}-${(0, $5XHJF.default)(thisMonth_0)}-${(0, $5XHJF.default)(thisDay_0)}`);
    const [selectedValue, setSelectedValue] = (0, $5Dlqn.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $5Dlqn.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
};
var $30f093e39d878d3b$export$2e2bcd8739ae039 = $30f093e39d878d3b$var$useControlledDateState;
function $30f093e39d878d3b$var$_temp() {
    const now = new Date();
    const thisDay = now.getDate();
    const thisMonth = now.getMonth() + 1;
    const thisYear = now.getFullYear();
    return {
        thisDay: thisDay,
        thisMonth: thisMonth,
        thisYear: thisYear
    };
}
module.exports["default"] = $30f093e39d878d3b$export$2e2bcd8739ae039;

});

parcelRegister("5XHJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7b9101ab01e01cd$export$2e2bcd8739ae039);
function $d7b9101ab01e01cd$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});

parcelRegister("669cn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $702ccecd4f852bb0$var$useFocusing = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFocusing(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { onBlur: onBlur, onFocus: onFocus } = t0;
    let t1;
    if ($[0] !== onBlur) {
        t1 = (event)=>{
            onBlur(event);
        };
        $[0] = onBlur;
        $[1] = t1;
    } else t1 = $[1];
    const handleContainerBlur = t1;
    let t2;
    if ($[2] !== onFocus) {
        t2 = (event_0)=>{
            onFocus(event_0);
        };
        $[2] = onFocus;
        $[3] = t2;
    } else t2 = $[3];
    const handleContainerFocus = t2;
    let t3;
    if ($[4] !== handleContainerBlur || $[5] !== handleContainerFocus) {
        t3 = {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
        $[4] = handleContainerBlur;
        $[5] = handleContainerFocus;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function useFocusing({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $cozmU.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $cozmU.useCallback)((event_0)=>{
        onFocus(event_0);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
};
var $702ccecd4f852bb0$export$2e2bcd8739ae039 = $702ccecd4f852bb0$var$useFocusing;
module.exports["default"] = $702ccecd4f852bb0$export$2e2bcd8739ae039;

});

parcelRegister("lq3dZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k5sGX = parcelRequire("k5sGX");


var $aviSf = parcelRequire("aviSf");


var $blHSj = parcelRequire("blHSj");


var $bAYvJ = parcelRequire("bAYvJ");

const $5a1ed6accae25dc2$var$useGetCalendarWithSixthWeek = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGetCalendarWithSixthWeek(calendar, t0) {
    const $ = (0, $bDgLe.c)(6);
    const { month: month, year: year, weekStartDay: weekStartDay } = t0;
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    let t1;
    bb0: {
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $aviSf.daysPerWeek) : 0;
            let t2;
            if ($[0] !== month || $[1] !== sliceStart || $[2] !== weekStartDay || $[3] !== year) {
                t2 = (0, $bAYvJ.default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, $aviSf.daysPerWeek)).map($5a1ed6accae25dc2$var$_temp);
                $[0] = month;
                $[1] = sliceStart;
                $[2] = weekStartDay;
                $[3] = year;
                $[4] = t2;
            } else t2 = $[4];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = [];
            $[5] = t2;
        } else t2 = $[5];
        t1 = t2;
    }
    return t1;
} : function useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $cozmU.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $aviSf.daysPerWeek) : 0;
            return (0, $bAYvJ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $aviSf.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $5a1ed6accae25dc2$var$_temp(date) {
    return {
        ...date,
        siblingMonth: true
    };
}
const $5a1ed6accae25dc2$var$useGetWeeks = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGetWeeks(t0) {
    const $ = (0, $bDgLe.c)(25);
    const { day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay } = t0;
    const t1 = month - 1;
    let t2;
    if ($[0] !== t1 || $[1] !== weekStartDay || $[2] !== year) {
        t2 = (0, $bAYvJ.default)(year, t1, {
            weekStartDay: weekStartDay
        });
        $[0] = t1;
        $[1] = weekStartDay;
        $[2] = year;
        $[3] = t2;
    } else t2 = $[3];
    const calendar = t2;
    let t3;
    if ($[4] !== month || $[5] !== weekStartDay || $[6] !== year) {
        t3 = {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        };
        $[4] = month;
        $[5] = weekStartDay;
        $[6] = year;
        $[7] = t3;
    } else t3 = $[7];
    const calendarWithSixthWeek = $5a1ed6accae25dc2$var$useGetCalendarWithSixthWeek(calendar, t3);
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    let t4;
    if ($[8] !== minDateString) {
        t4 = minDateString ? (0, $k5sGX.default)(minDateString) : undefined;
        $[8] = minDateString;
        $[9] = t4;
    } else t4 = $[9];
    const minDate = t4;
    let t5;
    if ($[10] !== maxDateString) {
        t5 = maxDateString ? (0, $k5sGX.default)(maxDateString) : undefined;
        $[10] = maxDateString;
        $[11] = t5;
    } else t5 = $[11];
    const maxDate = t5;
    const needJsDate = minDateString || maxDateString;
    let weeks;
    if ($[12] !== calendar || $[13] !== day || $[14] !== daysLong || $[15] !== disabled || $[16] !== disabledDateFilter || $[17] !== maxDate || $[18] !== minDate || $[19] !== needJsDate || $[20] !== previouslySelected || $[21] !== selected || $[22] !== today || $[23] !== weekStartDay) {
        weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $blHSj.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $k5sGX.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        $[12] = calendar;
        $[13] = day;
        $[14] = daysLong;
        $[15] = disabled;
        $[16] = disabledDateFilter;
        $[17] = maxDate;
        $[18] = minDate;
        $[19] = needJsDate;
        $[20] = previouslySelected;
        $[21] = selected;
        $[22] = today;
        $[23] = weekStartDay;
        $[24] = weeks;
    } else weeks = $[24];
    return weeks;
} : function useGetWeeks({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $cozmU.useMemo)(()=>(0, $bAYvJ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $5a1ed6accae25dc2$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $k5sGX.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $k5sGX.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $cozmU.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $blHSj.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $k5sGX.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
};
var $5a1ed6accae25dc2$export$2e2bcd8739ae039 = $5a1ed6accae25dc2$var$useGetWeeks;
module.exports["default"] = $5a1ed6accae25dc2$export$2e2bcd8739ae039;

});

parcelRegister("aviSf", function(module, exports) {
const $b38b8178c69eabf7$export$3ae905d9742bef55 = 7;
const $b38b8178c69eabf7$export$c9b7c010035d60c6 = 12;
module.exports["daysPerWeek"] = $b38b8178c69eabf7$export$3ae905d9742bef55;
module.exports["monthsPerYear"] = $b38b8178c69eabf7$export$c9b7c010035d60c6;

});

parcelRegister("blHSj", function(module, exports) {
$parcel$export(module.exports, "default", () => $330dc868cc8fcda9$export$2e2bcd8739ae039);

var $5XHJF = parcelRequire("5XHJF");

function $330dc868cc8fcda9$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $5XHJF.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $5XHJF.default)(date.day)}`;
}

});

parcelRegister("bAYvJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abf4bb131f576af$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $aviSf = parcelRequire("aviSf");


var $9PMdq = parcelRequire("9PMdq");

function $1abf4bb131f576af$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $aviSf.daysPerWeek) - weekStartDay + firstDay) % (0, $aviSf.daysPerWeek));
    const lastDate = (0, $9PMdq.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $aviSf.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9PMdq.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $aviSf.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $aviSf.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $aviSf.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $aviSf.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $aviSf.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});

parcelRegister("9PMdq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a9cb6917d411474$export$2e2bcd8739ae039);
function $0a9cb6917d411474$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});

parcelRegister("2NGTx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aviSf = parcelRequire("aviSf");


var $blHSj = parcelRequire("blHSj");


var $9PMdq = parcelRequire("9PMdq");

const $0dcfeb64fb14a2d7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $aviSf.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $0dcfeb64fb14a2d7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $aviSf.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $0dcfeb64fb14a2d7$var$useHandleDateChange = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHandleDateChange(t0) {
    const $ = (0, $bDgLe.c)(31);
    const { day: t1, month: t2, year: t3, shouldSetFocus: t4, onChange: onChange } = t0;
    const [dayValue, setDayValue] = t1;
    const [monthValue, setMonthValue] = t2;
    const [yearValue, setYearValue] = t3;
    const [, setShouldSetFocus] = t4;
    let t5;
    if ($[0] !== dayValue || $[1] !== monthValue || $[2] !== yearValue) {
        t5 = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
        $[0] = dayValue;
        $[1] = monthValue;
        $[2] = yearValue;
        $[3] = t5;
    } else t5 = $[3];
    const dateRef = (0, $cozmU.useRef)(t5);
    let t6;
    let t7;
    if ($[4] !== dayValue || $[5] !== monthValue || $[6] !== yearValue) {
        t6 = ()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        };
        t7 = [
            dayValue,
            monthValue,
            yearValue
        ];
        $[4] = dayValue;
        $[5] = monthValue;
        $[6] = yearValue;
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[9] !== onChange || $[10] !== setDayValue || $[11] !== setMonthValue || $[12] !== setShouldSetFocus || $[13] !== setYearValue) {
        t8 = (t9)=>{
            const { year: year, month: month, day: day, type: type } = t9;
            const iso = (0, $blHSj.default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                "up",
                "down",
                "left",
                "right"
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        };
        $[9] = onChange;
        $[10] = setDayValue;
        $[11] = setMonthValue;
        $[12] = setShouldSetFocus;
        $[13] = setYearValue;
        $[14] = t8;
    } else t8 = $[14];
    const triggerOnChange = t8;
    let t9;
    if ($[15] !== triggerOnChange) {
        t9 = (type_0)=>{
            const { day: day_0, month: month_0, year: year_0 } = dateRef.current;
            if (type_0 === "down") {
                const next = day_0 + (0, $aviSf.daysPerWeek);
                const daysInMonth = (0, $9PMdq.default)(year_0, month_0 - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type_0
                    });
                } else triggerOnChange({
                    year: year_0,
                    month: month_0,
                    day: next,
                    type: type_0
                });
            } else if (type_0 === "left") {
                const prev = day_0 - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                    const prevDay = (0, $9PMdq.default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type_0
                    });
                } else triggerOnChange({
                    year: year_0,
                    month: month_0,
                    day: prev,
                    type: type_0
                });
            } else {
                if (type_0 === "right") {
                    const next_0 = day_0 + 1;
                    const daysInMonth_0 = (0, $9PMdq.default)(year_0, month_0 - 1);
                    if (next_0 > daysInMonth_0) {
                        const { month: nextMonth_0, year: nextYear_0 } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                        triggerOnChange({
                            year: nextYear_0,
                            month: nextMonth_0,
                            day: 1,
                            type: type_0
                        });
                    } else triggerOnChange({
                        year: year_0,
                        month: month_0,
                        day: next_0,
                        type: type_0
                    });
                } else if (type_0 === "up") {
                    const prev_0 = day_0 - (0, $aviSf.daysPerWeek);
                    if (prev_0 < 1) {
                        const { month: prevMonth_0, year: prevYear_0 } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                        const prevDay_0 = (0, $9PMdq.default)(prevYear_0, prevMonth_0 - 1) + prev_0;
                        triggerOnChange({
                            year: prevYear_0,
                            month: prevMonth_0,
                            day: prevDay_0,
                            type: type_0
                        });
                    } else triggerOnChange({
                        year: year_0,
                        month: month_0,
                        day: prev_0,
                        type: type_0
                    });
                }
            }
        };
        $[15] = triggerOnChange;
        $[16] = t9;
    } else t9 = $[16];
    const navigate = t9;
    let t10;
    if ($[17] !== triggerOnChange) {
        t10 = ()=>{
            const { day: day_1, month: month_1, year: year_1 } = {
                ...dateRef.current,
                ...$0dcfeb64fb14a2d7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day_1,
                month: month_1,
                year: year_1,
                type: "nextMonth"
            });
        };
        $[17] = triggerOnChange;
        $[18] = t10;
    } else t10 = $[18];
    const handleClickNextMonth = t10;
    let t11;
    if ($[19] !== triggerOnChange) {
        t11 = ()=>{
            const { day: day_2, month: month_2, year: year_2 } = dateRef.current;
            triggerOnChange({
                day: day_2,
                month: month_2,
                year: year_2 + 1,
                type: "nextYear"
            });
        };
        $[19] = triggerOnChange;
        $[20] = t11;
    } else t11 = $[20];
    const handleClickNextYear = t11;
    let t12;
    if ($[21] !== triggerOnChange) {
        t12 = ()=>{
            const { day: day_3, month: month_3, year: year_3 } = {
                ...dateRef.current,
                ...$0dcfeb64fb14a2d7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day_3,
                month: month_3,
                year: year_3,
                type: "prevMonth"
            });
        };
        $[21] = triggerOnChange;
        $[22] = t12;
    } else t12 = $[22];
    const handleClickPrevMonth = t12;
    let t13;
    if ($[23] !== triggerOnChange) {
        t13 = ()=>{
            const { day: day_4, month: month_4, year: year_4 } = dateRef.current;
            triggerOnChange({
                day: day_4,
                month: month_4,
                year: year_4 - 1,
                type: "prevYear"
            });
        };
        $[23] = triggerOnChange;
        $[24] = t13;
    } else t13 = $[24];
    const handleClickPrevYear = t13;
    let t14;
    if ($[25] !== handleClickNextMonth || $[26] !== handleClickNextYear || $[27] !== handleClickPrevMonth || $[28] !== handleClickPrevYear || $[29] !== navigate) {
        t14 = {
            navigate: navigate,
            handleClickNextMonth: handleClickNextMonth,
            handleClickNextYear: handleClickNextYear,
            handleClickPrevMonth: handleClickPrevMonth,
            handleClickPrevYear: handleClickPrevYear
        };
        $[25] = handleClickNextMonth;
        $[26] = handleClickNextYear;
        $[27] = handleClickPrevMonth;
        $[28] = handleClickPrevYear;
        $[29] = navigate;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
} : function useHandleDateChange({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $cozmU.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $cozmU.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $cozmU.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $blHSj.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $cozmU.useCallback)((type_0)=>{
        const { day: day_0, month: month_0, year: year_0 } = dateRef.current;
        if (type_0 === 'down') {
            const next = day_0 + (0, $aviSf.daysPerWeek);
            const daysInMonth = (0, $9PMdq.default)(year_0, month_0 - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: next,
                type: type_0
            });
        } else if (type_0 === 'left') {
            const prev = day_0 - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                const prevDay = (0, $9PMdq.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: prev,
                type: type_0
            });
        } else if (type_0 === 'right') {
            const next_0 = day_0 + 1;
            const daysInMonth_0 = (0, $9PMdq.default)(year_0, month_0 - 1);
            if (next_0 > daysInMonth_0) {
                const { month: nextMonth_0, year: nextYear_0 } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                triggerOnChange({
                    year: nextYear_0,
                    month: nextMonth_0,
                    day: 1,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: next_0,
                type: type_0
            });
        } else if (type_0 === 'up') {
            const prev_0 = day_0 - (0, $aviSf.daysPerWeek);
            if (prev_0 < 1) {
                const { month: prevMonth_0, year: prevYear_0 } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                const prevDay_0 = (0, $9PMdq.default)(prevYear_0, prevMonth_0 - 1) + prev_0;
                triggerOnChange({
                    year: prevYear_0,
                    month: prevMonth_0,
                    day: prevDay_0,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: prev_0,
                type: type_0
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $cozmU.useCallback)(()=>{
        const { day: day_1, month: month_1, year: year_1 } = {
            ...dateRef.current,
            ...$0dcfeb64fb14a2d7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day_1,
            month: month_1,
            year: year_1,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $cozmU.useCallback)(()=>{
        const { day: day_2, month: month_2, year: year_2 } = dateRef.current;
        triggerOnChange({
            day: day_2,
            month: month_2,
            year: year_2 + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $cozmU.useCallback)(()=>{
        const { day: day_3, month: month_3, year: year_3 } = {
            ...dateRef.current,
            ...$0dcfeb64fb14a2d7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day_3,
            month: month_3,
            year: year_3,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $cozmU.useCallback)(()=>{
        const { day: day_4, month: month_4, year: year_4 } = dateRef.current;
        triggerOnChange({
            day: day_4,
            month: month_4,
            year: year_4 - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
};
var $0dcfeb64fb14a2d7$export$2e2bcd8739ae039 = $0dcfeb64fb14a2d7$var$useHandleDateChange;
module.exports["default"] = $0dcfeb64fb14a2d7$export$2e2bcd8739ae039;

});

parcelRegister("3f826", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $blHSj = parcelRequire("blHSj");

const $93dd0d18d735b0a5$var$arrowKeys = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $93dd0d18d735b0a5$var$useHandleDateSelect = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHandleDateSelect(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { day: t1, month: t2, year: t3, selected: t4, previous: t5, onSelect: onSelect, navigate: navigate } = t0;
    const [dayValue] = t1;
    const [monthValue] = t2;
    const [yearValue] = t3;
    const [selectedValue, setSelectedValue] = t4;
    const [, setPreviouslySelectedValue] = t5;
    let t6;
    if ($[0] !== dayValue || $[1] !== monthValue || $[2] !== yearValue) {
        t6 = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
        $[0] = dayValue;
        $[1] = monthValue;
        $[2] = yearValue;
        $[3] = t6;
    } else t6 = $[3];
    const dateRef = (0, $cozmU.useRef)(t6);
    let t7;
    let t8;
    if ($[4] !== dayValue || $[5] !== monthValue || $[6] !== yearValue) {
        t7 = ()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        };
        t8 = [
            dayValue,
            monthValue,
            yearValue
        ];
        $[4] = dayValue;
        $[5] = monthValue;
        $[6] = yearValue;
        $[7] = t7;
        $[8] = t8;
    } else {
        t7 = $[7];
        t8 = $[8];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[9] !== onSelect || $[10] !== selectedValue || $[11] !== setPreviouslySelectedValue || $[12] !== setSelectedValue) {
        t9 = (t10)=>{
            const { year: year, month: month, day: day } = t10;
            const iso = (0, $blHSj.default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        };
        $[9] = onSelect;
        $[10] = selectedValue;
        $[11] = setPreviouslySelectedValue;
        $[12] = setSelectedValue;
        $[13] = t9;
    } else t9 = $[13];
    const triggerOnSelect = t9;
    let t10;
    if ($[14] !== triggerOnSelect) {
        t10 = (t11)=>{
            const { year: year_0, month: month_0, day: day_0 } = t11;
            triggerOnSelect({
                year: year_0,
                month: month_0,
                day: day_0
            });
        };
        $[14] = triggerOnSelect;
        $[15] = t10;
    } else t10 = $[15];
    const handleClickDay = t10;
    let t11;
    if ($[16] !== navigate || $[17] !== triggerOnSelect) {
        t11 = (e)=>{
            const { key: key } = e;
            const arrowKey = $93dd0d18d735b0a5$var$arrowKeys[key];
            if (key === "Enter" || key === " ") {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        };
        $[16] = navigate;
        $[17] = triggerOnSelect;
        $[18] = t11;
    } else t11 = $[18];
    const handleContainerKeyDown = t11;
    let t12;
    if ($[19] !== handleClickDay || $[20] !== handleContainerKeyDown) {
        t12 = {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
        $[19] = handleClickDay;
        $[20] = handleContainerKeyDown;
        $[21] = t12;
    } else t12 = $[21];
    return t12;
} : function useHandleDateSelect({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $cozmU.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $cozmU.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $cozmU.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $blHSj.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $cozmU.useCallback)(({ year: year_0, month: month_0, day: day_0 })=>{
        triggerOnSelect({
            year: year_0,
            month: month_0,
            day: day_0
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $cozmU.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = $93dd0d18d735b0a5$var$arrowKeys[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
};
var $93dd0d18d735b0a5$export$2e2bcd8739ae039 = $93dd0d18d735b0a5$var$useHandleDateSelect;
module.exports["default"] = $93dd0d18d735b0a5$export$2e2bcd8739ae039;

});

parcelRegister("dEHey", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3vMGL = parcelRequire("3vMGL");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $59e91aec054ca8c1$var$useLocale = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocale(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { locale: locale, weekStartDay: weekStartDay } = t0;
    let t1;
    if ($[0] !== locale) {
        t1 = (0, $3vMGL.createLocalizationProvider)(locale);
        $[0] = locale;
        $[1] = t1;
    } else t1 = $[1];
    const l10n = t1;
    let t2;
    if ($[2] !== l10n) {
        t2 = l10n.getMonthsLong();
        $[2] = l10n;
        $[3] = t2;
    } else t2 = $[3];
    const monthsLong = t2;
    let t3;
    if ($[4] !== l10n || $[5] !== weekStartDay) {
        t3 = l10n.getDaysShort(weekStartDay);
        $[4] = l10n;
        $[5] = weekStartDay;
        $[6] = t3;
    } else t3 = $[6];
    const daysShort = t3;
    let t4;
    if ($[7] !== l10n || $[8] !== weekStartDay) {
        t4 = l10n.getDaysLong(weekStartDay);
        $[7] = l10n;
        $[8] = weekStartDay;
        $[9] = t4;
    } else t4 = $[9];
    const daysLong = t4;
    let t5;
    if ($[10] !== daysLong || $[11] !== daysShort || $[12] !== monthsLong) {
        t5 = {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
        $[10] = daysLong;
        $[11] = daysShort;
        $[12] = monthsLong;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : function useLocale({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $cozmU.useMemo)(()=>(0, $3vMGL.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $cozmU.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $cozmU.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $cozmU.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
};
var $59e91aec054ca8c1$export$2e2bcd8739ae039 = $59e91aec054ca8c1$var$useLocale;
module.exports["default"] = $59e91aec054ca8c1$export$2e2bcd8739ae039;

});

parcelRegister("a0UNJ", function(module, exports) {
/* fixed-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $2Fmt9 = parcelRequire("2Fmt9");


var $akErP = parcelRequire("akErP");

var $lQV5m = parcelRequire("lQV5m");

var $kN1yU = parcelRequire("kN1yU");

function $6d6e390f276bb723$var$_defineProperty(e, r, t) {
    return (r = $6d6e390f276bb723$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6d6e390f276bb723$var$_toPropertyKey(t) {
    var i = $6d6e390f276bb723$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6d6e390f276bb723$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $6d6e390f276bb723$var$styles = {
    root: "_0KLXrujOvk _1mT5xdWVPG _2I62gzPgdg",
    popperStyles: "_42Yu6BPvK5"
};
class $6d6e390f276bb723$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props; // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null);
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $2Fmt9.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kN1yU.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles,
                className: (0, $hekY6.default)([
                    $6d6e390f276bb723$var$styles.root
                ])
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: ref,
                style: style,
                "data-testid": testId && `${testId}--popper--container`,
                className: (0, $hekY6.default)([
                    $6d6e390f276bb723$var$styles.popperStyles
                ])
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        $6d6e390f276bb723$var$_defineProperty(this, "update", (0, $dpsRj.default));
    }
}
module.exports["default"] = $6d6e390f276bb723$export$2e2bcd8739ae039;

});

parcelRegister("cME0o", function(module, exports) {
/* menu-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $buG8Z = parcelRequire("buG8Z");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");

const $8f98c8fc52ca556a$var$popupPlacement = (0, $aRDbl.fromLegacyPlacement)({
    legacy: 'bottom-start'
}); /**
     * @param isos A series of ISO dates.
     * @returns The last valid date within the array of ISO strings.
     */ 
function $8f98c8fc52ca556a$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $k5sGX.default)(iso);
        return (0, $esV19.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $8f98c8fc52ca556a$export$11ed8c2ae184f5b3 = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $8f98c8fc52ca556a$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    // The select's container element is the anchor for the popup.
    const triggerRef = (0, $cozmU.useRef)(selectProps.calendarContainerRef ?? null);
    triggerRef.current = selectProps.calendarContainerRef ?? null;
    const popoverRef = (0, $cozmU.useRef)(null);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $8f98c8fc52ca556a$var$popupPlacement,
        // The Popover is rendered with `isOpen` always true while this
        // component is mounted (react-select conditionally mounts/unmounts
        // the menu), so positioning is always active.
        isOpen: true
    });
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $cozmU.Fragment);
    return /*#__PURE__*/ $cozmU.createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        role: "dialog",
        label: "calendar",
        isOpen: true // `mode="manual"` opts out of native popover light-dismiss.
        ,
        // react-select / DateTimePicker already own outside-click and
        // Esc handling. Without this, the same click that opens the
        // menu (which targets the select input outside the popover)
        // also bubbles to the browser's auto-dismiss handler and
        // immediately closes the popover.
        mode: "manual",
        placement: $8f98c8fc52ca556a$var$popupPlacement,
        shouldAnimate: true,
        testId: selectProps.testId && `${selectProps.testId}--popup`
    }, /*#__PURE__*/ $cozmU.createElement((0, $juXYb.PopoverSurface), null, /*#__PURE__*/ $cozmU.createElement("div", {
        ...innerProps,
        role: "presentation",
        onMouseDown: onMenuMouseDown
    }, /*#__PURE__*/ $cozmU.createElement(Wrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $buG8Z.default), {
        day: day,
        month: month,
        year: year,
        disabled: selectProps.calendarDisabled,
        disabledDateFilter: selectProps.calendarDisabledDateFilter,
        minDate: selectProps.calendarMinDate,
        maxDate: selectProps.calendarMaxDate,
        nextMonthLabel: selectProps.nextMonthLabel,
        onChange: selectProps.onCalendarChange,
        onSelect: selectProps.onCalendarSelect,
        previousMonthLabel: selectProps.previousMonthLabel,
        ref: selectProps.calendarRef,
        selected: [
            selectProps.calendarValue
        ],
        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
        locale: selectProps.calendarLocale,
        testId: selectProps.testId && `${selectProps.testId}--calendar`,
        weekStartDay: selectProps.calendarWeekStartDay
    })))));
};
module.exports["MenuTopLayer"] = $8f98c8fc52ca556a$export$11ed8c2ae184f5b3;

});

parcelRegister("lzTfS", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $esV19 = parcelRequire("esV19");

var $hSoEi = parcelRequire("hSoEi");


var $iDrrr = parcelRequire("iDrrr");


var $5NE0I = parcelRequire("5NE0I");


var $78xYN = parcelRequire("78xYN");

const $ed996f3d2fbc5c29$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $5NE0I.defaultDateFormat));
    if (dateFormat && (0, $iDrrr.fg)('platform-dst-dp-parse-date-format')) {
        // new Date(0) to make reference date deterministic
        const parsed = (0, $hSoEi.default)(date, (0, $78xYN.convertTokens)(dateFormat), new Date(0));
        // `dateFormat` is a display format, so typed input does not always match
        // it. Locale parsing stays as the fallback so those entries still work.
        if ((0, $esV19.default)(parsed)) return parsed;
    }
    return l10n.parseDate(date);
};
module.exports["parseDate"] = $ed996f3d2fbc5c29$export$6b862160d295c8e;

});

parcelRegister("hSoEi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d03a99980e3dbd9b$export$2e2bcd8739ae039);

var $68pA8 = parcelRequire("68pA8");


var $aTPTV = parcelRequire("aTPTV");


var $8SGej = parcelRequire("8SGej");


var $5Q0Vq = parcelRequire("5Q0Vq");


var $dkBOe = parcelRequire("dkBOe");


var $jrCh2 = parcelRequire("jrCh2");


var $761RI = parcelRequire("761RI");


var $j90Gh = parcelRequire("j90Gh");


var $itDH4 = parcelRequire("itDH4");


var $kr6hK = parcelRequire("kr6hK");


var $3yGK6 = parcelRequire("3yGK6");


var $5KqMf = parcelRequire("5KqMf");


var $erRVM = parcelRequire("erRVM");


var $4m74k = parcelRequire("4m74k");

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $d03a99980e3dbd9b$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $d03a99980e3dbd9b$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $d03a99980e3dbd9b$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $d03a99980e3dbd9b$var$doubleQuoteRegExp = /''/g;
var $d03a99980e3dbd9b$var$notWhitespaceRegExp = /\S/;
var $d03a99980e3dbd9b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d03a99980e3dbd9b$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $3yGK6.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8SGej.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $kr6hK.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $kr6hK.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $dkBOe.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $5KqMf.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($d03a99980e3dbd9b$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $761RI.default)) {
            var longFormatter = (0, $761RI.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($d03a99980e3dbd9b$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $aTPTV.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $itDH4.isProtectedWeekYearToken)(token)) (0, $itDH4.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $itDH4.isProtectedDayOfYearToken)(token)) (0, $itDH4.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $erRVM.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($d03a99980e3dbd9b$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $d03a99980e3dbd9b$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $68pA8.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $d03a99980e3dbd9b$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $dkBOe.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $5Q0Vq.default)(date, (0, $j90Gh.default)(date));
    var flags = {};
    var _iterator2 = (0, $aTPTV.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $jrCh2.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $d03a99980e3dbd9b$var$cleanEscapedString(input) {
    return input.match($d03a99980e3dbd9b$var$escapedStringRegExp)[1].replace($d03a99980e3dbd9b$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("aTPTV", function(module, exports) {

var $ivJm4 = parcelRequire("ivJm4");

function $7ef74ce90da10ddf$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $ivJm4.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports["default"] = $7ef74ce90da10ddf$export$2e2bcd8739ae039;

});

parcelRegister("ivJm4", function(module, exports) {

var $kL2zH = parcelRequire("kL2zH");

function $d79e4dd1e790fb08$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kL2zH.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kL2zH.default)(r, a) : void 0;
    }
}
module.exports["default"] = $d79e4dd1e790fb08$export$2e2bcd8739ae039;

});

parcelRegister("kL2zH", function(module, exports) {
function $f1ca31bcf83fc566$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports["default"] = $f1ca31bcf83fc566$export$2e2bcd8739ae039;

});

parcelRegister("jrCh2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27e3a4c5ffdab0c$export$2e2bcd8739ae039);
function $e27e3a4c5ffdab0c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("5KqMf", function(module, exports) {

var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $ccS36 = parcelRequire("ccS36");

var $42f6050afbbf6d25$var$TIMEZONE_UNIT_PRIORITY = 10;
var $42f6050afbbf6d25$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $g6rNx.default)(this, Setter);
        (0, $ccS36.default)(this, "priority", void 0);
        (0, $ccS36.default)(this, "subPriority", 0);
    }
    (0, $61VNy.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $42f6050afbbf6d25$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $8Npt5.default)(ValueSetter, _Setter);
    var _super = (0, $kUYG8.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $g6rNx.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $61VNy.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($42f6050afbbf6d25$export$81d53e3678089a6);
var $42f6050afbbf6d25$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $8Npt5.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $kUYG8.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $g6rNx.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this2), "priority", $42f6050afbbf6d25$var$TIMEZONE_UNIT_PRIORITY);
        (0, $ccS36.default)((0, $fPHWO.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $61VNy.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($42f6050afbbf6d25$export$81d53e3678089a6);
module.exports["ValueSetter"] = $42f6050afbbf6d25$export$9a09e32dd4990fd5;
module.exports["DateToSystemTimezoneSetter"] = $42f6050afbbf6d25$export$5aaf7ff7f09ea4ee;

});

parcelRegister("fPHWO", function(module, exports) {
function $b86db58908ab3a21$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports["default"] = $b86db58908ab3a21$export$2e2bcd8739ae039;

});

parcelRegister("8Npt5", function(module, exports) {

var $1o91h = parcelRequire("1o91h");

function $6676a7c55fc90fae$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1o91h.default)(t, e);
}
module.exports["default"] = $6676a7c55fc90fae$export$2e2bcd8739ae039;

});

parcelRegister("kUYG8", function(module, exports) {

var $3LZzv = parcelRequire("3LZzv");


var $1nPNx = parcelRequire("1nPNx");


var $3luEO = parcelRequire("3luEO");

function $f3a81b1c3407c48d$export$2e2bcd8739ae039(t) {
    var r = (0, $1nPNx.default)();
    return function() {
        var e, o = (0, $3LZzv.default)(t);
        if (r) {
            var s = (0, $3LZzv.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3luEO.default)(this, e);
    };
}
module.exports["default"] = $f3a81b1c3407c48d$export$2e2bcd8739ae039;

});

parcelRegister("3LZzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf585bebcf0d07d$export$2e2bcd8739ae039);
function $2bf585bebcf0d07d$export$2e2bcd8739ae039(t) {
    return $2bf585bebcf0d07d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2bf585bebcf0d07d$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1nPNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $10201e6b86fc7175$export$2e2bcd8739ae039);
function $10201e6b86fc7175$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($10201e6b86fc7175$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("3luEO", function(module, exports) {

var $68pA8 = parcelRequire("68pA8");


var $fPHWO = parcelRequire("fPHWO");

function $26fb1d235b43c874$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $68pA8.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fPHWO.default)(t);
}
module.exports["default"] = $26fb1d235b43c874$export$2e2bcd8739ae039;

});

parcelRegister("g6rNx", function(module, exports) {
function $bb92c4fc742f9d95$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports["default"] = $bb92c4fc742f9d95$export$2e2bcd8739ae039;

});

parcelRegister("61VNy", function(module, exports) {

var $kSfw9 = parcelRequire("kSfw9");

function $463fab9b5f038fe4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $kSfw9.default)(o.key), o);
    }
}
function $463fab9b5f038fe4$export$2e2bcd8739ae039(e, r, t) {
    return r && $463fab9b5f038fe4$var$_defineProperties(e.prototype, r), t && $463fab9b5f038fe4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports["default"] = $463fab9b5f038fe4$export$2e2bcd8739ae039;

});

parcelRegister("erRVM", function(module, exports) {

var $eC4Z9 = parcelRequire("eC4Z9");


var $712Vg = parcelRequire("712Vg");


var $dxXTH = parcelRequire("dxXTH");


var $88ORV = parcelRequire("88ORV");


var $gZ5xM = parcelRequire("gZ5xM");


var $jHpOc = parcelRequire("jHpOc");


var $hKLEL = parcelRequire("hKLEL");


var $2osza = parcelRequire("2osza");


var $eoc6L = parcelRequire("eoc6L");


var $9P2ZO = parcelRequire("9P2ZO");


var $6zqt8 = parcelRequire("6zqt8");


var $gaEPf = parcelRequire("gaEPf");


var $2zfZV = parcelRequire("2zfZV");


var $iSCOI = parcelRequire("iSCOI");


var $6ku3j = parcelRequire("6ku3j");


var $gxgDD = parcelRequire("gxgDD");


var $jE6Oy = parcelRequire("jE6Oy");


var $j28KI = parcelRequire("j28KI");


var $djpXE = parcelRequire("djpXE");


var $7Nf6S = parcelRequire("7Nf6S");


var $9UQOD = parcelRequire("9UQOD");


var $ael3l = parcelRequire("ael3l");


var $6M1cG = parcelRequire("6M1cG");


var $cAMvE = parcelRequire("cAMvE");


var $4mDmT = parcelRequire("4mDmT");


var $bLXDl = parcelRequire("bLXDl");


var $1kRDS = parcelRequire("1kRDS");


var $iRtG4 = parcelRequire("iRtG4");


var $62f5E = parcelRequire("62f5E");


var $bQs8D = parcelRequire("bQs8D");


var $26OJt = parcelRequire("26OJt");

var $a84d6be113196c14$export$19131010e7fd8373 = {
    G: new (0, $eC4Z9.EraParser)(),
    y: new (0, $712Vg.YearParser)(),
    Y: new (0, $dxXTH.LocalWeekYearParser)(),
    R: new (0, $88ORV.ISOWeekYearParser)(),
    u: new (0, $gZ5xM.ExtendedYearParser)(),
    Q: new (0, $jHpOc.QuarterParser)(),
    q: new (0, $hKLEL.StandAloneQuarterParser)(),
    M: new (0, $2osza.MonthParser)(),
    L: new (0, $eoc6L.StandAloneMonthParser)(),
    w: new (0, $9P2ZO.LocalWeekParser)(),
    I: new (0, $6zqt8.ISOWeekParser)(),
    d: new (0, $gaEPf.DateParser)(),
    D: new (0, $2zfZV.DayOfYearParser)(),
    E: new (0, $iSCOI.DayParser)(),
    e: new (0, $6ku3j.LocalDayParser)(),
    c: new (0, $gxgDD.StandAloneLocalDayParser)(),
    i: new (0, $jE6Oy.ISODayParser)(),
    a: new (0, $j28KI.AMPMParser)(),
    b: new (0, $djpXE.AMPMMidnightParser)(),
    B: new (0, $7Nf6S.DayPeriodParser)(),
    h: new (0, $9UQOD.Hour1to12Parser)(),
    H: new (0, $ael3l.Hour0to23Parser)(),
    K: new (0, $6M1cG.Hour0To11Parser)(),
    k: new (0, $cAMvE.Hour1To24Parser)(),
    m: new (0, $4mDmT.MinuteParser)(),
    s: new (0, $bLXDl.SecondParser)(),
    S: new (0, $1kRDS.FractionOfSecondParser)(),
    X: new (0, $iRtG4.ISOTimezoneWithZParser)(),
    x: new (0, $62f5E.ISOTimezoneParser)(),
    t: new (0, $bQs8D.TimestampSecondsParser)(),
    T: new (0, $26OJt.TimestampMillisecondsParser)()
};
module.exports["parsers"] = $a84d6be113196c14$export$19131010e7fd8373;

});

parcelRegister("eC4Z9", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");

var $aa387b4ba4d3e124$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(EraParser, _Parser);
    var _super = (0, $kUYG8.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $g6rNx.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 140);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $27tFE.Parser));
module.exports["EraParser"] = $aa387b4ba4d3e124$export$8e5a1d3f85a9688;

});

parcelRegister("27tFE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $ccS36 = parcelRequire("ccS36");


var $5KqMf = parcelRequire("5KqMf");

var $18b340333eececf0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $g6rNx.default)(this, Parser);
        (0, $ccS36.default)(this, "incompatibleTokens", void 0);
        (0, $ccS36.default)(this, "priority", void 0);
        (0, $ccS36.default)(this, "subPriority", void 0);
    }
    (0, $61VNy.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $5KqMf.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();
module.exports["Parser"] = $18b340333eececf0$export$7acfa6ed01010e37;

});

parcelRegister("712Vg", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $51bae4cb1fda6d08$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(YearParser, _Parser);
    var _super = (0, $kUYG8.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $g6rNx.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $5GO7m.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $27tFE.Parser));
module.exports["YearParser"] = $51bae4cb1fda6d08$export$48d352de7cd4a988;

});

parcelRegister("5GO7m", function(module, exports) {

var $jO73f = parcelRequire("jO73f");


var $f50NU = parcelRequire("f50NU");

function $4247c0569b65af7c$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $4247c0569b65af7c$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4247c0569b65af7c$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * (0, $jO73f.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4247c0569b65af7c$export$d931c43c4608a164(dateString) {
    return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).anyDigitsSigned, dateString);
}
function $4247c0569b65af7c$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).singleDigit, dateString);
        case 2:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).twoDigits, dateString);
        case 3:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).threeDigits, dateString);
        case 4:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).fourDigits, dateString);
        default:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $4247c0569b65af7c$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $4247c0569b65af7c$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $4247c0569b65af7c$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $4247c0569b65af7c$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
module.exports["mapValue"] = $4247c0569b65af7c$export$4f84e3a82c7b538;
module.exports["parseNumericPattern"] = $4247c0569b65af7c$export$cc7cc9e2a3ff9388;
module.exports["parseTimezonePattern"] = $4247c0569b65af7c$export$6497f4c0ecdfba8e;
module.exports["parseAnyDigitsSigned"] = $4247c0569b65af7c$export$d931c43c4608a164;
module.exports["parseNDigits"] = $4247c0569b65af7c$export$513bb01536146ab6;
module.exports["parseNDigitsSigned"] = $4247c0569b65af7c$export$2c9307b2e29c533c;
module.exports["dayPeriodEnumToHours"] = $4247c0569b65af7c$export$fb506d2676e7f207;
module.exports["normalizeTwoDigitYear"] = $4247c0569b65af7c$export$29126f735cbf69f7;
module.exports["isLeapYearIndex"] = $4247c0569b65af7c$export$3d50627710b84d75;

});

parcelRegister("f50NU", function(module, exports) {
var $afa7f24e905606cc$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $afa7f24e905606cc$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
module.exports["numericPatterns"] = $afa7f24e905606cc$export$c123ee06d9da8480;
module.exports["timezonePatterns"] = $afa7f24e905606cc$export$a7ee192b982af9c1;

});

parcelRegister("dxXTH", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $a8KF2 = parcelRequire("a8KF2");


var $37zWd = parcelRequire("37zWd");

var $9dccd1cb7e1e332d$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $a8KF2.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $5GO7m.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $37zWd.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $37zWd.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $27tFE.Parser));
module.exports["LocalWeekYearParser"] = $9dccd1cb7e1e332d$export$b8ef38dfcf05d5db;

});

parcelRegister("88ORV", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $87l2G = parcelRequire("87l2G");

var $5ed68794bfbcfe16$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $5GO7m.parseNDigitsSigned)(4, dateString);
                return (0, $5GO7m.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $87l2G.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $27tFE.Parser));
module.exports["ISOWeekYearParser"] = $5ed68794bfbcfe16$export$951d1df011fde06f;

});

parcelRegister("gZ5xM", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $c5d6a4ba42a42bbe$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ExtendedYearParser, _Parser);
    var _super = (0, $kUYG8.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $g6rNx.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $5GO7m.parseNDigitsSigned)(4, dateString);
                return (0, $5GO7m.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $27tFE.Parser));
module.exports["ExtendedYearParser"] = $c5d6a4ba42a42bbe$export$bad9d2ea38e8f1a;

});

parcelRegister("jHpOc", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $e5760d85672313f9$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(QuarterParser, _Parser);
    var _super = (0, $kUYG8.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $g6rNx.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 120);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $27tFE.Parser));
module.exports["QuarterParser"] = $e5760d85672313f9$export$5cb0f701186dde1d;

});

parcelRegister("hKLEL", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $cecbb3253193993a$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 120);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $27tFE.Parser));
module.exports["StandAloneQuarterParser"] = $cecbb3253193993a$export$300c0c2990e20e6d;

});

parcelRegister("2osza", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $5GO7m = parcelRequire("5GO7m");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");

var $1be3fb4bd2727d42$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(MonthParser, _Parser);
    var _super = (0, $kUYG8.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $g6rNx.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 110);
        return _this;
    }
    (0, $61VNy.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $27tFE.Parser));
module.exports["MonthParser"] = $1be3fb4bd2727d42$export$400dd8b40ef138a3;

});

parcelRegister("eoc6L", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $a79cb2fe3699b3ad$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 110);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $27tFE.Parser));
module.exports["StandAloneMonthParser"] = $a79cb2fe3699b3ad$export$1d7eaa53eaa5deba;

});

parcelRegister("9P2ZO", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");


var $2lVoT = parcelRequire("2lVoT");


var $37zWd = parcelRequire("37zWd");

var $726b33645464efcb$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalWeekParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 100);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $37zWd.default)((0, $2lVoT.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $27tFE.Parser));
module.exports["LocalWeekParser"] = $726b33645464efcb$export$c4005ffc174e07c0;

});

parcelRegister("2lVoT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6a117e7c1f54a1$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $5QkXN = parcelRequire("5QkXN");


var $3yGK6 = parcelRequire("3yGK6");

function $1b6a117e7c1f54a1$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var week = (0, $kr6hK.default)(dirtyWeek);
    var diff = (0, $5QkXN.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("6zqt8", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");


var $dnRFE = parcelRequire("dnRFE");


var $87l2G = parcelRequire("87l2G");

var $4c8a8b2857ddf8f8$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOWeekParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 100);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $87l2G.default)((0, $dnRFE.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $27tFE.Parser));
module.exports["ISOWeekParser"] = $4c8a8b2857ddf8f8$export$6fc8dbedd560a6af;

});

parcelRegister("dnRFE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9be70e3cbf57652f$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $f46XZ = parcelRequire("f46XZ");


var $3yGK6 = parcelRequire("3yGK6");

function $9be70e3cbf57652f$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var isoWeek = (0, $kr6hK.default)(dirtyISOWeek);
    var diff = (0, $f46XZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("gaEPf", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $5GO7m = parcelRequire("5GO7m");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");

var $bc5d3f9bf50740b1$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bc5d3f9bf50740b1$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bc5d3f9bf50740b1$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DateParser, _Parser);
    var _super = (0, $kUYG8.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $g6rNx.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "subPriority", 1);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $5GO7m.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $bc5d3f9bf50740b1$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $bc5d3f9bf50740b1$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $27tFE.Parser));
module.exports["DateParser"] = $bc5d3f9bf50740b1$export$e8d4b28a20981dd2;

});

parcelRegister("2zfZV", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $1deb4275d03bcc29$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayOfYearParser, _Parser);
    var _super = (0, $kUYG8.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $g6rNx.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "subpriority", 1);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $5GO7m.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $27tFE.Parser));
module.exports["DayOfYearParser"] = $1deb4275d03bcc29$export$6cfe0d613455f615;

});

parcelRegister("iSCOI", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $7EDfs = parcelRequire("7EDfs");

var $dbeb6164992582c5$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayParser, _Parser);
    var _super = (0, $kUYG8.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $g6rNx.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $27tFE.Parser));
module.exports["DayParser"] = $dbeb6164992582c5$export$1b03c8b76262f7bd;

});

parcelRegister("7EDfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $592ab6bea6499494$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");


var $4m74k = parcelRequire("4m74k");

function $592ab6bea6499494$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3yGK6.default)(2, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var weekStartsOn = (0, $kr6hK.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = (0, $kr6hK.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("6ku3j", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $7EDfs = parcelRequire("7EDfs");

var $49bbec1a392484db$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalDayParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $27tFE.Parser));
module.exports["LocalDayParser"] = $49bbec1a392484db$export$44d1c127ab42c480;

});

parcelRegister("gxgDD", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $7EDfs = parcelRequire("7EDfs");

var $c09ca268b6399ac1$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $27tFE.Parser));
module.exports["StandAloneLocalDayParser"] = $c09ca268b6399ac1$export$e447a647caaaec1d;

});

parcelRegister("jE6Oy", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $kxXlL = parcelRequire("kxXlL");

var $e4d709f3bfa22a1b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISODayParser, _Parser);
    var _super = (0, $kUYG8.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $g6rNx.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $kxXlL.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $27tFE.Parser));
module.exports["ISODayParser"] = $e4d709f3bfa22a1b$export$693fb1e525095b2a;

});

parcelRegister("kxXlL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef54ed65fb65360f$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $ef54ed65fb65360f$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $3yGK6.default)(2, arguments);
    var day = (0, $kr6hK.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $dkBOe.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("j28KI", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $ddb4fe47873dbecf$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(AMPMParser, _Parser);
    var _super = (0, $kUYG8.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $g6rNx.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $27tFE.Parser));
module.exports["AMPMParser"] = $ddb4fe47873dbecf$export$8d1e08492351df91;

});

parcelRegister("djpXE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $9b1130103b9ec382$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $kUYG8.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $g6rNx.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $27tFE.Parser));
module.exports["AMPMMidnightParser"] = $9b1130103b9ec382$export$73ca2bd0a17d273;

});

parcelRegister("7Nf6S", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $5ac8d485ed59c619$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayPeriodParser, _Parser);
    var _super = (0, $kUYG8.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $g6rNx.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $27tFE.Parser));
module.exports["DayPeriodParser"] = $5ac8d485ed59c619$export$bb9212adf05373db;

});

parcelRegister("9UQOD", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $7382502015b26245$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour1to12Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $27tFE.Parser));
module.exports["Hour1to12Parser"] = $7382502015b26245$export$8a04050a727a1756;

});

parcelRegister("ael3l", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $772b8adf69b218c7$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour0to23Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $27tFE.Parser));
module.exports["Hour0to23Parser"] = $772b8adf69b218c7$export$e56f4dea2c3e56dd;

});

parcelRegister("6M1cG", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $4ee828c00f7373ac$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour0To11Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $27tFE.Parser));
module.exports["Hour0To11Parser"] = $4ee828c00f7373ac$export$cbbe855312f87d77;

});

parcelRegister("cAMvE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $92ae79c7d88a2f90$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour1To24Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $27tFE.Parser));
module.exports["Hour1To24Parser"] = $92ae79c7d88a2f90$export$6008046d2b34b6a5;

});

parcelRegister("4mDmT", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $32d7c12f76c50723$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(MinuteParser, _Parser);
    var _super = (0, $kUYG8.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $g6rNx.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 60);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $27tFE.Parser));
module.exports["MinuteParser"] = $32d7c12f76c50723$export$2b52670d9e2be53;

});

parcelRegister("bLXDl", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $8922577c9d0d3a05$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(SecondParser, _Parser);
    var _super = (0, $kUYG8.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $g6rNx.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 50);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $27tFE.Parser));
module.exports["SecondParser"] = $8922577c9d0d3a05$export$94d46d540cf1366a;

});

parcelRegister("1kRDS", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $0f9144ee890f4d12$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $kUYG8.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $g6rNx.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 30);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $27tFE.Parser));
module.exports["FractionOfSecondParser"] = $0f9144ee890f4d12$export$b8e6f8b2d70893b1;

});

parcelRegister("iRtG4", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $dbb43294a2aa850b$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 10);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $27tFE.Parser));
module.exports["ISOTimezoneWithZParser"] = $dbb43294a2aa850b$export$104d901d49fea29b;

});

parcelRegister("62f5E", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $464ea28c4b2b8db5$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 10);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $27tFE.Parser));
module.exports["ISOTimezoneParser"] = $464ea28c4b2b8db5$export$12910e5204b52b9;

});

parcelRegister("bQs8D", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $89fa60b9e72bd0e2$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $kUYG8.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $g6rNx.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 40);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $61VNy.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $5GO7m.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $27tFE.Parser));
module.exports["TimestampSecondsParser"] = $89fa60b9e72bd0e2$export$2cd8bf877a05e96;

});

parcelRegister("26OJt", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $18937eb5d5c6e05e$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $kUYG8.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $g6rNx.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 20);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $61VNy.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $5GO7m.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $27tFE.Parser));
module.exports["TimestampMillisecondsParser"] = $18937eb5d5c6e05e$export$6d8f69c6906d6368;

});

parcelRegister("ep7Ex", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

const $f78c8b131116f7c9$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang.replace('_', '-')
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children);
    };
module.exports["makeSingleValue"] = $f78c8b131116f7c9$export$6e30bf8cb1347b56;

});

parcelRegister("57alK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f6RxU = parcelRequire("f6RxU");

var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $7r5Hr = parcelRequire("7r5Hr");


var $1sCHt = parcelRequire("1sCHt");


var $5avUB = parcelRequire("5avUB");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $1TlML = parcelRequire("1TlML");


var $7aT8w = parcelRequire("7aT8w");


var $5rzlj = parcelRequire("5rzlj");


var $78xYN = parcelRequire("78xYN");


var $lF9wS = parcelRequire("lF9wS");


var $3sqHc = parcelRequire("3sqHc");

const $f705306771a8ce7f$var$packageName = "platform-pkg";
const $f705306771a8ce7f$var$packageVersion = "0.0.0-use.local";
const $f705306771a8ce7f$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $f705306771a8ce7f$var$packageName,
    packageVersion: $f705306771a8ce7f$var$packageVersion
};
const $f705306771a8ce7f$var$compiledStyles = {
    datePickerContainerStyles: "_1bHrqE715P _2O5Vij7dHp _3YEZNOdnbC",
    timePickerContainerStyles: "_1bHrqE715P _2O5Vij7dHp",
    iconContainerStyles: "_3iDTPbQ4SZ _0hPCNLDIqT _1bHrqEOLYo"
}; // react-select overrides (via @atlaskit/select).
const $f705306771a8ce7f$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $f705306771a8ce7f$export$3b559a1219cb3c27 = 'Date';
const $f705306771a8ce7f$export$d82cc7e53d68a428 = 'Time'; /**
                                                   * __Date time picker__
                                                   *
                                                   * A date time picker allows the user to select an associated date and time.
                                                   *
                                                   * - [Examples](https://atlassian.design/components/datetime-picker/examples)
                                                   * - [Code](https://atlassian.design/components/datetime-picker/code)
                                                   * - [Usage](https://atlassian.design/components/datetime-picker/usage)
                                                   */ 
const $f705306771a8ce7f$var$DateTimePicker = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(142);
    const { "aria-describedby": ariaDescribedBy, appearance: t1, autoFocus: t2, clearControlLabel: t3, datePickerProps: t4, defaultValue: t5, id: t6, innerProps: t7, isDisabled: t8, isInvalid: t9, isRequired: t10, name: t11, onBlur: t12, onChange: t13, onFocus: t14, parseValue: providedParseValue, spacing: t15, locale: t16, testId: testId, timePickerProps: t17, value: providedValue } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const autoFocus = t2 === undefined ? false : t2;
    const clearControlLabel = t3 === undefined ? "clear" : t3;
    let t18;
    if ($[0] !== t4) {
        t18 = t4 === undefined ? {} : t4;
        $[0] = t4;
        $[1] = t18;
    } else t18 = $[1];
    const datePickerPropsWithSelectProps = t18;
    const defaultValue = t5 === undefined ? "" : t5;
    const id = t6 === undefined ? "" : t6;
    let t19;
    if ($[2] !== t7) {
        t19 = t7 === undefined ? {} : t7;
        $[2] = t7;
        $[3] = t19;
    } else t19 = $[3];
    const innerProps = t19;
    const isDisabled = t8 === undefined ? false : t8;
    const isInvalid = t9 === undefined ? false : t9;
    const isRequired = t10 === undefined ? false : t10;
    const name = t11 === undefined ? "" : t11;
    const onBlur = t12 === undefined ? $f705306771a8ce7f$var$_temp : t12;
    const onChangeProp = t13 === undefined ? $f705306771a8ce7f$var$_temp2 : t13;
    const onFocus = t14 === undefined ? $f705306771a8ce7f$var$_temp3 : t14;
    const spacing = t15 === undefined ? "default" : t15;
    const locale = t16 === undefined ? "en-US" : t16;
    let t20;
    if ($[4] !== t17) {
        t20 = t17 === undefined ? {} : t17;
        $[4] = t17;
        $[5] = t20;
    } else t20 = $[5];
    const timePickerPropsWithSelectProps = t20;
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    let t21;
    if ($[6] !== providedParseValue) {
        t21 = (state, action)=>{
            switch(action.type){
                case "APPLY":
                    return action.payload;
                case "SET_VALUE":
                    {
                        const newValue = action.payload;
                        if (!newValue) return {
                            value: "",
                            dateValue: "",
                            timeValue: "",
                            zoneValue: ""
                        };
                        if (providedParseValue) {
                            const parsed = providedParseValue(newValue, state.dateValue, state.timeValue, state.zoneValue);
                            return parsed ? {
                                value: newValue,
                                ...parsed
                            } : {
                                value: newValue,
                                dateValue: state.dateValue,
                                timeValue: state.timeValue,
                                zoneValue: state.zoneValue
                            };
                        }
                        const parsed_0 = (0, $k5sGX.default)(newValue);
                        return (0, $esV19.default)(parsed_0) ? {
                            value: newValue,
                            dateValue: (0, $f6RxU.default)(parsed_0, (0, $78xYN.convertTokens)("YYYY-MM-DD")),
                            timeValue: (0, $f6RxU.default)(parsed_0, (0, $78xYN.convertTokens)("HH:mm")),
                            zoneValue: (0, $f6RxU.default)(parsed_0, (0, $78xYN.convertTokens)("ZZ"))
                        } : {
                            value: newValue,
                            dateValue: "",
                            timeValue: "",
                            zoneValue: ""
                        };
                    }
                default:
                    return state;
            }
        };
        $[6] = providedParseValue;
        $[7] = t21;
    } else t21 = $[7];
    const reducer = t21;
    let t22;
    if ($[8] !== datePickerPropsWithSelectProps.defaultValue || $[9] !== defaultValue || $[10] !== providedParseValue || $[11] !== providedValue || $[12] !== timePickerPropsWithSelectProps.defaultValue) {
        t22 = ()=>{
            const initialValue = providedValue ?? defaultValue ?? "";
            const initialDate = datePickerPropsWithSelectProps?.defaultValue || "";
            const initialTime = timePickerPropsWithSelectProps?.defaultValue || "";
            if (!initialValue) return {
                value: "",
                dateValue: initialDate,
                timeValue: initialTime,
                zoneValue: ""
            };
            if (providedParseValue) {
                const parsed_1 = providedParseValue(initialValue, initialDate, initialTime, "");
                return parsed_1 ? {
                    value: initialValue,
                    ...parsed_1
                } : {
                    value: initialValue,
                    dateValue: initialDate,
                    timeValue: initialTime,
                    zoneValue: ""
                };
            }
            const parsed_2 = (0, $k5sGX.default)(initialValue);
            return (0, $esV19.default)(parsed_2) ? {
                value: initialValue,
                dateValue: (0, $f6RxU.default)(parsed_2, (0, $78xYN.convertTokens)("YYYY-MM-DD")),
                timeValue: (0, $f6RxU.default)(parsed_2, (0, $78xYN.convertTokens)("HH:mm")),
                zoneValue: (0, $f6RxU.default)(parsed_2, (0, $78xYN.convertTokens)("ZZ"))
            } : {
                value: initialValue,
                dateValue: initialDate,
                timeValue: initialTime,
                zoneValue: ""
            };
        };
        $[8] = datePickerPropsWithSelectProps.defaultValue;
        $[9] = defaultValue;
        $[10] = providedParseValue;
        $[11] = providedValue;
        $[12] = timePickerPropsWithSelectProps.defaultValue;
        $[13] = t22;
    } else t22 = $[13];
    const [dtState, dispatch] = (0, $cozmU.useReducer)(reducer, null, t22);
    const hasReceivedProvidedValue = (0, $cozmU.useRef)(providedValue !== undefined);
    const isFirstRender = (0, $cozmU.useRef)(true);
    let t23;
    let t24;
    if ($[14] !== providedValue) {
        t23 = ()=>{
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
            }
            if (providedValue !== undefined) {
                hasReceivedProvidedValue.current = true;
                dispatch({
                    type: "SET_VALUE",
                    payload: providedValue
                });
            } else if (hasReceivedProvidedValue.current) {
                hasReceivedProvidedValue.current = false;
                dispatch({
                    type: "SET_VALUE",
                    payload: ""
                });
            }
        };
        t24 = [
            providedValue
        ];
        $[14] = providedValue;
        $[15] = t23;
        $[16] = t24;
    } else {
        t23 = $[15];
        t24 = $[16];
    }
    (0, $cozmU.useEffect)(t23, t24);
    let t25;
    if ($[17] !== dtState.dateValue || $[18] !== dtState.timeValue || $[19] !== dtState.zoneValue || $[20] !== providedParseValue) {
        t25 = (value, providedDateValue, providedTimeValue, providedZoneValue)=>{
            if (providedParseValue) {
                const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
                return parsedFromFn || {
                    dateValue: providedDateValue,
                    timeValue: providedTimeValue,
                    zoneValue: providedZoneValue
                };
            }
            const parsed_3 = (0, $k5sGX.default)(value);
            return (0, $esV19.default)(parsed_3) ? {
                dateValue: (0, $f6RxU.default)(parsed_3, (0, $78xYN.convertTokens)("YYYY-MM-DD")),
                timeValue: (0, $f6RxU.default)(parsed_3, (0, $78xYN.convertTokens)("HH:mm")),
                zoneValue: (0, $f6RxU.default)(parsed_3, (0, $78xYN.convertTokens)("ZZ"))
            } : {
                dateValue: dtState.dateValue,
                timeValue: dtState.timeValue,
                zoneValue: dtState.zoneValue
            };
        };
        $[17] = dtState.dateValue;
        $[18] = dtState.timeValue;
        $[19] = dtState.zoneValue;
        $[20] = providedParseValue;
        $[21] = t25;
    } else t25 = $[21];
    const parseValue = t25;
    let t26;
    if ($[22] !== datePickerPropsWithSelectProps || $[23] !== onBlur) {
        t26 = (event)=>{
            setIsFocused(false);
            onBlur(event);
            if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
        };
        $[22] = datePickerPropsWithSelectProps;
        $[23] = onBlur;
        $[24] = t26;
    } else t26 = $[24];
    const onDateBlur = t26;
    let t27;
    if ($[25] !== onBlur || $[26] !== timePickerPropsWithSelectProps) {
        t27 = (event_0)=>{
            setIsFocused(false);
            onBlur(event_0);
            if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event_0);
        };
        $[25] = onBlur;
        $[26] = timePickerPropsWithSelectProps;
        $[27] = t27;
    } else t27 = $[27];
    const onTimeBlur = t27;
    let t28;
    if ($[28] !== datePickerPropsWithSelectProps || $[29] !== onFocus) {
        t28 = (event_1)=>{
            setIsFocused(false);
            onFocus(event_1);
            if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event_1);
        };
        $[28] = datePickerPropsWithSelectProps;
        $[29] = onFocus;
        $[30] = t28;
    } else t28 = $[30];
    const onDateFocus = t28;
    let t29;
    if ($[31] !== onFocus || $[32] !== timePickerPropsWithSelectProps) {
        t29 = (event_2)=>{
            setIsFocused(false);
            onFocus(event_2);
            if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event_2);
        };
        $[31] = onFocus;
        $[32] = timePickerPropsWithSelectProps;
        $[33] = t29;
    } else t29 = $[33];
    const onTimeFocus = t29;
    const onDateChange = (newDateValue)=>{
        const parsedValues = parseValue(dtState.value, newDateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: newDateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(newDateValue);
    };
    const onTimeChange = (newTimeValue)=>{
        const parsedValues_0 = parseValue(dtState.value, dtState.dateValue, newTimeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: parsedValues_0.dateValue,
            providedTimeValue: newTimeValue,
            providedZoneValue: parsedValues_0.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(newTimeValue);
    };
    const onClear = ()=>{
        const parsedValues_1 = parseValue(dtState.value, dtState.dateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: "",
            providedTimeValue: "",
            providedZoneValue: parsedValues_1.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange("");
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange("");
    };
    let t30;
    if ($[34] !== onChangeProp) {
        t30 = {
            fn: onChangeProp,
            action: "selectedDate",
            actionSubject: "dateTimePicker",
            ...$f705306771a8ce7f$var$analyticsAttributes
        };
        $[34] = onChangeProp;
        $[35] = t30;
    } else t30 = $[35];
    const onChangePropWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t30);
    const onValueChange = (t31)=>{
        const { providedDateValue: providedDateValue_0, providedTimeValue: providedTimeValue_0, providedZoneValue: providedZoneValue_0 } = t31;
        if (providedDateValue_0 && providedTimeValue_0) {
            const isoValue = (0, $5rzlj.formatDateTimeZoneIntoIso)(providedDateValue_0, providedTimeValue_0, providedZoneValue_0);
            const { zoneValue: parsedZone } = parseValue(isoValue, providedDateValue_0, providedTimeValue_0, providedZoneValue_0);
            const valueWithValidZone = (0, $5rzlj.formatDateTimeZoneIntoIso)(providedDateValue_0, providedTimeValue_0, parsedZone);
            dispatch({
                type: "APPLY",
                payload: {
                    value: valueWithValidZone,
                    dateValue: providedDateValue_0,
                    timeValue: providedTimeValue_0,
                    zoneValue: parsedZone
                }
            });
            onChangePropWithAnalytics(valueWithValidZone);
        } else if (dtState.value) {
            dispatch({
                type: "APPLY",
                payload: {
                    value: "",
                    dateValue: providedDateValue_0,
                    timeValue: providedTimeValue_0,
                    zoneValue: providedZoneValue_0
                }
            });
            onChangePropWithAnalytics("");
        } else dispatch({
            type: "APPLY",
            payload: {
                value: "",
                dateValue: providedDateValue_0,
                timeValue: providedTimeValue_0,
                zoneValue: providedZoneValue_0
            }
        });
    };
    let datePickerProps;
    let datePickerSelectProps;
    if ($[36] !== datePickerPropsWithSelectProps) {
        ({ selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps);
        $[36] = datePickerPropsWithSelectProps;
        $[37] = datePickerProps;
        $[38] = datePickerSelectProps;
    } else {
        datePickerProps = $[37];
        datePickerSelectProps = $[38];
    }
    const datePickerAriaDescribedBy = datePickerProps["aria-describedby"] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || "Date";
    const t32 = datePickerSelectProps?.styles;
    let t33;
    if ($[39] !== t32) {
        t33 = (0, $1TlML.mergeStyles)($f705306771a8ce7f$var$styles, t32);
        $[39] = t32;
        $[40] = t33;
    } else t33 = $[40];
    let t34;
    if ($[41] !== datePickerSelectProps || $[42] !== t33) {
        t34 = {
            ...datePickerSelectProps,
            styles: t33
        };
        $[41] = datePickerSelectProps;
        $[42] = t33;
        $[43] = t34;
    } else t34 = $[43];
    const mergedDatePickerSelectProps = t34;
    let timePickerProps;
    let timePickerSelectProps;
    if ($[44] !== timePickerPropsWithSelectProps) {
        ({ selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps);
        $[44] = timePickerPropsWithSelectProps;
        $[45] = timePickerProps;
        $[46] = timePickerSelectProps;
    } else {
        timePickerProps = $[45];
        timePickerSelectProps = $[46];
    }
    const timePickerAriaDescribedBy = timePickerProps["aria-describedby"] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || "Time";
    const t35 = timePickerSelectProps?.styles;
    let t36;
    if ($[47] !== t35) {
        t36 = (0, $1TlML.mergeStyles)($f705306771a8ce7f$var$styles, t35);
        $[47] = t35;
        $[48] = t36;
    } else t36 = $[48];
    let t37;
    if ($[49] !== t36 || $[50] !== timePickerSelectProps) {
        t37 = {
            ...timePickerSelectProps,
            styles: t36
        };
        $[49] = t36;
        $[50] = timePickerSelectProps;
        $[51] = t37;
    } else t37 = $[51];
    const mergedTimePickerSelectProps = t37;
    const isClearable = Boolean(dtState.dateValue || dtState.timeValue);
    const t38 = testId && `${testId}--input`;
    let t39;
    if ($[52] !== dtState.value || $[53] !== name || $[54] !== t38) {
        t39 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            name: name,
            type: "hidden",
            value: dtState.value,
            "data-testid": t38
        });
        $[52] = dtState.value;
        $[53] = name;
        $[54] = t38;
        $[55] = t39;
    } else t39 = $[55];
    const t40 = datePickerProps.autoFocus || autoFocus;
    const t41 = datePickerProps.hideIcon || true;
    const t42 = datePickerProps.id || id;
    const t43 = datePickerProps.isDisabled || isDisabled;
    const t44 = datePickerProps.isInvalid || isInvalid;
    const t45 = datePickerProps.isRequired || isRequired;
    const t46 = datePickerProps.locale || locale;
    const t47 = datePickerProps.spacing || spacing;
    const t48 = testId && `${testId}--datepicker` || datePickerProps.testId;
    let t49;
    if ($[56] !== appearance || $[57] !== datePickerAriaDescribedBy || $[58] !== datePickerLabel || $[59] !== datePickerProps.dateFormat || $[60] !== datePickerProps.defaultIsOpen || $[61] !== datePickerProps.defaultValue || $[62] !== datePickerProps.disabled || $[63] !== datePickerProps.disabledDateFilter || $[64] !== datePickerProps.formatDisplayLabel || $[65] !== datePickerProps.icon || $[66] !== datePickerProps.innerProps || $[67] !== datePickerProps.inputLabel || $[68] !== datePickerProps.inputLabelId || $[69] !== datePickerProps.isOpen || $[70] !== datePickerProps.maxDate || $[71] !== datePickerProps.minDate || $[72] !== datePickerProps.name || $[73] !== datePickerProps.nextMonthLabel || $[74] !== datePickerProps.openCalendarLabel || $[75] !== datePickerProps.parseInputValue || $[76] !== datePickerProps.placeholder || $[77] !== datePickerProps.previousMonthLabel || $[78] !== datePickerProps.shouldShowCalendarButton || $[79] !== datePickerProps.weekStartDay || $[80] !== dtState.dateValue || $[81] !== mergedDatePickerSelectProps || $[82] !== onDateBlur || $[83] !== onDateChange || $[84] !== onDateFocus || $[85] !== t40 || $[86] !== t41 || $[87] !== t42 || $[88] !== t43 || $[89] !== t44 || $[90] !== t45 || $[91] !== t46 || $[92] !== t47 || $[93] !== t48) {
        t49 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f705306771a8ce7f$var$compiledStyles.datePickerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
            appearance: appearance,
            "aria-describedby": datePickerAriaDescribedBy,
            autoFocus: t40,
            dateFormat: datePickerProps.dateFormat,
            defaultIsOpen: datePickerProps.defaultIsOpen,
            defaultValue: datePickerProps.defaultValue,
            disabled: datePickerProps.disabled,
            disabledDateFilter: datePickerProps.disabledDateFilter,
            formatDisplayLabel: datePickerProps.formatDisplayLabel,
            hideIcon: t41,
            icon: datePickerProps.icon,
            id: t42,
            innerProps: datePickerProps.innerProps,
            inputLabel: datePickerProps.inputLabel,
            inputLabelId: datePickerProps.inputLabelId,
            isDisabled: t43,
            isInvalid: t44,
            isOpen: datePickerProps.isOpen,
            isRequired: t45,
            label: datePickerLabel,
            locale: t46,
            maxDate: datePickerProps.maxDate,
            minDate: datePickerProps.minDate,
            name: datePickerProps.name,
            nextMonthLabel: datePickerProps.nextMonthLabel,
            onBlur: onDateBlur,
            onChange: onDateChange,
            onFocus: onDateFocus,
            openCalendarLabel: datePickerProps.openCalendarLabel,
            parseInputValue: datePickerProps.parseInputValue,
            placeholder: datePickerProps.placeholder,
            previousMonthLabel: datePickerProps.previousMonthLabel,
            selectProps: mergedDatePickerSelectProps,
            shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
            spacing: t47,
            testId: t48,
            value: dtState.dateValue,
            weekStartDay: datePickerProps.weekStartDay
        }));
        $[56] = appearance;
        $[57] = datePickerAriaDescribedBy;
        $[58] = datePickerLabel;
        $[59] = datePickerProps.dateFormat;
        $[60] = datePickerProps.defaultIsOpen;
        $[61] = datePickerProps.defaultValue;
        $[62] = datePickerProps.disabled;
        $[63] = datePickerProps.disabledDateFilter;
        $[64] = datePickerProps.formatDisplayLabel;
        $[65] = datePickerProps.icon;
        $[66] = datePickerProps.innerProps;
        $[67] = datePickerProps.inputLabel;
        $[68] = datePickerProps.inputLabelId;
        $[69] = datePickerProps.isOpen;
        $[70] = datePickerProps.maxDate;
        $[71] = datePickerProps.minDate;
        $[72] = datePickerProps.name;
        $[73] = datePickerProps.nextMonthLabel;
        $[74] = datePickerProps.openCalendarLabel;
        $[75] = datePickerProps.parseInputValue;
        $[76] = datePickerProps.placeholder;
        $[77] = datePickerProps.previousMonthLabel;
        $[78] = datePickerProps.shouldShowCalendarButton;
        $[79] = datePickerProps.weekStartDay;
        $[80] = dtState.dateValue;
        $[81] = mergedDatePickerSelectProps;
        $[82] = onDateBlur;
        $[83] = onDateChange;
        $[84] = onDateFocus;
        $[85] = t40;
        $[86] = t41;
        $[87] = t42;
        $[88] = t43;
        $[89] = t44;
        $[90] = t45;
        $[91] = t46;
        $[92] = t47;
        $[93] = t48;
        $[94] = t49;
    } else t49 = $[94];
    const t50 = timePickerProps.appearance || appearance;
    const t51 = timePickerProps.hideIcon || true;
    const t52 = timePickerProps.isDisabled || isDisabled;
    const t53 = timePickerProps.isInvalid || isInvalid;
    const t54 = timePickerProps.isRequired || isRequired;
    const t55 = timePickerProps.locale || locale;
    const t56 = timePickerProps.spacing || spacing;
    const t57 = timePickerProps.testId || testId && `${testId}--timepicker`;
    let t58;
    if ($[95] !== dtState.timeValue || $[96] !== mergedTimePickerSelectProps || $[97] !== onTimeBlur || $[98] !== onTimeChange || $[99] !== onTimeFocus || $[100] !== t50 || $[101] !== t51 || $[102] !== t52 || $[103] !== t53 || $[104] !== t54 || $[105] !== t55 || $[106] !== t56 || $[107] !== t57 || $[108] !== timePickerAriaDescribedBy || $[109] !== timePickerLabel || $[110] !== timePickerProps.autoFocus || $[111] !== timePickerProps.defaultIsOpen || $[112] !== timePickerProps.defaultValue || $[113] !== timePickerProps.formatDisplayLabel || $[114] !== timePickerProps.id || $[115] !== timePickerProps.innerProps || $[116] !== timePickerProps.isOpen || $[117] !== timePickerProps.name || $[118] !== timePickerProps.parseInputValue || $[119] !== timePickerProps.placeholder || $[120] !== timePickerProps.timeFormat || $[121] !== timePickerProps.timeIsEditable || $[122] !== timePickerProps.times) {
        t58 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f705306771a8ce7f$var$compiledStyles.timePickerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sqHc.default), {
            appearance: t50,
            "aria-describedby": timePickerAriaDescribedBy,
            autoFocus: timePickerProps.autoFocus,
            defaultIsOpen: timePickerProps.defaultIsOpen,
            defaultValue: timePickerProps.defaultValue,
            formatDisplayLabel: timePickerProps.formatDisplayLabel,
            hideIcon: t51,
            id: timePickerProps.id,
            innerProps: timePickerProps.innerProps,
            isDisabled: t52,
            isInvalid: t53,
            isOpen: timePickerProps.isOpen,
            isRequired: t54,
            label: timePickerLabel,
            locale: t55,
            name: timePickerProps.name,
            onBlur: onTimeBlur,
            onChange: onTimeChange,
            onFocus: onTimeFocus,
            parseInputValue: timePickerProps.parseInputValue,
            placeholder: timePickerProps.placeholder,
            selectProps: mergedTimePickerSelectProps,
            spacing: t56,
            testId: t57,
            timeFormat: timePickerProps.timeFormat,
            timeIsEditable: timePickerProps.timeIsEditable,
            times: timePickerProps.times,
            value: dtState.timeValue
        }));
        $[95] = dtState.timeValue;
        $[96] = mergedTimePickerSelectProps;
        $[97] = onTimeBlur;
        $[98] = onTimeChange;
        $[99] = onTimeFocus;
        $[100] = t50;
        $[101] = t51;
        $[102] = t52;
        $[103] = t53;
        $[104] = t54;
        $[105] = t55;
        $[106] = t56;
        $[107] = t57;
        $[108] = timePickerAriaDescribedBy;
        $[109] = timePickerLabel;
        $[110] = timePickerProps.autoFocus;
        $[111] = timePickerProps.defaultIsOpen;
        $[112] = timePickerProps.defaultValue;
        $[113] = timePickerProps.formatDisplayLabel;
        $[114] = timePickerProps.id;
        $[115] = timePickerProps.innerProps;
        $[116] = timePickerProps.isOpen;
        $[117] = timePickerProps.name;
        $[118] = timePickerProps.parseInputValue;
        $[119] = timePickerProps.placeholder;
        $[120] = timePickerProps.timeFormat;
        $[121] = timePickerProps.timeIsEditable;
        $[122] = timePickerProps.times;
        $[123] = t58;
    } else t58 = $[123];
    let t59;
    if ($[124] !== clearControlLabel || $[125] !== isClearable || $[126] !== isDisabled || $[127] !== onClear || $[128] !== testId) {
        t59 = isClearable && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f705306771a8ce7f$var$compiledStyles.iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            label: clearControlLabel,
            icon: $f705306771a8ce7f$var$_temp4,
            onClick: onClear,
            testId: testId && `${testId}--icon--container`,
            tabIndex: -1
        })) : null;
        $[124] = clearControlLabel;
        $[125] = isClearable;
        $[126] = isDisabled;
        $[127] = onClear;
        $[128] = testId;
        $[129] = t59;
    } else t59 = $[129];
    let t60;
    if ($[130] !== appearance || $[131] !== innerProps || $[132] !== isDisabled || $[133] !== isFocused || $[134] !== isInvalid || $[135] !== ref || $[136] !== t39 || $[137] !== t49 || $[138] !== t58 || $[139] !== t59 || $[140] !== testId) {
        t60 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aT8w.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps,
            ref: ref
        }, t39, t49, t58, t59);
        $[130] = appearance;
        $[131] = innerProps;
        $[132] = isDisabled;
        $[133] = isFocused;
        $[134] = isInvalid;
        $[135] = ref;
        $[136] = t39;
        $[137] = t49;
        $[138] = t58;
        $[139] = t59;
        $[140] = testId;
        $[141] = t60;
    } else t60 = $[141];
    return t60;
} : ({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event_0)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false); /**
                                                               * Defined inside the component so the reducer closes over `providedParseValue`
                                                               * without needing to smuggle it through every action payload. React always
                                                               * calls the reducer from the latest render, so stale-closure is not a concern.
                                                               */ 
    const reducer = (state, action)=>{
        switch(action.type){
            case 'APPLY':
                return action.payload;
            case 'SET_VALUE':
                {
                    const newValue = action.payload; // Explicit empty-string handling: clear all sub-fields so the date
                    // and time pickers visually reset when a controlled value is cleared.
                    if (!newValue) return {
                        value: '',
                        dateValue: '',
                        timeValue: '',
                        zoneValue: ''
                    };
                    if (providedParseValue) {
                        const parsed = providedParseValue(newValue, state.dateValue, state.timeValue, state.zoneValue);
                        return parsed ? {
                            value: newValue,
                            ...parsed
                        } : {
                            value: newValue,
                            dateValue: state.dateValue,
                            timeValue: state.timeValue,
                            zoneValue: state.zoneValue
                        };
                    }
                    const parsed_0 = (0, $k5sGX.default)(newValue);
                    return (0, $esV19.default)(parsed_0) ? {
                        value: newValue,
                        dateValue: (0, $f6RxU.default)(parsed_0, (0, $78xYN.convertTokens)('YYYY-MM-DD')),
                        timeValue: (0, $f6RxU.default)(parsed_0, (0, $78xYN.convertTokens)('HH:mm')),
                        zoneValue: (0, $f6RxU.default)(parsed_0, (0, $78xYN.convertTokens)('ZZ'))
                    } : {
                        value: newValue,
                        dateValue: '',
                        timeValue: '',
                        zoneValue: ''
                    };
                }
            default:
                return state;
        }
    };
    const [dtState, dispatch] = (0, $cozmU.useReducer)(reducer, null, ()=>{
        const initialValue = providedValue ?? defaultValue ?? '';
        const initialDate = datePickerPropsWithSelectProps?.defaultValue || '';
        const initialTime = timePickerPropsWithSelectProps?.defaultValue || '';
        if (!initialValue) return {
            value: '',
            dateValue: initialDate,
            timeValue: initialTime,
            zoneValue: ''
        };
        if (providedParseValue) {
            const parsed_1 = providedParseValue(initialValue, initialDate, initialTime, '');
            return parsed_1 ? {
                value: initialValue,
                ...parsed_1
            } : {
                value: initialValue,
                dateValue: initialDate,
                timeValue: initialTime,
                zoneValue: ''
            };
        }
        const parsed_2 = (0, $k5sGX.default)(initialValue);
        return (0, $esV19.default)(parsed_2) ? {
            value: initialValue,
            dateValue: (0, $f6RxU.default)(parsed_2, (0, $78xYN.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $f6RxU.default)(parsed_2, (0, $78xYN.convertTokens)('HH:mm')),
            zoneValue: (0, $f6RxU.default)(parsed_2, (0, $78xYN.convertTokens)('ZZ'))
        } : {
            value: initialValue,
            dateValue: initialDate,
            timeValue: initialTime,
            zoneValue: ''
        };
    });
    // if a previously controlled value becomes undefined, it clears the reducer
    // state so the hidden input no longer keeps the stale ISO timestamp.
    // Without this, components that try to clear their components by providing
    // `undefined` to the `value` prop will not clear the hidden input and will
    // cause unexpected issues.
    const hasReceivedProvidedValue = (0, $cozmU.useRef)(providedValue !== undefined); // We don't want to set the state on the first render, as it would
    // needlessly be a duplicate.
    const isFirstRender = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (providedValue !== undefined) {
            hasReceivedProvidedValue.current = true;
            dispatch({
                type: 'SET_VALUE',
                payload: providedValue
            });
        } else if (hasReceivedProvidedValue.current) {
            hasReceivedProvidedValue.current = false;
            dispatch({
                type: 'SET_VALUE',
                payload: ''
            });
        }
    }, [
        providedValue
    ]);
    const parseValue = (0, $cozmU.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed_3 = (0, $k5sGX.default)(value);
        return (0, $esV19.default)(parsed_3) ? {
            dateValue: (0, $f6RxU.default)(parsed_3, (0, $78xYN.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $f6RxU.default)(parsed_3, (0, $78xYN.convertTokens)('HH:mm')),
            zoneValue: (0, $f6RxU.default)(parsed_3, (0, $78xYN.convertTokens)('ZZ'))
        } : {
            dateValue: dtState.dateValue,
            timeValue: dtState.timeValue,
            zoneValue: dtState.zoneValue
        };
    }, [
        providedParseValue,
        dtState.dateValue,
        dtState.timeValue,
        dtState.zoneValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event_0)=>{
        setIsFocused(false);
        onBlur(event_0);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event_0);
    };
    const onDateFocus = (event_1)=>{
        setIsFocused(false);
        onFocus(event_1);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event_1);
    };
    const onTimeFocus = (event_2)=>{
        setIsFocused(false);
        onFocus(event_2);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event_2);
    };
    const onDateChange = (newDateValue)=>{
        const parsedValues = parseValue(dtState.value, newDateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: newDateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(newDateValue);
    };
    const onTimeChange = (newTimeValue)=>{
        const parsedValues_0 = parseValue(dtState.value, dtState.dateValue, newTimeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: parsedValues_0.dateValue,
            providedTimeValue: newTimeValue,
            providedZoneValue: parsedValues_0.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(newTimeValue);
    };
    const onClear = ()=>{
        const parsedValues_1 = parseValue(dtState.value, dtState.dateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues_1.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'dateTimePicker',
        ...$f705306771a8ce7f$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue_0, providedTimeValue: providedTimeValue_0, providedZoneValue: providedZoneValue_0 })=>{
        if (providedDateValue_0 && providedTimeValue_0) {
            const isoValue = (0, $5rzlj.formatDateTimeZoneIntoIso)(providedDateValue_0, providedTimeValue_0, providedZoneValue_0);
            const { zoneValue: parsedZone } = parseValue(isoValue, providedDateValue_0, providedTimeValue_0, providedZoneValue_0);
            const valueWithValidZone = (0, $5rzlj.formatDateTimeZoneIntoIso)(providedDateValue_0, providedTimeValue_0, parsedZone);
            dispatch({
                type: 'APPLY',
                payload: {
                    value: valueWithValidZone,
                    dateValue: providedDateValue_0,
                    timeValue: providedTimeValue_0,
                    zoneValue: parsedZone
                }
            });
            onChangePropWithAnalytics(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (dtState.value) {
            dispatch({
                type: 'APPLY',
                payload: {
                    value: '',
                    dateValue: providedDateValue_0,
                    timeValue: providedTimeValue_0,
                    zoneValue: providedZoneValue_0
                }
            });
            onChangePropWithAnalytics('');
        } else dispatch({
            type: 'APPLY',
            payload: {
                value: '',
                dateValue: providedDateValue_0,
                timeValue: providedTimeValue_0,
                zoneValue: providedZoneValue_0
            }
        });
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || 'Date';
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $1TlML.mergeStyles)($f705306771a8ce7f$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || 'Time';
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $1TlML.mergeStyles)($f705306771a8ce7f$var$styles, timePickerSelectProps?.styles)
    }; // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dtState.dateValue || dtState.timeValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aT8w.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        name: name,
        type: "hidden",
        value: dtState.value,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f705306771a8ce7f$var$compiledStyles.datePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
        appearance: appearance,
        "aria-describedby": datePickerAriaDescribedBy,
        autoFocus: datePickerProps.autoFocus || autoFocus,
        dateFormat: datePickerProps.dateFormat,
        defaultIsOpen: datePickerProps.defaultIsOpen,
        defaultValue: datePickerProps.defaultValue,
        disabled: datePickerProps.disabled,
        disabledDateFilter: datePickerProps.disabledDateFilter,
        formatDisplayLabel: datePickerProps.formatDisplayLabel,
        hideIcon: datePickerProps.hideIcon || true,
        icon: datePickerProps.icon,
        id: datePickerProps.id || id,
        innerProps: datePickerProps.innerProps,
        inputLabel: datePickerProps.inputLabel,
        inputLabelId: datePickerProps.inputLabelId,
        isDisabled: datePickerProps.isDisabled || isDisabled,
        isInvalid: datePickerProps.isInvalid || isInvalid,
        isOpen: datePickerProps.isOpen,
        isRequired: datePickerProps.isRequired || isRequired,
        label: datePickerLabel,
        locale: datePickerProps.locale || locale,
        maxDate: datePickerProps.maxDate,
        minDate: datePickerProps.minDate,
        name: datePickerProps.name,
        nextMonthLabel: datePickerProps.nextMonthLabel,
        onBlur: onDateBlur,
        onChange: onDateChange,
        onFocus: onDateFocus,
        openCalendarLabel: datePickerProps.openCalendarLabel,
        parseInputValue: datePickerProps.parseInputValue,
        placeholder: datePickerProps.placeholder,
        previousMonthLabel: datePickerProps.previousMonthLabel,
        selectProps: mergedDatePickerSelectProps,
        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
        spacing: datePickerProps.spacing || spacing,
        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
        value: dtState.dateValue,
        weekStartDay: datePickerProps.weekStartDay
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f705306771a8ce7f$var$compiledStyles.timePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sqHc.default), {
        appearance: timePickerProps.appearance || appearance,
        "aria-describedby": timePickerAriaDescribedBy,
        autoFocus: timePickerProps.autoFocus,
        defaultIsOpen: timePickerProps.defaultIsOpen,
        defaultValue: timePickerProps.defaultValue,
        formatDisplayLabel: timePickerProps.formatDisplayLabel,
        hideIcon: timePickerProps.hideIcon || true,
        id: timePickerProps.id,
        innerProps: timePickerProps.innerProps,
        isDisabled: timePickerProps.isDisabled || isDisabled,
        isInvalid: timePickerProps.isInvalid || isInvalid,
        isOpen: timePickerProps.isOpen,
        isRequired: timePickerProps.isRequired || isRequired,
        label: timePickerLabel,
        locale: timePickerProps.locale || locale,
        name: timePickerProps.name,
        onBlur: onTimeBlur,
        onChange: onTimeChange,
        onFocus: onTimeFocus,
        parseInputValue: timePickerProps.parseInputValue,
        placeholder: timePickerProps.placeholder,
        selectProps: mergedTimePickerSelectProps,
        spacing: timePickerProps.spacing || spacing,
        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
        timeFormat: timePickerProps.timeFormat,
        timeIsEditable: timePickerProps.timeIsEditable,
        times: timePickerProps.times,
        value: dtState.timeValue
    })), isClearable && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f705306771a8ce7f$var$compiledStyles.iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        label: clearControlLabel,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                ...iconProps,
                color: "var(--ds-text-subtlest, #6B6E76)",
                size: "small"
            }),
        onClick: onClear,
        testId: testId && `${testId}--icon--container`,
        tabIndex: -1
    })) : null);
});
var $f705306771a8ce7f$export$2e2bcd8739ae039 = $f705306771a8ce7f$var$DateTimePicker;
function $f705306771a8ce7f$var$_temp(_event) {}
function $f705306771a8ce7f$var$_temp2(_value) {}
function $f705306771a8ce7f$var$_temp3(_event_0) {}
function $f705306771a8ce7f$var$_temp4(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        ...iconProps,
        color: "var(--ds-text-subtlest, #6B6E76)",
        size: "small"
    });
}
module.exports["default"] = $f705306771a8ce7f$export$2e2bcd8739ae039;

});

parcelRegister("7aT8w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $d00f4021a28492cc$var$isInvalidBorderStyles = null;
const $d00f4021a28492cc$var$isFocusedBorderStyles = null;
const $d00f4021a28492cc$var$isFocusedStyles = null;
const $d00f4021a28492cc$var$subtleBgStyles = null;
const $d00f4021a28492cc$var$subtleFocusedBgStyles = null;
const $d00f4021a28492cc$var$noBgStyles = null;
const $d00f4021a28492cc$var$hoverStyles = null;
const $d00f4021a28492cc$var$isInvalidHoverStyles = null;
const $d00f4021a28492cc$var$isDisabledStyles = null;
const $d00f4021a28492cc$var$newBorderStyles = null;
const $d00f4021a28492cc$var$baseContainerStyles = null; // platform-dst-shape-theme-default TODO: Merge into base after rollout
const $d00f4021a28492cc$var$baseContainerStylesT26Shape = null;
const $d00f4021a28492cc$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId } = t0;
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    let t1;
    if ($[0] !== appearance || $[1] !== isDisabled || $[2] !== isFocused || $[3] !== isInvalid || $[4] !== notFocusedOrIsDisabled) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDKxmn _23rrnH5Vpu _3iDTPbQ4SZ _0KLXru7Cj1 _0ReiIH7zJH",
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && "_0bjKvDKTcp",
            "_30huDKS6k6",
            isDisabled && "_3vBAKHhQC5 _0KLXruVrZW _0ReiIH18ZR",
            isFocused && "_0KLXruutHW",
            appearance === "subtle" && isFocused && "_3vBAKHjOvk _0KLXruutHW",
            appearance === "subtle" && !isFocused && "_3vBAKHjOvk _0KLXrujOvk",
            isFocused && "_3vBAKHnXvL _2OUyjtPhRM",
            isInvalid && "_3vBAKHnod9",
            notFocusedOrIsDisabled && isInvalid && "_0hPERGnod9 _1eOmH6qWX3",
            notFocusedOrIsDisabled && !isInvalid && "_0hPERGHKt7 _1eOmH6qWX3",
            appearance === "none" && "_3vBAKHjOvk _0KLXrujOvk _0hPERGjOvk _1eOmH6jOvk"
        ]);
        $[0] = appearance;
        $[1] = isDisabled;
        $[2] = isFocused;
        $[3] = isInvalid;
        $[4] = notFocusedOrIsDisabled;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== children || $[7] !== innerProps || $[8] !== ref || $[9] !== t1 || $[10] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...innerProps,
            "data-testid": testId,
            ref: ref,
            className: t1
        }, children);
        $[6] = children;
        $[7] = innerProps;
        $[8] = ref;
        $[9] = t1;
        $[10] = testId;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
} : ({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled); // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _23rrnH5Vpu _3iDTPbQ4SZ _0KLXru7Cj1 _0ReiIH7zJH",
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_0bjKvDKTcp",
            "_30huDKS6k6",
            isDisabled && "_3vBAKHhQC5 _0KLXruVrZW _0ReiIH18ZR",
            isFocused && "_0KLXruutHW",
            appearance === 'subtle' && isFocused && "_3vBAKHjOvk _0KLXruutHW",
            appearance === 'subtle' && !isFocused && "_3vBAKHjOvk _0KLXrujOvk",
            isFocused && "_3vBAKHnXvL _2OUyjtPhRM",
            isInvalid && "_3vBAKHnod9",
            notFocusedOrIsDisabled && isInvalid && "_0hPERGnod9 _1eOmH6qWX3",
            notFocusedOrIsDisabled && !isInvalid && "_0hPERGHKt7 _1eOmH6qWX3",
            appearance === 'none' && "_3vBAKHjOvk _0KLXrujOvk _0hPERGjOvk _1eOmH6jOvk"
        ])
    }, children);
});
module.exports["DateTimePickerContainer"] = $d00f4021a28492cc$export$83034b1f07ab0b20;

});

parcelRegister("5rzlj", function(module, exports) {
/**
 * Formats a date, time, and zone into a ISO string.
 */ function $c1d57d8f02d4ee75$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}
module.exports["formatDateTimeZoneIntoIso"] = $c1d57d8f02d4ee75$export$2eeb05a2ecc2ce0a;

});

parcelRegister("3sqHc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $f6RxU = parcelRequire("f6RxU");

var $esV19 = parcelRequire("esV19");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $3vMGL = parcelRequire("3vMGL");


var $iDrrr = parcelRequire("iDrrr");


var $Vh9GY = parcelRequire("Vh9GY");

var $6wGOF = parcelRequire("6wGOF");

var $1TlML = parcelRequire("1TlML");


var $1rZwc = parcelRequire("1rZwc");


var $2DcxV = parcelRequire("2DcxV");


var $iCPxC = parcelRequire("iCPxC");


var $5vaVZ = parcelRequire("5vaVZ");


var $jRlJw = parcelRequire("jRlJw");


var $78xYN = parcelRequire("78xYN");


var $6YTmv = parcelRequire("6YTmv");


var $ep7Ex = parcelRequire("ep7Ex");

const $f10d9daae52ca02d$var$packageName = "platform-pkg";
const $f10d9daae52ca02d$var$packageVersion = "0.0.0-use.local";
const $f10d9daae52ca02d$var$defaultTimeFormat = 'h:mma';
const $f10d9daae52ca02d$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $f10d9daae52ca02d$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $f10d9daae52ca02d$var$packageName,
    packageVersion: $f10d9daae52ca02d$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $f10d9daae52ca02d$var$TimePicker = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $dpsRj.default), onChange: providedOnChange = (0, $dpsRj.default), onFocus: providedOnFocus = (0, $dpsRj.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $jRlJw.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $1rZwc.defaultTimes), value: providedValue }, _ref)=>{
    const [containerRef, setContainerRef] = (0, $cozmU.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $cozmU.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(defaultIsOpen);
    const [value, setValue] = (0, $cozmU.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $cozmU.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$f10d9daae52ca02d$var$analyticsAttributes
    });
    (0, $cozmU.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $cozmU.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || $f10d9daae52ca02d$var$defaultTimeFormat);
            } catch  {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $f6RxU.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event_0)=>{
        setIsFocused(true);
        providedOnFocus(event_0);
    };
    const onSelectKeyDown = (event_1)=>{
        const { key: key } = event_1;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $3vMGL.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $Vh9GY.default) : (0, $6wGOF.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time_0)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time_0, timeFormat || $f10d9daae52ca02d$var$defaultTimeFormat);
        const date = (0, $jRlJw.default)(time_0);
        if (!(date instanceof Date)) return '';
        if (!(0, $esV19.default)(date)) return time_0;
        if (timeFormat) return (0, $f6RxU.default)(date, (0, $78xYN.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time_1)=>{
        return {
            label: formatTime(time_1),
            value: time_1
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $ep7Ex.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $2DcxV.EmptyComponent),
        Menu: (0, $iDrrr.fg)('platform-dst-top-layer') ? (0, $5vaVZ.FixedLayerMenuTopLayer) : (0, $iCPxC.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $2DcxV.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $1TlML.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base_0)=>({
                ...base_0,
                ...$f10d9daae52ca02d$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base_1)=>({
                ...base_1,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`,
        onKeyDown: onSelectKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SelectComponent, {
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        appearance: appearance,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        // @ts-ignore - Type mismatch with components - workaround for help-center local consumption
        components: selectComponents,
        inputId: id,
        isClearable: true,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: isOpen && !isDisabled,
        menuPlacement: "auto",
        openMenuOnFocus: true,
        onBlur: onBlur,
        onCreateOption: onCreateOption,
        // @ts-ignore - Type mismatch with onChange handler - workaround for help-center local consumption
        onChange: onChange,
        options: options,
        onFocus: onFocus,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        placeholder: placeholder || l10n.formatTime((0, $6YTmv.placeholderDatetime)),
        // @ts-ignore - Type mismatch with styles config - workaround for help-center local consumption
        styles: mergedStyles,
        value: initialValue,
        spacing: spacing,
        // We need this to get things to work, even though it's not supported.
        // @ts-ignore
        fixedLayerRef: containerRef,
        isInvalid: isInvalid,
        testId: testId,
        ...otherSelectProps
    }));
});
var $f10d9daae52ca02d$export$2e2bcd8739ae039 = $f10d9daae52ca02d$var$TimePicker;
module.exports["default"] = $f10d9daae52ca02d$export$2e2bcd8739ae039;

});

parcelRegister("1rZwc", function(module, exports) {
const $2d33da056f62e1cf$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
module.exports["defaultTimes"] = $2d33da056f62e1cf$export$b42ffb9f09b1861b;

});

parcelRegister("iCPxC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $a0UNJ = parcelRequire("a0UNJ");

const $d7df26b4548de6c5$export$982ad994195b4356 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    let children;
    let className;
    let clearValue;
    let cx;
    let getStyles;
    let getValue;
    let hasValue;
    let innerProps;
    let innerRef;
    let isLoading;
    let isMulti;
    let isRtl;
    let maxMenuHeight;
    let menuPlacement;
    let menuPosition;
    let menuShouldScrollIntoView;
    let minMenuHeight;
    let options;
    let placement;
    let rest;
    let selectOption;
    let selectProps;
    let setValue;
    if ($[0] !== t0) {
        ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = clearValue;
        $[4] = cx;
        $[5] = getStyles;
        $[6] = getValue;
        $[7] = hasValue;
        $[8] = innerProps;
        $[9] = innerRef;
        $[10] = isLoading;
        $[11] = isMulti;
        $[12] = isRtl;
        $[13] = maxMenuHeight;
        $[14] = menuPlacement;
        $[15] = menuPosition;
        $[16] = menuShouldScrollIntoView;
        $[17] = minMenuHeight;
        $[18] = options;
        $[19] = placement;
        $[20] = rest;
        $[21] = selectOption;
        $[22] = selectProps;
        $[23] = setValue;
    } else {
        children = $[1];
        className = $[2];
        clearValue = $[3];
        cx = $[4];
        getStyles = $[5];
        getValue = $[6];
        hasValue = $[7];
        innerProps = $[8];
        innerRef = $[9];
        isLoading = $[10];
        isMulti = $[11];
        isRtl = $[12];
        maxMenuHeight = $[13];
        menuPlacement = $[14];
        menuPosition = $[15];
        menuShouldScrollIntoView = $[16];
        minMenuHeight = $[17];
        options = $[18];
        placement = $[19];
        rest = $[20];
        selectOption = $[21];
        selectProps = $[22];
        setValue = $[23];
    }
    const t1 = menuShouldScrollIntoView;
    let t2;
    if ($[24] !== children || $[25] !== className || $[26] !== clearValue || $[27] !== cx || $[28] !== getStyles || $[29] !== getValue || $[30] !== hasValue || $[31] !== innerProps || $[32] !== innerRef || $[33] !== isLoading || $[34] !== isMulti || $[35] !== isRtl || $[36] !== maxMenuHeight || $[37] !== menuPlacement || $[38] !== menuPosition || $[39] !== minMenuHeight || $[40] !== options || $[41] !== placement || $[42] !== rest || $[43] !== selectOption || $[44] !== selectProps || $[45] !== setValue || $[46] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Menu, {
            ...rest,
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: t1,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children);
        $[24] = children;
        $[25] = className;
        $[26] = clearValue;
        $[27] = cx;
        $[28] = getStyles;
        $[29] = getValue;
        $[30] = hasValue;
        $[31] = innerProps;
        $[32] = innerRef;
        $[33] = isLoading;
        $[34] = isMulti;
        $[35] = isRtl;
        $[36] = maxMenuHeight;
        $[37] = menuPlacement;
        $[38] = menuPosition;
        $[39] = minMenuHeight;
        $[40] = options;
        $[41] = placement;
        $[42] = rest;
        $[43] = selectOption;
        $[44] = selectProps;
        $[45] = setValue;
        $[46] = t1;
        $[47] = t2;
    } else t2 = $[47];
    let t3;
    if ($[48] !== selectProps.fixedLayerRef || $[49] !== selectProps.inputValue || $[50] !== selectProps.testId || $[51] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $a0UNJ.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.fixedLayerRef,
            content: t2,
            testId: selectProps.testId
        });
        $[48] = selectProps.fixedLayerRef;
        $[49] = selectProps.inputValue;
        $[50] = selectProps.testId;
        $[51] = t2;
        $[52] = t3;
    } else t3 = $[52];
    return t3;
} : ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ $cozmU.createElement((0, $a0UNJ.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Menu // We have to have this because `getClassNames` is missing. Can't define
        , {
            ...rest,
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });
module.exports["FixedLayerMenu"] = $d7df26b4548de6c5$export$982ad994195b4356;

});

parcelRegister("5vaVZ", function(module, exports) {
/* fixed-layer-menu-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");

const $7679a2c453aa3d7d$var$popupPlacement = (0, $aRDbl.fromLegacyPlacement)({
    legacy: 'bottom-start'
}); /**
     * Top-layer version of the fixed layer menu used in the time picker.
     *
     * Uses `Popover` + `useAnchorPosition` so the time options list renders
     * in the browser's top layer via the native Popover API and is positioned
     * via CSS Anchor Positioning. This avoids overflow clipping, z-index wars,
     * and portal-based layering.
     *
     * Gated behind the `platform-dst-top-layer` feature flag.
     */ 
const $7679a2c453aa3d7d$export$3c22007991249e6a = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>{
    // The select's container element is the anchor for the popup.
    // @ts-ignore -- fixedLayerRef is a custom prop passed through selectProps
    const triggerRef = (0, $cozmU.useRef)(selectProps.fixedLayerRef ?? null); // @ts-ignore -- fixedLayerRef is a custom prop passed through selectProps
    triggerRef.current = selectProps.fixedLayerRef ?? null;
    const popoverRef = (0, $cozmU.useRef)(null);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $7679a2c453aa3d7d$var$popupPlacement,
        // The Popover is rendered with `isOpen` always true while this
        // component is mounted (react-select conditionally mounts/unmounts
        // the menu), so positioning is always active.
        isOpen: true
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        role: "listbox",
        isOpen: true // `mode="manual"` opts out of the native popover light-dismiss
        ,
        // (Esc / click-outside). react-select already owns those: opening
        // the menu via a click on the input that lives outside the popover
        // element triggers the browser's auto-dismiss as that very click
        // bubbles, slamming the menu shut before the user sees it. With
        // `manual`, react-select's existing onMenuClose / outside-click
        // logic remains the single source of truth.
        mode: "manual",
        placement: $7679a2c453aa3d7d$var$popupPlacement,
        shouldAnimate: true // @ts-ignore -- testId is a custom prop passed through selectProps
        ,
        testId: selectProps.testId && `${selectProps.testId}--popup`
    }, /*#__PURE__*/ $cozmU.createElement((0, $juXYb.PopoverSurface), null, /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Menu // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    , {
        ...rest,
        className: className,
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        innerProps: innerProps,
        innerRef: innerRef,
        isLoading: isLoading,
        isMulti: isMulti,
        isRtl: isRtl,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView,
        minMenuHeight: minMenuHeight,
        options: options,
        placement: placement,
        selectOption: selectOption,
        selectProps: selectProps,
        setValue: setValue
    }, children)));
};
module.exports["FixedLayerMenuTopLayer"] = $7679a2c453aa3d7d$export$3c22007991249e6a;

});

parcelRegister("jRlJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ebd82d353b6d234$export$2e2bcd8739ae039);

var $cEXxL = parcelRequire("cEXxL");


var $3TXOR = parcelRequire("3TXOR");


var $dmiWj = parcelRequire("dmiWj");

function $6ebd82d353b6d234$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $6ebd82d353b6d234$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!(0, $3TXOR.isValid)(trimmedTime)) throw RangeError('invalid time format');
    const time1 = (0, $dmiWj.removeSpacer)(trimmedTime);
    const time2 = (0, $cEXxL.convertTo24hrTime)(time1);
    if (!time2) throw RangeError('invalid time format');
    return $6ebd82d353b6d234$var$assignToDate(time2);
}

});

parcelRegister("cEXxL", function(module, exports) {
const $d25f7568623fcd0d$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $d25f7568623fcd0d$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $d25f7568623fcd0d$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $d25f7568623fcd0d$var$map24[hour];
    return hour;
}
function $d25f7568623fcd0d$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $d25f7568623fcd0d$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $d25f7568623fcd0d$var$formatSemi24(timeArray[0].trim());
    const hour = $d25f7568623fcd0d$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $d25f7568623fcd0d$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $d25f7568623fcd0d$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
module.exports["convertTo24hrTime"] = $d25f7568623fcd0d$export$6137ce2c9c5166bb;

});

parcelRegister("3TXOR", function(module, exports) {
function $955e9b862cbbca60$export$1ea939691cdc45b8(timeString) {
    /**
   * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
   */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
   * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
   */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
   * Convert `2:34:56 pm` down to `23456`
   */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
module.exports["isValid"] = $955e9b862cbbca60$export$1ea939691cdc45b8;

});

parcelRegister("dmiWj", function(module, exports) {
function $d7ba4051cca88286$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
module.exports["removeSpacer"] = $d7ba4051cca88286$export$49c81d9f91c512ce;

});

parcelRegister("1nAzh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $ibxUk = parcelRequire("ibxUk");

const $626e4f557e972c77$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $626e4f557e972c77$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $626e4f557e972c77$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $626e4f557e972c77$var$noop = (0, $dpsRj.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $626e4f557e972c77$var$Range = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Range(props, ref) {
    const $ = (0, $bDgLe.c)(30);
    let propsValue;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let testId;
    if ($[0] !== props) {
        ({ isDisabled: t0, defaultValue: t1, max: t2, min: t3, onChange: t4, step: t5, value: propsValue, testId: testId, ...rest } = props);
        $[0] = props;
        $[1] = propsValue;
        $[2] = rest;
        $[3] = t0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
        $[9] = testId;
    } else {
        propsValue = $[1];
        rest = $[2];
        t0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
        t4 = $[7];
        t5 = $[8];
        testId = $[9];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const defaultValue = t1 === undefined ? 50 : t1;
    const max = t2 === undefined ? 100 : t2;
    const min = t3 === undefined ? 0 : t3;
    const onChange = t4 === undefined ? $626e4f557e972c77$var$noop : t4;
    const step = t5 === undefined ? 1 : t5;
    let t6;
    if ($[10] !== max || $[11] !== min || $[12] !== ref || $[13] !== rest || $[14] !== step) {
        t6 = {
            max: max,
            min: min,
            step: step,
            ref: ref,
            ...rest
        };
        $[10] = max;
        $[11] = min;
        $[12] = ref;
        $[13] = rest;
        $[14] = step;
        $[15] = t6;
    } else t6 = $[15];
    const spreadProps = t6;
    const [value, setValue] = (0, $cozmU.useState)(propsValue !== undefined ? propsValue : defaultValue);
    let t7;
    if ($[16] !== onChange) {
        t7 = (e)=>{
            const newValue = Number(e.target.value);
            setValue(newValue);
            onChange(newValue);
        };
        $[16] = onChange;
        $[17] = t7;
    } else t7 = $[17];
    const handleChange = t7;
    const renderValue = propsValue !== undefined ? propsValue : value;
    let t8;
    if ($[18] !== max || $[19] !== min || $[20] !== renderValue || $[21] !== step) {
        t8 = $626e4f557e972c77$var$getRoundedPercentValue(renderValue, min, max, step);
        $[18] = max;
        $[19] = min;
        $[20] = renderValue;
        $[21] = step;
        $[22] = t8;
    } else t8 = $[22];
    const valuePercent = t8;
    let t9;
    if ($[23] !== handleChange || $[24] !== isDisabled || $[25] !== renderValue || $[26] !== spreadProps || $[27] !== testId || $[28] !== valuePercent) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ibxUk.Input), {
            type: "range",
            disabled: isDisabled,
            onChange: handleChange,
            value: renderValue,
            valuePercent: valuePercent,
            "data-testid": testId,
            ...spreadProps
        });
        $[23] = handleChange;
        $[24] = isDisabled;
        $[25] = renderValue;
        $[26] = spreadProps;
        $[27] = testId;
        $[28] = valuePercent;
        $[29] = t9;
    } else t9 = $[29];
    return t9;
} : function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $626e4f557e972c77$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $cozmU.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $cozmU.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $626e4f557e972c77$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ibxUk.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $626e4f557e972c77$export$2e2bcd8739ae039 = $626e4f557e972c77$var$Range;
module.exports["default"] = $626e4f557e972c77$export$2e2bcd8739ae039;

});

parcelRegister("ibxUk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $44bc1869b7f411bd$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $44bc1869b7f411bd$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $44bc1869b7f411bd$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $44bc1869b7f411bd$var$webkitStyles = null;
const $44bc1869b7f411bd$var$firefoxStyles = null;
const $44bc1869b7f411bd$var$baseStyles = null;
const $44bc1869b7f411bd$var$themeStyles = null;
const $44bc1869b7f411bd$var$trackStyles = {
    root: "_39xV02N91d _0jFU0VUF4f _1mT5xdRAKS _2Gfj6iaaQb _4Gb5FivLZJ _2jfUf9UNDJ _47eTBtUNDJ _2WYcYGWVPG _3wEj0XVbka _0GBAIrogpp _30QdGX715P _13xWvlqQ3B",
    disabled: "_43i6GSVx3j"
};
const $44bc1869b7f411bd$var$rangeA11yStyles = null;
const $44bc1869b7f411bd$var$stylesT26Shape = null;
const $44bc1869b7f411bd$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(15);
    let strippedProps;
    let valuePercent;
    if ($[0] !== props) {
        const { valuePercent: t0, style: style, ...t1 } = props;
        valuePercent = t0;
        strippedProps = t1;
        $[0] = props;
        $[1] = strippedProps;
        $[2] = valuePercent;
    } else {
        strippedProps = $[1];
        valuePercent = $[2];
    }
    const t0 = `${valuePercent}%`;
    let t1;
    if ($[3] !== t0) {
        t1 = {
            "--track-fg-width": t0
        };
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const t2 = t1;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VUF4f _0KLXrujOvk _02aXbKsyl5 _3DEn3pVx3j _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            "_2adT7gYbGa _17ReAQYbGa _3IHAwlaaQb _1sYYW7Vrbj _4GrA24b6HL _37S3Nh2Njc _1ZOu9k5zaO _3DRyPV5zaO _3lPNj5m16B _0k1a6ZfS3z _2gWDpA7zJH _4fppgMTUhv _2WlyQdFQfX _3bWcI9YbGa _2pMQocdnbC _14foojcjp5 _24UNV6b6HL _3r4mpwN91d _2MQsmsUNDJ _0EftWF9EtP _3rBb706me1 _3fvQmuUZDI _1yYvJCuwZZ _2XoiRY7zJH _41QrXoN91d _4FMTDxsyl5 _0mwPBwsyl5",
            "_4Fp6kmYbGa _2oineeaaQb _4bw98iVrbj _4E8jlcb6HL _140A2Y2Njc _1NiH9S5zaO _3RYj0k5zaO _2x9U81m16B _40wEAHfS3z _2q4f1U7zJH _3LbkvOFQfX _2KSo2ZdnbC _0WfM9tdnbC _0dbilWcjp5 _4jnX0xb6HL _0HKGiLN91d _3IDRyUZimw _269VPM1gZM _4ha2Av7zJH _1PUdHudnbC _3uogJhcjp5 _3Xcfvib6HL _3nmeTON91d _2E1hwOUNDJ _0S5Rla9EtP _0Jp0ui7zJH _4t8vtqsyl5 _3pwxuKsyl5 _0cNETXsyl5",
            "_2FCvJDcZWP _2JkLrPDMqu _2WxSQPgozt _1jxa9ckTlo _03UiPHKcZT _3F2lemkTlo _4dfxHuVbka _2MmwZ6nXvL",
            "_3hFerrVbka _2JkLrPB4sa _2WxSQPVbka _14foojzXzM _2MQsmsZimw _0dbilWzXzM _3IDRyUZimw _4fppgM8e2l _03UiPHVzWZ",
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && "_14foojS5Zs _0dbilWS5Zs _3uogJhS5Zs"
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== ref || $[7] !== strippedProps || $[8] !== t2) {
        t4 = /*#__PURE__*/ $cozmU.createElement("input", {
            ...strippedProps,
            style: t2,
            ref: ref,
            className: t3
        });
        $[6] = ref;
        $[7] = strippedProps;
        $[8] = t2;
        $[9] = t4;
    } else t4 = $[9];
    const input = t4;
    const t5 = strippedProps.disabled && $44bc1869b7f411bd$var$trackStyles.disabled;
    let t6;
    if ($[10] !== t5) {
        t6 = (0, $hekY6.default)([
            $44bc1869b7f411bd$var$trackStyles.root,
            t5
        ]);
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== input || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t6
        }, input);
        $[12] = input;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : (props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ $cozmU.createElement("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VUF4f _0KLXrujOvk _02aXbKsyl5 _3DEn3pVx3j _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            "_2adT7gYbGa _17ReAQYbGa _3IHAwlaaQb _1sYYW7Vrbj _4GrA24b6HL _37S3Nh2Njc _1ZOu9k5zaO _3DRyPV5zaO _3lPNj5m16B _0k1a6ZfS3z _2gWDpA7zJH _4fppgMTUhv _2WlyQdFQfX _3bWcI9YbGa _2pMQocdnbC _14foojcjp5 _24UNV6b6HL _3r4mpwN91d _2MQsmsUNDJ _0EftWF9EtP _3rBb706me1 _3fvQmuUZDI _1yYvJCuwZZ _2XoiRY7zJH _41QrXoN91d _4FMTDxsyl5 _0mwPBwsyl5",
            "_4Fp6kmYbGa _2oineeaaQb _4bw98iVrbj _4E8jlcb6HL _140A2Y2Njc _1NiH9S5zaO _3RYj0k5zaO _2x9U81m16B _40wEAHfS3z _2q4f1U7zJH _3LbkvOFQfX _2KSo2ZdnbC _0WfM9tdnbC _0dbilWcjp5 _4jnX0xb6HL _0HKGiLN91d _3IDRyUZimw _269VPM1gZM _4ha2Av7zJH _1PUdHudnbC _3uogJhcjp5 _3Xcfvib6HL _3nmeTON91d _2E1hwOUNDJ _0S5Rla9EtP _0Jp0ui7zJH _4t8vtqsyl5 _3pwxuKsyl5 _0cNETXsyl5",
            "_2FCvJDcZWP _2JkLrPDMqu _2WxSQPgozt _1jxa9ckTlo _03UiPHKcZT _3F2lemkTlo _4dfxHuVbka _2MmwZ6nXvL",
            "_3hFerrVbka _2JkLrPB4sa _2WxSQPVbka _14foojzXzM _2MQsmsZimw _0dbilWzXzM _3IDRyUZimw _4fppgM8e2l _03UiPHVzWZ",
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_14foojS5Zs _0dbilWS5Zs _3uogJhS5Zs"
        ])
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $44bc1869b7f411bd$var$trackStyles.root,
            strippedProps.disabled && $44bc1869b7f411bd$var$trackStyles.disabled
        ])
    }, input);
});
$44bc1869b7f411bd$export$f5b8910cec6cf069.displayName = 'InputRange';
module.exports["Input"] = $44bc1869b7f411bd$export$f5b8910cec6cf069;

});

parcelRegister("dplZo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $vQngM = parcelRequire("vQngM");

/** Defaults applied when the user has not chosen a value. Matches the approved design. */ const $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE = {
    responseTone: 'rovo_default',
    responseLength: 'shorter',
    responseStructure: 'less_structured',
    responseEmojis: 'none',
    responseTldr: 'enabled'
};
const $2da994df357ab3bc$export$f7de98346d47a650 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { assistanceServiceParams: assistanceServiceParams } = t0;
    let t1;
    if ($[0] !== assistanceServiceParams) {
        t1 = {
            assistanceServiceParams: assistanceServiceParams,
            enabled: true
        };
        $[0] = assistanceServiceParams;
        $[1] = t1;
    } else t1 = $[1];
    const { settings: settings, isFetching: isFetching, isSubmitting: isSubmitting, updateSettings: updateSettings } = (0, $vQngM.useRovoUserSettings)(t1);
    const t2 = settings?.responseTone ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseTone;
    const t3 = settings?.responseLength ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseLength;
    const t4 = settings?.responseStructure ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseStructure;
    const t5 = settings?.responseEmojis ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseEmojis;
    const t6 = settings?.responseTldr ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseTldr;
    const t7 = settings?.customInstructions;
    let t8;
    if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t6 || $[7] !== t7) {
        t8 = {
            responseTone: t2,
            responseLength: t3,
            responseStructure: t4,
            responseEmojis: t5,
            responseTldr: t6,
            customInstructions: t7
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
    } else t8 = $[8];
    const responseStyle = t8;
    let t9;
    if ($[9] !== updateSettings) {
        t9 = (responseTone, callbacks)=>updateSettings({
                responseTone: responseTone
            }, callbacks);
        $[9] = updateSettings;
        $[10] = t9;
    } else t9 = $[10];
    const setResponseTone = t9;
    let t10;
    if ($[11] !== updateSettings) {
        t10 = (responseLength, callbacks_0)=>updateSettings({
                responseLength: responseLength
            }, callbacks_0);
        $[11] = updateSettings;
        $[12] = t10;
    } else t10 = $[12];
    const setResponseLength = t10;
    let t11;
    if ($[13] !== updateSettings) {
        t11 = (responseStructure, callbacks_1)=>updateSettings({
                responseStructure: responseStructure
            }, callbacks_1);
        $[13] = updateSettings;
        $[14] = t11;
    } else t11 = $[14];
    const setResponseStructure = t11;
    let t12;
    if ($[15] !== updateSettings) {
        t12 = (responseEmojis, callbacks_2)=>updateSettings({
                responseEmojis: responseEmojis
            }, callbacks_2);
        $[15] = updateSettings;
        $[16] = t12;
    } else t12 = $[16];
    const setResponseEmojis = t12;
    let t13;
    if ($[17] !== updateSettings) {
        t13 = (responseTldr, callbacks_3)=>updateSettings({
                responseTldr: responseTldr
            }, callbacks_3);
        $[17] = updateSettings;
        $[18] = t13;
    } else t13 = $[18];
    const setResponseTldr = t13;
    let t14;
    if ($[19] !== updateSettings) {
        t14 = (customInstructions, callbacks_4)=>updateSettings({
                customInstructions: customInstructions
            }, callbacks_4);
        $[19] = updateSettings;
        $[20] = t14;
    } else t14 = $[20];
    const setCustomInstructions = t14;
    let t15;
    if ($[21] !== isFetching || $[22] !== isSubmitting || $[23] !== responseStyle || $[24] !== setCustomInstructions || $[25] !== setResponseEmojis || $[26] !== setResponseLength || $[27] !== setResponseStructure || $[28] !== setResponseTldr || $[29] !== setResponseTone) {
        t15 = {
            responseStyle: responseStyle,
            isLoading: isFetching,
            isSaving: isSubmitting,
            setResponseTone: setResponseTone,
            setResponseLength: setResponseLength,
            setResponseStructure: setResponseStructure,
            setResponseEmojis: setResponseEmojis,
            setResponseTldr: setResponseTldr,
            setCustomInstructions: setCustomInstructions
        };
        $[21] = isFetching;
        $[22] = isSubmitting;
        $[23] = responseStyle;
        $[24] = setCustomInstructions;
        $[25] = setResponseEmojis;
        $[26] = setResponseLength;
        $[27] = setResponseStructure;
        $[28] = setResponseTldr;
        $[29] = setResponseTone;
        $[30] = t15;
    } else t15 = $[30];
    return t15;
} : ({ assistanceServiceParams: assistanceServiceParams })=>{
    const { settings: settings, isFetching: isFetching, isSubmitting: isSubmitting, updateSettings: updateSettings } = (0, $vQngM.useRovoUserSettings)({
        assistanceServiceParams: assistanceServiceParams,
        enabled: true
    });
    const responseStyle = (0, $cozmU.useMemo)(()=>({
            responseTone: settings?.responseTone ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseTone,
            responseLength: settings?.responseLength ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseLength,
            responseStructure: settings?.responseStructure ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseStructure,
            responseEmojis: settings?.responseEmojis ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseEmojis,
            responseTldr: settings?.responseTldr ?? $2da994df357ab3bc$var$DEFAULT_RESPONSE_STYLE.responseTldr,
            customInstructions: settings?.customInstructions
        }), [
        settings
    ]);
    const setResponseTone = (0, $cozmU.useCallback)((responseTone, callbacks)=>updateSettings({
            responseTone: responseTone
        }, callbacks), [
        updateSettings
    ]);
    const setResponseLength = (0, $cozmU.useCallback)((responseLength, callbacks_0)=>updateSettings({
            responseLength: responseLength
        }, callbacks_0), [
        updateSettings
    ]);
    const setResponseStructure = (0, $cozmU.useCallback)((responseStructure, callbacks_1)=>updateSettings({
            responseStructure: responseStructure
        }, callbacks_1), [
        updateSettings
    ]);
    const setResponseEmojis = (0, $cozmU.useCallback)((responseEmojis, callbacks_2)=>updateSettings({
            responseEmojis: responseEmojis
        }, callbacks_2), [
        updateSettings
    ]);
    const setResponseTldr = (0, $cozmU.useCallback)((responseTldr, callbacks_3)=>updateSettings({
            responseTldr: responseTldr
        }, callbacks_3), [
        updateSettings
    ]);
    const setCustomInstructions = (0, $cozmU.useCallback)((customInstructions, callbacks_4)=>updateSettings({
            customInstructions: customInstructions
        }, callbacks_4), [
        updateSettings
    ]);
    return {
        responseStyle: responseStyle,
        isLoading: isFetching,
        isSaving: isSubmitting,
        setResponseTone: setResponseTone,
        setResponseLength: setResponseLength,
        setResponseStructure: setResponseStructure,
        setResponseEmojis: setResponseEmojis,
        setResponseTldr: setResponseTldr,
        setCustomInstructions: setCustomInstructions
    };
};
module.exports["useResponseStyleSettings"] = $2da994df357ab3bc$export$f7de98346d47a650;

});

parcelRegister("2diYd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $6wOvs = parcelRequire("6wOvs");


var $f6wWZ = parcelRequire("f6wWZ");


var $ikV3b = parcelRequire("ikV3b");


var $k22Xw = parcelRequire("k22Xw");

const $4ec713fa0db90eb4$var$styles = {
    root: "_0jFU0VoWWg _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _3TGfC9LRg7 _0hPCNLDIqT",
    rootWithAdornment: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _3TGfC9LRg7 _0hPCNLDIqT",
    iconContainer: "_2mHwu82ADO _0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w",
    textRow: "_0jFU0VoWWg _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
    text: "_2sNsIgmnOE _1UtDYzy7kJ _3W2Oc8wPeg",
    textNoWrap: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _1ANEUSLRg7",
    ellipsesContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $4ec713fa0db90eb4$var$getLoadingMorphingIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ikV3b.MorphingShapeLoader), {
        testId: "morphing-loader"
    });
};
const $4ec713fa0db90eb4$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(icon)) return icon;
    else if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k22Xw.LazyAnimatedRovoIcon), {
        alt: "Rovo",
        testId: "rovo-loading-animation",
        width: "24px",
        height: "24px"
    });
    return null;
};
const $4ec713fa0db90eb4$export$cc468b3595726b51 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { title: title, isAnimated: t1, icon: t2, animation: t3, disableMorphingAnimation: t4, showEllipsis: t5, testId: testId, bottomAdornment: bottomAdornment } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const icon = t2 === undefined ? true : t2;
    const animation = t3 === undefined ? false : t3;
    const disableMorphingAnimation = t4 === undefined ? false : t4;
    const showEllipsis = t5 === undefined ? true : t5;
    const enableAnimation = animation;
    let t6;
    if ($[0] !== disableMorphingAnimation || $[1] !== enableAnimation || $[2] !== icon) {
        t6 = enableAnimation && !disableMorphingAnimation ? $4ec713fa0db90eb4$var$getLoadingMorphingIcon() : $4ec713fa0db90eb4$var$getIcon(icon);
        $[0] = disableMorphingAnimation;
        $[1] = enableAnimation;
        $[2] = icon;
        $[3] = t6;
    } else t6 = $[3];
    const iconNode = t6;
    const t7 = showEllipsis ? $4ec713fa0db90eb4$var$styles.textNoWrap : $4ec713fa0db90eb4$var$styles.text;
    let t8;
    if ($[4] !== enableAnimation || $[5] !== title) {
        t8 = enableAnimation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), null, title) : title;
        $[4] = enableAnimation;
        $[5] = title;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== t7 || $[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t7
        }, t8);
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    const textNode = t9;
    let t10;
    if ($[10] !== isAnimated || $[11] !== showEllipsis) {
        t10 = showEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.ellipsesContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
            isAnimated: isAnimated
        })) : null;
        $[10] = isAnimated;
        $[11] = showEllipsis;
        $[12] = t10;
    } else t10 = $[12];
    const ellipsesNode = t10;
    if (bottomAdornment) {
        let t11;
        if ($[13] !== iconNode) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.iconContainer
            }, iconNode);
            $[13] = iconNode;
            $[14] = t11;
        } else t11 = $[14];
        let t12;
        if ($[15] !== ellipsesNode || $[16] !== textNode) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.textRow
            }, textNode, ellipsesNode);
            $[15] = ellipsesNode;
            $[16] = textNode;
            $[17] = t12;
        } else t12 = $[17];
        let t13;
        if ($[18] !== bottomAdornment || $[19] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.textColumn
            }, t12, bottomAdornment);
            $[18] = bottomAdornment;
            $[19] = t12;
            $[20] = t13;
        } else t13 = $[20];
        let t14;
        if ($[21] !== t11 || $[22] !== t13 || $[23] !== testId) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.rootWithAdornment,
                testId: testId
            }, t11, t13);
            $[21] = t11;
            $[22] = t13;
            $[23] = testId;
            $[24] = t14;
        } else t14 = $[24];
        return t14;
    }
    let t11;
    if ($[25] !== iconNode || $[26] !== textNode) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.iconContainer
        }, iconNode, textNode);
        $[25] = iconNode;
        $[26] = textNode;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== ellipsesNode || $[29] !== t11 || $[30] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.root,
            testId: testId
        }, t11, ellipsesNode);
        $[28] = ellipsesNode;
        $[29] = t11;
        $[30] = testId;
        $[31] = t12;
    } else t12 = $[31];
    return t12;
} : ({ title: title, isAnimated: isAnimated = true, icon: icon = true, animation: animation = false, disableMorphingAnimation: disableMorphingAnimation = false, showEllipsis: showEllipsis = true, testId: testId, bottomAdornment: bottomAdornment })=>{
    const enableAnimation = animation;
    const iconNode = enableAnimation && !disableMorphingAnimation ? $4ec713fa0db90eb4$var$getLoadingMorphingIcon() : $4ec713fa0db90eb4$var$getIcon(icon);
    const textNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showEllipsis ? $4ec713fa0db90eb4$var$styles.textNoWrap : $4ec713fa0db90eb4$var$styles.text
    }, enableAnimation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), null, title) : title);
    const ellipsesNode = showEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.ellipsesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
        isAnimated: isAnimated
    })) : null;
    if (bottomAdornment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.rootWithAdornment,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.iconContainer
    }, iconNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.textColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.textRow
    }, textNode, ellipsesNode), bottomAdornment));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.root,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.iconContainer
    }, iconNode, textNode), ellipsesNode);
};
module.exports["RovoThinkingIndicator"] = $4ec713fa0db90eb4$export$cc468b3595726b51;

});

parcelRegister("f6wWZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $942fc30d2b38e6cb$var$animation = null;
const $942fc30d2b38e6cb$var$animation1 = null;
const $942fc30d2b38e6cb$var$animation2 = null;
const $942fc30d2b38e6cb$var$dot1 = null;
const $942fc30d2b38e6cb$var$dot2 = null;
const $942fc30d2b38e6cb$var$dot3 = null;
const $942fc30d2b38e6cb$var$animatedOpacity = null;
const $942fc30d2b38e6cb$export$c0e6915bcce7d1d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isAnimated: t1 } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const t2 = isAnimated && "";
    const t3 = isAnimated && "_2fBhteHasb";
    const t4 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t5;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t2,
            t3,
            t4
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t5,
            d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
            fill: "#1868DB"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = isAnimated && "";
    const t8 = isAnimated && "_2fBhteVjaG";
    const t9 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t10;
    if ($[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
        t10 = (0, $hekY6.default)([
            t7,
            t8,
            t9
        ]);
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t10,
            d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
            fill: "#BF63F3"
        });
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const t12 = isAnimated && "";
    const t13 = isAnimated && "_2fBhtegMFr";
    const t14 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t15;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14) {
        t15 = (0, $hekY6.default)([
            t12,
            t13,
            t14
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t15,
            d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
            fill: "#FCA700"
        });
        $[16] = t15;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== t11 || $[19] !== t16 || $[20] !== t6) {
        t17 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t6, t11, t16);
        $[18] = t11;
        $[19] = t16;
        $[20] = t6;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhteHasb",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhteVjaG",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhtegMFr",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};
module.exports["EllipsesAnimation"] = $942fc30d2b38e6cb$export$c0e6915bcce7d1d0;

});

parcelRegister("ikV3b", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lvJXz = parcelRequire("lvJXz");


var $iDrrr = parcelRequire("iDrrr");


var $dRDh9 = parcelRequire("dRDh9");

// Module-level state — persists the current frame across remounts
// so the morphing animation continues smoothly without restarting.
let $922511a0939f4ef0$var$savedFrame = 0;
let $922511a0939f4ef0$var$hasPlayedBefore = false;
const $922511a0939f4ef0$var$getSafeFrame = (frame)=>Number.isFinite(frame) && frame >= 0 ? frame : 0;
const $922511a0939f4ef0$var$SIZE_MAP = {
    small: 16,
    medium: 24,
    large: 32
};
const $922511a0939f4ef0$export$c07a397cf5c24cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { testId: testId, size: t1 } = t0;
    const size = t1 === undefined ? "small" : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const lottieSize = (0, $iDrrr.fg)("rovo_morphing_shape_loader_size") ? $922511a0939f4ef0$var$SIZE_MAP[size] : 16;
    const containerSize = (0, $iDrrr.fg)("rovo_morphing_shape_loader_size") ? lottieSize + 8 : 24;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const currentRef = containerRef.current;
            if (!currentRef) return;
            const baseAnimationConfig = {
                container: currentRef,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($dRDh9))),
                renderer: "svg",
                loop: true
            };
            if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation !== "function") return;
            const animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: true
            });
            if ($922511a0939f4ef0$var$hasPlayedBefore) animationInstance.goToAndPlay($922511a0939f4ef0$var$getSafeFrame($922511a0939f4ef0$var$savedFrame), true);
            $922511a0939f4ef0$var$hasPlayedBefore = true;
            return ()=>{
                $922511a0939f4ef0$var$savedFrame = $922511a0939f4ef0$var$getSafeFrame(animationInstance.currentFrame);
                animationInstance.destroy();
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== containerSize) {
        t4 = {
            width: containerSize,
            height: containerSize,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible"
        };
        $[2] = containerSize;
        $[3] = t4;
    } else t4 = $[3];
    const containerStyle = t4;
    let t5;
    if ($[4] !== lottieSize) {
        t5 = {
            width: lottieSize,
            height: lottieSize
        };
        $[4] = lottieSize;
        $[5] = t5;
    } else t5 = $[5];
    const lottieWrapperStyle = t5;
    let t6;
    if ($[6] !== lottieWrapperStyle) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: lottieWrapperStyle,
            ref: containerRef
        });
        $[6] = lottieWrapperStyle;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== containerStyle || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: containerStyle,
            "data-testid": testId
        }, t6);
        $[8] = containerStyle;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ testId: testId, size: size = 'small' })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const lottieSize = (0, $iDrrr.fg)('rovo_morphing_shape_loader_size') ? $922511a0939f4ef0$var$SIZE_MAP[size] : 16;
    const containerSize = (0, $iDrrr.fg)('rovo_morphing_shape_loader_size') ? lottieSize + 8 : 24;
    (0, $cozmU.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($dRDh9))),
            renderer: 'svg',
            loop: true
        };
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation !== 'function') return;
        const animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        if ($922511a0939f4ef0$var$hasPlayedBefore) // Remount — resume from saved frame, while still autoplaying as a visible fallback.
        animationInstance.goToAndPlay($922511a0939f4ef0$var$getSafeFrame($922511a0939f4ef0$var$savedFrame), true);
        $922511a0939f4ef0$var$hasPlayedBefore = true;
        return ()=>{
            // Save current frame before destroying
            $922511a0939f4ef0$var$savedFrame = $922511a0939f4ef0$var$getSafeFrame(animationInstance.currentFrame);
            animationInstance.destroy();
        };
    }, []);
    const containerStyle = {
        width: containerSize,
        height: containerSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible'
    };
    const lottieWrapperStyle = {
        width: lottieSize,
        height: lottieSize
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: containerStyle,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: lottieWrapperStyle,
        ref: containerRef
    })));
};
module.exports["MorphingShapeLoader"] = $922511a0939f4ef0$export$c07a397cf5c24cd8;

});

parcelRegister("dRDh9", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[240],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":11,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":32,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":37,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":59,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":64,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":86,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":91,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");

});

parcelRegister("k22Xw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $e5a0bad3f68b70bd$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("Bttch")));
const $e5a0bad3f68b70bd$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-platform-ui-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5a0bad3f68b70bd$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-platform-ui-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5a0bad3f68b70bd$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $e5a0bad3f68b70bd$export$7ea4e54699cd5224;

});

parcelRegister("Bttch", function(module, exports) {

let $070a50ed8fa7d465$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $070a50ed8fa7d465$var$load("70zyE").then(()=>parcelRequire('hGjSS'));

});

parcelRegister("3uG5w", function(module, exports) {
const $5afa62ba09a8a3b6$export$98646fa63a7524c7 = {
    fullScreenActions: 700,
    fullscreenInput: 300,
    sidebarActions: 100
};
module.exports["ANIMATION_TIMINGS"] = $5afa62ba09a8a3b6$export$98646fa63a7524c7;

});

parcelRegister("jAQW4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $17bf29e0c7c15551$export$a7f711f3ac7072e2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const config = t1;
    const { delay: delay, onStaggeringAnimationTimeout: onStaggeringAnimationTimeout } = config;
    const [shouldAnimate, setShouldAnimate] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[2] !== delay || $[3] !== onStaggeringAnimationTimeout) {
        t2 = ()=>{
            const timeout = setTimeout(()=>{
                setShouldAnimate(true);
                onStaggeringAnimationTimeout?.();
            }, delay);
            return ()=>clearTimeout(timeout);
        };
        t3 = [
            delay,
            onStaggeringAnimationTimeout
        ];
        $[2] = delay;
        $[3] = onStaggeringAnimationTimeout;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldAnimate(false);
        };
        $[6] = t4;
    } else t4 = $[6];
    const resetAnimation = t4;
    let t5;
    if ($[7] !== shouldAnimate) {
        t5 = {
            shouldAnimate: shouldAnimate,
            resetAnimation: resetAnimation
        };
        $[7] = shouldAnimate;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : (config = {})=>{
    const { delay: delay, onStaggeringAnimationTimeout: onStaggeringAnimationTimeout } = config;
    const [shouldAnimate, setShouldAnimate] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setShouldAnimate(true);
            onStaggeringAnimationTimeout?.();
        }, delay);
        return ()=>clearTimeout(timeout);
    }, [
        delay,
        onStaggeringAnimationTimeout
    ]);
    const resetAnimation = (0, $cozmU.useCallback)(()=>{
        setShouldAnimate(false);
    }, []);
    return {
        shouldAnimate: shouldAnimate,
        resetAnimation: resetAnimation
    };
};
module.exports["useStaggerAnimation"] = $17bf29e0c7c15551$export$a7f711f3ac7072e2;

});

parcelRegister("aBUXY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $brN3F = parcelRequire("brN3F");

const $efd4bff98fde0a14$export$e58bd68867dce41e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const dispatch = (0, $cozmU.useContext)((0, $brN3F.PlaceholderOverrideDispatchContext));
    if (dispatch === null) throw new Error("usePlaceholderOverrideDispatch must be used within ChatInputPlaceholderOverrideProvider");
    return dispatch;
} : ()=>{
    const dispatch = (0, $cozmU.useContext)((0, $brN3F.PlaceholderOverrideDispatchContext));
    if (dispatch === null) throw new Error('usePlaceholderOverrideDispatch must be used within ChatInputPlaceholderOverrideProvider');
    return dispatch;
};
module.exports["usePlaceholderOverrideDispatch"] = $efd4bff98fde0a14$export$e58bd68867dce41e;

});

parcelRegister("jsad9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5SS4O = parcelRequire("5SS4O");


var $7pCWA = parcelRequire("7pCWA");


var $ekfm7 = parcelRequire("ekfm7");


var $8hYSP = parcelRequire("8hYSP");


var $j3dQ1 = parcelRequire("j3dQ1");

function $05c3ae02fdeb758f$var$mapSourceToOption(source) {
    return {
        label: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source.source, source.friendlyName),
        value: source.source,
        iconUrl: source.iconUrl
    };
}
const $05c3ae02fdeb758f$export$3d24374afad920d1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useAppOptionsForSelect(assistanceServiceParams) {
    const $ = (0, $bDgLe.c)(20);
    let t0;
    if ($[0] !== assistanceServiceParams) {
        t0 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[0] = assistanceServiceParams;
        $[1] = t0;
    } else t0 = $[1];
    (0, $ekfm7.useEnsureConnectorsLoaded)(t0);
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [storeIsFetching] = (0, $7pCWA.useConnectorsIsFetching)();
    const productSortOrderProvider = (0, $8hYSP.useProductSortOrder)();
    let t1;
    if ($[2] !== storeAllSources) {
        t1 = storeAllSources.filter($05c3ae02fdeb758f$var$_temp);
        $[2] = storeAllSources;
        $[3] = t1;
    } else t1 = $[3];
    const sources = t1;
    let t2;
    if ($[4] !== sources) {
        t2 = sources.map($05c3ae02fdeb758f$var$_temp2).join(",");
        $[4] = sources;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = [
            "app-options-sorted",
            t2
        ];
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const sortQueryKey = t3;
    let t4;
    if ($[8] !== productSortOrderProvider || $[9] !== sources) {
        t4 = async ()=>{
            const sortFn = await productSortOrderProvider();
            return sources.map($05c3ae02fdeb758f$var$mapSourceToOption).sort((a, b)=>sortFn(a.value, b.value));
        };
        $[8] = productSortOrderProvider;
        $[9] = sources;
        $[10] = t4;
    } else t4 = $[10];
    const t5 = sources.length > 0;
    let t6;
    if ($[11] !== sortQueryKey || $[12] !== t4 || $[13] !== t5) {
        t6 = {
            queryKey: sortQueryKey,
            queryFn: t4,
            enabled: t5
        };
        $[11] = sortQueryKey;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    const { data: sortedOptions, isFetching: isSorting } = (0, $5SS4O.useQuery)(t6);
    let t7;
    if ($[15] !== sortedOptions) {
        t7 = sortedOptions ?? [];
        $[15] = sortedOptions;
        $[16] = t7;
    } else t7 = $[16];
    const options = t7;
    const t8 = storeIsFetching || isSorting;
    let t9;
    if ($[17] !== options || $[18] !== t8) {
        t9 = {
            options: options,
            isLoading: t8
        };
        $[17] = options;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : function useAppOptionsForSelect(assistanceServiceParams) {
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [storeIsFetching] = (0, $7pCWA.useConnectorsIsFetching)();
    const productSortOrderProvider = (0, $8hYSP.useProductSortOrder)();
    const sources = (0, $cozmU.useMemo)(()=>{
        return storeAllSources.filter((source)=>source.isUserOAuthed === true);
    }, [
        storeAllSources
    ]);
    const sortQueryKey = (0, $cozmU.useMemo)(()=>[
            'app-options-sorted',
            sources.map((s)=>s.source).join(',')
        ], [
        sources
    ]);
    const { data: sortedOptions, isFetching: isSorting } = (0, $5SS4O.useQuery)({
        queryKey: sortQueryKey,
        queryFn: async ()=>{
            const sortFn = await productSortOrderProvider();
            return sources.map($05c3ae02fdeb758f$var$mapSourceToOption).sort((a, b)=>sortFn(a.value, b.value));
        },
        enabled: sources.length > 0
    });
    const options = sortedOptions ?? [];
    return {
        options: options,
        isLoading: storeIsFetching || isSorting
    };
};
function $05c3ae02fdeb758f$var$_temp2(s) {
    return s.source;
}
function $05c3ae02fdeb758f$var$_temp(source) {
    return source.isUserOAuthed === true;
}
module.exports["useAppOptionsForSelect"] = $05c3ae02fdeb758f$export$3d24374afad920d1;

});

parcelRegister("4NbSC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $7pCWA = parcelRequire("7pCWA");


var $4gLhk = parcelRequire("4gLhk");


var $cvLcO = parcelRequire("cvLcO");

const $e92fbaf61117ac18$var$PRODUCT_NAME_MAP = {
    googledrive: 'google_drive',
    googlecalendar: 'google_calendar',
    microsoftteams: 'teams',
    microsoftonedrive: 'microsoft_onedrive',
    microsoftsharepoint: 'microsoft_sharepoint',
    microsoftpowerbi: 'microsoft_power_bi',
    atlas: 'atlas_goal'
};
const $e92fbaf61117ac18$var$normalizeSourceApp = (appSource)=>{
    const lower = appSource.toLowerCase().trim();
    return $e92fbaf61117ac18$var$PRODUCT_NAME_MAP[lower] ?? lower;
};
const $e92fbaf61117ac18$var$styles = {
    iconsContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS _2Zuz6QFQfX",
    iconsContainerNoPaddingLeft: "_2Zuz6QPgdg",
    appIcon: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKHxCOs _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _11sDorYbGa _09g4GJdnbC _0GcWPednbC"
};
const $e92fbaf61117ac18$var$ICON_ROTATIONS = {
    1: -6,
    3: 8
};
const $e92fbaf61117ac18$export$b887bc1aca5c5729 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appSource: appSource, iconUrl: iconUrl, zIndex: zIndex, isOverlapping: isOverlapping, index: index } = t0;
    if (!iconUrl) return null;
    let t1;
    if ($[0] !== appSource) {
        t1 = $e92fbaf61117ac18$var$normalizeSourceApp(appSource);
        $[0] = appSource;
        $[1] = t1;
    } else t1 = $[1];
    const normalizedAppSource = t1;
    const rotation = index !== undefined && (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26") ? $e92fbaf61117ac18$var$ICON_ROTATIONS[index] : undefined;
    const t2 = isOverlapping ? "-4px" : undefined;
    const t3 = rotation ? `rotate(${rotation}deg)` : undefined;
    let t4;
    if ($[2] !== t2 || $[3] !== t3 || $[4] !== zIndex) {
        t4 = {
            zIndex: zIndex,
            marginLeft: t2,
            transform: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = zIndex;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== iconUrl || $[7] !== normalizedAppSource) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: iconUrl,
            alt: normalizedAppSource,
            width: 16,
            height: 16
        });
        $[6] = iconUrl;
        $[7] = normalizedAppSource;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e92fbaf61117ac18$var$styles.appIcon,
            style: t4
        }, t5);
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appSource: appSource, iconUrl: iconUrl, zIndex: zIndex, isOverlapping: isOverlapping, index: index })=>{
    if (!iconUrl) return null;
    const normalizedAppSource = $e92fbaf61117ac18$var$normalizeSourceApp(appSource);
    const rotation = index !== undefined && (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') ? $e92fbaf61117ac18$var$ICON_ROTATIONS[index] : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e92fbaf61117ac18$var$styles.appIcon,
        style: {
            zIndex: zIndex,
            marginLeft: isOverlapping ? '-4px' : undefined,
            transform: rotation ? `rotate(${rotation}deg)` : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: iconUrl,
        alt: normalizedAppSource,
        width: 16,
        height: 16
    }));
}; /** Row container for overlapping app icons. Reused by prompt cards and source icons. */ 
const $e92fbaf61117ac18$export$3c842badfafa7c22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, noPaddingLeft: noPaddingLeft } = t0;
    const t1 = noPaddingLeft && $e92fbaf61117ac18$var$styles.iconsContainerNoPaddingLeft;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($e92fbaf61117ac18$var$styles.iconsContainer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, noPaddingLeft: noPaddingLeft })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e92fbaf61117ac18$var$styles.iconsContainer, noPaddingLeft && $e92fbaf61117ac18$var$styles.iconsContainerNoPaddingLeft)
    }, children);
const $e92fbaf61117ac18$var$extractAppSourcesWithCounts = (sources)=>{
    const appSourceCounts = new Map();
    sources.forEach(({ product: product, ari: ari })=>{
        let appSource = null;
        if (product) appSource = $e92fbaf61117ac18$var$normalizeSourceApp(product);
        if (!appSource && ari) {
            const productName = (0, $4gLhk.extractProductNameFromARI)(ari);
            if (productName) appSource = $e92fbaf61117ac18$var$normalizeSourceApp(productName);
        }
        if (appSource) appSourceCounts.set(appSource, (appSourceCounts.get(appSource) || 0) + 1);
    });
    return Array.from(appSourceCounts.entries()).sort((a, b)=>b[1] - a[1]);
};
const $e92fbaf61117ac18$export$e203adedbd5fe6a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { sources: sources } = t0;
    let t1;
    if ($[0] !== sources) {
        t1 = $e92fbaf61117ac18$var$extractAppSourcesWithCounts(sources);
        $[0] = sources;
        $[1] = t1;
    } else t1 = $[1];
    const appSourcesWithCounts = t1;
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    let t2;
    if ($[2] !== storeAllSources) {
        t2 = new Map(storeAllSources.map($e92fbaf61117ac18$var$_temp));
        $[2] = storeAllSources;
        $[3] = t2;
    } else t2 = $[3];
    const appIconUrlMap = t2;
    let t3;
    if ($[4] !== appSourcesWithCounts) {
        t3 = appSourcesWithCounts.slice(0, (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26") ? 4 : 3).map($e92fbaf61117ac18$var$_temp2);
        $[4] = appSourcesWithCounts;
        $[5] = t3;
    } else t3 = $[5];
    const topAppSourcesWithIcons = t3;
    if (topAppSourcesWithIcons.length === 0) return null;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26");
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== appIconUrlMap || $[8] !== topAppSourcesWithIcons) {
        let t6;
        if ($[10] !== appIconUrlMap || $[11] !== topAppSourcesWithIcons.length) {
            t6 = (appSource_0, index)=>{
                const normalizedSource = $e92fbaf61117ac18$var$normalizeSourceApp(appSource_0);
                const iconUrl = appIconUrlMap.get(normalizedSource);
                const isOverlapping = index > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$b887bc1aca5c5729, {
                    key: `${appSource_0}-${normalizedSource}`,
                    appSource: normalizedSource,
                    iconUrl: iconUrl,
                    zIndex: (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26") ? index + 1 : topAppSourcesWithIcons.length - index,
                    isOverlapping: isOverlapping,
                    index: (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26") ? index : undefined
                });
            };
            $[10] = appIconUrlMap;
            $[11] = topAppSourcesWithIcons.length;
            $[12] = t6;
        } else t6 = $[12];
        t5 = topAppSourcesWithIcons.map(t6);
        $[7] = appIconUrlMap;
        $[8] = topAppSourcesWithIcons;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$3c842badfafa7c22, {
            noPaddingLeft: t4
        }, t5);
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ sources: sources })=>{
    const appSourcesWithCounts = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>$e92fbaf61117ac18$var$extractAppSourcesWithCounts(sources), [
        sources
    ]);
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const appIconUrlMap = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return new Map(storeAllSources.map((source)=>[
                $e92fbaf61117ac18$var$normalizeSourceApp(source.source),
                source.iconUrl
            ]));
    }, [
        storeAllSources
    ]); // Filter to only include sources with iconUrls, then take top 3 or 4 for TWG flag
    const topAppSourcesWithIcons = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return appSourcesWithCounts.slice(0, (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') ? 4 : 3).map(([appSource])=>appSource);
    }, [
        appSourcesWithCounts
    ]);
    if (topAppSourcesWithIcons.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$3c842badfafa7c22, {
        noPaddingLeft: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26')
    }, topAppSourcesWithIcons.map((appSource_0, index)=>{
        const normalizedSource = $e92fbaf61117ac18$var$normalizeSourceApp(appSource_0);
        const iconUrl = appIconUrlMap.get(normalizedSource);
        const isOverlapping = index > 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$b887bc1aca5c5729, {
            key: `${appSource_0}-${normalizedSource}`,
            appSource: normalizedSource,
            iconUrl: iconUrl,
            zIndex: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') ? index + 1 : topAppSourcesWithIcons.length - index,
            isOverlapping: isOverlapping,
            index: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') ? index : undefined
        });
    }));
};
const $e92fbaf61117ac18$export$e5b256719ec2d67e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? function AssignedAppsIcons(t0) {
    const $ = (0, $bDgLe.c)(31);
    const { appIds: appIds, assistanceServiceParams: assistanceServiceParams } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    let map;
    if ($[0] !== storeAllSources) {
        map = new Map();
        storeAllSources.forEach((s)=>{
            map.set($e92fbaf61117ac18$var$normalizeSourceApp(s.source), {
                iconUrl: s.iconUrl,
                friendlyName: s.friendlyName
            });
        });
        $[0] = storeAllSources;
        $[1] = map;
    } else map = $[1];
    const sourceMap = map;
    let t1;
    if ($[2] !== appIds || $[3] !== sourceMap) {
        let t2;
        if ($[5] !== sourceMap) {
            t2 = (id)=>{
                const normalized = $e92fbaf61117ac18$var$normalizeSourceApp(id);
                const config = sourceMap.get(normalized);
                return config ? {
                    source: id,
                    ...config
                } : null;
            };
            $[5] = sourceMap;
            $[6] = t2;
        } else t2 = $[6];
        t1 = appIds.map(t2).filter($e92fbaf61117ac18$var$_temp3);
        $[2] = appIds;
        $[3] = sourceMap;
        $[4] = t1;
    } else t1 = $[4];
    const appsWithConfig = t1;
    if (!assistanceServiceParams || appsWithConfig.length === 0) return null;
    if (appsWithConfig.length === 1) {
        const app = appsWithConfig[0];
        let t2;
        if ($[7] !== app.iconUrl || $[8] !== app.source) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$3c842badfafa7c22, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$b887bc1aca5c5729, {
                appSource: app.source,
                iconUrl: app.iconUrl,
                zIndex: 1,
                isOverlapping: false
            }));
            $[7] = app.iconUrl;
            $[8] = app.source;
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] !== app.friendlyName) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                size: "small"
            }, app.friendlyName);
            $[10] = app.friendlyName;
            $[11] = t3;
        } else t3 = $[11];
        let t4;
        if ($[12] !== t2 || $[13] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
            $[12] = t2;
            $[13] = t3;
            $[14] = t4;
        } else t4 = $[14];
        return t4;
    }
    let T0;
    let T1;
    let t2;
    if ($[15] !== appsWithConfig) {
        const displayApps = appsWithConfig.slice(0, 3);
        T1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
        T0 = $e92fbaf61117ac18$export$3c842badfafa7c22;
        t2 = displayApps.map((app_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$b887bc1aca5c5729, {
                key: app_0.source,
                appSource: app_0.source,
                iconUrl: app_0.iconUrl,
                zIndex: displayApps.length - index,
                isOverlapping: index > 0
            }));
        $[15] = appsWithConfig;
        $[16] = T0;
        $[17] = T1;
        $[18] = t2;
    } else {
        T0 = $[16];
        T1 = $[17];
        t2 = $[18];
    }
    let t3;
    if ($[19] !== T0 || $[20] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, null, t2);
        $[19] = T0;
        $[20] = t2;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== appIds.length || $[23] !== formatMessage) {
        t4 = formatMessage((0, $cvLcO.assignedAppsCountMessages).appsCount, {
            count: appIds.length
        });
        $[22] = appIds.length;
        $[23] = formatMessage;
        $[24] = t4;
    } else t4 = $[24];
    let t5;
    if ($[25] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, t4);
        $[25] = t4;
        $[26] = t5;
    } else t5 = $[26];
    let t6;
    if ($[27] !== T1 || $[28] !== t3 || $[29] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, null, t3, t5);
        $[27] = T1;
        $[28] = t3;
        $[29] = t5;
        $[30] = t6;
    } else t6 = $[30];
    return t6;
} : function AssignedAppsIcons({ appIds: appIds, assistanceServiceParams: assistanceServiceParams }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const sourceMap = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const map = new Map();
        storeAllSources.forEach((s)=>{
            map.set($e92fbaf61117ac18$var$normalizeSourceApp(s.source), {
                iconUrl: s.iconUrl,
                friendlyName: s.friendlyName
            });
        });
        return map;
    }, [
        storeAllSources
    ]);
    const appsWithConfig = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return appIds.map((id)=>{
            const normalized = $e92fbaf61117ac18$var$normalizeSourceApp(id);
            const config = sourceMap.get(normalized);
            return config ? {
                source: id,
                ...config
            } : null;
        }).filter((a)=>a !== null);
    }, [
        appIds,
        sourceMap
    ]);
    if (!assistanceServiceParams || appsWithConfig.length === 0) return null;
    if (appsWithConfig.length === 1) {
        const app = appsWithConfig[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$3c842badfafa7c22, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$b887bc1aca5c5729, {
            appSource: app.source,
            iconUrl: app.iconUrl,
            zIndex: 1,
            isOverlapping: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, app.friendlyName));
    }
    const maxIcons = 3;
    const displayApps = appsWithConfig.slice(0, maxIcons);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$3c842badfafa7c22, null, displayApps.map((app_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e92fbaf61117ac18$export$b887bc1aca5c5729, {
            key: app_0.source,
            appSource: app_0.source,
            iconUrl: app_0.iconUrl,
            zIndex: displayApps.length - index,
            isOverlapping: index > 0
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage((0, $cvLcO.assignedAppsCountMessages).appsCount, {
        count: appIds.length
    })));
});
function $e92fbaf61117ac18$var$_temp(source) {
    return [
        $e92fbaf61117ac18$var$normalizeSourceApp(source.source),
        source.iconUrl
    ];
}
function $e92fbaf61117ac18$var$_temp2(t0) {
    const [appSource] = t0;
    return appSource;
}
function $e92fbaf61117ac18$var$_temp3(a) {
    return a !== null;
}
module.exports["SourceIcons"] = $e92fbaf61117ac18$export$e203adedbd5fe6a2;
module.exports["AssignedAppsIcons"] = $e92fbaf61117ac18$export$e5b256719ec2d67e;

});

parcelRegister("4gLhk", function(module, exports) {
const $a8829e20a225244c$export$ed5572b558d71438 = (ari)=>{
    if (!ari) return null;
    // see go/ari for possible values
    // Example:
    // ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
    // -> amplitude
    const ariParts = ari.split(':');
    if (ariParts.length < 3) return null;
    return ariParts[2];
};
module.exports["extractProductNameFromARI"] = $a8829e20a225244c$export$ed5572b558d71438;

});

parcelRegister("cvLcO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bed2bad4bbf4e8d8$export$d769a38990f6a0a2 = (0, $kSwu1.defineMessages)({
    appsCount: {
        id: "conversation-assistant-content-renderer.assigned-apps-icons.apps-count",
        defaultMessage: "{count, plural, one {# app} other {# apps}}"
    }
});
module.exports["assignedAppsCountMessages"] = $bed2bad4bbf4e8d8$export$d769a38990f6a0a2;

});

parcelRegister("eQZgt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $hpa99 = parcelRequire("hpa99");


var $l3wuH = parcelRequire("l3wuH");


var $cJ0FD = parcelRequire("cJ0FD");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $ljEF1 = parcelRequire("ljEF1");


var $ZKswU = parcelRequire("ZKswU");




const $184456f7289bad27$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    closeButtonLabel: {
        id: "rovo-conversation-actions.create-prompt-modal.close-button-label",
        defaultMessage: "Close"
    },
    createNewPromptTitle: {
        id: "rovo-conversation-actions.create-prompt-modal.title",
        defaultMessage: "Create new prompt"
    },
    requiredFieldsNote: {
        id: "rovo-conversation-actions.create-prompt-modal.required-fields-note",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    titleLabel: {
        id: "rovo-conversation-actions.create-prompt-modal.title-label",
        defaultMessage: "Title"
    },
    titlePlaceholder: {
        id: "rovo-conversation-actions.create-prompt-modal.title-placeholder",
        defaultMessage: "Enter a descriptive title for your prompt"
    },
    promptLabel: {
        id: "rovo-conversation-actions.create-prompt-modal.prompt-label",
        defaultMessage: "Prompt"
    },
    promptPlaceholder: {
        id: "rovo-conversation-actions.create-prompt-modal.prompt-placeholder",
        defaultMessage: "Type the prompt you want to create. Be clear and specific to get the best results."
    },
    useCaseLabel: {
        id: "rovo-conversation-actions.create-prompt-modal.use-case-label",
        defaultMessage: "Use Case"
    },
    useCasePlaceholder: {
        id: "rovo-conversation-actions.create-prompt-modal.use-case-placeholder",
        defaultMessage: "Pick the closest use case."
    },
    roleLabel: {
        id: "rovo-conversation-actions.create-prompt-modal.role-label",
        defaultMessage: "Role"
    },
    rolePlaceholder: {
        id: "rovo-conversation-actions.create-prompt-modal.role-placeholder",
        defaultMessage: "Who is this prompt intended for?"
    },
    appLabel: {
        id: "rovo-conversation-actions.create-prompt-modal.app-label",
        defaultMessage: "Apps"
    },
    appPlaceholder: {
        id: "rovo-conversation-actions.create-prompt-modal.app-placeholder",
        defaultMessage: "Adding apps help your prompt answer more accurately."
    },
    cancelButton: {
        id: "rovo-conversation-actions.create-prompt-modal.cancel",
        defaultMessage: "Cancel"
    },
    createButton: {
        id: "rovo-conversation-actions.create-prompt-modal.create",
        defaultMessage: "Create"
    },
    saveButton: {
        id: "rovo-conversation-actions.create-prompt-modal.save",
        defaultMessage: "Save"
    },
    createError: {
        id: "rovo-conversation-actions.create-prompt-modal.create-error",
        defaultMessage: "Something went wrong. Please try again."
    },
    copyTitlePrefix: {
        id: "rovo-conversation-actions.create-prompt-modal.copy-title-prefix",
        defaultMessage: "[Copy] {title}"
    }
});


const $9d88f24fa4464521$export$9348ed9a2c14cdcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCreatePromptInitialData(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { editingPromptCard: editingPromptCard, duplicatingPromptCard: duplicatingPromptCard, appOptions: appOptions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    bb0: {
        const card = editingPromptCard ?? duplicatingPromptCard;
        if (!card) {
            t1 = undefined;
            break bb0;
        }
        let t2;
        if ($[0] !== card.title || $[1] !== duplicatingPromptCard || $[2] !== formatMessage) {
            t2 = duplicatingPromptCard ? formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).copyTitlePrefix, {
                title: card.title
            }) : card.title;
            $[0] = card.title;
            $[1] = duplicatingPromptCard;
            $[2] = formatMessage;
            $[3] = t2;
        } else t2 = $[3];
        const title = t2;
        const t3 = card.prompt;
        let t4;
        if ($[4] !== card.useCase) {
            t4 = card.useCase ? {
                value: card.useCase,
                label: card.useCase
            } : null;
            $[4] = card.useCase;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== card.roles) {
            t5 = card.roles ?? [];
            $[6] = card.roles;
            $[7] = t5;
        } else t5 = $[7];
        let t6;
        if ($[8] !== t5) {
            t6 = t5.map($9d88f24fa4464521$var$_temp);
            $[8] = t5;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== card.appIds) {
            t7 = card.appIds ?? [];
            $[10] = card.appIds;
            $[11] = t7;
        } else t7 = $[11];
        let t8;
        if ($[12] !== appOptions || $[13] !== t7) {
            let t9;
            if ($[15] !== appOptions) {
                t9 = (id)=>{
                    const o = appOptions.find((opt)=>opt.value === id);
                    return o ? {
                        value: o.value,
                        label: o.label
                    } : {
                        value: id,
                        label: id
                    };
                };
                $[15] = appOptions;
                $[16] = t9;
            } else t9 = $[16];
            t8 = t7.map(t9);
            $[12] = appOptions;
            $[13] = t7;
            $[14] = t8;
        } else t8 = $[14];
        let t9;
        if ($[17] !== card.prompt || $[18] !== t4 || $[19] !== t6 || $[20] !== t8 || $[21] !== title) {
            t9 = {
                title: title,
                prompt: t3,
                useCase: t4,
                role: t6,
                app: t8
            };
            $[17] = card.prompt;
            $[18] = t4;
            $[19] = t6;
            $[20] = t8;
            $[21] = title;
            $[22] = t9;
        } else t9 = $[22];
        t1 = t9;
    }
    return t1;
} : function useCreatePromptInitialData({ editingPromptCard: editingPromptCard, duplicatingPromptCard: duplicatingPromptCard, appOptions: appOptions }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>{
        const card = editingPromptCard ?? duplicatingPromptCard;
        if (!card) return undefined;
        const title = duplicatingPromptCard ? formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).copyTitlePrefix, {
            title: card.title
        }) : card.title;
        return {
            title: title,
            prompt: card.prompt,
            useCase: card.useCase ? {
                value: card.useCase,
                label: card.useCase
            } : null,
            role: (card.roles ?? []).map((r)=>({
                    value: r,
                    label: r
                })),
            app: (card.appIds ?? []).map((id)=>{
                const o = appOptions.find((opt)=>opt.value === id);
                return o ? {
                    value: o.value,
                    label: o.label
                } : {
                    value: id,
                    label: id
                };
            })
        };
    }, [
        editingPromptCard,
        duplicatingPromptCard,
        appOptions,
        formatMessage
    ]);
};
function $9d88f24fa4464521$var$_temp(r) {
    return {
        value: r,
        label: r
    };
}
const $9d88f24fa4464521$var$emptyFormState = {
    titleValue: '',
    prompt: '',
    useCase: null,
    role: [],
    app: []
};
const $9d88f24fa4464521$var$styles = {
    headerFlex: "_0aFT5vf5Xk _39xV02N91d",
    requiredNote: "_1DCdHi5zaO",
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _3138428HPE",
    appOptionIcon: "_0bjKvDKxmn _0jFU0Vey7F _39xV02ey7F _3YEZNOdnbC"
};
function $9d88f24fa4464521$var$CreatePromptFormBody({ initialData: initialData, appOptions: appOptions, isEditMode: isEditMode = false, onClose: onClose, onCreate: onCreate, onCreateSuccess: onCreateSuccess }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const initialFormState = (0, $cozmU.useMemo)(()=>initialData ? {
            titleValue: initialData.title,
            prompt: initialData.prompt,
            useCase: initialData.useCase,
            role: initialData.role,
            app: initialData.app
        } : $9d88f24fa4464521$var$emptyFormState, [
        initialData
    ]);
    const [titleValue, setTitleValue] = (0, $cozmU.useState)(initialFormState.titleValue);
    const [prompt, setPrompt] = (0, $cozmU.useState)(initialFormState.prompt);
    const [useCase, setUseCase] = (0, $cozmU.useState)(initialFormState.useCase);
    const [role, setRole] = (0, $cozmU.useState)(initialFormState.role);
    const [app, setApp] = (0, $cozmU.useState)(initialFormState.app);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const handleCreate = (0, $cozmU.useCallback)(async ()=>{
        const data = {
            title: titleValue,
            prompt: prompt,
            useCase: useCase,
            role: role,
            app: app
        };
        setError(null);
        setIsSubmitting(true);
        try {
            const result = await onCreate(data);
            onClose();
            if (onCreateSuccess) onCreateSuccess(result);
        } catch (err) {
            setError(err instanceof Error ? err.message : formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).createError));
        } finally{
            setIsSubmitting(false);
        }
    }, [
        titleValue,
        prompt,
        useCase,
        role,
        app,
        onCreate,
        onCreateSuccess,
        onClose,
        formatMessage
    ]);
    const useCaseSelectOptions = (0, $ZKswU.useCaseOptions).map((opt)=>({
            label: opt.label,
            value: opt.id
        }));
    const roleSelectOptions = (0, $ZKswU.roleOptions).map((opt_0)=>({
            label: opt_0.label,
            value: opt_0.id
        }));
    const canCreate = titleValue.trim() !== '' && prompt.trim() !== '' && !isSubmitting;
    const formatAppOptionLabel = (0, $cozmU.useCallback)(({ iconUrl: iconUrl, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9d88f24fa4464521$var$styles.appOptionIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            width: 16,
            height: 16,
            src: iconUrl,
            alt: label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, label)), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9d88f24fa4464521$var$styles.requiredNote
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).requiredFieldsNote), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9d88f24fa4464521$var$styles.requiredNote
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.danger"
    }, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "label",
        htmlFor: "create-prompt-title-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).titleLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: "create-prompt-title-field",
        maxLength: 255,
        placeholder: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).titlePlaceholder),
        value: titleValue,
        onChange: (e)=>setTitleValue(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "label",
        htmlFor: "create-prompt-prompt-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).promptLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        id: "create-prompt-prompt-field",
        maxLength: (0, $ljEF1.MAX_CHARACTERS_INPUT),
        placeholder: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).promptPlaceholder),
        value: prompt,
        onChange: (e_0)=>setPrompt(e_0.target.value),
        minimumRows: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).appLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        isMulti: true,
        label: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).appLabel),
        placeholder: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).appPlaceholder),
        options: appOptions,
        value: app,
        onChange: (option)=>setApp(option ?? []),
        formatOptionLabel: formatAppOptionLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).useCaseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        label: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).useCaseLabel),
        placeholder: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).useCasePlaceholder),
        options: useCaseSelectOptions,
        value: useCase,
        onChange: (option_0)=>setUseCase(option_0)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).roleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        isMulti: true,
        label: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).roleLabel),
        placeholder: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).rolePlaceholder),
        options: roleSelectOptions,
        value: role,
        onChange: (option_1)=>setRole(option_1 ?? [])
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9d88f24fa4464521$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleCreate,
        isDisabled: !canCreate,
        isLoading: isSubmitting
    }, formatMessage(isEditMode ? (0, $184456f7289bad27$export$a7357cdd1f0b0168).saveButton : (0, $184456f7289bad27$export$a7357cdd1f0b0168).createButton)))));
}
const $9d88f24fa4464521$export$377f717e33b120ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { isOpen: isOpen, onClose: onClose, onCreate: onCreate, onCreateSuccess: onCreateSuccess, appOptions: t1, initialData: initialData, isEditMode: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const appOptions = t3;
    const isEditMode = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[2] !== appOptions || $[3] !== formatMessage || $[4] !== initialData || $[5] !== isEditMode || $[6] !== isOpen || $[7] !== onClose || $[8] !== onCreate || $[9] !== onCreateSuccess) {
        t4 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: onClose,
            width: "medium",
            shouldScrollInViewport: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $9d88f24fa4464521$var$styles.headerFlex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).closeButtonLabel),
            onClick: onClose,
            shape: "circle"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).createNewPromptTitle))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d88f24fa4464521$var$CreatePromptFormBody, {
            key: initialData?.title ?? "create",
            initialData: initialData,
            appOptions: appOptions ?? [],
            isEditMode: isEditMode,
            onClose: onClose,
            onCreate: onCreate,
            onCreateSuccess: onCreateSuccess
        }));
        $[2] = appOptions;
        $[3] = formatMessage;
        $[4] = initialData;
        $[5] = isEditMode;
        $[6] = isOpen;
        $[7] = onClose;
        $[8] = onCreate;
        $[9] = onCreateSuccess;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t4);
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ isOpen: isOpen, onClose: onClose, onCreate: onCreate, onCreateSuccess: onCreateSuccess, appOptions: appOptions = [], initialData: initialData, isEditMode: isEditMode = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "medium",
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $9d88f24fa4464521$var$styles.headerFlex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).closeButtonLabel),
        onClick: onClose,
        shape: "circle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "start",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $184456f7289bad27$export$a7357cdd1f0b0168).createNewPromptTitle))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d88f24fa4464521$var$CreatePromptFormBody, {
        key: initialData?.title ?? 'create',
        initialData: initialData,
        appOptions: appOptions ?? [],
        isEditMode: isEditMode,
        onClose: onClose,
        onCreate: onCreate,
        onCreateSuccess: onCreateSuccess
    })));
};
module.exports["useCreatePromptInitialData"] = $9d88f24fa4464521$export$9348ed9a2c14cdcd;
module.exports["CreatePromptModal"] = $9d88f24fa4464521$export$377f717e33b120ce;

});

parcelRegister("jCBG9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $2uDbg = parcelRequire("2uDbg");


var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $cXtTj = parcelRequire("cXtTj");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $kTb7m = parcelRequire("kTb7m");


var $dPtX5 = parcelRequire("dPtX5");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $bltJZ = parcelRequire("bltJZ");


var $57p4j = parcelRequire("57p4j");

var $hc9K5 = parcelRequire("hc9K5");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $3BY7M = parcelRequire("3BY7M");


var $4NbSC = parcelRequire("4NbSC");


var $6rwn6 = parcelRequire("6rwn6");


var $8lhhf = parcelRequire("8lhhf");


var $5TXhv = parcelRequire("5TXhv");


var $jQDPt = parcelRequire("jQDPt");


var $slkWY = parcelRequire("slkWY");


var $jjumc = parcelRequire("jjumc");


var $1rxhm = parcelRequire("1rxhm");

const $01ce5af50de8bf61$var$styles = {
    card: "_0bjKvDyzSk _23rrnHT8EO _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r2kG2W _1wydGWkG2W _2Zuz6Q5zaO _1Znuxb5zaO _0wOv4Q7zJH _39xV02NvzE _0jFU0Vb1xp _2fwxA5ecOK _24h04i2Njc _3iDTPbQ4SZ _0aFT5vbt8w",
    cardHover: "_3NJLv8v4qQ _3fSdSTGk8v",
    cardSelected: "_3vBAKHnXvL",
    cardNewChatDashed: "_3hxITisurO _1eOmH6bvxc",
    cardWithAppsSection: "_0jFU0V3ScF",
    cardHeader: "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLchRC _1DCdHi2ADO",
    iconContainer: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    checkboxContainer: "_2XsHFM5UaJ _3138425UaJ",
    optionsMenuButton: "_23rrnHniUh _3138425UaJ _0adFHs5UaJ _1YKVNsdnbC",
    optionsMenuButtonVisible: "_1YKVNs7dHp",
    title: "_4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _1DCdHi1Y8M _2fwxA5ecOK _0WKd3G4z3T _1kk5Tkf7mX _1ANEUSLRg7 _39HuIbz8Lp",
    cardContentWrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp",
    assignedApps: "_2mHwu8gVvo _313842IZbP _0Of8r22ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoPlaceholderIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    grid: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP29fcK _0GwItX7p2s _0Of8r25zaO _1wydGWNHnM _2Zuz6Q2ADO _1EqgXlJb33 _4kiQYAaVF6",
    gridLandingPage: "_2Zuz6QdnbC _0Of8r2dnbC _4kiQYAIZbP",
    gridFullWidth: "_2iEGP2UfmU",
    cardFullWidth: "_39xV02N91d _0jFU0VIZbP",
    cardHeaderFullWidth: "_0hPCNLDIqT",
    titleInline: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _39HuIbz8Lp _1ANEUSLRg7 _4xdlr0z9WS _2Zuz6Q5zaO"
};
const $01ce5af50de8bf61$export$5ba3bf9a55e59b41 = {
    [(0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE)]: (ext)=>{
        const params = ext.parameters;
        if (params) return /*#__PURE__*/ $cozmU.createElement((0, $5TXhv.SkillTag), {
            ...params,
            disableHovercard: true
        });
        return null;
    }
};
const $01ce5af50de8bf61$export$6a8677cc6744aa44 = /*#__PURE__*/ (0, $cozmU.memo)(({ card: card, onClick: onClick, onHover: onHover, onDeletePrompt: onDeletePrompt, onEditPrompt: onEditPrompt, onDuplicatePrompt: onDuplicatePrompt, onFavoriteToggle: onFavoriteToggle, onSharePrompt: onSharePrompt, showSelectCheckbox: showSelectCheckbox, isSelected: isSelected, onSelectToggle: onSelectToggle, assistanceServiceParams: assistanceServiceParams, skillMetadata: skillMetadata, fullWidth: fullWidth, hideAppsSection: hideAppsSection })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isCardHovered, setIsCardHovered] = (0, $cozmU.useState)(false);
    const [isCardFocused, setIsCardFocused] = (0, $cozmU.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = (0, $cozmU.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $cozmU.useState)(false);
    const [isFavorited, setIsFavorited] = (0, $cozmU.useState)(card.isFavorited ?? false);
    const [isTogglingFavorite, setIsTogglingFavorite] = (0, $cozmU.useState)(false);
    const Icon = card.icon ?? (0, $jQDPt.getUseCaseIcon)(card.useCase);
    const selectedAppIds = card.appIds ?? [];
    const appCount = selectedAppIds.length;
    (0, $cozmU.useEffect)(()=>{
        setIsFavorited(card.isFavorited ?? false);
    }, [
        card.isFavorited
    ]);
    const handleDeleteConfirm = async ()=>{
        setIsDeleting(true);
        try {
            await onDeletePrompt?.(card.id);
            setIsDeleteConfirmOpen(false);
        } catch  {} finally{
            setIsDeleting(false);
        }
    };
    const handleDeleteCancel = ()=>{
        setIsDeleteConfirmOpen(false);
    };
    const handleFavoriteToggle = async (e)=>{
        e.stopPropagation();
        setIsTogglingFavorite(true); // Optimistic update: immediately change the UI state
        const newFavoritedState = !isFavorited;
        const previousFavoritedState = isFavorited;
        setIsFavorited(newFavoritedState);
        try {
            await onFavoriteToggle?.(card.id, newFavoritedState, card.isUserGenerated);
        } catch  {
            // Rollback to previous state on error
            setIsFavorited(previousFavoritedState);
        } finally{
            setIsTogglingFavorite(false);
        }
    };
    const adfDocument = (0, $cozmU.useMemo)(()=>{
        return (0, $6rwn6.encodePromptToAdf)(card.prompt, skillMetadata).adf;
    }, [
        card.prompt,
        skillMetadata
    ]);
    const showActionsVisible = isCardHovered || isCardFocused || isDropdownOpen;
    const showCheckboxInPlaceOfIcon = showSelectCheckbox && (showActionsVisible || isSelected);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $01ce5af50de8bf61$var$styles.cardContentWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.cardHeader, fullWidth && $01ce5af50de8bf61$var$styles.cardHeaderFullWidth)
    }, showCheckboxInPlaceOfIcon ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $01ce5af50de8bf61$var$styles.checkboxContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        isChecked: isSelected,
        onChange: ()=>{
            onSelectToggle?.(card.id);
        },
        "aria-label": formatMessage((0, $1rxhm.messages).selectPrompt, {
            title: card.title
        })
    })) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $01ce5af50de8bf61$var$styles.iconContainer
    }, /*#__PURE__*/ $cozmU.createElement(Icon, null)), fullWidth && !showCheckboxInPlaceOfIcon && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.title, $01ce5af50de8bf61$var$styles.titleInline)
    }, card.title), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, onFavoriteToggle && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.optionsMenuButton, showActionsVisible && $01ce5af50de8bf61$var$styles.optionsMenuButtonVisible)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        appearance: "subtle",
        icon: ()=>isFavorited ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                label: "",
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                label: "",
                color: "var(--ds-icon, #292A2E)"
            }),
        label: isFavorited ? formatMessage((0, $1rxhm.messages).unfavoritePrompt) : formatMessage((0, $1rxhm.messages).favoritePrompt),
        isDisabled: isTogglingFavorite,
        onClick: handleFavoriteToggle
    })), onSharePrompt && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.optionsMenuButton, showActionsVisible && $01ce5af50de8bf61$var$styles.optionsMenuButtonVisible)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "",
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage((0, $1rxhm.messages).sharePrompt),
        onClick: (e_0)=>{
            e_0.stopPropagation();
            onSharePrompt(card);
        }
    })), (onEditPrompt || onDuplicatePrompt || onDeletePrompt) && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.optionsMenuButton, showActionsVisible && $01ce5af50de8bf61$var$styles.optionsMenuButtonVisible)
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                ref: triggerRef,
                spacing: "compact",
                appearance: "subtle",
                icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPtX5))), {
                        label: ""
                    }),
                label: formatMessage((0, $1rxhm.messages).cardMoreActions),
                onClick: (e_1)=>{
                    e_1.stopPropagation();
                    props.onClick?.(e_1);
                }
            }),
        shouldFlip: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        }),
        onClick: (e_2)=>{
            e_2.stopPropagation();
            onEditPrompt?.(card);
        }
    }, formatMessage((0, $1rxhm.messages).edit)), /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            label: ""
        }),
        onClick: (e_3)=>{
            e_3.stopPropagation();
            onDuplicatePrompt?.(card);
        }
    }, formatMessage((0, $1rxhm.messages).duplicate)), onDeletePrompt && /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        onClick: (e_4)=>{
            e_4.stopPropagation();
            setIsDeleteConfirmOpen(true);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, formatMessage((0, $1rxhm.messages).delete)))))))), !fullWidth && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $01ce5af50de8bf61$var$styles.title
    }, card.title), /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default), {
        document: adfDocument,
        extensionHandlers: $01ce5af50de8bf61$export$5ba3bf9a55e59b41,
        nodeComponents: {
            paragraph: ({ children: children })=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    size: "small",
                    maxLines: 2
                }, children),
            heading: ({ children: children_0 })=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    size: "small",
                    maxLines: 2
                }, children_0),
            rule: ()=>null
        }
    })), !hideAppsSection && (0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $01ce5af50de8bf61$var$styles.assignedApps
    }, appCount > 0 && assistanceServiceParams ? /*#__PURE__*/ $cozmU.createElement((0, $4NbSC.AssignedAppsIcons), {
        appIds: selectedAppIds,
        assistanceServiceParams: assistanceServiceParams
    }) : /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $01ce5af50de8bf61$var$styles.rovoPlaceholderIcon
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        label: "",
        shouldUseHexLogo: true,
        size: "xxsmall"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, "Rovo"))));
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.card, fullWidth && $01ce5af50de8bf61$var$styles.cardFullWidth, isSelected && $01ce5af50de8bf61$var$styles.cardSelected, card.startNewChat ? $01ce5af50de8bf61$var$styles.cardNewChatDashed : $01ce5af50de8bf61$var$styles.cardHover, /* eslint-disable-next-line @atlaskit/platform/use-recommended-utils */ !hideAppsSection && (0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) && $01ce5af50de8bf61$var$styles.cardWithAppsSection),
        onClick: (e_5)=>{
            // Don't trigger card click if click originated from an interactive element
            if (e_5.target.closest('input[type="checkbox"], button, [role="button"]')) return;
            onClick?.(card);
        },
        onKeyDown: (e_6)=>{
            // Handle Enter/Space for keyboard accessibility
            if (e_6.key === 'Enter' || e_6.key === ' ') {
                // Don't trigger if focused on an interactive child element
                if (e_6.target.closest('input[type="checkbox"], button, [role="button"]')) return;
                e_6.preventDefault();
                onClick?.(card);
            }
        },
        onMouseEnter: ()=>{
            setIsCardHovered(true);
            onHover?.(card);
        },
        onMouseLeave: ()=>{
            setIsCardHovered(false);
            onHover?.(null);
        },
        tabIndex: 0,
        "aria-label": card.title,
        onFocus: (e_7)=>{
            if (e_7.target.matches(':focus-visible')) {
                setIsCardFocused(true);
                onHover?.(card);
            }
        },
        onBlur: ()=>{
            if (isCardFocused) {
                setIsCardFocused(false);
                onHover?.(null);
            }
        }
    }, cardContent), /*#__PURE__*/ $cozmU.createElement((0, $slkWY.DeleteConfirmModal), {
        title: formatMessage((0, $1rxhm.messages).deleteConfirmTitle),
        body: formatMessage((0, $1rxhm.messages).deleteConfirmBody),
        isOpen: isDeleteConfirmOpen,
        isLoading: isDeleting,
        onClose: handleDeleteCancel,
        onConfirm: handleDeleteConfirm,
        testId: "delete-prompt-confirm-modal"
    }));
});
const $01ce5af50de8bf61$export$e9bc0927d444eb66 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { cards: cards, onCardClick: onCardClick, onCardHover: onCardHover, onDeletePrompt: onDeletePrompt, onEditPrompt: onEditPrompt, onDuplicatePrompt: onDuplicatePrompt, onFavoriteToggle: onFavoriteToggle, onSharePrompt: onSharePrompt, isLandingPage: isLandingPage, fullWidth: fullWidth, selectedCardIds: selectedCardIds, onSelectionChange: onSelectionChange, assistanceServiceParams: assistanceServiceParams, skillMetadata: skillMetadata, hideAppsSection: hideAppsSection } = t0;
    const enableMultiselect = selectedCardIds !== undefined && onSelectionChange !== undefined && (onDeletePrompt != null || onFavoriteToggle != null);
    let t1;
    if ($[0] !== onSelectionChange || $[1] !== selectedCardIds) {
        t1 = (cardId)=>{
            if (!onSelectionChange || !selectedCardIds) return;
            const next = new Set(selectedCardIds);
            if (next.has(cardId)) next.delete(cardId);
            else next.add(cardId);
            onSelectionChange(next);
        };
        $[0] = onSelectionChange;
        $[1] = selectedCardIds;
        $[2] = t1;
    } else t1 = $[2];
    const handleSelectToggle = t1;
    if (cards.length === 0) {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ $cozmU.createElement((0, $jjumc.PromptCardsEmptyState), null);
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    const t2 = isLandingPage && $01ce5af50de8bf61$var$styles.gridLandingPage;
    const t3 = fullWidth && $01ce5af50de8bf61$var$styles.gridFullWidth;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.grid, t2, t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== assistanceServiceParams || $[8] !== cards || $[9] !== enableMultiselect || $[10] !== fullWidth || $[11] !== handleSelectToggle || $[12] !== hideAppsSection || $[13] !== onCardClick || $[14] !== onCardHover || $[15] !== onDeletePrompt || $[16] !== onDuplicatePrompt || $[17] !== onEditPrompt || $[18] !== onFavoriteToggle || $[19] !== onSharePrompt || $[20] !== selectedCardIds || $[21] !== skillMetadata) {
        let t6;
        if ($[23] !== assistanceServiceParams || $[24] !== enableMultiselect || $[25] !== fullWidth || $[26] !== handleSelectToggle || $[27] !== hideAppsSection || $[28] !== onCardClick || $[29] !== onCardHover || $[30] !== onDeletePrompt || $[31] !== onDuplicatePrompt || $[32] !== onEditPrompt || $[33] !== onFavoriteToggle || $[34] !== onSharePrompt || $[35] !== selectedCardIds || $[36] !== skillMetadata) {
            t6 = (card)=>/*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
                    key: card.id,
                    duration: "medium"
                }, (props)=>/*#__PURE__*/ $cozmU.createElement("div", props, /*#__PURE__*/ $cozmU.createElement($01ce5af50de8bf61$export$6a8677cc6744aa44, {
                        card: card,
                        onClick: onCardClick,
                        onHover: onCardHover,
                        onDeletePrompt: onDeletePrompt,
                        onEditPrompt: onEditPrompt,
                        onDuplicatePrompt: onDuplicatePrompt,
                        onFavoriteToggle: onFavoriteToggle,
                        onSharePrompt: onSharePrompt,
                        showSelectCheckbox: enableMultiselect,
                        isSelected: selectedCardIds?.has(card.id),
                        onSelectToggle: enableMultiselect ? handleSelectToggle : undefined,
                        assistanceServiceParams: assistanceServiceParams,
                        skillMetadata: skillMetadata,
                        fullWidth: fullWidth,
                        hideAppsSection: hideAppsSection
                    })));
            $[23] = assistanceServiceParams;
            $[24] = enableMultiselect;
            $[25] = fullWidth;
            $[26] = handleSelectToggle;
            $[27] = hideAppsSection;
            $[28] = onCardClick;
            $[29] = onCardHover;
            $[30] = onDeletePrompt;
            $[31] = onDuplicatePrompt;
            $[32] = onEditPrompt;
            $[33] = onFavoriteToggle;
            $[34] = onSharePrompt;
            $[35] = selectedCardIds;
            $[36] = skillMetadata;
            $[37] = t6;
        } else t6 = $[37];
        t5 = cards.map(t6);
        $[7] = assistanceServiceParams;
        $[8] = cards;
        $[9] = enableMultiselect;
        $[10] = fullWidth;
        $[11] = handleSelectToggle;
        $[12] = hideAppsSection;
        $[13] = onCardClick;
        $[14] = onCardHover;
        $[15] = onDeletePrompt;
        $[16] = onDuplicatePrompt;
        $[17] = onEditPrompt;
        $[18] = onFavoriteToggle;
        $[19] = onSharePrompt;
        $[20] = selectedCardIds;
        $[21] = skillMetadata;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[38] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hc9K5.default), {
            columns: 1,
            delayStep: 100
        }, t5);
        $[38] = t5;
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== t4 || $[41] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t4
        }, t6);
        $[40] = t4;
        $[41] = t6;
        $[42] = t7;
    } else t7 = $[42];
    return t7;
} : ({ cards: cards, onCardClick: onCardClick, onCardHover: onCardHover, onDeletePrompt: onDeletePrompt, onEditPrompt: onEditPrompt, onDuplicatePrompt: onDuplicatePrompt, onFavoriteToggle: onFavoriteToggle, onSharePrompt: onSharePrompt, isLandingPage: isLandingPage, fullWidth: fullWidth, selectedCardIds: selectedCardIds, onSelectionChange: onSelectionChange, assistanceServiceParams: assistanceServiceParams, skillMetadata: skillMetadata, hideAppsSection: hideAppsSection })=>{
    const enableMultiselect = selectedCardIds !== undefined && onSelectionChange !== undefined && (onDeletePrompt != null || onFavoriteToggle != null);
    const handleSelectToggle = (cardId)=>{
        if (!onSelectionChange || !selectedCardIds) return;
        const next = new Set(selectedCardIds);
        if (next.has(cardId)) next.delete(cardId);
        else next.add(cardId);
        onSelectionChange(next);
    };
    if (cards.length === 0) return /*#__PURE__*/ $cozmU.createElement((0, $jjumc.PromptCardsEmptyState), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($01ce5af50de8bf61$var$styles.grid, isLandingPage && $01ce5af50de8bf61$var$styles.gridLandingPage, fullWidth && $01ce5af50de8bf61$var$styles.gridFullWidth)
    }, /*#__PURE__*/ $cozmU.createElement((0, $hc9K5.default), {
        columns: 1,
        delayStep: 100
    }, cards.map((card)=>/*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            key: card.id,
            duration: "medium"
        }, (props)=>/*#__PURE__*/ $cozmU.createElement("div", props, /*#__PURE__*/ $cozmU.createElement($01ce5af50de8bf61$export$6a8677cc6744aa44, {
                card: card,
                onClick: onCardClick,
                onHover: onCardHover,
                onDeletePrompt: onDeletePrompt,
                onEditPrompt: onEditPrompt,
                onDuplicatePrompt: onDuplicatePrompt,
                onFavoriteToggle: onFavoriteToggle,
                onSharePrompt: onSharePrompt,
                showSelectCheckbox: enableMultiselect,
                isSelected: selectedCardIds?.has(card.id),
                onSelectToggle: enableMultiselect ? handleSelectToggle : undefined,
                assistanceServiceParams: assistanceServiceParams,
                skillMetadata: skillMetadata,
                fullWidth: fullWidth,
                hideAppsSection: hideAppsSection
            }))))));
});
module.exports["skillExtensionHandlers"] = $01ce5af50de8bf61$export$5ba3bf9a55e59b41;
module.exports["PromptCardsGrid"] = $01ce5af50de8bf61$export$e9bc0927d444eb66;

});

parcelRegister("5TXhv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $91ZZN = parcelRequire("91ZZN");


var $6wOvs = parcelRequire("6wOvs");


var $fGEnS = parcelRequire("fGEnS");


var $9OqBj = parcelRequire("9OqBj");


var $80Hjq = parcelRequire("80Hjq");


var $9MCKh = parcelRequire("9MCKh");

const $dfa98e52cf6bfc2d$var$styles = {
    parallelogram: "_0bjKvDcjp5 _2XsHFM1Y8M _2Zuz6QgVvo _1ZnuxbgVvo _1VJPca73Em _3iDTPbvbI6",
    background: "_0KLXruDMqu",
    backgroundInverse: "_0KLXruB4sa",
    content: "_1VJPcaV6Hm"
};
const $dfa98e52cf6bfc2d$var$SkillTagInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { triggerProps: t1, invertColors: invertColors, slug: slug, IconComponent: IconComponent, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, color: color, shimmer: shimmer } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const triggerProps = t2;
    let t3;
    if ($[2] !== color || $[3] !== invertColors) {
        t3 = (0, $9OqBj.getBorderColor)(color, invertColors);
        $[2] = color;
        $[3] = invertColors;
        $[4] = t3;
    } else t3 = $[4];
    const borderColor = t3;
    const t4 = invertColors ? $dfa98e52cf6bfc2d$var$styles.backgroundInverse : $dfa98e52cf6bfc2d$var$styles.background;
    let t5;
    if ($[5] !== t4) {
        t5 = (0, $w6R6I.cx)($dfa98e52cf6bfc2d$var$styles.parallelogram, t4);
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = `${"var(--ds-border-width-selected, 2px)"} solid ${borderColor}`;
    let t7;
    if ($[7] !== t6) {
        t7 = {
            borderLeft: t6
        };
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== IconComponent || $[10] !== color || $[11] !== invertColors) {
        t8 = IconComponent && /*#__PURE__*/ $cozmU.createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "skill-tag-icon"
        }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
            label: "",
            size: "small",
            color: (0, $9OqBj.getIconColor)(color, invertColors)
        }));
        $[9] = IconComponent;
        $[10] = color;
        $[11] = invertColors;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== invertColors || $[14] !== shimmer || $[15] !== slug) {
        t9 = shimmer ? /*#__PURE__*/ $cozmU.createElement((0, $6wOvs.ShimmerText), null, slug) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: invertColors ? "color.text.inverse" : "color.text"
        }, slug);
        $[13] = invertColors;
        $[14] = shimmer;
        $[15] = slug;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $dfa98e52cf6bfc2d$var$styles.content,
            space: "space.050",
            alignBlock: "center"
        }, t8, t9);
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== onMouseEnter || $[21] !== onMouseLeave || $[22] !== t10 || $[23] !== t5 || $[24] !== t7 || $[25] !== triggerProps) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: t5,
            style: t7,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ...triggerProps
        }, t10);
        $[20] = onMouseEnter;
        $[21] = onMouseLeave;
        $[22] = t10;
        $[23] = t5;
        $[24] = t7;
        $[25] = triggerProps;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ({ triggerProps: triggerProps = {}, invertColors: invertColors, slug: slug, IconComponent: IconComponent, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, color: color, shimmer: shimmer })=>{
    const borderColor = (0, $9OqBj.getBorderColor)(color, invertColors);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($dfa98e52cf6bfc2d$var$styles.parallelogram, invertColors ? $dfa98e52cf6bfc2d$var$styles.backgroundInverse : $dfa98e52cf6bfc2d$var$styles.background),
        style: {
            borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${borderColor}`
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...triggerProps
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $dfa98e52cf6bfc2d$var$styles.content,
        space: "space.050",
        alignBlock: "center"
    }, IconComponent && /*#__PURE__*/ $cozmU.createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "skill-tag-icon"
    }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
        label: "",
        size: "small",
        color: (0, $9OqBj.getIconColor)(color, invertColors)
    })), shimmer ? /*#__PURE__*/ $cozmU.createElement((0, $6wOvs.ShimmerText), null, slug) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: invertColors ? 'color.text.inverse' : 'color.text'
    }, slug)));
};
// delay opening and closing of the hovercard to prevent flickering
const $dfa98e52cf6bfc2d$var$SKILL_TAG_HOVERCARD_DELAY = 200;
const $dfa98e52cf6bfc2d$export$55feb0e4f341a6f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    let hovercardMaxHeight;
    let iconName;
    let product;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ invertColors: t1, disableHovercard: t2, product: product, iconName: iconName, hovercardMaxHeight: hovercardMaxHeight, ...props } = t0);
        $[0] = t0;
        $[1] = hovercardMaxHeight;
        $[2] = iconName;
        $[3] = product;
        $[4] = props;
        $[5] = t1;
        $[6] = t2;
    } else {
        hovercardMaxHeight = $[1];
        iconName = $[2];
        product = $[3];
        props = $[4];
        t1 = $[5];
        t2 = $[6];
    }
    const invertColors = t1 === undefined ? false : t1;
    const disableHovercard = t2 === undefined ? false : t2;
    const IconComponent = iconName ? (0, $9MCKh.skillIconMap)[iconName] : undefined;
    const hasHovercardInfo = props?.name && props?.description;
    let t3;
    if ($[7] !== IconComponent || $[8] !== disableHovercard || $[9] !== hasHovercardInfo || $[10] !== hovercardMaxHeight || $[11] !== iconName || $[12] !== invertColors || $[13] !== product || $[14] !== props) {
        t3 = disableHovercard || !hasHovercardInfo ? /*#__PURE__*/ $cozmU.createElement($dfa98e52cf6bfc2d$var$SkillTagInternal, {
            ...props,
            invertColors: invertColors,
            disableHovercard: disableHovercard,
            IconComponent: IconComponent
        }) : /*#__PURE__*/ $cozmU.createElement((0, $fGEnS.HoverCard), {
            placement: "top",
            fallbackPlacements: [
                "bottom",
                "left"
            ],
            autoFocus: false,
            hoverCardDelay: $dfa98e52cf6bfc2d$var$SKILL_TAG_HOVERCARD_DELAY,
            shouldRenderToParent: false,
            content: /*#__PURE__*/ $cozmU.createElement((0, $80Hjq.SkillHoverCardContent), {
                product: product,
                iconName: iconName,
                maxHeight: hovercardMaxHeight,
                ...props
            })
        }, /*#__PURE__*/ $cozmU.createElement($dfa98e52cf6bfc2d$var$SkillTagInternal, {
            invertColors: invertColors,
            disableHovercard: disableHovercard,
            IconComponent: IconComponent,
            ...props
        }));
        $[7] = IconComponent;
        $[8] = disableHovercard;
        $[9] = hasHovercardInfo;
        $[10] = hovercardMaxHeight;
        $[11] = iconName;
        $[12] = invertColors;
        $[13] = product;
        $[14] = props;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : ({ invertColors: invertColors = false, disableHovercard: disableHovercard = false, product: product, iconName: iconName, hovercardMaxHeight: hovercardMaxHeight, ...props })=>{
    const IconComponent = iconName ? (0, $9MCKh.skillIconMap)[iconName] : undefined;
    const hasHovercardInfo = props?.name && props?.description;
    return disableHovercard || !hasHovercardInfo ? /*#__PURE__*/ $cozmU.createElement($dfa98e52cf6bfc2d$var$SkillTagInternal, {
        ...props,
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        IconComponent: IconComponent
    }) : /*#__PURE__*/ $cozmU.createElement((0, $fGEnS.HoverCard), {
        placement: "top",
        fallbackPlacements: [
            'bottom',
            'left'
        ],
        autoFocus: false,
        hoverCardDelay: $dfa98e52cf6bfc2d$var$SKILL_TAG_HOVERCARD_DELAY,
        shouldRenderToParent: false,
        content: /*#__PURE__*/ $cozmU.createElement((0, $80Hjq.SkillHoverCardContent), {
            product: product,
            iconName: iconName,
            maxHeight: hovercardMaxHeight,
            ...props
        })
    }, /*#__PURE__*/ $cozmU.createElement($dfa98e52cf6bfc2d$var$SkillTagInternal, {
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        IconComponent: IconComponent,
        ...props
    }));
};
module.exports["SkillTag"] = $dfa98e52cf6bfc2d$export$55feb0e4f341a6f6;

});

parcelRegister("jQDPt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");


var $gP4Ah = parcelRequire("gP4Ah");


var $iKq5p = parcelRequire("iKq5p");


var $aDLTK = parcelRequire("aDLTK");


var $d1E9z = parcelRequire("d1E9z");


var $4dGeq = parcelRequire("4dGeq");


var $7lEy4 = parcelRequire("7lEy4");


var $gLHF9 = parcelRequire("gLHF9");


var $3ZJWK = parcelRequire("3ZJWK");


var $6691T = parcelRequire("6691T");

const $2c0f5767430884e4$var$createIcon = (src)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: src,
            alt: ''
        });
const $2c0f5767430884e4$var$defaultIcon = $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($7lEy4))));
const $2c0f5767430884e4$export$cbe04d535daede57 = {
    Analyze: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($gP4Ah)))),
    Brainstorm: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($iKq5p)))),
    Review: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($3ZJWK)))),
    Summarize: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($6691T)))),
    Create: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($aDLTK)))),
    Execute: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($d1E9z)))),
    Find: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($4dGeq)))),
    Learn: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($gLHF9))))
};
const $2c0f5767430884e4$export$8581fc8a588fa6e0 = $2c0f5767430884e4$var$defaultIcon;
const $2c0f5767430884e4$export$9b54dda66a3b3d54 = (useCase)=>{
    if (useCase === undefined || !(useCase in $2c0f5767430884e4$export$cbe04d535daede57)) return $2c0f5767430884e4$var$defaultIcon;
    return $2c0f5767430884e4$export$cbe04d535daede57[useCase];
};
module.exports["promptUseCaseIconMap"] = $2c0f5767430884e4$export$cbe04d535daede57;
module.exports["defaultPromptUseCaseIcon"] = $2c0f5767430884e4$export$8581fc8a588fa6e0;
module.exports["getUseCaseIcon"] = $2c0f5767430884e4$export$9b54dda66a3b3d54;

});

parcelRegister("gP4Ah", function(module, exports) {
module.exports = new URL("analyze-icon.5c4c7ecb.svg", import.meta.url).toString();

});

parcelRegister("iKq5p", function(module, exports) {
module.exports = new URL("brainstorm-icon.f24d96f2.svg", import.meta.url).toString();

});

parcelRegister("aDLTK", function(module, exports) {
module.exports = new URL("create-icon.59c93a6c.svg", import.meta.url).toString();

});

parcelRegister("d1E9z", function(module, exports) {
module.exports = new URL("execute-icon.d7c359b6.svg", import.meta.url).toString();

});

parcelRegister("4dGeq", function(module, exports) {
module.exports = new URL("find-icon.63225fe6.svg", import.meta.url).toString();

});

parcelRegister("7lEy4", function(module, exports) {
module.exports = new URL("general-prompt-icon.5618909f.svg", import.meta.url).toString();

});

parcelRegister("gLHF9", function(module, exports) {
module.exports = new URL("learn-icon.7e0ca0d6.svg", import.meta.url).toString();

});

parcelRegister("3ZJWK", function(module, exports) {
module.exports = new URL("review-icon.7da7ded4.svg", import.meta.url).toString();

});

parcelRegister("6691T", function(module, exports) {
module.exports = new URL("summarize-icon.5a91c5af.svg", import.meta.url).toString();

});

parcelRegister("slkWY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");


var $4aRua = parcelRequire("4aRua");


var $9Wv0j = parcelRequire("9Wv0j");

const $2c8bdea3459c6f4c$export$d083836602d3f2cd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { title: title, body: body, isOpen: isOpen, isLoading: isLoading, onClose: onClose, onConfirm: onConfirm, testId: t1 } = t0;
    const testId = t1 === undefined ? "delete-confirm-modal" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!isOpen) return null;
    let t2;
    if ($[0] !== title) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, title));
        $[0] = title;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== body) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, body));
        $[2] = body;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $9Wv0j.messages).cancel);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== onClose || $[7] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onClose
        }, t4);
        $[6] = onClose;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage((0, $9Wv0j.messages).delete);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== isLoading || $[12] !== onConfirm || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "danger",
            isLoading: isLoading,
            onClick: onConfirm
        }, t6);
        $[11] = isLoading;
        $[12] = onConfirm;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t5 || $[16] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, t5, t7);
        $[15] = t5;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== onClose || $[19] !== t2 || $[20] !== t3 || $[21] !== t8 || $[22] !== testId) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: onClose,
            width: "small",
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: true,
            testId: testId
        }, t2, t3, t8);
        $[18] = onClose;
        $[19] = t2;
        $[20] = t3;
        $[21] = t8;
        $[22] = testId;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
} : ({ title: title, body: body, isOpen: isOpen, isLoading: isLoading, onClose: onClose, onConfirm: onConfirm, testId: testId = 'delete-confirm-modal' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!isOpen) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "small",
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, title)), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, body)), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $9Wv0j.messages).cancel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "danger",
        isLoading: isLoading,
        onClick: onConfirm
    }, formatMessage((0, $9Wv0j.messages).delete))));
};
module.exports["DeleteConfirmModal"] = $2c8bdea3459c6f4c$export$d083836602d3f2cd;

});

parcelRegister("9Wv0j", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3e6e66a8271833c3$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    selectedLabel: {
        id: "rovo-conversation-actions.prompt-library-toolbar.selected-label",
        defaultMessage: "selected"
    },
    multiAddToFavorites: {
        id: "rovo-conversation-actions.prompt-library-toolbar.multi-add-to-favorites",
        defaultMessage: "Add to favorites"
    },
    multiRemoveFromFavorites: {
        id: "rovo-conversation-actions.prompt-library-toolbar.multi-remove-from-favorites",
        defaultMessage: "Remove from favorites"
    },
    multiDelete: {
        id: "rovo-conversation-actions.prompt-library-toolbar.multi-delete",
        defaultMessage: "Delete"
    },
    clearSelection: {
        id: "rovo-conversation-actions.prompt-library-toolbar.clear-selection",
        defaultMessage: "Clear selection"
    },
    multiDeleteConfirmTitle: {
        id: "rovo-conversation-actions.prompt-library-toolbar.multi-delete-confirm-title",
        defaultMessage: "Delete {count, plural, one {# prompt} other {# prompts}}?"
    },
    multiDeleteConfirmBody: {
        id: "rovo-conversation-actions.prompt-library-toolbar.multi-delete-confirm-body",
        defaultMessage: "Are you sure you want to delete {count, plural, one {# prompt} other {# prompts}}? This action cannot be undone."
    },
    cancel: {
        id: "rovo-conversation-actions.prompt-library-toolbar.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "rovo-conversation-actions.prompt-library-toolbar.delete",
        defaultMessage: "Delete"
    },
    multiShare: {
        id: "rovo-conversation-actions.prompt-library-toolbar.multi-share",
        defaultMessage: "Create link to share"
    },
    linkCopied: {
        id: "rovo-conversation-actions.prompt-library-toolbar.link-copied",
        defaultMessage: "Link copied!"
    }
});
module.exports["messages"] = $3e6e66a8271833c3$export$defe85febe8b728c;

});

parcelRegister("jjumc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $jQoON = parcelRequire("jQoON");


var $1rxhm = parcelRequire("1rxhm");

const $86b68553532904d5$var$styles = {
    container: "_2mHwu82ADO _4c065U2ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _2fwxA5DIqT",
    icon: "_3iDTPbQ4SZ _37wbyuDIqT"
};
const $86b68553532904d5$export$9f79c9cd936e831 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { title: title, subtitle: subtitle } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $86b68553532904d5$var$styles.icon
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($jQoON))),
            alt: ""
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== formatMessage || $[2] !== title) {
        t2 = title || formatMessage((0, $1rxhm.messages).noResultsTitle);
        $[1] = formatMessage;
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "large",
            as: "p"
        }, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage || $[7] !== subtitle) {
        t4 = subtitle || formatMessage((0, $1rxhm.messages).noResultsSubtitle);
        $[6] = formatMessage;
        $[7] = subtitle;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "medium",
            as: "p"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $86b68553532904d5$var$styles.container
        }, t1, t3, t5);
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ title: title, subtitle: subtitle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $86b68553532904d5$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $86b68553532904d5$var$styles.icon
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jQoON))),
        alt: ""
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large",
        as: "p"
    }, title || formatMessage((0, $1rxhm.messages).noResultsTitle)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        as: "p"
    }, subtitle || formatMessage((0, $1rxhm.messages).noResultsSubtitle)));
};
module.exports["PromptCardsEmptyState"] = $86b68553532904d5$export$9f79c9cd936e831;

});

parcelRegister("jQoON", function(module, exports) {
module.exports = new URL("no-results.db2e9229.svg", import.meta.url).toString();

});

parcelRegister("1rxhm", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $444d0a15d2b4a9e0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardMoreActions: {
        id: "rovo-conversation-actions.prompt-card.more-actions",
        defaultMessage: "More actions"
    },
    edit: {
        id: "rovo-conversation-actions.prompt-card.edit",
        defaultMessage: "Edit"
    },
    duplicate: {
        id: "rovo-conversation-actions.prompt-card.duplicate",
        defaultMessage: "Duplicate"
    },
    delete: {
        id: "rovo-conversation-actions.prompt-card.delete",
        defaultMessage: "Delete"
    },
    deleteConfirmTitle: {
        id: "rovo-conversation-actions.prompt-card.delete-confirm-title",
        defaultMessage: "Delete this prompt?"
    },
    deleteConfirmBody: {
        id: "rovo-conversation-actions.prompt-card.delete-confirm-body",
        defaultMessage: "Are you sure you want to delete this prompt? This action can't be undone."
    },
    cancel: {
        id: "rovo-conversation-actions.prompt-card.cancel",
        defaultMessage: "Cancel"
    },
    favoritePrompt: {
        id: "rovo-conversation-actions.prompt-card.favorite",
        defaultMessage: "Add to favorites"
    },
    unfavoritePrompt: {
        id: "rovo-conversation-actions.prompt-card.unfavorite",
        defaultMessage: "Remove from favorites"
    },
    sharePrompt: {
        id: "rovo-conversation-actions.prompt-card.share",
        defaultMessage: "Share"
    },
    noResultsTitle: {
        id: "rovo-conversation-actions.prompt-card.no-results-title",
        defaultMessage: "No results found"
    },
    noResultsSubtitle: {
        id: "rovo-conversation-actions.prompt-card.no-results-subtitle",
        defaultMessage: "Try removing your filters and searching again"
    },
    selectPrompt: {
        id: "rovo-conversation-actions.prompt-card.select-prompt",
        defaultMessage: "Select {title}"
    }
});
module.exports["messages"] = $444d0a15d2b4a9e0$export$defe85febe8b728c;

});

parcelRegister("ednap", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $kTb7m = parcelRequire("kTb7m");


var $8rSbQ = parcelRequire("8rSbQ");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $IOtUu = parcelRequire("IOtUu");


var $Ou0Zz = parcelRequire("Ou0Zz");




const $2e8aa9de82009b59$export$5af6c7a995176943 = (assistanceService)=>{
    const [knowledgeSourceIconMap, setKnowledgeSourceIconMap] = (0, $cozmU.useState)({});
    const [knowledgeSourceFriendlyNameMap, setKnowledgeSourceFriendlyNameMap] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        const fetchKnowledgeConfiguration = async ()=>{
            setIsLoading(true);
            try {
                const response = await assistanceService.getAgentKnowledgeConfiguration();
                const iconMap = {};
                const friendlyNameMap = {};
                response.knowledgeSources.forEach((config)=>{
                    iconMap[config.source] = config.iconUrl;
                    friendlyNameMap[config.source] = config.friendlyName;
                });
                setKnowledgeSourceIconMap(iconMap);
                setKnowledgeSourceFriendlyNameMap(friendlyNameMap);
            } catch  {
            // Fallback to local icons if API fails
            } finally{
                setIsLoading(false);
            }
        };
        fetchKnowledgeConfiguration();
    }, [
        assistanceService
    ]);
    return {
        iconMap: knowledgeSourceIconMap,
        friendlyNameMap: knowledgeSourceFriendlyNameMap,
        isLoading: isLoading
    };
};



var $lJ6db = parcelRequire("lJ6db");


var $6dlKt = parcelRequire("6dlKt");


var $jQDPt = parcelRequire("jQDPt");




const $c7d878b090e14aa7$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    sharePromptTitle: {
        id: "rovo-conversation-actions.share-prompt-modal.title",
        defaultMessage: "Share prompt"
    },
    closeButtonLabel: {
        id: "rovo-conversation-actions.share-prompt-modal.close-button-label",
        defaultMessage: "Close"
    },
    informationLabel: {
        id: "rovo-conversation-actions.share-prompt-modal.information-label",
        defaultMessage: "Information"
    },
    useCaseLabel: {
        id: "rovo-conversation-actions.share-prompt-modal.use-case-label",
        defaultMessage: "Use case"
    },
    roleLabel: {
        id: "rovo-conversation-actions.share-prompt-modal.role-label",
        defaultMessage: "Role"
    },
    connectedAppsLabel: {
        id: "rovo-conversation-actions.share-prompt-modal.connected-apps-label",
        defaultMessage: "Connected apps"
    },
    fromOwner: {
        id: "rovo-conversation-actions.share-prompt-modal.from-owner",
        defaultMessage: "From {name}"
    },
    privacyNote: {
        id: "rovo-conversation-actions.share-prompt-modal.privacy-note",
        defaultMessage: "Shared only within {organizationName}"
    },
    privacyNoteNoOrganization: {
        id: "rovo-conversation-actions.share-prompt-modal.privacy-note-no-organization",
        defaultMessage: "Shared only within your organization"
    },
    copyLinkButton: {
        id: "rovo-conversation-actions.share-prompt-modal.copy-link-button",
        defaultMessage: "Copy link"
    },
    linkCopied: {
        id: "rovo-conversation-actions.share-prompt-modal.link-copied",
        defaultMessage: "Link copied!"
    },
    errorShareFailed: {
        id: "rovo-conversation-actions.share-prompt-modal.error-share-failed",
        defaultMessage: "Failed to share prompt. Please try again."
    }
});



var $5RYbF = parcelRequire("5RYbF");

const $0f7736c7401d7296$var$styles = {
    headerFlex: "_0aFT5vf5Xk _39xV02N91d",
    card: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM _1mT5xdRAKS _0NUa3r7FF2 _2WAcuGIZbP",
    promptTitle: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _1DCdHi2ADO",
    useCaseIconContainer: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    promptText: "_1UtDYzy7kJ",
    infoSection: "_3138425zaO _0Of8r25zaO _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    infoRow: "_2mHwu82ADO _3iDTPbQ4SZ _1DCdHi2ADO _0hPCNLchRC _37wbyuI7V3",
    infoLabel: "_4ouGXIVazu _3YEZNOdnbC",
    infoValue: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLchRC _3TGfC9HnLE",
    appIcons: "_3iDTPbQ4SZ _3TGfC9HnLE _37wbyuz9WS _0hPCNLDIqT",
    appTagIcon: "_2Y7lL4FQfX",
    appTagImage: "_39xV02xpxF _0jFU0VxpxF",
    copyButtonContainer: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0KLXru2o0p",
    privacyGroup: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1wydGW8HPE",
    buttonRow: "_3iDTPbQ4SZ _37wbyuDIqT"
};
const $0f7736c7401d7296$export$48796815b55a50a2 = ({ isOpen: isOpen, onClose: onClose, promptData: promptData, organizationName: organizationName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [copySuccess, setCopySuccess] = (0, $cozmU.useState)(false);
    const [shareError, setShareError] = (0, $cozmU.useState)(null);
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    const { iconMap: knowledgeSourceIconMap, isLoading: isLoadingIcons } = (0, $2e8aa9de82009b59$export$5af6c7a995176943)(assistanceService); // Always show an icon - use the useCase icon if available, otherwise use the default GeneralPromptIcon
    const UseCaseIcon = (0, $jQDPt.getUseCaseIcon)(promptData.useCase?.value);
    const shareUrl = (0, $5RYbF.generateShareLink)([
        promptData.shareId
    ]);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleCopyLink = (0, $cozmU.useCallback)(async ()=>{
        setShareError(null);
        try {
            const isSystemPrompt = promptData.shareId.startsWith('sys_');
            if (!isSystemPrompt && promptData.isPrivate !== false) await assistanceService.updatePrompt(promptData.shareId, {
                isPrivate: false
            });
            await navigator.clipboard.writeText(shareUrl);
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'copyPromptShareLink'
            });
            setCopySuccess(true);
            setTimeout(()=>setCopySuccess(false), 2000);
        } catch  {
            setShareError(formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).errorShareFailed));
        }
    }, [
        shareUrl,
        promptData.isPrivate,
        promptData.shareId,
        assistanceService,
        formatMessage,
        sendAnalyticsEvent
    ]);
    const hasInformation = promptData.useCase || promptData.role.length > 0 || promptData.app.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "medium",
        shouldScrollInViewport: true,
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).sharePromptTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.promptTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.useCaseIconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(UseCaseIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "medium"
    }, promptData.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.promptText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, promptData.prompt)), hasInformation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $0f7736c7401d7296$var$styles.infoSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "small"
    }, formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).informationLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, promptData.useCase && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).useCaseLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, promptData.useCase.label))), promptData.role.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).roleLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, promptData.role.map((r)=>r.label).join(', ')))), promptData.app.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).connectedAppsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.infoValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: $0f7736c7401d7296$var$styles.appIcons
    }, promptData.app.map((app)=>{
        // Use API icon if available, fallback to local icon
        const apiIconUrl = knowledgeSourceIconMap[app.value];
        const fallbackIcon = (0, $6dlKt.getKnowledgeSourceIcon)(app.value, {
            size: 12
        }); // Show skeleton while loading icons
        const iconElement = isLoadingIcons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0f7736c7401d7296$var$styles.appTagIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "12px",
            height: "12px",
            borderRadius: "var(--ds-radius-xsmall, 2px)"
        })) : apiIconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0f7736c7401d7296$var$styles.appTagIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "img",
            src: apiIconUrl,
            alt: app.label,
            xcss: $0f7736c7401d7296$var$styles.appTagImage
        })) : fallbackIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0f7736c7401d7296$var$styles.appTagIcon
        }, fallbackIcon) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: app.value,
            text: app.label,
            isRemovable: false,
            elemBefore: iconElement
        });
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.buttonRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.copyButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleCopyLink,
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.inverse"
    }, copySuccess ? formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).linkCopied) : formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).copyLinkButton)))))), shareError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.danger"
    }, shareError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0f7736c7401d7296$var$styles.privacyGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rSbQ))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, organizationName ? formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).privacyNote, {
        organizationName: organizationName
    }) : formatMessage((0, $c7d878b090e14aa7$export$a7357cdd1f0b0168).privacyNoteNoOrganization)))))));
};
module.exports["SharePromptModal"] = $0f7736c7401d7296$export$48796815b55a50a2;

});

parcelRegister("8rSbQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2c023450ab07659b873bcfa59efe875f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $626ae15b38db0924$var$_react = $626ae15b38db0924$var$_interopRequireDefault((parcelRequire("cozmU")));

var $626ae15b38db0924$var$_baseNew = $626ae15b38db0924$var$_interopRequireDefault((parcelRequire("gElAV")));
function $626ae15b38db0924$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/shield
 * Usage guidance:
 * Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $626ae15b38db0924$var$ShieldIcon = (props)=>/*#__PURE__*/ $626ae15b38db0924$var$_react.default.createElement($626ae15b38db0924$var$_baseNew.default, Object.assign({
        name: "ShieldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$626ae15b38db0924$var$ShieldIcon.displayName = 'ShieldIcon';
var $626ae15b38db0924$var$_default = module.exports.default = $626ae15b38db0924$var$ShieldIcon;

});

parcelRegister("6dlKt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmUhx = parcelRequire("jmUhx");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

const $bea364caeb317857$var$GoogleDriveIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let props;
    let size;
    if ($[0] !== t0) {
        ({ size: size, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = size;
    } else {
        props = $[1];
        size = $[2];
    }
    const t1 = size ?? 20;
    const t2 = size ?? 18;
    let t3;
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
            fill: "#3777E3"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
            fill: "#FFCF63"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
            fill: "#11A861"
        });
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== props.dataTestId || $[7] !== props.label || $[8] !== t1 || $[9] !== t2) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: "0 0 20 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props.dataTestId,
            "aria-label": props.label
        }, t3, t4, t5);
        $[6] = props.dataTestId;
        $[7] = props.label;
        $[8] = t1;
        $[9] = t2;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size ?? 20,
        height: size ?? 18,
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props.dataTestId,
        "aria-label": props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
        fill: "#3777E3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
        fill: "#FFCF63"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
        fill: "#11A861"
    }));
const $bea364caeb317857$var$SlackIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let props;
    let size;
    if ($[0] !== t0) {
        ({ size: size, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = size;
    } else {
        props = $[1];
        size = $[2];
    }
    const t1 = size ?? 24;
    const t2 = size ?? 24;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181639)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
            fill: "#E01E5A"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181639"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        })));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== props.dataTestId || $[6] !== props.label || $[7] !== t1 || $[8] !== t2) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props.dataTestId,
            "aria-label": props.label
        }, t3, t4);
        $[5] = props.dataTestId;
        $[6] = props.label;
        $[7] = t1;
        $[8] = t2;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size ?? 24,
        height: size ?? 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props.dataTestId,
        "aria-label": props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181639)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
        fill: "#E01E5A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181639"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
const $bea364caeb317857$var$MicrosoftSharepointIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let props;
    let size;
    if ($[0] !== t0) {
        ({ size: size, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = size;
    } else {
        props = $[1];
        size = $[2];
    }
    const t1 = size ?? 20;
    const t2 = size ?? 20;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask0_1701_19689",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20 0H0V20H20V0Z",
            fill: "white"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask0_1701_19689)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
            fill: "#036C70"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
            fill: "#1A9BA1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
            fill: "#37C6D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
            fill: "#04868B"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
            fill: "white"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== props.dataTestId || $[6] !== props.label || $[7] !== t1 || $[8] !== t2) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props.dataTestId,
            "aria-label": props.label
        }, t3, t4);
        $[5] = props.dataTestId;
        $[6] = props.label;
        $[7] = t1;
        $[8] = t2;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size ?? 20,
        height: size ?? 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props.dataTestId,
        "aria-label": props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask0_1701_19689",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20 0H0V20H20V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask0_1701_19689)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
        fill: "white"
    })));
const $bea364caeb317857$var$styles = {
    scaledLogoWrapper: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT",
    scaledLogoInner: "_3iDTPbccYA"
};
const $bea364caeb317857$var$renderScaledLogo = (element, baseSize, size)=>{
    if (!size) return element;
    const scale = size / baseSize;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $bea364caeb317857$var$styles.scaledLogoWrapper,
        style: {
            width: size,
            height: size
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $bea364caeb317857$var$styles.scaledLogoInner,
        style: {
            transform: `scale(${scale})`
        }
    }, element));
};
const $bea364caeb317857$export$f32a352406d501db = (source)=>source === 'atlas' ? 'Projects and goals' : source.replace(/[_-]/g, ' ').split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '); // Base sizes match the rendered pixel dimensions of each icon at their default/size="small" value.
// Atlaskit Logo size="small" = 24px. SVG icons use their native viewBox dimensions.
const $bea364caeb317857$var$iconRenderers = {
    confluence: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
            size: "small",
            appearance: "brand"
        }), 24, options?.size),
    jira: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
            size: "small",
            appearance: "brand"
        }), 24, options?.size),
    atlas: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
            label: "",
            size: "small",
            appearance: "brand"
        }), 24, options?.size),
    google_drive: (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bea364caeb317857$var$GoogleDriveIcon, {
            label: "",
            size: options?.size
        }),
    microsoft_sharepoint: (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bea364caeb317857$var$MicrosoftSharepointIcon, {
            label: "",
            size: options?.size
        }),
    slack: (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bea364caeb317857$var$SlackIcon, {
            label: "",
            size: options?.size
        }),
    loom: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomIcon), {
            label: "",
            size: "small"
        }), 24, options?.size),
    app: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
            label: "",
            size: "small"
        }), 12, options?.size)
};
const $bea364caeb317857$export$c63040ce43e3b7ce = Object.fromEntries(Object.entries($bea364caeb317857$var$iconRenderers).map(([key, render])=>[
        key,
        render()
    ]));
const $bea364caeb317857$export$40f6c94e234ed9d9 = (source, options)=>$bea364caeb317857$var$iconRenderers[source]?.(options) ?? null;
module.exports["formatKnowledgeSourceLabel"] = $bea364caeb317857$export$f32a352406d501db;
module.exports["iconMapper"] = $bea364caeb317857$export$c63040ce43e3b7ce;
module.exports["getKnowledgeSourceIcon"] = $bea364caeb317857$export$40f6c94e234ed9d9;

});

parcelRegister("7sEW2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");











var $7pCWA = parcelRequire("7pCWA");


var $ekfm7 = parcelRequire("ekfm7");


var $aJU2k = parcelRequire("aJU2k");


var $j3dQ1 = parcelRequire("j3dQ1");

const $d1e3c4a08a442449$var$normalizeSource = (source)=>source.toLowerCase().trim();
const $d1e3c4a08a442449$export$12df5ef2f23832e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { assistanceServiceParams: assistanceServiceParams } = t0;
    let t1;
    if ($[0] !== assistanceServiceParams) {
        t1 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[0] = assistanceServiceParams;
        $[1] = t1;
    } else t1 = $[1];
    (0, $ekfm7.useEnsureConnectorsLoaded)(t1);
    const { setAppFiltersFromPrompt: setAppFiltersFromPrompt } = (0, $aJU2k.useChatModeStoreActions)();
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    let t2;
    if ($[2] !== setAppFiltersFromPrompt || $[3] !== storeAllSources) {
        t2 = (chatModeKey, appIds)=>{
            if (appIds.length === 0 || storeAllSources.length === 0) return;
            const normalizedIds = new Set(appIds.map($d1e3c4a08a442449$var$normalizeSource));
            const filteredApps = storeAllSources.filter((s)=>normalizedIds.has($d1e3c4a08a442449$var$normalizeSource(s.source)) && s.isUserOAuthed).map($d1e3c4a08a442449$var$_temp);
            if (filteredApps.length > 0) setAppFiltersFromPrompt(chatModeKey, filteredApps);
        };
        $[2] = setAppFiltersFromPrompt;
        $[3] = storeAllSources;
        $[4] = t2;
    } else t2 = $[4];
    const setAppFiltersByPromptAppIds = t2;
    let t3;
    if ($[5] !== setAppFiltersByPromptAppIds) {
        t3 = {
            setAppFiltersByPromptAppIds: setAppFiltersByPromptAppIds
        };
        $[5] = setAppFiltersByPromptAppIds;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ assistanceServiceParams: assistanceServiceParams })=>{
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { setAppFiltersFromPrompt: setAppFiltersFromPrompt } = (0, $aJU2k.useChatModeStoreActions)();
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const setAppFiltersByPromptAppIds = (0, $cozmU.useCallback)((chatModeKey, appIds)=>{
        if (appIds.length === 0 || storeAllSources.length === 0) return;
        const normalizedIds = new Set(appIds.map($d1e3c4a08a442449$var$normalizeSource));
        // Don't clear all filters if the user hasn't connected to any of the apps
        const filteredApps = storeAllSources.filter((s)=>normalizedIds.has($d1e3c4a08a442449$var$normalizeSource(s.source)) && s.isUserOAuthed).map((s_0)=>({
                source: s_0.source,
                friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(s_0.source, s_0.friendlyName),
                iconUrl: s_0.iconUrl
            }));
        if (filteredApps.length > 0) setAppFiltersFromPrompt(chatModeKey, filteredApps);
    }, [
        setAppFiltersFromPrompt,
        storeAllSources
    ]);
    return {
        setAppFiltersByPromptAppIds: setAppFiltersByPromptAppIds
    };
};
function $d1e3c4a08a442449$var$_temp(s_0) {
    return {
        source: s_0.source,
        friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(s_0.source, s_0.friendlyName),
        iconUrl: s_0.iconUrl
    };
}




















const $c3e0f9a43a99c431$export$564414cb0f57d9b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUnconnectedAppsForPrompt(assistanceServiceParams) {
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== assistanceServiceParams) {
        t0 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[0] = assistanceServiceParams;
        $[1] = t0;
    } else t0 = $[1];
    (0, $ekfm7.useEnsureConnectorsLoaded)(t0);
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const allSources = storeAllSources;
    let t1;
    if ($[2] !== allSources) {
        t1 = (appIds)=>{
            if (!appIds || appIds.length === 0) return [];
            return allSources.filter((source)=>appIds.includes(source.source) && !source.isUserOAuthed).map($c3e0f9a43a99c431$var$_temp);
        };
        $[2] = allSources;
        $[3] = t1;
    } else t1 = $[3];
    const getUnconnectedApps = t1;
    let t2;
    if ($[4] !== getUnconnectedApps) {
        t2 = {
            getUnconnectedApps: getUnconnectedApps
        };
        $[4] = getUnconnectedApps;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function useUnconnectedAppsForPrompt(assistanceServiceParams) {
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const [storeAllSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const allSources = (0, $cozmU.useMemo)(()=>storeAllSources, [
        storeAllSources
    ]);
    const getUnconnectedApps = (0, $cozmU.useCallback)((appIds)=>{
        if (!appIds || appIds.length === 0) return [];
        return allSources.filter((source)=>appIds.includes(source.source) && !source.isUserOAuthed).map((source_0)=>({
                source: source_0.source,
                friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source_0.source, source_0.friendlyName),
                iconUrl: source_0.iconUrl,
                outboundAuthUrl: source_0.outboundAuthUrl
            }));
    }, [
        allSources
    ]);
    return {
        getUnconnectedApps: getUnconnectedApps
    };
};
function $c3e0f9a43a99c431$var$_temp(source_0) {
    return {
        source: source_0.source,
        friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source_0.source, source_0.friendlyName),
        iconUrl: source_0.iconUrl,
        outboundAuthUrl: source_0.outboundAuthUrl
    };
}



var $fIbhb = parcelRequire("fIbhb");




/**
 * The 3P connect prompt only ever offers this many connectors, keeping it concise —
 * the most-active unconnected ones from the API's activity-ranked
 * `third_party_connectors`.
 */ const $10ed611810c0da50$var$MAX_CONNECT_PROMPT_APPS = 2;
const $10ed611810c0da50$export$5009eb39752022ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePromptAppConnectors(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { conversationId: conversationId, assistanceServiceParams: assistanceServiceParams } = t0;
    let t1;
    if ($[0] !== assistanceServiceParams) {
        t1 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[0] = assistanceServiceParams;
        $[1] = t1;
    } else t1 = $[1];
    const { setAppFiltersByPromptAppIds: setAppFiltersByPromptAppIds } = (0, $d1e3c4a08a442449$export$12df5ef2f23832e7)(t1);
    const { getUnconnectedApps: getUnconnectedApps } = (0, $c3e0f9a43a99c431$export$564414cb0f57d9b6)(assistanceServiceParams);
    const { showBanner: showAppConnectionBanner, hideBanner: hideAppConnectionBanner } = (0, $fIbhb.useAppConnectionBannerActions)();
    const { setOrgKnowledge: setOrgKnowledge } = (0, $aJU2k.useChatModeStoreActions)();
    let t2;
    if ($[2] !== conversationId || $[3] !== getUnconnectedApps || $[4] !== hideAppConnectionBanner || $[5] !== setAppFiltersByPromptAppIds || $[6] !== setOrgKnowledge || $[7] !== showAppConnectionBanner) {
        t2 = (appIds, options)=>{
            if (appIds?.length) {
                setAppFiltersByPromptAppIds(conversationId, appIds);
                const unconnectedApps = getUnconnectedApps(appIds);
                let appsForPrompt = unconnectedApps;
                if (options?.showConnectedState) {
                    const bySource = new Map(unconnectedApps.map($10ed611810c0da50$var$_temp));
                    appsForPrompt = appIds.flatMap((appId)=>{
                        const app_0 = bySource.get(appId);
                        return app_0 ? [
                            app_0
                        ] : [];
                    }).slice(0, $10ed611810c0da50$var$MAX_CONNECT_PROMPT_APPS);
                }
                if (appsForPrompt.length > 0) showAppConnectionBanner(appsForPrompt, {
                    forceMultiline: options?.forceMultiline,
                    showConnectedState: options?.showConnectedState
                });
                else hideAppConnectionBanner();
            } else {
                setOrgKnowledge(conversationId, {
                    filteredApps: []
                });
                hideAppConnectionBanner();
            }
        };
        $[2] = conversationId;
        $[3] = getUnconnectedApps;
        $[4] = hideAppConnectionBanner;
        $[5] = setAppFiltersByPromptAppIds;
        $[6] = setOrgKnowledge;
        $[7] = showAppConnectionBanner;
        $[8] = t2;
    } else t2 = $[8];
    const handlePromptAppConnectors = t2;
    let t3;
    if ($[9] !== handlePromptAppConnectors) {
        t3 = {
            handlePromptAppConnectors: handlePromptAppConnectors
        };
        $[9] = handlePromptAppConnectors;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function usePromptAppConnectors({ conversationId: conversationId, assistanceServiceParams: assistanceServiceParams }) {
    const { setAppFiltersByPromptAppIds: setAppFiltersByPromptAppIds } = (0, $d1e3c4a08a442449$export$12df5ef2f23832e7)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { getUnconnectedApps: getUnconnectedApps } = (0, $c3e0f9a43a99c431$export$564414cb0f57d9b6)(assistanceServiceParams);
    const { showBanner: showAppConnectionBanner, hideBanner: hideAppConnectionBanner } = (0, $fIbhb.useAppConnectionBannerActions)();
    const { setOrgKnowledge: setOrgKnowledge } = (0, $aJU2k.useChatModeStoreActions)();
    /**
   * Handles app connectors and connection banner for a selected prompt card.
   * Call this when a user selects a prompt that may have associated apps.
   */ const handlePromptAppConnectors = (0, $cozmU.useCallback)((appIds, options)=>{
        if (appIds?.length) {
            setAppFiltersByPromptAppIds(conversationId, appIds);
            const unconnectedApps = getUnconnectedApps(appIds);
            let appsForPrompt = unconnectedApps;
            if (options?.showConnectedState) {
                // 3P connect prompt: offer the most-active *unconnected* connectors. Rank
                // first and cap second — capping `appIds` first would offer nothing at all
                // whenever the top-ranked connectors happen to be connected already.
                // `getUnconnectedApps` returns store order, so re-key by source to recover
                // the API's ranking. The app filters above still use the full set.
                const bySource = new Map(unconnectedApps.map((app)=>[
                        app.source,
                        app
                    ]));
                appsForPrompt = appIds.flatMap((appId)=>{
                    const app_0 = bySource.get(appId);
                    return app_0 ? [
                        app_0
                    ] : [];
                }).slice(0, $10ed611810c0da50$var$MAX_CONNECT_PROMPT_APPS);
            }
            if (appsForPrompt.length > 0) showAppConnectionBanner(appsForPrompt, {
                forceMultiline: options?.forceMultiline,
                showConnectedState: options?.showConnectedState
            });
            else hideAppConnectionBanner();
        } else {
            setOrgKnowledge(conversationId, {
                filteredApps: []
            });
            hideAppConnectionBanner();
        }
    }, [
        conversationId,
        getUnconnectedApps,
        setAppFiltersByPromptAppIds,
        setOrgKnowledge,
        showAppConnectionBanner,
        hideAppConnectionBanner
    ]);
    return {
        handlePromptAppConnectors: handlePromptAppConnectors
    };
};
function $10ed611810c0da50$var$_temp(app) {
    return [
        app.source,
        app
    ];
}
module.exports["usePromptAppConnectors"] = $10ed611810c0da50$export$5009eb39752022ec;

});

parcelRegister("eU4FB", function(module, exports) {
function $da0e152335263421$export$cfdea67cef0c3a2f(isUserGenerated) {
    return !(isUserGenerated ?? true);
}
module.exports["getIsSystemPromptForAnalytics"] = $da0e152335263421$export$cfdea67cef0c3a2f;

});

parcelRegister("jmZRX", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $8s9DV = parcelRequire("8s9DV");

const $adf9655c36c517ee$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        source: null
    },
    actions: {
        setPromptCardSource: (source)=>({ setState: setState })=>{
                setState({
                    source: source
                });
            },
        /**
     * Returns the current prompt card source (if any) and clears it.
     * Call this when the user sends a message to determine if they sent a prompt card as-is or tweaked it.
     */ takePromptCardSource: ()=>({ setState: setState, getState: getState })=>{
                const source = getState().source;
                setState({
                    source: null
                });
                return source;
            }
    }
});


const $ecd44545f6782335$export$787433804687cbc5 = (0, $kBr4q.createActionsHook)((0, $adf9655c36c517ee$export$6f57813fe9f31bf9));
module.exports["usePromptCardSendTrackingActions"] = $ecd44545f6782335$export$787433804687cbc5;

});

parcelRegister("8kqBU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lJ6db = parcelRequire("lJ6db");







const $6a8841f417f089f0$export$7c887a2bbf5566bd = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const createPrompt = (0, $cozmU.useCallback)((payload)=>assistanceService.createPrompt(payload), [
        assistanceService
    ]);
    return {
        createPrompt: createPrompt
    };
});


const $324e22b776e975bf$export$3a077119f3a18db0 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, refetchPrompts: refetchPrompts })=>{
    const assistanceServiceParams = {
        touchpointSource: assistanceServiceInjectedParams.touchpointSource,
        product: assistanceServiceInjectedParams.product,
        experienceId: assistanceServiceInjectedParams.experienceId,
        siteId: assistanceServiceInjectedParams.siteId,
        headers: assistanceServiceInjectedParams.headers,
        baseUrl: assistanceServiceInjectedParams.baseUrl
    };
    const { createPrompt: createPrompt } = (0, $6a8841f417f089f0$export$7c887a2bbf5566bd)({
        assistanceServiceParams: assistanceServiceParams
    });
    const handleCreatePrompt = (0, $cozmU.useCallback)(async (data)=>{
        const result = await createPrompt({
            title: data.title.trim(),
            prompt: data.prompt.trim(),
            ...data.useCase?.value && {
                useCase: data.useCase.value
            },
            roles: data.role.length > 0 ? data.role.map((r)=>r.value) : [
                'General'
            ],
            ...data.app.length > 0 && {
                appIds: data.app.map((a)=>a.value)
            }
        });
        await refetchPrompts?.();
        return result;
    }, [
        createPrompt,
        refetchPrompts
    ]);
    return {
        handleCreatePrompt: handleCreatePrompt
    };
});
module.exports["useCreatePrompt"] = $324e22b776e975bf$export$3a077119f3a18db0;

});

parcelRegister("dJo3Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lJ6db = parcelRequire("lJ6db");

const $97e719ee7ebd4236$export$6511f077f7a7fe4c = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const deletePrompt = (0, $cozmU.useCallback)((shareId)=>assistanceService.deletePrompt(shareId), [
        assistanceService
    ]);
    return {
        deletePrompt: deletePrompt
    };
});
module.exports["useDeletePromptController"] = $97e719ee7ebd4236$export$6511f077f7a7fe4c;

});

parcelRegister("9jj3s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $eU4FB = parcelRequire("eU4FB");


var $j4Mju = parcelRequire("j4Mju");





var $lJ6db = parcelRequire("lJ6db");

const $690899877a3adf4b$export$f4b64ae96b290ea7 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const bulkUpdatePrivacy = (0, $cozmU.useCallback)((payload)=>assistanceService.bulkUpdatePrivacy(payload), [
        assistanceService
    ]);
    return {
        bulkUpdatePrivacy: bulkUpdatePrivacy
    };
});








const $d6825c4101e8a1b8$export$828fd27c49936f56 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const favoritePrompts = (0, $cozmU.useCallback)((payload)=>assistanceService.favoritePrompts(payload), [
        assistanceService
    ]);
    return {
        favoritePrompts: favoritePrompts
    };
});


function $8d42f73309bd44ea$export$b69cbf7f2fd4c7ba({ assistanceServiceParams: assistanceServiceParams, showErrorFlag: showErrorFlag = true, onSuccess: onSuccess, deletePrompt: deletePrompt, refetchPrompts: refetchPrompts, updatePromptFavoriteInCache: updatePromptFavoriteInCache, bulkUpdatePromptFavoritesInCache: bulkUpdatePromptFavoritesInCache }) {
    const { favoritePrompts: favoritePrompts } = (0, $d6825c4101e8a1b8$export$828fd27c49936f56)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { bulkUpdatePrivacy: bulkUpdatePrivacy } = (0, $690899877a3adf4b$export$f4b64ae96b290ea7)({
        assistanceServiceParams: assistanceServiceParams
    });
    let showFlag = null;
    try {
        const flagContext = (0, $4MnFz.useFlags)();
        showFlag = flagContext?.showFlag || null;
    } catch  {
    // FlagProvider context not available (e.g., in tests)
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleFavoriteToggle = (0, $cozmU.useCallback)(async (promptId, isFavorited, isUserGenerated)=>{
        updatePromptFavoriteInCache?.(promptId, isFavorited);
        try {
            await favoritePrompts({
                prompts: [
                    {
                        shareId: promptId,
                        isFavorite: isFavorited
                    }
                ]
            });
            // Fire analytics only after successful API call to avoid over-reporting
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'promptLibraryFavoriteToggle',
                attributes: {
                    favoriteAction: isFavorited ? 'favorited' : 'unfavorited',
                    isSystemPrompt: (0, $eU4FB.getIsSystemPromptForAnalytics)(isUserGenerated)
                }
            });
            onSuccess?.();
        } catch (error) {
            // Revert optimistic update on failure
            updatePromptFavoriteInCache?.(promptId, !isFavorited);
            if (showErrorFlag && showFlag) showFlag({
                id: 'prompt-library.favorite-toggle-error',
                title: formatMessage(isFavorited ? (0, $j4Mju.default).failedToAddPromptToFavorites : (0, $j4Mju.default).failedToRemovePromptFromFavorites),
                description: formatMessage((0, $j4Mju.default).tryAgain),
                appearance: 'error',
                isAutoDismiss: true
            });
            throw error;
        }
    }, [
        favoritePrompts,
        showErrorFlag,
        showFlag,
        formatMessage,
        sendAnalyticsEvent,
        onSuccess,
        updatePromptFavoriteInCache
    ]);
    /**
   * Bulk favorite/unfavorite multiple prompts in a single API call.
   * Used by the multiselect toolbar for batch operations.
   * @param prompts - Array of prompts to favorite/unfavorite
   * @param systemPromptCount - Number of system prompts in the selection (for analytics)
   */ const handleBulkFavorite = (0, $cozmU.useCallback)(async (prompts, systemPromptCount = 0)=>{
        // Optimistically update all prompts in a single cache update
        bulkUpdatePromptFavoritesInCache?.(prompts.map((p)=>({
                promptId: p.shareId,
                isFavorited: p.isFavorite
            })));
        try {
            await favoritePrompts({
                prompts: prompts
            });
            // Fire analytics for bulk operation
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'promptLibraryBulkFavoriteToggle',
                attributes: {
                    count: prompts.length,
                    favoriteAction: prompts[0]?.isFavorite ? 'favorited' : 'unfavorited',
                    systemPromptCount: systemPromptCount
                }
            });
            onSuccess?.();
        } catch (error_0) {
            // Revert optimistic updates on failure
            bulkUpdatePromptFavoritesInCache?.(prompts.map((p_0)=>({
                    promptId: p_0.shareId,
                    isFavorited: !p_0.isFavorite
                })));
            if (showErrorFlag && showFlag) {
                const isFavoriting = prompts[0]?.isFavorite ?? true;
                showFlag({
                    id: 'prompt-library.bulk-favorite-toggle-error',
                    title: formatMessage(isFavoriting ? (0, $j4Mju.default).failedToAddPromptToFavorites : (0, $j4Mju.default).failedToRemovePromptFromFavorites),
                    description: formatMessage((0, $j4Mju.default).tryAgain),
                    appearance: 'error',
                    isAutoDismiss: true
                });
            }
            throw error_0;
        }
    }, [
        favoritePrompts,
        showErrorFlag,
        showFlag,
        formatMessage,
        sendAnalyticsEvent,
        onSuccess,
        bulkUpdatePromptFavoritesInCache
    ]);
    /**
   * Bulk delete multiple prompts and refetch the list.
   * Used by the multiselect toolbar for batch delete operations.
   * Requires deletePrompt and refetchPrompts to be provided to the hook.
   * @param promptIds - Array of prompt IDs to delete
   * @param systemPromptCount - Number of system prompts in the selection (for analytics)
   */ const handleBulkDelete = (0, $cozmU.useCallback)(async (promptIds, systemPromptCount_0 = 0)=>{
        if (!deletePrompt || !refetchPrompts) throw new Error('handleBulkDelete requires deletePrompt and refetchPrompts');
        try {
            await Promise.all(promptIds.map((id)=>deletePrompt(id)));
            // Fire analytics for bulk delete
            sendAnalyticsEvent({
                action: 'deleted',
                actionSubject: 'prompt',
                actionSubjectId: 'promptBulkDeleted',
                attributes: {
                    isBulkDelete: true,
                    bulkDeleteCount: promptIds.length,
                    systemPromptCount: systemPromptCount_0
                }
            });
            await refetchPrompts();
        } catch (error_1) {
            if (showErrorFlag && showFlag) showFlag({
                id: 'prompt-library.bulk-delete-error',
                title: formatMessage((0, $j4Mju.default).failedToDeletePrompt),
                description: formatMessage((0, $j4Mju.default).tryAgain),
                appearance: 'error',
                isAutoDismiss: true
            });
            throw error_1;
        }
    }, [
        deletePrompt,
        refetchPrompts,
        showErrorFlag,
        showFlag,
        formatMessage,
        sendAnalyticsEvent
    ]);
    /**
   * Bulk share multiple prompts by making them public.
   * Used by the multiselect toolbar for batch share operations.
   * @param promptIds - Array of prompt IDs to share
   * @param systemPromptCount - Number of system prompts in the selection (for analytics)
   */ const handleBulkShare = (0, $cozmU.useCallback)(async (promptIds_0, systemPromptCount_1 = 0)=>{
        try {
            await bulkUpdatePrivacy({
                prompts: promptIds_0.map((shareId)=>({
                        shareId: shareId,
                        isPrivate: false
                    }))
            });
            sendAnalyticsEvent({
                action: 'shared',
                actionSubject: 'prompt',
                actionSubjectId: 'promptBulkShared',
                attributes: {
                    bulkShareCount: promptIds_0.length + systemPromptCount_1,
                    systemPromptCount: systemPromptCount_1
                }
            });
        } catch (error_2) {
            if (showErrorFlag && showFlag) showFlag({
                id: 'prompt-library.bulk-share-error',
                title: formatMessage((0, $j4Mju.default).failedToSharePrompt),
                description: formatMessage((0, $j4Mju.default).tryAgain),
                appearance: 'error',
                isAutoDismiss: true
            });
            throw error_2;
        }
    }, [
        bulkUpdatePrivacy,
        showErrorFlag,
        showFlag,
        formatMessage,
        sendAnalyticsEvent
    ]);
    return {
        handleFavoriteToggle: handleFavoriteToggle,
        handleBulkFavorite: handleBulkFavorite,
        handleBulkDelete: handleBulkDelete,
        handleBulkShare: handleBulkShare
    };
}
module.exports["usePromptActions"] = $8d42f73309bd44ea$export$b69cbf7f2fd4c7ba;

});

parcelRegister("j4Mju", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ed45cc82f8516820$var$messages = (0, $kSwu1.defineMessages)({
    headerTitle: {
        id: "ai-mate.prompt-library.header-title",
        defaultMessage: "Prompts"
    },
    seeAll: {
        id: "ai-mate.prompt-library.see-all",
        defaultMessage: "See all"
    },
    morePrompts: {
        id: "ai-mate.prompt-library.more-prompts",
        defaultMessage: "More Prompts"
    },
    lessPrompts: {
        id: "ai-mate.prompt-library.less-prompts",
        defaultMessage: "Less Prompts"
    },
    createPrompt: {
        id: "ai-mate.prompt-library.create-prompt",
        defaultMessage: "Create prompt"
    },
    all: {
        id: "ai-mate.prompt-library.all",
        defaultMessage: "All"
    },
    myPrompts: {
        id: "ai-mate.prompt-library.my-prompts",
        defaultMessage: "My prompts"
    },
    myPromptsEmptyTitle: {
        id: "ai-mate.prompt-library.my-prompts-empty-title",
        defaultMessage: "You haven't created any prompts"
    },
    myPromptsEmptyDescription: {
        id: "ai-mate.prompt-library.my-prompts-empty-description",
        defaultMessage: "Duplicate and fine tune an existing prompt as a starting point, or create a new one tailored to your work."
    },
    favorites: {
        id: "ai-mate.prompt-library.favorites",
        defaultMessage: "Favorites"
    },
    favoritesEmptyTitle: {
        id: "ai-mate.prompt-library.favorites-empty-title",
        defaultMessage: "You haven't added any favorites"
    },
    favoritesEmptyDescription: {
        id: "ai-mate.prompt-library.favorites-empty-description",
        defaultMessage: "When a prompt works well for you, star it to save it here."
    },
    failedToAddPromptToFavorites: {
        id: "ai-mate.prompt-library.failed-to-add-prompt-to-favorites",
        defaultMessage: "Failed to add prompt to favorites"
    },
    failedToRemovePromptFromFavorites: {
        id: "ai-mate.prompt-library.failed-to-remove-prompt-from-favorites",
        defaultMessage: "Failed to remove prompt from favorites"
    },
    failedToDeletePrompt: {
        id: "ai-mate.prompt-library.failed-to-delete-prompt",
        defaultMessage: "Failed to delete prompt"
    },
    failedToSharePrompt: {
        id: "ai-mate.prompt-library.failed-to-share-prompt",
        defaultMessage: "Failed to share prompt"
    },
    tryAgain: {
        id: "ai-mate.prompt-library.try-again",
        defaultMessage: "Please try again."
    },
    browseSearchPlaceholder: {
        id: "ai-mate.inline-browse.search-placeholder",
        defaultMessage: "Search"
    },
    loadingPrompts: {
        id: "ai-mate.prompt-library.loading-prompts",
        defaultMessage: "Loading prompts"
    }
});
var $ed45cc82f8516820$export$2e2bcd8739ae039 = $ed45cc82f8516820$var$messages;
module.exports["default"] = $ed45cc82f8516820$export$2e2bcd8739ae039;

});

parcelRegister("4Aef9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");

const $c6a24f3abf1ab248$export$5f3702e16e499b57 = (0, $lJ6db.createHookWithAssistanceService)(({ enabled: enabled = true, assistanceServiceInjectedParams: { assistanceService: assistanceService, touchpointSource: touchpointSource } })=>{
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)({
        touchpointSource: touchpointSource ?? 'promptLibrary'
    });
    const queryResult = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchPrompts'
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_PROMPTS,
                id: (0, $irnO2.ExperienceName).FETCH_PROMPTS
            });
            try {
                const result = await assistanceService.getPrompts();
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_PROMPTS
                });
                return result;
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_PROMPTS,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        },
        enabled: enabled
    });
    const updatePromptFavoriteInCache = (0, $cozmU.useCallback)((promptId, isFavorited)=>{
        const currentData = queryResult.data;
        if (!currentData) return;
        // Handle both response formats: { prompts: [...] } and { items: [...] }.
        // The `{ items: [...] }` variant is a legacy response shape not present on
        // `GetAllPromptsResponse`, so the element type is asserted after the `in` guard.
        const prompts = currentData.prompts ?? ('items' in currentData ? currentData.items : []);
        const updatedPrompts = prompts.map((prompt)=>prompt.id === promptId ? {
                ...prompt,
                isFavorited: isFavorited
            } : prompt);
        // Update the cache with the modified data
        queryResult.updateCache({
            ...currentData,
            prompts: currentData.prompts ? updatedPrompts : undefined,
            ...'items' in currentData ? {
                items: updatedPrompts
            } : {}
        });
    }, [
        queryResult
    ]);
    const bulkUpdatePromptFavoritesInCache = (0, $cozmU.useCallback)((updates)=>{
        const currentData = queryResult.data;
        if (!currentData) return;
        // Create a map for quick lookup of updates
        const updatesMap = new Map(updates.map((u)=>[
                u.promptId,
                u.isFavorited
            ]));
        // Handle both response formats: { prompts: [...] } and { items: [...] }.
        // The `{ items: [...] }` variant is a legacy response shape not present on
        // `GetAllPromptsResponse`, so the element type is asserted after the `in` guard.
        const prompts = currentData.prompts ?? ('items' in currentData ? currentData.items : []);
        const updatedPrompts = prompts.map((prompt)=>updatesMap.has(prompt.id) ? {
                ...prompt,
                isFavorited: updatesMap.get(prompt.id)
            } : prompt);
        // Update the cache with the modified data
        queryResult.updateCache({
            ...currentData,
            prompts: currentData.prompts ? updatedPrompts : undefined,
            ...'items' in currentData ? {
                items: updatedPrompts
            } : {}
        });
    }, [
        queryResult
    ]);
    return {
        ...queryResult,
        updatePromptFavoriteInCache: updatePromptFavoriteInCache,
        bulkUpdatePromptFavoritesInCache: bulkUpdatePromptFavoritesInCache
    };
});
module.exports["usePromptsController"] = $c6a24f3abf1ab248$export$5f3702e16e499b57;

});

parcelRegister("dTXmz", function(module, exports) {
function $bebbc6dde5fe71be$export$ba91ee15316225f0(prompt, insertPlaceholder, skillMetadataMap) {
    insertPlaceholder(prompt, undefined, skillMetadataMap);
}
module.exports["insertPromptPlaceholder"] = $bebbc6dde5fe71be$export$ba91ee15316225f0;

});

parcelRegister("c1lhH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $b74e38261951ab09$var$isSystemPromptFromApi(p) {
    if (p.isSystemPrompt === true) return true;
    if (p.id.startsWith('sys_')) return true;
    return false;
}
function $b74e38261951ab09$export$29cbb8d8e94a6657(items) {
    return items.map((p)=>({
            id: p.id,
            title: p.title,
            prompt: p.prompt,
            useCase: p.useCase ?? undefined,
            roles: p.roles?.length ? p.roles : undefined,
            appIds: p.appIds?.length ? p.appIds : undefined,
            isFavorited: p.isFavorited,
            shareId: p.id,
            isUserGenerated: !$b74e38261951ab09$var$isSystemPromptFromApi(p)
        }));
}


/**
 * IDs of the priority default prompts that should appear first among system prompts.
 * These are shown in this specific order at the top of the system prompts section.
 */ const $0c32ff3eb6d78406$var$PRIORITY_SYSTEM_PROMPT_IDS = [
    'sys_01dd8573ce',
    // Analyze customer feedback trends
    'sys_3db52cef86',
    // Brainstorm ideas for project
    'sys_97d5b17ce5' // Send Slack message of weekly progress
];
/**
 * Pattern to detect skill tag syntax in prompts (e.g., '/get-data-insights').
 * Skills prompts contain slash commands that invoke Rovo skills.
 */ const $0c32ff3eb6d78406$var$SKILL_TAG_PATTERN = /'\/([\w-]+)'/;
/**
 * Checks if a prompt contains skill tag syntax.
 */ function $0c32ff3eb6d78406$var$promptContainsSkillTag(prompt) {
    return $0c32ff3eb6d78406$var$SKILL_TAG_PATTERN.test(prompt);
}
function $0c32ff3eb6d78406$var$isSystemPromptCheck(prompt) {
    if (prompt.id.startsWith('sys_')) return true;
    if (prompt.creator?.id === 'system' || prompt.creator?.id === 'system-prompts') return true;
    return prompt.isSystemPrompt === true;
}
/**
 * Determines the sort priority category for a prompt.
 * Lower numbers = higher priority (shown first).
 *
 * Priority order:
 * 1. User-generated prompts (non-system)
 * 2. Priority system prompts (specific IDs)
 * 3. System prompts with appIds (3P app connectors)
 * 4. System prompts with skill tags
 * 5. Other system prompts
 */ function $0c32ff3eb6d78406$var$getPromptSortCategory(prompt) {
    // User-generated prompts first
    if (!$0c32ff3eb6d78406$var$isSystemPromptCheck(prompt)) return 1;
    // Priority system prompts
    if ($0c32ff3eb6d78406$var$PRIORITY_SYSTEM_PROMPT_IDS.includes(prompt.id)) return 2;
    // System prompts with appIds (3P connectors)
    if (prompt.appIds && prompt.appIds.length > 0) return 3;
    // System prompts with skill tags
    if ($0c32ff3eb6d78406$var$promptContainsSkillTag(prompt.prompt)) return 4;
    // Other system prompts
    return 5;
}
/**
 * Gets the index of a priority system prompt for secondary sorting.
 * Returns a high number for non-priority prompts.
 */ function $0c32ff3eb6d78406$var$getPriorityPromptIndex(prompt) {
    const index = $0c32ff3eb6d78406$var$PRIORITY_SYSTEM_PROMPT_IDS.indexOf(prompt.id);
    return index >= 0 ? index : $0c32ff3eb6d78406$var$PRIORITY_SYSTEM_PROMPT_IDS.length;
}
function $0c32ff3eb6d78406$export$e3f623e12995ca43(prompts) {
    return [
        ...prompts
    ].sort((a, b)=>{
        // Favorites always come first
        if (a.isFavorited !== b.isFavorited) return a.isFavorited ? -1 : 1;
        const categoryA = $0c32ff3eb6d78406$var$getPromptSortCategory(a);
        const categoryB = $0c32ff3eb6d78406$var$getPromptSortCategory(b);
        // Sort by category
        if (categoryA !== categoryB) return categoryA - categoryB;
        // Within category 2 (priority system prompts), sort by predefined order
        if (categoryA === 2) return $0c32ff3eb6d78406$var$getPriorityPromptIndex(a) - $0c32ff3eb6d78406$var$getPriorityPromptIndex(b);
        // Within other categories, sort by createdAt descending (newest first)
        const createdAtA = a.createdAt ?? 0;
        const createdAtB = b.createdAt ?? 0;
        return createdAtB - createdAtA;
    });
}


function $92ace422f17cf12f$export$7543f1a54adfabf3(prompts) {
    const promptOrderRef = (0, $cozmU.useRef)([]);
    return (0, $cozmU.useMemo)(()=>{
        // On initial load or when new prompts are added, sort using the comprehensive sorting logic
        const currentIds = prompts.map((p)=>p.id);
        const hasNewPrompts = promptOrderRef.current.length === 0 || currentIds.some((id)=>!promptOrderRef.current.includes(id));
        if (hasNewPrompts) {
            const sorted = (0, $0c32ff3eb6d78406$export$e3f623e12995ca43)(prompts);
            promptOrderRef.current = sorted.map((p_0)=>p_0.id);
            return (0, $b74e38261951ab09$export$29cbb8d8e94a6657)(sorted);
        }
        // Use the stored order to maintain stability when favorite status changes
        const promptMap = new Map(prompts.map((p_1)=>[
                p_1.id,
                p_1
            ]));
        const orderedPrompts = promptOrderRef.current.filter((id_0)=>promptMap.has(id_0)).map((id_1)=>promptMap.get(id_1));
        return (0, $b74e38261951ab09$export$29cbb8d8e94a6657)(orderedPrompts);
    }, [
        prompts
    ]);
}
module.exports["useStablePromptOrder"] = $92ace422f17cf12f$export$7543f1a54adfabf3;

});

parcelRegister("3yAls", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ac5e56c1ae972fed0592a50e6dc88ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2970bd779dddb386$var$_react = $2970bd779dddb386$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2970bd779dddb386$var$_baseNew = $2970bd779dddb386$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2970bd779dddb386$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist-add
 * Usage guidance:
 * Adding items to your playlist (feature).
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2970bd779dddb386$var$PlaylistAddIcon = (props)=>/*#__PURE__*/ $2970bd779dddb386$var$_react.default.createElement($2970bd779dddb386$var$_baseNew.default, Object.assign({
        name: "PlaylistAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.75 7v2.25H13v1.5h-2.25V13h-1.5v-2.25H7v-1.5h2.25V7z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$2970bd779dddb386$var$PlaylistAddIcon.displayName = 'PlaylistAddIcon';
var $2970bd779dddb386$var$_default = module.exports.default = $2970bd779dddb386$var$PlaylistAddIcon;

});

parcelRegister("4zuSK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Ou0Zz = parcelRequire("Ou0Zz");

function $1623949d4d2d15ac$export$242a1f752c43f7ef(cards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors = []) {
    const normalizedQuery = searchQuery.trim().toLowerCase();
    return cards.filter((card)=>{
        // Search filter
        if (normalizedQuery) {
            const matchesSearch = card.title.toLowerCase().includes(normalizedQuery) || card.prompt.toLowerCase().includes(normalizedQuery) || (card.useCase?.toLowerCase().includes(normalizedQuery) ?? false) || (card.roles?.some((role)=>role.toLowerCase().includes(normalizedQuery)) ?? false) || (card.appIds?.some((appId)=>appId.toLowerCase().includes(normalizedQuery)) ?? false);
            if (!matchesSearch) return false;
        }
        // Use case filter
        if (selectedUseCases.length > 0) {
            if (!card.useCase || !selectedUseCases.includes(card.useCase)) return false;
        }
        // Role filter
        if (selectedRoles.length > 0) {
            if (!card.roles?.some((role)=>selectedRoles.includes(role))) return false;
        }
        // Connector filter
        if (selectedConnectors.length > 0) {
            const hasMatchingConnector = card.appIds?.length && card.appIds.some((id)=>selectedConnectors.includes(id));
            if (!hasMatchingConnector) return false;
        }
        return true;
    });
}


const $410323957b9c2809$export$e04099244c80b8e5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePromptLibraryFilters(promptCards, myPromptCards) {
    const $ = (0, $bDgLe.c)(54);
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)("");
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [selectedUseCases, setSelectedUseCases] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[1] = t1;
    } else t1 = $[1];
    const [selectedRoles, setSelectedRoles] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[2] = t2;
    } else t2 = $[2];
    const [selectedConnectors, setSelectedConnectors] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Set();
        $[3] = t3;
    } else t3 = $[3];
    const [selectedCategoryFilters, setSelectedCategoryFilters] = (0, $cozmU.useState)(t3);
    let t4;
    bb0: {
        if (selectedCategoryFilters.size === 0) {
            t4 = "all";
            break bb0;
        }
        if (selectedCategoryFilters.size === 1) {
            t4 = selectedCategoryFilters.has("myPrompts") ? "myPrompts" : "favorites";
            break bb0;
        }
        t4 = "all";
    }
    const selectedCategory = t4;
    let t5;
    if ($[4] !== promptCards) {
        t5 = promptCards.map($410323957b9c2809$var$_temp);
        $[4] = promptCards;
        $[5] = t5;
    } else t5 = $[5];
    const searchablePrompts = t5;
    let t6;
    if ($[6] !== promptCards || $[7] !== searchQuery || $[8] !== selectedConnectors || $[9] !== selectedRoles || $[10] !== selectedUseCases) {
        t6 = (0, $1623949d4d2d15ac$export$242a1f752c43f7ef)(promptCards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors);
        $[6] = promptCards;
        $[7] = searchQuery;
        $[8] = selectedConnectors;
        $[9] = selectedRoles;
        $[10] = selectedUseCases;
        $[11] = t6;
    } else t6 = $[11];
    const filteredPromptCards = t6;
    let t7;
    if ($[12] !== myPromptCards || $[13] !== searchQuery || $[14] !== selectedConnectors || $[15] !== selectedRoles || $[16] !== selectedUseCases) {
        t7 = (0, $1623949d4d2d15ac$export$242a1f752c43f7ef)(myPromptCards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors);
        $[12] = myPromptCards;
        $[13] = searchQuery;
        $[14] = selectedConnectors;
        $[15] = selectedRoles;
        $[16] = selectedUseCases;
        $[17] = t7;
    } else t7 = $[17];
    const filteredMyPromptCards = t7;
    let t8;
    if ($[18] !== promptCards || $[19] !== searchQuery || $[20] !== selectedConnectors || $[21] !== selectedRoles || $[22] !== selectedUseCases) {
        const favoriteCards = promptCards.filter($410323957b9c2809$var$_temp2);
        t8 = (0, $1623949d4d2d15ac$export$242a1f752c43f7ef)(favoriteCards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors);
        $[18] = promptCards;
        $[19] = searchQuery;
        $[20] = selectedConnectors;
        $[21] = selectedRoles;
        $[22] = selectedUseCases;
        $[23] = t8;
    } else t8 = $[23];
    const filteredFavoritePromptCards = t8;
    let t9;
    if ($[24] !== filteredFavoritePromptCards || $[25] !== filteredMyPromptCards || $[26] !== filteredPromptCards) {
        t9 = {
            all: filteredPromptCards,
            myPrompts: filteredMyPromptCards,
            favorites: filteredFavoritePromptCards
        };
        $[24] = filteredFavoritePromptCards;
        $[25] = filteredMyPromptCards;
        $[26] = filteredPromptCards;
        $[27] = t9;
    } else t9 = $[27];
    const promptCategories = t9;
    const cardsToShow = promptCategories[selectedCategory];
    const resultCount = cardsToShow.length;
    const hasActiveFilters = selectedUseCases.length > 0 || selectedRoles.length > 0 || selectedConnectors.length > 0 || selectedCategoryFilters.size > 0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t10;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (query, _filtered)=>{
            setSearchQuery(query);
        };
        $[28] = t10;
    } else t10 = $[28];
    const handleSearchChange = t10;
    let t11;
    if ($[29] !== sendAnalyticsEvent) {
        t11 = ()=>{
            setSelectedCategoryFilters((prev)=>{
                if (prev.has("myPrompts")) return new Set();
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "promptLibraryCategoryTab",
                    attributes: {
                        category: "myPrompts"
                    }
                });
                return new Set([
                    "myPrompts"
                ]);
            });
        };
        $[29] = sendAnalyticsEvent;
        $[30] = t11;
    } else t11 = $[30];
    const handleMyPromptsClick = t11;
    let t12;
    if ($[31] !== sendAnalyticsEvent) {
        t12 = ()=>{
            setSelectedCategoryFilters((prev_0)=>{
                if (prev_0.has("favorites")) return new Set();
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "promptLibraryCategoryTab",
                    attributes: {
                        category: "favorites"
                    }
                });
                return new Set([
                    "favorites"
                ]);
            });
        };
        $[31] = sendAnalyticsEvent;
        $[32] = t12;
    } else t12 = $[32];
    const handleFavoritesClick = t12;
    let t13;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (filters)=>{
            setSelectedUseCases(filters);
        };
        $[33] = t13;
    } else t13 = $[33];
    const handleUseCaseFilterChange = t13;
    let t14;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (filters_0)=>{
            setSelectedRoles(filters_0);
        };
        $[34] = t14;
    } else t14 = $[34];
    const handleRoleFilterChange = t14;
    let t15;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (filters_1)=>{
            setSelectedConnectors(filters_1);
        };
        $[35] = t15;
    } else t15 = $[35];
    const handleConnectorFilterChange = t15;
    let t16;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setSelectedUseCases([]);
            setSelectedRoles([]);
            setSelectedConnectors([]);
            setSelectedCategoryFilters(new Set());
        };
        $[36] = t16;
    } else t16 = $[36];
    const handleClearFilters = t16;
    let t17;
    if ($[37] !== cardsToShow || $[38] !== filteredFavoritePromptCards || $[39] !== filteredMyPromptCards || $[40] !== filteredPromptCards || $[41] !== handleFavoritesClick || $[42] !== handleMyPromptsClick || $[43] !== hasActiveFilters || $[44] !== promptCategories || $[45] !== resultCount || $[46] !== searchQuery || $[47] !== searchablePrompts || $[48] !== selectedCategory || $[49] !== selectedCategoryFilters || $[50] !== selectedConnectors || $[51] !== selectedRoles || $[52] !== selectedUseCases) {
        t17 = {
            searchQuery: searchQuery,
            selectedCategory: selectedCategory,
            selectedCategoryFilters: selectedCategoryFilters,
            selectedUseCases: selectedUseCases,
            selectedRoles: selectedRoles,
            selectedConnectors: selectedConnectors,
            searchablePrompts: searchablePrompts,
            filteredPromptCards: filteredPromptCards,
            filteredMyPromptCards: filteredMyPromptCards,
            filteredFavoritePromptCards: filteredFavoritePromptCards,
            promptCategories: promptCategories,
            cardsToShow: cardsToShow,
            resultCount: resultCount,
            hasActiveFilters: hasActiveFilters,
            handleSearchChange: handleSearchChange,
            handleMyPromptsClick: handleMyPromptsClick,
            handleFavoritesClick: handleFavoritesClick,
            handleUseCaseFilterChange: handleUseCaseFilterChange,
            handleRoleFilterChange: handleRoleFilterChange,
            handleConnectorFilterChange: handleConnectorFilterChange,
            handleClearFilters: handleClearFilters
        };
        $[37] = cardsToShow;
        $[38] = filteredFavoritePromptCards;
        $[39] = filteredMyPromptCards;
        $[40] = filteredPromptCards;
        $[41] = handleFavoritesClick;
        $[42] = handleMyPromptsClick;
        $[43] = hasActiveFilters;
        $[44] = promptCategories;
        $[45] = resultCount;
        $[46] = searchQuery;
        $[47] = searchablePrompts;
        $[48] = selectedCategory;
        $[49] = selectedCategoryFilters;
        $[50] = selectedConnectors;
        $[51] = selectedRoles;
        $[52] = selectedUseCases;
        $[53] = t17;
    } else t17 = $[53];
    return t17;
} : function usePromptLibraryFilters(promptCards, myPromptCards) {
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const [selectedUseCases, setSelectedUseCases] = (0, $cozmU.useState)([]);
    const [selectedRoles, setSelectedRoles] = (0, $cozmU.useState)([]);
    const [selectedConnectors, setSelectedConnectors] = (0, $cozmU.useState)([]);
    const [selectedCategoryFilters, setSelectedCategoryFilters] = (0, $cozmU.useState)(new Set());
    // For backward compatibility, derive selectedCategory from selectedCategoryFilters
    const selectedCategory = (0, $cozmU.useMemo)(()=>{
        if (selectedCategoryFilters.size === 0) return 'all';
        if (selectedCategoryFilters.size === 1) return selectedCategoryFilters.has('myPrompts') ? 'myPrompts' : 'favorites';
        // If both are selected, we'll show 'all' but filter the results
        return 'all';
    }, [
        selectedCategoryFilters
    ]);
    const searchablePrompts = (0, $cozmU.useMemo)(()=>promptCards.map((card)=>card.title), [
        promptCards
    ]);
    const filteredPromptCards = (0, $cozmU.useMemo)(()=>(0, $1623949d4d2d15ac$export$242a1f752c43f7ef)(promptCards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors), [
        promptCards,
        searchQuery,
        selectedUseCases,
        selectedRoles,
        selectedConnectors
    ]);
    const filteredMyPromptCards = (0, $cozmU.useMemo)(()=>(0, $1623949d4d2d15ac$export$242a1f752c43f7ef)(myPromptCards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors), [
        myPromptCards,
        searchQuery,
        selectedUseCases,
        selectedRoles,
        selectedConnectors
    ]);
    const filteredFavoritePromptCards = (0, $cozmU.useMemo)(()=>{
        const favoriteCards = promptCards.filter((card_0)=>card_0.isFavorited === true);
        return (0, $1623949d4d2d15ac$export$242a1f752c43f7ef)(favoriteCards, searchQuery, selectedUseCases, selectedRoles, selectedConnectors);
    }, [
        promptCards,
        searchQuery,
        selectedUseCases,
        selectedRoles,
        selectedConnectors
    ]);
    const promptCategories = (0, $cozmU.useMemo)(()=>({
            all: filteredPromptCards,
            myPrompts: filteredMyPromptCards,
            favorites: filteredFavoritePromptCards
        }), [
        filteredPromptCards,
        filteredMyPromptCards,
        filteredFavoritePromptCards
    ]);
    const cardsToShow = (0, $cozmU.useMemo)(()=>promptCategories[selectedCategory], [
        selectedCategory,
        promptCategories
    ]);
    const resultCount = cardsToShow.length;
    const hasActiveFilters = selectedUseCases.length > 0 || selectedRoles.length > 0 || selectedConnectors.length > 0 || selectedCategoryFilters.size > 0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleSearchChange = (0, $cozmU.useCallback)((query, _filtered)=>{
        setSearchQuery(query);
    }, []);
    const handleMyPromptsClick = (0, $cozmU.useCallback)(()=>{
        setSelectedCategoryFilters((prev)=>{
            if (prev.has('myPrompts')) return new Set();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'promptLibraryCategoryTab',
                attributes: {
                    category: 'myPrompts'
                }
            });
            return new Set([
                'myPrompts'
            ]);
        });
    }, [
        sendAnalyticsEvent
    ]);
    const handleFavoritesClick = (0, $cozmU.useCallback)(()=>{
        setSelectedCategoryFilters((prev_0)=>{
            if (prev_0.has('favorites')) return new Set();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'promptLibraryCategoryTab',
                attributes: {
                    category: 'favorites'
                }
            });
            return new Set([
                'favorites'
            ]);
        });
    }, [
        sendAnalyticsEvent
    ]);
    const handleUseCaseFilterChange = (0, $cozmU.useCallback)((filters)=>{
        setSelectedUseCases(filters);
    }, []);
    const handleRoleFilterChange = (0, $cozmU.useCallback)((filters_0)=>{
        setSelectedRoles(filters_0);
    }, []);
    const handleConnectorFilterChange = (0, $cozmU.useCallback)((filters_1)=>{
        setSelectedConnectors(filters_1);
    }, []);
    const handleClearFilters = (0, $cozmU.useCallback)(()=>{
        setSelectedUseCases([]);
        setSelectedRoles([]);
        setSelectedConnectors([]);
        setSelectedCategoryFilters(new Set());
    }, []);
    return {
        searchQuery: searchQuery,
        selectedCategory: selectedCategory,
        selectedCategoryFilters: selectedCategoryFilters,
        selectedUseCases: selectedUseCases,
        selectedRoles: selectedRoles,
        selectedConnectors: selectedConnectors,
        searchablePrompts: searchablePrompts,
        filteredPromptCards: filteredPromptCards,
        filteredMyPromptCards: filteredMyPromptCards,
        filteredFavoritePromptCards: filteredFavoritePromptCards,
        promptCategories: promptCategories,
        cardsToShow: cardsToShow,
        resultCount: resultCount,
        hasActiveFilters: hasActiveFilters,
        handleSearchChange: handleSearchChange,
        handleMyPromptsClick: handleMyPromptsClick,
        handleFavoritesClick: handleFavoritesClick,
        handleUseCaseFilterChange: handleUseCaseFilterChange,
        handleRoleFilterChange: handleRoleFilterChange,
        handleConnectorFilterChange: handleConnectorFilterChange,
        handleClearFilters: handleClearFilters
    };
};
function $410323957b9c2809$var$_temp2(card_0) {
    return card_0.isFavorited === true;
}
function $410323957b9c2809$var$_temp(card) {
    return card.title;
}
module.exports["usePromptLibraryFilters"] = $410323957b9c2809$export$e04099244c80b8e5;

});

parcelRegister("4be0A", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");

var $lU4RT = parcelRequire("lU4RT");

var $7DqNt = parcelRequire("7DqNt");


var $7sJoX = parcelRequire("7sJoX");









var $Ou0Zz = parcelRequire("Ou0Zz");


var $hXW4Y = parcelRequire("hXW4Y");

const $9c3a04b97065df32$export$7c769186c92b7c92 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoFilterStyleButton(t0, ref) {
    const $ = (0, $bDgLe.c)(11);
    let children;
    let isSelected;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isSelected: isSelected, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isSelected;
        $[3] = props;
    } else {
        children = $[1];
        isSelected = $[2];
        props = $[3];
    }
    const t1 = isSelected && $9c3a04b97065df32$var$styles.filterButtonSelected;
    let t2;
    if ($[4] !== t1) {
        t2 = (0, $w6R6I.cx)($9c3a04b97065df32$var$styles.filterButton, t1);
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            ref: ref,
            xcss: t2,
            ...props
        }, children);
        $[6] = children;
        $[7] = props;
        $[8] = ref;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function RovoFilterStyleButton({ children: children, isSelected: isSelected, ...props }, ref) {
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        ref: ref,
        xcss: (0, $w6R6I.cx)($9c3a04b97065df32$var$styles.filterButton, isSelected && $9c3a04b97065df32$var$styles.filterButtonSelected),
        ...props
    }, children);
});
const $9c3a04b97065df32$var$styles = {
    filterButton: "_2mHwu8gVvo _0bjKvDKTcp _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q8HPE _1Znuxb8HPE _0Of8r2gVvo _1wydGWgVvo _0KLXru66of _1UtDYzZpcK _1kk5Tkf7mX _0WKd3G4z3T _1eOmH6o126",
    filterButtonSelected: "_3vBAKHrzt2 _0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd",
    dropdownContainer: "_0bjKvD8fU6 _1mT5xdRAKS _4ouGXI4qGD _0NUa3rBfNa _2WAcuGIZbP",
    clearButtonContainer: "_1mT5xdWVPG _2IhTon5zaO _4ApkO25zaO",
    clearButton: "_0bjKvDKxmn _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _0Of8r21Y8M _1wydGW1Y8M _1Znuxb2ADO _2Zuz6Q2ADO _1UtDYzZpcK _0KLXru66of _0wOv4Q7zJH _0WKd3G4z3T",
    iconContainer: "_39xV0270UD _0jFU0V70UD _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    filterOption: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzZpcK"
};
const $9c3a04b97065df32$var$RovoPromptFilterDropdown = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { filterOptions: filterOptions, triggerText: triggerText, title: title, selectedFilters: t1, onFilterChange: onFilterChange, filterType: filterType, renderIcon: renderIcon } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const selectedFilters = t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t3;
    if ($[2] !== filterType || $[3] !== onFilterChange || $[4] !== selectedFilters || $[5] !== sendAnalyticsEvent) {
        t3 = (filterId)=>{
            if (!onFilterChange) return;
            const newSelectedFilters = selectedFilters.includes(filterId) ? selectedFilters.filter((id)=>id !== filterId) : [
                ...selectedFilters,
                filterId
            ];
            if (!selectedFilters.includes(filterId)) sendAnalyticsEvent({
                action: "selected",
                actionSubject: filterType,
                actionSubjectId: "promptLibraryFilter",
                attributes: {
                    filterId: filterId
                }
            });
            onFilterChange(newSelectedFilters);
        };
        $[2] = filterType;
        $[3] = onFilterChange;
        $[4] = selectedFilters;
        $[5] = sendAnalyticsEvent;
        $[6] = t3;
    } else t3 = $[6];
    const handleFilterToggle = t3;
    let t4;
    if ($[7] !== onFilterChange) {
        t4 = ()=>{
            if (!onFilterChange) return;
            onFilterChange([]);
        };
        $[7] = onFilterChange;
        $[8] = t4;
    } else t4 = $[8];
    const handleClearAll = t4;
    let t5;
    if ($[9] !== selectedFilters.length || $[10] !== triggerText) {
        t5 = (t6)=>{
            const { triggerRef: triggerRef, isSelected: isSelected, ...triggerProps } = t6;
            const isFilterSelected = isSelected || selectedFilters.length > 0;
            return /*#__PURE__*/ $cozmU.createElement($9c3a04b97065df32$export$7c769186c92b7c92, {
                ref: triggerRef,
                isSelected: isFilterSelected,
                ...triggerProps
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                as: "span",
                weight: "medium",
                color: isFilterSelected ? "color.text.selected" : "color.text.subtlest"
            }, selectedFilters.length > 0 ? `${selectedFilters.length} ${selectedFilters.length === 1 ? triggerText.toLowerCase().replace(/s$/, "") : triggerText.toLowerCase()}` : triggerText), /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small"
            })));
        };
        $[9] = selectedFilters.length;
        $[10] = triggerText;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== formatMessage) {
        t6 = formatMessage((0, $hXW4Y.messages).clearAll);
        $[12] = formatMessage;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== handleClearAll || $[15] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9c3a04b97065df32$var$styles.clearButtonContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $9c3a04b97065df32$var$styles.clearButton,
            onClick: handleClearAll,
            role: "menuitem"
        }, t6));
        $[14] = handleClearAll;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== filterOptions || $[18] !== handleFilterToggle || $[19] !== renderIcon || $[20] !== selectedFilters) {
        let t9;
        if ($[22] !== handleFilterToggle || $[23] !== renderIcon || $[24] !== selectedFilters) {
            t9 = (option)=>{
                const showIcon = renderIcon?.(option);
                return /*#__PURE__*/ $cozmU.createElement((0, $lU4RT.default), {
                    key: option.id,
                    id: option.id,
                    isSelected: selectedFilters.includes(option.id),
                    onClick: ()=>handleFilterToggle(option.id)
                }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $9c3a04b97065df32$var$styles.filterOption
                }, showIcon ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $9c3a04b97065df32$var$styles.iconContainer
                }, showIcon) : null, /*#__PURE__*/ $cozmU.createElement("span", null, option.label)));
            };
            $[22] = handleFilterToggle;
            $[23] = renderIcon;
            $[24] = selectedFilters;
            $[25] = t9;
        } else t9 = $[25];
        t8 = filterOptions.map(t9);
        $[17] = filterOptions;
        $[18] = handleFilterToggle;
        $[19] = renderIcon;
        $[20] = selectedFilters;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[26] !== t8 || $[27] !== title) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $7DqNt.default), {
            title: title,
            id: "filter-options"
        }, t8);
        $[26] = t8;
        $[27] = title;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== t7 || $[30] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9c3a04b97065df32$var$styles.dropdownContainer
        }, t7, t9);
        $[29] = t7;
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== t10 || $[33] !== t5) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
            spacing: "compact",
            shouldRenderToParent: true,
            trigger: t5
        }, t10);
        $[32] = t10;
        $[33] = t5;
        $[34] = t11;
    } else t11 = $[34];
    return t11;
} : ({ filterOptions: filterOptions, triggerText: triggerText, title: title, selectedFilters: selectedFilters = [], onFilterChange: onFilterChange, filterType: filterType, renderIcon: renderIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleFilterToggle = (filterId)=>{
        if (!onFilterChange) return;
        const newSelectedFilters = selectedFilters.includes(filterId) ? selectedFilters.filter((id)=>id !== filterId) : [
            ...selectedFilters,
            filterId
        ]; // only tracks when a filter is selected, not removed
        if (!selectedFilters.includes(filterId)) sendAnalyticsEvent({
            action: 'selected',
            actionSubject: filterType,
            actionSubjectId: 'promptLibraryFilter',
            attributes: {
                filterId: filterId
            }
        });
        onFilterChange(newSelectedFilters);
    };
    const handleClearAll = ()=>{
        if (!onFilterChange) return;
        onFilterChange([]);
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        spacing: "compact",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...triggerProps })=>{
            const isFilterSelected = isSelected || selectedFilters.length > 0;
            return /*#__PURE__*/ $cozmU.createElement($9c3a04b97065df32$export$7c769186c92b7c92, {
                ref: triggerRef,
                isSelected: isFilterSelected,
                ...triggerProps
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                as: "span",
                weight: "medium",
                color: isFilterSelected ? 'color.text.selected' : 'color.text.subtlest'
            }, selectedFilters.length > 0 ? `${selectedFilters.length} ${selectedFilters.length === 1 ? triggerText.toLowerCase().replace(/s$/, '') : triggerText.toLowerCase()}` : triggerText), /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small"
            })));
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9c3a04b97065df32$var$styles.dropdownContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9c3a04b97065df32$var$styles.clearButtonContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $9c3a04b97065df32$var$styles.clearButton,
        onClick: handleClearAll,
        role: "menuitem"
    }, formatMessage((0, $hXW4Y.messages).clearAll))), /*#__PURE__*/ $cozmU.createElement((0, $7DqNt.default), {
        title: title,
        id: "filter-options"
    }, filterOptions.map((option)=>{
        const showIcon = renderIcon?.(option);
        return /*#__PURE__*/ $cozmU.createElement((0, $lU4RT.default), {
            key: option.id,
            id: option.id,
            isSelected: selectedFilters.includes(option.id),
            onClick: ()=>handleFilterToggle(option.id)
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9c3a04b97065df32$var$styles.filterOption
        }, showIcon ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9c3a04b97065df32$var$styles.iconContainer
        }, showIcon) : null, /*#__PURE__*/ $cozmU.createElement("span", null, option.label)));
    }))));
};
var $9c3a04b97065df32$export$2e2bcd8739ae039 = $9c3a04b97065df32$var$RovoPromptFilterDropdown;






var $ZKswU = parcelRequire("ZKswU");


var $jCBG9 = parcelRequire("jCBG9");

/* PromptCardsMultiselectToolbar.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $jLnA6 = parcelRequire("jLnA6");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $iDfTs = parcelRequire("iDfTs");


var $kTb7m = parcelRequire("kTb7m");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");




var $1l0kj = parcelRequire("1l0kj");




var $5RYbF = parcelRequire("5RYbF");


var $slkWY = parcelRequire("slkWY");


var $9Wv0j = parcelRequire("9Wv0j");

const $aece07f548ffbd84$var$styles = {
    toolbar: "_2mHwu88HPE _0bjKvD8fU6 _1mT5xdy1CL _0Bm75G5zaO _3OE6xY715P _1VJPcajssS _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r22ADO _1Znuxb5zaO _1wydGW2ADO _2Zuz6Q5zaO _0KLXrulfZc _2OUyjtGk8v _42Yu6BN779",
    toolbarCount: "_0adFHs2ADO _1ANEUSLRg7"
};
const $aece07f548ffbd84$export$498786d97d606643 = /*#__PURE__*/ (0, $cozmU.memo)(({ selectedCount: selectedCount, selectedCards: selectedCards, onClearSelection: onClearSelection, onBulkFavorite: onBulkFavorite, onDeletePrompt: onDeletePrompt, onBulkDelete: onBulkDelete, onBulkShare: onBulkShare })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = (0, $cozmU.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $cozmU.useState)(false);
    const [isTogglingFavorites, setIsTogglingFavorites] = (0, $cozmU.useState)(false);
    const [isSharing, setIsSharing] = (0, $cozmU.useState)(false);
    const [showCopiedMessage, setShowCopiedMessage] = (0, $cozmU.useState)(false);
    const allFavorited = selectedCards.length > 0 && selectedCards.every((c)=>c.isFavorited);
    const anyFavorited = selectedCards.some((c_0)=>c_0.isFavorited);
    const systemPromptCount = selectedCards.filter((c_1)=>!c_1.isUserGenerated).length;
    const handleMultiFavorite = async (isFavorite)=>{
        if (!onBulkFavorite) return;
        setIsTogglingFavorites(true);
        try {
            const prompts = selectedCards.map((c)=>({
                    shareId: c.id,
                    isFavorite: isFavorite
                }));
            await onBulkFavorite(prompts, systemPromptCount);
            onClearSelection();
        } finally{
            setIsTogglingFavorites(false);
        }
    };
    const handleMultiDelete = async ()=>{
        if (!onBulkDelete && !onDeletePrompt) return;
        setIsDeleting(true);
        try {
            if (onBulkDelete) // Preferred: bulk delete and refetch in one call
            await onBulkDelete(selectedCards.map((c)=>c.id), systemPromptCount);
            else if (onDeletePrompt) // Fallback: delete one-by-one (may trigger multiple refetches)
            await Promise.all(selectedCards.map((c)=>onDeletePrompt(c.id)));
            setIsDeleteConfirmOpen(false);
            onClearSelection();
        } finally{
            setIsDeleting(false);
        }
    };
    const handleMultiShare = async ()=>{
        setIsSharing(true);
        try {
            const allPromptIds = selectedCards.map((c)=>c.id); // Only user-generated prompts need to be made public - system prompts are already public
            const userGeneratedPromptIds = selectedCards.filter((c)=>c.isUserGenerated).map((c)=>c.id); // Make user-generated prompts public if handler is provided
            if (onBulkShare && userGeneratedPromptIds.length > 0) await onBulkShare(userGeneratedPromptIds, systemPromptCount);
             // Generate and copy the share link (includes all selected prompts)
            const shareUrl = (0, $5RYbF.generateShareLink)(allPromptIds);
            await navigator.clipboard.writeText(shareUrl);
            setShowCopiedMessage(true);
            setTimeout(()=>setShowCopiedMessage(false), 2000);
        } finally{
            setIsSharing(false);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aece07f548ffbd84$var$styles.toolbar
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $aece07f548ffbd84$var$styles.toolbarCount,
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLnA6.default), {
        appearance: "neutral"
    }, selectedCount), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $9Wv0j.messages).selectedLabel))), onBulkFavorite && !allFavorited && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))),
        onClick: ()=>handleMultiFavorite(true),
        isDisabled: isTogglingFavorites
    }, formatMessage((0, $9Wv0j.messages).multiAddToFavorites)), onBulkFavorite && anyFavorited && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))),
        onClick: ()=>handleMultiFavorite(false),
        isDisabled: isTogglingFavorites
    }, formatMessage((0, $9Wv0j.messages).multiRemoveFromFavorites)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
        onClick: handleMultiShare,
        isDisabled: isSharing
    }, showCopiedMessage ? formatMessage((0, $9Wv0j.messages).linkCopied) : formatMessage((0, $9Wv0j.messages).multiShare)), (onBulkDelete || onDeletePrompt) && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onClick: ()=>setIsDeleteConfirmOpen(true),
        isDisabled: isDeleting
    }, formatMessage((0, $9Wv0j.messages).multiDelete)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            }),
        label: formatMessage((0, $9Wv0j.messages).clearSelection),
        appearance: "subtle",
        spacing: "compact",
        onClick: onClearSelection
    })), /*#__PURE__*/ $cozmU.createElement((0, $slkWY.DeleteConfirmModal), {
        title: formatMessage((0, $9Wv0j.messages).multiDeleteConfirmTitle, {
            count: selectedCount
        }),
        body: formatMessage((0, $9Wv0j.messages).multiDeleteConfirmBody, {
            count: selectedCount
        }),
        isOpen: isDeleteConfirmOpen,
        isLoading: isDeleting,
        onClose: ()=>setIsDeleteConfirmOpen(false),
        onConfirm: handleMultiDelete,
        testId: "multi-delete-prompt-confirm-modal"
    }));
});












var $hekY6 = parcelRequire("hekY6");





var $5Sv3D = parcelRequire("5Sv3D");


var $hAgam = parcelRequire("hAgam");




const $0d86e4599b4e135a$var$messages = (0, $kSwu1.defineMessages)({
    searchExamplesLabel: {
        id: "ai-mate.rovo-conversation-search-prompts.search-examples-label",
        defaultMessage: "Search examples"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-conversation-search-prompts.search-placeholder",
        defaultMessage: "Search"
    }
});
var $0d86e4599b4e135a$export$2e2bcd8739ae039 = $0d86e4599b4e135a$var$messages;


const $165deb0ff3d0f4e6$var$searchWrapperStyles = null;
const $165deb0ff3d0f4e6$var$inputStyles = null;
const $165deb0ff3d0f4e6$export$8dd3ed31ebb95943 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { prompts: prompts, onSearchChange: onSearchChange } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)("");
    let t1;
    if ($[0] !== onSearchChange || $[1] !== prompts) {
        t1 = (query)=>{
            if (!prompts) {
                onSearchChange?.(query, []);
                return;
            }
            const filtered = !query.trim() ? prompts : prompts.filter((prompt)=>prompt.toLowerCase().includes(query.toLowerCase()));
            onSearchChange?.(query, filtered);
        };
        $[0] = onSearchChange;
        $[1] = prompts;
        $[2] = t1;
    } else t1 = $[2];
    const filterPrompts = t1;
    const [debouncedFilterPrompts] = (0, $5Sv3D.default)(filterPrompts, 300);
    let t2;
    if ($[3] !== debouncedFilterPrompts) {
        t2 = (query_0)=>{
            debouncedFilterPrompts(query_0);
        };
        $[3] = debouncedFilterPrompts;
        $[4] = t2;
    } else t2 = $[4];
    const handleSearchChange = t2;
    let t3;
    let t4;
    if ($[5] !== handleSearchChange || $[6] !== searchQuery) {
        t3 = ()=>{
            handleSearchChange(searchQuery);
        };
        t4 = [
            searchQuery,
            handleSearchChange
        ];
        $[5] = handleSearchChange;
        $[6] = searchQuery;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _0bjKvD8fU6 _2V7sgO2M4S _3vBAKH9r67 _3hxITi6wH8 _39xV02sCRa _0jFU0VUofl _3138425zaO _3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS _0KLXru7Cj1 _1Znuxb2ADO _2Zuz6Q2ADO _1jJ2xknXvL"
        ]);
        t6 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: "",
            size: "medium"
        });
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== formatMessage) {
        t7 = formatMessage((0, $0d86e4599b4e135a$export$2e2bcd8739ae039).searchExamplesLabel);
        $[11] = formatMessage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== formatMessage) {
        t8 = formatMessage((0, $0d86e4599b4e135a$export$2e2bcd8739ae039).searchPlaceholder);
        $[13] = formatMessage;
        $[14] = t8;
    } else t8 = $[14];
    let t10;
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (e)=>setSearchQuery(e.currentTarget.value);
        t10 = (0, $hekY6.default)([
            "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2XsHFM2ADO _0KLXrujOvk _1UtDYzy7kJ _3AxjleKGUX"
        ]);
        $[15] = t10;
        $[16] = t9;
    } else {
        t10 = $[15];
        t9 = $[16];
    }
    let t11;
    if ($[17] !== searchQuery || $[18] !== t7 || $[19] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, t6, /*#__PURE__*/ $cozmU.createElement("input", {
            "aria-label": t7,
            placeholder: t8,
            value: searchQuery,
            onChange: t9,
            className: t10
        }));
        $[17] = searchQuery;
        $[18] = t7;
        $[19] = t8;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ prompts: prompts, onSearchChange: onSearchChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const filterPrompts = (0, $cozmU.useCallback)((query)=>{
        if (!prompts) {
            onSearchChange?.(query, []);
            return;
        }
        const filtered = !query.trim() ? prompts : prompts.filter((prompt)=>prompt.toLowerCase().includes(query.toLowerCase()));
        onSearchChange?.(query, filtered);
    }, [
        prompts,
        onSearchChange
    ]);
    const [debouncedFilterPrompts] = (0, $5Sv3D.default)(filterPrompts, 300);
    const handleSearchChange = (0, $cozmU.useCallback)((query_0)=>{
        debouncedFilterPrompts(query_0);
    }, [
        debouncedFilterPrompts
    ]);
    (0, $cozmU.useEffect)(()=>{
        handleSearchChange(searchQuery);
    }, [
        searchQuery,
        handleSearchChange
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _0bjKvD8fU6 _2V7sgO2M4S _3vBAKH9r67 _3hxITi6wH8 _39xV02sCRa _0jFU0VUofl _3138425zaO _3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS _0KLXru7Cj1 _1Znuxb2ADO _2Zuz6Q2ADO _1jJ2xknXvL"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
        label: "",
        size: "medium"
    }), /*#__PURE__*/ $cozmU.createElement("input", {
        "aria-label": formatMessage((0, $0d86e4599b4e135a$export$2e2bcd8739ae039).searchExamplesLabel),
        placeholder: formatMessage((0, $0d86e4599b4e135a$export$2e2bcd8739ae039).searchPlaceholder),
        value: searchQuery,
        onChange: (e)=>setSearchQuery(e.currentTarget.value),
        className: (0, $hekY6.default)([
            "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2XsHFM2ADO _0KLXrujOvk _1UtDYzy7kJ _3AxjleKGUX"
        ])
    }));
});



var $j4Mju = parcelRequire("j4Mju");

var $61b1587977976d05$exports = {};
$61b1587977976d05$exports = new URL("build-icon-no-prompts.73453fad.svg", import.meta.url).toString();


var $98a9b3138ddaad24$exports = {};
$98a9b3138ddaad24$exports = new URL("favorites-empty.0cc258ba.svg", import.meta.url).toString();




















var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");




const $9badb9d8bc94b318$var$styles = {
    skeletonGrid: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP28e8x _0Of8r25zaO _2Zuz6Q2ADO",
    skeletonCard: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r2kG2W _1wydGWkG2W _2Zuz6Q5zaO _1Znuxb5zaO _39xV02NvzE _0jFU0Vb1xp _24h04i2Njc _3iDTPbQ4SZ _0aFT5vbt8w",
    skeletonCardContent: "_0jFU0VN91d",
    skeletonCardIcon: "_1wydGW2ADO"
};
const $9badb9d8bc94b318$var$SKELETON_CARD_COUNT = 6;
const $9badb9d8bc94b318$var$PromptCardSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { testId: t1 } = t0;
    const testId = t1 === undefined ? "prompt-card-skeleton" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $w6R6I.cx)($9badb9d8bc94b318$var$styles.skeletonCard);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = `${testId}-icon`;
    let t4;
    if ($[1] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $9badb9d8bc94b318$var$styles.skeletonCardIcon
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "32px",
            height: "32px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true,
            testId: t3
        }));
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = `${testId}-title`;
    let t6;
    if ($[3] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "80%",
            height: "14px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true,
            testId: t5
        });
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const t7 = `${testId}-text-1`;
    let t8;
    if ($[5] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true,
            testId: t7
        });
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    const t9 = `${testId}-text-2`;
    let t10;
    if ($[7] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "70%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true,
            testId: t9
        });
        $[7] = t9;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== t10 || $[10] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t8, t10);
        $[9] = t10;
        $[10] = t8;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== t11 || $[13] !== t6) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, t11);
        $[12] = t11;
        $[13] = t6;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== t12 || $[16] !== t4) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $9badb9d8bc94b318$var$styles.skeletonCardContent
        }, t4, t12);
        $[15] = t12;
        $[16] = t4;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== t13 || $[19] !== testId) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t2,
            testId: testId,
            role: "presentation"
        }, t13);
        $[18] = t13;
        $[19] = testId;
        $[20] = t14;
    } else t14 = $[20];
    return t14;
} : ({ testId: testId = 'prompt-card-skeleton' })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($9badb9d8bc94b318$var$styles.skeletonCard),
        testId: testId,
        role: "presentation"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $9badb9d8bc94b318$var$styles.skeletonCardContent
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $9badb9d8bc94b318$var$styles.skeletonCardIcon
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true,
        testId: `${testId}-icon`
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "80%",
        height: "14px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true,
        testId: `${testId}-title`
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true,
        testId: `${testId}-text-1`
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true,
        testId: `${testId}-text-2`
    })))));
const $9badb9d8bc94b318$export$4e9e15263dd34ffa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { testId: t1 } = t0;
    const testId = t1 === undefined ? "prompt-cards-grid-skeleton" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $j4Mju.default).loadingPrompts);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = Array.from({
            length: $9badb9d8bc94b318$var$SKELETON_CARD_COUNT
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== testId) {
        t4 = t3.map((_, index)=>/*#__PURE__*/ $cozmU.createElement($9badb9d8bc94b318$var$PromptCardSkeleton, {
                key: index,
                testId: `${testId}-card-${index}`
            }));
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t2 || $[6] !== t4 || $[7] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9badb9d8bc94b318$var$styles.skeletonGrid,
            testId: testId,
            role: "status",
            "aria-busy": "true",
            "aria-label": t2
        }, t4);
        $[5] = t2;
        $[6] = t4;
        $[7] = testId;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ testId: testId = 'prompt-cards-grid-skeleton' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9badb9d8bc94b318$var$styles.skeletonGrid,
        testId: testId,
        role: "status",
        "aria-busy": "true",
        "aria-label": formatMessage((0, $j4Mju.default).loadingPrompts)
    }, Array.from({
        length: $9badb9d8bc94b318$var$SKELETON_CARD_COUNT
    }).map((_, index)=>/*#__PURE__*/ $cozmU.createElement($9badb9d8bc94b318$var$PromptCardSkeleton, {
            key: index,
            testId: `${testId}-card-${index}`
        })));
};


const $60ea1a8a9dd10d43$var$styles = {
    searchSection: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _1DCdHi5zaO _2Zuz6Q2ADO _1Znuxb2ADO",
    filterRow: "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _2Zuz6Q2ADO _1Znuxb2ADO _1DCdHi5zaO",
    filterContainer: "_2mHwu82ADO _3iDTPbQ4SZ",
    counterContainer: "_2mHwu8Va5s _3iDTPbQ4SZ _0hPCNLDIqT",
    clearFiltersButton: "_30huDKYbGa _0bjKvD8fU6 _0KLXrujOvk _0Of8r2gVvo _1ZnuxbgVvo _1wydGWgVvo _2Zuz6QgVvo _0wOv4Q7zJH _1eOmH6o126 _3gzVzLN4oS",
    emptyPromptState: "_2mHwu82ADO _4c065U2ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _2fwxA5DIqT",
    emptyPromptStateIcon: "_3iDTPbQ4SZ _37wbyuDIqT"
};
const $60ea1a8a9dd10d43$export$a8cff62c8e9679c0 = ({ searchablePrompts: searchablePrompts, onSearchChange: onSearchChange, selectedCategory: selectedCategory, selectedCategoryFilters: selectedCategoryFilters, onMyPromptsClick: onMyPromptsClick, onFavoritesClick: onFavoritesClick, showMyPromptsButton: showMyPromptsButton, showFavoritesButton: showFavoritesButton, selectedUseCases: selectedUseCases, onUseCaseFilterChange: onUseCaseFilterChange, selectedRoles: selectedRoles, onRoleFilterChange: onRoleFilterChange, resultCount: resultCount, hasActiveFilters: hasActiveFilters, onClearFilters: onClearFilters, cardsToShow: cardsToShow, onCardClick: onCardClick, onCardHover: onCardHover, onDeletePrompt: onDeletePrompt, onEditPrompt: onEditPrompt, onDuplicatePrompt: onDuplicatePrompt, onFavoriteToggle: onFavoriteToggle, onBulkFavorite: onBulkFavorite, onBulkDelete: onBulkDelete, onBulkShare: onBulkShare, onSharePrompt: onSharePrompt, assistanceServiceParams: assistanceServiceParams, skillMetadata: skillMetadata, connectorFilter: connectorFilter, renderUseCaseOptionIcon: renderUseCaseOptionIcon, onEmptyStateViewed: onEmptyStateViewed, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedCardIds, setSelectedCardIds] = (0, $cozmU.useState)(()=>new Set());
    (0, $cozmU.useEffect)(()=>{
        // Don't fire empty state analytics while loading
        if (isLoading || resultCount !== 0 || !onEmptyStateViewed) return;
        if (selectedCategory === 'favorites') onEmptyStateViewed('emptyFavorites');
        else if (selectedCategory === 'myPrompts') onEmptyStateViewed('emptyMyPrompts');
        else if (selectedCategory === 'all' && hasActiveFilters) onEmptyStateViewed('noPromptsFromFilters');
    }, [
        resultCount,
        selectedCategory,
        hasActiveFilters,
        onEmptyStateViewed,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.searchSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $165deb0ff3d0f4e6$export$8dd3ed31ebb95943), {
        prompts: searchablePrompts,
        onSearchChange: onSearchChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.filterRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.filterContainer
    }, showFavoritesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c3a04b97065df32$export$7c769186c92b7c92), {
        isSelected: selectedCategoryFilters.has('favorites'),
        onClick: onFavoritesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "medium",
        color: selectedCategoryFilters.has('favorites') ? 'color.text.selected' : 'color.text.subtlest'
    }, formatMessage((0, $j4Mju.default).favorites))), showMyPromptsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c3a04b97065df32$export$7c769186c92b7c92), {
        isSelected: selectedCategoryFilters.has('myPrompts'),
        onClick: onMyPromptsClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "medium",
        color: selectedCategoryFilters.has('myPrompts') ? 'color.text.selected' : 'color.text.subtlest'
    }, formatMessage((0, $j4Mju.default).myPrompts))), connectorFilter && connectorFilter.options.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c3a04b97065df32$export$2e2bcd8739ae039), {
        filterOptions: connectorFilter.options,
        selectedFilters: connectorFilter.selected,
        onFilterChange: connectorFilter.onChange,
        triggerText: formatMessage((0, $hXW4Y.messages).connectorsFilterTrigger),
        title: formatMessage((0, $hXW4Y.messages).connectorsFilterTitle),
        filterType: "connector",
        renderIcon: connectorFilter.renderIcon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c3a04b97065df32$export$2e2bcd8739ae039), {
        filterOptions: (0, $ZKswU.useCaseOptions),
        selectedFilters: selectedUseCases,
        onFilterChange: onUseCaseFilterChange,
        triggerText: formatMessage((0, $hXW4Y.messages).useCasesFilterTrigger),
        title: formatMessage((0, $hXW4Y.messages).useCasesFilterTitle),
        filterType: "useCase",
        renderIcon: renderUseCaseOptionIcon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c3a04b97065df32$export$2e2bcd8739ae039), {
        filterOptions: (0, $ZKswU.roleOptions),
        selectedFilters: selectedRoles,
        onFilterChange: onRoleFilterChange,
        triggerText: formatMessage((0, $hXW4Y.messages).rolesFilterTrigger),
        title: formatMessage((0, $hXW4Y.messages).rolesFilterTitle),
        filterType: "role"
    })), !(0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium"
    }, formatMessage((0, $hXW4Y.messages).resultsCount, {
        count: resultCount
    })), hasActiveFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onClearFilters,
        xcss: $60ea1a8a9dd10d43$var$styles.clearFiltersButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium"
    }, formatMessage((0, $hXW4Y.messages).clearFilters)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9badb9d8bc94b318$export$4e9e15263dd34ffa), null) : selectedCategory === 'myPrompts' && resultCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.emptyPromptState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.emptyPromptStateIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($61b1587977976d05$exports))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large",
        as: "p"
    }, formatMessage((0, $j4Mju.default).myPromptsEmptyTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        as: "p"
    }, formatMessage((0, $j4Mju.default).myPromptsEmptyDescription))) : selectedCategory === 'favorites' && resultCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.emptyPromptState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $60ea1a8a9dd10d43$var$styles.emptyPromptStateIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($98a9b3138ddaad24$exports))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large",
        as: "p"
    }, formatMessage((0, $j4Mju.default).favoritesEmptyTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        as: "p"
    }, formatMessage((0, $j4Mju.default).favoritesEmptyDescription))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jCBG9.PromptCardsGrid), {
        cards: cardsToShow,
        onCardClick: onCardClick,
        onCardHover: onCardHover,
        onDeletePrompt: onDeletePrompt,
        onEditPrompt: onEditPrompt,
        onDuplicatePrompt: onDuplicatePrompt,
        onFavoriteToggle: onFavoriteToggle,
        onSharePrompt: onSharePrompt,
        selectedCardIds: selectedCardIds,
        onSelectionChange: setSelectedCardIds,
        assistanceServiceParams: assistanceServiceParams,
        skillMetadata: skillMetadata
    }), selectedCardIds.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aece07f548ffbd84$export$498786d97d606643), {
        selectedCount: selectedCardIds.size,
        selectedCards: cardsToShow.filter((c)=>selectedCardIds.has(c.id)),
        onClearSelection: ()=>setSelectedCardIds(new Set()),
        onBulkFavorite: onBulkFavorite,
        onBulkDelete: onBulkDelete,
        onBulkShare: onBulkShare,
        onDeletePrompt: onDeletePrompt
    }))));
};
module.exports["PromptLibraryContent"] = $60ea1a8a9dd10d43$export$a8cff62c8e9679c0;

});

parcelRegister("lU4RT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $acQiA = parcelRequire("acQiA");


var $9d7Pd = parcelRequire("9d7Pd");


var $3jSHR = parcelRequire("3jSHR");


var $43dcO = parcelRequire("43dcO");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $6b3a69811500fe11$var$DropdownItemCheckbox = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, testId: testId, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[13] !== defaultSelected || $[14] !== id || $[15] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[13] = defaultSelected;
        $[14] = id;
        $[15] = isSelected;
        $[16] = t4;
    } else t4 = $[16];
    const [selected, setSelected] = (0, $43dcO.default)(t4);
    let t5;
    if ($[17] !== providedOnClick || $[18] !== setSelected) {
        t5 = (event)=>{
            setSelected($6b3a69811500fe11$var$_temp);
            providedOnClick(event);
        };
        $[17] = providedOnClick;
        $[18] = setSelected;
        $[19] = t5;
    } else t5 = $[19];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    let t6;
    if ($[20] !== selected) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        });
        $[20] = selected;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== children || $[23] !== description || $[24] !== id || $[25] !== interactionName || $[26] !== isDisabled || $[27] !== itemRef || $[28] !== onClickHandler || $[29] !== rest || $[30] !== selected || $[31] !== shouldDescriptionWrap || $[32] !== shouldTitleWrap || $[33] !== t6 || $[34] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: t6,
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest
        }, children));
        $[22] = children;
        $[23] = description;
        $[24] = id;
        $[25] = interactionName;
        $[26] = isDisabled;
        $[27] = itemRef;
        $[28] = onClickHandler;
        $[29] = rest;
        $[30] = selected;
        $[31] = shouldDescriptionWrap;
        $[32] = shouldTitleWrap;
        $[33] = t6;
        $[34] = testId;
        $[35] = t7;
    } else t7 = $[35];
    return t7;
} : ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $43dcO.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        interactionName: interactionName,
        ...rest
    }, children));
};
var $6b3a69811500fe11$export$2e2bcd8739ae039 = $6b3a69811500fe11$var$DropdownItemCheckbox;
function $6b3a69811500fe11$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $6b3a69811500fe11$export$2e2bcd8739ae039;

});

parcelRegister("3jSHR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $a8ec5e894df17170$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $a8ec5e894df17170$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            stroke: t5,
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            fillRule: "evenodd"
        }, t6, t7);
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4
        }, t8);
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
var $a8ec5e894df17170$export$2e2bcd8739ae039 = $a8ec5e894df17170$var$CheckboxIcon;
module.exports["default"] = $a8ec5e894df17170$export$2e2bcd8739ae039;

});

parcelRegister("43dcO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hR9fw = parcelRequire("hR9fw");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $e413fac5530a681e$var$useCheckboxState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isSelected: isSelected, id: id, defaultSelected: defaultSelected } = t0;
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    let t1;
    if ($[0] !== getItemState || $[1] !== groupId || $[2] !== id) {
        t1 = getItemState(groupId, id);
        $[0] = getItemState;
        $[1] = groupId;
        $[2] = id;
        $[3] = t1;
    } else t1 = $[3];
    const persistedIsSelected = t1;
    let t2;
    if ($[4] !== defaultSelected || $[5] !== persistedIsSelected) {
        t2 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[4] = defaultSelected;
        $[5] = persistedIsSelected;
        $[6] = t2;
    } else t2 = $[6];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[7] !== groupId || $[8] !== id || $[9] !== persistedIsSelected || $[10] !== setItemState) {
        t3 = (newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        };
        $[7] = groupId;
        $[8] = id;
        $[9] = persistedIsSelected;
        $[10] = setItemState;
        $[11] = t3;
    } else t3 = $[11];
    const setLocalState = t3;
    if (typeof isSelected === "boolean") {
        let t4;
        if ($[12] !== isSelected) {
            t4 = [
                isSelected,
                $e413fac5530a681e$var$_temp
            ];
            $[12] = isSelected;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
    let t4;
    if ($[14] !== localIsSelected || $[15] !== setLocalState) {
        t4 = [
            localIsSelected,
            setLocalState
        ];
        $[14] = localIsSelected;
        $[15] = setLocalState;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $e413fac5530a681e$export$2e2bcd8739ae039 = $e413fac5530a681e$var$useCheckboxState;
function $e413fac5530a681e$var$_temp() {
    return false;
}
module.exports["default"] = $e413fac5530a681e$export$2e2bcd8739ae039;

});

parcelRegister("hR9fw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c7ae6da6a8b76651$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $cozmU.createContext)('');
module.exports["CheckboxGroupContext"] = $c7ae6da6a8b76651$export$baf37c4be89255b8;

});

parcelRegister("7DqNt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");


var $hR9fw = parcelRequire("hR9fw");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = rest;
        $[18] = t1;
        $[19] = t2;
        $[20] = testId;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== id || $[23] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
            value: id
        }, t3);
        $[22] = id;
        $[23] = t3;
        $[24] = t4;
    } else t4 = $[24];
    return t4;
} : ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
        id: titleId,
        title: title
    }), children));
};
var $1b4057c4abe15cf7$export$2e2bcd8739ae039 = $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup;
module.exports["default"] = $1b4057c4abe15cf7$export$2e2bcd8739ae039;

});

parcelRegister("hXW4Y", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $89f93ed388a3a304$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    discoverMoreExamples: {
        id: "rovo-conversation-actions.examples.discover-more-examples",
        defaultMessage: "Discover more examples"
    },
    useCasesFilterTrigger: {
        id: "rovo-conversation-actions.filters.use-cases-trigger",
        defaultMessage: "Use cases"
    },
    useCasesFilterTitle: {
        id: "rovo-conversation-actions.filters.use-cases-title",
        defaultMessage: "Filter by use cases"
    },
    rolesFilterTrigger: {
        id: "rovo-conversation-actions.filters.roles-trigger",
        defaultMessage: "Roles"
    },
    rolesFilterTitle: {
        id: "rovo-conversation-actions.filters.roles-title",
        defaultMessage: "Filter by roles"
    },
    connectorsFilterTrigger: {
        id: "rovo-conversation-actions.filters.connectors-trigger",
        defaultMessage: "Connectors"
    },
    connectorsFilterTitle: {
        id: "rovo-conversation-actions.filters.connectors-title",
        defaultMessage: "Filter by connectors"
    },
    resultsCount: {
        id: "rovo-conversation-actions.results.count",
        defaultMessage: "{count, plural, one {# result} other {# results}}"
    },
    clearFilters: {
        id: "rovo-conversation-actions.filters.clear-filters",
        defaultMessage: "Clear filters"
    },
    clearAll: {
        id: "rovo-conversation-actions.filters.clear-all",
        defaultMessage: "Clear all"
    },
    openDropdown: {
        id: "rovo-conversation-actions.filters.open-dropdown",
        defaultMessage: "Open dropdown"
    }
});
module.exports["messages"] = $89f93ed388a3a304$export$defe85febe8b728c;

});

parcelRegister("40PcG", function(module, exports) {

let $2ebee17b84ba8fd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ebee17b84ba8fd3$var$load("k867s").then(()=>parcelRequire('7Uyqq'));

});

parcelRegister("bg8wx", function(module, exports) {
const $cc237ecfd088ad6e$export$22bef1c9a10acb97 = (previousGroup, nextGroup)=>previousGroup !== undefined && (previousGroup === nextGroup || previousGroup.length === nextGroup.length && previousGroup.every((previousMessage, index)=>Object.is(previousMessage, nextGroup[index])));
module.exports["areMessageGroupsEqual"] = $cc237ecfd088ad6e$export$22bef1c9a10acb97;

});

parcelRegister("fhR3q", function(module, exports) {
// When auto scrolling to the bottom of the page,
// if the last message group height is not reduced by this amount, the message bubble will be cut off by the header
const $900cd33abce42b7e$var$SCROLL_TO_VIEW_MARGIN = 16;
const $900cd33abce42b7e$export$9dc469fe11356d04 = (containerHeight)=>containerHeight - $900cd33abce42b7e$var$SCROLL_TO_VIEW_MARGIN;
module.exports["getLastMessageGroupMinHeight"] = $900cd33abce42b7e$export$9dc469fe11356d04;

});

parcelRegister("cCZyl", function(module, exports) {
const $40555c3e09b08a0e$export$cb0402a867e1f6cc = (previousVersion, nextVersion)=>{
    if (Object.is(previousVersion, nextVersion)) return true;
    if (!Array.isArray(previousVersion) || !Array.isArray(nextVersion)) return false;
    if (previousVersion.length !== nextVersion.length) return false;
    return previousVersion.every((previousField, index)=>Object.is(previousField, nextVersion[index]));
};
module.exports["areRenderVersionsEqual"] = $40555c3e09b08a0e$export$cb0402a867e1f6cc;

});

parcelRegister("a0EA0", function(module, exports) {

let $749961c4318f1dd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $749961c4318f1dd5$var$load("huRm3"),
    $749961c4318f1dd5$var$load("ffzod")
]).then(()=>parcelRequire('7hbfg'));

});

parcelRegister("eHdk6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jPaq9 = parcelRequire("jPaq9");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $eMlr8 = parcelRequire("eMlr8");

const $4ac3a0d17fe5065f$export$668058776bea98f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const analyticsPropertiesRef = (0, $cozmU.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $cozmU.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPaq9.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref
    }, followUpText);
});
module.exports["FollowUpButton"] = $4ac3a0d17fe5065f$export$668058776bea98f5;

});

parcelRegister("1PVOM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $jTt8P = parcelRequire("jTt8P");


var $1sCHt = parcelRequire("1sCHt");


var $eNbr2 = parcelRequire("eNbr2");


var $cXtTj = parcelRequire("cXtTj");


var $6YkHb = parcelRequire("6YkHb");


var $i1t43 = parcelRequire("i1t43");


var $5HApy = parcelRequire("5HApy");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lRkXe = parcelRequire("lRkXe");


var $91ZZN = parcelRequire("91ZZN");


var $3BY7M = parcelRequire("3BY7M");


var $l8wPz = parcelRequire("l8wPz");


var $eW61a = parcelRequire("eW61a");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $iDdTC = parcelRequire("iDdTC");


var $6rwn6 = parcelRequire("6rwn6");


var $kUcLs = parcelRequire("kUcLs");


var $6Bfyn = parcelRequire("6Bfyn");


var $1rNZu = parcelRequire("1rNZu");


var $8lhhf = parcelRequire("8lhhf");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $cu0n9 = parcelRequire("cu0n9");


var $6KgI8 = parcelRequire("6KgI8");


var $60Vy9 = parcelRequire("60Vy9");


var $kleFv = parcelRequire("kleFv");


var $kjEqQ = parcelRequire("kjEqQ");


var $e859c = parcelRequire("e859c");


var $5TXhv = parcelRequire("5TXhv");


var $7fxzU = parcelRequire("7fxzU");


var $b6fxF = parcelRequire("b6fxF");


var $1zWvS = parcelRequire("1zWvS");


var $fJ1pJ = parcelRequire("fJ1pJ");


var $4PnFr = parcelRequire("4PnFr");


var $ahHdE = parcelRequire("ahHdE");


var $6LXy2 = parcelRequire("6LXy2");


var $d1gG3 = parcelRequire("d1gG3");


var $1sL4Z = parcelRequire("1sL4Z");


var $fX67d = parcelRequire("fX67d");

const $825d903ce689badf$var$EmbedCardWithFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { url: url, onResolutionError: onResolutionError } = t0;
    let t1;
    if ($[0] !== onResolutionError || $[1] !== url) {
        t1 = (errorInfo)=>{
            onResolutionError?.(url, errorInfo);
        };
        $[0] = onResolutionError;
        $[1] = url;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== url) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: url ?? "",
                target: "_blank"
            }, url);
        $[3] = url;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2 || $[7] !== url) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "embed",
            frameStyle: "show",
            url: url,
            onError: t1,
            fallbackComponent: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = url;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ url: url, onResolutionError: onResolutionError })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "embed",
        frameStyle: "show",
        url: url,
        onError: (errorInfo)=>{
            onResolutionError?.(url, errorInfo);
        },
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: url ?? '',
                target: "_blank"
            }, url)
    });
}; // Lazy load ReactMarkdown for expandable markdown support

const $825d903ce689badf$var$LazyReactMarkdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("039lM")));

const $825d903ce689badf$var$VisualizationChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("aDu0N")).then((module)=>({
            default: module.VisualizationChart
        }))); //Styles overrides for content renderer
/* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-important-styles */ const $825d903ce689badf$var$stylesOverrides = {
    inverse: "_0vhDZie5R3 _1Xvi27y7kJ _16qBg1y7kJ _0vdJdxy7kJ _3xZrLyy7kJ _0rqgY4e5R3 _2QX4Jhe5R3 _2Bk1i1e5R3 _3X1qK0e5R3 _1DhNaxe5R3 _3msR0ie5R3 _4EDCxRB4sa _3KVM6HB4sa _2U1a1AB4sa _0aOfuBB4sa _1qgxRky7kJ _1Ussjby7kJ _0toGL9y7kJ _1FGHn2y7kJ _1FX3rr28sy _4gEIQu28sy _1rt6gXxCOs _05xvKixCOs _2rL4HSB4sa _20OLHde5R3 _0QUBAG46BV _2cDd6d46BV",
    inverseDarkMode: "_1Xvi27POUv _0vdJdxPOUv _3xZrLyPOUv _1qgxRkt28M _1Ussjbt28M _0rqgY4y7kJ _2QX4Jhy7kJ",
    subtlestText: "_0vhDZiKGUX",
    boldText: "_4lGPO5dRv1 _1oz4kjdRv1 _1Ntd73dRv1 _335YaHdRv1 _0mlj5ZdRv1 _3KSF9adRv1 _2OHxifdRv1 _33LYttdRv1 _3IE6WmdRv1"
}; /* eslint-enable */ 
const $825d903ce689badf$var$skillsStyles = {
    container: "_3iDTPbccYA"
};
const $825d903ce689badf$var$timeToRenderMessageContent = (0, $iDdTC.metrics).interaction({
    key: 'ai-mate.time-to-render-message-content'
});
const $825d903ce689badf$var$DataSculptorButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { text: text, formatMessage: formatMessage, getOnViewAnalysisClick: getOnViewAnalysisClick } = t0;
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $fX67d.default).viewCodeButtonLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== getOnViewAnalysisClick || $[3] !== text) {
        t2 = getOnViewAnalysisClick?.(parseInt(text.at(-1) ?? "0", 10));
        $[2] = getOnViewAnalysisClick;
        $[3] = text;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $825d903ce689badf$var$_temp,
            label: t1,
            isTooltipDisabled: false,
            appearance: "subtle",
            spacing: "compact",
            onClick: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ localId: localId, text: text, formatMessage: formatMessage, getOnViewAnalysisClick: getOnViewAnalysisClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                ...iconProps,
                color: "var(--ds-icon-brand, #1868DB)"
            }),
        label: formatMessage((0, $fX67d.default).viewCodeButtonLabel),
        isTooltipDisabled: false,
        appearance: "subtle",
        spacing: "compact",
        onClick: getOnViewAnalysisClick?.(parseInt(text.at(-1) ?? '0', 10))
    });
});
const $825d903ce689badf$var$hideCodeBlockLineNumbers = (document)=>{
    const transformedDocument = (0, $jTt8P.traverse)(document, {
        codeBlock: (node)=>({
                ...node,
                attrs: {
                    ...node.attrs,
                    hideLineNumbers: true
                }
            })
    });
    return transformedDocument === false ? document : transformedDocument;
};
const $825d903ce689badf$var$ExpandableContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { localId: localId, formatMessage: formatMessage, expandDataContent: expandDataContent, tempIsThirdPartyAgent: tempIsThirdPartyAgent } = t0;
    let t1;
    if ($[0] !== expandDataContent || $[1] !== formatMessage || $[2] !== localId || $[3] !== tempIsThirdPartyAgent) {
        const { header: header, content: content } = $825d903ce689badf$var$splitHeaderAndContent(expandDataContent);
        const shouldRenderEnhancedMarkdown = !!tempIsThirdPartyAgent;
        const renderBody = ()=>{
            if (shouldRenderEnhancedMarkdown) {
                const document = (0, $6rwn6.encodeAdf)(content, true);
                const shouldHideCodeBlockLineNumbers = (0, $cXtTj.default).getExperimentValue("jira_ai_expandable_hide_line_num_code_block", "isEnabled", false);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
                    document: shouldHideCodeBlockLineNumbers ? $825d903ce689badf$var$hideCodeBlockLineNumbers(document) : document,
                    allowCopyToClipboard: true,
                    allowWrapCodeBlock: (0, $cXtTj.default).getExperimentValue("jira_ai_agent_code_markdown_wrappable", "isEnabled", false) || undefined
                });
            }
            if ((0, $iDrrr.fg)("rovo-chat-expandable-markdown-support")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-markdown-suspense",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $fX67d.default).loadingMarkdownMessage))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$LazyReactMarkdown, null, content));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
        };
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cu0n9.DashboardInsightsExpandable), {
            title: header,
            defaultExpanded: false,
            testId: localId
        }, renderBody());
        $[0] = expandDataContent;
        $[1] = formatMessage;
        $[2] = localId;
        $[3] = tempIsThirdPartyAgent;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ localId: localId, formatMessage: formatMessage, expandDataContent: expandDataContent, tempIsThirdPartyAgent: tempIsThirdPartyAgent })=>{
    const { header: header, content: content } = $825d903ce689badf$var$splitHeaderAndContent(expandDataContent);
    const shouldRenderEnhancedMarkdown = !!tempIsThirdPartyAgent;
    const renderBody = ()=>{
        if (shouldRenderEnhancedMarkdown) {
            const document = (0, $6rwn6.encodeAdf)(content, true);
            const shouldHideCodeBlockLineNumbers = (0, $cXtTj.default).getExperimentValue('jira_ai_expandable_hide_line_num_code_block', 'isEnabled', false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
                document: shouldHideCodeBlockLineNumbers ? $825d903ce689badf$var$hideCodeBlockLineNumbers(document) : document,
                allowCopyToClipboard: true,
                allowWrapCodeBlock: (0, $cXtTj.default).getExperimentValue('jira_ai_agent_code_markdown_wrappable', 'isEnabled', false) || undefined
            });
        }
        if ((0, $iDrrr.fg)('rovo-chat-expandable-markdown-support')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "conversation-assistant-content-renderer-markdown-suspense",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $fX67d.default).loadingMarkdownMessage))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$LazyReactMarkdown, null, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cu0n9.DashboardInsightsExpandable), {
        title: header,
        defaultExpanded: false,
        testId: localId
    }, renderBody());
});
const $825d903ce689badf$var$ChartContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { localId: localId, formatMessage: formatMessage, isChartLoading: isChartLoading, chartConfigJson: chartConfigJson, messageId: messageId, siteId: siteId } = t0;
    if ((0, $iDrrr.fg)("rovo_chat_enable_updated_chart_loading")) {
        let t1;
        if ($[0] !== formatMessage) {
            t1 = formatMessage((0, $fX67d.default).loadingChartMessage);
            $[0] = formatMessage;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] !== isChartLoading || $[5] !== localId || $[6] !== messageId || $[7] !== siteId) {
            t3 = {
                isChartLoading: isChartLoading,
                testId: localId,
                messageId: messageId,
                cloudId: siteId
            };
            $[4] = isChartLoading;
            $[5] = localId;
            $[6] = messageId;
            $[7] = siteId;
            $[8] = t3;
        } else t3 = $[8];
        let t4;
        if ($[9] !== chartConfigJson || $[10] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kleFv.WidgetWrapper), {
                jsonStream: chartConfigJson,
                component: $825d903ce689badf$var$VisualizationChart,
                propSchema: (0, $kjEqQ.VISUALIZATION_CHART_PROP_SCHEMA),
                extraProps: t3
            });
            $[9] = chartConfigJson;
            $[10] = t3;
            $[11] = t4;
        } else t4 = $[11];
        let t5;
        if ($[12] !== t2 || $[13] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-chart-suspense",
                fallback: t2
            }, t4);
            $[12] = t2;
            $[13] = t4;
            $[14] = t5;
        } else t5 = $[14];
        return t5;
    }
    if (isChartLoading || chartConfigJson === "{}") {
        let t1;
        if ($[15] !== localId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60Vy9.ChartLoader), {
                testId: localId,
                interactionName: "rovo-viz-chart-loader"
            });
            $[15] = localId;
            $[16] = t1;
        } else t1 = $[16];
        return t1;
    }
    try {
        let t1;
        if ($[17] !== chartConfigJson) {
            t1 = JSON.parse(chartConfigJson);
            $[17] = chartConfigJson;
            $[18] = t1;
        } else t1 = $[18];
        const chartConfig = t1;
        let t2;
        if ($[19] !== formatMessage) {
            t2 = formatMessage((0, $fX67d.default).loadingChartMessage);
            $[19] = formatMessage;
            $[20] = t2;
        } else t2 = $[20];
        let t3;
        if ($[21] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t2);
            $[21] = t2;
            $[22] = t3;
        } else t3 = $[22];
        let t4;
        if ($[23] !== chartConfig || $[24] !== localId || $[25] !== messageId || $[26] !== siteId) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$VisualizationChart, {
                ...chartConfig,
                testId: localId,
                messageId: messageId,
                cloudId: siteId
            });
            $[23] = chartConfig;
            $[24] = localId;
            $[25] = messageId;
            $[26] = siteId;
            $[27] = t4;
        } else t4 = $[27];
        let t5;
        if ($[28] !== t3 || $[29] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-chart-suspense",
                fallback: t3
            }, t4);
            $[28] = t3;
            $[29] = t4;
            $[30] = t5;
        } else t5 = $[30];
        return t5;
    } catch  {
        let t1;
        if ($[31] !== localId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6KgI8.ChartError), {
                testId: localId
            });
            $[31] = localId;
            $[32] = t1;
        } else t1 = $[32];
        return t1;
    }
} : ({ localId: localId, formatMessage: formatMessage, isChartLoading: isChartLoading, chartConfigJson: chartConfigJson, messageId: messageId, siteId: siteId })=>{
    if ((0, $iDrrr.fg)('rovo_chat_enable_updated_chart_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-content-renderer-chart-suspense",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $fX67d.default).loadingChartMessage))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kleFv.WidgetWrapper), {
        jsonStream: chartConfigJson,
        component: $825d903ce689badf$var$VisualizationChart,
        propSchema: (0, $kjEqQ.VISUALIZATION_CHART_PROP_SCHEMA),
        extraProps: {
            isChartLoading: isChartLoading,
            testId: localId,
            messageId: messageId,
            cloudId: siteId
        }
    }));
    if (isChartLoading || chartConfigJson === '{}') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60Vy9.ChartLoader), {
        testId: localId,
        interactionName: "rovo-viz-chart-loader"
    });
    try {
        const chartConfig = JSON.parse(chartConfigJson);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "conversation-assistant-content-renderer-chart-suspense",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $fX67d.default).loadingChartMessage))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$VisualizationChart, {
            ...chartConfig,
            testId: localId,
            messageId: messageId,
            cloudId: siteId
        }));
    } catch  {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6KgI8.ChartError), {
            testId: localId
        });
    }
});
const $825d903ce689badf$var$InlineLuminaContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { luminaContent: luminaContent, cloudId: cloudId, orgId: orgId, requestingUserId: requestingUserId, sourceProduct: sourceProduct, messageId: messageId, onInteraction: onInteraction } = t0;
    if (luminaContent) {
        const t1 = `<lumina>${luminaContent}</lumina>`;
        let t2;
        if ($[0] !== cloudId || $[1] !== messageId || $[2] !== onInteraction || $[3] !== orgId || $[4] !== requestingUserId || $[5] !== sourceProduct || $[6] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-lumina-suspense",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$LuminaLayout, {
                luminaTagResponse: t1,
                source: "luminaRovoChatSidebar",
                cloudId: cloudId,
                orgId: orgId,
                requestingUserId: requestingUserId,
                sourceProduct: sourceProduct,
                sessionId: messageId,
                onInteraction: onInteraction,
                smartLinkRenderer: "embed"
            })));
            $[0] = cloudId;
            $[1] = messageId;
            $[2] = onInteraction;
            $[3] = orgId;
            $[4] = requestingUserId;
            $[5] = sourceProduct;
            $[6] = t1;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    return null;
} : ({ luminaContent: luminaContent, cloudId: cloudId, orgId: orgId, requestingUserId: requestingUserId, sourceProduct: sourceProduct, messageId: messageId, onInteraction: onInteraction })=>{
    if (luminaContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-content-renderer-lumina-suspense",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$LuminaLayout, {
        luminaTagResponse: `<lumina>${luminaContent}</lumina>`,
        source: "luminaRovoChatSidebar",
        cloudId: cloudId,
        orgId: orgId,
        requestingUserId: requestingUserId,
        sourceProduct: sourceProduct,
        sessionId: messageId,
        onInteraction: onInteraction,
        smartLinkRenderer: "embed"
    })));
    return null;
});
const $825d903ce689badf$var$InteractiveFollowUpQuestions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ segments: segments, onFollowUpClick: onFollowUpClick })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatActionableFollowUps'
        });
    }, [
        sendAnalyticsEvent
    ]);
    if (segments.length === 0) return null;
     // The `stacked` experiment cohort normally returns questions with no surrounding
    // prose. Production responses can also include a lead-in followed by newline-
    // separated questions; those must use the same vertical layout so wrapped labels
    // stay aligned with their text rather than returning beneath the arrow icon.
    // True inline responses interleave sentence prose between questions.
    const hasProse = segments.some((segment)=>segment.type === 'text');
    const firstSegment = segments[0];
    const isLineSeparatedList = firstSegment?.type === 'text' && /\r?\n\s*$/.test(firstSegment.value) && segments.slice(1).every((segment_0)=>segment_0.type === 'question' || segment_0.value.trim() === '');
    if (!hasProse || isLineSeparatedList) {
        const leadIn = isLineSeparatedList ? firstSegment.value.trim() : '';
        const questions = segments.filter((segment_1)=>segment_1.type === 'question');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, leadIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, leadIn), questions.map((segment_2, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e859c.ActionableFollowUpLink), {
                key: index,
                testId: `actionable-follow-up-link-${index}`,
                ariaLabel: segment_2.value,
                onClick: ()=>onFollowUpClick?.(segment_2.value)
            }, segment_2.value)));
    }
    let questionIndex = 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, segments.map((segment_3, index_0)=>{
        if (segment_3.type === 'text') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: index_0
        }, segment_3.value);
        const linkIndex = questionIndex++;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e859c.ActionableFollowUpLink), {
            key: index_0,
            appearance: "inline",
            testId: `actionable-follow-up-link-${linkIndex}`,
            ariaLabel: segment_3.value,
            onClick: ()=>onFollowUpClick?.(segment_3.value)
        }, segment_3.value);
    }));
});
const $825d903ce689badf$var$FollowUpQuestions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { segments: segments, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode } = t0;
    if (interactionMode === "read-only") return null;
    let t1;
    if ($[0] !== onFollowUpClick || $[1] !== segments) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$InteractiveFollowUpQuestions, {
            segments: segments,
            onFollowUpClick: onFollowUpClick
        });
        $[0] = onFollowUpClick;
        $[1] = segments;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ segments: segments, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode })=>{
    if (interactionMode === 'read-only') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$InteractiveFollowUpQuestions, {
        segments: segments,
        onFollowUpClick: onFollowUpClick
    });
};
const $825d903ce689badf$var$MemoizedEmbedCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { url: url, sendAnalyticsEvent: sendAnalyticsEvent, conversationId: conversationId, messageId: messageId } = t0;
    let t1;
    if ($[0] !== conversationId || $[1] !== messageId || $[2] !== sendAnalyticsEvent) {
        t1 = (failedUrl, errorInfo)=>{
            sendAnalyticsEvent({
                action: "failed",
                actionSubject: "embedCard",
                actionSubjectId: "urlResolution",
                attributes: {
                    url: failedUrl,
                    status: errorInfo?.status,
                    errorMessage: errorInfo?.err?.message,
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        };
        $[0] = conversationId;
        $[1] = messageId;
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1 || $[5] !== url) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$EmbedCardWithFallback, {
            url: url,
            onResolutionError: t1
        });
        $[4] = t1;
        $[5] = url;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ url: url, sendAnalyticsEvent: sendAnalyticsEvent, conversationId: conversationId, messageId: messageId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$EmbedCardWithFallback, {
        url: url,
        onResolutionError: (failedUrl, errorInfo)=>{
            sendAnalyticsEvent({
                action: 'failed',
                actionSubject: 'embedCard',
                actionSubjectId: 'urlResolution',
                attributes: {
                    url: failedUrl,
                    status: errorInfo?.status,
                    errorMessage: errorInfo?.err?.message,
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        }
    });
});
function $825d903ce689badf$var$renderStatusComponent(props, formatMessage, getOnViewAnalysisClick, onCitationClick, markdownData, messageId, siteId, orgId, aaid, sourceProduct, tempIsThirdPartyAgent, onFollowUpClick, interactionMode, // Streaming-gated id used ONLY for the inline lumina path (undefined while
// streaming). Kept separate from `messageId` so other status components (e.g.
// charts) are unaffected by the gating.
luminaMessageId, onLuminaInteraction) {
    if (props.localId.startsWith('data-sculptor-')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$DataSculptorButton, {
        localId: props.localId,
        text: props.text,
        formatMessage: formatMessage,
        getOnViewAnalysisClick: getOnViewAnalysisClick
    });
    if (props.localId.startsWith('expandable-')) {
        const expandId = (0, $iDrrr.fg)('rovo_chat_fix_status_localid_lookup') ? props.localId.replace('expandable-', 'expand-') : `expand-${props.text.at(-1)}`;
        const expandDataContent = markdownData?.[expandId] ?? '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$ExpandableContent, {
            localId: props.localId,
            formatMessage: formatMessage,
            expandDataContent: expandDataContent,
            tempIsThirdPartyAgent: tempIsThirdPartyAgent
        });
    }
    if (props.localId.startsWith('chart-')) {
        const chartId = (0, $iDrrr.fg)('rovo_chat_fix_status_localid_lookup') ? props.localId : `chart-${props.text.at(-1)}`;
        const isChartLoading = markdownData?.[`${chartId}-loading`] === 'true';
        const chartConfigJson = markdownData?.[chartId] ?? '{}';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$ChartContent, {
            localId: props.localId,
            formatMessage: formatMessage,
            isChartLoading: isChartLoading,
            chartConfigJson: chartConfigJson,
            messageId: messageId,
            siteId: siteId
        });
    }
    if ((0, $1rNZu.isInlineLuminaStatus)(props.localId) && (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) {
        const luminaIndex = parseInt(props.text.replace('inline-lumina-', ''), 10);
        const luminaContent = markdownData?.[`lumina-${luminaIndex}`] ?? '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$InlineLuminaContent, {
            luminaContent: luminaContent,
            cloudId: siteId,
            orgId: orgId,
            requestingUserId: aaid,
            sourceProduct: sourceProduct,
            messageId: luminaMessageId,
            onInteraction: onLuminaInteraction
        });
    }
    if ((0, $6Bfyn.isActionableFollowUpsStatus)(props.localId)) {
        const followUpsPayload = markdownData?.[props.localId] ?? ''; // Parse the payload into ordered prose/question segments so the surrounding
        // text renders as normal stream text and each question renders as an inline
        // clickable link in place.
        const segments = (0, $6Bfyn.parseActionableFollowUps)(followUpsPayload);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$FollowUpQuestions, {
            segments: segments,
            onFollowUpClick: onFollowUpClick,
            interactionMode: interactionMode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6LXy2.StatusCitation), {
        ...props,
        onClick: onCitationClick
    });
}
const $825d903ce689badf$var$InlineExtension = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { content: content, extensionType: extensionType, extensionKey: extensionKey, parameters: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const parameters = t2;
    if (extensionType && extensionKey && (0, $8lhhf.isSkillTagExtension)(extensionType, extensionKey) && parameters?.slug) {
        let t3;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                margin: "1px 1px var(--ds-space-050, 4px)"
            };
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] !== parameters) {
            t4 = JSON.stringify(parameters);
            $[3] = parameters;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = parameters;
        let t6;
        if ($[5] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
                invertColors: true,
                ...t5
            });
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== t4 || $[8] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $825d903ce689badf$var$skillsStyles.container,
                style: t3,
                "data-extension-type": (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                "data-extension-key": (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                "data-parameters": t4
            }, t6);
            $[7] = t4;
            $[8] = t6;
            $[9] = t7;
        } else t7 = $[9];
        return t7;
    }
    return content;
} : ({ content: content, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters = {} })=>{
    if (extensionType && extensionKey && (0, $8lhhf.isSkillTagExtension)(extensionType, extensionKey) && parameters?.slug) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $825d903ce689badf$var$skillsStyles.container,
        style: {
            margin: `1px 1px ${"var(--ds-space-050, 4px)"}`
        },
        "data-extension-type": (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        "data-extension-key": (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
        "data-parameters": JSON.stringify(parameters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
        invertColors: true,
        ...parameters
    }));
    return content;
};
const $825d903ce689badf$var$PassthroughExtension = ({ content: content })=>content;

const $825d903ce689badf$var$LuminaLayout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("6Wp5G")).then((mod)=>({
            default: mod.LuminaLayout
        }))); /**
       * This Renderer is intended to support the full set of markdown which we have
       * added support to our markdown transformers for.
       *
       * It is not currently lazy loaded -- we may want to do this in future to allow
       * products to have smaller bundles for Edit views. This was not needed at time
       * of writing, as the only view mode on confluence, which already includes the Renderer
       * in its initial js load.
       */ 
/**
 * Check if a URL is an authentication redirect URL that requires special handling
 * Auth URLs need to open without 'noopener' to allow OAuth callback communication
 */ const $825d903ce689badf$var$isAuthRedirectUrl = (url)=>{
    const isForgeAuth = (url.startsWith('https://id.stg.internal.atlassian.com/login') || url.startsWith('https://id.atlassian.com/login')) && url.includes('outboundAuth%2Fstart');
    const is3pAuth = url.startsWith('https://id.stg.internal.atlassian.com/outboundAuth') || url.startsWith('https://id.atlassian.com/outboundAuth');
    return {
        isForgeAuth: isForgeAuth,
        is3pAuth: is3pAuth
    };
};
function $825d903ce689badf$export$7ca2a6ac46c008fc({ content: content, onContentSelected: onContentSelected, onContentCopied: onContentCopied, lightweightEncoding: lightweightEncoding = false, onResponseLinkClick: onResponseLinkClick, onSmartCardClick: onSmartCardClick, onCodeBlockCopied: onCodeBlockCopied, allowDownloadCodeBlock: allowDownloadCodeBlock = false, onCitationClick: onCitationClick, onAuthLinkClick: onAuthLinkClick, getOnViewAnalysisClick: getOnViewAnalysisClick, onDeepLinkClick: onDeepLinkClick, markdownData: markdownData, smallerFont: smallerFont = false, largerFont: largerFont = false, boldText: boldText = false, subtlestText: subtlestText = false, productKey: productKey, orgId: orgId, siteId: siteId, aaid: aaid, conversationId: conversationId, theme: theme = 'default', messageId: messageId, contentStillStreaming: contentStillStreaming, shouldOverrideCardAsInline: shouldOverrideCardAsInline = false, isExperimentEnabled: isExperimentEnabled, adfTransformer: adfTransformer, sendLinkCountMetric: sendLinkCountMetric, extensionComponent: Extension = $825d903ce689badf$var$PassthroughExtension, xpcWrapUrl: xpcWrapUrl, tempIsThirdPartyAgent: tempIsThirdPartyAgent, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode, onLuminaInteraction: onLuminaInteraction, respondedAgentId: respondedAgentId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const currentValuesRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({
        formatMessage: formatMessage,
        getOnViewAnalysisClick: getOnViewAnalysisClick,
        onCitationClick: onCitationClick,
        markdownData: markdownData,
        onFollowUpClick: onFollowUpClick,
        interactionMode: interactionMode
    }); // CRCS-5217: refresh synchronously during render so StatusComponentMemoized
    // reads this render's markdownData, not the prior commit's snapshot.
    if ((0, $iDrrr.fg)('rovo_chat_fix_status_component_stale_markdowndata')) currentValuesRef.current = {
        formatMessage: formatMessage,
        getOnViewAnalysisClick: getOnViewAnalysisClick,
        onCitationClick: onCitationClick,
        markdownData: markdownData,
        onFollowUpClick: onFollowUpClick,
        interactionMode: interactionMode
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if ((0, $iDrrr.fg)('rovo_chat_fix_status_component_stale_markdowndata')) return;
        currentValuesRef.current = {
            formatMessage: formatMessage,
            getOnViewAnalysisClick: getOnViewAnalysisClick,
            onCitationClick: onCitationClick,
            markdownData: markdownData,
            onFollowUpClick: onFollowUpClick,
            interactionMode: interactionMode
        };
    }, [
        formatMessage,
        getOnViewAnalysisClick,
        onCitationClick,
        markdownData,
        onFollowUpClick,
        interactionMode
    ]); // The messageId is only stable/final once streaming completes: while streaming,
    // the assistant message is held under a temporary id and only swapped to the
    // final `message.message.id` on the final response. The inline lumina analytics
    // join on this id against the "extracted" event which always uses the final id,
    // so we must not surface the temporary id there.
    const luminaMessageId = contentStillStreaming ? undefined : messageId; // Without this, components in StatusComponent will mount/unmount on every new stream part
    // which makes them non-interactable and causes charts to flicker due to animation on mount
    const StatusComponentMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return (props)=>{
            const { formatMessage: formatMessage, getOnViewAnalysisClick: getOnViewAnalysisClick, onCitationClick: onCitationClick, markdownData: markdownData, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode } = currentValuesRef.current;
            return $825d903ce689badf$var$renderStatusComponent(props, formatMessage, getOnViewAnalysisClick, onCitationClick, markdownData, messageId, siteId, orgId ?? '', aaid ?? '', productKey, tempIsThirdPartyAgent, onFollowUpClick, interactionMode, luminaMessageId, onLuminaInteraction);
        };
    }, [
        messageId,
        luminaMessageId,
        siteId,
        orgId,
        aaid,
        productKey,
        tempIsThirdPartyAgent,
        onLuminaInteraction
    ]);
    const globalTheme = (0, $IQ4Dz.default)();
    const isDarkMode = globalTheme.colorMode === 'dark';
    const { value: mentionResourceOverride } = (0, $fJ1pJ.useRovoMentionProvider)();
    const { value: profilecardResourceOverride } = (0, $4PnFr.useRovoProfilecardProvider)();
    const userProfileHref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((userId)=>(0, $eW61a.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            },
            cloudId: siteId
        }).href, [
        siteId
    ]);
    const rendererRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null); // Single ref object to track streaming render times for averaging
    const streamingDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({
        renderStartTime: null,
        metricStartTime: null,
        contentStreamed: false,
        runningAvgRenderTime: 0,
        renderCount: 0,
        lastContent: null
    });
    if (streamingDataRef.current.lastContent !== content) {
        // For streaming content, track start time for individual renders
        const contentRenderStartTime = performance.now();
        streamingDataRef.current.renderStartTime = contentRenderStartTime;
        streamingDataRef.current.lastContent = content; // if it did not stream before at all or the metric has not started yet, start a new metric log
        if (!streamingDataRef.current.contentStreamed || streamingDataRef.current.metricStartTime == null) {
            streamingDataRef.current.metricStartTime = contentRenderStartTime;
            $825d903ce689badf$var$timeToRenderMessageContent.start({
                startTime: contentRenderStartTime
            });
        }
        if (contentStillStreaming) streamingDataRef.current.contentStreamed = contentStillStreaming;
    } // TODO: THIS MUST BE CORRECTED!
    // Strictly temporary fix to ensure citations are clickable once they appear for the user
    // Sources are only available after the final response, and even though onCitationClick changes
    // when this updates, the PureComponent of ReactRenderer does not re-render since none of its props have changed
    // This solution will get the job done for now to satisfy stakeholders, but we should improve it ASAP
    const [rendererKey, setRendererKey] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        setRendererKey(rendererKey + 1);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lightweightEncoding,
        xpcWrapUrl
    ]); // Hack for custom font sizes for the renderer
    // https://www.figma.com/design/rikAa0DTMVNjS5Ud1IuIAi/Deep-research?node-id=174-33296&t=0YpJzbIMBkAuiyt3-0
    // Standard font size is 14px; smallerFont uses 0.75rem (12px), largerFont uses 1rem (16px)
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (rendererRef.current) {
            if (smallerFont) rendererRef.current.style.fontSize = '0.75rem';
            else if (largerFont) rendererRef.current.style.fontSize = '1rem';
        }
    }, [
        rendererRef,
        smallerFont,
        largerFont,
        rendererKey
    ]);
    const mentionResource = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>Promise.resolve(mentionResourceOverride || new (0, $7fxzU.default)({
            productKey: productKey,
            siteId: siteId,
            includeTeams: true,
            includeUsers: true,
            shouldHighlightMention (mention) {
                return mention.id === aaid;
            }
        })), [
        productKey,
        siteId,
        aaid,
        mentionResourceOverride
    ]);
    const profileCardProvider = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>Promise.resolve(profilecardResourceOverride || {
            cloudId: siteId,
            resourceClient: new (0, $lRkXe.default)({
                url: '/gateway/api/directory/graphql',
                cloudId: siteId,
                productIdentifier: productKey
            }),
            getActions: (id)=>[
                    {
                        label: formatMessage((0, $fX67d.default).profileCardViewProfileButton),
                        id: 'view-profile',
                        callback: ()=>window.open((0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? userProfileHref(id) : `/people/${id}`, '_blank', 'noopener, noreferrer')
                    }
                ],
            ...(0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false) ? {
                renderUserMentionCard: ({ userId: userId, cloudId: cloudId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                        userId: userId,
                        cloudId: cloudId,
                        orgId: orgId ?? '',
                        viewerId: aaid ?? ''
                    }, children)
            } : {}
        }), [
        siteId,
        productKey,
        formatMessage,
        profilecardResourceOverride,
        userProfileHref,
        orgId,
        aaid
    ]);
    const dataProviders = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $eNbr2.default).create({
            mentionProvider: mentionResource,
            profilecardProvider: profileCardProvider
        }), [
        mentionResource,
        profileCardProvider
    ]);
    const handleSelection = ()=>{
        const selection = window.getSelection();
        if (onContentSelected && selection?.toString()) onContentSelected();
    };
    const handleRenderComplete = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((stat)=>{
        const { renderStartTime: renderStartTime, lastContent: lastContent } = streamingDataRef.current; // Only process render completion if we have a valid start time and content matches
        // This handles race conditions where new content arrives before previous render completes
        if (renderStartTime === null || lastContent !== content || streamingDataRef.current.metricStartTime === null) return;
        const renderTime = performance.now() - renderStartTime;
        if (contentStillStreaming) {
            // For streaming content, update running average
            streamingDataRef.current.renderCount++; // Calculate running average: new_avg = old_avg + (new_value - old_avg) / count
            streamingDataRef.current.runningAvgRenderTime = streamingDataRef.current.runningAvgRenderTime + (renderTime - streamingDataRef.current.runningAvgRenderTime) / streamingDataRef.current.renderCount; // Don't emit metric yet, wait for streaming to complete
        } else {
            if (streamingDataRef.current.contentStreamed) {
                // Streaming has completed, include final render time and emit metric
                streamingDataRef.current.renderCount++;
                streamingDataRef.current.runningAvgRenderTime = streamingDataRef.current.runningAvgRenderTime + (renderTime - streamingDataRef.current.runningAvgRenderTime) / streamingDataRef.current.renderCount;
                $825d903ce689badf$var$timeToRenderMessageContent.stop({
                    customData: {
                        ...stat,
                        renderTime: streamingDataRef.current.runningAvgRenderTime,
                        totalStreamingUpdates: streamingDataRef.current.renderCount
                    },
                    // ovverride to have the avg render time across all render cycles instead the actual render time per render cycle
                    stopTime: streamingDataRef.current.metricStartTime + streamingDataRef.current.runningAvgRenderTime
                });
            } else // Non-streaming content, emit metric normally
            $825d903ce689badf$var$timeToRenderMessageContent.stop({
                customData: {
                    ...stat,
                    totalStreamingUpdates: 0
                }
            });
             // Reset streaming state
            streamingDataRef.current.renderStartTime = null;
            streamingDataRef.current.metricStartTime = null;
            streamingDataRef.current.runningAvgRenderTime = 0;
            streamingDataRef.current.renderCount = 0;
            streamingDataRef.current.contentStreamed = false;
        }
    }, [
        contentStillStreaming,
        content
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        (async ()=>{
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            await (0, $kUcLs.hydrateLinkingPlatformCache)(localStorage);
        })();
    }, []); // Inline extension component that handles skill tags (via InlineExtension) and delegates
    // all other types to extensionComponent. This allows consumers to render custom inline
    // extensions (e.g. redaction scribbles) by providing an extensionComponent prop.
    const DelegatingInlineExtension = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ content: content, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters = {} })=>{
        if (extensionType && extensionKey && (0, $8lhhf.isSkillTagExtension)(extensionType, extensionKey) && parameters?.slug) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$InlineExtension, {
            content: content,
            extensionType: extensionType,
            extensionKey: extensionKey,
            parameters: parameters
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Extension, {
            content: content,
            extensionType: extensionType,
            extensionKey: extensionKey,
            parameters: parameters
        });
    }, [
        Extension
    ]); // See https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3523842928/Output+formatting+support+openai+-+editor+content
    // for content we support transforming from markdown returned by OpenAI into editor content.
    const docContent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const adf = (0, $6rwn6.encodeAdf)(content, lightweightEncoding, isExperimentEnabled, shouldOverrideCardAsInline, undefined, xpcWrapUrl); // Apply optional ADF transformer if provided
        return adfTransformer ? adfTransformer(adf) : adf;
    }, [
        content,
        lightweightEncoding,
        isExperimentEnabled,
        shouldOverrideCardAsInline,
        adfTransformer,
        xpcWrapUrl
    ]);
    const disabledAgentMentionTooltip = respondedAgentId ? formatMessage((0, $fX67d.default).disabledAgentMentionTooltip) : '';
    const linkCountMetricSentRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false); // Track if we ever saw the message streaming - if not, it's a historical message
    const wasEverStreamingRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(contentStillStreaming);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        // Update tracking if we see streaming state
        if (contentStillStreaming) wasEverStreamingRef.current = true;
    }, [
        contentStillStreaming
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        // Only send the metric once when streaming is complete AND the message was actually streamed
        // (not loaded from history where contentStillStreaming was always false)
        if (!contentStillStreaming && !linkCountMetricSentRef.current && sendLinkCountMetric && wasEverStreamingRef.current) {
            linkCountMetricSentRef.current = true;
            sendLinkCountMetric(true, docContent);
        }
    }, [
        contentStillStreaming,
        docContent,
        sendLinkCountMetric
    ]);
    const onSetLinkTargetCallback = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((url)=>(0, $1zWvS.handleOnSetLinkTarget)(url, productKey), [
        productKey
    ]);
    const nodeComponents = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            // Node override for `status` to enable citation clicks and data sculptor
            status: StatusComponentMemoized,
            inlineExtension: DelegatingInlineExtension,
            extension: Extension,
            embedCard: ({ url: url, _layout: _layout = 'center' } = {})=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($825d903ce689badf$var$MemoizedEmbedCard, {
                    url: url,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    conversationId: conversationId,
                    messageId: messageId
                });
            },
            // MentionNodeComponent is a stable module-level component, so the `mention`
            // override keeps a constant type across renders (no per-mention remount).
            ...respondedAgentId ? {
                mention: (0, $d1gG3.MentionNodeComponent)
            } : {}
        }), [
        StatusComponentMemoized,
        DelegatingInlineExtension,
        Extension,
        sendAnalyticsEvent,
        conversationId,
        messageId,
        respondedAgentId
    ]);
    const onClickCapture = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (!onCodeBlockCopied) return;
         /**
       * This is a hack to find out if codeblock inside renderer is clicked
       * We find up to 3 parents level up whether the clicked element is the code block copy button
       * Renderer does not support custom event handlers for code block copy button
       * (in https://atlassian.slack.com/archives/CFG3PSQ9E/p1717651112836979?thread_ts=1717648170.958499&cid=CFG3PSQ9E)
       * and AnalyticsContext doesn't work for this use case too
       */ 
        let targetElement = event.target;
        for(let i = 0; i < 3; i++){
            if (!targetElement) return;
            if (targetElement.classList.contains('copy-to-clipboard')) {
                onCodeBlockCopied?.();
                return;
            }
            targetElement = targetElement?.parentElement;
        }
    }, [
        onCodeBlockCopied
    ]);
    const rendererContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)(subtlestText && $825d903ce689badf$var$stylesOverrides.subtlestText, boldText && $825d903ce689badf$var$stylesOverrides.boldText, theme === 'inverse' && $825d903ce689badf$var$stylesOverrides.inverse, theme === 'inverse' && isDarkMode && $825d903ce689badf$var$stylesOverrides.inverseDarkMode),
        onMouseUp: handleSelection,
        onCopy: onContentCopied,
        onClickCapture: onClickCapture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        innerRef: rendererRef,
        key: rendererKey,
        onComplete: handleRenderComplete,
        document: docContent,
        media: {
            // We don't currently support images with captions
            allowLinking: false
        },
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        onSetLinkTarget: onSetLinkTargetCallback,
        dataProviders: dataProviders,
        nodeComponents: nodeComponents,
        eventHandlers: {
            smartCard: {
                onClick: (event, url)=>{
                    onSmartCardClick && onSmartCardClick();
                    event.preventDefault();
                    if (!url) return;
                    const redirectUrl = (0, $ahHdE.transformIfConfluenceLink)(url, true); // Check if it's an auth redirect URL
                    // This is a URL returned when forge app returned with `USER_CONSENT_REQUIRED`
                    // https://product-fabric.atlassian.net/browse/ROVOFE-11
                    const { isForgeAuth: isForgeAuthRedirect, is3pAuth: is3pAuthRedirect } = $825d903ce689badf$var$isAuthRedirectUrl(redirectUrl); // Forge newly opened window need access to `window.opener` to communicate back to this window
                    if (isForgeAuthRedirect || is3pAuthRedirect) {
                        onAuthLinkClick?.(redirectUrl, is3pAuthRedirect ? '3p' : 'forge');
                        window.open(redirectUrl, '_blank');
                    } else if ((0, $1zWvS.shouldHandleDeepLink)({
                        url: redirectUrl,
                        onDeepLinkClick: onDeepLinkClick
                    })) (0, $1zWvS.handleDeepLink)({
                        url: redirectUrl,
                        productKey: productKey,
                        onDeepLinkClick: onDeepLinkClick,
                        conversationId: conversationId
                    });
                    else window.open(redirectUrl, '_blank', 'noopener, noreferrer');
                }
            },
            link: {
                onClick: (event, url)=>{
                    onResponseLinkClick && onResponseLinkClick();
                    event.preventDefault();
                    if (!url) return;
                    const redirectUrl = (0, $ahHdE.transformIfConfluenceLink)(url, true); // This is a URL returned when forge app returned with `USER_CONSENT_REQUIRED`
                    // https://product-fabric.atlassian.net/browse/ROVOFE-11
                    const { isForgeAuth: isForgeAuthRedirect, is3pAuth: is3pAuthRedirect } = $825d903ce689badf$var$isAuthRedirectUrl(redirectUrl); // Forge newly opened window need access to `window.opener` to communicate back to this window
                    if (isForgeAuthRedirect || is3pAuthRedirect) {
                        onAuthLinkClick?.(redirectUrl, is3pAuthRedirect ? '3p' : 'forge');
                        window.open(redirectUrl, '_blank');
                    } else if ((0, $1zWvS.shouldHandleDeepLink)({
                        url: redirectUrl,
                        onDeepLinkClick: onDeepLinkClick
                    })) (0, $1zWvS.handleDeepLink)({
                        url: redirectUrl,
                        productKey: productKey,
                        onDeepLinkClick: onDeepLinkClick,
                        conversationId: conversationId
                    });
                    else window.open(redirectUrl, '_blank', 'noopener, noreferrer');
                }
            }
        }
    }));
    if (respondedAgentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sL4Z.MentionNodeComponentProvider), {
        respondedAgentId: respondedAgentId,
        disabledTooltip: disabledAgentMentionTooltip
    }, rendererContent);
    return rendererContent;
}
// Assumes expandData header and content are separated by a newline
function $825d903ce689badf$var$splitHeaderAndContent(expandData) {
    const [header, ...rest] = expandData.split(/\r?\n/);
    return {
        header: header,
        content: rest.join('\n')
    };
}
function $825d903ce689badf$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
        ...iconProps,
        color: "var(--ds-icon-brand, #1868DB)"
    });
}
module.exports["ContentRenderer"] = $825d903ce689badf$export$7ca2a6ac46c008fc;

});

parcelRegister("lRkXe", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1376e6c2d430db7$export$2e2bcd8739ae039);


var $5hJlu = parcelRequire("5hJlu");



var $e1376e6c2d430db7$export$2e2bcd8739ae039 = (0, $5hJlu.default);

});

parcelRegister("goaLH", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

class $796bf3f876369ae9$export$2e2bcd8739ae039 {
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
    constructor(config){
        this.config = void 0;
        this.cache = void 0;
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $lPEt0.LRUMap)(this.config.cacheSize);
    }
}
module.exports["default"] = $796bf3f876369ae9$export$2e2bcd8739ae039;

});

parcelRegister("cu0n9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iODl6 = parcelRequire("iODl6");

var $57p4j = parcelRequire("57p4j");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $5MgjO = parcelRequire("5MgjO");

const $f384350f3f69b3c0$var$contentStyles = {
    base: "_3138421Y8M",
    expandAtStart: "_2XsHFM1Y8M _2Zuz6QVa5s",
    expandAtEnd: "_0adFHs1Y8M _1ZnuxbVa5s"
}; /**
    * A reusable expandable section component that can be used to show/hide content.
    */ 
const $f384350f3f69b3c0$export$9bdf0fe6d422bd97 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { children: children, title: title, defaultExpanded: t1, showExpandAtEnd: t2, titleFontWeight: t3, onExpandChanged: onExpandChanged, testId: t4 } = t0;
    const defaultExpanded = t1 === undefined ? false : t1;
    const showExpandAtEnd = t2 === undefined ? false : t2;
    const titleFontWeight = t3 === undefined ? "medium" : t3;
    const testId = t4 === undefined ? "expandable-section" : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    let t5;
    let t6;
    if ($[0] !== defaultExpanded) {
        t5 = ()=>{
            setIsExpanded(defaultExpanded);
        };
        t6 = [
            defaultExpanded
        ];
        $[0] = defaultExpanded;
        $[1] = t5;
        $[2] = t6;
    } else {
        t5 = $[1];
        t6 = $[2];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[3] !== onExpandChanged) {
        t7 = (value)=>{
            setIsExpanded(value);
            onExpandChanged?.(value);
        };
        $[3] = onExpandChanged;
        $[4] = t7;
    } else t7 = $[4];
    const setIsExpandedValue = t7;
    const t8 = showExpandAtEnd ? "space-between" : undefined;
    let t9;
    if ($[5] !== formatMessage || $[6] !== isExpanded || $[7] !== setIsExpandedValue || $[8] !== showExpandAtEnd) {
        t9 = !showExpandAtEnd && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    size: "small"
                }),
            label: isExpanded ? formatMessage((0, $5MgjO.default).collapse) : formatMessage((0, $5MgjO.default).expand),
            onClick: ()=>setIsExpandedValue(!isExpanded)
        });
        $[5] = formatMessage;
        $[6] = isExpanded;
        $[7] = setIsExpandedValue;
        $[8] = showExpandAtEnd;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== title || $[11] !== titleFontWeight) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: titleFontWeight
        }, title);
        $[10] = title;
        $[11] = titleFontWeight;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== formatMessage || $[14] !== isExpanded || $[15] !== setIsExpandedValue || $[16] !== showExpandAtEnd) {
        t11 = showExpandAtEnd && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: isExpanded ? formatMessage((0, $5MgjO.default).collapse) : formatMessage((0, $5MgjO.default).expand),
            onClick: ()=>setIsExpandedValue(!isExpanded)
        });
        $[13] = formatMessage;
        $[14] = isExpanded;
        $[15] = setIsExpandedValue;
        $[16] = showExpandAtEnd;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== t10 || $[19] !== t11 || $[20] !== t8 || $[21] !== t9) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            spread: t8,
            alignBlock: "center",
            space: "space.050"
        }, t9, t10, t11);
        $[18] = t10;
        $[19] = t11;
        $[20] = t8;
        $[21] = t9;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== children || $[24] !== isExpanded || $[25] !== showExpandAtEnd) {
        t13 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: "top",
            exitDirection: "top",
            duration: "medium"
        }, (motionProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...motionProps,
                className: (0, $hekY6.default)([
                    $f384350f3f69b3c0$var$contentStyles.base,
                    showExpandAtEnd && $f384350f3f69b3c0$var$contentStyles.expandAtEnd,
                    !showExpandAtEnd && $f384350f3f69b3c0$var$contentStyles.expandAtStart
                ])
            }, children));
        $[23] = children;
        $[24] = isExpanded;
        $[25] = showExpandAtEnd;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, t13);
        $[27] = t13;
        $[28] = t14;
    } else t14 = $[28];
    let t15;
    if ($[29] !== isExpanded || $[30] !== t12 || $[31] !== t14 || $[32] !== testId) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            "data-expanded": isExpanded,
            testId: testId
        }, t12, t14);
        $[29] = isExpanded;
        $[30] = t12;
        $[31] = t14;
        $[32] = testId;
        $[33] = t15;
    } else t15 = $[33];
    return t15;
} : ({ children: children, title: title, defaultExpanded: defaultExpanded = false, showExpandAtEnd: showExpandAtEnd = false, titleFontWeight: titleFontWeight = 'medium', onExpandChanged: onExpandChanged, testId: testId = 'expandable-section' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    (0, $cozmU.useEffect)(()=>{
        setIsExpanded(defaultExpanded);
    }, [
        defaultExpanded
    ]);
    const setIsExpandedValue = (0, $cozmU.useCallback)((value)=>{
        setIsExpanded(value);
        onExpandChanged?.(value);
    }, [
        setIsExpanded,
        onExpandChanged
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "data-expanded": isExpanded,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: showExpandAtEnd ? 'space-between' : undefined,
        alignBlock: "center",
        space: "space.050"
    }, !showExpandAtEnd && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: isExpanded ? formatMessage((0, $5MgjO.default).collapse) : formatMessage((0, $5MgjO.default).expand),
        onClick: ()=>setIsExpandedValue(!isExpanded)
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: titleFontWeight
    }, title), showExpandAtEnd && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_0,
                size: "small"
            }),
        label: isExpanded ? formatMessage((0, $5MgjO.default).collapse) : formatMessage((0, $5MgjO.default).expand),
        onClick: ()=>setIsExpandedValue(!isExpanded)
    })), /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: "top",
        exitDirection: "top",
        duration: "medium"
    }, (motionProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
            ...motionProps,
            className: (0, $hekY6.default)([
                $f384350f3f69b3c0$var$contentStyles.base,
                showExpandAtEnd && $f384350f3f69b3c0$var$contentStyles.expandAtEnd,
                !showExpandAtEnd && $f384350f3f69b3c0$var$contentStyles.expandAtStart
            ])
        }, children))));
};
module.exports["DashboardInsightsExpandable"] = $f384350f3f69b3c0$export$9bdf0fe6d422bd97;

});

parcelRegister("5MgjO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4feee99ceda10ece$var$message = (0, $kSwu1.defineMessages)({
    expand: {
        id: "ai-mate.common.ui.expandable-section.expand",
        defaultMessage: "Expand"
    },
    collapse: {
        id: "ai-mate.common.ui.expandable-section.collapse",
        defaultMessage: "Collapse"
    }
});
var $4feee99ceda10ece$export$2e2bcd8739ae039 = $4feee99ceda10ece$var$message;
module.exports["default"] = $4feee99ceda10ece$export$2e2bcd8739ae039;

});

parcelRegister("6KgI8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $8Cx51 = parcelRequire("8Cx51");

const $a9d13291406ee723$var$chartErrorStyles = {
    errorContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruDMqu"
};
const $a9d13291406ee723$export$3ed05a3e77da7dd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { testId: testId, errorType: t1, chartType: chartType, supportedTypes: supportedTypes } = t0;
    const errorType = t1 === undefined ? "general" : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== testId) {
        t2 = testId ? {
            testId: `${testId}-error`
        } : {};
        $[0] = testId;
        $[1] = t2;
    } else t2 = $[1];
    const containerProps = t2;
    const isUnsupportedError = errorType === "unsupported" && chartType !== undefined && supportedTypes;
    let t3;
    if ($[2] !== chartType || $[3] !== intl || $[4] !== isUnsupportedError) {
        t3 = isUnsupportedError ? intl.formatMessage((0, $8Cx51.default).unsupportedChartType, {
            chartType: chartType
        }) : intl.formatMessage((0, $8Cx51.default).chartRenderError);
        $[2] = chartType;
        $[3] = intl;
        $[4] = isUnsupportedError;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.danger"
        }, t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== intl || $[9] !== isUnsupportedError || $[10] !== supportedTypes) {
        t5 = isUnsupportedError ? intl.formatMessage((0, $8Cx51.default).supportedChartTypes, {
            supportedTypes: supportedTypes.join(", ")
        }) : intl.formatMessage((0, $8Cx51.default).chartRenderErrorDetails);
        $[8] = intl;
        $[9] = isUnsupportedError;
        $[10] = supportedTypes;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, t5);
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t4 || $[15] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t4, t6);
        $[14] = t4;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== containerProps || $[18] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $a9d13291406ee723$var$chartErrorStyles.errorContainer,
            ...containerProps
        }, t7);
        $[17] = containerProps;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ testId: testId, errorType: errorType = 'general', chartType: chartType, supportedTypes: supportedTypes })=>{
    const intl = (0, $kSwu1.useIntl)();
    const containerProps = testId ? {
        testId: `${testId}-error`
    } : {};
    const isUnsupportedError = errorType === 'unsupported' && chartType !== undefined && supportedTypes;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a9d13291406ee723$var$chartErrorStyles.errorContainer,
        ...containerProps
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, isUnsupportedError ? intl.formatMessage((0, $8Cx51.default).unsupportedChartType, {
        chartType: chartType
    }) : intl.formatMessage((0, $8Cx51.default).chartRenderError))), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, isUnsupportedError ? intl.formatMessage((0, $8Cx51.default).supportedChartTypes, {
        supportedTypes: supportedTypes.join(', ')
    }) : intl.formatMessage((0, $8Cx51.default).chartRenderErrorDetails))));
};
var $a9d13291406ee723$export$2e2bcd8739ae039 = $a9d13291406ee723$export$3ed05a3e77da7dd4;
module.exports["ChartError"] = $a9d13291406ee723$export$3ed05a3e77da7dd4;

});

parcelRegister("8Cx51", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b88e54eae085cca7$var$message = (0, $kSwu1.defineMessages)({
    unsupportedChartType: {
        id: "ai-mate.common.ui.chart-error.unsupported-chart-type",
        defaultMessage: "Unsupported Chart Type: \"{chartType}\""
    },
    supportedChartTypes: {
        id: "ai-mate.common.ui.chart-error.supported-chart-types",
        defaultMessage: "Supported types: {supportedTypes}"
    },
    chartRenderError: {
        id: "ai-mate.common.ui.chart-error.render-error",
        defaultMessage: "Failed to render chart"
    },
    chartRenderErrorDetails: {
        id: "ai-mate.common.ui.chart-error.render-error-details",
        defaultMessage: "An unexpected error occurred while rendering the chart."
    }
});
var $b88e54eae085cca7$export$2e2bcd8739ae039 = $b88e54eae085cca7$var$message;
module.exports["default"] = $b88e54eae085cca7$export$2e2bcd8739ae039;

});

parcelRegister("60Vy9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $b8pma = parcelRequire("b8pma");


var $a9aSv = parcelRequire("a9aSv");

const $c0167fd1487b0235$var$chartLoaderStyles = {
    skeletonContainer: "_2mHwu88HPE _39xV02N91d _0jFU0VN91d _4kiQYAgZxp _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _3iDTPbQ4SZ _0aFT5vbt8w",
    barsContainer: "_2mHwu82ADO _2O5Vij7dHp _4kiQYAdnbC _0jFU0VdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS"
};
const $c0167fd1487b0235$export$aecc90cb5fb24e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== testId) {
        t1 = testId ? {
            testId: `${testId}-loading`
        } : {};
        $[0] = testId;
        $[1] = t1;
    } else t1 = $[1];
    const containerProps = t1;
    const ufoName = interactionName || "rovo-viz-chart-bundle-load";
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "55%",
            height: "16px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "35%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c0167fd1487b0235$var$chartLoaderStyles.barsContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "15%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "40%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "60%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "35%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "80%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "50%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "25%",
            isShimmering: true,
            borderRadius: "var(--ds-radius-small, 4px)"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== containerProps) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c0167fd1487b0235$var$chartLoaderStyles.skeletonContainer,
            ...containerProps
        }, t2, t3);
        $[4] = containerProps;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t4 || $[7] !== ufoName) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $b8pma.default), {
            name: ufoName
        }, t4);
        $[6] = t4;
        $[7] = ufoName;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ testId: testId, interactionName: interactionName })=>{
    const containerProps = testId ? {
        testId: `${testId}-loading`
    } : {};
    const ufoName = interactionName || 'rovo-viz-chart-bundle-load';
    return /*#__PURE__*/ $cozmU.createElement((0, $b8pma.default), {
        name: ufoName
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c0167fd1487b0235$var$chartLoaderStyles.skeletonContainer,
        ...containerProps
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "55%",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "35%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c0167fd1487b0235$var$chartLoaderStyles.barsContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "15%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "40%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "60%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "35%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "80%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "50%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "25%",
        isShimmering: true,
        borderRadius: "var(--ds-radius-small, 4px)"
    }))));
};
var $c0167fd1487b0235$export$2e2bcd8739ae039 = $c0167fd1487b0235$export$aecc90cb5fb24e56;
module.exports["ChartLoader"] = $c0167fd1487b0235$export$aecc90cb5fb24e56;

});

parcelRegister("kleFv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

/**
 * Extracts the raw text of a JSON value that begins at `startIndex` inside `json`.
 * Returns `null` when the value hasn't started yet.
 * Returns `{ raw, complete }` where `complete` is true when the closing delimiter has arrived.
 *
 * Works for strings, numbers, booleans, null, objects and arrays.
 */ function $fb4c9c7303fde485$var$extractJsonValue(json, startIndex) {
    if (startIndex >= json.length) return null;
    const ch = json[startIndex];
    if (ch === '"') {
        // String value — scan for the unescaped closing quote.
        let i = startIndex + 1;
        while(i < json.length){
            if (json[i] === '\\') {
                i += 2; // skip escaped character
                continue;
            }
            if (json[i] === '"') return {
                raw: json.slice(startIndex, i + 1),
                complete: true
            };
            i++;
        }
        // Closing quote not yet received — partial string.
        return {
            raw: json.slice(startIndex),
            complete: false
        };
    }
    if (ch === '[' || ch === '{') {
        // Object or array — track nesting depth.
        let depth = 0;
        let inString = false;
        let i = startIndex;
        while(i < json.length){
            const c = json[i];
            if (inString) {
                if (c === '\\') {
                    i += 2;
                    continue;
                }
                if (c === '"') inString = false;
            } else {
                if (c === '"') inString = true;
                else if (c === '[' || c === '{') depth++;
                else if (c === ']' || c === '}') {
                    depth--;
                    if (depth === 0) return {
                        raw: json.slice(startIndex, i + 1),
                        complete: true
                    };
                }
            }
            i++;
        }
        return {
            raw: json.slice(startIndex),
            complete: false
        };
    }
    // Number, boolean, null — only complete once followed by a structural
    // delimiter (optionally after whitespace). End-of-input alone is not enough
    // for streaming because a trailing `42` may still become `421` in the next
    // chunk.
    const match = json.slice(startIndex).match(/^(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?|true|false|null)/);
    if (match) {
        const end = startIndex + match[0].length;
        let i = end;
        while(i < json.length && (json[i] === ' ' || json[i] === '\t' || json[i] === '\n'))i++;
        const after = json[i];
        const complete = after === ',' || after === '}' || after === ']';
        return {
            raw: match[0],
            complete: complete
        };
    }
    return null;
}
/**
 * Finds the index in `json` where the value for `key` starts.
 * Returns -1 if the key hasn't appeared yet.
 */ function $fb4c9c7303fde485$var$findKeyValueStart(json, key) {
    const keyPattern = `"${key}"`;
    let searchFrom = 0;
    while(searchFrom < json.length){
        const keyIdx = json.indexOf(keyPattern, searchFrom);
        if (keyIdx === -1) return -1;
        // Skip past key + optional whitespace + colon + optional whitespace.
        let i = keyIdx + keyPattern.length;
        while(i < json.length && (json[i] === ' ' || json[i] === '\t' || json[i] === '\n'))i++;
        if (json[i] === ':') {
            i++;
            while(i < json.length && (json[i] === ' ' || json[i] === '\t' || json[i] === '\n'))i++;
            return i;
        }
        searchFrom = keyIdx + 1;
    }
    return -1;
}
/**
 * Extracts fully-received elements from a streaming JSON array.
 * E.g. `[{"x":1},{"x":2}` → returns `[{"x":1},{"x":2}]` if both are complete.
 * An unclosed trailing element is dropped.
 */ function $fb4c9c7303fde485$var$extractCompleteArrayItems(arrayRaw) {
    // arrayRaw may be complete or partial (missing closing `]`).
    if (!arrayRaw.startsWith('[')) return null;
    const items = [];
    let i = 1; // skip opening `[`
    while(i < arrayRaw.length){
        // Skip whitespace and commas between elements.
        while(i < arrayRaw.length && (arrayRaw[i] === ',' || arrayRaw[i] === ' ' || arrayRaw[i] === '\n' || arrayRaw[i] === '\t'))i++;
        if (i >= arrayRaw.length || arrayRaw[i] === ']') break;
        const result = $fb4c9c7303fde485$var$extractJsonValue(arrayRaw, i);
        if (!result) break;
        if (!result.complete) break;
        try {
            items.push(JSON.parse(result.raw));
        } catch  {
            break;
        }
        i += result.raw.length;
    }
    return items;
}
/**
 * Decodes JSON string escape sequences from a possibly-partial string body.
 *
 * This intentionally tolerates incomplete trailing escapes so streamed text can
 * continue rendering as characters arrive.
 */ function $fb4c9c7303fde485$var$decodePartialJsonStringContent(value) {
    let result = '';
    for(let i = 0; i < value.length; i += 1){
        const char = value[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        if (i === value.length - 1) {
            result += '\\';
            break;
        }
        const escapedChar = value[i + 1];
        switch(escapedChar){
            case '"':
                result += '"';
                i += 1;
                break;
            case '\\':
                result += '\\';
                i += 1;
                break;
            case '/':
                result += '/';
                i += 1;
                break;
            case 'b':
                result += '\b';
                i += 1;
                break;
            case 'f':
                result += '\f';
                i += 1;
                break;
            case 'n':
                result += '\n';
                i += 1;
                break;
            case 'r':
                result += '\r';
                i += 1;
                break;
            case 't':
                result += '\t';
                i += 1;
                break;
            case 'u':
                {
                    const hex = value.slice(i + 2, i + 6);
                    if (/^[0-9a-fA-F]{4}$/.test(hex)) {
                        result += String.fromCharCode(parseInt(hex, 16));
                        i += 5;
                        break;
                    }
                    result += '\\';
                    break;
                }
            default:
                result += '\\';
                break;
        }
    }
    return result;
}
/**
 * Parses a partial (streaming) JSON object string and extracts props according to the schema.
 *
 * - "wait-for-complete": only emits the prop once its JSON value is fully received.
 * - "stream-characters": emits a partial string value as characters arrive (excluding quotes).
 * - "stream-complete-items": emits array elements as they are fully received.
 *
 * Props not listed in the schema default to "wait-for-complete".
 */ function $fb4c9c7303fde485$var$extractStreamingProps(jsonStream, propSchema, knownKeys) {
    const result = {};
    const mutableResult = result;
    for (const key of knownKeys){
        const mode = propSchema[key] ?? 'wait-for-complete';
        const valueStart = $fb4c9c7303fde485$var$findKeyValueStart(jsonStream, String(key));
        if (valueStart === -1) continue;
        const extracted = $fb4c9c7303fde485$var$extractJsonValue(jsonStream, valueStart);
        if (!extracted) continue;
        if (mode === 'wait-for-complete') {
            if (extracted.complete) try {
                mutableResult[key] = JSON.parse(extracted.raw);
            } catch  {
            // ignore malformed
            }
        } else if (mode === 'stream-characters') {
            // For strings: strip the surrounding quotes and pass the partial content.
            const raw = extracted.raw;
            if (raw.startsWith('"')) {
                // If complete, strip both quotes; if partial, strip only the opening quote.
                const inner = extracted.complete ? raw.slice(1, -1) : raw.slice(1);
                mutableResult[key] = $fb4c9c7303fde485$var$decodePartialJsonStringContent(inner);
            } else if (extracted.complete) try {
                mutableResult[key] = JSON.parse(raw);
            } catch  {
            // ignore
            }
        } else if (mode === 'stream-complete-items') {
            const items = $fb4c9c7303fde485$var$extractCompleteArrayItems(extracted.raw);
            if (items !== null && items.length > 0) mutableResult[key] = items;
        }
    }
    return result;
}
const $fb4c9c7303fde485$export$49acb04f78f8e816 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WidgetWrapper(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { jsonStream: jsonStream, component: Component, propSchema: propSchema, extraProps: extraProps } = t0;
    let t1;
    if ($[0] !== propSchema) {
        t1 = Object.keys(propSchema);
        $[0] = propSchema;
        $[1] = t1;
    } else t1 = $[1];
    const knownKeys = t1;
    let t2;
    if ($[2] !== jsonStream || $[3] !== knownKeys || $[4] !== propSchema) {
        t2 = $fb4c9c7303fde485$var$extractStreamingProps(jsonStream, propSchema, knownKeys);
        $[2] = jsonStream;
        $[3] = knownKeys;
        $[4] = propSchema;
        $[5] = t2;
    } else t2 = $[5];
    const streamedProps = t2;
    let t3;
    if ($[6] !== extraProps || $[7] !== streamedProps) {
        t3 = {
            ...streamedProps,
            ...extraProps
        };
        $[6] = extraProps;
        $[7] = streamedProps;
        $[8] = t3;
    } else t3 = $[8];
    const mergedProps = t3;
    let t4;
    if ($[9] !== Component || $[10] !== mergedProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, mergedProps);
        $[9] = Component;
        $[10] = mergedProps;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : function WidgetWrapper({ jsonStream: jsonStream, component: Component, propSchema: propSchema, extraProps: extraProps }) {
    const knownKeys = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>Object.keys(propSchema), [
        propSchema
    ]);
    const streamedProps = $fb4c9c7303fde485$var$extractStreamingProps(jsonStream, propSchema, knownKeys);
    const mergedProps = {
        ...streamedProps,
        ...extraProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, mergedProps);
};
module.exports["WidgetWrapper"] = $fb4c9c7303fde485$export$49acb04f78f8e816;

});

parcelRegister("kjEqQ", function(module, exports) {
const $9fa1abf60737d1ea$export$6eaeab7bc7f88e20 = {
    chartType: 'wait-for-complete',
    data: 'stream-complete-items',
    chartTitle: 'stream-characters',
    subtitle: 'stream-characters',
    xAxisLabel: 'stream-characters',
    yAxisLabel: 'stream-characters',
    numEl: 'wait-for-complete',
    numGroups: 'wait-for-complete',
    yMin: 'wait-for-complete',
    yMax: 'wait-for-complete',
    xAccessor: 'wait-for-complete',
    yAccessor: 'wait-for-complete',
    labelAccessor: 'wait-for-complete',
    valueAccessor: 'wait-for-complete',
    colorAccessor: 'wait-for-complete',
    metricsConfig: 'wait-for-complete'
};
module.exports["VISUALIZATION_CHART_PROP_SCHEMA"] = $9fa1abf60737d1ea$export$6eaeab7bc7f88e20;

});

parcelRegister("e859c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $hiH4y = parcelRequire("hiH4y");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $6affa5fb37b24f40$var$styles = {
    root: "_0bjKvDKxmn _4c065UFQfX _2Y7lL4Pgdg _0KLXrujOvk _1UtDYzZpcK _2fwxA5ecOK _0clgaMy7kJ _0CMRbkAwSC",
    blockRoot: "_2mHwu82ADO _3iDTPbccYA _0hPCNLchRC _1EqgXlN91d",
    inlineRoot: "_3iDTPbS8kF _1ANEUSzUZr _1RrJLiQame _0wOv4Q7zJH _3zvHkHdC7N _0clgaMy7kJ _0CMRbkAwSC",
    inlineDisabled: "_0wOv4Qsyl5 _1YKVNsVx3j",
    inlineIcon: "_3iDTPbS8kF _1RrJLit2nV _2xTnZx1Y8M",
    disabled: "_1YKVNsVx3j",
    icon: "_3YEZNOdnbC",
    blockIcon: "_3iDTPbccYA",
    label: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _4ouGXIdnbC _1oM3wRFQfX",
    blockLabel: "_3zvHkHdC7N",
    inlineLabel: "_3iDTPbS8kF _3zvHkHdC7N"
};
const $6affa5fb37b24f40$var$ActionableFollowUpLinkComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { children: children, onClick: onClick, isDisabled: t1, testId: testId, ariaLabel: ariaLabel, appearance: t2 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const appearance = t2 === undefined ? "block" : t2;
    const isInline = appearance === "inline";
    const t3 = isInline ? $6affa5fb37b24f40$var$styles.inlineIcon : $6affa5fb37b24f40$var$styles.blockIcon;
    let t4;
    if ($[0] !== t3) {
        t4 = (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.icon, t3);
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiH4y))), {
            label: "",
            size: "small"
        });
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: t4
        }, t5);
        $[3] = t4;
        $[4] = t6;
    } else t6 = $[4];
    const t7 = isInline ? $6affa5fb37b24f40$var$styles.inlineLabel : $6affa5fb37b24f40$var$styles.blockLabel;
    let t8;
    if ($[5] !== t7) {
        t8 = (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.label, t7);
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== children || $[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: t8
        }, children);
        $[7] = children;
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t6 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t9);
        $[10] = t6;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    const content = t10;
    if (isInline) {
        let t11;
        if ($[13] !== isDisabled || $[14] !== onClick) {
            t11 = (event)=>{
                if (isDisabled) return;
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onClick();
                }
            };
            $[13] = isDisabled;
            $[14] = onClick;
            $[15] = t11;
        } else t11 = $[15];
        const handleKeyDown = t11;
        const t12 = isDisabled ? -1 : 0;
        const t13 = isDisabled || undefined;
        const t14 = isDisabled ? undefined : onClick;
        const t15 = isDisabled && $6affa5fb37b24f40$var$styles.inlineDisabled;
        let t16;
        if ($[16] !== t15) {
            t16 = (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.root, $6affa5fb37b24f40$var$styles.inlineRoot, t15);
            $[16] = t15;
            $[17] = t16;
        } else t16 = $[17];
        let t17;
        if ($[18] !== ariaLabel || $[19] !== content || $[20] !== handleKeyDown || $[21] !== t12 || $[22] !== t13 || $[23] !== t14 || $[24] !== t16 || $[25] !== testId) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                role: "button",
                tabIndex: t12,
                "aria-label": ariaLabel,
                "aria-disabled": t13,
                onClick: t14,
                onKeyDown: handleKeyDown,
                testId: testId,
                xcss: t16
            }, content);
            $[18] = ariaLabel;
            $[19] = content;
            $[20] = handleKeyDown;
            $[21] = t12;
            $[22] = t13;
            $[23] = t14;
            $[24] = t16;
            $[25] = testId;
            $[26] = t17;
        } else t17 = $[26];
        return t17;
    }
    const t11 = isDisabled && $6affa5fb37b24f40$var$styles.disabled;
    let t12;
    if ($[27] !== t11) {
        t12 = (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.root, $6affa5fb37b24f40$var$styles.blockRoot, t11);
        $[27] = t11;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== ariaLabel || $[30] !== content || $[31] !== isDisabled || $[32] !== onClick || $[33] !== t12 || $[34] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            "aria-label": ariaLabel,
            isDisabled: isDisabled,
            onClick: onClick,
            testId: testId,
            xcss: t12
        }, content);
        $[29] = ariaLabel;
        $[30] = content;
        $[31] = isDisabled;
        $[32] = onClick;
        $[33] = t12;
        $[34] = testId;
        $[35] = t13;
    } else t13 = $[35];
    return t13;
} : ({ children: children, onClick: onClick, isDisabled: isDisabled = false, testId: testId, ariaLabel: ariaLabel, appearance: appearance = 'block' })=>{
    const isInline = appearance === 'inline';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.icon, isInline ? $6affa5fb37b24f40$var$styles.inlineIcon : $6affa5fb37b24f40$var$styles.blockIcon)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiH4y))), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.label, isInline ? $6affa5fb37b24f40$var$styles.inlineLabel : $6affa5fb37b24f40$var$styles.blockLabel)
    }, children));
    if (isInline) {
        // A native <button> is an atomic inline box whose text cannot break across
        // line boxes, so a long inline link would wrap as a whole unit onto its own
        // line. To let the link text flow and break mid-line with the surrounding
        // prose, render an inline `<span role="button">` with keyboard support.
        const handleKeyDown = (event)=>{
            if (isDisabled) return;
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            role: "button",
            tabIndex: isDisabled ? -1 : 0,
            "aria-label": ariaLabel,
            "aria-disabled": isDisabled || undefined,
            onClick: isDisabled ? undefined : onClick,
            onKeyDown: handleKeyDown,
            testId: testId,
            xcss: (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.root, $6affa5fb37b24f40$var$styles.inlineRoot, isDisabled && $6affa5fb37b24f40$var$styles.inlineDisabled)
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        "aria-label": ariaLabel,
        isDisabled: isDisabled,
        onClick: onClick,
        testId: testId,
        xcss: (0, $w6R6I.cx)($6affa5fb37b24f40$var$styles.root, $6affa5fb37b24f40$var$styles.blockRoot, isDisabled && $6affa5fb37b24f40$var$styles.disabled)
    }, content);
};
const $6affa5fb37b24f40$export$b038a965c362bb20 = /*#__PURE__*/ (0, $cozmU.memo)($6affa5fb37b24f40$var$ActionableFollowUpLinkComponent);
module.exports["ActionableFollowUpLink"] = $6affa5fb37b24f40$export$b038a965c362bb20;

});

parcelRegister("hiH4y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df7850bea98831e5444e09083b5a8cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c98587650f7e230e$var$_react = $c98587650f7e230e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c98587650f7e230e$var$_baseNew = $c98587650f7e230e$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c98587650f7e230e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowCurvedDownRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/arrow-curved-down-right
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c98587650f7e230e$var$ArrowCurvedDownRightIcon = (props)=>/*#__PURE__*/ $c98587650f7e230e$var$_react.default.createElement($c98587650f7e230e$var$_baseNew.default, Object.assign({
        name: "ArrowCurvedDownRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.5 6a3 3 0 0 0 3 3h6.94L9.22 5.78l1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.22-3.22H5.5A4.5 4.5 0 0 1 1 6V1h1.5z"/>`
    }, props));
$c98587650f7e230e$var$ArrowCurvedDownRightIcon.displayName = 'ArrowCurvedDownRightIcon';
var $c98587650f7e230e$var$_default = module.exports.default = $c98587650f7e230e$var$ArrowCurvedDownRightIcon;

});

parcelRegister("7fxzU", function(module, exports) {

var $bijHC = parcelRequire("bijHC");

var $caelp = parcelRequire("caelp");


var $9Id8q = parcelRequire("9Id8q");


var $5Zhod = parcelRequire("5Zhod");


var $b8X74 = parcelRequire("b8X74");


var $30DeN = parcelRequire("30DeN");

const $e19aaf09f41a82e7$var$CONTEXT_TYPE = 'Mentions';
const $e19aaf09f41a82e7$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $e19aaf09f41a82e7$var$SmartMentionResource extends (0, $bijHC.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, _query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $e19aaf09f41a82e7$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                productAttributes: conf.productAttributes
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'users', (0, $5Zhod.Actions).REQUESTED, (0, $5Zhod.defaultAttributes)(contextIdentifier));
            const users = await (0, $30DeN.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $5Zhod.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'usersRequest', (0, $5Zhod.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $5Zhod.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'usersRequest', (0, $5Zhod.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $5Zhod.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $9Id8q.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType,
                appType: user.appType
            };
        }
        if (type === (0, $9Id8q.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
                userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
                lozenge: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink //OOH HERE Do we pass in resolver or add in provider?
                },
                source: 'smarts'
            };
        }
        if (type === (0, $9Id8q.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $9Id8q.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $9Id8q.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'usersRequest', (0, $5Zhod.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $5Zhod.defaultAttributes)(this.contextIdentifier)
        });
    }
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = void 0;
        this.lastReturnedSearch = void 0;
        this.contextIdentifier = void 0;
        this.smartMentionConfig = $e19aaf09f41a82e7$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $b8X74.DefaultMentionNameResolver)(smartMentionConfig.baseUrl, smartMentionConfig.siteId, smartMentionConfig.productKey)
        };
        this.lastReturnedSearch = 0;
    }
}
var $e19aaf09f41a82e7$export$2e2bcd8739ae039 = $e19aaf09f41a82e7$var$SmartMentionResource;
module.exports["default"] = $e19aaf09f41a82e7$export$2e2bcd8739ae039;

});

parcelRegister("bijHC", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $caelp = parcelRequire("caelp");


var $2SUNK = parcelRequire("2SUNK");


var $b3nqj = parcelRequire("b3nqj");


var $55fM8 = parcelRequire("55fM8");

const $ec39392517ed4807$var$MAX_QUERY_ITEMS = 100;
const $ec39392517ed4807$var$MAX_NOTIFIED_ITEMS = 20;
const $ec39392517ed4807$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ec39392517ed4807$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $ec39392517ed4807$export$8576ba1ed2760927 extends $ec39392517ed4807$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2SUNK.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ec39392517ed4807$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2SUNK.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ec39392517ed4807$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $ec39392517ed4807$export$5a4331e3e1c43553 extends $ec39392517ed4807$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    getMentionDisabledState(mention) {
        return this.config.getMentionDisabledState?.(mention);
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2SUNK.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $caelp.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ec39392517ed4807$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ec39392517ed4807$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            // Loading placeholders carry none of these fields and pass through untouched.
            if (mention.isPlaceholder) return mention;
            let lozenge;
            if ((0, $caelp.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $caelp.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.filter, this.config.debounceTime);
    }
}
class $ec39392517ed4807$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $ec39392517ed4807$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $ec39392517ed4807$export$2e2bcd8739ae039 = $ec39392517ed4807$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $ec39392517ed4807$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $ec39392517ed4807$export$8576ba1ed2760927;
module.exports["MentionResource"] = $ec39392517ed4807$export$5a4331e3e1c43553;
module.exports["isResolvingMentionProvider"] = $ec39392517ed4807$export$ae1fce5f69858ef3;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("9Id8q", function(module, exports) {
var $ce2b9a608726f465$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
module.exports["EntityType"] = $ce2b9a608726f465$export$8eda7e02f8f033b2;

});

parcelRegister("5Zhod", function(module, exports) {
const $aaff4d743589e839$export$c724588856bbfbcf = 'smart';
var $aaff4d743589e839$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $aaff4d743589e839$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $aaff4d743589e839$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};
module.exports["SMART_EVENT_TYPE"] = $aaff4d743589e839$export$c724588856bbfbcf;
module.exports["Actions"] = $aaff4d743589e839$export$b52183d5cfb26dc9;
module.exports["defaultAttributes"] = $aaff4d743589e839$export$38cd8db2db178f58;
module.exports["getUsersForAnalytics"] = $aaff4d743589e839$export$e8be30a842a4b49d;

});

parcelRegister("b8X74", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $gMmzr = parcelRequire("gMmzr");


var $b3mV7 = parcelRequire("b3mV7");

const $d5111af2e171b376$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $d5111af2e171b376$var$makeRequest = async (url, accountIds, cloudId, product)=>{
    const query = $d5111af2e171b376$var$buildUsersQuery(accountIds);
    return (0, $b3mV7.graphqlQuery)(url, query, cloudId, product);
};
class $d5111af2e171b376$export$2ae0434dccdcb77e {
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $caelp.MentionNameStatus).OK
            };
            const url = (0, $gMmzr.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $d5111af2e171b376$var$makeRequest(url, [
                id
            ], this.cloudId, this.product);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $caelp.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $caelp.MentionNameStatus).UNKNOWN
            };
        } catch  {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $caelp.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
    constructor(baseUrl, cloudId, product){
        this.baseUrl = void 0;
        this.cloudId = void 0;
        this.product = void 0;
        this.cache = void 0;
        this.baseUrl = baseUrl;
        this.cloudId = cloudId;
        this.product = product;
        this.cache = new Map();
    }
}
module.exports["DefaultMentionNameResolver"] = $d5111af2e171b376$export$2ae0434dccdcb77e;

});

parcelRegister("gMmzr", function(module, exports) {
const $cc0245eb84decfef$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $cc0245eb84decfef$export$d4fff2dfff3e2bc1;

});

parcelRegister("b3mV7", function(module, exports) {
const $721a16bcf92ff1cb$var$buildHeaders = (cloudId, product = 'platform')=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    if (cloudId && product) {
        const atlAttributionHeader = {
            tenantId: cloudId,
            product: product
        };
        headers.append('atl-attribution', JSON.stringify(atlAttributionHeader));
    }
    return headers;
};
function $721a16bcf92ff1cb$export$74eb8d79ae3e02b5(serviceUrl, query, cloudId, product) {
    const headers = $721a16bcf92ff1cb$var$buildHeaders(cloudId, product);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $721a16bcf92ff1cb$export$74eb8d79ae3e02b5;

});

parcelRegister("30DeN", function(module, exports) {

var $gMmzr = parcelRequire("gMmzr");

const $f4d78c0bc3a4e1ce$var$getUserRecommendations = (request)=>{
    const url = (0, $gMmzr.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $f4d78c0bc3a4e1ce$export$2e2bcd8739ae039 = $f4d78c0bc3a4e1ce$var$getUserRecommendations;
module.exports["default"] = $f4d78c0bc3a4e1ce$export$2e2bcd8739ae039;

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
const $0b67b0fc1e6d3033$var$anchorBelowModifiers = [
    {
        name: 'flip',
        enabled: false
    },
    {
        name: 'preventOverflow',
        options: {
            mainAxis: false
        }
    }
];
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {}),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        modifiers: $0b67b0fc1e6d3033$var$anchorBelowModifiers,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {})
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("1zWvS", function(module, exports) {

var $ahHdE = parcelRequire("ahHdE");

const $62fcaf22b5331842$var$DEEP_LINK_TARGET_PARAM = 'deepLinkTarget';
const $62fcaf22b5331842$export$90a76c2bef0153ac = (urlString)=>{
    const url = new URL(urlString);
    const paramValue = url.searchParams.get($62fcaf22b5331842$var$DEEP_LINK_TARGET_PARAM);
    return paramValue !== null && paramValue !== '';
};
const $62fcaf22b5331842$export$bf588c78bdf2c65e = (urlString, productKey)=>{
    const url = new URL(urlString);
    return url.searchParams.get($62fcaf22b5331842$var$DEEP_LINK_TARGET_PARAM) === productKey && url.origin === window.location.origin;
};
const $62fcaf22b5331842$export$52670f17ebbc294a = ({ url: url, onDeepLinkClick: onDeepLinkClick })=>{
    return !!url && $62fcaf22b5331842$export$90a76c2bef0153ac(url) && !!onDeepLinkClick;
};
const $62fcaf22b5331842$export$eb89388a22df1856 = ({ url: url, productKey: productKey, onDeepLinkClick: onDeepLinkClick, conversationId: conversationId })=>{
    if (onDeepLinkClick && $62fcaf22b5331842$export$bf588c78bdf2c65e(url, productKey)) {
        onDeepLinkClick(url);
        return;
    }
    // If the deep link is not for the current product, or the product did not set up a callback
    // open the link in new tab with Rovo opened
    const transformedUrl = (0, $ahHdE.transformRovoChatDeepLink)(url, conversationId);
    window.open(transformedUrl.toString(), '_blank', 'noopener, noreferrer');
};
const $62fcaf22b5331842$export$ab98a3cf883edbf6 = (url, productKey)=>{
    if ($62fcaf22b5331842$export$90a76c2bef0153ac(url) && !$62fcaf22b5331842$export$bf588c78bdf2c65e(url, productKey)) return '_blank';
    return undefined;
};
module.exports["shouldHandleDeepLink"] = $62fcaf22b5331842$export$52670f17ebbc294a;
module.exports["handleDeepLink"] = $62fcaf22b5331842$export$eb89388a22df1856;
module.exports["handleOnSetLinkTarget"] = $62fcaf22b5331842$export$ab98a3cf883edbf6;

});

parcelRegister("ahHdE", function(module, exports) {
const $411335ffdd31fe6a$export$921bf829cac3b2b5 = (url, shouldAddAttribution = false)=>{
    if (!url.includes('/wiki/spaces/') || !shouldAddAttribution) return url;
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.set('atl_f', 'ROVOCHAT');
        return urlObj.toString();
    } catch  {
        // Fallback to original URL if URL parsing fails
        return url;
    }
};
const $411335ffdd31fe6a$export$d05441815730f8ce = (urlString, conversationId, openChatMode)=>{
    const url = new URL(urlString);
    url.searchParams.set('rovoChatTriggerOpen', 'true');
    if (conversationId) {
        url.searchParams.set('rovoChatConversationId', conversationId);
        url.searchParams.set('rovoChatPathway', 'chat');
    }
    if (openChatMode) url.searchParams.set('rovoChatOpenChatMode', openChatMode);
    return url;
};
const $411335ffdd31fe6a$export$1bd96817ecef7470 = (text)=>{
    return /^https?:\/\//.test(text.trim());
};
const $411335ffdd31fe6a$export$4634c9b4c10ccdf0 = (urlString)=>{
    const url = new URL(urlString);
    return url.hostname.includes('slack.com');
};
const $411335ffdd31fe6a$export$2192630249bfc252 = (url, title)=>{
    if (!title) return false;
    if ($411335ffdd31fe6a$export$1bd96817ecef7470(title)) return false;
    const urlObj = new URL(url);
    return !urlObj.searchParams.has('preview');
};
const $411335ffdd31fe6a$export$ba517630e87cd898 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.searchParams.has('preview');
};
const $411335ffdd31fe6a$export$60a946ed54af2550 = (url)=>{
    const urlObj = new URL(url);
    const previewParam = urlObj.searchParams.get('preview');
    if (!previewParam) return '';
    // Extract filename from preview param
    const pathParts = previewParam.split('/');
    const filename = pathParts[pathParts.length - 1];
    if (!filename) return '';
    try {
        const decoded = decodeURIComponent(filename).replace(/\+/g, ' ').trim();
        return decoded && decoded.length > 0 ? decoded : '';
    } catch  {
        return '';
    }
};
const $411335ffdd31fe6a$export$db68cf502b682683 = (url)=>{
    if ($411335ffdd31fe6a$export$4634c9b4c10ccdf0(url)) {
        const urlObj = new URL(url);
        return `${urlObj.protocol}//${urlObj.hostname}${urlObj.pathname}`;
    }
    return url;
};
module.exports["transformIfConfluenceLink"] = $411335ffdd31fe6a$export$921bf829cac3b2b5;
module.exports["transformRovoChatDeepLink"] = $411335ffdd31fe6a$export$d05441815730f8ce;
module.exports["resolvesToReadableTitle"] = $411335ffdd31fe6a$export$2192630249bfc252;
module.exports["shouldSkipSmartCardResolution"] = $411335ffdd31fe6a$export$ba517630e87cd898;
module.exports["extractReadableTitleFromUrl"] = $411335ffdd31fe6a$export$60a946ed54af2550;
module.exports["stripSlackQueryParams"] = $411335ffdd31fe6a$export$db68cf502b682683;

});

parcelRegister("fJ1pJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $5bc0d79fa01100e2$var$initialState = {};
const $5bc0d79fa01100e2$export$f80440bac8b4447 = $5bc0d79fa01100e2$var$initialState;
const $5bc0d79fa01100e2$var$rovoMentionProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($5bc0d79fa01100e2$var$initialState);
const $5bc0d79fa01100e2$export$188c81c2e93279c4 = $5bc0d79fa01100e2$var$rovoMentionProvider.Provider;
const $5bc0d79fa01100e2$export$c577383a2f7ca57d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($5bc0d79fa01100e2$var$rovoMentionProvider);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($5bc0d79fa01100e2$var$rovoMentionProvider);
module.exports["RovoMentionProvider"] = $5bc0d79fa01100e2$export$188c81c2e93279c4;
module.exports["useRovoMentionProvider"] = $5bc0d79fa01100e2$export$c577383a2f7ca57d;

});

parcelRegister("4PnFr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $9093faffe82e4d97$var$initialState = {};
const $9093faffe82e4d97$var$rovoProfilecardProvider = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($9093faffe82e4d97$var$initialState);
const $9093faffe82e4d97$export$934e64d1311e24df = $9093faffe82e4d97$var$rovoProfilecardProvider.Provider;
const $9093faffe82e4d97$export$67a7359df5c1bd16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($9093faffe82e4d97$var$rovoProfilecardProvider);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($9093faffe82e4d97$var$rovoProfilecardProvider);
module.exports["useRovoProfilecardProvider"] = $9093faffe82e4d97$export$67a7359df5c1bd16;

});

parcelRegister("6LXy2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $9KSWX = parcelRequire("9KSWX");


var $hBYtq = parcelRequire("hBYtq");


var $jLxvy = parcelRequire("jLxvy");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $4gLhk = parcelRequire("4gLhk");


var $ahHdE = parcelRequire("ahHdE");


var $8BSfe = parcelRequire("8BSfe");

const $32d2672c4893b078$var$styles = {
    citation: "_30huDKYbGa _0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH7zJH"
};
const $32d2672c4893b078$var$convertColorAppearance = (color)=>{
    switch(color){
        case 'blue':
            return 'information';
        case 'green':
            return 'success';
        case 'red':
            return 'danger';
        case 'yellow':
            return 'warning';
        case 'purple':
            return 'discovery';
        default:
            return 'neutral';
    }
};
const $32d2672c4893b078$export$21553c57082a6434 = ({ localId: localId, text: text, color: color = 'blue', onClick: onClick })=>{
    (0, $6cFsl.di)((0, $8BSfe.useMessageSources), (0, $jLxvy.StandaloneHoverCard));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { sources: sources } = (0, $8BSfe.useMessageSources)();
    const { source: source, index: index_0 } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!localId.includes('citation')) return {};
        const index = parseInt(localId.split('-')?.[1]);
        return {
            source: sources?.[index - 1],
            index: index
        };
    }, [
        localId,
        sources
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((source_0, transformedUrl)=>{
        const citedProduct = (0, $4gLhk.extractProductNameFromARI)(source_0.ari);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'citationLink',
            attributes: {
                index: index_0,
                sourceType: source_0.type,
                citedProduct: citedProduct,
                sourceProduct: source_0.product
            }
        });
        onClick?.(index_0 ?? 0, citedProduct, source_0.product ?? null);
        window.open(transformedUrl, '_blank', 'noopener, noreferrer');
    }, [
        index_0,
        sendAnalyticsEvent,
        onClick
    ]);
    // Our special citation treatment
    if (!!source) {
        const transformedUrl_0 = source.url ? (0, $ahHdE.transformIfConfluenceLink)(source.url, true) : source.url;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.StandaloneHoverCard), {
            url: transformedUrl_0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $32d2672c4893b078$var$styles.citation,
            onClick: ()=>{
                handleClick(source, transformedUrl_0);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "information"
        }, index_0)));
    } // Standard lozenge for status nodes
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: $32d2672c4893b078$var$convertColorAppearance(color)
    }, text);
};
module.exports["StatusCitation"] = $32d2672c4893b078$export$21553c57082a6434;

});

parcelRegister("jLxvy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $lzgC6 = parcelRequire("lzgC6");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $jdqmT = parcelRequire("jdqmT");


var $hsgLh = parcelRequire("hsgLh");


var $1smAh = parcelRequire("1smAh");


var $cn7Ll = parcelRequire("cn7Ll");

const $f35adce8a13b91c6$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $6cFsl.di)((0, $cn7Ll.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $1smAh.useSmartLinkAnalyticsContext)({
        display: (0, $4yYAm.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $cn7Ll.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $cozmU.useCallback)((error, info)=>{
        (0, $jdqmT.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $jdqmT.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $jdqmT.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsgLh.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cn7Ll.HoverCardComponent), props, children)));
};
const $f35adce8a13b91c6$var$HoverCardWithoutAnalyticsContext = (0, $lzgC6.default)()($f35adce8a13b91c6$var$HoverCardWithErrorBoundary);
const $f35adce8a13b91c6$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f35adce8a13b91c6$var$HoverCardWithoutAnalyticsContext, props);
};
const $f35adce8a13b91c6$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f35adce8a13b91c6$export$57a077cc9fbe653e, props);
module.exports["HoverCard"] = $f35adce8a13b91c6$export$57a077cc9fbe653e;
module.exports["StandaloneHoverCard"] = $f35adce8a13b91c6$export$f1f63acbe6ed8fb0;

});

parcelRegister("cn7Ll", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $fqVYq = parcelRequire("fqVYq");


var $4yYAm = parcelRequire("4yYAm");


var $iUTeb = parcelRequire("iUTeb");


var $9ojsk = parcelRequire("9ojsk");


var $9H66G = parcelRequire("9H66G");


var $16kNn = parcelRequire("16kNn");


var $1smAh = parcelRequire("1smAh");


var $5irZi = parcelRequire("5irZi");


var $4xm0k = parcelRequire("4xm0k");


var $7CAOU = parcelRequire("7CAOU");

const $73aa8936eb4c3aa9$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $73aa8936eb4c3aa9$var$FADE_IN_DELAY = 500;
const $73aa8936eb4c3aa9$var$FADE_OUT_DELAY = 300;
const $73aa8936eb4c3aa9$var$RESOLVE_DELAY = 100;
const $73aa8936eb4c3aa9$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $7CAOU.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $73aa8936eb4c3aa9$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const fadeOutTimeoutId = (0, $cozmU.useRef)();
    const fadeInTimeoutId = (0, $cozmU.useRef)();
    const resolveTimeOutId = (0, $cozmU.useRef)();
    const mousePos = (0, $cozmU.useRef)();
    const popupOffset = (0, $cozmU.useRef)();
    const parentSpan = (0, $cozmU.useRef)(null);
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $iUTeb.useSmartCardActions)(id, url);
    const setMousePosition = (0, $cozmU.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $7CAOU.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $7CAOU.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $cozmU.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $cozmU.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $73aa8936eb4c3aa9$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $cozmU.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $cozmU.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus || linkState.status === 'resolved' && linkState.metadataStatus === 'pending' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization');
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
            register();
            else // Link has been already been partially resolved. Load metadata.
            loadMetadata();
        }, $73aa8936eb4c3aa9$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $cozmU.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $cozmU.useCallback)((actionId)=>{
        if (actionId === (0, $4yYAm.ActionName).PreviewAction || actionId === (0, $4yYAm.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $cozmU.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $cozmU.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $cozmU.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $cozmU.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onDismiss: hideCard,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            id: id,
            source: $73aa8936eb4c3aa9$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4xm0k.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        hideCard,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === ' ') {
            e.preventDefault();
            initShowCard(e);
        }
    }, [
        initShowCard
    ]);
    const trigger = (0, $cozmU.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, // `aria-controls` is also stripped because the trigger wrapper renders
    // with `role="none"`. axe's `aria-valid-attr-value` rule flags any
    // `aria-controls` value sitting on a presentational element, since the
    // element has no semantic role to control. Removing the attribute
    // keeps the trigger semantically inert without losing functionality.
    'aria-controls': _ariaControls, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...triggerProps,
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onKeyDown: handleKeyDown,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER,
            ...(0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                className: $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER
            } : {},
            onFocus: (0, $16kNn.noop),
            onBlur: (0, $16kNn.noop),
            role: "none"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        handleKeyDown
    ]);
    const popupComponent = (0, $cozmU.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $5irZi.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: initHideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: popupComponent
    });
};
module.exports["HOVER_CARD_SOURCE"] = $73aa8936eb4c3aa9$export$421dbc3834daf261;
module.exports["HoverCardComponent"] = $73aa8936eb4c3aa9$export$e2173dafa6a751bb;

});

parcelRegister("5irZi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $ac5e610c3ad80dcb$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        ref: ref
    }, children));
const $ac5e610c3ad80dcb$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// FIXME: ...props spreads all props to the div, including isReferenceHidden, which is not a valid prop for a div.
    // Find another way but adding exceptions with _, __, ___ etc.
    ({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};
var $ac5e610c3ad80dcb$export$2e2bcd8739ae039 = $ac5e610c3ad80dcb$var$CustomPopupContainer;
module.exports["createCustomPopupContainer"] = $ac5e610c3ad80dcb$export$c98f335200f1c8df;

});

parcelRegister("4xm0k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

var $9DHhW = parcelRequire("9DHhW");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

var $c3xon = parcelRequire("c3xon");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $8QLAc = parcelRequire("8QLAc");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");


var $16kNn = parcelRequire("16kNn");


var $lOOiS = parcelRequire("lOOiS");


var $l1f3f = parcelRequire("l1f3f");


var $5C2uB = parcelRequire("5C2uB");


var $7CAOU = parcelRequire("7CAOU");


var $6nncv = parcelRequire("6nncv");


var $6GUs4 = parcelRequire("6GUs4");


var $93zgq = parcelRequire("93zgq");


var $dcCaJ = parcelRequire("dcCaJ");


var $exTWI = parcelRequire("exTWI");


var $apqge = parcelRequire("apqge");


var $8qkhz = parcelRequire("8qkhz");

const $51fe488ad53df981$export$34883cbaea18402d = 'smart-links-hover-preview';
const $51fe488ad53df981$var$useIsResolvedView = ({ cardState: cardState, hoverPreviewOptions: hoverPreviewOptions })=>{
    return !hoverPreviewOptions?.render?.() && cardState.status === 'resolved';
};
const $51fe488ad53df981$var$useServices = ({ url: url })=>{
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const services = (0, $2Q7sv.getServices)(linkState.details);
    return services;
};
const $51fe488ad53df981$var$useIsUnauthorisedView = ({ cardState: cardState, url: url, hoverPreviewOptions: hoverPreviewOptions })=>{
    const services = $51fe488ad53df981$var$useServices({
        url: url
    });
    return !hoverPreviewOptions?.render?.() && cardState.status === 'unauthorized' && Boolean(services?.length);
};
const $51fe488ad53df981$var$useIsShowPreauthBetterHovercard = (props)=>{
    const { rovoOptions: rovoConfig } = (0, $8QLAc.default)();
    return Boolean($51fe488ad53df981$var$useIsUnauthorisedView(props) && rovoConfig?.isRovoEnabled && (0, $ieeJu.expValEquals)('platform_sl_3p_preauth_better_hovercard', 'isEnabled', true));
};
const $51fe488ad53df981$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDismiss: onDismiss, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const extensionKey = (0, $cozmU.useMemo)(()=>(0, $2Q7sv.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $cozmU.useMemo)(()=>(0, $2Q7sv.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $cMyWi.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $lOOiS.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $2Q7sv.getServices)(linkState.details);
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: linkState.details
    });
    const statusRef = (0, $cozmU.useRef)(linkStatus);
    const fireEventRef = (0, $cozmU.useRef)(fireEvent);
    const definitionIdRef = (0, $cozmU.useRef)(definitionId);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Must access object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const getDestinationUrl = (0, $cozmU.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $2Q7sv.getClickUrl)(url, linkState.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        linkState.details,
        url
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onAuxClick = (0, $cozmU.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onContextMenu = (0, $cozmU.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    const onClick = (0, $cozmU.useCallback)((event)=>{
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            // Prevent the anchor's native navigation so we can open the destination URL
            // with cross-product analytics query parameters appended.
            // The cross-product params are client-only and cannot be rendered
            // server-side. Falls back to the original `url` prop if the event target is
            // not an anchor element.
            event.preventDefault();
            const { target: target } = (0, $5C2uB.getAnchorAttributesFromEvent)(event);
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
            window.open(destinationUrl, target);
        }
        const isModifierKeyPressed = (0, $16kNn.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        getDestinationUrl,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $6nncv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $4yYAm.SmartLinkSize).Large,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        subtitle: subtitle,
        anchorTarget: product === 'ATLAS' ? '_self' : undefined
    };
    const uiOptions = (0, $7CAOU.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $4yYAm.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        ...(0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? {
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        } : undefined,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $cozmU.useCallback)((e)=>e.stopPropagation(), []);
    const useIsResolvedViewGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsResolvedView, ()=>undefined);
    const useIsUnauthorisedViewGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsUnauthorisedView, ()=>undefined);
    const useIsShowPreauthBetterHovercardGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsShowPreauthBetterHovercard, ()=>undefined);
    const isResolved = useIsResolvedViewGated({
        cardState: cardState,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const isUnauthorised = useIsUnauthorisedViewGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const showPreauthBetterHovercard = useIsShowPreauthBetterHovercardGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    if ((0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch')) {
        const cardView = (()=>{
            const overrideView = hoverPreviewOptions?.render?.();
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exTWI.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (isUnauthorised) {
                if (showPreauthBetterHovercard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8qkhz.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    onDismiss: onDismiss,
                    url: url
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apqge.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    url: url
                });
            }
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93zgq.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (isResolved) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcCaJ.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        })();
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GUs4.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            widthAppearance: showPreauthBetterHovercard ? 'slim' : undefined,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    } else {
        const getCardView = (cardState)=>{
            const overrideView = hoverPreviewOptions?.render?.();
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exTWI.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apqge.default), {
                extensionKey: extensionKey,
                id: id,
                flexibleCardProps: flexibleCardProps,
                url: url
            });
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93zgq.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcCaJ.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        };
        const cardView = getCardView(cardState);
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GUs4.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    }
};
const $51fe488ad53df981$var$HoverCardContentWithViewVariant = (props)=>{
    const showPreauthBetterHovercard = $51fe488ad53df981$var$useIsShowPreauthBetterHovercard(props);
    const data = (0, $cozmU.useMemo)(()=>{
        let viewVariant = 'default';
        if (showPreauthBetterHovercard) viewVariant = 'rovo-unauthorised-view';
        return {
            attributes: {
                viewVariant: viewVariant
            }
        };
    }, [
        showPreauthBetterHovercard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51fe488ad53df981$var$HoverCardContent, props));
};
const $51fe488ad53df981$var$_default_1 = (0, $8m50u.componentWithCondition)(()=>{
    return (0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch');
}, $51fe488ad53df981$var$HoverCardContentWithViewVariant, $51fe488ad53df981$var$HoverCardContent);
var $51fe488ad53df981$export$2e2bcd8739ae039 = $51fe488ad53df981$var$_default_1;
module.exports["hoverCardClassName"] = $51fe488ad53df981$export$34883cbaea18402d;
module.exports["default"] = $51fe488ad53df981$export$2e2bcd8739ae039;

});

parcelRegister("c3xon", function(module, exports) {

var $2zVsi = parcelRequire("2zVsi");

function $98c7b2cae218afe1$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return (0, $2zVsi.functionWithCondition)(condition, functionTrue, functionFalse);
}
module.exports["functionUnionWithCondition"] = $98c7b2cae218afe1$export$c41c28c1d883fcd5;

});

parcelRegister("2zVsi", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $70b08b83582e8047$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
module.exports["functionWithCondition"] = $70b08b83582e8047$export$af3c0e82a18fc057;

});

parcelRegister("dz9dk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b4SfK = parcelRequire("b4SfK");


var $cMyWi = parcelRequire("cMyWi");


var $1G3WB = parcelRequire("1G3WB");

const $decb67059ffe42ce$var$SMART_LINKS_XPC_BRIDGE = 'smartLinks';
const $decb67059ffe42ce$var$XPC_QUERY_PARAM = 'xpis';
const $decb67059ffe42ce$export$189e6ab4f1c74893 = (details)=>(details?.meta?.is1PLink ?? false) === true;
const $decb67059ffe42ce$var$identityUrlWrapper = (url)=>url;
const $decb67059ffe42ce$var$useSmartLinkCrossProductUrlWrapperFallback = (_args)=>$decb67059ffe42ce$var$identityUrlWrapper;
const $decb67059ffe42ce$export$119a84bedaff7b6e = ({ details: details })=>{
    const { product: product, bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $cMyWi.useSmartLinkContext)();
    // xpcProduct takes precedence over product — it identifies the host product for XPC analytics
    // without affecting link resolution (which uses the `product` prop separately).
    const effectiveProduct = xpcProduct ?? product;
    const effectiveBridge = bridgeProduct ?? $decb67059ffe42ce$var$SMART_LINKS_XPC_BRIDGE;
    const effectiveProductForWrapper = effectiveProduct?.toLowerCase() ?? 'unknown';
    const wrapUrl = (0, $b4SfK.useCrossProductUrlWrapper)({
        bridge: effectiveBridge,
        product: effectiveProductForWrapper,
        ...xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {}
    });
    return (0, $cozmU.useCallback)((url)=>{
        if (typeof window === 'undefined' || !$decb67059ffe42ce$export$189e6ab4f1c74893(details) || !effectiveProduct) return url;
        let parsedUrl;
        try {
            parsedUrl = new URL(url);
        } catch  {
            return url;
        }
        if (parsedUrl.searchParams.has($decb67059ffe42ce$var$XPC_QUERY_PARAM)) return url;
        return wrapUrl(url);
    }, // Keep bridge/subproduct in the dependency array so consumers that memoize this callback
    // refresh when mini-modal context updates from smartLinks to rovo-chat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        details,
        effectiveBridge,
        effectiveProduct,
        wrapUrl,
        xpcSubProduct
    ]);
};
const $decb67059ffe42ce$export$f59314b362d05e65 = (0, $1G3WB.functionWithFG)('platform_smartlink_xpc_url_wrapping', $decb67059ffe42ce$export$119a84bedaff7b6e, $decb67059ffe42ce$var$useSmartLinkCrossProductUrlWrapperFallback);
module.exports["useSmartLinkCrossProductUrlWrapper"] = $decb67059ffe42ce$export$119a84bedaff7b6e;
module.exports["useSmartLinkCrossProductUrlWrapperGated"] = $decb67059ffe42ce$export$f59314b362d05e65;

});

parcelRegister("b4SfK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kwd5f = parcelRequire("kwd5f");


var $3jjX7 = parcelRequire("3jjX7");

const $94cb50462294ed69$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function $94cb50462294ed69$export$fc6e9265f8d85c92(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    // `useRef(initialValue)` evaluates `initialValue` on every render but only uses the result on
    // the first render. Populate the ref imperatively the first time we need it so we don't call
    // `getInstance()` on every render (per Billy Chen's review suggestion).
    const interactionSessionClientRef = (0, $cozmU.useRef)(undefined);
    if (!interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $3jjX7.default).getInstance();
    const [interactionSessionId, setInteractionSessionId] = (0, $cozmU.useState)(()=>interactionSessionClientRef.current?.getCurrentInteractionSessionId() ?? '');
    (0, $cozmU.useEffect)(()=>{
        // Add event listener that subscribes to any future interaction session ID updates
        const unbind = (0, $cbY7C.bind)(document, {
            type: $94cb50462294ed69$export$5d4c4eab0863aae3,
            listener: ()=>{
                // Re-attempt fetch Global interactionSessionClient if not present already
                if (!interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $3jjX7.default).getInstance();
                if (interactionSessionClientRef.current) {
                    const currentSessionId = interactionSessionClientRef.current.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            }
        });
        return unbind;
    }, []);
    return (0, $cozmU.useCallback)((url)=>{
        if (!interactionSessionId) return url;
        return (0, $kwd5f.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
    }, [
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
}
var $94cb50462294ed69$export$2e2bcd8739ae039 = $94cb50462294ed69$export$fc6e9265f8d85c92;
module.exports["useCrossProductUrlWrapper"] = $94cb50462294ed69$export$fc6e9265f8d85c92;
module.exports["default"] = $94cb50462294ed69$export$2e2bcd8739ae039;

});

parcelRegister("kwd5f", function(module, exports) {
const $8f3492c0e77dd422$export$81d16f1428ce0486 = 'xpis';
const $8f3492c0e77dd422$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($8f3492c0e77dd422$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};
module.exports["generateUrlWithParams"] = $8f3492c0e77dd422$export$2e3999ec51334ffe;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("1G3WB", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");

const $dc93231c4629fa01$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $dc93231c4629fa01$export$53903226fff06fbb;

});

parcelRegister("7CAOU", function(module, exports) {

var $jp2Q3 = parcelRequire("jp2Q3");


var $4yYAm = parcelRequire("4yYAm");

const $4b92af562a9f6a65$export$8245b0eaabf3440c = (0, $jp2Q3.layers).modal();
const $4b92af562a9f6a65$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    zIndex: $4b92af562a9f6a65$export$8245b0eaabf3440c + 1
};
const $4b92af562a9f6a65$export$a0a37c997fbcd678 = 24;
const $4b92af562a9f6a65$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card
module.exports["HOVER_CARD_Z_INDEX"] = $4b92af562a9f6a65$export$8245b0eaabf3440c;
module.exports["flexibleUiOptions"] = $4b92af562a9f6a65$export$8e022b7269e8199a;
module.exports["CARD_WIDTH_REM"] = $4b92af562a9f6a65$export$a0a37c997fbcd678;
module.exports["CARD_GAP_PX"] = $4b92af562a9f6a65$export$e7cae8c75d768024;

});

parcelRegister("6nncv", function(module, exports) {

var $4FdKz = parcelRequire("4FdKz");


var $4yYAm = parcelRequire("4yYAm");


var $eeqm3 = parcelRequire("eeqm3");

const $40b39971c7d4e97d$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $4FdKz.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $4yYAm.ElementName).AuthorGroup,
            (0, $4yYAm.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn,
                    (0, $4yYAm.ElementName).SubscriberCount,
                    (0, $4yYAm.ElementName).State
                ],
                subtitle: [
                    (0, $4yYAm.ElementName).SourceBranch,
                    (0, $4yYAm.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $4yYAm.ElementName).LatestCommit,
                    (0, $4yYAm.ElementName).CollaboratorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $eeqm3.extractOwnedBy)(data) ? (0, $4yYAm.ElementName).OwnedByGroup : (0, $4yYAm.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $4yYAm.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount,
                    (0, $4yYAm.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $4yYAm.ElementName).AssignedToGroup,
                        (0, $4yYAm.ElementName).State,
                        (0, $4yYAm.ElementName).StoryPoints,
                        (0, $4yYAm.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).CollaboratorGroup,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ],
                secondary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount,
                    (0, $4yYAm.ElementName).AttachmentCount,
                    (0, $4yYAm.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $4yYAm.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).SentOn
                ],
                tertiary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $40b39971c7d4e97d$var$AvatarGroupsWithNamePrefix = [
    (0, $4yYAm.ElementName).AssignedToGroup,
    (0, $4yYAm.ElementName).OwnedByGroup,
    (0, $4yYAm.ElementName).AuthorGroup
];
const $40b39971c7d4e97d$var$toElementItem = (name)=>{
    const showNamePrefix = $40b39971c7d4e97d$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $40b39971c7d4e97d$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $4yYAm.ElementName)).map($40b39971c7d4e97d$var$toElementItem);
};
const $40b39971c7d4e97d$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $40b39971c7d4e97d$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $40b39971c7d4e97d$var$toElementItems(metadata.subtitle),
        primary: $40b39971c7d4e97d$var$toElementItems(primary),
        secondary: $40b39971c7d4e97d$var$toElementItems(metadata.secondary)
    };
};
module.exports["getMetadata"] = $40b39971c7d4e97d$export$8548546c0aa631e6;

});

parcelRegister("eeqm3", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");

var $6CHZa = parcelRequire("6CHZa");

var $htsh0 = parcelRequire("htsh0");

var $7LPcf = parcelRequire("7LPcf");

var $JTvZe = parcelRequire("JTvZe");

var $3ewaO = parcelRequire("3ewaO");

var $kAdyG = parcelRequire("kAdyG");

const $4f7a8ee2597639d5$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $4f7a8ee2597639d5$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $4f7a8ee2597639d5$export$b68822b76d5d51d5 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'schema:commentCount');
const $4f7a8ee2597639d5$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $4f7a8ee2597639d5$export$b68822b76d5d51d5(response?.data);
};
const $4f7a8ee2597639d5$export$4356c594f5c138d6 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $4f7a8ee2597639d5$export$ac56bd7a37249b48 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'endTime');
const $4f7a8ee2597639d5$export$e57334ce4738e29d = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:viewCount');
const $4f7a8ee2597639d5$export$44130aa92252501 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:reactCount');
const $4f7a8ee2597639d5$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $4f7a8ee2597639d5$export$44130aa92252501(response?.data);
};
const $4f7a8ee2597639d5$export$c8bef3d5e550a3a = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:voteCount');
const $4f7a8ee2597639d5$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $7LPcf.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4f7a8ee2597639d5$export$5546969a505305 = (data)=>{
    const person = (0, $6CHZa.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $4f7a8ee2597639d5$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $6CHZa.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $4f7a8ee2597639d5$export$69b10d653f96288b = (data)=>{
    const persons = (0, $htsh0.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4f7a8ee2597639d5$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $JTvZe.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $4f7a8ee2597639d5$export$43e54589935a1ff = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'schema:programmingLanguage');
const $4f7a8ee2597639d5$export$949ac6a8325b3fdb = (data)=>$4f7a8ee2597639d5$var$extractLinkName(data['atlassian:mergeSource']);
const $4f7a8ee2597639d5$export$8bd03a7beb5badf1 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:subscriberCount');
const $4f7a8ee2597639d5$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $4f7a8ee2597639d5$export$65362ff78a97fd8 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:attachmentCount');
const $4f7a8ee2597639d5$export$29b0ac5d2f9890cf = (data)=>$4f7a8ee2597639d5$var$extractLinkName(data['atlassian:mergeDestination']);
const $4f7a8ee2597639d5$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $4f7a8ee2597639d5$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $4f7a8ee2597639d5$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $4f7a8ee2597639d5$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $4f7a8ee2597639d5$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $4f7a8ee2597639d5$export$cc4028b2878d0675 = (data)=>{
    return $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $4f7a8ee2597639d5$export$b592ddecae70b61d = (data)=>{
    return $4f7a8ee2597639d5$var$extractValue(data, 'dateSent');
};
const $4f7a8ee2597639d5$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && $4f7a8ee2597639d5$export$b592ddecae70b61d(response?.data);
};
const $4f7a8ee2597639d5$export$bdcea84d1550eb9d = (data)=>{
    return $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:storyPoints');
};
const $4f7a8ee2597639d5$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $4f7a8ee2597639d5$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $4f7a8ee2597639d5$export$92037aea7f27bf7f = (meta)=>meta.tenantId;
const $4f7a8ee2597639d5$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $3ewaO.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};
module.exports["extractSmartLinkCommentCount"] = $4f7a8ee2597639d5$export$fb0960a89fb9c17b;
module.exports["extractAppliedToComponentsCount"] = $4f7a8ee2597639d5$export$4356c594f5c138d6;
module.exports["extractDueOn"] = $4f7a8ee2597639d5$export$ac56bd7a37249b48;
module.exports["extractViewCount"] = $4f7a8ee2597639d5$export$e57334ce4738e29d;
module.exports["extractSmartLinkReactCount"] = $4f7a8ee2597639d5$export$bb52c21c67a309ca;
module.exports["extractVoteCount"] = $4f7a8ee2597639d5$export$c8bef3d5e550a3a;
module.exports["extractOwnedBy"] = $4f7a8ee2597639d5$export$75b4b5a156f48ff3;
module.exports["extractAssignedTo"] = $4f7a8ee2597639d5$export$5546969a505305;
module.exports["extractPersonAssignedToAsArray"] = $4f7a8ee2597639d5$export$edb8a7a44b91274e;
module.exports["extractProgrammingLanguage"] = $4f7a8ee2597639d5$export$43e54589935a1ff;
module.exports["extractSourceBranch"] = $4f7a8ee2597639d5$export$949ac6a8325b3fdb;
module.exports["extractSubscriberCount"] = $4f7a8ee2597639d5$export$8bd03a7beb5badf1;
module.exports["extractTeamMemberCount"] = $4f7a8ee2597639d5$export$9fc8706c6cb5343a;
module.exports["extractAttachmentCount"] = $4f7a8ee2597639d5$export$65362ff78a97fd8;
module.exports["extractTargetBranch"] = $4f7a8ee2597639d5$export$29b0ac5d2f9890cf;
module.exports["extractChecklistProgress"] = $4f7a8ee2597639d5$export$dd980f9881b65d9c;
module.exports["extractLocation"] = $4f7a8ee2597639d5$export$9df94c77b0746c3c;
module.exports["extractSubTasksProgress"] = $4f7a8ee2597639d5$export$744e3a2674114c1d;
module.exports["extractUserAttributes"] = $4f7a8ee2597639d5$export$6052f26bb463e370;
module.exports["extractReadTime"] = $4f7a8ee2597639d5$export$cc4028b2878d0675;
module.exports["extractSmartLinkSentOn"] = $4f7a8ee2597639d5$export$5c05c5b7ca37e36e;
module.exports["extractStoryPoints"] = $4f7a8ee2597639d5$export$bdcea84d1550eb9d;
module.exports["extractMetaObjectId"] = $4f7a8ee2597639d5$export$bec1443e3e33b166;
module.exports["extractMetaResourceType"] = $4f7a8ee2597639d5$export$11d1314ebbee594e;
module.exports["extractMetaTenantId"] = $4f7a8ee2597639d5$export$92037aea7f27bf7f;
module.exports["extractHostName"] = $4f7a8ee2597639d5$export$f222ff3355b608d8;

});

parcelRegister("6CHZa", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $e6695a46069ee43e$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9EREa.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $e6695a46069ee43e$export$38a0979ebf273662;

});

parcelRegister("9EREa", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $9cbb96c910c4c39f$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $9cbb96c910c4c39f$export$c471ae5fddcf1392;

});

parcelRegister("htsh0", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $94cdde39bec9c233$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $94cdde39bec9c233$export$a66235cba0c9d11a;

});

parcelRegister("7LPcf", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $367262c04ca8598b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $367262c04ca8598b$export$19ee667f3f7a6ec3;

});

parcelRegister("JTvZe", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0;

});

parcelRegister("3ewaO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $jMcHR = parcelRequire("jMcHR");


var $kAdyG = parcelRequire("kAdyG");

const $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.url;
    return (0, $jMcHR.extractLink)(response?.data);
};
module.exports["extractSmartLinkUrl"] = $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de;

});

parcelRegister("jMcHR", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $04c77007239bb1c9$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $1kPn4.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $04c77007239bb1c9$export$63f54cf4c5883620;

});

parcelRegister("6GUs4", function(module, exports) {
/* ContentContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $euBHF = parcelRequire("euBHF");


var $6PgB0 = parcelRequire("6PgB0");


var $4xm0k = parcelRequire("4xm0k");

const $d306b041e75683ad$var$HoverCardContainerStyle = null;
const $d306b041e75683ad$var$hoverCardShellWidthDefault = null;
const $d306b041e75683ad$var$hoverCardShellWidthSlim = null;
const $d306b041e75683ad$var$hoverCardShellHideLoadingPlaceholder = null;
const $d306b041e75683ad$var$popupContainerStyles = null;
const $d306b041e75683ad$var$ConnectedAIPrismContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $6cFsl.di)((0, $euBHF.default), (0, $6PgB0.default));
    const { state: { status: status } } = (0, $euBHF.default)(url);
    const [showPrism, setShowPrism] = (0, $cozmU.useState)(status === 'loading');
    (0, $cozmU.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const resolvedWidthAppearance = widthAppearance ?? 'default';
    const container = /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _2V7sgOdnbC _24h04i2Njc",
            resolvedWidthAppearance === 'slim' ? "_39xV02zZoh" : "_39xV02VTmU",
            "_0E5LJLYbGa",
            !isAIEnabled && "_0bjKvD8fU6 _0KLXruoI2d _2OUyjtGk8v",
            (0, $4xm0k.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $6PgB0.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $d306b041e75683ad$var$ContentContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $cozmU.createElement($d306b041e75683ad$var$ConnectedAIPrismContainer, {
        widthAppearance: widthAppearance,
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $d306b041e75683ad$export$2e2bcd8739ae039 = $d306b041e75683ad$var$ContentContainer;
module.exports["default"] = $d306b041e75683ad$export$2e2bcd8739ae039;

});

parcelRegister("93zgq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $hHrlI = parcelRequire("hHrlI");


var $leSBv = parcelRequire("leSBv");


var $gCfXH = parcelRequire("gCfXH");


var $dM7c5 = parcelRequire("dM7c5");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");

var $voDgt = parcelRequire("voDgt");

const $950782f89926949b$var$titleBlockStyles = null;
const $950782f89926949b$var$mainTextStyles = null;
const $950782f89926949b$var$connectButtonStyles = null;
const $950782f89926949b$var$basePreviewStyles = null;
const $950782f89926949b$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hHrlI.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ $cozmU.createElement("b", null, (0, $gCfXH.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $leSBv.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $hekY6.default)([
            "_2C2kUQ8fU6 _1Lz9lo8fU6 _1DCdHi2ADO"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-title`,
        className: (0, $hekY6.default)([
            "_37wbyuDIqT _1kk5Tk7GSX _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-content`,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbS8kF _37wbyuDIqT _313842Pgdg _2fwxA5DIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        className: (0, $hekY6.default)([
            "_37wbyuDIqT _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $950782f89926949b$export$2e2bcd8739ae039 = $950782f89926949b$var$HoverCardForbiddenView;
module.exports["default"] = $950782f89926949b$export$2e2bcd8739ae039;

});

parcelRegister("leSBv", function(module, exports) {

var $dM7c5 = parcelRequire("dM7c5");


var $6GOAK = parcelRequire("6GOAK");


var $9ug60 = parcelRequire("9ug60");


var $gCfXH = parcelRequire("gCfXH");

const $ee3dc381f0d57dc0$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $gCfXH.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $dM7c5.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $dM7c5.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $9ug60.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $dM7c5.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $dM7c5.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};
module.exports["extractRequestAccessContextImproved"] = $ee3dc381f0d57dc0$export$846c1540a86749e6;

});

parcelRegister("9ug60", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dM7c5 = parcelRequire("dM7c5");

const $053e2873bd8bd139$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $dM7c5.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });
module.exports["ForbiddenAction"] = $053e2873bd8bd139$export$59f8830fb5467e35;

});

parcelRegister("gCfXH", function(module, exports) {
const $dd8187e5dc61e444$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $dd8187e5dc61e444$export$2e2bcd8739ae039 = $dd8187e5dc61e444$var$extractHostname;
module.exports["default"] = $dd8187e5dc61e444$export$2e2bcd8739ae039;

});

parcelRegister("bVAqi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");


var $b8pma = parcelRequire("b8pma");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $h6Vc4 = parcelRequire("h6Vc4");


var $9PA4G = parcelRequire("9PA4G");


var $lBXKn = parcelRequire("lBXKn");


var $cEvdy = parcelRequire("cEvdy");


var $8QLAc = parcelRequire("8QLAc");


var $dz9dk = parcelRequire("dz9dk");


var $9nA1A = parcelRequire("9nA1A");


var $jKbUI = parcelRequire("jKbUI");

const $dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES = [
    (0, $4yYAm.SmartLinkStatus).Pending,
    (0, $4yYAm.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $dee3aec0e9ff1e8c$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url, title: ssrTitle })=>{
    const aiSummaryConfig = (0, $lBXKn.useAISummaryConfig)();
    const resolve = (0, $cEvdy.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, product: product } = (0, $cMyWi.useSmartLinkContext)();
    const rovoConfig = (0, $8QLAc.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: details
    });
    const transformUrlCallback = (0, $cozmU.useCallback)((destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl), [
        appendCrossProductAnalyticsParams,
        url
    ]);
    const transformUrl = (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? transformUrlCallback : undefined;
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $cozmU.useMemo)(()=>$dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $h6Vc4.extractPlaceHolderCardState)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $cozmU.useMemo)(()=>(0, $jKbUI.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            product: product,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        onAuthorize,
        onClick,
        onAuxClick,
        onContextMenu,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        product,
        renderers,
        resolve,
        rovoConfig,
        status,
        transformUrl,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $cozmU.useMemo)(()=>({
            data: context,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $cozmU.useEffect)(()=>{
        switch(status){
            case (0, $4yYAm.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    extensionKey: details?.meta?.key
                });
                break;
            case (0, $4yYAm.SmartLinkStatus).Errored:
            case (0, $4yYAm.SmartLinkStatus).Fallback:
            case (0, $4yYAm.SmartLinkStatus).Forbidden:
            case (0, $4yYAm.SmartLinkStatus).NotFound:
            case (0, $4yYAm.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PA4G.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, $dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES.includes(status) && !Boolean(placeholderCardState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-flexible-card"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9nA1A.default), {
        testId: testId,
        ...ui,
        title: ssrTitle,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $dee3aec0e9ff1e8c$export$2e2bcd8739ae039 = $dee3aec0e9ff1e8c$var$FlexibleCard;
module.exports["default"] = $dee3aec0e9ff1e8c$export$2e2bcd8739ae039;

});

parcelRegister("h6Vc4", function(module, exports) {
const $ed97ea0952c19fa7$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $ed97ea0952c19fa7$export$684541b2632ffbbc = (placeholderData)=>{
    return $ed97ea0952c19fa7$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};
module.exports["extractPlaceHolderCardState"] = $ed97ea0952c19fa7$export$684541b2632ffbbc;

});

parcelRegister("9nA1A", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $1CN4f = parcelRequire("1CN4f");


var $4abK1 = parcelRequire("4abK1");


var $jdA6O = parcelRequire("jdA6O");


var $7ly7P = parcelRequire("7ly7P");


var $4JCld = parcelRequire("4JCld");

const $479950c88028365e$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $1CN4f.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
            if ((0, $4abK1.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $4yYAm.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $4yYAm.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $479950c88028365e$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) && (0, $4abK1.isFlexibleUiBlock)(child) ? child : undefined);
}; /**
    * Note: This function is only necessary for CompiledCSS within Jest tests due to the way it handles Styles.
    * CompiledCSS will inject a StyleCacheProvider around the component tree, which
    * causes the children to be wrapped in a StyleCacheProvider as well. This function recursively
    * searches for the first valid TitleBlock within the children of the StyleCacheProvider.
    */ 
const $479950c88028365e$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return undefined;
    if (node.type === (0, $jdA6O.default)) return node;
    if ((0, $4abK1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $479950c88028365e$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $479950c88028365e$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).map((child)=>$479950c88028365e$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(block)) return block.props;
};
const $479950c88028365e$var$getLayeredLink = (testId, context, children, onClick, onAuxClick, onContextMenu, title)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {}; // SSR cannot reliably extract TitleBlock props from children, so `title` is
    // provided from CardSSR as a stable server/client value to prevent hydration
    // text mismatches for the clickable container link.
    const { anchorTarget: target, text: text } = $479950c88028365e$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4JCld.default), {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        target: target,
        testId: testId,
        text: title || text || linkTitle?.text,
        url: url
    });
};
const $479950c88028365e$var$baseStyleCommon = null;
const $479950c88028365e$var$backgroundStyles = null;
const $479950c88028365e$var$elevationStyles = null;
const $479950c88028365e$var$clickableContainerStyles = null;
const $479950c88028365e$var$gapStyleMap = {
    xlarge: "_2mHwu8LmNS",
    large: "_2mHwu8EnCn",
    medium: "_2mHwu8dDL8",
    small: "_2mHwu8fLjz"
}; /**
    * Get container padding based on smart link size
    * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
    * at view/FlexibleCard/components/utils.tsx
    */ 
const $479950c88028365e$var$getPadding = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $479950c88028365e$var$getGap = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $479950c88028365e$var$previewOnLeftStyleMap = {
    xlarge: "_2Zuz6QmkyU _2fNyo2NHnM",
    large: "_2Zuz6Q25OK _2fNyo2kG2W",
    medium: "_2Zuz6QGxMP _2fNyo2NTt7",
    small: "_2Zuz6Qekl6 _2fNyo22ADO"
};
const $479950c88028365e$var$previewOnRightStyleMap = {
    xlarge: "_1ZnuxbmkyU _4Fd1ZpNHnM",
    large: "_1Znuxb25OK _4Fd1ZpkG2W",
    medium: "_1ZnuxbGxMP _4Fd1ZpNTt7",
    small: "_1Znuxbekl6 _4Fd1Zp2ADO"
}; /**
    * A container is a hidden component that build the Flexible Smart Link.
    * All the Flexible UI components are wrapped inside the container.
    * It inherits the ui props from Card component and applies the custom styling
    * accordingly.
    * @internal
    * @see Block
    */ 
const $479950c88028365e$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $4yYAm.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', title: title })=>{
    (0, $6cFsl.di)((0, $7ly7P.default));
    const padding = hidePadding ? '0px' : $479950c88028365e$var$getPadding(size);
    const gap = $479950c88028365e$var$getGap(size);
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $479950c88028365e$export$6f4e0540a2f2295a(children, context);
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = hoverPreviewOptions?.render !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC _4bt5LAnQyn _1mT5xdRAKS _433efc7dHp _4r4FCQLl21 _20xwADLl21",
            $479950c88028365e$var$gapStyleMap[size],
            !hideBackground && "_0KLXruqi9L",
            "_4FKVYEW37H _1h1ymjW37H _2fNyo2L0ZK _4Fd1Zp5Qdv _1MQRyzr1As",
            previewOnLeft && $479950c88028365e$var$previewOnLeftStyleMap[size],
            previewOnRight && $479950c88028365e$var$previewOnRightStyleMap[size],
            !hideElevation && "_30huDKOeNX _0bjKvDyzSk _313842FQfX _0adFHsFQfX _1DCdHiFQfX _2XsHFMFQfX",
            clickableContainer && "_1zaVr2RAKS _2Y1cn1RAKS _3WoImIRAKS _4itP7C7dHp _3Xe3wl7dHp _2dGRu57dHp"
        ]),
        style: {
            "--_1xumd0e": (0, $9aYkv.default)(padding),
            "--_73mooq": (0, $9aYkv.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $9aYkv.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $479950c88028365e$var$getLayeredLink(testId, context, children, onClick, onAuxClick, onContextMenu, title) : null, $479950c88028365e$var$filterChildren(children, removeBlockRestriction));
    if (context?.url && canShowHoverCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ly7P.default), {
        isHoverPreview: isResolved || hasHoverCardOverride,
        isAuthTooltip: isUnresolvedWithAuthFlow,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $479950c88028365e$export$2e2bcd8739ae039 = $479950c88028365e$var$Container;
module.exports["default"] = $479950c88028365e$export$2e2bcd8739ae039;

});

parcelRegister("1CN4f", function(module, exports) {
const $b11c19fc9aa89c7e$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);
module.exports["isFlexUiPreviewPresent"] = $b11c19fc9aa89c7e$export$783c1bf8fee63f80;

});

parcelRegister("7ly7P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $16kNn = parcelRequire("16kNn");


var $jLxvy = parcelRequire("jLxvy");

const $32ab5c854e7cdaa4$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $32ab5c854e7cdaa4$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $32ab5c854e7cdaa4$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $cozmU.useState)(true);
    const mouseStopTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $cozmU.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $4yYAm.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onBlur: (0, $16kNn.noop),
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $32ab5c854e7cdaa4$export$2e2bcd8739ae039 = $32ab5c854e7cdaa4$var$HoverCardControl;
module.exports["default"] = $32ab5c854e7cdaa4$export$2e2bcd8739ae039;

});

parcelRegister("4JCld", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3tPPd = parcelRequire("3tPPd");

const $8721fcf90b86ff31$var$styles = null; /**
                      * An anchor component to cover the entire container creating a clickable area.
                      * @internal
                      * @see `clickableContainer`
                      */ 
const $8721fcf90b86ff31$var$LayeredLink = ({ onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $3tPPd.useMouseDownEvent)();
    return /*#__PURE__*/ $cozmU.createElement("a" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _3OE6xYdnbC _0IXglfN91d _1ANEUSLRg7 _18TtmRWVPG _1BwB6vdnbC _0FuNJG7dHp",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        target: target
    }, text);
};
var $8721fcf90b86ff31$export$2e2bcd8739ae039 = $8721fcf90b86ff31$var$LayeredLink;
module.exports["default"] = $8721fcf90b86ff31$export$2e2bcd8739ae039;

});

parcelRegister("jKbUI", function(module, exports) {

var $hHrlI = parcelRequire("hHrlI");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $leSBv = parcelRequire("leSBv");


var $iCudX = parcelRequire("iCudX");


var $emAbv = parcelRequire("emAbv");


var $iRL51 = parcelRequire("iRL51");


var $eSImY = parcelRequire("eSImY");


var $fBEPJ = parcelRequire("fBEPJ");


var $7UwLu = parcelRequire("7UwLu");


var $eeqm3 = parcelRequire("eeqm3");


var $dM7c5 = parcelRequire("dM7c5");


var $16kNn = parcelRequire("16kNn");


var $8p295 = parcelRequire("8p295");

const $93d7982fee1bd82d$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Pending:
        case (0, $4yYAm.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $emAbv.default)(status, url, response, onClick),
                url: url
            };
        case (0, $4yYAm.SmartLinkStatus).Resolved:
            return (0, $iCudX.default)(params);
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).NotFound:
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $fBEPJ.extractErrorIcon)(response, status),
                linkTitle: (0, $emAbv.default)(status, url, response, onClick),
                preview: (0, $iRL51.extractSmartLinkPreviewImage)(response),
                provider: (0, $iDrrr.fg)('platform_sl_google_rebrand') ? (0, $eSImY.default)(response) : (0, $7UwLu.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $4yYAm.InternalActionName).UnresolvedAction]: $93d7982fee1bd82d$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                },
                hostName: (0, $eeqm3.extractHostName)(response)
            };
    }
};
const $93d7982fee1bd82d$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $93d7982fee1bd82d$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hHrlI.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
            const access = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $93d7982fee1bd82d$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $dM7c5.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $16kNn.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $dM7c5.messages).connect_link_account_card_name,
                onClick: (0, $16kNn.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $4yYAm.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $dM7c5.messages).cannot_find_link
            };
    }
};
module.exports["getContextByStatus"] = $93d7982fee1bd82d$export$e68aec76e359e401;

});

parcelRegister("iCudX", function(module, exports) {

var $7LPcf = parcelRequire("7LPcf");

var $lXmY5 = parcelRequire("lXmY5");

var $cLyLO = parcelRequire("cLyLO");

var $ddzkt = parcelRequire("ddzkt");

var $cbT5r = parcelRequire("cbT5r");

var $e1RBl = parcelRequire("e1RBl");

var $ltT9o = parcelRequire("ltT9o");

var $3ewaO = parcelRequire("3ewaO");

var $4FdKz = parcelRequire("4FdKz");


var $iDrrr = parcelRequire("iDrrr");


var $39PqP = parcelRequire("39PqP");


var $4omKw = parcelRequire("4omKw");


var $6hJQj = parcelRequire("6hJQj");


var $emAbv = parcelRequire("emAbv");


var $iRL51 = parcelRequire("iRL51");


var $k8KyO = parcelRequire("k8KyO");


var $eSImY = parcelRequire("eSImY");


var $igQUs = parcelRequire("igQUs");


var $fBEPJ = parcelRequire("fBEPJ");


var $7UwLu = parcelRequire("7UwLu");


var $hYTxH = parcelRequire("hYTxH");


var $eeqm3 = parcelRequire("eeqm3");

const $3e8bfec00ff792aa$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, origin: origin, product: product, resolve: resolve, rovoConfig: rovoConfig, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, transformUrl: transformUrl, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    return {
        actions: (0, $4omKw.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            product: product,
            rovoConfig: rovoConfig,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            ...(0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: transformUrl
            } : undefined
        }),
        appliedToComponentsCount: (0, $eeqm3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $eeqm3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $eeqm3.extractAttachmentCount)(data),
        authorGroup: (0, $cLyLO.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $7LPcf.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $6hJQj.extractPersonsUpdatedBy)(data),
        commentCount: (0, $eeqm3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $eeqm3.extractViewCount)(data),
        reactCount: (0, $eeqm3.extractSmartLinkReactCount)(response),
        voteCount: (0, $eeqm3.extractVoteCount)(data),
        checklistProgress: (0, $eeqm3.extractChecklistProgress)(data),
        createdBy: (0, $ddzkt.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $eeqm3.extractOwnedBy)(data),
        assignedTo: (0, $eeqm3.extractAssignedTo)(data),
        createdOn: (0, $cbT5r.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $eeqm3.extractDueOn)(data),
        latestCommit: (0, $hYTxH.extractLatestCommit)(data),
        linkIcon: (0, $fBEPJ.extractSmartLinkIcon)(response),
        linkTitle: (0, $emAbv.default)(status, props.url, response, onClick, onAuxClick, onContextMenu),
        location: (0, $eeqm3.extractLocation)(data),
        modifiedBy: (0, $e1RBl.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $ltT9o.extractSmartLinkModifiedOn)(response),
        preview: (0, $iRL51.extractSmartLinkPreviewImage)(response),
        priority: (0, $k8KyO.default)(data),
        provider: (0, $iDrrr.fg)('platform_sl_google_rebrand') ? (0, $eSImY.default)(response) : (0, $7UwLu.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $eeqm3.extractProgrammingLanguage)(data),
        readTime: (0, $eeqm3.extractReadTime)(data),
        sentOn: (0, $eeqm3.extractSmartLinkSentOn)(response),
        snippet: (0, $39PqP.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $eeqm3.extractSourceBranch)(data),
        state: (0, $igQUs.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? transformUrl : undefined, (0, $iDrrr.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined),
        subscriberCount: (0, $eeqm3.extractSubscriberCount)(data),
        subTasksProgress: (0, $eeqm3.extractSubTasksProgress)(data),
        storyPoints: (0, $eeqm3.extractStoryPoints)(data),
        targetBranch: (0, $eeqm3.extractTargetBranch)(data),
        userAttributes: (0, $eeqm3.extractUserAttributes)(data),
        teamMemberCount: (0, $eeqm3.extractTeamMemberCount)(data),
        url: url,
        ari: (0, $lXmY5.extractSmartLinkAri)(response),
        type: (0, $4FdKz.extractType)(data),
        meta: {
            objectId: (0, $eeqm3.extractMetaObjectId)(meta),
            resourceType: (0, $eeqm3.extractMetaResourceType)(meta),
            tenantId: (0, $eeqm3.extractMetaTenantId)(meta)
        },
        hostName: (0, $eeqm3.extractHostName)(response)
    };
};
var $3e8bfec00ff792aa$export$2e2bcd8739ae039 = $3e8bfec00ff792aa$var$extractFlexibleUiContext;
module.exports["default"] = $3e8bfec00ff792aa$export$2e2bcd8739ae039;

});

parcelRegister("lXmY5", function(module, exports) {

var $hiX3M = parcelRequire("hiX3M");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $652810c159b94aae$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.ari || (0, $8YE7G.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $hiX3M.extractAri)(data);
};
module.exports["extractSmartLinkAri"] = $652810c159b94aae$export$16b02be3e2bb31ad;

});

parcelRegister("cLyLO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $b816614c9f5e4543$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $htsh0.extractPersonCreatedBy)(response.data);
};
module.exports["extractSmartLinkAuthorGroup"] = $b816614c9f5e4543$export$41fc716e1bc2dc90;

});

parcelRegister("ddzkt", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $8118f7b98ace9299$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $htsh0.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
module.exports["extractSmartLinkCreatedBy"] = $8118f7b98ace9299$export$242875b46118beb2;

});

parcelRegister("cbT5r", function(module, exports) {

var $04wHu = parcelRequire("04wHu");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $0016e53066bcc8e1$export$7a685df468cbf38f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $04wHu.extractDateCreated)(response.data);
};
module.exports["extractSmartLinkCreatedOn"] = $0016e53066bcc8e1$export$7a685df468cbf38f;

});

parcelRegister("04wHu", function(module, exports) {
const $cb783639b44cd885$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $cb783639b44cd885$export$e1226a5e0bbbf862;

});

parcelRegister("e1RBl", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $JTvZe = parcelRequire("JTvZe");


var $kAdyG = parcelRequire("kAdyG");

const $0ec810a5f5f35d9a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $JTvZe.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
module.exports["extractSmartLinkModifiedBy"] = $0ec810a5f5f35d9a$export$7f099a839071a190;

});

parcelRegister("ltT9o", function(module, exports) {

var $hltP6 = parcelRequire("hltP6");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $42cf6b151797d39e$export$75047940e157fd1f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $hltP6.extractDateUpdated)(response.data);
};
module.exports["extractSmartLinkModifiedOn"] = $42cf6b151797d39e$export$75047940e157fd1f;

});

parcelRegister("hltP6", function(module, exports) {
const $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("39PqP", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");

var $kAdyG = parcelRequire("kAdyG");

const $0c0165a0a1a1634a$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $0c0165a0a1a1634a$export$8c6b9b49f358840 = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.description;
    return response?.data && $0c0165a0a1a1634a$export$db5a8500f6b6286e(response.data);
};
module.exports["extractSmartLinkSummary"] = $0c0165a0a1a1634a$export$8c6b9b49f358840;

});

parcelRegister("4omKw", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $6xM6r = parcelRequire("6xM6r");


var $jMbWL = parcelRequire("jMbWL");


var $fYH1Q = parcelRequire("fYH1Q");


var $524Ey = parcelRequire("524Ey");


var $h8eRG = parcelRequire("h8eRG");


var $hb494 = parcelRequire("hb494");


var $irGZZ = parcelRequire("irGZZ");


var $78FxT = parcelRequire("78FxT");

const $33660386a90b3130$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, product: product, response: response, rovoConfig: rovoConfig, transformUrl: transformUrl, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $4yYAm.ActionName).CopyLinkAction]: (0, $fYH1Q.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4yYAm.ActionName).DownloadAction]: (0, $524Ey.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4yYAm.ActionName).FollowAction]: (0, $h8eRG.default)(response, actionOptions, id),
        [(0, $4yYAm.ActionName).PreviewAction]: (0, $hb494.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            ...(0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: transformUrl
            } : undefined
        }),
        [(0, $4yYAm.ActionName).AutomationAction]: (0, $jMbWL.extractAutomationAction)(response),
        [(0, $4yYAm.InternalActionName).AISummaryAction]: (0, $6xM6r.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $4yYAm.ActionName).RovoChatAction]: (0, $irGZZ.default)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            product: product,
            response: response,
            rovoConfig: rovoConfig
        }),
        [(0, $4yYAm.InternalActionName).ViewRelatedLinksAction]: (0, $78FxT.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
module.exports["extractFlexibleCardActions"] = $33660386a90b3130$export$abe8d0ca1daa1755;

});

parcelRegister("6xM6r", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $98Ma9 = parcelRequire("98Ma9");


var $lOOiS = parcelRequire("lOOiS");

const $df0652b82bcf79d1$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).AISummaryAction, actionOptions) || !(0, $lOOiS.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};
module.exports["extractAISummaryAction"] = $df0652b82bcf79d1$export$e7f7a50a8b8932df;

});

parcelRegister("98Ma9", function(module, exports) {
const $0142dd557f1abf4d$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};
module.exports["canShowAction"] = $0142dd557f1abf4d$export$2487b058456cca75;

});

parcelRegister("jMbWL", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $2292e96bf8ec69a8$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $4yYAm.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};
module.exports["extractAutomationAction"] = $2292e96bf8ec69a8$export$f913cc6abf3ec084;

});

parcelRegister("fYH1Q", function(module, exports) {

var $bVyUW = parcelRequire("bVyUW");

const $430f851bfe7512e2$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $bVyUW.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractCopyLinkClientAction"] = $430f851bfe7512e2$export$31ddd5c40039ce53;

});

parcelRegister("bVyUW", function(module, exports) {

var $3ewaO = parcelRequire("3ewaO");


var $4yYAm = parcelRequire("4yYAm");





var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");

const $44f9f0e7452f446b$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $4yYAm.ActionName).CopyLinkAction,
        definitionId: (0, $2Q7sv.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $2Q7sv.getExtensionKey)(response),
        id: id,
        resourceType: (0, $2Q7sv.getResourceType)(response)
    };
};
module.exports["extractInvokeCopyLinkAction"] = $44f9f0e7452f446b$export$5ec86886067a062d;

});

parcelRegister("524Ey", function(module, exports) {

var $apFwO = parcelRequire("apFwO");

const $4623e5e8ceeb2845$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $apFwO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractDownloadClientAction"] = $4623e5e8ceeb2845$export$f6c386869a352b1f;

});

parcelRegister("apFwO", function(module, exports) {

var $hoB2R = parcelRequire("hoB2R");


var $4yYAm = parcelRequire("4yYAm");





var $2Q7sv = parcelRequire("2Q7sv");


var $16kNn = parcelRequire("16kNn");


var $98Ma9 = parcelRequire("98Ma9");


var $aTUup = parcelRequire("aTUup");

const $60e6e59f530d86aa$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $aTUup.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $hoB2R.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $16kNn.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $4yYAm.ActionName).DownloadAction,
            definitionId: (0, $2Q7sv.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $2Q7sv.getExtensionKey)(response),
            id: id,
            resourceType: (0, $2Q7sv.getResourceType)(response)
        };
    }
};
module.exports["extractInvokeDownloadAction"] = $60e6e59f530d86aa$export$ea97cd34c2ca86de;

});

parcelRegister("hoB2R", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $dedbbfb6fd3975a3$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkDownloadUrl"] = $dedbbfb6fd3975a3$export$96ed4c1b14ac210a;

});

parcelRegister("aTUup", function(module, exports) {
const $817aefb3251744bd$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
module.exports["getActionsFromJsonLd"] = $817aefb3251744bd$export$8f031784a3a03b23;

});

parcelRegister("h8eRG", function(module, exports) {

var $jMcHR = parcelRequire("jMcHR");

var $4FdKz = parcelRequire("4FdKz");


var $eWtDJ = parcelRequire("eWtDJ");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $dz3ZB = parcelRequire("dz3ZB");

const $6454219eec79705b$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $dz3ZB.default)(data);
    const type = (0, $4FdKz.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $eWtDJ.SmartLinkActionType).FollowEntityAction || actionName === (0, $eWtDJ.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $jMcHR.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $eWtDJ.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6454219eec79705b$export$2e2bcd8739ae039 = $6454219eec79705b$var$extractFollowAction;
module.exports["default"] = $6454219eec79705b$export$2e2bcd8739ae039;

});

parcelRegister("dz3ZB", function(module, exports) {
const $2b685e3fe936bab8$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $2b685e3fe936bab8$export$2e2bcd8739ae039 = $2b685e3fe936bab8$var$extractServerAction;
module.exports["default"] = $2b685e3fe936bab8$export$2e2bcd8739ae039;

});

parcelRegister("hb494", function(module, exports) {

var $jINxM = parcelRequire("jINxM");

const $2efe6a41c82eedcb$export$9f0d9100b079448 = (param)=>{
    const result = (0, $jINxM.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};
module.exports["extractPreviewClientAction"] = $2efe6a41c82eedcb$export$9f0d9100b079448;

});

parcelRegister("jINxM", function(module, exports) {

var $bw5Pv = parcelRequire("bw5Pv");

var $lXmY5 = parcelRequire("lXmY5");

var $8OcYi = parcelRequire("8OcYi");

var $hHrlI = parcelRequire("hHrlI");

var $7YvXl = parcelRequire("7YvXl");

var $3ewaO = parcelRequire("3ewaO");


var $4aczz = parcelRequire("4aczz");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $4yYAm = parcelRequire("4yYAm");





var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $01k3g = parcelRequire("01k3g");


var $1qrkW = parcelRequire("1qrkW");


var $a3jaM = parcelRequire("a3jaM");


var $fBEPJ = parcelRequire("fBEPJ");


var $apFwO = parcelRequire("apFwO");


var $2FmJb = parcelRequire("2FmJb");

const $ef64dce8a68d6434$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $lXmY5.extractSmartLinkAri)(response);
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    const name = (0, $7YvXl.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $4aczz.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).PreviewAction, actionOptions)) return;
    // Restricted (e.g. cross-unit) resources must not be previewed at all — suppress
    // the action so it does not fall back to a preview modal.
    if (ari && isPreviewRestricted?.({
        ari: ari
    }) && (0, $iDrrr.fg)('preview_panel_unit_check')) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $bw5Pv.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $01k3g.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $apFwO.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $2FmJb.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $1qrkW.extractIsSupportTheming)(meta),
                            isTrusted: (0, $a3jaM.extractIsTrusted)(meta),
                            linkIcon: (0, $fBEPJ.extractLinkIcon)(response),
                            providerName: (0, $hHrlI.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $8OcYi.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $7YvXl.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions?.previewAction?.size,
                            isBlanketHidden: actionOptions?.previewAction?.hideBlanket,
                            ...(0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $4yYAm.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};
module.exports["extractInvokePreviewAction"] = $ef64dce8a68d6434$export$caf83f49e52ac0bb;

});

parcelRegister("4aczz", function(module, exports) {
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $9b81732d1a3b5b72$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $9b81732d1a3b5b72$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $9b81732d1a3b5b72$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $9b81732d1a3b5b72$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $9b81732d1a3b5b72$var$getUrlSearchParams(currentSearch);
            if (currentParams && $9b81732d1a3b5b72$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $9b81732d1a3b5b72$export$24def1b22639c691 = ()=>{
    return $9b81732d1a3b5b72$export$9f140ed41af5108c() && $9b81732d1a3b5b72$export$f274fcef361fe59d();
};
module.exports["isWithinPreviewPanelIFrame"] = $9b81732d1a3b5b72$export$24def1b22639c691;

});

parcelRegister("01k3g", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $fRQ3t = parcelRequire("fRQ3t");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");

let $e71de8c9e06bc4a1$var$reactRoots = new WeakMap();
/** Mounts `element` into `mountPoint`: uses the React 18/19 `createRoot` API when `nike_r19_render_unmount` is on, else the legacy render path. */ const $e71de8c9e06bc4a1$var$renderToMountPoint = (element, mountPoint)=>{
    if ((0, $iDrrr.fg)('nike_r19_render_unmount')) {
        let root = $e71de8c9e06bc4a1$var$reactRoots.get(mountPoint);
        if (!root) {
            root = (0, $fRQ3t.createRoot)(mountPoint);
            $e71de8c9e06bc4a1$var$reactRoots.set(mountPoint, root);
        }
        root.render(element);
    } else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(element, mountPoint);
};
/** Unmounts the tree at `mountPoint`: uses `root.unmount()` when `nike_r19_render_unmount` is on, else the legacy unmount path. */ const $e71de8c9e06bc4a1$var$unmountFromMountPoint = (mountPoint)=>{
    if ((0, $iDrrr.fg)('nike_r19_render_unmount')) {
        const root = $e71de8c9e06bc4a1$var$reactRoots.get(mountPoint);
        if (root) {
            root.unmount();
            $e71de8c9e06bc4a1$var$reactRoots.delete(mountPoint);
        }
    } else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(mountPoint);
};
const $e71de8c9e06bc4a1$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $e71de8c9e06bc4a1$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("8ZVud"));
    $e71de8c9e06bc4a1$var$renderToMountPoint(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal.default, {
        ...props,
        iframeName: $e71de8c9e06bc4a1$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) $e71de8c9e06bc4a1$var$unmountFromMountPoint(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}
module.exports["openEmbedModal"] = $e71de8c9e06bc4a1$export$7859f96cd8cff034;

});

parcelRegister("8ZVud", function(module, exports) {

let $68d09cd1a0d68217$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $68d09cd1a0d68217$var$load("6wr18"),
    $68d09cd1a0d68217$var$load("7EjoG"),
    $68d09cd1a0d68217$var$load("ffEVr"),
    $68d09cd1a0d68217$var$load("Wowvf"),
    $68d09cd1a0d68217$var$load("fkLbQ"),
    $68d09cd1a0d68217$var$load("bMNgp"),
    $68d09cd1a0d68217$var$load("h1yOv"),
    $68d09cd1a0d68217$var$load("hhss7"),
    $68d09cd1a0d68217$var$load("9mGhw")
]).then(()=>parcelRequire('fGlyS'));

});

parcelRegister("1qrkW", function(module, exports) {

var $y3W88 = parcelRequire("y3W88");

const $a1c6aba8f77f7afa$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $y3W88.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};
module.exports["extractIsSupportTheming"] = $a1c6aba8f77f7afa$export$38d755f52cdf4acb;

});

parcelRegister("y3W88", function(module, exports) {
const $f18cdd07bdfda1f7$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $f18cdd07bdfda1f7$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $f18cdd07bdfda1f7$export$84a73a0383f58180 = 'JiraTask';
const $f18cdd07bdfda1f7$export$c6c83963a9378a67 = 'JiraSubTask';
const $f18cdd07bdfda1f7$export$58af3c426c111a6d = 'JiraStory';
const $f18cdd07bdfda1f7$export$ac9898a63417219e = 'JiraBug';
const $f18cdd07bdfda1f7$export$54db5e3fb12e39cd = 'JiraEpic';
const $f18cdd07bdfda1f7$export$2f54a5a217202c85 = 'JiraIncident';
const $f18cdd07bdfda1f7$export$d097371052bfc411 = 'JiraServiceRequest';
const $f18cdd07bdfda1f7$export$efd9452ad16c6676 = 'JiraChange';
const $f18cdd07bdfda1f7$export$2e7e70abb5d81f67 = 'JiraProblem';
const $f18cdd07bdfda1f7$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $f18cdd07bdfda1f7$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpviz-object-provider'
];
module.exports["CONFLUENCE_GENERATOR_ID"] = $f18cdd07bdfda1f7$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $f18cdd07bdfda1f7$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $f18cdd07bdfda1f7$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $f18cdd07bdfda1f7$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $f18cdd07bdfda1f7$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $f18cdd07bdfda1f7$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $f18cdd07bdfda1f7$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $f18cdd07bdfda1f7$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $f18cdd07bdfda1f7$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $f18cdd07bdfda1f7$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $f18cdd07bdfda1f7$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $f18cdd07bdfda1f7$export$ce25cfc40b280dbc;
module.exports["PROVIDER_KEYS_WITH_THEMING"] = $f18cdd07bdfda1f7$export$fe44ce30fd8d131b;

});

parcelRegister("a3jaM", function(module, exports) {
const $388cdc660293d4db$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};
module.exports["extractIsTrusted"] = $388cdc660293d4db$export$4f3ffbb500daac5a;

});

parcelRegister("fBEPJ", function(module, exports) {

var $kku4L = parcelRequire("kku4L");

var $kAdyG = parcelRequire("kAdyG");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $bJ2OW = parcelRequire("bJ2OW");


var $aldDV = parcelRequire("aldDV");


var $7UwLu = parcelRequire("7UwLu");

const $c45d8ee8f3107765$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $bJ2OW.default)(data, renderers);
    return {
        ...(0, $aldDV.default)(data),
        render: render
    };
};
const $c45d8ee8f3107765$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $7UwLu.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $4yYAm.IconType).Forbidden
            };
        case (0, $4yYAm.SmartLinkStatus).NotFound:
            return {
                icon: (0, $4yYAm.IconType).Error
            };
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $4yYAm.IconType).Default
            };
    }
};
const $c45d8ee8f3107765$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        if ((0, $kAdyG.isEntityPresent)(response)) {
            const entityIcon = (0, $kku4L.extractEntityIcon)(response);
            if (entityIcon) return entityIcon;
        }
    } else {
        if ((0, $kAdyG.isEntityPresent)(response)) return (0, $kku4L.extractEntityIcon)(response);
    }
    return $c45d8ee8f3107765$export$43612bed147eae48(response, renderers);
};
module.exports["extractLinkIcon"] = $c45d8ee8f3107765$export$43612bed147eae48;
module.exports["extractErrorIcon"] = $c45d8ee8f3107765$export$bdd29be9b0395931;
module.exports["extractSmartLinkIcon"] = $c45d8ee8f3107765$export$35040aed9264b11c;

});

parcelRegister("bJ2OW", function(module, exports) {
const $6d3228577637aa25$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $6d3228577637aa25$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $6d3228577637aa25$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $6d3228577637aa25$export$2e2bcd8739ae039 = $6d3228577637aa25$var$extractIconRenderer;
module.exports["default"] = $6d3228577637aa25$export$2e2bcd8739ae039;

});

parcelRegister("aldDV", function(module, exports) {

var $jqhMF = parcelRequire("jqhMF");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $2Pj3a = parcelRequire("2Pj3a");


var $i9AjY = parcelRequire("i9AjY");


var $8mPrX = parcelRequire("8mPrX");


var $y3W88 = parcelRequire("y3W88");


var $aX5dQ = parcelRequire("aX5dQ");


var $1VjCT = parcelRequire("1VjCT");


var $jQ3fx = parcelRequire("jQ3fx");


var $7UwLu = parcelRequire("7UwLu");


var $2P0qx = parcelRequire("2P0qx");

const $d862403e920df0d6$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8mPrX.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d862403e920df0d6$var$extractTaskNew = (data)=>{
    const taskTypeInfo = (0, $8mPrX.extractTaskType)(data) || {};
    const { id: id, icon: url, name: name } = taskTypeInfo;
    const taskType = id?.split('#').pop();
    const taskIconLabel = name?.trim() || 'Task';
    const taskIcon = url ? {
        label: taskIconLabel,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d862403e920df0d6$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0] : type;
};
const $d862403e920df0d6$var$isJiraProvider = (provider)=>provider === (0, $y3W88.JIRA_GENERATOR_ID);
function $d862403e920df0d6$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $1VjCT.default)(fileFormat);
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const iconDescriptor = $d862403e920df0d6$var$typeToIconDescriptor({
            type: type,
            providerId: providerId,
            data: data
        });
        const documentTitle = (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? undefined : (0, $jqhMF.extractTitle)(data);
        const extractedDocumentTypeIcon = (0, $aX5dQ.default)(type, documentTitle, providerId);
        const documentTypeIcon = iconDescriptor || extractedDocumentTypeIcon;
        const urlIconNew = (0, $2P0qx.default)(data.icon, documentTypeIcon?.label);
        return (0, $2Pj3a.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIconNew,
            providerIcon: providerIcon
        });
    } else {
        const documentTypeIcon = $d862403e920df0d6$var$typeToIconDescriptor({
            type: type,
            label: label,
            providerId: providerId,
            data: data
        }) || (0, $aX5dQ.default)(type, label, providerId);
        return (0, $2Pj3a.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIcon,
            providerIcon: providerIcon
        });
    }
}
function $d862403e920df0d6$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    const descriptorLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : label;
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $4yYAm.IconType).Task,
                label: descriptorLabel('goal')
            };
        case 'atlassian:Project':
            return {
                // FIXME: atlassian:Project seem to be returned for many things, including Confluence space or Trello board,
                // But `IconType.Project` actual value is `BitBucket:Project`!
                icon: (0, $4yYAm.IconType).Project,
                label: descriptorLabel('project')
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $4yYAm.IconType).Commit,
                label: descriptorLabel('commit')
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $4yYAm.IconType).PullRequest,
                label: descriptorLabel('pull request')
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $4yYAm.IconType).Branch,
                label: descriptorLabel('branch')
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $4yYAm.IconType).Repo,
                label: descriptorLabel('repository')
            };
        case 'atlassian:Task':
            if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
                const taskIconDescriptor = {
                    icon: (0, $4yYAm.IconType).Task,
                    label: descriptorLabel('task')
                };
                if ($d862403e920df0d6$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $d862403e920df0d6$var$extractTaskNew(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $jQ3fx.default)(taskType);
                }
                return taskIconDescriptor;
            } else {
                const taskLabel = label || 'Task';
                const taskIconDescriptor = {
                    icon: (0, $4yYAm.IconType).Task,
                    label: taskLabel
                };
                if ($d862403e920df0d6$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $d862403e920df0d6$var$extractTask(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $jQ3fx.default)(taskType, taskLabel);
                }
                return taskIconDescriptor;
            }
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $d862403e920df0d6$var$extractJsonldDataIcon = (data)=>{
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const type = $d862403e920df0d6$var$extractType(data);
        const providerIcon = (0, $7UwLu.default)(data);
        return $d862403e920df0d6$var$chooseIcon({
            type: type,
            data: data,
            providerIcon: providerIcon
        });
    } else {
        const label = (0, $jqhMF.extractTitle)(data);
        const type = $d862403e920df0d6$var$extractType(data);
        const urlIcon = (0, $2P0qx.default)(data.icon, label);
        const providerIcon = (0, $7UwLu.default)(data);
        return $d862403e920df0d6$var$chooseIcon({
            urlIcon: urlIcon,
            providerIcon: providerIcon,
            type: type,
            label: label,
            data: data
        });
    }
};
var $d862403e920df0d6$export$2e2bcd8739ae039 = $d862403e920df0d6$var$extractJsonldDataIcon;
module.exports["default"] = $d862403e920df0d6$export$2e2bcd8739ae039;

});

parcelRegister("2Pj3a", function(module, exports) {
/**
 * Options required to prioritise which icon to show
 */ function $4e81f2f1044982ba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}
module.exports["prioritiseIcon"] = $4e81f2f1044982ba$export$65e47eb22a387a86;

});

parcelRegister("i9AjY", function(module, exports) {
const $936fbc58b48eda25$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
module.exports["extractorPriorityMap"] = $936fbc58b48eda25$export$e0deaeb4a2dfe2b4;

});

parcelRegister("8mPrX", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $d0bc942c0997c3eb$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
module.exports["extractTaskType"] = $d0bc942c0997c3eb$export$ed3fd59180514d27;

});

parcelRegister("aX5dQ", function(module, exports) {

var $c1Kdq = parcelRequire("c1Kdq");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");

/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $3153f71083dbedd3$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    const getLabel = (hardcodedLabel)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label;
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $4yYAm.IconType).Blog,
                label: getLabel('blog')
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $c1Kdq.isConfluenceGenerator)(providerId)) return {
                icon: (0, $4yYAm.IconType).LiveDocument,
                label: getLabel('live document')
            };
            else return {
                icon: (0, $4yYAm.IconType).File,
                label: getLabel('file')
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Document,
                label: getLabel('document')
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Presentation,
                label: getLabel('presentation')
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Spreadsheet,
                label: getLabel('spreadsheet')
            };
        case 'atlassian:Template':
            return {
                icon: (0, $4yYAm.IconType).Template,
                label: getLabel('template')
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $4yYAm.IconType).Document,
                label: getLabel('document')
            };
        default:
            return undefined;
    }
};
var $3153f71083dbedd3$export$2e2bcd8739ae039 = $3153f71083dbedd3$var$extractDocumentTypeIcon;
module.exports["default"] = $3153f71083dbedd3$export$2e2bcd8739ae039;

});

parcelRegister("c1Kdq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $b2f43b4ca89bcf94$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
module.exports["isConfluenceGenerator"] = $b2f43b4ca89bcf94$export$38df542ff03a4183;

});

parcelRegister("jQ3fx", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");

const $616c5048633b5d21$var$extractJiraTaskIcon = (taskType, label)=>{
    const getLabel = (hardcodedLabel)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label || 'Task';
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $4yYAm.IconType).Bug,
                label: getLabel('Bug')
            };
        case 'JiraChange':
            return {
                icon: (0, $4yYAm.IconType).Change,
                label: getLabel('Change')
            };
        case 'JiraEpic':
            return {
                icon: (0, $4yYAm.IconType).Epic,
                label: getLabel('Epic')
            };
        case 'JiraIncident':
            return {
                icon: (0, $4yYAm.IconType).Incident,
                label: getLabel('Incident')
            };
        case 'JiraProblem':
            return {
                icon: (0, $4yYAm.IconType).Problem,
                label: getLabel('Problem')
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $4yYAm.IconType).ServiceRequest,
                label: getLabel('Service request')
            };
        case 'JiraStory':
            return {
                icon: (0, $4yYAm.IconType).Story,
                label: getLabel('Story')
            };
        case 'JiraSubTask':
            return {
                icon: (0, $4yYAm.IconType).SubTask,
                label: getLabel('Sub-task')
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $4yYAm.IconType).Task,
                label: getLabel('Task')
            };
    }
};
var $616c5048633b5d21$export$2e2bcd8739ae039 = $616c5048633b5d21$var$extractJiraTaskIcon;
module.exports["default"] = $616c5048633b5d21$export$2e2bcd8739ae039;

});

parcelRegister("7UwLu", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");

var $g0csk = parcelRequire("g0csk");

var $jqhMF = parcelRequire("jqhMF");

var $kAdyG = parcelRequire("kAdyG");


var $4yYAm = parcelRequire("4yYAm");


var $y3W88 = parcelRequire("y3W88");


var $2P0qx = parcelRequire("2P0qx");

/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $b98c3a64f7967b2a$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $jqhMF.extractTitle)(data);
    if (provider === (0, $y3W88.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $y3W88.JIRA_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $2P0qx.default)(icon, label);
};
var $b98c3a64f7967b2a$export$2e2bcd8739ae039 = $b98c3a64f7967b2a$var$extractProviderIcon;
const $b98c3a64f7967b2a$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $y3W88.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $4yYAm.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $y3W88.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $4yYAm.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $8YE7G.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $b98c3a64f7967b2a$var$extractProviderIcon(response.data);
};
module.exports["default"] = $b98c3a64f7967b2a$export$2e2bcd8739ae039;
module.exports["extractSmartLinkProviderIcon"] = $b98c3a64f7967b2a$export$5def189f04eea025;

});

parcelRegister("2P0qx", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $21ca246200c193a5$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $2GG3F.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $21ca246200c193a5$export$2e2bcd8739ae039 = $21ca246200c193a5$var$extractUrlIcon;
module.exports["default"] = $21ca246200c193a5$export$2e2bcd8739ae039;

});

parcelRegister("2FmJb", function(module, exports) {

var $jMcHR = parcelRequire("jMcHR");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $16kNn = parcelRequire("16kNn");


var $98Ma9 = parcelRequire("98Ma9");


var $aTUup = parcelRequire("aTUup");

const $eacd17f647b08bbc$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, transformUrl: transformUrl, id: id, response: response }, force)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $jMcHR.extractLink)(data);
    const viewActionExists = (0, $aTUup.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>{
            if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
                const destinationUrl = transformUrl?.(url) ?? url;
                return (0, $16kNn.openUrl)(destinationUrl);
            }
            return (0, $16kNn.openUrl)(url);
        },
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $2Q7sv.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $2Q7sv.getExtensionKey)(response),
        id: id,
        resourceType: (0, $2Q7sv.getResourceType)(response)
    };
};
module.exports["extractInvokeViewAction"] = $eacd17f647b08bbc$export$88c5813cfbbe4e4c;

});

parcelRegister("irGZZ", function(module, exports) {

var $3ewaO = parcelRequire("3ewaO");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $aflIU = parcelRequire("aflIU");

// For block card experiment (NAVX-4814)
const $62820a0adcb55b8e$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $62820a0adcb55b8e$var$extractRovoChatAction = ({ actionOptions: actionOptions, appearance: appearance, id: id, isEmbedRovoActionsFooterExperimentEnabled: isEmbedRovoActionsFooterExperimentEnabled, product: product, response: response, rovoConfig: rovoConfig })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).RovoChatAction, actionOptions)) return;
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig?.rovoOptions);
    if (!isRovoChatEnabled) return;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
    const isInlineExperimentEnabled = (0, $iDrrr.fg)('platform_sl_3p_auth_inline_tailored_cta_killswitch') && (0, $anBbz.expValEqualsNoExposure)('platform_sl_3p_auth_inline_tailored_cta', 'isEnabled', true);
    const is3PBlockPostAuthActionsEnabled = extensionKey !== undefined && $62820a0adcb55b8e$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey) && rovoConfig?.product === 'CONFLUENCE';
    const is3PEmbedPostAuthActionsEnabled = isEmbedRovoActionsFooterExperimentEnabled === true;
    const isSupportedFeature = is3PBlockPostAuthActionsEnabled || isInlineExperimentEnabled || is3PEmbedPostAuthActionsEnabled;
    const isOptIn = actionOptions?.rovoChatAction?.optIn === true;
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    return isSupportedFeature && isOptIn ? {
        invokeAction: {
            actionSubjectId: 'rovoChatPrompt',
            actionType: (0, $4yYAm.ActionName).RovoChatAction,
            definitionId: (0, $2Q7sv.getDefinitionId)(response),
            display: appearance,
            extensionKey: extensionKey,
            id: id,
            resourceType: (0, $2Q7sv.getResourceType)(response)
        },
        product: product,
        url: url
    } : undefined;
};
var $62820a0adcb55b8e$export$2e2bcd8739ae039 = $62820a0adcb55b8e$var$extractRovoChatAction;
module.exports["default"] = $62820a0adcb55b8e$export$2e2bcd8739ae039;

});

parcelRegister("78FxT", function(module, exports) {

var $lXmY5 = parcelRequire("lXmY5");

const $b78fcf394208fce3$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $lXmY5.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};
module.exports["extractViewRelatedLinksAction"] = $b78fcf394208fce3$export$debae7424a0231b9;

});

parcelRegister("6hJQj", function(module, exports) {

var $4ZxtP = parcelRequire("4ZxtP");

var $9EREa = parcelRequire("9EREa");

const $bee1077b61636bdc$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $4ZxtP.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};
module.exports["extractPersonsUpdatedBy"] = $bee1077b61636bdc$export$216e4f6aa7c169b8;

});

parcelRegister("4ZxtP", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $4dbfd7f5dbf19ca5$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9EREa.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9EREa.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $4dbfd7f5dbf19ca5$export$6281d080d62a0719;

});

parcelRegister("emAbv", function(module, exports) {

var $7YvXl = parcelRequire("7YvXl");

var $3ewaO = parcelRequire("3ewaO");


var $4yYAm = parcelRequire("4yYAm");

const $e366d9a2a40cc6bc$var$extractLinkTitle = (status, propUrl, response, onClick, onAuxClick, onContextMenu)=>{
    const responseUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
    const url = status === (0, $4yYAm.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $7YvXl.extractSmartLinkTitle)(response);
    const text = status === (0, $4yYAm.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        text: text,
        url: url
    };
};
var $e366d9a2a40cc6bc$export$2e2bcd8739ae039 = $e366d9a2a40cc6bc$var$extractLinkTitle;
module.exports["default"] = $e366d9a2a40cc6bc$export$2e2bcd8739ae039;

});

parcelRegister("iRL51", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");

var $d4O2g = parcelRequire("d4O2g");

var $kAdyG = parcelRequire("kAdyG");


var $4yYAm = parcelRequire("4yYAm");

const $31e8e497c67842e8$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $d4O2g.extractImage)(data);
    return url ? {
        type: (0, $4yYAm.MediaType).Image,
        url: url
    } : undefined;
};
var $31e8e497c67842e8$export$2e2bcd8739ae039 = $31e8e497c67842e8$var$extractPreview;
const $31e8e497c67842e8$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $4yYAm.MediaType).Image,
            url: url
        } : undefined;
    }
    return $31e8e497c67842e8$var$extractPreview(response.data);
};
module.exports["extractSmartLinkPreviewImage"] = $31e8e497c67842e8$export$a79836076066b8b6;

});

parcelRegister("d4O2g", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $b61bca3ca7bdd7f0$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $1kPn4.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $1kPn4.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $b61bca3ca7bdd7f0$export$4c753a1297cb9805;

});

parcelRegister("k8KyO", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");


var $4yYAm = parcelRequire("4yYAm");

const $a743bfb81d3280a1$var$priorityMapper = {
    blocker: (0, $4yYAm.IconType).PriorityBlocker,
    critical: (0, $4yYAm.IconType).PriorityCritical,
    high: (0, $4yYAm.IconType).PriorityHigh,
    highest: (0, $4yYAm.IconType).PriorityHighest,
    low: (0, $4yYAm.IconType).PriorityLow,
    lowest: (0, $4yYAm.IconType).PriorityLowest,
    major: (0, $4yYAm.IconType).PriorityMajor,
    medium: (0, $4yYAm.IconType).PriorityMedium,
    minor: (0, $4yYAm.IconType).PriorityMinor,
    trivial: (0, $4yYAm.IconType).PriorityTrivial,
    undefined: (0, $4yYAm.IconType).PriorityUndefined
};
const $a743bfb81d3280a1$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $a743bfb81d3280a1$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $a743bfb81d3280a1$export$2e2bcd8739ae039 = $a743bfb81d3280a1$var$extractPriority;
module.exports["default"] = $a743bfb81d3280a1$export$2e2bcd8739ae039;

});

parcelRegister("eSImY", function(module, exports) {

var $hHrlI = parcelRequire("hHrlI");


var $4yYAm = parcelRequire("4yYAm");


var $y3W88 = parcelRequire("y3W88");

const $fcaa8ed9f9022e61$var$extractProvider = (response)=>{
    const provider = (0, $hHrlI.extractSmartLinkProvider)(response);
    if (!provider) return;
    const providerName = provider.text;
    if (provider.id === (0, $y3W88.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Confluence,
        label: providerName || 'Confluence'
    };
    if (provider.id === (0, $y3W88.JIRA_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Jira,
        label: providerName || 'Jira'
    };
    if (providerName) return {
        label: providerName,
        url: typeof provider.icon === 'string' ? provider.icon : undefined
    };
};
var $fcaa8ed9f9022e61$export$2e2bcd8739ae039 = $fcaa8ed9f9022e61$var$extractProvider;
module.exports["default"] = $fcaa8ed9f9022e61$export$2e2bcd8739ae039;

});

parcelRegister("igQUs", function(module, exports) {

var $jMcHR = parcelRequire("jMcHR");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $jINxM = parcelRequire("jINxM");


var $2Mkmh = parcelRequire("2Mkmh");


var $dz3ZB = parcelRequire("dz3ZB");

const $b2b984cf2b128c1f$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $b2b984cf2b128c1f$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $dz3ZB.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $b2b984cf2b128c1f$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $jMcHR.extractLink)(data);
    const invokePreviewAction = response ? (0, $jINxM.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve({
                url: url,
                isReloading: true
            }) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
            isPreviewRestricted: isPreviewRestricted
        } : undefined,
        openPreviewPanel: openPreviewPanel,
        ...(0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? {
            transformUrl: transformUrl
        } : undefined
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $b2b984cf2b128c1f$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $b2b984cf2b128c1f$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $2Mkmh.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $b2b984cf2b128c1f$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? transformUrl : undefined, (0, $iDrrr.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined);
    return {
        ...lozenge,
        action: action
    };
};
var $b2b984cf2b128c1f$export$2e2bcd8739ae039 = $b2b984cf2b128c1f$var$extractState;
module.exports["default"] = $b2b984cf2b128c1f$export$2e2bcd8739ae039;

});

parcelRegister("2Mkmh", function(module, exports) {

var $4FdKz = parcelRequire("4FdKz");


var $2vpap = parcelRequire("2vpap");


var $2kOxL = parcelRequire("2kOxL");


var $77Vrx = parcelRequire("77Vrx");


var $8mPrX = parcelRequire("8mPrX");

const $e166bb124f5014dc$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4FdKz.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $2kOxL.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $77Vrx.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $e166bb124f5014dc$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $2vpap.extractState)(jsonLd);
    }
};
const $e166bb124f5014dc$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $8mPrX.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};
module.exports["extractLozenge"] = $e166bb124f5014dc$export$e5da155556a77bca;

});

parcelRegister("2vpap", function(module, exports) {

var $eZiNI = parcelRequire("eZiNI");

// Maps accent color short names to their corresponding background and text colors
const $29dee88bf4e3c006$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        color: "var(--ds-text-accent-blue, #1558BC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        color: "var(--ds-text-accent-gray, #505258)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
        color: "var(--ds-text-accent-orange, #9E4C00)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        color: "var(--ds-text-accent-purple, #803FA5)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $29dee88bf4e3c006$var$capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $29dee88bf4e3c006$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $eZiNI.OMIT_STATES).includes(linkState)) return {
                text: $29dee88bf4e3c006$var$capitalize(linkState),
                appearance: (0, $eZiNI.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $29dee88bf4e3c006$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};
module.exports["extractState"] = $29dee88bf4e3c006$export$5e4074cbce6574c7;

});

parcelRegister("eZiNI", function(module, exports) {
const $6cea38ed52bda634$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $6cea38ed52bda634$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $6cea38ed52bda634$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $6cea38ed52bda634$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default',
    'queued to merge': 'moved'
};
const $6cea38ed52bda634$export$772610da74ddbc07 = [
    'current'
];
module.exports["isValidAppearance"] = $6cea38ed52bda634$export$ce6b5b303f8e3c99;
module.exports["VALID_STATES"] = $6cea38ed52bda634$export$7b1deaaad25d1dc1;
module.exports["OMIT_STATES"] = $6cea38ed52bda634$export$772610da74ddbc07;

});

parcelRegister("2kOxL", function(module, exports) {

var $eZiNI = parcelRequire("eZiNI");

const $b2c263e15de4bef1$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($b2c263e15de4bef1$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $b2c263e15de4bef1$var$extractTagItem(tag);
    }
};
const $b2c263e15de4bef1$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $eZiNI.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};
module.exports["extractTag"] = $b2c263e15de4bef1$export$962a8da34cf78a4f;

});

parcelRegister("77Vrx", function(module, exports) {
const $3c63915f1609dad1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};
module.exports["extractTaskStatus"] = $3c63915f1609dad1$export$7698df1946deda72;

});

parcelRegister("hYTxH", function(module, exports) {
const $22c291da19a1c245$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};
module.exports["extractLatestCommit"] = $22c291da19a1c245$export$f222392162cff0d8;

});

parcelRegister("dcCaJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $jdqmT = parcelRequire("jdqmT");


var $euBHF = parcelRequire("euBHF");


var $bVAqi = parcelRequire("bVAqi");


var $9PQfP = parcelRequire("9PQfP");

var $8v3AV = parcelRequire("8v3AV");

var $i9PP7 = parcelRequire("i9PP7");

var $i1503 = parcelRequire("i1503");

var $es2gJ = parcelRequire("es2gJ");

var $jdA6O = parcelRequire("jdA6O");


var $6nncv = parcelRequire("6nncv");


var $9BEAr = parcelRequire("9BEAr");

const $9a8a2863bdf59a4a$var$hiddenSnippetStyles = null;
const $9a8a2863bdf59a4a$var$titleBlockStyles = null;
const $9a8a2863bdf59a4a$var$snippetBlockCss = null;
const $9a8a2863bdf59a4a$var$actionBlockCss = null;
const $9a8a2863bdf59a4a$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $jdqmT.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        }); // UFO will disregard this if authentication experience has not yet been started
        (0, $jdqmT.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $cozmU.useMemo)(()=>{
        return (0, $6nncv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(0);
    const snippetBlockRef = (0, $cozmU.useRef)(null);
    const onSnippetRender = (0, $cozmU.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $9BEAr.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        className: (0, $hekY6.default)([
            "_0Of8r21Y8M"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVAqi.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        ...titleBlockProps,
        metadataPosition: (0, $4yYAm.SmartLinkPosition).Top,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _1LQKoXPgdg _1BPXJ2Q4SZ _2C9dkJ7GSX"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9PP7.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $hekY6.default)([
            "_0fKRyPnQyn _1mT5xdWVPG"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PQfP.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        className: (0, $hekY6.default)([
            "_1wydGW1Y8M"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8v3AV.default), null));
};
var $9a8a2863bdf59a4a$export$2e2bcd8739ae039 = $9a8a2863bdf59a4a$var$HoverCardResolvedView;
module.exports["default"] = $9a8a2863bdf59a4a$export$2e2bcd8739ae039;

});

parcelRegister("9BEAr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iRL51 = parcelRequire("iRL51");


var $voDgt = parcelRequire("voDgt");

const $109b8409b5ebe112$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $cozmU.useRef)(false);
    const previewBlockRef = (0, $cozmU.useRef)(null);
    const [showPreview, setShowPreview] = (0, $cozmU.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $cozmU.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $cozmU.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $cozmU.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $cozmU.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $iRL51.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $voDgt.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $109b8409b5ebe112$export$2e2bcd8739ae039 = $109b8409b5ebe112$var$ImagePreview;
module.exports["default"] = $109b8409b5ebe112$export$2e2bcd8739ae039;

});

parcelRegister("exTWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $htZ7r = parcelRequire("htZ7r");


var $3qg1D = parcelRequire("3qg1D");


var $3M4EV = parcelRequire("3M4EV");


var $bt1e6 = parcelRequire("bt1e6");


var $7CAOU = parcelRequire("7CAOU");

const $8119c3383e55cb16$var$loadingViewContainer = null;
const $8119c3383e55cb16$var$skeletonContainer = null;
const $8119c3383e55cb16$var$titleStyle = null;
const $8119c3383e55cb16$var$titleBlockStyles = null;
const $8119c3383e55cb16$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $7CAOU.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3M4EV.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8g1xE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _39xV02N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt1e6.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _0jFU0VbKFA _0VARMJN91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $8119c3383e55cb16$export$2e2bcd8739ae039 = $8119c3383e55cb16$var$HoverCardLoadingView;
module.exports["default"] = $8119c3383e55cb16$export$2e2bcd8739ae039;

});

parcelRegister("apqge", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $hHrlI = parcelRequire("hHrlI");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $iUTeb = parcelRequire("iUTeb");


var $2Q7sv = parcelRequire("2Q7sv");


var $4bvRC = parcelRequire("4bvRC");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");


var $3M4EV = parcelRequire("3M4EV");


var $hsIfr = parcelRequire("hsIfr");

const $0784325f946f0262$var$connectButtonStyles = null;
const $0784325f946f0262$var$titleBlockStyles = null;
const $0784325f946f0262$var$mainTextStyles = null;
const $0784325f946f0262$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hHrlI.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $2Q7sv.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $iUTeb.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4yYAm.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $cozmU.useMemo)(()=>[
            {
                name: (0, $4yYAm.ActionName).CustomAction,
                content: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-title`,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2C9dkJ7GSX"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), null), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-content`,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $4bvRC.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-button`,
        className: (0, $hekY6.default)([
            "_37wbyuz9WS _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $0784325f946f0262$export$2e2bcd8739ae039 = $0784325f946f0262$var$HoverCardUnauthorisedView;
module.exports["default"] = $0784325f946f0262$export$2e2bcd8739ae039;

});

parcelRegister("4bvRC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $c5ed75a9c5c2c5b7$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $iDrrr.fg)('product-terminology-refresh') ? (0, $dM7c5.messages).learn_more_about_connecting_account_appify : (0, $dM7c5.messages).learn_more_about_connecting_account : (0, $dM7c5.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $dM7c5.messages).learn_more_about_connecting_account_experiment_shorter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iDrrr.fg)('product-terminology-refresh') ? (0, $dM7c5.messages).connect_unauthorised_account_description_no_provider_appify : (0, $dM7c5.messages).connect_unauthorised_account_description_no_provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: isProductIntegrationSupported ? (0, $4yYAm.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $4yYAm.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreMessage)));
};
var $c5ed75a9c5c2c5b7$export$2e2bcd8739ae039 = $c5ed75a9c5c2c5b7$var$UnauthorisedViewContent;
module.exports["default"] = $c5ed75a9c5c2c5b7$export$2e2bcd8739ae039;

});

parcelRegister("8qkhz", function(module, exports) {
/* RovoUnauthorisedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $f0b2F = parcelRequire("f0b2F");


var $kTb7m = parcelRequire("kTb7m");


var $bLfHG = parcelRequire("bLfHG");


var $hHrlI = parcelRequire("hHrlI");


var $NlHoa = parcelRequire("NlHoa");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $iUTeb = parcelRequire("iUTeb");


var $bVAqi = parcelRequire("bVAqi");


var $hsIfr = parcelRequire("hsIfr");


var $kyH4O = parcelRequire("kyH4O");

const $31dccf5742e9195b$var$ROVO_FEATURES = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_clear_link_names,
        testIdSuffix: 'clear-link-names'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_understand_linked_docs,
        testIdSuffix: 'understand-linked-docs'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_go_deeper_smart_suggestions,
        testIdSuffix: 'go-deeper-smart-suggestions'
    }
];
const $31dccf5742e9195b$var$sparkleWrapBase = null;
const $31dccf5742e9195b$var$sparkleLeftWrap = null;
const $31dccf5742e9195b$var$sparkleGreyRightWrap = null;
const $31dccf5742e9195b$var$sparkleVioletRightWrap = null;
const $31dccf5742e9195b$var$layoutStyles = {
    connectorStroke: "_1UtDYzy7kJ _3iDTPbQ4SZ _3YEZNOdnbC",
    atlassianIconTile: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _0KLXrutfbE",
    header: "_0KLXrumhAQ _0Of8r2NHnM _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO _2C2kUQ8fU6 _1Lz9lo8fU6 _1mT5xdRAKS",
    headerGraphicRow: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1DCdHi8HPE",
    headerTitle: "_2fwxA5DIqT",
    body: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    featureIconCell: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02ey7F",
    footer: "_2mHwu88HPE _3138428HPE _0Of8r21Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _3TGfC9HnLE"
};
const $31dccf5742e9195b$var$RovoUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, onDismiss: onDismiss, testId: testId = 'hover-card-rovo-unauthorised-view', url: url })=>{
    const providerName = (0, $cozmU.useMemo)(()=>(0, $hHrlI.extractSmartLinkProvider)(flexibleCardProps.cardState.details)?.text, [
        flexibleCardProps.cardState.details
    ]);
    const { authorize: authorize } = (0, $iUTeb.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4yYAm.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        if (onDismiss) {
            fireEvent('ui.button.clicked.dismiss', {});
            onDismiss();
        }
    }, [
        fireEvent,
        onDismiss
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId,
        ui: {
            hideElevation: true,
            hideBackground: true,
            removeBlockRestriction: true,
            hidePadding: true
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.header
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _3iDTPbQ4SZ _1mT5xdWVPG",
            "_1UtDYzfyEX _2IhTonuNcX _3OE6xYXJux"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.DenseSparkle), null)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _3iDTPbQ4SZ _1mT5xdWVPG",
            "_1UtDYzBee8 _2IhTonxpxF _4ApkO2E2XL"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.SparseSparkle), null)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _3iDTPbQ4SZ _1mT5xdWVPG",
            "_1UtDYzJhIs _39xV02E2XL _2IhTonUF4f _4ApkO2XJux"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.DenseSparkle), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.headerGraphicRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        isTiledIcon: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.connectorStroke
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.SquiglyArrow), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.atlassianIconTile
    }, /*#__PURE__*/ $cozmU.createElement((0, $NlHoa.AtlassianIcon), {
        appearance: "inverse",
        size: "small"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.headerTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        color: "color.text"
    }, providerName ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).rovo_unauthorised_title,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_title_no_provider)))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, $31dccf5742e9195b$var$ROVO_FEATURES.map((feature)=>{
        const FeatureIcon = feature.icon;
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            key: feature.testIdSuffix,
            space: "space.150",
            alignBlock: "center",
            testId: `${testId}-feature-${feature.testIdSuffix}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $31dccf5742e9195b$var$layoutStyles.featureIconCell
        }, /*#__PURE__*/ $cozmU.createElement(FeatureIcon, {
            label: ""
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), feature.message)));
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleDismiss,
        testId: `${testId}-not-now`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_not_now)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleAuthorize,
        testId: `${testId}-connect-account`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_connect_account)))))));
};
var $31dccf5742e9195b$export$2e2bcd8739ae039 = $31dccf5742e9195b$var$RovoUnauthorisedView;
module.exports["default"] = $31dccf5742e9195b$export$2e2bcd8739ae039;

});

parcelRegister("kyH4O", function(module, exports) {
/* graphics.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");

const $0e7d7cec4114cdb4$export$eaa6832866c251cf = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "M 18.1377,8.5584 C 19.820521,9.7606431 19.569624,7.0234324 19.891314,6.0724492 20.627318,4.4834923 20.654624,2.6485663 20.986387,0.9358225 20.985763,-0.63106096 19.153938,0.29529924 19.30907,1.4628594 18.581402,3.0380165 18.941526,4.9281736 18.3064,6.59809 18.189624,7.241971 17.98497,7.9130416 18.1377,8.5584 Z M 14.048,8.62872 C 16.108587,8.8291383 14.519035,6.5848441 14.323941,5.6001158 14.16595,3.856369 13.270155,2.254813 12.701225,0.60606587 11.918719,-0.74933808 10.791962,0.96396467 11.513059,1.8973545 11.672048,3.6244988 12.925689,5.0825474 13.2127,6.8456 13.436435,7.4621245 13.581302,8.1376081 14.048,8.62872 Z M 10.5438,10.7324 C 12.427639,9.875884 9.9317744,8.7259408 9.2689606,7.9718267 8.2625,6.5396335 6.6886891,5.5966404 5.36875,4.4566662 4.0131223,3.6745583 3.8966957,5.7235932 4.9866023,6.1718516 5.9867147,7.5895644 7.8032328,8.2251817 8.93219,9.61022 9.4294433,10.031063 9.9148481,10.555839 10.5438,10.7324 Z M 8.55828,14.3099 C 9.7604964,12.627122 7.023384,12.877794 6.0723265,12.556262 4.4833477,11.820331 2.6484558,11.792914 0.93570025,11.461212 c -1.5668845,6.26e-4 -0.64052126,1.832452 0.52703915,1.677318 1.5751539,0.727694 3.4653396,0.36738 5.1352306,1.00267 0.6438861,0.116827 1.314933,0.321333 1.96031,0.1687 z m 0.07008,4.0894 C 8.828733,16.338698 6.5844599,17.928323 5.5997508,18.123433 3.8560002,18.281408 2.2543901,19.1771 0.60569938,19.746162 -0.74955704,20.529217 0.96332374,21.653982 1.8969889,20.93548 3.6240071,20.774217 5.0821994,19.522267 6.84523,19.2346 7.4618123,19.010984 8.1372369,18.866007 8.62836,18.3993 Z m 2.10414,3.5072 C 9.8760472,20.022637 8.7260556,22.518484 7.9719398,23.181273 6.5393153,24.18655 5.6000777,25.76278 4.4595963,27.081513 3.6775168,28.437135 5.7265095,28.553572 6.1747816,27.463666 7.5925047,26.463552 8.2280912,24.647029 9.61315,23.5181 c 0.418283,-0.497326 0.951352,-0.985318 1.11935,-1.6116 z m 3.5775,1.9828 c -1.682815,-1.202255 -1.431924,1.534991 -1.753614,2.485976 -0.736023,1.588942 -0.763314,3.423872 -1.095073,5.136612 6.39e-4,1.566887 1.832425,0.640518 1.677317,-0.527032 0.727655,-1.57517 0.367555,-3.465328 1.00267,-5.135256 0.116772,-0.64388 0.321426,-1.314917 0.1687,-1.9603 z m 4.0891,-0.0702 c -2.060649,-0.200406 -0.470945,2.043891 -0.275873,3.028605 0.157937,1.743716 1.053669,3.345319 1.622686,4.994007 0.782496,1.355437 1.909207,-0.357878 1.188142,-1.291274 C 20.77504,28.823312 19.521385,27.365256 19.2344,25.6022 19.010647,24.985692 18.865809,24.310193 18.3991,23.8191 Z m 3.5074,-2.1038 c -1.88386,0.856461 0.611976,2.006423 1.274773,2.760542 1.006466,1.432207 2.580314,2.375182 3.90024,3.515183 1.355682,0.782012 1.472001,-1.26689 0.382153,-1.715209 C 26.463526,24.858147 24.647022,24.222555 23.5181,22.8375 23.02082,22.416678 22.53553,21.891757 21.9065,21.7153 Z m 1.9826,-3.5775 c -1.202233,1.682763 1.53485,1.432123 2.485905,1.753638 1.588978,0.735928 3.423859,0.763338 5.136608,1.095049 1.566893,-5.94e-4 0.640594,-1.832443 -0.527,-1.677317 C 29.409454,18.581486 27.519286,18.941792 25.8494,18.3065 25.205557,18.189667 24.534178,17.985164 23.8891,18.1378 Z m -0.0704,-4.0894 c -0.200405,2.06064 2.043899,0.470968 3.028605,0.275867 1.743759,-0.15797 3.345359,-1.053678 4.994083,-1.622679 1.355308,-0.782551 -0.357965,-1.909199 -1.29135,-1.188185 -1.727151,0.159054 -3.185218,1.412574 -4.948238,1.699697 -0.616574,0.223619 -1.291971,0.368616 -1.7831,0.8353 z M 21.7152,10.544 c 0.85645,1.88385 2.006449,-0.6119565 2.760542,-1.2747918 1.432624,-1.0052563 2.371905,-2.581444 3.512333,-3.9002107 C 28.770204,4.0133778 26.721159,3.8969258 26.272916,4.986848 24.855171,5.9869493 24.21954,7.8034667 22.8345,8.93243 22.416234,9.4297408 21.883198,9.917751 21.7152,10.544 Z"
    }));
};
const $0e7d7cec4114cdb4$export$d4cc5913ef36e057 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "m 21.4614,9.02651 c 1.774882,1.267966 1.510442,-1.6188099 1.849578,-2.6219063 0.776223,-1.6758612 0.805105,-3.61111 1.154947,-5.41753458 C 24.447185,-0.68027653 22.513317,0.28790594 22.69688,1.5429258 21.929419,3.2042498 22.309243,5.1977402 21.6394,6.95899 21.51609,7.6380728 21.300546,8.3458903 21.4614,9.02651 Z m -9.1629,0.611 C 14.479174,9.6115402 12.55696,7.4386694 12.239238,6.4296801 11.873994,4.6211661 10.751762,3.0453042 9.9684287,1.3818975 9.0519692,0.02745097 7.9717763,1.9817201 8.8672911,2.872095 9.2298246,4.664959 10.714117,6.0484595 11.2158,7.86365 c 0.30309,0.6222222 0.536236,1.3131609 1.0827,1.77386 z M 9.02651,14.4282 c 1.267976,-1.774848 -1.6188386,-1.510386 -2.6219063,-1.849578 -1.6758612,-0.776223 -3.61111,-0.805105 -5.41753458,-1.154947 -1.66734565,0.01874 -0.69916318,1.952608 0.55585668,1.769045 1.661324,0.767461 3.6548144,0.387637 5.4160642,1.05748 0.6790828,0.12331 1.3869003,0.338854 2.06752,0.178 z m 0.79812,7.0123 C 9.6506342,19.264889 7.6156756,21.33182 6.6290172,21.715218 4.8462675,22.200193 3.3480398,23.427583 1.7425513,24.327425 0.48184315,25.389439 2.4687817,26.243895 3.3047292,25.323131 5.0679233,24.838194 6.3485808,23.265036 8.1279,22.6448 8.727623,22.296964 9.4030508,22.019757 9.82463,21.4405 Z m 4.60367,2.4235 c -1.774857,-1.267999 -1.510322,1.618845 -1.849554,2.621865 -0.776222,1.675869 -0.805026,3.611122 -1.154946,5.417535 0.01882,1.667361 1.952587,0.699167 1.769034,-0.555848 0.767463,-1.661311 0.387597,-3.654815 1.057466,-5.416052 0.123252,-0.679055 0.338956,-1.387036 0.178,-2.0675 z m 5.9772,0.261 c -2.173333,-0.211383 -0.496768,2.155705 -0.291021,3.19429 0.166568,1.839106 1.111399,3.528228 1.711458,5.267122 0.84816,1.433261 2.042749,-0.366933 1.253122,-1.36187 C 22.911487,29.402909 21.589251,27.865123 21.2864,26.0057 21.05053,25.355401 20.897759,24.642984 20.4055,24.125 Z m 4.3514,-4.2566 c -1.918413,1.03763 0.793683,2.065164 1.542216,2.81224 1.163691,1.434148 2.891651,2.307238 4.359284,3.41661 1.503797,0.716781 1.491809,-1.445265 0.281572,-1.83218 C 29.783911,22.847779 27.827538,22.311391 26.5397,20.9362 25.981077,20.526301 25.453402,20.026312 24.7569,19.8684 Z m 0.2667,-6.5645 c -0.61356,2.094147 2.024993,0.892339 3.082584,0.881972 1.837741,0.184903 3.674321,-0.429733 5.494903,-0.694759 1.566146,-0.568664 0.02093,-2.078292 -1.105917,-1.48934 -1.8201,-0.172658 -3.577509,0.836398 -5.46037,0.783027 -0.682737,0.109486 -1.416687,0.125746 -2.0112,0.5191 z"
    }));
};
const $0e7d7cec4114cdb4$export$940e84768143d382 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "31",
        height: "21",
        viewBox: "0 0 31 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "M 21.853446,0.12040609 C 20.167706,1.2017532 24.715673,2.4997309 25.755055,3.0673371 25.02723,3.2209011 21.984019,3.856737 20.991485,3.9633568 16.045179,5.5890307 11.446918,7.8287185 9.1072914,12.742806 7.8983204,12.284216 5.7117383,11.960731 4.1643839,12.645906 2.2323901,13.501397 0.58356937,15.13985 0.06015349,17.184987 0.06666279,19.997869 1.7741124,16.035826 2.7542112,15.14763 c 1.6305676,-1.477671 4.7339707,-2.002323 5.8717147,-1.083896 -0.6742412,2.17406 -0.7914961,6.013849 1.8803011,6.750565 2.072285,0.571408 3.768061,-1.977378 2.786707,-4.245231 C 12.524186,14.792533 11.187386,13.937797 10.469825,13.425746 12.484573,8.4842061 19.328854,5.5947574 24.21859,4.6647774 25.288915,4.5397793 29.069777,3.0700705 27.388804,4.826459 26.472831,6.3589647 23.793814,8.1658647 23.628028,9.0737265 23.1618,11.626835 26.092344,8.4605266 26.699318,7.7349157 27.826169,6.2825775 29.856947,4.4211835 30.479445,3.5562506 28.766042,2.8991905 26.575439,1.3555612 24.569756,0.89998649 23.662177,0.65006782 22.790889,0.24992986 21.853446,0.12040609 Z M 9.9983561,14.652336 C 11.498101,15.3957 13.411213,18.565161 11.127761,19.347839 9.1996093,18.911365 9.5916528,16.22149 9.9983561,14.652336 Z"
    }));
};
module.exports["DenseSparkle"] = $0e7d7cec4114cdb4$export$eaa6832866c251cf;
module.exports["SparseSparkle"] = $0e7d7cec4114cdb4$export$d4cc5913ef36e057;
module.exports["SquiglyArrow"] = $0e7d7cec4114cdb4$export$940e84768143d382;

});

parcelRegister("8BSfe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $be34aefd245acdbf$export$96f885137e195758 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sources: []
});
const $be34aefd245acdbf$export$3349e66e592f2762 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($be34aefd245acdbf$export$96f885137e195758);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($be34aefd245acdbf$export$96f885137e195758);
module.exports["SourcesContext"] = $be34aefd245acdbf$export$96f885137e195758;
module.exports["useMessageSources"] = $be34aefd245acdbf$export$3349e66e592f2762;

});

parcelRegister("d1gG3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $04xaX = parcelRequire("04xaX");


var $dLTjh = parcelRequire("dLTjh");

const $fb7cced235f1c7b2$export$22e23c135da21dec = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { id: id, text: text, accessLevel: accessLevel, userType: userType, localId: localId, providers: providers, eventHandlers: eventHandlers } = t0;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $dLTjh.MentionNodeComponentContext));
    const isRespondingAgent = !!context && userType === "APP" && id === context.respondedAgentId;
    const isDisabled = !!context && userType === "APP" && id !== context.respondedAgentId;
    const t1 = eventHandlers?.mention;
    const t2 = isDisabled ? context.disabledTooltip : undefined;
    let t3;
    if ($[0] !== accessLevel || $[1] !== id || $[2] !== isDisabled || $[3] !== localId || $[4] !== providers || $[5] !== t1 || $[6] !== t2 || $[7] !== text) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04xaX.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            providers: providers,
            eventHandlers: t1,
            isDisabled: isDisabled,
            disabledTooltip: t2
        });
        $[0] = accessLevel;
        $[1] = id;
        $[2] = isDisabled;
        $[3] = localId;
        $[4] = providers;
        $[5] = t1;
        $[6] = t2;
        $[7] = text;
        $[8] = t3;
    } else t3 = $[8];
    const mention = t3;
    let t4;
    if ($[9] !== isRespondingAgent || $[10] !== mention) {
        t4 = isRespondingAgent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-active-agent-mention": true
        }, mention) : mention;
        $[9] = isRespondingAgent;
        $[10] = mention;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ id: id, text: text, accessLevel: accessLevel, userType: userType, localId: localId, providers: providers, eventHandlers: eventHandlers })=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $dLTjh.MentionNodeComponentContext));
    const isRespondingAgent = !!context && userType === 'APP' && id === context.respondedAgentId;
    const isDisabled = !!context && userType === 'APP' && id !== context.respondedAgentId;
    const mention = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04xaX.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        providers: providers,
        eventHandlers: eventHandlers?.mention,
        isDisabled: isDisabled,
        disabledTooltip: isDisabled ? context.disabledTooltip : undefined
    });
    return isRespondingAgent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-active-agent-mention": true
    }, mention) : mention;
};
module.exports["MentionNodeComponent"] = $fb7cced235f1c7b2$export$22e23c135da21dec;

});

parcelRegister("04xaX", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $eNbr2 = parcelRequire("eNbr2");

var $794I6 = parcelRequire("794I6");


var $d4eUy = parcelRequire("d4eUy");

const $3ca1b04bd37e35d3$var$MENTION_PROVIDERS = [
    'mentionProvider',
    'profilecardProvider'
];
class $3ca1b04bd37e35d3$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        const providers = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $3ca1b04bd37e35d3$var$MENTION_PROVIDERS : [
            'mentionProvider',
            'profilecardProvider'
        ];
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            providers: providers,
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId, userType: userType, isDisabled: isDisabled, disabledTooltip: disabledTooltip } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4eUy.MentionWithProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                userType: userType,
                isDisabled: isDisabled,
                disabledTooltip: disabledTooltip,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
module.exports["default"] = $3ca1b04bd37e35d3$export$2e2bcd8739ae039;

});

parcelRegister("d4eUy", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5zCi6 = parcelRequire("5zCi6");


var $Hhhdz = parcelRequire("Hhhdz");

const $379fc97538bbbbaa$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $379fc97538bbbbaa$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { accessLevel: accessLevel, disabledTooltip: disabledTooltip, eventHandlers: eventHandlers, id: id, isDisabled: isDisabled, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId, userType: userType } = t0;
    const [profilecardProvider, setProfilecardProvider] = (0, $cozmU.useState)(null);
    const mountedRef = (0, $cozmU.useRef)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] !== profilecardProviderResolver) {
        t3 = ()=>{
            profilecardProviderResolver?.then((result)=>{
                if (mountedRef.current) setProfilecardProvider(result);
            }).catch(()=>{
                if (mountedRef.current) setProfilecardProvider(null);
            });
        };
        t4 = [
            profilecardProviderResolver
        ];
        $[2] = profilecardProviderResolver;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $379fc97538bbbbaa$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $Hhhdz.default) : (0, $5zCi6.default);
    const ssrPlaceholderId = `mention-${id}`;
    if (isDisabled) {
        const t5 = eventHandlers?.onClick;
        const t6 = eventHandlers?.onMouseEnter;
        const t7 = eventHandlers?.onMouseLeave;
        let t8;
        if ($[5] !== accessLevel || $[6] !== disabledTooltip || $[7] !== id || $[8] !== localId || $[9] !== mentionProvider || $[10] !== ssrPlaceholderId || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== text) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                mentionProvider: mentionProvider,
                isDisabled: true,
                disabledTooltip: disabledTooltip,
                onClick: t5,
                onMouseEnter: t6,
                onMouseLeave: t7,
                ssrPlaceholderId: ssrPlaceholderId
            });
            $[5] = accessLevel;
            $[6] = disabledTooltip;
            $[7] = id;
            $[8] = localId;
            $[9] = mentionProvider;
            $[10] = ssrPlaceholderId;
            $[11] = t5;
            $[12] = t6;
            $[13] = t7;
            $[14] = text;
            $[15] = t8;
        } else t8 = $[15];
        return t8;
    }
    const t5 = eventHandlers?.onClick;
    const t6 = eventHandlers?.onMouseEnter;
    const t7 = eventHandlers?.onMouseLeave;
    let t8;
    if ($[16] !== MentionComponent || $[17] !== accessLevel || $[18] !== id || $[19] !== localId || $[20] !== mentionProvider || $[21] !== profilecardProvider || $[22] !== ssrPlaceholderId || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== text || $[27] !== userType) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)(MentionComponent, {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            userType: userType,
            mentionProvider: mentionProvider,
            profilecardProvider: profilecardProvider,
            onClick: t5,
            onMouseEnter: t6,
            onMouseLeave: t7,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[16] = MentionComponent;
        $[17] = accessLevel;
        $[18] = id;
        $[19] = localId;
        $[20] = mentionProvider;
        $[21] = profilecardProvider;
        $[22] = ssrPlaceholderId;
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = text;
        $[27] = userType;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ accessLevel: accessLevel, disabledTooltip: disabledTooltip, eventHandlers: eventHandlers, id: id, isDisabled: isDisabled, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId, userType: userType })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $cozmU.useState)(null);
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $379fc97538bbbbaa$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $Hhhdz.default) : (0, $5zCi6.default);
    const ssrPlaceholderId = `mention-${id}`;
    // A disabled mention is non-interactive, so it bypasses the profile-card
    // wrapper and renders the disabled resourced mention directly.
    if (isDisabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        isDisabled: true,
        disabledTooltip: disabledTooltip,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        userType: userType,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
});
module.exports["MentionWithProviders"] = $379fc97538bbbbaa$export$cd21803c89efe790;

});

parcelRegister("5zCi6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bijHC = parcelRequire("bijHC");


var $caelp = parcelRequire("caelp");


var $12QCz = parcelRequire("12QCz");


var $2SUNK = parcelRequire("2SUNK");

class $9a3220735be5ff34$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $2SUNK.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $caelp.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $caelp.MentionNameStatus).SERVICE_ERROR:
            case (0, $caelp.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $12QCz.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            isDisabled: props.isDisabled,
            disabledTooltip: props.disabledTooltip,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            ssrPlaceholderId: props.ssrPlaceholderId
        });
    }
    constructor(_props){
        super(_props);
        this._isMounted = void 0;
        this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $bijHC.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $caelp.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
}
module.exports["default"] = $9a3220735be5ff34$export$2e2bcd8739ae039;

});

parcelRegister("Hhhdz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $5zCi6 = parcelRequire("5zCi6");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $l8Rhq = parcelRequire("l8Rhq");


var $22Zs7 = parcelRequire("22Zs7");


var $eW61a = parcelRequire("eW61a");


var $ieeJu = parcelRequire("ieeJu");


// Lazy-loaded so the agent profile card chunk (and its `@atlaskit/rovo-agent-components`
// dependency) stays off the critical path — it is only fetched when an agent mention
// (`userType === 'APP'`) actually renders, never for person mentions.
// Uses react-loadable to match editor-common's code-splitting factory (see src/icons/index.ts).
const $e56bc9dce22ad0d3$var$AgentProfileCardTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "KoACG",
    name: "AgentProfileCardTrigger",
    loader: ()=>(parcelRequire("8WrgS")).then((mod)=>mod.AgentProfileCardTrigger),
    loading: ()=>null
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e56bc9dce22ad0d3$var$AT_PREFIX_REGEX = /^@/;
/**
 * Renders a mention chip wrapped in the appropriate profile card trigger.
 * 1. Agent mentions (`userType === 'APP'`, behind the `rovo_chat_mention_agents` experiment) open the Rovo agent profile card on click.
 * 2. Otherwise renders the person profile card (either via the provider's `renderUserMentionCard`/link fallback or the default user `ProfileCardTrigger`).
 */ const $e56bc9dce22ad0d3$var$MentionWithProfileCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MentionWithProfileCard(t0) {
    const $ = (0, $bDgLe.c)(46);
    const { autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId, userType: userType } = t0;
    const { cloudId: cloudId, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    let t1;
    if ($[0] !== accessLevel || $[1] !== id || $[2] !== profilecardProvider || $[3] !== text) {
        t1 = profilecardProvider.getActions(id, text, accessLevel);
        $[0] = accessLevel;
        $[1] = id;
        $[2] = profilecardProvider;
        $[3] = text;
        $[4] = t1;
    } else t1 = $[4];
    const actions = t1;
    let t2;
    if ($[5] !== accessLevel || $[6] !== id || $[7] !== localId || $[8] !== mentionProvider || $[9] !== onClick || $[10] !== onMouseEnter || $[11] !== onMouseLeave || $[12] !== ssrPlaceholderId || $[13] !== text) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[5] = accessLevel;
        $[6] = id;
        $[7] = localId;
        $[8] = mentionProvider;
        $[9] = onClick;
        $[10] = onMouseEnter;
        $[11] = onMouseLeave;
        $[12] = ssrPlaceholderId;
        $[13] = text;
        $[14] = t2;
    } else t2 = $[14];
    const mention = t2;
    if (userType === "APP" && cloudId && (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents")) {
        let t3;
        if ($[15] !== cloudId || $[16] !== id || $[17] !== mention || $[18] !== resourceClient) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTrigger, {
                agentId: id,
                cloudId: cloudId,
                resourceClient: resourceClient,
                trigger: "click",
                children: mention
            });
            $[15] = cloudId;
            $[16] = id;
            $[17] = mention;
            $[18] = resourceClient;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    if ((0, $iDrrr.fg)("people-teams_migrate-user-profile-card") || (0, $4o0zT.isExperimentEnabled)("pt_user_profile_card_migration_exp")) {
        if (renderUserMentionCard) {
            let t3;
            if ($[20] !== cloudId || $[21] !== id || $[22] !== mention || $[23] !== renderUserMentionCard) {
                t3 = renderUserMentionCard({
                    userId: id,
                    cloudId: cloudId,
                    children: mention
                });
                $[20] = cloudId;
                $[21] = id;
                $[22] = mention;
                $[23] = renderUserMentionCard;
                $[24] = t3;
            } else t3 = $[24];
            let t4;
            if ($[25] !== t3) {
                t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                    children: t3
                });
                $[25] = t3;
                $[26] = t4;
            } else t4 = $[26];
            return t4;
        }
        let t3;
        if ($[27] !== cloudId || $[28] !== id) {
            t3 = (0, $eW61a.navigateToTeamsApp)({
                type: "USER",
                payload: {
                    userId: id
                },
                cloudId: cloudId
            });
            $[27] = cloudId;
            $[28] = id;
            $[29] = t3;
        } else t3 = $[29];
        const { href: href, target: target } = t3;
        let t4;
        if ($[30] !== href || $[31] !== mention || $[32] !== target) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8Rhq.Anchor), {
                href: href,
                target: target,
                rel: "noopener noreferrer",
                testId: "mention-with-profilecard-link-fallback",
                children: mention
            });
            $[30] = href;
            $[31] = mention;
            $[32] = target;
            $[33] = t4;
        } else t4 = $[33];
        return t4;
    }
    let t3;
    if ($[34] !== text) {
        t3 = text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, "");
        $[34] = text;
        $[35] = t3;
    } else t3 = $[35];
    let t4;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $ieeJu.expValEquals)("editor_a11y_7152_profile_card_tab_order", "isEnabled", true);
        $[36] = t4;
    } else t4 = $[36];
    let t5;
    if ($[37] !== actions || $[38] !== autoFocus || $[39] !== cloudId || $[40] !== id || $[41] !== mention || $[42] !== resourceClient || $[43] !== ssrPlaceholderId || $[44] !== t3) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22Zs7.default), {
            autoFocus: autoFocus,
            cloudId: cloudId,
            userId: id,
            resourceClient: resourceClient,
            actions: actions,
            trigger: "click",
            position: "bottom-end",
            testId: "mention-with-profilecard-trigger",
            ariaLabel: t3,
            ssrPlaceholderId: ssrPlaceholderId,
            isRenderedInPortal: t4,
            children: mention
        });
        $[37] = actions;
        $[38] = autoFocus;
        $[39] = cloudId;
        $[40] = id;
        $[41] = mention;
        $[42] = resourceClient;
        $[43] = ssrPlaceholderId;
        $[44] = t3;
        $[45] = t5;
    } else t5 = $[45];
    return t5;
} : function MentionWithProfileCard({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId, userType: userType }) {
    const { cloudId: cloudId, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $cozmU.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    const mention = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
    // Agent mentions (userType 'APP') open the Rovo agent profile card on click.
    if (userType === 'APP' && cloudId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) return /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTrigger, {
        agentId: id,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: "click",
        children: mention
    });
    if ((0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $4o0zT.isExperimentEnabled)('pt_user_profile_card_migration_exp')) {
        if (renderUserMentionCard) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: renderUserMentionCard({
                userId: id,
                cloudId: cloudId,
                children: mention
            })
        });
        const { href: href, target: target } = (0, $eW61a.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            },
            cloudId: cloudId
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8Rhq.Anchor), {
            href: href,
            target: target,
            rel: "noopener noreferrer",
            testId: "mention-with-profilecard-link-fallback",
            children: mention
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22Zs7.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        ariaLabel: text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, ''),
        ssrPlaceholderId: ssrPlaceholderId,
        isRenderedInPortal: (0, $ieeJu.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true),
        children: mention
    });
};
var $e56bc9dce22ad0d3$export$2e2bcd8739ae039 = $e56bc9dce22ad0d3$var$MentionWithProfileCard;
module.exports["default"] = $e56bc9dce22ad0d3$export$2e2bcd8739ae039;

});

parcelRegister("22Zs7", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab0d1cd03b49a56$export$2e2bcd8739ae039);


var $cHMfQ = parcelRequire("cHMfQ");


var $hSs5g = parcelRequire("hSs5g");

var $cab0d1cd03b49a56$export$2e2bcd8739ae039 = (0, $hSs5g.default);

});

parcelRegister("8WrgS", function(module, exports) {

let $6828e500cc16d59b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6828e500cc16d59b$var$load("cyTuQ").then(()=>parcelRequire('eKpjD'));

});

parcelRegister("dLTjh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ec5c40550344894f$export$fd8f4868f371a708 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
module.exports["MentionNodeComponentContext"] = $ec5c40550344894f$export$fd8f4868f371a708;

});

parcelRegister("1sL4Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dLTjh = parcelRequire("dLTjh");

const $58450dc3685113ee$export$b2e088796204145 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { respondedAgentId: respondedAgentId, disabledTooltip: disabledTooltip, children: children } = t0;
    let t1;
    if ($[0] !== disabledTooltip || $[1] !== respondedAgentId) {
        t1 = {
            respondedAgentId: respondedAgentId,
            disabledTooltip: disabledTooltip
        };
        $[0] = disabledTooltip;
        $[1] = respondedAgentId;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dLTjh.MentionNodeComponentContext).Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ respondedAgentId: respondedAgentId, disabledTooltip: disabledTooltip, children: children })=>{
    // Stabilise the context value so the per-mention MentionNodeComponent
    // consumers don't re-render every time the parent renderer re-renders
    // (e.g. on each streaming chunk) when these values are unchanged.
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            respondedAgentId: respondedAgentId,
            disabledTooltip: disabledTooltip
        }), [
        respondedAgentId,
        disabledTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dLTjh.MentionNodeComponentContext).Provider, {
        value: value
    }, children);
};
module.exports["MentionNodeComponentProvider"] = $58450dc3685113ee$export$b2e088796204145;

});

parcelRegister("fX67d", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d7dc45cf6068999e$var$message = (0, $kSwu1.defineMessages)({
    profileCardViewProfileButton: {
        id: "ai-mate.content-renderer.profile-card.view-profile-button",
        defaultMessage: "View profile"
    },
    viewCodeButtonLabel: {
        id: "ai-mate.content-renderer.view-code-button-label",
        defaultMessage: "View analysis"
    },
    loadingMarkdownMessage: {
        id: "ai-mate.content-renderer.loading-markdown",
        defaultMessage: "Loading markdown..."
    },
    loadingChartMessage: {
        id: "ai-mate.content-renderer.loading-chart",
        defaultMessage: "Loading chart..."
    },
    disabledAgentMentionTooltip: {
        id: "ai-mate.content-renderer.disabled-agent-mention-tooltip",
        defaultMessage: "Only one agent can be active at a time"
    }
});
var $d7dc45cf6068999e$export$2e2bcd8739ae039 = $d7dc45cf6068999e$var$message;
module.exports["default"] = $d7dc45cf6068999e$export$2e2bcd8739ae039;

});

parcelRegister("039lM", function(module, exports) {

let $009788aec3eac91a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $009788aec3eac91a$var$load("gZI2F").then(()=>parcelRequire('61k6M'));

});

parcelRegister("aDu0N", function(module, exports) {

let $7be4d3a63f800ed8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7be4d3a63f800ed8$var$load("2jlml").then(()=>parcelRequire('8Uf6Z'));

});

parcelRegister("6Wp5G", function(module, exports) {

let $50db9f55a5f87622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $50db9f55a5f87622$var$load("7Ktrp"),
    $50db9f55a5f87622$var$load("hTxlQ"),
    $50db9f55a5f87622$var$load("6bjEk"),
    $50db9f55a5f87622$var$load("Wowvf"),
    $50db9f55a5f87622$var$load("fkLbQ"),
    $50db9f55a5f87622$var$load("bMNgp"),
    $50db9f55a5f87622$var$load("h1yOv"),
    $50db9f55a5f87622$var$load("eqj21"),
    $50db9f55a5f87622$var$load("3oAU3"),
    $50db9f55a5f87622$var$load("iZR3N"),
    $50db9f55a5f87622$var$load("4zz48"),
    $50db9f55a5f87622$var$load("jXM1T"),
    $50db9f55a5f87622$var$load("cvcNg"),
    $50db9f55a5f87622$var$load("jw3lv"),
    $50db9f55a5f87622$var$load("7rqWx"),
    $50db9f55a5f87622$var$load("aIze1"),
    $50db9f55a5f87622$var$load("il8bj"),
    $50db9f55a5f87622$var$load("4N1MY"),
    $50db9f55a5f87622$var$load("kG5Ju"),
    $50db9f55a5f87622$var$load("39XCn"),
    $50db9f55a5f87622$var$load("3Cky6"),
    $50db9f55a5f87622$var$load("aFLSJ"),
    $50db9f55a5f87622$var$load("6fJCf"),
    $50db9f55a5f87622$var$load("duEFL"),
    $50db9f55a5f87622$var$load("6wr18"),
    $50db9f55a5f87622$var$load("1pJPT"),
    $50db9f55a5f87622$var$load("7EorR"),
    $50db9f55a5f87622$var$load("ffEVr"),
    $50db9f55a5f87622$var$load("hhss7"),
    $50db9f55a5f87622$var$load("hVFIb")
]).then(()=>parcelRequire('eWlk7'));

});

parcelRegister("lfXuJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f04a2db07af1317a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    headerTitle: {
        id: "ai-mate.browse-skills.header-title",
        defaultMessage: "Skills"
    },
    searchPlaceholder: {
        id: "ai-mate.inline-browse.search-placeholder",
        defaultMessage: "Search"
    },
    seeAllSkillsLabel: {
        id: "ai-mate.skills-inline-browse.see-all-label",
        defaultMessage: "See all"
    }
});
module.exports["messages"] = $f04a2db07af1317a$export$defe85febe8b728c;

});

parcelRegister("iLIUb", function(module, exports) {

let $da9f72fd4c1183c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da9f72fd4c1183c6$var$load("9XJQS").then(()=>parcelRequire('fhi89'));

});

parcelRegister("6hUo1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $cMyWi = parcelRequire("cMyWi");


var $9KSWX = parcelRequire("9KSWX");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $9GVkD = parcelRequire("9GVkD");







const $588cd13b29e91083$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    harmfulContentFeedbackTitle: {
        id: "ai-feedback.harmful-content.feedback-title",
        defaultMessage: "Report harmful or inappropriate content"
    },
    feedbackTypeSelectorTitle: {
        id: "ai-feedback.feedback-type-selector.title",
        defaultMessage: "Report answer or leave feedback"
    },
    incorrectFlagFeedbackTitle: {
        id: "ai-feedback.incorrect-flag.feedback-title",
        defaultMessage: "Did we flag your input correctly?"
    },
    incorrectFlagCheckboxLabel: {
        id: "ai-feedback.incorrect-flag.checkbox-label",
        defaultMessage: "Include your input to help us improve the system."
    },
    consentCheckboxLabel: {
        id: "ai-feedback.consent.checkbox-label",
        defaultMessage: "Include the last 10 messages between you and Rovo in this feedback"
    },
    feedbackTextAreaLabel: {
        id: "ai-feedback.describe-issue-label",
        defaultMessage: "Describe the work item"
    },
    feedbackTextAreaRequired: {
        id: "ai-feedback.describe-issue-required",
        defaultMessage: "Please describe the work item."
    },
    harmfulContentDescription: {
        id: "ai-feedback.harmful-content.description-default-value",
        defaultMessage: "User reported content could be an AUP violation (false negative)"
    },
    incorrectFlagDescription: {
        id: "ai-feedback.incorrect-flag.description-default-value",
        defaultMessage: "User reported possible AUP violation that was incorrectly flagged (false positive)"
    },
    reportHarmfulContentFeedbackText: {
        id: "ai-feedback.feedback-type-selector.report-harmful-content.text",
        defaultMessage: "I want to report harmful or inappropriate content"
    },
    sendFeedbackToAtlassianText: {
        id: "ai-feedback.feedback-type-selector.send-feedback-to-atlassian.text",
        defaultMessage: "I want to send feedback to Atlassian"
    },
    reportHarmfulContentFeedbackSubText: {
        id: "ai-feedback.feedback-type-selector.report-harmful-content.subtext",
        defaultMessage: "Flag this AI output for inappropriate, offensive, or otherwise malicious output"
    },
    sendFeedbackToAtlassianSubText: {
        id: "ai-feedback.feedback-type-selector.send-feedback-to-atlassian.subtext",
        defaultMessage: "Share your feedback so we can improve these experiences."
    },
    cancelButtonText: {
        id: "ai-feedback.cancel-button-text",
        defaultMessage: "Cancel"
    },
    submitButtonText: {
        id: "ai-feedback.submit-button-text",
        defaultMessage: "Send feedback"
    },
    displayFeedbackButtonText: {
        id: "ai-feedback.display-feedback-button-text",
        defaultMessage: "Display Feedback"
    },
    displayFeedbackSelectorText: {
        id: "ai-feedback.display-feedback-selector-text",
        defaultMessage: "Display Feedback Selector"
    }
});









var $2uDbg = parcelRequire("2uDbg");


var $91uAX = parcelRequire("91uAX");


var $8Xvwd = parcelRequire("8Xvwd");

var $dUI0h = parcelRequire("dUI0h");


var $7BfeF = parcelRequire("7BfeF");


var $e3Wrf = parcelRequire("e3Wrf");

const $1744acb731fcaf2d$export$91728bdbed25c337 = '1a3369da-be17-4f4d-9c11-bb2895beebc2';






const $3b27678c8dbfa3d8$export$9d1b58282ec0e502 = ({ message: message, metadata: metadata })=>{
    if (!metadata) return message;
    return `${message}

\`\`\`
${JSON.stringify(metadata, null, 2)}
\`\`\`
`;
};


const $cd59bb3150f9e2ad$export$8e33ad70a8a08e0 = ({ allowFeedbackMetadata: allowFeedbackMetadata, feedbackMetadata: feedbackMetadata })=>{
    const [feedbackText, setFeedbackText] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState('');
    const [includeHistoryFeedbackMetadata, setIncludeHistoryFeedbackMetadata] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const feedbackTextWithMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!allowFeedbackMetadata) return (0, $3b27678c8dbfa3d8$export$9d1b58282ec0e502)({
            message: feedbackText
        });
        const metadata = feedbackMetadata ? {
            ...feedbackMetadata
        } : {};
        if (!includeHistoryFeedbackMetadata && metadata && 'history' in metadata) delete metadata.history;
        return (0, $3b27678c8dbfa3d8$export$9d1b58282ec0e502)({
            message: feedbackText,
            metadata: metadata
        });
    }, [
        feedbackMetadata,
        feedbackText,
        allowFeedbackMetadata,
        includeHistoryFeedbackMetadata
    ]);
    return {
        feedbackText: feedbackText,
        setFeedbackText: setFeedbackText,
        includeHistoryFeedbackMetadata: includeHistoryFeedbackMetadata,
        setIncludeHistoryFeedbackMetadata: setIncludeHistoryFeedbackMetadata,
        feedbackTextWithMetadata: feedbackTextWithMetadata
    };
};


const $7f67289018b39cae$export$7f4d225c90c885fd = ({ name: name, aaid: aaid, allowFeedbackMetadata: allowFeedbackMetadata, feedbackMetadata: feedbackMetadata, isOpen: isOpen, setIsOpen: setIsOpen, onSubmit: onSubmit, includeFeedbackCheckboxLabel: includeFeedbackCheckboxLabel, feedbackTitle: feedbackTitle })=>{
    const ref = (0, $cozmU.useRef)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { feedbackText: feedbackText, setFeedbackText: setFeedbackText, includeHistoryFeedbackMetadata: includeHistoryFeedbackMetadata, setIncludeHistoryFeedbackMetadata: setIncludeHistoryFeedbackMetadata, feedbackTextWithMetadata: feedbackTextWithMetadata } = (0, $cd59bb3150f9e2ad$export$8e33ad70a8a08e0)({
        allowFeedbackMetadata: allowFeedbackMetadata,
        feedbackMetadata: feedbackMetadata
    });
    const onClose = ()=>setIsOpen(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, allowFeedbackMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Xvwd.CheckboxField), {
            name: "includeInput",
            defaultIsChecked: false
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                label: formatMessage(includeFeedbackCheckboxLabel),
                isChecked: includeHistoryFeedbackMetadata,
                onChange: (event)=>setIncludeHistoryFeedbackMetadata(event.target.checked)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: formatMessage((0, $588cd13b29e91083$export$defe85febe8b728c).feedbackTextAreaLabel),
            name: "feedback-collector-description",
            isRequired: true
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                minimumRows: 4,
                value: feedbackText,
                onChange: (e)=>setFeedbackText(e.target.value),
                resize: "auto"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $588cd13b29e91083$export$defe85febe8b728c).feedbackTextAreaRequired))))),
        onClose: onClose,
        onSubmit: onSubmit,
        atlassianAccountId: aaid,
        name: name,
        // AUP feedback flows into a single pre-set feedback collector entrypoint
        entrypointId: (0, $1744acb731fcaf2d$export$91728bdbed25c337),
        feedbackTitle: formatMessage(feedbackTitle),
        // We are hiding the default text fields, so setting these defaults here
        // will cause these values to be submitted with the feedback behind the scenes
        summaryDefaultValue: feedbackText,
        descriptionDefaultValue: feedbackTextWithMetadata,
        showTypeField: false,
        showDefaultTextFields: false,
        cancelButtonLabel: formatMessage((0, $588cd13b29e91083$export$defe85febe8b728c).cancelButtonText),
        submitButtonLabel: formatMessage((0, $588cd13b29e91083$export$defe85febe8b728c).submitButtonText),
        // @ts-ignore
        shouldReturnFocusRef: ref
    }));
};


const $2ee2bab08eb5b7d0$export$1a4e37fedd01b118 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f67289018b39cae$export$7f4d225c90c885fd), {
        ...props,
        includeFeedbackCheckboxLabel: (0, $588cd13b29e91083$export$defe85febe8b728c).consentCheckboxLabel,
        feedbackTitle: (0, $588cd13b29e91083$export$defe85febe8b728c).harmfulContentFeedbackTitle
    });
};



var $i7OAD = parcelRequire("i7OAD");


var $1PVOM = parcelRequire("1PVOM");


var $jqovE = parcelRequire("jqovE");


var $6rwn6 = parcelRequire("6rwn6");

const $63e594faf9bc5df0$var$buildSourcesString = (sources)=>{
    return sources.map((source, index)=>`${index + 1}. ${source.url}`).join('\n\n');
};
const $63e594faf9bc5df0$export$5e6cca1a888b7324 = (content, sources)=>{
    const sourcesString = sources ? $63e594faf9bc5df0$var$buildSourcesString(sources) : '';
    const sourceCount = sources?.length ?? 0;
    // Replace all references with the normalized format.
    // Citations with leading zeros (e.g. ^00^, ^01^, ^02^) or exactly ^0^ are 0-based source indices → display as index+1.
    // Otherwise treat as 1-based display number (e.g. ^1^, ^2^).
    const result = content.replace(/\[\^(\d+)\^]/g, (_, digits)=>{
        const num = parseInt(digits, 10);
        const isZeroIndexed = digits === '0' || digits.length > 1 && digits[0] === '0';
        const displayNum = isZeroIndexed ? Math.max(1, Math.min(num + 1, sourceCount)) : Math.max(1, Math.min(num, sourceCount));
        return `[${displayNum}]`;
    });
    return {
        result: result,
        sourcesString: sourcesString
    };
};



var $Ou0Zz = parcelRequire("Ou0Zz");


var $637t4 = parcelRequire("637t4");


var $e02Sx = parcelRequire("e02Sx");


var $2429E = parcelRequire("2429E");


var $2knbJ = parcelRequire("2knbJ");


var $hSR6U = parcelRequire("hSR6U");


var $bGNkz = parcelRequire("bGNkz");


var $lTU4O = parcelRequire("lTU4O");


var $4NVkH = parcelRequire("4NVkH");


var $2Zool = parcelRequire("2Zool");


var $fhQlP = parcelRequire("fhQlP");


var $1V59x = parcelRequire("1V59x");

















var $91ZZN = parcelRequire("91ZZN");

const $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_EXTENSION_TYPE = 'com.atlassian.rovo.insightLinkCard';
const $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_COMBINED_EXTENSION_KEY = 'insight:linkCard';
const $1af56b3b70a9c0c4$var$isInsightLinkCardExtension = (extensionType, extensionKey)=>extensionType === $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_EXTENSION_TYPE && extensionKey === $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_COMBINED_EXTENSION_KEY;
const $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_EXTENSION_TYPE = 'com.atlassian.rovo.insightLinkCardGroup';
const $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_COMBINED_EXTENSION_KEY = 'insight:linkCardGroup';
const $1af56b3b70a9c0c4$var$isInsightLinkCardGroupExtension = (extensionType, extensionKey)=>extensionType === $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_EXTENSION_TYPE && extensionKey === $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_COMBINED_EXTENSION_KEY;
const $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_EXTENSION_TYPE = 'com.atlassian.rovo.insightProfileGroup';
const $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_COMBINED_EXTENSION_KEY = 'insight:profileGroup';
const $1af56b3b70a9c0c4$var$isInsightProfileGroupExtension = (extensionType, extensionKey)=>extensionType === $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_EXTENSION_TYPE && extensionKey === $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_COMBINED_EXTENSION_KEY;
const $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_TYPE = 'com.atlassian.rovo.insightCopyText';
const $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_KEY = 'insight:copyText';
const $1af56b3b70a9c0c4$var$isCopyTextExtension = (extensionType, extensionKey)=>extensionType === $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_TYPE && extensionKey === $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_KEY;

// statically and dynamically within one bundle, Atlaspack internalises the dynamic import and
// returns the module namespace instead of a promise, making `.then` undefined. `await` is correct
// for both shapes.
const $1af56b3b70a9c0c4$var$LazyInsightLinkCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(async ()=>{
    const module = await (parcelRequire("3s5Mh"));
    return {
        default: module.InsightLinkCard
    };
});

const $1af56b3b70a9c0c4$var$LazyInsightLinkCardGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(async ()=>{
    const module = await (parcelRequire("2pOgk"));
    return {
        default: module.InsightLinkCardGroup
    };
});

const $1af56b3b70a9c0c4$var$LazyInsightProfileGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(async ()=>{
    const module = await (parcelRequire("1iheS"));
    return {
        default: module.InsightProfileGroup
    };
});

const $1af56b3b70a9c0c4$var$LazyCopyText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(async ()=>{
    const module = await (parcelRequire("gLcMv"));
    return {
        default: module.CopyText
    };
});
const $1af56b3b70a9c0c4$var$InsightExtensionBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { content: content, extensionType: extensionType, extensionKey: extensionKey, parameters: t1, isFullScreen: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const parameters = t3;
    const isFullScreen = t2 === undefined ? false : t2;
    const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue("rovo_growth_chat_pulse", "isEnabled", false);
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isInsightLinkCardExtension(extensionType, extensionKey) && typeof parameters?.url === "string") {
        let t4;
        if ($[2] !== parameters) {
            t4 = JSON.stringify(parameters);
            $[2] = parameters;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== parameters.url) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-insight-link-card-suspense",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyInsightLinkCard, {
                url: parameters.url
            }));
            $[4] = parameters.url;
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] !== t4 || $[7] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                "data-extension-type": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_EXTENSION_TYPE,
                "data-extension-key": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_COMBINED_EXTENSION_KEY,
                "data-parameters": t4
            }, t5);
            $[6] = t4;
            $[7] = t5;
            $[8] = t6;
        } else t6 = $[8];
        return t6;
    }
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isInsightLinkCardGroupExtension(extensionType, extensionKey) && Array.isArray(parameters?.urls)) {
        let t4;
        if ($[9] !== parameters) {
            t4 = JSON.stringify(parameters);
            $[9] = parameters;
            $[10] = t4;
        } else t4 = $[10];
        let t5;
        if ($[11] !== isFullScreen || $[12] !== parameters.urls) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-insight-link-card-group-suspense",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyInsightLinkCardGroup, {
                urls: parameters.urls,
                variant: "detail",
                isFullScreen: isFullScreen
            }));
            $[11] = isFullScreen;
            $[12] = parameters.urls;
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== t4 || $[15] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                "data-extension-type": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_EXTENSION_TYPE,
                "data-extension-key": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_COMBINED_EXTENSION_KEY,
                "data-parameters": t4
            }, t5);
            $[14] = t4;
            $[15] = t5;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isInsightProfileGroupExtension(extensionType, extensionKey) && Array.isArray(parameters?.profileIds)) {
        let t4;
        if ($[17] !== parameters) {
            t4 = JSON.stringify(parameters);
            $[17] = parameters;
            $[18] = t4;
        } else t4 = $[18];
        let t5;
        if ($[19] !== isFullScreen || $[20] !== parameters.profileIds) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-insight-profile-group-suspense",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyInsightProfileGroup, {
                profileIds: parameters.profileIds,
                isFullScreen: isFullScreen
            }));
            $[19] = isFullScreen;
            $[20] = parameters.profileIds;
            $[21] = t5;
        } else t5 = $[21];
        let t6;
        if ($[22] !== t4 || $[23] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                "data-extension-type": $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_EXTENSION_TYPE,
                "data-extension-key": $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_COMBINED_EXTENSION_KEY,
                "data-parameters": t4
            }, t5);
            $[22] = t4;
            $[23] = t5;
            $[24] = t6;
        } else t6 = $[24];
        return t6;
    }
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isCopyTextExtension(extensionType, extensionKey) && typeof parameters?.text === "string" && parameters.text.trim().length > 0) {
        let t4;
        if ($[25] !== parameters) {
            t4 = JSON.stringify(parameters);
            $[25] = parameters;
            $[26] = t4;
        } else t4 = $[26];
        let t5;
        if ($[27] !== parameters.text) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                interactionName: "conversation-assistant-content-renderer-insight-copy-text-suspense",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyCopyText, {
                text: parameters.text
            }));
            $[27] = parameters.text;
            $[28] = t5;
        } else t5 = $[28];
        let t6;
        if ($[29] !== t4 || $[30] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                "data-extension-type": $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_TYPE,
                "data-extension-key": $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_KEY,
                "data-parameters": t4
            }, t5);
            $[29] = t4;
            $[30] = t5;
            $[31] = t6;
        } else t6 = $[31];
        return t6;
    }
    return content;
} : ({ content: content, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters = {}, isFullScreen: isFullScreen = false })=>{
    const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isInsightLinkCardExtension(extensionType, extensionKey) && typeof parameters?.url === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-extension-type": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_EXTENSION_TYPE,
        "data-extension-key": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_COMBINED_EXTENSION_KEY,
        "data-parameters": JSON.stringify(parameters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-content-renderer-insight-link-card-suspense",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyInsightLinkCard, {
        url: parameters.url
    })));
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isInsightLinkCardGroupExtension(extensionType, extensionKey) && Array.isArray(parameters?.urls)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-extension-type": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_EXTENSION_TYPE,
        "data-extension-key": $1af56b3b70a9c0c4$var$INSIGHT_LINK_CARD_GRID_COMBINED_EXTENSION_KEY,
        "data-parameters": JSON.stringify(parameters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-content-renderer-insight-link-card-group-suspense",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyInsightLinkCardGroup, {
        urls: parameters.urls,
        variant: "detail",
        isFullScreen: isFullScreen
    })));
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isInsightProfileGroupExtension(extensionType, extensionKey) && Array.isArray(parameters?.profileIds)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-extension-type": $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_EXTENSION_TYPE,
        "data-extension-key": $1af56b3b70a9c0c4$var$ROVO_INSIGHT_PROFILE_GROUP_COMBINED_EXTENSION_KEY,
        "data-parameters": JSON.stringify(parameters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-content-renderer-insight-profile-group-suspense",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyInsightProfileGroup, {
        profileIds: parameters.profileIds,
        isFullScreen: isFullScreen
    })));
    if (isPulseExperimentEnabled && $1af56b3b70a9c0c4$var$isCopyTextExtension(extensionType, extensionKey) && typeof parameters?.text === 'string' && parameters.text.trim().length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-extension-type": $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_TYPE,
        "data-extension-key": $1af56b3b70a9c0c4$var$INSIGHT_COPY_TEXT_EXTENSION_KEY,
        "data-parameters": JSON.stringify(parameters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "conversation-assistant-content-renderer-insight-copy-text-suspense",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1af56b3b70a9c0c4$var$LazyCopyText, {
        text: parameters.text
    })));
    return content;
};
const $1af56b3b70a9c0c4$export$3dcb0b7fce7438b4 = /*#__PURE__*/ (0, $cozmU.memo)($1af56b3b70a9c0c4$var$InsightExtensionBase);



var $4EPzQ = parcelRequire("4EPzQ");

const $c67872b41cdb1880$export$87534e1b3744f058 = (doc)=>{
    const counts = (0, $4EPzQ.reduce)(doc, (acc, node)=>{
        if (node.type === 'inlineCard') acc.inlineCardCount++;
        else if (node.type === 'embedCard') acc.embedCardCount++;
        else if (node.type === 'text' && node.marks?.some((m)=>m.type === 'link')) acc.regularLinkCount++;
        return acc;
    }, {
        inlineCardCount: 0,
        embedCardCount: 0,
        regularLinkCount: 0
    });
    const smartLinkCount = counts.inlineCardCount + counts.embedCardCount;
    return {
        totalLinks: smartLinkCount + counts.regularLinkCount,
        smartLinkCount: smartLinkCount,
        inlineCardCount: counts.inlineCardCount,
        embedCardCount: counts.embedCardCount,
        regularLinkCount: counts.regularLinkCount
    };
};















var $bkEQw = parcelRequire("bkEQw");


var $9qJ1N = parcelRequire("9qJ1N");


var $4AQlH = parcelRequire("4AQlH");

















var $7cSoR = parcelRequire("7cSoR");


var $1iIcq = parcelRequire("1iIcq");


var $8cKM4 = parcelRequire("8cKM4");

const $6a3b7aa53f68c768$export$3df839a954ab25b8 = ()=>{
    const data = (0, $8cKM4.readFromStorage)();
    return !(0, $7cSoR.isInCooldown)(data) && data.qualifyingConversations >= (0, $1iIcq.MIN_QUALIFYING_CONVERSATIONS);
};






var $714Yd = parcelRequire("714Yd");

const $ab85907883b56e66$export$a70d615b333abe5b = ()=>{
    const cur = (0, $8cKM4.readFromStorage)();
    (0, $714Yd.writeToStorage)({
        ...cur,
        lastShownAt: Date.now(),
        qualifyingConversations: 0
    });
};





const $8c59a7c2697ffade$export$7e2ec1c7f7608a97 = ()=>{
    const now = Date.now();
    (0, $714Yd.writeToStorage)({
        lastShownAt: now,
        lastInteractedAt: now,
        qualifyingConversations: 0
    });
};


const $de8bd2dcb2dbc1d8$export$68b696976406592 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { enabled: enabled } = t0;
    const onCsatInteracted = $de8bd2dcb2dbc1d8$var$_temp;
    const onCsatDisplayed = $de8bd2dcb2dbc1d8$var$_temp2;
    if (!enabled) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                isEligibleToShow: false,
                onCsatInteracted: onCsatInteracted,
                onCsatDisplayed: onCsatDisplayed
            };
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const isForceShow = (0, $iDrrr.fg)("rovo_chat_csat_survey_force_show");
    const passesPolicy = typeof window !== "undefined" && (0, $6a3b7aa53f68c768$export$3df839a954ab25b8)();
    let isEligibleToShow = false;
    if (isForceShow) isEligibleToShow = true;
    else if (passesPolicy) {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $cXtTj.default).getExperimentValue("rovo_chat_csat_survey_feedback", "isEnabled", false);
            $[1] = t1;
        } else t1 = $[1];
        isEligibleToShow = t1;
    }
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            isEligibleToShow: isEligibleToShow,
            onCsatInteracted: onCsatInteracted,
            onCsatDisplayed: onCsatDisplayed
        };
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ enabled: enabled })=>{
    const onCsatInteracted = (0, $cozmU.useCallback)(()=>{
        (0, $8c59a7c2697ffade$export$7e2ec1c7f7608a97)();
    }, []);
    const onCsatDisplayed = (0, $cozmU.useCallback)(()=>{
        (0, $ab85907883b56e66$export$a70d615b333abe5b)();
    }, []);
    if (!enabled) return {
        isEligibleToShow: false,
        onCsatInteracted: onCsatInteracted,
        onCsatDisplayed: onCsatDisplayed
    };
    // QA escape hatch: bypasses experiment + cooldowns.
    const isForceShow = (0, $iDrrr.fg)('rovo_chat_csat_survey_force_show');
    const passesPolicy = typeof window !== 'undefined' && (0, $6a3b7aa53f68c768$export$3df839a954ab25b8)();
    let isEligibleToShow = false;
    if (isForceShow) isEligibleToShow = true;
    else if (passesPolicy) isEligibleToShow = (0, $cXtTj.default).getExperimentValue('rovo_chat_csat_survey_feedback', 'isEnabled', false);
    return {
        isEligibleToShow: isEligibleToShow,
        onCsatInteracted: onCsatInteracted,
        onCsatDisplayed: onCsatDisplayed
    };
};
function $de8bd2dcb2dbc1d8$var$_temp() {
    (0, $8c59a7c2697ffade$export$7e2ec1c7f7608a97)();
}
function $de8bd2dcb2dbc1d8$var$_temp2() {
    (0, $ab85907883b56e66$export$a70d615b333abe5b)();
}














const $ca0a685ac6b27c04$export$603352dd4f434363 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { conversationId: conversationId, agentMessageId: agentMessageId, isEligibleToShow: isEligibleToShow, hadPendingActionAtAnyPoint: t1, shouldSuppressCsatForAgent: t2, handleCsatFeedback: handleCsatFeedback, onCsatInteracted: onCsatInteracted, onCsatDisplayed: onCsatDisplayed } = t0;
    const hadPendingActionAtAnyPoint = t1 === undefined ? false : t1;
    const shouldSuppressCsatForAgent = t2 === undefined ? false : t2;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [csatRating, setCsatRating] = (0, $cozmU.useState)(null);
    const [isCsatSurveyDismissed, setIsCsatSurveyDismissed] = (0, $cozmU.useState)(false);
    const resolvedLayoutRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (layout)=>{
            if (resolvedLayoutRef.current !== null) return;
            resolvedLayoutRef.current = layout;
        };
        $[0] = t3;
    } else t3 = $[0];
    const recordResolvedLayout = t3;
    const csatOptionClickedFiredRef = (0, $cozmU.useRef)(false);
    let t4;
    if ($[1] !== agentMessageId || $[2] !== conversationId || $[3] !== sendAnalyticsEvent) {
        t4 = (rating)=>{
            if (rating !== null && !csatOptionClickedFiredRef.current) {
                csatOptionClickedFiredRef.current = true;
                sendAnalyticsEvent({
                    eventType: "track",
                    action: "clicked",
                    actionSubject: "csatSurveyOption",
                    attributes: {
                        csatRating: rating,
                        conversationId: conversationId,
                        messageId: agentMessageId,
                        layout: resolvedLayoutRef.current
                    }
                });
            }
            setCsatRating(rating);
        };
        $[1] = agentMessageId;
        $[2] = conversationId;
        $[3] = sendAnalyticsEvent;
        $[4] = t4;
    } else t4 = $[4];
    const handleSelectRating = t4;
    const [csatFlowLatchedThisTurn, latchCsatFlowThisTurn] = (0, $cozmU.useReducer)($ca0a685ac6b27c04$var$_temp, isEligibleToShow);
    let t5;
    let t6;
    if ($[5] !== isEligibleToShow) {
        t5 = ()=>{
            if (isEligibleToShow) latchCsatFlowThisTurn(true);
        };
        t6 = [
            isEligibleToShow
        ];
        $[5] = isEligibleToShow;
        $[6] = t5;
        $[7] = t6;
    } else {
        t5 = $[6];
        t6 = $[7];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const csatFlowUsedThisTurn = csatFlowLatchedThisTurn || isEligibleToShow;
    const isCsatSurveyVisible = csatFlowUsedThisTurn && !hadPendingActionAtAnyPoint && !shouldSuppressCsatForAgent && !isCsatSurveyDismissed;
    const csatShownFiredRef = (0, $cozmU.useRef)(false);
    let t7;
    if ($[8] !== agentMessageId || $[9] !== conversationId || $[10] !== onCsatDisplayed || $[11] !== sendAnalyticsEvent) {
        t7 = ()=>{
            if (csatShownFiredRef.current) return;
            csatShownFiredRef.current = true;
            onCsatDisplayed();
            sendAnalyticsEvent({
                eventType: "track",
                action: "shown",
                actionSubject: "csatSurvey",
                attributes: {
                    conversationId: conversationId,
                    messageId: agentMessageId,
                    layout: resolvedLayoutRef.current
                }
            });
        };
        $[8] = agentMessageId;
        $[9] = conversationId;
        $[10] = onCsatDisplayed;
        $[11] = sendAnalyticsEvent;
        $[12] = t7;
    } else t7 = $[12];
    const recordCsatSurveyShown = t7;
    let t8;
    if ($[13] !== agentMessageId || $[14] !== conversationId || $[15] !== onCsatInteracted || $[16] !== sendAnalyticsEvent) {
        t8 = ()=>{
            sendAnalyticsEvent({
                eventType: "track",
                action: "dismissed",
                actionSubject: "csatSurvey",
                attributes: {
                    conversationId: conversationId,
                    messageId: agentMessageId,
                    layout: resolvedLayoutRef.current
                }
            });
            setCsatRating(null);
            setIsCsatSurveyDismissed(true);
            onCsatInteracted();
        };
        $[13] = agentMessageId;
        $[14] = conversationId;
        $[15] = onCsatInteracted;
        $[16] = sendAnalyticsEvent;
        $[17] = t8;
    } else t8 = $[17];
    const handleCsatDismiss = t8;
    let t9;
    if ($[18] !== agentMessageId || $[19] !== conversationId || $[20] !== handleCsatFeedback || $[21] !== onCsatInteracted || $[22] !== sendAnalyticsEvent) {
        t9 = (rating_0)=>{
            const isLike = handleCsatFeedback(rating_0);
            sendAnalyticsEvent({
                eventType: "track",
                action: "submitted",
                actionSubject: "csatSurvey",
                attributes: {
                    csatRating: rating_0,
                    isLike: isLike,
                    conversationId: conversationId,
                    messageId: agentMessageId,
                    layout: resolvedLayoutRef.current
                }
            });
            setCsatRating(null);
            setIsCsatSurveyDismissed(true);
            onCsatInteracted();
        };
        $[18] = agentMessageId;
        $[19] = conversationId;
        $[20] = handleCsatFeedback;
        $[21] = onCsatInteracted;
        $[22] = sendAnalyticsEvent;
        $[23] = t9;
    } else t9 = $[23];
    const handleCsatSubmit = t9;
    let t10;
    if ($[24] !== csatFlowUsedThisTurn || $[25] !== csatRating || $[26] !== handleCsatDismiss || $[27] !== handleCsatSubmit || $[28] !== handleSelectRating || $[29] !== isCsatSurveyVisible || $[30] !== recordCsatSurveyShown) {
        t10 = {
            csatRating: csatRating,
            handleSelectRating: handleSelectRating,
            handleCsatSubmit: handleCsatSubmit,
            handleCsatDismiss: handleCsatDismiss,
            isCsatSurveyVisible: isCsatSurveyVisible,
            csatFlowUsedThisTurn: csatFlowUsedThisTurn,
            recordCsatSurveyShown: recordCsatSurveyShown,
            recordResolvedLayout: recordResolvedLayout
        };
        $[24] = csatFlowUsedThisTurn;
        $[25] = csatRating;
        $[26] = handleCsatDismiss;
        $[27] = handleCsatSubmit;
        $[28] = handleSelectRating;
        $[29] = isCsatSurveyVisible;
        $[30] = recordCsatSurveyShown;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : ({ conversationId: conversationId, agentMessageId: agentMessageId, isEligibleToShow: isEligibleToShow, hadPendingActionAtAnyPoint: hadPendingActionAtAnyPoint = false, shouldSuppressCsatForAgent: shouldSuppressCsatForAgent = false, handleCsatFeedback: handleCsatFeedback, onCsatInteracted: onCsatInteracted, onCsatDisplayed: onCsatDisplayed })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [csatRating, setCsatRating] = (0, $cozmU.useState)(null);
    const [isCsatSurveyDismissed, setIsCsatSurveyDismissed] = (0, $cozmU.useState)(false);
    const resolvedLayoutRef = (0, $cozmU.useRef)(null);
    const recordResolvedLayout = (0, $cozmU.useCallback)((layout)=>{
        if (resolvedLayoutRef.current !== null) return;
        resolvedLayoutRef.current = layout;
    }, []);
    // Fire a single "clicked" event for the first rating option a user picks in
    // this CSAT survey instance. Switching between rating options (or
    // programmatic resets to `null`) must NOT re-fire the event so we get an
    // accurate count of users who engaged with the survey but never submitted.
    const csatOptionClickedFiredRef = (0, $cozmU.useRef)(false);
    const handleSelectRating = (0, $cozmU.useCallback)((rating)=>{
        if (rating !== null && !csatOptionClickedFiredRef.current) {
            csatOptionClickedFiredRef.current = true;
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'clicked',
                actionSubject: 'csatSurveyOption',
                attributes: {
                    csatRating: rating,
                    conversationId: conversationId,
                    messageId: agentMessageId,
                    layout: resolvedLayoutRef.current
                }
            });
        }
        setCsatRating(rating);
    }, [
        sendAnalyticsEvent,
        conversationId,
        agentMessageId
    ]);
    // Sticky per-message latch: once eligibility is true at any point during this
    // message lifecycle, keep the flow active for the rest of the turn.
    // Commit-safe reducer transition (false -> true only), then OR with current
    // eligibility so the first eligible render can show immediately.
    const [csatFlowLatchedThisTurn, latchCsatFlowThisTurn] = (0, $cozmU.useReducer)((previous, next)=>previous || next, isEligibleToShow);
    (0, $cozmU.useEffect)(()=>{
        if (isEligibleToShow) latchCsatFlowThisTurn(true);
    }, [
        isEligibleToShow
    ]);
    const csatFlowUsedThisTurn = csatFlowLatchedThisTurn || isEligibleToShow;
    const isCsatSurveyVisible = csatFlowUsedThisTurn && !hadPendingActionAtAnyPoint && !shouldSuppressCsatForAgent && !isCsatSurveyDismissed;
    const csatShownFiredRef = (0, $cozmU.useRef)(false);
    const recordCsatSurveyShown = (0, $cozmU.useCallback)(()=>{
        if (csatShownFiredRef.current) return;
        csatShownFiredRef.current = true;
        // Start the 7-day soft cooldown so the survey doesn't re-appear on every response when the user ignores it.
        onCsatDisplayed();
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'shown',
            actionSubject: 'csatSurvey',
            attributes: {
                conversationId: conversationId,
                messageId: agentMessageId,
                layout: resolvedLayoutRef.current
            }
        });
    }, [
        sendAnalyticsEvent,
        conversationId,
        agentMessageId,
        onCsatDisplayed
    ]);
    const handleCsatDismiss = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'dismissed',
            actionSubject: 'csatSurvey',
            attributes: {
                conversationId: conversationId,
                messageId: agentMessageId,
                layout: resolvedLayoutRef.current
            }
        });
        setCsatRating(null);
        setIsCsatSurveyDismissed(true);
        onCsatInteracted();
    }, [
        sendAnalyticsEvent,
        conversationId,
        agentMessageId,
        onCsatInteracted
    ]);
    const handleCsatSubmit = (0, $cozmU.useCallback)((rating_0)=>{
        const isLike = handleCsatFeedback(rating_0);
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'submitted',
            actionSubject: 'csatSurvey',
            attributes: {
                csatRating: rating_0,
                isLike: isLike,
                conversationId: conversationId,
                messageId: agentMessageId,
                layout: resolvedLayoutRef.current
            }
        });
        setCsatRating(null);
        // Close the CSAT card after submit so it doesn't sit on screen
        // behind the detailed-feedback survey that `handleCsatFeedback` opens.
        setIsCsatSurveyDismissed(true);
        onCsatInteracted();
    }, [
        sendAnalyticsEvent,
        conversationId,
        agentMessageId,
        handleCsatFeedback,
        onCsatInteracted
    ]);
    return {
        csatRating: csatRating,
        handleSelectRating: handleSelectRating,
        handleCsatSubmit: handleCsatSubmit,
        handleCsatDismiss: handleCsatDismiss,
        isCsatSurveyVisible: isCsatSurveyVisible,
        csatFlowUsedThisTurn: csatFlowUsedThisTurn,
        recordCsatSurveyShown: recordCsatSurveyShown,
        recordResolvedLayout: recordResolvedLayout
    };
};
function $ca0a685ac6b27c04$var$_temp(previous, next) {
    return previous || next;
}


const $1268d21d92b61d24$var$TERMINAL_ACTION_STATUSES = new Set([
    'finished',
    'cancelled',
    'errored'
]);
const $1268d21d92b61d24$export$79e5625152e2c837 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { storeAssistant: storeAssistant, assistantResponse: assistantResponse, invokedActions: invokedActions, filteredActions: filteredActions, feedbackTypeV2: feedbackTypeV2, streamingComplete: streamingComplete, shouldHideFooterButtons: shouldHideFooterButtons, isConversationActivelyGenerating: isConversationActivelyGenerating, conversationId: conversationId, agentMessageId: agentMessageId, handleCsatFeedback: handleCsatFeedback } = t0;
    const [activeTask] = (0, $9qJ1N.useActiveTaskForConversation)(conversationId);
    const isFinalResponse = storeAssistant.content.type === "FINAL_RESPONSE" && Boolean(streamingComplete) && assistantResponse.message.async_status !== "IN_PROGRESS";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo_chat_csat_interaction_conclusion_signal");
        $[0] = t1;
    } else t1 = $[0];
    const isInteractionConclusionSignalEnabled = t1;
    const isSuccessfulInteractionConclusion = !isInteractionConclusionSignalEnabled || storeAssistant.interactionConclusionOutcome === "SUCCEEDED";
    const hasActionInTurn = Boolean(filteredActions?.length);
    const hasCompletedTaskOrNoTask = !hasActionInTurn || !activeTask || activeTask.progressState === "Completed";
    let t2;
    if ($[1] !== assistantResponse.message.actions) {
        t2 = assistantResponse.message.actions ?? [];
        $[1] = assistantResponse.message.actions;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== invokedActions || $[4] !== t2) {
        let t4;
        if ($[6] !== invokedActions) {
            t4 = (action)=>{
                const feStatus = invokedActions?.[action.invocationId];
                if (feStatus && $1268d21d92b61d24$var$TERMINAL_ACTION_STATUSES.has(feStatus)) return false;
                if (action.status && $1268d21d92b61d24$var$TERMINAL_ACTION_STATUSES.has(action.status)) return false;
                return true;
            };
            $[6] = invokedActions;
            $[7] = t4;
        } else t4 = $[7];
        t3 = t2.some(t4);
        $[3] = invokedActions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const hasPendingActionInput = t3;
    let t4;
    if ($[8] !== hasPendingActionInput) {
        t4 = ()=>hasPendingActionInput;
        $[8] = hasPendingActionInput;
        $[9] = t4;
    } else t4 = $[9];
    const [hadPendingActionAtAnyPoint, setHadPendingActionAtAnyPoint] = (0, $cozmU.useState)(t4);
    let t5;
    let t6;
    if ($[10] !== hadPendingActionAtAnyPoint || $[11] !== hasPendingActionInput) {
        t5 = ()=>{
            if (hasPendingActionInput && !hadPendingActionAtAnyPoint) setHadPendingActionAtAnyPoint(true);
        };
        t6 = [
            hasPendingActionInput,
            hadPendingActionAtAnyPoint
        ];
        $[10] = hadPendingActionAtAnyPoint;
        $[11] = hasPendingActionInput;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const messageAuthor = assistantResponse.message.author;
    const t7 = messageAuthor?.external_config_reference ?? messageAuthor?.named_id ?? messageAuthor?.id;
    let t8;
    if ($[14] !== t7) {
        t8 = (0, $4AQlH.normalizeAgentIdentityValue)(t7);
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const isFromDefaultRovoAgent = t8 === undefined;
    const { activeSelectedAgentId: activeSelectedAgentId } = (0, $bkEQw.useSelectedAgentDraftController)(conversationId);
    const shouldSuppressCsatForAgent = !isFromDefaultRovoAgent || activeSelectedAgentId !== undefined;
    const isRuntimeEligible = !storeAssistant.isHistorical && !feedbackTypeV2 && !isConversationActivelyGenerating && isFinalResponse && isSuccessfulInteractionConclusion && !shouldHideFooterButtons && hasCompletedTaskOrNoTask && !hadPendingActionAtAnyPoint && !shouldSuppressCsatForAgent;
    let t9;
    if ($[16] !== isRuntimeEligible) {
        t9 = {
            enabled: isRuntimeEligible
        };
        $[16] = isRuntimeEligible;
        $[17] = t9;
    } else t9 = $[17];
    const { isEligibleToShow: isEligibleToShow, onCsatInteracted: onCsatInteracted, onCsatDisplayed: onCsatDisplayed } = (0, $de8bd2dcb2dbc1d8$export$68b696976406592)(t9);
    let t10;
    if ($[18] !== agentMessageId || $[19] !== conversationId || $[20] !== hadPendingActionAtAnyPoint || $[21] !== handleCsatFeedback || $[22] !== isEligibleToShow || $[23] !== onCsatDisplayed || $[24] !== onCsatInteracted || $[25] !== shouldSuppressCsatForAgent) {
        t10 = {
            conversationId: conversationId,
            agentMessageId: agentMessageId,
            handleCsatFeedback: handleCsatFeedback,
            isEligibleToShow: isEligibleToShow,
            hadPendingActionAtAnyPoint: hadPendingActionAtAnyPoint,
            shouldSuppressCsatForAgent: shouldSuppressCsatForAgent,
            onCsatInteracted: onCsatInteracted,
            onCsatDisplayed: onCsatDisplayed
        };
        $[18] = agentMessageId;
        $[19] = conversationId;
        $[20] = hadPendingActionAtAnyPoint;
        $[21] = handleCsatFeedback;
        $[22] = isEligibleToShow;
        $[23] = onCsatDisplayed;
        $[24] = onCsatInteracted;
        $[25] = shouldSuppressCsatForAgent;
        $[26] = t10;
    } else t10 = $[26];
    const surveyState = (0, $ca0a685ac6b27c04$export$603352dd4f434363)(t10);
    const { isCsatSurveyVisible: isCsatSurveyVisible, recordCsatSurveyShown: recordCsatSurveyShown } = surveyState;
    let t11;
    let t12;
    if ($[27] !== isCsatSurveyVisible || $[28] !== recordCsatSurveyShown) {
        t11 = ()=>{
            if (isCsatSurveyVisible) recordCsatSurveyShown();
        };
        t12 = [
            isCsatSurveyVisible,
            recordCsatSurveyShown
        ];
        $[27] = isCsatSurveyVisible;
        $[28] = recordCsatSurveyShown;
        $[29] = t11;
        $[30] = t12;
    } else {
        t11 = $[29];
        t12 = $[30];
    }
    (0, $cozmU.useEffect)(t11, t12);
    return surveyState;
} : ({ storeAssistant: storeAssistant, assistantResponse: assistantResponse, invokedActions: invokedActions, filteredActions: filteredActions, feedbackTypeV2: feedbackTypeV2, streamingComplete: streamingComplete, shouldHideFooterButtons: shouldHideFooterButtons, isConversationActivelyGenerating: isConversationActivelyGenerating, conversationId: conversationId, agentMessageId: agentMessageId, handleCsatFeedback: handleCsatFeedback })=>{
    const [activeTask] = (0, $9qJ1N.useActiveTaskForConversation)(conversationId);
    const isFinalResponse = storeAssistant.content.type === 'FINAL_RESPONSE' && Boolean(streamingComplete) && assistantResponse.message.async_status !== 'IN_PROGRESS';
    const isInteractionConclusionSignalEnabled = (0, $iDrrr.fg)('rovo_chat_csat_interaction_conclusion_signal');
    const isSuccessfulInteractionConclusion = !isInteractionConclusionSignalEnabled || storeAssistant.interactionConclusionOutcome === 'SUCCEEDED';
    const hasActionInTurn = Boolean(filteredActions?.length);
    const hasCompletedTaskOrNoTask = !hasActionInTurn || !activeTask || activeTask.progressState === 'Completed';
    const hasPendingActionInput = (assistantResponse.message.actions ?? []).some((action)=>{
        const feStatus = invokedActions?.[action.invocationId];
        if (feStatus && $1268d21d92b61d24$var$TERMINAL_ACTION_STATUSES.has(feStatus)) return false;
        if (action.status && $1268d21d92b61d24$var$TERMINAL_ACTION_STATUSES.has(action.status)) return false;
        return true;
    });
    // Sticky per-message latch: if this message ever had a pending action,
    // CSAT stays suppressed here for its whole lifetime.
    const [hadPendingActionAtAnyPoint, setHadPendingActionAtAnyPoint] = (0, $cozmU.useState)(()=>hasPendingActionInput);
    (0, $cozmU.useEffect)(()=>{
        if (hasPendingActionInput && !hadPendingActionAtAnyPoint) setHadPendingActionAtAnyPoint(true);
    }, [
        hasPendingActionInput,
        hadPendingActionAtAnyPoint
    ]);
    // CSAT should only measure the default Rovo experience. Suppress when the
    // message was authored by a non-default agent, or when a selected-agent
    // draft is present (next turn will route away from default Rovo).
    const messageAuthor = assistantResponse.message.author;
    const isFromDefaultRovoAgent = (0, $4AQlH.normalizeAgentIdentityValue)(messageAuthor?.external_config_reference ?? messageAuthor?.named_id ?? messageAuthor?.id) === undefined;
    const { activeSelectedAgentId: activeSelectedAgentId } = (0, $bkEQw.useSelectedAgentDraftController)(conversationId);
    const shouldSuppressCsatForAgent = !isFromDefaultRovoAgent || activeSelectedAgentId !== undefined;
    const isRuntimeEligible = !storeAssistant.isHistorical && !feedbackTypeV2 && !isConversationActivelyGenerating && isFinalResponse && isSuccessfulInteractionConclusion && !shouldHideFooterButtons && hasCompletedTaskOrNoTask && !hadPendingActionAtAnyPoint && !shouldSuppressCsatForAgent;
    const { isEligibleToShow: isEligibleToShow, onCsatInteracted: onCsatInteracted, onCsatDisplayed: onCsatDisplayed } = (0, $de8bd2dcb2dbc1d8$export$68b696976406592)({
        enabled: isRuntimeEligible
    });
    const surveyState = (0, $ca0a685ac6b27c04$export$603352dd4f434363)({
        conversationId: conversationId,
        agentMessageId: agentMessageId,
        handleCsatFeedback: handleCsatFeedback,
        isEligibleToShow: isEligibleToShow,
        hadPendingActionAtAnyPoint: hadPendingActionAtAnyPoint,
        shouldSuppressCsatForAgent: shouldSuppressCsatForAgent,
        onCsatInteracted: onCsatInteracted,
        onCsatDisplayed: onCsatDisplayed
    });
    const { isCsatSurveyVisible: isCsatSurveyVisible, recordCsatSurveyShown: recordCsatSurveyShown } = surveyState;
    (0, $cozmU.useEffect)(()=>{
        if (isCsatSurveyVisible) recordCsatSurveyShown();
    }, [
        isCsatSurveyVisible,
        recordCsatSurveyShown
    ]);
    return surveyState;
};



var $75YqA = parcelRequire("75YqA");


var $3hnlP = parcelRequire("3hnlP");


var $2zDNQ = parcelRequire("2zDNQ");


var $lCO2g = parcelRequire("lCO2g");


var $4tJut = parcelRequire("4tJut");


var $aiNUD = parcelRequire("aiNUD");

function $848797c72628a22c$export$84202b743b23a95b(content, insertableSections) {
    if (!insertableSections || insertableSections.length === 0 || !content) return undefined;
    const extractedSections = insertableSections.filter((section)=>section.start >= 0 && section.end > section.start).map((section)=>content.slice(section.start, section.end).trim()).filter((s)=>s.length > 0);
    return extractedSections.length > 0 ? extractedSections.join('\n\n') : undefined;
}



var $eKjv9 = parcelRequire("eKjv9");


var $dSCNl = parcelRequire("dSCNl");





var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $hd4Ag = parcelRequire("hd4Ag");

/**
 * Ordered list of URL patterns for recognized Atlassian content objects.
 * Each entry maps a regex (with one capture group for the object ID) to an
 * objectType. The first matching entry wins.
 */ const $ebc3500d61452c04$var$URL_PATTERNS = [
    // Jira issue: /browse/PROJ-123
    {
        pattern: /\/browse\/([A-Z][A-Z0-9_]+-\d+)/,
        objectType: 'work-item'
    },
    // Jira project board with selected issue: /jira/.../projects/...?selectedIssue=PROJ-123
    {
        pattern: /\/jira\/.+\/projects\/.+[?&]selectedIssue=([A-Z][A-Z0-9_]+-\d+)/,
        objectType: 'work-item',
        includeSearch: true
    },
    // Confluence page. Supports view and editor URL shapes:
    //   /wiki/spaces/SPACE/pages/123456
    //   /wiki/spaces/SPACE/pages/123456/Page+Title
    //   /wiki/spaces/SPACE/pages/edit-v2/123456     (editor)
    //   /wiki/spaces/SPACE/pages/live-edit/123456   (live editor)
    // The optional non-capturing group only matches a non-numeric mode segment,
    // so it can never accidentally consume the page ID itself.
    {
        pattern: /\/wiki\/spaces\/[^/]+\/pages\/(?:[a-z][a-z0-9-]*\/)?(\d+)/i,
        objectType: 'page'
    },
    // Confluence blog post. Similar to pages but with /blog/ instead of /pages/
    {
        pattern: /\/wiki\/spaces\/[^/]+\/blog\/(?:[a-z][a-z0-9-]*\/)?(\d+)/i,
        objectType: 'blog'
    },
    /**
 * NOTE: This methodology does not work for Confluence whiteboards, slides, databases (or anything rendered in an iframe) because events cannot bubble from within iframes due to cross-origin restrictions.
 * Whiteboard and database teams to log this information themselves.
 */ // Bitbucket pull request: /repos/<repo>/pull-requests/123 or /pull-requests/123
    {
        pattern: /\/pull-requests\/(\d+)/,
        objectType: 'pull-request'
    }
];
function $ebc3500d61452c04$export$296659e5d6c89475(href) {
    try {
        const url = new URL(href);
        for (const { pattern: pattern, objectType: objectType, includeSearch: includeSearch } of $ebc3500d61452c04$var$URL_PATTERNS){
            const subject = includeSearch ? url.pathname + url.search : url.pathname;
            const match = subject.match(pattern);
            if (match) return {
                objectType: objectType,
                objectId: match[1]
            };
        }
        return null;
    } catch  {
        return null;
    }
}


const $2a049f27e8be6707$var$SENTINEL_ATTR = 'data-rovo-chat-copy-id';
function $2a049f27e8be6707$export$f018dffa6c2a806a() {
    // Stores the current sentinel ID — set on copy, cleared after paste or unmount
    const sentinelIdRef = (0, $cozmU.useRef)(null);
    // Stores the cleanup fn for the active paste listener
    const removeListenerRef = (0, $cozmU.useRef)(null);
    const location = (0, $hd4Ag.useWindowLocation)();
    // Mirror `location` in a ref so the paste listener (created at copy-time)
    // always reads the *current* URL when the user actually pastes, instead
    // of the URL that was active when registerCopy was invoked. The user
    // virtually always navigates between copying in Rovo chat and pasting
    // into the destination Atlassian object, so without this the parsed URL
    // would be stale (and typically resolve to `null`, suppressing the event).
    const locationRef = (0, $cozmU.useRef)(location);
    (0, $cozmU.useEffect)(()=>{
        locationRef.current = location;
    }, [
        location
    ]);
    // Clean up any pending listener on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            removeListenerRef.current?.();
        };
    }, []);
    const registerCopy = (0, $cozmU.useCallback)(({ messageId: messageId, analyticsMessageActions: analyticsMessageActions, trackAIMAUEvent: trackAIMAUEvent, interactionModeExecuted: interactionModeExecuted })=>{
        // Remove any existing pending paste listener before registering a new one
        removeListenerRef.current?.();
        removeListenerRef.current = null;
        // Generate a unique sentinel ID for this copy event
        const sentinelId = crypto.randomUUID();
        sentinelIdRef.current = sentinelId;
        // Append our sentinel to the clipboard HTML asynchronously.
        // We read the current clipboard HTML content first, then rewrite it
        // with the sentinel appended. If the clipboard doesn't support HTML
        // (e.g. only text was written), we skip the sentinel — the paste
        // listener will simply not match and will clean itself up.
        (async ()=>{
            try {
                const clipboardItems = await navigator.clipboard.read();
                for (const item of clipboardItems)if (item.types.includes('text/html')) {
                    const htmlBlob = await item.getType('text/html');
                    const htmlText = await htmlBlob.text();
                    const sentinel = `<span ${$2a049f27e8be6707$var$SENTINEL_ATTR}="${sentinelId}" style="font-size:0;display:inline-block;width:0;height:0;overflow:hidden"></span>`;
                    const newHtml = htmlText + sentinel;
                    // Preserve text/plain if present
                    let textBlob;
                    if (item.types.includes('text/plain')) textBlob = await item.getType('text/plain');
                    const newItem = textBlob ? new ClipboardItem({
                        'text/html': new Blob([
                            newHtml
                        ], {
                            type: 'text/html'
                        }),
                        'text/plain': textBlob
                    }) : new ClipboardItem({
                        'text/html': new Blob([
                            newHtml
                        ], {
                            type: 'text/html'
                        })
                    });
                    await navigator.clipboard.write([
                        newItem
                    ]);
                    break;
                }
            } catch  {
            // If we can't read/write the clipboard (e.g. permissions denied,
            // or only plain text was copied), just skip the sentinel write.
            // The paste listener will not find a matching sentinel and will
            // clean itself up harmlessly.
            }
            // Register paste listener regardless — if clipboard read failed,
            // the sentinel won't match and the listener removes itself cleanly.
            const handlePaste = (event)=>{
                // Capture sentinel BEFORE we tear down the listener, since the cleanup
                // in `removeListenerRef.current` also nulls out `sentinelIdRef.current`.
                const currentSentinelId = sentinelIdRef.current;
                // Always remove listener after first paste attempt
                removeListenerRef.current?.();
                removeListenerRef.current = null;
                sentinelIdRef.current = null;
                if (!currentSentinelId) return;
                // Only fire if the paste landed in an editable element — this rules
                // out accidental pastes into non-editable areas (e.g. the address bar,
                // search inputs that are not content editors, read-only sections).
                const target = event.target;
                const isEditable = target?.isContentEditable || target?.getAttribute?.('contenteditable') === 'true' || target?.tagName === 'TEXTAREA' || target?.tagName === 'INPUT';
                if (!isEditable) return;
                // Don't fire if the paste landed inside the Rovo chat panel itself
                // (e.g. the user pasted back into the chat input), or into a search
                // input — neither of these constitutes a modification of an Atlassian
                // content object.
                const isInsideChatPanel = !!target?.closest?.('[data-rovo-chat-panel]');
                const isSearchInput = target?.getAttribute?.('role') === 'search' || target?.type === 'search';
                if (isInsideChatPanel || isSearchInput) return;
                const html = event.clipboardData?.getData('text/html') ?? '';
                // Validate that this paste originated from our chat copy
                if (!html.includes(`${$2a049f27e8be6707$var$SENTINEL_ATTR}="${currentSentinelId}"`)) return;
                // Parse the current page URL (read at PASTE time, not copy time) to
                // identify the Atlassian object the user is pasting into.
                const rovoModifiedObject = (0, $ebc3500d61452c04$export$296659e5d6c89475)(locationRef.current);
                if (!rovoModifiedObject) // Not on a recognized Atlassian product page — don't fire
                return;
                trackAIMAUEvent({
                    type: 'adopted',
                    actionKey: 'copy',
                    rovoModifiedObjects: [
                        rovoModifiedObject
                    ],
                    proactive: false,
                    messageId: messageId,
                    messageActions: analyticsMessageActions,
                    singleInstrumentationID: messageId,
                    ...interactionModeExecuted ? {
                        attributes: {
                            interactionModeExecuted: interactionModeExecuted
                        }
                    } : {}
                });
            };
            const doc = (0, $1hQ0e.getDocument)();
            if (doc) {
                const unbind = (0, $cbY7C.bind)(doc, {
                    type: 'paste',
                    listener: handlePaste,
                    options: {
                        capture: true
                    }
                });
                removeListenerRef.current = ()=>{
                    unbind();
                    sentinelIdRef.current = null;
                };
            }
        })();
    }, // `location` is read via locationRef at paste time, so this callback
    // can be stable across navigations.
    []);
    return {
        registerCopy: registerCopy
    };
}



var $SJycm = parcelRequire("SJycm");


var $kBr4q = parcelRequire("kBr4q");


var $igyuJ = parcelRequire("igyuJ");

const $c6b118eef4adaf4b$export$608e161d688d66c0 = (0, $kBr4q.createActionsHook)((0, $igyuJ.store));



var $4ee1h = parcelRequire("4ee1h");


var $bFeyZ = parcelRequire("bFeyZ");

// Helper function to extract data by type and index from markdownData
const $27146ba918be8917$export$4499bf045ea6bd06 = ({ markdownData: markdownData, type: type, index: index })=>{
    return markdownData?.[`${type}-${index}`];
};



var $iEKWu = parcelRequire("iEKWu");


var $3TxKn = parcelRequire("3TxKn");


var $5wAPd = parcelRequire("5wAPd");





var $eudbX = parcelRequire("eudbX");

const $fbed1930e790305e$export$af21e4ef6e16e2cc = (0, $kBr4q.createActionsHook)((0, $eudbX.store));



var $5l24t = parcelRequire("5l24t");


var $3Ofxv = parcelRequire("3Ofxv");


var $4JJQd = parcelRequire("4JJQd");













const $353c45de4e724fd9$export$fc049b80f1e5421b = {
    ISSUE_SEARCH: 'IssueSearchTool'
};


const $8ea096812ead765a$export$f5e9d1f59ec8d654 = Object.values((0, $353c45de4e724fd9$export$fc049b80f1e5421b));


const $4dc860647edf3730$export$5139c41f92c3af05 = (name)=>{
    return (0, $8ea096812ead765a$export$f5e9d1f59ec8d654).includes(name);
};



var $5Tn11 = parcelRequire("5Tn11");


var $jHYve = parcelRequire("jHYve");


var $cQWN1 = parcelRequire("cQWN1");


var $85mU8 = parcelRequire("85mU8");

const $62c02cdda12fb43e$export$bbc35ebbcd0ee518 = (pluginInvocation)=>{
    // guard checks
    const pluginInput = pluginInvocation.plugin_input;
    if (!pluginInput) return;
    // extract jql from the plugin invocation
    let jql;
    try {
        const parsedInput = JSON.parse(pluginInput);
        jql = parsedInput.jql;
    } catch  {
        return;
    }
    if (!jql) return;
    const bridge = (0, $85mU8.getBrowserBridgeAPI)();
    bridge.send((0, $cQWN1.JiraNLToJQLCommand), {
        receiverId: (0, $jHYve.JIRA_NL_TO_JQL_CLIENT_ID),
        senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
        data: [
            {
                jql: jql
            }
        ]
    });
};



const $ed2d12262b5cb709$export$d5af5083a0a9452f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (pluginInvocations)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    bb0: {
        if (!(0, $iDrrr.fg)("rovo_chat_jira_nl_to_jql_minion_in_fe")) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [];
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[1] !== pluginInvocations) {
            t1 = pluginInvocations.flatMap($ed2d12262b5cb709$var$_temp);
            $[1] = pluginInvocations;
            $[2] = t1;
        } else t1 = $[2];
        t0 = t1;
    }
    const filteredPluginInvocations = t0;
    let t1;
    let t2;
    if ($[3] !== filteredPluginInvocations) {
        t1 = ()=>{
            filteredPluginInvocations.forEach($ed2d12262b5cb709$var$_temp2);
        };
        t2 = [
            filteredPluginInvocations
        ];
        $[3] = filteredPluginInvocations;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : (pluginInvocations)=>{
    // filter for only the ones that we have handlers for
    const filteredPluginInvocations = (0, $cozmU.useMemo)(()=>{
        // currently only the 'rovo_chat_jira_nl_to_jql_minion_in_fe' feature uses this
        // handler so return immediately if this gate is not active
        if (!(0, $iDrrr.fg)('rovo_chat_jira_nl_to_jql_minion_in_fe')) return [];
        // using flatmap to both filter out the plugins without names and change the
        // ones with names to type of NamedPluginInvocationMessage
        return pluginInvocations.flatMap((pluginInvocation)=>{
            const name = pluginInvocation.plugin_name;
            // at the moment i don't know any other way to clearly identify
            // plugins except by name so any plugins without names will be
            // ignored
            if (!name || !(0, $4dc860647edf3730$export$5139c41f92c3af05)(name)) return [];
            return {
                definedName: name,
                ...pluginInvocation
            };
        });
    }, [
        pluginInvocations
    ]);
    (0, $cozmU.useEffect)(()=>{
        filteredPluginInvocations.forEach((pluginInvocation_0)=>{
            const name_0 = pluginInvocation_0.definedName;
            switch(name_0){
                case (0, $353c45de4e724fd9$export$fc049b80f1e5421b).ISSUE_SEARCH:
                    (0, $62c02cdda12fb43e$export$bbc35ebbcd0ee518)(pluginInvocation_0);
            }
        });
    }, [
        filteredPluginInvocations
    ]);
};
function $ed2d12262b5cb709$var$_temp(pluginInvocation) {
    const name = pluginInvocation.plugin_name;
    if (!name || !(0, $4dc860647edf3730$export$5139c41f92c3af05)(name)) return [];
    return {
        definedName: name,
        ...pluginInvocation
    };
}
function $ed2d12262b5cb709$var$_temp2(pluginInvocation_0) {
    const name_0 = pluginInvocation_0.definedName;
    switch(name_0){
        case (0, $353c45de4e724fd9$export$fc049b80f1e5421b).ISSUE_SEARCH:
            (0, $62c02cdda12fb43e$export$bbc35ebbcd0ee518)(pluginInvocation_0);
    }
}



var $dPoYT = parcelRequire("dPoYT");


var $ari4I = parcelRequire("ari4I");


var $aGWMb = parcelRequire("aGWMb");


/** True if `node` looks like an ADF `paragraph` node. */ const $0a6a86be8a114ba2$export$35f600abfe6f0127 = (node)=>typeof node === 'object' && node !== null && node.type === 'paragraph';


const $45ba265042838184$export$76aab34157a17ec4 = (children)=>{
    const onlyChild = children.length === 1 ? children[0] : undefined;
    if ((0, $0a6a86be8a114ba2$export$35f600abfe6f0127)(onlyChild)) return (onlyChild.content ?? []).map((0, $a05efe8991f695b1$export$44bd0526f662c4c0)).join('');
    return children.map((0, $a05efe8991f695b1$export$44bd0526f662c4c0)).join('');
};


const $521fee9ffa5da568$export$974da7009e560c73 = (node)=>node;


/**
 * Escapes a string for safe interpolation into HTML *text* content.
 * Use {@link escapeHtmlAttr} for HTML attribute values.
 */ const $212d5a85c067dce5$export$4cf11838cdc2a8a8 = (text)=>text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');



const $5ee07104e1f47b5b$export$ae8068d057b5a905 = (value)=>(0, $212d5a85c067dce5$export$4cf11838cdc2a8a8)(value);


const $0ac34bb7cdf8c87c$export$b8a0d78ca6be6390 = (type, safeUrl, rawUrl)=>{
    const cardUrl = (0, $5ee07104e1f47b5b$export$ae8068d057b5a905)(safeUrl);
    if (type === 'embedCard') return `<div data-embed-card="" data-card-url="${cardUrl}"></div>`;
    const dataAttr = type === 'blockCard' ? 'data-block-card' : 'data-inline-card';
    return `<a ${dataAttr}="" data-card-url="${cardUrl}" href="${cardUrl}">${(0, $212d5a85c067dce5$export$4cf11838cdc2a8a8)(rawUrl)}</a>`;
};




// Stricter check for smart-link card URLs, which must be resolvable http(s).
// NOTE: this is intentionally duplicated in @atlassian/lumina's
// smartlinklist-converter (which cannot depend on this package), where it gates
// smart-link-list items. The two MUST stay in sync — the 'isHttpUrl cross-package
// contract' tests in clipboard-serialiser-test.ts check both against the same
// list of test URLs to catch drift.
const $cafdacc3949739cf$export$c03cee527f684144 = /^https?:/i;


const $2d8fc59e6dad75c0$export$206c3129b8bb1b4f = (url)=>(0, $cafdacc3949739cf$export$c03cee527f684144).test(url.trim());


/**
 * Allowlist of URL schemes that are safe to put into a generic `href`. Anything
 * else (notably `javascript:`, `data:`, `vbscript:`, and protocol-relative URLs
 * like `//example.com`) is replaced with an empty href so a malformed or
 * attacker-controlled ADF cannot inject script execution or unexpected external
 * navigation into the clipboard payload.
 *
 * Do NOT use this for smart-card URLs — cards must be resolvable http(s) only;
 * use `isHttpUrl` for those.
 */ const $8cf6bbf8de5bc627$export$d3ac085d5abad494 = /^(?:https?:|mailto:|\/(?!\/)|#)/i;


const $1b977da35142ffa4$export$c9f92f5469372e0f = (url)=>(0, $8cf6bbf8de5bc627$export$d3ac085d5abad494).test(url.trim());


const $a05efe8991f695b1$export$44bd0526f662c4c0 = (node)=>{
    const n = (0, $521fee9ffa5da568$export$974da7009e560c73)(node);
    switch(n.type){
        case 'doc':
            return (n.content ?? []).map($a05efe8991f695b1$export$44bd0526f662c4c0).join('');
        case 'paragraph':
            return `<p>${(n.content ?? []).map($a05efe8991f695b1$export$44bd0526f662c4c0).join('')}</p>`;
        case 'heading':
            {
                // Clamp level to the valid HTML heading range so attacker-controlled or
                // malformed ADF cannot produce nonsense tags like <h7> or <hX>.
                const rawLevel = n.attrs?.level;
                const level = typeof rawLevel === 'number' && rawLevel >= 1 && rawLevel <= 6 ? Math.floor(rawLevel) : 1;
                return `<h${level}>${(n.content ?? []).map($a05efe8991f695b1$export$44bd0526f662c4c0).join('')}</h${level}>`;
            }
        case 'bulletList':
            return `<ul>${(n.content ?? []).map($a05efe8991f695b1$export$44bd0526f662c4c0).join('')}</ul>`;
        case 'orderedList':
            {
                const rawOrder = n.attrs?.order;
                const order = typeof rawOrder === 'number' && Number.isFinite(rawOrder) && rawOrder > 1 ? Math.floor(rawOrder) : undefined;
                const startAttr = order ? ` start="${order}"` : '';
                return `<ol${startAttr}>${(n.content ?? []).map($a05efe8991f695b1$export$44bd0526f662c4c0).join('')}</ol>`;
            }
        case 'listItem':
            return `<li>${(0, $45ba265042838184$export$76aab34157a17ec4)(n.content ?? [])}</li>`;
        case 'codeBlock':
            return `<pre><code>${(n.content ?? []).map($a05efe8991f695b1$export$44bd0526f662c4c0).join('')}</code></pre>`;
        case 'hardBreak':
            return '<br>';
        case 'inlineCard':
        case 'blockCard':
        case 'embedCard':
            {
                const url = String(n.attrs?.url ?? '');
                // Smart-link cards only resolve http(s) URLs. Reject anything else
                // (javascript:, data:, mailto:, relative, #frag) so a malformed ADF
                // can neither land a dangerous URL on the clipboard nor produce an
                // unresolvable card.
                const safeUrl = (0, $2d8fc59e6dad75c0$export$206c3129b8bb1b4f)(url) ? url : '';
                return (0, $0ac34bb7cdf8c87c$export$b8a0d78ca6be6390)(n.type, safeUrl, url);
            }
        case 'mention':
            {
                // data-mention-id lets the paste pipeline reconstruct an ADF mention.
                // Escape all interpolated values because clipboard HTML may be
                // pasted into unsanitised targets.
                const id = String(n.attrs?.id ?? '');
                const text = String(n.attrs?.text ?? `@${id}`);
                const userType = String(n.attrs?.userType ?? 'DEFAULT');
                return `<span data-mention-id="${(0, $5ee07104e1f47b5b$export$ae8068d057b5a905)(id)}" data-user-type="${(0, $5ee07104e1f47b5b$export$ae8068d057b5a905)(userType)}" contenteditable="false">${(0, $212d5a85c067dce5$export$4cf11838cdc2a8a8)(text)}</span>`;
            }
        case 'text':
            {
                let html = (0, $212d5a85c067dce5$export$4cf11838cdc2a8a8)(n.text ?? '');
                const marks = n.marks ?? [];
                for (const mark of marks){
                    if (mark.type === 'strong') html = `<strong>${html}</strong>`;
                    else if (mark.type === 'em') html = `<em>${html}</em>`;
                    else if (mark.type === 'underline') html = `<u>${html}</u>`;
                    else if (mark.type === 'strike') html = `<s>${html}</s>`;
                    else if (mark.type === 'code') html = `<code>${html}</code>`;
                    else if (mark.type === 'link') {
                        const href = String(mark.attrs?.href ?? '');
                        const safeHref = (0, $1b977da35142ffa4$export$c9f92f5469372e0f)(href) ? href : '';
                        html = `<a href="${(0, $5ee07104e1f47b5b$export$ae8068d057b5a905)(safeHref)}">${html}</a>`;
                    }
                }
                return html;
            }
        default:
            if (Array.isArray(n.content) && n.content.length > 0) return n.content.map($a05efe8991f695b1$export$44bd0526f662c4c0).join('');
            return n.text ? (0, $212d5a85c067dce5$export$4cf11838cdc2a8a8)(n.text) : '';
    }
};



const $437819c586833d09$export$835ab8cf7c4a00b4 = (node)=>{
    const n = (0, $521fee9ffa5da568$export$974da7009e560c73)(node);
    if (n.type === 'text') return n.text ?? '';
    if (n.type === 'hardBreak') return '\n';
    if (n.type === 'mention') {
        // Fall back to the id when the mention label is still unresolved.
        const mentionText = n.attrs?.text;
        const hasName = typeof mentionText === 'string' && mentionText !== '@' && mentionText !== '';
        return hasName ? mentionText : `@${n.attrs?.id ?? ''}`;
    }
    if (n.type === 'inlineCard' || n.type === 'blockCard' || n.type === 'embedCard') {
        const url = n.attrs?.url;
        return typeof url === 'string' ? url : '';
    }
    // Block nodes — separate with newlines for readability. `listItem` is
    // intentionally omitted: its child (typically a paragraph) already supplies
    // a trailing '\n', so re-adding one here yields a blank line per bullet.
    const childText = Array.isArray(n.content) ? n.content.map($437819c586833d09$export$835ab8cf7c4a00b4).join('') : '';
    if (n.type === 'paragraph' || n.type === 'heading' || n.type === 'bulletList' || n.type === 'orderedList' || n.type === 'codeBlock') return childText + '\n';
    return childText;
};



var $gIoZF = parcelRequire("gIoZF");

const $9c699046e74af916$export$6f1bc251cc9b5a57 = (content, markdownData)=>{
    try {
        const adfDoc = (0, $gIoZF.buildAdfDocForRichText)(content, markdownData);
        if (!adfDoc || !adfDoc.content || adfDoc.content.length === 0) {
            // Preserve plain-text fallback when rich conversion produces no insertable content.
            const plain = typeof content === 'string' ? content : (0, $437819c586833d09$export$835ab8cf7c4a00b4)(content).trim();
            return {
                plain: plain,
                html: null,
                format: 'plain'
            };
        }
        const html = (0, $a05efe8991f695b1$export$44bd0526f662c4c0)(adfDoc);
        const plain = (0, $437819c586833d09$export$835ab8cf7c4a00b4)(adfDoc).trim();
        if (!html) return {
            plain: plain,
            html: null,
            format: 'plain'
        };
        return {
            plain: plain,
            html: html,
            format: 'rich'
        };
    } catch  {
        const plain = typeof content === 'string' ? content : String(content);
        return {
            plain: plain,
            html: null,
            format: 'plain'
        };
    }
};



var $eAl7N = parcelRequire("eAl7N");

const $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction = (_value)=>undefined;
const $5ae6fc04f9da25b5$export$41890f70bc41601f = (interaction)=>{
    switch(interaction.type){
        case 'sourceActivated':
            switch(interaction.activation){
                case 'open':
                    return 'sourceLinkOpened';
                case 'copy':
                    return 'sourceLinkCopied';
                case 'contextMenu':
                    return 'sourceLinkContextMenuOpened';
                default:
                    return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(interaction.activation);
            }
        case 'cardActivated':
            const component = interaction.component;
            switch(component){
                case 'smartLink':
                    return 'smartLinkClicked';
                case 'actionCard':
                    return 'actionCardClicked';
                default:
                    return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(component);
            }
        case 'cardContextMenuOpened':
            const contextMenuComponent = interaction.component;
            switch(contextMenuComponent){
                case 'smartLink':
                    return 'smartLinkContextMenuOpened';
                case 'actionCard':
                    return 'actionCardContextMenuOpened';
                default:
                    return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(contextMenuComponent);
            }
        case 'sectionStateChanged':
            switch(interaction.state){
                case 'expanded':
                    return 'sectionExpanded';
                case 'collapsed':
                    return 'sectionCollapsed';
                default:
                    return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(interaction.state);
            }
        case 'carouselNavigated':
            switch(interaction.direction){
                case 'previous':
                    return 'carouselPrevious';
                case 'next':
                    return 'carouselNext';
                default:
                    return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(interaction.direction);
            }
        case 'peoplePreviewInteracted':
            switch(interaction.action){
                case 'viewProfile':
                    return 'peopleProfileViewed';
                case 'viewReportingLines':
                    return 'peopleReportingLinesViewed';
                case 'startMessage':
                    return 'peopleMessageStarted';
                case 'openRecentWorkItem':
                    return 'peopleRecentWorkItemOpened';
                case 'openRecentWorkItemContextMenu':
                    return 'peopleRecentWorkItemContextMenuOpened';
                case 'viewAllRecentWork':
                    return 'peopleRecentWorkViewAllOpened';
                case 'expandRecentWork':
                    return 'peopleRecentWorkExpanded';
                case 'expandCollaborators':
                    return 'peopleCollaboratorsExpanded';
                case 'selectTab':
                    return 'peopleProfileTabSelected';
                case 'clickHierarchyNode':
                    return 'peopleHierarchyNodeClicked';
                default:
                    return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(interaction.action);
            }
        default:
            return $5ae6fc04f9da25b5$var$ignoreUnexpectedInteraction(interaction);
    }
};















var $aJU2k = parcelRequire("aJU2k");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $9EOlJ = parcelRequire("9EOlJ");








var $ad7Ou = parcelRequire("ad7Ou");





var $lMGh1 = parcelRequire("lMGh1");







var $1l0kj = parcelRequire("1l0kj");


var $lfoFx = parcelRequire("lfoFx");





var $9yffN = parcelRequire("9yffN");


var $1uJIC = parcelRequire("1uJIC");





var $igOtY = parcelRequire("igOtY");


var $hMLWD = parcelRequire("hMLWD");


var $7eUSO = parcelRequire("7eUSO");







const $8d44f437faea350d$var$message = (0, $kSwu1.defineMessages)({
    confirmActionButton: {
        id: "ai-mate.chat-history.store-assistant.message-actions.confirm-button",
        defaultMessage: "Confirm"
    },
    cancelActionButton: {
        id: "ai-mate.chat-history.store-assistant.message-actions.cancel-button",
        defaultMessage: "Cancel"
    },
    erroredActionButton: {
        id: "ai-mate.chat-history.store-assistant.message-actions.errored-button",
        defaultMessage: "There was an issue completing this action"
    }
});
var $8d44f437faea350d$export$2e2bcd8739ae039 = $8d44f437faea350d$var$message;


const $9f0d5aa4f8896d10$var$styles = {
    wrapper: "_46hvQm1Y8M _0xmtko8HPE"
};
const $9f0d5aa4f8896d10$var$isActionEnded = (actionStatus)=>{
    if (!actionStatus) return false;
    return [
        'finished',
        'errored',
        'cancelled'
    ].includes(actionStatus);
};
const $9f0d5aa4f8896d10$export$dbbd5617eb71f0d = ({ actions: actions, onActioned: onActioned, invokedActions: invokedActions, recipientAgentNamedId: recipientAgentNamedId, recipientAgentId: recipientAgentId, recipientAgentName: recipientAgentName, conversationId: conversationId, messageId: messageId, messageType: messageType, jiraActivationId: jiraActivationId, isHistoricalMessage: isHistoricalMessage, isLastMessage: isLastMessage, isLastActionMessage: isLastActionMessage, interactionModeExecuted: interactionModeExecuted, taskModeEnabled: taskModeEnabled, cloudId: cloudId, orgId: orgId, aaid: aaid, productKey: productKey, experienceId: experienceId, renderingTouchpoint: renderingTouchpoint, isContentPreviewSupported: isContentPreviewSupported, sendMessageConfirmedTools: sendMessageConfirmedTools, resolveActionsBulk: resolveActionsBulk, messageActionsAnalytics: messageActionsAnalytics })=>{
    (0, $6cFsl.di)((0, $637t4.useCustomMessageActionBroker), (0, $igOtY.getActionInvocationStatus));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleDefaultActionConfirmed = (0, $cozmU.useCallback)((action)=>onActioned({
            context: {
                messageId: messageId,
                data: action.data,
                invocationId: action.invocationId,
                key: action.key,
                resolution: {
                    type: 'confirm'
                },
                recipient_agent_named_id: recipientAgentNamedId
            }
        }), [
        messageId,
        onActioned,
        recipientAgentNamedId
    ]);
    const handleDefaultActionCancelled = (0, $cozmU.useCallback)((action_0)=>onActioned({
            context: {
                messageId: messageId,
                data: action_0.data,
                invocationId: action_0.invocationId,
                key: action_0.key,
                resolution: {
                    type: 'cancel'
                },
                recipient_agent_named_id: recipientAgentNamedId
            }
        }), [
        messageId,
        onActioned,
        recipientAgentNamedId
    ]);
    const handleDefaultActionActionedElsewhere = (0, $cozmU.useCallback)((action_1, message)=>onActioned({
            context: {
                messageId: messageId,
                data: action_1.data,
                invocationId: action_1.invocationId,
                key: action_1.key,
                resolution: {
                    type: 'actioned',
                    message: message
                },
                recipient_agent_named_id: recipientAgentNamedId
            }
        }), [
        messageId,
        onActioned,
        recipientAgentNamedId
    ]);
    const handleCustomDataActionConfirmed = (0, $cozmU.useCallback)((action_2, data, actionContentProcessor)=>onActioned({
            context: {
                messageId: messageId,
                data: data,
                invocationId: action_2.invocationId,
                key: action_2.key,
                resolution: {
                    type: 'confirm'
                },
                recipient_agent_named_id: recipientAgentNamedId
            }
        }, actionContentProcessor), [
        messageId,
        onActioned,
        recipientAgentNamedId
    ]);
    const handleCustomDataActionActionedElsewhere = (0, $cozmU.useCallback)((action_3, data_0, message_0, skipSuccessOptimisticAssistantResponse)=>onActioned({
            context: {
                messageId: messageId,
                data: data_0,
                invocationId: action_3.invocationId,
                key: action_3.key,
                resolution: {
                    type: 'actioned',
                    message: message_0
                },
                recipient_agent_named_id: recipientAgentNamedId
            }
        }, undefined, {
            skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse
        }), [
        messageId,
        onActioned,
        recipientAgentNamedId
    ]);
    const getReadonly = (0, $cozmU.useCallback)((action_4)=>$9f0d5aa4f8896d10$var$isActionEnded(action_4.status) || $9f0d5aa4f8896d10$var$isActionEnded((0, $igOtY.getActionInvocationStatus)(action_4.invocationId, invokedActions)), [
        invokedActions
    ]);
    const getStatus = (0, $cozmU.useCallback)((action_5)=>(0, $igOtY.getActionInvocationStatus)(action_5.invocationId, invokedActions), [
        invokedActions
    ]);
    const getActionLoading = (0, $cozmU.useCallback)((action_6)=>(0, $igOtY.getActionInvocationStatus)(action_6.invocationId, invokedActions) === 'started', [
        invokedActions
    ]);
    const getActionError = (0, $cozmU.useCallback)((action_7)=>(0, $igOtY.getActionInvocationStatus)(action_7.invocationId, invokedActions) === 'errored', [
        invokedActions
    ]);
    const handleCancel = (0, $cozmU.useCallback)((action_8)=>{
        // TODO: Remove the legacy `onCancel` path once the tools resumption migration is
        // cleaned up (kill switch and experiment removed).
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((idleAction)=>getStatus(idleAction) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'messageActionsContainerCancel'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((idleAction_0)=>(0, $7eUSO.buildToolFromAction)(idleAction_0, 'cancelled'))
                }
            });
            return;
        }
        handleDefaultActionCancelled(action_8);
    }, [
        actions,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        handleDefaultActionCancelled
    ]);
    const getCancelButton = (0, $cozmU.useCallback)((action_9, isDisabled = false)=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            isDisabled: isDisabled || getActionLoading(action_9),
            appearance: "subtle",
            onClick: ()=>handleCancel(action_9)
        }, formatMessage((0, $8d44f437faea350d$export$2e2bcd8739ae039).cancelActionButton));
    }, [
        getActionLoading,
        handleCancel,
        formatMessage
    ]);
    const customAction = (0, $637t4.useCustomMessageActionBroker)(actions, {
        getStatus: getStatus,
        getReadonly: getReadonly,
        // TODO: consolidate action statuses in AIM-3229
        onConfirm: handleDefaultActionConfirmed,
        onCancel: handleDefaultActionCancelled,
        onActioned: handleDefaultActionActionedElsewhere,
        onCustomDataConfirm: handleCustomDataActionConfirmed,
        onCustomDataActioned: handleCustomDataActionActionedElsewhere,
        ContentRenderer: $1PVOM.ContentRenderer,
        getCancelButton: getCancelButton,
        cloudId: cloudId,
        ...orgId ? {
            orgId: orgId
        } : {},
        aaid: aaid,
        recipientAgentNamedId: recipientAgentNamedId,
        recipientAgentId: recipientAgentId,
        recipientAgentName: recipientAgentName,
        conversationId: conversationId,
        messageId: messageId,
        productKey: productKey,
        experienceId: experienceId,
        sendMessageConfirmedTools: sendMessageConfirmedTools,
        resolveActionsBulk: resolveActionsBulk,
        jiraActivationId: jiraActivationId,
        isHistoricalMessage: isHistoricalMessage,
        interactionModeExecuted: interactionModeExecuted,
        taskModeEnabled: taskModeEnabled,
        ...(0, $iDrrr.fg)('fe_enable_sa_externally') && {
            renderingTouchpoint: renderingTouchpoint
        },
        ...(0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') && {
            isLastMessage: isLastMessage
        },
        ...(0, $iDrrr.fg)('jsm-kb-action-message-prop') && {
            isLastActionMessage: isLastActionMessage
        }
    }, messageActionsAnalytics);
    if (customAction) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9f0d5aa4f8896d10$var$styles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>/*#__PURE__*/ $cozmU.createElement((0, $hMLWD.ChatGenericError), {
                errorType: "generic"
            })
    }, customAction));
    if (messageType === 'FINAL_RESPONSE' && (0, $iDrrr.fg)('aifc_create_enabled')) {
        const streamActions = actions.filter((action_10)=>(0, $i7OAD.isSupportedStreamAction)({
                key: action_10.key
            }));
        if (streamActions.length > 0) // For all streaming actions, we do not have a confirm/cancel phase in the UI
        return null;
    }
    if (messageType === 'FINAL_RESPONSE' && (0, $iDrrr.fg)('jira_aifc_enabled')) {
        const jiraCreatableActions = actions.filter((action_11)=>(0, $9yffN.isJiraCreatableAction)({
                key: action_11.key
            }));
        if (jiraCreatableActions.length > 0) // Don't show the confirm button in the chat for Jira AIFC actions
        return null;
    }
    if (messageType === 'FINAL_RESPONSE' && (0, $iDrrr.fg)('surveys-aifc')) {
        const jsmCreatableActions = actions.filter((action_12)=>(0, $1uJIC.isJsmCreatableAction)({
                key: action_12.key
            }));
        if (jsmCreatableActions.length > 0) // Don't show the confirm button in the chat for JSM AIFC actions
        return null;
    } // Don't show confirm/cancel for previewable actions when preview cards are
    // enabled - this allows any product where AIFC is disabled to show preview cards for
    // previewable actions where we can then open them in Atlassian Home
    if (messageType === 'FINAL_RESPONSE' && !isContentPreviewSupported && !(0, $iDrrr.fg)('aifc_create_enabled')) {
        const previewableActions = actions.filter((action_13)=>(0, $i7OAD.isPreviewCardAction)(action_13));
        if (previewableActions.length > 0) // Don't show confirm/cancel buttons - render preview cards instead
        return null;
    }
    return actions.map((action_14)=>{
        const actionInvocationStatus = (0, $igOtY.getActionInvocationStatus)(action_14.invocationId, invokedActions);
        if (!action_14 || !!action_14.status && action_14.status !== 'planned' || actionInvocationStatus === 'finished' || actionInvocationStatus === 'cancelled') return null;
        const actionLoading = getActionLoading(action_14);
        const actionError = getActionError(action_14);
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            key: action_14.invocationId,
            space: "space.100",
            xcss: $9f0d5aa4f8896d10$var$styles.wrapper,
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            isDisabled: actionLoading,
            onClick: ()=>handleDefaultActionConfirmed(action_14)
        }, formatMessage((0, $8d44f437faea350d$export$2e2bcd8739ae039).confirmActionButton)), getCancelButton(action_14), actionLoading && /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "message-action-loading-spinner"
        }), actionError && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            color: "currentColor",
            spacing: "spacious",
            label: formatMessage((0, $8d44f437faea350d$export$2e2bcd8739ae039).erroredActionButton)
        }));
    });
};



var $8akfd = parcelRequire("8akfd");























var $hlvTd = parcelRequire("hlvTd");

const $0b54e2a16a4f5628$export$29313ff2bda62c4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { recipientAgentNamedId: recipientAgentNamedId, messageId: messageId } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] !== messageId || $[1] !== recipientAgentNamedId || $[2] !== sendAnalyticsEvent) {
        t1 = (action, t2)=>{
            const { error: error } = t2;
            sendAnalyticsEvent({
                eventType: "track",
                action: "error",
                actionSubject: "rovoChatMessageAction",
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: action.key,
                    messageId: messageId
                }
            });
            (0, $hlvTd.logException)({
                name: "rovoChatMessageAction",
                exception: error,
                tags: {
                    component: "useActionRenderer",
                    actionKey: action.key,
                    invocationId: action.invocationId,
                    actionId: String(action.actionId),
                    status: String(action.status)
                }
            });
        };
        $[0] = messageId;
        $[1] = recipientAgentNamedId;
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const onErrorRender = t1;
    let t2;
    if ($[4] !== recipientAgentNamedId || $[5] !== sendAnalyticsEvent) {
        t2 = (action_0)=>{
            if (!action_0 || action_0.status !== "planned") return;
            sendAnalyticsEvent({
                eventType: "screen",
                name: "rovoChatMessageAction",
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: action_0.key
                }
            });
        };
        $[4] = recipientAgentNamedId;
        $[5] = sendAnalyticsEvent;
        $[6] = t2;
    } else t2 = $[6];
    const onSuccessRender = t2;
    let t3;
    if ($[7] !== onErrorRender || $[8] !== onSuccessRender) {
        t3 = {
            onErrorRender: onErrorRender,
            onSuccessRender: onSuccessRender
        };
        $[7] = onErrorRender;
        $[8] = onSuccessRender;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ recipientAgentNamedId: recipientAgentNamedId, messageId: messageId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const onErrorRender = (0, $cozmU.useCallback)((action, { error: error })=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'error',
            actionSubject: 'rovoChatMessageAction',
            attributes: {
                recipientAgentNamedId: recipientAgentNamedId,
                actionKey: action.key,
                messageId: messageId
            }
        });
        (0, $hlvTd.logException)({
            name: 'rovoChatMessageAction',
            exception: error,
            tags: {
                component: 'useActionRenderer',
                actionKey: action.key,
                invocationId: action.invocationId,
                actionId: String(action.actionId),
                status: String(action.status)
            }
        });
    }, [
        sendAnalyticsEvent,
        recipientAgentNamedId,
        messageId
    ]);
    const onSuccessRender = (0, $cozmU.useCallback)((action_0)=>{
        if (!action_0 || action_0.status !== 'planned') return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatMessageAction',
            attributes: {
                recipientAgentNamedId: recipientAgentNamedId,
                actionKey: action_0.key
            }
        });
    }, [
        sendAnalyticsEvent,
        recipientAgentNamedId
    ]);
    return {
        onErrorRender: onErrorRender,
        onSuccessRender: onSuccessRender
    };
};





const $d77110d97ca2071c$export$fb14e7c6e673c7b4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(31);
    (0, $6cFsl.di)((0, $9f0d5aa4f8896d10$export$dbbd5617eb71f0d));
    const { siteId: siteId, orgId: orgId, productKey: productKey, experienceId: experienceId, profileData: t0, renderingTouchpoint: renderingTouchpoint } = (0, $eKjv9.useGlobalConfig)();
    const { aaid: aaid } = t0;
    const { isContentPreviewSupported: isContentPreviewSupported, browserContextSanitizer: browserContextSanitizer } = (0, $dSCNl.useUIConfig)();
    let t1;
    if ($[0] !== props.messageId || $[1] !== props.recipientAgentNamedId) {
        t1 = {
            recipientAgentNamedId: props.recipientAgentNamedId,
            messageId: props.messageId
        };
        $[0] = props.messageId;
        $[1] = props.recipientAgentNamedId;
        $[2] = t1;
    } else t1 = $[2];
    const messageActionsAnalytics = (0, $0b54e2a16a4f5628$export$29313ff2bda62c4f)(t1);
    const { sendMessageConfirmedTools: sendMessageConfirmedTools, bulkResolveConversationUIActions: bulkResolveConversationUIActions } = (0, $3TxKn.useChatStoreActions)();
    const { getChatMode: getChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { preferences: t2 } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages } = t2;
    const { messageIdSelectedForPreview: messageIdSelectedForPreview, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const hasStagedContent = messageIdSelectedForPreview !== null || invocationIdSelectedForPreview !== null;
    const t3 = props.conversationId ?? "";
    let t4;
    if ($[3] !== getChatMode || $[4] !== t3) {
        t4 = getChatMode(t3);
        $[3] = getChatMode;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const taskModeEnabled = t4.taskModeEnabled;
    let t5;
    if ($[6] !== browserContextSanitizer || $[7] !== getChatMode || $[8] !== hasStagedContent || $[9] !== productKey || $[10] !== props.conversationId || $[11] !== sendMessageConfirmedTools || $[12] !== storeUserMessages) {
        t5 = (params)=>{
            const chatMode = getChatMode(props.conversationId ?? "");
            return sendMessageConfirmedTools({
                ...params,
                storeUserMessages: storeUserMessages,
                webSearchEnabled: chatMode.webSearchEnabled,
                deepResearchEnabled: chatMode.deepResearchEnabled,
                thinkDeeperEnabled: chatMode.thinkDeeperEnabled,
                alphaExtendedThinkingMode: chatMode.alphaExtendedThinkingMode,
                fastModeEnabled: chatMode.fastModeEnabled,
                taskModeEnabled: chatMode.taskModeEnabled,
                productKey: productKey,
                addCurrentPageAsContextUserPreference: chatMode.useCurrentPageContext,
                browserContextSanitizer: browserContextSanitizer,
                hasStagedContent: hasStagedContent
            });
        };
        $[6] = browserContextSanitizer;
        $[7] = getChatMode;
        $[8] = hasStagedContent;
        $[9] = productKey;
        $[10] = props.conversationId;
        $[11] = sendMessageConfirmedTools;
        $[12] = storeUserMessages;
        $[13] = t5;
    } else t5 = $[13];
    const sendMessageConfirmedToolsWithModes = t5;
    let t6;
    if ($[14] !== bulkResolveConversationUIActions || $[15] !== props.conversationId || $[16] !== props.messageId) {
        t6 = (actionKey, actionResolution, invocationIds, invocationIdToCreatedIssueKey)=>{
            bulkResolveConversationUIActions({
                conversationId: props.conversationId ?? "",
                messageId: props.messageId,
                payloads: invocationIds.map((invocationId)=>({
                        context: {
                            key: actionKey,
                            invocationId: invocationId,
                            messageId: props.messageId,
                            data: {
                                ...invocationIdToCreatedIssueKey ? {
                                    createdIssueKey: invocationIdToCreatedIssueKey[invocationId]
                                } : {}
                            },
                            resolution: {
                                type: actionResolution
                            }
                        }
                    })),
                skipSuccessOptimisticAssistantResponse: true
            });
        };
        $[14] = bulkResolveConversationUIActions;
        $[15] = props.conversationId;
        $[16] = props.messageId;
        $[17] = t6;
    } else t6 = $[17];
    const resolveActionsBulk = t6;
    const t7 = isContentPreviewSupported ?? false;
    let t8;
    if ($[18] !== aaid || $[19] !== experienceId || $[20] !== messageActionsAnalytics || $[21] !== orgId || $[22] !== productKey || $[23] !== props || $[24] !== renderingTouchpoint || $[25] !== resolveActionsBulk || $[26] !== sendMessageConfirmedToolsWithModes || $[27] !== siteId || $[28] !== t7 || $[29] !== taskModeEnabled) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f0d5aa4f8896d10$export$dbbd5617eb71f0d), {
            ...props,
            cloudId: siteId,
            orgId: orgId,
            aaid: aaid,
            productKey: productKey,
            experienceId: experienceId,
            renderingTouchpoint: renderingTouchpoint,
            isContentPreviewSupported: t7,
            messageActionsAnalytics: messageActionsAnalytics,
            sendMessageConfirmedTools: sendMessageConfirmedToolsWithModes,
            resolveActionsBulk: resolveActionsBulk,
            taskModeEnabled: taskModeEnabled
        });
        $[18] = aaid;
        $[19] = experienceId;
        $[20] = messageActionsAnalytics;
        $[21] = orgId;
        $[22] = productKey;
        $[23] = props;
        $[24] = renderingTouchpoint;
        $[25] = resolveActionsBulk;
        $[26] = sendMessageConfirmedToolsWithModes;
        $[27] = siteId;
        $[28] = t7;
        $[29] = taskModeEnabled;
        $[30] = t8;
    } else t8 = $[30];
    return t8;
} : (props)=>{
    (0, $6cFsl.di)((0, $9f0d5aa4f8896d10$export$dbbd5617eb71f0d));
    const { siteId: siteId, orgId: orgId, productKey: productKey, experienceId: experienceId, profileData: { aaid: aaid }, renderingTouchpoint: renderingTouchpoint } = (0, $eKjv9.useGlobalConfig)();
    const { isContentPreviewSupported: isContentPreviewSupported, browserContextSanitizer: browserContextSanitizer } = (0, $dSCNl.useUIConfig)();
    const messageActionsAnalytics = (0, $0b54e2a16a4f5628$export$29313ff2bda62c4f)({
        recipientAgentNamedId: props.recipientAgentNamedId,
        messageId: props.messageId
    });
    const { sendMessageConfirmedTools: sendMessageConfirmedTools, bulkResolveConversationUIActions: bulkResolveConversationUIActions } = (0, $3TxKn.useChatStoreActions)();
    const { getChatMode: getChatMode } = (0, $aJU2k.useChatModeStoreActions)();
    const { preferences: { storeUserMessages: storeUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const { messageIdSelectedForPreview: messageIdSelectedForPreview, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    // A previewed draft can be tracked by either signal, so both must count as staged
    // content. The invocation-id path is used when the staging area is opened from a Rovo
    // chat preview card (e.g. Atlassian Home inline mode), where messageIdSelectedForPreview
    // stays null even though a draft is being previewed.
    const hasStagedContent = messageIdSelectedForPreview !== null || invocationIdSelectedForPreview !== null;
    // Snapshot the task-mode state at render time so renderers (e.g.
    // AskQuestionRenderer) can record whether Max mode was active when the
    // message that produced their action card was sent.
    const taskModeEnabled = getChatMode(props.conversationId ?? '').taskModeEnabled;
    const sendMessageConfirmedToolsWithModes = (0, $cozmU.useMemo)(()=>{
        return (params)=>{
            const chatMode = getChatMode(props.conversationId ?? '');
            return sendMessageConfirmedTools({
                ...params,
                storeUserMessages: // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                storeUserMessages,
                webSearchEnabled: chatMode.webSearchEnabled,
                deepResearchEnabled: chatMode.deepResearchEnabled,
                thinkDeeperEnabled: chatMode.thinkDeeperEnabled,
                alphaExtendedThinkingMode: chatMode.alphaExtendedThinkingMode,
                fastModeEnabled: chatMode.fastModeEnabled,
                taskModeEnabled: chatMode.taskModeEnabled,
                productKey: // Context-driving params used (behind the
                // `rovo-include-full-context-on-confirmed-tools` experiment) by the store action to
                // build the same full request context that `sendMessage` sends. Sourced the same way
                // the chat input sources them so tool confirmation matches a regular follow-up send.
                productKey,
                addCurrentPageAsContextUserPreference: chatMode.useCurrentPageContext,
                browserContextSanitizer: browserContextSanitizer,
                hasStagedContent: hasStagedContent
            });
        };
    }, [
        sendMessageConfirmedTools,
        getChatMode,
        props.conversationId,
        storeUserMessages,
        productKey,
        browserContextSanitizer,
        hasStagedContent
    ]);
    // Resolves multiple UI actions in a single request (POST `/tools/resolution`) instead
    // of one `/action` call per invocation. Mirrors the payload shape used by
    // `MessageStreamActions`.
    const resolveActionsBulk = (0, $cozmU.useMemo)(()=>(actionKey, actionResolution, invocationIds, invocationIdToCreatedIssueKey)=>{
            bulkResolveConversationUIActions({
                conversationId: props.conversationId ?? '',
                messageId: props.messageId,
                payloads: invocationIds.map((invocationId)=>({
                        context: {
                            key: actionKey,
                            invocationId: invocationId,
                            messageId: props.messageId,
                            data: {
                                ...invocationIdToCreatedIssueKey ? {
                                    createdIssueKey: invocationIdToCreatedIssueKey[invocationId]
                                } : {}
                            },
                            resolution: {
                                type: actionResolution
                            }
                        }
                    })),
                skipSuccessOptimisticAssistantResponse: true
            });
        }, [
        bulkResolveConversationUIActions,
        props.conversationId,
        props.messageId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f0d5aa4f8896d10$export$dbbd5617eb71f0d), {
        ...props,
        cloudId: siteId,
        orgId: orgId,
        aaid: aaid,
        productKey: productKey,
        experienceId: experienceId,
        renderingTouchpoint: renderingTouchpoint,
        isContentPreviewSupported: isContentPreviewSupported ?? false,
        messageActionsAnalytics: messageActionsAnalytics,
        sendMessageConfirmedTools: sendMessageConfirmedToolsWithModes,
        resolveActionsBulk: resolveActionsBulk,
        taskModeEnabled: taskModeEnabled
    });
};




































var $eTCWv = parcelRequire("eTCWv");


var $aYC8J = parcelRequire("aYC8J");














var $hekY6 = parcelRequire("hekY6");










parcelRequire("g23UR");
var $kkLpw = parcelRequire("kkLpw");




var $eKMV3 = parcelRequire("eKMV3");


var $w6R6I = parcelRequire("w6R6I");





var $itpo2 = parcelRequire("itpo2");


var $cJ0FD = parcelRequire("cJ0FD");














var $hdBxM = parcelRequire("hdBxM");


var $dTEBe = parcelRequire("dTEBe");







async function $6a695435168b8b7b$export$98d1485e4ee43fe8(imageUrl) {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    await navigator.clipboard.write([
        new ClipboardItem({
            [blob.type]: blob
        })
    ]);
}









var $7cQjw = parcelRequire("7cQjw");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $iuCeV = parcelRequire("iuCeV");


var $iW40i = parcelRequire("iW40i");


var $63fke = parcelRequire("63fke");





var $cKMeF = parcelRequire("cKMeF");


var $6ASE9 = parcelRequire("6ASE9");


var $3FVEI = parcelRequire("3FVEI");


var $c7So7 = parcelRequire("c7So7");

var $5210a2d057f0b249$exports = {};
$5210a2d057f0b249$exports = new URL("preview-card-dashboard-header.228fc67e.svg", import.meta.url).toString();


var $4c8ab5fd7f919bc1$exports = {};
$4c8ab5fd7f919bc1$exports = new URL("preview-card-database-header.8549ac7f.svg", import.meta.url).toString();


var $8f284aedc91174f0$exports = {};
$8f284aedc91174f0$exports = new URL("preview-card-page-header.8639e9c6.svg", import.meta.url).toString();


var $731a82ecb9597e7d$exports = {};
$731a82ecb9597e7d$exports = new URL("preview-card-slides-header.a6094606.svg", import.meta.url).toString();


var $0cf82dfbe954dfb2$exports = {};
$0cf82dfbe954dfb2$exports = new URL("preview-card-whiteboard-header.a8b554de.svg", import.meta.url).toString();
















const $232254bb368cae82$var$ConfluenceLogoSvg = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.9252 9.64097C9.23277 8.33909 8.44622 8.14455 7.31176 8.14455C5.98067 8.14455 4.84622 8.69823 3.83277 10.2545L3.66639 10.5089C3.53025 10.7184 3.5 10.7932 3.5 10.883C3.5 10.9728 3.54538 11.0476 3.71176 11.1523L5.42101 12.2148C5.51176 12.2747 5.58739 12.3046 5.66303 12.3046C5.75378 12.3046 5.81429 12.2597 5.90504 12.125L6.17731 11.706C6.60084 11.0626 6.97899 10.8531 7.46303 10.8531C7.88655 10.8531 8.38571 10.9728 9.00588 11.2721L10.7908 12.1101C10.9723 12.1998 11.1689 12.1549 11.2597 11.9455L12.1067 10.0899C12.1975 9.8804 12.137 9.74572 11.9252 9.64097ZM4.07479 6.36382C6.76723 7.6657 7.55378 7.86023 8.68824 7.86023C10.0193 7.86023 11.1538 7.30656 12.1672 5.75029L12.3336 5.4959C12.4697 5.2864 12.5 5.21158 12.5 5.12179C12.5 5.03201 12.4546 4.95719 12.2882 4.85244L10.579 3.78998C10.4882 3.73012 10.4126 3.7002 10.337 3.7002C10.2462 3.7002 10.1857 3.74509 10.095 3.87977L9.82269 4.29876C9.39916 4.94222 9.02101 5.15172 8.53697 5.15172C8.11345 5.15172 7.61429 5.03201 6.99412 4.73272L5.20924 3.89473C5.02773 3.80494 4.83109 3.84984 4.74034 4.05934L3.89328 5.91489C3.80252 6.12439 3.86303 6.25907 4.07479 6.36382Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.9252 9.64097C9.23277 8.33909 8.44622 8.14455 7.31176 8.14455C5.98067 8.14455 4.84622 8.69823 3.83277 10.2545L3.66639 10.5089C3.53025 10.7184 3.5 10.7932 3.5 10.883C3.5 10.9728 3.54538 11.0476 3.71176 11.1523L5.42101 12.2148C5.51176 12.2747 5.58739 12.3046 5.66303 12.3046C5.75378 12.3046 5.81429 12.2597 5.90504 12.125L6.17731 11.706C6.60084 11.0626 6.97899 10.8531 7.46303 10.8531C7.88655 10.8531 8.38571 10.9728 9.00588 11.2721L10.7908 12.1101C10.9723 12.1998 11.1689 12.1549 11.2597 11.9455L12.1067 10.0899C12.1975 9.8804 12.137 9.74572 11.9252 9.64097ZM4.07479 6.36382C6.76723 7.6657 7.55378 7.86023 8.68824 7.86023C10.0193 7.86023 11.1538 7.30656 12.1672 5.75029L12.3336 5.4959C12.4697 5.2864 12.5 5.21158 12.5 5.12179C12.5 5.03201 12.4546 4.95719 12.2882 4.85244L10.579 3.78998C10.4882 3.73012 10.4126 3.7002 10.337 3.7002C10.2462 3.7002 10.1857 3.74509 10.095 3.87977L9.82269 4.29876C9.39916 4.94222 9.02101 5.15172 8.53697 5.15172C8.11345 5.15172 7.61429 5.03201 6.99412 4.73272L5.20924 3.89473C5.02773 3.80494 4.83109 3.84984 4.74034 4.05934L3.89328 5.91489C3.80252 6.12439 3.86303 6.25907 4.07479 6.36382Z",
        fill: "white"
    }));
const $232254bb368cae82$export$1b2e4fe6ef471556 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($232254bb368cae82$var$ConfluenceLogoSvg, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "Confluence"));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($232254bb368cae82$var$ConfluenceLogoSvg, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "Confluence"));
const $232254bb368cae82$export$17a31cb161404daa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 5C0 2.23858 2.23858 0 5 0H15C17.7614 0 20 2.23858 20 5V15C20 17.7614 17.7614 20 15 20H5C2.23858 20 0 17.7614 0 15V5Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M7.47814 12.9363H6.35122C4.6516 12.9363 3.43231 11.8953 3.43231 10.3709H9.49182C9.80588 10.3709 10.0091 10.594 10.0091 10.91V17.0075C8.49421 17.0075 7.47814 15.7806 7.47814 14.0703V12.9363ZM10.4709 9.90617H9.34402C7.64441 9.90617 6.42512 8.88371 6.42512 7.35933H12.4846C12.7987 7.35933 13.0204 7.56382 13.0204 7.87985V13.9774C11.5055 13.9774 10.4709 12.7504 10.4709 11.0402V9.90617ZM13.4822 6.89458H12.3553C10.6557 6.89458 9.43639 5.85354 9.43639 4.32916H15.4959C15.81 4.32916 16.0132 4.55224 16.0132 4.84968V10.9472C14.4983 10.9472 13.4822 9.72027 13.4822 8.00998V6.89458Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 5C0 2.23858 2.23858 0 5 0H15C17.7614 0 20 2.23858 20 5V15C20 17.7614 17.7614 20 15 20H5C2.23858 20 0 17.7614 0 15V5Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.47814 12.9363H6.35122C4.6516 12.9363 3.43231 11.8953 3.43231 10.3709H9.49182C9.80588 10.3709 10.0091 10.594 10.0091 10.91V17.0075C8.49421 17.0075 7.47814 15.7806 7.47814 14.0703V12.9363ZM10.4709 9.90617H9.34402C7.64441 9.90617 6.42512 8.88371 6.42512 7.35933H12.4846C12.7987 7.35933 13.0204 7.56382 13.0204 7.87985V13.9774C11.5055 13.9774 10.4709 12.7504 10.4709 11.0402V9.90617ZM13.4822 6.89458H12.3553C10.6557 6.89458 9.43639 5.85354 9.43639 4.32916H15.4959C15.81 4.32916 16.0132 4.55224 16.0132 4.84968V10.9472C14.4983 10.9472 13.4822 9.72027 13.4822 8.00998V6.89458Z",
        fill: "white"
    }));



var $jKT15 = parcelRequire("jKT15");










/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $arQY7 = parcelRequire("arQY7");









var $gR27Z = parcelRequire("gR27Z");

var $jOmQq = parcelRequire("jOmQq");


var $fBeNh = parcelRequire("fBeNh");




const $9f30f3eb14bcf82e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    updatedText: {
        id: "conversation-assistant-ui-components.updated-text",
        defaultMessage: "Updated {timeAgo}"
    }
});


const $6672bf79900bb35c$var$styles = {
    avatar: "_1Znuxb5zaO"
};
const $6672bf79900bb35c$export$bc21ad6ac51b9f43 = ({ publishedContentData: publishedContentData, emojiProvider: emojiProvider, cloudId: cloudId })=>{
    const { contributors: contributors, reactions: reactions, lastUpdated: lastUpdated } = publishedContentData;
    const [cloudUrl, setCloudUrl] = (0, $cozmU.useState)('');
    const normalizedReactions = reactions?.reactionsSummaryForEmoji?.map((reaction)=>({
            emojiId: reaction.emojiId,
            count: reaction.count,
            ari: reactions.ari,
            containerAri: reactions.containerAri,
            reacted: reaction.reacted
        })) || [];
    const lastUpdatedText = lastUpdated === 'A moment ago' ? 'a moment ago' : lastUpdated;
    (0, $cozmU.useEffect)(()=>{
        const getCloudUrl = async ()=>{
            try {
                const data = await (0, $fBeNh.getCloudUrlFromId)(cloudId);
                setCloudUrl(data?.cloudUrl ?? '');
            } catch (error) {}
        };
        getCloudUrl();
    }, [
        cloudId
    ]);
    const contributorsSrc = `${cloudUrl}${contributors?.[0]?.profilePicture?.path}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        maxLines: 3
    }, publishedContentData?.excerpt?.trim() ?? ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6672bf79900bb35c$var$styles.avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "circle",
        size: "xxsmall",
        src: contributorsSrc
    })), emojiProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gR27Z.Reactions), {
        reactions: normalizedReactions,
        status: (0, $jOmQq.ReactionStatus).ready,
        loadReaction: ()=>{},
        onSelection: ()=>{},
        onReactionClick: ()=>{},
        emojiProvider: emojiProvider,
        allowAllEmojis: true,
        quickReactionEmojis: undefined,
        summaryViewEnabled: true,
        summaryViewPlacement: "bottom-start",
        subtleReactionsSummaryAndPicker: true,
        isViewOnly: true
    }), lastUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $9f30f3eb14bcf82e$export$defe85febe8b728c).updatedText,
        values: {
            timeAgo: lastUpdatedText
        }
    }))));
};


const $a0d3180f633dfca4$export$cc11f0bd89960b80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { publishedContentData: publishedContentData, emojiProvider: emojiProvider, product: product, cloudId: cloudId } = t0;
    if (!publishedContentData) return null;
    if (product === "confluence") {
        let t1;
        if ($[0] !== cloudId || $[1] !== emojiProvider || $[2] !== publishedContentData) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6672bf79900bb35c$export$bc21ad6ac51b9f43), {
                publishedContentData: publishedContentData,
                emojiProvider: emojiProvider,
                cloudId: cloudId
            }));
            $[0] = cloudId;
            $[1] = emojiProvider;
            $[2] = publishedContentData;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    return null;
} : ({ publishedContentData: publishedContentData, emojiProvider: emojiProvider, product: product, cloudId: cloudId })=>{
    if (!publishedContentData) return null;
    if (product === 'confluence') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6672bf79900bb35c$export$bc21ad6ac51b9f43), {
        publishedContentData: publishedContentData,
        emojiProvider: emojiProvider,
        cloudId: cloudId
    }));
    return null;
};















var $6sD11 = parcelRequire("6sD11");




const $b5a02b2851cabbfe$var$tooltipInlineStyles = {
    bottom: '100%',
    left: '50%'
};
const $b5a02b2851cabbfe$var$wrapperStyles = null;
const $b5a02b2851cabbfe$var$tooltipPositionStyles = null;
const $b5a02b2851cabbfe$export$f3a4757df143458e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { children: children, content: content, isVisible: isVisible, onDismiss: onDismiss, dismissAfter: t1, dismissKey: dismissKey, testId: testId } = t0;
    const dismissAfter = t1 === undefined ? 1000 : t1;
    let t2;
    if ($[0] !== dismissAfter || $[1] !== isVisible || $[2] !== onDismiss) {
        t2 = ()=>{
            if (!isVisible) return;
            const timeoutId = window.setTimeout(onDismiss, dismissAfter);
            return ()=>window.clearTimeout(timeoutId);
        };
        $[0] = dismissAfter;
        $[1] = isVisible;
        $[2] = onDismiss;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== dismissAfter || $[5] !== dismissKey || $[6] !== isVisible || $[7] !== onDismiss) {
        t3 = [
            dismissAfter,
            dismissKey,
            isVisible,
            onDismiss
        ];
        $[4] = dismissAfter;
        $[5] = dismissKey;
        $[6] = isVisible;
        $[7] = onDismiss;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbccYA"
        ]);
        $[9] = t4;
    } else t4 = $[9];
    const t5 = isVisible && content;
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            role: "status",
            "aria-live": "assertive",
            "aria-atomic": "true"
        }, t5);
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== content || $[13] !== isVisible || $[14] !== testId) {
        t7 = isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: $b5a02b2851cabbfe$var$tooltipInlineStyles,
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _1DCdHi1Y8M _1VJPcajssS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6sD11.default), {
            placement: "top",
            testId: testId
        }, content));
        $[12] = content;
        $[13] = isVisible;
        $[14] = testId;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== children || $[17] !== t6 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t4
        }, t6, children, t7);
        $[16] = children;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ children: children, content: content, isVisible: isVisible, onDismiss: onDismiss, dismissAfter: dismissAfter = 1000, dismissKey: dismissKey, testId: testId })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!isVisible) return;
        const timeoutId = window.setTimeout(onDismiss, dismissAfter);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        dismissAfter,
        dismissKey,
        isVisible,
        onDismiss
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbccYA"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isVisible && content), children, isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: $b5a02b2851cabbfe$var$tooltipInlineStyles,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _1DCdHi1Y8M _1VJPcajssS"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6sD11.default), {
        placement: "top",
        testId: testId
    }, content)));
};















var $iF7Yl = parcelRequire("iF7Yl");

const $b71ee36f98a61401$var$isStaging = ()=>{
    return window.location.hostname.includes('jira-dev.com');
};
const $b71ee36f98a61401$export$6ac24dc114456b7d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (fileId, clientId, t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const product = t0 === undefined ? "confluence" : t0;
    const [imageUrl, setImageUrl] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== clientId || $[1] !== fileId || $[2] !== product) {
        t1 = async ()=>{
            if (!fileId || !clientId) return;
            const { token: token, collection: collection } = await (0, $iF7Yl.fetchMauiPersonalReadToken)(product, clientId);
            const url = (0, $aYC8J.buildImageUrl)({
                fileId: fileId,
                token: token.split("Bearer ")[1],
                collection: collection,
                clientId: clientId,
                isStaging: $b71ee36f98a61401$var$isStaging()
            });
            setImageUrl(url);
        };
        $[0] = clientId;
        $[1] = fileId;
        $[2] = product;
        $[3] = t1;
    } else t1 = $[3];
    const buildUrl = t1;
    let t2;
    let t3;
    if ($[4] !== buildUrl || $[5] !== clientId || $[6] !== fileId) {
        t2 = ()=>{
            if (!fileId || !clientId) {
                setImageUrl(null);
                return;
            }
            buildUrl();
        };
        t3 = [
            buildUrl,
            fileId,
            clientId
        ];
        $[4] = buildUrl;
        $[5] = clientId;
        $[6] = fileId;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return imageUrl;
} : (fileId, clientId, product = 'confluence')=>{
    const [imageUrl, setImageUrl] = (0, $cozmU.useState)(null);
    const buildUrl = (0, $cozmU.useCallback)(async ()=>{
        if (!fileId || !clientId) return;
        const { token: token, collection: collection } = await (0, $iF7Yl.fetchMauiPersonalReadToken)(product, clientId);
        const url = (0, $aYC8J.buildImageUrl)({
            fileId: fileId,
            token: token.split('Bearer ')[1],
            collection: collection,
            clientId: clientId,
            isStaging: $b71ee36f98a61401$var$isStaging()
        });
        setImageUrl(url);
    }, [
        fileId,
        clientId,
        product
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!fileId || !clientId) {
            setImageUrl(null);
            return;
        }
        buildUrl();
    }, [
        buildUrl,
        fileId,
        clientId
    ]);
    return imageUrl;
};


















var $24dy7 = parcelRequire("24dy7");











var $7ChxK = parcelRequire("7ChxK");

const $b2535348f76828a4$var$messages = (0, $kSwu1.defineMessages)({
    defaultErrorMessage: {
        defaultMessage: "Rovo couldn't create your work items. Refresh the page, or try again with a different prompt.",
        id: "jiraCreateErrorBoundaryFallback.heading"
    },
    refreshButton: {
        defaultMessage: "Refresh page",
        id: "jiraCreateErrorBoundaryFallback.refreshButton"
    }
});
const $b2535348f76828a4$var$styles = {
    container: "_43nrzT8HPE",
    iconContainer: "_43nrzTFQfX",
    buttonWrapper: "_4xdlr07p2s"
};
const $b2535348f76828a4$export$2ed946042a0386d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { error: error, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== sendAifcAnalyticsEvent) {
        t1 = ()=>{
            if (!hasFiredViewEvent.current) {
                hasFiredViewEvent.current = true;
                sendAifcAnalyticsEvent?.({
                    action: "rendered",
                    actionSubject: "component",
                    actionSubjectId: "createWorkItemsFallback",
                    attributes: {
                        reason: (0, $7ChxK.getJiraCreateErrorReason)(error),
                        errorName: error?.name
                    }
                });
            }
        };
        t2 = [
            sendAifcAnalyticsEvent,
            error
        ];
        $[0] = error;
        $[1] = sendAifcAnalyticsEvent;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const handleRefresh = $b2535348f76828a4$var$_temp;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b2535348f76828a4$var$styles.iconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }));
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage($b2535348f76828a4$var$messages.defaultErrorMessage);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "start",
            xcss: $b2535348f76828a4$var$styles.container
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t4));
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage($b2535348f76828a4$var$messages.refreshButton);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b2535348f76828a4$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleRefresh
        }, t6));
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t5 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t5, t7);
        $[13] = t5;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ error: error, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasFiredViewEvent.current) {
            hasFiredViewEvent.current = true;
            sendAifcAnalyticsEvent?.({
                action: 'rendered',
                actionSubject: 'component',
                actionSubjectId: 'createWorkItemsFallback',
                attributes: {
                    reason: (0, $7ChxK.getJiraCreateErrorReason)(error),
                    errorName: error?.name
                }
            });
        }
    }, [
        sendAifcAnalyticsEvent,
        error
    ]);
    const handleRefresh = ()=>{
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "start",
        xcss: $b2535348f76828a4$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b2535348f76828a4$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($b2535348f76828a4$var$messages.defaultErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b2535348f76828a4$var$styles.buttonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleRefresh
    }, formatMessage($b2535348f76828a4$var$messages.refreshButton))));
};
function $b2535348f76828a4$var$_temp() {
    window.location.reload();
}



var $gHaaj = parcelRequire("gHaaj");







/**
 * @generated SignedSource<<c9e46fd7edca3cbaca1804b3316844a3>>
 * @relayHash 88a23f693ebfb6da998041b597b06f7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d76d062021f4bb002a0a90aa0b12005fcfc45752fec4c2a15f663984d3495507
const $e1f5b812e5bdd650$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JsmCreateSurveyCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JsmCreateSurveyCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d76d062021f4bb002a0a90aa0b12005fcfc45752fec4c2a15f663984d3495507",
            "metadata": {},
            "name": "JsmCreateSurveyCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e1f5b812e5bdd650$var$node.hash = "30abedfede30b57d73b77ef4e59048bd";
var $e1f5b812e5bdd650$export$2e2bcd8739ae039 = $e1f5b812e5bdd650$var$node;









var $6SsN4 = parcelRequire("6SsN4");




var $1sCHt = parcelRequire("1sCHt");




var $4MnFz = parcelRequire("4MnFz");


var $I7hWB = parcelRequire("I7hWB");


var $2WCju = parcelRequire("2WCju");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");























var $eKUiY = parcelRequire("eKUiY");


var $aZB6I = parcelRequire("aZB6I");













const $8a849cbfd2239f6f$var$styles = {
    container: "_2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $8a849cbfd2239f6f$export$65e001b1c0481f66 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8a849cbfd2239f6f$var$styles.container,
            alignInline: "end",
            alignBlock: "center",
            space: "space.100"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $8a849cbfd2239f6f$var$styles.container,
        alignInline: "end",
        alignBlock: "center",
        space: "space.100"
    }, children);






















var $hBYtq = parcelRequire("hBYtq");





/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $a79Sy = parcelRequire("a79Sy");














var $1VhsF = parcelRequire("1VhsF");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $kB5K2 = parcelRequire("kB5K2");

var $hpa99 = parcelRequire("hpa99");




const $045a3fbc80f03e84$export$6969d4f1ac425436 = ({ label: label, name: name, isRequired: isRequired, options: options })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: name
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, options.map((option)=>/*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
            key: option.value,
            name: name,
            value: option.value,
            label: option.label,
            isRequired: isRequired
        }))));


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $6wGOF = parcelRequire("6wGOF");

const $ff471ff456ca3bb8$export$5a8f20dde0180f76 = ({ label: label, name: name, id: id, isRequired: isRequired, options: options })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: id
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        name: name,
        inputId: id,
        isRequired: isRequired,
        options: options,
        isMulti: true
    }));


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $1hHRQ = parcelRequire("1hHRQ");

const $09c5eacc206ad232$export$ba976889aca15156 = ({ label: label, name: name, isRequired: isRequired, options: options })=>{
    const labelId = (0, $cozmU.useId)();
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        id: labelId,
        htmlFor: name
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $1hHRQ.default), {
        name: name,
        options: options,
        isRequired: isRequired,
        labelId: labelId
    }));
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");











var $4ikjJ = parcelRequire("4ikjJ");




const $d7f316a92acffd56$var$DEFAULT_RATING_OPTIONS = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10'
];
const $d7f316a92acffd56$var$getSafeId = (value)=>value.replace(/[^A-Za-z0-9_-]/g, '-');
const $d7f316a92acffd56$var$styles = {
    container: "_4bt5LAIZbP _3CkH9otZyR _1DJ2rV14ZJ _2z4m57UZDI _3OqcjTgjg6 _1L04cOhIU2",
    options: "_0Of8r22ADO _1wydGW2ADO"
};
const $d7f316a92acffd56$export$b3046cc716629a68 = ({ label: label, name: name, id: id, isRequired: isRequired, options: options = [] })=>{
    const ratingOptions = options.length > 0 ? options : $d7f316a92acffd56$var$DEFAULT_RATING_OPTIONS;
    const fieldId = $d7f316a92acffd56$var$getSafeId(id);
    const labelId = `${fieldId}-label`;
    const [selected, setSelected] = (0, $cozmU.useState)(0);
    const [hovered, setHovered] = (0, $cozmU.useState)(0);
    const activeRating = hovered || selected;
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        id: labelId,
        htmlFor: fieldId
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        id: fieldId,
        xcss: $d7f316a92acffd56$var$styles.container,
        testId: "survey-builder-rating-input",
        role: "radiogroup",
        "aria-labelledby": labelId,
        "aria-required": isRequired,
        onMouseLeave: ()=>setHovered(0)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7f316a92acffd56$var$styles.options
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.400"
    }, ratingOptions.map((option, index)=>{
        const ratingValue = index + 1;
        const position = String(ratingValue);
        const inputId = `${fieldId}-${$d7f316a92acffd56$var$getSafeId(position)}`;
        const isFilled = ratingValue <= activeRating;
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            key: inputId,
            alignInline: "center",
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4ikjJ.default), {
            id: inputId,
            value: position,
            label: position,
            name: name,
            isRequired: isRequired,
            isChecked: selected === ratingValue,
            onChange: ()=>setSelected(ratingValue)
        })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps)=>isFilled ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                    ...iconProps,
                    color: "var(--ds-icon-selected, #1868DB)"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                    ...iconProps,
                    color: "var(--ds-icon-subtle, #505258)"
                }),
            label: position,
            onClick: ()=>setSelected(ratingValue),
            onMouseEnter: ()=>setHovered(ratingValue),
            "aria-hidden": true,
            tabIndex: -1,
            testId: `survey-builder-rating-input-option-button-${position}`
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            align: "center"
        }, position));
    })))));
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 























const $3d25495ea34fd3ea$var$DEFAULT_SCALE_OPTIONS = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10'
];
const $3d25495ea34fd3ea$var$getSafeId = (value)=>value.replace(/[^A-Za-z0-9_-]/g, '-');
const $3d25495ea34fd3ea$var$styles = {
    container: "_4bt5LAIZbP _3CkH9otZyR _1DJ2rV14ZJ _2z4m57UZDI _3OqcjTgjg6 _1L04cOhIU2",
    options: "_39xV02E6Kk _4ouGXIN91d _0Of8r22ADO _1wydGW2ADO",
    buttonWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $3d25495ea34fd3ea$export$3a0fc0157d92d075 = ({ label: label, name: name, id: id, isRequired: isRequired, options: options = [] })=>{
    const scaleOptions = options.length > 0 ? options : $3d25495ea34fd3ea$var$DEFAULT_SCALE_OPTIONS;
    const fieldId = $3d25495ea34fd3ea$var$getSafeId(id);
    const labelId = `${fieldId}-label`;
    const [selected, setSelected] = (0, $cozmU.useState)(null);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        id: labelId,
        htmlFor: fieldId
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        id: fieldId,
        xcss: $3d25495ea34fd3ea$var$styles.container,
        testId: "survey-builder-scale-input",
        role: "radiogroup",
        "aria-labelledby": labelId,
        "aria-required": isRequired
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $3d25495ea34fd3ea$var$styles.options
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.200"
    }, scaleOptions.map((option, index)=>{
        const position = String(index + 1);
        const inputId = `${fieldId}-${$3d25495ea34fd3ea$var$getSafeId(position)}`;
        const isChecked = selected === position;
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: inputId,
            xcss: $3d25495ea34fd3ea$var$styles.buttonWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4ikjJ.default), {
            id: inputId,
            value: position,
            label: position,
            name: name,
            isRequired: isRequired,
            isChecked: isChecked,
            onChange: ()=>setSelected(position)
        })), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            shouldFitContainer: true,
            isSelected: isChecked,
            onClick: ()=>setSelected(position),
            "aria-hidden": true,
            tabIndex: -1,
            testId: `survey-builder-scale-input-option-${position}`
        }, position));
    })))));
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 













const $7663022f07ae38a8$export$d6701e98ab1a6725 = ({ label: label, name: name, id: id, isRequired: isRequired, options: options })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: id
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        name: name,
        inputId: id,
        isRequired: isRequired,
        options: options
    }));


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $4yg9g = parcelRequire("4yg9g");

const $8c62462b2511381d$export$c86715117507e8e5 = ({ label: label, name: name, id: id, isRequired: isRequired })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: id
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        name: name,
        id: id,
        isRequired: isRequired,
        readOnly: true
    }));


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 













const $9241c3074a370467$export$9a5caaaacb4c92d3 = ({ label: label, name: name, id: id, isRequired: isRequired })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: id
    }, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $e3Wrf.default), {
        name: name,
        id: id,
        isRequired: isRequired,
        isReadOnly: true,
        minimumRows: 4,
        resize: "smart"
    }));


const $7855b8bef7d8d84a$var$styles = {
    container: "_2mHwu8NHnM _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM _1EqgXlpNyl",
    previewBanner: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO"
};
const $7855b8bef7d8d84a$var$previewMessage = (0, $kSwu1.defineMessage)({
    id: "survey-builder.preview-message.non-final",
    defaultMessage: "This is only a preview, you can't edit questions inline."
});
const $7855b8bef7d8d84a$var$previewMessageRedesign = (0, $kSwu1.defineMessage)({
    id: "survey-builder.preview-message-redesign.non-final",
    defaultMessage: "This is a preview. Create the survey or ask Rovo to make changes."
});
const $7855b8bef7d8d84a$var$unsupportedMessage = (0, $kSwu1.defineMessage)({
    id: "survey-builder.unsupported-message.non-final",
    defaultMessage: "This is an unsupported question type."
});
const $7855b8bef7d8d84a$var$renderQuestionField = ({ type: type, text: text, isRequired: isRequired, choices: choices = [] })=>{
    switch(type){
        case 'tl':
        case 'ts':
            return /*#__PURE__*/ $cozmU.createElement((0, $8c62462b2511381d$export$c86715117507e8e5), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired
            });
        case 'pg':
            return /*#__PURE__*/ $cozmU.createElement((0, $9241c3074a370467$export$9a5caaaacb4c92d3), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired
            });
        case 'cs':
            return /*#__PURE__*/ $cozmU.createElement((0, $09c5eacc206ad232$export$ba976889aca15156), {
                key: text,
                label: text,
                name: text,
                isRequired: isRequired,
                options: choices.map((choice)=>({
                        label: choice,
                        value: choice
                    }))
            });
        case 'cm':
            return /*#__PURE__*/ $cozmU.createElement((0, $045a3fbc80f03e84$export$6969d4f1ac425436), {
                key: text,
                label: text,
                name: text,
                isRequired: isRequired,
                options: choices.map((choice)=>({
                        label: choice,
                        value: choice
                    }))
            });
        case 'cl':
            return /*#__PURE__*/ $cozmU.createElement((0, $ff471ff456ca3bb8$export$5a8f20dde0180f76), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired,
                options: choices.map((choice)=>({
                        label: choice,
                        value: choice
                    }))
            });
        case 'cd':
            return /*#__PURE__*/ $cozmU.createElement((0, $7663022f07ae38a8$export$d6701e98ab1a6725), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired,
                options: choices.map((choice)=>({
                        label: choice,
                        value: choice
                    }))
            });
        case 'da':
        case 'dt':
        case 'no':
        case 'ti':
        case 'tu':
        case 'te':
            return /*#__PURE__*/ $cozmU.createElement((0, $8c62462b2511381d$export$c86715117507e8e5), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired
            });
        case 'rg':
            return /*#__PURE__*/ $cozmU.createElement((0, $d7f316a92acffd56$export$b3046cc716629a68), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired,
                options: choices
            });
        case 'sc':
            return /*#__PURE__*/ $cozmU.createElement((0, $3d25495ea34fd3ea$export$3a0fc0157d92d075), {
                key: text,
                label: text,
                name: text,
                id: text,
                isRequired: isRequired,
                options: choices
            });
        default:
            return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                key: text
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $7855b8bef7d8d84a$var$unsupportedMessage));
    }
};
const $7855b8bef7d8d84a$export$2d575e2c7db66ec0 = ({ title: title, description: description, questions: questions, isPreview: isPreview, testId: testId })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $7855b8bef7d8d84a$var$styles.container,
        testId: testId
    }, isPreview && ((0, $iDrrr.fg)('phx_survey_builder_preview_banner_redesign') ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.neutral",
        xcss: $7855b8bef7d8d84a$var$styles.previewBanner
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $7855b8bef7d8d84a$var$previewMessageRedesign)))) : /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
        appearance: "information"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), $7855b8bef7d8d84a$var$previewMessage))), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "medium"
    }, title), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, description)), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, questions.map(({ type: type, ...rest })=>$7855b8bef7d8d84a$var$renderQuestionField({
            type: type,
            ...rest
        }))));


const $0cf35f0338000ecd$var$styles = {
    container: "_1mT5xdRAKS",
    surveyWrapper: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHps5n",
    collapsed: "_0jFU0V9zBZ",
    expanded: "_0jFU0VIZbP",
    showMoreWrapper: "_37wbyuDIqT _1wydGWkG2W _1mT5xdRAKS",
    fade: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _1pp6NdYbGa _39xV02N91d _0jFU0V715P",
    showMore: "_0bjKvDS5Zs _3iDTPbQ4SZ _4kiQYAoWWg _0Of8r2dnbC _1wydGWdnbC _1Znuxb8HPE _2Zuz6Q8HPE _37wbyuDIqT _0hPCNLDIqT _0KLXrulfZc _2OUyjtGk8v _1eOmH6sumd _3gzVzLXsxn"
};
const $0cf35f0338000ecd$var$showMoreMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-show-more",
    defaultMessage: "Show more"
});
const $0cf35f0338000ecd$export$f2b0a76b0690f3fa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { selectedFormQuestions: t1 } = t0;
    const { title: title, description: description, questions: questions } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsExpanded($0cf35f0338000ecd$var$_temp);
        $[0] = t2;
    } else t2 = $[0];
    const handleToggle = t2;
    const t3 = isExpanded ? $0cf35f0338000ecd$var$styles.expanded : $0cf35f0338000ecd$var$styles.collapsed;
    let t4;
    if ($[1] !== t3) {
        t4 = (0, $w6R6I.cx)($0cf35f0338000ecd$var$styles.surveyWrapper, t3);
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== description || $[4] !== questions || $[5] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7855b8bef7d8d84a$export$2d575e2c7db66ec0), {
            title: title,
            description: description,
            questions: questions,
            testId: "conversation-assistant.jsm-create-survey-preview-card.survey-builder"
        });
        $[3] = description;
        $[4] = questions;
        $[5] = title;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t4 || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4
        }, t5);
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== formatMessage || $[11] !== isExpanded) {
        t7 = !isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0cf35f0338000ecd$var$styles.fade,
            "aria-hidden": "true",
            style: {
                background: "linear-gradient(to top, var(--ds-surface, #ffffff), transparent)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $0cf35f0338000ecd$var$styles.showMoreWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $0cf35f0338000ecd$var$styles.showMore,
            onClick: handleToggle,
            testId: "conversation-assistant.jsm-create-survey-preview-card.show-more-button",
            type: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small",
            weight: "medium"
        }, formatMessage($0cf35f0338000ecd$var$showMoreMessage)))));
        $[10] = formatMessage;
        $[11] = isExpanded;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t6 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $0cf35f0338000ecd$var$styles.container
        }, t6, t7);
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ selectedFormQuestions: { title: title, description: description, questions: questions } })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const handleToggle = ()=>setIsExpanded((prev)=>!prev);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $0cf35f0338000ecd$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0cf35f0338000ecd$var$styles.surveyWrapper, isExpanded ? $0cf35f0338000ecd$var$styles.expanded : $0cf35f0338000ecd$var$styles.collapsed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7855b8bef7d8d84a$export$2d575e2c7db66ec0), {
        title: title,
        description: description,
        questions: questions,
        testId: "conversation-assistant.jsm-create-survey-preview-card.survey-builder"
    })), !isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0cf35f0338000ecd$var$styles.fade,
        "aria-hidden": "true",
        style: {
            background: `linear-gradient(to top, var(--ds-surface, #ffffff), transparent)`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $0cf35f0338000ecd$var$styles.showMoreWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $0cf35f0338000ecd$var$styles.showMore,
        onClick: handleToggle,
        testId: "conversation-assistant.jsm-create-survey-preview-card.show-more-button",
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small",
        weight: "medium"
    }, formatMessage($0cf35f0338000ecd$var$showMoreMessage))))));
};
function $0cf35f0338000ecd$var$_temp(prev) {
    return !prev;
}



















var $4a9e192ca9f8138c$exports = {};
$4a9e192ca9f8138c$exports = new URL("preview-card-survey-header.fded201f.svg", import.meta.url).toString();


const $57ac87449cd47ada$var$styles = {
    container: "_2Zuz6Q5zaO _1Znuxb5zaO _0Of8r25zaO _1wydGW5zaO"
};
const $57ac87449cd47ada$export$e543a412c1d4574f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { selectedFormQuestions: t1 } = t0;
    const { title: title } = t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4a9e192ca9f8138c$exports))),
            alt: "Survey preview card"
        }));
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $57ac87449cd47ada$var$styles.container
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            color: "color.link"
        }, title));
        $[1] = title;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : ({ selectedFormQuestions: { title: title } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $57ac87449cd47ada$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4a9e192ca9f8138c$exports))),
        alt: "Survey preview card"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "color.link"
    }, title));






var $87Lnp = parcelRequire("87Lnp");














var $9XT2p = parcelRequire("9XT2p");

const $c0e7833da2ef7047$var$JsmActionDataSchema = (0, $87Lnp.z).object({
    selectedFormQuestions: (0, $87Lnp.z).object({
        title: (0, $87Lnp.z).string(),
        description: (0, $87Lnp.z).string(),
        questions: (0, $87Lnp.z).array((0, $87Lnp.z).object({
            text: (0, $87Lnp.z).string(),
            type: (0, $87Lnp.z).string(),
            isRequired: (0, $87Lnp.z).boolean(),
            choices: (0, $87Lnp.z).array((0, $87Lnp.z).string()).optional()
        }))
    }),
    projectId: (0, $87Lnp.z).string()
});
const $c0e7833da2ef7047$var$SurveySchema = (0, $87Lnp.z).object({
    id: (0, $87Lnp.z).string()
});
const $c0e7833da2ef7047$var$createSurvey = async (cloudId, actionData)=>{
    const res = await fetch(`/gateway/api/jsm/surveys/cloudid/${cloudId}/ai/create/survey`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(actionData)
    });
    if (!res.ok) {
        const apiError = await (0, $eKUiY.parseSurveyApiError)(res);
        throw apiError ?? new Error(`Failed to create survey with AI: ${res.status}`);
    }
    const json = await res.json();
    const survey = $c0e7833da2ef7047$var$SurveySchema.safeParse(json);
    if (!survey.success) throw new Error(`Failed to create survey with AI: ${survey.error.message}`);
    return survey.data;
};
/**
 * Make the open survey URL for the JSM Create Survey preview card experience.
 *
 * After a fresh creation, use the specific survey edit URL; otherwise fall back to the
 * generic surveys dashboard so the Open button remains valid across page reloads.
 */ const $c0e7833da2ef7047$var$makeOpenSurveyUrl = (projectKey, surveyId, conversationId)=>{
    const params = new URLSearchParams();
    params.append('conversationId', conversationId);
    let basePath = `/jira/servicedesk/projects/${projectKey}/surveys`;
    if (surveyId) basePath += `/${surveyId}/edit`;
    return `${basePath}?${params.toString()}`;
};
const $c0e7833da2ef7047$export$2008d6f7e33f1845 = ({ actions: actions, isEnabled: isEnabled, isSelected: isSelected, stagingAreaEnabled: stagingAreaEnabled, cloudId: cloudId, resolveAction: resolveAction, conversationId: conversationId, projectKey: projectKey })=>{
    const [firstAction] = actions;
    const { key: actionKey, data: actionData = {} } = firstAction ?? {};
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const jsmCreateSurveyData = $c0e7833da2ef7047$var$JsmActionDataSchema.parse(actionData);
    // When the survey is created from outside this card (e.g. by the staging-area
    // JsmSurveyFinalizeButton), the created survey's id is persisted on the action's
    // data. Its presence indicates the survey has already been created.
    const persistedSurveyId = actionData.surveyId;
    const hasCreated = firstAction?.status === (0, $9XT2p.MESSAGE_ACTION_INVOCATION_STATUSES).finished || Boolean(persistedSurveyId);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isCreating, setIsCreating] = (0, $cozmU.useState)(false);
    const [errorKey, setErrorKey] = (0, $cozmU.useState)(undefined);
    const [surveyId, setSurveyId] = (0, $cozmU.useState)(undefined);
    const [hasDismissed, setHasDismissed] = (0, $cozmU.useState)(false);
    const { messageIdSelectedForPreview: messageIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const handleToggle = ()=>setIsOpen((prev)=>!prev);
    const isInSmartCreateModal = Boolean(messageIdSelectedForPreview || stagingAreaEnabled);
    const openSurveyUrl = $c0e7833da2ef7047$var$makeOpenSurveyUrl(projectKey, surveyId ?? '', conversationId ?? '');
    const lastInvocationId = (0, $cozmU.useMemo)(()=>actions[actions.length - 1]?.invocationId, [
        actions
    ]);
    const areButtonsDisabled = isSelected || !isEnabled || hasCreated || isCreating || hasDismissed;
    const hasFiredInitiated = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('surveys-aifc-dismiss-button') || hasFiredInitiated.current || !actionKey || hasCreated) return;
        hasFiredInitiated.current = true;
        trackAIMAUEvent({
            type: 'initiated',
            attributes: {
                singleInstrumentationID: conversationId,
                aiFeatureName: 'jsmSurvey',
                createdContentProduct: 'jira',
                createdContentType: 'jsmSurvey',
                createdContentMetadata: {
                    projectId: jsmCreateSurveyData.projectId
                }
            }
        });
    }, [
        actionKey,
        conversationId,
        hasCreated,
        jsmCreateSurveyData.projectId,
        trackAIMAUEvent
    ]);
    const onDismissSurvey = (0, $cozmU.useCallback)(()=>{
        if (!actionKey || !lastInvocationId) return;
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'jsmSurveyPreviewCard.dismiss',
            attributes: {
                projectId: jsmCreateSurveyData.projectId
            }
        });
        trackAIMAUEvent({
            type: 'dismissed',
            attributes: {
                singleInstrumentationID: conversationId,
                aiFeatureName: 'jsmSurvey',
                createdContentProduct: 'jira',
                createdContentType: 'jsmSurvey',
                createdContentMetadata: {
                    projectId: jsmCreateSurveyData.projectId
                }
            }
        });
        resolveAction?.(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, lastInvocationId);
        setHasDismissed(true);
    }, [
        actionKey,
        conversationId,
        jsmCreateSurveyData.projectId,
        lastInvocationId,
        resolveAction,
        sendAnalyticsEvent,
        trackAIMAUEvent
    ]);
    const onCreateSurvey = (0, $cozmU.useCallback)(async ()=>{
        if (!actionKey || isCreating) return;
        // Fire analytics for create button click
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'jsmSurveyPreviewCard.create',
            attributes: {
                projectId: jsmCreateSurveyData.projectId
            }
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'contentFinalized',
            attributes: {
                singleInstrumentationID: conversationId,
                aiFeatureName: 'jsmSurvey',
                createdContentProduct: 'jira',
                createdContentType: 'jsmSurvey',
                createdContentMetadata: {
                    projectId: jsmCreateSurveyData.projectId
                }
            }
        });
        setIsCreating(true);
        setErrorKey(undefined);
        try {
            const { id: id } = await $c0e7833da2ef7047$var$createSurvey(cloudId, jsmCreateSurveyData);
            setSurveyId(id);
            // Fire analytics for successful survey creation
            sendAnalyticsEvent({
                eventType: 'operational',
                action: 'succeeded',
                actionSubject: 'jsmSurveyCreation',
                actionSubjectId: 'jsmSurveyPreviewCard.create',
                attributes: {
                    projectId: jsmCreateSurveyData.projectId,
                    surveyId: id
                }
            });
            resolveAction?.(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).actioned, lastInvocationId, {
                surveyId: id
            });
            trackAIMAUEvent({
                type: 'adopted',
                actionKey: actionKey ?? '',
                rovoModifiedObjects: [
                    {
                        objectType: 'jsm-survey',
                        objectId: id
                    }
                ],
                attributes: {
                    singleInstrumentationID: conversationId,
                    aiFeatureName: 'jsmSurvey',
                    createdContentProduct: 'jira',
                    createdContentType: 'jsmSurvey',
                    createdContentMetadata: {
                        projectId: jsmCreateSurveyData.projectId,
                        surveyId: id
                    }
                }
            });
        } catch (error) {
            // Fire analytics for failed survey creation
            sendAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'jsmSurveyCreation',
                actionSubjectId: 'jsmSurveyPreviewCard.create',
                attributes: {
                    projectId: jsmCreateSurveyData.projectId,
                    errorMessage: error instanceof Error ? error.message : 'Unknown error'
                }
            });
            setErrorKey(error instanceof (0, $eKUiY.SurveyApiError) ? error.errorKey : undefined);
        } finally{
            setIsCreating(false);
        }
    }, [
        resolveAction,
        actionKey,
        cloudId,
        isCreating,
        jsmCreateSurveyData,
        lastInvocationId,
        sendAnalyticsEvent,
        trackAIMAUEvent,
        conversationId
    ]);
    return {
        isOpen: isOpen,
        handleToggle: handleToggle,
        isInSmartCreateModal: isInSmartCreateModal,
        hasCreated: hasCreated,
        hasDismissed: hasDismissed,
        isCreating: isCreating,
        errorKey: errorKey,
        onCreateSurvey: onCreateSurvey,
        onDismissSurvey: onDismissSurvey,
        areButtonsDisabled: areButtonsDisabled,
        actionData: jsmCreateSurveyData,
        openSurveyUrl: openSurveyUrl
    };
};


const $1e115f32805dad23$var$surveyPreviewCardTitle = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-title",
    defaultMessage: "Create survey"
});
const $1e115f32805dad23$var$surveyPreviewCardPreviewButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-preview-button",
    defaultMessage: "Preview"
});
const $1e115f32805dad23$var$surveyPreviewCardCreateButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-create-button",
    defaultMessage: "Create"
});
const $1e115f32805dad23$var$surveyPreviewCardCreatingButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-creating-button",
    defaultMessage: "Creating\u2026"
});
const $1e115f32805dad23$var$surveyPreviewCardOpenButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-open-button",
    defaultMessage: "Open"
});
const $1e115f32805dad23$var$surveyPreviewCardDismissButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-dismiss-button",
    defaultMessage: "Dismiss"
});
const $1e115f32805dad23$var$surveyPreviewCardDismissedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-dismissed-message",
    defaultMessage: "You've dismissed the suggested survey"
});
const $1e115f32805dad23$var$surveyPreviewCardActionMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-action-message",
    defaultMessage: "I've drafted a survey for you to review: <title></title>. Select <bold>Create</bold> when you're ready. It will be added to the current space."
});
const $1e115f32805dad23$var$surveyPreviewCardSuccessMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-success-message",
    defaultMessage: "You created {title}"
});
const $1e115f32805dad23$var$surveyPreviewCardToggleCloseLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-toggle-close-label",
    defaultMessage: "Close"
});
const $1e115f32805dad23$var$surveyPreviewCardToggleOpenLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-ui-components.survey-preview-card-toggle-open-label",
    defaultMessage: "Open"
});
const $1e115f32805dad23$var$styles = {
    container: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _2OUyjtzwhj",
    header: "_39xV02N91d _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _2fwxA5ecOK _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    content: "_2bqfgdOeNX _2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67",
    icon: "_0bjKvD0O7w _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02Uofl _0jFU0VUofl"
};
const $1e115f32805dad23$export$bd9f82fd7df5c3f4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(67);
    const { actions: actions, cloudId: cloudId, onPreview: onPreview } = props;
    const [firstAction] = actions;
    const projectIdOrKey = String(firstAction?.data?.projectId ?? "");
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t0;
    if ($[0] !== cloudId || $[1] !== projectIdOrKey) {
        t0 = {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        };
        $[0] = cloudId;
        $[1] = projectIdOrKey;
        $[2] = t0;
    } else t0 = $[2];
    const projectData = (0, $6SsN4.useLazyLoadQuery)((0, $e1f5b812e5bdd650$export$2e2bcd8739ae039), t0);
    const projectKey = projectData.jira_projectByIdOrKey?.key ?? projectIdOrKey;
    let t1;
    if ($[3] !== projectKey || $[4] !== props) {
        t1 = {
            ...props,
            projectKey: projectKey
        };
        $[3] = projectKey;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const { isOpen: isOpen, handleToggle: handleToggle, isInSmartCreateModal: isInSmartCreateModal, hasCreated: hasCreated, hasDismissed: hasDismissed, isCreating: isCreating, errorKey: errorKey, onCreateSurvey: onCreateSurvey, onDismissSurvey: onDismissSurvey, areButtonsDisabled: areButtonsDisabled, actionData: actionData, openSurveyUrl: openSurveyUrl } = (0, $c0e7833da2ef7047$export$2008d6f7e33f1845)(t1);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    let t2;
    if ($[6] !== errorKey || $[7] !== formatMessage) {
        t2 = (0, $eKUiY.getSurveyCreationFlagContent)(errorKey, formatMessage);
        $[6] = errorKey;
        $[7] = formatMessage;
        $[8] = t2;
    } else t2 = $[8];
    const errorMessage = t2.description;
    let t3;
    let t4;
    if ($[9] !== errorKey || $[10] !== formatMessage || $[11] !== isInSmartCreateModal || $[12] !== showFlag) {
        t3 = ()=>{
            if (!errorKey || isInSmartCreateModal) return;
            const flagContent = (0, $eKUiY.getSurveyCreationFlagContent)(errorKey, formatMessage);
            showFlag({
                id: `conversation-assistant.jsm-create-survey-card.error-flag.${errorKey}`,
                title: flagContent.title,
                description: flagContent.description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    size: "small",
                    label: ""
                }),
                isAutoDismiss: false
            });
        };
        t4 = [
            errorKey,
            formatMessage,
            showFlag,
            isInSmartCreateModal
        ];
        $[9] = errorKey;
        $[10] = formatMessage;
        $[11] = isInSmartCreateModal;
        $[12] = showFlag;
        $[13] = t3;
        $[14] = t4;
    } else {
        t3 = $[13];
        t4 = $[14];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[15] !== onPreview || $[16] !== projectIdOrKey || $[17] !== sendAnalyticsEvent) {
        t5 = (e)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "jsmSurveyPreviewCard.preview",
                attributes: {
                    projectId: projectIdOrKey
                }
            });
            onPreview(e);
        };
        $[15] = onPreview;
        $[16] = projectIdOrKey;
        $[17] = sendAnalyticsEvent;
        $[18] = t5;
    } else t5 = $[18];
    const handlePreviewClick = t5;
    let t6;
    if ($[19] !== projectIdOrKey || $[20] !== sendAnalyticsEvent) {
        t6 = ()=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "jsmSurveyPreviewCard.open",
                attributes: {
                    projectId: projectIdOrKey
                }
            });
        };
        $[19] = projectIdOrKey;
        $[20] = sendAnalyticsEvent;
        $[21] = t6;
    } else t6 = $[21];
    const handleOpenClick = t6;
    if (hasDismissed) {
        let t7;
        if ($[22] !== formatMessage) {
            t7 = formatMessage($1e115f32805dad23$var$surveyPreviewCardDismissedMessage);
            $[22] = formatMessage;
            $[23] = t7;
        } else t7 = $[23];
        let t8;
        if ($[24] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
                message: t7,
                isSuccessMessage: false
            });
            $[24] = t7;
            $[25] = t8;
        } else t8 = $[25];
        return t8;
    }
    let t7;
    if ($[26] !== actionData || $[27] !== formatMessage || $[28] !== hasCreated) {
        t7 = !hasCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($1e115f32805dad23$var$surveyPreviewCardActionMessage, {
            bold: $1e115f32805dad23$var$_temp,
            title: (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    weight: "bold"
                }, actionData.selectedFormQuestions.title)
        }));
        $[26] = actionData;
        $[27] = formatMessage;
        $[28] = hasCreated;
        $[29] = t7;
    } else t7 = $[29];
    let t8;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $1e115f32805dad23$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2WCju))), {
            label: "Survey icon",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[30] = t8;
    } else t8 = $[30];
    let t9;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignInline: "center",
            space: "space.100",
            alignBlock: "center"
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardTitle)));
        $[31] = t9;
    } else t9 = $[31];
    const t10 = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    let t11;
    if ($[32] !== formatMessage || $[33] !== isOpen) {
        t11 = isOpen ? formatMessage($1e115f32805dad23$var$surveyPreviewCardToggleCloseLabel) : formatMessage($1e115f32805dad23$var$surveyPreviewCardToggleOpenLabel);
        $[32] = formatMessage;
        $[33] = isOpen;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== handleToggle || $[36] !== t10 || $[37] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1e115f32805dad23$var$styles.header
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: t10,
            label: t11,
            onClick: handleToggle,
            appearance: "subtle",
            spacing: "compact",
            testId: "conversation-assistant.jsm-create-survey-preview-card.toggle-button",
            isTooltipDisabled: false
        }));
        $[35] = handleToggle;
        $[36] = t10;
        $[37] = t11;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== actionData || $[40] !== areButtonsDisabled || $[41] !== handleOpenClick || $[42] !== handlePreviewClick || $[43] !== hasCreated || $[44] !== isCreating || $[45] !== isInSmartCreateModal || $[46] !== isOpen || $[47] !== onCreateSurvey || $[48] !== onDismissSurvey || $[49] !== openSurveyUrl) {
        t13 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $1e115f32805dad23$var$styles.content
        }, isInSmartCreateModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57ac87449cd47ada$export$e543a412c1d4574f), actionData) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0cf35f0338000ecd$export$f2b0a76b0690f3fa), actionData), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a849cbfd2239f6f$export$65e001b1c0481f66), null, hasCreated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            href: openSurveyUrl,
            onClick: handleOpenClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardOpenButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "end",
            spread: (0, $iDrrr.fg)("surveys-aifc-dismiss-button") ? "space-between" : undefined,
            grow: "fill"
        }, (0, $iDrrr.fg)("surveys-aifc-dismiss-button") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onDismissSurvey,
            isDisabled: areButtonsDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardDismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handlePreviewClick,
            isDisabled: areButtonsDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardPreviewButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onCreateSurvey,
            isDisabled: areButtonsDisabled,
            iconBefore: isCreating ? $1e115f32805dad23$var$_temp2 : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isCreating ? $1e115f32805dad23$var$surveyPreviewCardCreatingButton : $1e115f32805dad23$var$surveyPreviewCardCreateButton)))))));
        $[39] = actionData;
        $[40] = areButtonsDisabled;
        $[41] = handleOpenClick;
        $[42] = handlePreviewClick;
        $[43] = hasCreated;
        $[44] = isCreating;
        $[45] = isInSmartCreateModal;
        $[46] = isOpen;
        $[47] = onCreateSurvey;
        $[48] = onDismissSurvey;
        $[49] = openSurveyUrl;
        $[50] = t13;
    } else t13 = $[50];
    let t14;
    if ($[51] !== t12 || $[52] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $1e115f32805dad23$var$styles.container
        }, t12, t13);
        $[51] = t12;
        $[52] = t13;
        $[53] = t14;
    } else t14 = $[53];
    let t15;
    if ($[54] !== actionData || $[55] !== formatMessage || $[56] !== hasCreated || $[57] !== isInSmartCreateModal) {
        t15 = hasCreated && !isInSmartCreateModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
            message: formatMessage($1e115f32805dad23$var$surveyPreviewCardSuccessMessage, {
                title: actionData.selectedFormQuestions.title
            })
        });
        $[54] = actionData;
        $[55] = formatMessage;
        $[56] = hasCreated;
        $[57] = isInSmartCreateModal;
        $[58] = t15;
    } else t15 = $[58];
    let t16;
    if ($[59] !== errorKey || $[60] !== errorMessage) {
        t16 = errorKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
            isSuccessMessage: false,
            message: errorMessage
        });
        $[59] = errorKey;
        $[60] = errorMessage;
        $[61] = t16;
    } else t16 = $[61];
    let t17;
    if ($[62] !== t14 || $[63] !== t15 || $[64] !== t16 || $[65] !== t7) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t7, t14, t15, t16);
        $[62] = t14;
        $[63] = t15;
        $[64] = t16;
        $[65] = t7;
        $[66] = t17;
    } else t17 = $[66];
    return t17;
} : (props)=>{
    const { actions: actions, cloudId: cloudId, onPreview: onPreview } = props;
    const [firstAction] = actions;
    const projectIdOrKey = String(firstAction?.data?.projectId ?? '');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const projectData = (0, $6SsN4.useLazyLoadQuery)((0, $e1f5b812e5bdd650$export$2e2bcd8739ae039), {
        cloudId: cloudId,
        projectIdOrKey: projectIdOrKey
    });
    const projectKey = projectData.jira_projectByIdOrKey?.key ?? projectIdOrKey;
    const { isOpen: isOpen, handleToggle: handleToggle, isInSmartCreateModal: isInSmartCreateModal, hasCreated: hasCreated, hasDismissed: hasDismissed, isCreating: isCreating, errorKey: errorKey, onCreateSurvey: onCreateSurvey, onDismissSurvey: onDismissSurvey, areButtonsDisabled: areButtonsDisabled, actionData: actionData, openSurveyUrl: openSurveyUrl } = (0, $c0e7833da2ef7047$export$2008d6f7e33f1845)({
        ...props,
        projectKey: projectKey
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const errorMessage = (0, $eKUiY.getSurveyCreationFlagContent)(errorKey, formatMessage).description;
    (0, $cozmU.useEffect)(()=>{
        if (!errorKey || isInSmartCreateModal) return;
        const flagContent = (0, $eKUiY.getSurveyCreationFlagContent)(errorKey, formatMessage);
        showFlag({
            id: `conversation-assistant.jsm-create-survey-card.error-flag.${errorKey}`,
            title: flagContent.title,
            description: flagContent.description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                color: "var(--ds-icon-danger, #C9372C)",
                size: "small",
                label: ""
            }),
            isAutoDismiss: false
        });
    }, [
        errorKey,
        formatMessage,
        showFlag,
        isInSmartCreateModal
    ]); // Analytics-wrapped event handlers
    const handlePreviewClick = (e)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'jsmSurveyPreviewCard.preview',
            attributes: {
                projectId: projectIdOrKey
            }
        });
        onPreview(e);
    };
    const handleOpenClick = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'jsmSurveyPreviewCard.open',
            attributes: {
                projectId: projectIdOrKey
            }
        });
    };
    if (hasDismissed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        message: formatMessage($1e115f32805dad23$var$surveyPreviewCardDismissedMessage),
        isSuccessMessage: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, !hasCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($1e115f32805dad23$var$surveyPreviewCardActionMessage, {
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks),
        title: (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, actionData.selectedFormQuestions.title)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $1e115f32805dad23$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1e115f32805dad23$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "center",
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $1e115f32805dad23$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2WCju))), {
        label: "Survey icon",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: isOpen ? formatMessage($1e115f32805dad23$var$surveyPreviewCardToggleCloseLabel) : formatMessage($1e115f32805dad23$var$surveyPreviewCardToggleOpenLabel),
        onClick: handleToggle,
        appearance: "subtle",
        spacing: "compact",
        testId: "conversation-assistant.jsm-create-survey-preview-card.toggle-button",
        isTooltipDisabled: false
    })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $1e115f32805dad23$var$styles.content
    }, isInSmartCreateModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57ac87449cd47ada$export$e543a412c1d4574f), actionData) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0cf35f0338000ecd$export$f2b0a76b0690f3fa), actionData), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a849cbfd2239f6f$export$65e001b1c0481f66), null, hasCreated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: openSurveyUrl,
        onClick: handleOpenClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardOpenButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "end",
        spread: (0, $iDrrr.fg)('surveys-aifc-dismiss-button') ? 'space-between' : undefined,
        grow: "fill"
    }, (0, $iDrrr.fg)('surveys-aifc-dismiss-button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismissSurvey,
        isDisabled: areButtonsDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardDismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handlePreviewClick,
        isDisabled: areButtonsDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1e115f32805dad23$var$surveyPreviewCardPreviewButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onCreateSurvey,
        isDisabled: areButtonsDisabled,
        iconBefore: isCreating ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small"
            }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isCreating ? $1e115f32805dad23$var$surveyPreviewCardCreatingButton : $1e115f32805dad23$var$surveyPreviewCardCreateButton)))))))), hasCreated && !isInSmartCreateModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        message: formatMessage($1e115f32805dad23$var$surveyPreviewCardSuccessMessage, {
            title: actionData.selectedFormQuestions.title
        })
    }), errorKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        isSuccessMessage: false,
        message: errorMessage
    }));
};
function $1e115f32805dad23$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks);
}
function $1e115f32805dad23$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    });
}
































const $5d440274b79fd9ad$var$defaultErrorMessage = (0, $kSwu1.defineMessage)({
    id: "jsmCreateSurveyCardError.heading",
    defaultMessage: "Rovo couldn't create your survey. Refresh the page, or try again with a different prompt."
});
const $5d440274b79fd9ad$var$refreshButton = (0, $kSwu1.defineMessage)({
    id: "jsmCreateSurveyCardError.refreshButton",
    defaultMessage: "Refresh page"
});
const $5d440274b79fd9ad$var$styles = {
    container: "_43nrzT8HPE",
    iconContainer: "_43nrzTFQfX",
    buttonWrapper: "_4xdlr07p2s"
};
const $5d440274b79fd9ad$export$f9f1d2f0dae6d1fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(15);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    let t0;
    let t1;
    if ($[0] !== sendAnalyticsEvent) {
        t0 = ()=>{
            if (!hasFiredViewEvent.current) {
                hasFiredViewEvent.current = true;
                sendAnalyticsEvent({
                    action: "rendered",
                    actionSubject: "component",
                    actionSubjectId: "JsmCreateSurveyCardError"
                });
            }
        };
        t1 = [
            sendAnalyticsEvent
        ];
        $[0] = sendAnalyticsEvent;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const handleRefresh = $5d440274b79fd9ad$var$_temp;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5d440274b79fd9ad$var$styles.iconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }));
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage($5d440274b79fd9ad$var$defaultErrorMessage);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "start",
            xcss: $5d440274b79fd9ad$var$styles.container
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($5d440274b79fd9ad$var$refreshButton);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5d440274b79fd9ad$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleRefresh
        }, t5));
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t4 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t4, t6);
        $[12] = t4;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasFiredViewEvent.current) {
            hasFiredViewEvent.current = true;
            sendAnalyticsEvent({
                action: 'rendered',
                actionSubject: 'component',
                actionSubjectId: 'JsmCreateSurveyCardError'
            });
        }
    }, [
        sendAnalyticsEvent
    ]);
    const handleRefresh = ()=>window.location.reload();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "start",
        xcss: $5d440274b79fd9ad$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5d440274b79fd9ad$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($5d440274b79fd9ad$var$defaultErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5d440274b79fd9ad$var$styles.buttonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleRefresh
    }, formatMessage($5d440274b79fd9ad$var$refreshButton))));
};
function $5d440274b79fd9ad$var$_temp() {
    return window.location.reload();
}





const $40f5cabe6ee4cf1d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    previewButton: {
        id: "conversation-assistant-ui-components.preview-button",
        defaultMessage: "Preview"
    },
    openButton: {
        id: "conversation-assistant-ui-components.open-button",
        defaultMessage: "Open"
    },
    createDashboard: {
        id: "conversation-assistant-ui-components.create-home-dashboard",
        defaultMessage: "Create Dashboard"
    },
    viewingNow: {
        id: "conversation-assistant-ui-components.viewing-now",
        defaultMessage: "Viewing now"
    },
    newPreviewButton: {
        id: "conversation-assistant-ui-components.new-preview-button",
        defaultMessage: "Open preview"
    },
    dynamicUiPreviewTitle: {
        id: "conversation-assistant-ui-components.dynamic-ui-preview-title",
        defaultMessage: "Dynamic preview"
    },
    dynamicUiExpandButton: {
        id: "conversation-assistant-ui-components.dynamic-ui-expand-button",
        defaultMessage: "Expand"
    },
    dynamicUiCopyButton: {
        id: "conversation-assistant-ui-components.dynamic-ui-copy-button",
        defaultMessage: "Copy"
    },
    dynamicUiCopied: {
        id: "conversation-assistant-ui-components.dynamic-ui-copied",
        defaultMessage: "Copied!"
    }
});


















var $haiCi = parcelRequire("haiCi");

const $3ccbf81265041115$var$GetConfluenceContentQuery = `
query GetConfluenceContent($cloudId: ID!, $contentId: ID!, $includeReactions: Boolean!) {
  content(cloudId: $cloudId, id: $contentId) {
    nodes {
      id
      title
      type
      subType
      space {
        id
        key
      }
      links {
        webui
        base
      }
      version {
        friendlyWhen
      }
      excerpt(length: 372)
    }
  }
  contentContributors(id: $contentId, cloudId: $cloudId) {
    nodes {
      type
      displayName
      ... on KnownUser {
        accountId
      }
      profilePicture {
        path
      }
    }
  }
  confluence_contentReactionsSummary(cloudId: $cloudId, contentId: $contentId, contentType: PAGE) @include(if: $includeReactions) {
    contentReactionsSummary: reactionsSummary {
      reactionsCount
      ari
      containerAri
      reactionsSummaryForEmoji {
        emojiId
        count
        reacted
        id
      }
    }
  }
}
`;
const $3ccbf81265041115$export$2b1588eb5ed5a9af = (contentId, cloudId, includeReactions)=>{
    const getConfluenceContent = (0, $cozmU.useCallback)(async ()=>{
        try {
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $3ccbf81265041115$var$GetConfluenceContentQuery,
                variables: {
                    contentId: contentId,
                    cloudId: cloudId,
                    includeReactions: includeReactions
                }
            });
            return response?.data;
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'GetConfluenceContentQueryError',
                tags: {
                    contentId: contentId
                }
            });
            return undefined;
        }
    }, [
        contentId,
        cloudId,
        includeReactions
    ]);
    return {
        getConfluenceContent: getConfluenceContent
    };
};


const $7bf1ad9e43134df9$var$isRovoConfluenceSystemSpace = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
const $7bf1ad9e43134df9$export$59dc636aee1f545e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { previewProduct: previewProduct, id: id, cloudId: cloudId, includeReactions: includeReactions, status: status } = t0;
    const [publishedContentData, setPublishedContentData] = (0, $cozmU.useState)(undefined);
    const { getConfluenceContent: getConfluenceContent } = (0, $3ccbf81265041115$export$2b1588eb5ed5a9af)(id, cloudId, includeReactions);
    const previousStateRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== getConfluenceContent || $[1] !== previewProduct) {
        t1 = async ()=>{
            let fetchFunction;
            switch(previewProduct){
                case "confluence":
                    fetchFunction = getConfluenceContent;
            }
            if (!fetchFunction) return;
            const fetchedData = await fetchFunction();
            if (fetchedData) bb10: switch(previewProduct){
                case "confluence":
                    {
                        if (!fetchedData?.content?.nodes?.[0]) break bb10;
                        if ($7bf1ad9e43134df9$var$isRovoConfluenceSystemSpace(fetchedData?.content?.nodes?.[0]?.space?.key)) break bb10;
                        const result = {
                            title: fetchedData?.content?.nodes?.[0]?.title,
                            type: fetchedData?.content?.nodes?.[0]?.type,
                            subType: fetchedData?.content?.nodes?.[0]?.subType,
                            excerpt: fetchedData?.content?.nodes?.[0]?.excerpt,
                            contributors: fetchedData?.contentContributors?.nodes.map($7bf1ad9e43134df9$var$_temp),
                            reactions: fetchedData?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0],
                            links: fetchedData?.content?.nodes?.[0]?.links,
                            lastUpdated: fetchedData?.content?.nodes?.[0]?.version?.friendlyWhen
                        };
                        setPublishedContentData(result);
                    }
            }
        };
        $[0] = getConfluenceContent;
        $[1] = previewProduct;
        $[2] = t1;
    } else t1 = $[2];
    const fetchData = t1;
    let t2;
    let t3;
    if ($[3] !== fetchData || $[4] !== id || $[5] !== status) {
        t2 = ()=>{
            const shouldFetch = status === "finished" && (previousStateRef.current?.id !== id || previousStateRef.current?.status !== "finished");
            if (shouldFetch) fetchData();
            previousStateRef.current = {
                id: id,
                status: status
            };
        };
        t3 = [
            fetchData,
            id,
            status
        ];
        $[3] = fetchData;
        $[4] = id;
        $[5] = status;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[8] !== publishedContentData) {
        t4 = {
            publishedContentData: publishedContentData
        };
        $[8] = publishedContentData;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ previewProduct: previewProduct, id: id, cloudId: cloudId, includeReactions: includeReactions, status: status })=>{
    const [publishedContentData, setPublishedContentData] = (0, $cozmU.useState)(undefined);
    const { getConfluenceContent: getConfluenceContent } = (0, $3ccbf81265041115$export$2b1588eb5ed5a9af)(id, cloudId, includeReactions);
    const previousStateRef = (0, $cozmU.useRef)(null);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        let fetchFunction;
        switch(previewProduct){
            case 'confluence':
                fetchFunction = getConfluenceContent;
                break;
        }
        if (!fetchFunction) return;
        const fetchedData = await fetchFunction();
        if (fetchedData) switch(previewProduct){
            case 'confluence':
                if (!fetchedData?.content?.nodes?.[0]) break;
                // Status = finished should imply the content is not in the system space, but as the requests are to two different systemsnot a shared transaction, they can go out of sync
                // Therefore, we confirm here we're not in the system space. If we are able to improve how synchronous this logic is, we can remove this check.
                if ($7bf1ad9e43134df9$var$isRovoConfluenceSystemSpace(fetchedData?.content?.nodes?.[0]?.space?.key)) break;
                const result = {
                    title: fetchedData?.content?.nodes?.[0]?.title,
                    type: fetchedData?.content?.nodes?.[0]?.type,
                    subType: fetchedData?.content?.nodes?.[0]?.subType,
                    excerpt: fetchedData?.content?.nodes?.[0]?.excerpt,
                    contributors: fetchedData?.contentContributors?.nodes.map((node)=>({
                            name: node.displayName,
                            profilePicture: node.profilePicture
                        })),
                    reactions: fetchedData?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0],
                    links: fetchedData?.content?.nodes?.[0]?.links,
                    lastUpdated: fetchedData?.content?.nodes?.[0]?.version?.friendlyWhen
                };
                setPublishedContentData(result);
                break;
        }
    }, [
        previewProduct,
        getConfluenceContent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const shouldFetch = status === 'finished' && (previousStateRef.current?.id !== id || previousStateRef.current?.status !== 'finished');
        if (shouldFetch) fetchData();
        previousStateRef.current = {
            id: id,
            status: status
        };
    }, [
        fetchData,
        id,
        status
    ]);
    return {
        publishedContentData: publishedContentData
    };
};
function $7bf1ad9e43134df9$var$_temp(node) {
    return {
        name: node.displayName,
        profilePicture: node.profilePicture
    };
}


const $36a6ca40a62f0d9d$var$appendPreviewParam = (url)=>{
    try {
        const parsed = new URL(url);
        parsed.searchParams.set('preview', 'true');
        return parsed.toString();
    } catch  {
        return url.includes('?') ? `${url}&preview=true` : `${url}?preview=true`;
    }
};
const $36a6ca40a62f0d9d$var$styles = {
    containerBase: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _39xV02sz7G _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _3138425zaO _1DCdHi5zaO _3fSdSTGk8v",
    containerTransparentBorder: "_3vBAKH9r67",
    containerWithBorder: "_3vBAKHnXvL",
    imageContainer: "_1mT5xdRAKS",
    icon: "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ",
    textContainer: "_4kiQYAoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS",
    dynamicUiContainer: "_39xV02N91d _0jFU0VHakr",
    dynamicUiStack: "_0jFU0VN91d",
    iframe: "_30huDKYbGa _39xV02N91d _0jFU0VN91d",
    imageCreateContainer: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0NUa3rGVdc",
    avpCardContainer: "_39xV02sz7G"
};
const $36a6ca40a62f0d9d$var$imageCreateImageStyle = null;
const $36a6ca40a62f0d9d$var$getProductLogo = (product)=>{
    if (product === 'confluence') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $232254bb368cae82$export$1b2e4fe6ef471556), null);
    return null;
};
const $36a6ca40a62f0d9d$var$getContentToHeaderImage = (contentType)=>{
    switch(contentType){
        case (0, $63fke.ContentType).liveDoc:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8f284aedc91174f0$exports));
        case (0, $63fke.ContentType).whiteboard:
            return 0, (/*@__PURE__*/$parcel$interopDefault($0cf82dfbe954dfb2$exports));
        case (0, $63fke.ContentType).database:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4c8ab5fd7f919bc1$exports));
        case (0, $63fke.ContentType).slides:
            return 0, (/*@__PURE__*/$parcel$interopDefault($731a82ecb9597e7d$exports));
        case (0, $63fke.ContentType).dashboard:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5210a2d057f0b249$exports));
    }
};
const $36a6ca40a62f0d9d$var$CustomButtonWithPreviewDefault = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { defaultButton: defaultButton, links: links, formatMessage: formatMessage, conversationId: conversationId, shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome, cloudId: cloudId, messageId: messageId, isPreviewDisabled: isPreviewDisabled } = t0;
    if (links?.webui) {
        const { base: base, webui: webui } = links;
        const host = window.location.host;
        const linkToOpen = `${base}${webui}`;
        const t1 = base.includes(host) ? "_self" : "_blank";
        let t2;
        if ($[0] !== formatMessage) {
            t2 = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).openButton);
            $[0] = formatMessage;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== linkToOpen || $[3] !== t1 || $[4] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                target: t1,
                href: linkToOpen,
                spacing: "compact"
            }, t2);
            $[2] = linkToOpen;
            $[3] = t1;
            $[4] = t2;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    if (shouldOpenPreviewInAtlassianHome) {
        const t1 = conversationId ?? undefined;
        let t2;
        if ($[6] !== messageId || $[7] !== t1) {
            t2 = (0, $dTEBe.addRovoParamsToUrl)("", {
                pathway: "chat",
                conversationId: t1,
                stagingAreaOpen: true,
                messageIdSelectedForPreview: messageId
            });
            $[6] = messageId;
            $[7] = t1;
            $[8] = t2;
        } else t2 = $[8];
        const rovoPath = t2;
        const t3 = cloudId || "";
        const t4 = `/chat${rovoPath}`;
        let t5;
        if ($[9] !== t3 || $[10] !== t4) {
            t5 = (0, $7cQjw.getAtlasURL)(t3, t4, undefined);
            $[9] = t3;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        const atlassianHomeUrl = t5;
        let t6;
        if ($[12] !== formatMessage) {
            t6 = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).previewButton);
            $[12] = formatMessage;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== atlassianHomeUrl || $[15] !== isPreviewDisabled || $[16] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                target: "_blank",
                href: atlassianHomeUrl,
                spacing: "compact",
                testId: "home-preview-button",
                isDisabled: isPreviewDisabled
            }, t6);
            $[14] = atlassianHomeUrl;
            $[15] = isPreviewDisabled;
            $[16] = t6;
            $[17] = t7;
        } else t7 = $[17];
        return t7;
    }
    return defaultButton;
} : ({ defaultButton: defaultButton, links: links, formatMessage: formatMessage, conversationId: conversationId, shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome, cloudId: cloudId, messageId: messageId, isPreviewDisabled: isPreviewDisabled })=>{
    if (links?.webui) {
        const { base: base, webui: webui } = links;
        const host = window.location.host;
        const linkToOpen = `${base}${webui}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            target: base.includes(host) ? '_self' : '_blank',
            href: linkToOpen,
            spacing: "compact"
        }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).openButton));
    } // if shouldOpenPreviewInAtlassianHome is true, we want to open all previews in
    // Atlassian home with the current conversation and staging area open - this is
    // to better support creation flows where the content staging area isn't supported
    if (shouldOpenPreviewInAtlassianHome) {
        const rovoPath = (0, $dTEBe.addRovoParamsToUrl)('', {
            pathway: 'chat',
            conversationId: conversationId ?? undefined,
            stagingAreaOpen: true,
            messageIdSelectedForPreview: messageId
        });
        const atlassianHomeUrl = (0, $7cQjw.getAtlasURL)(cloudId || '', `/chat${rovoPath}`, undefined);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            target: "_blank",
            href: atlassianHomeUrl,
            spacing: "compact",
            testId: "home-preview-button",
            isDisabled: isPreviewDisabled
        }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).previewButton));
    }
    return defaultButton;
};
const $36a6ca40a62f0d9d$export$740e968d9f8d5dda = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(204);
    const { previewProduct: previewProduct, product: product, contentType: contentType, title: title, isSelected: isSelected, isEnabled: isEnabled, isLastMessage: isLastMessage, contentId: contentId, emojiProvider: emojiProvider, stagingAreaEnabled: stagingAreaEnabled, fullScreen: fullScreen, conversationId: conversationId, messageId: messageId, status: status, cloudId: cloudId, shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome, resolveActions: resolveActions, resolveAction: resolveAction, invocationId: invocationId, showSuccessFlagOnCreate: showSuccessFlagOnCreate } = t0;
    const [showDynamicUiCopied, setShowDynamicUiCopied] = (0, $cozmU.useState)(false);
    const [showImageCopied, setShowImageCopied] = (0, $cozmU.useState)(false);
    const [dynamicUiCopiedDismissKey, setDynamicUiCopiedDismissKey] = (0, $cozmU.useState)(0);
    const [imageCopiedDismissKey, setImageCopiedDismissKey] = (0, $cozmU.useState)(0);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiCopyButton);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const copyText = t1;
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiCopied);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    const copiedText = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setShowDynamicUiCopied(false);
        $[4] = t3;
    } else t3 = $[4];
    const onDynamicUiCopiedDismiss = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setShowImageCopied(false);
        $[5] = t4;
    } else t4 = $[5];
    const onImageCopiedDismiss = t4;
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = (0, $cKMeF.useAifcAnalytics)(messageId);
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const t5 = contentType === (0, $63fke.ContentType).liveDoc;
    let t6;
    if ($[6] !== cloudId || $[7] !== contentId || $[8] !== previewProduct || $[9] !== status || $[10] !== t5) {
        t6 = {
            previewProduct: previewProduct,
            id: contentId,
            cloudId: cloudId,
            includeReactions: t5,
            status: status
        };
        $[6] = cloudId;
        $[7] = contentId;
        $[8] = previewProduct;
        $[9] = status;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    const { publishedContentData: publishedContentData } = (0, $7bf1ad9e43134df9$export$59dc636aee1f545e)(t6);
    let t7;
    let t8;
    if ($[12] !== experienceTracker) {
        t7 = ()=>{
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                attributes: {
                    [(0, $irnO2.PreviewCardRenderStage).CARD_MOUNTED_AT]: performance.now()
                }
            });
        };
        t8 = [
            experienceTracker
        ];
        $[12] = experienceTracker;
        $[13] = t7;
        $[14] = t8;
    } else {
        t7 = $[13];
        t8 = $[14];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const isNonInstrumentedPreviewBranch = previewProduct === "jira" || previewProduct === "jsm" || previewProduct === "avp";
    let t10;
    let t9;
    if ($[15] !== experienceTracker || $[16] !== isNonInstrumentedPreviewBranch) {
        t9 = ()=>{
            if (isNonInstrumentedPreviewBranch) experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                attributes: {
                    [(0, $irnO2.PreviewCardRenderStage).ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT]: performance.now()
                }
            });
        };
        t10 = [
            isNonInstrumentedPreviewBranch,
            experienceTracker
        ];
        $[15] = experienceTracker;
        $[16] = isNonInstrumentedPreviewBranch;
        $[17] = t10;
        $[18] = t9;
    } else {
        t10 = $[17];
        t9 = $[18];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const { setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, getInvocationIdSelectedForPreview: getInvocationIdSelectedForPreview, getMessageIdSelectedForPreview: getMessageIdSelectedForPreview } = (0, $8akfd.useStagingAreaActions)();
    const { push: push } = (0, $kkLpw.useRouterActions)();
    let t11;
    if ($[19] !== getInvocationIdSelectedForPreview || $[20] !== getMessageIdSelectedForPreview) {
        t11 = !!getMessageIdSelectedForPreview() || !!getInvocationIdSelectedForPreview();
        $[19] = getInvocationIdSelectedForPreview;
        $[20] = getMessageIdSelectedForPreview;
        $[21] = t11;
    } else t11 = $[21];
    const isStagingArea = t11;
    const t12 = conversationId ?? "";
    let t13;
    if ($[22] !== t12) {
        t13 = {
            conversationId: t12
        };
        $[22] = t12;
        $[23] = t13;
    } else t13 = $[23];
    const [chatMessages] = (0, $iW40i.useChatMessages)(t13);
    let actions;
    let dynamicUiIframeUrl;
    let dynamicUiUrl;
    let headerImage;
    let iconConfig;
    let invokedActions;
    let isDefaultPreviewDisabled;
    let isDynamicUi;
    let isHomePreviewDisabled;
    let isInAtlassianHome;
    let isJiraCreateAction;
    let isJsmCreateAction;
    let isMauiPreview;
    let isOpenInCurrentTab;
    let resolvedContentType;
    let t14;
    if ($[24] !== chatMessages || $[25] !== contentType || $[26] !== fullScreen || $[27] !== invocationId || $[28] !== isSelected || $[29] !== messageId || $[30] !== publishedContentData || $[31] !== shouldOpenPreviewInAtlassianHome) {
        const selectedMessageForStatus = (0, $c7So7.findMessageById)(chatMessages, messageId);
        let t15;
        if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
            t15 = (0, $cXtTj.default).getExperimentValue("cwr-be-based-multi-creation-v0", "isEnabled", false);
            $[48] = t15;
        } else t15 = $[48];
        const isMultiCreateEnabled = t15;
        const previewStatus = (0, $c7So7.getAIFCActionStatus)(selectedMessageForStatus, isMultiCreateEnabled ? invocationId : undefined);
        let t16;
        if ($[49] !== contentType || $[50] !== publishedContentData) {
            t16 = publishedContentData ? (0, $63fke.getContentTypeFromPublishedContent)(publishedContentData.type, publishedContentData.subType) : contentType;
            $[49] = contentType;
            $[50] = publishedContentData;
            $[51] = t16;
        } else t16 = $[51];
        resolvedContentType = t16;
        let t17;
        if ($[52] !== resolvedContentType) {
            t17 = (0, $6ASE9.getPreviewItemIconConfig)(resolvedContentType);
            $[52] = resolvedContentType;
            $[53] = t17;
        } else t17 = $[53];
        iconConfig = t17;
        let t18;
        if ($[54] !== contentType) {
            t18 = contentType ? $36a6ca40a62f0d9d$var$getContentToHeaderImage(contentType) : null;
            $[54] = contentType;
            $[55] = t18;
        } else t18 = $[55];
        headerImage = t18;
        actions = selectedMessageForStatus?.content.message.message.actions ?? [];
        const selectedAction = isMultiCreateEnabled && invocationId && actions.find((action)=>action.invocationId === invocationId) || actions[0];
        invokedActions = selectedMessageForStatus?.invokedActions;
        const remixCandidate = isMultiCreateEnabled ? selectedAction : actions.find((0, $aYC8J.isRemixGeneratedFlow));
        const mauiAction = remixCandidate && (0, $aYC8J.isRemixGeneratedFlow)(remixCandidate) ? remixCandidate : null;
        const isDynamicUiAction = mauiAction !== null && (0, $aYC8J.isDynamicUiCreateAction)(mauiAction);
        dynamicUiUrl = isDynamicUiAction && (0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true) ? (0, $aYC8J.buildDynamicUiPageUrl)(mauiAction.data) : null;
        isDynamicUi = !!dynamicUiUrl;
        dynamicUiIframeUrl = dynamicUiUrl ? $36a6ca40a62f0d9d$var$appendPreviewParam(dynamicUiUrl) : undefined;
        isMauiPreview = mauiAction !== null && (0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true);
        let t19;
        if ($[56] !== publishedContentData) {
            t19 = ()=>{
                if (publishedContentData?.links?.webui && publishedContentData?.links?.base) {
                    const { base: base, webui: webui } = publishedContentData.links;
                    const linkToOpen = `${base}${webui}`;
                    const currentUrl = window.location.href;
                    return currentUrl.includes(webui) || currentUrl === linkToOpen;
                }
                return false;
            };
            $[56] = publishedContentData;
            $[57] = t19;
        } else t19 = $[57];
        isOpenInCurrentTab = t19;
        let t20;
        if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
            t20 = window.location.href.includes("home.atlassian.com") || window.location.href.includes("home.stg.atlassian.com");
            $[58] = t20;
        } else t20 = $[58];
        isInAtlassianHome = t20;
        isDefaultPreviewDisabled = isSelected || isInAtlassianHome && !fullScreen && previewStatus !== "complete";
        isHomePreviewDisabled = isDefaultPreviewDisabled || shouldOpenPreviewInAtlassianHome && previewStatus !== "complete";
        isJiraCreateAction = (0, $9yffN.isJiraCreatableAction)(selectedAction);
        isJsmCreateAction = (0, $1uJIC.isJsmCreatableAction)(selectedAction);
        t14 = isMultiCreateEnabled ? selectedAction : actions.find((0, $aYC8J.isImageCreateAction));
        $[24] = chatMessages;
        $[25] = contentType;
        $[26] = fullScreen;
        $[27] = invocationId;
        $[28] = isSelected;
        $[29] = messageId;
        $[30] = publishedContentData;
        $[31] = shouldOpenPreviewInAtlassianHome;
        $[32] = actions;
        $[33] = dynamicUiIframeUrl;
        $[34] = dynamicUiUrl;
        $[35] = headerImage;
        $[36] = iconConfig;
        $[37] = invokedActions;
        $[38] = isDefaultPreviewDisabled;
        $[39] = isDynamicUi;
        $[40] = isHomePreviewDisabled;
        $[41] = isInAtlassianHome;
        $[42] = isJiraCreateAction;
        $[43] = isJsmCreateAction;
        $[44] = isMauiPreview;
        $[45] = isOpenInCurrentTab;
        $[46] = resolvedContentType;
        $[47] = t14;
    } else {
        actions = $[32];
        dynamicUiIframeUrl = $[33];
        dynamicUiUrl = $[34];
        headerImage = $[35];
        iconConfig = $[36];
        invokedActions = $[37];
        isDefaultPreviewDisabled = $[38];
        isDynamicUi = $[39];
        isHomePreviewDisabled = $[40];
        isInAtlassianHome = $[41];
        isJiraCreateAction = $[42];
        isJsmCreateAction = $[43];
        isMauiPreview = $[44];
        isOpenInCurrentTab = $[45];
        resolvedContentType = $[46];
        t14 = $[47];
    }
    const imageCandidate = t14;
    let t15;
    if ($[59] !== imageCandidate) {
        t15 = imageCandidate && (0, $aYC8J.isImageCreateAction)(imageCandidate) ? imageCandidate : undefined;
        $[59] = imageCandidate;
        $[60] = t15;
    } else t15 = $[60];
    const imageCreateAction = t15;
    let t16;
    if ($[61] !== imageCreateAction || $[62] !== product) {
        t16 = !!imageCreateAction && (0, $cXtTj.default).getExperimentValue(product === "jira" ? "jira_maui_remix" : "cc-maui-experiment", "isEnabled", false);
        $[61] = imageCreateAction;
        $[62] = product;
        $[63] = t16;
    } else t16 = $[63];
    const isImageCreate = t16;
    const imageUrl = (0, $b71ee36f98a61401$export$6ac24dc114456b7d)(imageCreateAction?.data.mediaFileId, cloudId);
    let t17;
    if ($[64] !== contentType || $[65] !== conversationId || $[66] !== experienceTracker || $[67] !== fullScreen || $[68] !== invocationId || $[69] !== isInAtlassianHome || $[70] !== isJiraCreateAction || $[71] !== isJsmCreateAction || $[72] !== isMauiPreview || $[73] !== messageId || $[74] !== product || $[75] !== publish || $[76] !== push || $[77] !== setInvocationIdSelectedForPreview || $[78] !== setMessageIdSelectedForPreview || $[79] !== setStagingAreaMode || $[80] !== stagingAreaEnabled) {
        t17 = (e)=>{
            e.preventDefault();
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
                id: messageId,
                timeout: 30000,
                attributes: {
                    expectedContentType: contentType
                }
            });
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
                attributes: {
                    [(0, $irnO2.PreviewContentStage).STARTED_AT]: performance.now()
                }
            });
            if (invocationId && !(isJiraCreateAction && (0, $iDrrr.fg)("jira_aifc_enabled")) && !(isJsmCreateAction && (0, $iDrrr.fg)("surveys-aifc"))) setInvocationIdSelectedForPreview(invocationId);
            else setMessageIdSelectedForPreview(messageId);
            if (fullScreen && isInAtlassianHome) setStagingAreaMode("inline", "rovoChatPreviewCard");
            else {
                if (isInAtlassianHome) {
                    const path = (0, $dTEBe.addRovoParamsToUrl)("", {
                        pathway: "chat",
                        conversationId: conversationId ?? undefined,
                        stagingAreaOpen: true,
                        messageIdSelectedForPreview: messageId
                    });
                    push(`/chat${path}`);
                } else if (!stagingAreaEnabled) {
                    if (isMauiPreview && contentType !== (0, $63fke.ContentType).slides && contentType !== (0, $63fke.ContentType).database) {
                        if (product === "confluence" && (0, $iDrrr.fg)("remix_product_modal_rovo_chat")) publish({
                            type: "open-smart-creation-modal",
                            source: "rovo-chat-preview-card",
                            data: {
                                entryPoint: "rovoChatPreviewCard",
                                stagingAreaActive: true,
                                isFloating: true,
                                shouldShowBackButton: false
                            }
                        });
                        else setStagingAreaMode("ephemeralModal", "rovoChatPreviewCard");
                    } else setStagingAreaMode("modal", "rovoChatPreviewCard");
                }
            }
        };
        $[64] = contentType;
        $[65] = conversationId;
        $[66] = experienceTracker;
        $[67] = fullScreen;
        $[68] = invocationId;
        $[69] = isInAtlassianHome;
        $[70] = isJiraCreateAction;
        $[71] = isJsmCreateAction;
        $[72] = isMauiPreview;
        $[73] = messageId;
        $[74] = product;
        $[75] = publish;
        $[76] = push;
        $[77] = setInvocationIdSelectedForPreview;
        $[78] = setMessageIdSelectedForPreview;
        $[79] = setStagingAreaMode;
        $[80] = stagingAreaEnabled;
        $[81] = t17;
    } else t17 = $[81];
    const onPreviewClick = t17;
    let t18;
    if ($[82] !== actions.length || $[83] !== isStagingArea || $[84] !== onPreviewClick || $[85] !== sendAifcAnalyticsEvent) {
        t18 = (e_0)=>{
            sendAifcAnalyticsEvent?.({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "createWorkItemsAifcPreviewOpened",
                attributes: {
                    itemCount: actions.length,
                    isSingleWorkItem: false,
                    isStagingArea: isStagingArea
                }
            });
            onPreviewClick(e_0);
        };
        $[82] = actions.length;
        $[83] = isStagingArea;
        $[84] = onPreviewClick;
        $[85] = sendAifcAnalyticsEvent;
        $[86] = t18;
    } else t18 = $[86];
    const onJiraAifcPreviewClick = t18;
    let t19;
    if ($[87] !== dynamicUiUrl) {
        t19 = async ()=>{
            if (dynamicUiUrl) {
                await navigator.clipboard.writeText(dynamicUiUrl);
                setDynamicUiCopiedDismissKey($36a6ca40a62f0d9d$var$_temp);
                setShowDynamicUiCopied(true);
            }
        };
        $[87] = dynamicUiUrl;
        $[88] = t19;
    } else t19 = $[88];
    const onDynamicUiCopyClick = t19;
    if (previewProduct === "jira") {
        if (resolveActions && actions.length > 0 && isJiraCreateAction) {
            if ((0, $iDrrr.fg)("jira-aifc-migrate-action-renderer")) return null;
            let t20;
            if ($[89] !== sendAifcAnalyticsEvent) {
                t20 = (t21)=>{
                    const { error: error } = t21;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                        error: error,
                        name: (0, $irnO2.ExperienceName).JIRA_PREVIEW_CARD_RENDER
                    }), (0, $iDrrr.fg)("rovo_skills_work_item_reliability_ufo") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                        error: error,
                        name: (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2535348f76828a4$export$2ed946042a0386d), {
                        error: error,
                        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
                    }));
                };
                $[89] = sendAifcAnalyticsEvent;
                $[90] = t20;
            } else t20 = $[90];
            const t21 = conversationId ?? "";
            let t22;
            if ($[91] !== actions || $[92] !== cloudId || $[93] !== invokedActions || $[94] !== isEnabled || $[95] !== isLastMessage || $[96] !== isSelected || $[97] !== isStagingArea || $[98] !== messageId || $[99] !== onJiraAifcPreviewClick || $[100] !== product || $[101] !== resolveActions || $[102] !== showSuccessFlagOnCreate || $[103] !== t21) {
                t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gHaaj.JiraCreateWithRovoPreviewCard), {
                    product: product,
                    cloudId: cloudId,
                    actions: actions,
                    messageId: messageId,
                    conversationId: t21,
                    invokedActions: invokedActions,
                    isSelected: isSelected,
                    isEnabled: isEnabled,
                    isLastMessage: isLastMessage,
                    onPreviewClick: onJiraAifcPreviewClick,
                    resolveActions: resolveActions,
                    isStagingArea: isStagingArea,
                    showSuccessFlagOnCreate: showSuccessFlagOnCreate
                });
                $[91] = actions;
                $[92] = cloudId;
                $[93] = invokedActions;
                $[94] = isEnabled;
                $[95] = isLastMessage;
                $[96] = isSelected;
                $[97] = isStagingArea;
                $[98] = messageId;
                $[99] = onJiraAifcPreviewClick;
                $[100] = product;
                $[101] = resolveActions;
                $[102] = showSuccessFlagOnCreate;
                $[103] = t21;
                $[104] = t22;
            } else t22 = $[104];
            let t23;
            if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
                t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
                    name: (0, $irnO2.ExperienceName).JIRA_PREVIEW_CARD_RENDER
                });
                $[105] = t23;
            } else t23 = $[105];
            let t24;
            if ($[106] !== t20 || $[107] !== t22) {
                t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                    fallbackRender: t20
                }, t22, t23);
                $[106] = t20;
                $[107] = t22;
                $[108] = t24;
            } else t24 = $[108];
            return t24;
        } else return null;
    }
    if (previewProduct === "jsm") {
        if (isJsmCreateAction && (0, $iDrrr.fg)("surveys-aifc")) {
            let t20;
            if ($[109] !== actions || $[110] !== cloudId || $[111] !== conversationId || $[112] !== isEnabled || $[113] !== isSelected || $[114] !== onPreviewClick || $[115] !== resolveAction || $[116] !== stagingAreaEnabled) {
                t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e115f32805dad23$export$bd9f82fd7df5c3f4), {
                    actions: actions,
                    resolveAction: resolveAction,
                    isSelected: isSelected,
                    isEnabled: isEnabled,
                    stagingAreaEnabled: stagingAreaEnabled,
                    cloudId: cloudId,
                    onPreview: onPreviewClick,
                    conversationId: conversationId
                });
                $[109] = actions;
                $[110] = cloudId;
                $[111] = conversationId;
                $[112] = isEnabled;
                $[113] = isSelected;
                $[114] = onPreviewClick;
                $[115] = resolveAction;
                $[116] = stagingAreaEnabled;
                $[117] = t20;
            } else t20 = $[117];
            let t21;
            if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
                    name: (0, $irnO2.ExperienceName).JSM_PREVIEW_CARD_RENDER
                });
                $[118] = t21;
            } else t21 = $[118];
            let t22;
            if ($[119] !== t20) {
                t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                    fallbackRender: $36a6ca40a62f0d9d$var$_temp2
                }, t20, t21);
                $[119] = t20;
                $[120] = t22;
            } else t22 = $[120];
            return t22;
        } else return null;
    }
    if (previewProduct === "avp") {
        if (!(0, $iDrrr.fg)("platform_avp_aifc_enabled")) return null;
        let t20;
        if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($itpo2))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: "Dashboard"
            });
            $[121] = t20;
        } else t20 = $[121];
        let t21;
        if ($[122] !== formatMessage) {
            t21 = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).createDashboard);
            $[122] = formatMessage;
            $[123] = t21;
        } else t21 = $[123];
        let t22;
        if ($[124] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium",
                weight: "bold"
            }, t21);
            $[124] = t21;
            $[125] = t22;
        } else t22 = $[125];
        let t23;
        if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $36a6ca40a62f0d9d$var$styles.imageContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5210a2d057f0b249$exports))),
                alt: ""
            }));
            $[126] = t23;
        } else t23 = $[126];
        let t24;
        if ($[127] !== title) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, t23, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.link"
            }, title));
            $[127] = title;
            $[128] = t24;
        } else t24 = $[128];
        let t25;
        if ($[129] !== formatMessage || $[130] !== isOpenInCurrentTab || $[131] !== isSelected || $[132] !== onPreviewClick) {
            t25 = isSelected || isOpenInCurrentTab() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $36a6ca40a62f0d9d$var$styles.textContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest"
            }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).viewingNow))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onPreviewClick,
                interactionName: "rovo-aifc-avp-dashboard-preview-card-click",
                spacing: "compact"
            }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).newPreviewButton));
            $[129] = formatMessage;
            $[130] = isOpenInCurrentTab;
            $[131] = isSelected;
            $[132] = onPreviewClick;
            $[133] = t25;
        } else t25 = $[133];
        let t26;
        if ($[134] !== isEnabled || $[135] !== isSelected || $[136] !== t22 || $[137] !== t24 || $[138] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $36a6ca40a62f0d9d$var$styles.avpCardContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
                testId: "conversation-assistant-preview-card.avp-dashboard-preview-card",
                previewProductLogo: t20,
                isSelected: isSelected,
                isEnabled: isEnabled,
                previewHeaderTitle: t22,
                previewContent: t24,
                previewFooterActions: t25
            }));
            $[134] = isEnabled;
            $[135] = isSelected;
            $[136] = t22;
            $[137] = t24;
            $[138] = t25;
            $[139] = t26;
        } else t26 = $[139];
        return t26;
    }
    const t20 = isSelected ? $36a6ca40a62f0d9d$var$styles.containerWithBorder : $36a6ca40a62f0d9d$var$styles.containerTransparentBorder;
    const t21 = isDynamicUi && $36a6ca40a62f0d9d$var$styles.dynamicUiContainer;
    let t22;
    if ($[140] !== t20 || $[141] !== t21) {
        t22 = (0, $w6R6I.cx)($36a6ca40a62f0d9d$var$styles.containerBase, t20, t21);
        $[140] = t20;
        $[141] = t21;
        $[142] = t22;
    } else t22 = $[142];
    const t23 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
        fireExperimentExposure: false
    }) ? undefined : 0;
    const t24 = isDynamicUi ? $36a6ca40a62f0d9d$var$styles.dynamicUiStack : undefined;
    let t25;
    if ($[143] !== cloudId || $[144] !== dynamicUiIframeUrl || $[145] !== emojiProvider || $[146] !== formatMessage || $[147] !== headerImage || $[148] !== iconConfig || $[149] !== imageCreateAction?.data?.title || $[150] !== imageUrl || $[151] !== isDynamicUi || $[152] !== isImageCreate || $[153] !== previewProduct || $[154] !== publishedContentData || $[155] !== resolvedContentType || $[156] !== title) {
        t25 = isDynamicUi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
            src: dynamicUiIframeUrl,
            title: title || formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiPreviewTitle),
            className: (0, $hekY6.default)([
                $36a6ca40a62f0d9d$var$styles.iframe
            ])
        }) : isImageCreate && imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $36a6ca40a62f0d9d$var$styles.imageCreateContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: imageUrl,
            alt: imageCreateAction?.data?.title || "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _3iDTPbvLZJ _00EA0eiObl"
            ])
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $36a6ca40a62f0d9d$var$styles.imageContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: headerImage ?? undefined,
            alt: ""
        }), iconConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $36a6ca40a62f0d9d$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3FVEI.PreviewItemIcon), {
            contentType: resolvedContentType,
            bold: true,
            size: "medium"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            color: "color.link"
        }, publishedContentData?.title ?? title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a0d3180f633dfca4$export$cc11f0bd89960b80), {
            publishedContentData: publishedContentData,
            emojiProvider: emojiProvider,
            product: previewProduct,
            cloudId: cloudId
        }));
        $[143] = cloudId;
        $[144] = dynamicUiIframeUrl;
        $[145] = emojiProvider;
        $[146] = formatMessage;
        $[147] = headerImage;
        $[148] = iconConfig;
        $[149] = imageCreateAction?.data?.title;
        $[150] = imageUrl;
        $[151] = isDynamicUi;
        $[152] = isImageCreate;
        $[153] = previewProduct;
        $[154] = publishedContentData;
        $[155] = resolvedContentType;
        $[156] = title;
        $[157] = t25;
    } else t25 = $[157];
    let t26;
    if ($[158] !== previewProduct) {
        t26 = $36a6ca40a62f0d9d$var$getProductLogo(previewProduct);
        $[158] = previewProduct;
        $[159] = t26;
    } else t26 = $[159];
    let t27;
    if ($[160] !== copiedText || $[161] !== copyText || $[162] !== dynamicUiCopiedDismissKey || $[163] !== isDynamicUi || $[164] !== onDynamicUiCopyClick || $[165] !== showDynamicUiCopied) {
        t27 = isDynamicUi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5a02b2851cabbfe$export$f3a4757df143458e), {
            content: copiedText,
            isVisible: showDynamicUiCopied,
            dismissKey: dynamicUiCopiedDismissKey,
            onDismiss: onDynamicUiCopiedDismiss,
            testId: "conversation-assistant-preview-card.dynamic-ui-copied-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onDynamicUiCopyClick,
            spacing: "compact",
            appearance: "subtle"
        }, copyText));
        $[160] = copiedText;
        $[161] = copyText;
        $[162] = dynamicUiCopiedDismissKey;
        $[163] = isDynamicUi;
        $[164] = onDynamicUiCopyClick;
        $[165] = showDynamicUiCopied;
        $[166] = t27;
    } else t27 = $[166];
    let t28;
    if ($[167] !== copiedText || $[168] !== copyText || $[169] !== imageCopiedDismissKey || $[170] !== imageUrl || $[171] !== isImageCreate || $[172] !== showImageCopied) {
        t28 = isImageCreate && imageUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5a02b2851cabbfe$export$f3a4757df143458e), {
            content: copiedText,
            isVisible: showImageCopied,
            dismissKey: imageCopiedDismissKey,
            onDismiss: onImageCopiedDismiss,
            testId: "conversation-assistant-preview-card.image-copied-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: async ()=>{
                if (imageUrl) {
                    await (0, $6a695435168b8b7b$export$98d1485e4ee43fe8)(imageUrl);
                    setImageCopiedDismissKey($36a6ca40a62f0d9d$var$_temp3);
                    setShowImageCopied(true);
                }
            },
            spacing: "compact",
            appearance: "subtle"
        }, copyText));
        $[167] = copiedText;
        $[168] = copyText;
        $[169] = imageCopiedDismissKey;
        $[170] = imageUrl;
        $[171] = isImageCreate;
        $[172] = showImageCopied;
        $[173] = t28;
    } else t28 = $[173];
    let t29;
    if ($[174] !== cloudId || $[175] !== conversationId || $[176] !== formatMessage || $[177] !== isDefaultPreviewDisabled || $[178] !== isHomePreviewDisabled || $[179] !== isImageCreate || $[180] !== isMauiPreview || $[181] !== isOpenInCurrentTab || $[182] !== isSelected || $[183] !== messageId || $[184] !== onPreviewClick || $[185] !== publishedContentData?.links || $[186] !== shouldOpenPreviewInAtlassianHome) {
        t29 = isSelected || isOpenInCurrentTab() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $36a6ca40a62f0d9d$var$styles.textContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).viewingNow))) : isImageCreate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isDisabled: isDefaultPreviewDisabled,
            onClick: onPreviewClick,
            interactionName: "rovo-aifc-preview-card-click",
            spacing: "compact"
        }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiExpandButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36a6ca40a62f0d9d$var$CustomButtonWithPreviewDefault, {
            defaultButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                isDisabled: isDefaultPreviewDisabled,
                onClick: onPreviewClick,
                interactionName: "rovo-aifc-preview-card-click",
                spacing: "compact"
            }, isMauiPreview ? formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiExpandButton) : formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).previewButton)),
            links: publishedContentData?.links,
            formatMessage: formatMessage,
            conversationId: conversationId,
            shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
            cloudId: cloudId,
            messageId: messageId,
            isPreviewDisabled: isHomePreviewDisabled
        });
        $[174] = cloudId;
        $[175] = conversationId;
        $[176] = formatMessage;
        $[177] = isDefaultPreviewDisabled;
        $[178] = isHomePreviewDisabled;
        $[179] = isImageCreate;
        $[180] = isMauiPreview;
        $[181] = isOpenInCurrentTab;
        $[182] = isSelected;
        $[183] = messageId;
        $[184] = onPreviewClick;
        $[185] = publishedContentData?.links;
        $[186] = shouldOpenPreviewInAtlassianHome;
        $[187] = t29;
    } else t29 = $[187];
    let t30;
    if ($[188] !== t27 || $[189] !== t28 || $[190] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t27, t28, t29);
        $[188] = t27;
        $[189] = t28;
        $[190] = t29;
        $[191] = t30;
    } else t30 = $[191];
    let t31;
    if ($[192] !== t26 || $[193] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center"
        }, t26, t30);
        $[192] = t26;
        $[193] = t30;
        $[194] = t31;
    } else t31 = $[194];
    let t32;
    if ($[195] !== t24 || $[196] !== t25 || $[197] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: t24
        }, t25, t31);
        $[195] = t24;
        $[196] = t25;
        $[197] = t31;
        $[198] = t32;
    } else t32 = $[198];
    let t33;
    if ($[199] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER
        });
        $[199] = t33;
    } else t33 = $[199];
    let t34;
    if ($[200] !== t22 || $[201] !== t23 || $[202] !== t32) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t22,
            tabIndex: t23
        }, t32, t33);
        $[200] = t22;
        $[201] = t23;
        $[202] = t32;
        $[203] = t34;
    } else t34 = $[203];
    return t34;
} : ({ previewProduct: previewProduct, product: // Product of the content which is displayed in the preview card
product, contentType: // Product of where the preview card is being displayed
contentType, title: title, isSelected: isSelected, isEnabled: isEnabled, isLastMessage: isLastMessage, contentId: contentId, emojiProvider: emojiProvider, stagingAreaEnabled: stagingAreaEnabled, fullScreen: fullScreen, conversationId: conversationId, messageId: messageId, status: status, cloudId: cloudId, shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome, resolveActions: resolveActions, resolveAction: resolveAction, invocationId: invocationId, showSuccessFlagOnCreate: showSuccessFlagOnCreate })=>{
    const [showDynamicUiCopied, setShowDynamicUiCopied] = (0, $cozmU.useState)(false);
    const [showImageCopied, setShowImageCopied] = (0, $cozmU.useState)(false);
    const [dynamicUiCopiedDismissKey, setDynamicUiCopiedDismissKey] = (0, $cozmU.useState)(0);
    const [imageCopiedDismissKey, setImageCopiedDismissKey] = (0, $cozmU.useState)(0);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const copyText = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiCopyButton);
    const copiedText = formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiCopied);
    const onDynamicUiCopiedDismiss = (0, $cozmU.useCallback)(()=>setShowDynamicUiCopied(false), []);
    const onImageCopiedDismiss = (0, $cozmU.useCallback)(()=>setShowImageCopied(false), []);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = (0, $cKMeF.useAifcAnalytics)(messageId);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { publishedContentData: publishedContentData } = (0, $7bf1ad9e43134df9$export$59dc636aee1f545e)({
        previewProduct: previewProduct,
        id: contentId,
        cloudId: cloudId,
        includeReactions: contentType === (0, $63fke.ContentType).liveDoc,
        status: status
    }); // Update attributes for the aiMatePreviewCardRender experience
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
            attributes: {
                [(0, $irnO2.PreviewCardRenderStage).CARD_MOUNTED_AT]: performance.now()
            }
        });
    }, [
        experienceTracker
    ]);
    const isNonInstrumentedPreviewBranch = previewProduct === 'jira' || previewProduct === 'jsm' || previewProduct === 'avp';
    (0, $cozmU.useEffect)(()=>{
        if (isNonInstrumentedPreviewBranch) experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
            attributes: {
                [(0, $irnO2.PreviewCardRenderStage).ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT]: performance.now()
            }
        });
    }, [
        isNonInstrumentedPreviewBranch,
        experienceTracker
    ]);
    const { setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, getInvocationIdSelectedForPreview: getInvocationIdSelectedForPreview, getMessageIdSelectedForPreview: getMessageIdSelectedForPreview } = (0, $8akfd.useStagingAreaActions)();
    const { push: push } = (0, $kkLpw.useRouterActions)(); // Stable reference to track whether the Canvas is open or not using global sweet state values
    // stagingAreaEnabled is not a stable reference since the React Context is created for each instance of ConversationAssistant
    const isStagingArea = !!getMessageIdSelectedForPreview() || !!getInvocationIdSelectedForPreview();
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId ?? ''
    });
    const selectedMessageForStatus = (0, $c7So7.findMessageById)(chatMessages, messageId);
    const isMultiCreateEnabled = (0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false);
    const previewStatus = (0, $c7So7.getAIFCActionStatus)(selectedMessageForStatus, isMultiCreateEnabled ? invocationId : undefined); // For published content, resolve the content type from type/subType. For drafts, use contentType directly.
    const resolvedContentType = publishedContentData ? (0, $63fke.getContentTypeFromPublishedContent)(publishedContentData.type, publishedContentData.subType) : contentType;
    const iconConfig = (0, $6ASE9.getPreviewItemIconConfig)(resolvedContentType);
    const headerImage = contentType ? $36a6ca40a62f0d9d$var$getContentToHeaderImage(contentType) : null; // actions used to determine jira and dynamic ui preview flows
    const actions = selectedMessageForStatus?.content.message.message.actions ?? []; // A message can hold multiple creatable actions; resolve the one this card represents by
    // invocationId, falling back to the first action.
    const selectedAction = isMultiCreateEnabled && invocationId && actions.find((action)=>action.invocationId === invocationId) || actions[0]; // actions that have been invoked by the user
    const invokedActions = selectedMessageForStatus?.invokedActions; // The remix/MAUI action this card represents: its own selected action under multi-create, otherwise
    // the first remix action in the message (control path — preserves master for legacy multi-action
    // messages whose remix action isn't first).
    const remixCandidate = isMultiCreateEnabled ? selectedAction : actions.find((0, $aYC8J.isRemixGeneratedFlow));
    const mauiAction = remixCandidate && (0, $aYC8J.isRemixGeneratedFlow)(remixCandidate) ? remixCandidate : null;
    const isDynamicUiAction = mauiAction !== null && (0, $aYC8J.isDynamicUiCreateAction)(mauiAction);
    const dynamicUiUrl = isDynamicUiAction && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? (0, $aYC8J.buildDynamicUiPageUrl)(mauiAction.data) : null;
    const isDynamicUi = !!dynamicUiUrl; // `preview=true` is only added for the iframe so the Copy button still yields a shareable URL.
    const dynamicUiIframeUrl = dynamicUiUrl ? $36a6ca40a62f0d9d$var$appendPreviewParam(dynamicUiUrl) : undefined;
    const isMauiPreview = mauiAction !== null && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    const isOpenInCurrentTab = ()=>{
        if (publishedContentData?.links?.webui && publishedContentData?.links?.base) {
            const { base: base, webui: webui } = publishedContentData.links;
            const linkToOpen = `${base}${webui}`;
            const currentUrl = window.location.href;
            return currentUrl.includes(webui) || currentUrl === linkToOpen;
        }
        return false;
    };
    const isInAtlassianHome = window.location.href.includes('home.atlassian.com') || window.location.href.includes('home.stg.atlassian.com');
    const isDefaultPreviewDisabled = isSelected || isInAtlassianHome && !fullScreen && previewStatus !== 'complete';
    const isHomePreviewDisabled = isDefaultPreviewDisabled || shouldOpenPreviewInAtlassianHome && previewStatus !== 'complete';
    const isJiraCreateAction = (0, $9yffN.isJiraCreatableAction)(selectedAction);
    const isJsmCreateAction = (0, $1uJIC.isJsmCreatableAction)(selectedAction); // The image-create action this card represents; resolved the same way as `mauiAction`.
    const imageCandidate = isMultiCreateEnabled ? selectedAction : actions.find((0, $aYC8J.isImageCreateAction));
    const imageCreateAction = imageCandidate && (0, $aYC8J.isImageCreateAction)(imageCandidate) ? imageCandidate : undefined; // The infographic experiment is per-host-product (cc-maui-experiment on Confluence,
    // jira_maui_remix on Jira). expValEquals remaps via tmp-editor-statsig's global _product,
    // but on rovo chat that global is always 'confluence' (only the Jira editor calls
    // setupEditorExperiments('jira')), so on Jira it read the wrong (Confluence) experiment and
    // the thumbnail stayed blank. Key off the card's own `product` prop instead.
    const isImageCreate = !!imageCreateAction && (0, $cXtTj.default).getExperimentValue(product === 'jira' ? 'jira_maui_remix' : 'cc-maui-experiment', 'isEnabled', false);
    const imageUrl = (0, $b71ee36f98a61401$export$6ac24dc114456b7d)(imageCreateAction?.data.mediaFileId, cloudId);
    const onPreviewClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
            id: messageId,
            timeout: 30000,
            attributes: {
                expectedContentType: contentType
            }
        });
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
            attributes: {
                [(0, $irnO2.PreviewContentStage).STARTED_AT]: performance.now()
            }
        });
        if (invocationId && !(isJiraCreateAction && (0, $iDrrr.fg)('jira_aifc_enabled')) && !(isJsmCreateAction && (0, $iDrrr.fg)('surveys-aifc'))) setInvocationIdSelectedForPreview(invocationId);
        else setMessageIdSelectedForPreview(messageId);
        if (fullScreen && isInAtlassianHome) // If we are in Atlassian home and already fullscreen, render the staging area next to chat
        setStagingAreaMode('inline', 'rovoChatPreviewCard');
        else if (isInAtlassianHome) {
            // If we are in Atlassian home and not already in fullscreen chat, redirect to fullscreen chat and set the staging area to be open
            const path = (0, $dTEBe.addRovoParamsToUrl)('', {
                pathway: 'chat',
                conversationId: conversationId ?? undefined,
                stagingAreaOpen: true,
                messageIdSelectedForPreview: messageId
            });
            push(`/chat${path}`);
        } else if (!stagingAreaEnabled) {
            if (isMauiPreview && contentType !== (0, $63fke.ContentType).slides && contentType !== (0, $63fke.ContentType).database) {
                if (product === 'confluence' && (0, $iDrrr.fg)('remix_product_modal_rovo_chat')) // When in Confluence, open the product-specific AIFC modal so the
                // Ephemeral Preview can stay mounted when the Rovo side chat closes.
                publish({
                    type: 'open-smart-creation-modal',
                    source: 'rovo-chat-preview-card',
                    data: {
                        entryPoint: 'rovoChatPreviewCard',
                        stagingAreaActive: true,
                        isFloating: true,
                        shouldShowBackButton: false
                    }
                });
                else setStagingAreaMode('ephemeralModal', 'rovoChatPreviewCard');
            } else setStagingAreaMode('modal', 'rovoChatPreviewCard');
        }
    }, [
        setMessageIdSelectedForPreview,
        stagingAreaEnabled,
        setStagingAreaMode,
        conversationId,
        fullScreen,
        isInAtlassianHome,
        messageId,
        push,
        experienceTracker,
        contentType,
        invocationId,
        setInvocationIdSelectedForPreview,
        isMauiPreview,
        isJiraCreateAction,
        isJsmCreateAction,
        product,
        publish
    ]);
    const onJiraAifcPreviewClick = (0, $cozmU.useCallback)((e_0)=>{
        sendAifcAnalyticsEvent?.({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsAifcPreviewOpened',
            attributes: {
                itemCount: actions.length,
                // Only available in multiple work item preview card
                isSingleWorkItem: false,
                isStagingArea: isStagingArea
            }
        });
        onPreviewClick(e_0);
    }, [
        onPreviewClick,
        sendAifcAnalyticsEvent,
        isStagingArea,
        actions.length
    ]);
    const onDynamicUiCopyClick = (0, $cozmU.useCallback)(async ()=>{
        if (dynamicUiUrl) {
            await navigator.clipboard.writeText(dynamicUiUrl);
            setDynamicUiCopiedDismissKey((key)=>key + 1);
            setShowDynamicUiCopied(true);
        }
    }, [
        dynamicUiUrl
    ]); // Show the new preview card for Jira when the feature flag is enabled
    if (previewProduct === 'jira') {
        if (resolveActions && actions.length > 0 && isJiraCreateAction) {
            if ((0, $iDrrr.fg)('jira-aifc-migrate-action-renderer')) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                fallbackRender: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                        error: error,
                        name: (0, $irnO2.ExperienceName).JIRA_PREVIEW_CARD_RENDER
                    }), (0, $iDrrr.fg)('rovo_skills_work_item_reliability_ufo') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                        error: error,
                        name: (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2535348f76828a4$export$2ed946042a0386d), {
                        error: error,
                        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
                    }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gHaaj.JiraCreateWithRovoPreviewCard), {
                product: product,
                cloudId: cloudId,
                actions: actions,
                messageId: messageId,
                conversationId: conversationId ?? '',
                invokedActions: invokedActions,
                isSelected: isSelected,
                isEnabled: isEnabled,
                isLastMessage: isLastMessage,
                onPreviewClick: onJiraAifcPreviewClick,
                resolveActions: resolveActions,
                isStagingArea: isStagingArea,
                showSuccessFlagOnCreate: showSuccessFlagOnCreate
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
                name: (0, $irnO2.ExperienceName).JIRA_PREVIEW_CARD_RENDER
            }));
        } else // When the feature gate is disabled, we default to the UI shown for the bulk create action
        return null;
    } // Show the new preview card for JSM when the feature flag is enabled
    if (previewProduct === 'jsm') {
        if (isJsmCreateAction && (0, $iDrrr.fg)('surveys-aifc')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: ({ error: error_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                    error: error_0,
                    name: (0, $irnO2.ExperienceName).JSM_PREVIEW_CARD_RENDER
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d440274b79fd9ad$export$f9f1d2f0dae6d1fb), null))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e115f32805dad23$export$bd9f82fd7df5c3f4), {
            actions: actions,
            resolveAction: resolveAction,
            isSelected: isSelected,
            isEnabled: isEnabled,
            stagingAreaEnabled: stagingAreaEnabled,
            cloudId: cloudId,
            onPreview: onPreviewClick,
            conversationId: conversationId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: (0, $irnO2.ExperienceName).JSM_PREVIEW_CARD_RENDER
        }));
        else return null;
    }
    if (previewProduct === 'avp') {
        if (!(0, $iDrrr.fg)('platform_avp_aifc_enabled')) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $36a6ca40a62f0d9d$var$styles.avpCardContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
            testId: "conversation-assistant-preview-card.avp-dashboard-preview-card",
            previewProductLogo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($itpo2))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: "Dashboard"
            }),
            isSelected: isSelected,
            isEnabled: isEnabled,
            previewHeaderTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium",
                weight: "bold"
            }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).createDashboard)),
            previewContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $36a6ca40a62f0d9d$var$styles.imageContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5210a2d057f0b249$exports))),
                alt: ""
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.link"
            }, title)),
            previewFooterActions: isSelected || isOpenInCurrentTab() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $36a6ca40a62f0d9d$var$styles.textContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest"
            }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).viewingNow))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onPreviewClick,
                interactionName: "rovo-aifc-avp-dashboard-preview-card-click",
                spacing: "compact"
            }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).newPreviewButton))
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($36a6ca40a62f0d9d$var$styles.containerBase, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        isSelected ? $36a6ca40a62f0d9d$var$styles.containerWithBorder : $36a6ca40a62f0d9d$var$styles.containerTransparentBorder, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        isDynamicUi && $36a6ca40a62f0d9d$var$styles.dynamicUiContainer),
        tabIndex: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? undefined : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: isDynamicUi ? $36a6ca40a62f0d9d$var$styles.dynamicUiStack : undefined
    }, isDynamicUi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        src: dynamicUiIframeUrl,
        title: title || formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiPreviewTitle),
        className: (0, $hekY6.default)([
            $36a6ca40a62f0d9d$var$styles.iframe
        ])
    }) : isImageCreate && imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $36a6ca40a62f0d9d$var$styles.imageCreateContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: imageUrl,
        alt: imageCreateAction?.data?.title || '',
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbvLZJ _00EA0eiObl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $36a6ca40a62f0d9d$var$styles.imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: headerImage ?? undefined,
        alt: ""
    }), iconConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $36a6ca40a62f0d9d$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3FVEI.PreviewItemIcon), {
        contentType: resolvedContentType,
        bold: true,
        size: "medium"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "color.link"
    }, publishedContentData?.title ?? title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a0d3180f633dfca4$export$cc11f0bd89960b80), {
        publishedContentData: publishedContentData,
        emojiProvider: emojiProvider,
        product: previewProduct,
        cloudId: cloudId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, $36a6ca40a62f0d9d$var$getProductLogo(previewProduct), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, isDynamicUi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5a02b2851cabbfe$export$f3a4757df143458e), {
        content: copiedText,
        isVisible: showDynamicUiCopied,
        dismissKey: dynamicUiCopiedDismissKey,
        onDismiss: onDynamicUiCopiedDismiss,
        testId: "conversation-assistant-preview-card.dynamic-ui-copied-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onDynamicUiCopyClick,
        spacing: "compact",
        appearance: "subtle"
    }, copyText)), isImageCreate && imageUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5a02b2851cabbfe$export$f3a4757df143458e), {
        content: copiedText,
        isVisible: showImageCopied,
        dismissKey: imageCopiedDismissKey,
        onDismiss: onImageCopiedDismiss,
        testId: "conversation-assistant-preview-card.image-copied-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: async ()=>{
            if (imageUrl) {
                await (0, $6a695435168b8b7b$export$98d1485e4ee43fe8)(imageUrl);
                setImageCopiedDismissKey((key_0)=>key_0 + 1);
                setShowImageCopied(true);
            }
        },
        spacing: "compact",
        appearance: "subtle"
    }, copyText)), isSelected || isOpenInCurrentTab() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $36a6ca40a62f0d9d$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).viewingNow))) : isImageCreate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isDisabled: isDefaultPreviewDisabled,
        onClick: onPreviewClick,
        interactionName: "rovo-aifc-preview-card-click",
        spacing: "compact"
    }, formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiExpandButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36a6ca40a62f0d9d$var$CustomButtonWithPreviewDefault, {
        defaultButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default //Temporary solution - If we are in Atlassian home and the streaming isn't complete, don't allow user to use preview button
        ), {
            isDisabled: isDefaultPreviewDisabled,
            onClick: onPreviewClick,
            interactionName: "rovo-aifc-preview-card-click",
            spacing: "compact"
        }, isMauiPreview ? formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).dynamicUiExpandButton) : formatMessage((0, $40f5cabe6ee4cf1d$export$defe85febe8b728c).previewButton)),
        links: publishedContentData?.links,
        formatMessage: formatMessage,
        conversationId: conversationId,
        shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
        cloudId: cloudId,
        messageId: messageId,
        isPreviewDisabled: isHomePreviewDisabled
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER
    }));
};
function $36a6ca40a62f0d9d$var$_temp(key) {
    return key + 1;
}
function $36a6ca40a62f0d9d$var$_temp2(t0) {
    const { error: error_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
        error: error_0,
        name: (0, $irnO2.ExperienceName).JSM_PREVIEW_CARD_RENDER
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d440274b79fd9ad$export$f9f1d2f0dae6d1fb), null));
}
function $36a6ca40a62f0d9d$var$_temp3(key_0) {
    return key_0 + 1;
}








const $43903f91ff8e3b55$var$getProductFromActionKey = (actionKey)=>{
    if ((0, $9yffN.isJiraCreatableAction)({
        key: actionKey
    })) return 'jira';
    if ((0, $1uJIC.isJsmCreatableAction)({
        key: actionKey
    })) return 'jsm';
    if ((0, $eTCWv.isAvpPreviewCardAction)({
        key: actionKey
    })) return 'avp';
    // Ideally this isn't the default case, but it's a fallback for now
    return 'confluence';
};
const $43903f91ff8e3b55$var$getContentType = (key)=>{
    if ((0, $aYC8J.isConfluencePageCreateAction)({
        key: key
    })) return (0, $63fke.ContentType).liveDoc;
    if (key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY)) return (0, $63fke.ContentType).whiteboard;
    if (key === (0, $aYC8J.CONFLUENCE_AIFC_SLIDES_CREATE_KEY)) return (0, $63fke.ContentType).slides;
    if (key === (0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY)) return (0, $63fke.ContentType).database;
    if (key === (0, $eTCWv.AVP_DASHBOARD_CREATE_KEY)) return (0, $63fke.ContentType).dashboard;
    return null;
};
const $43903f91ff8e3b55$export$d2bfe4874b66b698 = ({ isMultiCreateEnabled: isMultiCreateEnabled, messageId: messageId, messageIdSelectedForPreview: messageIdSelectedForPreview, invocationId: invocationId, invocationIdSelectedForPreview: invocationIdSelectedForPreview, isFirstPreviewCard: isFirstPreviewCard })=>{
    if (!isMultiCreateEnabled) return messageIdSelectedForPreview === messageId || !!invocationIdSelectedForPreview && invocationId === invocationIdSelectedForPreview;
    if (invocationIdSelectedForPreview) return invocationId === invocationIdSelectedForPreview;
    return messageIdSelectedForPreview === messageId && isFirstPreviewCard;
};
const $43903f91ff8e3b55$export$f9e91ba0d3fa2dc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { title: actionTitle, contentId: actionContentId, actionKey: actionKey, messageId: messageId, emojiProvider: emojiProvider, stagingAreaEnabled: stagingAreaEnabled, fullScreen: fullScreen, conversationId: conversationId, status: status, cloudId: cloudId, shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome, isLastMessage: isLastMessage, invocationId: invocationId, resolveActions: resolveActions, resolveAction: resolveAction, product: product, showSuccessFlagOnCreate: showSuccessFlagOnCreate, isFirstPreviewCard: t1 } = t0;
    const isFirstPreviewCard = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== actionKey) {
        t2 = $43903f91ff8e3b55$var$getProductFromActionKey(actionKey);
        $[0] = actionKey;
        $[1] = t2;
    } else t2 = $[1];
    const previewProduct = t2;
    const { messageIdSelectedForPreview: messageIdSelectedForPreview, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const isSmartCreateModalOpen = messageIdSelectedForPreview !== null;
    const isPreviewCardEnabled = !isSmartCreateModalOpen && isLastMessage;
    let t3;
    if ($[2] !== invocationId || $[3] !== invocationIdSelectedForPreview || $[4] !== isFirstPreviewCard || $[5] !== messageId || $[6] !== messageIdSelectedForPreview) {
        const isMultiCreateEnabled = (0, $cXtTj.default).getExperimentValue("cwr-be-based-multi-creation-v0", "isEnabled", false);
        t3 = $43903f91ff8e3b55$export$d2bfe4874b66b698({
            isMultiCreateEnabled: isMultiCreateEnabled,
            messageId: messageId,
            messageIdSelectedForPreview: messageIdSelectedForPreview,
            invocationId: invocationId,
            invocationIdSelectedForPreview: invocationIdSelectedForPreview,
            isFirstPreviewCard: isFirstPreviewCard
        });
        $[2] = invocationId;
        $[3] = invocationIdSelectedForPreview;
        $[4] = isFirstPreviewCard;
        $[5] = messageId;
        $[6] = messageIdSelectedForPreview;
        $[7] = t3;
    } else t3 = $[7];
    const isSelected = t3;
    let t4;
    if ($[8] !== actionKey) {
        t4 = $43903f91ff8e3b55$var$getContentType(actionKey);
        $[8] = actionKey;
        $[9] = t4;
    } else t4 = $[9];
    const t5 = actionTitle ?? "";
    let t6;
    if ($[10] !== actionContentId || $[11] !== cloudId || $[12] !== conversationId || $[13] !== emojiProvider || $[14] !== fullScreen || $[15] !== invocationId || $[16] !== isLastMessage || $[17] !== isPreviewCardEnabled || $[18] !== isSelected || $[19] !== messageId || $[20] !== previewProduct || $[21] !== product || $[22] !== resolveAction || $[23] !== resolveActions || $[24] !== shouldOpenPreviewInAtlassianHome || $[25] !== showSuccessFlagOnCreate || $[26] !== stagingAreaEnabled || $[27] !== status || $[28] !== t4 || $[29] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36a6ca40a62f0d9d$export$740e968d9f8d5dda), {
            previewProduct: previewProduct,
            product: product,
            contentType: t4,
            title: t5,
            isSelected: isSelected,
            isEnabled: isPreviewCardEnabled,
            isLastMessage: isLastMessage,
            contentId: actionContentId,
            emojiProvider: emojiProvider,
            stagingAreaEnabled: stagingAreaEnabled,
            fullScreen: fullScreen,
            conversationId: conversationId,
            messageId: messageId,
            status: status,
            cloudId: cloudId,
            shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
            resolveActions: resolveActions,
            resolveAction: resolveAction,
            invocationId: invocationId,
            showSuccessFlagOnCreate: showSuccessFlagOnCreate
        });
        $[10] = actionContentId;
        $[11] = cloudId;
        $[12] = conversationId;
        $[13] = emojiProvider;
        $[14] = fullScreen;
        $[15] = invocationId;
        $[16] = isLastMessage;
        $[17] = isPreviewCardEnabled;
        $[18] = isSelected;
        $[19] = messageId;
        $[20] = previewProduct;
        $[21] = product;
        $[22] = resolveAction;
        $[23] = resolveActions;
        $[24] = shouldOpenPreviewInAtlassianHome;
        $[25] = showSuccessFlagOnCreate;
        $[26] = stagingAreaEnabled;
        $[27] = status;
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
    } else t6 = $[30];
    return t6;
} : ({ title: actionTitle, contentId: actionContentId, actionKey: actionKey, messageId: messageId, emojiProvider: emojiProvider, stagingAreaEnabled: stagingAreaEnabled, fullScreen: fullScreen, conversationId: conversationId, status: status, cloudId: cloudId, shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome, isLastMessage: isLastMessage, invocationId: invocationId, resolveActions: resolveActions, resolveAction: resolveAction, product: product, showSuccessFlagOnCreate: showSuccessFlagOnCreate, isFirstPreviewCard: isFirstPreviewCard = true })=>{
    const previewProduct = $43903f91ff8e3b55$var$getProductFromActionKey(actionKey);
    const { messageIdSelectedForPreview: messageIdSelectedForPreview, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const isSmartCreateModalOpen = messageIdSelectedForPreview !== null;
    const isPreviewCardEnabled = !isSmartCreateModalOpen && isLastMessage;
    // Selection is conversation-wide (`invocationIdSelectedForPreview` is a single value), so
    // invocationId-based selection must apply whenever the experiment is on, including single-action
    // messages. No-exposure read so this per-render lookup does not log an experiment exposure.
    const isMultiCreateEnabled = (0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false);
    const isSelected = $43903f91ff8e3b55$export$d2bfe4874b66b698({
        isMultiCreateEnabled: isMultiCreateEnabled,
        messageId: messageId,
        messageIdSelectedForPreview: messageIdSelectedForPreview,
        invocationId: invocationId,
        invocationIdSelectedForPreview: invocationIdSelectedForPreview,
        isFirstPreviewCard: isFirstPreviewCard
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36a6ca40a62f0d9d$export$740e968d9f8d5dda), {
        previewProduct: previewProduct,
        product: product,
        contentType: $43903f91ff8e3b55$var$getContentType(actionKey),
        title: actionTitle ?? '',
        isSelected: isSelected,
        isEnabled: isPreviewCardEnabled,
        isLastMessage: isLastMessage,
        contentId: actionContentId,
        emojiProvider: emojiProvider,
        stagingAreaEnabled: stagingAreaEnabled,
        fullScreen: fullScreen,
        conversationId: conversationId,
        messageId: messageId,
        status: status,
        cloudId: cloudId,
        shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
        resolveActions: resolveActions,
        resolveAction: resolveAction,
        invocationId: invocationId,
        showSuccessFlagOnCreate: showSuccessFlagOnCreate
    });
};












var $1IZrU = parcelRequire("1IZrU");

























const $49d1b0849b6e8249$export$1081015aaa7afe97 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(11);
    const { resolveConversationAction: resolveConversationAction } = (0, $3TxKn.useChatStoreActions)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    let t0;
    if ($[0] !== conversation?.id) {
        t0 = !(0, $1IZrU.isEmptyConversation)(conversation?.id) ? conversation?.id : undefined;
        $[0] = conversation?.id;
        $[1] = t0;
    } else t0 = $[1];
    const conversationId = t0;
    let t1;
    if ($[2] !== conversationId || $[3] !== messageId || $[4] !== resolveConversationAction) {
        t1 = (actionKey, actionResolution, invocationId, data)=>resolveConversationAction({
                conversationId: conversationId ?? "",
                messageId: messageId,
                payload: {
                    context: {
                        key: actionKey,
                        invocationId: invocationId,
                        messageId: messageId,
                        data: data,
                        resolution: {
                            type: actionResolution
                        }
                    }
                },
                skipSuccessOptimisticAssistantResponse: true
            });
        $[2] = conversationId;
        $[3] = messageId;
        $[4] = resolveConversationAction;
        $[5] = t1;
    } else t1 = $[5];
    const resolveAction = t1;
    let t2;
    if ($[6] !== resolveAction) {
        t2 = (actionKey_0, actionResolution_0, invocationIds, data_0)=>invocationIds.forEach((invocationId_0)=>resolveAction(actionKey_0, actionResolution_0, invocationId_0, data_0));
        $[6] = resolveAction;
        $[7] = t2;
    } else t2 = $[7];
    const resolveActions = t2;
    let t3;
    if ($[8] !== resolveAction || $[9] !== resolveActions) {
        t3 = {
            resolveAction: resolveAction,
            resolveActions: resolveActions
        };
        $[8] = resolveAction;
        $[9] = resolveActions;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (messageId)=>{
    const { resolveConversationAction: resolveConversationAction } = (0, $3TxKn.useChatStoreActions)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const conversationId = !(0, $1IZrU.isEmptyConversation)(conversation?.id) ? conversation?.id : undefined;
    const resolveAction = (0, $cozmU.useCallback)((actionKey, actionResolution, invocationId, data)=>resolveConversationAction({
            conversationId: conversationId ?? '',
            messageId: messageId,
            payload: {
                context: {
                    key: actionKey,
                    invocationId: invocationId,
                    messageId: messageId,
                    data: data,
                    resolution: {
                        type: actionResolution
                    }
                }
            },
            skipSuccessOptimisticAssistantResponse: true
        }), [
        resolveConversationAction,
        messageId,
        conversationId
    ]);
    const resolveActions = (0, $cozmU.useCallback)((actionKey_0, actionResolution_0, invocationIds, data_0)=>invocationIds.forEach((invocationId_0)=>resolveAction(actionKey_0, actionResolution_0, invocationId_0, data_0)), [
        resolveAction
    ]);
    return {
        resolveAction: resolveAction,
        resolveActions: resolveActions
    };
};


const $0ba42ae6fad3dbe8$var$getLastAssistantMessageId = (messages)=>{
    const assistantMessages = messages?.filter((0, $igOtY.isStoreAssistant));
    const lastAssistantMessage = assistantMessages && assistantMessages.length > 0 ? assistantMessages[assistantMessages.length - 1] : undefined;
    return lastAssistantMessage?.content?.message?.message?.id ?? '';
};
const $0ba42ae6fad3dbe8$var$getJiraLastAssistantCreatableActionMessageId = (messages)=>{
    // We want to get the last message with Jira creatable actions, discarding messages with other types or no actions
    const assistantMessagesWithCreatableActions = messages?.filter((msg)=>{
        if (!(0, $igOtY.isStoreAssistant)(msg)) return false;
        const actions = msg.content?.message?.message?.actions;
        return Boolean(actions?.[0] && (0, $9yffN.isJiraCreatableAction)(actions[0]));
    }) ?? [];
    const lastAssistantMessageWithCreatableActions = assistantMessagesWithCreatableActions && assistantMessagesWithCreatableActions.length > 0 ? assistantMessagesWithCreatableActions[assistantMessagesWithCreatableActions.length - 1] : undefined;
    return lastAssistantMessageWithCreatableActions?.content?.message?.message?.id ?? '';
};
const $0ba42ae6fad3dbe8$export$bfd345d064216d3e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { actions: actions, messageId: messageId, emojiProvider: emojiProvider, cloudId: cloudId, product: product } = t0;
    const { elements: elements, fullScreen: fullScreen, isContentPreviewSupported: isContentPreviewSupported } = (0, $dSCNl.useUIConfig)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    const { bulkResolveConversationUIActions: bulkResolveConversationUIActions } = (0, $3TxKn.useChatStoreActions)();
    const { resolveAction: resolveAction } = (0, $49d1b0849b6e8249$export$1081015aaa7afe97)(messageId);
    let t1;
    let t2;
    if ($[0] !== actions || $[1] !== bulkResolveConversationUIActions || $[2] !== cloudId || $[3] !== conversation?.id || $[4] !== elements?.stagingAreaEnabled || $[5] !== emojiProvider || $[6] !== fullScreen || $[7] !== getMessages || $[8] !== isContentPreviewSupported || $[9] !== messageId || $[10] !== product || $[11] !== resolveAction) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const messages = getMessages(conversation?.id ?? "") ?? [];
            const lastAssistantMessageId = $0ba42ae6fad3dbe8$var$getLastAssistantMessageId(messages);
            const previewableActions = actions.filter($0ba42ae6fad3dbe8$var$_temp);
            let t3;
            if ($[14] !== conversation?.id) {
                t3 = !(0, $1IZrU.isEmptyConversation)(conversation?.id) ? conversation?.id : undefined;
                $[14] = conversation?.id;
                $[15] = t3;
            } else t3 = $[15];
            const conversationId = t3;
            let t4;
            if ($[16] !== isContentPreviewSupported) {
                t4 = !isContentPreviewSupported && !(0, $iDrrr.fg)("aifc_create_enabled");
                $[16] = isContentPreviewSupported;
                $[17] = t4;
            } else t4 = $[17];
            const shouldOpenPreviewInAtlassianHome = t4;
            const jiraPreviewableActions = previewableActions.filter($0ba42ae6fad3dbe8$var$_temp2);
            const jsmPreviewableActions = previewableActions.filter($0ba42ae6fad3dbe8$var$_temp3);
            let t5;
            if ($[18] !== bulkResolveConversationUIActions || $[19] !== conversationId || $[20] !== messageId) {
                t5 = (actionKey, actionResolution, invocationIds, invocationIdToCreatedIssueKey)=>{
                    bulkResolveConversationUIActions({
                        conversationId: conversationId ?? "",
                        messageId: messageId,
                        payloads: invocationIds.map((invocationId)=>({
                                context: {
                                    key: actionKey,
                                    invocationId: invocationId,
                                    messageId: messageId,
                                    data: {
                                        ...invocationIdToCreatedIssueKey ? {
                                            createdIssueKey: invocationIdToCreatedIssueKey[invocationId]
                                        } : {}
                                    },
                                    resolution: {
                                        type: actionResolution
                                    }
                                }
                            })),
                        skipSuccessOptimisticAssistantResponse: true
                    });
                };
                $[18] = bulkResolveConversationUIActions;
                $[19] = conversationId;
                $[20] = messageId;
                $[21] = t5;
            } else t5 = $[21];
            const resolveActions = t5;
            if (jiraPreviewableActions.length > 0) {
                if ((0, $iDrrr.fg)("jira-aifc-migrate-action-renderer")) {
                    let t6;
                    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
                        t6 = [];
                        $[22] = t6;
                    } else t6 = $[22];
                    t2 = t6;
                    break bb0;
                }
                const { key: actionKey_0, status: status, invocationId: invocationId_0, data: data } = jiraPreviewableActions[0];
                const lastAssistantCreatableActionMessageId = $0ba42ae6fad3dbe8$var$getJiraLastAssistantCreatableActionMessageId(messages);
                t2 = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43903f91ff8e3b55$export$f9e91ba0d3fa2dc4), {
                        title: data?.title,
                        contentId: data?.contentId,
                        actionKey: actionKey_0,
                        messageId: messageId,
                        emojiProvider: emojiProvider,
                        stagingAreaEnabled: elements?.stagingAreaEnabled,
                        fullScreen: fullScreen,
                        conversationId: conversationId,
                        status: status,
                        cloudId: cloudId,
                        shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
                        isLastMessage: lastAssistantCreatableActionMessageId === messageId,
                        invocationId: invocationId_0,
                        resolveActions: resolveActions,
                        product: product
                    })
                ];
                break bb0;
            }
            t1 = previewableActions.map((action_2, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43903f91ff8e3b55$export$f9e91ba0d3fa2dc4), {
                    key: action_2.invocationId,
                    isFirstPreviewCard: index === 0,
                    title: action_2?.data?.title,
                    contentId: action_2?.data?.contentId,
                    actionKey: action_2?.key,
                    messageId: messageId,
                    emojiProvider: emojiProvider,
                    stagingAreaEnabled: elements?.stagingAreaEnabled,
                    fullScreen: fullScreen,
                    conversationId: conversationId,
                    status: action_2.status,
                    cloudId: cloudId,
                    shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
                    isLastMessage: lastAssistantMessageId === messageId,
                    invocationId: action_2.invocationId,
                    product: product,
                    resolveAction: jsmPreviewableActions.length > 0 && (0, $iDrrr.fg)("surveys-aifc") ? resolveAction : undefined
                }));
        }
        $[0] = actions;
        $[1] = bulkResolveConversationUIActions;
        $[2] = cloudId;
        $[3] = conversation?.id;
        $[4] = elements?.stagingAreaEnabled;
        $[5] = emojiProvider;
        $[6] = fullScreen;
        $[7] = getMessages;
        $[8] = isContentPreviewSupported;
        $[9] = messageId;
        $[10] = product;
        $[11] = resolveAction;
        $[12] = t1;
        $[13] = t2;
    } else {
        t1 = $[12];
        t2 = $[13];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    const renderedActions = t1;
    return renderedActions;
} : ({ actions: actions, messageId: messageId, emojiProvider: emojiProvider, cloudId: cloudId, product: product })=>{
    const { elements: elements, fullScreen: fullScreen, isContentPreviewSupported: isContentPreviewSupported } = (0, $dSCNl.useUIConfig)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { getMessages: getMessages } = (0, $iW40i.useChatMessagesActions)();
    const { bulkResolveConversationUIActions: bulkResolveConversationUIActions } = (0, $3TxKn.useChatStoreActions)();
    const { resolveAction: resolveAction } = (0, $49d1b0849b6e8249$export$1081015aaa7afe97)(messageId);
    const messages = getMessages(conversation?.id ?? '') ?? [];
    const lastAssistantMessageId = $0ba42ae6fad3dbe8$var$getLastAssistantMessageId(messages);
    // 'preparing' actions are technically previewable, they just render a lot sooner than the content is displayed, so its a weird UX to have a card for something that isn't ready to view yet.
    const previewableActions = actions.filter((action)=>(0, $i7OAD.isPreviewCardAction)(action) && action.status?.toLowerCase() !== 'preparing');
    const conversationId = !(0, $1IZrU.isEmptyConversation)(conversation?.id) ? conversation?.id : undefined;
    // Only use Atlassian Home preview when:
    // 1. content preview is not supported and
    // 2. AIFC is disabled and
    // 3. preview cards are enabled
    const shouldOpenPreviewInAtlassianHome = !isContentPreviewSupported && !(0, $iDrrr.fg)('aifc_create_enabled');
    const jiraPreviewableActions = previewableActions.filter((action_0)=>(0, $9yffN.isJiraPreviewCardAction)({
            key: action_0?.key
        }));
    const jsmPreviewableActions = previewableActions.filter((action_1)=>(0, $1uJIC.isJsmCreatableAction)({
            key: action_1?.key
        }));
    // This Jira-specific resolveActions implementation should be refactored into a generic solution for use by other products.
    // Please deprecate this in favour for a generic implemention from the useResolveActions hook.
    // For further guidance, refer to the comments in the useResolveActions hook.
    const resolveActions = (0, $cozmU.useCallback)((actionKey, actionResolution, invocationIds, invocationIdToCreatedIssueKey)=>{
        bulkResolveConversationUIActions({
            conversationId: conversationId ?? '',
            messageId: messageId,
            payloads: invocationIds.map((invocationId)=>({
                    context: {
                        key: actionKey,
                        invocationId: invocationId,
                        messageId: messageId,
                        data: {
                            ...invocationIdToCreatedIssueKey ? {
                                createdIssueKey: invocationIdToCreatedIssueKey[invocationId]
                            } : {}
                        },
                        resolution: {
                            type: actionResolution
                        }
                    }
                })),
            skipSuccessOptimisticAssistantResponse: true
        });
    }, [
        bulkResolveConversationUIActions,
        conversationId,
        messageId
    ]);
    // We need some custom handling of the Jira actions here since we want to show a single card
    // for multiple actions.
    if (jiraPreviewableActions.length > 0) {
        if ((0, $iDrrr.fg)('jira-aifc-migrate-action-renderer')) // When this flag is on, we want to use the non-streaming action renderer.
        return [];
        const { key: actionKey_0, status: status, invocationId: invocationId_0, data: data } = jiraPreviewableActions[0];
        const lastAssistantCreatableActionMessageId = $0ba42ae6fad3dbe8$var$getJiraLastAssistantCreatableActionMessageId(messages);
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43903f91ff8e3b55$export$f9e91ba0d3fa2dc4), {
                title: data?.title,
                contentId: data?.contentId,
                actionKey: actionKey_0,
                messageId: messageId,
                emojiProvider: emojiProvider,
                stagingAreaEnabled: elements?.stagingAreaEnabled,
                fullScreen: fullScreen,
                conversationId: conversationId,
                status: status,
                cloudId: cloudId,
                shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
                isLastMessage: lastAssistantCreatableActionMessageId === messageId,
                invocationId: invocationId_0,
                resolveActions: resolveActions,
                product: product
            })
        ];
    }
    const renderedActions = previewableActions.map((action_2, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43903f91ff8e3b55$export$f9e91ba0d3fa2dc4), {
            key: action_2.invocationId,
            isFirstPreviewCard: index === 0,
            title: action_2?.data?.title,
            contentId: action_2?.data?.contentId,
            actionKey: action_2?.key,
            messageId: messageId,
            emojiProvider: emojiProvider,
            stagingAreaEnabled: elements?.stagingAreaEnabled,
            fullScreen: fullScreen,
            conversationId: conversationId,
            status: action_2.status,
            cloudId: cloudId,
            shouldOpenPreviewInAtlassianHome: shouldOpenPreviewInAtlassianHome,
            isLastMessage: lastAssistantMessageId === messageId,
            invocationId: action_2.invocationId,
            product: product,
            resolveAction: jsmPreviewableActions.length > 0 && (0, $iDrrr.fg)('surveys-aifc') ? resolveAction : undefined
        });
    });
    return renderedActions;
};
function $0ba42ae6fad3dbe8$var$_temp(action) {
    return (0, $i7OAD.isPreviewCardAction)(action) && action.status?.toLowerCase() !== "preparing";
}
function $0ba42ae6fad3dbe8$var$_temp2(action_0) {
    return (0, $9yffN.isJiraPreviewCardAction)({
        key: action_0?.key
    });
}
function $0ba42ae6fad3dbe8$var$_temp3(action_1) {
    return (0, $1uJIC.isJsmCreatableAction)({
        key: action_1?.key
    });
}





const $232a2fb9697f0bdd$var$message = (0, $kSwu1.defineMessages)({
    sourcesTitle: {
        id: "rovo-chat.store-assistant.sources-title",
        defaultMessage: "Sources:"
    },
    betaFeaturesMessage: {
        id: "rovo-chat.store-assistant.beta-features-message",
        defaultMessage: "The answer provided utilizes BETA features."
    },
    betaLozenge: {
        id: "rovo-chat.store-assistant.beta-lozenge",
        defaultMessage: "BETA"
    },
    snapshotActionPlaceholder: {
        id: "rovo-chat.store-assistant.snapshot-action-placeholder",
        defaultMessage: "Action unavailable in shared conversation"
    }
});
var $232a2fb9697f0bdd$export$2e2bcd8739ae039 = $232a2fb9697f0bdd$var$message;



var $6j4UZ = parcelRequire("6j4UZ");


var $b6ezN = parcelRequire("b6ezN");


const $d0b8d0ec473bba39$var$CsatSurvey = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("irMkX")).then((m)=>({
            default: m.CsatSurvey
        })));
const $d0b8d0ec473bba39$var$CONFLUENCE_SUGGESTION_KEY = 'Confluence-Suggestion-Plugin';
const $d0b8d0ec473bba39$var$CODE_SEARCH_PLUGIN_KEY = 'Code-Search-Plugin';
const $d0b8d0ec473bba39$var$ROVO_SPACES_DETAILED_FEEDBACK_SOURCE = 'rovo-spaces-v2-detailed';
const $d0b8d0ec473bba39$var$canWriteRichTextToClipboard = (html)=>!!html && typeof ClipboardItem !== 'undefined' && typeof navigator?.clipboard?.write === 'function';
const $d0b8d0ec473bba39$var$writeRichTextToClipboard = async (html, plain)=>{
    await navigator.clipboard.write([
        new ClipboardItem({
            'text/html': new Blob([
                html
            ], {
                type: 'text/html'
            }),
            'text/plain': new Blob([
                plain
            ], {
                type: 'text/plain'
            })
        })
    ]);
};
const $d0b8d0ec473bba39$var$getRovoChatBridgeProduct = (mode, isFullScreen)=>isFullScreen ? 'rovo-chat.fullscreen' : `rovo-chat.${mode ?? (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR}`;
const $d0b8d0ec473bba39$var$RovoXpcSmartCardProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { mode: mode, fullScreen: fullScreen, children: children } = t0;
    const smartLinkContext = (0, $cMyWi.useSmartLinkContext)();
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    let t1;
    if ($[0] !== fullScreen || $[1] !== mode) {
        t1 = $d0b8d0ec473bba39$var$getRovoChatBridgeProduct(mode, fullScreen);
        $[0] = fullScreen;
        $[1] = mode;
        $[2] = t1;
    } else t1 = $[2];
    const bridgeProduct = t1;
    const xpcProduct = smartLinkContext.xpcProduct || productKey;
    const { xpcSubProduct: xpcSubProduct } = smartLinkContext;
    let t2;
    if ($[3] !== bridgeProduct || $[4] !== smartLinkContext || $[5] !== xpcProduct || $[6] !== xpcSubProduct) {
        t2 = {
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
        $[3] = bridgeProduct;
        $[4] = smartLinkContext;
        $[5] = xpcProduct;
        $[6] = xpcSubProduct;
        $[7] = t2;
    } else t2 = $[7];
    const smartCardContextValue = t2;
    const t3 = xpcProduct ?? "";
    const t4 = xpcSubProduct ?? "";
    let t5;
    if ($[8] !== bridgeProduct || $[9] !== t3 || $[10] !== t4) {
        t5 = [
            bridgeProduct,
            t3,
            t4
        ];
        $[8] = bridgeProduct;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const smartCardIdentityKey = t5.join(":");
    let t6;
    if ($[12] !== children || $[13] !== smartCardContextValue || $[14] !== smartCardIdentityKey) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
            key: smartCardIdentityKey,
            value: smartCardContextValue
        }, children);
        $[12] = children;
        $[13] = smartCardContextValue;
        $[14] = smartCardIdentityKey;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ mode: mode, fullScreen: fullScreen, children: children })=>{
    const smartLinkContext = (0, $cMyWi.useSmartLinkContext)();
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    const bridgeProduct = $d0b8d0ec473bba39$var$getRovoChatBridgeProduct(mode, fullScreen);
    const xpcProduct = smartLinkContext.xpcProduct || productKey;
    const { xpcSubProduct: xpcSubProduct } = smartLinkContext;
    const smartCardContextValue = (0, $cozmU.useMemo)(()=>({
            ...smartLinkContext,
            bridgeProduct: bridgeProduct,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        }), [
        smartLinkContext,
        bridgeProduct,
        xpcProduct,
        xpcSubProduct
    ]); // Remount the card subtree if the bridge identity changes (e.g. mode flips
    // from sidebar to mini-modal), so any URL wrapped against a stale bridge is
    // re-wrapped against the correct one.
    const smartCardIdentityKey = [
        bridgeProduct,
        xpcProduct ?? '',
        xpcSubProduct ?? ''
    ].join(':');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
        key: smartCardIdentityKey,
        value: smartCardContextValue
    }, children);
};
const $d0b8d0ec473bba39$var$writePlainTextToClipboard = async (text)=>{
    if (typeof navigator?.clipboard?.writeText !== 'function') return;
    await navigator.clipboard.writeText(text);
};
const $d0b8d0ec473bba39$var$styles = {
    responseCard: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    responseContent: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    legacyActionsWrapper: "_46hvQm2ADO",
    snapshotActionPlaceholder: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _46hvQmgVvo _03SyCP8HPE _0xmtkogVvo _0LQT5E8HPE",
    betaLabel: "_3YEZNOdnbC _2xTnZx2ADO",
    betaLabelWrapper: "_0bjKvD0RdW _43nrzT5zaO _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNO7dHp"
};
const $d0b8d0ec473bba39$var$BetaMessageLabel = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $232a2fb9697f0bdd$export$2e2bcd8739ae039).betaLozenge);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d0b8d0ec473bba39$var$styles.betaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, t0));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $232a2fb9697f0bdd$export$2e2bcd8739ae039).betaFeaturesMessage);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            backgroundColor: "color.background.neutral",
            paddingBlock: "space.100",
            paddingInline: "space.200",
            xcss: $d0b8d0ec473bba39$var$styles.betaLabelWrapper
        }, t1, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.neutral",
        paddingBlock: "space.100",
        paddingInline: "space.200",
        xcss: $d0b8d0ec473bba39$var$styles.betaLabelWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d0b8d0ec473bba39$var$styles.betaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, formatMessage((0, $232a2fb9697f0bdd$export$2e2bcd8739ae039).betaLozenge))), formatMessage((0, $232a2fb9697f0bdd$export$2e2bcd8739ae039).betaFeaturesMessage));
});
const $d0b8d0ec473bba39$var$InsightExtensionWithLayoutContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const t0 = Boolean(fullScreen);
    let t1;
    if ($[0] !== props || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1af56b3b70a9c0c4$export$3dcb0b7fce7438b4), {
            ...props,
            isFullScreen: t0
        });
        $[0] = props;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1af56b3b70a9c0c4$export$3dcb0b7fce7438b4), {
        ...props,
        isFullScreen: Boolean(fullScreen)
    });
};
const $d0b8d0ec473bba39$export$246e01ccfb2a99f0 = /*#__PURE__*/ (0, $cozmU.memo)(({ storeAssistant: storeAssistant, previousAssistantAuthor: previousAssistantAuthor, isConversationActivelyGenerating: isConversationActivelyGenerating = false, thinkingIndicatorHasHandedOff: thinkingIndicatorHasHandedOff = true, suppressInternalResponseHat: suppressInternalResponseHat = false, onAuthLinkClicked: onAuthLinkClicked, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode, mode: mode, product: product, isLastMessage: isLastMessage, isLastActionMessage: isLastActionMessage })=>{
    (0, $6cFsl.di)((0, $2knbJ.useIsMessageFeedbackSent), (0, $iDrrr.fg), (0, $5wAPd.useConversation), (0, $b6ezN.useResponseHatState), (0, $bGNkz.useSelectedSpaceSelector), (0, $5l24t.useFeedbackV2));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { elements: elements, customHandlers: customHandlers, isContentPreviewSupported: isContentPreviewSupported, fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)(); // TODO: implement getters for these values
    const { content: { message: assistantResponse, streamingComplete: streamingComplete = true, type: messageType }, invokedActions: invokedActions, markdownData: storeMarkdownData } = storeAssistant;
    const { message: { content: content, conversation_channel_id: conversationId, actions: actions, id: agentMessageId, sources: sources, plugin_invocations: plugin_invocations, jira_activation_id: jiraActivationId, insertable_sections: insertableSections, authority_ui_metadata: topLevelAuthorityUiMetadata, message_metadata: messageMetadata } } = assistantResponse; // authority_ui_metadata is at the top level for streaming responses, but
    // nested under message_metadata for history responses.
    const authorityUiMetadata = topLevelAuthorityUiMetadata ?? messageMetadata?.authority_ui_metadata;
    if ((0, $iDrrr.fg)('rovo_chat_jira_nl_to_jql_minion_in_fe')) //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $ed2d12262b5cb709$export$d5af5083a0a9452f)(plugin_invocations);
    const { profileData: { aaid: aaid, name: name, email: email }, feedbackCollector: { entryPointId: entryPointId }, productKey: productKey, siteId: siteId, orgId: orgId, emojiProvider: emojiProvider, assistanceServiceConfig: assistanceServiceConfig, experienceId: experienceId, productHeader: productHeader } = (0, $eKjv9.useGlobalConfig)();
    const { setAuth: setAuth } = (0, $2429E.useCurrentActionAuthActions)();
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    const feedbackTrigger = (0, $3Ofxv.useFeedbackTrigger)();
    const xpcWrapUrl = (0, $SJycm.useXpcLinkWrapper)();
    const detailedFeedbackSource = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) && (selectedSpace?.id || conversation?.rovoSpaceId) ? $d0b8d0ec473bba39$var$ROVO_SPACES_DETAILED_FEEDBACK_SOURCE : undefined;
    const { openModal: openDataSculptorModal } = (0, $fbed1930e790305e$export$af21e4ef6e16e2cc)();
    const { openModal: openAgentDebugModal } = (0, $c6b118eef4adaf4b$export$608e161d688d66c0)();
    const renderedContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null); /**
                                                                  * ⚠️ Technical debt: Confluence suggestion actions are currently handled in a special way.
                                                                  * it was built as an action, and actions are intended to render with their own components or
                                                                  * default to a Confirm/Cancel button, all of which will hit the action execution endpoint
                                                                  * to keep the BE service updated on what happens.
                                                                  *
                                                                  * This has since changed to simply prefering the InsertReplaceButton to handle the confluence
                                                                  * suggested content, and it does not need to phone home when actioned.
                                                                  *
                                                                  * We assume that when Confluence-Suggestion-Plugin is used, it will be the only action in the array.
                                                                  * Reference: https://atlassian.slack.com/archives/C06PKQPN8BF/p1723595459892209?thread_ts=1723419814.967079&cid=C06PKQPN8BF
                                                                  */ 
    const { filteredActions: filteredActions, insertReplaceContent: insertReplaceContent, suggestionContent: suggestionContent, plainTextClipboardContent: plainTextClipboardContent } = (0, $cozmU.useMemo)(()=>{
        const confluenceEditorAction = actions?.find((action)=>action.key === $d0b8d0ec473bba39$var$CONFLUENCE_SUGGESTION_KEY);
        const filteredActions = actions?.filter((action)=>action.key !== $d0b8d0ec473bba39$var$CONFLUENCE_SUGGESTION_KEY);
        const suggestionContent = confluenceEditorAction?.data.content ?? '';
        let insertReplaceContent = confluenceEditorAction?.data.content ?? content;
        let plainTextClipboardContent = content?.toString(); // When the BE provides insertable_sections indices, slice only those
        // portions of the content for the "Insert to page" button.
        // Falls back to the full content when insertable_sections is absent or empty.
        const insertSectionsEnabled = (0, $ieeJu.expValEquals)('cc_ai_insert_to_page_rovo_chat_experiment', 'isEnabled', true);
        if (insertSectionsEnabled && !confluenceEditorAction && typeof content === 'string') insertReplaceContent = (0, $848797c72628a22c$export$84202b743b23a95b)(content, insertableSections);
         // Append sources to clipboard content
        if (sources) {
            const { result: contentResult, sourcesString: contentSourcesString } = (0, $63e594faf9bc5df0$export$5e6cca1a888b7324)(content?.toString() ?? '', sources);
            plainTextClipboardContent = `${contentResult}\n\n${formatMessage((0, $232a2fb9697f0bdd$export$2e2bcd8739ae039).sourcesTitle)}\n\n${contentSourcesString}`;
        }
        return {
            filteredActions: filteredActions,
            insertReplaceContent: insertReplaceContent,
            suggestionContent: suggestionContent,
            plainTextClipboardContent: plainTextClipboardContent
        };
    }, [
        actions,
        content,
        sources,
        formatMessage,
        insertableSections
    ]);
    const hasAnswerContent = Boolean(content?.toString().trim());
    const hasAutoInsertedContent = (0, $cozmU.useMemo)(()=>{
        return filteredActions?.some((action)=>(0, $i7OAD.isSupportedStreamAction)({
                key: action.key
            }));
    }, [
        filteredActions
    ]); // Hide thumbs up/down & copy footer for ask-question, plan-complete, or
    // tool-source actions rendered as a permission confirmation block.
    const shouldHideFooterButtons = (0, $cozmU.useMemo)(()=>{
        return filteredActions?.some((action)=>(0, $i7OAD.isActionHidingFooterButtons)({
                key: action.key
            })) || !!filteredActions?.length && filteredActions.every((action)=>Boolean(action.toolSource)) || // Mirror pre-stream stop behavior for cancelled page-stream turns.
        conversation?.lastAgentMessageStatus === 'CANCELLED' && hasAutoInsertedContent && (0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true);
    }, [
        conversation?.lastAgentMessageStatus,
        hasAutoInsertedContent,
        filteredActions
    ]);
    const shouldRenderLLMContent = (0, $cozmU.useMemo)(()=>{
        return !filteredActions?.some((0, $637t4.shouldNotRenderLLMContentForAction));
    }, [
        filteredActions
    ]);
    const assistantResponseMessage = (0, $cozmU.useMemo)(()=>{
        if (!suggestionContent?.length) return assistantResponse.message;
        return {
            ...assistantResponse.message,
            content: (0, $6rwn6.appendContent)(content, `---\n\n ${suggestionContent}`)
        };
    }, [
        suggestionContent,
        assistantResponse.message,
        content
    ]);
    const shouldShowBetaLabel = (0, $cozmU.useMemo)(()=>{
        return assistantResponse.message.plugin_invocations?.some((plugin)=>{
            return plugin.plugin_name === $d0b8d0ec473bba39$var$CODE_SEARCH_PLUGIN_KEY;
        });
    }, [
        assistantResponse.message.plugin_invocations
    ]);
    const { selectedAgent: selectedAgent } = (0, $5wAPd.useConversation)({
        conversationId: conversationId
    });
    const shouldEnableAgentResponseHat = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const assistanceServiceParams = (0, $cozmU.useMemo)(()=>({
            baseUrl: assistanceServiceConfig?.baseUrl,
            headers: assistanceServiceConfig?.headers,
            channelId: assistanceServiceConfig?.channelId,
            experienceId: experienceId,
            product: productHeader,
            siteId: siteId,
            touchpointSource: productHeader
        }), [
        assistanceServiceConfig?.baseUrl,
        assistanceServiceConfig?.headers,
        assistanceServiceConfig?.channelId,
        experienceId,
        productHeader,
        siteId
    ]);
    const { resolveConversationAction: resolveConversationAction } = (0, $3TxKn.useChatStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const messageActivelyStreaming = (0, $cozmU.useMemo)(()=>{
        return messageType === 'FINAL_RESPONSE' && !streamingComplete;
    }, [
        streamingComplete,
        messageType
    ]);
    const { shouldRender: shouldRenderAgentResponseHatFromState, isDefaultRovo: isResponseAuthorDefaultRovo, identityAccountId: responseHatAgentIdentityAccountId, isHydrating: isResponseAuthorIdentityHydrating } = (0, $b6ezN.useResponseHatState)({
        storeAssistant: storeAssistant,
        previousAssistantAuthor: previousAssistantAuthor,
        shouldEnableAgentResponseHat: shouldEnableAgentResponseHat,
        canRenderAfterThinking: Boolean(thinkingIndicatorHasHandedOff),
        isConversationActivelyGenerating: Boolean(isConversationActivelyGenerating),
        hasAnswerContent: hasAnswerContent,
        assistanceServiceParams: assistanceServiceParams
    });
    const shouldRenderAgentResponseHat = shouldRenderAgentResponseHatFromState && !suppressInternalResponseHat;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (messageActivelyStreaming) (0, $4tJut.interactionMetrics).timeToRenderFinalResponse.start();
        else (0, $4tJut.interactionMetrics).timeToRenderFinalResponse.stop();
    }, [
        messageActivelyStreaming
    ]);
    (0, $2knbJ.useIsMessageFeedbackSent)(agentMessageId);
    const { preferences: { hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt }, setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: storeUserMessages, setStoreUserMessages: setStoreUserMessages } = (0, $hSR6U.useStoreUserMessagesPreference)({
        assistanceServiceParams: assistanceServiceParams
    });
    const [isHarmfulContentModalOpen, setIsHarmfulContentModalOpen] = (0, $cozmU.useState)(false);
    const [, setIsAupFeedbackSent] = (0, $cozmU.useState)(false);
    const analyticsMessageActions = (0, $cozmU.useMemo)(()=>{
        return assistantResponse.message.actions?.map((action)=>action.key);
    }, [
        assistantResponse.message.actions
    ]);
    const interactionModeExecuted = (0, $bFeyZ.getInteractionModeExecutedFromStoreAssistant)(storeAssistant);
    const onLuminaInteraction = (0, $cozmU.useCallback)((interaction)=>{
        if (!(0, $iDrrr.fg)('rovo_chat_lumina_component_interaction_tracking')) return;
        const luminaInteractionType = (0, $5ae6fc04f9da25b5$export$41890f70bc41601f)(interaction);
        if (!luminaInteractionType) return;
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'luminaComponentInteracted',
            proactive: false,
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            attributes: {
                luminaInteractionType: luminaInteractionType,
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        agentMessageId,
        analyticsMessageActions,
        interactionModeExecuted,
        trackAIMAUEvent
    ]);
    const gatedOnLuminaInteraction = (0, $iDrrr.fg)('rovo_chat_lumina_component_interaction_tracking') ? onLuminaInteraction : undefined;
    const { registerCopy: registerCopy } = (0, $2a049f27e8be6707$export$f018dffa6c2a806a)();
    const history = (0, $4JJQd.useMessageHistory)({
        canAttachMessages: true,
        answerId: storeAssistant.content.message.message.id
    });
    const thumbTriggerRef = (0, $cozmU.useRef)(null);
    const { feedbackType: feedbackTypeV2, isBannerVisible: isBannerVisible, handleThumbClick: handleV2ThumbClick, handleCsatFeedback: handleCsatFeedback, restartAutoDismiss: restartAutoDismiss, pauseAutoDismiss: pauseAutoDismiss, csatRating: submittedCsatRating, handleProvideAdditionalFeedback: handleProvideAdditionalFeedback, handleFeedbackSubmit: handleFeedbackSubmit, handleDismissBanner: handleDismissBanner, handleIncludeMessagesChecked: handleIncludeMessagesChecked, handleOptIn: handleOptIn, isOptedIn: isOptedIn } = (0, $5l24t.useFeedbackV2)({
        entryPointId: entryPointId,
        aaid: aaid ?? 'unknown',
        name: name,
        email: email,
        productKey: productKey,
        stagingAreaEnabled: elements?.stagingAreaEnabled,
        agentMessageId: agentMessageId,
        messageRequestId: storeAssistant.content.metadata?.request_id,
        interactionModeExecuted: interactionModeExecuted,
        conversationId: conversationId,
        selectedAgent: selectedAgent,
        history: history,
        analyticsMessageActions: analyticsMessageActions,
        minionAlias: assistanceServiceConfig?.minionAlias,
        channelId: assistanceServiceConfig?.channelId,
        storeUserMessages: storeUserMessages,
        siteId: siteId,
        experienceId: experienceId,
        productHeader: productHeader,
        setStoreUserMessages: setStoreUserMessages,
        detailedFeedbackSource: detailedFeedbackSource,
        feedbackTrigger: feedbackTrigger
    });
    const onAupFeedbackSubmitted = ()=>{
        setIsAupFeedbackSent(true);
    };
    const feedbackMetadata = {
        aaid: aaid ?? 'unknown',
        answerQuality: 'bad',
        entryPointId: entryPointId,
        assistantResponseId: storeAssistant.content.message.message.id,
        origin: (0, $aiNUD.getCurrentOrigin)(),
        history: history,
        feedbackSource: (0, $iDrrr.fg)('aifc_create_enabled') ? `${productKey}-v1${elements?.stagingAreaEnabled ? '-staging' : ''}` : 'errorMessageFeedback',
        isAupFeedback: true
    };
    const onThumbClick = (isLike)=>{
        thumbTriggerRef.current = document.activeElement;
        handleV2ThumbClick(isLike);
    };
    const { csatRating: csatRating, handleSelectRating: handleSelectRating, handleCsatSubmit: handleCsatSubmit, handleCsatDismiss: handleCsatDismiss, isCsatSurveyVisible: isCsatSurveyVisible, csatFlowUsedThisTurn: csatFlowUsedThisTurn, recordResolvedLayout: recordResolvedLayout } = (0, $1268d21d92b61d24$export$79e5625152e2c837)({
        storeAssistant: storeAssistant,
        assistantResponse: assistantResponse,
        invokedActions: invokedActions,
        filteredActions: filteredActions,
        feedbackTypeV2: feedbackTypeV2,
        streamingComplete: streamingComplete,
        shouldHideFooterButtons: shouldHideFooterButtons,
        isConversationActivelyGenerating: isConversationActivelyGenerating,
        conversationId: conversationId ?? '',
        agentMessageId: agentMessageId,
        handleCsatFeedback: handleCsatFeedback
    });
    const onCopyClick = (0, $cozmU.useCallback)(async ()=>{
        const gateOn = (0, $iDrrr.fg)('kd_lumina_copy_response_as_adf');
        let node = null;
        if (renderedContentRef.current && streamingComplete) node = renderedContentRef.current;
         // Choose which HTML/plain pair to put in the clipboard. Mid-stream gated
        // content is intentionally plain-text-only so we don't paste a
        // partial/malformed structured payload.
        let clipboardHtml;
        let clipboardPlain = plainTextClipboardContent;
        if (gateOn && streamingComplete) {
            const payload = (0, $9c699046e74af916$export$6f1bc251cc9b5a57)(content, storeMarkdownData);
            clipboardHtml = payload.html;
            clipboardPlain = payload.plain.includes('[^lumina') ? plainTextClipboardContent : payload.plain;
        } else if (!gateOn && node) clipboardHtml = node.innerHTML;
        try {
            if ($d0b8d0ec473bba39$var$canWriteRichTextToClipboard(clipboardHtml)) await $d0b8d0ec473bba39$var$writeRichTextToClipboard(clipboardHtml, clipboardPlain);
            else await $d0b8d0ec473bba39$var$writePlainTextToClipboard(clipboardPlain);
        } catch  {
            await $d0b8d0ec473bba39$var$writePlainTextToClipboard(clipboardPlain);
        }
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'copyButtonClicked',
            proactive: false,
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
        registerCopy({
            messageId: agentMessageId,
            analyticsMessageActions: analyticsMessageActions,
            trackAIMAUEvent: trackAIMAUEvent,
            interactionModeExecuted: interactionModeExecuted
        });
    }, [
        trackAIMAUEvent,
        agentMessageId,
        analyticsMessageActions,
        renderedContentRef,
        streamingComplete,
        plainTextClipboardContent,
        registerCopy,
        content,
        storeMarkdownData,
        interactionModeExecuted
    ]);
    const onContentSelected = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'selected',
            actionSubject: 'content',
            actionSubjectId: 'assistantResponse'
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onAuthorityPanelShown = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent((0, $fhQlP.buildAuthoritativeAnswerPanelShownEvent)({
            product: 'chat',
            correlationAttributes: {
                conversationId: conversationId,
                messageId: agentMessageId
            },
            authorityUiMetadata: authorityUiMetadata
        }));
    }, [
        sendAnalyticsEvent,
        conversationId,
        agentMessageId,
        authorityUiMetadata
    ]); // Reuses the shared `sourceLink` event; `clickOrigin` distinguishes these
    // clicks from the regular sources popup, which fires the same event.
    const onAuthorityLinkClicked = (0, $cozmU.useCallback)((linkType)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sourceLink',
            attributes: {
                linkType: linkType,
                clickOrigin: 'authoritativeAnswerPanel',
                conversationId: conversationId,
                messageId: agentMessageId,
                ...(0, $fhQlP.getAuthorityAttributes)(authorityUiMetadata)
            }
        }); // `actioned` credits the click towards Chat's success metric (CSR).
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'sourceLinkClicked',
            proactive: false,
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            attributes: {
                clickOrigin: 'authoritativeAnswerPanel',
                linkType: linkType,
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        sendAnalyticsEvent,
        conversationId,
        agentMessageId,
        authorityUiMetadata,
        trackAIMAUEvent,
        analyticsMessageActions,
        interactionModeExecuted
    ]);
    const onContentCopied = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'copied',
            actionSubject: 'content',
            actionSubjectId: 'assistantResponse'
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'copy',
            proactive: false,
            subjectId: 'assistantResponse',
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
        registerCopy({
            messageId: agentMessageId,
            analyticsMessageActions: analyticsMessageActions,
            trackAIMAUEvent: trackAIMAUEvent,
            interactionModeExecuted: interactionModeExecuted
        });
    }, [
        sendAnalyticsEvent,
        trackAIMAUEvent,
        agentMessageId,
        analyticsMessageActions,
        registerCopy,
        interactionModeExecuted
    ]);
    const onCodeBlockCopied = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'copied',
            actionSubject: 'content',
            actionSubjectId: 'assistantResponseCodeBlock'
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'codeblockCopied',
            proactive: false,
            subjectId: 'assistantResponseCodeBlock',
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
        registerCopy({
            messageId: agentMessageId,
            analyticsMessageActions: analyticsMessageActions,
            trackAIMAUEvent: trackAIMAUEvent,
            interactionModeExecuted: interactionModeExecuted
        });
    }, [
        sendAnalyticsEvent,
        trackAIMAUEvent,
        agentMessageId,
        analyticsMessageActions,
        registerCopy,
        interactionModeExecuted
    ]);
    const onClickSource = (0, $cozmU.useCallback)((_, citedProduct, product)=>{
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'sourceLinkClicked',
            proactive: false,
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            citedProduct: citedProduct,
            sourceProduct: product,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        trackAIMAUEvent,
        agentMessageId,
        analyticsMessageActions,
        interactionModeExecuted
    ]);
    const onClickResponseLink = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'responseLink'
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'responseLinkClicked',
            proactive: false,
            subjectId: 'responseLink',
            messageId: agentMessageId,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        trackAIMAUEvent,
        agentMessageId,
        sendAnalyticsEvent,
        interactionModeExecuted
    ]);
    const onClickSmartCard = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'smartCardLink'
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'smartCardClicked',
            proactive: false,
            subjectId: 'smartCardLink',
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        agentMessageId,
        sendAnalyticsEvent,
        trackAIMAUEvent,
        interactionModeExecuted
    ]);
    const onClickCitation = (0, $cozmU.useCallback)((_, citedProduct, product)=>{
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'citationClicked',
            proactive: false,
            subjectId: 'citationLink',
            singleInstrumentationID: agentMessageId,
            citedProduct: citedProduct,
            sourceProduct: product,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        agentMessageId,
        trackAIMAUEvent,
        interactionModeExecuted
    ]);
    const onClickInsertReplace = (0, $cozmU.useCallback)((mode)=>{
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: mode,
            subjectId: 'insertReplaceButton',
            proactive: false,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        agentMessageId,
        trackAIMAUEvent,
        interactionModeExecuted
    ]);
    const onAuthLinkClick = (0, $cozmU.useCallback)((url, authType)=>{
        setAuth({
            url: url,
            authType: authType,
            agentMessageId: agentMessageId
        });
        onAuthLinkClicked?.(authType);
    }, [
        onAuthLinkClicked,
        setAuth,
        agentMessageId
    ]);
    const { fireUiActionedAnalytics: fireUiActionedAnalytics, fireAIMAUActionedAnalytics: fireAIMAUActionedAnalytics } = (0, $4ee1h.useMessageActionedAnalytics)();
    const { getActionRenderer: getActionRenderer } = (0, $e02Sx.useActionRenderer)();
    const fireAdoptedEvent = (0, $cozmU.useCallback)((actionKey, actionPayload)=>{
        const { getAdoptedObjects: getAdoptedObjects } = getActionRenderer(actionKey, [
            actionPayload.context
        ]);
        if (!getAdoptedObjects) return;
        const rovoModifiedObjects = getAdoptedObjects(actionPayload.context);
        if (rovoModifiedObjects.length) trackAIMAUEvent({
            type: 'adopted',
            actionKey: actionKey,
            proactive: false,
            rovoModifiedObjects: rovoModifiedObjects,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        getActionRenderer,
        trackAIMAUEvent,
        interactionModeExecuted
    ]);
    const onActioned = (0, $cozmU.useCallback)(async (payload, actionContentProcessor, options)=>{
        if (!conversationId) return;
        fireUiActionedAnalytics(payload);
        const actionCallbackData = await resolveConversationAction({
            conversationId: conversationId,
            payload: payload,
            messageId: agentMessageId,
            actionContentProcessor: actionContentProcessor,
            skipSuccessOptimisticAssistantResponse: options?.skipSuccessOptimisticAssistantResponse
        });
        fireAIMAUActionedAnalytics(payload, agentMessageId, interactionModeExecuted);
        fireAdoptedEvent(payload.context.key, payload);
        return actionCallbackData;
    }, [
        agentMessageId,
        conversationId,
        resolveConversationAction,
        fireUiActionedAnalytics,
        fireAIMAUActionedAnalytics,
        fireAdoptedEvent,
        interactionModeExecuted
    ]);
    const onClickDebug = (0, $cozmU.useCallback)(()=>{
        if (!conversationId) return;
        openAgentDebugModal({
            messageId: agentMessageId,
            conversationId: conversationId
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'debugClicked',
            proactive: false,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...(0, $iEKWu.interactionModeExecutedAttributes)(interactionModeExecuted)
            }
        });
    }, [
        agentMessageId,
        trackAIMAUEvent,
        openAgentDebugModal,
        conversationId,
        interactionModeExecuted
    ]);
    const getOnViewAnalysisClick = (0, $cozmU.useCallback)((idx)=>()=>{
            const sculptorData = (0, $27146ba918be8917$export$4499bf045ea6bd06)({
                markdownData: storeAssistant.markdownData,
                type: 'sculptor',
                index: idx
            });
            if (sculptorData) openDataSculptorModal(sculptorData);
        }, [
        openDataSculptorModal,
        storeAssistant.markdownData
    ]);
    const { redactedResponse: redactedResponse } = storeAssistant;
    if (redactedResponse && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
        showPadding: false,
        variant: "neutral",
        pinchCorner: "topLeft",
        mode: mode?.toString()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: redactedResponse,
        productKey: productKey,
        siteId: siteId,
        adfTransformer: (0, $eAl7N.injectRedactScribbles),
        extensionComponent: (0, $6j4UZ.RedactScribbleExtension)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ari4I.RedactionEnforcementMessage), {
        alignInline: "start"
    }));
    if (!content && !filteredActions?.length && !shouldRenderAgentResponseHat) // Some messages might come empty when an error occurs while waiting for stream response.
    // Still render the response-hat slot when a streamed selected-agent turn is about to
    // produce content, so the text does not shift after the first streamed token arrives.
    return null;
    const sendLinkCountMetric = (streamingCompleted, adf)=>{
        if (!streamingCompleted) return;
        const linkCounts = (0, $c67872b41cdb1880$export$87534e1b3744f058)(adf);
        sendAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'messageContent',
            actionSubjectId: 'linkCounts',
            attributes: {
                totalLinks: linkCounts.totalLinks,
                smartLinkCount: linkCounts.smartLinkCount,
                inlineCardCount: linkCounts.inlineCardCount,
                embedCardCount: linkCounts.embedCardCount,
                regularLinkCount: linkCounts.regularLinkCount
            }
        });
    };
    const renderedResponseContent = shouldRenderLLMContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        xcss: shouldEnableAgentResponseHat ? $d0b8d0ec473bba39$var$styles.responseContent : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0b8d0ec473bba39$var$RovoXpcSmartCardProvider, {
        mode: mode,
        fullScreen: fullScreen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jqovE.MessageRenderer), {
        message: assistantResponseMessage,
        onContentSelected: onContentSelected,
        onContentCopied: onContentCopied,
        onCodeBlockCopied: onCodeBlockCopied,
        allowDownloadCodeBlock: true,
        onClickSource: onClickSource,
        onClickResponseLink: onClickResponseLink,
        onClickSmartCard: onClickSmartCard,
        onClickCitation: onClickCitation,
        onAuthLinkClick: onAuthLinkClick,
        getOnViewAnalysisClick: getOnViewAnalysisClick,
        markdownData: storeAssistant.markdownData,
        lightweightEncoding: messageActivelyStreaming,
        contentStillStreaming: !streamingComplete,
        productKey: productKey,
        siteId: siteId,
        orgId: orgId,
        aaid: aaid,
        conversationId: conversation?.id,
        tempIsThirdPartyAgent: conversation?.agent?.creator_type === 'REMOTE_A2A',
        onDeepLinkClick: customHandlers?.handleDeepLinkClick,
        isMiniModal: mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
        isExperimentEnabled: (experimentName, needsExposure)=>{
            return (0, $cXtTj.default).getExperimentValue(experimentName, 'isEnabled', false, {
                fireExperimentExposure: needsExposure ?? true
            });
        },
        adfTransformer: (0, $lCO2g.adfSmartlinksPlugin),
        sendLinkCountMetric: sendLinkCountMetric,
        extensionComponent: $d0b8d0ec473bba39$var$InsightExtensionWithLayoutContext,
        xpcWrapUrl: xpcWrapUrl,
        onFollowUpClick: onFollowUpClick,
        interactionMode: interactionMode,
        onLuminaInteraction: gatedOnLuminaInteraction
    }))) : null; // Navigation + analytics handlers for the source/expert rows are intentionally
    // left unset in this first pass so we can validate the visual treatment. They
    // will be wired up (deep links + GASv3) in a follow-up once the UX is confirmed.
    const isHighlyAuthoritative = authorityUiMetadata?.isHighlyAuthoritative ?? authorityUiMetadata?.highlyAuthoritative;
    const renderedAuthorityAttribution = streamingComplete && isHighlyAuthoritative && authorityUiMetadata && (0, $iDrrr.fg)('rovo_authoritative_answer_attribution') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0b8d0ec473bba39$var$RovoXpcSmartCardProvider, {
        mode: mode,
        fullScreen: fullScreen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Zool.AuthoritativeAnswerAttribution), {
        sources: authorityUiMetadata.sources,
        domainExperts: authorityUiMetadata.domainExperts,
        overallReasoning: authorityUiMetadata.overallReasoning,
        surface: "chat",
        // compact panel only makes sense in the narrow sidebar / mini modal.
        panelSize: fullScreen || mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL ? 'tall' : 'compact',
        onPanelOpen: onAuthorityPanelShown,
        onSourceClick: ()=>onAuthorityLinkClicked('source'),
        onExpertClick: ()=>onAuthorityLinkClicked('expert'),
        onFeedbackSubmit: (submission)=>{
            // Submit authority-answer feedback to the Feedback Collector API using
            // Chat's entrypoint (same destination as Chat's collector feedback).
            (0, $1V59x.submitAuthorityFeedback)({
                submission: submission,
                entrypointId: (0, $1V59x.FEEDBACK_ENTRYPOINT_ID_CHAT),
                origin: (0, $1V59x.AUTHORITY_FEEDBACK_ORIGIN_CHAT),
                cloudId: siteId
            });
        },
        testId: "assistant-authoritative-answer-attribution"
    })) : null;
    const isFromSnapshot = !!assistantResponse.message.message_metadata?.sharedFromMessageId;
    const renderedStreamActions = messageType === 'FINAL_RESPONSE' && ((0, $iDrrr.fg)('aifc_create_enabled') || !isContentPreviewSupported) && !isFromSnapshot ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0ba42ae6fad3dbe8$export$bfd345d064216d3e), {
        actions: filteredActions ?? [],
        messageId: agentMessageId,
        emojiProvider: emojiProvider,
        cloudId: siteId,
        product: product
    }) : null;
    const renderedCompletedActions = streamingComplete && !isFromSnapshot ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: shouldEnableAgentResponseHat ? undefined : $d0b8d0ec473bba39$var$styles.legacyActionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d77110d97ca2071c$export$fb14e7c6e673c7b4), {
        interactionModeExecuted: interactionModeExecuted,
        actions: filteredActions ?? [],
        onActioned: onActioned,
        invokedActions: invokedActions,
        recipientAgentNamedId: selectedAgent?.named_id,
        recipientAgentId: selectedAgent?.id,
        messageId: agentMessageId,
        messageType: messageType,
        jiraActivationId: jiraActivationId,
        ...(0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') && {
            recipientAgentName: selectedAgent?.name
        },
        isHistoricalMessage: storeAssistant.isHistorical,
        conversationId: conversationId,
        ...(0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') && {
            isLastMessage: isLastMessage
        },
        ...(0, $iDrrr.fg)('jsm-kb-action-message-prop') && {
            isLastActionMessage: isLastActionMessage
        }
    }), !shouldHideFooterButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75YqA.MessageFooterButtons), {
        hideThumbs: csatFlowUsedThisTurn,
        onThumbClick: onThumbClick,
        onCopyClick: onCopyClick,
        messageId: agentMessageId,
        insertReplaceContent: insertReplaceContent,
        selectedAgentId: selectedAgent?.id,
        onClickInsertReplace: onClickInsertReplace,
        hideInsertButton: hasAutoInsertedContent,
        showDebugButton: !selectedAgent?.is_default && (0, $iDrrr.fg)('rovo_agents_chat_debug_mode_enabled'),
        onClickDebug: onClickDebug,
        feedbackType: feedbackTypeV2,
        markdownData: storeAssistant.markdownData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, feedbackTypeV2 && isBannerVisible && formatMessage((0, $2zDNQ.default).thankYouMessage)), isCsatSurveyVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0b8d0ec473bba39$var$CsatSurvey, {
        selectedRating: csatRating,
        onSelectRating: handleSelectRating,
        onSubmit: ()=>{
            if (csatRating) handleCsatSubmit(csatRating);
        },
        onClose: handleCsatDismiss,
        onLayoutResolved: recordResolvedLayout
    })), feedbackTypeV2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3hnlP.FeedbackConfirmationBanner), {
        key: feedbackTypeV2,
        onProvideAdditionalFeedback: handleProvideAdditionalFeedback,
        onDismiss: ()=>{
            handleDismissBanner();
            thumbTriggerRef.current?.focus();
        },
        isVisible: isBannerVisible,
        feedbackType: feedbackTypeV2,
        onSubmit: handleFeedbackSubmit,
        onIncludeMessagesChecked: handleIncludeMessagesChecked,
        onOptIn: handleOptIn,
        isOptedIn: isOptedIn,
        hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt,
        onOptInPromptActioned: setHasSeenFeedbackOptInPrompt ? ()=>setHasSeenFeedbackOptInPrompt(true) : undefined,
        restartAutoDismiss: restartAutoDismiss,
        pauseAutoDismiss: pauseAutoDismiss,
        csatRating: submittedCsatRating
    }), shouldShowBetaLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0b8d0ec473bba39$var$BetaMessageLabel, null)) : null;
    const renderedSnapshotActionPlaceholder = isFromSnapshot && !!filteredActions?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d0b8d0ec473bba39$var$styles.snapshotActionPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.disabled"
    }, formatMessage((0, $232a2fb9697f0bdd$export$2e2bcd8739ae039).snapshotActionPlaceholder)))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderedAuthorityAttribution, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NVkH.Paper), {
        showPadding: false,
        variant: "neutral",
        pinchCorner: "topLeft",
        mode: mode?.toString()
    }, shouldEnableAgentResponseHat ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $d0b8d0ec473bba39$var$styles.responseCard,
        testId: "assistant-response-card-layout"
    }, shouldRenderAgentResponseHat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGWMb.AgentResponseHat), {
        isDefaultRovo: isResponseAuthorDefaultRovo,
        agentIdentityAccountId: responseHatAgentIdentityAccountId,
        isIdentityHydrating: isResponseAuthorIdentityHydrating,
        cloudId: siteId
    }), renderedResponseContent, renderedStreamActions, renderedCompletedActions, renderedSnapshotActionPlaceholder) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderedResponseContent, renderedStreamActions, renderedCompletedActions, renderedSnapshotActionPlaceholder)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ee2bab08eb5b7d0$export$1a4e37fedd01b118), {
        name: 'Harmful AI Content Feedback',
        aaid: aaid ?? 'unknown',
        allowFeedbackMetadata: true,
        feedbackMetadata: feedbackMetadata,
        isOpen: isHarmfulContentModalOpen,
        setIsOpen: setIsHarmfulContentModalOpen,
        onSubmit: onAupFeedbackSubmitted
    }));
});
module.exports["StoreAssistantView"] = $d0b8d0ec473bba39$export$246e01ccfb2a99f0;

});

parcelRegister("91uAX", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4dd8e62f46596b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("7MfQo")).default);


var $2eX69 = parcelRequire("2eX69");


var $7MfQo = parcelRequire("7MfQo");


var $eb4dd8e62f46596b$export$2e2bcd8739ae039 = (0, $2eX69.default);

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $iDrrr.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $dTHYM = parcelRequire("dTHYM");

var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $2Nu0e = parcelRequire("2Nu0e");

var $dQLwo = parcelRequire("dQLwo");

var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");


var $iDrrr = parcelRequire("iDrrr");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            shouldPreventEscapePropagation: (0, $iDrrr.fg)('ak_feedback_collector_select_escape'),
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "topic",
            id: "topic",
            label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
            isRequired: true,
            validate: validateType
        }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                ...restProps,
                value: selectOptions.find((opt)=>opt.value === type) ?? null,
                onChange: (option)=>{
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    restProps.onChange?.(option.value);
                },
                menuPosition: "fixed",
                options: selectOptions,
                shouldPreventEscapePropagation: (0, $iDrrr.fg)('ak_feedback_collector_select_escape'),
                // @ts-ignore
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id,
                isInvalid: !!error
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description",
            id: "description",
            validate: validateDescription
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: (e)=>{
                    setDescription(e.target.value);
                    fieldProps.onChange(e.target.value);
                },
                value: description
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "can-be-contacted"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                    ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                    target: "_blank"
                                }, chunks)
                        }
                    }
                }),
                onChange: (event)=>setCanBeContacted(event.target.checked)
            }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "enroll-in-research-group"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
                onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
            }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: 'anonymousFeedback'
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleCancel
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel))))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
const $e1a3f1d7e16f1235$var$isNestedMessagesModule = (value)=>'default' in value && typeof value.default === 'object' && value.default !== null;
const $e1a3f1d7e16f1235$var$unwrapMessages = (messages)=>{
    const defaultExport = messages.default;
    return $e1a3f1d7e16f1235$var$isNestedMessagesModule(defaultExport) ? defaultExport.default : defaultExport;
};





























const $e1a3f1d7e16f1235$var$messagesLoaders = {
    cs: ()=>(parcelRequire("gR4U1")),
    da: ()=>(parcelRequire("f1jrk")),
    de: ()=>(parcelRequire("aOLRB")),
    en: ()=>(parcelRequire("6kEFl")),
    en_GB: ()=>(parcelRequire("bjsxN")),
    en_ZZ: ()=>(parcelRequire("9DhD6")),
    es: ()=>(parcelRequire("ddpWy")),
    fi: ()=>(parcelRequire("5XvgX")),
    fr: ()=>(parcelRequire("cZf5E")),
    hr: ()=>(parcelRequire("CsODP")),
    hu: ()=>(parcelRequire("hPRyr")),
    it: ()=>(parcelRequire("z7zpe")),
    ja: ()=>(parcelRequire("8pzcT")),
    ko: ()=>(parcelRequire("1I2b8")),
    nb: ()=>(parcelRequire("gPBz3")),
    nl: ()=>(parcelRequire("78iTh")),
    pl: ()=>(parcelRequire("gHYE1")),
    pt_BR: ()=>(parcelRequire("9qN1z")),
    ru: ()=>(parcelRequire("dNwJi")),
    sl: ()=>(parcelRequire("fXweJ")),
    sr_RS: ()=>(parcelRequire("nFTVL")),
    sr_YR: ()=>(parcelRequire("bsw4B")),
    sv: ()=>(parcelRequire("97qPc")),
    th: ()=>(parcelRequire("bZmWu")),
    tr: ()=>(parcelRequire("aspSd")),
    uk: ()=>(parcelRequire("kWvvj")),
    vi: ()=>(parcelRequire("c5Sph")),
    zh: ()=>(parcelRequire("ecWO0")),
    zh_TW: ()=>(parcelRequire("dpkEO"))
};
const $e1a3f1d7e16f1235$var$getMessages = async (locale)=>{
    const loadMessages = $e1a3f1d7e16f1235$var$messagesLoaders[locale];
    if (!loadMessages) return undefined;
    try {
        const messages = await loadMessages();
        return $e1a3f1d7e16f1235$var$unwrapMessages(messages);
    } catch  {
        return undefined;
    }
};
const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    const localeKey = locale.replace('-', '_');
    const messages = await $e1a3f1d7e16f1235$var$getMessages(localeKey);
    return messages ?? $e1a3f1d7e16f1235$var$getMessages(localeKey.split(/[-_]/)[0]);
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("gR4U1", function(module, exports) {

let $c455661dc243c654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c455661dc243c654$var$load("iGnEn").then(()=>parcelRequire('6S4lG'));

});

parcelRegister("f1jrk", function(module, exports) {

let $aef60752586d2f07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef60752586d2f07$var$load("81CwI").then(()=>parcelRequire('9Q7ky'));

});

parcelRegister("aOLRB", function(module, exports) {

let $7e03b39534ef9cf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e03b39534ef9cf9$var$load("coMdg").then(()=>parcelRequire('4ELWT'));

});

parcelRegister("6kEFl", function(module, exports) {

let $49c427b32ae5dc71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c427b32ae5dc71$var$load("4t3GG").then(()=>parcelRequire('aPmYJ'));

});

parcelRegister("bjsxN", function(module, exports) {

let $83c79c54c6feadd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83c79c54c6feadd2$var$load("lJDHR").then(()=>parcelRequire('fYO3Z'));

});

parcelRegister("9DhD6", function(module, exports) {

let $70356e70b5fecfa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70356e70b5fecfa6$var$load("izI99").then(()=>parcelRequire('fcttw'));

});

parcelRegister("ddpWy", function(module, exports) {

let $99f09d110267a62d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f09d110267a62d$var$load("3LmH0").then(()=>parcelRequire('iTEZG'));

});

parcelRegister("5XvgX", function(module, exports) {

let $456ab880bb5ad2de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456ab880bb5ad2de$var$load("9nUzh").then(()=>parcelRequire('jCyLN'));

});

parcelRegister("cZf5E", function(module, exports) {

let $9746e31b2d06b6ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9746e31b2d06b6ef$var$load("b0H0M").then(()=>parcelRequire('sjYCD'));

});

parcelRegister("CsODP", function(module, exports) {

let $0739e6f0f7a8ce09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0739e6f0f7a8ce09$var$load("rlX60").then(()=>parcelRequire('kdtG9'));

});

parcelRegister("hPRyr", function(module, exports) {

let $cfc0bde35e1c9468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc0bde35e1c9468$var$load("8XGfa").then(()=>parcelRequire('9cMV0'));

});

parcelRegister("z7zpe", function(module, exports) {

let $0699244176860d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0699244176860d72$var$load("kX4YP").then(()=>parcelRequire('65zeK'));

});

parcelRegister("8pzcT", function(module, exports) {

let $61fbf7e9b29a6824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61fbf7e9b29a6824$var$load("cYuG5").then(()=>parcelRequire('amjcb'));

});

parcelRegister("1I2b8", function(module, exports) {

let $13eb9721d58dad03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13eb9721d58dad03$var$load("5bV9Q").then(()=>parcelRequire('3z1HI'));

});

parcelRegister("gPBz3", function(module, exports) {

let $c40e8c41f36f3f1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c40e8c41f36f3f1d$var$load("gjrov").then(()=>parcelRequire('ePp5T'));

});

parcelRegister("78iTh", function(module, exports) {

let $5317ef0d88303541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5317ef0d88303541$var$load("ekD3q").then(()=>parcelRequire('3sPeQ'));

});

parcelRegister("gHYE1", function(module, exports) {

let $c29fb436da7f42d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c29fb436da7f42d1$var$load("CRIov").then(()=>parcelRequire('21Pza'));

});

parcelRegister("9qN1z", function(module, exports) {

let $6ddc91febcf834c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ddc91febcf834c3$var$load("kLzqf").then(()=>parcelRequire('2YIPE'));

});

parcelRegister("dNwJi", function(module, exports) {

let $a0b93d651cd2386e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b93d651cd2386e$var$load("89F7K").then(()=>parcelRequire('lXD2K'));

});

parcelRegister("fXweJ", function(module, exports) {

let $b9e55f3b28230681$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e55f3b28230681$var$load("5ZUDB").then(()=>parcelRequire('16fIE'));

});

parcelRegister("nFTVL", function(module, exports) {

let $0472a6c8d6c4c707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0472a6c8d6c4c707$var$load("h2pVk").then(()=>parcelRequire('byreT'));

});

parcelRegister("bsw4B", function(module, exports) {

let $857b304eeac06c5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857b304eeac06c5e$var$load("hKNph").then(()=>parcelRequire('diuUZ'));

});

parcelRegister("97qPc", function(module, exports) {

let $6a39935eb8b824b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a39935eb8b824b7$var$load("bEB1L").then(()=>parcelRequire('57pGr'));

});

parcelRegister("bZmWu", function(module, exports) {

let $8ba730127f966548$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ba730127f966548$var$load("1DxcO").then(()=>parcelRequire('grvEM'));

});

parcelRegister("aspSd", function(module, exports) {

let $79d096d1d3432597$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79d096d1d3432597$var$load("4KHc0").then(()=>parcelRequire('13DVp'));

});

parcelRegister("kWvvj", function(module, exports) {

let $f3f1a976fda4a8c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3f1a976fda4a8c1$var$load("fWsCx").then(()=>parcelRequire('im5if'));

});

parcelRegister("c5Sph", function(module, exports) {

let $8ce027b238ed199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ce027b238ed199c$var$load("eVExC").then(()=>parcelRequire('1U1j1'));

});

parcelRegister("ecWO0", function(module, exports) {

let $a57fcd3be5a7543a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57fcd3be5a7543a$var$load("BGq3S").then(()=>parcelRequire('kBazV'));

});

parcelRegister("dpkEO", function(module, exports) {

let $9c2da245872fb648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c2da245872fb648$var$load("1BBYh").then(()=>parcelRequire('3tROA'));

});

parcelRegister("7MfQo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $a2foB = parcelRequire("a2foB");


var $chu6R = parcelRequire("chu6R");


var $iDrrr = parcelRequire("iDrrr");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $cf0d91eb970c8b8a$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $iDrrr.fg)('product-terminology-refresh') ? (0, $5r21M.messages).feedbackSuccessFlagDescriptionAppify : (0, $5r21M.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $5r21M.messages).feedbackSuccessFlagTitle)
    });
};
const $cf0d91eb970c8b8a$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: props.locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf0d91eb970c8b8a$var$FeedbackFlag, props));
var $cf0d91eb970c8b8a$export$2e2bcd8739ae039 = $cf0d91eb970c8b8a$var$FeedbackFlagWithIntl;
module.exports["default"] = $cf0d91eb970c8b8a$export$2e2bcd8739ae039;

});

parcelRegister("8Xvwd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dUI0h = parcelRequire("dUI0h");

const $17a57d278defc8d4$export$94195a47b94ed396 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, defaultIsChecked: t1, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value } = t0;
    const defaultIsChecked = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== defaultIsChecked || $[1] !== value) {
        t2 = (t3)=>{
            const currentValue = t3 === undefined ? [] : t3;
            return defaultIsChecked && value !== undefined ? [
                ...currentValue,
                value
            ] : currentValue;
        };
        $[0] = defaultIsChecked;
        $[1] = value;
        $[2] = t2;
    } else t2 = $[2];
    const defaultValue = t2;
    let t3;
    if ($[3] !== children || $[4] !== defaultIsChecked || $[5] !== defaultValue || $[6] !== isDisabled || $[7] !== isRequired || $[8] !== label || $[9] !== name || $[10] !== value) {
        t3 = value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            defaultValue: defaultValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            label: label,
            name: name,
            transform: (event, currentValue_0)=>!Array.isArray(event) && event.currentTarget.checked && currentValue_0 ? [
                    ...currentValue_0,
                    value
                ] : currentValue_0.filter((v)=>v !== value)
        }, (t4)=>{
            const { fieldProps: t5, ...others } = t4;
            const { value: fieldValue, onChange: onChange, ...otherFieldProps } = t5;
            return children({
                fieldProps: {
                    ...otherFieldProps,
                    onChange: (v_0)=>onChange(v_0),
                    isChecked: !!fieldValue.find((v_1)=>v_1 === value),
                    value: value
                },
                ...others
            });
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            defaultValue: defaultIsChecked,
            isDisabled: isDisabled,
            isRequired: isRequired,
            label: label,
            name: name,
            transform: $17a57d278defc8d4$var$_temp
        }, (t6)=>{
            const { fieldProps: t7, ...others_0 } = t6;
            const { value: fieldValue_0, onChange: onChange_0, ...otherFieldProps_0 } = t7;
            return children({
                fieldProps: {
                    ...otherFieldProps_0,
                    onChange: (v_2)=>onChange_0(v_2),
                    isChecked: fieldValue_0,
                    value: value
                },
                ...others_0
            });
        });
        $[3] = children;
        $[4] = defaultIsChecked;
        $[5] = defaultValue;
        $[6] = isDisabled;
        $[7] = isRequired;
        $[8] = label;
        $[9] = name;
        $[10] = value;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $cozmU.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue_0)=>!Array.isArray(event) && event.currentTarget.checked && currentValue_0 ? [
                ...currentValue_0,
                value
            ] : currentValue_0.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                // Setting to any because it's typed weirdly at the field level
                onChange: (v_0)=>onChange(v_0),
                isChecked: !!fieldValue.find((v_1)=>v_1 === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event_0)=>typeof event_0 === 'boolean' ? event_0 : event_0.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue_0, onChange: onChange_0, ...otherFieldProps_0 }, ...others_0 })=>children({
            fieldProps: {
                ...otherFieldProps_0,
                // Setting to any because it's typed weirdly at the field level
                onChange: (v_2)=>onChange_0(v_2),
                isChecked: fieldValue_0,
                value: value
            },
            ...others_0
        }));
};
function $17a57d278defc8d4$var$_temp(event_0) {
    return typeof event_0 === "boolean" ? event_0 : event_0.currentTarget.checked;
}
module.exports["CheckboxField"] = $17a57d278defc8d4$export$94195a47b94ed396;

});

parcelRegister("jqovE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $1VhsF = parcelRequire("1VhsF");


var $irnO2 = parcelRequire("irnO2");


var $iuCeV = parcelRequire("iuCeV");


var $3E9Hk = parcelRequire("3E9Hk");


var $1PVOM = parcelRequire("1PVOM");


var $8BSfe = parcelRequire("8BSfe");


var $kc6OK = parcelRequire("kc6OK");


var $4ASef = parcelRequire("4ASef");

const $58b67fad8f185fef$var$MessageRendererFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { error: error } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $kc6OK.default).messageErrorTitle);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $kc6OK.default).messageError);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t1,
            appearance: "error"
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== error) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
            error: error,
            name: (0, $irnO2.ExperienceName).MESSAGE_RENDERER
        });
        $[7] = error;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: formatMessage((0, $kc6OK.default).messageErrorTitle),
        appearance: "error"
    }, formatMessage((0, $kc6OK.default).messageError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
        error: error,
        name: (0, $irnO2.ExperienceName).MESSAGE_RENDERER
    }));
};
const $58b67fad8f185fef$var$MessageRendererRaw = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { message: message, onClickSource: onClickSource, onClickAppendix: onClickAppendix, onClickResponseLink: onClickResponseLink, onClickSmartCard: onClickSmartCard, onClickCitation: onClickCitation, onContentSelected: onContentSelected, onContentCopied: onContentCopied, onCodeBlockCopied: onCodeBlockCopied, allowDownloadCodeBlock: t1, onAuthLinkClick: onAuthLinkClick, getOnViewAnalysisClick: getOnViewAnalysisClick, onDeepLinkClick: onDeepLinkClick, markdownData: markdownData, lightweightEncoding: lightweightEncoding, productKey: productKey, orgId: orgId, siteId: siteId, aaid: aaid, conversationId: conversationId, contentStillStreaming: contentStillStreaming, isMiniModal: t2, isExperimentEnabled: isExperimentEnabled, adfTransformer: adfTransformer, sendLinkCountMetric: sendLinkCountMetric, extensionComponent: extensionComponent, xpcWrapUrl: xpcWrapUrl, tempIsThirdPartyAgent: tempIsThirdPartyAgent, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode, onLuminaInteraction: onLuminaInteraction } = t0;
    const allowDownloadCodeBlock = t1 === undefined ? false : t1;
    const isMiniModal = t2 === undefined ? false : t2;
    const { content: content, sources: sources, appendices: appendices } = message;
    const hasSources = !!sources && sources.length > 0;
    let t3;
    if ($[0] !== sources) {
        t3 = {
            sources: sources
        };
        $[0] = sources;
        $[1] = t3;
    } else t3 = $[1];
    const sourceContextData = t3;
    if (!content) return null;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).MESSAGE_RENDERER
        });
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== aaid || $[4] !== adfTransformer || $[5] !== allowDownloadCodeBlock || $[6] !== content || $[7] !== contentStillStreaming || $[8] !== conversationId || $[9] !== extensionComponent || $[10] !== getOnViewAnalysisClick || $[11] !== interactionMode || $[12] !== isExperimentEnabled || $[13] !== isMiniModal || $[14] !== lightweightEncoding || $[15] !== markdownData || $[16] !== message.id || $[17] !== onAuthLinkClick || $[18] !== onClickCitation || $[19] !== onClickResponseLink || $[20] !== onClickSmartCard || $[21] !== onCodeBlockCopied || $[22] !== onContentCopied || $[23] !== onContentSelected || $[24] !== onDeepLinkClick || $[25] !== onFollowUpClick || $[26] !== onLuminaInteraction || $[27] !== orgId || $[28] !== productKey || $[29] !== sendLinkCountMetric || $[30] !== siteId || $[31] !== tempIsThirdPartyAgent || $[32] !== xpcWrapUrl) {
        t5 = !!content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: content,
            lightweightEncoding: lightweightEncoding,
            onCodeBlockCopied: onCodeBlockCopied,
            allowDownloadCodeBlock: allowDownloadCodeBlock,
            onContentCopied: onContentCopied,
            onContentSelected: onContentSelected,
            onResponseLinkClick: onClickResponseLink,
            onSmartCardClick: onClickSmartCard,
            onCitationClick: onClickCitation,
            onAuthLinkClick: onAuthLinkClick,
            getOnViewAnalysisClick: getOnViewAnalysisClick,
            markdownData: markdownData,
            productKey: productKey,
            xpcWrapUrl: xpcWrapUrl,
            orgId: orgId,
            siteId: siteId,
            aaid: aaid,
            messageId: message.id,
            conversationId: conversationId,
            onDeepLinkClick: onDeepLinkClick,
            contentStillStreaming: contentStillStreaming,
            shouldOverrideCardAsInline: isMiniModal,
            isExperimentEnabled: isExperimentEnabled,
            adfTransformer: adfTransformer,
            sendLinkCountMetric: sendLinkCountMetric,
            extensionComponent: extensionComponent,
            tempIsThirdPartyAgent: tempIsThirdPartyAgent,
            onFollowUpClick: onFollowUpClick,
            interactionMode: interactionMode,
            onLuminaInteraction: onLuminaInteraction
        });
        $[3] = aaid;
        $[4] = adfTransformer;
        $[5] = allowDownloadCodeBlock;
        $[6] = content;
        $[7] = contentStillStreaming;
        $[8] = conversationId;
        $[9] = extensionComponent;
        $[10] = getOnViewAnalysisClick;
        $[11] = interactionMode;
        $[12] = isExperimentEnabled;
        $[13] = isMiniModal;
        $[14] = lightweightEncoding;
        $[15] = markdownData;
        $[16] = message.id;
        $[17] = onAuthLinkClick;
        $[18] = onClickCitation;
        $[19] = onClickResponseLink;
        $[20] = onClickSmartCard;
        $[21] = onCodeBlockCopied;
        $[22] = onContentCopied;
        $[23] = onContentSelected;
        $[24] = onDeepLinkClick;
        $[25] = onFollowUpClick;
        $[26] = onLuminaInteraction;
        $[27] = orgId;
        $[28] = productKey;
        $[29] = sendLinkCountMetric;
        $[30] = siteId;
        $[31] = tempIsThirdPartyAgent;
        $[32] = xpcWrapUrl;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== conversationId || $[35] !== hasSources || $[36] !== onClickSource || $[37] !== productKey || $[38] !== siteId || $[39] !== sources || $[40] !== xpcWrapUrl) {
        t6 = hasSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ASef.SourcesView), {
            sources: sources,
            onClickSource: onClickSource,
            conversationId: conversationId,
            siteId: siteId,
            productKey: productKey,
            xpcWrapUrl: xpcWrapUrl
        }) : null;
        $[34] = conversationId;
        $[35] = hasSources;
        $[36] = onClickSource;
        $[37] = productKey;
        $[38] = siteId;
        $[39] = sources;
        $[40] = xpcWrapUrl;
        $[41] = t6;
    } else t6 = $[41];
    let t7;
    if ($[42] !== appendices || $[43] !== onClickAppendix) {
        t7 = !!appendices && appendices.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3E9Hk.AppendicesView), {
            appendices: appendices,
            onClickAppendix: onClickAppendix
        });
        $[42] = appendices;
        $[43] = onClickAppendix;
        $[44] = t7;
    } else t7 = $[44];
    let t8;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: (0, $irnO2.ExperienceName).MESSAGE_RENDERER
        });
        $[45] = t8;
    } else t8 = $[45];
    let t9;
    if ($[46] !== t5 || $[47] !== t6 || $[48] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5, t6, t7, t8);
        $[46] = t5;
        $[47] = t6;
        $[48] = t7;
        $[49] = t9;
    } else t9 = $[49];
    let t10;
    if ($[50] !== sourceContextData || $[51] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BSfe.SourcesContext).Provider, {
            value: sourceContextData
        }, t9);
        $[50] = sourceContextData;
        $[51] = t9;
        $[52] = t10;
    } else t10 = $[52];
    return t10;
} : ({ message: message, onClickSource: onClickSource, onClickAppendix: onClickAppendix, onClickResponseLink: onClickResponseLink, onClickSmartCard: onClickSmartCard, onClickCitation: onClickCitation, onContentSelected: onContentSelected, onContentCopied: onContentCopied, onCodeBlockCopied: onCodeBlockCopied, allowDownloadCodeBlock: allowDownloadCodeBlock = false, onAuthLinkClick: onAuthLinkClick, getOnViewAnalysisClick: getOnViewAnalysisClick, onDeepLinkClick: onDeepLinkClick, markdownData: markdownData, lightweightEncoding: lightweightEncoding, productKey: productKey, orgId: orgId, siteId: siteId, aaid: aaid, conversationId: conversationId, contentStillStreaming: contentStillStreaming, isMiniModal: isMiniModal = false, isExperimentEnabled: isExperimentEnabled, adfTransformer: adfTransformer, sendLinkCountMetric: sendLinkCountMetric, extensionComponent: extensionComponent, xpcWrapUrl: xpcWrapUrl, tempIsThirdPartyAgent: tempIsThirdPartyAgent, onFollowUpClick: onFollowUpClick, interactionMode: interactionMode, onLuminaInteraction: onLuminaInteraction })=>{
    const { content: content, sources: sources, appendices: appendices } = message;
    const hasSources = !!sources && sources.length > 0;
    const sourceContextData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            sources: sources
        }), [
        sources
    ]);
    if (!content) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BSfe.SourcesContext).Provider, {
        value: sourceContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).MESSAGE_RENDERER
    }), !!content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: content,
        lightweightEncoding: lightweightEncoding,
        onCodeBlockCopied: onCodeBlockCopied,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        onContentCopied: onContentCopied,
        onContentSelected: onContentSelected,
        onResponseLinkClick: onClickResponseLink,
        onSmartCardClick: onClickSmartCard,
        onCitationClick: onClickCitation,
        onAuthLinkClick: onAuthLinkClick,
        getOnViewAnalysisClick: getOnViewAnalysisClick,
        markdownData: markdownData,
        productKey: productKey,
        xpcWrapUrl: xpcWrapUrl,
        orgId: orgId,
        siteId: siteId,
        aaid: aaid,
        messageId: message.id,
        conversationId: conversationId,
        onDeepLinkClick: onDeepLinkClick,
        contentStillStreaming: contentStillStreaming,
        shouldOverrideCardAsInline: isMiniModal,
        isExperimentEnabled: isExperimentEnabled,
        adfTransformer: adfTransformer,
        sendLinkCountMetric: sendLinkCountMetric,
        extensionComponent: extensionComponent,
        tempIsThirdPartyAgent: tempIsThirdPartyAgent,
        onFollowUpClick: onFollowUpClick,
        interactionMode: interactionMode,
        onLuminaInteraction: onLuminaInteraction
    }), hasSources ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ASef.SourcesView), {
        sources: sources,
        onClickSource: onClickSource,
        conversationId: conversationId,
        siteId: siteId,
        productKey: productKey,
        xpcWrapUrl: xpcWrapUrl
    }) : null, !!appendices && appendices.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3E9Hk.AppendicesView), {
        appendices: appendices,
        onClickAppendix: onClickAppendix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).MESSAGE_RENDERER
    })));
};
const $58b67fad8f185fef$export$2df1250b8f917a59 = (0, $9EOlJ.withErrorBoundary)($58b67fad8f185fef$var$MessageRendererRaw, {
    FallbackComponent: $58b67fad8f185fef$var$MessageRendererFallback
});
module.exports["MessageRenderer"] = $58b67fad8f185fef$export$2df1250b8f917a59;

});

parcelRegister("3E9Hk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");

const $c8fa8e82fa658712$var$fallbackComponent = (url, type1, title, onClickAppendix1)=>{
    const FallbackComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
        const $ = (0, $bDgLe.c)(1);
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: url,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: $c8fa8e82fa658712$var$_temp
            }, title || url);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    } : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: ()=>{
                if (onClickAppendix1) onClickAppendix1(type1);
            }
        }, title || url);
    return FallbackComponent;
};
const $c8fa8e82fa658712$export$59a549bf87328b40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { appendices: appendices, onClickAppendix: onClickAppendix1 } = t0;
    let t1;
    if ($[0] !== appendices || $[1] !== onClickAppendix1) {
        let t2;
        if ($[3] !== onClickAppendix1) {
            t2 = (t3, index)=>{
                const { content: content, appendix_sources: appendix_sources } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: index
                }, !!content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    paddingBlockEnd: "space.150"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "p"
                }, content)), appendix_sources && appendix_sources.map((t4, index_0)=>{
                    const { url: url, title: title, type: type1 } = t4;
                    return !!url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        as: "p",
                        key: index_0
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                        appearance: "inline",
                        url: url,
                        onClick: (e)=>{
                            if (onClickAppendix1) onClickAppendix1(type1);
                            e.preventDefault();
                            window.open(url, "_blank", "noopener, noreferrer");
                        },
                        fallbackComponent: $c8fa8e82fa658712$var$fallbackComponent(url, type1, title, onClickAppendix1)
                    }));
                }));
            };
            $[3] = onClickAppendix1;
            $[4] = t2;
        } else t2 = $[4];
        t1 = appendices.map(t2);
        $[0] = appendices;
        $[1] = onClickAppendix1;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ appendices: appendices, onClickAppendix: onClickAppendix1 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, appendices.map(({ content: content, appendix_sources: appendix_sources }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: index
        }, !!content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockEnd: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, content)), appendix_sources && appendix_sources.map(({ url: url, title: title, type: type1 }, index_0)=>!!url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p",
                key: index_0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                appearance: "inline",
                url: url,
                onClick: (e)=>{
                    if (onClickAppendix1) onClickAppendix1(type1);
                    e.preventDefault();
                    window.open(url, '_blank', 'noopener, noreferrer');
                },
                fallbackComponent: $c8fa8e82fa658712$var$fallbackComponent(url, type1, title, onClickAppendix1)
            }))))));
};
function $c8fa8e82fa658712$var$_temp() {
    if (onClickAppendix) onClickAppendix(type);
}
module.exports["AppendicesView"] = $c8fa8e82fa658712$export$59a549bf87328b40;

});

parcelRegister("kc6OK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a2a6ff04075e881d$var$message = (0, $kSwu1.defineMessages)({
    messageErrorTitle: {
        id: "ai-mate.message-renderer.error-title",
        defaultMessage: "Failed to load content"
    },
    messageError: {
        id: "ai-mate.message-renderer.error",
        defaultMessage: "Please let us know if the problem persists."
    },
    showSources: {
        id: "ai-mate.message-renderer.show-sources",
        defaultMessage: "{count, plural, one {Show {count} source} other {Show {count} sources}}"
    },
    hideSources: {
        id: "ai-mate.message-renderer.hide-sources",
        defaultMessage: "Hide all sources"
    }
});
var $a2a6ff04075e881d$export$2e2bcd8739ae039 = $a2a6ff04075e881d$var$message;
module.exports["default"] = $a2a6ff04075e881d$export$2e2bcd8739ae039;

});

parcelRegister("4ASef", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $l8wPz = parcelRequire("l8wPz");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $4gLhk = parcelRequire("4gLhk");


var $ahHdE = parcelRequire("ahHdE");


var $iOpHH = parcelRequire("iOpHH");


var $4NbSC = parcelRequire("4NbSC");


var $bSXpv = parcelRequire("bSXpv");

const $c4602c274ef4436f$var$styles = {
    box: "_0bjKvDKxmn _2YLqiKPgdg _3W2Oc8wPeg",
    boxPadding: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6QPgdg",
    boxMarginBlock: "_3SamIH5zaO",
    sourcesButton: "_0bjKvDKxmn _2mHwu81Y8M _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r2gVvo _1wydGWgVvo _0KLXru66of _1UtDYzZpcK _1kk5Tkf7mX _0WKd3G4z3T _0wOv4Q7zJH _3iDTPbQ4SZ _0hPCNLDIqT _1eOmH6o126",
    sourcesButtonSelected: "_3vBAKHrzt2 _0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd",
    sourcesButtonRadiusMedium: "_0bjKvDKTcp"
};
const $c4602c274ef4436f$export$fcc7cc8796e759fa = (url, type, title, ari, product, onClickSource, shouldAddConfluenceAttribution, index)=>()=>{
        const transformedUrl = (0, $ahHdE.transformIfConfluenceLink)(url, shouldAddConfluenceAttribution);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: transformedUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: ()=>{
                if (onClickSource) onClickSource(type, (0, $4gLhk.extractProductNameFromARI)(ari), product ?? null, index);
            }
        }, title || url);
    };
const $c4602c274ef4436f$export$4468db6b0f4929c5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnswerInfo(t0) {
    const $ = (0, $bDgLe.c)(38);
    const { sources: sources, onClickSource: onClickSource, onSourcesButtonClicked: onSourcesButtonClicked, conversationId: conversationId, showMarginBlock: t1, showPadding: t2, siteId: siteId, productKey: productKey, shouldRenderPopupToParent: t3, xpcWrapUrl: xpcWrapUrl } = t0;
    const showMarginBlock = t1 === undefined ? true : t1;
    const showPadding = t2 === undefined ? true : t2;
    const shouldRenderPopupToParent = t3 === undefined ? true : t3;
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const hasTrackedViewed = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    let t4;
    bb0: {
        if (!siteId || !productKey) {
            t4 = undefined;
            break bb0;
        }
        const t5 = productKey;
        let t6;
        if ($[0] !== siteId || $[1] !== t5) {
            t6 = {
                siteId: siteId,
                product: t5,
                touchpointSource: "message-renderer-sources",
                experienceId: "ai-mate"
            };
            $[0] = siteId;
            $[1] = t5;
            $[2] = t6;
        } else t6 = $[2];
        t4 = t6;
    }
    const assistanceServiceParams = t4;
    let t5;
    if ($[3] !== conversationId || $[4] !== onClickSource || $[5] !== sendAnalyticsEvent) {
        t5 = (type, ari, product, index)=>{
            const citedProduct = (0, $4gLhk.extractProductNameFromARI)(ari);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "sourceLink",
                attributes: {
                    sourceType: type,
                    conversationId: conversationId,
                    citedProduct: citedProduct,
                    sourceProduct: product
                }
            });
            if (onClickSource) onClickSource(type, citedProduct, product ?? null, index);
        };
        $[3] = conversationId;
        $[4] = onClickSource;
        $[5] = sendAnalyticsEvent;
        $[6] = t5;
    } else t5 = $[6];
    const onClickSourceHandler = t5;
    let t6;
    if ($[7] !== isPopupOpen || $[8] !== onSourcesButtonClicked || $[9] !== sendAnalyticsEvent) {
        t6 = ()=>{
            if (!isPopupOpen) {
                onSourcesButtonClicked?.();
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "openSourcesPopup"
                });
                if (!hasTrackedViewed.current) {
                    hasTrackedViewed.current = true;
                    sendAnalyticsEvent({
                        action: "viewed",
                        actionSubject: "sources",
                        actionSubjectId: "sourcesViewed",
                        attributes: {
                            newSourcesUIEnabled: true
                        }
                    });
                }
            }
            setIsPopupOpen(!isPopupOpen);
        };
        $[7] = isPopupOpen;
        $[8] = onSourcesButtonClicked;
        $[9] = sendAnalyticsEvent;
        $[10] = t6;
    } else t6 = $[10];
    const handlePopupOpen = t6;
    let t7;
    if ($[11] !== sources) {
        t7 = sources ?? [];
        $[11] = sources;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t7) {
        t8 = t7.filter($c4602c274ef4436f$var$_temp);
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    const validSources = t8;
    if (validSources.length === 0) return null;
    const t9 = showPadding && $c4602c274ef4436f$var$styles.boxPadding;
    const t10 = showMarginBlock && $c4602c274ef4436f$var$styles.boxMarginBlock;
    let t11;
    if ($[15] !== t10 || $[16] !== t9) {
        t11 = (0, $w6R6I.cx)($c4602c274ef4436f$var$styles.box, t9, t10);
        $[15] = t10;
        $[16] = t9;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>setIsPopupOpen(false);
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== onClickSource || $[20] !== onClickSourceHandler || $[21] !== validSources || $[22] !== xpcWrapUrl) {
        t13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bSXpv.SourcesPopupContent), {
                sources: validSources,
                onClickSourceHandler: onClickSourceHandler,
                onClickSource: onClickSource,
                onClose: ()=>setIsPopupOpen(false),
                xpcWrapUrl: xpcWrapUrl
            });
        $[19] = onClickSource;
        $[20] = onClickSourceHandler;
        $[21] = validSources;
        $[22] = xpcWrapUrl;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== assistanceServiceParams || $[25] !== formatMessage || $[26] !== handlePopupOpen || $[27] !== isPopupOpen || $[28] !== validSources) {
        t14 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: (0, $w6R6I.cx)($c4602c274ef4436f$var$styles.sourcesButton, isPopupOpen && $c4602c274ef4436f$var$styles.sourcesButtonSelected, (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26") && $c4602c274ef4436f$var$styles.sourcesButtonRadiusMedium),
                onClick: handlePopupOpen,
                "aria-label": formatMessage((0, $iOpHH.default).sourcesTitle, {
                    sourceCount: validSources.length
                }),
                "aria-expanded": isPopupOpen,
                "aria-haspopup": "dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, (0, $iDrrr.fg)("rovo_chat_enable_twg_trace_team26") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, formatMessage((0, $iOpHH.default).sourcesTitle, {
                sourceCount: validSources.length
            })), assistanceServiceParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NbSC.SourceIcons), {
                sources: validSources,
                assistanceServiceParams: assistanceServiceParams
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, assistanceServiceParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NbSC.SourceIcons), {
                sources: validSources,
                assistanceServiceParams: assistanceServiceParams
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, formatMessage((0, $iOpHH.default).sourcesTitle, {
                sourceCount: validSources.length
            })))));
        $[24] = assistanceServiceParams;
        $[25] = formatMessage;
        $[26] = handlePopupOpen;
        $[27] = isPopupOpen;
        $[28] = validSources;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== isPopupOpen || $[31] !== shouldRenderPopupToParent || $[32] !== t13 || $[33] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            placement: "top-start",
            isOpen: isPopupOpen,
            onClose: t12,
            content: t13,
            shouldRenderToParent: shouldRenderPopupToParent,
            trigger: t14
        });
        $[30] = isPopupOpen;
        $[31] = shouldRenderPopupToParent;
        $[32] = t13;
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== t11 || $[36] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t11
        }, t15);
        $[35] = t11;
        $[36] = t15;
        $[37] = t16;
    } else t16 = $[37];
    return t16;
} : function AnswerInfo({ sources: sources, onClickSource: onClickSource, onSourcesButtonClicked: onSourcesButtonClicked, conversationId: conversationId, showMarginBlock: showMarginBlock = true, showPadding: showPadding = true, siteId: siteId, productKey: productKey, shouldRenderPopupToParent: shouldRenderPopupToParent = true, xpcWrapUrl: xpcWrapUrl }) {
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const hasTrackedViewed = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const assistanceServiceParams = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!siteId || !productKey) return undefined;
        return {
            siteId: siteId,
            product: productKey,
            touchpointSource: 'message-renderer-sources',
            experienceId: 'ai-mate'
        };
    }, [
        siteId,
        productKey
    ]);
    const onClickSourceHandler = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((type, ari, product, index)=>{
        const citedProduct = (0, $4gLhk.extractProductNameFromARI)(ari);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sourceLink',
            attributes: {
                sourceType: type,
                conversationId: conversationId,
                citedProduct: citedProduct,
                sourceProduct: product
            }
        });
        if (onClickSource) onClickSource(type, citedProduct, product ?? null, index);
    }, [
        sendAnalyticsEvent,
        onClickSource,
        conversationId
    ]);
    const handlePopupOpen = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!isPopupOpen) {
            onSourcesButtonClicked?.();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openSourcesPopup'
            });
            if (!hasTrackedViewed.current) {
                hasTrackedViewed.current = true;
                sendAnalyticsEvent({
                    action: 'viewed',
                    actionSubject: 'sources',
                    actionSubjectId: 'sourcesViewed',
                    attributes: {
                        newSourcesUIEnabled: true
                    }
                });
            }
        }
        setIsPopupOpen(!isPopupOpen);
    }, [
        isPopupOpen,
        onSourcesButtonClicked,
        sendAnalyticsEvent
    ]);
    const validSources = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(sources ?? []).filter((s)=>{
            if (!s?.url) return false;
            try {
                new URL(s.url);
                return true;
            } catch  {
                return false;
            }
        }), [
        sources
    ]);
    if (validSources.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c4602c274ef4436f$var$styles.box, showPadding && $c4602c274ef4436f$var$styles.boxPadding, showMarginBlock && $c4602c274ef4436f$var$styles.boxMarginBlock)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        placement: "top-start",
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bSXpv.SourcesPopupContent), {
                sources: validSources,
                onClickSourceHandler: onClickSourceHandler,
                onClickSource: onClickSource,
                onClose: ()=>setIsPopupOpen(false),
                xpcWrapUrl: xpcWrapUrl
            }),
        shouldRenderToParent: shouldRenderPopupToParent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: (0, $w6R6I.cx)($c4602c274ef4436f$var$styles.sourcesButton, isPopupOpen && $c4602c274ef4436f$var$styles.sourcesButtonSelected, (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') && $c4602c274ef4436f$var$styles.sourcesButtonRadiusMedium),
                onClick: handlePopupOpen,
                "aria-label": formatMessage((0, $iOpHH.default).sourcesTitle, {
                    sourceCount: validSources.length
                }),
                "aria-expanded": isPopupOpen,
                "aria-haspopup": "dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, formatMessage((0, $iOpHH.default).sourcesTitle, {
                sourceCount: validSources.length
            })), assistanceServiceParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NbSC.SourceIcons), {
                sources: validSources,
                assistanceServiceParams: assistanceServiceParams
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, assistanceServiceParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NbSC.SourceIcons), {
                sources: validSources,
                assistanceServiceParams: assistanceServiceParams
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, formatMessage((0, $iOpHH.default).sourcesTitle, {
                sourceCount: validSources.length
            })))))
    }));
};
function $c4602c274ef4436f$var$_temp(s) {
    if (!s?.url) return false;
    try {
        new URL(s.url);
        return true;
    } catch  {
        return false;
    }
}
module.exports["createFallbackComponent"] = $c4602c274ef4436f$export$fcc7cc8796e759fa;
module.exports["SourcesView"] = $c4602c274ef4436f$export$4468db6b0f4929c5;

});

parcelRegister("iOpHH", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ac5f292a6db02164$var$message = (0, $kSwu1.defineMessages)({
    sourcesTitle: {
        id: "ai-mate.message-renderer.sources.sources-title",
        defaultMessage: "{sourceCount, plural, one {# Source} other {# Sources}}"
    },
    closeSourcesPopup: {
        id: "ai-mate.message-renderer.sources.close-sources-popup",
        defaultMessage: "Close sources popup"
    }
});
var $ac5f292a6db02164$export$2e2bcd8739ae039 = $ac5f292a6db02164$var$message;
module.exports["default"] = $ac5f292a6db02164$export$2e2bcd8739ae039;

});

parcelRegister("bSXpv", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $kkFbH = parcelRequire("kkFbH");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");

var $es2gJ = parcelRequire("es2gJ");

var $jdA6O = parcelRequire("jdA6O");


var $lpNn5 = parcelRequire("lpNn5");


var $ahHdE = parcelRequire("ahHdE");


var $4ASef = parcelRequire("4ASef");


var $iOpHH = parcelRequire("iOpHH");

const $48b3b57b5fd708b0$var$styles = {
    popupContent: "_0Of8r22ADO _1Znuxb8HPE _1wydGW5zaO _2Zuz6Q8HPE _39xV02BmSS _0NUa3rHakr _2WAcuGIZbP",
    popupHeader: "_1DCdHiFQfX",
    popupHeaderText: "_2Zuz6Q2ADO",
    sourcesList: "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2Zuz6QPgdg",
    sourceCard: "_30huDKYbGa _2fwxA5ecOK",
    sourceListItem: "_0bjKvDKTcp _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0wOv4Q7zJH _0KLXrujOvk _1eOmH6o126",
    pdfLink: "_3iDTPbQ4SZ _0wOv4Q7zJH _2Zuz6QPgdg _1ZnuxbPgdg _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $48b3b57b5fd708b0$export$84948b04639263ce = ({ sources: sources, onClickSourceHandler: onClickSourceHandler, onClickSource: onClickSource, onClose: onClose, openSourceLinkInSameTab: openSourceLinkInSameTab = false, xpcWrapUrl: xpcWrapUrl })=>{
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const sourcesList = (0, $cozmU.useMemo)(()=>{
        return sources.map(({ url: url, title: title, type: type, ari: ari, product: product }, index)=>{
            if (!url) return null;
            const xpcProcessedUrl = xpcWrapUrl ? xpcWrapUrl(url, false) : url;
            const processedUrl = (0, $ahHdE.stripSlackQueryParams)(xpcProcessedUrl);
            const transformedUrl = processedUrl ? (0, $ahHdE.transformIfConfluenceLink)(processedUrl, true) : processedUrl;
            const originalTransformedUrl = (0, $ahHdE.transformIfConfluenceLink)(xpcProcessedUrl, true);
            const hasReadableTitle = (0, $ahHdE.resolvesToReadableTitle)(url, title);
            const displayTitle = hasReadableTitle ? title : (0, $ahHdE.extractReadableTitleFromUrl)(url);
            const skipResolution = (0, $ahHdE.shouldSkipSmartCardResolution)(url);
            const handleItemClick = (e)=>{
                onClickSourceHandler(type, ari, product, index);
                e.preventDefault();
                window.open(originalTransformedUrl, openSourceLinkInSameTab ? '_self' : '_blank', 'noopener, noreferrer');
            };
            const handleLiClick = (e)=>{
                onClickSourceHandler(type, ari, product, index);
            };
            const handlePressableClick = (e)=>{
                e.stopPropagation();
                handleItemClick(e);
            };
            const handleLiKeyDown = (e)=>{
                if (e.key === 'Enter' || e.key === ' ') onClickSourceHandler(type, ari, product, index);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
                key: index,
                onClick: skipResolution ? undefined : handleLiClick,
                onKeyDown: skipResolution ? undefined : handleLiKeyDown
            }, skipResolution ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                onClick: handlePressableClick,
                xcss: $48b3b57b5fd708b0$var$styles.sourceListItem
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: displayTitle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $48b3b57b5fd708b0$var$styles.pdfLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                size: "medium",
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium",
                weight: "regular",
                maxLines: 1,
                color: "color.link"
            }, displayTitle))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $48b3b57b5fd708b0$var$styles.sourceListItem
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $48b3b57b5fd708b0$var$styles.sourceCard
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                appearance: "block",
                url: transformedUrl,
                showHoverPreview: false,
                fallbackComponent: (0, $4ASef.createFallbackComponent)(url, type, displayTitle, ari, product, onClickSource, true, index),
                ui: {
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
                maxLines: 1
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
                maxLines: 2
            })))));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sources
    ]);
    const titleId = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useId();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $48b3b57b5fd708b0$var$styles.popupContent,
        role: "dialog",
        "aria-label": formatMessage((0, $iOpHH.default).sourcesTitle, {
            sourceCount: sources.length
        }),
        "aria-modal": "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.0",
        spread: "space-between",
        alignBlock: "center",
        xcss: $48b3b57b5fd708b0$var$styles.popupHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $48b3b57b5fd708b0$var$styles.popupHeaderText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        id: titleId
    }, formatMessage((0, $iOpHH.default).sourcesTitle, {
        sourceCount: sources.length
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...props,
                size: "small"
            }),
        label: formatMessage((0, $iOpHH.default).closeSourcesPopup),
        shape: "circle",
        onClick: onClose,
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        xcss: $48b3b57b5fd708b0$var$styles.sourcesList,
        space: "space.050"
    }, sourcesList));
};
module.exports["SourcesPopupContent"] = $48b3b57b5fd708b0$export$84948b04639263ce;

});

parcelRegister("4n04n", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $8OOZ2 = parcelRequire("8OOZ2");


var $6OV8L = parcelRequire("6OV8L");


var $4XbfY = parcelRequire("4XbfY");


var $3xuv0 = parcelRequire("3xuv0");


var $9DPMp = parcelRequire("9DPMp");

const $41ee172e87bea8b0$var$defaultSerializer = new (0, $3xuv0.JSONTransformer)();
function $41ee172e87bea8b0$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    let serializer = $41ee172e87bea8b0$var$defaultSerializer;
    if (featureToggles.markdownPlusUseNextLayoutSection) serializer = new (0, $3xuv0.JSONTransformer)((0, $8OOZ2.createSchema)({
        ...(0, $4XbfY.defaultSchemaConfig),
        customNodeSpecs: {
            layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn)
        }
    }));
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $41ee172e87bea8b0$var$getMentionMap(serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $41ee172e87bea8b0$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $41ee172e87bea8b0$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $41ee172e87bea8b0$var$getUserMentionValues(node) {
    if (node.attrs && $41ee172e87bea8b0$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $41ee172e87bea8b0$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}
module.exports["adfToMarkdownPlus"] = $41ee172e87bea8b0$export$bd172d9b9473ac80;

});

parcelRegister("9DPMp", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bjg0G = parcelRequire("bjg0G");


var $3cHXJ = parcelRequire("3cHXJ");


var $h2a2b = parcelRequire("h2a2b");

/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $b6f242e395dcdf98$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $b6f242e395dcdf98$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $b6f242e395dcdf98$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $b6f242e395dcdf98$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $bjg0G.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $b6f242e395dcdf98$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $b6f242e395dcdf98$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $b6f242e395dcdf98$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $b6f242e395dcdf98$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $b6f242e395dcdf98$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $b6f242e395dcdf98$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $b6f242e395dcdf98$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $b6f242e395dcdf98$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $b6f242e395dcdf98$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $h2a2b.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $3cHXJ.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $b6f242e395dcdf98$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $b6f242e395dcdf98$export$3d24004275aefeab;

});

parcelRegister("3cHXJ", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

class $c4cbf946cacc0222$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $aPdNQ.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $c4cbf946cacc0222$export$acf14785d7d5b1be;

});

parcelRegister("h2a2b", function(module, exports) {

var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $9bzIP = parcelRequire("9bzIP");


var $9t7Od = parcelRequire("9t7Od");


var $jOZYJ = parcelRequire("jOZYJ");


var $2MdWj = parcelRequire("2MdWj");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$AT_BLANK_REGEX = /(^|\n)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$TRAILING_WHITESPACE_REGEX = /\s+$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$INLINE_WHITESPACE_REGEX = /^(\s*)(.*?)(\s*)$/m;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$LEADING_BACKTICK_REGEX = /^`/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$TRAILING_BACKTICK_REGEX = /`$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$FOUR_SPACES_REGEX = /^\s{4}/;
const $63a440ce8b406510$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $2MdWj.stringRepeat)('`', length);
    };
})();
class $63a440ce8b406510$export$61055fa707e69319 extends (0, $2jzwX.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        return $63a440ce8b406510$var$AT_BLANK_REGEX.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                const trim = $63a440ce8b406510$var$TRAILING_WHITESPACE_REGEX.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = $63a440ce8b406510$var$INLINE_WHITESPACE_REGEX.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $63a440ce8b406510$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    if (text.match($63a440ce8b406510$var$LEADING_BACKTICK_REGEX)) text = ' ' + text;
                    if (text.match($63a440ce8b406510$var$TRAILING_BACKTICK_REGEX)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($63a440ce8b406510$export$695720b7e7a61533, $63a440ce8b406510$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $63a440ce8b406510$export$695720b7e7a61533;
        this.marks = $63a440ce8b406510$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $63a440ce8b406510$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $63a440ce8b406510$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $jOZYJ.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $aPdNQ.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $9t7Od.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $2MdWj.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $2MdWj.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            if (!previousNode && $63a440ce8b406510$var$FOUR_SPACES_REGEX.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $2MdWj.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$63a440ce8b406510$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            // For native embed extension nodes, output the embedded URL as a markdown link
            // so that it's visible to Rovo (same as embedCard/blockCard serialization)
            if (node.attrs.extensionKey?.startsWith('native-embed:')) {
                const url = node.attrs.parameters?.macroParams?.url?.value;
                if (url) {
                    state.write(`[${url}](${url})`);
                    return;
                }
            }
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $63a440ce8b406510$export$695720b7e7a61533 = {
    ...$63a440ce8b406510$var$editorNodes,
    ...(0, $9bzIP.default)
};
const $63a440ce8b406510$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};
module.exports["MarkdownSerializerState"] = $63a440ce8b406510$export$61055fa707e69319;

});

parcelRegister("9bzIP", function(module, exports) {

var $3nCzG = parcelRequire("3nCzG");

const $3b8284ec19aad1fa$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $3b8284ec19aad1fa$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $3b8284ec19aad1fa$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($3b8284ec19aad1fa$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $3b8284ec19aad1fa$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $3b8284ec19aad1fa$var$renderNode(state, child, i);
    });
};
const $3b8284ec19aad1fa$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $3b8284ec19aad1fa$var$renderNode(state, node, 0);
    state.write(' ');
};
const $3b8284ec19aad1fa$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $3b8284ec19aad1fa$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($3b8284ec19aad1fa$var$isHeaderRow(node) || $3b8284ec19aad1fa$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $3b8284ec19aad1fa$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $3b8284ec19aad1fa$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $3b8284ec19aad1fa$export$2e2bcd8739ae039 = $3b8284ec19aad1fa$var$tableNodes;
module.exports["default"] = $3b8284ec19aad1fa$export$2e2bcd8739ae039;

});

parcelRegister("3nCzG", function(module, exports) {
const $1a2f04a85d2bd5e4$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};
module.exports["attributesMatchDefault"] = $1a2f04a85d2bd5e4$export$5be26e657c035da4;

});

parcelRegister("9t7Od", function(module, exports) {
const $3e354f9230625cfb$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3e354f9230625cfb$export$53fd140c96bc558;

});

parcelRegister("jOZYJ", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

const $2fc5fefa720a7491$export$8ef94ae42a3729bd = 1;
const $2fc5fefa720a7491$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $2fc5fefa720a7491$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $aPdNQ.Node))) return $2fc5fefa720a7491$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $2fc5fefa720a7491$export$d445360e2a3c026b(order) ?? $2fc5fefa720a7491$export$8ef94ae42a3729bd;
};
module.exports["getOrderFromMaybeOrderedListNode"] = $2fc5fefa720a7491$export$4ea3c6bbdf8f7944;

});

parcelRegister("2MdWj", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$USERNAME_MATCH_REGEX = /^@(.*?)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$EMOJI_SHORTNAME_REGEX = /([^\/]+)\.[^\/]+$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX = /\w/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_LINE_START_REGEX = /^(\+[ ]|[\-*>])/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_HEADING_REGEX = /^(\s*)(#{1,6})(\s|$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_ORDERED_LIST_REGEX = /^(\s*\d+)\.\s/;
function $e99fb8d9fbca0ae0$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $e99fb8d9fbca0ae0$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match($e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX) && str[i + 1].match($e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape.replace($e99fb8d9fbca0ae0$var$ESCAPE_LINE_START_REGEX, '\\$&').replace($e99fb8d9fbca0ae0$var$ESCAPE_HEADING_REGEX, '$1\\$2$3').replace($e99fb8d9fbca0ae0$var$ESCAPE_ORDERED_LIST_REGEX, '$1\\. ');
    if (insideTable) // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
function $e99fb8d9fbca0ae0$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    node.textContent = node.textContent.replace(/\u200c|↵/g, '');
    Array.from(node.childNodes).forEach((child)=>$e99fb8d9fbca0ae0$var$removeSpecialCharacters(child));
}
function $e99fb8d9fbca0ae0$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $e99fb8d9fbca0ae0$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                const usernameMatch = title.match($e99fb8d9fbca0ae0$var$USERNAME_MATCH_REGEX);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            const idMatch = !src ? false : src.match($e99fb8d9fbca0ae0$var$EMOJI_SHORTNAME_REGEX);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}
module.exports["stringRepeat"] = $e99fb8d9fbca0ae0$export$345d822805ab3239;
module.exports["escapeMarkdown"] = $e99fb8d9fbca0ae0$export$560888d6fe0cfe97;

});

parcelRegister("kFTt2", function(module, exports) {

var $huGTe = parcelRequire("huGTe");


var $66Bcq = parcelRequire("66Bcq");


var $k8V2e = parcelRequire("k8V2e");

var $hcOES = parcelRequire("hcOES");


var $lIkvQ = parcelRequire("lIkvQ");

let $1fc2285692461264$var$analyticsClient;
const $1fc2285692461264$export$d4079397f9611138 = (client)=>{
    $1fc2285692461264$var$analyticsClient = client;
};
const $1fc2285692461264$export$bf406c01a195b215 = ()=>{
    $1fc2285692461264$var$analyticsClient = undefined;
};
const $1fc2285692461264$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $k8V2e.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($huGTe))));
        if (event && event.context) {
            const fullEvent = (0, $k8V2e.extractAWCDataFromEvent)(event);
            (0, $lIkvQ.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $lIkvQ.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $hcOES.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($1fc2285692461264$var$analyticsClient && $1fc2285692461264$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $1fc2285692461264$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $lIkvQ.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $1fc2285692461264$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $1fc2285692461264$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $1fc2285692461264$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $1fc2285692461264$export$2e2bcd8739ae039 = $1fc2285692461264$var$fireErrorAnalytics;
module.exports["default"] = $1fc2285692461264$export$2e2bcd8739ae039;

});

parcelRegister("huGTe", function(module, exports) {

var $4rtI4 = parcelRequire("4rtI4");


var $jOCrv = parcelRequire("jOCrv");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");


var $9pMwd = parcelRequire("9pMwd");


var $6DVFM = parcelRequire("6DVFM");


var $bAfjw = parcelRequire("bAfjw");


var $5J1xO = parcelRequire("5J1xO");

/** `Object#toString` result references. */ var $cbc68209f80e3755$var$mapTag = '[object Map]', $cbc68209f80e3755$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cbc68209f80e3755$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cbc68209f80e3755$var$hasOwnProperty = $cbc68209f80e3755$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cbc68209f80e3755$var$isEmpty(value) {
    if (value == null) return true;
    if ($9pMwd(value) && ($1ScXu(value) || typeof value == 'string' || typeof value.splice == 'function' || $6DVFM(value) || $5J1xO(value) || $bZ5J1(value))) return !value.length;
    var tag = $jOCrv(value);
    if (tag == $cbc68209f80e3755$var$mapTag || tag == $cbc68209f80e3755$var$setTag) return !value.size;
    if ($bAfjw(value)) return !$4rtI4(value).length;
    for(var key in value){
        if ($cbc68209f80e3755$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cbc68209f80e3755$var$isEmpty;

});

parcelRegister("k8V2e", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $jYwtP = parcelRequire("jYwtP");


var $8El2z = parcelRequire("8El2z");

const $035dbde6912e4d4c$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8El2z.getAnalyticsType)(castedEvent);
    const attributes = (0, $8El2z.getAttributes)(castedEvent);
    const source = (0, $8El2z.getSource)(castedEvent);
    const actionSubject = (0, $8El2z.getActionSubject)(castedEvent);
    if (analyticsType === (0, $jYwtP.SCREEN_EVENT_TYPE)) return {
        type: (0, $jYwtP.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $jYwtP.UI_EVENT_TYPE:
        case 0, $jYwtP.TRACK_EVENT_TYPE:
        case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $8El2z.getAction)(castedEvent);
                const actionSubjectId = (0, $8El2z.getActionSubjectId)(castedEvent);
                const containerId = (0, $8El2z.getContainerId)(castedEvent);
                const containerType = (0, $8El2z.getContainerType)(castedEvent);
                const objectId = (0, $8El2z.getObjectId)(castedEvent);
                const objectType = (0, $8El2z.getObjectType)(castedEvent);
                const tags = (0, $8El2z.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $035dbde6912e4d4c$export$1c850cf68c053906;

});

parcelRegister("emZLc", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a763071343fcb354$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a763071343fcb354$var$isUndefined;

});

parcelRegister("jYwtP", function(module, exports) {
const $fec988d562d5bfbb$export$f636b5b56f1d624a = 'Screen';
const $fec988d562d5bfbb$export$9d2de6eebf7462b5 = 'Drawer';
const $fec988d562d5bfbb$export$1171103ea9083ffa = 'Modal';
const $fec988d562d5bfbb$export$cae2783c9279926 = 'InlineDialog';
const $fec988d562d5bfbb$export$d1123261ca8831d2 = 'Dropdown';
const $fec988d562d5bfbb$export$a1562d08625f5d7e = 'UI';
const $fec988d562d5bfbb$export$947dac6c72b26f81 = 'TRACK';
const $fec988d562d5bfbb$export$f1d537d508d2945a = 'SCREEN';
const $fec988d562d5bfbb$export$12346a674644c156 = 'OPERATIONAL';
const $fec988d562d5bfbb$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $fec988d562d5bfbb$export$f636b5b56f1d624a;
module.exports["MODAL"] = $fec988d562d5bfbb$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $fec988d562d5bfbb$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $fec988d562d5bfbb$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $fec988d562d5bfbb$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $fec988d562d5bfbb$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $fec988d562d5bfbb$export$2ceccf177fae277c;

});

parcelRegister("8El2z", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $emZLc = parcelRequire("emZLc");


var $gO1os = parcelRequire("gO1os");


var $lYpJw = parcelRequire("lYpJw");


var $66Bcq = parcelRequire("66Bcq");


var $1wIeS = parcelRequire("1wIeS");

const $c9f6533ef6431d6e$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $c9f6533ef6431d6e$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $c9f6533ef6431d6e$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $c9f6533ef6431d6e$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $c9f6533ef6431d6e$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $c9f6533ef6431d6e$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'source').filter(Boolean));
const $c9f6533ef6431d6e$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $c9f6533ef6431d6e$export$6ca3170acb89054 = (event)=>event.payload.action;
const $c9f6533ef6431d6e$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $c9f6533ef6431d6e$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerId').filter(Boolean));
const $c9f6533ef6431d6e$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerType').filter(Boolean));
const $c9f6533ef6431d6e$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectId').filter(Boolean));
const $c9f6533ef6431d6e$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectType').filter(Boolean));
const $c9f6533ef6431d6e$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))((0, (/*@__PURE__*/$parcel$interopDefault($lyW2B)))($c9f6533ef6431d6e$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $c9f6533ef6431d6e$export$a3569ac53b82a914;
module.exports["getAttributes"] = $c9f6533ef6431d6e$export$fe94072fee8a6976;
module.exports["getSource"] = $c9f6533ef6431d6e$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $c9f6533ef6431d6e$export$6f40cdf6d42c018d;
module.exports["getAction"] = $c9f6533ef6431d6e$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $c9f6533ef6431d6e$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $c9f6533ef6431d6e$export$7c8178cc9001d237;
module.exports["getContainerType"] = $c9f6533ef6431d6e$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $c9f6533ef6431d6e$export$fa986b91291934c7;
module.exports["getObjectType"] = $c9f6533ef6431d6e$export$11cc42aebef2ef3a;
module.exports["getTags"] = $c9f6533ef6431d6e$export$af63d7414243dad3;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("hcOES", function(module, exports) {

var $gO1os = parcelRequire("gO1os");


var $jYwtP = parcelRequire("jYwtP");


var $5sm3M = parcelRequire("5sm3M");

const $2b7c6f2b383d7d91$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL));
};
const $2b7c6f2b383d7d91$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $2b7c6f2b383d7d91$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $2b7c6f2b383d7d91$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $2b7c6f2b383d7d91$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $2b7c6f2b383d7d91$export$79f423cc3fd39762;

});

parcelRegister("5sm3M", function(module, exports) {
const $8f4a194f3d46df20$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $8f4a194f3d46df20$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $8f4a194f3d46df20$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $8f4a194f3d46df20$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $8f4a194f3d46df20$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $8f4a194f3d46df20$export$e6baab532ef8c6bf;

});

parcelRegister("lIkvQ", function(module, exports) {

var $l54O9 = parcelRequire("l54O9");

const $34ee97725f8181a5$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $l54O9.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $34ee97725f8181a5$export$f5282963edea4a68 = (location, error, details = {})=>(0, $l54O9.default).captureException(location, error, details);
module.exports["captureException"] = $34ee97725f8181a5$export$f5282963edea4a68;

});

parcelRegister("l54O9", function(module, exports) {
// This is the only file that should directly import Raven.

var $9HPf3 = parcelRequire("9HPf3");

var $amM2J = parcelRequire("amM2J");

var $eAdCn = parcelRequire("eAdCn");


var $iyIOY = parcelRequire("iyIOY");

var $6W0Xl = parcelRequire("6W0Xl");

var $fa95z = parcelRequire("fa95z");

var $hLq0X = parcelRequire("hLq0X");


var $1wIeS = parcelRequire("1wIeS");

const $15510fe24ae0eb31$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $15510fe24ae0eb31$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $15510fe24ae0eb31$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $15510fe24ae0eb31$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $15510fe24ae0eb31$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $amM2J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $15510fe24ae0eb31$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$15510fe24ae0eb31$var$getFilteredIntegrations(integrations),
                new $6W0Xl.Dedupe(),
                new $fa95z.ExtraErrorData(),
                new $hLq0X.Transaction(),
                new $iyIOY.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $eAdCn.init({
        ...defaultConfig,
        ...config
    });
    try {
        $9HPf3.setExtras(getExtraContext());
    } catch (e) {
        $9HPf3.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $15510fe24ae0eb31$var$tags = [
    'packageName',
    'teamName'
];
const $15510fe24ae0eb31$var$captureException = (location, error, details)=>{
    $9HPf3.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($15510fe24ae0eb31$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $9HPf3.captureException(error);
};
const $15510fe24ae0eb31$var$sentryErrorHandler = {
    installGlobalHandler: $15510fe24ae0eb31$var$installGlobalHandler,
    captureException: $15510fe24ae0eb31$var$captureException
};
var $15510fe24ae0eb31$export$2e2bcd8739ae039 = $15510fe24ae0eb31$var$sentryErrorHandler;
module.exports["default"] = $15510fe24ae0eb31$export$2e2bcd8739ae039;

});

parcelRegister("9HPf3", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $amM2J = parcelRequire("amM2J");

/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $710fe0c9136a2e3d$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $amM2J.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $fbwmZ.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $710fe0c9136a2e3d$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $710fe0c9136a2e3d$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $710fe0c9136a2e3d$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $710fe0c9136a2e3d$var$callOnHub('captureMessage', message, level, (0, $fbwmZ.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $710fe0c9136a2e3d$export$1462b974fdcf6ba2(event) {
    return $710fe0c9136a2e3d$var$callOnHub('captureEvent', event);
}
function $710fe0c9136a2e3d$export$99d44f04437e9cb8(callback) {
    $710fe0c9136a2e3d$var$callOnHub('configureScope', callback);
}
function $710fe0c9136a2e3d$export$efda9a273d7a036d(breadcrumb) {
    $710fe0c9136a2e3d$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $710fe0c9136a2e3d$export$2f04de43fe27971a(name, context) {
    $710fe0c9136a2e3d$var$callOnHub('setContext', name, context);
}
function $710fe0c9136a2e3d$export$bb4922da0dd51b92(extras) {
    $710fe0c9136a2e3d$var$callOnHub('setExtras', extras);
}
function $710fe0c9136a2e3d$export$74a8fb34822092e6(tags) {
    $710fe0c9136a2e3d$var$callOnHub('setTags', tags);
}
function $710fe0c9136a2e3d$export$8e8e7789d42ed61d(key, extra) {
    $710fe0c9136a2e3d$var$callOnHub('setExtra', key, extra);
}
function $710fe0c9136a2e3d$export$a37d07ee78eb4569(key, value) {
    $710fe0c9136a2e3d$var$callOnHub('setTag', key, value);
}
function $710fe0c9136a2e3d$export$8b6bb3dd62a01be2(user) {
    $710fe0c9136a2e3d$var$callOnHub('setUser', user);
}
function $710fe0c9136a2e3d$export$ec58d9285c204497(callback) {
    $710fe0c9136a2e3d$var$callOnHub('withScope', callback);
}
function $710fe0c9136a2e3d$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $710fe0c9136a2e3d$var$callOnHub.apply(void 0, (0, $fbwmZ.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $710fe0c9136a2e3d$export$e262da7ae6480481(context, customSamplingContext) {
    return $710fe0c9136a2e3d$var$callOnHub('startTransaction', (0, $fbwmZ.__assign)({}, context), customSamplingContext);
} //# sourceMappingURL=index.js.map
module.exports["captureException"] = $710fe0c9136a2e3d$export$f5282963edea4a68;
module.exports["captureMessage"] = $710fe0c9136a2e3d$export$45654777c133ae80;
module.exports["captureEvent"] = $710fe0c9136a2e3d$export$1462b974fdcf6ba2;
module.exports["configureScope"] = $710fe0c9136a2e3d$export$99d44f04437e9cb8;
module.exports["addBreadcrumb"] = $710fe0c9136a2e3d$export$efda9a273d7a036d;
module.exports["setContext"] = $710fe0c9136a2e3d$export$2f04de43fe27971a;
module.exports["setExtras"] = $710fe0c9136a2e3d$export$bb4922da0dd51b92;
module.exports["setTags"] = $710fe0c9136a2e3d$export$74a8fb34822092e6;
module.exports["setExtra"] = $710fe0c9136a2e3d$export$8e8e7789d42ed61d;
module.exports["setTag"] = $710fe0c9136a2e3d$export$a37d07ee78eb4569;
module.exports["setUser"] = $710fe0c9136a2e3d$export$8b6bb3dd62a01be2;
module.exports["withScope"] = $710fe0c9136a2e3d$export$ec58d9285c204497;
module.exports["startTransaction"] = $710fe0c9136a2e3d$export$e262da7ae6480481;

});

parcelRegister("amM2J", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("jyOOl");
var $jdXEW = parcelRequire("jdXEW");
var $6eouj = parcelRequire("6eouj");
var $1pyrV = parcelRequire("1pyrV");
var $kuBRj = parcelRequire("kuBRj");
var $i6z6R = parcelRequire("i6z6R");


var $20QP6 = parcelRequire("20QP6");


var $hkv0W = parcelRequire("hkv0W");


var $dQl3s = parcelRequire("dQl3s");

var $78c139cc7b9f08ca$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $78c139cc7b9f08ca$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $78c139cc7b9f08ca$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $hkv0W.Scope)();
        if (_version === void 0) _version = $78c139cc7b9f08ca$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $hkv0W.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $i6z6R.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $i6z6R.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $i6z6R.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $78c139cc7b9f08ca$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $6eouj.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $fbwmZ.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $jdXEW.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $78c139cc7b9f08ca$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $78c139cc7b9f08ca$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $20QP6.IS_DEBUG_BUILD) && (0, $jdXEW.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $1pyrV.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $dQl3s.Session)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $fbwmZ.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $78c139cc7b9f08ca$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $20QP6.IS_DEBUG_BUILD) && (0, $jdXEW.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $78c139cc7b9f08ca$export$19eade501500c6c1() {
    var carrier = (0, $1pyrV.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $78c139cc7b9f08ca$export$4188a14ad302d1bc(hub) {
    var registry = $78c139cc7b9f08ca$export$19eade501500c6c1();
    var oldHub = $78c139cc7b9f08ca$export$bfa8a924a84a76b7(registry);
    $78c139cc7b9f08ca$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $78c139cc7b9f08ca$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $78c139cc7b9f08ca$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$78c139cc7b9f08ca$var$hasHubOnCarrier(registry) || $78c139cc7b9f08ca$export$bfa8a924a84a76b7(registry).isOlderThan($78c139cc7b9f08ca$export$24a86ef7798177e4)) $78c139cc7b9f08ca$export$849f05434e95d2f2(registry, new $78c139cc7b9f08ca$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $kuBRj.isNodeEnv)()) return $78c139cc7b9f08ca$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $78c139cc7b9f08ca$export$bfa8a924a84a76b7(registry);
}
function $78c139cc7b9f08ca$export$1c4d656130202699() {
    (0, $20QP6.IS_DEBUG_BUILD) && (0, $jdXEW.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $78c139cc7b9f08ca$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $78c139cc7b9f08ca$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $78c139cc7b9f08ca$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $78c139cc7b9f08ca$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$78c139cc7b9f08ca$var$hasHubOnCarrier(activeDomain) || $78c139cc7b9f08ca$export$bfa8a924a84a76b7(activeDomain).isOlderThan($78c139cc7b9f08ca$export$24a86ef7798177e4)) {
            var registryHubTopStack = $78c139cc7b9f08ca$export$bfa8a924a84a76b7(registry).getStackTop();
            $78c139cc7b9f08ca$export$849f05434e95d2f2(activeDomain, new $78c139cc7b9f08ca$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $hkv0W.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $78c139cc7b9f08ca$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $78c139cc7b9f08ca$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $78c139cc7b9f08ca$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $78c139cc7b9f08ca$export$bfa8a924a84a76b7(carrier) {
    return (0, $1pyrV.getGlobalSingleton)('hub', function() {
        return new $78c139cc7b9f08ca$export$8c41bb232f1008b1();
    }, carrier);
}
function $78c139cc7b9f08ca$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
} //# sourceMappingURL=hub.js.map
module.exports["Hub"] = $78c139cc7b9f08ca$export$8c41bb232f1008b1;
module.exports["makeMain"] = $78c139cc7b9f08ca$export$4188a14ad302d1bc;
module.exports["getHubFromCarrier"] = $78c139cc7b9f08ca$export$bfa8a924a84a76b7;
module.exports["getCurrentHub"] = $78c139cc7b9f08ca$export$a07cdf6544bbd7c;

});

parcelRegister("jyOOl", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("1pyrV")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("1pyrV")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("atXMg")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("atXMg")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("jdXEW")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("jdXEW")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("i6z6R")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("fig2R")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("6tQQ6")).SyncPromise);





parcelRequire("1pyrV");


parcelRequire("atXMg");

parcelRequire("jdXEW");


parcelRequire("i6z6R");


var $kuBRj = parcelRequire("kuBRj");


parcelRequire("fig2R");








parcelRequire("6tQQ6");


var $6eouj = parcelRequire("6eouj");






 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $kuBRj);
$parcel$exportWildcard(module.exports, $6eouj);

});

parcelRegister("1rird", function(module, exports) {

var $1pyrV = parcelRequire("1pyrV");


var $atXMg = parcelRequire("atXMg");

function $10c69d78ea6b1336$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $10c69d78ea6b1336$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $10c69d78ea6b1336$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $atXMg.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $10c69d78ea6b1336$export$1cfafeee2987818b() {
    var global = (0, $1pyrV.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
} //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $10c69d78ea6b1336$export$5647df6b7814ac86;

});

parcelRegister("1pyrV", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $kuBRj = parcelRequire("kuBRj");

var $1072d93163c72622$var$fallbackGlobalObject = {};
function $1072d93163c72622$export$256479dc0cea61c4() {
    return (0, $kuBRj.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $1072d93163c72622$var$fallbackGlobalObject;
}
function $1072d93163c72622$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $1072d93163c72622$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
} //# sourceMappingURL=global.js.map
module.exports["getGlobalObject"] = $1072d93163c72622$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $1072d93163c72622$export$7e223ec222791509;

});

parcelRegister("kuBRj", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $hwVOT = parcelRequire("hwVOT");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $hwVOT.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
} //# sourceMappingURL=node.js.map

});

parcelRegister("hwVOT", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $cc3246a3366d1315$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
} //# sourceMappingURL=env.js.map
module.exports["isBrowserBundle"] = $cc3246a3366d1315$export$2928c40372e623c0;

});

parcelRegister("atXMg", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $7a1afb6197e5d298$var$objectToString = Object.prototype.toString;
function $7a1afb6197e5d298$export$e6127cc7fe7395c3(wat) {
    switch($7a1afb6197e5d298$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $7a1afb6197e5d298$export$49034edbe6b62415(wat, Error);
    }
}
function $7a1afb6197e5d298$var$isBuiltin(wat, ty) {
    return $7a1afb6197e5d298$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $7a1afb6197e5d298$export$9f9636d330b71954(wat) {
    return $7a1afb6197e5d298$var$isBuiltin(wat, 'ErrorEvent');
}
function $7a1afb6197e5d298$export$ef9e2056653f0c8e(wat) {
    return $7a1afb6197e5d298$var$isBuiltin(wat, 'DOMError');
}
function $7a1afb6197e5d298$export$12e869b2a583f783(wat) {
    return $7a1afb6197e5d298$var$isBuiltin(wat, 'DOMException');
}
function $7a1afb6197e5d298$export$844ec244b1367d54(wat) {
    return $7a1afb6197e5d298$var$isBuiltin(wat, 'String');
}
function $7a1afb6197e5d298$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $7a1afb6197e5d298$export$53b83ca8eaab0383(wat) {
    return $7a1afb6197e5d298$var$isBuiltin(wat, 'Object');
}
function $7a1afb6197e5d298$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $7a1afb6197e5d298$export$49034edbe6b62415(wat, Event);
}
function $7a1afb6197e5d298$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $7a1afb6197e5d298$export$49034edbe6b62415(wat, Element);
}
function $7a1afb6197e5d298$export$49841c62b9eff15(wat) {
    return $7a1afb6197e5d298$var$isBuiltin(wat, 'RegExp');
}
function $7a1afb6197e5d298$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $7a1afb6197e5d298$export$bc2894c7158efbac(wat) {
    return $7a1afb6197e5d298$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $7a1afb6197e5d298$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $7a1afb6197e5d298$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
} //# sourceMappingURL=is.js.map
module.exports["isError"] = $7a1afb6197e5d298$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $7a1afb6197e5d298$export$49034edbe6b62415;
module.exports["isString"] = $7a1afb6197e5d298$export$844ec244b1367d54;
module.exports["isPrimitive"] = $7a1afb6197e5d298$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $7a1afb6197e5d298$export$53b83ca8eaab0383;
module.exports["isEvent"] = $7a1afb6197e5d298$export$9671ea99bd126ace;
module.exports["isElement"] = $7a1afb6197e5d298$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $7a1afb6197e5d298$export$49841c62b9eff15;
module.exports["isThenable"] = $7a1afb6197e5d298$export$f5b060c2914b97c8;

});

parcelRegister("jdXEW", function(module, exports) {
$parcel$export(module.exports, "logger", () => $dfed825592f9ecfc$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $gJu5r = parcelRequire("gJu5r");


var $1pyrV = parcelRequire("1pyrV");

// TODO: Implement different loggers for different environments
var $dfed825592f9ecfc$var$global = (0, $1pyrV.getGlobalObject)();
/** Prefix for logging strings */ var $dfed825592f9ecfc$var$PREFIX = 'Sentry Logger ';
var $dfed825592f9ecfc$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $dfed825592f9ecfc$export$cda52e2a8927a2ca(callback) {
    var global = (0, $1pyrV.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $dfed825592f9ecfc$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $dfed825592f9ecfc$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $gJu5r.IS_DEBUG_BUILD) $dfed825592f9ecfc$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $dfed825592f9ecfc$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $dfed825592f9ecfc$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $dfed825592f9ecfc$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $dfed825592f9ecfc$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $dfed825592f9ecfc$export$af88d00dbe7f521;
if (0, $gJu5r.IS_DEBUG_BUILD) $dfed825592f9ecfc$export$af88d00dbe7f521 = (0, $1pyrV.getGlobalSingleton)('logger', $dfed825592f9ecfc$var$makeLogger);
else $dfed825592f9ecfc$export$af88d00dbe7f521 = $dfed825592f9ecfc$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["consoleSandbox"] = $dfed825592f9ecfc$export$cda52e2a8927a2ca;

});

parcelRegister("gJu5r", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $c2e82fe56dd7aafe$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $c2e82fe56dd7aafe$export$48a8984ec0bf2e44;

});

parcelRegister("i6z6R", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $1pyrV = parcelRequire("1pyrV");


var $fig2R = parcelRequire("fig2R");


var $5WUwD = parcelRequire("5WUwD");

function $d2e4058e0dc41675$export$19f53698e68b2496() {
    var global = (0, $1pyrV.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $d2e4058e0dc41675$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $d2e4058e0dc41675$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $d2e4058e0dc41675$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $d2e4058e0dc41675$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $d2e4058e0dc41675$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $d2e4058e0dc41675$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $d2e4058e0dc41675$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $d2e4058e0dc41675$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $d2e4058e0dc41675$export$d364f2020ab30578(input) {
    var match = input.match($d2e4058e0dc41675$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $d2e4058e0dc41675$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $5WUwD.snipLine)(line, 0);
    });
    frame.context_line = (0, $5WUwD.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $5WUwD.snipLine)(line, 0);
    });
}
function $d2e4058e0dc41675$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $d2e4058e0dc41675$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $fig2R.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
} //# sourceMappingURL=misc.js.map
module.exports["uuid4"] = $d2e4058e0dc41675$export$19f53698e68b2496;

});

parcelRegister("fig2R", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $1rird = parcelRequire("1rird");


var $atXMg = parcelRequire("atXMg");


var $5WUwD = parcelRequire("5WUwD");

function $b224fbb3fe1e90d7$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $b224fbb3fe1e90d7$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $b224fbb3fe1e90d7$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $b224fbb3fe1e90d7$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $b224fbb3fe1e90d7$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $b224fbb3fe1e90d7$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $b224fbb3fe1e90d7$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $b224fbb3fe1e90d7$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $atXMg.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $b224fbb3fe1e90d7$var$getOwnProperties(value));
    else if ((0, $atXMg.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $b224fbb3fe1e90d7$var$serializeEventTarget(event_1.target),
            currentTarget: $b224fbb3fe1e90d7$var$serializeEventTarget(event_1.currentTarget)
        }, $b224fbb3fe1e90d7$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $atXMg.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $b224fbb3fe1e90d7$var$serializeEventTarget(target) {
    try {
        return (0, $atXMg.isElement)(target) ? (0, $1rird.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $b224fbb3fe1e90d7$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $b224fbb3fe1e90d7$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($b224fbb3fe1e90d7$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $5WUwD.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $5WUwD.truncate)(serialized, maxLength);
    }
    return '';
}
function $b224fbb3fe1e90d7$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $atXMg.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $b224fbb3fe1e90d7$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($b224fbb3fe1e90d7$export$d25f2688db1bb433);
    return val;
}
function $b224fbb3fe1e90d7$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $atXMg.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
} //# sourceMappingURL=object.js.map
module.exports["addNonEnumerableProperty"] = $b224fbb3fe1e90d7$export$e73679ffaf56810e;
module.exports["dropUndefinedKeys"] = $b224fbb3fe1e90d7$export$d25f2688db1bb433;

});

parcelRegister("5WUwD", function(module, exports) {

var $atXMg = parcelRequire("atXMg");

function $454e3747831d531d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $454e3747831d531d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $454e3747831d531d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $454e3747831d531d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $atXMg.isString)(value)) return false;
    if ((0, $atXMg.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $454e3747831d531d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
} //# sourceMappingURL=string.js.map
module.exports["truncate"] = $454e3747831d531d$export$6a506b36fdea397d;
module.exports["snipLine"] = $454e3747831d531d$export$4215662d762d6f9d;

});

parcelRegister("6tQQ6", function(module, exports) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $atXMg = parcelRequire("atXMg");

function $4b7e704fcd2047ce$export$1fda8aa4d135f8aa(value) {
    return new $4b7e704fcd2047ce$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $4b7e704fcd2047ce$export$78e43115b553f358(reason) {
    return new $4b7e704fcd2047ce$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $4b7e704fcd2047ce$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $atXMg.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();
 //# sourceMappingURL=syncpromise.js.map
module.exports["SyncPromise"] = $4b7e704fcd2047ce$export$6f292d4960313241;

});

parcelRegister("6eouj", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $1pyrV = parcelRequire("1pyrV");


var $kuBRj = parcelRequire("kuBRj");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $1pyrV.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $kuBRj.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $kuBRj.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $1pyrV.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}(); //# sourceMappingURL=time.js.map

});

parcelRegister("20QP6", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $17748e7393626fcb$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $17748e7393626fcb$export$48a8984ec0bf2e44;

});

parcelRegister("hkv0W", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("jyOOl");
var $6eouj = parcelRequire("6eouj");
var $1pyrV = parcelRequire("1pyrV");
var $atXMg = parcelRequire("atXMg");
var $6tQQ6 = parcelRequire("6tQQ6");

/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $c9dc5cb228b8f1e3$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $c9dc5cb228b8f1e3$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $fbwmZ.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $fbwmZ.__assign)({}, scope._tags);
            newScope._extra = (0, $fbwmZ.__assign)({}, scope._extra);
            newScope._contexts = (0, $fbwmZ.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $fbwmZ.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $atXMg.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $c9dc5cb228b8f1e3$var$MAX_BREADCRUMBS) : $c9dc5cb228b8f1e3$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $fbwmZ.__assign)({
            timestamp: (0, $6eouj.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $fbwmZ.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $fbwmZ.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $fbwmZ.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $fbwmZ.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $fbwmZ.__spread)($c9dc5cb228b8f1e3$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $6tQQ6.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $fbwmZ.__assign)({}, event), hint);
                if ((0, $atXMg.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $c9dc5cb228b8f1e3$var$getGlobalEventProcessors() {
    return (0, $1pyrV.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $c9dc5cb228b8f1e3$export$8e4e25f54d456511(callback) {
    $c9dc5cb228b8f1e3$var$getGlobalEventProcessors().push(callback);
} //# sourceMappingURL=scope.js.map
module.exports["Scope"] = $c9dc5cb228b8f1e3$export$775b6bb06e53a214;
module.exports["addGlobalEventProcessor"] = $c9dc5cb228b8f1e3$export$8e4e25f54d456511;

});

parcelRegister("dQl3s", function(module, exports) {
parcelRequire("jyOOl");
var $fig2R = parcelRequire("fig2R");
var $6eouj = parcelRequire("6eouj");
var $i6z6R = parcelRequire("i6z6R");

/**
 * @inheritdoc
 */ var $a14076bb28326451$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $i6z6R.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $6eouj.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $6eouj.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $i6z6R.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $fig2R.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();
 //# sourceMappingURL=session.js.map
module.exports["Session"] = $a14076bb28326451$export$1fb4852a55678982;

});

parcelRegister("eAdCn", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $amM2J = parcelRequire("amM2J");

var $fIvm5 = parcelRequire("fIvm5");

var $ilRwI = parcelRequire("ilRwI");

parcelRequire("6NrTk");
var $hX59D = parcelRequire("hX59D");
var $jqTnS = parcelRequire("jqTnS");
var $eVWro = parcelRequire("eVWro");
var $d9uty = parcelRequire("d9uty");


var $e9HlS = parcelRequire("e9HlS");


var $4vRQe = parcelRequire("4vRQe");


var $9whyS = parcelRequire("9whyS");


var $bNfZ4 = parcelRequire("bNfZ4");

var $lBiNe = parcelRequire("lBiNe");

var $cEELl = parcelRequire("cEELl");

var $6oUta = parcelRequire("6oUta");

var $51FBI = parcelRequire("51FBI");

var $aMh6Y = parcelRequire("aMh6Y");

var $a9defdbce8aac352$export$5ef831fccfce35e5 = [
    new (0, $ilRwI).InboundFilters(),
    new (0, $ilRwI).FunctionToString(),
    new (0, $51FBI.TryCatch)(),
    new (0, $bNfZ4.Breadcrumbs)(),
    new (0, $cEELl.GlobalHandlers)(),
    new (0, $6oUta.LinkedErrors)(),
    new (0, $lBiNe.Dedupe)(),
    new (0, $aMh6Y.UserAgent)()
];
function $a9defdbce8aac352$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $a9defdbce8aac352$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $jqTnS.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $fIvm5.initAndBind)((0, $e9HlS.BrowserClient), options);
    if (options.autoSessionTracking) $a9defdbce8aac352$var$startSessionTracking();
}
function $a9defdbce8aac352$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $amM2J.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $a9defdbce8aac352$export$5d4e9fd7fac8e617() {
    return (0, $amM2J.getCurrentHub)().lastEventId();
}
function $a9defdbce8aac352$export$a3f323d81eede727() {
// Noop
}
function $a9defdbce8aac352$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $a9defdbce8aac352$export$4909b86c8034bf73(timeout) {
    var client = (0, $amM2J.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Cannot flush events. No client defined.');
    return (0, $d9uty.resolvedSyncPromise)(false);
}
function $a9defdbce8aac352$export$8360e631d277ea4d(timeout) {
    var client = (0, $amM2J.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $d9uty.resolvedSyncPromise)(false);
}
function $a9defdbce8aac352$export$4997ffc0176396a6(fn) {
    return (0, $9whyS.wrap)(fn)();
}
function $a9defdbce8aac352$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $a9defdbce8aac352$var$startSessionTracking() {
    var window = (0, $jqTnS.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $amM2J.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $a9defdbce8aac352$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $hX59D.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $a9defdbce8aac352$var$startSessionOnHub((0, $amM2J.getCurrentHub)());
    });
} //# sourceMappingURL=sdk.js.map
module.exports["defaultIntegrations"] = $a9defdbce8aac352$export$5ef831fccfce35e5;
module.exports["init"] = $a9defdbce8aac352$export$2cd8252107eb640b;
module.exports["showReportDialog"] = $a9defdbce8aac352$export$3a8fd680da42627b;
module.exports["lastEventId"] = $a9defdbce8aac352$export$5d4e9fd7fac8e617;
module.exports["forceLoad"] = $a9defdbce8aac352$export$a3f323d81eede727;
module.exports["onLoad"] = $a9defdbce8aac352$export$4e4d8b287d028b6b;
module.exports["flush"] = $a9defdbce8aac352$export$4909b86c8034bf73;
module.exports["close"] = $a9defdbce8aac352$export$8360e631d277ea4d;
module.exports["wrap"] = $a9defdbce8aac352$export$4997ffc0176396a6;

});

parcelRegister("fIvm5", function(module, exports) {

var $amM2J = parcelRequire("amM2J");

parcelRequire("6NrTk");
var $eVWro = parcelRequire("eVWro");


var $asCdn = parcelRequire("asCdn");

function $b713498defe7f84d$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $asCdn.IS_DEBUG_BUILD) (0, $eVWro.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $amM2J.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
} //# sourceMappingURL=sdk.js.map
module.exports["initAndBind"] = $b713498defe7f84d$export$5333c3f1c58d9bc1;

});

parcelRegister("6NrTk", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("2Van4")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("dx3aE")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("dx3aE")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("4xfBg")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("4xfBg")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("4y4n7")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("jqTnS")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("hX59D")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("23i8z")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("23i8z")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("23i8z")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("23i8z")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("23i8z")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("23i8z")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("23i8z")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("23i8z")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("23i8z")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("23i8z")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("eVWro")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("4XALr")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("4XALr")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("4XALr")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("4XALr")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("4XALr")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("4XALr")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("fmzj4")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("fmzj4")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("56AkW")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("56AkW")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("56AkW")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("56AkW")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("56AkW")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("56AkW")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("cY6s3")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("hjoOD")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("1MAkl")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("1MAkl")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("28HPT")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("iXZ4U")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("iXZ4U")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("iXZ4U")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("kmhID")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("kmhID")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("kmhID")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("d9uty")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("d9uty")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("d9uty")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("hgNA8")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("hgNA8")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("hgNA8")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("2TAee")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("dWiTY")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("dWiTY")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("dWiTY")).updateRateLimits);
parcelRequire("2Van4");

parcelRequire("dx3aE");

parcelRequire("4xfBg");


parcelRequire("4y4n7");

parcelRequire("jqTnS");

parcelRequire("hX59D");

parcelRequire("23i8z");

parcelRequire("eVWro");


parcelRequire("4XALr");


var $2C75o = parcelRequire("2C75o");

parcelRequire("fmzj4");

parcelRequire("56AkW");


parcelRequire("cY6s3");

parcelRequire("hjoOD");

parcelRequire("1MAkl");

parcelRequire("28HPT");

parcelRequire("iXZ4U");

parcelRequire("kmhID");

parcelRequire("d9uty");


var $f6xuJ = parcelRequire("f6xuJ");



parcelRequire("hgNA8");

parcelRequire("2TAee");

parcelRequire("dWiTY");

 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $2C75o);
$parcel$exportWildcard(module.exports, $f6xuJ);

});

parcelRegister("2Van4", function(module, exports) {
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2208f325376600d6$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
} //# sourceMappingURL=async.js.map
module.exports["forget"] = $2208f325376600d6$export$93c25f2590a5b540;

});

parcelRegister("dx3aE", function(module, exports) {

var $jqTnS = parcelRequire("jqTnS");


var $23i8z = parcelRequire("23i8z");

function $9da0d114b61ca33c$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $9da0d114b61ca33c$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9da0d114b61ca33c$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $23i8z.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $9da0d114b61ca33c$export$1cfafeee2987818b() {
    var global = (0, $jqTnS.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
} //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $9da0d114b61ca33c$export$5647df6b7814ac86;
module.exports["getLocationHref"] = $9da0d114b61ca33c$export$1cfafeee2987818b;

});

parcelRegister("jqTnS", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $2C75o = parcelRequire("2C75o");

var $e25b6827d0f6876e$var$fallbackGlobalObject = {};
function $e25b6827d0f6876e$export$256479dc0cea61c4() {
    return (0, $2C75o.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $e25b6827d0f6876e$var$fallbackGlobalObject;
}
function $e25b6827d0f6876e$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $e25b6827d0f6876e$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
} //# sourceMappingURL=global.js.map
module.exports["getGlobalObject"] = $e25b6827d0f6876e$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $e25b6827d0f6876e$export$7e223ec222791509;

});

parcelRegister("2C75o", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3sIgl = parcelRequire("3sIgl");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3sIgl.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
} //# sourceMappingURL=node.js.map

});

parcelRegister("3sIgl", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $28565245ce90ddcd$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
} //# sourceMappingURL=env.js.map
module.exports["isBrowserBundle"] = $28565245ce90ddcd$export$2928c40372e623c0;

});

parcelRegister("23i8z", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $17e9ee480003b058$var$objectToString = Object.prototype.toString;
function $17e9ee480003b058$export$e6127cc7fe7395c3(wat) {
    switch($17e9ee480003b058$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $17e9ee480003b058$export$49034edbe6b62415(wat, Error);
    }
}
function $17e9ee480003b058$var$isBuiltin(wat, ty) {
    return $17e9ee480003b058$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $17e9ee480003b058$export$9f9636d330b71954(wat) {
    return $17e9ee480003b058$var$isBuiltin(wat, 'ErrorEvent');
}
function $17e9ee480003b058$export$ef9e2056653f0c8e(wat) {
    return $17e9ee480003b058$var$isBuiltin(wat, 'DOMError');
}
function $17e9ee480003b058$export$12e869b2a583f783(wat) {
    return $17e9ee480003b058$var$isBuiltin(wat, 'DOMException');
}
function $17e9ee480003b058$export$844ec244b1367d54(wat) {
    return $17e9ee480003b058$var$isBuiltin(wat, 'String');
}
function $17e9ee480003b058$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $17e9ee480003b058$export$53b83ca8eaab0383(wat) {
    return $17e9ee480003b058$var$isBuiltin(wat, 'Object');
}
function $17e9ee480003b058$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $17e9ee480003b058$export$49034edbe6b62415(wat, Event);
}
function $17e9ee480003b058$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $17e9ee480003b058$export$49034edbe6b62415(wat, Element);
}
function $17e9ee480003b058$export$49841c62b9eff15(wat) {
    return $17e9ee480003b058$var$isBuiltin(wat, 'RegExp');
}
function $17e9ee480003b058$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $17e9ee480003b058$export$bc2894c7158efbac(wat) {
    return $17e9ee480003b058$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $17e9ee480003b058$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $17e9ee480003b058$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
} //# sourceMappingURL=is.js.map
module.exports["isError"] = $17e9ee480003b058$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $17e9ee480003b058$export$49034edbe6b62415;
module.exports["isErrorEvent"] = $17e9ee480003b058$export$9f9636d330b71954;
module.exports["isDOMError"] = $17e9ee480003b058$export$ef9e2056653f0c8e;
module.exports["isDOMException"] = $17e9ee480003b058$export$12e869b2a583f783;
module.exports["isString"] = $17e9ee480003b058$export$844ec244b1367d54;
module.exports["isPrimitive"] = $17e9ee480003b058$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $17e9ee480003b058$export$53b83ca8eaab0383;
module.exports["isEvent"] = $17e9ee480003b058$export$9671ea99bd126ace;
module.exports["isElement"] = $17e9ee480003b058$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $17e9ee480003b058$export$49841c62b9eff15;
module.exports["isThenable"] = $17e9ee480003b058$export$f5b060c2914b97c8;
module.exports["isSyntheticEvent"] = $17e9ee480003b058$export$bc2894c7158efbac;
module.exports["isNaN"] = $17e9ee480003b058$export$c9f5652083b8129d;

});

parcelRegister("4xfBg", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $4y4n7 = parcelRequire("4y4n7");


var $5cSD4 = parcelRequire("5cSD4");

/** Regular expression used to parse a Dsn. */ var $34d6585320075cfa$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $34d6585320075cfa$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $34d6585320075cfa$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $34d6585320075cfa$var$dsnFromString(str) {
    var match = $34d6585320075cfa$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $4y4n7.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $fbwmZ.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $34d6585320075cfa$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $34d6585320075cfa$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $34d6585320075cfa$var$validateDsn(dsn) {
    if (!(0, $5cSD4.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $4y4n7.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $4y4n7.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$34d6585320075cfa$var$isValidProtocol(protocol)) throw new (0, $4y4n7.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $4y4n7.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $34d6585320075cfa$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $34d6585320075cfa$var$dsnFromString(from) : $34d6585320075cfa$var$dsnFromComponents(from);
    $34d6585320075cfa$var$validateDsn(components);
    return components;
} //# sourceMappingURL=dsn.js.map
module.exports["dsnToString"] = $34d6585320075cfa$export$44d472fbb931a776;
module.exports["makeDsn"] = $34d6585320075cfa$export$128827c3562ec0cb;

});

parcelRegister("4y4n7", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $kg0U6 = parcelRequire("kg0U6");

/** An error emitted by Sentry SDKs and related utilities. */ var $34fdba8ecc555b39$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $kg0U6.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);
 //# sourceMappingURL=error.js.map
module.exports["SentryError"] = $34fdba8ecc555b39$export$5949942ba2a7c0e2;

});

parcelRegister("kg0U6", function(module, exports) {
var $ebf600c013927c6e$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $ebf600c013927c6e$var$setProtoOf : $ebf600c013927c6e$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ebf600c013927c6e$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ebf600c013927c6e$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
} //# sourceMappingURL=polyfill.js.map
module.exports["setPrototypeOf"] = $ebf600c013927c6e$export$1cb0d91350beb6cc;

});

parcelRegister("5cSD4", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $3ca872ef92ed5032$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $3ca872ef92ed5032$export$48a8984ec0bf2e44;

});

parcelRegister("fNhxt", function(module, exports) {
var $b7f9097546bc3590$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=enums.js.map
module.exports["SeverityLevels"] = $b7f9097546bc3590$export$484b1ea9aec914c;

});

parcelRegister("hX59D", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $5cSD4 = parcelRequire("5cSD4");


var $jqTnS = parcelRequire("jqTnS");


var $23i8z = parcelRequire("23i8z");


var $eVWro = parcelRequire("eVWro");


var $56AkW = parcelRequire("56AkW");


var $1MAkl = parcelRequire("1MAkl");


var $kmhID = parcelRequire("kmhID");

var $d11bf1e5e1cf5109$var$global = (0, $jqTnS.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $d11bf1e5e1cf5109$var$handlers = {};
var $d11bf1e5e1cf5109$var$instrumented = {};
/** Instruments given API */ function $d11bf1e5e1cf5109$var$instrument(type) {
    if ($d11bf1e5e1cf5109$var$instrumented[type]) return;
    $d11bf1e5e1cf5109$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $d11bf1e5e1cf5109$var$instrumentConsole();
            break;
        case 'dom':
            $d11bf1e5e1cf5109$var$instrumentDOM();
            break;
        case 'xhr':
            $d11bf1e5e1cf5109$var$instrumentXHR();
            break;
        case 'fetch':
            $d11bf1e5e1cf5109$var$instrumentFetch();
            break;
        case 'history':
            $d11bf1e5e1cf5109$var$instrumentHistory();
            break;
        case 'error':
            $d11bf1e5e1cf5109$var$instrumentError();
            break;
        case 'unhandledrejection':
            $d11bf1e5e1cf5109$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $5cSD4.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $d11bf1e5e1cf5109$export$285b9172a3741fb7(type, callback) {
    $d11bf1e5e1cf5109$var$handlers[type] = $d11bf1e5e1cf5109$var$handlers[type] || [];
    $d11bf1e5e1cf5109$var$handlers[type].push(callback);
    $d11bf1e5e1cf5109$var$instrument(type);
}
/** JSDoc */ function $d11bf1e5e1cf5109$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$d11bf1e5e1cf5109$var$handlers[type]) return;
    try {
        for(var _b = (0, $fbwmZ.__values)($d11bf1e5e1cf5109$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $5cSD4.IS_DEBUG_BUILD) && (0, $eVWro.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $1MAkl.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentConsole() {
    if (!('console' in $d11bf1e5e1cf5109$var$global)) return;
    (0, $eVWro.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $d11bf1e5e1cf5109$var$global.console)) return;
        (0, $56AkW.fill)($d11bf1e5e1cf5109$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $d11bf1e5e1cf5109$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($d11bf1e5e1cf5109$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentFetch() {
    if (!(0, $kmhID.supportsNativeFetch)()) return;
    (0, $56AkW.fill)($d11bf1e5e1cf5109$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $d11bf1e5e1cf5109$var$getFetchMethod(args),
                    url: $d11bf1e5e1cf5109$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $d11bf1e5e1cf5109$var$triggerHandlers('fetch', (0, $fbwmZ.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($d11bf1e5e1cf5109$var$global, args).then(function(response) {
                $d11bf1e5e1cf5109$var$triggerHandlers('fetch', (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $d11bf1e5e1cf5109$var$triggerHandlers('fetch', (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $d11bf1e5e1cf5109$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $d11bf1e5e1cf5109$var$global && (0, $23i8z.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $d11bf1e5e1cf5109$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $d11bf1e5e1cf5109$var$global && (0, $23i8z.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $d11bf1e5e1cf5109$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $56AkW.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $23i8z.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $23i8z.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $d11bf1e5e1cf5109$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $56AkW.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $56AkW.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $d11bf1e5e1cf5109$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $d11bf1e5e1cf5109$var$lastHref;
/** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentHistory() {
    if (!(0, $kmhID.supportsHistory)()) return;
    var oldOnPopState = $d11bf1e5e1cf5109$var$global.onpopstate;
    $d11bf1e5e1cf5109$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $d11bf1e5e1cf5109$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $d11bf1e5e1cf5109$var$lastHref;
        $d11bf1e5e1cf5109$var$lastHref = to;
        $d11bf1e5e1cf5109$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $d11bf1e5e1cf5109$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $d11bf1e5e1cf5109$var$lastHref = to;
                $d11bf1e5e1cf5109$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $56AkW.fill)($d11bf1e5e1cf5109$var$global.history, 'pushState', historyReplacementFunction);
    (0, $56AkW.fill)($d11bf1e5e1cf5109$var$global.history, 'replaceState', historyReplacementFunction);
}
var $d11bf1e5e1cf5109$var$debounceDuration = 1000;
var $d11bf1e5e1cf5109$var$debounceTimerID;
var $d11bf1e5e1cf5109$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $d11bf1e5e1cf5109$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $d11bf1e5e1cf5109$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $d11bf1e5e1cf5109$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $d11bf1e5e1cf5109$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($d11bf1e5e1cf5109$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($d11bf1e5e1cf5109$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $d11bf1e5e1cf5109$var$lastCapturedEvent = event;
        } else if ($d11bf1e5e1cf5109$var$shouldShortcircuitPreviousDebounce($d11bf1e5e1cf5109$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $d11bf1e5e1cf5109$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($d11bf1e5e1cf5109$var$debounceTimerID);
        $d11bf1e5e1cf5109$var$debounceTimerID = $d11bf1e5e1cf5109$var$global.setTimeout(function() {
            $d11bf1e5e1cf5109$var$debounceTimerID = undefined;
        }, $d11bf1e5e1cf5109$var$debounceDuration);
    };
}
/** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentDOM() {
    if (!('document' in $d11bf1e5e1cf5109$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $d11bf1e5e1cf5109$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $d11bf1e5e1cf5109$var$makeDOMEventHandler(triggerDOMHandler, true);
    $d11bf1e5e1cf5109$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $d11bf1e5e1cf5109$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $d11bf1e5e1cf5109$var$global[target] && $d11bf1e5e1cf5109$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $56AkW.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $d11bf1e5e1cf5109$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $56AkW.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $d11bf1e5e1cf5109$var$_oldOnErrorHandler = null;
/** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentError() {
    $d11bf1e5e1cf5109$var$_oldOnErrorHandler = $d11bf1e5e1cf5109$var$global.onerror;
    $d11bf1e5e1cf5109$var$global.onerror = function(msg, url, line, column, error) {
        $d11bf1e5e1cf5109$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($d11bf1e5e1cf5109$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $d11bf1e5e1cf5109$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $d11bf1e5e1cf5109$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $d11bf1e5e1cf5109$var$instrumentUnhandledRejection() {
    $d11bf1e5e1cf5109$var$_oldOnUnhandledRejectionHandler = $d11bf1e5e1cf5109$var$global.onunhandledrejection;
    $d11bf1e5e1cf5109$var$global.onunhandledrejection = function(e) {
        $d11bf1e5e1cf5109$var$triggerHandlers('unhandledrejection', e);
        if ($d11bf1e5e1cf5109$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $d11bf1e5e1cf5109$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
} //# sourceMappingURL=instrument.js.map
module.exports["addInstrumentationHandler"] = $d11bf1e5e1cf5109$export$285b9172a3741fb7;

});

parcelRegister("eVWro", function(module, exports) {
$parcel$export(module.exports, "logger", () => $adf3b8b4497a70a2$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $5cSD4 = parcelRequire("5cSD4");


var $jqTnS = parcelRequire("jqTnS");

// TODO: Implement different loggers for different environments
var $adf3b8b4497a70a2$var$global = (0, $jqTnS.getGlobalObject)();
/** Prefix for logging strings */ var $adf3b8b4497a70a2$var$PREFIX = 'Sentry Logger ';
var $adf3b8b4497a70a2$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $adf3b8b4497a70a2$export$cda52e2a8927a2ca(callback) {
    var global = (0, $jqTnS.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $adf3b8b4497a70a2$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $adf3b8b4497a70a2$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $5cSD4.IS_DEBUG_BUILD) $adf3b8b4497a70a2$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $adf3b8b4497a70a2$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $adf3b8b4497a70a2$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $adf3b8b4497a70a2$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $adf3b8b4497a70a2$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $adf3b8b4497a70a2$export$af88d00dbe7f521;
if (0, $5cSD4.IS_DEBUG_BUILD) $adf3b8b4497a70a2$export$af88d00dbe7f521 = (0, $jqTnS.getGlobalSingleton)('logger', $adf3b8b4497a70a2$var$makeLogger);
else $adf3b8b4497a70a2$export$af88d00dbe7f521 = $adf3b8b4497a70a2$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["CONSOLE_LEVELS"] = $adf3b8b4497a70a2$export$2a2b1d2252a69ecb;

});

parcelRegister("56AkW", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $dx3aE = parcelRequire("dx3aE");


var $23i8z = parcelRequire("23i8z");


var $iXZ4U = parcelRequire("iXZ4U");

function $3b79b30505faab1a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $3b79b30505faab1a$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $3b79b30505faab1a$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $3b79b30505faab1a$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $3b79b30505faab1a$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $3b79b30505faab1a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $3b79b30505faab1a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $3b79b30505faab1a$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $23i8z.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $3b79b30505faab1a$var$getOwnProperties(value));
    else if ((0, $23i8z.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $3b79b30505faab1a$var$serializeEventTarget(event_1.target),
            currentTarget: $3b79b30505faab1a$var$serializeEventTarget(event_1.currentTarget)
        }, $3b79b30505faab1a$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $23i8z.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $3b79b30505faab1a$var$serializeEventTarget(target) {
    try {
        return (0, $23i8z.isElement)(target) ? (0, $dx3aE.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $3b79b30505faab1a$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $3b79b30505faab1a$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($3b79b30505faab1a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $iXZ4U.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $iXZ4U.truncate)(serialized, maxLength);
    }
    return '';
}
function $3b79b30505faab1a$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $23i8z.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $3b79b30505faab1a$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($3b79b30505faab1a$export$d25f2688db1bb433);
    return val;
}
function $3b79b30505faab1a$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $23i8z.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
} //# sourceMappingURL=object.js.map
module.exports["fill"] = $3b79b30505faab1a$export$9563e054e6f787fb;
module.exports["markFunctionWrapped"] = $3b79b30505faab1a$export$5c1499e2e5d010ae;
module.exports["addNonEnumerableProperty"] = $3b79b30505faab1a$export$e73679ffaf56810e;
module.exports["getOriginalFunction"] = $3b79b30505faab1a$export$e6cc1e135e2092e5;
module.exports["urlEncode"] = $3b79b30505faab1a$export$9ef804feabbcbaf1;
module.exports["convertToPlainObject"] = $3b79b30505faab1a$export$62ff257738bf57f5;
module.exports["extractExceptionKeysForMessage"] = $3b79b30505faab1a$export$b0244d5063c0b61b;

});

parcelRegister("iXZ4U", function(module, exports) {

var $23i8z = parcelRequire("23i8z");

function $dced1d89d4ae9ea9$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $dced1d89d4ae9ea9$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $dced1d89d4ae9ea9$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $dced1d89d4ae9ea9$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $23i8z.isString)(value)) return false;
    if ((0, $23i8z.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $dced1d89d4ae9ea9$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
} //# sourceMappingURL=string.js.map
module.exports["truncate"] = $dced1d89d4ae9ea9$export$6a506b36fdea397d;
module.exports["snipLine"] = $dced1d89d4ae9ea9$export$4215662d762d6f9d;
module.exports["safeJoin"] = $dced1d89d4ae9ea9$export$465e9d514283d4fd;
module.exports["isMatchingPattern"] = $dced1d89d4ae9ea9$export$cdded5b28a5f8c6d;

});

parcelRegister("1MAkl", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $14c673ef68a85c28$var$STACKTRACE_LIMIT = 50;
function $14c673ef68a85c28$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fbwmZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fbwmZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $14c673ef68a85c28$export$c55c24c0eeba0205(frames);
    };
}
function $14c673ef68a85c28$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $14c673ef68a85c28$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $14c673ef68a85c28$var$defaultFunctionName = '<anonymous>';
function $14c673ef68a85c28$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $14c673ef68a85c28$var$defaultFunctionName;
        return fn.name || $14c673ef68a85c28$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $14c673ef68a85c28$var$defaultFunctionName;
    }
} //# sourceMappingURL=stacktrace.js.map
module.exports["createStackParser"] = $14c673ef68a85c28$export$a5739666fb2d03d4;
module.exports["getFunctionName"] = $14c673ef68a85c28$export$aad197c7121a6651;

});

parcelRegister("kmhID", function(module, exports) {

var $5cSD4 = parcelRequire("5cSD4");


var $jqTnS = parcelRequire("jqTnS");


var $eVWro = parcelRequire("eVWro");

function $ed239b5a1519e23d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $ed239b5a1519e23d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $ed239b5a1519e23d$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $ed239b5a1519e23d$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $jqTnS.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $ed239b5a1519e23d$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $ed239b5a1519e23d$export$c82d238e23c40b21() {
    if (!$ed239b5a1519e23d$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $jqTnS.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($ed239b5a1519e23d$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $ed239b5a1519e23d$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $5cSD4.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $ed239b5a1519e23d$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $jqTnS.getGlobalObject)();
}
function $ed239b5a1519e23d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$ed239b5a1519e23d$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $ed239b5a1519e23d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $jqTnS.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
} //# sourceMappingURL=supports.js.map
module.exports["supportsFetch"] = $ed239b5a1519e23d$export$edf3cb81fd7d2a3e;
module.exports["isNativeFetch"] = $ed239b5a1519e23d$export$18cf36ed71d733e7;
module.exports["supportsNativeFetch"] = $ed239b5a1519e23d$export$c82d238e23c40b21;
module.exports["supportsReferrerPolicy"] = $ed239b5a1519e23d$export$2d308b428295192f;
module.exports["supportsHistory"] = $ed239b5a1519e23d$export$67fc34576016d6ec;

});

parcelRegister("91aYu", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $690cb869593c4978$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
} //# sourceMappingURL=memo.js.map
module.exports["memoBuilder"] = $690cb869593c4978$export$8115b0b78e956ab3;

});

parcelRegister("4XALr", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $jqTnS = parcelRequire("jqTnS");


var $56AkW = parcelRequire("56AkW");


var $iXZ4U = parcelRequire("iXZ4U");

function $39c930bae49c2c43$export$19f53698e68b2496() {
    var global = (0, $jqTnS.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $39c930bae49c2c43$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $39c930bae49c2c43$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $39c930bae49c2c43$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $39c930bae49c2c43$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $39c930bae49c2c43$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $39c930bae49c2c43$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $39c930bae49c2c43$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $39c930bae49c2c43$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $39c930bae49c2c43$export$d364f2020ab30578(input) {
    var match = input.match($39c930bae49c2c43$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $39c930bae49c2c43$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $iXZ4U.snipLine)(line, 0);
    });
    frame.context_line = (0, $iXZ4U.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $iXZ4U.snipLine)(line, 0);
    });
}
function $39c930bae49c2c43$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $39c930bae49c2c43$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $56AkW.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
} //# sourceMappingURL=misc.js.map
module.exports["uuid4"] = $39c930bae49c2c43$export$19f53698e68b2496;
module.exports["parseUrl"] = $39c930bae49c2c43$export$7a5253c0f62e0150;
module.exports["getEventDescription"] = $39c930bae49c2c43$export$4157119e2b157127;
module.exports["addExceptionTypeValue"] = $39c930bae49c2c43$export$f26508487bf83ee7;
module.exports["addExceptionMechanism"] = $39c930bae49c2c43$export$c69a9a0313b03bb1;
module.exports["checkOrSetAlreadyCaught"] = $39c930bae49c2c43$export$6de4ffac6a2f1098;

});

parcelRegister("fmzj4", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $23i8z = parcelRequire("23i8z");


var $91aYu = parcelRequire("91aYu");


var $56AkW = parcelRequire("56AkW");


var $1MAkl = parcelRequire("1MAkl");

function $b2f44c41fb804357$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $b2f44c41fb804357$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $b2f44c41fb804357$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $b2f44c41fb804357$export$a3295358bff77e(object, depth);
    if ($b2f44c41fb804357$var$jsonSize(normalized) > maxSize) return $b2f44c41fb804357$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $b2f44c41fb804357$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $91aYu.memoBuilder)();
    var _a = (0, $fbwmZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $23i8z.isNaN)(value)) return value;
    var stringified = $b2f44c41fb804357$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $23i8z.isError)(value) || (0, $23i8z.isEvent)(value) ? (0, $56AkW.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $b2f44c41fb804357$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $b2f44c41fb804357$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $23i8z.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $1MAkl.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $b2f44c41fb804357$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $b2f44c41fb804357$var$jsonSize(value) {
    return $b2f44c41fb804357$var$utf8Length(JSON.stringify(value));
} //# sourceMappingURL=normalize.js.map
module.exports["normalize"] = $b2f44c41fb804357$export$a3295358bff77e;
module.exports["normalizeToSize"] = $b2f44c41fb804357$export$23fbbb20bed71033;

});

parcelRegister("cY6s3", function(module, exports) {

var $4y4n7 = parcelRequire("4y4n7");


var $d9uty = parcelRequire("d9uty");

function $971017c9010b16ca$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $d9uty.rejectedSyncPromise)(new (0, $4y4n7.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $d9uty.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $d9uty.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
} //# sourceMappingURL=promisebuffer.js.map
module.exports["makePromiseBuffer"] = $971017c9010b16ca$export$85a4f67f852183e6;

});

parcelRegister("d9uty", function(module, exports) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $23i8z = parcelRequire("23i8z");

function $9933c16fd0caba08$export$1fda8aa4d135f8aa(value) {
    return new $9933c16fd0caba08$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $9933c16fd0caba08$export$78e43115b553f358(reason) {
    return new $9933c16fd0caba08$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $9933c16fd0caba08$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $23i8z.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();
 //# sourceMappingURL=syncpromise.js.map
module.exports["resolvedSyncPromise"] = $9933c16fd0caba08$export$1fda8aa4d135f8aa;
module.exports["SyncPromise"] = $9933c16fd0caba08$export$6f292d4960313241;
module.exports["rejectedSyncPromise"] = $9933c16fd0caba08$export$78e43115b553f358;

});

parcelRegister("hjoOD", function(module, exports) {

var $dtZ6d = parcelRequire("dtZ6d");


var $fNhxt = parcelRequire("fNhxt");

function $c9a775eb0c6fcb36$var$isSupportedSeverity(level) {
    return (0, $fNhxt.SeverityLevels).indexOf(level) !== -1;
}
function $c9a775eb0c6fcb36$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $dtZ6d.Severity).Warning;
    if ($c9a775eb0c6fcb36$var$isSupportedSeverity(level)) return level;
    return (0, $dtZ6d.Severity).Log;
} //# sourceMappingURL=severity.js.map
module.exports["severityFromString"] = $c9a775eb0c6fcb36$export$e01cef29b4327697;

});

parcelRegister("dtZ6d", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $9d0d60d4f231a782$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $9d0d60d4f231a782$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($9d0d60d4f231a782$export$918a9776c0a3cf27 || ($9d0d60d4f231a782$export$918a9776c0a3cf27 = {}));
var $9d0d60d4f231a782$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=severity.js.map

});

parcelRegister("28HPT", function(module, exports) {
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $18ee550bf0ee5383$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
} //# sourceMappingURL=status.js.map
module.exports["eventStatusFromHttpCode"] = $18ee550bf0ee5383$export$82713360d763c449;

});

parcelRegister("f6xuJ", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $jqTnS = parcelRequire("jqTnS");


var $2C75o = parcelRequire("2C75o");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $jqTnS.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $2C75o.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $2C75o.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $jqTnS.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}(); //# sourceMappingURL=time.js.map

});

parcelRegister("hgNA8", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $23i8z = parcelRequire("23i8z");

function $c92a64362a8e5c5e$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $c92a64362a8e5c5e$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $fbwmZ.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $fbwmZ.__spread)(items, [
            newItem
        ])
    ];
}
function $c92a64362a8e5c5e$export$d84939284bbafcd4(envelope) {
    var _a = (0, $fbwmZ.__read)(envelope, 2), _b = (0, $fbwmZ.__read)(_a[1], 1), _c = (0, $fbwmZ.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $c92a64362a8e5c5e$export$32f9b428425aac85(envelope) {
    var _a = (0, $fbwmZ.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $fbwmZ.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $23i8z.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
} //# sourceMappingURL=envelope.js.map
module.exports["createEnvelope"] = $c92a64362a8e5c5e$export$f93f7f385160c44e;
module.exports["getEnvelopeType"] = $c92a64362a8e5c5e$export$d84939284bbafcd4;
module.exports["serializeEnvelope"] = $c92a64362a8e5c5e$export$32f9b428425aac85;

});

parcelRegister("2TAee", function(module, exports) {

var $hgNA8 = parcelRequire("hgNA8");


var $f6xuJ = parcelRequire("f6xuJ");

function $21bcd21068ddbb87$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $f6xuJ.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $hgNA8.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
} //# sourceMappingURL=clientreport.js.map
module.exports["createClientReportEnvelope"] = $21bcd21068ddbb87$export$f3b9ed77c03eeb00;

});

parcelRegister("dWiTY", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $a25f5aa4d4f2c44d$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $a25f5aa4d4f2c44d$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $a25f5aa4d4f2c44d$export$b09ce39faaeb1e7c;
}
function $a25f5aa4d4f2c44d$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $a25f5aa4d4f2c44d$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $a25f5aa4d4f2c44d$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $a25f5aa4d4f2c44d$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $fbwmZ.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $fbwmZ.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $fbwmZ.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $a25f5aa4d4f2c44d$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
} //# sourceMappingURL=ratelimit.js.map
module.exports["disabledUntil"] = $a25f5aa4d4f2c44d$export$b89fc7b2e4c799e7;
module.exports["isRateLimited"] = $a25f5aa4d4f2c44d$export$6c91fec22056810a;
module.exports["updateRateLimits"] = $a25f5aa4d4f2c44d$export$699aff705e0d49d4;

});

parcelRegister("asCdn", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $79da29910bf37690$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $79da29910bf37690$export$48a8984ec0bf2e44;

});

parcelRegister("ilRwI", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("2m26K")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("kgaWz")).InboundFilters);

var $2m26K = parcelRequire("2m26K");


var $kgaWz = parcelRequire("kgaWz");

 //# sourceMappingURL=index.js.map

});

parcelRegister("2m26K", function(module, exports) {
parcelRequire("6NrTk");
var $56AkW = parcelRequire("56AkW");

var $1b6f45709dada789$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $1b6f45709dada789$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $1b6f45709dada789$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $56AkW.getOriginalFunction)(this) || this;
            return $1b6f45709dada789$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();
 //# sourceMappingURL=functiontostring.js.map
module.exports["FunctionToString"] = $1b6f45709dada789$export$da4704525c20ae79;

});

parcelRegister("kgaWz", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("6NrTk");
var $4XALr = parcelRequire("4XALr");
var $iXZ4U = parcelRequire("iXZ4U");
var $eVWro = parcelRequire("eVWro");


var $asCdn = parcelRequire("asCdn");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $ebfdca760a97e69a$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $ebfdca760a97e69a$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $ebfdca760a97e69a$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $ebfdca760a97e69a$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $ebfdca760a97e69a$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $fbwmZ.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $fbwmZ.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $fbwmZ.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $ebfdca760a97e69a$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $ebfdca760a97e69a$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $ebfdca760a97e69a$var$_isSentryError(event)) {
        (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $4XALr.getEventDescription)(event));
        return true;
    }
    if ($ebfdca760a97e69a$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $4XALr.getEventDescription)(event));
        return true;
    }
    if ($ebfdca760a97e69a$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $4XALr.getEventDescription)(event) + ".\nUrl: " + $ebfdca760a97e69a$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$ebfdca760a97e69a$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $4XALr.getEventDescription)(event) + ".\nUrl: " + $ebfdca760a97e69a$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $ebfdca760a97e69a$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $ebfdca760a97e69a$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $iXZ4U.isMatchingPattern)(message, pattern);
        });
    });
}
function $ebfdca760a97e69a$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $ebfdca760a97e69a$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $iXZ4U.isMatchingPattern)(url, pattern);
    });
}
function $ebfdca760a97e69a$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $ebfdca760a97e69a$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $iXZ4U.isMatchingPattern)(url, pattern);
    });
}
function $ebfdca760a97e69a$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error("Cannot extract message for event " + (0, $4XALr.getEventDescription)(event));
        return [];
    }
    return [];
}
function $ebfdca760a97e69a$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $ebfdca760a97e69a$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $ebfdca760a97e69a$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $ebfdca760a97e69a$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $ebfdca760a97e69a$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error("Cannot extract url for event " + (0, $4XALr.getEventDescription)(event));
        return null;
    }
} //# sourceMappingURL=inboundfilters.js.map
module.exports["InboundFilters"] = $ebfdca760a97e69a$export$2ffbb5359dcc6be4;

});

parcelRegister("e9HlS", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $85iOw = parcelRequire("85iOw");

var $a953x = parcelRequire("a953x");

parcelRequire("6NrTk");
var $jqTnS = parcelRequire("jqTnS");
var $eVWro = parcelRequire("eVWro");


var $8edPB = parcelRequire("8edPB");


var $4vRQe = parcelRequire("4vRQe");


var $9whyS = parcelRequire("9whyS");


var $bNfZ4 = parcelRequire("bNfZ4");

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $a4e388bd1ece01e3$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $a953x.SDK_VERSION)
                }
            ],
            version: (0, $a953x.SDK_VERSION)
        };
        _this = _super.call(this, (0, $8edPB.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $jqTnS.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $9whyS.injectReportDialog)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $bNfZ4.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $85iOw.BaseClient));
 //# sourceMappingURL=client.js.map
module.exports["BrowserClient"] = $a4e388bd1ece01e3$export$1df9218a526d318d;

});

parcelRegister("85iOw", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $hkv0W = parcelRequire("hkv0W");

parcelRequire("6NrTk");
var $4XALr = parcelRequire("4XALr");
var $f6xuJ = parcelRequire("f6xuJ");
var $23i8z = parcelRequire("23i8z");
var $eVWro = parcelRequire("eVWro");
var $4xfBg = parcelRequire("4xfBg");
var $fmzj4 = parcelRequire("fmzj4");
var $d9uty = parcelRequire("d9uty");
var $4y4n7 = parcelRequire("4y4n7");
var $iXZ4U = parcelRequire("iXZ4U");


var $asCdn = parcelRequire("asCdn");


var $jmD2C = parcelRequire("jmD2C");

var $5e2d62633e2f0631$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $5e2d62633e2f0631$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $4xfBg.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $4XALr.checkOrSetAlreadyCaught)(exception)) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).log($5e2d62633e2f0631$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $23i8z.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $4XALr.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).log($5e2d62633e2f0631$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $jmD2C.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $fbwmZ.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $d9uty.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $4XALr.uuid4)()),
            timestamp: event.timestamp || (0, $f6xuJ.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $hkv0W.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $d9uty.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $fmzj4.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, b), b.data && {
                    data: (0, $fmzj4.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $fmzj4.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $fmzj4.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $fmzj4.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $iXZ4U.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $iXZ4U.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $iXZ4U.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $fbwmZ.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $d9uty.rejectedSyncPromise)(new (0, $4y4n7.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $d9uty.rejectedSyncPromise)(new (0, $4y4n7.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $4y4n7.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $5e2d62633e2f0631$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $4y4n7.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $4y4n7.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $4y4n7.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $5e2d62633e2f0631$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $23i8z.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $23i8z.isPlainObject)(event) || event === null)) throw new (0, $4y4n7.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $4y4n7.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $23i8z.isPlainObject)(rv) || rv === null)) throw new (0, $4y4n7.SentryError)(nullErr);
    return rv;
} //# sourceMappingURL=baseclient.js.map
module.exports["BaseClient"] = $5e2d62633e2f0631$export$4f22f74eddb7716a;

});

parcelRegister("jmD2C", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

parcelRequire("6NrTk");
var $56AkW = parcelRequire("56AkW");
var $eVWro = parcelRequire("eVWro");


var $asCdn = parcelRequire("asCdn");

var $e18e5b2f7264ec7c$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $e18e5b2f7264ec7c$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $e18e5b2f7264ec7c$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $fbwmZ.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $fbwmZ.__spread)($e18e5b2f7264ec7c$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $fbwmZ.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $e18e5b2f7264ec7c$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $fbwmZ.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $e18e5b2f7264ec7c$export$e7390a03b70a6f2f(integration) {
    if ($e18e5b2f7264ec7c$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $hkv0W.addGlobalEventProcessor), (0, $amM2J.getCurrentHub));
    $e18e5b2f7264ec7c$export$b14a8888f80a0b3e.push(integration.name);
    (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).log("Integration installed: " + integration.name);
}
function $e18e5b2f7264ec7c$export$51abed9797baa598(options) {
    var integrations = {};
    $e18e5b2f7264ec7c$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $e18e5b2f7264ec7c$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $56AkW.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
} //# sourceMappingURL=integration.js.map
module.exports["setupIntegrations"] = $e18e5b2f7264ec7c$export$51abed9797baa598;

});

parcelRegister("a953x", function(module, exports) {
var $762eaaa9e227a15c$export$31499a9cd224b78c = '6.19.7'; //# sourceMappingURL=version.js.map
module.exports["SDK_VERSION"] = $762eaaa9e227a15c$export$31499a9cd224b78c;

});

parcelRegister("8edPB", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $c2DC4 = parcelRequire("c2DC4");

var $8uubg = parcelRequire("8uubg");


var $dtZ6d = parcelRequire("dtZ6d");

parcelRequire("6NrTk");
var $kmhID = parcelRequire("kmhID");


var $l17tw = parcelRequire("l17tw");


var $9yqZL = parcelRequire("9yqZL");

var $hu9Hi = parcelRequire("hu9Hi");

var $3FUEv = parcelRequire("3FUEv");

var $5a5jw = parcelRequire("5a5jw");

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $5fda5c24a13639fb$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $l17tw.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $dtZ6d.Severity).Info;
        return (0, $l17tw.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $8uubg.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $8uubg.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $kmhID.supportsFetch)()) {
            var requestOptions = (0, $fbwmZ.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $hu9Hi.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $9yqZL.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $3FUEv.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $5a5jw.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $c2DC4.BaseBackend));
 //# sourceMappingURL=backend.js.map
module.exports["BrowserBackend"] = $5fda5c24a13639fb$export$2526e21aec9d0ce7;

});

parcelRegister("c2DC4", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("6NrTk");
var $eVWro = parcelRequire("eVWro");
var $4y4n7 = parcelRequire("4y4n7");


var $8uubg = parcelRequire("8uubg");


var $asCdn = parcelRequire("asCdn");


var $fNAQV = parcelRequire("fNAQV");


var $gpPlS = parcelRequire("gpPlS");

/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $8c446648f4f2697b$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $4y4n7.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $4y4n7.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8uubg.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $fNAQV.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8uubg.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $fbwmZ.__read)((0, $fNAQV.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $asCdn.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $gpPlS.NoopTransport)();
    };
    return BaseBackend;
}();
 //# sourceMappingURL=basebackend.js.map
module.exports["BaseBackend"] = $8c446648f4f2697b$export$8f43a53a38d7e95f;

});

parcelRegister("8uubg", function(module, exports) {
parcelRequire("6NrTk");
var $4xfBg = parcelRequire("4xfBg");
var $56AkW = parcelRequire("56AkW");

var $62e889549eae9303$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $62e889549eae9303$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $4xfBg.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $62e889549eae9303$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $62e889549eae9303$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $62e889549eae9303$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $62e889549eae9303$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $62e889549eae9303$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $4xfBg.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $62e889549eae9303$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $62e889549eae9303$var$_getIngestEndpoint(dsn, target) {
    return "" + $62e889549eae9303$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $62e889549eae9303$var$_encodedAuth(dsn) {
    return (0, $56AkW.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $62e889549eae9303$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $62e889549eae9303$var$getStoreEndpoint(dsn) {
    return $62e889549eae9303$var$_getIngestEndpoint(dsn, 'store');
}
function $62e889549eae9303$export$c1677e22ac2217a5(dsn) {
    return $62e889549eae9303$var$getStoreEndpoint(dsn) + "?" + $62e889549eae9303$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $62e889549eae9303$var$_getEnvelopeEndpoint(dsn) {
    return $62e889549eae9303$var$_getIngestEndpoint(dsn, 'envelope');
}
function $62e889549eae9303$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $62e889549eae9303$var$_getEnvelopeEndpoint(dsn) + "?" + $62e889549eae9303$var$_encodedAuth(dsn);
}
function $62e889549eae9303$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $62e889549eae9303$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $62e889549eae9303$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $4xfBg.makeDsn)(dsnLike);
    var endpoint = $62e889549eae9303$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $4xfBg.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
} //# sourceMappingURL=api.js.map
module.exports["getStoreEndpointWithUrlEncodedAuth"] = $62e889549eae9303$export$c1677e22ac2217a5;
module.exports["getEnvelopeEndpointWithUrlEncodedAuth"] = $62e889549eae9303$export$9964600bfe84e6a3;
module.exports["initAPIDetails"] = $62e889549eae9303$export$ad00a06efb2a29cb;
module.exports["getReportDialogEndpoint"] = $62e889549eae9303$export$671c7ed8e40a7a57;

});

parcelRegister("fNAQV", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("6NrTk");
var $hgNA8 = parcelRequire("hgNA8");
var $4xfBg = parcelRequire("4xfBg");
var $fmzj4 = parcelRequire("fmzj4");


var $8uubg = parcelRequire("8uubg");

/** Extract sdk info from from the API metadata */ function $b80804c6e2769fa2$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b80804c6e2769fa2$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $fbwmZ.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $fbwmZ.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $b80804c6e2769fa2$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $b80804c6e2769fa2$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $4xfBg.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $hgNA8.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $b80804c6e2769fa2$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $fbwmZ.__read)($b80804c6e2769fa2$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $hgNA8.serializeEnvelope)(envelope),
        type: type,
        url: (0, $8uubg.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $b80804c6e2769fa2$export$c31057337a18010f(event, api) {
    var sdkInfo = $b80804c6e2769fa2$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $b80804c6e2769fa2$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $4xfBg.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $hgNA8.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $b80804c6e2769fa2$export$2006389de558b996(event, api) {
    var sdkInfo = $b80804c6e2769fa2$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $b80804c6e2769fa2$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $fmzj4.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $8uubg.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $8uubg.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $4xfBg.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $hgNA8.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $hgNA8.serializeEnvelope)(envelope);
    }
    return req;
} //# sourceMappingURL=request.js.map
module.exports["createSessionEnvelope"] = $b80804c6e2769fa2$export$124b03c077baa2f3;
module.exports["sessionToSentryRequest"] = $b80804c6e2769fa2$export$977ee6eda1884ec3;
module.exports["createEventEnvelope"] = $b80804c6e2769fa2$export$c31057337a18010f;
module.exports["eventToSentryRequest"] = $b80804c6e2769fa2$export$2006389de558b996;

});

parcelRegister("gpPlS", function(module, exports) {
parcelRequire("6NrTk");
var $d9uty = parcelRequire("d9uty");

/** Noop transport */ var $bf36d08cdf756e85$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $d9uty.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $d9uty.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();
 //# sourceMappingURL=noop.js.map
module.exports["NoopTransport"] = $bf36d08cdf756e85$export$6f2767450ea1346c;

});

parcelRegister("l17tw", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $dtZ6d = parcelRequire("dtZ6d");

parcelRequire("6NrTk");
var $4XALr = parcelRequire("4XALr");
var $1MAkl = parcelRequire("1MAkl");
var $56AkW = parcelRequire("56AkW");
var $23i8z = parcelRequire("23i8z");
var $fmzj4 = parcelRequire("fmzj4");
var $d9uty = parcelRequire("d9uty");


var $iZgjk = parcelRequire("iZgjk");

function $f4cf7d619fe10357$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $f4cf7d619fe10357$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $f4cf7d619fe10357$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $f4cf7d619fe10357$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $23i8z.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $56AkW.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $fmzj4.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $f4cf7d619fe10357$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $f4cf7d619fe10357$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $f4cf7d619fe10357$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $f4cf7d619fe10357$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $f4cf7d619fe10357$var$getPopSize(ex);
    try {
        return (0, $1MAkl.createStackParser)((0, $iZgjk.opera10StackParser), (0, $iZgjk.opera11StackParser), (0, $iZgjk.chromeStackParser), (0, $iZgjk.winjsStackParser), (0, $iZgjk.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $f4cf7d619fe10357$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $f4cf7d619fe10357$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($f4cf7d619fe10357$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $f4cf7d619fe10357$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $f4cf7d619fe10357$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $f4cf7d619fe10357$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $4XALr.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $dtZ6d.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d9uty.resolvedSyncPromise)(event);
}
function $f4cf7d619fe10357$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $dtZ6d.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $f4cf7d619fe10357$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d9uty.resolvedSyncPromise)(event);
}
function $f4cf7d619fe10357$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $23i8z.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $f4cf7d619fe10357$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $23i8z.isDOMError)(exception) || (0, $23i8z.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $f4cf7d619fe10357$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $23i8z.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $f4cf7d619fe10357$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $4XALr.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $23i8z.isError)(exception)) // we have a real Error object, do nothing
    return $f4cf7d619fe10357$export$73fbea5a0a5234af(exception);
    if ((0, $23i8z.isPlainObject)(exception) || (0, $23i8z.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $f4cf7d619fe10357$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $4XALr.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $f4cf7d619fe10357$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $4XALr.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $4XALr.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $f4cf7d619fe10357$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $f4cf7d619fe10357$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
} //# sourceMappingURL=eventbuilder.js.map
module.exports["exceptionFromError"] = $f4cf7d619fe10357$export$a6c2d27607295951;
module.exports["eventFromException"] = $f4cf7d619fe10357$export$ea3ec7e569b823fc;
module.exports["eventFromUnknownInput"] = $f4cf7d619fe10357$export$9dd56ed1ef0c3420;
module.exports["eventFromMessage"] = $f4cf7d619fe10357$export$5425b53185d13d6c;

});

parcelRegister("iZgjk", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

// global reference to slice
var $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION = '?';
var $dd2a93765cb3c9f8$var$OPERA10_PRIORITY = 10;
var $dd2a93765cb3c9f8$var$OPERA11_PRIORITY = 20;
var $dd2a93765cb3c9f8$var$CHROME_PRIORITY = 30;
var $dd2a93765cb3c9f8$var$WINJS_PRIORITY = 40;
var $dd2a93765cb3c9f8$var$GECKO_PRIORITY = 50;
function $dd2a93765cb3c9f8$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $dd2a93765cb3c9f8$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $dd2a93765cb3c9f8$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $dd2a93765cb3c9f8$var$chrome = function(line) {
    var parts = $dd2a93765cb3c9f8$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $dd2a93765cb3c9f8$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $fbwmZ.__read)($dd2a93765cb3c9f8$var$extractSafariExtensionDetails(parts[1] || $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $dd2a93765cb3c9f8$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $dd2a93765cb3c9f8$export$c693d9295441d8f9 = [
    $dd2a93765cb3c9f8$var$CHROME_PRIORITY,
    $dd2a93765cb3c9f8$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $dd2a93765cb3c9f8$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $dd2a93765cb3c9f8$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $dd2a93765cb3c9f8$var$gecko = function(line) {
    var _a;
    var parts = $dd2a93765cb3c9f8$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $dd2a93765cb3c9f8$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION;
        _a = (0, $fbwmZ.__read)($dd2a93765cb3c9f8$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $dd2a93765cb3c9f8$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $dd2a93765cb3c9f8$export$c9ddf1e2b5d48bff = [
    $dd2a93765cb3c9f8$var$GECKO_PRIORITY,
    $dd2a93765cb3c9f8$var$gecko
];
var $dd2a93765cb3c9f8$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $dd2a93765cb3c9f8$var$winjs = function(line) {
    var parts = $dd2a93765cb3c9f8$var$winjsRegex.exec(line);
    return parts ? $dd2a93765cb3c9f8$var$createFrame(parts[2], parts[1] || $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $dd2a93765cb3c9f8$export$b6d155d85c1dcba5 = [
    $dd2a93765cb3c9f8$var$WINJS_PRIORITY,
    $dd2a93765cb3c9f8$var$winjs
];
var $dd2a93765cb3c9f8$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $dd2a93765cb3c9f8$var$opera10 = function(line) {
    var parts = $dd2a93765cb3c9f8$var$opera10Regex.exec(line);
    return parts ? $dd2a93765cb3c9f8$var$createFrame(parts[2], parts[3] || $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $dd2a93765cb3c9f8$export$966ec832d9699d6 = [
    $dd2a93765cb3c9f8$var$OPERA10_PRIORITY,
    $dd2a93765cb3c9f8$var$opera10
];
var $dd2a93765cb3c9f8$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $dd2a93765cb3c9f8$var$opera11 = function(line) {
    var parts = $dd2a93765cb3c9f8$var$opera11Regex.exec(line);
    return parts ? $dd2a93765cb3c9f8$var$createFrame(parts[5], parts[3] || parts[4] || $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $dd2a93765cb3c9f8$export$989a1824b4734ce6 = [
    $dd2a93765cb3c9f8$var$OPERA11_PRIORITY,
    $dd2a93765cb3c9f8$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $dd2a93765cb3c9f8$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $dd2a93765cb3c9f8$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
}; //# sourceMappingURL=stack-parsers.js.map
module.exports["chromeStackParser"] = $dd2a93765cb3c9f8$export$c693d9295441d8f9;
module.exports["geckoStackParser"] = $dd2a93765cb3c9f8$export$c9ddf1e2b5d48bff;
module.exports["winjsStackParser"] = $dd2a93765cb3c9f8$export$b6d155d85c1dcba5;
module.exports["opera10StackParser"] = $dd2a93765cb3c9f8$export$966ec832d9699d6;
module.exports["opera11StackParser"] = $dd2a93765cb3c9f8$export$989a1824b4734ce6;

});

parcelRegister("9yqZL", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("6NrTk");
var $4y4n7 = parcelRequire("4y4n7");
var $kmhID = parcelRequire("kmhID");
var $d9uty = parcelRequire("d9uty");


var $l2hU1 = parcelRequire("l2hU1");


var $9vsZX = parcelRequire("9vsZX");

/** `fetch` based transport */ var $6f4c3abaa38b8578$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $9vsZX.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $kmhID.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $d9uty.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $4y4n7.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $l2hU1.BaseTransport));
 //# sourceMappingURL=fetch.js.map
module.exports["FetchTransport"] = $6f4c3abaa38b8578$export$2bdee3f9b92f4e82;

});

parcelRegister("l2hU1", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $fNAQV = parcelRequire("fNAQV");

var $8uubg = parcelRequire("8uubg");

parcelRequire("6NrTk");
var $2TAee = parcelRequire("2TAee");
var $dWiTY = parcelRequire("dWiTY");
var $4xfBg = parcelRequire("4xfBg");
var $28HPT = parcelRequire("28HPT");
var $jqTnS = parcelRequire("jqTnS");
var $eVWro = parcelRequire("eVWro");
var $cY6s3 = parcelRequire("cY6s3");
var $hgNA8 = parcelRequire("hgNA8");


var $4vRQe = parcelRequire("4vRQe");


var $9vsZX = parcelRequire("9vsZX");

function $f507abf8ce047f27$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $f507abf8ce047f27$var$global = (0, $jqTnS.getGlobalObject)();
/** Base Transport class implementation */ var $f507abf8ce047f27$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $cY6s3.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $8uubg.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $8uubg.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $f507abf8ce047f27$var$global.document) $f507abf8ce047f27$var$global.document.addEventListener('visibilitychange', function() {
            if ($f507abf8ce047f27$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $fNAQV.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $fNAQV.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $f507abf8ce047f27$var$requestTypeToCategory(category) + ":" + reason;
        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).log('No outcomes to flush');
            return;
        }
        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $8uubg.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $fbwmZ.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $2TAee.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $4xfBg.dsnToString)(this._api.dsn));
        try {
            (0, $9vsZX.sendReport)(url, (0, $hgNA8.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $28HPT.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $dWiTY.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $4vRQe.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $eVWro.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $f507abf8ce047f27$var$requestTypeToCategory(requestType);
        return new Date((0, $dWiTY.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $f507abf8ce047f27$var$requestTypeToCategory(requestType);
        return (0, $dWiTY.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();
 //# sourceMappingURL=base.js.map
module.exports["BaseTransport"] = $f507abf8ce047f27$export$74b99d619e90f481;

});

parcelRegister("4vRQe", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $3493d2785b6fdc45$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $3493d2785b6fdc45$export$48a8984ec0bf2e44;

});

parcelRegister("9vsZX", function(module, exports) {
parcelRequire("6NrTk");
var $2Van4 = parcelRequire("2Van4");
var $jqTnS = parcelRequire("jqTnS");
var $kmhID = parcelRequire("kmhID");
var $eVWro = parcelRequire("eVWro");


var $4vRQe = parcelRequire("4vRQe");

var $6ebd80be0e7acf57$var$global = (0, $jqTnS.getGlobalObject)();
var $6ebd80be0e7acf57$var$cachedFetchImpl;
function $6ebd80be0e7acf57$export$8be2119ce08e3379() {
    if ($6ebd80be0e7acf57$var$cachedFetchImpl) return $6ebd80be0e7acf57$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $kmhID.isNativeFetch)($6ebd80be0e7acf57$var$global.fetch)) return $6ebd80be0e7acf57$var$cachedFetchImpl = $6ebd80be0e7acf57$var$global.fetch.bind($6ebd80be0e7acf57$var$global);
    var document = $6ebd80be0e7acf57$var$global.document;
    var fetchImpl = $6ebd80be0e7acf57$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $6ebd80be0e7acf57$var$cachedFetchImpl = fetchImpl.bind($6ebd80be0e7acf57$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $6ebd80be0e7acf57$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($6ebd80be0e7acf57$var$global && $6ebd80be0e7acf57$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $6ebd80be0e7acf57$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $6ebd80be0e7acf57$var$global.navigator.sendBeacon.bind($6ebd80be0e7acf57$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $kmhID.supportsFetch)()) {
        var fetch_1 = $6ebd80be0e7acf57$export$8be2119ce08e3379();
        return (0, $2Van4.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
} //# sourceMappingURL=utils.js.map
module.exports["getNativeFetchImplementation"] = $6ebd80be0e7acf57$export$8be2119ce08e3379;
module.exports["sendReport"] = $6ebd80be0e7acf57$export$84bb63b2c17ec44d;

});

parcelRegister("hu9Hi", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $9nBt6 = parcelRequire("9nBt6");


var $9vsZX = parcelRequire("9vsZX");

function $cbacc2af4da1d213$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $9vsZX.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $fbwmZ.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $9nBt6.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
} //# sourceMappingURL=new-fetch.js.map
module.exports["makeNewFetchTransport"] = $cbacc2af4da1d213$export$1c57e6bfd09bad13;

});

parcelRegister("9nBt6", function(module, exports) {
parcelRequire("6NrTk");
var $dWiTY = parcelRequire("dWiTY");
var $28HPT = parcelRequire("28HPT");
var $hgNA8 = parcelRequire("hgNA8");
var $cY6s3 = parcelRequire("cY6s3");
var $d9uty = parcelRequire("d9uty");

var $6d43537e052274c0$export$d8a725a7dce95622 = 'error';
var $6d43537e052274c0$export$99adc6fe67a3c63e = 'transaction';
var $6d43537e052274c0$export$9d7ad34f132fe68f = 'attachment';
var $6d43537e052274c0$export$42d9e7b5fc564c45 = 'session';
var $6d43537e052274c0$export$e515cf6dfd2f98b8 = 30;
function $6d43537e052274c0$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $cY6s3.makePromiseBuffer)(options.bufferSize || $6d43537e052274c0$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $hgNA8.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $hgNA8.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $dWiTY.isRateLimited)(rateLimits, category)) return (0, $d9uty.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $6d43537e052274c0$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $28HPT.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $dWiTY.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $d9uty.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $d9uty.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $6d43537e052274c0$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $6d43537e052274c0$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $dWiTY.disabledUntil)(rateLimits, category)).toISOString();
} //# sourceMappingURL=base.js.map
module.exports["createTransport"] = $6d43537e052274c0$export$d09f50d9ab7f7b69;

});

parcelRegister("3FUEv", function(module, exports) {

var $9nBt6 = parcelRequire("9nBt6");

parcelRequire("6NrTk");
var $d9uty = parcelRequire("d9uty");

/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $2ad1256412406d55$var$XHR_READYSTATE_DONE = 4;
function $2ad1256412406d55$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $d9uty.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $2ad1256412406d55$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $9nBt6.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
} //# sourceMappingURL=new-xhr.js.map
module.exports["makeNewXHRTransport"] = $2ad1256412406d55$export$4c0ac1dd4bbf4921;

});

parcelRegister("5a5jw", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("6NrTk");
var $4y4n7 = parcelRequire("4y4n7");
var $d9uty = parcelRequire("d9uty");


var $l2hU1 = parcelRequire("l2hU1");

/** `XHR` based transport */ var $3c220229cf4b91c4$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $d9uty.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $4y4n7.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $l2hU1.BaseTransport));
 //# sourceMappingURL=xhr.js.map
module.exports["XHRTransport"] = $3c220229cf4b91c4$export$874a283af77e8e62;

});

parcelRegister("9whyS", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $9HPf3 = parcelRequire("9HPf3");

var $8uubg = parcelRequire("8uubg");

parcelRequire("6NrTk");
var $4XALr = parcelRequire("4XALr");
var $56AkW = parcelRequire("56AkW");
var $jqTnS = parcelRequire("jqTnS");
var $eVWro = parcelRequire("eVWro");


var $4vRQe = parcelRequire("4vRQe");

var $6ee4b993ee51fbb3$var$global = (0, $jqTnS.getGlobalObject)();
var $6ee4b993ee51fbb3$var$ignoreOnError = 0;
function $6ee4b993ee51fbb3$export$b79738ab10c590b2() {
    return $6ee4b993ee51fbb3$var$ignoreOnError > 0;
}
function $6ee4b993ee51fbb3$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $6ee4b993ee51fbb3$var$ignoreOnError += 1;
    setTimeout(function() {
        $6ee4b993ee51fbb3$var$ignoreOnError -= 1;
    });
}
function $6ee4b993ee51fbb3$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $56AkW.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $6ee4b993ee51fbb3$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $6ee4b993ee51fbb3$export$1265a142ff5ba165();
            (0, $9HPf3.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $4XALr.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $4XALr.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $9HPf3.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $56AkW.markFunctionWrapped)(sentryWrapped, fn);
    (0, $56AkW.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $6ee4b993ee51fbb3$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$6ee4b993ee51fbb3$var$global.document) return;
    if (!options.eventId) {
        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $6ee4b993ee51fbb3$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $8uubg.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $6ee4b993ee51fbb3$var$global.document.head || $6ee4b993ee51fbb3$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
} //# sourceMappingURL=helpers.js.map
module.exports["shouldIgnoreOnError"] = $6ee4b993ee51fbb3$export$b79738ab10c590b2;
module.exports["wrap"] = $6ee4b993ee51fbb3$export$4997ffc0176396a6;
module.exports["injectReportDialog"] = $6ee4b993ee51fbb3$export$deb9aac8ea0b576c;

});

parcelRegister("bNfZ4", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $amM2J = parcelRequire("amM2J");


var $dtZ6d = parcelRequire("dtZ6d");

parcelRequire("6NrTk");
var $hX59D = parcelRequire("hX59D");
var $4XALr = parcelRequire("4XALr");
var $jqTnS = parcelRequire("jqTnS");
var $dx3aE = parcelRequire("dx3aE");
var $iXZ4U = parcelRequire("iXZ4U");
var $hjoOD = parcelRequire("hjoOD");

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $8960ab6c8a94ec5d$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $fbwmZ.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $amM2J.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $4XALr.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $hX59D.addInstrumentationHandler)('console', $8960ab6c8a94ec5d$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $hX59D.addInstrumentationHandler)('dom', $8960ab6c8a94ec5d$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $hX59D.addInstrumentationHandler)('xhr', $8960ab6c8a94ec5d$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $hX59D.addInstrumentationHandler)('fetch', $8960ab6c8a94ec5d$var$_fetchBreadcrumb);
        if (this._options.history) (0, $hX59D.addInstrumentationHandler)('history', $8960ab6c8a94ec5d$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8960ab6c8a94ec5d$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $dx3aE.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $dx3aE.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $amM2J.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8960ab6c8a94ec5d$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $hjoOD.severityFromString)(handlerData.level),
        message: (0, $iXZ4U.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $iXZ4U.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $amM2J.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8960ab6c8a94ec5d$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $amM2J.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8960ab6c8a94ec5d$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $amM2J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $dtZ6d.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $amM2J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8960ab6c8a94ec5d$var$_historyBreadcrumb(handlerData) {
    var global = (0, $jqTnS.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $4XALr.parseUrl)(global.location.href);
    var parsedFrom = (0, $4XALr.parseUrl)(from);
    var parsedTo = (0, $4XALr.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $amM2J.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
} //# sourceMappingURL=breadcrumbs.js.map
module.exports["Breadcrumbs"] = $8960ab6c8a94ec5d$export$2dc68d50d56fbbd;

});

parcelRegister("lBiNe", function(module, exports) {
parcelRequire("6NrTk");
var $eVWro = parcelRequire("eVWro");


var $4vRQe = parcelRequire("4vRQe");

/** Deduplication filter */ var $fb9ba193e0b5c24e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($fb9ba193e0b5c24e$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $fb9ba193e0b5c24e$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fb9ba193e0b5c24e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fb9ba193e0b5c24e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $fb9ba193e0b5c24e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fb9ba193e0b5c24e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fb9ba193e0b5c24e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fb9ba193e0b5c24e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $fb9ba193e0b5c24e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $fb9ba193e0b5c24e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fb9ba193e0b5c24e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fb9ba193e0b5c24e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fb9ba193e0b5c24e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $fb9ba193e0b5c24e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $fb9ba193e0b5c24e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $fb9ba193e0b5c24e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $fb9ba193e0b5c24e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $fb9ba193e0b5c24e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
} //# sourceMappingURL=dedupe.js.map
module.exports["Dedupe"] = $fb9ba193e0b5c24e$export$688d98c249d31ad3;

});

parcelRegister("cEELl", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $amM2J = parcelRequire("amM2J");


var $dtZ6d = parcelRequire("dtZ6d");

parcelRequire("6NrTk");
var $4XALr = parcelRequire("4XALr");
var $hX59D = parcelRequire("hX59D");
var $dx3aE = parcelRequire("dx3aE");
var $23i8z = parcelRequire("23i8z");
var $eVWro = parcelRequire("eVWro");


var $l17tw = parcelRequire("l17tw");


var $4vRQe = parcelRequire("4vRQe");


var $9whyS = parcelRequire("9whyS");

/** Global handlers */ var $9368d70df8944589$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $9368d70df8944589$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $9368d70df8944589$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $fbwmZ.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $9368d70df8944589$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $9368d70df8944589$var$_installGlobalOnErrorHandler() {
    (0, $hX59D.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $fbwmZ.__read)($9368d70df8944589$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($9368d70df8944589$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $9whyS.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $23i8z.isString)(msg) ? $9368d70df8944589$var$_eventFromIncompleteOnError(msg, url, line, column) : $9368d70df8944589$var$_enhanceEventWithInitialFrame((0, $l17tw.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $dtZ6d.Severity).Error;
        $9368d70df8944589$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $9368d70df8944589$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $hX59D.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $fbwmZ.__read)($9368d70df8944589$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($9368d70df8944589$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $9whyS.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $23i8z.isPrimitive)(error) ? $9368d70df8944589$var$_eventFromRejectionWithPrimitive(error) : (0, $l17tw.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $dtZ6d.Severity).Error;
        $9368d70df8944589$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9368d70df8944589$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9368d70df8944589$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $23i8z.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9368d70df8944589$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9368d70df8944589$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $23i8z.isString)(url) && url.length > 0 ? url : (0, $dx3aE.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9368d70df8944589$var$globalHandlerLog(type) {
    (0, $4vRQe.IS_DEBUG_BUILD) && (0, $eVWro.logger).log("Global Handler attached: " + type);
}
function $9368d70df8944589$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $4XALr.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $9368d70df8944589$var$getHubAndAttachStacktrace() {
    var hub = (0, $amM2J.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
} //# sourceMappingURL=globalhandlers.js.map
module.exports["GlobalHandlers"] = $9368d70df8944589$export$204155decbc90e5a;

});

parcelRegister("6oUta", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

parcelRequire("6NrTk");
var $23i8z = parcelRequire("23i8z");


var $l17tw = parcelRequire("l17tw");

var $4a90c99a3362221e$var$DEFAULT_KEY = 'cause';
var $4a90c99a3362221e$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $4a90c99a3362221e$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $4a90c99a3362221e$var$DEFAULT_KEY;
        this._limit = options.limit || $4a90c99a3362221e$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $hkv0W.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $amM2J.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $4a90c99a3362221e$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $4a90c99a3362221e$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $23i8z.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $4a90c99a3362221e$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $fbwmZ.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $4a90c99a3362221e$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $23i8z.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $l17tw.exceptionFromError)(error[key]);
    return $4a90c99a3362221e$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $fbwmZ.__spread)([
        exception
    ], stack));
} //# sourceMappingURL=linkederrors.js.map
module.exports["LinkedErrors"] = $4a90c99a3362221e$export$8d1e60aaf616fb4f;

});

parcelRegister("51FBI", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("6NrTk");
var $56AkW = parcelRequire("56AkW");
var $1MAkl = parcelRequire("1MAkl");
var $jqTnS = parcelRequire("jqTnS");


var $9whyS = parcelRequire("9whyS");

var $3a8d52137d9bc0de$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $3a8d52137d9bc0de$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $fbwmZ.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $jqTnS.getGlobalObject)();
        if (this._options.setTimeout) (0, $56AkW.fill)(global, 'setTimeout', $3a8d52137d9bc0de$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $56AkW.fill)(global, 'setInterval', $3a8d52137d9bc0de$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $56AkW.fill)(global, 'requestAnimationFrame', $3a8d52137d9bc0de$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $56AkW.fill)(XMLHttpRequest.prototype, 'send', $3a8d52137d9bc0de$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $3a8d52137d9bc0de$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($3a8d52137d9bc0de$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $3a8d52137d9bc0de$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $9whyS.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $1MAkl.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3a8d52137d9bc0de$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9whyS.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $1MAkl.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $3a8d52137d9bc0de$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $56AkW.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $1MAkl.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $56AkW.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $1MAkl.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $9whyS.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $3a8d52137d9bc0de$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $jqTnS.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $56AkW.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $9whyS.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $1MAkl.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9whyS.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $1MAkl.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $56AkW.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
} //# sourceMappingURL=trycatch.js.map
module.exports["TryCatch"] = $3a8d52137d9bc0de$export$f1a018517668e6d3;

});

parcelRegister("aMh6Y", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

parcelRequire("6NrTk");
var $jqTnS = parcelRequire("jqTnS");

var $7d8ba90cd5b587c2$var$global = (0, $jqTnS.getGlobalObject)();
/** UserAgent */ var $7d8ba90cd5b587c2$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $hkv0W.addGlobalEventProcessor)(function(event) {
            if ((0, $amM2J.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$7d8ba90cd5b587c2$var$global.navigator && !$7d8ba90cd5b587c2$var$global.location && !$7d8ba90cd5b587c2$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $7d8ba90cd5b587c2$var$global.location && $7d8ba90cd5b587c2$var$global.location.href;
                var referrer = ($7d8ba90cd5b587c2$var$global.document || {}).referrer;
                var userAgent = ($7d8ba90cd5b587c2$var$global.navigator || {}).userAgent;
                var headers = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();
 //# sourceMappingURL=useragent.js.map
module.exports["UserAgent"] = $7d8ba90cd5b587c2$export$5fba5e10934a4faf;

});

parcelRegister("iyIOY", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");
var $eC9tI = parcelRequire("eC9tI");
var $niMUw = parcelRequire("niMUw");
var $4RrPd = parcelRequire("4RrPd");
var $bJv8O = parcelRequire("bJv8O");

var $d82e2b7f9d9ed58c$var$global = (0, $niMUw.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $142hz.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $d82e2b7f9d9ed58c$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $d82e2b7f9d9ed58c$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eC9tI.fill)($d82e2b7f9d9ed58c$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $bJv8O.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $4RrPd.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $4RrPd.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($d82e2b7f9d9ed58c$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
 //# sourceMappingURL=captureconsole.js.map
module.exports["CaptureConsole"] = $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08;

});

parcelRegister("95IFc", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("niMUw")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("h6HKI")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("h6HKI")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("142hz")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("142hz")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("11Kkv")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("eC9tI")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("bJv8O")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("4RrPd")).safeJoin);





parcelRequire("niMUw");


parcelRequire("h6HKI");

parcelRequire("142hz");




var $5kreq = parcelRequire("5kreq");

parcelRequire("11Kkv");

parcelRequire("eC9tI");



parcelRequire("bJv8O");



parcelRequire("4RrPd");




var $6pmA9 = parcelRequire("6pmA9");






 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $5kreq);
$parcel$exportWildcard(module.exports, $6pmA9);

});

parcelRegister("lIxjW", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $h6HKI = parcelRequire("h6HKI");

function $fcf78dd05a1f2799$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fcf78dd05a1f2799$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fcf78dd05a1f2799$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $h6HKI.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fcf78dd05a1f2799$export$1cfafeee2987818b() {
    var global = (0, $niMUw.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
} //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $fcf78dd05a1f2799$export$5647df6b7814ac86;

});

parcelRegister("niMUw", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5kreq = parcelRequire("5kreq");

var $0460b8fabe4a64c2$var$fallbackGlobalObject = {};
function $0460b8fabe4a64c2$export$256479dc0cea61c4() {
    return (0, $5kreq.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $0460b8fabe4a64c2$var$fallbackGlobalObject;
}
function $0460b8fabe4a64c2$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $0460b8fabe4a64c2$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
} //# sourceMappingURL=global.js.map
module.exports["getGlobalObject"] = $0460b8fabe4a64c2$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $0460b8fabe4a64c2$export$7e223ec222791509;

});

parcelRegister("5kreq", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3HxeM = parcelRequire("3HxeM");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3HxeM.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
} //# sourceMappingURL=node.js.map

});

parcelRegister("3HxeM", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $2b1f2b7c68d97ced$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
} //# sourceMappingURL=env.js.map
module.exports["isBrowserBundle"] = $2b1f2b7c68d97ced$export$2928c40372e623c0;

});

parcelRegister("h6HKI", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c744ef8efbbea969$var$objectToString = Object.prototype.toString;
function $c744ef8efbbea969$export$e6127cc7fe7395c3(wat) {
    switch($c744ef8efbbea969$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c744ef8efbbea969$export$49034edbe6b62415(wat, Error);
    }
}
function $c744ef8efbbea969$var$isBuiltin(wat, ty) {
    return $c744ef8efbbea969$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c744ef8efbbea969$export$9f9636d330b71954(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'ErrorEvent');
}
function $c744ef8efbbea969$export$ef9e2056653f0c8e(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMError');
}
function $c744ef8efbbea969$export$12e869b2a583f783(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMException');
}
function $c744ef8efbbea969$export$844ec244b1367d54(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'String');
}
function $c744ef8efbbea969$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c744ef8efbbea969$export$53b83ca8eaab0383(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'Object');
}
function $c744ef8efbbea969$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Event);
}
function $c744ef8efbbea969$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Element);
}
function $c744ef8efbbea969$export$49841c62b9eff15(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'RegExp');
}
function $c744ef8efbbea969$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c744ef8efbbea969$export$bc2894c7158efbac(wat) {
    return $c744ef8efbbea969$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c744ef8efbbea969$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c744ef8efbbea969$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
} //# sourceMappingURL=is.js.map
module.exports["isError"] = $c744ef8efbbea969$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $c744ef8efbbea969$export$49034edbe6b62415;
module.exports["isString"] = $c744ef8efbbea969$export$844ec244b1367d54;
module.exports["isPrimitive"] = $c744ef8efbbea969$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $c744ef8efbbea969$export$53b83ca8eaab0383;
module.exports["isEvent"] = $c744ef8efbbea969$export$9671ea99bd126ace;
module.exports["isElement"] = $c744ef8efbbea969$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $c744ef8efbbea969$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $c744ef8efbbea969$export$bc2894c7158efbac;
module.exports["isNaN"] = $c744ef8efbbea969$export$c9f5652083b8129d;

});

parcelRegister("2Q8PY", function(module, exports) {
var $21174afd68a919a2$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=enums.js.map
module.exports["SeverityLevels"] = $21174afd68a919a2$export$484b1ea9aec914c;

});

parcelRegister("142hz", function(module, exports) {
$parcel$export(module.exports, "logger", () => $0c67ef66515853ff$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $4O82D = parcelRequire("4O82D");


var $niMUw = parcelRequire("niMUw");

// TODO: Implement different loggers for different environments
var $0c67ef66515853ff$var$global = (0, $niMUw.getGlobalObject)();
/** Prefix for logging strings */ var $0c67ef66515853ff$var$PREFIX = 'Sentry Logger ';
var $0c67ef66515853ff$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $0c67ef66515853ff$export$cda52e2a8927a2ca(callback) {
    var global = (0, $niMUw.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $0c67ef66515853ff$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $0c67ef66515853ff$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $0c67ef66515853ff$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $0c67ef66515853ff$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $0c67ef66515853ff$export$af88d00dbe7f521;
if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$af88d00dbe7f521 = (0, $niMUw.getGlobalSingleton)('logger', $0c67ef66515853ff$var$makeLogger);
else $0c67ef66515853ff$export$af88d00dbe7f521 = $0c67ef66515853ff$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["CONSOLE_LEVELS"] = $0c67ef66515853ff$export$2a2b1d2252a69ecb;

});

parcelRegister("4O82D", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $380211d076ff50e5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $380211d076ff50e5$export$48a8984ec0bf2e44;

});

parcelRegister("aY4rC", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $7fc2f48fbe1d088a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
} //# sourceMappingURL=memo.js.map
module.exports["memoBuilder"] = $7fc2f48fbe1d088a$export$8115b0b78e956ab3;

});

parcelRegister("11Kkv", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $h6HKI = parcelRequire("h6HKI");


var $aY4rC = parcelRequire("aY4rC");


var $eC9tI = parcelRequire("eC9tI");


var $fgmiz = parcelRequire("fgmiz");

function $0bf9d29200a37024$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $0bf9d29200a37024$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $0bf9d29200a37024$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $0bf9d29200a37024$export$a3295358bff77e(object, depth);
    if ($0bf9d29200a37024$var$jsonSize(normalized) > maxSize) return $0bf9d29200a37024$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $0bf9d29200a37024$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $aY4rC.memoBuilder)();
    var _a = (0, $fbwmZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $h6HKI.isNaN)(value)) return value;
    var stringified = $0bf9d29200a37024$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $h6HKI.isError)(value) || (0, $h6HKI.isEvent)(value) ? (0, $eC9tI.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $0bf9d29200a37024$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $0bf9d29200a37024$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $h6HKI.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $fgmiz.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $0bf9d29200a37024$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $0bf9d29200a37024$var$jsonSize(value) {
    return $0bf9d29200a37024$var$utf8Length(JSON.stringify(value));
} //# sourceMappingURL=normalize.js.map
module.exports["normalize"] = $0bf9d29200a37024$export$a3295358bff77e;

});

parcelRegister("eC9tI", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $lIxjW = parcelRequire("lIxjW");


var $h6HKI = parcelRequire("h6HKI");


var $4RrPd = parcelRequire("4RrPd");

function $aa3bf77b99750f4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $aa3bf77b99750f4a$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $aa3bf77b99750f4a$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $aa3bf77b99750f4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $aa3bf77b99750f4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $aa3bf77b99750f4a$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $h6HKI.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $aa3bf77b99750f4a$var$getOwnProperties(value));
    else if ((0, $h6HKI.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.target),
            currentTarget: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.currentTarget)
        }, $aa3bf77b99750f4a$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $h6HKI.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $aa3bf77b99750f4a$var$serializeEventTarget(target) {
    try {
        return (0, $h6HKI.isElement)(target) ? (0, $lIxjW.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $aa3bf77b99750f4a$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $aa3bf77b99750f4a$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($aa3bf77b99750f4a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4RrPd.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4RrPd.truncate)(serialized, maxLength);
    }
    return '';
}
function $aa3bf77b99750f4a$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $h6HKI.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $aa3bf77b99750f4a$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($aa3bf77b99750f4a$export$d25f2688db1bb433);
    return val;
}
function $aa3bf77b99750f4a$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $h6HKI.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
} //# sourceMappingURL=object.js.map
module.exports["fill"] = $aa3bf77b99750f4a$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $aa3bf77b99750f4a$export$62ff257738bf57f5;

});

parcelRegister("4RrPd", function(module, exports) {

var $h6HKI = parcelRequire("h6HKI");

function $38a1b21eefbb9b2d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $38a1b21eefbb9b2d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $38a1b21eefbb9b2d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $38a1b21eefbb9b2d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $h6HKI.isString)(value)) return false;
    if ((0, $h6HKI.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $38a1b21eefbb9b2d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
} //# sourceMappingURL=string.js.map
module.exports["truncate"] = $38a1b21eefbb9b2d$export$6a506b36fdea397d;
module.exports["safeJoin"] = $38a1b21eefbb9b2d$export$465e9d514283d4fd;

});

parcelRegister("fgmiz", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT = 50;
function $b1c9a5aa64b78b97$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fbwmZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fbwmZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $b1c9a5aa64b78b97$export$c55c24c0eeba0205(frames);
    };
}
function $b1c9a5aa64b78b97$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $b1c9a5aa64b78b97$var$defaultFunctionName = '<anonymous>';
function $b1c9a5aa64b78b97$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b1c9a5aa64b78b97$var$defaultFunctionName;
        return fn.name || $b1c9a5aa64b78b97$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b1c9a5aa64b78b97$var$defaultFunctionName;
    }
} //# sourceMappingURL=stacktrace.js.map
module.exports["getFunctionName"] = $b1c9a5aa64b78b97$export$aad197c7121a6651;

});

parcelRegister("bJv8O", function(module, exports) {

var $dtZ6d = parcelRequire("dtZ6d");


var $2Q8PY = parcelRequire("2Q8PY");

function $88ac0da36f058dd3$var$isSupportedSeverity(level) {
    return (0, $2Q8PY.SeverityLevels).indexOf(level) !== -1;
}
function $88ac0da36f058dd3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $dtZ6d.Severity).Warning;
    if ($88ac0da36f058dd3$var$isSupportedSeverity(level)) return level;
    return (0, $dtZ6d.Severity).Log;
} //# sourceMappingURL=severity.js.map
module.exports["severityFromString"] = $88ac0da36f058dd3$export$e01cef29b4327697;

});

parcelRegister("6pmA9", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $5kreq = parcelRequire("5kreq");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5kreq.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5kreq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}(); //# sourceMappingURL=time.js.map

});

parcelRegister("6W0Xl", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");


var $c9L3v = parcelRequire("c9L3v");

/** Deduplication filter */ var $50c8e6bccf5bbb5e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
} //# sourceMappingURL=dedupe.js.map
module.exports["Dedupe"] = $50c8e6bccf5bbb5e$export$688d98c249d31ad3;

});

parcelRegister("c9L3v", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8d9ad39358b035f4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $8d9ad39358b035f4$export$48a8984ec0bf2e44;

});

parcelRegister("fa95z", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("95IFc");
var $h6HKI = parcelRequire("h6HKI");
var $142hz = parcelRequire("142hz");
var $11Kkv = parcelRequire("11Kkv");


var $c9L3v = parcelRequire("c9L3v");

/** Patch toString calls to return proper name for wrapped functions */ var $b09ed70491c36903$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $fbwmZ.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $h6HKI.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $fbwmZ.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $11Kkv.normalize)(errorData, this._options.depth);
            if ((0, $h6HKI.isPlainObject)(normalizedErrorData)) contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $fbwmZ.__assign)({}, normalizedErrorData), _a));
            return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $fbwmZ.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $fbwmZ.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
 //# sourceMappingURL=extraerrordata.js.map
module.exports["ExtraErrorData"] = $b09ed70491c36903$export$56d961ef3a52a072;

});

parcelRegister("hLq0X", function(module, exports) {
/** Add node transaction to the event */ var $ceeb015bb088f872$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
 //# sourceMappingURL=transaction.js.map
module.exports["Transaction"] = $ceeb015bb088f872$export$febc5573c75cefb0;

});

parcelRegister("h9r4d", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("lIkvQ")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("kFTt2")).default);

var $lIkvQ = parcelRequire("lIkvQ");


var $kFTt2 = parcelRequire("kFTt2");


var $4sTW6 = parcelRequire("4sTW6");


});

parcelRegister("4sTW6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $kFTt2 = parcelRequire("kFTt2");

class $28efc9af7e790139$var$CatchAndReportErrors extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $kFTt2.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    }
}
const $28efc9af7e790139$var$reportingErrorBoundary = (0, $lzgC6.default)()($28efc9af7e790139$var$CatchAndReportErrors);
var $28efc9af7e790139$export$2e2bcd8739ae039 = $28efc9af7e790139$var$reportingErrorBoundary;

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $8OcYi = parcelRequire("8OcYi");

var $3ewaO = parcelRequire("3ewaO");


var $drRzc = parcelRequire("drRzc");


var $ieeJu = parcelRequire("ieeJu");


var $4B79C = parcelRequire("4B79C");

var $ggGdk = parcelRequire("ggGdk");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");


var $4yccB = parcelRequire("4yccB");


var $iDrrr = parcelRequire("iDrrr");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX);
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX);
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $ieeJu.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $iDrrr.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $d4521f0694a3bb0e$var$isConfluenceTeamCalendars(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $iDrrr.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url) && (0, $iDrrr.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    async resolvesToHardCodedEmbed(url) {
        try {
            const response = await this.fetchData(url);
            const resolvedUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
            return resolvedUrl !== undefined && this.getHardCodedAppearance(resolvedUrl) === 'embed';
        } catch  {
            return false;
        }
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $8OcYi.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $iDrrr.fg)('issue-link-suggestions-in-comments')) {
                if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                const isNativeEmbedShortlinkResolutionEnabled = (0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
                const shouldResolveShortLinkForEmbed = isNativeEmbedShortlinkResolutionEnabled && matchedProviderPattern !== undefined && $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl(url) && userPreference === undefined && isEmbedFriendlyLocationEvaluated;
                // Confluence shortlinks do not identify their content type. Resolve the URL before
                // deciding whether it should use one of the existing hardcoded embed appearances.
                if (shouldResolveShortLinkForEmbed && await this.resolvesToHardCodedEmbed(url)) preferredAppearance = 'embed';
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $4B79C.getBaseUrl)(envKey);
        this.resolverUrl = (0, $4B79C.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $fqVYq = parcelRequire("fqVYq");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");

var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $842937149a04b8ba$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $6YrB3.default)($842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("iH6fo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2InGJ = parcelRequire("2InGJ");


var $kFPLe = parcelRequire("kFPLe");


var $5yzjy = parcelRequire("5yzjy");

const $f5fbbd31e0646586$var$useUniversalPreset = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniversalPreset(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { props: props, initialPluginConfiguration: initialPluginConfiguration } = t0;
    const previousEditorProps = (0, $2InGJ.default)(props);
    let t1;
    if ($[0] !== initialPluginConfiguration || $[1] !== previousEditorProps || $[2] !== props) {
        t1 = ()=>(0, $kFPLe.createUniversalPreset)({
                props: props,
                prevProps: previousEditorProps,
                initialPluginConfiguration: initialPluginConfiguration
            });
        $[0] = initialPluginConfiguration;
        $[1] = previousEditorProps;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    const [preset, setPreset] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[4] !== initialPluginConfiguration || $[5] !== previousEditorProps || $[6] !== props) {
        t2 = ()=>{
            if (!previousEditorProps) return;
            const recreate = (0, $5yzjy.shouldRecreatePreset)(previousEditorProps, props);
            if (!recreate) return;
            setPreset((0, $kFPLe.createUniversalPreset)({
                props: props,
                prevProps: previousEditorProps,
                initialPluginConfiguration: initialPluginConfiguration
            }));
        };
        t3 = [
            props,
            previousEditorProps,
            initialPluginConfiguration
        ];
        $[4] = initialPluginConfiguration;
        $[5] = previousEditorProps;
        $[6] = props;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useLayoutEffect)(t2, t3);
    return preset;
} : function useUniversalPreset({ props: props, initialPluginConfiguration: initialPluginConfiguration }) {
    const previousEditorProps = (0, $2InGJ.default)(props);
    const [preset, setPreset] = (0, $cozmU.useState)(()=>(0, $kFPLe.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!previousEditorProps) return;
        const recreate = (0, $5yzjy.shouldRecreatePreset)(previousEditorProps, props);
        if (!recreate) return;
        // we are not comparing the previous initialPluginConfiguration to the new one assuming that it never changes
        setPreset((0, $kFPLe.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    }, [
        props,
        previousEditorProps,
        initialPluginConfiguration
    ]);
    return preset;
};
var $f5fbbd31e0646586$export$2e2bcd8739ae039 = $f5fbbd31e0646586$var$useUniversalPreset;
module.exports["default"] = $f5fbbd31e0646586$export$2e2bcd8739ae039;

});

parcelRegister("kFPLe", function(module, exports) {

var $kMKy3 = parcelRequire("kMKy3");


var $cfjQo = parcelRequire("cfjQo");


var $ceZg8 = parcelRequire("ceZg8");

function $16d68aa92ac52444$export$28b0115d03e9c7ad({ props: props, prevProps: prevProps, initialPluginConfiguration: initialPluginConfiguration }) {
    return (0, $kMKy3.default)({
        appearance: props.appearance,
        props: (0, $ceZg8.getDefaultPresetOptionsFromEditorProps)(props),
        initialPluginConfiguration: initialPluginConfiguration,
        featureFlags: (0, $cfjQo.createFeatureFlagsFromProps)(props.featureFlags),
        prevAppearance: prevProps?.appearance
    });
}
module.exports["createUniversalPreset"] = $16d68aa92ac52444$export$28b0115d03e9c7ad;

});

parcelRegister("kMKy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3cf84a6b8773be$export$2e2bcd8739ae039);

var $jj5K7 = parcelRequire("jj5K7");


var $7eCZG = parcelRequire("7eCZG");


var $dYbu7 = parcelRequire("dYbu7");


var $gLxaI = parcelRequire("gLxaI");


var $60Pfj = parcelRequire("60Pfj");


var $cX2jD = parcelRequire("cX2jD");


var $bUlOg = parcelRequire("bUlOg");


var $dHFAY = parcelRequire("dHFAY");


var $9ki8I = parcelRequire("9ki8I");


var $fLS6B = parcelRequire("fLS6B");


var $cud1R = parcelRequire("cud1R");


var $40ukF = parcelRequire("40ukF");


var $kaUwk = parcelRequire("kaUwk");


var $gh55E = parcelRequire("gh55E");


var $8PVlW = parcelRequire("8PVlW");


var $l5MIu = parcelRequire("l5MIu");


var $f2WDp = parcelRequire("f2WDp");


var $7gk7g = parcelRequire("7gk7g");


var $4y9hw = parcelRequire("4y9hw");


var $k7vUa = parcelRequire("k7vUa");


var $k8SUN = parcelRequire("k8SUN");


var $3gmKQ = parcelRequire("3gmKQ");


var $hCTxc = parcelRequire("hCTxc");


var $dGnqc = parcelRequire("dGnqc");


var $7iL2d = parcelRequire("7iL2d");


var $iVGec = parcelRequire("iVGec");


var $eHllO = parcelRequire("eHllO");


var $laiso = parcelRequire("laiso");


var $5UJW4 = parcelRequire("5UJW4");


var $HGu9Y = parcelRequire("HGu9Y");


var $5HQgD = parcelRequire("5HQgD");


var $4exuQ = parcelRequire("4exuQ");


var $hFvHs = parcelRequire("hFvHs");


var $63nNo = parcelRequire("63nNo");


var $5bzSg = parcelRequire("5bzSg");


var $7gEjc = parcelRequire("7gEjc");


var $2ZvWx = parcelRequire("2ZvWx");


var $jeuMk = parcelRequire("jeuMk");


var $4Bdub = parcelRequire("4Bdub");


var $1K7sQ = parcelRequire("1K7sQ");


var $2hEu6 = parcelRequire("2hEu6");


var $jNalm = parcelRequire("jNalm");


var $3VDvd = parcelRequire("3VDvd");


var $drevR = parcelRequire("drevR");


var $fxjEF = parcelRequire("fxjEF");


var $gUZEQ = parcelRequire("gUZEQ");


var $jIG3b = parcelRequire("jIG3b");


var $gkbos = parcelRequire("gkbos");


var $1171P = parcelRequire("1171P");


var $ctVsO = parcelRequire("ctVsO");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $loGKD = parcelRequire("loGKD");


var $kLi51 = parcelRequire("kLi51");


var $4nt1R = parcelRequire("4nt1R");

function $2f3cf84a6b8773be$export$2e2bcd8739ae039({ appearance: appearance, props: props, featureFlags: featureFlags, initialPluginConfiguration: initialPluginConfiguration, prevAppearance: prevAppearance, createAnalyticsEvent: createAnalyticsEvent }) {
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const isFullPage = (0, $loGKD.isFullPage)(appearance);
    const getEditorFeatureFlags = ()=>featureFlags;
    const defaultPreset = (0, $4nt1R.createDefaultPreset)({
        ...props,
        blockType: {
            ...props.blockType,
            ...initialPluginConfiguration?.blockTypePlugin
        },
        blockMenu: {
            enabled: initialPluginConfiguration?.blockMenuPlugin?.enabled ?? false,
            useStandardNodeWidth: initialPluginConfiguration?.blockMenuPlugin?.useStandardNodeWidth ?? false,
            blockLinkHashPrefix: initialPluginConfiguration?.blockMenuPlugin?.blockLinkHashPrefix,
            getLinkPath: initialPluginConfiguration?.blockMenuPlugin?.getLinkPath
        },
        appearance: appearance,
        createAnalyticsEvent: createAnalyticsEvent,
        hyperlinkOptions: {
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            ...props.hyperlinkOptions
        },
        __livePage: props.__livePage,
        toolbar: initialPluginConfiguration?.toolbarPlugin
    });
    const statusMenuDisabled = !props.allowStatus ? true : typeof props.allowStatus === 'object' ? Boolean(props.allowStatus.menuDisabled) : false;
    const hasBeforePrimaryToolbar = (components)=>{
        if (components && 'before' in components) return !!components.before;
        return false;
    };
    const finalPreset = defaultPreset.add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).maybeAdd([
        (0, $dHFAY.blockControlsPlugin),
        {
            quickInsertButtonEnabled: initialPluginConfiguration?.blockControlsPlugin?.quickInsertButtonEnabled ?? true,
            rightSideControlsEnabled: initialPluginConfiguration?.blockControlsPlugin?.rightSideControlsEnabled ?? false
        }
    ], Boolean(initialPluginConfiguration?.blockControlsPlugin?.enabled ?? false)).maybeAdd([
        (0, $fLS6B.breakoutPlugin),
        {
            allowBreakoutButton: appearance === 'full-page',
            appearance: appearance
        }
    ], Boolean(props.allowBreakout && (isFullPage || appearance === 'max' && ((0, $anBbz.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('confluence_max_width_content_appearance', 'isEnabled', true))))).maybeAdd((0, $dYbu7.alignmentPlugin), Boolean(props.allowTextAlignment)).maybeAdd([
        (0, $gkbos.textColorPlugin),
        props.allowTextColor
    ], Boolean(props.allowTextColor)).add((0, $hFvHs.listPlugin)).maybeAdd((0, $2hEu6.rulePlugin), Boolean(props.allowRule)).maybeAdd([
        (0, $k8SUN.expandPlugin),
        {
            allowInsertion: $2f3cf84a6b8773be$export$a9b5e68d7107c3df(props),
            useLongPressSelection: false,
            appearance: appearance,
            allowInteractiveExpand: typeof props.allowExpand === 'boolean' ? props.allowExpand : Boolean(props.allowExpand && props.allowExpand.allowInteractiveExpand !== false),
            __livePage: props.__livePage
        }
    ], Boolean(props.allowExpand)).maybeAdd((0, $eHllO.guidelinePlugin), Boolean(!isComment && !isChromeless && (props.media || props.allowTables) || (0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true, {
        exposure: true
    }) && (props.allowExpand || props.allowLayouts || props.codeBlock))).maybeAdd([
        (0, $iVGec.gridPlugin),
        {
            shouldCalcBreakoutGridLines: isFullPage
        }
    ], Boolean(props.media)).maybeAdd([
        (0, $gLxaI.annotationPlugin),
        props.annotationProviders
    ], Boolean(props.annotationProviders)).maybeAdd([
        (0, $5bzSg.mediaPlugin),
        {
            ...props.media,
            allowLazyLoading: true,
            allowBreakoutSnapPoints: isFullPage,
            allowAdvancedToolBarOptions: typeof props.media?.allowAdvancedToolBarOptions !== 'undefined' ? props.media?.allowAdvancedToolBarOptions : isFullPage || isComment,
            allowCommentsOnMedia: isFullPage && Boolean(props.annotationProviders),
            allowDropzoneDropLine: isFullPage,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkingUploadsAsIncomplete: false,
            allowImagePreview: typeof props.media?.allowImagePreview !== 'undefined' ? props.media?.allowImagePreview : isFullPage,
            fullWidthEnabled: appearance === 'full-width',
            editorAppearance: appearance,
            uploadErrorHandler: props.uploadErrorHandler,
            waitForMediaUpload: props.waitForMediaUpload,
            isCopyPasteEnabled: true,
            alignLeftOnInsert: typeof props.media?.alignLeftOnInsert !== 'undefined' ? props.media?.alignLeftOnInsert : isComment,
            getEditorFeatureFlags: getEditorFeatureFlags
        }
    ], Boolean(props.media)).maybeAdd((0, $7gEjc.mediaInsertPlugin), Boolean(props.media)).maybeAdd((0, $cud1R.default), Boolean(props.media?.allowCaptions)).maybeAdd([
        (0, $2ZvWx.mentionsPlugin),
        {
            sanitizePrivateContent: props.sanitizePrivateContent,
            insertDisplayName: props.mention?.insertDisplayName ?? props.mentionInsertDisplayName,
            allowZeroWidthSpaceAfter: true,
            HighlightComponent: props.mention?.HighlightComponent,
            profilecardProvider: props.mention?.profilecardProvider,
            mentionProvider: props.mentionProvider,
            ...initialPluginConfiguration?.mentionsPlugin
        }
    ], Boolean(props.mentionProvider)).maybeAdd([
        (0, $k7vUa.emojiPlugin),
        {
            emojiProvider: props.emojiProvider,
            ...initialPluginConfiguration?.emojiPlugin
        }
    ], Boolean(props.emojiProvider)).maybeAdd([
        (0, $gUZEQ.default),
        {
            tableOptions: !props.allowTables || typeof props.allowTables === 'boolean' ? {} : props.allowTables,
            isTableScalingEnabled: isFullPage || isComment,
            allowContextualMenu: true,
            fullWidthEnabled: appearance === 'full-width',
            wasFullWidthEnabled: prevAppearance && prevAppearance === 'full-width',
            getEditorFeatureFlags: getEditorFeatureFlags,
            isCommentEditor: isComment,
            isChromelessEditor: isChromeless,
            allowFixedColumnWidthOption: props.allowTables && typeof props.allowTables !== 'boolean' && props.allowTables.allowFixedColumnWidthOption,
            __livePage: props.__livePage
        }
    ], Boolean(props.allowTables)).maybeAdd([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        {
            allowNestedTasks: props.allowNestedTasks,
            consumeTabs: isFullPage,
            useLongPressSelection: false,
            taskDecisionProvider: props.taskDecisionProvider,
            ...initialPluginConfiguration?.tasksAndDecisionsPlugin
        }
    ], Boolean(props.allowTasksAndDecisions || props.taskDecisionProvider)).maybeAdd([
        (0, $hCTxc.feedbackDialogPlugin),
        {
            coreVersion: $kLi51.version,
            ...props.feedbackInfo
        }
    ], Boolean(props.feedbackInfo)).maybeAdd([
        (0, $laiso.helpDialogPlugin),
        !!props.legacyImageUploadProvider
    ], Boolean(props.allowHelpDialog)).maybeAdd([
        (0, $jNalm.saveOnEnterPlugin),
        props.onSave
    ], Boolean(props.saveOnEnter && props.onSave)).maybeAdd((0, $5UJW4.imageUploadPlugin), Boolean(props.legacyImageUploadProvider)).maybeAdd(// duplicate plugin exists because first one if media is enabled
    // second one when “media is disabled, and legacyMediaProvider is enabled
    // @ts-expect-error
    [
        (0, $5bzSg.mediaPlugin),
        {
            allowMediaSingle: {
                disableLayout: true
            },
            allowMediaGroup: false,
            isCopyPasteEnabled: true
        }
    ], Boolean(props.legacyImageUploadProvider && !props.media)).maybeAdd([
        (0, $gh55E.collabEditPlugin),
        {
            ...props.collabEdit,
            sanitizePrivateContent: props.sanitizePrivateContent,
            EXPERIMENTAL_allowInternalErrorAnalytics: props.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $jj5K7.shouldForceTracking)()
        }
    ], Boolean(props.collabEdit || props.collabEditProvider)).maybeAdd([
        (0, $63nNo.default),
        props.maxContentSize
    ], Boolean(props.maxContentSize)).maybeAdd([
        (0, $jeuMk.default),
        {
            useLongPressSelection: false,
            allowCustomPanel: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanel : false,
            allowCustomPanelEdit: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanelEdit : false
        }
    ], Boolean(props.allowPanel)).maybeAdd((0, $l5MIu.contextPanelPlugin), Boolean(isFullPage)).maybeAdd([
        (0, $3gmKQ.extensionPlugin),
        {
            breakoutEnabled: appearance === 'full-page' && (typeof props.allowExtension === 'object' ? props.allowExtension.allowBreakout : true) !== false,
            extensionHandlers: props.extensionHandlers,
            useLongPressSelection: false,
            appearance: appearance,
            ...initialPluginConfiguration?.extensionPlugin
        }
    ], Boolean(props.allowExtension)).maybeAdd(// we are ignoring a duplicate plugin error here
    // this error exists because we have two annotation plugins being added
    // one with annotationProviders and one with allowConfluenceInlineComment
    // long term this and media should be consolidated into adding both only once
    // @ts-expect-error
    [
        (0, $gLxaI.annotationPlugin),
        undefined
    ], Boolean(!props.annotationProviders && props.allowConfluenceInlineComment)).maybeAdd([
        (0, $4y9hw.default),
        {
            weekStartDay: typeof props.allowDate === 'object' ? props.allowDate.weekStartDay : undefined
        }
    ], Boolean(props.allowDate)).maybeAdd([
        (0, $1K7sQ.default),
        // @ts-expect-error 2322: Type 'false | PlaceholderTextOptions | undefined'
        props.allowTemplatePlaceholders !== true ? props.allowTemplatePlaceholders : {}
    ], Boolean(props.allowTemplatePlaceholders)).maybeAdd([
        (0, $4exuQ.layoutPlugin),
        {
            ...typeof props.allowLayouts === 'object' ? props.allowLayouts : {},
            useLongPressSelection: false,
            UNSAFE_allowSingleColumnLayout: typeof props.allowLayouts === 'object' ? props.allowLayouts.UNSAFE_allowSingleColumnLayout : undefined,
            editorAppearance: appearance
        }
    ], Boolean(props.allowLayouts)).maybeAdd([
        (0, $40ukF.cardPlugin),
        {
            ...props.UNSAFE_cards,
            ...props.smartLinks,
            ...props.linking?.smartLinks,
            fullWidthMode: appearance === 'full-width',
            linkPicker: props.linking?.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            editorAppearance: appearance,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: props.__livePage
        }
    ], Boolean(props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards)).maybeAdd([
        (0, $f2WDp.customAutoformatPlugin),
        {
            autoformattingProvider: props.autoformattingProvider
        }
    ], Boolean(props.autoformattingProvider)).maybeAdd([
        (0, $drevR.statusPlugin),
        {
            menuDisabled: statusMenuDisabled,
            allowZeroWidthSpaceAfter: true
        }
    ], Boolean(props.allowStatus)).maybeAdd([
        (0, $fxjEF.syncedBlockPlugin),
        props.syncBlock
    ], Boolean(props.syncBlock) && (0, $fqVYq.editorExperiment)('platform_synced_block', true)).maybeAdd((0, $HGu9Y.indentationPlugin), Boolean(props.allowIndentation)).maybeAdd((0, $3VDvd.scrollIntoViewPlugin), Boolean(props.autoScrollIntoView !== false)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: !!props.showIndentationButtons,
            allowHeadingAndParagraphIndentation: !!props.allowIndentation
        }
    ]).add([
        (0, $5HQgD.insertBlockPlugin),
        {
            allowTables: !!props.allowTables,
            allowExpand: $2f3cf84a6b8773be$export$a9b5e68d7107c3df(props),
            insertMenuItems: props.insertMenuItems,
            horizontalRuleEnabled: props.allowRule,
            tableSelectorSupported: featureFlags?.tableSelector && isFullPage,
            nativeStatusSupported: !statusMenuDisabled,
            showElementBrowserLink: props.elementBrowser && props.elementBrowser.showModal || false,
            appearance: appearance,
            ...initialPluginConfiguration?.insertBlockPlugin
        }
    ]).maybeAdd([
        (0, $bUlOg.beforePrimaryToolbarPlugin),
        {
            beforePrimaryToolbarComponents: // @ts-expect-error 2339: Property 'before' does not exist on type 'PrimaryToolbarComponents'.
            props.primaryToolbarComponents?.before
        }
    ], Boolean(hasBeforePrimaryToolbar(props.primaryToolbarComponents) && !featureFlags.twoLineEditorToolbar)).add([
        (0, $60Pfj.avatarGroupPlugin),
        {
            // Avatars are moved to Confluence codebase for Edit in Context
            // When Edit in Context is enabled primaryToolbarComponents is undefined
            // For more details please check
            // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
            collabEdit: props.collabEdit,
            takeFullWidth: !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            showAvatarGroup: featureFlags.showAvatarGroupAsPlugin === true && !featureFlags.twoLineEditorToolbar
        }
    ]).maybeAdd([
        (0, $dGnqc.findReplacePlugin),
        {
            takeFullWidth: !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            twoLineEditorToolbar: !!props.primaryToolbarComponents && !!featureFlags.twoLineEditorToolbar
        }
    ], Boolean(props.allowFindReplace)).maybeAdd((0, $9ki8I.borderPlugin), Boolean(props.allowBorderMark)).maybeAdd((0, $7iL2d.fragmentPlugin), Boolean(props.allowFragmentMark)).add((0, $4Bdub.pasteOptionsToolbarPlugin)).maybeAdd([
        (0, $kaUwk.codeBidiWarningPlugin),
        {
            appearance: appearance
        }
    ], !(0, $ieeJu.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true));
    return finalPreset;
}
function $2f3cf84a6b8773be$export$a9b5e68d7107c3df({ allowExpand: allowExpand }) {
    if (allowExpand === true && (0, $ieeJu.expValEquals)('platform_editor_expand_paste_in_comment_editor', 'isEnabled', true)) return true;
    if (allowExpand && typeof allowExpand === 'object') return !!allowExpand.allowInsertion;
    return false;
}

});

parcelRegister("bUlOg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $ahstG = parcelRequire("ahstG");

const $daf12a5ca9384865$export$66dff0ee14673555 = ({ api: api, config: props })=>{
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ahstG.BeforePrimaryToolbarWrapper), {
            beforePrimaryToolbarComponents: props?.beforePrimaryToolbarComponents
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'beforePrimaryToolbar',
        component: primaryToolbarComponent
    });
    return {
        name: 'beforePrimaryToolbar',
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["beforePrimaryToolbarPlugin"] = $daf12a5ca9384865$export$66dff0ee14673555;

});

parcelRegister("ahstG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");

function $591a93da05fcf652$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $591a93da05fcf652$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "4jjuk5",
    styles: "display:flex;margin-right:var(--ds-space-100, 8px);flex-grow:1;justify-content:flex-end;align-items:center"
};
const $591a93da05fcf652$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $591a93da05fcf652$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);
module.exports["BeforePrimaryToolbarWrapper"] = $591a93da05fcf652$export$b41281e8d2acb8ab;

});

parcelRegister("gh55E", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $iLrhi = parcelRequire("iLrhi");


var $3xuv0 = parcelRequire("3xuv0");


var $eOaGc = parcelRequire("eOaGc");


var $iDrrr = parcelRequire("iDrrr");


var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $6rAEj = parcelRequire("6rAEj");


var $a8NwW = parcelRequire("a8NwW");


var $eEHpO = parcelRequire("eEHpO");


var $k5ilr = parcelRequire("k5ilr");


var $jkbED = parcelRequire("jkbED");


var $alVJS = parcelRequire("alVJS");


var $jm7OT = parcelRequire("jm7OT");


var $6ixNC = parcelRequire("6ixNC");


var $auTW7 = parcelRequire("auTW7");


var $g5VrR = parcelRequire("g5VrR");


var $89tlI = parcelRequire("89tlI");


var $fkzSG = parcelRequire("fkzSG");


var $03X0Y = parcelRequire("03X0Y");

const $337191a1934f18d7$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $337191a1934f18d7$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $eOaGc.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $337191a1934f18d7$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $eOaGc.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $337191a1934f18d7$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    let providerResolver = ()=>{};
    const editorViewRef = {
        current: null
    };
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $337191a1934f18d7$var$providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined,
                lastReconnectionConflictMetadata: undefined
            };
            const collabPluginState = (0, $k5ilr.pluginKey).getState(state);
            const metadata = (0, $g5VrR.trackNCSInitializationPluginKey).getState(state);
            const lastOrganicChangeState = (0, $auTW7.trackLastOrganicChangePluginKey).getState(state);
            const lastRemoteConflict = (0, $89tlI.trackLastRemoteConflictPluginKey).getState(state);
            return {
                activeParticipants: collabPluginState?.activeParticipants,
                sessionId: collabPluginState?.sessionId,
                initialised: {
                    collabInitialisedAt: metadata?.collabInitialisedAt || null,
                    firstChangeAfterInitAt: metadata?.firstChangeAfterInitAt || null,
                    firstContentBodyChangeAfterInitAt: metadata?.firstContentBodyChangeAfterInitAt || null,
                    lastLocalOrganicChangeAt: lastOrganicChangeState?.lastLocalOrganicChangeAt || null,
                    lastRemoteOrganicChangeAt: lastOrganicChangeState?.lastRemoteOrganicChangeAt || null,
                    lastLocalOrganicBodyChangeAt: lastOrganicChangeState?.lastLocalOrganicBodyChangeAt || null,
                    lastRemoteOrganicBodyChangeAt: lastOrganicChangeState?.lastRemoteOrganicBodyChangeAt || null
                },
                lastReconnectionConflictMetadata: lastRemoteConflict
            };
        },
        actions: {
            getAvatarColor: $03X0Y.getAvatarColor,
            addInlineCommentMark: $337191a1934f18d7$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $337191a1934f18d7$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument'),
            getCurrentCollabState: ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const adfDocument = new (0, $3xuv0.JSONTransformer)().encode(editorViewRef.current.state.doc);
                return {
                    content: adfDocument,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    version: (0, $7TcbF.getCollabState)(editorViewRef.current.state)?.version || 0,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sendableSteps: (0, $7TcbF.sendableSteps)(editorViewRef.current.state)
                };
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validatePMJSONDocument: (doc)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorViewRef.current.state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch  {
                        return false;
                    }
                    return true;
                });
            }
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const transformUnconfirmed = (steps)=>{
                let transformed = steps;
                if ((0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
                    exposure: true
                })) transformed = (0, $a8NwW.filterAnalyticsSteps)(transformed);
                if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) transformed = (0, $jkbED.mergeUnconfirmedSteps)(transformed, api);
                return transformed;
            };
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $7TcbF.collab)({
                                clientID: userId,
                                transformUnconfirmed: transformUnconfirmed
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $jm7OT.nativeCollabProviderPlugin)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $eEHpO.createPlugin)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $g5VrR.createPlugin)
                }
            ];
            plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $6ixNC.createPlugin)((tr)=>{
                        const sanitizedSteps = tr.steps.map((step)=>(0, $6ixNC.sanitizeFilteredStep)(step));
                        api?.analytics?.actions?.fireAnalyticsEvent({
                            action: (0, $krYZG.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $auTW7.createPlugin)
            });
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) plugins.push({
                name: 'trackLastRemoteConflictPlugin',
                plugin: (0, $89tlI.createPlugin)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            const addErrorAnalytics = (0, $aQ9Nh.addSynchronyErrorAnalytics)(props.newEditorState, props.newEditorState.tr, featureFlags, api?.analytics?.actions);
            const isEmptyDoc = (0, $iLrhi.isEmptyDocument)(props.newEditorState.doc);
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            executeProviderCode((0, $6rAEj.sendTransaction)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options.useNativePlugin ?? false,
                hideTelecursorOnLoad: !isEmptyDoc && (options.hideTelecursorOnLoad ?? false),
                viewMode: viewMode
            }), addErrorAnalytics);
            if (!(0, $ieeJu.expValEquals)('platform_editor_remove_collab_step_metrics', 'isEnabled', true)) (0, $fkzSG.track)({
                api: api,
                ...props,
                onTrackDataProcessed: (steps)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).STEPS_TRACKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            steps: steps
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
            if ((0, $iDrrr.fg)('platform_editor_collab_organic_change_reporting')) (0, $alVJS.monitorOrganic)({
                api: api,
                ...props,
                onDataProcessed: (data)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).ORGANIC_CHANGES_TRACKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            organicChanges: data
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        },
        commands: {
            nudgeTelepointer: (sessionId)=>({ tr: tr })=>{
                    tr.setMeta('nudgeTelepointer', {
                        sessionId: sessionId
                    });
                    return tr;
                }
        }
    };
};
module.exports["collabEditPlugin"] = $337191a1934f18d7$export$7b59344e4e475116;

});

parcelRegister("7TcbF", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $kCECX = parcelRequire("kCECX");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $932sd = parcelRequire("932sd");

class $0596fc14d46b40f6$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $0596fc14d46b40f6$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $932sd.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $0596fc14d46b40f6$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $0596fc14d46b40f6$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $0596fc14d46b40f6$var$collabKey = new (0, $kCECX.PluginKey)('collab');
function $0596fc14d46b40f6$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $kHija.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $kCECX.Plugin)({
        key: $0596fc14d46b40f6$var$collabKey,
        state: {
            init: ()=>new $0596fc14d46b40f6$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($0596fc14d46b40f6$var$collabKey);
                if (newState) {
                    if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $0596fc14d46b40f6$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $0596fc14d46b40f6$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($0596fc14d46b40f6$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $0596fc14d46b40f6$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $0596fc14d46b40f6$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $0596fc14d46b40f6$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($0596fc14d46b40f6$var$collabKey, new $0596fc14d46b40f6$var$CollabState(version, newUnconfirmed));
}
function $0596fc14d46b40f6$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $0596fc14d46b40f6$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $0596fc14d46b40f6$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($0596fc14d46b40f6$var$collabKey, new $0596fc14d46b40f6$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $0596fc14d46b40f6$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $0596fc14d46b40f6$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $kCECX.TextSelection)) {
        tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($0596fc14d46b40f6$var$collabKey, newCollabState);
}
function $0596fc14d46b40f6$export$4da2109e7644e6c2(state) {
    const collabState = $0596fc14d46b40f6$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $0596fc14d46b40f6$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $0596fc14d46b40f6$export$971539697c176258(state) {
    return $0596fc14d46b40f6$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $0596fc14d46b40f6$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $0596fc14d46b40f6$export$bced9e015fcf3afa;
module.exports["collab"] = $0596fc14d46b40f6$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $0596fc14d46b40f6$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $0596fc14d46b40f6$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $0596fc14d46b40f6$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $0596fc14d46b40f6$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $0596fc14d46b40f6$export$971539697c176258;

});

parcelRegister("932sd", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

// Iterate from the specified starting index down to 0
const $b353c4f64821ca1d$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $l5rX3.AnalyticsStep))) return i;
    }
};
const $b353c4f64821ca1d$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $b353c4f64821ca1d$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $b353c4f64821ca1d$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $b353c4f64821ca1d$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $b353c4f64821ca1d$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $b353c4f64821ca1d$var$isReplaceTypeStep = (step)=>step instanceof (0, $eOaGc.ReplaceStep);
const $b353c4f64821ca1d$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $b353c4f64821ca1d$var$isReplaceTypeStep(previousRebaseableStep.step) && $b353c4f64821ca1d$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $b353c4f64821ca1d$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$b353c4f64821ca1d$var$isReplaceTypeStep(previousStep) || mapped && !$b353c4f64821ca1d$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $b353c4f64821ca1d$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $eOaGc.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $aPdNQ.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $eOaGc.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $b353c4f64821ca1d$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $b353c4f64821ca1d$export$798cdecdcbbf9755;

});

parcelRegister("aQ9Nh", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8ROsu = parcelRequire("8ROsu");


var $26lLV = parcelRequire("26lLV");

const $7cf676f4d1e8bc54$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $26lLV.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $krYZG.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        payload.attributes.docStructure = (0, $8ROsu.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $7cf676f4d1e8bc54$export$6f3f7a1f93aa6704 = (reason, agentType, error)=>({
        action: (0, $krYZG.ACTION).AGENT_EDIT_SHIMMER_NOT_SHOWN,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: reason,
            // Spread conditionally so absent context isn't emitted as `undefined` (the teardown path has no
            // single agent, and non-throw reasons have no error).
            ...agentType ? {
                agentType: agentType
            } : {},
            ...error ? {
                error: `${error.name}: ${error.message}`
            } : {}
        }
    });
const $7cf676f4d1e8bc54$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: type === 'error' ? (0, $krYZG.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $krYZG.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};
module.exports["addSynchronyErrorAnalytics"] = $7cf676f4d1e8bc54$export$8c408a1f4e12c948;
module.exports["getAgentEditShimmerNotShownPayload"] = $7cf676f4d1e8bc54$export$6f3f7a1f93aa6704;
module.exports["addSynchronyEntityAnalytics"] = $7cf676f4d1e8bc54$export$31cf0e3f119813a1;

});

parcelRegister("6rAEj", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $fqVYq = parcelRequire("fqVYq");


var $8ZYbW = parcelRequire("8ZYbW");


var $k5ilr = parcelRequire("k5ilr");

const $a38ec21fd2b3cec9$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode, hideTelecursorOnLoad: hideTelecursorOnLoad })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $k5ilr.pluginKey).getState(newEditorState);
        const trNoAnalytics = oldEditorState.tr;
        docChangedTransaction?.steps.forEach((step)=>{
            if (!(step instanceof (0, $l5rX3.AnalyticsStep))) trNoAnalytics.step(step);
        });
        if (!currentPluginState?.isReady) return;
        const newTransaction = (0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
            exposure: true
        }) ? trNoAnalytics : docChangedTransaction;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && ((0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newTransaction?.docChanged : true);
        if (useNativePlugin || shouldSendStepForSynchronyCollabProvider) provider.send(newTransaction, oldEditorState, newEditorState);
        const prevPluginState = (0, $k5ilr.pluginKey).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if (!sessionId || viewMode !== 'edit') return;
        // uiEvent is standard metdata (docs: https://prosemirror.net/docs/ref/#state.Transaction)
        const isPaste = docChangedTransaction?.getMeta('uiEvent') === 'paste';
        // If this metadata is truthy then it means a selection bookmark might be declared as the meta value OR the transaction
        // doesn't want the tr.selection to be sent to remote users at all.
        const remoteSelectionBookmark = originalTransaction.getMeta('useSelectionBookmarkForRemote');
        if (!!remoteSelectionBookmark) {
            if (remoteSelectionBookmark !== true && 'resolve' in remoteSelectionBookmark) {
                const selection = remoteSelectionBookmark.resolve(newEditorState.doc);
                const message = {
                    type: 'telepointer',
                    selection: (0, $8ZYbW.getSendableSelection)(selection),
                    sessionId: sessionId
                };
                provider.sendMessage(message);
            }
        } else if (// Broadcast the position if the selection has changed, and the doc hasn't changed (it is mapped
        // by the receiver).
        // If we're pasting content though make an exception (as doc has changed)
        // as on a ranged selection it results in not clearing the ranged selection after the paste
        selectionChanged && (!docChangedTransaction || isPaste) || participantsChanged && !hideTelecursorOnLoad) {
            const selection = (0, $8ZYbW.getSendableSelection)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };
module.exports["sendTransaction"] = $a38ec21fd2b3cec9$export$8e0e7ffc78696d30;

});

parcelRegister("8ZYbW", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");


var $jdUP6 = parcelRequire("jdUP6");


var $kCECX = parcelRequire("kCECX");


var $5aU9U = parcelRequire("5aU9U");


var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");


var $mW7G5 = parcelRequire("mW7G5");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $ceig5 = parcelRequire("ceig5");


var $3et3I = parcelRequire("3et3I");


var $lFb3G = parcelRequire("lFb3G");


var $03X0Y = parcelRequire("03X0Y");

const $666505553c33095c$export$d970973925859b8e = ()=>{
    Object.entries($aOSDg).forEach(()=>{});
    Object.entries($aqgkf).forEach(()=>{});
};
const $666505553c33095c$export$a04a448cc866246 = (initData, view, options, editorAnalyticsApi)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $03X0Y.replaceDocument)(doc, state, version, options, reserveCursor, editorAnalyticsApi);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $666505553c33095c$export$ff4f2767b9e99aa9(json, view, undefined, options, editorAnalyticsApi);
};
const $666505553c33095c$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $666505553c33095c$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $666505553c33095c$export$c6643a6a2625d22c = (remoteData, view, options, editorAnalyticsApi)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $666505553c33095c$export$ff4f2767b9e99aa9(json, view, userIds, options, editorAnalyticsApi);
};
const $666505553c33095c$export$ff4f2767b9e99aa9 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, view, userIds, options, editorAnalyticsApi)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $5aU9U.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $7TcbF.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        tr.setMeta('addToHistory', false);
        tr.setMeta('isRemote', true);
        // Agent edit shimmer: mark the ranges agent steps just wrote so the plugin reveals them with the
        // skeleton loader, then (optionally) a purple "just edited" highlight. Gated as a whole so no
        // experiment reads run off-experiment; off-path leaves `agentShimmers` empty and everything below
        // is a no-op.
        let shimmerDurationMs = 0;
        let highlightDurationMs = 0;
        let agentShimmers = [];
        if ((0, $ieeJu.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) {
            // The skeleton and purple-highlight phases toggle independently. `shimmerDurationMs` is the
            // skeleton lifetime; `0` skips the skeleton (an edit can still get the purple highlight).
            shimmerDurationMs = (0, $mW7G5.expVal)('platform_editor_agent_be_streaming', 'shimmerDurationMs', (0, $3et3I.AGENT_SHIMMER_DEFAULT_DURATION_MS));
            // `highlightDurationMs` is the purple "just edited" highlight lifetime; `0` skips the highlight
            // (the skeleton still shows). `0` on both shows nothing.
            highlightDurationMs = (0, $mW7G5.expVal)('platform_editor_agent_be_streaming', 'highlightDurationMs', (0, $3et3I.AGENT_EDIT_HIGHLIGHT_DEFAULT_DURATION_MS));
            // Telepointer shown by default; `telepointerDisabled` hides it (inverted because `expVal`
            // only permits `false` as a boolean default).
            const telepointerEnabled = !(0, $mW7G5.expVal)('platform_editor_agent_be_streaming', 'telepointerDisabled', false);
            agentShimmers = (0, $lFb3G.getAgentShimmerRanges)(json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, // An agent edit that applied without the shimmer fires the operational event on the same
            // transaction, so success stays event-free and only degrades are reported.
            (reason, agentType, error)=>editorAnalyticsApi?.attachAnalyticsEvent((0, $aQ9Nh.getAgentEditShimmerNotShownPayload)(reason, agentType, error))(tr));
            if (agentShimmers.length) tr.setMeta((0, $3et3I.ADD_AGENT_SHIMMER_META), agentShimmers);
        }
        // [CCI-17994] Post Stream Review ("Review moment") for BE streaming. Record what
        // the agent just wrote (original + new slice per contiguous change) onto this same
        // transaction. `editor-plugin-ai` consumes this neutral meta to populate
        // `aiContentPositions` and — only on the requester's client — open the Review
        // moment once the edit settles. Gated on `platform_editor_agent_be_streaming`
        // alongside shimmer; `getAgentEditSegments` also self-gates by returning null
        // unless the batch contains agent-authored steps (and never throws), so this is
        // a no-op for ordinary collaborator edits and can't affect step application.
        if ((0, $ieeJu.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) {
            const reviewData = (0, $ceig5.getAgentEditSegments)(json, steps, tr, view);
            if (reviewData) tr.setMeta((0, $jdUP6.AGENT_REMOTE_EDIT_REVIEW_DATA), reviewData);
        }
        /*
		 * Persist marks across transactions. Fixes an issue where
		 * marks are lost if remote transactions are dispatched
		 * between a user creating the mark and typing.
		 */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
        // Schedule each shimmer's phase changes. `dispatchMeta` is guarded so a timer firing after
        // teardown is a harmless no-op. Only reached when the gated block above produced ranges, so this
        // whole path is off-experiment-safe.
        if (agentShimmers.length) {
            let tornDownReported = false;
            const dispatchMeta = (metaKey, value)=>{
                try {
                    view.dispatch(view.state.tr.setMeta(metaKey, value));
                } catch  {
                    // View torn down before the timer fired — nothing to clean up. Report once (not once
                    // per shimmer) so we can see how often shimmers are interrupted by teardown.
                    if (!tornDownReported) {
                        tornDownReported = true;
                        editorAnalyticsApi?.fireAnalyticsEvent((0, $aQ9Nh.getAgentEditShimmerNotShownPayload)('tornDownMidAnimation'));
                    }
                }
            };
            agentShimmers.forEach(({ shimmerId: shimmerId })=>{
                if (shimmerDurationMs > 0) // Skeleton first. When it clears, show the purple highlight (if enabled) then remove;
                // otherwise remove straight away.
                setTimeout(()=>{
                    if (highlightDurationMs > 0) {
                        dispatchMeta((0, $3et3I.HIGHLIGHT_AGENT_SHIMMER_META), shimmerId);
                        setTimeout(()=>{
                            dispatchMeta((0, $3et3I.REMOVE_AGENT_SHIMMER_META), shimmerId);
                        }, highlightDurationMs);
                    } else dispatchMeta((0, $3et3I.REMOVE_AGENT_SHIMMER_META), shimmerId);
                }, shimmerDurationMs);
                else // Skeleton disabled: the range already starts in the highlight phase, so just time its
                // removal. (Reached only when `highlightDurationMs > 0`, else no ranges were produced.)
                setTimeout(()=>{
                    dispatchMeta((0, $3et3I.REMOVE_AGENT_SHIMMER_META), shimmerId);
                }, highlightDurationMs);
            });
        }
    }
};
const $666505553c33095c$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $666505553c33095c$var$isAllSelection(selection) {
    return selection instanceof (0, $kCECX.AllSelection);
}
function $666505553c33095c$var$isNodeSelection(selection) {
    return selection instanceof (0, $kCECX.NodeSelection);
}
const $666505553c33095c$export$b95b91cb8577b1db = (selection)=>{
    /**
	 * <kbd>CMD + A</kbd> triggers a AllSelection
	 * <kbd>escape</kbd> triggers a NodeSelection
	 */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $666505553c33095c$var$isAllSelection(selection) || $666505553c33095c$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};
module.exports["handleInit"] = $666505553c33095c$export$a04a448cc866246;
module.exports["handleConnection"] = $666505553c33095c$export$cf9a0dcadb173615;
module.exports["handlePresence"] = $666505553c33095c$export$f9db5387b510d6c;
module.exports["applyRemoteData"] = $666505553c33095c$export$c6643a6a2625d22c;
module.exports["handleTelePointer"] = $666505553c33095c$export$abfa80d838a68fd6;
module.exports["getSendableSelection"] = $666505553c33095c$export$b95b91cb8577b1db;

});

parcelRegister("aqgkf", function(module, exports) {
$parcel$export(module.exports, "InsertTypeAheadStages", () => (parcelRequire("gT4iv")).InsertTypeAheadStages);
$parcel$export(module.exports, "InsertTypeAheadStep", () => (parcelRequire("gT4iv")).InsertTypeAheadStep);
$parcel$export(module.exports, "SetAttrsStep", () => (parcelRequire("1A89X")).SetAttrsStep);
$parcel$export(module.exports, "AnalyticsStep", () => (parcelRequire("l5rX3")).AnalyticsStep);
$parcel$export(module.exports, "LinkMetaStep", () => (parcelRequire("73Kv0")).LinkMetaStep);
$parcel$export(module.exports, "OverrideDocumentStep", () => (parcelRequire("gIRc3")).OverrideDocumentStep);
$parcel$export(module.exports, "BatchAttrsStep", () => (parcelRequire("hdvEd")).BatchAttrsStep);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gT4iv = parcelRequire("gT4iv");


var $1A89X = parcelRequire("1A89X");


var $l5rX3 = parcelRequire("l5rX3");


var $73Kv0 = parcelRequire("73Kv0");


var $gIRc3 = parcelRequire("gIRc3");


var $hdvEd = parcelRequire("hdvEd");


});

parcelRegister("gIRc3", function(module, exports) {

var $5aU9U = parcelRequire("5aU9U");

var $eOaGc = parcelRequire("eOaGc");

const $2d26fccd79180fad$export$28ee9acdd4691fa9 = 'override-document';
class $2d26fccd79180fad$export$d790696cf3da3aa0 extends (0, $5aU9U.Step) {
    apply(doc) {
        this.oldDocumentSize = doc.content.size;
        return (0, $eOaGc.StepResult).ok(this.nextDocument);
    }
    map() {
        return new $2d26fccd79180fad$export$d790696cf3da3aa0({
            nextDocument: this.nextDocument,
            inverted: this.inverted
        });
    }
    getMap() {
        if (!this.nextDocument || !this.oldDocumentSize) return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
        const oldSize = this.oldDocumentSize;
        const nextDocumentSize = this.nextDocument.content.size;
        return new (0, $eOaGc.StepMap)([
            0,
            oldSize,
            nextDocumentSize
        ]);
    }
    invert(doc) {
        return new $2d26fccd79180fad$export$d790696cf3da3aa0({
            nextDocument: doc,
            inverted: true
        });
    }
    toJSON() {
        return {
            stepType: $2d26fccd79180fad$export$28ee9acdd4691fa9,
            inverted: this.inverted,
            nextDocument: this.nextDocument.toJSON()
        };
    }
    static fromJSON(schema, json) {
        if (!json || json.stepType !== $2d26fccd79180fad$export$28ee9acdd4691fa9) throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
        return new $2d26fccd79180fad$export$d790696cf3da3aa0({
            inverted: json.inverted,
            nextDocument: schema.nodeFromJSON(json.nextDocument)
        });
    }
    constructor(opts){
        super();
        this.inverted = false;
        this.nextDocument = void 0;
        this.oldDocumentSize = 0;
        const { inverted: inverted, nextDocument: nextDocument } = opts;
        if (nextDocument.type.name !== 'doc') throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
        this.nextDocument = nextDocument;
        this.inverted = Boolean(inverted);
    }
}
(0, $5aU9U.Step).jsonID($2d26fccd79180fad$export$28ee9acdd4691fa9, $2d26fccd79180fad$export$d790696cf3da3aa0);
module.exports["OverrideDocumentStep"] = $2d26fccd79180fad$export$d790696cf3da3aa0;

});

parcelRegister("aOSDg", function(module, exports) {
$parcel$export(module.exports, "TableSortOrder", () => (parcelRequire("6faDz")).SortOrder);
$parcel$export(module.exports, "TableSortStep", () => (parcelRequire("kVd8s")).TableSortStep);
$parcel$export(module.exports, "AddColumnStep", () => (parcelRequire("cTqvh")).AddColumnStep);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6faDz = parcelRequire("6faDz");


var $kVd8s = parcelRequire("kVd8s");


var $cTqvh = parcelRequire("cTqvh");


});

parcelRegister("jdUP6", function(module, exports) {
const $e0175a3940f41f50$export$566f0440891acc8e = 'agentRemoteEditReviewData';
module.exports["AGENT_REMOTE_EDIT_REVIEW_DATA"] = $e0175a3940f41f50$export$566f0440891acc8e;

});

parcelRegister("ceig5", function(module, exports) {

var $cha5E = parcelRequire("cha5E");


var $7TcbF = parcelRequire("7TcbF");


var $lFb3G = parcelRequire("lFb3G");

const $512a8a2a05552848$export$7c03da4a40433b = 'platform_editor_backend_review_moment_agent_types';
// [CCI-17994] Post Stream Review ("Review moment") recording for BE streaming.
//
// Sibling to `getAgentShimmerRanges`: same idea of deriving what the agent wrote
// from a received remote-step batch, but for a DIFFERENT consumer. The shimmer
// only needs the NEW extent of added content (to draw a skeleton), so it drops
// pure deletions and expands to whole blocks. The Review moment instead needs, per
// contiguous change, BOTH the original slice (pre-edit, for undo / "compare with
// original") and the new slice (for redo), AND it must keep deletions (a removed
// paragraph is a reviewable change). So this derives the actual changed extents
// and reconstructs the pre-edit slice from `tr.before`.
//
// The output is a neutral `AgentRemoteEditReviewData` (contract in editor-common);
// `editor-plugin-ai`'s session-context plugin turns each segment into a coarse
// `aiContentPositions` entry, reusing the entire FE Review moment pipeline.
const $512a8a2a05552848$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 0), doc.content.size);
// Map a position in doc_{i+1} forward through the remaining steps to final-doc
// coords. Mirrors the shimmer's `mapToFinalDoc` — a later step's own inserted
// content starts at its `from`; only subsequent steps shift it.
const $512a8a2a05552848$var$mapToFinalDoc = (steps, pos, stepIndex, bias)=>{
    let p = pos;
    for(let j = stepIndex + 1; j < steps.length; j++)p = steps[j].getMap().map(p, bias);
    return p;
};
const $512a8a2a05552848$export$72163675ef60f4e3 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, steps, tr, view)=>{
    // `agentType` present ⇒ agent-authored (per the NCS↔Editor steps contract). Read
    // from the first agent step; it is identical across a batch.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const agentStep = json.find((step)=>typeof step?.agentType === 'string');
    const agentType = agentStep?.agentType;
    if (agentType === undefined) return null;
    // Only record Review Moment for agentTypes allowlisted in Statsig. Default `[]` fails
    // closed until the config is populated (CCI-18607).
    const allowedAgentTypes = (0, $cha5E.expVal)($512a8a2a05552848$export$7c03da4a40433b, 'value', []);
    if (!allowedAgentTypes.includes(agentType)) return null;
    // The user the agent acted on behalf of (the requester). Optional/additive on the
    // step contract, so it may be absent.
    const actorUserId = typeof agentStep?.userId === 'string' ? agentStep.userId : undefined;
    // Which agent instance wrote the batch. Additive on the step contract like
    // `userId`, so treat it as optional. Carried for contract clarity / future
    // per-agent attribution; nothing consumes it yet.
    const agentId = typeof agentStep?.agentId === 'string' ? agentStep.agentId : undefined;
    // Hybrid end-of-edit seam: if the BE/NCS flags a batch as the terminal one, carry
    // it so the AI plugin can open review immediately instead of waiting for the
    // debounce. Additive marker; absent for streaming (non-final) batches.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const complete = json.some((step)=>step?.agentEditComplete === true);
    // Same rebase guard as the shimmer: index-based range math is only valid if any
    // rebased-over local steps shifted no positions. Degrade to no recording otherwise.
    if (Number(tr.getMeta('rebased')) > 0) {
        const unconfirmed = (0, $7TcbF.getCollabState)(view.state)?.unconfirmed ?? [];
        if (unconfirmed.some((entry)=>!(0, $lFb3G.isPositionNeutralStep)(entry.step))) return null;
    }
    try {
        // Compute one segment per step-level StepMap range. Each agent step's changed
        // extent is taken from its StepMap (the canonical, step-type-agnostic source).
        // Unlike the shimmer we KEEP zero-width new extents — a pure deletion has
        // `newEnd === newStart` but is a reviewable `remove`.
        //
        // We derive the originalSlice/newSlice PER RANGE (per step) rather than
        // grouping ranges first and then inverting over a merged range. Grouping
        // before slicing corrupts the invert-mapping: when multiple discrete
        // operations (e.g. two deleteNode + one insertNodeAfter) are merged into one
        // range, mapping that merged range back through the inverted mapping produces
        // a chimera — a blend of old and new text that never existed in the document.
        //
        // The downstream PSR pipeline (mergeOverlappingSegments +
        // calculateTopLevelNodeSegments) already handles overlapping/adjacent coarse
        // entries correctly, so grouping here is unnecessary.
        const segments = [];
        json.forEach((rawStep, index)=>{
            if (typeof rawStep?.agentType !== 'string') return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pmStep = steps[index];
            if (typeof pmStep?.getMap !== 'function') return;
            pmStep.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                try {
                    // NEW-doc coordinates: map this step's newStart/newEnd forward
                    // through all subsequent steps to get final-doc positions.
                    const finalFrom = $512a8a2a05552848$var$mapToFinalDoc(steps, newStart, index, -1);
                    const finalTo = $512a8a2a05552848$var$mapToFinalDoc(steps, newEnd, index, 1);
                    const newFrom = $512a8a2a05552848$var$clampToDoc(tr.doc, Math.min(finalFrom, finalTo));
                    const newTo = $512a8a2a05552848$var$clampToDoc(tr.doc, Math.max(finalFrom, finalTo));
                    // ORIGINAL-doc coordinates: map this step's oldStart/oldEnd
                    // BACKWARD through all preceding steps to get pre-batch
                    // (`tr.before`) positions. Each preceding step's StepMap tells
                    // us how positions shifted; we invert that shift by mapping
                    // through the inverted StepMap.
                    //
                    // This is the key difference from using `tr.mapping.invert()`
                    // which inverts ALL steps at once — that produces chimera text
                    // when multiple discrete operations (delete + delete + insert)
                    // interact in the same region. Per-step backward mapping keeps
                    // each operation's original range isolated.
                    let origStart = oldStart;
                    let origEnd = oldEnd;
                    for(let j = index - 1; j >= 0; j--){
                        const prevMap = steps[j].getMap().invert();
                        origStart = prevMap.map(origStart, -1);
                        origEnd = prevMap.map(origEnd, 1);
                    }
                    const origFrom = $512a8a2a05552848$var$clampToDoc(tr.before, Math.min(origStart, origEnd));
                    const origTo = $512a8a2a05552848$var$clampToDoc(tr.before, Math.max(origStart, origEnd));
                    const originalSlice = tr.before.slice(origFrom, origTo);
                    const newSlice = tr.doc.slice(newFrom, newTo);
                    const originalEmpty = originalSlice.content.size === 0;
                    const newEmpty = newSlice.content.size === 0;
                    // A truly empty-to-empty region is not a change — skip it.
                    if (originalEmpty && newEmpty) return;
                    const kind = originalEmpty ? 'add' : newEmpty ? 'remove' : 'update';
                    segments.push({
                        startPos: newFrom,
                        endPos: newTo,
                        originalSlice: originalSlice,
                        newSlice: newSlice,
                        kind: kind
                    });
                } catch  {
                // One bad range must not drop the others.
                }
            });
        });
        if (!segments.length) return null;
        return {
            actorUserId: actorUserId,
            agentId: agentId,
            agentType: agentType,
            complete: complete,
            segments: segments
        };
    } catch  {
        // Never throw into the shared remote-step handler; degrade to no recording.
        return null;
    }
};
module.exports["getAgentEditSegments"] = $512a8a2a05552848$export$72163675ef60f4e3;

});

parcelRegister("lFb3G", function(module, exports) {

var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");

// When an agent step lands we cover the top-level block(s) it wrote with a skeleton-loader shimmer
// (plus a Rovo agent telepointer at the end of the range), then remove it on a timer to reveal the
// content. Gated behind the `platform_editor_agent_be_streaming` experiment. `shimmerDurationMs` and
// `highlightDurationMs` size the skeleton and purple-highlight phases and toggle independently: `0` on
// either skips that phase, `0` on both shows nothing.
let $4607a4f054ecad4b$var$agentShimmerIdCounter = 0;
const $4607a4f054ecad4b$export$6e1942fa8b890756 = (step)=>{
    let neutral = true;
    step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
        if (oldEnd - oldStart !== newEnd - newStart) neutral = false;
    });
    return neutral;
};
// Top-level block/position helpers over a doc. Kept at module scope (rather than re-created as
// closures on every call) so they are defined once, reusable, and unit-testable. Each clamps into
// valid document coordinates before resolving.
const $4607a4f054ecad4b$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 1), doc.content.size);
const $4607a4f054ecad4b$var$topLevelBlockIndexAt = (doc, pos)=>doc.resolve($4607a4f054ecad4b$var$clampToDoc(doc, pos)).index(0);
// Start of the content of the top-level block containing `pos`, so the whole block is covered.
const $4607a4f054ecad4b$var$topLevelBlockContentStart = (doc, pos)=>{
    const $pos = doc.resolve($4607a4f054ecad4b$var$clampToDoc(doc, pos));
    return $pos.depth >= 1 ? $pos.start(1) : pos;
};
// End of the content of the top-level block containing `pos`, so the whole block is covered.
const $4607a4f054ecad4b$var$topLevelBlockContentEnd = (doc, pos)=>{
    const $pos = doc.resolve($4607a4f054ecad4b$var$clampToDoc(doc, pos));
    return $pos.depth >= 1 ? $pos.end(1) : pos;
};
const $4607a4f054ecad4b$export$f64f53873128087b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, // Called when an agent-authored batch did NOT get the shimmer and applied instantly, so the
// caller can fire the `agentEditShimmerNotShown` operational event. Not called when both phases are
// off (config) or the batch has no agent steps; those aren't "not shown" cases.
onNotShown)=>{
    if (!(0, $ieeJu.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) return [];
    // The two phases toggle independently: `shimmerDurationMs` sizes the skeleton, `highlightDurationMs`
    // sizes the purple highlight, and `0` on either skips just that phase. Nothing to reveal only when
    // both are off.
    if (shimmerDurationMs <= 0 && highlightDurationMs <= 0) return [];
    // Start in the skeleton phase when it's enabled, otherwise straight into the purple highlight phase
    // (skeleton toggled off, highlight on).
    const initialPhase = shimmerDurationMs > 0 ? 'skeleton' : 'highlight';
    // Telepointer label = the agent's type upper-cased (e.g. `mcp` → "MCP"), falling back to a generic
    // "Agent"; `undefined` when the telepointer is disabled, so the plugin skips it. `agentType` is the
    // same on every step of an agent batch, so read it from the first agent-authored step.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const agentType = json.find((step)=>typeof step?.agentType === 'string')?.agentType;
    // No agent-authored steps in this batch — nothing to shimmer, and not a "not shown" case.
    if (agentType === undefined) return [];
    const telepointerLabel = telepointerEnabled ? agentType.toUpperCase() || 'Agent' : undefined;
    // When the batch was rebased over local unconfirmed steps, our index-based range math is only
    // valid if those local steps shifted no positions. Attribute-only steps (e.g. `localId`) and
    // same-size replacements are position-neutral, so the shimmer stays correct. Skip only when a
    // local step actually changed sizes (a genuine concurrent content edit).
    if (Number(tr.getMeta('rebased')) > 0) {
        const unconfirmed = (0, $7TcbF.getCollabState)(view.state)?.unconfirmed ?? [];
        if (unconfirmed.some((entry)=>!$4607a4f054ecad4b$export$6e1942fa8b890756(entry.step))) {
            onNotShown?.('rebasedConcurrentEdit', agentType);
            return [];
        }
    }
    try {
        // Map an inserted range in doc_{i+1} forward through the remaining steps to final-doc coords.
        // (A later step's own inserted content starts at its `from`; only subsequent steps shift it.)
        const mapToFinalDoc = (pos, stepIndex, bias)=>{
            let p = pos;
            for(let j = stepIndex + 1; j < steps.length; j++)p = steps[j].getMap().map(p, bias);
            return p;
        };
        const infos = [];
        json.forEach((rawStep, index)=>{
            if (typeof rawStep?.agentType !== 'string') return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pmStep = steps[index];
            if (typeof pmStep?.getMap !== 'function') return;
            pmStep.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
                if (newEnd <= newStart) return; // pure deletion / attribute-only — no new content to highlight
                infos.push({
                    from: mapToFinalDoc(newStart, index, -1),
                    to: mapToFinalDoc(newEnd, index, 1)
                });
            });
        });
        if (!infos.length) {
            onNotShown?.('nothingToShow', agentType);
            return [];
        }
        // Group the changed ranges by the TOP-LEVEL block they landed in, then highlight each touched
        // block IN FULL. NCS emits a single agent edit as many small replace fragments and often keeps a
        // common prefix/suffix untouched, so the changed sub-ranges cover only part of a block (e.g. half
        // a rewritten heading). Expanding to the whole block's content makes the entire heading/paragraph
        // shimmer as one unit rather than leaving the unchanged half undecorated. Directly-adjacent
        // touched blocks (index n and n+1) merge into one group so a multi-block rewrite reveals together;
        // a genuinely untouched block in between (index gap > 1) splits the run, so far-apart edits stay
        // independent.
        const sorted = [
            ...infos
        ].sort((a, b)=>a.from - b.from || a.to - b.to);
        const groups = [];
        sorted.forEach((info)=>{
            const block = $4607a4f054ecad4b$var$topLevelBlockIndexAt(tr.doc, info.from);
            const current = groups[groups.length - 1];
            if (current && block <= current.maxBlock + 1) {
                current.to = Math.max(current.to, info.to);
                current.maxBlock = Math.max(current.maxBlock, block);
            } else groups.push({
                from: info.from,
                to: info.to,
                maxBlock: block
            });
        });
        return groups.map((group)=>({
                shimmerId: `agent-shimmer-${$4607a4f054ecad4b$var$agentShimmerIdCounter++}`,
                from: $4607a4f054ecad4b$var$topLevelBlockContentStart(tr.doc, group.from),
                to: $4607a4f054ecad4b$var$topLevelBlockContentEnd(tr.doc, group.to),
                telepointerLabel: telepointerLabel,
                phase: initialPhase,
                highlightDurationMs: highlightDurationMs
            }));
    } catch (err) {
        // Never let shimmer range derivation throw into the shared remote-step handler; degrade to no
        // shimmer.
        onNotShown?.('captureThrew', agentType, err);
        return [];
    }
};
module.exports["isPositionNeutralStep"] = $4607a4f054ecad4b$export$6e1942fa8b890756;
module.exports["getAgentShimmerRanges"] = $4607a4f054ecad4b$export$f64f53873128087b;

});

parcelRegister("3et3I", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");

const $2ae884f8c9798406$export$aa0937b45953b3db = 3000;
const $2ae884f8c9798406$export$f8af4b416532a528 = 2000;
const $2ae884f8c9798406$export$63ca995375149bdc = 'collab-agent-shimmer';
const $2ae884f8c9798406$export$222eb4184643a9 = 'collab-agent-edit-highlight';
const $2ae884f8c9798406$export$6c825ce2d4ad5f26 = 'ai-in-editor-telepointer';
const $2ae884f8c9798406$export$1aa6da0fcc4baa6e = 'ai-in-editor-telepointer-label';
const $2ae884f8c9798406$export$e48683d1c200d637 = 'addAgentShimmer'; // register the shimmer decorations
const $2ae884f8c9798406$export$736faf53f1a48861 = 'highlightAgentShimmer'; // skeleton → purple highlight phase
const $2ae884f8c9798406$export$4cd536a39e6c2c4f = 'removeAgentShimmer'; // remove them once the shimmer ends
// Rovo AI in-editor telepointer/cursor shown at the end of an agent-authored range (same DOM/style
// pattern as editor-plugin-ai's in-editor direct-streaming telepointer).
const $2ae884f8c9798406$var$createRovoAgentTelepointer = (label)=>{
    const element = document.createElement('span');
    element.setAttribute('data-testid', 'ai-in-editor-telepointer-widget');
    element.className = $2ae884f8c9798406$export$6c825ce2d4ad5f26;
    const labelElement = document.createElement('span');
    labelElement.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-label');
    labelElement.className = $2ae884f8c9798406$export$1aa6da0fcc4baa6e;
    labelElement.append(label);
    element.appendChild(labelElement);
    return element;
};
const $2ae884f8c9798406$export$caaa5661d99996f1 = (current, tr, added, removedShimmerId, highlightShimmerId)=>{
    let next = current;
    let changed = false;
    // Ranges added in THIS transaction are already in post-change coords, so map the pre-existing
    // ones BEFORE replacing with any new batch.
    if (tr.docChanged && next.length) {
        next = next.map((shimmer)=>({
                ...shimmer,
                from: tr.mapping.map(shimmer.from, -1),
                to: tr.mapping.map(shimmer.to, 1)
            }));
        changed = true;
    }
    if (added?.length) {
        next = added.map((shimmer)=>({
                ...shimmer
            }));
        changed = true;
    }
    // Transition a shimmer from the skeleton phase to the purple highlight phase (skeleton timer fired).
    // Guard on an actual match so a timer firing after the shimmer was already removed (superseded by a
    // new batch, or cleared) doesn't rebuild the array and trigger a pointless decoration rebuild.
    if (highlightShimmerId && next.some((shimmer)=>shimmer.shimmerId === highlightShimmerId)) {
        next = next.map((shimmer)=>shimmer.shimmerId === highlightShimmerId ? {
                ...shimmer,
                phase: 'highlight'
            } : shimmer);
        changed = true;
    }
    if (removedShimmerId) {
        next = next.filter((shimmer)=>shimmer.shimmerId !== removedShimmerId);
        changed = true;
    }
    return {
        changed: changed,
        next: next
    };
};
const $2ae884f8c9798406$export$6039627ad3fe2215 = (tr, shimmers, getValidPos, onError)=>{
    const decorations = [];
    shimmers.forEach(({ shimmerId: shimmerId, from: from, to: to, telepointerLabel: telepointerLabel, phase: phase, highlightDurationMs: highlightDurationMs })=>{
        try {
            // `getValidPos` already clamps to the last valid position, so only the lower bound needs
            // guarding here (a raw `from < 1` would throw in `doc.resolve`).
            const validFrom = getValidPos(tr, Math.max(from, 1));
            const validTo = getValidPos(tr, to);
            if (validTo <= validFrom) return;
            // Inline decoration over the whole range: the grey skeleton loader, or (once revealed) the
            // purple "just edited" highlight. The highlight eases in and out over its lifetime via a CSS
            // animation whose duration is set inline so it matches the removal timer.
            const isHighlight = phase === 'highlight';
            const inlineAttrs = {
                class: isHighlight ? $2ae884f8c9798406$export$222eb4184643a9 : $2ae884f8c9798406$export$63ca995375149bdc
            };
            if (isHighlight && highlightDurationMs > 0) inlineAttrs.style = `animation-duration: ${highlightDurationMs}ms`;
            decorations.push((0, $8nvEM.Decoration).inline(validFrom, validTo, inlineAttrs, {
                isAgentShimmer: true,
                shimmerId: shimmerId
            }));
            // Rovo AI telepointer/cursor (labelled with the agent's type) at the end of the range, shown
            // through BOTH the skeleton and purple-highlight phases so the agent's cursor stays put until
            // the edit is fully revealed.
            if (telepointerLabel) decorations.push((0, $8nvEM.Decoration).widget(validTo, $2ae884f8c9798406$var$createRovoAgentTelepointer(telepointerLabel), {
                isAgentShimmer: true,
                shimmerId: shimmerId,
                class: $2ae884f8c9798406$export$6c825ce2d4ad5f26,
                key: `agent-telepointer-${shimmerId}`,
                side: 1
            }));
        } catch (err) {
            // One bad range must not kill the others.
            onError(err);
        }
    });
    return decorations;
};
module.exports["AGENT_SHIMMER_DEFAULT_DURATION_MS"] = $2ae884f8c9798406$export$aa0937b45953b3db;
module.exports["AGENT_EDIT_HIGHLIGHT_DEFAULT_DURATION_MS"] = $2ae884f8c9798406$export$f8af4b416532a528;
module.exports["ADD_AGENT_SHIMMER_META"] = $2ae884f8c9798406$export$e48683d1c200d637;
module.exports["HIGHLIGHT_AGENT_SHIMMER_META"] = $2ae884f8c9798406$export$736faf53f1a48861;
module.exports["REMOVE_AGENT_SHIMMER_META"] = $2ae884f8c9798406$export$4cd536a39e6c2c4f;
module.exports["reduceAgentShimmers"] = $2ae884f8c9798406$export$caaa5661d99996f1;
module.exports["buildAgentShimmerDecorations"] = $2ae884f8c9798406$export$6039627ad3fe2215;

});

parcelRegister("03X0Y", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");

var $hdvEd = parcelRequire("hdvEd");

var $1A89X = parcelRequire("1A89X");


var $krYZG = parcelRequire("krYZG");


var $jbOus = parcelRequire("jbOus");


var $5Qi6J = parcelRequire("5Qi6J");


var $fngNp = parcelRequire("fngNp");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $8nvEM = parcelRequire("8nvEM");


var $6e6qw = parcelRequire("6e6qw");


var $73BU4 = parcelRequire("73BU4");

const $c09ce8c88f088fff$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce(// `pointer` is absent on non-telepointer decorations (e.g. the agent-shimmer
    // sweep decorations), so guard against it to avoid crashing this shared helper.
    (arr, deco)=>deco.spec.pointer?.presenceId === id ? arr.concat(deco) : arr, []);
function $c09ce8c88f088fff$var$style(options) {
    const color = options && options.color || "var(--ds-border, #0B120E24)";
    const borderWidth = "var(--ds-border-width-focused, 2px)";
    return `border-right: ${borderWidth} solid ${color}; margin-right: calc(-1 * ${borderWidth}); z-index: 1`;
}
function $c09ce8c88f088fff$export$90c6ee000c44ff4a(str) {
    const participantColor = (0, $6e6qw.getParticipantColor)(str);
    return {
        index: participantColor.index,
        backgroundColor: participantColor.color.backgroundColor,
        textColor: participantColor.color.textColor
    };
}
const $c09ce8c88f088fff$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial, presenceId, fullName, isNudged)=>{
    const decorations = [];
    const avatarColor = $c09ce8c88f088fff$export$90c6ee000c44ff4a(presenceId);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $8nvEM.Decoration).inline(from, to, {
            class: className
        }, {
            pointer: {
                sessionId: sessionId,
                presenceId: presenceId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$c09ce8c88f088fff$var$style({
        color: avatarColor.backgroundColor
    })};`;
    cursor.setAttribute('aria-label', `${fullName} cursor position`);
    cursor.setAttribute('role', 'button');
    cursor.setAttribute((0, $jbOus.TELEPOINTER_DATA_SESSION_ID_ATTR), sessionId);
    // If there is an ongoing expand animation, we'll keep the telepointer expanded
    // until the keyframe animation is complete. Please note that this will restart the anim timer
    // from 0 everytime it's re-added.
    if (isNudged) cursor.classList.add((0, $jbOus.TELEPOINTER_PULSE_DURING_TR_CLASS));
    const fullNameEl = document.createElement('span');
    fullNameEl.textContent = fullName;
    fullNameEl.className = 'telepointer-fullname';
    fullNameEl.style.backgroundColor = avatarColor.backgroundColor;
    fullNameEl.style.color = avatarColor.textColor;
    fullNameEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(fullNameEl);
    const initialEl = document.createElement('span');
    initialEl.textContent = initial;
    initialEl.className = 'telepointer-initial';
    initialEl.style.backgroundColor = avatarColor.backgroundColor;
    initialEl.style.color = avatarColor.textColor;
    initialEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(initialEl);
    return decorations.concat((0, $8nvEM.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $8nvEM.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $8nvEM.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $c09ce8c88f088fff$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor, editorAnalyticsAPI)=>{
    const { schema: schema, tr: tr } = state;
    const parsedDoc = (0, $5Qi6J.processRawValueWithoutValidation)(schema, doc, editorAnalyticsAPI?.fireAnalyticsEvent);
    const hasContent = !!parsedDoc?.childCount;
    const content = parsedDoc?.content;
    if (hasContent && content) {
        const preservedContent = (0, $73BU4.preserveNodeIdentity)(state.doc.content, content);
        // If the entire content is identical, skip the replaceWith entirely
        // and just update collab metadata. This avoids triggering a full
        // document reconciliation for no-op replacements.
        if (preservedContent === state.doc.content) {
            tr.setMeta('addToHistory', false);
            if (version !== undefined && options && options.useNativePlugin) {
                const collabState = {
                    version: version,
                    unconfirmed: []
                };
                tr.setMeta('collab$', collabState);
            }
            return tr;
        }
        // Use the preserved fragment (reuses old node references for unchanged nodes)
        // rather than the raw parsed content, so ProseMirror's view reconciliation
        // can fast-match unchanged subtrees via referential identity (===).
        tr.setMeta('addToHistory', false);
        tr.replaceWith(0, state.doc.nodeSize - 2, preservedContent);
        const selection = state.selection;
        if (reserveCursor) {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kCECX.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (version !== undefined && options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    } else if (hasContent) {
        tr.setMeta('addToHistory', false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kCECX.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $c09ce8c88f088fff$export$82e6f13680c85057 = (editorView, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        const tr = state.tr;
        const analyticsPayload = {
            action: (0, $krYZG.ACTION).MATCHED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SELECTION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $c09ce8c88f088fff$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $c09ce8c88f088fff$export$94600c572c12bcd6 = (step)=>step instanceof (0, $eOaGc.ReplaceStep);
const $c09ce8c88f088fff$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $kCECX.Transaction)) return $c09ce8c88f088fff$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $c09ce8c88f088fff$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth',
    'originalHeight',
    'originalWidth'
];
const $c09ce8c88f088fff$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $l5rX3.AnalyticsStep)) return false;
        // editor-plugin-local-id uses AttrStep to set the localId attribute
        if (step instanceof (0, $eOaGc.AttrStep) && step.attr === 'localId') return false;
        // editor-plugin-local-id uses BatchAttrStep to set the localId attribute
        if (step instanceof (0, $hdvEd.BatchAttrsStep)) {
            const allAttributes = step.data.map((data)=>Object.keys(data.attrs)).flat();
            return allAttributes.some((attr)=>!$c09ce8c88f088fff$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
        }
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $1A89X.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>!$c09ce8c88f088fff$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
    });
};
const $c09ce8c88f088fff$export$6a7a563833bcd8 = (sessionId, nudgeAnimations)=>{
    const nudgeAnimStartTime = nudgeAnimations.get(sessionId);
    let hasExistingNudge = false;
    if (nudgeAnimStartTime) {
        const timeElapsed = Date.now() - nudgeAnimStartTime;
        hasExistingNudge = timeElapsed < (0, $jbOus.TELEPOINTER_PULSE_DURING_TR_DURATION_MS);
    }
    return hasExistingNudge;
};
module.exports["findPointers"] = $c09ce8c88f088fff$export$cc7116c03c331d66;
module.exports["getAvatarColor"] = $c09ce8c88f088fff$export$90c6ee000c44ff4a;
module.exports["createTelepointers"] = $c09ce8c88f088fff$export$8f868fb36fe42fe8;
module.exports["replaceDocument"] = $c09ce8c88f088fff$export$fe10d6bdd551e45e;
module.exports["getPositionOfTelepointer"] = $c09ce8c88f088fff$export$4d66b240d6166074;
module.exports["isReplaceStep"] = $c09ce8c88f088fff$export$94600c572c12bcd6;
module.exports["originalTransactionHasMeta"] = $c09ce8c88f088fff$export$b8c92cc7dad49da;
module.exports["isOrganicChange"] = $c09ce8c88f088fff$export$227edb0398ff0ff6;
module.exports["hasExistingNudge"] = $c09ce8c88f088fff$export$6a7a563833bcd8;

});

parcelRegister("6e6qw", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

function $c454c81005f3f72e$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $c454c81005f3f72e$export$60ba61eca4eb64f2(str) {
    const index = $c454c81005f3f72e$export$c14f61804029af13(str) % (0, $7Y8M5.participantColors).length;
    return {
        index: index,
        color: (0, $7Y8M5.participantColors)[index]
    };
}
module.exports["getHashCode"] = $c454c81005f3f72e$export$c14f61804029af13;
module.exports["getParticipantColor"] = $c454c81005f3f72e$export$60ba61eca4eb64f2;

});

parcelRegister("73BU4", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

function $310f7ef6cdc3c4ee$export$e0776a297562f4e0(oldFragment, newFragment) {
    // Fast path: referentially identical — nothing to do
    if (oldFragment === newFragment) return oldFragment;
    // Fast path: structurally equal — reuse old fragment entirely.
    // This covers the common SSR case where collab init sends the same doc.
    if (oldFragment.eq(newFragment)) return oldFragment;
    // Walk children position-by-position and preserve what we can
    const oldCount = oldFragment.childCount;
    const newCount = newFragment.childCount;
    let changed = false;
    const children = [];
    for(let i = 0; i < newCount; i++){
        const newChild = newFragment.child(i);
        if (i < oldCount) {
            const oldChild = oldFragment.child(i);
            if (oldChild === newChild) // Already referentially identical
            children.push(newChild);
            else if (oldChild.eq(newChild)) // Structurally equal — reuse old reference (THE KEY OPERATION)
            children.push(oldChild);
            else if (oldChild.type === newChild.type && oldChild.sameMarkup(newChild) && oldChild.content.childCount > 0 && newChild.content.childCount > 0) {
                // Same type and markup but different content — recurse into children
                const preservedContent = $310f7ef6cdc3c4ee$export$e0776a297562f4e0(oldChild.content, newChild.content);
                if (preservedContent === oldChild.content) // All content was preserved — reuse old node entirely
                children.push(oldChild);
                else {
                    // Partially changed — create node with preserved content
                    children.push(oldChild.copy(preservedContent));
                    changed = true;
                }
            } else {
                // Completely different node — use new
                children.push(newChild);
                changed = true;
            }
        } else {
            // New child beyond old count — use as-is (insertion)
            children.push(newChild);
            changed = true;
        }
    }
    // If nothing changed and counts match, return old fragment directly
    // (avoids creating a new Fragment object)
    if (!changed && oldCount === newCount) return oldFragment;
    return (0, $aPdNQ.Fragment).from(children);
}
module.exports["preserveNodeIdentity"] = $310f7ef6cdc3c4ee$export$e0776a297562f4e0;

});

parcelRegister("k5ilr", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $2955bb74975a5428$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('collabEditPlugin');
module.exports["pluginKey"] = $2955bb74975a5428$export$18d4026d1ea86bb1;

});

parcelRegister("a8NwW", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $7TcbF = parcelRequire("7TcbF");

function $293a9c6514990e26$export$75962d04b28eb982(steps) {
    const filteredSteps = steps.reduce((acc, rebaseable)=>{
        if (!(rebaseable.step instanceof (0, $l5rX3.AnalyticsStep))) acc.push(new (0, $7TcbF.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin));
        return acc;
    }, []);
    return filteredSteps;
}
module.exports["filterAnalyticsSteps"] = $293a9c6514990e26$export$75962d04b28eb982;

});

parcelRegister("eEHpO", function(module, exports) {
// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");


var $krYZG = parcelRequire("krYZG");

var $fdQKX = parcelRequire("fdQKX");


var $kpCD8 = parcelRequire("kpCD8");


var $5aU9U = parcelRequire("5aU9U");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $kl8Qm = parcelRequire("kl8Qm");


var $k5ilr = parcelRequire("k5ilr");


var $euTSg = parcelRequire("euTSg");

const $4e5bb196f2fe3a0b$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $5aU9U.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($aOSDg);
    // @ts-expect-error
    tryToRegisterStep($aqgkf);
};
const $4e5bb196f2fe3a0b$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $4e5bb196f2fe3a0b$var$enforceCustomStepRegisters();
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $k5ilr.pluginKey),
        state: {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            init (config) {
                return (0, $euTSg.PluginState).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $k5ilr.pluginKey), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return (0, $k5ilr.pluginKey).getState(state)?.decorations;
            },
            handleDOMEvents: {
                click (view, event) {
                    if (!(event.target instanceof HTMLElement)) return false;
                    if (!view.state.selection.empty) return false;
                    const { pos: pos } = view.state.tr.selection.$from;
                    if (!pos) return false;
                    // check if the pos is the same pos as a telepointer decoration
                    const decorations = (0, $k5ilr.pluginKey).getState(view.state)?.decorations?.find(pos, pos);
                    if (!decorations?.length) return false;
                    // analytics to track telepointer clicks as they sometimes cause broken selections
                    const fireAnalyticsCallback = (0, $fdQKX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                    fireAnalyticsCallback({
                        payload: {
                            action: (0, $krYZG.ACTION).CLICKED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).TELEPOINTER,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TELEPOINTER,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK
                        }
                    });
                }
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $k5ilr.pluginKey).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!pluginState?.isReady && tr.docChanged) return false;
            return true;
        },
        view (view) {
            const addErrorAnalytics = (0, $aQ9Nh.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, pluginInjectionApi?.analytics?.actions);
            const onSyncUpError = (attributes)=>{
                const fireAnalyticsCallback = (0, $fdQKX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $krYZG.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $kl8Qm.initialize)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                pluginInjectionApi: pluginInjectionApi,
                editorAnalyticsApi: pluginInjectionApi?.analytics?.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};
module.exports["createPlugin"] = $4e5bb196f2fe3a0b$export$ae829ec7b2625219;

});

parcelRegister("kl8Qm", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5aU9U = parcelRequire("5aU9U");


var $ieeJu = parcelRequire("ieeJu");


var $k5ilr = parcelRequire("k5ilr");


var $g5VrR = parcelRequire("g5VrR");


var $3ozmx = parcelRequire("3ozmx");

const $f68e6042357b791f$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $5aU9U.Step).fromJSON(view.state.schema, json));
};
const $f68e6042357b791f$var$initNewCollab = (collabEditProvider, view, editorApi, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        editorApi: editorApi,
        onSyncUpError: onSyncUpError
    });
};
const $f68e6042357b791f$var$initCollabMemo = (0, $dOBRD.default)($f68e6042357b791f$var$initCollab);
const $f68e6042357b791f$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi, pluginInjectionApi: pluginInjectionApi })=>(provider)=>{
        // eslint-disable-next-line prefer-const
        let cleanup;
        const pluginState = (0, $k5ilr.pluginKey).getState(view.state);
        if (pluginState?.isReady && cleanup) cleanup();
        cleanup = (0, $3ozmx.subscribe)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $f68e6042357b791f$var$initNewCollab(provider, view, pluginInjectionApi, options.onSyncUpError);
        else /**
			 * We only want to initialise once, if we reload/reconfigure this plugin
			 * We dont want to re-init collab, it would break existing sessions
			 */ $f68e6042357b791f$var$initCollabMemo(provider, view);
        // Rebind path: if the provider has already initialised (i.e. this view()
        // is running because the editor preset was reconfigured or the EditorView
        // was recreated mid-session, e.g. on a rich-text → markdown-mode flip),
        // the provider's `init` event has already fired and won't fire again.
        // Without intervention the freshly-attached collab plugin view never sees
        // `collabInitialised`, so `filterTransaction` silently drops every
        // doc-changing transaction and the editor appears read-only.
        //
        // PM `state.reconfigure` preserves plugin state by key, so in many cases
        // the plugin state survives and no action is needed; we only seed when
        // state was actually lost (e.g. EditorView recreated from scratch).
        //
        // Gated behind `cc-markdown-mode` (the same experiment that drives the
        // preset rebuild on convert); when off, behaviour is unchanged. Uses
        // `expValEquals` (not `*NoExposure`) so the editor's statsig client
        // enrols the user — otherwise an early rebind can race the FE-side
        // exposure and read the default (false), defeating the gate. The
        // experiment check is last so legacy providers (no `getInitPayload`)
        // short-circuit and don't fire an exposure.
        if (provider.getInitPayload && (0, $ieeJu.expValEquals)('cc-markdown-mode', 'isEnabled', true)) {
            const cachedInit = provider.getInitPayload();
            if (cachedInit) // Defer one microtask so the new pluginView is fully registered
            // before we dispatch (mirrors the timing of a real `init` event).
            Promise.resolve().then(()=>{
                if (view.isDestroyed) return;
                const currentCollabState = (0, $k5ilr.pluginKey).getState(view.state);
                const currentTrackState = (0, $g5VrR.trackNCSInitializationPluginKey).getState(view.state);
                // State was preserved across reconfigure → nothing to do.
                if (currentCollabState?.isReady && currentTrackState?.collabInitialisedAt) return;
                // Seed the freshly-attached pluginView so `isReady` flips to true,
                // `data-has-collab-initialised` becomes "true", and downstream
                // listeners (analytics, sweet-state, track-ncs) re-receive init.
                // Note: we intentionally do NOT replay `handleInit` (which would
                // call `replaceDocument`) — the document is already in the editor
                // and replacing it would clobber any in-flight local steps.
                view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            });
        }
        return cleanup;
    };
module.exports["initialize"] = $f68e6042357b791f$export$2a47f398eeff8b01;

});

parcelRegister("g5VrR", function(module, exports) {

var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $03X0Y = parcelRequire("03X0Y");

const $7482f28e0a2bd480$export$a79cdfb4b852386b = new (0, $kCECX.PluginKey)('collabTrackNCSInitializationPlugin');
const $7482f28e0a2bd480$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $7482f28e0a2bd480$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $03X0Y.originalTransactionHasMeta)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $03X0Y.originalTransactionHasMeta)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $jbOus.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>step instanceof (0, $eOaGc.AddMarkStep) && step.mark?.type?.name === 'annotation');
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $7482f28e0a2bd480$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState?.collabInitialisedAt)}`
                };
            }
        }
    });
};
module.exports["trackNCSInitializationPluginKey"] = $7482f28e0a2bd480$export$a79cdfb4b852386b;
module.exports["createPlugin"] = $7482f28e0a2bd480$export$ae829ec7b2625219;

});

parcelRegister("3ozmx", function(module, exports) {

var $8ZYbW = parcelRequire("8ZYbW");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $89tlI = parcelRequire("89tlI");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98128c88e4bb0942$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $98128c88e4bb0942$export$ec068583843480e7 = $98128c88e4bb0942$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $aQ9Nh.addSynchronyEntityAnalytics)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $aQ9Nh.addSynchronyEntityAnalytics)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $8ZYbW.handleInit)(data, view, options, editorAnalyticsApi);
        },
        connectedHandler: (data)=>(0, $8ZYbW.handleConnection)(data, view),
        dataHandler: (data)=>(0, $8ZYbW.applyRemoteData)(data, view, options, editorAnalyticsApi),
        presenceHandler: (data)=>(0, $8ZYbW.handlePresence)(data, view),
        telepointerHandler: (data)=>(0, $8ZYbW.handleTelePointer)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $aQ9Nh.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        },
        dataConflictHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta((0, $89tlI.trackLastRemoteConflictPluginKey), data));
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler).on('data:conflict', handlers.dataConflictHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler).off('data:conflict', handlers.dataConflictHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));
module.exports["subscribe"] = $98128c88e4bb0942$export$ec068583843480e7;

});

parcelRegister("89tlI", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $9f98dc1e1d0f84b5$export$1fa2affd5117a057 = new (0, $kCECX.PluginKey)('trackLastRemoteConflict');
const $9f98dc1e1d0f84b5$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $9f98dc1e1d0f84b5$export$1fa2affd5117a057,
        state: {
            init () {
                return undefined;
            },
            apply (transaction, prevPluginState) {
                const metadata = transaction.getMeta($9f98dc1e1d0f84b5$export$1fa2affd5117a057);
                if (metadata) return metadata;
                return prevPluginState;
            }
        }
    });
};
module.exports["trackLastRemoteConflictPluginKey"] = $9f98dc1e1d0f84b5$export$1fa2affd5117a057;
module.exports["createPlugin"] = $9f98dc1e1d0f84b5$export$ae829ec7b2625219;

});

parcelRegister("euTSg", function(module, exports) {

var $8dxef = parcelRequire("8dxef");


var $jbOus = parcelRequire("jbOus");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $1mAej = parcelRequire("1mAej");


var $03X0Y = parcelRequire("03X0Y");


var $3et3I = parcelRequire("3et3I");

const $fe2c13f286900d8a$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $kCECX.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $fe2c13f286900d8a$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    getFullName(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name : 'X';
    }
    getInitial(sessionId) {
        return this.getFullName(sessionId).substring(0, 1).toUpperCase();
    }
    getPresenceId(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant?.presenceId ?? sessionId;
    }
    apply(tr) {
        // Ignored via go/ees005
        // eslint-disable-next-line prefer-const
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const nudgeTelepointerData = tr.getMeta('nudgeTelepointer');
        const agentShimmerData = tr.getMeta((0, $3et3I.ADD_AGENT_SHIMMER_META));
        const removeAgentShimmerId = tr.getMeta((0, $3et3I.REMOVE_AGENT_SHIMMER_META));
        const highlightAgentShimmerId = tr.getMeta((0, $3et3I.HIGHLIGHT_AGENT_SHIMMER_META));
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $03X0Y.findPointers)(this.getPresenceId(i.sessionId), this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                const oldPointers = (0, $03X0Y.findPointers)(this.getPresenceId(sessionId), this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $fe2c13f286900d8a$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom, 0) : rawFrom);
                    to = isSelection ? $fe2c13f286900d8a$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $03X0Y.createTelepointers)(from, to, sessionId, isSelection, this.getInitial(sessionId), this.getPresenceId(sessionId), this.getFullName(sessionId), (0, $03X0Y.hasExistingNudge)(sessionId, this.nudgeAnimations)));
            }
        }
        if (tr.docChanged) // Adjust decoration positions to changes made by the transaction
        try {
            this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                // Reapplies decorators those got removed by the state change
                onRemove: (spec)=>{
                    if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                        const step = tr.steps.filter((0, $03X0Y.isReplaceStep))[0];
                        if (step) {
                            const { sessionId: sessionId, presenceId: presenceId } = spec.pointer;
                            const { slice: { content: { size: size } }, from: from } = step;
                            const pos = $fe2c13f286900d8a$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                            add = add.concat((0, $03X0Y.createTelepointers)(pos, pos, sessionId, false, this.getInitial(sessionId), presenceId, this.getFullName(sessionId), (0, $03X0Y.hasExistingNudge)(sessionId, this.nudgeAnimations)));
                        }
                    }
                }
            });
        } catch (err) {
            this.onError(err);
        }
        const { selection: selection } = tr;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.decorationSet.find().forEach((deco)=>{
            // Never let telepointer dim/side logic touch agent-shimmer decorations.
            if (deco.spec?.isAgentShimmer) return;
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $jbOus.TELEPOINTER_DIM_CLASS));
                const browser = (0, $8dxef.getBrowserInfo)();
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $jbOus.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!browser.gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (nudgeTelepointerData) {
            const nudgeSessionId = nudgeTelepointerData?.sessionId;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.decorationSet.find().forEach((deco)=>{
                // Never let telepointer nudge logic touch agent-shimmer decorations.
                if (deco.spec?.isAgentShimmer) return;
                if (deco.type.toDOM && participants.get(nudgeSessionId) && deco.spec?.pointer?.sessionId === nudgeSessionId && deco.spec?.key === `telepointer-${nudgeSessionId}`) {
                    // Restart animation by removing and re-adding the class
                    deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_PULSE_DURING_TR_CLASS));
                    deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_PULSE_CLASS));
                    deco.type.toDOM.offsetWidth; // Force reflow
                    deco.type.toDOM.classList.add((0, $jbOus.TELEPOINTER_PULSE_CLASS));
                    this.nudgeAnimations.set(nudgeSessionId, Date.now());
                }
            });
        }
        // Register / keep-aligned / remove the agent-edit purple highlight
        // decorations. Fully fault-isolated — it works on local copies and only merges into the shared
        // `add`/`remove` (and commits `this.agentShimmers`) after the whole block succeeds, so a fault
        // here can never corrupt telepointer decorations or the shared decoration set. Never mutates
        // shimmer entries in place: each change produces a fresh array of fresh objects.
        try {
            const { changed: changed, next: next } = (0, $3et3I.reduceAgentShimmers)(this.agentShimmers, tr, agentShimmerData, removeAgentShimmerId, highlightAgentShimmerId);
            if (changed) {
                // Build into local arrays; only merge into the shared add/remove once the block succeeds.
                const agentRemove = this.decorationSet.find(undefined, undefined, (spec)=>spec.isAgentShimmer);
                const agentAdd = (0, $3et3I.buildAgentShimmerDecorations)(tr, next, $fe2c13f286900d8a$export$1e860daa85a829a5, this.onError);
                // Commit only after the whole block succeeded.
                remove = remove.concat(agentRemove);
                add = add.concat(agentAdd);
                this.agentShimmers = next;
            }
        } catch (err) {
            this.onError(err);
            // Degrade to no shimmer without corrupting telepointer decorations: drop all agent
            // decorations and clear agent state, leaving the telepointer `add`/`remove` untouched.
            this.agentShimmers = [];
            try {
                remove = remove.concat(this.decorationSet.find(undefined, undefined, (spec)=>spec.isAgentShimmer));
            } catch  {
            // Teardown must not re-throw.
            }
        }
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $03X0Y.getPositionOfTelepointer)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $fe2c13f286900d8a$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised, this.onError, this.nudgeAnimations, this.agentShimmers);
        return $fe2c13f286900d8a$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $fe2c13f286900d8a$export$d8e4bc17e84598c5((0, $8nvEM.DecorationSet).create(doc, []), new (0, $1mAej.Participants)(), undefined, undefined, onError);
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError, nudgeAnimations = new Map(), agentShimmers = []){
        this.decorationSet = void 0;
        this.participants = void 0;
        this.nudgeAnimations = void 0;
        // Active agent-edit shimmer ranges (pure data). Replaced with a fresh array of fresh
        // objects whenever it changes — never mutated in place.
        this.agentShimmers = void 0;
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.sid = void 0;
        this.isReady = void 0;
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
        this.nudgeAnimations = nudgeAnimations;
        this.agentShimmers = agentShimmers;
    }
}
module.exports["PluginState"] = $fe2c13f286900d8a$export$d8e4bc17e84598c5;

});

parcelRegister("1mAej", function(module, exports) {
class $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4 {
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
    constructor(participants = new Map()){
        this.participants = void 0;
        this.participants = participants;
    }
}
module.exports["Participants"] = $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4;

});

parcelRegister("jkbED", function(module, exports) {

var $6Ixg8 = parcelRequire("6Ixg8");


var $kCECX = parcelRequire("kCECX");


var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");

const $3f4c2e14e00f350f$var$isLocked = (step)=>{
    if (step.origin instanceof (0, $kCECX.Transaction)) return step.origin.getMeta('mergeIsLocked');
    return false;
};
function $3f4c2e14e00f350f$export$8e3092acded15d5d(steps, api) {
    const mergedSteps = steps.reduce((acc, rebaseable)=>{
        const lastStep = acc[acc.length - 1];
        const isOffline = (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
        const isOnlineMergeEnabled = (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        const isMergingEnabled = isOffline || isOnlineMergeEnabled;
        if (isMergingEnabled && lastStep && !$3f4c2e14e00f350f$var$isLocked(lastStep) && !$3f4c2e14e00f350f$var$isLocked(rebaseable)) {
            const mergedStep = lastStep.step.merge(rebaseable.step);
            const inverted = rebaseable.inverted.merge(lastStep.inverted);
            // Always take the origin of the new step.
            // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
            // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
            // As we want to wait until all the transactions have been pushed through
            const origin = lastStep.origin;
            if (mergedStep && inverted) {
                acc[acc.length - 1] = new (0, $7TcbF.Rebaseable)(mergedStep, inverted, origin instanceof (0, $kCECX.Transaction) ? origin.setMeta('isOffline', origin.getMeta('isOffline') === true || isOffline) : origin);
                return acc;
            }
        }
        acc.push(new (0, $7TcbF.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin instanceof (0, $kCECX.Transaction) ? rebaseable.origin.setMeta('isOffline', rebaseable.origin.getMeta('isOffline') === true || isOffline) : rebaseable.origin));
        return acc;
    }, []);
    return mergedSteps;
}
module.exports["mergeUnconfirmedSteps"] = $3f4c2e14e00f350f$export$8e3092acded15d5d;

});

parcelRegister("alVJS", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $auTW7 = parcelRequire("auTW7");


var $fkzSG = parcelRequire("fkzSG");

// This is essentially a queue of cached events. When the background task runs to send these items then this queue is flushed.
const $258b55880d613071$var$organicReportingCache = [];
// Every ten seconds we will try to process the step data.
const $258b55880d613071$var$LOW_PRIORITY_DELAY = 10000;
const $258b55880d613071$export$5cff7ac265db316a = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
/**
 * Processes the steps metadata from the cache and calls the callback function with the processed data.
 *
 * @param {OrganicCacheType} cache - A cache containing steps metadata.
 * @param {(data: OrganicMetadataAnalytics[]) => void} onDataProcessed - Callback function to be called with the processed data.
 */ const $258b55880d613071$var$task = (cache, onDataProcessed)=>{
    const data = [];
    for (const item of cache){
        const { steps: steps, ...rest } = item;
        // We'll use the same grouping and sanitize logic from the track-steps util
        const stepTypesAmount = (0, $fkzSG.groupSteps)(steps.map((0, $fkzSG.sanitizeStep)));
        data.push({
            ...rest,
            stepTypesAmount: stepTypesAmount
        });
    }
    // clear the cache.
    cache.length = 0;
    if (data.length > 0) onDataProcessed(data);
};
const $258b55880d613071$export$41ae48ec4a268424 = ({ newEditorState: newEditorState, oldEditorState: oldEditorState, transactions: transactions, onDataProcessed: onDataProcessed })=>{
    // We can exclude analytic steps since they should never trigger an organic change.
    const newSteps = transactions.flatMap((t)=>t.steps).filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep)));
    const scheduler = $258b55880d613071$export$5cff7ac265db316a(window);
    if (!newSteps.length || !scheduler) return;
    // We know that an organic change during startup will trigger a draft sync which will;
    // fire editor edited event ->  confluence/next/packages/editor-features/src/hooks/useDraftSync/useDraftSync.tsx
    // and call triggerUpdate() notifying the BE that user edited the page -> confluence/next/packages/editor-features/src/hooks/useDraftSync/useEditorDraftSyncAction.tsx
    // This can cause a problem with statsig metrics if organic changes are being incorrectly reported, ie an automated change
    // occurs which contributes the user towards editing a page when in fact they didn't edit the page.
    //
    const oldPluginState = (0, $auTW7.trackLastOrganicChangePluginKey).getState(oldEditorState);
    const newPluginState = (0, $auTW7.trackLastOrganicChangePluginKey).getState(newEditorState);
    if (newSteps.length && oldPluginState?.lastLocalOrganicBodyChangeAt !== newPluginState?.lastLocalOrganicBodyChangeAt) {
        const now = Date.now();
        const isFirstChange = !oldPluginState?.lastLocalOrganicBodyChangeAt;
        // Check if we should compact with the previous entry (within 2 seconds) this means with a possible 10sec delay
        // due to the postTask we could have a potential 5 grouped organic changes listed.
        const shouldCompact = $258b55880d613071$var$organicReportingCache.length > 0 && now - $258b55880d613071$var$organicReportingCache[$258b55880d613071$var$organicReportingCache.length - 1].startedAt < 2000;
        if (shouldCompact) {
            // Compact with previous entry
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prev = $258b55880d613071$var$organicReportingCache.pop(); // We know it exists due to shouldCompact check
            // tr.docChanged
            $258b55880d613071$var$organicReportingCache.push({
                transactions: prev.transactions + 1,
                startedAt: prev.startedAt,
                endedAt: now,
                isFirstChange: prev.isFirstChange || isFirstChange,
                steps: prev.steps.concat(newSteps)
            });
        } else // Add new entry
        $258b55880d613071$var$organicReportingCache.push({
            transactions: 1,
            startedAt: now,
            endedAt: now,
            isFirstChange: isFirstChange,
            steps: newSteps
        });
        if ($258b55880d613071$var$organicReportingCache.length === 1) scheduler.postTask(()=>{
            $258b55880d613071$var$task($258b55880d613071$var$organicReportingCache, onDataProcessed);
        }, {
            priority: 'background',
            delay: $258b55880d613071$var$LOW_PRIORITY_DELAY
        });
    }
};
module.exports["monitorOrganic"] = $258b55880d613071$export$41ae48ec4a268424;

});

parcelRegister("auTW7", function(module, exports) {

var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $03X0Y = parcelRequire("03X0Y");

const $ce42e57f255e75ac$export$e968e014d3efd8b6 = new (0, $kCECX.PluginKey)('collabTrackLastOrganicChangePlugin');
const $ce42e57f255e75ac$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $ce42e57f255e75ac$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>(step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) && step.mark?.type?.name === 'annotation');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $jbOus.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $03X0Y.isOrganicChange)(transaction)) {
                    if (isRemote) return {
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    return {
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};
module.exports["trackLastOrganicChangePluginKey"] = $ce42e57f255e75ac$export$e968e014d3efd8b6;
module.exports["createPlugin"] = $ce42e57f255e75ac$export$ae829ec7b2625219;

});

parcelRegister("fkzSG", function(module, exports) {
// delete this file when cleaning up platform_editor_remove_collab_step_metrics

var $l5rX3 = parcelRequire("l5rX3");

var $hdvEd = parcelRequire("hdvEd");

var $1A89X = parcelRequire("1A89X");


var $eOaGc = parcelRequire("eOaGc");


var $7TcbF = parcelRequire("7TcbF");


var $fqVYq = parcelRequire("fqVYq");


var $jq5Q3 = parcelRequire("jq5Q3");

function $ea00a46645b09ae6$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') // @ts-ignore TS2322 - Type 'Partial<Record<string, T[]>>' is not assignable to type 'Record<string, T[]>'.
    return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $ea00a46645b09ae6$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $eOaGc.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $1A89X.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep) || step instanceof (0, $eOaGc.RemoveNodeMarkStep) || step instanceof (0, $eOaGc.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    else if (step instanceof (0, $hdvEd.BatchAttrsStep)) {
        const batched = step.data.map(({ nodeType: nodeType, attrs: attrs })=>`${nodeType}_${Object.keys(attrs).sort().join('_')}`);
        sanitizedStep.attr = batched.sort().join('_');
    }
    return sanitizedStep;
};
const $ea00a46645b09ae6$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $ea00a46645b09ae6$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};
const $ea00a46645b09ae6$export$94e939b87ca64fb4 = (cache, onTrackDataProcessed)=>{
    const stepsMetadata = [];
    for (const entry of cache.values()){
        const { startedAt: startedAt, endedAt: endedAt, steps: steps } = entry;
        const stepTypesAmount = $ea00a46645b09ae6$export$cb21deee7d469afa(steps.map($ea00a46645b09ae6$export$685b976035d234a6));
        stepsMetadata.push({
            startedAt: startedAt,
            endedAt: endedAt,
            stepTypesAmount: stepTypesAmount
        });
    }
    cache.clear();
    if (stepsMetadata.length > 0) onTrackDataProcessed(stepsMetadata);
};
const $ea00a46645b09ae6$var$stepsSentCache = new Map();
// Every ten seconds we will try to process the step data.
const $ea00a46645b09ae6$var$LOW_PRIORITY_DELAY = 10000;
const $ea00a46645b09ae6$var$getScheduler = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
const $ea00a46645b09ae6$export$6b2a7d5132615086 = ({ api: api, newEditorState: newEditorState, transactions: transactions, onTrackDataProcessed: onTrackDataProcessed })=>{
    const newSteps = transactions.flatMap((t)=>t.steps);
    const collabState = (0, $7TcbF.sendableSteps)(newEditorState);
    const scheduler = $ea00a46645b09ae6$var$getScheduler(window);
    if (!newSteps.length || !scheduler || !collabState) return;
    const { version: version } = collabState;
    const buffer = $ea00a46645b09ae6$var$stepsSentCache.get(version);
    const startedAt = buffer?.startedAt || Date.now();
    const endedAt = Date.now();
    const steps = (buffer?.steps || []).concat(newSteps);
    $ea00a46645b09ae6$var$stepsSentCache.set(version, {
        startedAt: startedAt,
        endedAt: endedAt,
        steps: steps
    });
    (0, $jq5Q3.updateNcsSessionStepMetrics)({
        api: api,
        steps: (0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newSteps.filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep))) : newSteps
    });
    scheduler.postTask(()=>{
        $ea00a46645b09ae6$export$94e939b87ca64fb4($ea00a46645b09ae6$var$stepsSentCache, onTrackDataProcessed);
    }, {
        priority: 'background',
        delay: $ea00a46645b09ae6$var$LOW_PRIORITY_DELAY
    });
};
module.exports["sanitizeStep"] = $ea00a46645b09ae6$export$685b976035d234a6;
module.exports["groupSteps"] = $ea00a46645b09ae6$export$cb21deee7d469afa;
module.exports["track"] = $ea00a46645b09ae6$export$6b2a7d5132615086;

});

parcelRegister("jq5Q3", function(module, exports) {

var $a1TCB = parcelRequire("a1TCB");


var $6YrB3 = parcelRequire("6YrB3");

const $289cf17f76da8b8b$var$storageClient = new (0, $6YrB3.default)((0, $a1TCB.NCS_STORAGE).NCS_STORAGE_CLIENT_KEY);
const $289cf17f76da8b8b$export$4fe9abcf7996805c = (metrics, sessionId, steps)=>{
    const current = metrics[sessionId] ?? {
        ncsSessionId: sessionId,
        totalStepSize: 0,
        numberOfSteps: 0,
        maxStepSize: 0,
        stepSizeSumForP90: []
    };
    steps.forEach((step)=>{
        const stepSize = JSON.stringify(step).length;
        current.totalStepSize += stepSize;
        current.numberOfSteps += 1;
        current.maxStepSize = Math.max(current.maxStepSize, stepSize || 0);
        current.stepSizeSumForP90.push(stepSize || 0);
    });
    return current;
};
const $289cf17f76da8b8b$export$bc7fe0d8ce4c3c0a = (sessionId)=>{
    const currentActiveSessions = JSON.parse($289cf17f76da8b8b$var$storageClient.getItem((0, $a1TCB.NCS_STORAGE).NCS_ACTIVE_SESSIONS) || '{}');
    if (!currentActiveSessions[sessionId]) $289cf17f76da8b8b$var$storageClient.setItemWithExpiry((0, $a1TCB.NCS_STORAGE).NCS_ACTIVE_SESSIONS, JSON.stringify({
        ...currentActiveSessions,
        [sessionId]: true
    }));
};
const $289cf17f76da8b8b$export$defdcaf9cc1c87fe = ({ api: api, steps: steps })=>{
    const sessionId = api?.collabEdit?.sharedState.currentState()?.sessionId;
    if (!sessionId) return;
    const existingMetrics = JSON.parse($289cf17f76da8b8b$var$storageClient.getItem((0, $a1TCB.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    const ncsSessionStepMetrics = $289cf17f76da8b8b$export$4fe9abcf7996805c(existingMetrics, sessionId, steps);
    $289cf17f76da8b8b$var$storageClient.setItemWithExpiry((0, $a1TCB.NCS_STORAGE).NCS_SESSION_STEP_METRICS, JSON.stringify({
        ...existingMetrics,
        [sessionId]: ncsSessionStepMetrics
    }));
    $289cf17f76da8b8b$export$bc7fe0d8ce4c3c0a(sessionId);
};
module.exports["updateNcsSessionStepMetrics"] = $289cf17f76da8b8b$export$defdcaf9cc1c87fe;

});

parcelRegister("a1TCB", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ var $a362193e7f71cc60$export$d173f08296df529 = /*#__PURE__*/ function(NCS_STORAGE) {
    // remove step metrics keys when cleaning up platform_editor_remove_collab_step_metrics
    NCS_STORAGE["NCS_STORAGE_CLIENT_KEY"] = "ncs-session-step-metrics-storage";
    NCS_STORAGE["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    NCS_STORAGE["NCS_ACTIVE_SESSIONS"] = "ncsActiveSessions";
    return NCS_STORAGE;
}({});
module.exports["NCS_STORAGE"] = $a362193e7f71cc60$export$d173f08296df529;

});

parcelRegister("jm7OT", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $847ae5ee06d6088f$var$nativeCollabProviderPluginKey = new (0, $kCECX.PluginKey)('nativeCollabProviderPlugin');
const $847ae5ee06d6088f$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $847ae5ee06d6088f$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($847ae5ee06d6088f$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($847ae5ee06d6088f$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $847ae5ee06d6088f$export$82feb779db31f396 = (editorState)=>{
    return $847ae5ee06d6088f$var$nativeCollabProviderPluginKey.getState(editorState);
};
module.exports["nativeCollabProviderPlugin"] = $847ae5ee06d6088f$export$ad653665b59b3ffd;

});

parcelRegister("6ixNC", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");

var $gT4iv = parcelRequire("gT4iv");

var $73Kv0 = parcelRequire("73Kv0");

var $1A89X = parcelRequire("1A89X");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");

const $30d605db108db527$var$THRESHOLD = 50; // 50 milliseconds
const $30d605db108db527$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $eOaGc.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $eOaGc.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $1A89X.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $eOaGc.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $eOaGc.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $eOaGc.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $eOaGc.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $eOaGc.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $eOaGc.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $l5rX3.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $gT4iv.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $73Kv0.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $30d605db108db527$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $l5rX3.AnalyticsStep) || step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep) || step instanceof (0, $73Kv0.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $30d605db108db527$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $30d605db108db527$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $30d605db108db527$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $eOaGc.RemoveNodeMarkStep) || step instanceof (0, $eOaGc.AddNodeMarkStep) || step instanceof (0, $1A89X.SetAttrsStep) || step instanceof (0, $eOaGc.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $gT4iv.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $30d605db108db527$export$ea2d2436326e1247 = new (0, $kCECX.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $30d605db108db527$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $kpCD8.SafePlugin)({
        key: $30d605db108db527$export$ea2d2436326e1247,
        filterTransaction: $30d605db108db527$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};
module.exports["sanitizeFilteredStep"] = $30d605db108db527$export$2d791416d1075a3b;
module.exports["createPlugin"] = $30d605db108db527$export$ae829ec7b2625219;

});

parcelRegister("k7vUa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kpCD8 = parcelRequire("kpCD8");


var $efqK4 = parcelRequire("efqK4");


var $gZpSA = parcelRequire("gZpSA");


var $kCECX = parcelRequire("kCECX");


var $dtUVl = parcelRequire("dtUVl");

var $af2XZ = parcelRequire("af2XZ");

var $6ALId = parcelRequire("6ALId");

var $9tfSW = parcelRequire("9tfSW");


var $eDtFr = parcelRequire("eDtFr");


var $4o0zT = parcelRequire("4o0zT");


var $fqVYq = parcelRequire("fqVYq");


var $2PMvb = parcelRequire("2PMvb");


var $f5VOy = parcelRequire("f5VOy");


var $g5ewD = parcelRequire("g5ewD");


var $38lAe = parcelRequire("38lAe");


var $6wqCa = parcelRequire("6wqCa");


var $8civN = parcelRequire("8civN");


var $aowZj = parcelRequire("aowZj");

const $080d08f451e47419$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dtUVl.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $080d08f451e47419$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $080d08f451e47419$var$memoizedToItem = $080d08f451e47419$export$fc10aeed3a532e2a($080d08f451e47419$export$144d1b98bacb98cc);
const $080d08f451e47419$var$defaultListLimit = 50;
const $080d08f451e47419$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $080d08f451e47419$var$TRIGGER = ':';
function $080d08f451e47419$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $080d08f451e47419$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $efqK4.TypeAheadAvailableNodes).EMOJI,
        trigger: $080d08f451e47419$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $080d08f451e47419$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$080d08f451e47419$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($080d08f451e47419$var$TRIGGER.concat(query), {
                    limit: $080d08f451e47419$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $9tfSW.SearchSort).UsageFrequency : (0, $9tfSW.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $080d08f451e47419$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $080d08f451e47419$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!options?.disableAutoformat && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $080d08f451e47419$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $080d08f451e47419$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $6ALId.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $6ALId.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $2PMvb.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $aowZj.getEmojiQuickInsertComponents)());
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $f5VOy.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $cozmU.useEffect)(()=>{
                $080d08f451e47419$var$delayUntilIdle(()=>{
                    (0, $af2XZ.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $080d08f451e47419$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $6wqCa.inputRulePlugin)(schema, api?.analytics?.actions, api, options?.disableAutoformat)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $080d08f451e47419$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $38lAe.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$080d08f451e47419$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $2PMvb.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8civN.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'emoji',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emojiDescription),
                            priority: 500,
                            keyshortcut: ':',
                            isDisabledOffline: false,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconEmoji), {}),
                            action (insert) {
                                if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                                    exposure: true
                                })) {
                                    // Clear slash
                                    let tr = insert('');
                                    tr = (0, $38lAe.setInlineEmojiPopupOpen)(true)(tr);
                                    return tr;
                                }
                                const tr = insert(undefined);
                                api?.typeAhead?.actions.openAtTransaction({
                                    triggerHandler: typeAhead,
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).CLICKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                                    description: intl.formatMessage((0, $83k8i.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $080d08f451e47419$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $38lAe.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $080d08f451e47419$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $080d08f451e47419$var$logRateWarning = ()=>{};
const $080d08f451e47419$var$setProviderTr = $080d08f451e47419$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $38lAe.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $080d08f451e47419$var$logRateWarning);
const $080d08f451e47419$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $080d08f451e47419$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $080d08f451e47419$export$e3ef5170578bd8ba = new (0, $kCECX.PluginKey)('emojiPlugin');
function $080d08f451e47419$var$getEmojiPluginState(state) {
    return $080d08f451e47419$export$e3ef5170578bd8ba.getState(state) || {};
}
function $080d08f451e47419$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $kpCD8.SafePlugin)({
        key: $080d08f451e47419$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider && (0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($080d08f451e47419$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $38lAe.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $38lAe.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $38lAe.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $g5ewD.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $080d08f451e47419$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $080d08f451e47419$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $080d08f451e47419$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$080d08f451e47419$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $080d08f451e47419$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $080d08f451e47419$export$e3ef5170578bd8ba;

});

parcelRegister("2PMvb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $fRYCB = parcelRequire("fRYCB");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $e819716a0e878e7b$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $aPdNQ.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $e819716a0e878e7b$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $e819716a0e878e7b$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $bjg0G.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $kCECX.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $e819716a0e878e7b$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $e819716a0e878e7b$export$8d5c072327044b6f;

});

parcelRegister("f5VOy", function(module, exports) {

var $kOOm4 = parcelRequire("kOOm4");


var $8Dx7s = parcelRequire("8Dx7s");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

const $536e450147041236$var$isSSR = Boolean(undefined);
const $536e450147041236$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $kOOm4.emojiWithLocalId) : (0, $kOOm4.emoji);
    if ($536e450147041236$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$536e450147041236$export$9edeb07c311f4561(node)
    };
};
function $536e450147041236$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $8Dx7s.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $536e450147041236$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $536e450147041236$export$9edeb07c311f4561;

});

parcelRegister("g5ewD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $3u5lg = parcelRequire("3u5lg");


var $9wMFw = parcelRequire("9wMFw");


var $1hQ0e = parcelRequire("1hQ0e");


var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");

var $k8ZZN = parcelRequire("k8ZZN");

var $2O2Zk = parcelRequire("2O2Zk");


var $jv11C = parcelRequire("jv11C");


var $h1Peg = parcelRequire("h1Peg");


var $6Ixg8 = parcelRequire("6Ixg8");


var $aPdNQ = parcelRequire("aPdNQ");


var $4xiow = parcelRequire("4xiow");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $f5VOy = parcelRequire("f5VOy");

const $144c0f90b58057f8$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $144c0f90b58057f8$export$1d677781db73ff20(fallbackText) {
    return $144c0f90b58057f8$var$SINGLE_EMOJI_REGEX.test(fallbackText);
}
/**
 * Emoji node view for renderering emoji nodes
 */ const $144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS = 'emoji-tooltip-editor';
class $144c0f90b58057f8$export$cadc6675ce598ba8 {
    destroyTooltip() {
        this.destroyLazyTooltipListeners?.();
        this.tooltipInstance?.destroy();
        this.tooltipTarget?.removeAttribute('popovertarget');
        this.tooltipTarget?.removeAttribute('aria-describedby');
        this.destroyLazyTooltipListeners = undefined;
        this.tooltipInstance = undefined;
        this.tooltipTarget = undefined;
    }
    static logError(error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const unicodeEmoji = id && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true) ? (0, $4xiow.emojiIdToEmoji)(id) : undefined;
            const emojiRepresentation = unicodeEmoji ? {
                unicodeEmoji: unicodeEmoji
            } : emojiDescription?.representation;
            if (!$144c0f90b58057f8$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $144c0f90b58057f8$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation || 'unicodeEmoji' in representation);
    }
    static shouldRecordUnicodeEmojiExposure(description, representation) {
        return description.type === 'STANDARD' || 'unicodeEmoji' in representation;
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        this.destroyTooltip();
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    /**
   * Lazily creates a VanillaTooltip on the given element showing the emoji shortName.
   * Gated behind the platform_editor_emoji_hover_show_tooltip experiment.
   * When the tooltip is active, the native `title` attribute is removed to avoid
   * showing both the browser tooltip and the custom tooltip.
   */ createTooltip(element, shortName) {
        if (!(0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true)) return;
        if ((0, $4iudd.isSSR)()) return;
        const initTooltip = (event)=>{
            this.destroyLazyTooltipListeners?.();
            this.destroyLazyTooltipListeners = undefined;
            const tooltipId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `emoji-tooltip-${crypto.randomUUID()}` : (0, (/*@__PURE__*/$parcel$interopDefault($9wMFw)))('emoji-tooltip-');
            try {
                // Flag-on (platform-dst-top-layer), positioning is async via a React root;
                // safe here as VanillaTooltip stays hidden until positioned.
                const tooltipInstance = new (0, $h1Peg.VanillaTooltip)(// VanillaTooltip types expect HTMLButtonElement but works with any HTMLElement
                element, shortName, tooltipId, $144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS, // default timeout
                300, // Inline styles are required because the Popover API promotes the tooltip
                // to the browser's top layer, where ancestor CSS selectors cannot reach it.
                {
                    boxSizing: 'border-box',
                    maxWidth: '240px',
                    backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
                    border: 'none',
                    borderRadius: "var(--ds-radius-small, 3px)",
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    insetBlockStart: "var(--ds-space-0, 0px)",
                    insetInlineStart: "var(--ds-space-0, 0px)",
                    overflowWrap: 'break-word',
                    paddingBlockStart: "var(--ds-space-050, 4px)",
                    paddingBlockEnd: "var(--ds-space-050, 4px)",
                    paddingInlineEnd: "var(--ds-space-075, 6px)",
                    paddingInlineStart: "var(--ds-space-075, 6px)",
                    whiteSpace: 'normal'
                });
                this.tooltipInstance = tooltipInstance;
                this.tooltipTarget = element;
                element.removeAttribute('title');
                element.dispatchEvent(new Event(event.type));
            } catch (error) {
                element.removeAttribute('popovertarget');
                element.removeAttribute('aria-describedby');
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error(String(error)));
            }
        };
        const unbindMouseEnter = (0, $cbY7C.bind)(element, {
            type: 'mouseenter',
            listener: initTooltip,
            options: {
                once: true
            }
        });
        const unbindFocus = (0, $cbY7C.bind)(element, {
            type: 'focus',
            listener: initTooltip,
            options: {
                once: true
            }
        });
        this.destroyLazyTooltipListeners = ()=>{
            unbindMouseEnter();
            unbindFocus();
        };
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const fallbackElement = doc.createElement('span');
        const { text: text, shortName: shortName } = this.node.attrs;
        // When the gate is enabled and the emoji is "custom" (i.e. its fallback
        // text is not a single standard Unicode emoji), render the Unicode
        // Replacement Character (U+FFFD) instead of the shortName text. Standard
        // emojis continue to fall back to their Unicode text representation.
        const fallbackText = text || shortName;
        const useReplacementChar = (0, $iDrrr.fg)('platform_editor_custom_emoji_unicode_fallback') && !$144c0f90b58057f8$export$1d677781db73ff20(fallbackText);
        const renderedFallbackText = useReplacementChar ? '\uFFFD' : fallbackText;
        fallbackElement.innerText = renderedFallbackText;
        fallbackElement.setAttribute('role', 'img');
        fallbackElement.setAttribute('title', shortName);
        fallbackElement.setAttribute('aria-label', shortName);
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
        this.createTooltip(fallbackElement, shortName);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'unicodeEmoji' in representation ? 'unicode' : 'sprite' in representation ? 'sprite' : 'image';
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        // Add wrapper for the emoji
        const containerElement = doc.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.setAttribute('title', description.shortName);
        containerElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $2O2Zk.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'unicodeEmoji' in representation ? this.createUnicodeEmojiElement(representation.unicodeEmoji) : 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
        if ($144c0f90b58057f8$export$cadc6675ce598ba8.shouldRecordUnicodeEmojiExposure(description, representation)) (0, $ieeJu.expValEquals)('platform_use_unicode_emojis', 'isEnabled', true);
        this.createTooltip(containerElement, description.shortName);
    }
    createUnicodeEmojiElement(emoji) {
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spanElement = doc.createElement('span');
        spanElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_UNICODE);
        spanElement.textContent = emoji;
        spanElement.style.display = 'inline-flex';
        spanElement.style.fontSize = `var(--emoji-common-unicode-size, ${0, $l4yrE.defaultEmojiHeight}px)`;
        spanElement.style.alignItems = 'center';
        spanElement.style.aspectRatio = '1/1';
        spanElement.style.lineHeight = '1em';
        spanElement.style.margin = '-1px 0';
        spanElement.style.verticalAlign = 'middle'; // to keep vertical alignment consistent with images
        return spanElement;
    }
    createSpriteEmojiElement(representation) {
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spriteElement = doc.createElement('span');
        spriteElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $l4yrE.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $l4yrE.defaultEmojiHeight}px`;
        if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $l4yrE.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $l4yrE.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const imageElement = doc.createElement('img');
        imageElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        imageElement.style.minWidth = `${0, $l4yrE.defaultEmojiHeight}px`;
        imageElement.style.objectFit = 'contain';
        imageElement.height = (0, $l4yrE.defaultEmojiHeight);
        imageElement.onerror = ()=>{
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
                // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
                // mark the node to refresh when returning online.
                // Create a check that confirms if this.node.attrs.text if an ascii emoji
                if ($144c0f90b58057f8$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
                else this.renderingFallback = true;
            } else this.renderFallback();
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.tooltipInstance = void 0;
        this.tooltipTarget = void 0;
        this.destroyLazyTooltipListeners = void 0;
        this.destroy = ()=>{
            if (this.tooltipInstance || this.tooltipTarget || this.destroyLazyTooltipListeners) this.destroyTooltip();
        };
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $f5VOy.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        if (emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $144c0f90b58057f8$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$144c0f90b58057f8$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $4iudd.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if ((0, $6Ixg8.isOfflineMode)(prevSharedState?.mode) && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
                this.destroyTooltip();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $144c0f90b58057f8$export$cadc6675ce598ba8;

});

parcelRegister("9wMFw", function(module, exports) {

var $dojlP = parcelRequire("dojlP");

/** Used to generate unique IDs. */ var $6efcdace0fb66c85$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $6efcdace0fb66c85$var$uniqueId(prefix) {
    var id = ++$6efcdace0fb66c85$var$idCounter;
    return $dojlP(prefix) + id;
}
module.exports = $6efcdace0fb66c85$var$uniqueId;

});

parcelRegister("2O2Zk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $373e836c88a63247$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $373e836c88a63247$export$defe85febe8b728c;

});

parcelRegister("h1Peg", function(module, exports) {

var $kdxSx = parcelRequire("kdxSx");


var $cbY7C = parcelRequire("cbY7C");


var $iDrrr = parcelRequire("iDrrr");


var $5dNeE = parcelRequire("5dNeE");

const $b3a4b496786a0875$var$startingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            4
        ]
    }
};
const $b3a4b496786a0875$var$endingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            8
        ]
    }
};
function $b3a4b496786a0875$var$getCreatePopper() {
    if ((0, $iDrrr.fg)('platform-dst-popper-consolidation')) return 0, $5dNeE.createPopper;
    return 0, $kdxSx.createPopper;
}
class $b3a4b496786a0875$export$47a232ed95817c75 {
    createPopperInstance() {
        this.popperInstance = $b3a4b496786a0875$var$getCreatePopper()(this.button, this.tooltip, {
            placement: 'top',
            modifiers: [
                $b3a4b496786a0875$var$startingOffset
            ]
        });
    }
    destroy() {
        this.popperInstance?.destroy();
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    hide(immediate = false) {
        clearTimeout(this.currentTimeoutId);
        this.shouldHidePopover = true;
        // Disable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $b3a4b496786a0875$var$startingOffset,
                        {
                            name: 'eventListeners',
                            enabled: false
                        }
                    ]
                }));
            this.tooltip.style.opacity = '0';
            this.isDisplayed = false;
            // If transition animations are disabled immediately hide the popover
            if (this.tooltip.style.transition === 'none') this.tooltip.hidePopover();
        }, immediate ? 0 : this.timeout);
    }
    show() {
        if (this.isDisplayed) return;
        clearTimeout(this.currentTimeoutId);
        this.shouldHidePopover = false;
        // Make the tooltip visible - but hide until
        this.tooltip.style.visibility = 'hidden';
        this.tooltip.showPopover();
        // Update its position
        if (!this.popperInstance) this.createPopperInstance();
        else this.popperInstance.update();
        // Enable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.tooltip.style.opacity = '1';
            this.tooltip.style.visibility = 'visible';
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $b3a4b496786a0875$var$endingOffset,
                        {
                            name: 'eventListeners',
                            enabled: true
                        }
                    ]
                }));
            this.isDisplayed = true;
        }, this.timeout);
    }
    constructor(button, content, /**
   * Id associated to the tooltip - must be unique.
   */ id, /**
   * Class Name – used for styling.
   */ className, timeout = 300, /**
   * Optional inline styles to apply directly to the tooltip element.
   * Useful when the tooltip is rendered in the browser's top layer (via Popover API),
   * where ancestor CSS selectors cannot reach it.
   */ styles){
        this.button = button;
        this.timeout = timeout;
        this.popperInstance = void 0;
        this.listeners = [];
        this.currentTimeoutId = void 0;
        this.shouldHidePopover = false;
        this.tooltip = void 0;
        this.isDisplayed = false;
        const tooltip = document.createElement('span');
        tooltip.role = 'tooltip';
        tooltip.popover = 'hint';
        tooltip.className = className;
        tooltip.id = id;
        tooltip.textContent = content;
        if (styles) Object.assign(tooltip.style, styles);
        this.tooltip = tooltip;
        // Button preparation
        button.appendChild(tooltip);
        // Prepare the button to have the popover target and accessibility properties
        button.setAttribute('popovertarget', tooltip.id);
        button.setAttribute('aria-describedby', tooltip.id);
        const showEvents = [
            'mouseenter',
            'focus'
        ];
        const hideEvents = [
            'mouseleave',
            'blur'
        ];
        showEvents.forEach((event)=>{
            this.listeners.push((0, $cbY7C.bind)(button, {
                type: event,
                listener: ()=>this.show()
            }));
        });
        hideEvents.forEach((event)=>{
            this.listeners.push((0, $cbY7C.bind)(button, {
                type: event,
                listener: ()=>this.hide()
            }));
        });
        this.listeners.push((0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        }));
        // Hide the tooltip if the hide transition has completed
        this.tooltip.ontransitionend = ()=>{
            if (this.shouldHidePopover) this.tooltip.hidePopover();
        };
    }
}
module.exports["VanillaTooltip"] = $b3a4b496786a0875$export$47a232ed95817c75;

});

parcelRegister("5dNeE", function(module, exports) {
/**
 * UNSAFE compatibility entry point. `createPopper` for non-React, imperative
 * consumers moving direct `@popperjs/core` dependency ownership onto
 * `@atlaskit/popper`.
 *
 * Do not use this for new code. New overlays should build on
 * `@atlaskit/top-layer` directly: `Popover` + `useAnchorPosition`. top-layer
 * has no imperative positioning API and is not getting one — see
 * `top-layer/notes/migrations/popper-migration.md` -> "Decision: popper brings
 * its own React".
 *
 * Behind the `platform-dst-top-layer` feature gate this returns a top-layer
 * backed instance: the element is positioned with CSS Anchor Positioning and
 * lifted into the browser top layer. Flag-off it is the raw Popper.js v2
 * engine. See `createPopperTopLayer` for the option-handling tiers.
 */ 
var $kdxSx = parcelRequire("kdxSx");


var $iDrrr = parcelRequire("iDrrr");


var $hXEyv = parcelRequire("hXEyv");

const $19378def19a022a0$export$8f7491d57c8f97a9 = (reference, popper, options)=>{
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return (0, $hXEyv.createPopperTopLayer)(reference, popper, options);
    return (0, $kdxSx.createPopper)(reference, popper, options);
};
module.exports["createPopper"] = $19378def19a022a0$export$8f7491d57c8f97a9;

});

parcelRegister("hXEyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fRQ3t = parcelRequire("fRQ3t");


var $1hQ0e = parcelRequire("1hQ0e");


var $aRDbl = parcelRequire("aRDbl");


var $97Yf0 = parcelRequire("97Yf0");


var $7tQDG = parcelRequire("7tQDG");


var $aM6nP = parcelRequire("aM6nP");


var $duYjR = parcelRequire("duYjR");


var $pQqk9 = parcelRequire("pQqk9");

/**
 * Popper.js defaults, applied when the caller omits them.
 * <https://popper.js.org/docs/v2/constructors/#options>
 */ const $8a5d834575581bec$var$DEFAULT_PLACEMENT = 'bottom';
const $8a5d834575581bec$var$DEFAULT_STRATEGY = 'absolute';
/**
 * Popper.js' `offset` modifier defaults to `[0, 0]` — no gap. This differs from
 * ADS `<Popper>` (`[0, 8]`) and from top-layer's own `space.100` default, so the
 * offset is always passed explicitly: a caller that asked for no offset keeps
 * getting none.
 */ const $8a5d834575581bec$var$NO_OFFSET = [
    0,
    0
];
/**
 * Fills in Popper.js' option defaults so `state.options` is always complete,
 * matching what the real engine exposes.
 */ function $8a5d834575581bec$var$resolveOptions(options) {
    return {
        placement: options?.placement ?? $8a5d834575581bec$var$DEFAULT_PLACEMENT,
        modifiers: options?.modifiers ?? [],
        strategy: options?.strategy ?? $8a5d834575581bec$var$DEFAULT_STRATEGY,
        onFirstUpdate: options?.onFirstUpdate
    };
}
/**
 * Reads the `offset` modifier's `[skidding, distance]` tuple.
 *
 * Popper.js merges duplicate modifier entries by name with later entries
 * winning, so the last `offset` entry is the one that counts. A disabled
 * modifier, or a function-valued `offset` (which Popper.js resolves per-update
 * against live rects and CSS Anchor Positioning has no equivalent for), falls
 * back to no offset.
 */ function $8a5d834575581bec$var$getOffset(modifiers) {
    const offsetModifier = modifiers.filter((modifier)=>modifier?.name === 'offset').pop();
    if (!offsetModifier || offsetModifier.enabled === false) return $8a5d834575581bec$var$NO_OFFSET;
    const offset = offsetModifier.options?.offset;
    if (!Array.isArray(offset)) return $8a5d834575581bec$var$NO_OFFSET;
    const [along, away] = offset;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * Maps resolved Popper.js options onto top-layer's placement input.
 *
 * Called from the bridge components' render, not memoized: the bridge remounts
 * on every option change (see `createPopperTopLayer`), so a `useMemo` cache
 * could never be read, and `useAnchorPosition` already re-derives a stable
 * placement from the primitive fields so a fresh object identity per render
 * costs nothing downstream.
 */ function $8a5d834575581bec$var$toTopLayerPlacement(options) {
    return (0, $aRDbl.fromLegacyPlacement)({
        legacy: (0, $pQqk9.toLegacyPlacement)(options.placement),
        offset: $8a5d834575581bec$var$getOffset(options.modifiers)
    });
}
/**
 * Neutralises the UA stylesheet's `[popover]` rules for an element this adapter
 * promoted, so promotion is a change of paint order and nothing else.
 *
 * The UA sheet gives every popover `border: solid`, `padding: 0.25em`,
 * `overflow: auto`, `width` / `height: fit-content`, `color: CanvasText` and
 * `background-color: Canvas`. `<Popover>` overrides these in its own Compiled
 * class, but the element here belongs to the caller, so inline styles are the
 * wrong tool: they would beat the caller's own stylesheet rather than only the
 * UA's. A zero-specificity `:where()` rule in the author origin is exactly the
 * right precedence — it always beats the UA sheet and always loses to any
 * caller selector.
 *
 * `inline-size` is deliberately left at the UA default, matching `<Popover>`
 * (which keeps it for anchor-width matching).
 */ const $8a5d834575581bec$var$PROMOTED_ATTRIBUTE = 'data-ds--popper-promoted';
function $8a5d834575581bec$var$ensurePromotedStyles(element) {
    // Injected into the element's own document rather than a module-cached one,
    // so a caller positioning inside an iframe still gets the reset.
    const document = element.ownerDocument;
    if (document.querySelector(`style[${$8a5d834575581bec$var$PROMOTED_ATTRIBUTE}]`)) return;
    const style = document.createElement('style');
    style.setAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE, 'true');
    style.textContent = `:where([${$8a5d834575581bec$var$PROMOTED_ATTRIBUTE}]){border-style:none;padding:0;overflow:visible;block-size:auto;color:inherit;background-color:transparent;}`;
    document.head.appendChild(style);
}
/**
 * Lifts the caller's element into the browser top layer.
 *
 * Uses `popover="manual"` so the element gets top-layer promotion without light
 * dismiss and without joining the auto-dismiss stack - the caller keeps owning
 * visibility, which matches Popper.js' contract (and mirrors the
 * `<Popover mode="manual">` the React `<Popper>` FF-on path uses).
 *
 * Returns `undefined` when no promotion happened: the element is already a
 * popover / `<dialog>` (the caller owns the top layer already), or the browser
 * has no Popover API. The latter is unpositioned flag-on — but so is every
 * other `@atlaskit/top-layer` consumer, because the whole stack is built on the
 * Popover API. It is not a gap specific to this adapter.
 */ function $8a5d834575581bec$var$promoteToTopLayer(element) {
    if (element.hasAttribute('popover') || element.tagName === 'DIALOG') return undefined;
    if (typeof element.showPopover !== 'function') return undefined;
    $8a5d834575581bec$var$ensurePromotedStyles(element);
    element.setAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE, 'true');
    element.setAttribute('popover', 'manual');
    try {
        element.showPopover();
    } catch  {
        // `showPopover()` throws `InvalidStateError` for a disconnected element.
        // Leave the element in normal flow rather than stranding it as a hidden,
        // never-shown popover.
        element.removeAttribute('popover');
        element.removeAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE);
        return undefined;
    }
    return function undoPromotion() {
        try {
            element.hidePopover();
        } catch  {}
        element.removeAttribute('popover');
        element.removeAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE);
    };
}
const $8a5d834575581bec$var$EMPTY_RECT = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
};
/**
 * `VirtualElement.getBoundingClientRect()` is typed as `ClientRect | DOMRect`,
 * and `ClientRect` has no `x` / `y` - so read the physical edges instead.
 */ function $8a5d834575581bec$var$toRect(rect) {
    return {
        width: rect.width,
        height: rect.height,
        x: rect.left,
        y: rect.top
    };
}
// Both bridges below render nothing. They exist purely so top-layer's
// positioning hooks can run against elements that live outside any React tree,
// and they mirror the anchor resolution in `popper-top-layer.tsx`. Which one is
// used is decided when the instance is created and never changes, so each calls
// exactly one hook unconditionally.
//
// Every prop is constant for the lifetime of a mount: the elements are fixed at
// creation, and an option change remounts the bridge (see
// `createPopperTopLayer`). So props go straight into refs with no re-assignment,
// and closures over them cannot go stale.
/**
 * Real DOM anchor: `useAnchorPosition` gives it `anchor-name` on the CSS Anchor
 * Positioning path, and measures it on the JS fallback.
 */ const $8a5d834575581bec$var$AnchorBridge = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnchorBridge(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { anchor: anchor, popover: popover, options: options } = t0;
    const anchorRef = (0, $cozmU.useRef)(anchor);
    const popoverRef = (0, $cozmU.useRef)(popover);
    let t1;
    if ($[0] !== options) {
        t1 = $8a5d834575581bec$var$toTopLayerPlacement(options);
        $[0] = options;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = {
            anchorRef: anchorRef,
            popoverRef: popoverRef,
            placement: t1,
            isOpen: true
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    (0, $97Yf0.useAnchorPosition)(t2);
    return null;
} : function AnchorBridge({ anchor: anchor, popover: popover, options: options }) {
    const anchorRef = (0, $cozmU.useRef)(anchor);
    const popoverRef = (0, $cozmU.useRef)(popover);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: $8a5d834575581bec$var$toTopLayerPlacement(options),
        isOpen: true
    });
    return null;
};
/**
 * Anything that is not a real DOM element (a Popper.js `VirtualElement`, an SVG
 * element, an element from another realm) cannot carry `anchor-name`, so its
 * rect is reduced to the geometrically-equivalent point for the requested
 * placement and handed to `useAnchorPositionAtPoint`, which owns the synthetic
 * anchor.
 */ const $8a5d834575581bec$var$PointBridge = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PointBridge(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { reference: reference, popover: popover, options: options } = t0;
    const popoverRef = (0, $cozmU.useRef)(popover);
    let t1;
    if ($[0] !== options) {
        t1 = $8a5d834575581bec$var$toTopLayerPlacement(options);
        $[0] = options;
        $[1] = t1;
    } else t1 = $[1];
    const placement = t1;
    let t2;
    if ($[2] !== placement || $[3] !== reference) {
        t2 = ()=>(0, $duYjR.rectPointForPlacement)({
                rect: reference.getBoundingClientRect(),
                placement: placement,
                isRtl: (0, $aM6nP.isPageRtl)()
            });
        $[2] = placement;
        $[3] = reference;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== placement || $[6] !== t2) {
        t3 = {
            popoverRef: popoverRef,
            placement: placement,
            isOpen: true,
            getPoint: t2
        };
        $[5] = placement;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    (0, $7tQDG.useAnchorPositionAtPoint)(t3);
    return null;
} : function PointBridge({ reference: reference, popover: popover, options: options }) {
    const popoverRef = (0, $cozmU.useRef)(popover);
    const placement = $8a5d834575581bec$var$toTopLayerPlacement(options);
    (0, $7tQDG.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isOpen: true,
        getPoint: ()=>(0, $duYjR.rectPointForPlacement)({
                rect: reference.getBoundingClientRect(),
                placement: placement,
                isRtl: (0, $aM6nP.isPageRtl)()
            })
    });
    return null;
};
function $8a5d834575581bec$export$3f3476d827c0bd92(reference, popper, options) {
    let currentOptions = $8a5d834575581bec$var$resolveOptions(options);
    let isDestroyed = false;
    // Used as the bridge's `key` and bumped by every call that re-positions, so
    // the bridge remounts and its hook re-runs from scratch. See "Instance
    // surface" above for why that is load-bearing on both bridges.
    let generation = 0;
    // Which bridge to render is fixed here, for the instance's lifetime.
    const anchor = reference instanceof HTMLElement ? reference : null;
    // Promote BEFORE the first render so the popover is already open when the
    // hooks' layout effects run - `useAnchorPosition`'s JS fallback detects an
    // already-open popover and measures immediately instead of waiting for a
    // `toggle` event it would otherwise have missed.
    const undoPromotion = $8a5d834575581bec$var$promoteToTopLayer(popper);
    // React host for the bridge. The bridge renders `null`, so this container
    // stays empty and is deliberately never appended to the document: React only
    // needs an element to own, and effects run either way.
    const container = (0, $1hQ0e.getDocument)()?.createElement('div');
    const root = container ? (0, $fRQ3t.createRoot)(container) : null;
    const state = {
        elements: {
            reference: reference,
            popper: popper
        },
        options: currentOptions,
        placement: currentOptions.placement,
        strategy: currentOptions.strategy,
        orderedModifiers: [],
        rects: {
            reference: $8a5d834575581bec$var$EMPTY_RECT,
            popper: $8a5d834575581bec$var$EMPTY_RECT
        },
        scrollParents: {
            reference: [],
            popper: []
        },
        styles: {},
        attributes: {},
        modifiersData: {},
        reset: false
    };
    function render() {
        if (!root || isDestroyed) return;
        // Deliberately NOT wrapped in `flushSync`. React commits this on its own
        // schedule, so positioning lands on the next tick rather than before this
        // call returns. Popper.js is the same (its first update is async), and
        // forcing a sync flush is not an option: a React consumer calling
        // `createPopper` from an effect would trip
        // "flushSync was called from inside a lifecycle method", which React
        // downgrades to an async commit anyway — so the flush buys a console
        // error and nothing else.
        root.render(anchor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a5d834575581bec$var$AnchorBridge, {
            key: generation,
            anchor: anchor,
            popover: popper,
            options: currentOptions
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a5d834575581bec$var$PointBridge, {
            key: generation,
            reference: reference,
            popover: popper,
            options: currentOptions
        }));
        // Measured at call time, so `rects.popper` reflects the position before
        // this render commits. Popper.js' `state` is likewise only as fresh as the
        // last completed update.
        state.rects = {
            reference: $8a5d834575581bec$var$toRect(reference.getBoundingClientRect()),
            popper: $8a5d834575581bec$var$toRect(popper.getBoundingClientRect())
        };
    }
    render();
    // Popper.js resolves `onFirstUpdate` asynchronously, after the first update
    // completes. Match that timing so callers that mutate state in the callback
    // do not do so during their own `createPopper()` call.
    const { onFirstUpdate: onFirstUpdate } = currentOptions;
    if (onFirstUpdate) Promise.resolve().then(()=>{
        if (!isDestroyed) onFirstUpdate(state);
    });
    return {
        state: state,
        update () {
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        forceUpdate () {
            generation += 1;
            render();
        },
        setOptions (setOptionsAction) {
            if (isDestroyed) return Promise.resolve(state);
            const next = typeof setOptionsAction === 'function' ? setOptionsAction(currentOptions) : setOptionsAction;
            currentOptions = $8a5d834575581bec$var$resolveOptions({
                ...currentOptions,
                ...next
            });
            state.options = currentOptions;
            state.placement = currentOptions.placement;
            state.strategy = currentOptions.strategy;
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        destroy () {
            if (isDestroyed) return;
            // Set synchronously so a `render()` already in flight is dropped and
            // `onFirstUpdate` never fires after `destroy()`.
            isDestroyed = true;
            // Deferred to a microtask, NOT run inline. `root.unmount()` is
            // synchronous, and React logs "Attempted to synchronously unmount a
            // root while React was already rendering" when it is called during a
            // commit — which is exactly where a React caller destroys, since
            // effect cleanups run in the commit phase. React also downgrades the
            // unmount to an async commit there, so inline teardown would restore
            // the hooks' styles *after* `undoPromotion()` had already run,
            // inverting the order below. A microtask leaves the commit and gets
            // both: no warning, and teardown in the right order.
            queueMicrotask(()=>{
                // Unmounting runs the hooks' cleanups, which restore every inline
                // style they wrote and remove any synthetic anchor.
                root?.unmount();
                undoPromotion?.();
            });
        }
    };
}
module.exports["createPopperTopLayer"] = $8a5d834575581bec$export$3f3476d827c0bd92;

});

parcelRegister("38lAe", function(module, exports) {

var $k7vUa = parcelRequire("k7vUa");

const $0ac6ed1cc3df6249$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $0ac6ed1cc3df6249$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $0ac6ed1cc3df6249$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $0ac6ed1cc3df6249$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $0ac6ed1cc3df6249$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $0ac6ed1cc3df6249$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $0ac6ed1cc3df6249$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $0ac6ed1cc3df6249$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $0ac6ed1cc3df6249$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $0ac6ed1cc3df6249$export$f53f9c9a74ec859b;

});

parcelRegister("6wqCa", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");


var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");

let $4ed2d201aff988fe$var$matcher;
function $4ed2d201aff988fe$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat) return;
    if (schema.nodes.emoji) {
        $4ed2d201aff988fe$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $d8RhQ.createRule)($4ed2d201aff988fe$var$AsciiEmojiMatcher.REGEX, $4ed2d201aff988fe$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4ed2d201aff988fe$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4ed2d201aff988fe$var$matcher = new $4ed2d201aff988fe$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4ed2d201aff988fe$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4ed2d201aff988fe$var$matcher) return null;
        const match = $4ed2d201aff988fe$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4ed2d201aff988fe$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4ed2d201aff988fe$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4ed2d201aff988fe$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4ed2d201aff988fe$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4ed2d201aff988fe$var$getLeadingString = (match, withParenthesis = true)=>match[$4ed2d201aff988fe$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4ed2d201aff988fe$var$getLeadingStringWithoutParentheses = (match)=>$4ed2d201aff988fe$var$getLeadingString(match, false);
const $4ed2d201aff988fe$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4ed2d201aff988fe$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4ed2d201aff988fe$var$getAsciiWithParentheses = (matchParts)=>$4ed2d201aff988fe$var$getAscii(matchParts, true);
const $4ed2d201aff988fe$var$getTrailingString = (match)=>match[$4ed2d201aff988fe$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4ed2d201aff988fe$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4ed2d201aff988fe$var$getLeadingStringWithoutParentheses(matchParts), $4ed2d201aff988fe$var$getAsciiWithParentheses(matchParts), $4ed2d201aff988fe$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4ed2d201aff988fe$var$getLeadingString(matchParts), $4ed2d201aff988fe$var$getAscii(matchParts), $4ed2d201aff988fe$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // New behavior: All emoticons require whitespace after them
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4ed2d201aff988fe$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $3brWT.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $3brWT.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
class $4ed2d201aff988fe$var$RecordingAsciiEmojiMatcher extends $4ed2d201aff988fe$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4ed2d201aff988fe$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).ASCII
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4ed2d201aff988fe$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4ed2d201aff988fe$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4ed2d201aff988fe$export$2e2bcd8739ae039 = $4ed2d201aff988fe$var$plugins;
module.exports["inputRulePlugin"] = $4ed2d201aff988fe$export$568a7ed6897c4817;

});

parcelRegister("8civN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $ajK0g = parcelRequire("ajK0g");


var $4y8CY = parcelRequire("4y8CY");


var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $lAkJe = parcelRequire("lAkJe");


var $iDrrr = parcelRequire("iDrrr");


var $38lAe = parcelRequire("38lAe");

const $fea728d07a1765e1$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $fea728d07a1765e1$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $fea728d07a1765e1$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $4y8CY.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $cozmU.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fea728d07a1765e1$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fea728d07a1765e1$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lAkJe.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $fea728d07a1765e1$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        editorView.dispatch((0, $38lAe.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $cozmU.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $cozmU.useMemo)(()=>(0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fea728d07a1765e1$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fea728d07a1765e1$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lAkJe.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $fea728d07a1765e1$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fea728d07a1765e1$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});
module.exports["InlineEmojiPopup"] = $fea728d07a1765e1$export$295b54f3ba0abfa5;

});

parcelRegister("ajK0g", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $krYZG = parcelRequire("krYZG");

const $c1a12c1d77a0edce$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $c1a12c1d77a0edce$export$49d74ed2464a12b9;

});

parcelRegister("aowZj", function(module, exports) {

var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");


var $4hFUk = parcelRequire("4hFUk");

const $e3cd6ae3791803fd$export$cff8c6d3484f6a4c = ()=>[
        {
            key: (0, $dCkbP.EMOJI_MENU_ITEM).key,
            type: (0, $dCkbP.EMOJI_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.MEDIA_SECTION).key,
                    type: (0, $dCkbP.MEDIA_SECTION).type,
                    rank: (0, $dXqu3.MEDIA_SECTION_RANK)[(0, $dCkbP.EMOJI_MENU_ITEM).key]
                }
            ],
            component: (0, $4hFUk.EmojiQuickInsertMenuItem)
        }
    ];
module.exports["getEmojiQuickInsertComponents"] = $e3cd6ae3791803fd$export$cff8c6d3484f6a4c;

});

parcelRegister("4hFUk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $I2MTF = parcelRequire("I2MTF");


var $38lAe = parcelRequire("38lAe");

const $37ac3f787c71ab8c$export$436810d83faf90ed = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>(0, $38lAe.setInlineEmojiPopupOpen)(true)(insert('')), []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconEmoji), {}),
        onSelect: onSelect,
        shortcut: ":",
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji)
    });
};
module.exports["EmojiQuickInsertMenuItem"] = $37ac3f787c71ab8c$export$436810d83faf90ed;

});

parcelRegister("hCTxc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $ejDip = parcelRequire("ejDip");

let $93f2adb033f30f1d$var$showJiraCollectorDialog;
let $93f2adb033f30f1d$var$feedbackInfoHash;
let $93f2adb033f30f1d$var$defaultFeedbackInfo;
const $93f2adb033f30f1d$var$hashFeedbackInfo = (feedbackInfo)=>{
    const { product: product, packageName: packageName, packageVersion: packageVersion, labels: labels } = feedbackInfo;
    return [
        product,
        packageName,
        packageVersion,
        ...labels || []
    ].join('|');
};
const $93f2adb033f30f1d$export$432e2d318c18feaa = async (feedbackInfo)=>// eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject)=>{
        const combinedFeedbackInfo = {
            product: 'n/a',
            labels: [],
            packageName: '',
            packageVersion: '',
            coreVersion: '',
            sessionId: '',
            contentId: '',
            tabId: '',
            ...$93f2adb033f30f1d$var$defaultFeedbackInfo,
            ...feedbackInfo
        };
        const newFeedbackInfoHash = $93f2adb033f30f1d$var$hashFeedbackInfo(combinedFeedbackInfo);
        if (!$93f2adb033f30f1d$var$showJiraCollectorDialog || $93f2adb033f30f1d$var$feedbackInfoHash !== newFeedbackInfoHash) try {
            $93f2adb033f30f1d$var$showJiraCollectorDialog = await (0, $ejDip.default)([
                combinedFeedbackInfo.product,
                ...combinedFeedbackInfo.labels
            ], combinedFeedbackInfo.packageName, combinedFeedbackInfo.coreVersion, combinedFeedbackInfo.packageVersion, combinedFeedbackInfo.sessionId, combinedFeedbackInfo.contentId, combinedFeedbackInfo.tabId);
            $93f2adb033f30f1d$var$feedbackInfoHash = newFeedbackInfoHash;
        } catch (err) {
            reject(err);
        }
        const timeoutId = window.setTimeout($93f2adb033f30f1d$var$showJiraCollectorDialog, 0);
        // Return the timoutId for consumers to call clearTimeout if they need to.
        resolve(timeoutId);
    });
const $93f2adb033f30f1d$export$1b6ac82b29dcc009 = ({ config: feedbackInfo, api: api })=>{
    $93f2adb033f30f1d$var$defaultFeedbackInfo = feedbackInfo ?? {};
    return {
        name: 'feedbackDialog',
        actions: {
            openFeedbackDialog: $93f2adb033f30f1d$export$432e2d318c18feaa
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'feedbackdialog',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).feedbackDialog),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).feedbackDialogDescription),
                        priority: 400,
                        keywords: [
                            'bug'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconFeedback), {}),
                        action (insert, state) {
                            const tr = insert('');
                            $93f2adb033f30f1d$export$432e2d318c18feaa(feedbackInfo);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).OPENED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).FEEDBACK_DIALOG,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["feedbackDialogPlugin"] = $93f2adb033f30f1d$export$1b6ac82b29dcc009;

});

parcelRegister("ejDip", function(module, exports) {

var $dXXBc = parcelRequire("dXXBc");


var $bdDwi = parcelRequire("bdDwi");

const $5023d7679998a80e$var$JIRA_ISSUE_COLLECTOR_URL = 'https://product-fabric.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w0bwo4/b/14/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=98644b9c';
const $5023d7679998a80e$var$loadJiraCollectorDialogScript = (labels, packageName, coreVersion, packageVersion, sessionId, contentId, tabId)=>{
    // eslint-disable-next-line no-async-promise-executor, require-await
    return new Promise(async (resolve, reject)=>{
        if (window.jQuery) {
            window.ATL_JQ_PAGE_PROPS = {
                triggerFunction: (showCollectorDialog)=>{
                    if (typeof showCollectorDialog === 'function') resolve(showCollectorDialog);
                    else reject('Failed to initialize showCollectorDialog');
                },
                fieldValues: {
                    description: `Please describe the problem you're having or feature you'd like to see:\n\n\n`,
                    // 11711 is the field ID for the Feedback Labels field on Product Fabric.
                    // this is found by clicking "configure" on the field and inspecting the URL
                    customfield_11711: labels || [],
                    customfield_11712: `version: ${packageName}@${packageVersion} (${coreVersion})
              Browser: ${(0, $dXXBc.default)(navigator.userAgent)}
              OS: ${(0, $bdDwi.default)(navigator.userAgent, navigator.appVersion)}`
                },
                environment: {
                    'Editor Package': packageName,
                    'Editor Version': packageVersion,
                    'Editor Core Version': coreVersion,
                    sessionId: sessionId,
                    contentId: contentId,
                    tabId: tabId
                },
                priority: '1',
                components: '15306'
            };
            window.jQuery.ajax({
                url: $5023d7679998a80e$var$JIRA_ISSUE_COLLECTOR_URL,
                type: 'get',
                cache: true,
                dataType: 'script'
            });
        } else reject('jQuery is not defined');
    });
};
var $5023d7679998a80e$export$2e2bcd8739ae039 = $5023d7679998a80e$var$loadJiraCollectorDialogScript;
module.exports["default"] = $5023d7679998a80e$export$2e2bcd8739ae039;

});

parcelRegister("dXXBc", function(module, exports) {
/**
 * Inspired from:
 * https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
 */ const $8f3dbd94c7d32d73$var$getBrowserInfo = (nAgt)=>{
    let browserName;
    let browserVersion;
    let nameOffset;
    let verOffset;
    let index;
    // In Opera 15+, version is after "OPR/"
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera';
        browserVersion = nAgt.substring(verOffset + 4);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        // In older Opera, version is after "Opera" or after "Version"
        browserName = 'Opera';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 6);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // In MSIE, version is after "MSIE" in userAgent
        browserName = 'Microsoft Internet Explorer';
        browserVersion = nAgt.substring(verOffset + 5);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // In Chrome, version is after "Chrome"
        browserName = 'Chrome';
        browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // In Safari, version is after "Safari" or after "Version"
        browserName = 'Safari';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // In Firefox, version is after "Firefox"
        browserName = 'Firefox';
        browserVersion = nAgt.substring(verOffset + 8);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        browserVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) browserName = navigator.appName;
    } else {
        browserName = navigator.appName;
        browserVersion = '' + parseFloat(navigator.appVersion);
    }
    // trim the versionStr string at semicolon/space if present
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(';')) !== -1) browserVersion = browserVersion.substring(0, index);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(' ')) !== -1) browserVersion = browserVersion.substring(0, index);
    return `${browserName} ${browserVersion}`;
};
var $8f3dbd94c7d32d73$export$2e2bcd8739ae039 = $8f3dbd94c7d32d73$var$getBrowserInfo;
module.exports["default"] = $8f3dbd94c7d32d73$export$2e2bcd8739ae039;

});

parcelRegister("bdDwi", function(module, exports) {
/**
 * Inspired from:
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WIN16_REGEX = /Win16/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_95_REGEX = /(Windows 95|Win95|Windows_95)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_ME_REGEX = /(Win 9x 4.90|Windows ME)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_98_REGEX = /(Windows 98|Win98)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_CE_REGEX = /Windows CE/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_2000_REGEX = /(Windows NT 5.0|Windows 2000)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_XP_REGEX = /(Windows NT 5.1|Windows XP)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_SERVER_2003_REGEX = /Windows NT 5.2/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_VISTA_REGEX = /Windows NT 6.0/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_7_REGEX = /(Windows 7|Windows NT 6.1)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_8_1_REGEX = /(Windows 8.1|Windows NT 6.3)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_8_REGEX = /(Windows 8|Windows NT 6.2)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_NT_4_REGEX = /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$ANDROID_REGEX = /Android/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$OPEN_BSD_REGEX = /OpenBSD/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$SUN_OS_REGEX = /SunOS/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$LINUX_REGEX = /(Linux|X11)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$IOS_REGEX = /(iPhone|iPad|iPod)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$MAC_OS_X_REGEX = /Mac OS X/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$MAC_OS_REGEX = /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$QNX_REGEX = /QNX/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$UNIX_REGEX = /UNIX/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$BEOS_REGEX = /BeOS/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$OS2_REGEX = /OS\/2/;
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $8184c708b775f94f$var$SEARCH_BOT_REGEX = /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/;
/* eslint-enable require-unicode-regexp */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_TEST_REGEX = /Windows/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$WINDOWS_VERSION_REGEX = /Windows (.*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$MAC_OS_X_VERSION_REGEX = /Mac OS X (10[\.\_\d]+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$ANDROID_VERSION_REGEX = /Android ([\.\_\d]+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8184c708b775f94f$var$IOS_VERSION_REGEX = /OS (\d+)_(\d+)_?(\d+)?/;
const $8184c708b775f94f$var$getDeviceInfo = (nAgt, nVersion)=>{
    let os = '';
    let osVersion = '';
    const clientStrings = [
        {
            s: 'Windows 3.11',
            r: $8184c708b775f94f$var$WIN16_REGEX
        },
        {
            s: 'Windows 95',
            r: $8184c708b775f94f$var$WINDOWS_95_REGEX
        },
        {
            s: 'Windows ME',
            r: $8184c708b775f94f$var$WINDOWS_ME_REGEX
        },
        {
            s: 'Windows 98',
            r: $8184c708b775f94f$var$WINDOWS_98_REGEX
        },
        {
            s: 'Windows CE',
            r: $8184c708b775f94f$var$WINDOWS_CE_REGEX
        },
        {
            s: 'Windows 2000',
            r: $8184c708b775f94f$var$WINDOWS_2000_REGEX
        },
        {
            s: 'Windows XP',
            r: $8184c708b775f94f$var$WINDOWS_XP_REGEX
        },
        {
            s: 'Windows Server 2003',
            r: $8184c708b775f94f$var$WINDOWS_SERVER_2003_REGEX
        },
        {
            s: 'Windows Vista',
            r: $8184c708b775f94f$var$WINDOWS_VISTA_REGEX
        },
        {
            s: 'Windows 7',
            r: $8184c708b775f94f$var$WINDOWS_7_REGEX
        },
        {
            s: 'Windows 8.1',
            r: $8184c708b775f94f$var$WINDOWS_8_1_REGEX
        },
        {
            s: 'Windows 8',
            r: $8184c708b775f94f$var$WINDOWS_8_REGEX
        },
        {
            s: 'Windows NT 4.0',
            r: $8184c708b775f94f$var$WINDOWS_NT_4_REGEX
        },
        {
            s: 'Android',
            r: $8184c708b775f94f$var$ANDROID_REGEX
        },
        {
            s: 'Open BSD',
            r: $8184c708b775f94f$var$OPEN_BSD_REGEX
        },
        {
            s: 'Sun OS',
            r: $8184c708b775f94f$var$SUN_OS_REGEX
        },
        {
            s: 'Linux',
            r: $8184c708b775f94f$var$LINUX_REGEX
        },
        {
            s: 'iOS',
            r: $8184c708b775f94f$var$IOS_REGEX
        },
        {
            s: 'Mac OS X',
            r: $8184c708b775f94f$var$MAC_OS_X_REGEX
        },
        {
            s: 'Mac OS',
            r: $8184c708b775f94f$var$MAC_OS_REGEX
        },
        {
            s: 'QNX',
            r: $8184c708b775f94f$var$QNX_REGEX
        },
        {
            s: 'UNIX',
            r: $8184c708b775f94f$var$UNIX_REGEX
        },
        {
            s: 'BeOS',
            r: $8184c708b775f94f$var$BEOS_REGEX
        },
        {
            s: 'OS/2',
            r: $8184c708b775f94f$var$OS2_REGEX
        },
        {
            s: 'Search Bot',
            r: $8184c708b775f94f$var$SEARCH_BOT_REGEX
        }
    ];
    // eslint-disable-next-line guard-for-in
    for(const client in clientStrings){
        const clientObj = clientStrings[client];
        if (clientObj.r.test(nAgt)) {
            os = clientObj.s;
            break;
        }
    }
    let match;
    if ($8184c708b775f94f$var$WINDOWS_TEST_REGEX.test(os)) {
        match = $8184c708b775f94f$var$WINDOWS_VERSION_REGEX.exec(os);
        osVersion = match && match[1];
        os = 'Windows';
    }
    switch(os){
        case 'Mac OS X':
            match = $8184c708b775f94f$var$MAC_OS_X_VERSION_REGEX.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'Android':
            match = $8184c708b775f94f$var$ANDROID_VERSION_REGEX.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'iOS':
            match = $8184c708b775f94f$var$IOS_VERSION_REGEX.exec(nVersion);
            osVersion = match && match[1] + '.' + match[2] + '.' + (match[3] || 0);
    }
    return `${os} ${osVersion}`;
};
var $8184c708b775f94f$export$2e2bcd8739ae039 = $8184c708b775f94f$var$getDeviceInfo;
module.exports["default"] = $8184c708b775f94f$export$2e2bcd8739ae039;

});

parcelRegister("5UJW4", function(module, exports) {

var $3AVK5 = parcelRequire("3AVK5");


var $4GJ8D = parcelRequire("4GJ8D");


var $5k3so = parcelRequire("5k3so");


var $lH3ps = parcelRequire("lH3ps");

const $13291579996f6140$export$e3bfb926c9700157 = ()=>{
    const uploadHandlerReference = {
        current: null
    };
    return {
        name: 'imageUpload',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $lH3ps.stateKey).getState(editorState);
        },
        actions: {
            startUpload: ()=>(0, $3AVK5.insertActionForToolbar)(uploadHandlerReference)
        },
        pmPlugins () {
            return [
                {
                    name: 'imageUpload',
                    plugin: (0, $5k3so.createPlugin)(uploadHandlerReference)
                },
                {
                    name: 'imageUploadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $4GJ8D.default)(schema, featureFlags)
                }
            ];
        }
    };
};
module.exports["imageUploadPlugin"] = $13291579996f6140$export$e3bfb926c9700157;

});

parcelRegister("3AVK5", function(module, exports) {

var $18X7H = parcelRequire("18X7H");

const $0420815d46bf6eba$export$62f5bb5681401150 = (uploadHandlerReference)=>{
    return (state, dispatch)=>{
        if (!uploadHandlerReference.current) return false;
        uploadHandlerReference.current(undefined, (options)=>{
            (0, $18X7H.insertExternalImage)(options)(state, dispatch);
        });
        return true;
    };
};
module.exports["insertActionForToolbar"] = $0420815d46bf6eba$export$62f5bb5681401150;

});

parcelRegister("18X7H", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $fGspt = parcelRequire("fGspt");


var $acGbH = parcelRequire("acGbH");


var $lH3ps = parcelRequire("lH3ps");

const $c76b42de8fab93d0$export$d978a1cf00cd351b = (options)=>(state, dispatch)=>{
        const pluginState = (0, $lH3ps.stateKey).getState(state);
        if (!pluginState?.enabled || !options.src) return false;
        const mediaNode = (0, $fGspt.createExternalMediaNode)(options.src, state.schema);
        if (!mediaNode) return false;
        if (dispatch) dispatch((0, $bjg0G.safeInsert)(mediaNode, state.selection.$to.pos)(state.tr).scrollIntoView());
        return true;
    };
const $c76b42de8fab93d0$export$41b18c224f9e33da = (event)=>(state, dispatch)=>{
        const pluginState = (0, $lH3ps.stateKey).getState(state);
        if (pluginState && !pluginState.enabled) return false;
        if (dispatch) dispatch((0, $acGbH.startUpload)(event)(state.tr));
        return true;
    };
module.exports["insertExternalImage"] = $c76b42de8fab93d0$export$d978a1cf00cd351b;
module.exports["startImageUpload"] = $c76b42de8fab93d0$export$41b18c224f9e33da;

});

parcelRegister("fGspt", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $1ba1dcb04b865a16$export$d2ec7ab2b2a98746 = (state)=>{
    const { media: media } = state.schema.nodes;
    return state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type === media;
};
const $1ba1dcb04b865a16$export$262e43a15b79aeb7 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { $to: $to } = state.selection;
    if (mediaSingle) for(let d = $to.depth; d >= 0; d--){
        const index = $to.index(d);
        if ($to.node(d).canReplaceWith(index, index, mediaSingle)) return true;
    }
    return false;
};
const $1ba1dcb04b865a16$export$4747cb76ebf8d6df = (url, schema)=>{
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    if (!media || !mediaSingle) return null;
    const mediaNode = media.createChecked({
        type: 'external',
        url: url
    });
    return mediaSingle.createChecked({}, mediaNode);
};
module.exports["isMediaSelected"] = $1ba1dcb04b865a16$export$d2ec7ab2b2a98746;
module.exports["canInsertMedia"] = $1ba1dcb04b865a16$export$262e43a15b79aeb7;
module.exports["createExternalMediaNode"] = $1ba1dcb04b865a16$export$4747cb76ebf8d6df;

});

parcelRegister("acGbH", function(module, exports) {

var $lH3ps = parcelRequire("lH3ps");

const $3c2fb8e59da4b870$var$imageUploadAction = (tr, action)=>{
    return tr.setMeta((0, $lH3ps.stateKey), action);
};
const $3c2fb8e59da4b870$export$bacf5b3f68174df = (event)=>(tr)=>$3c2fb8e59da4b870$var$imageUploadAction(tr, {
            name: 'START_UPLOAD',
            event: event
        });
module.exports["startUpload"] = $3c2fb8e59da4b870$export$bacf5b3f68174df;

});

parcelRegister("lH3ps", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $1b5e06c33192f770$export$77b371d6becc8882 = new (0, $kCECX.PluginKey)('imageUploadPlugin');
module.exports["stateKey"] = $1b5e06c33192f770$export$77b371d6becc8882;

});

parcelRegister("4GJ8D", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");


var $91Kwo = parcelRequire("91Kwo");


var $fGspt = parcelRequire("fGspt");

// eslint-disable-next-line require-unicode-regexp
const $2c422a83fe005771$var$MARKDOWN_IMAGE_REGEX = /!\[(.*)\]\((\S+)\)$/;
function $2c422a83fe005771$export$568a7ed6897c4817(schema, featureFlags) {
    if (!schema.nodes.media || !schema.nodes.mediaSingle) return;
    // ![something](link) should convert to an image
    // eslint-disable-next-line require-unicode-regexp
    const imageRule = (0, $d8RhQ.createRule)($2c422a83fe005771$var$MARKDOWN_IMAGE_REGEX, (state, match, start, end)=>{
        const { schema: schema } = state;
        const attrs = {
            src: match[2],
            alt: match[1]
        };
        const node = (0, $fGspt.createExternalMediaNode)(attrs.src, schema);
        if (node) return state.tr.replaceWith(start, end, node);
        return null;
    });
    return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('image-upload', [
        imageRule
    ]));
}
var $2c422a83fe005771$export$2e2bcd8739ae039 = $2c422a83fe005771$export$568a7ed6897c4817;
module.exports["default"] = $2c422a83fe005771$export$2e2bcd8739ae039;

});

parcelRegister("5k3so", function(module, exports) {

var $4aSpR = parcelRequire("4aSpR");


var $kpCD8 = parcelRequire("kpCD8");


var $gl0Qn = parcelRequire("gl0Qn");


var $35hu8 = parcelRequire("35hu8");


var $fGspt = parcelRequire("fGspt");


var $18X7H = parcelRequire("18X7H");


var $lH3ps = parcelRequire("lH3ps");

/**
 * Microsoft Office includes a screenshot image when copying text content.
 *
 * This function determines whether or not we can ignore the image if it
 * came from MS Office. We do this by checking for
 *
 * - plain text
 * - HTML text which includes the MS Office namespace
 * - the number of files and the file name/type
 *
 * It is easy to manually verify this using by using Office on Mac
 * (or Excel if on Windows) and pasting into
 * https://evercoder.github.io/clipboard-inspector/
 *
 * Note: image content in Word is stored in the `text/html` portion
 * of the clipboard, not under `files` attachment like the screenshot.
 *
 * @returns boolean True if the paste event contains a screenshot from MS Office
 */ const $38d2cbdc4dfb9b70$var$hasScreenshotImageFromMSOffice = (ev)=>{
    const { clipboardData: clipboardData } = ev;
    if (!clipboardData || clipboardData.files.length !== 1) return false;
    const textPlain = !!clipboardData.getData('text/plain');
    const textHtml = clipboardData.getData('text/html');
    const isOfficeXMLNamespace = textHtml.includes('urn:schemas-microsoft-com:office:office');
    const file = clipboardData.files[0];
    const isImagePNG = file.type === 'image/png' && file.name === 'image.png';
    return isImagePNG && textPlain && isOfficeXMLNamespace;
};
const $38d2cbdc4dfb9b70$var$createReferenceEventFromEvent = (event)=>{
    if (!(0, $35hu8.isDragEvent)(event) && !(0, $gl0Qn.isClipboardEvent)(event)) return null;
    // Get files list and early exit if files is undefined
    const files = (0, $35hu8.isDragEvent)(event) ? event.dataTransfer?.files : event.clipboardData?.files;
    if (!files) return null;
    // Convert filelist into an array
    const filesArray = Array.from(files);
    // Creating a new DataTransfer object should remove any mutation that could be possible from the original event
    const dataTransfer = filesArray.reduce((acc, value)=>{
        acc.items.add(value);
        return acc;
    }, new DataTransfer());
    return {
        type: (0, $35hu8.isDragEvent)(event) ? 'drop' : 'paste',
        ...(0, $35hu8.isDragEvent)(event) && {
            dataTransfer: dataTransfer
        },
        ...(0, $gl0Qn.isClipboardEvent)(event) && {
            clipboardData: dataTransfer
        }
    };
};
const $38d2cbdc4dfb9b70$var$createDOMHandler = (pred, _eventName, uploadHandlerReference)=>(view, event)=>{
        if (!pred(event)) return false;
        const shouldUpload = !$38d2cbdc4dfb9b70$var$hasScreenshotImageFromMSOffice(event);
        const referenceEvent = $38d2cbdc4dfb9b70$var$createReferenceEventFromEvent(event);
        if (shouldUpload && referenceEvent) {
            event.preventDefault();
            event.stopPropagation();
            // Insert external image into document
            if (uploadHandlerReference.current) uploadHandlerReference.current(referenceEvent, (options)=>{
                (0, $18X7H.insertExternalImage)(options)(view.state, view.dispatch);
            });
            // Start image upload
            (0, $18X7H.startImageUpload)(referenceEvent)(view.state, view.dispatch);
        }
        return shouldUpload;
    };
const $38d2cbdc4dfb9b70$var$getNewActiveUpload = (tr, pluginState)=>{
    const meta = tr.getMeta((0, $lH3ps.stateKey));
    if (meta && meta.name === 'START_UPLOAD') return {
        event: meta.event
    };
    return pluginState.activeUpload;
};
const $38d2cbdc4dfb9b70$export$ae829ec7b2625219 = (uploadHandlerReference)=>({ dispatch: dispatch, providerFactory: providerFactory })=>{
        return new (0, $kpCD8.SafePlugin)({
            state: {
                init (_config, state) {
                    return {
                        active: false,
                        enabled: (0, $fGspt.canInsertMedia)(state),
                        hidden: !state.schema.nodes.media || !state.schema.nodes.mediaSingle
                    };
                },
                apply (tr, pluginState, _oldState, newState) {
                    const newActive = (0, $fGspt.isMediaSelected)(newState);
                    const newEnabled = (0, $fGspt.canInsertMedia)(newState);
                    const newActiveUpload = $38d2cbdc4dfb9b70$var$getNewActiveUpload(tr, pluginState);
                    if (newActive !== pluginState.active || newEnabled !== pluginState.enabled || newActiveUpload !== pluginState.activeUpload) {
                        const newPluginState = {
                            ...pluginState,
                            active: newActive,
                            enabled: newEnabled,
                            activeUpload: newActiveUpload
                        };
                        dispatch((0, $lH3ps.stateKey), newPluginState);
                        return newPluginState;
                    }
                    return pluginState;
                }
            },
            key: (0, $lH3ps.stateKey),
            view: ()=>{
                const handleProvider = async (name, provider)=>{
                    if (name !== 'imageUploadProvider' || !provider) return;
                    try {
                        const imageUploadProvider = await provider;
                        uploadHandlerReference.current = imageUploadProvider;
                    } catch (e) {
                        uploadHandlerReference.current = null;
                    }
                };
                providerFactory.subscribe('imageUploadProvider', handleProvider);
                return {
                    destroy () {
                        uploadHandlerReference.current = null;
                        providerFactory.unsubscribe('imageUploadProvider', handleProvider);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: $38d2cbdc4dfb9b70$var$createDOMHandler((0, $35hu8.isDroppedFile), 'atlassian.editor.image.drop', uploadHandlerReference),
                    paste: $38d2cbdc4dfb9b70$var$createDOMHandler((event)=>(0, $4aSpR.isPastedFile)(event), 'atlassian.editor.image.paste', uploadHandlerReference)
                }
            }
        });
    };
module.exports["createPlugin"] = $38d2cbdc4dfb9b70$export$ae829ec7b2625219;

});

parcelRegister("gl0Qn", function(module, exports) {
// Typeguard Function
const $f24dde8ef1f7ca9a$export$5694727fbed080b4 = (event)=>'clipboardData' in event;
module.exports["isClipboardEvent"] = $f24dde8ef1f7ca9a$export$5694727fbed080b4;

});

parcelRegister("35hu8", function(module, exports) {
// Typeguard Function
const $7d5912590dfa3583$export$fd4eab91eb7545c8 = (event)=>'dataTransfer' in event;
function $7d5912590dfa3583$export$6ca76751d014281f(rawEvent) {
    const e = rawEvent;
    if (!e.dataTransfer) return false;
    return Array.prototype.slice.call(e.dataTransfer.types).indexOf('Files') !== -1;
}
module.exports["isDragEvent"] = $7d5912590dfa3583$export$fd4eab91eb7545c8;
module.exports["isDroppedFile"] = $7d5912590dfa3583$export$6ca76751d014281f;

});

parcelRegister("HGu9Y", function(module, exports) {

var $7toP7 = parcelRequire("7toP7");


var $fClPf = parcelRequire("fClPf");


var $aOTwp = parcelRequire("aOTwp");


var $gYiLB = parcelRequire("gYiLB");

const $7545ccce0e49e308$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $7toP7.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $aOTwp.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $aOTwp.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $aOTwp.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $gYiLB.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $7545ccce0e49e308$export$171e576bb7c729fa;

});

parcelRegister("aOTwp", function(module, exports) {

var $iX5Ka = parcelRequire("iX5Ka");

var $krYZG = parcelRequire("krYZG");


var $9WBFV = parcelRequire("9WBFV");


var $fClPf = parcelRequire("fClPf");


var $fanJz = parcelRequire("fanJz");


var $eFZrs = parcelRequire("eFZrs");

const $8ccb9806c3a6424a$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $8ccb9806c3a6424a$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $9WBFV.toggleBlockMark)(indentation, getNewIndentationAttrs, $8ccb9806c3a6424a$export$54db194d337db321)(state, dispatch);
    };
}
function $8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $fanJz.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $8ccb9806c3a6424a$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $eFZrs.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $8ccb9806c3a6424a$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getIndentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $8ccb9806c3a6424a$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getOutdentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $8ccb9806c3a6424a$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $9WBFV.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $8ccb9806c3a6424a$export$54db194d337db321;
module.exports["getIndentCommand"] = $8ccb9806c3a6424a$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $8ccb9806c3a6424a$export$620b2a1f10eb3a5f;

});

parcelRegister("fanJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd1315d32deb815$export$2e2bcd8739ae039);
function $7dd1315d32deb815$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("eFZrs", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

var $iX5Ka = parcelRequire("iX5Ka");

const $1736d54b67a5c25e$var$indentTypes = {
    paragraph: (0, $iX5Ka.INDENT_TYPE).PARAGRAPH,
    heading: (0, $iX5Ka.INDENT_TYPE).HEADING
};
function $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $1736d54b67a5c25e$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $1736d54b67a5c25e$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $1736d54b67a5c25e$export$4f15b45384b61427;

});

parcelRegister("gYiLB", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $b9BvQ = parcelRequire("b9BvQ");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");


var $aOTwp = parcelRequire("aOTwp");

function $1df8e650ca8df6e6$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $aOTwp.getIndentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.outdent)), (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $b9BvQ.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $bjg0G.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
var $1df8e650ca8df6e6$export$2e2bcd8739ae039 = $1df8e650ca8df6e6$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $1df8e650ca8df6e6$export$e832373cff8dec22;

});

parcelRegister("63nNo", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $44d36964bbf6a1db$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('maxContentSizePlugin');
function $44d36964bbf6a1db$export$ae829ec7b2625219(dispatch, maxContentSize) {
    if (!maxContentSize) return;
    let maxContentSizeReached = false;
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    maxContentSizeReached: false
                }),
            apply (tr, state) {
                const result = tr.doc && tr.doc.nodeSize > maxContentSize - 1;
                return {
                    maxContentSizeReached: result
                };
            }
        },
        key: $44d36964bbf6a1db$export$18d4026d1ea86bb1,
        filterTransaction (tr) {
            const result = tr.doc && tr.doc.nodeSize > maxContentSize;
            if (result || result !== maxContentSizeReached) dispatch($44d36964bbf6a1db$export$18d4026d1ea86bb1, {
                maxContentSizeReached: result
            });
            maxContentSizeReached = result;
            return !result;
        }
    });
}
const $44d36964bbf6a1db$var$maxContentSizePlugin = ({ config: maxContentSize, api: api })=>{
    return {
        name: 'maxContentSize',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return $44d36964bbf6a1db$export$18d4026d1ea86bb1.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'maxContentSize',
                    plugin: ({ dispatch: dispatch })=>$44d36964bbf6a1db$export$ae829ec7b2625219(dispatch, maxContentSize)
                }
            ];
        }
    };
};
var $44d36964bbf6a1db$export$2e2bcd8739ae039 = $44d36964bbf6a1db$var$maxContentSizePlugin;
module.exports["default"] = $44d36964bbf6a1db$export$2e2bcd8739ae039;

});

parcelRegister("jNalm", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $6pnwK = parcelRequire("6pnwK");


var $44cyU = parcelRequire("44cyU");

const $c2f1117a8d6f30fe$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $44cyU.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $c2f1117a8d6f30fe$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $6pnwK.analyticsEventKey), $c2f1117a8d6f30fe$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $c2f1117a8d6f30fe$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$c2f1117a8d6f30fe$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$c2f1117a8d6f30fe$var$isEmptyAtCursor($cursor);
}
function $c2f1117a8d6f30fe$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $c2f1117a8d6f30fe$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $krYZG.ACTION).STOPPED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        }
    });
const $c2f1117a8d6f30fe$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$c2f1117a8d6f30fe$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });
module.exports["saveOnEnterPlugin"] = $c2f1117a8d6f30fe$export$8ba1e5775ae443a6;

});

parcelRegister("fxjEF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $c0Rae = parcelRequire("c0Rae");

var $5Z7gB = parcelRequire("5Z7gB");


var $3k5Tv = parcelRequire("3k5Tv");


var $5I78X = parcelRequire("5I78X");


var $ieeJu = parcelRequire("ieeJu");


var $2A6x2 = parcelRequire("2A6x2");


var $hzCKL = parcelRequire("hzCKL");


var $i57XD = parcelRequire("i57XD");


var $3HRZd = parcelRequire("3HRZd");


var $4bFib = parcelRequire("4bFib");


var $8NL8R = parcelRequire("8NL8R");


var $7KArf = parcelRequire("7KArf");


var $aXxPN = parcelRequire("aXxPN");


var $hpTl5 = parcelRequire("hpTl5");


var $6P5kj = parcelRequire("6P5kj");


var $jEkKX = parcelRequire("jEkKX");


var $7dsNj = parcelRequire("7dsNj");

/**
 * EDITOR-6929 / PR-G: Guard contentComponent rendering.
 * When `hasSyncedBlocks` is false return null
 * to avoid mounting SyncBlockRefresher, DeleteConfirmationModal, and Flag —
 * their hooks (useSharedPluginStateWithSelector) would execute selectors on
 * every transaction for no benefit on the ~99.98% of pages with zero synced
 * blocks.
 */ const $5d3a78d9c2d2a5c7$var$LazySyncedBlockUI = ({ syncBlockStore: syncBlockStoreManager, api: api, editorView: editorView, onFeedbackPromptShown: onFeedbackPromptShown, onGiveFeedback: onGiveFeedback })=>{
    const hasSyncBlocks = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'syncedBlock'
    ], (states)=>states.syncedBlockState?.hasSyncedBlocks);
    if (!hasSyncBlocks) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEkKX.SyncBlockRefresher), {
                syncBlockStoreManager: syncBlockStoreManager,
                api: api
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8NL8R.DeleteConfirmationModal), {
                syncBlockStoreManager: syncBlockStoreManager,
                api: api,
                editorView: editorView
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7KArf.Flag), {
                api: api,
                onFeedbackPromptShown: onFeedbackPromptShown,
                onGiveFeedback: onGiveFeedback
            })
        ]
    });
};
const $5d3a78d9c2d2a5c7$export$4567b5886e253c5a = ({ config: config, api: api })=>{
    const refs = {};
    const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
    const syncBlockStore = new (0, $5I78X.SyncBlockStoreManager)(config?.syncBlockDataProvider, viewMode, config?.__livePage);
    syncBlockStore.setFireAnalyticsEvent(api?.analytics?.actions?.fireAnalyticsEvent);
    // --- Memoized getSharedState (EDITOR-6929 / PR-F) ---
    // Cache the last returned shared state object. On each call, perform a
    // shallow comparison of all fields against the cached value. If nothing
    // changed, return the cached reference so SharedStateAPI subscribers
    // (React components) skip re-rendering.
    let cachedSharedState;
    api?.blockMenu?.actions.registerBlockMenuComponents((0, $4bFib.getBlockMenuComponents)(api, config?.enableSourceCreation ?? false));
    api?.toolbar?.actions.registerComponents((0, $7dsNj.getToolbarComponents)(api, config?.enableSourceCreation ?? false));
    return {
        name: 'syncedBlock',
        nodes () {
            return [
                {
                    name: 'syncBlock',
                    node: (0, $5Z7gB.syncBlock)
                },
                {
                    name: 'bodiedSyncBlock',
                    node: (0, $c0Rae.bodiedSyncBlock)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'syncedBlockPlugin',
                    plugin: (params)=>(0, $i57XD.createPlugin)(config, params, syncBlockStore, api)
                },
                {
                    name: 'menuAndToolbarExperiencesPlugin',
                    plugin: ()=>(0, $3HRZd.getMenuAndToolbarExperiencesPlugin)({
                            refs: refs,
                            dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                        })
                }
            ];
        },
        commands: {
            copySyncedBlockReferenceToClipboard: (inputMethod)=>(0, $hzCKL.copySyncedBlockReferenceToClipboardEditorCommand)(syncBlockStore, inputMethod, api, config?.__livePage),
            insertSyncedBlock: (inputMethod)=>({ tr: tr })=>{
                    if (!config?.enableSourceCreation) return null;
                    return (0, $hzCKL.createSyncedBlock)({
                        tr: tr,
                        syncBlockStore: syncBlockStore,
                        fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
                        inputMethod: inputMethod
                    }) || null;
                }
        },
        actions: {
            flushBodiedSyncBlocks: ()=>{
                return (0, $2A6x2.flushBodiedSyncBlocks)(syncBlockStore);
            },
            flushSyncedBlocks: ()=>{
                return (0, $2A6x2.flushSyncBlocks)(syncBlockStore);
            },
            discardUnpublishedSyncBlocks: ()=>{
                return (0, $2A6x2.discardUnpublishedSyncBlocks)(syncBlockStore);
            }
        },
        pluginsOptions: {
            quickInsert: (0, $hpTl5.getQuickInsertConfig)(config, api, syncBlockStore),
            floatingToolbar: (state, intl)=>{
                // When the experiment is ON and the document has no synced blocks,
                // skip the toolbar config entirely to avoid the per-selection-change
                // cost of findSyncBlockOrBodiedSyncBlock (EDITOR-6931).
                if (!(0, $i57XD.syncedBlockPluginKey).getState(state)?.hasSyncedBlocks) return undefined;
                return (0, $aXxPN.getToolbarConfig)(state, intl, api, syncBlockStore, config?.__livePage, config?.onGiveFeedback);
            }
        },
        contentComponent: ({ containerElement: containerElement, wrapperElement: wrapperElement, popupsMountPoint: popupsMountPoint, editorView: editorView })=>{
            refs.containerElement = containerElement || undefined;
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6P5kj.SourceSyncBlockPlaceholder), {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($5d3a78d9c2d2a5c7$var$LazySyncedBlockUI, {
                        syncBlockStore: syncBlockStore,
                        api: api,
                        editorView: editorView,
                        onFeedbackPromptShown: config?.onFeedbackPromptShown,
                        onGiveFeedback: config?.onGiveFeedback
                    })
                ]
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const pluginState = (0, $i57XD.syncedBlockPluginKey).getState(editorState);
            const { activeFlag: activeFlag, syncBlockStore: currentSyncBlockStore, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, retryCreationPosMap: retryCreationPosMap, hasSyncedBlocks: hasSyncedBlocks, hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges } = pluginState;
            // --- EDITOR-6929 / PR-F: return a stable reference when all
            // fields are unchanged to prevent unnecessary React re-renders. ---
            if (cachedSharedState !== undefined && cachedSharedState.activeFlag === activeFlag && cachedSharedState.syncBlockStore === currentSyncBlockStore && cachedSharedState.bodiedSyncBlockDeletionStatus === bodiedSyncBlockDeletionStatus && cachedSharedState.retryCreationPosMap === retryCreationPosMap && cachedSharedState.hasSyncedBlocks === hasSyncedBlocks && cachedSharedState.hasUnsavedBodiedSyncBlockChanges === hasUnsavedBodiedSyncBlockChanges) return cachedSharedState;
            const nextSharedState = {
                activeFlag: activeFlag,
                syncBlockStore: currentSyncBlockStore,
                bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus,
                retryCreationPosMap: retryCreationPosMap,
                hasSyncedBlocks: hasSyncedBlocks,
                hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges
            };
            cachedSharedState = nextSharedState;
            return nextSharedState;
        },
        // Destroy the SyncBlockStoreManager on editor unmount to cancel
        // pending timers, subscriptions, and in-flight fetches.
        destroy () {
            syncBlockStore.destroy();
        }
    };
};
module.exports["syncedBlockPlugin"] = $5d3a78d9c2d2a5c7$export$4567b5886e253c5a;

});

parcelRegister("5I78X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jv11C = parcelRequire("jv11C");


var $3xsB6 = parcelRequire("3xsB6");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cduI2 = parcelRequire("cduI2");


var $d04Ge = parcelRequire("d04Ge");


var $kaATz = parcelRequire("kaATz");


var $1MDPE = parcelRequire("1MDPE");

class $979f07693c6de5f0$export$d353efb45bc662f4 {
    isSyncBlock(node) {
        return this.sourceSyncBlockStoreManager.isSourceBlock(node) || this.referenceSyncBlockStoreManager.isReferenceBlock(node);
    }
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) return this.getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock);
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = (response.references ?? []).map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $3xsB6.getProductFromSourceAri)(reference.documentAri), reference.hasAccess);
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.fetchReferencesErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $cduI2.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $cduI2.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    async getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock) {
        // No reference found
        if (isSourceSyncBlock) {
            // Verify that a reference sync block for this specific source actually
            // exists on the current page by checking if the reference manager has
            // an active subscription for the derived reference resourceId.
            const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
            const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
            if (hasUnregisteredReferenceOnPage) {
                // This is current page data. It is the same for data for source and reference
                const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                const references = [];
                if (sourceSyncBlockData) {
                    const sourceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: true
                    };
                    const referenceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: false
                    };
                    references.push(sourceSyncBlockReference, referenceSyncBlockReference);
                }
                this.fetchReferencesExperience?.success();
                return {
                    references: references
                };
            }
            // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
            this.fetchReferencesExperience?.success();
            return {
                references: []
            };
        }
        // Though no references registered yet for this reference sync block,
        // still show the source and the current page itself since they are known
        // but not saved yet.
        const references = [];
        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
        if (sourceSyncBlockData) references.push({
            ...sourceSyncBlockData,
            onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
            hasAccess: true,
            isSource: true
        });
        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
        if (currentPageData) references.push({
            ...currentPageData,
            onSameDocument: true,
            hasAccess: true,
            isSource: false
        });
        if (references.length === 0) {
            this.fetchReferencesExperience?.failure({
                reason: 'No references found for reference synced block'
            });
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
        this.fetchReferencesExperience?.success();
        return {
            references: references
        };
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read its current in memory cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $1MDPE.SourceSyncBlockStoreManager)(dataProvider, viewMode, isLivePage);
        this.referenceSyncBlockStoreManager = new (0, $kaATz.ReferenceSyncBlockStoreManager)(dataProvider, viewMode);
        this.dataProvider = dataProvider;
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled(true);
    }
}
const $979f07693c6de5f0$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $979f07693c6de5f0$export$d353efb45bc662f4(dataProvider);
};
const $979f07693c6de5f0$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $cozmU.useMemo)(()=>{
        return $979f07693c6de5f0$var$createSyncBlockStoreManager(dataProvider);
    }, [
        dataProvider
    ]);
    const prevFireAnalyticsEventRef = (0, $cozmU.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    // Destroy the SyncBlockStoreManager when:
    //   (a) the component unmounts — manager is fully cleaned up, or
    //   (b) dataProvider changes — the old manager (now orphaned by the
    //       useMemo recalculation) is destroyed before the new one takes over.
    //
    // Without this, orphaned managers leak timers, GQL subscriptions, and
    // in-flight fetches indefinitely. The effect dep is `syncBlockStoreManager`
    // (the useMemo result) — it changes identity precisely when dataProvider
    // changes, triggering the cleanup for the old instance.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            syncBlockStoreManager.destroy();
        };
    }, [
        syncBlockStoreManager
    ]);
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $979f07693c6de5f0$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $979f07693c6de5f0$export$d95b04bc16414394;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("cduI2", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $6NW7h = parcelRequire("6NW7h");

const $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION = 30000;
const $5b2ece5cdbe51ebe$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $krYZG.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $krYZG.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $5b2ece5cdbe51ebe$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $5b2ece5cdbe51ebe$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $5b2ece5cdbe51ebe$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $5b2ece5cdbe51ebe$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $5b2ece5cdbe51ebe$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $5b2ece5cdbe51ebe$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $5b2ece5cdbe51ebe$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $5b2ece5cdbe51ebe$export$3ba8782eb93c9adf;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("kaATz", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $jv11C = parcelRequire("jv11C");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cduI2 = parcelRequire("cduI2");


var $8kkvD = parcelRequire("8kkvD");


var $d04Ge = parcelRequire("d04Ge");


var $f9GoL = parcelRequire("f9GoL");


var $3ZV9H = parcelRequire("3ZV9H");


var $8d6F6 = parcelRequire("8d6F6");


var $dWaXQ = parcelRequire("dWaXQ");

const $300c2e48dc416b36$var$CACHE_KEY_PREFIX = 'sync-block-data-';
const $300c2e48dc416b36$var$ENTITY_NOT_FOUND_MAX_RETRIES = 3;
const $300c2e48dc416b36$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS = 2000;
// Grace period before a cache entry is removed after the last subscriber
// unsubscribes. Guards are
// re-checked at fire time; if any are positive, the timer is rescheduled.
const $300c2e48dc416b36$var$CACHE_DELETION_GRACE_PERIOD_MS = 30000;
// Max reschedules before force-deleting with an analytics event (~5 min).
const $300c2e48dc416b36$var$CACHE_DELETION_MAX_RESCHEDULES = 10;
class $300c2e48dc416b36$export$fb04276dca31302e {
    isReferenceBlock(node) {
        return node.type.name === 'syncBlock';
    }
    /**
   * Whether the async data provider is wired and the manager is not torn down.
   * Consumers gate fetch/subscribe on this to avoid a false `Data provider not
   * set` fetch error (EDITOR-7860). The `isDestroyed` check covers managers
   * orphaned mid-flight during an async provider swap, where `dataProvider`
   * alone is insufficient.
   */ hasDataProvider() {
        return !this.isDestroyed && !!this.dataProvider;
    }
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $cduI2.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $cduI2.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $cduI2.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $d04Ge.createSyncBlockNode)('', resourceId);
        const providerData = this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (providerData) // Initial provider cache data can come from SSR/prefetch and bypass updateCache(),
        // so normalize legacy reference payloads here before rendering.
        return this.normalizeReferenceData(providerData);
        return this.getFromSessionCache(resourceId);
    }
    normalizeReferenceData(syncBlock) {
        if (!syncBlock.data?.content?.length) return syncBlock;
        const content = (0, $d04Ge.normalizeSyncBlockJSONContent)(syncBlock.data.content);
        if (content === syncBlock.data.content) return syncBlock;
        return {
            ...syncBlock,
            data: {
                ...syncBlock.data,
                content: content
            }
        };
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $3ZV9H.syncBlockInMemorySessionCache).setItem(`${$300c2e48dc416b36$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $3ZV9H.syncBlockInMemorySessionCache).getItem(`${$300c2e48dc416b36$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            // Session cache entries written before this sanitizer existed may still include
            // annotation marks or panel_c1 nodes, so keep this read-time safety net for legacy data.
            return this.normalizeReferenceData(JSON.parse(raw));
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType, issueType: issueType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                productType: product,
                issueType: issueType
            });
            // Derive once per call so we don't re-parse on every analytics event below.
            // `product` from cached data is preferred when available; fall back to parsing
            // the resourceId.
            const sourceProduct = product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId, sourceProduct));
                return Promise.resolve(undefined);
            }
            this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)('No source info returned', resourceId, sourceProduct));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                else {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                    this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)('Missing title or url', resourceId, sourceProduct));
                }
                return sourceInfo;
            }).catch((error)=>{
                this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message, resourceId, sourceProduct));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        this.fetchExperience?.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during prefetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied during prefetch'
            });
            else this.fetchExperience?.success();
        } catch (error) {
            this.fetchExperience?.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $79ir6.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) // EDITOR-7860: tag the throw so catch sites can suppress the benign
        // not-ready/torn-down case.
        throw new (0, $79ir6.ProviderNotReadyError)();
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) this.fetchExperience?.failure({
            reason: 'Unexpected error during fetch'
        });
        else if (hasExpectedError) this.fetchExperience?.abort({
            reason: 'Expected error: NotFound or PermissionDenied'
        });
        else this.fetchExperience?.success();
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                const payload = syncBlockInstance.error?.reason || syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id';
                // No resourceId means we cannot derive a sourceProduct here; intentionally omit.
                // Classify on the structured `type` first, falling back to the free-text
                // `reason`/payload (EDITOR-7862).
                this.fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(payload, undefined, undefined, (0, $916Gd.buildFetchErrorAttribution)(syncBlockInstance.error?.type || syncBlockInstance.error?.reason || payload, syncBlockInstance.error?.statusCode)));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $8kkvD.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            // Clear retry tracking on successful fetch — block has been created
            if (!syncBlockInstance.error && this.entityNotFoundRetryCount.has(syncBlockInstance.resourceId)) {
                const timer = this.entityNotFoundRetryTimers.get(syncBlockInstance.resourceId);
                if (timer) {
                    clearTimeout(timer);
                    this.entityNotFoundRetryTimers.delete(syncBlockInstance.resourceId);
                }
                this.entityNotFoundRetryCount.delete(syncBlockInstance.resourceId);
            }
            if (syncBlockInstance.error) {
                // Skip error analytics when EntityNotFound will be retried, to avoid
                // inflating error-rate metrics with expected transient failures
                const isRetryingEntityNotFound = syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).EntityNotFound && (this.entityNotFoundRetryCount.get(syncBlockInstance.resourceId) ?? 0) < $300c2e48dc416b36$var$ENTITY_NOT_FOUND_MAX_RETRIES;
                if (!isRetryingEntityNotFound) // Classify on the structured `type` (a `SyncBlockError` enum value) first,
                // falling back to the free-text `reason` so source-state/permission strings
                // are still bucketed (EDITOR-7862). The emitted `error` attribute is unchanged.
                this.fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $916Gd.buildFetchErrorAttribution)(syncBlockInstance.error.type || syncBlockInstance.error.reason, syncBlockInstance.error.statusCode)));
                if (syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).EntityNotFound) {
                    // Schedule a retry for EntityNotFound — the source block may be in
                    // the process of being created by a collaborator (race condition
                    // between NCS propagation and Block Service createBlock call).
                    this.scheduleEntityNotFoundRetry(syncBlockInstance.resourceId);
                    if (!isRetryingEntityNotFound) hasUnexpectedError = true;
                } else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.fireAnalyticsEvent?.((0, $916Gd.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        // If the cache entry was deleted while the source-info request was
        // in flight, fire an analytics event so the race is observable.
        if (!existingSyncBlock) {
            this.fireAnalyticsEvent?.((0, $916Gd.sourceInfoOrphanedPayload)(resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), {
                hasPendingDeletion: this.pendingCacheDeletions.has(resourceId),
                hasSubscribers: this._subscriptionManager.getSubscriptions().has(resourceId)
            }));
            (0, $jv11C.logException)(new Error('updateCacheWithSourceInfo: cache entry missing for resource'), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/orphaned-source-info'
            });
            return;
        }
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType,
                issueType: sourceInfo?.issueType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const sanitizedSyncBlock = this.normalizeReferenceData(syncBlock);
        const { resourceId: resourceId } = sanitizedSyncBlock;
        if (resourceId) {
            this.dataProvider?.updateCache({
                [resourceId]: sanitizedSyncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, sanitizedSyncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        const syncBlockNode = (0, $d04Ge.createSyncBlockNode)('', resourceId);
        return this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    deleteFromCache(resourceId) {
        this.dataProvider?.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
        // Evict in-flight source-info promise and reset reschedule counter
        // so a stale resolution can't silently merge into a re-fetched entry.
        this.syncBlockSourceInfoRequests.delete(resourceId);
        this.cacheDeletionRescheduleCounts.delete(resourceId);
    }
    /**
   * Returns true if the cache entry for `resourceId` is safe to delete:
   * no active subscribers, no in-flight source-info request, and no
   * queued/in-flight batch fetch.
   */ canDeleteCache(resourceId) {
        if (this._subscriptionManager.getSubscriptions().has(resourceId)) return false;
        if (this.syncBlockSourceInfoRequests.has(resourceId)) return false;
        if (this._batchFetcher.hasPendingFetch(resourceId)) return false;
        return true;
    }
    /**
   * Schedules cache deletion for `resourceId` after the grace period
   * Called when the last
   * subscriber unsubscribes. Guards are re-checked at fire time; if any
   * are positive the timer is rescheduled up to MAX_RESCHEDULES times.
   */ scheduleCacheDeletion(resourceId) {
        if (this.isDestroyed) return;
        // Cancel any existing timer \u2014 restart the grace period \u2014 but DO NOT
        // reset the reschedule counter. The counter is reset only by
        // `cancelPendingCacheDeletion` (called when a real subscriber returns)
        // or when the cache is actually deleted.
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        const timer = setTimeout(()=>{
            // Guard against timer callback running after destroy. clearTimeout
            // is synchronous so this should be unreachable in practice, but
            // belt-and-braces.
            if (this.isDestroyed) return;
            this.pendingCacheDeletions.delete(resourceId);
            this.onCacheDeletionTimerFire(resourceId);
        }, $300c2e48dc416b36$var$CACHE_DELETION_GRACE_PERIOD_MS);
        this.pendingCacheDeletions.set(resourceId, timer);
    }
    /**
   * Cancels any pending cache deletion timer for `resourceId` and resets the
   * reschedule counter. Called
   * when a new subscriber arrives.
   */ cancelPendingCacheDeletion(resourceId) {
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // Subscribers returning resets the reschedule counter \u2014 the resource is
        // active again.
        this.cacheDeletionRescheduleCounts.delete(resourceId);
    }
    /** Returns whether a cache deletion timer is pending for `resourceId`. */ hasPendingCacheDeletion(resourceId) {
        return this.pendingCacheDeletions.has(resourceId);
    }
    onCacheDeletionTimerFire(resourceId) {
        if (this.canDeleteCache(resourceId)) {
            // `deleteFromCache` resets the reschedule counter.
            this.deleteFromCache(resourceId);
            return;
        }
        const currentCount = this.cacheDeletionRescheduleCounts.get(resourceId) ?? 0;
        if (currentCount >= $300c2e48dc416b36$var$CACHE_DELETION_MAX_RESCHEDULES) {
            // Stuck guard — force deletion to prevent unbounded memory growth and
            // fire analytics so the stuck state is visible in production telemetry.
            //
            // NOTE: If active React subscribers still exist at force-delete time
            // (e.g. an in-flight batch fetch never settled), the cache entry is
            // removed without notifying subscribers. Those components will
            // continue to render with stale data until their next re-render
            // triggers a new batch fetch — typically within ~1 frame. We accept
            // this brief stale window in exchange for bounded memory growth.
            this.fireAnalyticsEvent?.((0, $916Gd.cacheDeletionForcedPayload)(currentCount, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            (0, $jv11C.logException)(new Error(`Cache deletion forced after ${currentCount} reschedules \u{2014} stuck in-flight guard`), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/cache-deletion-forced'
            });
            // `deleteFromCache` resets the reschedule counter.
            this.deleteFromCache(resourceId);
            // If subscribers still exist, kick off a fresh fetch so they get
            // fresh data on the next batch tick instead of holding stale data
            // indefinitely.
            if (this._subscriptionManager.getSubscriptions().has(resourceId)) this.debouncedBatchedFetchSyncBlocks(resourceId);
            return;
        }
        this.cacheDeletionRescheduleCounts.set(resourceId, currentCount + 1);
        this.scheduleCacheDeletion(resourceId);
    }
    /**
   * Schedules a delayed retry for a block that returned EntityNotFound.
   * The block may be in the process of being created by a collaborator —
   * the NCS transaction propagates the bodiedSyncBlock ADF node before
   * the Block Service createBlock call completes.
   */ scheduleEntityNotFoundRetry(resourceId) {
        const currentRetries = this.entityNotFoundRetryCount.get(resourceId) ?? 0;
        if (currentRetries >= $300c2e48dc416b36$var$ENTITY_NOT_FOUND_MAX_RETRIES) // Max retries exceeded — keep count at max so future calls immediately exit
        // (don't delete — that would reset the counter and allow unbounded retry waves)
        return;
        // If a timer is already pending, don't schedule another one — let the
        // existing timer fire. This prevents rapid EntityNotFound responses from
        // exhausting the retry budget through cancellations without any actual
        // fetch completing.
        if (this.entityNotFoundRetryTimers.has(resourceId)) return;
        const delay = $300c2e48dc416b36$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS * Math.pow(2, currentRetries);
        const timer = setTimeout(()=>{
            this.entityNotFoundRetryTimers.delete(resourceId);
            // If no active subscriptions remain for this block, clean up and skip
            const subscriptions = this._subscriptionManager.getSubscriptions().get(resourceId);
            if (!subscriptions || Object.keys(subscriptions).length === 0) {
                this.entityNotFoundRetryCount.delete(resourceId);
                return;
            }
            // Increment count only when the timer fires, not when scheduled
            this.entityNotFoundRetryCount.set(resourceId, currentRetries + 1);
            // Clear the error from cache so fetchSyncBlocksData doesn't skip it
            const cached = this.getFromCache(resourceId);
            if (cached?.error?.type === (0, $79ir6.SyncBlockError).EntityNotFound) this.deleteFromCache(resourceId);
            // Trigger a re-fetch via the batch fetcher
            this.debouncedBatchedFetchSyncBlocks(resourceId);
        }, delay);
        this.entityNotFoundRetryTimers.set(resourceId, timer);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            // EDITOR-7860: benign not-ready/torn-down case — suppress both the
            // exception-tracker log and the analytics event (checked first so the
            // benign case stays fully silent).
            if ((0, $79ir6.isProviderNotReadyError)(error)) return ()=>{};
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildFetchErrorAttribution)(error.message)));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        return this.getFromCache(resourceId)?.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    /**
   * The provider options currently supplied by the host. Safe to read during
   * render - it notifies nobody.
   */ getProviderOptions() {
        return this._providerFactoryManager.getProviderOptions();
    }
    /**
   * Applies the latest providers to the cached factory. Notifies subscribers, so
   * call from an effect rather than during render.
   */ syncProviders(resourceId) {
        this._providerFactoryManager.syncProviders(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (this.viewMode === 'view') // Reference flushes are only meaningful while editing. Treat view-mode flush attempts as
        // gated no-op successes so lifecycle/teardown calls do not report false save failures.
        return true;
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // Note that we will always flush at least once when editor starts
            // This is useful for eventual consistency between the editor and the BE.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $916Gd.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document', undefined, undefined, (0, $916Gd.buildErrorAttribution)(updateResult.error, updateResult.statusCode)));
            }
        } catch (error) {
            success = false;
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.saveExperience?.failure({
                reason: error.message
            });
            // No `resourceId` available in this catch — sourceProduct is intentionally omitted.
            // No structured SyncBlockError/status here, so the attribution `reason` falls back
            // to `unknown`.
            this.fireAnalyticsEvent?.((0, $916Gd.updateReferenceErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildErrorAttribution)()));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else {
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                this.saveExperience?.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        // Mark destroyed first so in-flight timer callbacks can early-return.
        this.isDestroyed = true;
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        // Cancel any pending EntityNotFound retry timers
        this.entityNotFoundRetryTimers.forEach((timer)=>clearTimeout(timer));
        this.entityNotFoundRetryTimers.clear();
        this.entityNotFoundRetryCount.clear();
        // Cancel pending cache deletion timers.
        this.pendingCacheDeletions.forEach((timer)=>clearTimeout(timer));
        this.pendingCacheDeletions.clear();
        this.cacheDeletionRescheduleCounts.clear();
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        this.dataProvider?.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
    // `destroy()` is wired to React component unmount via
    // `useMemoizedSyncBlockStoreManager`. Let the in-memory session cache age
    // out naturally instead of clearing it during a view-mode transition.
    }
    constructor(dataProvider, viewMode){
        this.viewMode = void 0;
        this.dataProvider = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track the setTimeout handle for queued flush so we can cancel it on destroy
        this.queuedFlushTimeout = void 0;
        // Track retry attempts for EntityNotFound errors (block may be in the process of being created)
        this.entityNotFoundRetryCount = new Map();
        this.entityNotFoundRetryTimers = new Map();
        // Pending cache deletion timers keyed by resourceId. Cancelled when a subscriber re-attaches.
        this.pendingCacheDeletions = new Map();
        // Reschedule counter per resource — reset on actual deletion or re-subscribe.
        this.cacheDeletionRescheduleCounts = new Map();
        // Set by destroy() so in-flight timer callbacks can early-return.
        this.isDestroyed = false;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this._subscriptionManager = void 0;
        this._providerFactoryManager = void 0;
        this._batchFetcher = void 0;
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $dWaXQ.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            },
            // Delegate cache lifecycle to the store manager so guards can be
            // checked atomically.
            scheduleCacheDeletion: (rid)=>this.scheduleCacheDeletion(rid),
            cancelPendingCacheDeletion: (rid)=>this.cancelPendingCacheDeletion(rid)
        });
        this._providerFactoryManager = new (0, $8d6F6.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $f9GoL.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            // EDITOR-7860: skip + re-queue fetches while not ready / torn down.
            isProviderReady: ()=>this.hasDataProvider()
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache(this.dataProvider?.getNodeDataCacheKeys());
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $300c2e48dc416b36$export$fb04276dca31302e;

});

parcelRegister("8kkvD", function(module, exports) {

var $6oMcp = parcelRequire("6oMcp");


var $79ir6 = parcelRequire("79ir6");

const $91813f771f17ec33$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $79ir6.SyncBlockError).NotFound || newResult.error?.type === (0, $79ir6.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            sourceSubType: $91813f771f17ec33$var$mergeSubType(oldResult, newResult),
            onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined,
            issueType: newResult.data?.issueType || oldResult.data?.issueType || undefined
        }
    };
};
const $91813f771f17ec33$var$mergeSubType = (oldResult, newResult)=>{
    // for classic pages, subType is 'null'
    if (newResult.data?.sourceSubType !== undefined) return newResult.data.sourceSubType;
    if (newResult.data?.sourceAri) // for blogposts, subType is always undefined
    try {
        const { type: pageType } = (0, $6oMcp.getPageIdAndTypeFromConfluencePageAri)({
            ari: newResult.data?.sourceAri
        });
        if (pageType === 'blogpost') return newResult.data?.sourceSubType;
    } catch  {}
    return oldResult.data?.sourceSubType;
};
module.exports["resolveSyncBlockInstance"] = $91813f771f17ec33$export$dcc459f28c1cd2fd;

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("f9GoL", function(module, exports) {

var $LQnOI = parcelRequire("LQnOI");


var $jv11C = parcelRequire("jv11C");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $d04Ge = parcelRequire("d04Ge");

class $7b654f51773d0aa6$export$7d827e0357659116 {
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    /**
   * Returns true if a batched fetch is queued or in flight for `resourceId`.
   * Used by cache deletion guards to prevent deleting while a fetch is
   * about to populate the entry.
   */ hasPendingFetch(resourceId) {
        return this.pendingFetchRequests.has(resourceId) || this.inFlightFetches.has(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.isDestroyed = true;
        this.cancel();
        this.clearPending();
        // Clear in-flight tracking to prevent stale entries after teardown.
        this.inFlightFetches.clear();
    }
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        // Tracks resourceIds whose batched fetch is in flight (after RAF drains
        // pendingFetchRequests, before the promise settles). Ensures
        // `hasPendingFetch` remains true during the network window.
        this.inFlightFetches = new Set();
        this.isDestroyed = false;
        this.scheduledBatchFetch = void 0;
        this.scheduledBatchFetch = (0, $LQnOI.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            // EDITOR-7860: not ready — skip and leave resourceIds queued for the
            // next batch once the provider resolves.
            if (this.deps.isProviderReady && !this.deps.isProviderReady()) return;
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $d04Ge.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            // Track in-flight before the fetch so guards remain positive.
            resourceIds.forEach((resId)=>this.inFlightFetches.add(resId));
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                // EDITOR-7860: benign not-ready throw — re-queue for retry and emit
                // nothing (no analytics, no exception-tracker noise). Checked before
                // `logException` so the benign case stays silent. Re-schedule so the
                // re-queued IDs are retried on the next frame even if no further
                // `queueFetch()` arrives.
                if ((0, $79ir6.isProviderNotReadyError)(error)) {
                    resourceIds.forEach((resId)=>this.pendingFetchRequests.add(resId));
                    if (!this.isDestroyed) this.scheduledBatchFetch();
                    return;
                }
                (0, $jv11C.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                const attribution = (0, $916Gd.buildFetchErrorAttribution)(error.message);
                resourceIds.forEach((resId)=>{
                    this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resId), attribution));
                });
            }).finally(()=>{
                // If the fetcher was destroyed while the request was in flight,
                // skip cleanup — `destroy()` already cleared `inFlightFetches`
                // and there's nothing observable to update.
                if (this.isDestroyed) return;
                // Clear in-flight tracking once the fetch settles.
                resourceIds.forEach((resId)=>this.inFlightFetches.delete(resId));
            });
        });
    }
}
module.exports["SyncBlockBatchFetcher"] = $7b654f51773d0aa6$export$7d827e0357659116;

});

parcelRegister("3ZV9H", function(module, exports) {
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $9e2a264ec952713b$export$75f7f86498dcaabe {
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        /**
     * Maximum total size of all cached values, measured in **UTF-16 code
     * units** (i.e. `String.prototype.length`), not bytes.  For ASCII-only
     * content the two are equivalent; for content with characters outside
     * the BMP each surrogate pair counts as 2.
     */ this.maxSize = void 0;
        this.maxSize = maxSize;
    }
}
const $9e2a264ec952713b$export$b811313deafee9ed = new $9e2a264ec952713b$export$75f7f86498dcaabe();
module.exports["syncBlockInMemorySessionCache"] = $9e2a264ec952713b$export$b811313deafee9ed;

});

parcelRegister("8d6F6", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $jv11C = parcelRequire("jv11C");


var $eNbr2 = parcelRequire("eNbr2");


var $iDrrr = parcelRequire("iDrrr");


var $916Gd = parcelRequire("916Gd");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

class $6125b02f0c1ee8e1$export$3bfff6c128de82c9 {
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            const error = new Error('Data provider not set');
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(error.message)));
            return undefined;
        }
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            const { parentDataProviders: parentDataProviders } = dataProvider.getSyncedBlockRendererProviderOptions();
            providerFactory = (0, $eNbr2.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        }
        // Syncing providers notifies subscribers synchronously, so on the client it
        // cannot run during render - callers invoke `syncProviders` from an effect
        // instead. Effects never run while server rendering, and there are no mounted
        // subscribers to notify, so the server keeps applying them inline.
        const deferProviderSync = (0, $iDrrr.fg)('platform_editor_blocks_patch_7');
        if (deferProviderSync && !(0, $4iudd.isSSR)()) return providerFactory;
        this.syncProviders(resourceId, providerFactory);
        return providerFactory;
    }
    /**
   * The provider options currently supplied by the host. A pure read that does
   * not notify subscribers, so it is safe to call during render - callers use it
   * to detect when the host swaps a provider and the factory needs re-syncing.
   */ getProviderOptions() {
        return this.deps.getDataProvider()?.getSyncedBlockRendererProviderOptions();
    }
    /**
   * Applies the latest parent and dynamic providers to the cached factory.
   * Notifies subscribers, so must be called from an effect, never during render.
   */ syncProviders(resourceId, factory) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return;
        const providerFactory = factory ?? this.providerFactories.get(resourceId);
        if (!providerFactory) return;
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
        if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
        if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        if (!providerCreator) return;
        try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(error.message)));
        }
    }
    getSSRProviders(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $cuwGS.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        let { contentId: contentId, product: contentProduct } = parsedResourceId;
        const syncBlock = this.deps.getFromCache(resourceId);
        let contentAri = syncBlock?.data?.sourceAri || '';
        if (syncBlock?.data?.sourceAri && syncBlock.data.product) {
            const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
            if (parentInfo) {
                contentId = parentInfo.contentId;
                contentProduct = parentInfo.contentProduct;
                contentAri = parentInfo.contentAri;
            }
        }
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)('Sync block source ari or product not found', resourceId, // Prefer cached product when available; fall back to parsing resourceId.
            syncBlock.data.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)('Sync block source ari or product not found')));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentAri: contentAri, contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
}
module.exports["SyncBlockProviderFactoryManager"] = $6125b02f0c1ee8e1$export$3bfff6c128de82c9;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("dWaXQ", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $jv11C = parcelRequire("jv11C");


var $916Gd = parcelRequire("916Gd");


var $8kkvD = parcelRequire("8kkvD");


var $d04Ge = parcelRequire("d04Ge");

class $0a36060a48fcf8c9$export$200c87d47b3d6e17 {
    // EDITOR-7861: higher ceiling lets transient WS-gateway drops self-heal
    // before a terminal failure is surfaced.
    getMaxRetryAttempts() {
        return $0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED;
    }
    // Backoff delay for the given attempt (EDITOR-7861): exponential capped at
    // MAX_RETRY_DELAY_MS with equal jitter (capped/2 + random*capped/2) —
    // de-synchronises simultaneous reconnects while guaranteeing a non-zero delay
    // (full jitter could hit 0).
    getReconnectionDelay(attempts) {
        const exponential = $0a36060a48fcf8c9$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS * Math.pow($0a36060a48fcf8c9$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER, attempts);
        const half = Math.min(exponential, $0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS) / 2;
        return Math.round(half + Math.random() * half);
    }
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $jv11C.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildFetchErrorAttribution)(error.message)));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $8kkvD.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        this.deps.cancelPendingCacheDeletion(resourceId);
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                const remainingIds = Object.keys(resourceSubscriptions);
                if (remainingIds.length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Delegate cache deletion to the store manager
                    // which uses a 30s grace period with guard re-checks.
                    this.deps.scheduleCacheDeletion(resourceId);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            // EDITOR-7861: a single socket drop is usually transient and recovers
            // on reconnect, so we don't fire a user-facing error here — it's only
            // surfaced on exhaustion, where the structured attribution
            // (EDITOR-7862) is applied too. See scheduleReconnection.
            this.handleSubscriptionTerminated(resourceId);
        }, ()=>{
            this.handleSubscriptionTerminated(resourceId);
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    /**
   * Handles subscription termination (complete or error) by cleaning up the
   * stale entry and scheduling a reconnection with exponential backoff.
   */ handleSubscriptionTerminated(resourceId) {
        // Remove the stale subscription entry so setupSubscription won't early-return
        this.graphqlSubscriptions.delete(resourceId);
        // Guard against duplicate calls (graphql-ws can fire both error and complete)
        if (this.pendingRetries.has(resourceId)) return;
        // Only reconnect if there are still active subscribers for this resource
        if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) this.scheduleReconnection(resourceId);
    }
    // Schedules a reconnection with backoff (see getMaxRetryAttempts /
    // getReconnectionDelay for the gated behaviour).
    scheduleReconnection(resourceId) {
        const attempts = this.retryAttempts.get(resourceId) ?? 0;
        const maxAttempts = this.getMaxRetryAttempts();
        if (attempts >= maxAttempts) {
            // Exhausted all attempts — the only place a WS drop surfaces as a
            // fetch error (EDITOR-7861).
            const errorMessage = `Subscription reconnection failed after ${attempts} attempts`;
            // Tab hidden at exhaustion: don't surface a terminal failure (user isn't
            // looking, and most exhaustions self-recover once foregrounded). Park + re-arm
            // on wake, emitting a benign `deferred` signal so suppression stays auditable.
            if (this.isDocumentHidden()) {
                this.deferredExhausted.add(resourceId);
                this.registerWakeListeners();
                this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(errorMessage, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(errorMessage, undefined, /* deferred */ true)));
                return;
            }
            (0, $jv11C.logException)(new Error(errorMessage), {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/max-retries-exhausted'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(errorMessage, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(errorMessage)));
            return;
        }
        const delay = this.getReconnectionDelay(attempts);
        const timer = setTimeout(()=>{
            this.pendingRetries.delete(resourceId);
            // Only re-subscribe if still relevant
            if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) {
                this.setupSubscription(resourceId);
                // Only increment if the subscription was actually established
                // (setupSubscription may be a no-op if another code path already re-established it)
                if (this.graphqlSubscriptions.has(resourceId)) this.retryAttempts.set(resourceId, attempts + 1);
            } else // Conditions no longer met — clean up stale retry state
            this.retryAttempts.delete(resourceId);
        }, delay);
        this.pendingRetries.set(resourceId, timer);
    }
    /**
   * Resets the retry counter for a resource. Called when a successful
   * update is received, indicating the subscription is healthy.
   */ resetRetryCount(resourceId) {
        this.retryAttempts.delete(resourceId);
    }
    /**
   * Whether the tab is currently hidden. SSR/non-browser is treated as "not hidden" so
   * we never defer where wake events can't fire (realtime never subscribes there anyway).
   */ isDocumentHidden() {
        return (0, $1hQ0e.getDocument)()?.hidden === true;
    }
    /**
   * Lazily register shared `online` / `visibilitychange` listeners on first deferral.
   * Torn down by `unregisterWakeListeners` (via `handleWake`). No-op in SSR / non-browser.
   */ registerWakeListeners() {
        if (this.wakeListenerCleanups.length > 0 || typeof window === 'undefined') return;
        this.wakeListenerCleanups.push((0, $cbY7C.bind)(window, {
            type: 'online',
            listener: this.onOnline
        }));
        const doc = (0, $1hQ0e.getDocument)();
        if (doc) this.wakeListenerCleanups.push((0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: this.onVisibilityChange
        }));
    }
    unregisterWakeListeners() {
        if (this.wakeDebounceTimer !== null) {
            clearTimeout(this.wakeDebounceTimer);
            this.wakeDebounceTimer = null;
        }
        for (const cleanup of this.wakeListenerCleanups)cleanup();
        this.wakeListenerCleanups = [];
    }
    /**
   * Coalesce a burst of wake events into one debounced re-arm sweep. Callers decide
   * eligibility: `onOnline` always sweeps; `onVisibilityChange` only sweeps when visible.
   */ scheduleWakeSweep() {
        if (this.wakeDebounceTimer !== null) return;
        this.wakeDebounceTimer = setTimeout(()=>{
            this.wakeDebounceTimer = null;
            this.handleWake();
        }, $0a36060a48fcf8c9$export$200c87d47b3d6e17.WAKE_DEBOUNCE_MS);
    }
    /**
   * Re-arm every deferred resource: full reset (attempts→0) + immediate reconnect now
   * the tab is visible / online. Healthy subscriptions are untouched. A re-armed cycle
   * that later exhausts while visible fires the terminal error normally.
   */ handleWake() {
        if (this.deferredExhausted.size === 0) {
            this.unregisterWakeListeners();
            return;
        }
        const toRearm = Array.from(this.deferredExhausted);
        this.deferredExhausted.clear();
        for (const resourceId of toRearm){
            // Only re-arm resources that still have active subscribers and realtime on.
            if (!this.subscriptions.has(resourceId) || !this.shouldUseRealTime()) continue;
            this.resetRetryCount(resourceId);
            this.cancelPendingRetry(resourceId);
            this.setupSubscription(resourceId);
        }
        // No deferred resources remain until another hidden exhaustion re-adds one.
        this.unregisterWakeListeners();
    }
    cancelPendingRetry(resourceId) {
        const timer = this.pendingRetries.get(resourceId);
        if (timer) {
            clearTimeout(timer);
            this.pendingRetries.delete(resourceId);
        }
    }
    cancelAllPendingRetries() {
        for (const timer of this.pendingRetries.values())clearTimeout(timer);
        this.pendingRetries.clear();
        this.retryAttempts.clear();
        // Nothing left to re-arm: drop parked exhaustions and tear down wake listeners.
        this.deferredExhausted.clear();
        this.unregisterWakeListeners();
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
        this.cancelPendingRetry(resourceId);
        this.retryAttempts.delete(resourceId);
        // No subscribers left, so this resource can't be re-armed.
        this.deferredExhausted.delete(resourceId);
        if (this.deferredExhausted.size === 0) this.unregisterWakeListeners();
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
        this.cancelAllPendingRetries();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $8kkvD.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            this.resetRetryCount(syncBlockInstance.resourceId);
            // A healthy update means a parked exhaustion recovered on its own before any
            // wake sweep — drop it and tear down listeners if nothing else is parked.
            if (this.deferredExhausted.delete(syncBlockInstance.resourceId)) {
                if (this.deferredExhausted.size === 0) this.unregisterWakeListeners();
            }
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            const errorMessage = syncBlockInstance.error?.reason || syncBlockInstance.error?.type;
            // Prefer the structured `type` (a `SyncBlockError` enum value) for classification
            // and fall back to the free-text `reason` so source-state/permission strings are
            // still bucketed (EDITOR-7862). The emitted free-text `error` attribute is unchanged.
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $916Gd.buildFetchErrorAttribution)(syncBlockInstance.error?.type || syncBlockInstance.error?.reason, syncBlockInstance.error?.statusCode)));
        }
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        // backoff cap
        this.retryAttempts = new Map();
        this.pendingRetries = new Map();
        // Resources whose reconnection exhausted while the tab was hidden: parked here and
        // re-armed on the next online / visibilitychange→visible instead of surfacing a
        // terminal error. Only a re-armed attempt that also exhausts while visible fails.
        this.deferredExhausted = new Set();
        this.wakeDebounceTimer = null;
        // `online` always sweeps (network is back regardless of tab visibility); a
        // `visibilitychange` only sweeps when the tab became visible.
        this.onOnline = ()=>this.scheduleWakeSweep();
        this.onVisibilityChange = ()=>{
            if (!this.isDocumentHidden()) this.scheduleWakeSweep();
        };
        // Cleanup fns returned by `bind` for the registered wake listeners; a non-empty
        // array means listeners are currently registered. Emptied on teardown.
        this.wakeListenerCleanups = [];
    }
}
// Reconnection with exponential backoff.
$0a36060a48fcf8c9$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS = 1000;
$0a36060a48fcf8c9$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER = 2;
$0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED = 8;
// EDITOR-7861
$0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS = 30000;
// Coalesce wake-event bursts into one re-arm sweep to avoid a reconnection storm.
$0a36060a48fcf8c9$export$200c87d47b3d6e17.WAKE_DEBOUNCE_MS = 1000;
module.exports["SyncBlockSubscriptionManager"] = $0a36060a48fcf8c9$export$200c87d47b3d6e17;

});

parcelRegister("1MDPE", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cduI2 = parcelRequire("cduI2");


var $d04Ge = parcelRequire("d04Ge");

/** Maximum time (ms) flush() will wait for in-flight block creations before proceeding. */ const $5851c127b5a56c3a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS = 1000;
/**
 * Window (ms) within which a repeated `syncedBlockDelete` emission for the same
 * resourceId is suppressed. The same logical removal can re-fire across
 * rebased/remote/redo transactions; a short window collapses those bursts to one
 * event while still allowing a genuine delete→recreate→delete later.
 */ const $5851c127b5a56c3a$var$DELETE_DEDUPE_WINDOW_MS = 5000;
class $5851c127b5a56c3a$export$9c6faa8962092f36 {
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    /**
   * Register a callback to be invoked when flush() timed out waiting for a
   * pending block creation and that creation subsequently completes. The
   * callback should trigger a deferred flush to persist the content that
   * was skipped due to the timeout. See EDITOR-7112.
   */ registerPostCreationFlushCallback(callback) {
        this.postCreationFlushCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $cduI2.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $cduI2.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $cduI2.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $cduI2.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    isNewSourceBlock(resourceId) {
        return this.newSourceBlockResourceIds.has(resourceId);
    }
    clearNewSourceBlock(resourceId) {
        this.newSourceBlockResourceIds.delete(resourceId);
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode, isRemote) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) // Identifiers not populated yet: benign timing case, skip as a no-op.
            return false;
            const cachedBlock = this.syncBlockCache.get(resourceId);
            // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
            // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
            if (cachedBlock?.contentFragment?.eq(syncBlockNode.content)) return true;
            const syncBlockData = (0, $d04Ge.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            if (cachedBlock && !isRemote) this.hasReceivedContentChange = true;
            const isDirty = !isRemote || !cachedBlock; // if the change is not remote, or the block is not in the cache yet, it's dirty
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: isDirty,
                // if the change is from remote, it's not dirty
                contentFragment: syncBlockNode.content,
                status: cachedBlock?.status
            });
            return true;
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // We can derive the product from `syncBlockNode.attrs.resourceId` even though
            // the variable wasn't destructured (the destructuring step itself may have thrown).
            this.fireAnalyticsEvent?.((0, $916Gd.updateCacheErrorPayload)(error.message, syncBlockNode?.attrs?.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockNode?.attrs?.resourceId)));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (this.viewMode === 'view') return true;
            // Wait (up to FLUSH_CREATION_AWAIT_TIMEOUT_MS) for any in-flight
            // block creations to complete before iterating the cache. Without
            // this, blocks created from existing content are skipped
            // (isPendingCreation check below) and if no further edits are made,
            // no subsequent flush is triggered — causing references to show an
            // "unpublished" error.
            // If the timeout expires, any block whose creation is still
            // in-flight is recorded in `creationsTimedOutDuringFlush` so that
            // `commitPendingCreation()` can trigger a follow-up flush once that
            // specific creation completes.
            // See EDITOR-7112.
            if (this.pendingCreationPromises.size > 0) {
                let timedOut = false;
                let timeoutId;
                const timeout = new Promise((resolve)=>{
                    timeoutId = setTimeout(()=>{
                        timedOut = true;
                        resolve();
                    }, $5851c127b5a56c3a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS);
                });
                await Promise.race([
                    Promise.all(this.pendingCreationPromises.values()),
                    timeout
                ]);
                if (timeoutId !== undefined) clearTimeout(timeoutId);
                if (timedOut) // Record every still-in-flight creation so each late
                // completion is tracked independently.
                for (const resourceId of this.pendingCreationPromises.keys())this.creationsTimedOutDuringFlush.add(resourceId);
            }
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $79ir6.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                this.saveExperience?.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) {
                        // Update cache with the status returned from the backend
                        const cachedData = this.syncBlockCache.get(result.resourceId);
                        if (cachedData && result.status) cachedData.status = result.status;
                        this.fireAnalyticsEvent?.((0, $916Gd.updateSuccessPayload)(result.resourceId, false, (0, $d04Ge.getSourceProductFromResourceIdSafe)(result.resourceId)));
                    }
                });
                return true;
            } else {
                this.saveExperience?.failure();
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $916Gd.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $916Gd.buildErrorAttribution)(result.error, result.statusCode)));
                });
                return false;
            }
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // Top-level flush failure is not tied to a single resourceId. There is no structured
            // SyncBlockError/status here, so the attribution `reason` falls back to `unknown`.
            this.fireAnalyticsEvent?.((0, $916Gd.updateErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildErrorAttribution)()));
            return false;
        } finally{
            this.flushCompletionCallback?.();
        }
    }
    hasUnsavedChanges() {
        if (this.viewMode === 'view') return false;
        // Only track unsaved changes in source synced block for live pages
        // classic pages's draft don't publish synced block content to block service and the content itself is saved as part of the draft
        // classic page's publish flow will trigger a flush which only uses the isDirty flag to determine if there are unsaved changes
        if (!this.isLivePage) return false;
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   * Returns `true` when at least one sync block is waiting for its backend
   * creation call to complete. Used as a cheap pre-check in the decoration
   * rebuild path to avoid a full `doc.descendants()` walk when no creations
   * are in flight (see EDITOR-6930).
   */ hasPendingCreations() {
        return this.creationCompletionCallbacks.size > 0;
    }
    /** Returns the source block's last known backend publication status. */ getStatus(resourceId) {
        return this.syncBlockCache.get(resourceId)?.status;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        if (this.viewMode === 'view') return;
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            // If a previous flush() timed out waiting for this specific
            // creation, drop it from the tracking set regardless of outcome so
            // it does not leak. See EDITOR-7112.
            const wasTimedOut = this.creationsTimedOutDuringFlush.delete(resourceId);
            if (success) {
                // If creation is successful, set hasReceivedContentChange to true
                // to indicate that there are unsaved changes in the cache
                this.hasReceivedContentChange = true;
                // If flush() timed out waiting for this creation, notify the
                // plugin so it can trigger a deferred flush. See EDITOR-7112.
                if (wasTimedOut) this.postCreationFlushCallback?.();
            }
        } else this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)('creation complete callback missing', resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        if (success) {
            const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
            this.fireAnalyticsEvent?.((0, $916Gd.createSuccessPayload)(resourceId || '', sourceProduct));
            // Operational create-success event with the join key + creation-type
            // signals (inputMethod / createdEmpty) captured at the command layer.
            this.fireAnalyticsEvent?.((0, $916Gd.createSuccessOperationalPayload)(resourceId || '', this.syncBlockCache.get(resourceId)?.blockInstanceId, sourceProduct, this.creationEnrichment.get(resourceId)));
        } else {
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            this.newSourceBlockResourceIds.delete(resourceId || '');
            // Creation failed, so there is no block to add content to — drop the
            // first-content tracking entry so a later unrelated edit cannot fire it.
            this.awaitingFirstContent.delete(resourceId || '');
            this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)('Fail to create bodied sync block', resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        // Enrichment is single-use — drop it once the create has resolved either way.
        this.creationEnrichment.delete(resourceId || '');
    }
    /**
   * Fire the first-content-added event once when a block created empty this
   * session first gains content. The caller detects the in-block edit; this owns
   * dedupe + emission (fires at most once per block, only for empty→content).
   */ maybeEmitFirstContentAdded(resourceId, blockInstanceId) {
        if (this.viewMode === 'view') return;
        // `delete` returns false when the id was not tracked (already emitted, or
        // the block was not created empty this session), so this both dedupes and
        // scopes emission to genuine first-content transitions in one check.
        if (!this.awaitingFirstContent.delete(resourceId)) return;
        this.fireAnalyticsEvent?.((0, $916Gd.addContentSuccessPayload)(resourceId, blockInstanceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   * @param node the ProseMirror node to cache
   * @param onCompletion callback invoked when creation completes
   * @param enrichment optional creation-type signals stashed and attached to the
   *   `syncedBlockCreate` event when the async create resolves. When
   *   `createdEmpty` is true the block is also registered for the
   *   first-content-added event.
   */ createBodiedSyncBlockNode(attrs, node, onCompletion, enrichment) {
        if (this.viewMode === 'view') return;
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        // Stash creation-type signals for commitPendingCreation to read.
        if (enrichment) {
            this.creationEnrichment.set(resourceId, enrichment);
            // Only empty-created blocks can produce an empty→content transition.
            if (enrichment.createdEmpty) this.awaitingFirstContent.add(resourceId);
        }
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            if (enrichment) this.newSourceBlockResourceIds.add(resourceId);
            // add the node to the cache
            this.updateSyncBlockData(node, false);
            // Mark the block as unpublished in the cache so it can be cleaned up on cancel
            const cached = this.syncBlockCache.get(resourceId);
            if (cached) cached.status = 'unpublished';
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            this.createExperience?.start({});
            const creationPromise = this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    this.commitPendingCreation(true, resourceId);
                    this.createExperience?.success();
                } else {
                    this.commitPendingCreation(false, resourceId);
                    this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildErrorAttribution)(result.error, result.statusCode)));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false, resourceId);
                (0, $jv11C.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            }).finally(()=>{
                this.pendingCreationPromises.delete(resourceId);
            });
            this.pendingCreationPromises.set(resourceId, creationPromise);
        } catch (error) {
            this.newSourceBlockResourceIds.delete(resourceId);
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        }
    }
    /**
   * Drop dedupe entries older than {@link DELETE_DEDUPE_WINDOW_MS} so
   * `recentDeleteEmissions` stays bounded by the number of recent deletes.
   */ pruneRecentDeleteEmissions(now) {
        for (const [resourceId, emittedAt] of this.recentDeleteEmissions)if (now - emittedAt >= $5851c127b5a56c3a$var$DELETE_DEDUPE_WINDOW_MS) this.recentDeleteEmissions.delete(resourceId);
    }
    /**
   * Emit the `syncedBlockDelete` success event. Attaches `deletionReason`,
   * `mechanism` and `blockInstanceId`, and suppresses repeat emissions within
   * {@link DELETE_DEDUPE_WINDOW_MS}. Must run while the cache entry still exists
   * so `blockInstanceId` is available.
   */ emitDeleteSuccess(resourceId, reason, mechanism) {
        const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
        const now = Date.now();
        const lastEmittedAt = this.recentDeleteEmissions.get(resourceId);
        if (lastEmittedAt !== undefined && now - lastEmittedAt < $5851c127b5a56c3a$var$DELETE_DEDUPE_WINDOW_MS) return; // duplicate emission for the same logical removal
        this.pruneRecentDeleteEmissions(now);
        this.recentDeleteEmissions.set(resourceId, now);
        const enrichment = {
            blockInstanceId: this.syncBlockCache.get(resourceId)?.blockInstanceId,
            deletionReason: reason,
            mechanism: mechanism
        };
        this.fireAnalyticsEvent?.((0, $916Gd.deleteSuccessPayload)(resourceId, sourceProduct, enrichment));
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason, mechanism) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                // Emit before the cache entry is deleted below, so blockInstanceId
                // is still available to emitDeleteSuccess.
                results.forEach((result)=>{
                    this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                });
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                this.deleteExperience?.success();
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                this.deleteExperience?.failure();
                results.forEach((result)=>{
                    if (result.success) this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                    else this.fireAnalyticsEvent?.((0, $916Gd.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $916Gd.buildErrorAttribution)(result.error, result.statusCode)));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            // Thrown (non-result) failure — no structured SyncBlockError/status is available,
            // so the attribution `reason` falls back to `unknown`.
            const attribution = (0, $916Gd.buildErrorAttribution)();
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $916Gd.deleteErrorPayload)(error.message, Ids.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(Ids.resourceId), attribution));
            });
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (this.viewMode === 'view') return Promise.resolve();
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason, mechanism: mechanism } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   * Fetches the current status of all source sync blocks in the cache from the backend
   * and updates the cache entries with the fetched status.
   * This is called on editor init so we know which blocks are 'unpublished' vs 'active'.
   */ async fetchAndCacheStatuses() {
        if (!this.dataProvider || this.syncBlockCache.size === 0) return;
        // Source blocks have plain UUID resourceIds, but fetchNodesData internally uses
        // generateBlockAriFromReference which expects reference-format resourceIds
        // (e.g. "confluence-page/pageId/uuid"). We convert source resourceIds to reference
        // format before fetching, and maintain a mapping back to original resourceIds
        // so we can update the correct cache entries.
        const sourceToReferenceMap = new Map();
        const syncBlockNodes = Array.from(this.syncBlockCache.entries()).map(([resourceId, data])=>{
            const referenceResourceId = this.dataProvider?.generateResourceIdForReference(resourceId) ?? resourceId;
            sourceToReferenceMap.set(referenceResourceId, resourceId);
            return {
                type: 'bodiedSyncBlock',
                attrs: {
                    localId: data.blockInstanceId,
                    resourceId: referenceResourceId
                }
            };
        });
        try {
            const results = await this.dataProvider.fetchNodesData(syncBlockNodes);
            for (const result of results){
                // Map the reference resourceId back to the source resourceId
                const sourceResourceId = sourceToReferenceMap.get(result.resourceId) ?? result.resourceId;
                const cached = this.syncBlockCache.get(sourceResourceId);
                if (cached && result.data?.status) cached.status = result.data.status;
            }
        } catch  {
        // If the fetch fails, statuses remain undefined.
        // This is acceptable — on cancel, blocks without a known status
        // will not be deleted (safe default).
        }
    }
    /**
   * Deletes all source sync blocks that have 'unpublished' status.
   * Used to clean up orphaned blocks when a user cancels editing without saving.
   * Blocks that were already saved (status 'active') are not affected.
   *
   * @returns true if all deletions succeeded, false otherwise
   */ discardUnpublishedBlocks() {
        const unpublishedBlockIds = Array.from(this.syncBlockCache.entries()).filter(([_, data])=>data.status === 'unpublished' && !data.pendingDeletion).map(([resourceId, data])=>({
                resourceId: resourceId,
                localId: data.blockInstanceId
            }));
        if (unpublishedBlockIds.length === 0) return Promise.resolve(true);
        return this.delete(unpublishedBlockIds, ()=>{}, // onDelete: no-op, document is being discarded
        ()=>{}, // onDeleteCompleted: no-op
        'source-block-unpublished', // Cancel/discard cleanup is code-initiated, not a direct user edit.
        'other');
    }
    /**
   * Deletes sync blocks with confirmation from the backend
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback, mechanism) {
        if (this.viewMode === 'view') return Promise.resolve();
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason,
                    mechanism: mechanism
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                    reason: 'No source info returned'
                });
                else this.fetchSourceInfoExperience?.success();
                return sourceInfo;
            });
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.fetchReferencesErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            return Promise.resolve({
                error: (0, $79ir6.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.postCreationFlushCallback = undefined;
        this.pendingCreationPromises.clear();
        this.creationsTimedOutDuringFlush.clear();
        this.creationEnrichment.clear();
        this.newSourceBlockResourceIds.clear();
        this.awaitingFirstContent.clear();
        this.recentDeleteEmissions.clear();
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.viewMode = void 0;
        this.isLivePage = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.hasReceivedContentChange = false;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.creationCompletionCallbacks = void 0;
        this.flushCompletionCallback = void 0;
        this.postCreationFlushCallback = void 0;
        /**
     * Promises for in-flight block creations, keyed by resourceId.
     * `flush()` awaits these so that blocks created from existing content are
     * persisted even if no further edits trigger a subsequent flush.
     * See EDITOR-7112.
     */ this.pendingCreationPromises = new Map();
        /**
     * Set of resource IDs whose creation was still in-flight when a `flush()`
     * timed out. Each completion (success or failure) is removed from this set;
     * the first successful completion of any of these IDs triggers
     * `postCreationFlushCallback` so the content is eventually persisted.
     * Tracking IDs (not just a boolean) avoids dropping late completions when
     * multiple blocks are created concurrently. See EDITOR-7112.
     */ this.creationsTimedOutDuringFlush = new Set();
        /**
     * Creation-type signals captured at `createBodiedSyncBlockNode` time and read
     * back in `commitPendingCreation` to enrich the `syncedBlockCreate` event.
     * Kept out of the flushed cache record so it never leaks into Block Service /
     * ADF; removed once consumed.
     */ this.creationEnrichment = new Map();
        /**
     * Source blocks created by the local insert command in this editor session that
     * have not yet been reconciled with authoritative reference data. This state is
     * intentionally kept out of ADF and the backend cache so reloaded, restored,
     * copied, and remotely inserted sources cannot inherit it.
     */ this.newSourceBlockResourceIds = new Set();
        /**
     * Resource IDs of blocks created empty this session that have not yet fired
     * the first-content-added event. Added on empty creation, removed when the
     * block first gains content (the event fires once). Blocks created with
     * content or not created this session are never tracked.
     */ this.awaitingFirstContent = new Set();
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        /**
     * resourceId -> timestamp (ms) of the last `syncedBlockDelete` emission, used
     * to suppress duplicates within {@link DELETE_DEDUPE_WINDOW_MS}.
     */ this.recentDeleteEmissions = new Map();
        this.setPendingDeletion = (Ids, value)=>{
            if (this.viewMode === 'view') return;
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.isLivePage = isLivePage;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $5851c127b5a56c3a$export$9c6faa8962092f36;

});

parcelRegister("2A6x2", function(module, exports) {
const $38d1d0a193cd4295$export$809659ed37baae65 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.flush();
};
const $38d1d0a193cd4295$export$42389f194734952a = (syncBlockStore)=>{
    return syncBlockStore.referenceManager.flush();
};
const $38d1d0a193cd4295$export$e79742b5511b2d66 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.discardUnpublishedBlocks();
};
module.exports["flushBodiedSyncBlocks"] = $38d1d0a193cd4295$export$809659ed37baae65;
module.exports["flushSyncBlocks"] = $38d1d0a193cd4295$export$42389f194734952a;
module.exports["discardUnpublishedSyncBlocks"] = $38d1d0a193cd4295$export$e79742b5511b2d66;

});

parcelRegister("hzCKL", function(module, exports) {

var $4XbfY = parcelRequire("4XbfY");


var $krYZG = parcelRequire("krYZG");


var $1TzXg = parcelRequire("1TzXg");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $d04Ge = parcelRequire("d04Ge");


var $anBbz = parcelRequire("anBbz");


var $i57XD = parcelRequire("i57XD");


var $73IhX = parcelRequire("73IhX");


var $kXmSu = parcelRequire("kXmSu");


var $hbTU5 = parcelRequire("hbTU5");

/**
 * Place the caret on the first editable position inside the newly created bodied
 * sync block, identified by its unique localId.
 *
 * - Empty selection: lands inside the block's empty paragraph.
 * - Converted content: lands at the start of the first editable child.
 *
 * `createSyncedBlock` builds the node but neither `safeInsert` (empty case) nor
 * `replaceWith` (convert case) leaves the selection inside the new block, so
 * without this the caret ends up outside/adjacent to the block after creation
 * from the block menu or toolbar (EDITOR-7949). The typeahead path avoids this
 * because `typeAheadInsert` positions the caret for us.
 *
 * Note: when created from the block menu, block-controls' selection preservation
 * is active and will restore a whole-node NodeSelection over this caret. The
 * caller (block-menu item) is responsible for calling `stopPreservingSelection`
 * in the same flow so the caret survives — mirroring the block-menu delete item.
 */ const $4d68281089368b28$var$placeCaretInsideBodiedSyncBlock = (tr, localId)=>{
    const bodiedSyncBlockType = tr.doc.type.schema.nodes.bodiedSyncBlock;
    let blockPos;
    tr.doc.descendants((node, pos)=>{
        if (blockPos !== undefined) return false;
        if (node.type === bodiedSyncBlockType && node.attrs.localId === localId) {
            blockPos = pos;
            return false;
        }
        return true;
    });
    if (blockPos === undefined) return tr;
    // Find the first valid text position at or after the block's start. `findFrom`
    // with textOnly=true descends into the first editable child (empty paragraph or
    // start of the converted content), which is exactly what we want for both cases.
    const selection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(blockPos), 1, true);
    if (selection) tr.setSelection(selection).scrollIntoView();
    else // Fallback: `bodiedSyncBlock` is always created with a paragraph as its first
    // child, so a text position should always be found above. This guards against
    // future schema changes where the first child isn't immediately text-editable
    // — place the caret just inside the block rather than leaving it outside.
    // `blockPos + 1` is the position immediately after the block's opening token,
    // which is a node boundary rather than a valid text position, so use
    // `TextSelection.near` to snap forward to the nearest selectable cursor. It
    // also clamps to the document bounds internally, so no explicit end-of-doc
    // check is required.
    tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(blockPos + 1), 1)).scrollIntoView();
    return tr;
};
const $4d68281089368b28$export$fbc30658d812c800 = ({ tr: tr, syncBlockStore: syncBlockStore, typeAheadInsert: typeAheadInsert, fireAnalyticsEvent: fireAnalyticsEvent, inputMethod: inputMethod })=>{
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock, paragraph: paragraph } } } = tr.doc.type;
    // Capture createdEmpty before any insertion mutates the selection. The meta is
    // set on the final transaction before returning (see below), since the
    // typeahead path may reassign `tr` and drop meta set here.
    const createdEmpty = tr.selection.empty;
    // If the selection is empty, we want to insert the sync block on a new line
    if (tr.selection.empty) {
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const paragraphNode = paragraph.createAndFill({});
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, paragraphNode ? [
            paragraphNode
        ] : []);
        if (!newBodiedSyncBlockNode) {
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Create and fill for empty content failed'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        if (typeAheadInsert) tr = typeAheadInsert(newBodiedSyncBlockNode);
        else {
            tr = (0, $bjg0G.safeInsert)(newBodiedSyncBlockNode)(tr).scrollIntoView();
            // safeInsert does not move the selection into the new block, so place the
            // caret inside the block's empty paragraph so typing continues inside the
            // synced block (EDITOR-7949).
            tr = $4d68281089368b28$var$placeCaretInsideBodiedSyncBlock(tr, newBodiedSyncBlockNode.attrs.localId);
        }
    } else {
        const conversionInfo = (0, $73IhX.canBeConvertedToSyncBlock)(tr.selection);
        if (!conversionInfo) {
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Content cannot be converted to sync block'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, conversionInfo.contentToInclude);
        if (!newBodiedSyncBlockNode) {
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Create and fill for content failed'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        tr.replaceWith(conversionInfo.from, conversionInfo.to, newBodiedSyncBlockNode).scrollIntoView();
        // Place the caret on the first editable position inside the converted
        // content so typing continues inside the synced block (EDITOR-7949).
        tr = $4d68281089368b28$var$placeCaretInsideBodiedSyncBlock(tr, newBodiedSyncBlockNode.attrs.localId);
    }
    // Stash creation-type signals on the final transaction (after any typeahead
    // reassignment). Set unconditionally — the store manager only reads it behind
    // the feature gate.
    tr.setMeta((0, $i57XD.creationMetaKey), {
        createdEmpty: createdEmpty,
        inputMethod: inputMethod
    });
    return tr;
};
const $4d68281089368b28$export$c461f640005976aa = (syncBlockStore, inputMethod, api, isLivePage)=>({ tr: tr })=>{
        if ($4d68281089368b28$var$copySyncedBlockReferenceToClipboardInternal(tr.doc.type.schema, tr.selection, syncBlockStore, inputMethod, api, isLivePage)) return tr;
        return null;
    };
const $4d68281089368b28$export$cdf949b884fe546d = (syncBlockStore, inputMethod, api, isLivePage)=>(state, _dispatch, _view)=>$4d68281089368b28$var$copySyncedBlockReferenceToClipboardInternal(state.tr.doc.type.schema, state.tr.selection, syncBlockStore, inputMethod, api, isLivePage);
const $4d68281089368b28$var$copySyncedBlockReferenceToClipboardInternal = (schema, selection, syncBlockStore, inputMethod, api, isLivePage)=>{
    const syncBlockFindResult = (0, $73IhX.findSyncBlockOrBodiedSyncBlock)(schema, selection);
    if (!syncBlockFindResult) {
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'No sync block found in selection',
                inputMethod: inputMethod
            }
        });
        return false;
    }
    const isBodiedSyncBlock = (0, $73IhX.isBodiedSyncBlockNode)(syncBlockFindResult.node, schema.nodes.bodiedSyncBlock);
    let referenceSyncBlockNode = null;
    if (isBodiedSyncBlock) {
        const { nodes: { syncBlock: syncBlock } } = schema;
        // create sync block reference node
        referenceSyncBlockNode = syncBlock.createAndFill({
            resourceId: syncBlockStore.referenceManager.generateResourceIdForReference(syncBlockFindResult.node.attrs.resourceId)
        });
        if (!referenceSyncBlockNode) {
            api?.analytics?.actions?.fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
                attributes: {
                    error: 'Failed to create reference sync block node',
                    resourceId: syncBlockFindResult.node.attrs.resourceId,
                    inputMethod: inputMethod
                }
            });
            return false;
        }
    } else referenceSyncBlockNode = syncBlockFindResult.node;
    if (!referenceSyncBlockNode) {
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'No reference sync block node available',
                inputMethod: inputMethod
            }
        });
        return false;
    }
    const domNode = (0, $1TzXg.toDOM)(referenceSyncBlockNode, schema);
    (0, $1TzXg.copyDomNode)(domNode, referenceSyncBlockNode.type, selection);
    // Bare-uuid join key shared with the create/delete events: for a source
    // bodiedSyncBlock its `localId` is the source uuid (copy was page-form only).
    const sourceJoinKey = isBodiedSyncBlock ? syncBlockFindResult.node.attrs.localId : undefined;
    const isSourceContentUnpublished = isBodiedSyncBlock ? syncBlockStore.sourceManager.getStatus(syncBlockFindResult.node.attrs.resourceId) !== 'active' : syncBlockStore.referenceManager.getFromCache(referenceSyncBlockNode.attrs.resourceId)?.data?.status === 'unpublished';
    const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(referenceSyncBlockNode.attrs.resourceId);
    (0, $73IhX.deferDispatch)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.analytics?.actions?.fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).COPIED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
                attributes: {
                    resourceId: referenceSyncBlockNode.attrs.resourceId,
                    inputMethod: inputMethod,
                    ...sourceJoinKey && {
                        blockInstanceId: sourceJoinKey
                    }
                }
            });
            return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                activeFlag: {
                    id: (0, $kXmSu.FLAG_ID).SYNC_BLOCK_COPIED,
                    isLivePage: isLivePage,
                    isSourceContentUnpublished: isSourceContentUnpublished,
                    sourceProduct: sourceProduct
                }
            });
        });
    });
    return true;
};
const $4d68281089368b28$export$3a389eb361f43fd = (syncBlockStore, api)=>(state, dispatch, _view)=>{
        const syncBlock = (0, $73IhX.findSyncBlock)(state.schema, state.selection);
        const resourceId = syncBlock?.node?.attrs?.resourceId;
        if (!resourceId) return false;
        const syncBlockURL = syncBlockStore.referenceManager.getSyncBlockURL(resourceId);
        const syncBlockData = syncBlockStore.referenceManager.getFromCache(resourceId)?.data;
        const isOnSameDocument = syncBlockData?.onSameDocument === true;
        const sourceBlock = isOnSameDocument && syncBlockData ? (0, $hbTU5.findBodiedSyncBlockByLocalId)(state, syncBlockData.blockInstanceId) : undefined;
        if (syncBlockURL) {
            api?.analytics?.actions.fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).SYNCED_BLOCK_EDIT_SOURCE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    resourceId: resourceId,
                    sameDocument: isOnSameDocument
                }
            });
            if (sourceBlock) {
                const tr = state.tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, sourceBlock.pos)).scrollIntoView();
                dispatch?.(tr);
                return true;
            }
            window.open(syncBlockURL, '_blank');
        } else {
            const { tr: tr } = state;
            api?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    error: 'No URL resolved for synced block'
                }
            })(tr);
            dispatch?.(tr);
        }
        return true;
    };
const $4d68281089368b28$export$1c38da93cd68ba6d = (api)=>(state, dispatch, _view)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        if (!dispatch) return false;
        let removeTr = tr;
        if ((0, $bjg0G.findSelectedNodeOfType)(nodes.syncBlock)(tr.selection) || (0, $bjg0G.findSelectedNodeOfType)(nodes.bodiedSyncBlock)(tr.selection)) removeTr = (0, $bjg0G.removeSelectedNode)(tr);
        else removeTr = (0, $bjg0G.removeParentNodeOfType)(nodes.bodiedSyncBlock)(tr);
        if (!removeTr) return false;
        // Tag the transaction so analytics can report this as `deleteButton` rather
        // than a keyboard delete (both produce a plain ReplaceStep).
        removeTr.setMeta((0, $i57XD.deleteMechanismMetaKey), 'deleteButton');
        dispatch(removeTr);
        api?.core.actions.focus();
        return true;
    };
const $4d68281089368b28$export$8d571a58cfd57507 = (api, pos)=>{
    api?.core.actions.execute(({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        if (node?.type.name === 'syncBlock') {
            const removeTr = tr.replace(pos, pos + (node?.nodeSize ?? 0));
            if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true)) removeTr.setMeta((0, $i57XD.deleteMechanismMetaKey), 'deleteButton');
            return removeTr;
        }
        return tr;
    });
};
const $4d68281089368b28$export$e44cd24c4e3ac750 = (storeManager, isBodiedSyncBlock, view)=>{
    if (!view) return false;
    const { state: state } = view;
    const syncBlock = (0, $73IhX.findSyncBlockOrBodiedSyncBlock)(state.schema, state.selection);
    if (!syncBlock) return false;
    if (isBodiedSyncBlock) {
        // Signal the unsync intent. This transaction is intercepted by the plugin's
        // filterTransaction, which shows the deletion-confirmation modal and, on confirm,
        // recomputes the actual document change from the live document keyed off the
        // `deletionReason: 'source-block-unsynced'` meta (see handleBodiedSyncBlockRemoval /
        // recomputeUnsyncTransaction). The real unwrap-vs-delete decision therefore lives in the
        // confirm path, not here (EDITOR-8230).
        const content = syncBlock?.node.content;
        const { tr: tr } = state;
        tr.replaceWith(syncBlock.pos, syncBlock.pos + syncBlock.node.nodeSize, content).setMeta('deletionReason', 'source-block-unsynced');
        view.dispatch(tr);
        return true;
    }
    // handle syncBlock unsync
    const syncBlockContent = storeManager.referenceManager.getFromCache(syncBlock.node.attrs.resourceId)?.data?.content;
    if (!syncBlockContent) return false;
    // use defaultSchema for serialization so we can serialize any type of nodes and marks despite current editor's schema might not allow it
    const contentFragment = (0, $aPdNQ.Fragment).fromJSON((0, $4XbfY.defaultSchema), syncBlockContent);
    const contentDOM = (0, $aPdNQ.DOMSerializer).fromSchema((0, $4XbfY.defaultSchema)).serializeFragment(contentFragment);
    return (0, $hbTU5.pasteSyncBlockHTMLContent)(contentDOM, view);
};
module.exports["createSyncedBlock"] = $4d68281089368b28$export$fbc30658d812c800;
module.exports["copySyncedBlockReferenceToClipboardEditorCommand"] = $4d68281089368b28$export$c461f640005976aa;
module.exports["copySyncedBlockReferenceToClipboard"] = $4d68281089368b28$export$cdf949b884fe546d;
module.exports["editSyncedBlockSource"] = $4d68281089368b28$export$3a389eb361f43fd;
module.exports["removeSyncedBlock"] = $4d68281089368b28$export$1c38da93cd68ba6d;
module.exports["removeSyncedBlockAtPos"] = $4d68281089368b28$export$8d571a58cfd57507;
module.exports["unsync"] = $4d68281089368b28$export$e44cd24c4e3ac750;

});

parcelRegister("i57XD", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");


var $95bQO = parcelRequire("95bQO");


var $fud2r = parcelRequire("fud2r");

var $2w79Z = parcelRequire("2w79Z");


var $6Ixg8 = parcelRequire("6Ixg8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $8nvEM = parcelRequire("8nvEM");


var $d04Ge = parcelRequire("d04Ge");





var $anBbz = parcelRequire("anBbz");


var $1Jyys = parcelRequire("1Jyys");


var $gx781 = parcelRequire("gx781");


var $kXmSu = parcelRequire("kXmSu");


var $fQgiq = parcelRequire("fQgiq");


var $aznRb = parcelRequire("aznRb");


var $fTCnv = parcelRequire("fTCnv");


var $3k2Mh = parcelRequire("3k2Mh");


var $6hFNe = parcelRequire("6hFNe");


var $8zLo1 = parcelRequire("8zLo1");


var $dIIrm = parcelRequire("dIIrm");


var $73IhX = parcelRequire("73IhX");

const $92ceda184e2df47e$export$cb5a03b39dafc9cc = new (0, $kCECX.PluginKey)('syncedBlockPlugin');
const $92ceda184e2df47e$export$84cb2650bbe09e82 = new (0, $kCECX.PluginKey)('syncedBlockDeleteMechanism');
const $92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey = new (0, $kCECX.PluginKey)('syncedBlockPromptedFeedback');
const $92ceda184e2df47e$export$cde24468c2642688 = new (0, $kCECX.PluginKey)('syncedBlockCreationMeta');
const $92ceda184e2df47e$var$mapRetryCreationPosMap = (oldMap, newRetryCreationPos, mapPos)=>{
    const resourceId = newRetryCreationPos?.resourceId;
    // Fast path: no new entry and nothing to remap — return the same reference.
    // This is critical for PR-E (EDITOR-6929) which relies on reference equality
    // to short-circuit SharedStateAPI deep-equality checks.
    if (!resourceId && oldMap.size === 0) return oldMap;
    const newMap = new Map(oldMap);
    if (resourceId) {
        const { pos: pos } = newRetryCreationPos;
        if (!pos) newMap.delete(resourceId);
        else newMap.set(resourceId, pos);
    }
    if (newMap.size === 0) return newMap;
    for (const [id, pos] of newMap.entries())newMap.set(id, {
        from: mapPos(pos.from),
        to: mapPos(pos.to)
    });
    return newMap;
};
const $92ceda184e2df47e$var$showCopiedFlag = (api, isLivePage, isSourceContentUnpublished, sourceProduct)=>{
    (0, $73IhX.deferDispatch)(()=>{
        api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                activeFlag: {
                    id: (0, $kXmSu.FLAG_ID).SYNC_BLOCK_COPIED,
                    isLivePage: isLivePage,
                    isSourceContentUnpublished: isSourceContentUnpublished,
                    sourceProduct: sourceProduct
                }
            }));
    });
};
const $92ceda184e2df47e$var$showExtensionInSyncBlockWarningIfNeeded = (tr, state, api, extensionFlagShown)=>{
    if (!tr.docChanged || tr.getMeta('isRemote') || Boolean(tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) || (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode)) return;
    const resourceId = (0, $73IhX.wasExtensionInsertedInBodiedSyncBlock)(tr, state);
    // Only show the flag on the first instance per sync block (same as UNPUBLISHED_SYNC_BLOCK_PASTED)
    if (resourceId && !extensionFlagShown.has(resourceId)) {
        extensionFlagShown.add(resourceId);
        (0, $73IhX.deferDispatch)(()=>{
            api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                    activeFlag: {
                        id: (0, $kXmSu.FLAG_ID).EXTENSION_IN_SYNC_BLOCK
                    }
                }));
        });
    }
};
const $92ceda184e2df47e$var$getDeleteReason = (tr)=>{
    const reason = tr.getMeta('deletionReason');
    if (!reason) return 'source-block-deleted';
    return reason;
};
/** Narrows the history plugin meta, matching the editor-plugin-card pattern. */ const $92ceda184e2df47e$var$isHistoryMeta = (meta)=>typeof meta === 'object' && meta !== null && 'redo' in meta && typeof meta.redo === 'boolean';
const $92ceda184e2df47e$export$d9923c7a8cbf31ed = (tr, state)=>{
    // Keep the legacy analytics classification unchanged while activation is off.
    // The stricter history, structural-step, and reference-selection handling is
    // only needed by the prompted feedback rollout.
    const isSyncBlockActivationEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true);
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    if (historyMeta) {
        if (isSyncBlockActivationEnabled && !$92ceda184e2df47e$var$isHistoryMeta(historyMeta)) return 'other';
        return $92ceda184e2df47e$var$isHistoryMeta(historyMeta) && historyMeta.redo ? 'redo' : 'undo';
    }
    // The toolbar Delete control tags its transaction so we can report it
    // distinctly from a keyboard delete (both produce a plain ReplaceStep).
    if (tr.getMeta($92ceda184e2df47e$export$84cb2650bbe09e82) === 'deleteButton') return 'deleteButton';
    const hasStructuralStep = isSyncBlockActivationEnabled && tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceAroundStep));
    const hasReplaceStep = tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep));
    if (hasStructuralStep || !hasReplaceStep) return 'other';
    const { selection: selection } = state;
    const isNodeSelected = selection instanceof (0, $kCECX.NodeSelection) && (selection.node?.type.name === 'bodiedSyncBlock' || isSyncBlockActivationEnabled && selection.node?.type.name === 'syncBlock');
    return isNodeSelected ? 'selectionReplaced' : 'keyboardDelete';
};
const $92ceda184e2df47e$export$9feff71901283088 = (mechanism)=>{
    if (mechanism === 'undo') return 'prompted-undo';
    if (mechanism === 'deleteButton' || mechanism === 'keyboardDelete' || mechanism === 'selectionReplaced') return 'prompted-delete';
    return undefined;
};
/**
 * True when a source `bodiedSyncBlock` holds user content — i.e. not just the
 * single empty paragraph it is created with (used to detect empty→content).
 */ const $92ceda184e2df47e$var$bodiedSyncBlockHasContent = (node)=>{
    if (node.childCount === 0) return false;
    if (node.childCount === 1) {
        const child = node.firstChild;
        // A freshly-created block is a single empty paragraph; anything else
        // (non-empty paragraph, or a different/first block) counts as content.
        return !(child?.type.name === 'paragraph' && child.content.size === 0);
    }
    return true;
};
/**
 * Ask the store manager to fire the one-shot first-content-added event for every
 * populated source block. The manager only emits for blocks it created empty
 * this session and dedupes per block, so iterating all populated blocks is safe
 * and self-limiting. Called only when `hasEditInSyncBlock` flagged an in-block
 * edit, so this walk runs rarely.
 */ const $92ceda184e2df47e$var$emitFirstContentAddedForEditedBlocks = (tr, state, syncBlockStore)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    tr.doc.descendants((node)=>{
        if (node.type === bodiedSyncBlock) {
            if ($92ceda184e2df47e$var$bodiedSyncBlockHasContent(node)) syncBlockStore.sourceManager.maybeEmitFirstContentAdded(node.attrs.resourceId, node.attrs.localId);
            // bodiedSyncBlocks are top-level and not nested, so no need to descend.
            return false;
        }
        return true;
    });
};
const $92ceda184e2df47e$var$filterTransactionOnline = ({ tr: tr, state: state, syncBlockStore: syncBlockStore, api: api, confirmationTransactionRef: confirmationTransactionRef, ctx: ctx, bodiedSyncBlockRemoved: bodiedSyncBlockRemoved, bodiedSyncBlockAdded: bodiedSyncBlockAdded, extensionFlagShown: extensionFlagShown })=>{
    const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $8zLo1.trackSyncBlocks)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
    syncBlockRemoved.forEach((syncBlock)=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_DELETE,
            attributes: {
                resourceId: syncBlock.attrs.resourceId,
                blockInstanceId: syncBlock.attrs.localId
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    });
    // Annotate every reference-block insertion with `sourceProduct`
    // (derived from the resourceId) and `isPaste` (when the originating transaction was a
    // paste). Together with the host product reported by the embedding product's pageview
    // events this lets us triangulate cross-product paste behaviour without standing up a
    // dedicated `cross_product_paste` event subject.
    const isPaste = Boolean(tr.getMeta('paste') ?? tr.getMeta('uiEvent') === 'paste');
    const isPasteOrDrop = isPaste || tr.getMeta('uiEvent') === 'drop';
    const hasRemovedSyncBlock = syncBlockRemoved.length > 0 || bodiedSyncBlockRemoved.length > 0;
    const isCutRemoval = hasRemovedSyncBlock && ctx.consumeCutRemoval();
    const canPromptForRemoval = Boolean(ctx.onGiveFeedback) && hasRemovedSyncBlock && !(0, $jbOus.isDirtyTransaction)(tr) && !isCutRemoval && !isPasteOrDrop;
    const promptedFeedbackEntryPoint = canPromptForRemoval ? $92ceda184e2df47e$export$9feff71901283088($92ceda184e2df47e$export$d9923c7a8cbf31ed(tr, state)) : undefined;
    const entryPoint = promptedFeedbackEntryPoint && (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true) ? promptedFeedbackEntryPoint : undefined;
    if (entryPoint && syncBlockRemoved.length > 0 && bodiedSyncBlockRemoved.length === 0) tr.setMeta($92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey, {
        context: {
            blockType: 'reference',
            entryPoint: entryPoint
        }
    });
    syncBlockAdded.forEach((syncBlock)=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK,
            attributes: {
                resourceId: syncBlock.attrs.resourceId,
                blockInstanceId: syncBlock.attrs.localId,
                sourceProduct: (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlock.attrs.resourceId),
                isPaste: isPaste
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        });
    });
    if (bodiedSyncBlockRemoved.length > 0) {
        // Recompute the delete fresh from the live document on confirm
        // (see handleBodiedSyncBlockRemoval). See EDITOR-7889.
        const mechanism = $92ceda184e2df47e$export$d9923c7a8cbf31ed(tr, state);
        const feedbackContext = entryPoint && $92ceda184e2df47e$var$getDeleteReason(tr) !== 'source-block-unsynced' ? {
            blockType: 'source',
            entryPoint: entryPoint
        } : undefined;
        if (feedbackContext) {
            const sourceAttempt = ctx.queueSourceFeedback(feedbackContext);
            return (0, $aznRb.handleBodiedSyncBlockRemoval)(bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef, $92ceda184e2df47e$var$getDeleteReason(tr), mechanism, {
                onDeleteCompleted: (success)=>ctx.completeSourceDeletion(sourceAttempt, success),
                onDeleteTransaction: (deleteTr)=>deleteTr.setMeta($92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey, {
                        context: feedbackContext,
                        sourceAttempt: sourceAttempt
                    }),
                onDestroy: ()=>ctx.clearSourceFeedback(sourceAttempt)
            });
        }
        return (0, $aznRb.handleBodiedSyncBlockRemoval)(bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef, $92ceda184e2df47e$var$getDeleteReason(tr), mechanism, undefined);
    }
    if (bodiedSyncBlockAdded.length > 0) {
        if (tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) // We don't allow bodiedSyncBlock creation via redo, however, we need to return true here to let transaction through so history can be updated properly.
        // If we simply returns false, creation from redo is blocked as desired, but this results in editor showing redo as possible even though it's not.
        // After true is returned here and the node is created, we delete the node in the filterTransaction immediately, which cancels out the creation
        return true;
        // Defense-in-depth: if a bodiedSyncBlock arrives via paste or drag-and-drop,
        // it may have bypassed transformCopied (e.g. cut, browser clipboard).
        // Do not call createBlock — it would use this page's parentId which may
        // be wrong. The bodiedSyncBlock content will still be inserted but will
        // not be registered as a source block in Block Service, which is safer
        // than creating a zombie block under the wrong ARI.
        if (isPasteOrDrop) return true;
        // Forward creation-type signals captured by createSyncedBlock onto the async
        // `syncedBlockCreate` success event.
        const creationMeta = tr.getMeta($92ceda184e2df47e$export$cde24468c2642688);
        (0, $fQgiq.handleBodiedSyncBlockCreation)(bodiedSyncBlockAdded, state, api, creationMeta);
        return true;
    }
    // On an in-block edit, let the store manager fire the one-shot first-content
    // event (dedupe + empty→content scoping live there). After the add/remove
    // branches so it never runs for the creation transaction itself.
    if ((0, $8zLo1.hasEditInSyncBlock)(tr, state)) $92ceda184e2df47e$var$emitFirstContentAddedForEditedBlocks(tr, state, syncBlockStore);
    $92ceda184e2df47e$var$showExtensionInSyncBlockWarningIfNeeded(tr, state, api, extensionFlagShown);
    return true;
};
const $92ceda184e2df47e$var$filterTransactionOffline = ({ tr: tr, state: state, syncBlockStore: syncBlockStore, api: api, isConfirmedSyncBlockDeletion: isConfirmedSyncBlockDeletion, bodiedSyncBlockRemoved: bodiedSyncBlockRemoved, bodiedSyncBlockAdded: bodiedSyncBlockAdded })=>{
    const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $8zLo1.trackSyncBlocks)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
    let errorFlag = false;
    if (isConfirmedSyncBlockDeletion || bodiedSyncBlockRemoved.length > 0 || syncBlockRemoved.length > 0) errorFlag = (0, $kXmSu.FLAG_ID).CANNOT_DELETE_WHEN_OFFLINE;
    else if (bodiedSyncBlockAdded.length > 0 || syncBlockAdded.length > 0) errorFlag = (0, $kXmSu.FLAG_ID).CANNOT_CREATE_WHEN_OFFLINE;
    else if ((0, $8zLo1.hasEditInSyncBlock)(tr, state)) errorFlag = (0, $kXmSu.FLAG_ID).CANNOT_EDIT_WHEN_OFFLINE;
    if (errorFlag) {
        (0, $73IhX.deferDispatch)(()=>{
            api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                    activeFlag: {
                        id: errorFlag
                    }
                }));
        });
        return false;
    }
    return true;
};
/**
 * Build the status decoration set for sync-block nodes. This performs a full
 * `doc.descendants()` walk so it must only be called when a status signal
 * actually changes (offline, view-mode, dragging, pending-creation). Between
 * status changes the caller should use `decorationSet.map(tr.mapping, tr.doc)`
 * instead (see EDITOR-6930).
 */ const $92ceda184e2df47e$var$buildStatusDecorations = (doc, syncBlockStore, isOffline, isViewMode, isDragging)=>{
    // Fast path: when all status flags are off and no creations are in flight,
    // no node can produce a decoration — skip the full doc traversal.
    if (!isOffline && !isViewMode && !isDragging && !syncBlockStore.sourceManager.hasPendingCreations()) return (0, $8nvEM.DecorationSet).empty;
    const offlineDecorations = [];
    const viewModeDecorations = [];
    const loadingDecorations = [];
    const dragDecorations = [];
    doc.descendants((node, pos)=>{
        if (node.type.name === 'bodiedSyncBlock' && isOffline) offlineDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).disabledClassName
        }));
        if (syncBlockStore.isSyncBlock(node) && isViewMode) viewModeDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).viewModeClassName
        }));
        if (node.type.name === 'bodiedSyncBlock' && syncBlockStore.sourceManager.isPendingCreation(node.attrs.resourceId)) loadingDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).creationLoadingClassName
        }));
        if (isDragging && syncBlockStore.isSyncBlock(node)) dragDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).draggingClassName
        }));
        // only traverse the top-level node of the document, as syncBlock and bodiedSyncBlock are top-level nodes
        return false;
    });
    return (0, $8nvEM.DecorationSet).create(doc, [
        ...offlineDecorations,
        ...viewModeDecorations,
        ...loadingDecorations,
        ...dragDecorations
    ]);
};
/**
 * Encapsulates mutable state that persists across transactions in the
 * synced block plugin. Replaces module-level closure variables so state
 * is explicitly scoped to a single plugin instance.
 */ class $92ceda184e2df47e$var$SyncedBlockPluginContext {
    get isCopyEvent() {
        return this._isCopyEvent;
    }
    markCopyEvent() {
        this._isCopyEvent = true;
    }
    markCutEvent() {
        this._isCutEvent = true;
    }
    consumeCopyEvent() {
        const was = this._isCopyEvent;
        this._isCopyEvent = false;
        return was;
    }
    consumeCutEvent() {
        const was = this._isCutEvent;
        this._isCutEvent = false;
        return was;
    }
    markCutRemovalPending() {
        this._cutRemovalPending = true;
        const generation = ++this.cutRemovalGeneration;
        queueMicrotask(()=>{
            if (this.cutRemovalGeneration === generation) this._cutRemovalPending = false;
        });
    }
    consumeCutRemoval() {
        const wasPending = this._cutRemovalPending;
        this._cutRemovalPending = false;
        this.cutRemovalGeneration += 1;
        return wasPending;
    }
    queueSourceFeedback(context) {
        const sourceAttempt = Symbol('syncedBlockSourceFeedbackAttempt');
        this.pendingSourceFeedback = {
            context: context,
            deletionSucceeded: false,
            sourceAttempt: sourceAttempt,
            transactionApplied: false
        };
        return sourceAttempt;
    }
    completeSourceDeletion(sourceAttempt, success) {
        if (this.pendingSourceFeedback?.sourceAttempt !== sourceAttempt) return;
        if (!success) // Keep the attempt pending because retryDeletion reuses these callbacks.
        // Dismissal or cancellation clears it through the destroy callback.
        return;
        this.pendingSourceFeedback.deletionSucceeded = true;
        this.flushSourceFeedback(sourceAttempt);
    }
    clearSourceFeedback(sourceAttempt) {
        if (this.pendingSourceFeedback?.sourceAttempt === sourceAttempt) this.pendingSourceFeedback = undefined;
    }
    handleAppliedFeedback({ context: context, sourceAttempt: sourceAttempt }) {
        if (context.blockType === 'source' && sourceAttempt && this.pendingSourceFeedback?.sourceAttempt === sourceAttempt) {
            this.pendingSourceFeedback.transactionApplied = true;
            this.flushSourceFeedback(sourceAttempt);
            return;
        }
        if (context.blockType === 'reference') this.requestFeedbackPrompt(context);
    }
    flushSourceFeedback(sourceAttempt) {
        if (this.pendingSourceFeedback?.sourceAttempt === sourceAttempt && this.pendingSourceFeedback?.deletionSucceeded && this.pendingSourceFeedback.transactionApplied) {
            const { context: context } = this.pendingSourceFeedback;
            this.pendingSourceFeedback = undefined;
            this.requestFeedbackPrompt(context);
        }
    }
    requestFeedbackPrompt(context) {
        if (this.feedbackPromptConsumed) return;
        this.feedbackPromptConsumed = true;
        (0, $73IhX.deferDispatch)(()=>{
            try {
                const shouldShow = this.shouldShowFeedbackPrompt?.() ?? true;
                Promise.resolve(shouldShow).then((isEligible)=>{
                    if (!isEligible) return;
                    this.api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                            activeFlag: {
                                id: (0, $kXmSu.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT,
                                feedbackContext: context
                            }
                        }));
                }).catch(()=>{});
            } catch  {
            // Persisted feedback eligibility is optional product UI.
            }
        });
    }
    constructor(onGiveFeedback, shouldShowFeedbackPrompt, api){
        this.onGiveFeedback = onGiveFeedback;
        this.shouldShowFeedbackPrompt = shouldShowFeedbackPrompt;
        this.api = api;
        this.confirmationTransactionRef = {
            current: undefined
        };
        this._cutRemovalPending = false;
        this.cutRemovalGeneration = 0;
        this._isCopyEvent = false;
        this._isCutEvent = false;
        this.feedbackPromptConsumed = false;
        this.pendingSourceFeedback = void 0;
        this.unpublishedFlagShown = new Set();
        this.extensionFlagShown = new Set();
    }
}
const $92ceda184e2df47e$export$ae829ec7b2625219 = (options, pmPluginFactoryParams, syncBlockStore, api)=>{
    const { useLongPressSelection: useLongPressSelection = false } = options || {};
    const ctx = new $92ceda184e2df47e$var$SyncedBlockPluginContext(options?.onGiveFeedback, options?.shouldShowFeedbackPrompt, api);
    const confirmationTransactionRef = ctx.confirmationTransactionRef;
    const unpublishedFlagShown = ctx.unpublishedFlagShown;
    const extensionFlagShown = ctx.extensionFlagShown;
    // Update plugin state post-flush to sync hasUnsavedBodiedSyncBlockChanges.
    // It prevents false "Changes may not be saved" warnings when publishing
    // Classic pages with sync blocks.
    syncBlockStore.sourceManager.registerFlushCompletionCallback(()=>{
        (0, $73IhX.deferDispatch)(()=>{
            api?.core.actions.execute(({ tr: tr })=>tr);
        });
    });
    // Trigger a deferred flush when block creation completes after the initial
    // flush timed out waiting for it. This ensures content created from
    // existing text is eventually persisted even if no further edits are made.
    // See EDITOR-7112.
    syncBlockStore.sourceManager.registerPostCreationFlushCallback(()=>{
        (0, $73IhX.deferDispatch)(()=>{
            syncBlockStore.sourceManager.flush();
        });
    });
    // Set up callback to detect unpublished sync blocks when they're fetched
    syncBlockStore.referenceManager.setOnUnpublishedSyncBlockDetected((resourceId)=>{
        // Only show the flag once per sync block
        if (!unpublishedFlagShown.has(resourceId)) {
            unpublishedFlagShown.add(resourceId);
            // Surface the source product so the flag's copy can be tailored — Jira work
            // items get "Pasted from unsaved item" / "...when the item's description is
            // saved" rather than the Confluence page-flavoured default. Falls back to
            // undefined when the resourceId can't be parsed (legacy shapes), in which
            // case the Confluence default is used.
            const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
            (0, $73IhX.deferDispatch)(()=>{
                api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                        activeFlag: {
                            id: (0, $kXmSu.FLAG_ID).UNPUBLISHED_SYNC_BLOCK_PASTED,
                            sourceProduct: sourceProduct
                        }
                    }));
            });
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $92ceda184e2df47e$export$cb5a03b39dafc9cc,
        state: {
            init (_, instance) {
                // When the document has no synced blocks, we skip the eager fetch +
                // cache walks. They will be re-run lazily by `apply` the first time a
                // synced block enters the document (paste, collab insert, or
                // programmatic insert).
                const docHasSyncedBlocks = (0, $fTCnv.hasSyncedBlocks)(instance.doc);
                if (docHasSyncedBlocks) {
                    const syncBlockNodes = instance.doc.children.filter(syncBlockStore.referenceManager.isReferenceBlock);
                    syncBlockStore.referenceManager.fetchSyncBlocksData((0, $d04Ge.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
                    // Populate source sync block cache from initial document.
                    // This replaces the constructor call in the nodeview.
                    instance.doc.forEach((node)=>{
                        if (syncBlockStore.sourceManager.isSourceBlock(node)) syncBlockStore.sourceManager.updateSyncBlockData(node, false);
                    });
                    // Fetch statuses from the backend so we can identify unpublished blocks on cancel
                    syncBlockStore.sourceManager.fetchAndCacheStatuses();
                }
                // Read initial shared-state signals for status decorations
                const initIsOffline = (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
                const initIsViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                const initIsDragging = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging';
                // Build initial status decoration set (EDITOR-6930).
                // When the perf gate is ON and the doc has synced blocks we do a
                // single traversal here; afterwards `apply()` will map or rebuild
                // only when a status signal changes.
                const initStatusDecorationSet = docHasSyncedBlocks ? $92ceda184e2df47e$var$buildStatusDecorations(instance.doc, syncBlockStore, initIsOffline, initIsViewMode, initIsDragging) : (0, $8nvEM.DecorationSet).empty;
                return {
                    selectionDecorationSet: (0, $6hFNe.calculateDecorations)(instance.doc, instance.selection, instance.schema),
                    activeFlag: false,
                    syncBlockStore: syncBlockStore,
                    retryCreationPosMap: new Map(),
                    hasSyncedBlocks: docHasSyncedBlocks,
                    hasUnsavedBodiedSyncBlockChanges: syncBlockStore.sourceManager.hasUnsavedChanges(),
                    statusDecorationSet: initStatusDecorationSet,
                    prevIsOffline: initIsOffline,
                    prevIsViewMode: initIsViewMode,
                    prevIsDragging: initIsDragging
                };
            },
            apply: (tr, currentPluginState, oldEditorState)=>{
                const meta = tr.getMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc);
                const { activeFlag: activeFlag, selectionDecorationSet: selectionDecorationSet, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, retryCreationPosMap: retryCreationPosMap, hasSyncedBlocks: prevHasSyncedBlocks, statusDecorationSet: prevStatusDecorationSet, prevIsOffline: prevOffline, prevIsViewMode: prevViewMode, prevIsDragging: prevDragging } = currentPluginState;
                // Pre-compute once so the fast-path probe and the bottom ref-equality
                // short-circuit share the same source-manager snapshot. Track C will make this O(1).
                const nextHasUnsavedBodiedSyncBlockChanges = syncBlockStore.sourceManager.hasUnsavedChanges();
                // --- Fast path (EDITOR-6934 follow-up, see Confluence 7050540723 §9.3 / §9.9):
                // when no plugin meta is set, and neither the document nor selection changed,
                // most synced-block plugin state cannot change. The source manager is mutable
                // outside ProseMirror transactions, though, so preserve existing empty-transaction
                // sync semantics by checking that snapshot first.
                //
                // Note: selection-only transactions intentionally fall through to the normal
                // apply path because calculateDecorations depends on drag/view-mode state
                // that is not captured here.
                //
                // We also need to ensure shared-state signals (drag, offline, view-mode)
                // haven't changed — these are propagated via empty transactions and drive
                // status decoration rebuilds (e.g. drag border). Without this check the
                // fast path would swallow drag-start transactions and the synced block
                // border would never appear (see VR test: synced-block-drag-selection).
                if (!meta && !tr.docChanged && tr.selection.eq(oldEditorState.selection) && nextHasUnsavedBodiedSyncBlockChanges === currentPluginState.hasUnsavedBodiedSyncBlockChanges && api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging' === prevDragging && (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode) === prevOffline && api?.editorViewMode?.sharedState.currentState()?.mode === 'view' === prevViewMode) return currentPluginState;
                // Lazy-init bookkeeping: once a synced block enters the document we
                // flip `hasSyncedBlocks` to `true` for the lifetime of this editor
                let nextHasSyncedBlocks = prevHasSyncedBlocks;
                if (!prevHasSyncedBlocks && tr.docChanged) {
                    if ((0, $dIIrm.transactionInsertsSyncedBlock)(tr)) nextHasSyncedBlocks = true;
                }
                let newDecorationSet = tr.docChanged ? selectionDecorationSet.map(tr.mapping, tr.doc) // only map if document changed
                 : selectionDecorationSet;
                if (!tr.selection.eq(oldEditorState.selection)) newDecorationSet = (0, $6hFNe.calculateDecorations)(tr.doc, tr.selection, tr.doc.type.schema);
                else if (tr.docChanged) {
                    const existingDecorationsLength = selectionDecorationSet.find().length;
                    const newDecorationsLength = newDecorationSet.find().length;
                    // Edge case: When document nodes are replaced, the mapping can lose decorations
                    // We rebuild decorations when the document changes but the selection hasn't.
                    // We can do this check because we only expect 1 decoration for the selection
                    if (existingDecorationsLength !== newDecorationsLength) newDecorationSet = (0, $6hFNe.calculateDecorations)(tr.doc, tr.selection, tr.doc.type.schema);
                }
                // --- Status decoration set (EDITOR-6930) ---
                // When the perf gate is ON we maintain `statusDecorationSet` in
                // plugin state so the `decorations` prop becomes an O(1) lookup.
                let nextStatusDecorationSet = prevStatusDecorationSet;
                let nextIsOffline = prevOffline;
                let nextIsViewMode = prevViewMode;
                let nextIsDragging = prevDragging;
                if (!nextHasSyncedBlocks) // No synced blocks → keep empty status decorations
                nextStatusDecorationSet = (0, $8nvEM.DecorationSet).empty;
                else {
                    // Read current shared-state signals
                    nextIsOffline = (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
                    nextIsViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                    nextIsDragging = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging';
                    // Determine whether we need a full rebuild or a cheap map
                    const hasSyncedBlocksJustFlipped = nextHasSyncedBlocks && !prevHasSyncedBlocks;
                    const statusSignalChanged = nextIsOffline !== prevOffline || nextIsViewMode !== prevViewMode || nextIsDragging !== prevDragging;
                    // Meta-driven status changes (e.g. pending creation
                    // completed, retry creation pos updated)
                    const hasMetaStatusChange = !!meta?.retryCreationPos || !!meta?.activeFlag;
                    if (hasSyncedBlocksJustFlipped || statusSignalChanged || hasMetaStatusChange) // Full rebuild — a status signal changed
                    nextStatusDecorationSet = $92ceda184e2df47e$var$buildStatusDecorations(tr.doc, syncBlockStore, nextIsOffline, nextIsViewMode, nextIsDragging);
                    else if (tr.docChanged) // Cheap map — positions shifted but status unchanged
                    nextStatusDecorationSet = prevStatusDecorationSet.map(tr.mapping, tr.doc);
                // else: nothing changed, keep same reference
                }
                const newPosEntry = meta?.retryCreationPos;
                const newRetryCreationPosMap = $92ceda184e2df47e$var$mapRetryCreationPosMap(retryCreationPosMap, newPosEntry, tr.mapping.map.bind(tr.mapping));
                const nextActiveFlag = meta?.activeFlag ?? activeFlag;
                const nextBodiedSyncBlockDeletionStatus = meta?.bodiedSyncBlockDeletionStatus ?? bodiedSyncBlockDeletionStatus;
                // --- Reference equality (EDITOR-6929): return the same object
                // when ALL fields are reference-equal to avoid SharedStateAPI
                // notifying subscribers and triggering React re-renders. ---
                if (nextActiveFlag === activeFlag && newDecorationSet === selectionDecorationSet && newRetryCreationPosMap === retryCreationPosMap && nextHasSyncedBlocks === prevHasSyncedBlocks && nextBodiedSyncBlockDeletionStatus === bodiedSyncBlockDeletionStatus && nextHasUnsavedBodiedSyncBlockChanges === currentPluginState.hasUnsavedBodiedSyncBlockChanges && nextStatusDecorationSet === prevStatusDecorationSet && nextIsOffline === prevOffline && nextIsViewMode === prevViewMode && nextIsDragging === prevDragging) return currentPluginState;
                return {
                    activeFlag: nextActiveFlag,
                    selectionDecorationSet: newDecorationSet,
                    syncBlockStore: syncBlockStore,
                    retryCreationPosMap: newRetryCreationPosMap,
                    hasSyncedBlocks: nextHasSyncedBlocks,
                    bodiedSyncBlockDeletionStatus: nextBodiedSyncBlockDeletionStatus,
                    hasUnsavedBodiedSyncBlockChanges: nextHasUnsavedBodiedSyncBlockChanges,
                    statusDecorationSet: nextStatusDecorationSet,
                    prevIsOffline: nextIsOffline,
                    prevIsViewMode: nextIsViewMode,
                    prevIsDragging: nextIsDragging
                };
            }
        },
        props: {
            nodeViews: {
                syncBlock: (node, view, getPos, _decorations)=>// To support SSR, pass `syncBlockStore` here
                    // and do not use lazy loading.
                    // We cannot start rendering and then load `syncBlockStore` asynchronously,
                    // because obtaining it is asynchronous (sharedPluginState.currentState() is delayed).
                    new (0, $gx781.SyncBlock)({
                        api: api,
                        options: options,
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI,
                        eventDispatcher: pmPluginFactoryParams.eventDispatcher,
                        syncBlockStore: syncBlockStore,
                        intl: pmPluginFactoryParams.getIntl()
                    }).init(),
                bodiedSyncBlock: (0, $1Jyys.bodiedSyncBlockNodeView)({
                    pluginOptions: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api,
                    syncBlockStore: syncBlockStore
                })
            },
            decorations: (state)=>{
                const currentPluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(state);
                if (!currentPluginState) return (0, $8nvEM.DecorationSet).empty;
                const { selectionDecorationSet: selectionDecorationSet, statusDecorationSet: statusDecorationSet, hasSyncedBlocks: docHasSyncedBlocks } = currentPluginState;
                // When the perf gate is ON, both `selectionDecorationSet` and
                // `statusDecorationSet` are maintained in plugin state by
                // `apply()`. The `decorations` prop is now an O(1) merge of
                // the two cached sets — no `doc.descendants()` walk, no
                // shared-state reads.
                if (!docHasSyncedBlocks) return selectionDecorationSet;
                // Focus state is read live here (single cheap read) because
                // it only gates whether selection decorations are included —
                // it does not affect the status decoration set and can change
                // within the same transaction cycle.
                const hasFocus = api?.focus?.sharedState?.currentState()?.hasFocus ?? true;
                // Merge selection + status decorations.
                // When the editor is unfocused,
                // omit selection decorations (matches old behaviour).
                const statusDecorations = statusDecorationSet.find();
                if (statusDecorations.length === 0) return hasFocus ? selectionDecorationSet : (0, $8nvEM.DecorationSet).empty;
                else return hasFocus ? selectionDecorationSet.add(state.doc, statusDecorations) : statusDecorationSet;
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'bodiedSyncBlock'
            ], (target)=>!!target.closest(`.${(0, $95bQO.BodiedSyncBlockSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                mouseover (view, event) {
                    return (0, $3k2Mh.shouldIgnoreDomEvent)(view, event, api);
                },
                mousedown (view, event) {
                    return (0, $3k2Mh.shouldIgnoreDomEvent)(view, event, api);
                },
                copy: ()=>{
                    ctx.markCopyEvent();
                    return false;
                },
                cut: ()=>{
                    ctx.consumeCutEvent();
                    ctx.markCutEvent();
                    return false;
                }
            },
            transformPasted: (slice, _view)=>{
                // Defense against bodiedSyncBlock nodes arriving via paste
                // (e.g. drag-and-drop, cut-paste, or browser-level clipboard
                // operations that bypass the transformCopied handler).
                // We cannot convert to a syncBlock reference here because we don't
                // know the source page's parentId (generateResourceIdForReference
                // would use the current page's parentId which is wrong).
                // Instead, strip the bodiedSyncBlock wrapper and keep only the
                // inner content to prevent createBlock being called with the
                // wrong parentId.
                return (0, $fud2r.mapSlice)(slice, (node)=>{
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) // Return the inner content without the sync block wrapper.
                    // This is the same behavior as when a partial selection of
                    // a bodiedSyncBlock is copied (see transformCopied line 937).
                    return node.content;
                    return node;
                });
            },
            transformCopied: (slice, { state: state })=>{
                const pluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(state);
                const syncBlockStore = pluginState?.syncBlockStore;
                const { schema: schema } = state;
                const isCopy = ctx.consumeCopyEvent();
                const isCut = ctx.consumeCutEvent();
                // A prompted feedback cut is always a cut, so the two never need combining.
                const isPromptedFeedbackCut = Boolean(syncBlockStore && options?.onGiveFeedback && isCut) && (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true);
                if (!syncBlockStore || !isCopy && !isCut) return slice;
                let containsCutSyncBlock = false;
                const transformedSlice = (0, $fud2r.mapSlice)(slice, (node)=>{
                    if (syncBlockStore.referenceManager.isReferenceBlock(node)) {
                        if (isCut) {
                            containsCutSyncBlock = isPromptedFeedbackCut;
                            return node;
                        }
                        $92ceda184e2df47e$var$showCopiedFlag(api, options?.__livePage, syncBlockStore.referenceManager.getFromCache(node.attrs.resourceId)?.data?.status === 'unpublished', (0, $d04Ge.getSourceProductFromResourceIdSafe)(node.attrs.resourceId));
                        return node;
                    }
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) {
                        if (isPromptedFeedbackCut && (0, $73IhX.sliceFullyContainsNode)(slice, node)) containsCutSyncBlock = true;
                        // if we only selected part of the bodied sync block content,
                        // remove the sync block node and only keep the content
                        if (!(0, $73IhX.sliceFullyContainsNode)(slice, node)) return node.content;
                        if (isCut) return node;
                        const newResourceId = syncBlockStore.referenceManager.generateResourceIdForReference(node.attrs.resourceId);
                        $92ceda184e2df47e$var$showCopiedFlag(api, options?.__livePage, syncBlockStore.sourceManager.getStatus(node.attrs.resourceId) !== 'active', (0, $d04Ge.getSourceProductFromResourceIdSafe)(newResourceId));
                        // Convert bodiedSyncBlock to syncBlock
                        // The paste transformation will regenrate the localId
                        const newAttrs = {
                            ...node.attrs,
                            resourceId: newResourceId
                        };
                        const newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter((mark)=>schema.nodes.syncBlock.markSet?.includes(mark.type)) : node.marks;
                        return schema.nodes.syncBlock.create(newAttrs, null, newMarks);
                    }
                    return node;
                });
                if (containsCutSyncBlock) ctx.markCutRemovalPending();
                return transformedSlice;
            }
        },
        filterTransaction: (tr, state)=>{
            // Lazy-init: when no synced block currently exists in the doc and the
            // transaction does not insert one, all downstream filter logic is a
            // no-op. Avoid both the shared-state reads and the `trackSyncBlocks`
            // walks for the ~99.97% of pages that have no synced blocks.
            const pluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(state);
            if (pluginState && !pluginState.hasSyncedBlocks && !(0, $dIIrm.transactionInsertsSyncedBlock)(tr)) return true;
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            if (viewMode === 'view') return true;
            const isOffline = (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
            const isConfirmedSyncBlockDeletion = Boolean(tr.getMeta('isConfirmedSyncBlockDeletion'));
            // Track newly added reference sync blocks before processing the transaction
            if (tr.docChanged && !tr.getMeta('isRemote')) {
                const { added: added } = (0, $8zLo1.trackSyncBlocks)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
                added.forEach((nodeInfo)=>{
                    if (nodeInfo.attrs?.resourceId) syncBlockStore.referenceManager.markAsNewlyAdded(nodeInfo.attrs.resourceId);
                });
            }
            // if doc changed and it's a remote transaction, check if any synced block were added,
            // and if so, for source synced blocks, ensure we update the cache with them
            // and for reference synced blocks, ensure we fetch the data from the server
            if (tr.docChanged && tr.getMeta('isRemote')) {
                const { added: added } = (0, $8zLo1.trackSyncBlocks)((node)=>syncBlockStore.isSyncBlock(node), tr, state);
                const sourceSyncBlockNodes = added.filter((nodeInfo)=>nodeInfo.node && syncBlockStore.sourceManager.isSourceBlock(nodeInfo.node));
                const referenceSyncBlockNodes = added.filter((nodeInfo)=>nodeInfo.node && syncBlockStore.referenceManager.isReferenceBlock(nodeInfo.node));
                sourceSyncBlockNodes.forEach((nodeInfo)=>{
                    if (nodeInfo.attrs?.resourceId && nodeInfo.node) syncBlockStore.sourceManager.updateSyncBlockData(nodeInfo.node, tr.getMeta('isRemote'));
                });
                // Fetch statuses for remotely-added source sync blocks
                // so we can identify unpublished blocks on cancel
                if (sourceSyncBlockNodes.length > 0) syncBlockStore.sourceManager.fetchAndCacheStatuses();
                const syncBlockNodes = referenceSyncBlockNodes.map((nodeInfo)=>nodeInfo.node).filter((node)=>node !== undefined);
                syncBlockStore.referenceManager.fetchSyncBlocksData((0, $d04Ge.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
            }
            if (!tr.docChanged || Boolean(tr.getMeta('isRemote')) || !isOffline && isConfirmedSyncBlockDeletion) return true;
            const { removed: bodiedSyncBlockRemoved, added: bodiedSyncBlockAdded } = (0, $8zLo1.trackSyncBlocks)(syncBlockStore.sourceManager.isSourceBlock, tr, state);
            return isOffline ? $92ceda184e2df47e$var$filterTransactionOffline({
                tr: tr,
                state: state,
                syncBlockStore: syncBlockStore,
                api: api,
                isConfirmedSyncBlockDeletion: isConfirmedSyncBlockDeletion,
                bodiedSyncBlockRemoved: bodiedSyncBlockRemoved,
                bodiedSyncBlockAdded: bodiedSyncBlockAdded
            }) : $92ceda184e2df47e$var$filterTransactionOnline({
                tr: tr,
                state: state,
                syncBlockStore: syncBlockStore,
                api: api,
                confirmationTransactionRef: confirmationTransactionRef,
                ctx: ctx,
                bodiedSyncBlockRemoved: bodiedSyncBlockRemoved,
                bodiedSyncBlockAdded: bodiedSyncBlockAdded,
                extensionFlagShown: extensionFlagShown
            });
        },
        appendTransaction: (trs, oldState, newState)=>{
            // Lazy-init: when neither the previous nor the new state contains a
            // synced block (and none of the dispatched transactions inserts one),
            // skip all downstream work. This is the hot path on the ~99.97% of
            // pages that don't use synced blocks (see EDITOR-6586).
            const oldPluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(oldState);
            const newPluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(newState);
            const hadOrHasSyncedBlocks = !!oldPluginState?.hasSyncedBlocks || !!newPluginState?.hasSyncedBlocks;
            if (!hadOrHasSyncedBlocks) return null;
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            if (viewMode === 'view') return null;
            if (options?.onGiveFeedback) {
                const feedbackContexts = trs.flatMap((tr)=>{
                    const feedbackContext = tr.getMeta($92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey);
                    return feedbackContext ? [
                        feedbackContext
                    ] : [];
                });
                if (feedbackContexts.length > 0 && (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true)) feedbackContexts.forEach((feedbackContext)=>{
                    ctx.handleAppliedFeedback(feedbackContext);
                });
            }
            // Update source sync block cache for user-initiated changes only.
            // Cache updates are handled here instead of in the nodeview update() so we
            // can filter out non-user changes (remote collab, dirty programmatic txns).
            const isUserChange = (tr)=>tr.docChanged && !(0, $jbOus.isDirtyTransaction)(tr) && !tr.getMeta('isRemote');
            const hasSourceBlockEdit = trs.some((tr)=>isUserChange(tr) && (0, $8zLo1.hasEditInSyncBlock)(tr, oldState));
            if (hasSourceBlockEdit) newState.doc.forEach((node)=>{
                if (syncBlockStore.sourceManager.isSourceBlock(node)) syncBlockStore.sourceManager.updateSyncBlockData(node, false);
            });
            for (const tr of trs)if (tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) {
                const { added: added } = (0, $8zLo1.trackSyncBlocks)(syncBlockStore.sourceManager.isSourceBlock, tr, oldState);
                if (added.length > 0) {
                    // Delete bodiedSyncBlock if it's originated from history, i.e. redo creation
                    // See filterTransaction above for more details
                    const { tr: tr } = newState;
                    added.forEach((node)=>{
                        if (node.from !== undefined && node.to !== undefined) tr.delete(node.from, node.to);
                    });
                    return tr;
                }
            }
            // Detect and remove duplicate bodiedSyncBlock resourceIds.
            // When a block template containing a source sync block is inserted into the
            // same document, it creates a duplicate with the same resourceId. We keep the
            // first occurrence and delete subsequent duplicates entirely (including their
            // contents), since a document must not contain two source sync blocks with the
            // same resourceId.
            if (trs.some((tr)=>tr.docChanged && !tr.getMeta('isRemote'))) {
                // Quick check: only walk the full document when at least one
                // transaction inserted a source synced block. This avoids an
                // expensive descendants() traversal on every local edit.
                const hasInsertedSourceBlock = trs.some((tr)=>{
                    if (!tr.docChanged || tr.getMeta('isRemote')) return false;
                    return tr.steps.some((step)=>{
                        if (!(step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep)) || !('slice' in step)) return false;
                        const { slice: slice } = step;
                        let found = false;
                        slice.content.descendants((node)=>{
                            if (syncBlockStore.sourceManager.isSourceBlock(node) && node.attrs.resourceId) found = true;
                            return false;
                        });
                        return found;
                    });
                });
                if (!hasInsertedSourceBlock) return null;
                const seenResourceIds = new Set();
                const duplicates = [];
                newState.doc.descendants((node, pos)=>{
                    if (syncBlockStore.sourceManager.isSourceBlock(node) && node.attrs.resourceId) {
                        if (seenResourceIds.has(node.attrs.resourceId)) duplicates.push({
                            pos: pos,
                            nodeSize: node.nodeSize
                        });
                        else seenResourceIds.add(node.attrs.resourceId);
                        return false;
                    }
                });
                if (duplicates.length > 0) {
                    const { tr: tr } = newState;
                    // Delete in reverse document order so positions remain valid
                    for(let i = duplicates.length - 1; i >= 0; i--){
                        const dup = duplicates[i];
                        tr.delete(dup.pos, dup.pos + dup.nodeSize);
                    }
                    tr.setMeta('addToHistory', false);
                    (0, $73IhX.deferDispatch)(()=>{
                        api?.core?.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                                activeFlag: {
                                    id: (0, $kXmSu.FLAG_ID).DUPLICATE_SOURCE_SYNC_BLOCK
                                }
                            }));
                    });
                    return tr;
                }
            }
            return null;
        }
    });
};
module.exports["syncedBlockPluginKey"] = $92ceda184e2df47e$export$cb5a03b39dafc9cc;
module.exports["deleteMechanismMetaKey"] = $92ceda184e2df47e$export$84cb2650bbe09e82;
module.exports["creationMetaKey"] = $92ceda184e2df47e$export$cde24468c2642688;
module.exports["createPlugin"] = $92ceda184e2df47e$export$ae829ec7b2625219;

});

parcelRegister("1Jyys", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $h75sz = parcelRequire("h75sz");


var $95bQO = parcelRequire("95bQO");


var $6Ixg8 = parcelRequire("6Ixg8");


var $aPdNQ = parcelRequire("aPdNQ");


var $fXTqR = parcelRequire("fXTqR");


var $87KuW = parcelRequire("87KuW");

const $d6e50e685ac89fcf$var$toDOM = (node)=>[
        'div',
        {
            class: `${(0, $95bQO.BodiedSyncBlockSharedCssClassName).prefix} bodiedSyncBlockView-content-wrap`,
            localid: node.attrs.localId,
            resourceid: node.attrs.resourceId
        },
        [
            'div',
            {
                class: (0, $95bQO.BodiedSyncBlockSharedCssClassName).content,
                contenteditable: 'true'
            },
            0
        ]
    ];
class $d6e50e685ac89fcf$export$e287a7d211075664 {
    updateContentEditable({ nextConnectivityMode: nextConnectivityMode, nextViewMode: nextViewMode }) {
        const connectivityMode = nextConnectivityMode ?? this.api?.connectivity?.sharedState?.currentState()?.mode;
        const viewMode = nextViewMode ?? this.api?.editorViewMode?.sharedState?.currentState()?.mode;
        const isOnline = !(0, $6Ixg8.isOfflineMode)(connectivityMode);
        const isEditMode = viewMode !== 'view';
        const shouldBeEditable = isOnline && isEditMode;
        this.contentDOM.setAttribute('contenteditable', shouldBeEditable ? 'true' : 'false');
    }
    handleConnectivityModeChange() {
        if (this.api?.connectivity) this.cleanupConnectivityModeListener = this.api.connectivity.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateContentEditable({
                nextConnectivityMode: nextSharedState.mode
            });
        });
    }
    handleViewModeChange() {
        if (this.api?.editorViewMode) this.cleanupViewModeListener = this.api.editorViewMode.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateContentEditable({
                nextViewMode: nextSharedState?.mode
            });
        });
    }
    /**
   * Marks the block as empty so the source placeholder can be shown purely from document state.
   * See `isEmptySourceSyncBlock` for why the DOM is not used to decide this.
   */ updateEmptyClass() {
        this.dom.classList.toggle((0, $95bQO.BodiedSyncBlockSharedCssClassName).empty, (0, $87KuW.isEmptySourceSyncBlock)(this.node));
    }
    update(node) {
        if (this.node.type !== node.type) return false;
        // Cache updates are handled in appendTransaction where we can
        // filter out non-user changes (remote collab, table auto-scale, etc.)
        this.node = node;
        this.updateEmptyClass();
        return true;
    }
    ignoreMutation(mutation) {
        if (mutation.type === 'selection') return false;
        return true;
    }
    destroy() {
        this.cleanupConnectivityModeListener?.();
        this.cleanupViewModeListener?.();
        this.nodeViewPortalProviderAPI.remove(this.labelKey);
    }
    constructor(node, view, getPos, api, nodeViewPortalProviderAPI){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.api = void 0;
        this.cleanupConnectivityModeListener = void 0;
        this.cleanupViewModeListener = void 0;
        this.labelKey = void 0;
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.api = api;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView serialization must target active runtime document
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $d6e50e685ac89fcf$var$toDOM(this.node));
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Render the label into a separate container so portal implementations that
        // write directly into the target do not clobber contentDOM. This also covers
        // SSR, where the portal's renderToStaticMarkup + innerHTML would clobber it.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView DOM must be created against active runtime document
        const labelContainer = document.createElement('div');
        this.dom.appendChild(labelContainer);
        this.labelKey = crypto.randomUUID();
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                componentId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_LABEL,
                dispatchAnalyticsEvent: this.api?.analytics?.actions.fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fXTqR.SyncBlockLabel), {
                    isSource: true,
                    localId: node.attrs.localId
                })
            }), labelContainer, this.labelKey);
        this.updateContentEditable({});
        this.updateEmptyClass();
        this.handleConnectivityModeChange();
        this.handleViewModeChange();
    // Cache is populated in state.init() and updated in appendTransaction,
    // so no additional updateSyncBlockData call is needed here.
    }
}
const $d6e50e685ac89fcf$export$89bdce39123f4223 = (props)=>{
    const { api: api, pmPluginFactoryParams: { nodeViewPortalProviderAPI: nodeViewPortalProviderAPI } } = props;
    return (node, view, getPos)=>{
        return new $d6e50e685ac89fcf$export$e287a7d211075664(node, view, getPos, api, nodeViewPortalProviderAPI);
    };
};
module.exports["bodiedSyncBlockNodeView"] = $d6e50e685ac89fcf$export$89bdce39123f4223;

});

parcelRegister("fXTqR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $95bQO = parcelRequire("95bQO");


var $3rarE = parcelRequire("3rarE");


var $4aRua = parcelRequire("4aRua");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $6XroG = parcelRequire("6XroG");

const $74d9a790701b865f$var$SyncBlockLabelDataId = 'sync-block-label';
const $74d9a790701b865f$var$SyncBlockLabelComponent = ({ contentUpdatedAt: contentUpdatedAt, isSource: isSource, localId: localId, title: title, isUnsyncedBlock: isUnsyncedBlock })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const [tooltipContent, setTooltipContent] = (0, $cozmU.useState)(formatMessage((0, $aI2Eh.syncBlockMessages).defaultSyncBlockTooltip));
    let tooltipMessage = formatMessage((0, $aI2Eh.syncBlockMessages).defaultSyncBlockTooltip);
    if (title) tooltipMessage = formatMessage((0, $aI2Eh.syncBlockMessages).referenceSyncBlockTooltip, {
        title: title
    });
    const updateTooltipContent = (0, $cozmU.useCallback)(()=>{
        let tooltipContent = tooltipMessage;
        if (contentUpdatedAt) {
            const elapsedTime = (0, $6XroG.formatElapsedTime)(contentUpdatedAt, intl);
            tooltipContent = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                children: [
                    title ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "small",
                                color: "color.text.inverse",
                                weight: "bold",
                                children: formatMessage((0, $aI2Eh.syncBlockMessages).referenceSyncBlockSyncedFrom)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
                                size: "small",
                                color: "color.text.inverse",
                                children: [
                                    ' ',
                                    title
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        children: tooltipMessage
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        weight: "bold",
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).referenceSyncBlockLastEdited)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        children: [
                            ' ',
                            elapsedTime
                        ]
                    })
                ]
            });
        }
        setTooltipContent(tooltipContent);
    }, [
        contentUpdatedAt,
        formatMessage,
        intl,
        title,
        tooltipMessage
    ]);
    const ariaDescribedById = `sync-block-label-description-${localId}`;
    const getLabelContent = (0, $cozmU.useMemo)(()=>{
        if (isUnsyncedBlock) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle",
            children: formatMessage((0, $aI2Eh.syncBlockMessages).unsyncedBlockLabel)
        });
        if (isSource) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle",
            children: formatMessage((0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? (0, $aI2Eh.syncBlockMessages).sourceSyncedBlockLabel : (0, $aI2Eh.syncBlockMessages).syncedBlockLabel)
        });
        if (!title) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle",
            children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedBlockLabel)
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            size: "small",
            color: "color.text.subtle",
            children: title
        });
    }, [
        formatMessage,
        isSource,
        isUnsyncedBlock,
        title
    ]);
    const label = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": $74d9a790701b865f$var$SyncBlockLabelDataId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $95bQO.SyncBlockLabelSharedCssClassName).labelClassName,
        "aria-describedby": isSource || isUnsyncedBlock ? undefined : ariaDescribedById,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
                color: "var(--ds-icon-subtle, #505258)",
                size: "small",
                label: ""
            }),
            getLabelContent
        ]
    });
    if (isSource || isUnsyncedBlock) return label;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $lpNn5.default), {
        position: "top",
        content: tooltipContent,
        // workaround because tooltip adds aria-describedby with a new id every time the tooltip is opened
        // this causes an infinite rerender loop because of the forwardRef from the node view we are inside in bodiedSyncBlock
        // tooltip content is available for screen readers in visually hidden content after the label
        isScreenReaderAnnouncementDisabled: true,
        // using this to ensure that the 'last edited' time is updated when the tooltip is opened
        onShow: updateTooltipContent,
        children: [
            label,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                id: ariaDescribedById,
                children: (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? tooltipMessage : tooltipContent
            })
        ]
    });
};
const $74d9a790701b865f$export$af6d83e4f9d69ba5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($74d9a790701b865f$var$SyncBlockLabelComponent);
module.exports["SyncBlockLabel"] = $74d9a790701b865f$export$af6d83e4f9d69ba5;

});

parcelRegister("3rarE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84739518118048ed21db64d5f304c13b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $280bfedcae88aedb$var$_react = $280bfedcae88aedb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $280bfedcae88aedb$var$_baseNew = $280bfedcae88aedb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $280bfedcae88aedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BlockSynced".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/block-synced
 * Usage guidance:
 * Reserved for syncing content blocks in Editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $280bfedcae88aedb$var$BlockSyncedIcon = (props)=>/*#__PURE__*/ $280bfedcae88aedb$var$_react.default.createElement($280bfedcae88aedb$var$_baseNew.default, Object.assign({
        name: "BlockSyncedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h-1.5z"/><path fill="currentcolor" d="M14.9 8.71a3.75 3.75 0 0 1 0 5.303l-.024.026.439.146a.75.75 0 0 1-.13 1.454l-2.476.354a.75.75 0 0 1-.848-.849l.353-2.474.029-.125a.75.75 0 0 1 1.425-.006l.147.44.025-.026a2.25 2.25 0 0 0 0-3.183l-.707-.707 1.06-1.06zm-3.818-1.98a.75.75 0 0 1 .85.849l-.354 2.475a.75.75 0 0 1-1.454.13l-.147-.44-.025.026a2.25 2.25 0 0 0 0 3.183l.707.707-1.06 1.06-.708-.707a3.75 3.75 0 0 1 0-5.303l.026-.026-.44-.146a.75.75 0 0 1 .13-1.454z"/>`
    }, props));
$280bfedcae88aedb$var$BlockSyncedIcon.displayName = 'BlockSyncedIcon';
var $280bfedcae88aedb$var$_default = module.exports.default = $280bfedcae88aedb$var$BlockSyncedIcon;

});

parcelRegister("6XroG", function(module, exports) {

var $15IyG = parcelRequire("15IyG");

const $034823299c32b512$var$SECONDS_IN_MINUTE = 60;
const $034823299c32b512$var$SECONDS_IN_HOUR = $034823299c32b512$var$SECONDS_IN_MINUTE * 60;
const $034823299c32b512$var$SECONDS_IN_DAY = $034823299c32b512$var$SECONDS_IN_HOUR * 24;
const $034823299c32b512$var$SECONDS_IN_WEEK = $034823299c32b512$var$SECONDS_IN_DAY * 7;
const $034823299c32b512$var$SECONDS_IN_MONTH = $034823299c32b512$var$SECONDS_IN_DAY * 30;
const $034823299c32b512$var$SECONDS_IN_YEAR = $034823299c32b512$var$SECONDS_IN_DAY * 365;
const $034823299c32b512$export$49475f5c6fb1131c = (isoDate, intl)=>{
    const now = Date.now();
    const date = new Date(isoDate).getTime();
    const diffInSeconds = Math.floor((now - date) / 1000);
    const dateObj = new Date(isoDate);
    // Show "yesterday" when timestamp is from the previous calendar day
    if ((0, $15IyG.default)(dateObj) && diffInSeconds >= $034823299c32b512$var$SECONDS_IN_DAY) return intl.formatRelativeTime(-1, 'day', {
        numeric: 'auto',
        style: 'long'
    });
    if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_MINUTE) return intl.formatRelativeTime(-Math.max(diffInSeconds, 1), 'second', {
        style: 'long'
    });
    else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_HOUR) {
        const minutes = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_MINUTE);
        return intl.formatRelativeTime(-minutes, 'minute', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_DAY) {
        const hours = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_HOUR);
        return intl.formatRelativeTime(-hours, 'hour', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_WEEK) {
        const days = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_DAY);
        return intl.formatRelativeTime(-days, 'day', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_MONTH) {
        const weeks = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_WEEK);
        return intl.formatRelativeTime(-weeks, 'week', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_YEAR) {
        const months = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_MONTH);
        return intl.formatRelativeTime(-months, 'month', {
            style: 'long'
        });
    } else {
        const years = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_YEAR);
        return intl.formatRelativeTime(-years, 'year', {
            style: 'long'
        });
    }
};
module.exports["formatElapsedTime"] = $034823299c32b512$export$49475f5c6fb1131c;

});

parcelRegister("87KuW", function(module, exports) {
const $88b0b05de75c97b3$export$9eec9bbd6569d309 = (node)=>{
    if (node.childCount !== 1) return false;
    const firstChild = node.firstChild;
    return firstChild?.type.name === 'paragraph' && firstChild.content.size === 0;
};
module.exports["isEmptySourceSyncBlock"] = $88b0b05de75c97b3$export$9eec9bbd6569d309;

});

parcelRegister("gx781", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $h75sz = parcelRequire("h75sz");


var $Igylv = parcelRequire("Igylv");


var $i2lVL = parcelRequire("i2lVL");

var $95bQO = parcelRequire("95bQO");


var $kCECX = parcelRequire("kCECX");


var $hzCKL = parcelRequire("hzCKL");


var $5y6A2 = parcelRequire("5y6A2");


var $5U2FI = parcelRequire("5U2FI");

// Event types that should be intercepted (returned as handled) when they
// originate inside the sync block content area, so ProseMirror does not
// convert them into node-level selections or drag operations and the browser
// can perform native text selection/cut instead.
const $64e6e0cab8437f11$var$STOPPED_EVENT_TYPES = [
    'mousedown',
    'mousemove',
    'mouseup',
    'click',
    'dblclick',
    'selectstart'
];
class $64e6e0cab8437f11$export$5dd7fae087dd8061 extends (0, $Igylv.default) {
    createDomRef() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView DOM must be created against active runtime document
        const domRef = document.createElement('div');
        domRef.classList.add((0, $95bQO.SyncBlockSharedCssClassName).prefix);
        // Prevent native browser drag on the contentEditable="false" wrapper.
        // Without this, clicking in empty space (outside the contentEditable
        // renderer but inside the domRef) initiates a native element drag.
        domRef.draggable = false;
        this.dragStartHandler = (e)=>{
            e.preventDefault();
        };
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
        domRef.addEventListener('dragstart', this.dragStartHandler);
        return domRef;
    }
    /**
   * Allow mouse and selection events inside the renderer content to pass
   * through to the browser so that users can select and copy text within a
   * reference sync block.
   *
   * Events that originate inside the sync block content area (but not the label)
   * are stopped so ProseMirror does not intercept them for node-level selection.
   * This includes the full click-drag cycle (mousedown, mousemove, mouseup),
   * click, dblclick, selectstart and cut. The `cut` event is stopped because
   * mousedown explicitly sets a NodeSelection on the sync block — without
   * stopping `cut`, a subsequent Ctrl+X would cause ProseMirror to delete the
   * entire sync block node instead of cutting the user's text selection.
   *
   * Copy events are conditionally stopped: when the user has an active native
   * text selection inside the renderer, `copy` is stopped so the browser handles
   * it natively (copying the selected text). When there is no text selection
   * (just a PM NodeSelection), `copy` is NOT stopped so ProseMirror's copy
   * handler runs and sets the "sync-block-copied" flag for the reference paste flow.
   *
   * Events on the SyncBlockLabel are left for ProseMirror to handle, preserving
   * label click interactions and the floating toolbar.
   *
   * The renderer wrapper sets contentEditable="true" to create a re-editable
   * island inside ProseMirror's contentEditable="false" nodeview, enabling
   * native text selection and preventing browser drag behaviour.
   */ stopEvent(event) {
        const target = event.target;
        if (!(target instanceof Element)) return false;
        // Stop events inside the sync block content area, but not on the
        // SyncBlockLabel (to preserve label click interactions).
        if (target.closest(`.${(0, $95bQO.SyncBlockSharedCssClassName).prefix}`) && !target.closest(`.${(0, $95bQO.SyncBlockLabelSharedCssClassName).labelClassName}`)) {
            const eventType = event.type;
            // Stop `copy` only when there is an active native text selection
            // inside the renderer. This lets the browser handle text copy
            // natively. When there is no text selection (just a PM
            // NodeSelection), we let PM handle the copy event so the
            // "sync-block-copied" flag is set for the reference paste flow.
            if (eventType === 'copy') {
                const selection = window.getSelection();
                return !!(selection && selection.toString().length > 0);
            }
            // For `cut`: when text is selected inside the renderer, stop the
            // event and prevent default to avoid the browser removing text from
            // the read-only content. When no text is selected (NodeSelection),
            // let PM handle it so cut deletes the sync block as expected.
            if (eventType === 'cut') {
                const selection = window.getSelection();
                if (selection && selection.toString().length > 0) {
                    event.preventDefault();
                    return true;
                }
                return false;
            }
            // Stop keyboard events that would cause PM to replace the
            // NodeSelection with typed text (deleting the sync block).
            // Allow modifier-key combos (Cmd+C, Cmd+A, etc.) through.
            // Allow Delete/Backspace through so PM's delete handler can
            // process them (e.g. show offline error flag).
            if ((eventType === 'keydown' || eventType === 'keypress') && event instanceof KeyboardEvent && !event.metaKey && !event.ctrlKey && event.key !== 'Delete' && event.key !== 'Backspace') return true;
            if ($64e6e0cab8437f11$var$STOPPED_EVENT_TYPES.includes(eventType)) {
                // Ensure the syncBlock has a NodeSelection so the floating
                // toolbar is visible while the user interacts with the renderer.
                // stopEvent prevents PM from processing the mousedown, so we
                // need to explicitly set the selection ourselves.
                if (eventType === 'mousedown' && !(this.view.state.selection instanceof (0, $kCECX.NodeSelection) && this.view.state.selection.node === this.node)) {
                    if (typeof this.getPos === 'function') {
                        const pos = this.getPos();
                        if (typeof pos === 'number') try {
                            const { tr: tr } = this.view.state;
                            this.view.dispatch(tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos)));
                        } catch  {
                        // pos no longer valid — leave selection unchanged
                        }
                    }
                }
                return true;
            }
        }
        return false;
    }
    validUpdate(currentNode, newNode) {
        // Only consider as the valid update if the localId and resourceId are the same
        // This prevents PM reusing the same node view for different sync block node in live page transition
        return currentNode.attrs.localId === newNode.attrs.localId && currentNode.attrs.resourceId === newNode.attrs.resourceId;
    }
    update(node, decorations, innerDecorations) {
        return super.update(node, decorations, innerDecorations, this.validUpdate);
    }
    render({ getPos: getPos }) {
        if (!this.options?.syncedBlockRenderer) return null;
        const { resourceId: resourceId, localId: localId } = this.node.attrs;
        if (!resourceId || !localId) return null;
        const syncBlockStore = this.api?.syncedBlock?.sharedState.currentState()?.syncBlockStore ?? this.syncBlockStore;
        if (!syncBlockStore) return null;
        // get document node from data provider
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5U2FI.SyncBlockSSRReactContextsProvider), {
            intl: this.intl,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                dispatchAnalyticsEvent: this.api?.analytics?.actions.fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i2lVL.SyncBlockActionsProvider), {
                    removeSyncBlock: this.removeSyncBlockStable,
                    fetchSyncBlockSourceInfo: this.fetchSyncBlockSourceInfoStable,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5y6A2.SyncBlockRendererWrapper), {
                        localId: localId,
                        resourceId: resourceId,
                        node: this.node,
                        syncBlockStore: syncBlockStore,
                        syncedBlockRenderer: this.options?.syncedBlockRenderer,
                        api: this.api
                    })
                })
            })
        });
    }
    destroy() {
        this.unsubscribe?.();
        if (this.dragStartHandler) {
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom?.removeEventListener('dragstart', this.dragStartHandler);
            this.dragStartHandler = undefined;
        }
        super.destroy();
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.options = void 0;
        this.api = void 0;
        this.syncBlockStore = void 0;
        this.intl = void 0;
        // Stable callback references — defined as arrow properties so they keep a
        // fixed identity across render() calls, avoiding defeats of React.memo.
        // The experiment gate lives in render(); these are always available.
        this.removeSyncBlockStable = ()=>{
            const pos = this.getPos();
            if (pos !== undefined) (0, $hzCKL.removeSyncedBlockAtPos)(this.api, pos);
        };
        this.fetchSyncBlockSourceInfoStable = (sourceAri)=>{
            // store is guaranteed non-null: render() guards on syncBlockStore
            // before these callbacks can be invoked.
            const store = this.api?.syncedBlock?.sharedState.currentState()?.syncBlockStore ?? this.syncBlockStore;
            return store ? store.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri) : Promise.resolve(undefined);
        };
        this.unsubscribe = void 0;
        // Stored reference so the listener can be removed in destroy() to
        // avoid a memory leak on every nodeview destruction.
        this.dragStartHandler = void 0;
        this.options = props.options;
        this.api = props.api;
        this.syncBlockStore = props.syncBlockStore;
        this.intl = props.intl;
    }
}
const $64e6e0cab8437f11$export$72faffc4c399ec30 = ({ options: options, pmPluginFactoryParams: pmPluginFactoryParams, api: api })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        return new $64e6e0cab8437f11$export$5dd7fae087dd8061({
            api: api,
            options: options,
            node: node,
            view: view,
            getPos: getPos,
            portalProviderAPI: portalProviderAPI,
            eventDispatcher: eventDispatcher
        }).init();
    };
module.exports["SyncBlock"] = $64e6e0cab8437f11$export$5dd7fae087dd8061;

});

parcelRegister("Igylv", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");


var $fGIRV = parcelRequire("fGIRV");


var $h75sz = parcelRequire("h75sz");


var $iAPNA = parcelRequire("iAPNA");

var $aTBle = parcelRequire("aTBle");


var $6pnwK = parcelRequire("6pnwK");


var $4HBuC = parcelRequire("4HBuC");


var $3k3tn = parcelRequire("3k3tn");


var $g9sVl = parcelRequire("g9sVl");

class $f03b41aa25e7d4ac$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $iAPNA.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $aTBle.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) {
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            // During SSR, renderToStaticMarkup + container.innerHTML (in portal) clobbers the
            // contentDOMWrapper that was appended above. The React ref callback
            // (forwardRef) never fires in renderToStaticMarkup, so contentDOM is
            // left detached. Re-attach it by finding the marked SSR ref target.
            if ((0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() && this.domRef) {
                const refTarget = this.domRef.querySelector('[data-ssr-content-dom-ref]');
                if (refTarget) {
                    this.handleRef(refTarget);
                    // The marker is only needed to locate the re-attach target during
                    // this SSR pass. Remove it so it doesn't leak into the streamed
                    // HTML (it has no meaning on the client).
                    refTarget.removeAttribute('data-ssr-content-dom-ref');
                }
            }
        }
        trackingEnabled && (0, $iAPNA.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $krYZG.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                children: component()
            });
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $f03b41aa25e7d4ac$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $fGIRV.createDispatch)(this.eventDispatcher);
                dispatch((0, $6pnwK.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $4HBuC.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $f03b41aa25e7d4ac$export$2e2bcd8739ae039;

});

parcelRegister("4HBuC", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $iwjSV = parcelRequire("iwjSV");

const $1746cd4e14fa5645$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
};
module.exports["generateUniqueNodeKey"] = $1746cd4e14fa5645$export$4a323a0542a1e4d1;

});

parcelRegister("3k3tn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $aPdNQ = parcelRequire("aPdNQ");


var $iDrrr = parcelRequire("iDrrr");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $h75sz = parcelRequire("h75sz");


var $6pnwK = parcelRequire("6pnwK");

var $iAPNA = parcelRequire("iAPNA");

var $aTBle = parcelRequire("aTBle");


var $8dxef = parcelRequire("8dxef");


var $fngNp = parcelRequire("fngNp");


var $4HBuC = parcelRequire("4HBuC");


var $6EnhY = parcelRequire("6EnhY");

const $d2b8a7e0987cd11a$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $d2b8a7e0987cd11a$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $d2b8a7e0987cd11a$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $d2b8a7e0987cd11a$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4HBuC.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $d2b8a7e0987cd11a$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($d2b8a7e0987cd11a$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $iAPNA.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $aTBle.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $iAPNA.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $d2b8a7e0987cd11a$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $d2b8a7e0987cd11a$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4HBuC.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $d2b8a7e0987cd11a$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($d2b8a7e0987cd11a$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$d2b8a7e0987cd11a$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $aPdNQ.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $6EnhY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $d2b8a7e0987cd11a$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $d2b8a7e0987cd11a$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $d2b8a7e0987cd11a$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $h75sz.ErrorBoundary), {
            component: (0, $krYZG.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $krYZG.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $fngNp.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $8dxef.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $fngNp.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $d2b8a7e0987cd11a$var$counterPerEditorViewMap = new WeakMap();
function $d2b8a7e0987cd11a$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $d2b8a7e0987cd11a$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $4iudd.isSSR)()) return $d2b8a7e0987cd11a$var$createNodeView(parameters);
        if ((0, $iDrrr.fg)('platform_editor_inline_node_virt_threshold_override')) return $d2b8a7e0987cd11a$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $d2b8a7e0987cd11a$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $d2b8a7e0987cd11a$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $d2b8a7e0987cd11a$var$createNodeView(parameters);
        return $d2b8a7e0987cd11a$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $d2b8a7e0987cd11a$export$17a8c3162956317d;

});

parcelRegister("6EnhY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $756975148395f764$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $756975148395f764$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $756975148395f764$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($756975148395f764$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$756975148395f764$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $756975148395f764$export$d73c873f0a6a03c3;

});

parcelRegister("g9sVl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $iAEsk = parcelRequire("iAEsk");

const $b7122d1a9520547e$export$27292f9d0a2a0aef = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...props,
            ref: ref,
            "data-ssr-content-dom-ref": (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? "" : undefined
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...props,
        ref: ref,
        "data-ssr-content-dom-ref": (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? '' : undefined
    }));
module.exports["NodeViewContentHole"] = $b7122d1a9520547e$export$27292f9d0a2a0aef;

});

parcelRegister("i2lVL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $c17e087269191e3c$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c17e087269191e3c$export$1536d3aa2f6b9cd9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c17e087269191e3c$var$SyncBlockActionsContext);
} : ()=>{
    return (0, $cozmU.useContext)($c17e087269191e3c$var$SyncBlockActionsContext);
};
const $c17e087269191e3c$export$5f0b55764d1d819f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo } = t0;
    let t1;
    if ($[0] !== fetchSyncBlockSourceInfo || $[1] !== removeSyncBlock) {
        t1 = {
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        };
        $[0] = fetchSyncBlockSourceInfo;
        $[1] = removeSyncBlock;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($c17e087269191e3c$var$SyncBlockActionsContext.Provider, {
            value: value,
            children: children
        });
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c17e087269191e3c$var$SyncBlockActionsContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["useSyncBlockActions"] = $c17e087269191e3c$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $c17e087269191e3c$export$5f0b55764d1d819f;

});

parcelRegister("5y6A2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $95bQO = parcelRequire("95bQO");


var $79ir6 = parcelRequire("79ir6");

var $4cJIQ = parcelRequire("4cJIQ");

var $a4OZH = parcelRequire("a4OZH");


var $ieeJu = parcelRequire("ieeJu");


var $fXTqR = parcelRequire("fXTqR");

const $76e39394309af1c6$var$SyncBlockRendererWrapperDataId = 'sync-block-plugin-renderer-wrapper';
const $76e39394309af1c6$var$SyncBlockRendererWrapperComponent = ({ syncedBlockRenderer: syncedBlockRenderer, syncBlockStore: syncBlockStore, node: node, resourceId: resourceId, localId: localId, api: api })=>{
    const syncBlockFetchResult = (0, $4cJIQ.useFetchSyncBlockData)(syncBlockStore, resourceId, localId, api?.analytics?.actions?.fireAnalyticsEvent);
    const title = (0, $a4OZH.useFetchSyncBlockTitle)(syncBlockStore, node);
    const contentUpdatedAt = syncBlockFetchResult?.syncBlockInstance?.data?.contentUpdatedAt;
    const isUnpublishedBlock = syncBlockFetchResult.syncBlockInstance?.data?.status === 'unpublished';
    const isUnsyncedBlock = isUnpublishedBlock || syncBlockFetchResult?.syncBlockInstance?.error?.type === (0, $79ir6.SyncBlockError).NotFound;
    // Evaluated unconditionally so the experiment exposure is tracked correctly
    // (recorded on every render, not lazily on first click).
    const isSyncBlockActivationEnabled = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true);
    // Prevent editing in the contentEditable renderer wrapper. We set
    // contentEditable="true" to enable text selection (creating an editable
    // island inside ProseMirror's contentEditable="false" nodeview wrapper),
    // but users must not be able to type into or modify the renderer content.
    const preventInput = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    // Browsers suppress link navigation on a plain click inside a
    // contentEditable region (they place the caret instead), which breaks links
    // rendered in the content — e.g. the "when the page is published" link in
    // the unpublished error card. Re-trigger navigation for _blank anchors
    // ourselves. A native listener (rather than an onClick on the div) is used
    // so we delegate link clicks without making the container itself interactive.
    const rendererRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const containerEl = rendererRef.current;
        if (!containerEl || !isSyncBlockActivationEnabled) return;
        const unbind = (0, $cbY7C.bind)(containerEl, {
            type: 'click',
            listener: (e)=>{
                // Let the browser handle modified/non-primary clicks (open-in-new-tab,
                // etc.) natively so we don't open a second tab on top of it.
                if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                const target = e.target instanceof Element ? e.target : null;
                const anchor = target?.closest('a[href]');
                if (!(anchor instanceof HTMLAnchorElement) || e.defaultPrevented || anchor.target !== '_blank') return;
                window.open(anchor.href, '_blank', 'noopener,noreferrer');
            }
        });
        return unbind;
    }, [
        isSyncBlockActivationEnabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: rendererRef,
                "data-testid": $76e39394309af1c6$var$SyncBlockRendererWrapperDataId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $95bQO.SyncBlockSharedCssClassName).renderer,
                contentEditable: true,
                suppressContentEditableWarning: true,
                // Prevent the contentEditable div from being keyboard-focusable.
                // It is only used to enable text selection, not as an input target.
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: -1,
                onBeforeInput: preventInput,
                onPaste: preventInput,
                // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
                onDrop: preventInput,
                children: syncedBlockRenderer({
                    syncBlockFetchResult: syncBlockFetchResult,
                    api: api
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fXTqR.SyncBlockLabel), {
                isSource: false,
                title: title,
                contentUpdatedAt: contentUpdatedAt,
                localId: localId,
                isUnsyncedBlock: isUnsyncedBlock
            })
        ]
    });
};
const $76e39394309af1c6$export$295fdde04ad91bbd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($76e39394309af1c6$var$SyncBlockRendererWrapperComponent);
module.exports["SyncBlockRendererWrapper"] = $76e39394309af1c6$export$295fdde04ad91bbd;

});

parcelRegister("4cJIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $jv11C = parcelRequire("jv11C");


var $iDrrr = parcelRequire("iDrrr");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $d04Ge = parcelRequire("d04Ge");

const $c9f3028cf767214f$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $cozmU.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    // On Jira the data provider is wired asynchronously, so the manager can be
    // constructed with `dataProvider === undefined`. Fetching/subscribing in that
    // window throws `Data provider not set`, logged as a false fetch error
    // (EDITOR-7860). Check readiness; once the provider resolves a new manager
    // instance is created so `referenceManager` changes identity and the effect
    // below re-runs, subscribing exactly once.
    const isDataProviderReady = manager.referenceManager.hasDataProvider?.() ?? false;
    const reloadData = (0, $cozmU.useCallback)(async ()=>{
        if (isLoading) return;
        // Not ready: skip fetch, emit no error (see readiness note above).
        if (!isDataProviderReady) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $d04Ge.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            // EDITOR-7860: benign not-ready throw — emit no error and stay loading
            // so it resolves on retry once the provider is wired. Checked before
            // `logException` so the benign case produces no exception-tracker noise.
            if ((0, $79ir6.isProviderNotReadyError)(error)) {
                setFetchState((prev)=>({
                        ...prev,
                        isLoading: true
                    }));
                return;
            }
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(error.message)));
            // Thread the PII-safe original message/name so the renderer can de-opaque
            // this otherwise-bare `errored` failure. `originalMessage` carries the
            // Error.message and is preferred over `reason` by the renderer, so no
            // separate `reason` is set here.
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        ...(0, $916Gd.getPiiSafeOriginalError)(error)
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        // Not ready: skip subscribe (it would trigger a batched fetch and a false
        // error) and keep `isLoading: true`. `isDataProviderReady` is in the deps,
        // so the effect re-runs and subscribes once the provider resolves.
        if (!isDataProviderReady) return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId
    ]);
    // Pure read, safe during render. The individual provider references are effect
    // dependencies below so a provider swapped by the host is re-applied to the
    // cached factory, which would otherwise keep serving the previous one.
    const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = manager.referenceManager.getProviderOptions?.() ?? {};
    // Applying providers notifies subscribers synchronously, so it must not run during
    // render - that would setState on another component mid-render and remount the block.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_blocks_patch_7')) return;
        if (!resourceId || (0, $4iudd.isSSR)()) return;
        manager.referenceManager.syncProviders(resourceId);
    // `syncBlockInstance` is a dependency because the dynamic providers are derived
    // from the fetched block data, so they can only be created once it has arrived.
    }, [
        manager.referenceManager,
        resourceId,
        syncBlockInstance,
        parentDataProviders?.mentionProvider,
        parentDataProviders?.profilecardProvider,
        parentDataProviders?.taskDecisionProvider,
        providerCreator
    ]);
    const ssrProviders = (0, $cozmU.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $c9f3028cf767214f$export$2b02427d5640395b;

});

parcelRegister("a4OZH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $eba34f15ca47930e$export$b5dcfcd5b90b41cc = (manager, syncBlockNode)=>{
    const nodeRef = (0, $cozmU.useRef)(syncBlockNode);
    nodeRef.current = syncBlockNode;
    const nodeTypeName = syncBlockNode.type.name;
    const resourceId = syncBlockNode.attrs?.resourceId;
    const localId = syncBlockNode.attrs?.localId;
    // Initialize state from cache to prevent flickering during re-renders
    const [sourceTitle, setSourceTitle] = (0, $cozmU.useState)(()=>{
        if (nodeTypeName !== 'syncBlock') return undefined;
        if (!resourceId) return undefined;
        const cachedData = manager.referenceManager.getFromCache(resourceId);
        return cachedData?.data?.sourceTitle;
    });
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSourceTitle(nodeRef.current, (title)=>{
            setSourceTitle(title);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        manager,
        nodeTypeName,
        resourceId,
        localId
    ]);
    return sourceTitle;
};
module.exports["useFetchSyncBlockTitle"] = $eba34f15ca47930e$export$b5dcfcd5b90b41cc;

});

parcelRegister("5U2FI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");

function $0fe46b9dabba4423$export$491fe064d74662f9({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
        value: intl,
        children: children
    });
}
module.exports["SyncBlockSSRReactContextsProvider"] = $0fe46b9dabba4423$export$491fe064d74662f9;

});

parcelRegister("kXmSu", function(module, exports) {
var $ec0a253b1ada3f34$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_DELETE_WHEN_OFFLINE"] = "cannot-delete-when-offline";
    FLAG_ID["CANNOT_EDIT_WHEN_OFFLINE"] = "cannot-edit-when-offline";
    FLAG_ID["CANNOT_CREATE_WHEN_OFFLINE"] = "cannot-create-when-offline";
    FLAG_ID["FAIL_TO_DELETE"] = "fail-to-delete";
    FLAG_ID["SYNC_BLOCK_COPIED"] = "sync-block-copied";
    FLAG_ID["UNPUBLISHED_SYNC_BLOCK_PASTED"] = "unpublished-sync-block-pasted";
    FLAG_ID["CANNOT_CREATE_SYNC_BLOCK"] = "cannot-create-sync-block";
    FLAG_ID["INLINE_EXTENSION_IN_SYNC_BLOCK"] = "inline-extension-in-sync-block";
    FLAG_ID["EXTENSION_IN_SYNC_BLOCK"] = "extension-in-sync-block";
    FLAG_ID["DUPLICATE_SOURCE_SYNC_BLOCK"] = "duplicate-source-sync-block";
    FLAG_ID["SYNC_BLOCK_FEEDBACK_PROMPT"] = "synced-block-feedback-prompt";
    return FLAG_ID;
}({});
const $ec0a253b1ada3f34$export$ce5236bf4eef2662 = {
    primaryToolbarCreate: 'create-synced-block-toolbar-btn',
    blockMenuCreate: 'create-synced-block-block-menu-btn',
    quickInsertCreate: 'create-synced-block-quick-insert-btn',
    syncedBlockToolbarCopy: 'synced-block-copy-btn',
    syncedBlockToolbarReferenceDelete: 'reference-synced-block-delete-btn',
    syncedBlockToolbarSourceDelete: 'source-synced-block-delete-btn',
    syncedBlockToolbarReferenceUnsync: 'reference-synced-block-unsync-btn',
    syncedBlockToolbarSourceUnsync: 'source-synced-block-unsync-btn',
    syncedBlockToolbarSyncedLocationsTrigger: 'synced-block-synced-locations-dropdown--trigger',
    syncedBlockToolbarReferenceOverflowTrigger: 'reference-synced-block-overflow-dropdown--trigger',
    syncedBlockToolbarSourceOverflowTrigger: 'source-synced-block-overflow-dropdown--trigger'
};
module.exports["FLAG_ID"] = $ec0a253b1ada3f34$export$5881677fb314e6d9;
module.exports["SYNCED_BLOCK_BUTTON_TEST_ID"] = $ec0a253b1ada3f34$export$ce5236bf4eef2662;

});

parcelRegister("fQgiq", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $kXmSu = parcelRequire("kXmSu");


var $i57XD = parcelRequire("i57XD");


var $73IhX = parcelRequire("73IhX");

const $978b73c23f40d240$var$onRetry = (api, resourceId)=>{
    return ()=>{
        api?.core?.actions.focus();
        api?.core?.actions.execute(({ tr: tr })=>{
            const pos = api?.syncedBlock?.sharedState.currentState()?.retryCreationPosMap?.get(resourceId);
            const from = pos?.from;
            const to = pos?.to;
            if (from === undefined || to === undefined) return tr;
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from, to)).setMeta((0, $i57XD.syncedBlockPluginKey), {
                activeFlag: false
            });
            api?.syncedBlock?.commands.insertSyncedBlock()({
                tr: tr
            });
            return tr;
        });
    };
};
const $978b73c23f40d240$var$getRevertCreationPos = (api, doc, resourceId)=>{
    const retryCreationPos = api?.syncedBlock?.sharedState.currentState()?.retryCreationPosMap?.get(resourceId);
    if (retryCreationPos) return retryCreationPos;
    // Fallback to find the positions in case BE call returns before plugin state becomes available
    // which is highly unlikely
    let currentPos;
    doc.descendants((node, pos)=>{
        if (currentPos) return false;
        if (node.type.name === 'bodiedSyncBlock' && resourceId === node.attrs.resourceId) {
            currentPos = {
                from: pos,
                to: pos + node.nodeSize
            };
            return false;
        }
    });
    return currentPos;
};
const $978b73c23f40d240$var$buildRevertCreationTr = (tr, pos)=>{
    const content = tr.doc.nodeAt(pos.from)?.content;
    if (content) {
        tr.replaceWith(pos.from, pos.to, content);
        const contentFrom = tr.mapping.map(pos.from);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, contentFrom, contentFrom + content.size));
    } else tr.delete(pos.from, pos.to);
    return tr;
};
const $978b73c23f40d240$export$4ef10a0a6b609715 = (bodiedSyncBlockAdded, editorState, api, enrichment)=>{
    const syncBlockStore = (0, $i57XD.syncedBlockPluginKey).getState(editorState).syncBlockStore;
    bodiedSyncBlockAdded.forEach((node)=>{
        if (node.from === undefined || node.to === undefined) return;
        const retryCreationPos = {
            from: node.from,
            to: node.to
        };
        const resourceId = node.attrs.resourceId;
        (0, $73IhX.deferDispatch)(()=>{
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                    retryCreationPos: {
                        resourceId: resourceId,
                        pos: retryCreationPos
                    }
                });
            });
        });
        syncBlockStore.sourceManager.createBodiedSyncBlockNode(node.attrs, node.node, (success)=>{
            if (success) {
                api?.core?.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                        retryCreationPos: {
                            resourceId: resourceId,
                            pos: undefined
                        }
                    });
                });
                api?.core?.actions.focus();
            } else api?.core?.actions.execute(({ tr: tr })=>{
                const revertCreationPos = $978b73c23f40d240$var$getRevertCreationPos(api, tr.doc, resourceId);
                if (!revertCreationPos) return tr;
                const revertTr = $978b73c23f40d240$var$buildRevertCreationTr(tr, revertCreationPos);
                return revertTr.setMeta('isConfirmedSyncBlockDeletion', true).setMeta('addToHistory', false).setMeta((0, $i57XD.syncedBlockPluginKey), {
                    activeFlag: {
                        id: (0, $kXmSu.FLAG_ID).CANNOT_CREATE_SYNC_BLOCK,
                        onRetry: $978b73c23f40d240$var$onRetry(api, resourceId),
                        onDismissed: (tr)=>tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                                ...tr.getMeta((0, $i57XD.syncedBlockPluginKey)),
                                retryCreationPos: {
                                    resourceId: resourceId,
                                    pos: undefined
                                }
                            })
                    }
                });
            });
        }, enrichment);
    });
};
module.exports["handleBodiedSyncBlockCreation"] = $978b73c23f40d240$export$4ef10a0a6b609715;

});

parcelRegister("73IhX", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $lVAkE = parcelRequire("lVAkE");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");


var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");

const $04e29bf458c24792$export$fb2d0f31ec71c7e9 = (fn)=>{
    queueMicrotask(fn);
};
const $04e29bf458c24792$export$8e2da6078c69a0c6 = (schema, selection)=>{
    const { syncBlock: syncBlock } = schema.nodes;
    return (0, $bjg0G.findSelectedNodeOfType)(syncBlock)(selection);
};
const $04e29bf458c24792$export$342c143cb64448d1 = (schema, selection)=>{
    return (0, $bjg0G.findSelectedNodeOfType)(schema.nodes.bodiedSyncBlock)(selection) || (0, $bjg0G.findParentNodeOfType)(schema.nodes.bodiedSyncBlock)(selection);
};
const $04e29bf458c24792$export$72f89723ce6d6fa3 = (schema, selection)=>{
    return $04e29bf458c24792$export$8e2da6078c69a0c6(schema, selection) || $04e29bf458c24792$export$342c143cb64448d1(schema, selection);
};
const $04e29bf458c24792$export$5f971aa95a01794c = (node, bodiedSyncBlock)=>node.type === bodiedSyncBlock;
const $04e29bf458c24792$export$77fbebd359a90e90 = (0, $dOBRD.default)(()=>new Set([
        'inlineExtension',
        'extension',
        'bodiedExtension',
        'syncBlock',
        'bodiedSyncBlock',
        ...(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : []
    ]));
const $04e29bf458c24792$export$a912fa82dfd54783 = (selection)=>{
    const { $from: $from, range: range } = (0, $lVAkE.expandSelectionToBlockRange)(selection);
    if (!range) return false;
    const from = range.start;
    const to = range.end;
    const unsupportedNodeTypes = $04e29bf458c24792$export$77fbebd359a90e90();
    let canBeConverted = true;
    $from.doc.nodesBetween(from, to, (node)=>{
        if (unsupportedNodeTypes.has(node.type.name)) {
            canBeConverted = false;
            return false;
        }
    });
    if (!canBeConverted) return false;
    const contentToInclude = $04e29bf458c24792$var$removeBreakoutMarks($from.doc.slice(from, to).content);
    return {
        contentToInclude: contentToInclude,
        from: from,
        to: to
    };
};
const $04e29bf458c24792$var$removeBreakoutMarks = (content)=>{
    const nodes = [];
    // we only need to recurse at the top level, because breakout has to be on a top level
    content.forEach((node)=>{
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
        if (node.isText) nodes.push(node);
        else {
            const newNode = node.type.create(node.attrs, node.content, filteredMarks);
            nodes.push(newNode);
        }
    });
    return (0, $aPdNQ.Fragment).from(nodes);
};
const $04e29bf458c24792$export$384f6683328fd2fe = (slice, node)=>{
    const isFirstChild = slice.content.firstChild?.type === node.type && slice.content.firstChild?.attrs.resourceId === node.attrs.resourceId;
    const isLastChild = slice.content.lastChild?.type === node.type && slice.content.lastChild?.attrs.resourceId === node.attrs.resourceId;
    const isOpenAtStart = isFirstChild && slice.openStart > 0;
    const isOpenAtEnd = isLastChild && slice.openEnd > 0;
    if (isOpenAtStart || isOpenAtEnd) return false;
    return true;
};
// even though extension and bodiedExtension are explicitly not allowed by the schema, they can still be inserted nested inside other nodes e.g. layouts
const $04e29bf458c24792$var$EXTENSION_NODES = new Set([
    'inlineExtension',
    'extension',
    'bodiedExtension'
]);
const $04e29bf458c24792$var$fragmentContainsExtension = (fragment)=>{
    let found = false;
    fragment.forEach((node)=>{
        if (found) return;
        if ($04e29bf458c24792$var$EXTENSION_NODES.has(node.type.name)) found = true;
        else if (node.content.size) {
            if ($04e29bf458c24792$var$fragmentContainsExtension(node.content)) found = true;
        }
    });
    return found;
};
const $04e29bf458c24792$var$sliceContainsExtension = (slice)=>$04e29bf458c24792$var$fragmentContainsExtension(slice.content);
const $04e29bf458c24792$export$ecac802907d15d9a = (tr, state)=>{
    if (!tr.docChanged || tr.getMeta('isRemote')) return undefined;
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    if (!bodiedSyncBlock) return undefined;
    const docs = tr.docs;
    // When docs is available (e.g. from history plugin), check each replace step
    if (docs && docs.length > 0) {
        for(let i = 0; i < tr.steps.length; i++){
            const step = tr.steps[i];
            const isReplaceStep = step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep);
            if (!isReplaceStep || !('slice' in step) || !('from' in step)) continue;
            const replaceStep = step;
            if (!$04e29bf458c24792$var$sliceContainsExtension(replaceStep.slice)) continue;
            const docAfterStep = docs[i + 1] ?? tr.doc;
            try {
                const $pos = docAfterStep.resolve(replaceStep.from);
                const parent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
                if (parent?.node.attrs.resourceId) return parent.node.attrs.resourceId;
            } catch  {
            // resolve() can throw if position is invalid
            }
        }
        return undefined;
    }
    // Fallback: scan final doc for inline extensions inside bodied sync block that were added
    let resourceId;
    tr.doc.descendants((node, pos)=>{
        if (resourceId !== undefined) return false;
        if ($04e29bf458c24792$var$EXTENSION_NODES.has(node.type.name)) {
            const $pos = tr.doc.resolve(pos);
            const parent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
            if (parent?.node.attrs.resourceId) {
                const mappedPos = tr.mapping.invert().map(pos);
                const nodeBefore = state.doc.nodeAt(mappedPos);
                if (!nodeBefore || $04e29bf458c24792$var$EXTENSION_NODES.has(nodeBefore.type.name)) {
                    resourceId = parent.node.attrs.resourceId;
                    return false;
                }
            }
        }
        return true;
    });
    return resourceId;
};
module.exports["deferDispatch"] = $04e29bf458c24792$export$fb2d0f31ec71c7e9;
module.exports["findSyncBlock"] = $04e29bf458c24792$export$8e2da6078c69a0c6;
module.exports["findSyncBlockOrBodiedSyncBlock"] = $04e29bf458c24792$export$72f89723ce6d6fa3;
module.exports["isBodiedSyncBlockNode"] = $04e29bf458c24792$export$5f971aa95a01794c;
module.exports["canBeConvertedToSyncBlock"] = $04e29bf458c24792$export$a912fa82dfd54783;
module.exports["sliceFullyContainsNode"] = $04e29bf458c24792$export$384f6683328fd2fe;
module.exports["wasExtensionInsertedInBodiedSyncBlock"] = $04e29bf458c24792$export$ecac802907d15d9a;

});

parcelRegister("aznRb", function(module, exports) {

var $2w79Z = parcelRequire("2w79Z");


var $iDrrr = parcelRequire("iDrrr");


var $kXmSu = parcelRequire("kXmSu");


var $i57XD = parcelRequire("i57XD");


var $atMOO = parcelRequire("atMOO");

const $60b0521823ac38c9$var$onRetry = (api, syncBlockStore)=>()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                bodiedSyncBlockDeletionStatus: 'processing',
                activeFlag: false
            });
        });
        syncBlockStore.sourceManager.retryDeletion();
    };
const $60b0521823ac38c9$var$onDismissed = (syncBlockStore)=>(tr)=>{
        syncBlockStore.sourceManager.clearPendingDeletion();
        return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
            bodiedSyncBlockDeletionStatus: 'none'
        });
    };
const $60b0521823ac38c9$export$4d68be81d3ab4a0d = (bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef, deletionReason, mechanism, feedbackCallbacks)=>{
    // Clear potential old pending deletion to retreat the deletion as first attempt
    syncBlockStore.sourceManager.clearPendingDeletion();
    // If there are source sync blocks being removed, and we need to confirm with user before deleting,
    // we block the transaction here, and wait for user confirmation to proceed with deletion.
    // See editor-common/src/sync-block/sync-block-store-manager.ts for how we handle user confirmation and
    // proceed with deletion.
    syncBlockStore.sourceManager.deleteSyncBlocksWithConfirmation(bodiedSyncBlockRemoved.map((node)=>node.attrs), deletionReason, ()=>{
        // Recompute the delete fresh from the live document instead of
        // replaying a stashed-and-rebased transaction. The stash/rebase
        // approach produced stale, schema-invalid transactions when the
        // document changed shape (local edits or remote collab) while the
        // confirmation modal was open — the dominant signature being
        // "Invalid content for node bodiedSyncBlock: <>". See EDITOR-7889.
        api?.core?.actions.execute(({ tr: tr })=>{
            // EDITOR-8230: unsync must remove only the sync wrapper and keep the block's
            // content inline, whereas delete removes the whole block. Before this branch,
            // the confirm path always recomputed a full delete, so unsyncing a source block
            // silently deleted its content. When the deletion was actually triggered by
            // unsync, recompute an unwrap (replaceWith content) instead of a delete.
            const isUnsync = (0, $iDrrr.fg)('platform_editor_blocks_patch_6') && deletionReason === 'source-block-unsynced';
            const recomputedTr = isUnsync ? (0, $atMOO.recomputeUnsyncTransaction)(tr, syncBlockStore.sourceManager.isSourceBlock, bodiedSyncBlockRemoved.map((node)=>node.attrs)) : (0, $atMOO.recomputeDeleteTransaction)(tr, syncBlockStore.sourceManager.isSourceBlock, bodiedSyncBlockRemoved.map((node)=>node.attrs));
            // The target node(s) no longer exist in the live document (e.g.
            // a remote collaborator already removed them). There is nothing
            // to delete locally, so return `null` to skip the dispatch
            // entirely — dispatching the untouched transaction would be a
            // no-op that still runs the plugin's filter/append hooks. The
            // backend deletion has already been issued by the store manager.
            if (!recomputedTr) return null;
            recomputedTr.setMeta('isConfirmedSyncBlockDeletion', true);
            feedbackCallbacks?.onDeleteTransaction(recomputedTr);
            if (!recomputedTr.getMeta((0, $2w79Z.pmHistoryPluginKey))) // bodiedSyncBlock deletion is expected to be permanent (cannot undo)
            // For a normal deletion (not triggered by undo), remove it from history so that it cannot be undone
            recomputedTr.setMeta('addToHistory', false);
            return recomputedTr;
        });
    }, (success)=>{
        feedbackCallbacks?.onDeleteCompleted(success);
        api?.core?.actions.execute(({ tr: tr })=>{
            let newState;
            if (!success) newState = {
                activeFlag: {
                    id: (0, $kXmSu.FLAG_ID).FAIL_TO_DELETE,
                    onRetry: $60b0521823ac38c9$var$onRetry(api, syncBlockStore),
                    onDismissed: $60b0521823ac38c9$var$onDismissed(syncBlockStore)
                }
            };
            else newState = {
                activeFlag: false
            };
            newState = {
                ...newState,
                bodiedSyncBlockDeletionStatus: syncBlockStore.sourceManager.isRetryingDeletion() ? 'none' : 'completed'
            };
            return tr.setMeta((0, $i57XD.syncedBlockPluginKey), newState);
        });
    }, ()=>{
        confirmationTransactionRef.current = undefined;
        feedbackCallbacks?.onDestroy();
    }, mechanism);
    return false;
};
module.exports["handleBodiedSyncBlockRemoval"] = $60b0521823ac38c9$export$4d68be81d3ab4a0d;

});

parcelRegister("atMOO", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

/**
 * Whether `node` is the source block requested by `wanted`.
 *
 * Matching is done *per requested block* (rather than against global pools of
 * every requested localId/resourceId) so a node cannot be matched by combining
 * one block's `localId` with a different block's `resourceId`. We match on the
 * requested block's `localId` first and only fall back to its `resourceId` when
 * the `localId` has been regenerated (so it no longer matches the live node).
 */ const $1f55c2daca4420d4$var$matchesRequestedBlock = (node, wanted)=>{
    const { localId: localId, resourceId: resourceId } = node.attrs;
    if (wanted.localId && localId && wanted.localId === localId) return true;
    return Boolean(wanted.resourceId && resourceId && wanted.resourceId === resourceId);
};
/**
 * Locate the live positions of the source `bodiedSyncBlock` nodes identified by
 * `syncBlockIds`, matching first on `localId` and falling back to `resourceId`.
 *
 * This walks the *current* document (`tr.doc`) rather than relying on positions
 * captured when the delete was first triggered, so it is robust to intervening
 * local edits and remote collab changes that occur while the confirmation modal
 * is open.
 */ const $1f55c2daca4420d4$var$findSourceBlocks = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = [];
    tr.doc.descendants((node, pos)=>{
        if (!isSourceBlock(node)) // bodiedSyncBlock is always a top-level node, so there is no need to
        // descend into other branches looking for one.
        return false;
        if (syncBlockIds.some((wanted)=>$1f55c2daca4420d4$var$matchesRequestedBlock(node, wanted))) matches.push({
            node: node,
            pos: pos
        });
        // Never recurse into a source block's body.
        return false;
    });
    return matches;
};
const $1f55c2daca4420d4$export$71458047dba8e515 = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = $1f55c2daca4420d4$var$findSourceBlocks(tr, isSourceBlock, syncBlockIds);
    if (matches.length === 0) return undefined;
    // Delete in reverse document order so positions remain valid across deletes.
    matches.sort((a, b)=>b.pos - a.pos).forEach(({ node: node, pos: pos })=>{
        tr.delete(pos, pos + node.nodeSize);
    });
    return tr;
};
const $1f55c2daca4420d4$export$43dcf6cfb7f47f27 = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = $1f55c2daca4420d4$var$findSourceBlocks(tr, isSourceBlock, syncBlockIds);
    if (matches.length === 0) return undefined;
    // Unwrap in reverse document order so positions remain valid across edits.
    // Use a raw zero-open Slice replace (not `replaceWith`) so the block's content
    // is inserted verbatim as top-level nodes without ProseMirror's replaceRange
    // heuristics collapsing a trailing block (EDITOR-8230).
    const orderedMatches = matches.sort((a, b)=>b.pos - a.pos);
    for (const { node: node, pos: pos } of orderedMatches)// This is ProseMirror's Transaction.replace (a document edit), not String.replace — the
    // perf rule misfires on the method name, and there is nothing to hoist.
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
    tr.replace(pos, pos + node.nodeSize, new (0, $aPdNQ.Slice)(node.content, 0, 0));
    return tr;
};
module.exports["recomputeDeleteTransaction"] = $1f55c2daca4420d4$export$71458047dba8e515;
module.exports["recomputeUnsyncTransaction"] = $1f55c2daca4420d4$export$43dcf6cfb7f47f27;

});

parcelRegister("fTCnv", function(module, exports) {
const $bb93622324819e61$export$cf93eddb8b14708a = (doc)=>{
    for(let i = 0; i < doc.childCount; i++){
        const node = doc.child(i);
        if (node.type.name === 'syncBlock' || node.type.name === 'bodiedSyncBlock') return true;
    }
    return false;
};
module.exports["hasSyncedBlocks"] = $bb93622324819e61$export$cf93eddb8b14708a;

});

parcelRegister("3k2Mh", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");

const $6fe83dd5984ba2f3$export$6b191088ef76a6be = (view, event, api)=>{
    if (api?.connectivity?.sharedState.currentState()?.mode !== 'offline') return;
    const { bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    const pos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    })?.pos;
    if (pos === undefined) return;
    const $pos = view.state.doc.resolve(pos);
    const maybeNode = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
    if (maybeNode) return true;
};
module.exports["shouldIgnoreDomEvent"] = $6fe83dd5984ba2f3$export$6b191088ef76a6be;

});

parcelRegister("6hFNe", function(module, exports) {

var $95bQO = parcelRequire("95bQO");


var $bjg0G = parcelRequire("bjg0G");


var $8nvEM = parcelRequire("8nvEM");

const $895c7941d473c11e$export$aee83dbd972779dd = (doc, selection, schema)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    const syncBlockParent = (0, $bjg0G.findParentNodeOfType)(bodiedSyncBlock)(selection);
    if (syncBlockParent) {
        const { node: node, pos: pos } = syncBlockParent;
        const decoration = (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: `${(0, $95bQO.BodiedSyncBlockSharedCssClassName).selectionInside}`
        });
        return (0, $8nvEM.DecorationSet).create(doc, [
            decoration
        ]);
    }
    return (0, $8nvEM.DecorationSet).empty;
};
module.exports["calculateDecorations"] = $895c7941d473c11e$export$aee83dbd972779dd;

});

parcelRegister("8zLo1", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");


var $bjg0G = parcelRequire("bjg0G");

const $96d8d664fb910a31$export$a1196481035d4d42 = (predicate, tr, state)=>{
    const removed = {};
    const added = {};
    if (!tr.docChanged) return {
        removed: [],
        added: []
    };
    // and cast to specific step types
    const replaceSteps = tr.steps.filter((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    // this is a quick check to see if any insertion/deletion of sync block happened
    const hasSyncBlockChanges = replaceSteps.some((step)=>{
        const { from: from, to: to } = step;
        const docAtStep = tr.docs[tr.steps.indexOf(step)];
        let hasChange = false;
        if (from !== to) step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart !== oldEnd && !hasChange) {
                const deletedSlice = docAtStep.slice(Math.max(0, oldStart), Math.min(docAtStep.content.size, oldEnd));
                deletedSlice.content.forEach((node)=>{
                    if (hasChange) return;
                    // for top level nodes
                    if (predicate(node)) hasChange = true;
                });
            }
        });
        // no need to check insertions if we already found deletions
        if (step.slice.content.size > 0 && !hasChange) step.slice.content.forEach((node)=>{
            if (predicate(node) && !hasChange) hasChange = true;
        });
        return hasChange;
    });
    if (hasSyncBlockChanges) {
        const oldDoc = state.doc;
        const newDoc = tr.doc;
        const syncBlockMapOld = {};
        const syncBlockMapNew = {};
        oldDoc.content.forEach((node)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapOld[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr
                };
            }
        });
        newDoc.content.forEach((node, offset)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapNew[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr,
                    node: node,
                    from: offset,
                    to: offset + node.nodeSize
                };
            }
        });
        // Find removed sync blocks
        for(const localId in syncBlockMapOld)if (!syncBlockMapNew[localId]) removed[localId] = syncBlockMapOld[localId];
        // Find added sync blocks
        for(const localId in syncBlockMapNew)if (!syncBlockMapOld[localId]) added[localId] = syncBlockMapNew[localId];
    }
    return {
        removed: Object.values(removed),
        added: Object.values(added)
    };
};
const $96d8d664fb910a31$export$7531459b60818a32 = (tr, state)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const map = step.getMap();
        const docAfterStep = tr.docs[i + 1] ?? tr.doc;
        const positions = [];
        // Extract positions from steps dynamically based on applicable properties
        if ('from' in step && typeof step.from === 'number' && 'to' in step && typeof step.to === 'number') {
            const { from: from, to: to } = step;
            positions.push(from, to);
        } else if ('pos' in step && typeof step.pos === 'number') {
            const { pos: pos } = step;
            positions.push(pos);
        }
        for (const pos of positions){
            const newPos = map.map(pos);
            if (newPos >= 0 && newPos <= docAfterStep.content.size) {
                if ((0, $bjg0G.findParentNodeOfTypeClosestToPos)(docAfterStep.resolve(newPos), bodiedSyncBlock)) return true;
            }
        }
    }
    return false;
};
module.exports["trackSyncBlocks"] = $96d8d664fb910a31$export$a1196481035d4d42;
module.exports["hasEditInSyncBlock"] = $96d8d664fb910a31$export$7531459b60818a32;

});

parcelRegister("dIIrm", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");

const $9173991c8121bb66$export$d7a680e133c792af = (tr)=>{
    if (!tr.docChanged) return false;
    for (const step of tr.steps){
        if (!(step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep))) continue;
        const childCount = step.slice.content.childCount;
        for(let i = 0; i < childCount; i++){
            const child = step.slice.content.child(i);
            if (child.type.name === 'syncBlock' || child.type.name === 'bodiedSyncBlock') return true;
        }
    }
    return false;
};
module.exports["transactionInsertsSyncedBlock"] = $9173991c8121bb66$export$d7a680e133c792af;

});

parcelRegister("hbTU5", function(module, exports) {
const $98a9fe325c1fc315$export$ce51166f6717ba9c = (state, localId)=>{
    let result;
    state.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.type === state.schema.nodes.bodiedSyncBlock && node.attrs.localId === localId) {
            result = {
                node: node,
                pos: pos
            };
            return false;
        }
        return true;
    });
    return result;
};
const $98a9fe325c1fc315$export$a97704a00c7e213a = (contentDOM, view)=>{
    const tmpDiv = document.createElement('div');
    tmpDiv.appendChild(contentDOM);
    // This is required so that prosemirror can read the fragment context and slice properly
    if (tmpDiv.firstChild instanceof HTMLElement) {
        tmpDiv.firstChild.setAttribute('data-pm-slice', '0 0 []');
        // As per requirement - when unsync reference block, it should render its content as copy&paste behaviour
        // Hence here we call pasteHTML to evoke editor paste logic that handles any unsupported nodes/marks
        return view.pasteHTML(tmpDiv.innerHTML);
    }
    return false;
};
module.exports["findBodiedSyncBlockByLocalId"] = $98a9fe325c1fc315$export$ce51166f6717ba9c;
module.exports["pasteSyncBlockHTMLContent"] = $98a9fe325c1fc315$export$a97704a00c7e213a;

});

parcelRegister("3HRZd", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $krYZG = parcelRequire("krYZG");


var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $brnfH = parcelRequire("brnfH");

var $6NW7h = parcelRequire("6NW7h");

var $0132F = parcelRequire("0132F");

var $jw4KW = parcelRequire("jw4KW");

var $bYHr8 = parcelRequire("bYHr8");

var $6X62h = parcelRequire("6X62h");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $kXmSu = parcelRequire("kXmSu");


var $i57XD = parcelRequire("i57XD");

const $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION = 30000;
const $ffc7cbcf63c6d9c3$var$pluginKey = new (0, $kCECX.PluginKey)('syncedBlockMenuAndToolbarExperience');
const $ffc7cbcf63c6d9c3$var$SYNCED_BLOCK_BUTTON_TEST_IDS = Object.values((0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID));
const $ffc7cbcf63c6d9c3$var$syncedBlockButtonIds = new Set($ffc7cbcf63c6d9c3$var$SYNCED_BLOCK_BUTTON_TEST_IDS);
const $ffc7cbcf63c6d9c3$export$8e0a561331eb68ce = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let popupsTargetEl;
    const editorViewRef = {
        current: undefined
    };
    const getPopupsTarget = ()=>{
        if (!popupsTargetEl) popupsTargetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $jw4KW.getPopupContainerFromEditorView)(editorViewRef?.current?.dom);
        return popupsTargetEl;
    };
    const createSourcePrimaryToolbarExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PRIMARY_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const createSourceBlockMenuExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BLOCK_MENU,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const createSourceQuickInsertMenuExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).QUICK_INSERT,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const deleteReferenceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).REFERENCE_SYNCED_BLOCK_DELETE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$referenceSyncBlockRemovedFromDomCheck(refs, editorViewRef)
        ]
    });
    const unsyncReferenceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).REFERENCE_SYNCED_BLOCK_UNSYNC,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$referenceSyncBlockRemovedFromDomCheck(refs, editorViewRef)
        ]
    });
    const unsyncSourceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_UNSYNC,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncBlockDeleteConfirmationModalAddedCheck()
        ]
    });
    const deleteSourceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_DELETE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncBlockDeleteConfirmationModalAddedCheck()
        ]
    });
    const syncedLocationsExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedLocationsDropdownOpenedCheck()
        ]
    });
    const bindListeners = ()=>{
        const unbindClickListener = (0, $cbY7C.bind)(document, {
            type: 'click',
            listener: (event)=>{
                const target = event.target;
                if (!target) return;
                const button = target.closest('button[data-testid]');
                if (!button || !(button instanceof HTMLButtonElement)) return;
                const testId = button.dataset.testid;
                if (!$ffc7cbcf63c6d9c3$var$isSyncedBlockButtonId(testId)) return;
                if (button.disabled) return;
                $ffc7cbcf63c6d9c3$var$handleButtonClick({
                    testId: testId,
                    button: button,
                    createSourcePrimaryToolbarExperience: createSourcePrimaryToolbarExperience,
                    createSourceBlockMenuExperience: createSourceBlockMenuExperience,
                    createSourceQuickInsertMenuExperience: createSourceQuickInsertMenuExperience,
                    deleteReferenceSyncedBlockExperience: deleteReferenceSyncedBlockExperience,
                    unsyncReferenceSyncedBlockExperience: unsyncReferenceSyncedBlockExperience,
                    unsyncSourceSyncedBlockExperience: unsyncSourceSyncedBlockExperience,
                    deleteSourceSyncedBlockExperience: deleteSourceSyncedBlockExperience,
                    syncedLocationsExperience: syncedLocationsExperience
                });
            },
            options: {
                capture: true
            }
        });
        const unbindKeydownListener = (0, $cbY7C.bind)(document, {
            type: 'keydown',
            listener: (event)=>{
                if ($ffc7cbcf63c6d9c3$var$isEnterKey(event.key)) {
                    const typeaheadPopup = (0, $6X62h.popupWithNestedElement)(getPopupsTarget(), '.fabric-editor-typeahead');
                    if (!typeaheadPopup || !(typeaheadPopup instanceof HTMLElement)) return;
                    const targetElement = typeaheadPopup.querySelector('[role="option"][aria-selected="true"]');
                    if (!targetElement || !(targetElement instanceof HTMLElement)) return;
                    const testId = targetElement.dataset.testid;
                    if (testId === (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).quickInsertCreate) createSourceQuickInsertMenuExperience.start();
                }
            },
            options: {
                capture: true
            }
        });
        return {
            unbindClickListener: unbindClickListener,
            unbindKeydownListener: unbindKeydownListener
        };
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $ffc7cbcf63c6d9c3$var$pluginKey,
        view: (view)=>{
            editorViewRef.current = view;
            // Track whether listeners have been bound. When the experiment is
            // ON and the document initially has no synced blocks, we defer
            // binding until `update()` detects that `hasSyncedBlocks` has
            // flipped to `true` (e.g. via paste or collab insert). This avoids
            // the ~2-5 ms TBT cost of capture-phase click/keydown handlers on
            // the ~99.97 % of pages that never use synced blocks (EDITOR-6931).
            let listenersBound = false;
            let unbindClickListener;
            let unbindKeydownListener;
            const ensureListenersBound = ()=>{
                if (listenersBound) return;
                listenersBound = true;
                const unbinders = bindListeners();
                unbindClickListener = unbinders.unbindClickListener;
                unbindKeydownListener = unbinders.unbindKeydownListener;
            };
            if ((0, $i57XD.syncedBlockPluginKey).getState(view.state)?.hasSyncedBlocks) ensureListenersBound();
            return {
                update: (view, prevState)=>{
                    if (!listenersBound && view.state.doc !== prevState.doc && (0, $i57XD.syncedBlockPluginKey).getState(view.state)?.hasSyncedBlocks) // Bind listeners now that synced blocks are present.
                    ensureListenersBound();
                },
                destroy: ()=>{
                    createSourcePrimaryToolbarExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    createSourceBlockMenuExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    createSourceQuickInsertMenuExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    deleteReferenceSyncedBlockExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    deleteSourceSyncedBlockExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    unsyncReferenceSyncedBlockExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    unsyncSourceSyncedBlockExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    syncedLocationsExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    unbindClickListener?.();
                    unbindKeydownListener?.();
                }
            };
        }
    });
};
const $ffc7cbcf63c6d9c3$var$isSyncedBlockButtonId = (value)=>{
    return !!value && $ffc7cbcf63c6d9c3$var$syncedBlockButtonIds.has(value);
};
const $ffc7cbcf63c6d9c3$var$handleButtonClick = ({ testId: testId, button: button, createSourcePrimaryToolbarExperience: createSourcePrimaryToolbarExperience, createSourceBlockMenuExperience: createSourceBlockMenuExperience, createSourceQuickInsertMenuExperience: createSourceQuickInsertMenuExperience, deleteReferenceSyncedBlockExperience: deleteReferenceSyncedBlockExperience, unsyncReferenceSyncedBlockExperience: unsyncReferenceSyncedBlockExperience, unsyncSourceSyncedBlockExperience: unsyncSourceSyncedBlockExperience, deleteSourceSyncedBlockExperience: deleteSourceSyncedBlockExperience, syncedLocationsExperience: syncedLocationsExperience })=>{
    switch(testId){
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).primaryToolbarCreate:
            createSourcePrimaryToolbarExperience.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).blockMenuCreate:
            createSourceBlockMenuExperience.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).quickInsertCreate:
            createSourceQuickInsertMenuExperience.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete:
            deleteReferenceSyncedBlockExperience.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceUnsync:
            unsyncReferenceSyncedBlockExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceUnsync:
            unsyncSourceSyncedBlockExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceDelete:
            deleteSourceSyncedBlockExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSyncedLocationsTrigger:
            // Only track when opening the dropdown
            if (button.getAttribute('aria-pressed') === 'false') syncedLocationsExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceOverflowTrigger:
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceOverflowTrigger:
        case (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarCopy:
            break;
        default:
            {
                // Exhaustiveness check: if a new SyncedBlockToolbarButtonId is added
                // but not handled above, TypeScript will error here.
                const _exhaustiveCheck = testId;
                return _exhaustiveCheck;
            }
    }
};
const $ffc7cbcf63c6d9c3$var$isEnterKey = (key)=>{
    return key === 'Enter';
};
const $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck = (refs, editorViewRef)=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isBodiedSyncBlockAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return [
                {
                    target: editorViewRef?.current?.dom,
                    options: {
                        childList: true
                    }
                },
                // When wrapping a node with breakout mark with sync block, breakout dom is reused
                // hence we need to observe subtree to catch sync block mutation
                {
                    target: (0, $bYHr8.getSelectionAncestorDOM)(editorViewRef?.current),
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ];
        }
    });
const $ffc7cbcf63c6d9c3$var$isBodiedSyncBlockAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isBodiedSyncBlockWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isBodiedSyncBlockWithinNode = (node)=>(0, $0132F.getNodeQuery)('[data-prosemirror-node-name="bodiedSyncBlock"]')(node);
const $ffc7cbcf63c6d9c3$var$referenceSyncBlockRemovedFromDomCheck = (refs, editorViewRef)=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isSyncBlockRemovedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return [
                {
                    target: editorViewRef?.current?.dom,
                    options: {
                        childList: true
                    }
                },
                {
                    target: (0, $bYHr8.getSelectionAncestorDOM)(editorViewRef?.current),
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ];
        }
    });
const $ffc7cbcf63c6d9c3$var$isSyncBlockRemovedInMutation = ({ type: type, removedNodes: removedNodes })=>{
    return type === 'childList' && [
        ...removedNodes
    ].some($ffc7cbcf63c6d9c3$var$isSyncBlockWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isSyncBlockWithinNode = (node)=>(0, $0132F.getNodeQuery)('[data-prosemirror-node-name="syncBlock"]')(node);
const $ffc7cbcf63c6d9c3$var$syncBlockDeleteConfirmationModalAddedCheck = ()=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return {
                target: document.body,
                options: {
                    childList: true,
                    subtree: true
                }
            };
        }
    });
const $ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalWithinNode = (node)=>(0, $0132F.getNodeQuery)('[data-testid="sync-block-delete-confirmation"]')(node);
const $ffc7cbcf63c6d9c3$var$syncedLocationsDropdownOpenedCheck = ()=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorInMutation)) return {
                status: 'failure'
            };
            if (mutations.some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return {
                target: document.body,
                options: {
                    childList: true,
                    subtree: true
                }
            };
        }
    });
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownWithinNode = (node)=>{
    return !!((0, $0132F.getNodeQuery)('[data-testid="synced-locations-dropdown-content"]')(node) || (0, $0132F.getNodeQuery)('[data-testid="synced-locations-dropdown-content-no-results"]')(node));
};
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorWithinNode = (node)=>{
    return !!(0, $0132F.getNodeQuery)('[data-testid="synced-locations-dropdown-content-error"]')(node);
};
module.exports["getMenuAndToolbarExperiencesPlugin"] = $ffc7cbcf63c6d9c3$export$8e0a561331eb68ce;

});

parcelRegister("0132F", function(module, exports) {
/**
 * Checks if a node matches or contains the node given by the provided query css selector
 *
 * @param query - CSS selector string
 * @returns true if node matches or contains query or false otherwise
 */ const $3d4bbf22d1dcb0b8$export$a3814e00999abbb7 = (query)=>(node)=>{
        if (!node || !(node instanceof Element)) return false;
        return node.matches(query) || node.querySelector(query) !== null;
    };
module.exports["getNodeQuery"] = $3d4bbf22d1dcb0b8$export$a3814e00999abbb7;

});

parcelRegister("4bFib", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $7gBZH = parcelRequire("7gBZH");

const $e23c7d606d2e1612$export$b1be7b75e24fc24b = (api, enableSourceSyncedBlockCreation)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_SECTION_RANK)[(0, $8i6M6.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gBZH.CreateOrCopySyncedBlockDropdownItem), {
                    api: api,
                    enableSourceSyncedBlockCreation: enableSourceSyncedBlockCreation
                })
        }
    ];
};
module.exports["getBlockMenuComponents"] = $e23c7d606d2e1612$export$b1be7b75e24fc24b;

});

parcelRegister("7gBZH", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $3FYPH = parcelRequire("3FYPH");

var $aI2Eh = parcelRequire("aI2Eh");


var $6Ixg8 = parcelRequire("6Ixg8");


var $3rarE = parcelRequire("3rarE");

var $dVKvM = parcelRequire("dVKvM");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $73IhX = parcelRequire("73IhX");


var $kXmSu = parcelRequire("kXmSu");

const $c35d561f111ba545$var$SyncedBlockNewLozenge = ({ label: label })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
        appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
        children: label
    });
const $c35d561f111ba545$var$CreateSyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { selection: selection, menuTriggerByNode: menuTriggerByNode, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection',
        'blockControls',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined,
            mode: states.connectivityState?.mode
        }));
    const isNested = menuTriggerByNode && menuTriggerByNode.rootPos !== menuTriggerByNode.pos;
    const canBeConverted = (0, $cozmU.useMemo)(()=>selection && (0, $73IhX.canBeConvertedToSyncBlock)(selection), [
        selection
    ]);
    if (isNested || !canBeConverted) return null;
    const onClick = ()=>{
        // Insert the synced block, close the block menu, and stop preserving the
        // selection — all in a single transaction, mirroring the block-menu delete
        // item. Stopping preservation is required so the caret that
        // insertSyncedBlock places inside the new block survives; otherwise
        // block-controls restores a whole-node NodeSelection over it, hiding the
        // caret (EDITOR-7949). Then re-focus the editor so the caret is active,
        // but only when the transaction was actually dispatched — otherwise a
        // failed insertion would still steal DOM focus into the editor.
        const dispatched = api?.core?.actions.execute(({ tr: tr })=>{
            // If the insertion fails, bail out without closing the menu or
            // stopping selection preservation — otherwise we would dispatch an
            // effectively-empty transaction and close the menu despite nothing
            // having been inserted.
            const result = api?.syncedBlock.commands.insertSyncedBlock((0, $krYZG.INPUT_METHOD).BLOCK_MENU)({
                tr: tr
            });
            if (!result) return null;
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        if (dispatched) api?.core?.actions.focus();
    };
    const isOffline = (0, $6Ixg8.isOfflineMode)(mode);
    const lozenge = /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$SyncedBlockNewLozenge, {
        label: formatMessage((0, $3FYPH.messages).newLozenge)
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        isDisabled: isOffline,
        testId: (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).blockMenuCreate,
        elemAfterText: lozenge,
        children: formatMessage((0, $3FYPH.messages).syncBlock)
    });
};
const $c35d561f111ba545$var$CopySyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const onClick = ()=>{
        api?.core?.actions.execute(api?.syncedBlock.commands.copySyncedBlockReferenceToClipboard((0, $krYZG.INPUT_METHOD).BLOCK_MENU));
        api?.core?.actions.execute(api?.blockControls?.commands?.toggleBlockMenu({
            closeMenu: true
        }));
    };
    const lozenge = /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$SyncedBlockNewLozenge, {
        label: formatMessage((0, $3FYPH.messages).newLozenge)
    });
    const copyLabel = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? (0, $aI2Eh.syncBlockMessages).copyToSyncLabel : (0, $3FYPH.messages).copySyncedBlock;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        isDisabled: (0, $6Ixg8.isOfflineMode)(mode),
        elemAfterText: lozenge,
        children: formatMessage(copyLabel)
    });
};
const $c35d561f111ba545$export$3699afce8ee13fa8 = ({ api: api, enableSourceSyncedBlockCreation: enableSourceSyncedBlockCreation })=>{
    const { menuTriggerByNode: menuTriggerByNode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined
        }));
    if (menuTriggerByNode?.nodeType === 'syncBlock' || menuTriggerByNode?.nodeType === 'bodiedSyncBlock') return /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$CopySyncedBlockDropdownItem, {
        api: api
    });
    else if (enableSourceSyncedBlockCreation) return /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$CreateSyncedBlockDropdownItem, {
        api: api
    });
    else return null;
};
module.exports["CreateOrCopySyncedBlockDropdownItem"] = $c35d561f111ba545$export$3699afce8ee13fa8;

});

parcelRegister("8NL8R", function(module, exports) {
/* DeleteConfirmationModal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $3k5Tv = parcelRequire("3k5Tv");


var $aI2Eh = parcelRequire("aI2Eh");


var $6Ixg8 = parcelRequire("6Ixg8");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $i57XD = parcelRequire("i57XD");

const $571e47d3afda4415$var$modalContentMap = {
    'source-block-deleted': {
        titleMultiple: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalTitleMultiple,
        titleSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalTitleSingle,
        descriptionSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNoRef,
        descriptionMultiple: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNew,
        confirmButtonLabel: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalDeleteButton
    },
    'source-block-unpublished': {
        titleMultiple: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalTitleMultiple,
        titleSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalTitleSingle,
        descriptionSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNoRef,
        descriptionMultiple: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNew,
        confirmButtonLabel: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalDeleteButton
    },
    'source-block-unsynced': {
        titleMultiple: (0, $aI2Eh.syncBlockMessages).unsyncConfirmationModalTitle,
        titleSingle: (0, $aI2Eh.syncBlockMessages).unsyncConfirmationModalTitle,
        descriptionSingle: (0, $aI2Eh.syncBlockMessages).unsyncConfirmModalDescriptionSingle,
        descriptionMultiple: (0, $aI2Eh.syncBlockMessages).unsyncConfirmModalDescriptionMultipleNew,
        confirmButtonLabel: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalUnsyncButton
    }
};
const $571e47d3afda4415$var$styles = {
    spinner: "_3SamIHIZbP _2YLqiKIZbP"
};
const $571e47d3afda4415$export$d973532b09e0f2cc = ({ syncBlockStoreManager: syncBlockStoreManager, api: api, editorView: editorView })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [syncBlockIds, setSyncBlockIds] = (0, $cozmU.useState)(undefined);
    const [referenceCount, setReferenceCount] = (0, $cozmU.useState)(undefined);
    const [deleteReason, setDeleteReason] = (0, $cozmU.useState)('source-block-deleted');
    const { mode: mode, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, activeFlag: activeFlag } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'syncedBlock'
    ], (states)=>({
            mode: states.connectivityState?.mode,
            bodiedSyncBlockDeletionStatus: states.syncedBlockState?.bodiedSyncBlockDeletionStatus,
            activeFlag: states.syncedBlockState?.activeFlag
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolverRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined); // When a source block with no references is deleted, the modal is never shown but
    // onDeleteCompleted still sets bodiedSyncBlockDeletionStatus to 'completed'. This ref signals
    // the useEffect to silently reset the status without trying to close the modal (which was never open).
    const skipModalOnCompletedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const handleClick = (0, $cozmU.useCallback)((confirm)=>()=>{
            if (resolverRef.current) {
                resolverRef.current(confirm);
                resolverRef.current = undefined;
            }
            if (!confirm) {
                setIsOpen(false);
                setReferenceCount(undefined);
            }
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                    bodiedSyncBlockDeletionStatus: confirm ? 'processing' : 'none',
                    activeFlag: false
                });
            }); // The delete menu adds a `danger` decoration that it only clears on mouse leave, which
            // never fires because clicking Delete closes the menu. It stays for the lifetime of this
            // modal so the block being deleted remains highlighted, and confirming drops it along
            // with the node, but cancelling has to clear it or the red highlight is left behind.
            if (!confirm && editorView && (0, $iDrrr.fg)('platform_editor_blocks_patch_7')) api?.decorations?.actions.removeDecoration(editorView.state, editorView.dispatch);
        }, [
        api?.core?.actions,
        api?.decorations?.actions,
        editorView
    ]);
    // Store activeFlag in a ref so confirmationCallback always reads the latest value
    // even if it changes during the await fetchReferenceCountRef call.
    const activeFlagRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(activeFlag);
    activeFlagRef.current = activeFlag; // Use a ref so fetchReferenceCount can be called from confirmationCallback without
    // being added to its dependency array — preventing confirmationCallback from being
    // recreated mid-flight during an await (which would break the promise chain).
    // The assignment during render is intentional — this is a standard React ref-as-latest-value
    // pattern. The reduce over syncBlockIds (typically 1-2 items) is not actually expensive.
    const fetchReferenceCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>Promise.resolve(0));
    fetchReferenceCountRef.current = async (syncBlockIds)=>{
        const references = await Promise.all(syncBlockIds.map(async (syncBlockId)=>{
            const result = await syncBlockStoreManager.sourceManager.fetchReferences(syncBlockId.resourceId);
            if (result?.error) // Consider fetch fails as soon as one of the fetches fails
            throw new Error();
            return result.references?.length ?? 0;
        })); // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render
        return references.reduce((sum, count)=>sum + count, 0);
    };
    const confirmationCallback = (0, $cozmU.useCallback)(async (syncBlockIds, deleteReason)=>{
        // Fetch references before opening the modal. If none exist, skip the modal
        // entirely and auto-confirm the deletion. On fetch error, default to showing
        // the modal to avoid accidental data loss.
        let count;
        try {
            count = await fetchReferenceCountRef.current(syncBlockIds);
        } catch  {
            count = 1;
        }
        if (count === 0) {
            // No references — auto-confirm without showing the modal.
            // Clear activeFlag to avoid issues with subsequent deletion attempts.
            // We do NOT reset bodiedSyncBlockDeletionStatus here because onDeleteCompleted
            // will set it to 'completed' after the delete call returns. Instead we use a
            // ref to signal that the next 'completed' status should be silently reset
            // without trying to close the modal.
            skipModalOnCompletedRef.current = true;
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                    ...activeFlagRef.current ? {
                        activeFlag: false
                    } : {}
                });
            });
            return true;
        }
        setReferenceCount(count);
        setIsOpen(true);
        setSyncBlockIds(syncBlockIds);
        if (deleteReason) setDeleteReason(deleteReason);
        const confirmedPromise = new Promise((resolve)=>{
            resolverRef.current = resolve;
        });
        if (activeFlagRef.current) api?.core?.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                // Clear flag to avoid potential retry deletion of different blocks
                activeFlag: false
            });
        });
        return confirmedPromise;
    }, // fetchReferenceCountRef and activeFlagRef are intentionally omitted — they are refs
    // and never change identity, ensuring confirmationCallback is never recreated mid-flight
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        api?.core?.actions
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unregister = syncBlockStoreManager.sourceManager.registerConfirmationCallback(confirmationCallback);
        return ()=>{
            unregister();
        };
    }, [
        syncBlockStoreManager,
        confirmationCallback
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skipModalOnCompletedRef.current) {
            if (bodiedSyncBlockDeletionStatus === 'completed') // Deletion was auto-confirmed without showing the modal (no references).
            // Reset the status to 'none' — keep skipModalOnCompletedRef true until
            // we confirm the status has landed as 'none' to guard against the race where
            // the next deletion opens the modal before this transaction is processed.
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                    bodiedSyncBlockDeletionStatus: 'none'
                });
            });
            else if (bodiedSyncBlockDeletionStatus === 'none') skipModalOnCompletedRef.current = false;
            else if (bodiedSyncBlockDeletionStatus === 'processing' && isOpen) // Reset on deletion failure (e.g. network error) to avoid modal stuck in opened state.
            skipModalOnCompletedRef.current = false;
            return;
        }
        if (bodiedSyncBlockDeletionStatus === 'completed' && isOpen) {
            // auto close modal once deletion is successful
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setIsOpen(false);
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                    // Reset deletion status to have a clean state for next deletion
                    bodiedSyncBlockDeletionStatus: 'none'
                });
            });
        }
    }, [
        api?.core?.actions,
        bodiedSyncBlockDeletionStatus,
        isOpen
    ]); // References are fetched and set before the modal opens in
    // confirmationCallback, so no additional fetch is needed here.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: handleClick(false),
            testId: "sync-block-delete-confirmation",
            height: 184,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                children: referenceCount === undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $571e47d3afda4415$var$styles.spinner,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: "large"
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)($571e47d3afda4415$var$ModalContent, {
                    content: $571e47d3afda4415$var$modalContentMap[deleteReason],
                    referenceCount: referenceCount,
                    handleClick: handleClick,
                    formatMessage: formatMessage,
                    isDeleting: bodiedSyncBlockDeletionStatus === 'processing',
                    isDisabled: (0, $6Ixg8.isOfflineMode)(mode),
                    deleteReason: deleteReason,
                    sourceCount: syncBlockIds?.length || 0
                })
            })
        })
    });
};
const $571e47d3afda4415$var$ModalContent = ({ content: content, referenceCount: referenceCount, handleClick: handleClick, formatMessage: formatMessage, isDeleting: isDeleting, isDisabled: isDisabled, deleteReason: deleteReason, sourceCount: sourceCount })=>{
    const { titleMultiple: titleMultiple, titleSingle: titleSingle, descriptionSingle: descriptionSingle, descriptionMultiple: descriptionMultiple, confirmButtonLabel: confirmButtonLabel } = content;
    const hasNoReferenceOrFailToFetch = referenceCount === 0;
    const totalLocationCount = deleteReason === 'source-block-deleted' ? referenceCount + sourceCount : referenceCount;
    const isReferenceCountDescriptionEnabled = deleteReason === 'source-block-deleted' && (0, $iDrrr.fg)('platform_editor_blocks_patch_7');
    const descriptionLocationCount = isReferenceCountDescriptionEnabled ? referenceCount : totalLocationCount;
    const descriptionMultipleMessage = isReferenceCountDescriptionEnabled ? (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionReferenceCount : descriptionMultiple;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    appearance: "warning",
                    children: hasNoReferenceOrFailToFetch ? formatMessage(titleSingle) : formatMessage(titleMultiple, {
                        count: totalLocationCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fEPJS.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    children: hasNoReferenceOrFailToFetch ? formatMessage(descriptionSingle) : formatMessage(descriptionMultipleMessage, {
                        syncBlockCount: descriptionLocationCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $eQiT1.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "subtle",
                        onClick: handleClick(false),
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).deleteConfirmationModalCancelButton)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "warning",
                        onClick: handleClick(true),
                        autoFocus: true,
                        isDisabled: isDisabled,
                        isLoading: isDeleting,
                        testId: `synced-block-delete-confirmation-modal-${deleteReason}-button`,
                        children: formatMessage(confirmButtonLabel)
                    })
                ]
            })
        ]
    });
};
module.exports["DeleteConfirmationModal"] = $571e47d3afda4415$export$d973532b09e0f2cc;

});

parcelRegister("7KArf", function(module, exports) {
/* Flag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $aI2Eh = parcelRequire("aI2Eh");


var $eO7Q2 = parcelRequire("eO7Q2");


var $6Ixg8 = parcelRequire("6Ixg8");


var $a2foB = parcelRequire("a2foB");

var $FKQbh = parcelRequire("FKQbh");

var $lqtHz = parcelRequire("lqtHz");


var $f3HCt = parcelRequire("f3HCt");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");


var $ieeJu = parcelRequire("ieeJu");


var $i57XD = parcelRequire("i57XD");


var $kXmSu = parcelRequire("kXmSu");

const $93a1ff420248a392$var$feedbackFlagStyles = null;
const $93a1ff420248a392$var$flagMap = {
    [(0, $kXmSu.FLAG_ID).CANNOT_DELETE_WHEN_OFFLINE]: {
        title: (0, $aI2Eh.syncBlockMessages).failToDeleteTitle,
        description: (0, $aI2Eh.syncBlockMessages).failToDeleteWhenOfflineDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).CANNOT_EDIT_WHEN_OFFLINE]: {
        title: (0, $aI2Eh.syncBlockMessages).failToEditTitle,
        description: (0, $aI2Eh.syncBlockMessages).failToEditWhenOfflineDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).CANNOT_CREATE_WHEN_OFFLINE]: {
        title: (0, $aI2Eh.syncBlockMessages).failToCreateTitle,
        description: (0, $aI2Eh.syncBlockMessages).failToCreateWhenOfflineDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).FAIL_TO_DELETE]: {
        title: (0, $aI2Eh.syncBlockMessages).cannotDeleteTitle,
        description: (0, $aI2Eh.syncBlockMessages).cannotDeleteDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).SYNC_BLOCK_COPIED]: {
        title: (0, $aI2Eh.syncBlockMessages).syncBlockCopiedTitle,
        type: 'info'
    },
    [(0, $kXmSu.FLAG_ID).UNPUBLISHED_SYNC_BLOCK_PASTED]: {
        title: (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedTitle,
        description: (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedDescription,
        type: 'info'
    },
    [(0, $kXmSu.FLAG_ID).CANNOT_CREATE_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).cannotCreateSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).CannotCreateSyncBlockDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).EXTENSION_IN_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).extensionInSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).extensionInSyncBlockDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).INLINE_EXTENSION_IN_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).inlineExtensionInSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).inlineExtensionInSyncBlockDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).DUPLICATE_SOURCE_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).duplicateSourceSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).duplicateSourceSyncBlockDescription,
        type: 'error'
    },
    [(0, $kXmSu.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT]: {
        title: (0, $aI2Eh.syncBlockMessages).feedbackFlagTitle,
        description: (0, $aI2Eh.syncBlockMessages).feedbackFlagDescription,
        type: 'feedback'
    }
};
const $93a1ff420248a392$export$ff27f1a30a9d5c47 = (activeFlag, isSyncBlockActivationEnabled)=>{
    if (!activeFlag || activeFlag.id !== (0, $kXmSu.FLAG_ID).SYNC_BLOCK_COPIED || activeFlag.sourceProduct !== 'confluence-page' || !isSyncBlockActivationEnabled) return undefined;
    return activeFlag.isLivePage || !activeFlag.isSourceContentUnpublished ? (0, $aI2Eh.syncBlockMessages).syncBlockCopiedLivePageDescription : (0, $aI2Eh.syncBlockMessages).syncBlockCopiedUnpublishedDescription;
};
const $93a1ff420248a392$export$48ea269755562084 = ({ api: api, onFeedbackPromptShown: onFeedbackPromptShown, onGiveFeedback: onGiveFeedback })=>{
    const { activeFlag: activeFlag, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'syncedBlock',
        'connectivity'
    ], (states)=>{
        return {
            activeFlag: states.syncedBlockState?.activeFlag,
            mode: states.connectivityState?.mode
        };
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isFeedbackPromptVisible = activeFlag && activeFlag.id === (0, $kXmSu.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!isFeedbackPromptVisible || !onFeedbackPromptShown) return;
        try {
            const promptShownResult = onFeedbackPromptShown();
            Promise.resolve(promptShownResult).catch(()=>{});
        } catch  {}
    }, [
        isFeedbackPromptVisible,
        onFeedbackPromptShown
    ]);
    if (!activeFlag) return;
    const { title: defaultTitle, description: defaultDescription, action: action, type: type } = $93a1ff420248a392$var$flagMap[activeFlag.id];
    const { onRetry: onRetry, onDismissed: onDismissedCallback } = activeFlag; // For the unpublished-paste flag, swap to the Jira-flavoured copy when the source
    // is a Jira work item. Other flags don't currently vary by product.
    const isJiraUnpublishedPaste = activeFlag.id === (0, $kXmSu.FLAG_ID).UNPUBLISHED_SYNC_BLOCK_PASTED && activeFlag.sourceProduct === 'jira-work-item';
    const copiedDescription = $93a1ff420248a392$export$ff27f1a30a9d5c47(activeFlag, activeFlag.id === (0, $kXmSu.FLAG_ID).SYNC_BLOCK_COPIED && (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true));
    const title = isJiraUnpublishedPaste ? (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedTitleJiraWorkItem : defaultTitle;
    const description = copiedDescription ?? (isJiraUnpublishedPaste ? (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedDescriptionJiraWorkItem : defaultDescription); // Retry button often involves network request, hence we dismiss the flag in offline mode to avoid retry
    if ((0, $6Ixg8.isOfflineMode)(mode) && !!onRetry) {
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                activeFlag: false
            });
            return tr;
        });
        return;
    }
    const dismissFlag = (shouldFocusEditor)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback?.(tr);
            const oldMeta = tr.getMeta((0, $i57XD.syncedBlockPluginKey));
            tr.setMeta((0, $i57XD.syncedBlockPluginKey), {
                ...oldMeta,
                activeFlag: false
            });
            return tr;
        });
        if (shouldFocusEditor) api?.core.actions.focus();
    };
    const onDismissed = ()=>dismissFlag(true);
    const typeToActions = ()=>{
        if (type === 'error') {
            if (onRetry) return [
                {
                    content: formatMessage((0, $aI2Eh.syncBlockMessages).deleteRetryButton),
                    onClick: onRetry
                }
            ];
        } else if (type === 'info' && action) return [
            {
                content: formatMessage(action),
                href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                target: '_blank',
                rel: 'noopener noreferrer'
            }
        ];
        else if (type === 'feedback' && activeFlag.id === (0, $kXmSu.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT && activeFlag.feedbackContext) {
            const feedbackContext = activeFlag.feedbackContext;
            return [
                {
                    content: formatMessage((0, $aI2Eh.syncBlockMessages).feedbackFlagGiveFeedback),
                    onClick: ()=>{
                        dismissFlag(false);
                        try {
                            const feedbackResult = onGiveFeedback?.(feedbackContext);
                            Promise.resolve(feedbackResult).catch(()=>{});
                        } catch  {}
                    }
                },
                {
                    content: formatMessage((0, $aI2Eh.syncBlockMessages).feedbackFlagNoThanks),
                    onClick: onDismissed
                }
            ];
        }
        return undefined;
    };
    const FlagComponent = type === 'info' ? (0, $a2foB.default) : (0, $FKQbh.default);
    const flag = /*#__PURE__*/ (0, $8aG6j.jsx)(FlagComponent, {
        onDismissed: onDismissed,
        title: formatMessage(title),
        description: description ? formatMessage(description) : undefined,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: $93a1ff420248a392$var$typeToIcon(type),
        actions: typeToActions()
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        children: type === 'feedback' ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            id: activeFlag.id,
            className: (0, $hekY6.default)([
                "_0MlzL8AASz"
            ]),
            children: flag
        }) : flag
    });
};
const $93a1ff420248a392$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    if (type === 'feedback') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
};
module.exports["Flag"] = $93a1ff420248a392$export$48ea269755562084;

});

parcelRegister("eO7Q2", function(module, exports) {
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $9b8564145c0d1038$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
module.exports["SYNCED_BLOCKS_DOCUMENTATION_URL"] = $9b8564145c0d1038$export$81b3a92cdfa3191b;

});

parcelRegister("aXxPN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $2xhuI = parcelRequire("2xhuI");

var $aI2Eh = parcelRequire("aI2Eh");

var $gx3UZ = parcelRequire("gx3UZ");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $4hfky = parcelRequire("4hfky");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $79ir6 = parcelRequire("79ir6");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8y86q = parcelRequire("8y86q");


var $f3HCt = parcelRequire("f3HCt");


var $ieeJu = parcelRequire("ieeJu");


var $hzCKL = parcelRequire("hzCKL");


var $73IhX = parcelRequire("73IhX");


var $kXmSu = parcelRequire("kXmSu");


var $8oKCo = parcelRequire("8oKCo");

const $cd8ed20e91ae803f$export$86ce8f8241c20a3 = (state, intl, api, syncBlockStore, isLivePage, onGiveFeedback)=>{
    const syncBlockObject = (0, $73IhX.findSyncBlockOrBodiedSyncBlock)(state.schema, state.selection);
    if (!syncBlockObject) return;
    if (syncBlockStore.sourceManager.isPendingCreation(syncBlockObject.node.attrs.resourceId)) return;
    const isSyncBlockActivationEnabled = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true);
    const syncBlockInstance = syncBlockStore.referenceManager.getFromCache(syncBlockObject.node.attrs.resourceId);
    const isUnsyncedBlock = syncBlockInstance?.error?.type === (0, $79ir6.SyncBlockError).NotFound;
    const isErroredBlock = syncBlockInstance?.error;
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock } } } = state;
    const isBodiedSyncBlock = (0, $73IhX.isBodiedSyncBlockNode)(syncBlockObject.node, bodiedSyncBlock);
    const { resourceId: resourceId, localId: localId } = syncBlockObject.node.attrs;
    const { formatMessage: formatMessage } = intl;
    const nodeType = syncBlockObject.node.type;
    const hoverDecoration = api?.decorations?.actions.hoverDecoration;
    const hoverDecorationProps = (nodeType, className)=>({
            onMouseEnter: hoverDecoration?.(nodeType, true, className),
            onMouseLeave: hoverDecoration?.(nodeType, false, className),
            onFocus: hoverDecoration?.(nodeType, true, className),
            onBlur: hoverDecoration?.(nodeType, false, className)
        });
    const items = [];
    if (isUnsyncedBlock) {
        const deleteButton = {
            type: 'button',
            title: formatMessage((0, $2xhuI.default).delete),
            onClick: (0, $hzCKL.removeSyncedBlock)(api),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            testId: (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete,
            ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
        };
        items.push(deleteButton);
    } else {
        // When the synced block activation experiment is enabled, the copy action is
        // re-framed as the primary "Copy to sync" action: it shows a visible label and
        // is moved to the first toolbar position (before the synced-location info). See
        // EDITOR-8060.
        const copyButton = {
            id: 'editor.syncedBlock.copy',
            type: 'button',
            appearance: 'subtle',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            title: isSyncBlockActivationEnabled ? formatMessage((0, $aI2Eh.syncBlockMessages).copyToSyncLabel) : formatMessage((0, $aI2Eh.syncBlockMessages).copySyncBlockLabel),
            showTitle: isSyncBlockActivationEnabled,
            tooltipContent: isSyncBlockActivationEnabled ? undefined : formatMessage((0, $aI2Eh.syncBlockMessages).copySyncedBlockTooltip),
            testId: isSyncBlockActivationEnabled ? (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarCopy : undefined,
            onClick: (0, $hzCKL.copySyncedBlockReferenceToClipboard)(syncBlockStore, (0, $krYZG.INPUT_METHOD).SYNCED_BLOCK_TB, api, isLivePage),
            ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
        };
        // In the activation experience the primary "Copy to sync" action leads the
        // toolbar, ahead of the informational synced-location dropdown.
        if (isSyncBlockActivationEnabled) items.push(copyButton);
        if (!isErroredBlock) {
            const syncedLocation = {
                type: 'custom',
                fallback: [],
                render: (_view, _idx, _dispatchAnalyticsEvent, floatingToolbarRenderContext)=>{
                    if (isSyncBlockActivationEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oKCo.SyncedLocationDropdownWithCount), {
                        syncBlockStore: syncBlockStore,
                        resourceId: resourceId,
                        localId: localId,
                        intl: intl,
                        isSource: isBodiedSyncBlock,
                        api: api,
                        floatingToolbarRenderContext: floatingToolbarRenderContext
                    }, `${resourceId}:${localId}:${isBodiedSyncBlock}`);
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oKCo.SyncedLocationDropdown), {
                        syncBlockStore: syncBlockStore,
                        resourceId: resourceId,
                        localId: localId,
                        intl: intl,
                        isSource: isBodiedSyncBlock,
                        api: api,
                        floatingToolbarRenderContext: floatingToolbarRenderContext
                    });
                }
            };
            const unsyncButton = {
                type: 'custom',
                fallback: [],
                render: (view)=>{
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
                        areAnyNewToolbarFlagsEnabled: true,
                        disabled: syncBlockInstance?.data?.status === 'unpublished',
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8y86q))), {
                            label: ""
                        }),
                        title: formatMessage((0, $aI2Eh.syncBlockMessages).unsyncButton),
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>(0, $hzCKL.unsync)(syncBlockStore, isBodiedSyncBlock, view),
                        testId: isBodiedSyncBlock ? (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceUnsync : (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceUnsync
                    });
                }
            };
            items.push(syncedLocation, unsyncButton);
        }
        // Outside the activation experience the copy button keeps its original
        // (icon-only, secondary) position after the synced-location info.
        if (!isSyncBlockActivationEnabled) items.push(copyButton);
        const disabled = !syncBlockStore.referenceManager.getSyncBlockURL(syncBlockObject.node.attrs.resourceId);
        if (!isBodiedSyncBlock) {
            const editSourceButton = {
                id: 'editor.syncedBlock.editSource',
                type: 'button',
                disabled: disabled,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
                title: formatMessage((0, $aI2Eh.syncBlockMessages).editSourceLabel),
                showTitle: false,
                tooltipContent: disabled ? formatMessage((0, $aI2Eh.syncBlockMessages).editSourceTooltipDisabled) : formatMessage((0, $aI2Eh.syncBlockMessages).editSourceTooltip),
                onClick: (0, $hzCKL.editSyncedBlockSource)(syncBlockStore, api),
                ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
            };
            items.push(editSourceButton);
        }
        if (!isSyncBlockActivationEnabled) {
            const separator = {
                type: 'separator'
            };
            const deleteButton = {
                id: 'editor.syncedBlock.delete',
                type: 'button',
                appearance: 'danger',
                title: formatMessage((0, $2xhuI.default).delete),
                showTitle: false,
                tooltipContent: formatMessage((0, $2xhuI.default).delete),
                onClick: (0, $hzCKL.removeSyncedBlock)(api),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                testId: isBodiedSyncBlock ? (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceDelete : (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete,
                ...hoverDecorationProps(nodeType)
            };
            items.push(separator, deleteButton);
        } else {
            // testId is required to show focus on trigger button on ESC key press
            // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
            const testId = isBodiedSyncBlock ? (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceOverflowTrigger : (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceOverflowTrigger;
            const overflowMenuConfig = [
                {
                    type: 'overflow-dropdown',
                    testId: testId,
                    options: [
                        ...isSyncBlockActivationEnabled && onGiveFeedback ? [
                            {
                                title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).feedbackDialog),
                                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
                                    label: ""
                                }),
                                onClick: ()=>{
                                    api?.core.actions.execute(({ tr: tr })=>tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(syncBlockObject.pos + syncBlockObject.node.nodeSize), (0, $eaLat.Side).RIGHT)));
                                    onGiveFeedback({
                                        blockType: isBodiedSyncBlock ? 'source' : 'reference',
                                        entryPoint: 'overflow-menu'
                                    });
                                    return true;
                                }
                            }
                        ] : [],
                        {
                            title: formatMessage((0, $2xhuI.default).delete),
                            onClick: (0, $hzCKL.removeSyncedBlock)(api),
                            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                                label: ""
                            }),
                            testId: isBodiedSyncBlock ? (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceDelete : (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete,
                            ...hoverDecorationProps(nodeType)
                        }
                    ]
                }
            ];
            items.push(...overflowMenuConfig);
        }
    }
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $bjg0G.findDomRefAtPos)(syncBlockObject.pos, domAtPos);
        return element;
    };
    return {
        title: 'Synced Block floating controls',
        getDomRef: getDomRef,
        nodeType: nodeType,
        items: items,
        scrollable: true,
        groupLabel: formatMessage((0, $aI2Eh.syncBlockMessages).syncBlockGroup),
        visible: api?.connectivity?.sharedState.currentState()?.mode !== 'offline'
    };
};
module.exports["getToolbarConfig"] = $cd8ed20e91ae803f$export$86ce8f8241c20a3;

});

parcelRegister("8oKCo", function(module, exports) {
/* SyncedLocationDropdown.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $krYZG = parcelRequire("krYZG");


var $aI2Eh = parcelRequire("aI2Eh");


var $eO7Q2 = parcelRequire("eO7Q2");


var $4hfky = parcelRequire("4hfky");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $6oMcp = parcelRequire("6oMcp");


var $2Fmt9 = parcelRequire("2Fmt9");


var $kLlYX = parcelRequire("kLlYX");


var $6spAz = parcelRequire("6spAz");


var $7sJoX = parcelRequire("7sJoX");


var $7vAVv = parcelRequire("7vAVv");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $24dy7 = parcelRequire("24dy7");


var $jrU5N = parcelRequire("jrU5N");


var $lSw2p = parcelRequire("lSw2p");


var $iAaYd = parcelRequire("iAaYd");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");


var $9KSWX = parcelRequire("9KSWX");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $lpNn5 = parcelRequire("lpNn5");


var $kXmSu = parcelRequire("kXmSu");


var $lExDX = parcelRequire("lExDX");

const $c9326a9d581538d9$var$fadeIn = null;
const $c9326a9d581538d9$var$headingStyles = null;
const $c9326a9d581538d9$var$dropdownItemStyles = null; // logo icon does not fit in ADS IconTile, hence we need custom styles to match with other icons
const $c9326a9d581538d9$var$logoTileStyles = null;
const $c9326a9d581538d9$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID = 'synced-block-synced-locations-dropdown';
const $c9326a9d581538d9$var$styles = {
    title: "_4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _39HuIbz8Lp _1ANEUSLRg7",
    note: "_1UtDYzKGUX _1ANEUSLRg7",
    lozenge: "_0GTcwRgVvo _4ouGXIfI2J",
    noResultsContainer: "_39xV02doBh _2fwxA5DIqT",
    activationDropdownContent: "_4c065UPgdg _39xV02Hakr",
    activationNoResultsContainer: "_24h04i2Njc _39xV02Hakr _0Of8r2NHnM _1wydGWNHnM",
    activationNoResultsContent: "_2YLqiKIZbP _39xV02Fsop _2fwxA5DIqT",
    dropdownContent: "_4c065UFQfX _39xV027EXf _0NUa3rAef5 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    containerWithMinHeight: "_4kiQYAKa7A",
    contentContainer: "_2fBhteZewk _39xV02N91d _4xdlr0FlnN _2WAcuGIZbP",
    errorContainer: "_39xV02doBh _3iDTPbQ4SZ",
    errorIcon: "_3SamIH5UaJ",
    learnMoreLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8",
    requestAccess: "_39xV02Mw9m _1ANEUSLRg7 _0GTcwRgVvo _1UtDYzKGUX"
};
const $c9326a9d581538d9$var$shouldApplyMinHeight = (fetchStatus, itemCount)=>{
    // When there are 1/2 items, dropdown height is less than minHeight 144px
    return !(fetchStatus === 'success' && itemCount > 0);
};
const $c9326a9d581538d9$var$ItemTitle = ({ title: title, formatMessage: formatMessage, onSameDocument: onSameDocument, isSource: isSource, hasAccess: hasAccess, productType: productType })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.title,
                children: title
            }),
            onSameDocument && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.note,
                children: [
                    "\xa0-",
                    ' ',
                    formatMessage(productType === 'confluence-page' ? (0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleNoteForConfluencePage : (0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleNoteForJiraWorkItem)
                ]
            }),
            isSource && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.lozenge,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownSourceLozenge)
                })
            }),
            !hasAccess && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.requestAccess,
                children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownRequestAccess)
            })
        ]
    });
};
const $c9326a9d581538d9$var$productIconMap = {
    'confluence-page': (0, $bltJZ.ConfluenceIcon),
    'jira-work-item': (0, $bltJZ.JiraIcon)
};
const $c9326a9d581538d9$var$subTypeIconMap = {
    live: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
    page: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH)))
};
const $c9326a9d581538d9$var$getConfluenceSubTypeIcon = (sourceAri, subType)=>{
    try {
        const { type: pageType } = (0, $6oMcp.getPageIdAndTypeFromConfluencePageAri)({
            ari: sourceAri
        });
        if (pageType === 'blogpost') return 0, (/*@__PURE__*/$parcel$interopDefault($d4GYd));
        else return subType && subType in $c9326a9d581538d9$var$subTypeIconMap ? $c9326a9d581538d9$var$subTypeIconMap[subType] : (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH)));
    } catch  {
        return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
    }
};
const $c9326a9d581538d9$var$ProductIcon = ({ product: product })=>{
    const ProductIcon = product ? $c9326a9d581538d9$var$productIconMap[product] ?? (0, $NlHoa.AtlassianIcon) : (0, $NlHoa.AtlassianIcon);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_0bjKvD0O7w _0KLXruDMqu _39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(ProductIcon, {
            size: "xxsmall",
            appearance: "neutral"
        })
    });
}; // Map AGG issue-type names to ADS icons. The mapping is by the English `name` returned
const $c9326a9d581538d9$var$jiraIssueTypeIconMap = {
    Task: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        messageKey: 'syncedLocationDropdownIssueTypeTask'
    },
    Bug: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        messageKey: 'syncedLocationDropdownIssueTypeBug'
    },
    Story: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        messageKey: 'syncedLocationDropdownIssueTypeStory'
    },
    Epic: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        messageKey: 'syncedLocationDropdownIssueTypeEpic'
    },
    Subtask: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        messageKey: 'syncedLocationDropdownIssueTypeSubtask'
    },
    'Sub-task': {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        messageKey: 'syncedLocationDropdownIssueTypeSubtask'
    }
}; /**
    * Creates an icon component from a custom Jira issue-type `iconUrl` that conforms to the
    * ADS icon component contract expected by `IconTile`. This lets us reuse `IconTile` for
    * custom issue types — ensuring consistent sizing, background, and border-radius with the
    * standard ADS icons used for known issue types (Bug, Story, etc.).
    *
    * The returned component ignores ADS icon props (color, spacing, etc.) because the image
    * is an external raster/SVG asset that doesn't respond to design tokens.
    */ 
const $c9326a9d581538d9$var$customIconCache = new Map();
const $c9326a9d581538d9$var$createCustomIssueTypeIcon = (iconUrl)=>{
    const cached = $c9326a9d581538d9$var$customIconCache.get(iconUrl);
    if (cached) return cached;
    const CustomIssueTypeIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: iconUrl,
            alt: "",
            width: "12",
            height: "12"
        });
    CustomIssueTypeIcon.displayName = 'CustomIssueTypeIcon';
    $c9326a9d581538d9$var$customIconCache.set(iconUrl, CustomIssueTypeIcon);
    return CustomIssueTypeIcon;
}; /**
    * Returns the icon to render for a Jira issue type, or `null` when neither an ADS icon
    * mapping nor an AGG-provided `iconUrl` is available so the caller can fall back to a
    * generic product icon.
    *
    * Implemented as a plain function (not a React component) so the `null` check actually
    * narrows — a JSX expression always evaluates to a truthy `ReactElement` object,
    * meaning callers cannot distinguish a "would render nothing" component from one that
    * renders an icon.
    */ 
const $c9326a9d581538d9$var$renderJiraIssueTypeIcon = (issueType, intl)=>{
    const mapped = $c9326a9d581538d9$var$jiraIssueTypeIconMap[issueType.name];
    if (mapped) {
        const label = intl.formatMessage((0, $aI2Eh.syncBlockMessages)[mapped.messageKey]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Fmt9.IconTile), {
            icon: mapped.icon,
            label: label,
            appearance: 'gray',
            size: "xsmall"
        });
    } // Custom Jira issue types — render inside `IconTile` using a wrapper component so the
    // icon gets the same tile background, border-radius, and sizing as known issue types.
    if (issueType.iconUrl) {
        const CustomIcon = $c9326a9d581538d9$var$createCustomIssueTypeIcon(issueType.iconUrl);
        const label = intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownIssueTypeGeneric);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Fmt9.IconTile), {
            icon: CustomIcon,
            label: label,
            appearance: 'gray',
            size: "xsmall"
        });
    }
    return null;
};
const $c9326a9d581538d9$var$ItemIcon = ({ reference: reference, intl: intl })=>{
    const { hasAccess: hasAccess, subType: subType, productType: productType, sourceAri: sourceAri, issueType: issueType } = reference;
    if (productType === 'confluence-page' && hasAccess) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Fmt9.IconTile), {
        icon: $c9326a9d581538d9$var$getConfluenceSubTypeIcon(sourceAri, subType),
        label: "",
        appearance: 'gray',
        size: "xsmall"
    });
     // Render a Jira issue-type icon when we have one.
    // Falls through to the generic product icon when:
    //   - we don't have access (issueType is not surfaced for no-access references),
    //   - AGG returned no `issueType` (partial index, deleted, etc.), or
    //   - the issue type is unrecognised AND has no `iconUrl`.
    if (productType === 'jira-work-item' && hasAccess && issueType) {
        const icon = $c9326a9d581538d9$var$renderJiraIssueTypeIcon(issueType, intl);
        if (icon !== null) return icon;
    } // Generic product fallback for `jira-work-item` (and any future product).
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ProductIcon, {
        product: productType
    });
};
const $c9326a9d581538d9$export$7233d77a72ff78ae = (referenceData, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const sourceInfoMap = new Map();
    referenceData?.forEach((reference)=>{
        if (!reference) return;
        if (sourceInfoMap.has(reference.sourceAri)) sourceInfoMap.get(reference.sourceAri)?.push(reference);
        else sourceInfoMap.set(reference.sourceAri, [
            reference
        ]);
    });
    for (const references of sourceInfoMap.values())if (references.length > 1) references.forEach((reference, index)=>reference.title = `${reference.title === '' && reference.hasAccess ? formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title}: ${formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleBlockIndex, {
            index: index + 1
        })}`);
    const sortedReferences = Array.from(sourceInfoMap.values()).flat().sort((a, b)=>{
        if (a.isSource !== b.isSource) return b.isSource ? 1 : -1;
        if (a.hasAccess !== b.hasAccess) return a.hasAccess ? -1 : 1;
        return (a.title || '').localeCompare(b.title || '');
    });
    return sortedReferences;
};
const $c9326a9d581538d9$export$1bd57d4057e7f613 = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$EditorPositionedSyncedLocationDropdown, {
        syncBlockStore: syncBlockStore,
        resourceId: resourceId,
        intl: intl,
        isSource: isSource,
        localId: localId,
        api: api,
        floatingToolbarRenderContext: floatingToolbarRenderContext
    });
};
const $c9326a9d581538d9$var$EditorPositionedSyncedLocationDropdown = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    const triggerTitle = intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitle);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const content = isOpen ? /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$DropdownContent, {
        syncBlockStore: syncBlockStore,
        resourceId: resourceId,
        intl: intl,
        isSource: isSource,
        localId: localId,
        api: api
    }) : null;
    const toggleOpen = (0, $cozmU.useCallback)(()=>{
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const closeDropdown = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const setDisableParentScroll = floatingToolbarRenderContext?.setDisableParentScroll;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) return;
        setDisableParentScroll?.(true);
        return ()=>{
            setDisableParentScroll?.(false);
        };
    }, [
        isOpen,
        setDisableParentScroll
    ]);
    const trigger = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
            areAnyNewToolbarFlagsEnabled: true,
            testId: (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSyncedLocationsTrigger,
            selected: isOpen,
            iconAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            }),
            onClick: toggleOpen,
            ariaHasPopup: true,
            children: triggerTitle
        }), [
        isOpen,
        toggleOpen,
        triggerTitle
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
        testId: $c9326a9d581538d9$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID,
        isOpen: isOpen,
        trigger: trigger,
        handleClickOutside: closeDropdown,
        handleEscapeKeydown: closeDropdown,
        mountTo: floatingToolbarRenderContext?.popupsMountPoint,
        boundariesElement: floatingToolbarRenderContext?.popupsBoundariesElement,
        scrollableElement: floatingToolbarRenderContext?.popupsScrollableElement,
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU
        },
        children: content
    });
};
const $c9326a9d581538d9$export$127208b0973f9135 = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { fetchStatus: fetchStatus, referenceData: referenceData } = $c9326a9d581538d9$var$useReferenceData({
        intl: intl,
        isSource: isSource,
        localId: localId,
        resourceId: resourceId,
        syncBlockStore: syncBlockStore
    });
    const referenceCount = (0, $cozmU.useMemo)(()=>referenceData.filter(({ isSource: isSourceItem })=>!isSourceItem).length, [
        referenceData
    ]);
    const tooltipContent = !isOpen && fetchStatus === 'success' && referenceCount === 0 ? intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownNoReferencesTooltip) : null;
    const content = isOpen ? /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$DropdownContentWithReferenceData, {
        resourceId: resourceId,
        intl: intl,
        api: api,
        fetchStatus: fetchStatus,
        referenceData: referenceData
    }) : null;
    const toggleOpen = (0, $cozmU.useCallback)(()=>{
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const closeDropdown = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const setDisableParentScroll = floatingToolbarRenderContext?.setDisableParentScroll;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) return;
        setDisableParentScroll?.(true);
        return ()=>{
            setDisableParentScroll?.(false);
        };
    }, [
        isOpen,
        setDisableParentScroll
    ]);
    const trigger = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
            areAnyNewToolbarFlagsEnabled: true,
            testId: (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSyncedLocationsTrigger,
            selected: isOpen,
            iconAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            }),
            onClick: toggleOpen,
            ariaHasPopup: true,
            tooltipContent: tooltipContent ?? undefined,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$SyncedLocationTriggerContent, {
                intl: intl,
                fetchStatus: fetchStatus,
                referenceCount: referenceCount
            })
        }), [
        fetchStatus,
        intl,
        isOpen,
        referenceCount,
        toggleOpen,
        tooltipContent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
        alignDropdownWithParentElement: true,
        alignX: "left",
        testId: $c9326a9d581538d9$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID,
        isOpen: isOpen,
        trigger: trigger,
        handleClickOutside: closeDropdown,
        handleEscapeKeydown: closeDropdown,
        mountTo: floatingToolbarRenderContext?.popupsMountPoint,
        boundariesElement: floatingToolbarRenderContext?.popupsBoundariesElement,
        scrollableElement: floatingToolbarRenderContext?.popupsScrollableElement,
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU
        },
        children: content
    });
};
const $c9326a9d581538d9$var$DropdownContent = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api })=>{
    const [fetchStatus, setFetchStatus] = (0, $cozmU.useState)('none');
    const [referenceData, setReferenceData] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        setFetchStatus('loading');
        const getReferenceData = async ()=>{
            const response = await syncBlockStore.fetchReferencesSourceInfo(resourceId, localId, isSource);
            if (response.error) {
                setFetchStatus('error');
                return;
            }
            setReferenceData($c9326a9d581538d9$export$7233d77a72ff78ae(response.references, intl));
            setFetchStatus('success');
        };
        getReferenceData();
    }, [
        syncBlockStore,
        intl,
        isSource,
        localId,
        resourceId
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$DropdownContentWithReferenceData, {
        resourceId: resourceId,
        intl: intl,
        api: api,
        fetchStatus: fetchStatus,
        referenceData: referenceData
    });
};
const $c9326a9d581538d9$var$useReferenceData = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId })=>{
    const [isNewSourceBlock] = (0, $cozmU.useState)(()=>isSource && syncBlockStore.sourceManager.isNewSourceBlock(resourceId));
    const [state, setState] = (0, $cozmU.useState)(()=>({
            fetchStatus: isNewSourceBlock ? 'success' : 'loading',
            referenceData: []
        }));
    (0, $cozmU.useEffect)(()=>{
        let isCurrentRequest = true;
        setState({
            fetchStatus: isNewSourceBlock ? 'success' : 'loading',
            referenceData: []
        });
        const getReferenceData = async ()=>{
            const response = await syncBlockStore.fetchReferencesSourceInfo(resourceId, localId, isSource);
            if (!isCurrentRequest) return;
            if (isNewSourceBlock) syncBlockStore.sourceManager.clearNewSourceBlock(resourceId);
            if (response.error) {
                setState({
                    fetchStatus: 'error',
                    referenceData: []
                });
                return;
            }
            setState({
                fetchStatus: 'success',
                referenceData: $c9326a9d581538d9$export$7233d77a72ff78ae(response.references, intl)
            });
        };
        getReferenceData();
        return ()=>{
            isCurrentRequest = false;
        };
    }, [
        syncBlockStore,
        resourceId,
        intl,
        isSource,
        localId,
        isNewSourceBlock
    ]);
    return {
        fetchStatus: state.fetchStatus,
        referenceData: state.referenceData
    };
};
const $c9326a9d581538d9$var$SyncedLocationTriggerContent = ({ intl: intl, fetchStatus: fetchStatus, referenceCount: referenceCount })=>{
    const { formatMessage: formatMessage } = intl;
    const triggerTitle = formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitle);
    const syncedLocationCount = referenceCount === 0 ? 0 : referenceCount + 1;
    switch(fetchStatus){
        case 'loading':
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    triggerTitle,
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: "small",
                        label: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLoading)
                    })
                ]
            });
        case 'success':
            {
                const count = syncedLocationCount > 99 ? '99+' : intl.formatNumber(syncedLocationCount);
                return formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleWithCount, {
                    count: count
                });
            }
        case 'none':
        case 'error':
            return triggerTitle;
    }
};
const $c9326a9d581538d9$var$DropdownContentWithReferenceData = ({ resourceId: resourceId, intl: intl, api: api, fetchStatus: fetchStatus, referenceData: referenceData })=>{
    const { formatMessage: formatMessage } = intl;
    const handleLocationClick = ()=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CLICK_SYNCED_LOCATION,
            attributes: {
                resourceId: resourceId
            }
        });
    };
    const content = ()=>{
        switch(fetchStatus){
            case 'loading':
                return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$LoadingScreen, {
                    formatMessage: formatMessage
                });
            case 'error':
                return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ErrorScreen, {
                    formatMessage: formatMessage
                });
            case 'success':
                if (referenceData.length > 0) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    "data-testid": "synced-locations-dropdown-content",
                    className: (0, $hekY6.default)([
                        $c9326a9d581538d9$var$styles.contentContainer,
                        "_1nhtpce513 _2VmLUgKGUX"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                        title: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownHeading, {
                            count: `${referenceData.length > 99 ? '99+' : referenceData.length}`
                        }),
                        children: referenceData.map((reference)=>{
                            const title = reference.title === '' && reference.hasAccess ? formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title || reference.url || '';
                            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    "_0aDwTLgVvo"
                                ]),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                                    content: title,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ItemIcon, {
                                            reference: reference,
                                            intl: intl
                                        }),
                                        href: reference.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLocationClick(),
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ItemTitle, {
                                            title: title,
                                            formatMessage: formatMessage,
                                            onSameDocument: reference.onSameDocument,
                                            isSource: reference.isSource,
                                            hasAccess: reference.hasAccess,
                                            productType: reference.productType
                                        })
                                    }, reference.title)
                                })
                            }, reference.title);
                        })
                    })
                });
                else return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$NoResultScreen, {
                    formatMessage: formatMessage
                });
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($c9326a9d581538d9$var$styles.dropdownContent, (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true) && fetchStatus === 'success' && referenceData.length === 0 && $c9326a9d581538d9$var$styles.activationDropdownContent, $c9326a9d581538d9$var$shouldApplyMinHeight(fetchStatus, referenceData.length) && $c9326a9d581538d9$var$styles.containerWithMinHeight),
        children: content()
    });
};
const $c9326a9d581538d9$var$LoadingScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            label: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLoading)
        })
    });
};
const $c9326a9d581538d9$var$ErrorScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $c9326a9d581538d9$var$styles.errorContainer,
        testId: "synced-locations-dropdown-content-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $c9326a9d581538d9$var$styles.errorIcon,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                size: "medium",
                children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownError)
            })
        ]
    });
};
const $c9326a9d581538d9$var$NoResultScreen = ({ formatMessage: formatMessage })=>{
    return (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c9326a9d581538d9$var$styles.activationNoResultsContainer,
        testId: "synced-locations-dropdown-content-no-results",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            alignInline: "center",
            xcss: $c9326a9d581538d9$var$styles.activationNoResultsContent,
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lExDX.SyncedLocationsEmptyStateIllustration), {}),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownActivationNoResults)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                        href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        xcss: $c9326a9d581538d9$var$styles.learnMoreLink,
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLearnMoreLink)
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: $c9326a9d581538d9$var$styles.noResultsContainer,
        space: "space.100",
        testId: "synced-locations-dropdown-content-no-results",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownNoResults)
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                    href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    xcss: $c9326a9d581538d9$var$styles.learnMoreLink,
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLearnMoreLink)
                })
            })
        ]
    });
};
module.exports["SyncedLocationDropdown"] = $c9326a9d581538d9$export$1bd57d4057e7f613;
module.exports["SyncedLocationDropdownWithCount"] = $c9326a9d581538d9$export$127208b0973f9135;

});

parcelRegister("lExDX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Figma specifies this fixed illustration color, which has no semantic token equivalent across themes.
const $41b8b984dc98014f$var$arrowFill = '#8C8F97';
const $41b8b984dc98014f$export$bc90f0a575a3d90f = ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const placeholderFill = colorMode === 'dark' ? "var(--ds-surface-overlay-pressed, #DDDEE1)" : "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "274",
        height: "92",
        viewBox: "0 0 274 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        "data-testid": "synced-locations-empty-state-illustration",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "0.41416",
                y: "0.41416",
                width: "115.965",
                height: "90.2868",
                rx: "2.89912",
                stroke: "var(--ds-border, #0B120E24)",
                strokeWidth: "0.82832"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "10.7681",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "43.3486",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "75.9292",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M10.8154 26.5352H77.1144V29.1609H10.8154V26.5352Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.45483 69.5781H110.166V72.0631H7.45483V69.5781Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.45483 75.3789H110.166V77.8639H7.45483V75.3789Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.45483 81.1719H82.0036V83.6568H7.45483V81.1719Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "10.8154",
                y: "31.7891",
                width: "17.7235",
                height: "2.6257",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "6.95492",
                y: "22.6954",
                width: "102.884",
                height: "40.7596",
                rx: "0.984638",
                stroke: "var(--ds-border-focused, #4688EC)",
                strokeWidth: "0.656425"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "81.5023",
                y: "20.707",
                width: "22.5506",
                height: "4.96992",
                rx: "0.82832",
                fill: "var(--ds-surface-overlay, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M85.2556 22.4161C85.2556 22.3732 85.2208 22.3384 85.1779 22.3384H83.6248C83.5819 22.3384 83.5472 22.3732 83.5472 22.4161V23.9692C83.5472 24.0121 83.5819 24.0468 83.6248 24.0468H84.0908V24.2798H83.6248C83.4533 24.2798 83.3142 24.1407 83.3142 23.9692V22.4161C83.3142 22.2445 83.4533 22.1055 83.6248 22.1055H85.1779C85.3495 22.1055 85.4885 22.2445 85.4885 22.4161V22.7267H85.2556V22.4161Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M85.4732 23.3029C85.7006 23.5303 85.7006 23.8991 85.4732 24.1266L85.4692 24.1305L85.5375 24.1533C85.5887 24.1704 85.6215 24.2205 85.6166 24.2743C85.6118 24.3281 85.5706 24.3715 85.5171 24.3791L85.1328 24.434C85.0965 24.4392 85.0598 24.427 85.0339 24.4011C85.008 24.3752 84.9958 24.3385 85.001 24.3022L85.0559 23.9179L85.0603 23.8985C85.0745 23.8547 85.1136 23.8226 85.1607 23.8184C85.2145 23.8135 85.2647 23.8463 85.2818 23.8976L85.3045 23.9658L85.3084 23.9619C85.4449 23.8254 85.4449 23.604 85.3084 23.4676L85.1986 23.3578L85.3633 23.1931L85.4732 23.3029ZM84.8801 22.9954C84.9164 22.9902 84.9531 23.0024 84.979 23.0283C85.0049 23.0543 85.0171 23.0909 85.0119 23.1272L84.957 23.5116C84.9494 23.565 84.906 23.6062 84.8522 23.6111C84.7984 23.6159 84.7483 23.5831 84.7312 23.5319L84.7084 23.4636L84.7045 23.4676C84.568 23.604 84.568 23.8254 84.7045 23.9619L84.8143 24.0717L84.6496 24.2364L84.5398 24.1266C84.3123 23.8991 84.3123 23.5303 84.5398 23.3029L84.5437 23.2989L84.4755 23.2762C84.4242 23.2591 84.3914 23.2089 84.3963 23.1551C84.4012 23.1013 84.4423 23.058 84.4958 23.0503L84.8801 22.9954Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "86.4723",
                y: "22.1289",
                width: "15.9241",
                height: "2.12321",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "7.53369",
                y: "5.53516",
                width: "47.2626",
                height: "3.93855",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "24.8138",
                y: "14.1758",
                width: "14.4003",
                height: "1.92004",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "10.8929",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "14.7333",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "18.5736",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#synced-locations-arrow-clip)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M153.151 39.5728C153.137 39.1517 151.895 38.7634 151.646 39.1155C151.294 39.6114 151.022 40.1671 150.803 40.9126C150.623 41.7746 150.828 42.0572 150.641 42.6134C150.509 43.089 150.24 43.7061 149.966 44.1967C149.692 44.691 149.411 45.0135 149.31 45.0811C149.281 45.1129 149.261 45.1394 149.246 45.1633C149.238 45.1894 149.22 45.2245 149.202 45.2719C149.184 45.291 149.164 45.3581 149.148 45.3734C149.109 45.4351 149.127 45.4725 148.993 45.5143C148.863 45.5572 148.58 45.5552 148.251 45.4788C147.924 45.4073 147.563 45.2853 147.215 45.1309C146.212 44.7559 145.565 44.449 145.235 44.3075C144.446 43.9591 143.8 43.8021 143.114 43.7547C142.737 43.7292 142.255 44.7498 142.515 45.0242C142.993 45.5205 143.531 45.9211 144.335 46.2984C144.655 46.4366 145.166 47.0275 146.147 47.4648C146.309 47.5326 146.478 47.578 146.665 47.5883C147.458 47.6306 148.351 47.8436 149.302 47.7055C149.781 47.6314 150.2 47.4182 150.458 47.2428C150.575 47.1475 150.67 47.0703 150.733 47.02C150.798 46.9661 150.823 46.9369 150.823 46.9369C150.823 46.9369 150.865 46.8886 150.938 46.8048C151.02 46.7195 151.104 46.5984 151.209 46.4471C151.407 46.1448 151.612 45.7354 151.767 45.3155C152.088 44.4704 152.337 43.5357 152.495 42.983C152.722 42.1549 152.83 41.7576 152.899 41.5105C153.099 40.7718 153.164 40.1758 153.145 39.5792L153.151 39.5728Z",
                        fill: $41b8b984dc98014f$var$arrowFill
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M122.093 51.2051C122.362 52.3321 123.634 52.0495 123.655 51.0274C123.691 49.5646 123.763 48.06 124.288 46.2549C124.363 46.0014 124.43 45.7703 124.493 45.5579C124.524 45.4498 124.546 45.347 124.571 45.249C124.599 45.152 124.638 45.0621 124.668 44.9738C124.789 44.6166 124.892 44.319 124.99 44.0401C125.239 43.5099 125.419 43.0202 125.904 42.4543C126 42.3327 126.1 42.2 126.203 42.0684C126.323 41.9497 126.445 41.8236 126.572 41.6948C126.698 41.5697 126.829 41.4383 126.961 41.3069C127.092 41.1754 127.253 41.0688 127.399 40.9454C127.7 40.7058 127.999 40.4576 128.34 40.262C128.668 40.0545 128.989 39.8412 129.331 39.6824C129.99 39.3251 130.654 39.0906 131.194 38.8926C131.752 38.7406 132.176 38.5935 132.43 38.5547C132.577 38.5248 132.721 38.4863 132.865 38.4392C132.991 38.3953 133.171 38.3346 133.395 38.2588C133.627 38.2011 133.906 38.1331 134.224 38.0563C134.539 37.9624 134.906 37.9244 135.302 37.8582C135.697 37.7798 136.127 37.7641 136.581 37.7314C136.697 37.7247 136.808 37.7169 136.928 37.7076C137.045 37.7095 137.162 37.7113 137.283 37.7143C137.52 37.7191 137.765 37.7261 138.011 37.7294C138.259 37.7375 138.502 37.7802 138.755 37.8017C139.004 37.8343 139.264 37.8457 139.513 37.9066C139.765 37.9601 140.017 38.0098 140.269 38.0633C140.522 38.1093 140.764 38.2086 141.01 38.2807C141.509 38.4148 141.971 38.635 142.431 38.8345C142.76 38.9675 143.038 39.1502 143.325 39.2909C143.613 39.4278 143.855 39.6082 144.092 39.7667C144.58 40.0635 144.95 40.4149 145.293 40.6974C145.943 41.3089 146.377 41.8043 146.636 42.1759C147.917 43.8828 148.559 45.4067 149.143 46.9622C149.466 47.8095 150.591 47.6859 150.514 46.676C150.477 46.2238 150.46 45.7574 150.339 45.3009C150.285 45.0706 150.233 44.8328 150.18 44.5987C150.128 44.361 150.066 44.1162 149.966 43.8802C149.623 42.9218 149.158 41.8867 148.375 40.8682C148.217 40.6762 148.066 40.3892 147.825 40.0957C147.579 39.8011 147.315 39.4322 146.969 39.0516C146.788 38.8689 146.593 38.6782 146.389 38.4767C146.284 38.3773 146.177 38.2731 146.066 38.1678C145.95 38.0688 145.827 37.9762 145.702 37.8788C145.45 37.6877 145.182 37.4836 144.897 37.2827C144.601 37.1067 144.285 36.9253 143.958 36.7444C143.748 36.6181 143.52 36.5269 143.293 36.4443C143.066 36.3616 142.834 36.2853 142.604 36.2139C140.599 35.6384 138.269 35.4412 136.47 35.5293C135.569 35.5525 134.8 35.6753 134.253 35.7335C133.709 35.8333 133.392 35.8941 133.392 35.8941C133.392 35.8941 133.271 35.9194 133.06 35.9628C132.844 35.9965 132.543 36.0985 132.168 36.2032C131.982 36.258 131.774 36.3185 131.558 36.3805C131.344 36.4596 131.113 36.5455 130.875 36.6378C130.637 36.7338 130.378 36.8158 130.128 36.9368C129.874 37.0568 129.614 37.183 129.351 37.3082C129.081 37.4275 128.822 37.5821 128.557 37.7393C128.296 37.8976 128.022 38.044 127.766 38.2157C127.265 38.5831 126.738 38.9183 126.3 39.3363C126.075 39.5375 125.843 39.7205 125.642 39.9246C125.443 40.1334 125.254 40.337 125.068 40.5294C124.882 40.7218 124.709 40.9101 124.57 41.1081C124.425 41.3003 124.287 41.4824 124.157 41.6469C123.956 41.8915 123.806 42.1428 123.667 42.3814C123.525 42.619 123.391 42.8389 123.266 43.0451C123.041 43.4688 122.884 43.8519 122.73 44.171C122.568 44.4878 122.501 44.784 122.41 45.0283C122.33 45.2721 122.261 45.4787 122.201 45.6554C121.577 47.8403 121.729 49.6415 122.093 51.2051Z",
                        fill: $41b8b984dc98014f$var$arrowFill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "157.621",
                y: "0.41416",
                width: "115.965",
                height: "90.2868",
                rx: "2.89912",
                stroke: "var(--ds-border, #0B120E24)",
                strokeWidth: "0.82832"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "167.975",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "200.556",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "233.136",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M168.022 39.7891H234.321V42.4148H168.022V39.7891Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M164.661 19.8789H267.373V22.3639H164.661V19.8789Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M164.661 25.6719H267.373V28.1568H164.661V25.6719Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "168.022",
                y: "45.0391",
                width: "17.7235",
                height: "2.6257",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "164.161",
                y: "35.9454",
                width: "102.884",
                height: "40.7596",
                rx: "0.984638",
                stroke: "var(--ds-border-focused, #4688EC)",
                strokeWidth: "0.656425"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "238.709",
                y: "33.9648",
                width: "22.5506",
                height: "4.96992",
                rx: "0.82832",
                fill: "var(--ds-surface-overlay, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M242.463 35.6739C242.463 35.631 242.428 35.5962 242.385 35.5962H240.832C240.789 35.5962 240.754 35.631 240.754 35.6739V37.227C240.754 37.2699 240.789 37.3047 240.832 37.3047H241.298V37.5376H240.832C240.66 37.5376 240.521 37.3986 240.521 37.227V35.6739C240.521 35.5024 240.66 35.3633 240.832 35.3633H242.385C242.557 35.3633 242.696 35.5024 242.696 35.6739V35.9845H242.463V35.6739Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M242.68 36.5607C242.908 36.7881 242.908 37.1569 242.68 37.3844L242.676 37.3883L242.745 37.4111C242.796 37.4282 242.829 37.4783 242.824 37.5321C242.819 37.5859 242.778 37.6293 242.724 37.6369L242.34 37.6918C242.304 37.697 242.267 37.6848 242.241 37.6589C242.215 37.633 242.203 37.5963 242.208 37.56L242.263 37.1757L242.267 37.1563C242.282 37.1125 242.321 37.0805 242.368 37.0762C242.422 37.0714 242.472 37.1041 242.489 37.1554L242.512 37.2236L242.516 37.2197C242.652 37.0832 242.652 36.8619 242.516 36.7254L242.406 36.6156L242.571 36.4509L242.68 36.5607ZM242.087 36.2532C242.124 36.2481 242.16 36.2602 242.186 36.2862C242.212 36.3121 242.224 36.3487 242.219 36.385L242.164 36.7694C242.157 36.8228 242.113 36.864 242.059 36.8689C242.006 36.8737 241.955 36.8409 241.938 36.7897L241.916 36.7214L241.912 36.7254C241.775 36.8619 241.775 37.0832 241.912 37.2197L242.021 37.3295L241.857 37.4942L241.747 37.3844C241.519 37.1569 241.519 36.7881 241.747 36.5607L241.751 36.5567L241.683 36.534C241.631 36.5169 241.599 36.4668 241.603 36.4129C241.608 36.3592 241.649 36.3158 241.703 36.3081L242.087 36.2532Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "243.679",
                y: "35.3867",
                width: "15.9241",
                height: "2.12321",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "164.74",
                y: "11.332",
                width: "47.2626",
                height: "3.93855",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "synced-locations-arrow-clip",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "20.9549",
                        height: "28.3348",
                        transform: "translate(120.479 51.5039) rotate(-73.6651)"
                    })
                })
            })
        ]
    });
};
module.exports["SyncedLocationsEmptyStateIllustration"] = $41b8b984dc98014f$export$bc90f0a575a3d90f;

});

parcelRegister("hpTl5", function(module, exports) {
/* quick-insert.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $krYZG = parcelRequire("krYZG");


var $5HBT9 = parcelRequire("5HBT9");


var $jGK9e = parcelRequire("jGK9e");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $hzCKL = parcelRequire("hzCKL");


var $kXmSu = parcelRequire("kXmSu");

const $0cbbe85ea6426dbe$var$lozengeWrapperStyles = null;
const $0cbbe85ea6426dbe$export$69e699948916d30c = (config, api, syncBlockStore)=>{
    return ({ formatMessage: formatMessage })=>{
        if (!config?.enableSourceCreation) return [];
        const syncBlockTitle = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? (0, $5HBT9.messages).syncedBlockQuickInsertTitle : (0, $5HBT9.messages).syncBlock;
        return [
            {
                id: 'syncBlock',
                title: formatMessage(syncBlockTitle),
                description: formatMessage((0, $5HBT9.messages).syncedBlockDescription),
                priority: 400,
                keywords: [
                    'synced',
                    'block',
                    'synced-block',
                    'sync',
                    'sync-block',
                    'auto',
                    'update',
                    'excerpt',
                    'connect',
                    'create'
                ],
                isDisabledOffline: true,
                keyshortcut: '',
                lozenge: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_3YEZNOdnbC _2O5VijdnbC _3iDTPbccYA"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                        appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
                        children: formatMessage((0, $5HBT9.messages).newLozenge)
                    })
                }),
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconSyncBlock), {
                        label: formatMessage(syncBlockTitle)
                    }),
                action: (insert, state)=>{
                    return (0, $hzCKL.createSyncedBlock)({
                        tr: state.tr,
                        syncBlockStore: syncBlockStore,
                        typeAheadInsert: insert,
                        fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                    });
                },
                testId: (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).quickInsertCreate
            }
        ];
    };
};
module.exports["getQuickInsertConfig"] = $0cbbe85ea6426dbe$export$69e699948916d30c;

});

parcelRegister("6P5kj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $WnqKg = parcelRequire("WnqKg");


var $95bQO = parcelRequire("95bQO");

const $b9206e5f8eb43fd0$var$getSourceSyncBlockPlaceholderStyles = (placeholderText)=>/*#__PURE__*/ (0, $lOiVq.css)({
        // Emptiness is signalled by the node view via the `empty` class, which is derived from the
        // ProseMirror document. Keeping this visual state in CSS means typing, deletion, undo/redo,
        // and remote changes update it without decorations.
        //
        // This deliberately does NOT inspect the rendered DOM shape. The paragraph inside an empty
        // block routinely gains extra children that are not user content — the selection marker's
        // cursor widget (`.ProseMirror-widget`), ProseMirror's `.ProseMirror-separator` hack node,
        // and the `.ProseMirror-trailingBreak`. An earlier `:has(.ProseMirror-trailingBreak:only-child)`
        // form treated those decorations as content and hid the placeholder whenever the user placed
        // a cursor in the block and then blurred the editor. See EDITOR-8327.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.ProseMirror .${(0, $95bQO.BodiedSyncBlockSharedCssClassName).prefix}.${(0, $95bQO.BodiedSyncBlockSharedCssClassName).empty} .${(0, $95bQO.BodiedSyncBlockSharedCssClassName).content}[contenteditable="true"] > p:only-child`]: {
            position: 'relative',
            '&::before': {
                // JSON.stringify produces a quoted and escaped CSS string.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: placeholderText,
                position: 'absolute',
                boxSizing: 'border-box',
                color: "var(--ds-text-subtlest, #6B6E76)",
                font: 'inherit',
                insetInlineStart: 0,
                width: '100%',
                overflow: 'hidden',
                pointerEvents: 'none',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                whiteSpace: 'nowrap'
            }
        }
    });
const $b9206e5f8eb43fd0$export$286cc38c7d222ebf = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const placeholderStyles = (0, $cozmU.useMemo)(()=>$b9206e5f8eb43fd0$var$getSourceSyncBlockPlaceholderStyles(JSON.stringify(formatMessage((0, $WnqKg.placeholderTextMessages).sourceSyncBlockPlaceholderText))), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: placeholderStyles
    });
};
module.exports["SourceSyncBlockPlaceholder"] = $b9206e5f8eb43fd0$export$286cc38c7d222ebf;

});

parcelRegister("jEkKX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $6Ixg8 = parcelRequire("6Ixg8");

const $bb91247d9c925f3a$export$f8d6f80345184030 = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const isOnline = !(0, $6Ixg8.isOfflineMode)(mode);
    (0, $cozmU.useEffect)(()=>{
        const useRealTimeSubscriptions = isOnline;
        syncBlockStoreManager.referenceManager.setRealTimeSubscriptionsEnabled(useRealTimeSubscriptions);
    }, [
        syncBlockStoreManager,
        isOnline
    ]);
    return null;
};
module.exports["SyncBlockRefresher"] = $bb91247d9c925f3a$export$f8d6f80345184030;

});

parcelRegister("7dsNj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $5AKbu = parcelRequire("5AKbu");


var $icCpa = parcelRequire("icCpa");

const $8a20a116451ec71e$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP = {
    type: (0, $3nacY.SYNCED_BLOCK_GROUP).type,
    key: (0, $3nacY.SYNCED_BLOCK_GROUP).key,
    component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
            above: "md",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                children: children
            })
        }),
    parents: [
        {
            type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
            key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
            rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.SYNCED_BLOCK_GROUP).key]
        }
    ]
};
const $8a20a116451ec71e$export$a758406ca53b86a5 = (api, enableSourceSyncedBlockCreation)=>{
    if (!enableSourceSyncedBlockCreation) return [];
    return [
        $8a20a116451ec71e$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP,
        {
            type: (0, $3nacY.SYNCED_BLOCK_BUTTON).type,
            key: (0, $3nacY.SYNCED_BLOCK_BUTTON).key,
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $icCpa.CreateSyncedBlockButton), {
                    api: api
                }),
            parents: [
                {
                    type: (0, $3nacY.SYNCED_BLOCK_GROUP).type,
                    key: (0, $3nacY.SYNCED_BLOCK_GROUP).key,
                    rank: (0, $hVLmg.SYNCED_BLOCK_SECTION_RANK)[(0, $3nacY.SYNCED_BLOCK_BUTTON).key]
                }
            ]
        }
    ];
};
module.exports["getToolbarComponents"] = $8a20a116451ec71e$export$a758406ca53b86a5;

});

parcelRegister("icCpa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $aI2Eh = parcelRequire("aI2Eh");


var $6Ixg8 = parcelRequire("6Ixg8");


var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");


var $3rarE = parcelRequire("3rarE");


var $73IhX = parcelRequire("73IhX");


var $kXmSu = parcelRequire("kXmSu");

const $378948e6d1a6f43a$export$954568e298a26ab0 = ({ api: api })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { selection: selection, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            mode: states.connectivityState?.mode
        }));
    // for toolbar button, we allow both creating a new synced block
    // and converting existing block to synced block
    const canBeConverted = Boolean(selection && (0, $73IhX.canBeConvertedToSyncBlock)(selection));
    const canInsertEmptyBlock = Boolean(selection?.empty);
    const isDisabled = Boolean((0, $6Ixg8.isOfflineMode)(mode) || !canBeConverted && !canInsertEmptyBlock);
    const onClick = (0, $cozmU.useCallback)(()=>{
        // Insert the synced block and stop preserving the selection in a single
        // transaction so the caret that insertSyncedBlock places inside the new
        // block survives (EDITOR-7949). The toolbar is not normally opened via the
        // block menu, but stopping preservation is defensive and keeps behaviour
        // consistent with the block-menu create item should preservation ever be
        // active (e.g. a block is selected via block-controls). Then re-focus so
        // the caret is active, but only when the transaction was actually
        // dispatched — otherwise a failed insertion would still steal DOM focus
        // into the editor (mirrors CreateSyncedBlockDropdownItem).
        const dispatched = api?.core?.actions.execute(({ tr: tr })=>{
            const result = api?.syncedBlock.commands.insertSyncedBlock((0, $krYZG.INPUT_METHOD).SYNCED_BLOCK_TB)({
                tr: tr
            });
            if (!result) return null;
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        if (dispatched) api?.core?.actions.focus();
    }, [
        api
    ]);
    const message = intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncBlockLabel);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            label: message,
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
                size: "small",
                label: ""
            }),
            isDisabled: isDisabled,
            testId: (0, $kXmSu.SYNCED_BLOCK_BUTTON_TEST_ID).primaryToolbarCreate,
            onClick: onClick
        })
    });
};
module.exports["CreateSyncedBlockButton"] = $378948e6d1a6f43a$export$954568e298a26ab0;

});

parcelRegister("5yzjy", function(module, exports) {
function $e9490881831f892b$export$79c7ce3012e5b8c8(props, nextProps) {
    const properties = [
        'appearance',
        'persistScrollGutter',
        'allowUndoRedoButtons',
        'placeholder',
        'sanitizePrivateContent'
    ];
    return properties.reduce((acc, curr)=>acc || props[curr] !== nextProps[curr], false);
}
module.exports["shouldRecreatePreset"] = $e9490881831f892b$export$79c7ce3012e5b8c8;

});

parcelRegister("4fqm1", function(module, exports) {
const $317d0183692131b1$var$peq = new Uint32Array(0x10000);
const $317d0183692131b1$var$myers_32 = (a, b)=>{
    const n = a.length;
    const m = b.length;
    const lst = 1 << n - 1;
    let pv = -1;
    let mv = 0;
    let sc = n;
    let i = n;
    while(i--)$317d0183692131b1$var$peq[a.charCodeAt(i)] |= 1 << i;
    for(i = 0; i < m; i++){
        let eq = $317d0183692131b1$var$peq[b.charCodeAt(i)];
        const xv = eq | mv;
        eq |= (eq & pv) + pv ^ pv;
        mv |= ~(eq | pv);
        pv &= eq;
        if (mv & lst) sc++;
        if (pv & lst) sc--;
        mv = mv << 1 | 1;
        pv = pv << 1 | ~(xv | mv);
        mv &= xv;
    }
    i = n;
    while(i--)$317d0183692131b1$var$peq[a.charCodeAt(i)] = 0;
    return sc;
};
const $317d0183692131b1$var$myers_x = (b, a)=>{
    const n = a.length;
    const m = b.length;
    const mhc = [];
    const phc = [];
    const hsize = Math.ceil(n / 32);
    const vsize = Math.ceil(m / 32);
    for(let i = 0; i < hsize; i++){
        phc[i] = -1;
        mhc[i] = 0;
    }
    let j = 0;
    for(; j < vsize - 1; j++){
        let mv = 0;
        let pv = -1;
        const start = j * 32;
        const vlen = Math.min(32, m) + start;
        for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] |= 1 << k;
        for(let i = 0; i < n; i++){
            const eq = $317d0183692131b1$var$peq[a.charCodeAt(i)];
            const pb = phc[i / 32 | 0] >>> i & 1;
            const mb = mhc[i / 32 | 0] >>> i & 1;
            const xv = eq | mv;
            const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
            let ph = mv | ~(xh | pv);
            let mh = pv & xh;
            if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
            if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
            ph = ph << 1 | pb;
            mh = mh << 1 | mb;
            pv = mh | ~(xv | ph);
            mv = ph & xv;
        }
        for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] = 0;
    }
    let mv = 0;
    let pv = -1;
    const start = j * 32;
    const vlen = Math.min(32, m - start) + start;
    for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] |= 1 << k;
    let score = m;
    for(let i = 0; i < n; i++){
        const eq = $317d0183692131b1$var$peq[a.charCodeAt(i)];
        const pb = phc[i / 32 | 0] >>> i & 1;
        const mb = mhc[i / 32 | 0] >>> i & 1;
        const xv = eq | mv;
        const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
        let ph = mv | ~(xh | pv);
        let mh = pv & xh;
        score += ph >>> m - 1 & 1;
        score -= mh >>> m - 1 & 1;
        if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
        if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
        ph = ph << 1 | pb;
        mh = mh << 1 | mb;
        pv = mh | ~(xv | ph);
        mv = ph & xv;
    }
    for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] = 0;
    return score;
};
const $317d0183692131b1$export$9f17032d917177de = (a, b)=>{
    if (a.length < b.length) {
        const tmp = b;
        b = a;
        a = tmp;
    }
    if (b.length === 0) return a.length;
    if (a.length <= 32) return $317d0183692131b1$var$myers_32(a, b);
    return $317d0183692131b1$var$myers_x(a, b);
};
const $317d0183692131b1$export$ff7f7c97cdce86e = (str, arr)=>{
    let min_distance = Infinity;
    let min_index = 0;
    for(let i = 0; i < arr.length; i++){
        const dist = $317d0183692131b1$export$9f17032d917177de(str, arr[i]);
        if (dist < min_distance) {
            min_distance = dist;
            min_index = i;
        }
    }
    return arr[min_index];
};
module.exports["distance"] = $317d0183692131b1$export$9f17032d917177de;
module.exports["closest"] = $317d0183692131b1$export$ff7f7c97cdce86e;

});

parcelRegister("5sRAM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $4teLb = parcelRequire("4teLb");


var $1PvMy = parcelRequire("1PvMy");

const $90b377a2d86d3528$var$useRovodalEntryHook = (0, $kBr4q.createHook)((0, $4teLb.RovodalStore), {
    selector: (state, { key: key, instanceId: instanceId })=>state.byKey[key]?.[instanceId]
});
function $90b377a2d86d3528$export$c1ed3e4dd978bf73(key, instanceId = (0, $1PvMy.DEFAULT_INSTANCE_ID)) {
    const [entry, boundActions] = $90b377a2d86d3528$var$useRovodalEntryHook({
        key: key,
        instanceId: instanceId
    });
    const keyedActions = (0, $cozmU.useMemo)(()=>({
            open: (state)=>boundActions.open(key, instanceId, state),
            close: ()=>boundActions.close(key, instanceId),
            setState: (state)=>boundActions.setState(key, instanceId, state),
            remove: ()=>boundActions.remove(key, instanceId)
        }), [
        boundActions,
        key,
        instanceId
    ]);
    return [
        entry,
        keyedActions
    ];
}
module.exports["useRovodal"] = $90b377a2d86d3528$export$c1ed3e4dd978bf73;

});

parcelRegister("4teLb", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $1PvMy = parcelRequire("1PvMy");

const $0c1c76225215c63b$var$initialState = {
    byKey: {}
};
/** Immutably write a single `instanceId` entry into the nested `byKey` map. */ const $0c1c76225215c63b$var$writeInstance = (byKey, key, instanceId, entry)=>({
        ...byKey,
        [key]: {
            ...byKey[key],
            [instanceId]: entry
        }
    });
const $0c1c76225215c63b$var$upsert = (key, instanceId, isOpen, state)=>({ setState: setState, getState: getState })=>{
        setState({
            byKey: $0c1c76225215c63b$var$writeInstance(getState().byKey, key, instanceId, {
                key: key,
                instanceId: instanceId,
                isOpen: isOpen,
                state: state
            })
        });
    };
/** Flip every open entry to closed (only one is ever open, but this is safe regardless). */ const $0c1c76225215c63b$var$closeAllOpen = (byKey)=>{
    let next = byKey;
    for (const k of Object.keys(byKey)){
        for (const i of Object.keys(byKey[k]))if (byKey[k][i].isOpen) next = $0c1c76225215c63b$var$writeInstance(next, k, i, {
            ...next[k][i],
            isOpen: false
        });
    }
    return next;
};
const $0c1c76225215c63b$var$actions = {
    open: (key, instanceId = (0, $1PvMy.DEFAULT_INSTANCE_ID), state)=>({ setState: setState, getState: getState })=>{
            const byKey = $0c1c76225215c63b$var$closeAllOpen(getState().byKey);
            const existing = byKey[key]?.[instanceId];
            setState({
                byKey: $0c1c76225215c63b$var$writeInstance(byKey, key, instanceId, {
                    key: key,
                    instanceId: instanceId,
                    isOpen: true,
                    state: state !== undefined ? state : existing?.state
                })
            });
        },
    close: (key, instanceId = (0, $1PvMy.DEFAULT_INSTANCE_ID))=>({ setState: setState, getState: getState })=>{
            if (key === undefined) {
                setState({
                    byKey: $0c1c76225215c63b$var$closeAllOpen(getState().byKey)
                });
                return;
            }
            const existing = getState().byKey[key]?.[instanceId];
            if (!existing) return;
            setState({
                byKey: $0c1c76225215c63b$var$writeInstance(getState().byKey, key, instanceId, {
                    ...existing,
                    isOpen: false
                })
            });
        },
    setState: (key, instanceId = (0, $1PvMy.DEFAULT_INSTANCE_ID), state)=>(api)=>{
            const existing = api.getState().byKey[key]?.[instanceId];
            $0c1c76225215c63b$var$upsert(key, instanceId, existing?.isOpen ?? false, state)(api);
        },
    remove: (key, instanceId = (0, $1PvMy.DEFAULT_INSTANCE_ID))=>({ setState: setState, getState: getState })=>{
            const byKey = getState().byKey;
            const bucket = byKey[key];
            if (!bucket || !(instanceId in bucket)) return;
            const { [instanceId]: _removed, ...remainingInstances } = bucket;
            if (Object.keys(remainingInstances).length === 0) {
                const { [key]: _removedBucket, ...restKeys } = byKey;
                setState({
                    byKey: restKeys
                });
                return;
            }
            setState({
                byKey: {
                    ...byKey,
                    [key]: remainingInstances
                }
            });
        }
};
const $0c1c76225215c63b$export$f55959c9c973a422 = (0, $8s9DV.createStore)({
    name: 'rovodal',
    initialState: $0c1c76225215c63b$var$initialState,
    actions: $0c1c76225215c63b$var$actions
});
module.exports["RovodalStore"] = $0c1c76225215c63b$export$f55959c9c973a422;

});

parcelRegister("gKKIc", function(module, exports) {
/** The single set of Rovodal store keys (one per openable entry). Add new keys here. */ const $c990fcdfe0c3d5c2$export$5359035ab3aafb8d = {
    jiraAdminAgentCanvas: 'jira-admin-agent-canvas'
};
module.exports["RovodalStoreKeys"] = $c990fcdfe0c3d5c2$export$5359035ab3aafb8d;

});

parcelRegister("8HjAL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a7190a411ec39d58$var$collectSteps = (plan)=>{
    return plan.steps.concat(plan.plans.flatMap($a7190a411ec39d58$var$collectSteps));
};
const $a7190a411ec39d58$export$6d1f950accb65ffe = (topLevelPlan)=>{
    if (!topLevelPlan) return topLevelPlan;
    const allSteps = $a7190a411ec39d58$var$collectSteps(topLevelPlan);
    const isSingleStep = allSteps.length === 1;
    const isSingleIntent = topLevelPlan.plans.length === 1;
    if (isSingleStep || isSingleIntent) return {
        actionType: 'plan',
        id: topLevelPlan.id,
        payload: {
            ...(topLevelPlan.plans[0] ?? topLevelPlan).payload,
            blastRadius: topLevelPlan.payload.blastRadius,
            summary: topLevelPlan.payload.summary
        },
        plans: [],
        steps: allSteps
    };
    return topLevelPlan;
};


const $ccfed09c41307062$export$b6eb0ea46a58d30c = ({ actions: actions = [] })=>{
    return (0, $cozmU.useMemo)(()=>{
        if (actions.some((action)=>action.data.validated === false)) return {};
        const planNodesById = new Map();
        for (const action of actions)if (action.data.actionType === 'plan') {
            const { parentId: _parentId, ...rest } = action.data;
            const planNode = {
                ...rest,
                plans: [],
                steps: []
            };
            if (planNode.id !== undefined) planNodesById.set(planNode.id, planNode);
        }
        let topLevelPlan;
        for (const action of actions){
            if (action.data.actionType === 'plan') {
                const planNode = action.data.id !== undefined ? planNodesById.get(action.data.id) : undefined;
                if (!planNode) continue;
                if (!action.data.parentId) topLevelPlan = topLevelPlan ?? planNode;
                else planNodesById.get(action.data.parentId)?.plans.push(planNode);
            } else if (action.data.actionType === 'step') {
                if (!action.data.parentId) continue;
                const { parentId: _parentId, ...rest } = action.data;
                const stepNode = {
                    ...rest,
                    invocationId: action.invocationId
                };
                planNodesById.get(action.data.parentId)?.steps.push(stepNode);
            }
        }
        return {
            topLevelPlan: (0, $a7190a411ec39d58$export$6d1f950accb65ffe)(topLevelPlan)
        };
    }, [
        actions
    ]);
};
module.exports["useConvertActionsToPlan"] = $ccfed09c41307062$export$b6eb0ea46a58d30c;

});

parcelRegister("kaPN1", function(module, exports) {
const $dce5bea5f497e6fa$export$9b6bf5a6ece70453 = (steps)=>{
    // IN_PROGRESS
    if (steps.some((step)=>step.inProgress || step.currentStatus === 'preparing' || step.currentStatus === 'started' || step.currentStatus === 'streaming')) return 'IN_PROGRESS';
    // CANCELLED
    // A cleanly dismissed plan: nothing in progress, no errors, and every step was cancelled.
    if (steps.length > 0 && steps.every((step)=>step.error === undefined) && steps.every((step)=>step.storedStatus === 'cancelled' || step.currentStatus === 'cancelled')) return 'CANCELLED';
    // ERROR
    if (steps.some((step)=>step.error !== undefined || step.storedStatus === 'errored' || step.currentStatus === 'errored')) return 'ERROR';
    // COMPLETE
    if (steps.every((step)=>step.storedStatus === 'finished' || step.currentStatus === 'finished')) return 'COMPLETE';
    // IDLE: includes the mixed/partial case: some done, some still pending — this is the fix.
    return 'IDLE';
};
module.exports["getRenderMode"] = $dce5bea5f497e6fa$export$9b6bf5a6ece70453;

});

parcelRegister("doYOO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $57e2e70b485e949c$export$9554f6a1292b8201 = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.empty.summary.non-final",
    defaultMessage: "No spaces, boards, filters or dashboards are impacted."
});
module.exports["emptyBlastRadiusSummaryMessage"] = $57e2e70b485e949c$export$9554f6a1292b8201;

});

parcelRegister("2swKg", function(module, exports) {
/* Entities.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3DMf9 = parcelRequire("3DMf9");


var $iFXu4 = parcelRequire("iFXu4");


var $iRFKG = parcelRequire("iRFKG");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");

const $c6b5c15ebf640e88$var$fieldLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.entities.fieldLabel.non-final",
    defaultMessage: "Field"
});
const $c6b5c15ebf640e88$var$spaceLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.entities.spaceLabel.non-final",
    defaultMessage: "Space"
});
const $c6b5c15ebf640e88$var$workTypeLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.entities.workTypeLabel.non-final",
    defaultMessage: "Work Type"
});
const $c6b5c15ebf640e88$var$styles = {
    fieldWrapper: "_0Of8r28HPE _1wydGW8HPE"
};
const $c6b5c15ebf640e88$export$50f02d20b9547443 = ({ entities: entities })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), null, entities?.fields && entities.fields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $c6b5c15ebf640e88$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($c6b5c15ebf640e88$var$fieldLabel)), entities.fields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            key: field.id,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, field.name)))), entities?.spaces && entities.spaces.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $c6b5c15ebf640e88$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($c6b5c15ebf640e88$var$spaceLabel)), entities.spaces.map((space)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            key: space.id,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, space.name)))), entities?.workTypes && entities.workTypes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $c6b5c15ebf640e88$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($c6b5c15ebf640e88$var$workTypeLabel)), entities.workTypes.map((workType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            key: workType.id,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, workType.name)))));
};
module.exports["Entities"] = $c6b5c15ebf640e88$export$50f02d20b9547443;

});

parcelRegister("3DMf9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::268323681afb5c6318c6a3e2103073e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a6a6fc31d2ce9f8$var$_react = $2a6a6fc31d2ce9f8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2a6a6fc31d2ce9f8$var$_baseNew = $2a6a6fc31d2ce9f8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2a6a6fc31d2ce9f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Field".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field
 * Usage guidance:
 * Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a6a6fc31d2ce9f8$var$FieldIcon = (props)=>/*#__PURE__*/ $2a6a6fc31d2ce9f8$var$_react.default.createElement($2a6a6fc31d2ce9f8$var$_baseNew.default, Object.assign({
        name: "FieldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 3.5H0V2h6zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$2a6a6fc31d2ce9f8$var$FieldIcon.displayName = 'FieldIcon';
var $2a6a6fc31d2ce9f8$var$_default = module.exports.default = $2a6a6fc31d2ce9f8$var$FieldIcon;

});

parcelRegister("19FYy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $3DMf9 = parcelRequire("3DMf9");

/* FieldOptionsCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $6Pqow = parcelRequire("6Pqow");

const $d4521ed9f566ba3e$var$addedTitle = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.createTitle.non-final",
    defaultMessage: "Add options"
});
const $d4521ed9f566ba3e$var$renamedTitle = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.renameTitle.non-final",
    defaultMessage: "Rename options"
});
const $d4521ed9f566ba3e$var$disabledTitle = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.disableTitle.non-final",
    defaultMessage: "Disable options"
});
const $d4521ed9f566ba3e$var$fieldLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldOptionsCard.fieldLabel.non-final",
    defaultMessage: "Field"
});
const $d4521ed9f566ba3e$var$styles = {
    fieldWrapper: "_0Of8r28HPE _1wydGW8HPE",
    optionsWrapper: "_0Of8r28HPE _1wydGW8HPE"
};
const $d4521ed9f566ba3e$var$getChange = (oldName, newName)=>`${oldName} -> ${newName}`;
const $d4521ed9f566ba3e$export$7026c377272c45e5 = ({ fieldIcon: fieldIcon, fieldName: fieldName, optionsAdded: optionsAdded, optionsDisabled: optionsDisabled, optionsRenamed: optionsRenamed })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $d4521ed9f566ba3e$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($d4521ed9f566ba3e$var$fieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, fieldIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, fieldName))), optionsRenamed.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $d4521ed9f566ba3e$var$styles.optionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, formatMessage($d4521ed9f566ba3e$var$renamedTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, optionsRenamed.map((rename, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, $d4521ed9f566ba3e$var$getChange(rename.old, rename.new)))))), optionsDisabled.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $d4521ed9f566ba3e$var$styles.optionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, formatMessage($d4521ed9f566ba3e$var$disabledTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, optionsDisabled.map((name, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, name))))), optionsAdded.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $d4521ed9f566ba3e$var$styles.optionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, formatMessage($d4521ed9f566ba3e$var$addedTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, optionsAdded.map((name, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, name))))));
};


const $ebe939470e7b3ba2$export$70556cf06721e61c = (steps)=>{
    const fieldsById = new Map();
    for (const step of steps){
        if (step.actionSubject !== 'field-options') continue;
        const { operation: operation, changes: changes, fieldId: fieldId, fieldName: fieldName } = step.payload;
        let field = fieldsById.get(fieldId);
        if (!field) {
            field = {
                fieldId: fieldId,
                fieldName: fieldName,
                optionsAdded: [],
                optionsDisabled: [],
                optionsRenamed: []
            };
            fieldsById.set(fieldId, field);
        }
        for (const change of changes){
            if (operation === 'create' && change.new) field.optionsAdded.push(change.new.optionName);
            else if (operation === 'disable' && change.old) field.optionsDisabled.push(change.old.optionName);
            else if (operation === 'update' && change.old && change.new) field.optionsRenamed.push({
                new: change.new.optionName,
                old: change.old.optionName
            });
        }
    }
    return Array.from(fieldsById.values());
};


const $51e60ec45653c705$export$27a53e1c988e51a = ({ steps: steps })=>{
    const cardProps = (0, $ebe939470e7b3ba2$export$70556cf06721e61c)(steps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, cardProps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d4521ed9f566ba3e$export$7026c377272c45e5), {
        fieldIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: ""
        }),
        ...cardProps[0]
    }));
};








/* FieldCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $2wCqQ = parcelRequire("2wCqQ");




const $b0b30aa5fc7752be$var$fieldTypeLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldCard.fieldTypeLabel.non-final",
    defaultMessage: "Field type"
});
const $b0b30aa5fc7752be$var$fieldNameLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldCard.fieldNameLabel.non-final",
    defaultMessage: "Field name"
});
const $b0b30aa5fc7752be$var$fieldOptionsLabel = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.FieldCard.fieldOptionsLabel.non-final",
    defaultMessage: "Options"
});
const $b0b30aa5fc7752be$var$styles = {
    fieldWrapper: "_0Of8r28HPE _1wydGW8HPE"
};
const $b0b30aa5fc7752be$export$d59ace3569612be2 = ({ fieldIcon: fieldIcon, fieldName: fieldName, fieldOptions: fieldOptions, fieldType: fieldType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $b0b30aa5fc7752be$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($b0b30aa5fc7752be$var$fieldTypeLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, fieldIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, fieldType))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $b0b30aa5fc7752be$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($b0b30aa5fc7752be$var$fieldNameLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, fieldName)), fieldOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $b0b30aa5fc7752be$var$styles.fieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage($b0b30aa5fc7752be$var$fieldOptionsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, fieldOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: option
        }, option)))));
};


const $23f72f103087e1c7$export$74ee11cb1ecd9c8d = ({ payload: payload })=>{
    const { fieldName: fieldName, fieldOptions: fieldOptions, fieldType: fieldType } = payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0b30aa5fc7752be$export$d59ace3569612be2), {
        fieldIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: ""
        }),
        fieldName: fieldName,
        fieldOptions: fieldOptions,
        fieldType: fieldType
    });
};


const $f4849fd7257b4b82$export$2e49f440307cfab = ({ steps: steps })=>{
    if (steps.length === 0) return null;
    // check for field options
    if (steps.find((step)=>step.actionSubject === 'field-options')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51e60ec45653c705$export$27a53e1c988e51a), {
        steps: steps
    });
    // check for field
    const fieldStep = steps.find((step)=>step.actionSubject === 'field');
    if (fieldStep) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $23f72f103087e1c7$export$74ee11cb1ecd9c8d), {
        payload: fieldStep.payload
    });
    return null;
};
module.exports["IntentBody"] = $f4849fd7257b4b82$export$2e49f440307cfab;

});

parcelRegister("1C0CS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $8s9DV = parcelRequire("8s9DV");

/** Default entry for a `(conversationId, invocationId)` pair that has never been touched. */ const $b4bf077a12c6cbe6$var$DEFAULT_ENTRY = {
    inProgress: false,
    error: undefined
};
const $b4bf077a12c6cbe6$var$initialState = {
    byConversation: {}
};
/** Immutably write a single `invocationId` entry into the nested `byConversation` map. */ const $b4bf077a12c6cbe6$var$writeEntry = (byConversation, conversationId, invocationId, entry)=>({
        ...byConversation,
        [conversationId]: {
            ...byConversation[conversationId],
            [invocationId]: entry
        }
    });
const $b4bf077a12c6cbe6$var$actions = {
    setInProgress: (conversationId, invocationId, inProgress)=>({ setState: setState, getState: getState })=>{
            const byConversation = getState().byConversation;
            const existing = byConversation[conversationId]?.[invocationId] ?? $b4bf077a12c6cbe6$var$DEFAULT_ENTRY;
            setState({
                byConversation: $b4bf077a12c6cbe6$var$writeEntry(byConversation, conversationId, invocationId, {
                    ...existing,
                    inProgress: inProgress
                })
            });
        },
    setError: (conversationId, invocationId, error)=>({ setState: setState, getState: getState })=>{
            const byConversation = getState().byConversation;
            const existing = byConversation[conversationId]?.[invocationId] ?? $b4bf077a12c6cbe6$var$DEFAULT_ENTRY;
            setState({
                byConversation: $b4bf077a12c6cbe6$var$writeEntry(byConversation, conversationId, invocationId, {
                    ...existing,
                    error: error
                })
            });
        }
};
const $b4bf077a12c6cbe6$export$149d18f9ce0dc59d = (0, $8s9DV.createStore)({
    name: 'action-step-apply',
    initialState: $b4bf077a12c6cbe6$var$initialState,
    actions: $b4bf077a12c6cbe6$var$actions
});


const $4b198fe6db889a6b$export$5ddfab801403192d = (0, $kBr4q.createHook)((0, $b4bf077a12c6cbe6$export$149d18f9ce0dc59d), {
    selector: (state, { conversationId: conversationId, invocationIds: invocationIds })=>{
        const entries = {};
        for (const invocationId of invocationIds)entries[invocationId] = state.byConversation[conversationId]?.[invocationId] ?? {
            inProgress: false,
            error: undefined
        };
        return entries;
    }
});
module.exports["useActionStepApplyEntriesHook"] = $4b198fe6db889a6b$export$5ddfab801403192d;

});

parcelRegister("8JVOU", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $ca02c54eee33a76a$var$JSM_CREATE_KB_SYNC_COMMANDS = {
    CHAT_TO_STAGING_MESSAGE: 'jsm-create-kb-chat-to-staging-message-command',
    STAGING_TO_CHAT_MESSAGE: 'jsm-create-kb-staging-to-chat-message-command',
    CREATE_ITEMS: 'jsm-create-kb-create-items-command',
    CARD_EVENT: 'jsm-kb-card-event-command',
    CREATE_ARTICLES: 'jsm-create-kb-create-articles-command'
};
const $ca02c54eee33a76a$export$5e8734d5a5291870 = (0, $dSoGR.createCommand)($ca02c54eee33a76a$var$JSM_CREATE_KB_SYNC_COMMANDS.CHAT_TO_STAGING_MESSAGE);
const $ca02c54eee33a76a$export$882288ce04127b99 = (0, $dSoGR.createCommand)($ca02c54eee33a76a$var$JSM_CREATE_KB_SYNC_COMMANDS.STAGING_TO_CHAT_MESSAGE);
const $ca02c54eee33a76a$export$ab2fd49178253131 = (0, $dSoGR.createCommand)($ca02c54eee33a76a$var$JSM_CREATE_KB_SYNC_COMMANDS.CREATE_ITEMS);
const $ca02c54eee33a76a$export$19d303208f067b7c = (0, $dSoGR.createCommand)($ca02c54eee33a76a$var$JSM_CREATE_KB_SYNC_COMMANDS.CARD_EVENT);
const $ca02c54eee33a76a$export$3c5e5097d90bb27b = (0, $dSoGR.createCommand)($ca02c54eee33a76a$var$JSM_CREATE_KB_SYNC_COMMANDS.CREATE_ARTICLES);
const $ca02c54eee33a76a$export$485cde51277c7d6f = (0, $dSoGR.createCommand)('jsm-kb-staging-area-event-command');
module.exports["JsmCreateKbCreateItemsCommand"] = $ca02c54eee33a76a$export$ab2fd49178253131;
module.exports["JSMKbCardEventCommand"] = $ca02c54eee33a76a$export$19d303208f067b7c;
module.exports["JSMKBStagingAreaEventCommand"] = $ca02c54eee33a76a$export$485cde51277c7d6f;

});

parcelRegister("eDWhq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $85mU8 = parcelRequire("85mU8");

const $d70864677eee19d7$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $85mU8.getBrowserBridgeAPI)())=>{
    const refApi = (0, $cozmU.useRef)(apiInstance);
    const refReady = (0, $cozmU.useRef)(false);
    const refMount = (0, $cozmU.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $cozmU.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $cozmU.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $cozmU.useCallback)((command_0, params)=>{
        // devx: provide current `clientId`
        return api.send(command_0, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $cozmU.useCallback)((command_1, params_0, options)=>{
        api.broadcast(command_1, params_0, options);
    }, [
        api
    ]);
    const teardown = (0, $cozmU.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
   * If we have already mounted our handlers once and marked ourselves as ready, then this
   * bridge API client is already capable of receiving & handling commands. On subsequent renders
   * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
   *
   * This will ensure the newest state of every handler is being used, with no stale references
   * in closures, as can often occur with initialise-only-once code in React.
   */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $d70864677eee19d7$export$a74fbbd6fb01001c;

});

parcelRegister("gznGh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8218d968f99f965e3473f1bbc7ff080>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10248beccb6a135$var$_react = $c10248beccb6a135$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c10248beccb6a135$var$_baseNew = $c10248beccb6a135$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c10248beccb6a135$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/book-with-bookmark
 * Usage guidance:
 * Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c10248beccb6a135$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $c10248beccb6a135$var$_react.default.createElement($c10248beccb6a135$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$c10248beccb6a135$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $c10248beccb6a135$var$_default = module.exports.default = $c10248beccb6a135$var$BookWithBookmarkIcon;

});

parcelRegister("1HjbK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hlvTd = parcelRequire("hlvTd");


var $haiCi = parcelRequire("haiCi");


var $jTKfH = parcelRequire("jTKfH");

const $3768814c895f680b$var$GetSingleSpaceQuery = `
query GetSpace($id: ID!, $fetchHomepage: Boolean = false) {
	confluence {
		space(id: $id) {
			id: spaceId
			name
				key
				icon {
					path
				}
			homepage @include(if: $fetchHomepage) {
			type
			ari: id
			id: pageId
			name: title
		}
		operations {
			operation
			target
		}
		typeSettings {
			enabledContentTypes {
				isBlogsEnabled
				isDatabasesEnabled
				isLivePagesEnabled
				isWhiteboardsEnabled
				isEmbedsEnabled
				isFoldersEnabled
				}
			}
		}
	}
}
`;
const $3768814c895f680b$var$GetSinglePageQuery = `
query GetPage($id: ID!) {
	confluence {
	page(id: $id) {
		id: pageId
		name: title
		space {
			id
			name
			key
			icon {
			path
			}
		}
	}
	}
}
`;
const $3768814c895f680b$var$GetSingleBlogPostQuery = `
query GetBlogPost($id: ID!) {
	confluence {
	blogPost(id: $id) {
		id: blogPostId
		name: title
	}
	}
}
`;
const $3768814c895f680b$var$ListEntitiesQuery = `
query ListEntities($query: String!, $siteAri: String!, $entityAtis: [String!]!, $confluenceFilters: SearchConfluenceFilter, $fetchHomepage: Boolean = false) {
	search {
		search(
			query: $query
			filters: {
				entities: $entityAtis,
				locations: [$siteAri],
				confluenceFilters: $confluenceFilters,
			}
			experience: "rovo-chat-message-actions"
		) {
			edges {
				node {
					type
					ari: id
					... on SearchConfluenceSpace {
						id: entityId
						name:title
						key
						iconPath
						spaceEntity {
							links {
								base
							}
							type
							operations {
								operation
								target
							}
							typeSettings {
								enabledContentTypes {
									isBlogsEnabled
									isDatabasesEnabled
									isLivePagesEnabled
									isWhiteboardsEnabled
									isEmbedsEnabled
									isFoldersEnabled
								}
							}
							homepage @include(if: $fetchHomepage) {
								type
								ari: id
								id: pageId
								name: title
							}
						}
					}
					... on SearchConfluencePageBlogAttachment {
						id:entityId
						name:title
						confluenceEntity {
							... on ConfluencePage {
								id
								subtype
							}
						}
					}
				}
			}
		}
	}
}
`;
const $3768814c895f680b$var$recommendedSpacesQuery = `
	query SmartsRecommendedContainerQueryFromRovo($userId: String!, $tenantId: String!, $fetchHomepage: Boolean = false) {
		smarts {
			results: recommendedContainer(
				recommendationsQuery: {
					context: {
						userId: $userId,
						tenantId: $tenantId,
						product: "confluence"
					},
					modelRequestParams: {
						caller: "rovo-chat-sync-space-selector",
						experience: "CgContainerNearbyUser"
					},
					requestingUserId: $userId
				}
			) {
				id
				score
				container {
					typeSettings {
						enabledContentTypes {
							isBlogsEnabled
							isDatabasesEnabled
							isLivePagesEnabled
							isWhiteboardsEnabled
							isEmbedsEnabled
							isFoldersEnabled
						}
					}
					createdDate
					id
					key
					name
					spaceId
					status
					type
					links {
						base
						webUi
					}
					icon {
						path
					}
					homepage @include(if: $fetchHomepage) {
						type
						ari: id
						id: pageId
						name: title
					}
				}
			}
		}
	}
`;
const $3768814c895f680b$var$smartRecommendedSpacesQuery = `
	query SmartsRecommendedQueryFromRovo($pageTitle: String!, $userPrompt: String!, $cloudId: ID!){
		convoai_confluenceSpaceRecommendations(
			pageTitle: $pageTitle
			userPrompt: $userPrompt
			cloudId: $cloudId
		) {
			id
			name
			spaceDetails {
				status
				type
				key
				icon {
					path
				}
				homepage {
					id
					title
					type
				}
				spaceTypeSettings {
					enabledContentTypes {
						isBlogsEnabled
						isDatabasesEnabled
						isLivePagesEnabled
						isWhiteboardsEnabled
						isEmbedsEnabled
						isFoldersEnabled
					}
				}
			}
		}
	}
`;
const $3768814c895f680b$var$getAbsoluteIconPath = (baseUrl, iconPath)=>new URL(iconPath.replace(/^\//, ''), `${baseUrl.replace(/\/$/, '')}/`).toString();
const $3768814c895f680b$var$fetchDraftContentEntity = async (id, type)=>{
    const resource = type === 'page' ? 'pages' : 'blogposts';
    const draft = await (0, $jTKfH.performHttpFetch)({
        path: `/wiki/api/v2/${resource}/${encodeURIComponent(id)}?get-draft=true`,
        options: {
            credentials: 'include'
        }
    });
    if (!draft?.id) return undefined;
    return {
        id: draft.id,
        name: draft.title ?? ''
    };
};
/**
 * Maximum number of unique space keys to query in a single batched
 * `confluence_contentApprovalsSpaceSettingConfig` call. The AGG gateway
 * enforces a per-request variable limit (currently around 50); going above
 * that fails the whole batch. Pickers very rarely surface more than ~25
 * spaces at once, so this cap is effectively a soft guardrail.
 */ const $3768814c895f680b$var$FETCH_SPACE_APPROVALS_BATCH_LIMIT = 50;
/**
 * Builds an aliased batch query that resolves the approvals space-setting config
 * for each space key in a single request. `confluence_contentApprovalsSpaceSettingConfig`
 * is a top-level Query field (it is not a nested field on a Confluence space), so it
 * cannot be co-resolved inside the space list queries the way typeSettings is.
 *
 * Each space key is exposed under a stable alias (s0, s1, ...). The mapping back to the
 * original space key is returned alongside the query so the response can be re-keyed.
 */ const $3768814c895f680b$var$buildSpaceApprovalsConfigsQuery = (spaceKeys)=>{
    const aliasToKey = {};
    const fields = spaceKeys.map((key, index)=>{
        const alias = `s${index}`;
        aliasToKey[alias] = key;
        // spaceKey is passed as a GraphQL variable to avoid any string-injection concerns.
        return `${alias}: confluence_contentApprovalsSpaceSettingConfig(cloudId: $cloudId, spaceKey: $${alias}) {
				config {
					disallowFirstPublish
				}
			}`;
    }).join('\n');
    const varDecls = [
        '$cloudId: ID!',
        ...spaceKeys.map((_, index)=>`$s${index}: String!`)
    ].join(', ');
    return {
        query: `query SpaceApprovalsConfigsFromRovo(${varDecls}) {\n${fields}\n}`,
        aliasToKey: aliasToKey
    };
};
const $3768814c895f680b$export$df21df037fc44122 = (siteId, options)=>{
    const listEntities = (0, $cozmU.useCallback)(async (query, types, spaceId)=>{
        try {
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $3768814c895f680b$var$ListEntitiesQuery,
                headerOptions: {
                    'X-ExperimentalApi': 'confluence-agg-beta'
                },
                variables: {
                    query: query,
                    entityAtis: types.map((type)=>`ati:cloud:confluence:${type.toLowerCase()}`),
                    siteAri: `ari:cloud:confluence::site/${siteId}`,
                    confluenceFilters: spaceId ? {
                        containerARIs: [
                            `ari:cloud:confluence:${siteId}:space/${spaceId}`
                        ]
                    } : undefined,
                    fetchHomepage: options?.fetchHomepage
                }
            });
            return response.data.search.search.edges.filter((edge)=>{
                if (edge.node.type === 'space') {
                    const operations = edge.node.spaceEntity?.operations;
                    return operations?.some((op)=>op?.operation === 'CREATE' && op?.target === 'PAGE') ?? false;
                }
                return true;
            }).map((edge_0)=>({
                    ari: edge_0.node.ari,
                    id: edge_0.node.id,
                    key: edge_0.node.type === 'space' ? edge_0.node.key : undefined,
                    name: edge_0.node.name,
                    type: edge_0.node.type === 'space' ? edge_0.node.spaceEntity?.type ?? edge_0.node.type : edge_0.node.type,
                    homepage: edge_0.node.type === 'space' ? edge_0.node.spaceEntity?.homepage : undefined,
                    iconPath: edge_0.node.type === 'space' && edge_0.node.iconPath && edge_0.node.spaceEntity?.links?.base ? $3768814c895f680b$var$getAbsoluteIconPath(edge_0.node.spaceEntity.links.base, edge_0.node.iconPath) : edge_0.node.type === 'space' ? edge_0.node.iconPath : undefined,
                    subtype: edge_0.node.type !== 'space' ? edge_0.node.confluenceEntity?.subtype : undefined,
                    typeSettings: edge_0.node.type === 'space' ? edge_0.node.spaceEntity?.typeSettings : undefined
                }));
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'ListEntitiesQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return [];
        }
    }, [
        siteId,
        options?.fetchHomepage
    ]);
    const getEntity = (0, $cozmU.useCallback)(async (id, type_0)=>{
        let query_0;
        switch(type_0){
            case 'space':
                query_0 = $3768814c895f680b$var$GetSingleSpaceQuery;
                break;
            case 'page':
                query_0 = $3768814c895f680b$var$GetSinglePageQuery;
                break;
            case 'blogPost':
                query_0 = $3768814c895f680b$var$GetSingleBlogPostQuery;
                break;
        }
        try {
            const response_0 = await (0, $haiCi.performGqlFetch)({
                gqlQuery: query_0,
                variables: {
                    id: `ari:cloud:confluence:${siteId}:${type_0.toLowerCase()}/${id}`,
                    fetchHomepage: options?.fetchHomepage
                },
                headerOptions: {
                    'X-ExperimentalApi': 'confluence-agg-beta'
                }
            });
            // The agg API cannot resolve drafts, so fall back to the Confluence REST
            // v2 draft API for pages and blog posts when the primary query is empty.
            if (type_0 === 'page' && !response_0.data.confluence.page || type_0 === 'blogPost' && !response_0.data.confluence.blogPost) return await $3768814c895f680b$var$fetchDraftContentEntity(id, type_0);
            return response_0.data.confluence[type_0];
        } catch (error_0) {
            (0, $hlvTd.logException)({
                exception: error_0,
                name: 'GetEntityQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return undefined;
        }
    }, [
        siteId,
        options?.fetchHomepage
    ]);
    const fetchRecommendedSpaces = (0, $cozmU.useCallback)(async ({ userId: userId })=>{
        try {
            const response_1 = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $3768814c895f680b$var$recommendedSpacesQuery,
                variables: {
                    tenantId: siteId,
                    userId: userId,
                    fetchHomepage: options?.fetchHomepage
                }
            });
            return response_1.data.smarts.results.map((recommendedSpace)=>({
                    ...recommendedSpace,
                    container: {
                        ...recommendedSpace.container,
                        icon: {
                            ...recommendedSpace.container.icon,
                            path: $3768814c895f680b$var$getAbsoluteIconPath(recommendedSpace.container.links.base, recommendedSpace.container.icon.path)
                        }
                    }
                }));
        } catch (error_1) {
            (0, $hlvTd.logException)({
                exception: error_1,
                name: 'RecommendedSpacesQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return [];
        }
    }, [
        siteId,
        options?.fetchHomepage
    ]);
    const fetchSmartRecommendedSpaces = (0, $cozmU.useCallback)(async ({ pageTitle: pageTitle, userPrompt: userPrompt })=>{
        try {
            const response_2 = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $3768814c895f680b$var$smartRecommendedSpacesQuery,
                variables: {
                    pageTitle: pageTitle,
                    userPrompt: userPrompt,
                    cloudId: siteId
                }
            });
            return response_2.data.convoai_confluenceSpaceRecommendations.filter(({ spaceDetails: spaceDetails })=>spaceDetails?.status.toLowerCase() === 'current');
        } catch (error_2) {
            (0, $hlvTd.logException)({
                exception: error_2,
                name: 'SmartRecommendedSpacesQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return [];
        }
    }, [
        siteId
    ]);
    const fetchSpaceApprovalsConfigs = (0, $cozmU.useCallback)(async (spaceKeys)=>{
        const allUniqueKeys = Array.from(new Set(spaceKeys.filter(Boolean)));
        if (allUniqueKeys.length === 0) return {};
        // Cap the batch so we don't blow past the AGG gateway's per-request
        // variable limit (~50 today). Spaces beyond the cap are simply not
        // resolved this round — `filterOutFirstPublishDisallowedSpaces` falls
        // back to "include the space" when its key is missing from the map,
        // matching the rest-of-system "fail open" behaviour.
        const uniqueKeys = allUniqueKeys.slice(0, $3768814c895f680b$var$FETCH_SPACE_APPROVALS_BATCH_LIMIT);
        try {
            const { query: query_1, aliasToKey: aliasToKey } = $3768814c895f680b$var$buildSpaceApprovalsConfigsQuery(uniqueKeys);
            const variables = {
                cloudId: siteId
            };
            uniqueKeys.forEach((key, index)=>{
                variables[`s${index}`] = key;
            });
            const response_3 = await (0, $haiCi.performGqlFetch)({
                gqlQuery: query_1,
                variables: variables,
                headerOptions: {
                    'X-ExperimentalApi': 'confluence-agg-beta'
                }
            });
            const result = {};
            const aliasMap = response_3?.data ?? {};
            Object.entries(aliasToKey).forEach(([alias, key_0])=>{
                const disallowFirstPublish = aliasMap[alias]?.config?.disallowFirstPublish ?? false;
                result[key_0] = {
                    disallowFirstPublish: disallowFirstPublish
                };
            });
            return result;
        } catch (error_3) {
            (0, $hlvTd.logException)({
                exception: error_3,
                name: 'SpaceApprovalsConfigsQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            // Degrade gracefully: an empty map means no space is treated as gated,
            // so the picker behaves exactly as it does today.
            return {};
        }
    }, [
        siteId
    ]);
    return {
        listEntities: listEntities,
        getEntity: getEntity,
        fetchRecommendedSpaces: fetchRecommendedSpaces,
        fetchSmartRecommendedSpaces: fetchSmartRecommendedSpaces,
        fetchSpaceApprovalsConfigs: fetchSpaceApprovalsConfigs
    };
};
module.exports["useConfluenceEntities"] = $3768814c895f680b$export$df21df037fc44122;

});

parcelRegister("63sT2", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("8NccQ")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("8NccQ")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("8NccQ")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("dYn3u")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("dYn3u")).Reasons);

var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("kgHuu", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("6ROIE")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("3qdJ0")).Targets);

var $6ROIE = parcelRequire("6ROIE");


var $3qdJ0 = parcelRequire("3qdJ0");


});

parcelRegister("6ROIE", function(module, exports) {
class $f31eace768ed80b8$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $f31eace768ed80b8$export$a5e53d1dcbd6eb61;

});

parcelRegister("3qdJ0", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $8c8615b3f214c36e$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $8c8615b3f214c36e$export$59a8eb9cff113544;

});

parcelRegister("aBKty", function(module, exports) {

var $6EphZ = parcelRequire("6EphZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/site/manifest.ts
var $7b91693551a8064f$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6EphZ.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $6EphZ.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $7b91693551a8064f$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $7b91693551a8064f$export$82e6693d75ffdd8;

});

parcelRegister("6EphZ", function(module, exports) {
// src/confluence/site/types.ts
var $4d7a18635b736c71$export$9e07499cd8b0bde5 = "confluence", $4d7a18635b736c71$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $4d7a18635b736c71$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $4d7a18635b736c71$export$57b7cabbf31f1f68;

});

parcelRegister("5OelY", function(module, exports) {

var $lWK1w = parcelRequire("lWK1w");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/space/manifest.ts
var $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lWK1w.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $lWK1w.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $43acc191f70ab1e6$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $43acc191f70ab1e6$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
};
module.exports["ConfluenceSpaceAri"] = $43acc191f70ab1e6$export$4e1bd9257e1b7213;

});

parcelRegister("lWK1w", function(module, exports) {
// src/confluence/space/types.ts
var $ffa2b71257b046bf$export$204c4c730af505ce = "confluence", $ffa2b71257b046bf$export$7c78a678ea7a8ac7 = "space";
module.exports["ConfluenceSpaceAriResourceOwner"] = $ffa2b71257b046bf$export$204c4c730af505ce;
module.exports["ConfluenceSpaceAriResourceType"] = $ffa2b71257b046bf$export$7c78a678ea7a8ac7;

});

parcelRegister("9LE5K", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $8eSEp = parcelRequire("8eSEp");


var $irq28 = parcelRequire("irq28");

const $ebc30e71ada51b63$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $irq28.printDocToString)((0, $8eSEp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(options, [
        'printWidth'
    ]));
};
module.exports["print"] = $ebc30e71ada51b63$export$c2d084dc44961371;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("8eSEp", function(module, exports) {

var $6acZZ = parcelRequire("6acZZ");


var $j8RTJ = parcelRequire("j8RTJ");


var $bn40z = parcelRequire("bn40z");

const $c5b93e096496256e$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $c5b93e096496256e$export$27a275559a5c8102 extends (0, $j8RTJ.AbstractJastVisitor) {
    visitArgument(argument) {
        return argument.text;
    }
    /**
   * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
   */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $bn40z.ifBreak)((0, $bn40z.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $6acZZ.CLAUSE_TYPE_COMPOUND)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $bn40z.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $c5b93e096496256e$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $bn40z.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $bn40z.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $bn40z.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $c5b93e096496256e$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $bn40z.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $bn40z.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $c5b93e096496256e$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $bn40z.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $c5b93e096496256e$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $bn40z.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $bn40z.group)([
            query.where.accept(this),
            (0, $bn40z.ifBreak)((0, $bn40z.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $bn40z.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $6acZZ.CLAUSE_TYPE_COMPOUND)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $bn40z.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = void 0;
        this.operatorCase = operatorCase || 'preserve';
    }
}
const $c5b93e096496256e$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $c5b93e096496256e$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};
module.exports["printAstToDoc"] = $c5b93e096496256e$export$f0ef38932978952;

});

parcelRegister("bn40z", function(module, exports) {
const $3df9822ef8ba2310$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $3df9822ef8ba2310$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $3df9822ef8ba2310$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};
module.exports["group"] = $3df9822ef8ba2310$export$e5e25fbcc1f7affe;
module.exports["ifBreak"] = $3df9822ef8ba2310$export$1db8e61901dcb0fa;
module.exports["newLine"] = $3df9822ef8ba2310$export$dc84f6841f96b7da;

});

parcelRegister("irq28", function(module, exports) {
const $df0a63871a342381$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $df0a63871a342381$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $df0a63871a342381$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $df0a63871a342381$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $df0a63871a342381$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $df0a63871a342381$var$printGroup(doc, context);
        case 'if-break':
            return $df0a63871a342381$var$printIfBreak(doc, context);
        case 'new-line':
            return $df0a63871a342381$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $df0a63871a342381$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $df0a63871a342381$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $df0a63871a342381$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $df0a63871a342381$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $df0a63871a342381$var$printDoc(doc.breakContents, context);
    return $df0a63871a342381$var$printDoc(doc.flatContents, context);
};
const $df0a63871a342381$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $df0a63871a342381$var$defaultPrintWidth = 100;
const $df0a63871a342381$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $df0a63871a342381$var$defaultPrintWidth } = options;
    const output = $df0a63871a342381$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};
module.exports["printDocToString"] = $df0a63871a342381$export$316fc7e94b95b118;

});

parcelRegister("fjKr7", function(module, exports) {

var $lGE71 = parcelRequire("lGE71");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/jira/issue/manifest.ts
var $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lGE71.JiraIssueAriResourceOwner),
    resourceType: (0, $lGE71.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $b26ca6a6a4ea6688$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $b26ca6a6a4ea6688$export$1da6808e89ee03e;

});

parcelRegister("lGE71", function(module, exports) {
// src/jira/issue/types.ts
var $fc9ca2abfea94195$export$665a39f1b4e29e0a = "jira", $fc9ca2abfea94195$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $fc9ca2abfea94195$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $fc9ca2abfea94195$export$76beb4d0da177ad4;

});

parcelRegister("iqP6y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c54b6d29d504c6ad8900af2bbcc304b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6b24c047a76f26c$var$_react = $d6b24c047a76f26c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d6b24c047a76f26c$var$_baseNew = $d6b24c047a76f26c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d6b24c047a76f26c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintPalette".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/paint-palette
 * Usage guidance:
 * Multi purpose - Known usages: Customize.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6b24c047a76f26c$var$PaintPaletteIcon = (props)=>/*#__PURE__*/ $d6b24c047a76f26c$var$_react.default.createElement($d6b24c047a76f26c$var$_baseNew.default, Object.assign({
        name: "PaintPaletteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.932.274a8 8 0 0 1 4.14 15.455 1 1 0 0 1-.097.02c-.908.118-1.72.055-2.29-.438-.573-.498-.672-1.24-.682-1.85-.011-.672-.309-1.152-.72-1.426-.42-.279-1.016-.384-1.682-.169-1.006.325-1.93.458-2.717.158-.837-.32-1.308-1.042-1.597-1.909l-.012-.043A8 8 0 0 1 5.932.274M14.28 6.32A6.5 6.5 0 0 0 1.718 9.66c.218.647.464.871.701.962.29.11.796.116 1.72-.182 1.061-.344 2.14-.209 2.974.346.84.56 1.371 1.507 1.39 2.65.009.546.112.695.166.742.058.05.291.181 1.064.088a6.5 6.5 0 0 0 4.547-7.947"/><path fill="currentcolor" d="M10.87 5.68a1.13 1.13 0 1 1 .58 2.17 1.13 1.13 0 0 1-.58-2.17m-6.49-.07a1.13 1.13 0 1 1 .58 2.17 1.13 1.13 0 0 1-.58-2.17m3.3-2.18a1.13 1.13 0 1 1 .58 2.17 1.13 1.13 0 0 1-.58-2.17"/>`
    }, props));
$d6b24c047a76f26c$var$PaintPaletteIcon.displayName = 'PaintPaletteIcon';
var $d6b24c047a76f26c$var$_default = module.exports.default = $d6b24c047a76f26c$var$PaintPaletteIcon;

});

parcelRegister("3DjKS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ad9913fe9e202296$var$baseStyles = null;
const $ad9913fe9e202296$var$justifyStartStyles = null;
const $ad9913fe9e202296$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $ad9913fe9e202296$var$TagGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { alignment: t1, titleId: titleId, label: label, children: children } = t0;
    const alignment = t1 === undefined ? "start" : t1;
    const t2 = alignment === "start" && "_37wbyuchRC";
    const t3 = alignment === "end" && "_37wbyuz9WS";
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _3TGfC9HnLE",
            t2,
            t3
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== label || $[5] !== ref || $[6] !== t4 || $[7] !== titleId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "group",
            ref: ref,
            "aria-label": label,
            "aria-labelledby": titleId,
            className: t4,
            children: children
        });
        $[3] = children;
        $[4] = label;
        $[5] = ref;
        $[6] = t4;
        $[7] = titleId;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _3TGfC9HnLE",
            alignment === 'start' && "_37wbyuchRC",
            alignment === 'end' && "_37wbyuz9WS"
        ]),
        children: children
    });
});
var $ad9913fe9e202296$export$2e2bcd8739ae039 = $ad9913fe9e202296$var$TagGroup;
module.exports["default"] = $ad9913fe9e202296$export$2e2bcd8739ae039;

});

parcelRegister("3p3yp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8527a967f745a644fb3f0c69253e7d8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27a676a43c39b52c$var$_react = $27a676a43c39b52c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $27a676a43c39b52c$var$_baseNew = $27a676a43c39b52c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $27a676a43c39b52c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataNumber".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/data-number
 * Usage guidance:
 * Known uses: Representing number datatype fields in Proforma and databases.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27a676a43c39b52c$var$DataNumberIcon = (props)=>/*#__PURE__*/ $27a676a43c39b52c$var$_react.default.createElement($27a676a43c39b52c$var$_baseNew.default, Object.assign({
        name: "DataNumberIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.75 4h2a.75.75 0 0 1 .75.75V12H2V5.5H.75zM5 4h3.13c.76 0 1.38.62 1.38 1.38v2c0 .76-.62 1.38-1.37 1.38H6.5v1.75h3V12H5.75a.75.75 0 0 1-.75-.75V8.63c0-.76.62-1.37 1.38-1.37H8V5.5H5zm6 0h3.13c.76 0 1.38.62 1.38 1.38v5.25c0 .76-.62 1.38-1.37 1.38H11v-1.5h3V8.75h-3v-1.5h3V5.5h-3z" clip-rule="evenodd"/>`
    }, props));
$27a676a43c39b52c$var$DataNumberIcon.displayName = 'DataNumberIcon';
var $27a676a43c39b52c$var$_default = module.exports.default = $27a676a43c39b52c$var$DataNumberIcon;

});

parcelRegister("isb4V", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("kP7lf"));

});

parcelRegister("kP7lf", function(module, exports) {
'use strict';

var $7bFJu = parcelRequire("7bFJu");


var $3TXUV = parcelRequire("3TXUV");


var $bm2P5 = parcelRequire("bm2P5");

var $f28e43f90b5e7094$var$loadQuery = $bm2P5.loadQuery;

var $DzQY7 = parcelRequire("DzQY7");


var $g3VN8 = parcelRequire("g3VN8");


var $kRACb = parcelRequire("kRACb");


var $64oDd = parcelRequire("64oDd");


var $9ODTT = parcelRequire("9ODTT");


var $lrlFo = parcelRequire("lrlFo");


var $1aILl = parcelRequire("1aILl");


var $6GfGb = parcelRequire("6GfGb");


var $ahDXf = parcelRequire("ahDXf");


var $yJOoK = parcelRequire("yJOoK");


var $11WLO = parcelRequire("11WLO");


var $gDDHO = parcelRequire("gDDHO");


var $4Ni4N = parcelRequire("4Ni4N");


var $eqEJl = parcelRequire("eqEJl");

module.exports = {
    ConnectionHandler: $eqEJl.ConnectionHandler,
    applyOptimisticMutation: $eqEJl.applyOptimisticMutation,
    commitLocalUpdate: $eqEJl.commitLocalUpdate,
    commitMutation: $eqEJl.commitMutation,
    graphql: $eqEJl.graphql,
    readInlineData: $eqEJl.readInlineData,
    requestSubscription: $eqEJl.requestSubscription,
    EntryPointContainer: $7bFJu,
    RelayEnvironmentProvider: $g3VN8,
    ProfilerContext: $DzQY7,
    fetchQuery: $eqEJl.fetchQuery,
    loadQuery: $f28e43f90b5e7094$var$loadQuery,
    loadEntryPoint: $3TXUV,
    useFragment: $64oDd,
    useLazyLoadQuery: $9ODTT,
    useEntryPointLoader: $kRACb,
    useQueryLoader: $ahDXf,
    useMutation: $lrlFo,
    usePaginationFragment: $1aILl,
    usePreloadedQuery: $6GfGb,
    useRefetchableFragment: $yJOoK,
    useRelayEnvironment: $11WLO,
    useSubscribeToInvalidationState: $gDDHO,
    useSubscription: $4Ni4N
};

});

parcelRegister("6dcFV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1209a2f4f8901a660cee517b19ae711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $485dc9fd900ed296$var$_react = $485dc9fd900ed296$var$_interopRequireDefault((parcelRequire("cozmU")));

var $485dc9fd900ed296$var$_baseNew = $485dc9fd900ed296$var$_interopRequireDefault((parcelRequire("gElAV")));
function $485dc9fd900ed296$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonOffboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-offboard
 * Usage guidance:
 * 📦 @atlaskit/icon/core/person-offboard
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $485dc9fd900ed296$var$PersonOffboardIcon = (props)=>/*#__PURE__*/ $485dc9fd900ed296$var$_react.default.createElement($485dc9fd900ed296$var$_baseNew.default, Object.assign({
        name: "PersonOffboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m4.78 8.22a.75.75 0 0 1 0 1.06l-2.62 2.63-1.06-1.06 1.35-1.34H9.5v-1.5h3.94l-1.34-1.34 1.06-1.06z"/>`
    }, props));
$485dc9fd900ed296$var$PersonOffboardIcon.displayName = 'PersonOffboardIcon';
var $485dc9fd900ed296$var$_default = module.exports.default = $485dc9fd900ed296$var$PersonOffboardIcon;

});

parcelRegister("jerDQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::493336d4c8282919ec0a9182a18e013b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e004c42a6127bf6c$var$_react = $e004c42a6127bf6c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e004c42a6127bf6c$var$_baseNew = $e004c42a6127bf6c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e004c42a6127bf6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sprint
 * Usage guidance:
 * Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e004c42a6127bf6c$var$SprintIcon = (props)=>/*#__PURE__*/ $e004c42a6127bf6c$var$_react.default.createElement($e004c42a6127bf6c$var$_baseNew.default, Object.assign({
        name: "SprintIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$e004c42a6127bf6c$var$SprintIcon.displayName = 'SprintIcon';
var $e004c42a6127bf6c$var$_default = module.exports.default = $e004c42a6127bf6c$var$SprintIcon;

});

parcelRegister("eU4qe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f23a65ba5081d7290600a8244718711d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad99b9c9f3e67774$var$_react = $ad99b9c9f3e67774$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ad99b9c9f3e67774$var$_baseNew = $ad99b9c9f3e67774$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ad99b9c9f3e67774$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/stopwatch
 * Usage guidance:
 * Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad99b9c9f3e67774$var$StopwatchIcon = (props)=>/*#__PURE__*/ $ad99b9c9f3e67774$var$_react.default.createElement($ad99b9c9f3e67774$var$_baseNew.default, Object.assign({
        name: "StopwatchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$ad99b9c9f3e67774$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $ad99b9c9f3e67774$var$_default = module.exports.default = $ad99b9c9f3e67774$var$StopwatchIcon;

});

parcelRegister("4w5r5", function(module, exports) {
/* AskQuestionCompletedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $5hU6h = parcelRequire("5hU6h");

const $478a3f2c323cd588$var$styles = {
    completedItemRow: "_0bjKvD8fU6 _0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO",
    completedNumberContainer: "_3iDTPbQ4SZ _0hPCNLchRC _37wbyuDIqT _4kiQYAoWWg _39xV02SPN1 _2Zuz6QFQfX _1ZnuxbFQfX _0Of8r2FQfX _3YEZNOdnbC",
    completedAnswerBlock: "_0bjKvD8fU6 _1Znuxb2ADO _1wydGWgVvo",
    rightAlignedAnswersBubble: "_39xV02gE1Q _0GTcwRIZbP"
};
const $478a3f2c323cd588$export$27e43c94a1c95fd5 = ({ questions: questions, answers: answers, ContentRenderer: ContentRenderer, productKey: productKey, cloudId: cloudId, conversationId: conversationId, invocationId: invocationId, headerIcon: headerIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)(); // Fire once per mount — this component only renders when the answer card is shown.
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'AskQuestionCompletedView',
            actionSubjectId: 'answer',
            attributes: {
                conversationId: conversationId ?? '',
                invocationId: invocationId ?? '',
                questionsCount: questions.length,
                answersCount: Object.keys(answers).length
            }
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [fallbackIndices] = (0, $cozmU.useState)(()=>questions.map((q)=>Math.floor(Math.random() * q.options.length)));
    const displayAnswers = questions.map((q, idx)=>{
        const ans = answers[idx];
        if (ans?.type === 'option') {
            const option = q.options[ans.optionIndex];
            return {
                label: option?.label ?? '',
                description: option?.description ?? ''
            };
        }
        if (ans?.type === 'custom' && ans.text.trim()) return {
            label: formatMessage((0, $5hU6h.default).customAnswerLabel),
            description: ans.text
        };
        if (ans?.type === 'auto') return {
            label: formatMessage((0, $5hU6h.default).skippedAnswerLabel),
            description: formatMessage((0, $5hU6h.default).autoAnswerLabel)
        };
        const option = q.options[fallbackIndices[idx]] ?? q.options[0];
        return {
            label: option?.label ?? '',
            description: option?.description ?? ''
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $478a3f2c323cd588$var$styles.rightAlignedAnswersBubble
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $5hU6h.default).completedTitle),
        subtitle: formatMessage((0, $5hU6h.default).completedSubtitle, {
            count: questions.length
        }),
        product: "ask-question",
        isExpandable: true,
        defaultExpanded: true,
        isTitleBold: true,
        invertChevron: true,
        headerIcon: headerIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, displayAnswers.map((answer, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: idx,
            xcss: $478a3f2c323cd588$var$styles.completedItemRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.200",
            alignBlock: "start",
            shouldWrap: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $478a3f2c323cd588$var$styles.completedNumberContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium"
        }, idx + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentRenderer, {
            content: questions[idx].question,
            productKey: productKey,
            siteId: cloudId,
            boldText: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $478a3f2c323cd588$var$styles.completedAnswerBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium"
        }, answer.label), answer.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, answer.description))))))))));
};
module.exports["AskQuestionCompletedView"] = $478a3f2c323cd588$export$27e43c94a1c95fd5;

});

parcelRegister("9qyl6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $iDrrr = parcelRequire("iDrrr");


var $22YX5 = parcelRequire("22YX5");

var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");




const $e676d7b916aa3038$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    collapse: {
        id: "ai-mate.conversation-assistant-message-actions.action-card-wrapper.collapse",
        defaultMessage: "Collapse"
    },
    expand: {
        id: "ai-mate.conversation-assistant-message-actions.action-card-wrapper.expand",
        defaultMessage: "Expand"
    }
});












var $7wD0t = parcelRequire("7wD0t");


var $824lD = parcelRequire("824lD");


var $5ZtfK = parcelRequire("5ZtfK");


var $kyJuy = parcelRequire("kyJuy");


var $ijkxh = parcelRequire("ijkxh");


var $aNmuJ = parcelRequire("aNmuJ");


var $lSQgn = parcelRequire("lSQgn");


var $bltJZ = parcelRequire("bltJZ");


var $9NPFC = parcelRequire("9NPFC");


var $7hgf7 = parcelRequire("7hgf7");

const $c73ee3d8462f9525$var$actionCardProducts = [
    'google-calendar',
    'google-doc',
    'slack',
    'github',
    'sharepoint',
    'confluence',
    'jira',
    'jsm',
    'resumption',
    'capacity-planning',
    'plan',
    'focus',
    'focus-ask',
    'ask-question',
    'schedule'
];
const $c73ee3d8462f9525$export$22a9451e3bf2233f = (product)=>{
    switch(product){
        case 'google-calendar':
            return /*#__PURE__*/ $cozmU.createElement((0, $7hgf7.GoogleCalendarIcon), {
                label: ""
            });
        case 'google-doc':
            return /*#__PURE__*/ $cozmU.createElement($c73ee3d8462f9525$export$515ef75e64d59277, {
                label: ""
            });
        case 'slack':
            return /*#__PURE__*/ $cozmU.createElement($c73ee3d8462f9525$export$b33fb54b08bb6422, {
                label: ""
            });
        case 'github':
            return /*#__PURE__*/ $cozmU.createElement($c73ee3d8462f9525$export$e8e65f186ccd8749, {
                label: ""
            });
        case 'sharepoint':
            return /*#__PURE__*/ $cozmU.createElement($c73ee3d8462f9525$export$af5de1528a078112, {
                label: ""
            });
        case 'confluence':
            return /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceIcon), {
                appearance: "brand",
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            });
        case 'jira':
            return /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.JiraIcon), {
                appearance: "brand",
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            });
        case 'jsm':
            return /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.JiraServiceManagementIcon), {
                appearance: "brand",
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            });
        case 'resumption':
            return /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aNmuJ))),
                label: "",
                appearance: "gray",
                size: "medium"
            });
        case 'capacity-planning':
            return /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
                label: "",
                size: "medium",
                backgroundColor: "transparent",
                hasBorder: true
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-accent-blue, #357DE8)"
            }));
        case 'plan':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ijkxh))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-accent-blue, #357DE8)"
            });
        case 'focus':
            return /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.FocusIcon), {
                appearance: "brand",
                size: "xsmall"
            });
        case 'focus-ask':
            return /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
                label: "",
                size: "medium",
                backgroundColor: "transparent",
                hasBorder: true
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7wD0t))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }));
        case 'ask-question':
            return /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
                label: "",
                appearance: "gray",
                size: "medium"
            });
        case 'schedule':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                label: "",
                spacing: "none"
            });
        default:
            return null;
    }
};
const $c73ee3d8462f9525$export$515ef75e64d59277 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M20.5938 24H8.40625C7.63281 24 7 23.3864 7 22.6364V5.36364C7 4.61364 7.63281 4 8.40625 4H16.8438L22 9V22.6364C22 23.3864 21.3672 24 20.5938 24Z",
            fill: "#3086F6"
        });
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M16.8438 4L22 9H16.8438V4Z",
            fill: "#0C67D6"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M18.7188 12.8634H10.2812V11.7271H18.7188V12.8634ZM18.7188 14.4543H10.2812V15.5907H18.7188V14.4543ZM16.375 17.1816H10.2812V18.318H16.375V17.1816Z",
            fill: "#FDFFFF"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] !== props.label) {
        t3 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, t0, t1, t2);
        $[3] = props.label;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": props.label
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M20.5938 24H8.40625C7.63281 24 7 23.3864 7 22.6364V5.36364C7 4.61364 7.63281 4 8.40625 4H16.8438L22 9V22.6364C22 23.3864 21.3672 24 20.5938 24Z",
        fill: "#3086F6"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M16.8438 4L22 9H16.8438V4Z",
        fill: "#0C67D6"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M18.7188 12.8634H10.2812V11.7271H18.7188V12.8634ZM18.7188 14.4543H10.2812V15.5907H18.7188V14.4543ZM16.375 17.1816H10.2812V18.318H16.375V17.1816Z",
        fill: "#FDFFFF"
    }));
const $c73ee3d8462f9525$export$b33fb54b08bb6422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("g", {
            clipPath: "url(#clip0_271_181639)"
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
            fill: "#E01E5A"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("clipPath", {
            id: "clip0_271_181639"
        }, /*#__PURE__*/ $cozmU.createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        })));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.label) {
        t2 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, t0, t1);
        $[2] = props.label;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": props.label
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#clip0_271_181639)"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
        fill: "#E01E5A"
    })), /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "clip0_271_181639"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
const $c73ee3d8462f9525$export$e8e65f186ccd8749 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 2.14801C4.685 2.14801 2 4.83301 2 8.14801C2 10.803 3.7175 13.0455 6.1025 13.8405C6.4025 13.893 6.515 13.713 6.515 13.5555C6.515 13.413 6.5075 12.9405 6.5075 12.438C5 12.7155 4.61 12.0705 4.49 11.733C4.4225 11.5605 4.13 11.028 3.875 10.8855C3.665 10.773 3.365 10.4955 3.8675 10.488C4.34 10.4805 4.6775 10.923 4.79 11.103C5.33 12.0105 6.1925 11.7555 6.5375 11.598C6.59 11.208 6.7475 10.9455 6.92 10.7955C5.585 10.6455 4.19 10.128 4.19 7.83301C4.19 7.18051 4.4225 6.64051 4.805 6.22051C4.745 6.07051 4.535 5.45551 4.865 4.63051C4.865 4.63051 5.3675 4.47301 6.515 5.24551C6.995 5.11051 7.505 5.04301 8.015 5.04301C8.525 5.04301 9.035 5.11051 9.515 5.24551C10.6625 4.46551 11.165 4.63051 11.165 4.63051C11.495 5.45551 11.285 6.07051 11.225 6.22051C11.6075 6.64051 11.84 7.17301 11.84 7.83301C11.84 10.1355 10.4375 10.6455 9.1025 10.7955C9.32 10.983 9.5075 11.343 9.5075 11.9055C9.5075 12.708 9.5 13.353 9.5 13.5555C9.5 13.713 9.6125 13.9005 9.9125 13.8405C12.2825 13.0455 14 10.7955 14 8.14801C14 4.83301 11.315 2.14801 8 2.14801Z",
            fill: "currentColor"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.label) {
        t1 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, t0);
        $[1] = props.label;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": props.label
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 2.14801C4.685 2.14801 2 4.83301 2 8.14801C2 10.803 3.7175 13.0455 6.1025 13.8405C6.4025 13.893 6.515 13.713 6.515 13.5555C6.515 13.413 6.5075 12.9405 6.5075 12.438C5 12.7155 4.61 12.0705 4.49 11.733C4.4225 11.5605 4.13 11.028 3.875 10.8855C3.665 10.773 3.365 10.4955 3.8675 10.488C4.34 10.4805 4.6775 10.923 4.79 11.103C5.33 12.0105 6.1925 11.7555 6.5375 11.598C6.59 11.208 6.7475 10.9455 6.92 10.7955C5.585 10.6455 4.19 10.128 4.19 7.83301C4.19 7.18051 4.4225 6.64051 4.805 6.22051C4.745 6.07051 4.535 5.45551 4.865 4.63051C4.865 4.63051 5.3675 4.47301 6.515 5.24551C6.995 5.11051 7.505 5.04301 8.015 5.04301C8.525 5.04301 9.035 5.11051 9.515 5.24551C10.6625 4.46551 11.165 4.63051 11.165 4.63051C11.495 5.45551 11.285 6.07051 11.225 6.22051C11.6075 6.64051 11.84 7.17301 11.84 7.83301C11.84 10.1355 10.4375 10.6455 9.1025 10.7955C9.32 10.983 9.5075 11.343 9.5075 11.9055C9.5075 12.708 9.5 13.353 9.5 13.5555C9.5 13.713 9.6125 13.9005 9.9125 13.8405C12.2825 13.0455 14 10.7955 14 8.14801C14 4.83301 11.315 2.14801 8 2.14801Z",
        fill: "currentColor"
    }));
const $c73ee3d8462f9525$export$af5de1528a078112 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("mask", {
            id: "mask0_1701_19689",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20"
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M20 0H0V20H20V0Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement("g", {
            mask: "url(#mask0_1701_19689)"
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
            fill: "#036C70"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
            fill: "#1A9BA1"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
            fill: "#37C6D0"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            opacity: "0.1",
            d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
            fill: "black"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            opacity: "0.2",
            d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
            fill: "#04868B"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.label) {
        t2 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, t0, t1);
        $[2] = props.label;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": props.label
    }, /*#__PURE__*/ $cozmU.createElement("mask", {
        id: "mask0_1701_19689",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M20 0H0V20H20V0Z",
        fill: "white"
    })), /*#__PURE__*/ $cozmU.createElement("g", {
        mask: "url(#mask0_1701_19689)"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        opacity: "0.1",
        d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
        fill: "black"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        opacity: "0.2",
        d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        opacity: "0.2",
        d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        opacity: "0.2",
        d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
        fill: "white"
    })));


const $92c29915f34e04be$var$styles = {
    actionCardWrapper: "_30huDKOeNX _0bjKvDyzSk",
    actionCardWrapperBorder: "_0bjKvDyzSk _30huDKOeNX",
    actionCardHeader: "_1x1D3gOeNX _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    actionCardHeaderCollapsed: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    actionCardContentWrapper: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    actionCardFooter: "_2bqfgdOeNX _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    actionCardFooterOuterMargin: "_3138428HPE _1DCdHiB0rP",
    titleBold: "_2sNsIgEqul"
};
const $92c29915f34e04be$var$getChevronIcon = (isExpanded, invertChevron)=>{
    if (invertChevron) return isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT)));
    return isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
};
const $92c29915f34e04be$var$renderTitle = (title, isTitleBold)=>{
    if (isTitleBold) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $92c29915f34e04be$var$styles.titleBold
    }, title);
    return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, title);
};
const $92c29915f34e04be$export$2061af696e09df60 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { title: title, subtitle: subtitle, product: product, children: children, isExpandable: t1, defaultExpanded: t2, isTitleBold: t3, headerIcon: headerIcon, headerActionIcon: headerActionIcon, invertChevron: t4 } = t0;
    const isExpandable = t1 === undefined ? false : t1;
    const defaultExpanded = t2 === undefined ? true : t2;
    const isTitleBold = t3 === undefined ? false : t3;
    const invertChevron = t4 === undefined ? false : t4;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldShowContent = !isExpandable || isExpanded;
    let t5;
    if ($[0] !== subtitle) {
        t5 = subtitle && ((0, $iDrrr.fg)("ai_features_in_icp_m1") || (0, $iDrrr.fg)("rovo_chat_enable_tasks"));
        $[0] = subtitle;
        $[1] = t5;
    } else t5 = $[1];
    const showSubtitle = Boolean(t5);
    let t6;
    if ($[2] !== formatMessage || $[3] !== headerActionIcon || $[4] !== headerIcon || $[5] !== invertChevron || $[6] !== isExpandable || $[7] !== isExpanded || $[8] !== isTitleBold || $[9] !== product || $[10] !== shouldShowContent || $[11] !== showSubtitle || $[12] !== subtitle || $[13] !== title) {
        t6 = title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: !shouldShowContent && (0, $iDrrr.fg)("rovo_chat_enable_tasks") ? $92c29915f34e04be$var$styles.actionCardHeaderCollapsed : $92c29915f34e04be$var$styles.actionCardHeader
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, headerIcon ?? (0, $c73ee3d8462f9525$export$22a9451e3bf2233f)(product), showSubtitle ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, $92c29915f34e04be$var$renderTitle(title, isTitleBold), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, subtitle)) : $92c29915f34e04be$var$renderTitle(title, isTitleBold)), isExpandable && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, isExpanded && headerActionIcon, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $92c29915f34e04be$var$getChevronIcon(isExpanded, invertChevron),
            label: isExpanded ? formatMessage((0, $e676d7b916aa3038$export$defe85febe8b728c).collapse) : formatMessage((0, $e676d7b916aa3038$export$defe85febe8b728c).expand),
            onClick: ()=>setIsExpanded($92c29915f34e04be$var$_temp)
        }))));
        $[2] = formatMessage;
        $[3] = headerActionIcon;
        $[4] = headerIcon;
        $[5] = invertChevron;
        $[6] = isExpandable;
        $[7] = isExpanded;
        $[8] = isTitleBold;
        $[9] = product;
        $[10] = shouldShowContent;
        $[11] = showSubtitle;
        $[12] = subtitle;
        $[13] = title;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== children || $[16] !== shouldShowContent) {
        t7 = shouldShowContent && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $92c29915f34e04be$var$styles.actionCardContentWrapper
        }, children);
        $[15] = children;
        $[16] = shouldShowContent;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $iDrrr.fg)("rovo_chat_enable_tasks") ? $92c29915f34e04be$var$styles.actionCardWrapper : $92c29915f34e04be$var$styles.actionCardWrapperBorder,
            testId: "action-card-wrapper"
        }, t6, t7);
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ title: title, subtitle: subtitle, product: product, children: children, isExpandable: isExpandable = false, defaultExpanded: defaultExpanded = true, isTitleBold: isTitleBold = false, headerIcon: headerIcon, headerActionIcon: headerActionIcon, invertChevron: invertChevron = false })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldShowContent = !isExpandable || isExpanded;
    const showSubtitle = Boolean(subtitle && ((0, $iDrrr.fg)('ai_features_in_icp_m1') || (0, $iDrrr.fg)('rovo_chat_enable_tasks')));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $iDrrr.fg)('rovo_chat_enable_tasks') ? $92c29915f34e04be$var$styles.actionCardWrapper : $92c29915f34e04be$var$styles.actionCardWrapperBorder,
        testId: "action-card-wrapper"
    }, title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: !shouldShowContent && (0, $iDrrr.fg)('rovo_chat_enable_tasks') ? $92c29915f34e04be$var$styles.actionCardHeaderCollapsed : $92c29915f34e04be$var$styles.actionCardHeader
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, headerIcon ?? (0, $c73ee3d8462f9525$export$22a9451e3bf2233f)(product), showSubtitle ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, $92c29915f34e04be$var$renderTitle(title, isTitleBold), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, subtitle)) : $92c29915f34e04be$var$renderTitle(title, isTitleBold)), isExpandable && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, isExpanded && headerActionIcon, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: $92c29915f34e04be$var$getChevronIcon(isExpanded, invertChevron),
        label: isExpanded ? formatMessage((0, $e676d7b916aa3038$export$defe85febe8b728c).collapse) : formatMessage((0, $e676d7b916aa3038$export$defe85febe8b728c).expand),
        onClick: ()=>setIsExpanded((isExpanded_0)=>!isExpanded_0)
    })))), shouldShowContent && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $92c29915f34e04be$var$styles.actionCardContentWrapper
    }, children));
};
const $92c29915f34e04be$export$60124cef578bfa4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $22YX5.Bleed), {
            inline: "space.150",
            xcss: $92c29915f34e04be$var$styles.actionCardFooterOuterMargin
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $92c29915f34e04be$var$styles.actionCardFooter,
            testId: testId
        }, children));
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $22YX5.Bleed), {
        inline: "space.150",
        xcss: $92c29915f34e04be$var$styles.actionCardFooterOuterMargin
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $92c29915f34e04be$var$styles.actionCardFooter,
        testId: testId
    }, children));
};
function $92c29915f34e04be$var$_temp(isExpanded_0) {
    return !isExpanded_0;
}
module.exports["ActionCardWrapper"] = $92c29915f34e04be$export$2061af696e09df60;
module.exports["ActionCardFooter"] = $92c29915f34e04be$export$60124cef578bfa4;

});

parcelRegister("ijkxh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3bc23dd2dda71d7961123faeb4e223f6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d549ee5876e0bf5c$var$_react = $d549ee5876e0bf5c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d549ee5876e0bf5c$var$_baseNew = $d549ee5876e0bf5c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d549ee5876e0bf5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/roadmap
 * Usage guidance:
 * Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d549ee5876e0bf5c$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d549ee5876e0bf5c$var$_react.default.createElement($d549ee5876e0bf5c$var$_baseNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$d549ee5876e0bf5c$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d549ee5876e0bf5c$var$_default = module.exports.default = $d549ee5876e0bf5c$var$RoadmapIcon;

});

parcelRegister("aNmuJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03386ee74472adda4aa278c7ca8c5e2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dbfedefe5ba5302$var$_react = $7dbfedefe5ba5302$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dbfedefe5ba5302$var$_baseNew = $7dbfedefe5ba5302$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7dbfedefe5ba5302$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tools".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/tools
 * Usage guidance:
 * Known usages: 'Service request' Jira work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dbfedefe5ba5302$var$ToolsIcon = (props)=>/*#__PURE__*/ $7dbfedefe5ba5302$var$_react.default.createElement($7dbfedefe5ba5302$var$_baseNew.default, Object.assign({
        name: "ToolsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 5q0-.093-.006-.185L12.78 6.53a.75.75 0 0 1-1.004.052l-.056-.052-2.25-2.25a.75.75 0 0 1 0-1.06l1.714-1.715a3.5 3.5 0 0 0-3.406 4.864.75.75 0 0 1-.16.823l-5.829 5.83a.84.84 0 0 0 0 1.189l.064.058c.33.27.818.25 1.126-.058l5.74-5.741.088-.088.086-.073a.75.75 0 0 1 .738-.086 3.5 3.5 0 0 0 1.773.254l.162-.023A3.5 3.5 0 0 0 14.5 5m-5.43 5.241 3.97 3.97a.841.841 0 0 0 1.189-1.19L11.2 9.994q-.1.005-.2.006a5 5 0 0 1-1.47-.22zM1.662 1.896l.799 1.586H3.5V2.464l-1.602-.802zM16 5a5 5 0 0 1-3.062 4.61l2.351 2.35a2.34 2.34 0 0 1-3.31 3.311l-3.97-3.97-3.97 3.97a2.34 2.34 0 0 1-3.133.162L.73 15.27a2.34 2.34 0 0 1 0-3.31l5.094-5.095L3.94 4.982H2a.75.75 0 0 1-.67-.413L.08 2.087a.75.75 0 0 1 .14-.867l1-1 .09-.077a.75.75 0 0 1 .775-.064l2.5 1.25.09.054A.75.75 0 0 1 5 2v1.922l1.002 1.002A5 5 0 0 1 12.956.397l.083.041a.75.75 0 0 1 .153 1.18L11.061 3.75l1.188 1.188 2.133-2.131.07-.06a.75.75 0 0 1 1.15.297C15.86 3.646 16 4.307 16 5"/>`
    }, props));
$7dbfedefe5ba5302$var$ToolsIcon.displayName = 'ToolsIcon';
var $7dbfedefe5ba5302$var$_default = module.exports.default = $7dbfedefe5ba5302$var$ToolsIcon;

});

parcelRegister("5hU6h", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9a065852121b818f$var$messages = (0, $kSwu1.defineMessages)({
    completedTitle: {
        id: "ai-mate.message-actions.ask-question.completedTitle",
        defaultMessage: "Your answers"
    },
    completedSubtitle: {
        id: "ai-mate.message-actions.ask-question.completedSubtitle",
        defaultMessage: "{count, plural, one {{count} question} other {{count} questions}}"
    },
    readOnlySummaryTitle: {
        id: "ai-mate.message-actions.ask-question.readOnlySummaryTitle",
        defaultMessage: "Answer question"
    },
    readOnlySummaryMessage: {
        id: "ai-mate.message-actions.ask-question.readOnlySummaryMessage",
        defaultMessage: "Answers are not available in this read-only view."
    },
    customInputPlaceholder: {
        id: "ai-mate.message-actions.ask-question.customInputPlaceholder",
        defaultMessage: "Tell Rovo what to do"
    },
    skipButton: {
        id: "ai-mate.message-actions.ask-question.skipButton",
        defaultMessage: "Skip"
    },
    previousQuestion: {
        id: "ai-mate.message-actions.ask-question.previousQuestion",
        defaultMessage: "Previous question"
    },
    nextQuestion: {
        id: "ai-mate.message-actions.ask-question.nextQuestion",
        defaultMessage: "Next question"
    },
    confirmButton: {
        id: "ai-mate.message-actions.ask-question.confirmButton",
        defaultMessage: "Confirm"
    },
    questionProgress: {
        id: "ai-mate.message-actions.ask-question.questionProgress",
        defaultMessage: "{current}\xA0/\xA0{total}"
    },
    autoAnswerLabel: {
        id: "ai-mate.message-actions.ask-question.autoAnswerLabel",
        defaultMessage: "Let Rovo decide"
    },
    customAnswerLabel: {
        id: "ai-mate.message-actions.ask-question.customAnswerLabel",
        defaultMessage: "Custom Prompt"
    },
    skippedAnswerLabel: {
        id: "ai-mate.message-actions.ask-question.skippedAnswerLabel",
        defaultMessage: "Skipped"
    }
});
var $9a065852121b818f$export$2e2bcd8739ae039 = $9a065852121b818f$var$messages;
module.exports["default"] = $9a065852121b818f$export$2e2bcd8739ae039;

});

parcelRegister("7Fn78", function(module, exports) {

let $594e4ab6c9e0b249$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $594e4ab6c9e0b249$var$load("bcGk8").then(()=>parcelRequire('8h3ax'));

});

parcelRegister("aLUFu", function(module, exports) {

var $ilC9E = parcelRequire("ilC9E");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/project/manifest.ts
var $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ilC9E.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ilC9E.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $7d7a404ac451d38c$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $7d7a404ac451d38c$export$41215e8d01921e7d;

});

parcelRegister("ilC9E", function(module, exports) {
// src/townsquare/project/types.ts
var $d5b7c8e3ddea6aee$export$a258bc824c789b17 = "townsquare", $d5b7c8e3ddea6aee$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $d5b7c8e3ddea6aee$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $d5b7c8e3ddea6aee$export$aa8900dadffaa32a;

});

parcelRegister("QrYx2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c700a4b4555247cec194f8cfd22350e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09da8ec252a65cb4$var$_react = $09da8ec252a65cb4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $09da8ec252a65cb4$var$_baseNew = $09da8ec252a65cb4$var$_interopRequireDefault((parcelRequire("gElAV")));
function $09da8ec252a65cb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/alert
 * Usage guidance:
 * Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09da8ec252a65cb4$var$AlertIcon = (props)=>/*#__PURE__*/ $09da8ec252a65cb4$var$_react.default.createElement($09da8ec252a65cb4$var$_baseNew.default, Object.assign({
        name: "AlertIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$09da8ec252a65cb4$var$AlertIcon.displayName = 'AlertIcon';
var $09da8ec252a65cb4$var$_default = module.exports.default = $09da8ec252a65cb4$var$AlertIcon;

});

parcelRegister("iJxD8", function(module, exports) {

var $15uL0 = parcelRequire("15uL0");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/team/manifest.ts
var $da3684392924794e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $15uL0.IdentityTeamAriResourceOwner),
    resourceType: (0, $15uL0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $da3684392924794e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $1gKSA.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $da3684392924794e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $da3684392924794e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $da3684392924794e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $da3684392924794e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $da3684392924794e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $da3684392924794e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $da3684392924794e$export$33bbb2d79e520118;

});

parcelRegister("15uL0", function(module, exports) {
// src/identity/team/types.ts
var $0cae1dd2c8cb7865$export$49beddf48ffb3f35 = "identity", $0cae1dd2c8cb7865$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $0cae1dd2c8cb7865$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $0cae1dd2c8cb7865$export$b2079a2a841afe32;

});

parcelRegister("aXvOq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $4ez2K = parcelRequire("4ez2K");


var $9DXoL = parcelRequire("9DXoL");


var $gVKzP = parcelRequire("gVKzP");


var $aQL68 = parcelRequire("aQL68");

const $e8d96f9ece7c689a$var$styles = {
    containerWithBorder: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _2Y7lL41Y8M _4c065UFQfX _39xV02E6Kk"
}; /**
    * Displays a team's information inline with an avatar, team name, optional description, and status badges.
    * Use this component to show team details in a compact format within lists, cards, or other UI elements.
    */ 
const $e8d96f9ece7c689a$export$9c73d505931d9c13 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamInlinePreview(props) {
    const $ = (0, $bDgLe.c)(19);
    let t0;
    if ($[0] !== props.avatarSize || $[1] !== props.hideAvatar || $[2] !== props.overrideAvatarUrl) {
        t0 = props.hideAvatar ? null : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gVKzP.Avatar), {
            src: props.overrideAvatarUrl,
            size: props.avatarSize
        });
        $[0] = props.avatarSize;
        $[1] = props.hideAvatar;
        $[2] = props.overrideAvatarUrl;
        $[3] = t0;
    } else t0 = $[3];
    let t1;
    if ($[4] !== props.description || $[5] !== props.showType || $[6] !== props.teamName || $[7] !== props.teamType) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aQL68.TeamContent), {
            teamName: props.teamName,
            description: props.description,
            teamType: props.teamType,
            showType: props.showType
        });
        $[4] = props.description;
        $[5] = props.showType;
        $[6] = props.teamName;
        $[7] = props.teamType;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== props.isArchived || $[10] !== props.isVerified || $[11] !== props.preserveBadges || $[12] !== props.showBorder || $[13] !== props.singleLine || $[14] !== props.teamId || $[15] !== props.testId || $[16] !== t0 || $[17] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsxs)($e8d96f9ece7c689a$var$TeamInlinePreviewProvider, {
            teamId: props.teamId,
            testId: props.testId,
            isVerified: props.isVerified,
            isArchived: props.isArchived,
            singleLine: props.singleLine,
            preserveBadges: props.preserveBadges,
            showBorder: props.showBorder,
            children: [
                t0,
                t1
            ]
        });
        $[9] = props.isArchived;
        $[10] = props.isVerified;
        $[11] = props.preserveBadges;
        $[12] = props.showBorder;
        $[13] = props.singleLine;
        $[14] = props.teamId;
        $[15] = props.testId;
        $[16] = t0;
        $[17] = t1;
        $[18] = t2;
    } else t2 = $[18];
    return t2;
} : function TeamInlinePreview(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($e8d96f9ece7c689a$var$TeamInlinePreviewProvider, {
        teamId: props.teamId,
        testId: props.testId,
        isVerified: props.isVerified,
        isArchived: props.isArchived,
        singleLine: props.singleLine,
        preserveBadges: props.preserveBadges,
        showBorder: props.showBorder,
        children: [
            props.hideAvatar ? null : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gVKzP.Avatar), {
                src: props.overrideAvatarUrl,
                size: props.avatarSize
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aQL68.TeamContent), {
                teamName: props.teamName,
                description: props.description,
                teamType: props.teamType,
                showType: props.showType
            })
        ]
    });
};
const $e8d96f9ece7c689a$var$TeamInlinePreviewProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamInlinePreviewProvider(t0) {
    const $ = (0, $bDgLe.c)(19);
    const { teamId: teamId, testId: testIdPrefix, isVerified: t1, isArchived: t2, singleLine: t3, preserveBadges: t4, showBorder: t5, children: children } = t0;
    const isVerified = t1 === undefined ? false : t1;
    const isArchived = t2 === undefined ? false : t2;
    const singleLine = t3 === undefined ? true : t3;
    const preserveBadges = t4 === undefined ? true : t4;
    const showBorder = t5 === undefined ? false : t5;
    const testId = `team-inline-preview-${teamId}`;
    const providerTestId = `${testId}${testIdPrefix ? `--${testIdPrefix}` : ""}`;
    let t6;
    if ($[0] !== testId || $[1] !== testIdPrefix) {
        t6 = (suffix)=>testId ? `${testId}-${suffix}${testIdPrefix ? `--${testIdPrefix}` : ""}` : undefined;
        $[0] = testId;
        $[1] = testIdPrefix;
        $[2] = t6;
    } else t6 = $[2];
    const getTestId = t6;
    const t7 = showBorder && $e8d96f9ece7c689a$var$styles.containerWithBorder;
    let t8;
    if ($[3] !== t7) {
        t8 = (0, $w6R6I.cx)(t7);
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    let t9;
    if ($[5] !== getTestId || $[6] !== isArchived || $[7] !== isVerified || $[8] !== preserveBadges || $[9] !== singleLine || $[10] !== teamId) {
        t9 = {
            teamId: teamId,
            isVerified: isVerified,
            isArchived: isArchived,
            singleLine: singleLine,
            preserveBadges: preserveBadges,
            getTestId: getTestId
        };
        $[5] = getTestId;
        $[6] = isArchived;
        $[7] = isVerified;
        $[8] = preserveBadges;
        $[9] = singleLine;
        $[10] = teamId;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== children || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9DXoL.TeamInlinePreviewContext).Provider, {
            value: t9,
            children: children
        });
        $[12] = children;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== providerTestId || $[16] !== t10 || $[17] !== t8) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            gap: "space.100",
            alignItems: "center",
            testId: providerTestId,
            xcss: t8,
            children: t10
        });
        $[15] = providerTestId;
        $[16] = t10;
        $[17] = t8;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
} : function TeamInlinePreviewProvider({ teamId: teamId, testId: testIdPrefix, isVerified: isVerified = false, isArchived: isArchived = false, singleLine: singleLine = true, preserveBadges: preserveBadges = true, showBorder: showBorder = false, children: children }) {
    const testId = `team-inline-preview-${teamId}`;
    const providerTestId = `${testId}${testIdPrefix ? `--${testIdPrefix}` : ''}`;
    const getTestId = (suffix)=>testId ? `${testId}-${suffix}${testIdPrefix ? `--${testIdPrefix}` : ''}` : undefined;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        gap: "space.100",
        alignItems: "center",
        testId: providerTestId,
        xcss: (0, $w6R6I.cx)(showBorder && $e8d96f9ece7c689a$var$styles.containerWithBorder),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9DXoL.TeamInlinePreviewContext).Provider, {
            value: {
                teamId: teamId,
                isVerified: isVerified,
                isArchived: isArchived,
                singleLine: singleLine,
                preserveBadges: preserveBadges,
                getTestId: getTestId
            },
            children: children
        })
    });
};
module.exports["TeamInlinePreview"] = $e8d96f9ece7c689a$export$9c73d505931d9c13;

});

parcelRegister("9DXoL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $61698f28cf198283$export$1408dcf6f618920b = /*#__PURE__*/ (0, $cozmU.createContext)({
    teamId: '',
    isVerified: false,
    isArchived: false,
    singleLine: false,
    preserveBadges: true,
    getTestId: ()=>undefined
});
module.exports["TeamInlinePreviewContext"] = $61698f28cf198283$export$1408dcf6f618920b;

});

parcelRegister("gVKzP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2c3Eq = parcelRequire("2c3Eq");


var $9DXoL = parcelRequire("9DXoL");

/**
 * Internal component that renders the team avatar using TeamsAvatar.
 * Automatically pulls teamId from context and uses the provided size or defaults to small.
 */ const $82263acfbdbd85a4$export$e2255cf6045e8d47 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Avatar(props) {
    const $ = (0, $bDgLe.c)(7);
    const { teamId: teamId, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const t0 = props.size ?? "small";
    let t1;
    if ($[0] !== getTestId) {
        t1 = getTestId("avatar");
        $[0] = getTestId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props || $[3] !== t0 || $[4] !== t1 || $[5] !== teamId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2c3Eq.default), {
            ...props,
            teamId: teamId,
            size: t0,
            testId: t1
        });
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
        $[5] = teamId;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function Avatar(props) {
    const { teamId: teamId, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2c3Eq.default), {
        ...props,
        teamId: teamId,
        size: props.size ?? 'small',
        testId: getTestId('avatar')
    });
};
module.exports["Avatar"] = $82263acfbdbd85a4$export$e2255cf6045e8d47;

});

parcelRegister("2c3Eq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");

var $arQY7 = parcelRequire("arQY7");


var $iDrrr = parcelRequire("iDrrr");


var $3VIRc = parcelRequire("3VIRc");

const $402d6e8638203e24$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $402d6e8638203e24$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
const $402d6e8638203e24$var$TeamAvatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamAvatar(t0) {
    const $ = (0, $bDgLe.c)(31);
    let props;
    let src;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ testId: testId, src: src, size: t1, teamId: t2, compact: t3, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = src;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = testId;
    } else {
        props = $[1];
        src = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        testId = $[6];
    }
    const size = t1 === undefined ? "medium" : t1;
    let teamId = t2 === undefined ? "" : t2;
    const compact = t3 === undefined ? false : t3;
    let t4;
    if ($[7] !== teamId) {
        t4 = teamId.replace("ari:cloud:identity::team/", "");
        $[7] = teamId;
        $[8] = t4;
    } else t4 = $[8];
    teamId = t4;
    if ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t5 = `${testId}-team-avatar`;
        let t6;
        if ($[9] !== size || $[10] !== src || $[11] !== teamId || $[12] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7zsi1.AvatarContent), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
                    src: src,
                    size: size,
                    testId: testId,
                    teamId: teamId
                }, teamId)
            });
            $[9] = size;
            $[10] = src;
            $[11] = teamId;
            $[12] = testId;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== props || $[15] !== size || $[16] !== t5 || $[17] !== t6) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                ...props,
                appearance: "square",
                size: size,
                testId: t5,
                children: t6
            });
            $[14] = props;
            $[15] = size;
            $[16] = t5;
            $[17] = t6;
            $[18] = t7;
        } else t7 = $[18];
        return t7;
    }
    const t5 = `${testId}-team-avatar`;
    let t6;
    if ($[19] !== compact || $[20] !== size || $[21] !== src || $[22] !== teamId || $[23] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        });
        $[19] = compact;
        $[20] = size;
        $[21] = src;
        $[22] = teamId;
        $[23] = testId;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== props || $[26] !== size || $[27] !== src || $[28] !== t5 || $[29] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            appearance: "square",
            ...props,
            size: size,
            src: src,
            testId: t5,
            children: t6
        });
        $[25] = props;
        $[26] = size;
        $[27] = src;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : function TeamAvatar({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    if ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7zsi1.AvatarContent), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                teamId: teamId
            }, teamId)
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3VIRc.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
};
var $402d6e8638203e24$export$2e2bcd8739ae039 = $402d6e8638203e24$var$TeamAvatar;
module.exports["default"] = $402d6e8638203e24$export$2e2bcd8739ae039;

});

parcelRegister("3VIRc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $giWSb = parcelRequire("giWSb");


var $l5WTV = parcelRequire("l5WTV");


var $5jzbe = parcelRequire("5jzbe");

const $e9b0094c91a8ccec$var$boxShadowCssVar = '--avatar-box-shadow';
const $e9b0094c91a8ccec$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $e9b0094c91a8ccec$var$containerStyles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _1VJPcaeKTE _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XjOvk _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa",
    nonCompactSpacing: "_0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX",
    compactSpacing: "_0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg",
    circle: "_0bjKvDaaQb _2Gfj6iaaQb",
    positionRelative: "_1mT5xdRAKS",
    disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const $e9b0094c91a8ccec$var$unboundStyles = {
    root: "_24h04iPvdi _0KLXruVZWJ _2OUyjtrcoi",
    interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu"
};
const $e9b0094c91a8ccec$var$avatarImageStyles = {
    image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d"
};
const $e9b0094c91a8ccec$var$SIZES = {
    xxsmall: 16,
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $e9b0094c91a8ccec$var$borderRadiusMap = {
    xxsmall: "_0bjKvD0O7w",
    xsmall: "_0bjKvD0O7w",
    small: "_0bjKvD0O7w",
    medium: "_0bjKvD0O7w",
    large: "_0bjKvD0O7w",
    xlarge: "_0bjKvD0O7w",
    xxlarge: "_0bjKvD0O7w"
};
const $e9b0094c91a8ccec$var$widthHeightMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $e9b0094c91a8ccec$export$ac3673635a5387be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { alt: t1, src: src, size: size, testId: testId, teamId: teamId, compact: t2 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const compact = t2 === undefined ? false : t2;
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] !== src || $[1] !== teamId) {
        t3 = (0, $5jzbe.getTeamAvatarSrc)(src, teamId);
        $[0] = src;
        $[1] = teamId;
        $[2] = t3;
    } else t3 = $[2];
    const avatarSrc = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) return;
            setHasImageErrored(false);
        };
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== avatarSrc) {
        t5 = [
            avatarSrc
        ];
        $[4] = avatarSrc;
        $[5] = t5;
    } else t5 = $[5];
    (0, $cozmU.useEffect)(t4, t5);
    if ((!avatarSrc || hasImageErrored) && !(0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t6 = $e9b0094c91a8ccec$var$SIZES[size];
        const t7 = $e9b0094c91a8ccec$var$SIZES[size];
        let t8;
        if ($[6] !== alt || $[7] !== compact || $[8] !== t6 || $[9] !== t7 || $[10] !== testId) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $giWSb.FallbackAvatar), {
                "aria-label": alt,
                width: t6,
                height: t7,
                "data-testid": testId,
                compact: compact
            });
            $[6] = alt;
            $[7] = compact;
            $[8] = t6;
            $[9] = t7;
            $[10] = testId;
            $[11] = t8;
        } else t8 = $[11];
        return t8;
    }
    if ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const resolvedSrc = hasImageErrored ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        const t6 = testId && `${testId}--image`;
        let t7;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = ()=>setHasImageErrored(true);
            $[12] = t7;
        } else t7 = $[12];
        let t8;
        if ($[13] !== alt || $[14] !== resolvedSrc || $[15] !== t6) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "img",
                src: resolvedSrc,
                alt: alt,
                testId: t6,
                xcss: $e9b0094c91a8ccec$var$avatarImageStyles.image,
                onError: t7
            });
            $[13] = alt;
            $[14] = resolvedSrc;
            $[15] = t6;
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    const t6 = $e9b0094c91a8ccec$var$borderRadiusMap[size];
    const t7 = $e9b0094c91a8ccec$var$widthHeightMap[size];
    const t8 = compact ? $e9b0094c91a8ccec$var$containerStyles.compactSpacing : $e9b0094c91a8ccec$var$containerStyles.nonCompactSpacing;
    let t9;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$unboundStyles.root,
            $e9b0094c91a8ccec$var$containerStyles.root,
            t6,
            t7,
            t8
        ]);
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    const t10 = testId && `${testId}--image`;
    let t11;
    let t12;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>setHasImageErrored(true);
        t12 = (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$avatarImageStyles.image
        ]);
        $[21] = t11;
        $[22] = t12;
    } else {
        t11 = $[21];
        t12 = $[22];
    }
    let t13;
    if ($[23] !== alt || $[24] !== avatarSrc || $[25] !== t10) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": t10,
            onError: t11,
            className: t12
        });
        $[23] = alt;
        $[24] = avatarSrc;
        $[25] = t10;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== alt || $[28] !== t13 || $[29] !== t9 || $[30] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            "aria-label": alt,
            className: t9,
            children: t13
        });
        $[27] = alt;
        $[28] = t13;
        $[29] = t9;
        $[30] = testId;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    const avatarSrc = (0, $5jzbe.getTeamAvatarSrc)(src, teamId);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) return;
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if ((!avatarSrc || hasImageErrored) && !(0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $giWSb.FallbackAvatar), {
        "aria-label": alt,
        width: $e9b0094c91a8ccec$var$SIZES[size],
        height: $e9b0094c91a8ccec$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    if ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences')) {
        const resolvedSrc = hasImageErrored ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "img",
            src: resolvedSrc,
            alt: alt,
            testId: testId && `${testId}--image`,
            xcss: $e9b0094c91a8ccec$var$avatarImageStyles.image,
            onError: ()=>setHasImageErrored(true)
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$unboundStyles.root,
            $e9b0094c91a8ccec$var$containerStyles.root,
            $e9b0094c91a8ccec$var$borderRadiusMap[size],
            $e9b0094c91a8ccec$var$widthHeightMap[size],
            compact ? $e9b0094c91a8ccec$var$containerStyles.compactSpacing : $e9b0094c91a8ccec$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hekY6.default)([
                $e9b0094c91a8ccec$var$avatarImageStyles.image
            ])
        })
    });
};
module.exports["TeamAvatarImage"] = $e9b0094c91a8ccec$export$ac3673635a5387be;

});

parcelRegister("giWSb", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $fd19101f9abb11e9$var$styles = {
    wrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbQ4SZ",
    wrapperSpacing: "_313842FQfX _0adFHsFQfX _1DCdHiFQfX _2XsHFMFQfX",
    compactWrapperSpacing: "_313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg"
};
const $fd19101f9abb11e9$export$eb63dcc490f6bbcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FallbackAvatar(t0) {
    const $ = (0, $bDgLe.c)(12);
    let compact;
    let props;
    if ($[0] !== t0) {
        ({ compact: compact, ...props } = t0);
        $[0] = t0;
        $[1] = compact;
        $[2] = props;
    } else {
        compact = $[1];
        props = $[2];
    }
    const t1 = compact ? $fd19101f9abb11e9$var$styles.compactWrapperSpacing : $fd19101f9abb11e9$var$styles.wrapperSpacing;
    let t2;
    if ($[3] !== t1) {
        t2 = (0, $w6R6I.cx)($fd19101f9abb11e9$var$styles.wrapper, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            clipPath: "url(#clip0_2032_552)",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "4",
                    fill: "#DCDFE4"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                    fill: "#44546F"
                })
            ]
        });
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                id: "clip0_2032_552",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "4",
                    fill: "white"
                })
            })
        });
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== props) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                t3,
                t4
            ]
        });
        $[7] = props;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t2 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t2,
            children: t5
        });
        $[9] = t2;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : function FallbackAvatar({ compact: compact, ...props }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fd19101f9abb11e9$var$styles.wrapper, compact ? $fd19101f9abb11e9$var$styles.compactWrapperSpacing : $fd19101f9abb11e9$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};
module.exports["FallbackAvatar"] = $fd19101f9abb11e9$export$eb63dcc490f6bbcd;

});

parcelRegister("l5WTV", function(module, exports) {
const $ef1de21fbce43fe8$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;
module.exports["TEAM_FALLBACK_AVATAR_DATA_URI"] = $ef1de21fbce43fe8$export$215bd25cfab1a96;

});

parcelRegister("5jzbe", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $l5WTV = parcelRequire("l5WTV");

function $b576d3f3fb082ae0$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return (0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences') ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : undefined;
}
module.exports["getTeamAvatarSrc"] = $b576d3f3fb082ae0$export$59ff7d19feb890b6;

});

parcelRegister("aQL68", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aRrFB = parcelRequire("aRrFB");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $bqCUt = parcelRequire("bqCUt");


var $f4S7L = parcelRequire("f4S7L");


var $aZiZL = parcelRequire("aZiZL");


var $56sl1 = parcelRequire("56sl1");


var $kHcM6 = parcelRequire("kHcM6");

/**
 * Internal component that renders the team name and optional secondary text.
 * Handles truncation detection and conditionally displays verified/archived badges.
 */ const $97becf6b74b92417$export$3f630d5b5095f120 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamContent(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { teamName: teamName, description: description, teamType: teamType, showType: t1 } = t0;
    const showType = t1 === undefined ? false : t1;
    const shouldShowType = Boolean(showType && teamType);
    const t2 = !shouldShowType;
    let t3;
    if ($[0] !== t2) {
        t3 = {
            showVerifiedBadge: t2,
            showArchivedBadge: true
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const { elementRef: teamNameRef, showVerified: showVerifiedWithName, showArchived: showArchived } = (0, $bqCUt.useShowBadges)(t3);
    let t4;
    if ($[2] !== shouldShowType) {
        t4 = {
            showVerifiedBadge: shouldShowType,
            showArchivedBadge: false
        };
        $[2] = shouldShowType;
        $[3] = t4;
    } else t4 = $[3];
    const { elementRef: teamTypeRef, showVerified: showVerifiedWithType } = (0, $bqCUt.useShowBadges)(t4);
    if (!teamName && !description && !shouldShowType) return null;
    let t5;
    if ($[4] !== showArchived || $[5] !== showVerifiedWithName || $[6] !== teamName || $[7] !== teamNameRef) {
        t5 = teamName ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $56sl1.TeamName), {
                    teamName: teamName,
                    elementRef: teamNameRef
                }),
                showVerifiedWithName ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRrFB.VerifiedTeamIcon), {}) : null,
                showArchived ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4S7L.ArchivedLozenge), {}) : null
            ]
        }) : null;
        $[4] = showArchived;
        $[5] = showVerifiedWithName;
        $[6] = teamName;
        $[7] = teamNameRef;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== description || $[10] !== shouldShowType || $[11] !== showVerifiedWithType || $[12] !== teamType || $[13] !== teamTypeRef) {
        t6 = shouldShowType ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kHcM6.TeamType), {
            teamType: teamType,
            elementRef: teamTypeRef,
            showVerified: showVerifiedWithType
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aZiZL.Description), {
            description: description
        });
        $[9] = description;
        $[10] = shouldShowType;
        $[11] = showVerifiedWithType;
        $[12] = teamType;
        $[13] = teamTypeRef;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            children: [
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : function TeamContent({ teamName: teamName, description: description, teamType: teamType, showType: showType = false }) {
    const shouldShowType = Boolean(showType && teamType);
    const { elementRef: teamNameRef, showVerified: showVerifiedWithName, showArchived: showArchived } = (0, $bqCUt.useShowBadges)({
        showVerifiedBadge: !shouldShowType,
        showArchivedBadge: true
    });
    const { elementRef: teamTypeRef, showVerified: showVerifiedWithType } = (0, $bqCUt.useShowBadges)({
        showVerifiedBadge: shouldShowType,
        showArchivedBadge: false
    });
    if (!teamName && !description && !shouldShowType) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        children: [
            teamName ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.025",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $56sl1.TeamName), {
                        teamName: teamName,
                        elementRef: teamNameRef
                    }),
                    showVerifiedWithName ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRrFB.VerifiedTeamIcon), {}) : null,
                    showArchived ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4S7L.ArchivedLozenge), {}) : null
                ]
            }) : null,
            shouldShowType ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kHcM6.TeamType), {
                teamType: teamType,
                elementRef: teamTypeRef,
                showVerified: showVerifiedWithType
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aZiZL.Description), {
                description: description
            })
        ]
    });
};
module.exports["TeamContent"] = $97becf6b74b92417$export$3f630d5b5095f120;

});

parcelRegister("aRrFB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d2UzA = parcelRequire("d2UzA");


var $lpNn5 = parcelRequire("lpNn5");


var $2rxeJ = parcelRequire("2rxeJ");

const $c118d249a8b39a96$export$d7949f68d31e5edd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: t2, spacing: t3 } = t0;
    const label = t1 === undefined ? "Verified Team" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const spacing = t3 === undefined ? "spacious" : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] !== customTooltipContent || $[1] !== formatMessage || $[2] !== showTooltip) {
        t4 = showTooltip ? customTooltipContent || formatMessage((0, $2rxeJ.messages).verifiedIconDefaultTooltip) : undefined;
        $[0] = customTooltipContent;
        $[1] = formatMessage;
        $[2] = showTooltip;
        $[3] = t4;
    } else t4 = $[3];
    const tooltipContent = t4;
    let t5;
    if ($[4] !== label || $[5] !== size || $[6] !== spacing || $[7] !== tooltipContent) {
        t5 = tooltipContent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                tabIndex: 0,
                role: "button",
                "data-testid": "verified-team-icon",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                        color: "var(--ds-icon-accent-blue, #357DE8)",
                        size: size,
                        label: tooltipContent,
                        spacing: spacing
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            size: size,
            spacing: spacing,
            label: label
        });
        $[4] = label;
        $[5] = size;
        $[6] = spacing;
        $[7] = tooltipContent;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $2rxeJ.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                    color: "var(--ds-icon-accent-blue, #357DE8)",
                    size: size,
                    label: tooltipContent,
                    spacing: spacing
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
module.exports["VerifiedTeamIcon"] = $c118d249a8b39a96$export$d7949f68d31e5edd;

});

parcelRegister("2rxeJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a8f8527678b71e0e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: "ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip",
        defaultMessage: "This team is verified because it can only be changed by admin."
    }
});
module.exports["messages"] = $a8f8527678b71e0e$export$defe85febe8b728c;

});

parcelRegister("bqCUt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DXoL = parcelRequire("9DXoL");


var $f4S7L = parcelRequire("f4S7L");


var $4qCxJ = parcelRequire("4qCxJ");

/**
 * Hook that determines whether to display verified and archived badges.
 * Uses truncation detection to conditionally hide badges when text is truncated,
 * unless preserveBadges is enabled in the context.
 */ const $0957676fb71c2b35$export$2a515b2ffa38dd05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useShowBadges(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { showVerifiedBadge: showVerifiedBadge, showArchivedBadge: showArchivedBadge } = t0;
    const { isArchived: isArchived, isVerified: isVerified, preserveBadges: preserveBadges } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasVerified = Boolean(isVerified && showVerifiedBadge);
    const hasArchived = Boolean(isArchived && showArchivedBadge);
    let t1;
    if ($[0] !== formatMessage || $[1] !== hasArchived) {
        t1 = hasArchived ? formatMessage((0, $f4S7L.messages).archived) : "";
        $[0] = formatMessage;
        $[1] = hasArchived;
        $[2] = t1;
    } else t1 = $[2];
    const archivedText = t1;
    let t2;
    if ($[3] !== archivedText || $[4] !== hasArchived || $[5] !== hasVerified) {
        t2 = {
            hasVerified: hasVerified,
            hasArchived: hasArchived,
            archivedText: archivedText
        };
        $[3] = archivedText;
        $[4] = hasArchived;
        $[5] = hasVerified;
        $[6] = t2;
    } else t2 = $[6];
    const { elementRef: elementRef, isTruncated: isTruncated } = (0, $4qCxJ.useTruncationDetection)(t2);
    const canShowBadges = preserveBadges || !isTruncated;
    const showVerified = hasVerified && canShowBadges;
    const showArchived = hasArchived && canShowBadges;
    let t3;
    if ($[7] !== elementRef || $[8] !== showArchived || $[9] !== showVerified) {
        t3 = {
            elementRef: elementRef,
            showVerified: showVerified,
            showArchived: showArchived
        };
        $[7] = elementRef;
        $[8] = showArchived;
        $[9] = showVerified;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function useShowBadges({ showVerifiedBadge: showVerifiedBadge, showArchivedBadge: showArchivedBadge }) {
    const { isArchived: isArchived, isVerified: isVerified, preserveBadges: preserveBadges } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasVerified = Boolean(isVerified && showVerifiedBadge);
    const hasArchived = Boolean(isArchived && showArchivedBadge);
    // Get the translated archived text for width calculation
    const archivedText = hasArchived ? formatMessage((0, $f4S7L.messages).archived) : '';
    const { elementRef: elementRef, isTruncated: isTruncated } = (0, $4qCxJ.useTruncationDetection)({
        hasVerified: hasVerified,
        hasArchived: hasArchived,
        archivedText: archivedText
    });
    const canShowBadges = preserveBadges || !isTruncated;
    const showVerified = hasVerified && canShowBadges;
    const showArchived = hasArchived && canShowBadges;
    return {
        elementRef: elementRef,
        showVerified: showVerified,
        showArchived: showArchived
    };
};
module.exports["useShowBadges"] = $0957676fb71c2b35$export$2a515b2ffa38dd05;

});

parcelRegister("f4S7L", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $iMnC5 = parcelRequire("iMnC5");


var $9DXoL = parcelRequire("9DXoL");

const $a8bd590272dc8fc5$var$styles = {
    lozengeWrapper: "_3iDTPbQ4SZ _2Zuz6Q1Y8M"
}; /**
    * Internal component that renders the "Archived" lozenge badge.
    * Conditionally wraps in Box based on preserveBadges setting for layout purposes.
    */ 
const $a8bd590272dc8fc5$export$4e78ca9595e429a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ArchivedLozenge() {
    const $ = (0, $bDgLe.c)(8);
    const { preserveBadges: preserveBadges, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    let t0;
    if ($[0] !== getTestId) {
        t0 = getTestId("archived-lozenge");
        $[0] = getTestId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            ...$a8bd590272dc8fc5$export$defe85febe8b728c.archived
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t0) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
            testId: t0,
            children: t1
        });
        $[3] = t0;
        $[4] = t2;
    } else t2 = $[4];
    const lozenge = t2;
    let t3;
    if ($[5] !== lozenge || $[6] !== preserveBadges) {
        t3 = preserveBadges ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a8bd590272dc8fc5$var$styles.lozengeWrapper,
            children: lozenge
        }) : lozenge;
        $[5] = lozenge;
        $[6] = preserveBadges;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function ArchivedLozenge() {
    const { preserveBadges: preserveBadges, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const lozenge = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
        testId: getTestId('archived-lozenge'),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            ...$a8bd590272dc8fc5$export$defe85febe8b728c.archived
        })
    });
    return preserveBadges ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a8bd590272dc8fc5$var$styles.lozengeWrapper,
        children: lozenge
    }) : lozenge;
};
const $a8bd590272dc8fc5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    archived: {
        id: "team-inline.archived",
        defaultMessage: "Archived"
    }
});
module.exports["ArchivedLozenge"] = $a8bd590272dc8fc5$export$4e78ca9595e429a7;
module.exports["messages"] = $a8bd590272dc8fc5$export$defe85febe8b728c;

});

parcelRegister("4qCxJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// Verified icon is a fixed-size SVG (24px icon + ~4px gap from Inline space)
const $e786aa223a5a569b$var$VERIFIED_ICON_WIDTH = 28;
// Lozenge has ~8px horizontal padding on each side + ~4px gap from Inline space
const $e786aa223a5a569b$var$LOZENGE_PADDING = 20;
const $e786aa223a5a569b$var$RESIZE_DEBOUNCE_MS = 50;
// Reusable canvas for text measurement (created lazily, cached)
let $e786aa223a5a569b$var$measureCanvas = null;
/**
 * Detects if an element's content would be truncated when badges are present.
 *
 * Instead of detecting current truncation (which causes feedback loops when badges
 * toggle), we calculate whether text + badges would fit in the available space.
 * Uses Canvas API to measure badge text width without rendering duplicate elements.
 *
 * Features:
 * - SSR safe (returns false during server-side rendering)
 * - Debounced resize handling to prevent excessive calculations
 * - Cached canvas instance for text measurement
 */ const $e786aa223a5a569b$export$16ec983cba4cfc6d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useTruncationDetection(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { hasVerified: hasVerified, hasArchived: hasArchived, archivedText: archivedText } = t0;
    const elementRef = (0, $cozmU.useRef)(null);
    const [isTruncated, setIsTruncated] = (0, $cozmU.useState)(false);
    const lastContainerWidth = (0, $cozmU.useRef)(0);
    const debounceTimeoutRef = (0, $cozmU.useRef)(null);
    const hasBadges = hasVerified || hasArchived;
    let t1;
    let t2;
    if ($[0] !== archivedText || $[1] !== hasArchived || $[2] !== hasBadges || $[3] !== hasVerified) {
        t1 = ()=>{
            if (!hasBadges) {
                setIsTruncated(false);
                return;
            }
            if (typeof document === "undefined") return;
            const element = elementRef.current;
            const container = element?.parentElement?.parentElement;
            if (!element || !container) return;
            let badgeWidth = 0;
            if (hasVerified) {
                badgeWidth = badgeWidth + $e786aa223a5a569b$var$VERIFIED_ICON_WIDTH;
                badgeWidth;
            }
            if (hasArchived && archivedText) {
                const computedStyle = getComputedStyle(element);
                const lozengeFont = `600 11px ${computedStyle.fontFamily}`;
                const textWidth = $e786aa223a5a569b$var$measureTextWidth(archivedText, lozengeFont);
                badgeWidth = badgeWidth + (textWidth + $e786aa223a5a569b$var$LOZENGE_PADDING);
                badgeWidth;
            }
            const checkTruncation = ()=>{
                const containerWidth = container.clientWidth;
                if (containerWidth === lastContainerWidth.current && lastContainerWidth.current !== 0) return;
                lastContainerWidth.current = containerWidth;
                const range = document.createRange();
                range.selectNodeContents(element);
                const textWidth_0 = range.getBoundingClientRect().width;
                const wouldTruncateWithBadges = textWidth_0 + badgeWidth > containerWidth;
                setIsTruncated(wouldTruncateWithBadges);
            };
            const debouncedCheckTruncation = ()=>{
                if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
                debounceTimeoutRef.current = setTimeout(checkTruncation, $e786aa223a5a569b$var$RESIZE_DEBOUNCE_MS);
            };
            const resizeObserver = new ResizeObserver(debouncedCheckTruncation);
            resizeObserver.observe(container);
            checkTruncation();
            return ()=>{
                resizeObserver.disconnect();
                if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
            };
        };
        t2 = [
            hasBadges,
            hasVerified,
            hasArchived,
            archivedText
        ];
        $[0] = archivedText;
        $[1] = hasArchived;
        $[2] = hasBadges;
        $[3] = hasVerified;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[6] !== isTruncated) {
        t3 = {
            elementRef: elementRef,
            isTruncated: isTruncated
        };
        $[6] = isTruncated;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function useTruncationDetection({ hasVerified: hasVerified, hasArchived: hasArchived, archivedText: archivedText }) {
    const elementRef = (0, $cozmU.useRef)(null);
    const [isTruncated, setIsTruncated] = (0, $cozmU.useState)(false);
    const lastContainerWidth = (0, $cozmU.useRef)(0);
    const debounceTimeoutRef = (0, $cozmU.useRef)(null);
    const hasBadges = hasVerified || hasArchived;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!hasBadges) {
            setIsTruncated(false);
            return;
        }
        // SSR safety check
        if (typeof document === 'undefined') return;
        const element = elementRef.current;
        // Get stable container (grandparent - Stack) that doesn't change with badges
        const container = element?.parentElement?.parentElement;
        if (!element || !container) return;
        let badgeWidth = 0;
        if (hasVerified) badgeWidth += $e786aa223a5a569b$var$VERIFIED_ICON_WIDTH;
        if (hasArchived && archivedText) {
            const computedStyle = getComputedStyle(element);
            const lozengeFont = `600 11px ${computedStyle.fontFamily}`;
            const textWidth = $e786aa223a5a569b$var$measureTextWidth(archivedText, lozengeFont);
            badgeWidth += textWidth + $e786aa223a5a569b$var$LOZENGE_PADDING;
        }
        const checkTruncation = ()=>{
            const containerWidth = container.clientWidth;
            // Only recheck if container width actually changed
            if (containerWidth === lastContainerWidth.current && lastContainerWidth.current !== 0) return;
            lastContainerWidth.current = containerWidth;
            const range = document.createRange();
            range.selectNodeContents(element);
            const textWidth_0 = range.getBoundingClientRect().width;
            const wouldTruncateWithBadges = textWidth_0 + badgeWidth > containerWidth;
            setIsTruncated(wouldTruncateWithBadges);
        };
        const debouncedCheckTruncation = ()=>{
            if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
            debounceTimeoutRef.current = setTimeout(checkTruncation, $e786aa223a5a569b$var$RESIZE_DEBOUNCE_MS);
        };
        const resizeObserver = new ResizeObserver(debouncedCheckTruncation);
        resizeObserver.observe(container);
        checkTruncation();
        return ()=>{
            resizeObserver.disconnect();
            if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
        };
    }, [
        hasBadges,
        hasVerified,
        hasArchived,
        archivedText
    ]);
    return {
        elementRef: elementRef,
        isTruncated: isTruncated
    };
};
/**
 * Measures text width using the Canvas API.
 * Reuses a single canvas instance for performance.
 * Returns 0 during SSR when document is unavailable.
 */ function $e786aa223a5a569b$var$measureTextWidth(text, font) {
    // SSR safety check
    if (typeof document === 'undefined') return 0;
    if (!$e786aa223a5a569b$var$measureCanvas) $e786aa223a5a569b$var$measureCanvas = document.createElement('canvas');
    const context = $e786aa223a5a569b$var$measureCanvas.getContext('2d');
    if (!context) return 0;
    context.font = font;
    return context.measureText(text).width;
}
module.exports["useTruncationDetection"] = $e786aa223a5a569b$export$16ec983cba4cfc6d;

});

parcelRegister("aZiZL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $9DXoL = parcelRequire("9DXoL");

const $00754e9f06717660$var$styles = {
    description: "_2sNsIg7NXe _1UtDYzKGUX _3TGfC9LRg7"
}; /**
    * Internal component that renders the team name and optional description text.
    * Handles truncation detection and conditionally displays verified/archived badges.
    */ 
const $00754e9f06717660$export$393edc798c47379d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Description(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { description: description } = t0;
    const { singleLine: singleLine, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const maxLines = singleLine ? 1 : undefined;
    if (!description) return null;
    if (typeof description === "string") {
        let t1;
        if ($[0] !== getTestId) {
            t1 = getTestId("team-description");
            $[0] = getTestId;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== description || $[3] !== maxLines || $[4] !== t1) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "small",
                maxLines: maxLines,
                color: "color.text.subtle",
                align: "start",
                testId: t1,
                children: description
            });
            $[2] = description;
            $[3] = maxLines;
            $[4] = t1;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    let t1;
    if ($[6] !== getTestId) {
        t1 = getTestId("team-description");
        $[6] = getTestId;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[8] !== description || $[9] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            testId: t1,
            xcss: $00754e9f06717660$var$styles.description,
            children: description
        });
        $[8] = description;
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function Description({ description: description }) {
    const { singleLine: singleLine, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const maxLines = singleLine ? 1 : undefined;
    if (!description) return null;
    if (typeof description === 'string') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines,
        color: "color.text.subtle",
        align: "start",
        testId: getTestId('team-description'),
        children: description
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        testId: getTestId('team-description'),
        xcss: $00754e9f06717660$var$styles.description,
        children: description
    });
};
module.exports["Description"] = $00754e9f06717660$export$393edc798c47379d;

});

parcelRegister("56sl1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $9DXoL = parcelRequire("9DXoL");

/**
 * Internal component that renders the team name text.
 * Supports single-line mode and accepts an optional ref for truncation detection.
 */ const $d1f6f1daf410e2b6$export$8fe6f0aed18a58c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamName(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { teamName: teamName, elementRef: elementRef } = t0;
    const { singleLine: singleLine, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const maxLines = singleLine ? 1 : undefined;
    let t1;
    if ($[0] !== getTestId) {
        t1 = getTestId("team-name");
        $[0] = getTestId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== elementRef || $[3] !== maxLines || $[4] !== t1 || $[5] !== teamName) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "medium",
            maxLines: maxLines,
            ref: elementRef,
            testId: t1,
            children: teamName
        });
        $[2] = elementRef;
        $[3] = maxLines;
        $[4] = t1;
        $[5] = teamName;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function TeamName({ teamName: teamName, elementRef: elementRef }) {
    const { singleLine: singleLine, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const maxLines = singleLine ? 1 : undefined;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
        size: "medium",
        maxLines: maxLines,
        ref: elementRef,
        testId: getTestId('team-name'),
        children: teamName
    });
};
module.exports["TeamName"] = $d1f6f1daf410e2b6$export$8fe6f0aed18a58c7;

});

parcelRegister("kHcM6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aRrFB = parcelRequire("aRrFB");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $9DXoL = parcelRequire("9DXoL");

/**
 * Internal component that renders the team type text and optional verified icon.
 * Supports single-line mode and accepts an optional ref for truncation detection.
 */ const $ee9aefbd0191ff57$export$26bc40b960693765 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamType(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { teamType: teamType, elementRef: elementRef, showVerified: t1 } = t0;
    const showVerified = t1 === undefined ? false : t1;
    const { singleLine: singleLine, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const maxLines = singleLine ? 1 : undefined;
    if (!teamType) return null;
    let t2;
    if ($[0] !== getTestId) {
        t2 = getTestId("team-type");
        $[0] = getTestId;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== elementRef || $[3] !== maxLines || $[4] !== t2 || $[5] !== teamType) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            maxLines: maxLines,
            ref: elementRef,
            color: "color.text.subtle",
            align: "start",
            testId: t2,
            children: teamType
        });
        $[2] = elementRef;
        $[3] = maxLines;
        $[4] = t2;
        $[5] = teamType;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== showVerified) {
        t4 = showVerified ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRrFB.VerifiedTeamIcon), {}) : null;
        $[7] = showVerified;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.025",
            children: [
                t3,
                t4
            ]
        });
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function TeamType({ teamType: teamType, elementRef: elementRef, showVerified: showVerified = false }) {
    const { singleLine: singleLine, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9DXoL.TeamInlinePreviewContext));
    const maxLines = singleLine ? 1 : undefined;
    if (!teamType) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.025",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "small",
                maxLines: maxLines,
                ref: elementRef,
                color: "color.text.subtle",
                align: "start",
                testId: getTestId('team-type'),
                children: teamType
            }),
            showVerified ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRrFB.VerifiedTeamIcon), {}) : null
        ]
    });
};
module.exports["TeamType"] = $ee9aefbd0191ff57$export$26bc40b960693765;

});

parcelRegister("7Jde4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d230dc9ab962e8b83fe82dda866afb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a06fec133986b41$var$_react = $5a06fec133986b41$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5a06fec133986b41$var$_baseNew = $5a06fec133986b41$var$_interopRequireDefault((parcelRequire("gElAV")));
function $5a06fec133986b41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-cleanup
 * Usage guidance:
 * Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a06fec133986b41$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $5a06fec133986b41$var$_react.default.createElement($5a06fec133986b41$var$_baseNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$5a06fec133986b41$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $5a06fec133986b41$var$_default = module.exports.default = $5a06fec133986b41$var$AiGenerativeCleanupIcon;

});

parcelRegister("2V04G", function(module, exports) {
$parcel$export(module.exports, "default", () => $2200f677ed36580e$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $2200f677ed36580e$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $3yGK6.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $dkBOe.default)(interval.start);
    var endDate = (0, $dkBOe.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $dkBOe.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

parcelRegister("bXJJJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df41cc4d70a30093af7801a73c08281c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b58aebc4d54a61c$var$_react = $8b58aebc4d54a61c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8b58aebc4d54a61c$var$_baseNew = $8b58aebc4d54a61c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8b58aebc4d54a61c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircleUnchecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle-unchecked
 * Usage guidance:
 * Known uses: Incomplete items
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b58aebc4d54a61c$var$CheckCircleUncheckedIcon = (props)=>/*#__PURE__*/ $8b58aebc4d54a61c$var$_react.default.createElement($8b58aebc4d54a61c$var$_baseNew.default, Object.assign({
        name: "CheckCircleUncheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$8b58aebc4d54a61c$var$CheckCircleUncheckedIcon.displayName = 'CheckCircleUncheckedIcon';
var $8b58aebc4d54a61c$var$_default = module.exports.default = $8b58aebc4d54a61c$var$CheckCircleUncheckedIcon;

});

parcelRegister("7eUSO", function(module, exports) {
const $eb42c349b4f6ce76$export$64aa7f11204484dc = (action, resolutionType, args)=>({
        key: action.key,
        tool_id: action.actionId,
        tool_source: action.toolSource,
        invocation_id: action.invocationId,
        resolution: {
            type: resolutionType
        },
        data: {
            human_message_id: action.humanMessageId ?? '',
            arguments: args ?? action.data
        }
    });
module.exports["buildToolFromAction"] = $eb42c349b4f6ce76$export$64aa7f11204484dc;

});

parcelRegister("icMUY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $lBKFk = parcelRequire("lBKFk");


var $2hJf7 = parcelRequire("2hJf7");


var $kTb7m = parcelRequire("kTb7m");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $cJ0FD = parcelRequire("cJ0FD");


var $1l0kj = parcelRequire("1l0kj");

const $f240996055e4bf31$var$styles = {
    spaceIcon: "_0bjKvDcjp5 _2V7sgOdnbC _3YEZNOdnbC _0KLXrujOvk _39xV02oWWg _0jFU0VoWWg"
};
const $f240996055e4bf31$export$cbe66ba5a24d87ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { type: type, subType: subType, iconPath: iconPath } = t0;
    if (!!iconPath) {
        const t1 = iconPath?.includes("/wiki") || iconPath?.startsWith("http") ? iconPath : `/wiki${iconPath}`;
        let t2;
        if ($[0] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $f240996055e4bf31$var$styles.spaceIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: t1,
                alt: ""
            }));
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    } else {
        if (type === "page" && subType?.toLowerCase() === "live") {
            let t1;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
                    label: "",
                    color: "var(--ds-icon-accent-magenta, #CD519D)"
                });
                $[2] = t1;
            } else t1 = $[2];
            return t1;
        }
        switch(type){
            case "page":
                {
                    let t1;
                    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                            label: "",
                            color: "var(--ds-icon-accent-blue, #357DE8)"
                        });
                        $[3] = t1;
                    } else t1 = $[3];
                    return t1;
                }
            case "blogPost":
                {
                    let t1;
                    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                            label: "",
                            color: "var(--ds-icon-accent-blue, #357DE8)"
                        });
                        $[4] = t1;
                    } else t1 = $[4];
                    return t1;
                }
            case "whiteboard":
                {
                    let t1;
                    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
                            label: "",
                            color: "var(--ds-icon-accent-teal, #2898BD)"
                        });
                        $[5] = t1;
                    } else t1 = $[5];
                    return t1;
                }
            case "database":
                {
                    let t1;
                    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
                            label: "",
                            color: "var(--ds-icon-accent-purple, #AF59E1)"
                        });
                        $[6] = t1;
                    } else t1 = $[6];
                    return t1;
                }
            case "folder":
                {
                    let t1;
                    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                            label: "",
                            color: "var(--ds-icon-accent-magenta, #CD519D)"
                        });
                        $[7] = t1;
                    } else t1 = $[7];
                    return t1;
                }
            case "embed":
                {
                    let t1;
                    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                            label: "",
                            color: "var(--ds-icon-accent-gray, #7D818A)"
                        });
                        $[8] = t1;
                    } else t1 = $[8];
                    return t1;
                }
            default:
                return null;
        }
    }
} : ({ type: type, subType: subType, iconPath: iconPath })=>{
    if (!!iconPath) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f240996055e4bf31$var$styles.spaceIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: iconPath?.includes('/wiki') || iconPath?.startsWith('http') ? iconPath : `/wiki${iconPath}`,
        alt: ""
    }));
    else {
        if (type === 'page' && subType?.toLowerCase() === 'live') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
            label: "",
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        switch(type){
            case 'page':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                    label: "",
                    color: "var(--ds-icon-accent-blue, #357DE8)"
                });
            case 'blogPost':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                    label: "",
                    color: "var(--ds-icon-accent-blue, #357DE8)"
                });
            case 'whiteboard':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
                    label: "",
                    color: "var(--ds-icon-accent-teal, #2898BD)"
                });
            case 'database':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
                    label: "",
                    color: "var(--ds-icon-accent-purple, #AF59E1)"
                });
            case 'folder':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                    label: "",
                    color: "var(--ds-icon-accent-magenta, #CD519D)"
                });
            case 'embed':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    label: "",
                    color: "var(--ds-icon-accent-gray, #7D818A)"
                });
            default:
                return null;
        }
    }
};
module.exports["OptionIcon"] = $f240996055e4bf31$export$cbe66ba5a24d87ce;

});

parcelRegister("jlxRT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7avaU = parcelRequire("7avaU");


var $iOCEj = parcelRequire("iOCEj");

var $av9vJ = parcelRequire("av9vJ");

var $lEAnc = parcelRequire("lEAnc");


var $bY9nm = parcelRequire("bY9nm");

const $abbf6cd31f4ebca9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    pageSelectorLabel: {
        id: "ai-mate.conversation-assistant-page-selector.page-selector-label",
        defaultMessage: "Select page"
    }
});
const $abbf6cd31f4ebca9$export$a1be606b9aa0a4aa = (result)=>{
    if (result?.toLowerCase() === 'blogpost') return 'blogPost';
    return result;
};
const $abbf6cd31f4ebca9$export$e839ab847bfd35fb = (ari)=>{
    // Folders, databases, and embeds have a special resourceId format like this: activation/0591fa3a-8f53-4cfe-8f24-2f7be5d4011b/454769345158
    // So we have to use their specific ARI parsers to extract the contentId
    if ((0, $lEAnc.ConfluenceFolderAri).check(ari)) return (0, $lEAnc.ConfluenceFolderAri).parse(ari).folderId;
    else if ((0, $iOCEj.ConfluenceDatabaseAri).check(ari)) return (0, $iOCEj.ConfluenceDatabaseAri).parse(ari).databaseId;
    else if ((0, $av9vJ.ConfluenceEmbedAri).check(ari)) return (0, $av9vJ.ConfluenceEmbedAri).parse(ari).embedId;
    else return (0, $7avaU.AnyAri).parse(ari).resourceId;
};
const $abbf6cd31f4ebca9$export$6ad74c9154854842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let contentTypes;
    let listEntities;
    let props;
    let spaceId;
    if ($[0] !== t0) {
        ({ spaceId: spaceId, contentTypes: contentTypes, listEntities: listEntities, ...props } = t0);
        $[0] = t0;
        $[1] = contentTypes;
        $[2] = listEntities;
        $[3] = props;
        $[4] = spaceId;
    } else {
        contentTypes = $[1];
        listEntities = $[2];
        props = $[3];
        spaceId = $[4];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[5] !== contentTypes || $[6] !== listEntities || $[7] !== spaceId) {
        t1 = async (searchText)=>{
            const response = await listEntities(searchText, contentTypes, spaceId);
            return response.flatMap($abbf6cd31f4ebca9$var$_temp);
        };
        $[5] = contentTypes;
        $[6] = listEntities;
        $[7] = spaceId;
        $[8] = t1;
    } else t1 = $[8];
    const loadOptions = t1;
    let t2;
    if ($[9] !== formatMessage) {
        t2 = formatMessage($abbf6cd31f4ebca9$export$defe85febe8b728c.pageSelectorLabel);
        $[9] = formatMessage;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== loadOptions || $[12] !== props || $[13] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $bY9nm.DebouncedSelector), {
            loadOptions: loadOptions,
            label: t2,
            ...props
        });
        $[11] = loadOptions;
        $[12] = props;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : ({ spaceId: spaceId, contentTypes: contentTypes, listEntities: listEntities, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const loadOptions = (0, $cozmU.useCallback)(async (searchText)=>{
        const response = await listEntities(searchText, contentTypes, spaceId);
        return response.flatMap((item)=>item.ari && item.type ? [
                {
                    label: item.name,
                    value: $abbf6cd31f4ebca9$export$e839ab847bfd35fb(item.ari),
                    type: $abbf6cd31f4ebca9$export$a1be606b9aa0a4aa(item.type),
                    subType: item.subtype
                }
            ] : []);
    }, [
        listEntities,
        spaceId,
        contentTypes
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bY9nm.DebouncedSelector), {
        loadOptions: loadOptions,
        label: formatMessage($abbf6cd31f4ebca9$export$defe85febe8b728c.pageSelectorLabel),
        ...props
    });
};
function $abbf6cd31f4ebca9$var$_temp(item) {
    return item.ari && item.type ? [
        {
            label: item.name,
            value: $abbf6cd31f4ebca9$export$e839ab847bfd35fb(item.ari),
            type: $abbf6cd31f4ebca9$export$a1be606b9aa0a4aa(item.type),
            subType: item.subtype
        }
    ] : [];
}
module.exports["convertContentType"] = $abbf6cd31f4ebca9$export$a1be606b9aa0a4aa;
module.exports["extractContentId"] = $abbf6cd31f4ebca9$export$e839ab847bfd35fb;
module.exports["BaseConfluencePageSelectorInner"] = $abbf6cd31f4ebca9$export$6ad74c9154854842;

});

parcelRegister("iOCEj", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/database/manifest.ts
var $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $db2ae073c8566cc3$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $db2ae073c8566cc3$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("av9vJ", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/embed/manifest.ts
var $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $7a542d43713a04fa$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $7a542d43713a04fa$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("lEAnc", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/folder/manifest.ts
var $fc398c589f411de7$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $fc398c589f411de7$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $fc398c589f411de7$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("bY9nm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eiLi2 = parcelRequire("eiLi2");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");


var $6wGOF = parcelRequire("6wGOF");


var $icMUY = parcelRequire("icMUY");

const $85037c7f30f88d53$var$DEBOUNCE_DELAY = 300;
const $85037c7f30f88d53$var$styles = {
    optionLabel: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbHnLE _39xV02N91d"
};
const $85037c7f30f88d53$export$ca84f74301306fcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let loadOptions;
    let props;
    if ($[0] !== t0) {
        ({ loadOptions: loadOptions, ...props } = t0);
        $[0] = t0;
        $[1] = loadOptions;
        $[2] = props;
    } else {
        loadOptions = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== loadOptions) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))(loadOptions, $85037c7f30f88d53$var$DEBOUNCE_DELAY);
        $[3] = loadOptions;
        $[4] = t1;
    } else t1 = $[4];
    const debouncedLoadOptions = t1;
    let t2;
    if ($[5] !== debouncedLoadOptions) {
        t2 = async (searchText)=>await debouncedLoadOptions(searchText);
        $[5] = debouncedLoadOptions;
        $[6] = t2;
    } else t2 = $[6];
    const handleLoadOptions = t2;
    const formatOptionLabel = $85037c7f30f88d53$var$_temp;
    const formatGroupLabel = $85037c7f30f88d53$var$_temp2;
    let t3;
    if ($[7] !== handleLoadOptions || $[8] !== props) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
            spacing: "default",
            appearance: "default",
            cacheOptions: true,
            defaultOptions: true,
            loadOptions: handleLoadOptions,
            formatOptionLabel: formatOptionLabel,
            formatGroupLabel: formatGroupLabel,
            ...props
        });
        $[7] = handleLoadOptions;
        $[8] = props;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ loadOptions: loadOptions, ...props })=>{
    const debouncedLoadOptions = (0, $cozmU.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))(loadOptions, $85037c7f30f88d53$var$DEBOUNCE_DELAY);
    }, [
        loadOptions
    ]);
    const handleLoadOptions = (0, $cozmU.useCallback)(async (searchText)=>{
        // Show debounced search results for what they've typed into the selector.
        return await debouncedLoadOptions(searchText);
    }, [
        debouncedLoadOptions
    ]);
    const formatOptionLabel = (0, $cozmU.useCallback)((option)=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "start",
            gap: "space.100",
            xcss: $85037c7f30f88d53$var$styles.optionLabel
        }, /*#__PURE__*/ $cozmU.createElement((0, $icMUY.OptionIcon), {
            type: option.type,
            subType: option.subType,
            iconPath: option.iconPath
        }), option.label);
    }, []);
    const formatGroupLabel = (0, $cozmU.useCallback)((group)=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xxsmall"
        }, group.label || '');
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        spacing: "default",
        appearance: "default",
        cacheOptions: true,
        defaultOptions: true,
        loadOptions: handleLoadOptions,
        formatOptionLabel: formatOptionLabel,
        formatGroupLabel: formatGroupLabel,
        ...props
    });
};
function $85037c7f30f88d53$var$_temp(option) {
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "start",
        gap: "space.100",
        xcss: $85037c7f30f88d53$var$styles.optionLabel
    }, /*#__PURE__*/ $cozmU.createElement((0, $icMUY.OptionIcon), {
        type: option.type,
        subType: option.subType,
        iconPath: option.iconPath
    }), option.label);
}
function $85037c7f30f88d53$var$_temp2(group) {
    return /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, group.label || "");
}
module.exports["DebouncedSelector"] = $85037c7f30f88d53$export$ca84f74301306fcd;

});

parcelRegister("eiLi2", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $a6976de9968040b3$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $a6976de9968040b3$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $a6976de9968040b3$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $a6976de9968040b3$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
} //# sourceMappingURL=index.js.map

});

parcelRegister("fuTaJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dqxOF = parcelRequire("dqxOF");


var $1HjbK = parcelRequire("1HjbK");


var $fFzPo = parcelRequire("fFzPo");

const $914d12401bc69982$var$HOOK_OUTPUT_PROPS = [
    'listEntities',
    'fetchRecommendedSpaces',
    'fetchSpaceApprovalsConfigs'
];
const $914d12401bc69982$var$omitHookOutputProps = (props, keys)=>Object.fromEntries(Object.entries(props).filter(([key])=>!keys.includes(key))); /**
                                                                                                                                                                                                                   * Memoized version of BaseConfluenceSpaceSelector with custom comparison function.
                                                                                                                                                                                                                   */ 
const $914d12401bc69982$var$BaseConfluenceSpaceSelector = /*#__PURE__*/ (0, $cozmU.memo)((0, $fFzPo.BaseConfluenceSpaceSelectorInner), (prevProps, nextProps)=>(0, $dqxOF.shallowEqualObjects)($914d12401bc69982$var$omitHookOutputProps(prevProps, $914d12401bc69982$var$HOOK_OUTPUT_PROPS), $914d12401bc69982$var$omitHookOutputProps(nextProps, $914d12401bc69982$var$HOOK_OUTPUT_PROPS))); /**
                                                                                                                                                                                                                                  * AFM consumers should use this web-specific component
                                                                                                                                                                                                                                  */ 
const $914d12401bc69982$export$b056203be29b752a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let cloudId;
    let fetchHomepage;
    let props;
    let recommendedSpaces;
    let userId;
    if ($[0] !== t0) {
        ({ cloudId: cloudId, userId: userId, fetchHomepage: fetchHomepage, recommendedSpaces: recommendedSpaces, ...props } = t0);
        $[0] = t0;
        $[1] = cloudId;
        $[2] = fetchHomepage;
        $[3] = props;
        $[4] = recommendedSpaces;
        $[5] = userId;
    } else {
        cloudId = $[1];
        fetchHomepage = $[2];
        props = $[3];
        recommendedSpaces = $[4];
        userId = $[5];
    }
    let t1;
    if ($[6] !== fetchHomepage) {
        t1 = {
            fetchHomepage: fetchHomepage
        };
        $[6] = fetchHomepage;
        $[7] = t1;
    } else t1 = $[7];
    const { listEntities: listEntities, fetchRecommendedSpaces: fetchRecommendedSpaces, fetchSpaceApprovalsConfigs: fetchSpaceApprovalsConfigs } = (0, $1HjbK.useConfluenceEntities)(cloudId, t1);
    let t2;
    if ($[8] !== fetchRecommendedSpaces || $[9] !== fetchSpaceApprovalsConfigs || $[10] !== listEntities || $[11] !== props || $[12] !== recommendedSpaces || $[13] !== userId) {
        t2 = /*#__PURE__*/ $cozmU.createElement($914d12401bc69982$var$BaseConfluenceSpaceSelector, {
            userId: userId,
            recommendedSpaces: recommendedSpaces,
            listEntities: listEntities,
            fetchRecommendedSpaces: fetchRecommendedSpaces,
            fetchSpaceApprovalsConfigs: fetchSpaceApprovalsConfigs,
            ...props
        });
        $[8] = fetchRecommendedSpaces;
        $[9] = fetchSpaceApprovalsConfigs;
        $[10] = listEntities;
        $[11] = props;
        $[12] = recommendedSpaces;
        $[13] = userId;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
} : ({ cloudId: cloudId, userId: userId, fetchHomepage: fetchHomepage, recommendedSpaces: recommendedSpaces, ...props })=>{
    const { listEntities: listEntities, fetchRecommendedSpaces: fetchRecommendedSpaces, fetchSpaceApprovalsConfigs: fetchSpaceApprovalsConfigs } = (0, $1HjbK.useConfluenceEntities)(cloudId, {
        fetchHomepage: fetchHomepage
    });
    return /*#__PURE__*/ $cozmU.createElement($914d12401bc69982$var$BaseConfluenceSpaceSelector, {
        userId: userId,
        recommendedSpaces: recommendedSpaces,
        listEntities: listEntities,
        fetchRecommendedSpaces: fetchRecommendedSpaces,
        fetchSpaceApprovalsConfigs: fetchSpaceApprovalsConfigs,
        ...props
    });
};
module.exports["ConfluenceSpaceSelector"] = $914d12401bc69982$export$b056203be29b752a;

});

parcelRegister("fFzPo", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $anBbz = parcelRequire("anBbz");


var $jlxRT = parcelRequire("jlxRT");


var $bY9nm = parcelRequire("bY9nm");

const $73383652e4ba45d0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    spaceSelectorLabel: {
        id: "ai-mate.conversation-assistant-space-selector.space-selector-label",
        defaultMessage: "Select space"
    },
    suggestedSpacesHeading: {
        id: "ai-mate.conversation-assistant-space-selector.suggested-spaces-heading",
        defaultMessage: "Suggested spaces"
    }
});
/**
 * Maps a filterContentType value to the corresponding enabledContentTypes field.
 *
 * Note: 'confluence-page' maps to isLivePagesEnabled because this filter is only
 * applied when creating live pages (livedocs). Regular pages are supported by all
 * spaces and should not be filtered — the caller is responsible for passing
 * filterContentType as undefined when creating regular pages.
 */ const $73383652e4ba45d0$var$getEnabledFlag = (enabledContentTypes, filterContentType)=>{
    switch(filterContentType){
        case 'confluence-whiteboard':
            return enabledContentTypes.isWhiteboardsEnabled;
        case 'confluence-page':
            // 'confluence-page' here refers to live pages (livedocs), not regular pages.
            // Regular pages are supported by all spaces and are not filtered.
            return enabledContentTypes.isLivePagesEnabled;
        case 'confluence-database':
            return enabledContentTypes.isDatabasesEnabled;
        case 'confluence-slide':
            return enabledContentTypes.isSlidesEnabled;
        default:
            return undefined;
    }
};
const $73383652e4ba45d0$var$isSpaceFilterableContentType = (contentType)=>contentType === 'confluence-page' || contentType === 'confluence-whiteboard' || contentType === 'confluence-database' || contentType === 'confluence-slide';
const $73383652e4ba45d0$export$6a5af1cf31dba6 = ({ contentType: contentType, selectedContentType: selectedContentType })=>{
    if (!$73383652e4ba45d0$var$isSpaceFilterableContentType(contentType)) return undefined;
     // Regular pages are supported by all spaces.
    if (contentType === 'confluence-page' && selectedContentType === 'page') return undefined;
    return contentType;
}; /**
    * Checks if a space supports the specified content type based on its type settings.
    * When filterContentType is set, only spaces that have the corresponding content type
    * enabled in their enabledContentTypes settings will be included.
    * If no settings data is available, the space will not be included.
    */ 
const $73383652e4ba45d0$export$23f4df947b7119d7 = (space, filterContentType)=>{
    if (!filterContentType) return true;
    const enabledContentTypes = space?.typeSettings?.enabledContentTypes;
    if (!enabledContentTypes) return false;
    const isEnabled = $73383652e4ba45d0$var$getEnabledFlag(enabledContentTypes, filterContentType);
    return isEnabled !== false;
}; /**
    * Safely checks the gate controlling whether spaces that disallow first publish
    * (approvals) are filtered out of the picker. Uses the same Approvals Beta killswitch
    * as the monolith first-publish gate so the picker behavior stays in lockstep with the
    * backend. Returns false if the Statsig SDK throws so the component degrades gracefully
    * to today's behavior (no filtering).
    */ 
const $73383652e4ba45d0$var$isFirstPublishFilterEnabled = ()=>{
    try {
        // TODO CCIMPORTER-3221: register `confluence_approvals_eap` in
        // `@atlaskit/tmp-editor-statsig` (`experiments-config.ts`) so the
        // experiment id is known to TypeScript and this cast can be
        // removed. Matches the same cast in store-error/index.tsx and
        // confluence-object-finalize-popup/index.tsx.
        if ((0, $anBbz.expValEqualsNoExposure)('confluence_approvals_eap', 'isEnabled', true)) return true;
        return false;
    } catch  {
        return false;
    }
}; /**
    * Filters out spaces that disallow first publish, using a batched approvals lookup.
    *
    * No-op (returns the input unchanged) when the feature gate is off, when no
    * fetcher is provided, or when the input is empty. Degrades gracefully: any space
    * whose config is missing from the resolved map is treated as allowed (kept), so a
    * failed/partial lookup never incorrectly hides a space.
    */ 
const $73383652e4ba45d0$var$filterOutFirstPublishDisallowedSpaces = async (spaces, getSpaceKey, fetchSpaceApprovalsConfigs)=>{
    if (!$73383652e4ba45d0$var$isFirstPublishFilterEnabled() || !fetchSpaceApprovalsConfigs || spaces.length === 0) return spaces;
    const keys = spaces.map(getSpaceKey).filter((key)=>typeof key === 'string' && key.length > 0);
    if (keys.length === 0) return spaces;
    const approvalsConfigs = await fetchSpaceApprovalsConfigs(keys);
    return spaces.filter((space)=>{
        const key = getSpaceKey(space);
        if (!key) return true;
        return approvalsConfigs[key]?.disallowFirstPublish !== true;
    });
};
const $73383652e4ba45d0$export$27f0bf5c5d5a3559 = ({ userId: userId, recommendedSpaces: recommendedSpaces, listEntities: listEntities, fetchRecommendedSpaces: fetchRecommendedSpaces, fetchSpaceApprovalsConfigs: fetchSpaceApprovalsConfigs, filterContentType: filterContentType, onFallbackError: onFallbackError, onFallbackSuccess: onFallbackSuccess, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const mapSearchResultsToOptions = (0, $cozmU.useCallback)((spaces)=>{
        return spaces.map((space)=>({
                label: space.name,
                value: space.id,
                key: space.key,
                ...space.homepage && {
                    homepage: {
                        label: space.homepage.name,
                        value: space.homepage.id,
                        type: (0, $jlxRT.convertContentType)(space.homepage.type)
                    }
                },
                iconPath: space.iconPath,
                type: space.type,
                typeSettings: space.typeSettings
            }));
    }, []);
    const shouldUseSmartRecommendedSpaces = recommendedSpaces !== undefined;
    const [hasSearchText, setHasSearchText] = (0, $cozmU.useState)(false); // Memoised cache of per-space approvals lookups so that successive debounced
    // search invocations (each calling `fetchSpaceApprovalsConfigs` for the new
    // page of results) do not re-fetch the same space keys we already resolved
    // in a prior call. The cache is keyed by space key and only stores the boolean
    // `disallowFirstPublish`; this is intentionally per-render-instance and not a
    // global cache, so it lives and dies with the picker mount.
    const approvalsCacheRef = (0, $cozmU.useRef)(new Map()); // Reset the cache when the underlying fetcher reference changes (e.g. on a
    // different cloudId / siteId), to avoid serving stale results across tenants.
    (0, $cozmU.useEffect)(()=>{
        approvalsCacheRef.current = new Map();
    }, [
        fetchSpaceApprovalsConfigs
    ]);
    const cachedFetchSpaceApprovalsConfigs = (0, $cozmU.useMemo)(()=>{
        if (!fetchSpaceApprovalsConfigs) return undefined;
        return async (spaceKeys)=>{
            const result = {};
            const missing = [];
            for (const key of spaceKeys){
                const cached = approvalsCacheRef.current.get(key);
                if (cached !== undefined) result[key] = {
                    disallowFirstPublish: cached
                };
                else missing.push(key);
            }
            if (missing.length === 0) return result;
            const fetched = await fetchSpaceApprovalsConfigs(missing);
            for (const key_0 of missing){
                const disallowed = fetched[key_0]?.disallowFirstPublish === true;
                approvalsCacheRef.current.set(key_0, disallowed);
                result[key_0] = {
                    disallowFirstPublish: disallowed
                };
            }
            return result;
        };
    }, [
        fetchSpaceApprovalsConfigs
    ]); // Space keys (from the pre-fetched suggested spaces) that disallow first publish
    // and should be hidden from the synchronous `options` render. Resolved via the
    // batched approvals lookup. Empty by default so the picker behaves as today until
    // (and unless) the gate is on and the lookup resolves.
    const [firstPublishDisallowedKeys, setFirstPublishDisallowedKeys] = (0, $cozmU.useState)(()=>new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!$73383652e4ba45d0$var$isFirstPublishFilterEnabled() || !fetchSpaceApprovalsConfigs || !recommendedSpaces) {
            // Do not reset state to a fresh `new Set()` here — the initial
            // state is already `new Set()`, and because `Object.is(new Set(),
            // new Set())` is `false`, an unconditional setter call would
            // schedule a re-render on every dep change even though the
            // effective state did not change. Only reset when we know there
            // is something to clear.
            setFirstPublishDisallowedKeys((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const keys = recommendedSpaces.map((space_0)=>space_0.spaceDetails.key).filter((key_1)=>typeof key_1 === 'string' && key_1.length > 0);
        if (keys.length === 0) {
            // Same rationale as the early-return above: only reset when we know
            // the previous state actually held something.
            setFirstPublishDisallowedKeys((prev_0)=>prev_0.size === 0 ? prev_0 : new Set());
            return;
        }
        let cancelled = false; // Use the cached wrapper here too so the effect's batch is co-cached
        // with the loadOptions paths — if a user types and then closes/reopens
        // the picker we don't re-query the same space keys.
        const fetcher = cachedFetchSpaceApprovalsConfigs ?? fetchSpaceApprovalsConfigs;
        fetcher(keys).then((configs)=>{
            if (cancelled) return;
            const disallowed_0 = new Set(Object.entries(configs).filter(([, config])=>config?.disallowFirstPublish === true).map(([key_2])=>key_2));
            setFirstPublishDisallowedKeys(disallowed_0);
        }).catch(()=>{
            // Degrade gracefully: on error, hide nothing. Same idempotent
            // reset as the early-return paths so we don't churn renders.
            if (!cancelled) setFirstPublishDisallowedKeys((prev_1)=>prev_1.size === 0 ? prev_1 : new Set());
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        recommendedSpaces,
        fetchSpaceApprovalsConfigs,
        cachedFetchSpaceApprovalsConfigs
    ]); /**
                                                                                          * Runs the listEntities fallback when recommended spaces are empty.
                                                                                          * Shared between the fetchRecommendedSpaces path and the pre-fetched
                                                                                          * recommendedSpaces prop path.
                                                                                          */ 
    const runFallback = (0, $cozmU.useCallback)(async ()=>{
        try {
            const fallbackSpaces = await listEntities('', [
                'space'
            ]);
            const contentTypeFiltered = fallbackSpaces.filter((space_1)=>$73383652e4ba45d0$export$23f4df947b7119d7(space_1, filterContentType));
            const filteredFallback = await $73383652e4ba45d0$var$filterOutFirstPublishDisallowedSpaces(contentTypeFiltered, (space_2)=>space_2.key, cachedFetchSpaceApprovalsConfigs);
            const options = mapSearchResultsToOptions(filteredFallback);
            onFallbackSuccess?.({
                fallbackResultCount: options.length
            });
            return options;
        } catch (error) {
            onFallbackError?.(error);
            return [];
        }
    }, [
        listEntities,
        filterContentType,
        cachedFetchSpaceApprovalsConfigs,
        mapSearchResultsToOptions,
        onFallbackError,
        onFallbackSuccess
    ]);
    const loadOptions = (0, $cozmU.useCallback)(async (searchText)=>{
        if (userId && !searchText) {
            // When recommendedSpaces is pre-fetched as a prop (including empty array),
            // the dropdown options are rendered via the `options` prop. However, when
            // the pre-fetched list is empty (or all entries are filtered out), we need
            // to trigger the fallback here so the user isn't stuck with "No options".
            if (shouldUseSmartRecommendedSpaces) {
                const contentTypeFiltered_0 = recommendedSpaces ? recommendedSpaces.filter((space_3)=>$73383652e4ba45d0$export$23f4df947b7119d7({
                        typeSettings: space_3.spaceDetails.spaceTypeSettings
                    }, filterContentType)) : [];
                const filtered = await $73383652e4ba45d0$var$filterOutFirstPublishDisallowedSpaces(contentTypeFiltered_0, (space_4)=>space_4.spaceDetails.key, cachedFetchSpaceApprovalsConfigs);
                if (filtered.length === 0) return runFallback();
                return [];
            }
            const response = await fetchRecommendedSpaces({
                userId: userId
            }) ?? [];
            const contentTypeFiltered_1 = response.filter((space_5)=>$73383652e4ba45d0$export$23f4df947b7119d7({
                    typeSettings: space_5.container?.typeSettings
                }, filterContentType));
            const filteredSpaces = await $73383652e4ba45d0$var$filterOutFirstPublishDisallowedSpaces(contentTypeFiltered_1, (space_6)=>space_6.container?.key, cachedFetchSpaceApprovalsConfigs);
            if (filteredSpaces.length === 0) return runFallback();
            return filteredSpaces.map(({ container: container })=>({
                    label: container.name,
                    value: container.spaceId,
                    key: container.key,
                    ...container.homepage && {
                        homepage: {
                            label: container.homepage.name,
                            value: container.homepage.id,
                            type: (0, $jlxRT.convertContentType)(container.homepage.type)
                        }
                    },
                    iconPath: container.icon.path,
                    type: container.type,
                    typeSettings: container.typeSettings
                }));
        }
        const response_0 = await listEntities(searchText, [
            'space'
        ]);
        const contentTypeFiltered_2 = response_0.filter((space_7)=>$73383652e4ba45d0$export$23f4df947b7119d7(space_7, filterContentType));
        const filteredSpaces_0 = await $73383652e4ba45d0$var$filterOutFirstPublishDisallowedSpaces(contentTypeFiltered_2, (space_8)=>space_8.key, cachedFetchSpaceApprovalsConfigs);
        return mapSearchResultsToOptions(filteredSpaces_0);
    }, [
        listEntities,
        userId,
        fetchRecommendedSpaces,
        cachedFetchSpaceApprovalsConfigs,
        mapSearchResultsToOptions,
        shouldUseSmartRecommendedSpaces,
        recommendedSpaces,
        filterContentType,
        runFallback
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bY9nm.DebouncedSelector), {
        isLoading: Boolean(!recommendedSpaces && shouldUseSmartRecommendedSpaces),
        loadOptions: loadOptions,
        onInputChange: (e)=>{
            setHasSearchText(Boolean(e));
        },
        options: hasSearchText || !shouldUseSmartRecommendedSpaces || !recommendedSpaces ? undefined : [
            {
                label: formatMessage($73383652e4ba45d0$export$defe85febe8b728c.suggestedSpacesHeading),
                options: recommendedSpaces.filter((space_9)=>$73383652e4ba45d0$export$23f4df947b7119d7({
                        typeSettings: space_9.spaceDetails.spaceTypeSettings
                    }, filterContentType)).filter((space_10)=>!space_10.spaceDetails.key || !firstPublishDisallowedKeys.has(space_10.spaceDetails.key)).map((space_11)=>({
                        label: space_11.name,
                        value: space_11.id,
                        key: space_11.spaceDetails.key,
                        ...space_11.spaceDetails.homepage && {
                            homepage: {
                                label: space_11.spaceDetails.homepage.title,
                                value: space_11.spaceDetails.homepage.id,
                                type: (0, $jlxRT.convertContentType)(space_11.spaceDetails.homepage.type)
                            }
                        },
                        iconPath: space_11.spaceDetails.icon?.path,
                        type: space_11.spaceDetails.type,
                        typeSettings: space_11.spaceDetails.spaceTypeSettings
                    }))
            }
        ],
        label: formatMessage($73383652e4ba45d0$export$defe85febe8b728c.spaceSelectorLabel),
        ...props
    });
};
module.exports["getSpaceFilterContentType"] = $73383652e4ba45d0$export$6a5af1cf31dba6;
module.exports["supportsContentType"] = $73383652e4ba45d0$export$23f4df947b7119d7;
module.exports["BaseConfluenceSpaceSelectorInner"] = $73383652e4ba45d0$export$27f0bf5c5d5a3559;

});

parcelRegister("6STLT", function(module, exports) {

let $50330c42df660d64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50330c42df660d64$var$load("cG8fC").then(()=>parcelRequire('5RmTz'));

});

parcelRegister("2SuBW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::006dceb418e831d7566ee430d605056b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21885e9a84019410$var$_react = $21885e9a84019410$var$_interopRequireDefault((parcelRequire("cozmU")));

var $21885e9a84019410$var$_baseNew = $21885e9a84019410$var$_interopRequireDefault((parcelRequire("gElAV")));
function $21885e9a84019410$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityCritical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/priority-critical
 * Usage guidance:
 * Reserved for critical work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21885e9a84019410$var$PriorityCriticalIcon = (props)=>/*#__PURE__*/ $21885e9a84019410$var$_react.default.createElement($21885e9a84019410$var$_baseNew.default, Object.assign({
        name: "PriorityCriticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.837 14.836A.75.75 0 0 0 14 14.21v-9a.75.75 0 0 0-.337-.626l-5.25-3.46a.75.75 0 0 0-.826 0l-5.25 3.46A.75.75 0 0 0 2 5.21v9l.007.103a.75.75 0 0 0 1.156.523L8 11.65zm-4.424-4.713a.75.75 0 0 0-.826 0L3.5 12.818V5.614L8 2.65l4.5 2.965v7.204z"/>`
    }, props));
$21885e9a84019410$var$PriorityCriticalIcon.displayName = 'PriorityCriticalIcon';
var $21885e9a84019410$var$_default = module.exports.default = $21885e9a84019410$var$PriorityCriticalIcon;

});

parcelRegister("1tj8s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14b1eaea497574b277bdc69d0d5b07af>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $112757c8d254e280$var$_react = $112757c8d254e280$var$_interopRequireDefault((parcelRequire("cozmU")));

var $112757c8d254e280$var$_baseNew = $112757c8d254e280$var$_interopRequireDefault((parcelRequire("gElAV")));
function $112757c8d254e280$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHigh".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/priority-high
 * Usage guidance:
 * Reserved for high work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $112757c8d254e280$var$PriorityHighIcon = (props)=>/*#__PURE__*/ $112757c8d254e280$var$_react.default.createElement($112757c8d254e280$var$_baseNew.default, Object.assign({
        name: "PriorityHighIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 9.25-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353z"/>`
    }, props));
$112757c8d254e280$var$PriorityHighIcon.displayName = 'PriorityHighIcon';
var $112757c8d254e280$var$_default = module.exports.default = $112757c8d254e280$var$PriorityHighIcon;

});

parcelRegister("gsQhG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5468d80605a701350dca7e2985f6fee0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfc7d1708bb593c6$var$_react = $bfc7d1708bb593c6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $bfc7d1708bb593c6$var$_baseNew = $bfc7d1708bb593c6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $bfc7d1708bb593c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHighest".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/priority-highest
 * Usage guidance:
 * Reserved for highest work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfc7d1708bb593c6$var$PriorityHighestIcon = (props)=>/*#__PURE__*/ $bfc7d1708bb593c6$var$_react.default.createElement($bfc7d1708bb593c6$var$_baseNew.default, Object.assign({
        name: "PriorityHighestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 6.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 8 8 4.65 13.087 8zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.624.826 1.252L8 9.15l5.087 3.353z"/>`
    }, props));
$bfc7d1708bb593c6$var$PriorityHighestIcon.displayName = 'PriorityHighestIcon';
var $bfc7d1708bb593c6$var$_default = module.exports.default = $bfc7d1708bb593c6$var$PriorityHighestIcon;

});

parcelRegister("5yfjd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68da5eeb8314a8364f0e17f22fe87e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40ac00c7acb1bcda$var$_react = $40ac00c7acb1bcda$var$_interopRequireDefault((parcelRequire("cozmU")));

var $40ac00c7acb1bcda$var$_baseNew = $40ac00c7acb1bcda$var$_interopRequireDefault((parcelRequire("gElAV")));
function $40ac00c7acb1bcda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityLow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/priority-low
 * Usage guidance:
 * Reserved for low work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40ac00c7acb1bcda$var$PriorityLowIcon = (props)=>/*#__PURE__*/ $40ac00c7acb1bcda$var$_react.default.createElement($40ac00c7acb1bcda$var$_baseNew.default, Object.assign({
        name: "PriorityLowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 7.251-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 9.352l5.087-3.353z"/>`
    }, props));
$40ac00c7acb1bcda$var$PriorityLowIcon.displayName = 'PriorityLowIcon';
var $40ac00c7acb1bcda$var$_default = module.exports.default = $40ac00c7acb1bcda$var$PriorityLowIcon;

});

parcelRegister("14iVz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b794a0323798902811bc606d9e28fc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c74d8ce9b92e875$var$_react = $0c74d8ce9b92e875$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0c74d8ce9b92e875$var$_baseNew = $0c74d8ce9b92e875$var$_interopRequireDefault((parcelRequire("gElAV")));
function $0c74d8ce9b92e875$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/priority-medium
 * Usage guidance:
 * Reserved for medium work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c74d8ce9b92e875$var$PriorityMediumIcon = (props)=>/*#__PURE__*/ $0c74d8ce9b92e875$var$_react.default.createElement($0c74d8ce9b92e875$var$_baseNew.default, Object.assign({
        name: "PriorityMediumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 9.5V11H2V9.5zM14 5v1.5H2V5z"/>`
    }, props));
$0c74d8ce9b92e875$var$PriorityMediumIcon.displayName = 'PriorityMediumIcon';
var $0c74d8ce9b92e875$var$_default = module.exports.default = $0c74d8ce9b92e875$var$PriorityMediumIcon;

});

parcelRegister("24tIi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9K2Ng = parcelRequire("9K2Ng");


var $cCc2a = parcelRequire("cCc2a");


var $7GkXv = parcelRequire("7GkXv");

const $146c3ccf1b168812$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $7GkXv.useUFOConcurrentExperience)((0, $7GkXv.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7GkXv.UfoErrorBoundary), {
        id: ufoId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cCc2a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9K2Ng.SmartUserPicker), props)));
};
var $146c3ccf1b168812$export$2e2bcd8739ae039 = $146c3ccf1b168812$var$SmartUserPickerWithIntlProvider;
module.exports["default"] = $146c3ccf1b168812$export$2e2bcd8739ae039;

});

parcelRegister("9K2Ng", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $kHija = parcelRequire("kHija");


var $lzgC6 = parcelRequire("lzgC6");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $j7Sza = parcelRequire("j7Sza");


var $kfLla = parcelRequire("kfLla");

var $f1uNX = parcelRequire("f1uNX");

var $bsEy7 = parcelRequire("bsEy7");


var $iDrrr = parcelRequire("iDrrr");


var $kK1nI = parcelRequire("kK1nI");


var $cCc2a = parcelRequire("cCc2a");


var $jItb7 = parcelRequire("jItb7");


var $b9heI = parcelRequire("b9heI");

var $uUDXo = parcelRequire("uUDXo");


var $7GkXv = parcelRequire("7GkXv");

const $537559c2d938befb$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $537559c2d938befb$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $537559c2d938befb$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.userbaseId !== newContext.userbaseId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $537559c2d938befb$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $537559c2d938befb$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $537559c2d938befb$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $537559c2d938befb$var$isEmailQuery = (query)=>{
    return (0, $bsEy7.isValidEmail)(query.trim()) === 'VALID';
};
class $537559c2d938befb$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    async componentDidMount() {
        try {
            const value = await (0, $uUDXo.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId, {
                tenantId: this.props.siteId,
                activationId: this.props.activationId
            });
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $kHija.v4)();
            this.fireEvent((0, $kK1nI.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($537559c2d938befb$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $j7Sza.UFOExperienceState).FAILED.id,
                (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
                (0, $j7Sza.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, suggestEmailsForDomain: suggestEmailsForDomain, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        // When suggestEmailsForDomain is active, partial (non-email) input must still reach the base
        // picker's domain-suggestion creatable logic, so the isEmailQuery restriction is relaxed for
        // those queries only. Full email queries that matched an existing user remain suppressed.
        const isDomainSuggestionEnabled = (0, $iDrrr.fg)('smart_user_picker_suggest_emails_for_domain') && !!suggestEmailsForDomain;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            const isCurrentQueryEmail = $537559c2d938befb$var$isEmailQuery(this.state.query);
            if (isDomainSuggestionEnabled) // Allow email for partial queries so the "<query>@<domain>" suggestion can render,
            // but still suppress selection when a full email query matched an existing user,
            // or when the synthesized "<query>@<domain>" is itself an existing user's email.
            shouldAllowEmail = isCurrentQueryEmail ? !this.lastEmailSearchFoundMatches // full email: suppress when user matched
             : !this.lastDomainSuggestionMatchedUser; // partial: suppress when synth email matched a user
            else // Only allow email selection when:
            // 1. The query matches email format (validated by regex)
            // 2. No user/external user matches were found (only teams/groups suggested)
            shouldAllowEmail = isCurrentQueryEmail && !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cCc2a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
            ...restProps,
            allowEmail: shouldAllowEmail,
            suggestEmailsForDomain: suggestEmailsForDomain,
            onInputChange: this.onInputChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            defaultValue: this.state.defaultValue,
            isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
            options: this.filterUsers(),
            menuIsOpen: this.props.menuIsOpen
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        };
        // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false;
        // Track if the domain-suggested email (`<query>@<suggestEmailsForDomain>`) for a partial
        // query already belongs to a returned user, in which case the suggestion is redundant
        this.lastDomainSuggestionMatchedUser = false;
        this.optionsShownUfoExperienceInstance = void 0;
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $j7Sza.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $kK1nI.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        };
        this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users;
        this.memoizedFilterOptions = (0, $dOBRD.default)(this.filterOptions);
        this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, fetchOptions: fetchOptions, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, verifiedTeams: verifiedTeams, orgId: orgId, userbaseId: userbaseId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, restrictTo: restrictTo, searchQueryFilter: searchQueryFilter, siteId: siteId, isTeamSyncedToGroupDirectoryFilter: isTeamSyncedToGroupDirectoryFilter, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $537559c2d938befb$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    userbaseId: userbaseId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                ...verifiedTeams === true && {
                    verifiedTeams: true
                },
                /*
        	For email-based searches, we have decided to filter out apps.
        	Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
        	when filter is empty, they have been added here to maintain consistency.
        		Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
         */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter,
                ...restrictTo && {
                    restrictTo: restrictTo
                },
                ...isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                }
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $kK1nI.requestUsersEvent));
                let recommendedUsers;
                if (fetchOptions && (0, $iDrrr.fg)('smart-user-picker-load-options-gate')) recommendedUsers = await fetchOptions(query);
                else {
                    const userRecommendationsPromise = (0, $b9heI.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $kK1nI.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                }
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $f1uNX.isUser)(option) || (0, $f1uNX.isExternalUser)(option) || (0, $f1uNX.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $f1uNX.isUser)(option) || (0, $f1uNX.isExternalUser)(option)) {
                        if (option.userType === (0, $jItb7.UserEntityType).DEFAULT || option.userType === (0, $jItb7.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $f1uNX.isGroup)(option) || (0, $f1uNX.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) {
                    // Only count user/external user matches, not teams or groups
                    const userMatches = recommendedUsers.filter((user)=>(0, $f1uNX.isUser)(user) || (0, $f1uNX.isExternalUser)(user));
                    this.lastEmailSearchFoundMatches = userMatches.length > 0;
                } else this.lastEmailSearchFoundMatches = false;
                // For a partial query with a suggested domain, check whether the email we would
                // synthesize (`<query>@<domain>`) already belongs to one of the returned users. If so,
                // the real user option is shown instead and the email suggestion is suppressed.
                const { suggestEmailsForDomain: suggestEmailsForDomain } = this.props;
                if (suggestEmailsForDomain && !isEmail && query) {
                    const suggestedEmail = `${query}@${suggestEmailsForDomain}`.toLowerCase();
                    this.lastDomainSuggestionMatchedUser = recommendedUsers.some((option)=>((0, $f1uNX.isUser)(option) || (0, $f1uNX.isExternalUser)(option)) && option.email?.toLowerCase() === suggestedEmail);
                } else this.lastDomainSuggestionMatchedUser = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $kK1nI.successfulRequestUsersEvent), {
                        users: $537559c2d938befb$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $537559c2d938befb$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                if (this.state.query !== query && (0, $iDrrr.fg)('smart-user-picker-fetch-error-fix')) {
                    // The query has moved on since this request was sent, so its results are not the ones
                    // on screen. Applying the failure here would clear the options and fail the UFO
                    // experience that belong to the newer query.
                    this.fireEvent((0, $kK1nI.failedRequestUsersEvent), {
                        elapsedTimeMilli: window.performance.now() - startTime,
                        productAttributes: productAttributes
                    });
                    return;
                }
                const is5xxEvent = $537559c2d938befb$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch  {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $kK1nI.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0);
        this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        };
        this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $kK1nI.filterUsersEvent), {
                    filtered: $537559c2d938befb$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $537559c2d938befb$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$537559c2d938befb$var$stringContains(user.name, query));
            this.fireEvent((0, $kK1nI.filterUsersEvent), {
                filtered: $537559c2d938befb$var$getUsersForAnalytics(queryFilteredUsers),
                all: $537559c2d938befb$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        };
        this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $kK1nI.preparedUsersLoadedEvent), {
                users: $537559c2d938befb$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        };
        this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $7GkXv.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
}
// TODO: Smart User picker team will have to add a type annotation here
$537559c2d938befb$export$9b9bd453d1d4e4ce.defaultProps = {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeTeamsUpdates: false,
    includeNonLicensedUsers: false,
    displayEmailInByline: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $537559c2d938befb$var$DEFAULT_DEBOUNCE_TIME_MS,
    userResolvers: [],
    enableEmailSearch: false,
    allowEmailSelectionWhenEmailMatched: true,
    verifiedTeams: false
};
const $537559c2d938befb$export$9eedb6e5d313efdb = (0, $lzgC6.default)()((0, $kSwu1.injectIntl)($537559c2d938befb$export$9b9bd453d1d4e4ce));
module.exports["SmartUserPicker"] = $537559c2d938befb$export$9eedb6e5d313efdb;

});

parcelRegister("kfLla", function(module, exports) {
/* UserPicker.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $lzgC6 = parcelRequire("lzgC6");


var $Vh9GY = parcelRequire("Vh9GY");

var $6wGOF = parcelRequire("6wGOF");


var $j7Sza = parcelRequire("j7Sza");


var $cozmU = parcelRequire("cozmU");


var $bmH9E = parcelRequire("bmH9E");


var $aeELu = parcelRequire("aeELu");


var $al9c2 = parcelRequire("al9c2");


var $1aEbM = parcelRequire("1aEbM");


var $7HZsv = parcelRequire("7HZsv");


var $i7OwT = parcelRequire("i7OwT");


var $50iN8 = parcelRequire("50iN8");


var $aZ910 = parcelRequire("aZ910");


var $kHija = parcelRequire("kHija");


var $iDrrr = parcelRequire("iDrrr");

function $039672e380479ab5$var$_defineProperty(e, r, t) {
    return (r = $039672e380479ab5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $039672e380479ab5$var$_toPropertyKey(t) {
    var i = $039672e380479ab5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $039672e380479ab5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $039672e380479ab5$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        const experienceForId = (0, $aZ910.userPickerRenderedUfoExperience).getInstance(this.ufoId); // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
            (0, $j7Sza.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $Vh9GY.default) : (0, $6wGOF.default);
        const creatableProps = suggestEmailsForDomain ? (0, $7HZsv.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $1aEbM.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZ910.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i7OwT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50iN8.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bmH9E.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            forwardedRef: this.props.forwardedRef,
            width: width,
            SelectComponent: SelectComponent,
            styles: (0, $aeELu.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $iDrrr.fg)('platform-component-visual-refresh'), false, this.props.height, this.props.minHeight),
            components: (0, $al9c2.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
            pickerProps: pickerProps
        }))));
    }
    constructor(props){
        super(props); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        $039672e380479ab5$var$_defineProperty(this, "ufoId", void 0);
        this.ufoId = (0, $kHija.v4)();
        const experienceForId = (0, $aZ910.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
            (0, $j7Sza.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
}
$039672e380479ab5$var$_defineProperty($039672e380479ab5$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $039672e380479ab5$export$83e0c73b09b3a9cd = (0, $lzgC6.default)()($039672e380479ab5$export$164f4d95e5d7e2f5);
module.exports["UserPicker"] = $039672e380479ab5$export$83e0c73b09b3a9cd;

});

parcelRegister("bmH9E", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $lzgC6 = parcelRequire("lzgC6");


var $j7Sza = parcelRequire("j7Sza");


var $55fM8 = parcelRequire("55fM8");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kHija = parcelRequire("kHija");


var $4hbXV = parcelRequire("4hbXV");


var $a4iVb = parcelRequire("a4iVb");


var $7xLai = parcelRequire("7xLai");


var $f1uNX = parcelRequire("f1uNX");


var $1Xd8s = parcelRequire("1Xd8s");


var $aZ910 = parcelRequire("aZ910");

const $a288f8d93fd9b6f7$var$loadingMessage = ()=>null;
const $a288f8d93fd9b6f7$var$classNamePrefix = 'fabric-user-picker';
class $a288f8d93fd9b6f7$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $f1uNX.optionToSelectableOptions)(nextProps.value);
        else if ((0, $f1uNX.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $f1uNX.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused or isHeaderFocused changes from true to false
        if (menuIsOpen && (prevProps.isFooterFocused === true && this.props.isFooterFocused === false || prevProps.isHeaderFocused === true && this.props.isHeaderFocused === false) && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $f1uNX.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $4hbXV.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $4hbXV.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $j7Sza.UFOExperienceState).STARTED.id,
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: this.props.openMenuOnFocus ?? true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $a288f8d93fd9b6f7$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).placeholder),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $a288f8d93fd9b6f7$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
    constructor(props){
        super(props);
        this.selectRef = void 0;
        this.session = void 0;
        // session id for focus to blur
        this.journeyId = void 0;
        this.optionsShownUfoExperienceInstance = void 0;
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $f1uNX.callCallback)(onChange, (0, $f1uNX.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $f1uNX.callCallback)(onSelection, (0, $f1uNX.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $4hbXV.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $4hbXV.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $f1uNX.callCallback)(onClear);
                    this.fireEvent((0, $4hbXV.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $4hbXV.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $4hbXV.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $a4iVb.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $4hbXV.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $f1uNX.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $j7Sza.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $f1uNX.callCallback)(this.props.onFocus, this.getSessionId());
            const openMenuOnFocus = this.props.openMenuOnFocus ?? true;
            if (!this.isMenuOpenOnClickForSingleSelect && openMenuOnFocus) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $f1uNX.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $f1uNX.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleOpen = ()=>{
            (0, $f1uNX.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleBlur = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            (0, $f1uNX.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $f1uNX.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleClose = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            this.resetInputState();
            (0, $f1uNX.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $f1uNX.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $4hbXV.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $4hbXV.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $4hbXV.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (event.key === 'Escape') {
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
                this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                this.props.setIsHeaderFocused && this.props.setIsHeaderFocused(false);
            }
            if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            if (event.key === 'Tab' && this.props.setIsHeaderFocused && this.props.header) this.props.setIsHeaderFocused(true);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptionsOld = ()=>{
            const options = (0, $f1uNX.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(options, groupByTypeOrder) : options;
        };
        this.getOptionsNew = ()=>{
            const options = (0, $f1uNX.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder, customGroupLabels: customGroupLabels } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder, customGroupLabels) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(options, groupByTypeOrder, customGroupLabels) : options;
        };
        this.getOptions = ()=>{
            return (0, $iDrrr.fg)('jsm-wfo-assignee-recommendation-on-queues') ? this.getOptionsNew() : this.getOptionsOld();
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused) || Boolean(!!this.props.header) && Boolean(this.props.isHeaderFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $aZ910.userPickerOptionsShownUfoExperience).getInstance((0, $kHija.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
}
$a288f8d93fd9b6f7$export$b4ff48c8d43b18c3.defaultProps = {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).errorMessage),
    openMenuOnClick: false
};
const $a288f8d93fd9b6f7$export$d099ade7b4f4d2a4 = (0, $lzgC6.default)()($a288f8d93fd9b6f7$export$b4ff48c8d43b18c3);
module.exports["BaseUserPickerWithoutAnalytics"] = $a288f8d93fd9b6f7$export$b4ff48c8d43b18c3;

});

parcelRegister("4hbXV", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $2iGHk = parcelRequire("2iGHk");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $kHija = parcelRequire("kHija");


var $f1uNX = parcelRequire("f1uNX");

const $dd632030d02bf872$var$packageName = "platform-pkg";
const $dd632030d02bf872$var$packageVersion = "0.0.0-use.local";
const $dd632030d02bf872$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $dd632030d02bf872$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $dd632030d02bf872$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $dd632030d02bf872$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $kHija.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $dd632030d02bf872$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
const $dd632030d02bf872$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $dd632030d02bf872$var$packageName,
            packageVersion: $dd632030d02bf872$var$packageVersion,
            ...attributes
        }
    });
const $dd632030d02bf872$var$checkValidId = (id)=>{
    return $dd632030d02bf872$var$UUID_REGEXP_NEW_AAID.test(id) || $dd632030d02bf872$var$UUID_REGEXP_OLD_AAID.test(id) || $dd632030d02bf872$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $dd632030d02bf872$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $dd632030d02bf872$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $f1uNX.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $f1uNX.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $dd632030d02bf872$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$dd632030d02bf872$var$optionData2Analytics(data));
    }
    return [];
};
const $dd632030d02bf872$var$selectedCustomGroupAnalyticsAttributes = (props, option)=>{
    if (!props.customGroupLabels) return {};
    const selectedType = option?.data.type;
    const analyticsLabel = selectedType ? props.customGroupAnalyticsLabels?.[selectedType] : undefined;
    return {
        hasCustomGroupLabels: true,
        ...analyticsLabel ? {
            selectedLabel: analyticsLabel
        } : {}
    };
};
const $dd632030d02bf872$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $dd632030d02bf872$var$sessionId(session),
        pickerType: $dd632030d02bf872$var$pickerType(props),
        journeyId: journeyId
    });
const $dd632030d02bf872$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$dd632030d02bf872$var$createEvent('ui', 'focused', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $dd632030d02bf872$var$buildValueForAnalytics(state.value)
    });
const $dd632030d02bf872$export$7b5800e732182efb = (props, state, session, journeyId)=>$dd632030d02bf872$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $dd632030d02bf872$var$values(state)
    });
const $dd632030d02bf872$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$dd632030d02bf872$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $dd632030d02bf872$var$sessionId(session),
        journeyId: journeyId,
        value: $dd632030d02bf872$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen,
        ...(0, $cXtTj.default).getExperimentValue('team_member_suggestions_while_creating_team', 'isEnabled', false) && args[0]?.isSuggestedMember !== undefined ? {
            isSuggestedMember: args[0].isSuggestedMember
        } : {}
    });
const $dd632030d02bf872$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$dd632030d02bf872$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $dd632030d02bf872$var$sessionDuration(session),
        queryLength: $dd632030d02bf872$var$queryLength(args[0]),
        spaceInQuery: $dd632030d02bf872$var$spaceInQuery(args[0]),
        upKeyCount: $dd632030d02bf872$var$upKeyCount(session),
        downKeyCount: $dd632030d02bf872$var$downKeyCount(session)
    });
const $dd632030d02bf872$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $dd632030d02bf872$var$createEvent('ui', $dd632030d02bf872$var$selectEventType(session), 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $dd632030d02bf872$var$sessionDuration(session),
        position: $dd632030d02bf872$var$position(state, args[0]),
        queryLength: $dd632030d02bf872$var$queryLength(state),
        spaceInQuery: $dd632030d02bf872$var$spaceInQuery(state),
        upKeyCount: $dd632030d02bf872$var$upKeyCount(session),
        downKeyCount: $dd632030d02bf872$var$downKeyCount(session),
        result: $dd632030d02bf872$var$result(args[0]),
        numberOfResults: $dd632030d02bf872$var$numberOfResults(state),
        ...(0, $iDrrr.fg)('jsm_routing_recommended_agent_minor_fix') ? $dd632030d02bf872$var$selectedCustomGroupAnalyticsAttributes(props, args[0]) : {}
    });
};
const $dd632030d02bf872$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $dd632030d02bf872$var$results(state);
    return $dd632030d02bf872$var$createEvent('operational', 'searched', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $dd632030d02bf872$var$sessionDuration(session),
        durationSinceInputChange: $dd632030d02bf872$var$durationSinceInputChange(session),
        queryLength: $dd632030d02bf872$var$queryLength(state),
        isLoading: $dd632030d02bf872$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $dd632030d02bf872$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$dd632030d02bf872$var$createEvent('operational', 'failed', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $dd632030d02bf872$export$f541f04954b0c11e = (sources, accountId)=>$dd632030d02bf872$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $dd632030d02bf872$var$checkValidId(accountId) ? accountId : null
    });
function $dd632030d02bf872$var$queryLength(state) {
    return state.inputValue.length;
}
function $dd632030d02bf872$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $dd632030d02bf872$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $dd632030d02bf872$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $dd632030d02bf872$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $dd632030d02bf872$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $dd632030d02bf872$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $dd632030d02bf872$var$sessionId(session) {
    return session && session.id;
}
function $dd632030d02bf872$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $dd632030d02bf872$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $dd632030d02bf872$var$result(option) {
    return option ? $dd632030d02bf872$var$optionData2Analytics(option.data) : null;
}
function $dd632030d02bf872$var$results(state) {
    return (state.options || []).map($dd632030d02bf872$var$optionData2Analytics);
}
function $dd632030d02bf872$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $dd632030d02bf872$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$dd632030d02bf872$var$optionData2Analytics(option.data)) : [
        $dd632030d02bf872$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $dd632030d02bf872$var$numberOfResults(state) {
    return (state.options || []).length;
}
module.exports["startSession"] = $dd632030d02bf872$export$c0d84948cecf78d8;
module.exports["createAndFireEventInElementsChannel"] = $dd632030d02bf872$export$53eef0dcd9611650;
module.exports["focusEvent"] = $dd632030d02bf872$export$e7818c470f37c4bd;
module.exports["clearEvent"] = $dd632030d02bf872$export$7b5800e732182efb;
module.exports["deleteEvent"] = $dd632030d02bf872$export$95711ec6c6227e9a;
module.exports["cancelEvent"] = $dd632030d02bf872$export$e9caaaecfee38128;
module.exports["selectEvent"] = $dd632030d02bf872$export$48143d759475d90f;
module.exports["searchedEvent"] = $dd632030d02bf872$export$911fb7184b6037eb;
module.exports["failedEvent"] = $dd632030d02bf872$export$c2aec355fef65c9c;
module.exports["userInfoEvent"] = $dd632030d02bf872$export$f541f04954b0c11e;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("f1uNX", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $3GNtk = parcelRequire("3GNtk");

const $f703df8a196cd65a$export$f6058dbcb5980cb = (option)=>option.type === (0, $9kYT2.ExternalUserType) || Boolean(option.isExternal);
const $f703df8a196cd65a$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $9kYT2.UserType);
const $f703df8a196cd65a$export$f8c4277cb588611f = (option)=>option?.type === (0, $9kYT2.TeamType);
const $f703df8a196cd65a$export$d7976824e9f55785 = (option)=>option.type === (0, $9kYT2.GroupType);
const $f703df8a196cd65a$export$7fbbfbca30081d0 = (option)=>option.type === (0, $9kYT2.EmailType);
const $f703df8a196cd65a$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $9kYT2.CustomType);
const $f703df8a196cd65a$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $f703df8a196cd65a$var$isOptionData = (option)=>option.name !== undefined;
const $f703df8a196cd65a$export$3f993c492bd6c728 = (option)=>{
    if ($f703df8a196cd65a$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $f703df8a196cd65a$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $f703df8a196cd65a$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $f703df8a196cd65a$export$d2312e68e1f5ad00 = (0, $dOBRD.default)((options)=>options.map($f703df8a196cd65a$export$3f993c492bd6c728));
const $f703df8a196cd65a$export$e6fda14a194bcbcc = (0, $dOBRD.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($f703df8a196cd65a$export$3f993c492bd6c728);
    return $f703df8a196cd65a$export$3f993c492bd6c728(defaultValue);
});
const $f703df8a196cd65a$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xxsmall' : 'small';
const $f703df8a196cd65a$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $f703df8a196cd65a$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $f703df8a196cd65a$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $f703df8a196cd65a$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $f703df8a196cd65a$export$b4f8f1f54acec99b = (optionData)=>{
    if ($f703df8a196cd65a$export$2e44165f1da65304(optionData) || $f703df8a196cd65a$export$f8c4277cb588611f(optionData) || $f703df8a196cd65a$export$d3a8f0b77e9737fc(optionData) || $f703df8a196cd65a$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $f703df8a196cd65a$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $3GNtk.PopupSelect);
const $f703df8a196cd65a$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $f703df8a196cd65a$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};
module.exports["isExternalUser"] = $f703df8a196cd65a$export$f6058dbcb5980cb;
module.exports["isUser"] = $f703df8a196cd65a$export$2e44165f1da65304;
module.exports["isTeam"] = $f703df8a196cd65a$export$f8c4277cb588611f;
module.exports["isGroup"] = $f703df8a196cd65a$export$d7976824e9f55785;
module.exports["isEmail"] = $f703df8a196cd65a$export$7fbbfbca30081d0;
module.exports["isCustom"] = $f703df8a196cd65a$export$d3a8f0b77e9737fc;
module.exports["isDefaultValuePopulated"] = $f703df8a196cd65a$export$d6978985a41b0c8;
module.exports["extractOptionValue"] = $f703df8a196cd65a$export$7ae97131df521bff;
module.exports["isIterable"] = $f703df8a196cd65a$export$9652023d9040757;
module.exports["getOptions"] = $f703df8a196cd65a$export$d2312e68e1f5ad00;
module.exports["optionToSelectableOptions"] = $f703df8a196cd65a$export$e6fda14a194bcbcc;
module.exports["getAvatarSize"] = $f703df8a196cd65a$export$695fb564e621339a;
module.exports["isChildInput"] = $f703df8a196cd65a$export$3c62cf9a01367f27;
module.exports["isSingleValue"] = $f703df8a196cd65a$export$203c2bd2662d1ca2;
module.exports["hasValue"] = $f703df8a196cd65a$export$96bdbc84526f3739;
module.exports["callCallback"] = $f703df8a196cd65a$export$df325aa844b03c31;
module.exports["getAvatarUrl"] = $f703df8a196cd65a$export$b4f8f1f54acec99b;
module.exports["isPopupUserPickerByComponent"] = $f703df8a196cd65a$export$4f60a74234178416;
module.exports["isLozengeText"] = $f703df8a196cd65a$export$5419897287f5f1c7;

});

parcelRegister("9kYT2", function(module, exports) {
const $7b15e63389e1c86f$export$8436e53e45ffe15b = 'user';
const $7b15e63389e1c86f$export$50042ec1d2e00e63 = 'external_user';
const $7b15e63389e1c86f$export$26bc40b960693765 = 'team';
const $7b15e63389e1c86f$export$d460f747b73abb10 = 'group';
const $7b15e63389e1c86f$export$6662b3461398ef8c = 'email';
const $7b15e63389e1c86f$export$eafd0979afa5b224 = 'custom';
module.exports["UserType"] = $7b15e63389e1c86f$export$8436e53e45ffe15b;
module.exports["ExternalUserType"] = $7b15e63389e1c86f$export$50042ec1d2e00e63;
module.exports["TeamType"] = $7b15e63389e1c86f$export$26bc40b960693765;
module.exports["GroupType"] = $7b15e63389e1c86f$export$d460f747b73abb10;
module.exports["EmailType"] = $7b15e63389e1c86f$export$6662b3461398ef8c;
module.exports["CustomType"] = $7b15e63389e1c86f$export$eafd0979afa5b224;

});

parcelRegister("a4iVb", function(module, exports) {
function $77fb950dcbf791ab$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}
module.exports["batchByKey"] = $77fb950dcbf791ab$export$da86c38211c1c0a8;

});

parcelRegister("7xLai", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b9ef7149d9297ba5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "fabric.elements.user-picker.placeholder",
        defaultMessage: "Enter people or teams..."
    },
    addMore: {
        id: "fabric.elements.user-picker.placeholder.add-more",
        defaultMessage: "add more people..."
    },
    remove: {
        id: "fabric.elements.user-picker.multi.remove-item",
        defaultMessage: "Remove"
    },
    clear: {
        id: "fabric.elements.user-picker.single.clear",
        defaultMessage: "Clear"
    },
    errorMessage: {
        id: "fabric.elements.user-picker.error.message",
        defaultMessage: "Something went wrong"
    },
    teamByline: {
        id: "fabric.elements.user-picker.team.byline",
        defaultMessage: "Team"
    },
    officialTeamByline: {
        id: "fabric.elements.user-picker.team.byline.official",
        defaultMessage: "{teamTypeName} {verifiedIcon}"
    },
    officialMemberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}"
    },
    officialMemberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.including.you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    officialPlus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members"
    },
    officialPlus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    addEmail: {
        id: "fabric.elements.user-picker.email.add",
        defaultMessage: "Add user"
    },
    selectToAddEmail: {
        id: "fabric.elements.user-picker.email.select.to.add",
        defaultMessage: "Select an email address"
    },
    continueToAddEmail: {
        id: "fabric.elements.user-picker.email.add.potential",
        defaultMessage: "Enter an email address"
    },
    adminManagedGroupByline: {
        id: "fabric.elements.user-picker.group.byline.admin-managed",
        defaultMessage: "Admin group {verifiedIcon}"
    },
    groupByline: {
        id: "fabric.elements.user-picker.group.byline",
        defaultMessage: "Admin-managed group"
    },
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    externalUserSourcesError: {
        id: "fabric.elements.user-picker.external.sourced.error",
        defaultMessage: "We can't connect you right now."
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    jiraSource: {
        id: "fabric.elements.user-picker.source.jira",
        defaultMessage: "Jira"
    },
    confluenceSource: {
        id: "fabric.elements.user-picker.source.confluence",
        defaultMessage: "Confluence"
    },
    otherAtlassianSource: {
        id: "fabric.elements.user-picker.source.other-atlassian",
        defaultMessage: "Other Atlassian products"
    },
    otherAtlassianSourceAppify: {
        id: "fabric.elements.user-picker.source.other-atlassian-appify",
        defaultMessage: "Other Atlassian apps"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    },
    archivedLozenge: {
        id: "fabric.elements.user-picker.archived.lozenge.text",
        defaultMessage: "Archived"
    },
    userTypeLabel: {
        id: "fabric.elements.user-picker.user.type.label",
        defaultMessage: "People"
    },
    teamTypeLabel: {
        id: "fabric.elements.user-picker.team.type.label",
        defaultMessage: "Teams"
    },
    emailTypeLabel: {
        id: "fabric.elements.user-picker.email.type.label",
        defaultMessage: "Emails"
    },
    groupTypeLabel: {
        id: "fabric.elements.user-picker.group.type.label",
        defaultMessage: "Groups"
    },
    externalUserTypeLabel: {
        id: "fabric.elements.user-picker.external.user.type.label",
        defaultMessage: "External Users"
    },
    customTypeLabel: {
        id: "fabric.elements.user-picker.custom.type.label",
        defaultMessage: "Customs"
    },
    otherTypeLabel: {
        id: "fabric.elements.user-picker.other.type.label",
        defaultMessage: "Others"
    }
});
module.exports["messages"] = $b9ef7149d9297ba5$export$defe85febe8b728c;

});

parcelRegister("1Xd8s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $7xLai = parcelRequire("7xLai");

const $21c303164bc44ab5$var$getLabelForType = (type, customLabels)=>{
    if (customLabels && type in customLabels && (0, $iDrrr.fg)('jsm-wfo-assignee-recommendation-on-queues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customLabels[type]);
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).userTypeLabel);
        case 'team':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).teamTypeLabel);
        case 'group':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).groupTypeLabel);
        case 'custom':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).customTypeLabel);
        case 'external_user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).externalUserTypeLabel);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).otherTypeLabel);
    }
};
const $21c303164bc44ab5$export$393a985f7dd07cfe = (0, $dOBRD.default)((options, groupByTypeOrder, customGroupLabels)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $21c303164bc44ab5$var$getLabelForType(type, customGroupLabels),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});
module.exports["groupOptionsByType"] = $21c303164bc44ab5$export$393a985f7dd07cfe;

});

parcelRegister("aZ910", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

var $j7Sza = parcelRequire("j7Sza");

const $e55e5f2e4b7d5736$export$b49757166e1acfc2 = new (0, $fh15z.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e55e5f2e4b7d5736$export$135a264e0da507ae = new (0, $fh15z.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
});
class $e55e5f2e4b7d5736$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        const instance = $e55e5f2e4b7d5736$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $j7Sza.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["userPickerRenderedUfoExperience"] = $e55e5f2e4b7d5736$export$b49757166e1acfc2;
module.exports["userPickerOptionsShownUfoExperience"] = $e55e5f2e4b7d5736$export$135a264e0da507ae;
module.exports["UfoErrorBoundary"] = $e55e5f2e4b7d5736$export$5ef1c2550074a375;

});

parcelRegister("aeELu", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $1TlML = parcelRequire("1TlML");


var $dOBRD = parcelRequire("dOBRD");

const $4ae7cbc7591eb216$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $4ae7cbc7591eb216$export$53937c04f7dfc2ae = 6;
const $4ae7cbc7591eb216$export$2c62ba763e976c54 = 39;
const $4ae7cbc7591eb216$export$ffd58b7f6f099a57 = (0, $dOBRD.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height, minHeight)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : state.selectProps.subtle ? 'transparent' : state.isDisabled && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-background-disabled, #0515240F)" : state.selectProps.textFieldBackgroundColor ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)",
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? "var(--ds-background-danger, #FFECEB)" : state.isFocused ? css[':hover'] ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)" : state.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-background-input-hovered, #F8F8F8)"
                },
                padding: 0,
                minHeight: minHeight ? minHeight : height || isCompact ? isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 30 : 'none' : isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 42 : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _paddingLeft: _paddingLeft, _paddingRight: _paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _position: _position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b,
                paddingBottom: isCompact ? isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b,
                // Match pre–tag-uplift leading inset when only the placeholder shows (share dialog VR, etc.).
                paddingLeft: isMulti ? state.hasValue && state.selectProps.controlShouldRenderValue !== false && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b : 0,
                gap: isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-050, 4px)" : undefined,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$4ae7cbc7591eb216$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $4ae7cbc7591eb216$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 0 : `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                ...isMulti && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && {
                    height: "var(--ds-space-250, 20px)",
                    alignItems: 'center'
                },
                paddingLeft: state.selectProps.isMulti ? 0 : $4ae7cbc7591eb216$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: "var(--ds-text-subtlest, #6B6E76)",
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: "var(--ds-text-subtlest, #6B6E76)"
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $1TlML.mergeStyles)(styles, overrideStyles) : styles;
});
const $4ae7cbc7591eb216$export$4e983f376ad8a3af = (0, $dOBRD.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$4ae7cbc7591eb216$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));
module.exports["getStyles"] = $4ae7cbc7591eb216$export$ffd58b7f6f099a57;

});

parcelRegister("al9c2", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $73k2m = parcelRequire("73k2m");


var $1UZNj = parcelRequire("1UZNj");


var $88TF2 = parcelRequire("88TF2");


var $cs8ca = parcelRequire("cs8ca");


var $c48SA = parcelRequire("c48SA");


var $cnIP4 = parcelRequire("cnIP4");


var $bPMiS = parcelRequire("bPMiS");


var $97jiw = parcelRequire("97jiw");


var $8otJJ = parcelRequire("8otJJ");


var $bV3S4 = parcelRequire("bV3S4");


var $dnFcR = parcelRequire("dnFcR");

const $c4825579da0c037a$export$4e811121b221213b = (0, $dOBRD.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $cs8ca.Option
    };
    else return {
        MultiValue: $1UZNj.MultiValue,
        DropdownIndicator: null,
        SingleValue: $c48SA.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $73k2m.ClearIndicator) : null,
        Option: $cs8ca.Option,
        ValueContainer: multi ? (0, $88TF2.MultiValueContainer) : (0, $bPMiS.SingleValueContainer),
        Input: $cnIP4.Input,
        Menu: $bV3S4.Menu,
        Control: $dnFcR.default,
        ...customComponents ? customComponents : {}
    };
});
const $c4825579da0c037a$export$19205fd341a6bb08 = (0, $dOBRD.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $c48SA.SingleValue,
        ClearIndicator: $73k2m.ClearIndicator,
        Option: $cs8ca.Option,
        ValueContainer: (0, $bPMiS.SingleValueContainer),
        Input: (0, $97jiw.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $8otJJ.PopupControl)
    };
    return baseProps;
});
module.exports["getComponents"] = $c4825579da0c037a$export$4e811121b221213b;

});

parcelRegister("73k2m", function(module, exports) {
/* ClearIndicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

function $f2345ab9bbe409ae$var$_defineProperty(e, r, t) {
    return (r = $f2345ab9bbe409ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2345ab9bbe409ae$var$_toPropertyKey(t) {
    var i = $f2345ab9bbe409ae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f2345ab9bbe409ae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

const $f2345ab9bbe409ae$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("8GbgH")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $f2345ab9bbe409ae$var$clearIndicatorStyles = {
    root: "_23rrnHyl2N _1YKVNs7dHp _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0clgaM7j8z _06EbysAASz"
};
class $f2345ab9bbe409ae$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $f2345ab9bbe409ae$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2345ab9bbe409ae$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        $f2345ab9bbe409ae$var$_defineProperty(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
             // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue(); //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
}
module.exports["ClearIndicator"] = $f2345ab9bbe409ae$export$ecf9cf59142dd54a;

});

parcelRegister("8GbgH", function(module, exports) {

let $651afca19fe3ed7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $651afca19fe3ed7a$var$load("9XXCk").then(()=>parcelRequire('2TLXz'));

});

parcelRegister("1UZNj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");


var $lOiVq = parcelRequire("lOiVq");


var $arQY7 = parcelRequire("arQY7");


var $iDrrr = parcelRequire("iDrrr");


var $3Una5 = parcelRequire("3Una5");

var $IOtUu = parcelRequire("IOtUu");


var $2c3Eq = parcelRequire("2c3Eq");


var $kBIAo = parcelRequire("kBIAo");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $9KSWX = parcelRequire("9KSWX");


var $fBqzD = parcelRequire("fBqzD");


var $aRrFB = parcelRequire("aRrFB");


var $kSwu1 = parcelRequire("kSwu1");


var $7xLai = parcelRequire("7xLai");

function $bffbf0089c3afad8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bffbf0089c3afad8$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $bffbf0089c3afad8$var$groupTagContainerOld = (0, $buxP3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $bffbf0089c3afad8$var$groupTagContainer = (0, $buxP3.xcss)({
    paddingLeft: 'space.050'
});
const $bffbf0089c3afad8$var$archivedLozengeWrapper = (0, $buxP3.xcss)({
    display: 'flex',
    paddingLeft: 'space.050'
});
const $bffbf0089c3afad8$var$iconStyle = {
    name: "1sq8lny",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:20px;height:20px"
};
const $bffbf0089c3afad8$var$nameWrapper = {
    name: "1b3uxdh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
const $bffbf0089c3afad8$var$avatarTagWrapperStyle = {
    name: "14413o7",
    styles: "display:flex;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
class $bffbf0089c3afad8$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $bffbf0089c3afad8$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: option, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: nextOption, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        if (option == null || nextOption == null) return option !== nextOption || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        const { label: label, data: data } = option;
        const { label: nextLabel, data: nextData } = nextOption;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: _innerProps, removeProps: removeProps, data: option, ...rest } = this.props;
        if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const { data: data, label: label } = option;
            const isTeamOption = (0, $f1uNX.isTeam)(data);
            const isGroupOption = (0, $f1uNX.isGroup)(data);
            const isEmailOption = (0, $f1uNX.isEmail)(data);
            const avatarUrl = (0, $f1uNX.getAvatarUrl)(data);
            const isDisabled = Boolean(this.props.selectProps?.isDisabled);
            const canShowArchivedLozenge = (0, $f1uNX.isTeam)(data) && data?.state === 'DISBANDED';
            const avatarProps = avatarUrl ? {
                name: data.name,
                src: avatarUrl
            } : {
                name: data.name
            };
            const onAfterRemoveAction = ()=>{
                removeProps.onClick({});
            };
            if (isEmailOption) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kBIAo.AddOptionAvatar), {
                    isLozenge: true,
                    isPendingAction: data.isPendingAction
                }),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (isGroupOption) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                    xcss: $bffbf0089c3afad8$var$groupTagContainer
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (data.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: $bffbf0089c3afad8$var$iconStyle,
                    style: {
                        color: data.iconColor
                    }
                }, data.icon),
                isRemovable: !isDisabled,
                hasMargin: false,
                onAfterRemoveAction: onAfterRemoveAction
            }));
            return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, isTeamOption ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3Una5.default), {
                type: "other",
                text: label,
                isVerified: isTeamOption ? data.verified : undefined,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>// AvatarTag always supplies size="xxsmall", which is a valid
                    // TeamAvatarSize; TeamAvatar does not support UNSAFE_xsmall.
                    /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2c3Eq.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }), canShowArchivedLozenge ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $bffbf0089c3afad8$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), {
                appearance: "neutral"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3Una5.default), {
                type: "user",
                text: label,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $arQY7.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }));
        }
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l9ukq.components).MultiValue, {
            ...rest,
            data: option,
            removeProps: removeProps,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kz1Yj.Inline), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $bffbf0089c3afad8$var$nameWrapper
        }, children), this.getElemAfter()));
    }
    constructor(props){
        super(props);
        this.containerRef = void 0;
        this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $f1uNX.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kBIAo.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $f1uNX.isGroup)(data)) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $bffbf0089c3afad8$var$groupTagContainerOld
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                color: "currentColor",
                label: ""
            }));
            if (data.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lvlsM.AvatarOrIcon), {
                appearance: "multi",
                icon: data.icon,
                iconColor: data.iconColor,
                src: (0, $f1uNX.getAvatarUrl)(data),
                type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person'
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
                appearance: "multi",
                src: (0, $f1uNX.getAvatarUrl)(data),
                type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person'
            });
        };
        this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            const canShowArchivedLozenge = (0, $f1uNX.isTeam)(data) && data?.state === 'DISBANDED';
            if ((0, $f1uNX.isGroup)(data) && data.includeTeamsUpdates || (0, $f1uNX.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aRrFB.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            if (canShowArchivedLozenge) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $bffbf0089c3afad8$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), {
                appearance: "neutral"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge)));
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
module.exports["MultiValue"] = $bffbf0089c3afad8$export$419cdf50db8b579;

});

parcelRegister("kBIAo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ldb9Z = parcelRequire("ldb9Z");


var $lOiVq = parcelRequire("lOiVq");

parcelRequire("cozmU");

const $d4e90a9cb054ea8d$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction ? "var(--ds-background-warning, #FFF5DB)" : "var(--ds-background-neutral, #0515240F)";
    return /*#__PURE__*/ (0, $lOiVq.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $d4e90a9cb054ea8d$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $d4e90a9cb054ea8d$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        color: isPendingAction ? "var(--ds-text-warning, #9E4C00)" : "var(--ds-text-subtle, #505258)"
    })));
};
module.exports["AddOptionAvatar"] = $d4e90a9cb054ea8d$export$df396db45e491922;

});

parcelRegister("lvlsM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $lOiVq = parcelRequire("lOiVq");

function $25f984a67853b2bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $25f984a67853b2bf$var$iconStyle = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $25f984a67853b2bf$var$iconSizes = {
    xxsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    xsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    small: {
        name: "1c76jn8",
        styles: "width:28px;height:28px"
    },
    medium: {
        name: "bgbjt4",
        styles: "width:36px;height:36px"
    }
};
const $25f984a67853b2bf$export$60751fd23180a0ed = ({ appearance: appearance = 'big', avatarAppearanceShape: avatarAppearanceShape, icon: icon, iconColor: iconColor, presence: presence, src: src, type: type = 'person' })=>{
    // If icon is provided, render it instead of avatar
    if (icon) {
        const avatarSize = (0, $f1uNX.getAvatarSize)(appearance);
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $25f984a67853b2bf$var$iconStyle,
                $25f984a67853b2bf$var$iconSizes[avatarSize]
            ],
            style: {
                color: iconColor
            }
        }, icon);
    }
    // Otherwise, render the avatar as before
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
        appearance: appearance,
        src: src,
        presence: presence,
        type: type,
        avatarAppearanceShape: avatarAppearanceShape
    });
};
module.exports["AvatarOrIcon"] = $25f984a67853b2bf$export$60751fd23180a0ed;

});

parcelRegister("cGbTM", function(module, exports) {

var $arQY7 = parcelRequire("arQY7");


var $2c3Eq = parcelRequire("2c3Eq");


var $cozmU = parcelRequire("cozmU");


var $f1uNX = parcelRequire("f1uNX");

class $e2222437848781c0$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const size = (0, $f1uNX.getAvatarSize)(appearance);
        const props = {
            size: size,
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), props);
    }
}
module.exports["SizeableAvatar"] = $e2222437848781c0$export$44d81a88129649da;

});

parcelRegister("88TF2", function(module, exports) {
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $l9ukq = parcelRequire("l9ukq");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $7xLai = parcelRequire("7xLai");


var $f1uNX = parcelRequire("f1uNX");


var $9gNGh = parcelRequire("9gNGh");


var $k12R1 = parcelRequire("k12R1");

function $f3ca9dc7e39dcc1b$var$_defineProperty(e, r, t) {
    return (r = $f3ca9dc7e39dcc1b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f3ca9dc7e39dcc1b$var$_toPropertyKey(t) {
    var i = $f3ca9dc7e39dcc1b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f3ca9dc7e39dcc1b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $f3ca9dc7e39dcc1b$var$valueContainerStyles = {
    root: "_2iEGP2N2y8 _4bt5LAnQyn _2WAcuGIZbP _3oUqlsYbGa _0NUa3rN91d _4ho0wCjOvk _3ILZpPdnbC",
    paddingLegacy: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q2ADO",
    tagUpliftVerticalDefault: "_0Of8r22ADO _1wydGW2ADO",
    tagUpliftVerticalCompact: "_0Of8r2FQfX _1wydGWFQfX",
    paddingLeftTight: "_2Zuz6QgVvo",
    paddingLeftWide: "_2Zuz6Q2ADO",
    withFlexAndGap: "_2mHwu81Y8M _2iEGP2ZqHV _3TGfC9HnLE"
};
class $f3ca9dc7e39dcc1b$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: _children, innerProps: _innerProps, hasValue: hasValue, isCompact: isCompact, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            hasValue: hasValue,
            isCompact: isCompact,
            innerProps: this.valueContainerInnerProps
        };
        const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
        const controlRendersValueInControl = this.props.selectProps.controlShouldRenderValue !== false;
        const tagUpliftChipRow = ffTagUplifts && hasValue && controlRendersValueInControl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gNGh.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
            ...props,
            xcss: (0, $k12R1.cx)($f3ca9dc7e39dcc1b$var$valueContainerStyles.root, !ffTagUplifts && $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLegacy, ffTagUplifts && (isCompact ? $f3ca9dc7e39dcc1b$var$valueContainerStyles.tagUpliftVerticalCompact : $f3ca9dc7e39dcc1b$var$valueContainerStyles.tagUpliftVerticalDefault), ffTagUplifts && (tagUpliftChipRow ? $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLeftWide : $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLeftTight), tagUpliftChipRow && $f3ca9dc7e39dcc1b$var$valueContainerStyles.withFlexAndGap)
        }, this.renderChildren()));
    }
    constructor(props){
        super(props);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "valueContainerInnerProps", void 0);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "timeoutId", null);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(this.props.children, (child)=>(0, $f1uNX.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "renderChildren", ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props; // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        }); //@ts-ignore react-select unsupported props
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef()
        };
    }
}
module.exports["MultiValueContainer"] = $f3ca9dc7e39dcc1b$export$cf9cf2a30a59265c;

});

parcelRegister("9gNGh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $93cc2b2f9d20e1e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $93cc2b2f9d20e1e3$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $93cc2b2f9d20e1e3$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $93cc2b2f9d20e1e3$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $93cc2b2f9d20e1e3$export$2e2bcd8739ae039 = $93cc2b2f9d20e1e3$var$ValueContainerWrapper;
module.exports["default"] = $93cc2b2f9d20e1e3$export$2e2bcd8739ae039;

});

parcelRegister("cs8ca", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iMnC5 = parcelRequire("iMnC5");


var $l9ukq = parcelRequire("l9ukq");


var $lpNn5 = parcelRequire("lpNn5");


var $cozmU = parcelRequire("cozmU");


var $2c63x = parcelRequire("2c63x");


var $bYoB2 = parcelRequire("bYoB2");


var $k0mXu = parcelRequire("k0mXu");


var $hohk8 = parcelRequire("hohk8");


var $cTtI6 = parcelRequire("cTtI6");


var $2RstY = parcelRequire("2RstY");


var $f1uNX = parcelRequire("f1uNX");


var $bsEy7 = parcelRequire("bsEy7");

const $e10fd610d1140d68$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c63x.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $e10fd610d1140d68$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $f1uNX.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYoB2.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $f1uNX.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c63x.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $f1uNX.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTtI6.default), {
        email: data,
        emailValidity: (0, $bsEy7.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $f1uNX.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k0mXu.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $f1uNX.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hohk8.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $f1uNX.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2RstY.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $e10fd610d1140d68$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), tooltipProps, $e10fd610d1140d68$var$dataOption(props)));
    return $e10fd610d1140d68$var$dataOption(props);
};
const $e10fd610d1140d68$export$36d18380658d5d20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const t0 = props;
    let t1;
    if ($[0] !== props) {
        t1 = $e10fd610d1140d68$var$defaultOption(props);
        $[0] = props;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = $e10fd610d1140d68$var$dataOptionWithTooltip(props);
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: t1
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t0 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, t0, t3);
        $[7] = t0;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: $e10fd610d1140d68$var$defaultOption(props)
    }, $e10fd610d1140d68$var$dataOptionWithTooltip(props)));
module.exports["Option"] = $e10fd610d1140d68$export$36d18380658d5d20;

});

parcelRegister("2c63x", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dWZMi = parcelRequire("dWZMi");


var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $pr26r = parcelRequire("pr26r");


var $apA01 = parcelRequire("apA01");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $iDrrr = parcelRequire("iDrrr");

class $afa55f5fa163021c$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $pr26r.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $pr26r.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)")
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $apA01.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $f1uNX.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)";
                result.push(/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $pr26r.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $lOiVq.jsx)((0, $apA01.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $pr26r.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)")
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType, icon: icon, iconColor: iconColor }, status: status } = this.props;
            const appearance = (0, $iDrrr.fg)('platform-component-visual-refresh') ? 'medium' : 'big';
            if (icon) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lvlsM.AvatarOrIcon), {
                appearance: appearance,
                icon: icon,
                iconColor: iconColor,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dWZMi.default)(appType)
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
                appearance: appearance,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dWZMi.default)(appType)
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
module.exports["UserOption"] = $afa55f5fa163021c$export$8e59f78010871662;

});

parcelRegister("pr26r", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $9KSWX = parcelRequire("9KSWX");


var $IOtUu = parcelRequire("IOtUu");


var $f1uNX = parcelRequire("f1uNX");


var $iDrrr = parcelRequire("iDrrr");

function $09486341bedb25c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $09486341bedb25c7$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("8GbgH")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $09486341bedb25c7$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $lOiVq.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $09486341bedb25c7$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $09486341bedb25c7$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $lOiVq.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $09486341bedb25c7$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $09486341bedb25c7$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $lOiVq.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $09486341bedb25c7$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
const $09486341bedb25c7$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderTag = ()=>{
        if ((0, $f1uNX.isLozengeText)(lozenge) && !lozenge.isBold) {
            const color = lozenge.appearance ? $09486341bedb25c7$var$lozengeAppearanceToTagColor[lozenge.appearance] : 'standard';
            const tag = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: lozenge.text,
                color: color,
                isRemovable: false,
                migration_fallback: "lozenge"
            });
            if (lozenge.tooltip) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: tag
            }, /*#__PURE__*/ (0, $lOiVq.jsx)($09486341bedb25c7$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, tag));
            return tag;
        }
        return renderLozenge();
    };
    const renderLozenge = ()=>{
        if ((0, $f1uNX.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)($09486341bedb25c7$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $09486341bedb25c7$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$optionWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$additionalInfo
    }, (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? renderTag() : renderLozenge())));
};
module.exports["textWrapper"] = $09486341bedb25c7$export$aa6223da92b253dd;
module.exports["AvatarItemOption"] = $09486341bedb25c7$export$164a9d9b3b86dd0c;

});

parcelRegister("apA01", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $f375a32a5b8051ad$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}
module.exports["HighlightText"] = $f375a32a5b8051ad$export$bb02e7bc6e1a7119;

});

parcelRegister("bYoB2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a3b2e53394cea8af$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("56JsK")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $a3b2e53394cea8af$export$2e2bcd8739ae039 = $a3b2e53394cea8af$var$AsyncExternalUserOption;
module.exports["default"] = $a3b2e53394cea8af$export$2e2bcd8739ae039;

});

parcelRegister("56JsK", function(module, exports) {

let $3b80c73b9dae979d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b80c73b9dae979d$var$load("6Vp6A"),
    $3b80c73b9dae979d$var$load("l9aze")
]).then(()=>parcelRequire('hjSks'));

});

parcelRegister("k0mXu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $334e5641372502ac$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("Blpcv")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $334e5641372502ac$export$2e2bcd8739ae039 = $334e5641372502ac$var$AsyncTeamOption;
module.exports["default"] = $334e5641372502ac$export$2e2bcd8739ae039;

});

parcelRegister("Blpcv", function(module, exports) {

let $07040f7ebd894018$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07040f7ebd894018$var$load("dBsbZ").then(()=>parcelRequire('k0sQA'));

});

parcelRegister("hohk8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $85cffe183f5a17a9$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("0YD1J")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $85cffe183f5a17a9$export$2e2bcd8739ae039 = $85cffe183f5a17a9$var$AsyncGroupOption;
module.exports["default"] = $85cffe183f5a17a9$export$2e2bcd8739ae039;

});

parcelRegister("0YD1J", function(module, exports) {

let $002f07c0999fbf19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $002f07c0999fbf19$var$load("fFsaR").then(()=>parcelRequire('hrN4e'));

});

parcelRegister("cTtI6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a5138e07c3616ec7$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("hJOc8")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $a5138e07c3616ec7$export$2e2bcd8739ae039 = $a5138e07c3616ec7$var$AsyncEmailOption;
module.exports["default"] = $a5138e07c3616ec7$export$2e2bcd8739ae039;

});

parcelRegister("hJOc8", function(module, exports) {

let $ce9d9343e981ef24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce9d9343e981ef24$var$load("g8N2Z").then(()=>parcelRequire('3wXNe'));

});

parcelRegister("2RstY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $846221ee191ca6c1$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("5aSGg")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $846221ee191ca6c1$export$2e2bcd8739ae039 = $846221ee191ca6c1$var$AsyncCustomOption;
module.exports["default"] = $846221ee191ca6c1$export$2e2bcd8739ae039;

});

parcelRegister("5aSGg", function(module, exports) {

let $3c484d605f8245e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c484d605f8245e8$var$load("k9RdS").then(()=>parcelRequire('f8Kzz'));

});

parcelRegister("bsEy7", function(module, exports) {
const $c776d91474b4faaf$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $c776d91474b4faaf$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $c776d91474b4faaf$export$371e338370561054 = (inputText)=>{
    if (inputText.match($c776d91474b4faaf$var$validRegex)) return 'VALID';
    if (inputText.match($c776d91474b4faaf$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};
module.exports["isValidEmail"] = $c776d91474b4faaf$export$371e338370561054;

});

parcelRegister("c48SA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l9ukq = parcelRequire("l9ukq");


var $9KSWX = parcelRequire("9KSWX");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $dWZMi = parcelRequire("dWZMi");


var $aRrFB = parcelRequire("aRrFB");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $7xLai = parcelRequire("7xLai");

const $afcedb8febd5dd73$var$styles = {
    avatarItem: "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _4ouGXIQEt6",
    avatarItemTextWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _4ouGXIdnbC _1EqgXlN91d _0LQT5E2ADO _26BoRwflal",
    avatarItemText: "_1UtDYzy7kJ _4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7",
    archivedLozengeWrapper: "_3iDTPbQ4SZ _2Zuz6Q1Y8M"
};
const $afcedb8febd5dd73$var$ElementAfter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    const { data: t0, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const { data: data } = t0;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $f1uNX.isTeam)(data) && data.verified || (0, $f1uNX.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) {
        const t1 = data.includeTeamsUpdates ? "small" : "medium";
        let t2;
        if ($[0] !== t1) {
            t2 = /*#__PURE__*/ $cozmU.createElement((0, $aRrFB.VerifiedTeamIcon), {
                size: t1
            });
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    return null;
} : (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $f1uNX.isTeam)(data) && data.verified || (0, $f1uNX.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ $cozmU.createElement((0, $aRrFB.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
const $afcedb8febd5dd73$export$1949dac661ba6e3a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { data: t0, selectProps: t1 } = props;
    const { label: label, data: data } = t0;
    const { appearance: appearance, isFocused: isFocused } = t1;
    let t2;
    if ($[0] !== data) {
        t2 = (0, $f1uNX.isTeam)(data) && data?.state === "DISBANDED";
        $[0] = data;
        $[1] = t2;
    } else t2 = $[1];
    const canShowArchivedLozenge = t2;
    let t3;
    if ($[2] !== appearance || $[3] !== canShowArchivedLozenge || $[4] !== data || $[5] !== isFocused || $[6] !== label || $[7] !== props) {
        t3 = !isFocused ? /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItem
        }, data.icon ? /*#__PURE__*/ $cozmU.createElement((0, $lvlsM.AvatarOrIcon), {
            icon: data.icon,
            iconColor: data.iconColor,
            src: (0, $f1uNX.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $f1uNX.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $cGbTM.SizeableAvatar), {
            src: (0, $f1uNX.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $f1uNX.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItem
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $afcedb8febd5dd73$var$styles.avatarItemTextWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItemText
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, label, /*#__PURE__*/ $cozmU.createElement($afcedb8febd5dd73$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $afcedb8febd5dd73$var$styles.archivedLozengeWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: "neutral"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null)))))) : null;
        $[2] = appearance;
        $[3] = canShowArchivedLozenge;
        $[4] = data;
        $[5] = isFocused;
        $[6] = label;
        $[7] = props;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    const canShowArchivedLozenge = (0, $f1uNX.isTeam)(data) && data?.state === 'DISBANDED';
    return !isFocused ? /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItem
    }, data.icon ? /*#__PURE__*/ $cozmU.createElement((0, $lvlsM.AvatarOrIcon), {
        icon: data.icon,
        iconColor: data.iconColor,
        src: (0, $f1uNX.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $cGbTM.SizeableAvatar), {
        src: (0, $f1uNX.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItem
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $afcedb8febd5dd73$var$styles.avatarItemTextWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItemText
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, label, /*#__PURE__*/ $cozmU.createElement($afcedb8febd5dd73$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $afcedb8febd5dd73$var$styles.archivedLozengeWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null)))))) : null;
};
module.exports["SingleValue"] = $afcedb8febd5dd73$export$1949dac661ba6e3a;

});

parcelRegister("cnIP4", function(module, exports) {
/* Input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

function $0a548c9faa3635cd$var$_defineProperty(e, r, t) {
    return (r = $0a548c9faa3635cd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0a548c9faa3635cd$var$_toPropertyKey(t) {
    var i = $0a548c9faa3635cd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0a548c9faa3635cd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0a548c9faa3635cd$var$inputStyles = {
    root: "_0lRTubKGUX _3C3m0V7dHp _18bzZTKGUX"
};
class $0a548c9faa3635cd$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get ariaLabelledBy() {
        // A11Y-37267: An explicit aria-labelledby is a deliberate association with a visible label
        // element and is the field's true accessible name (WCAG 2.5.3 Label in Name), so it always
        // wins. Otherwise we promote aria-describedby -> aria-labelledby to work around
        // react-select's placeholder linkage bug, but skip that promotion when the input already
        // has an accessible name via aria-label so the description is announced via
        // aria-describedby instead.
        if (this.props['aria-labelledby']) return this.props['aria-labelledby'];
        if (this.props['aria-label']) return undefined;
        return this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $0a548c9faa3635cd$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args); // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        $0a548c9faa3635cd$var$_defineProperty(this, "handleKeyPress", (e)=>{
            if (e.key === 'Enter') e.preventDefault();
             //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        });
    }
}
module.exports["Input"] = $0a548c9faa3635cd$export$f5b8910cec6cf069;

});

parcelRegister("bPMiS", function(module, exports) {
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $9gNGh = parcelRequire("9gNGh");


var $dWZMi = parcelRequire("dWZMi");

function $66428c86f185db93$var$_defineProperty(e, r, t) {
    return (r = $66428c86f185db93$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $66428c86f185db93$var$_toPropertyKey(t) {
    var i = $66428c86f185db93$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66428c86f185db93$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $66428c86f185db93$var$valueContainerStyles = {
    root: "_2iEGP2N2y8 _0Of8r2gVvo _1wydGWgVvo _2Zuz6QPgdg _4bt5LAnQyn _2WAcuGIZbP _3oUqlsYbGa _0NUa3rN91d _4ho0wCjOvk _3ILZpPdnbC"
};
const $66428c86f185db93$var$placeholderIconContainer = null;
const $66428c86f185db93$var$wrapperStyle = null;
const $66428c86f185db93$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $66428c86f185db93$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gNGh.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
            ...valueContainerProps,
            xcss: $66428c86f185db93$var$valueContainerStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1xC2CJarlp _2Zuz6QgVvo _26BoRwdnbC"
            ])
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        $66428c86f185db93$var$_defineProperty(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) {
                const userData = $66428c86f185db93$var$showUserAvatar(inputValue, value) ? value.data : undefined;
                if (userData?.icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lvlsM.AvatarOrIcon), {
                    appearance: appearance,
                    icon: userData.icon,
                    iconColor: userData.iconColor,
                    type: placeholderAvatar,
                    src: userData.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $dWZMi.default)(userData.appType) : undefined
                });
                 // Fallback to original behavior
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cGbTM.SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: userData?.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $dWZMi.default)(userData.appType) : undefined
                });
            }
            return null;
        }); //@ts-ignore react-select unsupported props
        $66428c86f185db93$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        $66428c86f185db93$var$_defineProperty(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp"
                ])
            }, children) : children;
        });
    }
}
module.exports["SingleValueContainer"] = $66428c86f185db93$export$afa5f855316c6a48;

});

parcelRegister("97jiw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cnIP4 = parcelRequire("cnIP4");

class $ae16fbc8746297f4$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnIP4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
module.exports["PopupInput"] = $ae16fbc8746297f4$export$d8edbfd510a7db82;

});

parcelRegister("8otJJ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $dnFcR = parcelRequire("dnFcR");

function $aa22d968e17202e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa22d968e17202e4$var$controlWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $aa22d968e17202e4$var$labelStyle = {
    name: "14uum76",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);padding-bottom:var(--ds-space-050, 4px);padding-left:var(--ds-space-0, 0px);padding-right:var(--ds-space-0, 0px);padding-top:var(--ds-space-250, 20px)"
};
class $aa22d968e17202e4$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $aa22d968e17202e4$var$controlWrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $aa22d968e17202e4$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dnFcR.default), this.props));
    }
}
module.exports["PopupControl"] = $aa22d968e17202e4$export$a0cb1b4352357fcc;

});

parcelRegister("dnFcR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $k12R1 = parcelRequire("k12R1");

const $b9f98721f1489aa7$var$controlStyles = {
    invalid: "_3vBAKHnod9 _0hPERGnod9",
    focused: "_3vBAKHnXvL _0KLXru7Cj1 _0hPERGnXvL _1eOmH67Cj1",
    disabled: "_1eOmH6VrZW",
    subtle: "_3vBAKHjOvk _0KLXrujOvk _0hPERGjOvk _1eOmH6hH7k",
    root: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3vBAKHHKt7 _0KLXru7Cj1 _1EqgXlN91d _2GNrf4AASz _0hPERGHKt7 _1eOmH6qWX3 _33hNqm3mKv",
    compact: "_4kiQYAIZbP"
};
const $b9f98721f1489aa7$var$Control = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const isCompact = props.appearance === "compact";
    const t0 = isCompact && $b9f98721f1489aa7$var$controlStyles.compact;
    const t1 = (props.selectProps.subtle || props.selectProps.noBorder) && $b9f98721f1489aa7$var$controlStyles.subtle;
    const t2 = props.isFocused && $b9f98721f1489aa7$var$controlStyles.focused;
    const t3 = props.isInvalid && $b9f98721f1489aa7$var$controlStyles.invalid;
    const t4 = props.isDisabled && $b9f98721f1489aa7$var$controlStyles.disabled;
    let t5;
    if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
        t5 = (0, $k12R1.cx)($b9f98721f1489aa7$var$controlStyles.root, t0, t1, t2, t3, t4);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== props || $[7] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
            ...props,
            xcss: t5
        });
        $[6] = props;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
        ...props,
        xcss: (0, $k12R1.cx)($b9f98721f1489aa7$var$controlStyles.root, isCompact && $b9f98721f1489aa7$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $b9f98721f1489aa7$var$controlStyles.subtle, props.isFocused && $b9f98721f1489aa7$var$controlStyles.focused, props.isInvalid && $b9f98721f1489aa7$var$controlStyles.invalid, props.isDisabled && $b9f98721f1489aa7$var$controlStyles.disabled)
    });
};
var $b9f98721f1489aa7$export$2e2bcd8739ae039 = $b9f98721f1489aa7$var$Control;
module.exports["default"] = $b9f98721f1489aa7$export$2e2bcd8739ae039;

});

parcelRegister("bV3S4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $lOiVq = parcelRequire("lOiVq");

const $797d49a3eba443b9$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $797d49a3eba443b9$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l9ukq.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $797d49a3eba443b9$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
module.exports["Menu"] = $797d49a3eba443b9$export$d9b273488cd8ce6f;

});

parcelRegister("1aEbM", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $bsEy7 = parcelRequire("bsEy7");


var $f1uNX = parcelRequire("f1uNX");

const $ff7ae3636e19fcd6$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $ff7ae3636e19fcd6$var$isValidNewOption = (isValidEmail = (0, $bsEy7.isValidEmail))=>(inputValue)=>inputValue && $ff7ae3636e19fcd6$var$validOption.includes(isValidEmail(inputValue));
const $ff7ae3636e19fcd6$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $9kYT2.EmailType)
        }
    });
const $ff7ae3636e19fcd6$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $ff7ae3636e19fcd6$var$isOptionDisabled = (isValidEmail = (0, $bsEy7.isValidEmail))=>(option)=>{
        if ((0, $f1uNX.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $ff7ae3636e19fcd6$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $ff7ae3636e19fcd6$var$isValidNewOption(isValidEmail),
        getNewOptionData: $ff7ae3636e19fcd6$var$getNewOptionData,
        formatCreateLabel: $ff7ae3636e19fcd6$var$formatCreateLabel,
        isOptionDisabled: $ff7ae3636e19fcd6$var$isOptionDisabled(isValidEmail)
    };
}
const $ff7ae3636e19fcd6$export$36f97d8afa97203d = (0, $dOBRD.default)($ff7ae3636e19fcd6$var$creatableProps);
module.exports["getCreatableProps"] = $ff7ae3636e19fcd6$export$36f97d8afa97203d;

});

parcelRegister("7HZsv", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $bsEy7 = parcelRequire("bsEy7");


var $f1uNX = parcelRequire("f1uNX");

const $c6733fa977d328f9$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $c6733fa977d328f9$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $c6733fa977d328f9$var$getNewOptionData = (isValidEmail = (0, $bsEy7.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $c6733fa977d328f9$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $9kYT2.EmailType),
                suggestion: true
            }
        };
    };
const $c6733fa977d328f9$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $c6733fa977d328f9$var$isOptionDisabled = (isValidEmail = (0, $bsEy7.isValidEmail))=>(option)=>{
        if ((0, $f1uNX.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $c6733fa977d328f9$export$34b9dd2dd6a225e5 = (0, $dOBRD.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $c6733fa977d328f9$var$isValidNewOption,
        getNewOptionData: $c6733fa977d328f9$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $c6733fa977d328f9$var$formatCreateLabel,
        isOptionDisabled: $c6733fa977d328f9$var$isOptionDisabled(isValidEmail)
    }));
module.exports["getCreatableSuggestedEmailProps"] = $c6733fa977d328f9$export$34b9dd2dd6a225e5;

});

parcelRegister("i7OwT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8B59y = parcelRequire("8B59y");

const $affe1f0b873bb0fd$var$EMPTY = {};
const $affe1f0b873bb0fd$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($affe1f0b873bb0fd$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($affe1f0b873bb0fd$var$EMPTY);
            (0, $8B59y.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($affe1f0b873bb0fd$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($affe1f0b873bb0fd$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($affe1f0b873bb0fd$var$EMPTY);
        (0, $8B59y.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $affe1f0b873bb0fd$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    const { children: children } = props;
    const messages = $affe1f0b873bb0fd$var$useI18n(intl.locale);
    const t0 = intl.messages;
    let t1;
    if ($[0] !== messages || $[1] !== t0) {
        t1 = {
            ...t0,
            ...messages
        };
        $[0] = messages;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const mergedMessages = t1;
    let t2;
    if ($[3] !== children || $[4] !== intl.locale || $[5] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
        $[3] = children;
        $[4] = intl.locale;
        $[5] = mergedMessages;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const { children: children } = props;
    const messages = $affe1f0b873bb0fd$var$useI18n(intl.locale);
    const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $affe1f0b873bb0fd$export$2e2bcd8739ae039 = $affe1f0b873bb0fd$var$MessagesIntlProvider;
function $affe1f0b873bb0fd$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $affe1f0b873bb0fd$export$2e2bcd8739ae039;

});

parcelRegister("8B59y", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $fabf0ee840193b6d$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("czT7f")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("is2CR")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("f9PXz")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hTBlD")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("knhp1")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("6Jf3c")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("4stbQ")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("e5Zyb")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("hTGoS")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4NzHm")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("7WMbM")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("kRet2")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("k0Ylw")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("ed6HY")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("gYHEQ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("4y6hg")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("ipkwl")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("6Auf5")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("2Y1OG")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7U9Cn")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("bpqHS")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1UMpa")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("5rDRi")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("fTac2")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("kJkHm")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("aMBTr")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("4Y1bg")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("4KYVB")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("4DhwK")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("4H0kN")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $fabf0ee840193b6d$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hTBlD")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $fabf0ee840193b6d$export$d0a3169680473b6c;

});

parcelRegister("czT7f", function(module, exports) {

let $928381cfcdc88412$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $928381cfcdc88412$var$load("aQPG0").then(()=>parcelRequire('2MNNk'));

});

parcelRegister("is2CR", function(module, exports) {

let $d6ece0f77e900d01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6ece0f77e900d01$var$load("bkZFg").then(()=>parcelRequire('6wHKZ'));

});

parcelRegister("f9PXz", function(module, exports) {

let $b090006a45f0dcb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b090006a45f0dcb0$var$load("55jRH").then(()=>parcelRequire('9lr8J'));

});

parcelRegister("hTBlD", function(module, exports) {

let $d0748b3f49a16dcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0748b3f49a16dcb$var$load("7gZXw").then(()=>parcelRequire('kLDJj'));

});

parcelRegister("knhp1", function(module, exports) {

let $ed5374660f7d9b16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed5374660f7d9b16$var$load("b3SDM").then(()=>parcelRequire('bpfBt'));

});

parcelRegister("6Jf3c", function(module, exports) {

let $4e629ec849dd4d3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e629ec849dd4d3f$var$load("1JMhO").then(()=>parcelRequire('PSbJN'));

});

parcelRegister("4stbQ", function(module, exports) {

let $33f06b7bd600d6cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33f06b7bd600d6cb$var$load("9yhAT").then(()=>parcelRequire('bgepv'));

});

parcelRegister("e5Zyb", function(module, exports) {

let $a43146ee98ca6159$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a43146ee98ca6159$var$load("cdSjM").then(()=>parcelRequire('iklsj'));

});

parcelRegister("hTGoS", function(module, exports) {

let $d0787686b6b885e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0787686b6b885e3$var$load("d5cjH").then(()=>parcelRequire('iNF4u'));

});

parcelRegister("4NzHm", function(module, exports) {

let $37e76e00ca9b33bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37e76e00ca9b33bf$var$load("cM3qB").then(()=>parcelRequire('acET6'));

});

parcelRegister("7WMbM", function(module, exports) {

let $5c93548215716d82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c93548215716d82$var$load("ju3RT").then(()=>parcelRequire('aCa90'));

});

parcelRegister("kRet2", function(module, exports) {

let $f2f3facd803b8f3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2f3facd803b8f3c$var$load("eKgTI").then(()=>parcelRequire('5HGir'));

});

parcelRegister("k0Ylw", function(module, exports) {

let $e9229e398f49c2fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9229e398f49c2fd$var$load("4SiFB").then(()=>parcelRequire('50gw0'));

});

parcelRegister("ed6HY", function(module, exports) {

let $a5877bb71bc0f7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5877bb71bc0f7fc$var$load("3sB8d").then(()=>parcelRequire('43D7o'));

});

parcelRegister("gYHEQ", function(module, exports) {

let $c5c41d72d00b66dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5c41d72d00b66dd$var$load("cufjc").then(()=>parcelRequire('8ROxp'));

});

parcelRegister("4y6hg", function(module, exports) {

let $34ff34fe5bb47354$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34ff34fe5bb47354$var$load("hPzC3").then(()=>parcelRequire('8awf7'));

});

parcelRegister("ipkwl", function(module, exports) {

let $d66a7ac30169d5cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d66a7ac30169d5cd$var$load("cjMnf").then(()=>parcelRequire('44rnN'));

});

parcelRegister("6Auf5", function(module, exports) {

let $4cbd90648eaac27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4cbd90648eaac27c$var$load("bdFVZ").then(()=>parcelRequire('dfiIH'));

});

parcelRegister("2Y1OG", function(module, exports) {

let $229298178354000a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $229298178354000a$var$load("73TPf").then(()=>parcelRequire('g36ET'));

});

parcelRegister("7U9Cn", function(module, exports) {

let $5c15394e51389f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c15394e51389f53$var$load("84JCz").then(()=>parcelRequire('biRQ5'));

});

parcelRegister("bpqHS", function(module, exports) {

let $84e6bee535d6157a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84e6bee535d6157a$var$load("e9I4V").then(()=>parcelRequire('iVMCW'));

});

parcelRegister("1UMpa", function(module, exports) {

let $1650919caaa8e2ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1650919caaa8e2ca$var$load("11Tbc").then(()=>parcelRequire('1KBJA'));

});

parcelRegister("5rDRi", function(module, exports) {

let $3f6e6475cd44f19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f6e6475cd44f19c$var$load("9tJmD").then(()=>parcelRequire('aZaJA'));

});

parcelRegister("fTac2", function(module, exports) {

let $b913e639f322e6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b913e639f322e6fc$var$load("15Pfi").then(()=>parcelRequire('fXcYB'));

});

parcelRegister("kJkHm", function(module, exports) {

let $f17810e6417eeb22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f17810e6417eeb22$var$load("5JkSw").then(()=>parcelRequire('cMTKF'));

});

parcelRegister("aMBTr", function(module, exports) {

let $7d9bc7e1a9c9a29a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d9bc7e1a9c9a29a$var$load("8yuuY").then(()=>parcelRequire('i0dXc'));

});

parcelRegister("4Y1bg", function(module, exports) {

let $39ddae750cc71672$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39ddae750cc71672$var$load("gYFls").then(()=>parcelRequire('47Oa4'));

});

parcelRegister("4KYVB", function(module, exports) {

let $376ab8566e57c3f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $376ab8566e57c3f9$var$load("4tohK").then(()=>parcelRequire('20QzR'));

});

parcelRegister("4DhwK", function(module, exports) {

let $35f8667a2cfca562$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35f8667a2cfca562$var$load("iXqHo").then(()=>parcelRequire('4cqqy'));

});

parcelRegister("4H0kN", function(module, exports) {

let $36ab7002b9784b9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36ab7002b9784b9c$var$load("lcic8").then(()=>parcelRequire('kb5xT'));

});

parcelRegister("50iN8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $bfa0c313f69ddec7$var$ExusUserSourceContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $bfa0c313f69ddec7$export$bcd5c65b586ee3c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetchUserSource: fetchUserSource, children: children } = t0;
    let t1;
    if ($[0] !== fetchUserSource) {
        t1 = {
            fetchUserSource: fetchUserSource
        };
        $[0] = fetchUserSource;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfa0c313f69ddec7$var$ExusUserSourceContext.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfa0c313f69ddec7$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $bfa0c313f69ddec7$export$c6c0c1a2bac363f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (accountId, shouldFetchSources, existingSources)=>{
    const $ = (0, $bDgLe.c)(19);
    const { fetchUserSource: fetchUserSource } = (0, $cozmU.useContext)($bfa0c313f69ddec7$var$ExusUserSourceContext);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [externalSources, setExternalSources] = (0, $cozmU.useState)(t0);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    let t1;
    bb0: {
        if (typeof AbortController === "undefined") {
            t1 = undefined;
            break bb0;
        }
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = new AbortController();
            $[1] = t2;
        } else t2 = $[1];
        t1 = t2;
    }
    const abortController = t1;
    let t2;
    let t3;
    if ($[2] !== accountId || $[3] !== fetchUserSource || $[4] !== shouldFetchSources) {
        t2 = ()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources_0)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources_0.map($bfa0c313f69ddec7$var$_temp);
                setExternalSources(externalSourceTypes);
            }).catch((error_0)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error_0);
            });
            return cleanup;
        };
        t3 = [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ];
        $[2] = accountId;
        $[3] = fetchUserSource;
        $[4] = shouldFetchSources;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== existingSources || $[8] !== externalSources) {
        let t5;
        if ($[10] !== existingSources) {
            t5 = existingSources ?? [];
            $[10] = existingSources;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== externalSources || $[13] !== t5) {
            t6 = new Set([
                ...t5,
                ...externalSources
            ]);
            $[12] = externalSources;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        t4 = Array.from(t6);
        $[7] = existingSources;
        $[8] = externalSources;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[15] !== error || $[16] !== loading || $[17] !== t4) {
        t5 = {
            sources: t4,
            loading: loading,
            error: error
        };
        $[15] = error;
        $[16] = loading;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $cozmU.useContext)($bfa0c313f69ddec7$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const abortController = (0, $cozmU.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources_0)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources_0.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error_0)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error_0);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $cozmU.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};
function $bfa0c313f69ddec7$var$_temp(source) {
    return source.sourceType;
}
module.exports["ExusUserSourceProvider"] = $bfa0c313f69ddec7$export$bcd5c65b586ee3c3;
module.exports["useUserSource"] = $bfa0c313f69ddec7$export$c6c0c1a2bac363f;

});

parcelRegister("kK1nI", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $2iGHk = parcelRequire("2iGHk");


var $kHija = parcelRequire("kHija");

const $7fe07237a7d94e47$var$packageName = "platform-pkg";
const $7fe07237a7d94e47$var$packageVersion = "0.0.0-use.local";
const $7fe07237a7d94e47$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $kHija.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $7fe07237a7d94e47$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
const $7fe07237a7d94e47$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $7fe07237a7d94e47$var$packageName,
            packageVersion: $7fe07237a7d94e47$var$packageVersion,
            ...attributes
        }
    });
const $7fe07237a7d94e47$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $7fe07237a7d94e47$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$7fe07237a7d94e47$var$createEvent('operational', action, actionSubect, attributes)
    });
const $7fe07237a7d94e47$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$fbba77127d7cb173 = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('requested', 'users', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$bfc020018aa738d0 = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$738aca68b593db8e = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$b9358131e14a4b0b = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
module.exports["createAndFireEventInElementsChannel"] = $7fe07237a7d94e47$export$53eef0dcd9611650;
module.exports["preparedUsersLoadedEvent"] = $7fe07237a7d94e47$export$185f4c3d9b7ef9bf;
module.exports["mountedWithPrefetchEvent"] = $7fe07237a7d94e47$export$9cfb4251e50d7b91;
module.exports["filterUsersEvent"] = $7fe07237a7d94e47$export$fbba77127d7cb173;
module.exports["requestUsersEvent"] = $7fe07237a7d94e47$export$1762ed8845ff2d9b;
module.exports["successfulRequestUsersEvent"] = $7fe07237a7d94e47$export$bfc020018aa738d0;
module.exports["failedRequestUsersEvent"] = $7fe07237a7d94e47$export$738aca68b593db8e;
module.exports["failedUserResolversEvent"] = $7fe07237a7d94e47$export$b9358131e14a4b0b;

});

parcelRegister("cCc2a", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iX1XL = parcelRequire("iX1XL");

const $3783e719317347ac$var$EMPTY = {};
const $3783e719317347ac$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($3783e719317347ac$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($3783e719317347ac$var$EMPTY);
        (0, $iX1XL.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $3783e719317347ac$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $3783e719317347ac$var$useI18n(intl.locale);
    const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
const $3783e719317347ac$var$_default_1 = (0, $kSwu1.injectIntl)($3783e719317347ac$var$MessagesIntlProvider);
var $3783e719317347ac$export$2e2bcd8739ae039 = $3783e719317347ac$var$_default_1;
module.exports["default"] = $3783e719317347ac$export$2e2bcd8739ae039;

});

parcelRegister("iX1XL", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $792857de5d56fcc9$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6npt8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("gDFuO")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("68pf5")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hHGlo")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("f1C0z")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3gTwX")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("6pI2S")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("2ZlOL")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("8T8Ab")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("6nJ4E")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("5IoA9")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("g1CsZ")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("aZGmw")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("fOV60")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("g75fo")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("4yIMZ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("1bALo")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("dhear")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("yo5gM")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dbxCp")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("3E3J9")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("2tXi9")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("cCZAe")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("btBWb")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("kU1Eg")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("ePEp4")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("25Xis")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("79I5G")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("ibtYk")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $792857de5d56fcc9$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hHGlo")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $792857de5d56fcc9$export$d0a3169680473b6c;

});

parcelRegister("6npt8", function(module, exports) {

let $4a48a5a7336ef556$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a48a5a7336ef556$var$load("aQPG0").then(()=>parcelRequire('kNAr6'));

});

parcelRegister("gDFuO", function(module, exports) {

let $c1d07a1d592a63c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1d07a1d592a63c6$var$load("bkZFg").then(()=>parcelRequire('iQITF'));

});

parcelRegister("68pf5", function(module, exports) {

let $47771203695ddf00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47771203695ddf00$var$load("55jRH").then(()=>parcelRequire('4Y6NR'));

});

parcelRegister("hHGlo", function(module, exports) {

let $ce374c76d2f1e237$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce374c76d2f1e237$var$load("7gZXw").then(()=>parcelRequire('44AgC'));

});

parcelRegister("f1C0z", function(module, exports) {

let $af046eaa9eb40603$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af046eaa9eb40603$var$load("b3SDM").then(()=>parcelRequire('aAjDq'));

});

parcelRegister("3gTwX", function(module, exports) {

let $261df0f125d7ec52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $261df0f125d7ec52$var$load("9yhAT").then(()=>parcelRequire('gebt4'));

});

parcelRegister("6pI2S", function(module, exports) {

let $4ab73e5e45bd9c3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab73e5e45bd9c3a$var$load("cdSjM").then(()=>parcelRequire('66D3r'));

});

parcelRegister("2ZlOL", function(module, exports) {

let $22d233da3d024f10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22d233da3d024f10$var$load("d5cjH").then(()=>parcelRequire('5GOkE'));

});

parcelRegister("8T8Ab", function(module, exports) {

let $678a1e1a8fa5b9ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $678a1e1a8fa5b9ec$var$load("cM3qB").then(()=>parcelRequire('4kDHd'));

});

parcelRegister("6nJ4E", function(module, exports) {

let $4a57dacc74badc26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a57dacc74badc26$var$load("ju3RT").then(()=>parcelRequire('2EVaB'));

});

parcelRegister("5IoA9", function(module, exports) {

let $429421467dc9e033$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $429421467dc9e033$var$load("eKgTI").then(()=>parcelRequire('c7qHA'));

});

parcelRegister("g1CsZ", function(module, exports) {

let $baaa94056a83aeca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $baaa94056a83aeca$var$load("4SiFB").then(()=>parcelRequire('bikcP'));

});

parcelRegister("aZGmw", function(module, exports) {

let $80107625e0a4f412$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80107625e0a4f412$var$load("3sB8d").then(()=>parcelRequire('kuHNn'));

});

parcelRegister("fOV60", function(module, exports) {

let $b847d096a5dfc710$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b847d096a5dfc710$var$load("cufjc").then(()=>parcelRequire('gF7hG'));

});

parcelRegister("g75fo", function(module, exports) {

let $bbb15ec44325a35c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbb15ec44325a35c$var$load("hPzC3").then(()=>parcelRequire('dffVf'));

});

parcelRegister("4yIMZ", function(module, exports) {

let $351d149a8785bd34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $351d149a8785bd34$var$load("cjMnf").then(()=>parcelRequire('6FAuN'));

});

parcelRegister("1bALo", function(module, exports) {

let $0dd355f3ec300f90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0dd355f3ec300f90$var$load("bdFVZ").then(()=>parcelRequire('5e6r7'));

});

parcelRegister("dhear", function(module, exports) {

let $9aa7da3b13e70e6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9aa7da3b13e70e6f$var$load("73TPf").then(()=>parcelRequire('ag0hm'));

});

parcelRegister("yo5gM", function(module, exports) {

let $0675dbab9a2187ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0675dbab9a2187ad$var$load("84JCz").then(()=>parcelRequire('fK5Ez'));

});

parcelRegister("dbxCp", function(module, exports) {

let $99966165c3f9d8e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99966165c3f9d8e1$var$load("e9I4V").then(()=>parcelRequire('cOlwg'));

});

parcelRegister("3E3J9", function(module, exports) {

let $2a77ffa9ff93ba5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a77ffa9ff93ba5e$var$load("11Tbc").then(()=>parcelRequire('g7siS'));

});

parcelRegister("2tXi9", function(module, exports) {

let $1cec4853d1711128$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cec4853d1711128$var$load("9tJmD").then(()=>parcelRequire('khkji'));

});

parcelRegister("cCZAe", function(module, exports) {

let $9318cdcec3856db5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9318cdcec3856db5$var$load("15Pfi").then(()=>parcelRequire('9Bj7P'));

});

parcelRegister("btBWb", function(module, exports) {

let $85afd4b72e7d87e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85afd4b72e7d87e4$var$load("5JkSw").then(()=>parcelRequire('8DnOd'));

});

parcelRegister("kU1Eg", function(module, exports) {

let $f37a50eefde1b8b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a50eefde1b8b9$var$load("8yuuY").then(()=>parcelRequire('dD65A'));

});

parcelRegister("ePEp4", function(module, exports) {

let $acc52b641fad9633$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acc52b641fad9633$var$load("gYFls").then(()=>parcelRequire('eZJS0'));

});

parcelRegister("25Xis", function(module, exports) {

let $186a0b79be7dcc0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $186a0b79be7dcc0f$var$load("4tohK").then(()=>parcelRequire('d7z8J'));

});

parcelRegister("79I5G", function(module, exports) {

let $535b932ba5103996$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $535b932ba5103996$var$load("iXqHo").then(()=>parcelRequire('d1XXs'));

});

parcelRegister("ibtYk", function(module, exports) {

let $d3d080e86badaf7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3d080e86badaf7d$var$load("lcic8").then(()=>parcelRequire('9U3K8'));

});

parcelRegister("jItb7", function(module, exports) {
var $96c0d04f40ba3ed5$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $96c0d04f40ba3ed5$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});
module.exports["EntityType"] = $96c0d04f40ba3ed5$export$8eda7e02f8f033b2;
module.exports["UserEntityType"] = $96c0d04f40ba3ed5$export$ef0ef29634e52a6b;

});

parcelRegister("b9heI", function(module, exports) {

var $cMfSg = parcelRequire("cMfSg");


var $gh5tj = parcelRequire("gh5tj");

const $a24728959ef3490f$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $gh5tj.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                ...request.verifiedTeams === true && {
                    isVerifiedTeamFilter: true
                },
                ...request.isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                },
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: request.restrictTo || {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $cMfSg.transformUsers)(response, intl));
};
var $a24728959ef3490f$export$2e2bcd8739ae039 = $a24728959ef3490f$var$getUserRecommendations;
module.exports["default"] = $a24728959ef3490f$export$2e2bcd8739ae039;

});

parcelRegister("cMfSg", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");


var $4oxIw = parcelRequire("4oxIw");


var $jItb7 = parcelRequire("jItb7");


var $iDrrr = parcelRequire("iDrrr");

const $9b431fcf90cc0132$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $4oxIw.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $jItb7.EntityType).GROUP ? (0, $4oxIw.messages).guestGroupLozengeTooltip : (0, $4oxIw.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $4oxIw.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    const isJiraGuestUser = (0, $iDrrr.fg)('user_picker_guest_lozenges') && entity.attributes?.isJiraGuest;
    if (isJiraGuestUser) return intl.formatMessage((0, $4oxIw.messages).guestLozengeText);
    return undefined;
};
const $9b431fcf90cc0132$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $jItb7.EntityType).USER) {
        const user = item;
        const lozenge = $9b431fcf90cc0132$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $9kYT2.ExternalUserType) : (0, $9kYT2.UserType),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined,
            appType: user.appType !== undefined ? user.appType : user.attributes?.appType
        };
    }
    if (type === (0, $jItb7.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $9kYT2.TeamType),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified,
            teamTypeName: team.type?.name,
            state: team.state
        };
    }
    if (type === (0, $jItb7.EntityType).GROUP) {
        const group = item;
        const lozenge = $9b431fcf90cc0132$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $9kYT2.GroupType),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $9b431fcf90cc0132$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$9b431fcf90cc0132$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
module.exports["transformUsers"] = $9b431fcf90cc0132$export$fb8c90bfc4beaa59;

});

parcelRegister("4oxIw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9369811f0ae39467$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
module.exports["messages"] = $9369811f0ae39467$export$defe85febe8b728c;

});

parcelRegister("gh5tj", function(module, exports) {
const $35b9c4aa02694e21$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};
module.exports["config"] = $35b9c4aa02694e21$export$e506a1d27d1eaa20;

});

parcelRegister("uUDXo", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");


var $gh5tj = parcelRequire("gh5tj");


var $2Pcx3 = parcelRequire("2Pcx3");


var $7okd1 = parcelRequire("7okd1");


var $532Sr = parcelRequire("532Sr");

const $e67531141dda4e4c$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $gh5tj.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $e67531141dda4e4c$var$transformJiraUsers : $e67531141dda4e4c$var$transformConfluenceUsers);
};
const $e67531141dda4e4c$var$transformJiraUsers = (userResponse)=>userResponse.values.map($e67531141dda4e4c$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $e67531141dda4e4c$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $9kYT2.UserType),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $e67531141dda4e4c$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($e67531141dda4e4c$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $e67531141dda4e4c$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $9kYT2.UserType),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $e67531141dda4e4c$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $532Sr.UNKNOWN)
        };
    });
};
const $e67531141dda4e4c$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $e67531141dda4e4c$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $7okd1.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $e67531141dda4e4c$var$hydrateAccountIds = async (baseUrl, productKey, values, atlAttributes)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $e67531141dda4e4c$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $2Pcx3.default)(baseUrl, accountIds, {
        product: productKey,
        ...atlAttributes
    });
};
async function $e67531141dda4e4c$var$hydrateDefaultValues(baseUrl, value, productKey, siteId, atlAttributes) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$e67531141dda4e4c$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $e67531141dda4e4c$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$e67531141dda4e4c$var$isOptionData(val) && val.type === 'user'), atlAttributes),
        $e67531141dda4e4c$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$e67531141dda4e4c$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$e67531141dda4e4c$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $e67531141dda4e4c$var$sortResults(hydratedOptions, values);
}
var $e67531141dda4e4c$export$2e2bcd8739ae039 = $e67531141dda4e4c$var$hydrateDefaultValues;
module.exports["default"] = $e67531141dda4e4c$export$2e2bcd8739ae039;

});

parcelRegister("2Pcx3", function(module, exports) {

var $532Sr = parcelRequire("532Sr");


var $h2zzp = parcelRequire("h2zzp");


var $gh5tj = parcelRequire("gh5tj");

/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $dd0e88f689d12292$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $dd0e88f689d12292$var$makeRequest = async (url, accountIds, attributionData)=>{
    const query = $dd0e88f689d12292$var$buildUsersQuery(accountIds);
    return await (0, $h2zzp.graphqlQuery)(url, query, attributionData);
};
const $dd0e88f689d12292$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $dd0e88f689d12292$var$getHydratedUsers = (baseUrl, userIds, attributionData)=>{
    const url = (0, $gh5tj.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $dd0e88f689d12292$var$makeRequest(url, userIds, attributionData).then((data)=>{
            resolve($dd0e88f689d12292$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $532Sr.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $dd0e88f689d12292$export$2e2bcd8739ae039 = $dd0e88f689d12292$var$getHydratedUsers;
module.exports["default"] = $dd0e88f689d12292$export$2e2bcd8739ae039;

});

parcelRegister("532Sr", function(module, exports) {
const $6db3863417a51977$export$78244dbb77cfa6b6 = 'Unknown';
const $6db3863417a51977$export$d1f5101c0939e3fe = {
    id: $6db3863417a51977$export$78244dbb77cfa6b6,
    name: $6db3863417a51977$export$78244dbb77cfa6b6,
    type: 'user'
};
const $6db3863417a51977$export$8144dcfc9025ca57 = {
    id: $6db3863417a51977$export$78244dbb77cfa6b6,
    name: $6db3863417a51977$export$78244dbb77cfa6b6,
    type: 'team'
};
module.exports["UNKNOWN"] = $6db3863417a51977$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_USER"] = $6db3863417a51977$export$d1f5101c0939e3fe;
module.exports["UNKNOWN_TEAM"] = $6db3863417a51977$export$8144dcfc9025ca57;

});

parcelRegister("h2zzp", function(module, exports) {

var $bI2Ez = parcelRequire("bI2Ez");

const $cb73305b812b5ba3$var$buildHeaders = (attributionData)=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const atlAttributionHeader = (0, $bI2Ez.createAtlAttributionHeader)(attributionData);
    headers.append('atl-attribution', atlAttributionHeader['atl-attribution']);
    return headers;
};
function $cb73305b812b5ba3$export$74eb8d79ae3e02b5(serviceUrl, query, attributionData) {
    const headers = $cb73305b812b5ba3$var$buildHeaders(attributionData);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $cb73305b812b5ba3$export$74eb8d79ae3e02b5;

});

parcelRegister("bI2Ez", function(module, exports) {
/**
 * Utility for creating the atl-attribution header for AGG requests
 * Reference: https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
 */ function $de0a2e7a5a86c4fd$export$14ef296862e3705e({ product: product = 'platform', activationId: activationId, ...props } = {}) {
    const headerData = {
        service: 'smart-experiences/smart-user-picker',
        product: product,
        atlWorkspaceId: activationId && props.tenantId ? `ari:cloud:${product}:${props.tenantId}:workspace/${activationId}` : undefined,
        ...props
    };
    return {
        'atl-attribution': JSON.stringify(headerData)
    };
}
module.exports["createAtlAttributionHeader"] = $de0a2e7a5a86c4fd$export$14ef296862e3705e;

});

parcelRegister("7okd1", function(module, exports) {

var $gh5tj = parcelRequire("gh5tj");


var $532Sr = parcelRequire("532Sr");

const $b51f40c08b009007$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl,
        ...team.state && {
            state: team.state
        }
    };
};
const $b51f40c08b009007$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $gh5tj.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $b51f40c08b009007$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $532Sr.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $b51f40c08b009007$export$2e2bcd8739ae039 = $b51f40c08b009007$var$hydrateTeamFromLegion;
module.exports["default"] = $b51f40c08b009007$export$2e2bcd8739ae039;

});

parcelRegister("7GkXv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

var $j7Sza = parcelRequire("j7Sza");

const $d95d43c2c4127308$var$COMPONENT_NAME = 'smart-user-picker';
const $d95d43c2c4127308$export$df77da4c0210f1c1 = new (0, $fh15z.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $d95d43c2c4127308$var$COMPONENT_NAME
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
const $d95d43c2c4127308$export$a0e7cca3ab9586eb = new (0, $fh15z.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $d95d43c2c4127308$var$COMPONENT_NAME
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
});
const $d95d43c2c4127308$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $cozmU.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $cozmU.useEffect)(()=>{
        if (experienceForId.state !== (0, $j7Sza.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $j7Sza.UFOExperienceState)['STARTED'],
                (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $d95d43c2c4127308$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        $d95d43c2c4127308$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["smartUserPickerRenderedUfoExperience"] = $d95d43c2c4127308$export$df77da4c0210f1c1;
module.exports["smartUserPickerOptionsShownUfoExperience"] = $d95d43c2c4127308$export$a0e7cca3ab9586eb;
module.exports["useUFOConcurrentExperience"] = $d95d43c2c4127308$export$e5e0512991825310;
module.exports["UfoErrorBoundary"] = $d95d43c2c4127308$export$5ef1c2550074a375;

});

parcelRegister("haZfQ", function(module, exports) {

let $c812e2b7f1ae3aa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c812e2b7f1ae3aa3$var$load("2PuFo").then(()=>parcelRequire('5ES8T'));

});

parcelRegister("cX2Om", function(module, exports) {

let $96dd2cf92a16e0f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96dd2cf92a16e0f7$var$load("cc4qW").then(()=>parcelRequire('h9h6g'));

});

parcelRegister("7SeeH", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $5bb89e8909dcc61b$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $5bb89e8909dcc61b$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $5bb89e8909dcc61b$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $5bb89e8909dcc61b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $5bb89e8909dcc61b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $5bb89e8909dcc61b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $5bb89e8909dcc61b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $5bb89e8909dcc61b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $5bb89e8909dcc61b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $5bb89e8909dcc61b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5bb89e8909dcc61b$var$root = $5bb89e8909dcc61b$var$freeGlobal || $5bb89e8909dcc61b$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $5bb89e8909dcc61b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5bb89e8909dcc61b$var$objectToString = $5bb89e8909dcc61b$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5bb89e8909dcc61b$var$nativeMax = Math.max, $5bb89e8909dcc61b$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $5bb89e8909dcc61b$var$now = function() {
    return $5bb89e8909dcc61b$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5bb89e8909dcc61b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($5bb89e8909dcc61b$var$FUNC_ERROR_TEXT);
    wait = $5bb89e8909dcc61b$var$toNumber(wait) || 0;
    if ($5bb89e8909dcc61b$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $5bb89e8909dcc61b$var$nativeMax($5bb89e8909dcc61b$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $5bb89e8909dcc61b$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $5bb89e8909dcc61b$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($5bb89e8909dcc61b$var$now());
    }
    function debounced() {
        var time = $5bb89e8909dcc61b$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5bb89e8909dcc61b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5bb89e8909dcc61b$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5bb89e8909dcc61b$var$isSymbol(value) {
    return typeof value == 'symbol' || $5bb89e8909dcc61b$var$isObjectLike(value) && $5bb89e8909dcc61b$var$objectToString.call(value) == $5bb89e8909dcc61b$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $5bb89e8909dcc61b$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($5bb89e8909dcc61b$var$isSymbol(value)) return $5bb89e8909dcc61b$var$NAN;
    if ($5bb89e8909dcc61b$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $5bb89e8909dcc61b$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($5bb89e8909dcc61b$var$reTrim, '');
    var isBinary = $5bb89e8909dcc61b$var$reIsBinary.test(value);
    return isBinary || $5bb89e8909dcc61b$var$reIsOctal.test(value) ? $5bb89e8909dcc61b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $5bb89e8909dcc61b$var$reIsBadHex.test(value) ? $5bb89e8909dcc61b$var$NAN : +value;
}
module.exports = $5bb89e8909dcc61b$var$debounce;

});

parcelRegister("eO7Xs", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $ac7be878b65c198f$var$noop() {
// No operation performed.
}
module.exports = $ac7be878b65c198f$var$noop;

});

parcelRegister("4NiRC", function(module, exports) {
'use strict';

var $UV56W = parcelRequire("UV56W");


var $1XKQW = parcelRequire("1XKQW");

var $37da5efad62bea45$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $37da5efad62bea45$var$CRHTLF = /[\n\r\t]/g, $37da5efad62bea45$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $37da5efad62bea45$var$port = /:\d+$/, $37da5efad62bea45$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $37da5efad62bea45$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $37da5efad62bea45$var$trimLeft(str) {
    return (str ? str : '').toString().replace($37da5efad62bea45$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $37da5efad62bea45$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $37da5efad62bea45$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $37da5efad62bea45$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $37da5efad62bea45$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $37da5efad62bea45$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $37da5efad62bea45$var$Url(loc, {});
        for(key in $37da5efad62bea45$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $37da5efad62bea45$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $37da5efad62bea45$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $37da5efad62bea45$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $37da5efad62bea45$var$extractProtocol(address, location) {
    address = $37da5efad62bea45$var$trimLeft(address);
    address = address.replace($37da5efad62bea45$var$CRHTLF, '');
    location = location || {};
    var match = $37da5efad62bea45$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($37da5efad62bea45$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $37da5efad62bea45$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $37da5efad62bea45$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $37da5efad62bea45$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $37da5efad62bea45$var$Url(address, location, parser) {
    address = $37da5efad62bea45$var$trimLeft(address);
    address = address.replace($37da5efad62bea45$var$CRHTLF, '');
    if (!(this instanceof $37da5efad62bea45$var$Url)) return new $37da5efad62bea45$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $37da5efad62bea45$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $1XKQW.parse;
    location = $37da5efad62bea45$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $37da5efad62bea45$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $37da5efad62bea45$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$37da5efad62bea45$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $37da5efad62bea45$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $37da5efad62bea45$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$UV56W(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $37da5efad62bea45$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $1XKQW.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$UV56W(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($37da5efad62bea45$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $37da5efad62bea45$var$rules.length; i++){
        var ins = $37da5efad62bea45$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $37da5efad62bea45$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $1XKQW.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $37da5efad62bea45$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $37da5efad62bea45$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$37da5efad62bea45$var$Url.prototype = {
    set: $37da5efad62bea45$var$set,
    toString: $37da5efad62bea45$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$37da5efad62bea45$var$Url.extractProtocol = $37da5efad62bea45$var$extractProtocol;
$37da5efad62bea45$var$Url.location = $37da5efad62bea45$var$lolcation;
$37da5efad62bea45$var$Url.trimLeft = $37da5efad62bea45$var$trimLeft;
$37da5efad62bea45$var$Url.qs = $1XKQW;
module.exports = $37da5efad62bea45$var$Url;

});

parcelRegister("UV56W", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("1XKQW", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $16dfa51e60a0cda0$export$fac44ee5b035f737, (v) => $16dfa51e60a0cda0$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $16dfa51e60a0cda0$export$98e6a39c04603d36, (v) => $16dfa51e60a0cda0$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $16dfa51e60a0cda0$export$fac44ee5b035f737;
var $16dfa51e60a0cda0$export$98e6a39c04603d36;
'use strict';
var $16dfa51e60a0cda0$var$has = Object.prototype.hasOwnProperty, $16dfa51e60a0cda0$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $16dfa51e60a0cda0$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $16dfa51e60a0cda0$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $16dfa51e60a0cda0$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $16dfa51e60a0cda0$var$decode(part[1]), value = $16dfa51e60a0cda0$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $16dfa51e60a0cda0$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($16dfa51e60a0cda0$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $16dfa51e60a0cda0$var$undef || isNaN(value))) value = '';
        key = $16dfa51e60a0cda0$var$encode(key);
        value = $16dfa51e60a0cda0$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$16dfa51e60a0cda0$export$fac44ee5b035f737 = $16dfa51e60a0cda0$var$querystringify;
$16dfa51e60a0cda0$export$98e6a39c04603d36 = $16dfa51e60a0cda0$var$querystring;

});

parcelRegister("eLaen", function(module, exports) {

let $abed642071cbe659$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abed642071cbe659$var$load("fcAaN"),
    $abed642071cbe659$var$load("c0bZa")
]).then(()=>parcelRequire('4R6LN'));

});

parcelRegister("euW6K", function(module, exports) {

var $f8dGE = parcelRequire("f8dGE");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $bcdSN = parcelRequire("bcdSN");

/**
 * This sweet state is a global singleton so we can track inline edits between conversations.
 * We store a map of message states, each with a draft work items map and top level invocation ids.
 */ const $7e2ff82faa7f32ef$var$initialMessageState = {
    isInitialised: false,
    hasAppliedDraftEdits: false,
    draftWorkItemsMap: {},
    topLevelInvocationIds: []
};
const $7e2ff82faa7f32ef$var$initialState = {
    messages: {}
};
const $7e2ff82faa7f32ef$export$216418abc831be7c = (state, messageId)=>state.messages[messageId] ?? $7e2ff82faa7f32ef$var$initialMessageState;
/**
 * Removes a work item from the map and handles parent/child relationships.
 */ const $7e2ff82faa7f32ef$var$removeFromMap = (draftItemsMap, invocationId)=>{
    if (!draftItemsMap[invocationId]) return {
        newMap: draftItemsMap,
        promotedInvocationIds: []
    };
    const newMap = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(draftItemsMap);
    const childInvocationIds = newMap[invocationId].childInvocationIds || [];
    const parent = newMap[invocationId]?.fields[0, $bcdSN.PARENT_FIELD_ID];
    delete newMap[invocationId];
    const parentInvocationId = Object.values(newMap).find((item)=>item.summary === parent || item?.createdIssueKey === parent)?.invocationId;
    if (parentInvocationId) newMap[parentInvocationId].childInvocationIds = newMap[parentInvocationId].childInvocationIds?.filter((childInvocationId)=>childInvocationId !== invocationId) || [];
    const promotedInvocationIds = [];
    childInvocationIds.forEach((childInvocationId)=>{
        if (newMap[childInvocationId].status !== 'finished') delete newMap[childInvocationId];
        else {
            promotedInvocationIds.push(childInvocationId);
            newMap[childInvocationId].fields[0, $bcdSN.PARENT_FIELD_ID] = undefined;
        }
    });
    return {
        newMap: newMap,
        promotedInvocationIds: promotedInvocationIds
    };
};
const $7e2ff82faa7f32ef$var$actions = {
    initDraftWorkItems: (messageId, invocationIdToWorkItemMap, topLevelInvocationIds)=>({ setState: setState, getState: getState })=>{
            // Only initialise once — subsequent calls are no-ops once the message is initialised.
            if ($7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId).isInitialised) return;
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        isInitialised: true,
                        hasAppliedDraftEdits: false,
                        draftWorkItemsMap: invocationIdToWorkItemMap,
                        topLevelInvocationIds: topLevelInvocationIds
                    }
                }
            });
        },
    setDraftWorkItems: (messageId, invocationIdToWorkItemMap, topLevelInvocationIds)=>({ setState: setState, getState: getState })=>{
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        isInitialised: true,
                        hasAppliedDraftEdits: true,
                        draftWorkItemsMap: invocationIdToWorkItemMap,
                        topLevelInvocationIds: topLevelInvocationIds
                    }
                }
            });
        },
    onFieldChange: (messageId, invocationId, fieldId, newValue)=>({ setState: setState, getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            const item = draftWorkItemsMap[invocationId];
            if (!item) return;
            const updatedFields = {
                ...item.fields,
                [fieldId]: newValue ?? undefined
            };
            const nextItems = {
                ...draftWorkItemsMap
            };
            // Handle summary field changes — need to update parent field in children too
            if (fieldId === 'summary' && typeof newValue === 'string') {
                nextItems[invocationId] = {
                    ...item,
                    summary: newValue,
                    fields: updatedFields
                };
                item.childInvocationIds?.forEach((childInvocationId)=>{
                    const child = nextItems[childInvocationId];
                    if (child) nextItems[childInvocationId] = {
                        ...child,
                        fields: {
                            ...child.fields,
                            [(0, $bcdSN.PARENT_FIELD_ID)]: newValue
                        }
                    };
                });
            } else nextItems[invocationId] = {
                ...item,
                fields: updatedFields
            };
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        ...$7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId),
                        draftWorkItemsMap: nextItems
                    }
                }
            });
        },
    onBulkFieldChange: (messageId, invocationId, newFields)=>({ setState: setState, getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            const item = draftWorkItemsMap[invocationId];
            if (!item) return;
            const nextItems = {
                ...draftWorkItemsMap
            };
            const newSummary = typeof newFields.summary === 'string' ? newFields.summary : item.summary;
            const issuetype = newFields.issuetype;
            const newIssueTypeId = typeof issuetype === 'object' && issuetype !== null && 'issueTypeId' in issuetype && typeof issuetype.issueTypeId === 'string' ? issuetype.issueTypeId : item.issueTypeId;
            nextItems[invocationId] = {
                ...item,
                summary: newSummary,
                issueTypeId: newIssueTypeId,
                fields: newFields
            };
            // If summary changed, update parent field in all children
            if (newSummary !== item.summary) item.childInvocationIds?.forEach((childInvocationId)=>{
                const child = nextItems[childInvocationId];
                if (child) nextItems[childInvocationId] = {
                    ...child,
                    fields: {
                        ...child.fields,
                        [(0, $bcdSN.PARENT_FIELD_ID)]: newSummary
                    }
                };
            });
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        ...$7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId),
                        // Prevents stale BE fetch from overwriting new GIC edits - defensive correctness as it is very likely
                        // the BE fetch would have already been applied by the time a user opens GIC and saves their changes.
                        hasAppliedDraftEdits: true,
                        draftWorkItemsMap: nextItems
                    }
                }
            });
        },
    removeDraftWorkItem: (messageId, invocationId)=>({ setState: setState, getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap, topLevelInvocationIds: topLevelInvocationIds } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            if (!draftWorkItemsMap[invocationId]) return false;
            const { newMap: newMap, promotedInvocationIds: promotedInvocationIds } = $7e2ff82faa7f32ef$var$removeFromMap(draftWorkItemsMap, invocationId);
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        ...$7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId),
                        draftWorkItemsMap: newMap,
                        topLevelInvocationIds: [
                            ...topLevelInvocationIds,
                            ...promotedInvocationIds
                        ]
                    }
                }
            });
            return true;
        },
    onDraftWorkItemsCreated: (messageId, invocationIdToCreatedIssueKey)=>({ setState: setState, getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            const nextItems = {
                ...draftWorkItemsMap
            };
            Object.entries(invocationIdToCreatedIssueKey).forEach(([invocationId, issueKey])=>{
                const item = nextItems[invocationId];
                if (!item) return;
                nextItems[invocationId] = {
                    ...item,
                    createdIssueKey: issueKey,
                    status: 'finished'
                };
                item.childInvocationIds?.forEach((childInvocationId)=>{
                    const child = nextItems[childInvocationId];
                    if (child) nextItems[childInvocationId] = {
                        ...child,
                        fields: {
                            ...child.fields,
                            [(0, $bcdSN.PARENT_FIELD_ID)]: issueKey
                        }
                    };
                });
            });
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        ...$7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId),
                        draftWorkItemsMap: nextItems
                    }
                }
            });
        },
    onDismissAllDraftWorkItems: (messageId)=>({ setState: setState, getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            const newMap = {
                ...draftWorkItemsMap
            };
            Object.values(newMap).forEach((item)=>{
                if (item.status !== 'finished') delete newMap[item.invocationId];
            });
            setState({
                messages: {
                    ...getState().messages,
                    [messageId]: {
                        ...$7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId),
                        draftWorkItemsMap: newMap,
                        topLevelInvocationIds: Object.keys(newMap)
                    }
                }
            });
        },
    getDraftWorkItemsWithoutHierarchy: (messageId)=>({ getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            return Object.values(draftWorkItemsMap);
        },
    getAllActiveInvocationIds: (messageId)=>({ getState: getState })=>{
            const { draftWorkItemsMap: draftWorkItemsMap } = $7e2ff82faa7f32ef$export$216418abc831be7c(getState(), messageId);
            return Object.values(draftWorkItemsMap).filter((item)=>item.status !== 'cancelled' && !item.createdIssueKey).map((item)=>item.invocationId);
        }
};
const $7e2ff82faa7f32ef$var$draftWorkItemsStore = (0, $8s9DV.createStore)({
    initialState: $7e2ff82faa7f32ef$var$initialState,
    actions: $7e2ff82faa7f32ef$var$actions
});
const $7e2ff82faa7f32ef$export$390f32400eaf98c9 = $7e2ff82faa7f32ef$var$draftWorkItemsStore;
const $7e2ff82faa7f32ef$var$useDraftWorkItemsStateHook = (0, $kBr4q.createStateHook)($7e2ff82faa7f32ef$export$390f32400eaf98c9);
const $7e2ff82faa7f32ef$export$f64ec363b704473c = $7e2ff82faa7f32ef$var$useDraftWorkItemsStateHook;
const $7e2ff82faa7f32ef$var$useDraftWorkItemsActionsHook = (0, $kBr4q.createActionsHook)($7e2ff82faa7f32ef$export$390f32400eaf98c9);
const $7e2ff82faa7f32ef$export$fa7245a8d1afdb11 = $7e2ff82faa7f32ef$var$useDraftWorkItemsActionsHook;
const $7e2ff82faa7f32ef$export$3db88b9ceb02a42a = ()=>{
    (0, $c6StJ.defaultRegistry).stores.clear();
};
module.exports["getMessageState"] = $7e2ff82faa7f32ef$export$216418abc831be7c;
module.exports["Store"] = $7e2ff82faa7f32ef$export$390f32400eaf98c9;
module.exports["useDraftWorkItemsState"] = $7e2ff82faa7f32ef$export$f64ec363b704473c;
module.exports["useDraftWorkItemsActions"] = $7e2ff82faa7f32ef$export$fa7245a8d1afdb11;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("bcdSN", function(module, exports) {
const $5c2b84d898a5a260$export$8a6aade97c20b786 = 'parent';
const $5c2b84d898a5a260$export$62b2171b1fe9adef = 'issuetype';
const $5c2b84d898a5a260$export$ea0053c5b62767c7 = 'summary';
const $5c2b84d898a5a260$export$10dafb596206a824 = 'description';
const $5c2b84d898a5a260$export$e855284a234b113b = 'priority';
const $5c2b84d898a5a260$export$8e9031924f65d0b3 = 'labels';
const $5c2b84d898a5a260$export$5be719d597f3dd9c = 'duedate';
const $5c2b84d898a5a260$export$6eb3a938f079cb29 = 'assignee';
const $5c2b84d898a5a260$export$635708b49ba81c56 = 'reporter';
const $5c2b84d898a5a260$export$bc10cdad16f9d227 = 'status';
const $5c2b84d898a5a260$export$4ac8365bf364d35b = 'project';
const $5c2b84d898a5a260$export$3725ea18cce8186f = [
    $5c2b84d898a5a260$export$62b2171b1fe9adef,
    $5c2b84d898a5a260$export$ea0053c5b62767c7,
    $5c2b84d898a5a260$export$10dafb596206a824,
    $5c2b84d898a5a260$export$bc10cdad16f9d227,
    $5c2b84d898a5a260$export$6eb3a938f079cb29,
    $5c2b84d898a5a260$export$e855284a234b113b,
    $5c2b84d898a5a260$export$5be719d597f3dd9c,
    $5c2b84d898a5a260$export$8e9031924f65d0b3,
    $5c2b84d898a5a260$export$635708b49ba81c56
];
const $5c2b84d898a5a260$export$9965d1d1af6a6f0f = new Set($5c2b84d898a5a260$export$3725ea18cce8186f);
const $5c2b84d898a5a260$export$3f7d11106de3cc42 = new Set([
    $5c2b84d898a5a260$export$8a6aade97c20b786,
    $5c2b84d898a5a260$export$4ac8365bf364d35b
]);
const $5c2b84d898a5a260$export$cea6be08100fe80a = 'custom-text-field-container';
const $5c2b84d898a5a260$export$29c46a9049d97503 = [
    'JiraSingleSelectUserPickerField',
    'JiraMultipleSelectUserPickerField',
    'JiraPeopleField'
];
const $5c2b84d898a5a260$export$ead016293fa2440c = 'JiraComponentsField';
const $5c2b84d898a5a260$export$1550716a190c2013 = {
    'com.atlassian.jira.plugin.system.customfieldtypes:textarea': {
        payload: 'ADF_VALUE',
        inputType: 'string',
        inputDescription: 'Provide content as either a plain string or markdown format.'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:people': {
        payload: {
            accountId: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide a list of Atlassian account IDs (AAIDs).'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:select': {
        payload: {
            value: 'VALUE'
        },
        inputType: 'string',
        inputDescription: "Provide the name of the option you want to select, e.g. 'TeamA'. Simply provide it as a string.",
        allowedValuesExtractorKey: 'value'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': {
        payload: {
            value: 'VALUE'
        },
        inputType: 'array',
        inputDescription: "Provide the name of the options you want to select, e.g. ['TeamA', 'TeamB']. Simply provide it as an array of strings.",
        allowedValuesExtractorKey: 'value'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': {
        payload: {
            value: 'VALUE'
        },
        inputType: 'array',
        inputDescription: "Provide the name of the options you want to select, e.g. ['TeamA', 'TeamB']. Simply provide it as an array of strings.",
        allowedValuesExtractorKey: 'value'
    },
    'com.pyxis.greenhopper.jira:gh-sprint': {
        inputType: 'integer',
        inputDescription: 'Provide the id of the Sprint, e.g. 28. Ensure pass the id of the Sprint, not the name. To find the id call the \'FieldSearchTool\' tool with this input: {"fieldsToSearch":"sprint","project":"<jira-project>"} make sure you only swap out the project keep the field to search param the same.'
    },
    environment: {
        payload: 'ADF_VALUE',
        inputType: 'string',
        inputDescription: 'Provide environment details as either a plain string or markdown format. Include relevant system, browser, or platform information.'
    },
    description: {
        payload: 'ADF_VALUE',
        inputType: 'string',
        inputDescription: 'Provide the issue description as either a plain string or markdown format. Can include headings, lists, code blocks, and tables.'
    },
    assignee: {
        payload: {
            id: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide a single Atlassian account ID (AAID) for the person to assign the issue to, to unassign pass in null',
        nullable: true
    },
    priority: {
        payload: {
            name: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide a valid Jira priority level name string',
        allowedValuesExtractorKey: 'name'
    },
    reporter: {
        payload: {
            id: 'VALUE'
        },
        inputType: 'string',
        inputDescription: "Provide the Atlassian account ID (AAID) for the issue reporter. The AAID is always the value immediately after the last '/' in the format: ari:cloud:identity::user/<AAID>",
        nullable: true
    },
    labels: {
        payload: 'VALUE',
        inputType: 'array',
        inputDescription: "Provide a list of label strings. Labels should be lowercase, no spaces (use hyphens). Example: ['backend', 'bug-fix', 'high-priority']"
    },
    parent: {
        inputType: 'string',
        inputDescription: 'Provide the parent issue id or key. The id of a work item (issue). Example of id is 10000, or example key is ABC-1. To remove the parent pass in an empty string.'
    },
    comment: {
        isUpdateOperation: true,
        payload: [
            {
                add: {
                    body: 'ADF_VALUE'
                }
            }
        ],
        inputType: 'string',
        inputDescription: 'Provide comment content as either a plain string or markdown format. Can include formatting such as bold, lists, and code blocks.'
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        inputType: 'string',
        inputDescription: "Provide as a string. If user asks for major incident, the value should be 'MAJOR_INCIDENT'. Otherwise, it should be an empty string ''"
    },
    project: {
        payload: {
            id: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide the exact ID of the project that you want the issue within',
        allowedValuesExtractorKey: 'id'
    },
    issuetype: {
        payload: {
            name: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide the name of the issue type you want to switch to.',
        allowedValuesExtractorKey: 'name'
    },
    'com.pyxis.greenhopper.jira:jsw-issue-color': {
        inputType: 'string',
        inputDescription: "Provide the name of the color. The only allowed values are: [purple, blue, green, teal, yellow, orange, grey, dark_purple, dark_blue, dark_green, dark_teal, dark_yellow, dark_orange, dark_grey]. If a color outside this list is requested, automatically select and use the closest allowed color instead\u2014do not ask for clarification or input. Always ensure the value you provide is valid."
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:float': {
        inputType: 'float',
        inputDescription: 'Provide the value as a floating point number. Do not provide it as a string.'
    },
    issuelinks: {
        isUpdateOperation: true,
        payload: [
            {
                add: 'VALUE'
            }
        ],
        inputType: 'object',
        inputDescription: 'Provide input as object, example: { "type": {"name": "Blocks"}, "outwardIssue": {"key": "ABC-1"} }'
    },
    fixVersions: {
        payload: {
            name: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide the name of the version(s) that you want to select, provide as an array of strings.',
        allowedValuesExtractorKey: 'name'
    },
    versions: {
        payload: {
            name: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide the name of the version(s) that you want to select, provide as an array of strings.',
        allowedValuesExtractorKey: 'name'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:version': {
        payload: {
            name: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide the name of the version that you want to select, provide as a single string.',
        allowedValuesExtractorKey: 'name'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': {
        payload: {
            name: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide the name of the version(s) that you want to select, provide as an array of strings.',
        allowedValuesExtractorKey: 'name'
    },
    components: {
        payload: {
            id: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide the ids of the component(s) that you want to select, provide as an array of strings. If names are provided instead of ids, they will be hydrated and mapped to { id }.'
    },
    'com.pyxis.greenhopper.jira:jsw-story-points': {
        inputType: 'integer',
        inputDescription: 'Please provide the story points as an integer. e.g. 7. Do not provide it as a string.'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons': {
        payload: {
            value: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide the value of the option you want to select, e.g. OldProject. Simply provide a single string.',
        allowedValuesExtractorKey: 'value'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': {
        payload: {
            name: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide the exact name of the group(s) that you want to select, provide as an array of strings.'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:project': {
        payload: {
            key: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide the exact key of the project that you want to select, provide as a single string.'
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category': {
        payload: {
            value: 'VALUE'
        },
        inputType: 'string',
        inputDescription: 'Provide the exact name of the category that you want to select, provide as a single string.',
        allowedValuesExtractorKey: 'value'
    },
    'com.atlassian.servicedesk:sd-customer-organizations': {
        payload: 'VALUE',
        inputType: 'array',
        inputDescription: 'Provide the exact id(s) of the organisations that you want to select, provide as an array of integers.'
    },
    'com.atlassian.servicedesk:sd-request-participants': {
        payload: {
            accountId: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide the exact AAID(s) of the users that you want to select, provide as an array of strings.'
    },
    'com.atlassian.servicedesk:vp-origin': {
        inputType: 'string',
        inputDescription: 'Provide the exact id of the request type that you want to select, provide as a single string.'
    },
    timetracking: {
        inputType: 'object',
        inputDescription: 'Provide an object, example object for all timetracking fields: { "originalEstimate": "3d", "remainingEstimate": "5w" }. Only provide fields you want to update in this object. Ensure you give times in this format: 2w 4d 6h 45m.'
    },
    // Jira custom field: User Picker (single)
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker': {
        payload: {
            accountId: 'VALUE'
        },
        inputType: 'object',
        inputDescription: 'Provide a single Atlassian account ID (AAID). Value will be mapped to { accountId }.',
        nullable: true
    },
    // Jira custom field: User Picker (multiple)
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': {
        payload: {
            accountId: 'VALUE'
        },
        inputType: 'array',
        inputDescription: 'Provide a list of Atlassian account IDs (AAIDs). Each will be mapped to { accountId }.',
        nullable: true
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:url': {
        inputType: 'string',
        inputDescription: 'Provide the URL that you want to select, provide as a single string.'
    }
};
module.exports["PARENT_FIELD_ID"] = $5c2b84d898a5a260$export$8a6aade97c20b786;
module.exports["ISSUE_TYPE_FIELD_ID"] = $5c2b84d898a5a260$export$62b2171b1fe9adef;
module.exports["SUMMARY_FIELD_ID"] = $5c2b84d898a5a260$export$ea0053c5b62767c7;
module.exports["REPORTER_FIELD_ID"] = $5c2b84d898a5a260$export$635708b49ba81c56;
module.exports["DEFAULT_ORDER_FIELD_IDS"] = $5c2b84d898a5a260$export$3725ea18cce8186f;
module.exports["EXCLUDED_FIELD_IDS_SET"] = $5c2b84d898a5a260$export$3f7d11106de3cc42;
module.exports["CUSTOM_TEXT_FIELD_ID"] = $5c2b84d898a5a260$export$cea6be08100fe80a;
module.exports["USER_PICKER_FIELD_TYPES"] = $5c2b84d898a5a260$export$29c46a9049d97503;
module.exports["COMPONENTS_FIELD_TYPE"] = $5c2b84d898a5a260$export$ead016293fa2440c;
module.exports["fieldTypeToPayload"] = $5c2b84d898a5a260$export$1550716a190c2013;

});

parcelRegister("fkQpA", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bcdSN = parcelRequire("bcdSN");

const $6a3a90c99bf78854$export$a67159d3a7facf9e = (issueKey)=>issueKey.match(/^[A-Za-z0-9]+-\d+$/) !== null;



var $euW6K = parcelRequire("euW6K");

const $9bc6b9b28f9e42b2$export$338bbb68320190f5 = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>{
        const { isInitialised: isInitialised, draftWorkItemsMap: draftWorkItemsMap } = (0, $euW6K.getMessageState)(state, messageId);
        if (!isInitialised) return false;
        return Object.values(draftWorkItemsMap).filter((item)=>item.status !== 'cancelled').every((item)=>item.createdIssueKey);
    }
});
const $9bc6b9b28f9e42b2$export$85ff6907b9e94fb8 = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>{
        const { isInitialised: isInitialised, draftWorkItemsMap: draftWorkItemsMap } = (0, $euW6K.getMessageState)(state, messageId);
        if (!isInitialised) return false;
        return Object.values(draftWorkItemsMap).every((item)=>item.status === 'cancelled');
    }
});
const $9bc6b9b28f9e42b2$export$d560fbb48c0a0656 = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>{
        const { draftWorkItemsMap: draftWorkItemsMap, topLevelInvocationIds: topLevelInvocationIds } = (0, $euW6K.getMessageState)(state, messageId);
        const draftWorkItemsWithHierarchy = [];
        topLevelInvocationIds.forEach((topLevelInvocationId)=>{
            const draftWorkItem = draftWorkItemsMap[topLevelInvocationId];
            if (draftWorkItem) draftWorkItemsWithHierarchy.push({
                ...draftWorkItem,
                childWorkItems: draftWorkItem.childInvocationIds?.map((child)=>draftWorkItemsMap[child]).filter((child)=>child && !topLevelInvocationIds.includes(child.invocationId)) || []
            });
        });
        return draftWorkItemsWithHierarchy;
    }
});
const $9bc6b9b28f9e42b2$export$b339b21ea41c462a = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>{
        const { draftWorkItemsMap: draftWorkItemsMap } = (0, $euW6K.getMessageState)(state, messageId);
        // TODO: Refactor onCreate to be able to create items without the hierarchy logic
        // Return only active (not cancelled or created) work items with Hierarchy
        const notCreatedItems = Object.values(draftWorkItemsMap).filter((item)=>item.status !== 'cancelled' && !item.createdIssueKey);
        // Helper to build child work items with hierarchy, will only include children that are active (not cancelled or created)
        const buildChildWorkItems = (item)=>item.childInvocationIds?.map((childId)=>draftWorkItemsMap[childId]).filter((child)=>child != null && !child.createdIssueKey && child.status !== 'cancelled') || [];
        const topLevelNotCreatedItems = notCreatedItems.filter((item)=>!item.fields[0, $bcdSN.PARENT_FIELD_ID]);
        // Only include child that have a parent that has been created, the ones with a parent that hasn't been created will be created as top level items
        const childNotCreatedItems = notCreatedItems.filter((item)=>typeof item.fields[0, $bcdSN.PARENT_FIELD_ID] === 'string' && (0, $6a3a90c99bf78854$export$a67159d3a7facf9e)(item.fields[0, $bcdSN.PARENT_FIELD_ID]));
        return [
            ...topLevelNotCreatedItems,
            ...childNotCreatedItems
        ].map((item)=>({
                ...item,
                childWorkItems: buildChildWorkItems(item)
            }));
    }
});
const $9bc6b9b28f9e42b2$export$3b51d8b7739cd95 = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>{
        const { draftWorkItemsMap: draftWorkItemsMap } = (0, $euW6K.getMessageState)(state, messageId);
        const activePlannedChildInvocationIdsByParent = {};
        for (const parent of Object.values(draftWorkItemsMap)){
            const { invocationId: invocationId, childInvocationIds: childInvocationIds } = parent;
            if (!childInvocationIds?.length) continue;
            const plannedOnly = childInvocationIds.filter((childId)=>draftWorkItemsMap[childId]?.status === 'planned');
            if (plannedOnly.length > 0) activePlannedChildInvocationIdsByParent[invocationId] = plannedOnly;
        }
        return activePlannedChildInvocationIdsByParent;
    }
});
const $9bc6b9b28f9e42b2$export$84c988abecf5a75b = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>{
        const { draftWorkItemsMap: draftWorkItemsMap } = (0, $euW6K.getMessageState)(state, messageId);
        return Object.values(draftWorkItemsMap).length;
    }
});
const $9bc6b9b28f9e42b2$export$99d8021551f74012 = (0, $kBr4q.createStateHook)((0, $euW6K.Store), {
    selector: (state, messageId)=>(0, $euW6K.getMessageState)(state, messageId).hasAppliedDraftEdits
});
module.exports["useAreAllCreated"] = $9bc6b9b28f9e42b2$export$338bbb68320190f5;
module.exports["useAreAllDismissed"] = $9bc6b9b28f9e42b2$export$85ff6907b9e94fb8;
module.exports["useGetDraftWorkItemsWithHierarchy"] = $9bc6b9b28f9e42b2$export$d560fbb48c0a0656;
module.exports["useGetDraftWorkItemsToCreate"] = $9bc6b9b28f9e42b2$export$b339b21ea41c462a;
module.exports["useGetActivePlannedChildInvocationIdsByParent"] = $9bc6b9b28f9e42b2$export$3b51d8b7739cd95;
module.exports["useGetActiveOrFinishedDraftWorkItemsCount"] = $9bc6b9b28f9e42b2$export$84c988abecf5a75b;
module.exports["useHasAppliedDraftEdits"] = $9bc6b9b28f9e42b2$export$99d8021551f74012;

});

parcelRegister("2Ueo4", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");

const $e17c6982b9a81658$var$buildUrl = (cloudId, conversationId, messageId)=>`/gateway/api/ex/jira/${encodeURIComponent(cloudId)}/rest/draftactions/conversation/${encodeURIComponent(conversationId)}/message/${encodeURIComponent(messageId)}`;
// In-memory promise cache so that a prefetch call made before canvas mount
// is reused by getOrFetchDraftWorkItemsWithEdits — avoiding a duplicate network request.
const $e17c6982b9a81658$var$prefetchCache = new Map();
const $e17c6982b9a81658$export$767e8fde888ed193 = ()=>$e17c6982b9a81658$var$prefetchCache.clear();
const $e17c6982b9a81658$var$getCacheKey = (conversationId, messageId)=>`${conversationId}:${messageId}`;
const $e17c6982b9a81658$export$30744f74f94753c = (storeItem)=>{
    return {
        invocationId: storeItem.invocationId,
        data: {
            ...storeItem
        }
    };
};
const $e17c6982b9a81658$var$fetchDraftActions = async (cloudId, conversationId, messageId, sendAifcAnalyticsEvent)=>{
    try {
        const response = await fetch($e17c6982b9a81658$var$buildUrl(cloudId, conversationId, messageId), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (!response.ok) {
            sendAifcAnalyticsEvent?.({
                action: 'failed',
                actionSubject: 'jiraAifcGetDraftWorkItems',
                attributes: {
                    statusCode: response.status
                },
                eventType: 'operational'
            });
            return null;
        }
        const data = await response.json();
        sendAifcAnalyticsEvent?.({
            action: 'success',
            actionSubject: 'jiraAifcGetDraftWorkItems',
            attributes: {
                numActions: data?.length ?? 0,
                statusCode: response.status
            },
            eventType: 'operational'
        });
        return data;
    } catch (error) {
        sendAifcAnalyticsEvent?.({
            action: 'errored',
            actionSubject: 'jiraAifcGetDraftWorkItems',
            attributes: {
                error: String(error)
            },
            eventType: 'operational'
        });
    }
    return null;
};
const $e17c6982b9a81658$export$366383b5f76a133f = (cloudId, conversationId, messageId, sendAnalyticsEvent)=>{
    const key = $e17c6982b9a81658$var$getCacheKey(conversationId, messageId);
    if (!$e17c6982b9a81658$var$prefetchCache.has(key)) $e17c6982b9a81658$var$prefetchCache.set(key, $e17c6982b9a81658$var$fetchDraftActions(cloudId, conversationId, messageId, sendAnalyticsEvent));
    return $e17c6982b9a81658$var$prefetchCache.get(key);
};
const $e17c6982b9a81658$export$200530b043927e95 = async (cloudId, conversationId, messageId, draftAction, sendAifcAnalyticsEvent, experienceTracker)=>{
    // Unique id so that rapid concurrent field-edit saves do not clobber one another.
    const experienceId = `${conversationId}:${messageId}:${draftAction.invocationId}`;
    if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker?.start({
        id: experienceId,
        name: (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM
    });
    try {
        const response = await fetch($e17c6982b9a81658$var$buildUrl(cloudId, conversationId, messageId), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                draftAction: draftAction
            })
        });
        sendAifcAnalyticsEvent?.({
            action: response.ok ? 'success' : 'failed',
            actionSubject: 'jiraAifcSaveDraftWorkItem',
            attributes: {
                statusCode: response.status
            },
            eventType: 'operational'
        });
        if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) {
            if (response.ok) experienceTracker?.succeed({
                name: (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM
            });
            else experienceTracker?.fail({
                name: (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
                error: new Error(`Failed to save draft work item: ${response.status}`)
            });
        }
    } catch (error) {
        sendAifcAnalyticsEvent?.({
            action: 'errored',
            actionSubject: 'jiraAifcSaveDraftWorkItem',
            attributes: {
                error: error instanceof Error ? error.message : String(error)
            },
            eventType: 'operational'
        });
        if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker?.fail({
            name: (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
};
const $e17c6982b9a81658$export$61fc00a341ad1f6d = async (cloudId, conversationId, messageId, draftAction, resolution, sendAifcAnalyticsEvent, experienceTracker)=>{
    // Unique id so that rapid concurrent field-edit saves do not clobber one another.
    const experienceId = `${conversationId}:${messageId}:${draftAction.invocationId}`;
    if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker?.start({
        id: experienceId,
        name: (0, $irnO2.ExperienceName).JIRA_RESOLVE_DRAFT_WORK_ITEM
    });
    try {
        const response = await fetch($e17c6982b9a81658$var$buildUrl(cloudId, conversationId, messageId), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                draftAction: {
                    ...draftAction,
                    data: {
                        ...draftAction.data,
                        resolution: resolution
                    }
                }
            })
        });
        sendAifcAnalyticsEvent?.({
            action: response.ok ? 'success' : 'failed',
            actionSubject: 'jiraAifcResolveDraftWorkItem',
            attributes: {
                statusCode: response.status,
                resolution: resolution
            },
            eventType: 'operational'
        });
        if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) {
            if (response.ok) experienceTracker?.succeed({
                name: (0, $irnO2.ExperienceName).JIRA_RESOLVE_DRAFT_WORK_ITEM
            });
            else experienceTracker?.fail({
                name: (0, $irnO2.ExperienceName).JIRA_RESOLVE_DRAFT_WORK_ITEM,
                error: new Error(`Failed to resolve draft work item: ${response.status}`)
            });
        }
    } catch (error) {
        sendAifcAnalyticsEvent?.({
            action: 'errored',
            actionSubject: 'jiraAifcResolveDraftWorkItem',
            attributes: {
                error: error instanceof Error ? error.message : String(error),
                resolution: resolution
            },
            eventType: 'operational'
        });
        if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker?.fail({
            name: (0, $irnO2.ExperienceName).JIRA_RESOLVE_DRAFT_WORK_ITEM,
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
};
module.exports["mapStoreItemToDraftWorkItemWithEdits"] = $e17c6982b9a81658$export$30744f74f94753c;
module.exports["getOrFetchDraftWorkItemsWithEdits"] = $e17c6982b9a81658$export$366383b5f76a133f;
module.exports["saveDraftWorkItem"] = $e17c6982b9a81658$export$200530b043927e95;
module.exports["resolveDraftWorkItemInMonolith"] = $e17c6982b9a81658$export$61fc00a341ad1f6d;

});

parcelRegister("8avtg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<f64dcad2df963ef36c6d6ad651560991>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9571c0da827caa4a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectIdOrKey"
            }
        ],
        "kind": "Fragment",
        "name": "useAiCreateProjectContextQuery",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Variable",
                        "name": "idOrKey",
                        "variableName": "projectIdOrKey"
                    }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jira_projectByIdOrKey",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "projectId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "concreteType": "JiraIssueTypeConnection",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "issueTypeId"
                                            },
                                            v0 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                "kind": "LinkedField",
                                                "name": "hierarchy",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "level"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "small"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "type"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "fieldId"
                                                                    },
                                                                    v0 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraFieldConfig",
                                                                                "kind": "LinkedField",
                                                                                "name": "fieldConfig",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "isEditable"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "isRequired"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "type": "JiraIssueFieldConfiguration",
                                                                        "abstractKey": "__isJiraIssueFieldConfiguration"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "components",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponentEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraComponent",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "componentId"
                                                                                                    },
                                                                                                    v0 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "type": "JiraComponentsField"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$9571c0da827caa4a$var$node.hash = "3645fad7b26174038e7b4e48448e2bfa";
var $9571c0da827caa4a$export$2e2bcd8739ae039 = $9571c0da827caa4a$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");





var $isb4V = parcelRequire("isb4V");

/**
 * @generated SignedSource<<baf120e535a1379ba247b94f1f31747c>>
 * @relayHash a00d7876f0eb3cb47782930584a21b6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b13ae57832aa475b58f48b0bb842b0ce3453b17fd873bb403af475d33c2c1cc6
const $60cd2c3615303801$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getUsersLoaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getUsersLoaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "b13ae57832aa475b58f48b0bb842b0ce3453b17fd873bb403af475d33c2c1cc6",
            "metadata": {},
            "name": "getUsersLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$60cd2c3615303801$var$node.hash = "63c326aba24c0c46d53744e43a04f1c8";
var $60cd2c3615303801$export$2e2bcd8739ae039 = $60cd2c3615303801$var$node;



var $6Q8Dd = parcelRequire("6Q8Dd");




// Module-level singleton per environment
const $78f4014fa44c5e2e$var$hydratedUserDataLoader = new WeakMap();
function $78f4014fa44c5e2e$export$b821a427bafd70cf(environment) {
    if ($78f4014fa44c5e2e$var$hydratedUserDataLoader.get(environment)) return $78f4014fa44c5e2e$var$hydratedUserDataLoader.get(environment);
    const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(async (accountIds)=>{
        const data = await (0, $6SsN4.fetchQuery)(environment, (0, $60cd2c3615303801$export$2e2bcd8739ae039), {
            accountIds: accountIds
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        // Map results to ensure O(1) lookup
        const userMap = new Map();
        const ariMap = new Map();
        for (const user of data?.users ?? []){
            const mappedUser = {
                ari: user?.id,
                accountId: user?.accountId,
                name: user?.name,
                avatarUrl: user?.picture
            };
            userMap.set(user.accountId, mappedUser);
            ariMap.set(mappedUser.ari, mappedUser);
        }
        // Return values in the exact same order as 'keys', as expected by the DataLoader
        return accountIds.map((accountId)=>{
            return userMap.get(accountId) ?? ariMap.get(accountId) ?? null;
        });
    }, {
        cache: true,
        batch: true
    });
    $78f4014fa44c5e2e$var$hydratedUserDataLoader.set(environment, loader);
    return loader;
}



var $4ZN5q = parcelRequire("4ZN5q");

function $2b26c9f0f51ee6de$export$f1de398e9368e7f1({ accountIds: accountIds, shouldHydrate: shouldHydrate }) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const loader = (0, $78f4014fa44c5e2e$export$b821a427bafd70cf)(environment);
    const accountIdsToFetch = (0, $4ZN5q.useStableArray)(accountIds, {
        sort: true,
        deduplicate: true
    });
    // Initialize state
    const [results, setResults] = (0, $cozmU.useState)({});
    (0, $cozmU.useEffect)(()=>{
        if (!shouldHydrate || accountIdsToFetch.length === 0) return;
        // 1. Optimistically update status to IN_FLIGHT for missing items
        setResults((prev)=>{
            const next = {
                ...prev
            };
            let dirty = false;
            accountIdsToFetch.forEach((accountId)=>{
                // If we don't have a DONE status for this ID, mark it as IN_FLIGHT
                if (next[accountId]?.status !== 'READY') {
                    next[accountId] = {
                        user: next[accountId]?.user || null,
                        status: 'LOADING',
                        error: null,
                        accountIdOrAri: accountId,
                        id: accountId
                    };
                    dirty = true;
                }
            });
            return dirty ? next : prev;
        });
        // 2. Delegate to the Loader
        Promise.all(accountIdsToFetch.map(async (accountId)=>{
            try {
                const user = await loader?.load(accountId);
                return {
                    accountId: accountId,
                    user: user,
                    error: null
                };
            } catch (e) {
                return {
                    accountId: accountId,
                    user: null,
                    error: e
                };
            }
        })).then((fetchedData)=>{
            setResults((prev)=>{
                const next = {
                    ...prev
                };
                const fetchedDataMap = new Map(fetchedData.map((data)=>[
                        data.accountId,
                        data
                    ]));
                accountIdsToFetch.forEach((accountId)=>{
                    const data = fetchedDataMap.get(accountId);
                    if (data && data.user) next[accountId] = {
                        accountIdOrAri: accountId,
                        id: accountId,
                        user: data.user,
                        status: 'READY',
                        error: null
                    };
                    else next[accountId] = {
                        accountIdOrAri: accountId,
                        id: accountId,
                        user: null,
                        status: 'ERRORED',
                        error: shouldHydrate ? new Error(`Failed to hydrate user ${accountId}`) : null
                    };
                });
                return next;
            });
        });
    }, [
        accountIdsToFetch,
        shouldHydrate,
        loader
    ]);
    return (0, $cozmU.useMemo)(()=>accountIdsToFetch.map((accountId)=>results[accountId] ?? {
                accountIdOrAri: accountId,
                user: null,
                status: 'ERRORED',
                error: new Error(`Unknown error. Failed to hydrate user ${accountId}`)
            }), [
        accountIdsToFetch,
        results
    ]);
}






var $bcdSN = parcelRequire("bcdSN");

function $74bb8e18cf82eba8$export$8083afddc1f4ca0a(issueTypeEdges) {
    const issueTypeToFieldsConfiguration = {};
    issueTypeEdges?.forEach((issueTypeEdge)=>{
        const issueTypeNode = issueTypeEdge?.node;
        const issueTypeId = issueTypeNode?.issueTypeId;
        if (!issueTypeId) return;
        issueTypeToFieldsConfiguration[issueTypeId] = {
            issueTypeId: String(issueTypeNode.issueTypeId),
            name: issueTypeNode.name,
            hierarchyLevel: issueTypeNode.hierarchy?.level ?? 0,
            avatarUrl: issueTypeNode.avatar?.small ?? undefined,
            fieldsConfigurationNode: Object.fromEntries((issueTypeNode.fieldsConfiguration?.edges ?? []).map((edge)=>edge?.node ? [
                    edge.node?.fieldId,
                    edge.node
                ] : []).filter((entry)=>entry.length > 0))
        };
    });
    return issueTypeToFieldsConfiguration;
}





const $ac24a907a39433f1$export$2d5a62a3515ad4c6 = {
    __typename: 'JiraIssueTypeField',
    fieldId: 'issuetype',
    type: 'issuetype',
    name: 'Type',
    isEditable: true,
    isRequired: true
};


function $d37a16d5ba1a44bc$export$c87803eaecd9013f(project, suggestIssueTypeIds, suggestFieldIds, draftItemHasExistingParent = false) {
    const issueTypeEdges = project?.issueTypes?.edges;
    if (!issueTypeEdges?.length) return {};
    // Map preserves insertion order for first appearance; Set for quick membership.
    const fieldsMap = new Map();
    const seen = new Set();
    for (const issueTypeEdge of issueTypeEdges){
        const fieldEdges = issueTypeEdge?.node?.fieldsConfiguration?.edges;
        if (fieldEdges?.length) for (const fieldEdge of fieldEdges){
            const node = fieldEdge?.node;
            if (node) {
                const fieldId = node.fieldId;
                const excluded = !fieldId || (0, $bcdSN.EXCLUDED_FIELD_IDS_SET).has(fieldId);
                // If the draft has an existing parent issue key, we want to include the parent field to be displayed in the table,
                if (!excluded || draftItemHasExistingParent && fieldId === (0, $bcdSN.PARENT_FIELD_ID)) {
                    const isExistOnIssueType = suggestIssueTypeIds.has(issueTypeEdge?.node?.issueTypeId ?? '');
                    const isRequired = (node.fieldConfig?.isRequired && isExistOnIssueType) ?? false;
                    const allowed = isRequired && isExistOnIssueType || (suggestFieldIds ? suggestFieldIds.has(fieldId) : false);
                    if (allowed) {
                        const existing = fieldsMap.get(fieldId);
                        if (!existing || isRequired && !existing.isRequired) fieldsMap.set(fieldId, {
                            __typename: node.__typename,
                            fieldId: fieldId,
                            name: node.name,
                            isEditable: node.fieldConfig?.isEditable ?? undefined,
                            isRequired: isRequired || undefined,
                            type: node.type
                        });
                        if (!seen.has(fieldId)) seen.add(fieldId);
                    }
                }
            }
        }
    }
    if (fieldsMap.size === 0) // Even if no GraphQL-provided fields, we still inject the artificial issuetype field.
    return {
        issuetype: (0, $ac24a907a39433f1$export$2d5a62a3515ad4c6)
    };
    const ordered = {};
    // 1. Defaults in declared order if present.
    for (const id of (0, $bcdSN.DEFAULT_ORDER_FIELD_IDS)){
        const fieldConfiguration = fieldsMap.get(id);
        if (fieldConfiguration && !(0, $bcdSN.EXCLUDED_FIELD_IDS_SET).has(id) && (fieldConfiguration.isRequired || (suggestFieldIds ? suggestFieldIds.has(id) : false))) ordered[id] = fieldConfiguration;
    }
    // 2 & 3. Iterate collected in insertion order to bucket leftover required vs others.
    const requiredNonDefault = [];
    const remaining = [];
    for (const [id, fieldConfiguration] of fieldsMap.entries())if (!ordered[id]) {
        // TODO: Only show required fields that exist for the issue type
        if (fieldConfiguration.isRequired) requiredNonDefault.push(fieldConfiguration);
        else if (suggestFieldIds ? suggestFieldIds.has(id) : false) remaining.push(fieldConfiguration);
    }
    for (const fieldConfiguration of requiredNonDefault)ordered[fieldConfiguration.fieldId] = fieldConfiguration;
    for (const fieldConfiguration of remaining)ordered[fieldConfiguration.fieldId] = fieldConfiguration;
    const { issuetype: existingIssueType, ...rest } = ordered;
    return {
        issuetype: existingIssueType ?? (0, $ac24a907a39433f1$export$2d5a62a3515ad4c6),
        ...rest
    };
}






var $frwr8 = parcelRequire("frwr8");

/**
 * Returns a map from a JiraComponentsField's label to its id.
 */ function $411b895f5f381b4e$var$getComponentsLabelToIdMap(fieldConfig) {
    if (!fieldConfig || fieldConfig.__typename !== (0, $bcdSN.COMPONENTS_FIELD_TYPE)) return null;
    const edges = fieldConfig?.components?.edges;
    if (!edges) return null;
    const labelToId = new Map();
    edges.forEach((edge)=>{
        const name = edge?.node?.name;
        const id = edge?.node?.componentId;
        if (name && id) labelToId.set(name, String(id));
    });
    return labelToId.size > 0 ? labelToId : null;
}
/**
 * Converts incoming JiraComponentsField labels into IDs.
 */ function $411b895f5f381b4e$var$hydrateComponentsValue(value, labelToId) {
    if (!Array.isArray(value)) return value;
    return value.map((v)=>typeof v === 'string' && labelToId.has(v) ? labelToId.get(v) : v);
}
function $411b895f5f381b4e$var$toDraftWorkItemHydratedUser(__typename, accountIdOrAri, hydratedUserResult) {
    if (!hydratedUserResult) return {
        __typename: __typename,
        accountIdOrAri: accountIdOrAri,
        status: 'INIT',
        error: null
    };
    return {
        __typename: __typename,
        accountIdOrAri: hydratedUserResult.accountIdOrAri,
        status: hydratedUserResult.status,
        error: hydratedUserResult.error,
        user: hydratedUserResult.user ? {
            accountId: hydratedUserResult.user.accountId,
            name: hydratedUserResult.user.name,
            avatarUrl: hydratedUserResult.user.avatarUrl
        } : undefined
    };
}
function $411b895f5f381b4e$export$ec6ff639525d1442({ fields: fields, extraFields: extraFields }) {
    const safeFields = {};
    const extraFieldKeys = Object.keys(extraFields);
    extraFieldKeys.forEach((key)=>{
        // TODO - check in code review: why are we doing this? Why not just use the extraFields object? Is there a reason why the top level summary and fields would be different?
        if (!Object.prototype.hasOwnProperty.call(fields, key)) safeFields[key] = extraFields[key];
    });
    return {
        ...fields,
        ...safeFields
    };
}
function $411b895f5f381b4e$export$b6d9aa160433baed({ actions: actions, issueTypeMap: issueTypeMap, hydratedUsersMap: hydratedUsersMap }) {
    const invocationIdToWorkItemMap = {};
    // Build the map directly from actions and prepare lookup maps
    actions.forEach((action)=>{
        if (action.status === 'cancelled') return;
        const issueType = issueTypeMap?.[action.data.issueTypeId];
        let createdIssueKey;
        if (action.executedData && typeof action.executedData === 'object' && 'createdIssueKey' in action.executedData && typeof action.executedData.createdIssueKey === 'string') createdIssueKey = action.executedData.createdIssueKey;
        const item = {
            invocationId: action.invocationId,
            projectIdOrKey: action.data.projectIdOrKey,
            issueTypeId: action.data.issueTypeId,
            summary: action.data.summary,
            status: action.status,
            createdIssueKey: createdIssueKey,
            fields: $411b895f5f381b4e$export$ec6ff639525d1442({
                fields: {
                    ...Object.fromEntries(Object.entries(action?.data?.fields ?? {}).map(([fieldId, value])=>{
                        const fieldConfig = issueType?.fieldsConfigurationNode?.[fieldId];
                        // If there is no field config, that means the field was hallucinated by the LLM
                        // So we'll skip those fields
                        if (!fieldConfig) {
                            // Sometimes AGG can miss the parent field, so we don't filter the parent field out even if there is no field config
                            //
                            if (fieldId === (0, $bcdSN.PARENT_FIELD_ID)) return [
                                fieldId,
                                value
                            ];
                            return [];
                        }
                        const fieldTypeName = fieldConfig.__typename;
                        if ((0, $bcdSN.USER_PICKER_FIELD_TYPES).includes(fieldTypeName)) {
                            if (Array.isArray(value)) return [
                                fieldId,
                                value.map((v)=>$411b895f5f381b4e$var$toDraftWorkItemHydratedUser(fieldTypeName, v, hydratedUsersMap?.[v]))
                            ];
                            if (typeof value !== 'string') return [];
                            return [
                                fieldId,
                                $411b895f5f381b4e$var$toDraftWorkItemHydratedUser(fieldTypeName, value, hydratedUsersMap?.[value])
                            ];
                        }
                        if (fieldTypeName === (0, $bcdSN.COMPONENTS_FIELD_TYPE)) {
                            const labelToId = $411b895f5f381b4e$var$getComponentsLabelToIdMap(fieldConfig);
                            if (labelToId) return [
                                fieldId,
                                $411b895f5f381b4e$var$hydrateComponentsValue(value, labelToId)
                            ];
                        }
                        return [
                            fieldId,
                            value
                        ];
                    }).filter((entry)=>!!entry?.length))
                },
                extraFields: {
                    // Add required fields from the issue type
                    ...Object.fromEntries(Object.values(issueType?.fieldsConfigurationNode ?? {}).filter((field)=>field.fieldConfig?.isRequired).map((field)=>[
                            field.fieldId,
                            null
                        ])),
                    issuetype: issueType,
                    summary: action.data.summary
                }
            })
        };
        invocationIdToWorkItemMap[action.invocationId] = item;
    });
    const { newMap: newMap, childInvocationIdsSet: childInvocationIdsSet } = (0, $frwr8.recalculateHierarchy)({
        itemsMap: invocationIdToWorkItemMap,
        issueTypeMap: issueTypeMap
    });
    // Calculate top-level items in order (those not in childInvocationIdsSet)
    const topLevelInvocationIds = actions.filter((action)=>!childInvocationIdsSet.has(action.invocationId) && action.status !== 'cancelled').map((action)=>action.invocationId);
    return {
        invocationIdToWorkItemMap: newMap,
        topLevelInvocationIds: topLevelInvocationIds
    };
}














const $78739190c083ec8b$export$3cfab3cce9f03f6 = (stringArray, { sort: sort, deduplicate: deduplicate, sortFunction: sortFunction = (a, b)=>a.localeCompare(b) })=>{
    const separator = '___@@@$$@@@___'; // unique separator to avoid conflicts with other strings
    // First we
    const stableItemsString = (0, $cozmU.useMemo)(()=>{
        let items = [
            ...stringArray
        ];
        if (deduplicate) items = [
            ...new Set(items)
        ];
        if (sort) items.sort(sortFunction);
        return items.join(separator);
    }, [
        stringArray,
        sort,
        separator,
        deduplicate,
        sortFunction
    ]);
    return (0, $cozmU.useMemo)(()=>stableItemsString.length ? stableItemsString.split(separator) : [], [
        stableItemsString
    ]);
};


const $04d5b079080a378f$export$9f7f8bcf70bf744 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniqueIssueTypeIds(items) {
    const $ = (0, $bDgLe.c)(6);
    let t0;
    let t1;
    if ($[0] !== items) {
        function extractIssueTypeIds(items_) {
            return items_.flatMap((item)=>[
                    item.issueTypeId,
                    ...item.childWorkItems ? extractIssueTypeIds(item.childWorkItems) : []
                ]);
        }
        t0 = (0, $78739190c083ec8b$export$3cfab3cce9f03f6);
        t1 = extractIssueTypeIds(items);
        $[0] = items;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            sort: true,
            deduplicate: true
        };
        $[3] = t2;
    } else t2 = $[3];
    const uniqueIssueTypeIdsArray = t0(t1, t2);
    let t3;
    if ($[4] !== uniqueIssueTypeIdsArray) {
        t3 = new Set(uniqueIssueTypeIdsArray);
        $[4] = uniqueIssueTypeIdsArray;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function useUniqueIssueTypeIds(items) {
    function extractIssueTypeIds(items_) {
        return items_.flatMap((item)=>[
                item.issueTypeId,
                ...item.childWorkItems ? extractIssueTypeIds(item.childWorkItems) : []
            ]);
    }
    const uniqueIssueTypeIdsArray = (0, $78739190c083ec8b$export$3cfab3cce9f03f6)(extractIssueTypeIds(items), {
        sort: true,
        deduplicate: true
    });
    return (0, $cozmU.useMemo)(()=>{
        return new Set(uniqueIssueTypeIdsArray);
    }, [
        uniqueIssueTypeIdsArray
    ]);
};












/**
 * Builds a set of unique field IDs from a collection of draft work items,
 * including all nested child work items recursively.
 *
 * Traverses the provided `draftWorkItems` array in a depth-first manner,
 * collecting all field keys from each work item and its descendants.
 *
 * @param draftWorkItems - An array of draft work items to process.
 * @returns A `Set<string>` containing all unique field IDs found in the work items and their children.
 */ function $4400b8723ab84cd1$var$toUniqueFieldIds(draftWorkItems) {
    const unique = new Set();
    if (!draftWorkItems.length) return unique;
    // Use a stack to process items depth-first; order is irrelevant for a Set.
    // Spread the readonly array into a mutable stack for depth-first processing.
    const stack = [
        ...draftWorkItems
    ];
    while(stack.length){
        const current = stack.pop();
        // current is expected to be defined because we only push non-null items.
        if (current) {
            const { fields: fields, childWorkItems: childWorkItems } = current;
            if (fields) for (const key of Object.keys(fields))unique.add(key);
            if (childWorkItems && childWorkItems.length) for(let i = 0; i < childWorkItems.length; i++){
                const child = childWorkItems[i];
                if (child) stack.push(child);
            }
        }
    }
    return unique;
}
const $4400b8723ab84cd1$export$bf8e0848557fc029 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniqueSuggestedField(draftWorkItems) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== draftWorkItems) {
        t0 = [
            ...$4400b8723ab84cd1$var$toUniqueFieldIds(draftWorkItems)
        ];
        $[0] = draftWorkItems;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            sort: true,
            deduplicate: false
        };
        $[2] = t1;
    } else t1 = $[2];
    const uniqueFieldIds = (0, $78739190c083ec8b$export$3cfab3cce9f03f6)(t0, t1);
    let t2;
    if ($[3] !== uniqueFieldIds) {
        t2 = new Set(uniqueFieldIds);
        $[3] = uniqueFieldIds;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function useUniqueSuggestedField(draftWorkItems) {
    const uniqueFieldIds = (0, $78739190c083ec8b$export$3cfab3cce9f03f6)([
        ...$4400b8723ab84cd1$var$toUniqueFieldIds(draftWorkItems)
    ], {
        sort: true,
        deduplicate: false
    });
    return (0, $cozmU.useMemo)(()=>{
        return new Set(uniqueFieldIds);
    }, [
        uniqueFieldIds
    ]);
};



var $euW6K = parcelRequire("euW6K");


var $fkQpA = parcelRequire("fkQpA");


var $GP1c3 = parcelRequire("GP1c3");

const $287682b36aed8a05$var$ISSUEKEY_REGEX = /^[A-Za-z0-9]+-\d+$/;
function $287682b36aed8a05$var$isValidJiraIssueKey(value) {
    return $287682b36aed8a05$var$ISSUEKEY_REGEX.test(value);
}
const $287682b36aed8a05$var$HYDRATION_FALLBACK_TIMEOUT_MS = 1000;
const $287682b36aed8a05$var$useHasLoadedOrTimedOut = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasLoadedOrTimedOut(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { isHydrationDone: isHydrationDone, hydratedUsersResults: hydratedUsersResults, messageId: messageId, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const [hasTimedOut, setHasTimedOut] = (0, $cozmU.useState)(false);
    const hasReportedTimeoutRef = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== isHydrationDone) {
        t1 = ()=>{
            if (isHydrationDone) return;
            const timeoutId = setTimeout(()=>{
                setHasTimedOut(true);
            }, $287682b36aed8a05$var$HYDRATION_FALLBACK_TIMEOUT_MS);
            return ()=>clearTimeout(timeoutId);
        };
        t2 = [
            isHydrationDone
        ];
        $[0] = isHydrationDone;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== hasTimedOut || $[4] !== hydratedUsersResults || $[5] !== isHydrationDone || $[6] !== messageId || $[7] !== sendAifcAnalyticsEvent) {
        t3 = ()=>{
            if (!hasTimedOut || isHydrationDone || hasReportedTimeoutRef.current) return;
            hasReportedTimeoutRef.current = true;
            sendAifcAnalyticsEvent?.({
                action: "failed",
                actionSubject: "userPickerHydration",
                actionSubjectId: "aiCreateProjectContext",
                attributes: {
                    messageId: messageId,
                    totalCount: hydratedUsersResults.length,
                    readyCount: hydratedUsersResults.filter($287682b36aed8a05$var$_temp).length,
                    erroredCount: hydratedUsersResults.filter($287682b36aed8a05$var$_temp2).length,
                    stillLoadingCount: hydratedUsersResults.filter($287682b36aed8a05$var$_temp3).length
                }
            });
        };
        t4 = [
            hasTimedOut,
            isHydrationDone,
            hydratedUsersResults,
            messageId,
            sendAifcAnalyticsEvent
        ];
        $[3] = hasTimedOut;
        $[4] = hydratedUsersResults;
        $[5] = isHydrationDone;
        $[6] = messageId;
        $[7] = sendAifcAnalyticsEvent;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useEffect)(t3, t4);
    return isHydrationDone || hasTimedOut;
} : function useHasLoadedOrTimedOut({ isHydrationDone: isHydrationDone, hydratedUsersResults: hydratedUsersResults, messageId: messageId, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent }) {
    const [hasTimedOut, setHasTimedOut] = (0, $cozmU.useState)(false);
    const hasReportedTimeoutRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isHydrationDone) return;
        const timeoutId = setTimeout(()=>{
            setHasTimedOut(true);
        }, $287682b36aed8a05$var$HYDRATION_FALLBACK_TIMEOUT_MS);
        return ()=>clearTimeout(timeoutId);
    }, [
        isHydrationDone
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!hasTimedOut || isHydrationDone || hasReportedTimeoutRef.current) return;
        hasReportedTimeoutRef.current = true;
        sendAifcAnalyticsEvent?.({
            action: 'failed',
            actionSubject: 'userPickerHydration',
            actionSubjectId: 'aiCreateProjectContext',
            attributes: {
                messageId: messageId,
                totalCount: hydratedUsersResults.length,
                readyCount: hydratedUsersResults.filter((r)=>r.status === 'READY').length,
                erroredCount: hydratedUsersResults.filter((r_0)=>r_0.status === 'ERRORED').length,
                stillLoadingCount: hydratedUsersResults.filter((r_1)=>r_1.status === 'LOADING' || r_1.status === 'INIT').length
            }
        });
    }, [
        hasTimedOut,
        isHydrationDone,
        hydratedUsersResults,
        messageId,
        sendAifcAnalyticsEvent
    ]);
    return isHydrationDone || hasTimedOut;
};
function $287682b36aed8a05$var$_temp3(r_1) {
    return r_1.status === "LOADING" || r_1.status === "INIT";
}
function $287682b36aed8a05$var$_temp2(r_0) {
    return r_0.status === "ERRORED";
}
function $287682b36aed8a05$var$_temp(r) {
    return r.status === "READY";
}
const $287682b36aed8a05$var$useAllHydratedUsersFromActions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (actions, issueTypeMap)=>{
    const $ = (0, $bDgLe.c)(11);
    let accountIds;
    if ($[0] !== actions || $[1] !== issueTypeMap) {
        accountIds = [];
        actions.forEach((action)=>Object.entries(action.data.fields).forEach((t0)=>{
                const [fieldId, value] = t0;
                const fieldType = issueTypeMap?.[action?.data?.issueTypeId]?.fieldsConfigurationNode?.[fieldId];
                if ((0, $bcdSN.USER_PICKER_FIELD_TYPES).includes(fieldType?.__typename ?? "")) accountIds.push(...Array.isArray(value) ? value : [
                    value
                ]);
            }));
        $[0] = actions;
        $[1] = issueTypeMap;
        $[2] = accountIds;
    } else accountIds = $[2];
    const allAccountIds = accountIds;
    let t0;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            sort: false,
            deduplicate: true
        };
        $[3] = t0;
    } else t0 = $[3];
    const dedupedAccountIds = (0, $4ZN5q.useStableArray)(allAccountIds, t0);
    let t1;
    if ($[4] !== dedupedAccountIds) {
        t1 = {
            accountIds: dedupedAccountIds,
            shouldHydrate: true
        };
        $[4] = dedupedAccountIds;
        $[5] = t1;
    } else t1 = $[5];
    const hydratedUsersResults = (0, $2b26c9f0f51ee6de$export$f1de398e9368e7f1)(t1);
    let t2;
    if ($[6] !== hydratedUsersResults) {
        t2 = hydratedUsersResults.reduce($287682b36aed8a05$var$_temp4, {});
        $[6] = hydratedUsersResults;
        $[7] = t2;
    } else t2 = $[7];
    const hydratedUsersMap = t2;
    let t3;
    if ($[8] !== hydratedUsersMap || $[9] !== hydratedUsersResults) {
        t3 = {
            hydratedUsersMap: hydratedUsersMap,
            hydratedUsersResults: hydratedUsersResults
        };
        $[8] = hydratedUsersMap;
        $[9] = hydratedUsersResults;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (actions, issueTypeMap)=>{
    const allAccountIds = (0, $cozmU.useMemo)(()=>{
        const accountIds = [];
        actions.forEach((action)=>{
            return Object.entries(action.data.fields).forEach(([fieldId, value])=>{
                const fieldType = issueTypeMap?.[action?.data?.issueTypeId]?.fieldsConfigurationNode?.[fieldId];
                if ((0, $bcdSN.USER_PICKER_FIELD_TYPES).includes(fieldType?.__typename ?? '')) accountIds.push(...Array.isArray(value) ? value : [
                    value
                ]);
            });
        });
        return accountIds;
    }, [
        actions,
        issueTypeMap
    ]);
    const dedupedAccountIds = (0, $4ZN5q.useStableArray)(allAccountIds, {
        sort: false,
        deduplicate: true
    });
    const hydratedUsersResults = (0, $2b26c9f0f51ee6de$export$f1de398e9368e7f1)({
        accountIds: dedupedAccountIds,
        shouldHydrate: true
    });
    const hydratedUsersMap = (0, $cozmU.useMemo)(()=>{
        return hydratedUsersResults.reduce((acc, result)=>{
            if (result.id) acc[result.id] = result;
            return acc;
        }, {});
    }, [
        hydratedUsersResults
    ]);
    return {
        hydratedUsersMap: hydratedUsersMap,
        hydratedUsersResults: hydratedUsersResults
    };
};
const $287682b36aed8a05$var$withValidateIssueTypes = (actions, issueTypes)=>{
    const validIssueTypeIds = new Set(issueTypes.map((edge)=>edge?.node?.issueTypeId).filter(Boolean));
    const defaultIssueTypeId = issueTypes.find((edge)=>edge?.node?.hierarchy?.level === 0)?.node?.issueTypeId;
    return actions.map((action)=>{
        if (validIssueTypeIds.has(action.data.issueTypeId)) return action;
        if (!defaultIssueTypeId) return action;
        return {
            ...action,
            data: {
                ...action.data,
                issueTypeId: defaultIssueTypeId
            }
        };
    });
};
const $287682b36aed8a05$var$useDraftWorkItemsState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { actions: actions, data: data, messageId: messageId, conversationId: conversationId, cloudId: cloudId, isActiveMessage: isActiveMessage, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    let t1;
    if ($[0] !== data.jira_projectByIdOrKey?.issueTypes?.edges) {
        t1 = data.jira_projectByIdOrKey?.issueTypes?.edges ?? [];
        $[0] = data.jira_projectByIdOrKey?.issueTypes?.edges;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = (0, $74bb8e18cf82eba8$export$8083afddc1f4ca0a)(t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const issueTypeMap = t2;
    const { hydratedUsersMap: hydratedUsersMap, hydratedUsersResults: hydratedUsersResults } = $287682b36aed8a05$var$useAllHydratedUsersFromActions(actions, issueTypeMap);
    let t3;
    if ($[4] !== actions || $[5] !== hydratedUsersMap || $[6] !== issueTypeMap) {
        t3 = (0, $411b895f5f381b4e$export$b6d9aa160433baed)({
            actions: actions,
            issueTypeMap: issueTypeMap,
            hydratedUsersMap: hydratedUsersMap
        });
        $[4] = actions;
        $[5] = hydratedUsersMap;
        $[6] = issueTypeMap;
        $[7] = t3;
    } else t3 = $[7];
    const { invocationIdToWorkItemMap: invocationIdToWorkItemMap, topLevelInvocationIds: topLevelInvocationIds } = t3;
    let t4;
    if ($[8] !== hydratedUsersResults) {
        t4 = hydratedUsersResults.every($287682b36aed8a05$var$_temp5);
        $[8] = hydratedUsersResults;
        $[9] = t4;
    } else t4 = $[9];
    const isHydrationDone = t4;
    let t5;
    if ($[10] !== cloudId || $[11] !== conversationId || $[12] !== isActiveMessage || $[13] !== messageId || $[14] !== sendAifcAnalyticsEvent) {
        t5 = {
            messageId: messageId,
            cloudId: cloudId,
            conversationId: conversationId,
            isActiveMessage: isActiveMessage,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        };
        $[10] = cloudId;
        $[11] = conversationId;
        $[12] = isActiveMessage;
        $[13] = messageId;
        $[14] = sendAifcAnalyticsEvent;
        $[15] = t5;
    } else t5 = $[15];
    const draftWorkItemsActions = (0, $GP1c3.useDraftWorkItems)(t5);
    const draftWorkItems = (0, $fkQpA.useGetDraftWorkItemsWithHierarchy)(messageId);
    const { initDraftWorkItems: initDraftWorkItems } = (0, $euW6K.useDraftWorkItemsActions)();
    let t6;
    if ($[16] !== hydratedUsersResults || $[17] !== isHydrationDone || $[18] !== messageId || $[19] !== sendAifcAnalyticsEvent) {
        t6 = {
            isHydrationDone: isHydrationDone,
            hydratedUsersResults: hydratedUsersResults,
            messageId: messageId,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        };
        $[16] = hydratedUsersResults;
        $[17] = isHydrationDone;
        $[18] = messageId;
        $[19] = sendAifcAnalyticsEvent;
        $[20] = t6;
    } else t6 = $[20];
    const hasLoadedOrTimedOut = $287682b36aed8a05$var$useHasLoadedOrTimedOut(t6);
    let t7;
    let t8;
    if ($[21] !== hasLoadedOrTimedOut || $[22] !== initDraftWorkItems || $[23] !== invocationIdToWorkItemMap || $[24] !== messageId || $[25] !== topLevelInvocationIds) {
        t7 = ()=>{
            if (!hasLoadedOrTimedOut) return;
            initDraftWorkItems(messageId, invocationIdToWorkItemMap, topLevelInvocationIds);
        };
        t8 = [
            messageId,
            invocationIdToWorkItemMap,
            topLevelInvocationIds,
            initDraftWorkItems,
            hasLoadedOrTimedOut
        ];
        $[21] = hasLoadedOrTimedOut;
        $[22] = initDraftWorkItems;
        $[23] = invocationIdToWorkItemMap;
        $[24] = messageId;
        $[25] = topLevelInvocationIds;
        $[26] = t7;
        $[27] = t8;
    } else {
        t7 = $[26];
        t8 = $[27];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[28] !== draftWorkItems || $[29] !== draftWorkItemsActions || $[30] !== hasLoadedOrTimedOut || $[31] !== isHydrationDone) {
        t9 = {
            draftWorkItems: draftWorkItems,
            isHydrationDone: isHydrationDone,
            isStoreReady: hasLoadedOrTimedOut,
            ...draftWorkItemsActions
        };
        $[28] = draftWorkItems;
        $[29] = draftWorkItemsActions;
        $[30] = hasLoadedOrTimedOut;
        $[31] = isHydrationDone;
        $[32] = t9;
    } else t9 = $[32];
    return t9;
} : ({ actions: actions, data: data, messageId: messageId, conversationId: conversationId, cloudId: cloudId, isActiveMessage: isActiveMessage, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const issueTypeMap = (0, $cozmU.useMemo)(()=>{
        return (0, $74bb8e18cf82eba8$export$8083afddc1f4ca0a)(data.jira_projectByIdOrKey?.issueTypes?.edges ?? []);
    }, [
        data.jira_projectByIdOrKey
    ]);
    const { hydratedUsersMap: hydratedUsersMap, hydratedUsersResults: hydratedUsersResults } = $287682b36aed8a05$var$useAllHydratedUsersFromActions(actions, issueTypeMap);
    const { invocationIdToWorkItemMap: invocationIdToWorkItemMap, topLevelInvocationIds: topLevelInvocationIds } = (0, $cozmU.useMemo)(()=>{
        return (0, $411b895f5f381b4e$export$b6d9aa160433baed)({
            actions: actions,
            issueTypeMap: issueTypeMap,
            hydratedUsersMap: hydratedUsersMap
        });
    }, [
        actions,
        issueTypeMap,
        hydratedUsersMap
    ]);
    const isHydrationDone = (0, $cozmU.useMemo)(()=>{
        return hydratedUsersResults.every((result)=>result.status === 'READY');
    }, [
        hydratedUsersResults
    ]);
    const draftWorkItemsActions = (0, $GP1c3.useDraftWorkItems)({
        messageId: messageId,
        cloudId: cloudId,
        conversationId: conversationId,
        isActiveMessage: isActiveMessage,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    });
    const draftWorkItems = (0, $fkQpA.useGetDraftWorkItemsWithHierarchy)(messageId);
    const { initDraftWorkItems: initDraftWorkItems } = (0, $euW6K.useDraftWorkItemsActions)();
    // Wait for user-picker hydration before initialising the store.
    // To avoid blocking the card forever if hydration is slow or fails, fall back to writing
    // the (possibly unhydrated) map.
    const hasLoadedOrTimedOut = $287682b36aed8a05$var$useHasLoadedOrTimedOut({
        isHydrationDone: isHydrationDone,
        hydratedUsersResults: hydratedUsersResults,
        messageId: messageId,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    });
    (0, $cozmU.useEffect)(()=>{
        if (!hasLoadedOrTimedOut) return;
        initDraftWorkItems(messageId, invocationIdToWorkItemMap, topLevelInvocationIds);
    }, [
        messageId,
        invocationIdToWorkItemMap,
        topLevelInvocationIds,
        initDraftWorkItems,
        hasLoadedOrTimedOut
    ]);
    return {
        draftWorkItems: draftWorkItems,
        isHydrationDone: // Whether user pickers have been hydrated.
        isHydrationDone,
        // Whether the store has been initialised. Until this is
        isStoreReady: hasLoadedOrTimedOut,
        ...draftWorkItemsActions
    };
};
const $287682b36aed8a05$export$e1a9d307f652a09f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useAiCreateProjectContext(t0) {
    const $ = (0, $bDgLe.c)(35);
    const { project: project, actions: actions, messageId: messageId, isActiveMessage: isActiveMessage, conversationId: conversationId, cloudId: cloudId, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const data = (0, $6SsN4.useFragment)((0, $9571c0da827caa4a$export$2e2bcd8739ae039), project);
    data.jira_projectByIdOrKey?.issueTypes?.edges;
    let t1;
    if ($[0] !== data.jira_projectByIdOrKey?.issueTypes?.edges) {
        t1 = data.jira_projectByIdOrKey?.issueTypes?.edges ?? [];
        $[0] = data.jira_projectByIdOrKey?.issueTypes?.edges;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== actions || $[3] !== t1) {
        t2 = $287682b36aed8a05$var$withValidateIssueTypes(actions, t1);
        $[2] = actions;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const validatedActions = t2;
    let t3;
    if ($[5] !== cloudId || $[6] !== conversationId || $[7] !== data || $[8] !== isActiveMessage || $[9] !== messageId || $[10] !== sendAifcAnalyticsEvent || $[11] !== validatedActions) {
        t3 = {
            actions: validatedActions,
            data: data,
            messageId: messageId,
            isActiveMessage: isActiveMessage,
            conversationId: conversationId,
            cloudId: cloudId,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        };
        $[5] = cloudId;
        $[6] = conversationId;
        $[7] = data;
        $[8] = isActiveMessage;
        $[9] = messageId;
        $[10] = sendAifcAnalyticsEvent;
        $[11] = validatedActions;
        $[12] = t3;
    } else t3 = $[12];
    const t4 = $287682b36aed8a05$var$useDraftWorkItemsState(t3);
    let draftWorkItems;
    let draftWorkItemsActions;
    let isHydrationDone;
    if ($[13] !== t4) {
        ({ draftWorkItems: draftWorkItems, isHydrationDone: isHydrationDone, ...draftWorkItemsActions } = t4);
        $[13] = t4;
        $[14] = draftWorkItems;
        $[15] = draftWorkItemsActions;
        $[16] = isHydrationDone;
    } else {
        draftWorkItems = $[14];
        draftWorkItemsActions = $[15];
        isHydrationDone = $[16];
    }
    const uniqueFieldIds = (0, $4400b8723ab84cd1$export$bf8e0848557fc029)(draftWorkItems);
    const uniqueIssueTypeIds = (0, $04d5b079080a378f$export$9f7f8bcf70bf744)(draftWorkItems);
    let t5;
    if ($[17] !== draftWorkItems) {
        t5 = draftWorkItems.some($287682b36aed8a05$var$_temp6);
        $[17] = draftWorkItems;
        $[18] = t5;
    } else t5 = $[18];
    const draftItemHasExistingParent = t5;
    let t6;
    if ($[19] !== data.jira_projectByIdOrKey || $[20] !== draftItemHasExistingParent || $[21] !== uniqueFieldIds || $[22] !== uniqueIssueTypeIds) {
        t6 = (0, $d37a16d5ba1a44bc$export$c87803eaecd9013f)(data.jira_projectByIdOrKey, uniqueIssueTypeIds, uniqueFieldIds, draftItemHasExistingParent);
        $[19] = data.jira_projectByIdOrKey;
        $[20] = draftItemHasExistingParent;
        $[21] = uniqueFieldIds;
        $[22] = uniqueIssueTypeIds;
        $[23] = t6;
    } else t6 = $[23];
    const uniqueFieldsConfiguration = t6;
    let t7;
    if ($[24] !== data.jira_projectByIdOrKey?.key || $[25] !== data.jira_projectByIdOrKey?.projectId) {
        t7 = ()=>({
                projectKey: data.jira_projectByIdOrKey?.key,
                projectId: data.jira_projectByIdOrKey?.projectId
            });
        $[24] = data.jira_projectByIdOrKey?.key;
        $[25] = data.jira_projectByIdOrKey?.projectId;
        $[26] = t7;
    } else t7 = $[26];
    data.jira_projectByIdOrKey?.key;
    data.jira_projectByIdOrKey?.projectId;
    let t8;
    if ($[27] !== t7) {
        t8 = t7();
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    const projectInfo = t8;
    let t9;
    if ($[29] !== draftWorkItems || $[30] !== draftWorkItemsActions || $[31] !== isHydrationDone || $[32] !== projectInfo || $[33] !== uniqueFieldsConfiguration) {
        t9 = {
            uniqueFieldsConfiguration: uniqueFieldsConfiguration,
            isHydrationDone: isHydrationDone,
            projectInfo: projectInfo,
            draftWorkItems: draftWorkItems,
            ...draftWorkItemsActions
        };
        $[29] = draftWorkItems;
        $[30] = draftWorkItemsActions;
        $[31] = isHydrationDone;
        $[32] = projectInfo;
        $[33] = uniqueFieldsConfiguration;
        $[34] = t9;
    } else t9 = $[34];
    return t9;
} : function useAiCreateProjectContext({ project: project, actions: actions, messageId: messageId, isActiveMessage: isActiveMessage, conversationId: conversationId, cloudId: cloudId, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent }) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks, @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $6SsN4.useFragment)((0, $9571c0da827caa4a$export$2e2bcd8739ae039), project);
    const validatedActions = (0, $cozmU.useMemo)(()=>$287682b36aed8a05$var$withValidateIssueTypes(actions, data.jira_projectByIdOrKey?.issueTypes?.edges ?? []), [
        actions,
        data.jira_projectByIdOrKey?.issueTypes?.edges
    ]);
    const { draftWorkItems: draftWorkItems, isHydrationDone: isHydrationDone, ...draftWorkItemsActions } = $287682b36aed8a05$var$useDraftWorkItemsState({
        actions: validatedActions,
        data: data,
        messageId: messageId,
        isActiveMessage: isActiveMessage,
        conversationId: conversationId,
        cloudId: cloudId,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    });
    const uniqueFieldIds = (0, $4400b8723ab84cd1$export$bf8e0848557fc029)(draftWorkItems);
    const uniqueIssueTypeIds = (0, $04d5b079080a378f$export$9f7f8bcf70bf744)(draftWorkItems);
    const draftItemHasExistingParent = (0, $cozmU.useMemo)(()=>draftWorkItems.some((item)=>{
            const parent = item.fields[0, $bcdSN.PARENT_FIELD_ID];
            return typeof parent === 'string' && $287682b36aed8a05$var$isValidJiraIssueKey(parent);
        }), [
        draftWorkItems
    ]);
    const uniqueFieldsConfiguration = (0, $cozmU.useMemo)(()=>(0, $d37a16d5ba1a44bc$export$c87803eaecd9013f)(data.jira_projectByIdOrKey, uniqueIssueTypeIds, uniqueFieldIds, draftItemHasExistingParent), [
        data.jira_projectByIdOrKey,
        uniqueIssueTypeIds,
        uniqueFieldIds,
        draftItemHasExistingParent
    ]);
    const projectInfo = (0, $cozmU.useMemo)(()=>({
            projectKey: data.jira_projectByIdOrKey?.key,
            projectId: data.jira_projectByIdOrKey?.projectId
        }), [
        data.jira_projectByIdOrKey?.key,
        data.jira_projectByIdOrKey?.projectId
    ]);
    return {
        uniqueFieldsConfiguration: uniqueFieldsConfiguration,
        isHydrationDone: isHydrationDone,
        projectInfo: projectInfo,
        draftWorkItems: draftWorkItems,
        ...draftWorkItemsActions
    };
};
function $287682b36aed8a05$var$_temp6(item) {
    const parent = item.fields[0, $bcdSN.PARENT_FIELD_ID];
    return typeof parent === "string" && $287682b36aed8a05$var$isValidJiraIssueKey(parent);
}
function $287682b36aed8a05$var$_temp4(acc, result) {
    if (result.id) acc[result.id] = result;
    return acc;
}
function $287682b36aed8a05$var$_temp5(result) {
    return result.status === "READY";
}
module.exports["useAiCreateProjectContext"] = $287682b36aed8a05$export$e1a9d307f652a09f;

});

parcelRegister("GP1c3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bjY3F = parcelRequire("bjY3F");


var $2Ueo4 = parcelRequire("2Ueo4");


var $euW6K = parcelRequire("euW6K");











var $hdBxM = parcelRequire("hdBxM");

const $6c1279e5c328dbaf$export$b952f2be4c0a81dc = (draftWorkItems)=>{
    const items = Object.values(draftWorkItems).filter((workItem)=>workItem.status !== 'cancelled' && !workItem.createdIssueKey);
    return items.map((item)=>{
        const { issuetype: _issuetypeIgnored, ...fieldsWithoutIssuetype } = item.fields;
        return {
            projectIdOrKey: item.projectIdOrKey,
            issueTypeId: item.issueTypeId,
            summary: item.summary,
            fields: fieldsWithoutIssuetype
        };
    });
};


/**
 * Publishes draft work items context to the chat store whenever they change.
 * This allows the chat to access Jira context for prompts.
 */ const $4a8ac430aba434b7$var$PUBLISH_TYPE = 'jira-create-context-payload';
const $4a8ac430aba434b7$var$PUBLISH_SOURCE = 'useJiraContext';
const $4a8ac430aba434b7$export$1c2ab1c062b203b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isActiveMessage: t1, draftWorkItems: draftWorkItems } = t0;
    const isActiveMessage = t1 === undefined ? true : t1;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const previousDataRef = (0, $cozmU.useRef)("");
    const previousIsActiveMessageRef = (0, $cozmU.useRef)(false);
    let t2;
    if ($[0] !== draftWorkItems) {
        t2 = (0, $6c1279e5c328dbaf$export$b952f2be4c0a81dc)(draftWorkItems);
        $[0] = draftWorkItems;
        $[1] = t2;
    } else t2 = $[1];
    const draftWorkItemsToSend = t2;
    let t3;
    let t4;
    if ($[2] !== draftWorkItemsToSend || $[3] !== isActiveMessage || $[4] !== publish) {
        t3 = ()=>{
            if (!isActiveMessage) return;
            const currentData = JSON.stringify(draftWorkItemsToSend);
            if (currentData !== previousDataRef.current) {
                previousDataRef.current = currentData;
                publish({
                    type: $4a8ac430aba434b7$var$PUBLISH_TYPE,
                    source: $4a8ac430aba434b7$var$PUBLISH_SOURCE,
                    data: {
                        draftWorkItems: draftWorkItemsToSend
                    }
                });
            }
        };
        t4 = [
            draftWorkItemsToSend,
            isActiveMessage,
            publish
        ];
        $[2] = draftWorkItemsToSend;
        $[3] = isActiveMessage;
        $[4] = publish;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[7] !== isActiveMessage || $[8] !== publish) {
        t5 = ()=>{
            if (!isActiveMessage && previousIsActiveMessageRef.current) publish({
                type: $4a8ac430aba434b7$var$PUBLISH_TYPE,
                source: $4a8ac430aba434b7$var$PUBLISH_SOURCE,
                data: {
                    draftWorkItems: null
                }
            });
            previousIsActiveMessageRef.current = isActiveMessage;
        };
        t6 = [
            isActiveMessage,
            publish
        ];
        $[7] = isActiveMessage;
        $[8] = publish;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $cozmU.useEffect)(t5, t6);
} : ({ isActiveMessage: isActiveMessage = true, draftWorkItems: draftWorkItems })=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const previousDataRef = (0, $cozmU.useRef)('');
    const previousIsActiveMessageRef = (0, $cozmU.useRef)(false);
    const draftWorkItemsToSend = (0, $cozmU.useMemo)(()=>(0, $6c1279e5c328dbaf$export$b952f2be4c0a81dc)(draftWorkItems), [
        draftWorkItems
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isActiveMessage) return;
        // Serialize the data to check if it actually changed
        const currentData = JSON.stringify(draftWorkItemsToSend);
        // Only publish if the serialized data has actually changed
        if (currentData !== previousDataRef.current) {
            previousDataRef.current = currentData;
            publish({
                type: $4a8ac430aba434b7$var$PUBLISH_TYPE,
                source: $4a8ac430aba434b7$var$PUBLISH_SOURCE,
                data: {
                    draftWorkItems: draftWorkItemsToSend
                }
            });
        }
    }, [
        draftWorkItemsToSend,
        isActiveMessage,
        publish
    ]);
    (0, $cozmU.useEffect)(()=>{
        // If the message becomes inactive, clear the context from the chat store
        if (!isActiveMessage && previousIsActiveMessageRef.current) publish({
            type: $4a8ac430aba434b7$var$PUBLISH_TYPE,
            source: $4a8ac430aba434b7$var$PUBLISH_SOURCE,
            data: {
                draftWorkItems: null
            }
        });
        previousIsActiveMessageRef.current = isActiveMessage;
    }, [
        isActiveMessage,
        publish
    ]);
};


const $6791a41f8594b6bd$var$EMPTY_DRAFT_WORK_ITEMS_MAP = {};
const $6791a41f8594b6bd$export$d9a8dc018b983cbe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { messageId: messageId, isActiveMessage: isActiveMessage, conversationId: conversationId, cloudId: cloudId, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { messages: messages } = (0, $euW6K.useDraftWorkItemsState)();
    const messageState = messages[messageId];
    const draftWorkItems = messageState?.draftWorkItemsMap ?? $6791a41f8594b6bd$var$EMPTY_DRAFT_WORK_ITEMS_MAP;
    const storeActions = (0, $euW6K.useDraftWorkItemsActions)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    let t1;
    if ($[0] !== draftWorkItems || $[1] !== isActiveMessage) {
        t1 = {
            draftWorkItems: draftWorkItems,
            isActiveMessage: isActiveMessage
        };
        $[0] = draftWorkItems;
        $[1] = isActiveMessage;
        $[2] = t1;
    } else t1 = $[2];
    (0, $4a8ac430aba434b7$export$1c2ab1c062b203b9)(t1);
    let t2;
    if ($[3] !== messageId || $[4] !== storeActions) {
        t2 = (t3)=>{
            const { invocationIdToCreatedIssueKey: invocationIdToCreatedIssueKey } = t3;
            storeActions.onDraftWorkItemsCreated(messageId, invocationIdToCreatedIssueKey);
        };
        $[3] = messageId;
        $[4] = storeActions;
        $[5] = t2;
    } else t2 = $[5];
    const onWorkItemsCreated = t2;
    let t3;
    if ($[6] !== messageId || $[7] !== storeActions) {
        t3 = (invocationId)=>storeActions.removeDraftWorkItem(messageId, invocationId);
        $[6] = messageId;
        $[7] = storeActions;
        $[8] = t3;
    } else t3 = $[8];
    const removeWorkItem = t3;
    let t4;
    if ($[9] !== messageId || $[10] !== storeActions) {
        t4 = ()=>{
            storeActions.onDismissAllDraftWorkItems(messageId);
        };
        $[9] = messageId;
        $[10] = storeActions;
        $[11] = t4;
    } else t4 = $[11];
    const onDismissAllDraftWorkItems = t4;
    let t5;
    if ($[12] !== cloudId || $[13] !== conversationId || $[14] !== draftWorkItems || $[15] !== experienceTracker || $[16] !== messageId || $[17] !== sendAifcAnalyticsEvent || $[18] !== storeActions) {
        t5 = (invocationId_0, fieldId, newValue, t6)=>{
            const skipFireAnalytics = t6 === undefined ? false : t6;
            const draftWorkItem = draftWorkItems[invocationId_0];
            if (draftWorkItem && cloudId && conversationId && !skipFireAnalytics) {
                const payload = {
                    invocationId: invocationId_0,
                    data: {
                        summary: fieldId === "summary" ? String(newValue) : draftWorkItem.summary,
                        issueTypeId: draftWorkItem.issueTypeId,
                        projectIdOrKey: draftWorkItem.projectIdOrKey,
                        fields: {
                            ...draftWorkItem.fields,
                            [fieldId]: newValue
                        }
                    }
                };
                (0, $2Ueo4.saveDraftWorkItem)(cloudId, conversationId, messageId, payload, sendAifcAnalyticsEvent, experienceTracker);
            }
            storeActions.onFieldChange(messageId, invocationId_0, fieldId, newValue);
        };
        $[12] = cloudId;
        $[13] = conversationId;
        $[14] = draftWorkItems;
        $[15] = experienceTracker;
        $[16] = messageId;
        $[17] = sendAifcAnalyticsEvent;
        $[18] = storeActions;
        $[19] = t5;
    } else t5 = $[19];
    const onFieldChange = t5;
    let t6;
    if ($[20] !== onDismissAllDraftWorkItems || $[21] !== onFieldChange || $[22] !== onWorkItemsCreated || $[23] !== removeWorkItem) {
        t6 = {
            onWorkItemsCreated: onWorkItemsCreated,
            onDismissAllDraftWorkItems: onDismissAllDraftWorkItems,
            onFieldChange: onFieldChange,
            removeWorkItem: removeWorkItem
        };
        $[20] = onDismissAllDraftWorkItems;
        $[21] = onFieldChange;
        $[22] = onWorkItemsCreated;
        $[23] = removeWorkItem;
        $[24] = t6;
    } else t6 = $[24];
    return t6;
} : ({ messageId: messageId, isActiveMessage: isActiveMessage, conversationId: conversationId, cloudId: cloudId, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { messages: messages } = (0, $euW6K.useDraftWorkItemsState)();
    const messageState = messages[messageId];
    const draftWorkItems = messageState?.draftWorkItemsMap ?? $6791a41f8594b6bd$var$EMPTY_DRAFT_WORK_ITEMS_MAP;
    const storeActions = (0, $euW6K.useDraftWorkItemsActions)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    // TODO: Fix this usage so that we correctly send current state (including inline edits) as JiraContext
    (0, $4a8ac430aba434b7$export$1c2ab1c062b203b9)({
        draftWorkItems: draftWorkItems,
        isActiveMessage: isActiveMessage
    });
    const onWorkItemsCreated = (0, $cozmU.useCallback)(({ invocationIdToCreatedIssueKey: invocationIdToCreatedIssueKey })=>{
        storeActions.onDraftWorkItemsCreated(messageId, invocationIdToCreatedIssueKey);
    }, [
        storeActions,
        messageId
    ]);
    const removeWorkItem = (0, $cozmU.useCallback)((invocationId)=>{
        return storeActions.removeDraftWorkItem(messageId, invocationId);
    }, [
        storeActions,
        messageId
    ]);
    const onDismissAllDraftWorkItems = (0, $cozmU.useCallback)(()=>{
        storeActions.onDismissAllDraftWorkItems(messageId);
    }, [
        storeActions,
        messageId
    ]);
    const onFieldChange = (0, $cozmU.useCallback)((invocationId_0, fieldId, newValue, skipFireAnalytics = false)=>{
        const draftWorkItem = draftWorkItems[invocationId_0];
        // If we are skipping the analytics firing event, it is not a user action and hence we don't need to save the draft work item
        if (draftWorkItem && cloudId && conversationId && !skipFireAnalytics) {
            const payload = {
                invocationId: invocationId_0,
                data: {
                    summary: fieldId === 'summary' ? String(newValue) : draftWorkItem.summary,
                    issueTypeId: draftWorkItem.issueTypeId,
                    projectIdOrKey: draftWorkItem.projectIdOrKey,
                    fields: {
                        ...draftWorkItem.fields,
                        [fieldId]: newValue
                    }
                }
            };
            (0, $2Ueo4.saveDraftWorkItem)(cloudId, conversationId, messageId, payload, sendAifcAnalyticsEvent, experienceTracker);
        }
        storeActions.onFieldChange(messageId, invocationId_0, fieldId, newValue);
    }, [
        storeActions,
        messageId,
        cloudId,
        conversationId,
        sendAifcAnalyticsEvent,
        experienceTracker,
        draftWorkItems
    ]);
    return {
        onWorkItemsCreated: onWorkItemsCreated,
        onDismissAllDraftWorkItems: onDismissAllDraftWorkItems,
        onFieldChange: onFieldChange,
        removeWorkItem: removeWorkItem
    };
};
module.exports["useDraftWorkItems"] = $6791a41f8594b6bd$export$d9a8dc018b983cbe;

});

parcelRegister("cKMeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $Ou0Zz = parcelRequire("Ou0Zz");

const $72d94aaabe1bb177$export$dee720ed7e83e283 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(7);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t0;
    if ($[0] !== messageId) {
        t0 = (0, $iDrrr.fg)("jira-aifc-workflow-resumption-ui-updates-targeting") ? {
            messageId: messageId,
            variant: (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "cohort", "control", {
                fireExperimentExposure: false
            })
        } : {};
        $[0] = messageId;
        $[1] = t0;
    } else t0 = $[1];
    const baseAttributes = t0;
    let t1;
    if ($[2] !== baseAttributes || $[3] !== sendAnalyticsEvent) {
        t1 = (payload, options)=>{
            const attributes = "attributes" in payload ? payload.attributes : {};
            sendAnalyticsEvent({
                ...payload,
                attributes: {
                    ...baseAttributes,
                    ...attributes
                }
            }, ...options ? [
                options
            ] : []);
        };
        $[2] = baseAttributes;
        $[3] = sendAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const sendAifcAnalyticsEvent = t1;
    let t2;
    if ($[5] !== sendAifcAnalyticsEvent) {
        t2 = {
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        };
        $[5] = sendAifcAnalyticsEvent;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (messageId)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    // conversationId is already sent as `conversationChannelId`, a default attribute in the instrumentation.
    const baseAttributes = (0, $cozmU.useMemo)(()=>{
        return (0, $iDrrr.fg)('jira-aifc-workflow-resumption-ui-updates-targeting') ? {
            messageId: messageId,
            variant: (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
                fireExperimentExposure: false
            })
        } : {};
    }, [
        messageId
    ]);
    const sendAifcAnalyticsEvent = (0, $cozmU.useCallback)((payload, options)=>{
        const attributes = 'attributes' in payload ? payload.attributes : {};
        sendAnalyticsEvent({
            ...payload,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }, ...options ? [
            options
        ] : []);
    }, [
        sendAnalyticsEvent,
        baseAttributes
    ]);
    return {
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    };
};
module.exports["useAifcAnalytics"] = $72d94aaabe1bb177$export$dee720ed7e83e283;

});

parcelRegister("k1Pvg", function(module, exports) {
const $facdac86f4ba08d8$export$49073de218c0e4d6 = {
    AI_MATE: 'ai-mate',
    AI_MATE_ACTIONS: 'ai-mate-actions',
    AI_MATE_INSERT_URLS: 'ai-mate-chat-inserts',
    AI_MATE_CHAT_INPUT_OVERLAY: 'ai-mate-chat-input-overlay',
    AVP: 'avp'
};
const $facdac86f4ba08d8$export$69d3cd8e04a34bd6 = 'jira-inline-agent-creation-agent-assigned';
const $facdac86f4ba08d8$export$273aa0a3b01f12a3 = 'jira-work-items-creating';
const $facdac86f4ba08d8$export$6c48beaef33b5d07 = 'jira-work-items-created';
const $facdac86f4ba08d8$export$141a1577d8898865 = 'jira-work-items-create-failed';
module.exports["Topics"] = $facdac86f4ba08d8$export$49073de218c0e4d6;
module.exports["JIRA_INLINE_AGENT_CREATION_AGENT_ASSIGNED_EVENT"] = $facdac86f4ba08d8$export$69d3cd8e04a34bd6;
module.exports["JIRA_WORK_ITEMS_CREATING_EVENT"] = $facdac86f4ba08d8$export$273aa0a3b01f12a3;
module.exports["JIRA_WORK_ITEMS_CREATED_EVENT"] = $facdac86f4ba08d8$export$6c48beaef33b5d07;
module.exports["JIRA_WORK_ITEMS_CREATE_FAILED_EVENT"] = $facdac86f4ba08d8$export$141a1577d8898865;

});

parcelRegister("f8NKz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $iZMIZ = parcelRequire("iZMIZ");


var $4aRua = parcelRequire("4aRua");

parcelRequire("h9r4d");
var $kFTt2 = parcelRequire("kFTt2");

const $8f986accc3dfbae7$var$SUCCESS_FLAG_ID = 'conversation-assistant-message-actions.jira-smart-issue-create.success-flag';
const $8f986accc3dfbae7$var$messages = (0, $kSwu1.defineMessages)({
    viewIssueCta: {
        id: "jira-create-work-items.success-flag.view-issue-cta",
        defaultMessage: "View{issueCount, plural, one { work item} other { work items}}"
    },
    copyLinkCta: {
        id: "jira-create-work-items.success-flag.copy-link-cta",
        defaultMessage: "Copy link"
    },
    linkCopied: {
        id: "jira-create-work-items.success-flag.link-copied",
        defaultMessage: "Copied"
    }
});
// Creates the issue discovery link for given Jira issue keys based on the cloudUrl
const $8f986accc3dfbae7$var$getNavigatorLink = (cloudUrl, issueKeys)=>`${cloudUrl}/issues/?jql=issuekey in (${issueKeys.join(',')})`;
const $8f986accc3dfbae7$export$b58defee63578cad = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const showSuccessFlag = (0, $cozmU.useCallback)(({ createdIssueKeys: createdIssueKeys, cloudUrl: cloudUrl = '' })=>{
        const issueDiscoveryUrl = $8f986accc3dfbae7$var$getNavigatorLink(cloudUrl, createdIssueKeys);
        // Create a self-contained copy action that persists after component unmount
        const createFlagActions = ()=>{
            let isCopied = false;
            let flagId = null;
            const updateFlag = ()=>{
                const viewAction = {
                    content: formatMessage($8f986accc3dfbae7$var$messages.viewIssueCta, {
                        issueCount: createdIssueKeys.length
                    }),
                    href: issueDiscoveryUrl
                };
                const copyAction = {
                    content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        color: 'color.text.success'
                    }, formatMessage($8f986accc3dfbae7$var$messages.linkCopied)) : formatMessage($8f986accc3dfbae7$var$messages.copyLinkCta),
                    onClick: async ()=>{
                        try {
                            await navigator.clipboard.writeText(issueDiscoveryUrl);
                            isCopied = true;
                            updateFlag();
                            // Reset after 2 seconds
                            setTimeout(()=>{
                                isCopied = false;
                                updateFlag();
                            }, 2000);
                            return {
                                content: formatMessage($8f986accc3dfbae7$var$messages.copyLinkCta),
                                onClick: copyAction
                            };
                        } catch (error) {
                            (0, $kFTt2.default)({
                                meta: {
                                    id: 'copyToClipboard',
                                    packageName: 'jiraSmartIssueCreate',
                                    teamName: 'Jira AI - Crocs'
                                },
                                error: error instanceof Error ? error : new Error(String(error))
                            });
                        }
                    }
                };
                if (flagId) showFlag({
                    id: flagId,
                    title: formatMessage($8f986accc3dfbae7$var$messages.viewIssueCta, {
                        issueCount: createdIssueKeys.length
                    }),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: ""
                    }),
                    actions: [
                        viewAction,
                        copyAction
                    ]
                });
            };
            return {
                setFlagId: (id)=>{
                    flagId = id;
                },
                updateFlag: updateFlag
            };
        };
        const { setFlagId: setFlagId, updateFlag: updateFlag_0 } = createFlagActions();
        setFlagId($8f986accc3dfbae7$var$SUCCESS_FLAG_ID);
        updateFlag_0();
    }, [
        showFlag,
        formatMessage
    ]);
    return showSuccessFlag;
};
module.exports["useCreateIssuesSuccessFlags"] = $8f986accc3dfbae7$export$b58defee63578cad;

});

parcelRegister("hCHQD", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $09b5bedb64deaadf$var$IssueTypeSchema = (0, $87Lnp.z).object({
    issueTypeId: (0, $87Lnp.z).string(),
    name: (0, $87Lnp.z).string(),
    avatarUrl: (0, $87Lnp.z).string().optional()
});
const $09b5bedb64deaadf$var$UserSchema = (0, $87Lnp.z).object({
    accountId: (0, $87Lnp.z).string().catch(''),
    name: (0, $87Lnp.z).string().catch(''),
    avatarUrl: (0, $87Lnp.z).string().optional().catch('')
});
const $09b5bedb64deaadf$var$UserSchemaWithFieldWrapper = (0, $87Lnp.z).object({
    __typename: (0, $87Lnp.z).string().nullable().optional().catch(null),
    status: (0, $87Lnp.z).enum([
        'INIT',
        'READY',
        'LOADING',
        'ERRORED'
    ]),
    error: (0, $87Lnp.z).string().nullable().optional().catch(null),
    user: $09b5bedb64deaadf$var$UserSchema.nullable().catch(null)
}).optional().nullable();
const $09b5bedb64deaadf$export$6db8ad17713603d8 = (value)=>{
    return $09b5bedb64deaadf$var$UserSchemaWithFieldWrapper.parse(value);
};
const $09b5bedb64deaadf$export$d4b1d39c659c49b2 = (value)=>{
    return value.map($09b5bedb64deaadf$export$6db8ad17713603d8);
};
const $09b5bedb64deaadf$export$9c4507382911ad85 = (value)=>{
    return $09b5bedb64deaadf$var$IssueTypeSchema.parse(value).issueTypeId;
};
module.exports["parseUser"] = $09b5bedb64deaadf$export$6db8ad17713603d8;
module.exports["parseUsers"] = $09b5bedb64deaadf$export$d4b1d39c659c49b2;
module.exports["parseIssueType"] = $09b5bedb64deaadf$export$9c4507382911ad85;

});

parcelRegister("htTUm", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $4XbfY = parcelRequire("4XbfY");


var $3xuv0 = parcelRequire("3xuv0");


var $97CWy = parcelRequire("97CWy");

const $ecada00de6215dbb$var$serializer = new (0, $3xuv0.JSONTransformer)();
function $ecada00de6215dbb$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $97CWy.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $4XbfY.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $ecada00de6215dbb$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $ecada00de6215dbb$export$dfca419434f7e5a8;

});

parcelRegister("97CWy", function(module, exports) {

var $3GWdi = parcelRequire("3GWdi");


var $zBSTr = parcelRequire("zBSTr");


var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $kSg3y = parcelRequire("kSg3y");


var $32JXH = parcelRequire("32JXH");


var $tBiym = parcelRequire("tBiym");


var $dufQX = parcelRequire("dufQX");


var $6ePpQ = parcelRequire("6ePpQ");


var $fj1lJ = parcelRequire("fj1lJ");


var $lmUH1 = parcelRequire("lmUH1");


var $4b30g = parcelRequire("4b30g");


var $6Fusb = parcelRequire("6Fusb");


var $dEYMF = parcelRequire("dEYMF");


var $jqtAE = parcelRequire("jqtAE");


var $04Duz = parcelRequire("04Duz");


var $dEwV7 = parcelRequire("dEwV7");


var $g7zAo = parcelRequire("g7zAo");

function $2c1f17fa8725a273$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $2c1f17fa8725a273$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($2c1f17fa8725a273$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $aPdNQ.Fragment)) children.push(...$2c1f17fa8725a273$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $aPdNQ.Fragment).fromArray(children);
}
function $2c1f17fa8725a273$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, $3GWdi.default)('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $kSg3y.PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, $kSg3y.PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $dufQX.default), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $fj1lJ.default), idMap);
        tokenizer.use((0, $6ePpQ.default), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $tBiym.default), idMap);
    tokenizer.use((0, $04Duz.default));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $4b30g.default));
    tokenizer.use((0, $dEYMF.default));
    tokenizer.use((0, $lmUH1.default));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $zBSTr.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $jqtAE.default));
        else tokenizer.use((0, $6Fusb.markdownItMedia));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $32JXH.default));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $dEwV7.default));
    const markdownParser = new (0, $2jzwX.MarkdownParser)(schema, tokenizer, (0, $kSg3y.filterMdToPmSchemaMapping)(schema, (0, $kSg3y.getMdToPmMapping)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $aPdNQ.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $g7zAo.escapeLinks)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $2c1f17fa8725a273$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $2c1f17fa8725a273$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $2c1f17fa8725a273$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $2c1f17fa8725a273$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $2c1f17fa8725a273$export$e661a057c2263d64;

});

parcelRegister("kSg3y", function(module, exports) {
function $c5a7138b7add57b2$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $c5a7138b7add57b2$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $c5a7138b7add57b2$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });
module.exports["filterMdToPmSchemaMapping"] = $c5a7138b7add57b2$export$a9d25ff08f358d72;
module.exports["PM_SCHEMA_TO_MD_MAPPING"] = $c5a7138b7add57b2$export$b535e2638dcce02;
module.exports["getMdToPmMapping"] = $c5a7138b7add57b2$export$8f853a1c35ed8bbe;

});

parcelRegister("32JXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $347ba1e2d3b8b47a$export$2e2bcd8739ae039);
const $347ba1e2d3b8b47a$var$captionOpen = 'caption_open';
const $347ba1e2d3b8b47a$var$paragraphOpen = 'paragraph_open';
const $347ba1e2d3b8b47a$var$paragraphClose = 'paragraph_close';
function $347ba1e2d3b8b47a$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $347ba1e2d3b8b47a$var$paragraphOpen && tokens[index + 2]?.type !== $347ba1e2d3b8b47a$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $347ba1e2d3b8b47a$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $347ba1e2d3b8b47a$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $347ba1e2d3b8b47a$var$captionOpen;
            if (type === $347ba1e2d3b8b47a$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $347ba1e2d3b8b47a$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("tBiym", function(module, exports) {
$parcel$export(module.exports, "default", () => $6076957fd7cd32c6$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6076957fd7cd32c6$var$CITATION_REGEXP = /^\[\^[^\^]+\^]/;
function $6076957fd7cd32c6$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ const match = $6076957fd7cd32c6$var$CITATION_REGEXP.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}

});

parcelRegister("dufQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e900860f50f3a4b$export$2e2bcd8739ae039);

var $3Rhha = parcelRequire("3Rhha");


var $6uqzh = parcelRequire("6uqzh");

// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $6e900860f50f3a4b$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $6e900860f50f3a4b$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005, go/ees019
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$6e900860f50f3a4b$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $3Rhha.createToken)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $6uqzh.sanitizeCustomBlocks)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}

});

parcelRegister("3Rhha", function(module, exports) {
function $9ab51ce7b808dc10$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}
module.exports["createToken"] = $9ab51ce7b808dc10$export$c255480b061bd6aa;

});

parcelRegister("6uqzh", function(module, exports) {
function $711a479e43e35ace$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}
module.exports["sanitizeCustomBlocks"] = $711a479e43e35ace$export$e717b161ec14d433;

});

parcelRegister("6ePpQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c81b4420832543a$export$2e2bcd8739ae039);

var $3u5lg = parcelRequire("3u5lg");

function $1c81b4420832543a$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005, go/ees019
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005, go/ees019
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}

});

parcelRegister("fj1lJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $69d4f76cefec72c0$export$2e2bcd8739ae039);
const $69d4f76cefec72c0$var$decisionItemOpen = 'decisionItem_open';
const $69d4f76cefec72c0$var$paragraphOpen = 'paragraph_open';
const $69d4f76cefec72c0$var$paragraphClose = 'paragraph_close';
const $69d4f76cefec72c0$var$inline = 'inline';
function $69d4f76cefec72c0$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $69d4f76cefec72c0$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $69d4f76cefec72c0$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $69d4f76cefec72c0$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $69d4f76cefec72c0$var$paragraphOpen || type === $69d4f76cefec72c0$var$paragraphClose) $69d4f76cefec72c0$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("lmUH1", function(module, exports) {
$parcel$export(module.exports, "default", () => $076f59d847c7ddfa$export$2e2bcd8739ae039);
const $076f59d847c7ddfa$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $076f59d847c7ddfa$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $076f59d847c7ddfa$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $076f59d847c7ddfa$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $076f59d847c7ddfa$var$processInlineChildren(token.children);
};
var $076f59d847c7ddfa$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $076f59d847c7ddfa$var$brToLineBreak);

});

parcelRegister("4b30g", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55cb656ca55803d$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $tALAR = parcelRequire("tALAR");


var $9p0BY = parcelRequire("9p0BY");


var $g7zAo = parcelRequire("g7zAo");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$IS_LINK_OPEN_REGEX = /^<a[>\s]/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$IS_LINK_CLOSE_REGEX = /^<\/a\s*>/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$STRIP_HTTP_PREFIX_REGEX = /^http:\/\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$MAILTO_TEST_REGEX = /^mailto:/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$STRIP_MAILTO_PREFIX_REGEX = /^mailto:/;
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b55cb656ca55803d$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $b55cb656ca55803d$var$isLinkOpen = (str)=>{
    return $b55cb656ca55803d$var$IS_LINK_OPEN_REGEX.test(str);
};
const $b55cb656ca55803d$var$isLinkClose = (str)=>{
    return $b55cb656ca55803d$var$IS_LINK_CLOSE_REGEX.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b55cb656ca55803d$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, $tALAR.default)();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($b55cb656ca55803d$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($b55cb656ca55803d$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $9p0BY.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $g7zAo.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $g7zAo.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees017 (to be fixed)
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace($b55cb656ca55803d$var$STRIP_HTTP_PREFIX_REGEX, '');
                    else if (links[ln].schema === 'mailto:' && !$b55cb656ca55803d$var$MAILTO_TEST_REGEX.test(urlText)) // Ignored via go/ees017 (to be fixed)
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace($b55cb656ca55803d$var$STRIP_MAILTO_PREFIX_REGEX, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $b55cb656ca55803d$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$b55cb656ca55803d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $b55cb656ca55803d$var$linkify);

});

parcelRegister("g7zAo", function(module, exports) {
// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
const $49c0612cc98e451f$export$893fccbed37586dd = // eslint-disable-next-line require-unicode-regexp
/([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $49c0612cc98e451f$var$HTTP_FTP_URL_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s]+$/;
const $49c0612cc98e451f$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($49c0612cc98e451f$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $49c0612cc98e451f$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $49c0612cc98e451f$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        return str.match($49c0612cc98e451f$var$HTTP_FTP_URL_REGEX) ? `<${str}>` : str;
    });
}
module.exports["findFilepaths"] = $49c0612cc98e451f$export$d37783fe63e2f0fe;
module.exports["isLinkInMatches"] = $49c0612cc98e451f$export$5e652e74655163e5;
module.exports["escapeLinks"] = $49c0612cc98e451f$export$8acd10161c5f8b07;

});

parcelRegister("6Fusb", function(module, exports) {
// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $9t7Od = parcelRequire("9t7Od");

function $37fa07c339d48bac$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $9t7Od.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens// eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                .map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $37fa07c339d48bac$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $37fa07c339d48bac$var$createRule());
};
module.exports["markdownItMedia"] = $37fa07c339d48bac$export$c8dcbd316b71f8cf;

});

parcelRegister("dEYMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $931c1633f054cf68$export$2e2bcd8739ae039);
// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $931c1633f054cf68$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$931c1633f054cf68$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $931c1633f054cf68$var$newline);

});

parcelRegister("jqtAE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6a726a34adc4bbd$export$2e2bcd8739ae039);

var $9t7Od = parcelRequire("9t7Od");


var $3Rhha = parcelRequire("3Rhha");

// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c6a726a34adc4bbd$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c6a726a34adc4bbd$var$INLINE_MEDIA_MATCH_REGEX = /!\[[^\]]*\]\([^)]+\)/u;
const $c6a726a34adc4bbd$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $c6a726a34adc4bbd$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $c6a726a34adc4bbd$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $3Rhha.createToken)(state, 'media_single_open');
    const media = (0, $3Rhha.createToken)(state, 'media');
    media.attrs = [
        [
            'url',
            $c6a726a34adc4bbd$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $9t7Od.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($c6a726a34adc4bbd$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $3Rhha.createToken)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $c6a726a34adc4bbd$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $3Rhha.createToken)(state, 'paragraph_open');
    const inline = (0, $3Rhha.createToken)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $3Rhha.createToken)(state, 'text')
    ];
    const paragraphClose = (0, $3Rhha.createToken)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $c6a726a34adc4bbd$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $c6a726a34adc4bbd$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $c6a726a34adc4bbd$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $c6a726a34adc4bbd$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $c6a726a34adc4bbd$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($c6a726a34adc4bbd$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $c6a726a34adc4bbd$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = $c6a726a34adc4bbd$var$INLINE_MEDIA_MATCH_REGEX.test(item);
                    if (doesMatch) $c6a726a34adc4bbd$var$createMediaTokens(item, state, acc);
                    else $c6a726a34adc4bbd$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$c6a726a34adc4bbd$var$checkPreviousToken('media_single_close', acc) && !$c6a726a34adc4bbd$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("04Duz", function(module, exports) {
$parcel$export(module.exports, "default", () => $79a66323a159f1f1$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $79a66323a159f1f1$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$79a66323a159f1f1$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $79a66323a159f1f1$var$paragraph);

});

parcelRegister("dEwV7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4b8821874531627$export$2e2bcd8739ae039);

var $3Rhha = parcelRequire("3Rhha");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e4b8821874531627$var$REMOVE_TODO_MARKDOWN_REGEX = /(\[x\]\s)|(\[\s\]\s)/;
const $e4b8821874531627$var$bulletListOpen = 'bullet_list_open';
const $e4b8821874531627$var$bulletListClose = 'bullet_list_close';
const $e4b8821874531627$var$listItemOpen = 'list_item_open';
const $e4b8821874531627$var$listItemClose = 'list_item_close';
const $e4b8821874531627$var$taskListOpen = 'task_list_open';
const $e4b8821874531627$var$taskListClose = 'task_list_close';
const $e4b8821874531627$var$taskItemOpen = 'task_item_open';
const $e4b8821874531627$var$taskItemClose = 'task_item_close';
const $e4b8821874531627$var$paragraphOpen = 'paragraph_open';
const $e4b8821874531627$var$paragraphClose = 'paragraph_close';
function $e4b8821874531627$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $e4b8821874531627$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $e4b8821874531627$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $e4b8821874531627$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $e4b8821874531627$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskItemClose, $e4b8821874531627$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskListOpen, $e4b8821874531627$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskListOpen));
    else acc.push(token);
}
function $e4b8821874531627$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemClose);
    const isPreviousTokenTaskListClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskListClose, $e4b8821874531627$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $e4b8821874531627$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $e4b8821874531627$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemClose);
    const isPreviousTokenListItemClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$listItemClose);
    const isPreviousTokenTaskListClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$bulletListClose));
            acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskListOpen));
        }
        newTaskItemOpen.meta = $e4b8821874531627$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $e4b8821874531627$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskListClose));
            acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $e4b8821874531627$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $e4b8821874531627$var$checkTypeByIndex(acc, 'inline') && $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $3Rhha.createToken)(state, $e4b8821874531627$var$taskItemClose, $e4b8821874531627$var$getTokenByIndex(acc, -2).level));
    else if (!$e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskListClose)) acc.push(token);
}
function $e4b8821874531627$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $e4b8821874531627$var$removeTodoMarkdown(token.children[0].content);
    token.content = $e4b8821874531627$var$removeTodoMarkdown(token.content);
    token.level = $e4b8821874531627$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $e4b8821874531627$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemOpen) || $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $e4b8821874531627$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $e4b8821874531627$var$taskItemOpen;
}
function $e4b8821874531627$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $e4b8821874531627$var$removeTodoMarkdown(content) {
    return content.replace($e4b8821874531627$var$REMOVE_TODO_MARKDOWN_REGEX, '');
}
function $e4b8821874531627$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $e4b8821874531627$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $e4b8821874531627$var$bulletListOpen) $e4b8821874531627$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $e4b8821874531627$var$bulletListClose) $e4b8821874531627$var$handleBulletListClose(state, token, acc);
            else if (type === $e4b8821874531627$var$listItemOpen) $e4b8821874531627$var$handleListItemOpen(state, token, acc, index);
            else if ($e4b8821874531627$var$isInlineAfterTaskItemOpen(token, acc)) $e4b8821874531627$var$handleInline(token, acc);
            else if (type === $e4b8821874531627$var$listItemClose) $e4b8821874531627$var$handleListItemClose(state, token, acc);
            else if (type === $e4b8821874531627$var$paragraphOpen || type === $e4b8821874531627$var$paragraphClose) $e4b8821874531627$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $iDrrr.fg)("nin_glance_panel_initial_width_ssr") ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $iDrrr.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $iDrrr.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $iDrrr.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $7avaU.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $7avaU.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("5WTxQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $2oyXR = parcelRequire("2oyXR");

const $e01be1a23d2a446d$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc"
};
const $e01be1a23d2a446d$export$9520f072db304aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== children || $[1] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
                testId: testId
            }, children);
            $[0] = children;
            $[1] = testId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $e01be1a23d2a446d$var$styles.wrapper,
            testId: testId
        }, children);
        $[3] = children;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, testId: testId })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
        testId: testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $e01be1a23d2a446d$var$styles.wrapper,
        testId: testId
    }, children);
};
module.exports["PreviewPanel"] = $e01be1a23d2a446d$export$9520f072db304aa0;

});

parcelRegister("2oyXR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $biqj4 = parcelRequire("biqj4");

const $6ccdb3d7b226a54f$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC"
}; /**
    * The PanelContainer component provides a standardized container for displaying content
    * in a side panel layout. It follows the design system patterns and integrates
    * with the navigation system for consistent styling and behavior.
    *
    * Compose it with a fixed `PanelHeader` / `PanelFooter` and a scrollable `PanelContent`
    * (wrapping `PanelSubheader` and `PanelBody`).
    *
    * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
    * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
    */ 
const $6ccdb3d7b226a54f$export$7c4d2b536147788a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelContainer(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { children: children, testId: testId, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6ccdb3d7b226a54f$var$styles.content
        }, children);
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2 || $[3] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper
        }, t2);
        $[2] = t2;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isFocusLockEnabled || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $biqj4.PanelFocusLock), {
            isFocusLockEnabled: isFocusLockEnabled
        }, t3);
        $[5] = isFocusLockEnabled;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function PanelContainer({ children: children, testId: testId, isFocusLockEnabled: isFocusLockEnabled = false }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $biqj4.PanelFocusLock), {
        isFocusLockEnabled: isFocusLockEnabled
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "section",
        testId: testId,
        xcss: $6ccdb3d7b226a54f$var$styles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6ccdb3d7b226a54f$var$styles.content
    }, children)));
};
module.exports["PanelContainer"] = $6ccdb3d7b226a54f$export$7c4d2b536147788a;

});

parcelRegister("biqj4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1enXm = parcelRequire("1enXm");


var $1hQ0e = parcelRequire("1hQ0e");

// box model so PanelContainer's own height/flex styles work exactly as if this wrapper
// were not there. This avoids breaking resize and full-height layouts.
const $2153848f433e7d96$var$contentsStyle = {
    display: 'contents'
};
const $2153848f433e7d96$var$containerStyles = null; /**
                               * Module-level count of currently-mounted PanelFocusLock instances.
                               *
                               * Used to suppress the return-focus restore when one panel is replaced by
                               * another (e.g. Jira admin sidebar swaps Sidebar A → Sidebar B by changing
                               * the Provider component, which unmounts/remounts PanelFocusLock). Without
                               * this guard, the unmounting panel's queued double-rAF restore would fire
                               * AFTER the new panel's autofocus, snapping focus back to the original
                               * trigger while a replacement panel is on screen.
                               *
                               * The counter is decremented synchronously on cleanup BEFORE the new
                               * instance's mount effect runs, then re-checked inside the deferred restore.
                               * If another instance has mounted by the time the double-rAF fires, the
                               * restore is skipped.
                               */ 
let $2153848f433e7d96$var$panelFocusLockMountCount = 0; /**
                                   * Module-level handoff for the "previously focused" element across an
                                   * unmount → mount swap.
                                   *
                                   * When one PanelFocusLock unmounts and is immediately replaced by another
                                   * because a button INSIDE the unmounting panel triggered the swap (e.g.
                                   * Sidebar A's footer "Add spaces" button opens Sidebar B), the replacement's
                                   * mount effect sees `document.activeElement === document.body` because the
                                   * previously-focused element lived inside the panel that just unmounted.
                                   * Without a handoff, the replacement would capture `body` as its "previously
                                   * focused" snapshot and on close would restore focus to nothing / blur.
                                   *
                                   * The unmounting instance writes its own previously-focused snapshot here,
                                   * and the next mounting instance reads + clears it. The handoff is used
                                   * ONLY when the replacement's `document.activeElement` is `body` (or null) —
                                   * meaning focus disappeared because it lived inside the unmounting panel.
                                   * If `document.activeElement` is a real element (e.g. the user clicked a
                                   * different page-level trigger to open this panel), that element wins
                                   * because it's a more accurate "where focus came from" signal than the
                                   * previous panel's snapshot. Cleared either by the next mount or by the
                                   * deferred restore when no replacement appears, so a stale value can't leak
                                   * across unrelated open cycles.
                                   */ 
let $2153848f433e7d96$var$pendingPreviouslyFocused = null; /**
                                                          * Selector for all focusable elements inside a container, in LTR tab order.
                                                          */ 
const $2153848f433e7d96$var$FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'audio[controls]',
    'video[controls]'
].join(', ');
const $2153848f433e7d96$export$85d112ac7df5c04f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelFocusLock(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const doc = (0, $1hQ0e.getDocument)();
            $2153848f433e7d96$var$pendingPreviouslyFocused = null;
            const activeElement = doc?.activeElement ?? null;
            const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
            const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
            const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
            const handoffIsAttached = !!$2153848f433e7d96$var$pendingPreviouslyFocused && !!doc?.body?.contains($2153848f433e7d96$var$pendingPreviouslyFocused);
            previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? $2153848f433e7d96$var$pendingPreviouslyFocused : activeElement;
            $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount + 1;
            return ()=>{
                $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount - 1;
                $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current;
                const toFocus = previouslyFocusedRef.current;
                setTimeout(()=>{
                    setTimeout(()=>{
                        if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                        toFocus?.focus();
                    }, 0);
                }, 0);
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[2] !== isFocusLockEnabled) {
        t4 = ()=>{
            if (isFocusLockEnabled) return;
            const container = containerRef.current;
            if (!container) return;
            const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
            if (firstFocusable) firstFocusable.focus({
                preventScroll: true
            });
        };
        t5 = [
            isFocusLockEnabled
        ];
        $[2] = isFocusLockEnabled;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (isFocusLockEnabled) {
        let t6;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                style: $2153848f433e7d96$var$contentsStyle
            };
            $[5] = t6;
        } else t6 = $[5];
        let t7;
        if ($[6] !== children) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
                autoFocus: true,
                returnFocus: false,
                lockProps: t6
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: containerRef,
                style: $2153848f433e7d96$var$contentsStyle
            }, children));
            $[6] = children;
            $[7] = t7;
        } else t7 = $[7];
        return t7;
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]);
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== children || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            className: t6
        }, children);
        $[9] = children;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : function PanelFocusLock({ children: children, isFocusLockEnabled: isFocusLockEnabled = false }) {
    const containerRef = (0, $cozmU.useRef)(null); // Capture the element that was focused before the panel opened so we can
    // restore focus to it when the panel closes — regardless of which close
    // path is taken (X button, footer Close, programmatic close, etc.).
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Determine the element focus should return to when this panel closes.
        //
        // Default: use the element that was focused at the moment we mount —
        // this is the natural "page trigger" the user just clicked.
        //
        // Edge case (handoff): when one panel unmounts and is immediately
        // replaced by another because a button INSIDE the previous panel
        // triggered the swap (e.g. Sidebar A's footer "Add spaces" button
        // opens Sidebar B), focus has nowhere to go: the trigger button just
        // unmounted with the previous panel, so `document.activeElement`
        // falls back to `body`. In that specific case we adopt the previous
        // panel's snapshot via the module-level handoff slot — it's typically
        // the original page-level trigger that opened the chain.
        //
        // Edge case (StrictMode): in development, React double-invokes
        // effects (setup → cleanup → setup). The second setup runs AFTER
        // Effect 2 below has already moved focus to our own first focusable,
        // so `document.activeElement` is inside our own container — but the
        // DOM was never actually unmounted, so the focused element is still
        // attached. We treat this case the same as body: the user never
        // "came from" our own input, so we should fall back to the handoff
        // (which was just set by Pass 1's cleanup). Without this guard,
        // `previouslyFocused` would be set to our own first focusable, and
        // on close `focus()` would target an element that is by then detached.
        //
        // Always clear the handoff slot regardless of whether we used it, so
        // a stale value can't leak forward into an unrelated future mount.
        const doc = (0, $1hQ0e.getDocument)();
        const handoff = $2153848f433e7d96$var$pendingPreviouslyFocused;
        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
        const activeElement = doc?.activeElement ?? null;
        const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
        const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
        const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
        const handoffIsAttached = !!handoff && !!doc?.body?.contains(handoff);
        previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? handoff : activeElement;
        $2153848f433e7d96$var$panelFocusLockMountCount += 1;
        return ()=>{
            $2153848f433e7d96$var$panelFocusLockMountCount -= 1; // Hand our snapshot off in case a replacement instance is about to
            // mount in the same commit — it will consume this and use it as its
            // own return-focus target, preserving the original trigger across the
            // swap. The slot is cleared either by the next mount or by the
            // deferred restore below if no replacement appears.
            $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current; // Capture the target locally so it survives even if something else
            // mutates the ref between now and when the deferred callback fires.
            const toFocus = previouslyFocusedRef.current; // Restore focus on unmount (panel close). Two chained `setTimeout(0)`
            // ensure this fires after react-focus-lock's own deactivation logic
            // when the lock is active, and after React has finished applying any
            // commit that mounted a replacement panel.
            //
            // We use setTimeout rather than requestAnimationFrame here because
            // the latter is unreliable under jsdom + the React 18 concurrent
            // scheduler in unit tests: rAF callbacks scheduled inside a passive
            // effect cleanup don't always flush even when `jest.runAllTimers`
            // is called inside an `act` block (the scheduler uses MessageChannel,
            // which fake timers don't drive). setTimeout(0) flushes reliably with
            // both fake and real timers.
            setTimeout(()=>{
                setTimeout(()=>{
                    // Skip restore if another PanelFocusLock instance has mounted in
                    // the meantime — e.g. a sidebar swap where the consumer unmounts
                    // the current panel and mounts a replacement. The new instance's
                    // autofocus already moved focus into the replacement; restoring
                    // here would yank focus back to this panel's previously-focused
                    // element (typically the original page trigger) and visibly steal
                    // focus away from the replacement panel.
                    if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                     // We're the last one out — clear the handoff so a future,
                    // unrelated panel open doesn't inherit a stale snapshot.
                    $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                    toFocus?.focus();
                }, 0);
            }, 0);
        };
    }, []);
    // When the lock is NOT enabled, handle auto-focus ourselves — do NOT use
    // react-focus-lock even in disabled mode as it causes layout recalculations
    // that causes animation jank when the panel is inside a CSS transform animation
    // (e.g. SlideIn from @atlaskit/motion).
    (0, $cozmU.useEffect)(()=>{
        if (isFocusLockEnabled) return;
        const container = containerRef.current;
        if (!container) return;
         // Focus synchronously in useEffect (post-paint) with preventScroll to avoid
        // the browser calling scrollIntoView on a mid-animation element.
        const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({
            preventScroll: true
        });
    }, [
        isFocusLockEnabled
    ]); // When the lock IS enabled, use react-focus-lock for both autoFocus and the trap.
    if (isFocusLockEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
        autoFocus: true,
        returnFocus: false,
        lockProps: {
            style: $2153848f433e7d96$var$contentsStyle
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        style: $2153848f433e7d96$var$contentsStyle
    }, children));
     // Default (no lock): plain wrapper div, auto-focus handled by useEffect above.
    // We deliberately avoid react-focus-lock here to prevent animation jank.
    // height: 100% ensures PanelContainer's own height: 100% resolves correctly.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_0jFU0VN91d"
        ])
    }, children);
};
module.exports["PanelFocusLock"] = $2153848f433e7d96$export$85d112ac7df5c04f;

});

parcelRegister("kMhHg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $aio9r = parcelRequire("aio9r");


var $2Emkv = parcelRequire("2Emkv");

const $f9d4da2be7611286$var$panelSystemStyles = {
    fillParent: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $f9d4da2be7611286$export$cda5e69749e7aeee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles } = t0;
    const bodyRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== analyticsAttributes || $[1] !== analyticsClient || $[2] !== panelType || $[3] !== parentProduct) {
        t1 = ()=>{
            if (analyticsClient) {
                analyticsClient.sendTrackEvent({
                    action: "viewed",
                    actionSubject: "preview-panel",
                    actionSubjectId: "preview-panel-view",
                    source: "preview-panel",
                    attributes: {
                        parentProduct: parentProduct,
                        panelType: panelType,
                        ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $iDrrr.fg)("add-trigger-point-key-attribute-to-preview-panel") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                            fireExperimentExposure: false
                        }) ? analyticsAttributes : {}
                    }
                });
                analyticsClient?.startUIViewedEvent();
            }
        };
        t2 = [
            analyticsClient,
            parentProduct,
            panelType,
            analyticsAttributes
        ];
        $[0] = analyticsAttributes;
        $[1] = analyticsClient;
        $[2] = panelType;
        $[3] = parentProduct;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== consumerStyles) {
        t3 = (0, $iDrrr.fg)("ads-panel-system-gpp") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children);
        $[6] = children;
        $[7] = consumerStyles;
        $[8] = t3;
    } else t3 = $[8];
    const panelBodyContent = t3;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t4;
        if ($[9] !== panelBodyContent) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
                spacing: "none"
            }, panelBodyContent);
            $[9] = panelBodyContent;
            $[10] = t4;
        } else t4 = $[10];
        const wrappedBody = t4;
        let t5;
        if ($[11] !== analyticsAttributes || $[12] !== analyticsClient || $[13] !== panelType || $[14] !== parentProduct || $[15] !== wrappedBody) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
                containerRef: bodyRef,
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsAttributes: analyticsAttributes
            }, wrappedBody);
            $[11] = analyticsAttributes;
            $[12] = analyticsClient;
            $[13] = panelType;
            $[14] = parentProduct;
            $[15] = wrappedBody;
            $[16] = t5;
        } else t5 = $[16];
        return t5;
    }
    let t4;
    if ($[17] !== analyticsAttributes || $[18] !== analyticsClient || $[19] !== panelBodyContent || $[20] !== panelType || $[21] !== parentProduct) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, panelBodyContent);
        $[17] = analyticsAttributes;
        $[18] = analyticsClient;
        $[19] = panelBodyContent;
        $[20] = panelType;
        $[21] = parentProduct;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
} : ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    // Availability check only — this decides whether to decorate the preview-panel
                    // "viewed" track event with analyticsAttributes, NOT whether the user is
                    // accessing the Capacity planning experience. We therefore read the GA
                    // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
                    // exposure is fired at the point the user actually opens the Capacity
                    // experience, keeping the GA experiment's population clean.
                    //
                    // The OR (now 3-way) still short-circuits: when either the legacy EAP gate or
                    // the `add-trigger-point-key-attribute-to-preview-panel` gate is ON, the GA
                    // experiment is never read at all. EAP customers remain unconditionally enabled.
                    ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $iDrrr.fg)('add-trigger-point-key-attribute-to-preview-panel') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $iDrrr.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children); /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
            spacing: "none"
        }, panelBodyContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, wrappedBody);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes
    }, panelBodyContent);
};
module.exports["PreviewPanelBody"] = $f9d4da2be7611286$export$cda5e69749e7aeee;

});

parcelRegister("aio9r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $d35068f09c7abc33$var$styles = {
    body: "_2O5Vij7dHp _3zvHkHdC7N _1mT5xdRAKS",
    defaultSpacing: "_4c065UPgdg _0LQT5ENHnM _03SyCPNHnM"
}; /**
    * The PanelBody component provides the main content area for panels
    * with consistent styling and scroll behavior.
    */ 
const $d35068f09c7abc33$export$3ac6fba5a6f84a87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelBody(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "default" : t1;
    const t2 = spacing === "default" && $d35068f09c7abc33$var$styles.defaultSpacing;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== children || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: testId,
            xcss: t3
        }, children);
        $[2] = children;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function PanelBody({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, spacing === 'default' && $d35068f09c7abc33$var$styles.defaultSpacing)
    }, children);
};
module.exports["PanelBody"] = $d35068f09c7abc33$export$3ac6fba5a6f84a87;

});

parcelRegister("2Emkv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $75ef0261b167901c$export$93a96f69a5c679de = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes } = t0;
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== containerRef) {
        t1 = (event, contentSizePayload)=>{
            if (contentSizePayload.type !== "contentSize" || typeof contentSizePayload.width !== "number" || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== "number" || contentSizePayload.height <= 0) return false;
            const panelIframe = containerRef.current?.querySelector("iframe");
            const panelIframeWindow = panelIframe?.contentWindow;
            if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
            if (event.origin && event.origin !== "null" && panelIframe?.src) try {
                const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
                if (event.origin !== iframeOrigin) return false;
            } catch  {
                return false;
            }
            return true;
        };
        $[0] = containerRef;
        $[1] = t1;
    } else t1 = $[1];
    const isValidContentSizeMessage = t1;
    let t2;
    if ($[2] !== analyticsAttributes || $[3] !== analyticsClient || $[4] !== panelType || $[5] !== parentProduct) {
        t2 = (t3)=>{
            const { clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth } = t3;
            if (!analyticsClient || hasSentOverflowEventRef.current) return;
            hasSentOverflowEventRef.current = true;
            const overflowPx = typeof clientWidth === "number" && typeof scrollWidth === "number" ? Math.max(scrollWidth - clientWidth, 0) : undefined;
            analyticsClient.sendOperationalEvent({
                action: "detected",
                actionSubject: "layoutOverflow",
                actionSubjectId: "preview-panel-horizontal-overflow",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    detectionMethod: detectionMethod,
                    clientWidth: clientWidth,
                    scrollWidth: scrollWidth,
                    overflowPx: overflowPx,
                    ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
        };
        $[2] = analyticsAttributes;
        $[3] = analyticsClient;
        $[4] = panelType;
        $[5] = parentProduct;
        $[6] = t2;
    } else t2 = $[6];
    const sendOverflowEvent = t2;
    let t3;
    let t4;
    if ($[7] !== containerRef || $[8] !== sendOverflowEvent) {
        t3 = ()=>{
            const bodyElement = containerRef.current;
            if (!bodyElement || typeof ResizeObserver === "undefined") return;
            const detectBodyOverflow = ()=>{
                const clientWidth_0 = bodyElement.clientWidth;
                const scrollWidth_0 = bodyElement.scrollWidth;
                if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                    detectionMethod: "body-observer",
                    clientWidth: clientWidth_0,
                    scrollWidth: scrollWidth_0
                });
            };
            detectBodyOverflow();
            const observer = new ResizeObserver(detectBodyOverflow);
            observer.observe(bodyElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            containerRef,
            sendOverflowEvent
        ];
        $[7] = containerRef;
        $[8] = sendOverflowEvent;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== containerRef || $[12] !== isValidContentSizeMessage || $[13] !== sendOverflowEvent) {
        t5 = ()=>{
            const handleMessage = (event_0)=>{
                const contentSizePayload_0 = event_0.data;
                if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
                const panelIframe_0 = containerRef.current?.querySelector("iframe");
                const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
                const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
                if (typeof clientWidth_1 !== "number" || contentSizePayload_0.width <= clientWidth_1) return;
                sendOverflowEvent({
                    detectionMethod: "iframe-content-size-message",
                    clientWidth: clientWidth_1,
                    scrollWidth: contentSizePayload_0.width
                });
            };
            return (0, $cbY7C.bind)(window, {
                type: "message",
                listener: handleMessage
            });
        };
        t6 = [
            containerRef,
            isValidContentSizeMessage,
            sendOverflowEvent
        ];
        $[11] = containerRef;
        $[12] = isValidContentSizeMessage;
        $[13] = sendOverflowEvent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[16] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[16] = children;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    const isValidContentSizeMessage = (0, $cozmU.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $cozmU.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                // Availability check only — this decides whether to decorate the overflow
                // operational event with analyticsAttributes, NOT whether the user is
                // accessing the Capacity planning experience. We therefore read the GA
                // experiment WITHOUT firing a Statsig exposure
                // (fireExperimentExposure: false); exposure is fired at the point the user
                // actually opens the Capacity experience, keeping the GA experiment's
                // population clean.
                //
                // The OR still short-circuits: when the legacy EAP gate is ON the experiment
                // is never read at all. EAP customers remain unconditionally enabled.
                ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth_0 = bodyElement.clientWidth;
            const scrollWidth_0 = bodyElement.scrollWidth;
            if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth_0,
                scrollWidth: scrollWidth_0
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event_0)=>{
            const contentSizePayload_0 = event_0.data;
            if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
            const panelIframe_0 = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
            const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth_1 !== 'number' || contentSizePayload_0.width <= clientWidth_1) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth_1,
                scrollWidth: contentSizePayload_0.width
            });
        };
        return (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PreviewPanelSniffer"] = $75ef0261b167901c$export$93a96f69a5c679de;

});

parcelRegister("fE1YT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $kdlgT = parcelRequire("kdlgT");


var $l3wuH = parcelRequire("l3wuH");


var $V3JOP = parcelRequire("V3JOP");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $7ZpVx = parcelRequire("7ZpVx");

var $i68yG = parcelRequire("i68yG");

var $7ZxlY = parcelRequire("7ZxlY");

var $1jpZo = parcelRequire("1jpZo");


var $Emr0i = parcelRequire("Emr0i");


var $7Yky3 = parcelRequire("7Yky3");

const $30b8761d1cee2886$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $30b8761d1cee2886$var$styles = {
    header: "_3vBAKH9r67 _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _2yjt2x6wH8 _4auqkJNvrM _0jFU0VmdCj",
    childWrapper: "_2O5Vij7dHp",
    titleRegion: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3 _2O5Vij7dHp _4ouGXIdnbC"
};
const $30b8761d1cee2886$export$426d4171de44bac0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("platform_preview_panels_cross_app_interaction");
        $[0] = t1;
    } else t1 = $[0];
    const enableCrossMAUUsage = t1;
    const t2 = parentProduct ?? "unknown";
    let t3;
    if ($[1] !== t2) {
        t3 = {
            bridge: "preview-panels",
            product: t2
        };
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)(t3);
    let t4;
    if ($[3] !== analyticsClient || $[4] !== onClose || $[5] !== panelType || $[6] !== parentProduct) {
        t4 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-close",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onClose?.();
        };
        $[3] = analyticsClient;
        $[4] = onClose;
        $[5] = panelType;
        $[6] = parentProduct;
        $[7] = t4;
    } else t4 = $[7];
    const onPanelClose = t4;
    let t5;
    if ($[8] !== analyticsClient || $[9] !== buildUrlWithAnalyticsParams || $[10] !== onOpenInNewTab || $[11] !== panelType || $[12] !== parentProduct || $[13] !== url) {
        t5 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "preview-panel-open-in-new-window",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onOpenInNewTab?.();
            if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels")) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels"));
        };
        $[8] = analyticsClient;
        $[9] = buildUrlWithAnalyticsParams;
        $[10] = onOpenInNewTab;
        $[11] = panelType;
        $[12] = parentProduct;
        $[13] = url;
        $[14] = t5;
    } else t5 = $[14];
    const onOpenInNewWindow = t5;
    let t6;
    if ($[15] !== analyticsClient || $[16] !== onNavigateBack || $[17] !== panelType || $[18] !== parentProduct) {
        t6 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-navigate-back",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onNavigateBack?.();
        };
        $[15] = analyticsClient;
        $[16] = onNavigateBack;
        $[17] = panelType;
        $[18] = parentProduct;
        $[19] = t6;
    } else t6 = $[19];
    const onPanelNavigateBack = t6;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t7;
        if ($[20] !== formatMessage || $[21] !== onNavigateBack || $[22] !== onPanelNavigateBack || $[23] !== testId) {
            t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`,
                appearance: "default"
            });
            $[20] = formatMessage;
            $[21] = onNavigateBack;
            $[22] = onPanelNavigateBack;
            $[23] = testId;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== children) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $30b8761d1cee2886$var$styles.titleRegion
            }, children);
            $[25] = children;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== formatMessage || $[28] !== onOpenInNewWindow || $[29] !== testId || $[30] !== url) {
            t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
                onClick: onOpenInNewWindow,
                testId: testId && `${testId}.open-in-new-window-button`,
                appearance: "subtle"
            });
            $[27] = formatMessage;
            $[28] = onOpenInNewWindow;
            $[29] = testId;
            $[30] = url;
            $[31] = t9;
        } else t9 = $[31];
        let t10;
        if ($[32] !== formatMessage || $[33] !== onClose || $[34] !== onPanelClose || $[35] !== testId) {
            t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
                onClick: onPanelClose,
                testId: testId && `${testId}.close-button`,
                label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
            });
            $[32] = formatMessage;
            $[33] = onClose;
            $[34] = onPanelClose;
            $[35] = testId;
            $[36] = t10;
        } else t10 = $[36];
        let t11;
        if ($[37] !== moreActions || $[38] !== t10 || $[39] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, t9, moreActions, t10);
            $[37] = moreActions;
            $[38] = t10;
            $[39] = t9;
            $[40] = t11;
        } else t11 = $[40];
        let t12;
        if ($[41] !== t11 || $[42] !== t7 || $[43] !== t8 || $[44] !== testId) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
                testId: testId
            }, t7, t8, t11);
            $[41] = t11;
            $[42] = t7;
            $[43] = t8;
            $[44] = testId;
            $[45] = t12;
        } else t12 = $[45];
        return t12;
    }
    let t7;
    if ($[46] !== formatMessage || $[47] !== onNavigateBack || $[48] !== onPanelNavigateBack || $[49] !== testId) {
        t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp,
            label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
            onClick: onPanelNavigateBack,
            testId: testId && `${testId}.navigate-back-button`
        });
        $[46] = formatMessage;
        $[47] = onNavigateBack;
        $[48] = onPanelNavigateBack;
        $[49] = testId;
        $[50] = t7;
    } else t7 = $[50];
    let t8;
    if ($[51] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.childWrapper,
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, children);
        $[51] = children;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== formatMessage || $[54] !== onOpenInNewWindow || $[55] !== testId || $[56] !== url) {
        t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
            label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
            onClick: onOpenInNewWindow,
            testId: testId && `${testId}.open-in-new-window-button`
        });
        $[53] = formatMessage;
        $[54] = onOpenInNewWindow;
        $[55] = testId;
        $[56] = url;
        $[57] = t9;
    } else t9 = $[57];
    let t10;
    if ($[58] !== formatMessage || $[59] !== onClose || $[60] !== onPanelClose || $[61] !== testId) {
        t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp2,
            label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
            onClick: onPanelClose,
            testId: testId && `${testId}.close-button`,
            role: "button"
        });
        $[58] = formatMessage;
        $[59] = onClose;
        $[60] = onPanelClose;
        $[61] = testId;
        $[62] = t10;
    } else t10 = $[62];
    let t11;
    if ($[63] !== moreActions || $[64] !== t10 || $[65] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100"
        }, t9, moreActions, t10);
        $[63] = moreActions;
        $[64] = t10;
        $[65] = t9;
        $[66] = t11;
    } else t11 = $[66];
    let t12;
    if ($[67] !== t11 || $[68] !== t7 || $[69] !== t8 || $[70] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.header,
            testId: testId,
            alignBlock: "center",
            space: "space.100"
        }, t7, t8, t11);
        $[67] = t11;
        $[68] = t7;
        $[69] = t8;
        $[70] = testId;
        $[71] = t12;
    } else t12 = $[71];
    return t12;
} : ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const enableCrossMAUUsage = (0, $iDrrr.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    const onPanelNavigateBack = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-navigate-back',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onNavigateBack?.();
    };
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
        testId: testId
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`,
        appearance: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $30b8761d1cee2886$var$styles.titleRegion
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`,
        appearance: "subtle"
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100"
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.childWrapper,
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        role: "button"
    })));
};
function $30b8761d1cee2886$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        ...iconProps,
        size: "small"
    });
}
function $30b8761d1cee2886$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        size: "small"
    });
}
module.exports["PreviewPanelHeader"] = $30b8761d1cee2886$export$426d4171de44bac0;

});

parcelRegister("7ZpVx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $7vK9E = parcelRequire("7vK9E");

const $2efd2cd3ca9e912b$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, "aria-label": ariaLabel, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded, icon: icon, label: label, appearance: t1, spacing: t2 } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    if (icon) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[0] !== appearance || $[1] !== ariaExpanded || $[2] !== ariaHaspopup || $[3] !== icon || $[4] !== spacing || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== testId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ref: t3,
                onClick: t4,
                testId: testId,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[0] = appearance;
            $[1] = ariaExpanded;
            $[2] = ariaHaspopup;
            $[3] = icon;
            $[4] = spacing;
            $[5] = t3;
            $[6] = t4;
            $[7] = t5;
            $[8] = testId;
            $[9] = t6;
        } else t6 = $[9];
        return t6;
    }
    if (href) {
        const t3 = ref;
        const t4 = onClick;
        let t5;
        if ($[10] !== ariaExpanded || $[11] !== ariaHaspopup || $[12] !== ariaLabel || $[13] !== children || $[14] !== href || $[15] !== rel || $[16] !== t3 || $[17] !== t4 || $[18] !== target || $[19] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                "aria-label": ariaLabel,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded
            }, children);
            $[10] = ariaExpanded;
            $[11] = ariaHaspopup;
            $[12] = ariaLabel;
            $[13] = children;
            $[14] = href;
            $[15] = rel;
            $[16] = t3;
            $[17] = t4;
            $[18] = target;
            $[19] = testId;
            $[20] = t5;
        } else t5 = $[20];
        return t5;
    }
    const t3 = ref;
    const t4 = onClick;
    let t5;
    if ($[21] !== appearance || $[22] !== ariaExpanded || $[23] !== ariaHaspopup || $[24] !== ariaLabel || $[25] !== children || $[26] !== t3 || $[27] !== t4 || $[28] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            ref: t3,
            onClick: t4,
            testId: testId,
            "aria-label": ariaLabel,
            "aria-haspopup": ariaHaspopup,
            "aria-expanded": ariaExpanded,
            appearance: appearance
        }, children);
        $[21] = appearance;
        $[22] = ariaExpanded;
        $[23] = ariaHaspopup;
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = t3;
        $[27] = t4;
        $[28] = testId;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, 'aria-expanded': ariaExpanded, icon: icon, label: label, appearance: appearance = 'subtle', spacing: spacing = 'default' }, ref)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        appearance: appearance
    }, children);
});
module.exports["PanelAction"] = $2efd2cd3ca9e912b$export$2a18e3520151503;

});

parcelRegister("i68yG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l3wuH = parcelRequire("l3wuH");


var $7ZpVx = parcelRequire("7ZpVx");

const $837042f62dde5900$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== onBeforeClose || $[1] !== onClick) {
        t1 = async (event, analyticsEvent)=>{
            if (onBeforeClose) {
                const canClose = await onBeforeClose();
                if (!canClose) return;
            }
            if (onClick) onClick(event, analyticsEvent);
        };
        $[0] = onBeforeClose;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = label || "Close panel";
    let t3;
    if ($[3] !== handleClick || $[4] !== ref || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            onClick: handleClick,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t2,
            spacing: "compact",
            appearance: "subtle"
        });
        $[3] = handleClick;
        $[4] = ref;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || 'Close panel',
        spacing: "compact",
        appearance: "subtle"
    });
});
module.exports["PanelActionClose"] = $837042f62dde5900$export$75d0a5a5f71a1ab1;

});

parcelRegister("7ZxlY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $2d2f9566579f7703$var$styles = {
    group: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
}; /**
    * The PanelActionGroup component provides a container for grouping
    * panel actions together with consistent spacing and layout.
    */ 
const $2d2f9566579f7703$export$9546bd4ca18522f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelActionGroup(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: testId,
            xcss: $2d2f9566579f7703$var$styles.group
        }, children);
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function PanelActionGroup({ children: children, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: $2d2f9566579f7703$var$styles.group
    }, children);
};
module.exports["PanelActionGroup"] = $2d2f9566579f7703$export$9546bd4ca18522f9;

});

parcelRegister("1jpZo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

const $2747dc4177a5f32c$var$styles = {
    header: "_0jFU0V36Ow _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EkG2W _03SyCPkG2W _46hvQm5zaO _0xmtko5zaO",
    headerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d"
}; /**
    * The PanelHeader component provides a standardized header area for panels
    * containing the title, actions, and other header-specific content.
    * It automatically organizes content into left (back button + title) and right (actions) sections
    * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
    */ 
const $2747dc4177a5f32c$export$968713404ca1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelHeader(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "header",
            testId: testId,
            xcss: $2747dc4177a5f32c$var$styles.header
        }, t1);
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function PanelHeader({ children: children, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "header",
        testId: testId,
        xcss: $2747dc4177a5f32c$var$styles.header
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $2747dc4177a5f32c$var$styles.headerContent
    }, children));
};
module.exports["PanelHeader"] = $2747dc4177a5f32c$export$968713404ca1c9aa;

});

parcelRegister("Emr0i", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e1da37ec0a029195$var$_default_1 = (0, $kSwu1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    },
    previewPanelNavigateBackLabel: {
        id: "navigation.preview-panel.preview-panel-header.navigate-back-label",
        defaultMessage: "Go back to previous panel"
    }
});
var $e1da37ec0a029195$export$2e2bcd8739ae039 = $e1da37ec0a029195$var$_default_1;
module.exports["default"] = $e1da37ec0a029195$export$2e2bcd8739ae039;

});

parcelRegister("7Yky3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $Emr0i = parcelRequire("Emr0i");


var $6GBgL = parcelRequire("6GBgL");

const $3d98d316d4b42e83$export$d05dda6f1d91eaad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== analyticsContext || $[4] !== href || $[5] !== onClick || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: t1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext
        });
        $[3] = analyticsContext;
        $[4] = href;
        $[5] = onClick;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
        label: label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $3d98d316d4b42e83$export$d05dda6f1d91eaad;

});

parcelRegister("6GBgL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");

var $7WEaj = parcelRequire("7WEaj");


var $iDrrr = parcelRequire("iDrrr");


var $7ZpVx = parcelRequire("7ZpVx");

const $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function PreviewPanelAction(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    const { icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        if (analyticsContext || href) {
            let t1;
            if ($[0] !== analyticsContext || $[1] !== href || $[2] !== icon || $[3] !== label || $[4] !== onClick || $[5] !== ref || $[6] !== testId) {
                t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    href: href,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    target: "_blank",
                    ref: ref,
                    role: "button"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    ref: ref,
                    role: "button"
                });
                $[0] = analyticsContext;
                $[1] = href;
                $[2] = icon;
                $[3] = label;
                $[4] = onClick;
                $[5] = ref;
                $[6] = testId;
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
        let t1;
        if ($[8] !== icon || $[9] !== label || $[10] !== onClick || $[11] !== ref || $[12] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                ref: ref,
                icon: icon,
                label: label,
                onClick: onClick,
                testId: testId,
                appearance: "subtle"
            });
            $[8] = icon;
            $[9] = label;
            $[10] = onClick;
            $[11] = ref;
            $[12] = testId;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== analyticsContext || $[15] !== href || $[16] !== icon || $[17] !== label || $[18] !== onClick || $[19] !== ref || $[20] !== testId) {
        t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        $[14] = analyticsContext;
        $[15] = href;
        $[16] = icon;
        $[17] = label;
        $[18] = onClick;
        $[19] = ref;
        $[20] = testId;
        $[21] = t1;
    } else t1 = $[21];
    return t1;
} : function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16;

});

parcelRegister("bRCqW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $aMRlV = parcelRequire("aMRlV");

const $33c23c71035fcd90$export$92a58681483f4529 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { title: title, icon: icon, color: color } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== icon || $[1] !== title) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
                icon: icon
            }, title);
            $[0] = icon;
            $[1] = title;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== color || $[4] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            maxLines: 1,
            color: color
        }, title);
        $[3] = color;
        $[4] = title;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== icon || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, icon, t1);
        $[6] = icon;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ title: title, icon: icon, color: color })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
        icon: icon
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        maxLines: 1,
        color: color
    }, title));
};
module.exports["PreviewPanelTitle"] = $33c23c71035fcd90$export$92a58681483f4529;

});

parcelRegister("aMRlV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

const $4105ecb3e4516dff$var$styles = {
    title: "_3iDTPbQ4SZ _0hPCNLDIqT _2O5Vij7dHp",
    titleText: "_0LQT5E1Y8M",
    icon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM"
}; /**
    * The PanelTitle component provides a standardized title display for panels
    * with optional icon support and consistent typography.
    */ 
const $4105ecb3e4516dff$export$86de09faaa70680d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelTitle(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, icon: icon, testId: testId } = t0;
    let t1;
    if ($[0] !== icon) {
        t1 = icon && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $4105ecb3e4516dff$var$styles.icon
        }, icon);
        $[0] = icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, children));
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: testId,
            xcss: $4105ecb3e4516dff$var$styles.title
        }, t1, t3);
        $[5] = t1;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function PanelTitle({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: $4105ecb3e4516dff$var$styles.title
    }, icon && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4105ecb3e4516dff$var$styles.icon
    }, icon), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, children)));
};
module.exports["PanelTitle"] = $4105ecb3e4516dff$export$86de09faaa70680d;

});

parcelRegister("9XT2p", function(module, exports) {
const $469e9e8c40c7cb7a$export$c1ca07766924f82d = 320;
const $469e9e8c40c7cb7a$export$8060d3fdfb20d4e4 = {
    planned: 'planned',
    finished: 'finished',
    cancelled: 'cancelled'
};
const $469e9e8c40c7cb7a$export$84e9f6174996372a = {
    actioned: 'actioned',
    cancel: 'cancel'
};
module.exports["MESSAGE_ACTION_INVOCATION_STATUSES"] = $469e9e8c40c7cb7a$export$8060d3fdfb20d4e4;
module.exports["MESSAGE_ACTION_RESOLUTIONS"] = $469e9e8c40c7cb7a$export$84e9f6174996372a;

});

parcelRegister("7ChxK", function(module, exports) {
const $95e16ccad73800a4$var$ISSUEKEY_REGEX = /^[A-Za-z0-9]+-\d+$/;
const $95e16ccad73800a4$var$BASE_URL_REGEX = /^(https:\/\/[^\/]+)/;
const $95e16ccad73800a4$export$59e194e2109f4ded = (cloudId, issueKey)=>`ari:cloud:jira:${cloudId}:issue/${issueKey}`;
const $95e16ccad73800a4$export$227a8a277ec657e1 = (issueKey)=>{
    return issueKey.match($95e16ccad73800a4$var$ISSUEKEY_REGEX) !== null;
};
const $95e16ccad73800a4$export$d313a575fc0fe8a3 = (fieldId)=>{
    if (!fieldId) return false;
    return !fieldId.startsWith('customfield_');
};
const $95e16ccad73800a4$export$f417eb424f8726d9 = (draftWorkItem)=>{
    if (!draftWorkItem?.fields) return false;
    const hierarchyLevel = draftWorkItem.fields.issuetype?.hierarchyLevel;
    return hierarchyLevel !== undefined && hierarchyLevel < 0;
};
const $95e16ccad73800a4$export$6c5d1ee305fbc45e = (draftWorkItem)=>{
    if (!draftWorkItem?.fields) return false;
    const parent = draftWorkItem.fields?.parent;
    const isSubTaskWithoutParent = $95e16ccad73800a4$export$f417eb424f8726d9(draftWorkItem) && (!parent || !$95e16ccad73800a4$export$227a8a277ec657e1(parent));
    return isSubTaskWithoutParent;
};
const $95e16ccad73800a4$export$5096ffede784b94 = (link)=>{
    return link.match($95e16ccad73800a4$var$BASE_URL_REGEX)?.[0] ?? '';
};
const $95e16ccad73800a4$export$eb2385235602e22c = (error)=>{
    if (!error) return 'unknown';
    if (error.name === 'ChunkLoadError') return 'chunk_load';
    const message = error.message?.toLowerCase() ?? '';
    if (message.includes('network') || message.includes('fetch')) return 'network';
    if (message.includes('timeout')) return 'timeout';
    if (message.includes('permission') || message.includes('forbidden')) return 'permission';
    return 'render_error';
};
module.exports["createWorkItemAri"] = $95e16ccad73800a4$export$59e194e2109f4ded;
module.exports["isValidJiraIssueKey"] = $95e16ccad73800a4$export$227a8a277ec657e1;
module.exports["isSystemField"] = $95e16ccad73800a4$export$d313a575fc0fe8a3;
module.exports["isSubTask"] = $95e16ccad73800a4$export$f417eb424f8726d9;
module.exports["isSubTaskWithoutCreatedParent"] = $95e16ccad73800a4$export$6c5d1ee305fbc45e;
module.exports["extractCloudUrl"] = $95e16ccad73800a4$export$5096ffede784b94;
module.exports["getJiraCreateErrorReason"] = $95e16ccad73800a4$export$eb2385235602e22c;

});

parcelRegister("cC4M6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $1aX82 = parcelRequire("1aX82");

function $0a0887ed220821e3$export$156b5756ed7a09ad({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus, loadingText: loadingText, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aX82.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        onError: onError,
        preloadOnFocus: preloadOnFocus,
        loadingText: loadingText
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            ref: ref,
            ...buttonProps
        }, children));
}
module.exports["ModalButtonTrigger"] = $0a0887ed220821e3$export$156b5756ed7a09ad;

});

parcelRegister("1aX82", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $2VwyL = parcelRequire("2VwyL");


var $dpsRj = parcelRequire("dpsRj");


var $7aRdF = parcelRequire("7aRdF");


var $iDrrr = parcelRequire("iDrrr");


var $ln34A = parcelRequire("ln34A");


var $ghNlj = parcelRequire("ghNlj");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $lBLkF = parcelRequire("lBLkF");


var $1xDc3 = parcelRequire("1xDc3");


var $fweCp = parcelRequire("fweCp");

const $5e4505b4866e7641$var$emptyEntryPointParams = {};
const $5e4505b4866e7641$var$emptyEntryPointProps = {};
function $5e4505b4866e7641$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText }) {
    (0, $6cFsl.di)((0, $6SsN4.loadEntryPoint));
    const { openModal: openModal } = (0, $cozmU.useContext)((0, $lBLkF.ModalContext));
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $ln34A.useEntryPointConfig)();
    const modalRef = (0, $cozmU.useRef)(null);
    const metricName = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $5e4505b4866e7641$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(GlobalModalErrorFallback, {
                        error: error,
                        closeModal: (0, $iDrrr.fg)('platform_dst-a11y_move-close-modal') ? closeModal : (0, $dpsRj.default)
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    if (!(0, $iDrrr.fg)('platform_dst-a11y_move-close-modal')) closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fweCp.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $5e4505b4866e7641$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
                ...modalProps,
                ref: modalRef,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xDc3.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps?.autoFocus,
                modalRef: modalRef
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        GlobalModalErrorFallback,
        onError,
        loadingText
    ]);
    const triggerRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $2VwyL.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
module.exports["ModalTrigger"] = $5e4505b4866e7641$export$fb10b32cfe19f1e;

});

parcelRegister("ghNlj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dIRsp = parcelRequire("dIRsp");

function $34284f28bf40f8ea$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $dIRsp.useEntryPointPreload)(load);
    const clickListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $34284f28bf40f8ea$export$1ff47f24e06a5d2d;

});

parcelRegister("dIRsp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $d4f85bcbe97d7b23$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $d4f85bcbe97d7b23$var$TIME_TO_INTENT = 200;
function $d4f85bcbe97d7b23$export$57effc2a5e3611f(load) {
    const actions = (0, $cozmU.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $iDrrr.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            if ((0, $iDrrr.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) request.preload?.dispose();
        };
        const cleanupPreload = ()=>{
            request.preload?.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $iDrrr.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $d4f85bcbe97d7b23$var$PRELOAD_MAX_AGE);
            }, $d4f85bcbe97d7b23$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if ((0, $iDrrr.fg)('platform_relay_persist_entrypoint_preloaded_data')) actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}
module.exports["useEntryPointPreload"] = $d4f85bcbe97d7b23$export$57effc2a5e3611f;

});

parcelRegister("1xDc3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $dpsRj = parcelRequire("dpsRj");


var $3hJ5V = parcelRequire("3hJ5V");

const $71f3689a65ae7009$var$FocusInsideOnLoadInner = ({ autoFocusRef: autoFocusRef, entryPointReference: entryPointReference, modalRef: modalRef })=>{
    // Suspends until the entry point's module has finished loading. The result
    // is intentionally unused — this call exists purely to gate the mount of
    // this component on the load completing.
    entryPointReference.getComponent();
    (0, $cozmU.useEffect)(()=>{
        // Fence for if container element doesn't exist, but this is effectively not
        // possible.
        if (!modalRef.current) return;
        // If ref provided, use that first. Else find first focusable element or
        // container if not exists
        if (autoFocusRef?.current) {
            autoFocusRef.current.focus();
            return;
        }
        const firstFocusable = (0, $3hJ5V.getFirstFocusable)({
            container: modalRef.current
        });
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }
        modalRef.current.focus();
    }, [
        autoFocusRef,
        modalRef
    ]);
    return null;
};
const $71f3689a65ae7009$var$renderNothing = ()=>null;
const $71f3689a65ae7009$export$eb58c1f6b41ee511 = ({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: $71f3689a65ae7009$var$renderNothing,
        onError: (0, $dpsRj.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71f3689a65ae7009$var$FocusInsideOnLoadInner, {
        entryPointReference: entryPointReference,
        autoFocusRef: autoFocusRef,
        modalRef: modalRef
    })));
module.exports["FocusInsideOnLoad"] = $71f3689a65ae7009$export$eb58c1f6b41ee511;

});

parcelRegister("fweCp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");


var $2XUAV = parcelRequire("2XUAV");

const $a403242a80e54023$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XUAV.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null));
module.exports["Loading"] = $a403242a80e54023$export$669f6ea7d267feaf;

});

parcelRegister("2XUAV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");

const $959798a9a32c7c0a$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, loadingText));
};
module.exports["LoadingContent"] = $959798a9a32c7c0a$export$4ab3512e4872e6ff;

});

parcelRegister("kEZoA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $6yxNO = parcelRequire("6yxNO");

const $613f3af20b5ad9cc$export$99042cce45c07881 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    let ariaLabel;
    let buttonContent;
    let getDraftWorkItems;
    let onClick;
    let props;
    let t1;
    let t2;
    let testId;
    if ($[0] !== t0) {
        ({ getDraftWorkItems: getDraftWorkItems, buttonContent: buttonContent, testId: testId, isDisabled: t1, onClick: onClick, appearance: t2, ariaLabel: ariaLabel, ...props } = t0);
        $[0] = t0;
        $[1] = ariaLabel;
        $[2] = buttonContent;
        $[3] = getDraftWorkItems;
        $[4] = onClick;
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = testId;
    } else {
        ariaLabel = $[1];
        buttonContent = $[2];
        getDraftWorkItems = $[3];
        onClick = $[4];
        props = $[5];
        t1 = $[6];
        t2 = $[7];
        testId = $[8];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const appearance = t2 === undefined ? "default" : t2;
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const onCreateDraftWorkItems = (0, $6yxNO.useCreateDraftWorkItems)(props);
    let t3;
    if ($[9] !== getDraftWorkItems || $[10] !== onClick || $[11] !== onCreateDraftWorkItems) {
        t3 = async ()=>{
            onClick?.();
            setIsLoading(true);
            const draftWorkItems = await getDraftWorkItems();
            await onCreateDraftWorkItems({
                draftWorkItems: draftWorkItems
            });
            setIsLoading(false);
        };
        $[9] = getDraftWorkItems;
        $[10] = onClick;
        $[11] = onCreateDraftWorkItems;
        $[12] = t3;
    } else t3 = $[12];
    const handleOnClick = t3;
    let t4;
    if ($[13] !== appearance || $[14] !== ariaLabel || $[15] !== buttonContent || $[16] !== handleOnClick || $[17] !== isDisabled || $[18] !== isLoading || $[19] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleOnClick,
            isLoading: isLoading,
            isDisabled: isDisabled,
            testId: testId,
            appearance: appearance,
            "aria-label": ariaLabel
        }, buttonContent);
        $[13] = appearance;
        $[14] = ariaLabel;
        $[15] = buttonContent;
        $[16] = handleOnClick;
        $[17] = isDisabled;
        $[18] = isLoading;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ getDraftWorkItems: getDraftWorkItems, buttonContent: buttonContent, testId: testId, isDisabled: isDisabled = false, onClick: onClick, appearance: appearance = 'default', ariaLabel: ariaLabel, ...props })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const onCreateDraftWorkItems = (0, $6yxNO.useCreateDraftWorkItems)(props);
    const handleOnClick = (0, $cozmU.useCallback)(async ()=>{
        onClick?.();
        setIsLoading(true);
        const draftWorkItems = await getDraftWorkItems();
        await onCreateDraftWorkItems({
            draftWorkItems: draftWorkItems
        });
        setIsLoading(false);
    }, [
        getDraftWorkItems,
        onCreateDraftWorkItems,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleOnClick,
        isLoading: isLoading,
        isDisabled: isDisabled,
        testId: testId,
        appearance: appearance,
        "aria-label": ariaLabel
    }, buttonContent);
};
module.exports["CreateWorkItemsButton"] = $613f3af20b5ad9cc$export$99042cce45c07881;

});

parcelRegister("bzfOg", function(module, exports) {

let $86bf3a1272d714de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $86bf3a1272d714de$var$load("8TRae"),
    $86bf3a1272d714de$var$load("aMUi4"),
    $86bf3a1272d714de$var$load("lQDwI")
]).then(()=>parcelRequire('bYQTC'));

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::578fbc9c8694ec05cdde124c4145b9df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_baseNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("jNOAq", function(module, exports) {
/**
 * @generated SignedSource<<5fdd9a262af74c6a4bcad3e93574da77>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19ee1b73ae6c94b7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraCascadingSelectField_Platform",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            },
            {
                "concreteType": "JiraCascadingOptionsConnection",
                "kind": "LinkedField",
                "name": "cascadingOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCascadingOptionsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCascadingOptions",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "parentOptionValue",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "childOptionValues",
                                        "plural": true,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$19ee1b73ae6c94b7$var$node.hash = "9cb0c614cdcec0cf84156c6af9d58dc3";
var $19ee1b73ae6c94b7$export$2e2bcd8739ae039 = $19ee1b73ae6c94b7$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $1hQ0e = parcelRequire("1hQ0e");


var $1JERl = parcelRequire("1JERl");


var $akErP = parcelRequire("akErP");

var $lQV5m = parcelRequire("lQV5m");

var $kN1yU = parcelRequire("kN1yU");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $8wMiv = parcelRequire("8wMiv");


var $hcOES = parcelRequire("hcOES");


var $gVzkK = parcelRequire("gVzkK");


var $2v5cF = parcelRequire("2v5cF");

const $151e7bc06906d0e3$var$selectLabel = (0, $kSwu1.defineMessage)({
    id: "jira.jira.jira-platform-fields.cascading-select-field.label",
    defaultMessage: "Select {fieldName}"
});
const $151e7bc06906d0e3$var$noOptionMessage = (0, $kSwu1.defineMessage)({
    id: "jira.jira.jira-platform-fields.cascading-select-field.no-options",
    defaultMessage: "None"
});
const $151e7bc06906d0e3$var$noParentOptionMessage = (0, $kSwu1.defineMessage)({
    id: "jira.jira.jira-platform-fields.cascading-select-field.no-parent-option",
    defaultMessage: "Parent option is required when child option is selected"
});
const $151e7bc06906d0e3$var$isCascadingSelectValue = (value)=>{
    if (value === null) return true;
    return typeof value === 'object' && value !== null && 'id' in value && typeof value.id === 'string';
};
const $151e7bc06906d0e3$var$isCascadingSelectChildValue = (value)=>{
    if (value === null) return true;
    return typeof value === 'object' && value !== null && 'id' in value && typeof value.id === 'string';
};
const $151e7bc06906d0e3$var$styles = {
    readViewContainer: "_0jFU0VUF4f _0hPCNLDIqT _3iDTPbQ4SZ _1Znuxb2ADO _2Zuz6Q2ADO _39xV02N91d _24h04i2Njc",
    popperContainer: "_42Yu6BFIQA _3138424F84",
    editableReadViewContainer: "_39xV02N91d _0wOv4Q7zJH",
    editViewContainer: "_2mHwu8gVvo _4bt5LAYvD1 _2WAcuGYvD1 _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w",
    control: "_39xV02N91d _24h04i2Njc",
    container: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _4ouGXIdnbC _39xV02N91d",
    valueContainer: "_4ouGXIdnbC",
    childSelector: "_39xV02N91d"
}; /**
    * `JiraCascadingSelectField` is a memoized React component that renders a Jira cascading select field,
    * supporting read-only mode (as of current implementation). It displays the current option and allows
    * users to select from available options if the field is editable. The component uses
    * Relay fragments to fetch option data and renders options with icons and labels.
    *
    * @param field - The Relay fragment reference for the Jira option field.
    * @param fieldValue - The currently suggested option value.
    * @param onChange - Callback invoked when the option selection changes.
    * @returns A JSX element representing the option field, or `null` if no option is found.
    */ 
const $151e7bc06906d0e3$export$9b2ab116fcf0865f = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $6SsN4.useFragment)((0, $19ee1b73ae6c94b7$export$2e2bcd8739ae039), // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isEditable: isEditable, isRequired: isRequired } = data.fieldConfig ?? {};
    const fieldName = data.name;
    const FIELD_TYPE_FOR_ANALYTICS = 'CascadingSelectField';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const validateRequired = (0, $gVzkK.useValidateRequiredField)({
        isRequired: !!isRequired,
        isEditable: !!isEditable,
        fieldName: fieldName,
        fieldTypeForAnalytics: FIELD_TYPE_FOR_ANALYTICS
    }); // Refs and field configuration
    const parentRef = (0, $cozmU.useRef)(null);
    const childRef = (0, $cozmU.useRef)(null); // Menu states for controlling display of parent and child dropdowns
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false); // Get parent options from graphql fragment
    const parentOptions = (0, $cozmU.useMemo)(()=>{
        return data.cascadingOptions?.edges?.filter(Boolean).map((edge)=>({
                id: String(edge?.node?.parentOptionValue?.optionId ?? ''),
                value: String(edge?.node?.parentOptionValue?.value ?? '')
            })) ?? [];
    }, [
        data.cascadingOptions?.edges
    ]); // Use currently selected parent option or the first parent option if no option is selected
    const initialParentOption = (0, $cozmU.useMemo)(()=>{
        if ($151e7bc06906d0e3$var$isCascadingSelectValue(fieldValue) && fieldValue !== null) {
            const fieldParentOption = parentOptions.find((option)=>option.id === fieldValue.id) || null;
            if (fieldParentOption) return fieldParentOption;
        } // Return null if field is not required
        if (!isRequired) return null;
         // If no parent is fetched for a required field, set the first parent option as the selected option
        const firstParentOption = parentOptions[0];
        onChange?.({
            id: firstParentOption?.id ?? null,
            child: null
        });
        return firstParentOption;
    }, [
        onChange,
        fieldValue,
        isRequired,
        parentOptions
    ]); // States for controlling parent dropdown and selections
    const [selectedParentOption, setSelectedParentOption] = (0, $cozmU.useState)(initialParentOption); // Get child options from graphql fragment based on selected parent option
    const childOptions = (0, $cozmU.useMemo)(()=>{
        if (!selectedParentOption?.value) return [];
        const parentEdge = data?.cascadingOptions?.edges?.find((edge)=>edge?.node?.parentOptionValue?.value === selectedParentOption?.value);
        return parentEdge?.node?.childOptionValues?.map((childOption)=>({
                id: String(childOption?.optionId ?? ''),
                value: String(childOption?.value ?? '')
            })) ?? [];
    }, [
        selectedParentOption,
        data?.cascadingOptions?.edges
    ]); // Use currently selected child option or the first child option if no option is selected
    const initialChildOption = (0, $cozmU.useMemo)(()=>{
        if ($151e7bc06906d0e3$var$isCascadingSelectValue(fieldValue) && fieldValue !== null) {
            const child = fieldValue.child;
            if ($151e7bc06906d0e3$var$isCascadingSelectChildValue(child) && child !== null) {
                const fieldChildOption = childOptions.find((option)=>option.id === child.id) || null;
                if (fieldChildOption) return fieldChildOption;
            }
        }
        if (!isRequired || !childOptions.length) return null;
         // If no child is fetched for a required field, set the first child option as the selected option
        const firstChildOption = childOptions[0];
        onChange?.({
            id: selectedParentOption?.id ?? null,
            child: firstChildOption?.id ? {
                id: firstChildOption.id
            } : null
        });
        return firstChildOption;
    }, [
        onChange,
        fieldValue,
        isRequired,
        childOptions,
        selectedParentOption?.id
    ]);
    const [selectedChildOption, setSelectedChildOption] = (0, $cozmU.useState)(initialChildOption); // Hide child selector when no child options are available
    const showChildSelector = (0, $cozmU.useMemo)(()=>selectedParentOption?.value && (selectedChildOption?.value || childOptions.length > 0), [
        childOptions.length,
        selectedChildOption?.value,
        selectedParentOption?.value
    ]);
    const originalParentOption = (0, $cozmU.useRef)(null);
    const originalChildOption = (0, $cozmU.useRef)(null);
    const currentValue = (0, $cozmU.useMemo)(()=>{
        if (!selectedParentOption?.value) return '';
        if (selectedChildOption?.value) return `${selectedParentOption.value} - ${selectedChildOption.value}`;
        return selectedParentOption.value;
    }, [
        selectedParentOption?.value,
        selectedChildOption?.value
    ]);
    const selectComponentProps = {
        appearance: 'default',
        getOptionValue: (option)=>option.value,
        getOptionLabel: (option)=>option.value,
        tabSelectsValue: true,
        blurInputOnSelect: false,
        closeMenuOnSelect: true,
        isSearchable: true,
        isRequired: !!isRequired,
        placeholder: formatMessage($151e7bc06906d0e3$var$noOptionMessage),
        isMulti: false,
        menuPortalTarget: (0, $1hQ0e.getDocument)()?.body,
        menuPlacement: 'auto',
        menuPosition: 'fixed',
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $8wMiv.layers).modal()
                })
        }
    }; // Track which menu should be focused/open
    const [currentMenuOpen, setCurrentMenuOpen] = (0, $cozmU.useState)(null);
    const currentMenuIsOpenRef = (0, $cozmU.useRef)(null); // Keep ref in sync with state for synchronous updates
    const updateMenuOpen = (value)=>{
        setCurrentMenuOpen(value);
        currentMenuIsOpenRef.current = value;
    }; // Focus the appropriate dropdown when the menu state changes
    // (focus does not always align with user actions without autoFocus prop, but it does not work with Portal/Popper implementation)
    (0, $cozmU.useEffect)(()=>{
        // Use setTimeout to ensure the Select components have been mounted
        const timeoutId = setTimeout(()=>{
            if (currentMenuIsOpenRef.current === 'parent') parentRef.current?.focus?.();
            else if (currentMenuIsOpenRef.current === 'child') childRef.current?.focus?.();
        }, 0);
        return ()=>clearTimeout(timeoutId);
    }, [
        currentMenuOpen,
        isEditing
    ]);
    const onParentChange = (newValue)=>{
        // Return focus to parent and reset selections upon parent clear
        if (newValue === null) {
            setSelectedParentOption(null);
            setSelectedChildOption(null);
            setTimeout(()=>{
                parentRef.current?.focus();
            }, 0);
            updateMenuOpen('parent');
            return;
        }
        setSelectedParentOption(newValue);
        setSelectedChildOption(null); // Compute child options for the new parent for immediate use
        const newParentEdge = data?.cascadingOptions?.edges?.find((edge)=>edge?.node?.parentOptionValue?.optionId === newValue.id);
        const newChildOptions = newParentEdge?.node?.childOptionValues ?? []; // Only open child menu if there are child options
        if (newChildOptions.length > 0) updateMenuOpen('child');
        else {
            updateMenuOpen(null);
            setTimeout(()=>{
                parentRef.current?.focus();
            }, 0);
        }
    };
    const onChildChange = (newValue)=>{
        setSelectedChildOption(newValue); // Maintain focus on child select after selection (as per list view implementation behaviour)
        setTimeout(()=>{
            childRef.current?.focus();
        }, 0);
    };
    const onParentMenuClose = ()=>{
        // Keep parent menu open if no selection is made and the field is required
        if (isRequired && !selectedParentOption?.id) parentRef.current?.focus();
    };
    const validate = (0, $cozmU.useCallback)((_value)=>{
        // Check if the field is required and value is empty
        const validateError = validateRequired(currentValue);
        if (validateError) {
            updateMenuOpen('parent');
            return validateError;
        } // Guard against unlikely case where child option is selected but parent option is not
        if (!selectedParentOption?.id && selectedChildOption?.id) {
            (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
                action: 'validationError',
                actionSubject: 'inlineEdit'
            }), {
                fieldName: fieldName,
                fieldType: FIELD_TYPE_FOR_ANALYTICS,
                isRequired: isRequired,
                isEditable: isEditable
            });
            return formatMessage($151e7bc06906d0e3$var$noParentOptionMessage);
        }
    }, [
        createAnalyticsEvent,
        fieldName,
        isEditable,
        validateRequired,
        formatMessage,
        selectedParentOption,
        selectedChildOption,
        currentValue,
        isRequired
    ]);
    const onEdit = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        }); // Save original selections for cancel
        originalParentOption.current = selectedParentOption;
        originalChildOption.current = selectedChildOption; // Enter edit mode and open parent menu automatically
        updateMenuOpen('parent');
        setIsEditing(true);
    }, [
        createAnalyticsEvent,
        fieldName,
        isEditable,
        isRequired,
        selectedParentOption,
        selectedChildOption
    ]);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        }); // Restore original selections
        setSelectedParentOption(originalParentOption.current ?? null);
        setSelectedChildOption(originalChildOption.current ?? null);
        setIsEditing(false);
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable
    ]);
    const onConfirm = (0, $cozmU.useCallback)(()=>{
        // Save the new value
        onChange?.({
            id: selectedParentOption?.id ?? null,
            child: selectedChildOption?.id ? {
                id: selectedChildOption.id
            } : null
        });
        setIsEditing(false);
    }, [
        onChange,
        selectedParentOption,
        selectedChildOption
    ]); // Update menu open state for parent in the case where user immediately returns to the parent select
    // without any actions after parent select (currentMenuOpen does not get updated otherwise)
    const onParentFocus = ()=>{
        // Condition required to not keep menu open when no child options are available
        if (childOptions.length > 0) updateMenuOpen('parent');
    };
    const ReadView = /*#__PURE__*/ (0, $cozmU.memo)(({ value: value })=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $151e7bc06906d0e3$var$styles.readViewContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, value || formatMessage($151e7bc06906d0e3$var$noOptionMessage)));
    });
    const EditView = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $151e7bc06906d0e3$var$styles.editViewContainer,
            backgroundColor: "color.background.input"
        }, /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
            ...selectComponentProps,
            ref: parentRef,
            label: formatMessage($151e7bc06906d0e3$var$selectLabel, {
                fieldName: data.name
            }),
            options: parentOptions,
            value: parentOptions.find((option)=>option.value === selectedParentOption?.value),
            formatOptionLabel: (option)=>option.value,
            onFocus: onParentFocus,
            menuIsOpen: currentMenuOpen === 'parent',
            onMenuOpen: ()=>updateMenuOpen('parent'),
            onMenuClose: onParentMenuClose,
            onChange: onParentChange,
            isClearable: true,
            components: {
                Control: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
                        ...props,
                        xcss: $151e7bc06906d0e3$var$styles.control
                    }),
                SelectContainer: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SelectContainer, {
                        ...props,
                        xcss: $151e7bc06906d0e3$var$styles.container
                    }),
                ValueContainer: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).ValueContainer, {
                        ...props,
                        xcss: $151e7bc06906d0e3$var$styles.valueContainer
                    }),
                DropdownIndicator: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).DropdownIndicator, props)
            }
        }), showChildSelector && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $151e7bc06906d0e3$var$styles.childSelector,
            backgroundColor: "color.background.input"
        }, /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
            ref: childRef,
            label: formatMessage($151e7bc06906d0e3$var$selectLabel, {
                fieldName: data.name
            }),
            options: childOptions,
            value: childOptions.find((option)=>option.value === selectedChildOption?.value),
            menuIsOpen: currentMenuOpen === 'child',
            onMenuOpen: ()=>updateMenuOpen('child'),
            onMenuClose: ()=>updateMenuOpen(null),
            onChange: onChildChange,
            isClearable: selectedChildOption !== null,
            components: {
                Control: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
                        ...props,
                        xcss: $151e7bc06906d0e3$var$styles.control
                    }),
                SelectContainer: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SelectContainer, {
                        ...props,
                        xcss: $151e7bc06906d0e3$var$styles.container
                    }),
                ValueContainer: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).ValueContainer, {
                        ...props,
                        xcss: $151e7bc06906d0e3$var$styles.valueContainer
                    }),
                DropdownIndicator: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).DropdownIndicator, props)
            },
            ...selectComponentProps
        })));
    });
    const ReadViewComponent = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ $cozmU.createElement(ReadView, {
            value: currentValue
        });
    }, [
        currentValue,
        ReadView
    ]);
    const isEditableProp = isEditable && isFieldEditable; // Render only the read view component if the field is not editable
    if (!isEditableProp) return /*#__PURE__*/ $cozmU.createElement(ReadView, {
        value: currentValue
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $akErP.Manager), null, /*#__PURE__*/ $cozmU.createElement((0, $kN1yU.Reference), null, ({ ref: ref })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            role: "none",
            ref: ref,
            xcss: $151e7bc06906d0e3$var$styles.editableReadViewContainer,
            onClick: !isEditing ? onEdit : undefined
        }, !isEditing && /*#__PURE__*/ $cozmU.createElement(ReadView, {
            value: currentValue
        }))), isEditing && /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
        zIndex: (0, $8wMiv.layers).modal()
    }, /*#__PURE__*/ $cozmU.createElement((0, $lQV5m.Popper), {
        placement: "bottom-start",
        strategy: "fixed",
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: ({ reference: reference })=>[
                            0,
                            -reference.height
                        ]
                }
            },
            {
                name: 'sameWidth',
                enabled: true,
                phase: 'beforeWrite',
                requires: [
                    'computeStyles'
                ],
                fn: ({ state: state })=>{
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                effect: ({ state: state })=>{
                    state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
                }
            }
        ]
    }, ({ ref: popperRef, style: style })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ref: popperRef,
            xcss: $151e7bc06906d0e3$var$styles.popperContainer,
            style: style
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $151e7bc06906d0e3$var$styles.editViewContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            isEditing: true,
            defaultValue: currentValue,
            editButtonLabel: currentValue || formatMessage($151e7bc06906d0e3$var$noOptionMessage),
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ $cozmU.createElement((0, $2v5cF.ValidationPopup), {
                    errorMessage: errorMessage,
                    trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                            ref: triggerProps.ref
                        }, /*#__PURE__*/ $cozmU.createElement(EditView, null)),
                    placement: "right",
                    showInvalidPopup: fieldProps.isInvalid
                }),
            readView: ReadViewComponent,
            onConfirm: onConfirm,
            onCancel: onCancel,
            onEdit: onEdit,
            readViewFitContainerWidth: true,
            validate: validate
        }))))));
});
module.exports["JiraCascadingSelectField"] = $151e7bc06906d0e3$export$9b2ab116fcf0865f;

});

parcelRegister("gYtwq", function(module, exports) {
/**
 * @generated SignedSource<<cf870b812fa842f13a24c4391af7f57b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a7b79a22c2809c4$var$node = function() {
    var v0 = [
        {
            "concreteType": "JiraOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraOption",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraCheckboxesField_Platform",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraCheckboxesField"
    };
}();
$7a7b79a22c2809c4$var$node.hash = "3e45bfdb7cc15e25fa0063d380b856d9";
var $7a7b79a22c2809c4$export$2e2bcd8739ae039 = $7a7b79a22c2809c4$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $1PdA8 = parcelRequire("1PdA8");


var $8wMiv = parcelRequire("8wMiv");


var $7nqlz = parcelRequire("7nqlz");


var $5r5PB = parcelRequire("5r5PB");

/* JiraInlineField.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $9DHhW = parcelRequire("9DHhW");


var $1hQ0e = parcelRequire("1hQ0e");


var $w6R6I = parcelRequire("w6R6I");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $hcOES = parcelRequire("hcOES");


var $gVzkK = parcelRequire("gVzkK");


var $9XiTB = parcelRequire("9XiTB");


var $2v5cF = parcelRequire("2v5cF");

const $7f084a3d3414a099$var$messages = (0, $kSwu1.defineMessages)({
    none: {
        id: "jira.jira-platform-fields.jira-inline-field.none",
        defaultMessage: "None"
    }
});
const $7f084a3d3414a099$var$styles = {
    container: "_39xV02N91d _3138424F84",
    readView: "_0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb2ADO _2Zuz6Q2ADO",
    editableReadView: "_39xV02N91d _0wOv4Q7zJH _0jFU0VnlTt"
};
const $7f084a3d3414a099$export$1c5c7582aa6ab213 = ({ containerStyles: containerStyles, defaultValue: defaultValue, editView: editView, fieldName: fieldName, fieldTypeForAnalytics: fieldTypeForAnalytics, hideActionButtons: hideActionButtons = true, hideEmptyPlaceholder: hideEmptyPlaceholder = false, isEditable: isEditable, isRequired: isRequired, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, readView: readView, readViewFitContainerWidth: readViewFitContainerWidth = true, tooltipText: tooltipText, customValidate: customValidate, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEmpty = (0, $cozmU.useMemo)(()=>defaultValue == null || typeof defaultValue === 'string' && defaultValue.trim() === '' || Array.isArray(defaultValue) && defaultValue.length === 0, [
        defaultValue
    ]);
    const requiredValidation = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: fieldName,
        fieldTypeForAnalytics: fieldTypeForAnalytics
    });
    const combinedValidate = (0, $cozmU.useCallback)((value, formState, fieldState)=>{
        // Required validation first
        const requiredError = requiredValidation(value);
        if (requiredError) return requiredError;
         // Then custom validation if provided
        return customValidate?.(value, formState, fieldState);
    }, [
        requiredValidation,
        customValidate
    ]); // Analytics-wrapped handlers
    const handleEdit = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: fieldTypeForAnalytics,
            isRequired: isRequired,
            isEditable: isEditable
        });
        onEdit?.();
    }, [
        createAnalyticsEvent,
        fieldName,
        fieldTypeForAnalytics,
        isRequired,
        isEditable,
        onEdit
    ]);
    const handleConfirm = (0, $cozmU.useCallback)((value, analyticsEvent)=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'applied',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: fieldTypeForAnalytics,
            isRequired: isRequired,
            isEditable: isEditable
        });
        onConfirm(value, analyticsEvent);
    }, [
        createAnalyticsEvent,
        fieldName,
        fieldTypeForAnalytics,
        isRequired,
        isEditable,
        onConfirm
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: fieldTypeForAnalytics,
            isRequired: isRequired,
            isEditable: isEditable
        });
        onCancel?.();
    }, [
        createAnalyticsEvent,
        fieldName,
        fieldTypeForAnalytics,
        isRequired,
        isEditable,
        onCancel
    ]); // Rely on a couple of refs to determine whether a tooltip is needed:
    // 1. Ref to the container Box that wraps the read view content. Used to
    // measure available width for text.
    const readViewContainerRef = (0, $cozmU.useRef)(null); // 2. Ref to a cached canvas element to avoid creating a new one on every
    // hover. Used to simulate how much width would the text take up on the
    // screen.
    const measureCanvasRef = (0, $cozmU.useRef)(null);
    const canAppear = (0, $cozmU.useCallback)(()=>{
        if (!tooltipText || !readViewContainerRef.current) return false;
        const container = readViewContainerRef.current;
        const computedStyle = window.getComputedStyle(container); // Build the font string from the container's computed styles so the
        // measurement matches the actual rendering context.
        const font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
        if (!measureCanvasRef.current) measureCanvasRef.current = (0, $1hQ0e.getDocument)()?.createElement('canvas') ?? null;
        const ctx = measureCanvasRef.current?.getContext('2d');
        if (ctx == null) return false;
        ctx.font = font;
        const textWidth = ctx.measureText(tooltipText).width; // Subtract horizontal padding to get the actual available content width
        const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
        const availableWidth = container.clientWidth - paddingLeft - paddingRight;
        return textWidth > availableWidth;
    }, [
        tooltipText
    ]);
    const enrichedReadView = (0, $cozmU.useCallback)(()=>{
        const containedReadView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: readViewContainerRef,
            xcss: (0, $w6R6I.cx)($7f084a3d3414a099$var$styles.readView, isEditable && $7f084a3d3414a099$var$styles.editableReadView)
        }, isEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            align: "start",
            color: "color.text.subtle",
            maxLines: 1
        }, hideEmptyPlaceholder ? null : formatMessage($7f084a3d3414a099$var$messages.none)) : readView({
            value: defaultValue
        }));
        return tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            component: (0, $9XiTB.CustomTooltip),
            content: tooltipText,
            canAppear: canAppear
        }, containedReadView) : containedReadView;
    }, [
        canAppear,
        defaultValue,
        formatMessage,
        hideEmptyPlaceholder,
        isEditable,
        isEmpty,
        readView,
        tooltipText
    ]);
    const enrichedEditView = (0, $cozmU.useCallback)((fieldProps, ref)=>{
        const { errorMessage: errorMessage, isInvalid: isInvalid, ...restFieldProps } = fieldProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2v5cF.ValidationPopup), {
            errorMessage: errorMessage,
            showInvalidPopup: isInvalid && !!errorMessage,
            trigger: ({ ref: popupRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    ref: popupRef
                }, editView({
                    ...restFieldProps,
                    errorMessage: errorMessage,
                    isInvalid: isInvalid,
                    ...triggerProps
                }, ref))
        });
    }, [
        editView
    ]); // Read-only view
    if (!isEditable) return enrichedReadView();
     // Editable view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: containerStyles ?? $7f084a3d3414a099$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
        ...props,
        defaultValue: defaultValue,
        hideActionButtons: hideActionButtons,
        readViewFitContainerWidth: readViewFitContainerWidth,
        validate: combinedValidate,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCancel: handleCancel,
        readView: enrichedReadView,
        editView: enrichedEditView
    }));
};


const $a9b1f4dc26f9d2f9$var$FIELD_TYPE_FOR_ANALYTICS = 'JiraCheckboxesField';
const $a9b1f4dc26f9d2f9$var$messages = (0, $kSwu1.defineMessages)({
    none: {
        id: "jira.jira.jira-platform-fields.jira-checkboxes-field.none",
        defaultMessage: "None"
    },
    showMoreTooltip: {
        id: "jira.jira.jira-platform-fields.jira-checkboxes-field.show-more-tooltip",
        defaultMessage: "Show more options"
    }
});
const $a9b1f4dc26f9d2f9$var$parseOptions = (fieldOptions)=>{
    const options = [];
    if (fieldOptions?.edges) for (const option of fieldOptions.edges){
        const value = option?.node?.value;
        if (value != null) options.push({
            value: value,
            label: value
        });
    }
    return options;
};
const $a9b1f4dc26f9d2f9$var$ReadView = /*#__PURE__*/ (0, $cozmU.memo)(({ selectedOptions: selectedOptions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7nqlz.default), {
        items: selectedOptions.map((opt)=>({
                key: opt.value,
                name: opt.label,
                isColored: false
            })),
        ItemComponent: (0, $5r5PB.TagItem),
        PopupContentWrapper: (0, $5r5PB.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage($a9b1f4dc26f9d2f9$var$messages.showMoreTooltip),
        isHoverPopoverEnabled: true
    });
});
const $a9b1f4dc26f9d2f9$var$readView = (readViewProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9b1f4dc26f9d2f9$var$ReadView, {
        selectedOptions: readViewProps.value
    });
const $a9b1f4dc26f9d2f9$export$b6615d2689cf40dc = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $6SsN4.useFragment)((0, $7a7b79a22c2809c4$export$2e2bcd8739ae039), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const fieldName = data.name;
    const defaultValues = (0, $cozmU.useMemo)(()=>{
        const values = [];
        if (data.selectedOptions?.edges) for (const edge of data.selectedOptions.edges){
            const value = edge?.node?.value;
            if (value != null) values.push(value);
        }
        return values.length > 0 ? values : null;
    }, [
        data.selectedOptions
    ]);
    const currentValue = (0, $cozmU.useMemo)(()=>{
        if (Array.isArray(fieldValue)) return fieldValue.filter((v)=>typeof v === 'string');
        return null;
    }, [
        fieldValue
    ]);
    const hasValue = currentValue != null && currentValue.length > 0;
    const options = $a9b1f4dc26f9d2f9$var$parseOptions(data.fieldOptions);
    const selectedOptions = (0, $cozmU.useMemo)(()=>hasValue ? currentValue.map((val)=>({
                value: val,
                label: val
            })) : [], [
        hasValue,
        currentValue
    ]);
    // Display text for editButtonLabel
    const editButtonLabel = (0, $cozmU.useMemo)(()=>{
        if (!hasValue) return formatMessage($a9b1f4dc26f9d2f9$var$messages.none);
        if (currentValue.length === 1) return currentValue[0];
        return currentValue.join(', ');
    }, [
        hasValue,
        currentValue,
        formatMessage
    ]);
    // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and default values are available, tell the upstream
        if (!fieldValue && defaultValues != null && isFirstRenderRef.current) onChange(defaultValues);
        isFirstRenderRef.current = false;
    }, [
        fieldValue,
        defaultValues,
        onChange
    ]);
    const onConfirm = (0, $cozmU.useCallback)((newValue)=>{
        // Extract string values from options
        const newValues = newValue && newValue.length > 0 ? newValue.map((opt)=>String(opt.value)).filter(Boolean) : null;
        // Compare arrays for changes
        const hasChanged = (()=>{
            if (!newValues && !currentValue) return false;
            if (!newValues || !currentValue) return true;
            if (newValues.length !== currentValue.length) return true;
            const currentSet = new Set(currentValue);
            return !newValues.every((val)=>currentSet.has(val));
        })();
        if (hasChanged) onChange(newValues);
    }, [
        currentValue,
        onChange
    ]);
    const editView = (0, $cozmU.useCallback)((fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PdA8.CheckboxSelect), {
            ...fieldProps,
            label: fieldName,
            options: options,
            autoFocus: true,
            isRequired: isRequired,
            isClearable: true,
            menuPosition: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'fixed' : 'absolute',
            menuPlacement: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'auto' : 'bottom',
            styles: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? {
                control: (base)=>({
                        ...base,
                        height: '40px',
                        minHeight: '40px',
                        maxHeight: '40px',
                        boxSizing: 'border-box',
                        flexWrap: 'nowrap',
                        overflow: 'hidden'
                    }),
                valueContainer: (base)=>({
                        ...base,
                        flexWrap: 'nowrap',
                        overflow: 'hidden'
                    }),
                menu: (base)=>({
                        ...base,
                        zIndex: (0, $8wMiv.layers).modal()
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $8wMiv.layers).modal()
                    })
            } : undefined
        }), [
        fieldName,
        isRequired,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f084a3d3414a099$export$1c5c7582aa6ab213), {
        fieldName: fieldName,
        fieldTypeForAnalytics: $a9b1f4dc26f9d2f9$var$FIELD_TYPE_FOR_ANALYTICS,
        isEditable: isEditable,
        isRequired: isRequired,
        readView: $a9b1f4dc26f9d2f9$var$readView,
        editView: editView,
        defaultValue: selectedOptions,
        editButtonLabel: editButtonLabel,
        onConfirm: onConfirm
    });
});
module.exports["JiraCheckboxesField"] = $a9b1f4dc26f9d2f9$export$b6615d2689cf40dc;

});

parcelRegister("1PdA8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aj8Vc = parcelRequire("aj8Vc");


var $6wGOF = parcelRequire("6wGOF");

const $bddbdd57e047aa5f$var$CheckboxSelectInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let components;
    let props;
    if ($[0] !== t0) {
        ({ components: components, ...props } = t0);
        $[0] = t0;
        $[1] = components;
        $[2] = props;
    } else {
        components = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== components) {
        t1 = {
            ...components,
            Option: (0, $aj8Vc.CheckboxOption)
        };
        $[3] = components;
        $[4] = t1;
    } else t1 = $[4];
    const mergedComponents = t1;
    let t2;
    if ($[5] !== mergedComponents || $[6] !== props) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            isMulti: true,
            ...props,
            components: mergedComponents
        });
        $[5] = mergedComponents;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ components: components, ...props })=>{
    const mergedComponents = (0, $cozmU.useMemo)(()=>({
            ...components,
            Option: (0, $aj8Vc.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $bddbdd57e047aa5f$export$c1107a07d26cc03c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($bddbdd57e047aa5f$var$CheckboxSelectInternal); // eslint-disable-next-line @repo/internal/react/require-jsdoc
module.exports["CheckboxSelect"] = $bddbdd57e047aa5f$export$c1107a07d26cc03c;

});

parcelRegister("aj8Vc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fekRe = parcelRequire("fekRe");

const $60c7d7f04a94467b$var$svgStyles = null;
const $60c7d7f04a94467b$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    let t0;
    if ($[0] !== primaryColor || $[1] !== secondaryColor) {
        t0 = {
            color: primaryColor,
            fill: secondaryColor
        };
        $[0] = primaryColor;
        $[1] = secondaryColor;
        $[2] = t0;
    } else t0 = $[2];
    const t1 = label ? label : undefined;
    const t2 = label ? "img" : "presentation";
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            viewBox: "0 0 24 24",
            style: t0,
            "aria-label": t1,
            role: t2,
            className: t3,
            children: t4
        });
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _1rdFvhlfZc _1pp6NdYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $60c7d7f04a94467b$export$d40cc97ecda916f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fekRe.ControlOption), {
            Icon: $60c7d7f04a94467b$var$CheckboxIcon,
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fekRe.ControlOption), {
        Icon: $60c7d7f04a94467b$var$CheckboxIcon,
        ...props
    });
module.exports["CheckboxOption"] = $60c7d7f04a94467b$export$d40cc97ecda916f9;

});

parcelRegister("fekRe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $c75784b58b2be878$var$optionStyles = {
    default: "_3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _20VacPYbGa _2X4BecWrS5 _24h04i2Njc _0xmtko1Y8M _46hvQm1Y8M _0LQT5E5zaO _03SyCP8HPE _0KLXrujOvk _2OUyjtOLYo _1UtDYzOLYo _3gzVzLN4oS",
    focused: "_0KLXruo126 _2OUyjtP5Rf _2rG9p6TjXh",
    disabled: "_1UtDYzot27",
    motion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4"
}; // state of the parent option
const $c75784b58b2be878$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $c75784b58b2be878$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c75784b58b2be878$var$iconStyles = {
    inherit: "_4na8rw98eZ _3tP2Tm98eZ",
    default: "_4na8rwWkXl _3tP2TmWkXl"
};
const $c75784b58b2be878$var$baseIconStyles = null;
const $c75784b58b2be878$var$baseOptionStyles = null;
const $c75784b58b2be878$export$e41f7c07e51665da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(32);
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsActive(true);
        $[0] = t0;
    } else t0 = $[0];
    const onMouseDown = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsActive(false);
        $[1] = t1;
    } else t1 = $[1];
    const onMouseUp = t1;
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    let t2;
    if ($[2] !== className || $[3] !== cx || $[4] !== isDisabled || $[5] !== isFocused || $[6] !== isSelected) {
        t2 = cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className);
        $[2] = className;
        $[3] = cx;
        $[4] = isDisabled;
        $[5] = isFocused;
        $[6] = isSelected;
        $[7] = t2;
    } else t2 = $[7];
    const classNames = t2;
    let t3;
    if ($[8] !== classNames || $[9] !== isDisabled || $[10] !== isFocused) {
        t3 = (0, $hekY6.default)([
            $c75784b58b2be878$var$optionStyles.default,
            !isDisabled && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $c75784b58b2be878$var$optionStyles.motion,
            isFocused && $c75784b58b2be878$var$optionStyles.focused,
            isDisabled && $c75784b58b2be878$var$optionStyles.disabled,
            classNames
        ]);
        $[8] = classNames;
        $[9] = isDisabled;
        $[10] = isFocused;
        $[11] = t3;
    } else t3 = $[11];
    const t4 = isSelected || isActive || isDisabled ? $c75784b58b2be878$var$iconStyles.inherit : $c75784b58b2be878$var$iconStyles.default;
    let t5;
    if ($[12] !== t4) {
        t5 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _03SyCP1Y8M _2Nkr8bLEV2 _4zMa6vLEV2 _0lzfxTNvrM _0AC44BNvrM",
            t4
        ]);
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== Icon || $[15] !== isActive || $[16] !== isDisabled || $[17] !== isFocused || $[18] !== isSelected) {
        t6 = !!Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: "",
            primaryColor: $c75784b58b2be878$var$getPrimaryColor({
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                isActive: isActive
            }),
            secondaryColor: $c75784b58b2be878$var$getSecondaryColor({
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            isFacadeDisabled: true
        }) : null;
        $[14] = Icon;
        $[15] = isActive;
        $[16] = isDisabled;
        $[17] = isFocused;
        $[18] = isSelected;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t5,
            children: t6
        });
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_2O5Vij7dHp _4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7"
        ]);
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== children) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t8,
            children: children
        });
        $[24] = children;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== innerProps || $[27] !== innerRef || $[28] !== t3 || $[29] !== t7 || $[30] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t3,
            ref: innerRef,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseLeave: onMouseUp,
            ...innerProps,
            children: [
                t7,
                t9
            ]
        });
        $[26] = innerProps;
        $[27] = innerRef;
        $[28] = t3;
        $[29] = t7;
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : (props)=>{
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const onMouseDown = (0, $cozmU.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $cozmU.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $cozmU.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            $c75784b58b2be878$var$optionStyles.default,
            !isDisabled && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $c75784b58b2be878$var$optionStyles.motion,
            isFocused && $c75784b58b2be878$var$optionStyles.focused,
            isDisabled && $c75784b58b2be878$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _03SyCP1Y8M _2Nkr8bLEV2 _4zMa6vLEV2 _0lzfxTNvrM _0AC44BNvrM",
                    isSelected || isActive || isDisabled ? $c75784b58b2be878$var$iconStyles.inherit : $c75784b58b2be878$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    label: "",
                    primaryColor: $c75784b58b2be878$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c75784b58b2be878$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp _4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7"
                ]),
                children: children
            })
        ]
    });
};
module.exports["ControlOption"] = $c75784b58b2be878$export$e41f7c07e51665da;

});

parcelRegister("iQxQk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $2gopW = parcelRequire("2gopW");

const $e185839fcf3cffd9$export$758a2fef95a29ad0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    let t0;
    if ($[0] !== props.children) {
        t0 = props.children({
            loading: false,
            error: true
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2gopW.MediaImageWithMediaClient), props);
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t1
        }, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2gopW.MediaImageWithMediaClient), props));
module.exports["MediaImageWithErrorBoundary"] = $e185839fcf3cffd9$export$758a2fef95a29ad0;

});

parcelRegister("2gopW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $g0fSg = parcelRequire("g0fSg");


var $9vt4W = parcelRequire("9vt4W");


var $iDrrr = parcelRequire("iDrrr");

const $67c41173d305abe8$var$copyDivStyles = null;
const $67c41173d305abe8$var$MediaImageBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { identifier: identifier, apiConfig: t1, children: children, ssr: ssr } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const apiConfig = t2;
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, "max-age": maxAge } = apiConfig;
    let t3;
    if ($[2] !== height || $[3] !== width) {
        t3 = {
            width: width,
            height: height
        };
        $[2] = height;
        $[3] = width;
        $[4] = t3;
    } else t3 = $[4];
    const dimensions = t3;
    let t4;
    if ($[5] !== allowAnimated || $[6] !== dimensions || $[7] !== identifier || $[8] !== maxAge || $[9] !== mode || $[10] !== ssr || $[11] !== upscale) {
        t4 = {
            identifier: identifier,
            dimensions: dimensions,
            ssr: ssr,
            resizeMode: mode,
            allowAnimated: allowAnimated,
            upscale: upscale,
            maxAge: maxAge
        };
        $[5] = allowAnimated;
        $[6] = dimensions;
        $[7] = identifier;
        $[8] = maxAge;
        $[9] = mode;
        $[10] = ssr;
        $[11] = upscale;
        $[12] = t4;
    } else t4 = $[12];
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $9vt4W.useFilePreview)(t4);
    let status = "loading";
    if (preview?.dataURI) status = "succeeded";
    else if (error) status = "error";
    const t5 = status === "loading";
    const t6 = status === "error";
    let t7;
    if ($[13] !== children || $[14] !== preview?.dataURI || $[15] !== status || $[16] !== t5 || $[17] !== t6) {
        t7 = children({
            loading: t5,
            error: t6,
            data: status === "succeeded" ? {
                status: status,
                src: preview?.dataURI
            } : undefined
        });
        $[13] = children;
        $[14] = preview?.dataURI;
        $[15] = status;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== copyNodeRef) {
        t8 = (0, $iDrrr.fg)("platform_media_cross_client_copy") && /*#__PURE__*/ $cozmU.createElement("div", {
            ref: copyNodeRef,
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        });
        $[19] = copyNodeRef;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== getSsrScriptProps) {
        t9 = getSsrScriptProps && /*#__PURE__*/ $cozmU.createElement("script", getSsrScriptProps());
        $[21] = getSsrScriptProps;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, t7, t8, t9);
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $9vt4W.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), (0, $iDrrr.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $cozmU.createElement("div", {
        ref: copyNodeRef,
        className: (0, $hekY6.default)([
            "_3iDTPbYbGa"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $cozmU.createElement("script", getSsrScriptProps()));
};
const $67c41173d305abe8$export$8acd7eecc88dfeb5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $g0fSg.withMediaClient)($67c41173d305abe8$var$MediaImageBase);
        $[0] = t0;
    } else t0 = $[0];
    const MediaImageComponent = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement(MediaImageComponent, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    const MediaImageComponent = (0, $cozmU.useMemo)(()=>(0, $g0fSg.withMediaClient)($67c41173d305abe8$var$MediaImageBase), []);
    return /*#__PURE__*/ $cozmU.createElement(MediaImageComponent, props);
};
module.exports["MediaImageWithMediaClient"] = $67c41173d305abe8$export$8acd7eecc88dfeb5;

});

parcelRegister("g0fSg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");


var $g9ZnD = parcelRequire("g9ZnD");


var $gIMcb = parcelRequire("gIMcb");

const $e5bbb38f64c6a3e7$export$9f7977d4a2561bee = (Component)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
        const mediaClient = (0, $cozmU.useMemo)(()=>existingMediaClient ?? (0, $g9ZnD.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));
module.exports["withMediaClient"] = $e5bbb38f64c6a3e7$export$9f7977d4a2561bee;

});

parcelRegister("9vt4W", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gOi68 = parcelRequire("gOi68");

var $4OSQA = parcelRequire("4OSQA");


var $4zScG = parcelRequire("4zScG");

var $h7nb4 = parcelRequire("h7nb4");

var $lNvN4 = parcelRequire("lNvN4");


var $9OT81 = parcelRequire("9OT81");


var $iDrrr = parcelRequire("iDrrr");


var $8BQV6 = parcelRequire("8BQV6");


var $joP8U = parcelRequire("joP8U");


var $j6hoF = parcelRequire("j6hoF");


var $61zD1 = parcelRequire("61zD1");

var $1FrxG = parcelRequire("1FrxG");

var $a0nKQ = parcelRequire("a0nKQ");


var $l32w2 = parcelRequire("l32w2");

var $a4SEC = parcelRequire("a4SEC");


var $gE3xj = parcelRequire("gE3xj");

// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $88a5d6d53a08a849$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $88a5d6d53a08a849$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source, initialFileState: initialFileState })=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const [status, setStatus] = (0, $cozmU.useState)('loading');
    const [error, setError] = (0, $cozmU.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $cozmU.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $cozmU.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $cozmU.useState)('not-resolved');
    const ssrReliabilityRef = (0, $cozmU.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $8BQV6.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isLoading) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $cozmU.useMemo)(()=>dimensions ? (0, $gE3xj.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $gE3xj.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $a0nKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $a4SEC.getSSRData)(identifier, resizeMode);
            if (ssrData?.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!ssrData?.dataURI) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    // When the relay/SSR-seed path provided a pre-signed CDN URL,
                    // overlay its CDN-signing query params on the URL produced by
                    // getImageUrlSync. This makes the SSR-rendered HTML use the
                    // cdn-signed URL directly (no auth-token -> cdn-signed swap on
                    // hydration) and the 'ssr-data' rehydration path inherits it
                    // automatically via globalScope.
                    const seededCdnUrl = initialFileState && initialFileState.status !== 'error' ? initialFileState.previewCdnUrl : undefined;
                    const cdnSigningParams = seededCdnUrl && (0, $iDrrr.fg)('platform_media_ssr_data_seed') ? (0, $61zD1.extractCdnSigningParams)(seededCdnUrl) : undefined;
                    return (0, $61zD1.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs, cdnSigningParams);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $joP8U.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions_0, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions_0,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview_0, setPreview] = (0, $cozmU.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $h7nb4.useFileState)(identifier.id, {
        initialFileState: initialFileState,
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $gOi68.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $cozmU.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status !== 'error') {
            if (preview_0 || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview_0 && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $j6hoF.MediaFilePreviewError)('failed-processing'));
            } else if (!preview_0 && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $j6hoF.MediaFilePreviewError)('metadata-fetch', (0, $4OSQA.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview_0,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (0, $a4SEC.getSSRData)(identifier, resizeMode)?.loadPromise;
        if (preview_0 && (0, $61zD1.isSSRDataPreview)(preview_0) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview_0,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $gE3xj.useCurrentValueRef)(()=>{
        return (0, $61zD1.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview_0) setUpfrontPreviewStatus('resolved');
        else if (!preview_0 && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $gE3xj.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview_0,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $gE3xj.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $cozmU.useEffect)(()=>{
        const cachedPreview = (0, $a0nKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview_0 && cachedPreview && !(0, $gE3xj.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview_0 && !isBannedLocalPreview && localBinary && (0, $1FrxG.isSupportedLocalPreview)(mediaType) && (0, $9OT81.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $61zD1.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e_0)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e_0);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview_0 || (0, $gE3xj.isBigger)(preview_0.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $61zD1.isSSRPreview)(preview_0)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview_0 && (0, $61zD1.isSSRPreview)(preview_0) && !(0, $gE3xj.isWider)(preview_0.dimensions, dimensions) && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e_1)=>{
                const wrappedError = (0, $j6hoF.ensureMediaFilePreviewError)('preview-fetch', e_1);
                if (!preview_0) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview_0,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        (0, $a0nKQ.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $a0nKQ.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $cozmU.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $61zD1.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $joP8U.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $61zD1.isSSRDataPreview)(failedPreview) || (0, $61zD1.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $joP8U.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $joP8U.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview_0?.dataURI) return;
        const isLocal = (0, $61zD1.isLocalPreview)(failedPreview);
        const isRemote = (0, $61zD1.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error_0 = new (0, $j6hoF.ImageLoadError)(failedPreview?.source);
            (0, $a0nKQ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error_0);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview_0?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $cozmU.useCallback)((newPreview_0)=>{
        if (newPreview_0) {
            if ((0, $61zD1.isSSRClientPreview)(newPreview_0) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $61zD1.isSSRDataPreview)(newPreview_0) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview_0.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview_0?.dataURI !== preview_0?.dataURI) return;
    }, [
        preview_0?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $l32w2.generateScriptProps)(identifier, preview_0?.dataURI, resizeMode, preview_0?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $iDrrr.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $iDrrr.fg)('media-perf-lazy-loading-optimisation')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $4zScG.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix') ? $88a5d6d53a08a849$var$DEFAULT_SSR_PREVIEW : preview_0,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};
module.exports["useFilePreview"] = $88a5d6d53a08a849$export$4eaebdef02112fe4;

});

parcelRegister("4zScG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $lNvN4 = parcelRequire("lNvN4");


var $6LIML = parcelRequire("6LIML");


var $LCmg6 = parcelRequire("LCmg6");

function $53479886ecc2e2a4$var$useCurrentValueRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
const $53479886ecc2e2a4$export$46fd859414de9d62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (id, t0)=>{
    const $ = (0, $bDgLe.c)(20);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const innerRef = (0, $cozmU.useRef)(null);
    const clientIdRef = (0, $cozmU.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[2] !== mediaClient || $[3] !== options.collectionName) {
        t2 = ()=>{
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy_with_auth")) mediaClient.getClientId(options.collectionName).then((clientId)=>{
                clientIdRef.current = clientId;
            }).catch($53479886ecc2e2a4$var$_temp);
        };
        t3 = [
            mediaClient,
            options.collectionName
        ];
        $[2] = mediaClient;
        $[3] = options.collectionName;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[6] !== createAnalyticsEvent || $[7] !== id || $[8] !== mediaClient || $[9] !== options.collectionName) {
        t4 = async ()=>{
            try {
                await mediaClient.file.registerCopyIntent(id, options.collectionName);
                createAnalyticsEvent((0, $6LIML.getCopyIntentSuccessPayload)(id));
            } catch (t5) {
                const err = t5;
                createAnalyticsEvent((0, $6LIML.getCopyIntentErrorPayload)(err, id));
            }
        };
        $[6] = createAnalyticsEvent;
        $[7] = id;
        $[8] = mediaClient;
        $[9] = options.collectionName;
        $[10] = t4;
    } else t4 = $[10];
    const registerCopyIntentRef = $53479886ecc2e2a4$var$useCurrentValueRef(t4);
    let t5;
    if ($[11] !== registerCopyIntentRef) {
        t5 = (elem)=>{
            innerRef.current = elem;
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy")) elem?.addEventListener("contextmenu", ()=>{
                registerCopyIntentRef.current();
            });
        };
        $[11] = registerCopyIntentRef;
        $[12] = t5;
    } else t5 = $[12];
    const copyNodeRef = t5;
    let t6;
    if ($[13] !== registerCopyIntentRef) {
        t6 = (event)=>{
            const currentCopyTarget = innerRef.current;
            const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
            if (currentSelectionContainsNode) {
                registerCopyIntentRef.current();
                if ((0, $iDrrr.fg)("platform_media_cross_client_copy_with_auth")) {
                    const clientId_0 = clientIdRef.current;
                    const html = event.clipboardData?.getData("text/html");
                    if (html && html.includes("data-node-type=\"media") && clientId_0) {
                        const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId_0}"$2`);
                        event.clipboardData?.setData("text/html", modifiedHtml);
                    }
                }
            }
        };
        $[13] = registerCopyIntentRef;
        $[14] = t6;
    } else t6 = $[14];
    const onGlobalCopy = t6;
    let t7;
    let t8;
    if ($[15] !== onGlobalCopy) {
        t7 = ()=>{
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy")) (0, $LCmg6.getDocument)()?.addEventListener("copy", onGlobalCopy);
            return ()=>(0, $LCmg6.getDocument)()?.removeEventListener("copy", onGlobalCopy);
        };
        t8 = [
            onGlobalCopy
        ];
        $[15] = onGlobalCopy;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[18] !== copyNodeRef) {
        t9 = {
            copyNodeRef: copyNodeRef
        };
        $[18] = copyNodeRef;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : (id, options = {})=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const innerRef = (0, $cozmU.useRef)(null);
    const clientIdRef = (0, $cozmU.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $53479886ecc2e2a4$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $6LIML.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $6LIML.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $cozmU.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $cozmU.useCallback)((event)=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) {
                const clientId_0 = clientIdRef.current;
                const html = event.clipboardData?.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId_0) {
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId_0}"$2`);
                    event.clipboardData?.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy')) (0, $LCmg6.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $LCmg6.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};
function $53479886ecc2e2a4$var$_temp() {}
module.exports["useCopyIntent"] = $53479886ecc2e2a4$export$46fd859414de9d62;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("6LIML", function(module, exports) {

var $kQ37v = parcelRequire("kQ37v");

const $9900c963844535b6$var$getRequestErrorDetails = (err)=>{
    if ((0, $kQ37v.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $9900c963844535b6$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $kQ37v.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9900c963844535b6$var$getRequestErrorDetails(error)
        }
    };
};
const $9900c963844535b6$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};
module.exports["getCopyIntentErrorPayload"] = $9900c963844535b6$export$3ab52330b662b987;
module.exports["getCopyIntentSuccessPayload"] = $9900c963844535b6$export$aacb463551da2e8f;

});

parcelRegister("LCmg6", function(module, exports) {
const $92acd99a6d98db3f$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};
module.exports["getDocument"] = $92acd99a6d98db3f$export$f65ca476c09acec0;

});

parcelRegister("h7nb4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lNvN4 = parcelRequire("lNvN4");


var $4fGOw = parcelRequire("4fGOw");

const $387adc567339a7f4$export$90ff537b0999afb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFileState(id, t0) {
    const $ = (0, $bDgLe.c)(15);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: t2, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const skipRemote = t2 === undefined ? false : t2;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    let t3;
    if ($[2] !== id) {
        t3 = (state)=>state.files[id];
        $[2] = id;
        $[3] = t3;
    } else t3 = $[3];
    const fileState = (0, $4fGOw.useMediaStore)(t3);
    const initialFileStateRef = (0, $cozmU.useRef)(initialFileState);
    let t4;
    let t5;
    if ($[4] !== collectionName || $[5] !== fileState || $[6] !== id || $[7] !== includeHashForDuplicateFiles || $[8] !== mediaClient || $[9] !== occurrenceKey || $[10] !== skipRemote) {
        t4 = ()=>{
            if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
                initialFileState: initialFileStateRef.current,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            });
        };
        t5 = [
            id,
            mediaClient,
            collectionName,
            occurrenceKey,
            skipRemote,
            fileState,
            includeHashForDuplicateFiles
        ];
        $[4] = collectionName;
        $[5] = fileState;
        $[6] = id;
        $[7] = includeHashForDuplicateFiles;
        $[8] = mediaClient;
        $[9] = occurrenceKey;
        $[10] = skipRemote;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = fileState ?? initialFileState;
    let t7;
    if ($[13] !== t6) {
        t7 = {
            fileState: t6
        };
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : function useFileState(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const fileState = (0, $4fGOw.useMediaStore)((state)=>state.files[id]);
    // Capture initialFileState as a ref so it's a stable one-time SSR seed that
    // doesn't affect the useEffect dependency array. Including it directly would
    // cause repeated unsubscribe/resubscribe cycles whenever the caller passes a
    // new (unstabilized) object reference — each cycle fires getFileState before
    // the store is populated.
    const initialFileStateRef = (0, $cozmU.useRef)(initialFileState);
    (0, $cozmU.useEffect)(()=>{
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            initialFileState: initialFileStateRef.current,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState ?? initialFileState
    };
};
module.exports["useFileState"] = $387adc567339a7f4$export$90ff537b0999afb;

});

parcelRegister("4fGOw", function(module, exports) {

var $jx5V5 = parcelRequire("jx5V5");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $jx5V5.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("jx5V5", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $e385b0e7bfdc7f87$export$6ccbb43953eebf8);

var $3xeSM = parcelRequire("3xeSM");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $e385b0e7bfdc7f87$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $e385b0e7bfdc7f87$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = false;
const $e385b0e7bfdc7f87$var$identity = (arg)=>arg;
function $e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector = $e385b0e7bfdc7f87$var$identity, equalityFn) {
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$e385b0e7bfdc7f87$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = true;
    }
    const slice = $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $e385b0e7bfdc7f87$var$useDebugValue(slice);
    return slice;
}
const $e385b0e7bfdc7f87$var$createImpl = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $3xeSM.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $e385b0e7bfdc7f87$export$185802fd694ee1f5 = (createState)=>createState ? $e385b0e7bfdc7f87$var$createImpl(createState) : $e385b0e7bfdc7f87$var$createImpl;
var $e385b0e7bfdc7f87$export$2e2bcd8739ae039 = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $e385b0e7bfdc7f87$export$185802fd694ee1f5(createState);
};

});

parcelRegister("joP8U", function(module, exports) {

var $4OSQA = parcelRequire("4OSQA");


var $j6hoF = parcelRequire("j6hoF");

const $f6a8566e9c76eb8c$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4OSQA.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $f6a8566e9c76eb8c$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $f6a8566e9c76eb8c$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4OSQA.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $f6a8566e9c76eb8c$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4OSQA.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $f6a8566e9c76eb8c$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $f6a8566e9c76eb8c$export$4af9d71992e89714(error),
        error: $f6a8566e9c76eb8c$export$88c61dcad53762da(error),
        errorDetail: $f6a8566e9c76eb8c$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $f6a8566e9c76eb8c$export$29aa614726672b2e(error)
    };
};
const $f6a8566e9c76eb8c$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$f6a8566e9c76eb8c$export$74aaf4784c2edb2c(new (0, $j6hoF.ImageLoadError)(preview.source), metadataTraceContext)
    });
module.exports["extractErrorInfo"] = $f6a8566e9c76eb8c$export$74aaf4784c2edb2c;
module.exports["createFailedSSRObject"] = $f6a8566e9c76eb8c$export$768c370ed0dbaeb3;

});

parcelRegister("j6hoF", function(module, exports) {
class $71061d29c37eeba3$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $71061d29c37eeba3$export$2c035820a31723e extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $71061d29c37eeba3$export$10ab445310d30114 extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $71061d29c37eeba3$export$18e89b7e50818288 extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $71061d29c37eeba3$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $71061d29c37eeba3$export$d0a45ab59b4606b extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(source){
        super($71061d29c37eeba3$var$getImageLoadPrimaryReason(source));
    }
}
function $71061d29c37eeba3$export$553696a6e769784c(err) {
    return err instanceof $71061d29c37eeba3$export$96e559194c287cf4;
}
const $71061d29c37eeba3$export$b380593ba3516c6f = (err)=>err instanceof $71061d29c37eeba3$export$2c035820a31723e;
const $71061d29c37eeba3$export$e1d87830b3784f94 = (err)=>err instanceof $71061d29c37eeba3$export$10ab445310d30114;
const $71061d29c37eeba3$export$443aeb298d35d79d = (err)=>$71061d29c37eeba3$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $71061d29c37eeba3$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($71061d29c37eeba3$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $71061d29c37eeba3$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $71061d29c37eeba3$export$96e559194c287cf4(primaryReason, error);
};
module.exports["MediaFilePreviewError"] = $71061d29c37eeba3$export$96e559194c287cf4;
module.exports["LocalPreviewError"] = $71061d29c37eeba3$export$2c035820a31723e;
module.exports["RemotePreviewError"] = $71061d29c37eeba3$export$10ab445310d30114;
module.exports["SsrPreviewError"] = $71061d29c37eeba3$export$18e89b7e50818288;
module.exports["ImageLoadError"] = $71061d29c37eeba3$export$d0a45ab59b4606b;
module.exports["ensureMediaFilePreviewError"] = $71061d29c37eeba3$export$7156ce7b78b49bd7;

});

parcelRegister("61zD1", function(module, exports) {

var $6wYuL = parcelRequire("6wYuL");


var $iDrrr = parcelRequire("iDrrr");


var $j6hoF = parcelRequire("j6hoF");


var $a0nKQ = parcelRequire("a0nKQ");


var $1FrxG = parcelRequire("1FrxG");

const $d8a1d04f617229a6$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $6wYuL.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $a0nKQ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
/**
 * Allowlist of CDN signing query-param names that we propagate from a
 * pre-signed `previewCdnUrl` onto the URL produced by `getImageUrlSync`.
 * These are the standard CloudFront signed-URL params; if the upstream
 * adds a new one, this list needs updating.
 */ const $d8a1d04f617229a6$var$SIGNING_PARAM_NAMES = [
    'token',
    'Policy',
    'Key-Pair-Id',
    'Signature',
    'Expires'
];
const $d8a1d04f617229a6$export$8b90d6fc9c946379 = (cdnUrl)=>{
    try {
        const url = new URL(cdnUrl);
        const out = {};
        for (const name of $d8a1d04f617229a6$var$SIGNING_PARAM_NAMES){
            const value = url.searchParams.get(name);
            if (value !== null) out[name] = value;
        }
        return out;
    } catch  {
        return {};
    }
};
const $d8a1d04f617229a6$var$applyCdnSigningParams = (url, cdnSigningParams)=>{
    if (!cdnSigningParams || Object.keys(cdnSigningParams).length === 0) return url;
    try {
        const parsed = new URL(url);
        Object.entries(cdnSigningParams).forEach(([key, value])=>{
            parsed.searchParams.set(key, value);
        });
        return parsed.toString();
    } catch  {
        return url;
    }
};
const $d8a1d04f617229a6$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs, cdnSigningParams)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    const signedDataURI = $d8a1d04f617229a6$var$applyCdnSigningParams(rawDataURI, cdnSigningParams);
    return mediaBlobUrlAttrs ? (0, $6wYuL.addFileAttrsToUrl)(signedDataURI, mediaBlobUrlAttrs) : signedDataURI;
};
/**
 * Merges a clientId into mediaBlobUrlAttrs for cross-client copy support.
 * Returns the original attrs unchanged if clientId is not available or the feature flag is off.
 */ const $d8a1d04f617229a6$var$mergeClientIdIntoAttrs = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};
const $d8a1d04f617229a6$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs, cdnSigningParams)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = $d8a1d04f617229a6$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $d8a1d04f617229a6$var$getDataUri(mediaClient, id, params, attrsWithClientId, cdnSigningParams);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $d8a1d04f617229a6$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId, cdnSigningParams);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $j6hoF.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $d8a1d04f617229a6$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $d8a1d04f617229a6$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $d8a1d04f617229a6$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $d8a1d04f617229a6$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $d8a1d04f617229a6$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
/**
 * Resolves clientId (sync first, async fallback) and enriches mediaBlobUrlAttrs
 * with it for cross-client copy support.
 */ const $d8a1d04f617229a6$var$enrichAttrsWithClientId = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return $d8a1d04f617229a6$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, collectionName);
};
const $d8a1d04f617229a6$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $1FrxG.getRemotePreview)(mediaClient, id, params, traceContext),
        $d8a1d04f617229a6$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return $d8a1d04f617229a6$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
const $d8a1d04f617229a6$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $1FrxG.getLocalPreview)(filePreview),
        $d8a1d04f617229a6$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return $d8a1d04f617229a6$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
module.exports["extractCdnSigningParams"] = $d8a1d04f617229a6$export$8b90d6fc9c946379;
module.exports["getSSRPreview"] = $d8a1d04f617229a6$export$faf1c301c59a1bdc;
module.exports["isLocalPreview"] = $d8a1d04f617229a6$export$78ad02c5efc361c9;
module.exports["isRemotePreview"] = $d8a1d04f617229a6$export$87442a14a8a19e0;
module.exports["isSSRClientPreview"] = $d8a1d04f617229a6$export$36aae1afbc0a9661;
module.exports["isSSRDataPreview"] = $d8a1d04f617229a6$export$f366c2c8a792cce6;
module.exports["isSSRPreview"] = $d8a1d04f617229a6$export$dea79d05143ccf4;
module.exports["getAndCacheRemotePreview"] = $d8a1d04f617229a6$export$49721bcc26fb9388;
module.exports["getAndCacheLocalPreview"] = $d8a1d04f617229a6$export$98e935d981c884d;

});

parcelRegister("a0nKQ", function(module, exports) {

var $jx0Wk = parcelRequire("jx0Wk");

const $017d76cb8cfc0c2c$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $017d76cb8cfc0c2c$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}
const $017d76cb8cfc0c2c$export$b7e8ee3f7a41459 = new $017d76cb8cfc0c2c$export$7b50526c091bb915((0, $jx0Wk.createObjectURLCache)());
module.exports["mediaFilePreviewCache"] = $017d76cb8cfc0c2c$export$b7e8ee3f7a41459;

});

parcelRegister("jx0Wk", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

const $ff738ace400485a0$export$36d0f9859761643d = 50;
/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * The oldest entry is kept if `shouldEvict` returns false.
 */ class $ff738ace400485a0$var$EvictionLRUCache extends (0, $lPEt0.LRUMap) {
    shift() {
        const oldest = this.oldest;
        if (oldest && this.shouldEvict && !this.shouldEvict([
            oldest.key,
            oldest.value
        ])) return undefined;
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = void 0;
        this.onEvict = void 0;
        this.shouldEvict = options?.shouldEvict;
        this.onEvict = options?.onEvict;
    }
}
class $ff738ace400485a0$export$75d1c8c9ba1d0773 {
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = removed?.dataURI.split('#')[0];
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
    constructor(size){
        this.cache = void 0;
        this.activeRefs = new Map();
        this.cache = new $ff738ace400485a0$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = entry[1].dataURI.split('#')[0];
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
}
const $ff738ace400485a0$export$ba71be67d5c32535 = ()=>new $ff738ace400485a0$export$75d1c8c9ba1d0773($ff738ace400485a0$export$36d0f9859761643d);
module.exports["createObjectURLCache"] = $ff738ace400485a0$export$ba71be67d5c32535;

});

parcelRegister("1FrxG", function(module, exports) {

var $nfEzS = parcelRequire("nfEzS");


var $edV3B = parcelRequire("edV3B");


var $j6hoF = parcelRequire("j6hoF");


var $599Ht = parcelRequire("599Ht");

const $326902bd67ba4ecb$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $326902bd67ba4ecb$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $edV3B.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $j6hoF.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $326902bd67ba4ecb$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $599Ht.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $j6hoF.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $326902bd67ba4ecb$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $j6hoF.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $nfEzS.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $326902bd67ba4ecb$var$getImageLocalPreview(value);
            case 'video':
                return $326902bd67ba4ecb$var$getVideoLocalPreview(value);
            default:
                throw new (0, $j6hoF.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $j6hoF.LocalPreviewError)('local-preview-unsupported');
};
const $326902bd67ba4ecb$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $j6hoF.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};
module.exports["isSupportedLocalPreview"] = $326902bd67ba4ecb$export$1fa85b75e8662d54;
module.exports["getLocalPreview"] = $326902bd67ba4ecb$export$3d6ed68e437b8c99;
module.exports["getRemotePreview"] = $326902bd67ba4ecb$export$bfe20bd01db02b3;

});

parcelRegister("edV3B", function(module, exports) {

var $4n1J4 = parcelRequire("4n1J4");


var $je5JP = parcelRequire("je5JP");


var $if407 = parcelRequire("if407");


var $3Seye = parcelRequire("3Seye");

const { Orientation: $aa4e7022d1781569$var$Orientation, XResolution: $aa4e7022d1781569$var$XResolution } = (0, $4n1J4.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $aa4e7022d1781569$var$DPI_WEB_BASELINE = 72;
async function $aa4e7022d1781569$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $aa4e7022d1781569$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $aa4e7022d1781569$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $aa4e7022d1781569$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $aa4e7022d1781569$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
     * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
     * So we are only relying on X axis.
     */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $aa4e7022d1781569$var$DPI_WEB_BASELINE;
        else return $aa4e7022d1781569$export$268f92356524130b(tags, $aa4e7022d1781569$var$XResolution, $aa4e7022d1781569$var$DPI_WEB_BASELINE) / $aa4e7022d1781569$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $aa4e7022d1781569$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$aa4e7022d1781569$var$Orientation]) {
        const tagValue = tags[$aa4e7022d1781569$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $4n1J4.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $aa4e7022d1781569$export$67689507e8404821(file) {
    const tags = await (0, $je5JP.readImageMetaTags)(file);
    return $aa4e7022d1781569$var$getOrientationFromTags(tags);
}
function $aa4e7022d1781569$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $aa4e7022d1781569$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $aa4e7022d1781569$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $je5JP.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $aa4e7022d1781569$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $aa4e7022d1781569$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
   * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
   * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
   * We've also received JAC tickets reporting incorrect dimensions because of this
   * https://jira.atlassian.com/browse/CONFCLOUD-78275
   * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
   */ try {
        const img = await (0, $if407.loadImage)(src);
        const { width: width, height: height } = (0, $if407.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}
module.exports["getImageInfo"] = $aa4e7022d1781569$export$2176b0e68c10508f;
module.exports["getOrientation"] = $aa4e7022d1781569$export$67689507e8404821;

});

parcelRegister("4n1J4", function(module, exports) {
var $b9c1a9cc5ecd1c95$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $b9c1a9cc5ecd1c95$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $b9c1a9cc5ecd1c95$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    // none
    'top-right': 2,
    // flip horizontal
    'bottom-right': 3,
    // rotate 180
    'bottom-left': 4,
    // flip vertical
    'left-top': 5,
    // transpose
    'right-top': 6,
    // rotate 90
    'right-bottom': 7,
    // transverse
    'left-bottom': 8 // rotate 270
};
module.exports["ImageType"] = $b9c1a9cc5ecd1c95$export$48c85e6e32ef0825;
module.exports["SupportedImageMetaTag"] = $b9c1a9cc5ecd1c95$export$e369bb48cf33e564;
module.exports["ExifOrientation"] = $b9c1a9cc5ecd1c95$export$f6ea0c89fd7d156;

});

parcelRegister("je5JP", function(module, exports) {

var $4n1J4 = parcelRequire("4n1J4");


var $lFcXW = parcelRequire("lFcXW");


var $4IlAI = parcelRequire("4IlAI");


var $7kpm3 = parcelRequire("7kpm3");

async function $63ab4f0fc6bf0709$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $4n1J4.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $4IlAI.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $7kpm3.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $4n1J4.ImageType).JPEG) return await (0, $lFcXW.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}
module.exports["readImageMetaTags"] = $63ab4f0fc6bf0709$export$41982b5c7acb23c4;

});

parcelRegister("lFcXW", function(module, exports) {

var $4n1J4 = parcelRequire("4n1J4");

const { XResolution: $c25f01645762d82d$var$XResolution, YResolution: $c25f01645762d82d$var$YResolution } = (0, $4n1J4.SupportedImageMetaTag);
let $c25f01645762d82d$var$loadImage;

function $c25f01645762d82d$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$c25f01645762d82d$var$loadImage) {
            const module = await (parcelRequire("9XMvT"));
            $c25f01645762d82d$var$loadImage = module.default || module;
        }
        $c25f01645762d82d$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $c25f01645762d82d$var$XResolution || key === $c25f01645762d82d$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}
module.exports["readJPEGExifMetaData"] = $c25f01645762d82d$export$556b2ccec62d7f2a;

});

parcelRegister("9XMvT", function(module, exports) {

let $740f41841e0aae08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $740f41841e0aae08$var$load("jZpW9").then(()=>parcelRequire('fEeWF'));

});

parcelRegister("4IlAI", function(module, exports) {

var $if407 = parcelRequire("if407");

let $e61e27988ac2aa89$var$pngChunksExtract;

async function $e61e27988ac2aa89$export$5fb37736440fca6f(file) {
    if (!$e61e27988ac2aa89$var$pngChunksExtract) {
        const module = await (parcelRequire("7TUsv"));
        $e61e27988ac2aa89$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $if407.fileToArrayBuffer)(file);
    const chunks = $e61e27988ac2aa89$var$pngChunksExtract(buffer);
    return await $e61e27988ac2aa89$export$9185743fdd58ce45(chunks);
}
async function $e61e27988ac2aa89$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
   * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
   * Order of every chunk is not guaranteed.
   * And both iTXt and pHYs are Ancillary chunks.
   */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
     * iTXt contains the useful XMP/XML string data of meta tags
     */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
     * Pixels per unit, X axis: 4 bytes (unsigned integer)
     * Pixels per unit, Y axis: 4 bytes (unsigned integer)
     * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
     */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}
module.exports["readPNGXMPMetaData"] = $e61e27988ac2aa89$export$5fb37736440fca6f;

});

parcelRegister("if407", function(module, exports) {

var $90EXt = parcelRequire("90EXt");


var $gCL8n = parcelRequire("gCL8n");


var $6lknI = parcelRequire("6lknI");


var $fGSwx = parcelRequire("fGSwx");


var $8BODT = parcelRequire("8BODT");


var $54wdw = parcelRequire("54wdw");


var $jTyNF = parcelRequire("jTyNF");


var $l8FBD = parcelRequire("l8FBD");


var $cSPDT = parcelRequire("cSPDT");


var $lhYzt = parcelRequire("lhYzt");


var $3Ll8s = parcelRequire("3Ll8s");


var $67SYT = parcelRequire("67SYT");


var $jZpwZ = parcelRequire("jZpwZ");


var $dc5oR = parcelRequire("dc5oR");


var $42Fpa = parcelRequire("42Fpa");


var $cwkAT = parcelRequire("cwkAT");

function $5ccb4041b71070e3$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $5ccb4041b71070e3$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $5ccb4041b71070e3$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $5ccb4041b71070e3$export$849633012686f7ee(file)
    };
}
async function $5ccb4041b71070e3$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $5ccb4041b71070e3$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $5ccb4041b71070e3$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $5ccb4041b71070e3$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $5ccb4041b71070e3$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $5ccb4041b71070e3$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $5ccb4041b71070e3$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSPDT)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Ll8s)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSPDT)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhYzt)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l8FBD)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dc5oR)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jZpwZ)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    }
];
function $5ccb4041b71070e3$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $5ccb4041b71070e3$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $cwkAT.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8BODT)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($54wdw)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jTyNF)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}
module.exports["dataURItoFile"] = $5ccb4041b71070e3$export$80d19edb7b1ae293;
module.exports["fileToDataURI"] = $5ccb4041b71070e3$export$849633012686f7ee;
module.exports["getFileInfo"] = $5ccb4041b71070e3$export$ca39f27fe4f7d9b4;
module.exports["fileToArrayBuffer"] = $5ccb4041b71070e3$export$956310555b96755a;
module.exports["loadImage"] = $5ccb4041b71070e3$export$fe58198efe02b173;
module.exports["readImageNaturalOrientationFromDOM"] = $5ccb4041b71070e3$export$325d46491952db2d;
module.exports["findParentByClassname"] = $5ccb4041b71070e3$export$89ff65f1d45dfb03;
module.exports["getMimeIcon"] = $5ccb4041b71070e3$export$61a1de0822e2820;

});

parcelRegister("90EXt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $01b15a5d4b81fd5c$var$_react = $01b15a5d4b81fd5c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $01b15a5d4b81fd5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01b15a5d4b81fd5c$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $01b15a5d4b81fd5c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$01b15a5d4b81fd5c$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $01b15a5d4b81fd5c$var$_default = module.exports.default = $01b15a5d4b81fd5c$var$PdfDocument24Icon;

});

parcelRegister("adk2f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3cb2d8c9faefdb0f$var$iconStyles = null;
const $3cb2d8c9faefdb0f$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _0mcUfEey7F _2kxbLJey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg _0mcUfEoWWg _2kxbLJoWWg",
    large: "_39xV02Uofl _0jFU0VUofl _0mcUfEUofl _2kxbLJUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _0mcUfEpJKa _2kxbLJpJKa"
}; /**
    * For windows high contrast mode
    */ 
const $3cb2d8c9faefdb0f$var$baseHcmStyles = null;
const $3cb2d8c9faefdb0f$var$primaryEqualsSecondaryHcmStyles = null;
const $3cb2d8c9faefdb0f$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $3cb2d8c9faefdb0f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Icon(props) {
    const $ = (0, $bDgLe.c)(24);
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: t0, secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const primaryColor = t0 === undefined ? "currentColor" : t0;
    let t1;
    if ($[0] !== Glyph || $[1] !== dangerouslySetGlyph) {
        t1 = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
                role: "presentation"
            }) : null
        };
        $[0] = Glyph;
        $[1] = dangerouslySetGlyph;
        $[2] = t1;
    } else t1 = $[2];
    const glyphProps = t1;
    let t2;
    if ($[3] !== height || $[4] !== width) {
        t2 = width && height ? {
            width: width + "px",
            height: height + "px"
        } : null;
        $[3] = height;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    const customDimensions = t2;
    const t3 = `icon-${testId}`;
    const t4 = label ? "img" : undefined;
    const t5 = label ? label : undefined;
    const t6 = label ? undefined : true;
    let t7;
    if ($[6] !== UNSAFE_margin || $[7] !== customDimensions || $[8] !== primaryColor || $[9] !== secondaryColor) {
        t7 = {
            ...customDimensions,
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor,
            margin: UNSAFE_margin
        };
        $[6] = UNSAFE_margin;
        $[7] = customDimensions;
        $[8] = primaryColor;
        $[9] = secondaryColor;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    const t9 = primaryColor === secondaryColor && "_2W1hK9k5Cz";
    const t10 = secondaryColor === "transparent" && "_0ibj0wjOvk";
    const t11 = size && $3cb2d8c9faefdb0f$var$sizeStyles[size];
    let t12;
    if ($[11] !== t10 || $[12] !== t11 || $[13] !== t9) {
        t12 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _03DdiXlfZc _26BoRw7dHp _4hYdNbnQyn _4ktURhnQyn _1QzFdLN91d _2S9CkHN91d _3Krhx8bMfJ _0fvd5AdkvI _1O5n5yYbGa _4rPVFiUWqv _3J08zt98eZ",
            "_1hdADdMFyn _16qGwyTxK4 _4l7oXfk5Cz",
            t9,
            t10,
            t11
        ]);
        $[11] = t10;
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== glyphProps || $[16] !== t12 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "data-vc": t3,
            role: t4,
            "aria-label": t5,
            "aria-hidden": t6,
            style: t8,
            ...glyphProps,
            className: t12
        });
        $[15] = glyphProps;
        $[16] = t12;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = testId;
        $[23] = t13;
    } else t13 = $[23];
    return t13;
} : function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _03DdiXlfZc _26BoRw7dHp _4hYdNbnQyn _4ktURhnQyn _1QzFdLN91d _2S9CkHN91d _3Krhx8bMfJ _0fvd5AdkvI _1O5n5yYbGa _4rPVFiUWqv _3J08zt98eZ",
            "_1hdADdMFyn _16qGwyTxK4 _4l7oXfk5Cz",
            primaryColor === secondaryColor && "_2W1hK9k5Cz",
            secondaryColor === 'transparent' && "_0ibj0wjOvk",
            size && $3cb2d8c9faefdb0f$var$sizeStyles[size]
        ])
    });
});
var $3cb2d8c9faefdb0f$export$2e2bcd8739ae039 = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;
module.exports["Icon"] = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;

});

parcelRegister("gCL8n", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1a4c1cb74e7fe66$var$_react = $c1a4c1cb74e7fe66$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c1a4c1cb74e7fe66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1a4c1cb74e7fe66$var$Gif24Icon = (props)=>/*#__PURE__*/ $c1a4c1cb74e7fe66$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1a4c1cb74e7fe66$var$Gif24Icon.displayName = 'Gif24Icon';
var $c1a4c1cb74e7fe66$var$_default = module.exports.default = $c1a4c1cb74e7fe66$var$Gif24Icon;

});

parcelRegister("6lknI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $49e483933a21e023$var$_react = $49e483933a21e023$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $49e483933a21e023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $49e483933a21e023$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $49e483933a21e023$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$49e483933a21e023$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $49e483933a21e023$var$_default = module.exports.default = $49e483933a21e023$var$PowerpointPresentation24Icon;

});

parcelRegister("fGSwx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b6c5128728f95629$var$_react = $b6c5128728f95629$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $b6c5128728f95629$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b6c5128728f95629$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $b6c5128728f95629$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b6c5128728f95629$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $b6c5128728f95629$var$_default = module.exports.default = $b6c5128728f95629$var$WordDocument24Icon;

});

parcelRegister("8BODT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64490ff67d091387$var$_react = $64490ff67d091387$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $64490ff67d091387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64490ff67d091387$var$Sketch24Icon = (props)=>/*#__PURE__*/ $64490ff67d091387$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$64490ff67d091387$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $64490ff67d091387$var$_default = module.exports.default = $64490ff67d091387$var$Sketch24Icon;

});

parcelRegister("54wdw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3b165123a3076159$var$_react = $3b165123a3076159$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $3b165123a3076159$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b165123a3076159$var$Figma24Icon = (props)=>/*#__PURE__*/ $3b165123a3076159$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$3b165123a3076159$var$Figma24Icon.displayName = 'Figma24Icon';
var $3b165123a3076159$var$_default = module.exports.default = $3b165123a3076159$var$Figma24Icon;

});

parcelRegister("jTyNF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e7be25f42053d936$var$_react = $e7be25f42053d936$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $e7be25f42053d936$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e7be25f42053d936$var$Executable24Icon = (props)=>/*#__PURE__*/ $e7be25f42053d936$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e7be25f42053d936$var$Executable24Icon.displayName = 'Executable24Icon';
var $e7be25f42053d936$var$_default = module.exports.default = $e7be25f42053d936$var$Executable24Icon;

});

parcelRegister("l8FBD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f63a9e6c3f95b37c$var$_react = $f63a9e6c3f95b37c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f63a9e6c3f95b37c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f63a9e6c3f95b37c$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $f63a9e6c3f95b37c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f63a9e6c3f95b37c$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $f63a9e6c3f95b37c$var$_default = module.exports.default = $f63a9e6c3f95b37c$var$GoogleDoc24Icon;

});

parcelRegister("cSPDT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9612964eb3dd5544$var$_react = $9612964eb3dd5544$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $9612964eb3dd5544$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9612964eb3dd5544$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $9612964eb3dd5544$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9612964eb3dd5544$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $9612964eb3dd5544$var$_default = module.exports.default = $9612964eb3dd5544$var$GoogleForm24Icon;

});

parcelRegister("lhYzt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f7fa2ba87c6278a2$var$_react = $f7fa2ba87c6278a2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f7fa2ba87c6278a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7fa2ba87c6278a2$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $f7fa2ba87c6278a2$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f7fa2ba87c6278a2$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $f7fa2ba87c6278a2$var$_default = module.exports.default = $f7fa2ba87c6278a2$var$GoogleSheet24Icon;

});

parcelRegister("3Ll8s", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd627f5b12c5946$var$_react = $2bd627f5b12c5946$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2bd627f5b12c5946$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd627f5b12c5946$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $2bd627f5b12c5946$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd627f5b12c5946$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $2bd627f5b12c5946$var$_default = module.exports.default = $2bd627f5b12c5946$var$GoogleSlide24Icon;

});

parcelRegister("67SYT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $475e0ba3e7829a3a$var$_react = $475e0ba3e7829a3a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $475e0ba3e7829a3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $475e0ba3e7829a3a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $475e0ba3e7829a3a$var$_default = module.exports.default = $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon;

});

parcelRegister("jZpwZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e8d784bfa3b30ee1$var$_react = $e8d784bfa3b30ee1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $e8d784bfa3b30ee1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8d784bfa3b30ee1$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $e8d784bfa3b30ee1$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e8d784bfa3b30ee1$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $e8d784bfa3b30ee1$var$_default = module.exports.default = $e8d784bfa3b30ee1$var$Spreadsheet24Icon;

});

parcelRegister("dc5oR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $99b095a9e65218fe$var$_react = $99b095a9e65218fe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $99b095a9e65218fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $99b095a9e65218fe$var$Presentation24Icon = (props)=>/*#__PURE__*/ $99b095a9e65218fe$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$99b095a9e65218fe$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $99b095a9e65218fe$var$_default = module.exports.default = $99b095a9e65218fe$var$Presentation24Icon;

});

parcelRegister("42Fpa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2f17777bbdd9049a$var$_react = $2f17777bbdd9049a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2f17777bbdd9049a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f17777bbdd9049a$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2f17777bbdd9049a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2f17777bbdd9049a$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2f17777bbdd9049a$var$_default = module.exports.default = $2f17777bbdd9049a$var$SourceCode24Icon;

});

parcelRegister("cwkAT", function(module, exports) {
function $c54e139f1f15e146$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $c54e139f1f15e146$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $c54e139f1f15e146$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $c54e139f1f15e146$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $c54e139f1f15e146$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $c54e139f1f15e146$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $c54e139f1f15e146$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain') return 'text';
            return null;
    }
}
module.exports["getExtension"] = $c54e139f1f15e146$export$78d71f9ed5534abe;
module.exports["isCodeViewerItem"] = $c54e139f1f15e146$export$bb139b46f345ca28;
module.exports["getLanguageType"] = $c54e139f1f15e146$export$ba4368c844580f9e;

});

parcelRegister("7TUsv", function(module, exports) {

let $5c09770087093396$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c09770087093396$var$load("5ViqD").then(()=>parcelRequire('eOunc'));

});

parcelRegister("7kpm3", function(module, exports) {
function $1cae499d3986977a$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}
module.exports["parseXMPMetaData"] = $1cae499d3986977a$export$55c3bc9841b19de2;

});

parcelRegister("3Seye", function(module, exports) {
const $c719ea4a1ff2b93b$var$ORIENT_TRANSFORMS = {
    1: 'none',
    // Horizontal (normal)
    2: 'rotateY(180deg)',
    // Mirror horizontal
    3: 'rotate(180deg)',
    // Rotate 180
    4: 'rotate(180deg) rotateY(180deg)',
    // Mirror vertical
    5: 'rotate(270deg) rotateY(180deg)',
    // Mirror horizontal and rotate 270 CW
    6: 'rotate(90deg)',
    // Rotate 90 CW
    7: 'rotate(90deg) rotateY(180deg)',
    // Mirror horizontal and rotate 90 CW
    8: 'rotate(270deg)' // Rotate 270 CW
};
const $c719ea4a1ff2b93b$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $c719ea4a1ff2b93b$export$43142f95b8de7a91 = (orientation)=>{
    return $c719ea4a1ff2b93b$var$ORIENT_TRANSFORMS[orientation];
};
module.exports["isRotated"] = $c719ea4a1ff2b93b$export$8af433705f41088f;
module.exports["getCssFromImageOrientation"] = $c719ea4a1ff2b93b$export$43142f95b8de7a91;

});

parcelRegister("599Ht", function(module, exports) {
const $e9eb3851d008a755$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["takeSnapshot"] = $e9eb3851d008a755$export$4269d30173168e5c;

});

parcelRegister("l32w2", function(module, exports) {
const $df091675c0f8d5b7$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $df091675c0f8d5b7$export$d26005e8749921c9 = 'mediaCountSsr';
const $df091675c0f8d5b7$export$7aeb4eab53a57df7 = 'performanceEntries';
const $df091675c0f8d5b7$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $df091675c0f8d5b7$var$MAX_EAGER_LOAD_COUNT = 6;
function $df091675c0f8d5b7$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $df091675c0f8d5b7$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $df091675c0f8d5b7$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $df091675c0f8d5b7$var$dashed = (param)=>param ? `-${param}` : '';
const $df091675c0f8d5b7$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$df091675c0f8d5b7$var$dashed(collectionName)}${$df091675c0f8d5b7$var$dashed(occurrenceKey)}${$df091675c0f8d5b7$var$dashed(resizeMode)}`;
const $df091675c0f8d5b7$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = $df091675c0f8d5b7$export$a47fb462a08de82f(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: $df091675c0f8d5b7$var$MAX_EAGER_LOAD_COUNT
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $df091675c0f8d5b7$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $df091675c0f8d5b7$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });
module.exports["getMediaCardSSR"] = $df091675c0f8d5b7$export$ede93d4564eaa8da;
module.exports["getKey"] = $df091675c0f8d5b7$export$a47fb462a08de82f;
module.exports["generateScriptProps"] = $df091675c0f8d5b7$export$de7c49925e44d75d;

});

parcelRegister("a4SEC", function(module, exports) {

var $l32w2 = parcelRequire("l32w2");

const $b4afaddd3336dcb8$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $l32w2.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $l32w2.getKey)(identifier, resizeMode)];
};
module.exports["getSSRData"] = $b4afaddd3336dcb8$export$d3a890b0f7844b6f;

});

parcelRegister("gE3xj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c46a7830eda9de64$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
const $c46a7830eda9de64$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = current?.width || 0;
    const nextWidth = next?.width || 0;
    return currentWidth < nextWidth;
};
/** Verifies if the current screen is retina display */ function $c46a7830eda9de64$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $c46a7830eda9de64$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $c46a7830eda9de64$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $c46a7830eda9de64$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["isBigger"] = $c46a7830eda9de64$export$912a00e9a5470d9a;
module.exports["isWider"] = $c46a7830eda9de64$export$ae6224430098bc5f;
module.exports["createRequestDimensions"] = $c46a7830eda9de64$export$3063221e86a58f9;
module.exports["useCurrentValueRef"] = $c46a7830eda9de64$export$b3e10e1f0fbb71db;

});

parcelRegister("9XiTB", function(module, exports) {
/* CustomTooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1B9Aq = parcelRequire("1B9Aq");

const $783fa8effd140dfb$var$styles = {
    tooltip: "_0bjKvDKxmn _0KLXrulfZc _2OUyjtGk8v _1UtDYzy7kJ _1EqgXlBfNa _46hvQm2ADO _0xmtko2ADO _0LQT5E8HPE _03SyCP8HPE _3W2Oc8wPeg"
};
const $783fa8effd140dfb$export$9f95857259638e76 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...rest }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $1B9Aq.default), {
        ...rest,
        ref: ref,
        className: (0, $hekY6.default)([
            $783fa8effd140dfb$var$styles.tooltip
        ])
    }, children);
});
module.exports["CustomTooltip"] = $783fa8effd140dfb$export$9f95857259638e76;

});

parcelRegister("dX04h", function(module, exports) {
/**
 * @generated SignedSource<<d6992bd9610df4651de8880c883bc222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c0c857a89b3d92e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraComponentsField",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            },
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "components",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "componentId"
                                    },
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    };
}();
$4c0c857a89b3d92e$var$node.hash = "5e97da6f23797a48e135e5fe767dafc6";
var $4c0c857a89b3d92e$export$2e2bcd8739ae039 = $4c0c857a89b3d92e$var$node;



var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $1JERl = parcelRequire("1JERl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $8wMiv = parcelRequire("8wMiv");


var $7nqlz = parcelRequire("7nqlz");


var $5r5PB = parcelRequire("5r5PB");


var $gVzkK = parcelRequire("gVzkK");


var $2v5cF = parcelRequire("2v5cF");

const $c2dc2ab506db25cf$var$messages = (0, $kSwu1.defineMessages)({
    showMoreTooltip: {
        id: "jira.platform-fields.components.show-more",
        defaultMessage: "Show more"
    },
    none: {
        id: "jira.jira-platform-fields.components.none",
        defaultMessage: "None"
    },
    isRequiredError: {
        id: "jira.jira-platform-fields.components.is-required-error",
        defaultMessage: "{fieldName} is required"
    }
});
const $c2dc2ab506db25cf$var$styles = {
    container: "_39xV02N91d _3138424F84",
    readView: "_39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb2ADO _2Zuz6Q2ADO",
    editableReadView: "_0wOv4Q7zJH _0jFU0VnlTt"
};
const $c2dc2ab506db25cf$var$ReadView = /*#__PURE__*/ (0, $cozmU.memo)(({ options: options, isEditable: isEditable })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($c2dc2ab506db25cf$var$styles.readView, isEditable && $c2dc2ab506db25cf$var$styles.editableReadView)
    }, options.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "start",
        color: "color.text.subtle",
        maxLines: 1
    }, formatMessage($c2dc2ab506db25cf$var$messages.none)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7nqlz.default), {
        items: options.map((opt)=>({
                key: opt.value,
                name: opt.label,
                isColored: false
            })),
        ItemComponent: (0, $5r5PB.TagItem),
        PopupContentWrapper: (0, $5r5PB.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage($c2dc2ab506db25cf$var$messages.showMoreTooltip),
        isHoverPopoverEnabled: true
    }));
});
const $c2dc2ab506db25cf$export$c2497a01ac2e24b9 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $4c0c857a89b3d92e$export$2e2bcd8739ae039), field);
    const fieldName = data?.name;
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const validate = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: fieldName,
        fieldTypeForAnalytics: 'ComponentsField'
    });
    const allowedOptions = (0, $cozmU.useMemo)(()=>{
        const edges = data?.components?.edges;
        return edges?.filter(Boolean).map((edge)=>{
            const node = edge?.node;
            const value = String(node?.componentId ?? '');
            const label = node?.name ?? value;
            return {
                label: label,
                value: value
            };
        }).filter((o)=>o.value) ?? [];
    }, [
        data?.components?.edges
    ]);
    const selectedOptions = (0, $cozmU.useMemo)(()=>{
        if (Array.isArray(fieldValue) && fieldValue.length > 0) return allowedOptions.filter((o)=>fieldValue.includes(o.value) || fieldValue.includes(o.label));
        return [];
    }, [
        fieldValue,
        allowedOptions
    ]);
    const handleOnConfirm = (0, $cozmU.useCallback)((newValues)=>{
        onChange?.(newValues.length > 0 ? newValues.map((opt)=>opt.value) : null);
    }, [
        onChange
    ]);
    const readView = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c2dc2ab506db25cf$var$ReadView, {
            options: selectedOptions,
            isEditable: isEditable
        }), [
        selectedOptions,
        isEditable
    ]);
    if (!isEditable) return readView;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c2dc2ab506db25cf$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
        defaultValue: selectedOptions,
        readView: ()=>readView,
        editView: ({ errorMessage: errorMessage, isInvalid: isInvalid, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2v5cF.ValidationPopup), {
                errorMessage: errorMessage,
                showInvalidPopup: Boolean(isInvalid && errorMessage),
                trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        ref: ref
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                        ...fieldProps,
                        menuPortalTarget: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? undefined : document.body,
                        menuPosition: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'fixed' : 'absolute',
                        menuPlacement: "auto",
                        styles: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? {
                            menu: (base)=>({
                                    ...base,
                                    zIndex: (0, $8wMiv.layers).modal()
                                }),
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: (0, $8wMiv.layers).modal()
                                })
                        } : undefined,
                        label: fieldName,
                        isMulti: true,
                        autoFocus: true,
                        options: allowedOptions,
                        getOptionValue: (o)=>o.value,
                        getOptionLabel: (o)=>o.label,
                        placeholder: formatMessage($c2dc2ab506db25cf$var$messages.showMoreTooltip),
                        isInvalid: isInvalid
                    }))
            }),
        validate: validate,
        onConfirm: handleOnConfirm,
        hideActionButtons: true,
        readViewFitContainerWidth: true,
        editButtonLabel: selectedOptions.map((o)=>o.label).join(', ') ?? undefined
    }));
});
module.exports["JiraComponentsField"] = $c2dc2ab506db25cf$export$c2497a01ac2e24b9;

});

parcelRegister("nti55", function(module, exports) {
/**
 * @generated SignedSource<<84356189d45142eadf064d074a1a11ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0be7eb540c65803$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraDatePickerField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "date"
        }
    ],
    "type": "JiraDatePickerField"
};
$b0be7eb540c65803$var$node.hash = "2445a9071e3d7af6ea8c192198c3452a";
var $b0be7eb540c65803$export$2e2bcd8739ae039 = $b0be7eb540c65803$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $lF9wS = parcelRequire("lF9wS");


var $3Yuw9 = parcelRequire("3Yuw9");

const $9a9f98c487a48cb2$var$messages = (0, $kSwu1.defineMessages)({
    datePickerLabel: {
        id: "jira.jira.jira-platform-fields.jira-date-picker-field.date-picker-label",
        defaultMessage: "Date"
    }
});
const $9a9f98c487a48cb2$export$4cf4255bcded4e03 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $b0be7eb540c65803$export$2e2bcd8739ae039), field);
    const { isRequired: isRequired } = data?.fieldConfig || {};
    const isEditable = data?.fieldConfig?.isEditable && isFieldEditable;
    const defaultValue = data?.date;
    const currentValue = typeof fieldValue === 'string' ? fieldValue : null;
    const renderPicker = (0, $cozmU.useCallback)((renderPickerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
            ...renderPickerProps,
            label: formatMessage($9a9f98c487a48cb2$var$messages.datePickerLabel),
            shouldShowCalendarButton: true
        }), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Yuw9.BaseDateField), {
        fieldName: data?.name,
        labelText: formatMessage($9a9f98c487a48cb2$var$messages.datePickerLabel),
        isEditable: !!isEditable,
        isRequired: !!isRequired,
        currentValue: currentValue,
        defaultValue: defaultValue,
        includeTime: false,
        onChange: onChange,
        renderPicker: renderPicker
    });
});
module.exports["JiraDatePickerField"] = $9a9f98c487a48cb2$export$4cf4255bcded4e03;

});

parcelRegister("hzIKQ", function(module, exports) {
/**
 * @generated SignedSource<<0eb8812e06d8920ded072bdf4fb161e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2360533ab0768bf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraDateTimePickerField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$c2360533ab0768bf$var$node.hash = "7738bd8ae6202cd4fdb8449d7a95909d";
var $c2360533ab0768bf$export$2e2bcd8739ae039 = $c2360533ab0768bf$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $57alK = parcelRequire("57alK");


var $3Yuw9 = parcelRequire("3Yuw9");

const $ce28e24b28b28d37$var$messages = (0, $kSwu1.defineMessages)({
    dateTimePickerLabel: {
        id: "jira.jira.jira-platform-fields.jira-date-time-picker-field.date-time-picker-label",
        defaultMessage: "Date and time"
    }
});
// Styles for the individual select components inside the date and time pickers
const $ce28e24b28b28d37$var$selectPropsStyles = {
    control: (base)=>({
            ...base,
            // For cleaner UI/borders, leave outline responsibility to outer input element (DateTimePicker)
            boxShadow: 'none',
            // Input height dynamically changes based on presence of value, so we need to set a fixed height
            height: '36px',
            // 40px - 2*2px outer border
            minHeight: '36px' // overrides default min-height of 40px
        })
};
const $ce28e24b28b28d37$export$918c6b245d9e927a = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $c2360533ab0768bf$export$2e2bcd8739ae039), field);
    const { isRequired: isRequired } = data?.fieldConfig || {};
    const isEditable = data?.fieldConfig?.isEditable && isFieldEditable;
    const defaultValue = data?.dateTime;
    const currentValue = typeof fieldValue === 'string' ? fieldValue : null;
    const renderPicker = (0, $cozmU.useCallback)(({ placeholder: placeholder, ...renderPickerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57alK.default), {
            ...renderPickerProps,
            innerProps: {
                style: {
                    borderWidth: "var(--ds-border-width-focused, 2px)",
                    ...!isRequired || !!currentValue ? {
                        borderColor: "var(--ds-border-focused, #4688EC)"
                    } : {}
                }
            },
            datePickerProps: {
                placeholder: placeholder,
                label: formatMessage($ce28e24b28b28d37$var$messages.dateTimePickerLabel),
                selectProps: {
                    styles: $ce28e24b28b28d37$var$selectPropsStyles
                }
            },
            timePickerProps: {
                selectProps: {
                    styles: $ce28e24b28b28d37$var$selectPropsStyles
                }
            }
        }), [
        formatMessage,
        isRequired,
        currentValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Yuw9.BaseDateField), {
        fieldName: data?.name,
        labelText: formatMessage($ce28e24b28b28d37$var$messages.dateTimePickerLabel),
        isEditable: !!isEditable,
        isRequired: !!isRequired,
        currentValue: currentValue,
        defaultValue: defaultValue,
        includeTime: true,
        onChange: onChange,
        renderPicker: renderPicker
    });
});
module.exports["JiraDateTimePickerField"] = $ce28e24b28b28d37$export$918c6b245d9e927a;

});

parcelRegister("9Gvh5", function(module, exports) {
/* JiraIssueLinkField.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $5ba9aef3a0925159$var$styles = {
    inline: "_0LQT5E2ADO _03SyCP2ADO"
};
const $5ba9aef3a0925159$export$72f5e617934f9459 = ({ fieldValue: fieldValue })=>{
    if (!fieldValue) return null;
    if (Array.isArray(fieldValue)) {
        const fieldValueAsIssueLinks = fieldValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            xcss: $5ba9aef3a0925159$var$styles.inline
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            size: "medium"
        }, `${fieldValueAsIssueLinks.map((item)=>item.outwardIssue.key).join(', ')}`));
    }
    const fieldValueAsIssueLink = fieldValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        xcss: $5ba9aef3a0925159$var$styles.inline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1,
        size: "medium"
    }, `${fieldValueAsIssueLink.outwardIssue.key}`));
};
module.exports["JiraIssueLinkField"] = $5ba9aef3a0925159$export$72f5e617934f9459;

});

parcelRegister("hTOEa", function(module, exports) {
/**
 * @generated SignedSource<<24fee5ed14561a7eaac763058834d973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $069cceea82ced260$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraLabelsField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraLabelsField"
};
$069cceea82ced260$var$node.hash = "abec5e1ff0707b5a460966357bebf690";
var $069cceea82ced260$export$2e2bcd8739ae039 = $069cceea82ced260$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $iMnC5 = parcelRequire("iMnC5");


var $7nqlz = parcelRequire("7nqlz");


var $5r5PB = parcelRequire("5r5PB");


var $1UWNP = parcelRequire("1UWNP");


var $iPm7V = parcelRequire("iPm7V");




const $a2556c4014d4832f$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $iPm7V.HASH_RANDOMISER) + text.charCodeAt(i)) % (0, $iPm7V.MOD_VALUE);
    return hashValue;
};





const $fc6aa4e955407e6e$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $iPm7V.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};


const $b9ae3302c27a1c4f$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $a2556c4014d4832f$export$e352defce701b36e)(option);
        const randomIndex = (0, $fc6aa4e955407e6e$export$cb0dffe2d2ae675a)(hashValue);
        return (0, $iPm7V.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $iPm7V.GREY_META).name;
};
const $b9ae3302c27a1c4f$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $a2556c4014d4832f$export$e352defce701b36e)(option);
        const randomIndex = (0, $fc6aa4e955407e6e$export$cb0dffe2d2ae675a)(hashValue);
        return (0, $iPm7V.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $iPm7V.GREY_META).tagColor;
};
const $b9ae3302c27a1c4f$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($b9ae3302c27a1c4f$export$97056d4b28203ee9);
const $b9ae3302c27a1c4f$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($b9ae3302c27a1c4f$export$a3f5334e7a13e57a);



var $gBLwY = parcelRequire("gBLwY");

const $1ae5ea0a31a63ede$var$messages = (0, $kSwu1.defineMessages)({
    showMoreTooltip: {
        id: "ai-first-create.jiraLabelsField.showMoreTooltip",
        defaultMessage: "Show more labels"
    }
});
const $1ae5ea0a31a63ede$var$styles = {
    readOnlyViewContainer: "_2Zuz6Q2ADO _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUF4f _39xV02N91d"
};
const $1ae5ea0a31a63ede$export$4f1cef997d4897b3 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, onChange: _onChange })=>{
    const data = (0, $6SsN4.useFragment)((0, $069cceea82ced260$export$2e2bcd8739ae039), field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labels = Array.isArray(fieldValue) ? fieldValue.filter((label)=>typeof label === 'string') : [];
    if (labels.length === 0) return null;
     // TODO - remove this fake condition when adding inline edit
    // Adding this just so I can keep the relay fragment happy
    if (!data.id) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1ae5ea0a31a63ede$var$styles.readOnlyViewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7nqlz.default), {
        items: labels.map((label)=>{
            return {
                name: label,
                key: label,
                isColored: true,
                color: (0, $gBLwY.getColorMetadata)((0, $b9ae3302c27a1c4f$export$8100203285e9ab92)(label)).backgroundColor
            };
        }),
        ItemComponent: (0, $5r5PB.TagItem),
        PopupContentWrapper: (0, $5r5PB.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage($1ae5ea0a31a63ede$var$messages.showMoreTooltip),
        isHoverPopoverEnabled: true
    }));
});
module.exports["JiraLabelsField"] = $1ae5ea0a31a63ede$export$4f1cef997d4897b3;

});

parcelRegister("g0hFf", function(module, exports) {
/**
 * @generated SignedSource<<ffa7cfe23a1002334a1888f6287cf96c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9176ad815322640c$var$node = function() {
    var v0 = [
        {
            "concreteType": "JiraOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraOption",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraMultipleSelectField",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraMultipleSelectField"
    };
}();
$9176ad815322640c$var$node.hash = "54bbee5f9eafbc5f79cae473fe8f5388";
var $9176ad815322640c$export$2e2bcd8739ae039 = $9176ad815322640c$var$node;



var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $1JERl = parcelRequire("1JERl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $8wMiv = parcelRequire("8wMiv");


var $7nqlz = parcelRequire("7nqlz");


var $5r5PB = parcelRequire("5r5PB");


var $gVzkK = parcelRequire("gVzkK");


var $2v5cF = parcelRequire("2v5cF");

const $9518e5525aca5467$var$messages = (0, $kSwu1.defineMessages)({
    showMoreTooltip: {
        id: "jira.platform-fields.multi-select.show-more",
        defaultMessage: "Show more"
    },
    none: {
        id: "jira.jira-platform-fields.multi-select.none",
        defaultMessage: "None"
    },
    isRequiredError: {
        id: "jira.jira-platform-fields.multi-select.is-required-error",
        defaultMessage: "{fieldName} is required"
    }
});
const $9518e5525aca5467$var$styles = {
    container: "_39xV02N91d _3138424F84",
    readView: "_39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb2ADO _2Zuz6Q2ADO",
    editableReadView: "_0wOv4Q7zJH _0jFU0VnlTt"
};
const $9518e5525aca5467$var$ReadView = /*#__PURE__*/ (0, $cozmU.memo)(({ options: options, isEditable: isEditable })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($9518e5525aca5467$var$styles.readView, isEditable && $9518e5525aca5467$var$styles.editableReadView)
    }, options.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "start",
        color: "color.text.subtle",
        maxLines: 1
    }, formatMessage($9518e5525aca5467$var$messages.none)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7nqlz.default), {
        items: options.map((opt)=>({
                key: opt.value,
                name: opt.label,
                isColored: false
            })),
        ItemComponent: (0, $5r5PB.TagItem),
        PopupContentWrapper: (0, $5r5PB.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage($9518e5525aca5467$var$messages.showMoreTooltip),
        isHoverPopoverEnabled: true
    }));
});
const $9518e5525aca5467$export$ac7bfd3a56ad4f61 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $9176ad815322640c$export$2e2bcd8739ae039), field);
    const fieldName = data?.name;
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const validate = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: fieldName,
        fieldTypeForAnalytics: 'MultipleSelectField'
    });
    const allowedOptions = (0, $cozmU.useMemo)(()=>{
        const edges = data?.fieldOptions?.edges;
        return edges?.filter(Boolean).map((edge)=>{
            const value = String(edge?.node?.value ?? '');
            return {
                label: value,
                value: value
            };
        }) ?? [];
    }, [
        data?.fieldOptions?.edges
    ]);
    const defaultSelectedValues = (0, $cozmU.useMemo)(()=>{
        const edges = data?.selectedOptions?.edges;
        return edges?.filter(Boolean).map((edge)=>String(edge?.node?.value ?? '')).filter(Boolean) ?? [];
    }, [
        data?.selectedOptions?.edges
    ]);
    const currentValues = (0, $cozmU.useMemo)(()=>{
        if (!Array.isArray(fieldValue)) return [];
        const allowedSet = new Set(allowedOptions.map((o)=>o.value.toLowerCase()));
        const filteredValues = fieldValue.filter((v)=>allowedSet.has(v.toLowerCase())); // If some invalid values were filtered out, tell the upstream
        if (filteredValues.length !== fieldValue.length) onChange?.(filteredValues);
        return filteredValues;
    }, [
        fieldValue,
        allowedOptions,
        onChange
    ]);
    const selectedOptions = (0, $cozmU.useMemo)(()=>{
        const map = new Map(allowedOptions.map((o)=>[
                o.value.toLowerCase(),
                o
            ]));
        return currentValues.map((v)=>map.get(String(v).toLowerCase()) ?? {
                label: String(v),
                value: String(v)
            }).filter(Boolean);
    }, [
        allowedOptions,
        currentValues
    ]);
    const handleOnConfirm = (0, $cozmU.useCallback)((newValue)=>{
        const values = (newValue ?? []).map((opt)=>String(opt.value)).filter(Boolean);
        onChange?.(values.length ? values : null);
    }, [
        onChange
    ]);
    const readView = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9518e5525aca5467$var$ReadView, {
            options: selectedOptions,
            isEditable: isEditable
        }), [
        selectedOptions,
        isEditable
    ]); // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (currentValues.length === 0 && defaultSelectedValues.length > 0 && isFirstRenderRef.current === true) onChange?.(defaultSelectedValues);
        isFirstRenderRef.current = false;
    }, [
        currentValues,
        defaultSelectedValues,
        onChange
    ]);
    if (!isEditable) return readView;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9518e5525aca5467$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
        defaultValue: selectedOptions,
        readView: ()=>readView,
        editView: ({ errorMessage: errorMessage, isInvalid: isInvalid, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2v5cF.ValidationPopup), {
                errorMessage: errorMessage,
                showInvalidPopup: Boolean(isInvalid && errorMessage),
                trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        ref: ref
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                        ...fieldProps,
                        menuPortalTarget: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? undefined : document.body,
                        menuPosition: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'fixed' : 'absolute',
                        menuPlacement: "auto",
                        styles: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? {
                            menu: (base)=>({
                                    ...base,
                                    zIndex: (0, $8wMiv.layers).modal()
                                }),
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: (0, $8wMiv.layers).modal()
                                })
                        } : undefined,
                        label: fieldName,
                        isMulti: true,
                        autoFocus: true,
                        options: allowedOptions,
                        getOptionValue: (o)=>o.value,
                        getOptionLabel: (o)=>o.label,
                        placeholder: formatMessage($9518e5525aca5467$var$messages.showMoreTooltip),
                        isInvalid: isInvalid
                    }))
            }),
        validate: validate,
        onConfirm: handleOnConfirm,
        hideActionButtons: true,
        readViewFitContainerWidth: true,
        editButtonLabel: selectedOptions.map((o)=>o.label).join(', ') ?? undefined
    }));
});
module.exports["JiraMultipleSelectField"] = $9518e5525aca5467$export$ac7bfd3a56ad4f61;

});

parcelRegister("gpQ9H", function(module, exports) {
/**
 * @generated SignedSource<<036e6c78613c5af00ff55f7741b4afc6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3303e99c4b626d8b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraMultipleSelectUserPickerField_Platform",
    "selections": [
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$3303e99c4b626d8b$var$node.hash = "03d643e1f86865d308a30b45583702b9";
var $3303e99c4b626d8b$export$2e2bcd8739ae039 = $3303e99c4b626d8b$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $aLI5J = parcelRequire("aLI5J");

const $66648f103f9f7f26$export$17fd1612e8ef3559 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, isFieldEditable: isFieldEditable = true, ...props })=>{
    const data = (0, $6SsN4.useFragment)((0, $3303e99c4b626d8b$export$2e2bcd8739ae039), field);
    const isEditable = (data?.fieldConfig?.isEditable ?? false) && isFieldEditable;
    const isRequired = data?.fieldConfig?.isRequired ?? false;
    const defaultUsers = data?.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.id && edge.node.accountId && {
            id: edge.node.id,
            accountId: edge.node.accountId,
            name: edge.node.name,
            avatarUrl: edge.node.picture ?? undefined
        }).filter(Boolean);
    return /*#__PURE__*/ $cozmU.createElement((0, $aLI5J.UserPickerComponent), {
        ...props,
        isEditable: isEditable,
        isRequired: isRequired,
        defaultUsers: defaultUsers ?? null,
        isMulti: true
    });
});
module.exports["JiraMultipleSelectUserPickerField"] = $66648f103f9f7f26$export$17fd1612e8ef3559;

});

parcelRegister("eAi78", function(module, exports) {
/**
 * @generated SignedSource<<d1b47504b0165d29b2c3c103a0a507b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e9c815f3cc4e9eea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraNumberField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "concreteType": "JiraNumberFieldFormatConfig",
            "kind": "LinkedField",
            "name": "formatConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "formatStyle"
                },
                {
                    "kind": "ScalarField",
                    "name": "formatUnit"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$e9c815f3cc4e9eea$var$node.hash = "aefa4c52f7440a76d4e89d6349d58fe2";
var $e9c815f3cc4e9eea$export$2e2bcd8739ae039 = $e9c815f3cc4e9eea$var$node;



var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $hcOES = parcelRequire("hcOES");


var $gVzkK = parcelRequire("gVzkK");


var $2v5cF = parcelRequire("2v5cF");

const $e49d6266474b39d6$var$DEFAULT_CURRENCY = 'USD';
const $e49d6266474b39d6$var$DEFAULT_CURRENCY_DISPLAY = 'symbol';
const $e49d6266474b39d6$var$isSupportedCurrencyCode = (currencyCode)=>{
    const intlMaybe = Intl;
    return (typeof intlMaybe.supportedValuesOf === 'function' ? intlMaybe.supportedValuesOf('currency') : []).includes(currencyCode);
};
const $e49d6266474b39d6$var$formatCurrency = (number, locale, currency = $e49d6266474b39d6$var$DEFAULT_CURRENCY)=>{
    if ($e49d6266474b39d6$var$isSupportedCurrencyCode(currency)) return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: $e49d6266474b39d6$var$DEFAULT_CURRENCY_DISPLAY,
        maximumFractionDigits: Number.isInteger(number) ? 0 : undefined
    }).format(number);
    return $e49d6266474b39d6$var$formatDecimal(number, locale);
};
const $e49d6266474b39d6$export$ada9449cdfaaabd8 = (number, formatConfig)=>number != null && formatConfig?.formatStyle === 'PERCENT' ? number * 100 : number;
const $e49d6266474b39d6$export$6f0c6eec5b71d787 = (number, formatConfig)=>{
    if (number == null || formatConfig?.formatStyle !== 'PERCENT') return number ?? null;
     // Use Number.EPSILON to avoid floating-point precision issues
    const result = number / 100;
    const factor = Math.pow(10, 8); // 8 decimal places should be sufficient for percentage precision
    return Math.round((result + Number.EPSILON) * factor) / factor;
};
const $e49d6266474b39d6$var$formatPercent = (number, locale)=>new Intl.NumberFormat(locale, {
        style: 'unit',
        unit: 'percent'
    }).format(number);
const $e49d6266474b39d6$var$formatDecimal = (number, locale)=>new Intl.NumberFormat(locale, {
        style: 'decimal'
    }).format(number);
const $e49d6266474b39d6$var$formatNumberField = (number, locale, formatConfig)=>{
    if (formatConfig == null) return $e49d6266474b39d6$var$formatDecimal(number, locale);
    const { formatStyle: formatStyle, formatUnit: formatUnit } = formatConfig;
    switch(formatStyle){
        case 'CURRENCY':
            return formatUnit ? $e49d6266474b39d6$var$formatCurrency(number, locale, formatUnit) : $e49d6266474b39d6$var$formatDecimal(number, locale);
        case 'PERCENT':
            return $e49d6266474b39d6$var$formatPercent(number, locale);
        default:
            return $e49d6266474b39d6$var$formatDecimal(number, locale);
    }
};
const $e49d6266474b39d6$var$messages = (0, $kSwu1.defineMessages)({
    requiredMessage: {
        id: "jira.jira-platform-fields.jira-number-field.required-message",
        defaultMessage: "{fieldName} is required"
    },
    none: {
        id: "jira.jira-platform-fields.number-field.none",
        defaultMessage: "None"
    }
});
const $e49d6266474b39d6$var$styles = {
    textFieldContainer: "_39xV02N91d _3138424F84",
    editableTextFieldReadViewContainer: "_39xV02N91d _0jFU0VUF4f",
    textField: "_39xV02N91d",
    readView: "_0jFU0VUF4f _0hPCNLDIqT _3iDTPbQ4SZ _1Znuxb2ADO _2Zuz6Q2ADO",
    editableReadView: "_0wOv4Q7zJH _0jFU0VnlTt"
};
const $e49d6266474b39d6$export$73442d2f4cd698d3 = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const data = (0, $6SsN4.useFragment)((0, $e9c815f3cc4e9eea$export$2e2bcd8739ae039), field);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const defaultValue = data.number;
    const currentValue = $e49d6266474b39d6$export$ada9449cdfaaabd8(typeof fieldValue === 'number' ? fieldValue : null, data.formatConfig);
    const hasValue = currentValue != null;
    const displayText = hasValue ? $e49d6266474b39d6$var$formatNumberField(currentValue, locale, data.formatConfig) : formatMessage($e49d6266474b39d6$var$messages.none); // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (fieldValue == null && defaultValue != null && isFirstRenderRef.current) onChange($e49d6266474b39d6$export$6f0c6eec5b71d787(defaultValue, data.formatConfig));
        isFirstRenderRef.current = false;
    }, [
        fieldValue,
        hasValue,
        onChange,
        defaultValue,
        data.formatConfig
    ]);
    const validate = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: data.name,
        fieldTypeForAnalytics: data.__typename
    });
    const onEdit = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: data.__typename,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsEditing(true);
    }, [
        createAnalyticsEvent,
        data.name,
        data.__typename,
        isRequired,
        isEditable
    ]);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: data.__typename,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsEditing(false);
    }, [
        createAnalyticsEvent,
        data.name,
        data.__typename,
        isRequired,
        isEditable
    ]);
    const onConfirm = (0, $cozmU.useCallback)((newValue)=>{
        setIsEditing(false);
        const newNumericValue = newValue === '' ? null : Number(newValue);
        if (newNumericValue !== currentValue) onChange($e49d6266474b39d6$export$6f0c6eec5b71d787(newNumericValue, data.formatConfig));
        else (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: data.__typename,
            isRequired: isRequired,
            isEditable: isEditable
        });
    }, [
        createAnalyticsEvent,
        onChange,
        currentValue,
        data.formatConfig,
        data.name,
        data.__typename,
        isRequired,
        isEditable
    ]);
    const readView = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $k12R1.cx)($e49d6266474b39d6$var$styles.readView, isEditable && $e49d6266474b39d6$var$styles.editableReadView)
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1,
            color: hasValue ? 'color.text' : 'color.text.subtle'
        }, displayText));
    }, [
        displayText,
        isEditable,
        hasValue
    ]);
    if (!isEditable) return readView();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($e49d6266474b39d6$var$styles.textFieldContainer, !isEditing && $e49d6266474b39d6$var$styles.editableTextFieldReadViewContainer)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        isEditing: isEditing,
        defaultValue: currentValue,
        editButtonLabel: displayText,
        editView: ({ errorMessage: errorMessage, isInvalid: isInvalid, ...fieldProps })=>/*#__PURE__*/ $cozmU.createElement((0, $2v5cF.ValidationPopup), {
                showInvalidPopup: isInvalid,
                errorMessage: isInvalid ? errorMessage : undefined,
                trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        xcss: $e49d6266474b39d6$var$styles.textField
                    }, /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                        ...fieldProps,
                        ...triggerProps,
                        type: "number",
                        step: "any",
                        autoFocus: true,
                        isInvalid: isInvalid,
                        "aria-invalid": isInvalid,
                        "aria-describedby": isInvalid ? triggerProps.errorId : undefined,
                        "aria-errormessage": isInvalid ? errorMessage : undefined
                    }))
            }),
        readView: readView,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onEdit: onEdit,
        readViewFitContainerWidth: true,
        validate: validate
    }));
});
module.exports["JiraNumberField"] = $e49d6266474b39d6$export$73442d2f4cd698d3;

});

parcelRegister("h7OKx", function(module, exports) {
/**
 * @generated SignedSource<<810d585ca877793e249c9c0339e48736>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ce2cdcf0184ad28$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraPeopleField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isMulti"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraPeopleField"
};
$5ce2cdcf0184ad28$var$node.hash = "79c46e08dfc96c72c4c7888004cc1468";
var $5ce2cdcf0184ad28$export$2e2bcd8739ae039 = $5ce2cdcf0184ad28$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $aLI5J = parcelRequire("aLI5J");

const $cb5f9b7ef2ca3da2$export$3f9ca1fff04891cb = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, isFieldEditable: isFieldEditable = true, ...props })=>{
    const data = (0, $6SsN4.useFragment)((0, $5ce2cdcf0184ad28$export$2e2bcd8739ae039), field);
    const isEditable = (data?.fieldConfig?.isEditable ?? false) && isFieldEditable;
    const isRequired = data?.fieldConfig?.isRequired ?? false;
    const defaultUsers = data?.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.id && {
            id: edge.node.id,
            name: edge.node.name,
            accountId: edge.node.accountId,
            avatarUrl: edge.node.picture
        }).filter(Boolean);
    return /*#__PURE__*/ $cozmU.createElement((0, $aLI5J.UserPickerComponent), {
        ...props,
        isEditable: isEditable,
        isRequired: isRequired,
        defaultUsers: defaultUsers ?? null,
        isMulti: Boolean(data?.isMulti)
    });
});
module.exports["JiraPeopleField"] = $cb5f9b7ef2ca3da2$export$3f9ca1fff04891cb;

});

parcelRegister("hzmZ3", function(module, exports) {
/**
 * @generated SignedSource<<60c00fae2159fe8cad5b1f0290338819>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $28cbf8ef0439e43b$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "priorityId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraPriorityField_Platform",
        "selections": [
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            },
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraPriorityConnection",
                "kind": "LinkedField",
                "name": "priorities",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPriorityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
}();
$28cbf8ef0439e43b$var$node.hash = "116f0c33db1e8652714194faaad6b2a8";
var $28cbf8ef0439e43b$export$2e2bcd8739ae039 = $28cbf8ef0439e43b$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $1hQ0e = parcelRequire("1hQ0e");


var $cXtTj = parcelRequire("cXtTj");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $8wMiv = parcelRequire("8wMiv");

const $abbdc48a4c6593a2$var$messages = (0, $kSwu1.defineMessages)({
    selectLabel: {
        id: "jira.jira.jira-platform-fields.priority.select.label",
        defaultMessage: "Select issue priority"
    }
});
const $abbdc48a4c6593a2$var$styles = {
    control: "_39xV02N91d _24h04i2Njc _0jFU0VUF4f",
    container: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _4ouGXIdnbC _39xV02N91d",
    valueContainer: "_4ouGXIdnbC",
    inline: "_39xV02N91d",
    readOnlyViewContainer: "_2Zuz6Q2ADO _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUF4f _39xV02N91d"
};
const $abbdc48a4c6593a2$var$PriorityOptionComponent = (option)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        xcss: $abbdc48a4c6593a2$var$styles.inline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        width: 16,
        src: option.iconUrl ?? undefined,
        alt: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? '' : option.label,
        "aria-hidden": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? true : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, option.label));
};
const $abbdc48a4c6593a2$export$8dfee0b7a176529c = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, onChange: onChange, isFieldEditable: isFieldEditable = true })=>{
    const data = (0, $6SsN4.useFragment)((0, $28cbf8ef0439e43b$export$2e2bcd8739ae039), field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectRef = (0, $cozmU.useRef)(null);
    const isEditable = data?.fieldConfig?.isEditable && isFieldEditable;
    const defaultValue = data?.priority?.name;
    const options = (0, $cozmU.useMemo)(()=>{
        return data?.priorities?.edges?.filter(Boolean).map((edge)=>({
                value: String(edge?.node?.priorityId ?? ''),
                label: String(edge?.node?.name ?? ''),
                iconUrl: edge?.node?.iconUrl ?? undefined
            })) ?? [];
    }, [
        data?.priorities?.edges
    ]);
    const handleChange = (newValue)=>{
        onChange?.(newValue?.label ?? null); // Defer blur so internal state settles before removing focus styling.
        queueMicrotask(()=>selectRef.current?.blur?.());
    };
    const handleMenuClose = ()=>{
        selectRef.current?.blur?.();
    };
    const selectedOption = (0, $cozmU.useMemo)(()=>{
        if (fieldValue == null) return null;
        if (fieldValue) {
            const fieldOption = options.find((option)=>option.label === fieldValue) ?? null;
            return fieldOption;
        }
    }, [
        fieldValue,
        options
    ]); // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (!selectedOption?.label && defaultValue != null && isFirstRenderRef.current) onChange?.(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        selectedOption?.label,
        defaultValue,
        onChange
    ]);
    if (isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        ref: selectRef,
        label: formatMessage($abbdc48a4c6593a2$var$messages.selectLabel),
        appearance: "subtle",
        options: options,
        getOptionValue: (option)=>option.value,
        getOptionLabel: (option)=>option.label,
        value: selectedOption,
        onChange: handleChange,
        onMenuClose: handleMenuClose,
        searchThreshold: 5,
        formatOptionLabel: $abbdc48a4c6593a2$var$PriorityOptionComponent,
        components: {
            Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, {
                    ...props,
                    xcss: $abbdc48a4c6593a2$var$styles.control
                }),
            SelectContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SelectContainer, {
                    ...props,
                    xcss: $abbdc48a4c6593a2$var$styles.container
                }),
            ValueContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
                    ...props,
                    xcss: $abbdc48a4c6593a2$var$styles.valueContainer
                }),
            DropdownIndicator: (props)=>props.selectProps.menuIsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).DropdownIndicator, props) : null
        },
        isMulti: false,
        menuPortalTarget: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? undefined : (0, $1hQ0e.getDocument)()?.body,
        menuPosition: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'fixed' : 'absolute',
        menuPlacement: "auto",
        styles: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? {
            menu: (base)=>({
                    ...base,
                    zIndex: (0, $8wMiv.layers).modal()
                }),
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $8wMiv.layers).modal()
                })
        } : undefined
    });
    if (!selectedOption) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $abbdc48a4c6593a2$var$styles.readOnlyViewContainer
    }, $abbdc48a4c6593a2$var$PriorityOptionComponent(selectedOption));
});
module.exports["JiraPriorityField"] = $abbdc48a4c6593a2$export$8dfee0b7a176529c;

});

parcelRegister("k28ss", function(module, exports) {
/**
 * @generated SignedSource<<0ddca9cceaaa167027235f60cd10f533>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fb86b0b82ad5d303$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraRadioSelectField_Platform",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRadioSelectField"
    };
}();
$fb86b0b82ad5d303$var$node.hash = "92f411b7b38c29e27a50cf8ceb71b938";
var $fb86b0b82ad5d303$export$2e2bcd8739ae039 = $fb86b0b82ad5d303$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $1XBkA = parcelRequire("1XBkA");


var $6wGOF = parcelRequire("6wGOF");

const $d291abdf69ddf272$export$b6b4cb8dcfd6af64 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let components;
    let props;
    if ($[0] !== t0) {
        ({ components: components, ...props } = t0);
        $[0] = t0;
        $[1] = components;
        $[2] = props;
    } else {
        components = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== components) {
        t1 = {
            ...components,
            Option: (0, $1XBkA.RadioOption)
        };
        $[3] = components;
        $[4] = t1;
    } else t1 = $[4];
    const mergedComponents = t1;
    let t2;
    if ($[5] !== mergedComponents || $[6] !== props) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
            ...props,
            isMulti: false,
            components: mergedComponents
        });
        $[5] = mergedComponents;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ components: components, ...props })=>{
    const mergedComponents = (0, $cozmU.useMemo)(()=>({
            ...components,
            Option: (0, $1XBkA.RadioOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
        ...props,
        isMulti: false,
        components: mergedComponents
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc



var $8wMiv = parcelRequire("8wMiv");


var $hcOES = parcelRequire("hcOES");


var $2v5cF = parcelRequire("2v5cF");

const $3ed5880481112c75$var$FIELD_TYPE_FOR_ANALYTICS = 'JiraRadioSelectField';
const $3ed5880481112c75$var$messages = (0, $kSwu1.defineMessages)({
    requiredMessage: {
        id: "jira.jira.jira-platform-fields.jira-radio-select-field.required-message",
        defaultMessage: "{fieldName} is required"
    },
    none: {
        id: "jira.jira.jira-platform-fields.jira-radio-select-field.none",
        defaultMessage: "None"
    }
});
const $3ed5880481112c75$var$styles = {
    readOnlyViewContainer: "_39xV02N91d _0jFU0VUF4f _2Zuz6Q2ADO _1Znuxb2ADO",
    readViewButton: "_0bjKvDKxmn _39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q2ADO _1Znuxb2ADO _0KLXrujOvk _34b3D2Ll21 _1eOmH6o126",
    textContainer: "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7 _39HuIbz8Lp",
    invalidField: "_3vBAKHnod9 _3hxITi6wH8 _2V7sgOvc3e",
    editViewContainer: "_39xV02N91d"
};
const $3ed5880481112c75$var$parseOptions = (fieldOptions)=>{
    const options = [];
    if (fieldOptions?.edges) for (const option of fieldOptions.edges){
        const value = option?.node?.value;
        if (value != null) options.push({
            value: value,
            label: value
        });
    }
    return options;
};
const $3ed5880481112c75$export$e8f047dd67507868 = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $6SsN4.useFragment)((0, $fb86b0b82ad5d303$export$2e2bcd8739ae039), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const defaultValue = data.selectedOption?.value;
    const currentValue = typeof fieldValue === 'string' ? fieldValue : null;
    const hasValue = currentValue != null;
    const isInvalid = isRequired && !hasValue;
    const displayText = hasValue ? currentValue : formatMessage($3ed5880481112c75$var$messages.none);
    const options = $3ed5880481112c75$var$parseOptions(data.fieldOptions);
    const selectedValue = (0, $cozmU.useMemo)(()=>hasValue ? {
            value: currentValue,
            label: currentValue
        } : undefined, [
        hasValue,
        currentValue
    ]); // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (!fieldValue && defaultValue != null && isFirstRenderRef.current) onChange(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        fieldValue,
        defaultValue,
        onChange
    ]);
    const onClickEditableField = (0, $cozmU.useCallback)(()=>{
        setIsEditing(true);
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: $3ed5880481112c75$var$FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
    }, [
        createAnalyticsEvent,
        data.name,
        isEditable,
        isRequired
    ]);
    const fieldValueText = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $3ed5880481112c75$var$styles.textContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: hasValue ? 'color.text' : 'color.text.subtle'
        }, displayText)), [
        displayText,
        hasValue
    ]);
    const readViewNode = (0, $cozmU.useMemo)(()=>isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            onClick: onClickEditableField,
            xcss: (0, $w6R6I.cx)($3ed5880481112c75$var$styles.readViewButton, isInvalid && $3ed5880481112c75$var$styles.invalidField)
        }, fieldValueText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            xcss: $3ed5880481112c75$var$styles.readOnlyViewContainer
        }, fieldValueText), [
        isEditable,
        fieldValueText,
        onClickEditableField,
        isInvalid
    ]);
    const onChangeValue = (0, $cozmU.useCallback)((newValue)=>{
        const value = newValue?.value != null ? String(newValue.value) : null;
        setIsEditing(false);
        if (value !== currentValue) {
            (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
                action: 'applied',
                actionSubject: 'inlineEdit'
            }), {
                fieldName: data.name,
                fieldType: $3ed5880481112c75$var$FIELD_TYPE_FOR_ANALYTICS,
                isRequired: isRequired,
                isEditable: isEditable
            });
            onChange(value);
        } else (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: $3ed5880481112c75$var$FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
    }, [
        currentValue,
        createAnalyticsEvent,
        data.name,
        isRequired,
        isEditable,
        onChange
    ]);
    const editViewMode = (0, $cozmU.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ...triggerProps,
            xcss: $3ed5880481112c75$var$styles.editViewContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d291abdf69ddf272$export$b6b4cb8dcfd6af64), {
            options: options,
            value: selectedValue,
            onChange: onChangeValue,
            onFocus: ()=>setIsEditing(true),
            onBlur: ()=>setIsEditing(false),
            autoFocus: true,
            menuIsOpen: isEditing,
            isRequired: isRequired,
            isInvalid: isInvalid,
            isClearable: true,
            menuPosition: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'fixed' : 'absolute',
            menuPlacement: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'auto' : 'bottom',
            styles: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? {
                control: (base)=>({
                        ...base,
                        height: '40px',
                        minHeight: '40px',
                        boxSizing: 'border-box'
                    }),
                menu: (base)=>({
                        ...base,
                        zIndex: (0, $8wMiv.layers).modal()
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $8wMiv.layers).modal()
                    })
            } : undefined
        })), [
        isEditing,
        isRequired,
        onChangeValue,
        options,
        selectedValue,
        isInvalid
    ]);
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2v5cF.ValidationPopup), {
        showInvalidPopup: isEditing && isInvalid,
        placement: "right",
        errorMessage: isInvalid ? formatMessage($3ed5880481112c75$var$messages.requiredMessage, {
            fieldName: data.name
        }) : undefined,
        trigger: editViewMode
    });
    return readViewNode;
});
module.exports["JiraRadioSelectField"] = $3ed5880481112c75$export$e8f047dd67507868;

});

parcelRegister("1XBkA", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fekRe = parcelRequire("fekRe");

const $590215a905adec4b$var$svgStyles = null;
const $590215a905adec4b$var$RadioIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    let t0;
    if ($[0] !== primaryColor || $[1] !== secondaryColor) {
        t0 = {
            color: primaryColor,
            fill: secondaryColor
        };
        $[0] = primaryColor;
        $[1] = secondaryColor;
        $[2] = t0;
    } else t0 = $[2];
    const t1 = label ? label : undefined;
    const t2 = label ? "img" : "presentation";
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            viewBox: "0 0 24 24",
            style: t0,
            "aria-label": t1,
            role: t2,
            className: t3,
            children: t4
        });
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _1rdFvhlfZc _1pp6NdYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $590215a905adec4b$export$82ab7168879267a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fekRe.ControlOption), {
            Icon: $590215a905adec4b$var$RadioIcon,
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fekRe.ControlOption), {
        Icon: $590215a905adec4b$var$RadioIcon,
        ...props
    });
module.exports["RadioOption"] = $590215a905adec4b$export$82ab7168879267a7;

});

parcelRegister("7QeEQ", function(module, exports) {
/**
 * @generated SignedSource<<e28a6f52a6c75e5425eb3e951d09f6a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $971536a3ec695872$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraRichTextField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAdfToConvertedPlainText",
                            "kind": "LinkedField",
                            "name": "convertedPlainText",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "plainText"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$971536a3ec695872$var$node.hash = "ac5a7c471e1aeab3959577f819a8c8e3";
var $971536a3ec695872$export$2e2bcd8739ae039 = $971536a3ec695872$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jFZPQ = parcelRequire("jFZPQ");

const $f797cdeb087ae3f0$export$9997d96934580069 = ({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, isFullWidth: isFullWidth, onChange: onChange })=>{
    const data = (0, $6SsN4.useFragment)((0, $971536a3ec695872$export$2e2bcd8739ae039), field);
    const { isRequired: isRequired } = data?.fieldConfig || {};
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const defaultValue = data?.richText?.adfValue?.convertedPlainText?.plainText ?? '';
    const currentValue = typeof fieldValue === 'string' ? fieldValue : ''; // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (!fieldValue && defaultValue != null && isFirstRenderRef.current) onChange(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        fieldValue,
        defaultValue,
        onChange
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $jFZPQ.CustomTextField), {
        isEditable: !!isEditable,
        isFullWidth: isFullWidth,
        isRequired: !!isRequired,
        currentValue: currentValue,
        fieldName: data?.name,
        onChange: onChange
    });
};
module.exports["JiraRichTextField"] = $f797cdeb087ae3f0$export$9997d96934580069;

});

parcelRegister("671V0", function(module, exports) {
/**
 * @generated SignedSource<<53217016bae42f3c22c0ff9200d73ae7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ae46d3eda49eff3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraSingleLineTextField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$5ae46d3eda49eff3$var$node.hash = "6cf15d61982b829c6f1f9f478b7976c8";
var $5ae46d3eda49eff3$export$2e2bcd8739ae039 = $5ae46d3eda49eff3$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jFZPQ = parcelRequire("jFZPQ");

const $69345088235e78d2$export$f271d10dbe9a0e23 = ({ as: as, fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, isFullWidth: isFullWidth, onChange: onChange })=>{
    const data = (0, $6SsN4.useFragment)((0, $5ae46d3eda49eff3$export$2e2bcd8739ae039), field);
    const { isRequired: isRequired } = data?.fieldConfig || {};
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const defaultValue = typeof data?.text === 'string' ? data.text : '';
    const currentValue = typeof fieldValue === 'string' ? fieldValue : ''; // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (!fieldValue && defaultValue != null && isFirstRenderRef.current) onChange(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        fieldValue,
        defaultValue,
        onChange
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $jFZPQ.CustomTextField), {
        as: as,
        isEditable: !!isEditable,
        isFullWidth: isFullWidth,
        isRequired: !!isRequired,
        currentValue: currentValue,
        fieldName: data?.name,
        onChange: onChange
    });
};
module.exports["JiraSingleLineTextField"] = $69345088235e78d2$export$f271d10dbe9a0e23;

});

parcelRegister("ifOkh", function(module, exports) {
/**
 * @generated SignedSource<<e06c5217128bde45a816440c22accf51>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e826a7d2761002a8$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "JiraSingleSelectField_Platform",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$e826a7d2761002a8$var$node.hash = "ef651f5bb749d7c5b877b85cce4f4c5b";
var $e826a7d2761002a8$export$2e2bcd8739ae039 = $e826a7d2761002a8$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $1hQ0e = parcelRequire("1hQ0e");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $8wMiv = parcelRequire("8wMiv");


var $hcOES = parcelRequire("hcOES");

/* OptionTag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");





var $w6R6I = parcelRequire("w6R6I");





var $lpNn5 = parcelRequire("lpNn5");


var $gBLwY = parcelRequire("gBLwY");

const $5e5e6fbb2830aaab$var$styles = {
    tooltipStyles: "_4bt5LAnQyn _2WAcuGnQyn",
    tagWrapperStyles: "_23rrnH0jWM _3iDTPbccYA _37wbyuecOK _0hPCNLDIqT _1EqgXlN91d _4ouGXIdnbC _4kiQYAdnbC _1UtDYzy7kJ",
    interactiveStyles: "_0ReiIH7zJH",
    styledTagsStyles: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _39HuIbz8Lp _1ANEUSLRg7 _0KLXru66of _1Znuxb1Y8M _2Zuz6Q1Y8M _1EqgXlWD6W"
};
const $5e5e6fbb2830aaab$export$5991b62d89f5cc = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true, showTooltip: showTooltip = false, isColoredLabel: isColoredLabel }, ref)=>{
    const { backgroundColor: tagColor } = (0, $gBLwY.getColorMetadata)(color);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5e5e6fbb2830aaab$var$styles.tagWrapperStyles, isInteractive && $5e5e6fbb2830aaab$var$styles.interactiveStyles),
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, isColoredLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `option-color-picker.option-tag.${color || 'default'}`,
        xcss: $5e5e6fbb2830aaab$var$styles.styledTagsStyles,
        style: {
            borderColor: tagColor
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e5e6fbb2830aaab$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5e5e6fbb2830aaab$var$styles.tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: name
    }, content)) : content;
})); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e5e6fbb2830aaab$var$StyledTagBase = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _1EqgXlN91d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e5e6fbb2830aaab$var$StyledTag = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $5e5e6fbb2830aaab$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_36rcb1": (0, $9aYkv.default)(`${"var(--ds-border-width, 1px)"} solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDc3FE _30huDKxzQx _0KLXrujOvk _1Znuxb1Y8M _2Zuz6Q1Y8M",
            __cmplp.className
        ])
    });
});


const $b3e9148af2322522$var$messages = (0, $kSwu1.defineMessages)({
    selectLabel: {
        id: "jira.jira.jira-platform-fields.single-select.label",
        defaultMessage: "Select {fieldName}"
    },
    noOptionMessage: {
        id: "jira.jira.jira-platform-fields.single-select.no.options",
        defaultMessage: "None"
    }
});
const $b3e9148af2322522$var$styles = {
    readViewContainer: "_2Zuz6Q2ADO _0jFU0VUF4f",
    control: "_39xV02N91d _24h04i2Njc _0jFU0VUF4f",
    container: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _4ouGXIdnbC _39xV02N91d",
    valueContainer: "_4ouGXIdnbC"
};
const $b3e9148af2322522$var$ReadView = ({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e5e6fbb2830aaab$export$5991b62d89f5cc), {
        name: option.value ?? '',
        color: option.color ?? null,
        showTooltip: true
    }); /**
                                                                                         * `JiraSingleSelectField` is a memoized React component that renders a Jira single select field,
                                                                                         * supporting both editable and read-only modes. It displays the current option and allows
                                                                                         * users to select from available options if the field is editable. The component uses
                                                                                         * Relay fragments to fetch option data and renders options with icons and labels.
                                                                                         *
                                                                                         * @param field - The Relay fragment reference for the Jira option field.
                                                                                         * @param fieldValue - The currently suggested option value.
                                                                                         * @param onChange - Callback invoked when the option selection changes.
                                                                                         * @returns A JSX element representing the option field, or `null` if no option is found.
                                                                                         */ 
const $b3e9148af2322522$export$f004bf6f4b852921 = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const data = (0, $6SsN4.useFragment)((0, $e826a7d2761002a8$export$2e2bcd8739ae039), field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const selectRef = (0, $cozmU.useRef)(null);
    const { isRequired: isRequired } = data.fieldConfig ?? {};
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const options = (0, $cozmU.useMemo)(()=>{
        return data?.fieldOptions?.edges?.filter(Boolean).map((edge)=>({
                value: String(edge?.node?.value ?? ''),
                color: edge?.node?.color?.colorKey ?? ''
            })) ?? [];
    }, [
        data?.fieldOptions?.edges
    ]);
    const defaultValue = data?.fieldOption?.value;
    const selectedOption = (0, $cozmU.useMemo)(()=>{
        if (fieldValue == null) return null;
        if (fieldValue) {
            const fieldOption = options.find((option)=>option.value === fieldValue) ?? null;
            return fieldOption;
        }
    }, [
        fieldValue,
        options
    ]); // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (!selectedOption?.value && defaultValue != null && isFirstRenderRef.current) onChange?.(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        selectedOption?.value,
        defaultValue,
        onChange
    ]);
    const handleChange = (0, $cozmU.useCallback)((newValue)=>{
        onChange?.(newValue?.value ?? null); // Defer blur so internal state settles before removing focus styling.
        queueMicrotask(()=>selectRef.current?.blur?.());
    }, [
        onChange
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const handleMenuClose = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: data.__typename,
            isRequired: isRequired,
            isEditable: isEditable
        });
        selectRef.current?.blur?.();
        setIsMenuOpen(false);
    }, [
        createAnalyticsEvent,
        data.name,
        data.__typename,
        isRequired,
        isEditable
    ]);
    const handleMenuOpen = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: data.name,
            fieldType: data.__typename,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsMenuOpen(true);
    }, [
        createAnalyticsEvent,
        data.name,
        data.__typename,
        isRequired,
        isEditable
    ]);
    if (isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        ref: selectRef,
        label: formatMessage($b3e9148af2322522$var$messages.selectLabel, {
            fieldName: data.name
        }),
        appearance: "subtle",
        options: options,
        getOptionValue: (option)=>option.value,
        getOptionLabel: (option)=>option.value,
        value: selectedOption,
        onChange: handleChange,
        onMenuOpen: handleMenuOpen,
        onMenuClose: handleMenuClose,
        searchThreshold: 5,
        isSearchable: false,
        isRequired: isRequired || false,
        isClearable: isMenuOpen && !isRequired,
        placeholder: formatMessage($b3e9148af2322522$var$messages.noOptionMessage),
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3e9148af2322522$var$ReadView, {
                option: option
            }),
        components: {
            Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, {
                    ...props,
                    xcss: $b3e9148af2322522$var$styles.control
                }),
            SelectContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SelectContainer, {
                    ...props,
                    xcss: $b3e9148af2322522$var$styles.container
                }),
            ValueContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
                    ...props,
                    xcss: $b3e9148af2322522$var$styles.valueContainer
                }),
            DropdownIndicator: (props)=>props.selectProps.menuIsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).DropdownIndicator, props) : null
        },
        isMulti: false,
        menuPortalTarget: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? undefined : (0, $1hQ0e.getDocument)()?.body,
        menuPosition: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? 'fixed' : 'absolute',
        menuPlacement: "auto",
        styles: (0, $iDrrr.fg)('gravityai-4581-jira-aifc-iframe-korosu') ? {
            menu: (base)=>({
                    ...base,
                    zIndex: (0, $8wMiv.layers).modal()
                }),
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $8wMiv.layers).modal()
                })
        } : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b3e9148af2322522$var$styles.readViewContainer
    }, selectedOption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3e9148af2322522$var$ReadView, {
        option: selectedOption
    }) : formatMessage($b3e9148af2322522$var$messages.noOptionMessage));
});
module.exports["JiraSingleSelectField"] = $b3e9148af2322522$export$f004bf6f4b852921;

});

parcelRegister("f4HfZ", function(module, exports) {
/**
 * @generated SignedSource<<e823e7b7827fbe8ca4357edf15b780b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f594b1817c39db33$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraSingleSelectUserPickerField_Platform",
    "selections": [
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$f594b1817c39db33$var$node.hash = "92f8d8ede281dfd71d1e1fc642b3adc5";
var $f594b1817c39db33$export$2e2bcd8739ae039 = $f594b1817c39db33$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $aLI5J = parcelRequire("aLI5J");

const $ea9a6482ad6f50f4$export$c4d34830837ed7a1 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, isFieldEditable: isFieldEditable = true, ...props })=>{
    const data = (0, $6SsN4.useFragment)((0, $f594b1817c39db33$export$2e2bcd8739ae039), field);
    const isEditable = (data?.fieldConfig?.isEditable ?? false) && isFieldEditable;
    const isRequired = data?.fieldConfig?.isRequired ?? false;
    const defaultUser = (0, $cozmU.useMemo)(()=>{
        if (data?.user?.id && data?.user?.name) return [
            {
                id: data.user.id,
                name: data.user.name,
                accountId: data.user.accountId,
                avatarUrl: data.user.picture
            }
        ];
        return null;
    }, [
        data?.user
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $aLI5J.UserPickerComponent), {
        ...props,
        isEditable: isEditable,
        isRequired: isRequired,
        defaultUsers: defaultUser,
        isMulti: false
    });
});
module.exports["JiraSingleSelectUserPickerField"] = $ea9a6482ad6f50f4$export$c4d34830837ed7a1;

});

parcelRegister("bKWb7", function(module, exports) {
/**
 * @generated SignedSource<<65f62712955b80ecf01a7cb4e040f7db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0b817830aaab163$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraSprintField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$b0b817830aaab163$var$node.hash = "9245e07b2767a85feb27d772abaeb31c";
var $b0b817830aaab163$export$2e2bcd8739ae039 = $b0b817830aaab163$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $8wMiv = parcelRequire("8wMiv");


var $jTKfH = parcelRequire("jTKfH");


var $4Qaxv = parcelRequire("4Qaxv");

const $94653646bec03ccb$var$messages = (0, $kSwu1.defineMessages)({
    selectLabel: {
        id: "jira.jira.jira-platform-fields.sprint-field.label",
        defaultMessage: "Select Sprint"
    },
    none: {
        id: "jira.jira.jira-platform-fields.sprint-field.none",
        defaultMessage: "None"
    }
});
const $94653646bec03ccb$var$styles = {
    container: "_39xV02N91d",
    readOnlyContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q2ADO _1Znuxb2ADO _39xV02N91d _0jFU0VUF4f"
};
const $94653646bec03ccb$var$selectStylesIframe = {
    menu: (base)=>({
            ...base,
            zIndex: (0, $8wMiv.layers).modal()
        }),
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $8wMiv.layers).modal()
        })
};
const $94653646bec03ccb$var$getOptionValue = (opt)=>opt.value;
const $94653646bec03ccb$var$getOptionLabel = (opt)=>opt.label;
const $94653646bec03ccb$var$SPRINT_PICKER_BASE_URL = '/rest/greenhopper/1.0/sprint/picker?query=';
const $94653646bec03ccb$var$SPRINT_BY_ID_BASE_URL = '/rest/agile/1.0/sprint/';
const $94653646bec03ccb$var$fetchSprints = (query = '')=>(0, $jTKfH.performHttpFetch)({
        path: `${$94653646bec03ccb$var$SPRINT_PICKER_BASE_URL}${encodeURIComponent(query)}`,
        options: {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    }).then((data)=>(data.allMatches ?? []).map((s)=>({
                value: String(s.id),
                label: s.name
            })));
const $94653646bec03ccb$var$sprintByIdCache = (0, $4Qaxv.LruCache)(20);
const $94653646bec03ccb$var$sprintByIdInFlight = new Map();
const $94653646bec03ccb$var$fetchSprintById = (id)=>{
    const cached = $94653646bec03ccb$var$sprintByIdCache.get(id);
    if (cached) return cached.value;
    const inFlight = $94653646bec03ccb$var$sprintByIdInFlight.get(id);
    if (inFlight) return inFlight;
    const req = (0, $jTKfH.performHttpFetch)({
        path: `${$94653646bec03ccb$var$SPRINT_BY_ID_BASE_URL}${encodeURIComponent(id)}`,
        options: {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    }).then((data)=>{
        const opt = {
            value: String(data.id),
            label: data.name ?? String(data.id)
        };
        $94653646bec03ccb$var$sprintByIdCache.set(id, Promise.resolve(opt));
        $94653646bec03ccb$var$sprintByIdInFlight.delete(id);
        return opt;
    }).catch(()=>{
        $94653646bec03ccb$var$sprintByIdInFlight.delete(id);
        return null;
    });
    $94653646bec03ccb$var$sprintByIdInFlight.set(id, req);
    return req;
};
const $94653646bec03ccb$var$SEARCH_DEBOUNCE_MS = 300;
const $94653646bec03ccb$export$542300d912507e86 = /*#__PURE__*/ (0, $cozmU.memo)(({ field: field, fieldValue: fieldValue, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $b0b817830aaab163$export$2e2bcd8739ae039), field);
    const { isRequired: isRequired, isEditable: isEditableFromConfig } = data.fieldConfig ?? {};
    const isEditable = !!(isEditableFromConfig ?? true) && isFieldEditable;
    const selectRef = (0, $cozmU.useRef)(null);
    const [options, setOptions] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const debounceTimerRef = (0, $cozmU.useRef)();
    const hasSearchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        setIsLoading(true);
        $94653646bec03ccb$var$fetchSprints().then((opts)=>{
            if (!cancelled) setOptions(opts);
        }).catch(()=>{
            if (!cancelled) setOptions([]);
        }).finally(()=>{
            if (!cancelled) setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        };
    }, []);
    const currentId = fieldValue != null ? String(fieldValue) : null;
    const [hydratedOption, setHydratedOption] = (0, $cozmU.useState)(null);
    const optionValueSet = (0, $cozmU.useMemo)(()=>new Set(options.map((opt)=>opt.value)), [
        options
    ]);
    const hydratedIdRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!currentId) {
            setHydratedOption(null);
            hydratedIdRef.current = null;
            return;
        }
        if (hydratedIdRef.current === currentId) return;
        hydratedIdRef.current = currentId;
        setHydratedOption(null);
        let cancelled = false;
        $94653646bec03ccb$var$fetchSprintById(currentId).then((opt)=>{
            if (!cancelled && opt) setHydratedOption(opt);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        currentId
    ]);
    const selected = (0, $cozmU.useMemo)(()=>{
        if (!currentId) return null;
        if (optionValueSet.has(currentId)) return options.find((opt)=>opt.value === currentId) ?? null;
        return hydratedOption;
    }, [
        options,
        optionValueSet,
        currentId,
        hydratedOption
    ]);
    const handleChange = (0, $cozmU.useCallback)((option)=>{
        onChange?.(option?.value ?? null);
        selectRef.current?.blur();
    }, [
        onChange
    ]);
    const handleMenuOpen = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpen(true);
    }, []);
    const handleMenuClose = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpen(false);
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        if (hasSearchedRef.current) {
            hasSearchedRef.current = false;
            setIsLoading(true);
            $94653646bec03ccb$var$fetchSprints().then((opts)=>{
                setOptions(opts);
            }).catch(()=>{
                setOptions([]);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, []);
    const handleInputChange = (0, $cozmU.useCallback)((inputValue, actionMeta)=>{
        if (actionMeta.action !== 'input-change') return;
        hasSearchedRef.current = true;
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        setIsLoading(true);
        debounceTimerRef.current = setTimeout(()=>{
            $94653646bec03ccb$var$fetchSprints(inputValue).then((opts)=>{
                setOptions(opts);
            }).catch(()=>{
                setOptions([]);
            }).finally(()=>{
                setIsLoading(false);
            });
        }, $94653646bec03ccb$var$SEARCH_DEBOUNCE_MS);
    }, []);
    if (!isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $94653646bec03ccb$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $94653646bec03ccb$var$styles.readOnlyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: selected?.label ? 'color.text' : 'color.text.subtle',
        maxLines: 1
    }, selected?.label || formatMessage($94653646bec03ccb$var$messages.none))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $94653646bec03ccb$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        ref: selectRef,
        label: formatMessage($94653646bec03ccb$var$messages.selectLabel),
        appearance: "subtle",
        options: options,
        isLoading: isLoading,
        value: selected,
        onChange: handleChange,
        onInputChange: handleInputChange,
        onMenuOpen: handleMenuOpen,
        onMenuClose: handleMenuClose,
        getOptionValue: $94653646bec03ccb$var$getOptionValue,
        getOptionLabel: $94653646bec03ccb$var$getOptionLabel,
        isRequired: !!isRequired,
        isClearable: isMenuOpen && !isRequired,
        isMulti: false,
        isSearchable: true,
        menuPlacement: "auto",
        menuPosition: "fixed",
        styles: $94653646bec03ccb$var$selectStylesIframe
    }));
});
module.exports["JiraSprintField"] = $94653646bec03ccb$export$542300d912507e86;

});

parcelRegister("7R0Ml", function(module, exports) {
/**
 * @generated SignedSource<<37a5a710675c6ebc6fab63a51f8f40df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $28de1a7de497a8d2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraTimeTrackingField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$28de1a7de497a8d2$var$node.hash = "0c11996e1f104db6163ad2f69fb28ccf";
var $28de1a7de497a8d2$export$2e2bcd8739ae039 = $28de1a7de497a8d2$var$node;



var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $jLnA6 = parcelRequire("jLnA6");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $hcOES = parcelRequire("hcOES");


var $gVzkK = parcelRequire("gVzkK");

/**
 * Utilities in this file have been copied over from @jira/src/packages/issue/format-time/src/isValidTimeString.tsx
 */ var $52a617aece81b869$exports = {};

var $aJIqZ = parcelRequire("aJIqZ");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $52a617aece81b869$var$nativeIsFinite = $aJIqZ.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $52a617aece81b869$var$isFinite(value) {
    return typeof value == 'number' && $52a617aece81b869$var$nativeIsFinite(value);
}
$52a617aece81b869$exports = $52a617aece81b869$var$isFinite;


/**
 * Utilities in this file have been copied over from @jira/src/packages/issue/get-formatted-time-string/src/secondsToTimeString.tsx
 */ const $2dd887545282b4a3$var$MINUTES_PER_HOUR = 60;
const $2dd887545282b4a3$var$SECONDS_PER_MINUTE = 60;
const $2dd887545282b4a3$var$secondsToTimeString = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $2dd887545282b4a3$var$MINUTES_PER_HOUR * $2dd887545282b4a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $2dd887545282b4a3$var$MINUTES_PER_HOUR * $2dd887545282b4a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $2dd887545282b4a3$var$MINUTES_PER_HOUR * $2dd887545282b4a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $2dd887545282b4a3$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};
var $2dd887545282b4a3$export$2e2bcd8739ae039 = $2dd887545282b4a3$var$secondsToTimeString;


/**
 * Utilities in this file have been copied over from @jira/src/packages/issue/get-formatted-time-string/src/timeStringToSeconds.tsx
 */ const $ba6360079c379903$var$MINUTES_PER_HOUR = 60;
const $ba6360079c379903$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $ba6360079c379903$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $ba6360079c379903$var$convertToUnitQuantity = (rawString)=>{
    const matches = $ba6360079c379903$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replace(/,/g, '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $ba6360079c379903$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $ba6360079c379903$var$MINUTES_PER_HOUR * $ba6360079c379903$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $ba6360079c379903$var$MINUTES_PER_HOUR * $ba6360079c379903$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $ba6360079c379903$var$MINUTES_PER_HOUR * $ba6360079c379903$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $ba6360079c379903$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($ba6360079c379903$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $ba6360079c379903$export$2e2bcd8739ae039 = $ba6360079c379903$var$timeStringToSeconds;


const $c20a24f85e0a00f3$export$8a86f5af4e5a2dd8 = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $c20a24f85e0a00f3$export$2b38dfc7401492ba = (serverDefaultUnit)=>$c20a24f85e0a00f3$export$8a86f5af4e5a2dd8[serverDefaultUnit] || $c20a24f85e0a00f3$export$8a86f5af4e5a2dd8.minute;
const $c20a24f85e0a00f3$var$isNumeric = (num)=>num.length > 0 && !Number.isNaN(Number(num));
const $c20a24f85e0a00f3$var$isValidTimeFormat = (value)=>{
    return value === 'pretty' || value === 'days' || value === 'hours';
};
const $c20a24f85e0a00f3$var$isValidTimeUnit = (value)=>{
    return value === 'week' || value === 'day' || value === 'hour' || value === 'minute';
};
const $c20a24f85e0a00f3$export$868e58349a7161ca = (value, defaultFormat)=>{
    if (!value) return defaultFormat;
    const lowercased = value.toLowerCase();
    if ($c20a24f85e0a00f3$var$isValidTimeFormat(lowercased)) return lowercased;
    return defaultFormat;
};
const $c20a24f85e0a00f3$export$64c6fb7fbd1625b7 = (value, defaultUnit)=>{
    if (!value) return defaultUnit;
    const lowercased = value.toLowerCase();
    if ($c20a24f85e0a00f3$var$isValidTimeUnit(lowercased)) return lowercased;
    return defaultUnit;
};
const $c20a24f85e0a00f3$var$isTimeStringValid = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $ba6360079c379903$export$2e2bcd8739ae039)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($52a617aece81b869$exports)))(result);
};
const $c20a24f85e0a00f3$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $2dd887545282b4a3$export$2e2bcd8739ae039)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $c20a24f85e0a00f3$var$appendTimeUnitIfMissing = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = $c20a24f85e0a00f3$var$isNumeric(trimmedValue.replace(/,/g, '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${$c20a24f85e0a00f3$export$2b38dfc7401492ba(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $c20a24f85e0a00f3$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $c20a24f85e0a00f3$var$appendTimeUnitIfMissing(config)(value);
        return timeString === '' || $c20a24f85e0a00f3$var$isTimeStringValid(timeString);
    };
const $c20a24f85e0a00f3$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $c20a24f85e0a00f3$var$appendTimeUnitIfMissing(config)(value);
        if (!$c20a24f85e0a00f3$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $ba6360079c379903$export$2e2bcd8739ae039)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };



var $2v5cF = parcelRequire("2v5cF");

const $3fdbe42831caf22c$export$8c7070611f332ef9 = 8;
const $3fdbe42831caf22c$export$21ed1f454652d913 = 5;
const $3fdbe42831caf22c$export$c4d2eaadfa3c28df = 'pretty';
const $3fdbe42831caf22c$export$2ee07242bbb09b61 = 'minute'; /**
                                            * Validates and transforms an input string in the format " *w *d *h *m " (representing weeks, days, hours and minutes)
                                            * into seconds.
                                            *
                                            * Examples: "4d", "5h 30m", "60m", "3w"
                                            *
                                            * @param timeString - The time string to parse (e.g., "4d", "5h 30m", "60m", "3w")
                                            * @param config - Time tracking configuration with working hours/days
                                            * @returns Object with `isValid` boolean and `seconds` number (or null if invalid)
                                            */ 
const $3fdbe42831caf22c$export$402eaf1f8a25a8a = (timeString, config)=>{
    if (!timeString || timeString.trim() === '') return {
        isValid: true,
        seconds: 0
    };
     // Check time string is valid first
    const isValid = (0, $c20a24f85e0a00f3$export$669626963db3b187)(config)(timeString);
    if (!isValid) return {
        isValid: false,
        seconds: null
    };
     // Always parse to seconds first for easier comparison and reformatting
    // i.e. if user inputs "500h", it will be parsed to 1800000 seconds then formatted to "12w 2d 4h" (assuming default hours and days)
    const seconds = (0, $c20a24f85e0a00f3$export$53148bfa4e677363)(config)(timeString);
    return {
        isValid: true,
        seconds: seconds
    };
};
const $3fdbe42831caf22c$var$noneMessage = (0, $kSwu1.defineMessage)({
    id: "jira.jira.jira-platform-fields.time-tracking-field.none",
    defaultMessage: "None"
});
const $3fdbe42831caf22c$var$invalidFormatMessage = (0, $kSwu1.defineMessage)({
    id: "jira.jira.jira-platform-fields.time-tracking-field.invalid-format-message",
    defaultMessage: "Your estimate must be in the format 2w 4d 6h 45m"
});
const $3fdbe42831caf22c$var$styles = {
    textFieldContainer: "_39xV02N91d _3138424F84",
    textFieldContainerReadView: "_39xV02N91d",
    textField: "_39xV02N91d",
    readView: "_0jFU0VUF4f _0hPCNLDIqT _3iDTPbQ4SZ _1Znuxb2ADO _2Zuz6Q2ADO",
    editableReadView: "_0wOv4Q7zJH"
};
const $3fdbe42831caf22c$var$ReadView = /*#__PURE__*/ (0, $cozmU.memo)(({ text: text, isEditable: isEditable })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($3fdbe42831caf22c$var$styles.readView, isEditable && $3fdbe42831caf22c$var$styles.editableReadView)
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLnA6.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, text)));
}); /**
     * `JiraTimeTrackingField` is a React component that renders a Jira time tracking field,
     * supporting both editable and read-only modes. It displays the field value and allows
     * users to edit the original time estimate value if the field is editable. The component uses
     * Relay fragments to fetch the current time tracking settings.
     *
     * @param field - The Relay fragment reference for the Jira time tracking field.
     * @param fieldValue - The current original time estimate value.
     * @param onChange - Callback invoked when the original time estimate value changes.
     */ 
const $3fdbe42831caf22c$export$31728d3876d53912 = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    // eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
    const data = (0, $6SsN4.useFragment)((0, $28de1a7de497a8d2$export$2e2bcd8739ae039), // eslint-disable-next-line @atlassian/relay/use-fragment-naming
    field);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const isEditable = !!data?.fieldConfig?.isEditable && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const settingsInput = (0, $cozmU.useMemo)(()=>({
            hoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay ?? $3fdbe42831caf22c$export$8c7070611f332ef9,
            daysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek ?? $3fdbe42831caf22c$export$21ed1f454652d913,
            format: (0, $c20a24f85e0a00f3$export$868e58349a7161ca)(data?.timeTrackingSettings?.defaultFormat, $3fdbe42831caf22c$export$c4d2eaadfa3c28df),
            defaultUnit: (0, $c20a24f85e0a00f3$export$64c6fb7fbd1625b7)(data?.timeTrackingSettings?.defaultUnit, $3fdbe42831caf22c$export$2ee07242bbb09b61),
            isTimeTrackingEnabled: true
        }), [
        data?.timeTrackingSettings
    ]);
    const getCurrentValue = ()=>{
        // Type guarding in case a string is provided
        if (typeof fieldValue === 'string') return fieldValue;
        if (typeof fieldValue === 'object' && fieldValue !== null && 'originalEstimate' in fieldValue && typeof fieldValue.originalEstimate === 'string') return fieldValue.originalEstimate;
         // Default fallback
        return `0${(0, $c20a24f85e0a00f3$export$8a86f5af4e5a2dd8)[settingsInput.defaultUnit]}`;
    };
    const currentValue = getCurrentValue();
    const hasValue = currentValue != null;
    const displayText = hasValue ? currentValue : formatMessage($3fdbe42831caf22c$var$noneMessage);
    const fieldName = data.name;
    const FIELD_TYPE_FOR_ANALYTICS = 'TextField';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const validateRequired = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: fieldName,
        fieldTypeForAnalytics: FIELD_TYPE_FOR_ANALYTICS
    });
    const validate = (0, $cozmU.useCallback)((value)=>{
        const validateError = validateRequired(value);
        if (validateError) return validateError;
        const result = $3fdbe42831caf22c$export$402eaf1f8a25a8a(value, settingsInput);
        if (!result.isValid) {
            (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
                action: 'validationError',
                actionSubject: 'inlineEdit'
            }), {
                fieldName: fieldName,
                fieldType: FIELD_TYPE_FOR_ANALYTICS,
                isRequired: isRequired,
                isEditable: isEditable
            });
            return formatMessage($3fdbe42831caf22c$var$invalidFormatMessage);
        }
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable,
        formatMessage,
        settingsInput,
        validateRequired
    ]);
    const onEdit = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsEditing(true);
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable
    ]);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsEditing(false);
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable
    ]);
    const onConfirm = (0, $cozmU.useCallback)((newValue)=>{
        setIsEditing(false);
        const result = $3fdbe42831caf22c$export$402eaf1f8a25a8a(newValue, settingsInput);
        const formattedTimeString = (0, $c20a24f85e0a00f3$export$2de90790c3ad23b1)(settingsInput)(result.seconds);
        if (formattedTimeString === currentValue) {
            (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit'
            }), {
                fieldName: fieldName,
                fieldType: FIELD_TYPE_FOR_ANALYTICS,
                isRequired: isRequired,
                isEditable: isEditable
            });
            return;
        }
        if (result.isValid) {
            (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
                action: 'applied',
                actionSubject: 'inlineEdit'
            }), {
                fieldName: fieldName,
                fieldType: FIELD_TYPE_FOR_ANALYTICS,
                isRequired: isRequired,
                isEditable: isEditable
            });
            onChange({
                originalEstimate: formattedTimeString
            });
        } else (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable,
        currentValue,
        settingsInput,
        onChange
    ]);
    const ReadViewComponent = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ $cozmU.createElement($3fdbe42831caf22c$var$ReadView, {
            text: currentValue,
            isEditable: isEditable
        });
    }, [
        currentValue,
        isEditable
    ]);
    if (!isEditable) return /*#__PURE__*/ $cozmU.createElement($3fdbe42831caf22c$var$ReadView, {
        text: currentValue,
        isEditable: isEditable
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($3fdbe42831caf22c$var$styles.textFieldContainer, !isEditing && $3fdbe42831caf22c$var$styles.textFieldContainerReadView)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        isEditing: isEditable && isEditing,
        defaultValue: currentValue,
        editButtonLabel: displayText,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ $cozmU.createElement((0, $2v5cF.ValidationPopup), {
                errorMessage: errorMessage,
                trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        xcss: $3fdbe42831caf22c$var$styles.textField
                    }, /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                        ...fieldProps,
                        ...triggerProps,
                        type: "text",
                        step: "any",
                        autoFocus: true
                    })),
                placement: "right",
                showInvalidPopup: fieldProps.isInvalid
            }),
        readView: ReadViewComponent,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onEdit: onEdit,
        readViewFitContainerWidth: true,
        validate: validate
    }));
});
module.exports["JiraTimeTrackingField"] = $3fdbe42831caf22c$export$31728d3876d53912;

});

parcelRegister("QLwYi", function(module, exports) {
/**
 * @generated SignedSource<<370af5aec90a6cfa9577a0edb5470b59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f41bc32b9ff73740$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraUrlField_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        }
    ],
    "type": "JiraUrlField"
};
$f41bc32b9ff73740$var$node.hash = "fe0925cf185b84cb8f1f85633532636e";
var $f41bc32b9ff73740$export$2e2bcd8739ae039 = $f41bc32b9ff73740$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jFZPQ = parcelRequire("jFZPQ");

const $cfac46d01265a734$export$13eac96be9691ddf = ({ fieldValue: fieldValue, field: field, isFieldEditable: isFieldEditable = true, onChange: onChange })=>{
    const data = (0, $6SsN4.useFragment)((0, $f41bc32b9ff73740$export$2e2bcd8739ae039), field);
    const isEditable = (data?.fieldConfig?.isEditable ?? false) && isFieldEditable;
    const isRequired = !!data?.fieldConfig?.isRequired;
    const defaultValue = typeof data?.uri === 'string' ? data.uri : '';
    const currentValue = typeof fieldValue === 'string' ? fieldValue : ''; // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (fieldValue == null && defaultValue !== '' && isFirstRenderRef.current) onChange(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        fieldValue,
        onChange,
        defaultValue
    ]);
    const handleChange = (0, $cozmU.useCallback)((newValue)=>{
        onChange(newValue === '' ? null : newValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $jFZPQ.CustomTextField), {
        isEditable: !!isEditable,
        isRequired: !!isRequired,
        currentValue: currentValue,
        fieldName: data?.name,
        onChange: handleChange,
        inputType: "url"
    });
};
module.exports["JiraUrlField"] = $cfac46d01265a734$export$13eac96be9691ddf;

});

parcelRegister("jR0Nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $eDWhq = parcelRequire("eDWhq");

/**
 * Binds teardown logic to multiple window lifecycle events to ensure cleanup occurs
 * when the current JavaScript context is being destroyed (e.g., page unload, navigation).
 *
 * The provided `teardown` function will be invoked once when any of the following events fire:
 * - `beforeunload`
 * - `unload`
 * - `pagehide`
 *
 * The event listeners are automatically removed after invocation to prevent memory leaks.
 * No return value is yielded from the event handler to avoid triggering browser confirmation dialogs.
 *
 * @param teardown - A function to execute cleanup logic before the window is unloaded.
 * @returns An `UnbindFn` function that can be called to manually remove the event listeners.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
 */ const $c3915642ebcb447b$var$bindRovoBridgeTeardown = (teardown)=>{
    const onCleanup = ()=>{
        teardown();
        unbind();
    };
    const unbind = (0, $cbY7C.bindAll)(globalThis.window, [
        {
            type: 'beforeunload',
            listener: onCleanup,
            options: {
                once: true
            }
        },
        {
            type: 'unload',
            listener: onCleanup,
            options: {
                once: true
            }
        },
        {
            type: 'pagehide',
            listener: onCleanup,
            options: {
                once: true
            }
        }
    ]);
    return unbind;
};
const $c3915642ebcb447b$export$e7ad81cf6c64fe07 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { clientId: clientId, setupHandler: setupHandler } = t0;
    const hasTeardownRef = (0, $cozmU.useRef)(false);
    const { ready: ready, teardown: teardown } = (0, $eDWhq.useRovoContentBridgeAPI)(clientId, setupHandler);
    let t1;
    if ($[0] !== teardown) {
        t1 = ()=>{
            if (!hasTeardownRef.current) {
                hasTeardownRef.current = true;
                teardown();
            }
        };
        $[0] = teardown;
        $[1] = t1;
    } else t1 = $[1];
    const performTeardown = t1;
    let t2;
    let t3;
    if ($[2] !== performTeardown || $[3] !== ready || $[4] !== teardown) {
        t2 = ()=>{
            const unbindRovoBridgeTeardown = $c3915642ebcb447b$var$bindRovoBridgeTeardown(teardown);
            ready();
            return ()=>{
                unbindRovoBridgeTeardown();
                performTeardown();
            };
        };
        t3 = [
            ready,
            teardown,
            performTeardown
        ];
        $[2] = performTeardown;
        $[3] = ready;
        $[4] = teardown;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : ({ clientId: clientId, setupHandler: setupHandler })=>{
    const hasTeardownRef = (0, $cozmU.useRef)(false);
    const { ready: ready, teardown: teardown } = (0, $eDWhq.useRovoContentBridgeAPI)(clientId, setupHandler);
    const performTeardown = (0, $cozmU.useCallback)(()=>{
        if (!hasTeardownRef.current) {
            hasTeardownRef.current = true;
            teardown();
        }
    }, [
        teardown
    ]);
    // Single effect ensures deterministic ordering:
    // 1. Call ready() to initialise the bridge.
    // 2. Bind window lifecycle teardown listeners AFTER the bridge is initialised.
    // 3. Unified cleanup (component unmount) first unbinds listeners then performs teardown (idempotent).
    // This reduces chances of a race where listeners fire before initialisation completes and
    // guarantees we don't miss teardown on rapid mount/unmount cycles.
    (0, $cozmU.useEffect)(()=>{
        const unbindRovoBridgeTeardown = $c3915642ebcb447b$var$bindRovoBridgeTeardown(teardown);
        ready();
        return ()=>{
            unbindRovoBridgeTeardown();
            performTeardown();
        };
    }, [
        ready,
        teardown,
        performTeardown
    ]);
};
module.exports["useRovoBridgeAPI"] = $c3915642ebcb447b$export$e7ad81cf6c64fe07;

});

parcelRegister("iEl0d", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $589102ec96bb6a62$export$7e0530015bf70936 = (0, $dSoGR.createCommand)('jira-created-items-command');
module.exports["JiraCreatedItemsCommand"] = $589102ec96bb6a62$export$7e0530015bf70936;

});

parcelRegister("gQAiI", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $85e1b5331b7b34a0$export$15fbd6768db72be6 = (0, $dSoGR.createCommand)('jira-decline-item-command');
module.exports["JiraDeclineItemCommand"] = $85e1b5331b7b34a0$export$15fbd6768db72be6;

});

parcelRegister("eMnb3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lF9wS = parcelRequire("lF9wS");


var $cXtTj = parcelRequire("cXtTj");


var $dTHYM = parcelRequire("dTHYM");

var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $dQLwo = parcelRequire("dQLwo");


var $eh6Ml = parcelRequire("eh6Ml");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $7eUSO = parcelRequire("7eUSO");














var $ad7Ou = parcelRequire("ad7Ou");


var $j1kxT = parcelRequire("j1kxT");







const $9c69bd68bc518813$var$_default_1 = (0, $kSwu1.defineMessages)({
    saveRelease: {
        id: "ai-mate.message-actions.jira-version-create.jira-version-create-form-footer.saveRelease",
        defaultMessage: "Create release"
    }
});
var $9c69bd68bc518813$export$2e2bcd8739ae039 = $9c69bd68bc518813$var$_default_1;


const $0e7b9a37fdb4c8cf$export$6d73c6b7b504ed3a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { readonly: readonly, status: status } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            invalid: true,
            submitting: true,
            values: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const formState = (0, $j1kxT.useFormState)(t1);
    const [isDisabledState, setIsDisabledState] = (0, $cozmU.useState)(readonly);
    let t2;
    if ($[1] !== formState?.invalid || $[2] !== formState?.values?.name || $[3] !== readonly || $[4] !== status) {
        t2 = ()=>{
            setIsDisabledState(readonly || Boolean(formState?.invalid) || !formState?.values?.name || status === "started");
        };
        $[1] = formState?.invalid;
        $[2] = formState?.values?.name;
        $[3] = readonly;
        $[4] = status;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== formState || $[7] !== readonly || $[8] !== status) {
        t3 = [
            formState,
            readonly,
            status
        ];
        $[6] = formState;
        $[7] = readonly;
        $[8] = status;
        $[9] = t3;
    } else t3 = $[9];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = formState?.submitting;
    let t5;
    if ($[10] !== intl) {
        t5 = intl.formatMessage((0, $9c69bd68bc518813$export$2e2bcd8739ae039).saveRelease);
        $[10] = intl;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== isDisabledState || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "submit",
            appearance: "primary",
            isDisabled: isDisabledState,
            isLoading: t4
        }, t5));
        $[12] = isDisabledState;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ readonly: readonly, status: status })=>{
    const intl = (0, $kSwu1.useIntl)();
    const formState = (0, $j1kxT.useFormState)({
        invalid: true,
        submitting: true,
        values: true
    });
    const [isDisabledState, setIsDisabledState] = (0, $cozmU.useState)(readonly);
    (0, $cozmU.useEffect)(()=>{
        setIsDisabledState(readonly || Boolean(formState?.invalid) || !formState?.values?.name || status === 'started');
    }, [
        formState,
        readonly,
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: isDisabledState,
        isLoading: formState?.submitting
    }, intl.formatMessage((0, $9c69bd68bc518813$export$2e2bcd8739ae039).saveRelease)));
};





const $0b7ee0ee2560a4b9$var$_default_1 = (0, $kSwu1.defineMessages)({
    presentationText: {
        id: "ai-mate.message-actions.jira-version-create.presentationText",
        defaultMessage: "I have drafted a new release for you. Please review the information below to create your new release."
    },
    projectSelectorLabel: {
        id: "ai-mate.message-actions.jira-version-create.project-selector.label.non-final",
        defaultMessage: "Space"
    },
    nameLabel: {
        id: "ai-mate.message-actions.jira-version-create.nameLabel",
        defaultMessage: "Name" // TODO: Update this to "Release name" when the feature is released
    },
    descriptionLabel: {
        id: "ai-mate.message-actions.jira-version-create.descriptionLabel",
        defaultMessage: "Description"
    },
    startDateLabel: {
        id: "ai-mate.message-actions.jira-version-create.startDateLabel",
        defaultMessage: "Start Date"
    },
    releaseDateLabel: {
        id: "ai-mate.message-actions.jira-version-create.releaseDateLabel",
        defaultMessage: "Release Date"
    },
    clearChooseDate: {
        id: "ai-mate.message-actions.jira-version-create.clearChooseDate",
        defaultMessage: "Clear choose date"
    },
    openCalendar: {
        id: "ai-mate.message-actions.jira-version-create.openCalendar",
        defaultMessage: "Open calendar"
    },
    createVersionHeading: {
        id: "ai-mate.message-actions.jira-version-create.createVersionHeading",
        defaultMessage: "Create release"
    },
    dateValidationError: {
        id: "ai-mate.message-actions.jira-version-create.dateValidationError",
        defaultMessage: "The start date cannot be after the release date."
    },
    nameValidationError: {
        id: "ai-mate.message-actions.jira-version-create.nameValidationError",
        defaultMessage: "Enter a name."
    },
    createReleaseSelected: {
        id: "ai-mate.message-actions.jira-version-create.createReleaseSelected",
        defaultMessage: "You selected \"Create Release\""
    }
});
var $0b7ee0ee2560a4b9$export$2e2bcd8739ae039 = $0b7ee0ee2560a4b9$var$_default_1;












var $6cFsl = parcelRequire("6cFsl");


var $5Sv3D = parcelRequire("5Sv3D");


var $iFXu4 = parcelRequire("iFXu4");


var $cJ0FD = parcelRequire("cJ0FD");







var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");





var $hlvTd = parcelRequire("hlvTd");


var $haiCi = parcelRequire("haiCi");

const $e8a95c6114c24605$var$styles = {
    customControl: "_39xV02N91d",
    projectIcon: "_0bjKvDcjp5 _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F"
};
const $e8a95c6114c24605$var$DEBOUNCE_DELAY = 300;
const $e8a95c6114c24605$var$extractProjectFromARI = (input)=>{
    // Match the last number digits after "project/"
    const pattern = /project\/(\d+)$/;
    const match = input.match(pattern);
    return match ? match[1] : '';
};
const $e8a95c6114c24605$export$8090ddd4c79fffdc = `
query GetProject($projectAri: ID!) {
  jira {
    jiraProject(id: $projectAri) {
	  id
	  projectId
      name
	  avatar {
		xsmall
	  }
    }
  }
}`;
const $e8a95c6114c24605$export$1f1bf7370aa8d830 = `
query GetProjects($query: String!, $siteAri: String!) {
  	search {
		search(
			query: $query
			filters: {
				entities: ["ati:cloud:jira:project"],
				locations: [$siteAri],
        jiraFilters: {
          projectFilter : {
            projectTypes : software
          }
        }
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					... on SearchResultJiraProject {
						id
						title
						iconUrl
						url

					}
				}
			}
		}
	}
}
`;
const $e8a95c6114c24605$export$a764642e4b725728 = ({ siteId: siteId, onProjectChangeSelect: onProjectChangeSelect, initialProjectId: initialProjectId, selectedProject: selectedProject, isDisabled: isDisabled })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [allOptions, setAllOptions] = (0, $cozmU.useState)([]);
    const [displayedOptions, setDisplayedOptions] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const hasFetchedInitialProject = (0, $cozmU.useRef)(false);
    const sortOptionsWithSelectedFirst = (0, $cozmU.useCallback)((options)=>{
        if (!selectedProject?.value || !options || options.length === 0) return options || [];
        const otherOptions = options.filter((option)=>{
            let optionValue = option.value;
            if (typeof option.value === 'string') optionValue = $e8a95c6114c24605$var$extractProjectFromARI(option.value) || option.value;
            return optionValue !== selectedProject.value;
        });
        return [
            selectedProject,
            ...otherOptions
        ];
    }, [
        selectedProject
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!initialProjectId || hasFetchedInitialProject.current) return;
        hasFetchedInitialProject.current = true;
        (async ()=>{
            try {
                const { data: { jira: { jiraProject: jiraProject } } } = await (0, $haiCi.performGqlFetch)({
                    gqlQuery: $e8a95c6114c24605$export$8090ddd4c79fffdc,
                    variables: {
                        projectAri: `ari:cloud:jira:${siteId}:project/${initialProjectId}`
                    }
                });
                onProjectChangeSelect({
                    projectId: jiraProject.projectId,
                    projectName: jiraProject.name,
                    iconUrl: jiraProject.avatar?.xsmall
                });
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'GetProjectQueryError',
                    tags: {
                        cloudId: siteId
                    }
                });
            }
        })();
    }, [
        initialProjectId,
        siteId,
        onProjectChangeSelect
    ]);
    const loadOptions = (0, $cozmU.useCallback)(async (value)=>{
        setIsLoading(true);
        try {
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $e8a95c6114c24605$export$1f1bf7370aa8d830,
                variables: {
                    query: value,
                    siteAri: `ari:cloud:jira::site/${siteId}`
                }
            });
            return response.data?.search?.search?.edges?.map((edge)=>edge.node)?.map((item)=>({
                    label: item.title,
                    value: item.id,
                    iconUrl: item.iconUrl
                })) ?? [];
        } catch (error_0) {
            (0, $hlvTd.logException)({
                exception: error_0,
                name: 'SearchJiraProjectsQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return [];
        } finally{
            setIsLoading(false);
        }
    }, [
        siteId
    ]);
    // Preload initial options when component mounts
    (0, $cozmU.useEffect)(()=>{
        const preloadOptions = async ()=>{
            if (allOptions.length === 0 && !isLoading) {
                const initialOptions = await loadOptions('');
                setAllOptions(initialOptions);
                setDisplayedOptions(initialOptions);
            }
        };
        preloadOptions();
    }, [
        allOptions.length,
        isLoading,
        loadOptions
    ]);
    const handleProjectChange = (0, $cozmU.useCallback)((selectedOption)=>{
        const selectedOptionValue = selectedOption?.value;
        if (!selectedOption || typeof selectedOptionValue !== 'string') return;
        const selectedOptionProjectId = $e8a95c6114c24605$var$extractProjectFromARI(selectedOptionValue) || selectedOptionValue;
        if (selectedOptionProjectId === selectedProject?.value) return;
        onProjectChangeSelect({
            projectId: selectedOptionProjectId,
            projectName: selectedOption.label ?? '',
            iconUrl: selectedOption.iconUrl
        });
        if (!allOptions.some((option_0)=>option_0.value === selectedOptionValue)) setAllOptions((prev)=>[
                ...prev,
                selectedOption
            ]);
        setDisplayedOptions(allOptions);
    }, [
        selectedProject,
        onProjectChangeSelect,
        allOptions
    ]);
    const [debouncedLoadOptions] = (0, $5Sv3D.default)(async (value_0)=>{
        setDisplayedOptions(await loadOptions(value_0));
    }, $e8a95c6114c24605$var$DEBOUNCE_DELAY);
    const handleInputChange = (0, $cozmU.useCallback)((inputValue, { action: action })=>{
        if (action === 'input-change') debouncedLoadOptions(inputValue);
    }, [
        debouncedLoadOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        testId: "jira-version-create-project-selector",
        inputId: "jira-version-create-project-selector-input",
        label: "Select a project",
        isDisabled: isDisabled,
        spacing: "compact",
        appearance: "default",
        value: selectedProject,
        isLoading: isLoading,
        options: sortOptionsWithSelectedFirst(displayedOptions),
        onChange: handleProjectChange,
        onInputChange: handleInputChange,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoJiraVersionCreateProjectSelector'
            });
        },
        onMenuClose: ()=>{
            setDisplayedOptions(allOptions);
        },
        components: {
            Control: $e8a95c6114c24605$var$CustomControl,
            Option: $e8a95c6114c24605$var$CustomOption,
            SingleValue: $e8a95c6114c24605$var$CustomSingleValue
        }
    });
};
const $e8a95c6114c24605$var$ProjectIconImage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { iconUrl: iconUrl } = t0;
    if (!iconUrl) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                label: "",
                size: "small"
            });
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    let t1;
    if ($[1] !== iconUrl) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e8a95c6114c24605$var$styles.projectIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: iconUrl,
            alt: ""
        }));
        $[1] = iconUrl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ iconUrl: iconUrl })=>{
    if (!iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e8a95c6114c24605$var$styles.projectIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: iconUrl,
        alt: ""
    }));
};
const $e8a95c6114c24605$var$CustomOption = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== props.data.iconUrl) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a95c6114c24605$var$ProjectIconImage, {
            iconUrl: props.data.iconUrl
        });
        $[3] = props.data.iconUrl;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== children || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t1, children);
        $[5] = children;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== props || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, t2);
        $[8] = props;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a95c6114c24605$var$ProjectIconImage, {
        iconUrl: props.data.iconUrl
    }), children));
};
const $e8a95c6114c24605$var$CustomSingleValue = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SingleValue, props, t1);
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, children));
};
const $e8a95c6114c24605$var$CustomControl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let children;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        t1 = props.getValue()?.[0];
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
    } else {
        children = $[1];
        props = $[2];
        t1 = $[3];
    }
    const selectedOption = t1;
    const t2 = selectedOption?.iconUrl;
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a95c6114c24605$var$ProjectIconImage, {
            iconUrl: t2
        });
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== children || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInline: "space.100",
            xcss: $e8a95c6114c24605$var$styles.customControl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t3, children));
        $[6] = children;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== props || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, props, t4);
        $[9] = props;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children, ...props })=>{
    const selectedOption = props.getValue()?.[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingInline: "space.100",
        xcss: $e8a95c6114c24605$var$styles.customControl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a95c6114c24605$var$ProjectIconImage, {
        iconUrl: selectedOption?.iconUrl
    }), children)));
};


const $fbf7db78bb75b8ac$var$styles = {
    inlineSpacing: "_2mHwu85zaO",
    cardGroup: "_23rrnH2HTN _0bjKvD8fU6 _1UtDYzy7kJ _0KLXruqi9L _2OUyjtzwhj",
    divider: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    boxSpacing: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    boxSuccess: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1UtDYzy7kJ _0KLXruqi9L _2OUyjtzwhj _0Of8r21Y8M _1Znuxb2ADO _1wydGW1Y8M _2Zuz6Q2ADO _313842S40j _1DCdHiS40j"
}; //JiraVersionCreate component also renders outside of the unified renderer, so we need to keep the old props structure
const $fbf7db78bb75b8ac$export$bcc257b9b8728ae1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { onConfirm: onConfirm, actions: actions, getReadonly: getReadonly, getStatus: getStatus, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [hasDateValidationError, setHasDateValidationError] = (0, $cozmU.useState)(false);
    const firstAction = actions[0];
    let t1;
    if ($[0] !== firstAction || $[1] !== getStatus) {
        t1 = getStatus(firstAction);
        $[0] = firstAction;
        $[1] = getStatus;
        $[2] = t1;
    } else t1 = $[2];
    const status = t1;
    const { data: data } = firstAction;
    const { name: name, description: description, startDate: startDate, releaseDate: releaseDate, projectId: projectId, driver: driver } = data;
    let t2;
    if ($[3] !== data.name || $[4] !== projectId) {
        t2 = projectId ? {
            label: data.name,
            value: projectId
        } : undefined;
        $[3] = data.name;
        $[4] = projectId;
        $[5] = t2;
    } else t2 = $[5];
    const [selectedProject, setSelectedProject] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (t4)=>{
            const { projectId: projectId_0, projectName: projectName, iconUrl: iconUrl } = t4;
            setSelectedProject({
                label: projectName,
                value: projectId_0,
                iconUrl: iconUrl
            });
        };
        $[6] = t3;
    } else t3 = $[6];
    const handleProjectChange = t3;
    let t4;
    if ($[7] !== actions || $[8] !== conversationId || $[9] !== driver || $[10] !== firstAction.actionId || $[11] !== firstAction.invocationId || $[12] !== firstAction.key || $[13] !== firstAction.status || $[14] !== getStatus || $[15] !== messageId || $[16] !== onConfirm || $[17] !== projectId || $[18] !== recipientAgentId || $[19] !== selectedProject?.value || $[20] !== sendAnalyticsEvent || $[21] !== sendMessageConfirmedTools) {
        t4 = (data_0)=>{
            const mergedData = {
                ...data_0,
                driver: driver || null,
                projectId: String(selectedProject?.value ?? projectId ?? "")
            };
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "jiraVersionCreateRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
            } else onConfirm({
                key: firstAction.key,
                invocationId: firstAction.invocationId,
                data: mergedData,
                actionId: firstAction.actionId,
                status: firstAction.status
            });
            sendAnalyticsEvent({
                eventType: "track",
                action: "submit",
                actionSubject: "rovoJiraCreateVersionSubmit"
            });
        };
        $[7] = actions;
        $[8] = conversationId;
        $[9] = driver;
        $[10] = firstAction.actionId;
        $[11] = firstAction.invocationId;
        $[12] = firstAction.key;
        $[13] = firstAction.status;
        $[14] = getStatus;
        $[15] = messageId;
        $[16] = onConfirm;
        $[17] = projectId;
        $[18] = recipientAgentId;
        $[19] = selectedProject?.value;
        $[20] = sendAnalyticsEvent;
        $[21] = sendMessageConfirmedTools;
        $[22] = t4;
    } else t4 = $[22];
    selectedProject?.value;
    const handleSubmit = t4;
    let t5;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (startDateValue, releaseDateValue)=>{
            const isValid = !Boolean(startDateValue) || !Boolean(releaseDateValue) || new Date(startDateValue) <= new Date(releaseDateValue);
            setHasDateValidationError(!isValid);
            return !isValid ? "INVALID_DATE_PERIOD" : undefined;
        };
        $[23] = t5;
    } else t5 = $[23];
    const validateDatePeriod = t5;
    let t6;
    if ($[24] !== firstAction || $[25] !== getReadonly) {
        t6 = getReadonly(firstAction);
        $[24] = firstAction;
        $[25] = getReadonly;
        $[26] = t6;
    } else t6 = $[26];
    const readonly = t6;
    let t7;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = new Date();
        $[27] = t7;
    } else t7 = $[27];
    const today = t7;
    let t8;
    if ($[28] !== intl) {
        t8 = ()=>intl.formatDate(today, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            });
        $[28] = intl;
        $[29] = t8;
    } else t8 = $[29];
    const getTodayDate = t8;
    let t9;
    if ($[30] !== intl) {
        t9 = ()=>{
            const twoWeeksLater = new Date(today);
            twoWeeksLater.setDate(twoWeeksLater.getDate() + 14);
            return intl.formatDate(twoWeeksLater, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            });
        };
        $[30] = intl;
        $[31] = t9;
    } else t9 = $[31];
    const getTwoWeeksFromNow = t9;
    let t10;
    if ($[32] !== intl) {
        t10 = intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).presentationText);
        $[32] = intl;
        $[33] = t10;
    } else t10 = $[33];
    let t11;
    if ($[34] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t10);
        $[34] = t10;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] !== cloudId || $[37] !== description || $[38] !== getTodayDate || $[39] !== getTwoWeeksFromNow || $[40] !== handleSubmit || $[41] !== hasDateValidationError || $[42] !== intl || $[43] !== name || $[44] !== projectId || $[45] !== readonly || $[46] !== releaseDate || $[47] !== selectedProject || $[48] !== startDate || $[49] !== status) {
        t12 = (0, $iDrrr.fg)("platform-design_system_team-form_conversion") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: handleSubmit,
            isDisabled: readonly
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.cardGroup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.boxSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
            appearance: "brand",
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createVersionHeading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.divider
        }, (0, $iDrrr.fg)("enable-create-releases-project-dropdown") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "project",
            id: "jira-version-create-project-selector-input",
            isRequired: true,
            defaultValue: projectId || "",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).projectSelectorLabel)
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8a95c6114c24605$export$a764642e4b725728), {
                siteId: cloudId,
                initialProjectId: projectId,
                onProjectChangeSelect: handleProjectChange,
                selectedProject: selectedProject,
                isDisabled: readonly
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            isRequired: true,
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameLabel),
            defaultValue: name,
            validate: $fbf7db78bb75b8ac$var$_temp
        }, (t13)=>{
            const { fieldProps: fieldProps, error: error } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, Boolean(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameValidationError))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "description",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).descriptionLabel),
            defaultValue: description
        }, $fbf7db78bb75b8ac$var$_temp2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $fbf7db78bb75b8ac$var$styles.inlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "startDate",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).startDateLabel),
            defaultValue: startDate,
            validate: (value_0, formState)=>validateDatePeriod(value_0, formState.releaseDate)
        }, (t14)=>{
            const { fieldProps: fieldProps_1 } = t14;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
                locale: intl.locale,
                clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
                shouldShowCalendarButton: true,
                inputLabelId: "date",
                openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
                placeholder: getTodayDate(),
                ...fieldProps_1
            });
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "releaseDate",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).releaseDateLabel),
            defaultValue: releaseDate,
            validate: (value_1, formState_0)=>validateDatePeriod(formState_0.startDate, value_1)
        }, (t15)=>{
            const { fieldProps: fieldProps_2 } = t15;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
                locale: intl.locale,
                clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
                shouldShowCalendarButton: true,
                inputLabelId: "date",
                openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
                placeholder: getTwoWeeksFromNow(),
                ...fieldProps_2
            });
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, hasDateValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).dateValidationError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.divider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e7b9a37fdb4c8cf$export$6d73c6b7b504ed3a), {
            readonly: readonly,
            status: status
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            onSubmit: handleSubmit,
            isDisabled: readonly
        }, (t16)=>{
            const { formProps: formProps } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fbf7db78bb75b8ac$var$styles.cardGroup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fbf7db78bb75b8ac$var$styles.boxSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                appearance: "brand",
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createVersionHeading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fbf7db78bb75b8ac$var$styles.divider
            }, (0, $iDrrr.fg)("enable-create-releases-project-dropdown") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "project",
                id: "jira-version-create-project-selector-input",
                isRequired: true,
                defaultValue: projectId,
                label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).projectSelectorLabel)
            }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8a95c6114c24605$export$a764642e4b725728), {
                    siteId: cloudId,
                    initialProjectId: projectId,
                    onProjectChangeSelect: handleProjectChange,
                    selectedProject: selectedProject,
                    isDisabled: readonly
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "name",
                isRequired: true,
                label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameLabel),
                defaultValue: name,
                validate: $fbf7db78bb75b8ac$var$_temp3
            }, (t17)=>{
                const { fieldProps: fieldProps_3, error: error_0 } = t17;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), fieldProps_3), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, Boolean(error_0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameValidationError))));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "description",
                label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).descriptionLabel),
                defaultValue: description
            }, $fbf7db78bb75b8ac$var$_temp4), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $fbf7db78bb75b8ac$var$styles.inlineSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "startDate",
                label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).startDateLabel),
                defaultValue: startDate,
                validate: (value_3, formState_1)=>validateDatePeriod(value_3, formState_1.releaseDate)
            }, (t18)=>{
                const { fieldProps: fieldProps_5 } = t18;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
                    locale: intl.locale,
                    clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
                    shouldShowCalendarButton: true,
                    inputLabelId: "date",
                    openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
                    placeholder: getTodayDate(),
                    ...fieldProps_5
                });
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "releaseDate",
                label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).releaseDateLabel),
                defaultValue: releaseDate,
                validate: (value_4, formState_2)=>validateDatePeriod(formState_2.startDate, value_4)
            }, (t19)=>{
                const { fieldProps: fieldProps_6 } = t19;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
                    locale: intl.locale,
                    clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
                    shouldShowCalendarButton: true,
                    inputLabelId: "date",
                    openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
                    placeholder: getTwoWeeksFromNow(),
                    ...fieldProps_6
                });
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, hasDateValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).dateValidationError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fbf7db78bb75b8ac$var$styles.divider
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e7b9a37fdb4c8cf$export$6d73c6b7b504ed3a), {
                readonly: readonly,
                status: status
            }))));
        });
        $[36] = cloudId;
        $[37] = description;
        $[38] = getTodayDate;
        $[39] = getTwoWeeksFromNow;
        $[40] = handleSubmit;
        $[41] = hasDateValidationError;
        $[42] = intl;
        $[43] = name;
        $[44] = projectId;
        $[45] = readonly;
        $[46] = releaseDate;
        $[47] = selectedProject;
        $[48] = startDate;
        $[49] = status;
        $[50] = t12;
    } else t12 = $[50];
    let t13;
    if ($[51] !== intl || $[52] !== status) {
        t13 = status === "started" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.boxSuccess
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            size: "small",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createReleaseSelected),
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createReleaseSelected)))));
        $[51] = intl;
        $[52] = status;
        $[53] = t13;
    } else t13 = $[53];
    let t14;
    if ($[54] !== t11 || $[55] !== t12 || $[56] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t11, t12, t13);
        $[54] = t11;
        $[55] = t12;
        $[56] = t13;
        $[57] = t14;
    } else t14 = $[57];
    return t14;
} : ({ onConfirm: onConfirm, actions: actions, getReadonly: getReadonly, getStatus: getStatus, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [hasDateValidationError, setHasDateValidationError] = (0, $cozmU.useState)(false);
    const firstAction = actions[0];
    const status = getStatus(firstAction);
    const { data: data } = firstAction;
    const { name: name, description: description, startDate: startDate, releaseDate: releaseDate, projectId: projectId, driver: driver } = data;
    const [selectedProject, setSelectedProject] = (0, $cozmU.useState)(projectId ? {
        label: data.name,
        value: projectId
    } : undefined);
    const handleProjectChange = (0, $cozmU.useCallback)(({ projectId: projectId_0, projectName: projectName, iconUrl: iconUrl })=>{
        setSelectedProject({
            label: projectName,
            value: projectId_0,
            iconUrl: iconUrl
        });
    }, []);
    const handleSubmit = (0, $cozmU.useCallback)((data_0)=>{
        const mergedData = {
            ...data_0,
            driver: driver || null,
            projectId: String(selectedProject?.value ?? projectId ?? '')
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'jiraVersionCreateRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
        } else onConfirm({
            key: firstAction.key,
            invocationId: firstAction.invocationId,
            data: mergedData,
            actionId: firstAction.actionId,
            status: firstAction.status
        });
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'submit',
            actionSubject: 'rovoJiraCreateVersionSubmit'
        });
    }, [
        firstAction,
        actions,
        onConfirm,
        sendAnalyticsEvent,
        selectedProject?.value,
        projectId,
        driver,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        getStatus
    ]);
    const validateDatePeriod = (startDateValue, releaseDateValue)=>{
        const isValid = !Boolean(startDateValue) || !Boolean(releaseDateValue) || new Date(startDateValue) <= new Date(releaseDateValue);
        setHasDateValidationError(!isValid);
        return !isValid ? 'INVALID_DATE_PERIOD' : undefined;
    };
    const readonly = getReadonly(firstAction);
    const today = new Date();
    const getTodayDate = ()=>intl.formatDate(today, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    const getTwoWeeksFromNow = ()=>{
        const twoWeeksLater = new Date(today);
        twoWeeksLater.setDate(twoWeeksLater.getDate() + 14);
        return intl.formatDate(twoWeeksLater, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).presentationText)), (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit,
        isDisabled: readonly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fbf7db78bb75b8ac$var$styles.cardGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fbf7db78bb75b8ac$var$styles.boxSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createVersionHeading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fbf7db78bb75b8ac$var$styles.divider
    }, (0, $iDrrr.fg)('enable-create-releases-project-dropdown') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "project",
        id: "jira-version-create-project-selector-input",
        isRequired: true,
        defaultValue: projectId || '',
        label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).projectSelectorLabel)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8a95c6114c24605$export$a764642e4b725728), {
            siteId: cloudId,
            initialProjectId: projectId,
            onProjectChangeSelect: handleProjectChange,
            selectedProject: selectedProject,
            isDisabled: readonly
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "name",
        isRequired: true,
        label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameLabel),
        defaultValue: name,
        validate: (value, _, fieldState)=>(fieldState.dirty || fieldState.touched) && !value ? 'EMPTY_NAME' : undefined
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, Boolean(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameValidationError))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "description",
        label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).descriptionLabel),
        defaultValue: description
    }, ({ fieldProps: fieldProps_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), fieldProps_0)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $fbf7db78bb75b8ac$var$styles.inlineSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "startDate",
        label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).startDateLabel),
        defaultValue: startDate,
        validate: (value_0, formState)=>// @ts-expect-error - formState type from @atlaskit/form does not expose startDate/releaseDate; upstream type gap
            validateDatePeriod(value_0, formState.releaseDate)
    }, ({ fieldProps: fieldProps_1 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
            locale: intl.locale,
            clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
            shouldShowCalendarButton: true,
            inputLabelId: "date",
            openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
            placeholder: getTodayDate(),
            ...fieldProps_1
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "releaseDate",
        label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).releaseDateLabel),
        defaultValue: releaseDate,
        validate: (value_1, formState_0)=>// @ts-expect-error - formState type from @atlaskit/form does not expose startDate/releaseDate; upstream type gap
            validateDatePeriod(formState_0.startDate, value_1)
    }, ({ fieldProps: fieldProps_2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
            locale: intl.locale,
            clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
            shouldShowCalendarButton: true,
            inputLabelId: "date",
            openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
            placeholder: getTwoWeeksFromNow(),
            ...fieldProps_2
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, hasDateValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).dateValidationError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fbf7db78bb75b8ac$var$styles.divider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e7b9a37fdb4c8cf$export$6d73c6b7b504ed3a), {
        readonly: readonly,
        status: status
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit,
        isDisabled: readonly
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.cardGroup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.boxSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
            appearance: "brand",
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createVersionHeading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.divider
        }, (0, $iDrrr.fg)('enable-create-releases-project-dropdown') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "project",
            id: "jira-version-create-project-selector-input",
            isRequired: true,
            defaultValue: projectId,
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).projectSelectorLabel)
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8a95c6114c24605$export$a764642e4b725728), {
                siteId: cloudId,
                initialProjectId: projectId,
                onProjectChangeSelect: handleProjectChange,
                selectedProject: selectedProject,
                isDisabled: readonly
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            isRequired: true,
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameLabel),
            defaultValue: name,
            validate: (value_2, __0, fieldState_0)=>(fieldState_0.dirty || fieldState_0.touched) && !value_2 ? 'EMPTY_NAME' : undefined
        }, ({ fieldProps: fieldProps_3, error: error_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), fieldProps_3), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, Boolean(error_0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).nameValidationError))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "description",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).descriptionLabel),
            defaultValue: description
        }, ({ fieldProps: fieldProps_4 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), fieldProps_4)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $fbf7db78bb75b8ac$var$styles.inlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "startDate",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).startDateLabel),
            defaultValue: startDate,
            validate: (value_3, formState_1)=>// @ts-expect-error - formState type from @atlaskit/form does not expose startDate/releaseDate; upstream type gap
                validateDatePeriod(value_3, formState_1.releaseDate)
        }, ({ fieldProps: fieldProps_5 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
                locale: intl.locale,
                clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
                shouldShowCalendarButton: true,
                inputLabelId: "date",
                openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
                placeholder: getTodayDate(),
                ...fieldProps_5
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "releaseDate",
            label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).releaseDateLabel),
            defaultValue: releaseDate,
            validate: (value_4, formState_2)=>// @ts-expect-error - formState type from @atlaskit/form does not expose startDate/releaseDate; upstream type gap
                validateDatePeriod(formState_2.startDate, value_4)
        }, ({ fieldProps: fieldProps_6 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
                locale: intl.locale,
                clearControlLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).clearChooseDate),
                shouldShowCalendarButton: true,
                inputLabelId: "date",
                openCalendarLabel: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).openCalendar),
                placeholder: getTwoWeeksFromNow(),
                ...fieldProps_6
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, hasDateValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).dateValidationError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fbf7db78bb75b8ac$var$styles.divider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e7b9a37fdb4c8cf$export$6d73c6b7b504ed3a), {
            readonly: readonly,
            status: status
        }))))), status === 'started' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fbf7db78bb75b8ac$var$styles.boxSuccess
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        size: "small",
        label: intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createReleaseSelected),
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, intl.formatMessage((0, $0b7ee0ee2560a4b9$export$2e2bcd8739ae039).createReleaseSelected))))));
};
function $fbf7db78bb75b8ac$var$_temp(value, _, fieldState) {
    return (fieldState.dirty || fieldState.touched) && !value ? "EMPTY_NAME" : undefined;
}
function $fbf7db78bb75b8ac$var$_temp2(t0) {
    const { fieldProps: fieldProps_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), fieldProps_0);
}
function $fbf7db78bb75b8ac$var$_temp3(value_2, __0, fieldState_0) {
    return (fieldState_0.dirty || fieldState_0.touched) && !value_2 ? "EMPTY_NAME" : undefined;
}
function $fbf7db78bb75b8ac$var$_temp4(t0) {
    const { fieldProps: fieldProps_4 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), fieldProps_4);
}
module.exports["JiraVersionCreateAction"] = $fbf7db78bb75b8ac$export$bcc257b9b8728ae1;

});

parcelRegister("iJGPY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afa91bdc55de1839ed910f52b2869bf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da3da89121f9544b$var$_react = $da3da89121f9544b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $da3da89121f9544b$var$_baseNew = $da3da89121f9544b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $da3da89121f9544b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/transition
 * Usage guidance:
 * Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da3da89121f9544b$var$TransitionIcon = (props)=>/*#__PURE__*/ $da3da89121f9544b$var$_react.default.createElement($da3da89121f9544b$var$_baseNew.default, Object.assign({
        name: "TransitionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$da3da89121f9544b$var$TransitionIcon.displayName = 'TransitionIcon';
var $da3da89121f9544b$var$_default = module.exports.default = $da3da89121f9544b$var$TransitionIcon;

});

parcelRegister("cxFP3", function(module, exports) {

let $92190226e2649405$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $92190226e2649405$var$load("13mnW").then(()=>parcelRequire('U0pFT'));

});

parcelRegister("bNNFr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa291a7114ac297cb48812db96298079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $897acc3bd5e6beb9$var$_react = $897acc3bd5e6beb9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $897acc3bd5e6beb9$var$_baseNew = $897acc3bd5e6beb9$var$_interopRequireDefault((parcelRequire("gElAV")));
function $897acc3bd5e6beb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Devices".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/devices
 * Usage guidance:
 * Known usages: 'Asset' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $897acc3bd5e6beb9$var$DevicesIcon = (props)=>/*#__PURE__*/ $897acc3bd5e6beb9$var$_react.default.createElement($897acc3bd5e6beb9$var$_baseNew.default, Object.assign({
        name: "DevicesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5zM13 3a.5.5 0 0 0-.5-.5h-9A.5.5 0 0 0 3 3v7h5v1.5H1.5v.5a.5.5 0 0 0 .5.5h6V14H2a2 2 0 0 1-2-2v-1.25l.004-.077A.75.75 0 0 1 .75 10h.75V3a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1.5H13zm3 11a2 2 0 0 1-2 2h-2.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2z"/>`
    }, props));
$897acc3bd5e6beb9$var$DevicesIcon.displayName = 'DevicesIcon';
var $897acc3bd5e6beb9$var$_default = module.exports.default = $897acc3bd5e6beb9$var$DevicesIcon;

});

parcelRegister("2dupP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::641f4049c4de4eca9c893ab68b600d00>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19d46392e855dad4$var$_react = $19d46392e855dad4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $19d46392e855dad4$var$_baseNew = $19d46392e855dad4$var$_interopRequireDefault((parcelRequire("gElAV")));
function $19d46392e855dad4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "HardwareConfiguration".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/hardware-configuration
 * Usage guidance:
 * Reserved for representing hardware configuration.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19d46392e855dad4$var$HardwareConfigurationIcon = (props)=>/*#__PURE__*/ $19d46392e855dad4$var$_react.default.createElement($19d46392e855dad4$var$_baseNew.default, Object.assign({
        name: "HardwareConfigurationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3a2 2 0 0 1 2-2h4v1.5H3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8H15v2a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13 3.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m1.5 0q-.002.28-.061.542l.967.559-.75 1.298-.968-.56a2.5 2.5 0 0 1-.938.546V7h-1.5V5.885a2.5 2.5 0 0 1-.938-.545l-.968.56-.75-1.3.967-.558a2.5 2.5 0 0 1 0-1.085l-.967-.558.75-1.298.968.558c.266-.244.585-.434.938-.545V0h1.5v1.114c.354.111.671.3.938.545l.968-.558.75 1.298-.967.558q.059.262.061.543"/>`
    }, props));
$19d46392e855dad4$var$HardwareConfigurationIcon.displayName = 'HardwareConfigurationIcon';
var $19d46392e855dad4$var$_default = module.exports.default = $19d46392e855dad4$var$HardwareConfigurationIcon;

});

parcelRegister("d6fii", function(module, exports) {

let $9897b2fc58064724$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9897b2fc58064724$var$load("17E6J").then(()=>parcelRequire('7ILBF'));

});

parcelRegister("1f0MK", function(module, exports) {

let $0e77cd130d9cbe02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e77cd130d9cbe02$var$load("5b9ql").then(()=>parcelRequire('j8PhF'));

});

parcelRegister("SJBPH", function(module, exports) {
const $32b87066dfc2f047$export$b1df05d3bfea11b3 = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
const $32b87066dfc2f047$var$DAY_MAP = {
    sunday: 'SUN',
    monday: 'MON',
    tuesday: 'TUE',
    wednesday: 'WED',
    thursday: 'THU',
    friday: 'FRI',
    saturday: 'SAT'
};
const $32b87066dfc2f047$var$REVERSE_DAY_MAP = {
    SUN: 'sunday',
    MON: 'monday',
    TUE: 'tuesday',
    WED: 'wednesday',
    THU: 'thursday',
    FRI: 'friday',
    SAT: 'saturday'
};
function $32b87066dfc2f047$export$7ca134fe253c555b(frontendPayload) {
    const { name: name, prompt: prompt, frequency: frequency, daysOfWeek: daysOfWeek, time: time } = frontendPayload;
    let hours;
    let minutes;
    if (time.includes('AM') || time.includes('PM')) {
        // Handle AM/PM format
        const [timePart, period] = time.split(' ');
        const [hoursStr, minutesStr] = timePart.split(':');
        hours = parseInt(hoursStr);
        minutes = parseInt(minutesStr);
        // Convert to 24-hour format
        if (period === 'PM' && hours !== 12) hours += 12;
        else if (period === 'AM' && hours === 12) hours = 0;
    } else {
        // Handle 24-hour format
        const [hoursStr, minutesStr] = time.split(':');
        hours = parseInt(hoursStr);
        minutes = parseInt(minutesStr);
    }
    let cronExpression;
    switch(frequency){
        case 'hourly':
            cronExpression = `${minutes} * * * *`;
            break;
        case 'daily':
            cronExpression = `${minutes} ${hours} * * *`;
            break;
        case 'weekdays':
            cronExpression = `${minutes} ${hours} * * MON-FRI`;
            break;
        case 'custom':
            const daysList = daysOfWeek.map((day)=>$32b87066dfc2f047$var$DAY_MAP[day]).join(',');
            cronExpression = `${minutes} ${hours} * * ${daysList}`;
            break;
        default:
            throw new Error(`Unsupported frequency: ${frequency}`);
    }
    return {
        prompt: prompt,
        scheduleExpression: cronExpression,
        title: name
    };
}
function $32b87066dfc2f047$export$46b363da4a4d2a21(backendPayload) {
    const { prompt: prompt, scheduleExpression: scheduleExpression, title: title } = backendPayload;
    const cronParts = scheduleExpression.split(' ');
    if (cronParts.length !== 5) throw new Error(`Invalid cron expression: ${scheduleExpression}`);
    const [minutes, hours, , , dayOfWeek] = cronParts;
    // Format time in AM/PM format
    const hoursNum = parseInt(hours);
    const minutesNum = parseInt(minutes);
    const ampm = hoursNum >= 12 ? 'PM' : 'AM';
    const hours12 = hoursNum % 12 || 12; // Convert 0 to 12 for 12 AM
    const time = `${hours12}:${minutesNum.toString().padStart(2, '0')} ${ampm}`;
    let frequency;
    let daysOfWeek;
    if (hours === '*') {
        frequency = 'hourly';
        daysOfWeek = [];
    } else if (dayOfWeek === '*') {
        frequency = 'daily';
        daysOfWeek = [];
    } else if (dayOfWeek === 'MON-FRI') {
        frequency = 'weekdays';
        daysOfWeek = [
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday'
        ];
    } else {
        frequency = 'custom';
        daysOfWeek = dayOfWeek.split(',').map((day)=>{
            const frontendDay = $32b87066dfc2f047$var$REVERSE_DAY_MAP[day.trim()];
            if (!frontendDay) throw new Error(`Unknown day abbreviation: ${day}`);
            return frontendDay;
        });
    }
    return {
        name: title || 'Scheduled Chat',
        prompt: prompt,
        frequency: frequency,
        daysOfWeek: daysOfWeek,
        time: time,
        ...backendPayload.ruleIdUuid !== undefined && backendPayload.ruleIdUuid !== '' ? {
            ruleIdUuid: backendPayload.ruleIdUuid
        } : {}
    };
}
// Studio SC3 API Integration
const $32b87066dfc2f047$var$isStaging = ()=>false;
const $32b87066dfc2f047$export$db85df314632a42d = 'https://studio-next-staging.atlassian.com';
const $32b87066dfc2f047$export$2e97ff3aba01850c = 'https://studio-next.atlassian.com';
function $32b87066dfc2f047$export$76becec913dd9377() {
    return $32b87066dfc2f047$var$isStaging() ? $32b87066dfc2f047$export$db85df314632a42d : $32b87066dfc2f047$export$2e97ff3aba01850c;
}
function $32b87066dfc2f047$export$adae8558d0791c3c(workspaceId, spaceId, ruleIdUuid) {
    const base = `/w/${workspaceId}/spaces/${spaceId}/automation#`;
    return `${base}/rule/${encodeURIComponent(ruleIdUuid)}`;
}
function $32b87066dfc2f047$export$afd2bd65ce6e3a50(workspaceId, spaceId, ruleIdUuid) {
    return `${$32b87066dfc2f047$export$76becec913dd9377()}${$32b87066dfc2f047$export$adae8558d0791c3c(workspaceId, spaceId, ruleIdUuid)}`;
}
const $32b87066dfc2f047$export$6962ce6890cfe117 = 'b78e328b-be49-4a4e-82b6-5158df2cb77f';
const $32b87066dfc2f047$export$bc220cf0294c0bc4 = '14c7f07b-60c0-4a38-bbaa-510e961f3866';
function $32b87066dfc2f047$var$buildStudioSc3RestPrefix(workspaceId, spaceId) {
    return `/gateway/api/automation/sc3/o/studio/t/workspace/i/${workspaceId}/internal-api/pro/rest/${spaceId}`;
}
function $32b87066dfc2f047$export$264dd2cb40028198(workspaceId, spaceId) {
    return `${$32b87066dfc2f047$var$buildStudioSc3RestPrefix(workspaceId, spaceId)}/rule`;
}
function $32b87066dfc2f047$export$b50ad82efecb3219(workspaceId, spaceId, ruleId) {
    return `${$32b87066dfc2f047$export$264dd2cb40028198(workspaceId, spaceId)}/${ruleId}`;
}
async function $32b87066dfc2f047$export$b9dd80c6f6446dda({ workspaceId: workspaceId, spaceId: spaceId, ruleName: ruleName, prompt: prompt, cronExpression: cronExpression, authorAccountId: authorAccountId, cloudId: cloudId }) {
    const url = $32b87066dfc2f047$export$264dd2cb40028198(workspaceId, spaceId);
    const connectionId = crypto.randomUUID();
    const currentTime = new Date().toISOString();
    const containerId = `__NEW__${Date.now()}`;
    const ruleConfig = {
        ruleConfigBean: {
            name: ruleName,
            isNewRule: true,
            state: 'ENABLED',
            canOtherRuleTrigger: false,
            notifyOnError: 'FIRSTERROR',
            authorAccountId: authorAccountId,
            actor: {
                type: 'ACCOUNT_ID',
                value: authorAccountId
            },
            created: currentTime,
            updated: currentTime,
            components: [
                {
                    id: `__NEW__COMPONENT__${crypto.randomUUID()}`,
                    type: 'rovo.start-agent-conversation.action',
                    component: 'ACTION',
                    value: {
                        agentInstruction: prompt
                    },
                    connectionId: connectionId,
                    // FIXED: Using the same connection ID
                    children: [],
                    conditions: []
                }
            ],
            writeAccessType: 'OWNER_ONLY',
            collaborators: [],
            trigger: {
                id: '__NEW__TRIGGER',
                type: 'scheduled',
                component: 'TRIGGER',
                value: {
                    executionMode: 'nosearch',
                    schedule: {
                        rate: 0,
                        rateInterval: 86400,
                        cronExpression: '',
                        method: 'BASIC',
                        rRule: $32b87066dfc2f047$var$buildRRuleFromCron(cronExpression)
                    }
                },
                children: [],
                conditions: []
            },
            labels: [],
            projects: [],
            ruleScope: {
                resources: [
                    `ari:cloud:studio::space/${workspaceId}/${spaceId}`
                ]
            },
            clientKey: '',
            partitionId: null,
            description: '',
            tags: [],
            billingType: 'NORMAL'
        },
        newConnections: [
            {
                id: connectionId,
                connectionTargetKey: 'com.atlassian.rovo',
                accountId: authorAccountId,
                targetConfigJson: JSON.stringify({
                    cloudId: cloudId,
                    product: 'atlassian-agent-studio'
                }),
                authType: 'ASAP',
                authUserSource: 'CONFIG',
                container: {
                    id: containerId,
                    type: 'RULE'
                },
                createdAt: currentTime,
                updatedAt: currentTime
            }
        ]
    };
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*'
        },
        credentials: 'include',
        body: JSON.stringify(ruleConfig)
    });
}
// Helper function to build RRule from cron expression
function $32b87066dfc2f047$var$buildRRuleFromCron(cronExpression) {
    const cronParts = cronExpression.split(' ');
    if (cronParts.length !== 5) throw new Error(`Invalid cron expression: ${cronExpression}`);
    const [minutes, hours, dayOfMonth, month, dayOfWeek] = cronParts;
    const now = new Date();
    let startTime = new Date(now);
    const tzid = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let rruleFreq = '';
    let rruleParams = '';
    // Check for minutely patterns (every X minutes)
    if (minutes.includes('/')) {
        const interval = parseInt(minutes.split('/')[1]);
        startTime = new Date(now.getTime() + 60000); // Start 1 minute from now
        rruleFreq = 'MINUTELY';
        rruleParams = `INTERVAL=${interval};BYSECOND=0;COUNT=5`;
    } else if (hours === '*' || hours.includes('/')) {
        const interval = hours.includes('/') ? parseInt(hours.split('/')[1]) : 1;
        const targetMinutes = minutes === '*' ? 0 : parseInt(minutes);
        startTime.setMinutes(targetMinutes, 0, 0);
        if (startTime <= now) startTime.setHours(startTime.getHours() + interval);
        rruleFreq = 'HOURLY';
        rruleParams = `INTERVAL=${interval};BYSECOND=0`;
    } else if (hours !== '*' && minutes !== '*') {
        const targetHours = parseInt(hours);
        const targetMinutes = parseInt(minutes);
        startTime.setHours(targetHours, targetMinutes, 0, 0);
        // If the time has already passed today, schedule for tomorrow
        if (startTime <= now) startTime.setDate(startTime.getDate() + 1);
        const isDaily = dayOfWeek === '*' && dayOfMonth === '*';
        const isWeekdays = dayOfWeek === 'MON-FRI';
        const isCustomDays = dayOfWeek !== '*';
        const isMonthly = month !== '*' && dayOfMonth !== '*';
        if (isDaily) {
            // Daily
            rruleFreq = 'DAILY';
            rruleParams = `BYHOUR=${targetHours};BYMINUTE=${targetMinutes};BYSECOND=0;INTERVAL=1`;
        }
        if (isWeekdays) {
            // Weekdays
            rruleFreq = 'WEEKLY';
            rruleParams = `BYDAY=MO,TU,WE,TH,FR;BYHOUR=${targetHours};BYMINUTE=${targetMinutes};BYSECOND=0`;
        }
        if (isCustomDays) {
            // Custom days
            const dayMap = {
                SUN: 'SU',
                MON: 'MO',
                TUE: 'TU',
                WED: 'WE',
                THU: 'TH',
                FRI: 'FR',
                SAT: 'SA'
            };
            const byDay = dayOfWeek.split(',').map((d)=>dayMap[d.trim()]).join(',');
            rruleFreq = 'WEEKLY';
            rruleParams = `BYDAY=${byDay};BYHOUR=${targetHours};BYMINUTE=${targetMinutes};BYSECOND=0`;
        }
        if (isMonthly) {
            // Monthly or specific day of month
            rruleFreq = 'MONTHLY';
            rruleParams = `INTERVAL=1;BYHOUR=${targetHours};BYMINUTE=${targetMinutes};BYSECOND=0;BYMONTHDAY=${dayOfMonth}`;
        }
    } else // Fallback for unsupported patterns
    throw new Error(`Unsupported cron expression: ${cronExpression}`);
    const dtstart = $32b87066dfc2f047$var$formatDTStart(startTime);
    return `BEGIN:VEVENT\nDTSTART;TZID=${tzid}:${dtstart}\nRRULE:FREQ=${rruleFreq};${rruleParams}\nEND:VEVENT\n`;
}
function $32b87066dfc2f047$var$formatDTStart(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const second = String(date.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}T${hour}${minute}${second}`;
}
function $32b87066dfc2f047$export$1b20cb8c6597178c(workspaceId, spaceId, ruleId) {
    return `${$32b87066dfc2f047$var$buildStudioSc3RestPrefix(workspaceId, spaceId)}/rule/${encodeURIComponent(ruleId)}`;
}
const $32b87066dfc2f047$export$a824a83a259c96de = [
    {
        op: 'replace',
        path: '/state',
        value: 'DISABLED'
    }
];
const $32b87066dfc2f047$export$ee8d62aad4d6e9fb = [
    {
        op: 'replace',
        path: '/state',
        value: 'ENABLED'
    }
];
async function $32b87066dfc2f047$export$7589e4f468cbbb83({ workspaceId: workspaceId, spaceId: spaceId, ruleId: ruleId, patch: patch }) {
    if (!workspaceId || !spaceId) throw new Error('workspaceId and spaceId are required for rule operations');
    const url = $32b87066dfc2f047$export$b50ad82efecb3219(workspaceId, spaceId, ruleId);
    return fetch(url, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(patch)
    });
}
async function $32b87066dfc2f047$export$497c7c1b299ac108({ workspaceId: workspaceId, spaceId: spaceId, ruleId: ruleId, body: body }) {
    const url = $32b87066dfc2f047$export$1b20cb8c6597178c(workspaceId, spaceId, ruleId);
    return fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*'
        },
        body: JSON.stringify(body)
    });
}
async function $32b87066dfc2f047$export$f6f3d93dbaec9f30({ workspaceId: workspaceId, spaceId: spaceId, ruleId: ruleId }) {
    const url = $32b87066dfc2f047$export$b50ad82efecb3219(workspaceId, spaceId, ruleId);
    return fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*'
        }
    });
}
const $32b87066dfc2f047$export$df1bf2d90cccb5f4 = '/gateway/api/assist/api/rovo/v1/scheduled-chat/studio-info';
function $32b87066dfc2f047$export$cb7dacba731875ef(data) {
    if (!data || typeof data !== 'object') return null;
    const r = data;
    const workspaceRaw = typeof r.studioWorkspaceId === 'string' && r.studioWorkspaceId || typeof r.workspaceId === 'string' && r.workspaceId || typeof r.workspace_id === 'string' && r.workspace_id;
    const spaceRaw = typeof r.defaultSpaceId === 'string' && r.defaultSpaceId || typeof r.spaceId === 'string' && r.spaceId || typeof r.space_id === 'string' && r.space_id || typeof r.studioSpaceId === 'string' && r.studioSpaceId;
    const workspaceId = typeof workspaceRaw === 'string' ? workspaceRaw.trim() : '';
    const spaceId = typeof spaceRaw === 'string' ? spaceRaw.trim() : '';
    if (!workspaceId || !spaceId) return null;
    return {
        workspaceId: workspaceId,
        spaceId: spaceId
    };
}
function $32b87066dfc2f047$var$buildScheduledChatStudioInfoRequestHeaders(params) {
    const headers = {
        'X-Product': params.productHeader.trim()
    };
    if (params.experienceId.trim()) headers['X-Experience-Id'] = params.experienceId.trim();
    if (params.cloudId.trim()) headers['X-Cloudid'] = params.cloudId.trim();
    return headers;
}
const $32b87066dfc2f047$export$740f726c2b92c3c2 = 'rovo.start-agent-conversation.action';
function $32b87066dfc2f047$export$70ea89193cb8316a(payload) {
    const FRONTEND_DAY_TO_RRULE = {
        sunday: 'SU',
        monday: 'MO',
        tuesday: 'TU',
        wednesday: 'WE',
        thursday: 'TH',
        friday: 'FR',
        saturday: 'SA'
    };
    const [hs, ms] = (payload.time ?? '09:00').split(':');
    const h = Math.min(23, Math.max(0, Number.parseInt(hs ?? '9', 10) || 0));
    const mi = Math.min(59, Math.max(0, Number.parseInt(ms ?? '0', 10) || 0));
    const pad = (n)=>String(n).padStart(2, '0');
    const dtStart = `DTSTART:20000101T${pad(h)}${pad(mi)}00Z`;
    let rrule;
    switch(payload.frequency){
        case 'hourly':
            rrule = 'RRULE:FREQ=HOURLY;INTERVAL=1';
            break;
        case 'daily':
            rrule = 'RRULE:FREQ=DAILY;INTERVAL=1';
            break;
        case 'weekdays':
            rrule = 'RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TU,WE,TH,FR';
            break;
        case 'custom':
            {
                const days = [
                    ...new Set(payload.daysOfWeek)
                ].sort((a, b)=>$32b87066dfc2f047$export$b1df05d3bfea11b3.indexOf(a) - $32b87066dfc2f047$export$b1df05d3bfea11b3.indexOf(b));
                if (days.length === 0) rrule = 'RRULE:FREQ=DAILY;INTERVAL=1';
                else {
                    const byday = days.map((d)=>FRONTEND_DAY_TO_RRULE[d]).join(',');
                    rrule = `RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=${byday}`;
                }
                break;
            }
        default:
            rrule = 'RRULE:FREQ=DAILY;INTERVAL=1';
    }
    return `BEGIN:VEVENT\n${dtStart}\n${rrule}\nEND:VEVENT`;
}
function $32b87066dfc2f047$var$applyScheduleRRuleToTrigger(trigger, rRule) {
    if (!trigger || typeof trigger !== 'object') return;
    const value = trigger.value;
    if (!value || typeof value !== 'object') return;
    const schedule = {
        ...value.schedule ?? {}
    };
    schedule.method = schedule.method ?? 'BASIC';
    schedule.rRule = rRule;
    if ('rrule' in schedule) schedule.rrule = rRule;
    value.schedule = schedule;
}
function $32b87066dfc2f047$var$findScheduledChatActionComponentIndex(components) {
    if (!Array.isArray(components)) return -1;
    for(let i = 0; i < components.length; i++){
        const c = components[i];
        if (c && typeof c === 'object' && c.type === $32b87066dfc2f047$export$740f726c2b92c3c2) return i;
    }
    return -1;
}
function $32b87066dfc2f047$export$667bf9d58ec1ed9f(listRow, payload, automationState) {
    const inner = listRow.ruleSummary ?? listRow;
    const components = inner.components;
    const i = $32b87066dfc2f047$var$findScheduledChatActionComponentIndex(components);
    if (i < 0) return null;
    if (inner.trigger === undefined || inner.trigger === null) return null;
    const rRule = $32b87066dfc2f047$export$70ea89193cb8316a(payload);
    const comp = components[i];
    if (!comp || typeof comp !== 'object') return null;
    const prevValue = comp.value && typeof comp.value === 'object' ? {
        ...comp.value
    } : {};
    const name = String(payload.name ?? inner.name ?? '');
    const promptText = String(payload.prompt ?? '');
    const nextValue = comp.type === $32b87066dfc2f047$export$740f726c2b92c3c2 ? {
        ...prevValue,
        agentInstruction: promptText
    } : {
        ...prevValue,
        prompt: promptText
    };
    const trigger = JSON.parse(JSON.stringify(inner.trigger));
    $32b87066dfc2f047$var$applyScheduleRRuleToTrigger(trigger, rRule);
    return [
        {
            op: 'replace',
            path: '/name',
            value: name
        },
        {
            op: 'replace',
            path: '/state',
            value: automationState
        },
        {
            op: 'replace',
            path: `/components/${i}/value`,
            value: nextValue
        },
        {
            op: 'replace',
            path: '/trigger',
            value: trigger
        }
    ];
}
async function $32b87066dfc2f047$export$e9b8da1d9faee175({ workspaceId: workspaceId, spaceId: spaceId, ruleId: ruleId }) {
    if (!workspaceId || !spaceId || !ruleId) return null;
    const url = $32b87066dfc2f047$export$b50ad82efecb3219(workspaceId, spaceId, ruleId);
    try {
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (!res.ok) return null;
        return await res.json();
    } catch  {
        return null;
    }
}
async function $32b87066dfc2f047$export$ee92a203897b2c83(params) {
    if (!params.productHeader?.trim()) return null;
    try {
        const response = await fetch($32b87066dfc2f047$export$df1bf2d90cccb5f4, {
            method: 'GET',
            headers: $32b87066dfc2f047$var$buildScheduledChatStudioInfoRequestHeaders(params),
            credentials: 'include'
        });
        if (!response.ok) return null;
        const data = await response.json();
        return $32b87066dfc2f047$export$cb7dacba731875ef(data);
    } catch  {
        return null;
    }
}
module.exports["SCHEDULED_CHAT_DAYS"] = $32b87066dfc2f047$export$b1df05d3bfea11b3;
module.exports["convertToBackendPayload"] = $32b87066dfc2f047$export$7ca134fe253c555b;
module.exports["convertFromBackendPayload"] = $32b87066dfc2f047$export$46b363da4a4d2a21;
module.exports["STUDIO_SC3_JSON_PATCH_PAUSE_RULE_STATE"] = $32b87066dfc2f047$export$a824a83a259c96de;
module.exports["STUDIO_SC3_JSON_PATCH_RESUME_RULE_STATE"] = $32b87066dfc2f047$export$ee8d62aad4d6e9fb;
module.exports["patchStudioSc3RuleJsonPatch"] = $32b87066dfc2f047$export$7589e4f468cbbb83;
module.exports["deleteStudioSc3Rule"] = $32b87066dfc2f047$export$f6f3d93dbaec9f30;
module.exports["buildScheduledChatStudioSc3RuleJsonPatch"] = $32b87066dfc2f047$export$667bf9d58ec1ed9f;
module.exports["fetchStudioSc3Rule"] = $32b87066dfc2f047$export$e9b8da1d9faee175;
module.exports["fetchScheduledChatStudioInfo"] = $32b87066dfc2f047$export$ee92a203897b2c83;

});

parcelRegister("fU3O0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dcde4f05570f8c79135be7d66a0f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b93f09b036470fe4$var$_react = $b93f09b036470fe4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b93f09b036470fe4$var$_baseNew = $b93f09b036470fe4$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b93f09b036470fe4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/repeat
 * Usage guidance:
 * Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b93f09b036470fe4$var$RepeatIcon = (props)=>/*#__PURE__*/ $b93f09b036470fe4$var$_react.default.createElement($b93f09b036470fe4$var$_baseNew.default, Object.assign({
        name: "RepeatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$b93f09b036470fe4$var$RepeatIcon.displayName = 'RepeatIcon';
var $b93f09b036470fe4$var$_default = module.exports.default = $b93f09b036470fe4$var$RepeatIcon;

});

parcelRegister("6iyQh", function(module, exports) {
/**
 * Deduce `nextRunAt` (ISO-8601 UTC) from automation scheduled trigger `schedule.rRule` (iCalendar VEVENT).
 */ 
var $SJBPH = parcelRequire("SJBPH");

function $8ae7801b97ef83e8$export$18f1e10d3d0eb792(rule) {
    const trigger = rule.trigger;
    const value = trigger?.value;
    const schedule = value?.schedule;
    const raw = schedule?.rRule ?? schedule?.rrule;
    return typeof raw === 'string' && raw.trim() !== '' ? raw : undefined;
}
function $8ae7801b97ef83e8$var$parseDtStartLine(line) {
    const tzMatch = line.match(/TZID=([^;:]+)[:;]/);
    const tzid = tzMatch?.[1]?.trim();
    const dtMatch = line.match(/(\d{8}T\d{6})/);
    if (!dtMatch) return null;
    const compact = dtMatch[1];
    const y = Number(compact.slice(0, 4));
    const mo = Number(compact.slice(4, 6));
    const d = Number(compact.slice(6, 8));
    const h = Number(compact.slice(9, 11));
    const mi = Number(compact.slice(11, 13));
    const s = Number(compact.slice(13, 15));
    if ([
        y,
        mo,
        d,
        h,
        mi,
        s
    ].some((n)=>Number.isNaN(n))) return null;
    return {
        tzid: tzid,
        y: y,
        mo: mo,
        d: d,
        h: h,
        mi: mi,
        s: s
    };
}
function $8ae7801b97ef83e8$var$parseRRuleLine(line) {
    const body = line.startsWith('RRULE:') ? line.slice(6) : line;
    const parts = body.split(';').map((p)=>p.trim());
    const map = {};
    for (const p of parts){
        const eq = p.indexOf('=');
        if (eq === -1) continue;
        map[p.slice(0, eq).toUpperCase()] = p.slice(eq + 1);
    }
    const freq = (map.FREQ ?? '').toUpperCase();
    if (!freq) return null;
    const interval = Math.max(1, Number.parseInt(map.INTERVAL ?? '1', 10) || 1);
    const byHour = map.BYHOUR !== undefined ? Number.parseInt(map.BYHOUR, 10) : undefined;
    const byMinute = map.BYMINUTE !== undefined ? Number.parseInt(map.BYMINUTE, 10) : undefined;
    const bySecond = map.BYSECOND !== undefined ? Number.parseInt(map.BYSECOND, 10) : undefined;
    const byDayRaw = map.BYDAY;
    const byDays = byDayRaw ? byDayRaw.split(',').map((x)=>$8ae7801b97ef83e8$var$parseByDayTwoLetter(x.trim())).filter((x)=>x !== undefined) : undefined;
    const byMonthDayRaw = map.BYMONTHDAY;
    const byMonthDayParsed = byMonthDayRaw !== undefined ? Number.parseInt(byMonthDayRaw.split(',')[0] ?? '', 10) : undefined;
    return {
        freq: freq,
        interval: interval,
        byHour: Number.isFinite(byHour) ? byHour : undefined,
        byMinute: Number.isFinite(byMinute) ? byMinute : undefined,
        bySecond: Number.isFinite(bySecond) ? bySecond : undefined,
        byDays: byDays?.length ? byDays : undefined,
        byMonthDay: Number.isFinite(byMonthDayParsed) ? byMonthDayParsed : undefined
    };
}
/** `TH`, `2TH`, `-1MO` → `TH` / `MO`. */ function $8ae7801b97ef83e8$var$parseByDayTwoLetter(raw) {
    const m = raw.match(/^(-?\d+)?([A-Z]{2})$/i);
    const code = (m?.[2] ?? raw.slice(-2)).toUpperCase();
    return /^[A-Z]{2}$/.test(code) ? code : undefined;
}
function $8ae7801b97ef83e8$var$bydayTwoLetterToJsWeekday(twoLetter) {
    const m = {
        SU: 0,
        MO: 1,
        TU: 2,
        WE: 3,
        TH: 4,
        FR: 5,
        SA: 6
    };
    return m[twoLetter.slice(0, 2).toUpperCase()] ?? -1;
}
function $8ae7801b97ef83e8$var$jsWeekdayToBydayCode(weekdaySun0) {
    return [
        'SU',
        'MO',
        'TU',
        'WE',
        'TH',
        'FR',
        'SA'
    ][weekdaySun0] ?? 'MO';
}
function $8ae7801b97ef83e8$var$getYmdInZone(ms, timeZone) {
    const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
    const parts = fmt.formatToParts(new Date(ms));
    const g = (ty)=>Number(parts.find((p)=>p.type === ty)?.value);
    return {
        y: g('year'),
        mo: g('month'),
        d: g('day')
    };
}
/** Next calendar date after `(y,mo,d)` in `timeZone` (noon-based step avoids some DST edges). */ function $8ae7801b97ef83e8$var$nextCalendarDate(y, mo, d, timeZone) {
    const noon = $8ae7801b97ef83e8$var$wallTimeToUtcMs({
        tzid: timeZone,
        y: y,
        mo: mo,
        d: d,
        h: 12,
        mi: 0,
        s: 0
    }, timeZone);
    for (const addH of [
        22,
        26,
        30
    ]){
        const cand = noon + addH * 3600000;
        const n = $8ae7801b97ef83e8$var$getYmdInZone(cand, timeZone);
        if (n.y !== y || n.mo !== mo || n.d !== d) return n;
    }
    return $8ae7801b97ef83e8$var$getYmdInZone(noon + 172800000, timeZone);
}
function $8ae7801b97ef83e8$var$zonedWeekdaySun0(ms, timeZone) {
    const w = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        weekday: 'short'
    }).format(new Date(ms));
    const map = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6
    };
    return map[w] ?? -1;
}
/**
 * Next instant ≥ `nowMs` that falls on `targetWeekdaySun0` at `hour`:`minute`:`second` in `timeZone`.
 */ function $8ae7801b97ef83e8$var$findNextWeeklyWallTime(timeZone, targetWeekdaySun0, hour, minute, second, nowMs) {
    const zone = timeZone ?? 'UTC';
    let { y: y, mo: mo, d: d } = $8ae7801b97ef83e8$var$getYmdInZone(nowMs, zone);
    for(let i = 0; i < 400; i++){
        const t = $8ae7801b97ef83e8$var$wallTimeToUtcMs({
            tzid: timeZone,
            y: y,
            mo: mo,
            d: d,
            h: hour,
            mi: minute,
            s: second
        }, timeZone);
        const wd = $8ae7801b97ef83e8$var$zonedWeekdaySun0(t, zone);
        if (wd === targetWeekdaySun0 && t >= nowMs) return t;
        const n = $8ae7801b97ef83e8$var$nextCalendarDate(y, mo, d, zone);
        y = n.y;
        mo = n.mo;
        d = n.d;
    }
    return undefined;
}
function $8ae7801b97ef83e8$var$resolveWeeklyByDays(dtStart, rrule, nowMs) {
    if (rrule.byDays?.length) return rrule.byDays;
    const zone = dtStart.tzid ?? 'UTC';
    const t0 = $8ae7801b97ef83e8$var$wallTimeToUtcMs(dtStart, dtStart.tzid);
    const wd = $8ae7801b97ef83e8$var$zonedWeekdaySun0(t0, zone);
    if (wd < 0) return undefined;
    return [
        $8ae7801b97ef83e8$var$jsWeekdayToBydayCode(wd)
    ];
}
function $8ae7801b97ef83e8$var$nextRunMsForWeekly(dtStart, rrule, nowMs) {
    if (rrule.interval !== 1) return undefined;
    const hour = rrule.byHour ?? dtStart.h;
    const minute = rrule.byMinute ?? dtStart.mi;
    const second = rrule.bySecond ?? dtStart.s;
    const dayCodes = $8ae7801b97ef83e8$var$resolveWeeklyByDays(dtStart, rrule, nowMs);
    if (!dayCodes?.length) return undefined;
    const candidates = [];
    for (const code of dayCodes){
        const wd = $8ae7801b97ef83e8$var$bydayTwoLetterToJsWeekday(code);
        if (wd < 0) continue;
        const t = $8ae7801b97ef83e8$var$findNextWeeklyWallTime(dtStart.tzid, wd, hour, minute, second, nowMs);
        if (t !== undefined) candidates.push(t);
    }
    if (candidates.length === 0) return undefined;
    return Math.min(...candidates);
}
function $8ae7801b97ef83e8$var$daysInMonth(year, month1to12) {
    return new Date(year, month1to12, 0).getDate();
}
function $8ae7801b97ef83e8$var$addCalendarMonths(year, month1to12, deltaMonths) {
    const idx = year * 12 + (month1to12 - 1) + deltaMonths;
    const y = Math.floor(idx / 12);
    const mo = idx % 12 + 1;
    return {
        y: y,
        mo: mo
    };
}
/**
 * `FREQ=MONTHLY` with BYMONTHDAY (or day-of-month from DTSTART). BYDAY forms (e.g. second Tuesday) are not supported.
 */ function $8ae7801b97ef83e8$var$nextRunMsForMonthly(dtStart, rrule, nowMs) {
    if (rrule.byDays?.length) return undefined;
    const interval = Math.max(1, rrule.interval);
    const hour = rrule.byHour ?? dtStart.h;
    const minute = rrule.byMinute ?? dtStart.mi;
    const second = rrule.bySecond ?? dtStart.s;
    const desiredDom = rrule.byMonthDay ?? dtStart.d;
    if (desiredDom < 1 || desiredDom > 31) return undefined;
    const tz = dtStart.tzid;
    for(let k = 0; k < 120; k++){
        const { y: y, mo: mo } = $8ae7801b97ef83e8$var$addCalendarMonths(dtStart.y, dtStart.mo, k * interval);
        const dim = $8ae7801b97ef83e8$var$daysInMonth(y, mo);
        const dom = Math.min(desiredDom, dim);
        const t = $8ae7801b97ef83e8$var$wallTimeToUtcMs({
            tzid: tz,
            y: y,
            mo: mo,
            d: dom,
            h: hour,
            mi: minute,
            s: second
        }, tz);
        if (t >= nowMs) return t;
    }
    return undefined;
}
function $8ae7801b97ef83e8$export$d76424cb025f97ed(raw) {
    const lines = raw.split(/\n/).map((l)=>l.trim());
    let dtStart = null;
    let rrule = null;
    for (const line of lines){
        if (line.startsWith('DTSTART')) dtStart = $8ae7801b97ef83e8$var$parseDtStartLine(line);
        else if (line.startsWith('RRULE')) rrule = $8ae7801b97ef83e8$var$parseRRuleLine(line);
    }
    if (!dtStart || !rrule) return null;
    return {
        dtStart: dtStart,
        rrule: rrule
    };
}
function $8ae7801b97ef83e8$var$wallTimeToUtcMs(dt, timeZone) {
    const { y: y, mo: mo, d: d, h: h, mi: mi, s: s } = dt;
    if (!timeZone) return Date.UTC(y, mo - 1, d, h, mi, s);
    const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
    });
    const read = (epoch)=>{
        const parts = fmt.formatToParts(new Date(epoch));
        const g = (ty)=>Number(parts.find((p)=>p.type === ty)?.value);
        return {
            y: g('year'),
            mo: g('month'),
            d: g('day'),
            h: g('hour'),
            mi: g('minute'),
            s: g('second')
        };
    };
    let t = Date.UTC(y, mo - 1, d, h, mi, s);
    for(let i = 0; i < 120; i++){
        const p = read(t);
        if (p.y === y && p.mo === mo && p.d === d && p.h === h && p.mi === mi && p.s === s) return t;
        t += ((h - p.h) * 3600 + (mi - p.mi) * 60 + (s - p.s)) * 1000;
    }
    return Date.UTC(y, mo - 1, d, h, mi, s);
}
function $8ae7801b97ef83e8$var$periodMsForFreq(freq, interval) {
    switch(freq){
        case 'MINUTELY':
            return 60000 * interval;
        case 'HOURLY':
            return 3600000 * interval;
        case 'DAILY':
            return 86400000 * interval;
        default:
            return null;
    }
}
function $8ae7801b97ef83e8$export$e989d78927f4764(slotTimestampsMs, rawSchedule, fallbackMs) {
    const sorted = [
        ...new Set(slotTimestampsMs)
    ].sort((a, b)=>a - b);
    if (sorted.length >= 2) {
        let minGap = Infinity;
        for(let i = 1; i < sorted.length; i++){
            const g = sorted[i] - sorted[i - 1];
            if (g > 0 && g < minGap) minGap = g;
        }
        if (Number.isFinite(minGap) && minGap > 0) {
            const w = Math.floor(minGap / 2) - 1;
            if (w >= 1000) return w;
        }
    }
    const parsed = $8ae7801b97ef83e8$export$d76424cb025f97ed(rawSchedule);
    if (parsed) {
        const { rrule: rrule } = parsed;
        const interval = Math.max(1, rrule.interval);
        if (rrule.freq === 'WEEKLY') {
            const periodMs = 604800000 * interval;
            return Math.max(1000, Math.floor(periodMs / 2) - 1);
        }
        if (rrule.freq === 'MONTHLY') {
            const periodMs = 2419200000 * interval;
            return Math.max(1000, Math.floor(periodMs / 2) - 1);
        }
        const period = $8ae7801b97ef83e8$var$periodMsForFreq(rrule.freq, interval);
        if (period !== null) return Math.max(1000, Math.floor(period / 2) - 1);
    }
    return fallbackMs;
}
function $8ae7801b97ef83e8$var$nextAlignedOccurrenceMs(startMs, periodMs, nowMs) {
    if (nowMs <= startMs) return startMs;
    const steps = Math.ceil((nowMs - startMs) / periodMs);
    return startMs + steps * periodMs;
}
function $8ae7801b97ef83e8$export$7741d53a2d5df058(raw, nowMs = Date.now()) {
    if (!raw?.trim()) return undefined;
    const parsed = $8ae7801b97ef83e8$export$d76424cb025f97ed(raw);
    if (!parsed) return undefined;
    const { dtStart: dtStart, rrule: rrule } = parsed;
    if (rrule.freq === 'WEEKLY') {
        const nextMs = $8ae7801b97ef83e8$var$nextRunMsForWeekly(dtStart, rrule, nowMs);
        return nextMs !== undefined ? new Date(nextMs).toISOString() : undefined;
    }
    if (rrule.freq === 'MONTHLY') {
        const nextMs = $8ae7801b97ef83e8$var$nextRunMsForMonthly(dtStart, rrule, nowMs);
        return nextMs !== undefined ? new Date(nextMs).toISOString() : undefined;
    }
    const period = $8ae7801b97ef83e8$var$periodMsForFreq(rrule.freq, rrule.interval);
    if (period === null) return undefined;
    const adjustedDtStart = {
        ...dtStart,
        h: rrule.byHour ?? dtStart.h,
        mi: rrule.byMinute ?? dtStart.mi,
        s: rrule.bySecond ?? dtStart.s
    };
    const startMs = $8ae7801b97ef83e8$var$wallTimeToUtcMs(adjustedDtStart, adjustedDtStart.tzid);
    const nextMs = $8ae7801b97ef83e8$var$nextAlignedOccurrenceMs(startMs, period, nowMs);
    return new Date(nextMs).toISOString();
}
function $8ae7801b97ef83e8$export$475050adf3d4698d(rule) {
    const raw = $8ae7801b97ef83e8$export$18f1e10d3d0eb792(rule);
    return $8ae7801b97ef83e8$export$7741d53a2d5df058(raw);
}
const $8ae7801b97ef83e8$var$MAX_SCHEDULED_OCCURRENCES = 5000;
function $8ae7801b97ef83e8$export$211a0d9f7df2a00d(rule) {
    const c = rule.created;
    if (c instanceof Date) {
        const n = c.getTime();
        return Number.isNaN(n) ? undefined : n;
    }
    if (typeof c === 'number' && Number.isFinite(c)) return c < 1e12 ? c * 1000 : c;
    if (typeof c === 'string') {
        const n = Date.parse(c);
        return Number.isNaN(n) ? undefined : n;
    }
    return undefined;
}
function $8ae7801b97ef83e8$export$38d799fe7b8ed9dc(scheduleRRule, ruleCreatedAtIso) {
    const parsed = $8ae7801b97ef83e8$export$d76424cb025f97ed(scheduleRRule);
    if (!parsed) return undefined;
    if (ruleCreatedAtIso) {
        const n = Date.parse(ruleCreatedAtIso);
        if (Number.isFinite(n)) return n;
    }
    return $8ae7801b97ef83e8$var$wallTimeToUtcMs(parsed.dtStart, parsed.dtStart.tzid);
}
function $8ae7801b97ef83e8$var$listFixedPeriodOccurrencesBetween(dtStart, periodMs, ruleCreatedMs, untilMs) {
    const startMs = $8ae7801b97ef83e8$var$wallTimeToUtcMs(dtStart, dtStart.tzid);
    const out = [];
    let t = startMs;
    if (t < ruleCreatedMs) {
        const steps = Math.ceil((ruleCreatedMs - t) / periodMs);
        t = startMs + steps * periodMs;
    }
    while(t <= untilMs && out.length < $8ae7801b97ef83e8$var$MAX_SCHEDULED_OCCURRENCES){
        out.push(t);
        t += periodMs;
    }
    return out;
}
function $8ae7801b97ef83e8$var$listWeeklyOccurrencesBetween(dtStart, rrule, ruleCreatedMs, untilMs) {
    if (rrule.interval !== 1) return [];
    const out = [];
    let cur = ruleCreatedMs;
    for(let i = 0; i < $8ae7801b97ef83e8$var$MAX_SCHEDULED_OCCURRENCES; i++){
        const next = $8ae7801b97ef83e8$var$nextRunMsForWeekly(dtStart, rrule, cur);
        if (next === undefined || next > untilMs) break;
        out.push(next);
        cur = next + 1000;
    }
    return out;
}
function $8ae7801b97ef83e8$var$listMonthlyOccurrencesBetween(dtStart, rrule, ruleCreatedMs, untilMs) {
    const out = [];
    let cur = ruleCreatedMs;
    for(let i = 0; i < $8ae7801b97ef83e8$var$MAX_SCHEDULED_OCCURRENCES; i++){
        const next = $8ae7801b97ef83e8$var$nextRunMsForMonthly(dtStart, rrule, cur);
        if (next === undefined || next > untilMs) break;
        out.push(next);
        cur = next + 1000;
    }
    return out;
}
function $8ae7801b97ef83e8$export$a41e8912a1fb97ea(raw, ruleCreatedMs, untilMs) {
    if (!raw?.trim() || untilMs < ruleCreatedMs) return [];
    const parsed = $8ae7801b97ef83e8$export$d76424cb025f97ed(raw);
    if (!parsed) return [];
    const { dtStart: dtStart, rrule: rrule } = parsed;
    if (rrule.freq === 'WEEKLY') return $8ae7801b97ef83e8$var$listWeeklyOccurrencesBetween(dtStart, rrule, ruleCreatedMs, untilMs);
    if (rrule.freq === 'MONTHLY') return $8ae7801b97ef83e8$var$listMonthlyOccurrencesBetween(dtStart, rrule, ruleCreatedMs, untilMs);
    const period = $8ae7801b97ef83e8$var$periodMsForFreq(rrule.freq, rrule.interval);
    if (period === null) return [];
    return $8ae7801b97ef83e8$var$listFixedPeriodOccurrencesBetween(dtStart, period, ruleCreatedMs, untilMs);
}
const $8ae7801b97ef83e8$var$RRULE_CODE_TO_EDITOR_DAY = {
    SU: 'sunday',
    MO: 'monday',
    TU: 'tuesday',
    WE: 'wednesday',
    TH: 'thursday',
    FR: 'friday',
    SA: 'saturday'
};
function $8ae7801b97ef83e8$var$normalizeTwoLetterDayCode(code) {
    const m = code.trim().match(/^(-?\d+)?([A-Z]{2})$/i);
    return (m?.[2] ?? code.slice(-2)).toUpperCase();
}
function $8ae7801b97ef83e8$var$codesToSortedEditorDays(codes) {
    const mapped = codes.map((c)=>$8ae7801b97ef83e8$var$RRULE_CODE_TO_EDITOR_DAY[$8ae7801b97ef83e8$var$normalizeTwoLetterDayCode(c)]).filter((d)=>d !== undefined);
    const uniq = [
        ...new Set(mapped)
    ];
    const dayOrder = (d)=>(0, $SJBPH.SCHEDULED_CHAT_DAYS).indexOf(d);
    return uniq.sort((a, b)=>dayOrder(a) - dayOrder(b));
}
function $8ae7801b97ef83e8$var$isMonThroughFriOnly(codes) {
    const set = new Set(codes.map($8ae7801b97ef83e8$var$normalizeTwoLetterDayCode));
    if (set.size !== 5) return false;
    return [
        'MO',
        'TU',
        'WE',
        'TH',
        'FR'
    ].every((c)=>set.has(c));
}
function $8ae7801b97ef83e8$var$formatEditorTime24h(hour, minute) {
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}
function $8ae7801b97ef83e8$export$e4c43d003a8e3c01(rule) {
    const raw = $8ae7801b97ef83e8$export$18f1e10d3d0eb792(rule);
    if (!raw?.trim()) return null;
    const parsed = $8ae7801b97ef83e8$export$d76424cb025f97ed(raw);
    if (!parsed) return null;
    const { dtStart: dtStart, rrule: rrule } = parsed;
    const hour = rrule.byHour ?? dtStart.h;
    const minute = rrule.byMinute ?? dtStart.mi;
    const time = $8ae7801b97ef83e8$var$formatEditorTime24h(hour, minute);
    const freq = rrule.freq.toUpperCase();
    if (freq === 'HOURLY' || freq === 'MINUTELY') return {
        frequency: 'hourly',
        daysOfWeek: [],
        time: time
    };
    if (freq === 'DAILY') return {
        frequency: 'daily',
        daysOfWeek: [],
        time: time
    };
    if (freq === 'WEEKLY') {
        let dayCodes;
        if (rrule.byDays?.length) dayCodes = rrule.byDays;
        else {
            const resolved = $8ae7801b97ef83e8$var$resolveWeeklyByDays(dtStart, rrule, Date.now());
            if (!resolved?.length) return null;
            dayCodes = resolved;
        }
        if ($8ae7801b97ef83e8$var$isMonThroughFriOnly(dayCodes)) return {
            frequency: 'weekdays',
            daysOfWeek: [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday'
            ],
            time: time
        };
        const daysOfWeek = $8ae7801b97ef83e8$var$codesToSortedEditorDays(dayCodes);
        if (daysOfWeek.length === 0) return null;
        return {
            frequency: 'custom',
            daysOfWeek: daysOfWeek,
            time: time
        };
    }
    // No monthly/yearly mode in editor — surface as daily at the same wall time
    if (freq === 'MONTHLY' || freq === 'YEARLY') return {
        frequency: 'daily',
        daysOfWeek: [],
        time: time
    };
    return null;
}
module.exports["getScheduleRRuleString"] = $8ae7801b97ef83e8$export$18f1e10d3d0eb792;
module.exports["getSuccessAuditSlotMatchWindowMs"] = $8ae7801b97ef83e8$export$e989d78927f4764;
module.exports["deduceNextRunAtIsoFromRRuleRaw"] = $8ae7801b97ef83e8$export$7741d53a2d5df058;
module.exports["deduceNextRunAtIsoFromRule"] = $8ae7801b97ef83e8$export$475050adf3d4698d;
module.exports["getRuleCreatedMsFromRule"] = $8ae7801b97ef83e8$export$211a0d9f7df2a00d;
module.exports["resolveScheduleHistoryStartMs"] = $8ae7801b97ef83e8$export$38d799fe7b8ed9dc;
module.exports["listScheduledOccurrencesMsBetween"] = $8ae7801b97ef83e8$export$a41e8912a1fb97ea;
module.exports["deriveScheduledChatScheduleFromAutomationRule"] = $8ae7801b97ef83e8$export$e4c43d003a8e3c01;

});

parcelRegister("8KSQx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $5ZtfK = parcelRequire("5ZtfK");


var $lSQgn = parcelRequire("lSQgn");


var $cDs9S = parcelRequire("cDs9S");

var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $c0A7H = parcelRequire("c0A7H");


var $6iyQh = parcelRequire("6iyQh");


var $fESy2 = parcelRequire("fESy2");


var $9krqg = parcelRequire("9krqg");

const $8367081e075aff4b$var$styles = {
    headerContentFullWidth: "_39xV02N91d",
    headerContent: "_2mHwu85zaO _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _39xV02N91d",
    headerMeta: "_4ouGXIdnbC",
    headerTitle: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    contentSection: "_2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5vbt8w",
    footer: "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _0Of8r25zaO _1wydGWNHnM",
    footerActions: "_3YEZNOdnbC",
    pauseControl: "_3YEZNOdnbC"
};
const $8367081e075aff4b$export$7960aaadcce34cda = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { isOpen: isOpen, mode: mode, initialPayload: initialPayload, onClose: onClose, onSubmit: onSubmit, onDelete: onDelete, onPauseChange: onPauseChange, readonly: t1, isSubmitting: t2, initialPaused: t3, rRule: rRule } = t0;
    const readonly = t1 === undefined ? false : t1;
    const isSubmitting = t2 === undefined ? false : t2;
    const initialPaused = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const [payload, setPayload] = (0, $cozmU.useState)(initialPayload);
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(initialPaused);
    const wasModalOpenRef = (0, $cozmU.useRef)(false);
    let t4;
    let t5;
    if ($[0] !== initialPaused || $[1] !== initialPayload || $[2] !== isOpen) {
        t4 = ()=>{
            const justOpened = isOpen && !wasModalOpenRef.current;
            wasModalOpenRef.current = isOpen;
            if (justOpened) {
                setPayload(initialPayload);
                setIsPaused(initialPaused);
            }
        };
        t5 = [
            isOpen,
            initialPayload,
            initialPaused
        ];
        $[0] = initialPaused;
        $[1] = initialPayload;
        $[2] = isOpen;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[5] !== isPaused || $[6] !== onSubmit || $[7] !== payload) {
        t6 = ()=>{
            const context = {
                isPaused: isPaused
            };
            onSubmit(payload, context);
        };
        $[5] = isPaused;
        $[6] = onSubmit;
        $[7] = payload;
        $[8] = t6;
    } else t6 = $[8];
    const handleSubmit = t6;
    let t7;
    if ($[9] !== onClose) {
        t7 = ()=>{
            onClose();
        };
        $[9] = onClose;
        $[10] = t7;
    } else t7 = $[10];
    const handleClose = t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (updates)=>{
            setPayload((prev)=>({
                    ...prev,
                    ...updates
                }));
        };
        $[11] = t8;
    } else t8 = $[11];
    const updatePayload = t8;
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (name)=>updatePayload({
                name: name
            });
        $[12] = t9;
    } else t9 = $[12];
    const handleNameChange = t9;
    let t10;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (prompt)=>updatePayload({
                prompt: prompt
            });
        $[13] = t10;
    } else t10 = $[13];
    const handlePromptChange = t10;
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (frequency)=>updatePayload({
                frequency: frequency
            });
        $[14] = t11;
    } else t11 = $[14];
    const handleFrequencyChange = t11;
    let t12;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (daysOfWeek)=>updatePayload({
                daysOfWeek: daysOfWeek
            });
        $[15] = t12;
    } else t12 = $[15];
    const handleDaysOfWeekChange = t12;
    let t13;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (time)=>updatePayload({
                time: time
            });
        $[16] = t13;
    } else t13 = $[16];
    const handleTimeChange = t13;
    const isCreateMode = mode === "create";
    const isRenameMode = mode === "rename";
    let t14;
    if ($[17] !== payload.name || $[18] !== payload.prompt) {
        t14 = payload.name.trim() && payload.prompt.trim();
        $[17] = payload.name;
        $[18] = payload.prompt;
        $[19] = t14;
    } else t14 = $[19];
    const isFormValid = Boolean(t14);
    let t15;
    if ($[20] !== formatMessage || $[21] !== isCreateMode || $[22] !== isRenameMode) {
        t15 = isCreateMode ? formatMessage((0, $fESy2.default).createModalTitle) : isRenameMode ? formatMessage((0, $fESy2.default).renameModalTitle) : formatMessage((0, $fESy2.default).editModalTitle);
        $[20] = formatMessage;
        $[21] = isCreateMode;
        $[22] = isRenameMode;
        $[23] = t15;
    } else t15 = $[23];
    const modalTitle = t15;
    let t16;
    if ($[24] !== formatMessage || $[25] !== isCreateMode) {
        t16 = isCreateMode ? formatMessage((0, $fESy2.default).createButton) : formatMessage((0, $fESy2.default).saveButton);
        $[24] = formatMessage;
        $[25] = isCreateMode;
        $[26] = t16;
    } else t16 = $[26];
    const submitButtonText = t16;
    let t17;
    if ($[27] !== formatDate || $[28] !== formatMessage || $[29] !== isCreateMode || $[30] !== rRule) {
        bb0: {
            if (isCreateMode) {
                t17 = undefined;
                break bb0;
            }
            const nextRunIso = (0, $6iyQh.deduceNextRunAtIsoFromRRuleRaw)(rRule);
            if (!nextRunIso) {
                t17 = undefined;
                break bb0;
            }
            const dateLabel = formatDate(nextRunIso, {
                day: "numeric",
                month: "short"
            });
            const timeLabel = formatDate(nextRunIso, {
                hour: "numeric",
                minute: "2-digit"
            });
            const dateAndTime = formatMessage((0, $fESy2.default).dateAtTime, {
                date: dateLabel,
                time: timeLabel
            });
            t17 = formatMessage((0, $fESy2.default).editModalNextRunAt, {
                nextRunLabel: dateAndTime
            });
        }
        $[27] = formatDate;
        $[28] = formatMessage;
        $[29] = isCreateMode;
        $[30] = rRule;
        $[31] = t17;
    } else t17 = $[31];
    const nextRunSubtitle = t17;
    let t18;
    if ($[32] !== formatDate || $[33] !== formatMessage || $[34] !== handleClose || $[35] !== handleSubmit || $[36] !== isFormValid || $[37] !== isOpen || $[38] !== isPaused || $[39] !== isSubmitting || $[40] !== modalTitle || $[41] !== mode || $[42] !== nextRunSubtitle || $[43] !== onDelete || $[44] !== onPauseChange || $[45] !== payload || $[46] !== readonly || $[47] !== submitButtonText) {
        t18 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: handleClose,
            width: "large",
            testId: "scheduled-chat-editor-modal",
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8367081e075aff4b$var$styles.headerContentFullWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8367081e075aff4b$var$styles.headerContent,
            spread: "space-between",
            alignBlock: "start",
            shouldWrap: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))),
            label: "",
            size: "medium",
            appearance: "gray"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0",
            xcss: $8367081e075aff4b$var$styles.headerMeta
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $8367081e075aff4b$var$styles.headerTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "span",
            size: "xsmall"
        }, payload.name || modalTitle)), !!nextRunSubtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, nextRunSubtitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
            onClick: handleClose
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8367081e075aff4b$var$styles.contentSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9krqg.ScheduledChatFormFields), {
            formatMessage: formatMessage,
            formatDate: formatDate,
            readonly: readonly,
            isActionLoading: isSubmitting,
            name: payload.name,
            prompt: payload.prompt,
            frequency: payload.frequency,
            daysOfWeek: payload.daysOfWeek,
            time: payload.time,
            onNameChange: handleNameChange,
            onPromptChange: handlePromptChange,
            onFrequencyChange: handleFrequencyChange,
            onDaysOfWeekChange: handleDaysOfWeekChange,
            onTimeChange: handleTimeChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8367081e075aff4b$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8367081e075aff4b$var$styles.pauseControl,
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            isChecked: isPaused,
            onChange: (event)=>{
                const nextChecked = event.currentTarget.checked;
                setIsPaused(nextChecked);
                onPauseChange?.(payload, nextChecked);
            },
            label: formatMessage((0, $fESy2.default).editModalPause)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $fESy2.default).editModalPause))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8367081e075aff4b$var$styles.footerActions,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleClose,
            isDisabled: isSubmitting
        }, formatMessage((0, $fESy2.default).cancelButton)), (mode === "edit" || mode === "rename") && onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: ()=>onDelete(payload)
        }, formatMessage((0, $fESy2.default).editModalDelete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleSubmit,
            isLoading: isSubmitting,
            isDisabled: !isFormValid || readonly,
            testId: "scheduled-chat-submit"
        }, submitButtonText))))));
        $[32] = formatDate;
        $[33] = formatMessage;
        $[34] = handleClose;
        $[35] = handleSubmit;
        $[36] = isFormValid;
        $[37] = isOpen;
        $[38] = isPaused;
        $[39] = isSubmitting;
        $[40] = modalTitle;
        $[41] = mode;
        $[42] = nextRunSubtitle;
        $[43] = onDelete;
        $[44] = onPauseChange;
        $[45] = payload;
        $[46] = readonly;
        $[47] = submitButtonText;
        $[48] = t18;
    } else t18 = $[48];
    let t19;
    if ($[49] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t18);
        $[49] = t18;
        $[50] = t19;
    } else t19 = $[50];
    return t19;
} : ({ isOpen: isOpen, mode: mode, initialPayload: initialPayload, onClose: onClose, onSubmit: onSubmit, onDelete: onDelete, onPauseChange: onPauseChange, readonly: readonly = false, isSubmitting: isSubmitting = false, initialPaused: initialPaused = false, rRule: rRule })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const [payload, setPayload] = (0, $cozmU.useState)(initialPayload);
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(initialPaused);
    const wasModalOpenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const justOpened = isOpen && !wasModalOpenRef.current;
        wasModalOpenRef.current = isOpen;
        if (justOpened) {
            setPayload(initialPayload);
            setIsPaused(initialPaused);
        }
    }, [
        isOpen,
        initialPayload,
        initialPaused
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        const context = {
            isPaused: isPaused
        };
        onSubmit(payload, context);
    }, [
        onSubmit,
        payload,
        isPaused
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    const updatePayload = (0, $cozmU.useCallback)((updates)=>{
        setPayload((prev)=>({
                ...prev,
                ...updates
            }));
    }, []);
    const handleNameChange = (0, $cozmU.useCallback)((name)=>updatePayload({
            name: name
        }), [
        updatePayload
    ]);
    const handlePromptChange = (0, $cozmU.useCallback)((prompt)=>updatePayload({
            prompt: prompt
        }), [
        updatePayload
    ]);
    const handleFrequencyChange = (0, $cozmU.useCallback)((frequency)=>updatePayload({
            frequency: frequency
        }), [
        updatePayload
    ]);
    const handleDaysOfWeekChange = (0, $cozmU.useCallback)((daysOfWeek)=>updatePayload({
            daysOfWeek: daysOfWeek
        }), [
        updatePayload
    ]);
    const handleTimeChange = (0, $cozmU.useCallback)((time)=>updatePayload({
            time: time
        }), [
        updatePayload
    ]);
    const isCreateMode = mode === 'create';
    const isRenameMode = mode === 'rename';
    const isFormValid = Boolean(payload.name.trim() && payload.prompt.trim());
    const modalTitle = isCreateMode ? formatMessage((0, $fESy2.default).createModalTitle) : isRenameMode ? formatMessage((0, $fESy2.default).renameModalTitle) : formatMessage((0, $fESy2.default).editModalTitle);
    const submitButtonText = isCreateMode ? formatMessage((0, $fESy2.default).createButton) : formatMessage((0, $fESy2.default).saveButton);
    const nextRunSubtitle = (0, $cozmU.useMemo)(()=>{
        if (isCreateMode) return undefined;
        const nextRunIso = (0, $6iyQh.deduceNextRunAtIsoFromRRuleRaw)(rRule);
        if (!nextRunIso) return undefined;
        const dateLabel = formatDate(nextRunIso, {
            day: 'numeric',
            month: 'short'
        });
        const timeLabel = formatDate(nextRunIso, {
            hour: 'numeric',
            minute: '2-digit'
        });
        const dateAndTime = formatMessage((0, $fESy2.default).dateAtTime, {
            date: dateLabel,
            time: timeLabel
        });
        return formatMessage((0, $fESy2.default).editModalNextRunAt, {
            nextRunLabel: dateAndTime
        });
    }, [
        isCreateMode,
        rRule,
        formatDate,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: handleClose,
        width: "large",
        testId: "scheduled-chat-editor-modal",
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8367081e075aff4b$var$styles.headerContentFullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $8367081e075aff4b$var$styles.headerContent,
        spread: "space-between",
        alignBlock: "start",
        shouldWrap: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))),
        label: "",
        size: "medium",
        appearance: "gray"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0",
        xcss: $8367081e075aff4b$var$styles.headerMeta
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $8367081e075aff4b$var$styles.headerTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "span",
        size: "xsmall"
    }, payload.name || modalTitle)), !!nextRunSubtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, nextRunSubtitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: handleClose
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8367081e075aff4b$var$styles.contentSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9krqg.ScheduledChatFormFields), {
        formatMessage: formatMessage,
        formatDate: formatDate,
        readonly: readonly,
        isActionLoading: isSubmitting,
        name: payload.name,
        prompt: payload.prompt,
        frequency: payload.frequency,
        daysOfWeek: payload.daysOfWeek,
        time: payload.time,
        onNameChange: handleNameChange,
        onPromptChange: handlePromptChange,
        onFrequencyChange: handleFrequencyChange,
        onDaysOfWeekChange: handleDaysOfWeekChange,
        onTimeChange: handleTimeChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8367081e075aff4b$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $8367081e075aff4b$var$styles.pauseControl,
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        isChecked: isPaused,
        onChange: (event)=>{
            const nextChecked = event.currentTarget.checked;
            setIsPaused(nextChecked);
            onPauseChange?.(payload, nextChecked);
        },
        label: formatMessage((0, $fESy2.default).editModalPause)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $fESy2.default).editModalPause))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $8367081e075aff4b$var$styles.footerActions,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClose,
        isDisabled: isSubmitting
    }, formatMessage((0, $fESy2.default).cancelButton)), (mode === 'edit' || mode === 'rename') && onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: ()=>onDelete(payload)
    }, formatMessage((0, $fESy2.default).editModalDelete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSubmit,
        isLoading: isSubmitting,
        isDisabled: !isFormValid || readonly,
        testId: "scheduled-chat-submit"
    }, submitButtonText)))))));
};
module.exports["ScheduledChatEditorModal"] = $8367081e075aff4b$export$7960aaadcce34cda;

});

parcelRegister("agNz3", function(module, exports) {

let $77a1d8735f96e1fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77a1d8735f96e1fc$var$load("4WPsT").then(()=>parcelRequire('gpLTm'));

});

parcelRegister("2UKhw", function(module, exports) {
const $dc602b285bee0e19$export$3d931b64f46140b3 = '1248px';
const $dc602b285bee0e19$export$1dd7793cb602b5ab = '100%';
const $dc602b285bee0e19$export$a5e66ebb2aa164d3 = [
    'jsm',
    'jira',
    'confluence'
];
module.exports["MODAL_WIDTH"] = $dc602b285bee0e19$export$3d931b64f46140b3;
module.exports["MODAL_HEIGHT"] = $dc602b285bee0e19$export$1dd7793cb602b5ab;
module.exports["STUDIO_EXTERNAL_ALLOWLIST_SKILL_PRODUCTS"] = $dc602b285bee0e19$export$a5e66ebb2aa164d3;

});

parcelRegister("eTjNs", function(module, exports) {
/**
 * @generated SignedSource<<55d23df36b22de872c95d3c5a40b7478>>
 * @relayHash d56cfe01460ad4d9ffe80d53cfb30a5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83bc37f98bd776bd60c1c99f39aa37d664da0eb7a194f78e5f1e1747612d6042
const $db39629300fc152e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skillAri"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contextAri",
                    "variableName": "contextAri"
                },
                {
                    "kind": "Variable",
                    "name": "skillAri",
                    "variableName": "skillAri"
                }
            ],
            "concreteType": "GraphIntegrationSkill",
            "kind": "LinkedField",
            "name": "graphIntegration_skill",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "instructions"
                },
                {
                    "concreteType": "GraphIntegrationSkillUiMetadata",
                    "kind": "LinkedField",
                    "name": "uiMetadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                },
                {
                    "concreteType": "GraphIntegrationSkillMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "tags"
                        },
                        {
                            "concreteType": "GraphIntegrationSkillTool",
                            "kind": "LinkedField",
                            "name": "tools",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "source"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditSkillModalQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditSkillModalQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "83bc37f98bd776bd60c1c99f39aa37d664da0eb7a194f78e5f1e1747612d6042",
            "metadata": {},
            "name": "EditSkillModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$db39629300fc152e$var$node.hash = "de9bf69e026fd33de24954517b4308c5";
var $db39629300fc152e$export$2e2bcd8739ae039 = $db39629300fc152e$var$node;
module.exports["default"] = $db39629300fc152e$export$2e2bcd8739ae039;

});

parcelRegister("9nGMF", function(module, exports) {

let $6d4773045a6131ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d4773045a6131ac$var$load("aMj9X").then(()=>parcelRequire('fHfb2'));

});

parcelRegister("dIT3V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4defd18abd6ffd8b3e96599daa442427>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fda18a13dbde1ee$var$_react = $9fda18a13dbde1ee$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9fda18a13dbde1ee$var$_baseNew = $9fda18a13dbde1ee$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9fda18a13dbde1ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Plan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/plan
 * Usage guidance:
 * Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fda18a13dbde1ee$var$PlanIcon = (props)=>/*#__PURE__*/ $9fda18a13dbde1ee$var$_react.default.createElement($9fda18a13dbde1ee$var$_baseNew.default, Object.assign({
        name: "PlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H5.625a3.125 3.125 0 1 1 0-6.25h4.75a1.625 1.625 0 1 0 0-3.25H5.394A2.749 2.749 0 0 1 0 3.25a2.75 2.75 0 0 1 5.394-.75h4.981a3.125 3.125 0 1 1 0 6.25h-4.75a1.625 1.625 0 0 0 0 3.25h4.981a2.749 2.749 0 0 1 5.394.75M1.5 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"/>`
    }, props));
$9fda18a13dbde1ee$var$PlanIcon.displayName = 'PlanIcon';
var $9fda18a13dbde1ee$var$_default = module.exports.default = $9fda18a13dbde1ee$var$PlanIcon;

});

parcelRegister("ha4hi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


var $9OqBj = parcelRequire("9OqBj");


var $9MCKh = parcelRequire("9MCKh");

const $fc3417792dad5b5b$export$a2413bcd82f992ef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { iconKey: iconKey, color: color, size: t1 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const IconComponent = iconKey && (0, $9MCKh.skillIconMap)[iconKey] || (0, $9MCKh.DefaultSkillIcon);
    const t2 = color;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $9OqBj.getIconColor)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== IconComponent || $[3] !== size || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "skill-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            label: "",
            size: size,
            color: t3
        }));
        $[2] = IconComponent;
        $[3] = size;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ iconKey: iconKey, color: color, size: size = 'medium' })=>{
    const IconComponent = iconKey && (0, $9MCKh.skillIconMap)[iconKey] || (0, $9MCKh.DefaultSkillIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: null,
        interactionName: "skill-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        label: "",
        size: size,
        color: (0, $9OqBj.getIconColor)(color)
    }));
};
module.exports["SkillIcon"] = $fc3417792dad5b5b$export$a2413bcd82f992ef;

});

parcelRegister("3s5Mh", function(module, exports) {

let $283877f8f1c25625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $283877f8f1c25625$var$load("7cI7O").then(()=>parcelRequire('amo5X'));

});

parcelRegister("1iheS", function(module, exports) {

let $0f14d82f5f521e58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f14d82f5f521e58$var$load("cIKQL").then(()=>parcelRequire('fPSm3'));

});

parcelRegister("gLcMv", function(module, exports) {

let $c33af338c513ed7c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c33af338c513ed7c$var$load("jFeyW").then(()=>parcelRequire('gl1Vz'));

});

parcelRegister("6gkxM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f32f2abf1f225d229b6be2dfd61a6635>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48f42c44f00f80bd$var$_react = $48f42c44f00f80bd$var$_interopRequireDefault((parcelRequire("cozmU")));

var $48f42c44f00f80bd$var$_baseNew = $48f42c44f00f80bd$var$_interopRequireDefault((parcelRequire("gElAV")));
function $48f42c44f00f80bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CurlyBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/curly-brackets
 * Usage guidance:
 * Known uses: Represents Smart values in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48f42c44f00f80bd$var$CurlyBracketsIcon = (props)=>/*#__PURE__*/ $48f42c44f00f80bd$var$_react.default.createElement($48f42c44f00f80bd$var$_baseNew.default, Object.assign({
        name: "CurlyBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10 1h2.5a2 2 0 0 1 2 2v4.25H16v1.5h-1.5V13a2 2 0 0 1-2 2H10v-1.5h2.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H10zM1.5 3a2 2 0 0 1 2-2H6v1.5H3.5A.5.5 0 0 0 3 3v10a.5.5 0 0 0 .5.5H6V15H3.5a2 2 0 0 1-2-2V8.75H0v-1.5h1.5z" clip-rule="evenodd"/>`
    }, props));
$48f42c44f00f80bd$var$CurlyBracketsIcon.displayName = 'CurlyBracketsIcon';
var $48f42c44f00f80bd$var$_default = module.exports.default = $48f42c44f00f80bd$var$CurlyBracketsIcon;

});

parcelRegister("hf8wM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $e0NeE = parcelRequire("e0NeE");


var $haiCi = parcelRequire("haiCi");


var $e8F4L = parcelRequire("e8F4L");


var $4SvUT = parcelRequire("4SvUT");


var $4eBF1 = parcelRequire("4eBF1");


var $aUFTx = parcelRequire("aUFTx");


var $4mBI1 = parcelRequire("4mBI1");

/**
 * Resolves activation ID mapping using Relay when available, otherwise falls back to performGqlFetch.
 */ async function $cdc3698df373f844$var$resolveActivationIdMapping(cloudId, relayEnvironment) {
    if (relayEnvironment) {
        const data = await (0, $4SvUT.getActivationIdsByCloudId)(relayEnvironment, cloudId);
        const tenantContext = data.tenantContexts?.[0];
        if (!tenantContext) throw new Error(`No tenant context found for cloud ID: ${cloudId}`);
        return (tenantContext.activationIds ?? []).reduce((acc, activationId)=>{
            if (activationId.product && activationId.active) acc[activationId.product] = activationId.active;
            return acc;
        }, {});
    }
    return (0, $4mBI1.getActivationIdMappingByCloudId)(cloudId);
}
async function $cdc3698df373f844$var$resolveRovoWorkspaceAri(cloudId, relayEnvironment) {
    try {
        const activationIdMap = await $cdc3698df373f844$var$resolveActivationIdMapping(cloudId, relayEnvironment);
        const rovoActivationId = activationIdMap['rovo'];
        if (rovoActivationId) return `ari:cloud:rovo::workspace/${rovoActivationId}`;
    } catch  {
    // Non-fatal: fall back to region routing if we can't resolve the Rovo activation ID
    }
    return undefined;
}
async function $cdc3698df373f844$var$createStandaloneChartGraphQL(chart, cloudId, relayEnvironment, chartId) {
    let workspaceId;
    if (chart.metricsConfig?.metricNames?.[0]) workspaceId = await (0, $4mBI1.resolveWorkspaceIdForMetric)(cloudId, chart.metricsConfig.metricNames[0]);
    const workspaceAri = await $cdc3698df373f844$var$resolveRovoWorkspaceAri(cloudId, relayEnvironment);
    const avpChartInput = (0, $4mBI1.transformChartPayloadToAvpInput)(chart, workspaceId, chartId);
    if (relayEnvironment) {
        const response = await (0, $e8F4L.createStandaloneChart)(relayEnvironment, {
            chart: avpChartInput,
            cloudId: cloudId,
            ...workspaceAri ? {
                workspaceAri: workspaceAri
            } : {}
        });
        return response;
    }
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: (0, $4mBI1.CREATE_STANDALONE_CHART_QUERY),
        variables: {
            chart: avpChartInput,
            cloudId: cloudId,
            ...workspaceAri ? {
                workspaceAri: workspaceAri
            } : {}
        }
    });
    return response.data;
}
function $cdc3698df373f844$var$getCurrentUrl() {
    if (typeof window === 'undefined' || !window.location) throw new Error('Window location is not available');
    return new URL(window.location.href);
}
async function $cdc3698df373f844$var$fetchCloudId() {
    try {
        const { origin: origin } = $cdc3698df373f844$var$getCurrentUrl();
        const response = await fetch(`${origin}/_edge/tenant_info`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        if (!response.ok) return null;
        const json = await response.json();
        return json.cloudId || null;
    } catch  {
        return null;
    }
}
class $cdc3698df373f844$export$294759a77c4958d6 {
    async getCloudId() {
        if (!this.cloudId) this.cloudId = await $cdc3698df373f844$var$fetchCloudId();
        return this.cloudId;
    }
    /**
   * Generate a shareable link for chart data
   */ async generateChartLink(payload) {
        const cloudId = await this.getCloudId();
        if (!cloudId) throw new Error('cloudId is required for chart creation');
        const graphqlResult = await $cdc3698df373f844$var$createStandaloneChartGraphQL(payload, cloudId, this.relayEnvironment);
        return {
            link: graphqlResult.avp_createStandaloneChart.avpVizUrl,
            chartId: graphqlResult.avp_createStandaloneChart.chart.id
        };
    }
    async exportChartToDashboard(payload, targetDashboardAri, dataFetchStrategy = 'STATIC') {
        const cloudId = await this.getCloudId();
        if (!cloudId) throw new Error('cloudId is required to export a chart to a dashboard');
        let workspaceId = null;
        if (payload.metricsConfig?.metricNames?.[0]) try {
            workspaceId = await (0, $4mBI1.resolveWorkspaceIdForMetric)(cloudId, payload.metricsConfig.metricNames[0]);
        } catch  {
            workspaceId = null;
        }
        const avpChartInput = (0, $4mBI1.transformChartPayloadToAvpInput)(payload, workspaceId || '', undefined, dataFetchStrategy);
        const response = await (0, $haiCi.performGqlFetch)({
            gqlQuery: (0, $4mBI1.CREATE_CHART_TO_DASHBOARD_MUTATION),
            variables: {
                dashboardAri: targetDashboardAri,
                chart: avpChartInput
            }
        });
        const result = response.data?.avp_createChart;
        return {
            chart: result?.chart ?? null,
            canvasLayout: result?.canvasLayout ?? null
        };
    }
    async addChartToDashboard(payload) {
        const dashboardContext = (0, $aUFTx.getDashboardContextFromUrl)();
        if (!dashboardContext) throw new Error('Not on a dashboard page. Add to Dashboard is only available when viewing or editing a dashboard.');
        const cloudId = dashboardContext.cloudId;
        let activationIdMap;
        try {
            activationIdMap = await $cdc3698df373f844$var$resolveActivationIdMapping(cloudId, this.relayEnvironment);
        } catch (error) {
            throw new Error(`Failed to get activation ID mapping for dashboard: ${error instanceof Error ? error.message : String(error)}`);
        }
        // getDashboardContextFromUrl ensures we are on a home dashboard
        const activationId = activationIdMap['townsquare'];
        if (!activationId) throw new Error('Could not resolve activationId for dashboard from tenant context (no activation IDs in mapping).');
        let workspaceId = null;
        if (payload.metricsConfig?.metricNames?.[0]) try {
            workspaceId = (0, $4mBI1.resolveWorkspaceIdForMetricWithMapping)(activationIdMap, payload.metricsConfig.metricNames[0]);
        } catch  {}
        const avpChartInput = (0, $4mBI1.transformChartPayloadToAvpInput)(payload, workspaceId || '');
        let dashboardAri;
        try {
            dashboardAri = (0, $e0NeE.AvpDashboardAri).create({
                siteId: cloudId,
                activationId: activationId,
                dashboardId: dashboardContext.dashboardId
            });
        } catch (ariError) {
            const message = ariError instanceof Error ? ariError.message : 'Invalid dashboard URL context';
            throw new Error(`Failed to build dashboard ARI from URL context: ${message}`);
        }
        const response = await (0, $haiCi.performGqlFetch)({
            gqlQuery: (0, $4mBI1.CREATE_CHART_TO_DASHBOARD_MUTATION),
            variables: {
                dashboardAri: dashboardAri.toString(),
                chart: avpChartInput
            }
        });
        const result = response.data?.avp_createChart;
        return {
            chart: result.chart ?? null,
            canvasLayout: result.canvasLayout ?? null
        };
    }
    constructor(cloudId, relayEnvironment){
        this.cloudId = null;
        this.relayEnvironment = void 0;
        if (cloudId) this.cloudId = cloudId;
        this.relayEnvironment = relayEnvironment ?? null;
    }
}
const $cdc3698df373f844$export$ff1b9d32701a7bae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cloudId)=>{
    const $ = (0, $bDgLe.c)(3);
    (0, $6cFsl.di)($cdc3698df373f844$export$294759a77c4958d6);
    const relayEnvironment = (0, $4eBF1.useRelayEnvironment)();
    let t0;
    if ($[0] !== cloudId || $[1] !== relayEnvironment) {
        t0 = new $cdc3698df373f844$export$294759a77c4958d6(cloudId, relayEnvironment);
        $[0] = cloudId;
        $[1] = relayEnvironment;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (cloudId)=>{
    (0, $6cFsl.di)($cdc3698df373f844$export$294759a77c4958d6);
    const relayEnvironment = (0, $4eBF1.useRelayEnvironment)();
    // Memoize the service instance to prevent re-creation on every render
    return (0, $cozmU.useMemo)(()=>new $cdc3698df373f844$export$294759a77c4958d6(cloudId, relayEnvironment), [
        cloudId,
        relayEnvironment
    ]);
}; // Mock service is available through '@atlassian/conversation-assistant-viz/test-utils' export path
module.exports["useChartApiService"] = $cdc3698df373f844$export$ff1b9d32701a7bae;

});

parcelRegister("e0NeE", function(module, exports) {

var $i2WDe = parcelRequire("i2WDe");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/avp/dashboard/manifest.ts
var $a33741e68c02512c$var$avpDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: "avp",
    resourceType: (0, $i2WDe.AvpDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/avp/dashboard/index.ts
var $a33741e68c02512c$export$4f332b50c12537eb = class _AvpDashboardAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a33741e68c02512c$var$avpDashboardAriStaticOpts.qualifier,
            platformQualifier: $a33741e68c02512c$var$avpDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a33741e68c02512c$var$avpDashboardAriStaticOpts.resourceOwner,
            resourceType: $a33741e68c02512c$var$avpDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $a33741e68c02512c$var$avpDashboardAriStaticOpts);
        return new _AvpDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $a33741e68c02512c$var$avpDashboardAriStaticOpts);
        return new _AvpDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
};
module.exports["AvpDashboardAri"] = $a33741e68c02512c$export$4f332b50c12537eb;

});

parcelRegister("i2WDe", function(module, exports) {
// src/avp/dashboard/types.ts
var $d235e4f43548340b$export$cab1e40024c8ea24 = "avp", $d235e4f43548340b$export$fb6b42ce2aa2b8c9 = "dashboard";
module.exports["AvpDashboardAriResourceType"] = $d235e4f43548340b$export$fb6b42ce2aa2b8c9;

});

parcelRegister("e8F4L", function(module, exports) {

var $4ToZP = parcelRequire("4ToZP");


var $6SsN4 = parcelRequire("6SsN4");

async function $8cfead3fec50d9a0$export$7ab823b655f029ca(environment, variables) {
    return new Promise((resolve, reject)=>{
        (0, $6SsN4.commitMutation)(environment, {
            mutation: (0, $4ToZP.default),
            variables: variables,
            onCompleted: (response)=>{
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
}
module.exports["createStandaloneChart"] = $8cfead3fec50d9a0$export$7ab823b655f029ca;

});

parcelRegister("4ToZP", function(module, exports) {
/**
 * @generated SignedSource<<98c2cd4a8ad959268b333d51fbbe9d75>>
 * @relayHash 13588cd8240171a496a5fe60c65cb262
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fcf03d0cb9904b89bdf05664b1123004945846c5af8b2ea4b1f311b292386d0
const $0ff2f2bb46df651c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chart"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "integrationId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "chart",
                    "variableName": "chart"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "containerAri",
                    "variableName": "containerAri"
                },
                {
                    "kind": "Variable",
                    "name": "integrationId",
                    "variableName": "integrationId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "avpVizUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "AVPChart",
        "kind": "LinkedField",
        "name": "chart",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "chartType"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standaloneChartsVizCreateMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "AVPCreateStandaloneChartPayload",
                    "kind": "LinkedField",
                    "name": "avp_createStandaloneChart",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standaloneChartsVizCreateMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "AVPCreateStandaloneChartPayload",
                    "kind": "LinkedField",
                    "name": "avp_createStandaloneChart",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fcf03d0cb9904b89bdf05664b1123004945846c5af8b2ea4b1f311b292386d0",
            "metadata": {},
            "name": "standaloneChartsVizCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0ff2f2bb46df651c$var$node.hash = "b7c2b5e8fc7437b3c032514653d596e5";
var $0ff2f2bb46df651c$export$2e2bcd8739ae039 = $0ff2f2bb46df651c$var$node;
module.exports["default"] = $0ff2f2bb46df651c$export$2e2bcd8739ae039;

});

parcelRegister("4SvUT", function(module, exports) {

var $27ilf = parcelRequire("27ilf");


var $6SsN4 = parcelRequire("6SsN4");

async function $5bfefbb8bd06aafb$export$40fef16d3ad9a69e(environment, cloudId) {
    const data = await (0, $6SsN4.fetchQuery)(environment, (0, $27ilf.default), {
        cloudId: cloudId
    }).toPromise();
    if (!data) throw new Error('Failed to fetch activation IDs');
    return data;
}
module.exports["getActivationIdsByCloudId"] = $5bfefbb8bd06aafb$export$40fef16d3ad9a69e;

});

parcelRegister("27ilf", function(module, exports) {
/**
 * @generated SignedSource<<cbd4b01ef32600d88296d95b17a93e56>>
 * @relayHash d4ff00f1382bdce8b9f253b1949b1290
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7081399d2f20e531d1fe319a6e4447244e098bbaea7bc48a318648f0dc4b677
const $4b66d8902a660a0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "cloudIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIds",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "tenantVizGetActivationIdsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "tenantVizGetActivationIdsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "e7081399d2f20e531d1fe319a6e4447244e098bbaea7bc48a318648f0dc4b677",
            "metadata": {},
            "name": "tenantVizGetActivationIdsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4b66d8902a660a0d$var$node.hash = "fd182b11ab0a2e93e1aa7729d0553268";
var $4b66d8902a660a0d$export$2e2bcd8739ae039 = $4b66d8902a660a0d$var$node;
module.exports["default"] = $4b66d8902a660a0d$export$2e2bcd8739ae039;

});

parcelRegister("4eBF1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $d5gEx = parcelRequire("d5gEx");

const $33cb8cc33b0de1bc$export$93b27837988a39ef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const existingEnvironment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    if ((0, $iDrrr.fg)("ai_mate_viz_relay_provider")) {
        if (existingEnvironment) {
            let t1;
            if ($[0] !== children) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
                $[0] = children;
                $[1] = t1;
            } else t1 = $[1];
            return t1;
        }
        let t1;
        if ($[2] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, children);
            $[2] = children;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    let t1;
    if ($[4] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[4] = children;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children })=>{
    const existingEnvironment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    if ((0, $iDrrr.fg)('ai_mate_viz_relay_provider')) {
        if (existingEnvironment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
var $33cb8cc33b0de1bc$export$2e2bcd8739ae039 = $33cb8cc33b0de1bc$export$93b27837988a39ef;
const $33cb8cc33b0de1bc$export$ca90c91bc4ab016f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRelayEnvironment() {
    const context = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    if (!(0, $iDrrr.fg)("ai_mate_viz_relay_provider")) return null;
    return context?.environment ?? null;
} : function useRelayEnvironment() {
    const context = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    if (!(0, $iDrrr.fg)('ai_mate_viz_relay_provider')) return null;
    return context?.environment ?? null;
};
module.exports["useRelayEnvironment"] = $33cb8cc33b0de1bc$export$ca90c91bc4ab016f;

});

parcelRegister("aUFTx", function(module, exports) {
/**
 * Pattern for dashboard page path: /o/:cloudId/s/:siteId/d/:dashboardId
 * siteId = cloudId
 */ const $078accd0e5a9e135$var$DASHBOARD_PATH_REGEX = /^\/o\/([^/]+)\/s\/([^/]+)\/d\/([^/]+)(?:\/|$)/;
function $078accd0e5a9e135$export$910703e033a6e671() {
    if (typeof window === 'undefined' || !window.location?.pathname) return null;
    const pathname = window.location.pathname;
    const match = pathname.match($078accd0e5a9e135$var$DASHBOARD_PATH_REGEX);
    if (!match) return null;
    const [, , cloudId, dashboardId] = match;
    if (!cloudId || !dashboardId) return null;
    return {
        cloudId: cloudId,
        dashboardId: dashboardId
    };
}
function $078accd0e5a9e135$export$4ee8a31db37d158() {
    return $078accd0e5a9e135$export$910703e033a6e671() !== null;
}
module.exports["getDashboardContextFromUrl"] = $078accd0e5a9e135$export$910703e033a6e671;
module.exports["isOnDashboardPage"] = $078accd0e5a9e135$export$4ee8a31db37d158;

});

parcelRegister("4mBI1", function(module, exports) {

var $haiCi = parcelRequire("haiCi");

const $77d466caab7173e9$export$a4b615be33120a6a = `
  query ActivationIds($cloudId: ID!) {
    tenantContexts(cloudIds: [$cloudId]) {
      activationIds {
        product
        active
      }
    }
  }
`;
const $77d466caab7173e9$var$ENV_VAR_FRAGMENT = `
  fragment envVarFields on AVPEnvVar {
    id
    name
    chartId
    chartType
    dataType
    defaultValues
    hotTierFilterConfig {
      datasourceLocator {
        dstype
        workspaceId
      }
      product
      semanticModel
      dimension
    }
    operator
    metadata
  }
`;
const $77d466caab7173e9$var$PIPELINE_FRAGMENT = `
  fragment pipelineFields on AVPChartPipeline {
    id
    queries {
      id
      datasourceLocator {
        dstype
        workspaceId
      }
      metricsConfiguration {
        metrics
        dimensions {
          type
          name
        }
        filters {
          product
          dimension
          comparison
          operands
        }
      }
    }
  }
`;
const $77d466caab7173e9$var$CHART_FRAGMENT = `
  fragment chartFields on AVPChart {
    id
    chartType
    chartLayout {
      x
      y
      z
      blocksWide
      blocksHigh
    }
    envVar {
      ...envVarFields
    }
    templateChartId
    chartConfig {
      clientSettings {
        type
        options {
          name
          jsonValue
        }
      }
      settings {
        name
        jsonValue
      }
    }
  }
  ${$77d466caab7173e9$var$ENV_VAR_FRAGMENT}
`;
const $77d466caab7173e9$var$CHART_FRAGMENT_WITH_PIPELINE = `
  fragment chartFieldsWithPipeline on AVPChart {
    ...chartFields
    pipeline {
      ...pipelineFields
    }
  }
  ${$77d466caab7173e9$var$CHART_FRAGMENT}
  ${$77d466caab7173e9$var$PIPELINE_FRAGMENT}
`;
const $77d466caab7173e9$var$CANVAS_LAYOUT_FRAGMENT = `
  fragment canvasLayoutFields on AVPDashboardCanvasLayout {
    version
    rows {
      id
      height
      columns: elements {
        id
        span
        item {
          id
          template_chart_id: templateChartId
        }
      }
    }
    controlIds
  }
`;
const $77d466caab7173e9$var$MUTATION_PAYLOAD_FRAGMENT = `
  fragment payloadFields on Payload {
    success
    errors {
      message
      extensions {
        statusCode
        errorType
      }
    }
  }
`;
const $77d466caab7173e9$export$771b6ec7a445547 = `
mutation avp_createStandaloneChart($chart: AVPChartInput!, $cloudId: ID!, $containerAri: ID, $workspaceAri: ID, $integrationId: AVPIntegrationId) {
  avp_createStandaloneChart(
    input: {chart: $chart, cloudId: $cloudId, containerAri: $containerAri, workspaceAri: $workspaceAri, integrationId: $integrationId}
  ) @optIn(to: "AVP-standalone-charts") {
    success
    avpVizUrl
    chart {
      id
      chartType
      pipeline {
        queries {
          metricsConfiguration {
            metrics
            dimensions {
              type
              name
            }
            filters {
              product
              dimension
              comparison
              operands
            }
            workspaceId
            searchCondition
          }
        }
        nodes
      }
      chartConfig {
        creator
        createdAt
        updatedAt
        settings {
          name
          jsonValue
        }
        clientSettings {
          type
          options {
            name
            jsonValue
          }
        }
		dataFetchStrategy
        vizConfig {
		  accessors
          data
        }
      }
    }
    dashboard {
      id
      isReadOnly
      access
    }
    errors {
      message
      extensions {
        statusCode
        errorType
      }
    }
  }
}
`;
const $77d466caab7173e9$export$a21c2ea9e8651553 = `
  mutation avp_createChart($dashboardAri: ID!, $chart: AVPChartInput!, $canvasElementId: ID) {
    avp_createChart(input: { dashboardAri: $dashboardAri, chart: $chart, canvasElementId: $canvasElementId }) @optIn(to: "AVP-standalone-charts") {
      chart {
        ...chartFieldsWithPipeline
      }
      canvasLayout {
        ...canvasLayoutFields
      }
      ...payloadFields
    }
  }

  ${$77d466caab7173e9$var$CHART_FRAGMENT_WITH_PIPELINE}
  ${$77d466caab7173e9$var$CANVAS_LAYOUT_FRAGMENT}
  ${$77d466caab7173e9$var$MUTATION_PAYLOAD_FRAGMENT}
`;
function $77d466caab7173e9$var$mapChartTypeToGraphQL(chartType) {
    const chartTypeMap = {
        bar: 'bar',
        horizontalbar: 'bar_horizontal',
        stackbar: 'bar_stack',
        horizontalstackbar: 'bar_stack_horizontal',
        line: 'line',
        pie: 'pie',
        donut: 'donut'
    };
    return chartTypeMap[chartType] || 'bar';
}
function $77d466caab7173e9$export$9b81abbaf6041dc2(metric) {
    if (!metric || !metric.includes('/')) return null;
    const parts = metric.split('/');
    return parts.length > 0 && parts[0] ? parts[0] : null;
}
/**
 * Get activation IDs for a specific cloud ID using GraphQL
 * This maps products to their workspace IDs (activation IDs)
 * Adapted from avp/packages/product-metrics-provider/src/store/store.ts
 * @param performGqlFetch - GraphQL fetch function to use (allows different implementations for mocks vs production)
 */ // The activation-id mapping is stable for a given cloudId, so cache the
// in-flight promise per cloudId. This dedupes concurrent callers (e.g. the
// export picker and metric workspace resolution) and avoids repeated network
// calls. Failed lookups are evicted so they can be retried.
const $77d466caab7173e9$var$activationIdMappingCache = new Map();
async function $77d466caab7173e9$export$f3f262f23f5ef2e5(cloudId) {
    const cached = $77d466caab7173e9$var$activationIdMappingCache.get(cloudId);
    if (cached) return cached;
    const request = (async ()=>{
        try {
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $77d466caab7173e9$export$a4b615be33120a6a,
                variables: {
                    cloudId: cloudId
                }
            });
            const tenantContext = response.data?.tenantContexts?.[0];
            if (!tenantContext) throw new Error(`No tenant context found for cloud ID: ${cloudId}`);
            return tenantContext.activationIds.reduce((acc, activationId)=>{
                acc[activationId.product] = activationId.active;
                return acc;
            }, {});
        } catch (error) {
            throw new Error(`Failed to get activation ID mapping for cloud ID: ${cloudId}. ${error instanceof Error ? error.message : String(error)}`);
        }
    })();
    $77d466caab7173e9$var$activationIdMappingCache.set(cloudId, request);
    request.catch(()=>$77d466caab7173e9$var$activationIdMappingCache.delete(cloudId));
    return request;
}
function $77d466caab7173e9$export$badfbb3c54037700(activationIdMap, metric) {
    const product = $77d466caab7173e9$export$9b81abbaf6041dc2(metric);
    if (!product) throw new Error(`Failed to extract product from metric: ${metric}`);
    return activationIdMap[product];
}
async function $77d466caab7173e9$export$fb528d54105b2793(cloudId, metric) {
    const product = $77d466caab7173e9$export$9b81abbaf6041dc2(metric);
    if (!product) throw new Error(`Failed to extract product from metric: ${metric}`);
    try {
        const activationIdMap = await $77d466caab7173e9$export$f3f262f23f5ef2e5(cloudId);
        return activationIdMap[product];
    } catch (error) {
        throw new Error(`Failed to resolve workspaceId for metric: ${metric}. ${error instanceof Error ? error.message : String(error)}`);
    }
}
function $77d466caab7173e9$var$isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $77d466caab7173e9$var$transformDimensions(dimensions) {
    if (!dimensions || !Array.isArray(dimensions)) return [];
    return dimensions.map((dim)=>{
        const name = $77d466caab7173e9$var$isRecord(dim) ? dim.name : dim;
        return {
            name: String(name),
            type: ''
        }; // TODO: DXAI-1066
    });
}
/**
 * Transform filters: extract dimension.name from nested dimension object
 */ function $77d466caab7173e9$var$transformFilters(filters) {
    if (!filters || !Array.isArray(filters)) return [];
    return filters.map((filter)=>{
        if (!$77d466caab7173e9$var$isRecord(filter)) return {
            product: '',
            dimension: '',
            comparison: '',
            operands: []
        };
        const rawDimension = filter.dimension;
        const dimensionName = $77d466caab7173e9$var$isRecord(rawDimension) ? rawDimension.name : rawDimension;
        return {
            product: typeof filter.product === 'string' ? filter.product : '',
            dimension: String(dimensionName ?? ''),
            comparison: typeof filter.comparison === 'string' ? filter.comparison : '',
            operands: Array.isArray(filter.operands) ? filter.operands.filter((o)=>typeof o === 'string') : []
        };
    });
}
/**
 * Transforms chart data into a 2D array format.
 * @param payload - The chart payload with data and accessors
 * @returns Object with data (2D array format) and accessors
 */ function $77d466caab7173e9$var$transformChartData(payload) {
    if (!payload.data || !Array.isArray(payload.data) || payload.data.length === 0) return {
        data: [],
        accessors: {}
    };
    const { xAccessor: xAccessor, yAccessor: yAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, colorAccessor: colorAccessor } = payload;
    if (xAccessor !== undefined && yAccessor !== undefined) {
        const data = payload.data.map((item)=>{
            const record = $77d466caab7173e9$var$isRecord(item) ? item : {};
            const row = [
                isNaN(Number(record[xAccessor])) ? String(record[xAccessor]) : Number(record[xAccessor]),
                isNaN(Number(record[yAccessor])) ? String(record[yAccessor]) : Number(record[yAccessor])
            ];
            if (colorAccessor !== undefined && record[colorAccessor] !== undefined) row.push(String(record[colorAccessor]));
            return row;
        });
        return {
            data: data,
            accessors: {
                x: 0,
                y: 1,
                ...colorAccessor !== undefined ? {
                    color: 2
                } : {}
            }
        };
    }
    if (labelAccessor !== undefined && valueAccessor !== undefined) {
        const data = payload.data.map((item)=>{
            const record = $77d466caab7173e9$var$isRecord(item) ? item : {};
            const row = [
                String(record[labelAccessor]),
                isNaN(Number(record[valueAccessor])) ? String(record[valueAccessor]) : Number(record[valueAccessor])
            ];
            if (colorAccessor !== undefined && record[colorAccessor] !== undefined) row.push(String(record[colorAccessor]));
            return row;
        });
        return {
            data: data,
            accessors: {
                label: 0,
                value: 1,
                ...colorAccessor !== undefined ? {
                    color: 2
                } : {}
            }
        };
    }
    return {
        data: [],
        accessors: {}
    };
}
/**
 * Builds chart config options from payload
 */ function $77d466caab7173e9$var$buildChartConfigOptions(payload) {
    const options = [];
    if (payload.chartTitle) options.push({
        name: 'title',
        jsonValue: JSON.stringify(payload.chartTitle)
    });
    if (payload.subtitle) options.push({
        name: 'subtitle',
        jsonValue: JSON.stringify(payload.subtitle)
    });
    return options;
}
function $77d466caab7173e9$export$888640ec610bcd3(payload, workspaceId, chartId, dataFetchStrategy) {
    const avpChartType = $77d466caab7173e9$var$mapChartTypeToGraphQL(payload.chartType);
    const chartConfigOptions = $77d466caab7173e9$var$buildChartConfigOptions(payload);
    const { data: data, accessors: accessors } = $77d466caab7173e9$var$transformChartData(payload);
    const metricsConfig = payload.metricsConfig;
    const metrics = metricsConfig?.metricNames;
    const metricWorkspace = workspaceId || metricsConfig?.workspaceId;
    if (metrics && metrics.length > 0 && !metricWorkspace) throw new Error('No workspaceId found for the metricConfig and datasourceLocator');
    if (data.length === 0) throw new Error('Cannot create chart: chart requires non-empty data and resolvable accessors');
    const resolvedDataFetchStrategy = dataFetchStrategy ?? ((metrics?.length ?? 0) > 0 ? 'DYNAMIC' : 'STATIC');
    return {
        chartType: 'avp_chart',
        ...chartId ? {
            id: chartId
        } : {},
        chartConfig: {
            settings: [],
            clientSettings: {
                type: avpChartType,
                options: chartConfigOptions
            },
            dataFetchStrategy: resolvedDataFetchStrategy,
            vizConfig: {
                accessors: accessors,
                data: data
            }
        },
        ...metrics && metrics.length > 0 && metricsConfig ? {
            pipeline: {
                nodes: [],
                queries: [
                    {
                        isManual: false,
                        metricsConfiguration: {
                            metrics: metrics,
                            dimensions: $77d466caab7173e9$var$transformDimensions(metricsConfig.dimensions ?? []),
                            filters: $77d466caab7173e9$var$transformFilters(metricsConfig.filters ?? []),
                            granularity: metricsConfig.granularity || null,
                            workspaceId: metricWorkspace,
                            searchCondition: metricsConfig.searchCondition || null
                        },
                        datasourceLocator: {
                            dstype: 'HotTier',
                            workspaceId: metricWorkspace
                        }
                    }
                ]
            }
        } : {}
    };
}
module.exports["CREATE_STANDALONE_CHART_QUERY"] = $77d466caab7173e9$export$771b6ec7a445547;
module.exports["CREATE_CHART_TO_DASHBOARD_MUTATION"] = $77d466caab7173e9$export$a21c2ea9e8651553;
module.exports["getActivationIdMappingByCloudId"] = $77d466caab7173e9$export$f3f262f23f5ef2e5;
module.exports["resolveWorkspaceIdForMetricWithMapping"] = $77d466caab7173e9$export$badfbb3c54037700;
module.exports["resolveWorkspaceIdForMetric"] = $77d466caab7173e9$export$fb528d54105b2793;
module.exports["transformChartPayloadToAvpInput"] = $77d466caab7173e9$export$888640ec610bcd3;

});

parcelRegister("4ee1h", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Ou0Zz = parcelRequire("Ou0Zz");

const $490637d578ed6836$export$b3e087cb7a0808af = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    let t0;
    if ($[0] !== sendAnalyticsEvent) {
        t0 = (payload)=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "actioned",
                actionSubject: "rovoChatMessageAction",
                attributes: {
                    recipientAgentNamedId: payload.context.recipient_agent_named_id,
                    actionKey: payload.context.key,
                    resolutionType: payload.context.resolution.type
                }
            });
        };
        $[0] = sendAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireUiActionedAnalytics = t0;
    let t1;
    if ($[2] !== trackAIMAUEvent) {
        t1 = (payload_0, agentMessageId, interactionModeExecuted, aiFeatureName)=>{
            const attributes = {
                actionKey: payload_0.context.key,
                ...interactionModeExecuted ? {
                    interactionModeExecuted: interactionModeExecuted
                } : {},
                ...aiFeatureName ? {
                    aiFeatureName: aiFeatureName
                } : {}
            };
            bb11: switch(payload_0.context.resolution.type){
                case "actioned":
                    trackAIMAUEvent({
                        type: "actioned",
                        actionResult: "messageActionedExternally",
                        attributes: attributes,
                        proactive: false,
                        singleInstrumentationID: agentMessageId
                    });
                    break bb11;
                case "confirm":
                    trackAIMAUEvent({
                        type: "actioned",
                        actionResult: "confirmActionClicked",
                        attributes: attributes,
                        proactive: false,
                        singleInstrumentationID: agentMessageId
                    });
                    break bb11;
                case "cancel":
                    trackAIMAUEvent({
                        type: "actioned",
                        actionResult: "cancelActionClicked",
                        attributes: attributes,
                        proactive: false,
                        singleInstrumentationID: agentMessageId
                    });
            }
        };
        $[2] = trackAIMAUEvent;
        $[3] = t1;
    } else t1 = $[3];
    const fireAIMAUActionedAnalytics = t1;
    let t2;
    if ($[4] !== fireAIMAUActionedAnalytics || $[5] !== fireUiActionedAnalytics) {
        t2 = {
            fireUiActionedAnalytics: fireUiActionedAnalytics,
            fireAIMAUActionedAnalytics: fireAIMAUActionedAnalytics
        };
        $[4] = fireAIMAUActionedAnalytics;
        $[5] = fireUiActionedAnalytics;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const fireUiActionedAnalytics = (0, $cozmU.useCallback)((payload)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'actioned',
            actionSubject: 'rovoChatMessageAction',
            attributes: {
                recipientAgentNamedId: payload.context.recipient_agent_named_id,
                actionKey: payload.context.key,
                resolutionType: payload.context.resolution.type
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const fireAIMAUActionedAnalytics = (0, $cozmU.useCallback)((payload_0, agentMessageId, interactionModeExecuted, aiFeatureName)=>{
        const attributes = {
            actionKey: payload_0.context.key,
            ...interactionModeExecuted ? {
                interactionModeExecuted: interactionModeExecuted
            } : {},
            ...aiFeatureName ? {
                aiFeatureName: aiFeatureName
            } : {}
        };
        switch(payload_0.context.resolution.type){
            case 'actioned':
                trackAIMAUEvent({
                    type: 'actioned',
                    actionResult: 'messageActionedExternally',
                    attributes: attributes,
                    proactive: false,
                    singleInstrumentationID: agentMessageId
                });
                break;
            case 'confirm':
                trackAIMAUEvent({
                    type: 'actioned',
                    actionResult: 'confirmActionClicked',
                    attributes: attributes,
                    proactive: false,
                    singleInstrumentationID: agentMessageId
                });
                break;
            case 'cancel':
                trackAIMAUEvent({
                    type: 'actioned',
                    actionResult: 'cancelActionClicked',
                    attributes: attributes,
                    proactive: false,
                    singleInstrumentationID: agentMessageId
                });
                break;
        }
    }, [
        trackAIMAUEvent
    ]);
    return {
        fireUiActionedAnalytics: fireUiActionedAnalytics,
        fireAIMAUActionedAnalytics: fireAIMAUActionedAnalytics
    };
};
module.exports["useMessageActionedAnalytics"] = $490637d578ed6836$export$b3e087cb7a0808af;

});

parcelRegister("itpo2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4be337a0854dc10329a216cf9ae09002>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d72ea0b312f9d00a$var$_react = $d72ea0b312f9d00a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d72ea0b312f9d00a$var$_baseNew = $d72ea0b312f9d00a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d72ea0b312f9d00a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d72ea0b312f9d00a$var$DashboardIcon = (props)=>/*#__PURE__*/ $d72ea0b312f9d00a$var$_react.default.createElement($d72ea0b312f9d00a$var$_baseNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$d72ea0b312f9d00a$var$DashboardIcon.displayName = 'DashboardIcon';
var $d72ea0b312f9d00a$var$_default = module.exports.default = $d72ea0b312f9d00a$var$DashboardIcon;

});

parcelRegister("63fke", function(module, exports) {
var $62a0180409ebc190$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["whiteboard"] = "whiteboard";
    ContentType["liveDoc"] = "liveDoc";
    ContentType["database"] = "database";
    ContentType["workItem"] = "workItem";
    ContentType["slides"] = "slides";
    ContentType["dashboard"] = "dashboard";
    ContentType["page"] = "page";
    return ContentType;
}({});
const $62a0180409ebc190$export$69b773d96829ab84 = (type, subType)=>{
    // CNS-26518: slides may be returned by AGG as a top-level `'slide'` content
    // type (modern data shape used after publishing slides to Confluence) or as
    // a `'whiteboard'` with `subType === 'slide'` (legacy shape). Normalise both
    // here so the slides icon never disappears from the chat preview card.
    if (type === 'slide') return "slides";
    if (type === 'whiteboard') return subType === 'slide' ? "slides" : "whiteboard";
    if (type === 'page') return subType === 'live' ? "liveDoc" : "page";
    if (type === 'database') return "database";
    return null;
};
module.exports["ContentType"] = $62a0180409ebc190$export$e2e108cbe2e4f865;
module.exports["getContentTypeFromPublishedContent"] = $62a0180409ebc190$export$69b773d96829ab84;

});

parcelRegister("6ASE9", function(module, exports) {

var $kWSTb = parcelRequire("kWSTb");


var $kLlYX = parcelRequire("kLlYX");


var $lBKFk = parcelRequire("lBKFk");


var $hMaHH = parcelRequire("hMaHH");


var $bDjVc = parcelRequire("bDjVc");


var $63fke = parcelRequire("63fke");


var $7jUVh = parcelRequire("7jUVh");

const $3b8ac8a94543df1c$export$f7025ccf7825f8c9 = (contentType)=>{
    switch(contentType){
        case (0, $63fke.ContentType).whiteboard:
            return {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
                appearance: 'teal',
                boldAppearance: 'tealBold',
                altText: (0, $7jUVh.messages).whiteboardIconAlt
            };
        case (0, $63fke.ContentType).liveDoc:
            return {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
                appearance: 'magenta',
                boldAppearance: 'magentaBold',
                altText: (0, $7jUVh.messages).liveDocIconAlt
            };
        case (0, $63fke.ContentType).database:
            return {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
                appearance: 'purple',
                boldAppearance: 'purpleBold',
                altText: (0, $7jUVh.messages).databaseIconAlt
            };
        case (0, $63fke.ContentType).slides:
            return {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
                appearance: 'green',
                boldAppearance: 'greenBold',
                altText: (0, $7jUVh.messages).slidesIconAlt
            };
        case (0, $63fke.ContentType).page:
            return {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
                appearance: 'blue',
                boldAppearance: 'blueBold',
                altText: (0, $7jUVh.messages).pageIconAlt
            };
        default:
            return null;
    }
};
module.exports["getPreviewItemIconConfig"] = $3b8ac8a94543df1c$export$f7025ccf7825f8c9;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58786e80764588d2fd870a7346986359>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_baseNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("7jUVh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9ddb9849227bcdeb$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    liveDocIconAlt: {
        id: "ai-mate.rovo-platform-ui-components.preview-item.live-doc-icon-alt",
        defaultMessage: "Live Doc Icon"
    },
    whiteboardIconAlt: {
        id: "ai-mate.rovo-platform-ui-components.preview-item.whiteboard-icon-alt",
        defaultMessage: "Whiteboard Icon"
    },
    databaseIconAlt: {
        id: "ai-mate.rovo-platform-ui-components.preview-item.database-icon-alt",
        defaultMessage: "Database Icon"
    },
    slidesIconAlt: {
        id: "ai-mate.rovo-platform-ui-components.preview-item.slides-icon-alt",
        defaultMessage: "Slides Icon"
    },
    pageIconAlt: {
        id: "ai-mate.rovo-platform-ui-components.preview-item.page-icon-alt",
        defaultMessage: "Page Icon"
    }
});
module.exports["messages"] = $9ddb9849227bcdeb$export$defe85febe8b728c;

});

parcelRegister("3FVEI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lSQgn = parcelRequire("lSQgn");


var $6ASE9 = parcelRequire("6ASE9");

const $ca5fc648c611b860$export$aff29aefe39d0ce2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(14);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let config;
    let t0;
    let t1;
    if ($[0] !== formatMessage || $[1] !== props.contentType) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            config = (0, $6ASE9.getPreviewItemIconConfig)(props.contentType);
            if (!config) {
                t1 = null;
                break bb0;
            }
            t0 = formatMessage(config.altText);
        }
        $[0] = formatMessage;
        $[1] = props.contentType;
        $[2] = config;
        $[3] = t0;
        $[4] = t1;
    } else {
        config = $[2];
        t0 = $[3];
        t1 = $[4];
    }
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    const label = t0;
    if (props.variant === "plain") {
        const Icon = config.icon;
        let t2;
        if ($[5] !== Icon || $[6] !== label || $[7] !== props.size) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                label: label,
                size: props.size
            });
            $[5] = Icon;
            $[6] = label;
            $[7] = props.size;
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    const t2 = props.bold ? config.boldAppearance : config.appearance;
    let t3;
    if ($[9] !== config.icon || $[10] !== label || $[11] !== props.size || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: config.icon,
            label: label,
            appearance: t2,
            size: props.size
        });
        $[9] = config.icon;
        $[10] = label;
        $[11] = props.size;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const config = (0, $6ASE9.getPreviewItemIconConfig)(props.contentType);
    if (!config) return null;
    const label = formatMessage(config.altText);
    if (props.variant === 'plain') {
        const Icon = config.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            size: props.size
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: config.icon,
        label: label,
        appearance: props.bold ? config.boldAppearance : config.appearance,
        size: props.size
    });
};
module.exports["PreviewItemIcon"] = $ca5fc648c611b860$export$aff29aefe39d0ce2;

});

parcelRegister("gR27Z", function(module, exports) {
/* Reactions.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $aRGok = parcelRequire("aRGok");


var $a1L5E = parcelRequire("a1L5E");


var $iDrrr = parcelRequire("iDrrr");


var $3aKBk = parcelRequire("3aKBk");


var $lbdYm = parcelRequire("lbdYm");


var $jFWFL = parcelRequire("jFWFL");


var $jOmQq = parcelRequire("jOmQq");


var $97zIA = parcelRequire("97zIA");


var $j2uPw = parcelRequire("j2uPw");


var $9aIb5 = parcelRequire("9aIb5");


var $bm4sQ = parcelRequire("bm4sQ");


var $5VUoE = parcelRequire("5VUoE");

const $96abc169ab45ec97$var$wrapperStyle = null;
const $96abc169ab45ec97$var$noFlexWrapStyles = null;
const $96abc169ab45ec97$var$noContainerPositionStyles = null;
const $96abc169ab45ec97$var$reactionPickerStyle = null;
const $96abc169ab45ec97$var$listContainerStyles = null; /**
                                   * Set of all available UFO experiences relating to Reactions Dialog
                                   */ 
const $96abc169ab45ec97$export$615f888019c45765 = {
    /**
   * Experience when a reaction dialog is opened
   */ openDialog: (0, $97zIA.ReactionDialogOpened),
    /**
   * Experience when a reaction changed/fetched from inside the modal dialog
   */ selectedReactionChangeInsideDialog: (0, $97zIA.ReactionDialogSelectedReactionChanged)
}; /**
    * Test id for wrapper Reactions div
    */ 
const $96abc169ab45ec97$export$45beea5a8efd4cda = 'render-reactions'; /**
                                                            * Test id for the view all reacted user to trigger the dialog
                                                            */ 
const $96abc169ab45ec97$export$6fd545f57ca8a08a = 'viewall-reacted-users-dialog'; /**
                                                                                    * Test id for summary view of reactions
                                                                                    */ 
const $96abc169ab45ec97$export$23a875699bfce51b = 'reaction-summary-view';
function $96abc169ab45ec97$export$46455b4476d4b8e1(status, errorMessage, tooltipContent) {
    switch(status){
        case (0, $jOmQq.ReactionStatus).error:
            return errorMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).unexpectedError);
        // When reaction is not available don't show any tooltip (e.g. Archive page in Confluence)
        case (0, $jOmQq.ReactionStatus).disabled:
            return null;
        case (0, $jOmQq.ReactionStatus).notLoaded:
        case (0, $jOmQq.ReactionStatus).loading:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).loadingReactions);
        case (0, $jOmQq.ReactionStatus).ready:
            return !!tooltipContent ? tooltipContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).addReaction);
    }
} /**
   * Renders list of reactions
   */ 
const $96abc169ab45ec97$export$44cd1c46d5ca2376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, status: status, errorMessage: errorMessage, loadReaction: loadReaction, quickReactionEmojis: quickReactionEmojis, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, getReactionDetails: getReactionDetails = ()=>{}, onSelection: onSelection, reactions: reactions = [], emojiProvider: emojiProvider, allowAllEmojis: allowAllEmojis, onReactionClick: onReactionClick, allowUserDialog: allowUserDialog, onDialogOpenCallback: onDialogOpenCallback = ()=>{}, onDialogCloseCallback: onDialogCloseCallback = ()=>{}, onDialogSelectReactionCallback: onDialogSelectReactionCallback = ()=>{}, onDialogPageChangeCallback: onDialogPageChangeCallback = ()=>{}, emojiPickerSize: emojiPickerSize = 'medium', miniMode: miniMode = false, summaryViewEnabled: summaryViewEnabled = false, summaryViewThreshold: summaryViewThreshold = 3, summaryViewPlacement: summaryViewPlacement, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, hideDefaultReactions: hideDefaultReactions = false, ProfileCardWrapper: ProfileCardWrapper, onlyRenderPicker: onlyRenderPicker = false, isViewOnly: isViewOnly = false, noWrap: noWrap = false, noRelativeContainer: noRelativeContainer = false, showSubtleDefaultReactions: showSubtleDefaultReactions, reactionPickerTriggerTooltipContent: reactionPickerTriggerTooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, allowSelectFromSummaryView: allowSelectFromSummaryView = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, isListItem: isListItem = false, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, getOptimisticImageURL: getOptimisticImageURL, reactionPickerPlacement: reactionPickerPlacement, summaryButtonIconAfter: summaryButtonIconAfter, renderParticleEffectOnSummaryView: renderParticleEffectOnSummaryView = false, reactionPickerPopperZIndex: reactionPickerPopperZIndex })=>{
    const [selectedEmojiId, setSelectedEmojiId] = (0, $cozmU.useState)('');
    const [summaryViewParticleEffectEmojiId, setSummaryViewParticleEffectEmojiId] = (0, $cozmU.useState)(null); // if the reactions are empty, then set summaryViewParticleEffectEmojiId to null to clear the particle effect state
    (0, $cozmU.useEffect)(()=>{
        if (reactions.length === 0) setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let openTime = (0, $cozmU.useRef)();
    let renderTime = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (status === (0, $jOmQq.ReactionStatus).notLoaded) loadReaction();
    }, [
        status,
        loadReaction
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status !== (0, $jOmQq.ReactionStatus).ready) renderTime.current = Date.now();
        else {
            const isSSR = undefined;
            if ((0, $3aKBk.isSampled)((0, $lbdYm.SAMPLING_RATE_REACTIONS_RENDERED_EXP)) && !isSSR) (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionsRenderedEvent), renderTime.current ?? Date.now() //renderTime.current can be null during unit test cases
            );
            renderTime.current = undefined;
        }
    }, [
        createAnalyticsEvent,
        status
    ]);
    const handleReactionMouseEnter = (0, $cozmU.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handleReactionFocused = (0, $cozmU.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handlePickerOpen = (0, $cozmU.useCallback)(()=>{
        openTime.current = Date.now();
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createPickerButtonClickedEvent), reactions.length);
    }, [
        createAnalyticsEvent,
        reactions
    ]);
    const handleOnCancel = (0, $cozmU.useCallback)(()=>{
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createPickerCancelledEvent), openTime.current);
        openTime.current = undefined;
    }, [
        createAnalyticsEvent
    ]);
    const handleOnMore = (0, $cozmU.useCallback)(()=>{
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createPickerMoreClickedEvent), openTime.current);
    }, [
        createAnalyticsEvent
    ]);
    const handleSetSummaryViewParticleEffectEmojiId = (0, $cozmU.useCallback)((emojiId)=>{
        // Find if this emoji is already in existing reactions
        const existingReaction = reactions.find((reaction)=>reaction.emojiId === emojiId); // Only set mostRecentlyClickedId if user hasn't reacted with this emoji yet
        if (!existingReaction?.reacted) setSummaryViewParticleEffectEmojiId({
            id: emojiId,
            shortName: ''
        });
        else setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions,
        setSummaryViewParticleEffectEmojiId
    ]);
    const handleOnSelection = (0, $cozmU.useCallback)((emojiId, source)=>{
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionSelectionEvent), source, emojiId, reactions.find((reaction)=>reaction.emojiId === emojiId), openTime.current);
        openTime.current = undefined;
        onSelection(emojiId);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        createAnalyticsEvent,
        onSelection,
        reactions,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleSummaryViewReactionClick = (0, $cozmU.useCallback)((emojiId, event)=>{
        onReactionClick(emojiId, event);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        onReactionClick,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleCloseReactionsDialog = (e, analyticsEvent)=>{
        setSelectedEmojiId('');
        onDialogCloseCallback(e, analyticsEvent);
    };
    const handleSelectReactionInDialog = (emojiId)=>{
        // ufo selected reaction inside the modal dialog
        $96abc169ab45ec97$export$615f888019c45765.selectedReactionChangeInsideDialog.start();
        handleReactionMouseEnter(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogSelectReactionCallback(emojiId); // ufo selected reaction inside the modal dialog success
        $96abc169ab45ec97$export$615f888019c45765.selectedReactionChangeInsideDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Selected Emoji changed'
            }
        });
    };
    const handlePaginationChange = (0, $cozmU.useCallback)((emojiId, currentPage, maxPages)=>{
        // fetch the latest active emoji from the new page
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogPageChangeCallback(emojiId, currentPage, maxPages);
    }, // Exclude unstable getReactionDetails to avoid extra re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectedEmojiId
    ]); /**
                          * Get the reactions that we want to render are any reactions with a count greater than zero as well as any default emoji not already shown
                          */ 
    const memorizedReactions = (0, $cozmU.useMemo)(()=>{
        //
        /**
     * If reactions not empty, don't show quick reactions Pre defined emoji or if its empty and default reactions not hidden => return the current list of reactions
     */ if (reactions.length === 0 && hideDefaultReactions || reactions.length > 0 || !quickReactionEmojis) return reactions;
         // add any missing default reactions
        const { ari: ari, containerAri: containerAri, emojiIds: emojiIds } = quickReactionEmojis;
        const items = emojiIds.filter((emojiId)=>!reactions.some((reaction)=>reaction.emojiId === emojiId)).map((emojiId)=>{
            return {
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId,
                count: 0,
                reacted: false
            };
        });
        return reactions.concat(items);
    }, [
        quickReactionEmojis,
        reactions,
        hideDefaultReactions
    ]);
    const shouldShowSummaryView = summaryViewEnabled && memorizedReactions.length >= summaryViewThreshold && reactions.length > 0; // criteria to show Reactions Dialog
    const hasEmojiWithFivePlusReactions = reactions.some((reaction)=>reaction.count >= 5);
    const shouldShowPicker = !isViewOnly && !(!onlyRenderPicker && shouldShowSummaryView && allowSelectFromSummaryView);
    const sortedReactions = (0, $cozmU.useMemo)(()=>{
        return [
            ...memorizedReactions
        ].sort((a, b)=>b?.count - a?.count);
    }, [
        memorizedReactions
    ]); /**
                             * event handler to open dialog with selected reaction
                             * @param emojiId initial emoji id to load dialog with
                             */ 
    const handleOpenReactionsDialog = ({ emojiId: emojiId = sortedReactions[0].emojiId, source: source = 'endOfPageReactions' } = {})=>{
        // ufo start opening reaction dialog
        $96abc169ab45ec97$export$615f888019c45765.openDialog.start();
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogOpenCallback(emojiId, source); // ufo opening reaction dialog success
        $96abc169ab45ec97$export$615f888019c45765.openDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Opening Reactions Dialog successfully'
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $96abc169ab45ec97$export$45beea5a8efd4cda,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _1mT5xdRAKS _0hPCNLDIqT _43nrzT5UaJ _3ptPdXdnbC",
            noWrap && "_3TGfC9LRg7",
            noRelativeContainer && "_1mT5xd5HSx"
        ])
    }, !onlyRenderPicker && (shouldShowSummaryView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $96abc169ab45ec97$export$23a875699bfce51b
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5VUoE.ReactionSummaryView), {
        reactions: sortedReactions,
        emojiProvider: emojiProvider,
        flash: flash,
        particleEffectByEmoji: particleEffectByEmoji,
        onSelection: handleOnSelection,
        onReactionClick: handleSummaryViewReactionClick,
        onReactionFocused: handleReactionFocused,
        onReactionMouseEnter: handleReactionMouseEnter,
        placement: summaryViewPlacement,
        showOpaqueBackground: showOpaqueBackground,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
        handleOpenReactionsDialog: ()=>handleOpenReactionsDialog({
                source: 'summaryView'
            }),
        allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
        isViewOnly: isViewOnly,
        allowSelectFromSummaryView: allowSelectFromSummaryView,
        disabled: status !== (0, $jOmQq.ReactionStatus).ready,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        tooltipContent: $96abc169ab45ec97$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
        emojiPickerSize: emojiPickerSize,
        onOpen: handlePickerOpen,
        useButtonAlignmentStyling: useButtonAlignmentStyling,
        reactionPickerTriggerText: reactionPickerTriggerText,
        hoverableSummaryView: hoverableSummaryView,
        summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
        summaryButtonIconAfter: summaryButtonIconAfter,
        summaryViewParticleEffectEmojiId: renderParticleEffectOnSummaryView ? summaryViewParticleEffectEmojiId : null
    })) : (0, $iDrrr.fg)('jfp_a11y_team_comment_actions_semantic') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _1mT5xdRAKS"
        ])
    }, memorizedReactions.map((reaction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2uPw.Reaction), {
            key: reaction.emojiId,
            rootElement: "li",
            reaction: reaction,
            emojiProvider: emojiProvider,
            onClick: onReactionClick,
            onMouseEnter: handleReactionMouseEnter,
            onFocused: handleReactionFocused,
            flash: flash[reaction.emojiId],
            showParticleEffect: particleEffectByEmoji[reaction.emojiId],
            showOpaqueBackground: showOpaqueBackground,
            allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
            handleOpenReactionsDialog: handleOpenReactionsDialog,
            isViewOnly: isViewOnly,
            showSubtleStyle: showSubtleDefaultReactions && reactions.length === 0,
            optimisticImageURL: (0, $iDrrr.fg)('platform_reactions_optimistic_url') ? getOptimisticImageURL?.(reaction.emojiId) : undefined
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, memorizedReactions.map((reaction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2uPw.Reaction), {
            key: reaction.emojiId,
            reaction: reaction,
            emojiProvider: emojiProvider,
            onClick: onReactionClick,
            onMouseEnter: handleReactionMouseEnter,
            onFocused: handleReactionFocused,
            flash: flash[reaction.emojiId],
            showParticleEffect: particleEffectByEmoji[reaction.emojiId],
            showOpaqueBackground: showOpaqueBackground,
            allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
            handleOpenReactionsDialog: handleOpenReactionsDialog,
            isViewOnly: isViewOnly,
            showSubtleStyle: showSubtleDefaultReactions && reactions.length === 0,
            optimisticImageURL: (0, $iDrrr.fg)('platform_reactions_optimistic_url') ? getOptimisticImageURL?.(reaction.emojiId) : undefined
        })))), shouldShowPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bm4sQ.ReactionPicker), {
        emojiProvider: emojiProvider,
        allowAllEmojis: allowAllEmojis,
        pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
        disabled: status !== (0, $jOmQq.ReactionStatus).ready,
        onSelection: handleOnSelection,
        onOpen: handlePickerOpen,
        onCancel: handleOnCancel,
        onShowMore: handleOnMore,
        tooltipContent: hoverableSummaryView ? null : $96abc169ab45ec97$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
        emojiPickerSize: emojiPickerSize,
        miniMode: miniMode,
        showOpaqueBackground: showOpaqueBackground,
        showAddReactionText: showAddReactionText,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        reactionPickerTriggerText: reactionPickerTriggerText,
        isListItem: isListItem,
        hoverableReactionPicker: hoverableSummaryView,
        hoverableReactionPickerDelay: hoverableSummaryView ? 300 : 0,
        reactionPickerPlacement: reactionPickerPlacement,
        reactionPickerPopperZIndex: reactionPickerPopperZIndex,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _43nrzT1Y8M"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, !!selectedEmojiId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "reactions-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aIb5.ReactionsDialog), {
        selectedEmojiId: selectedEmojiId,
        reactions: sortedReactions,
        emojiProvider: emojiProvider,
        handleCloseReactionsDialog: handleCloseReactionsDialog,
        handleSelectReaction: handleSelectReactionInDialog,
        handlePaginationChange: handlePaginationChange,
        ProfileCardWrapper: ProfileCardWrapper
    })))));
});
module.exports["Reactions"] = $96abc169ab45ec97$export$44cd1c46d5ca2376;

});

parcelRegister("3aKBk", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $2iGHk = parcelRequire("2iGHk");


var $852mP = parcelRequire("852mP");

const $7403ad658064272a$var$packageName = "platform-pkg";
const $7403ad658064272a$var$packageVersion = "0.0.0-use.local";
const $7403ad658064272a$export$ed7a494f7df966be = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $7403ad658064272a$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
const $7403ad658064272a$export$1b95a6072f2f9fae = (createAnalyticsEvent, creator, ...args)=>{
    if (createAnalyticsEvent) $7403ad658064272a$export$53eef0dcd9611650(creator(...args))(createAnalyticsEvent);
};
const $7403ad658064272a$var$createPayload = (action, actionSubject, eventType, actionSubjectId)=>(attributes = {})=>({
            action: action,
            actionSubject: actionSubject,
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes,
                packageName: $7403ad658064272a$var$packageName,
                packageVersion: $7403ad658064272a$var$packageVersion
            }
        });
const $7403ad658064272a$var$calculateDuration = (startTime)=>startTime ? Date.now() - startTime : undefined;
const $7403ad658064272a$var$getPreviousState = (reaction)=>{
    if (reaction) {
        if (reaction.reacted) return 'existingReacted';
        return 'existingNotReacted';
    }
    return 'new';
};
const $7403ad658064272a$export$d61cc4fea6b821c6 = (actionSubject)=>$7403ad658064272a$var$createPayload('succeeded', actionSubject, (0, $852mP.OPERATIONAL_EVENT_TYPE))();
const $7403ad658064272a$export$33f46652cacb6853 = (actionSubject, errorCode)=>$7403ad658064272a$var$createPayload('failed', actionSubject, (0, $852mP.OPERATIONAL_EVENT_TYPE))({
        errorCode: errorCode
    });
const $7403ad658064272a$export$fd86d4b03f87495 = (startTime)=>$7403ad658064272a$var$createPayload('rendered', 'reactionView', (0, $852mP.OPERATIONAL_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$5797d4afdfbf7ff2 = (reactionEmojiCount)=>$7403ad658064272a$var$createPayload('clicked', 'reactionPickerButton', (0, $852mP.UI_EVENT_TYPE))({
        reactionEmojiCount: reactionEmojiCount
    });
const $7403ad658064272a$export$aa268ce0cc416ab4 = (startTime)=>$7403ad658064272a$var$createPayload('cancelled', 'reactionPicker', (0, $852mP.UI_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$280ed8781309406f = (startTime)=>$7403ad658064272a$var$createPayload('clicked', 'reactionPicker', (0, $852mP.UI_EVENT_TYPE), 'more')({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$6181167d075f0ec0 = (source, emojiId, reaction, startTime)=>$7403ad658064272a$var$createPayload('clicked', 'reactionPicker', (0, $852mP.UI_EVENT_TYPE), 'emoji')({
        duration: $7403ad658064272a$var$calculateDuration(startTime),
        source: source,
        previousState: $7403ad658064272a$var$getPreviousState(reaction),
        emojiId: emojiId
    });
const $7403ad658064272a$export$c7349958d247ace6 = (startTime)=>$7403ad658064272a$var$createPayload('hovered', 'existingReaction', (0, $852mP.UI_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$2402f68e3d87389c = (startTime)=>$7403ad658064272a$var$createPayload('focused', 'existingReaction', (0, $852mP.UI_EVENT_TYPE))({
        duration: $7403ad658064272a$var$calculateDuration(startTime)
    });
const $7403ad658064272a$export$d3f48819b8df93ec = (added, emojiId)=>$7403ad658064272a$var$createPayload('clicked', 'existingReaction', (0, $852mP.UI_EVENT_TYPE))({
        added: added,
        emojiId: emojiId
    });
const $7403ad658064272a$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};
module.exports["isSampled"] = $7403ad658064272a$export$ed7a494f7df966be;
module.exports["createAndFireSafe"] = $7403ad658064272a$export$1b95a6072f2f9fae;
module.exports["createRestSucceededEvent"] = $7403ad658064272a$export$d61cc4fea6b821c6;
module.exports["createRestFailedEvent"] = $7403ad658064272a$export$33f46652cacb6853;
module.exports["createReactionsRenderedEvent"] = $7403ad658064272a$export$fd86d4b03f87495;
module.exports["createPickerButtonClickedEvent"] = $7403ad658064272a$export$5797d4afdfbf7ff2;
module.exports["createPickerCancelledEvent"] = $7403ad658064272a$export$aa268ce0cc416ab4;
module.exports["createPickerMoreClickedEvent"] = $7403ad658064272a$export$280ed8781309406f;
module.exports["createReactionSelectionEvent"] = $7403ad658064272a$export$6181167d075f0ec0;
module.exports["createReactionHoveredEvent"] = $7403ad658064272a$export$c7349958d247ace6;
module.exports["createReactionFocusedEvent"] = $7403ad658064272a$export$2402f68e3d87389c;
module.exports["createReactionClickedEvent"] = $7403ad658064272a$export$d3f48819b8df93ec;
module.exports["extractErrorInfo"] = $7403ad658064272a$export$74aaf4784c2edb2c;

});

parcelRegister("lbdYm", function(module, exports) {
const $addde3a1004d4e01$export$a1b2ffe56d40782b = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    }
];
const $addde3a1004d4e01$export$f3516ebbf35f82ea = [
    {
        id: 'atlassian-thumbs_up',
        shortName: ':thumbs_up:'
    },
    {
        id: 'atlassian-clap',
        shortName: ':clap:'
    },
    {
        id: 'atlassian-fire',
        shortName: ':fire:'
    },
    {
        id: 'atlassian-red_heart',
        shortName: ':red_heart:'
    },
    {
        id: 'atlassian-surprise',
        shortName: ':surprise:'
    },
    {
        id: 'atlassian-thinking',
        shortName: ':thinking:'
    }
];
const $addde3a1004d4e01$export$86ad6a676949132c = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    },
    {
        id: '1f44e',
        shortName: ':thumbsdown:'
    },
    {
        id: '1f4a1',
        shortName: ':bulb:'
    },
    {
        id: '2b50',
        shortName: ':star:'
    },
    {
        id: '1f49a',
        shortName: ':green_heart:'
    },
    {
        id: '1f499',
        shortName: ':blue_heart:'
    },
    {
        id: '1f494',
        shortName: ':broken_heart:'
    },
    {
        id: '1f600',
        shortName: ':grinning:'
    },
    {
        id: '1f642',
        shortName: ':slight_smile:'
    }
];
const $addde3a1004d4e01$export$d8c2ebcd0ee41219 = new Map($addde3a1004d4e01$export$a1b2ffe56d40782b.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $addde3a1004d4e01$export$bae055b7087a845 = (isTeamojiPickerRefreshEnabled = false)=>isTeamojiPickerRefreshEnabled ? $addde3a1004d4e01$export$f3516ebbf35f82ea : $addde3a1004d4e01$export$a1b2ffe56d40782b;
const $addde3a1004d4e01$export$865044c189f353c2 = new Map($addde3a1004d4e01$export$86ad6a676949132c.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $addde3a1004d4e01$export$59a228d10bdb32fa = 5;
const $addde3a1004d4e01$export$85d1598de110e7b3 = 8;
const $addde3a1004d4e01$export$50b3c15a723386a7 = 50;
const $addde3a1004d4e01$export$d78bee0d9fab78ad = 16;
module.exports["DefaultReactions"] = $addde3a1004d4e01$export$a1b2ffe56d40782b;
module.exports["ExtendedReactions"] = $addde3a1004d4e01$export$86ad6a676949132c;
module.exports["DefaultReactionsByShortName"] = $addde3a1004d4e01$export$d8c2ebcd0ee41219;
module.exports["getDefaultReactions"] = $addde3a1004d4e01$export$bae055b7087a845;
module.exports["ExtendedReactionsByShortName"] = $addde3a1004d4e01$export$865044c189f353c2;
module.exports["TOOLTIP_USERS_LIMIT"] = $addde3a1004d4e01$export$59a228d10bdb32fa;
module.exports["NUMBER_OF_REACTIONS_TO_DISPLAY"] = $addde3a1004d4e01$export$85d1598de110e7b3;
module.exports["SAMPLING_RATE_REACTIONS_RENDERED_EXP"] = $addde3a1004d4e01$export$50b3c15a723386a7;
module.exports["RESOURCED_EMOJI_COMPACT_HEIGHT"] = $addde3a1004d4e01$export$d78bee0d9fab78ad;

});

parcelRegister("jFWFL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e3feb1f3f2c9dde8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    addReaction: {
        id: "fabric.reactions.add",
        defaultMessage: "Add reaction"
    },
    addNewReaction: {
        id: "fabric.reactions.add.new",
        defaultMessage: "Add new"
    },
    loadingReactions: {
        id: "fabric.reactions.loading",
        defaultMessage: "Loading..."
    },
    moreEmoji: {
        id: "fabric.reactions.more.emojis",
        defaultMessage: "More emojis"
    },
    reactWithEmoji: {
        id: "fabric.reactions.reactwithemoji",
        defaultMessage: "React with {emoji} emoji"
    },
    reactWithEmojiAndCount: {
        id: "fabric.reactions.reactwithemojiandcount",
        defaultMessage: "{count, plural, one {# {emoji} emoji} other {# {emoji} emojis}}. React with {emoji} emoji"
    },
    summary: {
        id: "fabric.reactions.summary",
        defaultMessage: "View all user reactions, {count, plural, one {# reaction} other {# reactions}}"
    },
    unexpectedError: {
        id: "fabric.reactions.error.unexpected",
        defaultMessage: "Reactions are temporarily unavailable"
    },
    otherUsers: {
        id: "fabric.reactions.other.reacted.users",
        defaultMessage: "{count, plural, one {and one other} other {and {count} others}}"
    },
    closeReactionsDialog: {
        id: "reactions.dialog.close",
        defaultMessage: "Close"
    },
    reactionsCount: {
        id: "reactions.dialog.reactions.count",
        defaultMessage: "{count, plural,\n        one {# total reaction}\n        other {# total reactions}\n      }"
    },
    leftNavigateLabel: {
        id: "reactions.dialog.left.navigate",
        defaultMessage: "Left Navigate"
    },
    rightNavigateLabel: {
        id: "reactions.dialog.right.navigate",
        defaultMessage: "Right Navigate"
    },
    emojiName: {
        id: "reactions.dialog.emoji.name",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{emojiName}"
    },
    seeWhoReacted: {
        id: "reactions.dialog.viewall",
        defaultMessage: "View all"
    },
    seeWhoReactedTooltip: {
        id: "reactions.dialog.viewall.tooltip",
        defaultMessage: "View all user reactions"
    },
    popperWrapperLabel: {
        id: "reactions-reaction.picker-label",
        defaultMessage: "Add reactions"
    }
});
module.exports["messages"] = $e3feb1f3f2c9dde8$export$defe85febe8b728c;

});

parcelRegister("jOmQq", function(module, exports) {
var $7022e8c6bf5742d1$export$3618cac445fcd41d = /*#__PURE__*/ function(ReactionUpdateType) {
    ReactionUpdateType["added"] = "added";
    ReactionUpdateType["removed"] = "removed";
    return ReactionUpdateType;
}({});
var $7022e8c6bf5742d1$export$ae1bec9d610f93d3 = /*#__PURE__*/ function(ReactionStatus) {
    ReactionStatus["ready"] = "READY";
    ReactionStatus["loading"] = "LOADING";
    ReactionStatus["error"] = "ERROR";
    ReactionStatus["notLoaded"] = "NOT_LOADED";
    ReactionStatus["disabled"] = "DISABLED";
    return ReactionStatus;
}({});
module.exports["ReactionUpdateType"] = $7022e8c6bf5742d1$export$3618cac445fcd41d;
module.exports["ReactionStatus"] = $7022e8c6bf5742d1$export$ae1bec9d610f93d3;

});

parcelRegister("97zIA", function(module, exports) {

var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

var $cNAch = parcelRequire("cNAch");


var $5O0tO = parcelRequire("5O0tO");

/**
 * Helper method for create the config type for an individual/Concurrent experience
 * @param componentName
 */ const $7baed629d8d594eb$var$createExperienceConfig = (componentName, type, performanceType)=>{
    return {
        platform: {
            component: componentName
        },
        type: type,
        performanceType: performanceType
    };
};
var $7baed629d8d594eb$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REACTIONS_RENDERED"] = "reactions-rendered";
    ExperienceName["PICKER_OPENED"] = "reactions-picker-opened";
    ExperienceName["REACTION_ADDED"] = "reaction-added";
    ExperienceName["REACTION_REMOVED"] = "reaction-removed";
    ExperienceName["REACTION_DETAILS_FETCHED"] = "reaction-details-fetched";
    ExperienceName["REACTION_DIALOG_OPENED"] = "reaction-dialog-opened";
    ExperienceName["REACTION_DIALOG_CLOSED"] = "reaction-dialog-closed";
    ExperienceName["REACTION_DIALOG_SELECTED_REACTION_CHANGED"] = "reaction-dialog-selected-reaction-changed";
    ExperienceName["REACTION_DIALOG_PAGE_NAVIGATION"] = "reaction-dialog-page-navigation";
    return ExperienceName;
}({});
var $7baed629d8d594eb$export$57d347d1902b5fe6 = /*#__PURE__*/ function(ComponentName) {
    ComponentName["PICKER_RENDERED"] = "reactions-picker";
    ComponentName["REACTIONS"] = "reactions-list";
    ComponentName["REACTION_ITEM"] = "reaction-item";
    ComponentName["REACTION_DIALOG"] = "reaction-dialog";
    return ComponentName;
}({});
const $7baed629d8d594eb$export$6a3784263f4fa16e = new (0, $cNAch.UFOExperience)("reactions-picker-opened", $7baed629d8d594eb$var$createExperienceConfig("reactions-picker", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$5990348071f4d2f = new (0, $fh15z.ConcurrentExperience)("reactions-rendered", $7baed629d8d594eb$var$createExperienceConfig("reactions-list", (0, $4MiWC.ExperienceTypes).Load, (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad));
const $7baed629d8d594eb$export$2fe905192bb057 = new (0, $fh15z.ConcurrentExperience)("reaction-added", $7baed629d8d594eb$var$createExperienceConfig("reactions-list", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$6d84aa1577071ff0 = new (0, $cNAch.UFOExperience)("reaction-dialog-opened", $7baed629d8d594eb$var$createExperienceConfig("reaction-dialog", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$ef9cf69898a6ff56 = new (0, $cNAch.UFOExperience)("reaction-dialog-selected-reaction-changed", $7baed629d8d594eb$var$createExperienceConfig("reaction-dialog", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$517f7e3ffbcd0621 = new (0, $fh15z.ConcurrentExperience)("reaction-details-fetched", $7baed629d8d594eb$var$createExperienceConfig("reaction-item", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$4f07dc8d2bdd140d = new (0, $fh15z.ConcurrentExperience)("reaction-removed", $7baed629d8d594eb$var$createExperienceConfig("reactions-list", (0, $4MiWC.ExperienceTypes).Experience, (0, $4MiWC.ExperiencePerformanceTypes).InlineResult));
const $7baed629d8d594eb$export$45a4d1bf25d8455d = (instanceId)=>(0, $5O0tO.withSampling)($7baed629d8d594eb$export$5990348071f4d2f.getInstance(instanceId));
module.exports["ExperienceName"] = $7baed629d8d594eb$export$b881bd9f00ed8ed1;
module.exports["ComponentName"] = $7baed629d8d594eb$export$57d347d1902b5fe6;
module.exports["PickerRender"] = $7baed629d8d594eb$export$6a3784263f4fa16e;
module.exports["ReactionsRendered"] = $7baed629d8d594eb$export$5990348071f4d2f;
module.exports["ReactionsAdd"] = $7baed629d8d594eb$export$2fe905192bb057;
module.exports["ReactionDialogOpened"] = $7baed629d8d594eb$export$6d84aa1577071ff0;
module.exports["ReactionDialogSelectedReactionChanged"] = $7baed629d8d594eb$export$ef9cf69898a6ff56;
module.exports["ReactionDetailsFetch"] = $7baed629d8d594eb$export$517f7e3ffbcd0621;
module.exports["ReactionsRemove"] = $7baed629d8d594eb$export$4f07dc8d2bdd140d;
module.exports["sampledReactionsRendered"] = $7baed629d8d594eb$export$45a4d1bf25d8455d;

});

parcelRegister("j2uPw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $9DHhW = parcelRequire("9DHhW");


var $6OpMl = parcelRequire("6OpMl");


var $3aKBk = parcelRequire("3aKBk");


var $9UzxD = parcelRequire("9UzxD");


var $e1UZX = parcelRequire("e1UZX");


var $2RxDT = parcelRequire("2RxDT");


var $jFWFL = parcelRequire("jFWFL");


var $3TY4f = parcelRequire("3TY4f");


var $lbdYm = parcelRequire("lbdYm");


var $3dtSX = parcelRequire("3dtSX");


var $2NjvG = parcelRequire("2NjvG");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

const $7ab9ebaf6ac7f8d6$var$styles = {
    container: "_1mT5xdRAKS",
    listItem: "_2YLqiKPgdg _3SamIHPgdg _2Y7lL4Pgdg _4c065UPgdg"
};
const $7ab9ebaf6ac7f8d6$var$emojiStyle = null;
const $7ab9ebaf6ac7f8d6$var$emojiNoReactionStyle = null; /**
                                    * Test id for Reaction item wrapper div
                                    */ 
const $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111 = 'render_reaction_wrapper';
const $7ab9ebaf6ac7f8d6$export$d2ae4167a30cf6bb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { emojiProvider: emojiProvider, onClick: onClick, reaction: reaction, onMouseEnter: t1, onFocused: t2, flash: t3, showParticleEffect: t4, showOpaqueBackground: t5, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: t6, showSubtleStyle: showSubtleStyle, optimisticImageURL: optimisticImageURL, rootElement: rootElement } = t0;
    const onMouseEnter = t1 === undefined ? $7ab9ebaf6ac7f8d6$var$_temp : t1;
    const onFocused = t2 === undefined ? $7ab9ebaf6ac7f8d6$var$_temp2 : t2;
    const flash = t3 === undefined ? false : t3;
    const showParticleEffect = t4 === undefined ? false : t4;
    const showOpaqueBackground = t5 === undefined ? false : t5;
    const isViewOnly = t6 === undefined ? false : t6;
    const intl = (0, $kSwu1.useIntl)();
    const hoverStart = (0, $cozmU.useRef)();
    const focusStart = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [emojiName, setEmojiName] = (0, $cozmU.useState)();
    const [isTooltipEnabled, setIsTooltipEnabled] = (0, $cozmU.useState)(true);
    const { reacted: reacted } = reaction;
    let t7;
    if ($[0] !== reaction.emojiId) {
        t7 = {
            id: reaction.emojiId,
            shortName: ""
        };
        $[0] = reaction.emojiId;
        $[1] = t7;
    } else t7 = $[1];
    const emojiId = t7;
    let t8;
    let t9;
    if ($[2] !== emojiProvider || $[3] !== reaction.emojiId) {
        t8 = ()=>{
            (async ()=>{
                const emojiResource = await Promise.resolve(emojiProvider);
                const foundEmoji = await emojiResource.findById(reaction.emojiId);
                if (foundEmoji) setEmojiName(foundEmoji.name);
            })();
        };
        t9 = [
            emojiProvider,
            reaction.emojiId
        ];
        $[2] = emojiProvider;
        $[3] = reaction.emojiId;
        $[4] = t8;
        $[5] = t9;
    } else {
        t8 = $[4];
        t9 = $[5];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[6] !== createAnalyticsEvent || $[7] !== onClick || $[8] !== reaction) {
        t10 = (event)=>{
            event.preventDefault();
            if ((0, $3TY4f.isLeftClick)(event)) {
                const { reacted: reacted_0, emojiId: emojiId_0 } = reaction;
                (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionClickedEvent), !reacted_0, emojiId_0);
                onClick(reaction.emojiId, event);
            }
        };
        $[6] = createAnalyticsEvent;
        $[7] = onClick;
        $[8] = reaction;
        $[9] = t10;
    } else t10 = $[9];
    const handleClick = t10;
    let t11;
    if ($[10] !== createAnalyticsEvent || $[11] !== onMouseEnter || $[12] !== reaction.emojiId || $[13] !== reaction.users) {
        t11 = (event_0)=>{
            event_0.preventDefault();
            setIsTooltipEnabled(true);
            if (!reaction.users || !reaction.users.length) focusStart.current = Date.now();
            (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionHoveredEvent), focusStart.current);
            onMouseEnter(reaction.emojiId, event_0);
        };
        $[10] = createAnalyticsEvent;
        $[11] = onMouseEnter;
        $[12] = reaction.emojiId;
        $[13] = reaction.users;
        $[14] = t11;
    } else t11 = $[14];
    const handleMouseEnter = t11;
    let t12;
    if ($[15] !== createAnalyticsEvent || $[16] !== onFocused || $[17] !== reaction.emojiId || $[18] !== reaction.users) {
        t12 = (event_1)=>{
            event_1.preventDefault();
            setIsTooltipEnabled(true);
            if (!reaction.users || !reaction.users.length) hoverStart.current = Date.now();
            (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionFocusedEvent), hoverStart.current);
            onFocused(reaction.emojiId, event_1);
        };
        $[15] = createAnalyticsEvent;
        $[16] = onFocused;
        $[17] = reaction.emojiId;
        $[18] = reaction.users;
        $[19] = t12;
    } else t12 = $[19];
    const handleFocused = t12;
    let t13;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>{
            setIsTooltipEnabled(false);
        };
        $[20] = t13;
    } else t13 = $[20];
    const dismissTooltip = t13;
    const t14 = reaction.count === 0 && "_4c065U1Y8M _0LQT5EuFDC _03SyCPFQfX";
    let t15;
    if ($[21] !== t14) {
        t15 = (0, $hekY6.default)([
            "_4c065U1Y8M _0yKXXaDGiX _26BoRwxpxF _0LQT5E2ADO _03SyCP1Y8M",
            t14
        ]);
        $[21] = t14;
        $[22] = t15;
    } else t15 = $[22];
    let t16;
    if ($[23] !== emojiId || $[24] !== emojiProvider || $[25] !== optimisticImageURL) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            optimisticImageURL: optimisticImageURL
        });
        $[23] = emojiId;
        $[24] = emojiProvider;
        $[25] = optimisticImageURL;
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] !== t15 || $[28] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t15
        }, t16);
        $[27] = t15;
        $[28] = t16;
        $[29] = t17;
    } else t17 = $[29];
    const t18 = !isViewOnly && reaction.reacted;
    let t19;
    if ($[30] !== reaction.count || $[31] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
            value: reaction.count,
            highlight: t18
        });
        $[30] = reaction.count;
        $[31] = t18;
        $[32] = t19;
    } else t19 = $[32];
    let t20;
    if ($[33] !== t17 || $[34] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, t17, t19);
        $[33] = t17;
        $[34] = t19;
        $[35] = t20;
    } else t20 = $[35];
    const emojiAndCount = t20;
    let t21;
    if ($[36] !== emojiName || $[37] !== intl) {
        t21 = intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
            emoji: emojiName
        });
        $[36] = emojiName;
        $[37] = intl;
        $[38] = t21;
    } else t21 = $[38];
    let reactionAriaLabel = t21;
    if (reaction.count) {
        let t22;
        if ($[39] !== emojiName || $[40] !== intl || $[41] !== reaction.count) {
            t22 = intl.formatMessage((0, $jFWFL.messages).reactWithEmojiAndCount, {
                emoji: emojiName,
                count: reaction.count
            });
            $[39] = emojiName;
            $[40] = intl;
            $[41] = reaction.count;
            $[42] = t22;
        } else t22 = $[42];
        reactionAriaLabel = t22;
    }
    const t22 = rootElement === "li" ? $7ab9ebaf6ac7f8d6$var$styles.listItem : undefined;
    let t23;
    if ($[43] !== t22) {
        t23 = (0, $w6R6I.cx)($7ab9ebaf6ac7f8d6$var$styles.container, t22);
        $[43] = t22;
        $[44] = t23;
    } else t23 = $[44];
    let t24;
    if ($[45] !== emojiId || $[46] !== emojiProvider || $[47] !== optimisticImageURL || $[48] !== showParticleEffect) {
        t24 = showParticleEffect && /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
            emojiId: emojiId,
            emojiProvider: emojiProvider,
            optimisticImageURL: optimisticImageURL
        });
        $[45] = emojiId;
        $[46] = emojiProvider;
        $[47] = optimisticImageURL;
        $[48] = showParticleEffect;
        $[49] = t24;
    } else t24 = $[49];
    let t25;
    if ($[50] !== emojiAndCount || $[51] !== flash || $[52] !== handleClick || $[53] !== handleFocused || $[54] !== handleMouseEnter || $[55] !== isViewOnly || $[56] !== reacted || $[57] !== reaction.emojiId || $[58] !== reactionAriaLabel || $[59] !== showOpaqueBackground || $[60] !== showSubtleStyle) {
        t25 = isViewOnly ? /*#__PURE__*/ $cozmU.createElement((0, $2NjvG.StaticReaction), {
            onMouseEnter: handleMouseEnter,
            onFocus: handleFocused,
            testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
            dataAttributes: {
                "data-emoji-id": reaction.emojiId
            }
        }, emojiAndCount) : /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
            onClick: handleClick,
            flash: flash,
            ariaLabel: reactionAriaLabel,
            ariaPressed: reacted,
            onMouseEnter: handleMouseEnter,
            onFocus: handleFocused,
            testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
            dataAttributes: {
                "data-emoji-id": reaction.emojiId,
                "data-emoji-button-id": reaction.emojiId
            },
            showOpaqueBackground: showOpaqueBackground,
            showSubtleStyle: showSubtleStyle,
            reacted: reacted
        }, emojiAndCount);
        $[50] = emojiAndCount;
        $[51] = flash;
        $[52] = handleClick;
        $[53] = handleFocused;
        $[54] = handleMouseEnter;
        $[55] = isViewOnly;
        $[56] = reacted;
        $[57] = reaction.emojiId;
        $[58] = reactionAriaLabel;
        $[59] = showOpaqueBackground;
        $[60] = showSubtleStyle;
        $[61] = t25;
    } else t25 = $[61];
    let t26;
    if ($[62] !== allowUserDialog || $[63] !== emojiName || $[64] !== handleOpenReactionsDialog || $[65] !== isTooltipEnabled || $[66] !== reaction || $[67] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $2RxDT.ReactionTooltip), {
            emojiName: emojiName,
            reaction: reaction,
            isEnabled: isTooltipEnabled,
            allowUserDialog: allowUserDialog,
            handleOpenReactionsDialog: handleOpenReactionsDialog,
            dismissTooltip: dismissTooltip
        }, t25);
        $[62] = allowUserDialog;
        $[63] = emojiName;
        $[64] = handleOpenReactionsDialog;
        $[65] = isTooltipEnabled;
        $[66] = reaction;
        $[67] = t25;
        $[68] = t26;
    } else t26 = $[68];
    let t27;
    if ($[69] !== rootElement || $[70] !== t23 || $[71] !== t24 || $[72] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t23,
            as: rootElement
        }, t24, t26);
        $[69] = rootElement;
        $[70] = t23;
        $[71] = t24;
        $[72] = t26;
        $[73] = t27;
    } else t27 = $[73];
    return t27;
} : ({ emojiProvider: emojiProvider, onClick: onClick, reaction: reaction, onMouseEnter: onMouseEnter = ()=>{}, onFocused: onFocused = ()=>{}, flash: flash = false, showParticleEffect: showParticleEffect = false, showOpaqueBackground: showOpaqueBackground = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, showSubtleStyle: showSubtleStyle, optimisticImageURL: optimisticImageURL, rootElement: rootElement })=>{
    const intl = (0, $kSwu1.useIntl)();
    const hoverStart = (0, $cozmU.useRef)();
    const focusStart = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [emojiName, setEmojiName] = (0, $cozmU.useState)();
    const [isTooltipEnabled, setIsTooltipEnabled] = (0, $cozmU.useState)(true);
    const { reacted: reacted } = reaction;
    const emojiId = {
        id: reaction.emojiId,
        shortName: ''
    }; // TODO: Extract the flow to a custom hook to retrieve emoji detailed description from an id using a custom hook. This will benefit a better optimization instead of the emojiProvider resolving everytime.
    // Also optimize in future version to fetch in batch several emojiIds
    (0, $cozmU.useEffect)(()=>{
        (async ()=>{
            const emojiResource = await Promise.resolve(emojiProvider);
            const foundEmoji = await emojiResource.findById(reaction.emojiId);
            if (foundEmoji) setEmojiName(foundEmoji.name);
        })();
    }, [
        emojiProvider,
        reaction.emojiId
    ]);
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        if ((0, $3TY4f.isLeftClick)(event)) {
            const { reacted: reacted_0, emojiId: emojiId_0 } = reaction;
            (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionClickedEvent), !reacted_0, emojiId_0);
            onClick(reaction.emojiId, event);
        }
    }, [
        createAnalyticsEvent,
        reaction,
        onClick
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)((event_0)=>{
        event_0.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) focusStart.current = Date.now();
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionHoveredEvent), focusStart.current);
        onMouseEnter(reaction.emojiId, event_0);
    }, [
        createAnalyticsEvent,
        reaction,
        onMouseEnter
    ]);
    const handleFocused = (0, $cozmU.useCallback)((event_1)=>{
        event_1.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) hoverStart.current = Date.now();
        (0, $3aKBk.createAndFireSafe)(createAnalyticsEvent, (0, $3aKBk.createReactionFocusedEvent), hoverStart.current);
        onFocused(reaction.emojiId, event_1);
    }, [
        createAnalyticsEvent,
        reaction,
        onFocused
    ]);
    const dismissTooltip = ()=>{
        setIsTooltipEnabled(false);
    };
    const emojiAndCount = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4c065U1Y8M _0yKXXaDGiX _26BoRwxpxF _0LQT5E2ADO _03SyCP1Y8M",
            reaction.count === 0 && "_4c065U1Y8M _0LQT5EuFDC _03SyCPFQfX"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
        optimisticImageURL: optimisticImageURL
    })), /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
        value: reaction.count,
        highlight: !isViewOnly && reaction.reacted
    }));
    let reactionAriaLabel = intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
        emoji: emojiName
    });
    if (reaction.count) reactionAriaLabel = intl.formatMessage((0, $jFWFL.messages).reactWithEmojiAndCount, {
        emoji: emojiName,
        count: reaction.count
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($7ab9ebaf6ac7f8d6$var$styles.container, rootElement === 'li' ? $7ab9ebaf6ac7f8d6$var$styles.listItem : undefined),
        as: rootElement
    }, showParticleEffect && /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
        emojiId: emojiId,
        emojiProvider: emojiProvider,
        optimisticImageURL: optimisticImageURL
    }), /*#__PURE__*/ $cozmU.createElement((0, $2RxDT.ReactionTooltip), {
        emojiName: emojiName,
        reaction: reaction,
        isEnabled: isTooltipEnabled,
        allowUserDialog: allowUserDialog,
        handleOpenReactionsDialog: handleOpenReactionsDialog,
        dismissTooltip: dismissTooltip
    }, isViewOnly ? /*#__PURE__*/ $cozmU.createElement((0, $2NjvG.StaticReaction), {
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocused,
        testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
        dataAttributes: {
            'data-emoji-id': reaction.emojiId
        }
    }, emojiAndCount) : /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
        onClick: handleClick,
        flash: flash,
        ariaLabel: reactionAriaLabel,
        ariaPressed: reacted,
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocused,
        testId: $7ab9ebaf6ac7f8d6$export$b64f94cf5ea5f111,
        dataAttributes: {
            'data-emoji-id': reaction.emojiId,
            'data-emoji-button-id': reaction.emojiId
        },
        showOpaqueBackground: showOpaqueBackground,
        showSubtleStyle: showSubtleStyle,
        reacted: reacted
    }, emojiAndCount)));
};
function $7ab9ebaf6ac7f8d6$var$_temp() {}
function $7ab9ebaf6ac7f8d6$var$_temp2() {}
module.exports["Reaction"] = $7ab9ebaf6ac7f8d6$export$d2ae4167a30cf6bb;

});

parcelRegister("9UzxD", function(module, exports) {
/* Counter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");

var $j72ee = parcelRequire("j72ee");


var $3TY4f = parcelRequire("3TY4f");

const $5764d4bf4940709b$var$containerStyle = null;
const $5764d4bf4940709b$var$counterLabelStyle = null;
const $5764d4bf4940709b$var$countStyle = null;
const $5764d4bf4940709b$var$highlightStyle = null;
const $5764d4bf4940709b$var$darkerFontStyle = null;
const $5764d4bf4940709b$var$updatedStyles = null; /**
                             * Test id for component top level div
                             */ 
const $5764d4bf4940709b$export$abd04e330cfe02b = 'counter-wrapper'; /**
                                                            * Test id for wrapper div of the counter inside the slider
                                                            */ 
const $5764d4bf4940709b$export$5d72ec7afc5923f4 = 'counter-container'; /**
                                                           * Counter label value wrapper div
                                                           */ 
const $5764d4bf4940709b$export$3b4c1ed5ad4af669 = 'counter_label_wrapper';
const $5764d4bf4940709b$export$1b74141c5fe63a28 = ({ highlight: highlight = false, limit: limit, overLimitLabel: overLimitLabel, className: className, value: value, animationDuration: animationDuration = 'medium', useDarkerFont: useDarkerFont, useUpdatedStyles: useUpdatedStyles })=>{
    const getLabel = (value_0)=>{
        // Check if reached limit
        if (limit && overLimitLabel && value_0 >= limit) return overLimitLabel || '';
        else if (value_0 === 0) return '';
        else return (0, $3TY4f.formatLargeNumber)(value_0);
    };
    const lastValue = (0, $cozmU.useRef)();
    const label = getLabel(value);
    (0, $cozmU.useEffect)(()=>{
        lastValue.current = value;
    }, [
        value
    ]);
    const isIncreasing = (0, $cozmU.useMemo)(()=>{
        return lastValue.current ? lastValue.current < value : false;
    }, [
        value
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _1mT5xdRAKS _0Of8r21Y8M _1Znuxb2ADO _1wydGW1Y8M _2Zuz6QdnbC _26BoRwEbN9",
            useDarkerFont && "_1UtDYzZpcK",
            useUpdatedStyles && "_313842FQfX",
            className
        ]),
        "data-testid": $5764d4bf4940709b$export$abd04e330cfe02b
    }, /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
        enterFrom: isIncreasing ? 'top' : 'bottom',
        exitTo: isIncreasing ? 'top' : 'bottom',
        key: value,
        duration: animationDuration
    }, (motion, direction)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            ref: motion.ref,
            style: {
                position: direction === 'exiting' ? 'absolute' : undefined
            },
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5vbt8w",
                motion.className
            ]),
            "data-testid": $5764d4bf4940709b$export$5d72ec7afc5923f4
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": $5764d4bf4940709b$export$3b4c1ed5ad4af669,
            key: value,
            className: (0, $hekY6.default)([
                "_4zgPmfbiPq",
                highlight && "_1UtDYzjTy9"
            ])
        }, label));
    })));
};
module.exports["Counter"] = $5764d4bf4940709b$export$1b74141c5fe63a28;

});

parcelRegister("3TY4f", function(module, exports) {

var $lbdYm = parcelRequire("lbdYm");

const $0028d9ae1df7c3fc$export$698c4f0ff5e11e52 = (event)=>event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
const $0028d9ae1df7c3fc$export$486a422686c27c1 = (item)=>(0, $lbdYm.DefaultReactions).some((otherEmojiId)=>$0028d9ae1df7c3fc$var$isEqualEmojiId(otherEmojiId, item));
/**
 * compare 2 emoji items if they are same input
 * @param a first emoji item
 * @param b second emoji item
 */ const $0028d9ae1df7c3fc$var$isEqualEmojiId = (a, b)=>{
    if ($0028d9ae1df7c3fc$var$isEmojiId(a) && $0028d9ae1df7c3fc$var$isEmojiId(b)) return a === b || a && b && a.id === b.id && a.shortName === b.shortName;
    else return a === b;
};
/**
 * Type guard if provided object is a string id or an object info collection for the emoji
 * @param item given item
 */ const $0028d9ae1df7c3fc$var$isEmojiId = (item)=>{
    return item.id !== undefined;
};
const $0028d9ae1df7c3fc$export$cabcad7683a98538 = (value, decimalPlaces)=>{
    const decimalIndex = value.indexOf('.');
    if (decimalIndex === -1) // Integers with trailing 0s will have no decimal (Ex. 18000, 7700000, 500)
    return value.substring(0, value.length);
    if (decimalPlaces === 0) // Return an integer value
    return value.substring(0, decimalIndex);
    return value.substring(0, decimalIndex + decimalPlaces + 1);
};
const $0028d9ae1df7c3fc$export$2369f32a5da9d5b8 = (value)=>{
    // 999M+
    const maxLimit = 999999999;
    const thounsandSeparator = 1000;
    const millionSeparator = 1000000;
    const valueInK = value / thounsandSeparator;
    const valueInM = value / millionSeparator;
    if (value > maxLimit) return '999.9M+';
    if (value >= 1000000) {
        // determine the decimal breakpoints by length and check its value
        // 1234567 -> 1.234567 and decimal value is 2
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInM.toString().charAt(numDigits - 5);
        return decimalIndexValue === '0' ? $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInM.toString(), 0) + 'M' : $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInM.toString(), 1) + 'M';
    }
    if (value >= 1000) {
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInK.toString().charAt(numDigits - 2);
        return decimalIndexValue === '0' ? $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInK.toString(), 0) + 'K' : $0028d9ae1df7c3fc$export$cabcad7683a98538(valueInK.toString(), 1) + 'K';
    }
    // <999
    return value.toString();
};
module.exports["isLeftClick"] = $0028d9ae1df7c3fc$export$698c4f0ff5e11e52;
module.exports["formatLargeNumber"] = $0028d9ae1df7c3fc$export$2369f32a5da9d5b8;

});

parcelRegister("e1UZX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6OpMl = parcelRequire("6OpMl");


var $lbdYm = parcelRequire("lbdYm");

const $fe588e33953a56d3$var$containerStyle = null;
const $fe588e33953a56d3$var$reactionParticleStyle = null;
const $fe588e33953a56d3$export$ffc0241869fe445 = 4;
const $fe588e33953a56d3$export$2538eeb2e8d3da5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { emojiProvider: emojiProvider, emojiId: emojiId, optimisticImageURL: optimisticImageURL } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdRAKS _3OE6xYJg58 _42Yu6BpoSI _1sHUMgdnbC"
        ]);
        t2 = [
            ...Array($fe588e33953a56d3$export$ffc0241869fe445)
        ];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== emojiId || $[3] !== emojiProvider || $[4] !== optimisticImageURL) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": true,
            className: t1
        }, t2.map((_, index)=>/*#__PURE__*/ $cozmU.createElement("div", {
                key: index,
                className: (0, $hekY6.default)([
                    "_2fBhte3wI7 _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _1pp6NdYbGa _1YKVNsdnbC _0nFVCG0G4o _47ndRJ8e2l _2cS58fb8VS _0B2GSPJg58 _3Mqk2F0jWM _02fzjrA17z _0weNkOhSmB"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
                emojiProvider: emojiProvider,
                emojiId: emojiId,
                fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
                optimisticImageURL: optimisticImageURL
            }))));
        $[2] = emojiId;
        $[3] = emojiProvider;
        $[4] = optimisticImageURL;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ emojiProvider: emojiProvider, emojiId: emojiId, optimisticImageURL: optimisticImageURL })=>/*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3OE6xYJg58 _42Yu6BpoSI _1sHUMgdnbC"
        ])
    }, [
        ...Array($fe588e33953a56d3$export$ffc0241869fe445)
    ].map((_, index)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            key: index,
            className: (0, $hekY6.default)([
                "_2fBhte3wI7 _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _1pp6NdYbGa _1YKVNsdnbC _0nFVCG0G4o _47ndRJ8e2l _2cS58fb8VS _0B2GSPJg58 _3Mqk2F0jWM _02fzjrA17z _0weNkOhSmB"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            optimisticImageURL: optimisticImageURL
        }));
    }));
module.exports["ReactionParticleEffect"] = $fe588e33953a56d3$export$2538eeb2e8d3da5e;

});

parcelRegister("2RxDT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $lbdYm = parcelRequire("lbdYm");


var $jFWFL = parcelRequire("jFWFL");

const $6ca35ee292e5704e$export$507197e0ca3872c2 = 5;
const $6ca35ee292e5704e$var$tooltipStyle = null;
const $6ca35ee292e5704e$var$emojiNameStyle = null;
const $6ca35ee292e5704e$var$footerStyle = null;
const $6ca35ee292e5704e$var$underlineStyle = null; // Resets native <button> chrome so it renders as inline text within the tooltip list.
const $6ca35ee292e5704e$var$footerButtonStyle = null;
const $6ca35ee292e5704e$var$footerButtonColorStyle = null; /**
                                      * Test id for wrapper ReactionTooltip div
                                      */ 
const $6ca35ee292e5704e$export$4850cb7690e62d5f = 'render-reactionTooltip';
const $6ca35ee292e5704e$export$22b33b34188069b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, emojiName: emojiName, reaction: t1, maxReactions: t2, isEnabled: t3, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, dismissTooltip: dismissTooltip } = t0;
    const { users: t4 } = t1;
    let t5;
    if ($[0] !== allowUserDialog || $[1] !== dismissTooltip || $[2] !== emojiName || $[3] !== handleOpenReactionsDialog || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        const users = t4 === undefined ? [] : t4;
        const maxReactions = t2 === undefined ? (0, $lbdYm.TOOLTIP_USERS_LIMIT) : t2;
        const isEnabled = t3 === undefined ? true : t3;
        let t6;
        if ($[8] !== allowUserDialog || $[9] !== dismissTooltip || $[10] !== handleOpenReactionsDialog) {
            t6 = ()=>{
                if (allowUserDialog && handleOpenReactionsDialog) {
                    dismissTooltip();
                    handleOpenReactionsDialog();
                }
            };
            $[8] = allowUserDialog;
            $[9] = dismissTooltip;
            $[10] = handleOpenReactionsDialog;
            $[11] = t6;
        } else t6 = $[11];
        const handleClick = t6;
        t5 = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            tabIndex: (0, $iDrrr.fg)("platform_suppression_removal_fix_reactions") ? undefined : 0,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlb1xp _39HuIbz8Lp _1ANEUSLRg7 _1DCdHiyrFs _0RnPfxYbGa _2nCqgUdnbC _3KMNLzdnbC _4FGVR6dnbC _2Rs5q5dnbC _3yURFsdnbC _0eU7W7dnbC _1rj44LdnbC _1kKzb0dnbC _4Ga63UecOK _44MxIUnQyn _1YODaRnQyn _0nsAOgz8Lp _3krqYeyrFs"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, emojiName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: (0, $hekY6.default)([
                "_41LZZBMRGa _1UtDYze5R3 _1kk5Tk7GSX"
            ])
        }, emojiName) : null, users.slice(0, maxReactions).map($6ca35ee292e5704e$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: (0, $hekY6.default)([
                "_1UtDYze5R3"
            ])
        }, users.length > maxReactions && (allowUserDialog && handleOpenReactionsDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            type: "button",
            onClick: handleClick,
            onMouseDown: $6ca35ee292e5704e$var$_temp2,
            className: (0, $hekY6.default)([
                "_30huDKYbGa _2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _3iDTPbvLZJ _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _39xV02N91d _2fwxA5ecOK _39HuIbz8Lp",
                "_1UtDYze5R3",
                "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _0wOv4Q7zJH _1eOmH6gozt _0clgaMe5R3"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $jFWFL.messages).otherUsers,
            values: {
                count: users.length - maxReactions
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $jFWFL.messages).otherUsers,
            values: {
                count: users.length - maxReactions
            }
        })))));
        $[0] = allowUserDialog;
        $[1] = dismissTooltip;
        $[2] = emojiName;
        $[3] = handleOpenReactionsDialog;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const content = t5;
    let t6;
    if ($[12] !== children) {
        t6 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children);
        $[12] = children;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== content || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: content,
            position: "bottom",
            testId: $6ca35ee292e5704e$export$4850cb7690e62d5f
        }, t6);
        $[14] = content;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ children: children, emojiName: emojiName, reaction: { users: users = [] }, maxReactions: maxReactions = (0, $lbdYm.TOOLTIP_USERS_LIMIT), isEnabled: isEnabled = true, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, dismissTooltip: dismissTooltip })=>{
    const handleClick = ()=>{
        if (allowUserDialog && handleOpenReactionsDialog) {
            dismissTooltip();
            handleOpenReactionsDialog();
        }
    };
    const content = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        tabIndex: (0, $iDrrr.fg)('platform_suppression_removal_fix_reactions') ? undefined : 0,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlb1xp _39HuIbz8Lp _1ANEUSLRg7 _1DCdHiyrFs _0RnPfxYbGa _2nCqgUdnbC _3KMNLzdnbC _4FGVR6dnbC _2Rs5q5dnbC _3yURFsdnbC _0eU7W7dnbC _1rj44LdnbC _1kKzb0dnbC _4Ga63UecOK _44MxIUnQyn _1YODaRnQyn _0nsAOgz8Lp _3krqYeyrFs"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, emojiName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_41LZZBMRGa _1UtDYze5R3 _1kk5Tk7GSX"
        ])
    }, emojiName) : null, users.slice(0, maxReactions).map((user)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: user.id
        }, user.displayName);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_1UtDYze5R3"
        ])
    }, users.length > maxReactions && (allowUserDialog && handleOpenReactionsDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        onClick: handleClick,
        onMouseDown: (e)=>e.preventDefault(),
        className: (0, $hekY6.default)([
            "_30huDKYbGa _2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _3iDTPbvLZJ _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _39xV02N91d _2fwxA5ecOK _39HuIbz8Lp",
            "_1UtDYze5R3",
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _0wOv4Q7zJH _1eOmH6gozt _0clgaMe5R3"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $jFWFL.messages).otherUsers,
        values: {
            count: users.length - maxReactions
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $jFWFL.messages).otherUsers,
        values: {
            count: users.length - maxReactions
        }
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: content,
        position: "bottom",
        testId: $6ca35ee292e5704e$export$4850cb7690e62d5f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children));
};
function $6ca35ee292e5704e$var$_temp(user) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        key: user.id
    }, user.displayName);
}
function $6ca35ee292e5704e$var$_temp2(e) {
    return e.preventDefault();
}
module.exports["ReactionTooltip"] = $6ca35ee292e5704e$export$22b33b34188069b6;

});

parcelRegister("3dtSX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $h52mZ = parcelRequire("h52mZ");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $hBYtq = parcelRequire("hBYtq");

const $7a657a940372e424$var$styles = {
    reactionButton: "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _4ouGXInlTt _0jFU0VoWWg _0KLXru66of _1UtDYzZpcK _43nrzT1Y8M _2xTnZx1Y8M _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _1eOmH6o126 _3gzVzLN4oS",
    reactionStylesRefresh: "_0bjKvDKxmn",
    reacted: "_3vBAKHrzt2 _0KLXruY9q9 _1eOmH6sumd _3gzVzLXsxn",
    opaqueBackground: "_0KLXrulfZc _1eOmH6d1Zr _3gzVzLJNoT",
    compactButton: "_0jFU0VSPN1 _0hPCNLDIqT _313842gVvo",
    borderless: "_3hxITiYbGa"
};
/**
 * Default styling px height for an emoji reaction
 */ const $7a657a940372e424$var$akHeight = 24;
const $7a657a940372e424$var$flashHeight = $7a657a940372e424$var$akHeight - 2; // height without the 1px border
const $7a657a940372e424$var$flashStyle = null;
const $7a657a940372e424$var$flashStyleOld = null;
const $7a657a940372e424$export$6ce3894c36b53067 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { onClick: onClick, flash: t1, showSubtleStyle: showSubtleStyle, showOpaqueBackground: showOpaqueBackground, useCompactStyles: useCompactStyles, reacted: reacted, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaPressed: ariaPressed, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, children: children, dataAttributes: t2, testId: testId } = t0;
    const flash = t1 === undefined ? false : t1;
    let t3;
    if ($[0] !== t2) {
        t3 = t2 === undefined ? {} : t2;
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const dataAttributes = t3;
    const t4 = (0, $ieeJu.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true) ? ariaExpanded : undefined;
    const t5 = useCompactStyles && $7a657a940372e424$var$styles.compactButton;
    const t6 = reacted && $7a657a940372e424$var$styles.reacted;
    const t7 = !reacted && showSubtleStyle && $7a657a940372e424$var$styles.borderless;
    const t8 = !reacted && showOpaqueBackground && $7a657a940372e424$var$styles.opaqueBackground;
    let t9;
    if ($[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8) {
        t9 = (0, $k12R1.cx)($7a657a940372e424$var$styles.reactionButton, t5, t6, t7, t8, (0, $iDrrr.fg)("platform-component-visual-refresh") && $7a657a940372e424$var$styles.reactionStylesRefresh);
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            (0, $iDrrr.fg)("platform-component-visual-refresh") ? "_0bjKvDcjp5 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL" : "_0bjKvDuFDC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL"
        ]);
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== children || $[9] !== flash) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $h52mZ.FlashAnimation), {
            flash: flash,
            className: t10
        }, children);
        $[8] = children;
        $[9] = flash;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== ariaLabel || $[12] !== ariaPressed || $[13] !== dataAttributes || $[14] !== onClick || $[15] !== onFocus || $[16] !== onMouseEnter || $[17] !== onMouseLeave || $[18] !== t11 || $[19] !== t4 || $[20] !== t9 || $[21] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            "aria-label": ariaLabel,
            "aria-pressed": ariaPressed,
            "aria-expanded": t4,
            testId: testId,
            xcss: t9,
            ...dataAttributes
        }, t11);
        $[11] = ariaLabel;
        $[12] = ariaPressed;
        $[13] = dataAttributes;
        $[14] = onClick;
        $[15] = onFocus;
        $[16] = onMouseEnter;
        $[17] = onMouseLeave;
        $[18] = t11;
        $[19] = t4;
        $[20] = t9;
        $[21] = testId;
        $[22] = t12;
    } else t12 = $[22];
    return t12;
} : ({ onClick: onClick, flash: flash = false, showSubtleStyle: showSubtleStyle, showOpaqueBackground: showOpaqueBackground, useCompactStyles: useCompactStyles, reacted: reacted, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaPressed: ariaPressed, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, children: children, dataAttributes: dataAttributes = {}, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-expanded": (0, $ieeJu.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? ariaExpanded : undefined,
        testId: testId,
        xcss: (0, $k12R1.cx)($7a657a940372e424$var$styles.reactionButton, useCompactStyles && $7a657a940372e424$var$styles.compactButton, reacted && $7a657a940372e424$var$styles.reacted, !reacted && showSubtleStyle && $7a657a940372e424$var$styles.borderless, !reacted && showOpaqueBackground && $7a657a940372e424$var$styles.opaqueBackground, (0, $iDrrr.fg)('platform-component-visual-refresh') && $7a657a940372e424$var$styles.reactionStylesRefresh),
        ...dataAttributes
    }, /*#__PURE__*/ $cozmU.createElement((0, $h52mZ.FlashAnimation), {
        flash: flash,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('platform-component-visual-refresh') ? "_0bjKvDcjp5 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL" : "_0bjKvDuFDC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE2XL"
        ])
    }, children));
};
module.exports["ReactionButton"] = $7a657a940372e424$export$6ce3894c36b53067;

});

parcelRegister("h52mZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $628c02958bf75670$var$flashTime = 700;
const $628c02958bf75670$var$flashAnimation = null;
const $628c02958bf75670$var$containerStyle = null;
const $628c02958bf75670$var$flashStyle = null;
const $628c02958bf75670$export$101a417749e701a3 = 'flash-animation'; /**
                                                                * Flash animation background component. See Reaction component for usage.
                                                                */ 
const $628c02958bf75670$export$2b501aee548bae06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const t0 = props.flash && "";
    const t1 = props.flash && "_1gBibygdz8 _0nFVCG0G4o _43vdfTN8t6";
    let t2;
    if ($[0] !== props.className || $[1] !== t0 || $[2] !== t1) {
        t2 = (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d",
            t0,
            t1,
            props.className
        ]);
        $[0] = props.className;
        $[1] = t0;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== props.children || $[5] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2,
            "data-testid": $628c02958bf75670$export$101a417749e701a3
        }, props.children);
        $[4] = props.children;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d",
            props.flash && "",
            props.flash && "_1gBibygdz8 _0nFVCG0G4o _43vdfTN8t6",
            props.className
        ]),
        "data-testid": $628c02958bf75670$export$101a417749e701a3
    }, props.children);
module.exports["FlashAnimation"] = $628c02958bf75670$export$2b501aee548bae06;

});

parcelRegister("2NjvG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hBYtq = parcelRequire("hBYtq");

const $68378bea7627df85$var$styles = {
    staticReaction: "_4bt5LAnQyn _2WAcuGnQyn _30huDKYbGa _0bjKvDKxmn _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _4ouGXInlTt _0jFU0VoWWg _0KLXru66of _1UtDYzZpcK _43nrzT1Y8M _2xTnZx1Y8M _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH18ZR _1eOmH6o126"
};
const $68378bea7627df85$export$1a66ed011c614568 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onMouseEnter: onMouseEnter, onFocus: onFocus, children: children, testId: testId, dataAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const dataAttributes = t2;
    let t3;
    if ($[2] !== children || $[3] !== dataAttributes || $[4] !== onFocus || $[5] !== onMouseEnter || $[6] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            onMouseEnter: onMouseEnter,
            onFocus: onFocus,
            testId: testId,
            xcss: $68378bea7627df85$var$styles.staticReaction,
            ...dataAttributes
        }, children);
        $[2] = children;
        $[3] = dataAttributes;
        $[4] = onFocus;
        $[5] = onMouseEnter;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onMouseEnter: onMouseEnter, onFocus: onFocus, children: children, testId: testId, dataAttributes: dataAttributes = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        testId: testId,
        xcss: $68378bea7627df85$var$styles.staticReaction,
        ...dataAttributes
    }, children);
};
module.exports["StaticReaction"] = $68378bea7627df85$export$1a66ed011c614568;

});

parcelRegister("9aIb5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hMjUh = parcelRequire("hMjUh");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");


var $iMnC5 = parcelRequire("iMnC5");


var $lbdYm = parcelRequire("lbdYm");


var $lgLLu = parcelRequire("lgLLu");


var $kvJXG = parcelRequire("kvJXG");

const $6c371858ccc38d3c$var$styles = {
    modalBodyStyle: "_1DCdHiNHnM"
}; /* Reactions Container. Using pseudo Element :after to set border since with onClick of Reaction to higlight the
   border blue below the reaction. */ 
const $6c371858ccc38d3c$var$containerStyle = null; /**
                              * Test id for the Reactions modal dialog
                              */ 
const $6c371858ccc38d3c$export$ef88759cddab4775 = 'render-reactions-modal';
const $6c371858ccc38d3c$export$df84a24235404de6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { reactions: t1, handleCloseReactionsDialog: t2, emojiProvider: emojiProvider, selectedEmojiId: selectedEmojiId, handleSelectReaction: t3, handlePaginationChange: t4, ProfileCardWrapper: ProfileCardWrapper } = t0;
    let t5;
    if ($[0] !== t1) {
        t5 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t5;
    } else t5 = $[1];
    const reactions = t5;
    const handleCloseReactionsDialog = t2 === undefined ? $6c371858ccc38d3c$var$_temp : t2;
    const handleSelectReaction = t3 === undefined ? $6c371858ccc38d3c$var$_temp2 : t3;
    const handlePaginationChange = t4 === undefined ? $6c371858ccc38d3c$var$_temp3 : t4;
    const [hasNavigatedPages, setHasNavigatedPages] = (0, $cozmU.useState)(false);
    const [currentPage, setCurrentPage] = (0, $cozmU.useState)(1);
    let t6;
    if ($[2] !== reactions) {
        t6 = reactions.reduce($6c371858ccc38d3c$var$_temp4, 0);
        $[2] = reactions;
        $[3] = t6;
    } else t6 = $[3];
    const totalReactionsCount = t6;
    const maxPages = Math.max(1, Math.ceil(reactions.length / (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY)));
    const start = (currentPage - 1) * (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
    const end = start + (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
    let t7;
    if ($[4] !== end || $[5] !== reactions || $[6] !== start) {
        t7 = reactions.slice(start, end);
        $[4] = end;
        $[5] = reactions;
        $[6] = start;
        $[7] = t7;
    } else t7 = $[7];
    const currentReactions = t7;
    let t8;
    if ($[8] !== maxPages) {
        t8 = ()=>{
            setCurrentPage((prevPage)=>Math.min(prevPage + 1, maxPages));
            setHasNavigatedPages(true);
        };
        $[8] = maxPages;
        $[9] = t8;
    } else t8 = $[9];
    const handleNextPage = t8;
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setCurrentPage($6c371858ccc38d3c$var$_temp5);
            setHasNavigatedPages(true);
        };
        $[10] = t9;
    } else t9 = $[10];
    const handlePreviousPage = t9;
    const firstEmojiOnPage = currentReactions[0]?.emojiId;
    let t10;
    let t11;
    if ($[11] !== currentPage || $[12] !== firstEmojiOnPage || $[13] !== handlePaginationChange || $[14] !== hasNavigatedPages || $[15] !== maxPages) {
        t10 = ()=>{
            if (hasNavigatedPages && firstEmojiOnPage) handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
        };
        t11 = [
            hasNavigatedPages,
            currentPage,
            maxPages,
            firstEmojiOnPage,
            handlePaginationChange
        ];
        $[11] = currentPage;
        $[12] = firstEmojiOnPage;
        $[13] = handlePaginationChange;
        $[14] = hasNavigatedPages;
        $[15] = maxPages;
        $[16] = t10;
        $[17] = t11;
    } else {
        t10 = $[16];
        t11 = $[17];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[18] !== currentReactions || $[19] !== selectedEmojiId) {
        let t13;
        if ($[21] !== selectedEmojiId) {
            t13 = (reaction)=>reaction.emojiId === selectedEmojiId;
            $[21] = selectedEmojiId;
            $[22] = t13;
        } else t13 = $[22];
        t12 = currentReactions.findIndex(t13);
        $[18] = currentReactions;
        $[19] = selectedEmojiId;
        $[20] = t12;
    } else t12 = $[20];
    const selectedIndex = t12;
    let t13;
    if ($[23] !== currentReactions || $[24] !== handleSelectReaction || $[25] !== selectedIndex) {
        t13 = (index)=>{
            if (index === selectedIndex) return;
            const emojiId = currentReactions[index].emojiId;
            handleSelectReaction(emojiId);
        };
        $[23] = currentReactions;
        $[24] = handleSelectReaction;
        $[25] = selectedIndex;
        $[26] = t13;
    } else t13 = $[26];
    const onTabChange = t13;
    let t14;
    if ($[27] !== currentPage || $[28] !== currentReactions || $[29] !== emojiProvider || $[30] !== handleCloseReactionsDialog || $[31] !== handleNextPage || $[32] !== maxPages || $[33] !== totalReactionsCount) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $kvJXG.ReactionsDialogHeader), {
            totalReactionsCount: totalReactionsCount,
            maxPages: maxPages,
            handlePreviousPage: handlePreviousPage,
            handleNextPage: handleNextPage,
            currentPage: currentPage,
            emojiProvider: emojiProvider,
            currentReactions: currentReactions,
            handleCloseReactionsDialog: handleCloseReactionsDialog
        });
        $[27] = currentPage;
        $[28] = currentReactions;
        $[29] = emojiProvider;
        $[30] = handleCloseReactionsDialog;
        $[31] = handleNextPage;
        $[32] = maxPages;
        $[33] = totalReactionsCount;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _3iDTPbQ4SZ _37wbyu7p2s _1mT5xdRAKS _3h2tDz3EvU _0GBAIrogpp _39mJBjdnbC _4Gb5FivLZJ _4DX2ezN91d _4zi1EpdnbC _2WYcYGWVPG"
        ]);
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== ProfileCardWrapper || $[37] !== currentReactions || $[38] !== selectedEmojiId) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6c371858ccc38d3c$var$styles.modalBodyStyle
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t15
        }, /*#__PURE__*/ $cozmU.createElement((0, $lgLLu.ReactionsList), {
            selectedEmojiId: selectedEmojiId,
            reactions: currentReactions,
            ProfileCardWrapper: ProfileCardWrapper
        }))));
        $[36] = ProfileCardWrapper;
        $[37] = currentReactions;
        $[38] = selectedEmojiId;
        $[39] = t16;
    } else t16 = $[39];
    let t17;
    if ($[40] !== onTabChange || $[41] !== selectedIndex || $[42] !== t14 || $[43] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
            id: "reactions-dialog-tabs",
            onChange: onTabChange,
            selected: selectedIndex
        }, t14, t16);
        $[40] = onTabChange;
        $[41] = selectedIndex;
        $[42] = t14;
        $[43] = t16;
        $[44] = t17;
    } else t17 = $[44];
    let t18;
    if ($[45] !== handleCloseReactionsDialog || $[46] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: handleCloseReactionsDialog,
            height: 600,
            testId: $6c371858ccc38d3c$export$ef88759cddab4775
        }, t17);
        $[45] = handleCloseReactionsDialog;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    return t18;
} : ({ reactions: reactions = [], handleCloseReactionsDialog: handleCloseReactionsDialog = ()=>{}, emojiProvider: emojiProvider, selectedEmojiId: selectedEmojiId, handleSelectReaction: handleSelectReaction = ()=>{}, handlePaginationChange: handlePaginationChange = ()=>{}, ProfileCardWrapper: ProfileCardWrapper })=>{
    const [hasNavigatedPages, setHasNavigatedPages] = (0, $cozmU.useState)(false);
    const [currentPage, setCurrentPage] = (0, $cozmU.useState)(1);
    const totalReactionsCount = (0, $cozmU.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count;
        }, 0);
    }, [
        reactions
    ]);
    const maxPages = Math.max(1, Math.ceil(reactions.length / (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY)));
    const currentReactions = (0, $cozmU.useMemo)(()=>{
        const start = (currentPage - 1) * (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
        const end = start + (0, $lbdYm.NUMBER_OF_REACTIONS_TO_DISPLAY);
        return reactions.slice(start, end);
    }, [
        reactions,
        currentPage
    ]);
    const handleNextPage = ()=>{
        setCurrentPage((prevPage)=>Math.min(prevPage + 1, maxPages));
        setHasNavigatedPages(true);
    };
    const handlePreviousPage = ()=>{
        setCurrentPage((prevPage_0)=>Math.max(prevPage_0 - 1, 1));
        setHasNavigatedPages(true);
    };
    const firstEmojiOnPage = currentReactions[0]?.emojiId;
    (0, $cozmU.useEffect)(()=>{
        // trigger the handler with the first emoji when the page changes
        if (hasNavigatedPages && firstEmojiOnPage) handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
    }, [
        hasNavigatedPages,
        currentPage,
        maxPages,
        firstEmojiOnPage,
        handlePaginationChange
    ]);
    const selectedIndex = currentReactions.findIndex((reaction)=>reaction.emojiId === selectedEmojiId);
    const onTabChange = (0, $cozmU.useCallback)((index)=>{
        if (index === selectedIndex) return;
        const emojiId = currentReactions[index].emojiId;
        handleSelectReaction(emojiId);
    }, [
        selectedIndex,
        currentReactions,
        handleSelectReaction
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: handleCloseReactionsDialog,
        height: 600,
        testId: $6c371858ccc38d3c$export$ef88759cddab4775
    }, /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
        id: "reactions-dialog-tabs",
        onChange: onTabChange,
        selected: selectedIndex
    }, /*#__PURE__*/ $cozmU.createElement((0, $kvJXG.ReactionsDialogHeader), {
        totalReactionsCount: totalReactionsCount,
        maxPages: maxPages,
        handlePreviousPage: handlePreviousPage,
        handleNextPage: handleNextPage,
        currentPage: currentPage,
        emojiProvider: emojiProvider,
        currentReactions: currentReactions,
        handleCloseReactionsDialog: handleCloseReactionsDialog
    }), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6c371858ccc38d3c$var$styles.modalBodyStyle
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _3iDTPbQ4SZ _37wbyu7p2s _1mT5xdRAKS _3h2tDz3EvU _0GBAIrogpp _39mJBjdnbC _4Gb5FivLZJ _4DX2ezN91d _4zi1EpdnbC _2WYcYGWVPG"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lgLLu.ReactionsList), {
        selectedEmojiId: selectedEmojiId,
        reactions: currentReactions,
        ProfileCardWrapper: ProfileCardWrapper
    }))))));
};
function $6c371858ccc38d3c$var$_temp() {}
function $6c371858ccc38d3c$var$_temp2() {}
function $6c371858ccc38d3c$var$_temp3() {}
function $6c371858ccc38d3c$var$_temp4(accum, current) {
    accum = accum + current?.count;
    return accum;
}
function $6c371858ccc38d3c$var$_temp5(prevPage_0) {
    return Math.max(prevPage_0 - 1, 1);
}
module.exports["ReactionsDialog"] = $6c371858ccc38d3c$export$df84a24235404de6;

});

parcelRegister("lgLLu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $7uYie = parcelRequire("7uYie");

const $28b3de9cab4acb5c$export$a87089fe362b9d93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { reactions: reactions, selectedEmojiId: selectedEmojiId, ProfileCardWrapper: ProfileCardWrapper } = t0;
    let t1;
    if ($[0] !== ProfileCardWrapper || $[1] !== reactions || $[2] !== selectedEmojiId) {
        let t2;
        if ($[4] !== ProfileCardWrapper || $[5] !== selectedEmojiId) {
            t2 = (reaction)=>{
                if (reaction.emojiId === selectedEmojiId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7uYie.ReactionView), {
                    key: reaction.emojiId,
                    reaction: reaction,
                    ProfileCardWrapper: ProfileCardWrapper
                });
                else return null;
            };
            $[4] = ProfileCardWrapper;
            $[5] = selectedEmojiId;
            $[6] = t2;
        } else t2 = $[6];
        t1 = reactions.map(t2);
        $[0] = ProfileCardWrapper;
        $[1] = reactions;
        $[2] = selectedEmojiId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ reactions: reactions, selectedEmojiId: selectedEmojiId, ProfileCardWrapper: ProfileCardWrapper })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, reactions.map((reaction)=>{
        if (reaction.emojiId === selectedEmojiId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7uYie.ReactionView), {
            key: reaction.emojiId,
            reaction: reaction,
            ProfileCardWrapper: ProfileCardWrapper
        });
        else return null;
    }));
};
module.exports["ReactionsList"] = $28b3de9cab4acb5c$export$a87089fe362b9d93;

});

parcelRegister("7uYie", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $arQY7 = parcelRequire("arQY7");


var $lfoFx = parcelRequire("lfoFx");


var $gRGWz = parcelRequire("gRGWz");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

const $0adbe123f7e78edb$var$userListStyle = null;
const $0adbe123f7e78edb$var$userStyle = null;
const $0adbe123f7e78edb$var$styles = {
    userDescriptionStyle: "_2XsHFM8HPE",
    profileWrapperStyle: "_2XsHFMPgdg",
    reactionViewStyle: "_3138428HPE _4kiQYABfNa _4ouGXIbAsb",
    centerSpinnerStyle: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VN91d _313842NHnM"
};
const $0adbe123f7e78edb$export$5ad09c2943879b39 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { reaction: reaction, ProfileCardWrapper: ProfileCardWrapper } = t0;
    const reactionObj = reaction;
    let t1;
    if ($[0] !== reactionObj.users) {
        t1 = reactionObj.users?.sort($0adbe123f7e78edb$var$_temp) || [];
        $[0] = reactionObj.users;
        $[1] = t1;
    } else t1 = $[1];
    const alphabeticalNames = t1;
    let t2;
    if ($[2] !== ProfileCardWrapper || $[3] !== alphabeticalNames) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $gRGWz.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $0adbe123f7e78edb$var$styles.reactionViewStyle
        }, alphabeticalNames.length === 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0adbe123f7e78edb$var$styles.centerSpinnerStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "large",
            interactionName: "reactions-spinner"
        })) : /*#__PURE__*/ $cozmU.createElement("ul", {
            className: (0, $hekY6.default)([
                "_1LMyvKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3138425zaO _2fwxA5ecOK _1xwpxGmnOE _1WG9Way7kJ"
            ])
        }, alphabeticalNames.map((user)=>{
            const profile = user.profilePicture?.path;
            return /*#__PURE__*/ $cozmU.createElement("li", {
                key: user.id,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0hPCNLDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6QdnbC _1ZnuxbdnbC _08IXD05zaO"
                ])
            }, ProfileCardWrapper && user.accountId ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $0adbe123f7e78edb$var$styles.profileWrapperStyle
            }, /*#__PURE__*/ $cozmU.createElement(ProfileCardWrapper, {
                userId: user.accountId,
                isAnonymous: false,
                canViewProfile: true,
                position: "left-start"
            }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                size: "medium",
                src: profile,
                testId: "profile"
            }))) : /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                size: "medium",
                src: profile,
                testId: "profile"
            }), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                xcss: $0adbe123f7e78edb$var$styles.userDescriptionStyle
            }, /*#__PURE__*/ $cozmU.createElement("div", null, user.displayName)));
        }))));
        $[2] = ProfileCardWrapper;
        $[3] = alphabeticalNames;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ reaction: reaction, ProfileCardWrapper: ProfileCardWrapper })=>{
    const alphabeticalNames = (0, $cozmU.useMemo)(()=>{
        const reactionObj = reaction;
        return reactionObj.users?.sort((a, b)=>a.displayName.localeCompare(b.displayName)) || [];
    }, [
        reaction
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $gRGWz.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: $0adbe123f7e78edb$var$styles.reactionViewStyle
    }, alphabeticalNames.length === 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0adbe123f7e78edb$var$styles.centerSpinnerStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "reactions-spinner"
    })) : /*#__PURE__*/ $cozmU.createElement("ul", {
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3138425zaO _2fwxA5ecOK _1xwpxGmnOE _1WG9Way7kJ"
        ])
    }, alphabeticalNames.map((user)=>{
        const profile = user.profilePicture?.path;
        return /*#__PURE__*/ $cozmU.createElement("li", {
            key: user.id,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6QdnbC _1ZnuxbdnbC _08IXD05zaO"
            ])
        }, ProfileCardWrapper && user.accountId ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0adbe123f7e78edb$var$styles.profileWrapperStyle
        }, /*#__PURE__*/ $cozmU.createElement(ProfileCardWrapper, {
            userId: user.accountId,
            isAnonymous: false,
            canViewProfile: true,
            position: "left-start"
        }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            size: "medium",
            src: profile,
            testId: "profile"
        }))) : /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            size: "medium",
            src: profile,
            testId: "profile"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $0adbe123f7e78edb$var$styles.userDescriptionStyle
        }, /*#__PURE__*/ $cozmU.createElement("div", null, user.displayName)));
    }))));
};
function $0adbe123f7e78edb$var$_temp(a, b) {
    return a.displayName.localeCompare(b.displayName);
}
module.exports["ReactionView"] = $0adbe123f7e78edb$export$5ad09c2943879b39;

});

parcelRegister("kvJXG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $cDs9S = parcelRequire("cDs9S");

var $aGB72 = parcelRequire("aGB72");


var $bxtKM = parcelRequire("bxtKM");

var $dkVNA = parcelRequire("dkVNA");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $aDSIl = parcelRequire("aDSIl");


var $iW7aI = parcelRequire("iW7aI");


var $6OpMl = parcelRequire("6OpMl");


var $jFWFL = parcelRequire("jFWFL");


var $9UzxD = parcelRequire("9UzxD");


var $lbdYm = parcelRequire("lbdYm");

const $2634b67aa7c4350a$var$styles = {
    leftNavigationStyle: "_3138421Y8M _4xdlr0R7aE _2Zuz6Q5zaO _1wydGW8HPE",
    rightNavigationStyle: "_3138421Y8M _4xdlr0R7aE _2XsHFMIZbP _0adFHs2ADO",
    fullWidthStyle: "_39xV02N91d _0Of8r2NHnM _2Zuz6QNHnM _1ZnuxbNHnM _0xmtkoVa5s",
    emoji: "_4c065U1Y8M _0yKXXaDGiX _0LQT5E2ADO _03SyCP1Y8M",
    counterStyle: "_313842FQfX"
};
const $2634b67aa7c4350a$var$REACTIONS_CONTAINER_WIDTH = 56;
const $2634b67aa7c4350a$var$REACTION_CONTAINER_HEIGHT = 40;
const $2634b67aa7c4350a$var$customTabListStyles = null;
const $2634b67aa7c4350a$var$customTabWrapper = {
    base: "_3YEZNOdnbC _3iDTPbQ4SZ _0aFT5vbt8w _2fwxA5DIqT _0hPCNLDIqT _37wbyuDIqT _4ouGXImdCj _24h04i2Njc _1mT5xdRAKS _1C8dRaAASz _0rUhZjAASz _3c7I3RAASz _1stIVYAASz _0qRrkpmdCj _4EeuowUF4f _0VdfO7DIqT _1WMabhDIqT _1y7d8OTFQX _0bu9Bbogpp _1vJN9LWVPG _0IIxcqdnbC _4B8qZSdnbC _3s5ErCmdCj _1Py4UeUF4f _3H9klIdnbC _1gogL6INwl _0Nbas4ogpp _4xh3Z9WVPG _0m3eUKdnbC _0Pz6hydnbC _3KlDlumdCj _3C4BpoUF4f _0y2qr2dnbC _2oOvNHey7F _0GCLsBey7F",
    darkTheme: "_1y7d8Ocbvn _1gogL60miN"
};
const $2634b67aa7c4350a$var$firstElement = null;
const $2634b67aa7c4350a$var$LeftNavigationButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { handlePreviousPage: handlePreviousPage } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $jFWFL.messages).leftNavigateLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== handlePreviousPage || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $2634b67aa7c4350a$var$styles.leftNavigationStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            spacing: "compact",
            onClick: handlePreviousPage,
            icon: $2634b67aa7c4350a$var$_temp,
            label: t1,
            isTooltipDisabled: false
        }));
        $[2] = handlePreviousPage;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ handlePreviousPage: handlePreviousPage })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $2634b67aa7c4350a$var$styles.leftNavigationStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        onClick: handlePreviousPage,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage((0, $jFWFL.messages).leftNavigateLabel),
        isTooltipDisabled: false
    }));
};
const $2634b67aa7c4350a$var$RightNavigationButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { handleNextPage: handleNextPage } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $jFWFL.messages).rightNavigateLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== handleNextPage || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $2634b67aa7c4350a$var$styles.rightNavigationStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            spacing: "compact",
            onClick: handleNextPage,
            icon: $2634b67aa7c4350a$var$_temp2,
            label: t1,
            isTooltipDisabled: false
        }));
        $[2] = handleNextPage;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ handleNextPage: handleNextPage })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $2634b67aa7c4350a$var$styles.rightNavigationStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        onClick: handleNextPage,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage((0, $jFWFL.messages).rightNavigateLabel),
        isTooltipDisabled: false
    }));
};
const $2634b67aa7c4350a$export$6c6a0fee39bccb13 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { totalReactionsCount: totalReactionsCount, handlePreviousPage: handlePreviousPage, handleNextPage: handleNextPage, currentPage: currentPage, maxPages: maxPages, currentReactions: currentReactions, emojiProvider: emojiProvider, handleCloseReactionsDialog: handleCloseReactionsDialog } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [cache, setCache] = (0, $cozmU.useState)(t1);
    const { titleId: titleId } = (0, $aGB72.useModal)();
    const intl = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isSinglePage = maxPages === 1;
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === maxPages;
    let t2;
    if ($[1] !== cache || $[2] !== emojiProvider) {
        t2 = (reaction)=>{
            const { emojiId: emojiId } = reaction;
            if (!emojiId || cache[emojiId]) return;
            (async ()=>{
                const provider = await emojiProvider;
                const emoji = await provider.findByEmojiId({
                    shortName: "",
                    id: emojiId
                });
                if (emoji?.name) {
                    const capitalizedName = emoji.name.replace(/\b\w/g, $2634b67aa7c4350a$var$_temp3);
                    setCache((prevCache)=>({
                            ...prevCache,
                            [emojiId]: capitalizedName
                        }));
                }
            })();
        };
        $[1] = cache;
        $[2] = emojiProvider;
        $[3] = t2;
    } else t2 = $[3];
    const handleMouseEnter = t2;
    let t3;
    if ($[4] !== intl || $[5] !== totalReactionsCount) {
        t3 = intl.formatMessage((0, $jFWFL.messages).reactionsCount, {
            count: totalReactionsCount
        });
        $[4] = intl;
        $[5] = totalReactionsCount;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3 || $[8] !== titleId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "medium",
            id: titleId
        }, t3);
        $[7] = t3;
        $[8] = titleId;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== handleCloseReactionsDialog) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
            onClick: handleCloseReactionsDialog
        });
        $[10] = handleCloseReactionsDialog;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $2634b67aa7c4350a$var$styles.fullWidthStyle
        }, t4, t5);
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _1x1D3gOeNX _3iDTPbQ4SZ _39xV02N91d _0hPCNLchRC _0wPZYW2ADO _1QQliJ7dHp _2DRTKujOvk"
        ]);
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== handlePreviousPage || $[17] !== isOnFirstPage || $[18] !== isSinglePage) {
        t8 = !isSinglePage && !isOnFirstPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$LeftNavigationButton, {
            handlePreviousPage: handlePreviousPage
        });
        $[16] = handlePreviousPage;
        $[17] = isOnFirstPage;
        $[18] = isSinglePage;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== cache || $[21] !== colorMode || $[22] !== currentReactions || $[23] !== emojiProvider || $[24] !== handleMouseEnter) {
        let t10;
        if ($[26] !== cache || $[27] !== colorMode || $[28] !== emojiProvider || $[29] !== handleMouseEnter) {
            t10 = (reaction_0, index)=>{
                const emojiId_0 = {
                    id: reaction_0.emojiId,
                    shortName: ""
                };
                return /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        $2634b67aa7c4350a$var$customTabWrapper.base,
                        colorMode === "dark" && $2634b67aa7c4350a$var$customTabWrapper.darkTheme,
                        index === 0 && "_2Zuz6Q5zaO",
                        "reaction-elements"
                    ]),
                    key: reaction_0.emojiId,
                    "data-testid": emojiId_0?.id,
                    onMouseEnter: ()=>{
                        handleMouseEnter(reaction_0);
                    },
                    onFocus: (0, $iDrrr.fg)("platform_suppression_removal_fix_reactions") ? ()=>{
                        handleMouseEnter(reaction_0);
                    } : undefined
                }, /*#__PURE__*/ $cozmU.createElement((0, $bxtKM.default), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                    content: cache[reaction_0.emojiId],
                    canAppear: ()=>!!cache[reaction_0.emojiId]
                }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                    justifyContent: "center",
                    alignItems: "center",
                    direction: "row"
                }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $2634b67aa7c4350a$var$styles.emoji
                }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
                    emojiProvider: emojiProvider,
                    emojiId: emojiId_0,
                    fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
                    showTooltip: true
                })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $2634b67aa7c4350a$var$styles.counterStyle
                }, /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
                    value: reaction_0.count
                }))))));
            };
            $[26] = cache;
            $[27] = colorMode;
            $[28] = emojiProvider;
            $[29] = handleMouseEnter;
            $[30] = t10;
        } else t10 = $[30];
        t9 = currentReactions.map(t10);
        $[20] = cache;
        $[21] = colorMode;
        $[22] = currentReactions;
        $[23] = emojiProvider;
        $[24] = handleMouseEnter;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[31] !== handleNextPage || $[32] !== isOnLastPage || $[33] !== isSinglePage) {
        t10 = !isSinglePage && !isOnLastPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$RightNavigationButton, {
            handleNextPage: handleNextPage
        });
        $[31] = handleNextPage;
        $[32] = isOnLastPage;
        $[33] = isSinglePage;
        $[34] = t10;
    } else t10 = $[34];
    let t11;
    if ($[35] !== t10 || $[36] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, t9, t10);
        $[35] = t10;
        $[36] = t9;
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== t11 || $[39] !== t8) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement("div", {
            id: "reactions-dialog-tabs-list",
            className: t7
        }, t8, t11));
        $[38] = t11;
        $[39] = t8;
        $[40] = t12;
    } else t12 = $[40];
    let t13;
    if ($[41] !== t12 || $[42] !== t6) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t6, t12);
        $[41] = t12;
        $[42] = t6;
        $[43] = t13;
    } else t13 = $[43];
    return t13;
} : ({ totalReactionsCount: totalReactionsCount, handlePreviousPage: handlePreviousPage, handleNextPage: handleNextPage, currentPage: currentPage, maxPages: maxPages, currentReactions: currentReactions, emojiProvider: emojiProvider, handleCloseReactionsDialog: handleCloseReactionsDialog })=>{
    const [cache, setCache] = (0, $cozmU.useState)({});
    const { titleId: titleId } = (0, $aGB72.useModal)();
    const intl = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isSinglePage = maxPages === 1;
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === maxPages;
    const handleMouseEnter = (reaction)=>{
        const { emojiId: emojiId } = reaction;
        if (!emojiId || cache[emojiId]) return;
        (async ()=>{
            // Note: not a network request e.g. ReactedUsersQuery
            const provider = await emojiProvider;
            const emoji = await provider.findByEmojiId({
                shortName: '',
                id: emojiId
            });
            if (emoji?.name) {
                // capitalize first letter of each string
                const capitalizedName = emoji.name.replace(/\b\w/g, (char)=>char.toUpperCase());
                setCache((prevCache)=>({
                        ...prevCache,
                        [emojiId]: capitalizedName
                    }));
            }
        })();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $2634b67aa7c4350a$var$styles.fullWidthStyle
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "medium",
        id: titleId
    }, intl.formatMessage((0, $jFWFL.messages).reactionsCount, {
        count: totalReactionsCount
    })), /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
        onClick: handleCloseReactionsDialog
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement("div", {
        id: "reactions-dialog-tabs-list",
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _1x1D3gOeNX _3iDTPbQ4SZ _39xV02N91d _0hPCNLchRC _0wPZYW2ADO _1QQliJ7dHp _2DRTKujOvk"
        ])
    }, !isSinglePage && !isOnFirstPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$LeftNavigationButton, {
        handlePreviousPage: handlePreviousPage
    }), /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, currentReactions.map((reaction_0, index)=>{
        const emojiId_0 = {
            id: reaction_0.emojiId,
            shortName: ''
        };
        return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $2634b67aa7c4350a$var$customTabWrapper.base,
                colorMode === 'dark' && $2634b67aa7c4350a$var$customTabWrapper.darkTheme,
                index === 0 && "_2Zuz6Q5zaO",
                "reaction-elements"
            ]),
            key: reaction_0.emojiId,
            "data-testid": emojiId_0?.id,
            onMouseEnter: ()=>{
                handleMouseEnter(reaction_0);
            },
            onFocus: (0, $iDrrr.fg)('platform_suppression_removal_fix_reactions') ? ()=>{
                handleMouseEnter(reaction_0);
            } : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $bxtKM.default), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: cache[reaction_0.emojiId],
            canAppear: ()=>!!cache[reaction_0.emojiId]
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center",
            direction: "row"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2634b67aa7c4350a$var$styles.emoji
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId_0,
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            showTooltip: true
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2634b67aa7c4350a$var$styles.counterStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
            value: reaction_0.count
        }))))));
    }), !isSinglePage && !isOnLastPage && /*#__PURE__*/ $cozmU.createElement($2634b67aa7c4350a$var$RightNavigationButton, {
        handleNextPage: handleNextPage
    })))));
};
function $2634b67aa7c4350a$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps,
        size: "small"
    });
}
function $2634b67aa7c4350a$var$_temp2(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps,
        size: "small"
    });
}
function $2634b67aa7c4350a$var$_temp3(char) {
    return char.toUpperCase();
}
module.exports["ReactionsDialogHeader"] = $2634b67aa7c4350a$export$6c6a0fee39bccb13;

});

parcelRegister("bm4sQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $af2XZ = parcelRequire("af2XZ");


var $iDrrr = parcelRequire("iDrrr");


var $akErP = parcelRequire("akErP");

var $lQV5m = parcelRequire("lQV5m");

var $kN1yU = parcelRequire("kN1yU");


var $jp2Q3 = parcelRequire("jp2Q3");


var $iMnC5 = parcelRequire("iMnC5");


var $5kgY7 = parcelRequire("5kgY7");


var $6T1Vv = parcelRequire("6T1Vv");


var $75Lmu = parcelRequire("75Lmu");


var $jFWFL = parcelRequire("jFWFL");


var $97zIA = parcelRequire("97zIA");


var $8lhEp = parcelRequire("8lhEp");


var $bih1Q = parcelRequire("bih1Q");


var $170Uc = parcelRequire("170Uc");


var $cK21K = parcelRequire("cK21K");


var $ieeJu = parcelRequire("ieeJu");

const $947dedcc17ccb720$var$pickerStyle = null;
const $947dedcc17ccb720$var$popupWrapperStyle = null;
const $947dedcc17ccb720$var$popupStyle = null;
const $947dedcc17ccb720$var$additionalStyles = {
    selectorContainer: "_3iDTPbQ4SZ"
}; /**
    * Test id for wrapper ReactionPicker div
    */ 
const $947dedcc17ccb720$export$4e9694165fb83edd = 'reactionPicker-testid'; /**
                                                                      * Test id for ReactionPicker panel div
                                                                      */ 
const $947dedcc17ccb720$export$d52b610bc836b6d7 = 'reactionPickerPanel-testid'; /**
                                                                                * Emoji Picker Controller Id for Accessibility Labels
                                                                                */ 
const $947dedcc17ccb720$var$PICKER_CONTROL_ID = 'emoji-picker';
const $947dedcc17ccb720$export$1d5ec51e9af399a5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { miniMode: miniMode, className: className, emojiProvider: emojiProvider, onSelection: onSelection, allowAllEmojis: allowAllEmojis, disabled: disabled, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, onShowMore: onShowMore = ()=>{}, onOpen: onOpen = ()=>{}, onCancel: onCancel = ()=>{}, tooltipContent: tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).addReaction), emojiPickerSize: emojiPickerSize, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText, reactionPickerPlacement: reactionPickerPlacement, isListItem: isListItem = false, hoverableReactionPicker: hoverableReactionPicker = false, hoverableReactionPickerDelay: hoverableReactionPickerDelay = 0, reactionPickerPopperZIndex: reactionPickerPopperZIndex } = props;
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    const [isHoverableReactionPickerEmojiPickerOpen, setIsHoverableReactionPickerEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = (0, $cozmU.useState)(false);
    const [isHoveringPopup, setIsHoveringPopup] = (0, $cozmU.useState)(false);
    const [isTriggerClicked, setIsTriggerClicked] = (0, $cozmU.useState)(false);
    const [isPopupTrayOpen, setIsPopupTrayOpen] = (0, $6T1Vv.useDelayedState)(false, hoverableReactionPickerDelay); /**
                                                                                                                * Container <div /> reference (used by custom hook to detect click outside)
                                                                                                                */ 
    const wrapperRef = (0, $cozmU.useRef)(null);
    const updatePopper = (0, $cozmU.useRef)();
    const popperPlacement = reactionPickerPlacement || 'bottom-start';
    const popperModifiers = [
        /**
    Removing this applyStyle modifier as it throws client errors ref:
   https://popper.js.org/docs/v1/#modifiers
   https://popper.js.org/docs/v1/#modifiers..applyStyle
   { name: 'applyStyle', enabled: false },
    */ {
            name: 'hide',
            enabled: false
        },
        {
            name: 'offset',
            enabled: true,
            options: {
                offset: [
                    0,
                    4
                ]
            }
        },
        {
            name: 'flip',
            enabled: true,
            options: {
                flipVariations: true,
                boundariesElement: 'scrollParent'
            }
        }
    ];
    const [settings, setSettings] = (0, $cozmU.useState)({
        /**
     * Show the full custom emoji list picker or the default list of emojis
     */ showFullPicker: !!allowAllEmojis && Array.isArray(pickerQuickReactionEmojiIds) && pickerQuickReactionEmojiIds.length === 0,
        popperPlacement: /**
     * Use placement for popper based on reactionPickerPlacement prop
     */ popperPlacement
    }); /**
       * Event callback when the picker is closed
       * @param _id Optional id if an emoji button was selected or undefineed if was clicked outside the picker
       */ 
    const close = (0, $cozmU.useCallback)((_id)=>{
        setIsPopupTrayOpen(false, true); // ufo abort reaction experience
        (0, $97zIA.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(false);
            setIsTriggerClicked(false);
            setIsHoveringTrigger(false);
            setIsHoveringPopup(false);
        }
    }, [
        setIsPopupTrayOpen,
        setIsHoverableReactionPickerEmojiPickerOpen,
        hoverableReactionPicker,
        setIsTriggerClicked,
        setIsHoveringTrigger,
        setIsHoveringPopup
    ]); /**
                                                                                                                                                                  * Event handle rwhen selecting to show the custom emoji icons picker
                                                                                                                                                                  * @param e event param
                                                                                                                                                                  */ 
    const onSelectMoreClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setSettings({
            showFullPicker: hoverableReactionPicker ? settings.showFullPicker : true,
            popperPlacement: popperPlacement
        });
        setIsPopupTrayOpen(true);
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(!isHoverableReactionPickerEmojiPickerOpen);
            setIsTriggerClicked(false);
        }
        onShowMore();
    }, [
        settings.showFullPicker,
        setIsPopupTrayOpen,
        onShowMore,
        popperPlacement,
        hoverableReactionPicker,
        setIsHoverableReactionPickerEmojiPickerOpen,
        isHoverableReactionPickerEmojiPickerOpen
    ]); /**
                                                                                                                                                                                                   * Event callback when an emoji icon is selected
                                                                                                                                                                                                   * @param item selected item
                                                                                                                                                                                                   */ 
    const onEmojiSelected = (0, $cozmU.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? 'emojiPicker' : 'quickSelector');
        close(item.id); // After selecting an emoji, we would like focus to be returned to the trigger button
        // This is for the purposes of navigation for keyboard users
        requestAnimationFrame(()=>triggerRef?.focus());
    }, [
        close,
        onSelection,
        settings.showFullPicker,
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        triggerRef
    ]); /**
                                                                                                                                     * Event handler when the emoji icon to open the custom picker is selected
                                                                                                                                     */ 
    const onTriggerClick = (0, $cozmU.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $97zIA.PickerRender).start();
        setSettings({
            ...settings,
            popperPlacement: popperPlacement
        });
        if (hoverableReactionPicker) {
            if (isHoverableReactionPickerEmojiPickerOpen || isTriggerClicked) {
                // if either the emoji picker is open or the trigger was clicked, close the popup and reset the state
                setIsTriggerClicked(false);
                setIsPopupTrayOpen(false, true);
            } else {
                // if neither condition is true, open the popup and set the state
                setIsTriggerClicked(true);
                setIsPopupTrayOpen(true, true);
            } // close the emoji picker
            setIsHoverableReactionPickerEmojiPickerOpen(false);
        } else setIsPopupTrayOpen(!isPopupTrayOpen);
        onOpen(); // ufo reactions picker opened success
        (0, $97zIA.PickerRender).success({
            metadata: {
                readingOrderInline: (0, $iDrrr.fg)('a11y_reactions_reading_order')
            }
        });
    }, [
        hoverableReactionPicker,
        isPopupTrayOpen,
        setIsPopupTrayOpen,
        isTriggerClicked,
        setIsTriggerClicked,
        isHoverableReactionPickerEmojiPickerOpen,
        onOpen,
        settings,
        popperPlacement
    ]);
    const handleTriggerMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handleTriggerMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(false);
            if (!isHoveringPopup && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringPopup,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const handlePopupMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handlePopupMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(false);
            if (!isHoveringTrigger && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringTrigger,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const wrapperClassName = ` ${isPopupTrayOpen ? 'isOpen' : ''} ${miniMode ? 'miniMode' : ''} ${className}`;
    (0, $cozmU.useLayoutEffect)(()=>{
        updatePopper.current?.();
    }, [
        settings
    ]);
    const onClose = ()=>{
        close();
        onCancel();
    };
    const pickerPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($947dedcc17ccb720$export$8c62d061746e97b3, {
        settings: settings,
        popperModifiers: popperModifiers,
        isOpen: isPopupTrayOpen,
        onClose: onClose,
        triggerRef: triggerRef,
        zIndex: reactionPickerPopperZIndex || (0, $jp2Q3.layers).flag()
    }, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $947dedcc17ccb720$var$additionalStyles.selectorContainer,
        onMouseEnter: handlePopupMouseEnter,
        onMouseLeave: handlePopupMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2XZ.default), {
        emojiProvider: emojiProvider,
        onSelection: onEmojiSelected,
        size: emojiPickerSize
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $947dedcc17ccb720$var$additionalStyles.selectorContainer,
        onMouseEnter: handlePopupMouseEnter,
        onMouseLeave: handlePopupMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lhEp.Selector), {
        emojiProvider: emojiProvider,
        onSelection: onEmojiSelected,
        showMore: allowAllEmojis,
        onMoreClick: onSelectMoreClick,
        pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
        hoverableReactionPickerSelector: hoverableReactionPicker
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_1RrJLit2nV _44IyhFvbI6",
            wrapperClassName
        ]),
        "data-testid": $947dedcc17ccb720$export$4e9694165fb83edd,
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kN1yU.Reference), null, ({ ref: ref })=>// Render a button to open the <Selector /> panel
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: handleTriggerMouseEnter,
            onMouseLeave: handleTriggerMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bih1Q.Trigger), {
            ariaAttributes: {
                'aria-expanded': isPopupTrayOpen,
                'aria-controls': $947dedcc17ccb720$var$PICKER_CONTROL_ID,
                ...isPopupTrayOpen && (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? {
                    'aria-owns': $947dedcc17ccb720$var$PICKER_CONTROL_ID
                } : {}
            },
            ref: (node)=>{
                if (node && isPopupTrayOpen) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setTriggerRef(node);
                }
            },
            isSelected: isPopupTrayOpen,
            onClick: onTriggerClick,
            miniMode: miniMode,
            disabled: disabled,
            tooltipContent: isPopupTrayOpen ? null : tooltipContent,
            showOpaqueBackground: showOpaqueBackground,
            showAddReactionText: showAddReactionText,
            subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
            reactionPickerTriggerIcon: reactionPickerTriggerIcon,
            reactionPickerTriggerText: reactionPickerTriggerText,
            isListItem: isListItem,
            emojiPickerSize: emojiPickerSize
        }))), isPopupTrayOpen && ((0, $iDrrr.fg)('a11y_reactions_reading_order') ? // Render the picker panel inline (a DOM sibling directly after the trigger)
    // so assistive technologies encounter the expanded content in the correct
    // reading order. The popper still positions with `position: fixed`, so the
    // visual placement is unchanged.
    pickerPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: reactionPickerPopperZIndex || (0, $jp2Q3.layers).flag()
    }, pickerPanel))));
});
const $947dedcc17ccb720$export$8c62d061746e97b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(16);
    const { triggerRef: triggerRef, settings: settings, isOpen: isOpen, onClose: onClose, children: children, popperModifiers: popperModifiers, zIndex: zIndex } = props;
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("platform_ceps-5921-a11y-fix-reactions");
        $[0] = t0;
    } else t0 = $[0];
    const isDialogRoleEnabled = t0;
    let t1;
    if ($[1] !== popupRef) {
        t1 = {
            initialFocusRef: null,
            targetRef: popupRef
        };
        $[1] = popupRef;
        $[2] = t1;
    } else t1 = $[2];
    (0, $75Lmu.useFocusTrap)(t1);
    let t2;
    if ($[3] !== onClose || $[4] !== popupRef || $[5] !== triggerRef) {
        t2 = (callbackType)=>{
            onClose();
            if (popupRef && callbackType === "ESCAPE") requestAnimationFrame(()=>triggerRef?.focus());
        };
        $[3] = onClose;
        $[4] = popupRef;
        $[5] = triggerRef;
        $[6] = t2;
    } else t2 = $[6];
    (0, $5kgY7.useCloseManagerV2)(popupRef, triggerRef, t2, true, isOpen);
    let t3;
    if ($[7] !== children || $[8] !== formatMessage || $[9] !== settings || $[10] !== zIndex) {
        t3 = (t4)=>{
            const { ref: ref, style: style, update: update } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                role: isDialogRoleEnabled ? "dialog" : "group",
                "aria-modal": isDialogRoleEnabled ? false : undefined,
                "aria-label": formatMessage((0, $jFWFL.messages).popperWrapperLabel),
                id: $947dedcc17ccb720$var$PICKER_CONTROL_ID,
                "data-testid": $947dedcc17ccb720$export$d52b610bc836b6d7,
                style: {
                    zIndex: zIndex,
                    ...style
                },
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === "function") ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                tabIndex: (0, $iDrrr.fg)("platform_suppression_removal_fix_reactions") ? undefined : 0,
                className: (0, $hekY6.default)([
                    "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $170Uc.RepositionOnUpdate), {
                update: update,
                settings: settings
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v _0tKlqQ1Y8M"
                ])
            }, children)));
        };
        $[7] = children;
        $[8] = formatMessage;
        $[9] = settings;
        $[10] = zIndex;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== popperModifiers || $[13] !== settings.popperPlacement || $[14] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
            placement: settings.popperPlacement,
            modifiers: popperModifiers
        }, t3);
        $[12] = popperModifiers;
        $[13] = settings.popperPlacement;
        $[14] = t3;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : (props)=>{
    const { triggerRef: triggerRef, settings: settings, isOpen: isOpen, onClose: onClose, children: children, popperModifiers: popperModifiers, zIndex: zIndex } = props;
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); /**
                  * Expose the reaction picker panel as a non-modal dialog to assistive technology.
                  * When disabled, fall back to the previous `role="group"` semantics.
                  */ 
    const isDialogRoleEnabled = (0, $iDrrr.fg)('platform_ceps-5921-a11y-fix-reactions'); /**
                                                                            * add focus lock to popup
                                                                            */ 
    (0, $75Lmu.useFocusTrap)({
        initialFocusRef: null,
        targetRef: popupRef
    }); /**
       * Custom hook triggers when user clicks outside the reactions picker
       */ 
    (0, $5kgY7.useCloseManagerV2)(popupRef, triggerRef, (callbackType)=>{
        onClose();
        if (popupRef && callbackType === 'ESCAPE') requestAnimationFrame(()=>triggerRef?.focus());
    }, true, isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
        placement: settings.popperPlacement,
        modifiers: popperModifiers
    }, ({ ref: ref, style: style, update: update })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: isDialogRoleEnabled ? 'dialog' : 'group',
            "aria-modal": isDialogRoleEnabled ? false : undefined,
            "aria-label": formatMessage((0, $jFWFL.messages).popperWrapperLabel),
            id: $947dedcc17ccb720$var$PICKER_CONTROL_ID,
            "data-testid": $947dedcc17ccb720$export$d52b610bc836b6d7,
            style: {
                zIndex: zIndex,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...style
            },
            ref: (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setPopupRef(node);
                }
            },
            tabIndex: (0, $iDrrr.fg)('platform_suppression_removal_fix_reactions') ? undefined : 0,
            className: (0, $hekY6.default)([
                "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $170Uc.RepositionOnUpdate), {
            update: update,
            settings: settings
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v _0tKlqQ1Y8M"
            ])
        }, children)));
    });
};
module.exports["ReactionPicker"] = $947dedcc17ccb720$export$1d5ec51e9af399a5;

});

parcelRegister("5kgY7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cd2f8ae127029e1f$export$92dae2778ae88f9d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCloseManager(ref, callback, t0, t1) {
    const $ = (0, $bDgLe.c)(6);
    const useCapture = t0 === undefined ? false : t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== callback || $[1] !== enabled || $[2] !== ref || $[3] !== useCapture) {
        t2 = ()=>{
            if (!enabled) return;
            const handleClickOutside = function handleClickOutside(event) {
                if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) callback("CLICK_OUTSIDE");
            };
            const handleKeydown = function handleKeydown(event_0) {
                const { key: key } = event_0;
                if (key === "Escape" || key === "Esc") callback("ESCAPE");
            };
            document.addEventListener("click", handleClickOutside, useCapture);
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("click", handleClickOutside, useCapture);
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t3 = [
            ref,
            callback,
            useCapture,
            enabled
        ];
        $[0] = callback;
        $[1] = enabled;
        $[2] = ref;
        $[3] = useCapture;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useCloseManager(ref, callback, useCapture = false, enabled = true) {
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        /**
     * Alert if clicked on outside of element
     */ function handleClickOutside(event) {
            if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event_0) {
            const { key: key } = event_0;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        ref,
        callback,
        useCapture,
        enabled
    ]);
};
const $cd2f8ae127029e1f$export$d6c3c92a8b7167c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCloseManagerV2(popupRef, triggerRef, callback, t0, t1) {
    const $ = (0, $bDgLe.c)(7);
    const useCapture = t0 === undefined ? false : t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== callback || $[1] !== enabled || $[2] !== popupRef || $[3] !== triggerRef || $[4] !== useCapture) {
        t2 = ()=>{
            if (!enabled) return;
            const handleClickOutside = function handleClickOutside(event) {
                const target = event.target;
                const isClickOnPopup = popupRef && popupRef.contains(target);
                const isClickOnTrigger = triggerRef && triggerRef.contains(target);
                if (!isClickOnPopup && !isClickOnTrigger) callback("CLICK_OUTSIDE");
            };
            const handleKeydown = function handleKeydown(event_0) {
                const { key: key } = event_0;
                if (key === "Escape" || key === "Esc") callback("ESCAPE");
            };
            document.addEventListener("click", handleClickOutside, useCapture);
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("click", handleClickOutside, useCapture);
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t3 = [
            triggerRef,
            popupRef,
            callback,
            useCapture,
            enabled
        ];
        $[0] = callback;
        $[1] = enabled;
        $[2] = popupRef;
        $[3] = triggerRef;
        $[4] = useCapture;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useCloseManagerV2(popupRef, triggerRef, callback, useCapture = false, enabled = true) {
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        /**
     * Alert if clicked on outside of element
     */ function handleClickOutside(event) {
            const target = event.target;
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event_0) {
            const { key: key } = event_0;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        triggerRef,
        popupRef,
        callback,
        useCapture,
        enabled
    ]);
};
module.exports["useCloseManagerV2"] = $cd2f8ae127029e1f$export$d6c3c92a8b7167c2;

});

parcelRegister("6T1Vv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $ca45144c595c321e$export$94d25041dfc7e5be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (initialState, delay)=>{
    const $ = (0, $bDgLe.c)(7);
    const [state, setState] = (0, $cozmU.useState)(initialState);
    const timeoutRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== delay) {
        t2 = (newState, t3)=>{
            const immediate = t3 === undefined ? false : t3;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (immediate || delay === 0) setState(newState);
            else timeoutRef.current = setTimeout(()=>{
                setState(newState);
            }, delay);
        };
        $[2] = delay;
        $[3] = t2;
    } else t2 = $[3];
    const handleDelayedStateChange = t2;
    let t3;
    if ($[4] !== handleDelayedStateChange || $[5] !== state) {
        t3 = [
            state,
            handleDelayedStateChange
        ];
        $[4] = handleDelayedStateChange;
        $[5] = state;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (initialState, delay)=>{
    const [state, setState] = (0, $cozmU.useState)(initialState);
    const timeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleDelayedStateChange = (0, $cozmU.useCallback)((newState, immediate = false)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (immediate || delay === 0) setState(newState);
        else timeoutRef.current = setTimeout(()=>{
            setState(newState);
        }, delay);
    }, [
        delay
    ]);
    return [
        state,
        handleDelayedStateChange
    ];
};
module.exports["useDelayedState"] = $ca45144c595c321e$export$94d25041dfc7e5be;

});

parcelRegister("75Lmu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dlU1V = parcelRequire("dlU1V");

const $6cb1a3d2db6a68e4$export$5562a1f223a0d314 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { targetRef: targetRef, initialFocusRef: initialFocusRef } = t0;
    let t1;
    let t2;
    if ($[0] !== initialFocusRef || $[1] !== targetRef) {
        t1 = ()=>{
            if (!targetRef) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: initialFocusRef || targetRef,
                fallbackFocus: targetRef,
                returnFocusOnDeactivate: false
            };
            const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dlU1V)))(targetRef, trapConfig);
            let frameId = requestAnimationFrame(()=>{
                frameId = null;
                focusTrap.activate();
            });
            return ()=>{
                if (frameId != null) {
                    cancelAnimationFrame(frameId);
                    frameId = null;
                }
                focusTrap.deactivate();
            };
        };
        t2 = [
            targetRef,
            initialFocusRef
        ];
        $[0] = initialFocusRef;
        $[1] = targetRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ targetRef: targetRef, initialFocusRef: initialFocusRef })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: false
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dlU1V)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef,
        initialFocusRef
    ]);
};
module.exports["useFocusTrap"] = $6cb1a3d2db6a68e4$export$5562a1f223a0d314;

});

parcelRegister("8lhEp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ieeJu = parcelRequire("ieeJu");


var $4o0zT = parcelRequire("4o0zT");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lpNn5 = parcelRequire("lpNn5");


var $jFWFL = parcelRequire("jFWFL");


var $lbdYm = parcelRequire("lbdYm");


var $lStsD = parcelRequire("lStsD");


var $15vr2 = parcelRequire("15vr2");


var $bih1Q = parcelRequire("bih1Q");

const $a2ab395c45579380$var$styles = {
    container: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    emojiContainer: "_0aNu0LYbGa _313842Pgdg",
    separator: "_1Vs123NvrM _0obpEh9r67 _421I1o6wH8 _0GTcwR1Y8M _2xTnZx2ADO _0jFU0VoWWg _3iDTPbvbI6",
    hoverableReactionPickerSelectorContainer: "_2mHwu81Y8M _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    hoverableReactionPickerSelectorList: "_2mHwu81Y8M _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0aNu0LYbGa"
};
const $a2ab395c45579380$var$revealAnimation = null;
const $a2ab395c45579380$var$revealStyle = null; /**
                           * Test id for wrapper Selector div
                           */ 
const $a2ab395c45579380$export$fbfb01485b140555 = 'render-selector';
const $a2ab395c45579380$var$Reveal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1gBibyk2o5 _0nFVCGb8VS _43vdfTN8t6 _3Y6bKpgRhm _1YKVNsdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: (0, $ieeJu.expValEquals)("platform_a11y_fixes_reactions_selector_list", "isEnabled", true) ? undefined : "li",
            xcss: $a2ab395c45579380$var$styles.emojiContainer
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            className: t1
        }, children));
        $[1] = children;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: (0, $ieeJu.expValEquals)('platform_a11y_fixes_reactions_selector_list', 'isEnabled', true) ? undefined : 'li',
        xcss: $a2ab395c45579380$var$styles.emojiContainer
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1gBibyk2o5 _0nFVCGb8VS _43vdfTN8t6 _3Y6bKpgRhm _1YKVNsdnbC"
        ])
    }, children));
}; /**
    * Reactions picker panel part of the <ReactionPicker /> component
    */ 
const $a2ab395c45579380$export$d15f4cd5286f9b1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { emojiProvider: emojiProvider, onMoreClick: onMoreClick, onSelection: onSelection, showMore: showMore, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, hoverableReactionPickerSelector: t1 } = t0;
    const hoverableReactionPickerSelector = t1 === undefined ? false : t1;
    const [isTeamojiPickerRefreshEnabled, setIsTeamojiPickerRefreshEnabled] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsTeamojiPickerRefreshEnabled((0, $ieeJu.expValEquals)("platform_teamoji_26_refresh_emoji_picker", "isEnabled", true));
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== isTeamojiPickerRefreshEnabled || $[3] !== pickerQuickReactionEmojiIds) {
        t4 = pickerQuickReactionEmojiIds ?? (0, $lbdYm.getDefaultReactions)(isTeamojiPickerRefreshEnabled);
        $[2] = isTeamojiPickerRefreshEnabled;
        $[3] = pickerQuickReactionEmojiIds;
        $[4] = t4;
    } else t4 = $[4];
    const quickReactionEmojiIds = t4;
    let t5;
    if ($[5] !== hoverableReactionPickerSelector) {
        t5 = hoverableReactionPickerSelector && (0, $4o0zT.isExperimentEnabled)("platform_a11y_reactions_hover_selector_list");
        $[5] = hoverableReactionPickerSelector;
        $[6] = t5;
    } else t5 = $[6];
    const shouldRenderHoverableReactionPickerSelectorList = t5;
    let t6;
    if ($[7] !== emojiProvider || $[8] !== hoverableReactionPickerSelector || $[9] !== onSelection || $[10] !== shouldRenderHoverableReactionPickerSelectorList) {
        t6 = (emoji, index)=>{
            const emojiButtonAndTooltip = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                key: emoji.id ?? emoji.shortName,
                content: emoji.shortName
            }, /*#__PURE__*/ $cozmU.createElement((0, $lStsD.EmojiButton), {
                emojiId: emoji,
                emojiProvider: emojiProvider,
                onClick: onSelection,
                hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelector
            }));
            return hoverableReactionPickerSelector ? shouldRenderHoverableReactionPickerSelectorList ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "li",
                key: emoji.id ?? emoji.shortName,
                xcss: $a2ab395c45579380$var$styles.emojiContainer
            }, emojiButtonAndTooltip) : emojiButtonAndTooltip : /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, {
                key: emoji.id ?? emoji.shortName,
                testId: $a2ab395c45579380$export$fbfb01485b140555
            }, emojiButtonAndTooltip);
        };
        $[7] = emojiProvider;
        $[8] = hoverableReactionPickerSelector;
        $[9] = onSelection;
        $[10] = shouldRenderHoverableReactionPickerSelectorList;
        $[11] = t6;
    } else t6 = $[11];
    const renderEmoji = t6;
    if (hoverableReactionPickerSelector) {
        let t7;
        if ($[12] !== onMoreClick) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $bih1Q.Trigger), {
                tooltipContent: (0, $jFWFL.messages).addReaction.defaultMessage,
                onClick: onMoreClick,
                showAddReactionText: true,
                reactionPickerTriggerText: (0, $jFWFL.messages).addNewReaction.defaultMessage,
                fullWidthSelectorTrayReactionPickerTrigger: true
            });
            $[12] = onMoreClick;
            $[13] = t7;
        } else t7 = $[13];
        const t8 = shouldRenderHoverableReactionPickerSelectorList ? "ul" : undefined;
        const t9 = shouldRenderHoverableReactionPickerSelectorList ? $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorList : $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer;
        let t10;
        if ($[14] !== quickReactionEmojiIds || $[15] !== renderEmoji) {
            t10 = quickReactionEmojiIds.map(renderEmoji);
            $[14] = quickReactionEmojiIds;
            $[15] = renderEmoji;
            $[16] = t10;
        } else t10 = $[16];
        let t11;
        if ($[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
            t11 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: t8,
                alignBlock: "center",
                xcss: t9
            }, t10);
            $[17] = t10;
            $[18] = t8;
            $[19] = t9;
            $[20] = t11;
        } else t11 = $[20];
        let t12;
        if ($[21] !== t11 || $[22] !== t7) {
            t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer
            }, t7, t11);
            $[21] = t11;
            $[22] = t7;
            $[23] = t12;
        } else t12 = $[23];
        return t12;
    }
    let t7;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $ieeJu.expValEquals)("platform_a11y_fixes_reactions_selector_list", "isEnabled", true);
        $[24] = t7;
    } else t7 = $[24];
    const isSelectorListMarkupFixEnabled = t7;
    let t8;
    if ($[25] !== quickReactionEmojiIds || $[26] !== renderEmoji) {
        t8 = quickReactionEmojiIds.map(renderEmoji);
        $[25] = quickReactionEmojiIds;
        $[26] = renderEmoji;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== onMoreClick || $[29] !== showMore) {
        t9 = showMore ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: isSelectorListMarkupFixEnabled ? undefined : "li",
            xcss: $a2ab395c45579380$var$styles.separator,
            "aria-hidden": isSelectorListMarkupFixEnabled ? true : undefined
        }), /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, null, /*#__PURE__*/ $cozmU.createElement((0, $15vr2.ShowMore), {
            key: "more",
            onClick: onMoreClick
        }))) : null;
        $[28] = onMoreClick;
        $[29] = showMore;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== t8 || $[32] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            xcss: $a2ab395c45579380$var$styles.container,
            as: isSelectorListMarkupFixEnabled ? undefined : "ul",
            role: isSelectorListMarkupFixEnabled ? "group" : undefined,
            "aria-label": isSelectorListMarkupFixEnabled ? (0, $jFWFL.messages).popperWrapperLabel.defaultMessage : undefined
        }, t8, t9);
        $[31] = t8;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ emojiProvider: emojiProvider, onMoreClick: onMoreClick, onSelection: onSelection, showMore: showMore, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, hoverableReactionPickerSelector: hoverableReactionPickerSelector = false })=>{
    const [isTeamojiPickerRefreshEnabled, setIsTeamojiPickerRefreshEnabled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsTeamojiPickerRefreshEnabled((0, $ieeJu.expValEquals)('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', true));
    }, []);
    const quickReactionEmojiIds = pickerQuickReactionEmojiIds ?? (0, $lbdYm.getDefaultReactions)(isTeamojiPickerRefreshEnabled);
    const shouldRenderHoverableReactionPickerSelectorList = hoverableReactionPickerSelector && (0, $4o0zT.isExperimentEnabled)('platform_a11y_reactions_hover_selector_list'); /**
                                                                                                                                                                  * Render the default emoji icon
                                                                                                                                                                  * @param emoji emoji item
                                                                                                                                                                  * @param index location of the emoji in the array
                                                                                                                                                                  */ 
    const renderEmoji = (emoji, index)=>{
        const emojiButtonAndTooltip = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            key: emoji.id ?? emoji.shortName,
            content: emoji.shortName
        }, /*#__PURE__*/ $cozmU.createElement((0, $lStsD.EmojiButton), {
            emojiId: emoji,
            emojiProvider: emojiProvider,
            onClick: onSelection,
            hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelector
        }));
        return hoverableReactionPickerSelector ? shouldRenderHoverableReactionPickerSelectorList ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            key: emoji.id ?? emoji.shortName,
            xcss: $a2ab395c45579380$var$styles.emojiContainer
        }, emojiButtonAndTooltip) : emojiButtonAndTooltip : /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, {
            key: emoji.id ?? emoji.shortName,
            testId: $a2ab395c45579380$export$fbfb01485b140555
        }, emojiButtonAndTooltip);
    };
    if (hoverableReactionPickerSelector) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $bih1Q.Trigger), {
        tooltipContent: (0, $jFWFL.messages).addReaction.defaultMessage,
        onClick: onMoreClick,
        showAddReactionText: true,
        reactionPickerTriggerText: (0, $jFWFL.messages).addNewReaction.defaultMessage,
        fullWidthSelectorTrayReactionPickerTrigger: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        as: shouldRenderHoverableReactionPickerSelectorList ? 'ul' : undefined,
        alignBlock: "center",
        xcss: shouldRenderHoverableReactionPickerSelectorList ? $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorList : $a2ab395c45579380$var$styles.hoverableReactionPickerSelectorContainer
    }, quickReactionEmojiIds.map(renderEmoji)));
    const isSelectorListMarkupFixEnabled = (0, $ieeJu.expValEquals)('platform_a11y_fixes_reactions_selector_list', 'isEnabled', true);
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $a2ab395c45579380$var$styles.container,
        as: isSelectorListMarkupFixEnabled ? undefined : 'ul',
        role: isSelectorListMarkupFixEnabled ? 'group' : undefined,
        "aria-label": isSelectorListMarkupFixEnabled ? (0, $jFWFL.messages).popperWrapperLabel.defaultMessage : undefined
    }, quickReactionEmojiIds.map(renderEmoji), showMore ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: isSelectorListMarkupFixEnabled ? undefined : 'li',
        xcss: $a2ab395c45579380$var$styles.separator,
        "aria-hidden": isSelectorListMarkupFixEnabled ? true : undefined
    }), /*#__PURE__*/ $cozmU.createElement($a2ab395c45579380$var$Reveal, null, /*#__PURE__*/ $cozmU.createElement((0, $15vr2.ShowMore), {
        key: "more",
        onClick: onMoreClick
    }))) : null);
};
module.exports["Selector"] = $a2ab395c45579380$export$d15f4cd5286f9b1e;

});

parcelRegister("lStsD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $l4yrE = parcelRequire("l4yrE");

var $6OpMl = parcelRequire("6OpMl");


var $cXtTj = parcelRequire("cXtTj");


var $jFWFL = parcelRequire("jFWFL");


var $3TY4f = parcelRequire("3TY4f");


var $lbdYm = parcelRequire("lbdYm");


var $hBYtq = parcelRequire("hBYtq");

const $a824af7beab19c72$var$styles = {
    emojiButton: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0bjKvDKxmn _2V7sgOdnbC _3iDTPbQ4SZ _0KLXru66of _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _1B4rbIOsGf _3NJLv8keKm",
    hoverableReactionPickerSelectorEmojiButton: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0yKXXaDGiX _0Of8r2FQfX _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0KLXru66of _1UtDYzZpcK _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _1eOmH6o126 _3gzVzLN4oS",
    emojiSlot: "_4ouGXISPN1",
    hoverableReactionPickerSelectorEmojiSlot: "_4ouGXIey7F"
};
const $a824af7beab19c72$export$116e2ec39db7c58e = 'button-emoji-id';
const $a824af7beab19c72$export$c42b68175913d473 = 'button-emoji-slot-id';
const $a824af7beab19c72$export$e6ce3311a4d41b7f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { emojiId: emojiId, onClick: onClick, emojiProvider: emojiProvider, hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelectorEmoji } = t0;
    let t1;
    if ($[0] !== emojiId || $[1] !== onClick) {
        t1 = (event)=>{
            event.preventDefault();
            if (onClick && (0, $3TY4f.isLeftClick)(event)) onClick(emojiId, undefined, event);
        };
        $[0] = emojiId;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onButtonClick = t1;
    const intl = (0, $kSwu1.useIntl)();
    const emojiHeight = hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : (0, $l4yrE.defaultEmojiHeight);
    const t2 = hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : undefined;
    let t3;
    if ($[3] !== emojiId || $[4] !== emojiProvider || $[5] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: t2
        });
        $[3] = emojiId;
        $[4] = emojiProvider;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const emoji = t3;
    let t4;
    if ($[7] !== emojiHeight || $[8] !== emojiId || $[9] !== emojiProvider || $[10] !== hoverableReactionPickerSelectorEmoji) {
        t4 = hoverableReactionPickerSelectorEmoji ? /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": $a824af7beab19c72$export$c42b68175913d473,
            className: (0, $hekY6.default)([
                $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiSlot
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: emojiHeight
        })) : /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": $a824af7beab19c72$export$c42b68175913d473,
            className: (0, $hekY6.default)([
                $a824af7beab19c72$var$styles.emojiSlot
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: emojiHeight
        }));
        $[7] = emojiHeight;
        $[8] = emojiId;
        $[9] = emojiProvider;
        $[10] = hoverableReactionPickerSelectorEmoji;
        $[11] = t4;
    } else t4 = $[11];
    const reservedEmoji = t4;
    let t5;
    if ($[12] !== emojiId.shortName || $[13] !== intl) {
        t5 = intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
            emoji: emojiId.shortName
        });
        $[12] = emojiId.shortName;
        $[13] = intl;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = hoverableReactionPickerSelectorEmoji ? $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiButton : $a824af7beab19c72$var$styles.emojiButton;
    let t7;
    if ($[15] !== emoji || $[16] !== reservedEmoji) {
        t7 = (0, $cXtTj.default).getExperimentValue("platform_teamoji_26_refresh_emoji_picker", "isEnabled", false) ? reservedEmoji : emoji;
        $[15] = emoji;
        $[16] = reservedEmoji;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== onButtonClick || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            testId: $a824af7beab19c72$export$116e2ec39db7c58e,
            onClick: onButtonClick,
            "aria-label": t5,
            xcss: t6
        }, t7);
        $[18] = onButtonClick;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ emojiId: emojiId, onClick: onClick, emojiProvider: emojiProvider, hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelectorEmoji })=>{
    const onButtonClick = (event)=>{
        event.preventDefault();
        if (onClick && (0, $3TY4f.isLeftClick)(event)) onClick(emojiId, undefined, event);
    };
    const intl = (0, $kSwu1.useIntl)();
    const emojiHeight = hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : (0, $l4yrE.defaultEmojiHeight);
    const emoji = /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: hoverableReactionPickerSelectorEmoji ? (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT) : undefined
    });
    const reservedEmoji = hoverableReactionPickerSelectorEmoji ? /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": $a824af7beab19c72$export$c42b68175913d473,
        className: (0, $hekY6.default)([
            $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiSlot
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: emojiHeight
    })) : /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": $a824af7beab19c72$export$c42b68175913d473,
        className: (0, $hekY6.default)([
            $a824af7beab19c72$var$styles.emojiSlot
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        fitToHeight: emojiHeight
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        testId: $a824af7beab19c72$export$116e2ec39db7c58e,
        onClick: onButtonClick,
        "aria-label": intl.formatMessage((0, $jFWFL.messages).reactWithEmoji, {
            emoji: emojiId.shortName
        }),
        xcss: hoverableReactionPickerSelectorEmoji ? $a824af7beab19c72$var$styles.hoverableReactionPickerSelectorEmojiButton : $a824af7beab19c72$var$styles.emojiButton
    }, (0, $cXtTj.default).getExperimentValue('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', false) ? reservedEmoji : emoji);
};
module.exports["EmojiButton"] = $a824af7beab19c72$export$e6ce3311a4d41b7f;

});

parcelRegister("15vr2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $lpNn5 = parcelRequire("lpNn5");


var $jFWFL = parcelRequire("jFWFL");

const $a5eeba0f96f1fb4c$export$3b6c19440cd8324b = 'show-more-button';
const $a5eeba0f96f1fb4c$export$ca7697601dcd7803 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).moreEmoji, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: message
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                label: message,
                onClick: onClick,
                testId: $a5eeba0f96f1fb4c$export$3b6c19440cd8324b,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                appearance: "subtle"
            })));
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jFWFL.messages).moreEmoji, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            label: message,
            onClick: onClick,
            testId: $a5eeba0f96f1fb4c$export$3b6c19440cd8324b,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
            appearance: "subtle"
        })));
};
module.exports["ShowMore"] = $a5eeba0f96f1fb4c$export$ca7697601dcd7803;

});

parcelRegister("bih1Q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $b35Wv = parcelRequire("b35Wv");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $k12R1 = parcelRequire("k12R1");


var $cozmU = parcelRequire("cozmU");

const $5a2af3b1f8e184d8$var$styles = {
    trigger: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _4ouGXIUofl _0jFU0VoWWg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    subtleTrigger: "_3hxITiYbGa _4ouGXIoWWg",
    expandedTrigger: "_4ouGXIoV4E",
    triggerStylesRefresh: "_0bjKvDKxmn",
    transparentEnabledTrigger: "_3vBAKH9r67 _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    opaqueEnabledTrigger: "_3vBAKH9r67 _0KLXrulfZc _1eOmH6d1Zr _3gzVzLJNoT",
    disabledTrigger: "_3vBAKHhQC5 _0KLXruVrZW",
    miniMode: "_0bjKvDKxmn _3hxITiYbGa _4ouGXIoWWg _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    fullWidthSummaryViewReactionPickerTrigger: "_39xV02N91d _0Of8r22ADO _2Zuz6Q2ADO _1Znuxb2ADO",
    fullWidthSelectorTrayReactionPickerTrigger: "_39xV02N91d _0Of8r21Y8M _2Zuz6Q1Y8M _1Znuxb1Y8M",
    fullWidth: "_39xV02N91d _1EqgXl5R67"
};
const $5a2af3b1f8e184d8$export$456835f64b911ea5 = 'render-tooltip-trigger';
const $5a2af3b1f8e184d8$export$4397a1ddb3e8d706 = 'render-trigger-button';
const $5a2af3b1f8e184d8$export$361f8ee5961b2075 = 'render-trigger-container';
const $5a2af3b1f8e184d8$export$2243b1861b17bb3b = 'render-list-item-wrapper';
const $5a2af3b1f8e184d8$var$i18n = (0, $kSwu1.defineMessages)({
    addReaction: {
        id: "reaction-picker-trigger.add.reaction.message",
        defaultMessage: "Add a reaction"
    }
});
const $5a2af3b1f8e184d8$var$addReactionStyles = {
    addReactionMessage: "_2sNsIg7NXe _1UtDYzZpcK _2XsHFM1Y8M"
};
const $5a2af3b1f8e184d8$var$noMarkerListStyle = null; /**
                                 * Render an emoji button to open the reactions select picker
                                 */ 
const $5a2af3b1f8e184d8$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(47);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onClick: onClick, miniMode: miniMode, tooltipContent: tooltipContent, disabled: t0, ariaAttributes: t1, showOpaqueBackground: t2, showAddReactionText: t3, subtleReactionsSummaryAndPicker: t4, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: t5, fullWidthSummaryViewReactionPickerTrigger: t6, isListItem: t7, fullWidthSelectorTrayReactionPickerTrigger: t8, emojiPickerSize: emojiPickerSize } = props;
    const disabled = t0 === undefined ? false : t0;
    let t9;
    if ($[0] !== t1) {
        t9 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t9;
    } else t9 = $[1];
    const ariaAttributes = t9;
    const showOpaqueBackground = t2 === undefined ? false : t2;
    const showAddReactionText = t3 === undefined ? false : t3;
    const subtleReactionsSummaryAndPicker = t4 === undefined ? false : t4;
    let t10;
    if ($[2] !== formatMessage || $[3] !== t5) {
        t10 = t5 === undefined ? formatMessage($5a2af3b1f8e184d8$var$i18n.addReaction) : t5;
        $[2] = formatMessage;
        $[3] = t5;
        $[4] = t10;
    } else t10 = $[4];
    const reactionPickerTriggerText = t10;
    const fullWidthSummaryViewReactionPickerTrigger = t6 === undefined ? false : t6;
    const isListItem = t7 === undefined ? false : t7;
    const fullWidthSelectorTrayReactionPickerTrigger = t8 === undefined ? false : t8;
    let t11;
    if ($[5] !== disabled || $[6] !== onClick) {
        t11 = (e, analyticsEvent)=>{
            if (onClick && !disabled) onClick(e, analyticsEvent);
        };
        $[5] = disabled;
        $[6] = onClick;
        $[7] = t11;
    } else t11 = $[7];
    const handleMouseDown = t11;
    let T0;
    let T1;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    if ($[8] !== ariaAttributes || $[9] !== disabled || $[10] !== emojiPickerSize || $[11] !== fullWidthSelectorTrayReactionPickerTrigger || $[12] !== fullWidthSummaryViewReactionPickerTrigger || $[13] !== handleMouseDown || $[14] !== isListItem || $[15] !== miniMode || $[16] !== reactionPickerTriggerIcon || $[17] !== reactionPickerTriggerText || $[18] !== ref || $[19] !== showAddReactionText || $[20] !== showOpaqueBackground || $[21] !== subtleReactionsSummaryAndPicker || $[22] !== tooltipContent) {
        const renderPressableButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                testId: $5a2af3b1f8e184d8$export$4397a1ddb3e8d706,
                xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && $5a2af3b1f8e184d8$var$styles.fullWidth, subtleReactionsSummaryAndPicker && $5a2af3b1f8e184d8$var$styles.subtleTrigger, showAddReactionText && $5a2af3b1f8e184d8$var$styles.expandedTrigger, disabled ? $5a2af3b1f8e184d8$var$styles.disabledTrigger : showOpaqueBackground ? $5a2af3b1f8e184d8$var$styles.opaqueEnabledTrigger : $5a2af3b1f8e184d8$var$styles.transparentEnabledTrigger, miniMode && $5a2af3b1f8e184d8$var$styles.miniMode, (0, $iDrrr.fg)("platform-component-visual-refresh") && $5a2af3b1f8e184d8$var$styles.triggerStylesRefresh),
                style: {
                    lineHeight: "16px"
                },
                onClick: handleMouseDown,
                isDisabled: disabled,
                ref: ref,
                "data-subtle": subtleReactionsSummaryAndPicker,
                "data-mini-mode": miniMode,
                ...ariaAttributes
            }, !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                testId: "emoji-add-icon",
                color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)",
                label: "Add reaction",
                "aria-hidden": true,
                size: emojiPickerSize === "small" ? "small" : "medium"
            }), showAddReactionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$addReactionStyles.addReactionMessage)
            }, reactionPickerTriggerText));
        T1 = (0, $iMnC5.Box);
        const t18 = fullWidthSummaryViewReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSummaryViewReactionPickerTrigger;
        const t19 = fullWidthSelectorTrayReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSelectorTrayReactionPickerTrigger;
        if ($[31] !== t18 || $[32] !== t19) {
            t16 = (0, $k12R1.cx)(t18, t19);
            $[31] = t18;
            $[32] = t19;
            $[33] = t16;
        } else t16 = $[33];
        t17 = $5a2af3b1f8e184d8$export$361f8ee5961b2075;
        T0 = (0, $lpNn5.default);
        t12 = $5a2af3b1f8e184d8$export$456835f64b911ea5;
        t13 = tooltipContent;
        if ($[34] !== showAddReactionText) {
            t14 = ()=>!showAddReactionText;
            $[34] = showAddReactionText;
            $[35] = t14;
        } else t14 = $[35];
        t15 = isListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            "data-testid": $5a2af3b1f8e184d8$export$2243b1861b17bb3b,
            className: (0, $hekY6.default)([
                "_1LMyvKYbGa"
            ])
        }, renderPressableButton()) : renderPressableButton();
        $[8] = ariaAttributes;
        $[9] = disabled;
        $[10] = emojiPickerSize;
        $[11] = fullWidthSelectorTrayReactionPickerTrigger;
        $[12] = fullWidthSummaryViewReactionPickerTrigger;
        $[13] = handleMouseDown;
        $[14] = isListItem;
        $[15] = miniMode;
        $[16] = reactionPickerTriggerIcon;
        $[17] = reactionPickerTriggerText;
        $[18] = ref;
        $[19] = showAddReactionText;
        $[20] = showOpaqueBackground;
        $[21] = subtleReactionsSummaryAndPicker;
        $[22] = tooltipContent;
        $[23] = T0;
        $[24] = T1;
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
        $[28] = t15;
        $[29] = t16;
        $[30] = t17;
    } else {
        T0 = $[23];
        T1 = $[24];
        t12 = $[25];
        t13 = $[26];
        t14 = $[27];
        t15 = $[28];
        t16 = $[29];
        t17 = $[30];
    }
    let t18;
    if ($[36] !== T0 || $[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t15) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            testId: t12,
            content: t13,
            canAppear: t14
        }, t15);
        $[36] = T0;
        $[37] = t12;
        $[38] = t13;
        $[39] = t14;
        $[40] = t15;
        $[41] = t18;
    } else t18 = $[41];
    let t19;
    if ($[42] !== T1 || $[43] !== t16 || $[44] !== t17 || $[45] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            xcss: t16,
            testId: t17
        }, t18);
        $[42] = T1;
        $[43] = t16;
        $[44] = t17;
        $[45] = t18;
        $[46] = t19;
    } else t19 = $[46];
    return t19;
} : (props, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onClick: onClick, miniMode: miniMode, tooltipContent: tooltipContent, disabled: disabled = false, ariaAttributes: ariaAttributes = {}, showOpaqueBackground: showOpaqueBackground = false, showAddReactionText: showAddReactionText = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText = formatMessage($5a2af3b1f8e184d8$var$i18n.addReaction), fullWidthSummaryViewReactionPickerTrigger: fullWidthSummaryViewReactionPickerTrigger = false, isListItem: isListItem = false, fullWidthSelectorTrayReactionPickerTrigger: fullWidthSelectorTrayReactionPickerTrigger = false, emojiPickerSize: emojiPickerSize } = props;
    const handleMouseDown = (e, analyticsEvent)=>{
        if (onClick && !disabled) onClick(e, analyticsEvent);
    };
    const renderPressableButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            testId: $5a2af3b1f8e184d8$export$4397a1ddb3e8d706,
            xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && $5a2af3b1f8e184d8$var$styles.fullWidth, subtleReactionsSummaryAndPicker && $5a2af3b1f8e184d8$var$styles.subtleTrigger, showAddReactionText && $5a2af3b1f8e184d8$var$styles.expandedTrigger, disabled ? $5a2af3b1f8e184d8$var$styles.disabledTrigger : showOpaqueBackground ? $5a2af3b1f8e184d8$var$styles.opaqueEnabledTrigger : $5a2af3b1f8e184d8$var$styles.transparentEnabledTrigger, miniMode && $5a2af3b1f8e184d8$var$styles.miniMode, (0, $iDrrr.fg)('platform-component-visual-refresh') && $5a2af3b1f8e184d8$var$styles.triggerStylesRefresh),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                lineHeight: '16px'
            },
            onClick: handleMouseDown,
            isDisabled: disabled,
            ref: ref,
            "data-subtle": subtleReactionsSummaryAndPicker,
            "data-mini-mode": miniMode,
            ...ariaAttributes
        }, !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon : // TODO: https://product-fabric.atlassian.net/browse/DSP-21007
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)",
            label: "Add reaction",
            "aria-hidden": true,
            size: emojiPickerSize === 'small' ? 'small' : 'medium'
        }), showAddReactionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $k12R1.cx)($5a2af3b1f8e184d8$var$addReactionStyles.addReactionMessage)
        }, reactionPickerTriggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)(fullWidthSummaryViewReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSummaryViewReactionPickerTrigger, fullWidthSelectorTrayReactionPickerTrigger && $5a2af3b1f8e184d8$var$styles.fullWidthSelectorTrayReactionPickerTrigger),
        testId: $5a2af3b1f8e184d8$export$361f8ee5961b2075
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        testId: $5a2af3b1f8e184d8$export$456835f64b911ea5,
        content: tooltipContent,
        canAppear: ()=>!showAddReactionText
    }, isListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        "data-testid": $5a2af3b1f8e184d8$export$2243b1861b17bb3b,
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa"
        ])
    }, renderPressableButton()) : renderPressableButton()));
});
module.exports["Trigger"] = $5a2af3b1f8e184d8$export$41fb9f06171c75f4;

});

parcelRegister("170Uc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $212e91376d92dc65$export$51eddd7655ca235a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, update: update, settings: settings } = t0;
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    let t1;
    if ($[0] !== update) {
        t1 = ()=>{
            if (isFirstRenderRef.current) {
                isFirstRenderRef.current = false;
                return;
            }
            update();
        };
        $[0] = update;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== settings || $[3] !== update) {
        t2 = [
            update,
            settings
        ];
        $[2] = settings;
        $[3] = update;
        $[4] = t2;
    } else t2 = $[4];
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[5] = children;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, update: update, settings: settings })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        settings
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["RepositionOnUpdate"] = $212e91376d92dc65$export$51eddd7655ca235a;

});

parcelRegister("5VUoE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5wHqn = parcelRequire("5wHqn");


var $ieeJu = parcelRequire("ieeJu");


var $af2XZ = parcelRequire("af2XZ");


var $4o0zT = parcelRequire("4o0zT");


var $6T1Vv = parcelRequire("6T1Vv");


var $j2uPw = parcelRequire("j2uPw");


var $bih1Q = parcelRequire("bih1Q");


var $bI8Le = parcelRequire("bI8Le");


var $97zIA = parcelRequire("97zIA");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

const $741d424eddcf1ce0$var$styles = {
    summaryPopup: "_0Of8r21Y8M _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _1EqgXll0GD",
    summaryList: "_0Of8r21Y8M _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _1EqgXll0GD _0aNu0LYbGa"
}; /**
    * Test id for the Reactions summary view popup
    */ 
const $741d424eddcf1ce0$export$55d575bd4bcbc45e = 'render-summary-view-popup';
const $741d424eddcf1ce0$export$d441f1c2eaaec099 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(85);
    const { emojiProvider: emojiProvider, reactions: t1, flash: t2, particleEffectByEmoji: t3, placement: t4, onReactionClick: onReactionClick, onReactionFocused: onReactionFocused, onReactionMouseEnter: onReactionMouseEnter, showOpaqueBackground: t5, subtleReactionsSummaryAndPicker: t6, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: t7, allowSelectFromSummaryView: allowSelectFromSummaryView, disabled: disabled, emojiPickerSize: emojiPickerSize, onSelection: onSelection, tooltipContent: tooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, onOpen: onOpen, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: t8, hoverableSummaryViewDelay: t9, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId } = t0;
    let t10;
    if ($[0] !== t1) {
        t10 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t10;
    } else t10 = $[1];
    const reactions = t10;
    let t11;
    if ($[2] !== t2) {
        t11 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t11;
    } else t11 = $[3];
    const flash = t11;
    let t12;
    if ($[4] !== t3) {
        t12 = t3 === undefined ? {} : t3;
        $[4] = t3;
        $[5] = t12;
    } else t12 = $[5];
    const particleEffectByEmoji = t12;
    const placement = t4 === undefined ? "auto-start" : t4;
    const showOpaqueBackground = t5 === undefined ? false : t5;
    const subtleReactionsSummaryAndPicker = t6 === undefined ? false : t6;
    const isViewOnly = t7 === undefined ? false : t7;
    const hoverableSummaryView = t8 === undefined ? false : t8;
    const hoverableSummaryViewDelay = t9 === undefined ? 300 : t9;
    const [isSummaryPopupOpen, setSummaryPopupOpen] = (0, $6T1Vv.useDelayedState)(false, hoverableSummaryViewDelay);
    const [isHoveringSummaryView, setIsHoveringSummaryView] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonHovered, setIsSummaryViewButtonHovered] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonClicked, setIsSummaryViewButtonClicked] = (0, $cozmU.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $cozmU.useState)(false);
    let t13;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (_id)=>{
            setIsEmojiPickerOpen(false);
            (0, $97zIA.PickerRender).abort({
                metadata: {
                    emojiId: _id,
                    source: "ReactionPicker",
                    reason: "close dialog"
                }
            });
        };
        $[6] = t13;
    } else t13 = $[6];
    const close = t13;
    let t14;
    if ($[7] !== onSelection) {
        t14 = (item)=>{
            if (!item.id) return;
            onSelection(item.id, "emojiPicker");
            close(item.id);
        };
        $[7] = onSelection;
        $[8] = t14;
    } else t14 = $[8];
    const onEmojiSelected = t14;
    let t15;
    if ($[9] !== setSummaryPopupOpen) {
        t15 = ()=>{
            setSummaryPopupOpen(false, true);
            setIsEmojiPickerOpen(false);
            setIsSummaryViewButtonClicked(false);
            setIsSummaryViewButtonHovered(false);
            setIsHoveringSummaryView(false);
        };
        $[9] = setSummaryPopupOpen;
        $[10] = t15;
    } else t15 = $[10];
    const handlePopupClose = t15;
    let t16;
    if ($[11] !== onOpen) {
        t16 = ()=>{
            (0, $97zIA.PickerRender).start();
            onOpen && onOpen();
            setIsEmojiPickerOpen(true);
            (0, $97zIA.PickerRender).success();
        };
        $[11] = onOpen;
        $[12] = t16;
    } else t16 = $[12];
    const openEmojiPicker = t16;
    let t17;
    if ($[13] !== openEmojiPicker || $[14] !== setSummaryPopupOpen) {
        t17 = ()=>{
            openEmojiPicker();
            setSummaryPopupOpen(false, true);
            setIsSummaryViewButtonClicked(false);
            setIsSummaryViewButtonHovered(false);
            setIsHoveringSummaryView(false);
        };
        $[13] = openEmojiPicker;
        $[14] = setSummaryPopupOpen;
        $[15] = t17;
    } else t17 = $[15];
    const handleEmojiPickerTriggerClick = t17;
    let t18;
    if ($[16] !== handlePopupClose || $[17] !== hoverableSummaryView || $[18] !== isEmojiPickerOpen || $[19] !== isSummaryPopupOpen || $[20] !== isSummaryViewButtonClicked || $[21] !== setSummaryPopupOpen) {
        t18 = ()=>{
            if (hoverableSummaryView) {
                setIsHoveringSummaryView(false);
                setIsSummaryViewButtonHovered(false);
                if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
                    setSummaryPopupOpen(false, true);
                    setIsSummaryViewButtonClicked(false);
                } else {
                    setSummaryPopupOpen(true, true);
                    setIsSummaryViewButtonClicked(true);
                }
                setIsEmojiPickerOpen(false);
            } else if (isSummaryPopupOpen) handlePopupClose();
            else setSummaryPopupOpen(true);
        };
        $[16] = handlePopupClose;
        $[17] = hoverableSummaryView;
        $[18] = isEmojiPickerOpen;
        $[19] = isSummaryPopupOpen;
        $[20] = isSummaryViewButtonClicked;
        $[21] = setSummaryPopupOpen;
        $[22] = t18;
    } else t18 = $[22];
    const handleSummaryClick = t18;
    let t19;
    if ($[23] !== hoverableSummaryView || $[24] !== isEmojiPickerOpen || $[25] !== setSummaryPopupOpen) {
        t19 = ()=>{
            setIsSummaryViewButtonHovered(true);
            if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
        };
        $[23] = hoverableSummaryView;
        $[24] = isEmojiPickerOpen;
        $[25] = setSummaryPopupOpen;
        $[26] = t19;
    } else t19 = $[26];
    const handleButtonMouseEnter = t19;
    let t20;
    if ($[27] !== hoverableSummaryView || $[28] !== isHoveringSummaryView || $[29] !== isSummaryViewButtonClicked || $[30] !== setSummaryPopupOpen) {
        t20 = ()=>{
            setIsSummaryViewButtonHovered(false);
            if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
        };
        $[27] = hoverableSummaryView;
        $[28] = isHoveringSummaryView;
        $[29] = isSummaryViewButtonClicked;
        $[30] = setSummaryPopupOpen;
        $[31] = t20;
    } else t20 = $[31];
    const handleButtonMouseLeave = t20;
    let t21;
    if ($[32] !== hoverableSummaryView || $[33] !== isEmojiPickerOpen || $[34] !== setSummaryPopupOpen) {
        t21 = ()=>{
            setIsHoveringSummaryView(true);
            if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
        };
        $[32] = hoverableSummaryView;
        $[33] = isEmojiPickerOpen;
        $[34] = setSummaryPopupOpen;
        $[35] = t21;
    } else t21 = $[35];
    const handleSummaryViewTrayMouseEnter = t21;
    let t22;
    if ($[36] !== hoverableSummaryView || $[37] !== isSummaryViewButtonClicked || $[38] !== isSummaryViewButtonHovered || $[39] !== setSummaryPopupOpen) {
        t22 = ()=>{
            setIsHoveringSummaryView(false);
            if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
        };
        $[36] = hoverableSummaryView;
        $[37] = isSummaryViewButtonClicked;
        $[38] = isSummaryViewButtonHovered;
        $[39] = setSummaryPopupOpen;
        $[40] = t22;
    } else t22 = $[40];
    const handleSummaryViewTrayMouseLeave = t22;
    let t23;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $4o0zT.isExperimentEnabled)("platform_a11y_reactions_hover_selector_list");
        $[41] = t23;
    } else t23 = $[41];
    const shouldRenderReactionSummaryList = t23;
    let t24;
    if ($[42] !== allowSelectFromSummaryView || $[43] !== allowUserDialog || $[44] !== disabled || $[45] !== emojiPickerSize || $[46] !== emojiProvider || $[47] !== flash || $[48] !== handleEmojiPickerTriggerClick || $[49] !== handleOpenReactionsDialog || $[50] !== handleSummaryViewTrayMouseEnter || $[51] !== handleSummaryViewTrayMouseLeave || $[52] !== isEmojiPickerOpen || $[53] !== isViewOnly || $[54] !== onEmojiSelected || $[55] !== onReactionClick || $[56] !== onReactionFocused || $[57] !== onReactionMouseEnter || $[58] !== particleEffectByEmoji || $[59] !== reactionPickerTriggerIcon || $[60] !== reactionPickerTriggerText || $[61] !== reactions || $[62] !== tooltipContent) {
        t24 = (t25)=>{
            const { update: recalculatePopupPosition } = t25;
            return isEmojiPickerOpen ? /*#__PURE__*/ $cozmU.createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: onEmojiSelected,
                size: emojiPickerSize
            }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                testId: $741d424eddcf1ce0$export$55d575bd4bcbc45e,
                onMouseEnter: handleSummaryViewTrayMouseEnter,
                onMouseLeave: handleSummaryViewTrayMouseLeave
            }, allowSelectFromSummaryView && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                testId: "reaction-summary-view-emoji-picker-container"
            }, /*#__PURE__*/ $cozmU.createElement((0, $bih1Q.Trigger), {
                disabled: disabled,
                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                tooltipContent: tooltipContent,
                onClick: ()=>{
                    handleEmojiPickerTriggerClick();
                    recalculatePopupPosition();
                },
                showAddReactionText: true,
                reactionPickerTriggerText: reactionPickerTriggerText,
                fullWidthSummaryViewReactionPickerTrigger: true
            })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: shouldRenderReactionSummaryList ? "ul" : undefined,
                xcss: shouldRenderReactionSummaryList ? $741d424eddcf1ce0$var$styles.summaryList : $741d424eddcf1ce0$var$styles.summaryPopup,
                space: "space.025",
                shouldWrap: true,
                alignBlock: "center"
            }, reactions.map((reaction)=>/*#__PURE__*/ $cozmU.createElement((0, $j2uPw.Reaction), {
                    key: reaction.emojiId,
                    rootElement: shouldRenderReactionSummaryList ? "li" : undefined,
                    reaction: reaction,
                    emojiProvider: emojiProvider,
                    onClick: onReactionClick,
                    onFocused: onReactionFocused,
                    onMouseEnter: onReactionMouseEnter,
                    flash: flash[reaction.emojiId],
                    showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                    allowUserDialog: allowUserDialog,
                    handleOpenReactionsDialog: handleOpenReactionsDialog,
                    isViewOnly: isViewOnly
                }))));
        };
        $[42] = allowSelectFromSummaryView;
        $[43] = allowUserDialog;
        $[44] = disabled;
        $[45] = emojiPickerSize;
        $[46] = emojiProvider;
        $[47] = flash;
        $[48] = handleEmojiPickerTriggerClick;
        $[49] = handleOpenReactionsDialog;
        $[50] = handleSummaryViewTrayMouseEnter;
        $[51] = handleSummaryViewTrayMouseLeave;
        $[52] = isEmojiPickerOpen;
        $[53] = isViewOnly;
        $[54] = onEmojiSelected;
        $[55] = onReactionClick;
        $[56] = onReactionFocused;
        $[57] = onReactionMouseEnter;
        $[58] = particleEffectByEmoji;
        $[59] = reactionPickerTriggerIcon;
        $[60] = reactionPickerTriggerText;
        $[61] = reactions;
        $[62] = tooltipContent;
        $[63] = t24;
    } else t24 = $[63];
    const t25 = isSummaryPopupOpen || isEmojiPickerOpen;
    let t26;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = (0, $ieeJu.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true);
        $[64] = t26;
    } else t26 = $[64];
    let t27;
    if ($[65] !== emojiProvider || $[66] !== handleButtonMouseEnter || $[67] !== handleButtonMouseLeave || $[68] !== handleSummaryClick || $[69] !== isEmojiPickerOpen || $[70] !== isSummaryPopupOpen || $[71] !== reactions || $[72] !== showOpaqueBackground || $[73] !== subtleReactionsSummaryAndPicker || $[74] !== summaryButtonIconAfter || $[75] !== summaryGetOptimisticImageURL || $[76] !== summaryViewParticleEffectEmojiId || $[77] !== useButtonAlignmentStyling) {
        t27 = (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $bI8Le.ReactionSummaryButton), {
                ...triggerProps,
                emojiProvider: emojiProvider,
                reactions: reactions,
                onClick: handleSummaryClick,
                onMouseEnter: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                showOpaqueBackground: showOpaqueBackground,
                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                useButtonAlignmentStyling: useButtonAlignmentStyling,
                summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                summaryButtonIconAfter: summaryButtonIconAfter,
                summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId,
                isOpen: isSummaryPopupOpen || isEmojiPickerOpen
            });
        $[65] = emojiProvider;
        $[66] = handleButtonMouseEnter;
        $[67] = handleButtonMouseLeave;
        $[68] = handleSummaryClick;
        $[69] = isEmojiPickerOpen;
        $[70] = isSummaryPopupOpen;
        $[71] = reactions;
        $[72] = showOpaqueBackground;
        $[73] = subtleReactionsSummaryAndPicker;
        $[74] = summaryButtonIconAfter;
        $[75] = summaryGetOptimisticImageURL;
        $[76] = summaryViewParticleEffectEmojiId;
        $[77] = useButtonAlignmentStyling;
        $[78] = t27;
    } else t27 = $[78];
    let t28;
    if ($[79] !== handlePopupClose || $[80] !== placement || $[81] !== t24 || $[82] !== t25 || $[83] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            placement: placement,
            content: t24,
            isOpen: t25,
            onClose: handlePopupClose,
            shouldRenderToParent: t26,
            trigger: t27
        });
        $[79] = handlePopupClose;
        $[80] = placement;
        $[81] = t24;
        $[82] = t25;
        $[83] = t27;
        $[84] = t28;
    } else t28 = $[84];
    return t28;
} : ({ emojiProvider: emojiProvider, reactions: reactions = [], flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, placement: placement = 'auto-start', onReactionClick: onReactionClick, onReactionFocused: onReactionFocused, onReactionMouseEnter: onReactionMouseEnter, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, allowSelectFromSummaryView: allowSelectFromSummaryView, disabled: disabled, emojiPickerSize: emojiPickerSize, onSelection: onSelection, tooltipContent: tooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, onOpen: onOpen, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, hoverableSummaryViewDelay: hoverableSummaryViewDelay = 300, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId })=>{
    const [isSummaryPopupOpen, setSummaryPopupOpen] = (0, $6T1Vv.useDelayedState)(false, hoverableSummaryViewDelay);
    const [isHoveringSummaryView, setIsHoveringSummaryView] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonHovered, setIsSummaryViewButtonHovered] = (0, $cozmU.useState)(false);
    const [isSummaryViewButtonClicked, setIsSummaryViewButtonClicked] = (0, $cozmU.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $cozmU.useState)(false); /**
                                                                               * Event callback when the picker is closed
                                                                               * @param _id Optional id if an emoji button was selected or undefined if was clicked outside the picker
                                                                               */ 
    const close = (0, $cozmU.useCallback)((_id)=>{
        setIsEmojiPickerOpen(false); // ufo abort reaction experience
        (0, $97zIA.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
    }, []); /**
           * Event callback when an emoji icon is selected
           * @param item selected item
           */ 
    const onEmojiSelected = (0, $cozmU.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, 'emojiPicker');
        close(item.id);
    }, [
        onSelection,
        close
    ]);
    const handlePopupClose = (0, $cozmU.useCallback)(()=>{
        setSummaryPopupOpen(false, true);
        setIsEmojiPickerOpen(false);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        setSummaryPopupOpen,
        setIsEmojiPickerOpen,
        setIsSummaryViewButtonClicked,
        setIsSummaryViewButtonHovered,
        setIsHoveringSummaryView
    ]);
    const openEmojiPicker = (0, $cozmU.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $97zIA.PickerRender).start();
        onOpen && onOpen(); // ufo reactions picker opened success
        setIsEmojiPickerOpen(true);
        (0, $97zIA.PickerRender).success();
    }, [
        onOpen
    ]);
    const handleEmojiPickerTriggerClick = (0, $cozmU.useCallback)(()=>{
        openEmojiPicker();
        setSummaryPopupOpen(false, true);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        openEmojiPicker,
        setSummaryPopupOpen
    ]);
    const handleSummaryClick = (0, $cozmU.useCallback)(()=>{
        if (hoverableSummaryView) {
            setIsHoveringSummaryView(false);
            setIsSummaryViewButtonHovered(false);
            if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
                // if either the emoji picker is open or the button was clicked, close the popup and reset the state
                setSummaryPopupOpen(false, true);
                setIsSummaryViewButtonClicked(false);
            } else {
                // if neither condition is true, open the popup and set the state
                setSummaryPopupOpen(true, true);
                setIsSummaryViewButtonClicked(true);
            } // close the emoji picker
            setIsEmojiPickerOpen(false);
        } else if (isSummaryPopupOpen) handlePopupClose();
        else setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        isEmojiPickerOpen,
        setSummaryPopupOpen,
        isSummaryPopupOpen,
        handlePopupClose,
        isSummaryViewButtonClicked,
        setIsSummaryViewButtonClicked
    ]);
    const handleButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsSummaryViewButtonHovered(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isEmojiPickerOpen
    ]);
    const handleButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsSummaryViewButtonHovered(false);
        if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isHoveringSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isSummaryViewButtonClicked
    ]);
    const handleSummaryViewTrayMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHoveringSummaryView(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsHoveringSummaryView,
        isEmojiPickerOpen
    ]);
    const handleSummaryViewTrayMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHoveringSummaryView(false);
        if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isSummaryViewButtonHovered,
        setIsHoveringSummaryView,
        setSummaryPopupOpen,
        isSummaryViewButtonClicked
    ]);
    const shouldRenderReactionSummaryList = (0, $4o0zT.isExperimentEnabled)('platform_a11y_reactions_hover_selector_list');
    return /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        placement: placement,
        content: ({ update: recalculatePopupPosition })=>isEmojiPickerOpen ? /*#__PURE__*/ $cozmU.createElement((0, $af2XZ.default), {
                emojiProvider: emojiProvider,
                onSelection: onEmojiSelected,
                size: emojiPickerSize
            }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                testId: $741d424eddcf1ce0$export$55d575bd4bcbc45e,
                onMouseEnter: handleSummaryViewTrayMouseEnter,
                onMouseLeave: handleSummaryViewTrayMouseLeave
            }, allowSelectFromSummaryView && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                testId: "reaction-summary-view-emoji-picker-container"
            }, /*#__PURE__*/ $cozmU.createElement((0, $bih1Q.Trigger), {
                disabled: disabled,
                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                tooltipContent: tooltipContent,
                onClick: ()=>{
                    handleEmojiPickerTriggerClick();
                    recalculatePopupPosition();
                },
                showAddReactionText: true,
                reactionPickerTriggerText: reactionPickerTriggerText,
                fullWidthSummaryViewReactionPickerTrigger: true
            })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: shouldRenderReactionSummaryList ? 'ul' : undefined,
                xcss: shouldRenderReactionSummaryList ? $741d424eddcf1ce0$var$styles.summaryList : $741d424eddcf1ce0$var$styles.summaryPopup,
                space: "space.025",
                shouldWrap: true,
                alignBlock: "center"
            }, reactions.map((reaction)=>{
                return /*#__PURE__*/ $cozmU.createElement((0, $j2uPw.Reaction), {
                    key: reaction.emojiId,
                    rootElement: shouldRenderReactionSummaryList ? 'li' : undefined,
                    reaction: reaction,
                    emojiProvider: emojiProvider,
                    onClick: onReactionClick,
                    onFocused: onReactionFocused,
                    onMouseEnter: onReactionMouseEnter,
                    flash: flash[reaction.emojiId],
                    showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                    allowUserDialog: allowUserDialog,
                    handleOpenReactionsDialog: handleOpenReactionsDialog,
                    isViewOnly: isViewOnly
                });
            }))),
        isOpen: isSummaryPopupOpen || isEmojiPickerOpen,
        onClose: handlePopupClose,
        shouldRenderToParent: (0, $ieeJu.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true),
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $bI8Le.ReactionSummaryButton), {
                ...triggerProps,
                emojiProvider: emojiProvider,
                reactions: reactions,
                onClick: handleSummaryClick,
                onMouseEnter: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                showOpaqueBackground: showOpaqueBackground,
                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                useButtonAlignmentStyling: useButtonAlignmentStyling,
                summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                summaryButtonIconAfter: summaryButtonIconAfter,
                summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId,
                isOpen: isSummaryPopupOpen || isEmojiPickerOpen
            })
    });
};
module.exports["ReactionSummaryView"] = $741d424eddcf1ce0$export$d441f1c2eaaec099;

});

parcelRegister("bI8Le", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6OpMl = parcelRequire("6OpMl");


var $jFWFL = parcelRequire("jFWFL");


var $lbdYm = parcelRequire("lbdYm");


var $9UzxD = parcelRequire("9UzxD");


var $3dtSX = parcelRequire("3dtSX");


var $e1UZX = parcelRequire("e1UZX");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $k12R1 = parcelRequire("k12R1");

const $c2486cdaea993b56$var$styles = {
    emoji: "_0yKXXaDGiX",
    button: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q2ADO",
    container: "_1mT5xdRAKS",
    summaryButtonIconAfter: "_1Znuxb2ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    emojiPlaceholderBackground: "_0KLXruGsB2",
    particleEffectContainer: "_1ZnuxbNHnM"
};
const $c2486cdaea993b56$export$bf8263842b2b0eb6 = 'reaction-summary-button'; /**
                                                                        * Test id for emojis displayed inside summary button. All emoji's in the summary button will have this test id
                                                                        */ 
const $c2486cdaea993b56$export$6adb00c908f27fce = 'summary-emoji-display'; // forwardRef is used here so that the parent popup component can properly interact with the button
const $c2486cdaea993b56$export$cc50c972184463a7 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(45);
    const { emojiProvider: emojiProvider, reactions: t1, emojisToShow: t2, onClick: onClick, showOpaqueBackground: t3, subtleReactionsSummaryAndPicker: t4, useButtonAlignmentStyling: t5, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId, isOpen: isOpen } = t0;
    let t6;
    if ($[0] !== t1) {
        t6 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t6;
    } else t6 = $[1];
    const reactions = t6;
    const emojisToShow = t2 === undefined ? 3 : t2;
    const showOpaqueBackground = t3 === undefined ? false : t3;
    const subtleReactionsSummaryAndPicker = t4 === undefined ? false : t4;
    const useButtonAlignmentStyling = t5 === undefined ? false : t5;
    const intl = (0, $kSwu1.useIntl)();
    const getTopReactions = $c2486cdaea993b56$var$_temp2;
    let t7;
    if ($[2] !== reactions) {
        t7 = reactions.reduce($c2486cdaea993b56$var$_temp3, 0);
        $[2] = reactions;
        $[3] = t7;
    } else t7 = $[3];
    const totalReactionsCount = t7;
    let t8;
    if ($[4] !== emojisToShow || $[5] !== reactions) {
        t8 = getTopReactions(reactions, emojisToShow);
        $[4] = emojisToShow;
        $[5] = reactions;
        $[6] = t8;
    } else t8 = $[6];
    const topReactions = t8;
    let t9;
    if ($[7] !== emojiProvider || $[8] !== summaryViewParticleEffectEmojiId) {
        t9 = summaryViewParticleEffectEmojiId && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c2486cdaea993b56$var$styles.particleEffectContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
            key: summaryViewParticleEffectEmojiId.id,
            emojiId: summaryViewParticleEffectEmojiId,
            emojiProvider: emojiProvider
        }));
        $[7] = emojiProvider;
        $[8] = summaryViewParticleEffectEmojiId;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== intl || $[11] !== totalReactionsCount) {
        t10 = intl.formatMessage((0, $jFWFL.messages).summary, {
            count: totalReactionsCount
        });
        $[10] = intl;
        $[11] = totalReactionsCount;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $k12R1.cx)($c2486cdaea993b56$var$styles.button);
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== emojiProvider || $[15] !== summaryGetOptimisticImageURL || $[16] !== topReactions) {
        let t13;
        if ($[18] !== emojiProvider || $[19] !== summaryGetOptimisticImageURL) {
            t13 = (reaction)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $c2486cdaea993b56$var$styles.emoji,
                    testId: $c2486cdaea993b56$export$6adb00c908f27fce,
                    style: {
                        lineHeight: "12px"
                    }
                }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
                    key: reaction.emojiId,
                    emojiProvider: emojiProvider,
                    emojiId: {
                        id: reaction.emojiId,
                        shortName: ""
                    },
                    fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
                    optimisticImageURL: summaryGetOptimisticImageURL?.(reaction.emojiId),
                    placeholderXcss: $c2486cdaea993b56$var$styles.emojiPlaceholderBackground
                }));
            $[18] = emojiProvider;
            $[19] = summaryGetOptimisticImageURL;
            $[20] = t13;
        } else t13 = $[20];
        t12 = topReactions.map(t13);
        $[14] = emojiProvider;
        $[15] = summaryGetOptimisticImageURL;
        $[16] = topReactions;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[21] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            xcss: t11,
            testId: "reaction-summary-wrapper"
        }, t12);
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== totalReactionsCount || $[24] !== useButtonAlignmentStyling) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
            value: totalReactionsCount,
            useDarkerFont: useButtonAlignmentStyling,
            useUpdatedStyles: useButtonAlignmentStyling
        });
        $[23] = totalReactionsCount;
        $[24] = useButtonAlignmentStyling;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== summaryButtonIconAfter) {
        t15 = summaryButtonIconAfter && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c2486cdaea993b56$var$styles.summaryButtonIconAfter
        }, summaryButtonIconAfter);
        $[26] = summaryButtonIconAfter;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== isOpen || $[29] !== onClick || $[30] !== onMouseEnter || $[31] !== onMouseLeave || $[32] !== showOpaqueBackground || $[33] !== subtleReactionsSummaryAndPicker || $[34] !== t10 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            testId: $c2486cdaea993b56$export$bf8263842b2b0eb6,
            ariaLabel: t10,
            ariaExpanded: isOpen,
            showSubtleStyle: subtleReactionsSummaryAndPicker,
            showOpaqueBackground: showOpaqueBackground
        }, t13, t14, t15);
        $[28] = isOpen;
        $[29] = onClick;
        $[30] = onMouseEnter;
        $[31] = onMouseLeave;
        $[32] = showOpaqueBackground;
        $[33] = subtleReactionsSummaryAndPicker;
        $[34] = t10;
        $[35] = t13;
        $[36] = t14;
        $[37] = t15;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== t16 || $[40] !== t9) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            alignInline: "center"
        }, t9, t16);
        $[39] = t16;
        $[40] = t9;
        $[41] = t17;
    } else t17 = $[41];
    let t18;
    if ($[42] !== ref || $[43] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $c2486cdaea993b56$var$styles.container,
            ref: ref,
            alignItems: "center",
            justifyContent: "center"
        }, t17);
        $[42] = ref;
        $[43] = t17;
        $[44] = t18;
    } else t18 = $[44];
    return t18;
} : ({ emojiProvider: emojiProvider, reactions: reactions = [], emojisToShow: emojisToShow = 3, onClick: onClick, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId, isOpen: isOpen }, ref)=>{
    const intl = (0, $kSwu1.useIntl)(); // Helper function to sort reactions by count and return top N
    const getTopReactions = (reactions_0, topN)=>{
        return [
            ...reactions_0
        ].sort((a, b)=>b.count - a.count).slice(0, topN);
    };
    const totalReactionsCount = (0, $cozmU.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count || 0;
        }, 0);
    }, [
        reactions
    ]);
    const topReactions = (0, $cozmU.useMemo)(()=>getTopReactions(reactions, emojisToShow), [
        emojisToShow,
        reactions
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $c2486cdaea993b56$var$styles.container,
        ref: ref,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        alignInline: "center"
    }, summaryViewParticleEffectEmojiId && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c2486cdaea993b56$var$styles.particleEffectContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $e1UZX.ReactionParticleEffect), {
        key: summaryViewParticleEffectEmojiId.id,
        emojiId: summaryViewParticleEffectEmojiId,
        emojiProvider: emojiProvider
    })), /*#__PURE__*/ $cozmU.createElement((0, $3dtSX.ReactionButton), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: $c2486cdaea993b56$export$bf8263842b2b0eb6,
        ariaLabel: intl.formatMessage((0, $jFWFL.messages).summary, {
            count: totalReactionsCount
        }),
        ariaExpanded: isOpen,
        showSubtleStyle: subtleReactionsSummaryAndPicker,
        showOpaqueBackground: showOpaqueBackground
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: (0, $k12R1.cx)($c2486cdaea993b56$var$styles.button),
        testId: "reaction-summary-wrapper"
    }, topReactions.map((reaction)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c2486cdaea993b56$var$styles.emoji,
            testId: $c2486cdaea993b56$export$6adb00c908f27fce,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                lineHeight: '12px'
            }
        }, /*#__PURE__*/ $cozmU.createElement((0, $6OpMl.default), {
            key: reaction.emojiId,
            emojiProvider: emojiProvider,
            emojiId: {
                id: reaction.emojiId,
                shortName: ''
            },
            fitToHeight: (0, $lbdYm.RESOURCED_EMOJI_COMPACT_HEIGHT),
            optimisticImageURL: summaryGetOptimisticImageURL?.(reaction.emojiId),
            placeholderXcss: $c2486cdaea993b56$var$styles.emojiPlaceholderBackground
        })))), /*#__PURE__*/ $cozmU.createElement((0, $9UzxD.Counter), {
        value: totalReactionsCount,
        useDarkerFont: useButtonAlignmentStyling,
        useUpdatedStyles: useButtonAlignmentStyling
    }), summaryButtonIconAfter && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c2486cdaea993b56$var$styles.summaryButtonIconAfter
    }, summaryButtonIconAfter))));
});
function $c2486cdaea993b56$var$_temp(a, b) {
    return b.count - a.count;
}
function $c2486cdaea993b56$var$_temp2(reactions_0, topN) {
    return [
        ...reactions_0
    ].sort($c2486cdaea993b56$var$_temp).slice(0, topN);
}
function $c2486cdaea993b56$var$_temp3(accum, current) {
    accum = accum + (current?.count || 0);
    return accum;
}
module.exports["ReactionSummaryButton"] = $c2486cdaea993b56$export$cc50c972184463a7;

});

parcelRegister("iF7Yl", function(module, exports) {
const $006c5a8383b762f1$var$MAUI_PERSONAL_READ_TOKEN_PATH = '/gateway/api/assist/rovo/v1/maui/media/personal-read-token';
async function $006c5a8383b762f1$export$c64afe9f7c18b7d9(productHeader, cloudId) {
    const response = await fetch($006c5a8383b762f1$var$MAUI_PERSONAL_READ_TOKEN_PATH, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'X-Product': productHeader,
            // Backend requires the site id; without it the request 400s and no image renders.
            ...cloudId ? {
                'X-Cloudid': cloudId
            } : {}
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch MAUI personal read token: ${response.status} ${response.statusText}`);
    const data = await response.json();
    return {
        token: data.token,
        collection: data.collection
    };
}
module.exports["fetchMauiPersonalReadToken"] = $006c5a8383b762f1$export$c64afe9f7c18b7d9;

});

parcelRegister("2WCju", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb5c0f58dd764150414ba5ddc93fd293>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $224eb7c825ef8980$var$_react = $224eb7c825ef8980$var$_interopRequireDefault((parcelRequire("cozmU")));

var $224eb7c825ef8980$var$_baseNew = $224eb7c825ef8980$var$_interopRequireDefault((parcelRequire("gElAV")));
function $224eb7c825ef8980$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Survey".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/survey
 * Usage guidance:
 * Reserved for surveys.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $224eb7c825ef8980$var$SurveyIcon = (props)=>/*#__PURE__*/ $224eb7c825ef8980$var$_react.default.createElement($224eb7c825ef8980$var$_baseNew.default, Object.assign({
        name: "SurveyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13 3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75V3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zm-7 7V12H4.5v-1.5zm5.5 0V12h-4v-1.5zM6 7.5V9H4.5V7.5zm5.5 0V9h-4V7.5zm-5-6A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5zm8 12.5a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2h1.065A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.935 1.5H12.5a2 2 0 0 1 2 2z"/>`
    }, props));
$224eb7c825ef8980$var$SurveyIcon.displayName = 'SurveyIcon';
var $224eb7c825ef8980$var$_default = module.exports.default = $224eb7c825ef8980$var$SurveyIcon;

});

parcelRegister("eKUiY", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $46ed75517425bf1b$var$messages = (0, $kSwu1.defineMessages)({
    generic: {
        id: "conversation-assistant-ui-components.survey-preview-card-error-message",
        defaultMessage: "We couldn't create the survey. Try again."
    },
    creationLimitExceeded: {
        id: "conversation-assistant-ui-components.survey-preview-card-error-creation-limit-exceeded",
        defaultMessage: "Survey limit reached in your current space. Delete an existing survey and try again."
    },
    titleTooLong: {
        id: "conversation-assistant-ui-components.survey-preview-card-error-title-too-long",
        defaultMessage: "This title exceeds the character limit. Ask Rovo to use a shorter name."
    },
    questionLimitExceeded: {
        id: "conversation-assistant-ui-components.survey-preview-card-error-question-limit-exceeded",
        defaultMessage: "Question limit reached. Ask Rovo to remove a few questions."
    },
    featureDisabled: {
        id: "conversation-assistant-ui-components.survey-preview-card-error-feature-disabled",
        defaultMessage: "The Surveys feature isn't turned on in your space. Ask your space admin to turn it on."
    },
    flagTitle: {
        id: "conversation-assistant-ui-components.survey-preview-card-error-flag-title",
        defaultMessage: "Couldn't create this survey"
    }
});
const $46ed75517425bf1b$var$errorKeyToMessage = {
    SURVEY_CREATION_LIMIT_EXCEEDED: $46ed75517425bf1b$var$messages.creationLimitExceeded,
    SURVEY_TITLE_TOO_LONG: $46ed75517425bf1b$var$messages.titleTooLong,
    SURVEY_QUESTION_LIMIT_EXCEEDED: $46ed75517425bf1b$var$messages.questionLimitExceeded,
    SURVEYS_FEATURE_DISABLED: $46ed75517425bf1b$var$messages.featureDisabled
};
class $46ed75517425bf1b$export$e3c3630e3a037e53 extends Error {
    constructor(errorKey, message){
        super(message);
        this.errorKey = void 0;
        this.errorKey = errorKey;
    }
}
const $46ed75517425bf1b$export$c51e115de6a27117 = (errorKey, formatMessage)=>{
    const descriptor = errorKey ? $46ed75517425bf1b$var$errorKeyToMessage[errorKey] ?? $46ed75517425bf1b$var$messages.generic : $46ed75517425bf1b$var$messages.generic;
    return {
        title: formatMessage($46ed75517425bf1b$var$messages.flagTitle),
        description: formatMessage(descriptor)
    };
};
const $46ed75517425bf1b$export$2a15a9d0ad1f086d = async (res)=>{
    let errorKey;
    let message;
    try {
        const json = await res.json();
        errorKey = json?.error;
        message = json?.message;
    } catch  {
        return null;
    }
    if (errorKey && typeof errorKey === 'string' && message && typeof message === 'string') return new $46ed75517425bf1b$export$e3c3630e3a037e53(errorKey, message);
    return null;
};
module.exports["SurveyApiError"] = $46ed75517425bf1b$export$e3c3630e3a037e53;
module.exports["getSurveyCreationFlagContent"] = $46ed75517425bf1b$export$c51e115de6a27117;
module.exports["parseSurveyApiError"] = $46ed75517425bf1b$export$2a15a9d0ad1f086d;

});

parcelRegister("irMkX", function(module, exports) {

let $d6e03e588895a344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6e03e588895a344$var$load("gdBVS").then(()=>parcelRequire('hBcFG'));

});

parcelRegister("lvJqX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_4bt5LAIZbP _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _1EqgXlhPwX _0NUa3rhPwX",
    rootStyles: "_3iDTPbvbI6 _1EqgXlN91d _4GplSjDF1i _2fqI0W7iY9",
    pressableStyles: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL4Pgdg _3iDTPbccYA _0KLXru66of _1UtDYzZpcK _1ANEUSLRg7 _1mT5xdRAKS _0hPCNLQame _1EqgXlN91d _0jFU0VIZbP _39xV02IZbP _1RrJLiQame _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_2bHMMpZFWO",
    confirmation: "_2bHMMpfyEX",
    info: "_2bHMMpTNil",
    warning: "_2bHMMpspgB",
    error: "_2bHMMp7j8z"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles
            }, children);
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $cEipP.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))));
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            className: t9
        }, t13);
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        onClose: onCloseDialog,
        content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles
            }, children),
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--popup`,
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $cEipP.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))))
    }));
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_1UtDYzZFWO",
    confirmation: "_1UtDYzfyEX",
    info: "_1UtDYzTNil",
    warning: "_1UtDYzspgB",
    error: "_1UtDYz7j8z"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_1UtDYzDF1i"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        spacing: spacing
    }));
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("j9QuA", function(module, exports) {
/**
 * Shared string token returned by the Confluence monolith in the body of a
 * 409 response when the destination space requires approval before publishing
 * new pages for the first time.
 *
 * The body is concatenated into `FetchError.message` by `performHttpFetch`,
 * so consumers detect this case via substring match rather than a structured
 * field.
 *
 * Backend contract (CCIMPORTER-3221): the response body includes
 * `"errorType": "APPROVAL_REQUIRED_FOR_FIRST_PUBLISH"`. This single source of
 * truth keeps the `conversation-assistant` and `rovo-platform-ui-components`
 * detection paths in sync if the token ever changes.
 */ const $c0a5cd9b85928de3$export$124fed4fc121a7b = 'APPROVAL_REQUIRED_FOR_FIRST_PUBLISH';
module.exports["APPROVAL_REQUIRED_FOR_FIRST_PUBLISH"] = $c0a5cd9b85928de3$export$124fed4fc121a7b;

});

parcelRegister("3xwCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119d33b234e3a9f5d46223e4e15d9b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293dc2808d336068$var$_react = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("cozmU")));

var $293dc2808d336068$var$_baseNew = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("gElAV")));
function $293dc2808d336068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293dc2808d336068$var$PencilIcon = (props)=>/*#__PURE__*/ $293dc2808d336068$var$_react.default.createElement($293dc2808d336068$var$_baseNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$293dc2808d336068$var$PencilIcon.displayName = 'PencilIcon';
var $293dc2808d336068$var$_default = module.exports.default = $293dc2808d336068$var$PencilIcon;

});

parcelRegister("dTzKN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KUOAT = parcelRequire("KUOAT");


var $hKlzx = parcelRequire("hKlzx");


var $2c3E0 = parcelRequire("2c3E0");

const $120813d45fd6ff30$export$a65b3bdf6438f574 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFileThumbnails(files) {
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const [blobUrls, setBlobUrls] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[1] = t1;
    } else t1 = $[1];
    const [previewErrors, setPreviewErrors] = (0, $cozmU.useState)(t1);
    const cacheFiles = $120813d45fd6ff30$var$_temp2;
    let cachedFileObjects;
    if ($[2] !== files) {
        cachedFileObjects = {};
        files.forEach((file_0)=>{
            if (file_0.id) {
                const sourceFile = (0, $2c3E0.fileCache).get(file_0.id);
                if (sourceFile) cachedFileObjects[file_0.id] = sourceFile;
            }
        });
        $[2] = files;
        $[3] = cachedFileObjects;
    } else cachedFileObjects = $[3];
    const fileObjects = cachedFileObjects;
    let loading;
    if ($[4] !== blobUrls || $[5] !== fileObjects || $[6] !== previewErrors) {
        loading = {};
        Object.keys(fileObjects).forEach((id)=>{
            loading[id] = !blobUrls[id] && !previewErrors[id];
        });
        $[4] = blobUrls;
        $[5] = fileObjects;
        $[6] = previewErrors;
        $[7] = loading;
    } else loading = $[7];
    const isLoading = loading;
    let t2;
    let t3;
    if ($[8] !== fileObjects) {
        t2 = ()=>{
            const fileIds = Object.keys(fileObjects);
            if (fileIds.length === 0) return;
            Promise.allSettled(fileIds.map(async (id_0)=>{
                const url = await (0, $KUOAT.generateFilePreview)(fileObjects[id_0]);
                return {
                    id: id_0,
                    url: url
                };
            })).then((results)=>{
                const urls = {};
                const errors = {};
                results.forEach((result, index)=>{
                    if (result.status === "fulfilled") urls[result.value.id] = result.value.url;
                    else {
                        const error = result.reason;
                        errors[fileIds[index]] = error instanceof Error ? error.message : String(error);
                    }
                });
                if (Object.keys(urls).length > 0) setBlobUrls(urls);
                if (Object.keys(errors).length > 0) setPreviewErrors(errors);
            });
        };
        t3 = [
            fileObjects
        ];
        $[8] = fileObjects;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[11] !== blobUrls) {
        t4 = ()=>()=>{
                Object.values(blobUrls).forEach($120813d45fd6ff30$var$_temp3);
            };
        t5 = [
            blobUrls
        ];
        $[11] = blobUrls;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[14] !== blobUrls || $[15] !== fileObjects || $[16] !== isLoading) {
        t6 = {
            cacheFiles: cacheFiles,
            blobUrls: blobUrls,
            isLoading: isLoading,
            fileObjects: fileObjects
        };
        $[14] = blobUrls;
        $[15] = fileObjects;
        $[16] = isLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : function useFileThumbnails(files) {
    const [blobUrls, setBlobUrls] = (0, $cozmU.useState)({});
    const [previewErrors, setPreviewErrors] = (0, $cozmU.useState)({});
    const cacheFiles = (0, $cozmU.useCallback)((filesToCache)=>{
        filesToCache.forEach((file)=>{
            if (file.fileObject.type.startsWith('image/') || file.fileObject.type === 'application/pdf' || (0, $hKlzx.isTextFile)(file.fileObject.type, file.fileObject.name)) (0, $2c3E0.fileCache).set(file.id, file.fileObject);
        });
    }, []);
    const fileObjects = (0, $cozmU.useMemo)(()=>{
        const cachedFileObjects = {};
        files.forEach((file_0)=>{
            if (file_0.id) {
                const sourceFile = (0, $2c3E0.fileCache).get(file_0.id);
                if (sourceFile) cachedFileObjects[file_0.id] = sourceFile;
            }
        });
        return cachedFileObjects;
    }, [
        files
    ]);
    const isLoading = (0, $cozmU.useMemo)(()=>{
        const loading = {};
        Object.keys(fileObjects).forEach((id)=>{
            loading[id] = !blobUrls[id] && !previewErrors[id];
        });
        return loading;
    }, [
        fileObjects,
        blobUrls,
        previewErrors
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fileIds = Object.keys(fileObjects);
        if (fileIds.length === 0) return;
        Promise.allSettled(fileIds.map(async (id_0)=>{
            const url = await (0, $KUOAT.generateFilePreview)(fileObjects[id_0]);
            return {
                id: id_0,
                url: url
            };
        })).then((results)=>{
            const urls = {};
            const errors = {};
            results.forEach((result, index)=>{
                if (result.status === 'fulfilled') urls[result.value.id] = result.value.url;
                else {
                    const error = result.reason;
                    errors[fileIds[index]] = error instanceof Error ? error.message : String(error);
                }
            });
            if (Object.keys(urls).length > 0) setBlobUrls(urls);
            if (Object.keys(errors).length > 0) setPreviewErrors(errors);
        });
    }, [
        fileObjects
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            Object.values(blobUrls).forEach((url_0)=>{
                if (url_0) URL.revokeObjectURL(url_0);
            });
        };
    }, [
        blobUrls
    ]);
    return {
        cacheFiles: cacheFiles,
        blobUrls: blobUrls,
        isLoading: isLoading,
        fileObjects: fileObjects
    };
};
function $120813d45fd6ff30$var$_temp3(url_0) {
    if (url_0) URL.revokeObjectURL(url_0);
}
function $120813d45fd6ff30$var$_temp2(filesToCache) {
    filesToCache.forEach($120813d45fd6ff30$var$_temp);
}
function $120813d45fd6ff30$var$_temp(file) {
    if (file.fileObject.type.startsWith("image/") || file.fileObject.type === "application/pdf" || (0, $hKlzx.isTextFile)(file.fileObject.type, file.fileObject.name)) (0, $2c3E0.fileCache).set(file.id, file.fileObject);
}
module.exports["useFileThumbnails"] = $120813d45fd6ff30$export$a65b3bdf6438f574;

});

parcelRegister("bY61u", function(module, exports) {
/**
 * Hook to check whether the Rovo Insights feature is available for the current user.
 *
 * Uses RovoInsightsService (extends AssistanceServiceBase) so that Rovo Insights
 * concerns stay out of the general-purpose AssistanceService.
 */ 
var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $4pKRH = parcelRequire("4pKRH");

const $ccf10fb413687b05$var$FRESHNESS_WINDOW_MS = 172800000;
const $ccf10fb413687b05$var$isGeneratedAtFresh = (generatedAt)=>{
    if (!generatedAt) return false;
    const generatedAtTime = new Date(generatedAt).getTime();
    if (Number.isNaN(generatedAtTime)) return false;
    return Date.now() - generatedAtTime < $ccf10fb413687b05$var$FRESHNESS_WINDOW_MS;
};
const $ccf10fb413687b05$export$d191a72e03ff3705 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled })=>{
    const insightsService = (0, $cozmU.useMemo)(()=>{
        const config = assistanceService.getConfig();
        return new (0, $4pKRH.RovoInsightsService)(config);
    }, [
        assistanceService
    ]);
    const { data: data, isFetching: isFetching, error: error } = (0, $5SS4O.useQuery)({
        queryKey: [
            'insightsStatus'
        ],
        enabled: enabled,
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS,
                name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS
            });
            try {
                const response = await insightsService.getInsightsStatus();
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS
                });
                return response;
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        }
    });
    // `success` means the fetch settled with data; a null `data` (no error) is still
    // pending, regardless of the transient `isFetching` flag — otherwise a no-data
    // window could mislabel as `success` and lock in a wrong reason via the fire-once ref.
    const statusFetchState = !enabled ? 'disabled' : error ? 'error' : data === null ? 'loading' : 'success';
    return {
        isInsightsAvailable: Boolean(data?.insights_available),
        isLoading: isFetching && data === null,
        generatedAt: data?.generated_at,
        isFresh: $ccf10fb413687b05$var$isGeneratedAtFresh(data?.generated_at),
        statusFetchState: statusFetchState
    };
});
module.exports["useInsightsStatus"] = $ccf10fb413687b05$export$d191a72e03ff3705;

});

parcelRegister("59lLN", function(module, exports) {
/**
 * `usePinnedItems` — the pinned-items data layer for the "For You" tab and the Search page.
 *
 * Built on the shared `useQuery` cache (the same primitive backing `useListSpaces`,
 * `useGetSpace`, etc. — see `@atlassian/conversation-assistant-service/common/utils/use-query`)
 * rather than a React Context provider. The cache is keyed by `cloudId`/`product`, not by
 * where in the component tree this hook is called from, so `PinnedWorkSection` (on the "Your
 * Work" tab) and `RecentWorkResults` (on the Search page) share the same list without any
 * shared ancestor — whichever surface the user opens first triggers the fetch; the other gets
 * a cache hit. `pin`/`unpin` update that same cache entry directly (via `updateCache`) rather
 * than triggering a refetch, so both surfaces reflect a mutation immediately.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5SS4O = parcelRequire("5SS4O");

/**
 * `POST /gateway/api/assist/rovo/v1/pins`. Mirrors the `rovo-spaces` fetch-file convention (see
 * `useCreateSpace.fetch.ts`): `credentials: 'include'` so the existing authenticated session
 * cookie is sent — this endpoint is never called anonymously.
 */ 
var $jTKfH = parcelRequire("jTKfH");

const $7b670578dd40dc1d$var$PINS_API_PATH = '/gateway/api/assist/rovo/v1/pins';
// Fixed per rovo-for-you/for-you-panel's own convention for this surface — see e.g.
// `useInsightsStatus`'s `experienceId: 'ai-mate'` call in for-you-panel/index.tsx.
const $7b670578dd40dc1d$var$EXPERIENCE_ID = 'ai-mate';
const $7b670578dd40dc1d$export$ac3b53eef2dc4cbd = ({ request: request, cloudId: cloudId, product: product })=>(0, $jTKfH.performHttpFetch)({
        path: $7b670578dd40dc1d$var$PINS_API_PATH,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product ?? '',
                'x-experience-id': $7b670578dd40dc1d$var$EXPERIENCE_ID
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }
    });


/**
 * `DELETE /gateway/api/assist/rovo/v1/pins/:pinId`. Mirrors the `rovo-spaces` fetch-file
 * convention (see `useDeleteSpace.fetch.ts`): `credentials: 'include'` so the existing
 * authenticated session cookie is sent, and raw `fetch` rather than `performHttpFetch` —
 * `performHttpFetch` unconditionally calls `response.json()`, which throws on the bodyless
 * response a DELETE typically returns.
 */ 


const $4a568ab29ea51feb$var$PINS_API_PATH = '/gateway/api/assist/rovo/v1/pins';
// Fixed per rovo-for-you/for-you-panel's own convention for this surface — see e.g.
// `useInsightsStatus`'s `experienceId: 'ai-mate'` call in for-you-panel/index.tsx.
const $4a568ab29ea51feb$var$EXPERIENCE_ID = 'ai-mate';
const $4a568ab29ea51feb$var$getDeletePinPath = (pinId)=>`${$4a568ab29ea51feb$var$PINS_API_PATH}/${pinId}`;
const $4a568ab29ea51feb$export$2d8697f327018d9c = async ({ pinId: pinId, cloudId: cloudId, product: product })=>{
    const path = $4a568ab29ea51feb$var$getDeletePinPath(pinId);
    let response;
    try {
        response = await fetch(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product ?? '',
                'x-experience-id': $4a568ab29ea51feb$var$EXPERIENCE_ID
            },
            credentials: 'include'
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`deletePinFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'deletePinFetchError'
        });
    }
    if (!response.ok) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`deletePinFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'deletePinFetchError',
            statusCode: response.status
        });
    }
};


/**
 * `GET /gateway/api/assist/rovo/v1/pins`. Mirrors the `rovo-spaces` fetch-file convention (see
 * `useListSpaces.fetch.ts`'s `SPACES_API_PATH`): `credentials: 'include'` so the existing
 * authenticated session cookie is sent — this endpoint is never called anonymously.
 */ 


const $9a2b17f140961f57$var$PINS_API_PATH = '/gateway/api/assist/rovo/v1/pins';
// Fixed per rovo-for-you/for-you-panel's own convention for this surface — see e.g.
// `useInsightsStatus`'s `experienceId: 'ai-mate'` call in for-you-panel/index.tsx.
const $9a2b17f140961f57$var$EXPERIENCE_ID = 'ai-mate';
const $9a2b17f140961f57$export$fd92ca452bab9262 = ({ cloudId: cloudId, product: product })=>(0, $jTKfH.performHttpFetch)({
        path: $9a2b17f140961f57$var$PINS_API_PATH,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product ?? '',
                'x-experience-id': $9a2b17f140961f57$var$EXPERIENCE_ID
            },
            credentials: 'include'
        }
    }).then((response)=>response.data);


// Mirrors the real API's 100-pin/user limit, enforced client-side too.
const $ede605f972a2125c$var$MAX_PINNED_ITEMS = 100;
/** Falls back to the last path segment of a pin's URL when the backend has no name for
 * it (`Pin.name` is nullable), rather than showing the full URL. */ const $ede605f972a2125c$var$deriveNameFromUrl = (url)=>{
    try {
        const segments = new URL(url).pathname.split('/').filter(Boolean);
        return segments[segments.length - 1] ?? url;
    } catch  {
        return url;
    }
};
const $ede605f972a2125c$var$toPinnedItem = (pin)=>({
        id: pin.id,
        ari: pin.ari,
        url: pin.url,
        pinType: pin.pinType,
        name: pin.name ?? $ede605f972a2125c$var$deriveNameFromUrl(pin.url)
    });
function $ede605f972a2125c$export$cfeef9889d6a8860({ cloudId: cloudId, product: product }) {
    // The backend rejects every pins request with no product ("Unknown product. product=")
    // — skip the call entirely rather than firing a request guaranteed to 400. Hosts that
    // don't set a product (e.g. `ForYouPanelProps.product` is optional) just see an empty,
    // non-loading pinned list instead of a failed fetch.
    const hasProduct = Boolean(product);
    const { data: pins, isFetching: isLoading, updateCache: updateCache } = (0, $5SS4O.useQuery)({
        queryKey: [
            'rovo-pins:listPins',
            cloudId,
            product ?? ''
        ],
        queryFn: ()=>(0, $9a2b17f140961f57$export$fd92ca452bab9262)({
                cloudId: cloudId,
                product: product
            }),
        enabled: hasProduct
    });
    const rawPins = pins ?? [];
    // `pin`/`unpin` read from this ref rather than `rawPins` directly. `rawPins` is a
    // render-time snapshot — calling `pin()` twice in quick succession (before React has
    // re-rendered with the first mutation's `updateCache` result) would otherwise compute the
    // second mutation from a stale, pre-first-mutation list and clobber it. The ref is updated
    // synchronously inside `pin`/`unpin` themselves, and mirrors `pins` via effect for changes
    // from outside (the initial fetch, or a mutation from another `usePinnedItems` call sharing
    // this same cache entry). Depends on `pins` (the query's own stable value), not the derived
    // `rawPins` — `rawPins` is a fresh `?? []` fallback on every render while `pins` is still
    // null, which would otherwise re-run this effect every render for no reason.
    const latestPinsRef = (0, $cozmU.useRef)(rawPins);
    (0, $cozmU.useEffect)(()=>{
        latestPinsRef.current = pins ?? [];
    }, [
        pins
    ]);
    /**
   * Pins an item via the real create endpoint, using the backend-assigned `id`. Moves it to
   * the top if its `ari` is already pinned instead of duplicating it, capped at
   * `MAX_PINNED_ITEMS`. Leaves the cache unchanged on failure, so a failed pin doesn't show
   * as pinned locally when the backend never persisted it.
   */ const pin = (0, $cozmU.useCallback)(async (item)=>{
        if (!hasProduct) return;
        let created;
        try {
            created = await (0, $7b670578dd40dc1d$export$ac3b53eef2dc4cbd)({
                request: {
                    ari: item.ari,
                    url: item.url,
                    pinType: item.pinType,
                    name: item.name
                },
                cloudId: cloudId,
                product: product
            });
        } catch  {
            return;
        }
        // `created.name` is always null on create (see createPinFetch.ts) — fall back to the
        // name the user already saw when they clicked pin, rather than showing a
        // URL-derived name until the next full list refetch resolves it.
        const cached = {
            ...created,
            name: created.name ?? item.name
        };
        const withoutExisting = latestPinsRef.current.filter((existing)=>existing.ari !== item.ari);
        const next = [
            cached,
            ...withoutExisting
        ].slice(0, $ede605f972a2125c$var$MAX_PINNED_ITEMS);
        latestPinsRef.current = next;
        updateCache(next);
    }, [
        cloudId,
        product,
        hasProduct,
        updateCache
    ]);
    /** Unpins the item with the given `ari` via the real delete endpoint. No-op if the ari
   * isn't currently pinned, or the delete fails. */ const unpin = (0, $cozmU.useCallback)(async (ari)=>{
        if (!hasProduct) return;
        const target = latestPinsRef.current.find((existing)=>existing.ari === ari);
        if (!target) return;
        try {
            await (0, $4a568ab29ea51feb$export$2d8697f327018d9c)({
                pinId: target.id,
                cloudId: cloudId,
                product: product
            });
        } catch  {
            return;
        }
        const next = latestPinsRef.current.filter((existing)=>existing.ari !== ari);
        latestPinsRef.current = next;
        updateCache(next);
    }, [
        cloudId,
        product,
        hasProduct,
        updateCache
    ]);
    return {
        items: rawPins.map($ede605f972a2125c$var$toPinnedItem),
        isLoading: isLoading,
        pin: pin,
        unpin: unpin
    };
}
module.exports["usePinnedItems"] = $ede605f972a2125c$export$cfeef9889d6a8860;

});

parcelRegister("ieYVG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $7vAVv = parcelRequire("7vAVv");


var $6CsCB = parcelRequire("6CsCB");


var $iFXu4 = parcelRequire("iFXu4");

/**
 * Accessible labels for each entity type's icon. Single source of truth for the type label copy,
 * shared by every surface that renders a type icon (pinned rows on the For You page and the Your
 * Work search results).
 */ const $6aeac8b77ad3e1eb$var$messages = (0, $kSwu1.defineMessages)({
    epicLabel: {
        id: "rovo-pins.typeIconConfig.epicLabel",
        defaultMessage: "Epic"
    },
    goalLabel: {
        id: "rovo-pins.typeIconConfig.goalLabel",
        defaultMessage: "Goal"
    },
    projectLabel: {
        id: "rovo-pins.typeIconConfig.projectLabel",
        defaultMessage: "Project"
    }
});
const $6aeac8b77ad3e1eb$export$1d8638a022066e61 = {
    JiraIssue: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)",
        label: $6aeac8b77ad3e1eb$var$messages.epicLabel
    },
    AtlasProject: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))),
        color: "var(--ds-icon-accent-blue, #357DE8)",
        label: $6aeac8b77ad3e1eb$var$messages.projectLabel
    },
    AtlasGoal: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6CsCB))),
        color: "var(--ds-icon-accent-gray, #7D818A)",
        label: $6aeac8b77ad3e1eb$var$messages.goalLabel
    }
};
module.exports["TYPE_ICON_CONFIG"] = $6aeac8b77ad3e1eb$export$1d8638a022066e61;

});

parcelRegister("dQeg1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d16476b5ca40ef7b1045035dfd6777a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a13b30eb29a7bdd5$var$_react = $a13b30eb29a7bdd5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a13b30eb29a7bdd5$var$_baseNew = $a13b30eb29a7bdd5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a13b30eb29a7bdd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeChapters".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-chapters
 * Usage guidance:
 * Reserved for auto chapters functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a13b30eb29a7bdd5$var$AiGenerativeChaptersIcon = (props)=>/*#__PURE__*/ $a13b30eb29a7bdd5$var$_react.default.createElement($a13b30eb29a7bdd5$var$_baseNew.default, Object.assign({
        name: "AiGenerativeChaptersIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.5v10h5.75V14H1.375C.615 14 0 13.384 0 12.625V2.375C0 1.617.613 1 1.374 1h3.5A3.87 3.87 0 0 1 8 2.583 3.87 3.87 0 0 1 11.125 1h3.5C15.387 1 16 1.62 16 2.376V8.25h-1.5V2.5h-3.375A2.375 2.375 0 0 0 8.75 4.875V10h-1.5V4.875A2.375 2.375 0 0 0 4.875 2.5zM13.25 6H10.5V4.5h2.75zM2.75 4.5H5.5V6H2.75zm0 2.5H5.5v1.5H2.75zm9.045 2.494a.75.75 0 0 1 1.41 0l.614 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/>`
    }, props));
$a13b30eb29a7bdd5$var$AiGenerativeChaptersIcon.displayName = 'AiGenerativeChaptersIcon';
var $a13b30eb29a7bdd5$var$_default = module.exports.default = $a13b30eb29a7bdd5$var$AiGenerativeChaptersIcon;

});

parcelRegister("jXbuX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ea38671faf140bcc11c82d58d78ecbd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e86c725a407358ea$var$_react = $e86c725a407358ea$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e86c725a407358ea$var$_baseNew = $e86c725a407358ea$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e86c725a407358ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sunset
 * Usage guidance:
 * Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e86c725a407358ea$var$SunsetIcon = (props)=>/*#__PURE__*/ $e86c725a407358ea$var$_react.default.createElement($e86c725a407358ea$var$_baseNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$e86c725a407358ea$var$SunsetIcon.displayName = 'SunsetIcon';
var $e86c725a407358ea$var$_default = module.exports.default = $e86c725a407358ea$var$SunsetIcon;

});

parcelRegister("8V8zt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $ivSJV = parcelRequire("ivSJV");

const $9f4445173e17ab12$export$bbe9fefbd7814f35 = 3;
const $9f4445173e17ab12$var$styles = {
    outerContainer: "_3iDTPbccYA _0hPCNLDIqT",
    overflowCount: "_2xTnZx1Y8M",
    container: "_3iDTPbccYA _0hPCNLDIqT _1mT5xdRAKS",
    logoWrapper: "_1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _0GTcwR4F84",
    firstLogo: "_0GTcwRLl21",
    logo: "_0bjKvDKTcp _2V7sgO2M4S _3hxITi6wH8 _3vBAKHxCOs _39xV02SPN1 _0jFU0VSPN1"
};
const $9f4445173e17ab12$export$3b2450ab8d88608 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { sources: sources, hideOverflowCount: t1 } = t0;
    const hideOverflowCount = t1 === undefined ? false : t1;
    if (sources.length === 0) return null;
    let T0;
    let T1;
    let overflowCount;
    let t2;
    let t3;
    let t4;
    if ($[0] !== sources) {
        const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $ivSJV.getSourceType))));
        const visibleSourceTypes = allUniqueSourceTypes.slice(0, $9f4445173e17ab12$export$bbe9fefbd7814f35);
        overflowCount = sources.length - visibleSourceTypes.length;
        T1 = (0, $iMnC5.Box);
        t4 = $9f4445173e17ab12$var$styles.outerContainer;
        T0 = (0, $iMnC5.Box);
        t2 = $9f4445173e17ab12$var$styles.container;
        t3 = visibleSourceTypes.map((sourceType, index)=>{
            const Logo = (0, $ivSJV.getLogoForSourceType)(sourceType);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: sourceType,
                xcss: (0, $w6R6I.cx)($9f4445173e17ab12$var$styles.logoWrapper, index === 0 && $9f4445173e17ab12$var$styles.firstLogo),
                style: {
                    zIndex: visibleSourceTypes.length - index
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $9f4445173e17ab12$var$styles.logo
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
                size: "xxsmall",
                shouldUseNewLogoDesign: true
            })));
        });
        $[0] = sources;
        $[1] = T0;
        $[2] = T1;
        $[3] = overflowCount;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[1];
        T1 = $[2];
        overflowCount = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t2 || $[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t2
        }, t3);
        $[7] = T0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== hideOverflowCount || $[12] !== overflowCount) {
        t6 = !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9f4445173e17ab12$var$styles.overflowCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, "+", overflowCount));
        $[11] = hideOverflowCount;
        $[12] = overflowCount;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== T1 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            xcss: t4
        }, t5, t6);
        $[14] = T1;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ sources: sources, hideOverflowCount: hideOverflowCount = false })=>{
    if (sources.length === 0) return null;
    const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $ivSJV.getSourceType))));
    const visibleSourceTypes = allUniqueSourceTypes.slice(0, $9f4445173e17ab12$export$bbe9fefbd7814f35);
    const overflowCount = sources.length - visibleSourceTypes.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9f4445173e17ab12$var$styles.outerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9f4445173e17ab12$var$styles.container
    }, visibleSourceTypes.map((sourceType, index)=>{
        const Logo = (0, $ivSJV.getLogoForSourceType)(sourceType);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: sourceType,
            xcss: (0, $w6R6I.cx)($9f4445173e17ab12$var$styles.logoWrapper, index === 0 && $9f4445173e17ab12$var$styles.firstLogo),
            style: {
                zIndex: visibleSourceTypes.length - index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9f4445173e17ab12$var$styles.logo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        })));
    })), !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9f4445173e17ab12$var$styles.overflowCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, "+", overflowCount)));
};
module.exports["MAX_VISIBLE_LOGOS"] = $9f4445173e17ab12$export$bbe9fefbd7814f35;
module.exports["SourceLogoStack"] = $9f4445173e17ab12$export$3b2450ab8d88608;

});

parcelRegister("ivSJV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");

/** Fallback icon for unrecognized source URLs. */ const $96c73bee20ad6a6c$var$UnknownIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
            appearance: "neutral",
            label: "",
            size: "xxsmall"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
const $96c73bee20ad6a6c$var$LogoMap = {
    jira: (0, $bltJZ.JiraIcon),
    confluence: (0, $bltJZ.ConfluenceIcon),
    bitbucket: (0, $bltJZ.BitbucketIcon),
    loom: (0, $bltJZ.LoomIcon),
    goals: (0, $bltJZ.GoalsIcon),
    projects: (0, $bltJZ.ProjectsIcon),
    teams: (0, $bltJZ.TeamsIcon),
    home: (0, $bltJZ.HomeIcon),
    unknown: $96c73bee20ad6a6c$var$UnknownIcon
};
function $96c73bee20ad6a6c$export$369d94b7632e2acd(source) {
    const lowerSource = source.toLowerCase();
    if (lowerSource.includes('/browse/') || lowerSource.includes('/jira/')) return 'jira';
    if (lowerSource.includes('/wiki/')) return 'confluence';
    if (lowerSource.includes('bitbucket')) return 'bitbucket';
    if (lowerSource.includes('loom.com')) return 'loom';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/goal/')) return 'goals';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/project/')) return 'projects';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/people/')) return 'teams';
    if (lowerSource.includes('home.atlassian.com')) return 'home';
    return 'unknown';
}
function $96c73bee20ad6a6c$export$70ffc3122e8f5e93(sourceType) {
    return $96c73bee20ad6a6c$var$LogoMap[sourceType];
}
module.exports["getSourceType"] = $96c73bee20ad6a6c$export$369d94b7632e2acd;
module.exports["getLogoForSourceType"] = $96c73bee20ad6a6c$export$70ffc3122e8f5e93;

});

parcelRegister("jXXTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f29e840576a4895aa674c32027ed06f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e891fc467a4625b3$var$_react = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e891fc467a4625b3$var$_baseNew = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e891fc467a4625b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/atom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e891fc467a4625b3$var$AtomIcon = (props)=>/*#__PURE__*/ $e891fc467a4625b3$var$_react.default.createElement($e891fc467a4625b3$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e891fc467a4625b3$var$AtomIcon.displayName = 'AtomIcon';
var $e891fc467a4625b3$var$_default = module.exports.default = $e891fc467a4625b3$var$AtomIcon;

});

parcelRegister("72Oi6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5SS4O = parcelRequire("5SS4O");


var $2AN91 = parcelRequire("2AN91");

/**
 * Derives a sourceType string from an ARI.
 *
 * ARIs follow the pattern `ari:cloud:<product>:<cloudId>:<resourceType>/<id>`.
 * We extract the `<product>` segment (e.g. "confluence", "jira").
 */ const $0721db9366398da5$var$getSourceTypeFromAri = (ari)=>{
    const parts = ari.split(':');
    // ari:cloud:<product>:<cloudId>:<resourceType>/<id>
    if (parts.length >= 3) return parts[2].toLowerCase();
    return 'unknown';
};
/**
 * Derives a sourceType string from a URL's hostname.
 */ const $0721db9366398da5$var$getSourceTypeFromUrl = (url)=>{
    try {
        const hostname = new URL(url).hostname;
        if (hostname.includes('atlassian.net') && url.includes('/browse/')) return 'jira';
        if (hostname.includes('atlassian.net') && url.includes('/wiki/')) return 'confluence';
        if (hostname.includes('bitbucket')) return 'bitbucket';
        if (hostname.includes('loom')) return 'loom';
        if (hostname.includes('github')) return 'github';
    } catch  {
    // fall through
    }
    return 'unknown';
};
/**
 * Maps a REST `SourceDTO` into the `ThreadSource` shape that the existing UI
 * helpers (`extractSourcesFromThread`, etc.) expect.
 *
 * The GraphQL schema uses union types (`ConvoAiHomeThreadsFirstPartySource` /
 * `ConvoAiHomeThreadsThirdPartySource`) with `__typename` discriminators.
 * The REST endpoint returns flat `{ url, ari }` objects — we synthesize the
 * correct `__typename` and nested `data.__typename` so downstream code works
 * unchanged.
 */ const $0721db9366398da5$var$mapSourceToThreadSource = (source)=>{
    const sourceType = source.ari ? $0721db9366398da5$var$getSourceTypeFromAri(source.ari) : $0721db9366398da5$var$getSourceTypeFromUrl(source.url);
    // If the source has an ARI it's a first-party Atlassian source; otherwise
    // treat it as third-party.
    const isFirstParty = source.ari && (sourceType === 'confluence' || sourceType === 'jira' || sourceType === 'townsquare');
    if (isFirstParty) {
        // Map the product name to the GraphQL data __typename convention:
        // confluence → ConvoAiHomeThreadsConfluenceData, jira → ConvoAiHomeThreadsJiraData, etc.
        const capitalized = sourceType.charAt(0).toUpperCase() + sourceType.slice(1);
        return {
            __typename: 'ConvoAiHomeThreadsFirstPartySource',
            ari: source.ari,
            url: source.url,
            data: {
                __typename: `ConvoAiHomeThreads${capitalized}Data`
            }
        };
    }
    return {
        __typename: 'ConvoAiHomeThreadsThirdPartySource',
        url: source.url
    };
};
/**
 * Maps a REST `HomeThreadDTO` into the `ThreadNode` shape used by UI components.
 */ const $0721db9366398da5$var$mapThreadDTOToThreadNode = (thread)=>({
        id: thread.id,
        title: thread.title,
        sources: thread.sources.map($0721db9366398da5$var$mapSourceToThreadSource)
    });
const $0721db9366398da5$var$getRecommendedSpacesQueryKey = ({ cloudId: cloudId, product: product, experienceId: experienceId })=>[
        'rovo-spaces:recommendedSpaces',
        cloudId,
        product,
        experienceId
    ];
const $0721db9366398da5$export$1c0761155eb1e36b = ({ cloudId: cloudId, product: product, experienceId: experienceId, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    (0, $5SS4O.prefetchQuery)({
        queryKey: $0721db9366398da5$var$getRecommendedSpacesQueryKey({
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        }),
        queryFn: ()=>(0, $2AN91.recommendedSpacesFetchAction)({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            }),
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
const $0721db9366398da5$export$3dad4020fe0045ad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { cloudId: cloudId, product: product, experienceId: experienceId, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product) {
        t2 = $0721db9366398da5$var$getRecommendedSpacesQueryKey({
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        });
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== cloudId || $[5] !== experienceId || $[6] !== product) {
        t3 = ()=>(0, $2AN91.recommendedSpacesFetchAction)({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
        $[4] = cloudId;
        $[5] = experienceId;
        $[6] = product;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = !skip;
    let t5;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            queryKey: t2,
            queryFn: t3,
            enabled: t4
        };
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, isFetching: isFetching, error: error } = (0, $5SS4O.useQuery)(t5);
    let t6;
    bb0: {
        if (!data?.threads) {
            let t7;
            if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
                t7 = [];
                $[12] = t7;
            } else t7 = $[12];
            t6 = t7;
            break bb0;
        }
        let t7;
        if ($[13] !== data.threads) {
            t7 = data.threads.map($0721db9366398da5$var$mapThreadDTOToThreadNode);
            $[13] = data.threads;
            $[14] = t7;
        } else t7 = $[14];
        t6 = t7;
    }
    const threads = t6;
    const t7 = error ?? null;
    let t8;
    if ($[15] !== isFetching || $[16] !== t7 || $[17] !== threads) {
        t8 = {
            threads: threads,
            isLoading: isFetching,
            error: t7
        };
        $[15] = isFetching;
        $[16] = t7;
        $[17] = threads;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ cloudId: cloudId, product: product, experienceId: experienceId, skip: skip = false })=>{
    const { data: data, isFetching: isFetching, error: error } = (0, $5SS4O.useQuery)({
        queryKey: $0721db9366398da5$var$getRecommendedSpacesQueryKey({
            cloudId: cloudId,
            product: product,
            experienceId: experienceId
        }),
        queryFn: ()=>(0, $2AN91.recommendedSpacesFetchAction)({
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            }),
        enabled: !skip
    });
    const threads = (0, $cozmU.useMemo)(()=>{
        if (!data?.threads) return [];
        return data.threads.map($0721db9366398da5$var$mapThreadDTOToThreadNode);
    }, [
        data
    ]);
    return (0, $cozmU.useMemo)(()=>({
            threads: threads,
            isLoading: isFetching,
            error: error ?? null
        }), [
        threads,
        isFetching,
        error
    ]);
};
module.exports["prefetchRecommendedSpaces"] = $0721db9366398da5$export$1c0761155eb1e36b;
module.exports["useRecommendedSpaces"] = $0721db9366398da5$export$3dad4020fe0045ad;

});

parcelRegister("2AN91", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $c3e8c7f54743307a$export$3eaada971224cfa1 = async ({ cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/recommended`,
        options: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        }
    });
module.exports["recommendedSpacesFetchAction"] = $c3e8c7f54743307a$export$3eaada971224cfa1;

});

parcelRegister("klllb", function(module, exports) {

let $ecf6529a0fa5c9fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecf6529a0fa5c9fc$var$load("jdsAG").then(()=>parcelRequire('atEGZ'));

});

parcelRegister("fT6bY", function(module, exports) {

let $b910cbb3a491a7f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b910cbb3a491a7f6$var$load("jdsAG").then(()=>parcelRequire('tPiQn'));

});

parcelRegister("onDaH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $e8YqO = parcelRequire("e8YqO");


var $6GT8L = parcelRequire("6GT8L");


var $i4nJ0 = parcelRequire("i4nJ0");

const $05f4d3d143d7d8f6$export$cfd2b6d59231e554 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { assistanceServiceParams: assistanceServiceParams } = t1;
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    const conversation = (0, $e8YqO.useCurrentConversation)();
    let t2;
    if ($[2] !== assistanceServiceParams || $[3] !== conversation || $[4] !== conversationId) {
        t2 = {
            conversationId: conversationId,
            conversation: conversation,
            assistanceServiceParams: assistanceServiceParams
        };
        $[2] = assistanceServiceParams;
        $[3] = conversation;
        $[4] = conversationId;
        $[5] = t2;
    } else t2 = $[5];
    return (0, $i4nJ0.useConversationData)(t2);
} : ({ assistanceServiceParams: assistanceServiceParams } = {})=>{
    const conversationId = (0, $6GT8L.useCurrentConversationId)();
    const conversation = (0, $e8YqO.useCurrentConversation)();
    return (0, $i4nJ0.useConversationData)({
        conversationId: conversationId,
        conversation: conversation,
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["useCurrentChatConversation"] = $05f4d3d143d7d8f6$export$cfd2b6d59231e554;

});

parcelRegister("j78zM", function(module, exports) {
parcelRequire("cozmU");


var $bUd6P = parcelRequire("bUd6P");


var $hcVQz = parcelRequire("hcVQz");

const $3395c154ccba6903$export$9e62346a60cfb459 = (0, $hcVQz.tempSizeWrapper)((0, $bUd6P.RovoHexIcon));
module.exports["RovoHexIcon"] = $3395c154ccba6903$export$9e62346a60cfb459;

});

parcelRegister("1KLPb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a05e8365b19766ca73e82e6f6133ae2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $146f2f46410fb12f$var$_react = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $146f2f46410fb12f$var$_baseNew = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $146f2f46410fb12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/book-open
 * Usage guidance:
 * Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $146f2f46410fb12f$var$BookOpenIcon = (props)=>/*#__PURE__*/ $146f2f46410fb12f$var$_react.default.createElement($146f2f46410fb12f$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$146f2f46410fb12f$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $146f2f46410fb12f$var$_default = module.exports.default = $146f2f46410fb12f$var$BookOpenIcon;

});

parcelRegister("5uiWK", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

const $f650f5d03c59255a$var$supportedPageContextTypes = [
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT
];
const $f650f5d03c59255a$export$c2a686cb0530eec8 = (pageContextType)=>{
    return $f650f5d03c59255a$var$supportedPageContextTypes.includes(pageContextType);
};
module.exports["isPageContextTypeSupportedForDynamicStarters"] = $f650f5d03c59255a$export$c2a686cb0530eec8;

});

parcelRegister("bQmvI", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

const $1fc19c5e39a1bbf3$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $1fc19c5e39a1bbf3$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($1fc19c5e39a1bbf3$export$10c6f1bef31d587c.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
const $1fc19c5e39a1bbf3$export$ee833111bcbf78d7 = (url, pageContextType)=>{
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT || pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT) {
        // Match: /pages/edit-v2/{resourceId} or /blog/edit-v2/{resourceId}
        const match = url.match(/\/(?:pages|blog)\/edit-v2\/(\d+)/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW) {
        // Page pattern: /pages/{resourceId}/
        const match = url.match(/\/pages\/(\d+)(?:\/|$|[?#])/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW) {
        // Blog pattern: /blog/{year}/{month}/{day}/{resourceId}/
        const match = url.match(/\/blog\/\d{4}\/\d{2}\/\d{2}\/(\d+)/);
        return match ? match[1] : null;
    }
    return null;
};
const $1fc19c5e39a1bbf3$export$3bb5b6748490a3c9 = (siteId, contentUrl, pageContextType)=>{
    const resourceId = $1fc19c5e39a1bbf3$export$ee833111bcbf78d7(contentUrl, pageContextType);
    if (!resourceId) return null;
    const isBlogPost = /\/spaces\/[^\/]+\/blog\//.test(contentUrl);
    const resourceType = isBlogPost ? 'blogpost' : 'page';
    return $1fc19c5e39a1bbf3$export$6a2f2c83863e9bfe({
        siteId: siteId,
        resourceType: resourceType,
        activationId: '',
        resourceId: // Not needed for pages/blogposts
        resourceId
    });
};
module.exports["getContentAri"] = $1fc19c5e39a1bbf3$export$3bb5b6748490a3c9;

});

parcelRegister("lFQjm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

const $d4fc531cc0ae7b89$export$46133998910543ac = (0, $cozmU.createContext)(null);
const $d4fc531cc0ae7b89$export$6fa751d66e55d2e1 = (usePathname)=>{
    const [location, setLocation] = (0, $cozmU.useState)(usePathname ? window.location.pathname : window.location.href);
    // For easier mocking
    const contextValue = (0, $cozmU.useContext)($d4fc531cc0ae7b89$export$46133998910543ac);
    const handleLocationChange = (0, $cozmU.useCallback)(()=>{
        const newValue = usePathname ? window.location.pathname : window.location.href;
        if (newValue !== location) setLocation(newValue);
    }, [
        location,
        setLocation,
        usePathname
    ]);
    (0, $cozmU.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args_0) {
            originalReplaceState.apply(this, args_0);
            handleLocationChange();
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $d4fc531cc0ae7b89$export$6fa751d66e55d2e1;

});

parcelRegister("csz0J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $jXXTm = parcelRequire("jXXTm");


var $mfdwv = parcelRequire("mfdwv");


var $f0b2F = parcelRequire("f0b2F");


var $1TvTa = parcelRequire("1TvTa");


var $5n93X = parcelRequire("5n93X");


var $aooxV = parcelRequire("aooxV");


var $4s4Os = parcelRequire("4s4Os");


var $hAgam = parcelRequire("hAgam");


var $11OF7 = parcelRequire("11OF7");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $gzMZq = parcelRequire("gzMZq");


var $6iWVH = parcelRequire("6iWVH");


var $lFQjm = parcelRequire("lFQjm");


var $7HZZ5 = parcelRequire("7HZZ5");


var $en9ZE = parcelRequire("en9ZE");

const $ae28fc22beba689b$export$2f76bd244cc53ebd = new Set([
    (0, $en9ZE.default).jiraBacklogPrompt3,
    (0, $en9ZE.default).jiraBacklogPrompt7
]);
const $ae28fc22beba689b$export$c6a4ebf596b0c08a = {
    [(0, $6iWVH.PageContextType).BITBUCKET_CREATE_PULL_REQUEST]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketCreatePullRequestsPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST]: [
        {
            labelType: 'summarize-information',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'summarize-code',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt4
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt5
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_REPOSITORY_SOURCE]: [
        {
            labelType: 'summarize-code',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt4
        },
        {
            labelType: 'code-search',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt5
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_PIPELINES]: [
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).bitbucketPipelinePrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).bitbucketPrompt5
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).bitbucketPrompt6
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketPrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_HOME]: [
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY]: [],
    [(0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY]: [],
    [(0, $6iWVH.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS]: [],
    [(0, $6iWVH.PageContextType).JIRA_HOME]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraHomePrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_FOR_YOU]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).unknownPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraIssueViewPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_PROJECT]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt14
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_BOARD]: [
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).jiraBoardPrompt1
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraBoardPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraBoardPrompt4
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).jiraBoardPrompt5
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraBoardPrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraBoardPrompt7
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraBoardPrompt8
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraBoardPrompt9
        },
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).jiraBoardPrompt10
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_BACKLOG]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraBacklogPrompt1
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).jiraBacklogPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraBacklogPrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt4
        },
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).jiraBacklogPrompt7
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt8
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt9
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt10
        },
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).jiraBacklogPrompt11
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraBacklogPrompt12
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraBacklogPrompt13
        },
        {
            labelType: 'summarize-information',
            message: (0, $en9ZE.default).jiraBacklogPrompt14
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraBacklogPrompt15
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_INCIDENT_VIEW]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_INCIDENT_LIST_VIEW]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_LIST_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_MAIN]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_DISCOVER]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_RECENTS]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).FOCUS]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusPrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).focusPrompt2
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOR_YOU]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusForYouPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_PAGE]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaGoalPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaWorkPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaPrompt1
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).focusAreaFundsPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).SAC]: [
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).sacPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).sacPrompt2
        },
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).sacPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).TRELLO_BOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).trelloBoardPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).trelloBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).trelloBoardPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).TRELLO_CARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).trelloCardPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).trelloCardPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).trelloCardPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).UNKNOWN]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).unknownPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).STUDIO_AGENT_BUILDER]: [
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).ADMIN_HUB]: []
};
const $ae28fc22beba689b$export$a905239756c1fbae = (location)=>{
    const jsmIncidentViewPatterns = [
        // Single incident view (with issue key at the end)
        [
            (0, $6iWVH.PageContextType).JSM_INCIDENT_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+\/[A-Z]+-\d+/
        ]
    ];
    const jsmOpsPatterns = (0, $iDrrr.fg)('rovo_ops_conversation_starters_enabled') ? [
        // Incident list view (without issue key at the end)
        [
            (0, $6iWVH.PageContextType).JSM_INCIDENT_LIST_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+$/
        ],
        // Single alert view (has / after alerts)
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_VIEW,
            /\/jira\/ops\/alerts\//
        ],
        // Alert list view (has ? after alerts)
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_LIST_VIEW,
            /\/jira\/ops\/alerts\?/
        ],
        // Alert group detail view
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW,
            /\/jira\/ops\/group-detail\//
        ]
    ] : [];
    const jiraBoardPattern = /\/jira\/.+\/projects\/[^\/]+\/boards\/[^\/?#]+\/?(?:[?#].*)?$/;
    // Jira board contextual starters are gated by a targeting feature gate plus an experiment.
    // Unlike most patterns below, we test the board route before adding it to urlPatterns so
    // getExperimentValue is only read on board pages and non-board pages do not log exposures.
    const jiraBoardPatterns = [];
    if (jiraBoardPattern.test(location) && (0, $iDrrr.fg)('jira_boards_rovo_contextual_actions_experiment_eligibility')) {
        const actionsVariant = (0, $cXtTj.default).getExperimentValue('jira_boards_rovo_actions_exp_targeted', 'actions_variant', 'control_static_actions');
        if (actionsVariant === 'contextual_actions_only') jiraBoardPatterns.push([
            (0, $6iWVH.PageContextType).JIRA_BOARD,
            jiraBoardPattern
        ]);
    }
    // Test the backlog route before reading the experiment so `getExperimentValue` is only
    // called on backlog pages and non-backlog pages do not log exposures.
    const jiraBacklogPattern = /\/jira\/.+\/projects\/[^\/]+\/boards\/[^\/]+\/backlog/;
    const jiraBacklogPatterns = [];
    if (jiraBacklogPattern.test(location) && (0, $cXtTj.default).getExperimentValue('jira_backlog_rovo_contextual_starters_experiment', 'isEnabled', false)) jiraBacklogPatterns.push([
        (0, $6iWVH.PageContextType).JIRA_BACKLOG,
        jiraBacklogPattern
    ]);
    // Builder starters show only on a Studio agent page reached via "Customize a template", marked by
    // the `fromTemplate=true` param Studio stamps on the URL. Scoped to the `studio.` domain so it
    // never matches other products, and tested before `fg` so exposure stays on these pages.
    const studioAgentBuilderFromTemplatePattern = /\/\/studio\.[^/]+\/.*\/agents\/[^#]*[?&]fromTemplate=true(?:&|#|$)/;
    const studioAgentBuilderPatterns = studioAgentBuilderFromTemplatePattern.test(location) && (0, $iDrrr.fg)('sgrow-149-open-rovo-after-customize') ? [
        [
            (0, $6iWVH.PageContextType).STUDIO_AGENT_BUILDER,
            studioAgentBuilderFromTemplatePattern
        ]
    ] : [];
    const urlPatterns = [
        ...studioAgentBuilderPatterns,
        [
            (0, $6iWVH.PageContextType).BITBUCKET_REPOSITORY_SOURCE,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/src\//
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/\d+/
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_CREATE_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/new/
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_PIPELINES,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pipelines\/results\/[^\/]+\/steps\//
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/?$/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/home$/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT,
            /\/wiki\/spaces\/[^\/]+\/blog\/edit-v2\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW,
            /\/wiki\/spaces\/[^\/]+\/blog\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/pages\/edit-v2\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/pages\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/[^/]+\/[^?]+\?(?:.*&)?selectedIssue=/
        ],
        ...jsmIncidentViewPatterns,
        ...jsmOpsPatterns,
        [
            (0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS,
            /\/jira\/software\/projects\/[^\/]+\/settings\/access/
        ],
        // Order matters: backlog must be tested before board because backlog URLs are a superset
        // of board URLs (they both start with `/projects/<key>/boards/<id>`), and the first match wins.
        ...jiraBacklogPatterns,
        ...jiraBoardPatterns,
        [
            (0, $6iWVH.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_FOR_YOU,
            /\/jira\/for-you$/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_DISCOVER,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*discover+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_RECENTS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*recents+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*notifications+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/projects+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/goals+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/team+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/tag+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_MAIN,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*\?cloudId=[^\/]+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW,
            /\/focus\/focus-area\/.*\/goals/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW,
            /\/focus\/focus-area\/.*\/work/
        ],
        ...(0, $iDrrr.fg)('rovo_chat_focus_analyze_funds') ? [
            [
                (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW,
                /\/focus\/focus-area\/.*\/funds/
            ]
        ] : [],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_PAGE,
            /\/focus\/focus-area\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOR_YOU,
            /\/focus\/for-you(?:\/.*)?$/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS,
            /\/focus\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).SAC,
            /support\.atlassian\.com/
        ],
        // Trello: card view first (more specific), then board. Prod: trello.com, Staging: trellis.coffee (and *.atlassian.com)
        [
            (0, $6iWVH.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/c\//
        ],
        [
            (0, $6iWVH.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/b\//
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            (0, $6iWVH.PageContextType).ADMIN_HUB,
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return (0, $6iWVH.PageContextType).UNKNOWN;
};
const $ae28fc22beba689b$export$bc4bf2ff8e40b690 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const location = (0, $lFQjm.useWindowLocation)();
    let t0;
    if ($[0] !== location) {
        t0 = $ae28fc22beba689b$export$a905239756c1fbae(location);
        $[0] = location;
        $[1] = t0;
    } else t0 = $[1];
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[2] !== location) {
        t1 = ()=>{
            setPageContextType($ae28fc22beba689b$export$a905239756c1fbae(location));
        };
        t2 = [
            location
        ];
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return pageContextType;
} : ()=>{
    const location = (0, $lFQjm.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)($ae28fc22beba689b$export$a905239756c1fbae(location));
    (0, $cozmU.useEffect)(()=>{
        setPageContextType($ae28fc22beba689b$export$a905239756c1fbae(location));
    }, [
        location
    ]);
    return pageContextType;
};
const $ae28fc22beba689b$var$shuffleStarters = (arr)=>{
    const copiedArr = [
        ...arr
    ];
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [copiedArr[i], copiedArr[j]] = [
            copiedArr[j],
            copiedArr[i]
        ];
    }
    return copiedArr;
};
const $ae28fc22beba689b$export$82bea1a28fda43c1 = (starters, num)=>{
    // Return the first `num` items
    return $ae28fc22beba689b$var$shuffleStarters(starters).slice(0, num);
};
const $ae28fc22beba689b$var$getIconAndLabelForStarter = (labelType)=>{
    switch(labelType){
        case 'be-productive':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).beProductiveLabel
            };
        case 'stay-up-to-date':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).stayUpToDateLabel
            };
        case 'summarize-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeContentLabel
            };
        case 'rephrase-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).rephraseContentLabel
            };
        case 'draft-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).draftContentLabel
            };
        case 'find-information':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).findInformationLabel
            };
        case 'find-people':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).findPeopleLabel
            };
        case 'code-search':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).codeSearchLabel
            };
        case 'measure-productivity':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).measureProductivityLabel
            };
        case 'get-answers':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).getAnswersLabel
            };
        case 'check-status':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5n93X))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).checkStatusLabel
            };
        case 'summarize-information':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeInformationLabel
            };
        case 'analyze-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).analyzeContentLabel
            };
        case 'summarize-code':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXXTm))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeCodeLabel
            };
        case 'manage-settings':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4s4Os))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).manageSettingsLabel
            };
        case 'automation-rule':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).automationRuleLabel
            };
        default:
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).beProductiveLabel
            };
    }
};
// default to fetching 3 dynamic starters
const $ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT = 3;
const $ae28fc22beba689b$export$65b45f3b39cd6930 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = $ae28fc22beba689b$export$bc4bf2ff8e40b690();
    const location = (0, $lFQjm.useWindowLocation)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const t1 = dynamicStartersConfig?.enabled && !!assistanceServiceParams;
    let t2;
    if ($[0] !== assistanceServiceParams) {
        t2 = assistanceServiceParams || {
            touchpointSource: "",
            product: "",
            experienceId: "",
            siteId: ""
        };
        $[0] = assistanceServiceParams;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== location || $[3] !== pageContextType || $[4] !== t1 || $[5] !== t2) {
        t3 = {
            contentUrl: location,
            pageContextType: pageContextType,
            showConvoStarters: t1,
            assistanceServiceParams: t2
        };
        $[2] = location;
        $[3] = pageContextType;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $7HZZ5.useFetchConvoStarters)(t3);
    let t4;
    bb0: {
        if (pageContextType !== (0, $6iWVH.PageContextType).JIRA_BACKLOG) {
            t4 = false;
            break bb0;
        }
        const jiraViewContext = aiFeatureContext?.jira_view_context;
        t4 = jiraViewContext?.isSprintEnabled === false;
    }
    const isBacklogSprintDisabled = t4;
    let t5;
    if ($[7] !== formatMessage || $[8] !== isBacklogSprintDisabled || $[9] !== pageContextType) {
        let t6;
        if ($[11] !== isBacklogSprintDisabled) {
            t6 = (starter)=>isBacklogSprintDisabled ? !$ae28fc22beba689b$export$2f76bd244cc53ebd.has(starter.message) : true;
            $[11] = isBacklogSprintDisabled;
            $[12] = t6;
        } else t6 = $[12];
        const rawStarters = $ae28fc22beba689b$export$c6a4ebf596b0c08a[pageContextType].filter(t6);
        let t7;
        if ($[13] !== formatMessage) {
            t7 = (starter_0)=>{
                const shouldShowBetaBadge = starter_0.message === (0, $en9ZE.default).focusAreaFundsPrompt1;
                return {
                    labelType: starter_0.labelType,
                    message: formatMessage(starter_0.message),
                    badge: shouldShowBetaBadge ? /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                        appearance: "discovery"
                    }, formatMessage((0, $en9ZE.default).focusAreaFundsBetaBadge)) : undefined,
                    type: "static"
                };
            };
            $[13] = formatMessage;
            $[14] = t7;
        } else t7 = $[14];
        t5 = rawStarters.map(t7);
        $[7] = formatMessage;
        $[8] = isBacklogSprintDisabled;
        $[9] = pageContextType;
        $[10] = t5;
    } else t5 = $[10];
    const contextualStarters = t5;
    const staticStarters = contextualStarters;
    let t6;
    if ($[15] !== staticStarters) {
        t6 = staticStarters.reduce($ae28fc22beba689b$var$_temp, {});
        $[15] = staticStarters;
        $[16] = t6;
    } else t6 = $[16];
    const groupedStarters = t6;
    let t7;
    if ($[17] !== groupedStarters) {
        t7 = Object.entries(groupedStarters).map($ae28fc22beba689b$var$_temp6);
        $[17] = groupedStarters;
        $[18] = t7;
    } else t7 = $[18];
    const conversationStarterActions = t7;
    let t8;
    if ($[19] !== formatMessage || $[20] !== groupedStarters) {
        t8 = Object.entries(groupedStarters).map((t9)=>{
            const [, starters_0] = t9;
            const { icon: icon, label: label } = $ae28fc22beba689b$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: "convo-starter",
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: $ae28fc22beba689b$var$_temp7,
                badge: starters_0.find($ae28fc22beba689b$var$_temp8)?.badge,
                children: starters_0.map((starter_4)=>{
                    const starterHasPlaceholder_0 = starter_4.message.includes("`");
                    return {
                        id: "convo-starter",
                        title: starter_4.message,
                        icon: ()=>icon,
                        onClick: $ae28fc22beba689b$var$_temp9,
                        type: "convo-starter-action",
                        handleType: (0, $6iWVH.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_4.message
                        } : {
                            staticPrompt: starter_4.message
                        },
                        badge: starter_4.badge,
                        starterType: "static"
                    };
                }),
                handleType: (0, $6iWVH.HandleActionType).Nested,
                type: "convo-starter-action"
            };
        });
        $[19] = formatMessage;
        $[20] = groupedStarters;
        $[21] = t8;
    } else t8 = $[21];
    const nestedConversationStarterActions = t8;
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    dynamicStartersConfig?.enabled;
    let t9;
    bb1: {
        if (!dynamicStartersConfig?.enabled) {
            let t10;
            if ($[22] !== conversationStarterActions || $[23] !== numStartersToReturn) {
                t10 = $ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
                $[22] = conversationStarterActions;
                $[23] = numStartersToReturn;
                $[24] = t10;
            } else t10 = $[24];
            t9 = t10;
            break bb1;
        }
        if (isDynamicStarterActionsLoading) {
            let t10;
            if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
                t10 = [];
                $[25] = t10;
            } else t10 = $[25];
            t9 = t10;
            break bb1;
        }
        if (dynamicStarterActions.length >= numStartersToReturn) {
            let t10;
            if ($[26] !== dynamicStarterActions || $[27] !== numStartersToReturn) {
                t10 = dynamicStarterActions.slice(0, numStartersToReturn);
                $[26] = dynamicStarterActions;
                $[27] = numStartersToReturn;
                $[28] = t10;
            } else t10 = $[28];
            t9 = t10;
            break bb1;
        }
        let t10;
        if ($[29] !== conversationStarterActions || $[30] !== dynamicStarterActions || $[31] !== numStartersToReturn) {
            t10 = [
                ...dynamicStarterActions,
                ...$ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
            ];
            $[29] = conversationStarterActions;
            $[30] = dynamicStarterActions;
            $[31] = numStartersToReturn;
            $[32] = t10;
        } else t10 = $[32];
        t9 = t10;
    }
    const randomizedConversationStarterActions = t9;
    let t10;
    if ($[33] !== nestedConversationStarterActions || $[34] !== numNestedStartersToReturn) {
        t10 = $ae28fc22beba689b$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
        $[33] = nestedConversationStarterActions;
        $[34] = numNestedStartersToReturn;
        $[35] = t10;
    } else t10 = $[35];
    const randomizedNestedConversationStarterActions = t10;
    const t11 = Math.min($ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn);
    let t12;
    if ($[36] !== isDynamicStarterActionsLoading || $[37] !== randomizedConversationStarterActions || $[38] !== randomizedNestedConversationStarterActions || $[39] !== t11) {
        t12 = {
            conversationStarterActions: randomizedConversationStarterActions,
            nestedConversationStarterActions: randomizedNestedConversationStarterActions,
            getRandomStarters: $ae28fc22beba689b$export$82bea1a28fda43c1,
            isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
            numDynamicStarterActionsLoading: t11
        };
        $[36] = isDynamicStarterActionsLoading;
        $[37] = randomizedConversationStarterActions;
        $[38] = randomizedNestedConversationStarterActions;
        $[39] = t11;
        $[40] = t12;
    } else t12 = $[40];
    return t12;
} : ({ numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = $ae28fc22beba689b$export$bc4bf2ff8e40b690();
    const location = (0, $lFQjm.useWindowLocation)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $7HZZ5.useFetchConvoStarters)({
        contentUrl: location,
        pageContextType: pageContextType,
        showConvoStarters: dynamicStartersConfig?.enabled && !!assistanceServiceParams,
        // hacky workaround for consumers that don't need dynamic starters (and therfore don't pass in assistanceServiceParams)
        assistanceServiceParams: assistanceServiceParams || {
            touchpointSource: '',
            product: '',
            experienceId: '',
            siteId: ''
        }
    });
    const isBacklogSprintDisabled = (0, $cozmU.useMemo)(()=>{
        if (pageContextType !== (0, $6iWVH.PageContextType).JIRA_BACKLOG) return false;
        const jiraViewContext = aiFeatureContext?.jira_view_context;
        return jiraViewContext?.isSprintEnabled === false;
    }, [
        pageContextType,
        aiFeatureContext
    ]);
    const staticStarters = (0, $cozmU.useMemo)(()=>{
        const rawStarters = $ae28fc22beba689b$export$c6a4ebf596b0c08a[pageContextType].filter((starter)=>isBacklogSprintDisabled ? !$ae28fc22beba689b$export$2f76bd244cc53ebd.has(starter.message) : true);
        const contextualStarters = rawStarters.map((starter_0)=>{
            const shouldShowBetaBadge = starter_0.message === (0, $en9ZE.default).focusAreaFundsPrompt1;
            return {
                labelType: starter_0.labelType,
                message: formatMessage(starter_0.message),
                badge: shouldShowBetaBadge ? /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                    appearance: "discovery"
                }, formatMessage((0, $en9ZE.default).focusAreaFundsBetaBadge)) : undefined,
                type: 'static'
            };
        });
        return contextualStarters;
    }, [
        pageContextType,
        formatMessage,
        isBacklogSprintDisabled
    ]);
    const groupedStarters = (0, $cozmU.useMemo)(()=>staticStarters.reduce((acc, starter_1)=>{
            if (!starter_1.labelType) return acc;
            acc[starter_1.labelType] = [
                ...acc[starter_1.labelType] || [],
                starter_1
            ];
            return acc;
        }, {}), [
        staticStarters
    ]);
    // Use this to get conversation starter actions that are not nested (e.g. for Sidebar)
    const conversationStarterActions = (0, $cozmU.useMemo)(()=>Object.entries(groupedStarters).map(([, starters])=>{
            // If there is only one starter in the group, return as a single chat action, otherwise return one of the nested items to use as a starter
            if (starters.length === 1) {
                const starter_2 = starters[0];
                const starterHasPlaceholder = starter_2.message.includes('`');
                return {
                    id: 'convo-starter',
                    title: starter_2.message,
                    icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6iWVH.HandleActionType).Chat,
                    children: [],
                    ...starterHasPlaceholder ? {
                        dynamicPrompt: starter_2.message
                    } : {
                        staticPrompt: starter_2.message
                    },
                    badge: starter_2.badge,
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            } else {
                //Grab a random starter from the group to use
                const randomIndex = Math.floor(Math.random() * starters.length);
                const randomStarter = starters[randomIndex];
                const randomStarterHasPlaceholder = randomStarter.message.includes('`');
                return {
                    id: `convo-starter`,
                    title: randomStarter.message,
                    icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6iWVH.HandleActionType).Chat,
                    ...randomStarterHasPlaceholder ? {
                        dynamicPrompt: randomStarter.message
                    } : {
                        staticPrompt: randomStarter.message
                    },
                    badge: randomStarter.badge,
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            }
        }), [
        groupedStarters
    ]);
    // Use this to get conversation starter actions that are nested (e.g. for Full Screen)
    const nestedConversationStarterActions = (0, $cozmU.useMemo)(()=>Object.entries(groupedStarters).map(([, starters_0])=>{
            const { icon: icon, label: label } = $ae28fc22beba689b$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: 'convo-starter',
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: ()=>{},
                badge: starters_0.find((starter_3)=>starter_3.badge)?.badge,
                children: starters_0.map((starter_4)=>{
                    const starterHasPlaceholder_0 = starter_4.message.includes('`');
                    return {
                        id: 'convo-starter',
                        title: starter_4.message,
                        icon: ()=>icon,
                        onClick: ()=>{},
                        type: 'convo-starter-action',
                        handleType: (0, $6iWVH.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_4.message
                        } : {
                            staticPrompt: starter_4.message
                        },
                        badge: starter_4.badge,
                        starterType: 'static'
                    };
                }),
                handleType: (0, $6iWVH.HandleActionType).Nested,
                type: 'convo-starter-action'
            };
        }), [
        groupedStarters,
        formatMessage
    ]);
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    // dynamic starter actions are not included in nested use case
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    const randomizedConversationStarterActions = (0, $cozmU.useMemo)(()=>{
        if (!dynamicStartersConfig?.enabled) return $ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
        if (isDynamicStarterActionsLoading) return [];
        if (dynamicStarterActions.length >= numStartersToReturn) return dynamicStarterActions.slice(0, numStartersToReturn);
        // prioritizes dynamic starters, and then randomizes the static starters
        return [
            ...dynamicStarterActions,
            ...$ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
        ];
    }, [
        conversationStarterActions,
        numStartersToReturn,
        dynamicStarterActions,
        isDynamicStarterActionsLoading,
        dynamicStartersConfig?.enabled
    ]);
    const randomizedNestedConversationStarterActions = (0, $cozmU.useMemo)(()=>{
        return $ae28fc22beba689b$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
    }, [
        nestedConversationStarterActions,
        numNestedStartersToReturn
    ]);
    return {
        conversationStarterActions: randomizedConversationStarterActions,
        nestedConversationStarterActions: randomizedNestedConversationStarterActions,
        getRandomStarters: $ae28fc22beba689b$export$82bea1a28fda43c1,
        isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
        numDynamicStarterActionsLoading: Math.min($ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn)
    };
};
function $ae28fc22beba689b$var$_temp(acc, starter_1) {
    if (!starter_1.labelType) return acc;
    acc[starter_1.labelType] = [
        ...acc[starter_1.labelType] || [],
        starter_1
    ];
    return acc;
}
function $ae28fc22beba689b$var$_temp2() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: ""
    });
}
function $ae28fc22beba689b$var$_temp3() {}
function $ae28fc22beba689b$var$_temp4() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: ""
    });
}
function $ae28fc22beba689b$var$_temp5() {}
function $ae28fc22beba689b$var$_temp6(t0) {
    const [, starters] = t0;
    if (starters.length === 1) {
        const starter_2 = starters[0];
        const starterHasPlaceholder = starter_2.message.includes("`");
        return {
            id: "convo-starter",
            title: starter_2.message,
            icon: $ae28fc22beba689b$var$_temp2,
            onClick: $ae28fc22beba689b$var$_temp3,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            children: [],
            ...starterHasPlaceholder ? {
                dynamicPrompt: starter_2.message
            } : {
                staticPrompt: starter_2.message
            },
            badge: starter_2.badge,
            type: "convo-starter-action",
            starterType: "static"
        };
    } else {
        const randomIndex = Math.floor(Math.random() * starters.length);
        const randomStarter = starters[randomIndex];
        const randomStarterHasPlaceholder = randomStarter.message.includes("`");
        return {
            id: "convo-starter",
            title: randomStarter.message,
            icon: $ae28fc22beba689b$var$_temp4,
            onClick: $ae28fc22beba689b$var$_temp5,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            ...randomStarterHasPlaceholder ? {
                dynamicPrompt: randomStarter.message
            } : {
                staticPrompt: randomStarter.message
            },
            badge: randomStarter.badge,
            type: "convo-starter-action",
            starterType: "static"
        };
    }
}
function $ae28fc22beba689b$var$_temp7() {}
function $ae28fc22beba689b$var$_temp8(starter_3) {
    return starter_3.badge;
}
function $ae28fc22beba689b$var$_temp9() {}
module.exports["usePageContextType"] = $ae28fc22beba689b$export$bc4bf2ff8e40b690;
module.exports["useRovoConversationStarters"] = $ae28fc22beba689b$export$65b45f3b39cd6930;

});

parcelRegister("5n93X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::641dd5d03db662197381257f8f1690c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e96216f98bcdad5$var$_react = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3e96216f98bcdad5$var$_baseNew = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3e96216f98bcdad5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cloud-arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e96216f98bcdad5$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $3e96216f98bcdad5$var$_react.default.createElement($3e96216f98bcdad5$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$3e96216f98bcdad5$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $3e96216f98bcdad5$var$_default = module.exports.default = $3e96216f98bcdad5$var$CloudArrowUpIcon;

});

parcelRegister("aooxV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76e1d7852c77788b608c8a25a14c5e2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $790f2fa6e07cdd43$var$_react = $790f2fa6e07cdd43$var$_interopRequireDefault((parcelRequire("cozmU")));

var $790f2fa6e07cdd43$var$_baseNew = $790f2fa6e07cdd43$var$_interopRequireDefault((parcelRequire("gElAV")));
function $790f2fa6e07cdd43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EditBulk".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/edit-bulk
 * Usage guidance:
 * Single purpose - Reserved for editing multiple objects in bulk.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $790f2fa6e07cdd43$var$EditBulkIcon = (props)=>/*#__PURE__*/ $790f2fa6e07cdd43$var$_react.default.createElement($790f2fa6e07cdd43$var$_baseNew.default, Object.assign({
        name: "EditBulkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 4.25zm1.5.75v1h1v-1zm9.836.104a2 2 0 0 1 2.828 0l.232.232a2 2 0 0 1 0 2.828l-4.848 4.849a2 2 0 0 1-1.022.547l-2.129.425a.75.75 0 0 1-.882-.882l.425-2.129a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.708 0L13.061 4l.939.94.336-.336a.5.5 0 0 0 0-.708zM12.939 6 12 5.06 8.548 8.514a.5.5 0 0 0-.137.255l-.205 1.026 1.026-.205a.5.5 0 0 0 .255-.137zM1 6.75A.75.75 0 0 1 1.75 6h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 9.25zm1.5.75v1h1v-1zM1 11.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75zm1.5.75v1h1v-1z" clip-rule="evenodd"/>`
    }, props));
$790f2fa6e07cdd43$var$EditBulkIcon.displayName = 'EditBulkIcon';
var $790f2fa6e07cdd43$var$_default = module.exports.default = $790f2fa6e07cdd43$var$EditBulkIcon;

});

parcelRegister("4s4Os", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c39ab428064e6510a97203cbbc69e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33dd82a961935154$var$_react = $33dd82a961935154$var$_interopRequireDefault((parcelRequire("cozmU")));

var $33dd82a961935154$var$_baseNew = $33dd82a961935154$var$_interopRequireDefault((parcelRequire("gElAV")));
function $33dd82a961935154$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-added
 * Usage guidance:
 * Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33dd82a961935154$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $33dd82a961935154$var$_react.default.createElement($33dd82a961935154$var$_baseNew.default, Object.assign({
        name: "PersonAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m4.95 6.99-3.83 4.5a.75.75 0 0 1-1.14 0l-1.92-2.25 1.14-.97 1.35 1.58 3.26-3.83z"/>`
    }, props));
$33dd82a961935154$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $33dd82a961935154$var$_default = module.exports.default = $33dd82a961935154$var$PersonAddedIcon;

});

parcelRegister("7HZZ5", function(module, exports) {
// adapted from: platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-actions/hooks/useFetchConvoStarters.ts

var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $6iWVH = parcelRequire("6iWVH");


var $5uiWK = parcelRequire("5uiWK");


var $bQmvI = parcelRequire("bQmvI");

const $534dbfa9546a4c22$var$mapToConversationActionNew = (starterObject)=>{
    return {
        id: 'convo-starter',
        title: starterObject.starter,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                label: ""
            }),
        staticPrompt: starterObject.starter,
        handleType: (0, $6iWVH.HandleActionType).Chat,
        starterType: 'dynamic',
        jtbdCategory: starterObject.jtbd_category,
        agent: undefined,
        type: 'convo-starter-action'
    };
};
const $534dbfa9546a4c22$export$460b2fd9dae847fd = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId }, contentUrl: contentUrl, pageContextType: pageContextType, showConvoStarters: showConvoStarters = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const timingRef = (0, $cozmU.useRef)(null);
    const contentAri = (0, $cozmU.useMemo)(()=>(0, $bQmvI.getContentAri)(siteId, contentUrl, pageContextType), [
        siteId,
        contentUrl,
        pageContextType
    ]);
    // TODO ASIMO-2398: experiment cleanup
    const urlDebugInfo = (0, $cozmU.useMemo)(()=>{
        try {
            const url = new URL(contentUrl);
            return {
                pathSegmentCount: url.pathname.split('/').filter(Boolean).length,
                hasQueryParams: url.search.length > 0,
                protocol: url.protocol
            };
        } catch  {
            return {
                pathSegmentCount: 0,
                hasQueryParams: false,
                protocol: 'invalid'
            };
        }
    }, [
        contentUrl
    ]);
    const isPageContextTypeSupported = (0, $5uiWK.isPageContextTypeSupportedForDynamicStarters)(pageContextType);
    const isEligibleContext = isPageContextTypeSupported && contentAri !== null;
    const isFeatureEnabled = showConvoStarters && isEligibleContext;
    // TODO ASIMO-2398: experiment cleanup
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'called',
            actionSubject: 'useFetchConvoStarters',
            attributes: {
                showConvoStarters: showConvoStarters,
                isPageContextTypeSupported: isPageContextTypeSupported,
                isEligibleContext: isEligibleContext,
                isFeatureEnabled: isFeatureEnabled,
                pageContextType: String(pageContextType),
                hasContentAri: contentAri !== null,
                contentAri: contentAri,
                urlStructure: urlDebugInfo
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { data: convoStarters, isFetching: isLoading, error: fetchError } = (0, $5SS4O.useQuery)({
        enabled: isFeatureEnabled,
        queryKey: [
            'dynamicConvoStarters',
            contentAri ?? contentUrl
        ],
        queryFn: async ()=>{
            // Custom performance tracking for dynamic starters experiment to analyze on Statsig.
            // Confluence ui taskSuccess events aren't sent to Statsig.
            timingRef.current = {
                startTime: performance.now(),
                sent: false,
                pageContextType: String(pageContextType)
            };
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'started',
                actionSubject: 'fetchConvoStarters',
                attributes: {
                    pageContextType: timingRef.current.pageContextType
                }
            });
            const response = await assistanceService.getDynamicConvoStartersNew({
                ai_feature_input: {
                    // safe to assert: query is disabled (enabled condition) when contentAri is null
                    documents: [
                        {
                            ari: contentAri
                        }
                    ]
                }
            });
            // Since we only request one document, we should get exactly one result
            const result = response?.ai_feature_output?.results?.[0];
            if (!result) throw new Error('Expected one result in API response but received none');
            if (result.error) {
                const errorType = result.error.error_type;
                // expected failures (HYDRATION_ERROR) are silently filtered
                if (errorType === 'HYDRATION_ERROR') return [];
                throw new Error(`[${errorType}] ${result.error.message}`);
            }
            if (!result.convo_starters.length) return [];
            return result.convo_starters.map((starter)=>$534dbfa9546a4c22$var$mapToConversationActionNew(starter));
        },
        onSuccess: (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'succeeded',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        startersCount: data?.length ?? 0,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        },
        onError: (error)=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        errorMessage: error.message,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                error: error
            });
        }
    });
    // Track cancellations when component unmounts during fetch
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'cancelled',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        };
    }, [
        sendAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            convoStarters: convoStarters ?? [],
            isLoading: isLoading,
            error: fetchError ?? undefined
        }), [
        convoStarters,
        isLoading,
        fetchError
    ]);
});
module.exports["useFetchConvoStarters"] = $534dbfa9546a4c22$export$460b2fd9dae847fd;

});

parcelRegister("en9ZE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0ccb00ee4479897$var$_default_1 = (0, $kSwu1.defineMessages)({
    // Conversation starter labels
    beProductiveLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.be-productive",
        defaultMessage: "Be productive"
    },
    stayUpToDateLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.stay-up-to-date",
        defaultMessage: "Stay up-to-date"
    },
    summarizeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-content",
        defaultMessage: "Summarize content"
    },
    rephraseContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.rephrase-content",
        defaultMessage: "Rephrase content"
    },
    draftContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.draft-content",
        defaultMessage: "Draft content"
    },
    findInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-information",
        defaultMessage: "Find information"
    },
    findPeopleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-people",
        defaultMessage: "Find people"
    },
    codeSearchLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.code-search",
        defaultMessage: "Code search"
    },
    measureProductivityLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.measure-productivity",
        defaultMessage: "Measure productivity"
    },
    getAnswersLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.get-answers",
        defaultMessage: "Get answers"
    },
    checkStatusLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.check-status",
        defaultMessage: "Check status"
    },
    summarizeInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-information",
        defaultMessage: "Summarize information"
    },
    analyzeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.analyze-content",
        defaultMessage: "Analyze content"
    },
    summarizeCodeLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-code",
        defaultMessage: "Summarize code"
    },
    automationRuleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.automation-rule",
        defaultMessage: "Automation rule"
    },
    manageSettingsLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.manage-settings",
        defaultMessage: "Manage settings"
    },
    // BITBUCKET_CREATE_PULL_REQUESTS
    bitbucketCreatePullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1",
        defaultMessage: "Summarize this pull request"
    },
    bitbucketPullRequestsPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2",
        defaultMessage: "Explain the code changes to me."
    },
    bitbucketPullRequestsPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3",
        defaultMessage: "Summarize the comments on this pull request"
    },
    bitbucketPullRequestsPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4",
        defaultMessage: "Explain the code changes"
    },
    bitbucketPullRequestsPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPullRequestsPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1",
        defaultMessage: "Explain this file"
    },
    bitbucketRepositorySourcePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketRepositorySourcePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3",
        defaultMessage: " What APIs or modules do these files interact with?"
    },
    bitbucketRepositorySourcePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketRepositorySourcePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5",
        defaultMessage: "Find APIs that these files interact with"
    },
    // BITBUCKET_PIPELINES
    bitbucketPipelinePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPipelinePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2",
        defaultMessage: "What is the status of the `build`?"
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-1",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-2",
        defaultMessage: "What are the open PRs for the current Jira sprint?"
    },
    bitbucketPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-3",
        defaultMessage: "Has `Jira work item` been deployed?"
    },
    bitbucketPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-4",
        defaultMessage: "Who are the reviewers on this `Pull request`?"
    },
    bitbucketPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-5",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-6",
        defaultMessage: "Check deployment status of `Jira work item`"
    },
    bitbucketPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-7",
        defaultMessage: "Find reviewers of `pull request`"
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-1",
        defaultMessage: "Is there any new activity on pages I've written?"
    },
    confluenceHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-2",
        defaultMessage: "Are there any new comments mentioning me?"
    },
    confluenceHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-3",
        defaultMessage: "Summarize the most recently published pages in this space."
    },
    confluenceHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-4",
        defaultMessage: "Summarize my contributions to pages from last week."
    },
    confluenceHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-5",
        defaultMessage: "Can you take this `page` and write it in a less technical way?"
    },
    confluenceHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-6",
        defaultMessage: "Create a game plan template for project management."
    },
    confluenceHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-7",
        defaultMessage: "What research do we have on common customer problems?"
    },
    confluenceHomePrompt8: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-8",
        defaultMessage: "Has anyone on my team published any new pages this week?"
    },
    confluenceHomePrompt9: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-9",
        defaultMessage: "Has `person` published any new pages this week?"
    },
    confluenceHomePrompt10: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-10",
        defaultMessage: "Has `person` commented on any pages that I've published?"
    },
    confluenceHomePrompt11: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-11",
        defaultMessage: "What are the key takeaways from `page`?"
    },
    confluenceHomePrompt12: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-12",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
    confluencePageViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluencePageViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2",
        defaultMessage: "Summarize the comments on this page."
    },
    confluencePageViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3",
        defaultMessage: "Explain this page to me like I'm a beginner."
    },
    confluencePageViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4",
        defaultMessage: "Who wrote this page and what team are they on?"
    },
    confluencePageViewPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5",
        defaultMessage: "Has anything on this page changed in the last week?"
    },
    confluencePageViewPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
    confluencePageEditPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1",
        defaultMessage: "Can you improve the writing on this page?"
    },
    confluencePageEditPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2",
        defaultMessage: "Write an executive summary for this page."
    },
    confluencePageEditPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3",
        defaultMessage: "Give me links to some other relevant pages."
    },
    confluencePageEditPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluenceWhiteboardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2",
        defaultMessage: "Highlight any patterns or trends visible here."
    },
    confluenceWhiteboardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3",
        defaultMessage: "Identify any key action items or decisions captured in this whiteboard."
    },
    confluenceWhiteboardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-1",
        defaultMessage: "Find Jira issues that have been updated this week."
    },
    jiraHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-2",
        defaultMessage: "What Jira issues are the highest priority?"
    },
    jiraHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-3",
        defaultMessage: "What Jira issues have comments mentioning me?"
    },
    jiraHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-4",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-5",
        defaultMessage: "Create a description template for user stories."
    },
    jiraHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1",
        defaultMessage: "Are there any similar Jira issues to this one?"
    },
    jiraIssueViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2",
        defaultMessage: "How could I improve the description?"
    },
    jiraIssueViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3",
        defaultMessage: "What labels could I add to this issue?"
    },
    jiraIssueViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_PROJECT
    jiraProjectPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-1",
        defaultMessage: "What work hasn\u2019t been picked up in a while?"
    },
    jiraProjectPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-2",
        defaultMessage: "Are any Jira issues blocked?"
    },
    jiraProjectPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-3",
        defaultMessage: "List Jira issues that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-4",
        defaultMessage: "How many issues are assigned to `person`?"
    },
    jiraProjectPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-5",
        defaultMessage: "Has `person` commented on any Jira issues in this sprint?"
    },
    jiraProjectPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-6",
        defaultMessage: "What Jira issues are unassigned?"
    },
    jiraProjectPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-7",
        defaultMessage: "What Jira issues have been open the longest?"
    },
    jiraProjectPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-8",
        defaultMessage: "Who has the most tasks?"
    },
    jiraProjectPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-9",
        defaultMessage: "Find and group similar Jira issues."
    },
    jiraProjectPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-10",
        defaultMessage: "Are there any Jira issues not connected to a parent issue?"
    },
    jiraProjectPrompt11: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-11",
        defaultMessage: "Take `Jira issue` description and align it to best-practice."
    },
    jiraProjectPrompt12: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-12",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraProjectPrompt13: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-13",
        defaultMessage: "Create a description template for user stories."
    },
    jiraProjectPrompt14: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-14",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_BOARD
    jiraBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-1",
        defaultMessage: "Update status for work items in this board."
    },
    jiraBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-2",
        defaultMessage: "Update assignee for work items in this board."
    },
    jiraBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-3",
        defaultMessage: "Update work items in this board."
    },
    jiraBoardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-4",
        defaultMessage: "What are the risks for this active sprint?"
    },
    jiraBoardPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-5",
        defaultMessage: "How many work items are unassigned in this board?"
    },
    jiraBoardPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-6",
        defaultMessage: "Which work items are stale?"
    },
    jiraBoardPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-7",
        defaultMessage: "Which work items are blocked?"
    },
    jiraBoardPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-8",
        defaultMessage: "Summarize this board for me."
    },
    jiraBoardPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-9",
        defaultMessage: "Update work items on this board."
    },
    jiraBoardPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-10",
        defaultMessage: "Move work items to a status."
    },
    // JIRA_BACKLOG
    jiraBacklogPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-1",
        defaultMessage: "Find work items assigned to me in this backlog."
    },
    jiraBacklogPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-2",
        defaultMessage: "Update the status of a set of work items in this backlog to `status`."
    },
    jiraBacklogPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-3",
        defaultMessage: "Add the top-ranked work items from this backlog to the upcoming sprint."
    },
    jiraBacklogPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-4",
        defaultMessage: "Create new work items in the backlog."
    },
    jiraBacklogPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-7",
        defaultMessage: "Move a set of work items in this backlog to the upcoming sprint."
    },
    jiraBacklogPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-8",
        defaultMessage: "Write a description for a `Jira work item`."
    },
    jiraBacklogPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-9",
        defaultMessage: "Update the summary for a set of work items in this backlog."
    },
    jiraBacklogPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-10",
        defaultMessage: "Update the priority of a set of work items in this backlog to `priority`."
    },
    jiraBacklogPrompt11: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-11",
        defaultMessage: "Update the parent for a set of work items in this backlog."
    },
    jiraBacklogPrompt12: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-12",
        defaultMessage: "Are there any Jira issues not connected to a parent issue?"
    },
    jiraBacklogPrompt13: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-13",
        defaultMessage: "Which work items are stale in the backlog?"
    },
    jiraBacklogPrompt14: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-14",
        defaultMessage: "What issues don't have an estimate in the backlog?"
    },
    jiraBacklogPrompt15: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-15",
        defaultMessage: "Are there any blocked issues in the backlog?"
    },
    // JSM_INCIDENT_VIEW
    jsmIncidentViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1",
        defaultMessage: "Find people who can help resolve this incident"
    },
    jsmIncidentViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3",
        defaultMessage: "Create a post-incident review (PIR)"
    },
    // JSM_INCIDENT_LIST_VIEW
    jsmIncidentListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2",
        defaultMessage: "Get me the open high priority incidents"
    },
    jsmIncidentListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3",
        defaultMessage: "Are there any open alerts?"
    },
    // JSM_ALERT_VIEW (Alert details page)
    jsmAlertViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2",
        defaultMessage: "Investigate this alert"
    },
    jsmAlertViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_LIST_VIEW (Alert list page)
    jsmAlertListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
    jsmAlertGroupDetailViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertGroupDetailViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertGroupDetailViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-1",
        defaultMessage: "What Confluence pages have I contributed to recently?"
    },
    atlasHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-2",
        defaultMessage: "Find all Jira tickets that are assigned to me."
    },
    atlasHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-3",
        defaultMessage: "What is our travel policy?"
    },
    atlasHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-4",
        defaultMessage: "Draft a Confluence page for a marketing campaign."
    },
    atlasHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-5",
        defaultMessage: "How can I create a project timeline?"
    },
    atlasHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-6",
        defaultMessage: "Write a follow up email to potential clients."
    },
    atlasHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-7",
        defaultMessage: "What should I work on next?"
    },
    // FOCUS
    focusPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    focusPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-2",
        defaultMessage: "Identify gaps and highlight risks."
    },
    // FOCUS_FOCUS_AREA_PAGE
    focusAreaPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area.starter-1",
        defaultMessage: "Summarize this focus area."
    },
    // FOCUS_FOCUS_AREA_GOAL_VIEW
    focusAreaGoalPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1",
        defaultMessage: "Summarize the goals linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_WORK_VIEW
    focusAreaWorkPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-work.starter-1",
        defaultMessage: "Summarize the work linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_FUNDS_VIEW
    focusAreaFundsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-funds.starter-1",
        defaultMessage: "Analyze the funds linked to this focus area."
    },
    focusAreaFundsBetaBadge: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-funds.beta-badge",
        defaultMessage: "Beta"
    },
    // FOCUS_FOR_YOU
    focusForYouPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-for-you.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    // SAC
    sacPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-1",
        defaultMessage: "How do I manage settings?"
    },
    sacPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-2",
        defaultMessage: "How do I find information?"
    },
    sacPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-3",
        defaultMessage: "How do I create an automation rule?"
    },
    // TRELLO_BOARD (board/universal rovo button)
    trelloBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-1",
        defaultMessage: "Summarize this board."
    },
    trelloBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-2",
        defaultMessage: "Suggest ways to organize this board."
    },
    trelloBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-3",
        defaultMessage: "What should my top 3 priorities be today?"
    },
    // TRELLO_CARD (cardback)
    trelloCardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-1",
        defaultMessage: "Summarize this card."
    },
    trelloCardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-2",
        defaultMessage: "Find work related to this card."
    },
    trelloCardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-3",
        defaultMessage: "Suggest improvements for this card's description."
    },
    // UNKNOWN
    unknownPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-1",
        defaultMessage: "Are any of my work items overdue?"
    },
    unknownPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-2",
        defaultMessage: "What should I work on next?"
    },
    unknownPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-3",
        defaultMessage: "Write an update about my week."
    },
    studioAgentBuilderPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-1",
        defaultMessage: "Personalize this agent to my needs"
    },
    studioAgentBuilderPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-2",
        defaultMessage: "What other tools could I add"
    },
    studioAgentBuilderPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-3",
        defaultMessage: "Find more knowledge sources"
    }
});
var $b0ccb00ee4479897$export$2e2bcd8739ae039 = $b0ccb00ee4479897$var$_default_1;
module.exports["default"] = $b0ccb00ee4479897$export$2e2bcd8739ae039;

});

parcelRegister("jdw9n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $54033ecc926bdd79$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $cozmU.useState)(null);
    const [isMounted, setIsMounted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            (parcelRequire("46G2C")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.Placement);
                    setIsMounted(true);
                }
            }).catch(()=>{
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};
module.exports["usePostOfficePlacement"] = $54033ecc926bdd79$export$b9e056b3d42aef4;

});

parcelRegister("46G2C", function(module, exports) {

let $2fd85574ef2de7af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2fd85574ef2de7af$var$load("4UGUK"),
    $2fd85574ef2de7af$var$load("koqff"),
    $2fd85574ef2de7af$var$load("4qksR"),
    $2fd85574ef2de7af$var$load("7VzZT"),
    $2fd85574ef2de7af$var$load("2l8zo"),
    $2fd85574ef2de7af$var$load("cWzGN")
]).then(()=>parcelRequire('ikSqk'));

});

parcelRegister("5JcMj", function(module, exports) {
const $37c3470506073d18$export$b43e46cd2196fd17 = 200;
const $37c3470506073d18$export$dc2b038e384ab366 = 5;
const $37c3470506073d18$export$68396b9352efd8a3 = 1000;
module.exports["VIRTUAL_GROUP_ESTIMATED_HEIGHT_PX"] = $37c3470506073d18$export$b43e46cd2196fd17;
module.exports["MINIMUM_OLDER_MESSAGE_GROUPS_TO_VIRTUALIZE"] = $37c3470506073d18$export$dc2b038e384ab366;
module.exports["INITIAL_ANCHOR_SETTLING_WINDOW_MS"] = $37c3470506073d18$export$68396b9352efd8a3;

});

parcelRegister("cvKZ9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $5JcMj = parcelRequire("5JcMj");

const $0269adbbe737c642$export$2c9ebb56e048948b = [
    'wheel',
    'touchstart',
    'pointerdown'
];


const $b11a8b4d38da7845$export$a07982805d97c266 = new Set([
    'ArrowUp',
    'Home',
    'PageUp'
]);


const $4a480382f5d9c63a$export$9e7874a6e62c79bb = ({ enabled: enabled, conversationId: conversationId, totalSize: totalSize, containerRef: containerRef, scrollToBottomGeneration: scrollToBottomGeneration, onInitialAnchorApplied: onInitialAnchorApplied }, { hasInitialScrollSettledRef: hasInitialScrollSettledRef, lastSettledConversationIdRef: lastSettledConversationIdRef, lastScrollToBottomGenerationRef: lastScrollToBottomGenerationRef })=>{
    if (!enabled) return;
    // Reopen the settling window when the conversation changes or when a
    // new scroll-to-bottom is requested (e.g. user sent a message).
    if (lastSettledConversationIdRef.current !== conversationId) {
        hasInitialScrollSettledRef.current = false;
        lastSettledConversationIdRef.current = conversationId;
    }
    if (lastScrollToBottomGenerationRef.current !== scrollToBottomGeneration) {
        hasInitialScrollSettledRef.current = false;
        lastScrollToBottomGenerationRef.current = scrollToBottomGeneration;
    }
    if (hasInitialScrollSettledRef.current) return;
    const settle = ()=>{
        if (hasInitialScrollSettledRef.current) return;
        hasInitialScrollSettledRef.current = true;
    };
    const container = containerRef.current;
    if (!container || typeof container.scrollTo !== 'function') {
        settle();
        onInitialAnchorApplied?.();
        return;
    }
    let frame = null;
    let isCancelled = false;
    let lastScrollHeight = -1;
    const settlingWindowStart = performance.now();
    const anchorToBottom = ()=>{
        const nextScrollHeight = container.scrollHeight;
        // Skip until the container has real measurements. Anchoring to 0 (or
        // NaN) briefly puts the scroll position at the top, which cancels the
        // subsequent RAF re-anchor because our own scrollTo dispatches a
        // scroll event that other listeners may treat as user intent.
        if (!Number.isFinite(nextScrollHeight) || nextScrollHeight <= 0) return;
        if (nextScrollHeight === lastScrollHeight) return;
        lastScrollHeight = nextScrollHeight;
        container.scrollTo({
            top: nextScrollHeight,
            behavior: 'instant'
        });
    };
    const markUserInteracted = ()=>{
        settle();
    };
    const markKeyboardScrollIntent = (event)=>{
        if ((0, $b11a8b4d38da7845$export$a07982805d97c266).has(event.key)) settle();
    };
    const unbindUserScrollCancelEvents = (0, $cbY7C.bindAll)(container, [
        ...(0, $0269adbbe737c642$export$2c9ebb56e048948b).map((eventName)=>({
                type: eventName,
                listener: markUserInteracted,
                options: {
                    passive: true
                }
            })),
        {
            type: 'keydown',
            listener: markKeyboardScrollIntent,
            options: {
                passive: true
            }
        }
    ]);
    anchorToBottom();
    onInitialAnchorApplied?.();
    const keepAnchoredDuringSettlingWindow = (timestamp)=>{
        if (isCancelled || hasInitialScrollSettledRef.current) return;
        anchorToBottom();
        if (timestamp - settlingWindowStart >= (0, $5JcMj.INITIAL_ANCHOR_SETTLING_WINDOW_MS)) {
            settle();
            return;
        }
        frame = requestAnimationFrame(keepAnchoredDuringSettlingWindow);
    };
    frame = requestAnimationFrame(keepAnchoredDuringSettlingWindow);
    return ()=>{
        isCancelled = true;
        if (frame !== null) cancelAnimationFrame(frame);
        unbindUserScrollCancelEvents();
    };
};











const $f6c9e4ad83cd263a$export$e235940f0742d9fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const hasInitialScrollSettledRef = (0, $cozmU.useRef)(false);
    const lastSettledConversationIdRef = (0, $cozmU.useRef)(null);
    const lastScrollToBottomGenerationRef = (0, $cozmU.useRef)(0);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            hasInitialScrollSettledRef: hasInitialScrollSettledRef,
            lastSettledConversationIdRef: lastSettledConversationIdRef,
            lastScrollToBottomGenerationRef: lastScrollToBottomGenerationRef
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const hasInitialScrollSettledRef = (0, $cozmU.useRef)(false);
    const lastSettledConversationIdRef = (0, $cozmU.useRef)(null);
    const lastScrollToBottomGenerationRef = (0, $cozmU.useRef)(0);
    return (0, $cozmU.useMemo)(()=>({
            hasInitialScrollSettledRef: hasInitialScrollSettledRef,
            lastSettledConversationIdRef: lastSettledConversationIdRef,
            lastScrollToBottomGenerationRef: lastScrollToBottomGenerationRef
        }), []);
};


const $dab2b4b10b7a3954$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
const $dab2b4b10b7a3954$export$c5c6ad5b63f27ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (args)=>{
    const $ = (0, $bDgLe.c)(9);
    const { enabled: enabled, totalSize: totalSize, conversationId: conversationId, containerRef: containerRef, scrollToBottomGeneration: scrollToBottomGeneration, onInitialAnchorApplied: onInitialAnchorApplied } = args;
    const refs = (0, $f6c9e4ad83cd263a$export$e235940f0742d9fe)();
    let t0;
    let t1;
    if ($[0] !== containerRef || $[1] !== conversationId || $[2] !== enabled || $[3] !== onInitialAnchorApplied || $[4] !== refs || $[5] !== scrollToBottomGeneration || $[6] !== totalSize) {
        t0 = ()=>(0, $4a480382f5d9c63a$export$9e7874a6e62c79bb)({
                enabled: enabled,
                totalSize: totalSize,
                conversationId: conversationId,
                containerRef: containerRef,
                scrollToBottomGeneration: scrollToBottomGeneration,
                onInitialAnchorApplied: onInitialAnchorApplied
            }, refs);
        t1 = [
            enabled,
            totalSize,
            conversationId,
            containerRef,
            scrollToBottomGeneration,
            onInitialAnchorApplied,
            refs
        ];
        $[0] = containerRef;
        $[1] = conversationId;
        $[2] = enabled;
        $[3] = onInitialAnchorApplied;
        $[4] = refs;
        $[5] = scrollToBottomGeneration;
        $[6] = totalSize;
        $[7] = t0;
        $[8] = t1;
    } else {
        t0 = $[7];
        t1 = $[8];
    }
    $dab2b4b10b7a3954$var$useIsomorphicLayoutEffect(t0, t1);
} : (args)=>{
    const { enabled: enabled, totalSize: totalSize, conversationId: conversationId, containerRef: containerRef, scrollToBottomGeneration: scrollToBottomGeneration, onInitialAnchorApplied: onInitialAnchorApplied } = args;
    const refs = (0, $f6c9e4ad83cd263a$export$e235940f0742d9fe)();
    $dab2b4b10b7a3954$var$useIsomorphicLayoutEffect(()=>(0, $4a480382f5d9c63a$export$9e7874a6e62c79bb)({
            enabled: enabled,
            totalSize: totalSize,
            conversationId: conversationId,
            containerRef: containerRef,
            scrollToBottomGeneration: scrollToBottomGeneration,
            onInitialAnchorApplied: onInitialAnchorApplied
        }, refs), [
        enabled,
        totalSize,
        conversationId,
        containerRef,
        scrollToBottomGeneration,
        onInitialAnchorApplied,
        refs
    ]);
};
module.exports["useLayoutInitialBottomAnchor"] = $dab2b4b10b7a3954$export$c5c6ad5b63f27ae;

});

parcelRegister("iQVBK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f3fd04cb039a7e1db6ef0e51fefb003>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db99c51049c0bf52$var$_react = $db99c51049c0bf52$var$_interopRequireDefault((parcelRequire("cozmU")));

var $db99c51049c0bf52$var$_baseNew = $db99c51049c0bf52$var$_interopRequireDefault((parcelRequire("gElAV")));
function $db99c51049c0bf52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Scorecard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/scorecard
 * Usage guidance:
 * Single purpose - Reserved for Scorecard in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db99c51049c0bf52$var$ScorecardIcon = (props)=>/*#__PURE__*/ $db99c51049c0bf52$var$_react.default.createElement($db99c51049c0bf52$var$_baseNew.default, Object.assign({
        name: "ScorecardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0 0 13V16a8 8 0 1 1 8-8h-1.5A6.5 6.5 0 0 0 8 1.5m4.326 3.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zm-1.889 8.548a6.52 6.52 0 0 0 3.59-3.59l1.391.562A8.03 8.03 0 0 1 11 15.418z" clip-rule="evenodd"/>`
    }, props));
$db99c51049c0bf52$var$ScorecardIcon.displayName = 'ScorecardIcon';
var $db99c51049c0bf52$var$_default = module.exports.default = $db99c51049c0bf52$var$ScorecardIcon;

});

parcelRegister("33DXp", function(module, exports) {
const $f2aa1c62c37e6cdd$var$BOLD_APPEARANCES = [
    'redBold',
    'orangeBold',
    'yellowBold',
    'limeBold',
    'greenBold',
    'tealBold',
    'blueBold',
    'purpleBold',
    'magentaBold'
];
function $f2aa1c62c37e6cdd$export$4c1d34e61697239e(id) {
    let hash = 0;
    for(let i = 0; i < id.length; i++)hash = hash * 31 + id.charCodeAt(i) >>> 0;
    return $f2aa1c62c37e6cdd$var$BOLD_APPEARANCES[hash % $f2aa1c62c37e6cdd$var$BOLD_APPEARANCES.length];
}
module.exports["getAppearanceFromId"] = $f2aa1c62c37e6cdd$export$4c1d34e61697239e;

});

parcelRegister("1kxki", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $12c61bdb5e5d4432$var$slideAnimation = null; // 'planning' / 'running' animation: scroll a 200% wide inner div by -50% of its
// own width so it loops seamlessly within the fixed-width clip region.
const $12c61bdb5e5d4432$var$scrollAnimation = null; // Order: orange, green, blue, purple
const $12c61bdb5e5d4432$var$COLORS = [
    "var(--ds-chart-categorical-4, #F68909)",
    // orange
    "var(--ds-chart-categorical-2, #82B536)",
    // green
    "var(--ds-chart-categorical-1, #357DE8)",
    // blue
    "var(--ds-chart-categorical-3, #BF63F3)" // purple
];
const $12c61bdb5e5d4432$var$COMPLETE_COLOR = "var(--ds-chart-categorical-2, #82B536)"; // green
const $12c61bdb5e5d4432$var$containerStyles = null;
const $12c61bdb5e5d4432$var$containerThickStyles = null; // 'start': sliding train of divs
const $12c61bdb5e5d4432$var$trainStyles = null;
const $12c61bdb5e5d4432$var$blockStyles = null; // Scroll train blocks are 1/8th of the inner div width (which is 200% of the clip container)
const $12c61bdb5e5d4432$var$scrollBlockStyles = null;
const $12c61bdb5e5d4432$var$scrollInnerStyles = null;
const $12c61bdb5e5d4432$var$completeStyles = null; // Clipping container for 'planning' and 'running' — width is set dynamically via inline style
const $12c61bdb5e5d4432$var$scrollRegionStyles = null; // Determinate mode: width is driven by the `progress` prop. Parents are
// responsible for animating it smoothly (e.g. via requestAnimationFrame).
const $12c61bdb5e5d4432$var$determinateRegionStyles = null; // Static rainbow: same 4 color blocks as the animated version, no scroll.
const $12c61bdb5e5d4432$var$staticRainbowFillStyles = null;
const $12c61bdb5e5d4432$var$solidFillStyles = null; /**
                               * Determinate-mode fill style:
                               * - `'rainbow'`: scrolling rainbow color blocks
                               * - `'static-rainbow'`: static rainbow gradient
                               * - any other string: a solid CSS color (e.g. a design token value)
                               */ 
const $12c61bdb5e5d4432$var$ColorTrain = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _1mT5xdWVPG _0jFU0VN91d _1gBibyGxWQ _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
            ])
        }, $12c61bdb5e5d4432$var$COLORS.map($12c61bdb5e5d4432$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1mT5xdWVPG _0jFU0VN91d _1gBibyGxWQ _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
        ])
    }, $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
            ])
        })));
const $12c61bdb5e5d4432$var$ScrollTrainInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0jFU0VN91d _39xV02xxUt _1gBiby7Xiq _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
            ])
        }, [
            0,
            1
        ].map($12c61bdb5e5d4432$var$_temp2));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VN91d _39xV02xxUt _1gBiby7Xiq _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
        ])
    }, [
        0,
        1
    ].map((copy)=>$12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
                key: `${copy}-${color}`,
                style: {
                    backgroundColor: color
                },
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp _3YEZNOdnbC _1bHrqETz69 _0jFU0VN91d"
                ])
            }))));
const $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT = {
    planning: 'Planning...',
    running: 'Running...'
};
const $12c61bdb5e5d4432$var$StaticRainbowFill = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0jFU0VN91d _39xV02N91d"
            ])
        }, $12c61bdb5e5d4432$var$COLORS.map($12c61bdb5e5d4432$var$_temp3));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VN91d _39xV02N91d"
        ])
    }, $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
            ])
        })));
const $12c61bdb5e5d4432$var$DeterminateFill = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { appearance: appearance } = t0;
    if (appearance === "rainbow") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (appearance === "static-rainbow") {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$StaticRainbowFill, null);
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance) {
        t1 = {
            backgroundColor: appearance
        };
        $[2] = appearance;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t1,
            className: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ appearance: appearance })=>{
    if (appearance === 'rainbow') return /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null);
    if (appearance === 'static-rainbow') return /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$StaticRainbowFill, null);
     // Treat any other string as a CSS color.
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: appearance
        },
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG"
        ])
    });
};
const $12c61bdb5e5d4432$export$38b7902100288853 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { testId: testId, status: t1, label: t2, progress: progress, appearance: t3, thickness: t4 } = t0;
    const status = t1 === undefined ? "start" : t1;
    const label = t2 === undefined ? "Loading" : t2;
    const appearance = t3 === undefined ? "rainbow" : t3;
    const thickness = t4 === undefined ? "default" : t4;
    const isDeterminate = progress !== undefined;
    const isComplete = status === "complete";
    const ariaValueText = isDeterminate ? undefined : $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT[status];
    const clampedProgress = isDeterminate ? Math.min(100, Math.max(0, progress)) : undefined;
    let t5;
    if ($[0] !== clampedProgress || $[1] !== isComplete || $[2] !== isDeterminate) {
        t5 = isDeterminate ? Math.round(clampedProgress) : isComplete ? 100 : undefined;
        $[0] = clampedProgress;
        $[1] = isComplete;
        $[2] = isDeterminate;
        $[3] = t5;
    } else t5 = $[3];
    const t6 = isDeterminate || isComplete ? 0 : undefined;
    const t7 = isDeterminate || isComplete ? 100 : undefined;
    const t8 = thickness === "thick" && "_0bjKvDS5Zs _0jFU0VZimw";
    let t9;
    if ($[4] !== t8) {
        t9 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0V4Y4b _1mT5xdRAKS _0KLXruDMqu",
            t8
        ]);
        $[4] = t8;
        $[5] = t9;
    } else t9 = $[5];
    let t10;
    if ($[6] !== appearance || $[7] !== clampedProgress || $[8] !== isComplete || $[9] !== isDeterminate || $[10] !== status) {
        t10 = isDeterminate ? /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                width: `${clampedProgress}%`
            },
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
            ])
        }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$DeterminateFill, {
            appearance: appearance
        })) : isComplete ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _0KLXruVNK6"
            ])
        }) : status === "planning" || status === "running" ? /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                width: status === "planning" ? "30%" : "60%"
            },
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
            ])
        }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null)) : /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ColorTrain, null);
        $[6] = appearance;
        $[7] = clampedProgress;
        $[8] = isComplete;
        $[9] = isDeterminate;
        $[10] = status;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== ariaValueText || $[13] !== label || $[14] !== t10 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t9 || $[19] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            role: "progressbar",
            "aria-label": label,
            "aria-valuetext": ariaValueText,
            "aria-valuenow": t5,
            "aria-valuemin": t6,
            "aria-valuemax": t7,
            className: t9
        }, t10);
        $[12] = ariaValueText;
        $[13] = label;
        $[14] = t10;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = t9;
        $[19] = testId;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ testId: testId, status: status = 'start', label: label = 'Loading', progress: progress, appearance: appearance = 'rainbow', thickness: thickness = 'default' })=>{
    const isDeterminate = progress !== undefined;
    const isComplete = status === 'complete'; // Indeterminate states: omit aria-valuenow/min/max (per the ARIA spec) and
    // surface contextual feedback via aria-valuetext for planning/running.
    const ariaValueText = isDeterminate ? undefined : $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT[status];
    const clampedProgress = isDeterminate ? Math.min(100, Math.max(0, progress)) : undefined;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "progressbar",
        "aria-label": label,
        "aria-valuetext": ariaValueText,
        "aria-valuenow": isDeterminate ? Math.round(clampedProgress) : isComplete ? 100 : undefined,
        "aria-valuemin": isDeterminate || isComplete ? 0 : undefined,
        "aria-valuemax": isDeterminate || isComplete ? 100 : undefined,
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0V4Y4b _1mT5xdRAKS _0KLXruDMqu",
            thickness === 'thick' && "_0bjKvDS5Zs _0jFU0VZimw"
        ])
    }, isDeterminate ? /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: `${clampedProgress}%`
        },
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$DeterminateFill, {
        appearance: appearance
    })) : isComplete ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _0KLXruVNK6"
        ])
    }) : status === 'planning' || status === 'running' ? /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: status === 'planning' ? '30%' : '60%'
        },
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null)) : // Full-bar sliding train (start).
    /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ColorTrain, null));
};
function $12c61bdb5e5d4432$var$_temp(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
        ])
    });
}
function $12c61bdb5e5d4432$var$_temp2(copy) {
    return $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: `${copy}-${color}`,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqETz69 _0jFU0VN91d"
            ])
        }));
}
function $12c61bdb5e5d4432$var$_temp3(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
        ])
    });
}
module.exports["RainbowProgressBar"] = $12c61bdb5e5d4432$export$38b7902100288853;

});

parcelRegister("jqWbJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kuIhJ = parcelRequire("kuIhJ");


var $12shJ = parcelRequire("12shJ");


var $imR6I = parcelRequire("imR6I");

const $bb666cce217f58d7$export$874484b32a681e3d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { spaceId: spaceId, cloudId: cloudId, product: t1, experienceId: t2 } = t0;
    const product = t1 === undefined ? "rovo" : t1;
    const experienceId = t2 === undefined ? "ai-mate" : t2;
    const { upsertSpaceSource: upsertSpaceSource } = (0, $12shJ.useSpaceStoreActions)();
    let t3;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product || $[3] !== spaceId) {
        t3 = async (t4)=>{
            const { url: url, ari: ari, name: name, sourceType: sourceType } = t4;
            return (0, $imR6I.addSpaceSourceFetchAction)({
                spaceId: spaceId,
                request: {
                    ari: ari ?? url,
                    url: url,
                    name: name,
                    sourceType: sourceType
                },
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
        };
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = spaceId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== spaceId || $[6] !== upsertSpaceSource) {
        t4 = (response)=>{
            upsertSpaceSource(spaceId, response);
        };
        $[5] = spaceId;
        $[6] = upsertSpaceSource;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = {
            mutationFn: t3,
            onSuccess: t4
        };
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)(t5);
    let t6;
    if ($[11] !== mutate) {
        t6 = (params, callbacks)=>mutate(params, callbacks);
        $[11] = mutate;
        $[12] = t6;
    } else t6 = $[12];
    const addSource = t6;
    let t7;
    if ($[13] !== addSource || $[14] !== error || $[15] !== isSubmitting) {
        t7 = {
            addSource: addSource,
            isAdding: isSubmitting,
            error: error
        };
        $[13] = addSource;
        $[14] = error;
        $[15] = isSubmitting;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ spaceId: spaceId, cloudId: cloudId, product: product = 'rovo', experienceId: experienceId = 'ai-mate' })=>{
    const { upsertSpaceSource: upsertSpaceSource } = (0, $12shJ.useSpaceStoreActions)();
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)({
        mutationFn: async ({ url: url, ari: ari, name: name, sourceType: sourceType })=>(0, $imR6I.addSpaceSourceFetchAction)({
                spaceId: spaceId,
                request: {
                    ari: ari ?? url,
                    url: url,
                    name: name,
                    sourceType: sourceType
                },
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            }),
        onSuccess: (response)=>{
            // Mirror to the store so any consumer of `useSpaceById` /
            // `useSpaceDetail` sees the new source without a refetch.
            upsertSpaceSource(spaceId, response);
        }
    });
    const addSource = (0, $cozmU.useCallback)((params, callbacks)=>mutate(params, callbacks), [
        mutate
    ]);
    return {
        addSource: addSource,
        isAdding: isSubmitting,
        error: error
    };
};
module.exports["useAddSpaceSource"] = $bb666cce217f58d7$export$874484b32a681e3d;

});

parcelRegister("imR6I", function(module, exports) {
/**
 * Pure fetch helper extracted from `useAddSpaceSource` so the hook itself can
 * stay focused on the React-state / sweet-state mirroring concerns and the
 * shared `useMutation` utility can drive the request lifecycle.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $f93d8a90fb2a0681$export$3febf6aaf126f87a = async ({ spaceId: spaceId, request: request, cloudId: cloudId, product: product, experienceId: experienceId })=>(0, $jTKfH.performHttpFetch)({
        path: `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/sources`,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }
    });
module.exports["addSpaceSourceFetchAction"] = $f93d8a90fb2a0681$export$3febf6aaf126f87a;

});

parcelRegister("fItNb", function(module, exports) {
/**
 * SBS (Side-by-Side) evaluation types for UI components.
 *
 * These types are used by the SBS consent modal and feedback bar
 * rendered inside the ConversationAssistant component tree.
 */ // ── Event name constants ──────────────────────────────────────────────
/** The custom event name dispatched by useSBSTrigger in the platform package. */ const $fb32e1abab80c307$export$7f51937c56ae4513 = 'rovo-sbs-trigger';
const $fb32e1abab80c307$export$33791c10391a8d15 = 'rovo-sbs-consent-received';
const $fb32e1abab80c307$export$43dd8d67ea63fd94 = 'rovo-sbs-bridge';
const $fb32e1abab80c307$export$44e3b0b18a7628ff = [
    'better_grounding_information',
    'better_formatted_response',
    'answer_length_more_adequate',
    'followed_instructions_better',
    'more_relevant_to_me',
    'it_was_faster',
    'less_hallucination'
];
module.exports["SBS_TRIGGER_EVENT_NAME"] = $fb32e1abab80c307$export$7f51937c56ae4513;
module.exports["SBS_CONSENT_RECEIVED_EVENT_NAME"] = $fb32e1abab80c307$export$33791c10391a8d15;
module.exports["SBS_BRIDGE_SOURCE"] = $fb32e1abab80c307$export$43dd8d67ea63fd94;

});

parcelRegister("j1wsN", function(module, exports) {

let $dd974ae56e86fa98$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd974ae56e86fa98$var$load("43KDb").then(()=>parcelRequire('7PxUu'));

});

parcelRegister("6nI6v", function(module, exports) {

let $4a571a340fe7a384$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a571a340fe7a384$var$load("7TWMq").then(()=>parcelRequire('iJ9Ln'));

});

parcelRegister("lNheA", function(module, exports) {

let $fddb8aecf79c6cc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fddb8aecf79c6cc2$var$load("4yvWc").then(()=>parcelRequire('dRwZE'));

});

parcelRegister("etmuJ", function(module, exports) {

let $a89539121831f5f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a89539121831f5f8$var$load("8Sa5Q").then(()=>parcelRequire('eKL6x'));

});

parcelRegister("gxmD5", function(module, exports) {
const $2f7f93fb83392ebb$export$cb9fc4c34a0afb34 = {
    lastSeenAt: 0,
    exposureCount: 0,
    onboardingCompleted: false
};
module.exports["DEFAULT_HOLDOUT_STATE"] = $2f7f93fb83392ebb$export$cb9fc4c34a0afb34;

});

parcelRegister("advdT", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");


var $aWbI3 = parcelRequire("aWbI3");

function $35b5f67ffede8a05$export$70098a1ba52d021f() {
    try {
        return (0, $aWbI3.parseState)((0, $7dBf8.AtlBrowserStorageLocal).getItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY)));
    } catch  {
        return null;
    }
}
module.exports["getOnboardingHoldoutState"] = $35b5f67ffede8a05$export$70098a1ba52d021f;

});

parcelRegister("9O4fI", function(module, exports) {
/**
 * Onboarding holdout feature: gate onboarding behind a 24h cooldown, a max of 3 exposures,
 * and don't-show-again-after-completion. This module defines the holdout tunables
 * (cooldown, exposure cap, storage key) and the persisted state shape. State is read/written
 * via the get/persist helpers using AtlBrowserStorageLocal; if productionized, consider a more
 * permanent source (e.g. backend or user preferences).
 */ 
var $oV0CU = parcelRequire("oV0CU");

const $1243988fe5d236ac$export$124df12a015901ba = 'rovoOnboardingHoldout';
const $1243988fe5d236ac$export$a478a0028a108fe6 = 3;
const $1243988fe5d236ac$export$af9030d6dd88ec25 = 24 * (0, $oV0CU.SECONDS_IN_HR) * (0, $oV0CU.MS_IN_SECOND);
module.exports["LS_ONBOARDING_HOLDOUT_KEY"] = $1243988fe5d236ac$export$124df12a015901ba;
module.exports["MAX_ONBOARDING_EXPOSURES"] = $1243988fe5d236ac$export$a478a0028a108fe6;
module.exports["HOLDOUT_MS"] = $1243988fe5d236ac$export$af9030d6dd88ec25;

});

parcelRegister("aWbI3", function(module, exports) {

var $9O4fI = parcelRequire("9O4fI");

function $12e24d7a304110aa$export$adb402f717f36848(raw) {
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.lastSeenAt === 'number' && typeof parsed.exposureCount === 'number') return {
        lastSeenAt: parsed.lastSeenAt,
        exposureCount: Math.min(Math.max(0, Math.floor(parsed.exposureCount)), (0, $9O4fI.MAX_ONBOARDING_EXPOSURES)),
        onboardingCompleted: parsed.onboardingCompleted === true
    };
    return null;
}
module.exports["parseState"] = $12e24d7a304110aa$export$adb402f717f36848;

});

parcelRegister("3LpEG", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");

function $a9ad9738d21e6d42$export$9f127573fd964184(state) {
    try {
        (0, $7dBf8.AtlBrowserStorageLocal).setItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY), JSON.stringify(state));
    } catch  {
    // AtlBrowserStorageLocal may be full or unavailable (e.g. private browsing in Safari)
    }
}
module.exports["persistState"] = $a9ad9738d21e6d42$export$9f127573fd964184;

});

parcelRegister("d7zDK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7hgf7 = parcelRequire("7hgf7");

const $c2d3c2e14a888e0a$export$dc8e328f8eb98139 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hgf7.GoogleCalendarIcon), {
            size: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hgf7.GoogleCalendarIcon), {
        size: 16
    });
module.exports["GoogleCalendarIconBorderless"] = $c2d3c2e14a888e0a$export$dc8e328f8eb98139;

});

parcelRegister("gaafy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a42d6ea162637bd1$export$359ca796b415372 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46666H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9999 5.86634C16.0005 4.98365 15.2841 4.26732 14.3996 4.26667C13.5151 4.26732 12.7987 4.98365 12.7993 5.86634V7.46667H14.3996C15.2841 7.46601 16.0005 6.74968 15.9999 5.86634ZM11.7331 5.86634V1.59967C11.7338 0.717635 11.018 0.00130479 10.1335 0C9.24907 0.000652395 8.53261 0.716983 8.53327 1.59967V5.86634C8.53196 6.74903 9.24842 7.46536 10.1329 7.46667C11.0173 7.46601 11.7338 6.74968 11.7331 5.86634Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.133 15.9998C11.0174 15.9992 11.7339 15.2829 11.7333 14.4002C11.7339 13.5175 11.0174 12.8011 10.133 12.8005H8.53272V14.4002C8.53206 15.2822 9.24852 15.9985 10.133 15.9998ZM10.133 11.7325H14.3997C15.2842 11.7319 16.0006 11.0155 16 10.1328C16.0013 9.25014 15.2848 8.53381 14.4004 8.5325H10.1336C9.24917 8.53315 8.53272 9.24949 8.53337 10.1322C8.53272 11.0155 9.24852 11.7319 10.133 11.7325Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.000122517 10.1334C-0.000531185 11.0161 0.715927 11.7325 1.60039 11.7331C2.48485 11.7325 3.2013 11.0161 3.20065 10.1334V8.53375H1.60039C0.715927 8.5344 -0.000531185 9.25074 0.000122517 10.1334ZM4.26684 10.1334V14.4001C4.26553 15.2828 4.98199 15.9991 5.86645 16.0004C6.75091 15.9998 7.46737 15.2835 7.46672 14.4008V10.1347C7.46802 9.25204 6.75156 8.53571 5.86711 8.5344C4.98199 8.5344 4.26619 9.25074 4.26684 10.1334C4.26684 10.1341 4.26684 10.1334 4.26684 10.1334Z",
            fill: "#E01E5A"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46666H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9999 5.86634C16.0005 4.98365 15.2841 4.26732 14.3996 4.26667C13.5151 4.26732 12.7987 4.98365 12.7993 5.86634V7.46667H14.3996C15.2841 7.46601 16.0005 6.74968 15.9999 5.86634ZM11.7331 5.86634V1.59967C11.7338 0.717635 11.018 0.00130479 10.1335 0C9.24907 0.000652395 8.53261 0.716983 8.53327 1.59967V5.86634C8.53196 6.74903 9.24842 7.46536 10.1329 7.46667C11.0173 7.46601 11.7338 6.74968 11.7331 5.86634Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.133 15.9998C11.0174 15.9992 11.7339 15.2829 11.7333 14.4002C11.7339 13.5175 11.0174 12.8011 10.133 12.8005H8.53272V14.4002C8.53206 15.2822 9.24852 15.9985 10.133 15.9998ZM10.133 11.7325H14.3997C15.2842 11.7319 16.0006 11.0155 16 10.1328C16.0013 9.25014 15.2848 8.53381 14.4004 8.5325H10.1336C9.24917 8.53315 8.53272 9.24949 8.53337 10.1322C8.53272 11.0155 9.24852 11.7319 10.133 11.7325Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.000122517 10.1334C-0.000531185 11.0161 0.715927 11.7325 1.60039 11.7331C2.48485 11.7325 3.2013 11.0161 3.20065 10.1334V8.53375H1.60039C0.715927 8.5344 -0.000531185 9.25074 0.000122517 10.1334ZM4.26684 10.1334V14.4001C4.26553 15.2828 4.98199 15.9991 5.86645 16.0004C6.75091 15.9998 7.46737 15.2835 7.46672 14.4008V10.1347C7.46802 9.25204 6.75156 8.53571 5.86711 8.5344C4.98199 8.5344 4.26619 9.25074 4.26684 10.1334C4.26684 10.1341 4.26684 10.1334 4.26684 10.1334Z",
        fill: "#E01E5A"
    }));
module.exports["SlackIconBorderless"] = $a42d6ea162637bd1$export$359ca796b415372;

});

parcelRegister("bp6jG", function(module, exports) {

let $84d6edd04345aab9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $84d6edd04345aab9$var$load("ilUG7"),
    $84d6edd04345aab9$var$load("efUj2"),
    $84d6edd04345aab9$var$load("a8glC"),
    $84d6edd04345aab9$var$load("cmtVo")
]).then(()=>parcelRequire('8B7yv'));

});

parcelRegister("gKxUw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $91uAX = parcelRequire("91uAX");


var $isp1U = parcelRequire("isp1U");


var $eoEVy = parcelRequire("eoEVy");


var $2dlSO = parcelRequire("2dlSO");


var $bSAnS = parcelRequire("bSAnS");


var $kEjXh = parcelRequire("kEjXh");

const $9d2832a2132f7625$var$ANALYTICS_CHANNEL = 'aiMate';
const $9d2832a2132f7625$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $9d2832a2132f7625$var$constructFeedbackContext = (additionalFields, aaid, tenantId)=>{
    const userAgent = navigator.userAgent;
    const screenResolution = `${window.screen.width} x ${window.screen.height}`;
    const feedbackContext = {
        'User-Agent': userAgent,
        'Screen Resolution': screenResolution,
        'User Account Id': aaid ?? 'unknown',
        'Tenant Id': tenantId ?? 'unknown',
        /* Other context fields will have to be passed in as props, since there aren't public hooks to get these.
    Environment: metadata.environment ?? '',
    Product: metadata.product ?? '',
    Edition: metadata.edition ?? '',
    */ ...additionalFields
    };
    const feedbackContextStr = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${value}`).join('\n');
    return [
        {
            id: $9d2832a2132f7625$var$FEEDBACK_CONTEXT_FIELD_ID,
            value: feedbackContextStr
        }
    ];
};
const $9d2832a2132f7625$var$getFeedbackConfig = (variant)=>{
    switch(variant){
        case (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitle,
                rateExperience: (0, $bSAnS.messages).rateExperience,
                entrypointId: '63867aef-06e5-4520-855f-4d29e062f22c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).ROVO:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleNoCreate,
                rateExperience: (0, $bSAnS.messages).rateExperienceNoCreate,
                entrypointId: '63867aef-06e5-4520-855f-4d29e062f22c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO_FROM_JIRA:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitle,
                rateExperience: (0, $bSAnS.messages).rateExperience,
                // https://customerfeedback.atlassian.net/jira/servicedesk/projects/JIRAAIFC
                entrypointId: 'e79ff340-38e9-4c53-9d3b-87a776964f2c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).REMIX:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleRemix,
                rateExperience: (0, $bSAnS.messages).rateExperienceRemix,
                entrypointId: '0953facd-d9b5-4ce6-b1d6-7bae93e09b2f'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).SLIDES:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleSlides,
                rateExperience: (0, $bSAnS.messages).rateExperienceSlides,
                entrypointId: 'dd0e4a6a-6a39-40d4-961f-a5bf382c9fb0'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO_FROM_JSM:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitle,
                rateExperience: (0, $bSAnS.messages).rateExperience,
                entrypointId: 'ad7943a4-aa8a-4f69-b317-7241ec65472c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).ROVO_INSIGHTS_FROM_JSM:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleRovoInsights,
                rateExperience: (0, $bSAnS.messages).rateExperienceRovoInsights,
                // https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSAIF
                entrypointId: '122afbe6-2758-40f4-a24e-59c01eb0fd39'
            };
    }
};
const $9d2832a2132f7625$export$35c06614b8d216da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartCreateFeedback(props) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, aaid: aaid, email: email } = (0, $isp1U.useProfileController)();
    let t0;
    if ($[0] !== aaid || $[1] !== email || $[2] !== name || $[3] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($9d2832a2132f7625$export$4a210f0e33a62fe0, {
            name: name,
            aaid: aaid,
            email: email,
            ...props
        });
        $[0] = aaid;
        $[1] = email;
        $[2] = name;
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : function SmartCreateFeedback(props) {
    const { name: name, aaid: aaid, email: email } = (0, $isp1U.useProfileController)();
    return /*#__PURE__*/ $cozmU.createElement($9d2832a2132f7625$export$4a210f0e33a62fe0, {
        name: name,
        aaid: aaid,
        email: email,
        ...props
    });
};
const $9d2832a2132f7625$export$4a210f0e33a62fe0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartCreateFeedbackInternal(t0) {
    const $ = (0, $bDgLe.c)(69);
    const { variant: t1, onClose: onClose, onSubmit: onSubmit, tenantId: tenantId, additionalFields: t2, name: name, aaid: aaid, email: email, customContent: customContent, showDefaultTextFields: t3, summaryDefaultValue: summaryDefaultValue, descriptionDefaultValue: descriptionDefaultValue, categories: categoriesProp } = t0;
    const variant = t1 === undefined ? (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO : t1;
    const additionalFields = t2 === undefined ? {} : t2;
    const showDefaultTextFields = t3 === undefined ? true : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { feedbackTitle: feedbackTitle, rateExperience: rateExperience, entrypointId: entrypointId } = $9d2832a2132f7625$var$getFeedbackConfig(variant);
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $bSAnS.messages).categoryPerformance);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t4) {
        t5 = {
            id: "performance",
            text: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== formatMessage) {
        t6 = formatMessage((0, $bSAnS.messages).categoryResponseQuality);
        $[4] = formatMessage;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t6) {
        t7 = {
            id: "response-quality",
            text: t6
        };
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== formatMessage) {
        t8 = formatMessage((0, $bSAnS.messages).categoryUserExperience);
        $[8] = formatMessage;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t8) {
        t9 = {
            id: "user-experience",
            text: t8
        };
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== formatMessage) {
        t10 = formatMessage((0, $bSAnS.messages).categoryOther);
        $[12] = formatMessage;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== t10) {
        t11 = {
            id: "other",
            text: t10
        };
        $[14] = t10;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11 || $[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
        t12 = [
            t5,
            t7,
            t9,
            t11
        ];
        $[16] = t11;
        $[17] = t5;
        $[18] = t7;
        $[19] = t9;
        $[20] = t12;
    } else t12 = $[20];
    const defaultCategories = t12;
    const categories = categoriesProp ?? defaultCategories;
    const [experienceRating, setExperienceRating] = (0, $cozmU.useState)(undefined);
    const [selectedCategory, setSelectedCategory] = (0, $cozmU.useState)(undefined);
    let t13;
    let t14;
    if ($[21] !== createAnalyticsEvent || $[22] !== variant) {
        t13 = ()=>{
            createAnalyticsEvent({
                eventType: "screen",
                name: "smartCreateFeedbackCollector",
                attributes: {
                    feedbackVariant: variant
                },
                tags: [
                    "atlaskit"
                ]
            }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
        };
        t14 = [
            variant,
            createAnalyticsEvent
        ];
        $[21] = createAnalyticsEvent;
        $[22] = variant;
        $[23] = t13;
        $[24] = t14;
    } else {
        t13 = $[23];
        t14 = $[24];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    if ($[25] !== createAnalyticsEvent || $[26] !== onClose || $[27] !== variant) {
        t15 = ()=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "closed",
                actionSubject: "smartCreateFeedbackCollector",
                attributes: {
                    feedbackVariant: variant
                },
                tags: [
                    "atlaskit"
                ]
            }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
            onClose();
        };
        $[25] = createAnalyticsEvent;
        $[26] = onClose;
        $[27] = variant;
        $[28] = t15;
    } else t15 = $[28];
    const onCloseWithAnalytics = t15;
    let t16;
    if ($[29] !== createAnalyticsEvent || $[30] !== experienceRating || $[31] !== onSubmit || $[32] !== selectedCategory || $[33] !== variant) {
        t16 = ()=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "submitted",
                actionSubject: "smartCreateFeedbackCollector",
                attributes: {
                    feedbackVariant: variant,
                    experienceRating: experienceRating,
                    selectedCategory: selectedCategory
                },
                tags: [
                    "atlaskit"
                ]
            }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
            onSubmit();
        };
        $[29] = createAnalyticsEvent;
        $[30] = experienceRating;
        $[31] = onSubmit;
        $[32] = selectedCategory;
        $[33] = variant;
        $[34] = t16;
    } else t16 = $[34];
    const onSubmitWithAnalytics = t16;
    const customFields = {
        "Feedback Variant": variant,
        "Selected Category": selectedCategory ?? "",
        "Experience Rating": experienceRating ?? "",
        "Experience Rating Number": experienceRating !== undefined ? (0, $2dlSO.ExperienceRatingToNumber)[experienceRating] : "",
        ...additionalFields
    };
    const T0 = (0, $91uAX.default);
    const t17 = formatMessage(feedbackTitle);
    const t18 = false;
    let t19;
    if ($[35] !== formatMessage) {
        t19 = formatMessage((0, $bSAnS.messages).summaryPlaceholderText);
        $[35] = formatMessage;
        $[36] = t19;
    } else t19 = $[36];
    let t20;
    if ($[37] !== formatMessage) {
        t20 = formatMessage((0, $bSAnS.messages).summaryTitle);
        $[37] = formatMessage;
        $[38] = t20;
    } else t20 = $[38];
    const t21 = formatMessage(rateExperience);
    let t22;
    if ($[39] !== experienceRating || $[40] !== t21) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $2dlSO.EmojiRatingSelector), {
            rating: experienceRating,
            setRating: setExperienceRating,
            label: t21
        });
        $[39] = experienceRating;
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    let t23;
    if ($[42] !== formatMessage) {
        t23 = formatMessage((0, $bSAnS.messages).categoryTitle);
        $[42] = formatMessage;
        $[43] = t23;
    } else t23 = $[43];
    let t24;
    if ($[44] !== categories || $[45] !== selectedCategory || $[46] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $eoEVy.CategoryPillGroup), {
            categories: categories,
            selectedCategory: selectedCategory,
            setSelectedCategory: setSelectedCategory,
            label: t23
        });
        $[44] = categories;
        $[45] = selectedCategory;
        $[46] = t23;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== customContent || $[49] !== t22 || $[50] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, t22, t24, customContent);
        $[48] = customContent;
        $[49] = t22;
        $[50] = t24;
        $[51] = t25;
    } else t25 = $[51];
    const t26 = experienceRating === undefined;
    const t27 = $9d2832a2132f7625$var$constructFeedbackContext(customFields, aaid, tenantId);
    let t28;
    if ($[52] !== T0 || $[53] !== aaid || $[54] !== descriptionDefaultValue || $[55] !== email || $[56] !== entrypointId || $[57] !== name || $[58] !== onCloseWithAnalytics || $[59] !== onSubmitWithAnalytics || $[60] !== showDefaultTextFields || $[61] !== summaryDefaultValue || $[62] !== t17 || $[63] !== t19 || $[64] !== t20 || $[65] !== t25 || $[66] !== t26 || $[67] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement(T0, {
            onClose: onCloseWithAnalytics,
            onSubmit: onSubmitWithAnalytics,
            atlassianAccountId: aaid,
            name: name,
            email: email,
            entrypointId: entrypointId,
            feedbackTitle: t17,
            showTypeField: t18,
            showDefaultTextFields: showDefaultTextFields,
            summaryPlaceholder: t19,
            customTextAreaLabel: t20,
            customContent: t25,
            descriptionDefaultValue: descriptionDefaultValue,
            summaryDefaultValue: summaryDefaultValue,
            disableSubmitButton: t26,
            additionalFields: t27
        });
        $[52] = T0;
        $[53] = aaid;
        $[54] = descriptionDefaultValue;
        $[55] = email;
        $[56] = entrypointId;
        $[57] = name;
        $[58] = onCloseWithAnalytics;
        $[59] = onSubmitWithAnalytics;
        $[60] = showDefaultTextFields;
        $[61] = summaryDefaultValue;
        $[62] = t17;
        $[63] = t19;
        $[64] = t20;
        $[65] = t25;
        $[66] = t26;
        $[67] = t27;
        $[68] = t28;
    } else t28 = $[68];
    return t28;
} : function SmartCreateFeedbackInternal({ variant: variant = (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO, onClose: onClose, onSubmit: onSubmit, tenantId: tenantId, additionalFields: additionalFields = {}, name: name, aaid: aaid, email: email, customContent: customContent, showDefaultTextFields: showDefaultTextFields = true, summaryDefaultValue: summaryDefaultValue, descriptionDefaultValue: descriptionDefaultValue, categories: categoriesProp }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { feedbackTitle: feedbackTitle, rateExperience: rateExperience, entrypointId: entrypointId } = $9d2832a2132f7625$var$getFeedbackConfig(variant);
    const defaultCategories = (0, $cozmU.useMemo)(()=>[
            {
                id: 'performance',
                text: formatMessage((0, $bSAnS.messages).categoryPerformance)
            },
            {
                id: 'response-quality',
                text: formatMessage((0, $bSAnS.messages).categoryResponseQuality)
            },
            {
                id: 'user-experience',
                text: formatMessage((0, $bSAnS.messages).categoryUserExperience)
            },
            {
                id: 'other',
                text: formatMessage((0, $bSAnS.messages).categoryOther)
            }
        ], [
        formatMessage
    ]); // Use caller-supplied categories when provided; fall back to the shared defaults.
    const categories = categoriesProp ?? defaultCategories;
    const [experienceRating, setExperienceRating] = (0, $cozmU.useState)(undefined);
    const [selectedCategory, setSelectedCategory] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
    }, [
        variant,
        createAnalyticsEvent
    ]);
    const onCloseWithAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'closed',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
        onClose();
    }, [
        onClose,
        variant,
        createAnalyticsEvent
    ]);
    const onSubmitWithAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant,
                experienceRating: experienceRating,
                selectedCategory: selectedCategory
            },
            tags: [
                'atlaskit'
            ]
        }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
        onSubmit();
    }, [
        onSubmit,
        variant,
        experienceRating,
        selectedCategory,
        createAnalyticsEvent
    ]);
    const customFields = {
        'Feedback Variant': variant,
        'Selected Category': selectedCategory ?? '',
        'Experience Rating': experienceRating ?? '',
        'Experience Rating Number': experienceRating !== undefined ? (0, $2dlSO.ExperienceRatingToNumber)[experienceRating] : '',
        ...additionalFields
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $91uAX.default), {
        onClose: onCloseWithAnalytics,
        onSubmit: onSubmitWithAnalytics,
        atlassianAccountId: aaid,
        name: name,
        email: email,
        entrypointId: entrypointId,
        feedbackTitle: formatMessage(feedbackTitle),
        showTypeField: false,
        showDefaultTextFields: showDefaultTextFields,
        summaryPlaceholder: formatMessage((0, $bSAnS.messages).summaryPlaceholderText),
        customTextAreaLabel: formatMessage((0, $bSAnS.messages).summaryTitle),
        customContent: /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $2dlSO.EmojiRatingSelector), {
            rating: experienceRating,
            setRating: setExperienceRating,
            label: formatMessage(rateExperience)
        }), /*#__PURE__*/ $cozmU.createElement((0, $eoEVy.CategoryPillGroup), {
            categories: categories,
            selectedCategory: selectedCategory,
            setSelectedCategory: setSelectedCategory,
            label: formatMessage((0, $bSAnS.messages).categoryTitle)
        }), customContent),
        descriptionDefaultValue: descriptionDefaultValue,
        summaryDefaultValue: summaryDefaultValue,
        disableSubmitButton: experienceRating === undefined,
        additionalFields: $9d2832a2132f7625$var$constructFeedbackContext(customFields, aaid, tenantId)
    });
};
module.exports["SmartCreateFeedback"] = $9d2832a2132f7625$export$35c06614b8d216da;

});

parcelRegister("eoEVy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $dUI0h = parcelRequire("dUI0h");


var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

// This file is based on confluence/next/packages/object-sidebar-components/src/sidebar-buttons/FeedbackCollectorButton.tsx
const $5d74c12af684e944$var$styles = {
    categoryPillGroupContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _3TGfC9HnLE _1DCdHi5zaO",
    categoryPill: "_2sNsIgmnOE _0bjKvDS5Zs _3vBAKHjOvk _2V7sgONvrM _3hxITi6wH8 _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _20VacPYbGa _1ANEUSLRg7 _24h04i2Njc _1UtDYzy7kJ _0KLXruDMqu _0Of8r2gVvo _1wydGWgVvo _1Znuxb8HPE _2Zuz6Q8HPE _1eOmH6KcZT",
    categoryPillSelected: "_3vBAKHrzt2 _1UtDYzjTy9 _0KLXruY9q9 _1eOmH6sumd"
};
const $5d74c12af684e944$export$7dad6a6503835f40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { categories: categories, selectedCategory: selectedCategory, setSelectedCategory: setSelectedCategory, label: label } = t0;
    let t1;
    if ($[0] !== setSelectedCategory) {
        t1 = (category)=>(e)=>{
                e.preventDefault();
                setSelectedCategory(category);
            };
        $[0] = setSelectedCategory;
        $[1] = t1;
    } else t1 = $[1];
    const onCategoryButtonClick = t1;
    let t2;
    if ($[2] !== categories || $[3] !== onCategoryButtonClick || $[4] !== selectedCategory) {
        t2 = (t3)=>{
            const { fieldProps: fieldProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                "data-name": fieldProps.id,
                xcss: $5d74c12af684e944$var$styles.categoryPillGroupContainer,
                role: "radiogroup"
            }, categories.map((category_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                    role: "radio",
                    "aria-checked": category_0.id === selectedCategory,
                    key: category_0.id,
                    "data-name": category_0.text,
                    "data-value": category_0.id,
                    onClick: onCategoryButtonClick(category_0.id),
                    xcss: (0, $w6R6I.cx)($5d74c12af684e944$var$styles.categoryPill, category_0.id === selectedCategory && $5d74c12af684e944$var$styles.categoryPillSelected)
                }, category_0.text))));
        };
        $[2] = categories;
        $[3] = onCategoryButtonClick;
        $[4] = selectedCategory;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== label || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: label,
            isRequired: false,
            name: "category-group",
            id: "category-group"
        }, t2);
        $[6] = label;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ categories: categories, selectedCategory: selectedCategory, setSelectedCategory: setSelectedCategory, label: label })=>{
    const onCategoryButtonClick = (0, $cozmU.useCallback)((category)=>(e)=>{
            e.preventDefault();
            setSelectedCategory(category);
        }, [
        setSelectedCategory
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: label,
        isRequired: false,
        name: "category-group",
        id: "category-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            "data-name": fieldProps.id,
            xcss: $5d74c12af684e944$var$styles.categoryPillGroupContainer,
            role: "radiogroup"
        }, categories.map((category_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                role: "radio",
                "aria-checked": category_0.id === selectedCategory,
                key: category_0.id,
                "data-name": category_0.text,
                "data-value": category_0.id,
                onClick: onCategoryButtonClick(category_0.id),
                xcss: (0, $w6R6I.cx)($5d74c12af684e944$var$styles.categoryPill, category_0.id === selectedCategory && $5d74c12af684e944$var$styles.categoryPillSelected)
            }, category_0.text)))));
};
module.exports["CategoryPillGroup"] = $5d74c12af684e944$export$7dad6a6503835f40;

});

parcelRegister("2dlSO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $dQLwo = parcelRequire("dQLwo");


var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $4C3ql = parcelRequire("4C3ql");

const $c0d088953076e6a9$var$styles = {
    emojiSelectionContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _1DCdHi5zaO",
    emojiButton: "_2sNsIgXwEm _0bjKvDKxmn _3vBAKHjOvk _2V7sgONvrM _3hxITi6wH8 _0KLXrujOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _1eOmH6KcZT",
    emojiButtonSelected: "_3vBAKHnXvL _0KLXruY9q9 _1eOmH6sumd"
};
var $c0d088953076e6a9$export$d51aadc3a803b62 = /*#__PURE__*/ function(ExperienceRating) {
    ExperienceRating["VeryDissatisfied"] = "Very dissatisfied";
    ExperienceRating["Dissatisfied"] = "Dissatisfied";
    ExperienceRating["Neutral"] = "Neutral";
    ExperienceRating["Satisfied"] = "Satisfied";
    ExperienceRating["VerySatisfied"] = "Very satisfied";
    return ExperienceRating;
}({});
const $c0d088953076e6a9$export$1224208ff0eb2a38 = {
    ["Very dissatisfied"]: 1,
    ["Dissatisfied"]: 2,
    ["Neutral"]: 3,
    ["Satisfied"]: 4,
    ["Very satisfied"]: 5
};
const $c0d088953076e6a9$var$OPTION_DATA = [
    {
        emoji: "\uD83D\uDE20",
        experienceRating: "Very dissatisfied"
    },
    {
        emoji: "\u2639\uFE0F",
        experienceRating: "Dissatisfied"
    },
    {
        emoji: "\uD83D\uDE10",
        experienceRating: "Neutral"
    },
    {
        emoji: "\uD83D\uDE42",
        experienceRating: "Satisfied"
    },
    {
        emoji: "\uD83D\uDE03",
        experienceRating: "Very satisfied"
    }
];
const $c0d088953076e6a9$export$dfef634eb7f87ea8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { rating: rating, setRating: setRating, label: label } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== setRating) {
        t1 = (option, fieldProps)=>(e)=>{
                e.preventDefault();
                setRating(option.experienceRating);
                fieldProps.onChange(option.experienceRating);
            };
        $[0] = setRating;
        $[1] = t1;
    } else t1 = $[1];
    const onEmojiButtonClick = t1;
    let t2;
    if ($[2] !== formatMessage) {
        t2 = (value)=>{
            if (!value) return formatMessage((0, $4C3ql.messages).validationErrorRatingRequired);
        };
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    const validateRating = t2;
    let t3;
    if ($[4] !== onEmojiButtonClick || $[5] !== rating) {
        t3 = (t4)=>{
            const { fieldProps: fieldProps_0, error: error } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                "data-name": fieldProps_0.id,
                xcss: $c0d088953076e6a9$var$styles.emojiSelectionContainer,
                role: "radiogroup"
            }, $c0d088953076e6a9$var$OPTION_DATA.map((option_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                    role: "radio",
                    "aria-checked": rating === option_0.experienceRating,
                    key: option_0.experienceRating,
                    "data-name": option_0.experienceRating,
                    "data-value": option_0.experienceRating,
                    testId: `emoji-rating-${$c0d088953076e6a9$export$1224208ff0eb2a38[option_0.experienceRating]}`,
                    onClick: onEmojiButtonClick(option_0, fieldProps_0),
                    xcss: (0, $w6R6I.cx)($c0d088953076e6a9$var$styles.emojiButton, rating === option_0.experienceRating && $c0d088953076e6a9$var$styles.emojiButtonSelected)
                }, option_0.emoji))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)));
        };
        $[4] = onEmojiButtonClick;
        $[5] = rating;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== label || $[8] !== t3 || $[9] !== validateRating) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: label,
            isRequired: true,
            name: "rate-experience",
            id: "rate-experience",
            validate: validateRating
        }, t3);
        $[7] = label;
        $[8] = t3;
        $[9] = validateRating;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ rating: rating, setRating: setRating, label: label })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onEmojiButtonClick = (0, $cozmU.useCallback)((option, fieldProps)=>(e)=>{
            e.preventDefault();
            setRating(option.experienceRating);
            fieldProps.onChange(option.experienceRating);
        }, [
        setRating
    ]);
    const validateRating = (value)=>{
        if (!value) return formatMessage((0, $4C3ql.messages).validationErrorRatingRequired);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: label,
        isRequired: true,
        name: "rate-experience",
        id: "rate-experience",
        validate: validateRating
    }, ({ fieldProps: fieldProps_0, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            "data-name": fieldProps_0.id,
            xcss: $c0d088953076e6a9$var$styles.emojiSelectionContainer,
            role: "radiogroup"
        }, $c0d088953076e6a9$var$OPTION_DATA.map((option_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                role: "radio",
                "aria-checked": rating === option_0.experienceRating,
                key: option_0.experienceRating,
                "data-name": option_0.experienceRating,
                "data-value": option_0.experienceRating,
                testId: `emoji-rating-${$c0d088953076e6a9$export$1224208ff0eb2a38[option_0.experienceRating]}`,
                onClick: onEmojiButtonClick(option_0, fieldProps_0),
                xcss: (0, $w6R6I.cx)($c0d088953076e6a9$var$styles.emojiButton, rating === option_0.experienceRating && $c0d088953076e6a9$var$styles.emojiButtonSelected)
            }, option_0.emoji))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error))));
};
module.exports["ExperienceRatingToNumber"] = $c0d088953076e6a9$export$1224208ff0eb2a38;
module.exports["EmojiRatingSelector"] = $c0d088953076e6a9$export$dfef634eb7f87ea8;

});

parcelRegister("4C3ql", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2536a32f2337ad3c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    validationErrorRatingRequired: {
        id: "smart-create-feedback.emoji-rating-selector.validation.rating.required",
        defaultMessage: "Please select a rating before submitting"
    }
});
module.exports["messages"] = $2536a32f2337ad3c$export$defe85febe8b728c;

});

parcelRegister("bSAnS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dc168e6918416fa8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "smart-create-feedback.feedback-title",
        defaultMessage: "Help us improve Create with Rovo"
    },
    rateExperience: {
        id: "smart-create-feedback.emoji-rating-selector.label",
        defaultMessage: "Please rate your experience with Create with Rovo:"
    },
    feedbackTitleNoCreate: {
        id: "smart-create-feedback.feedback-title-no-create",
        defaultMessage: "Help us improve Rovo"
    },
    rateExperienceNoCreate: {
        id: "smart-create-feedback.emoji-rating-selector.label-no-create",
        defaultMessage: "Please rate your experience with Rovo:"
    },
    feedbackTitleRemix: {
        id: "smart-create-feedback.feedback-title-remix",
        defaultMessage: "Help us improve Remix"
    },
    rateExperienceRemix: {
        id: "smart-create-feedback.emoji-rating-selector.label-remix",
        defaultMessage: "Please rate your experience with Remix:"
    },
    feedbackTitleSlides: {
        id: "smart-create-feedback.feedback-title-slides",
        defaultMessage: "Help us improve Slides"
    },
    rateExperienceSlides: {
        id: "smart-create-feedback.emoji-rating-selector.label-slides",
        defaultMessage: "Please rate your experience with Slides:"
    },
    feedbackTitleRovoInsights: {
        id: "smart-create-feedback.feedback-title-rovo-insights",
        defaultMessage: "Help us improve Rovo Insights"
    },
    rateExperienceRovoInsights: {
        id: "smart-create-feedback.emoji-rating-selector.label-rovo-insights",
        defaultMessage: "Please rate your experience with Rovo Insights:"
    },
    summaryTitle: {
        id: "smart-create-feedback.summary-title",
        defaultMessage: "Tell us more about your experience:"
    },
    categoryTitle: {
        id: "smart-create-feedback.category-title",
        defaultMessage: "What category best describes your feedback? (optional)"
    },
    categoryPerformance: {
        id: "smart-create-feedback.category.performance",
        defaultMessage: "Performance"
    },
    categoryResponseQuality: {
        id: "smart-create-feedback.category.response-quality",
        defaultMessage: "Response quality"
    },
    categoryUserExperience: {
        id: "smart-create-feedback.category.user-experience",
        defaultMessage: "User experience"
    },
    categoryOther: {
        id: "smart-create-feedback.category.other",
        defaultMessage: "Other"
    },
    categoryUnderstandingMyRequest: {
        id: "smart-create-feedback.category.understanding-my-request",
        defaultMessage: "Understanding my request"
    },
    categoryNumberOfQuestions: {
        id: "smart-create-feedback.category.number-of-questions",
        defaultMessage: "Number of questions"
    },
    categoryPlanQuality: {
        id: "smart-create-feedback.category.plan-quality",
        defaultMessage: "Plan quality"
    },
    categorySpeed: {
        id: "smart-create-feedback.category.speed",
        defaultMessage: "Speed"
    },
    categoryEaseInEditing: {
        id: "smart-create-feedback.category.ease-in-editing",
        defaultMessage: "Ease in editing"
    },
    categoryInterfaceUsability: {
        id: "smart-create-feedback.category.interface-usability",
        defaultMessage: "Interface usability"
    },
    categoryStepCompletion: {
        id: "smart-create-feedback.category.step-completion",
        defaultMessage: "Step completion"
    },
    summaryPlaceholderText: {
        id: "smart-create-feedback.summary-placeholder-text",
        defaultMessage: "What are we doing well? What could be improved?"
    }
});
module.exports["messages"] = $dc168e6918416fa8$export$defe85febe8b728c;

});

parcelRegister("kEjXh", function(module, exports) {
var $9c0da96e768fd607$export$cc1cd6888a5f186c = /*#__PURE__*/ function(SmartCreateFeedbackVariant) {
    SmartCreateFeedbackVariant["ROVO"] = "rovo";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO"] = "create-with-rovo";
    // Confluence
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO_FROM_JIRA"] = "create-with-rovo-from-jira";
    // Jira
    SmartCreateFeedbackVariant["REMIX"] = "remix";
    SmartCreateFeedbackVariant["SLIDES"] = "slides";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO_FROM_JSM"] = "create-with-rovo-from-jsm";
    SmartCreateFeedbackVariant["ROVO_INSIGHTS_FROM_JSM"] = "rovo-insights-from-jsm";
    return SmartCreateFeedbackVariant;
}({});
module.exports["SmartCreateFeedbackVariant"] = $9c0da96e768fd607$export$cc1cd6888a5f186c;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("hUVfy", function(module, exports) {

let $d0b41348fd61a524$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d0b41348fd61a524$var$load("hhss7"),
    $d0b41348fd61a524$var$load("7gL7H")
]).then(()=>parcelRequire('91uAX'));

});

parcelRegister("af8pL", function(module, exports) {

let $7751d5073ebe8c34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7751d5073ebe8c34$var$load("iws4Z").then(()=>parcelRequire('bfBrX'));

});

parcelRegister("7o2Oy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");


var $hBYtq = parcelRequire("hBYtq");


var $oV0CU = parcelRequire("oV0CU");


var $Vl9MW = parcelRequire("Vl9MW");


var $6FfVp = parcelRequire("6FfVp");

const $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH = 4;
const $abb6876f0c761819$var$messages = (0, $kSwu1.defineMessages)({
    resizeSidePanelAriaLabel: {
        id: "ai-mate.conversation-assistant.split-layout.resize-side-panel-aria-label",
        defaultMessage: "Resize side panel"
    }
});
const $abb6876f0c761819$var$styles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _24h04i2Njc _4xdlr0FlnN _0jFU0VN91d _39xV02N91d _4kiQYAdnbC _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLFlnN",
    leftPane: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4xdlr0FlnN _0jFU0VN91d _4kiQYAdnbC _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLFlnN",
    rightPanel: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _24h04i2Njc _4xdlr0FlnN _0jFU0VN91d _4kiQYAdnbC _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLFlnN _1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    resizeHandle: "_30huDKYbGa _23rrnHb6HL _39xV02UNDJ _4xdlr0FlnN _1mT5xdRAKS _0wOv4QYNYw _0KLXrujOvk _1JM8vvb6HL _0GBAIrogpp _2WYcYGWVPG _2ZHpDR715P _2KaDuOdnbC _4zi1EpdnbC _2jfUf94Jdh _3wEj0XjOvk _0PxRoQjssS _0jKh9gDM2k",
    resizeHandleDragging: "_3wEj0XDM2k"
};
const $abb6876f0c761819$var$isBrowser = typeof window !== 'undefined';
const $abb6876f0c761819$var$readPersistedWidth = (storageKey)=>{
    if (!storageKey || !$abb6876f0c761819$var$isBrowser) return null;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = window.localStorage.getItem(storageKey);
        if (raw == null) return null;
        const parsed = Number.parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    } catch  {
        return null;
    }
};
const $abb6876f0c761819$var$writePersistedWidth = (storageKey, width)=>{
    if (!storageKey || !$abb6876f0c761819$var$isBrowser) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem(storageKey, String(Math.round(width)));
    } catch  {}
}; /**
    * Renders a horizontal split layout:
    *   [ chat children (flex-grow left pane) ] [ resize handle ] [ right panel (sized) ]
    *
    * - The chat (left) uses `flex: 1` so it always absorbs surplus horizontal
    *   space and is the visually dominant pane.
    * - The right panel has an explicit pixel width that the user can drag.
    *
    * The drag math is a mirror of `useResizablePanel`: `rightWidth = containerRight
    * - clientX`, clamped so the chat keeps at least `minWidth`, the right panel keeps at least
    * `adjacentMinWidth`, and the right panel never becomes wider than the chat.
    */ 
const $abb6876f0c761819$export$581077d6f0ab5bc7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { initialWidth: t1, minWidth: t2, adjacentMinWidth: t3, storageKey: t4, children: children, isRightPanelVisible: t5, onAutoCollapse: onAutoCollapse, rightPanelExitHandlerRef: rightPanelExitHandlerRef } = t0;
    const initialWidth = t1 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_INITIAL_WIDTH) : t1;
    const minWidth = t2 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_MIN_WIDTH) : t2;
    const adjacentMinWidth = t3 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_ADJACENT_MIN_WIDTH) : t3;
    const storageKey = t4 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_STORAGE_KEY) : t4;
    const isRightPanelVisible = t5 === undefined ? true : t5;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const onAutoCollapseRef = (0, $cozmU.useRef)(onAutoCollapse);
    let t6;
    if ($[0] !== adjacentMinWidth || $[1] !== initialWidth || $[2] !== storageKey) {
        t6 = ()=>{
            const persisted = $abb6876f0c761819$var$readPersistedWidth(storageKey);
            const seed = persisted ?? initialWidth;
            return Math.max(seed, adjacentMinWidth);
        };
        $[0] = adjacentMinWidth;
        $[1] = initialWidth;
        $[2] = storageKey;
        $[3] = t6;
    } else t6 = $[3];
    const [rightWidth, setRightWidth] = (0, $cozmU.useState)(t6);
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [isRightPanelMounted, setIsRightPanelMounted] = (0, $cozmU.useState)(isRightPanelVisible);
    const rightWidthRef = (0, $cozmU.useRef)(rightWidth);
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (e)=>{
            e.preventDefault();
            setIsDragging(true);
        };
        $[4] = t7;
    } else t7 = $[4];
    const handleMouseDown = t7;
    let t8;
    if ($[5] !== adjacentMinWidth || $[6] !== isDragging || $[7] !== minWidth) {
        t8 = (e_0)=>{
            if (!isDragging || !containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            const proposed = rect.right - e_0.clientX;
            const maxRight = Math.max(adjacentMinWidth, Math.min(rect.width - minWidth, (rect.width - $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH) / 2));
            setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
        };
        $[5] = adjacentMinWidth;
        $[6] = isDragging;
        $[7] = minWidth;
        $[8] = t8;
    } else t8 = $[8];
    const handleMouseMove = t8;
    let t9;
    if ($[9] !== storageKey) {
        t9 = ()=>{
            setIsDragging(false);
            $abb6876f0c761819$var$writePersistedWidth(storageKey, rightWidthRef.current);
        };
        $[9] = storageKey;
        $[10] = t9;
    } else t9 = $[10];
    const handleMouseUp = t9;
    let t10;
    let t11;
    if ($[11] !== isRightPanelVisible) {
        t10 = ()=>{
            if (isRightPanelVisible) setIsRightPanelMounted(true);
        };
        t11 = [
            isRightPanelVisible
        ];
        $[11] = isRightPanelVisible;
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[14] !== rightWidth) {
        t12 = ()=>{
            rightWidthRef.current = rightWidth;
        };
        t13 = [
            rightWidth
        ];
        $[14] = rightWidth;
        $[15] = t12;
        $[16] = t13;
    } else {
        t12 = $[15];
        t13 = $[16];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[17] !== onAutoCollapse) {
        t14 = ()=>{
            onAutoCollapseRef.current = onAutoCollapse;
        };
        t15 = [
            onAutoCollapse
        ];
        $[17] = onAutoCollapse;
        $[18] = t14;
        $[19] = t15;
    } else {
        t14 = $[18];
        t15 = $[19];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    let t17;
    if ($[20] !== isRightPanelVisible) {
        t16 = ()=>{
            if (!isRightPanelVisible || !$abb6876f0c761819$var$isBrowser || typeof ResizeObserver === "undefined") return;
            const container = containerRef.current;
            if (!container) return;
            let previousWidth = null;
            const observer = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    const { width: width } = entry.contentRect;
                    const isShrinking = previousWidth !== null && width < previousWidth;
                    if (isShrinking && width < (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH)) onAutoCollapseRef.current?.();
                    previousWidth = width;
                }
            });
            observer.observe(container);
            return ()=>{
                observer.disconnect();
            };
        };
        t17 = [
            isRightPanelVisible
        ];
        $[20] = isRightPanelVisible;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    let t19;
    if ($[23] !== handleMouseMove || $[24] !== handleMouseUp || $[25] !== isDragging) {
        t18 = ()=>{
            if (!isDragging) return;
            const doc = (0, $1hQ0e.getDocument)();
            if (!doc) return;
            const unbindMouseMove = (0, $cbY7C.bind)(doc, {
                type: "mousemove",
                listener: handleMouseMove
            });
            const unbindMouseUp = (0, $cbY7C.bind)(doc, {
                type: "mouseup",
                listener: handleMouseUp
            });
            return ()=>{
                unbindMouseMove();
                unbindMouseUp();
            };
        };
        t19 = [
            isDragging,
            handleMouseMove,
            handleMouseUp
        ];
        $[23] = handleMouseMove;
        $[24] = handleMouseUp;
        $[25] = isDragging;
        $[26] = t18;
        $[27] = t19;
    } else {
        t18 = $[26];
        t19 = $[27];
    }
    (0, $cozmU.useEffect)(t18, t19);
    const t20 = `${rightWidth}px`;
    const t21 = isDragging ? "none" : undefined;
    let t22;
    if ($[28] !== t20 || $[29] !== t21) {
        t22 = {
            width: t20,
            maxWidth: `calc(50% - ${$abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH / 2}px)`,
            pointerEvents: t21
        };
        $[28] = t20;
        $[29] = t21;
        $[30] = t22;
    } else t22 = $[30];
    const rightStyle = t22;
    let t23;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.root
        ]);
        $[31] = t23;
    } else t23 = $[31];
    let t24;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.leftPane
        ]);
        $[32] = t24;
    } else t24 = $[32];
    let t25;
    if ($[33] !== children) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout-left",
            className: t24
        }, children);
        $[33] = children;
        $[34] = t25;
    } else t25 = $[34];
    let t26;
    if ($[35] !== formatMessage || $[36] !== isDragging || $[37] !== isRightPanelMounted) {
        t26 = isRightPanelMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $k12R1.cx)($abb6876f0c761819$var$styles.resizeHandle, isDragging && $abb6876f0c761819$var$styles.resizeHandleDragging),
            "data-dragging": isDragging,
            testId: "conversation-assistant-split-layout-resize-handle",
            onMouseDown: handleMouseDown,
            "aria-label": formatMessage($abb6876f0c761819$var$messages.resizeSidePanelAriaLabel)
        });
        $[35] = formatMessage;
        $[36] = isDragging;
        $[37] = isRightPanelMounted;
        $[38] = t26;
    } else t26 = $[38];
    let t27;
    if ($[39] !== isRightPanelVisible || $[40] !== rightPanelExitHandlerRef || $[41] !== rightStyle) {
        t27 = isRightPanelVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            onFinish: (state)=>{
                if (state === "exiting") {
                    setIsRightPanelMounted(false);
                    const exitHandler = rightPanelExitHandlerRef?.current;
                    if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                    exitHandler?.();
                }
            }
        }, (t28)=>{
            const { className: className, ref: ref } = t28;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $abb6876f0c761819$var$styles.rightPanel,
                    className
                ]),
                ref: ref,
                "data-testid": "conversation-assistant-split-layout-right",
                style: rightStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vl9MW.SessionRightPanelLazy), null)));
        });
        $[39] = isRightPanelVisible;
        $[40] = rightPanelExitHandlerRef;
        $[41] = rightStyle;
        $[42] = t27;
    } else t27 = $[42];
    let t28;
    if ($[43] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t27);
        $[43] = t27;
        $[44] = t28;
    } else t28 = $[44];
    let t29;
    if ($[45] !== t25 || $[46] !== t26 || $[47] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout",
            ref: containerRef,
            className: t23
        }, t25, t26, t28);
        $[45] = t25;
        $[46] = t26;
        $[47] = t28;
        $[48] = t29;
    } else t29 = $[48];
    return t29;
} : ({ initialWidth: initialWidth = (0, $oV0CU.SPLIT_LAYOUT_INITIAL_WIDTH), minWidth: minWidth = (0, $oV0CU.SPLIT_LAYOUT_MIN_WIDTH), adjacentMinWidth: adjacentMinWidth = (0, $oV0CU.SPLIT_LAYOUT_ADJACENT_MIN_WIDTH), storageKey: storageKey = (0, $oV0CU.SPLIT_LAYOUT_STORAGE_KEY), children: children, isRightPanelVisible: isRightPanelVisible = true, onAutoCollapse: onAutoCollapse, rightPanelExitHandlerRef: rightPanelExitHandlerRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null); // Mirror the callback to a ref so the resize observer below doesn't need to re-subscribe every time the host passes a new callback identity.
    const onAutoCollapseRef = (0, $cozmU.useRef)(onAutoCollapse); // Lazy initializer so we only touch `localStorage` once on mount. The persisted value (if any) wins over the explicit `initialWidth` prop.
    const [rightWidth, setRightWidth] = (0, $cozmU.useState)(()=>{
        const persisted = $abb6876f0c761819$var$readPersistedWidth(storageKey);
        const seed = persisted ?? initialWidth;
        return Math.max(seed, adjacentMinWidth);
    });
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [isRightPanelMounted, setIsRightPanelMounted] = (0, $cozmU.useState)(isRightPanelVisible); // Latest width is mirrored to a ref so the `mouseup` handler can persist without being recreated (and re-binding listeners) on every drag tick.
    const rightWidthRef = (0, $cozmU.useRef)(rightWidth);
    const handleMouseDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setIsDragging(true);
    }, []);
    const handleMouseMove = (0, $cozmU.useCallback)((e_0)=>{
        if (!isDragging || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        const proposed = rect.right - e_0.clientX;
        const maxRight = Math.max(adjacentMinWidth, Math.min(rect.width - minWidth, (rect.width - $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH) / 2));
        setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
    }, [
        isDragging,
        minWidth,
        adjacentMinWidth
    ]);
    const handleMouseUp = (0, $cozmU.useCallback)(()=>{
        setIsDragging(false); // Persist the resting width once per drag (not on every mousemove tick).
        $abb6876f0c761819$var$writePersistedWidth(storageKey, rightWidthRef.current);
    }, [
        storageKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isRightPanelVisible) setIsRightPanelMounted(true);
    }, [
        isRightPanelVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        rightWidthRef.current = rightWidth;
    }, [
        rightWidth
    ]);
    (0, $cozmU.useEffect)(()=>{
        onAutoCollapseRef.current = onAutoCollapse;
    }, [
        onAutoCollapse
    ]); // When the panel the chat lives in is resized narrower than the split-layout minimum, auto-collapse the right panel
    (0, $cozmU.useEffect)(()=>{
        if (!isRightPanelVisible || !$abb6876f0c761819$var$isBrowser || typeof ResizeObserver === 'undefined') return;
        const container = containerRef.current;
        if (!container) return;
         // Collapse the right panel only when the user actively *narrows* the container below the split
        // minimum — i.e. the width is shrinking. Acting on the shrink direction (rather than any narrow
        // reading) means we ignore the panel growing as it expands on open, so a just-opened split is
        // never collapsed mid-expansion, and a split that simply opened narrow isn't yanked away —
        // only a deliberate narrowing hides it.
        let previousWidth = null;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { width: width } = entry.contentRect;
                const isShrinking = previousWidth !== null && width < previousWidth;
                if (isShrinking && width < (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH)) onAutoCollapseRef.current?.();
                previousWidth = width;
            }
        });
        observer.observe(container);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isRightPanelVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isDragging) return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const unbindMouseMove = (0, $cbY7C.bind)(doc, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const unbindMouseUp = (0, $cbY7C.bind)(doc, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            unbindMouseMove();
            unbindMouseUp();
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const rightStyle = {
        width: `${rightWidth}px`,
        maxWidth: `calc(50% - ${$abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH / 2}px)`,
        pointerEvents: isDragging ? 'none' : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout",
        ref: containerRef,
        className: (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout-left",
        className: (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.leftPane
        ])
    }, children), isRightPanelMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $k12R1.cx)($abb6876f0c761819$var$styles.resizeHandle, isDragging && $abb6876f0c761819$var$styles.resizeHandleDragging),
        "data-dragging": isDragging,
        testId: "conversation-assistant-split-layout-resize-handle",
        onMouseDown: handleMouseDown,
        "aria-label": formatMessage($abb6876f0c761819$var$messages.resizeSidePanelAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isRightPanelVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: "right",
        fade: "inout",
        duration: "medium",
        onFinish: (state)=>{
            if (state === 'exiting') {
                setIsRightPanelMounted(false);
                const exitHandler = rightPanelExitHandlerRef?.current;
                if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                exitHandler?.();
            }
        }
    }, ({ className: className, ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required to forward the motion animation class from @atlaskit/motion's SlideIn render prop
        , {
            className: (0, $hekY6.default)([
                $abb6876f0c761819$var$styles.rightPanel,
                className
            ]),
            ref: ref,
            "data-testid": "conversation-assistant-split-layout-right",
            style: rightStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vl9MW.SessionRightPanelLazy), null))))));
};
module.exports["SplitLayout"] = $abb6876f0c761819$export$581077d6f0ab5bc7;

});

parcelRegister("Vl9MW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $c519d749112a26b1$export$a0bce28b49dab85d = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("01iJf")).then((module)=>({
            default: module.SessionRightPanel
        })));
module.exports["SessionRightPanelLazy"] = $c519d749112a26b1$export$a0bce28b49dab85d;

});

parcelRegister("01iJf", function(module, exports) {

let $003e9f48d25a9684$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $003e9f48d25a9684$var$load("lhLGe"),
    $003e9f48d25a9684$var$load("8STUC"),
    $003e9f48d25a9684$var$load("2la9m"),
    $003e9f48d25a9684$var$load("9pQri"),
    $003e9f48d25a9684$var$load("bbLnX"),
    $003e9f48d25a9684$var$load("1UUnk"),
    $003e9f48d25a9684$var$load("80Yra"),
    $003e9f48d25a9684$var$load("cgKMu"),
    $003e9f48d25a9684$var$load("5e5ry"),
    $003e9f48d25a9684$var$load("hUbK8"),
    $003e9f48d25a9684$var$load("dgfR3"),
    $003e9f48d25a9684$var$load("awOLN"),
    $003e9f48d25a9684$var$load("eS1b9"),
    $003e9f48d25a9684$var$load("jomLJ"),
    $003e9f48d25a9684$var$load("ignwK"),
    $003e9f48d25a9684$var$load("j5RRe"),
    $003e9f48d25a9684$var$load("agaLh"),
    $003e9f48d25a9684$var$load("1Gr4q"),
    $003e9f48d25a9684$var$load("7TyQi"),
    $003e9f48d25a9684$var$load("e5ukl"),
    $003e9f48d25a9684$var$load("d19Pa"),
    $003e9f48d25a9684$var$load("hYORG"),
    $003e9f48d25a9684$var$load("219np"),
    $003e9f48d25a9684$var$load("4Mi85"),
    $003e9f48d25a9684$var$load("kccW9"),
    $003e9f48d25a9684$var$load("TfSzW"),
    $003e9f48d25a9684$var$load("ceyL9"),
    $003e9f48d25a9684$var$load("fHS77"),
    $003e9f48d25a9684$var$load("9jVdm"),
    $003e9f48d25a9684$var$load("kSgPY"),
    $003e9f48d25a9684$var$load("k2NjG"),
    $003e9f48d25a9684$var$load("dZYhM"),
    $003e9f48d25a9684$var$load("fAzyA"),
    $003e9f48d25a9684$var$load("Tjs4D"),
    $003e9f48d25a9684$var$load("6bjEk"),
    $003e9f48d25a9684$var$load("fkLbQ"),
    $003e9f48d25a9684$var$load("bMNgp"),
    $003e9f48d25a9684$var$load("g8J2P"),
    $003e9f48d25a9684$var$load("ieJFF"),
    $003e9f48d25a9684$var$load("eqj21"),
    $003e9f48d25a9684$var$load("3oAU3"),
    $003e9f48d25a9684$var$load("6fgrL"),
    $003e9f48d25a9684$var$load("ewOAX"),
    $003e9f48d25a9684$var$load("2Bp34"),
    $003e9f48d25a9684$var$load("3iw68"),
    $003e9f48d25a9684$var$load("kHXvF"),
    $003e9f48d25a9684$var$load("5Mm1x"),
    $003e9f48d25a9684$var$load("90vep"),
    $003e9f48d25a9684$var$load("aAJyu"),
    $003e9f48d25a9684$var$load("f8Q8b"),
    $003e9f48d25a9684$var$load("6wr18"),
    $003e9f48d25a9684$var$load("Wowvf"),
    $003e9f48d25a9684$var$load("gnocL"),
    $003e9f48d25a9684$var$load("7EorR"),
    $003e9f48d25a9684$var$load("hhss7"),
    $003e9f48d25a9684$var$load("ffEVr"),
    $003e9f48d25a9684$var$load("gEkwn"),
    $003e9f48d25a9684$var$load("ixrKS"),
    $003e9f48d25a9684$var$load("fdLC1"),
    $003e9f48d25a9684$var$load("5CO1V")
]).then(()=>parcelRequire('lBYt7'));

});

parcelRegister("6FfVp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $lWpNe = parcelRequire("lWpNe");


var $i6htE = parcelRequire("i6htE");

const $5b8c79aaf8c3f9d7$var$styles = {
    root: "_0jFU0VN91d _39xV02N91d _24h04i2Njc _2WAcuGIZbP",
    wrapper: "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _313842kG2W _1DCdHikG2W _2XsHFMkG2W _0adFHskG2W",
    card: "_0bjKvDyzSk _4bt5LAoWuR _2WAcuGoWuR _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc",
    row: "_2mHwu88HPE _4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    borderBottom: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    cardBody: "_4c065U8HPE _2Y7lL45zaO",
    timelineRow: "_3iDTPbgBM8 _2iEGP2sM9l _17lj8p8HPE _0hPCNLFlnN",
    rail: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg",
    connector: "_39xV024Jdh _2O5Vij7dHp _0KLXruDMqu",
    timelineText: "_1wydGW5zaO _4ouGXIdnbC",
    section: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    artefactRow: "_2mHwu88HPE _0bjKvDyzSk _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYA9LX5"
};
/** Rovo Space, Agent context and Conversation rows of the Context card. */ const $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS = [
    {
        labelWidth: 96,
        descriptionWidth: 104,
        trailingWidth: 16
    },
    {
        labelWidth: 112,
        descriptionWidth: 88,
        trailingWidth: 16
    },
    {
        labelWidth: 104,
        trailingWidth: 88
    }
]; /** Entries of the expanded progress timeline. */ 
const $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS = [
    {
        titleWidth: 120,
        descriptionWidth: 168
    },
    {
        titleWidth: 96
    },
    {
        titleWidth: 140,
        descriptionWidth: 72
    },
    {
        titleWidth: 104
    }
];
const $5b8c79aaf8c3f9d7$var$ARTEFACT_ROWS = [
    {
        titleWidth: 150
    },
    {
        titleWidth: 190
    }
];
const $5b8c79aaf8c3f9d7$var$HeadingSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { width: width } = t0;
    let t1;
    if ($[0] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: width,
            height: 16,
            isShimmering: true
        });
        $[0] = width;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: width,
        height: 16,
        isShimmering: true
    }); /**
                                                                               * Loading placeholder for {@link SessionRightPanel}. Mirrors the panel's sections
                                                                               * -feedback banner, parent work item, context card, actions, progress timeline and output
                                                                               */ 
const $5b8c79aaf8c3f9d7$export$659bc7cd6c22a575 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWpNe.FeedbackBanner), null);
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i6htE.SmartLinkCardSkeleton), null);
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 60
        })), $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.map($5b8c79aaf8c3f9d7$var$_temp));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.section
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 56
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom);
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 64
        });
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 44,
            height: 20,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.card
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
        }, $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.map($5b8c79aaf8c3f9d7$var$_temp2)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 52
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.wrapper
        }, t0, t1, t2, t3, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.card
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, $5b8c79aaf8c3f9d7$var$ARTEFACT_ROWS.map($5b8c79aaf8c3f9d7$var$_temp3))))));
        $[9] = t9;
    } else t9 = $[9];
    return t9;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWpNe.FeedbackBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i6htE.SmartLinkCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 60
    })), $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.map(({ labelWidth: labelWidth, descriptionWidth: descriptionWidth, trailingWidth: trailingWidth }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: labelWidth,
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, index < $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.length - 1 && $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: labelWidth,
            height: 16,
            isShimmering: true
        }), descriptionWidth !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: descriptionWidth,
            height: 12,
            isShimmering: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: trailingWidth,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 56
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 64
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 44,
        height: 20,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
    }, $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.map(({ titleWidth: titleWidth, descriptionWidth: descriptionWidth_0 }, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: titleWidth,
            xcss: $5b8c79aaf8c3f9d7$var$styles.timelineRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.rail
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }), index_0 < $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.connector
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.timelineText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: titleWidth,
            height: 14,
            isShimmering: true
        }), descriptionWidth_0 !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: descriptionWidth_0,
            height: 12,
            isShimmering: true
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 52
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, $5b8c79aaf8c3f9d7$var$ARTEFACT_ROWS.map(({ titleWidth: titleWidth_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: titleWidth_0,
            xcss: $5b8c79aaf8c3f9d7$var$styles.artefactRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: titleWidth_0,
            height: 14,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 100,
            height: 12,
            isShimmering: true
        })))))))));
function $5b8c79aaf8c3f9d7$var$_temp(t0, index) {
    const { labelWidth: labelWidth, descriptionWidth: descriptionWidth, trailingWidth: trailingWidth } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: labelWidth,
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, index < $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.length - 1 && $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: labelWidth,
        height: 16,
        isShimmering: true
    }), descriptionWidth !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: descriptionWidth,
        height: 12,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: trailingWidth,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }));
}
function $5b8c79aaf8c3f9d7$var$_temp2(t0, index_0) {
    const { titleWidth: titleWidth, descriptionWidth: descriptionWidth_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: titleWidth,
        xcss: $5b8c79aaf8c3f9d7$var$styles.timelineRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.rail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), index_0 < $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.connector
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.timelineText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: titleWidth,
        height: 14,
        isShimmering: true
    }), descriptionWidth_0 !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: descriptionWidth_0,
        height: 12,
        isShimmering: true
    }))));
}
function $5b8c79aaf8c3f9d7$var$_temp3(t0) {
    const { titleWidth: titleWidth_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: titleWidth_0,
        xcss: $5b8c79aaf8c3f9d7$var$styles.artefactRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: titleWidth_0,
        height: 14,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 100,
        height: 12,
        isShimmering: true
    })));
}
module.exports["SessionRightPanelSkeleton"] = $5b8c79aaf8c3f9d7$export$659bc7cd6c22a575;

});

parcelRegister("lWpNe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $d012be43ff57fdc3$var$styles = {
    root: "_0bjKvDyzSk _4c065U8HPE _2Y7lL45zaO _0KLXruzHaB _2fwxA5DIqT"
};
const $d012be43ff57fdc3$var$messages = (0, $kSwu1.defineMessages)({
    feedbackBannerText: {
        id: "ai-mate.conversation-assistant.session-right-panel.feedback-banner-text-non-final",
        defaultMessage: "\uD83E\uDDEA Internal experiment - Don't demo externally {feedbackChannelLink}"
    }
});
const $d012be43ff57fdc3$export$362b733259f0b9ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            weight: "bold",
            color: "color.text.inverse"
        }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: "https://atlassian.enterprise.slack.com/archives/C0BK8TXT3S5",
            target: "_blank",
            rel: "noopener noreferrer",
            appearance: "inverse"
        }, "#feedback-agent-session-experience"));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage($d012be43ff57fdc3$var$messages.feedbackBannerText, {
            feedbackChannelLink: t0
        });
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d012be43ff57fdc3$var$styles.root
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.inverse"
        }, t1));
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d012be43ff57fdc3$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.inverse"
    }, formatMessage($d012be43ff57fdc3$var$messages.feedbackBannerText, {
        feedbackChannelLink: /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            weight: "bold",
            color: "color.text.inverse"
        }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: "https://atlassian.enterprise.slack.com/archives/C0BK8TXT3S5",
            target: "_blank",
            rel: "noopener noreferrer",
            appearance: "inverse"
        }, "#feedback-agent-session-experience"))
    })));
};
module.exports["FeedbackBanner"] = $d012be43ff57fdc3$export$362b733259f0b9ed;

});

parcelRegister("i6htE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $755fb07bffbdea29$var$styles = {
    card: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYAFFh0 _39xV02N91d _24h04i2Njc _0LQT5E8HPE _03SyCP8HPE _0KLXrulfZc"
};
const $755fb07bffbdea29$export$b809446cefbba987 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 180,
            height: 16,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 120,
            height: 12,
            isShimmering: true
        }));
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $755fb07bffbdea29$var$styles.card,
            testId: testId
        }, t1, t2);
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $755fb07bffbdea29$var$styles.card,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 180,
        height: 16,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 120,
        height: 12,
        isShimmering: true
    })));
module.exports["SmartLinkCardSkeleton"] = $755fb07bffbdea29$export$b809446cefbba987;

});

parcelRegister("fBd2O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $cK21K = parcelRequire("cK21K");


var $8akfd = parcelRequire("8akfd");


var $dSCNl = parcelRequire("dSCNl");


var $dPoYT = parcelRequire("dPoYT");


var $2FUOC = parcelRequire("2FUOC");

const $f5c1836cf94a50bb$var$styles = {
    wrapper: "_24h04i2Njc _39xV02Cylp _3138425zaO _0jFU0VlGYu _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXFlnN _0hPCNLFlnN",
    wrapperNav4: "_24h04i2Njc _39xV02N91d _0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXFlnN _0hPCNLFlnN",
    wrapperHeight: "_4kiQYAaQBb",
    externalEmbed: "_313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _39xV02N91d _0jFU0VN91d",
    fullscreenDebug: "_49OCfRPgdg _1mT5xdy1CL _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0jFU0VZqHV _39xV02ZqHV",
    withExternalStagingArea: "_39xV02N91d"
};
const $f5c1836cf94a50bb$var$stylesBorder = {
    borderNavV3: "_3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _2C2kUQ8fU6 _1Lz9lo8fU6",
    borderNavV4: "",
    borderFullScreenDebug: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKHQvmT _2V7sgO8fU6",
    borderExternalEmbed: "",
    borderStagingArea: "_0bjKvDyzSk _2OUyjtzwhj"
};
const $f5c1836cf94a50bb$var$miniModalWrapperStyles = null; // When rendered inside a full-screen MaximisedModal, the modal already provides
// width/height/border-radius/shadow. The wrapper should fill the modal body
// without the sidebar-mode top margin or border-radius.
const $f5c1836cf94a50bb$var$fullScreenModalWrapperStyles = null;
const $f5c1836cf94a50bb$export$6661021c36f0a701 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode } = t0;
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $iDrrr.fg)("agent_session_experience_fg");
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isContextPanelEnabled: isContextPanelEnabled } = (0, $dSCNl.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    let t1;
    if ($[0] !== children || $[1] !== isContextPanelEnabled || $[2] !== isMiniModal) {
        t1 = ()=>{
            if (!isContextPanelEnabled || !(0, $iDrrr.fg)("agent_session_experience_fg")) return children;
            return /*#__PURE__*/ $cozmU.createElement((0, $2FUOC.SessionContextLayout), {
                isMiniModal: isMiniModal
            }, children);
        };
        $[0] = children;
        $[1] = isContextPanelEnabled;
        $[2] = isMiniModal;
        $[3] = t1;
    } else t1 = $[3];
    const renderInnerChildren = t1;
    const shouldShowStagingArea = stagingAreaMode === "inline";
    const fullscreenDebugEnabled = localStorage.getItem("DEBUG_rovo_chat_fullscreen") === "true" && (0, $iDrrr.fg)("rovo_chat_show_local_frontend_components");
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) {
        const t2 = shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper;
        const t3 = isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0we0oO _0qk6IKjwM9" : $f5c1836cf94a50bb$var$styles.wrapperHeight;
        const t4 = externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed;
        let t5;
        if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
            t5 = (0, $hekY6.default)([
                t2,
                t3,
                t4,
                $f5c1836cf94a50bb$var$styles.fullscreenDebug,
                $f5c1836cf94a50bb$var$stylesBorder.borderFullScreenDebug
            ]);
            $[4] = t2;
            $[5] = t3;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        let t6;
        if ($[8] !== renderInnerChildren) {
            t6 = renderInnerChildren();
            $[8] = renderInnerChildren;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== t5 || $[11] !== t6 || $[12] !== testId) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
                zIndex: 500
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": testId,
                "data-rovo-chat-panel": "true",
                className: t5
            }, t6));
            $[10] = t5;
            $[11] = t6;
            $[12] = testId;
            $[13] = t7;
        } else t7 = $[13];
        return t7;
    }
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return "borderStagingArea";
        if (externalEmbed) return "borderExternalEmbed";
        if (fullscreenDebugEnabled) return "borderFullScreenDebug";
        if (shouldUseWrapperNav4Styles) return "borderNavV4";
        return "borderNavV3";
    };
    const t2 = "true";
    const t3 = (0, $hekY6.default)([
        shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
        isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0we0oO _0qk6IKjwM9" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
        externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
        $f5c1836cf94a50bb$var$stylesBorder[getBorderStyle()],
        fullScreen && shouldShowStagingArea && $f5c1836cf94a50bb$var$styles.withExternalStagingArea,
        isFullScreenModal && "_0bjKvDKxmn _2V7sgONvrM _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _39xV02N91d _0jFU0VN91d"
    ]);
    let t4;
    if ($[14] !== renderInnerChildren) {
        t4 = renderInnerChildren();
        $[14] = renderInnerChildren;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== t3 || $[17] !== t4 || $[18] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            "data-rovo-chat-panel": t2,
            className: t3
        }, t4);
        $[16] = t3;
        $[17] = t4;
        $[18] = testId;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
} : ({ testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode })=>{
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $iDrrr.fg)('agent_session_experience_fg');
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isContextPanelEnabled: isContextPanelEnabled } = (0, $dSCNl.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    const renderInnerChildren = ()=>{
        if (!isContextPanelEnabled || !(0, $iDrrr.fg)('agent_session_experience_fg')) return children;
        return /*#__PURE__*/ $cozmU.createElement((0, $2FUOC.SessionContextLayout), {
            isMiniModal: isMiniModal
        }, children);
    };
    const shouldShowStagingArea = stagingAreaMode === 'inline'; // Purely for FE team testing fullscreen where branch deploys are accessible
    // The use of localStorage and a private FF should make this safe, and it's our
    // best bet to improve dev velocity at the moment. Once Atlas has local consumption
    // we can remove this
    const fullscreenDebugEnabled = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components');
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
        zIndex: 500
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $hekY6.default)([
            shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
            isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0we0oO _0qk6IKjwM9" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
            externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
            $f5c1836cf94a50bb$var$styles.fullscreenDebug,
            $f5c1836cf94a50bb$var$stylesBorder.borderFullScreenDebug
        ])
    }, renderInnerChildren()));
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return 'borderStagingArea';
        if (externalEmbed) return 'borderExternalEmbed';
        if (fullscreenDebugEnabled) // this is not possible because if condition above, but adding it here for completeness
        return 'borderFullScreenDebug';
        if (shouldUseWrapperNav4Styles) return 'borderNavV4';
        return 'borderNavV3';
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $hekY6.default)([
            shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
            isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0we0oO _0qk6IKjwM9" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
            externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
            $f5c1836cf94a50bb$var$stylesBorder[getBorderStyle()],
            fullScreen && shouldShowStagingArea && $f5c1836cf94a50bb$var$styles.withExternalStagingArea,
            isFullScreenModal && "_0bjKvDKxmn _2V7sgONvrM _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _39xV02N91d _0jFU0VN91d"
        ])
    }, renderInnerChildren());
};
module.exports["MainWrapper"] = $f5c1836cf94a50bb$export$6661021c36f0a701;

});

parcelRegister("2FUOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $7o2Oy = parcelRequire("7o2Oy");


var $iehIX = parcelRequire("iehIX");


var $axKZp = parcelRequire("axKZp");

const $0ddc8c1cb3dfb4b8$var$styles = {
    overlayHost: "_0bjKvDOLYo _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC"
};
const $0ddc8c1cb3dfb4b8$export$9a828967a77275b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { children: children, isMiniModal: isMiniModal } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [presentation, setPresentation] = (0, $cozmU.useState)(null);
    const rightPanelExitHandlerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setPresentation(null);
        $[0] = t1;
    } else t1 = $[0];
    const closeSessionContext = t1;
    let t2;
    if ($[1] !== isMiniModal || $[2] !== sendAnalyticsEvent) {
        t2 = (requestedPresentation)=>{
            const nextPresentation = isMiniModal ? "drawer" : requestedPresentation;
            setPresentation(nextPresentation);
            sendAnalyticsEvent({
                action: "viewed",
                actionSubject: "sessionContextPanel",
                attributes: {
                    presentation: nextPresentation
                }
            });
            return nextPresentation;
        };
        $[1] = isMiniModal;
        $[2] = sendAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const openSessionContext = t2;
    let t3;
    if ($[4] !== openSessionContext || $[5] !== presentation) {
        t3 = {
            presentation: presentation,
            openSessionContext: openSessionContext,
            closeSessionContext: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        };
        $[4] = openSessionContext;
        $[5] = presentation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $0ddc8c1cb3dfb4b8$var$styles.overlayHost
        ]);
        $[7] = t4;
    } else t4 = $[7];
    const t5 = presentation === "split";
    let t6;
    if ($[8] !== children || $[9] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), {
            isRightPanelVisible: t5,
            onAutoCollapse: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        }, children);
        $[8] = children;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = presentation === "drawer";
    let t8;
    if ($[11] !== isMiniModal || $[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $axKZp.SessionContextPanelDrawer), {
            isOpen: t7,
            isMiniModal: isMiniModal
        });
        $[11] = isMiniModal;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t6 || $[15] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t4
        }, t6, t8);
        $[14] = t6;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t3 || $[18] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iehIX.SplitViewContext).Provider, {
            value: t3
        }, t9);
        $[17] = t3;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
} : ({ children: children, isMiniModal: isMiniModal })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [presentation, setPresentation] = (0, $cozmU.useState)(null);
    const rightPanelExitHandlerRef = (0, $cozmU.useRef)(null);
    const closeSessionContext = (0, $cozmU.useCallback)(()=>setPresentation(null), []);
    const openSessionContext = (0, $cozmU.useCallback)((requestedPresentation)=>{
        const nextPresentation = isMiniModal ? 'drawer' : requestedPresentation;
        setPresentation(nextPresentation);
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'sessionContextPanel',
            attributes: {
                presentation: nextPresentation
            }
        });
        return nextPresentation;
    }, [
        isMiniModal,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iehIX.SplitViewContext).Provider, {
        value: {
            presentation: presentation,
            openSessionContext: openSessionContext,
            closeSessionContext: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $0ddc8c1cb3dfb4b8$var$styles.overlayHost
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), {
        isRightPanelVisible: presentation === 'split',
        onAutoCollapse: closeSessionContext,
        rightPanelExitHandlerRef: rightPanelExitHandlerRef
    }, children), /*#__PURE__*/ $cozmU.createElement((0, $axKZp.SessionContextPanelDrawer), {
        isOpen: presentation === 'drawer',
        isMiniModal: isMiniModal
    })));
};
module.exports["SessionContextLayout"] = $0ddc8c1cb3dfb4b8$export$9a828967a77275b7;

});

parcelRegister("axKZp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");


var $iMnC5 = parcelRequire("iMnC5");


var $dSCNl = parcelRequire("dSCNl");


var $iiDOK = parcelRequire("iiDOK");


var $Vl9MW = parcelRequire("Vl9MW");


var $6FfVp = parcelRequire("6FfVp");

const $579ae2552509f6a5$var$messages = (0, $kSwu1.defineMessages)({
    contextPanelLabel: {
        id: "ai-mate.conversation-assistant.session-context-panel-drawer.label-non-final",
        defaultMessage: "Context panel"
    },
    closeContextPanelLabel: {
        id: "ai-mate.conversation-assistant.session-context-panel-drawer.close-label-non-final",
        defaultMessage: "Hide context"
    }
});
const $579ae2552509f6a5$var$styles = {
    sideNavContent: "_1mT5xdWVPG _2IhTonPgdg _4ApkO2Pgdg _0Bm75GPgdg _42Yu6B7dHp _4bt5LAnQyn",
    backdropCover: "_0bjKvDOLYo _3OE6xYPgdg",
    rightTray: "_39xV02N91d",
    trayNonFullscreen: "_1EqgXlE1Ft",
    trayFullscreen: "_1EqgXl715P",
    panel: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0KLXrulfZc",
    panelMiniModal: "_0bjKvDuMRm _0KLXruqi9L",
    toolbar: "_3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT _37wbyuz9WS _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    body: "_2O5Vij7dHp _4kiQYAdnbC"
}; // The scrim is authored with `@compiled/react` because `@atlaskit/css`'s typed `cssMap` does not
// expose this token as an allowed `backgroundColor` value. Uses the same token as the hamburger
// side-nav backdrop so the two menus dim the surface identically.
const $579ae2552509f6a5$var$backdropStyles = null;
const $579ae2552509f6a5$export$a00c723d48325325 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isOpen: isOpen, isMiniModal: t1 } = t0;
    const isMiniModal = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { closeSessionContext: closeSessionContext } = (0, $iiDOK.useSplitView)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    let t2;
    if ($[0] !== closeSessionContext || $[1] !== formatMessage || $[2] !== fullScreen || $[3] !== isMiniModal || $[4] !== isOpen) {
        t2 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("button", {
            type: "button",
            "aria-label": formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
            onClick: closeSessionContext,
            className: (0, $hekY6.default)([
                $579ae2552509f6a5$var$styles.sideNavContent,
                $579ae2552509f6a5$var$styles.backdropCover,
                "_30huDKdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrushJp _0wOv4Q7zJH"
            ])
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($579ae2552509f6a5$var$styles.sideNavContent, $579ae2552509f6a5$var$styles.rightTray, fullScreen ? $579ae2552509f6a5$var$styles.trayFullscreen : $579ae2552509f6a5$var$styles.trayNonFullscreen),
            testId: "conversation-assistant-session-context-panel-drawer",
            role: "dialog",
            "aria-label": formatMessage($579ae2552509f6a5$var$messages.contextPanelLabel)
        }, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
            enterFrom: "right",
            exitTo: "right",
            fade: "inout",
            duration: "medium"
        }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...animationProps,
                style: {
                    ...animationProps.style,
                    height: "100%"
                }
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $579ae2552509f6a5$var$styles.panel,
                    isMiniModal && $579ae2552509f6a5$var$styles.panelMiniModal
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $579ae2552509f6a5$var$styles.toolbar
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                testId: "conversation-assistant-session-context-panel-drawer-close-button",
                shape: "circle",
                appearance: "subtle",
                isTooltipDisabled: false,
                label: formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                onClick: closeSessionContext
            })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $579ae2552509f6a5$var$styles.body
            }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ $cozmU.createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
            }, /*#__PURE__*/ $cozmU.createElement((0, $Vl9MW.SessionRightPanelLazy), null))))))));
        $[0] = closeSessionContext;
        $[1] = formatMessage;
        $[2] = fullScreen;
        $[3] = isMiniModal;
        $[4] = isOpen;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ isOpen: isOpen, isMiniModal: isMiniModal = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { closeSessionContext: closeSessionContext } = (0, $iiDOK.useSplitView)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("button", {
        type: "button",
        "aria-label": formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
        onClick: closeSessionContext,
        className: (0, $hekY6.default)([
            $579ae2552509f6a5$var$styles.sideNavContent,
            $579ae2552509f6a5$var$styles.backdropCover,
            "_30huDKdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrushJp _0wOv4Q7zJH"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($579ae2552509f6a5$var$styles.sideNavContent, $579ae2552509f6a5$var$styles.rightTray, fullScreen ? $579ae2552509f6a5$var$styles.trayFullscreen : $579ae2552509f6a5$var$styles.trayNonFullscreen),
        testId: "conversation-assistant-session-context-panel-drawer",
        role: "dialog",
        "aria-label": formatMessage($579ae2552509f6a5$var$messages.contextPanelLabel)
    }, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
        enterFrom: "right",
        exitTo: "right",
        fade: "inout",
        duration: "medium"
    }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
            ...animationProps,
            style: {
                ...animationProps.style,
                height: '100%'
            }
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $579ae2552509f6a5$var$styles.panel,
                isMiniModal && $579ae2552509f6a5$var$styles.panelMiniModal
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.toolbar
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            testId: "conversation-assistant-session-context-panel-drawer-close-button",
            shape: "circle",
            appearance: "subtle",
            isTooltipDisabled: false,
            label: formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            onClick: closeSessionContext
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.body
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ $cozmU.createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ $cozmU.createElement((0, $Vl9MW.SessionRightPanelLazy), null)))))))));
};
module.exports["SessionContextPanelDrawer"] = $579ae2552509f6a5$export$a00c723d48325325;

});

parcelRegister("bC9Xc", function(module, exports) {
var $57b63a35c962a507$export$201c344d2af0a02 = /*#__PURE__*/ function(ChatEntryPoint) {
    ChatEntryPoint["SEARCH_PAGE_AUTO_OPEN_CHAT"] = "searchPageAutoOpenChat";
    return ChatEntryPoint;
}({});
module.exports["ChatEntryPoint"] = $57b63a35c962a507$export$201c344d2af0a02;

});

parcelRegister("bapzw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $e28a0d50c2d41991$var$LazyCreateWithRovoAnimatedLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("hH5VP"))); /**
             * @todo move to @atlassian/rovo-platform-ui-components
             */ 
const $e28a0d50c2d41991$export$33bbf4df09fde75b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-create-with-rovo-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28a0d50c2d41991$var$LazyCreateWithRovoAnimatedLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-create-with-rovo-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e28a0d50c2d41991$var$LazyCreateWithRovoAnimatedLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedCreateWithRovoIcon"] = $e28a0d50c2d41991$export$33bbf4df09fde75b;

});

parcelRegister("hH5VP", function(module, exports) {

let $ce1b0dbc3671e52f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce1b0dbc3671e52f$var$load("1ws82").then(()=>parcelRequire('geiYA'));

});

parcelRegister("fxbF1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9089ed3f6a5fc310482f628accd47a0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f2fba9f65c2ddf$var$_react = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4f2fba9f65c2ddf$var$_baseNew = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b4f2fba9f65c2ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/history
 * Usage guidance:
 * Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f2fba9f65c2ddf$var$HistoryIcon = (props)=>/*#__PURE__*/ $b4f2fba9f65c2ddf$var$_react.default.createElement($b4f2fba9f65c2ddf$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b4f2fba9f65c2ddf$var$HistoryIcon.displayName = 'HistoryIcon';
var $b4f2fba9f65c2ddf$var$_default = module.exports.default = $b4f2fba9f65c2ddf$var$HistoryIcon;

});

parcelRegister("gmhHk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $h11I1 = parcelRequire("h11I1");


var $5tUtl = parcelRequire("5tUtl");

const $61ed3f7435f1fd68$export$4b1545b4f2016d26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: t1 } = t0;
    const isMenuListItem = t1 === undefined ? false : t1;
    const id = (0, $6JrSr.useId)();
    const t2 = `${id}-heading`;
    let t3;
    if ($[0] !== ariaLabel || $[1] !== children || $[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "group",
            "aria-labelledby": t2,
            "aria-label": ariaLabel
        }, children);
        $[0] = ariaLabel;
        $[1] = children;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== id || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tUtl.MenuSectionContext).Provider, {
            value: id
        }, t3);
        $[4] = id;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const content = t4;
    if (isMenuListItem) {
        let t5;
        if ($[7] !== content || $[8] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
                testId: testId
            }, content);
            $[7] = content;
            $[8] = testId;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    return content;
} : ({ children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $6JrSr.useId)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tUtl.MenuSectionContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "group",
        "aria-labelledby": `${id}-heading`,
        "aria-label": ariaLabel
    }, children));
    if (isMenuListItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        testId: testId
    }, content);
    // Legacy. isMenuListItem should become default.
    return content;
};
module.exports["MenuSection"] = $61ed3f7435f1fd68$export$4b1545b4f2016d26;

});

parcelRegister("5tUtl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");

const $f8fd377d923f47fb$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $f8fd377d923f47fb$export$8100cda602411810 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($f8fd377d923f47fb$export$728ac99b9c7eea8a);
    (0, $bB0i2.default)(context, "useMenuSectionContext must be used within a MenuSection");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($f8fd377d923f47fb$export$728ac99b9c7eea8a);
    (0, $bB0i2.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};
module.exports["MenuSectionContext"] = $f8fd377d923f47fb$export$728ac99b9c7eea8a;
module.exports["useMenuSectionContext"] = $f8fd377d923f47fb$export$8100cda602411810;

});

parcelRegister("4X3mP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5tUtl = parcelRequire("5tUtl");

const $81e6b252f2c7d20c$var$styles = {
    root: "_2sNsIgd8bj _4c065U2ADO _1UtDYzKGUX _0LQT5EgVvo"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $81e6b252f2c7d20c$export$5d3acdbf9237a364 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, headingLevel: headingLevel } = t0;
    const id = (0, $5tUtl.useMenuSectionContext)();
    const HeadingTag = headingLevel ? `h${headingLevel}` : "p";
    const t1 = `${id}-heading`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $81e6b252f2c7d20c$var$styles.root
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== HeadingTag || $[2] !== children || $[3] !== t1) {
        t3 = /*#__PURE__*/ $cozmU.createElement(HeadingTag, {
            id: t1,
            className: t2
        }, children);
        $[1] = HeadingTag;
        $[2] = children;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, headingLevel: headingLevel })=>{
    const id = (0, $5tUtl.useMenuSectionContext)();
    const HeadingTag = headingLevel ? `h${headingLevel}` : 'p';
    return /*#__PURE__*/ $cozmU.createElement(HeadingTag, {
        id: `${id}-heading`,
        className: (0, $hekY6.default)([
            $81e6b252f2c7d20c$var$styles.root
        ])
    }, children);
};
module.exports["MenuSectionHeading"] = $81e6b252f2c7d20c$export$5d3acdbf9237a364;

});

parcelRegister("huaOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $hLtfj = parcelRequire("hLtfj");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");

const $e30c6d4ea2de4ef1$var$listItemStyles = {
    root: "_2pQraJ0Qmj"
};
const $e30c6d4ea2de4ef1$var$LinkMenuItemNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(26);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const itemRef = (0, $cozmU.useRef)(null);
    const t1 = isSelected ?? false;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            elementRef: itemRef,
            isSelected: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    (0, $4o9cR.useScrollMenuItemIntoView)(t2);
    const t3 = listItemRef ?? null;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $lmzCg.default)([
            itemRef,
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const ref = t4;
    let t5;
    if ($[4] !== actions || $[5] !== actionsOnHover || $[6] !== children || $[7] !== description || $[8] !== dropIndicator || $[9] !== elemAfter || $[10] !== elemBefore || $[11] !== forwardedRef || $[12] !== hasDragIndicator || $[13] !== href || $[14] !== interactionName || $[15] !== isContentTooltipDisabled || $[16] !== isDragging || $[17] !== isSelected || $[18] !== onClick || $[19] !== target || $[20] !== testId || $[21] !== visualContentRef) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[4] = actions;
        $[5] = actionsOnHover;
        $[6] = children;
        $[7] = description;
        $[8] = dropIndicator;
        $[9] = elemAfter;
        $[10] = elemBefore;
        $[11] = forwardedRef;
        $[12] = hasDragIndicator;
        $[13] = href;
        $[14] = interactionName;
        $[15] = isContentTooltipDisabled;
        $[16] = isDragging;
        $[17] = isSelected;
        $[18] = onClick;
        $[19] = target;
        $[20] = testId;
        $[21] = visualContentRef;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== ref || $[24] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
            ref: ref,
            xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
        }, t5);
        $[23] = ref;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
        ref: ref,
        xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f = (0, $4Qc44.default)($e30c6d4ea2de4ef1$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("4o9cR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $8AWCX = parcelRequire("8AWCX");

function $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
const $9fe3f1218f1710c7$export$2c52ec851fcc6058 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollMenuItemIntoView(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { elementRef: elementRef, isSelected: isSelected } = t0;
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            type: "waiting-to-be-selected-and-all-ancestors-expanded"
        };
        $[0] = t1;
    } else t1 = $[0];
    const waitingStateRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== areAllAncestorsExpanded || $[2] !== elementRef || $[3] !== isSelected) {
        t2 = ()=>{
            if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
                const shouldScroll = areAllAncestorsExpanded && isSelected;
                if (!shouldScroll) return;
                const element = elementRef.current;
                (0, $bB0i2.default)(element, "Element ref must be set");
                $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
                waitingStateRef.current.type = "waiting-to-be-unselected";
                return;
            }
            if (waitingStateRef.current.type === "waiting-to-be-unselected") {
                if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
                return;
            }
        };
        t3 = [
            areAllAncestorsExpanded,
            elementRef,
            isSelected
        ];
        $[1] = areAllAncestorsExpanded;
        $[2] = elementRef;
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useScrollMenuItemIntoView({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $cozmU.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $cozmU.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $bB0i2.default)(element, 'Element ref must be set');
            $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
};
module.exports["useScrollMenuItemIntoView"] = $9fe3f1218f1710c7$export$2c52ec851fcc6058;

});

parcelRegister("d5um7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5Dlqn = parcelRequire("5Dlqn");


var $h11I1 = parcelRequire("h11I1");


var $8AWCX = parcelRequire("8AWCX");

const $6b9c8550570135b2$var$relativeStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $6b9c8550570135b2$export$341dea48c30b36ff = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(21);
    const { isExpanded: isExpandedControlled, isDefaultExpanded: t1, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId } = t0;
    const isDefaultExpanded = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDefaultExpanded) {
        t2 = ()=>isDefaultExpanded;
        $[0] = isDefaultExpanded;
        $[1] = t2;
    } else t2 = $[1];
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, t2);
    const t3 = onExpansionToggle ?? null;
    const t4 = dropIndicator && $6b9c8550570135b2$var$relativeStyles.root;
    let t5;
    if ($[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t4
        ]);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== children || $[5] !== dropIndicator || $[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, children, dropIndicator);
        $[4] = children;
        $[5] = dropIndicator;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== forwardedRef || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
            ref: forwardedRef,
            testId: testId
        }, t6);
        $[8] = forwardedRef;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t3 || $[13] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
            value: t3
        }, t7);
        $[12] = t3;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== setIsExpanded || $[16] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
            value: setIsExpanded
        }, t8);
        $[15] = setIsExpanded;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== isExpanded || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
            value: isExpanded
        }, t9);
        $[18] = isExpanded;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
} : ({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
        value: isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
        value: setIsExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
        value: onExpansionToggle ?? null
    }, /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
        ref: forwardedRef,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            dropIndicator && $6b9c8550570135b2$var$relativeStyles.root
        ])
    }, children, dropIndicator)))));
});
module.exports["ExpandableMenuItem"] = $6b9c8550570135b2$export$341dea48c30b36ff;

});

parcelRegister("jZuGB", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $k27u5 = parcelRequire("k27u5");


var $8AWCX = parcelRequire("8AWCX");

const $9c28a97efb757560$var$styles = {
    content: "_0LQT5ExpxF",
    collapsedContent: "_3iDTPbYbGa"
};
const $9c28a97efb757560$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const level = (0, $8AWCX.useLevel)();
    const hasExpanded = (0, $cozmU.useRef)(false);
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.LevelContext).Provider, {
        value: level + 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.AreAllAncestorsExpandedContext).Provider, {
        value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $k27u5.List), {
        ref: forwardedRef,
        xcss: (0, $k12R1.cx)($9c28a97efb757560$var$styles.content, !isExpanded && $9c28a97efb757560$var$styles.collapsedContent)
    }, children)));
});
module.exports["ExpandableMenuItemContent"] = $9c28a97efb757560$export$bd680a81504a92e9;

});

parcelRegister("gMhPZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $4Qc44 = parcelRequire("4Qc44");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");


var $8AWCX = parcelRequire("8AWCX");

const $17b37eab23d553a8$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $17b37eab23d553a8$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $17b37eab23d553a8$var$wrapperStyles = {
    root: "_3RTSTAQ4SZ _2MvGBxYbGa",
    showProvidedElemBefore: "_3RTSTAYbGa _2MvGBxcK7c _3g4o8sQ4SZ _1H0K9XYbGa _0Jml7pQ4SZ _4sQNN8Q4SZ _2zl65PYbGa _1FfrqxYbGa"
}; // Merge back into the `wrapperStyles` after cleanup
const $17b37eab23d553a8$var$nestedOpenPopupStyles = {
    showProvidedElemBefore: "_3g4o8sQ4SZ _1H0K9XYbGa"
};
const $17b37eab23d553a8$var$iconStyles = {
    chevron: "_3iDTPbismd _4lYzgRyz1h",
    providedElemBefore: "_3iDTPbC5M9",
    providedElemBeforeSelected: "_1UtDYzrFwf"
};
const $17b37eab23d553a8$var$ExpandableMenuItemIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore } = t0;
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const t1 = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    let t2;
    if ($[0] !== ChevronIcon || $[1] !== iconProps || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
            ...iconProps,
            label: "",
            color: t1,
            size: "small"
        });
        $[0] = ChevronIcon;
        $[1] = iconProps;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const chevronElem = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ]);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== chevronElem) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, chevronElem);
        $[5] = chevronElem;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isSelected || $[8] !== providedElemBefore) {
        t5 = providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $17b37eab23d553a8$var$iconStyles.providedElemBefore,
                isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
            ])
        }, providedElemBefore);
        $[7] = isSelected;
        $[8] = providedElemBefore;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ])
    }, chevronElem), providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.providedElemBefore,
            isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
        ])
    }, providedElemBefore));
};
const $17b37eab23d553a8$export$fe6fe51056867f4d = (0, $4Qc44.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $cozmU.useId)();
    const onExpansionToggle = (0, $8AWCX.useOnExpansionToggle)();
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const setIsExpanded = (0, $8AWCX.useSetIsExpanded)();
    const itemRef = (0, $cozmU.useRef)(null);
    const handleIconClick = (0, $cozmU.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: itemRef,
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$wrapperStyles.root,
            providedElemBefore && $17b37eab23d553a8$var$wrapperStyles.showProvidedElemBefore,
            $17b37eab23d553a8$var$nestedOpenPopupStyles.showProvidedElemBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        id: id,
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: elemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        testId: testId,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ExpandableMenuItemTrigger"] = $17b37eab23d553a8$export$fe6fe51056867f4d;

});

parcelRegister("jsuJ9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $bB0i2 = parcelRequire("bB0i2");


var $6JrSr = parcelRequire("6JrSr");


var $jyAY3 = parcelRequire("jyAY3");


var $kgGsB = parcelRequire("kgGsB");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");

parcelRequire("5Wedv");
var $cUdy2 = parcelRequire("cUdy2");

parcelRequire("iN08H");
var $cIWiw = parcelRequire("cIWiw");

parcelRequire("aLPNu");
var $fGXGw = parcelRequire("fGXGw");


var $lpNn5 = parcelRequire("lpNn5");


var $6sD11 = parcelRequire("6sD11");


var $9GVkD = parcelRequire("9GVkD");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $bqqhM = parcelRequire("bqqhM");


var $7uL08 = parcelRequire("7uL08");


var $j6GCu = parcelRequire("j6GCu");


var $6ZWGn = parcelRequire("6ZWGn");


var $aLgN8 = parcelRequire("aLgN8");


var $1NH4A = parcelRequire("1NH4A");


var $eoCwK = parcelRequire("eoCwK");


var $kdCH7 = parcelRequire("kdCH7");


var $eMMLI = parcelRequire("eMMLI");

function $aa50747aa4702ef1$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $eMMLI.panelSplitterDragDataSymbol)]: true
    };
}
const $aa50747aa4702ef1$var$containerStyles = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3iDTPbYbGa _1mT5xdWVPG _1ZB6UydnbC _2I62gzdnbC _42Yu6B7dHp _2UeR8bvLZJ",
    positionEnd: "_1OKFqYJg58",
    positionStart: "_3iC0zd1x6F"
};
const $aa50747aa4702ef1$var$grabAreaStyles = {
    root: "_39xV02vFgp _0jFU0VN91d _1mT5xdWVPG _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _1UtDYzjOvk _0KLXrujOvk _3Z9K0wb8VS _3OZqoK0jWM _0qk6IKN8t6 _1kOSYtWkA1 _0ReiIHuudW _25IEJJjTy9 _0clgaMjTy9 _3sFUREYbGa _0CMRbkAwSC",
    fullHeightSidebar: "_0ReiIHYNYw"
};
const $aa50747aa4702ef1$var$lineStyles = {
    root: "_1mT5xdWVPG _3iDTPbvLZJ _39xV024Y4b _0jFU0VN91d _1UtDYzOLYo _0KLXru98eZ _3iC0zdXJux"
};
const $aa50747aa4702ef1$var$tooltipStyles = {
    root: "_0GTcwRTUhv _39xV02W9qI"
};
const $aa50747aa4702ef1$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(18);
    let children;
    let className;
    let props;
    if ($[0] !== t0) {
        ({ children: children, className: className, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = props;
    } else {
        children = $[1];
        className = $[2];
        props = $[3];
    }
    let t1;
    bb0: {
        if (!props.style || !props.style.transform) {
            t1 = props.style;
            break bb0;
        }
        let t2;
        if ($[4] !== props.style.transform) {
            let t3;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = /(?:-|\+)?\d*\.?\d+px/g;
                $[6] = t3;
            } else t3 = $[6];
            t2 = props.style.transform.matchAll(t3);
            $[4] = props.style.transform;
            $[5] = t2;
        } else t2 = $[5];
        const [translateX, translateY] = t2;
        if (!translateY) {
            t1 = props.style;
            break bb0;
        }
        const newTranslateY = `max(calc(${(0, $liCgE.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        let t3;
        if ($[7] !== newTransform || $[8] !== props.style) {
            t3 = {
                ...props.style,
                transform: newTransform
            };
            $[7] = newTransform;
            $[8] = props.style;
            $[9] = t3;
        } else t3 = $[9];
        t1 = t3;
    }
    const style = t1;
    let t2;
    if ($[10] !== className) {
        t2 = (0, $hekY6.default)([
            $aa50747aa4702ef1$var$tooltipStyles.root,
            className
        ]);
        $[10] = className;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== props || $[14] !== ref || $[15] !== style || $[16] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6sD11.default), {
            ...props,
            ref: ref,
            className: t2,
            style: style
        }, children);
        $[12] = children;
        $[13] = props;
        $[14] = ref;
        $[15] = style;
        $[16] = t2;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : ({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $cozmU.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
         // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
         /**
       * Adjusts the translate Y to keep the tooltip within the main content area,
       * so that it does not appear over the banner or top navigation.
       */ 
        const newTranslateY = `max(calc(${(0, $liCgE.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $6sD11.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, children);
}); /**
     * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
     */ 
const $aa50747aa4702ef1$var$MaybeTooltip = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    if (tooltipContent && isFhsEnabled) {
        let t1;
        if ($[0] !== children || $[1] !== shortcut || $[2] !== testId || $[3] !== tooltipContent) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                testId: testId,
                content: tooltipContent,
                shortcut: shortcut,
                position: "mouse-y",
                mousePosition: "right",
                isScreenReaderAnnouncementDisabled: true,
                component: $aa50747aa4702ef1$var$PanelSplitterTooltip,
                shouldAlwaysFadeIn: true,
                shouldRenderToParent: true
            }, children);
            $[0] = children;
            $[1] = shortcut;
            $[2] = testId;
            $[3] = tooltipContent;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    return children;
} : ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    if (tooltipContent && isFhsEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $aa50747aa4702ef1$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true
    }, children);
    return children;
};
function $aa50747aa4702ef1$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $aa50747aa4702ef1$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const splitterRef = (0, $cozmU.useRef)(null);
    const labelId = (0, $6JrSr.useId)(); // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $cozmU.useState)(panelWidth); /**
                                                                       * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
                                                                       * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
                                                                       * when the user tries to resize using the keyboard.
                                                                       */ 
    const [rangeInputBounds, setRangeInputBounds] = (0, $cozmU.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)(); /**
                                                     * This is a temporary workaround to enable the `SideNavPanelSplitter` component
                                                     * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
                                                     * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
                                                     */ 
    const onDoubleClick = (0, $cozmU.useContext)((0, $eoCwK.OnDoubleClickContext)); // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $bB0i2.default)(splitter, 'Splitter ref must be set');
        return (0, $aDtKq.combine)((0, $cUdy2.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $cbY7C.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $iSrRp.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $cIWiw.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $fGXGw.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $j6GCu.getPixelWidth)(panel); /**
                                                    * The drag calculations require the actual computed width of the element
                                                    * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
                                                    * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
                                                    */ 
                return $aa50747aa4702ef1$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $aa50747aa4702ef1$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $bB0i2.default)((0, $aLgN8.isPanelSplitterDragData)(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                }); // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source_0 }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $bB0i2.default)((0, $aLgN8.isPanelSplitterDragData)(source_0.data));
                const { initialWidth: initialWidth_0, resizeBounds: resizeBounds, direction: direction } = source_0.data;
                (0, $bB0i2.default)(initialClientXRef.current !== null, 'initialClientX must be set'); /**
                                                                                      * How wide the element would be if there were no width constraints,
                                                                                      * based on the pointer's position.
                                                                                      */ 
                const targetWidth = (0, $6ZWGn.getWidthFromDragLocation)({
                    initialWidth: initialWidth_0,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source_0.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source_1 }) {
                (0, $bB0i2.default)((0, $aLgN8.isPanelSplitterDragData)(source_1.data));
                (0, $fGXGw.preventUnhandled).stop();
                const finalWidth = (0, $j6GCu.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source_1.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $jyAY3.default)(onResizeStart);
    const onResizeEndStableRef = (0, $jyAY3.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $cozmU.useState)(()=>(0, $1NH4A.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args_0)=>onResizeEndStableRef.current?.(...args_0)
        }));
    const handleSliderInputChange = (0, $cozmU.useCallback)((event_0)=>{
        const value = parseInt(event_0.target.value);
        setRangeInputValue(value); /**
                                * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
                                * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
                                */ 
        onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $cozmU.useRef)(null);
    const handleSliderFocus = (0, $cozmU.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.(); // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds_0 = getResizeBounds(); // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_0.min),
            max: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_0.max)
        }); /**
         * _While the slider element is focused_, add a window resize event listener to update the range input bounds
         * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
         * size - in case they are provided in vw units.
         *
         * This listener is cleaned up when the element is blurred.
         */ 
        resizeEventListenerCleanupFn.current = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds_1 = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_1.min),
                    max: (0, $bqqhM.convertResizeBoundToPixels)(resizeBounds_1.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $cozmU.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $cozmU.useMemo)(()=>`${(0, $7uL08.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$containerStyles.root,
            position === 'start' && $aa50747aa4702ef1$var$containerStyles.positionStart,
            position === 'end' && $aa50747aa4702ef1$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $cozmU.createElement($aa50747aa4702ef1$var$MaybeTooltip, {
        tooltipContent: tooltipContent,
        shortcut: shortcut,
        testId: testId ? `${testId}-tooltip` : undefined
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        ref: splitterRef,
        "data-testid": testId,
        onDoubleClick: onDoubleClick,
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$grabAreaStyles.root,
            isFhsEnabled && $aa50747aa4702ef1$var$grabAreaStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement("input", {
        type: "range",
        value: rangeInputValue,
        step: 20,
        min: rangeInputBounds.min,
        max: rangeInputBounds.max,
        "aria-valuetext": ariaValueText,
        "aria-labelledby": labelId,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        id: labelId
    }, label)), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $aa50747aa4702ef1$var$lineStyles.root
        ])
    })))), portal);
};
const $aa50747aa4702ef1$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $cozmU.useState)(null);
    const [portal, setPortal] = (0, $cozmU.useState)(null);
    const context = (0, $cozmU.useContext)((0, $kdCH7.PanelSplitterContext));
    (0, $bB0i2.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, position: position, shortcut: shortcut } = context; /**
                * **Explanation**
                *
                * _How React Suspense works_
                *
                * When a component is suspended:
                *
                * - it is _not_ "unmounted" and effects are _not_ cleaned up
                * - refs to react managed elements are cleared
                * - react adds `display:none !important` as an inline style to hide the element
                * - state is preserved
                *
                * When a suspended component is resumed:
                * - `display:none !important` inline style is removed
                * - it will re-render (without the refs set)
                * - refs will be set
                * - `useEffect` will _not_ re-run
                *
                * [More details](https://x.com/alexandereardon/status/1944617494569992440)
                *
                * _What does this mean for the panel splitter?_
                *
                * - The panel splitter renders into content into a react managed element (eg managed by Aside)
                * - When UI is suspended the portal ref is cleared
                * - After a suspense, we will get a render with cleared refs
                * - 🔥 This is problematic if we want to portal into that ref during the render
                *
                * _Approach: initial render_
                *
                * - We cannot portal the panel splitter until after the refs are initially set
                * - Effects run after refs being set. In an effect we set the ref values (which are populated),
                *   trigger a re-render and then portal into the refs.
                *
                * _Approach: suspense_
                *
                * - We put the refs into react `state` after every render
                * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
                *   when components are suspended / resumed.
                * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
                *   to continue to portal into.
                *
                * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
                *
                * - The `portalRef` is set high in the tree, so a re-render will cause a
                *   large amount of components to re-render (eg the whole sidebar)
                * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
                * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
                *   (just in the `<PanelSplitter>`)
                */ 
    // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
         // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $bB0i2.default)(panelEl, 'panelRef not set');
        (0, $bB0i2.default)(portalEl, 'portal element not set'); // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
         // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ $cozmU.createElement($aa50747aa4702ef1$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};
module.exports["PanelSplitter"] = $aa50747aa4702ef1$export$db67e3f8d3d6da0f;

});

parcelRegister("kgGsB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3fPCt = parcelRequire("3fPCt");

const $709cc20fff743ac3$export$750f5b0d6c51617e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOpenLayerObserver() {
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $cozmU.useContext)((0, $3fPCt.OpenLayerObserverContext));
    let t0;
    bb0: {
        if (context === null) {
            t0 = null;
            break bb0;
        }
        let t1;
        if ($[0] !== context.closeLayers || $[1] !== context.getCount || $[2] !== context.onChange) {
            t1 = {
                getCount: context.getCount,
                onChange: context.onChange,
                closeLayers: context.closeLayers
            };
            $[0] = context.closeLayers;
            $[1] = context.getCount;
            $[2] = context.onChange;
            $[3] = t1;
        } else t1 = $[3];
        t0 = t1;
    }
    const publicAPI = t0;
    return publicAPI;
} : function useOpenLayerObserver() {
    const context = (0, $cozmU.useContext)((0, $3fPCt.OpenLayerObserverContext));
    const publicAPI = (0, $cozmU.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
};
module.exports["useOpenLayerObserver"] = $709cc20fff743ac3$export$750f5b0d6c51617e;

});

parcelRegister("5Wedv", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("cUdy2")).blockDraggingToIFrames);

var $cUdy2 = parcelRequire("cUdy2");


});

parcelRegister("cUdy2", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $4QfFX = parcelRequire("4QfFX");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $ccdab035e89654de$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $ccdab035e89654de$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $ccdab035e89654de$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($ccdab035e89654de$var$isActive) return;
    $ccdab035e89654de$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$ccdab035e89654de$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $4QfFX.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $4Vdlk.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $ccdab035e89654de$var$isActive = false;
    });
}
function $ccdab035e89654de$export$6ae1d8fab001518c({ element: element }) {
    return (0, $4Vdlk.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $ccdab035e89654de$var$tryStart();
        }
    });
}
module.exports["blockDraggingToIFrames"] = $ccdab035e89654de$export$6ae1d8fab001518c;

});

parcelRegister("iN08H", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("cIWiw")).disableNativeDragPreview);

var $cIWiw = parcelRequire("cIWiw");


});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("aLPNu", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("fGXGw")).preventUnhandled);

var $fGXGw = parcelRequire("fGXGw");


});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("1fHIr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fvwa0 = parcelRequire("fvwa0");

const $306fbdba1b69a421$export$8b40a725a91166de = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const isFhsEnabled = (0, $cozmU.useContext)((0, $fvwa0.IsFhsEnabledContext));
    let t0;
    if ($[0] !== isFhsEnabled) {
        t0 = typeof isFhsEnabled === "boolean" ? isFhsEnabled : isFhsEnabled();
        $[0] = isFhsEnabled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const isFhsEnabled = (0, $cozmU.useContext)((0, $fvwa0.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};
module.exports["useIsFhsEnabled"] = $306fbdba1b69a421$export$8b40a725a91166de;

});

parcelRegister("fvwa0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $cc70da0c927ab5a3$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $cozmU.createContext)(()=>(0, $iDrrr.fg)('navx-full-height-sidebar'));
module.exports["IsFhsEnabledContext"] = $cc70da0c927ab5a3$export$1e91b29ada71c32a;

});

parcelRegister("liCgE", function(module, exports) {
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $df3f68d355f73372$export$951bf5156e86d974 = '--n_sNvw';
const $df3f68d355f73372$export$594e6a30db7c057e = '--n_asDw';
const $df3f68d355f73372$export$db0c2e1d744fb281 = '--n_pnlW';
const $df3f68d355f73372$export$515a0b1baafe906c = '--n_bnrM';
const $df3f68d355f73372$export$60ef3a7b1ed42328 = '--n_tNvM';
const $df3f68d355f73372$export$a16bbd599f6269e7 = '--n_rbnW';
const $df3f68d355f73372$export$1216dacffd1e9e65 = '--n_sNvlw';
const $df3f68d355f73372$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $df3f68d355f73372$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $df3f68d355f73372$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $df3f68d355f73372$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $df3f68d355f73372$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $df3f68d355f73372$export$855f5a09f5c99ac = '--topNavigationHeight';
const $df3f68d355f73372$export$26354f9814213292 = '--bannerHeight';
const $df3f68d355f73372$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $df3f68d355f73372$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $df3f68d355f73372$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $df3f68d355f73372$export$753bf7651b25db91 = '--rightPanelWidth';
const $df3f68d355f73372$export$6460bd6a2446260 = `calc(var(${$df3f68d355f73372$export$26354f9814213292}, 0px) + var(${$df3f68d355f73372$export$855f5a09f5c99ac}, 0px))`;
const $df3f68d355f73372$export$3055529fab2b4edf = `calc(var(${$df3f68d355f73372$export$58de0a46980ca7f4}, 0px) + var(${$df3f68d355f73372$export$6bfc931a04ec5741}, 0px))`;
const $df3f68d355f73372$export$166d8fd766c3eb92 = `calc(var(${$df3f68d355f73372$export$bbbace2ff0c7ae1b}, 0px) + var(${$df3f68d355f73372$export$753bf7651b25db91}, 0px))`;
const $df3f68d355f73372$export$61156ceb1a99f6a0 = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $df3f68d355f73372$export$876effa8b02edc2f = 'side-nav';
const $df3f68d355f73372$export$a6be839a92c90df7 = 'top-nav-start';
const $df3f68d355f73372$export$762ad20d97870b35 = 'top-nav-middle';
const $df3f68d355f73372$export$8dd71e8a7db48024 = 'top-nav-end';
module.exports["sideNavVar"] = $df3f68d355f73372$export$951bf5156e86d974;
module.exports["panelVar"] = $df3f68d355f73372$export$db0c2e1d744fb281;
module.exports["bannerMountedVar"] = $df3f68d355f73372$export$515a0b1baafe906c;
module.exports["topNavMountedVar"] = $df3f68d355f73372$export$60ef3a7b1ed42328;
module.exports["sideNavLiveWidthVar"] = $df3f68d355f73372$export$1216dacffd1e9e65;
module.exports["sideNavPanelSplitterId"] = $df3f68d355f73372$export$5db28b16b6e686bc;
module.exports["panelPanelSplitterId"] = $df3f68d355f73372$export$3452dcb65711af44;
module.exports["contentInsetBlockStart"] = $df3f68d355f73372$export$bfabd8c2c572ad29;
module.exports["UNSAFE_topNavVar"] = $df3f68d355f73372$export$855f5a09f5c99ac;
module.exports["UNSAFE_bannerVar"] = $df3f68d355f73372$export$26354f9814213292;
module.exports["UNSAFE_sideNavLayoutVar"] = $df3f68d355f73372$export$6bfc931a04ec5741;
module.exports["UNSAFE_panelLayoutVar"] = $df3f68d355f73372$export$753bf7651b25db91;
module.exports["UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY"] = $df3f68d355f73372$export$6460bd6a2446260;
module.exports["openLayerObserverSideNavNamespace"] = $df3f68d355f73372$export$876effa8b02edc2f;
module.exports["openLayerObserverTopNavStartNamespace"] = $df3f68d355f73372$export$a6be839a92c90df7;
module.exports["openLayerObserverTopNavMiddleNamespace"] = $df3f68d355f73372$export$762ad20d97870b35;
module.exports["openLayerObserverTopNavEndNamespace"] = $df3f68d355f73372$export$8dd71e8a7db48024;

});

parcelRegister("bqqhM", function(module, exports) {
function $d49f7917cd31356f$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}
module.exports["convertResizeBoundToPixels"] = $d49f7917cd31356f$export$3d412b3011b66f82;

});

parcelRegister("7uL08", function(module, exports) {
function $eecdceaa8eea5c83$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}
module.exports["getPercentageWithinPixelBounds"] = $eecdceaa8eea5c83$export$b5423678cdf09f5;

});

parcelRegister("j6GCu", function(module, exports) {
/**
 * Returns the computed width of an element in pixels.
 */ const $90570af16555ddca$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};
module.exports["getPixelWidth"] = $90570af16555ddca$export$d942790ad00c41f9;

});

parcelRegister("6ZWGn", function(module, exports) {
const $eca965d9d38b7fed$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
module.exports["getWidthFromDragLocation"] = $eca965d9d38b7fed$export$e360234971cb95b8;

});

parcelRegister("aLgN8", function(module, exports) {

var $eMMLI = parcelRequire("eMMLI");

function $761da17727e72b97$export$e239b3966b677000(data) {
    return data[0, $eMMLI.panelSplitterDragDataSymbol] === true;
}
module.exports["isPanelSplitterDragData"] = $761da17727e72b97$export$e239b3966b677000;

});

parcelRegister("eMMLI", function(module, exports) {
const $f541948e785e50cb$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');
module.exports["panelSplitterDragDataSymbol"] = $f541948e785e50cb$export$64f49ceb7f6e9a23;

});

parcelRegister("1NH4A", function(module, exports) {
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $701d71138fd3edb2$var$resizeCallbackDebounceTimeMs = 500;
function $701d71138fd3edb2$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $701d71138fd3edb2$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}
module.exports["createKeyboardResizeManager"] = $701d71138fd3edb2$export$f7d3d5dae65f74aa;

});

parcelRegister("eoCwK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $81891a3d68477451$export$e253efba824eceb = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["OnDoubleClickContext"] = $81891a3d68477451$export$e253efba824eceb;

});

parcelRegister("kdCH7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $eba789b1db8bb9f2$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["PanelSplitterContext"] = $eba789b1db8bb9f2$export$7a4054f2c546f2cd;

});

parcelRegister("eCqXP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $9DHhW = parcelRequire("9DHhW");


var $lmzCg = parcelRequire("lmzCg");


var $jyAY3 = parcelRequire("jyAY3");


var $1IrNk = parcelRequire("1IrNk");


var $kgGsB = parcelRequire("kgGsB");


var $iDrrr = parcelRequire("iDrrr");


var $iSrRp = parcelRequire("iSrRp");


var $gnKXs = parcelRequire("gnKXs");


var $eaAhc = parcelRequire("eaAhc");


var $a5Bb1 = parcelRequire("a5Bb1");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $b24kF = parcelRequire("b24kF");


var $iynkA = parcelRequire("iynkA");


var $eyPWA = parcelRequire("eyPWA");


var $IRNbu = parcelRequire("IRNbu");


var $6iHsT = parcelRequire("6iHsT");


var $4xyOi = parcelRequire("4xyOi");


var $2udoJ = parcelRequire("2udoJ");


var $2E6Hq = parcelRequire("2E6Hq");


var $8CGNp = parcelRequire("8CGNp");


var $5rNCB = parcelRequire("5rNCB");


var $aFvBm = parcelRequire("aFvBm");


var $d8d8E = parcelRequire("d8d8E");


var $1gX7M = parcelRequire("1gX7M");


var $g9jMx = parcelRequire("g9jMx");


var $gjVTm = parcelRequire("gjVTm");


var $7PUR3 = parcelRequire("7PUR3");


var $6NDDH = parcelRequire("6NDDH");

const $69afecb6c46cd616$var$panelSplitterResizingVar = '--n_snvRsz'; // Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $69afecb6c46cd616$var$sideNavClampedWidthVar = '--n_snvW';
const $69afecb6c46cd616$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $69afecb6c46cd616$var$getResizeBounds() {
    return $69afecb6c46cd616$var$widthResizeBounds;
} /**
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ 
const $69afecb6c46cd616$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $69afecb6c46cd616$var$panelSplitterPortalTargetStyles = {
    root: "_1mT5xdy1CL _42Yu6B8OLE _1ZB6UydnbC _1VJPca4Hw8 _0jFU0VlOMI _2MwU8rfsLy _1EkTBE4L7p"
};
const $69afecb6c46cd616$var$styles = {
    root: "_2YmqfPYbGa _1VfddaYbGa _0KLXruoI2d _2OUyjtGk8v _24h04i2Njc _0jFU0VlOMI _2I62gzgiHs _1mT5xdHE3j _39xV02uZus _42Yu6BiZR3 _2EWYUbX3P0 _1KvygPUzyj _1EUs3cOeNX _0hAebtlfZc _1RYJRxYbGa _0xO92q39pk",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _1E7uFmIt9z",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _4pNSLEIt9z",
    animationRTLSupport: "_2LGtmL7dHp _0pbPskvQQr",
    flyoutBaseStylesFullHeightSidebar: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2SsmzmRodp _2QPceGThaV",
    flyoutOpenFullHeightSidebar: "_19NLAJ2HTN _03zLI5AYH4 _1QQNNIJF1Y",
    flyoutAnimateClosedFullHeightSidebar: "_0THHewYbGa _19NLAJ2HTN _03zLI5ROYS _19veLJJF1Y",
    flexContainer: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3",
    hiddenMobileAndDesktop: "_3iDTPbYbGa",
    hiddenMobileOnly: "_3iDTPbYbGa _0THHewyL8i",
    hiddenDesktopOnly: "_0THHewYbGa",
    animationBaseStyles: "_2qDx9mRodp _4tikTSThaV _03Q0ee2HTN",
    expandAnimationMobile: "_4BklsuAYH4 _3WRiEcJF1Y",
    collapseAnimationMobile: "_3NcSKiOQJL _4BklsuROYS _0G6dy0JF1Y",
    expandAnimationDesktop: "_4fJQ5SUzyj _03zLI5AYH4 _1QQNNIJF1Y",
    collapseAnimationDesktop: "_4fJQ5SOQJL _03zLI5ROYS _19veLJJF1Y"
}; /**
    * Styles for the side nav enter/exit animations when `platform-dst-motion-uplift-sidenav` is enabled.
    *
    * These use the `motion.sidenav.*` tokens (keyframe animations) instead of the `transform` transitions
    * with `@starting-style` used by `styles`.
    *
    * ⚠️ The `transition-duration` values below need to stay in sync with the duration baked into the tokens
    * (`motion.sidenav.enter.*` is 250ms, `motion.sidenav.exit.*` is 200ms). The `display` property is
    * transitioned (with `allow-discrete`) so the element stays rendered for the length of the exit animation —
    * if the transition is shorter than the animation, `display: none` applies early and the exit animation
    * never runs.
    */ 
const $69afecb6c46cd616$var$motionUpliftStyles = {
    animationRTLSupport: "_0PlsTg2NCt _41VWnOrGoh _3G2eGnoK2N _0bboGQNyFl",
    animationBaseStyles: "_2qDx9m4Gny _4tikTSThaV _03Q0eeLrT7",
    expandAnimationMobile: "_1jZhRJWRfq",
    collapseAnimationMobile: "_3NcSKiOQJL _1jZhRJTRd8",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _0k9R9aWRfq _4kVtJlqvoi _1UvFJ1ThaV",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _0k9R9aTRd8 _4kVtJlLrT7 _1UvFJ1ThaV",
    flyoutOpenFullHeightSidebar: "_1wp4FmWRfq _19NLAJqvoi",
    flyoutAnimateClosedFullHeightSidebar: "_0THHewYbGa _1wp4FmTRd8 _19NLAJLrT7",
    expandAnimationDesktop: "_4fJQ5SUzyj _1wp4FmWRfq",
    collapseAnimationDesktop: "_4fJQ5SOQJL _1wp4FmTRd8"
};
const $69afecb6c46cd616$var$fallbackDefaultWidth = 320;
const $69afecb6c46cd616$export$c735dc1c21910e21 = 500; /**
                                        * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
                                        * context value.
                                        */ 
function $69afecb6c46cd616$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $69afecb6c46cd616$var$fallbackDefaultWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $aFvBm.useExpandSideNav)({
        trigger: 'skip-link'
    }); /**
       * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
       *
       * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
       *
       * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
       */ 
    const synchronouslyExpandSideNav = (0, $cozmU.useCallback)(()=>{
        (0, $9kbTQ.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $gjVTm.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }); // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $cozmU.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $cozmU.useState)(isExpandedOnDesktop); /**
                                                                       * Captures the initial collapsed/expanded state of the side nav.
                                                                       *
                                                                       * Only firing on desktop because the nav is never open by default on mobile.
                                                                       */ 
    (0, $cozmU.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $6iHsT.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $69afecb6c46cd616$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth);
    const clampedWidth = `clamp(${$69afecb6c46cd616$var$widthResizeBounds.min}, ${width}px, ${$69afecb6c46cd616$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const navRef = (0, $cozmU.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $cozmU.useRef)(null); /**
                                                                             * Used to share the side nav element with the `Panel`,
                                                                             * which observes the side nav to determine its maximum width.
                                                                             */ 
    const sharedRef = (0, $1gX7M.useSideNavRef)();
    const mergedRef = (0, $lmzCg.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $cozmU.useContext)((0, $2E6Hq.SideNavToggleButtonElement));
    const topNavStartElement = (0, $cozmU.useContext)((0, $a5Bb1.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const flyoutStateRef = (0, $cozmU.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $jyAY3.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $cozmU.useRef)(false);
    const onPeekStartRef = (0, $jyAY3.default)(onPeekStart);
    const onPeekEndRef = (0, $jyAY3.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $cozmU.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $liCgE.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $69afecb6c46cd616$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState_0 = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState_0)=>{
                if (currentState_0?.desktop === 'collapsed' && currentState_0?.flyout === 'open') return {
                    ...currentState_0,
                    flyout: 'triggered-animate-close'
                };
                return currentState_0;
            }); // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState_0.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            } // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                 // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $4xyOi.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $6NDDH.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $6NDDH.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    }); // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $cozmU.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
         // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $cozmU.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $cozmU.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent_0 = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent_0.fire('navigation'); // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $cozmU.useCallback)(({ screen: screen_0, trigger: trigger_0 })=>{
        onCollapse?.({
            screen: screen_0,
            trigger: trigger_0
        });
        const navigationAnalyticsEvent_1 = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger_0
            }
        });
        navigationAnalyticsEvent_1.fire('navigation'); // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $7PUR3.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $cozmU.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]); /**
                                                                                  * Close the mobile side nav if there is a click outside.
                                                                                  *
                                                                                  * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
                                                                                  * If we listened to window size changes we'd need nested `bind()` calls.
                                                                                  */ 
    (0, $cozmU.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
         /**
       * The expected URL fragment used by the side nav skip link.
       */ 
        const skipLinkUrlFragment = `#${id}`;
        return (0, $cbY7C.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cbY7C.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                 // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cbY7C.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cbY7C.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                 // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cbY7C.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
         // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $iSrRp.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished'); // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $cbY7C.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event_0) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event_0.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event_0.target instanceof Element && toggleButtonElement.contains(event_0.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                 // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $cbY7C.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                 // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $g9jMx.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    }); // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    (0, $IRNbu.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $69afecb6c46cd616$var$panelSplitterResizingVar,
        panelId: (0, $liCgE.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop; /**
                                                                                                                         * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
                                                                                                                         *
                                                                                                                         * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
                                                                                                                         */ 
    const hasExpandedStateChangedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]); /**
                                              * If the expanded state of the side nav has ever changed since mount.
                                              *
                                              * Used to prevent sidebar expand animations from running on the initial load.
                                              * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
                                              */ 
    const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    const isMotionUpliftEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-sidenav'); // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = (isMotionUpliftEnabled || isFhsEnabled) && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$69afecb6c46cd616$var$isFirefox;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $liCgE.sideNavVar)]: clampedWidth
        },
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $69afecb6c46cd616$var$styles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileAndDesktop,
            isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.animationRTLSupport,
            !isMotionUpliftEnabled && isFhsEnabled && $69afecb6c46cd616$var$styles.animationRTLSupport,
            shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.animationBaseStyles,
            shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.animationBaseStyles,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.expandAnimationMobile,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.expandAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.collapseAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.collapseAnimationMobile,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.expandAnimationDesktop,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.expandAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.collapseAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.collapseAnimationDesktop,
            sideNavState?.flyout === 'open' && !isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutOpen,
            sideNavState?.flyout === 'open' && !isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutAnimateClosed,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutAnimateClosed,
            (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && $69afecb6c46cd616$var$styles.flyoutBaseStylesFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $69afecb6c46cd616$var$motionUpliftStyles.flyoutAnimateClosedFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$69afecb6c46cd616$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $69afecb6c46cd616$var$styles.flyoutAnimateClosedFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.sideNavLiveWidthVar),
        value: "0px",
        mediaQuery: (0, $gnKXs.media).above.md,
        responsiveValue: isExpandedOnDesktop ? `var(${$69afecb6c46cd616$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_sideNavLayoutVar),
        value: `var(${(0, $liCgE.sideNavLiveWidthVar)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iynkA.PanelSplitterProvider), {
        panelId: (0, $liCgE.sideNavPanelSplitterId),
        panelRef: navRef,
        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: $69afecb6c46cd616$var$getResizeBounds,
        resizingCssVar: $69afecb6c46cd616$var$panelSplitterResizingVar,
        isEnabled: !isFlyoutVisible,
        shortcut: isShortcutEnabled ? (0, $8CGNp.sideNavToggleTooltipKeyboardShortcut) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $69afecb6c46cd616$var$styles.flexContainer
        ])
    }, children))), isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: panelSplitterPortalTargetRef,
        "data-layout-slot": true,
        style: {
            // We need to use an inline style here to share the side nav width to position the panel splitter.
            // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
            // however the panel splitter is still visible and usable on small viewports until 48rem.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            [$69afecb6c46cd616$var$sideNavClampedWidthVar]: clampedWidth
        },
        className: (0, $hekY6.default)([
            $69afecb6c46cd616$var$panelSplitterPortalTargetStyles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $69afecb6c46cd616$var$styles.hiddenMobileAndDesktop
        ])
    }));
}
const $69afecb6c46cd616$export$1a35787d6353cf6a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SideNav(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, defaultCollapsed: defaultCollapsed, defaultWidth: t1, testId: testId, label: label, skipLinkLabel: t2, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id } = t0;
    const defaultWidth = t1 === undefined ? 320 : t1;
    const skipLinkLabel = t2 === undefined ? label : t2;
    let t3;
    if ($[0] !== canToggleWithShortcut || $[1] !== children || $[2] !== defaultCollapsed || $[3] !== defaultWidth || $[4] !== id || $[5] !== label || $[6] !== onCollapse || $[7] !== onExpand || $[8] !== onPeekEnd || $[9] !== onPeekStart || $[10] !== skipLinkLabel || $[11] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($69afecb6c46cd616$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut
        }, children));
        $[0] = canToggleWithShortcut;
        $[1] = children;
        $[2] = defaultCollapsed;
        $[3] = defaultWidth;
        $[4] = id;
        $[5] = label;
        $[6] = onCollapse;
        $[7] = onExpand;
        $[8] = onPeekEnd;
        $[9] = onPeekStart;
        $[10] = skipLinkLabel;
        $[11] = testId;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : function SideNav({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $liCgE.openLayerObserverSideNavNamespace)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($69afecb6c46cd616$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        id: id,
        canToggleWithShortcut: canToggleWithShortcut
    }, children));
};
module.exports["SideNav"] = $69afecb6c46cd616$export$1a35787d6353cf6a;

});

parcelRegister("1IrNk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $6SYAs = parcelRequire("6SYAs");


var $1wsnZ = parcelRequire("1wsnZ");

const $5a507d5d8d84b171$export$327d0d2a7ae6f7cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function OpenLayerObserverNamespaceProvider(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, namespace: namespace } = t0;
    const parentContext = (0, $1wsnZ.useOpenLayerObserverNamespace)();
    let t1;
    let t2;
    if ($[0] !== parentContext) {
        t1 = ()=>{
            (0, $bB0i2.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
        };
        t2 = [
            parentContext
        ];
        $[0] = parentContext;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== namespace) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SYAs.OpenLayerObserverNamespaceContext).Provider, {
            value: namespace
        }, children);
        $[3] = children;
        $[4] = namespace;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function OpenLayerObserverNamespaceProvider({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $1wsnZ.useOpenLayerObserverNamespace)();
    (0, $cozmU.useEffect)(()=>{
        (0, $bB0i2.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SYAs.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace
    }, children);
};
module.exports["OpenLayerObserverNamespaceProvider"] = $5a507d5d8d84b171$export$327d0d2a7ae6f7cc;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("eaAhc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vxJx = parcelRequire("7vxJx");

const $e876544291882b78$export$707b94c26b8b75aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden } = t0;
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $cozmU.useContext)((0, $7vxJx.SkipLinksContext));
    let t1;
    let t2;
    if ($[0] !== id || $[1] !== isHidden || $[2] !== label || $[3] !== listIndex || $[4] !== navigate || $[5] !== onBeforeNavigate || $[6] !== registerSkipLink || $[7] !== unregisterSkipLink) {
        t1 = ()=>{
            if (isHidden) return;
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex,
                onBeforeNavigate: onBeforeNavigate,
                navigate: navigate,
                isHidden: isHidden
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        };
        t2 = [
            id,
            isHidden,
            label,
            listIndex,
            onBeforeNavigate,
            navigate,
            registerSkipLink,
            unregisterSkipLink
        ];
        $[0] = id;
        $[1] = isHidden;
        $[2] = label;
        $[3] = listIndex;
        $[4] = navigate;
        $[5] = onBeforeNavigate;
        $[6] = registerSkipLink;
        $[7] = unregisterSkipLink;
        $[8] = t1;
        $[9] = t2;
    } else {
        t1 = $[8];
        t2 = $[9];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $cozmU.useContext)((0, $7vxJx.SkipLinksContext));
    (0, $cozmU.useEffect)(()=>{
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
module.exports["useSkipLinkInternal"] = $e876544291882b78$export$707b94c26b8b75aa;

});

parcelRegister("7vxJx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $17411c769fc5f032$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $cozmU.createContext)({
    registerSkipLink: (0, $dpsRj.default),
    unregisterSkipLink: (0, $dpsRj.default)
});
module.exports["SkipLinksContext"] = $17411c769fc5f032$export$4c5cc3b14c7678a;

});

parcelRegister("a5Bb1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $46933863bb9e41c6$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TopNavStartElement"] = $46933863bb9e41c6$export$e9e5087bd319cc8c;

});

parcelRegister("4aMCy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $044d6c64bd91ab11$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $044d6c64bd91ab11$export$9f45a1325e3cdfb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $044d6c64bd91ab11$var$getCssStringValue(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    let style = `:root { ${variableName}: ${t1} }`;
    if (mediaQuery && responsiveValue) {
        const t2 = style;
        let t3;
        if ($[2] !== responsiveValue) {
            t3 = $044d6c64bd91ab11$var$getCssStringValue(responsiveValue);
            $[2] = responsiveValue;
            $[3] = t3;
        } else t3 = $[3];
        style = t2 + ` ${mediaQuery} { :root { ${variableName}: ${t3} } }`;
    }
    let t2;
    if ($[4] !== style) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, style);
        $[4] = style;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root { ${variableName}: ${$044d6c64bd91ab11$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$044d6c64bd91ab11$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, style));
};
module.exports["DangerouslyHoistCssVarToDocumentRoot"] = $044d6c64bd91ab11$export$9f45a1325e3cdfb8;

});

parcelRegister("b24kF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $487ca48827d0d3da$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["DangerouslyHoistSlotSizes"] = $487ca48827d0d3da$export$66e2c1a0115af861;

});

parcelRegister("iynkA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kdCH7 = parcelRequire("kdCH7");

const $53b5162ceac70888$export$f662bfb764348932 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: t1, isEnabled: t2, shortcut: shortcut, children: children } = t0;
    const position = t1 === undefined ? "end" : t1;
    const isEnabled = t2 === undefined ? true : t2;
    const portalRef = (0, $cozmU.useRef)(null);
    const t3 = typeof providedPortalRef !== "undefined" ? providedPortalRef : portalRef;
    let t4;
    if ($[0] !== getResizeBounds || $[1] !== isEnabled || $[2] !== onCompleteResize || $[3] !== panelId || $[4] !== panelRef || $[5] !== panelWidth || $[6] !== position || $[7] !== resizingCssVar || $[8] !== shortcut || $[9] !== t3) {
        t4 = {
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: t3,
            shortcut: shortcut
        };
        $[0] = getResizeBounds;
        $[1] = isEnabled;
        $[2] = onCompleteResize;
        $[3] = panelId;
        $[4] = panelRef;
        $[5] = panelWidth;
        $[6] = position;
        $[7] = resizingCssVar;
        $[8] = shortcut;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const context = t4;
    let t5;
    if ($[11] !== children || $[12] !== context) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kdCH7.PanelSplitterContext).Provider, {
            value: context
        }, children);
        $[11] = children;
        $[12] = context;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== providedPortalRef) {
        t6 = typeof providedPortalRef !== "undefined" ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: portalRef
        });
        $[14] = providedPortalRef;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t5, t6);
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $cozmU.useRef)(null);
    const context = (0, $cozmU.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kdCH7.PanelSplitterContext).Provider, {
        value: context
    }, children), typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: portalRef
    }));
};
module.exports["PanelSplitterProvider"] = $53b5162ceac70888$export$f662bfb764348932;

});

parcelRegister("eyPWA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fG4wV = parcelRequire("fG4wV");

const $92c2259f831194de$export$110c3550c7c1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLayoutId(t0) {
    const $ = (0, $bDgLe.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { providedId: providedId } = t1;
    const uniqueId = (0, $fG4wV.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
} : function useLayoutId({ providedId: providedId } = {}) {
    const uniqueId = (0, $fG4wV.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
};
module.exports["useLayoutId"] = $92c2259f831194de$export$110c3550c7c1c9aa;

});

parcelRegister("fG4wV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $34fa9019e33947fd$export$fa3cfac0c8e29c5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSkipLinkId() {
    const uniqueId = (0, $6JrSr.useId)();
    return uniqueId;
} : function useSkipLinkId() {
    const uniqueId = (0, $6JrSr.useId)();
    return uniqueId;
};
module.exports["useSkipLinkId"] = $34fa9019e33947fd$export$fa3cfac0c8e29c5c;

});

parcelRegister("IRNbu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");


var $aLgN8 = parcelRequire("aLgN8");

const $5922881dcb012091$export$d4931ecf0fbcc8fc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useResizingWidthCssVarOnRootElement(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { isEnabled: t1, cssVar: cssVar, panelId: panelId } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== cssVar || $[1] !== isEnabled || $[2] !== panelId) {
        t2 = ()=>{
            if (!isEnabled) return;
            return (0, $aDtKq.combine)((0, $iSrRp.monitorForElements)({
                canMonitor (t4) {
                    const { source: source } = t4;
                    return source.data.panelId === panelId;
                },
                onDrag (t5) {
                    const { source: source_0 } = t5;
                    if (!(0, $aLgN8.isPanelSplitterDragData)(source_0.data)) return;
                    document.documentElement.style.setProperty(cssVar, source_0.data.resizingWidth);
                },
                onDrop () {
                    document.documentElement.style.removeProperty(cssVar);
                }
            }));
        };
        t3 = [
            cssVar,
            isEnabled,
            panelId
        ];
        $[0] = cssVar;
        $[1] = isEnabled;
        $[2] = panelId;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[5] !== cssVar || $[6] !== isEnabled) {
        t4 = ()=>{
            if (!isEnabled) return;
            return function cleanupGlobalResizingCssVar() {
                document.documentElement.style.removeProperty(cssVar);
            };
        };
        t5 = [
            cssVar,
            isEnabled
        ];
        $[5] = cssVar;
        $[6] = isEnabled;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : function useResizingWidthCssVarOnRootElement({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $aDtKq.combine)((0, $iSrRp.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source_0 }) {
                if (!(0, $aLgN8.isPanelSplitterDragData)(source_0.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source_0.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
};
module.exports["useResizingWidthCssVarOnRootElement"] = $5922881dcb012091$export$d4931ecf0fbcc8fc;

});

parcelRegister("6iHsT", function(module, exports) {
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $900eefb3c2156b48$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}
module.exports["useSafeDefaultWidth"] = $900eefb3c2156b48$export$cff429d7d83ba1f0;

});

parcelRegister("4xyOi", function(module, exports) {
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $1d796bc36218efa4$export$a7801e29f563faad = 400;
module.exports["sideNavFlyoutCloseDelayMs"] = $1d796bc36218efa4$export$a7801e29f563faad;

});

parcelRegister("2udoJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $78d3ad3ac2c5fcd5$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["SetSideNavVisibilityState"] = $78d3ad3ac2c5fcd5$export$f6b496b07d1ea493;

});

parcelRegister("2E6Hq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2f1a6650dc7c80f1$export$9c1768094bef896 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["SideNavToggleButtonElement"] = $2f1a6650dc7c80f1$export$9c1768094bef896;

});

parcelRegister("8CGNp", function(module, exports) {
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $2169f54a5c039586$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];
module.exports["sideNavToggleTooltipKeyboardShortcut"] = $2169f54a5c039586$export$bcd616a79072c3e4;

});

parcelRegister("5rNCB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $eeda3404f6707f04$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["SideNavVisibilityState"] = $eeda3404f6707f04$export$eb04201bb6dd1e4e;

});

parcelRegister("aFvBm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $iDrrr = parcelRequire("iDrrr");


var $2udoJ = parcelRequire("2udoJ");


var $1gX7M = parcelRequire("1gX7M");

/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $9744c12cac2fb670$var$focusFirstNavItem(sideNavElement) {
    /**
   * Try to get the first focusable item in the side nav.
   * The selector is not very broad, but should be appropriate for items from this package.
   */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
     * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
     * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
     *
     * Our slots are not interactive, so this is required.
     *
     * In the future we may want to check if there is an existing `tabindex` attribute,
     * as custom skip linked elements might already have one.
     */ sideNavElement.setAttribute('tabindex', '-1');
        /**
     * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
     *
     * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
     *
     * - mess with click events
     * - potentially cause a focus ring to be always visible
     */ (0, $cbY7C.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
   * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
   */ itemToFocus.focus();
}
const $9744c12cac2fb670$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
const $9744c12cac2fb670$export$e44b4744d8ff971a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useExpandSideNav(t0) {
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { trigger: t2 } = t1;
    const trigger = t2 === undefined ? "programmatic" : t2;
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavRef = (0, $1gX7M.useSideNavRef)();
    let t3;
    if ($[2] !== setSideNavState || $[3] !== sideNavRef || $[4] !== trigger) {
        t3 = ()=>{
            const { matches: isDesktop } = window.matchMedia("(min-width: 64rem)");
            const runUpdate = ()=>{
                if (isDesktop) setSideNavState((currentState)=>{
                    if (!currentState) return null;
                    if (currentState.desktop === "expanded" && currentState.flyout === "closed") return currentState;
                    return {
                        mobile: currentState.mobile,
                        desktop: "expanded",
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
                else setSideNavState((currentState_0)=>{
                    if (!currentState_0) return null;
                    if (currentState_0.mobile === "expanded" && currentState_0.flyout === "closed") return currentState_0;
                    return {
                        desktop: currentState_0.desktop,
                        mobile: "expanded",
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
            };
            if ($9744c12cac2fb670$var$triggersWithFocusOnExpand.has(trigger) && (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) {
                (0, $9kbTQ.flushSync)(runUpdate);
                const sideNavElement = sideNavRef.current;
                if (sideNavElement) $9744c12cac2fb670$var$focusFirstNavItem(sideNavElement);
            } else runUpdate();
        };
        $[2] = setSideNavState;
        $[3] = sideNavRef;
        $[4] = trigger;
        $[5] = t3;
    } else t3 = $[5];
    const expandSideNav = t3;
    return expandSideNav;
} : function useExpandSideNav({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavRef = (0, $1gX7M.useSideNavRef)();
    const expandSideNav = (0, $cozmU.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState_0)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState_0) return null;
                // Skip the re-render if it's a no-op change
                if (currentState_0.mobile === 'expanded' && currentState_0.flyout === 'closed') return currentState_0;
                return {
                    desktop: currentState_0.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($9744c12cac2fb670$var$triggersWithFocusOnExpand.has(trigger) && (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $9kbTQ.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $9744c12cac2fb670$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
};
module.exports["useExpandSideNav"] = $9744c12cac2fb670$export$e44b4744d8ff971a;

});

parcelRegister("1gX7M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $aQh3x = parcelRequire("aQh3x");

const $50ff21347d670a2f$export$fa4d0cff03b1ea4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSideNavRef() {
    return (0, $cozmU.useContext)((0, $aQh3x.SideNavRefContext));
} : function useSideNavRef() {
    return (0, $cozmU.useContext)((0, $aQh3x.SideNavRefContext));
};
module.exports["useSideNavRef"] = $50ff21347d670a2f$export$fa4d0cff03b1ea4f;

});

parcelRegister("aQh3x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ddeb9803e72f6a24$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $cozmU.createContext)({
    current: null
});
module.exports["SideNavRefContext"] = $ddeb9803e72f6a24$export$1cd490805a3a9874;

});

parcelRegister("d8d8E", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iaSOX = parcelRequire("iaSOX");

const $3a9506b5e2c493a4$export$be30cdcd17f95ec7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useIsSideNavShortcutEnabled() {
    return (0, $cozmU.useContext)((0, $iaSOX.IsSideNavShortcutEnabledContext));
} : function useIsSideNavShortcutEnabled() {
    return (0, $cozmU.useContext)((0, $iaSOX.IsSideNavShortcutEnabledContext));
};
module.exports["useIsSideNavShortcutEnabled"] = $3a9506b5e2c493a4$export$be30cdcd17f95ec7;

});

parcelRegister("iaSOX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4733d63ffc9c0010$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["IsSideNavShortcutEnabledContext"] = $4733d63ffc9c0010$export$c41e1ac5602bc8d5;

});

parcelRegister("g9jMx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $jyAY3 = parcelRequire("jyAY3");


var $kgGsB = parcelRequire("kgGsB");


var $1fHIr = parcelRequire("1fHIr");


var $d8d8E = parcelRequire("d8d8E");


var $6NDDH = parcelRequire("6NDDH");

const $51ee361d7fd33029$export$f762e7ac9d86adb0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSideNavToggleKeyboardShortcut(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { canToggleWithShortcut: canToggleWithShortcut } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            trigger: "keyboard"
        };
        $[0] = t1;
    } else t1 = $[0];
    const toggleVisibilityByShortcut = (0, $6NDDH.useToggleSideNav)(t1);
    const canToggleWithShortcutStableRef = (0, $jyAY3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    let t2;
    let t3;
    if ($[1] !== canToggleWithShortcutStableRef || $[2] !== isFhsEnabled || $[3] !== isSideNavShortcutEnabled || $[4] !== openLayerObserver || $[5] !== toggleVisibilityByShortcut) {
        t2 = ()=>{
            if (!isFhsEnabled) return;
            if (!isSideNavShortcutEnabled) return;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener (event) {
                    if (event.ctrlKey && event.key === "[") {
                        if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) return;
                        if (event.repeat) return;
                        if (openLayerObserver && openLayerObserver.getCount({
                            type: "modal"
                        }) > 0) return;
                        openLayerObserver?.closeLayers();
                        toggleVisibilityByShortcut();
                    }
                }
            });
        };
        t3 = [
            canToggleWithShortcutStableRef,
            isFhsEnabled,
            isSideNavShortcutEnabled,
            openLayerObserver,
            toggleVisibilityByShortcut
        ];
        $[1] = canToggleWithShortcutStableRef;
        $[2] = isFhsEnabled;
        $[3] = isSideNavShortcutEnabled;
        $[4] = openLayerObserver;
        $[5] = toggleVisibilityByShortcut;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useSideNavToggleKeyboardShortcut({ canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $6NDDH.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $jyAY3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    (0, $cozmU.useEffect)(()=>{
        if (!isFhsEnabled) return;
        if (!isSideNavShortcutEnabled) return;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isFhsEnabled,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
};
module.exports["useSideNavToggleKeyboardShortcut"] = $51ee361d7fd33029$export$f762e7ac9d86adb0;

});

parcelRegister("6NDDH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $2udoJ = parcelRequire("2udoJ");


var $5rNCB = parcelRequire("5rNCB");


var $aFvBm = parcelRequire("aFvBm");

const $85245a7ff1efb457$export$477ee35601a0a8ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useToggleSideNav(t0) {
    const $ = (0, $bDgLe.c)(10);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { trigger: t2 } = t1;
    const trigger = t2 === undefined ? "programmatic" : t2;
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    let t3;
    if ($[2] !== trigger) {
        t3 = {
            trigger: trigger
        };
        $[2] = trigger;
        $[3] = t3;
    } else t3 = $[3];
    const expandSideNav = (0, $aFvBm.useExpandSideNav)(t3);
    const isCollapsedOnDesktop = sideNavState?.desktop === "collapsed";
    const isCollapsedOnMobile = sideNavState?.mobile === "collapsed";
    let t4;
    if ($[4] !== expandSideNav || $[5] !== isCollapsedOnDesktop || $[6] !== isCollapsedOnMobile || $[7] !== setSideNavState || $[8] !== trigger) {
        t4 = ()=>{
            const { matches: isDesktop } = window.matchMedia("(min-width: 64rem)");
            if ((0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) {
                const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
                if (isExpanding) expandSideNav();
                else setSideNavState((currentState)=>{
                    if (!currentState) return null;
                    return {
                        mobile: isDesktop ? currentState.mobile : "collapsed",
                        desktop: isDesktop ? "collapsed" : currentState.desktop,
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
                return;
            }
            if (isDesktop) setSideNavState((currentState_0)=>{
                if (!currentState_0) return null;
                return {
                    mobile: currentState_0.mobile,
                    desktop: currentState_0.desktop === "expanded" ? "collapsed" : "expanded",
                    flyout: "closed",
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState_1)=>{
                if (!currentState_1) return null;
                return {
                    desktop: currentState_1.desktop,
                    mobile: currentState_1.mobile === "expanded" ? "collapsed" : "expanded",
                    flyout: "closed",
                    lastTrigger: trigger
                };
            });
        };
        $[4] = expandSideNav;
        $[5] = isCollapsedOnDesktop;
        $[6] = isCollapsedOnMobile;
        $[7] = setSideNavState;
        $[8] = trigger;
        $[9] = t4;
    } else t4 = $[9];
    const toggleSideNav = t4;
    return toggleSideNav;
} : function useToggleSideNav({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $cozmU.useContext)((0, $2udoJ.SetSideNavVisibilityState));
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const expandSideNav = (0, $aFvBm.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $cozmU.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState_0)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState_0) return null;
            return {
                mobile: currentState_0.mobile,
                desktop: currentState_0.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState_1)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState_1) return null;
            return {
                desktop: currentState_1.desktop,
                mobile: currentState_1.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
};
module.exports["useToggleSideNav"] = $85245a7ff1efb457$export$477ee35601a0a8ce;

});

parcelRegister("gjVTm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5rNCB = parcelRequire("5rNCB");

const $ef249aefe62a86fe$export$4a602ad7e09bdb2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { defaultCollapsed: t2 } = t1;
    const defaultCollapsed = t2 === undefined ? false : t2;
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    if (sideNavState === null) {
        const t3 = !defaultCollapsed;
        let t4;
        if ($[2] !== t3) {
            t4 = {
                isExpandedOnDesktop: t3,
                isExpandedOnMobile: false
            };
            $[2] = t3;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const t3 = sideNavState.desktop === "expanded";
    const t4 = sideNavState.mobile === "expanded";
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = {
            isExpandedOnDesktop: t3,
            isExpandedOnMobile: t4
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};
module.exports["useSideNavVisibility"] = $ef249aefe62a86fe$export$4a602ad7e09bdb2c;

});

parcelRegister("7PUR3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6iJ3v = parcelRequire("6iJ3v");

const $bea74fa628ffec08$export$1904b8f2577aba9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSideNavVisibilityCallbacks(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger } = t0;
    const onExpandRef = (0, $cozmU.useRef)(onExpand);
    const onCollapseRef = (0, $cozmU.useRef)(onCollapse);
    let t1;
    let t2;
    if ($[0] !== onCollapse || $[1] !== onExpand) {
        t1 = ()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        };
        t2 = [
            onExpand,
            onCollapse
        ];
        $[0] = onCollapse;
        $[1] = onExpand;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const previousIsExpandedOnDesktop = (0, $6iJ3v.default)(isExpandedOnDesktop);
    let t3;
    let t4;
    if ($[4] !== isExpandedOnDesktop || $[5] !== lastTrigger || $[6] !== previousIsExpandedOnDesktop) {
        t3 = ()=>{
            if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) return;
            if (isExpandedOnDesktop) onExpandRef.current?.({
                screen: "desktop",
                trigger: lastTrigger
            });
            else onCollapseRef.current?.({
                screen: "desktop",
                trigger: lastTrigger
            });
        };
        t4 = [
            previousIsExpandedOnDesktop,
            isExpandedOnDesktop,
            lastTrigger
        ];
        $[4] = isExpandedOnDesktop;
        $[5] = lastTrigger;
        $[6] = previousIsExpandedOnDesktop;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const previousIsExpandedOnMobile = (0, $6iJ3v.default)(isExpandedOnMobile);
    let t5;
    let t6;
    if ($[9] !== isExpandedOnMobile || $[10] !== lastTrigger || $[11] !== previousIsExpandedOnMobile) {
        t5 = ()=>{
            if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) return;
            if (isExpandedOnMobile) onExpandRef.current?.({
                screen: "mobile",
                trigger: lastTrigger
            });
            else onCollapseRef.current?.({
                screen: "mobile",
                trigger: lastTrigger
            });
        };
        t6 = [
            previousIsExpandedOnMobile,
            isExpandedOnMobile,
            lastTrigger
        ];
        $[9] = isExpandedOnMobile;
        $[10] = lastTrigger;
        $[11] = previousIsExpandedOnMobile;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
} : function useSideNavVisibilityCallbacks({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $cozmU.useRef)(onExpand);
    const onCollapseRef = (0, $cozmU.useRef)(onCollapse);
    (0, $cozmU.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $6iJ3v.default)(isExpandedOnDesktop);
    (0, $cozmU.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $6iJ3v.default)(isExpandedOnMobile);
    (0, $cozmU.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
};
module.exports["useSideNavVisibilityCallbacks"] = $bea74fa628ffec08$export$1904b8f2577aba9a;

});

parcelRegister("4oUV5", function(module, exports) {
/* side-nav-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $1fHIr = parcelRequire("1fHIr");

const $c2e0995421fdf372$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $cozmU.forwardRef)($c2e0995421fdf372$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $c2e0995421fdf372$var$styles = {
    scrollContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP",
    paddingContainer: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE"
};
function $c2e0995421fdf372$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRef = (0, $cozmU.useMemo)(()=>(0, $lmzCg.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $c2e0995421fdf372$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $c2e0995421fdf372$var$styles.paddingContainer
        ])
    }, children));
}
module.exports["SideNavBody"] = $c2e0995421fdf372$export$28f21f3651df4fa1;

});

parcelRegister("gRMSv", function(module, exports) {

let $c47782c3f17f41a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c47782c3f17f41a4$var$load("koqff"),
    $c47782c3f17f41a4$var$load("a9nz3")
]).then(()=>parcelRequire('aMAND'));

});

parcelRegister("jJev0", function(module, exports) {

let $03b4dcc43b1827b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03b4dcc43b1827b0$var$load("huk1H").then(()=>parcelRequire('gyspK'));

});

parcelRegister("3DdwQ", function(module, exports) {

let $2a4f82210d4f587b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2a4f82210d4f587b$var$load("lvkNu"),
    $2a4f82210d4f587b$var$load("lgIhe"),
    $2a4f82210d4f587b$var$load("hNZQO")
]).then(()=>parcelRequire('9EwLd'));

});

parcelRegister("pFqKC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");

function $7a5cd95f78fc7101$export$d9621e370b3a0518(conversationId, invocationIds) {
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId ?? ''
    });
    return (0, $cozmU.useMemo)(()=>{
        const statuses = {};
        for (const invocationId of invocationIds){
            let resolved = 'idle';
            for (const message of messages)if ((0, $igOtY.isStoreAssistant)(message)) {
                const status = (0, $igOtY.getActionInvocationStatus)(invocationId, message.invokedActions);
                if (status !== 'idle') {
                    resolved = status;
                    break;
                }
            }
            statuses[invocationId] = resolved;
        }
        return statuses;
    }, [
        messages,
        invocationIds
    ]);
}
module.exports["useActionInvocationStatuses"] = $7a5cd95f78fc7101$export$d9621e370b3a0518;

});

parcelRegister("bKJ8C", function(module, exports) {

let $88e701084c5c27e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88e701084c5c27e2$var$load("6THhx").then(()=>parcelRequire('lCz1U'));

});

parcelRegister("cio5w", function(module, exports) {

let $8f39d9da234b6062$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8f39d9da234b6062$var$load("lhLGe"),
    $8f39d9da234b6062$var$load("8STUC"),
    $8f39d9da234b6062$var$load("2la9m"),
    $8f39d9da234b6062$var$load("9pQri"),
    $8f39d9da234b6062$var$load("bbLnX"),
    $8f39d9da234b6062$var$load("1UUnk"),
    $8f39d9da234b6062$var$load("80Yra"),
    $8f39d9da234b6062$var$load("cgKMu"),
    $8f39d9da234b6062$var$load("5e5ry"),
    $8f39d9da234b6062$var$load("hUbK8"),
    $8f39d9da234b6062$var$load("dgfR3"),
    $8f39d9da234b6062$var$load("awOLN"),
    $8f39d9da234b6062$var$load("eS1b9"),
    $8f39d9da234b6062$var$load("jomLJ"),
    $8f39d9da234b6062$var$load("ignwK"),
    $8f39d9da234b6062$var$load("j5RRe"),
    $8f39d9da234b6062$var$load("agaLh"),
    $8f39d9da234b6062$var$load("1Gr4q"),
    $8f39d9da234b6062$var$load("7TyQi"),
    $8f39d9da234b6062$var$load("e5ukl"),
    $8f39d9da234b6062$var$load("d19Pa"),
    $8f39d9da234b6062$var$load("hYORG"),
    $8f39d9da234b6062$var$load("219np"),
    $8f39d9da234b6062$var$load("4Mi85"),
    $8f39d9da234b6062$var$load("kccW9"),
    $8f39d9da234b6062$var$load("TfSzW"),
    $8f39d9da234b6062$var$load("ceyL9"),
    $8f39d9da234b6062$var$load("fHS77"),
    $8f39d9da234b6062$var$load("9jVdm"),
    $8f39d9da234b6062$var$load("kSgPY"),
    $8f39d9da234b6062$var$load("k2NjG"),
    $8f39d9da234b6062$var$load("dZYhM"),
    $8f39d9da234b6062$var$load("fAzyA"),
    $8f39d9da234b6062$var$load("Tjs4D"),
    $8f39d9da234b6062$var$load("6bjEk"),
    $8f39d9da234b6062$var$load("fkLbQ"),
    $8f39d9da234b6062$var$load("bMNgp"),
    $8f39d9da234b6062$var$load("g8J2P"),
    $8f39d9da234b6062$var$load("ieJFF"),
    $8f39d9da234b6062$var$load("eqj21"),
    $8f39d9da234b6062$var$load("3oAU3"),
    $8f39d9da234b6062$var$load("6fgrL"),
    $8f39d9da234b6062$var$load("ewOAX"),
    $8f39d9da234b6062$var$load("2Bp34"),
    $8f39d9da234b6062$var$load("3iw68"),
    $8f39d9da234b6062$var$load("kHXvF"),
    $8f39d9da234b6062$var$load("5Mm1x"),
    $8f39d9da234b6062$var$load("90vep"),
    $8f39d9da234b6062$var$load("aAJyu"),
    $8f39d9da234b6062$var$load("f8Q8b"),
    $8f39d9da234b6062$var$load("6wr18"),
    $8f39d9da234b6062$var$load("Wowvf"),
    $8f39d9da234b6062$var$load("gnocL"),
    $8f39d9da234b6062$var$load("7EorR"),
    $8f39d9da234b6062$var$load("hhss7"),
    $8f39d9da234b6062$var$load("ffEVr"),
    $8f39d9da234b6062$var$load("gEkwn"),
    $8f39d9da234b6062$var$load("ixrKS"),
    $8f39d9da234b6062$var$load("fdLC1"),
    $8f39d9da234b6062$var$load("5CO1V")
]).then(()=>parcelRequire('eBhXO'));

});

parcelRegister("eS3l0", function(module, exports) {
/**
 * Canonical production Home host that recipients are sent to when opening a shared chat.
 *
 * A share link is consumed by a recipient who has no relationship to the
 * tenant/origin where the chat was created (e.g. a chat shared from
 * `hello.atlassian.net` should still open on Home, not on `hello`). Production
 * tenants use this as the default for generated links.
 */ const $63181e7ce6633f6c$export$8955dfdae8a2a221 = 'https://home.atlassian.com';
const $63181e7ce6633f6c$export$f7619140282e6f7a = 'https://home.stg.atlassian.com';
/**
 * Path segment placed between the base URL and the opaque share token.
 */ const $63181e7ce6633f6c$var$SHARE_PATH = '/chat/share';
const $63181e7ce6633f6c$var$SHARE_PREVIEW_PATH = `${$63181e7ce6633f6c$var$SHARE_PATH}/preview`;
const $63181e7ce6633f6c$var$getCurrentOrigin = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.location.origin;
};
const $63181e7ce6633f6c$export$1f2105e47e4394d6 = ()=>{
    if (typeof window === 'undefined') return undefined;
    const match = window.location.pathname.match(/^\/o\/([^/]+)/);
    return match?.[1];
};
const $63181e7ce6633f6c$export$e8ce839529963220 = (origin = $63181e7ce6633f6c$var$getCurrentOrigin())=>{
    if (origin?.includes('jira-dev.com') || origin?.includes('home.stg.atlassian.com')) return $63181e7ce6633f6c$export$f7619140282e6f7a;
    return $63181e7ce6633f6c$export$8955dfdae8a2a221;
};
const $63181e7ce6633f6c$export$c3e9175d403671f7 = (shareToken, baseUrl = $63181e7ce6633f6c$export$e8ce839529963220(), orgId, siteId)=>{
    // Normalise away any trailing slash on the base URL so we never emit a
    // double slash before the share path.
    const normalisedBase = baseUrl.replace(/\/+$/, '');
    const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
    const params = siteId ? new URLSearchParams({
        siteId: siteId
    }) : undefined;
    return `${normalisedBase}${orgPath}${$63181e7ce6633f6c$var$SHARE_PATH}/${shareToken}${params ? `?${params.toString()}` : ''}`;
};
const $63181e7ce6633f6c$export$9fba46c1fd475aa6 = ({ conversationId: conversationId, messageId: messageId, baseUrl: baseUrl = $63181e7ce6633f6c$export$e8ce839529963220(), orgId: orgId, siteId: siteId })=>{
    const normalisedBase = baseUrl.replace(/\/+$/, '');
    const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
    const params = new URLSearchParams({
        conversationId: conversationId,
        messageId: messageId,
        ...siteId ? {
            siteId: siteId
        } : {}
    });
    return `${normalisedBase}${orgPath}${$63181e7ce6633f6c$var$SHARE_PREVIEW_PATH}?${params.toString()}`;
};
module.exports["getOrgIdFromLocation"] = $63181e7ce6633f6c$export$1f2105e47e4394d6;
module.exports["getDefaultShareBaseUrl"] = $63181e7ce6633f6c$export$e8ce839529963220;
module.exports["buildShareConversationUrl"] = $63181e7ce6633f6c$export$c3e9175d403671f7;
module.exports["buildShareConversationPreviewUrl"] = $63181e7ce6633f6c$export$9fba46c1fd475aa6;

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("iuXnd"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("iuXnd", function(module, exports) {

let $d77915abbb736969$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d77915abbb736969$var$load("9vfaJ"),
    $d77915abbb736969$var$load("a3UEF"),
    $d77915abbb736969$var$load("cyTuQ"),
    $d77915abbb736969$var$load("59hV4"),
    $d77915abbb736969$var$load("5hXCh"),
    $d77915abbb736969$var$load("9eAMl"),
    $d77915abbb736969$var$load("70VQ3"),
    $d77915abbb736969$var$load("3WmaY"),
    $d77915abbb736969$var$load("7gL7H"),
    $d77915abbb736969$var$load("gnocL"),
    $d77915abbb736969$var$load("11yNG"),
    $d77915abbb736969$var$load("gQYVn"),
    $d77915abbb736969$var$load("jvUhP"),
    $d77915abbb736969$var$load("7sOKp"),
    $d77915abbb736969$var$load("7Ysw6"),
    $d77915abbb736969$var$load("3xL2F"),
    $d77915abbb736969$var$load("aAWLw"),
    $d77915abbb736969$var$load("ccAQf"),
    $d77915abbb736969$var$load("hUbK8"),
    $d77915abbb736969$var$load("lomHl"),
    $d77915abbb736969$var$load("fmAgy"),
    $d77915abbb736969$var$load("7fsAO"),
    $d77915abbb736969$var$load("53ySD"),
    $d77915abbb736969$var$load("7Ktrp"),
    $d77915abbb736969$var$load("hTxlQ"),
    $d77915abbb736969$var$load("lLB3Y"),
    $d77915abbb736969$var$load("7TyQi"),
    $d77915abbb736969$var$load("axj69"),
    $d77915abbb736969$var$load("219np"),
    $d77915abbb736969$var$load("4Mi85"),
    $d77915abbb736969$var$load("TfSzW"),
    $d77915abbb736969$var$load("fHS77"),
    $d77915abbb736969$var$load("lhLGe"),
    $d77915abbb736969$var$load("8STUC"),
    $d77915abbb736969$var$load("3zwpG"),
    $d77915abbb736969$var$load("fkLbQ"),
    $d77915abbb736969$var$load("bMNgp"),
    $d77915abbb736969$var$load("6fgrL"),
    $d77915abbb736969$var$load("ewOAX"),
    $d77915abbb736969$var$load("dRQNV"),
    $d77915abbb736969$var$load("kwVVP"),
    $d77915abbb736969$var$load("8exG0"),
    $d77915abbb736969$var$load("lYB2V"),
    $d77915abbb736969$var$load("djzm4"),
    $d77915abbb736969$var$load("6Vp6A"),
    $d77915abbb736969$var$load("6wr18"),
    $d77915abbb736969$var$load("ffEVr"),
    $d77915abbb736969$var$load("bbLnX"),
    $d77915abbb736969$var$load("1UUnk"),
    $d77915abbb736969$var$load("90vep"),
    $d77915abbb736969$var$load("ixrKS"),
    $d77915abbb736969$var$load("fdLC1"),
    $d77915abbb736969$var$load("hhss7"),
    $d77915abbb736969$var$load("Wowvf"),
    $d77915abbb736969$var$load("aAJyu"),
    $d77915abbb736969$var$load("f8Q8b"),
    $d77915abbb736969$var$load("cKDij"),
    $d77915abbb736969$var$load("7EorR"),
    $d77915abbb736969$var$load("ce05o"),
    $d77915abbb736969$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});

parcelRegister("b1E2G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kuIhJ = parcelRequire("kuIhJ");


var $12shJ = parcelRequire("12shJ");


var $6RbPE = parcelRequire("6RbPE");

const $febfb227ddaedd16$export$f8e0e90cb175d8a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { spaceId: spaceId, cloudId: cloudId, product: t1, experienceId: t2 } = t0;
    const product = t1 === undefined ? "rovo" : t1;
    const experienceId = t2 === undefined ? "ai-mate" : t2;
    const { removeSpaceSource: removeSpaceSource } = (0, $12shJ.useSpaceStoreActions)();
    let t3;
    if ($[0] !== cloudId || $[1] !== experienceId || $[2] !== product || $[3] !== removeSpaceSource || $[4] !== spaceId) {
        t3 = {
            mutationFn: async (sourceId)=>{
                await (0, $6RbPE.deleteSpaceSourceFetchAction)({
                    spaceId: spaceId,
                    sourceId: sourceId,
                    cloudId: cloudId,
                    product: product,
                    experienceId: experienceId
                });
                removeSpaceSource(spaceId, sourceId);
            }
        };
        $[0] = cloudId;
        $[1] = experienceId;
        $[2] = product;
        $[3] = removeSpaceSource;
        $[4] = spaceId;
        $[5] = t3;
    } else t3 = $[5];
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)(t3);
    let t4;
    if ($[6] !== mutate) {
        t4 = async (sourceId_0)=>{
            let caught = null;
            await mutate(sourceId_0, {
                onError: (err)=>{
                    caught = err;
                }
            });
            if (caught !== null) throw caught;
        };
        $[6] = mutate;
        $[7] = t4;
    } else t4 = $[7];
    const deleteSource = t4;
    let t5;
    if ($[8] !== deleteSource || $[9] !== error || $[10] !== isSubmitting) {
        t5 = {
            deleteSource: deleteSource,
            isDeleting: isSubmitting,
            error: error
        };
        $[8] = deleteSource;
        $[9] = error;
        $[10] = isSubmitting;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ spaceId: spaceId, cloudId: cloudId, product: product = 'rovo', experienceId: experienceId = 'ai-mate' })=>{
    const { removeSpaceSource: removeSpaceSource } = (0, $12shJ.useSpaceStoreActions)();
    const { mutate: mutate, isSubmitting: isSubmitting, error: error } = (0, $kuIhJ.useMutation)({
        mutationFn: async (sourceId)=>{
            await (0, $6RbPE.deleteSpaceSourceFetchAction)({
                spaceId: spaceId,
                sourceId: sourceId,
                cloudId: cloudId,
                product: product,
                experienceId: experienceId
            });
            // Mirror the deletion. Done here (not in top-level `onSuccess`)
            // because that callback receives only `data` — we'd lose `sourceId`.
            removeSpaceSource(spaceId, sourceId);
        }
    });
    // Re-throw on failure to preserve the previous `Promise<void>` contract
    // — callers (e.g. ChatView) rely on it for optimistic-UI rollback.
    const deleteSource = (0, $cozmU.useCallback)(async (sourceId_0)=>{
        let caught = null;
        await mutate(sourceId_0, {
            onError: (err)=>{
                caught = err;
            }
        });
        if (caught !== null) // `caught` is a real `Error`/`ApiError` instance from the mutation
        // reducer; oxlint's `no-throw-literal` is purely syntactic and
        // can't see the captured-from-callback type, so disable here.
        // eslint-disable-next-line no-throw-literal
        throw caught;
    }, [
        mutate
    ]);
    return {
        deleteSource: deleteSource,
        isDeleting: isSubmitting,
        error: error
    };
};
module.exports["useDeleteSpaceSource"] = $febfb227ddaedd16$export$f8e0e90cb175d8a;

});

parcelRegister("6RbPE", function(module, exports) {
/**
 * Pure fetch helper extracted from `useDeleteSpaceSource` so the hook itself
 * can stay focused on the React-state / sweet-state mirroring concerns and
 * the shared `useMutation` utility can drive the request lifecycle.
 *
 * The DELETE endpoint returns 204 No Content; `performHttpFetch` would
 * attempt `response.json()` and throw on an empty body, so we keep the
 * manual `fetch` here.
 */ 
var $jTKfH = parcelRequire("jTKfH");


var $98i9C = parcelRequire("98i9C");

const $2243bed6c9c111ba$export$303fe452d3c190f2 = async ({ spaceId: spaceId, sourceId: sourceId, cloudId: cloudId, product: product, experienceId: experienceId })=>{
    const path = `${(0, $98i9C.SPACES_API_PATH)}/${spaceId}/sources/${sourceId}`;
    let response;
    try {
        response = await fetch(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-cloudid': cloudId,
                'x-product': product,
                'x-experience-id': experienceId
            },
            credentials: 'include'
        });
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`deleteSpaceSourceFetch error while fetching ${path}. Original error: ${originalErrorMessage}`, {
            errorCode: 'deleteSpaceSourceFetchError'
        });
    }
    if (!response.ok || response.status >= 400) {
        const body = await response.text().catch(()=>'');
        throw new (0, $jTKfH.FetchError)(`deleteSpaceSourceFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`, {
            errorCode: 'deleteSpaceSourceFetchError',
            statusCode: response.status
        });
    }
// 204 No Content — no body to parse.
};
module.exports["deleteSpaceSourceFetchAction"] = $2243bed6c9c111ba$export$303fe452d3c190f2;

});

parcelRegister("kfRNa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c84e3779256b42c88ff2b5ef5b8d752>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebeeef547073e2ff$var$_react = $ebeeef547073e2ff$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ebeeef547073e2ff$var$_baseNew = $ebeeef547073e2ff$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ebeeef547073e2ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Return".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/return
 * Usage guidance:
 * Reserved for submitting text fields without dedicated button, mainly AI prompts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebeeef547073e2ff$var$ReturnIcon = (props)=>/*#__PURE__*/ $ebeeef547073e2ff$var$_react.default.createElement($ebeeef547073e2ff$var$_baseNew.default, Object.assign({
        name: "ReturnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 8V3H14v5.438c0 .586-.476 1.062-1.062 1.062H4.56l2.72 2.72-1.061 1.06-4-4a.75.75 0 0 1 0-1.06l4-4 1.06 1.06L4.56 8z" clip-rule="evenodd"/>`
    }, props));
$ebeeef547073e2ff$var$ReturnIcon.displayName = 'ReturnIcon';
var $ebeeef547073e2ff$var$_default = module.exports.default = $ebeeef547073e2ff$var$ReturnIcon;

});

parcelRegister("c9Pnc", function(module, exports) {

let $8d9e2cf456615ace$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d9e2cf456615ace$var$load("kxWsm").then(()=>parcelRequire('g8xD2'));

});

parcelRegister("19Vqd", function(module, exports) {

let $0d832c7f8c67e35d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d832c7f8c67e35d$var$load("9kaTf").then(()=>parcelRequire('4AEMK'));

});

parcelRegister("3hkHS", function(module, exports) {

let $26330591977d3503$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26330591977d3503$var$load("qInk0").then(()=>parcelRequire('iSc3l'));

});

parcelRegister("enLuU", function(module, exports) {

let $a7880eb5f7aa9993$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a7880eb5f7aa9993$var$load("qInk0"),
    $a7880eb5f7aa9993$var$load("kBzTX")
]).then(()=>parcelRequire('3x6Vn'));

});

parcelRegister("2KBjj", function(module, exports) {

let $200cd1bd19372eef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $200cd1bd19372eef$var$load("6UX1V").then(()=>parcelRequire('86PIE'));

});

parcelRegister("2S1Ct", function(module, exports) {

let $2171e1853d43c8eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2171e1853d43c8eb$var$load("4booW").then(()=>parcelRequire('g7sBx'));

});

parcelRegister("7Myh3", function(module, exports) {
// Single-source dynamic import factory for the conversation-assistant chunk.
// Mirrors the chunk-name used by the live lazy()/loadable() boundaries so preload
// and the live boundaries share the same chunk identity.

const $9d88e303fe02f351$export$24a887167476720c = ()=>(parcelRequire("iZ5DO"));
module.exports["importConversationAssistant"] = $9d88e303fe02f351$export$24a887167476720c;

});

parcelRegister("iZ5DO", function(module, exports) {

let $dd224cbb4593ff0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dd224cbb4593ff0f$var$load("ccAQf"),
    $dd224cbb4593ff0f$var$load("hUbK8"),
    $dd224cbb4593ff0f$var$load("lomHl"),
    $dd224cbb4593ff0f$var$load("fmAgy"),
    $dd224cbb4593ff0f$var$load("7fsAO"),
    $dd224cbb4593ff0f$var$load("53ySD"),
    $dd224cbb4593ff0f$var$load("7Ktrp"),
    $dd224cbb4593ff0f$var$load("hTxlQ"),
    $dd224cbb4593ff0f$var$load("lLB3Y"),
    $dd224cbb4593ff0f$var$load("7TyQi"),
    $dd224cbb4593ff0f$var$load("axj69"),
    $dd224cbb4593ff0f$var$load("219np"),
    $dd224cbb4593ff0f$var$load("4Mi85"),
    $dd224cbb4593ff0f$var$load("TfSzW"),
    $dd224cbb4593ff0f$var$load("fHS77"),
    $dd224cbb4593ff0f$var$load("lhLGe"),
    $dd224cbb4593ff0f$var$load("8STUC"),
    $dd224cbb4593ff0f$var$load("3zwpG"),
    $dd224cbb4593ff0f$var$load("fkLbQ"),
    $dd224cbb4593ff0f$var$load("bMNgp"),
    $dd224cbb4593ff0f$var$load("6fgrL"),
    $dd224cbb4593ff0f$var$load("ewOAX"),
    $dd224cbb4593ff0f$var$load("dRQNV"),
    $dd224cbb4593ff0f$var$load("kwVVP"),
    $dd224cbb4593ff0f$var$load("8exG0"),
    $dd224cbb4593ff0f$var$load("lYB2V"),
    $dd224cbb4593ff0f$var$load("djzm4"),
    $dd224cbb4593ff0f$var$load("6Vp6A"),
    $dd224cbb4593ff0f$var$load("6wr18"),
    $dd224cbb4593ff0f$var$load("ffEVr"),
    $dd224cbb4593ff0f$var$load("bbLnX"),
    $dd224cbb4593ff0f$var$load("1UUnk"),
    $dd224cbb4593ff0f$var$load("90vep"),
    $dd224cbb4593ff0f$var$load("ixrKS"),
    $dd224cbb4593ff0f$var$load("fdLC1"),
    $dd224cbb4593ff0f$var$load("hhss7"),
    $dd224cbb4593ff0f$var$load("Wowvf"),
    $dd224cbb4593ff0f$var$load("aAJyu"),
    $dd224cbb4593ff0f$var$load("f8Q8b"),
    $dd224cbb4593ff0f$var$load("cKDij"),
    $dd224cbb4593ff0f$var$load("7EorR"),
    $dd224cbb4593ff0f$var$load("ce05o")
]).then(()=>parcelRequire('iuVKP'));

});

parcelRegister("gE1ec", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c1e155a1b94f67fa$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c1e155a1b94f67fa$var$useInsertionEffect = $cozmU.useInsertionEffect ? $cozmU.useInsertionEffect : false;
var $c1e155a1b94f67fa$export$db21c7ffa21794e7 = $c1e155a1b94f67fa$var$useInsertionEffect || $c1e155a1b94f67fa$var$syncFallback;
var $c1e155a1b94f67fa$export$811a713a7276cb9d = $c1e155a1b94f67fa$var$useInsertionEffect || $cozmU.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $c1e155a1b94f67fa$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $c1e155a1b94f67fa$export$811a713a7276cb9d;

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");

parcelRequire("6NrTk");
var $jqTnS = parcelRequire("jqTnS");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $jqTnS.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");

 //# sourceMappingURL=index.js.map

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("lPUNq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3X3EV = parcelRequire("3X3EV");


var $jkMwL = parcelRequire("jkMwL");


var $2qYWP = parcelRequire("2qYWP");

const $fe42529edd9dec5e$var$AsyncSelect = /*#__PURE__*/ (0, $cozmU.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $jkMwL.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $2qYWP.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3X3EV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fe42529edd9dec5e$export$2e2bcd8739ae039 = $fe42529edd9dec5e$var$AsyncSelect;
module.exports["default"] = $fe42529edd9dec5e$export$2e2bcd8739ae039;

});

parcelRegister("3X3EV", function(module, exports) {
/* select.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $1CRXN = parcelRequire("1CRXN");


var $7kFxw = parcelRequire("7kFxw");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $l9ukq = parcelRequire("l9ukq");


var $4GDah = parcelRequire("4GDah");


var $bGZw4 = parcelRequire("bGZw4");


var $gRxNR = parcelRequire("gRxNR");


var $lSrYn = parcelRequire("lSrYn");


var $cDWm8 = parcelRequire("cDWm8");


var $bJjSn = parcelRequire("bJjSn");


var $kskvm = parcelRequire("kskvm");


var $4LNOJ = parcelRequire("4LNOJ");


var $hNobR = parcelRequire("hNobR");


var $014PI = parcelRequire("014PI");


var $70HV3 = parcelRequire("70HV3");


var $jXJB3 = parcelRequire("jXJB3");


var $eTsbU = parcelRequire("eTsbU");


var $ekHZj = parcelRequire("ekHZj");


var $lufHJ = parcelRequire("lufHJ");


var $6RV9E = parcelRequire("6RV9E");


var $22s7D = parcelRequire("22s7D");


var $2Li48 = parcelRequire("2Li48");


var $aeRIw = parcelRequire("aeRIw");


var $a0zhA = parcelRequire("a0zhA");

function $fdb5147fd7c82020$var$_defineProperty(e, r, t) {
    return (r = $fdb5147fd7c82020$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fdb5147fd7c82020$var$_toPropertyKey(t) {
    var i = $fdb5147fd7c82020$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fdb5147fd7c82020$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fdb5147fd7c82020$var$noop = (0, $dpsRj.default);
function $fdb5147fd7c82020$var$notNullish(item) {
    return item != null;
}
function $fdb5147fd7c82020$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $6RV9E.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $6RV9E.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $fdb5147fd7c82020$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $fdb5147fd7c82020$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
} /**
   * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
   * @param styles - The styles object to filter.
   * @returns A new object containing only supported styles.
   */ 
const $fdb5147fd7c82020$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $fdb5147fd7c82020$var$elemBeforeCSS = null;
const $fdb5147fd7c82020$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $fdb5147fd7c82020$var$isTouchCapable(),
    captureMenuScroll: !$fdb5147fd7c82020$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $lSrYn.createFilter)(),
    formatGroupLabel: (0, $cDWm8.formatGroupLabel),
    getOptionLabel: (0, $bJjSn.getOptionLabel),
    getOptionValue: (0, $kskvm.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $a0zhA.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$fdb5147fd7c82020$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $fdb5147fd7c82020$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $fdb5147fd7c82020$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $fdb5147fd7c82020$var$isOptionSelected(props, option, selectValue);
    const label = $fdb5147fd7c82020$var$getOptionLabel(props, option);
    const value = $fdb5147fd7c82020$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $fdb5147fd7c82020$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$fdb5147fd7c82020$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$fdb5147fd7c82020$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $fdb5147fd7c82020$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $fdb5147fd7c82020$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($fdb5147fd7c82020$var$notNullish);
}
function $fdb5147fd7c82020$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $fdb5147fd7c82020$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $fdb5147fd7c82020$var$buildFocusableOptions(props, selectValue) {
    return $fdb5147fd7c82020$var$buildFocusableOptionsFromCategorizedOptions($fdb5147fd7c82020$var$buildCategorizedOptions(props, selectValue));
}
function $fdb5147fd7c82020$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$fdb5147fd7c82020$var$shouldHideSelectedOptions(props) || !isSelected) && $fdb5147fd7c82020$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $fdb5147fd7c82020$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $fdb5147fd7c82020$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $fdb5147fd7c82020$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $fdb5147fd7c82020$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $fdb5147fd7c82020$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $fdb5147fd7c82020$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $fdb5147fd7c82020$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $fdb5147fd7c82020$var$getOptionValue(props, option);
    return selectValue.some((i)=>$fdb5147fd7c82020$var$getOptionValue(props, i) === candidate);
}
function $fdb5147fd7c82020$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $fdb5147fd7c82020$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $fdb5147fd7c82020$var$instanceId = 1; // eslint-disable-next-line @repo/internal/react/no-class-components, @atlaskit/volt-strict-mode/no-multiple-exports
class $fdb5147fd7c82020$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $hNobR.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $fdb5147fd7c82020$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $fdb5147fd7c82020$var$buildFocusableOptionsWithIds($fdb5147fd7c82020$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $fdb5147fd7c82020$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $fdb5147fd7c82020$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $fdb5147fd7c82020$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $aeRIw.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $fdb5147fd7c82020$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $fdb5147fd7c82020$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        this.cancelDeferredOpenMenu();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open past the in-flight pointer gesture.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss runs on the matching `pointerup` and
   * closes the menu immediately. Today only the top-layer path needs it.
   */ shouldDeferOpenPastPointerUp() {
        return (0, $iDrrr.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current pointer gesture, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser captures the pointerdown target before the popover exists, so
   * opening synchronously gets immediately light-dismissed on pointerup
   * (and the matching `beforetoggle: closed` is not cancellable). Deferring
   * to the next `pointerup` avoids that.
   *
   * We listen for `pointerup` rather than `click` because `pointerup` is
   * the exact event the browser uses for light-dismiss (earliest safe
   * moment), always fires (`click` requires same down/up target), is hard
   * to lose to upstream `stopPropagation`, and is uniform across input
   * types. Off the top-layer path we open synchronously as before.
   */ openMenuAfterPointerUp(focusOption) {
        if (!this.shouldDeferOpenPastPointerUp()) {
            this.openMenu(focusOption);
            return;
        }
        // A second pointerdown can land before the queued pointerup if the
        // user releases and re-clicks very quickly. Replace any pending
        // deferred open with the latest one so we never stack listeners.
        this.cancelDeferredOpenMenu();
        const handlePointerUp = ()=>{
            this.deferredOpenMenuCleanup = null;
            this.openMenu(focusOption);
        };
        this.deferredOpenMenuCleanup = (0, $cbY7C.bind)(document, {
            type: 'pointerup',
            listener: handlePointerUp,
            options: {
                capture: true,
                once: true
            }
        });
    }
    cancelDeferredOpenMenu() {
        if (this.deferredOpenMenuCleanup) {
            this.deferredOpenMenuCleanup();
            this.deferredOpenMenuCleanup = null;
        }
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $7kFxw.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0;
        // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $fdb5147fd7c82020$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $fdb5147fd7c82020$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $fdb5147fd7c82020$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !this.props.components?.Option && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const isDisabledA11yFixEnabled = (0, $iDrrr.fg)('platform_dst_select_disabled_a11y_fix'); // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $iDrrr.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $iDrrr.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            // Using aria-disabled so the element remains in the a11y tree.
            ...isDisabledA11yFixEnabled && {
                'aria-disabled': isDisabled || undefined
            },
            ...this.calculateDescription()
        };
        const effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4GDah.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $fdb5147fd7c82020$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: effectiveTabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
         // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $8aG6j.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: effectiveTabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $cozmU.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $cozmU.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $8aG6j.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value'),
                // Hide from AT so the value is only announced via aria-describedby on the combobox.
                ...isDisabled && (0, $iDrrr.fg)('platform_dst_select_disabled_a11y_fix') && {
                    'aria-hidden': true
                }
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
            // children only, keeping the voice-control button visible to AT.
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
         // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $cozmU.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $cozmU.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $8aG6j.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $8aG6j.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gRxNR.default), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $8aG6j.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lufHJ.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $7kFxw.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        }); // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, $iDrrr.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
         // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, $iDrrr.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, $8aG6j.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }); // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, $iDrrr.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $70HV3.MenuPortalCloseContext).Provider, {
            value: this.handleOpenLayerObserverCloseSignal,
            children: menuPortal
        });
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ekHZj.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bGZw4.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22s7D.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown,
                    ...testId && {
                        'data-testid': testId && `${testId}-select--container`
                    }
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)(Control, {
                        ...commonProps,
                        innerRef: this.getControlRef,
                        innerProps: {
                            onMouseDown: this.onControlMouseDown,
                            onTouchEnd: this.onControlTouchEnd,
                            ...testId && {
                                'data-testid': `${testId}-select--control`
                            }
                        },
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)(ValueContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--value-container`
                                    },
                                    ...commonProps.isMulti && commonProps.hasValue && !(0, $1CRXN.isAppleDevice)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }
                                },
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)(IndicatorsContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--indicators-container`
                                    }
                                },
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            })
                        ]
                    }),
                    this.renderMenu(),
                    this.renderFormField(),
                    !(0, $iDrrr.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eTsbU.NotifyOpenLayerObserver), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleOpenLayerObserverCloseSignal
                    })
                ]
            })
        });
    }
    // Lifecycle
    // ------------------------------
    constructor(_props){
        super(_props);
        $fdb5147fd7c82020$var$_defineProperty(this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null
        }); // Misc. Instance Properties
        // ------------------------------
        $fdb5147fd7c82020$var$_defineProperty(this, "blockOptionHover", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "isComposing", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "commonProps", void 0); // TODO
        $fdb5147fd7c82020$var$_defineProperty(this, "initialTouchX", 0);
        $fdb5147fd7c82020$var$_defineProperty(this, "initialTouchY", 0);
        $fdb5147fd7c82020$var$_defineProperty(this, "openAfterFocus", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "scrollToFocusedOptionOnUpdate", false); // Cleanup for a pending document `pointerup` listener registered by
        // `openMenuAfterPointerUp`. See that method for the full rationale.
        $fdb5147fd7c82020$var$_defineProperty(this, "deferredOpenMenuCleanup", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "userIsDragging", void 0); // Refs
        // ------------------------------
        $fdb5147fd7c82020$var$_defineProperty(this, "controlRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getControlRef", (ref)=>{
            this.controlRef = ref; // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, $iDrrr.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "focusedOptionRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusedOptionRef", (ref)=>{
            this.focusedOptionRef = ref;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "menuListRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getMenuListRef", (ref)=>{
            this.menuListRef = ref;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "inputRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getInputRef", (ref)=>{
            this.inputRef = ref;
        }); // aliased for consumers
        $fdb5147fd7c82020$var$_defineProperty(this, "focus", this.focusInput);
        $fdb5147fd7c82020$var$_defineProperty(this, "blur", this.blurInput);
        $fdb5147fd7c82020$var$_defineProperty(this, "onChange", (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "setValue", (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "selectOption", (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $jXJB3.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $jXJB3.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $2Li48.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $2Li48.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "removeValue", (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $aeRIw.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "clearValue", ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $aeRIw.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "popValue", ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $aeRIw.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }); // ==============================
        // Getters
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusedOptionId", (focusedOption)=>{
            return $fdb5147fd7c82020$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusableOptionsWithIds", ()=>{
            return $fdb5147fd7c82020$var$buildFocusableOptionsWithIds($fdb5147fd7c82020$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getValue", ()=>this.state.selectValue);
        $fdb5147fd7c82020$var$_defineProperty(this, "cx", (...args)=>(0, $4LNOJ.classNames)(this.props.classNamePrefix, ...args));
        $fdb5147fd7c82020$var$_defineProperty(this, "getOptionLabel", (data)=>{
            return $fdb5147fd7c82020$var$getOptionLabel(this.props, data);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getOptionValue", (data)=>{
            return $fdb5147fd7c82020$var$getOptionValue(this.props, data);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getStyles", (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $fdb5147fd7c82020$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getClassNames", (key, props)=>this.props.classNames[key]?.(props));
        $fdb5147fd7c82020$var$_defineProperty(this, "getElementId", (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getComponents", ()=>{
            return (0, $l9ukq.defaultComponents)(this.props);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "buildCategorizedOptions", ()=>$fdb5147fd7c82020$var$buildCategorizedOptions(this.props, this.state.selectValue));
        $fdb5147fd7c82020$var$_defineProperty(this, "getCategorizedOptions", ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : []);
        $fdb5147fd7c82020$var$_defineProperty(this, "buildFocusableOptions", ()=>$fdb5147fd7c82020$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()));
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusableOptions", ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : []); // ==============================
        // Helpers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "ariaOnChange", (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }); // ==============================
        // Mouse Handlers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "onMenuMouseDown", (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onMenuMouseMove", (_)=>{
            this.blockOptionHover = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onControlMouseDown", (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterPointerUp('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onDropdownIndicatorMouseDown", (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterPointerUp('first');
            event.preventDefault();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onClearIndicatorMouseDown", (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onScroll", (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $014PI.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onCompositionStart", ()=>{
            this.isComposing = true;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onCompositionEnd", ()=>{
            this.isComposing = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onTouchStart", ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onTouchMove", ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onTouchEnd", (event)=>{
            if (this.userIsDragging) return;
             // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
             // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onControlTouchEnd", (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onClearIndicatorTouchEnd", (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onDropdownIndicatorTouchEnd", (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }); // ==============================
        // Focus Handlers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "handleInputChange", (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onInputFocus", (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer past
                // pointerup. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterPointerUp('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onInputBlur", (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $iDrrr.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onOptionHover", (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "shouldHideSelectedOptions", ()=>{
            return $fdb5147fd7c82020$var$shouldHideSelectedOptions(this.props);
        }); // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        $fdb5147fd7c82020$var$_defineProperty(this, "onValueInputFocus", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }); // ==============================
        // Keyboard Handlers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "onKeyDown", (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "handleOpenLayerObserverCloseSignal", ()=>{
            this.onMenuClose();
        });
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$fdb5147fd7c82020$var$instanceId);
        this.state.selectValue = (0, $hNobR.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $fdb5147fd7c82020$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
}
$fdb5147fd7c82020$var$_defineProperty($fdb5147fd7c82020$export$2e2bcd8739ae039, "defaultProps", $fdb5147fd7c82020$export$9c21a3269931e1e6);
module.exports["default"] = $fdb5147fd7c82020$export$2e2bcd8739ae039;

});

parcelRegister("1CRXN", function(module, exports) {
function $e2a83d2c832246af$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $e2a83d2c832246af$var$isIPhone() {
    return $e2a83d2c832246af$var$testPlatform(/^iPhone/i);
}
function $e2a83d2c832246af$var$isIPad() {
    return $e2a83d2c832246af$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $e2a83d2c832246af$var$isMac() && navigator.maxTouchPoints > 1;
}
function $e2a83d2c832246af$var$isMac() {
    return $e2a83d2c832246af$var$testPlatform(/^Mac/i);
}
function $e2a83d2c832246af$var$isIOS() {
    return $e2a83d2c832246af$var$isIPhone() || $e2a83d2c832246af$var$isIPad();
}
function $e2a83d2c832246af$export$e1865c3bedcd822b() {
    return $e2a83d2c832246af$var$isMac() || $e2a83d2c832246af$var$isIOS();
}
module.exports["isAppleDevice"] = $e2a83d2c832246af$export$e1865c3bedcd822b;

});

parcelRegister("4GDah", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d6cb6d8ded15819$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $2d6cb6d8ded15819$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $2d6cb6d8ded15819$var$dummyInputStyles = null;
function $2d6cb6d8ded15819$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $2d6cb6d8ded15819$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear'); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        ref: innerRef,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2uo31fdnbC _30huDKdnbC _1xC2CJpl7Y _2xIroY98eZ _497WNwYbGa _2zndICdnbC _39xV02HZdu _1mT5xdRAKS _3U2PsZjOvk _1UtDYzjOvk _3iC0zdvcBI _1YKVNsdnbC _1VJPcaG8T7",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("bGZw4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jR914 = parcelRequire("jR914");


var $4T0os = parcelRequire("4T0os");

const $cf09ff68c567883e$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $cozmU.useMemo)(()=>({
            ...(0, $jR914.defaultAriaLiveMessages),
            ...ariaLiveMessages
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $cozmU.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $cozmU.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4T0os.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4T0os.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cf09ff68c567883e$export$2e2bcd8739ae039 = $cf09ff68c567883e$var$LiveRegion;
module.exports["default"] = $cf09ff68c567883e$export$2e2bcd8739ae039;

});

parcelRegister("jR914", function(module, exports) {
const $0dc13d4070494870$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};
module.exports["defaultAriaLiveMessages"] = $0dc13d4070494870$export$a7265767c78f9bae;

});

parcelRegister("4T0os", function(module, exports) {
/* a11y-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5cadb6bbae063b3e$var$styles = null;
const $5cadb6bbae063b3e$var$A11yText = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _39xV02HZdu _0jFU0VHZdu _1mT5xdWVPG _42Yu6BA6TK _1C7BHPdEFh _20VacPYbGa _1ANEUSLRg7",
            "-a11yText"
        ]),
        ...props
    });
var $5cadb6bbae063b3e$export$2e2bcd8739ae039 = $5cadb6bbae063b3e$var$A11yText;
module.exports["default"] = $5cadb6bbae063b3e$export$2e2bcd8739ae039;

});

parcelRegister("gRxNR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $310h3 = parcelRequire("310h3");

const $2c7f5c4bf8d5037d$var$noop = (0, $dpsRj.default);
function $2c7f5c4bf8d5037d$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $2c7f5c4bf8d5037d$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $2c7f5c4bf8d5037d$var$normalizedHeight(el) {
    if ($2c7f5c4bf8d5037d$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $2c7f5c4bf8d5037d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($2c7f5c4bf8d5037d$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $2c7f5c4bf8d5037d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $2c7f5c4bf8d5037d$var$getScrollTop(el) {
    if ($2c7f5c4bf8d5037d$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $2c7f5c4bf8d5037d$var$animatedScrollTo(element, to, duration = 200, callback = $2c7f5c4bf8d5037d$var$noop) {
    const start = $2c7f5c4bf8d5037d$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $2c7f5c4bf8d5037d$var$easeOutCubic(currentTime, start, change, duration);
        $2c7f5c4bf8d5037d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $2c7f5c4bf8d5037d$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $2c7f5c4bf8d5037d$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $2c7f5c4bf8d5037d$var$normalizedHeight(scrollParent);
    const scrollTop = $2c7f5c4bf8d5037d$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $2c7f5c4bf8d5037d$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $2c7f5c4bf8d5037d$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $cozmU.useContext)((0, $310h3.PortalPlacementContext)) || {};
    const ref = (0, $cozmU.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $cozmU.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $cozmU.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $cozmU.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $2c7f5c4bf8d5037d$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $2c7f5c4bf8d5037d$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
var $2c7f5c4bf8d5037d$export$2e2bcd8739ae039 = $2c7f5c4bf8d5037d$var$MenuPlacer;
module.exports["default"] = $2c7f5c4bf8d5037d$export$2e2bcd8739ae039;

});

parcelRegister("lSrYn", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $29Cvw = parcelRequire("29Cvw");

const $6b1b0c551aa67178$var$memoizedStripDiacriticsForInput = (0, $dOBRD.default)((0, $29Cvw.stripDiacritics));
const $6b1b0c551aa67178$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $6b1b0c551aa67178$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $6b1b0c551aa67178$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $6b1b0c551aa67178$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $6b1b0c551aa67178$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $6b1b0c551aa67178$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $6b1b0c551aa67178$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $29Cvw.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
module.exports["createFilter"] = $6b1b0c551aa67178$export$5d81789ff4aeccdf;

});

parcelRegister("29Cvw", function(module, exports) {
const $d63abcda1284ac20$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $d63abcda1284ac20$var$anyDiacritic = new RegExp('[' + $d63abcda1284ac20$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $d63abcda1284ac20$var$diacriticToBase = {};
for(let i = 0; i < $d63abcda1284ac20$var$diacritics.length; i++){
    let diacritic = $d63abcda1284ac20$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$d63abcda1284ac20$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $d63abcda1284ac20$export$b5bee4b27048330b = (str)=>{
    return str.replace($d63abcda1284ac20$var$anyDiacritic, (match)=>$d63abcda1284ac20$var$diacriticToBase[match]);
};
module.exports["stripDiacritics"] = $d63abcda1284ac20$export$b5bee4b27048330b;

});

parcelRegister("cDWm8", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $312d6cd6268ed29a$export$f4da216a6ca54656 = (group)=>group.label;
module.exports["formatGroupLabel"] = $312d6cd6268ed29a$export$f4da216a6ca54656;

});

parcelRegister("bJjSn", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $81a1c472cad5dd30$export$dac6ace3020563ca = (option)=>option.label;
module.exports["getOptionLabel"] = $81a1c472cad5dd30$export$dac6ace3020563ca;

});

parcelRegister("kskvm", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $699dc714e415a23f$export$40be908210c5a79c = (option)=>option.value;
module.exports["getOptionValue"] = $699dc714e415a23f$export$40be908210c5a79c;

});

parcelRegister("4LNOJ", function(module, exports) {
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $23f9642fe3df7275$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $23f9642fe3df7275$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$23f9642fe3df7275$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
module.exports["classNames"] = $23f9642fe3df7275$export$ce4ab0c55987d1ff;

});

parcelRegister("hNobR", function(module, exports) {
const $c84c6644eee4f36c$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
module.exports["cleanValue"] = $c84c6644eee4f36c$export$33f062f47f21a01;

});

parcelRegister("014PI", function(module, exports) {
function $4bf658c2f5849ba4$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
module.exports["isDocumentElement"] = $4bf658c2f5849ba4$export$d8a62a489b442872;

});

parcelRegister("jXJB3", function(module, exports) {
function $d4f6ae23391d9f86$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
module.exports["multiValueAsValue"] = $d4f6ae23391d9f86$export$d1ca752ec761b95b;

});

parcelRegister("eTsbU", function(module, exports) {

var $5Tdig = parcelRequire("5Tdig");

function $8007bffd16fcb4f7$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}
module.exports["NotifyOpenLayerObserver"] = $8007bffd16fcb4f7$export$17baa7c95b6ba1b8;

});

parcelRegister("ekHZj", function(module, exports) {
/* required-input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $dpsRj = parcelRequire("dpsRj");

const $57b92616b4a43e5e$var$styles = null;
const $57b92616b4a43e5e$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdWVPG _1ZB6UydnbC _1OKFqYdnbC _3iC0zddnbC _1YKVNsdnbC _1pp6NdYbGa",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        value: "",
        onChange: (0, $dpsRj.default)
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $57b92616b4a43e5e$export$2e2bcd8739ae039 = $57b92616b4a43e5e$var$RequiredInput;
module.exports["default"] = $57b92616b4a43e5e$export$2e2bcd8739ae039;

});

parcelRegister("lufHJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $43596bd475aeda63$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $7bfP7 = parcelRequire("7bfP7");


var $a1JKY = parcelRequire("a1JKY");

const $43596bd475aeda63$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $43596bd475aeda63$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $7bfP7.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $a1JKY.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                onClick: $43596bd475aeda63$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});

parcelRegister("7bfP7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b8f925ccf96b434$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $ceMZ1 = parcelRequire("ceMZ1");

const $9b8f925ccf96b434$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $9b8f925ccf96b434$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $cozmU.useRef)(false);
    const isTop = (0, $cozmU.useRef)(false);
    const touchStart = (0, $cozmU.useRef)(0);
    const scrollTarget = (0, $cozmU.useRef)(null);
    const handleEventDelta = (0, $cozmU.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $9b8f925ccf96b434$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $cozmU.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $cozmU.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $cozmU.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $cozmU.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $ceMZ1.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $cozmU.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("ceMZ1", function(module, exports) {
// ==============================
// Passive Event Detector
// ==============================

var $dpsRj = parcelRequire("dpsRj");

const $e49696561ee7bcce$var$noop = (0, $dpsRj.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $e49696561ee7bcce$var$passiveOptionAccessed = false;
const $e49696561ee7bcce$var$options = {
    get passive () {
        return $e49696561ee7bcce$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $e49696561ee7bcce$var$w = typeof window !== 'undefined' ? window : {};
if ($e49696561ee7bcce$var$w.addEventListener && $e49696561ee7bcce$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $e49696561ee7bcce$var$w.addEventListener('p', $e49696561ee7bcce$var$noop, $e49696561ee7bcce$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $e49696561ee7bcce$var$w.removeEventListener('p', $e49696561ee7bcce$var$noop, false);
}
const $e49696561ee7bcce$export$b0622a6911dbeaf5 = $e49696561ee7bcce$var$passiveOptionAccessed;
module.exports["supportsPassiveEvents"] = $e49696561ee7bcce$export$b0622a6911dbeaf5;

});

parcelRegister("a1JKY", function(module, exports) {
$parcel$export(module.exports, "default", () => $88d66ae1308422f9$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

const $88d66ae1308422f9$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $88d66ae1308422f9$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $88d66ae1308422f9$var$preventTouchMove(e) {
    e.preventDefault();
}
function $88d66ae1308422f9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $88d66ae1308422f9$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $88d66ae1308422f9$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $88d66ae1308422f9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $88d66ae1308422f9$var$activeScrollLocks = 0;
const $88d66ae1308422f9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $88d66ae1308422f9$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $cozmU.useRef)({});
    const scrollTarget = (0, $cozmU.useRef)(null);
    const addScrollLock = (0, $cozmU.useCallback)((touchScrollTarget)=>{
        if (!$88d66ae1308422f9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $88d66ae1308422f9$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $88d66ae1308422f9$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($88d66ae1308422f9$var$LOCK_STYLES).forEach((key)=>{
                const val = $88d66ae1308422f9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $88d66ae1308422f9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $88d66ae1308422f9$var$preventTouchMove, $88d66ae1308422f9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $88d66ae1308422f9$var$preventInertiaScroll, $88d66ae1308422f9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $88d66ae1308422f9$var$allowTouchMove, $88d66ae1308422f9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $88d66ae1308422f9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $cozmU.useCallback)((touchScrollTarget)=>{
        if (!$88d66ae1308422f9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $88d66ae1308422f9$var$activeScrollLocks = Math.max($88d66ae1308422f9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $88d66ae1308422f9$var$activeScrollLocks < 1) $88d66ae1308422f9$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $88d66ae1308422f9$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $88d66ae1308422f9$var$preventTouchMove, $88d66ae1308422f9$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $88d66ae1308422f9$var$preventInertiaScroll, $88d66ae1308422f9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $88d66ae1308422f9$var$allowTouchMove, $88d66ae1308422f9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("6RV9E", function(module, exports) {

var $014PI = parcelRequire("014PI");

function $89b76ef2cfe44086$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $014PI.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
module.exports["scrollTo"] = $89b76ef2cfe44086$export$3f99968195accfaf;

});

parcelRegister("2Li48", function(module, exports) {
function $14fb42ad8f3c150c$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
module.exports["singleValueAsValue"] = $14fb42ad8f3c150c$export$dea4763e29237f4c;

});

parcelRegister("aeRIw", function(module, exports) {
function $25c47531e63a634f$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
module.exports["valueTernary"] = $25c47531e63a634f$export$40fb9515c784cc3b;

});

parcelRegister("a0zhA", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $049c42a667ab2997$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
module.exports["isOptionDisabled"] = $049c42a667ab2997$export$56bd0c8d90db075;

});

parcelRegister("jkMwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c0b8f7e58ea102$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $44c0b8f7e58ea102$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $44c0b8f7e58ea102$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $cozmU.useRef)(undefined);
    const mounted = (0, $cozmU.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $cozmU.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $cozmU.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $cozmU.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $cozmU.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $cozmU.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $cozmU.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $cozmU.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $cozmU.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $cozmU.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $cozmU.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $cozmU.useCallback)((newValue, actionMeta)=>{
        const inputValue = $44c0b8f7e58ea102$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("2qYWP", function(module, exports) {
$parcel$export(module.exports, "default", () => $582f0891543bc339$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $582f0891543bc339$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $cozmU.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $cozmU.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $cozmU.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $cozmU.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $cozmU.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $cozmU.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $cozmU.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});

parcelRegister("ggg0l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $h6GPp = parcelRequire("h6GPp");

const $bbeb3f75bd6af510$export$53c2b9c37c40e0d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (method, payload, channel)=>{
    const $ = (0, $bDgLe.c)(5);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const methodRef = (0, $h6GPp.useTrackedRef)(method);
    const payloadRef = (0, $h6GPp.useTrackedRef)(payload);
    let t0;
    if ($[0] !== channel || $[1] !== createAnalyticsEvent || $[2] !== methodRef || $[3] !== payloadRef) {
        t0 = (...t1)=>{
            const args = t1;
            const pload = typeof payloadRef.current === "function" ? payloadRef.current(...args) : payloadRef.current;
            createAnalyticsEvent(pload).fire(channel);
            methodRef.current(...args);
        };
        $[0] = channel;
        $[1] = createAnalyticsEvent;
        $[2] = methodRef;
        $[3] = payloadRef;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const methodRef = (0, $h6GPp.useTrackedRef)(method);
    const payloadRef = (0, $h6GPp.useTrackedRef)(payload);
    return (0, $cozmU.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};
module.exports["useCallbackWithAnalytics"] = $bbeb3f75bd6af510$export$53c2b9c37c40e0d8;

});

parcelRegister("aIOjp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4dGdo = parcelRequire("4dGdo");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $iODl6 = parcelRequire("iODl6");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $638c8511a917505b$var$ShrinkOut = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, duration: t1, onFinish: onFinish } = t0;
    const duration = t1 === undefined ? "small" : t1;
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const exiting = (0, $iODl6.useExitingPersistence)();
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    const setTimeout = (0, $1U6E9.useSetTimeout)();
    const direction = exiting.isExiting ? "exiting" : "entering";
    let t2;
    if ($[0] !== duration || $[1] !== element || $[2] !== exiting || $[3] !== onFinish || $[4] !== requestAnimationFrame || $[5] !== setTimeout) {
        t2 = ()=>{
            if (exiting.isExiting && element) {
                if ((0, $jlWUB.isReducedMotion)()) {
                    exiting.onFinish && exiting.onFinish();
                    onFinish && onFinish("exiting");
                    return;
                }
                const newStyles = {
                    width: `${element.offsetWidth}px`,
                    height: `${element.offsetHeight}px`,
                    boxSizing: "border-box",
                    willChange: "width,margin"
                };
                Object.assign(element.style, newStyles);
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const newStyles_0 = {
                            width: "0px",
                            margin: "0px",
                            transitionTimingFunction: "cubic-bezier(0.8,0,0,0.8)",
                            transitionDuration: (0, $4dGdo.durations)[duration] + "ms",
                            transitionProperty: "width,margin"
                        };
                        Object.assign(element.style, newStyles_0);
                        setTimeout(()=>{
                            exiting.onFinish && exiting.onFinish();
                            onFinish && onFinish("exiting");
                        }, (0, $4dGdo.durations)[duration]);
                    });
                });
            }
        };
        $[0] = duration;
        $[1] = element;
        $[2] = exiting;
        $[3] = onFinish;
        $[4] = requestAnimationFrame;
        $[5] = setTimeout;
        $[6] = t2;
    } else t2 = $[6];
    (0, $7BVQi.useLayoutEffect)(t2);
    let t3;
    if ($[7] !== children || $[8] !== direction || $[9] !== setElementRef) {
        t3 = children({
            ref: setElementRef
        }, direction);
        $[7] = children;
        $[8] = direction;
        $[9] = setElementRef;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const exiting = (0, $iODl6.useExitingPersistence)();
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    const setTimeout = (0, $1U6E9.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $jlWUB.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles_0 = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4dGdo.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles_0);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4dGdo.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $638c8511a917505b$export$2e2bcd8739ae039 = $638c8511a917505b$var$ShrinkOut;
module.exports["default"] = $638c8511a917505b$export$2e2bcd8739ae039;

});

parcelRegister("l1uFv", function(module, exports) {

var $jWnFe = parcelRequire("jWnFe");


var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

const $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY = '__clientEdgeTraversalPath';
function $65c7b8940c778902$var$cloneRelayQueryResult(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jWnFe)))(data, (value, key)=>{
        // Relay fragment refs can contain operation descriptors and client-edge reader nodes.
        // Keep that internal metadata by reference while restoring Apollo-compatible mutable data.
        if (key === (0, $eqEJl.FRAGMENT_OWNER_KEY) || key === $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY) return value;
        return undefined;
    });
}
function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : $65c7b8940c778902$var$cloneRelayQueryResult(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("jWnFe", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $e845ca4b0059397d$var$CLONE_DEEP_FLAG = 1, $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */ function $e845ca4b0059397d$var$cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $hGc5T(value, $e845ca4b0059397d$var$CLONE_DEEP_FLAG | $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG, customizer);
}
module.exports = $e845ca4b0059397d$var$cloneDeepWith;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<29d02a00238e986613f78bcab9812352>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("jGizm", function(module, exports) {

var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
const $04d4b8463fee3aa7$var$normalizeProperties = (properties)=>{
    const normalizedProperties = properties.reduce((acc, property)=>{
        if (!property.value || !property.key) return acc;
        try {
            const jsonValue = JSON.parse(property.value);
            acc[property.key] = jsonValue;
        } catch (_error) {
            acc[property.key] = property.value;
        }
        return acc;
    }, {});
    if ('migratedFrom' in normalizedProperties && !$04d4b8463fee3aa7$var$isStringArray(normalizedProperties.migratedFrom)) {
        const { migratedFrom: _migratedFrom, ...propertiesWithoutInvalidMigratedFrom } = normalizedProperties;
        return propertiesWithoutInvalidMigratedFrom;
    }
    return normalizedProperties;
};
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: $04d4b8463fee3aa7$var$normalizeProperties(extension.properties),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                sandboxPolicies: extension.sandboxPolicies ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
const $a413c718e4c7bf40$export$ffcb70f38ee10c0a = {
    FULL_PAGE: 'global:fullPage'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;
module.exports["GlobalExtension"] = $a413c718e4c7bf40$export$ffcb70f38ee10c0a;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if (this.shouldDisplayAsEmbed(url)) return 'embed';
        if (this.shouldDisplayAsCard(url)) return 'block';
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("3rMm0", function(module, exports) {
const $9bfb4763c90d8540$export$5ca004be156a127a = 'http://localhost:4224';
const $9bfb4763c90d8540$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $9bfb4763c90d8540$export$1e9fed4c0197724c = 'http://localhost:8081';
const $9bfb4763c90d8540$export$919a9569bce66f17 = '/api/v1/placements/';
const $9bfb4763c90d8540$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $9bfb4763c90d8540$export$67be2569ef5d7666 = 'http://localhost:9009';
const $9bfb4763c90d8540$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $9bfb4763c90d8540$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
const $9bfb4763c90d8540$export$a2ac4fea250cfcb6 = 'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
const $9bfb4763c90d8540$export$4db578e7ea13bd1b = 'https://post-office-rml-frontend.frontend.cdn.atlassian-us-gov-mod.com';
module.exports["API_ORIGIN_TEST_SERVER"] = $9bfb4763c90d8540$export$5ca004be156a127a;
module.exports["API_ORIGIN_LOCAL"] = $9bfb4763c90d8540$export$1e9fed4c0197724c;
module.exports["API_PATHNAME_LOCAL"] = $9bfb4763c90d8540$export$919a9569bce66f17;
module.exports["API_PATHNAME_STG_PROD"] = $9bfb4763c90d8540$export$d4fe3482c88e73a8;
module.exports["REMOTE_MODULE_URI_LOCAL"] = $9bfb4763c90d8540$export$67be2569ef5d7666;
module.exports["REMOTE_MODULE_URI_STG"] = $9bfb4763c90d8540$export$b49738b89db261cd;
module.exports["REMOTE_MODULE_URI_PROD"] = $9bfb4763c90d8540$export$bbd96cd490b0df63;
module.exports["REMOTE_MODULE_URI_STG_FEDM"] = $9bfb4763c90d8540$export$a2ac4fea250cfcb6;
module.exports["REMOTE_MODULE_URI_PROD_FEDM"] = $9bfb4763c90d8540$export$4db578e7ea13bd1b;

});

parcelRegister("jdpvF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $3rMm0 = parcelRequire("3rMm0");

const $1f78ef0061fd59e3$export$5dba87a2097d7fb2 = (isFedRampCompliantUrlsEnabled = false)=>{
    return {
        currentEnv: 'local',
        envConfigs: {
            'test-server': {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_TEST_SERVER),
                    pathname: (0, $3rMm0.API_ORIGIN_TEST_SERVER),
                    searchParams: undefined
                }
            },
            test: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_LOCAL),
                    pathname: (0, $3rMm0.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_LOCAL),
                    pathname: (0, $3rMm0.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_LOCAL),
                    pathname: (0, $3rMm0.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $3rMm0.REMOTE_MODULE_URI_STG_FEDM) : (0, $3rMm0.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $3rMm0.REMOTE_MODULE_URI_PROD_FEDM) : (0, $3rMm0.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            }
        }
    };
};
const $1f78ef0061fd59e3$export$b4ede87479bfcf09 = $1f78ef0061fd59e3$export$5dba87a2097d7fb2();
const $1f78ef0061fd59e3$export$fceca2c399b32565 = (0, $cozmU.createContext)($1f78ef0061fd59e3$export$b4ede87479bfcf09);
const $1f78ef0061fd59e3$export$604607f913ef367c = $1f78ef0061fd59e3$export$fceca2c399b32565.Provider;
const $1f78ef0061fd59e3$export$877b97169cc75e8b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($1f78ef0061fd59e3$export$fceca2c399b32565);
} : ()=>(0, $cozmU.useContext)($1f78ef0061fd59e3$export$fceca2c399b32565);
module.exports["buildDefaultEnvironmentValues"] = $1f78ef0061fd59e3$export$5dba87a2097d7fb2;
module.exports["defaultEnvironmentValues"] = $1f78ef0061fd59e3$export$b4ede87479bfcf09;
module.exports["PostOfficeEnvironmentProvider"] = $1f78ef0061fd59e3$export$604607f913ef367c;
module.exports["usePostOfficeEnvironment"] = $1f78ef0061fd59e3$export$877b97169cc75e8b;

});

parcelRegister("30Qx8", function(module, exports) {

var $cEGBg = parcelRequire("cEGBg");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/navigation/setting/manifest.ts
var $231a1f3f133ad522$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $cEGBg.NavigationSettingAriResourceOwner),
    resourceType: (0, $cEGBg.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /[a-z0-9-]{1,100}/,
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/navigation/setting/index.ts
var $231a1f3f133ad522$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $1gKSA.RegisteredAri) {
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $231a1f3f133ad522$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $231a1f3f133ad522$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
    constructor(opts){
        super(opts), this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
};
module.exports["NavigationSettingAri"] = $231a1f3f133ad522$export$d9494d14fa8a72a2;

});

parcelRegister("cEGBg", function(module, exports) {
// src/navigation/setting/types.ts
var $936a43f66cf48d67$export$efad67ea8db3f12e = "navigation", $936a43f66cf48d67$export$fd28c74ac3f5b728 = "setting";
module.exports["NavigationSettingAriResourceOwner"] = $936a43f66cf48d67$export$efad67ea8db3f12e;
module.exports["NavigationSettingAriResourceType"] = $936a43f66cf48d67$export$fd28c74ac3f5b728;

});

parcelRegister("jAKKt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krxYo = parcelRequire("krxYo");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2a08l = parcelRequire("2a08l");


var $frXak = parcelRequire("frXak");

const $349db1466702a732$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $frXak.messages)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2a08l.WebDomainSearchResultIcon), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            additionalTexts: [
                ...existingFilters?.additionalTexts || [],
                ...datasource?.workspaceUrl ? [
                    datasource.workspaceUrl
                ] : []
            ]
        })
};
module.exports["atlassianWebCrawlerConfig"] = $349db1466702a732$export$fbd198cf40195606;

});

parcelRegister("dAioJ", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ac1d391d64bfedde$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $ac1d391d64bfedde$export$d520529b4595d46c;

});

parcelRegister("2a08l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l1BmH")).then((m)=>m.WebDomainSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/atlassian-web-crawler/search-result-icon'
});
const $f2ed16baff72ba2b$export$b16288f56aa4a879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
module.exports["WebDomainSearchResultIcon"] = $f2ed16baff72ba2b$export$b16288f56aa4a879;

});

parcelRegister("l1BmH", function(module, exports) {

let $f4e6ace1a3666370$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4e6ace1a3666370$var$load("5ZoVX").then(()=>parcelRequire('5TYsy'));

});

parcelRegister("frXak", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $67596226ed2b5a5b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $67596226ed2b5a5b$export$defe85febe8b728c;

});

parcelRegister("7dzhu", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jyScu = parcelRequire("jyScu");

const $5121b1584cf21fa5$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Figma,
    icon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaIcon), 'Figma', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaSearchResultIcon), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $5121b1584cf21fa5$export$e821d8af66e3adab;

});

parcelRegister("hareu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $572397f4f72859d8$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $572397f4f72859d8$export$9d37c36d8b43baee;

});

parcelRegister("kFLxH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cd2849e7738ca37b$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $cd2849e7738ca37b$export$1dc2d469fb044d48;

});

parcelRegister("jyScu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $63cad5270e3124a2$var$LazyFigmaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/icon'
});

const $63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon'
});
const $63cad5270e3124a2$export$54e0f4982aa79afe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaIconComponent, null));
const $63cad5270e3124a2$export$b31792ff95c3d83f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent, null));
module.exports["FigmaIcon"] = $63cad5270e3124a2$export$54e0f4982aa79afe;
module.exports["FigmaSearchResultIcon"] = $63cad5270e3124a2$export$b31792ff95c3d83f;

});

parcelRegister("lv0ob", function(module, exports) {

let $fa6ccb7c265dd600$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa6ccb7c265dd600$var$load("lXqxA").then(()=>parcelRequire('3jkLL'));

});

parcelRegister("aZX0c", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6suVE = parcelRequire("6suVE");

const $46e7fee1c70574c7$var$getGithubTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Repository, {
        entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).PullRequest, {
        entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Branch, {
        entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Commit, {
        entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).DevopsWorkItem, {
        entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo_github_code_search')) config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $46e7fee1c70574c7$export$71c63cb45707eee = {
    displayName: 'GitHub',
    id: 'github',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Github,
    icon: (0, $i52Hf.get3PLogo)((0, $6suVE.GithubIcon), 'Github', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6suVE.GithubSearchResultIcon), 'Github', 'large'),
    integrationAri: 'ari:cloud:platform::integration/github',
    get typeFilterConfig () {
        return $46e7fee1c70574c7$var$getGithubTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch',
            'pullRequestStatus'
        ];
        if ((0, $iDrrr.fg)('rovo_fps_show_repository_filter')) baseFilters.push('repository');
        if ((0, $iDrrr.fg)('rovo_fps_show_github_created_by_filter')) baseFilters.push('createdBy');
        if ((0, $iDrrr.fg)('rovo_fps_show_reviewer_filter')) baseFilters.push('reviewer');
        if ((0, $iDrrr.fg)('rovo_fps_show_github_assignee_filter')) baseFilters.push('assignee');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["githubConfig"] = $46e7fee1c70574c7$export$71c63cb45707eee;

});

parcelRegister("6Ymez", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $0aab066f73937fd8$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $0aab066f73937fd8$export$7bf025ec33e76761;

});

parcelRegister("bCUcs", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ea564ddf0cc8c2fd$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $ea564ddf0cc8c2fd$export$3e5409bef2addb56;

});

parcelRegister("fmJYG", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $51acdb1b50e4834b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $51acdb1b50e4834b$export$3268f1527392e5ac;

});

parcelRegister("iM9d2", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fe7cd180c5f0ee38$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fe7cd180c5f0ee38$export$c28231fcae6448eb;

});

parcelRegister("2Rsot", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a989069c3574d0d8$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $a989069c3574d0d8$export$d810eae89914369b;

});

parcelRegister("kFYBW", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9Jc29 = parcelRequire("9Jc29");

const $aac32d306159bd81$var$getGoogleDriveTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Document,
            (0, $5PPrc.NounSubtypeKey).Pdf,
            (0, $5PPrc.NounSubtypeKey).Page,
            (0, $5PPrc.NounSubtypeKey).Blogpost
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Spreadsheet, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Presentation, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Presentation
        ]
    });
    if ((0, $iDrrr.fg)('rovo_fps_enable_video_noun_filter')) config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: [
            ...(0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Video
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Image, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Image
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Folder, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Folder
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Audio, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Audio
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Pdf, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Code, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Code
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Form, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Form
        ]
    });
    // Back-ported (consolidated) shape — replaces individual Page/Blogpost entries
    // with a richer WebPage entry and folds Archive into Other.
    config.set((0, $5PPrc.TypeFilterValueKey).Notebook, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Notebook
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).WebPage, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).WebPage,
            (0, $5PPrc.NounSubtypeKey).Shortcut
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Other, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Other,
            (0, $5PPrc.NounSubtypeKey).Archive
        ]
    });
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats Google Drive comment matches as documents rather than standalone comments.
    if ((0, $iDrrr.fg)('enable_3p_embedded_comments_search')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    return config;
};
const $aac32d306159bd81$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).GoogleDrive,
    icon: (0, $i52Hf.get3PLogo)((0, $9Jc29.GoogleDriveIcon), 'Google Drive', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9Jc29.GoogleDriveIconBorderless), 'Google Drive', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9Jc29.GoogleDriveSearchResultIcon), 'Google Drive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    // Use a getter to evaluate lazily so that it's evaluated when accessed, not at module load.
    // This allows for feature gate mocks in tests to work correctly
    get typeFilterConfig () {
        return $aac32d306159bd81$var$getGoogleDriveTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch'
        ];
        if ((0, $iDrrr.fg)('rovo_fps_enable_gdrive_space_filter')) baseFilters.push('space');
        if ((0, $iDrrr.fg)('rovo_fps_enable_gdrive_content_filter')) baseFilters.push('content');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["googleDriveConfig"] = $aac32d306159bd81$export$6634ddcb22ed69a;

});

parcelRegister("sRb5o", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cedd31adddcd6a4e$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $cedd31adddcd6a4e$export$a3d7cddace4fe237;

});

parcelRegister("gOrBS", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $Douji = parcelRequire("Douji");

const $9591d824618efc40$var$getSharePointTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Document,
            (0, $5PPrc.NounSubtypeKey).Pdf,
            (0, $5PPrc.NounSubtypeKey).Page,
            (0, $5PPrc.NounSubtypeKey).Blogpost
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Spreadsheet, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Presentation, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Presentation
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Video
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Image, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Image
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Folder, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Folder,
            (0, $5PPrc.NounSubtypeKey).Drive
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Pdf, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Notebook, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Notebook
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).WebPage, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).WebPage,
            (0, $5PPrc.NounSubtypeKey).Shortcut
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Other, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Other,
            (0, $5PPrc.NounSubtypeKey).Archive
        ]
    });
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats SharePoint comment matches as documents rather than standalone comments.
    // SharePoint embedded comments are gated behind a SharePoint-specific flag (independent of the
    // shared 3p flag used for Google Drive) so we can enable/disable SharePoint comment support
    // independently of other 3p products.
    if ((0, $iDrrr.fg)('rovo_fps_sharepoint_embedded_comments')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $9591d824618efc40$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft SharePoint',
    id: 'sharepoint',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sharepoint,
    icon: (0, $i52Hf.get3PLogo)((0, $Douji.SharePointIcon), 'Sharepoint', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $Douji.SharepointIconBorderless), 'Sharepoint', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $Douji.SharePointSearchResultIcon), 'Sharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    // Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    get typeFilterConfig () {
        return $9591d824618efc40$var$getSharePointTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch'
        ];
        if ((0, $iDrrr.fg)('rovo_fps_enable_sharepoint_space_filter')) baseFilters.push('space');
        if ((0, $iDrrr.fg)('rovo_fps_enable_sharepoint_content_filter')) baseFilters.push('content');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sharepointConfig"] = $9591d824618efc40$export$eb46bb6c4f0e628c;

});

parcelRegister("Douji", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null));
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null));
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null));
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("lSeWC", function(module, exports) {

var $bltJZ = parcelRequire("bltJZ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");

const $248c68d25f33bedd$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.LoomIcon), 'small'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.LoomIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["loomConfig"] = $248c68d25f33bedd$export$9cb908560d4a0a78;

});

parcelRegister("4TRyZ", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gjT9P = parcelRequire("gjT9P");

const $0dfe51a80d18d316$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OneDrive,
    icon: (0, $i52Hf.get3PLogo)((0, $gjT9P.OneDriveIcon), 'OneDrive', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $gjT9P.OneDriveIconBorderless), 'OneDrive', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gjT9P.OneDriveSearchResultIcon), 'OneDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["oneDriveConfig"] = $0dfe51a80d18d316$export$b3b3a7aaf94fe09;

});

parcelRegister("gjT9P", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $a09e3766710471f8$var$LazyOneDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDyw")).then((m)=>m.OneDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/icon'
});

const $a09e3766710471f8$var$LazyOneDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDyw")).then((m)=>m.OneDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/search-result-icon'
});

const $a09e3766710471f8$var$LazyOneDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDyw")).then((m)=>m.OneDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/icon-borderless'
});
const $a09e3766710471f8$export$44884401d09e251c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveIconComponent, null));
const $a09e3766710471f8$export$f2ab3f3a9966c07c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveSearchResultIconComponent, null));
const $a09e3766710471f8$export$9b1a95f6ce5942a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a09e3766710471f8$var$LazyOneDriveIconBorderlessComponent, null));
module.exports["OneDriveIcon"] = $a09e3766710471f8$export$44884401d09e251c;
module.exports["OneDriveSearchResultIcon"] = $a09e3766710471f8$export$f2ab3f3a9966c07c;
module.exports["OneDriveIconBorderless"] = $a09e3766710471f8$export$9b1a95f6ce5942a8;

});

parcelRegister("lbDyw", function(module, exports) {

let $f6c94f073561a95b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c94f073561a95b$var$load("3WneE").then(()=>parcelRequire('8EfTH'));

});

parcelRegister("2qza4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jkp8o = parcelRequire("jkp8o");

const $f930aa7851f48d68$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dropbox,
    icon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxIcon), 'Dropbox', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxSearchResultIcon), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $f930aa7851f48d68$export$4a63cdb15a145936;

});

parcelRegister("jkp8o", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f91f519b5bcd4961$var$LazyDropboxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/icon'
});

const $f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon'
});
const $f91f519b5bcd4961$export$5e2362bb78414664 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxIconComponent, null));
const $f91f519b5bcd4961$export$197780c70679b508 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent, null));
module.exports["DropboxIcon"] = $f91f519b5bcd4961$export$5e2362bb78414664;
module.exports["DropboxSearchResultIcon"] = $f91f519b5bcd4961$export$197780c70679b508;

});

parcelRegister("jawnG", function(module, exports) {

let $df4811b549e8b26a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df4811b549e8b26a$var$load("4zHyf").then(()=>parcelRequire('lOu1t'));

});

parcelRegister("kDG5l", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $72Zuk = parcelRequire("72Zuk");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2sFbd = parcelRequire("2sFbd");

const $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig = ()=>{
    const typeFilter = new Map();
    // Always include Message
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Message, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Conversation, {
        entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
        subTypes3P: []
    });
    return typeFilter;
};
const $35e09b6a61d5b2b9$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Slack,
    icon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIcon), 'Slack', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIconBorderless), 'Slack', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackSearchResultIcon), 'Slack', 'large'),
    integrationAri: 'ari:cloud:platform::integration/slack',
    get typeFilterConfig () {
        return $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'slackChannel'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["slackConfig"] = $35e09b6a61d5b2b9$export$c33894e475506863;

});

parcelRegister("6GYKu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $76ad9eb563127536$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $76ad9eb563127536$export$a752b216a5b9069f;

});

parcelRegister("72Zuk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $229f506edf3bbbcc$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $229f506edf3bbbcc$export$8bd7fa13a82672fe;

});

parcelRegister("2sFbd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null));
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null));
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null));
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null));
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("6sCQO", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $72Zuk = parcelRequire("72Zuk");


var $kFLxH = parcelRequire("kFLxH");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fHkb6 = parcelRequire("fHkb6");

const $5b2f0af1768b93e1$var$getTeamsTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Conversation, {
        entities3P: [
            ...(0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Message, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: []
    });
    // NOTE: Attachment intentionally reuses DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI (same as
    // Message above) because there is no dedicated attachment ATI in the cloud graph schema.
    // This means convertFiltersToQueryParams / extractType cannot distinguish 'attachment'
    // from 'message' when reading back the blob — both produce ati:cloud:graph:message with
    // no differentiating subtypes.
    // To fix this properly, either:
    //   1. Introduce a dedicated ati:cloud:graph:attachment entity ATI, or
    //   2. Add a NounSubtypeKey.Attachment subtype and update the Teams config to use it.
    config.set((0, $5PPrc.TypeFilterValueKey).Attachment, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $5b2f0af1768b93e1$export$a579e078acf13bef = {
    displayName: 'Microsoft Teams',
    id: 'teams',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Teams,
    icon: (0, $i52Hf.get3PLogo)((0, $fHkb6.TeamsIcon), 'Teams', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $fHkb6.TeamsIconBorderless), 'Teams', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fHkb6.TeamsSearchResultIcon), 'Teams', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    get typeFilterConfig () {
        return $5b2f0af1768b93e1$var$getTeamsTypeFilterConfig();
    },
    get filters () {
        const filters = [
            'lastUpdated',
            'hasAttachment',
            'workspaceName'
        ];
        return filters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["teamsConfig"] = $5b2f0af1768b93e1$export$a579e078acf13bef;

});

parcelRegister("fHkb6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $aab5ba40d056e465$var$LazyTeamsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gEuqq")).then((m)=>m.TeamsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/teams/icon'
});

const $aab5ba40d056e465$var$LazyTeamsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gEuqq")).then((m)=>m.TeamsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/teams/search-result-icon'
});

const $aab5ba40d056e465$var$LazyTeamsIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gEuqq")).then((m)=>m.TeamsIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/teams/icon-borderless'
});
const $aab5ba40d056e465$export$1bcbc9c337da86da = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsIconComponent, null));
const $aab5ba40d056e465$export$fa291efbf00e84d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsSearchResultIconComponent, null));
const $aab5ba40d056e465$export$1b2996b1dd1cd142 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aab5ba40d056e465$var$LazyTeamsIconBorderlessComponent, null));
module.exports["TeamsIcon"] = $aab5ba40d056e465$export$1bcbc9c337da86da;
module.exports["TeamsSearchResultIcon"] = $aab5ba40d056e465$export$fa291efbf00e84d3;
module.exports["TeamsIconBorderless"] = $aab5ba40d056e465$export$1b2996b1dd1cd142;

});

parcelRegister("gEuqq", function(module, exports) {

let $c1f7fb973646ad66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1f7fb973646ad66$var$load("5YFUU").then(()=>parcelRequire('hui2Z'));

});

parcelRegister("6eg6r", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bshDC = parcelRequire("bshDC");

const $5a3e20cfdf519b55$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIcon), 'Google Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIconBorderless), 'Google Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarSearchResultIcon), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};
module.exports["googleCalendarConfig"] = $5a3e20cfdf519b55$export$be326f2f9a08a3a4;

});

parcelRegister("f3t7x", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $353cafebfceb5684$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $353cafebfceb5684$export$733c2acb2513a07a;

});

parcelRegister("bshDC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $5e54e69c86724cae$var$LazyGoogleCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/search-result-icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon-borderless'
});
const $5e54e69c86724cae$export$5d128e0a6ffc0558 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconComponent, null));
const $5e54e69c86724cae$export$aed283b8fb73a449 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent, null));
const $5e54e69c86724cae$export$dc8e328f8eb98139 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent, null));
module.exports["GoogleCalendarIcon"] = $5e54e69c86724cae$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarSearchResultIcon"] = $5e54e69c86724cae$export$aed283b8fb73a449;
module.exports["GoogleCalendarIconBorderless"] = $5e54e69c86724cae$export$dc8e328f8eb98139;

});

parcelRegister("4w4Kc", function(module, exports) {

let $349dd4aca5d2aad7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $349dd4aca5d2aad7$var$load("41vki").then(()=>parcelRequire('bzpJH'));

});

parcelRegister("52jas", function(module, exports) {

var $iURDc = parcelRequire("iURDc");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4sGAv = parcelRequire("4sGAv");

const $b333d81b934c9f10$export$c771ac380e225e02 = {
    displayName: 'Gmail',
    id: 'gmail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gmail,
    icon: (0, $i52Hf.get3PLogo)((0, $4sGAv.GmailIcon), 'Gmail', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $4sGAv.GmailIconBorderless), 'Gmail', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4sGAv.GmailSearchResultIcon), 'Gmail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $iURDc.FEDERATED_GOOGLE_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    isEnabled: ()=>true,
    isFederated: true
};
module.exports["gmailConfig"] = $b333d81b934c9f10$export$c771ac380e225e02;

});

parcelRegister("iURDc", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ 




var $sRb5o = parcelRequire("sRb5o");


















const $24284859cca72d32$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $24284859cca72d32$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $24284859cca72d32$export$50adf3273cb5cdeb = [
    $24284859cca72d32$export$6ec0530ffade9ab0,
    $24284859cca72d32$export$dfd3b612305212b4
];
module.exports["FEDERATED_GOOGLE_EMAIL_ENTITY_ATI"] = $24284859cca72d32$export$6ec0530ffade9ab0;
module.exports["FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI"] = $24284859cca72d32$export$dfd3b612305212b4;

});

parcelRegister("2vDkv", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $b3506739b3db16a9$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $b3506739b3db16a9$export$1e3b02869b42f77a;

});

parcelRegister("4moZS", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4dabbc53c19f0eb6$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $4dabbc53c19f0eb6$export$4e0eae9edc1a8907;

});

parcelRegister("kQMkl", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $58e4cb80d7bd8f2a$export$3f89e5cd56d4a568 = [
    'ati:cloud:graph:project'
];
module.exports["DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI"] = $58e4cb80d7bd8f2a$export$3f89e5cd56d4a568;

});

parcelRegister("2eAN0", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $985674bff788ed13$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $985674bff788ed13$export$13c55dcee8605c46;

});

parcelRegister("5L3UP", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c71c6856c01ed4e1$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $c71c6856c01ed4e1$export$8dd471de1c2be682;

});

parcelRegister("lSV0R", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $73e7c9ae902307cd$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $73e7c9ae902307cd$export$5794851cbc8ee193;

});

parcelRegister("5zhyH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c56574206e5d9432$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $c56574206e5d9432$export$f752f74515f17189;

});

parcelRegister("5ET0n", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $9b3a3e2680ba7ccf$export$fedd20c53936ae44 = [
    'ati:cloud:graph:customer-contact'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI"] = $9b3a3e2680ba7ccf$export$fedd20c53936ae44;

});

parcelRegister("l2DTy", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $5b29277d1a8af5e5$export$2b1dc2787f647e40 = [
    'ati:cloud:graph:campaign'
];
module.exports["DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI"] = $5b29277d1a8af5e5$export$2b1dc2787f647e40;

});

parcelRegister("kxWyf", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a8af9f863b3e166c$export$47853cd30a48f750 = [
    'ati:cloud:graph:case'
];
module.exports["DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI"] = $a8af9f863b3e166c$export$47853cd30a48f750;

});

parcelRegister("4sGAv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $71969d87ce9cceb1$var$LazyGmailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2LZrP")).then((m)=>m.GmailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gmail/icon'
});

const $71969d87ce9cceb1$var$LazyGmailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2LZrP")).then((m)=>m.GmailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gmail/search-result-icon'
});

const $71969d87ce9cceb1$var$LazyGmailIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2LZrP")).then((m)=>m.GmailIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gmail/icon-borderless'
});
const $71969d87ce9cceb1$export$856bad9032bbc5ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailIconComponent, null));
const $71969d87ce9cceb1$export$5abf8db8f9fa0429 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailSearchResultIconComponent, null));
const $71969d87ce9cceb1$export$60f25f99f40f37f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($71969d87ce9cceb1$var$LazyGmailIconBorderlessComponent, null));
module.exports["GmailIcon"] = $71969d87ce9cceb1$export$856bad9032bbc5ed;
module.exports["GmailSearchResultIcon"] = $71969d87ce9cceb1$export$5abf8db8f9fa0429;
module.exports["GmailIconBorderless"] = $71969d87ce9cceb1$export$60f25f99f40f37f6;

});

parcelRegister("2LZrP", function(module, exports) {

let $204fa2d3335e90ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $204fa2d3335e90ee$var$load("4ypyc").then(()=>parcelRequire('lq00l'));

});

parcelRegister("ijAga", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9dIsl = parcelRequire("9dIsl");

const $28f910cc1563149a$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIcon), 'Outlook Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIconBorderless), 'Outlook Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarSearchResultIcon), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["outlookCalendarConfig"] = $28f910cc1563149a$export$3e5044818f2e9ef3;

});

parcelRegister("9dIsl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/search-result-icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon-borderless'
});
const $b7be050c70ad0dbd$export$62b570fbaf793397 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent, null));
const $b7be050c70ad0dbd$export$c93fd0887f18cc87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent, null));
const $b7be050c70ad0dbd$export$dd150ae24aa9e16a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent, null));
module.exports["OutlookCalendarIcon"] = $b7be050c70ad0dbd$export$62b570fbaf793397;
module.exports["OutlookCalendarSearchResultIcon"] = $b7be050c70ad0dbd$export$c93fd0887f18cc87;
module.exports["OutlookCalendarIconBorderless"] = $b7be050c70ad0dbd$export$dd150ae24aa9e16a;

});

parcelRegister("1cK5e", function(module, exports) {

let $0e0aa8a5bee42239$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e0aa8a5bee42239$var$load("kD3mK").then(()=>parcelRequire('izieu'));

});

parcelRegister("dPp45", function(module, exports) {

var $iURDc = parcelRequire("iURDc");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lbM4I = parcelRequire("lbM4I");

const $80f26afb2b86eb44$export$31104d47075e6dfd = {
    displayName: 'Outlook Mail',
    id: 'outlook-mail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OutlookMail,
    icon: (0, $i52Hf.get3PLogo)((0, $lbM4I.OutlookMailIcon), 'Outlook Mail', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $lbM4I.OutlookMailIconBorderless), 'Outlook Mail', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lbM4I.OutlookMailSearchResultIcon), 'Outlook Mail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $iURDc.FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    isEnabled: ()=>true,
    isFederated: true
};
module.exports["outlookMail"] = $80f26afb2b86eb44$export$31104d47075e6dfd;

});

parcelRegister("lbM4I", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $9b087007c6338cae$var$LazyOutlookMailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1MgDj")).then((m)=>m.OutlookMailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-mail/icon'
});

const $9b087007c6338cae$var$LazyOutlookMailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1MgDj")).then((m)=>m.OutlookMailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-mail/search-result-icon'
});

const $9b087007c6338cae$var$LazyOutlookMailIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1MgDj")).then((m)=>m.OutlookMailIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-mail/icon-borderless'
});
const $9b087007c6338cae$export$d905606eb58fea64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailIconComponent, null));
const $9b087007c6338cae$export$f819ae7cc5008c40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailSearchResultIconComponent, null));
const $9b087007c6338cae$export$c828641fbf8ac5e9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b087007c6338cae$var$LazyOutlookMailIconBorderlessComponent, null));
module.exports["OutlookMailIcon"] = $9b087007c6338cae$export$d905606eb58fea64;
module.exports["OutlookMailSearchResultIcon"] = $9b087007c6338cae$export$f819ae7cc5008c40;
module.exports["OutlookMailIconBorderless"] = $9b087007c6338cae$export$c828641fbf8ac5e9;

});

parcelRegister("1MgDj", function(module, exports) {

let $14b72d21451b9e01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14b72d21451b9e01$var$load("5dATw").then(()=>parcelRequire('cs6al'));

});

parcelRegister("4Be7r", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5SyKL = parcelRequire("5SyKL");

const $e64348b365719323$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaIcon), 'Asana', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Asana,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaSearchResultIcon), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["asanaConfig"] = $e64348b365719323$export$72c8845a87b8934e;

});

parcelRegister("5SyKL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6e40eba859cc102e$var$LazyAsanaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/icon'
});

const $6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/search-result-icon'
});
const $6e40eba859cc102e$export$671541d0c7918cd9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaIconComponent, null));
const $6e40eba859cc102e$export$c3fa6bf9156b56f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent, null));
module.exports["AsanaIcon"] = $6e40eba859cc102e$export$671541d0c7918cd9;
module.exports["AsanaSearchResultIcon"] = $6e40eba859cc102e$export$c3fa6bf9156b56f9;

});

parcelRegister("63WVt", function(module, exports) {

let $46a0bb5c742ef139$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46a0bb5c742ef139$var$load("cQSOF").then(()=>parcelRequire('9fYuQ'));

});

parcelRegister("kmEEk", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ajO8r = parcelRequire("ajO8r");

const $c81e254992debedb$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskIcon), 'Zendesk', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zendesk,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskSearchResultIcon), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Ticket,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Post,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Post
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Article,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Article
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zendeskConfig"] = $c81e254992debedb$export$74a2db0a5eb2da3f;

});

parcelRegister("ajO8r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $8cf8b8beac6f4758$var$LazyZendeskIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/icon'
});

const $8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/search-result-icon'
});
const $8cf8b8beac6f4758$export$9969d63eaadfddf7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskIconComponent, null));
const $8cf8b8beac6f4758$export$439dd6b525db0f9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent, null));
module.exports["ZendeskIcon"] = $8cf8b8beac6f4758$export$9969d63eaadfddf7;
module.exports["ZendeskSearchResultIcon"] = $8cf8b8beac6f4758$export$439dd6b525db0f9a;

});

parcelRegister("fmsuC", function(module, exports) {

let $b2ef03301938ca3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2ef03301938ca3f$var$load("2TtSv").then(()=>parcelRequire('iMWOo'));

});

parcelRegister("52Drw", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $inzhp = parcelRequire("inzhp");

const $03fbf292f7174bda$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Airtable,
    icon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableIcon), 'Airtable', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableSearchResultIcon), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["airtableConfig"] = $03fbf292f7174bda$export$962b0679c5bd2c33;

});

parcelRegister("inzhp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $92a7691f4600f71d$var$LazyAirtableIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/icon'
});

const $92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/search-result-icon'
});
const $92a7691f4600f71d$export$88b64eee273831fd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableIconComponent, null));
const $92a7691f4600f71d$export$826c628c1cea041a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent, null));
module.exports["AirtableIcon"] = $92a7691f4600f71d$export$88b64eee273831fd;
module.exports["AirtableSearchResultIcon"] = $92a7691f4600f71d$export$826c628c1cea041a;

});

parcelRegister("kzDsq", function(module, exports) {

let $efa5aef30890ae60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efa5aef30890ae60$var$load("ks6Jw").then(()=>parcelRequire('dIIkr'));

});

parcelRegister("aaz0Y", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g0bLV = parcelRequire("g0bLV");

const $81da3ded26649f38$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Smartsheet,
    icon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetIcon), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetSearchResultIcon), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["smartsheetConfig"] = $81da3ded26649f38$export$aad10bcf647ef696;

});

parcelRegister("g0bLV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $8f9328e012078649$var$LazySmartsheetIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/icon'
});

const $8f9328e012078649$var$LazySmartsheetSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/search-result-icon'
});
const $8f9328e012078649$export$dd0ad7bd8a5794f4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetIconComponent, null));
const $8f9328e012078649$export$3b8c4380ae1ed96d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetSearchResultIconComponent, null));
module.exports["SmartsheetIcon"] = $8f9328e012078649$export$dd0ad7bd8a5794f4;
module.exports["SmartsheetSearchResultIcon"] = $8f9328e012078649$export$3b8c4380ae1ed96d;

});

parcelRegister("hsPg7", function(module, exports) {

let $cb6cd027ab9362e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb6cd027ab9362e1$var$load("hwAbd").then(()=>parcelRequire('7j9rQ'));

});

parcelRegister("kcCFv", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dpFv1 = parcelRequire("dpFv1");

const $2afe1256651e861b$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Notion,
    icon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIcon), 'Notion', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIconBorderless), 'Notion', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionSearchResultIcon), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["notionConfig"] = $2afe1256651e861b$export$ddf7404f556e473a;

});

parcelRegister("dpFv1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $eadc98172343aaf6$var$LazyNotionIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon'
});

const $eadc98172343aaf6$var$LazyNotionSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon'
});

const $eadc98172343aaf6$var$LazyNotionIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless'
});
const $eadc98172343aaf6$export$694ff710b1e20299 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconComponent, null));
const $eadc98172343aaf6$export$7dd377a68ecb1d9f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionSearchResultIconComponent, null));
const $eadc98172343aaf6$export$5b5388c6f4e608dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconBorderlessComponent, null));
module.exports["NotionIcon"] = $eadc98172343aaf6$export$694ff710b1e20299;
module.exports["NotionSearchResultIcon"] = $eadc98172343aaf6$export$7dd377a68ecb1d9f;
module.exports["NotionIconBorderless"] = $eadc98172343aaf6$export$5b5388c6f4e608dd;

});

parcelRegister("dqLLz", function(module, exports) {

let $9c72c17820ac74dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c72c17820ac74dc$var$load("iCnHc").then(()=>parcelRequire('lRem0'));

});

parcelRegister("6lsSn", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1q7zk = parcelRequire("1q7zk");

const $b9040784bae93d2b$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Miro,
    icon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroIcon), 'Miro', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroSearchResultIcon), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $b9040784bae93d2b$export$b11bada05d439596;

});

parcelRegister("1q7zk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $795cd329f1dc6efb$var$LazyMiroIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/icon'
});

const $795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/search-result-icon'
});
const $795cd329f1dc6efb$export$38410c1d5582587e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroIconComponent, null));
const $795cd329f1dc6efb$export$c22696a011659024 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent, null));
module.exports["MiroIcon"] = $795cd329f1dc6efb$export$38410c1d5582587e;
module.exports["MiroSearchResultIcon"] = $795cd329f1dc6efb$export$c22696a011659024;

});

parcelRegister("8rXyj", function(module, exports) {

let $626f0a394095201f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $626f0a394095201f$var$load("6cQfl").then(()=>parcelRequire('UNjzi'));

});

parcelRegister("k521G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XMnx = parcelRequire("3XMnx");

const $3c5ca7e0efe3fba9$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Docusign,
    icon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIcon), 'Docusign', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIconBorderless), 'Docusign', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignSearchResultIcon), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["docusignConfig"] = $3c5ca7e0efe3fba9$export$cee55280cabc1aa1;

});

parcelRegister("3XMnx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $094cc084c2c96e5c$var$LazyDocusignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon'
});

const $094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/search-result-icon'
});

const $094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon-borderless'
});
const $094cc084c2c96e5c$export$393452da0e179bab = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconComponent, null));
const $094cc084c2c96e5c$export$4cdd065eb81c5a09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent, null));
const $094cc084c2c96e5c$export$db2f9bd1f316d475 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent, null));
module.exports["DocusignIcon"] = $094cc084c2c96e5c$export$393452da0e179bab;
module.exports["DocusignSearchResultIcon"] = $094cc084c2c96e5c$export$4cdd065eb81c5a09;
module.exports["DocusignIconBorderless"] = $094cc084c2c96e5c$export$db2f9bd1f316d475;

});

parcelRegister("l2dtx", function(module, exports) {

let $f5043cd00e87a001$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5043cd00e87a001$var$load("hY6q1").then(()=>parcelRequire('l3sY5'));

});

parcelRegister("43W2t", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $kSVSf = parcelRequire("kSVSf");

const $20e2732837474949$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Lucid,
    icon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidIcon), 'Lucid', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidSearchResultIcon), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["lucidConfig"] = $20e2732837474949$export$3cac442956139a7e;

});

parcelRegister("kSVSf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $28a610a168ffc34d$var$LazyLucidIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/icon'
});

const $28a610a168ffc34d$var$LazyLucidSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon'
});
const $28a610a168ffc34d$export$8664694e1d7db2a0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidIconComponent, null));
const $28a610a168ffc34d$export$6daa097ac5ffeb2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidSearchResultIconComponent, null));
module.exports["LucidIcon"] = $28a610a168ffc34d$export$8664694e1d7db2a0;
module.exports["LucidSearchResultIcon"] = $28a610a168ffc34d$export$6daa097ac5ffeb2c;

});

parcelRegister("627KK", function(module, exports) {

let $4648f18ba45c9e97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4648f18ba45c9e97$var$load("hU3Xi").then(()=>parcelRequire('c6ZRh'));

});

parcelRegister("6ThsT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cJP8d = parcelRequire("cJP8d");

const $03d641d2f237614a$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Monday,
    icon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIcon), 'Monday', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIconBorderless), 'Monday', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondaySearchResultIcon), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["mondayConfig"] = $03d641d2f237614a$export$49283b8341865631;

});

parcelRegister("cJP8d", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $142215abe5670892$var$LazyMondayIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon'
});

const $142215abe5670892$var$LazyMondaySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondaySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon'
});

const $142215abe5670892$var$LazyMondayIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless'
});
const $142215abe5670892$export$37b4104f63b2f4bd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconComponent, null));
const $142215abe5670892$export$bf10d2e61430fb53 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondaySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondaySearchResultIconComponent, null));
const $142215abe5670892$export$43da0494a61d1337 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconBorderlessComponent, null));
module.exports["MondayIcon"] = $142215abe5670892$export$37b4104f63b2f4bd;
module.exports["MondaySearchResultIcon"] = $142215abe5670892$export$bf10d2e61430fb53;
module.exports["MondayIconBorderless"] = $142215abe5670892$export$43da0494a61d1337;

});

parcelRegister("9b74Z", function(module, exports) {

let $6aeaa1f9faf92676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aeaa1f9faf92676$var$load("1EOaf").then(()=>parcelRequire('iBWwo'));

});

parcelRegister("4x6XK", function(module, exports) {

var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dULnI = parcelRequire("dULnI");

const $aaf7a143bc096e5d$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AzureDevops,
    icon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsIcon), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsSearchResultIcon), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["azureDevopsConfig"] = $aaf7a143bc096e5d$export$f324080d91cfb196;

});

parcelRegister("382mb", function(module, exports) {

var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ehKBQ = parcelRequire("ehKBQ");

const $e23e1846e340baa7$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitlab,
    icon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIcon), 'Gitlab', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIconBorderless), 'Gitlab', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabSearchResultIcon), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Repository,
                    (0, $5PPrc.NounSubtypeKey).Project
                ]
            }
        ]
    ]),
    filters: [
        'pullRequestStatus'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gitlabConfig"] = $e23e1846e340baa7$export$72758f81cc2e21e1;

});

parcelRegister("8oQ7k", function(module, exports) {

var $bltJZ = parcelRequire("bltJZ");


var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");

const $e50bb482688d43d3$export$3dab4b73b27a9d7e = {
    displayName: 'Confluence Data Center',
    id: 'confluence-dc',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ConfluenceDC,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.ConfluenceIcon), 'Confluence Data Center'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.ConfluenceIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/confluence-dc',
    typeFilterConfig: (()=>{
        const typeFilter = new Map([
            [
                (0, $5PPrc.TypeFilterValueKey).Space,
                {
                    entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Space
                    ]
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Page,
                {
                    entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Page
                    ]
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Blogpost,
                {
                    entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Blogpost
                    ]
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Comment,
                {
                    entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                    subTypes3P: []
                }
            ],
            [
                (0, $5PPrc.TypeFilterValueKey).Attachment,
                {
                    entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $5PPrc.NounSubtypeKey).Archive,
                        (0, $5PPrc.NounSubtypeKey).Audio,
                        (0, $5PPrc.NounSubtypeKey).Code,
                        (0, $5PPrc.NounSubtypeKey).Document,
                        (0, $5PPrc.NounSubtypeKey).Image,
                        (0, $5PPrc.NounSubtypeKey).Pdf,
                        (0, $5PPrc.NounSubtypeKey).Presentation,
                        (0, $5PPrc.NounSubtypeKey).Spreadsheet,
                        (0, $5PPrc.NounSubtypeKey).Video,
                        (0, $5PPrc.NounSubtypeKey).WebPage,
                        (0, $5PPrc.NounSubtypeKey).Other
                    ]
                }
            ]
        ]);
        return typeFilter;
    })(),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'createdBy',
        'content',
        'space',
        'label'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["confluenceDCConfig"] = $e50bb482688d43d3$export$3dab4b73b27a9d7e;

});

parcelRegister("79ijY", function(module, exports) {

var $bltJZ = parcelRequire("bltJZ");


var $4moZS = parcelRequire("4moZS");


var $kQMkl = parcelRequire("kQMkl");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $3h5an = parcelRequire("3h5an");


var $fR63l = parcelRequire("fR63l");

const $003320bf4eff71f2$export$7441620f71b01d27 = {
    displayName: 'Jira Data Center',
    id: 'jira-dc',
    resourceType: (0, $fR63l.ProductResourceTypes3P).JiraDC,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.JiraIcon), 'Jira Data Center'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3h5an.JiraSearchResultIcon), 'Jira Data Center', 'large'),
    integrationAri: 'ari:cloud:platform::integration/jira-dc',
    containerTypes: [
        'software',
        'business',
        'project'
    ],
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Software,
                    (0, $5PPrc.NounSubtypeKey).Business,
                    (0, $5PPrc.NounSubtypeKey).ServiceDesk,
                    (0, $5PPrc.NounSubtypeKey).Project
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Issue,
            {
                entities3P: [
                    ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Issue
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'project',
        'assignee'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true,
    fanOutConnectorSources: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            thirdPartyProduct: {
                ...existingFilters?.thirdPartyProduct,
                integrationId: datasource?.integrationAri,
                providerId: datasource?.providerId
            }
        })
};
module.exports["jiraDCConfig"] = $003320bf4eff71f2$export$7441620f71b01d27;

});

parcelRegister("3h5an", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $bf572cc91e29acc8$export$f68d29dbb4f2da82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18716)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18716)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18716)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18716"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18716"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18716"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "30.9683",
            height: "31.2083",
            fill: "white",
            transform: "translate(3.83331 6.04169)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "30.9683",
        height: "31.2083",
        fill: "white",
        transform: "translate(3.83331 6.04169)"
    }))));
module.exports["JiraSearchResultIcon"] = $bf572cc91e29acc8$export$f68d29dbb4f2da82;

});

parcelRegister("e7BOf", function(module, exports) {

var $bltJZ = parcelRequire("bltJZ");


var $4moZS = parcelRequire("4moZS");


var $kQMkl = parcelRequire("kQMkl");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $aIhxJ = parcelRequire("aIhxJ");


var $fR63l = parcelRequire("fR63l");

const $0c7c15dfc6acf8cc$export$1bc88db204558364 = {
    displayName: 'JSM Data Center',
    id: 'jsm-dc',
    resourceType: (0, $fR63l.ProductResourceTypes3P).JsmDC,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.JiraServiceManagementIcon), 'JSM Data Center'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $aIhxJ.JiraServiceManagementSearchResultIcon), 'JSM Data Center', 'large'),
    integrationAri: 'ari:cloud:platform::integration/jira-dc',
    containerTypes: [
        'service_desk'
    ],
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).ServiceDesk
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Issue,
            {
                entities3P: [
                    ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Issue
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'project',
        'assignee'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            thirdPartyProduct: {
                ...existingFilters?.thirdPartyProduct,
                integrationId: datasource?.integrationAri,
                providerId: datasource?.providerId
            }
        })
};
module.exports["jsmDCConfig"] = $0c7c15dfc6acf8cc$export$1bc88db204558364;

});

parcelRegister("aIhxJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $adbd5c4f9b3901a5$export$ceeb1de9ca56c2f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18708)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18708)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18708)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
            fill: "#0C66E4"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18708"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18708"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18708"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "28.2341",
            height: "33",
            fill: "white",
            transform: "translate(5.83331 3.33334)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
        fill: "#0C66E4"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.2341",
        height: "33",
        fill: "white",
        transform: "translate(5.83331 3.33334)"
    }))));
module.exports["JiraServiceManagementSearchResultIcon"] = $adbd5c4f9b3901a5$export$ceeb1de9ca56c2f7;

});

parcelRegister("fg2gb", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fDs5L = parcelRequire("fDs5L");

const $ded2e0e354596c76$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Canva,
    icon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaIcon), 'Canva', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaSearchResultIcon), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["canvaConfig"] = $ded2e0e354596c76$export$75e56657ffc0207b;

});

parcelRegister("fDs5L", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $4d4fb88adf934208$var$LazyCanvaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/icon'
});

const $4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/search-result-icon'
});
const $4d4fb88adf934208$export$3ad1ba1bf426d64a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaIconComponent, null));
const $4d4fb88adf934208$export$ac6bbd7ba99716e3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent, null));
module.exports["CanvaIcon"] = $4d4fb88adf934208$export$3ad1ba1bf426d64a;
module.exports["CanvaSearchResultIcon"] = $4d4fb88adf934208$export$ac6bbd7ba99716e3;

});

parcelRegister("6LmRM", function(module, exports) {

let $4ec8dea8ab0a1852$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ec8dea8ab0a1852$var$load("bX5IH").then(()=>parcelRequire('agGaQ'));

});

parcelRegister("fauGM", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6MJWz = parcelRequire("6MJWz");

const $9286766965944e9d$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Box,
    icon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxIcon), 'Box', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxSearchResultIcon), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["boxConfig"] = $9286766965944e9d$export$3e7603f097ea326e;

});

parcelRegister("6MJWz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b99c2662195c467e$var$LazyBoxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/icon'
});

const $b99c2662195c467e$var$LazyBoxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/search-result-icon'
});
const $b99c2662195c467e$export$adedf1569d7107de = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxIconComponent, null));
const $b99c2662195c467e$export$f9ea3a56c013af54 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxSearchResultIconComponent, null));
module.exports["BoxIcon"] = $b99c2662195c467e$export$adedf1569d7107de;
module.exports["BoxSearchResultIcon"] = $b99c2662195c467e$export$f9ea3a56c013af54;

});

parcelRegister("1x79L", function(module, exports) {

let $11de6ca258b12afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11de6ca258b12afa$var$load("1KhjS").then(()=>parcelRequire('h43rp'));

});

parcelRegister("bj13p", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8uEzt = parcelRequire("8uEzt");

const $55934d84816643a8$export$ce290ee9e9d9bcd7 = {
    displayName: 'Zoom',
    id: 'zoom',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zoom,
    icon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomIcon), 'Zoom', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomSearchResultIcon), 'Zoom', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zoom',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zoomConfig"] = $55934d84816643a8$export$ce290ee9e9d9bcd7;

});

parcelRegister("8uEzt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f1c2fec685aced05$var$LazyZoomIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/icon'
});

const $f1c2fec685aced05$var$LazyZoomSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/search-result-icon'
});
const $f1c2fec685aced05$export$db7393a57b3e6d84 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomIconComponent, null));
const $f1c2fec685aced05$export$5c9fb0638b666051 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomSearchResultIconComponent, null));
module.exports["ZoomIcon"] = $f1c2fec685aced05$export$db7393a57b3e6d84;
module.exports["ZoomSearchResultIcon"] = $f1c2fec685aced05$export$5c9fb0638b666051;

});

parcelRegister("brtqH", function(module, exports) {

let $85490b746b3dbf90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85490b746b3dbf90$var$load("kxE93").then(()=>parcelRequire('9e80B'));

});

parcelRegister("3VdqU", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cdPZA = parcelRequire("cdPZA");

const $6e80d7674da45b22$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zeplin,
    icon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIcon), 'Zeplin', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIconBorderless), 'Zeplin', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinSearchResultIcon), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zeplinConfig"] = $6e80d7674da45b22$export$d198c255b2b88327;

});

parcelRegister("cdPZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $fbd169a88d312a73$var$LazyZeplinIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon'
});

const $fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/search-result-icon'
});

const $fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon-borderless'
});
const $fbd169a88d312a73$export$81c909fcf490b72b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconComponent, null));
const $fbd169a88d312a73$export$e3736b5ffc9fcc9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent, null));
const $fbd169a88d312a73$export$d013f8d99ccc63fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent, null));
module.exports["ZeplinIcon"] = $fbd169a88d312a73$export$81c909fcf490b72b;
module.exports["ZeplinSearchResultIcon"] = $fbd169a88d312a73$export$e3736b5ffc9fcc9e;
module.exports["ZeplinIconBorderless"] = $fbd169a88d312a73$export$d013f8d99ccc63fb;

});

parcelRegister("gAgWa", function(module, exports) {

let $c12d257c331759c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c12d257c331759c7$var$load("dBdPR").then(()=>parcelRequire('cNG5i'));

});

parcelRegister("iN1Vs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4Bw3O = parcelRequire("4Bw3O");

const $b9ccdad19edf777f$var$getServiceNowTypeFilterConfig = ()=>{
    const config = new Map();
    if ((0, $iDrrr.fg)('rovo_fps_servicenow_type_filter_subtypes')) {
        config.set((0, $5PPrc.TypeFilterValueKey).Incident, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Incident
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).CatalogItem, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).CatalogItem
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).RequestedItem, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).RequestedItem
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).Epic, {
            entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Epic
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).KnowledgeArticle, {
            entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).KnowledgeArticle
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).NewsArticle, {
            entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).NewsArticle
            ]
        });
    } else config.set((0, $5PPrc.TypeFilterValueKey).WorkItem, {
        entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('enable_rovo_search_comment_filter_for_servicenow')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('enable_rovo_search_project_filter_for_servicenow')) {
        config.set((0, $5PPrc.TypeFilterValueKey).Project, {
            entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Project
            ]
        });
        config.set((0, $5PPrc.TypeFilterValueKey).Demand, {
            entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
            subTypes3P: [
                (0, $5PPrc.NounSubtypeKey).Demand
            ]
        });
    }
    return config;
};
const $b9ccdad19edf777f$export$d60233309c5c50ab = {
    displayName: 'ServiceNow',
    id: 'servicenow',
    icon: (0, $i52Hf.get3PLogo)((0, $4Bw3O.ServiceNowIcon), 'ServiceNow', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).ServiceNow,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4Bw3O.ServiceNowSearchResultIcon), 'ServiceNow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/servicenow',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    get typeFilterConfig () {
        return $b9ccdad19edf777f$var$getServiceNowTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["serviceNowConfig"] = $b9ccdad19edf777f$export$d60233309c5c50ab;

});

parcelRegister("4Bw3O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ef61d391b7057faa$var$LazyServiceNowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8760j")).then((m)=>m.ServiceNowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/servicenow/icon'
});

const $ef61d391b7057faa$var$LazyServiceNowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8760j")).then((m)=>m.ServiceNowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/servicenow/search-result-icon'
});
const $ef61d391b7057faa$export$829928eabc615ce1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef61d391b7057faa$var$LazyServiceNowIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef61d391b7057faa$var$LazyServiceNowIconComponent, null));
const $ef61d391b7057faa$export$4b2cdd8d303d18d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef61d391b7057faa$var$LazyServiceNowSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef61d391b7057faa$var$LazyServiceNowSearchResultIconComponent, null));
module.exports["ServiceNowIcon"] = $ef61d391b7057faa$export$829928eabc615ce1;
module.exports["ServiceNowSearchResultIcon"] = $ef61d391b7057faa$export$4b2cdd8d303d18d0;

});

parcelRegister("8760j", function(module, exports) {

let $5e83a277194a08ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e83a277194a08ff$var$load("6vNYv").then(()=>parcelRequire('3QvRx'));

});

parcelRegister("fA9zj", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ldmHj = parcelRequire("ldmHj");

const $95e57b030e0f8dca$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceIcon), 'Freshservice', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Freshservice,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceSearchResultIcon), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["freshserviceConfig"] = $95e57b030e0f8dca$export$8120804698f632ae;

});

parcelRegister("ldmHj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $45beef96d43b57ec$var$LazyFreshserviceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/icon'
});

const $45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/search-result-icon'
});
const $45beef96d43b57ec$export$327de5bc0476c8b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceIconComponent, null));
const $45beef96d43b57ec$export$afb7a1d2b1e9186c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent, null));
module.exports["FreshserviceIcon"] = $45beef96d43b57ec$export$327de5bc0476c8b8;
module.exports["FreshserviceSearchResultIcon"] = $45beef96d43b57ec$export$afb7a1d2b1e9186c;

});

parcelRegister("jwajS", function(module, exports) {

let $e35902b647be50d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e35902b647be50d9$var$load("cgVYM").then(()=>parcelRequire('byKTU'));

});

parcelRegister("iTxTm", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jHpbI = parcelRequire("jHpbI");

const $fe7cdbf0eb82d212$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PowerBI,
    icon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIcon), 'PowerBI', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIconBorderless), 'PowerBI', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBISearchResultIcon), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["powerBIConfig"] = $fe7cdbf0eb82d212$export$b883b80d867cc715;

});

parcelRegister("jHpbI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b89a7a27b28a6f7f$var$LazyPowerBIIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBISearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless'
});
const $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconComponent, null));
const $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent, null));
const $b89a7a27b28a6f7f$export$77c3c6e8d16b3669 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent, null));
module.exports["PowerBIIcon"] = $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7;
module.exports["PowerBISearchResultIcon"] = $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09;
module.exports["PowerBIIconBorderless"] = $b89a7a27b28a6f7f$export$77c3c6e8d16b3669;

});

parcelRegister("gLSjb", function(module, exports) {

let $c35b29a88fc41c42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c35b29a88fc41c42$var$load("7yeiN").then(()=>parcelRequire('7NK6P'));

});

parcelRegister("5pWqV", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iq3xJ = parcelRequire("iq3xJ");

const $cec4d02f64d13f8c$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ClickUp,
    icon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIcon), 'ClickUp', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIconBorderless), 'ClickUp', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpSearchResultIcon), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["clickUpConfig"] = $cec4d02f64d13f8c$export$7ef79ba9bf00ce19;

});

parcelRegister("iq3xJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $530f12575ecdabb5$var$LazyClickUpIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon'
});

const $530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/search-result-icon'
});

const $530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon-borderless'
});
const $530f12575ecdabb5$export$592b235c95c5fb2b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconComponent, null));
const $530f12575ecdabb5$export$7ca2508a62493599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent, null));
const $530f12575ecdabb5$export$d29fdfa1300ec8ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent, null));
module.exports["ClickUpIcon"] = $530f12575ecdabb5$export$592b235c95c5fb2b;
module.exports["ClickUpSearchResultIcon"] = $530f12575ecdabb5$export$7ca2508a62493599;
module.exports["ClickUpIconBorderless"] = $530f12575ecdabb5$export$d29fdfa1300ec8ae;

});

parcelRegister("eZzOO", function(module, exports) {

let $aea28c0308a21713$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aea28c0308a21713$var$load("Wo3LI").then(()=>parcelRequire('aFqIo'));

});

parcelRegister("juuLe", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8DGA8 = parcelRequire("8DGA8");

const $bf887cabcde61381$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Amplitude,
    icon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeIcon), 'Amplitude', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeSearchResultIcon), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["amplitudeConfig"] = $bf887cabcde61381$export$a0702b571a9392d4;

});

parcelRegister("8DGA8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $1c1e864948fda48c$var$LazyAmplitudeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/icon'
});

const $1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/search-result-icon'
});
const $1c1e864948fda48c$export$5e013c7991ef7bd0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeIconComponent, null));
const $1c1e864948fda48c$export$49b3130ea0e9d6dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent, null));
module.exports["AmplitudeIcon"] = $1c1e864948fda48c$export$5e013c7991ef7bd0;
module.exports["AmplitudeSearchResultIcon"] = $1c1e864948fda48c$export$49b3130ea0e9d6dd;

});

parcelRegister("1Lj2x", function(module, exports) {

let $1488f32e8fa7fe12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1488f32e8fa7fe12$var$load("aHKXM").then(()=>parcelRequire('7uWoZ'));

});

parcelRegister("3juV6", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9PLia = parcelRequire("9PLia");

const $92674268e4049146$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Stripe,
    icon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeIcon), 'Stripe', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeSearchResultIcon), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["stripeConfig"] = $92674268e4049146$export$3be693d67bbce82;

});

parcelRegister("9PLia", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $33b6aea29cf3117b$var$LazyStripeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/icon'
});

const $33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/search-result-icon'
});
const $33b6aea29cf3117b$export$86ab8f6f2448222e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeIconComponent, null));
const $33b6aea29cf3117b$export$efbbc3acb0731d93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent, null));
module.exports["StripeIcon"] = $33b6aea29cf3117b$export$86ab8f6f2448222e;
module.exports["StripeSearchResultIcon"] = $33b6aea29cf3117b$export$efbbc3acb0731d93;

});

parcelRegister("cp8O6", function(module, exports) {

let $907ea6b91679f987$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $907ea6b91679f987$var$load("12xPP").then(()=>parcelRequire('5eELb'));

});

parcelRegister("hIDj1", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $01lrE = parcelRequire("01lrE");

const $9077aa6f5e17fbbd$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeXD,
    icon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDIcon), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDSearchResultIcon), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeXDConfig"] = $9077aa6f5e17fbbd$export$e69f90b2aa757835;

});

parcelRegister("01lrE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $9542dedcb7e547d5$var$LazyAdobeXDIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon'
});

const $9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon'
});
const $9542dedcb7e547d5$export$be8cba599441db6e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDIconComponent, null));
const $9542dedcb7e547d5$export$145a936ff16d9011 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent, null));
module.exports["AdobeXDIcon"] = $9542dedcb7e547d5$export$be8cba599441db6e;
module.exports["AdobeXDSearchResultIcon"] = $9542dedcb7e547d5$export$145a936ff16d9011;

});

parcelRegister("6qisw", function(module, exports) {

let $4ad37d5fd1b448bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ad37d5fd1b448bd$var$load("jIck0").then(()=>parcelRequire('1M0ll'));

});

parcelRegister("7WW80", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9DXSY = parcelRequire("9DXSY");

const $c8bb031355bf837b$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Aha,
    icon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaIcon), 'Aha', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaSearchResultIcon), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["ahaConfig"] = $c8bb031355bf837b$export$ad976bfe08240460;

});

parcelRegister("9DXSY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2d91c1380dbfeb61$var$LazyAhaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/icon'
});

const $2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon'
});
const $2d91c1380dbfeb61$export$f28fe6c5ebff8c30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaIconComponent, null));
const $2d91c1380dbfeb61$export$7dd76757b7d2d978 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent, null));
module.exports["AhaIcon"] = $2d91c1380dbfeb61$export$f28fe6c5ebff8c30;
module.exports["AhaSearchResultIcon"] = $2d91c1380dbfeb61$export$7dd76757b7d2d978;

});

parcelRegister("eC0Ay", function(module, exports) {

let $aa35122a7f0ad582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa35122a7f0ad582$var$load("crPYr").then(()=>parcelRequire('52Csx'));

});

parcelRegister("au9jr", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $exlh6 = parcelRequire("exlh6");

const $5a9c1a558ebaa3a8$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeSign,
    icon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignIcon), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignSearchResultIcon), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeSignConfig"] = $5a9c1a558ebaa3a8$export$8130889f372e8ca5;

});

parcelRegister("exlh6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $0790bbd11d84640d$var$LazyAdobeSignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/icon'
});

const $0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/search-result-icon'
});
const $0790bbd11d84640d$export$600af2172b0f5fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
const $0790bbd11d84640d$export$9efd1df023dc9339 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
module.exports["AdobeSignIcon"] = $0790bbd11d84640d$export$600af2172b0f5fb;
module.exports["AdobeSignSearchResultIcon"] = $0790bbd11d84640d$export$9efd1df023dc9339;

});

parcelRegister("71Q5J", function(module, exports) {

let $51e108abf4f92495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51e108abf4f92495$var$load("6hjEN").then(()=>parcelRequire('8lSkY'));

});

parcelRegister("diJOH", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fgzey = parcelRequire("fgzey");

const $4cab0849efa124dd$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Mural,
    icon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIcon), 'Mural', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIconBorderless), 'Mural', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralSearchResultIcon), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["muralConfig"] = $4cab0849efa124dd$export$8855f5ba0dd32fb9;

});

parcelRegister("fgzey", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $a97a3de67fb67ec6$var$LazyMuralIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon'
});

const $a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/search-result-icon'
});

const $a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon-borderless'
});
const $a97a3de67fb67ec6$export$807a21e0dcf114c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconComponent, null));
const $a97a3de67fb67ec6$export$930cc976c0fd31d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent, null));
const $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent, null));
module.exports["MuralIcon"] = $a97a3de67fb67ec6$export$807a21e0dcf114c4;
module.exports["MuralSearchResultIcon"] = $a97a3de67fb67ec6$export$930cc976c0fd31d6;
module.exports["MuralIconBorderless"] = $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a;

});

parcelRegister("fR633", function(module, exports) {

let $b8b07f4942fa03b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8b07f4942fa03b7$var$load("hZppl").then(()=>parcelRequire('9pV7D'));

});

parcelRegister("5bQLl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9tcvD = parcelRequire("9tcvD");

const $1ec69a9c30a99d71$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Webex,
    icon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIcon), 'Webex', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIconBorderless), 'Webex', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexSearchResultIcon), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["webexConfig"] = $1ec69a9c30a99d71$export$57d2eef9725d4993;

});

parcelRegister("9tcvD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $df7a27f90b6b2c5e$var$LazyWebexIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/search-result-icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon-borderless'
});
const $df7a27f90b6b2c5e$export$4079343fb47e7f0d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconComponent, null));
const $df7a27f90b6b2c5e$export$37506c98e5c4eabb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent, null));
const $df7a27f90b6b2c5e$export$92866e6fe777cbf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent, null));
module.exports["WebexIcon"] = $df7a27f90b6b2c5e$export$4079343fb47e7f0d;
module.exports["WebexSearchResultIcon"] = $df7a27f90b6b2c5e$export$37506c98e5c4eabb;
module.exports["WebexIconBorderless"] = $df7a27f90b6b2c5e$export$92866e6fe777cbf9;

});

parcelRegister("lSDFq", function(module, exports) {

let $fedd6930306be96d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fedd6930306be96d$var$load("cbO8L").then(()=>parcelRequire('4o0Z8'));

});

parcelRegister("dVIA3", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $566qE = parcelRequire("566qE");

const $f809cfee2fd3adf4$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Todoist,
    icon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistIcon), 'Todoist', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistSearchResultIcon), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["todoistConfig"] = $f809cfee2fd3adf4$export$2ece5664272d405b;

});

parcelRegister("566qE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $7f696030f35b1bfe$var$LazyTodoistIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/icon'
});

const $7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/search-result-icon'
});
const $7f696030f35b1bfe$export$e5f255e151507cba = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistIconComponent, null));
const $7f696030f35b1bfe$export$c7baa9df7dbe4b13 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent, null));
module.exports["TodoistIcon"] = $7f696030f35b1bfe$export$e5f255e151507cba;
module.exports["TodoistSearchResultIcon"] = $7f696030f35b1bfe$export$c7baa9df7dbe4b13;

});

parcelRegister("7r1J2", function(module, exports) {

let $569c64a902747f35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $569c64a902747f35$var$load("kriZK").then(()=>parcelRequire('bkDWX'));

});

parcelRegister("emznk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cgpdn = parcelRequire("cgpdn");

const $aedb00e010a8a347$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PagerDuty,
    icon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutyIcon), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutySearchResultIcon), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pagerDutyConfig"] = $aedb00e010a8a347$export$cc8a555111f14137;

});

parcelRegister("cgpdn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $82cf772d0622b4e8$var$LazyPagerDutyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon'
});

const $82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon'
});
const $82cf772d0622b4e8$export$e9a3fd43f9d4bddc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutyIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutyIconComponent, null));
const $82cf772d0622b4e8$export$494d5ec19d75a736 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent, null));
module.exports["PagerDutyIcon"] = $82cf772d0622b4e8$export$e9a3fd43f9d4bddc;
module.exports["PagerDutySearchResultIcon"] = $82cf772d0622b4e8$export$494d5ec19d75a736;

});

parcelRegister("bUXcS", function(module, exports) {

let $8ad2d9e55360e7ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ad2d9e55360e7ef$var$load("i66KR").then(()=>parcelRequire('BKXay'));

});

parcelRegister("fMCQp", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4dY8b = parcelRequire("4dY8b");

const $3e19c412c5468840$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Pipedrive,
    icon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveIcon), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveSearchResultIcon), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pipedriveConfig"] = $3e19c412c5468840$export$9441b0ee1f92e710;

});

parcelRegister("4dY8b", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $37fe8e692e6a8fbb$var$LazyPipedriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/icon'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/search-result-icon'
});
const $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveIconComponent, null));
const $37fe8e692e6a8fbb$export$18970dea61783916 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent, null));
module.exports["PipedriveIcon"] = $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1;
module.exports["PipedriveSearchResultIcon"] = $37fe8e692e6a8fbb$export$18970dea61783916;

});

parcelRegister("1NJ45", function(module, exports) {

let $14fd53058867bdc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14fd53058867bdc5$var$load("1Vgyr").then(()=>parcelRequire('7n163'));

});

parcelRegister("cdiu6", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $i3YNQ = parcelRequire("i3YNQ");

const $cc73151629925938$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Hubspot,
    icon: (0, $i52Hf.get3PLogo)((0, $i3YNQ.HubSpotFilterIcon), 'HubSpot', 'medium'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromGlyph)((0, $i3YNQ.HubSpotIcon), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["hubSpotConfig"] = $cc73151629925938$export$ba5f4c654d743419;

});

parcelRegister("i3YNQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2057a2845d392fbb$var$LazyHubSpotFilterIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotFilterIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/icon'
});

const $2057a2845d392fbb$var$LazyHubSpotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/search-result-icon'
});
const $2057a2845d392fbb$export$bee6964e6c60da93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotFilterIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotFilterIconComponent, null));
const $2057a2845d392fbb$export$c9a6a66ee7acc43a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotIconComponent, null));
module.exports["HubSpotFilterIcon"] = $2057a2845d392fbb$export$bee6964e6c60da93;
module.exports["HubSpotIcon"] = $2057a2845d392fbb$export$c9a6a66ee7acc43a;

});

parcelRegister("iQk0M", function(module, exports) {

let $db7c9b3ae5d37f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db7c9b3ae5d37f01$var$load("jjiWX").then(()=>parcelRequire('7iwl3'));

});

parcelRegister("8djpu", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1IKTt = parcelRequire("1IKTt");

const $a36ea8dac5de07a0$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dovetail,
    icon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailIcon), 'Dovetail', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailSearchResultIcon), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dovetailConfig"] = $a36ea8dac5de07a0$export$74bb7abed969b4a3;

});

parcelRegister("1IKTt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2f56e48e9ad9c3ed$var$LazyDovetailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/icon'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/search-result-icon'
});
const $2f56e48e9ad9c3ed$export$e67ec9178da81ba8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailIconComponent, null));
const $2f56e48e9ad9c3ed$export$ba101884e6c20332 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent, null));
module.exports["DovetailIcon"] = $2f56e48e9ad9c3ed$export$e67ec9178da81ba8;
module.exports["DovetailSearchResultIcon"] = $2f56e48e9ad9c3ed$export$ba101884e6c20332;

});

parcelRegister("1agKU", function(module, exports) {

let $0d93b8f44ef4ee77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d93b8f44ef4ee77$var$load("lX1Po").then(()=>parcelRequire('2C7nj'));

});

parcelRegister("3P9fk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cGNUU = parcelRequire("cGNUU");

const $c668170e147f45a4$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
    icon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklyIcon), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklySearchResultIcon), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["launchDarklyConfig"] = $c668170e147f45a4$export$e45ddd51efe4cb0c;

});

parcelRegister("cGNUU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ef4ce76b17680270$var$LazyLaunchDarklyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/icon'
});

const $ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/search-result-icon'
});
const $ef4ce76b17680270$export$68470e68dec0bc46 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklyIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklyIconComponent, null));
const $ef4ce76b17680270$export$66f000bb4bcf5fcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent, null));
module.exports["LaunchDarklyIcon"] = $ef4ce76b17680270$export$68470e68dec0bc46;
module.exports["LaunchDarklySearchResultIcon"] = $ef4ce76b17680270$export$66f000bb4bcf5fcd;

});

parcelRegister("ezxxX", function(module, exports) {

let $a9be5b4384d2d964$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9be5b4384d2d964$var$load("fK6ul").then(()=>parcelRequire('26kgz'));

});

parcelRegister("lPRuX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $f3t7x = parcelRequire("f3t7x");


var $l2DTy = parcelRequire("l2DTy");


var $kxWyf = parcelRequire("kxWyf");


var $5ET0n = parcelRequire("5ET0n");


var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $dAioJ = parcelRequire("dAioJ");


var $958CL = parcelRequire("958CL");


var $kFLxH = parcelRequire("kFLxH");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cP5WD = parcelRequire("cP5WD");

const $6d43d8ef7378751b$var$getSalesforce3PTypeFilterConfig = ()=>{
    const config = new Map();
    // Entries are ordered alphabetically by display label.
    config.set((0, $5PPrc.TypeFilterValueKey).Campaign, {
        entities3P: [
            ...(0, $l2DTy.DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-case-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Case, {
        entities3P: [
            ...(0, $kxWyf.DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-calendar-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Calendar, {
        entities3P: [
            ...(0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).CustomerContact, {
        entities3P: [
            ...(0, $5ET0n.DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).CustomerOrg, {
        entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Deal, {
        entities3P: [
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
            ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Deal
        ]
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-document-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: [
            ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-lead-noun')) config.set((0, $5PPrc.TypeFilterValueKey).Lead, {
        entities3P: [
            ...(0, $958CL.DEFAULT_CLOUD_GRAPH_LEAD_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-work-item-noun')) config.set((0, $5PPrc.TypeFilterValueKey).WorkItem, {
        entities3P: [
            ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    return config;
};
const $6d43d8ef7378751b$export$68b7906270c63e2d = {
    displayName: 'Salesforce',
    id: 'salesforce',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Salesforce,
    icon: (0, $i52Hf.get3PLogo)((0, $cP5WD.SalesforceIcon), 'Salesforce', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cP5WD.SalesforceIconBorderless), 'Salesforce', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cP5WD.SalesforceSearchResultIcon), 'Salesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/salesforce',
    // Use getters to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    get typeFilterConfig () {
        return $6d43d8ef7378751b$var$getSalesforce3PTypeFilterConfig();
    },
    get filters () {
        const base = [
            'lastUpdated',
            'onlyTitleMatch',
            'lastUpdatedBy',
            'createdBy',
            'owner',
            'opportunityStatus',
            'closeDate'
        ];
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter') || (0, $iDrrr.fg)('rovo-studio-3p-ux-salesforce-dynamic-stage-filter')) base.push('salesforceStage');
        base.push('campaignStatus');
        base.push('caseStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-document-status-filter')) base.push('documentStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-calendar-type-filter')) base.push('calendarType');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-sf-lead-status-filter')) base.push('leadStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-task-status-filter')) base.push('taskStatus');
        if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-task-type-filter')) base.push('taskType');
        return base;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["salesforceConfig"] = $6d43d8ef7378751b$export$68b7906270c63e2d;

});

parcelRegister("958CL", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $33c1f01c191ac084$export$485669874d5d2ec4 = [
    'ati:cloud:graph:lead'
];
module.exports["DEFAULT_CLOUD_GRAPH_LEAD_ENTITY_ATI"] = $33c1f01c191ac084$export$485669874d5d2ec4;

});

parcelRegister("cP5WD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $099630e1101e7950$var$LazySalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7QiUr")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/salesforce/icon'
});

const $099630e1101e7950$var$LazySalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7QiUr")).then((m)=>m.SalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/salesforce/search-result-icon'
});

const $099630e1101e7950$var$LazySalesforceIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7QiUr")).then((m)=>m.SalesforceIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/salesforce/icon-borderless'
});
const $099630e1101e7950$export$89e1f2a7c57f2a4d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceIconComponent, null));
const $099630e1101e7950$export$1c85788b02a4bdef = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceSearchResultIconComponent, null));
const $099630e1101e7950$export$2ca8c87c1acb4a50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($099630e1101e7950$var$LazySalesforceIconBorderlessComponent, null));
module.exports["SalesforceIcon"] = $099630e1101e7950$export$89e1f2a7c57f2a4d;
module.exports["SalesforceSearchResultIcon"] = $099630e1101e7950$export$1c85788b02a4bdef;
module.exports["SalesforceIconBorderless"] = $099630e1101e7950$export$2ca8c87c1acb4a50;

});

parcelRegister("7QiUr", function(module, exports) {

let $5b5c0ebfe669333a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b5c0ebfe669333a$var$load("7YLBK").then(()=>parcelRequire('wQghi'));

});

parcelRegister("2zNcl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gZuUC = parcelRequire("gZuUC");

const $b44f335e0add65f2$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sentry,
    icon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentryIcon), 'Sentry', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentrySearchResultIcon), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sentryConfig"] = $b44f335e0add65f2$export$6c52693ff10aea16;

});

parcelRegister("gZuUC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2e1e358b3dafc32e$var$LazySentryIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/icon'
});

const $2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentrySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/search-result-icon'
});
const $2e1e358b3dafc32e$export$ddeafef64c08610e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentryIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentryIconComponent, null));
const $2e1e358b3dafc32e$export$18b7ca5aa35613ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent, null));
module.exports["SentryIcon"] = $2e1e358b3dafc32e$export$ddeafef64c08610e;
module.exports["SentrySearchResultIcon"] = $2e1e358b3dafc32e$export$18b7ca5aa35613ec;

});

parcelRegister("5Kyst", function(module, exports) {

let $42fbfa53463ffb37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42fbfa53463ffb37$var$load("2wWLi").then(()=>parcelRequire('8cuRQ'));

});

parcelRegister("h8Js2", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iS3Tu = parcelRequire("iS3Tu");

const $1575c63b0570ab84$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $iS3Tu.GitbookIcon), 'GitBook'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitbook,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iS3Tu.GitbookSearchResultIcon), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>true
};
module.exports["gitbookConfig"] = $1575c63b0570ab84$export$49c4b548f63d5a90;

});

parcelRegister("9Om9G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8dCVx = parcelRequire("8dCVx");

const $e51655ee0504dbb7$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $8dCVx.AWSS3Icon), 'Amazon Web Services S3'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).AWSS3,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8dCVx.AWSS3SearchResultIcon), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};
module.exports["awss3Config"] = $e51655ee0504dbb7$export$7a257877f5f8c5de;

});

parcelRegister("8dCVx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3Icon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/icon'
});

const $8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3SearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/search-result-icon'
});
const $8d6fe8b599ff2fd4$export$abf71a44e930800c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
const $8d6fe8b599ff2fd4$export$30c777236008d219 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
module.exports["AWSS3Icon"] = $8d6fe8b599ff2fd4$export$abf71a44e930800c;
module.exports["AWSS3SearchResultIcon"] = $8d6fe8b599ff2fd4$export$30c777236008d219;

});

parcelRegister("lyZyY", function(module, exports) {

let $fb2c871e4dc34770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb2c871e4dc34770$var$load("dy0Fn").then(()=>parcelRequire('2tcCJ'));

});

parcelRegister("kiNtZ", function(module, exports) {

var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4mBqr = parcelRequire("4mBqr");

const $436740c22c009a9f$export$a9b5a82aefd10fde = {
    displayName: 'Databricks',
    id: 'databricks',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Databricks,
    icon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksIcon), 'Databricks', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksSearchResultIcon), 'Databricks', 'large'),
    integrationAri: 'ari:cloud:platform::integration/databricks',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["databricksConfig"] = $436740c22c009a9f$export$a9b5a82aefd10fde;

});

parcelRegister("4mBqr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $4005a63328b92542$var$LazyDatabricksIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/icon'
});

const $4005a63328b92542$var$LazyDatabricksSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/search-result-icon'
});
const $4005a63328b92542$export$d86876f5e6aac5e0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksIconComponent, null));
const $4005a63328b92542$export$efd3770b613bb37b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksSearchResultIconComponent, null));
module.exports["DatabricksIcon"] = $4005a63328b92542$export$d86876f5e6aac5e0;
module.exports["DatabricksSearchResultIcon"] = $4005a63328b92542$export$efd3770b613bb37b;

});

parcelRegister("aug3w", function(module, exports) {

let $7a292913e24060be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a292913e24060be$var$load("cSRnY").then(()=>parcelRequire('8CpxA'));

});

parcelRegister("1RpaO", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bcqy7 = parcelRequire("bcqy7");

const $2080cd553843d21e$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $2080cd553843d21e$export$208b563484d68ba9;

});

parcelRegister("bcqy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/icon'
});

const $93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/search-result-icon'
});
const $93f1018b38c58e9f$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
const $93f1018b38c58e9f$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $93f1018b38c58e9f$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $93f1018b38c58e9f$export$bd28886795da63ae;

});

parcelRegister("bVu7g", function(module, exports) {

let $8aec6105bf7a443e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8aec6105bf7a443e$var$load("ePl2b").then(()=>parcelRequire('kel29'));

});

parcelRegister("jENKA", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eRwR0 = parcelRequire("eRwR0");

const $939217ca713606ec$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
    icon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $939217ca713606ec$export$208b563484d68ba9;

});

parcelRegister("eRwR0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/icon'
});

const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/search-result-icon'
});
const $ecc3a7c114d137a3$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
const $ecc3a7c114d137a3$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $ecc3a7c114d137a3$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $ecc3a7c114d137a3$export$bd28886795da63ae;

});

parcelRegister("4m2wQ", function(module, exports) {

let $32bb2da49487064c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32bb2da49487064c$var$load("5bnED").then(()=>parcelRequire('gKTnp'));

});

parcelRegister("j34lg", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $hareu = parcelRequire("hareu");


var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g3p3u = parcelRequire("g3p3u");

const $6b1eab62b600e75b$export$6bbd9bc3bcb111b9 = {
    displayName: 'Scroll Sites by k15t',
    id: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesDev,
    icon: (0, $i52Hf.get3PLogo)((0, $g3p3u.ForgeK15tScrollSitesIcon), 'ForgeK15tScrollSites', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g3p3u.ForgeK15tScrollSitesSearchResultIcon), 'ForgeK15tScrollSites', 'large'),
    integrationAri: 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeK15tScrollSitesConfig"] = $6b1eab62b600e75b$export$6bbd9bc3bcb111b9;

});

parcelRegister("g3p3u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $330263601da56d87$var$LazyForgeK15tScrollSitesIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("b59ND")).then((m)=>m.ForgeK15tScrollSitesIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-dev/icon'
});

const $330263601da56d87$var$LazyForgeK15tScrollSitesSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("b59ND")).then((m)=>m.ForgeK15tScrollSitesSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-dev/search-result-icon'
});
const $330263601da56d87$export$317be388f2737846 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesIconComponent, null));
const $330263601da56d87$export$62ea9658fc6624da = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($330263601da56d87$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
module.exports["ForgeK15tScrollSitesIcon"] = $330263601da56d87$export$317be388f2737846;
module.exports["ForgeK15tScrollSitesSearchResultIcon"] = $330263601da56d87$export$62ea9658fc6624da;

});

parcelRegister("b59ND", function(module, exports) {

let $8117c359d2039e56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8117c359d2039e56$var$load("5tOei").then(()=>parcelRequire('aplI2'));

});

parcelRegister("in2Pi", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $hareu = parcelRequire("hareu");


var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g149F = parcelRequire("g149F");

const $7ddf546c1d92443d$export$6bbd9bc3bcb111b9 = {
    displayName: 'Scroll Sites by k15t',
    id: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesProd,
    icon: (0, $i52Hf.get3PLogo)((0, $g149F.ForgeK15tScrollSitesIcon), 'ForgeK15tScrollSites', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g149F.ForgeK15tScrollSitesSearchResultIcon), 'ForgeK15tScrollSites', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeK15tScrollSitesConfig"] = $7ddf546c1d92443d$export$6bbd9bc3bcb111b9;

});

parcelRegister("g149F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $caff09bd80328dee$var$LazyForgeK15tScrollSitesIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1jv7r")).then((m)=>m.ForgeK15tScrollSitesIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-prod/icon'
});

const $caff09bd80328dee$var$LazyForgeK15tScrollSitesSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1jv7r")).then((m)=>m.ForgeK15tScrollSitesSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-prod/search-result-icon'
});
const $caff09bd80328dee$export$317be388f2737846 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesIconComponent, null));
const $caff09bd80328dee$export$62ea9658fc6624da = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($caff09bd80328dee$var$LazyForgeK15tScrollSitesSearchResultIconComponent, null));
module.exports["ForgeK15tScrollSitesIcon"] = $caff09bd80328dee$export$317be388f2737846;
module.exports["ForgeK15tScrollSitesSearchResultIcon"] = $caff09bd80328dee$export$62ea9658fc6624da;

});

parcelRegister("1jv7r", function(module, exports) {

let $0f4fb463401f7949$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f4fb463401f7949$var$load("9U12B").then(()=>parcelRequire('5Wybx'));

});

parcelRegister("7vbr8", function(module, exports) {

var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lJJFS = parcelRequire("lJJFS");

const $565f36f2f1b6aee9$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioAwsDev,
    icon: (0, $i52Hf.get3PLogo)((0, $lJJFS.ForgePioAwsIcon), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lJJFS.ForgePioAwsSearchResultIcon), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioAwsConfig"] = $565f36f2f1b6aee9$export$7fa480c37589b20;

});

parcelRegister("lJJFS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $bd58b69f4ea0aad2$var$LazyForgePioAwsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aUJpv")).then((m)=>m.ForgePioAwsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-dev/icon'
});

const $bd58b69f4ea0aad2$var$LazyForgePioAwsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aUJpv")).then((m)=>m.ForgePioAwsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-dev/search-result-icon'
});
const $bd58b69f4ea0aad2$export$9a2f1d62325d249c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsIconComponent, null));
const $bd58b69f4ea0aad2$export$e391bf4e4f614708 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd58b69f4ea0aad2$var$LazyForgePioAwsSearchResultIconComponent, null));
module.exports["ForgePioAwsIcon"] = $bd58b69f4ea0aad2$export$9a2f1d62325d249c;
module.exports["ForgePioAwsSearchResultIcon"] = $bd58b69f4ea0aad2$export$e391bf4e4f614708;

});

parcelRegister("aUJpv", function(module, exports) {

let $7f225be650ed44b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f225be650ed44b9$var$load("dL9uw").then(()=>parcelRequire('caQhm'));

});

parcelRegister("k6vRK", function(module, exports) {

var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9Vl84 = parcelRequire("9Vl84");

const $54f0d63711890722$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioAwsProd,
    icon: (0, $i52Hf.get3PLogo)((0, $9Vl84.ForgePioAwsIcon), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9Vl84.ForgePioAwsSearchResultIcon), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioAwsConfig"] = $54f0d63711890722$export$7fa480c37589b20;

});

parcelRegister("9Vl84", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6e9f77e13cf7efa7$var$LazyForgePioAwsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8Mcta")).then((m)=>m.ForgePioAwsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-prod/icon'
});

const $6e9f77e13cf7efa7$var$LazyForgePioAwsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8Mcta")).then((m)=>m.ForgePioAwsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-prod/search-result-icon'
});
const $6e9f77e13cf7efa7$export$9a2f1d62325d249c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsIconComponent, null));
const $6e9f77e13cf7efa7$export$e391bf4e4f614708 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e9f77e13cf7efa7$var$LazyForgePioAwsSearchResultIconComponent, null));
module.exports["ForgePioAwsIcon"] = $6e9f77e13cf7efa7$export$9a2f1d62325d249c;
module.exports["ForgePioAwsSearchResultIcon"] = $6e9f77e13cf7efa7$export$e391bf4e4f614708;

});

parcelRegister("8Mcta", function(module, exports) {

let $663c7a941f8801fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $663c7a941f8801fe$var$load("hvaIm").then(()=>parcelRequire('esn4d'));

});

parcelRegister("aiL8h", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8xRaD = parcelRequire("8xRaD");

const $3bed2460a9ac74a9$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
    icon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $3bed2460a9ac74a9$export$1e9db6975f6a70ae;

});

parcelRegister("8xRaD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $90c5d9d93ae12793$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/icon'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/search-result-icon'
});
const $90c5d9d93ae12793$export$836fbefaf37221f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupIconComponent, null));
const $90c5d9d93ae12793$export$83043b67e00ef5ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent, null));
module.exports["ForgePioClickupIcon"] = $90c5d9d93ae12793$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $90c5d9d93ae12793$export$83043b67e00ef5ec;

});

parcelRegister("cIrR2", function(module, exports) {

let $941f336918174642$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $941f336918174642$var$load("8s0tV").then(()=>parcelRequire('8nxWD'));

});

parcelRegister("cY0ZT", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8IQya = parcelRequire("8IQya");

const $5d6955193314318a$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
    icon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $5d6955193314318a$export$1e9db6975f6a70ae;

});

parcelRegister("8IQya", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/icon'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/search-result-icon'
});
const $87a1e5b2c35074ff$export$836fbefaf37221f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent, null));
const $87a1e5b2c35074ff$export$83043b67e00ef5ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent, null));
module.exports["ForgePioClickupIcon"] = $87a1e5b2c35074ff$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $87a1e5b2c35074ff$export$83043b67e00ef5ec;

});

parcelRegister("181bf", function(module, exports) {

let $0d2774388cdc3227$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d2774388cdc3227$var$load("fHbPr").then(()=>parcelRequire('lbEqU'));

});

parcelRegister("9SYma", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $luC3K = parcelRequire("luC3K");

const $30c6c0a5f88da5cd$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $30c6c0a5f88da5cd$export$a10b5ae888bd2541;

});

parcelRegister("luC3K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/icon'
});

const $ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/search-result-icon'
});
const $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
const $ff3e09ebc7d38a88$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $ff3e09ebc7d38a88$export$6de477beffd11496;

});

parcelRegister("eaLXQ", function(module, exports) {

let $a517348cc13b5415$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a517348cc13b5415$var$load("doxhZ").then(()=>parcelRequire('5yzek'));

});

parcelRegister("ie06K", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $hqQhc = parcelRequire("hqQhc");

const $7e16e25b4d6e9ae6$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $7e16e25b4d6e9ae6$export$a10b5ae888bd2541;

});

parcelRegister("hqQhc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f7c3187305b5af82$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/icon'
});

const $f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/search-result-icon'
});
const $f7c3187305b5af82$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
const $f7c3187305b5af82$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $f7c3187305b5af82$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $f7c3187305b5af82$export$6de477beffd11496;

});

parcelRegister("cxRlS", function(module, exports) {

let $9221f3aa58abeaa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9221f3aa58abeaa8$var$load("f79rV").then(()=>parcelRequire('jAHFR'));

});

parcelRegister("h5NUz", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4moZS = parcelRequire("4moZS");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bMpOM = parcelRequire("bMpOM");

const $b38ab40b92cfb88e$export$dd7854123286bd26 = {
    displayName: 'Github by Pio',
    id: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGithubDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bMpOM.ForgePioGithubIcon), 'ForgePioGithub', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bMpOM.ForgePioGithubSearchResultIcon), 'ForgePioGithub', 'large'),
    integrationAri: 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'pullRequestStatus'
        ];
        if ((0, $iDrrr.fg)('rovo_fps_show_repository_filter')) baseFilters.push('repository');
        if ((0, $iDrrr.fg)('rovo_fps_show_github_created_by_filter')) baseFilters.push('createdBy');
        if ((0, $iDrrr.fg)('rovo_fps_show_reviewer_filter')) baseFilters.push('reviewer');
        if ((0, $iDrrr.fg)('rovo_fps_show_github_assignee_filter')) baseFilters.push('assignee');
        return baseFilters;
    },
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGithubConfig"] = $b38ab40b92cfb88e$export$dd7854123286bd26;

});

parcelRegister("bMpOM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $7dcd77abcb76f468$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxyY4")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-dev/icon'
});

const $7dcd77abcb76f468$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxyY4")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-dev/search-result-icon'
});
const $7dcd77abcb76f468$export$f1d7e8d930f0538e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dcd77abcb76f468$var$LazyForgePioGithubIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dcd77abcb76f468$var$LazyForgePioGithubIconComponent, null));
const $7dcd77abcb76f468$export$f318f463f9328f3f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dcd77abcb76f468$var$LazyForgePioGithubSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dcd77abcb76f468$var$LazyForgePioGithubSearchResultIconComponent, null));
module.exports["ForgePioGithubIcon"] = $7dcd77abcb76f468$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $7dcd77abcb76f468$export$f318f463f9328f3f;

});

parcelRegister("cxyY4", function(module, exports) {

let $9213b103faa763c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9213b103faa763c2$var$load("9DAHg").then(()=>parcelRequire('9qnlQ'));

});

parcelRegister("9Y160", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4moZS = parcelRequire("4moZS");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iPmoS = parcelRequire("iPmoS");

const $3fed812b1389566f$export$dd7854123286bd26 = {
    displayName: 'Github by Pio',
    id: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGithubProd,
    icon: (0, $i52Hf.get3PLogo)((0, $iPmoS.ForgePioGithubIcon), 'ForgePioGithub', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iPmoS.ForgePioGithubSearchResultIcon), 'ForgePioGithub', 'large'),
    integrationAri: 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'pullRequestStatus'
        ];
        if ((0, $iDrrr.fg)('rovo_fps_show_repository_filter')) baseFilters.push('repository');
        if ((0, $iDrrr.fg)('rovo_fps_show_github_created_by_filter')) baseFilters.push('createdBy');
        if ((0, $iDrrr.fg)('rovo_fps_show_reviewer_filter')) baseFilters.push('reviewer');
        if ((0, $iDrrr.fg)('rovo_fps_show_github_assignee_filter')) baseFilters.push('assignee');
        return baseFilters;
    },
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGithubConfig"] = $3fed812b1389566f$export$dd7854123286bd26;

});

parcelRegister("hdy05", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $aw1q4 = parcelRequire("aw1q4");

const $979771840684c647$export$8d71df70076b5c6 = {
    displayName: 'Gitlab by Pio',
    id: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabDev,
    icon: (0, $i52Hf.get3PLogo)((0, $aw1q4.ForgePioGitlabIcon), 'ForgePioGitlab', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $aw1q4.ForgePioGitlabSearchResultIcon), 'ForgePioGitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitlabConfig"] = $979771840684c647$export$8d71df70076b5c6;

});

parcelRegister("aw1q4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2fdf4191c525e5e6$var$LazyForgePioGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8GA7N")).then((m)=>m.ForgePioGitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-dev/icon'
});

const $2fdf4191c525e5e6$var$LazyForgePioGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8GA7N")).then((m)=>m.ForgePioGitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-dev/search-result-icon'
});
const $2fdf4191c525e5e6$export$ccbc2eb39f3b36a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fdf4191c525e5e6$var$LazyForgePioGitlabIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fdf4191c525e5e6$var$LazyForgePioGitlabIconComponent, null));
const $2fdf4191c525e5e6$export$31ecffbb988c6a26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fdf4191c525e5e6$var$LazyForgePioGitlabSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fdf4191c525e5e6$var$LazyForgePioGitlabSearchResultIconComponent, null));
module.exports["ForgePioGitlabIcon"] = $2fdf4191c525e5e6$export$ccbc2eb39f3b36a7;
module.exports["ForgePioGitlabSearchResultIcon"] = $2fdf4191c525e5e6$export$31ecffbb988c6a26;

});

parcelRegister("8GA7N", function(module, exports) {

let $652e4494ff028aea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $652e4494ff028aea$var$load("fKFEw").then(()=>parcelRequire('dmIao'));

});

parcelRegister("djF8v", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $dAioJ = parcelRequire("dAioJ");


var $kQMkl = parcelRequire("kQMkl");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5xmWb = parcelRequire("5xmWb");

const $39b78f0661ba6ff8$export$8d71df70076b5c6 = {
    displayName: 'Gitlab by Pio',
    id: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabProd,
    icon: (0, $i52Hf.get3PLogo)((0, $5xmWb.ForgePioGitlabIcon), 'ForgePioGitlab', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5xmWb.ForgePioGitlabSearchResultIcon), 'ForgePioGitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitlabConfig"] = $39b78f0661ba6ff8$export$8d71df70076b5c6;

});

parcelRegister("5xmWb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $23319306e79424e9$var$LazyForgePioGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("j5rao")).then((m)=>m.ForgePioGitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-prod/icon'
});

const $23319306e79424e9$var$LazyForgePioGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("j5rao")).then((m)=>m.ForgePioGitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-prod/search-result-icon'
});
const $23319306e79424e9$export$ccbc2eb39f3b36a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23319306e79424e9$var$LazyForgePioGitlabIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23319306e79424e9$var$LazyForgePioGitlabIconComponent, null));
const $23319306e79424e9$export$31ecffbb988c6a26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23319306e79424e9$var$LazyForgePioGitlabSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23319306e79424e9$var$LazyForgePioGitlabSearchResultIconComponent, null));
module.exports["ForgePioGitlabIcon"] = $23319306e79424e9$export$ccbc2eb39f3b36a7;
module.exports["ForgePioGitlabSearchResultIcon"] = $23319306e79424e9$export$31ecffbb988c6a26;

});

parcelRegister("j5rao", function(module, exports) {

let $de538eb1441efdcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de538eb1441efdcb$var$load("iVQaW").then(()=>parcelRequire('jPghV'));

});

parcelRegister("dChew", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5QuHV = parcelRequire("5QuHV");

const $e57423fd67cdd8c6$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $e57423fd67cdd8c6$export$7b3aebc675da1806;

});

parcelRegister("5QuHV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/icon'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/search-result-icon'
});
const $9b14ef24b242b0f5$export$a1f95679f652d1ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent, null));
const $9b14ef24b242b0f5$export$4bae7f77a341daa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
module.exports["ForgePioGoogleDriveIcon"] = $9b14ef24b242b0f5$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $9b14ef24b242b0f5$export$4bae7f77a341daa0;

});

parcelRegister("2dyBk", function(module, exports) {

let $19d7a2b45b018186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19d7a2b45b018186$var$load("eQyR8").then(()=>parcelRequire('65WlL'));

});

parcelRegister("TCovD", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $f0NBB = parcelRequire("f0NBB");

const $edc55c611b3bef54$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
    icon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $edc55c611b3bef54$export$7b3aebc675da1806;

});

parcelRegister("f0NBB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/icon'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/search-result-icon'
});
const $2a4f11fd35f1561d$export$a1f95679f652d1ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent, null));
const $2a4f11fd35f1561d$export$4bae7f77a341daa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
module.exports["ForgePioGoogleDriveIcon"] = $2a4f11fd35f1561d$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $2a4f11fd35f1561d$export$4bae7f77a341daa0;

});

parcelRegister("a07eA", function(module, exports) {

let $747f8411ae156579$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $747f8411ae156579$var$load("fPrZJ").then(()=>parcelRequire('foLez'));

});

parcelRegister("feDPe", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cDJLe = parcelRequire("cDJLe");

const $6d6cb4a42f1a5c65$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
    icon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $6d6cb4a42f1a5c65$export$528a99587bc9b40e;

});

parcelRegister("cDJLe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2920441e11b70cd2$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/icon'
});

const $2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/search-result-icon'
});
const $2920441e11b70cd2$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
const $2920441e11b70cd2$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $2920441e11b70cd2$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $2920441e11b70cd2$export$b49ff31395265951;

});

parcelRegister("hIbHQ", function(module, exports) {

let $ce4fa05b13629a64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce4fa05b13629a64$var$load("lxdqb").then(()=>parcelRequire('27bjo'));

});

parcelRegister("klS4t", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4tpeK = parcelRequire("4tpeK");

const $77afbf3b994cdec8$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
    icon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $77afbf3b994cdec8$export$528a99587bc9b40e;

});

parcelRegister("4tpeK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b236eb93e0f85320$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/icon'
});

const $b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/search-result-icon'
});
const $b236eb93e0f85320$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
const $b236eb93e0f85320$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $b236eb93e0f85320$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $b236eb93e0f85320$export$b49ff31395265951;

});

parcelRegister("hReiL", function(module, exports) {

let $d0027aea808a4c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0027aea808a4c93$var$load("l3yCu").then(()=>parcelRequire('5IaNj'));

});

parcelRegister("hFdyH", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9o5zM = parcelRequire("9o5zM");

const $d06de435425db1cd$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $d06de435425db1cd$export$a612366ee7742bc4;

});

parcelRegister("9o5zM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/icon'
});

const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/search-result-icon'
});
const $1a59bb9fa163a26b$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
const $1a59bb9fa163a26b$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $1a59bb9fa163a26b$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $1a59bb9fa163a26b$export$2782a2dcd42b923c;

});

parcelRegister("l85tV", function(module, exports) {

let $f61e98dabceec19b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f61e98dabceec19b$var$load("BZA59").then(()=>parcelRequire('lcok7'));

});

parcelRegister("e6TPF", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XLGG = parcelRequire("3XLGG");

const $ebd7c08029c46f92$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $ebd7c08029c46f92$export$a612366ee7742bc4;

});

parcelRegister("3XLGG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/icon'
});

const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/search-result-icon'
});
const $c3f8a80c4bf2155c$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
const $c3f8a80c4bf2155c$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $c3f8a80c4bf2155c$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $c3f8a80c4bf2155c$export$2782a2dcd42b923c;

});

parcelRegister("8ZtAm", function(module, exports) {

let $68baf8514ec615e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68baf8514ec615e9$var$load("89OPU").then(()=>parcelRequire('exmtD'));

});

parcelRegister("7piBv", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lHmnw = parcelRequire("lHmnw");

const $ff6b770550126248$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
    icon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $ff6b770550126248$export$2bb44bd2479444f9;

});

parcelRegister("lHmnw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/icon'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/search-result-icon'
});
const $ae4c750f6148d7b8$export$e87bb425fde16105 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent, null));
const $ae4c750f6148d7b8$export$cc1026e3c5b549e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent, null));
module.exports["ForgePioHubspotIcon"] = $ae4c750f6148d7b8$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $ae4c750f6148d7b8$export$cc1026e3c5b549e1;

});

parcelRegister("gDgqn", function(module, exports) {

let $c1bd0762a9485a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1bd0762a9485a15$var$load("12zSS").then(()=>parcelRequire('577rm'));

});

parcelRegister("3yXQ1", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dB1o2 = parcelRequire("dB1o2");

const $9438ce5263366d16$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $9438ce5263366d16$export$2bb44bd2479444f9;

});

parcelRegister("dB1o2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $138972da21ac7328$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/icon'
});

const $138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/search-result-icon'
});
const $138972da21ac7328$export$e87bb425fde16105 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotIconComponent, null));
const $138972da21ac7328$export$cc1026e3c5b549e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent, null));
module.exports["ForgePioHubspotIcon"] = $138972da21ac7328$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $138972da21ac7328$export$cc1026e3c5b549e1;

});

parcelRegister("23P54", function(module, exports) {

let $18037c2587a44799$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18037c2587a44799$var$load("6nOSk").then(()=>parcelRequire('5aOBD'));

});

parcelRegister("cmwLF", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5N1qm = parcelRequire("5N1qm");

const $86d0647c502027e9$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5N1qm.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5N1qm.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $86d0647c502027e9$export$6ab686f8808b6986;

});

parcelRegister("5N1qm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2795db874931a453$var$LazyForgePioSalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cXnTk")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/icon'
});

const $2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cXnTk")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/search-result-icon'
});
const $2795db874931a453$export$fd669dbaab8ebe1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceIconComponent, null));
const $2795db874931a453$export$ebba99402341b0c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent, null));
module.exports["ForgePioSalesforceIcon"] = $2795db874931a453$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $2795db874931a453$export$ebba99402341b0c4;

});

parcelRegister("cXnTk", function(module, exports) {

let $96ed870d8ca0e90e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96ed870d8ca0e90e$var$load("8FiJs").then(()=>parcelRequire('boSNc'));

});

parcelRegister("brRUk", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jW2EI = parcelRequire("jW2EI");

const $57c4a39dfa3b2602$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $jW2EI.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jW2EI.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $57c4a39dfa3b2602$export$6ab686f8808b6986;

});

parcelRegister("jW2EI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ad250f24924a2221$var$LazyForgePioSalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6D4bc")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/icon'
});

const $ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6D4bc")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/search-result-icon'
});
const $ad250f24924a2221$export$fd669dbaab8ebe1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceIconComponent, null));
const $ad250f24924a2221$export$ebba99402341b0c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent, null));
module.exports["ForgePioSalesforceIcon"] = $ad250f24924a2221$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $ad250f24924a2221$export$ebba99402341b0c4;

});

parcelRegister("6D4bc", function(module, exports) {

let $4d39a098c6f42bda$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d39a098c6f42bda$var$load("HN9Az").then(()=>parcelRequire('ezeQe'));

});

parcelRegister("dwyZc", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $7hXqS = parcelRequire("7hXqS");

const $d0c1882acaf8175d$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
    icon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $d0c1882acaf8175d$export$a62192356b6384ff;

});

parcelRegister("7hXqS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/icon'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/search-result-icon'
});
const $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent, null));
const $9b6113d0f81ce6d8$export$ff73eba88c3a5de7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent, null));
module.exports["ForgePioSharepointIcon"] = $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $9b6113d0f81ce6d8$export$ff73eba88c3a5de7;

});

parcelRegister("4NZXw", function(module, exports) {

let $37fbccc6b891f09a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37fbccc6b891f09a$var$load("jSUxV").then(()=>parcelRequire('l1iDy'));

});

parcelRegister("9sIt4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bE1lG = parcelRequire("bE1lG");

const $683bf0dbe93cd230$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
    icon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $683bf0dbe93cd230$export$a62192356b6384ff;

});

parcelRegister("bE1lG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b90524babf24a663$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/icon'
});

const $b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/search-result-icon'
});
const $b90524babf24a663$export$ecc35ba2a32c7e3f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointIconComponent, null));
const $b90524babf24a663$export$ff73eba88c3a5de7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent, null));
module.exports["ForgePioSharepointIcon"] = $b90524babf24a663$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $b90524babf24a663$export$ff73eba88c3a5de7;

});

parcelRegister("4OSjU", function(module, exports) {

let $3825f7c2c9b6438f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3825f7c2c9b6438f$var$load("dGvaI").then(()=>parcelRequire('53U7P'));

});

parcelRegister("7UyZr", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eLukX = parcelRequire("eLukX");

const $7b363fb97ca8421c$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
    icon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $7b363fb97ca8421c$export$cc9a98fbdf14b1ba;

});

parcelRegister("eLukX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $d275976379838dc2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/icon'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/search-result-icon'
});
const $d275976379838dc2$export$99bc27b78a6e71df = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowIconComponent, null));
const $d275976379838dc2$export$9a30339a9bdbd3d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
module.exports["ForgePioStackOverflowIcon"] = $d275976379838dc2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d275976379838dc2$export$9a30339a9bdbd3d6;

});

parcelRegister("kmocd", function(module, exports) {

let $ed28a18858f32988$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed28a18858f32988$var$load("fhGCt").then(()=>parcelRequire('cH70d'));

});

parcelRegister("2KPYZ", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dNyzf = parcelRequire("dNyzf");

const $406347052a44a9c5$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $406347052a44a9c5$export$cc9a98fbdf14b1ba;

});

parcelRegister("dNyzf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/icon'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/search-result-icon'
});
const $d7c3a178bcc55be2$export$99bc27b78a6e71df = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent, null));
const $d7c3a178bcc55be2$export$9a30339a9bdbd3d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
module.exports["ForgePioStackOverflowIcon"] = $d7c3a178bcc55be2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d7c3a178bcc55be2$export$9a30339a9bdbd3d6;

});

parcelRegister("2QdDM", function(module, exports) {

let $211b04dc028d7bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $211b04dc028d7bac$var$load("i47NY").then(()=>parcelRequire('7DqjS'));

});

parcelRegister("9lVxQ", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5vkE3 = parcelRequire("5vkE3");

const $3e70faad8a12b1e6$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $3e70faad8a12b1e6$export$1c8bdcf28097f33d;

});

parcelRegister("5vkE3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/icon'
});

const $d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/search-result-icon'
});
const $d8f18c592b583242$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
const $d8f18c592b583242$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $d8f18c592b583242$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $d8f18c592b583242$export$41e46c9b83e3cfe1;

});

parcelRegister("31MoW", function(module, exports) {

let $2347029a7fa3b936$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2347029a7fa3b936$var$load("5b0ls").then(()=>parcelRequire('krol2'));

});

parcelRegister("1HfnT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cRk65 = parcelRequire("cRk65");

const $86431f8286f0d68f$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $86431f8286f0d68f$export$1c8bdcf28097f33d;

});

parcelRegister("cRk65", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/icon'
});

const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/search-result-icon'
});
const $6130c3bf337d5909$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
const $6130c3bf337d5909$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $6130c3bf337d5909$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $6130c3bf337d5909$export$41e46c9b83e3cfe1;

});

parcelRegister("84tMx", function(module, exports) {

let $5e05cc7d0478333e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e05cc7d0478333e$var$load("etezH").then(()=>parcelRequire('k1qzV'));

});

parcelRegister("9JBuG", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bOzDC = parcelRequire("bOzDC");

const $15b3a26189142445$export$c0c8ceeb88dd1e08 = {
    displayName: 'Forge GDrive Eugene Test Staging',
    id: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bOzDC.ForgeGdriveEugeneTestDevIcon), 'ForgeGdriveEugeneTestDev', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bOzDC.ForgeGdriveEugeneTestDevSearchResultIcon), 'ForgeGdriveEugeneTestDev', 'large'),
    integrationAri: 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeGdriveEugeneTestDevConfig"] = $15b3a26189142445$export$c0c8ceeb88dd1e08;

});

parcelRegister("bOzDC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bS2kQ")).then((m)=>m.ForgeGdriveEugeneTestDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/icon'
});

const $0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bS2kQ")).then((m)=>m.ForgeGdriveEugeneTestDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/search-result-icon'
});
const $0812653a4f5fcb19$export$d25ddeed4ba7332 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevIconComponent, null));
const $0812653a4f5fcb19$export$5a35b3e4364deaaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent, null));
module.exports["ForgeGdriveEugeneTestDevIcon"] = $0812653a4f5fcb19$export$d25ddeed4ba7332;
module.exports["ForgeGdriveEugeneTestDevSearchResultIcon"] = $0812653a4f5fcb19$export$5a35b3e4364deaaf;

});

parcelRegister("bS2kQ", function(module, exports) {

let $8a468c9a4cc1fd6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a468c9a4cc1fd6d$var$load("7XbUL").then(()=>parcelRequire('37RNC'));

});

parcelRegister("aHqTQ", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jypps = parcelRequire("jypps");

const $89120f59978d45f6$export$a3dc73add88484a8 = {
    displayName: 'Forge GDrive Eugene Test PROD',
    id: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestProd,
    icon: (0, $i52Hf.get3PLogo)((0, $jypps.ForgeGdriveEugeneTestProdIcon), 'ForgeGdriveEugeneTestProd', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jypps.ForgeGdriveEugeneTestProdSearchResultIcon), 'ForgeGdriveEugeneTestProd', 'large'),
    integrationAri: 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeGdriveEugeneTestProdConfig"] = $89120f59978d45f6$export$a3dc73add88484a8;

});

parcelRegister("jypps", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $546a2690b9747760$var$LazyForgeGdriveEugeneTestProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ke3Ft")).then((m)=>m.ForgeGdriveEugeneTestProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-prod/icon'
});

const $546a2690b9747760$var$LazyForgeGdriveEugeneTestProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ke3Ft")).then((m)=>m.ForgeGdriveEugeneTestProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-prod/search-result-icon'
});
const $546a2690b9747760$export$1fba1a4a4b5390fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546a2690b9747760$var$LazyForgeGdriveEugeneTestProdIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546a2690b9747760$var$LazyForgeGdriveEugeneTestProdIconComponent, null));
const $546a2690b9747760$export$1821b5c60d4d13ba = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546a2690b9747760$var$LazyForgeGdriveEugeneTestProdSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546a2690b9747760$var$LazyForgeGdriveEugeneTestProdSearchResultIconComponent, null));
module.exports["ForgeGdriveEugeneTestProdIcon"] = $546a2690b9747760$export$1fba1a4a4b5390fe;
module.exports["ForgeGdriveEugeneTestProdSearchResultIcon"] = $546a2690b9747760$export$1821b5c60d4d13ba;

});

parcelRegister("ke3Ft", function(module, exports) {

let $eb97f5cfae611d32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb97f5cfae611d32$var$load("6iHrB").then(()=>parcelRequire('lg5sr'));

});

parcelRegister("34wuK", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2EMFc = parcelRequire("2EMFc");

const $aea7621510adabe2$export$fa2bcc689ce846fa = {
    displayName: 'Salesforce by Unito',
    id: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $2EMFc.ForgeUnitoSalesforceDevIcon), 'ForgeUnitoSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2EMFc.ForgeUnitoSalesforceDevSearchResultIcon), 'ForgeUnitoSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoSalesforceConfig"] = $aea7621510adabe2$export$fa2bcc689ce846fa;

});

parcelRegister("2EMFc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $7826867ff450288a$var$LazyForgeUnitoSalesforceDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1wtRK")).then((m)=>m.ForgeUnitoSalesforceDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-dev/icon'
});

const $7826867ff450288a$var$LazyForgeUnitoSalesforceDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1wtRK")).then((m)=>m.ForgeUnitoSalesforceDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-dev/search-result-icon'
});
const $7826867ff450288a$export$8104e2df0f916abb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7826867ff450288a$var$LazyForgeUnitoSalesforceDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7826867ff450288a$var$LazyForgeUnitoSalesforceDevIconComponent, null));
const $7826867ff450288a$export$ed1cdf10de7cf033 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7826867ff450288a$var$LazyForgeUnitoSalesforceDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7826867ff450288a$var$LazyForgeUnitoSalesforceDevSearchResultIconComponent, null));
module.exports["ForgeUnitoSalesforceDevIcon"] = $7826867ff450288a$export$8104e2df0f916abb;
module.exports["ForgeUnitoSalesforceDevSearchResultIcon"] = $7826867ff450288a$export$ed1cdf10de7cf033;

});

parcelRegister("1wtRK", function(module, exports) {

let $11bff254d75d82cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11bff254d75d82cf$var$load("943Km").then(()=>parcelRequire('MkFOg'));

});

parcelRegister("g36Mb", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ddvjW = parcelRequire("ddvjW");

const $349e55f8f8689790$export$fa2bcc689ce846fa = {
    displayName: 'Salesforce by Unito',
    id: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $ddvjW.ForgeUnitoSalesforceProdIcon), 'ForgeUnitoSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ddvjW.ForgeUnitoSalesforceProdSearchResultIcon), 'ForgeUnitoSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoSalesforceConfig"] = $349e55f8f8689790$export$fa2bcc689ce846fa;

});

parcelRegister("ddvjW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f4892c500f697005$var$LazyForgeUnitoSalesforceProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5KAye")).then((m)=>m.ForgeUnitoSalesforceProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-prod/icon'
});

const $f4892c500f697005$var$LazyForgeUnitoSalesforceProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5KAye")).then((m)=>m.ForgeUnitoSalesforceProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-prod/search-result-icon'
});
const $f4892c500f697005$export$343dc2b8e291afb2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4892c500f697005$var$LazyForgeUnitoSalesforceProdIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4892c500f697005$var$LazyForgeUnitoSalesforceProdIconComponent, null));
const $f4892c500f697005$export$25516afb15bfa187 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4892c500f697005$var$LazyForgeUnitoSalesforceProdSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4892c500f697005$var$LazyForgeUnitoSalesforceProdSearchResultIconComponent, null));
module.exports["ForgeUnitoSalesforceProdIcon"] = $f4892c500f697005$export$343dc2b8e291afb2;
module.exports["ForgeUnitoSalesforceProdSearchResultIcon"] = $f4892c500f697005$export$25516afb15bfa187;

});

parcelRegister("5KAye", function(module, exports) {

let $42fd99e8051848de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42fd99e8051848de$var$load("lbXBb").then(()=>parcelRequire('fdO7I'));

});

parcelRegister("eODbN", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9FED9 = parcelRequire("9FED9");

const $a16d458bec3b19cc$export$da42ac6c929f2d1 = {
    displayName: 'ServiceNow by Unito',
    id: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowDev,
    icon: (0, $i52Hf.get3PLogo)((0, $9FED9.ForgeUnitoServicenowDevIcon), 'ForgeUnitoServicenow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9FED9.ForgeUnitoServicenowDevSearchResultIcon), 'ForgeUnitoServicenow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoServicenowConfig"] = $a16d458bec3b19cc$export$da42ac6c929f2d1;

});

parcelRegister("9FED9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $9e8885c91d006b9f$var$LazyForgeUnitoServicenowDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jI4co")).then((m)=>m.ForgeUnitoServicenowDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-dev/icon'
});

const $9e8885c91d006b9f$var$LazyForgeUnitoServicenowDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jI4co")).then((m)=>m.ForgeUnitoServicenowDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-dev/search-result-icon'
});
const $9e8885c91d006b9f$export$9d41b3d14b7278ba = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e8885c91d006b9f$var$LazyForgeUnitoServicenowDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e8885c91d006b9f$var$LazyForgeUnitoServicenowDevIconComponent, null));
const $9e8885c91d006b9f$export$aa41257056ffa0f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e8885c91d006b9f$var$LazyForgeUnitoServicenowDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e8885c91d006b9f$var$LazyForgeUnitoServicenowDevSearchResultIconComponent, null));
module.exports["ForgeUnitoServicenowDevIcon"] = $9e8885c91d006b9f$export$9d41b3d14b7278ba;
module.exports["ForgeUnitoServicenowDevSearchResultIcon"] = $9e8885c91d006b9f$export$aa41257056ffa0f6;

});

parcelRegister("jI4co", function(module, exports) {

let $e59562363414c6ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e59562363414c6ce$var$load("bUwp8").then(()=>parcelRequire('gpDms'));

});

parcelRegister("2k3z5", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jJfaS = parcelRequire("jJfaS");

const $a288e08a13e84492$export$da42ac6c929f2d1 = {
    displayName: 'ServiceNow by Unito',
    id: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowProd,
    icon: (0, $i52Hf.get3PLogo)((0, $jJfaS.ForgeUnitoServicenowProdIcon), 'ForgeUnitoServicenow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jJfaS.ForgeUnitoServicenowProdSearchResultIcon), 'ForgeUnitoServicenow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RzFogW4EQLcXYmYpKkItRUhLAn3jETMq',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoServicenowConfig"] = $a288e08a13e84492$export$da42ac6c929f2d1;

});

parcelRegister("jJfaS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $a58b8a240bd4e837$var$LazyForgeUnitoServicenowProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("97QVs")).then((m)=>m.ForgeUnitoServicenowProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-prod/icon'
});

const $a58b8a240bd4e837$var$LazyForgeUnitoServicenowProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("97QVs")).then((m)=>m.ForgeUnitoServicenowProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-prod/search-result-icon'
});
const $a58b8a240bd4e837$export$4492fca47bdf8f21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a58b8a240bd4e837$var$LazyForgeUnitoServicenowProdIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a58b8a240bd4e837$var$LazyForgeUnitoServicenowProdIconComponent, null));
const $a58b8a240bd4e837$export$47ccbbbcbef66311 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a58b8a240bd4e837$var$LazyForgeUnitoServicenowProdSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a58b8a240bd4e837$var$LazyForgeUnitoServicenowProdSearchResultIconComponent, null));
module.exports["ForgeUnitoServicenowProdIcon"] = $a58b8a240bd4e837$export$4492fca47bdf8f21;
module.exports["ForgeUnitoServicenowProdSearchResultIcon"] = $a58b8a240bd4e837$export$47ccbbbcbef66311;

});

parcelRegister("97QVs", function(module, exports) {

let $6a4dd273ad822fef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a4dd273ad822fef$var$load("9Tgm1").then(()=>parcelRequire('kQgDV'));

});

parcelRegister("lHAGV", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $a2UXX = parcelRequire("a2UXX");

const $581c8928d6b8c09e$export$b2bafc74c57288f3 = {
    displayName: 'Wrike by Unito',
    id: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeDev,
    icon: (0, $i52Hf.get3PLogo)((0, $a2UXX.ForgeUnitoWrikeDevIcon), 'ForgeUnitoWrike', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $a2UXX.ForgeUnitoWrikeDevSearchResultIcon), 'ForgeUnitoWrike', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoWrikeConfig"] = $581c8928d6b8c09e$export$b2bafc74c57288f3;

});

parcelRegister("a2UXX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $25c9e7c8fc2f2f18$var$LazyForgeUnitoWrikeDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("k87eQ")).then((m)=>m.ForgeUnitoWrikeDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-dev/icon'
});

const $25c9e7c8fc2f2f18$var$LazyForgeUnitoWrikeDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("k87eQ")).then((m)=>m.ForgeUnitoWrikeDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-dev/search-result-icon'
});
const $25c9e7c8fc2f2f18$export$17dc9d80eebdf65c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25c9e7c8fc2f2f18$var$LazyForgeUnitoWrikeDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25c9e7c8fc2f2f18$var$LazyForgeUnitoWrikeDevIconComponent, null));
const $25c9e7c8fc2f2f18$export$f4934c6437de6183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25c9e7c8fc2f2f18$var$LazyForgeUnitoWrikeDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25c9e7c8fc2f2f18$var$LazyForgeUnitoWrikeDevSearchResultIconComponent, null));
module.exports["ForgeUnitoWrikeDevIcon"] = $25c9e7c8fc2f2f18$export$17dc9d80eebdf65c;
module.exports["ForgeUnitoWrikeDevSearchResultIcon"] = $25c9e7c8fc2f2f18$export$f4934c6437de6183;

});

parcelRegister("k87eQ", function(module, exports) {

let $ea7a2b6deab998b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea7a2b6deab998b0$var$load("8cmss").then(()=>parcelRequire('jN0Qa'));

});

parcelRegister("iPw5B", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $nKmi3 = parcelRequire("nKmi3");

const $fcf55f666081dee2$export$b2bafc74c57288f3 = {
    displayName: 'Wrike by Unito',
    id: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeProd,
    icon: (0, $i52Hf.get3PLogo)((0, $nKmi3.ForgeUnitoWrikeProdIcon), 'ForgeUnitoWrike', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $nKmi3.ForgeUnitoWrikeProdSearchResultIcon), 'ForgeUnitoWrike', 'large'),
    integrationAri: 'ari:cloud:platform::integration/390XhSnH4YgwqVgmyqYOujxVoL3IOUcM',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoWrikeConfig"] = $fcf55f666081dee2$export$b2bafc74c57288f3;

});

parcelRegister("nKmi3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $c7621601753489b0$var$LazyForgeUnitoWrikeProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dT8Yk")).then((m)=>m.ForgeUnitoWrikeProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-prod/icon'
});

const $c7621601753489b0$var$LazyForgeUnitoWrikeProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dT8Yk")).then((m)=>m.ForgeUnitoWrikeProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-prod/search-result-icon'
});
const $c7621601753489b0$export$518d4767160867f3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7621601753489b0$var$LazyForgeUnitoWrikeProdIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7621601753489b0$var$LazyForgeUnitoWrikeProdIconComponent, null));
const $c7621601753489b0$export$13cc65e658693d1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7621601753489b0$var$LazyForgeUnitoWrikeProdSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7621601753489b0$var$LazyForgeUnitoWrikeProdSearchResultIconComponent, null));
module.exports["ForgeUnitoWrikeProdIcon"] = $c7621601753489b0$export$518d4767160867f3;
module.exports["ForgeUnitoWrikeProdSearchResultIcon"] = $c7621601753489b0$export$13cc65e658693d1e;

});

parcelRegister("dT8Yk", function(module, exports) {

let $a1c75f13e19a83e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1c75f13e19a83e7$var$load("I6kmM").then(()=>parcelRequire('8Y1A9'));

});

parcelRegister("3LgSg", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $16Wwz = parcelRequire("16Wwz");

const $03b0710ec10f5545$export$802c434914cc51cb = {
    displayName: 'Asana by Unito',
    id: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaDev,
    icon: (0, $i52Hf.get3PLogo)((0, $16Wwz.ForgeUnitoAsanaDevIcon), 'ForgeUnitoAsana', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $16Wwz.ForgeUnitoAsanaDevSearchResultIcon), 'ForgeUnitoAsana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/6wHDDwNbam77WvGwMKYMGDiTWP8pza54',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoAsanaConfig"] = $03b0710ec10f5545$export$802c434914cc51cb;

});

parcelRegister("16Wwz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jdE4p")).then((m)=>m.ForgeUnitoAsanaDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/icon'
});

const $b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jdE4p")).then((m)=>m.ForgeUnitoAsanaDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/search-result-icon'
});
const $b8ff5851b44fb2d6$export$84e4ab153a34ad7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevIconComponent, null));
const $b8ff5851b44fb2d6$export$cd30ec5cd19c805 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8ff5851b44fb2d6$var$LazyForgeUnitoAsanaDevSearchResultIconComponent, null));
module.exports["ForgeUnitoAsanaDevIcon"] = $b8ff5851b44fb2d6$export$84e4ab153a34ad7e;
module.exports["ForgeUnitoAsanaDevSearchResultIcon"] = $b8ff5851b44fb2d6$export$cd30ec5cd19c805;

});

parcelRegister("jdE4p", function(module, exports) {

let $dfde50523d636ab8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfde50523d636ab8$var$load("6fZlZ").then(()=>parcelRequire('1K5y8'));

});

parcelRegister("bRkOn", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6qL93 = parcelRequire("6qL93");

const $2cb9c75b34e21339$export$802c434914cc51cb = {
    displayName: 'Asana by Unito',
    id: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaProd,
    icon: (0, $i52Hf.get3PLogo)((0, $6qL93.ForgeUnitoAsanaProdIcon), 'ForgeUnitoAsana', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6qL93.ForgeUnitoAsanaProdSearchResultIcon), 'ForgeUnitoAsana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoAsanaConfig"] = $2cb9c75b34e21339$export$802c434914cc51cb;

});

parcelRegister("6qL93", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fPn6N")).then((m)=>m.ForgeUnitoAsanaProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/icon'
});

const $cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fPn6N")).then((m)=>m.ForgeUnitoAsanaProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/search-result-icon'
});
const $cf5194bf62aeff02$export$df888f4c8633dd6a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdIconComponent, null));
const $cf5194bf62aeff02$export$b7301999a3358df4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf5194bf62aeff02$var$LazyForgeUnitoAsanaProdSearchResultIconComponent, null));
module.exports["ForgeUnitoAsanaProdIcon"] = $cf5194bf62aeff02$export$df888f4c8633dd6a;
module.exports["ForgeUnitoAsanaProdSearchResultIcon"] = $cf5194bf62aeff02$export$b7301999a3358df4;

});

parcelRegister("fPn6N", function(module, exports) {

let $b85d8b5371f44bee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b85d8b5371f44bee$var$load("badpd").then(()=>parcelRequire('3xxsS'));

});

parcelRegister("eoGOF", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1WCEK = parcelRequire("1WCEK");

const $d176d2984c0af30f$export$6cacedfbd2e2676a = {
    displayName: 'Basecamp by Unito',
    id: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampDev,
    icon: (0, $i52Hf.get3PLogo)((0, $1WCEK.ForgeUnitoBasecampDevIcon), 'ForgeUnitoBasecamp', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1WCEK.ForgeUnitoBasecampDevSearchResultIcon), 'ForgeUnitoBasecamp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nImlCTNLZUCtQzFsthpnlYJL0B981lMH',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoBasecampConfig"] = $d176d2984c0af30f$export$6cacedfbd2e2676a;

});

parcelRegister("1WCEK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $c1b5f15872f4400a$var$LazyForgeUnitoBasecampDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3634l")).then((m)=>m.ForgeUnitoBasecampDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-dev/icon'
});

const $c1b5f15872f4400a$var$LazyForgeUnitoBasecampDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3634l")).then((m)=>m.ForgeUnitoBasecampDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-dev/search-result-icon'
});
const $c1b5f15872f4400a$export$ed9e7ffb4c370ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1b5f15872f4400a$var$LazyForgeUnitoBasecampDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1b5f15872f4400a$var$LazyForgeUnitoBasecampDevIconComponent, null));
const $c1b5f15872f4400a$export$a77ad170c76187c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1b5f15872f4400a$var$LazyForgeUnitoBasecampDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1b5f15872f4400a$var$LazyForgeUnitoBasecampDevSearchResultIconComponent, null));
module.exports["ForgeUnitoBasecampDevIcon"] = $c1b5f15872f4400a$export$ed9e7ffb4c370ac;
module.exports["ForgeUnitoBasecampDevSearchResultIcon"] = $c1b5f15872f4400a$export$a77ad170c76187c6;

});

parcelRegister("3634l", function(module, exports) {

let $24145019fd96e785$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $24145019fd96e785$var$load("lNn41").then(()=>parcelRequire('73xBC'));

});

parcelRegister("jWqmd", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $hFQXg = parcelRequire("hFQXg");

const $6fde0139df050b44$export$6cacedfbd2e2676a = {
    displayName: 'Basecamp by Unito',
    id: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampProd,
    icon: (0, $i52Hf.get3PLogo)((0, $hFQXg.ForgeUnitoBasecampProdIcon), 'ForgeUnitoBasecamp', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $hFQXg.ForgeUnitoBasecampProdSearchResultIcon), 'ForgeUnitoBasecamp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUnitoBasecampConfig"] = $6fde0139df050b44$export$6cacedfbd2e2676a;

});

parcelRegister("hFQXg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $72c90af0a8d94a29$var$LazyForgeUnitoBasecampProdIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("sQLNW")).then((m)=>m.ForgeUnitoBasecampProdIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-prod/icon'
});

const $72c90af0a8d94a29$var$LazyForgeUnitoBasecampProdSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("sQLNW")).then((m)=>m.ForgeUnitoBasecampProdSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-prod/search-result-icon'
});
const $72c90af0a8d94a29$export$e7d4885dcb83a937 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72c90af0a8d94a29$var$LazyForgeUnitoBasecampProdIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72c90af0a8d94a29$var$LazyForgeUnitoBasecampProdIconComponent, null));
const $72c90af0a8d94a29$export$db9a338191bfb0c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72c90af0a8d94a29$var$LazyForgeUnitoBasecampProdSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72c90af0a8d94a29$var$LazyForgeUnitoBasecampProdSearchResultIconComponent, null));
module.exports["ForgeUnitoBasecampProdIcon"] = $72c90af0a8d94a29$export$e7d4885dcb83a937;
module.exports["ForgeUnitoBasecampProdSearchResultIcon"] = $72c90af0a8d94a29$export$db9a338191bfb0c2;

});

parcelRegister("sQLNW", function(module, exports) {

let $056b8caba6476939$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $056b8caba6476939$var$load("lh5zV").then(()=>parcelRequire('emr8L'));

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("bGVJw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $df1fef41340c50c5$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $df1fef41340c50c5$export$a228be81fcb77b42 = (0, $cozmU.createContext)($df1fef41340c50c5$export$da5dc9062cba6715);
const $df1fef41340c50c5$export$3a10495c2cd2db0c = $df1fef41340c50c5$export$a228be81fcb77b42.Provider;
const $df1fef41340c50c5$export$b77983be89bb0a4e = $df1fef41340c50c5$export$3a10495c2cd2db0c;
const $df1fef41340c50c5$export$5bd9099e0ae94a43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($df1fef41340c50c5$export$a228be81fcb77b42);
} : ()=>(0, $cozmU.useContext)($df1fef41340c50c5$export$a228be81fcb77b42);
module.exports["defaultPostOfficeContextValue"] = $df1fef41340c50c5$export$da5dc9062cba6715;
module.exports["PostOfficeContext"] = $df1fef41340c50c5$export$a228be81fcb77b42;
module.exports["InternalPostOfficeContextProvider"] = $df1fef41340c50c5$export$3a10495c2cd2db0c;
module.exports["PostOfficeContextProvider"] = $df1fef41340c50c5$export$b77983be89bb0a4e;
module.exports["usePostOfficeContext"] = $df1fef41340c50c5$export$5bd9099e0ae94a43;

});

parcelRegister("iQwJa", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $23faa112e8710681$export$be54ac815726b4bd = (context)=>{
    const isGlobalDisablePlacementCheckEnabled = (0, $iDrrr.fg)('post-office-enable-disable-placement-check');
    if (isGlobalDisablePlacementCheckEnabled) return context.disableAllPlacements === true;
    return false;
};
module.exports["isPostOfficePlacementsGloballyDisabled"] = $23faa112e8710681$export$be54ac815726b4bd;

});

parcelRegister("gswTK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $32399d5f04a6fb7b$export$afec669dc416ee7e = /*#__PURE__*/ (0, $cozmU.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $32399d5f04a6fb7b$export$e1e2cdb0425a9fa8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($32399d5f04a6fb7b$export$afec669dc416ee7e);
} : ()=>(0, $cozmU.useContext)($32399d5f04a6fb7b$export$afec669dc416ee7e);
const $32399d5f04a6fb7b$export$e6d4e8801dff09b9 = ()=>{
    try {
        return (0, $cozmU.useContext)($32399d5f04a6fb7b$export$afec669dc416ee7e);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
        return undefined;
    }
};
const $32399d5f04a6fb7b$export$5f25a6ddf0324fa8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetch: fetch, children: children } = t0;
    let t1;
    if ($[0] !== fetch) {
        t1 = {
            fetch: fetch
        };
        $[0] = fetch;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    if ($[2] !== children || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$afec669dc416ee7e.Provider, {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ fetch: fetch, children: children })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};
const $32399d5f04a6fb7b$export$a088c81282679a25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetch: fetch, children: children } = t0;
    if (!fetch) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== fetch) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$5f25a6ddf0324fa8, {
            fetch: fetch
        }, children);
        $[2] = children;
        $[3] = fetch;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ fetch: fetch, children: children })=>{
    if (!fetch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$5f25a6ddf0324fa8, {
        fetch: fetch
    }, children);
};
module.exports["usePlacementFetchingContext"] = $32399d5f04a6fb7b$export$e1e2cdb0425a9fa8;
module.exports["useOptionalPlacementFetchingContext"] = $32399d5f04a6fb7b$export$e6d4e8801dff09b9;
module.exports["PlacementFetchingProvider"] = $32399d5f04a6fb7b$export$5f25a6ddf0324fa8;
module.exports["MaybePlacementFetchingProvider"] = $32399d5f04a6fb7b$export$a088c81282679a25;

});

parcelRegister("6NRmI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bGVJw = parcelRequire("bGVJw");

var $jdpvF = parcelRequire("jdpvF");


var $2dA2p = parcelRequire("2dA2p");


var $ifV7w = parcelRequire("ifV7w");

// @twood: NEVER CHANGE THIS DEFAULT VALUE
const $a0a682275c4a0108$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a0a682275c4a0108$var$choreographerLogger = (0, $2dA2p.createInBrowserDebugLogger)('Choreographer');
const $a0a682275c4a0108$var$defaultContext = {
    choreographerEnabled: $a0a682275c4a0108$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a0a682275c4a0108$var$ChoreographerContext = /*#__PURE__*/ (0, $cozmU.createContext)($a0a682275c4a0108$var$defaultContext);
// Helper to automatically handle ESM and non-ESM imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $a0a682275c4a0108$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        $a0a682275c4a0108$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        $a0a682275c4a0108$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        $a0a682275c4a0108$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $a0a682275c4a0108$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};

const $a0a682275c4a0108$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $cozmU.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $cozmU.useState)(choreographer?.isDefaultEnabled ?? $a0a682275c4a0108$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $jdpvF.usePostOfficeEnvironment)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ifV7w.shouldBypassChoreographerFromDevtools)()) setChoreographerEnabled(false);
    }, [
        setChoreographerEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (choreographerEnabled) // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("bszpu")).then((m)=>{
            const ChoreographerRegistryClass = $a0a682275c4a0108$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $a0a682275c4a0108$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $a0a682275c4a0108$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $a0a682275c4a0108$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $a0a682275c4a0108$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $cozmU.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        $a0a682275c4a0108$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    (0, $cozmU.useEffect)(()=>{
        return (0, $ifV7w.installChoreographerDevtoolsBridge)({
            setChoreographerEnabled: setChoreographerEnabled
        });
    }, [
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a0a682275c4a0108$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext
    }, children);
};
const $a0a682275c4a0108$export$cab5a8adbabcee23 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a0a682275c4a0108$var$ChoreographerContext);
} : ()=>(0, $cozmU.useContext)($a0a682275c4a0108$var$ChoreographerContext);
module.exports["StableChoreographerProvider"] = $a0a682275c4a0108$export$e68b2c75bfb5682a;
module.exports["useChoreographerContext"] = $a0a682275c4a0108$export$cab5a8adbabcee23;

});

parcelRegister("2dA2p", function(module, exports) {
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components.
 *
 * NOTE: This is a copy of
 * `post-office/packages/util/shared-contracts/src/util/in-browser-debug-logger.ts`
 * to avoid a cross-workspace import. You may want to keep them in sync.
 *
 * Usage:
 * - Enable:  window.postOffice{Component}Debug = true
 * - Disable: window.postOffice{Component}Debug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $ec8b1e18434a088d$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};
module.exports["createInBrowserDebugLogger"] = $ec8b1e18434a088d$export$806eda59584e395d;

});

parcelRegister("ifV7w", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $iDrrr = parcelRequire("iDrrr");

const $3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_KEY = 'postOffice.choreographer.debug';
const $3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY = 'bypassEnabled';
const $3e4b6bb4c2123311$var$getStorageClient = ()=>new (0, $6YrB3.default)($3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_KEY, {
        storageEngine: 'sessionStorage'
    });
const $3e4b6bb4c2123311$var$getWindow = ()=>typeof window === 'undefined' ? undefined : window;
const $3e4b6bb4c2123311$var$getPersistedBypassEnabled = ()=>{
    return $3e4b6bb4c2123311$var$getStorageClient().getItem($3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY) === true;
};
const $3e4b6bb4c2123311$export$8e299e8aab3a0cc6 = ()=>{
    return (0, $iDrrr.fg)('post-office_choreographer_devtools_bridge') && $3e4b6bb4c2123311$var$getPersistedBypassEnabled();
};
const $3e4b6bb4c2123311$var$setPersistedBypassEnabled = (isEnabled)=>{
    // The devtools bridge should never break message rendering when browser storage is blocked.
    // StorageClient handles exceptions internally.
    $3e4b6bb4c2123311$var$getStorageClient().setItemWithExpiry($3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY, isEnabled);
};
const $3e4b6bb4c2123311$var$getChoreographerSingleton = ()=>$3e4b6bb4c2123311$var$getWindow()?.postOffice?.choreographer?.singleton;
const $3e4b6bb4c2123311$var$getRegisteredPluginIds = ()=>{
    return [
        ...$3e4b6bb4c2123311$var$getWindow()?.choreographerRegistry?.keys() ?? []
    ];
};
const $3e4b6bb4c2123311$var$getSnapshot = ()=>{
    const singleton = $3e4b6bb4c2123311$var$getChoreographerSingleton();
    const registeredPlugins = $3e4b6bb4c2123311$var$getRegisteredPluginIds();
    return {
        activeMessage: singleton?.getCurrentMessage() ?? null,
        bypassEnabled: $3e4b6bb4c2123311$export$8e299e8aab3a0cc6(),
        pendingMessage: singleton?.getCurrentPendingMessage() ?? null,
        queuedMessages: singleton?.getQueuedMessages() ?? [],
        recentEvents: [],
        registeredMessages: registeredPlugins.map((productId)=>({
                productId: productId,
                messageIds: [
                    ...singleton?.getMessages(productId).keys() ?? []
                ]
            })),
        registeredPlugins: registeredPlugins,
        updatedAt: Date.now()
    };
};
const $3e4b6bb4c2123311$export$606f928dbd560712 = ({ setChoreographerEnabled: setChoreographerEnabled })=>{
    const currentWindow = $3e4b6bb4c2123311$var$getWindow();
    if (!currentWindow) return ()=>{};
    if (!(0, $iDrrr.fg)('post-office_choreographer_devtools_bridge')) {
        delete currentWindow.postOffice?.choreographer?.debug;
        return ()=>{};
    }
    const bridge = {
        getSnapshot: $3e4b6bb4c2123311$var$getSnapshot,
        isBypassEnabled: $3e4b6bb4c2123311$export$8e299e8aab3a0cc6,
        setBypassEnabled: (isEnabled)=>{
            $3e4b6bb4c2123311$var$setPersistedBypassEnabled(isEnabled);
            setChoreographerEnabled(!isEnabled);
        }
    };
    currentWindow.postOffice = {
        ...currentWindow.postOffice,
        choreographer: {
            ...currentWindow.postOffice?.choreographer,
            debug: bridge
        }
    };
    return ()=>{
        if (currentWindow.postOffice?.choreographer?.debug === bridge) delete currentWindow.postOffice.choreographer.debug;
    };
};
module.exports["shouldBypassChoreographerFromDevtools"] = $3e4b6bb4c2123311$export$8e299e8aab3a0cc6;
module.exports["installChoreographerDevtoolsBridge"] = $3e4b6bb4c2123311$export$606f928dbd560712;

});

parcelRegister("bszpu", function(module, exports) {

let $857dc6f22f4c1d9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857dc6f22f4c1d9c$var$load("41Qou").then(()=>parcelRequire('8h6a6'));

});

parcelRegister("4cICV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eq1BO = parcelRequire("eq1BO");


var $VDfNH = parcelRequire("VDfNH");

const $2831b09faf7bf56f$export$6394bf86db095a8 = /*#__PURE__*/ (0, $cozmU.createContext)({
    placementId: undefined
});
const $2831b09faf7bf56f$export$6272e220478c7f1d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== value.placementId) {
        t1 = {
            placementId: value.placementId
        };
        $[0] = value.placementId;
        $[1] = t1;
    } else t1 = $[1];
    const memoizedValue = t1;
    (0, $VDfNH.usePostOfficeScreenPlacement)(memoizedValue);
    let t2;
    if ($[2] !== children || $[3] !== memoizedValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.PostOfficeAnalyticsContext), {
            data: memoizedValue
        }, children);
        $[2] = children;
        $[3] = memoizedValue;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== memoizedValue || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2831b09faf7bf56f$export$6394bf86db095a8.Provider, {
            value: memoizedValue
        }, t2);
        $[5] = memoizedValue;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ value: value, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $VDfNH.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2831b09faf7bf56f$export$6394bf86db095a8.Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.PostOfficeAnalyticsContext), {
        data: memoizedValue
    }, children));
};
const $2831b09faf7bf56f$export$4fc0446ee742ad80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($2831b09faf7bf56f$export$6394bf86db095a8);
} : ()=>(0, $cozmU.useContext)($2831b09faf7bf56f$export$6394bf86db095a8);
module.exports["PlacementProvider"] = $2831b09faf7bf56f$export$6272e220478c7f1d;
module.exports["usePlacementContext"] = $2831b09faf7bf56f$export$4fc0446ee742ad80;

});

parcelRegister("VDfNH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2z6YT = parcelRequire("2z6YT");

const $28ba2b78924c6069$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $28ba2b78924c6069$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    placements: $28ba2b78924c6069$var$initialPlacementState
});
const $28ba2b78924c6069$export$70e19226ddeaf957 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenContext);
} : ()=>(0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenContext);
const $28ba2b78924c6069$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $28ba2b78924c6069$export$5d27c0ee02be2a23 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenUpdateContext);
} : ()=>(0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenUpdateContext);
const $28ba2b78924c6069$export$ca77a8cbe94108fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [placements, setPlacements] = (0, $cozmU.useState)($28ba2b78924c6069$var$initialPlacementState);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (t2)=>{
            const { placementId: placementId } = t2;
            return setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: (0, $2z6YT.uniqueArray)([
                        ...state.currentlyMounted,
                        placementId
                    ]),
                    hasMounted: (0, $2z6YT.uniqueArray)([
                        ...state.hasMounted,
                        placementId
                    ])
                });
        };
        $[0] = t1;
    } else t1 = $[0];
    const placementMount = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (t3)=>{
            const { placementId: placementId_0 } = t3;
            return setPlacements((state_0)=>!state_0.currentlyMounted.includes(placementId_0) ? state_0 : {
                    ...state_0,
                    currentlyMounted: state_0.currentlyMounted.filter((e)=>e !== placementId_0)
                });
        };
        $[1] = t2;
    } else t2 = $[1];
    const placementUnmount = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            placementMount: placementMount,
            placementUnmount: placementUnmount
        };
        $[2] = t3;
    } else t3 = $[2];
    const postOfficeScreenUpdateContext = t3;
    let t4;
    if ($[3] !== placements) {
        t4 = {
            placements: placements
        };
        $[3] = placements;
        $[4] = t4;
    } else t4 = $[4];
    const postOfficeScreenContext = t4;
    let t5;
    if ($[5] !== children || $[6] !== postOfficeScreenContext) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenUpdateContext.Provider, {
            value: postOfficeScreenUpdateContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext
        }, children));
        $[5] = children;
        $[6] = postOfficeScreenContext;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ children: children })=>{
    const [placements, setPlacements] = (0, $cozmU.useState)($28ba2b78924c6069$var$initialPlacementState);
    const placementMount = (0, $cozmU.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $2z6YT.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $2z6YT.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $cozmU.useCallback)(({ placementId: placementId_0 })=>setPlacements((state_0)=>!state_0.currentlyMounted.includes(placementId_0) ? state_0 : {
                ...state_0,
                currentlyMounted: state_0.currentlyMounted.filter((e)=>e !== placementId_0)
            }), []);
    const postOfficeScreenUpdateContext = (0, $cozmU.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $cozmU.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $28ba2b78924c6069$export$f51d04a086368016 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { placementId: placementId } = t0;
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $28ba2b78924c6069$export$5d27c0ee02be2a23();
    let t1;
    let t2;
    if ($[0] !== placementId || $[1] !== placementMount || $[2] !== placementUnmount) {
        t1 = ()=>{
            if (!placementId) return;
            placementMount({
                placementId: placementId
            });
            return ()=>{
                placementUnmount({
                    placementId: placementId
                });
            };
        };
        t2 = [
            placementId,
            placementMount,
            placementUnmount
        ];
        $[0] = placementId;
        $[1] = placementMount;
        $[2] = placementUnmount;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $28ba2b78924c6069$export$5d27c0ee02be2a23();
    (0, $cozmU.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};
module.exports["usePostOfficeScreen"] = $28ba2b78924c6069$export$70e19226ddeaf957;
module.exports["PostOfficeScreenContextProvider"] = $28ba2b78924c6069$export$ca77a8cbe94108fe;
module.exports["usePostOfficeScreenPlacement"] = $28ba2b78924c6069$export$f51d04a086368016;

});

parcelRegister("2z6YT", function(module, exports) {
const $153c91e5091772be$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
module.exports["uniqueArray"] = $153c91e5091772be$export$bbd17ecb0679edd7;

});

parcelRegister("di43e", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $10c4c3085134b526$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
   * Subscribes a callback function to the pub-sub system.
   * @param {Callback} subscriber - The callback function to subscribe.
   * @returns A function to unsubscribe the callback.
   */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
   * Publishes the payload to all subscribed callbacks.
   * @param {Callback} payload - The payload to publish to the subscribers.
   */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $10c4c3085134b526$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $10c4c3085134b526$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $10c4c3085134b526$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $cozmU.createContext)($10c4c3085134b526$export$a28a0c048b24fc5a());
const $10c4c3085134b526$export$c7535f8ebc5b75a9 = $10c4c3085134b526$export$ea58328f3ceee4d4.Provider;
const $10c4c3085134b526$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10c4c3085134b526$export$c7535f8ebc5b75a9, {
            value: $10c4c3085134b526$export$a28a0c048b24fc5a()
        }, children);
const $10c4c3085134b526$export$89f8e1f623d8f5ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($10c4c3085134b526$export$ea58328f3ceee4d4);
} : ()=>(0, $cozmU.useContext)($10c4c3085134b526$export$ea58328f3ceee4d4);
module.exports["createMessagePlacementValues"] = $10c4c3085134b526$export$a28a0c048b24fc5a;
module.exports["MessagePlacementProvider"] = $10c4c3085134b526$export$c7535f8ebc5b75a9;
module.exports["useMessagePlacementHooks"] = $10c4c3085134b526$export$89f8e1f623d8f5ac;

});

parcelRegister("k4HA2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $73152d52b0fbce45$var$initialValue = {};
const $73152d52b0fbce45$export$b060d577040138d8 = (0, $cozmU.createContext)($73152d52b0fbce45$var$initialValue);
const $73152d52b0fbce45$export$42de33f7652dc3de = $73152d52b0fbce45$export$b060d577040138d8.Provider;
const $73152d52b0fbce45$export$a5b6d14a2e25725a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($73152d52b0fbce45$export$b060d577040138d8);
} : ()=>(0, $cozmU.useContext)($73152d52b0fbce45$export$b060d577040138d8);
module.exports["MessageContextProvider"] = $73152d52b0fbce45$export$42de33f7652dc3de;
module.exports["useMessageContext"] = $73152d52b0fbce45$export$a5b6d14a2e25725a;

});

parcelRegister("kEPax", function(module, exports) {
$parcel$export(module.exports, "MessageInstanceEventClient", () => (parcelRequire("eZHZB")).MessageInstanceEventClient);
$parcel$export(module.exports, "useRecommendationContext", () => (parcelRequire("82Ab4")).useRecommendationContext);
$parcel$export(module.exports, "useMessageContext", () => (parcelRequire("k4HA2")).useMessageContext);
$parcel$export(module.exports, "usePlacementContext", () => (parcelRequire("4cICV")).usePlacementContext);
/**
 * Message lifecycle hooks for Post Office headless consumers.
 *
 * Provides `useMessageViewed` — a single hook that fires viewed and delivery
 * analytics events on mount:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed() (message-instance-event endpoint)
 *   - messageInstanceDeliveredSuccessfully() (message-instance-event endpoint)
 *
 * This module is hoisted into @atlassian/post-office-context so that platform
 * packages can consume it without cross-workspace @post-office/* imports.
 *
 * Canonical sources this was inlined from:
 *   post-office/packages/clients/message-lifecycle
 *   post-office/packages/clients/message-instance-event-frontend-client
 *   post-office/packages/clients/recommendation-context
 */ 
var $cozmU = parcelRequire("cozmU");


var $di43e = parcelRequire("di43e");

var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $dEG1b = parcelRequire("dEG1b");


var $eZHZB = parcelRequire("eZHZB");


var $4cICV = parcelRequire("4cICV");


var $82Ab4 = parcelRequire("82Ab4");

class $380d86e06eb73b45$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $380d86e06eb73b45$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}
const $380d86e06eb73b45$export$39b0f5626e96f41e = ()=>{
    // globalThis resolves to window in the browser, this will therefore attach at window.window, but we should not change until we are sure what is relying on this path.
    if (typeof window !== 'undefined' && !globalThis?.window?.postOfficeMessageInstanceEventClient) {
        // If we are in the browser but there is no window.window
        if (typeof globalThis.window === 'undefined') globalThis.window = {};
        globalThis.window.postOfficeMessageInstanceEventClient = new (0, $eZHZB.MessageInstanceEventClient)();
    }
    const messageInstanceEventClientRef = (0, $cozmU.useRef)(globalThis?.window?.postOfficeMessageInstanceEventClient ?? new (0, $eZHZB.MessageInstanceEventClient)());
    // This falls back to creation per call in the case window is not defined. It is not the best behaviour as this could cause too many object to be created but is
    // better than an uncontrolled error in SSR. This function needs to be made SSR safe in a safter manner.
    const client = messageInstanceEventClientRef.current;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null, configSetId: configSetId } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $cozmU.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $380d86e06eb73b45$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? '',
                    itemFeatureSetId: recommendationContext.itemFeatureSetId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        recommendationContext.itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceViewed = (0, $cozmU.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $380d86e06eb73b45$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? '',
                    itemFeatureSetId: recommendationContext.itemFeatureSetId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        recommendationContext.itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceClicked = (0, $cozmU.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $380d86e06eb73b45$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? '',
                    itemFeatureSetId: recommendationContext.itemFeatureSetId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        recommendationContext.itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};
const $380d86e06eb73b45$export$f847ba3acec566f4 = ()=>{
    // -- message-lifecycle (legacy) client --
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const legacyClient = globalThis.window.postOfficeMessageEventClient;
    // -- message-instance-event client --
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $eZHZB.MessageInstanceEventClient)();
    const instanceClient = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const { markViewedFromPlacement: markViewedFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    return async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) {
            // eslint-disable-next-line no-console
            console.error('[post-office] useMessageViewed: missing required context fields');
            return;
        }
        const sharedContext = {
            ...browserContext,
            source: placementId,
            recommendation: {
                recommendationSessionId: recommendationContext.sessionId ?? '',
                recommendationEntityId: recommendationContext.entityId ?? '',
                itemFeatureSetId: recommendationContext.itemFeatureSetId ?? ''
            }
        };
        // 1. Legacy lifecycle event (messageViewed)
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        legacyClient.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $dEG1b.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: {
                browser: browserContext,
                recommendation: recommendationContext
            }
        });
        // 2. messageInstanceViewed
        await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType ?? 'implicit',
            messageTriggerId: messageTriggerId ?? '',
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
        // 3. messageInstanceDeliveredSuccessfully
        if (messageCreationType && messageTriggerId) await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
    };
};
module.exports["useMessageInstanceEvent"] = $380d86e06eb73b45$export$39b0f5626e96f41e;
module.exports["useMessageViewed"] = $380d86e06eb73b45$export$f847ba3acec566f4;

});

parcelRegister("dEG1b", function(module, exports) {
/**
 * Canonical MessageEventClient implementation.
 *
 * This is the source of truth. `@post-office/message-lifecycle` uses this via
 * `@atlassian/post-office-context/message-lifecycle`.
 */ // ---------------------------------------------------------------------------
// Types (inlined from @post-office/message-lifecycle/src/types.ts)
// ---------------------------------------------------------------------------
var $e5120a75155e5f6a$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $e5120a75155e5f6a$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $e5120a75155e5f6a$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("eZedZ"));
class $e5120a75155e5f6a$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $e5120a75155e5f6a$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $e5120a75155e5f6a$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $e5120a75155e5f6a$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["InAppMessageEventType"] = $e5120a75155e5f6a$export$b31ffc6f7c85f1b;
module.exports["MessageEventClient"] = $e5120a75155e5f6a$export$ae86a6dabe385178;

});

parcelRegister("eZedZ", function(module, exports) {
$parcel$export(module.exports, "DOMException", () => $ae91cbe7bd95c977$export$fe58bcf938607f6a);
/* eslint-disable no-prototype-builtins */ var $ae91cbe7bd95c977$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $ae91cbe7bd95c977$var$support = {
    searchParams: 'URLSearchParams' in $ae91cbe7bd95c977$var$g,
    iterable: 'Symbol' in $ae91cbe7bd95c977$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $ae91cbe7bd95c977$var$g && 'Blob' in $ae91cbe7bd95c977$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $ae91cbe7bd95c977$var$g,
    arrayBuffer: 'ArrayBuffer' in $ae91cbe7bd95c977$var$g
};
function $ae91cbe7bd95c977$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($ae91cbe7bd95c977$var$support.arrayBuffer) {
    var $ae91cbe7bd95c977$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $ae91cbe7bd95c977$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $ae91cbe7bd95c977$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $ae91cbe7bd95c977$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $ae91cbe7bd95c977$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $ae91cbe7bd95c977$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($ae91cbe7bd95c977$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $ae91cbe7bd95c977$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $ae91cbe7bd95c977$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $ae91cbe7bd95c977$var$normalizeName(name);
    value = $ae91cbe7bd95c977$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$ae91cbe7bd95c977$var$normalizeName(name)];
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $ae91cbe7bd95c977$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($ae91cbe7bd95c977$var$normalizeName(name));
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$ae91cbe7bd95c977$var$normalizeName(name)] = $ae91cbe7bd95c977$var$normalizeValue(value);
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $ae91cbe7bd95c977$var$iteratorFor(items);
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $ae91cbe7bd95c977$var$iteratorFor(items);
};
$ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $ae91cbe7bd95c977$var$iteratorFor(items);
};
if ($ae91cbe7bd95c977$var$support.iterable) $ae91cbe7bd95c977$export$79b704688b15c0f4.prototype[Symbol.iterator] = $ae91cbe7bd95c977$export$79b704688b15c0f4.prototype.entries;
function $ae91cbe7bd95c977$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $ae91cbe7bd95c977$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $ae91cbe7bd95c977$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $ae91cbe7bd95c977$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $ae91cbe7bd95c977$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $ae91cbe7bd95c977$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $ae91cbe7bd95c977$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $ae91cbe7bd95c977$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $ae91cbe7bd95c977$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($ae91cbe7bd95c977$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($ae91cbe7bd95c977$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($ae91cbe7bd95c977$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($ae91cbe7bd95c977$var$support.arrayBuffer && $ae91cbe7bd95c977$var$support.blob && $ae91cbe7bd95c977$var$isDataView(body)) {
            this._bodyArrayBuffer = $ae91cbe7bd95c977$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($ae91cbe7bd95c977$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $ae91cbe7bd95c977$var$isArrayBufferView(body))) this._bodyArrayBuffer = $ae91cbe7bd95c977$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($ae91cbe7bd95c977$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($ae91cbe7bd95c977$var$support.blob) this.blob = function() {
        var rejected = $ae91cbe7bd95c977$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $ae91cbe7bd95c977$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($ae91cbe7bd95c977$var$support.blob) return this.blob().then($ae91cbe7bd95c977$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $ae91cbe7bd95c977$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $ae91cbe7bd95c977$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($ae91cbe7bd95c977$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($ae91cbe7bd95c977$var$support.formData) this.formData = function() {
        return this.text().then($ae91cbe7bd95c977$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $ae91cbe7bd95c977$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $ae91cbe7bd95c977$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $ae91cbe7bd95c977$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $ae91cbe7bd95c977$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $ae91cbe7bd95c977$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $ae91cbe7bd95c977$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $ae91cbe7bd95c977$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $ae91cbe7bd95c977$export$79b704688b15c0f4(options.headers);
    this.method = $ae91cbe7bd95c977$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $ae91cbe7bd95c977$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$ae91cbe7bd95c977$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $ae91cbe7bd95c977$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $ae91cbe7bd95c977$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $ae91cbe7bd95c977$var$parseHeaders(rawHeaders) {
    var headers = new $ae91cbe7bd95c977$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$ae91cbe7bd95c977$var$Body.call($ae91cbe7bd95c977$export$7fa6c5b6f8193917.prototype);
function $ae91cbe7bd95c977$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $ae91cbe7bd95c977$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $ae91cbe7bd95c977$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$ae91cbe7bd95c977$var$Body.call($ae91cbe7bd95c977$export$9f633d56d7ec90d3.prototype);
$ae91cbe7bd95c977$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $ae91cbe7bd95c977$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $ae91cbe7bd95c977$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$ae91cbe7bd95c977$export$9f633d56d7ec90d3.error = function() {
    var response = new $ae91cbe7bd95c977$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $ae91cbe7bd95c977$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$ae91cbe7bd95c977$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($ae91cbe7bd95c977$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $ae91cbe7bd95c977$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $ae91cbe7bd95c977$export$fe58bcf938607f6a = $ae91cbe7bd95c977$var$g.DOMException;
try {
    new $ae91cbe7bd95c977$export$fe58bcf938607f6a();
} catch (err) {
    $ae91cbe7bd95c977$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $ae91cbe7bd95c977$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $ae91cbe7bd95c977$export$fe58bcf938607f6a.prototype.constructor = $ae91cbe7bd95c977$export$fe58bcf938607f6a;
}
function $ae91cbe7bd95c977$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $ae91cbe7bd95c977$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $ae91cbe7bd95c977$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $ae91cbe7bd95c977$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $ae91cbe7bd95c977$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $ae91cbe7bd95c977$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $ae91cbe7bd95c977$var$g.location.href ? $ae91cbe7bd95c977$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($ae91cbe7bd95c977$var$support.blob) xhr.responseType = 'blob';
            else if ($ae91cbe7bd95c977$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $ae91cbe7bd95c977$export$79b704688b15c0f4 || $ae91cbe7bd95c977$var$g.Headers && init.headers instanceof $ae91cbe7bd95c977$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($ae91cbe7bd95c977$var$normalizeName(name));
                xhr.setRequestHeader(name, $ae91cbe7bd95c977$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$ae91cbe7bd95c977$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$ae91cbe7bd95c977$var$g.fetch) {
    $ae91cbe7bd95c977$var$g.fetch = $ae91cbe7bd95c977$export$e7aa7bc5c1b3cfb3;
    $ae91cbe7bd95c977$var$g.Headers = $ae91cbe7bd95c977$export$79b704688b15c0f4;
    $ae91cbe7bd95c977$var$g.Request = $ae91cbe7bd95c977$export$7fa6c5b6f8193917;
    $ae91cbe7bd95c977$var$g.Response = $ae91cbe7bd95c977$export$9f633d56d7ec90d3;
}
module.exports["Headers"] = $ae91cbe7bd95c977$export$79b704688b15c0f4;
module.exports["Request"] = $ae91cbe7bd95c977$export$7fa6c5b6f8193917;
module.exports["Response"] = $ae91cbe7bd95c977$export$9f633d56d7ec90d3;
module.exports["fetch"] = $ae91cbe7bd95c977$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("eZHZB", function(module, exports) {
/**
 * Canonical MessageInstanceEventClient implementation.
 *
 * This is the source of truth for frontend in-app message instance events.
 * `@atlassian/message-instance-event-frontend-client/message-instance-event-client` and the legacy
 * `@post-office/message-instance-event-frontend-client` package both export this implementation.
 */ // ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $4f99a14f3531a72b$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $4f99a14f3531a72b$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("eZedZ"));
class $4f99a14f3531a72b$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $4f99a14f3531a72b$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $4f99a14f3531a72b$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $4f99a14f3531a72b$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["MessageInstanceEventClient"] = $4f99a14f3531a72b$export$4564cfc2de39be55;

});

parcelRegister("82Ab4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $ea8345716b24b21f$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $cozmU.createContext)({
    sessionId: undefined,
    entityId: undefined,
    itemFeatureSetId: undefined
});
const $ea8345716b24b21f$export$f60e87d7b5f59562 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: value
        }, children);
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1 || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea8345716b24b21f$export$ba2f44035effd9c1.Provider, {
            value: value
        }, t1);
        $[3] = t1;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea8345716b24b21f$export$ba2f44035effd9c1.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: value
    }, children));
};
const $ea8345716b24b21f$export$3321c0b02f750bcc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($ea8345716b24b21f$export$ba2f44035effd9c1);
} : ()=>(0, $cozmU.useContext)($ea8345716b24b21f$export$ba2f44035effd9c1);
module.exports["RecommendationProvider"] = $ea8345716b24b21f$export$f60e87d7b5f59562;
module.exports["useRecommendationContext"] = $ea8345716b24b21f$export$3321c0b02f750bcc;

});

parcelRegister("dBFrb", function(module, exports) {
const $355fe673f3cc5740$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $355fe673f3cc5740$export$1ee5f9be618fd29e = (context)=>{
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(context)){
        if (Array.isArray(value)) value.filter($355fe673f3cc5740$var$isNotEmpty).forEach((element)=>params.append(key, String(element)));
        else if ($355fe673f3cc5740$var$isNotEmpty(value)) params.append(key, String(value));
    }
    params.sort();
    return params;
};
module.exports["buildSearchParams"] = $355fe673f3cc5740$export$1ee5f9be618fd29e;

});

parcelRegister("iDSbf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $jvnPU = parcelRequire("jvnPU");


var $dBFrb = parcelRequire("dBFrb");

const $5a4cef3573b27dec$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $5a4cef3573b27dec$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $5a4cef3573b27dec$export$ef70136078f15deb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== path) {
        t0 = path === "" || path === "/" ? "" : `/${path.charAt(0) === "/" ? path.substring(1) : path}`;
        $[0] = path;
        $[1] = t0;
    } else t0 = $[1];
    const normalizedPath = t0;
    let t1;
    if ($[2] !== context) {
        const queryParams = (0, $dBFrb.buildSearchParams)(context);
        t1 = queryParams.toString();
        $[2] = context;
        $[3] = t1;
    } else t1 = $[3];
    const contextAsSearchParams = t1;
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$5a4cef3573b27dec$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    let t2;
    if ($[4] !== fetcher || $[5] !== requestOptions) {
        t2 = (url_0)=>fetcher.fetch(url_0, {
                ...requestOptions,
                headers: {
                    ...$5a4cef3573b27dec$var$defaultHeaders,
                    ...requestOptions?.headers
                }
            })?.then($5a4cef3573b27dec$var$_temp);
        $[4] = fetcher;
        $[5] = requestOptions;
        $[6] = t2;
    } else t2 = $[6];
    return (0, $jvnPU.default)(placementId ? url : null, t2, useSWROptions);
} : (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = (0, $dBFrb.buildSearchParams)(context);
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$5a4cef3573b27dec$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $jvnPU.default)(placementId ? url : null, (url_0)=>fetcher.fetch(url_0, {
            ...requestOptions,
            headers: {
                ...$5a4cef3573b27dec$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};
function $5a4cef3573b27dec$var$_temp(res) {
    if (!res) throw new Error("No response from fetch");
    return res.json();
}
module.exports["useFetchPlacementData"] = $5a4cef3573b27dec$export$ef70136078f15deb;

});

parcelRegister("jvnPU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $8h4fq = parcelRequire("8h4fq");
parcelRequire("3PVFp");
var $3PVFp = parcelRequire("3PVFp");

var $2Yg7J = parcelRequire("2Yg7J");

// Shared state between server components and client components
const $e33366f5385eaa59$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $e33366f5385eaa59$var$UNDEFINED = /*#__NOINLINE__*/ $e33366f5385eaa59$var$noop();
const $e33366f5385eaa59$var$OBJECT = Object;
const $e33366f5385eaa59$var$isUndefined = (v)=>v === $e33366f5385eaa59$var$UNDEFINED;
const $e33366f5385eaa59$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $e33366f5385eaa59$var$table = new WeakMap();
const $e33366f5385eaa59$var$getTypeName = (value)=>$e33366f5385eaa59$var$OBJECT.prototype.toString.call(value);
const $e33366f5385eaa59$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $e33366f5385eaa59$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $e33366f5385eaa59$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $e33366f5385eaa59$var$getTypeName(arg);
    const isDate = $e33366f5385eaa59$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $e33366f5385eaa59$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $e33366f5385eaa59$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($e33366f5385eaa59$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $e33366f5385eaa59$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$e33366f5385eaa59$var$counter + '~';
        $e33366f5385eaa59$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $e33366f5385eaa59$var$stableHash(arg[index]) + ',';
            $e33366f5385eaa59$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $e33366f5385eaa59$var$OBJECT.keys(arg).sort();
            while(!$e33366f5385eaa59$var$isUndefined(index = keys.pop()))if (!$e33366f5385eaa59$var$isUndefined(arg[index])) result += index + ':' + $e33366f5385eaa59$var$stableHash(arg[index]) + ',';
            $e33366f5385eaa59$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $e33366f5385eaa59$var$serialize = (key)=>{
    if ($e33366f5385eaa59$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $e33366f5385eaa59$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $e33366f5385eaa59$export$dbab534a48e651ef = (key)=>$e33366f5385eaa59$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $e33366f5385eaa59$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $e33366f5385eaa59$var$WITH_DEDUPE = {
    dedupe: true
};
const $e33366f5385eaa59$var$resolvedUndef = Promise.resolve((0, $8h4fq.U));
/**
 * The core implementation of the useSWR hook.
 *
 * This is the main handler function that implements all SWR functionality including
 * data fetching, caching, revalidation, error handling, and state management.
 * It manages the complete lifecycle of SWR requests from initialization through
 * cleanup.
 *
 * Key responsibilities:
 * - Key serialization and normalization
 * - Cache state management and synchronization
 * - Automatic and manual revalidation
 * - Error handling and retry logic
 * - Suspense integration
 * - Loading state management
 * - Effect cleanup and memory management
 *
 * @template Data - The type of data returned by the fetcher
 * @template Error - The type of error that can be thrown
 *
 * @param _key - The SWR key (string, array, object, function, or falsy)
 * @param fetcher - The fetcher function to retrieve data, or null to disable fetching
 * @param config - Complete SWR configuration object with both public and internal options
 *
 * @returns SWRResponse object containing data, error, mutate function, and loading states
 *
 * @internal This is the internal implementation. Use `useSWR` instead.
 */ const $e33366f5385eaa59$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData, strictServerPrefetchWarning: strictServerPrefetchWarning } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $8h4fq.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $8h4fq.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $cozmU.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $cozmU.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $cozmU.useRef)(key);
    const fetcherRef = (0, $cozmU.useRef)(fetcher);
    const configRef = (0, $cozmU.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $8h4fq.z)(cache, key);
    const stateDependencies = (0, $cozmU.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $8h4fq.e)(fallbackData) ? (0, $8h4fq.e)(config.fallback) ? (0, $8h4fq.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $8h4fq.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $cozmU.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $8h4fq.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $8h4fq.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $6nvBr.useSyncExternalStore)((0, $cozmU.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $8h4fq.e)(cachedData) ? fallback && (0, $8h4fq.B)(fallback) ? $e33366f5385eaa59$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $cozmU.useRef)(data);
    const returnedData = keepPreviousData ? (0, $8h4fq.e)(cachedData) ? (0, $8h4fq.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    const hasKeyButNoData = key && (0, $8h4fq.e)(data);
    // Note: the conditionally hook call is fine because the environment
    // `IS_SERVER` never changes.
    const isHydration = !(0, $8h4fq.r) && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6nvBr.useSyncExternalStore)(()=>(0, $8h4fq.A), ()=>false, ()=>true);
    // During the initial SSR render, warn if the key has no data pre-fetched via:
    // - fallback data
    // - preload calls
    // - initial data from the cache provider
    // We only warn once for each key during SSR.
    if (strictServerPrefetchWarning && isHydration && !suspense && hasKeyButNoData) console.warn(`Missing pre-initiated data for serialized key "${key}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $8h4fq.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $8h4fq.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $8h4fq.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $8h4fq.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $8h4fq.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $8h4fq.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $cozmU.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $8h4fq.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $8h4fq.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $8h4fq.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $8h4fq.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $8h4fq.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $8h4fq.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $8h4fq.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $2Yg7J).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $cozmU.useCallback)((...args)=>{
        return (0, $8h4fq.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $8h4fq.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $8h4fq.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $8h4fq.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $8h4fq.U), $e33366f5385eaa59$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $2Yg7J).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $2Yg7J).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $2Yg7J).MUTATE_EVENT) return revalidate();
            else if (type == (0, $2Yg7J).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $3PVFp.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $8h4fq.e)(data) || (0, $8h4fq.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $8h4fq.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $8h4fq.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $8h4fq.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($e33366f5385eaa59$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $cozmU.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $8h4fq.I) && (0, $8h4fq.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $8h4fq.e)(req) && hasKeyButNoData ? boundMutate(req) : $e33366f5385eaa59$var$resolvedUndef;
        $e33366f5385eaa59$var$use(mutateReq);
        if (!(0, $8h4fq.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($e33366f5385eaa59$var$WITH_DEDUPE) : $e33366f5385eaa59$var$resolvedUndef;
        if (!(0, $8h4fq.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $e33366f5385eaa59$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $e33366f5385eaa59$export$4c7bbecdacc3ca2c = (0, $8h4fq.O).defineProperty((0, $8h4fq.g), 'defaultValue', {
    value: (0, $8h4fq.d)
});
/**
 * A hook to fetch data.
 *
 * @see {@link https://swr.vercel.app}
 *
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $e33366f5385eaa59$export$2e2bcd8739ae039 = (0, $3PVFp.withArgs)($e33366f5385eaa59$var$useSWRHandler);
module.exports["SWRConfig"] = $e33366f5385eaa59$export$4c7bbecdacc3ca2c;
module.exports["default"] = $e33366f5385eaa59$export$2e2bcd8739ae039;

});

parcelRegister("8h4fq", function(module, exports) {
$parcel$export(module.exports, "c", () => $606334c7ff6e8c2f$export$db3b6bfb95261072);

var $cozmU = parcelRequire("cozmU");


var $2Yg7J = parcelRequire("2Yg7J");


var $5W8qe = parcelRequire("5W8qe");

'use client';
// Global state used to deduplicate requests and store listeners
const $606334c7ff6e8c2f$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $606334c7ff6e8c2f$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $606334c7ff6e8c2f$export$ebd11618f299a286();
const $606334c7ff6e8c2f$export$c4ce752e73470fba = Object;
const $606334c7ff6e8c2f$export$f1e1789686576879 = (v)=>v === $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08;
const $606334c7ff6e8c2f$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $606334c7ff6e8c2f$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $606334c7ff6e8c2f$export$ef35774e6d314e91 = (x)=>$606334c7ff6e8c2f$export$407448d2b89b1813(x.then);
const $606334c7ff6e8c2f$var$EMPTY_CACHE = {};
const $606334c7ff6e8c2f$var$INITIAL_CACHE = {};
const $606334c7ff6e8c2f$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $606334c7ff6e8c2f$export$23f2a1d2818174ef = typeof window != $606334c7ff6e8c2f$var$STR_UNDEFINED;
const $606334c7ff6e8c2f$export$efccba1c4a2ef57b = typeof document != $606334c7ff6e8c2f$var$STR_UNDEFINED;
const $606334c7ff6e8c2f$export$d141bba7fdc215a3 = $606334c7ff6e8c2f$export$23f2a1d2818174ef && 'Deno' in window;
const $606334c7ff6e8c2f$export$4a5767248b18ef41 = ()=>$606334c7ff6e8c2f$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $606334c7ff6e8c2f$var$STR_UNDEFINED;
const $606334c7ff6e8c2f$export$df995fae86a55f06 = (cache, key)=>{
    const state = $606334c7ff6e8c2f$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$606334c7ff6e8c2f$export$f1e1789686576879(key) && cache.get(key) || $606334c7ff6e8c2f$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$606334c7ff6e8c2f$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $606334c7ff6e8c2f$var$INITIAL_CACHE)) $606334c7ff6e8c2f$var$INITIAL_CACHE[key] = prev;
                state[5](key, $606334c7ff6e8c2f$export$953cecd6e717a553(prev, info), prev || $606334c7ff6e8c2f$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$606334c7ff6e8c2f$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $606334c7ff6e8c2f$var$INITIAL_CACHE) return $606334c7ff6e8c2f$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$606334c7ff6e8c2f$export$f1e1789686576879(key) && cache.get(key) || $606334c7ff6e8c2f$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $606334c7ff6e8c2f$var$online = true;
const $606334c7ff6e8c2f$var$isOnline = ()=>$606334c7ff6e8c2f$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$606334c7ff6e8c2f$var$onWindowEvent, $606334c7ff6e8c2f$var$offWindowEvent] = $606334c7ff6e8c2f$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $606334c7ff6e8c2f$export$ebd11618f299a286,
    $606334c7ff6e8c2f$export$ebd11618f299a286
];
const $606334c7ff6e8c2f$var$isVisible = ()=>{
    const visibilityState = $606334c7ff6e8c2f$export$efccba1c4a2ef57b && document.visibilityState;
    return $606334c7ff6e8c2f$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $606334c7ff6e8c2f$var$initFocus = (callback)=>{
    // focus revalidate
    if ($606334c7ff6e8c2f$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $606334c7ff6e8c2f$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($606334c7ff6e8c2f$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $606334c7ff6e8c2f$var$offWindowEvent('focus', callback);
    };
};
const $606334c7ff6e8c2f$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $606334c7ff6e8c2f$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $606334c7ff6e8c2f$var$online = false;
    };
    $606334c7ff6e8c2f$var$onWindowEvent('online', onOnline);
    $606334c7ff6e8c2f$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $606334c7ff6e8c2f$var$offWindowEvent('online', onOnline);
        $606334c7ff6e8c2f$var$offWindowEvent('offline', onOffline);
    };
};
const $606334c7ff6e8c2f$export$ffb5f4729a158638 = {
    isOnline: $606334c7ff6e8c2f$var$isOnline,
    isVisible: $606334c7ff6e8c2f$var$isVisible
};
const $606334c7ff6e8c2f$export$9e5f44173e64f162 = {
    initFocus: $606334c7ff6e8c2f$var$initFocus,
    initReconnect: $606334c7ff6e8c2f$var$initReconnect
};
const $606334c7ff6e8c2f$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useId;
const $606334c7ff6e8c2f$export$43caf9889c228507 = !$606334c7ff6e8c2f$export$23f2a1d2818174ef || $606334c7ff6e8c2f$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $606334c7ff6e8c2f$export$625550452a3fa3ec = (f)=>$606334c7ff6e8c2f$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $606334c7ff6e8c2f$export$3b14a55fb2447963 = $606334c7ff6e8c2f$export$43caf9889c228507 ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $606334c7ff6e8c2f$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $606334c7ff6e8c2f$export$90a7f3efeed30595 = !$606334c7ff6e8c2f$export$43caf9889c228507 && $606334c7ff6e8c2f$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($606334c7ff6e8c2f$var$navigatorConnection.effectiveType) || $606334c7ff6e8c2f$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $606334c7ff6e8c2f$var$table = new WeakMap();
const $606334c7ff6e8c2f$var$getTypeName = (value)=>$606334c7ff6e8c2f$export$c4ce752e73470fba.prototype.toString.call(value);
const $606334c7ff6e8c2f$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $606334c7ff6e8c2f$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $606334c7ff6e8c2f$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $606334c7ff6e8c2f$var$getTypeName(arg);
    const isDate = $606334c7ff6e8c2f$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $606334c7ff6e8c2f$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $606334c7ff6e8c2f$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($606334c7ff6e8c2f$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $606334c7ff6e8c2f$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$606334c7ff6e8c2f$var$counter + '~';
        $606334c7ff6e8c2f$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $606334c7ff6e8c2f$export$882b5998b3b9117c(arg[index]) + ',';
            $606334c7ff6e8c2f$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $606334c7ff6e8c2f$export$c4ce752e73470fba.keys(arg).sort();
            while(!$606334c7ff6e8c2f$export$f1e1789686576879(index = keys.pop()))if (!$606334c7ff6e8c2f$export$f1e1789686576879(arg[index])) result += index + ':' + $606334c7ff6e8c2f$export$882b5998b3b9117c(arg[index]) + ',';
            $606334c7ff6e8c2f$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $606334c7ff6e8c2f$export$2408f22a0fab9ae5 = (key)=>{
    if ($606334c7ff6e8c2f$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $606334c7ff6e8c2f$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $606334c7ff6e8c2f$var$__timestamp = 0;
const $606334c7ff6e8c2f$export$ae1af26003f05816 = ()=>++$606334c7ff6e8c2f$var$__timestamp;
async function $606334c7ff6e8c2f$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $606334c7ff6e8c2f$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($606334c7ff6e8c2f$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $606334c7ff6e8c2f$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $606334c7ff6e8c2f$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $606334c7ff6e8c2f$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $606334c7ff6e8c2f$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($2Yg7J.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $606334c7ff6e8c2f$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$606334c7ff6e8c2f$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $606334c7ff6e8c2f$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $606334c7ff6e8c2f$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($606334c7ff6e8c2f$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $606334c7ff6e8c2f$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($606334c7ff6e8c2f$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08,
                        _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08,
                    _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $606334c7ff6e8c2f$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $606334c7ff6e8c2f$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $606334c7ff6e8c2f$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$606334c7ff6e8c2f$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $606334c7ff6e8c2f$export$953cecd6e717a553($606334c7ff6e8c2f$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $606334c7ff6e8c2f$export$7ccc53e8f1e7dfc5.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, provider);
        let unmount = $606334c7ff6e8c2f$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$606334c7ff6e8c2f$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $606334c7ff6e8c2f$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$606334c7ff6e8c2f$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, $606334c7ff6e8c2f$var$revalidateAllKeys.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $2Yg7J.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, $606334c7ff6e8c2f$var$revalidateAllKeys.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $2Yg7J.RECONNECT_EVENT)));
                    unmount = ()=>{
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseFocus && releaseFocus();
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $606334c7ff6e8c2f$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $606334c7ff6e8c2f$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $606334c7ff6e8c2f$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$606334c7ff6e8c2f$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $606334c7ff6e8c2f$export$342063e11d6c3cad = (0, $5W8qe.dequal);
// Default cache provider
const [$606334c7ff6e8c2f$export$db3b6bfb95261072, $606334c7ff6e8c2f$export$35e795649ee09318] = $606334c7ff6e8c2f$export$dda1d9f60106f0e9(new Map());
// Default config
const $606334c7ff6e8c2f$export$4368d992c4eafac0 = $606334c7ff6e8c2f$export$953cecd6e717a553({
    // events
    onLoadingSlow: $606334c7ff6e8c2f$export$ebd11618f299a286,
    onSuccess: $606334c7ff6e8c2f$export$ebd11618f299a286,
    onError: $606334c7ff6e8c2f$export$ebd11618f299a286,
    onErrorRetry: $606334c7ff6e8c2f$var$onErrorRetry,
    onDiscarded: $606334c7ff6e8c2f$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $606334c7ff6e8c2f$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $606334c7ff6e8c2f$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $606334c7ff6e8c2f$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $606334c7ff6e8c2f$export$db3b6bfb95261072,
    mutate: $606334c7ff6e8c2f$export$35e795649ee09318,
    fallback: {}
}, $606334c7ff6e8c2f$export$ffb5f4729a158638);
const $606334c7ff6e8c2f$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $606334c7ff6e8c2f$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $606334c7ff6e8c2f$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $606334c7ff6e8c2f$export$25ce5a424b770e84 = (0, $cozmU.createContext)({});
const $606334c7ff6e8c2f$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $cozmU.useContext)($606334c7ff6e8c2f$export$25ce5a424b770e84);
    const isFunctionalConfig = $606334c7ff6e8c2f$export$407448d2b89b1813(value);
    const config = (0, $cozmU.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $cozmU.useMemo)(()=>isFunctionalConfig ? config : $606334c7ff6e8c2f$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $cozmU.useRef)($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $606334c7ff6e8c2f$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $606334c7ff6e8c2f$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $606334c7ff6e8c2f$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $cozmU.createElement)($606334c7ff6e8c2f$export$25ce5a424b770e84.Provider, $606334c7ff6e8c2f$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};
module.exports["b"] = $606334c7ff6e8c2f$export$8b22cf2602fb60ce;
module.exports["A"] = $606334c7ff6e8c2f$export$ebd11618f299a286;
module.exports["U"] = $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08;
module.exports["O"] = $606334c7ff6e8c2f$export$c4ce752e73470fba;
module.exports["e"] = $606334c7ff6e8c2f$export$f1e1789686576879;
module.exports["a"] = $606334c7ff6e8c2f$export$407448d2b89b1813;
module.exports["m"] = $606334c7ff6e8c2f$export$953cecd6e717a553;
module.exports["B"] = $606334c7ff6e8c2f$export$ef35774e6d314e91;
module.exports["i"] = $606334c7ff6e8c2f$export$23f2a1d2818174ef;
module.exports["z"] = $606334c7ff6e8c2f$export$df995fae86a55f06;
module.exports["I"] = $606334c7ff6e8c2f$export$9bb611d729802a56;
module.exports["r"] = $606334c7ff6e8c2f$export$43caf9889c228507;
module.exports["t"] = $606334c7ff6e8c2f$export$625550452a3fa3ec;
module.exports["u"] = $606334c7ff6e8c2f$export$3b14a55fb2447963;
module.exports["s"] = $606334c7ff6e8c2f$export$2408f22a0fab9ae5;
module.exports["o"] = $606334c7ff6e8c2f$export$ae1af26003f05816;
module.exports["n"] = $606334c7ff6e8c2f$export$7ccc53e8f1e7dfc5;
module.exports["d"] = $606334c7ff6e8c2f$export$4368d992c4eafac0;
module.exports["f"] = $606334c7ff6e8c2f$export$2d1720544b23b823;
module.exports["S"] = $606334c7ff6e8c2f$export$25ce5a424b770e84;
module.exports["g"] = $606334c7ff6e8c2f$export$39b482c5e57630a8;

});

parcelRegister("2Yg7J", function(module, exports) {
const $229db13431cd9163$export$831c820ad60f9d12 = 0;
const $229db13431cd9163$export$24e9454cb99a11dc = 1;
const $229db13431cd9163$export$75ea288459391154 = 2;
const $229db13431cd9163$export$b019c3839228f243 = 3;
module.exports["FOCUS_EVENT"] = $229db13431cd9163$export$831c820ad60f9d12;
module.exports["RECONNECT_EVENT"] = $229db13431cd9163$export$24e9454cb99a11dc;
module.exports["MUTATE_EVENT"] = $229db13431cd9163$export$75ea288459391154;
module.exports["ERROR_REVALIDATE_EVENT"] = $229db13431cd9163$export$b019c3839228f243;

});

parcelRegister("5W8qe", function(module, exports) {
var $4528e6ffac657016$var$has = Object.prototype.hasOwnProperty;
function $4528e6ffac657016$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4528e6ffac657016$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($4528e6ffac657016$var$has.call(foo, ctor) && ++len && !$4528e6ffac657016$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4528e6ffac657016$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $4528e6ffac657016$export$de8294bb3be0322f;

});

parcelRegister("3PVFp", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $2cb2ddf873b575a0$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $2cb2ddf873b575a0$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $2cb2ddf873b575a0$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("8h4fq")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("8h4fq")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("8h4fq")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("8h4fq")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("8h4fq")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("8h4fq")).s);

var $8h4fq = parcelRequire("8h4fq");


var $2Yg7J = parcelRequire("2Yg7J");


var $lv9Y3 = parcelRequire("lv9Y3");


var $cozmU = parcelRequire("cozmU");


// @ts-expect-error
const $2cb2ddf873b575a0$var$enableDevtools = (0, $8h4fq.i) && window.__SWR_DEVTOOLS_USE__;
const $2cb2ddf873b575a0$var$use = $2cb2ddf873b575a0$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $2cb2ddf873b575a0$var$setupDevTools = ()=>{
    if ($2cb2ddf873b575a0$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
};
const $2cb2ddf873b575a0$export$a3295358bff77e = (args)=>{
    return (0, $8h4fq.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $2cb2ddf873b575a0$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $cozmU.useContext)((0, $8h4fq.S));
    const mergedConfig = (0, $cozmU.useMemo)(()=>(0, $8h4fq.m)((0, $8h4fq.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $2cb2ddf873b575a0$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $8h4fq.s)(key_);
    const [, , , PRELOAD] = (0, $8h4fq.b).get((0, $8h4fq.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $2cb2ddf873b575a0$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $8h4fq.s)(key_);
            const [, , , PRELOAD] = (0, $8h4fq.b).get((0, $8h4fq.c));
            if (key.startsWith((0, $lv9Y3.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $8h4fq.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $2cb2ddf873b575a0$var$BUILT_IN_MIDDLEWARE = $2cb2ddf873b575a0$var$use.concat($2cb2ddf873b575a0$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $2cb2ddf873b575a0$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $2cb2ddf873b575a0$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $2cb2ddf873b575a0$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $8h4fq.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($2cb2ddf873b575a0$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $2cb2ddf873b575a0$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $2cb2ddf873b575a0$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $2cb2ddf873b575a0$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$2cb2ddf873b575a0$var$setupDevTools();

});

parcelRegister("lv9Y3", function(module, exports) {
const $fa743998d40d8600$export$8667f065faedc62c = '$inf$';
module.exports["INFINITE_PREFIX"] = $fa743998d40d8600$export$8667f065faedc62c;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("58FyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bddefb3ed7cf5f3$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $3bddefb3ed7cf5f3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("lkYE1", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");

//      
var $f88a81f3886ec3a5$var$charCodeOfDot = ".".charCodeAt(0);
var $f88a81f3886ec3a5$var$reEscapeChar = /\\(\\)?/g;
var $f88a81f3886ec3a5$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f88a81f3886ec3a5$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f88a81f3886ec3a5$var$charCodeOfDot) result.push("");
    string.replace($f88a81f3886ec3a5$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f88a81f3886ec3a5$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f88a81f3886ec3a5$var$keysCache = {};
var $f88a81f3886ec3a5$var$keysRegex = /[.[\]]+/;
var $f88a81f3886ec3a5$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f88a81f3886ec3a5$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f88a81f3886ec3a5$var$keysCache[key] = key.split($f88a81f3886ec3a5$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f88a81f3886ec3a5$var$keysCache[key] = $f88a81f3886ec3a5$var$stringToPath(key);
    }
    return $f88a81f3886ec3a5$var$keysCache[key];
};
//      
var $f88a81f3886ec3a5$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f88a81f3886ec3a5$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f88a81f3886ec3a5$var$_toPropertyKey(arg) {
    var key = $f88a81f3886ec3a5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f88a81f3886ec3a5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f88a81f3886ec3a5$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1eVGO.default)(current, [
                key
            ].map($f88a81f3886ec3a5$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $eb3ax.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f88a81f3886ec3a5$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f88a81f3886ec3a5$var$setInRecursor(state, 0, $f88a81f3886ec3a5$var$toPath(key), value1, destroyArrays);
};
var $f88a81f3886ec3a5$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f88a81f3886ec3a5$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f88a81f3886ec3a5$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(values, name);
    var error = $f88a81f3886ec3a5$export$c52e5867d5879e24(errors, name);
    if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) error = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f88a81f3886ec3a5$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f88a81f3886ec3a5$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f88a81f3886ec3a5$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f88a81f3886ec3a5$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f88a81f3886ec3a5$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f88a81f3886ec3a5$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f88a81f3886ec3a5$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$41e855cb628c1b55, $f88a81f3886ec3a5$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f88a81f3886ec3a5$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3, $f88a81f3886ec3a5$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f88a81f3886ec3a5$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f88a81f3886ec3a5$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f88a81f3886ec3a5$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f88a81f3886ec3a5$export$83d89fbfd8236492 = "4.20.10";
var $f88a81f3886ec3a5$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f88a81f3886ec3a5$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f88a81f3886ec3a5$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f88a81f3886ec3a5$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f88a81f3886ec3a5$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f88a81f3886ec3a5$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f88a81f3886ec3a5$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f88a81f3886ec3a5$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $eb3ax.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $eb3ax.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $eb3ax.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $eb3ax.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $eb3ax.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f88a81f3886ec3a5$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f88a81f3886ec3a5$export$e6bdf135a54e021b,
                    shallowEqual: $f88a81f3886ec3a5$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $eb3ax.default)({}, state.formState.values)); // clone to avoid writing
            if ($f88a81f3886ec3a5$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f88a81f3886ec3a5$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f88a81f3886ec3a5$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $eb3ax.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f88a81f3886ec3a5$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) {
                    var existing = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f88a81f3886ec3a5$export$735bebc8ffabf28a] = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
                    merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f88a81f3886ec3a5$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f88a81f3886ec3a5$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f88a81f3886ec3a5$var$notify(fieldSubscriber, fieldState, lastFieldState, $f88a81f3886ec3a5$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f88a81f3886ec3a5$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f88a81f3886ec3a5$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f88a81f3886ec3a5$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f88a81f3886ec3a5$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f88a81f3886ec3a5$var$notify(state.subscribers, nextFormState, lastFormState, $f88a81f3886ec3a5$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $eb3ax.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f88a81f3886ec3a5$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f88a81f3886ec3a5$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f88a81f3886ec3a5$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f88a81f3886ec3a5$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f88a81f3886ec3a5$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f88a81f3886ec3a5$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f88a81f3886ec3a5$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $f88a81f3886ec3a5$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $f88a81f3886ec3a5$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $f88a81f3886ec3a5$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $f88a81f3886ec3a5$export$83d89fbfd8236492;
module.exports["createForm"] = $f88a81f3886ec3a5$export$f681a8129d2e9d28;

});

parcelRegister("19ZlF", function(module, exports) {

var $lkYE1 = parcelRequire("lkYE1");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $0d863840e9077425$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $0d863840e9077425$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $0d863840e9077425$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};
//      
var $0d863840e9077425$var$noop = function noop() {};
var $0d863840e9077425$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $0d863840e9077425$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $0d863840e9077425$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $0d863840e9077425$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $0d863840e9077425$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$0d863840e9077425$export$2e2bcd8739ae039 = $0d863840e9077425$var$createDecorator;
module.exports["default"] = $0d863840e9077425$export$2e2bcd8739ae039;

});

parcelRegister("lSFbL", function(module, exports) {

var $2itBe = parcelRequire("2itBe");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fede975c1f302c4c$var$set(object, path, value) {
    return object == null ? object : $2itBe(object, path, value);
}
module.exports = $fede975c1f302c4c$var$set;

});

parcelRegister("hLP6B", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d27efa463aaac1e4$var$skeletonItemElemSize = 20;
const $d27efa463aaac1e4$var$styles = {
    root: "_4c065UPgdg _2Y7lL4kG2W _3iDTPbQ4SZ _4kiQYAUF4f _0hPCNLDIqT _1pp6NdYbGa _2Gfj6iQEt6 _47eTBt2AF2 _3wEj0XGsB2 _0GBAIrogpp _0eSLDaHZdu",
    defaultWidth: "_1ShRFFoBHb _0jufqb715P _0KfecEygnw _1v7p3wE1Ft _0pFvyeR1Le _1n9qNYrXaT",
    customWidth: "_2v4nLRyRC6",
    beforeElement: "_3ScelFSPN1 _1lBcDcSPN1 _0tXlYZdnbC _4diMdqGsB2 _3Ku51Iogpp _3QFY1HEbN9 _4bQ7pPFQfX",
    avatar: "_1OimfuS5Zs",
    icon: "_1OimfuzXzM",
    sideNavSkeleton: "_2Y7lL42ADO _1lBcDc9DVM _3QFY1H5zaO _3ScelF9DVM"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $d27efa463aaac1e4$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $d27efa463aaac1e4$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $d27efa463aaac1e4$var$SkeletonItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: t1, isSideNavSkeleton: t2, testId: testId, width: width, xcss: xcss } = t0;
    const isShimmering = t1 === undefined ? false : t1;
    const isSideNavSkeleton = t2 === undefined ? false : t2;
    const t3 = (hasAvatar || hasIcon) && $d27efa463aaac1e4$var$styles.beforeElement;
    const t4 = hasAvatar && $d27efa463aaac1e4$var$styles.avatar;
    const t5 = hasIcon && $d27efa463aaac1e4$var$styles.icon;
    const t6 = width ? $d27efa463aaac1e4$var$styles.customWidth : $d27efa463aaac1e4$var$styles.defaultWidth;
    const t7 = isSideNavSkeleton && $d27efa463aaac1e4$var$styles.sideNavSkeleton;
    const t8 = isShimmering && "";
    const t9 = isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2";
    let t10;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8 || $[6] !== t9 || $[7] !== xcss) {
        t10 = (0, $hekY6.default)([
            $d27efa463aaac1e4$var$styles.root,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8,
            t9,
            xcss
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
        $[7] = xcss;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== width) {
        t11 = {
            "--width": width
        };
        $[9] = width;
        $[10] = t11;
    } else t11 = $[10];
    const t12 = t11;
    let t13;
    if ($[11] !== t10 || $[12] !== t12 || $[13] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t10,
            style: t12,
            "data-testid": testId
        });
        $[11] = t10;
        $[12] = t12;
        $[13] = testId;
        $[14] = t13;
    } else t13 = $[14];
    return t13;
} : ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $d27efa463aaac1e4$var$styles.root,
            (hasAvatar || hasIcon) && $d27efa463aaac1e4$var$styles.beforeElement,
            hasAvatar && $d27efa463aaac1e4$var$styles.avatar,
            hasIcon && $d27efa463aaac1e4$var$styles.icon,
            width ? $d27efa463aaac1e4$var$styles.customWidth : $d27efa463aaac1e4$var$styles.defaultWidth,
            isSideNavSkeleton && $d27efa463aaac1e4$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $d27efa463aaac1e4$export$2e2bcd8739ae039 = $d27efa463aaac1e4$var$SkeletonItem;
module.exports["default"] = $d27efa463aaac1e4$export$2e2bcd8739ae039;

});

parcelRegister("go7uG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8f99a430e8355353$export$74e304339778e94d = (0, $kSwu1.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    },
    downloadCodeBlock: {
        id: "fabric.editor.codeBlockDownloadButton.downloadCodeBlock",
        defaultMessage: "Download"
    }
});
module.exports["codeBlockButtonMessages"] = $8f99a430e8355353$export$74e304339778e94d;

});

parcelRegister("8Xus6", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("fhdGv", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9KSWX = parcelRequire("9KSWX");


var $lzgC6 = parcelRequire("lzgC6");


var $ftY7H = parcelRequire("ftY7H");


var $jDboD = parcelRequire("jDboD");

function $ba35a2a9fe36df5b$var$_defineProperty(e, r, t) {
    return (r = $ba35a2a9fe36df5b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba35a2a9fe36df5b$var$_toPropertyKey(t) {
    var i = $ba35a2a9fe36df5b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba35a2a9fe36df5b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ba35a2a9fe36df5b$var$colorToLozengeAppearanceMap = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $ba35a2a9fe36df5b$var$DEFAULT_APPEARANCE = 'neutral';
const $ba35a2a9fe36df5b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $ba35a2a9fe36df5b$var$inlineBlockStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $ba35a2a9fe36df5b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $ba35a2a9fe36df5b$var$StatusInternal extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $ba35a2a9fe36df5b$var$colorToLozengeAppearanceMap[color] || $ba35a2a9fe36df5b$var$DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $ba35a2a9fe36df5b$var$isAndroidChromium && "_0ReY56US2K _3HdVfPey7F _3pS3pEt2nV",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: appearance,
            maxWidth: $ba35a2a9fe36df5b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "hoverStartTime", 0);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleKeyDown", (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleFocus", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleBlur", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$ba35a2a9fe36df5b$var$_defineProperty($ba35a2a9fe36df5b$var$StatusInternal, "displayName", 'StatusInternal');
const $ba35a2a9fe36df5b$export$96e9906d6d93a972 = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($ba35a2a9fe36df5b$var$StatusInternal);
module.exports["Status"] = $ba35a2a9fe36df5b$export$96e9906d6d93a972;

});

parcelRegister("ftY7H", function(module, exports) {
const $63d299faa378dc1a$export$d821aa4c8afb384e = 'fabric-elements';
const $63d299faa378dc1a$var$packageName = "platform-pkg";
const $63d299faa378dc1a$var$packageVersion = "0.0.0-use.local";
const $63d299faa378dc1a$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $63d299faa378dc1a$var$packageName;
        statusPayload.attributes.packageVersion = $63d299faa378dc1a$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($63d299faa378dc1a$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $63d299faa378dc1a$export$aa98853957f9f5aa;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $88149 = parcelRequire("88149");

const $c358709489b4576e$var$FileIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $88149 = parcelRequire("88149");

const $3736b97729106be6$var$ChartBarIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $88149 = parcelRequire("88149");

const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("3OVVx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c82f9b957a0dd41$var$_react = $2c82f9b957a0dd41$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2c82f9b957a0dd41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2c82f9b957a0dd41$var$Executable16Icon = (props)=>/*#__PURE__*/ $2c82f9b957a0dd41$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$2c82f9b957a0dd41$var$Executable16Icon.displayName = 'Executable16Icon';
var $2c82f9b957a0dd41$var$_default = module.exports.default = $2c82f9b957a0dd41$var$Executable16Icon;

});

parcelRegister("EhIdb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $079179cb50a24843$var$_react = $079179cb50a24843$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $079179cb50a24843$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $079179cb50a24843$var$Gif16Icon = (props)=>/*#__PURE__*/ $079179cb50a24843$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$079179cb50a24843$var$Gif16Icon.displayName = 'Gif16Icon';
var $079179cb50a24843$var$_default = module.exports.default = $079179cb50a24843$var$Gif16Icon;

});

parcelRegister("hmd8r", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ca2eae1e9270fd6e$var$_react = $ca2eae1e9270fd6e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $ca2eae1e9270fd6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ca2eae1e9270fd6e$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $ca2eae1e9270fd6e$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$ca2eae1e9270fd6e$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $ca2eae1e9270fd6e$var$_default = module.exports.default = $ca2eae1e9270fd6e$var$GoogleDoc16Icon;

});

parcelRegister("lLxTI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fd88481d2a5e9c77$var$_react = $fd88481d2a5e9c77$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $fd88481d2a5e9c77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd88481d2a5e9c77$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $fd88481d2a5e9c77$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fd88481d2a5e9c77$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $fd88481d2a5e9c77$var$_default = module.exports.default = $fd88481d2a5e9c77$var$GoogleForm16Icon;

});

parcelRegister("kUQwC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f3a1c7fef4d4d082$var$_react = $f3a1c7fef4d4d082$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f3a1c7fef4d4d082$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f3a1c7fef4d4d082$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f3a1c7fef4d4d082$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f3a1c7fef4d4d082$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f3a1c7fef4d4d082$var$_default = module.exports.default = $f3a1c7fef4d4d082$var$GoogleSheet16Icon;

});

parcelRegister("1G3Dq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $138c887dc5ea0961$var$_react = $138c887dc5ea0961$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $138c887dc5ea0961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $138c887dc5ea0961$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $138c887dc5ea0961$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$138c887dc5ea0961$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $138c887dc5ea0961$var$_default = module.exports.default = $138c887dc5ea0961$var$GoogleSlide16Icon;

});

parcelRegister("1kVaD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0f9401986b2d6c49$var$_react = $0f9401986b2d6c49$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $0f9401986b2d6c49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $0f9401986b2d6c49$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$0f9401986b2d6c49$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $0f9401986b2d6c49$var$_default = module.exports.default = $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon;

});

parcelRegister("aeJll", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $773e626dd1065814$var$_react = $773e626dd1065814$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $773e626dd1065814$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $773e626dd1065814$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $773e626dd1065814$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$773e626dd1065814$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $773e626dd1065814$var$_default = module.exports.default = $773e626dd1065814$var$PowerpointPresentation16Icon;

});

parcelRegister("8If3N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $657e1d6efd6121d9$var$_react = $657e1d6efd6121d9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $657e1d6efd6121d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $657e1d6efd6121d9$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $657e1d6efd6121d9$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$657e1d6efd6121d9$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $657e1d6efd6121d9$var$_default = module.exports.default = $657e1d6efd6121d9$var$WordDocument16Icon;

});

parcelRegister("8B1YK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6423506162d1ed28$var$_react = $6423506162d1ed28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $6423506162d1ed28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6423506162d1ed28$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $6423506162d1ed28$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$6423506162d1ed28$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $6423506162d1ed28$var$_default = module.exports.default = $6423506162d1ed28$var$PdfDocument16Icon;

});

parcelRegister("AzmWu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $06decc763d5ed155$var$_react = $06decc763d5ed155$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $06decc763d5ed155$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $06decc763d5ed155$var$Sketch16Icon = (props)=>/*#__PURE__*/ $06decc763d5ed155$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$06decc763d5ed155$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $06decc763d5ed155$var$_default = module.exports.default = $06decc763d5ed155$var$Sketch16Icon;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("9Q3yl", function(module, exports) {

var $5lkNm = parcelRequire("5lkNm");


var $6YXrY = parcelRequire("6YXrY");


var $8UJqr = parcelRequire("8UJqr");

const $c22c9af788df97f8$export$68f3db7f6af48bcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8UJqr.ConfluenceIcon), (0, $5lkNm.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $c22c9af788df97f8$export$68f3db7f6af48bcb;

});

parcelRegister("rECdA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("fLtAn", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $j39Hd = parcelRequire("j39Hd");

const $aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE = 'smart-card-social-proof';
const $aff19b92c38e9221$export$f44b87513fae83d9 = 'site-cloud-id:v1:';
const $aff19b92c38e9221$export$a99d139543208cca = 86400000;
const $aff19b92c38e9221$var$smartCardStorage = new (0, $6YrB3.default)($aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE);
function $aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
function $aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash = '') {
    return `${$aff19b92c38e9221$export$f44b87513fae83d9}${encodeURIComponent($aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash))}`;
}
const $aff19b92c38e9221$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${$aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE}_${$aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash)}`;
const $aff19b92c38e9221$export$b4b75b5ce5d33ae5 = $aff19b92c38e9221$export$dea1a8bc5840f118();
class $aff19b92c38e9221$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $aff19b92c38e9221$var$smartCardStorage.getItem($aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $aff19b92c38e9221$var$smartCardStorage.setItemWithExpiry($aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash), cloudId, $aff19b92c38e9221$export$a99d139543208cca);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = $aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $j39Hd.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
const $aff19b92c38e9221$export$1956112846aa829e = new $aff19b92c38e9221$export$a15da722a3b05509();
function $aff19b92c38e9221$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return $aff19b92c38e9221$export$1956112846aa829e.getStoredCloudId(baseUriWithNoTrailingSlash);
}
const $aff19b92c38e9221$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>$aff19b92c38e9221$export$1956112846aa829e.get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudIdSync"] = $aff19b92c38e9221$export$763646cf0dfa675c;
module.exports["getCurrentSiteCloudId"] = $aff19b92c38e9221$export$143af22820ae9de;

});

parcelRegister("fzDaA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $16kNn = parcelRequire("16kNn");

// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $fb41cb56e8ed3651$var$ROOT_MARGIN_VERTICAL = '360px';
const $fb41cb56e8ed3651$var$useIntersectionObserver = ({ onIntersecting: onIntersectingCallback, onIntersection: onIntersectionCallback })=>{
    const ref = (0, $cozmU.useRef)(null);
    const onIntersectingCallbackRef = (0, $cozmU.useRef)(onIntersectingCallback);
    const onIntersectionCallbackRef = (0, $cozmU.useRef)(onIntersectionCallback);
    (0, $cozmU.useEffect)(()=>{
        onIntersectingCallbackRef.current = onIntersectingCallback;
        onIntersectionCallbackRef.current = onIntersectionCallback;
    }, [
        onIntersectingCallback,
        onIntersectionCallback
    ]);
    const onIntersection = (0, $cozmU.useCallback)((entries, observer)=>{
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        onIntersectionCallbackRef.current?.(isIntersecting);
        if (isIntersecting) {
            onIntersectingCallbackRef.current?.();
            observer.disconnect();
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $16kNn.isIntersectionObserverSupported)() || !ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$fb41cb56e8ed3651$var$ROOT_MARGIN_VERTICAL} 0px ${$fb41cb56e8ed3651$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    return ref;
};
var $fb41cb56e8ed3651$export$2e2bcd8739ae039 = $fb41cb56e8ed3651$var$useIntersectionObserver;
module.exports["default"] = $fb41cb56e8ed3651$export$2e2bcd8739ae039;

});

parcelRegister("4xRBl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Vsq4 = parcelRequire("6Vsq4");


var $1smAh = parcelRequire("1smAh");


var $4abK1 = parcelRequire("4abK1");

function $cfe56479f167f818$export$c721b83ca330cb86({ appearance: appearance, children: children, id: id, ui: ui, url: url = '' }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { getByUrl: getByUrl } = (0, $1smAh.useSmartLinkAnalyticsUtils)();
    const getAnalyticsProps = (0, $cozmU.useCallback)(()=>{
        const isFlexibleUi = (0, $4abK1.isFlexibleUiCard)(children, ui);
        const display = isFlexibleUi ? 'flexible' : appearance;
        return {
            display: display,
            id: id
        };
    }, [
        appearance,
        children,
        id,
        ui
    ]);
    const statusRef = (0, $cozmU.useRef)();
    const analyticsPropsRef = (0, $cozmU.useRef)(null);
    const hasIntersectedRef = (0, $cozmU.useRef)(false);
    const hasFiredSeenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        analyticsPropsRef.current = getAnalyticsProps();
    }, [
        getAnalyticsProps
    ]);
    const maybeFireSeenEvent = (0, $cozmU.useCallback)(()=>{
        if (!hasFiredSeenRef.current && hasIntersectedRef.current && statusRef.current === 'unauthorized') {
            const payload = getByUrl(url, analyticsPropsRef.current);
            fireEvent('ui.smartLink.seen', payload?.attributes);
            hasFiredSeenRef.current = true;
        }
    }, [
        fireEvent,
        getByUrl,
        url
    ]);
    const onIntersecting = (0, $cozmU.useCallback)(()=>{
        if (hasIntersectedRef.current) return;
        hasIntersectedRef.current = true;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    const onStatusSettled = (0, $cozmU.useCallback)((status)=>{
        statusRef.current = status;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onIntersecting: onIntersecting,
            onStatusSettled: onStatusSettled
        }), [
        onIntersecting,
        onStatusSettled
    ]);
}
module.exports["useSmartLinkSeenEvent"] = $cfe56479f167f818$export$c721b83ca330cb86;

});

parcelRegister("lL0wb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $3bb02ff4d0bc6181$var$CardLoaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance, children: children }, ref)=>{
    const Component = appearance === 'inline' ? 'span' : 'div';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        className: "loader-wrapper",
        ref: ref
    }, children));
});
var $3bb02ff4d0bc6181$export$2e2bcd8739ae039 = $3bb02ff4d0bc6181$var$CardLoaderWrapper;
module.exports["default"] = $3bb02ff4d0bc6181$export$2e2bcd8739ae039;

});

parcelRegister("59u5K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8OcYi = parcelRequire("8OcYi");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $hFGFI = parcelRequire("hFGFI");


var $jdqmT = parcelRequire("jdqmT");


var $2Q7sv = parcelRequire("2Q7sv");


var $dz9dk = parcelRequire("dz9dk");


var $hsgLh = parcelRequire("hsgLh");


var $16kNn = parcelRequire("16kNn");


var $b6maq = parcelRequire("b6maq");


var $l1f3f = parcelRequire("l1f3f");


var $1smAh = parcelRequire("1smAh");


var $5C2uB = parcelRequire("5C2uB");


var $4abK1 = parcelRequire("4abK1");


var $98Qqv = parcelRequire("98Qqv");


var $hxi7d = parcelRequire("hxi7d");


var $8rblg = parcelRequire("8rblg");


var $bVAqi = parcelRequire("bVAqi");


var $dsoKG = parcelRequire("dsoKG");


var $19KQj = parcelRequire("19KQj");


var $jZn4j = parcelRequire("jZn4j");


var $4lJUs = parcelRequire("4lJUs");

const $6c8ebed741634f4e$var$thirdPartyARIPrefix = 'ari:third-party';
function $6c8ebed741634f4e$var$Component({ id: id, url: url, title: title, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    let isFlexibleUi = (0, $cozmU.useMemo)(()=>(0, $4abK1.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    // appearance is pre-resolved by the caller (loader.tsx for Card, ssr.tsx for CardSSR):
    // FlexibleCards are always passed appearance='block' when FG is on, so component.tsx
    // simply consumes whatever appearance it receives.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $hFGFI.useSmartLink)(id, url, appearance);
    const ari = (0, $2Q7sv.getObjectAri)(state.details);
    const name = (0, $2Q7sv.getObjectName)(state.details);
    const definitionId = (0, $2Q7sv.getDefinitionId)(state.details);
    const extensionKey = (0, $2Q7sv.getExtensionKey)(state.details);
    const resourceType = (0, $2Q7sv.getResourceType)(state.details);
    const services = (0, $2Q7sv.getServices)(state.details);
    const thirdPartyARI = (0, $2Q7sv.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $2Q7sv.getFirstPartyIdentifier)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: state.details
    });
    const actionOptions = (0, $b6maq.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // TODO: [ZS] Add new experiment flag to determine if the Rovo Actions CTA should be shown
    const rovoActionsCtaShown = false;
    const fire3PClickEvent = (0, $iDrrr.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $19KQj.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = thirdPartyARI && thirdPartyARI.startsWith($6c8ebed741634f4e$var$thirdPartyARIPrefix) && (0, $2Q7sv.getClickUrl)(url, state.details) === url && fire3PClickEvent && (0, $iDrrr.fg)('platform_smartlink_3pclick_analytics');
    const getDestinationUrl = (0, $cozmU.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $2Q7sv.getClickUrl)(url, state.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        state.details,
        url
    ]);
    // Setup UI handlers.
    const handleClickWrapper = (0, $cozmU.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $16kNn.isSpecialKey)(event) || (0, $16kNn.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $4yYAm.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (shouldFire3PClickEvent) // For questions or concerns about this event,
        // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
        fire3PClickEvent?.();
        const isDisablePreviewPanel = disablePreviewPanel && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            // FIXME: InlineCard, BlockCard and EmbedCard call event.preventDefault() internally
            // before the event bubbles up to this handler. This forces us to snapshot
            // event.defaultPrevented before calling onClick to detect whether the consumer
            // specifically prevented navigation. Ideally those components should not call
            // preventDefault so this workaround can be removed.
            const isEventDefaultPrevented = event.defaultPrevented;
            const canOpenPreviewPanel = !isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
                ari: ari
            }) && !isDisablePreviewPanel;
            // Preview panel takes priority over link navigation when available.
            if (canOpenPreviewPanel) {
                event.preventDefault();
                event.stopPropagation();
                openPreviewPanel({
                    url: url,
                    ari: ari,
                    name: name,
                    iconUrl: (0, $2Q7sv.getObjectIconUrl)(state.details),
                    panelData: {
                        embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(state.details)?.src : undefined
                    }
                });
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                    attributes: {
                        clickOutcome: 'previewPanel'
                    }
                });
                return;
            }
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
            // For FlexibleCard, read target from the clicked anchor element (e.g. _blank for links
            // rendered with explicit target). For classic cards, default to _self
            const { target: anchorTarget } = (0, $5C2uB.getAnchorAttributesFromEvent)(event);
            const target = (0, $16kNn.isSpecialEvent)(event) ? '_blank' : isFlexibleUi ? anchorTarget : '_self';
            onClick?.(event, {
                url: url,
                destinationUrl: destinationUrl
            });
            // Check if the event is prevented via onClick callback
            const consumerPreventedNavigation = event.defaultPrevented && !isEventDefaultPrevented;
            // Classic cards (InlineCard, BlockCard, EmbedCard) rely on their own anchor navigation
            // when onClick is provided, so this handler should not open the link for them.
            // FlexibleCard's anchor is prevented from native navigation, so this handler always
            // opens the link for FlexibleCard unless the consumer's onClick called preventDefault.
            const shouldOpenLink = isFlexibleUi || !onClick;
            const doOpenLink = shouldOpenLink && !consumerPreventedNavigation;
            if (doOpenLink) {
                event.preventDefault();
                window.open(destinationUrl, target);
            }
            // Only set clickOutcome when this handler actually opened the link.
            // If a parent onClick handled navigation, fire a generic click event instead.
            (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, doOpenLink ? {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            } : undefined);
        } else {
            // If preview panel is available and the user clicked on the link,
            // delegate the click to the preview panel handler
            if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
                ari: ari
            }) && !isDisablePreviewPanel) {
                event.preventDefault();
                event.stopPropagation();
                openPreviewPanel({
                    url: url,
                    ari: ari,
                    name: name,
                    iconUrl: (0, $2Q7sv.getObjectIconUrl)(state.details),
                    panelData: {
                        embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(state.details)?.src : undefined
                    }
                });
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                    attributes: {
                        clickOutcome: 'previewPanel'
                    }
                });
                return;
            } else if (!onClick && !isFlexibleUi) {
                const clickUrl = (0, $2Q7sv.getClickUrl)(url, state.details);
                // Ctrl+left click on mac typically doesn't trigger onClick
                // The event could have potentially had `e.preventDefault()` called on it by now
                // event by smart card internally
                // If it has been called then only then can `isSpecialEvent` be true.
                const target = (0, $16kNn.isSpecialEvent)(event) ? '_blank' : '_self';
                window.open(clickUrl, target);
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                    attributes: {
                        clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                    }
                });
            } else {
                if (onClick) onClick(event);
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event);
            }
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        getDestinationUrl,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        shouldFire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        disablePreviewPanel
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameAuxClick = (0, $cozmU.useCallback)((event)=>{
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
        }
        // isAuxClick filters Windows right-clicks (button === 2) that also fire onAuxClick.
        if ((0, $5C2uB.isAuxClick)(event) && shouldFire3PClickEvent) fire3PClickEvent?.({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameContextMenu = (0, $cozmU.useCallback)((event)=>{
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
        }
        if (shouldFire3PClickEvent) fire3PClickEvent?.({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent
    ]);
    const { reload: reload } = actions;
    const handleAuthorize = (0, $cozmU.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $cozmU.useCallback)(()=>{
        reload();
    }, [
        reload
    ]);
    const hasMounted = (0, $cozmU.useRef)(false);
    const prevAppearance = (0, $cozmU.useRef)(appearance);
    // When appearance changes from inline to non-inline on a mounted card
    // (e.g. direct consumer changes inline → block/embed), reload with the new appearance
    // so ORS can return the appropriate full data. We intentionally do NOT reload on
    // block → embed or embed → block transitions since both already have full ORS data.
    (0, $cozmU.useEffect)(()=>{
        if (!hasMounted.current) {
            hasMounted.current = true;
            prevAppearance.current = appearance;
            return;
        }
        if (prevAppearance.current === 'inline' && appearance !== 'inline' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) reload(appearance);
        prevAppearance.current = appearance;
    }, [
        appearance,
        reload
    ]);
    const handleInvoke = (0, $cozmU.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    const experimentMetaEventAttributes = (0, $4lJUs.default)({
        actionOptions: actionOptions,
        appearance: appearance,
        state: state
    });
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $cozmU.useEffect)(()=>{
        $98Qqv.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $98Qqv.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $98Qqv.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError' && state.error?.name !== 'InvalidUrlError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $cozmU.useEffect)(()=>{
        if ((0, $2Q7sv.isFinalState)(state.status)) {
            (0, $jdqmT.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $jdqmT.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance,
                ...appearance === 'inline' && {
                    rovoActionsCtaShown: rovoActionsCtaShown
                },
                ...experimentMetaEventAttributes && {
                    experimentMeta: experimentMetaEventAttributes
                }
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        rovoActionsCtaShown,
        state.status,
        experimentMetaEventAttributes
    ]);
    const onIframeDwell = (0, $cozmU.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'focus'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseEnter = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseenter'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseLeave = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseleave'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVAqi.default), {
            id: id,
            cardState: cardState,
            placeholderData: placeholderData,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            onAuxClick: handleFrameAuxClick,
            onContextMenu: handleFrameContextMenu,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            title: title,
            testId: testId,
            onResolve: onResolve,
            onError: onError
        }, children);
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dsoKG.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hxi7d.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8rblg.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $6c8ebed741634f4e$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $4abK1.isFlexibleUiCard)(props.children, props?.ui) ? (0, $4yYAm.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsgLh.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
        url: props.url,
        id: props.id,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c8ebed741634f4e$var$Component, props)));
};
const $6c8ebed741634f4e$export$d4ee8167ac732647 = (0, $jZn4j.default)($6c8ebed741634f4e$export$7598f5d7c597dd32);
module.exports["CardWithUrlContent"] = $6c8ebed741634f4e$export$7598f5d7c597dd32;
module.exports["CardWithUrl"] = $6c8ebed741634f4e$export$d4ee8167ac732647;

});

parcelRegister("hFGFI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");


var $iUTeb = parcelRequire("iUTeb");


var $isphl = parcelRequire("isphl");


var $9ojsk = parcelRequire("9ojsk");


var $9H66G = parcelRequire("9H66G");

function $13cbf7ecf495c2ea$export$9f4e486b1dc3e700(id, url, appearance) {
    const state = (0, $9H66G.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $cMyWi.useSmartLinkContext)();
    const actions = (0, $iUTeb.useSmartCardActions)(id, url);
    const config = (0, $isphl.useSmartLinkConfig)();
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $cozmU.useState)(null);
    // Register the current card with appearance hint for optimized ORS response.
    const register = ()=>{
        actions.register((0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? appearance : undefined).catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        isPreviewRestricted: (0, $iDrrr.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined,
        openPreviewPanel: openPreviewPanel
    };
}
module.exports["useSmartLink"] = $13cbf7ecf495c2ea$export$9f4e486b1dc3e700;

});

parcelRegister("isphl", function(module, exports) {

var $cMyWi = parcelRequire("cMyWi");

const $4cb46df851842e38$export$5d10838c1e539409 = ()=>{
    const context = (0, $cMyWi.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};
module.exports["useSmartLinkConfig"] = $4cb46df851842e38$export$5d10838c1e539409;

});

parcelRegister("b6maq", function(module, exports) {
const $5b32e42d109a17bd$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};
module.exports["combineActionOptions"] = $5b32e42d109a17bd$export$2ae4cf79c720146a;

});

parcelRegister("hxi7d", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");


var $g3QJw = parcelRequire("g3QJw");


var $7LU3Q = parcelRequire("7LU3Q");


var $ghw3R = parcelRequire("ghw3R");


var $h1uyX = parcelRequire("h1uyX");


var $lhtoR = parcelRequire("lhtoR");


var $iGSW0 = parcelRequire("iGSW0");


var $hRrmV = parcelRequire("hRrmV");


var $3D9Fp = parcelRequire("3D9Fp");


var $etAbL = parcelRequire("etAbL");

const $958d842453deb70e$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-block-card"
    }), children);
const $958d842453deb70e$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $ghw3R.handleClickCommon)(event, handleFrameClick),
        onAuxClick: handleFrameAuxClick,
        onContextMenu: handleFrameContextMenu,
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $g3QJw.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($958d842453deb70e$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3D9Fp.default), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            }));
        case 'resolved':
            if ((0, $7LU3Q.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etAbL.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3D9Fp.default), blockCardProps);
        case 'unauthorized':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etAbL.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iGSW0.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRrmV.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h1uyX.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lhtoR.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};
module.exports["BlockCard"] = $958d842453deb70e$export$d18ccd25c0d2c6b0;

});

parcelRegister("g3QJw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $e8b011f03e2ed95f$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $cMyWi.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};
module.exports["useControlDataExportConfig"] = $e8b011f03e2ed95f$export$f93c47f1b2b3f55b;

});

parcelRegister("7LU3Q", function(module, exports) {
const $97c57299ded7b56e$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));
module.exports["getIsDataExportEnabled"] = $97c57299ded7b56e$export$a019611f39785186;

});

parcelRegister("ghw3R", function(module, exports) {
const $d65ac04b6e155b42$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};
module.exports["handleClickCommon"] = $d65ac04b6e155b42$export$9759a67e215c4598;

});

parcelRegister("lhtoR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lMGh1 = parcelRequire("lMGh1");


var $dM7c5 = parcelRequire("dM7c5");


var $cZnAt = parcelRequire("cZnAt");


var $8HHLm = parcelRequire("8HHLm");


var $l8ou8 = parcelRequire("l8ou8");


var $j7u0e = parcelRequire("j7u0e");

/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ef07791dc4abcf0a$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $cozmU.useMemo)(()=>props.onAuthorize ? [
            (0, $8HHLm.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8ou8.default), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "errored-warning-icon",
        color: "var(--ds-icon-warning, #E06C00)",
        testId: `${testId}-warning-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $dM7c5.messages).could_not_load_link
        }
    }));
};
const $ef07791dc4abcf0a$var$_default_1 = (0, $j7u0e.withFlexibleUIBlockCardStyle)($ef07791dc4abcf0a$var$ErroredView);
var $ef07791dc4abcf0a$export$2e2bcd8739ae039 = $ef07791dc4abcf0a$var$_default_1;
module.exports["default"] = $ef07791dc4abcf0a$export$2e2bcd8739ae039;

});

parcelRegister("8HHLm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

const $0456bba425094b84$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $4yYAm.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).try_again),
        testId: 'smart-action-try-again'
    });
module.exports["RetryAction"] = $0456bba425094b84$export$c527d977b53f7537;

});

parcelRegister("l8ou8", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $a3Cph = parcelRequire("a3Cph");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");

var $hSS22 = parcelRequire("hSS22");

var $voDgt = parcelRequire("voDgt");

var $jdA6O = parcelRequire("jdA6O");


var $buLMw = parcelRequire("buLMw");

const $e296049f8e718ff9$var$customBlockStyles = null;
const $e296049f8e718ff9$var$titleBlockCss = null;
const $e296049f8e718ff9$var$footerBlockCss = null;
const $e296049f8e718ff9$var$footerBlockSafariStyles = null;
const $e296049f8e718ff9$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $cozmU.useMemo)(()=>(0, $a3Cph.browser)(), []);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $buLMw.FlexibleCardUiOptions),
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
        ...(0, $buLMw.titleBlockOptions),
        hideIcon: !!title,
        text: title,
        CompetitorPrompt: CompetitorPrompt,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2C9dkJ7GSX _0c6yoiM7Tp"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLchRC _4xdlr0FlnN _0wzsVTdnbC _1xYrcmy7kJ"
        ])
    }, children), showPreview && /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), (0, $buLMw.PreviewBlockOptions)), /*#__PURE__*/ $cozmU.createElement((0, $hSS22.default), {
        actions: actions,
        testId: "smart-block-card-footer",
        className: (0, $hekY6.default)([
            "_0jFU0V9DVM _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN",
            safari && "_0jFU0VN91d"
        ])
    }));
};
var $e296049f8e718ff9$export$2e2bcd8739ae039 = $e296049f8e718ff9$var$UnresolvedView;
module.exports["default"] = $e296049f8e718ff9$export$2e2bcd8739ae039;

});

parcelRegister("buLMw", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $eeqm3 = parcelRequire("eeqm3");


var $2Q7sv = parcelRequire("2Q7sv");

const $791079cdeeb65697$var$baseTopMetadata = [
    {
        name: (0, $4yYAm.ElementName).ModifiedOn
    },
    {
        name: (0, $4yYAm.ElementName).AttachmentCount
    },
    {
        name: (0, $4yYAm.ElementName).SubscriberCount
    },
    {
        name: (0, $4yYAm.ElementName).VoteCount
    },
    {
        name: (0, $4yYAm.ElementName).DueOn
    },
    {
        name: (0, $4yYAm.ElementName).ReadTime
    }
];
const $791079cdeeb65697$var$baseBottomMetaData = [
    {
        name: (0, $4yYAm.ElementName).ReactCount
    },
    {
        name: (0, $4yYAm.ElementName).CommentCount
    },
    {
        name: (0, $4yYAm.ElementName).ViewCount
    },
    {
        name: (0, $4yYAm.ElementName).Priority
    },
    {
        name: (0, $4yYAm.ElementName).SubTasksProgress
    },
    {
        name: (0, $4yYAm.ElementName).ChecklistProgress
    }
];
const $791079cdeeb65697$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $4yYAm.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $4yYAm.ElementName).AuthorGroup
        },
        {
            name: (0, $4yYAm.ElementName).CreatedBy
        },
        ...$791079cdeeb65697$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $791079cdeeb65697$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $4yYAm.ElementName).LatestCommit
                    },
                    {
                        name: (0, $4yYAm.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $eeqm3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4yYAm.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).OwnedBy
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AppliedToComponentsCount
                    },
                    ...$791079cdeeb65697$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
        case 'mercury-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $eeqm3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4yYAm.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).OwnedBy
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AppliedToComponentsCount
                    },
                    ...$791079cdeeb65697$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $eeqm3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4yYAm.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).OwnedBy
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $4yYAm.ElementName).AuthorGroup
                },
                {
                    name: (0, $4yYAm.ElementName).CreatedBy
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $4yYAm.ElementName).AssignedToGroup
                },
                {
                    name: (0, $4yYAm.ElementName).AssignedTo
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $4yYAm.ElementName).OwnedByGroup
                },
                {
                    name: (0, $4yYAm.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).StoryPoints
                    },
                    {
                        name: (0, $4yYAm.ElementName).Priority
                    },
                    {
                        name: (0, $4yYAm.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).ReactCount
                    },
                    {
                        name: (0, $4yYAm.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).CollaboratorGroup
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $4yYAm.ElementName).UserAttributes
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $791079cdeeb65697$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $791079cdeeb65697$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $4yYAm.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $4yYAm.SmartLinkSize).Large
};
const $791079cdeeb65697$export$9671929f11bd4ad8 = {
    placement: (0, $4yYAm.MediaPlacement).Right,
    ignoreContainerPadding: true
};
module.exports["getSimulatedBetterMetadata"] = $791079cdeeb65697$export$f87d357259b3b7c8;
module.exports["FlexibleCardUiOptions"] = $791079cdeeb65697$export$22ebf74c8bee4708;
module.exports["titleBlockOptions"] = $791079cdeeb65697$export$45bdb4108909a713;
module.exports["PreviewBlockOptions"] = $791079cdeeb65697$export$9671929f11bd4ad8;

});

parcelRegister("j7u0e", function(module, exports) {
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $772dc4e1baeec1f1$var$flexibleBlockCardStyle = null;
const $772dc4e1baeec1f1$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3rPG7s8fU6 _48rQAxOeNX"
            ])
        }, /*#__PURE__*/ $cozmU.createElement(FlexibleBlockCardView, props));
    };
module.exports["withFlexibleUIBlockCardStyle"] = $772dc4e1baeec1f1$export$36ce1a3a446661ab;

});

parcelRegister("iGSW0", function(module, exports) {
/* ForbiddenView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4efpo = parcelRequire("4efpo");


var $hHrlI = parcelRequire("hHrlI");


var $leSBv = parcelRequire("leSBv");


var $gCfXH = parcelRequire("gCfXH");


var $dM7c5 = parcelRequire("dM7c5");


var $dr8Ob = parcelRequire("dr8Ob");


var $8p295 = parcelRequire("8p295");


var $cZnAt = parcelRequire("cZnAt");


var $a8mq4 = parcelRequire("a8mq4");


var $l8ou8 = parcelRequire("l8ou8");


var $j7u0e = parcelRequire("j7u0e");

const $4f2a8e9f717802a0$var$textStyles = null; /**
                          * This view represent a Block Card with the 'Forbidden' status.
                          * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
                          *
                          * @see SmartLinkStatus
                          * @see FlexibleCardProps
                          */ 
const $4f2a8e9f717802a0$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
    const provider = (0, $hHrlI.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $cozmU.useMemo)(()=>{
        const hostname = /*#__PURE__*/ $cozmU.createElement("b", null, (0, $gCfXH.default)(url));
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $cozmU.useMemo)(()=>{
        return (0, $leSBv.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $cozmU.useMemo)(()=>{
        const descriptor = (0, $dr8Ob.toMessage)((0, $dM7c5.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $cozmU.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $a8mq4.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $a8mq4.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $l8ou8.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "forbidden-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $cozmU.createElement((0, $cZnAt.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $dr8Ob.toMessage)((0, $dM7c5.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
            values: messageContext
        },
        className: (0, $hekY6.default)([
            "_1UtDYzy7kJ"
        ])
    }));
};
const $4f2a8e9f717802a0$var$_default_1 = (0, $j7u0e.withFlexibleUIBlockCardStyle)($4f2a8e9f717802a0$var$ForbiddenView);
var $4f2a8e9f717802a0$export$2e2bcd8739ae039 = $4f2a8e9f717802a0$var$_default_1;
module.exports["default"] = $4f2a8e9f717802a0$export$2e2bcd8739ae039;

});

parcelRegister("dr8Ob", function(module, exports) {

var $dM7c5 = parcelRequire("dM7c5");

const $393972733951d863$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $dM7c5.messages)) return (0, $dM7c5.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};
module.exports["toMessage"] = $393972733951d863$export$d14c2a6dee946f52;

});

parcelRegister("a8mq4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

const $27b19f6e931b03a4$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $4yYAm.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });
module.exports["ForbiddenAction"] = $27b19f6e931b03a4$export$59f8830fb5467e35;

});

parcelRegister("hRrmV", function(module, exports) {
/* NotFoundView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $4efpo = parcelRequire("4efpo");


var $hHrlI = parcelRequire("hHrlI");


var $dM7c5 = parcelRequire("dM7c5");


var $cZnAt = parcelRequire("cZnAt");


var $l8ou8 = parcelRequire("l8ou8");


var $j7u0e = parcelRequire("j7u0e");

const $190fb10d746b139d$var$textStyles = null; /**
                          * This view represents a Block Card with a 'Not_Found' status.
                          *
                          * @see SmartLinkStatus
                          * @see FlexibleCardProps
                          */ 
const $190fb10d746b139d$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cardState: { details: details } } = props;
    const product = (0, $cozmU.useMemo)(()=>{
        const provider = (0, $hHrlI.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $cozmU.useMemo)(()=>intl.formatMessage((0, $dM7c5.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $cozmU.useMemo)(()=>({
            descriptor: (0, $dM7c5.messages).not_found_description
        }), []);
    return /*#__PURE__*/ $cozmU.createElement((0, $l8ou8.default), {
        ...props,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "not-found-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $cozmU.createElement((0, $cZnAt.default), {
        message: description,
        testId: `${testId}-message`,
        maxLines: 3,
        className: (0, $hekY6.default)([
            "_1UtDYzy7kJ"
        ])
    }));
};
const $190fb10d746b139d$var$_default_1 = (0, $j7u0e.withFlexibleUIBlockCardStyle)($190fb10d746b139d$var$NotFoundView);
var $190fb10d746b139d$export$2e2bcd8739ae039 = $190fb10d746b139d$var$_default_1;
module.exports["default"] = $190fb10d746b139d$export$2e2bcd8739ae039;

});

parcelRegister("3D9Fp", function(module, exports) {
/* ResolvedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $a3Cph = parcelRequire("a3Cph");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $irGZZ = parcelRequire("irGZZ");


var $2Q7sv = parcelRequire("2Q7sv");


var $aXSHN = parcelRequire("aXSHN");


var $8QLAc = parcelRequire("8QLAc");


var $edVsK = parcelRequire("edVsK");


var $bVAqi = parcelRequire("bVAqi");


var $aKJEB = parcelRequire("aKJEB");

var $i1503 = parcelRequire("i1503");

var $voDgt = parcelRequire("voDgt");

var $es2gJ = parcelRequire("es2gJ");

var $jdA6O = parcelRequire("jdA6O");


var $buLMw = parcelRequire("buLMw");


var $j7u0e = parcelRequire("j7u0e");

const $4ca1983200af5b1b$var$titleBlockCss = null;
const $4ca1983200af5b1b$var$footerBlockCssOld = null;
const $4ca1983200af5b1b$var$footerBlockCss = null;
const $4ca1983200af5b1b$var$footerExtraSpacingCss = null;
const $4ca1983200af5b1b$var$footerBlockSafariStyles = null; /**
                                       * This view represents a Block card that has an 'Resolved' status.
                                       * @see SmartLinkStatus
                                       * @see FlexibleCardProps
                                       */ 
const $4ca1983200af5b1b$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $cozmU.useState)(false);
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const is3PRovoBlockRovoActionEnabled = (0, $aXSHN.default)(url, actionOptions);
    const rovoConfig = (0, $8QLAc.default)(); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $cozmU.useMemo)(()=>(0, $a3Cph.browser)(), []);
    (0, $cozmU.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $buLMw.getSimulatedBetterMetadata)(cardState.details);
    const prompts = (0, $cozmU.useMemo)(()=>{
        if (is3PRovoBlockRovoActionEnabled) {
            const defaultPrompts = [
                (0, $edVsK.RovoChatPromptKey).KEY_HIGHLIGHTS
            ];
            const linkType = cardState.details?.data?.['@type'];
            if (extensionKey === 'slack-object-provider') return [
                (0, $edVsK.RovoChatPromptKey).FIND_OPEN_QUESTIONS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType?.includes('schema:PresentationDigitalDocument')) return [
                (0, $edVsK.RovoChatPromptKey).IDENTIFY_KEY_POINTS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType?.includes('schema:SpreadsheetDigitalDocument')) return [
                (0, $edVsK.RovoChatPromptKey).IDENTIFY_KEY_TRENDS,
                ...defaultPrompts
            ];
            return [
                (0, $edVsK.RovoChatPromptKey).SUMMARIZE_LINK,
                ...defaultPrompts
            ];
        }
        return [];
    }, [
        cardState?.details?.data,
        extensionKey,
        is3PRovoBlockRovoActionEnabled
    ]);
    const footerActions = (0, $cozmU.useMemo)(()=>{
        const showRovoResolvedView = cardState?.status === 'resolved' && cardState.details && (0, $irGZZ.default)({
            response: cardState.details,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions
        }) !== undefined;
        return showRovoResolvedView && is3PRovoBlockRovoActionEnabled ? [
            {
                name: (0, $4yYAm.ActionName).RovoChatAction,
                prompts: prompts,
                iconSize: 'small',
                cardAppearance: (0, $4yYAm.CardDisplay).Block
            },
            {
                name: (0, $4yYAm.ActionName).FollowAction,
                iconSize: 'small'
            },
            {
                name: (0, $4yYAm.ActionName).DownloadAction,
                iconSize: 'small'
            }
        ] : [
            {
                name: (0, $4yYAm.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).DownloadAction,
                hideIcon: true
            }
        ];
    }, [
        prompts,
        is3PRovoBlockRovoActionEnabled,
        cardState,
        rovoConfig,
        actionOptions
    ]);
    const uiOptions = (0, $buLMw.FlexibleCardUiOptions);
    uiOptions.enableSnippetRenderer = true;
    uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
        ...(0, $buLMw.titleBlockOptions),
        metadata: titleMetadata,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Location
            }
        ],
        metadataPosition: (0, $4yYAm.SmartLinkPosition).Top,
        CompetitorPrompt: CompetitorPrompt,
        url: url,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2C9dkJ7GSX _0c6yoiM7Tp"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $i1503.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), null), /*#__PURE__*/ $cozmU.createElement((0, $i1503.default), {
        primary: bottomMetadata,
        maxLines: 1
    }), !isPreviewBlockErrored ? /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
        ...(0, $buLMw.PreviewBlockOptions),
        onError: ()=>{
            setIsPreviewBlockErrored(true);
        }
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $aKJEB.default), {
        actions: footerActions,
        isPreviewBlockErrored: isPreviewBlockErrored,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('navx-5343-sl-action-block-styling-fixes') ? "_0jFU0VfFOW _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN" : "_0jFU0V9DVM _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN",
            safari && "_0jFU0VN91d",
            (0, $iDrrr.fg)('platform_navx_block_card_footer_spacing') && "_3138422ADO"
        ])
    }));
};
const $4ca1983200af5b1b$var$_default_1 = (0, $j7u0e.withFlexibleUIBlockCardStyle)($4ca1983200af5b1b$var$ResolvedView);
var $4ca1983200af5b1b$export$2e2bcd8739ae039 = $4ca1983200af5b1b$var$_default_1;
module.exports["default"] = $4ca1983200af5b1b$export$2e2bcd8739ae039;

});

parcelRegister("aXSHN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aflIU = parcelRequire("aflIU");


var $2Q7sv = parcelRequire("2Q7sv");


var $9H66G = parcelRequire("9H66G");


var $8QLAc = parcelRequire("8QLAc");

const $4faa9ead3d7b0ad3$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
/**
 * Returns whether the rovo actions are enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $4faa9ead3d7b0ad3$var$useBlockCardRovoAction = (url, actionOptions)=>{
    const { rovoOptions: rovoConfig, product: product } = (0, $8QLAc.default)();
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn) return false;
        if (extensionKey && !$4faa9ead3d7b0ad3$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return false;
        return !!product && product === 'CONFLUENCE';
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $4faa9ead3d7b0ad3$export$2e2bcd8739ae039 = $4faa9ead3d7b0ad3$var$useBlockCardRovoAction;
module.exports["default"] = $4faa9ead3d7b0ad3$export$2e2bcd8739ae039;

});

parcelRegister("etAbL", function(module, exports) {
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $gBjHb = parcelRequire("gBjHb");


var $hHrlI = parcelRequire("hHrlI");


var $cMyWi = parcelRequire("cMyWi");


var $rECdA = parcelRequire("rECdA");


var $iMnC5 = parcelRequire("iMnC5");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $2Q7sv = parcelRequire("2Q7sv");


var $bnSsE = parcelRequire("bnSsE");


var $4bvRC = parcelRequire("4bvRC");


var $bVAqi = parcelRequire("bVAqi");


var $3M4EV = parcelRequire("3M4EV");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");


var $1xR0T = parcelRequire("1xR0T");


var $hsIfr = parcelRequire("hsIfr");

var $fIakH = parcelRequire("fIakH");


var $bhvUi = parcelRequire("bhvUi");


var $gj5b4 = parcelRequire("gj5b4");


var $1p3nb = parcelRequire("1p3nb");


var $buLMw = parcelRequire("buLMw");


var $j7u0e = parcelRequire("j7u0e");

const $de399e6481e0a2d0$var$contentStyles = null;
const $de399e6481e0a2d0$var$contentAdditionalStyles = null;
const $de399e6481e0a2d0$var$newTitleBlockStyles = null;
const $de399e6481e0a2d0$var$intermediumGapStyles = null;
const $de399e6481e0a2d0$var$titleBlockStyles = null;
const $de399e6481e0a2d0$var$previewBlockStyle = null;
const $de399e6481e0a2d0$var$previewBlockStyleWithOverlap = null;
const $de399e6481e0a2d0$var$linkIconStyles = null;
const $de399e6481e0a2d0$var$containerStyles = null;
const $de399e6481e0a2d0$var$previewBlockImageStyle = null;
const $de399e6481e0a2d0$var$styles = {
    titleBoxCard: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d"
};
const $de399e6481e0a2d0$var$getBetterTitle = (url)=>{
    // List of regexps to extract human-readable titles from URLs
    // Each regex should have a capture group for the title at index 1
    const titleExtractors = [
        // Dropbox: https://www.dropbox.com/scl/fi/scebraopvx4bni0sechq9/Atlas23_D1_A_0014.jpg?rlkey=... -> Atlas23_D1_A_0014.jpg
        /^https:\/\/www\.dropbox\.com\/scl\/fi\/[^\/]+\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home/Teamwork%20Ecosystem?preview=xsociety00.dat -> Teamwork Ecosystem
        /^https:\/\/www\.dropbox\.com\/home\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home?preview=Insomnia-All_2019-03-14.json -> Insomnia-All_2019-03-14.json
        /^https:\/\/www\.dropbox\.com\/home\?(?:.*?&)?preview=([^&#]+)/,
        // Dropbox: https://www.dropbox.com/preview/AI%20Contest -> AI Contest
        /^https:\/\/www\.dropbox\.com\/preview\/([^&?]+)/,
        // Dropbox: https://www.dropbox.com/s/votiehk00g4opif/xsociety00.dat?dl=0 -> xsociety00.dat
        /^https:\/\/www\.dropbox\.com\/(?:s|sh|sc|t)\/[^\/]+\/([^\/\?]+)/,
        // Figma: https://www.figma.com/slides/vW47To0dYPnT7jlrJdUd7h/Universal-Create-in-TwC?node-id=... -> Universal-Create-in-TwC
        // Also supports: /file/, /design/, /board/, /proto/
        /^https:\/\/(?:[\w.-]+\.)?figma\.com\/(?:design|board|file|proto|slides)\/[0-9a-zA-Z]{22,128}\/([^\/\?]+)/,
        // OneDrive: https://1drv.ms/w/s!ABC123DEF456/Project_Plan.docx?e=abcdEF -> Project_Plan.docx
        /^https:\/\/1drv\.ms\/[a-z]+\/s![^\/]+\/([^\/\?]+)/,
        // Miro: https://miro.com/app/board/uXjVOPnT123=/my-board-name/ -> my-board-name
        /^https:\/\/miro\.com\/app\/board\/[^\/]+\/([^\/\?]+)\/?/
    ]; // Try each extractor pattern
    for (const pattern of titleExtractors){
        const match = url.match(pattern);
        if (match) {
            const extracted = decodeURIComponent(match[1]);
            if (extracted) return extracted;
        }
    }
    try {
        const { pathname: pathname, search: search } = new URL(url);
        if (pathname.length > 1) return pathname.substring(1);
        if (search) return search;
         // Fall back to the full URL when there is no useful path/search to display,
        // so the title (and the underlying link) always has accessible text.
        return url;
    } catch  {
        return url;
    }
};
const $de399e6481e0a2d0$var$UnauthorisedBlock = ({ actions: actions, children: children, url: url, CompetitorPrompt: CompetitorPrompt, testId: testId })=>{
    const { ui: ui, data: data } = (0, $9PA4G.useFlexibleCardContext)() ?? {
        ui: undefined,
        data: undefined
    };
    const hasActions = actions && actions.length > 0;
    const actionGroup = hasActions ? /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        size: (0, $4yYAm.SmartLinkSize).Large,
        items: actions
    }) : null;
    const competitorPrompt = CompetitorPrompt && data?.url ? /*#__PURE__*/ $cozmU.createElement(CompetitorPrompt, {
        sourceUrl: data?.url,
        linkType: 'card'
    }) : null;
    const title = /*#__PURE__*/ $cozmU.createElement((0, $fIakH.default), {
        hideTooltip: false,
        maxLines: 1,
        theme: ui?.theme,
        text: $de399e6481e0a2d0$var$getBetterTitle(url),
        className: (0, $hekY6.default)([
            "_1kk5Tk7GSX _1UtDYzM7Tp"
        ])
    });
    const { position: position } = (0, $buLMw.titleBlockOptions);
    let overrideUrl = data?.preview?.url ?? (0, (/*@__PURE__*/$parcel$interopDefault($gj5b4)));
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...(0, $buLMw.titleBlockOptions),
        testId: `${testId}-errored-view`,
        className: (0, $hekY6.default)([
            "_0u2WMmrU95 _3n40gWrqxC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: (0, $4yYAm.SmartLinkSize).Medium,
        className: (0, $hekY6.default)([
            "_2mHwu88HPE"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        position: position,
        size: (0, $4yYAm.SmartLinkSize).Medium,
        isTiledIcon: true,
        className: (0, $hekY6.default)([
            "_267wa5YbGa"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: (0, $4yYAm.SmartLinkSize).Large,
        className: (0, $hekY6.default)([
            "_2mHwu8dnbC"
        ])
    }, competitorPrompt ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $de399e6481e0a2d0$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal
    }, (0, $1xR0T.renderElementItems)([
        {
            name: (0, $4yYAm.ElementName).HostName
        }
    ])))), children, actionGroup), hasActions ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02srRs _4xdlr0FlnN _3hrKbBYbGa",
            "_39xV02ToBl"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundImage: `url(${overrideUrl})`
        },
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VN91d _39xV02srRs _3OqcjTgIor _1DJ2rV715P _2z4m57UZDI"
        ])
    })) : null);
}; /**
    * This view represents a Block card that has an 'Unauthorized' status .
    * It should have a "Connect" button that will allow a user to connect their account and view the block card.
    *
    * @see SmartLinkStatus
    * @see FlexibleCardProps
    */ 
const $de399e6481e0a2d0$var$UnauthorisedViewFrame = ({ content: content, providerName: providerName, testId: testId, ...props })=>{
    const { onAuthorize: onAuthorize } = props;
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const actions = (0, $cozmU.useMemo)(()=>onAuthorize ? [
            (0, $bhvUi.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        appearance: "block",
        onAuthorize: onAuthorize,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $buLMw.FlexibleCardUiOptions),
        ...props
    }, /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedBlock, {
        actions: actions,
        cardState: props.cardState,
        CompetitorPrompt: props.CompetitorPrompt,
        testId: testId,
        url: props.url
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": `${testId}-content`,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ _3138422ADO",
            actions.length > 0 && "_4bt5LAnQyn _2WAcuGnQyn _1DCdHi5zaO _1EqgXlN91d _1ANEUSLRg7 _39HuIbz8Lp"
        ])
    }, content)));
};
const $de399e6481e0a2d0$var$UnauthorisedViewBase = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hHrlI.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $2Q7sv.hasAuthScopeOverrides)(cardState.details);
    const content = (0, $cozmU.useMemo)(()=>onAuthorize ? /*#__PURE__*/ $cozmU.createElement((0, $4bvRC.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    return /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewFrame, {
        ...props,
        content: content,
        providerName: providerName,
        testId: testId
    });
}; /**
    * Experiment wrapper: fires social proof exposure and renders social proof UI when FG is on.
    * TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    */ 
const $de399e6481e0a2d0$var$UnauthorisedViewWithExperiment = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const extensionKey = props.cardState?.details?.meta?.key;
    (0, $6cFsl.di)((0, $bnSsE.default));
    const providerName = (0, $hHrlI.extractSmartLinkProvider)(props.cardState.details)?.text;
    const { connections: connections } = (0, $cMyWi.useSmartLinkContext)();
    const { isTreatment: isTreatment, tier: tier, connectedPct: connectedPct } = (0, $bnSsE.default)(providerName ? extensionKey : undefined, connections.client.baseUrlOverride);
    const socialProofExperimentMeta = (0, $bnSsE.getSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: connections.client.baseUrlOverride
    });
    const analyticsContextData = {
        attributes: {
            experiment: 'social_proof_3p_unauth_block_exp',
            cohort: isTreatment ? 'treatment' : 'control',
            tier: tier,
            experimentMeta: socialProofExperimentMeta
        }
    };
    if (!isTreatment || !providerName) {
        const fallbackView = /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewBase, {
            ...props,
            testId: testId
        });
        return connectedPct !== undefined ? /*#__PURE__*/ $cozmU.createElement((0, $gBjHb.default), {
            data: analyticsContextData
        }, fallbackView) : fallbackView;
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $gBjHb.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewFrame, {
        ...props,
        content: /*#__PURE__*/ $cozmU.createElement((0, $1p3nb.default), {
            tier: tier,
            connectedPct: connectedPct,
            providerName: providerName
        }),
        providerName: providerName,
        testId: testId
    }));
};
const $de399e6481e0a2d0$var$UnauthorisedViewWithoutExperiment = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewBase, props);
};
const $de399e6481e0a2d0$var$UnauthorisedView = (0, $rECdA.componentWithFG)('social-proof-3p-unauth-block-fg', $de399e6481e0a2d0$var$UnauthorisedViewWithExperiment, $de399e6481e0a2d0$var$UnauthorisedViewWithoutExperiment);
const $de399e6481e0a2d0$var$_default_1 = (0, $j7u0e.withFlexibleUIBlockCardStyle)($de399e6481e0a2d0$var$UnauthorisedView);
var $de399e6481e0a2d0$export$2e2bcd8739ae039 = $de399e6481e0a2d0$var$_default_1;
module.exports["default"] = $de399e6481e0a2d0$export$2e2bcd8739ae039;

});

parcelRegister("bnSsE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $fLtAn = parcelRequire("fLtAn");


var $8Mlyd = parcelRequire("8Mlyd");


var $6oIUT = parcelRequire("6oIUT");

const $593a61648c304682$export$4d1c9f059e1da2cc = 'social_proof_3p_unauth_block_exp';
const $593a61648c304682$export$9f0628890f2ea4ef = 'platform_sl_3p_preauth_social_proof_inline_cta';
const $593a61648c304682$export$e85fe820223563f3 = 30;
const $593a61648c304682$export$adbe2edcab243434 = (connectedPct)=>{
    if (connectedPct === undefined) return undefined;
    return connectedPct >= $593a61648c304682$export$e85fe820223563f3 ? 'not-low' : 'low';
};
const $593a61648c304682$var$getSocialProofExperimentMetadata = ({ extensionKey: extensionKey, baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash = '' })=>{
    if (!extensionKey) return {
        isEligible: false
    };
    const cloudId = (0, $fLtAn.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
    const providerPctMap = (0, $8Mlyd.getProviderPctMapSync)(cloudId, (0, $8Mlyd.SOCIAL_PROOF_TRAIT_NAME));
    const tier = $593a61648c304682$export$adbe2edcab243434(providerPctMap?.[extensionKey]);
    return {
        isEligible: tier !== undefined,
        ...tier ? {
            tier: tier
        } : {}
    };
};
const $593a61648c304682$export$49fab64ef7e3aab7 = (params)=>({
        [$593a61648c304682$export$4d1c9f059e1da2cc]: $593a61648c304682$var$getSocialProofExperimentMetadata(params)
    });
const $593a61648c304682$export$e53e13aaa7d7b805 = (params)=>({
        [$593a61648c304682$export$9f0628890f2ea4ef]: $593a61648c304682$var$getSocialProofExperimentMetadata(params)
    });
/**
 * Returns enrollment and treatment state for the social proof unauth block card experiment.
 *
 * Delegates data-fetching to `useSocialProof` (Sasha's shared service layer),
 * which handles cloudId resolution, TAP trait fetch, localStorage caching,
 * request deduping, and sync reads.
 *
 * This hook adds the experiment/cohort layer on top:
 * - Only fires exposure (via editorExperiment) when data has loaded.
 * - Derives `tier` and `isTreatment` for rendering decisions.
 *
 * Expected to be called only inside the fg-enabled branch (via componentWithFG).
 *
 * @param extensionKey - The extensionKey of the current 3P provider (e.g. 'google-object-provider').
 */ const $593a61648c304682$var$useSocialProofExperiment = (extensionKey, baseUriWithNoTrailingSlash = '')=>{
    const { connectedPct: connectedPct, isEnabled: isEnabled, isLoading: isLoading } = (0, $6oIUT.default)(extensionKey, true, baseUriWithNoTrailingSlash);
    return (0, $cozmU.useMemo)(()=>{
        const hasSocialProofData = connectedPct !== undefined;
        // Only fire exposure when data has loaded (prevents exposure inflation)
        const isTreatment = isEnabled && !isLoading && hasSocialProofData ? (0, $ieeJu.expValEquals)($593a61648c304682$export$4d1c9f059e1da2cc, 'isEnabled', true) : false;
        const tier = $593a61648c304682$export$adbe2edcab243434(connectedPct) ?? 'low';
        return {
            isTreatment: isTreatment,
            tier: tier,
            connectedPct: connectedPct,
            isLoading: isLoading
        };
    }, [
        isEnabled,
        isLoading,
        connectedPct
    ]);
};
var $593a61648c304682$export$2e2bcd8739ae039 = $593a61648c304682$var$useSocialProofExperiment;
module.exports["getSocialProofExperimentMeta"] = $593a61648c304682$export$49fab64ef7e3aab7;
module.exports["getInlineSocialProofExperimentMeta"] = $593a61648c304682$export$e53e13aaa7d7b805;
module.exports["default"] = $593a61648c304682$export$2e2bcd8739ae039;

});

parcelRegister("8Mlyd", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $fLtAn = parcelRequire("fLtAn");

const $5f908bf6fdd7b4c6$var$BASE_URL = '/gateway/api/tap-delivery/api/v3/personalization';
const $5f908bf6fdd7b4c6$export$2f936a88fd429e8c = 'smart-card-social-proof';
const $5f908bf6fdd7b4c6$export$93b4593f39ac22dc = 'pct-map:v1:';
const $5f908bf6fdd7b4c6$export$d8f80dc0b98f1c37 = 86400000;
const $5f908bf6fdd7b4c6$export$eb1c7e303b49fcc6 = 'sl_3p_connected_providers_site_pct';
const $5f908bf6fdd7b4c6$var$smartCardStorage = new (0, $6YrB3.default)($5f908bf6fdd7b4c6$export$2f936a88fd429e8c);
/** Keys written by this service in localStorage when using {@link smartCardStorage}. */ const $5f908bf6fdd7b4c6$var$LOCAL_STORAGE_ROW_KEY_PREFIX = `${$5f908bf6fdd7b4c6$export$2f936a88fd429e8c}_${$5f908bf6fdd7b4c6$export$93b4593f39ac22dc}`;
function $5f908bf6fdd7b4c6$var$scopedCacheKey(cloudId, traitName) {
    return `${cloudId}:${traitName}`;
}
function $5f908bf6fdd7b4c6$var$pctMapStorageItemKey(cloudId, traitName) {
    return `${$5f908bf6fdd7b4c6$export$93b4593f39ac22dc}${encodeURIComponent(cloudId)}:${encodeURIComponent(traitName)}`;
}
async function $5f908bf6fdd7b4c6$var$fetchSiteTraits(cloudId) {
    const response = await fetch(`${$5f908bf6fdd7b4c6$var$BASE_URL}/site/${cloudId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data?.attributes ?? [];
}
class $5f908bf6fdd7b4c6$export$d653d8abac1e12ce {
    /** Pure synchronous read for an explicit cloud id / trait pair. */ getProviderPctMapSync(cloudId, traitName) {
        if (!cloudId) return null;
        return this.readStoredProviderPctMap(cloudId, traitName);
    }
    async getProviderPctMap(cloudId, traitName) {
        if (!cloudId) return undefined;
        const cacheKey = $5f908bf6fdd7b4c6$var$scopedCacheKey(cloudId, traitName);
        const cachedPromise = this.cache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                const traits = await $5f908bf6fdd7b4c6$var$fetchSiteTraits(cloudId);
                const trait = traits.find((t)=>t.name === traitName);
                const mapped = this.parseTraitValue(trait?.value);
                if (mapped !== undefined) this.writeStoredProviderPctMap(cloudId, traitName, mapped);
                return mapped;
            } catch  {
                return undefined;
            }
        })();
        const retryablePromise = promise.finally(()=>{
            this.cache.delete(cacheKey);
        });
        this.cache.set(cacheKey, retryablePromise);
        return retryablePromise;
    }
    readStoredProviderPctMap(cloudId, traitName) {
        try {
            const stored = $5f908bf6fdd7b4c6$var$smartCardStorage.getItem($5f908bf6fdd7b4c6$var$pctMapStorageItemKey(cloudId, traitName));
            if (stored === undefined || stored === null) return null;
            return this.normalizeProviderPctMap(stored);
        } catch  {
            return null;
        }
    }
    writeStoredProviderPctMap(cloudId, traitName, map) {
        try {
            $5f908bf6fdd7b4c6$var$smartCardStorage.setItemWithExpiry($5f908bf6fdd7b4c6$var$pctMapStorageItemKey(cloudId, traitName), map, $5f908bf6fdd7b4c6$export$d8f80dc0b98f1c37);
        } catch  {
        // Quota, private-mode, etc.
        }
    }
    normalizeProviderPctMap(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
        const map = {};
        const entries = Object.entries(value);
        for (const [providerKey, percentageRaw] of entries){
            if (typeof percentageRaw !== 'number' || !Number.isFinite(percentageRaw)) return null;
            map[providerKey] = percentageRaw;
        }
        return map;
    }
    parseTraitValue(raw) {
        if (typeof raw !== 'string') return undefined;
        try {
            const parsed = JSON.parse(raw);
            const normalized = this.normalizeProviderPctMap(parsed);
            return normalized === null ? undefined : normalized;
        } catch  {
            return undefined;
        }
    }
    clearCache() {
        this.cache.clear();
        this.clearStoredProviderPctMaps();
    }
    clearStoredProviderPctMaps() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        if (typeof globalThis.localStorage === 'undefined' || globalThis.localStorage === null) return;
        const keysToRemove = [];
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let index = 0; index < globalThis.localStorage.length; index += 1){
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = globalThis.localStorage.key(index);
            if (key !== null && key.startsWith($5f908bf6fdd7b4c6$var$LOCAL_STORAGE_ROW_KEY_PREFIX)) keysToRemove.push(key);
        }
        for (const key of keysToRemove)try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            globalThis.localStorage.removeItem(key);
        } catch  {
        /* ignore */ }
    }
    constructor(){
        this.cache = new Map();
    }
}
const $5f908bf6fdd7b4c6$export$356056318a4fd636 = new $5f908bf6fdd7b4c6$export$d653d8abac1e12ce();
const $5f908bf6fdd7b4c6$export$fed0d3ced5218947 = (cloudId, traitName)=>$5f908bf6fdd7b4c6$export$356056318a4fd636.getProviderPctMap(cloudId, traitName);
function $5f908bf6fdd7b4c6$export$70435023d0d90129(cloudId, traitName) {
    return $5f908bf6fdd7b4c6$export$356056318a4fd636.getProviderPctMapSync(cloudId, traitName);
}
function $5f908bf6fdd7b4c6$export$63f5703c889fdfe6(traitName) {
    const cloudId = (0, $fLtAn.getCurrentSiteCloudIdSync)();
    const providerPctMap = $5f908bf6fdd7b4c6$export$70435023d0d90129(cloudId, traitName);
    (0, $fLtAn.getCurrentSiteCloudId)().then((resolvedCloudId)=>{
        $5f908bf6fdd7b4c6$export$fed0d3ced5218947(resolvedCloudId, traitName);
    });
    return providerPctMap;
}
module.exports["SOCIAL_PROOF_TRAIT_NAME"] = $5f908bf6fdd7b4c6$export$eb1c7e303b49fcc6;
module.exports["getProviderPctMap"] = $5f908bf6fdd7b4c6$export$fed0d3ced5218947;
module.exports["getProviderPctMapSync"] = $5f908bf6fdd7b4c6$export$70435023d0d90129;
module.exports["getCachedProviderPctMapAndRefresh"] = $5f908bf6fdd7b4c6$export$63f5703c889fdfe6;

});

parcelRegister("6oIUT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fLtAn = parcelRequire("fLtAn");


var $8Mlyd = parcelRequire("8Mlyd");

const $9fb3090db1207824$var$NOT_ENABLED_RESULT = {
    connectedPct: undefined,
    isEnabled: false,
    isLoading: false
};
/**
 * Cache-first social proof hook.
 *
 * On mount:
 * 1. Reads localStorage synchronously via `getProviderPctMapSync`.
 *    - If data exists (warm cache): sets `providerPctMap` immediately, `isLoading = false`.
 *    - If no data (cold cache): leaves `providerPctMap` undefined, `isLoading = false`.
 * 2. Always kicks off an async fetch (fire-and-forget) via `getProviderPctMap` to populate
 *    localStorage for next page load. Does NOT update state with the async result.
 *
 * This means:
 * - First page visit (cold): no social proof rendered, no experiment exposure fired.
 *   Background fetch populates localStorage for next time.
 * - Second page visit (warm): social proof renders immediately from localStorage.
 *   Background refresh keeps localStorage fresh.
 *
 * Callers decide separately (e.g. via Statsig experiment) whether to surface the data.
 */ const $9fb3090db1207824$var$useSocialProof = (extensionKey, isKillswitchOn = false, baseUriWithNoTrailingSlash = '')=>{
    const isEnabled = isKillswitchOn;
    const [snapshot] = (0, $cozmU.useState)(()=>{
        if (!isEnabled) return {
            cloudId: undefined,
            providerPctMap: null
        };
        const cloudId = (0, $fLtAn.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
        return {
            cloudId: cloudId,
            providerPctMap: (0, $8Mlyd.getProviderPctMapSync)(cloudId, (0, $8Mlyd.SOCIAL_PROOF_TRAIT_NAME))
        };
    });
    // Fire-and-forget: warm caches for future mounts only. Never update this mount's treatment UI.
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        (0, $fLtAn.getCurrentSiteCloudId)(baseUriWithNoTrailingSlash).then((cloudId)=>{
            (0, $8Mlyd.getProviderPctMap)(cloudId, (0, $8Mlyd.SOCIAL_PROOF_TRAIT_NAME));
        });
    }, [
        baseUriWithNoTrailingSlash,
        isEnabled
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!isEnabled) return $9fb3090db1207824$var$NOT_ENABLED_RESULT;
        return {
            connectedPct: extensionKey && snapshot.providerPctMap ? snapshot.providerPctMap[extensionKey] : undefined,
            isEnabled: Boolean(snapshot.cloudId && snapshot.providerPctMap),
            isLoading: false
        };
    }, [
        extensionKey,
        isEnabled,
        snapshot
    ]);
};
var $9fb3090db1207824$export$2e2bcd8739ae039 = $9fb3090db1207824$var$useSocialProof;
module.exports["default"] = $9fb3090db1207824$export$2e2bcd8739ae039;

});

parcelRegister("bhvUi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

const $01cbdaa835a1c102$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $4yYAm.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_link_account_card),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });
module.exports["AuthorizeAction"] = $01cbdaa835a1c102$export$34cef2b72294bd84;

});

parcelRegister("gj5b4", function(module, exports) {
module.exports = new URL("general@2x.8b524499.png", import.meta.url).toString();

});

parcelRegister("1p3nb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $dM7c5 = parcelRequire("dM7c5");

// TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
const $2d2d86d582e5927f$var$SocialProofMessage = ({ tier: tier, connectedPct: connectedPct, providerName: providerName, testId: testId = 'smart-block-social-proof-message' })=>{
    const message = tier === 'not-low' ? (0, $dM7c5.messages).pre_auth_block_social_proof_not_low : (0, $dM7c5.messages).pre_auth_block_social_proof_low;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...message,
        values: {
            percentage: connectedPct ?? 0,
            provider: providerName,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "strong",
                    weight: "bold"
                }, chunks)
        }
    }));
};
var $2d2d86d582e5927f$export$2e2bcd8739ae039 = $2d2d86d582e5927f$var$SocialProofMessage;
module.exports["default"] = $2d2d86d582e5927f$export$2e2bcd8739ae039;

});

parcelRegister("8rblg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $leSBv = parcelRequire("leSBv");


var $48Ypq = parcelRequire("48Ypq");


var $aqIRz = parcelRequire("aqIRz");


var $2Q7sv = parcelRequire("2Q7sv");


var $g3QJw = parcelRequire("g3QJw");


var $8p295 = parcelRequire("8p295");


var $7LU3Q = parcelRequire("7LU3Q");


var $3D9Fp = parcelRequire("3D9Fp");


var $1Zwrg = parcelRequire("1Zwrg");


var $jtpFm = parcelRequire("jtpFm");


var $iIdXZ = parcelRequire("iIdXZ");


var $jp8Mi = parcelRequire("jp8Mi");


var $ev6Ol = parcelRequire("ev6Ol");


var $ak0yl = parcelRequire("ak0yl");

const $b3ceae4ab8d9d0f7$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-embed-card"
    }), children);
const $b3ceae4ab8d9d0f7$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $2Q7sv.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $g3QJw.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3ceae4ab8d9d0f7$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3D9Fp.default), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            }));
        case 'resolved':
            const resolvedViewProps = (0, $48Ypq.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio,
                extensionKey: details?.meta?.key
            });
            if ((0, $7LU3Q.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $48Ypq.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak0yl.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ev6Ol.EmbedCardResolvedView), {
                ...resolvedViewProps,
                actionOptions: actionOptions,
                details: details,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aqIRz.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Zwrg.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3D9Fp.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                    // Other states (e.g. "resolving") could be added later for completeness.
                    onAuxClick: handleFrameAuxClick,
                    onContextMenu: handleFrameContextMenu,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $48Ypq.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak0yl.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $48Ypq.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ev6Ol.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iIdXZ.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $48Ypq.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jp8Mi.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jtpFm.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});
module.exports["EmbedCard"] = $b3ceae4ab8d9d0f7$export$6789d7ecdc77631b;

});

parcelRegister("48Ypq", function(module, exports) {

var $8OcYi = parcelRequire("8OcYi");

var $7YvXl = parcelRequire("7YvXl");

var $3ewaO = parcelRequire("3ewaO");

var $4FdKz = parcelRequire("4FdKz");


var $8p295 = parcelRequire("8p295");


var $3YNP7 = parcelRequire("3YNP7");


var $1qrkW = parcelRequire("1qrkW");


var $a3jaM = parcelRequire("a3jaM");

const $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3 = (response, _platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $8p295.getEmptyJsonLd)();
    return {
        link: (0, $3ewaO.extractSmartLinkUrl)(response) || '',
        title: (0, $7YvXl.extractSmartLinkTitle)(response),
        context: (0, $3YNP7.extractSmartLinkContext)(response),
        preview: (0, $8OcYi.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $a3jaM.extractIsTrusted)(meta),
        isSupportTheming: (0, $1qrkW.extractIsSupportTheming)(meta),
        type: (0, $4FdKz.extractType)(jsonLd)
    };
};
module.exports["extractEmbedProps"] = $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3;

});

parcelRegister("3YNP7", function(module, exports) {

var $g0csk = parcelRequire("g0csk");

var $2A177 = parcelRequire("2A177");

var $7FNdz = parcelRequire("7FNdz");

var $2GG3F = parcelRequire("2GG3F");

var $kAdyG = parcelRequire("kAdyG");


var $8p295 = parcelRequire("8p295");


var $2Pj3a = parcelRequire("2Pj3a");


var $leSBv = parcelRequire("leSBv");

function $d6cc6e0d201b986b$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $2Pj3a.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $7FNdz.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $d6cc6e0d201b986b$export$6ec4b6b24dec9156(response) {
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $g0csk.extractEntityProvider)(response);
    return $d6cc6e0d201b986b$export$8dcb07487061d3c1(response?.data || (0, $8p295.getEmptyJsonLd)());
}
module.exports["extractSmartLinkContext"] = $d6cc6e0d201b986b$export$6ec4b6b24dec9156;

});

parcelRegister("aqIRz", function(module, exports) {

var $kku4L = parcelRequire("kku4L");

var $g0csk = parcelRequire("g0csk");

var $2A177 = parcelRequire("2A177");

var $7YvXl = parcelRequire("7YvXl");

var $3ewaO = parcelRequire("3ewaO");

var $4FdKz = parcelRequire("4FdKz");

var $kAdyG = parcelRequire("kAdyG");


var $3Xkfu = parcelRequire("3Xkfu");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $8p295 = parcelRequire("8p295");


var $1k5z7 = parcelRequire("1k5z7");


var $2Mkmh = parcelRequire("2Mkmh");


var $laYho = parcelRequire("laYho");


var $3OpXn = parcelRequire("3OpXn");


var $y3W88 = parcelRequire("y3W88");

const $77f5ac99c8e12626$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $y3W88.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $y3W88.JIRA_GENERATOR_ID)) return (0, $1k5z7.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $1k5z7.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $77f5ac99c8e12626$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $kku4L.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $77f5ac99c8e12626$var$extractInlineIcon(response?.data || (0, $8p295.getEmptyJsonLd)(), showLabel);
};
const $77f5ac99c8e12626$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $8p295.getEmptyJsonLd)();
    return {
        link: (0, $3ewaO.extractSmartLinkUrl)(response),
        title: (0, $7YvXl.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: (0, $ieeJu.expValEquals)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true) ? (0, $3Xkfu.extractSmartLinkInlineIcon)(response, showLabel) : $77f5ac99c8e12626$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $2Mkmh.extractLozenge)(jsonLd),
        titleTextColor: (0, $laYho.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $3OpXn.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $4FdKz.extractType)(jsonLd)
    };
};
module.exports["extractInlineProps"] = $77f5ac99c8e12626$export$68e1703c529dc7e0;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $kku4L = parcelRequire("kku4L");


var $g0csk = parcelRequire("g0csk");


var $2A177 = parcelRequire("2A177");


var $jqhMF = parcelRequire("jqhMF");


var $2GG3F = parcelRequire("2GG3F");


var $jrSlu = parcelRequire("jrSlu");


var $c1Kdq = parcelRequire("c1Kdq");


var $kAdyG = parcelRequire("kAdyG");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];
const $f1ce3764841d3d06$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $f1ce3764841d3d06$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: $f1ce3764841d3d06$var$documentLabel(opts, 'file'),
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $f1ce3764841d3d06$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    const getLabel = (title)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jqhMF.extractTitle)(jsonLd)
        },
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $kku4L.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>(parcelRequire("9v3GN"))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>(parcelRequire("4Emmj"))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>(parcelRequire("4Emmj"))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>(parcelRequire("b5Dss"))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("7vzLW"))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV"))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke"))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas"))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw"))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI"))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU"))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || '';
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/ban-types
const $616e4ede6f48d352$var$BlogIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("eqhrF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hhrxw = parcelRequire("hhrxw");

const $ef7997acb045a8f6$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $ef7997acb045a8f6$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($ef7997acb045a8f6$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
module.exports["renderIconPerSize"] = $ef7997acb045a8f6$export$28dd5ad82647c000;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $9D4WS = parcelRequire("9D4WS");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("9D4WS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2Fmt9 = parcelRequire("2Fmt9");


var $6nWVS = parcelRequire("6nWVS");

const $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $eb6ec3e0096439cb$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $6nWVS.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconTile"] = $eb6ec3e0096439cb$export$87c3646d0e299cfe;

});

parcelRegister("6nWVS", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $7fb62870d007a2a2$export$3acc3fb10995f020 = (size)=>{
    if ((0, $iDrrr.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $7fb62870d007a2a2$export$3acc3fb10995f020;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $9D4WS = parcelRequire("9D4WS");

const $30795df12c6626e4$var$FileIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/ban-types
const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $9D4WS = parcelRequire("9D4WS");

// eslint-disable-next-line @typescript-eslint/ban-types
const $77093538826d7e25$var$ChartBarIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $9D4WS = parcelRequire("9D4WS");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("1k5z7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fBqzD = parcelRequire("fBqzD");


var $2A177 = parcelRequire("2A177");

var $jqhMF = parcelRequire("jqhMF");

var $2GG3F = parcelRequire("2GG3F");


var $iMQz5 = parcelRequire("iMQz5");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $gITbz = parcelRequire("gITbz");


var $a5G9M = parcelRequire("a5G9M");


var $iDrrr = parcelRequire("iDrrr");


var $16kNn = parcelRequire("16kNn");


var $8mPrX = parcelRequire("8mPrX");


var $54xUX = parcelRequire("54xUX");


var $bAp1o = parcelRequire("bAp1o");


var $bgpNO = parcelRequire("bgpNO");


var $2Pj3a = parcelRequire("2Pj3a");


var $i9AjY = parcelRequire("i9AjY");

const $c6cb06b5744ce8d5$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jqhMF.extractTitle)(jsonLd)
        },
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: (0, $54xUX.extractFileFormat)(jsonLd),
        taskType: (0, $8mPrX.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0];
        return $c6cb06b5744ce8d5$var$extractIconByType(highestPriorityType, opts);
    } else return $c6cb06b5744ce8d5$var$extractIconByType(type, opts);
};
function $c6cb06b5744ce8d5$var$typeToIcon(type, opts) {
    const getLabel = (title)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $bgpNO.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $c6cb06b5744ce8d5$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $c6cb06b5744ce8d5$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $16kNn.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $2Pj3a.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $c6cb06b5744ce8d5$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $bAp1o.extractIconFromDocument)(type, opts);
        default:
            return $c6cb06b5744ce8d5$var$standardisedExtractIcon(type, opts);
    }
};
module.exports["extractIcon"] = $c6cb06b5744ce8d5$export$64bdf1f5e49e8626;

});

parcelRegister("54xUX", function(module, exports) {
const $7b0fffa5fa3ec27e$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};
module.exports["extractFileFormat"] = $7b0fffa5fa3ec27e$export$f2d65f02f6888b60;

});

parcelRegister("bAp1o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $c1Kdq = parcelRequire("c1Kdq");


var $iDrrr = parcelRequire("iDrrr");


var $16kNn = parcelRequire("16kNn");


var $2Pj3a = parcelRequire("2Pj3a");


const $4f896bdd2d7540cd$var$getBlogIconWrapped = ()=>(parcelRequire("lYcSC")).default;

const $4f896bdd2d7540cd$var$getDocumentIcon = ()=>(parcelRequire("2jRrx")).default;

const $4f896bdd2d7540cd$var$getFileIcon = ()=>(parcelRequire("ipz0N")).default;

const $4f896bdd2d7540cd$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("66hVV")).default;

const $4f896bdd2d7540cd$var$getPresentationIcon = ()=>(parcelRequire("f49me")).default;

const $4f896bdd2d7540cd$var$getSpreadsheetIcon = ()=>(parcelRequire("jBJvN")).default;
const $4f896bdd2d7540cd$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $4f896bdd2d7540cd$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $4f896bdd2d7540cd$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $2Pj3a.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $4f896bdd2d7540cd$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $16kNn.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined);
};
const $4f896bdd2d7540cd$var$documentLabel = (opts, label)=>{
    // NAVX-4354 can be inlined during cleanup.
    if (!opts.showIconLabel) return '';
    return (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};
const $4f896bdd2d7540cd$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                // Intentionally keep this icon on a synchronous require()-based path.
                // This icon must be present in SSR markup so hydration does not cause a
                // visible empty-state-then-pop-in transition for Smart Links.
                const BlogIconWrapped = $4f896bdd2d7540cd$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $4f896bdd2d7540cd$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $4f896bdd2d7540cd$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $4f896bdd2d7540cd$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $4f896bdd2d7540cd$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $4f896bdd2d7540cd$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $4f896bdd2d7540cd$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $4f896bdd2d7540cd$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        // Intentionally keep this icon on a synchronous require()-based path.
        // This icon must be present in SSR markup so hydration does not cause a
        // visible empty-state-then-pop-in transition for Smart Links.
        const LiveDocumentIconWrapped = $4f896bdd2d7540cd$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $4f896bdd2d7540cd$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    } else {
        const FileIcon = $4f896bdd2d7540cd$var$getFileIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
            label: $4f896bdd2d7540cd$var$documentLabel(opts, 'file'),
            testId: "file-icon"
        });
    }
};
module.exports["extractIconFromDocument"] = $4f896bdd2d7540cd$export$25c24c7f577936d3;

});

parcelRegister("bgpNO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $y3W88 = parcelRequire("y3W88");

const $25b9a77feae19a2e$var$TaskIcon = (0, $a5G9M.default);
const $25b9a77feae19a2e$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25b9a77feae19a2e$var$TaskIcon, {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $y3W88.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $y3W88.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $y3W88.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $y3W88.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $y3W88.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $y3W88.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $y3W88.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $y3W88.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $y3W88.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $y3W88.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $y3W88.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
module.exports["extractIconFromTask"] = $25b9a77feae19a2e$export$321256ed044e3100;

});

parcelRegister("laYho", function(module, exports) {

var $i9AjY = parcelRequire("i9AjY");

const $9e4a95fa3dc128fa$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return "var(--ds-text-danger, #AE2E24)";
            default:
                return undefined;
        }
    }
};
module.exports["extractTitleTextColor"] = $9e4a95fa3dc128fa$export$a2afc198e9dada1;

});

parcelRegister("3OpXn", function(module, exports) {
const $a46204b9e466e80e$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $a46204b9e466e80e$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $a46204b9e466e80e$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};
module.exports["extractTitlePrefix"] = $a46204b9e466e80e$export$58d9bc37318dfb32;

});

parcelRegister("1Zwrg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $rECdA = parcelRequire("rECdA");


var $jLxvy = parcelRequire("jLxvy");


var $JiXpY = parcelRequire("JiXpY");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");


var $gMe7e = parcelRequire("gMe7e");

class $bcd0f021ef78debd$var$InlineCardResolvedViewClass extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge || !lozenge?.text) return null;
        if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
            if (stateMetricMatch) {
                const [, label, metric] = stateMetricMatch;
                const appearance = lozenge.appearance || 'neutral';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
                    testId: "inline-card-resolved-view-lozenge",
                    appearance: appearance,
                    style: {
                        backgroundColor: lozenge?.style?.backgroundColor,
                        color: lozenge?.style?.color
                    },
                    trailingMetric: metric
                }, label);
            }
        }
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: lozenge.isBold !== false
        }, lozenge.text);
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            truncateInline: truncateInline
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
            emoji: titlePrefix,
            icon: icon,
            title: title,
            titleTextColor: titleTextColor,
            type: type,
            hideIconLoadingSkeleton: hideIconLoadingSkeleton
        }), this.renderLozenge());
        if (showHoverPreview && link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions
        }, inlineCardResolvedView);
        return inlineCardResolvedView;
    }
}
const $bcd0f021ef78debd$export$6d5912cb4b56390e = (0, $rECdA.componentWithFG)('smart-card-inline-resolved-view-refactor', (0, $gMe7e.InlineCardResolvedViewFunctional), $bcd0f021ef78debd$var$InlineCardResolvedViewClass);
module.exports["InlineCardResolvedView"] = $bcd0f021ef78debd$export$6d5912cb4b56390e;

});

parcelRegister("JiXpY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");

const $7d8c99d2ebeab5e4$var$wrapperStylesOld = null;
const $7d8c99d2ebeab5e4$var$wrapperStylesNew = null;
const $7d8c99d2ebeab5e4$var$wrapperStylesNewLozenge = null;
const $7d8c99d2ebeab5e4$var$InlineLozenge = (props)=>{
    if ((0, $iDrrr.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _2IhTonA17z _1mT5xdRAKS _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFMFQfX _1EqgXlN91d",
            (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_0adFHsHZdu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), props));
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1RrJLiHZdu _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFMFQfX _1EqgXlN91d",
            (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_0adFHsHZdu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), props));
};
var $7d8c99d2ebeab5e4$export$2e2bcd8739ae039 = $7d8c99d2ebeab5e4$var$InlineLozenge;
module.exports["default"] = $7d8c99d2ebeab5e4$export$2e2bcd8739ae039;

});

parcelRegister("bZ9jR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $6Eovk = parcelRequire("6Eovk");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $16kNn = parcelRequire("16kNn");


var $hXuY9 = parcelRequire("hXuY9");

const $2309ddd74f282083$var$iconWrapperStyle = null;
const $2309ddd74f282083$var$iconImageStyle = null;
const $2309ddd74f282083$var$styles = {
    iconEmptyStyle: "_39xV02ey7F _0jFU0VN91d _3iDTPbvbI6 _1YKVNsdnbC",
    iconOuterWrapperStyle: "_3iDTPbvbI6 _0adFHs1Y8M _1mT5xdRAKS",
    iconTitleWrapperStyle: "_1ANEUSlpBW _3W2Oc84hR5 _2NnhnEXpc7 _0Of8r2FQfX _1Znuxb1Y8M _1wydGWFQfX _2Zuz6Q1Y8M",
    linkStyle: "_0bjKvDcjp5",
    noLinkAppearanceStyle: "_1UtDYzKGUX _2XsHFM1Y8M",
    roundImageStyle: "_0bjKvDS5Zs"
};
const $2309ddd74f282083$var$LinkAppearance = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzM7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
            __cmplp.className
        ])
    });
});
const $2309ddd74f282083$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            if (emoji) return emoji;
            if (!icon || typeof icon === 'string' || Array.isArray(icon)) return null;
            return icon;
        } else {
            if (emoji) return emoji;
            if (!icon || typeof icon === 'string') return null;
            return icon;
        }
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $16kNn.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((errored, testId)=>{
        (0, $6cFsl.di)((0, $6Eovk.default));
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            if (!icon) return null;
            let iconUrl;
            let iconLabel = '';
            if (Array.isArray(icon)) {
                const [tupleIconUrl, tupleIconLabel] = icon;
                if (typeof tupleIconUrl !== 'string') return null;
                iconUrl = tupleIconUrl;
                iconLabel = typeof tupleIconLabel === 'string' ? tupleIconLabel : '';
            } else if (typeof icon === 'string') iconUrl = icon;
            else return null;
            if (hideIconLoadingSkeleton) {
                if (hasImageErrored) return errored;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: iconUrl,
                    "data-testid": `${testId}-image`,
                    alt: iconLabel,
                    onError: ()=>setHasImageErrored(true),
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
                src: iconUrl,
                loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: iconUrl,
                    "data-testid": `${testId}-image`,
                    alt: iconLabel,
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                }),
                errored: errored,
                loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXuY9.Shimmer), {
                    testId: `${testId}-loading`
                })
            });
        } else {
            if (!icon || typeof icon !== 'string') return null;
            if (hideIconLoadingSkeleton) {
                if (hasImageErrored) return errored;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: icon,
                    "data-testid": `${testId}-image`,
                    alt: "",
                    onError: ()=>setHasImageErrored(true),
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
                src: icon,
                loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: icon,
                    "data-testid": `${testId}-image`,
                    alt: "",
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                }),
                errored: errored,
                loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXuY9.Shimmer), {
                    testId: `${testId}-loading`
                })
            });
        }
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "link",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]); // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        // We cannot set the fix font because inline is taking the parent container font size into account.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        style: {
            lineHeight: `1`
        },
        xcss: $2309ddd74f282083$var$styles.iconOuterWrapperStyle,
        testId: "icon-position-wrapper"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $2309ddd74f282083$var$styles.iconEmptyStyle,
        testId: "icon-empty-wrapper"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "icon-wrapper",
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _0bjKvDcjp5 _3iDTPbccYA _1mT5xdWVPG _0adFHs1Y8M _0jFU0Vey7F _39xV02ey7F _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _20VacPYbGa"
        ])
    }, renderIcon(testId)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            color: titleTextColor
        }
    }, title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2309ddd74f282083$export$c73a53738ef9e3f, {
        style: {
            color: titleColor
        },
        testId: testId
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2309ddd74f282083$var$LinkAppearance, {
        href: link,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        className: (0, $hekY6.default)([
            $2309ddd74f282083$var$styles.linkStyle
        ])
    }, titlePart) : titlePart, rightSide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $2309ddd74f282083$var$styles.noLinkAppearanceStyle
    }, rightSide) : null));
};
const $2309ddd74f282083$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $2309ddd74f282083$var$styles.iconTitleWrapperStyle,
        ...props
    });
};
module.exports["IconAndTitleLayout"] = $2309ddd74f282083$export$d34be4d513116847;
module.exports["IconTitleWrapper"] = $2309ddd74f282083$export$c73a53738ef9e3f;

});

parcelRegister("hXuY9", function(module, exports) {
/* Icon.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hyOTw = parcelRequire("hyOTw");

const $cac0f68f685429e5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _0jFU0Vey7F _39xV02ey7F _0adFHs1Y8M _20VacPYbGa _1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ",
            __cmplp.className
        ])
    });
});
const $cac0f68f685429e5$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hyOTw.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        testId: testId,
        style: skeletonCustomStyles
    });
};
module.exports["Shimmer"] = $cac0f68f685429e5$export$809644b82cfe94b1;

});

parcelRegister("hyOTw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $52c0c0ab9e795973$var$placeholderShimmer = null;
const $52c0c0ab9e795973$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $52c0c0ab9e795973$var$spanSkeletonStyles = null;
const $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap = {
    gray: "_0KLXrumhAQ",
    blue: "_0KLXruVva3",
    darkGray: "_0KLXruG6qS"
};
const $52c0c0ab9e795973$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_20VacPYbGa _2z4m57UZDI _1gBibyw5cc _0nFVCGipXj _43vdfTHVQb _03m2nySHWH _3Y6bKpgRhm",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $52c0c0ab9e795973$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_20VacPYbGa _2z4m57UZDI _1gBibyw5cc _0nFVCGipXj _43vdfTHVQb _03m2nySHWH _3Y6bKpgRhm",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $52c0c0ab9e795973$export$2e2bcd8739ae039 = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $52c0c0ab9e795973$export$85d5658002cae6ce;
module.exports["Skeleton"] = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;

});

parcelRegister("gMe7e", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $rECdA = parcelRequire("rECdA");


var $csrAG = parcelRequire("csrAG");


var $jLxvy = parcelRequire("jLxvy");


var $8FtTH = parcelRequire("8FtTH");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");


var $gvKrb = parcelRequire("gvKrb");

function $3ad9caaf785d398d$export$a75b7a22e5b9b36({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $gvKrb.renderLozenge)(lozenge));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}
function $3ad9caaf785d398d$export$9fc2dee105372861({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const { isEnabled: isInlineTailoredRovoActionEnabled } = (0, $csrAG.default)(link, showHoverPreview, actionOptions);
    // TODO https://hello.jira.atlassian.cloud/browse/NAVX-4436: fire analytics with cohort
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $gvKrb.renderLozenge)(lozenge), isInlineTailoredRovoActionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FtTH.InlineRovoActionButton), {
        testId: `${testId}-rovo-actions-cta`,
        url: link,
        actionOptions: actionOptions
    }));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}
const $3ad9caaf785d398d$export$4dcde1a6b9223e2e = (0, $rECdA.componentWithFG)('platform_sl_3p_auth_inline_tailored_cta_killswitch', $3ad9caaf785d398d$export$9fc2dee105372861, $3ad9caaf785d398d$export$a75b7a22e5b9b36);
module.exports["InlineCardResolvedViewFunctional"] = $3ad9caaf785d398d$export$4dcde1a6b9223e2e;

});

parcelRegister("csrAG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $aflIU = parcelRequire("aflIU");


var $2Q7sv = parcelRequire("2Q7sv");


var $9H66G = parcelRequire("9H66G");


var $8QLAc = parcelRequire("8QLAc");

const $dc67e572c7f8359a$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $dc67e572c7f8359a$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
/**
 * Returns whether the platform_sl_3p_auth_inline_tailored_cta experiment
 * is enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 * 5. The experiment value must be true (via tmp-editor-statsig).
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $dc67e572c7f8359a$var$useInlineTailoredActionExperiment = (url, showHoverPreview, actionOptions)=>{
    const { rovoOptions: rovoConfig } = (0, $8QLAc.default)();
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (!isRovoChatEnabled || !showHoverPreview || !url || !isRovoChatActionOptedIn) return $dc67e572c7f8359a$var$NOT_ENABLED_RESULT;
        if (!extensionKey || !$dc67e572c7f8359a$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return $dc67e572c7f8359a$var$NOT_ENABLED_RESULT;
        const isEnabled = (0, $iDrrr.fg)('platform_sl_3p_auth_inline_tailored_cta_killswitch') && (0, $ieeJu.expValEquals)('platform_sl_3p_auth_inline_tailored_cta', 'isEnabled', true);
        return {
            isEnabled: isEnabled
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        showHoverPreview,
        url,
        isRovoChatActionOptedIn
    ]);
};
var $dc67e572c7f8359a$export$2e2bcd8739ae039 = $dc67e572c7f8359a$var$useInlineTailoredActionExperiment;
module.exports["default"] = $dc67e572c7f8359a$export$2e2bcd8739ae039;

});

parcelRegister("8FtTH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hHrlI = parcelRequire("hHrlI");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $irGZZ = parcelRequire("irGZZ");


var $2Q7sv = parcelRequire("2Q7sv");


var $kfxZm = parcelRequire("kfxZm");


var $4ZDKy = parcelRequire("4ZDKy");


var $8QLAc = parcelRequire("8QLAc");


var $9H66G = parcelRequire("9H66G");


var $edVsK = parcelRequire("edVsK");


var $b78WJ = parcelRequire("b78WJ");

const $210989b8c3d24ec4$var$styles = {
    text: "_2Zuz6QgVvo _3iDTPbccYA _0hPCNLDIqT _1RrJLit2nV _313842Ll21"
};
const $210989b8c3d24ec4$export$47ac6a4b603479b6 = ({ testId: testId, url: url, actionOptions: actionOptions })=>{
    const { sendPromptMessage: sendPromptMessage, isRovoChatEnabled: isRovoChatEnabled } = (0, $4ZDKy.default)();
    const intl = (0, $kSwu1.useIntl)();
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const rovoConfig = (0, $8QLAc.default)();
    const rovoChatAction = (0, $cozmU.useMemo)(()=>{
        return cardState.details && (0, $irGZZ.default)({
            response: cardState.details,
            actionOptions: actionOptions,
            rovoConfig: rovoConfig
        });
    }, [
        cardState.details,
        rovoConfig,
        actionOptions
    ]);
    const provider = (0, $cozmU.useMemo)(()=>{
        return cardState.details && (0, $hHrlI.extractSmartLinkProvider)(cardState.details);
    }, [
        cardState.details
    ]);
    const invoke = (0, $kfxZm.default)({});
    const promptKey = (0, $cozmU.useMemo)(()=>{
        if (extensionKey === 'google-object-provider' && cardState.details?.data?.['@type']?.includes('schema:SpreadsheetDigitalDocument')) return;
        switch(extensionKey){
            case 'google-object-provider':
                if (cardState.details?.data?.['@type']?.includes('schema:PresentationDigitalDocument')) return (0, $edVsK.RovoChatPromptKey).SUMMARIZE_PRESENTATION;
                return (0, $edVsK.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'onedrive-object-provider':
                return (0, $edVsK.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'github-object-provider':
            case 'gitlab-object-provider':
                return (0, $edVsK.RovoChatPromptKey).EXPLAIN_CODE;
            case 'slack-object-provider':
            case 'ms-teams-object-provider':
                return (0, $edVsK.RovoChatPromptKey).CATCH_UP;
            case 'salesforce-object-provider':
                return (0, $edVsK.RovoChatPromptKey).SALESFORCE_PREP;
        }
    }, [
        extensionKey,
        cardState
    ]);
    const { data: promptData, content: content, icon: icon } = promptKey ? (0, $edVsK.getPromptAction)({
        promptKey: promptKey,
        intl: intl,
        url: url,
        iconSize: 'small',
        provider: provider?.text
    }) || {} : {};
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (isRovoChatEnabled && promptData && rovoChatAction?.invokeAction) invoke({
            ...rovoChatAction?.invokeAction,
            actionFn: async ()=>sendPromptMessage(promptData),
            prompt: promptKey
        });
    }, [
        sendPromptMessage,
        isRovoChatEnabled,
        promptData,
        rovoChatAction,
        promptKey,
        invoke
    ]);
    return promptData && content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
        onClick: handleClick,
        testId: testId
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $210989b8c3d24ec4$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, content))) : null;
};
module.exports["InlineRovoActionButton"] = $210989b8c3d24ec4$export$47ac6a4b603479b6;

});

parcelRegister("b78WJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $d0b3107199ef42eb$var$styles = {
    button: "_3iDTPbcK7c",
    innerContainer: "_3iDTPbS8kF _07XDTD4rZt _2NnhnEXpc7 _1kk5Tkf7mX _2Zuz6QgVvo _0Of8r2FQfX _1wydGWFQfX _1ZnuxbgVvo _2fwxA5yL8i _1ANEUSJfqQ _3W2Oc84hR5",
    innerContainerSocialProofConnect: "_0bjKvDKxmn _1UtDYze5R3 _0wOv4Q7zJH _0KLXrukLmD _0adFHsFQfX _3iDTPbS8kF _0hPCNLDIqT _4ya3eETekT _07XDTD4rZt _2NnhnEXpc7 _2Zuz6QgVvo _0Of8r2FQfX _1wydGWFQfX _1ZnuxbgVvo _2fwxA5yL8i _1RrJLiHZdu _1ANEUSJfqQ _3W2Oc84hR5 _1eOmH6XLOx _3gzVzLPSfI",
    innerContainerNoWrap: "_1ANEUSLRg7 _3W2Oc8zUZr",
    enabled: "_1UtDYzy7kJ _0wOv4Q7zJH _0KLXruDMqu _1eOmH6KcZT _3gzVzLnpTK",
    disabled: "_1UtDYzot27 _0wOv4Qsyl5 _0KLXruVrZW",
    unauthorised: "_1UtDYze5R3 _0wOv4Q7zJH _0KLXrukLmD _1Lz9locjp5 _3XDz3Bcjp5 _2C2kUQcjp5 _1v9SsVcjp5 _0Of8r2HZdu _1wydGWHZdu _0adFHsHZdu _1kk5Tku7m9 _1eOmH6XLOx _3gzVzLPSfI"
}; /* eslint-enable @compiled/shorthand-property-sorting */ 
const $d0b3107199ef42eb$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', isSlimDesign: isSlimDesign = false, ...props }, ref)=>{
    const shouldUseUnauthorisedSlimStyle = viewType === 'unauthorised' && isSlimDesign && (0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch');
    if (shouldUseUnauthorisedSlimStyle && !isDisabled) {
        const { onClick: onClick, ...boxProps } = props;
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ...boxProps,
            ref: ref,
            style: {
                font: `inherit`
            },
            xcss: $d0b3107199ef42eb$var$styles.button
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $d0b3107199ef42eb$var$styles.innerContainerSocialProofConnect,
                (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') && ""
            ])
        }, children));
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $d0b3107199ef42eb$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $hekY6.default)([
            $d0b3107199ef42eb$var$styles.innerContainer,
            isDisabled ? $d0b3107199ef42eb$var$styles.disabled : viewType === 'unauthorised' ? $d0b3107199ef42eb$var$styles.unauthorised : $d0b3107199ef42eb$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $d0b3107199ef42eb$export$cfc7921d29ef7b80;

});

parcelRegister("gvKrb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $JiXpY = parcelRequire("JiXpY");

const $dfdb1966c3a31649$var$LOZENGE_TEST_ID = 'inline-card-resolved-view-lozenge';
function $dfdb1966c3a31649$export$69cf9880ad713b0e(lozenge) {
    if (!lozenge || !lozenge?.text) return null;
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
        if (stateMetricMatch) {
            const [, label, metric] = stateMetricMatch;
            const appearance = lozenge.appearance || 'neutral';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
                testId: $dfdb1966c3a31649$var$LOZENGE_TEST_ID,
                appearance: appearance,
                style: {
                    backgroundColor: lozenge?.style?.backgroundColor,
                    color: lozenge?.style?.color
                },
                trailingMetric: metric
            }, label);
        }
    }
    const appearance = lozenge.appearance || 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
        testId: $dfdb1966c3a31649$var$LOZENGE_TEST_ID,
        appearance: appearance,
        style: {
            backgroundColor: lozenge?.style?.backgroundColor,
            color: lozenge?.style?.color
        },
        isBold: lozenge.isBold !== false
    }, lozenge.text);
}
module.exports["renderLozenge"] = $dfdb1966c3a31649$export$69cf9880ad713b0e;

});

parcelRegister("jtpFm", function(module, exports) {
/* ErroredView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $dM7c5 = parcelRequire("dM7c5");


var $gJOOu = parcelRequire("gJOOu");

const $1402c290c2a79a1a$var$styles = {
    boxStyles: "_2Zuz6Q1Y8M _1Znuxb1Y8M"
};
const $1402c290c2a79a1a$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ $cozmU.createElement((0, $gJOOu.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error-icon"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $1402c290c2a79a1a$var$styles.boxStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).could_not_load_link))), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        testId: "err-view-retry",
        spacing: "compact",
        onClick: onRetry
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).try_again)));
module.exports["EmbedCardErroredView"] = $1402c290c2a79a1a$export$6819d845957344e;

});

parcelRegister("gJOOu", function(module, exports) {
/* ErrorFrame.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $43f9b1cf28b9cc98$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43f9b1cf28b9cc98$export$f862a410248f4f00, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43f9b1cf28b9cc98$export$7b360cd785b6c366, props);
const $43f9b1cf28b9cc98$var$sharedBaseFrameStyles = null;
const $43f9b1cf28b9cc98$var$sharedFrameStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameHoverStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameFluidHeightTrueStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameFluidHeightFalseStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameSelectedStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameNotSelectedStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameStyles = null;
const $43f9b1cf28b9cc98$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbQ4SZ",
            "_1EqgXl8yGE _0KLXruqi9L",
            isHoverable && "_1eOmH6o126 _0ReiIH7zJH",
            isFluidHeight ? "_4kiQYAdnbC" : "_4kiQYAv6H3",
            isSelected ? "_0bjKvDzXzM _3vBAKHrzt2 _3hxITi6wH8 _2V7sgO2M4S" : "_0bjKvDcjp5 _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S",
            "_4bt5LAnQyn _2WAcuGnQyn _37wbyuI7V3 _2OUyjtzwhj",
            className
        ]),
        "data-trello-do-not-use-override": testId
    }, children);
};
const $43f9b1cf28b9cc98$var$compactFrameHoverStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameInheritDimensionsTrueStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameInheritDimensionsFalseStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameAlignStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameNotSelectedStyles = null;
const $43f9b1cf28b9cc98$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbQ4SZ",
            "_1EqgXl8yGE _0KLXruqi9L",
            isHoverable && "_1eOmH6KcZT",
            isSelected && "_0bjKvDzXzM _3vBAKHrzt2 _3hxITi6wH8 _2V7sgO2M4S",
            !isSelected && "_0bjKvDcjp5",
            "_37wbyuDIqT _0hPCNLDIqT _0KLXruDMqu",
            inheritDimensions ? "_0jFU0VN91d" : "_0jFU0VUF4f",
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _39xV02N91d",
            className
        ])
    }, children);
};
module.exports["Frame"] = $43f9b1cf28b9cc98$export$b89a827e9254211a;

});

parcelRegister("iIdXZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $dM7c5 = parcelRequire("dM7c5");


var $dr8Ob = parcelRequire("dr8Ob");


var $cKLWB = parcelRequire("cKLWB");


var $dCAZw = parcelRequire("dCAZw");

const $0932ea1b8e978982$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $cozmU.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, hostname)
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
   * if there is a request access context, but no action to perform, do not show any button.
   * By default, a "Try another account" button shows, but with request access context, we don't
   * want to encourage users to try another account, if their request is already pending, etc.
   */ const button = (0, $cozmU.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dr8Ob.toMessage)((0, $dM7c5.messages).try_another_account, callToActionMessageKey),
            values: values
        }));
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cKLWB.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dCAZw.ForbiddenSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dr8Ob.toMessage)((0, $dM7c5.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dr8Ob.toMessage)((0, $dM7c5.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $0932ea1b8e978982$export$2e2bcd8739ae039 = $0932ea1b8e978982$var$ForbiddenView;
module.exports["default"] = $0932ea1b8e978982$export$2e2bcd8739ae039;

});

parcelRegister("cKLWB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $kTb7m = parcelRequire("kTb7m");


var $4aRua = parcelRequire("4aRua");


var $856OS = parcelRequire("856OS");


var $85KcP = parcelRequire("85KcP");

const $ffabb40f353fd16d$var$containerStyles = null;
const $ffabb40f353fd16d$var$contentStyles = null;
const $ffabb40f353fd16d$var$imageStyles = null;
const $ffabb40f353fd16d$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $cozmU.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $85KcP.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "icon",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $cozmU.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hekY6.default)([
                "_0jFU0Vv6H3 _39xV02WD6W _00EA0egIor _1PLshBXWGq"
            ])
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": imageTestId,
            className: (0, $hekY6.default)([
                "_0jFU0Vv6H3 _39xV02WD6W _00EA0egIor _1PLshBXWGq"
            ])
        }, imageUrlOrElement);
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856OS.ExpandedFrame // Scroll bar must be shown for unresolved views to display the connect account button
    ), {
        allowScrollBar: true,
        setOverflow: true,
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": `${testId}-unresolved-container`,
        className: (0, $hekY6.default)([
            "_3iDTPbgBM8 _0jFU0VOLYo"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2fwxA5DIqT _0hPCNLDIqT _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _1EqgXlHakr"
        ])
    }, image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        testId: `${testId}-unresolved-title`
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "center",
        testId: `${testId}-unresolved-description`
    }, description), button)));
};
var $ffabb40f353fd16d$export$2e2bcd8739ae039 = $ffabb40f353fd16d$var$UnresolvedView;
module.exports["default"] = $ffabb40f353fd16d$export$2e2bcd8739ae039;

});

parcelRegister("856OS", function(module, exports) {
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lpNn5 = parcelRequire("lpNn5");


var $3tPPd = parcelRequire("3tPPd");


var $ghw3R = parcelRequire("ghw3R");


var $aFr4e = parcelRequire("aFr4e");

const $6317c3ad9e8d2304$var$styles = {
    linkWrapper: "_2mHwu82ADO _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0Vw5sG _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _20VacPYbGa _1JM8vvoAmG _2Gfj6iyzSk _0GBAIrogpp _2WYcYGWVPG _2KaDuOdnbC _0cAGM7dnbC _4zi1EpdnbC _2ZHpDRdnbC _3wEj0XjOvk _39mJBjdnbC _03rd7HdnbC _3AJDandnbC",
    linkWrapperInheritDimensions: "_0jFU0VN91d",
    linkWrapperSelected: "_0Av05f5WZX",
    linkWrapperBorderAndBackground: "_4l3pdPOeNX _3wEj0Xqi9L _3AJDan7dHp",
    linkWrapperInteractiveNotHidden: "_18YWq9OeNX _0jKh9gqi9L _2baiL77dHp",
    header: "_2sNsIgEqul _2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0jFU0VSPN1 _42Yu6B7dHp",
    leftSection: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    tooltipWrapper: "_4bt5LAnQyn _2WAcuGnQyn",
    headerAnchor: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    headerIcon: "_2sNsIgEqul _39xV02ey7F _0jFU0Vey7F",
    contentStyle: "_30huDKFq6s _0bjKvD8jTr _4bt5LAnQyn _2WAcuGnQyn _23rrnHUL21 _0KLXruqi9L _2O5Vij7dHp _0jFU0VN91d _42Yu6B7dHp",
    contentInteractiveActiveBorder: "_3F4jYbiUq6",
    contentOverflowAuto: "_4bt5LAIZbP _2WAcuGIZbP"
};
const $6317c3ad9e8d2304$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt, onContentMouseEnter: onContentMouseEnter, onContentMouseLeave: onContentMouseLeave })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $ghw3R.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $3tPPd.useMouseDownEvent)();
    const CompetitorPromptComponent = CompetitorPrompt && href ? /*#__PURE__*/ $cozmU.createElement(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.header,
                "embed-header"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.leftSection
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.headerIcon
            ])
        }, icon), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.tooltipWrapper
            ])
        }, !isPlaceholder && /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: text,
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ $cozmU.createElement("a", {
            href: href,
            onClick: handleClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: handleMouseDown,
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.headerAnchor
            ])
        }, text)))), CompetitorPromptComponent);
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "embed-content-wrapper",
            // See: HOT-107830
            contentEditable: false,
            onMouseEnter: onContentMouseEnter,
            onMouseLeave: onContentMouseLeave,
            onFocus: onContentMouseEnter,
            onBlur: onContentMouseLeave,
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.contentStyle,
                setOverflow && allowScrollBar && $6317c3ad9e8d2304$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $6317c3ad9e8d2304$var$styles.contentInteractiveActiveBorder
            ])
        }, children);
    };
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $6317c3ad9e8d2304$var$styles.linkWrapper,
            inheritDimensions && $6317c3ad9e8d2304$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $6317c3ad9e8d2304$var$styles.linkWrapperSelected,
            showBackgroundAlways && $6317c3ad9e8d2304$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $6317c3ad9e8d2304$var$styles.linkWrapperInteractiveNotHidden,
            (0, $aFr4e.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        }
    }, renderHeader(), renderContent());
};
module.exports["ExpandedFrame"] = $6317c3ad9e8d2304$export$7b360cd785b6c366;

});

parcelRegister("aFr4e", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $5b9fd94d0fcc59ac$export$2913c0c0b5623090 = 'media-card-frame';
const $5b9fd94d0fcc59ac$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
const $5b9fd94d0fcc59ac$export$3e431a229df88919 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $9aYkv.default)($5b9fd94d0fcc59ac$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _39xV02TA3o _0jFU0VTA3o",
            __cmplp.className
        ])
    });
});
const $5b9fd94d0fcc59ac$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $9aYkv.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02pJKa _0jFU0VpJKa _33tBfP0dzo _3138421Y8M _0adFHsdnbC _1DCdHi8HPE _2XsHFM8HPE _0KLXruGsB2 _3OqcjTiObl _3CkH9o4749",
            __cmplp.className
        ])
    });
});
module.exports["className"] = $5b9fd94d0fcc59ac$export$2913c0c0b5623090;
module.exports["Image"] = $5b9fd94d0fcc59ac$export$3e431a229df88919;

});

parcelRegister("85KcP", function(module, exports) {
/* ImageIcon.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6Eovk = parcelRequire("6Eovk");


var $aFr4e = parcelRequire("aFr4e");

const $c56aa820dbfc924e$var$styles = {
    roundedImage: "_0bjKvDS5Zs"
};
const $c56aa820dbfc924e$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false); // If url changes, reset state
    (0, $cozmU.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $cozmU.useCallback)(()=>{
        setHasImageErrored(true);
    }, []); // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if (hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aFr4e.Image // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: (0, $hekY6.default)([
            appearance === 'round' && $c56aa820dbfc924e$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton ? {
            onError: handleError
        } : undefined
    });
    if (hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};
module.exports["ImageIcon"] = $c56aa820dbfc924e$export$4a122bafaa48b23d;

});

parcelRegister("dCAZw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bd7aa1482f10082c$export$f51768a4e7ff128 = ()=>{
    const gradientId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: gradientId,
        gradientUnits: "userSpaceOnUse",
        x1: "49.4199",
        x2: "122.662",
        y1: "59.7673",
        y2: "59.7673"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0",
        stopColor: "#0065ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: ".2188",
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: ".5999",
        stopColor: "#2780ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
        fill: `url(#${gradientId})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
        fill: "#ff7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
        fill: "#344563"
    }));
};
module.exports["ForbiddenSVG"] = $bd7aa1482f10082c$export$f51768a4e7ff128;

});

parcelRegister("jp8Mi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dM7c5 = parcelRequire("dM7c5");


var $dr8Ob = parcelRequire("dr8Ob");


var $cKLWB = parcelRequire("cKLWB");


var $h4p2T = parcelRequire("h4p2T");

const $2ca454ac27b3dd0b$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $cozmU.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cKLWB.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h4p2T.NotFoundSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dr8Ob.toMessage)((0, $dM7c5.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dr8Ob.toMessage)((0, $dM7c5.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $2ca454ac27b3dd0b$export$2e2bcd8739ae039 = $2ca454ac27b3dd0b$var$NotFoundView;
module.exports["default"] = $2ca454ac27b3dd0b$export$2e2bcd8739ae039;

});

parcelRegister("h4p2T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $0fbd1516733958fd$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "1316.98",
        y1: "230.66",
        x2: "1396.36",
        y2: "230.66",
        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0",
        stopColor: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#6c798f"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "170.3",
        y1: "897.49",
        x2: "365.15",
        y2: "897.49",
        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0",
        stopColor: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.69",
        stopColor: "#fff",
        stopOpacity: "0.1"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        defaultMessage: "Search error",
        id: "smart-card.not-found-svg.title"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        id: "Objects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#cfd4db",
        d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        id: "_Path_",
        "data-name": "<Path>",
        fill: "url(#linear-gradient)",
        d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091e42",
        opacity: 0.1,
        d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#344563",
        d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        id: "_Clipping_Path_",
        "data-name": "<Clipping Path>",
        fill: "#deebff",
        d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        id: "_Path_2",
        "data-name": "<Path>",
        fill: "#b2d4ff",
        d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#cce0ff",
        d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "url(#linear-gradient-2)",
        d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("polygon", {
        id: "_Path_3",
        "data-name": "<Path>",
        fill: "#5e6c84",
        points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#ffc400",
        d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#ffc400",
        d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#344563",
        d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
    }))));
module.exports["NotFoundSVG"] = $0fbd1516733958fd$export$80542c1714a314c8;

});

parcelRegister("ev6Ol", function(module, exports) {
/* ResolvedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $rECdA = parcelRequire("rECdA");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $4yYAm = parcelRequire("4yYAm");


var $irGZZ = parcelRequire("irGZZ");


var $2Q7sv = parcelRequire("2Q7sv");


var $3YqvO = parcelRequire("3YqvO");


var $8QLAc = parcelRequire("8QLAc");


var $16kNn = parcelRequire("16kNn");


var $2qmKU = parcelRequire("2qmKU");


var $856OS = parcelRequire("856OS");


var $6Z2q8 = parcelRequire("6Z2q8");


var $85KcP = parcelRequire("85KcP");


var $8sc8n = parcelRequire("8sc8n");


const $5dcf92556a9a48ad$var$EmbedRovoActionsFooter = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "AgJNn",
    name: "EmbedRovoActionsFooter",
    loader: ()=>(parcelRequire("ehQDZ")).then((module)=>module.default),
    loading: ()=>null
});
$5dcf92556a9a48ad$var$EmbedRovoActionsFooter.displayName = 'lazy(EmbedRovoActionsFooter)';
const $5dcf92556a9a48ad$var$styles = {
    contentWithFooter: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC",
    frameWithFooter: "_2O5Vij7dHp _4kiQYAdnbC",
    footer: "_3iDTPbQ4SZ _37wbyuchRC _0xmtko2ADO _46hvQm2ADO _03SyCP2ADO _0LQT5E2ADO"
};
const $5dcf92556a9a48ad$var$EmbedFrameWithRovoFooter = ({ actionOptions: actionOptions, details: details, frame: frame, link: link, testId: testId })=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $8QLAc.default)();
    const { isEnabled: isEmbedRovoActionsFooterEnabled } = (0, $3YqvO.default)(link, actionOptions, rovoOptions, product);
    const rovoActionData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>isEmbedRovoActionsFooterEnabled && details ? (0, $irGZZ.default)({
            response: details,
            rovoConfig: {
                rovoOptions: rovoOptions,
                product: product
            },
            product: product,
            actionOptions: actionOptions,
            appearance: (0, $4yYAm.CardDisplay).Embed,
            isEmbedRovoActionsFooterExperimentEnabled: isEmbedRovoActionsFooterEnabled
        }) : undefined, [
        actionOptions,
        details,
        isEmbedRovoActionsFooterEnabled,
        product,
        rovoOptions
    ]);
    const prompts = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!isEmbedRovoActionsFooterEnabled) return [];
        return (0, $2qmKU.getRovoPostAuthPromptKeys)({
            extensionKey: (0, $2Q7sv.getExtensionKey)(details)
        });
    }, [
        details,
        isEmbedRovoActionsFooterEnabled
    ]);
    const footer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>rovoActionData && prompts.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5dcf92556a9a48ad$var$EmbedRovoActionsFooter, {
            actionData: rovoActionData,
            prompts: prompts,
            testId: `${testId}-rovo-actions-footer`
        }) : undefined, [
        prompts,
        rovoActionData,
        testId
    ]);
    return footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dcf92556a9a48ad$var$styles.contentWithFooter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dcf92556a9a48ad$var$styles.frameWithFooter
        ])
    }, frame), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dcf92556a9a48ad$var$styles.footer
        ])
    }, footer)) : frame;
};
const $5dcf92556a9a48ad$var$EmbedFrameWithoutRovoFooter = ({ frame: frame })=>frame;
const $5dcf92556a9a48ad$var$EmbedFrameWithOptionalRovoFooter = (0, $rECdA.componentWithFG)('platform_sl_3p_auth_rovo_embed_footer_kill_switch', $5dcf92556a9a48ad$var$EmbedFrameWithRovoFooter, $5dcf92556a9a48ad$var$EmbedFrameWithoutRovoFooter);
const $5dcf92556a9a48ad$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ actionOptions: actionOptions, link: link, context: context, details: details, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const iconLabel = context?.iconLabel;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "icon",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $85KcP.ImageIcon), {
            src: src,
            ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                alt: iconLabel
            } : undefined,
            default: linkGlyph,
            appearance: (0, $16kNn.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton,
        iconLabel
    ]);
    (0, $8sc8n.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $IQ4Dz.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $16kNn.getPreviewUrlWithTheme)(previewUrl, themeState);
    const [isMouseOver, setMouseOver] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Z2q8.Frame), {
        url: previewUrl,
        isTrusted: isTrusted,
        testId: testId,
        ref: embedIframeRef,
        onIframeDwell: onIframeDwell,
        onIframeFocus: onIframeFocus,
        onIframeMouseEnter: onIframeMouseEnter,
        onIframeMouseLeave: onIframeMouseLeave,
        isMouseOver: isMouseOver,
        title: text,
        extensionKey: extensionKey
    });
    const frameWithFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5dcf92556a9a48ad$var$EmbedFrameWithOptionalRovoFooter, {
        actionOptions: actionOptions,
        details: details,
        frame: frame,
        link: link,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856OS.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        onContentMouseEnter: ()=>{
            setMouseOver(true);
            onIframeMouseEnter?.();
        },
        onContentMouseLeave: ()=>{
            setMouseOver(false);
            onIframeMouseLeave?.();
        }
    }, frameWithFooter);
});
module.exports["EmbedCardResolvedView"] = $5dcf92556a9a48ad$export$30f3c6c32b384a8b;

});

parcelRegister("3YqvO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $aflIU = parcelRequire("aflIU");


var $2Q7sv = parcelRequire("2Q7sv");


var $9H66G = parcelRequire("9H66G");

const $9741347bf457b85f$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS = new Set([
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'gitlab-object-provider'
]);
const $9741347bf457b85f$var$isEligibleEmbedRovoActionsFooterExtensionKey = (extensionKey)=>extensionKey !== undefined && $9741347bf457b85f$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS.has(extensionKey);
const $9741347bf457b85f$export$76c8c65be40d033d = 'platform_sl_3p_auth_rovo_embed_footer_exp';
const $9741347bf457b85f$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
const $9741347bf457b85f$export$f52bc2858cff4634 = (product)=>{
    return product === 'CONFLUENCE' && (0, $iDrrr.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch') && (0, $ieeJu.expValEquals)($9741347bf457b85f$export$76c8c65be40d033d, 'isEnabled', true);
};
const $9741347bf457b85f$var$isEmbedRovoActionsFooterKillSwitchEnabled = (product)=>{
    return product === 'CONFLUENCE' && (0, $iDrrr.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch');
};
const $9741347bf457b85f$var$isEmbedRovoActionsFooterExperimentEnabledNoExposure = (product)=>{
    return $9741347bf457b85f$var$isEmbedRovoActionsFooterKillSwitchEnabled(product) && (0, $anBbz.expValEqualsNoExposure)($9741347bf457b85f$export$76c8c65be40d033d, 'isEnabled', true);
};
const $9741347bf457b85f$export$d92e090f28e31112 = ({ extensionKey: extensionKey, isRovoChatActionOptedIn: isRovoChatActionOptedIn, isRovoChatEnabled: isRovoChatEnabled, product: product })=>{
    const isEligible = $9741347bf457b85f$var$isEmbedRovoActionsFooterKillSwitchEnabled(product) && isRovoChatEnabled && isRovoChatActionOptedIn && $9741347bf457b85f$var$isEligibleEmbedRovoActionsFooterExtensionKey(extensionKey);
    if (!isEligible) return undefined;
    return {
        [$9741347bf457b85f$export$76c8c65be40d033d]: {
            isEligible: true,
            isTreatment: $9741347bf457b85f$var$isEmbedRovoActionsFooterExperimentEnabledNoExposure(product)
        }
    };
};
const $9741347bf457b85f$var$useEmbedRovoActionsFooterExperiment = (url, actionOptions, rovoOptions, product)=>{
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoOptions);
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn || !extensionKey) return $9741347bf457b85f$var$NOT_ENABLED_RESULT;
        if (!$9741347bf457b85f$var$isEligibleEmbedRovoActionsFooterExtensionKey(extensionKey)) return $9741347bf457b85f$var$NOT_ENABLED_RESULT;
        return {
            isEnabled: $9741347bf457b85f$export$f52bc2858cff4634(product)
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $9741347bf457b85f$export$2e2bcd8739ae039 = $9741347bf457b85f$var$useEmbedRovoActionsFooterExperiment;
module.exports["getEmbedRovoActionsFooterExperimentMeta"] = $9741347bf457b85f$export$d92e090f28e31112;
module.exports["default"] = $9741347bf457b85f$export$2e2bcd8739ae039;

});

parcelRegister("2qmKU", function(module, exports) {

var $edVsK = parcelRequire("edVsK");

const $46eb4abe0e555d2b$export$126e73c0e270bd5c = ({ extensionKey: extensionKey })=>{
    const defaultPrompts = [
        (0, $edVsK.RovoChatPromptKey).KEY_HIGHLIGHTS
    ];
    if (extensionKey === 'github-object-provider' || extensionKey === 'gitlab-object-provider') return [
        (0, $edVsK.RovoChatPromptKey).EXPLAIN_CODE,
        ...defaultPrompts
    ];
    return [
        (0, $edVsK.RovoChatPromptKey).SUMMARIZE_DOCUMENT,
        ...defaultPrompts
    ];
};
module.exports["getRovoPostAuthPromptKeys"] = $46eb4abe0e555d2b$export$126e73c0e270bd5c;

});

parcelRegister("6Z2q8", function(module, exports) {
/* Frame.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $1hQ0e = parcelRequire("1hQ0e");


var $iDrrr = parcelRequire("iDrrr");


var $16kNn = parcelRequire("16kNn");


var $gJj3k = parcelRequire("gJj3k");


var $9mLDM = parcelRequire("9mLDM");

function $12f901a32427aa31$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $12f901a32427aa31$var$iframeStyles = null;
const $12f901a32427aa31$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isMouseOver: isMouseOverProp, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $6cFsl.di)((0, $gJj3k.IFrame));
    const doc = (0, $1hQ0e.getDocument)();
    const [isIframeLoaded, setIframeLoaded] = (0, $cozmU.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $cozmU.useState)(false); // Accessing the document here for SSR where document.hasFocus may be absent breaks SSR
    // when we're trying to load things like Loom frames in SSR
    // We _could_ either throw a guard in here (i.e check for the existence of document)
    // _or_
    // we can default to false, and set this state once the frame ref is available in a useEffect (safer IMO)
    // which already seems to be existing behavior in a useEffect below.
    const [isWindowFocused, setWindowFocused] = (0, $cozmU.useState)(// The below will be removed as part of FG cleanup
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (0, $iDrrr.fg)('jpx-1074-smart-links-iframe') ? doc?.hasFocus() ?? false : document.hasFocus()); // Use prop if provided (from wrapper), otherwise use local state (for backward compatibility)
    const effectiveMouseOver = isMouseOverProp !== undefined ? isMouseOverProp : isMouseOver;
    const ref = (0, $cozmU.useRef)();
    const mergedRef = $12f901a32427aa31$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $cozmU.useState)(0); /**
                                                            * These are the 'percent visible' thresholds at which the intersectionObserver will
                                                            * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
                                                            * vice versa. It's in a state object so that its static for the useEffect
                                                            */ 
    const [threshold] = (0, $cozmU.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Initialize with current focus state
        // The below will be removed as part of FG cleanup
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        setWindowFocused((0, $iDrrr.fg)('jpx-1074-smart-links-iframe') ? doc?.hasFocus() ?? false : document.hasFocus());
        const onBlur = ()=>{
            setWindowFocused(false);
            if ((0, $iDrrr.fg)('jpx-1074-smart-links-iframe')) {
                if (doc?.activeElement === ref.current) onIframeFocus && onIframeFocus();
            } else // The below will be removed as part of FG cleanup
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus,
        doc
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9mLDM.IframeDwellTracker), {
        isIframeLoaded: isIframeLoaded,
        isMouseOver: effectiveMouseOver,
        isWindowFocused: isWindowFocused,
        iframePercentVisible: percentVisible,
        onIframeDwell: onIframeDwell
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gJj3k.IFrame), {
        childRef: mergedRef,
        src: url,
        "data-testid": `${testId}-frame`,
        "data-test-iframe-loaded": isIframeLoaded,
        onMouseEnter: ()=>{
            onIframeMouseEnter?.(); // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(true);
        },
        onMouseLeave: ()=>{
            onIframeMouseLeave?.(); // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(false);
        },
        allowFullScreen: true,
        scrolling: "yes",
        allow: "autoplay; encrypted-media; clipboard-write",
        onLoad: ()=>{
            setIframeLoaded(true);
        },
        sandbox: (0, $16kNn.getIframeSandboxAttribute)(isTrusted),
        title: title,
        extensionKey: extensionKey,
        className: (0, $hekY6.default)([
            "_30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _0bjKvDzXzM _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
        ])
    }));
});
module.exports["Frame"] = $12f901a32427aa31$export$b89a827e9254211a;

});

parcelRegister("gJj3k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jpl1A = parcelRequire("jpl1A");


var $19zon = parcelRequire("19zon");

const $5b6c9e2393a4e885$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $19zon.useConfluencePageData)(props.src || '', extensionKey || '');
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jpl1A.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $5b6c9e2393a4e885$export$b32b5f1ee4493319;

});

parcelRegister("jpl1A", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $huDU4 = parcelRequire("huDU4");

const $4e16066777de6fa0$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huDU4.Page), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huDU4.Page), props));
module.exports["Page"] = $4e16066777de6fa0$export$6955bcca4cd3539f;

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("ZTkH5", function(module, exports) {

var $bhgzl = parcelRequire("bhgzl");


var $kN2Vj = parcelRequire("kN2Vj");

const $7689e3ff3e3f1e38$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $bhgzl.default;
        case 'en-US':
        default:
            return 0, $kN2Vj.default;
    }
};
var $7689e3ff3e3f1e38$export$2e2bcd8739ae039 = $7689e3ff3e3f1e38$var$fetchTranslations;
module.exports["default"] = $7689e3ff3e3f1e38$export$2e2bcd8739ae039;

});

parcelRegister("bhgzl", function(module, exports) {
$parcel$export(module.exports, "default", () => $934ba482728c60bf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $934ba482728c60bf$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("kN2Vj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ff8966a59ac9886$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2ff8966a59ac9886$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("huDU4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bneqI = parcelRequire("bneqI");


var $kSwu1 = parcelRequire("kSwu1");


var $lNV6K = parcelRequire("lNV6K");


var $eqf9i = parcelRequire("eqf9i");

const $2a2f2045c781985c$var$ViewComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNV6K.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNV6K.ViewPage), {
        locale: locale,
        ...props
    });
};
const $2a2f2045c781985c$var$EditComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqf9i.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqf9i.EditPage), {
        locale: locale,
        ...props
    });
};
const $2a2f2045c781985c$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bneqI.Page), {
            locale: locale,
            ...props,
            viewComponent: $2a2f2045c781985c$var$ViewComponent,
            editComponent: $2a2f2045c781985c$var$EditComponent
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bneqI.Page), {
        locale: locale,
        ...props,
        viewComponent: $2a2f2045c781985c$var$ViewComponent,
        editComponent: $2a2f2045c781985c$var$EditComponent
    });
};
module.exports["Page"] = $2a2f2045c781985c$export$6955bcca4cd3539f;

});

parcelRegister("lNV6K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $d6sBA = parcelRequire("d6sBA");

const $33123752fa9ae571$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6sBA.ViewPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6sBA.ViewPage), props));
module.exports["ViewPage"] = $33123752fa9ae571$export$767e3006bdbb424a;

});

parcelRegister("d6sBA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $50kEc = parcelRequire("50kEc");


var $kSwu1 = parcelRequire("kSwu1");

const $f2833a7709cd73fa$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50kEc.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50kEc.ViewPage), {
        locale: locale,
        ...props
    });
};
module.exports["ViewPage"] = $f2833a7709cd73fa$export$767e3006bdbb424a;

});

parcelRegister("eqf9i", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $b06A9 = parcelRequire("b06A9");

const $93cc002eb7ec4a9a$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b06A9.EditPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b06A9.EditPage), props));
module.exports["EditPage"] = $93cc002eb7ec4a9a$export$1fea75498367c4ac;

});

parcelRegister("b06A9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4nZvv = parcelRequire("4nZvv");


var $kSwu1 = parcelRequire("kSwu1");

const $3470eb5cef855d36$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4nZvv.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4nZvv.EditPage), {
        locale: locale,
        ...props
    });
};
module.exports["EditPage"] = $3470eb5cef855d36$export$1fea75498367c4ac;

});

parcelRegister("19zon", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k4lqb = parcelRequire("k4lqb");


var $jIrdU = parcelRequire("jIrdU");

var $0848f0766ba8a46c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $0848f0766ba8a46c$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $0848f0766ba8a46c$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $0848f0766ba8a46c$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $cozmU.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($0848f0766ba8a46c$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $cozmU.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $k4lqb.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $0848f0766ba8a46c$export$10fb2803bc7b79fc;

});

parcelRegister("9mLDM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");

/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $70fd23309a2b541b$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $70fd23309a2b541b$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $cozmU.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $cozmU.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $cozmU.useEffect)(()=>{
        if (dwell.time > 0 && $70fd23309a2b541b$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $cozmU.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        // Require: iframe loaded, mouse over, and >75% visible.
        // Note: isWindowFocused is intentionally not required - it's unreliable and
        // prevents tracking. The mouse over check is sufficient to indicate user engagement.
        const shouldTrack = isIframeLoaded && isMouseOver && iframePercentVisible > 0.75;
        if (shouldTrack) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        } else if (dwellTimeoutId.current) {
            clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = undefined;
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};
module.exports["IframeDwellTracker"] = $70fd23309a2b541b$export$e3cb965901aecabd;

});

parcelRegister("8sc8n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEvdy = parcelRequire("cEvdy");

const $2edfb61374fec3d9$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $cEvdy.default)();
    (0, $cozmU.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve({
                url: url,
                isReloading: true
            });
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};
module.exports["useEmbedResolvePostMessageListener"] = $2edfb61374fec3d9$export$50ac35a9a8f2ebaa;

});

parcelRegister("ehQDZ", function(module, exports) {

let $a66b7d358b50bb91$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a66b7d358b50bb91$var$load("RBIOk").then(()=>parcelRequire('hUPNm'));

});

parcelRegister("ak0yl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $4bvRC = parcelRequire("4bvRC");


var $cKLWB = parcelRequire("cKLWB");


var $6cFDN = parcelRequire("6cFDN");


var $jDMdd = parcelRequire("jDMdd");

const $1d2b6b3921e803b4$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $cozmU.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $cozmU.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4bvRC.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_unauthorised_account_action,
                    values: values
                }))
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $dM7c5.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $dM7c5.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).unauthorised_account_name_no_provider),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).unauthorised_account_description_no_provider)
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cKLWB.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cFDN.UnauthorizedSVG), null),
        testId: testId,
        text: context?.text
    });
};
const $1d2b6b3921e803b4$var$UnauthorizedViewGated = (props)=>{
    if ((0, $cXtTj.default).initializeCompleted() && (0, $cXtTj.default).getExperimentValue('platform_sl_embed_preauth_teaser_exp', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jDMdd.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d2b6b3921e803b4$var$UnauthorizedView, props);
};
var $1d2b6b3921e803b4$export$2e2bcd8739ae039 = $1d2b6b3921e803b4$var$UnauthorizedViewGated;
module.exports["default"] = $1d2b6b3921e803b4$export$2e2bcd8739ae039;

});

parcelRegister("6cFDN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $100aad242333a22e$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1375_267)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        transform: "translate(0.870117 0.509766)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
        stroke: "url(#paint0_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
        fill: "#403294"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.25",
        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
        fill: "url(#paint1_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.25",
        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
        fill: "url(#paint2_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
        stroke: "url(#paint3_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.38",
        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
        fill: "url(#paint4_radial_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
        fill: "url(#paint5_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
        fill: "url(#paint6_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
        fill: "url(#paint7_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
        fill: "url(#paint8_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
        fill: "url(#paint9_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
        fill: "url(#paint10_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
        fill: "url(#paint11_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
        fill: "url(#paint12_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
        fill: "url(#paint13_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
        fill: "url(#paint14_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
        fill: "url(#paint15_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
        fill: "url(#paint16_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
        fill: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
        fill: "url(#paint17_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
        fill: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
        fill: "url(#paint18_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_1375_267",
        x1: "141.994",
        y1: "181.192",
        x2: "0.870117",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#C1C7D0",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_1375_267",
        x1: "208.292",
        y1: "264.428",
        x2: "0.870117",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_1375_267",
        x1: "357.327",
        y1: "264.428",
        x2: "564.748",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_1375_267",
        x1: "423.624",
        y1: "181.192",
        x2: "564.748",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1724",
        stopColor: "#076AFF",
        stopOpacity: "0.8007"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.4145",
        stopColor: "#1976FF",
        stopOpacity: "0.5208"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.6966",
        stopColor: "#378BFF",
        stopOpacity: "0.1947"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8651",
        stopColor: "#4C9AFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
        id: "paint4_radial_1375_267",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(285 99.0229) scale(96.5182)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1584",
        stopColor: "#FFE587",
        stopOpacity: "0.8416"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.3589",
        stopColor: "#FFDA57",
        stopOpacity: "0.6411"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.5498",
        stopColor: "#FFD031",
        stopOpacity: "0.4502"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.7256",
        stopColor: "#FFC916",
        stopOpacity: "0.2744"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8811",
        stopColor: "#FFC506",
        stopOpacity: "0.1189"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint5_linear_1375_267",
        x1: "346.074",
        y1: "98.8386",
        x2: "423.624",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint6_linear_1375_267",
        x1: "237.087",
        y1: "120.044",
        x2: "276.412",
        y2: "120.044",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint7_linear_1375_267",
        x1: "237.087",
        y1: "75.0106",
        x2: "276.412",
        y2: "75.0106",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint8_linear_1375_267",
        x1: "335.969",
        y1: "146.593",
        x2: "335.969",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint9_linear_1375_267",
        x1: "219.544",
        y1: "98.8386",
        x2: "141.994",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint10_linear_1375_267",
        x1: "229.65",
        y1: "146.593",
        x2: "229.65",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#F4F5F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint11_linear_1375_267",
        x1: "402.858",
        y1: "216.64",
        x2: "421.684",
        y2: "223.492",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8134",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8713",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint12_linear_1375_267",
        x1: "376.968",
        y1: "157.139",
        x2: "433.936",
        y2: "157.139",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint13_linear_1375_267",
        x1: "289.638",
        y1: "45.0027",
        x2: "289.638",
        y2: "0.510323",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint14_linear_1375_267",
        x1: "262.238",
        y1: "36.2259",
        x2: "272.592",
        y2: "36.2259",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint15_linear_1375_267",
        x1: "259.6",
        y1: "180.859",
        x2: "259.6",
        y2: "141.017",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint16_linear_1375_267",
        x1: "284.971",
        y1: "171.613",
        x2: "284.971",
        y2: "149.45",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint17_linear_1375_267",
        x1: "157.982",
        y1: "221.995",
        x2: "188.627",
        y2: "221.995",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.3435",
        stopColor: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#998DD9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint18_linear_1375_267",
        x1: "163.185",
        y1: "155.517",
        x2: "213.758",
        y2: "155.517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#8777D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1375_267"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        fill: "white",
        transform: "translate(0.870117 0.509766)"
    }))));
module.exports["UnauthorizedSVG"] = $100aad242333a22e$export$6526edaac83a8c90;

});

parcelRegister("jDMdd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $kTb7m = parcelRequire("kTb7m");


var $cSGyR = parcelRequire("cSGyR");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $8QLAc = parcelRequire("8QLAc");


var $98xYo = parcelRequire("98xYo");


var $856OS = parcelRequire("856OS");


var $85KcP = parcelRequire("85KcP");


var $a7hZJ = parcelRequire("a7hZJ");


var $3mNgv = parcelRequire("3mNgv");


var $gV2Is = parcelRequire("gV2Is");


var $fxgGA = parcelRequire("fxgGA");


var $8gING = parcelRequire("8gING");

const $8c5432aa21bcbbd9$var$PARENT_PRODUCT = {
    ATLAS: 'ATLAS',
    BITBUCKET: 'BITBUCKET',
    CONFLUENCE: 'CONFLUENCE',
    CSM: 'JIRA',
    JPD: 'JIRA',
    JSM: 'JIRA',
    JSW: 'JIRA',
    JWM: 'JIRA',
    TRELLO: 'TRELLO'
};
const $8c5432aa21bcbbd9$var$PRODUCT_COMPANION = {
    ATLAS: 'ATLAS',
    BITBUCKET: 'BITBUCKET',
    CONFLUENCE: 'JIRA',
    JIRA: 'CONFLUENCE',
    TRELLO: 'TRELLO'
};
const $8c5432aa21bcbbd9$var$UnauthorizedCarouselView = ({ context: context, frameStyle: frameStyle, inheritDimensions: inheritDimensions, isSelected: isSelected, onAuthorize: onAuthorize, onClick: onClick, testId: testId = 'embed-card-unauthorized-view', url: url })=>{
    (0, $6cFsl.di)((0, $98xYo.default));
    (0, $6cFsl.di)((0, $a7hZJ.default));
    (0, $6cFsl.di)((0, $3mNgv.default));
    const intl = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { rovoOptions: rovoOptions, product: product } = (0, $8QLAc.default)();
    const canAuthorize = typeof onAuthorize === 'function';
    const providerName = context?.text;
    const providerIcon = (0, $cozmU.useMemo)(()=>{
        const iconLabel = context?.iconLabel ?? context?.text ?? '';
        if (typeof context?.icon === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: context.icon,
            alt: iconLabel
        });
        if (context?.icon) return context.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: "blue",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))),
            label: iconLabel,
            size: "small",
            testId: "embed-card-fallback-icon"
        });
    }, [
        context
    ]);
    const items = (0, $cozmU.useMemo)(()=>{
        if (!canAuthorize) return [
            {
                id: 'no-auth-available',
                title: intl.formatMessage((0, $dM7c5.messages).unauthorised_account_name_no_provider),
                description: intl.formatMessage((0, $dM7c5.messages).unauthorised_account_description_no_provider),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gV2Is.default), null)
            }
        ];
        const parentProduct = product ? $8c5432aa21bcbbd9$var$PARENT_PRODUCT[product] : undefined;
        const parentProductIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxgGA.default), {
            product: parentProduct
        });
        const parentProductAlt = parentProduct ? $8c5432aa21bcbbd9$var$PRODUCT_COMPANION[parentProduct] : parentProduct;
        const parentProductIconAlt = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxgGA.default), {
            product: parentProductAlt
        });
        // We only have special text for Google Drive and i18n select takes only one word (no space).
        const i18nSelectContext = context?.text === 'Google Drive' ? 'Google' : context?.text;
        const slides = [
            {
                id: 'smart-link-benefit',
                title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_sl_title),
                description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_sl_description, {
                    context: i18nSelectContext,
                    product: parentProduct
                }),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8gING.default), {
                    productIcon: parentProductIcon,
                    providerIcon: providerIcon
                })
            }
        ];
        // If the link has an unauthorized status and provides an onAuthorize callback,
        // it is likely a 3P (third-party) link and is supported by Rovo. In that case,
        // we show additional Rovo-specific teaser slides to encourage the user to connect their account.
        if (rovoOptions?.isRovoEnabled) slides.push({
            id: 'rovo-search-benefit',
            title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovo_title),
            description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovo_description, {
                context: providerName,
                product: parentProduct
            }),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3mNgv.default), {
                productIcon: parentProductIcon,
                productIconAlt: parentProductIconAlt,
                providerIcon: providerIcon
            }))
        });
        if (rovoOptions?.isRovoEnabled && rovoOptions?.isRovoLLMEnabled) slides.push({
            id: 'rovo-chat-benefit',
            title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovochat_title),
            description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovochat_description, {
                context: providerName
            }),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a7hZJ.default), {
                productIcon: parentProductIcon,
                productIconAlt: parentProductIconAlt,
                providerIcon: providerIcon
            }))
        });
        return slides;
    }, [
        canAuthorize,
        context,
        intl,
        product,
        providerName,
        providerIcon,
        rovoOptions
    ]);
    const handleOnAuthorizeClick = (0, $cozmU.useCallback)((slideId)=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            fireEvent('ui.button.clicked.carouselConnect', {
                display: 'embed',
                slideId: slideId
            });
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const handleOnNextClick = (0, $cozmU.useCallback)((slideId)=>{
        fireEvent('ui.button.clicked.carouselNext', {
            display: 'embed',
            slideId: slideId
        });
    }, [
        fireEvent
    ]);
    const buttonLabel = context?.text ? intl.formatMessage((0, $dM7c5.messages).connect_3p_account, {
        context: context.text
    }) : intl.formatMessage((0, $dM7c5.messages).connect_link_account_card);
    const icon = (0, $cozmU.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(context?.icon)) return context.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $85KcP.ImageIcon), {
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "icon",
                color: "currentColor"
            }),
            src: typeof context?.icon === 'string' ? context.icon : undefined
        });
    }, [
        context?.icon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856OS.ExpandedFrame), {
        allowScrollBar: true,
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        isSelected: isSelected,
        inheritDimensions: inheritDimensions,
        onClick: onClick,
        setOverflow: true,
        testId: testId,
        text: context?.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98xYo.default), {
        icon: context?.icon,
        iconLabel: context?.text,
        items: items,
        onNextClick: handleOnNextClick,
        onPrimaryButtonClick: canAuthorize ? handleOnAuthorizeClick : undefined,
        primaryButtonLabel: buttonLabel,
        testId: `${testId}-carousel`
    }));
};
var $8c5432aa21bcbbd9$export$2e2bcd8739ae039 = $8c5432aa21bcbbd9$var$UnauthorizedCarouselView;
module.exports["default"] = $8c5432aa21bcbbd9$export$2e2bcd8739ae039;

});

parcelRegister("98xYo", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $iaqX7 = parcelRequire("iaqX7");

const $271896453320d65e$var$styles = {
    carousel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
};
const $271896453320d65e$var$fadeIn = null;
const $271896453320d65e$var$slideWrapperMap = {
    static: "_39xV02N91d _0jFU0VN91d",
    animated: "_39xV02N91d _0jFU0VN91d _1gBibyZMPz _0nFVCGwPCu _43vdfTF4l5 _3Y6bKpZSoF _0LqqFdYbGa _0adGzLrPZy"
};
const $271896453320d65e$var$getSize = (width, height)=>{
    if (width < 200 || height < 100) return 'minimal';
    if (width < 400 || height < 140) return 'compact';
    return 'full';
};
const $271896453320d65e$var$Carousel = ({ icon: icon, iconLabel: iconLabel, initialSlideIndex: initialSlideIndex = 0, items: items, onNextClick: onNextClick, onPrimaryButtonClick: onPrimaryButtonClick, primaryButtonLabel: primaryButtonLabel, testId: testId = 'embed-card-teaser-carousel' })=>{
    const [activeIndex, setActiveIndex] = (0, $cozmU.useState)(initialSlideIndex);
    const [size, setSize] = (0, $cozmU.useState)('full'); // Tracks whether the user has navigated at least once.
    // The first slide is rendered statically (no animation) to avoid any
    // CSS animation running during SSR or on the initial paint.
    const hasNavigated = (0, $cozmU.useRef)(false);
    const containerRef = (0, $cozmU.useRef)(null); // Observe the carousel container's size and update the layout bucket.
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            const { width: width, height: height } = entry.contentRect;
            setSize($271896453320d65e$var$getSize(width, height));
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    const goNext = (0, $cozmU.useCallback)(()=>{
        hasNavigated.current = true;
        onNextClick?.(items[activeIndex].id);
        setActiveIndex((current)=>(current + 1) % items.length);
    }, [
        items,
        activeIndex,
        onNextClick
    ]);
    const goTo = (0, $cozmU.useCallback)((index)=>{
        if (index === activeIndex) return;
        hasNavigated.current = true;
        setActiveIndex(index);
    }, [
        activeIndex
    ]);
    const handlePrimaryButtonClick = (0, $cozmU.useCallback)(()=>{
        onPrimaryButtonClick?.(items[activeIndex].id);
    }, [
        onPrimaryButtonClick,
        items,
        activeIndex
    ]);
    const currentSlide = items[activeIndex];
    const isLastSlide = activeIndex === items.length - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        xcss: $271896453320d65e$var$styles.carousel,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: activeIndex,
        xcss: $271896453320d65e$var$slideWrapperMap[hasNavigated.current ? 'animated' : 'static'],
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaqX7.default), {
        primaryButtonLabel: primaryButtonLabel,
        description: currentSlide.description,
        icon: icon,
        iconLabel: iconLabel,
        image: currentSlide.image,
        title: currentSlide.title,
        onPrimaryButtonClick: onPrimaryButtonClick ? handlePrimaryButtonClick : undefined,
        onDotClick: goTo,
        onNextClick: !isLastSlide ? goNext : undefined,
        size: size,
        slideIndex: activeIndex,
        testId: `${testId}-slide`,
        totalSlides: items.length
    })));
};
var $271896453320d65e$export$2e2bcd8739ae039 = $271896453320d65e$var$Carousel;
module.exports["default"] = $271896453320d65e$export$2e2bcd8739ae039;

});

parcelRegister("iaqX7", function(module, exports) {
/* CarouselSlide.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $cSGyR = parcelRequire("cSGyR");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $dM7c5 = parcelRequire("dM7c5");

const $d76e07b4ffd67ffa$var$styles = {
    columnImage: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEskRj _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLFlnN _37wbyuchRC _4kiQYAdnbC _4ouGXIdnbC _0KLXruJVoT",
    imageContainer: "_1mT5xdRAKS _39xV02N91d _0jFU0VN91d",
    imageAbsolute: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d",
    columnContent: "_2mHwu8NHnM _2O5Vij7dHp _3YEZNO7dHp _1bHrqEgZxp _4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0Of8r2S40j _1ZnuxbS40j _1wydGWS40j _2Zuz6QS40j _0hPCNLchRC _37wbyuI7V3",
    columnContentTop: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d",
    columnContentBody: "_2mHwu8NHnM _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d",
    columnContentCompact: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    dot: "_0bjKvDS5Zs _39xV02Jg58 _0jFU0VJg58 _0KLXruDMqu _3Z9K0w2HTN _1kOSYtQiA2 _0qk6IKUtCU _1pp6NdYbGa",
    dotActive: "_0KLXrukLmD",
    dotPassable: "_0bjKvDS5Zs _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg",
    icon: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconImage: "_39xV02N91d _0jFU0VN91d _00EA0egIor",
    image: "_39xV02N91d _0NUa3rPIoL _00EA0egIor _1PLshBXWGq _3iDTPbvLZJ",
    rowButton: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE _0hPCNLDIqT",
    rowButtonCompact: "_39xV02N91d",
    rowDot: "_2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
    rowIcon: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    slide: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _3TGfC9LRg7 _39xV02N91d _0jFU0VN91d _0hPCNLFlnN _24h04i2Njc"
};
const $d76e07b4ffd67ffa$var$CarouselSlide = ({ icon: icon, iconLabel: iconLabel = '', title: title, description: description, image: image, primaryButtonLabel: primaryButtonLabel, onPrimaryButtonClick: onPrimaryButtonClick, onDotClick: onDotClick, onNextClick: onNextClick, slideIndex: slideIndex, totalSlides: totalSlides, size: size, testId: testId = 'embed-card-carousel-slide' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCompact = size !== 'full';
    const showPrimaryButton = typeof onPrimaryButtonClick === 'function';
    const showNavigation = totalSlides > 1;
    const renderedIcon = (0, $cozmU.useMemo)(()=>{
        if (typeof icon === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d76e07b4ffd67ffa$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: icon,
            alt: iconLabel,
            className: (0, $hekY6.default)([
                $d76e07b4ffd67ffa$var$styles.iconImage
            ])
        }));
        if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d76e07b4ffd67ffa$var$styles.icon
        }, icon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: "blue",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))),
            label: iconLabel,
            size: "small",
            testId: "embed-card-fallback-icon"
        });
    }, [
        icon,
        iconLabel
    ]);
    const renderedImage = image == null ? null : typeof image === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: image,
        alt: title,
        className: (0, $hekY6.default)([
            $d76e07b4ffd67ffa$var$styles.image
        ])
    }) : image;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.slide,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d76e07b4ffd67ffa$var$styles.columnContent, isCompact && $d76e07b4ffd67ffa$var$styles.columnContentCompact)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.columnContentTop
    }, showPrimaryButton && isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d76e07b4ffd67ffa$var$styles.rowButton, $d76e07b4ffd67ffa$var$styles.rowButtonCompact)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        shouldFitContainer: true,
        testId: `${testId}-connect-compact`
    }, primaryButtonLabel)), renderedIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.rowIcon
    }, renderedIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        testId: `${testId}-title`
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.columnContentBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        testId: `${testId}-description`
    }, description)), (showPrimaryButton && !isCompact || showNavigation && onNextClick) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.rowButton
    }, showPrimaryButton && !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        testId: `${testId}-connect`
    }, primaryButtonLabel), showNavigation && onNextClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onNextClick,
        testId: `${testId}-next`
    }, formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_button_next))))), showNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.rowDot,
        role: "group",
        "aria-label": formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_dot_row_label)
    }, Array.from({
        length: totalSlides
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            key: i,
            xcss: $d76e07b4ffd67ffa$var$styles.dotPassable,
            onClick: ()=>onDotClick?.(i),
            "aria-label": formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_dot_label, {
                index: i + 1,
                total: totalSlides
            }),
            "aria-current": i === slideIndex ? 'true' : undefined,
            testId: `${testId}-dot-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($d76e07b4ffd67ffa$var$styles.dot, i === slideIndex && $d76e07b4ffd67ffa$var$styles.dotActive)
        }))))), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.columnImage,
        testId: `${testId}-image-panel-${slideIndex}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.imageAbsolute
    }, renderedImage))));
};
var $d76e07b4ffd67ffa$export$2e2bcd8739ae039 = $d76e07b4ffd67ffa$var$CarouselSlide;
module.exports["default"] = $d76e07b4ffd67ffa$export$2e2bcd8739ae039;

});

parcelRegister("a7hZJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $b229bec432b10716$var$LazyRovoChatBenefitImage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("JMHgK")));
var $b229bec432b10716$export$2e2bcd8739ae039 = $b229bec432b10716$var$LazyRovoChatBenefitImage;
module.exports["default"] = $b229bec432b10716$export$2e2bcd8739ae039;

});

parcelRegister("JMHgK", function(module, exports) {

let $0899fa458f021cf8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0899fa458f021cf8$var$load("7CLTD").then(()=>parcelRequire('11TEZ'));

});

parcelRegister("3mNgv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $94cf8a623e442cb8$var$LazyRovoSearchBenefitImage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1DOok")));
var $94cf8a623e442cb8$export$2e2bcd8739ae039 = $94cf8a623e442cb8$var$LazyRovoSearchBenefitImage;
module.exports["default"] = $94cf8a623e442cb8$export$2e2bcd8739ae039;

});

parcelRegister("1DOok", function(module, exports) {

let $132085a1c6c96408$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $132085a1c6c96408$var$load("6bjSp").then(()=>parcelRequire('hR3gu'));

});

parcelRegister("gV2Is", function(module, exports) {
/* NoAuthAvailableImage.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $6cFDN = parcelRequire("6cFDN");

const $98d344ae937c575f$var$styles = {
    container: "_39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0Of8r2NHnM _1wydGWNHnM"
};
const $98d344ae937c575f$var$NoAuthAvailableImage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $98d344ae937c575f$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cFDN.UnauthorizedSVG), null));
var $98d344ae937c575f$export$2e2bcd8739ae039 = $98d344ae937c575f$var$NoAuthAvailableImage;
module.exports["default"] = $98d344ae937c575f$export$2e2bcd8739ae039;

});

parcelRegister("fxgGA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $NlHoa = parcelRequire("NlHoa");


var $6lKz8 = parcelRequire("6lKz8");


var $9Q3yl = parcelRequire("9Q3yl");


var $bltJZ = parcelRequire("bltJZ");


var $k6zJT = parcelRequire("k6zJT");


var $dCFrb = parcelRequire("dCFrb");

const $8744eb45bfff96be$var$ProductIcon = ({ product: product, size: size = 'xsmall' })=>{
    switch(product){
        case 'ATLAS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k6zJT.ProjectsIcon), {
                size: size
            });
        case 'BITBUCKET':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6lKz8.BitbucketIcon), {
                size: size
            });
        case 'CONFLUENCE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3yl.ConfluenceIcon), {
                size: size
            });
        case 'JIRA':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                size: size
            });
        case 'TRELLO':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dCFrb.TrelloIcon), {
                size: size
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                appearance: "brand",
                size: size
            });
    }
};
var $8744eb45bfff96be$export$2e2bcd8739ae039 = $8744eb45bfff96be$var$ProductIcon;
module.exports["default"] = $8744eb45bfff96be$export$2e2bcd8739ae039;

});

parcelRegister("6lKz8", function(module, exports) {

var $fxqZn = parcelRequire("fxqZn");


var $6YXrY = parcelRequire("6YXrY");


var $lRiBt = parcelRequire("lRiBt");

const $6e64e4af8f086740$export$5fc1066e677788d4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $lRiBt.BitbucketIcon), (0, $fxqZn.BitbucketIcon));
module.exports["BitbucketIcon"] = $6e64e4af8f086740$export$5fc1066e677788d4;

});

parcelRegister("k6zJT", function(module, exports) {
parcelRequire("cozmU");


var $hQVHS = parcelRequire("hQVHS");


var $hcVQz = parcelRequire("hcVQz");

const $442b446e44696e25$export$5ed3e1bb3b04fc02 = (0, $hcVQz.tempSizeWrapper)((0, $hQVHS.ProjectsIcon));
module.exports["ProjectsIcon"] = $442b446e44696e25$export$5ed3e1bb3b04fc02;

});

parcelRegister("dCFrb", function(module, exports) {

var $8JGXU = parcelRequire("8JGXU");


var $6YXrY = parcelRequire("6YXrY");


var $ecv2t = parcelRequire("ecv2t");

const $cf42489b45990929$export$4384da9b8b140bf4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $ecv2t.TrelloIcon), (0, $8JGXU.TrelloIcon));
module.exports["TrelloIcon"] = $cf42489b45990929$export$4384da9b8b140bf4;

});

parcelRegister("8gING", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $cozmU = parcelRequire("cozmU");


var $kkpJg = parcelRequire("kkpJg");

const $3a6f3ec5db73232c$var$SmartLinkBenefitImage = ({ productIcon: productIcon, providerIcon: providerIcon })=>{
    const productIconSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kkpJg.default), {
        icon: productIcon,
        x: 68,
        y: 58,
        w: 24,
        h: 24
    });
    const providerIconSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kkpJg.default), {
        icon: providerIcon,
        x: 98.8,
        y: 217.1,
        w: 20,
        h: 20
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        viewBox: "0 0 440 660",
        preserveAspectRatio: "xMidYMin meet",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_3120_9396)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: "scale(1.3) translate(0, 0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M366.41 476.854C366.44 476.804 366.44 476.714 366.5 476.644C364.75 475.764 364.55 473.604 363.2 472.314L363.15 472.264C361.78 471.824 362.15 470.454 360.45 470.444C360.45 470.444 360.89 470.224 360.9 470.224C358.14 467.484 351.32 460.754 351.32 460.754C351.17 461.364 352.41 460.304 353.66 460.484C353.66 460.484 353.75 460.254 353.84 460.434C357.03 457.324 360.62 456.134 364.7 454.654C366.74 454.104 367.05 448.334 363.56 450.724C363.52 450.684 363.43 450.654 363.39 450.584C362.17 452.004 360.14 451.484 358.6 452.224L358.54 452.254L355.98 453.504C354.59 454.074 352.94 454.524 351.21 454.964C351.26 454.914 351.31 454.864 351.36 454.814C351.36 454.814 351.54 452.044 351.49 450.674C351.49 450.674 353.24 448.474 352.66 446.964C353.65 445.194 357.17 441.324 353.97 440.224C352.92 440.224 352.1 439.314 351.74 441.004C351.68 440.994 351.6 441.014 351.52 440.984C351.33 442.734 349.26 443.974 348.69 445.634L348.67 445.704C348.81 447.124 347.71 448.524 347.7 448.524C347.18 449.824 346.5 451.244 345.78 452.724C345.48 451.924 345.15 451.214 344.82 450.704C343.62 449.404 344.13 431.644 339.69 435.564C339.9 438.914 340.96 442.404 340.1 445.384C339.68 445.614 340.32 446.804 340.84 447.774C340.8 449.004 340.55 449.664 340.48 451.424C338.28 449.834 328.68 441.784 329.27 447.204C330.3 447.754 331.05 448.384 331.59 449.664C332.09 450.214 336.5 452.694 336.64 453.314C336.35 454.174 341.56 454.864 339.45 455.504C339.76 456.184 340.18 456.834 340.67 457.464C338.39 457.704 335.66 458.374 334.23 459.244C333.98 459.674 324.88 460.254 321.58 462.384C319.61 463.494 317.87 464.044 319.92 465.714C320.66 465.114 323.44 465.974 323.38 465.184C324.06 465.464 328.66 463.704 329.17 464.004C329.42 464.404 333.04 462.284 332.61 463.284C335.12 463.994 338.18 463.414 341.36 462.604C340.1 464.604 338.86 467.454 338.7 469.224C337.62 471.494 334.77 476.514 333.86 479.594C332.56 481.834 333.01 482.014 334.65 483.164L334.68 483.194C335.02 483.424 334.64 483.194 335.93 483.244C335.8 483.124 335.61 482.604 335.36 482.694C335.53 482.344 337.49 481.844 336.67 481.374C336.64 481.304 337.92 480.324 338.05 479.264C339.19 475.484 341.92 473.574 343.94 469.264C343.89 469.714 347.29 478.184 347.13 482.404C346.88 484.484 351.92 487.584 351.19 482.944C351.25 482.924 351.3 482.844 351.39 482.834C350.58 480.924 351.65 478.954 351.23 477.014L351.21 476.934C350.3 475.754 351.35 474.774 349.91 473.814C349.91 473.814 350.4 473.864 350.41 473.874C349.77 471.124 349.37 467.764 348.77 464.754C350.92 466.704 352.81 468.804 353.59 471.114L353.69 470.964C353.69 471.034 353.84 471.084 353.71 471.244C355.52 471.624 356.14 472.384 357.45 472.894C357.45 472.894 358.85 475.424 360.48 475.514L362.96 479.024C364.03 480.834 369.8 479.794 366.45 476.894L366.41 476.854Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "44",
        y: "42",
        width: "417",
        height: "618",
        rx: "12",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2249 94)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2126 112.083)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2007 130.165)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2324 385)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2205 403)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "271.987",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2083 421)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "26.8308",
        height: "7.5752",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 342.951 94.4097)",
        fill: "#D3F1A7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "34.6884",
        height: "12.9096",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 370.104 80.0767)",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M368.765 80.1709L370.08 80.1759L369.983 102.033L368.668 102.028L368.765 80.1709Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "26.1985",
        height: "2.5257",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 373.772 85.4707)",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "62",
        height: "8",
        transform: "matrix(1 -0.000310775 -0.000336467 1 100.479 66.0459)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "31",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 211.886 238.778)",
        fill: "#94C748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "50",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 226.663 254.858)",
        fill: "#FBD779"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 217.979 270.451)",
        fill: "#C97CF4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 262.94 286.163)",
        fill: "#357DE8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_3120_9396)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M223.554 267.082C223.289 267.367 222.539 267.001 222.639 266.641C222.787 266.127 222.999 265.621 223.339 265.003C223.771 264.319 224.027 264.224 224.276 263.745C224.733 262.944 225.285 261.498 225.416 261.145C225.438 261.092 225.457 261.045 225.493 260.999C225.523 260.949 225.521 260.997 225.564 260.954C225.571 260.942 225.581 260.939 225.582 260.923C225.582 260.923 225.572 260.91 225.569 260.9L225.556 260.893C225.509 260.87 225.462 260.846 225.415 260.822C224.942 260.621 224.374 260.389 223.818 260.195C222.789 259.785 222.154 259.534 221.821 259.405C221.041 259.089 220.483 258.781 219.969 258.415C219.687 258.215 219.976 257.579 220.329 257.63C220.971 257.722 221.594 257.877 222.381 258.181C222.683 258.302 223.405 258.379 224.317 258.706C224.469 258.759 224.609 258.83 224.739 258.92C225.112 259.158 225.543 259.386 225.945 259.574L226.093 259.649C226.18 259.678 226.254 259.715 226.331 259.746C226.499 259.816 226.66 259.882 226.811 259.95C227.121 260.075 227.396 260.183 227.628 260.277C227.337 260.799 227.177 261.097 227.177 261.097C227.177 261.097 225.861 263.422 225.305 264.405C224.914 265.094 224.726 265.426 224.608 265.625C224.255 266.236 223.925 266.69 223.55 267.088L223.554 267.082Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M211.197 241.523C212.078 240.978 212.545 241.643 211.861 242.255C210.914 243.162 210.001 244.175 209.137 245.648C208.645 246.479 208.376 247.02 208.168 247.504C207.953 247.984 207.802 248.415 207.69 249.06C207.488 250.152 207.549 251.652 207.875 252.924C208.02 253.562 208.273 254.135 208.458 254.601C208.696 255.052 208.879 255.404 208.984 255.594C209.058 255.705 209.129 255.821 209.192 255.934C209.397 256.353 210.037 257.478 211.223 258.622C211.797 259.212 212.55 259.749 213.357 260.24C214.182 260.7 215.077 261.115 216 261.35C216.634 261.56 217.235 261.648 217.774 261.752C218.322 261.813 218.805 261.865 219.234 261.89C220.098 261.917 220.732 261.861 221.161 261.813C223.198 261.565 224.664 261.06 226.063 260.448C226.812 260.095 227.271 260.643 226.549 261.172C225.23 262.091 223.63 262.835 221.343 263.124C220.478 263.217 218.562 263.598 215.947 262.954C215.532 262.832 215.106 262.728 214.724 262.534C213.033 261.802 211.304 260.632 210.175 259.525C209.878 259.261 209.626 258.996 209.418 258.745C209.209 258.493 208.995 258.296 208.864 258.092C208.579 257.705 208.407 257.48 208.407 257.48C208.407 257.48 208.346 257.392 208.236 257.24C208.14 257.078 208.003 256.839 207.834 256.551C207.489 255.972 207.111 255.126 206.816 254.168C206.184 252.249 206.242 249.858 206.558 248.501C207.012 246.456 207.592 245.564 207.882 245.017C208.855 243.374 210.003 242.319 211.197 241.523Z",
        fill: "#292A2E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "72",
        y: "161",
        width: "347",
        height: "207",
        rx: "6",
        fill: "#8FB8F6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "66.75",
        y: "155.75",
        width: "348.5",
        height: "207.5",
        rx: "3.25",
        fill: "#F9FBFD",
        stroke: "#8FB8F6",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 103.012 173.165)",
        fill: "#D0DEF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "path-49-inside-1_3120_9396",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M103 206H379V362H103V206Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M103 206H379V362H103V206Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M103 206V205H102V206H103ZM379 206H380V205H379V206ZM103 206V207H379V206V205H103V206ZM379 206H378V362H379H380V206H379ZM103 362H104V206H103H102V362H103Z",
        fill: "#0B120E",
        fillOpacity: "0.14",
        mask: "url(#path-49-inside-1_3120_9396)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 224.002)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "237.496",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 242.005)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "237.496",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 260.005)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M61.3378 122.737C61.6171 122.177 58.1342 113.118 57.2561 115.732C56.801 116.617 57.0322 117.422 58.0247 117.666C56.2623 117.985 59.0352 119.646 58.611 120.492C57.284 120.234 60.4323 122.647 59.0166 122.206C59.6449 132.085 75.9612 151.538 63.6634 127.589C63.5817 130.007 62.6201 127.756 62.6812 126.669C64.6157 128.167 62.2943 123.699 61.5656 122.884C61.8811 124.279 60.2179 122.01 61.3344 122.741L61.3378 122.737Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.5857 140.943C49.2459 139.662 39.2484 134.515 38.2637 133.861C35.9524 132.802 36.384 135.758 38.2594 136.193C38.6122 136.426 41.3136 137.197 40.3497 137.823C41.4171 140.321 46.0137 140.555 46.7236 142.668C47.2511 142.314 48.1137 143.046 48.4778 142.865C48.5362 143.497 49.4685 143.827 49.5152 143.674C52.2908 146.31 54.2499 142.903 50.7524 141.538C50.8676 141.425 50.1541 140.706 49.5943 140.943L49.5857 140.943Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M39.4701 174.033C41.1809 175.147 39.6046 175.107 38.7741 174.555C39.8901 173.487 36.7954 173.565 36.0723 173.932C36.4066 173.988 36.5682 174.533 35.8805 174.456C36.2338 173.13 27.5479 172.249 31.8883 175.362C32.0358 175.367 32.0059 174.299 32.2092 174.645C32.0627 176.249 33.3227 175.211 33.6952 175.114C33.7617 175.957 34.0569 175.199 34.1847 175.555C33.8165 176.657 35.8605 174.913 35.4289 176C37.5666 177.865 41.2905 175.863 42.9467 177.541C43.8244 175.717 50.427 179.002 47.6545 175.204C44.8439 174.19 42.5606 173.57 39.4701 174.033Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.2561 153.478C20.8018 156.036 26.7133 155.89 28.429 157.072C30.5261 158.735 52.0689 165.506 46.1376 159.992C39.609 157.994 34.4269 155.302 26.3618 153.802C25.0538 153.469 20.9211 151.644 21.2561 153.478Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M82.7198 134.846C85.0673 136.492 82.5184 138.446 84.4665 139.99C88.1502 142.366 87.5201 123.15 84.0027 123.526C81.095 124.254 83.8998 133.561 82.7198 134.846Z",
        fill: "#101214"
    }), productIconSlot), providerIconSlot), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_3120_9396",
        x1: "89.6875",
        y1: "172.49",
        x2: "89.6875",
        y2: "177.111",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#1A237E",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#1A237E",
        stopOpacity: "0.02"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
        id: "paint1_radial_3120_9396",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(77.4644 167.395) scale(24.8062 23.319)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "440",
        height: "660",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "matrix(1 -0.000310775 -0.000336467 1 68.0081 58.0562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "18.4543",
        height: "24.9028",
        fill: "white",
        transform: "matrix(-0.507908 0.846939 0.903773 0.454122 212.523 240.466)"
    }))));
};
var $3a6f3ec5db73232c$export$2e2bcd8739ae039 = $3a6f3ec5db73232c$var$SmartLinkBenefitImage;
module.exports["default"] = $3a6f3ec5db73232c$export$2e2bcd8739ae039;

});

parcelRegister("kkpJg", function(module, exports) {
/* IconSlot.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $ced805262a47c5cf$var$iconSlotDivStyles = null;
const $ced805262a47c5cf$var$IconSlot = ({ icon: icon, x: x, y: y, w: w, h: h })=>{
    if (!icon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
        x: x,
        y: y,
        width: w,
        height: h
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, icon));
};
var $ced805262a47c5cf$export$2e2bcd8739ae039 = $ced805262a47c5cf$var$IconSlot;
module.exports["default"] = $ced805262a47c5cf$export$2e2bcd8739ae039;

});

parcelRegister("dsoKG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hHrlI = parcelRequire("hHrlI");


var $b8pma = parcelRequire("b8pma");


var $4yYAm = parcelRequire("4yYAm");


var $leSBv = parcelRequire("leSBv");


var $aqIRz = parcelRequire("aqIRz");


var $2Q7sv = parcelRequire("2Q7sv");


var $8p295 = parcelRequire("8p295");


var $h1uyX = parcelRequire("h1uyX");


var $aw4sA = parcelRequire("aw4sA");


var $a1w5z = parcelRequire("a1w5z");


var $1Zwrg = parcelRequire("1Zwrg");


var $4uUBn = parcelRequire("4uUBn");


var $bAr6P = parcelRequire("bAr6P");

const $561dde74fc5c9bd8$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-inline-card"
    }), children);
const $561dde74fc5c9bd8$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $4yYAm.SmartLinkStatus).Resolved ? (0, $aqIRz.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $cozmU.useEffect)(()=>{
        switch(status){
            case (0, $4yYAm.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title,
                    extensionKey: details?.meta?.key
                });
                break;
            case (0, $4yYAm.SmartLinkStatus).Errored:
            case (0, $4yYAm.SmartLinkStatus).Fallback:
            case (0, $4yYAm.SmartLinkStatus).Forbidden:
            case (0, $4yYAm.SmartLinkStatus).NotFound:
            case (0, $4yYAm.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details?.meta?.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($561dde74fc5c9bd8$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4uUBn.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            }));
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Zwrg.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $hHrlI.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bAr6P.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hHrlI.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1w5z.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hHrlI.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aw4sA.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h1uyX.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline,
                viewType: "errored"
            });
    }
};
module.exports["InlineCard"] = $561dde74fc5c9bd8$export$aff6291803939b05;

});

parcelRegister("aw4sA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $dM7c5 = parcelRequire("dM7c5");


var $jLxvy = parcelRequire("jLxvy");


var $b78WJ = parcelRequire("b78WJ");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

const $204654a0fc91ba1d$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        testId: "errored-view-default-icon"
    });
};
const $204654a0fc91ba1d$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
            onClick: handleRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).try_again));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: icon || $204654a0fc91ba1d$var$fallbackIcon(),
        link: hashAction ? url : undefined,
        title: url,
        onClick: hashAction ? onClick : undefined,
        rightSide: message
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        url: url
    }, content);
    return content;
};
module.exports["InlineCardErroredView"] = $204654a0fc91ba1d$export$8ae570c871cdb179;

});

parcelRegister("a1w5z", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4efpo = parcelRequire("4efpo");


var $hBYtq = parcelRequire("hBYtq");


var $dM7c5 = parcelRequire("dM7c5");


var $jLxvy = parcelRequire("jLxvy");


var $b78WJ = parcelRequire("b78WJ");


var $JiXpY = parcelRequire("JiXpY");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

const $92b1538e1391e576$var$styles = {
    actionButtonLozengeStyle: "_0bjKvDcjp5 _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _1EqgXlN91d"
};
const $92b1538e1391e576$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "forbidden-view-fallback-icon"
    });
};
const $92b1538e1391e576$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $dM7c5.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).invalid_permissions, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formattedMessage));
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account"
            }, renderForbiddenAccessMessage());
        }
        if (onAuthorise) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $92b1538e1391e576$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
            appearance: "moved",
            isBold: true
        }, renderForbiddenAccessMessage()));
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: icon ? icon : $92b1538e1391e576$var$fallbackForbiddenIcon(),
        link: url,
        title: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        url: url
    }, content);
    return content;
};
module.exports["InlineCardForbiddenView"] = $92b1538e1391e576$export$ebd227d2573ed3d8;

});

parcelRegister("4uUBn", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");


var $aWk1Z = parcelRequire("aWk1Z");

const $a634cc4b6380e4aa$var$styles = {
    spinnerWrapper: "_2sNsIg7NXe _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0Vey7F _39xV02ey7F"
};
const $a634cc4b6380e4aa$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $a634cc4b6380e4aa$var$styles.spinnerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: 14,
            interactionName: "smart-card-inline-card-spinner"
        })), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconTitleWrapper), null, url, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aWk1Z.RightIconPositionWrapper), null, renderSpinner())));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: renderSpinner(),
        title: resolvingPlaceholder ?? url,
        titleTextColor: titleTextColor
    }));
};
module.exports["InlineCardResolvingView"] = $a634cc4b6380e4aa$export$98531adac42f053e;

});

parcelRegister("aWk1Z", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $fc7046c3fca81f77$export$91b164375b8037b5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFMFQfX _1mT5xdRAKS _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
module.exports["RightIconPositionWrapper"] = $fc7046c3fca81f77$export$91b164375b8037b5;

});

parcelRegister("bAr6P", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $w6R6I = parcelRequire("w6R6I");


var $4efpo = parcelRequire("4efpo");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $8Mlyd = parcelRequire("8Mlyd");


var $jLxvy = parcelRequire("jLxvy");


var $b78WJ = parcelRequire("b78WJ");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

const $33f2ea2010a25b29$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    });
}; /**
    * When persisted personalization adoption from {@link getCachedProviderPctMapAndRefresh} is strictly below this value,
    * the pill uses exploratory "previewing" copy instead of a percentage headline.
    */ 
const $33f2ea2010a25b29$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD = 30;
const $33f2ea2010a25b29$var$SOCIAL_PROOF_TRAIT_NAME = 'sl_3p_connected_providers_site_pct';
const $33f2ea2010a25b29$var$socialProofPillStyles = {
    strong: "_1kk5Tkmb2E",
    root: "_0bjKvDKxmn _3iDTPbS8kF _0hPCNLDIqT _24h04i2Njc _1EqgXlN91d _0KLXruo126 _1UtDYzZpcK _2fwxA5yL8i _4ya3eETekT _1RrJLiHZdu _0Of8r2FQfX _1wydGWFQfX _1ZnuxbgVvo _2Zuz6QgVvo _0adFHs1Y8M _1eOmH6KcZT _3gzVzLnpTK",
    label: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    wrappingLabel: "_4bt5LAYvD1 _2WAcuGYvD1 _39HuIboWuR _1ANEUSJfqQ _3W2Oc84hR5",
    button: "_0KLXrujOvk _1ZnuxbPgdg _2Zuz6QPgdg _0Of8r2Pgdg _1wydGWPgdg",
    pressableContents: "_3iDTPbcK7c",
    inlineGroup: "_3iDTPbS8kF"
};
/**
 * Renders the social-proof pill and Connect button using persisted percentages only ({@link getCachedProviderPctMapAndRefresh}) — no
 * loading skeleton; either the cached percentage is shown or the legacy long connect label is used.
 *
 * Only mounted when the parent has passed the killswitch and
 * `platform_sl_3p_preauth_social_proof_inline_cta`. See platform docs: `rules-of-hooks.md` "Should §1".
 */ const $33f2ea2010a25b29$var$UnauthorisedConnectWithSocialProof = ({ context: context, extensionKey: extensionKey, testId: testId, onConnectClick: onConnectClick, isPreviewCTATreatment: isPreviewCTATreatment })=>{
    (0, $6cFsl.di)((0, $8Mlyd.getCachedProviderPctMapAndRefresh));
    const providerPctMap = (0, $8Mlyd.getCachedProviderPctMapAndRefresh)($33f2ea2010a25b29$var$SOCIAL_PROOF_TRAIT_NAME); // Will be false if this is the first render, when we fetch traits and store to local storage,
    // or if there wasn't our trait for it.
    const isProviderPctMapLoaded = providerPctMap !== null; // Percent of current user team (same tenant users) who are connected to this extension.
    const connectedPct = extensionKey && isProviderPctMapLoaded ? providerPctMap[extensionKey] : undefined;
    const trimmedProviderDisplayName = context?.trim() ?? '';
    const hasProviderDisplayName = trimmedProviderDisplayName.length > 0;
    const isSocialProofUsageHighEnough = connectedPct !== undefined && connectedPct >= $33f2ea2010a25b29$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD; /**
                                                                                                                           * As long as trait is loaded we show the pill/lozange.
                                                                                                                           */ 
    const showSocialProofPill = providerPctMap !== null && (0, $ieeJu.expValEquals)('platform_sl_3p_preauth_social_proof_inline_cta', 'isEnabled', true);
    const bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "strong",
            xcss: $33f2ea2010a25b29$var$socialProofPillStyles.strong
        }, chunks); // As long as pill is shown it will be one of four messages depending on percent and provider presence:
    // - 45% of your team sees Figma previews
    // - 45% of your team sees richer previews
    // - Your team sees richer Figma previews
    // - Your team sees richer previews
    const socialProofPillContent = isSocialProofUsageHighEnough ? hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).social_proof_inline_cta_tag_high_with_context,
        values: {
            connectedPct: connectedPct,
            context: trimmedProviderDisplayName,
            b: bold
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).social_proof_inline_cta_tag_high_no_context,
        values: {
            connectedPct: connectedPct,
            b: bold
        }
    }) : hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).social_proof_inline_cta_tag_low_with_context,
        values: {
            context: trimmedProviderDisplayName
        }
    }) : // Unlikely case, but possible from TS standpoint.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).social_proof_inline_cta_tag_low_no_context);
    const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $33f2ea2010a25b29$var$socialProofPillStyles.root,
        testId: `${testId}-social-proof-tag`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($33f2ea2010a25b29$var$socialProofPillStyles.label, (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') && $33f2ea2010a25b29$var$socialProofPillStyles.wrappingLabel)
    }, socialProofPillContent)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
        onClick: onConnectClick,
        viewType: "unauthorised",
        testId: "button-connect-account",
        isSlimDesign: showSocialProofPill
    }, isPreviewCTATreatment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_link_account_preview) : showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_inline_social_proof) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).connect_link_account_card_name,
        values: {
            context: context
        }
    })));
    return showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onConnectClick,
        style: {
            font: `inherit`
        },
        xcss: (0, $w6R6I.cx)($33f2ea2010a25b29$var$socialProofPillStyles.button, (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') && $33f2ea2010a25b29$var$socialProofPillStyles.pressableContents)
    }, (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $33f2ea2010a25b29$var$socialProofPillStyles.inlineGroup
    }, buttonContent) : buttonContent) : buttonContent;
};
const $33f2ea2010a25b29$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context, extensionKey: extensionKey })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        const isPreviewCTATreatment = (0, $iDrrr.fg)('rovogrowth-635-pre-auth-cta-preview-fg') && (0, $ieeJu.expValEquals)('rovogrowth-635-pre-auth-cta-preview-exp', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
            onClick: handleConnectAccount,
            viewType: 'unauthorised',
            testId: "button-connect-account"
        }, isPreviewCTATreatment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_link_account_preview) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages).connect_link_account_card_name,
            values: {
                context: context
            }
        }));
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        viewType: "unauthorised"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: icon ? icon : $33f2ea2010a25b29$var$fallbackUnauthorizedIcon(),
        title: url,
        link: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), onAuthorise && ((0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33f2ea2010a25b29$var$UnauthorisedConnectWithSocialProof, {
        context: context,
        extensionKey: extensionKey,
        testId: testId,
        onConnectClick: handleConnectAccount,
        isPreviewCTATreatment: (0, $iDrrr.fg)('rovogrowth-635-pre-auth-cta-preview-fg') && (0, $ieeJu.expValEquals)('rovogrowth-635-pre-auth-cta-preview-exp', 'isEnabled', true)
    }) : renderActionButton()));
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        url: url,
        id: id
    }, inlineCardUnauthenticatedView);
    return inlineCardUnauthenticatedView;
};
module.exports["InlineCardUnauthorizedView"] = $33f2ea2010a25b29$export$ece47728c0503997;

});

parcelRegister("jZn4j", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fzDaA = parcelRequire("fzDaA");


var $4xRBl = parcelRequire("4xRBl");


var $lL0wb = parcelRequire("lL0wb");

const $adf961e1c1bb4505$var$withCardIntersectionObserver = (Component)=>(props)=>{
        // TODO: NAVX-4682: Add feature parity to LazyIntersectionObserverCard for no lazy loading
        const { appearance: appearance, children: children, id: id, onError: onErrorCallback, ui: ui, url: url = '' } = props;
        const { onIntersecting: onIntersecting, onStatusSettled: onStatusSettled } = (0, $4xRBl.useSmartLinkSeenEvent)({
            appearance: appearance,
            children: children,
            id: id,
            ui: ui,
            url: url
        });
        const onError = (0, $cozmU.useCallback)((data)=>{
            if (data?.status) onStatusSettled(data.status);
            onErrorCallback?.(data);
        }, [
            onStatusSettled,
            onErrorCallback
        ]);
        const ref = (0, $fzDaA.default)({
            onIntersecting: onIntersecting
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lL0wb.default), {
            appearance: props.appearance,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            onError: onError
        }));
    };
var $adf961e1c1bb4505$export$2e2bcd8739ae039 = $adf961e1c1bb4505$var$withCardIntersectionObserver;
module.exports["default"] = $adf961e1c1bb4505$export$2e2bcd8739ae039;

});

parcelRegister("4lJUs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $cMyWi = parcelRequire("cMyWi");


var $2Q7sv = parcelRequire("2Q7sv");


var $3YqvO = parcelRequire("3YqvO");


var $8QLAc = parcelRequire("8QLAc");


var $bnSsE = parcelRequire("bnSsE");


var $aflIU = parcelRequire("aflIU");

const $2f46b60da1a1e284$var$useExperimentMetaEventAttributes = ({ actionOptions: actionOptions, appearance: appearance, state: state })=>{
    const { connections: { client: { baseUrlOverride: baseUriWithNoTrailingSlash } } } = (0, $cMyWi.useSmartLinkContext)();
    const { rovoOptions: rovoOptions, product: product } = (0, $8QLAc.default)();
    const { details: details, status: status } = state;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
    const embedRovoActionsFooterExperimentMeta = appearance === 'embed' && status === 'resolved' ? (0, $3YqvO.getEmbedRovoActionsFooterExperimentMeta)({
        extensionKey: extensionKey,
        isRovoChatActionOptedIn: actionOptions?.rovoChatAction?.optIn ?? false,
        isRovoChatEnabled: (0, $aflIU.getIsRovoChatEnabled)(rovoOptions),
        product: product
    }) : undefined;
    if (!embedRovoActionsFooterExperimentMeta && !(0, $iDrrr.fg)('social-proof-3p-unauth-block-fg') && !(0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch')) return undefined;
    const blockSocialProofExperimentMeta = appearance === 'block' && status === 'unauthorized' && (0, $iDrrr.fg)('social-proof-3p-unauth-block-fg') ? (0, $bnSsE.getSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const inlineSocialProofExperimentMeta = appearance === 'inline' && status === 'unauthorized' && (0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch') ? (0, $bnSsE.getInlineSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const experimentMeta = {
        ...blockSocialProofExperimentMeta,
        ...inlineSocialProofExperimentMeta,
        ...embedRovoActionsFooterExperimentMeta
    };
    if (Object.keys(experimentMeta).length > 0) return experimentMeta;
};
var $2f46b60da1a1e284$export$2e2bcd8739ae039 = $2f46b60da1a1e284$var$useExperimentMetaEventAttributes;
module.exports["default"] = $2f46b60da1a1e284$export$2e2bcd8739ae039;

});

parcelRegister("36Uax", function(module, exports) {

var $bVevd = parcelRequire("bVevd");


var $kTPbu = parcelRequire("kTPbu");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("hMKdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ctzvi = parcelRequire("ctzvi");

const $e93c907c43f1ec9c$var$UniqueKeyContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    uniqueKey: undefined
});
const $e93c907c43f1ec9c$export$71829d27b87a2006 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ctzvi.createUniqueKey)();
        $[0] = t1;
    } else t1 = $[0];
    const uniqueKey = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            uniqueKey: uniqueKey
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const uniqueKey = (0, $cozmU.useMemo)(()=>(0, $ctzvi.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $e93c907c43f1ec9c$export$cef64a0cfb90e369 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
} : ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $e93c907c43f1ec9c$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $e93c907c43f1ec9c$export$cef64a0cfb90e369;

});

parcelRegister("lWz4S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRK7f = parcelRequire("iRK7f");


var $hDLmU = parcelRequire("hDLmU");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $495e0a92c5164d61$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $495e0a92c5164d61$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $495e0a92c5164d61$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $cozmU.useState)(contentType);
    const isInitialized = (0, $cozmU.useRef)(true);
    const iframeLoadMetrics = (0, $cozmU.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $iRK7f.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $cozmU.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $iRK7f.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $cozmU.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $cozmU.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $495e0a92c5164d61$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
} : ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
};
const $495e0a92c5164d61$export$c6f19d9afc6c86c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    (0, $cozmU.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $495e0a92c5164d61$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $495e0a92c5164d61$export$c6f19d9afc6c86c8;

});

parcelRegister("iRK7f", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");


var $lCTbz = parcelRequire("lCTbz");

const $e6b49468896929e5$export$4de078c3b9971f9b = ()=>(0, $iDdTC.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e6b49468896929e5$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e6b49468896929e5$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    }
};
const $e6b49468896929e5$export$a23245993532c751 = (contentType)=>(0, $iDdTC.metrics).pageSegmentLoad($e6b49468896929e5$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $e6b49468896929e5$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $e6b49468896929e5$export$a23245993532c751;

});

parcelRegister("hDLmU", function(module, exports) {
const $b5c2a7dcc1a96b34$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $b5c2a7dcc1a96b34$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $b5c2a7dcc1a96b34$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $b5c2a7dcc1a96b34$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $b5c2a7dcc1a96b34$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $b5c2a7dcc1a96b34$export$73b982309451f084;

});

parcelRegister("ij75C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fcaWu = parcelRequire("fcaWu");


var $36Uax = parcelRequire("36Uax");


var $hMKdq = parcelRequire("hMKdq");


var $kTPbu = parcelRequire("kTPbu");

var $bVevd = parcelRequire("bVevd");


var $eAWIs = parcelRequire("eAWIs");

const $1ae0fabae864f28a$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $1ae0fabae864f28a$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $1ae0fabae864f28a$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $1ae0fabae864f28a$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $cozmU.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $cozmU.useMemo)(()=>allowedFeatures === 'all' ? (0, $36Uax.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature_0)=>feature_0 !== 'edit' && feature_0 !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature_1)=>!$1ae0fabae864f28a$var$nonAllFeatures.includes(feature_1)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature_2)=>(0, $eAWIs.isRedirectionEnabled)(feature_2)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $eAWIs.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const consumerQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $cozmU.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $1ae0fabae864f28a$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value_0, key_0)=>{
            searchParams.set(key_0, value_0);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $cozmU.useMemo)(()=>({
            ...$1ae0fabae864f28a$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $1ae0fabae864f28a$var$CONTEXT_PATH = '/wiki/spaces';
const $1ae0fabae864f28a$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $1ae0fabae864f28a$var$constructUrl(mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$1ae0fabae864f28a$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$1ae0fabae864f28a$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $1ae0fabae864f28a$export$6e43e60d51b79331;
module.exports["useUrl"] = $1ae0fabae864f28a$export$305222dff575c4e3;

});

parcelRegister("eAWIs", function(module, exports) {
const $66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $66050da24b77bea6$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $66050da24b77bea6$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$66050da24b77bea6$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $66050da24b77bea6$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $66050da24b77bea6$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $66050da24b77bea6$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $66050da24b77bea6$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $66050da24b77bea6$export$243fbba563b8aa8e;

});

parcelRegister("11zX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fa07988e74fc1b7d$export$8f5a73ba0d077b01 = 32;
class $fa07988e74fc1b7d$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $fa07988e74fc1b7d$export$3482036c37e627f4;

});

parcelRegister("QXwxo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $gBjHb = parcelRequire("gBjHb");


var $iDrrr = parcelRequire("iDrrr");


var $6GOAK = parcelRequire("6GOAK");


var $4abK1 = parcelRequire("4abK1");


var $8PZKI = parcelRequire("8PZKI");


var $59u5K = parcelRequire("59u5K");

const $dcc248a77e12baf7$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $cozmU.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))());
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring a complete response.
    // Override appearance to 'block' for FlexibleCards when FG is enabled.
    const effectiveAppearance = (0, $4abK1.isFlexibleUiCard)(props.children, props.ui) && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : props.appearance;
    const propsWithId = {
        ...props,
        id: id,
        appearance: effectiveAppearance
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: (0, $6GOAK.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8PZKI.default), propsWithId, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $59u5K.CardWithUrl), propsWithId)));
};
module.exports["CardSSR"] = $dcc248a77e12baf7$export$7b5e1b7f9a325b6;

});

parcelRegister("8PZKI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $1384B = parcelRequire("1384B");

const $66563430cdef2c51$var$CardErrorBoundary = ({ children: children, ...props })=>{
    // TODO: NAVX-4682: Add feature parity to CardWithURLRenderer
    const ErrorFallbackComponent = props.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1384B.LoadingCardLink), props);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, children);
};
var $66563430cdef2c51$export$2e2bcd8739ae039 = $66563430cdef2c51$var$CardErrorBoundary;
module.exports["default"] = $66563430cdef2c51$export$2e2bcd8739ae039;

});

parcelRegister("aHoC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc71b9d8c80c48f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");


var $4G6PK = parcelRequire("4G6PK");


var $95Vjg = parcelRequire("95Vjg");


var $ihn0W = parcelRequire("ihn0W");


var $hNvnn = parcelRequire("hNvnn");

function $7fc71b9d8c80c48f$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ihn0W.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100) && (0, $iDrrr.fg)('platform_editor_embed_height_only_fallback')) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $hNvnn.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')
        }),
        ...!(0, $iDrrr.fg)('platform_editor_fix_media_in_renderer') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("95Vjg", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $69e3419be6a9274a$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $69e3419be6a9274a$export$a6f4ec2edd25b07e;

});

parcelRegister("hNvnn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $8qft0 = parcelRequire("8qft0");


var $h9Lux = parcelRequire("h9Lux");


var $5y9Nl = parcelRequire("5y9Nl");


var $fuDKy = parcelRequire("fuDKy");

function $640d411acbc53708$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $640d411acbc53708$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $640d411acbc53708$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $640d411acbc53708$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $640d411acbc53708$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $640d411acbc53708$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $640d411acbc53708$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $640d411acbc53708$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $640d411acbc53708$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $fuDKy.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $5y9Nl.calcResizedWidth)(layout, width || 0, containerWidth) : $640d411acbc53708$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $640d411acbc53708$var$_ref2, " ", isInRenderer ? $640d411acbc53708$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $640d411acbc53708$var$float(layout), ";margin:", $640d411acbc53708$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $640d411acbc53708$var$isImageAligned(layout), ";");
};
const $640d411acbc53708$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $lOiVq.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $640d411acbc53708$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;", $640d411acbc53708$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $640d411acbc53708$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $640d411acbc53708$export$9e3fd9f6215dd7b6(rest)
    }, children);
$640d411acbc53708$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $640d411acbc53708$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    // [FEATURE FLAG: platform_editor_media_border_radius_fix]
    // Fixes border radius to properly match image with 8px radius
    // To clean up: remove conditional, keep only flag-on behavior ('8px')
    const borderRadius = (0, $iDrrr.fg)('platform_editor_media_border_radius_fix') ? "var(--ds-radius-large, 8px)" : '1px'; // OLD BEHAVIOR (to be removed when flag is cleaned up)
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $640d411acbc53708$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $640d411acbc53708$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $640d411acbc53708$export$e18e95249d813157;

});

parcelRegister("5y9Nl", function(module, exports) {

var $h9Lux = parcelRequire("h9Lux");

function $a736c0097336f0f5$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $a736c0097336f0f5$export$d48e8f24f681763e;

});

parcelRegister("fuDKy", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $e6d228c4639d9fdf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $e6d228c4639d9fdf$export$c832331b07480714;

});

parcelRegister("fbHl6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("cueDJ")));
const $14d0cd645fed394d$export$f386473e8f104bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
                ...props
            })
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $14d0cd645fed394d$export$f386473e8f104bcb;

});

parcelRegister("cueDJ", function(module, exports) {

let $9173a48e434958c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9173a48e434958c3$var$load("bzl94").then(()=>parcelRequire('j30TZ'));

});

parcelRegister("iIYTj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $7YvXl = parcelRequire("7YvXl");


var $cMyWi = parcelRequire("cMyWi");


var $1F2YI = parcelRequire("1F2YI");


var $iSrRp = parcelRequire("iSrRp");

parcelRequire("fYWmN");
var $1bRPL = parcelRequire("1bRPL");

parcelRequire("cDMxg");
var $deUyp = parcelRequire("deUyp");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $2Q7sv = parcelRequire("2Q7sv");

var $a1a722d55501d95d$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $a1a722d55501d95d$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $a1a722d55501d95d$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $a1a722d55501d95d$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $a1a722d55501d95d$var$idleState = {
    type: 'idle'
};
const $a1a722d55501d95d$var$draggingState = {
    type: 'dragging'
};
const $a1a722d55501d95d$var$styles = {
    preview: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _4c065U1Y8M _2Y7lL42ADO _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _1EqgXle7g8 _2OUyjtGk8v",
    previewText: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    draggableBlock: "_0wOv4QAxrc"
};
const $a1a722d55501d95d$var$previewIconStyles = null;
const $a1a722d55501d95d$var$draggableInlineStyles = null;
const $a1a722d55501d95d$var$SmartLinkDragPreview = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDragPreview(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { title: title, url: url, iconUrl: iconUrl } = t0;
    let t1;
    if ($[0] !== iconUrl) {
        t1 = iconUrl && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: iconUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV025zaO _0jFU0V5zaO _3YEZNOdnbC"
            ])
        });
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = title || url;
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $a1a722d55501d95d$var$styles.previewText,
            children: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a1a722d55501d95d$var$styles.preview,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.075",
                children: [
                    t1,
                    t3
                ]
            })
        });
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a1a722d55501d95d$var$styles.preview,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            children: [
                iconUrl && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
                    src: iconUrl,
                    alt: "",
                    className: (0, $hekY6.default)([
                        "_39xV025zaO _0jFU0V5zaO _3YEZNOdnbC"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $a1a722d55501d95d$var$styles.previewText,
                    children: title || url
                })
            ]
        })
    });
};
function $a1a722d55501d95d$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $2Q7sv.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
} /**
   * Inner component that handles the actual drag behavior.
   * Must be rendered within a SmartCardProvider context.
   */ 
const $a1a722d55501d95d$var$SmartLinkDraggableInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggableInner(t0) {
    const $ = (0, $bDgLe.c)(35);
    const { url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: t1, children: children } = t0;
    const isChangeboardTarget = t1 === undefined ? false : t1;
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $cMyWi.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState);
    let t2;
    if ($[0] !== appearance || $[1] !== propTitle || $[2] !== source || $[3] !== store || $[4] !== url) {
        t2 = (targetEl)=>({
                element: targetEl,
                getInitialData: ()=>{
                    const cardState = store.getState()[url];
                    const details = cardState?.details;
                    const title = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details);
                    const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                    return {
                        type: source,
                        url: url,
                        title: title,
                        iconUrl: iconUrl,
                        appearance: appearance
                    };
                },
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    const cardState_0 = store.getState()[url];
                    const details_0 = cardState_0?.details;
                    const title_0 = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details_0);
                    const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                    (0, $deUyp.setCustomNativeDragPreview)({
                        getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                            x: "16px",
                            y: "8px"
                        }),
                        render (t4) {
                            const { container: container } = t4;
                            setState({
                                type: "preview",
                                container: container,
                                title: title_0,
                                iconUrl: iconUrl_0
                            });
                            return ()=>setState($a1a722d55501d95d$var$draggingState);
                        },
                        nativeSetDragImage: nativeSetDragImage
                    });
                },
                onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
                onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
            });
        $[0] = appearance;
        $[1] = propTitle;
        $[2] = source;
        $[3] = store;
        $[4] = url;
        $[5] = t2;
    } else t2 = $[5];
    const getDragConfig = t2;
    let t3;
    if ($[6] !== appearance || $[7] !== getDragConfig) {
        t3 = ()=>{
            const el = ref.current;
            if (!el) return;
            let cleanupDraggable = null;
            let observer = null;
            if (appearance !== "inline") {
                const setupSmartElementLink = ()=>{
                    el.querySelectorAll("[data-smart-element-link]").forEach($a1a722d55501d95d$var$_temp);
                };
                setupSmartElementLink();
                observer = new MutationObserver(setupSmartElementLink);
                observer.observe(el, {
                    childList: true,
                    subtree: true
                });
            }
            const unbindPointerDown = (0, $cbY7C.bind)(el, {
                type: "pointerdown",
                listener: (event)=>{
                    const selectionAtPointerDown = window.getSelection();
                    if (appearance === "inline" && selectionAtPointerDown?.type === "Range" && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                    cleanupDraggable?.();
                    const target = event.target;
                    let dragTarget = el;
                    if (appearance === "inline") {
                        const targetElement = target instanceof Element ? target : null;
                        const hostInlineCardRoot = el.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]");
                        const inlineCardRoot = targetElement?.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]") ?? null;
                        const closestInlineAnchor = targetElement?.closest("a[href], [data-smart-element-link]") ?? null;
                        if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                        else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                    } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                    cleanupDraggable = (0, $iSrRp.draggable)(getDragConfig(dragTarget));
                }
            });
            return ()=>{
                cleanupDraggable?.();
                unbindPointerDown();
                observer?.disconnect();
            };
        };
        $[6] = appearance;
        $[7] = getDragConfig;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== appearance || $[10] !== getDragConfig || $[11] !== propTitle || $[12] !== source || $[13] !== store || $[14] !== url) {
        t4 = [
            url,
            propTitle,
            appearance,
            source,
            store,
            getDragConfig
        ];
        $[9] = appearance;
        $[10] = getDragConfig;
        $[11] = propTitle;
        $[12] = source;
        $[13] = store;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[16] !== state.container || $[17] !== state.iconUrl || $[18] !== state.title || $[19] !== state.type || $[20] !== url) {
        t5 = state.type === "preview" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDragPreview, {
            title: state.title,
            url: url,
            iconUrl: state.iconUrl
        }), state.container) : null;
        $[16] = state.container;
        $[17] = state.iconUrl;
        $[18] = state.title;
        $[19] = state.type;
        $[20] = url;
        $[21] = t5;
    } else t5 = $[21];
    const preview = t5;
    if (appearance === "inline") {
        const t6 = isChangeboardTarget ? "smart-link-draggable-changeboard" : undefined;
        let t7;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                "_0wOv4QAxrc _3iDTPbS8kF"
            ]);
            $[22] = t7;
        } else t7 = $[22];
        let t8;
        if ($[23] !== children || $[24] !== t6 || $[25] !== t7) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": t6,
                className: t7,
                children: children
            });
            $[23] = children;
            $[24] = t6;
            $[25] = t7;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== preview || $[28] !== t8) {
            t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    t8,
                    preview
                ]
            });
            $[27] = preview;
            $[28] = t8;
            $[29] = t9;
        } else t9 = $[29];
        return t9;
    }
    let t6;
    if ($[30] !== children) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            ref: ref,
            xcss: $a1a722d55501d95d$var$styles.draggableBlock,
            testId: "smart-link-draggable-block",
            children: children
        });
        $[30] = children;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== preview || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                t6,
                preview
            ]
        });
        $[32] = preview;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : function SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $cMyWi.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $cozmU.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details);
                const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState_0 = store.getState()[url];
                const details_0 = cardState_0?.details;
                const title_0 = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details_0);
                const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title_0,
                            iconUrl: iconUrl_0
                        });
                        return ()=>setState($a1a722d55501d95d$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
            onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $cbY7C.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $iSrRp.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
                className: (0, $hekY6.default)([
                    "_0wOv4QAxrc _3iDTPbS8kF"
                ]),
                children: children
            }),
            preview
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: ref,
                xcss: $a1a722d55501d95d$var$styles.draggableBlock,
                testId: "smart-link-draggable-block",
                children: children
            }),
            preview
        ]
    });
};
/**
 * Wraps a smart link card to make it draggable into the content tree.
 * Extracts the resolved title and icon from the smart link data store at drag start time.
 * Falls back to rendering children directly when the feature flag is off or url is missing.
 */ function $a1a722d55501d95d$var$_temp(link) {
    link.contentEditable = "false";
    link.setAttribute("draggable", "true");
}
const $a1a722d55501d95d$export$c67c8f76ce4436c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggable(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children } = t0;
    if (!url || !(0, $1F2YI.isSafeUrl)(url)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance || $[3] !== children || $[4] !== isChangeboardTarget || $[5] !== source || $[6] !== title || $[7] !== url) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDraggableInner, {
            url: url,
            title: title,
            appearance: appearance,
            source: source,
            isChangeboardTarget: isChangeboardTarget,
            children: children
        });
        $[2] = appearance;
        $[3] = children;
        $[4] = isChangeboardTarget;
        $[5] = source;
        $[6] = title;
        $[7] = url;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : function SmartLinkDraggable({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $1F2YI.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget,
        children: children
    });
};
module.exports["SMART_LINK_DRAG_TYPES"] = $a1a722d55501d95d$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $a1a722d55501d95d$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $a1a722d55501d95d$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $a1a722d55501d95d$export$c67c8f76ce4436c;

});

parcelRegister("fYWmN", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("1bRPL")).pointerOutsideOfPreview);

var $1bRPL = parcelRequire("1bRPL");


});

parcelRegister("1bRPL", function(module, exports) {

var $dJ9DS = parcelRequire("dJ9DS");


var $fYxCA = parcelRequire("fYxCA");


var $beJwy = parcelRequire("beJwy");

function $c244e860353a6e68$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $fYxCA.isSafariOnIOS)() || (0, $dJ9DS.isAndroid)()) return (0, $beJwy.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $c244e860353a6e68$export$427e20518819fabc;

});

parcelRegister("fYxCA", function(module, exports) {

var $gEZCs = parcelRequire("gEZCs");


var $kc8B9 = parcelRequire("kc8B9");

const $e0d278f731546dca$export$52fc40c68fea4952 = (0, $gEZCs.once)(function isSafariOnIOS() {
    return (0, $kc8B9.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $e0d278f731546dca$export$52fc40c68fea4952;

});

parcelRegister("beJwy", function(module, exports) {
const $d5bf326c593d3c52$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $d5bf326c593d3c52$export$81d8e72a15eef435;

});

parcelRegister("cDMxg", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("deUyp")).setCustomNativeDragPreview);

var $deUyp = parcelRequire("deUyp");


});

parcelRegister("deUyp", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $kc8B9 = parcelRequire("kc8B9");


var $f0WuI = parcelRequire("f0WuI");


var $7nhOg = parcelRequire("7nhOg");


var $fbx9a = parcelRequire("fbx9a");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $0a7192879c73e22c$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $0a7192879c73e22c$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $0a7192879c73e22c$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $fbx9a.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $fbx9a.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $7nhOg.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f0WuI.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $fbx9a.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $kc8B9.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $4Vdlk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $0a7192879c73e22c$export$52d889c66db0f96e;

});

parcelRegister("gybyF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $apFwO = parcelRequire("apFwO");


var $jINxM = parcelRequire("jINxM");


var $2FmJb = parcelRequire("2FmJb");


var $dM7c5 = parcelRequire("dM7c5");


var $kG7AM = parcelRequire("kG7AM");


var $kfxZm = parcelRequire("kfxZm");


var $cEvdy = parcelRequire("cEvdy");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");

function $f78fd23812cb38dc$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))(), []);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $cMyWi.useSmartLinkContext)();
    const invokeClientAction = (0, $kfxZm.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $cEvdy.default)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: linkState.details
    });
    if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $apFwO.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $kG7AM.toAction)(downloadActionProps, invokeClientAction, (0, $dM7c5.messages).download, 'download-content'));
        const viewActionProps = (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? (0, $2FmJb.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        }) : (0, $2FmJb.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $kG7AM.toAction)(viewActionProps, invokeClientAction, (0, $dM7c5.messages).view, 'view-content'));
        const previewActionProps = (0, $jINxM.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            ...(0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
            } : undefined
        });
        if (previewActionProps) actions.push((0, $kG7AM.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $dM7c5.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $f78fd23812cb38dc$export$a95296ded9241771;

});

parcelRegister("kG7AM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $658c5c09596e5d2b$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $658c5c09596e5d2b$export$9d52be0dab870c7;

});

parcelRegister("b2XFx", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8VfSP = parcelRequire("8VfSP");


var $V3JOP = parcelRequire("V3JOP");


var $gDx2k = parcelRequire("gDx2k");


var $iDrrr = parcelRequire("iDrrr");


var $l8Rhq = parcelRequire("l8Rhq");

var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $eaCAt = parcelRequire("eaCAt");

var $krYZG = parcelRequire("krYZG");


var $bI2nS = parcelRequire("bI2nS");

function $4e976cfe241fa7a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)}px) - ${(0, $7Y8M5.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $4e976cfe241fa7a6$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $4e976cfe241fa7a6$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $4e976cfe241fa7a6$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $4e976cfe241fa7a6$var$linkStylesCommon = (0, $buxP3.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $4e976cfe241fa7a6$var$ICON_WIDTH = 16;
const $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $4e976cfe241fa7a6$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $4e976cfe241fa7a6$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, destinationUrl: destinationUrl, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const hoverLinkButtonRef = (0, $cozmU.useRef)(null);
    const hiddenTextRef = (0, $cozmU.useRef)(null);
    const [showLabel, setShowLabel] = (0, $cozmU.useState)(true);
    const [isHovered, setHovered] = (0, $cozmU.useState)(false);
    const openTextWidthRef = (0, $cozmU.useRef)(null);
    const regularPadding = $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK;
    const memoizedHoverLinkStyles = (0, $cozmU.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $4e976cfe241fa7a6$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if (containerRef.current && hoverLinkButtonRef.current) {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
            if (buttonRight > containerRight) canShowLabel = false;
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if (isHovered) setShowLabel(true);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $4e976cfe241fa7a6$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl ?? url : url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $bI2nS.messages).previewButtonTitle) : formatMessage((0, $bI2nS.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: containerRef,
        css: $4e976cfe241fa7a6$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $4e976cfe241fa7a6$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l8Rhq.Anchor), {
        ref: hoverLinkButtonRef,
        xcss: $4e976cfe241fa7a6$var$linkStylesCommon,
        href: (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl ?? url : url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $4e976cfe241fa7a6$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $4e976cfe241fa7a6$export$2e2bcd8739ae039 = $4e976cfe241fa7a6$var$HoverLinkOverlay;
module.exports["default"] = $4e976cfe241fa7a6$export$2e2bcd8739ae039;

});

parcelRegister("lmL4n", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $73286e13e84d8c04$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j8gbn")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $73286e13e84d8c04$var$DatasourceTableViewWithWrappers = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($73286e13e84d8c04$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($73286e13e84d8c04$var$LazyDatasourceTableView, {
            ...props
        })
    });
};
var $73286e13e84d8c04$export$2e2bcd8739ae039 = $73286e13e84d8c04$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $73286e13e84d8c04$export$2e2bcd8739ae039;

});

parcelRegister("j8gbn", function(module, exports) {

let $dedb512f541997a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dedb512f541997a6$var$load("90vep"),
    $dedb512f541997a6$var$load("ixrKS"),
    $dedb512f541997a6$var$load("fdLC1"),
    $dedb512f541997a6$var$load("2l8zo"),
    $dedb512f541997a6$var$load("6wr18"),
    $dedb512f541997a6$var$load("aEiTV"),
    $dedb512f541997a6$var$load("fAzyA"),
    $dedb512f541997a6$var$load("6KvrM"),
    $dedb512f541997a6$var$load("5eOUj"),
    $dedb512f541997a6$var$load("5Mm1x"),
    $dedb512f541997a6$var$load("ffEVr"),
    $dedb512f541997a6$var$load("hhss7"),
    $dedb512f541997a6$var$load("Wowvf"),
    $dedb512f541997a6$var$load("7EorR"),
    $dedb512f541997a6$var$load("3WGfe")
]).then(()=>parcelRequire('khl4A'));

});

parcelRegister("3u1Hp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lPEt0 = parcelRequire("lPEt0");


var $cMyWi = parcelRequire("cMyWi");


var $j39Hd = parcelRequire("j39Hd");


var $c7dFC = parcelRequire("c7dFC");

const $adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE = 50;
const $adf5b0efff0513f5$export$f82fcd766a8daa7f = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$40b1dd31340bd5c2 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$15cd58682efec5a5 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$5e074c0b68e2ce03 = 20;
const $adf5b0efff0513f5$export$7d812bb756889442 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(13);
    const { connections: t0 } = (0, $cMyWi.useSmartLinkContext)();
    const { client: client } = t0;
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = $adf5b0efff0513f5$var$_temp;
    const uncachedRequest = $adf5b0efff0513f5$var$_temp2;
    let t1;
    if ($[0] !== resolverUrl) {
        t1 = async (datasourceId, data_1, t2)=>{
            const force_0 = t2 === undefined ? false : t2;
            return cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0);
        };
        $[0] = resolverUrl;
        $[1] = t1;
    } else t1 = $[1];
    const getDatasourceDetails = t1;
    let t2;
    if ($[2] !== resolverUrl) {
        t2 = async (datasourceId_0, data_2, t3)=>{
            const force_1 = t3 === undefined ? false : t3;
            return cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1);
        };
        $[2] = resolverUrl;
        $[3] = t2;
    } else t2 = $[3];
    const getDatasourceData = t2;
    let t3;
    if ($[4] !== resolverUrl) {
        t3 = async (data_3, t4)=>{
            const force_2 = t4 === undefined ? false : t4;
            const resolvedCacheIdKey = "datasourceId" in data_3 ? data_3.datasourceId : data_3.integrationKey;
            if (!resolvedCacheIdKey) throw new Error("No target was supplied to retrieve actions for");
            return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
        };
        $[4] = resolverUrl;
        $[5] = t3;
    } else t3 = $[5];
    const getDatasourceActionsAndPermissions = t3;
    let t4;
    if ($[6] !== resolverUrl) {
        t4 = async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`);
        $[6] = resolverUrl;
        $[7] = t4;
    } else t4 = $[7];
    const executeAtomicAction = t4;
    const invalidateDatasourceDataCacheByAri = $adf5b0efff0513f5$var$_temp3;
    let t5;
    if ($[8] !== executeAtomicAction || $[9] !== getDatasourceActionsAndPermissions || $[10] !== getDatasourceData || $[11] !== getDatasourceDetails) {
        t5 = {
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        };
        $[8] = executeAtomicAction;
        $[9] = getDatasourceActionsAndPermissions;
        $[10] = getDatasourceData;
        $[11] = getDatasourceDetails;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { connections: { client: client } } = (0, $cMyWi.useSmartLinkContext)();
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $j39Hd.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data_0, url_0)=>{
        const responsePromise_0 = (0, $j39Hd.request)('post', url_0, data_0, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise_0;
    };
    const getDatasourceDetails = (0, $cozmU.useCallback)(async (datasourceId, data_1, force_0 = false)=>cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $cozmU.useCallback)(async (datasourceId_0, data_2, force_1 = false)=>cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $cozmU.useCallback)(async (data_3, force_2 = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data_3 ? data_3.datasourceId : data_3.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $cozmU.useCallback)(async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $cozmU.useCallback)((ari)=>{
        $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
async function $adf5b0efff0513f5$var$_temp(cacheKeyId, data, url, lruMap, force) {
    const cacheKeyData = {
        ...data,
        ..."fields" in data ? {
            fields: [
                ...data.fields || []
            ].sort()
        } : {},
        ..."fieldKeys" in data ? {
            fieldKeys: [
                ...data.fieldKeys || []
            ].sort()
        } : {}
    };
    const cacheKey = JSON.stringify({
        cacheKeyId: cacheKeyId,
        cacheKeyData: cacheKeyData
    });
    if (force) lruMap.delete(cacheKey);
    let responsePromise = lruMap.get(cacheKey);
    if (responsePromise) return responsePromise;
    const headers = {
        "origin-timezone": Intl?.DateTimeFormat().resolvedOptions().timeZone
    };
    try {
        responsePromise = (0, $j39Hd.request)("post", url, data, headers, [
            200,
            201,
            202,
            203,
            204
        ]);
        lruMap.set(cacheKey, responsePromise);
        return await responsePromise;
    } catch (t0) {
        const e = t0;
        lruMap.delete(cacheKey);
        throw e;
    }
}
async function $adf5b0efff0513f5$var$_temp2(data_0, url_0) {
    const responsePromise_0 = (0, $j39Hd.request)("post", url_0, data_0, undefined, [
        200,
        201,
        202,
        203,
        204
    ]);
    return responsePromise_0;
}
function $adf5b0efff0513f5$var$_temp3(ari) {
    $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
        const response = await value;
        const targetFound = response.data.items.some((item)=>item.ari?.data === ari);
        if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
    });
}
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $adf5b0efff0513f5$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $adf5b0efff0513f5$export$7d812bb756889442;

});

parcelRegister("gbf0M", function(module, exports) {
const $5ba4766046c2d106$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $5ba4766046c2d106$export$1de3504963fc32f2;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("aqP4n", function(module, exports) {
const $03a217ae6d97834d$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $03a217ae6d97834d$var$uniqueKey = Symbol('closestEdge');
function $03a217ae6d97834d$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $03a217ae6d97834d$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$03a217ae6d97834d$var$uniqueKey]: addClosestEdge
    };
}
function $03a217ae6d97834d$export$945a571f3b658bf(userData) {
    return userData[$03a217ae6d97834d$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $03a217ae6d97834d$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $03a217ae6d97834d$export$945a571f3b658bf;

});

parcelRegister("3obFl", function(module, exports) {
$parcel$export(module.exports, "reorder", () => (parcelRequire("BdDJf")).reorder);

var $BdDJf = parcelRequire("BdDJf");


});

parcelRegister("BdDJf", function(module, exports) {
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $96763c629161d444$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}
module.exports["reorder"] = $96763c629161d444$export$fc77a6137e3f91c;

});

parcelRegister("21ejV", function(module, exports) {
function $cbf58e886ee3aa4f$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}
module.exports["getReorderDestinationIndex"] = $cbf58e886ee3aa4f$export$846f792f51b92b6e;

});

parcelRegister("66v15", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("31Y6I")).getElementFromPointWithoutHoneypot);

var $31Y6I = parcelRequire("31Y6I");


});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_3iDTPbvLZJ _1mT5xdWVPG _42Yu6B7dHp _1pp6NdYbGa _0KLXrul0Q1 _1Oimfu715P _0eGJOxOn88 _1nRsHk6wH8 _2KinTkl0Q1 _0OU75rKWn1 _3Ku51Iogpp _3dCYwDWVPG _2DsrY12Njc _3ScelF3U6W _1lBcDc3U6W"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_0jFU0VOn88 _3iC0zdfRAD _1OKFqYdnbC _2jTvwtWjDq",
    vertical: "_39xV02On88 _2IhTonfRAD _0Bm75GdnbC _35I30BWjDq"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_2IhTon5Cwg _35I30BHqe5",
    right: "_4ApkO25Cwg _1D2b5MHqe5",
    bottom: "_0Bm75G5Cwg _31ReDyHqe5",
    left: "_3OE6xY5Cwg _1L3m71Hqe5"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("9Rq82", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1P2f3 = parcelRequire("1P2f3");

'use strict';
function $72dd54e799957753$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $72dd54e799957753$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $72dd54e799957753$var$_typeof(o);
}
function $72dd54e799957753$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $72dd54e799957753$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $72dd54e799957753$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $72dd54e799957753$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $72dd54e799957753$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $72dd54e799957753$var$_toPropertyKey(arg) {
    var key = $72dd54e799957753$var$_toPrimitive(arg, "string");
    return $72dd54e799957753$var$_typeof(key) === "symbol" ? key : String(key);
}
function $72dd54e799957753$var$_toPrimitive(input, hint) {
    if ($72dd54e799957753$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($72dd54e799957753$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $72dd54e799957753$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9VDwT = parcelRequire("9VDwT");

var $72dd54e799957753$var$_require$codes = $9VDwT.codes, $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT = $72dd54e799957753$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $72dd54e799957753$var$ERR_INVALID_ARG_TYPE = $72dd54e799957753$var$_require$codes.ERR_INVALID_ARG_TYPE, $72dd54e799957753$var$ERR_INVALID_ARG_VALUE = $72dd54e799957753$var$_require$codes.ERR_INVALID_ARG_VALUE, $72dd54e799957753$var$ERR_INVALID_RETURN_VALUE = $72dd54e799957753$var$_require$codes.ERR_INVALID_RETURN_VALUE, $72dd54e799957753$var$ERR_MISSING_ARGS = $72dd54e799957753$var$_require$codes.ERR_MISSING_ARGS;

var $9OEKu = parcelRequire("9OEKu");


var $7T2Y0 = parcelRequire("7T2Y0");

var $72dd54e799957753$var$inspect = $7T2Y0.inspect;



var $72dd54e799957753$require$_require$types = $7T2Y0.types;
var $72dd54e799957753$var$isPromise = $72dd54e799957753$require$_require$types.isPromise, $72dd54e799957753$var$isRegExp = $72dd54e799957753$require$_require$types.isRegExp;

var $72dd54e799957753$var$objectAssign = (parcelRequire("fnK1J"))();

var $72dd54e799957753$var$objectIs = (parcelRequire("aKQxr"))();

var $72dd54e799957753$var$RegExpPrototypeTest = (parcelRequire("2BPyg"))('RegExp.prototype.test');
var $72dd54e799957753$var$errorCache = new Map();
var $72dd54e799957753$var$isDeepEqual;
var $72dd54e799957753$var$isDeepStrictEqual;
var $72dd54e799957753$var$parseExpressionAt;
var $72dd54e799957753$var$findNodeAround;
var $72dd54e799957753$var$decoder;

function $72dd54e799957753$var$lazyLoadComparison() {
    var comparison = (parcelRequire("ilKc6"));
    $72dd54e799957753$var$isDeepEqual = comparison.isDeepEqual;
    $72dd54e799957753$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $72dd54e799957753$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $72dd54e799957753$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $72dd54e799957753$var$escapeFn = function escapeFn(str) {
    return $72dd54e799957753$var$meta[str.charCodeAt(0)];
};
var $72dd54e799957753$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $72dd54e799957753$var$assert = module.exports = $72dd54e799957753$var$ok;
var $72dd54e799957753$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $72dd54e799957753$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $9OEKu(obj);
}
function $72dd54e799957753$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($72dd54e799957753$var$warned === false) {
            $72dd54e799957753$var$warned = true;
            var warn = $1P2f3.emitWarning ? $1P2f3.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $72dd54e799957753$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $9OEKu(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$72dd54e799957753$var$assert.fail = $72dd54e799957753$var$fail;
// The AssertionError is defined in internal/error.
$72dd54e799957753$var$assert.AssertionError = $9OEKu;
function $72dd54e799957753$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $9OEKu({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $72dd54e799957753$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $72dd54e799957753$var$innerOk.apply(void 0, [
        $72dd54e799957753$var$ok,
        args.length
    ].concat(args));
}
$72dd54e799957753$var$assert.ok = $72dd54e799957753$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $72dd54e799957753$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$72dd54e799957753$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$72dd54e799957753$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if (!$72dd54e799957753$var$isDeepEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$72dd54e799957753$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if ($72dd54e799957753$var$isDeepEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $72dd54e799957753$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if (!$72dd54e799957753$var$isDeepStrictEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$72dd54e799957753$var$assert.notDeepStrictEqual = $72dd54e799957753$var$notDeepStrictEqual;
function $72dd54e799957753$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if ($72dd54e799957753$var$isDeepStrictEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $72dd54e799957753$var$notDeepStrictEqual
    });
}
$72dd54e799957753$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$72dd54e799957753$var$objectIs(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$72dd54e799957753$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$objectIs(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $72dd54e799957753$var$Comparison = /*#__PURE__*/ $72dd54e799957753$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $72dd54e799957753$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $72dd54e799957753$var$isRegExp(obj[key]) && $72dd54e799957753$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $72dd54e799957753$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$72dd54e799957753$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $72dd54e799957753$var$Comparison(actual, keys);
            var b = new $72dd54e799957753$var$Comparison(expected, keys, actual);
            var err = new $9OEKu({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $72dd54e799957753$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $72dd54e799957753$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($72dd54e799957753$var$isRegExp(expected)) return $72dd54e799957753$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($72dd54e799957753$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $9OEKu({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $72dd54e799957753$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $72dd54e799957753$var$isRegExp(expected[key]) && $72dd54e799957753$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $72dd54e799957753$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $72dd54e799957753$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $72dd54e799957753$var$NO_EXCEPTION_SENTINEL;
}
function $72dd54e799957753$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $72dd54e799957753$var$isPromise(obj) || obj !== null && $72dd54e799957753$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $72dd54e799957753$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$72dd54e799957753$var$checkIsPromise(resultPromise)) throw new $72dd54e799957753$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($72dd54e799957753$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $72dd54e799957753$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $72dd54e799957753$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($72dd54e799957753$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $72dd54e799957753$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $72dd54e799957753$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $72dd54e799957753$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$72dd54e799957753$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $72dd54e799957753$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $72dd54e799957753$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $72dd54e799957753$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $72dd54e799957753$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$72dd54e799957753$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $72dd54e799957753$var$expectsError.apply(void 0, [
        throws,
        $72dd54e799957753$var$getActual(promiseFn)
    ].concat(args));
};
$72dd54e799957753$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $72dd54e799957753$var$waitForActual(promiseFn).then(function(result) {
        return $72dd54e799957753$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$72dd54e799957753$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $72dd54e799957753$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $72dd54e799957753$var$getActual(fn)
    ].concat(args));
};
$72dd54e799957753$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $72dd54e799957753$var$waitForActual(fn).then(function(result) {
        return $72dd54e799957753$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$72dd54e799957753$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($72dd54e799957753$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $72dd54e799957753$var$inspect(err);
        var newErr = new $9OEKu({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $72dd54e799957753$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$72dd54e799957753$var$isRegExp(regexp)) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $72dd54e799957753$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($72dd54e799957753$var$_typeof(string), " (").concat($72dd54e799957753$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($72dd54e799957753$var$inspect(regexp), ". Input:\n\n").concat($72dd54e799957753$var$inspect(string), "\n"));
        var err = new $9OEKu({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$72dd54e799957753$var$assert.match = function match(string, regexp, message) {
    $72dd54e799957753$var$internalMatch(string, regexp, message, match, 'match');
};
$72dd54e799957753$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $72dd54e799957753$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $72dd54e799957753$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $72dd54e799957753$var$innerOk.apply(void 0, [
        $72dd54e799957753$var$strict,
        args.length
    ].concat(args));
}
$72dd54e799957753$var$assert.strict = $72dd54e799957753$var$objectAssign($72dd54e799957753$var$strict, $72dd54e799957753$var$assert, {
    equal: $72dd54e799957753$var$assert.strictEqual,
    deepEqual: $72dd54e799957753$var$assert.deepStrictEqual,
    notEqual: $72dd54e799957753$var$assert.notStrictEqual,
    notDeepEqual: $72dd54e799957753$var$assert.notDeepStrictEqual
});
$72dd54e799957753$var$assert.strict.strict = $72dd54e799957753$var$assert.strict;

});

parcelRegister("9VDwT", function(module, exports) {
$parcel$export(module.exports, "codes", () => $73a819a63e892b7f$export$e45cb6485273080e, (v) => $73a819a63e892b7f$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $73a819a63e892b7f$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $73a819a63e892b7f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73a819a63e892b7f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73a819a63e892b7f$var$_typeof(o);
}
function $73a819a63e892b7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $73a819a63e892b7f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $73a819a63e892b7f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $73a819a63e892b7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $73a819a63e892b7f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $73a819a63e892b7f$var$_toPropertyKey(arg) {
    var key = $73a819a63e892b7f$var$_toPrimitive(arg, "string");
    return $73a819a63e892b7f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $73a819a63e892b7f$var$_toPrimitive(input, hint) {
    if ($73a819a63e892b7f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($73a819a63e892b7f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $73a819a63e892b7f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $73a819a63e892b7f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $73a819a63e892b7f$var$_setPrototypeOf(subClass, superClass);
}
function $73a819a63e892b7f$var$_setPrototypeOf(o, p) {
    $73a819a63e892b7f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $73a819a63e892b7f$var$_setPrototypeOf(o, p);
}
function $73a819a63e892b7f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $73a819a63e892b7f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $73a819a63e892b7f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $73a819a63e892b7f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $73a819a63e892b7f$var$_possibleConstructorReturn(this, result);
    };
}
function $73a819a63e892b7f$var$_possibleConstructorReturn(self, call) {
    if (call && ($73a819a63e892b7f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $73a819a63e892b7f$var$_assertThisInitialized(self);
}
function $73a819a63e892b7f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $73a819a63e892b7f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $73a819a63e892b7f$var$_getPrototypeOf(o) {
    $73a819a63e892b7f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $73a819a63e892b7f$var$_getPrototypeOf(o);
}
var $73a819a63e892b7f$var$codes = {};
// Lazy loaded
var $73a819a63e892b7f$var$assert;
var $73a819a63e892b7f$var$util;
function $73a819a63e892b7f$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $73a819a63e892b7f$var$_inherits(NodeError, _Base);
        var _super = $73a819a63e892b7f$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $73a819a63e892b7f$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $73a819a63e892b7f$var$_createClass(NodeError);
    }(Base);
    $73a819a63e892b7f$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $73a819a63e892b7f$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $73a819a63e892b7f$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $73a819a63e892b7f$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $73a819a63e892b7f$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$73a819a63e892b7f$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($73a819a63e892b7f$var$assert === undefined) $73a819a63e892b7f$var$assert = (parcelRequire("9Rq82"));
    $73a819a63e892b7f$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $73a819a63e892b7f$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($73a819a63e892b7f$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($73a819a63e892b7f$var$oneOf(expected, 'type'));
    else {
        var type = $73a819a63e892b7f$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($73a819a63e892b7f$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($73a819a63e892b7f$var$_typeof(actual));
    return msg;
}, TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($73a819a63e892b7f$var$util === undefined) $73a819a63e892b7f$var$util = (parcelRequire("7T2Y0"));
    var inspected = $73a819a63e892b7f$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$73a819a63e892b7f$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($73a819a63e892b7f$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($73a819a63e892b7f$var$assert === undefined) $73a819a63e892b7f$var$assert = (parcelRequire("9Rq82"));
    $73a819a63e892b7f$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$73a819a63e892b7f$export$e45cb6485273080e = $73a819a63e892b7f$var$codes;

});

parcelRegister("7T2Y0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1P2f3 = parcelRequire("1P2f3");

var $5bdff89be3748b6d$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $5bdff89be3748b6d$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$5bdff89be3748b6d$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($5bdff89be3748b6d$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($5bdff89be3748b6d$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($5bdff89be3748b6d$var$isNull(x) || !$5bdff89be3748b6d$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $5bdff89be3748b6d$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $1P2f3 !== 'undefined' && $1P2f3.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $1P2f3 === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1P2f3.throwDeprecation) throw new Error(msg);
            else if ($1P2f3.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $5bdff89be3748b6d$var$debugs = {};
var $5bdff89be3748b6d$var$debugEnvRegex = /^$/;
var $5bdff89be3748b6d$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$5bdff89be3748b6d$var$debugs[set]) {
        if ($5bdff89be3748b6d$var$debugEnvRegex.test(set)) {
            var pid = $1P2f3.pid;
            $5bdff89be3748b6d$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $5bdff89be3748b6d$var$debugs[set] = function() {};
    }
    return $5bdff89be3748b6d$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $5bdff89be3748b6d$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $5bdff89be3748b6d$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($5bdff89be3748b6d$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($5bdff89be3748b6d$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $5bdff89be3748b6d$var$stylizeWithColor;
    return $5bdff89be3748b6d$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $5bdff89be3748b6d$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$5bdff89be3748b6d$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$5bdff89be3748b6d$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $5bdff89be3748b6d$var$stylizeWithColor(str, styleType) {
    var style = $5bdff89be3748b6d$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $5bdff89be3748b6d$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $5bdff89be3748b6d$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $5bdff89be3748b6d$var$stylizeNoColor(str, styleType) {
    return str;
}
function $5bdff89be3748b6d$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $5bdff89be3748b6d$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $5bdff89be3748b6d$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$5bdff89be3748b6d$var$isString(ret)) ret = $5bdff89be3748b6d$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $5bdff89be3748b6d$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $5bdff89be3748b6d$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($5bdff89be3748b6d$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $5bdff89be3748b6d$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($5bdff89be3748b6d$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($5bdff89be3748b6d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($5bdff89be3748b6d$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($5bdff89be3748b6d$var$isError(value)) return $5bdff89be3748b6d$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($5bdff89be3748b6d$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($5bdff89be3748b6d$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($5bdff89be3748b6d$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($5bdff89be3748b6d$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($5bdff89be3748b6d$var$isError(value)) base = ' ' + $5bdff89be3748b6d$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($5bdff89be3748b6d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $5bdff89be3748b6d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $5bdff89be3748b6d$var$reduceToSingleString(output, base, braces);
}
function $5bdff89be3748b6d$var$formatPrimitive(ctx, value) {
    if ($5bdff89be3748b6d$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($5bdff89be3748b6d$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($5bdff89be3748b6d$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($5bdff89be3748b6d$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($5bdff89be3748b6d$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $5bdff89be3748b6d$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $5bdff89be3748b6d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($5bdff89be3748b6d$var$hasOwnProperty(value, String(i))) output.push($5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$5bdff89be3748b6d$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($5bdff89be3748b6d$var$isNull(recurseTimes)) str = $5bdff89be3748b6d$var$formatValue(ctx, desc.value, null);
            else str = $5bdff89be3748b6d$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($5bdff89be3748b6d$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $5bdff89be3748b6d$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("3xAFV"));
function $5bdff89be3748b6d$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $5bdff89be3748b6d$var$isArray;
function $5bdff89be3748b6d$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $5bdff89be3748b6d$var$isBoolean;
function $5bdff89be3748b6d$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $5bdff89be3748b6d$var$isNull;
function $5bdff89be3748b6d$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $5bdff89be3748b6d$var$isNullOrUndefined;
function $5bdff89be3748b6d$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $5bdff89be3748b6d$var$isNumber;
function $5bdff89be3748b6d$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $5bdff89be3748b6d$var$isString;
function $5bdff89be3748b6d$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $5bdff89be3748b6d$var$isSymbol;
function $5bdff89be3748b6d$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $5bdff89be3748b6d$var$isUndefined;
function $5bdff89be3748b6d$var$isRegExp(re) {
    return $5bdff89be3748b6d$var$isObject(re) && $5bdff89be3748b6d$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $5bdff89be3748b6d$var$isRegExp;
module.exports.types.isRegExp = $5bdff89be3748b6d$var$isRegExp;
function $5bdff89be3748b6d$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $5bdff89be3748b6d$var$isObject;
function $5bdff89be3748b6d$var$isDate(d) {
    return $5bdff89be3748b6d$var$isObject(d) && $5bdff89be3748b6d$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $5bdff89be3748b6d$var$isDate;
module.exports.types.isDate = $5bdff89be3748b6d$var$isDate;
function $5bdff89be3748b6d$var$isError(e) {
    return $5bdff89be3748b6d$var$isObject(e) && ($5bdff89be3748b6d$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $5bdff89be3748b6d$var$isError;
module.exports.types.isNativeError = $5bdff89be3748b6d$var$isError;
function $5bdff89be3748b6d$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $5bdff89be3748b6d$var$isFunction;
function $5bdff89be3748b6d$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $5bdff89be3748b6d$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("hUXoN"));
function $5bdff89be3748b6d$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $5bdff89be3748b6d$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $5bdff89be3748b6d$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $5bdff89be3748b6d$var$timestamp() {
    var d = new Date();
    var time = [
        $5bdff89be3748b6d$var$pad(d.getHours()),
        $5bdff89be3748b6d$var$pad(d.getMinutes()),
        $5bdff89be3748b6d$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $5bdff89be3748b6d$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $5bdff89be3748b6d$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("iuv32"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$5bdff89be3748b6d$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $5bdff89be3748b6d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $5bdff89be3748b6d$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($5bdff89be3748b6d$var$kCustomPromisifiedSymbol && original[$5bdff89be3748b6d$var$kCustomPromisifiedSymbol]) {
        var fn = original[$5bdff89be3748b6d$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $5bdff89be3748b6d$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($5bdff89be3748b6d$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $5bdff89be3748b6d$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $5bdff89be3748b6d$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $5bdff89be3748b6d$var$kCustomPromisifiedSymbol;
function $5bdff89be3748b6d$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $5bdff89be3748b6d$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $1P2f3.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $1P2f3.nextTick($5bdff89be3748b6d$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $5bdff89be3748b6d$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $5bdff89be3748b6d$var$callbackify;

});

parcelRegister("3xAFV", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $2Xb4T = parcelRequire("2Xb4T");


var $6TAnP = parcelRequire("6TAnP");


var $go4T7 = parcelRequire("go4T7");


var $5RMvC = parcelRequire("5RMvC");

function $2940e712aca02fa7$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2940e712aca02fa7$var$BigIntSupported = typeof BigInt !== 'undefined';
var $2940e712aca02fa7$var$SymbolSupported = typeof Symbol !== 'undefined';
var $2940e712aca02fa7$var$ObjectToString = $2940e712aca02fa7$var$uncurryThis(Object.prototype.toString);
var $2940e712aca02fa7$var$numberValue = $2940e712aca02fa7$var$uncurryThis(Number.prototype.valueOf);
var $2940e712aca02fa7$var$stringValue = $2940e712aca02fa7$var$uncurryThis(String.prototype.valueOf);
var $2940e712aca02fa7$var$booleanValue = $2940e712aca02fa7$var$uncurryThis(Boolean.prototype.valueOf);
if ($2940e712aca02fa7$var$BigIntSupported) var $2940e712aca02fa7$var$bigIntValue = $2940e712aca02fa7$var$uncurryThis(BigInt.prototype.valueOf);
if ($2940e712aca02fa7$var$SymbolSupported) var $2940e712aca02fa7$var$symbolValue = $2940e712aca02fa7$var$uncurryThis(Symbol.prototype.valueOf);
function $2940e712aca02fa7$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $2Xb4T;
module.exports.isGeneratorFunction = $6TAnP;
module.exports.isTypedArray = $5RMvC;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $2940e712aca02fa7$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $2940e712aca02fa7$var$isPromise;
function $2940e712aca02fa7$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $5RMvC(value) || $2940e712aca02fa7$var$isDataView(value);
}
module.exports.isArrayBufferView = $2940e712aca02fa7$var$isArrayBufferView;
function $2940e712aca02fa7$var$isUint8Array(value) {
    return $go4T7(value) === 'Uint8Array';
}
module.exports.isUint8Array = $2940e712aca02fa7$var$isUint8Array;
function $2940e712aca02fa7$var$isUint8ClampedArray(value) {
    return $go4T7(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $2940e712aca02fa7$var$isUint8ClampedArray;
function $2940e712aca02fa7$var$isUint16Array(value) {
    return $go4T7(value) === 'Uint16Array';
}
module.exports.isUint16Array = $2940e712aca02fa7$var$isUint16Array;
function $2940e712aca02fa7$var$isUint32Array(value) {
    return $go4T7(value) === 'Uint32Array';
}
module.exports.isUint32Array = $2940e712aca02fa7$var$isUint32Array;
function $2940e712aca02fa7$var$isInt8Array(value) {
    return $go4T7(value) === 'Int8Array';
}
module.exports.isInt8Array = $2940e712aca02fa7$var$isInt8Array;
function $2940e712aca02fa7$var$isInt16Array(value) {
    return $go4T7(value) === 'Int16Array';
}
module.exports.isInt16Array = $2940e712aca02fa7$var$isInt16Array;
function $2940e712aca02fa7$var$isInt32Array(value) {
    return $go4T7(value) === 'Int32Array';
}
module.exports.isInt32Array = $2940e712aca02fa7$var$isInt32Array;
function $2940e712aca02fa7$var$isFloat32Array(value) {
    return $go4T7(value) === 'Float32Array';
}
module.exports.isFloat32Array = $2940e712aca02fa7$var$isFloat32Array;
function $2940e712aca02fa7$var$isFloat64Array(value) {
    return $go4T7(value) === 'Float64Array';
}
module.exports.isFloat64Array = $2940e712aca02fa7$var$isFloat64Array;
function $2940e712aca02fa7$var$isBigInt64Array(value) {
    return $go4T7(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $2940e712aca02fa7$var$isBigInt64Array;
function $2940e712aca02fa7$var$isBigUint64Array(value) {
    return $go4T7(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $2940e712aca02fa7$var$isBigUint64Array;
function $2940e712aca02fa7$var$isMapToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Map]';
}
$2940e712aca02fa7$var$isMapToString.working = typeof Map !== 'undefined' && $2940e712aca02fa7$var$isMapToString(new Map());
function $2940e712aca02fa7$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $2940e712aca02fa7$var$isMapToString.working ? $2940e712aca02fa7$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $2940e712aca02fa7$var$isMap;
function $2940e712aca02fa7$var$isSetToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Set]';
}
$2940e712aca02fa7$var$isSetToString.working = typeof Set !== 'undefined' && $2940e712aca02fa7$var$isSetToString(new Set());
function $2940e712aca02fa7$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $2940e712aca02fa7$var$isSetToString.working ? $2940e712aca02fa7$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $2940e712aca02fa7$var$isSet;
function $2940e712aca02fa7$var$isWeakMapToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WeakMap]';
}
$2940e712aca02fa7$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $2940e712aca02fa7$var$isWeakMapToString(new WeakMap());
function $2940e712aca02fa7$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $2940e712aca02fa7$var$isWeakMapToString.working ? $2940e712aca02fa7$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $2940e712aca02fa7$var$isWeakMap;
function $2940e712aca02fa7$var$isWeakSetToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WeakSet]';
}
$2940e712aca02fa7$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $2940e712aca02fa7$var$isWeakSetToString(new WeakSet());
function $2940e712aca02fa7$var$isWeakSet(value) {
    return $2940e712aca02fa7$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $2940e712aca02fa7$var$isWeakSet;
function $2940e712aca02fa7$var$isArrayBufferToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$2940e712aca02fa7$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $2940e712aca02fa7$var$isArrayBufferToString(new ArrayBuffer());
function $2940e712aca02fa7$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $2940e712aca02fa7$var$isArrayBufferToString.working ? $2940e712aca02fa7$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $2940e712aca02fa7$var$isArrayBuffer;
function $2940e712aca02fa7$var$isDataViewToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object DataView]';
}
$2940e712aca02fa7$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $2940e712aca02fa7$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $2940e712aca02fa7$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $2940e712aca02fa7$var$isDataViewToString.working ? $2940e712aca02fa7$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $2940e712aca02fa7$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $2940e712aca02fa7$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $2940e712aca02fa7$var$isSharedArrayBufferToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $2940e712aca02fa7$var$isSharedArrayBuffer(value) {
    if (typeof $2940e712aca02fa7$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $2940e712aca02fa7$var$isSharedArrayBufferToString.working === 'undefined') $2940e712aca02fa7$var$isSharedArrayBufferToString.working = $2940e712aca02fa7$var$isSharedArrayBufferToString(new $2940e712aca02fa7$var$SharedArrayBufferCopy());
    return $2940e712aca02fa7$var$isSharedArrayBufferToString.working ? $2940e712aca02fa7$var$isSharedArrayBufferToString(value) : value instanceof $2940e712aca02fa7$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $2940e712aca02fa7$var$isSharedArrayBuffer;
function $2940e712aca02fa7$var$isAsyncFunction(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $2940e712aca02fa7$var$isAsyncFunction;
function $2940e712aca02fa7$var$isMapIterator(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $2940e712aca02fa7$var$isMapIterator;
function $2940e712aca02fa7$var$isSetIterator(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $2940e712aca02fa7$var$isSetIterator;
function $2940e712aca02fa7$var$isGeneratorObject(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $2940e712aca02fa7$var$isGeneratorObject;
function $2940e712aca02fa7$var$isWebAssemblyCompiledModule(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $2940e712aca02fa7$var$isWebAssemblyCompiledModule;
function $2940e712aca02fa7$var$isNumberObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$numberValue);
}
module.exports.isNumberObject = $2940e712aca02fa7$var$isNumberObject;
function $2940e712aca02fa7$var$isStringObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$stringValue);
}
module.exports.isStringObject = $2940e712aca02fa7$var$isStringObject;
function $2940e712aca02fa7$var$isBooleanObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$booleanValue);
}
module.exports.isBooleanObject = $2940e712aca02fa7$var$isBooleanObject;
function $2940e712aca02fa7$var$isBigIntObject(value) {
    return $2940e712aca02fa7$var$BigIntSupported && $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$bigIntValue);
}
module.exports.isBigIntObject = $2940e712aca02fa7$var$isBigIntObject;
function $2940e712aca02fa7$var$isSymbolObject(value) {
    return $2940e712aca02fa7$var$SymbolSupported && $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$symbolValue);
}
module.exports.isSymbolObject = $2940e712aca02fa7$var$isSymbolObject;
function $2940e712aca02fa7$var$isBoxedPrimitive(value) {
    return $2940e712aca02fa7$var$isNumberObject(value) || $2940e712aca02fa7$var$isStringObject(value) || $2940e712aca02fa7$var$isBooleanObject(value) || $2940e712aca02fa7$var$isBigIntObject(value) || $2940e712aca02fa7$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $2940e712aca02fa7$var$isBoxedPrimitive;
function $2940e712aca02fa7$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($2940e712aca02fa7$var$isArrayBuffer(value) || $2940e712aca02fa7$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $2940e712aca02fa7$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});

parcelRegister("2Xb4T", function(module, exports) {
'use strict';

var $2269af4a175bb16e$var$hasToStringTag = (parcelRequire("DVsRa"))();

var $2BPyg = parcelRequire("2BPyg");

var $2269af4a175bb16e$var$$toString = $2BPyg('Object.prototype.toString');
var $2269af4a175bb16e$var$isStandardArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $2269af4a175bb16e$var$$toString(value) === '[object Arguments]';
};
var $2269af4a175bb16e$var$isLegacyArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2269af4a175bb16e$var$$toString(value) !== '[object Array]' && $2269af4a175bb16e$var$$toString(value.callee) === '[object Function]';
};
var $2269af4a175bb16e$var$supportsStandardArguments = function() {
    return $2269af4a175bb16e$var$isStandardArguments(arguments);
}();
$2269af4a175bb16e$var$isStandardArguments.isLegacyArguments = $2269af4a175bb16e$var$isLegacyArguments; // for tests
module.exports = $2269af4a175bb16e$var$supportsStandardArguments ? $2269af4a175bb16e$var$isStandardArguments : $2269af4a175bb16e$var$isLegacyArguments;

});

parcelRegister("2BPyg", function(module, exports) {
'use strict';

var $cAbhD = parcelRequire("cAbhD");


var $26J2z = parcelRequire("26J2z");

var $1e670692988d4e8b$var$$indexOf = $26J2z($cAbhD('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $cAbhD(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $1e670692988d4e8b$var$$indexOf(name, '.prototype.') > -1) return $26J2z(intrinsic);
    return intrinsic;
};

});

parcelRegister("6TAnP", function(module, exports) {
'use strict';
var $50541a19d60c8c39$var$toStr = Object.prototype.toString;
var $50541a19d60c8c39$var$fnToStr = Function.prototype.toString;
var $50541a19d60c8c39$var$isFnRegex = /^\s*(?:function)?\*/;

var $50541a19d60c8c39$var$hasToStringTag = (parcelRequire("DVsRa"))();
var $50541a19d60c8c39$var$getProto = Object.getPrototypeOf;
var $50541a19d60c8c39$var$getGeneratorFunc = function() {
    if (!$50541a19d60c8c39$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $50541a19d60c8c39$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($50541a19d60c8c39$var$isFnRegex.test($50541a19d60c8c39$var$fnToStr.call(fn))) return true;
    if (!$50541a19d60c8c39$var$hasToStringTag) {
        var str = $50541a19d60c8c39$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$50541a19d60c8c39$var$getProto) return false;
    if (typeof $50541a19d60c8c39$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $50541a19d60c8c39$var$getGeneratorFunc();
        $50541a19d60c8c39$var$GeneratorFunction = generatorFunc ? $50541a19d60c8c39$var$getProto(generatorFunc) : false;
    }
    return $50541a19d60c8c39$var$getProto(fn) === $50541a19d60c8c39$var$GeneratorFunction;
};

});

parcelRegister("hUXoN", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("9OEKu", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $1P2f3 = parcelRequire("1P2f3");

'use strict';
function $7258646f9557e685$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7258646f9557e685$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7258646f9557e685$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7258646f9557e685$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7258646f9557e685$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7258646f9557e685$var$_defineProperty(obj, key, value) {
    key = $7258646f9557e685$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7258646f9557e685$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7258646f9557e685$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7258646f9557e685$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7258646f9557e685$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7258646f9557e685$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7258646f9557e685$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7258646f9557e685$var$_toPropertyKey(arg) {
    var key = $7258646f9557e685$var$_toPrimitive(arg, "string");
    return $7258646f9557e685$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7258646f9557e685$var$_toPrimitive(input, hint) {
    if ($7258646f9557e685$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7258646f9557e685$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7258646f9557e685$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7258646f9557e685$var$_setPrototypeOf(subClass, superClass);
}
function $7258646f9557e685$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7258646f9557e685$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7258646f9557e685$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7258646f9557e685$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7258646f9557e685$var$_possibleConstructorReturn(this, result);
    };
}
function $7258646f9557e685$var$_possibleConstructorReturn(self, call) {
    if (call && ($7258646f9557e685$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7258646f9557e685$var$_assertThisInitialized(self);
}
function $7258646f9557e685$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7258646f9557e685$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7258646f9557e685$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7258646f9557e685$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7258646f9557e685$var$_construct(Class, arguments, $7258646f9557e685$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7258646f9557e685$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7258646f9557e685$var$_wrapNativeSuper(Class);
}
function $7258646f9557e685$var$_construct(Parent, args, Class) {
    if ($7258646f9557e685$var$_isNativeReflectConstruct()) $7258646f9557e685$var$_construct = Reflect.construct.bind();
    else $7258646f9557e685$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7258646f9557e685$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7258646f9557e685$var$_construct.apply(null, arguments);
}
function $7258646f9557e685$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7258646f9557e685$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7258646f9557e685$var$_setPrototypeOf(o, p) {
    $7258646f9557e685$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7258646f9557e685$var$_setPrototypeOf(o, p);
}
function $7258646f9557e685$var$_getPrototypeOf(o) {
    $7258646f9557e685$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7258646f9557e685$var$_getPrototypeOf(o);
}
function $7258646f9557e685$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7258646f9557e685$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7258646f9557e685$var$_typeof(o);
}

var $7T2Y0 = parcelRequire("7T2Y0");

var $7258646f9557e685$var$inspect = $7T2Y0.inspect;

var $9VDwT = parcelRequire("9VDwT");

var $7258646f9557e685$var$ERR_INVALID_ARG_TYPE = $9VDwT.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7258646f9557e685$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $7258646f9557e685$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $7258646f9557e685$var$blue = '';
var $7258646f9557e685$var$green = '';
var $7258646f9557e685$var$red = '';
var $7258646f9557e685$var$white = '';
var $7258646f9557e685$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $7258646f9557e685$var$kMaxShortLength = 10;
function $7258646f9557e685$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $7258646f9557e685$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $7258646f9557e685$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $7258646f9557e685$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $7258646f9557e685$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $7258646f9557e685$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $7258646f9557e685$var$_typeof(actual) === 'object' && $7258646f9557e685$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $7258646f9557e685$var$kMaxShortLength) {
            if (($7258646f9557e685$var$_typeof(actual) !== 'object' || actual === null) && ($7258646f9557e685$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($7258646f9557e685$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $1P2f3.stderr && $1P2f3.stderr.isTTY ? $1P2f3.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($7258646f9557e685$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($7258646f9557e685$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $7258646f9557e685$var$kReadableOperator[operator] + "\n".concat($7258646f9557e685$var$green, "+ actual").concat($7258646f9557e685$var$white, " ").concat($7258646f9557e685$var$red, "- expected").concat($7258646f9557e685$var$white);
    var skippedMsg = " ".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($7258646f9557e685$var$red, "-").concat($7258646f9557e685$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($7258646f9557e685$var$green, "+").concat($7258646f9557e685$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$7258646f9557e685$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $7258646f9557e685$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($7258646f9557e685$var$green, "+").concat($7258646f9557e685$var$white, " ").concat(actualLine);
                other += "\n".concat($7258646f9557e685$var$red, "-").concat($7258646f9557e685$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white).concat(other, "\n") + "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $7258646f9557e685$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $7258646f9557e685$var$_inherits(AssertionError, _Error);
    var _super = $7258646f9557e685$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $7258646f9557e685$var$_classCallCheck(this, AssertionError);
        if ($7258646f9557e685$var$_typeof(options) !== 'object' || options === null) throw new $7258646f9557e685$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($1P2f3.stderr && $1P2f3.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($1P2f3.stderr && $1P2f3.stderr.getColorDepth && $1P2f3.stderr.getColorDepth() !== 1) {
                    $7258646f9557e685$var$blue = "\x1B[34m";
                    $7258646f9557e685$var$green = "\x1B[32m";
                    $7258646f9557e685$var$white = "\x1B[39m";
                    $7258646f9557e685$var$red = "\x1B[31m";
                } else {
                    $7258646f9557e685$var$blue = '';
                    $7258646f9557e685$var$green = '';
                    $7258646f9557e685$var$white = '';
                    $7258646f9557e685$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($7258646f9557e685$var$_typeof(actual) === 'object' && actual !== null && $7258646f9557e685$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $7258646f9557e685$var$copyError(actual);
                expected = $7258646f9557e685$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $7258646f9557e685$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $7258646f9557e685$var$kReadableOperator[operator];
                var res = $7258646f9557e685$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $7258646f9557e685$var$_typeof(actual) === 'object' && actual !== null) base = $7258646f9557e685$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $7258646f9557e685$var$inspectValue(actual);
                var other = '';
                var knownOperators = $7258646f9557e685$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($7258646f9557e685$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($7258646f9557e685$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($7258646f9557e685$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($7258646f9557e685$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $7258646f9557e685$var$_possibleConstructorReturn(_this);
    }
    $7258646f9557e685$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $7258646f9557e685$var$inspect(this, $7258646f9557e685$var$_objectSpread($7258646f9557e685$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $7258646f9557e685$var$_wrapNativeSuper(Error), $7258646f9557e685$var$inspect.custom);
module.exports = $7258646f9557e685$var$AssertionError;

});

parcelRegister("fnK1J", function(module, exports) {
'use strict';

var $3yGSv = parcelRequire("3yGSv");

var $b32cb5030c98732b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $b32cb5030c98732b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $3yGSv;
    if ($b32cb5030c98732b$var$lacksProperEnumerationOrder()) return $3yGSv;
    if ($b32cb5030c98732b$var$assignHasPendingExceptions()) return $3yGSv;
    return Object.assign;
};

});

parcelRegister("3yGSv", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");


var $2975cec13e42e027$var$hasSymbols = (parcelRequire("edGXQ"))();

var $blqMe = parcelRequire("blqMe");


var $f8a3L = parcelRequire("f8a3L");

var $2975cec13e42e027$var$$push = $blqMe('Array.prototype.push');
var $2975cec13e42e027$var$$propIsEnumerable = $blqMe('Object.prototype.propertyIsEnumerable');
var $2975cec13e42e027$var$originalGetSymbols = $2975cec13e42e027$var$hasSymbols ? $f8a3L.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $f8a3L(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $f8a3L(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $2aMTq(from);
        var getSymbols = $2975cec13e42e027$var$hasSymbols && ($f8a3L.getOwnPropertySymbols || $2975cec13e42e027$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($2975cec13e42e027$var$$propIsEnumerable(from, key)) $2975cec13e42e027$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($2975cec13e42e027$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});

parcelRegister("2aMTq", function(module, exports) {
'use strict';
var $19527114ab6c974a$var$slice = Array.prototype.slice;

var $9QzFm = parcelRequire("9QzFm");

var $19527114ab6c974a$var$origKeys = Object.keys;

var $19527114ab6c974a$var$keysShim = $19527114ab6c974a$var$origKeys ? function keys(o) {
    return $19527114ab6c974a$var$origKeys(o);
} : (parcelRequire("6NXwY"));
var $19527114ab6c974a$var$originalKeys = Object.keys;
$19527114ab6c974a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($9QzFm(object)) return $19527114ab6c974a$var$originalKeys($19527114ab6c974a$var$slice.call(object));
            return $19527114ab6c974a$var$originalKeys(object);
        };
    } else Object.keys = $19527114ab6c974a$var$keysShim;
    return Object.keys || $19527114ab6c974a$var$keysShim;
};
module.exports = $19527114ab6c974a$var$keysShim;

});

parcelRegister("9QzFm", function(module, exports) {
'use strict';
var $72b4a2f3cb441a79$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $72b4a2f3cb441a79$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $72b4a2f3cb441a79$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("6NXwY", function(module, exports) {
'use strict';
var $4f457f4760cceef9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $4f457f4760cceef9$var$has = Object.prototype.hasOwnProperty;
    var $4f457f4760cceef9$var$toStr = Object.prototype.toString;
    var $4f457f4760cceef9$var$isArgs = (parcelRequire("9QzFm")); // eslint-disable-line global-require
    var $4f457f4760cceef9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $4f457f4760cceef9$var$hasDontEnumBug = !$4f457f4760cceef9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $4f457f4760cceef9$var$hasProtoEnumBug = $4f457f4760cceef9$var$isEnumerable.call(function() {}, 'prototype');
    var $4f457f4760cceef9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $4f457f4760cceef9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $4f457f4760cceef9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $4f457f4760cceef9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$4f457f4760cceef9$var$excludedKeys['$' + k] && $4f457f4760cceef9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $4f457f4760cceef9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$4f457f4760cceef9$var$hasAutomationEqualityBug) return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        try {
            return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $4f457f4760cceef9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $4f457f4760cceef9$var$toStr.call(object) === '[object Function]';
        var isArguments = $4f457f4760cceef9$var$isArgs(object);
        var isString = isObject && $4f457f4760cceef9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $4f457f4760cceef9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$4f457f4760cceef9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $4f457f4760cceef9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($4f457f4760cceef9$var$hasDontEnumBug) {
            var skipConstructor = $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $4f457f4760cceef9$var$dontEnums.length; ++k)if (!(skipConstructor && $4f457f4760cceef9$var$dontEnums[k] === 'constructor') && $4f457f4760cceef9$var$has.call(object, $4f457f4760cceef9$var$dontEnums[k])) theKeys.push($4f457f4760cceef9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $4f457f4760cceef9$var$keysShim;

});

parcelRegister("aKQxr", function(module, exports) {
'use strict';

var $iZo8r = parcelRequire("iZo8r");

module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iZo8r;
};

});

parcelRegister("iZo8r", function(module, exports) {
'use strict';
var $dd30a53fbc79558f$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($dd30a53fbc79558f$var$numberIsNaN(a) && $dd30a53fbc79558f$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("ilKc6", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $d5be055d9baf98a0$var$_slicedToArray(arr, i) {
    return $d5be055d9baf98a0$var$_arrayWithHoles(arr) || $d5be055d9baf98a0$var$_iterableToArrayLimit(arr, i) || $d5be055d9baf98a0$var$_unsupportedIterableToArray(arr, i) || $d5be055d9baf98a0$var$_nonIterableRest();
}
function $d5be055d9baf98a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d5be055d9baf98a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d5be055d9baf98a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d5be055d9baf98a0$var$_arrayLikeToArray(o, minLen);
}
function $d5be055d9baf98a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d5be055d9baf98a0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d5be055d9baf98a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d5be055d9baf98a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5be055d9baf98a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5be055d9baf98a0$var$_typeof(o);
}
var $d5be055d9baf98a0$var$regexFlagsSupported = /a/g.flags !== undefined;
var $d5be055d9baf98a0$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $d5be055d9baf98a0$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $d5be055d9baf98a0$var$objectIs = Object.is ? Object.is : (parcelRequire("29nQp"));
var $d5be055d9baf98a0$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $d5be055d9baf98a0$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("ojU0q"));
function $d5be055d9baf98a0$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $d5be055d9baf98a0$var$hasOwnProperty = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.hasOwnProperty);
var $d5be055d9baf98a0$var$propertyIsEnumerable = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $d5be055d9baf98a0$var$objectToString = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.toString);

var $7T2Y0 = parcelRequire("7T2Y0");

var $d5be055d9baf98a0$require$_require$types = $7T2Y0.types;
var $d5be055d9baf98a0$var$isAnyArrayBuffer = $d5be055d9baf98a0$require$_require$types.isAnyArrayBuffer, $d5be055d9baf98a0$var$isArrayBufferView = $d5be055d9baf98a0$require$_require$types.isArrayBufferView, $d5be055d9baf98a0$var$isDate = $d5be055d9baf98a0$require$_require$types.isDate, $d5be055d9baf98a0$var$isMap = $d5be055d9baf98a0$require$_require$types.isMap, $d5be055d9baf98a0$var$isRegExp = $d5be055d9baf98a0$require$_require$types.isRegExp, $d5be055d9baf98a0$var$isSet = $d5be055d9baf98a0$require$_require$types.isSet, $d5be055d9baf98a0$var$isNativeError = $d5be055d9baf98a0$require$_require$types.isNativeError, $d5be055d9baf98a0$var$isBoxedPrimitive = $d5be055d9baf98a0$require$_require$types.isBoxedPrimitive, $d5be055d9baf98a0$var$isNumberObject = $d5be055d9baf98a0$require$_require$types.isNumberObject, $d5be055d9baf98a0$var$isStringObject = $d5be055d9baf98a0$require$_require$types.isStringObject, $d5be055d9baf98a0$var$isBooleanObject = $d5be055d9baf98a0$require$_require$types.isBooleanObject, $d5be055d9baf98a0$var$isBigIntObject = $d5be055d9baf98a0$require$_require$types.isBigIntObject, $d5be055d9baf98a0$var$isSymbolObject = $d5be055d9baf98a0$require$_require$types.isSymbolObject, $d5be055d9baf98a0$var$isFloat32Array = $d5be055d9baf98a0$require$_require$types.isFloat32Array, $d5be055d9baf98a0$var$isFloat64Array = $d5be055d9baf98a0$require$_require$types.isFloat64Array;
function $d5be055d9baf98a0$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $d5be055d9baf98a0$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($d5be055d9baf98a0$var$isNonIndex).concat($d5be055d9baf98a0$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $d5be055d9baf98a0$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $d5be055d9baf98a0$var$ONLY_ENUMERABLE = undefined;
var $d5be055d9baf98a0$var$kStrict = true;
var $d5be055d9baf98a0$var$kLoose = false;
var $d5be055d9baf98a0$var$kNoIterator = 0;
var $d5be055d9baf98a0$var$kIsArray = 1;
var $d5be055d9baf98a0$var$kIsSet = 2;
var $d5be055d9baf98a0$var$kIsMap = 3;
// Check if they have the same source and flags
function $d5be055d9baf98a0$var$areSimilarRegExps(a, b) {
    return $d5be055d9baf98a0$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $d5be055d9baf98a0$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $d5be055d9baf98a0$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $d5be055d9baf98a0$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $d5be055d9baf98a0$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $d5be055d9baf98a0$var$isEqualBoxedPrimitive(val1, val2) {
    if ($d5be055d9baf98a0$var$isNumberObject(val1)) return $d5be055d9baf98a0$var$isNumberObject(val2) && $d5be055d9baf98a0$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($d5be055d9baf98a0$var$isStringObject(val1)) return $d5be055d9baf98a0$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($d5be055d9baf98a0$var$isBooleanObject(val1)) return $d5be055d9baf98a0$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($d5be055d9baf98a0$var$isBigIntObject(val1)) return $d5be055d9baf98a0$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $d5be055d9baf98a0$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $d5be055d9baf98a0$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($d5be055d9baf98a0$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $d5be055d9baf98a0$var$numberIsNaN(val1) && $d5be055d9baf98a0$var$numberIsNaN(val2);
        if ($d5be055d9baf98a0$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $d5be055d9baf98a0$var$_typeof(val1) !== 'object') {
            if (val2 === null || $d5be055d9baf98a0$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $d5be055d9baf98a0$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $d5be055d9baf98a0$var$objectToString(val1);
    var val2Tag = $d5be055d9baf98a0$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val1, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        var keys2 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val2, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$d5be055d9baf98a0$var$isMap(val1) && $d5be055d9baf98a0$var$isMap(val2) || !$d5be055d9baf98a0$var$isSet(val1) && $d5be055d9baf98a0$var$isSet(val2)) return false;
    }
    if ($d5be055d9baf98a0$var$isDate(val1)) {
        if (!$d5be055d9baf98a0$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($d5be055d9baf98a0$var$isRegExp(val1)) {
        if (!$d5be055d9baf98a0$var$isRegExp(val2) || !$d5be055d9baf98a0$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($d5be055d9baf98a0$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($d5be055d9baf98a0$var$isArrayBufferView(val1)) {
        if (!strict && ($d5be055d9baf98a0$var$isFloat32Array(val1) || $d5be055d9baf98a0$var$isFloat64Array(val1))) {
            if (!$d5be055d9baf98a0$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$d5be055d9baf98a0$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val1, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        var _keys2 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val2, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kNoIterator, _keys);
    } else if ($d5be055d9baf98a0$var$isSet(val1)) {
        if (!$d5be055d9baf98a0$var$isSet(val2) || val1.size !== val2.size) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsSet);
    } else if ($d5be055d9baf98a0$var$isMap(val1)) {
        if (!$d5be055d9baf98a0$var$isMap(val2) || val1.size !== val2.size) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsMap);
    } else if ($d5be055d9baf98a0$var$isAnyArrayBuffer(val1)) {
        if (!$d5be055d9baf98a0$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($d5be055d9baf98a0$var$isBoxedPrimitive(val1) && !$d5be055d9baf98a0$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kNoIterator);
}
function $d5be055d9baf98a0$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $d5be055d9baf98a0$var$propertyIsEnumerable(val, k);
    });
}
function $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$d5be055d9baf98a0$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($d5be055d9baf98a0$var$propertyIsEnumerable(val1, key)) {
                    if (!$d5be055d9baf98a0$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($d5be055d9baf98a0$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $d5be055d9baf98a0$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $d5be055d9baf98a0$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $d5be055d9baf98a0$var$kNoIterator || iterationType === $d5be055d9baf98a0$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $d5be055d9baf98a0$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $d5be055d9baf98a0$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $d5be055d9baf98a0$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($d5be055d9baf98a0$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim) {
    switch($d5be055d9baf98a0$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($d5be055d9baf98a0$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $d5be055d9baf98a0$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$d5be055d9baf98a0$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $d5be055d9baf98a0$var$innerDeepEqual(item, curB, false, memo);
}
function $d5be055d9baf98a0$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $d5be055d9baf98a0$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($d5be055d9baf98a0$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$d5be055d9baf98a0$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $d5be055d9baf98a0$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($d5be055d9baf98a0$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$d5be055d9baf98a0$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$d5be055d9baf98a0$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $d5be055d9baf98a0$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $d5be055d9baf98a0$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($d5be055d9baf98a0$var$innerDeepEqual(key1, key2, strict, memo) && $d5be055d9baf98a0$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $d5be055d9baf98a0$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $d5be055d9baf98a0$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $d5be055d9baf98a0$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($d5be055d9baf98a0$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$d5be055d9baf98a0$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$d5be055d9baf98a0$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $d5be055d9baf98a0$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $d5be055d9baf98a0$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($d5be055d9baf98a0$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$d5be055d9baf98a0$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$d5be055d9baf98a0$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$d5be055d9baf98a0$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $d5be055d9baf98a0$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $d5be055d9baf98a0$var$kIsSet) {
        if (!$d5be055d9baf98a0$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $d5be055d9baf98a0$var$kIsMap) {
        if (!$d5be055d9baf98a0$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $d5be055d9baf98a0$var$kIsArray) for(; i < a.length; i++){
        if ($d5be055d9baf98a0$var$hasOwnProperty(a, i)) {
            if (!$d5be055d9baf98a0$var$hasOwnProperty(b, i) || !$d5be055d9baf98a0$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($d5be055d9baf98a0$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$d5be055d9baf98a0$var$hasOwnProperty(b, key) || !$d5be055d9baf98a0$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$d5be055d9baf98a0$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$isDeepEqual(val1, val2) {
    return $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, $d5be055d9baf98a0$var$kLoose);
}
function $d5be055d9baf98a0$var$isDeepStrictEqual(val1, val2) {
    return $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, $d5be055d9baf98a0$var$kStrict);
}
module.exports = {
    isDeepEqual: $d5be055d9baf98a0$var$isDeepEqual,
    isDeepStrictEqual: $d5be055d9baf98a0$var$isDeepStrictEqual
};

});

parcelRegister("29nQp", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $26J2z = parcelRequire("26J2z");


var $iZo8r = parcelRequire("iZo8r");


var $aKQxr = parcelRequire("aKQxr");


var $h9z8p = parcelRequire("h9z8p");

var $190eeb03c4f85517$var$polyfill = $26J2z($aKQxr(), Object);
$eGbn7($190eeb03c4f85517$var$polyfill, {
    getPolyfill: $aKQxr,
    implementation: $iZo8r,
    shim: $h9z8p
});
module.exports = $190eeb03c4f85517$var$polyfill;

});

parcelRegister("eGbn7", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");

var $aafdcf22e1319c4a$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $aafdcf22e1319c4a$var$toStr = Object.prototype.toString;
var $aafdcf22e1319c4a$var$concat = Array.prototype.concat;

var $iFj39 = parcelRequire("iFj39");

var $aafdcf22e1319c4a$var$isFunction = function(fn) {
    return typeof fn === 'function' && $aafdcf22e1319c4a$var$toStr.call(fn) === '[object Function]';
};

var $aafdcf22e1319c4a$var$supportsDescriptors = (parcelRequire("9CFxa"))();
var $aafdcf22e1319c4a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$aafdcf22e1319c4a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($aafdcf22e1319c4a$var$supportsDescriptors) $iFj39(object, name, value, true);
    else $iFj39(object, name, value);
};
var $aafdcf22e1319c4a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $2aMTq(map);
    if ($aafdcf22e1319c4a$var$hasSymbols) props = $aafdcf22e1319c4a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$aafdcf22e1319c4a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$aafdcf22e1319c4a$var$defineProperties.supportsDescriptors = !!$aafdcf22e1319c4a$var$supportsDescriptors;
module.exports = $aafdcf22e1319c4a$var$defineProperties;

});

parcelRegister("h9z8p", function(module, exports) {
'use strict';

var $aKQxr = parcelRequire("aKQxr");


var $eGbn7 = parcelRequire("eGbn7");

module.exports = function shimObjectIs() {
    var polyfill = $aKQxr();
    $eGbn7(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("ojU0q", function(module, exports) {
'use strict';

var $26J2z = parcelRequire("26J2z");


var $eGbn7 = parcelRequire("eGbn7");


var $5PvCl = parcelRequire("5PvCl");


var $15HFT = parcelRequire("15HFT");


var $99fDU = parcelRequire("99fDU");

var $0491ae3133badd22$var$polyfill = $26J2z($15HFT(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $eGbn7($0491ae3133badd22$var$polyfill, {
    getPolyfill: $15HFT,
    implementation: $5PvCl,
    shim: $99fDU
});
module.exports = $0491ae3133badd22$var$polyfill;

});

parcelRegister("5PvCl", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("15HFT", function(module, exports) {
'use strict';

var $5PvCl = parcelRequire("5PvCl");

module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $5PvCl;
};

});

parcelRegister("99fDU", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $15HFT = parcelRequire("15HFT");

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $15HFT();
    $eGbn7(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("a46d9", function(module, exports) {

var $dojlP = parcelRequire("dojlP");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $753f187ea15d0048$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $753f187ea15d0048$var$reHasRegExpChar = RegExp($753f187ea15d0048$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $753f187ea15d0048$var$escapeRegExp(string) {
    string = $dojlP(string);
    return string && $753f187ea15d0048$var$reHasRegExpChar.test(string) ? string.replace($753f187ea15d0048$var$reRegExpChar, '\\$&') : string;
}
module.exports = $753f187ea15d0048$var$escapeRegExp;

});

parcelRegister("c8XQL", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lOiVq = parcelRequire("lOiVq");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $8d74a858e0464007$var$isDevelopment = false;
var $8d74a858e0464007$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $8d74a858e0464007$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8d74a858e0464007$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8d74a858e0464007$var$testOmitPropsOnStringTag : $8d74a858e0464007$var$testOmitPropsOnComponent;
};
var $8d74a858e0464007$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8d74a858e0464007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8d74a858e0464007$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8d74a858e0464007$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8d74a858e0464007$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $lOiVq.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $lOiVq.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8d74a858e0464007$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($8d74a858e0464007$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8d74a858e0464007$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $8d74a858e0464007$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $8d74a858e0464007$export$2e2bcd8739ae039;

});

parcelRegister("ifF9E", function(module, exports) {

var $e8eWN = parcelRequire("e8eWN");

// eslint-disable-next-line no-undef
var $d4998d3150d9a680$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4998d3150d9a680$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e8eWN.default)(function(prop) {
    return $d4998d3150d9a680$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $d4998d3150d9a680$export$2e2bcd8739ae039;

});

parcelRegister("aYr7p", function(module, exports) {

var $aQVxe = parcelRequire("aQVxe");


var $gvTsE = parcelRequire("gvTsE");


var $j6gAQ = parcelRequire("j6gAQ");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $7fd48b25632d9305$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1ScXu(collection) ? $aQVxe : $gvTsE, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $j6gAQ(iteratee, 2), accumulator);
    };
}
module.exports = $7fd48b25632d9305$var$createAggregator;

});

parcelRegister("aQVxe", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7e6b63f27d697568$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $7e6b63f27d697568$var$arrayAggregator;

});

parcelRegister("gvTsE", function(module, exports) {

var $bNHBU = parcelRequire("bNHBU");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c05a9000df9c8764$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $bNHBU(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $c05a9000df9c8764$var$baseAggregator;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("17wiG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $3lbOc = parcelRequire("3lbOc");


var $a1L5E = parcelRequire("a1L5E");

const $7f8f90030369ae01$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $7f8f90030369ae01$var$CardLoadingWithContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            ...props,
            interactionName: "media-card-async-loading"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $7f8f90030369ae01$var$loadCardWithMediaClient() {
    return (parcelRequire("cDdYd"));
}
const $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
});
const $7f8f90030369ae01$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $7f8f90030369ae01$var$CardLoader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("platform_media_react19_support") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "media-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
            value: props
        }, t0));
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
        value: props
    }, (0, $iDrrr.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props)));
};
$7f8f90030369ae01$var$CardLoader.preload = ()=>{
    if ((0, $iDrrr.fg)('platform_media_react19_support')) $7f8f90030369ae01$var$loadCardWithMediaClient().then(()=>{});
    else $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $7f8f90030369ae01$export$2e2bcd8739ae039 = $7f8f90030369ae01$var$CardLoader;
module.exports["default"] = $7f8f90030369ae01$export$2e2bcd8739ae039;

});

parcelRegister("3lbOc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $ieeJu = parcelRequire("ieeJu");


var $97Pj3 = parcelRequire("97Pj3");


var $8quKc = parcelRequire("8quKc");


var $1pEse = parcelRequire("1pEse");

const $9010bd9f06816b06$export$5d25853fd6bdf402 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== dimensionsProp) {
        t1 = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
        $[0] = dimensionsProp;
        $[1] = t1;
    } else t1 = $[1];
    const dimensions = t1;
    const t2 = testId || "media-card-loading";
    let t3;
    if ($[2] !== interactionName) {
        t3 = (0, $ieeJu.expValEquals)("cc-maui-ai-edit-loading-experiment", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
            interactionName: interactionName || "media-card-loading"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            interactionName: interactionName || "media-card-loading"
        });
        $[2] = interactionName;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== dimensions || $[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
            "data-testid": t2,
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, t3);
        $[4] = dimensions;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, (0, $ieeJu.expValEquals)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: interactionName || 'media-card-loading'
    }));
};
module.exports["CardLoading"] = $9010bd9f06816b06$export$5d25853fd6bdf402;

});

parcelRegister("97Pj3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5EzLH = parcelRequire("5EzLH");

const $9d658d6460d574ed$var$TICK_INTERVAL_MS = 1000;
const $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE = 0.9; /**
                                    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                    * which makes things simpler than doing an `isServer` check or a `null` check.
                                    *
                                    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                    */ 
const $9d658d6460d574ed$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $9d658d6460d574ed$var$messages = (0, $kSwu1.defineMessages)({
    loadingBarLabel: {
        id: "fabric.media.loading_bar_label",
        defaultMessage: "Loading"
    }
});
const $9d658d6460d574ed$var$trackStyles = null;
const $9d658d6460d574ed$var$fillStyles = null;
const $9d658d6460d574ed$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $9d658d6460d574ed$export$6665614bc5d690f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { animationDisabled: t1, testId: testId, interactionName: interactionName } = t0;
    const animationDisabled = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    let t3;
    if ($[0] !== interactionContext || $[1] !== interactionName) {
        t2 = ()=>{
            if (interactionContext != null) return interactionContext.hold(interactionName);
        };
        t3 = [
            interactionContext,
            interactionName
        ];
        $[0] = interactionContext;
        $[1] = interactionName;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    $9d658d6460d574ed$var$useLayoutEffect(t2, t3);
    let t4;
    let t5;
    if ($[4] !== animationDisabled) {
        t4 = ()=>{
            if (animationDisabled) {
                setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
                return;
            }
            intervalRef.current = setInterval(()=>{
                setProgress((prev)=>{
                    if (prev < 0.1) return prev + 0.1;
                    else {
                        if (prev < 0.6) return prev + 0.35;
                        else {
                            if (prev < 0.9) return prev + 0.1;
                        }
                    }
                    clearInterval(intervalRef.current);
                    return prev;
                });
            }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
            return ()=>clearInterval(intervalRef.current);
        };
        t5 = [
            animationDisabled
        ];
        $[4] = animationDisabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[7] !== intl) {
        t6 = intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel);
        $[7] = intl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== progress) {
        t8 = $9d658d6460d574ed$var$clampToPercent(progress);
        $[10] = progress;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `${t8}%`;
    let t10;
    if ($[12] !== t9) {
        t10 = {
            width: t9
        };
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ]);
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t10,
            className: t11
        });
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== progress || $[18] !== t12 || $[19] !== t6 || $[20] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": t6,
            "data-testid": testId,
            className: t7
        }, t12);
        $[17] = progress;
        $[18] = t12;
        $[19] = t6;
        $[20] = testId;
        $[21] = t13;
    } else t13 = $[21];
    return t13;
} : ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    $9d658d6460d574ed$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: `${$9d658d6460d574ed$var$clampToPercent(progress)}%`
        },
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ])
    }));
};
module.exports["LoadingBar"] = $9d658d6460d574ed$export$6665614bc5d690f6;

});

parcelRegister("1pEse", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $ew4xH = parcelRequire("ew4xH");

const $edacca4f67c5c3ed$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $ew4xH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $edacca4f67c5c3ed$export$e6dfd72ab29f8598;

});

parcelRegister("ew4xH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $9AILw = parcelRequire("9AILw");

const $b57e90473f867d52$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $b57e90473f867d52$export$491e6397d7c1480b;

});

parcelRegister("9AILw", function(module, exports) {
const $1086bc1f8c9770f0$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $1086bc1f8c9770f0$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $1086bc1f8c9770f0$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $1086bc1f8c9770f0$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $1086bc1f8c9770f0$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["size"] = $1086bc1f8c9770f0$export$346677f925de839c;
module.exports["center"] = $1086bc1f8c9770f0$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $1086bc1f8c9770f0$export$7a57f79000377ca2;

});

parcelRegister("cDdYd", function(module, exports) {

let $9323f6bd23fe44a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9323f6bd23fe44a3$var$load("2Bp34"),
    $9323f6bd23fe44a3$var$load("90vep"),
    $9323f6bd23fe44a3$var$load("ixrKS"),
    $9323f6bd23fe44a3$var$load("fdLC1"),
    $9323f6bd23fe44a3$var$load("6OMo6"),
    $9323f6bd23fe44a3$var$load("aaRXj"),
    $9323f6bd23fe44a3$var$load("fHlIz"),
    $9323f6bd23fe44a3$var$load("4QwAJ"),
    $9323f6bd23fe44a3$var$load("3i44s"),
    $9323f6bd23fe44a3$var$load("5kI0b"),
    $9323f6bd23fe44a3$var$load("kYkz1"),
    $9323f6bd23fe44a3$var$load("jfYeU"),
    $9323f6bd23fe44a3$var$load("b4nm1"),
    $9323f6bd23fe44a3$var$load("geXPZ"),
    $9323f6bd23fe44a3$var$load("aQ5uu"),
    $9323f6bd23fe44a3$var$load("6wr18"),
    $9323f6bd23fe44a3$var$load("7EorR"),
    $9323f6bd23fe44a3$var$load("aOIZj"),
    $9323f6bd23fe44a3$var$load("lVz4k"),
    $9323f6bd23fe44a3$var$load("fV46K"),
    $9323f6bd23fe44a3$var$load("jOE2W"),
    $9323f6bd23fe44a3$var$load("jTOhL"),
    $9323f6bd23fe44a3$var$load("cuNBo"),
    $9323f6bd23fe44a3$var$load("4Ldt2"),
    $9323f6bd23fe44a3$var$load("2XRLb"),
    $9323f6bd23fe44a3$var$load("gkVge"),
    $9323f6bd23fe44a3$var$load("io0qR"),
    $9323f6bd23fe44a3$var$load("3MJxZ"),
    $9323f6bd23fe44a3$var$load("kHMR7"),
    $9323f6bd23fe44a3$var$load("e3OZZ"),
    $9323f6bd23fe44a3$var$load("cL682"),
    $9323f6bd23fe44a3$var$load("4MePG"),
    $9323f6bd23fe44a3$var$load("5JWJI"),
    $9323f6bd23fe44a3$var$load("ffEVr"),
    $9323f6bd23fe44a3$var$load("7gPXS")
]).then(()=>parcelRequire('gnpwR'));

});

parcelRegister("gjPL4", function(module, exports) {
const $2cc17340c0c1baf9$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2cc17340c0c1baf9$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2cc17340c0c1baf9$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2cc17340c0c1baf9$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $2cc17340c0c1baf9$export$d87a47989c00f322;
    if (appearance === 'square') return $2cc17340c0c1baf9$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2cc17340c0c1baf9$export$aeb48196afcd236a;
    return $2cc17340c0c1baf9$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $2cc17340c0c1baf9$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $2cc17340c0c1baf9$export$ed7b8a4728e9c63;

});

parcelRegister("PGUCj", function(module, exports) {

var $jg98Q = parcelRequire("jg98Q");

const $edab81c479d02fd3$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $edab81c479d02fd3$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $edab81c479d02fd3$export$5883721593c4e4b1 = (a, b)=>{
    if ($edab81c479d02fd3$export$7695387cd66cf5b5(a) && $edab81c479d02fd3$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))(a, b);
};
module.exports["isFileIdentifier"] = $edab81c479d02fd3$export$7695387cd66cf5b5;
module.exports["isExternalImageIdentifier"] = $edab81c479d02fd3$export$2782f2fbff82f0c9;

});

parcelRegister("jg98Q", function(module, exports) {
var $e0569a4986fb9bed$var$pSlice = Array.prototype.slice;

var $4P5TS = parcelRequire("4P5TS");


var $jmVod = parcelRequire("jmVod");

var $e0569a4986fb9bed$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $e0569a4986fb9bed$var$objEquiv(actual, expected, opts);
};
function $e0569a4986fb9bed$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $e0569a4986fb9bed$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $e0569a4986fb9bed$var$objEquiv(a, b, opts) {
    var i, key;
    if ($e0569a4986fb9bed$var$isUndefinedOrNull(a) || $e0569a4986fb9bed$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($jmVod(a)) {
        if (!$jmVod(b)) return false;
        a = $e0569a4986fb9bed$var$pSlice.call(a);
        b = $e0569a4986fb9bed$var$pSlice.call(b);
        return $e0569a4986fb9bed$var$deepEqual(a, b, opts);
    }
    if ($e0569a4986fb9bed$var$isBuffer(a)) {
        if (!$e0569a4986fb9bed$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $4P5TS(a), kb = $4P5TS(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$e0569a4986fb9bed$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("4P5TS", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("jmVod", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("1tBud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2mOOd = parcelRequire("2mOOd");


var $717N0 = parcelRequire("717N0");


const $4cc16dba49469f3f$var$MediaViewer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("03W5r")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
const $4cc16dba49469f3f$var$AsyncMediaViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
};
var $4cc16dba49469f3f$export$2e2bcd8739ae039 = $4cc16dba49469f3f$var$AsyncMediaViewer;
module.exports["default"] = $4cc16dba49469f3f$export$2e2bcd8739ae039;

});

parcelRegister("2mOOd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $imqjG = parcelRequire("imqjG");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6ffa2f80eb372db6$export$442b7be89436c101 = '#101214';
const $6ffa2f80eb372db6$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
            blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
        blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $6ffa2f80eb372db6$export$2e2bcd8739ae039 = $6ffa2f80eb372db6$var$ModalSpinner;
module.exports["default"] = $6ffa2f80eb372db6$export$2e2bcd8739ae039;

});

parcelRegister("imqjG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $knkYU = parcelRequire("knkYU");

const $75f640d6e866ba35$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
var $75f640d6e866ba35$export$2e2bcd8739ae039 = $75f640d6e866ba35$var$ModalSpinner;
module.exports["default"] = $75f640d6e866ba35$export$2e2bcd8739ae039;

});

parcelRegister("knkYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea0f137a8e557bc$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $1ea0f137a8e557bc$var$blanketStyles = null;
const $1ea0f137a8e557bc$var$spinnerStyles = null;
const $1ea0f137a8e557bc$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1ea0f137a8e557bc$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: blankedColor || $1ea0f137a8e557bc$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTondnbC _3OE6xYdnbC _0Bm75GdnbC _4ApkO2dnbC _42Yu6BEvR7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        appearance: invertSpinnerColor || $1ea0f137a8e557bc$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("717N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");

const $60b53ae22e9372b5$export$51aee4c01b17acde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $60b53ae22e9372b5$export$51aee4c01b17acde;

});

parcelRegister("03W5r", function(module, exports) {

let $00bd56be4630c929$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00bd56be4630c929$var$load("2Bp34"),
    $00bd56be4630c929$var$load("90vep"),
    $00bd56be4630c929$var$load("6OMo6"),
    $00bd56be4630c929$var$load("aaRXj"),
    $00bd56be4630c929$var$load("fHlIz"),
    $00bd56be4630c929$var$load("4QwAJ"),
    $00bd56be4630c929$var$load("3i44s"),
    $00bd56be4630c929$var$load("5kI0b"),
    $00bd56be4630c929$var$load("kYkz1"),
    $00bd56be4630c929$var$load("jfYeU"),
    $00bd56be4630c929$var$load("b4nm1"),
    $00bd56be4630c929$var$load("geXPZ"),
    $00bd56be4630c929$var$load("aQ5uu"),
    $00bd56be4630c929$var$load("6wr18"),
    $00bd56be4630c929$var$load("1xeJ3"),
    $00bd56be4630c929$var$load("60PUI"),
    $00bd56be4630c929$var$load("flY2n"),
    $00bd56be4630c929$var$load("fV46K"),
    $00bd56be4630c929$var$load("jOE2W"),
    $00bd56be4630c929$var$load("jTOhL"),
    $00bd56be4630c929$var$load("cuNBo"),
    $00bd56be4630c929$var$load("4Ldt2"),
    $00bd56be4630c929$var$load("2XRLb"),
    $00bd56be4630c929$var$load("gkVge"),
    $00bd56be4630c929$var$load("io0qR"),
    $00bd56be4630c929$var$load("3MJxZ"),
    $00bd56be4630c929$var$load("kHMR7"),
    $00bd56be4630c929$var$load("e3OZZ"),
    $00bd56be4630c929$var$load("cL682"),
    $00bd56be4630c929$var$load("4MePG"),
    $00bd56be4630c929$var$load("5JWJI"),
    $00bd56be4630c929$var$load("ffEVr"),
    $00bd56be4630c929$var$load("hhss7"),
    $00bd56be4630c929$var$load("4jXCC")
]).then(()=>parcelRequire('9vMzD'));

});

parcelRegister("fA65V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c226a72f375a9da1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    select_an_avatar_option: {
        id: "fabric.media.select_an_avatar_option",
        defaultMessage: "Default avatar option {number}"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $c226a72f375a9da1$export$defe85febe8b728c;

});

parcelRegister("c2smn", function(module, exports) {

var $adEwt = parcelRequire("adEwt");


var $hsnIS = parcelRequire("hsnIS");


var $iC5Q5 = parcelRequire("iC5Q5");

const $a3703bbade11fb84$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $a3703bbade11fb84$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hsnIS.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $adEwt.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $a3703bbade11fb84$export$836625761e76d373 = {
    mediaInline: false
};
function $a3703bbade11fb84$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iC5Q5.getGenericFeatureFlag)(flagName, $a3703bbade11fb84$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $a3703bbade11fb84$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $a3703bbade11fb84$export$383e8f51978266d;

});

parcelRegister("adEwt", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $55eb57bebd45f4d3$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $55eb57bebd45f4d3$export$2db74afa1ef496f1;

});

parcelRegister("hsnIS", function(module, exports) {
const $642951ddc1f8ae05$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $642951ddc1f8ae05$export$189fe120be7e73fc = ()=>$642951ddc1f8ae05$var$productKeys;
module.exports["getProductKeys"] = $642951ddc1f8ae05$export$189fe120be7e73fc;

});

parcelRegister("iC5Q5", function(module, exports) {

var $2hYl7 = parcelRequire("2hYl7");

function $cf2104adc10a7224$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $2hYl7.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $cf2104adc10a7224$export$f2687d0de19e4973;

});

parcelRegister("2hYl7", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $8ed9ff59a41a6857$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $8ed9ff59a41a6857$export$d125817a2695dbc9;

});

parcelRegister("czp8P", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $185ef2202d608231$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $185ef2202d608231$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $185ef2202d608231$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};
module.exports["hexToEditorBorderPaletteColor"] = $185ef2202d608231$export$bad3c41dd33cb4bc;

});

parcelRegister("1SZMn", function(module, exports) {
var $420fd782fb031b11$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $420fd782fb031b11$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});
module.exports["RESOLVE_METHOD"] = $420fd782fb031b11$export$ecd1fed429542b49;
module.exports["VIEW_METHOD"] = $420fd782fb031b11$export$9cf3651d97128b9c;

});

parcelRegister("294Sp", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eDtFr = parcelRequire("eDtFr");


var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $ImNkk = parcelRequire("ImNkk");

const $55b84b299399ca35$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $55b84b299399ca35$var$mediumBadgeStyles = (0, $buxP3.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $55b84b299399ca35$export$d5da84b0136a0cc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { status: t1, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = t0;
    const status = t1 === undefined ? "default" : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== intl) {
        t2 = intl.formatMessage((0, $ImNkk.commentMessages).viewCommentsOnMedia);
        $[0] = intl;
        $[1] = t2;
    } else t2 = $[1];
    const title = t2;
    let t3;
    bb0: switch(status){
        case "active":
            t3 = "color.background.accent.yellow.subtlest.pressed";
            break bb0;
        case "entered":
            t3 = "color.background.accent.yellow.subtlest.hovered";
            break bb0;
        default:
            t3 = "color.background.accent.yellow.subtlest";
    }
    const colourToken = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $55b84b299399ca35$var$baseStyles,
            $55b84b299399ca35$var$mediumBadgeStyles
        ];
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== title) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: title,
            spacing: "spacious",
            color: "currentColor"
        });
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== colourToken || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== onMouseLeave || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
            xcss: t4,
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: t5
        });
        $[5] = colourToken;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = onMouseLeave;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6 || $[12] !== title) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            position: "top",
            content: title,
            children: t6
        });
        $[11] = t6;
        $[12] = title;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $kSwu1.useIntl)();
    const title = intl.formatMessage((0, $ImNkk.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $cozmU.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $55b84b299399ca35$var$baseStyles,
                $55b84b299399ca35$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: title,
                spacing: "spacious",
                color: "currentColor"
            })
        })
    });
};
module.exports["CommentBadgeNext"] = $55b84b299399ca35$export$d5da84b0136a0cc4;

});

parcelRegister("ImNkk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a3dbe84aa3c3621f$export$4c0d145df60cfb04 = (0, $kSwu1.defineMessages)({
    addCommentOnMedia: {
        id: "fabric.editor.addCommentOnMedia",
        defaultMessage: "Add comment"
    },
    viewCommentsOnMedia: {
        id: "fabric.editor.viewCommentOnMedia",
        defaultMessage: "View comments"
    },
    viewAndAddCommentsOnMedia: {
        id: "fabric.editor.viewAndAddCommentsOnMedia",
        defaultMessage: "View and add comments"
    }
});
module.exports["commentMessages"] = $a3dbe84aa3c3621f$export$4c0d145df60cfb04;

});

parcelRegister("2G2MI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $gR535 = parcelRequire("gR535");

const $ccec193f181caf27$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com'
];
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS_NEW = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $ccec193f181caf27$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    if ((0, $ieeJu.expValEquals)('platform_editor_media_external_badge_bbc_fix', 'isEnabled', true)) return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS_NEW.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
    return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $ccec193f181caf27$export$66bf2ed7a5d4691f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, url: url } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    if (type !== "external" || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "external-image-badge"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== message) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: message
        });
        $[3] = message;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
            padding: "space.050",
            xcss: $ccec193f181caf27$var$baseStyles,
            tabIndex: 0,
            children: [
                t2,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: message,
                    position: "top",
                    children: t3
                })
            ]
        });
        $[5] = message;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ type: type, url: url })=>{
    const intl = (0, $kSwu1.useIntl)();
    const message = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
        padding: "space.050",
        xcss: $ccec193f181caf27$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: message
                })
            })
        ]
    });
};
module.exports["ExternalImageBadge"] = $ccec193f181caf27$export$66bf2ed7a5d4691f;

});

parcelRegister("gR535", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $211a5f48c385cec9$export$8e36294abfabe45e = (0, $kSwu1.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});
module.exports["externalMediaMessages"] = $211a5f48c385cec9$export$8e36294abfabe45e;

});

parcelRegister("7UxJ0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $a2c23c75d9cad129$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $a2c23c75d9cad129$var$hackedZIndexStyles = (0, $buxP3.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $a2c23c75d9cad129$var$resizeOffsetStyles = (0, $buxP3.xcss)({
    right: 'space.150'
});
const $a2c23c75d9cad129$var$getBadgeVisible = (width, height)=>{
    return width && width < $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $a2c23c75d9cad129$export$6a31fc38737d0e58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let { children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: t1 } = t0;
    const useMinimumZIndex = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== mediaHeight || $[1] !== mediaWidth) {
        t2 = $a2c23c75d9cad129$var$getBadgeVisible(mediaWidth, mediaHeight);
        $[0] = mediaHeight;
        $[1] = mediaWidth;
        $[2] = t2;
    } else t2 = $[2];
    const [visible, setVisible] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[3] !== mediaElement) {
        t3 = ()=>{
            const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
                const [entry] = entries;
                const { width: width, height: height } = entry.contentRect;
                setVisible($a2c23c75d9cad129$var$getBadgeVisible(width, height));
            }));
            if (mediaElement) observer.observe(mediaElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            mediaElement
        ];
        $[3] = mediaElement;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof children === "function") {
        let t5;
        if ($[6] !== children || $[7] !== visible) {
            t5 = children({
                visible: visible
            });
            $[6] = children;
            $[7] = visible;
            $[8] = t5;
        } else t5 = $[8];
        children = t5;
    }
    if (!(0, $iDrrr.fg)("media-perf-uplift-mutation-fix")) {
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    const t5 = useMinimumZIndex && $a2c23c75d9cad129$var$hackedZIndexStyles;
    const t6 = extendedResizeOffset && $a2c23c75d9cad129$var$resizeOffsetStyles;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = [
            $a2c23c75d9cad129$var$containerStyles,
            t5,
            t6
        ];
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            as: "div",
            testId: "media-badges",
            "data-media-badges": "true",
            contentEditable: false,
            xcss: t7,
            children: children
        });
        $[12] = children;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $cozmU.useState)($a2c23c75d9cad129$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($a2c23c75d9cad129$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $a2c23c75d9cad129$var$containerStyles,
            useMinimumZIndex && $a2c23c75d9cad129$var$hackedZIndexStyles,
            extendedResizeOffset && $a2c23c75d9cad129$var$resizeOffsetStyles
        ],
        children: children
    });
};
module.exports["MediaBadges"] = $a2c23c75d9cad129$export$6a31fc38737d0e58;

});

parcelRegister("8TTbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j3UOY = parcelRequire("j3UOY");


var $gWRZb = parcelRequire("gWRZb");

const $75428e9db26defa4$var$DURATION_MIN = 0.5;
const $75428e9db26defa4$var$DURATION_MAX = 1.0;
const $75428e9db26defa4$var$EXTRA_PADDING = 4;
const $75428e9db26defa4$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $75428e9db26defa4$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $75428e9db26defa4$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $75428e9db26defa4$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $75428e9db26defa4$var$DURATION_MAX - $75428e9db26defa4$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $75428e9db26defa4$var$DURATION_MAX), $75428e9db26defa4$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $75428e9db26defa4$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $75428e9db26defa4$var$EXTRA_PADDING) return newOffset - $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $75428e9db26defa4$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, $75428e9db26defa4$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($j3UOY)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$75428e9db26defa4$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $75428e9db26defa4$var$mapReactChildToReactNode(child, index) {
    const key = $75428e9db26defa4$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $75428e9db26defa4$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $75428e9db26defa4$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $75428e9db26defa4$export$817db220b90d8024;

});

parcelRegister("j3UOY", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $de0a5fa3d60c62bd$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$de0a5fa3d60c62bd$var$debounce.debounce = $de0a5fa3d60c62bd$var$debounce;
module.exports = $de0a5fa3d60c62bd$var$debounce;

});

parcelRegister("gWRZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXJyv = parcelRequire("jXJyv");

const $8dba4ca83cef8f6b$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
const $8dba4ca83cef8f6b$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
const $8dba4ca83cef8f6b$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
const $8dba4ca83cef8f6b$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
const $8dba4ca83cef8f6b$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
const $8dba4ca83cef8f6b$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
const $8dba4ca83cef8f6b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
module.exports["LeftArrow"] = $8dba4ca83cef8f6b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $8dba4ca83cef8f6b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $8dba4ca83cef8f6b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $8dba4ca83cef8f6b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $8dba4ca83cef8f6b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $8dba4ca83cef8f6b$export$54cfc70c184c0713;

});

parcelRegister("jXJyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $8TTbR = parcelRequire("8TTbR");

const $b735c99c0da4e1ae$var$filmStripViewStyles = null;
const $b735c99c0da4e1ae$var$filmStripListWrapperStyles = null;
const $b735c99c0da4e1ae$var$filmStripListStyles = null;
const $b735c99c0da4e1ae$var$filmStripListItemStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowLeftWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowRightWrapperStyles = null;
const $b735c99c0da4e1ae$var$shadowStyles = null;
const $b735c99c0da4e1ae$var$resetButtonStyle = null;
const $b735c99c0da4e1ae$var$shadowLeftStyles = null;
const $b735c99c0da4e1ae$var$shadowRightStyles = null;
const $b735c99c0da4e1ae$var$ShadowLeft = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHBXJV _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHBXJV _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHBXJV _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHBXJV _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $b735c99c0da4e1ae$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $b735c99c0da4e1ae$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ])
    }, children);
const $b735c99c0da4e1ae$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ])
    }, children));
const $b735c99c0da4e1ae$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ])
    }, children));
const $b735c99c0da4e1ae$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $b735c99c0da4e1ae$export$924abd21043fc000;
module.exports["ShadowRight"] = $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $b735c99c0da4e1ae$export$abf07652016c7e56;
module.exports["LeftArrow"] = $b735c99c0da4e1ae$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $b735c99c0da4e1ae$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $b735c99c0da4e1ae$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $b735c99c0da4e1ae$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $b735c99c0da4e1ae$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $b735c99c0da4e1ae$export$54cfc70c184c0713;

});

parcelRegister("3Uz4b", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gOi68 = parcelRequire("gOi68");


var $lNvN4 = parcelRequire("lNvN4");


var $4fGOw = parcelRequire("4fGOw");


var $kJaAu = parcelRequire("kJaAu");

const $d2b956a25eda15ad$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
const $d2b956a25eda15ad$export$f91c9e51e5ab027d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFileHashes(ids) {
    const $ = (0, $bDgLe.c)(15);
    const nonErrorFiles = (0, $4fGOw.useMediaStore)($d2b956a25eda15ad$var$_temp);
    const mediaClient = (0, $lNvN4.useMediaClient)();
    let t0;
    if ($[0] !== ids) {
        t0 = Object.fromEntries(ids.map($d2b956a25eda15ad$var$_temp2));
        $[0] = ids;
        $[1] = t0;
    } else t0 = $[1];
    const collections = t0;
    let t1;
    if ($[2] !== ids || $[3] !== nonErrorFiles) {
        let t2;
        if ($[5] !== ids) {
            t2 = (file)=>ids.some((t3)=>{
                    const { id: id_0 } = t3;
                    return file.id === id_0;
                });
            $[5] = ids;
            $[6] = t2;
        } else t2 = $[6];
        t1 = nonErrorFiles.filter(t2);
        $[2] = ids;
        $[3] = nonErrorFiles;
        $[4] = t1;
    } else t1 = $[4];
    const files = t1;
    const prevFiles = (0, $kJaAu.usePrevious)(files);
    let t2;
    let t3;
    if ($[7] !== collections || $[8] !== files || $[9] !== mediaClient || $[10] !== prevFiles) {
        t2 = ()=>{
            const prev = prevFiles ?? [];
            const addedOrChangedFiles = files.filter((file_0)=>file_0 && prev.every((prevFile)=>prevFile.id !== file_0.id || prevFile.status !== file_0.status));
            const potentialDuplicates = files.filter((file_1)=>addedOrChangedFiles.some((addedFile)=>$d2b956a25eda15ad$var$areFilesPotentiallyDuplicated(file_1, addedFile)));
            if (potentialDuplicates.length) [
                ...addedOrChangedFiles,
                ...potentialDuplicates
            ].forEach((file_2)=>{
                const collectionName_0 = collections[file_2.id];
                mediaClient.file.getFileState(file_2.id, {
                    collectionName: collectionName_0,
                    includeHashForDuplicateFiles: true,
                    forceRefresh: true
                });
            });
        };
        t3 = [
            files,
            prevFiles,
            mediaClient,
            collections
        ];
        $[7] = collections;
        $[8] = files;
        $[9] = mediaClient;
        $[10] = prevFiles;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[13] !== files) {
        t4 = Object.fromEntries(files.map($d2b956a25eda15ad$var$_temp3));
        $[13] = files;
        $[14] = t4;
    } else t4 = $[14];
    const hashMap = t4;
    return hashMap;
} : function useFileHashes(ids) {
    const nonErrorFiles = (0, $4fGOw.useMediaStore)((state)=>Object.values(state.files).filter((0, $gOi68.isNonErrorFinalFileState)));
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const collections = (0, $cozmU.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $cozmU.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id_0 })=>file.id === id_0)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $kJaAu.usePrevious)(files);
    (0, $cozmU.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file_0)=>file_0 && prev.every((prevFile)=>prevFile.id !== file_0.id || prevFile.status !== file_0.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file_1)=>addedOrChangedFiles.some((addedFile)=>$d2b956a25eda15ad$var$areFilesPotentiallyDuplicated(file_1, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file_2)=>{
            const collectionName_0 = collections[file_2.id];
            mediaClient.file.getFileState(file_2.id, {
                collectionName: collectionName_0,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $cozmU.useMemo)(()=>Object.fromEntries(files.map((file_3)=>[
                file_3.id,
                file_3.hash
            ])), [
        files
    ]);
    return hashMap;
};
function $d2b956a25eda15ad$var$_temp3(file_3) {
    return [
        file_3.id,
        file_3.hash
    ];
}
function $d2b956a25eda15ad$var$_temp2(t0) {
    const { id: id, collectionName: collectionName } = t0;
    return [
        id,
        collectionName
    ];
}
function $d2b956a25eda15ad$var$_temp(state) {
    return Object.values(state.files).filter((0, $gOi68.isNonErrorFinalFileState));
}
module.exports["useFileHashes"] = $d2b956a25eda15ad$export$f91c9e51e5ab027d;

});

parcelRegister("kJaAu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $2f894d46a9c73353$export$5cae361ad82dce8b(value) {
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $2f894d46a9c73353$export$5cae361ad82dce8b;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $eW61a = parcelRequire("eW61a");


var $lUcpS = parcelRequire("lUcpS");


var $1kejP = parcelRequire("1kejP");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)((0, $iDrrr.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $eW61a.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $iDrrr.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $iDrrr.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $eW61a.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $1kejP.AgentForbiddenError) && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        if (!((0, $iDrrr.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash'))) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creator.name, " ", creator.status === "inactive" && formatMessage((0, $fNIRw.messages).agentDeactivated))
            });
            if (creator.type === "REMOTE_A2A") {
                if ((0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
                return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                    creatorNameWithLink: creator.name
                });
            }
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t1 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = t1;
    } else t1 = $[4];
    const creatorRender = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes");
        $[5] = t2;
    } else t2 = $[5];
    const hideCreatorIcon = t2;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t3;
        if ($[6] !== creatorRender || $[7] !== showRovoIcon) {
            t3 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[6] = creatorRender;
            $[7] = showRovoIcon;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    let t3;
    if ($[9] !== creatorRender) {
        t3 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[9] = creatorRender;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $fNIRw.messages).agentDeactivated))
        });
        if (creator.type === 'REMOTE_A2A') {
            if ((0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
            return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
        } // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    pressableStarIcon: "_0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0jFU0VoWWg _39xV02oWWg",
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    if ((0, $iDrrr.fg)("rovo_agent_star_icon_button")) {
        const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
        let t3;
        if ($[0] !== t2) {
            t3 = (0, $w6R6I.cx)(t2);
            $[0] = t2;
            $[1] = t3;
        } else t3 = $[1];
        let t4;
        if ($[2] !== isHovered || $[3] !== isStarred) {
            t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                    ...iconProps,
                    color: "var(--ds-icon-accent-orange, #E06C00)"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                    ...iconProps,
                    color: "var(--ds-icon, #292A2E)"
                });
            $[2] = isHovered;
            $[3] = isStarred;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
        let t6;
        if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
            t6 = formatMessage(t5, {
                agentName: agentName
            });
            $[5] = agentName;
            $[6] = formatMessage;
            $[7] = t5;
            $[8] = t6;
        } else t6 = $[8];
        let t7;
        let t8;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = ()=>setIsHovered(true);
            t8 = ()=>setIsHovered(false);
            $[9] = t7;
            $[10] = t8;
        } else {
            t7 = $[9];
            t8 = $[10];
        }
        let t9;
        if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
            t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                appearance: "subtle",
                spacing: "compact",
                icon: t4,
                label: t6,
                onClick: handleToggle,
                onMouseEnter: t7,
                onMouseLeave: t8
            });
            $[11] = handleToggle;
            $[12] = t4;
            $[13] = t6;
            $[14] = t9;
        } else t9 = $[14];
        let t10;
        if ($[15] !== t3 || $[16] !== t9) {
            t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: t3
            }, t9);
            $[15] = t3;
            $[16] = t9;
            $[17] = t10;
        } else t10 = $[17];
        return t10;
    }
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[18] !== t2) {
        t3 = (0, $w6R6I.cx)($fbe2d7b3097e2d22$var$styles.pressableStarIcon, t2);
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    let t5;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHovered(true);
        t5 = ()=>setIsHovered(false);
        $[20] = t4;
        $[21] = t5;
    } else {
        t4 = $[20];
        t5 = $[21];
    }
    let t6;
    if ($[22] !== agentName || $[23] !== formatMessage || $[24] !== isHovered || $[25] !== isStarred) {
        t6 = isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
            spacing: "spacious",
            label: formatMessage((0, $4ssVW.default).removeFromFavouritesLabel, {
                agentName: agentName
            }),
            color: "var(--ds-icon-accent-orange, #E06C00)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
            spacing: "spacious",
            label: formatMessage((0, $4ssVW.default).clickToFavouriteLabel, {
                agentName: agentName
            }),
            color: "var(--ds-icon, #292A2E)"
        });
        $[22] = agentName;
        $[23] = formatMessage;
        $[24] = isHovered;
        $[25] = isStarred;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== handleToggle || $[28] !== t3 || $[29] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: t3,
            onClick: handleToggle,
            onMouseEnter: t4,
            onMouseLeave: t5
        }, t6);
        $[27] = handleToggle;
        $[28] = t3;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    if ((0, $iDrrr.fg)('rovo_agent_star_icon_button')) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($fbe2d7b3097e2d22$var$styles.pressableStarIcon, !visible && $fbe2d7b3097e2d22$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        spacing: "spacious",
        label: formatMessage((0, $4ssVW.default).removeFromFavouritesLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon-accent-orange, #E06C00)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
        spacing: "spacious",
        label: formatMessage((0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon, #292A2E)"
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("1kejP", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");


var $dRAjC = parcelRequire("dRAjC");


var $goaLH = parcelRequire("goaLH");


var $bTlNq = parcelRequire("bTlNq");


var $de4Mg = parcelRequire("de4Mg");


var $bCBEs = parcelRequire("bCBEs");

class $7eb6fbaa97f76140$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
const $7eb6fbaa97f76140$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountIdOld = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($identityAccountId: ID!, $cloudId: ID!) {
			agentStudio_agentByIdentityAccountId(identityAccountId: $identityAccountId, cloudId: $cloudId) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            identityAccountId: identityAccountId,
            cloudId: cloudId
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($id: ID!, $cloudId: String!) {
			agentStudio_agentByIdentityAccountId(cloudId: $cloudId, id: $id) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            id: identityAccountId.startsWith((0, $dRAjC.USER_ARI_PREFIX)) ? identityAccountId : `${0, $dRAjC.USER_ARI_PREFIX}${identityAccountId}`,
            cloudId: cloudId
        }
    });
const $7eb6fbaa97f76140$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $7eb6fbaa97f76140$export$2e2bcd8739ae039 extends (0, $goaLH.default) {
    basePath() {
        return '/gateway/api/assist/rovo/v1/agents';
    }
    sharedCacheKey(idValue) {
        return `${this.options.cloudId ?? ''}:${idValue}`;
    }
    getCachedProfile(idValue) {
        const key = this.sharedCacheKey(idValue);
        const cached = (0, $bCBEs.sharedAgentProfileCache).get(key);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            (0, $bCBEs.sharedAgentProfileCache).delete(key);
            return null;
        }
        return cached.profile;
    }
    setCachedProfile(idValue, profile) {
        (0, $bCBEs.sharedAgentProfileCache).set(this.sharedCacheKey(idValue), {
            expire: Date.now() + (this.config.cacheMaxAge || (0, $bCBEs.SHARED_CACHE_MAX_AGE)),
            profile: profile
        });
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', (0, $iDrrr.fg)('jira_ai_fix_agent_profile_card_flashing') ? $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId) : $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountIdOld(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analytics) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) throw new $7eb6fbaa97f76140$export$a6d78d75d03919f1();
            return response.json();
        });
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) throw new $7eb6fbaa97f76140$export$a6d78d75d03919f1();
            return response.json();
        });
        const aggStartTime = (0, $1GhPJ.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $bTlNq.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $1GhPJ.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
   * This function will call both REST and AGG endpoints to get the agent profile
   * There are some data that is only available in the AGG endpoint, so we need to call both
   * For any new fields, please only add them to the AGG endpoint
   *
   * @TODO migrate everything to AGG endpoint
   */ getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            this.makeRequest(id, analytics).then((data)=>{
                this.setCachedProfile(id.value, data);
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                this.syncFavouriteToCache(agentId, isFavourite);
                resolve();
            }).catch((error)=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    /**
   * Keeps the shared agent profile cache in sync with the favourite state
   */ syncFavouriteToCache(agentId, isFavourite) {
        const prefix = `${this.options.cloudId ?? ''}:`;
        const keysToUpdate = [];
        (0, $bCBEs.sharedAgentProfileCache).forEach((cached, key)=>{
            if (key.startsWith(prefix) && cached.profile?.restData?.id === agentId) keysToUpdate.push(key);
        });
        keysToUpdate.forEach((key)=>{
            const cached = (0, $bCBEs.sharedAgentProfileCache).get(key);
            if (!cached) return;
            const { restData: restData } = cached.profile;
            const wasFavourite = restData.favourite;
            const currentCount = restData.favourite_count ?? 0;
            const favouriteCount = isFavourite ? currentCount + (wasFavourite ? 0 : 1) : Math.max(0, currentCount - (wasFavourite ? 1 : 0));
            (0, $bCBEs.sharedAgentProfileCache).set(key, {
                ...cached,
                profile: {
                    ...cached.profile,
                    restData: {
                        ...restData,
                        favourite: isFavourite,
                        favourite_count: favouriteCount
                    }
                }
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["AgentForbiddenError"] = $7eb6fbaa97f76140$export$a6d78d75d03919f1;
module.exports["default"] = $7eb6fbaa97f76140$export$2e2bcd8739ae039;

});

parcelRegister("bTlNq", function(module, exports) {

var $44kjq = parcelRequire("44kjq");

const $ee2789e570b42c37$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $ee2789e570b42c37$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $ee2789e570b42c37$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $ee2789e570b42c37$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $44kjq.DirectoryGraphQLError)) return !!error && $ee2789e570b42c37$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $44kjq.AGGError)) return !!error.errorType && $ee2789e570b42c37$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $ee2789e570b42c37$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $ee2789e570b42c37$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null,
        errorStack: null
    };
    if (error instanceof (0, $44kjq.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($ee2789e570b42c37$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($ee2789e570b42c37$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $44kjq.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$ee2789e570b42c37$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $44kjq.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($ee2789e570b42c37$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($ee2789e570b42c37$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $44kjq.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$ee2789e570b42c37$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $44kjq.DirectoryGraphQLErrors) || causeError instanceof (0, $44kjq.AGGErrors)) return $ee2789e570b42c37$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $ee2789e570b42c37$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $44kjq.DirectoryGraphQLErrors)(errors, traceId);
};
const $ee2789e570b42c37$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $44kjq.AGGErrors)(errors, traceId);
};
module.exports["getErrorAttributes"] = $ee2789e570b42c37$export$6ad9e7706a4ee0f8;
module.exports["handleDirectoryGraphQLErrors"] = $ee2789e570b42c37$export$7642af465ceb7f05;
module.exports["handleAGGErrors"] = $ee2789e570b42c37$export$d9ad65d422ee3f8c;

});

parcelRegister("44kjq", function(module, exports) {
class $6e856ef94dca185e$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
class $6e856ef94dca185e$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = void 0;
        this.type = void 0;
        this.path = void 0;
        this.errorNumber = void 0;
        this.extensions = void 0;
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $6e856ef94dca185e$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $6e856ef94dca185e$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $6e856ef94dca185e$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = void 0;
        this.extensions = void 0;
        this.statusCode = void 0;
        this.errorType = void 0;
        this.classification = void 0;
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $6e856ef94dca185e$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $6e856ef94dca185e$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["HttpError"] = $6e856ef94dca185e$export$65bd6083489bd8bb;
module.exports["DirectoryGraphQLError"] = $6e856ef94dca185e$export$c1e4d0de940c06a2;
module.exports["DirectoryGraphQLErrors"] = $6e856ef94dca185e$export$5a5fbfed34a590a1;
module.exports["AGGError"] = $6e856ef94dca185e$export$4a696f048dcc929;
module.exports["AGGErrors"] = $6e856ef94dca185e$export$60d8267243755b9c;

});

parcelRegister("de4Mg", function(module, exports) {

var $44kjq = parcelRequire("44kjq");


var $bTlNq = parcelRequire("bTlNq");

const $c62bb02609d7d21d$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $c62bb02609d7d21d$var$id = (headers)=>headers;
async function $c62bb02609d7d21d$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id) {
    return $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bTlNq.handleDirectoryGraphQLErrors));
}
async function $c62bb02609d7d21d$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id) {
    return $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bTlNq.handleAGGErrors));
}
async function $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id, handleErrors) {
    const headers = processHeaders($c62bb02609d7d21d$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $44kjq.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}
module.exports["directoryGraphqlQuery"] = $c62bb02609d7d21d$export$a5b5995619d4fe36;
module.exports["AGGQuery"] = $c62bb02609d7d21d$export$a14afb5f82fe705;

});

parcelRegister("bCBEs", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

const $0e922c460acdfb54$var$SHARED_CACHE_SIZE = 50;
const $0e922c460acdfb54$export$815222107f6bee54 = 300000; // 5 minutes
const $0e922c460acdfb54$export$d0bf8b40238c05cd = new (0, $lPEt0.LRUMap)($0e922c460acdfb54$var$SHARED_CACHE_SIZE);
module.exports["SHARED_CACHE_MAX_AGE"] = $0e922c460acdfb54$export$815222107f6bee54;
module.exports["sharedAgentProfileCache"] = $0e922c460acdfb54$export$d0bf8b40238c05cd;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("5aWdo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $6TaGl = parcelRequire("6TaGl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lfoFx = parcelRequire("lfoFx");


var $l0Ey3 = parcelRequire("l0Ey3");


var $hu1eo = parcelRequire("hu1eo");


var $cPCog = parcelRequire("cPCog");

const $d73d415dd7b49fa6$var$styles = {
    chatToAgentButtonContainer: "_39xV02N91d",
    chatToAgentButtonWrapper: "_3iDTPbQ4SZ _37wbyuDIqT _1kk5Tkf7mX",
    chatPillButtonInline: "_2Y7lL4FQfX",
    chatPillText: "_3W2Oc8wPeg _2fwxA5ecOK _1ANEUSlpBW",
    chatPillIconWrapper: "_4ouGXISPN1 _0jFU0VSPN1"
};
const $d73d415dd7b49fa6$export$ffe1cf57f0b5db02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d73d415dd7b49fa6$var$styles.chatPillIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l0Ey3.ChatPillIcon), null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $cPCog.default).chatToAgentButton);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d73d415dd7b49fa6$var$styles.chatToAgentButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            xcss: $d73d415dd7b49fa6$var$styles.chatPillButtonInline
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d73d415dd7b49fa6$var$styles.chatPillText
        }, t2)));
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClick || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d73d415dd7b49fa6$var$styles.chatToAgentButtonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick
        }, t3));
        $[5] = onClick;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d73d415dd7b49fa6$var$styles.chatToAgentButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "view-agent-modal-chat-to-agent-button",
        shouldFitContainer: true,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d73d415dd7b49fa6$var$styles.chatToAgentButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: $d73d415dd7b49fa6$var$styles.chatPillButtonInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d73d415dd7b49fa6$var$styles.chatPillIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l0Ey3.ChatPillIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d73d415dd7b49fa6$var$styles.chatPillText
    }, formatMessage((0, $cPCog.default).chatToAgentButton))))));
};
const $d73d415dd7b49fa6$export$fc284fc0f7cc8f16 = ({ isAutodevTemplateAgent: isAutodevTemplateAgent, onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onDeleteAgent: onDeleteAgent, onViewAgentFullProfileClick: onViewAgentFullProfileClick, onOpenChange: onOpenChange, isForgeAgent: isForgeAgent, showDeleteOption: showDeleteOption = true, showViewAgentOption: showViewAgentOption = false, onViewAgentClick: onViewAgentClick, onDropdownTriggerClick: onDropdownTriggerClick, spacing: spacing, appearance: appearance, dropdownMenuTestId: dropdownMenuTestId, doesAgentHaveIdentityAccountId: doesAgentHaveIdentityAccountId, loadAgentPermissions: loadAgentPermissions, loadPermissionsOnMount: loadPermissionsOnMount, shouldTriggerStopPropagation: shouldTriggerStopPropagation, shouldRenderToParent: shouldRenderToParent, agentName: agentName, agentRef: agentRef, userPermissionsRef: userPermissionsRef, onVerificationSuccess: onVerificationSuccess, customDropdownOptions: customDropdownOptions })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isDuplicating, setIsDuplicating] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [hasBeenCopied, setHasBeenCopied] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [permissions, setPermissions] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            setIsLoading(true);
            const { isCreateEnabled: isCreateEnabled, isEditEnabled: isEditEnabled, isDeleteEnabled: isDeleteEnabled } = await loadAgentPermissions();
            setIsLoading(false);
            setPermissions({
                isCreateEnabled: isCreateEnabled,
                isEditEnabled: isEditEnabled,
                isDeleteEnabled: isDeleteEnabled
            });
        }; // Only load once
        if (!permissions && (isOpen || loadPermissionsOnMount)) fetchData();
    }, [
        isOpen,
        loadAgentPermissions,
        loadPermissionsOnMount,
        permissions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) setHasBeenCopied(false);
    }, [
        isOpen
    ]);
    const renderEditDelete = ()=>{
        if (!permissions?.isEditEnabled && !permissions?.isDeleteEnabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
            hasSeparator: true
        }, permissions.isEditEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: onEditAgent
        }, formatMessage((0, $cPCog.default).editAgent)), permissions.isDeleteEnabled && showDeleteOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: onDeleteAgent
        }, formatMessage((0, $cPCog.default).deleteAgent)));
    };
    const isCreateAgentsEnabled = permissions?.isCreateEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        shouldRenderToParent: shouldRenderToParent,
        isLoading: isLoading,
        isOpen: isOpen,
        testId: dropdownMenuTestId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: agentName ? formatMessage((0, $cPCog.default).moreActionsForLabel, {
                    agentName: agentName
                }) : formatMessage((0, $cPCog.default).moreActionsLabel),
                ref: triggerRef,
                spacing: spacing,
                appearance: appearance,
                onClick: (e, analyticsEvent)=>{
                    if (onDropdownTriggerClick) onDropdownTriggerClick(e, analyticsEvent);
                    if (shouldTriggerStopPropagation) e.stopPropagation();
                    props.onClick?.(e);
                }
            }),
        onOpenChange: (args)=>{
            setIsOpen(args.isOpen);
            onOpenChange?.(args);
            if (!args.isOpen) setHasBeenCopied(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, customDropdownOptions?.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: option.id,
            onClick: option.onClick
        }, option.label)), showViewAgentOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: onViewAgentClick
    }, formatMessage((0, $cPCog.default).viewAgent)), doesAgentHaveIdentityAccountId && onViewAgentFullProfileClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: onViewAgentFullProfileClick
    }, formatMessage((0, $cPCog.default).viewAgentFullProfile)), !isForgeAgent && isCreateAgentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: async (e_0)=>{
            if ((0, $iDrrr.fg)('rovo_agent_versioning_enabled')) e_0.stopPropagation();
            setIsDuplicating(true);
            try {
                await onDuplicateAgent?.(e_0);
            } finally{
                setIsDuplicating(false);
            }
        },
        isDisabled: isDuplicating
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, isDuplicating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }), isAutodevTemplateAgent ? formatMessage((0, $cPCog.default).useTemplateButton) : formatMessage((0, $cPCog.default).duplicateAgent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: (e_1)=>{
            e_1.stopPropagation();
            setHasBeenCopied(true);
            onCopyAgent?.(e_1);
        }
    }, formatMessage(hasBeenCopied ? (0, $cPCog.default).linkedCopiedToProfile : (0, $cPCog.default).copyLinkToProfile)), agentRef && userPermissionsRef && (0, $iDrrr.fg)('rovo_agents_agent_verification') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu1eo.AgentVerificationDropdownItem), {
        agentRef: agentRef ?? null,
        userPermissionsRef: userPermissionsRef ?? null,
        onVerificationSuccess: onVerificationSuccess,
        testId: "agent-actions-menu-verification"
    })), renderEditDelete());
};
module.exports["AgentDropdownMenu"] = $d73d415dd7b49fa6$export$fc284fc0f7cc8f16;

});

parcelRegister("cPCog", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b66d65717d5e251d$var$message = (0, $kSwu1.defineMessages)({
    chatToAgentButton: {
        id: "rovo-chat.view-agent.chat-to-agent-button",
        defaultMessage: "Chat to agent"
    },
    moreActionsLabel: {
        id: "rovo-chat.view-agent.more-actions-label",
        defaultMessage: "More actions"
    },
    moreActionsForLabel: {
        id: "rovo-chat.view-agent.more-actions-for-label",
        defaultMessage: "More actions for {agentName}"
    },
    duplicateAgent: {
        id: "rovo-chat.view-agent.duplicate-agent",
        defaultMessage: "Duplicate agent"
    },
    editAgent: {
        id: "rovo-chat.view-agent.edit-agent",
        defaultMessage: "Edit agent"
    },
    deleteAgent: {
        id: "rovo-chat.view-agent.delete-agent",
        defaultMessage: "Delete agent"
    },
    copyLinkToProfile: {
        id: "rovo-chat.view-agent.copy-link-to-profile",
        defaultMessage: "Copy link"
    },
    linkedCopiedToProfile: {
        id: "rovo-chat.view-agent.link-copied-to-profile",
        defaultMessage: "Copied URL"
    },
    viewAgent: {
        id: "rovo-chat.view-agents.view-agent",
        defaultMessage: "View agent"
    },
    viewAgentFullProfile: {
        id: "rovo-chat.view-agents.view-agent-full-profile",
        defaultMessage: "View full profile"
    },
    useTemplateButton: {
        id: "rovo-chat.view-agents.use-template-button",
        defaultMessage: "Use template"
    }
});
var $b66d65717d5e251d$export$2e2bcd8739ae039 = $b66d65717d5e251d$var$message;
module.exports["default"] = $b66d65717d5e251d$export$2e2bcd8739ae039;

});

parcelRegister("cSuwJ", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");

function $4a8c68f17b3fe31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a8c68f17b3fe31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    expandBodyAriaLabel: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    }
});
const $4a8c68f17b3fe31c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>expanded ? [
                $4a8c68f17b3fe31c$var$expandIconWrapperStyle(),
                $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle
            ] : $4a8c68f17b3fe31c$var$expandIconWrapperStyle()
    }, children);
};
const $4a8c68f17b3fe31c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`
        }
    });
const $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4a8c68f17b3fe31c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4a8c68f17b3fe31c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4a8c68f17b3fe31c$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $4a8c68f17b3fe31c$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $4a8c68f17b3fe31c$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $4a8c68f17b3fe31c$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $4a8c68f17b3fe31c$export$c67faf67c1185cba;

});

parcelRegister("7iIKP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $4nIKB = parcelRequire("4nIKB");


var $5wHqn = parcelRequire("5wHqn");


var $lfoFx = parcelRequire("lfoFx");


var $ghNlj = parcelRequire("ghNlj");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $f2FAo = parcelRequire("f2FAo");

const $2fb8d68051612d7a$var$emptyEntryPointParams = {};
const $2fb8d68051612d7a$var$emptyEntryPointProps = {};
const $2fb8d68051612d7a$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null));
};
function $2fb8d68051612d7a$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, preloadOnFocus: preloadOnFocus = true, ...popupProps }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const id = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [content, setContent] = (0, $cozmU.useState)(null);
    const updateRef = (0, $cozmU.useRef)(null);
    const handleOpen = (0, $cozmU.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $cozmU.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const triggerCloseRef = (0, $f2FAo.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $2fb8d68051612d7a$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fb8d68051612d7a$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $2fb8d68051612d7a$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4nIKB.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $cozmU.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
module.exports["PopupTrigger"] = $2fb8d68051612d7a$export$95d4acdbab2fc6ef;

});

parcelRegister("f2FAo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $c47b5f752a74b79b$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('click', clickListener);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}
module.exports["useClickToCloseRef"] = $c47b5f752a74b79b$export$46ec6629f411921d;

});

parcelRegister("c7GB4", function(module, exports) {

var $gsyiL = parcelRequire("gsyiL");

var $iOCEj = parcelRequire("iOCEj");

var $av9vJ = parcelRequire("av9vJ");

var $lEAnc = parcelRequire("lEAnc");

var $6B1vK = parcelRequire("6B1vK");

var $1lJ86 = parcelRequire("1lJ86");

var $cCPLV = parcelRequire("cCPLV");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $6B1vK.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $gsyiL.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $cCPLV.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iOCEj.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $av9vJ.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lEAnc.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1lJ86.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("1lJ86", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/slide/manifest.ts
var $0fbac26e81c45336$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $0fbac26e81c45336$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $0fbac26e81c45336$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("e6Ach", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3X3EV = parcelRequire("3X3EV");


var $iWhnp = parcelRequire("iWhnp");


var $2qYWP = parcelRequire("2qYWP");

const $bfdefd8cab144f9e$var$CreatableSelect = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const creatableProps = (0, $2qYWP.default)(props);
    const selectProps = (0, $iWhnp.default)(creatableProps);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3X3EV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfdefd8cab144f9e$export$2e2bcd8739ae039 = $bfdefd8cab144f9e$var$CreatableSelect;
module.exports["default"] = $bfdefd8cab144f9e$export$2e2bcd8739ae039;

});

parcelRegister("iWhnp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8107ecf375dbb21a$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJjSn = parcelRequire("bJjSn");


var $kskvm = parcelRequire("kskvm");


var $hNobR = parcelRequire("hNobR");


var $aeRIw = parcelRequire("aeRIw");

const $8107ecf375dbb21a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $8107ecf375dbb21a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$8107ecf375dbb21a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$8107ecf375dbb21a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $8107ecf375dbb21a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $8107ecf375dbb21a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $8107ecf375dbb21a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $8107ecf375dbb21a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $kskvm.getOptionValue), getOptionLabel: getOptionLabel = (0, $bJjSn.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $cozmU.useMemo)(()=>isValidNewOption(inputValue, (0, $hNobR.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $cozmU.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $cozmU.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $aeRIw.valueTernary)(isMulti, [
                    ...(0, $hNobR.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $kNIYN.Container) {
    constructor(props = {}){
        super();
        // Nav4 is fully rolled out; top nav height is always 48px unless FHS is enabled
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = 48;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("bdpeX", function(module, exports) {

var $54Kws = parcelRequire("54Kws");

class $88516670672fc955$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $54Kws.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $88516670672fc955$export$2e2bcd8739ae039;

});

parcelRegister("54Kws", function(module, exports) {
async function $4782fc034cf1736f$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $4782fc034cf1736f$export$60407594ea5edd1c;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("erHVE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $786700e92aa2b215$export$31b2b7ff910ba1f3 = new (0, $kCECX.PluginKey)('editorToolbarPluginKey');
module.exports["editorToolbarPluginKey"] = $786700e92aa2b215$export$31b2b7ff910ba1f3;

});

parcelRegister("faAj4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $54Cdh = parcelRequire("54Cdh");

class $c089dd5bc3bc2565$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c089dd5bc3bc2565$var$WithEditorActionsNew, this.props);
    }
    constructor(props){
        super(props);
    }
}
const $c089dd5bc3bc2565$var$WithEditorActionsNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WithEditorActionsNew(props) {
    const $ = (0, $bDgLe.c)(3);
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    const t0 = context?.editorActions;
    let t1;
    if ($[0] !== render || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c089dd5bc3bc2565$var$WithEditorActionsInner, {
            render: render,
            editorActions: t0
        });
        $[0] = render;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c089dd5bc3bc2565$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}; // Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c089dd5bc3bc2565$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $c089dd5bc3bc2565$export$2e2bcd8739ae039;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $29vMs = parcelRequire("29vMs");

var $cXLoX = parcelRequire("cXLoX");


var $5JhlM = parcelRequire("5JhlM");

var $bBIvl = parcelRequire("bBIvl");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");

var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $29vMs.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cXLoX = parcelRequire("cXLoX");


var $cAiYt = parcelRequire("cAiYt");

var $aIn0d = parcelRequire("aIn0d");

var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        size: "xxsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $91uAX = parcelRequire("91uAX");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("k9rxT", function(module, exports) {

var $eaCYh = parcelRequire("eaCYh");


var $2SUNK = parcelRequire("2SUNK");


var $bijHC = parcelRequire("bijHC");

class $f4cb6c0703060f5e$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $f4cb6c0703060f5e$export$7b4524ed61cc8203 extends (0, $bijHC.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $f4cb6c0703060f5e$var$PresenceResource extends $f4cb6c0703060f5e$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $eaCYh.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $f4cb6c0703060f5e$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $f4cb6c0703060f5e$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $f4cb6c0703060f5e$export$80bae4549cafd20d();
    }
}
class $f4cb6c0703060f5e$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $f4cb6c0703060f5e$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $f4cb6c0703060f5e$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $f4cb6c0703060f5e$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($f4cb6c0703060f5e$export$80bae4549cafd20d.isFocusState(presence)) return $f4cb6c0703060f5e$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$f4cb6c0703060f5e$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $f4cb6c0703060f5e$export$2e2bcd8739ae039 = $f4cb6c0703060f5e$var$PresenceResource;
module.exports["default"] = $f4cb6c0703060f5e$export$2e2bcd8739ae039;

});

parcelRegister("eaCYh", function(module, exports) {
function $669159666a118337$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $669159666a118337$export$9df8b8301f41e4b7;

});

parcelRegister("d8W41", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");

class $d0502b4ecdd37873$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $caelp.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $caelp.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $d0502b4ecdd37873$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $b3nqj.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $d0502b4ecdd37873$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $d0502b4ecdd37873$export$2ae0434dccdcb77e;

});

parcelRegister("80Dol", function(module, exports) {

var $bijHC = parcelRequire("bijHC");


var $b3nqj = parcelRequire("b3nqj");


var $caelp = parcelRequire("caelp");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");


var $gYPwD = parcelRequire("gYPwD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
/**
 * MAX_NOTIFIED_ITEMS in platform/packages/elements/mention/src/api/MentionResource.ts limits how many mentions returned by UserTeamMentionProvider will be used really! 20 is its value at the time of this writing.
 */ const $76cb501321125a14$var$MAX_RESULTS = 20;
/**
 * platform/packages/editor/editor-plugin-mentions/src/ui/type-ahead/index.tsx sections the mentions returned by UserTeamMentionProvider in agents and non-agents (such as people and teams).
 * But it also defines its own limit per section! 5 is its limit for agents at the time of this writing.
 * So to see both agents and people/non-agents in the sectioned UI, UserTeamMentionProvider needs to arrange enough of each section into the first MAX_RESULTS mentions it returns.
 */ const $76cb501321125a14$var$MIN_AGENT_RESULTS = 5;
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bijHC.MentionResource) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const [response, agentMentionsResult] = await Promise.all([
            this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier),
            this.includeAgents ? (0, $gYPwD.queryAgentMentions)(query, $76cb501321125a14$var$MAX_RESULTS).catch(()=>/* Do not let queryAgentMentions break the production-available people and teams search. */ ({
                    mentions: [],
                    query: query
                })) : undefined
        ]);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        let agentMentions = agentMentionsResult?.mentions ?? [];
        let nonAgentMentions = [
            ...mentions,
            ...jiraMentions
        ];
        if (agentMentions.length) {
            // Studio agent results should win if URS ever returns the same agent ID.
            const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
            nonAgentMentions = nonAgentMentions.filter((mention)=>!agentMentionIds.has(mention.id));
            agentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - nonAgentMentions.length));
        }
        return {
            query: query,
            mentions: [
                ...agentMentions,
                ...nonAgentMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
            userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("gYPwD", function(module, exports) {

var $gNfbp = parcelRequire("gNfbp");


var $eKwxR = parcelRequire("eKwxR");


var $kCDdC = parcelRequire("kCDdC");


var $as9lu = parcelRequire("as9lu");


var $c0rhi = parcelRequire("c0rhi");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $ge2sX = parcelRequire("ge2sX");

const $5016900c96a66750$var$PRODUCT = 'confluence';
async function $5016900c96a66750$export$edde3720d795ca12(query, maxResults) {
    let mentions;
    try {
        mentions = query ? await $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) : await $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
    return {
        query: query,
        mentions: mentions
    };
}
async function $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsByNameQuery,
        variables: {
            cloudId: cloudId,
            first: maxResults,
            input: {
                name: query
            },
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    return $5016900c96a66750$var$convertToMentions(data?.agentStudio_getAgents?.edges);
}
async function $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery,
        variables: {
            cloudId: cloudId,
            first: maxResults,
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    const mentions = [
        ...$5016900c96a66750$var$convertToMentions(data?.favoriteAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.verifiedAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.allAgents?.edges)
    ];
    // Only return the first distinct maxResults:
    const returnedMentionIds = new Set();
    return mentions.filter((mention)=>{
        if (returnedMentionIds.size >= maxResults || returnedMentionIds.has(mention.id)) return false;
        returnedMentionIds.add(mention.id);
        return true;
    });
}
function $5016900c96a66750$var$convertToMentions(edges) {
    return edges?.map((edge)=>edge.node).filter((agent)=>Boolean(agent?.identityAccountId && agent?.name)).map($5016900c96a66750$var$convertToMentionDescription) ?? [];
}
function $5016900c96a66750$var$convertToMentionDescription(agent) {
    return {
        appType: 'agent',
        avatarUrl: agent.identityAccount?.picture || undefined,
        id: $5016900c96a66750$export$8cac12d91c2ad785(agent.identityAccountId),
        mentionName: agent.name,
        name: agent.name,
        userType: 'APP'
    };
}
function $5016900c96a66750$export$8cac12d91c2ad785(identityAccountId) {
    try {
        return (0, $as9lu.IdentityUserAri).parse(identityAccountId).userId;
    } catch  {
        return identityAccountId;
    }
}
const $5016900c96a66750$export$ee0ef79a58e4aab4 = (0, $kCDdC.default);
const $5016900c96a66750$var$queryAgentMentionsByNameQuery = (0, $eKwxR.default);
const $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery = (0, $gNfbp.default);
module.exports["queryAgentMentions"] = $5016900c96a66750$export$edde3720d795ca12;

});

parcelRegister("gNfbp", function(module, exports) {
/**
 * @generated SignedSource<<62646a7a67913d3b81ca122dab9f1a24>>
 * @relayHash e042b93f5de90950eb91574cd22bbc7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a839b5d5d36aee005cb02ad4dffef740beacb567033ede1d076bf606d9e866e
const $23b05ae499fb93a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": true
            }
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                }
            ]
        }
    ], v10 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyVerifiedAgents": true
            }
        },
        v3 /*: any*/ 
    ], v11 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v12 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v6 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "alias": "verifiedAgents",
                    "args": v10 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v11 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v12 /*: any*/ 
                },
                {
                    "alias": "verifiedAgents",
                    "args": v10 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v12 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v11 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v12 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "e042b93f5de90950eb91574cd22bbc7c",
            "id": "5a839b5d5d36aee005cb02ad4dffef740beacb567033ede1d076bf606d9e866e",
            "metadata": {},
            "name": "queryAgentMentionsForInitialStateQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$product:String){favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$23b05ae499fb93a6$var$node.hash = "7b8fc7e0377ddfa0fae702a19385c8e8";
var $23b05ae499fb93a6$export$2e2bcd8739ae039 = $23b05ae499fb93a6$var$node;
module.exports["default"] = $23b05ae499fb93a6$export$2e2bcd8739ae039;

});

parcelRegister("eKwxR", function(module, exports) {
/**
 * @generated SignedSource<<ddff732f42b23263955e42feef99b630>>
 * @relayHash a096fec484fb7780e1230039602511ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a8903318134a696a2e78a720645757b43d86d173ef218da0699bc07fd25ee0ea
const $d9f9c84cb1e3d64f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a096fec484fb7780e1230039602511ba",
            "id": "a8903318134a696a2e78a720645757b43d86d173ef218da0699bc07fd25ee0ea",
            "metadata": {},
            "name": "queryAgentMentionsByNameQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsByNameQuery($cloudId:String!,$first:Int,$input:AgentStudioAgentQueryInput,$product:String){agentStudio_getAgents(cloudId:$cloudId,first:$first,input:$input,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$d9f9c84cb1e3d64f$var$node.hash = "f44bfcd4dfdb02102d0d5899552fd79b";
var $d9f9c84cb1e3d64f$export$2e2bcd8739ae039 = $d9f9c84cb1e3d64f$var$node;
module.exports["default"] = $d9f9c84cb1e3d64f$export$2e2bcd8739ae039;

});

parcelRegister("kCDdC", function(module, exports) {
/**
 * @generated SignedSource<<82f707f5e1900b63ef6d27065ff30e56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c4367f6180fde75$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "queryAgentMentionsFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "identityAccountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "AgentStudioAssistant"
};
$5c4367f6180fde75$var$node.hash = "e8b4ce6a6bbc22c76e7da2a2f720ab58";
var $5c4367f6180fde75$export$2e2bcd8739ae039 = $5c4367f6180fde75$var$node;
module.exports["default"] = $5c4367f6180fde75$export$2e2bcd8739ae039;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $3PNw6.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery,
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("8pCvZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $b4vCW = parcelRequire("b4vCW");

var $69Kfj = parcelRequire("69Kfj");


var $1wUTJ = parcelRequire("1wUTJ");


var $ecarE = parcelRequire("ecarE");


var $kBVpY = parcelRequire("kBVpY");

const $79f162dac5953229$var$messages = (0, $kSwu1.defineMessages)({
    create: {
        id: "link-create.jira-plugin-create-config",
        defaultMessage: "Create"
    }
});
const $79f162dac5953229$export$c0007b48d375a9ff = {
    tabConfig: {
        tabKey: 'jira',
        tabTitle: 'Jira'
    },
    products: [
        'jira'
    ],
    scope: (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter
};
const $79f162dac5953229$export$af1b31f68dc05ab3 = (formatMessage)=>({
        ...$79f162dac5953229$export$c0007b48d375a9ff,
        action: {
            label: formatMessage($79f162dac5953229$var$messages.create),
            callback: ()=>{
                console.log('Placeholder for Jira Create');
            }
        }
    });
const $79f162dac5953229$export$3fc43c5f39c4a529 = {
    tabConfig: {
        tabKey: 'confluence',
        tabTitle: 'Confluence'
    },
    products: [
        'confluence'
    ],
    scope: (0, $b4vCW.Scope).ConfluenceContentType
};
const $79f162dac5953229$export$547f1973f56da40b = {
    tabConfig: {
        tabKey: 'atlas',
        tabTitle: 'Atlas'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $b4vCW.Scope).TownsquareProject
};
const $79f162dac5953229$export$32f102fef46346 = {
    tabConfig: {
        tabKey: 'home',
        tabTitle: 'Home'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $b4vCW.Scope).TownsquareProject
};
const $79f162dac5953229$export$b1b5e4959b6adcf2 = {
    tabConfig: {
        tabKey: 'loom',
        tabTitle: 'Loom'
    },
    products: [
        'loom'
    ],
    scope: (0, $b4vCW.Scope).Loom,
    disableActivityClient: true
};
const $79f162dac5953229$var$currentProductToPluginMap = {
    jira: $79f162dac5953229$export$c0007b48d375a9ff,
    confluence: $79f162dac5953229$export$3fc43c5f39c4a529,
    atlas: $79f162dac5953229$export$547f1973f56da40b,
    loom: $79f162dac5953229$export$b1b5e4959b6adcf2,
    townsquare: $79f162dac5953229$export$32f102fef46346
};
const $79f162dac5953229$export$ede9abe489c9321b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $bDgLe.c)(33);
    let t0;
    if ($[0] !== config) {
        t0 = config ?? {};
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = t0;
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $kBVpY.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[2] !== config?.product) {
        t1 = config?.product?.toLowerCase();
        $[2] = config?.product;
        $[3] = t1;
    } else t1 = $[3];
    const currentProduct = t1;
    let t2;
    if ($[4] !== activityClientEndpoint || $[5] !== aggregatorUrl || $[6] !== cloudId) {
        t2 = (config_0)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config_0
            });
        $[4] = activityClientEndpoint;
        $[5] = aggregatorUrl;
        $[6] = cloudId;
        $[7] = t2;
    } else t2 = $[7];
    const createPluginConfig = t2;
    let t3;
    if ($[8] !== createPluginConfig || $[9] !== formatMessage) {
        t3 = createPluginConfig((0, $iDrrr.fg)("platform.linking-platform.link-picker.enable-jira-create") ? $79f162dac5953229$export$af1b31f68dc05ab3(formatMessage) : $79f162dac5953229$var$currentProductToPluginMap.jira);
        $[8] = createPluginConfig;
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[11] !== createPluginConfig) {
        t4 = createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.confluence);
        t5 = createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.atlas);
        t6 = createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.townsquare);
        t7 = createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.loom);
        $[11] = createPluginConfig;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else {
        t4 = $[12];
        t5 = $[13];
        t6 = $[14];
        t7 = $[15];
    }
    let t8;
    if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = {
            jira: t3,
            confluence: t4,
            atlas: t5,
            townsquare: t6,
            loom: t7
        };
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    const configMap = t8;
    let t9;
    if ($[22] !== availableProducts || $[23] !== configMap || $[24] !== currentProduct || $[25] !== isLoading) {
        const plugins = [];
        const isLoomBetaEnabled = (0, $cXtTj.default).checkGate("confluence_loom_beta_enabled");
        const isLoomM25Enabled = (0, $cXtTj.default).checkGate("confluence_frontend_loom_cross_sell");
        if (currentProduct && (0, $ecarE.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        let t10;
        if ($[27] !== currentProduct) {
            t10 = (product)=>currentProduct !== product;
            $[27] = currentProduct;
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== currentProduct) {
            t11 = (product_0)=>{
                if (currentProduct === "townsquare") return product_0 !== "atlas";
                return !!product_0;
            };
            $[29] = currentProduct;
            $[30] = t11;
        } else t11 = $[30];
        let t12;
        if ($[31] !== configMap) {
            t12 = (product_2)=>configMap[product_2];
            $[31] = configMap;
            $[32] = t12;
        } else t12 = $[32];
        t9 = {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $1wUTJ.supportedCurrentProducts).filter(t10).filter(t11).filter((product_1)=>product_1 === "loom" && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product_1 === (0, $ecarE.lookupCurrentProductByProduct)(availableProduct) && (product_1 !== "loom" || isLoomM25Enabled))).map(t12)
            ]
        };
        $[22] = availableProducts;
        $[23] = configMap;
        $[24] = currentProduct;
        $[25] = isLoading;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : (config)=>{
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = config ?? {};
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $kBVpY.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    /**
   * Lower case possible name of product. Should be `confluence` or `jira`.
   * This typing is not ideal. An unknown current product will:
   * - in the case of no 1P tabs enabled, default to Scope.ConfluencePageBlog scope
   * - in the case of 1P tabs enabled, not ensure the first tab is the current product
   */ const currentProduct = config?.product?.toLowerCase();
    const createPluginConfig = (0, $cozmU.useMemo)(()=>{
        return (config_0)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config_0
            });
    }, [
        cloudId,
        activityClientEndpoint,
        aggregatorUrl
    ]);
    const configMap = (0, $cozmU.useMemo)(()=>{
        return {
            jira: createPluginConfig((0, $iDrrr.fg)('platform.linking-platform.link-picker.enable-jira-create') ? $79f162dac5953229$export$af1b31f68dc05ab3(formatMessage) : $79f162dac5953229$var$currentProductToPluginMap.jira),
            confluence: createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.confluence),
            atlas: createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.atlas),
            townsquare: createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.townsquare),
            loom: createPluginConfig($79f162dac5953229$var$currentProductToPluginMap.loom)
        };
    }, [
        createPluginConfig,
        formatMessage
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const plugins = [];
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomBetaEnabled = (0, $cXtTj.default).checkGate('confluence_loom_beta_enabled');
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomM25Enabled = (0, $cXtTj.default).checkGate('confluence_frontend_loom_cross_sell');
        // Add plugin for current product as the first tab, if we have a supported tab for it
        // We are assuming that if a product is the current product and we have a supported tab, it's in available products
        // (eg. we assume if you're in Jira, Jira will be in available products)
        if (currentProduct && (0, $ecarE.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        return {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $1wUTJ.supportedCurrentProducts)// Exclude the current product, we've already included it above if theres a matching config available
                .filter((product)=>currentProduct !== product)// Exclude 'Atlas' tab is there is already a 'Home' tab
                .filter((product_0)=>{
                    if (currentProduct === 'townsquare') return product_0 !== 'atlas';
                    return !!product_0;
                })// Remove any products that did not appear in the list of availableProducts
                // Does not factor in the currentProduct, that will still be in the resulting array as it
                // has been included seperately above
                .filter((product_1)=>product_1 === 'loom' && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product_1 === (0, $ecarE.lookupCurrentProductByProduct)(availableProduct) && (product_1 !== 'loom' || isLoomM25Enabled)))// Map product strings to their defined config in the config map
                .map((product_2)=>configMap[product_2])
            ]
        };
    }, [
        configMap,
        availableProducts,
        currentProduct,
        isLoading
    ]);
};
const $79f162dac5953229$export$45a18a62e79260ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $bDgLe.c)(3);
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $79f162dac5953229$export$ede9abe489c9321b(config);
    const plugins = (0, $69Kfj.useAtlassianPlugins)(atlassianPluginsConfig);
    let t0;
    if ($[0] !== isLoading || $[1] !== plugins) {
        t0 = {
            plugins: plugins,
            isLoading: isLoading
        };
        $[0] = isLoading;
        $[1] = plugins;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (config)=>{
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $79f162dac5953229$export$ede9abe489c9321b(config);
    const plugins = (0, $69Kfj.useAtlassianPlugins)(atlassianPluginsConfig);
    return {
        plugins: plugins,
        isLoading: isLoading
    };
};
module.exports["useLinkPickerPlugins"] = $79f162dac5953229$export$45a18a62e79260ff;

});

parcelRegister("1wUTJ", function(module, exports) {
/**
 * Possible values for the current product. This is the order that tabs will appear in - though the first tab will always be the current product.
 * This is currently typed in LinkPickerPluginsConfiguration as `string` so this is used for checking tab order.
 * `atlas` is used as it's a public API.
 * This is also documented in the docstring for `product` in LinkPickerPluginsConfiguration.
 */ const $091f6a1b36ba2f4d$export$15d6fc53154f51b3 = [
    'loom',
    'jira',
    'confluence',
    'atlas',
    'townsquare'
];
module.exports["supportedCurrentProducts"] = $091f6a1b36ba2f4d$export$15d6fc53154f51b3;

});

parcelRegister("ecarE", function(module, exports) {

var $1wUTJ = parcelRequire("1wUTJ");

const $65efd3e3450a21b1$var$suportedCurrentProductMap = {
    'jira-core.ondemand': 'jira',
    'jira-incident-manager.ondemand': 'jira',
    'jira-product-discovery': 'jira',
    'jira-servicedesk.ondemand': 'jira',
    'jira-software.ondemand': 'jira',
    'confluence.ondemand': 'confluence',
    townsquare: 'atlas',
    loom: 'loom'
};
function $65efd3e3450a21b1$export$40cf7a2a01d13d9d(str) {
    const strings = (0, $1wUTJ.supportedCurrentProducts);
    return strings.includes(str);
}
function $65efd3e3450a21b1$export$7e250790d0036a52(product) {
    // Product may not be in supportedProducts array, that's what this is checking
    if (!(product in $65efd3e3450a21b1$var$suportedCurrentProductMap)) return undefined;
    return $65efd3e3450a21b1$var$suportedCurrentProductMap[product];
}
module.exports["isSupportedCurrentProduct"] = $65efd3e3450a21b1$export$40cf7a2a01d13d9d;
module.exports["lookupCurrentProductByProduct"] = $65efd3e3450a21b1$export$7e250790d0036a52;

});

parcelRegister("kBVpY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $itxfh = parcelRequire("itxfh");

const $43cf617c53ebfb58$export$5afbfe6edea8e998 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cloudId)=>{
    const $ = (0, $bDgLe.c)(9);
    const { data: data, loading: isLoading } = (0, $itxfh.useAvailableSites)();
    let t0;
    bb0: {
        if (!data.length) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [];
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        if (cloudId) {
            let t1;
            if ($[1] !== cloudId || $[2] !== data) {
                t1 = data.find((site)=>site.cloudId === cloudId)?.products ?? [];
                $[1] = cloudId;
                $[2] = data;
                $[3] = t1;
            } else t1 = $[3];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[4] !== data) {
            t1 = Array.from(data.reduce($43cf617c53ebfb58$var$_temp, new Set()));
            $[4] = data;
            $[5] = t1;
        } else t1 = $[5];
        t0 = t1;
    }
    let t1;
    if ($[6] !== isLoading || $[7] !== t0) {
        t1 = {
            availableProducts: t0,
            isLoading: isLoading
        };
        $[6] = isLoading;
        $[7] = t0;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : (cloudId)=>{
    const { data: data, loading: isLoading } = (0, $itxfh.useAvailableSites)();
    return {
        availableProducts: (0, $cozmU.useMemo)(()=>{
            if (!data.length) return [];
            if (cloudId) return data.find((site)=>site.cloudId === cloudId)?.products ?? [];
            // Get all the products from all sites and deduplicate
            return Array.from(data.reduce((prev, curr)=>{
                return new Set([
                    ...curr.products,
                    ...Array.from(prev)
                ]);
            }, new Set()));
        }, [
            data,
            cloudId
        ]),
        isLoading: isLoading
    };
};
function $43cf617c53ebfb58$var$_temp(prev, curr) {
    return new Set([
        ...curr.products,
        ...Array.from(prev)
    ]);
}
module.exports["useAvailableProducts"] = $43cf617c53ebfb58$export$5afbfe6edea8e998;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $hZpML = parcelRequire("hZpML");


var $8zKDl = parcelRequire("8zKDl");


var $cemw8 = parcelRequire("cemw8");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $cozmU.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
} : ()=>{
    return (0, $cozmU.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("1RQo0", function(module, exports) {

var $lyqUH = parcelRequire("lyqUH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/goal/manifest.ts
var $15c3607bf04229f4$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lyqUH.TownsquareGoalAriResourceOwner),
    resourceType: (0, $lyqUH.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $15c3607bf04229f4$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $15c3607bf04229f4$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $15c3607bf04229f4$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $15c3607bf04229f4$export$e45ea1bd9a289a4f;

});

parcelRegister("lyqUH", function(module, exports) {
// src/townsquare/goal/types.ts
var $fb11a66b9944d017$export$947838268868cc57 = "townsquare", $fb11a66b9944d017$export$935b9c2af9d62e80 = "goal";
module.exports["TownsquareGoalAriResourceOwner"] = $fb11a66b9944d017$export$947838268868cc57;
module.exports["TownsquareGoalAriResourceType"] = $fb11a66b9944d017$export$935b9c2af9d62e80;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("8OpiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0025fd3bfdd51ff0ae263d95eeebc788>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66a69eb8c574d02b$var$_react = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $66a69eb8c574d02b$var$_baseNew = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $66a69eb8c574d02b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object
 * Usage guidance:
 * Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66a69eb8c574d02b$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $66a69eb8c574d02b$var$_react.default.createElement($66a69eb8c574d02b$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$66a69eb8c574d02b$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $66a69eb8c574d02b$var$_default = module.exports.default = $66a69eb8c574d02b$var$AssetsObjectIcon;

});

parcelRegister("fvoKJ", function(module, exports) {

var $8Yift = parcelRequire("8Yift");

const $e160175aa6804997$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $8Yift.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $e160175aa6804997$export$792aeacb7990bc6;

});

parcelRegister("8Yift", function(module, exports) {

var $4Yksf = parcelRequire("4Yksf");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/site/manifest.ts
var $6882151697c9008c$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4Yksf.TownsquareSiteAriResourceOwner),
    resourceType: (0, $4Yksf.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $6882151697c9008c$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6882151697c9008c$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $6882151697c9008c$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6882151697c9008c$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $6882151697c9008c$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $6882151697c9008c$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $6882151697c9008c$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $6882151697c9008c$export$87ae3de5f1f7725a;

});

parcelRegister("4Yksf", function(module, exports) {
// src/townsquare/site/types.ts
var $39eca1dd131685dd$export$9ee8c46ef1f3e6a8 = "townsquare", $39eca1dd131685dd$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $39eca1dd131685dd$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $39eca1dd131685dd$export$44737bde24f3bac1;

});

parcelRegister("4slsU", function(module, exports) {

var $1RQo0 = parcelRequire("1RQo0");

var $aLUFu = parcelRequire("aLUFu");

var $8Yift = parcelRequire("8Yift");

function $4caae11b2ff1f088$export$3ae2d1e732b25194(entity, ari) {
    try {
        if (entity === 'goal') return (0, $1RQo0.TownsquareGoalAri).parse(ari).siteId;
        if (entity === 'project') return (0, $aLUFu.TownsquareProjectAri).parse(ari).siteId;
        if (entity === 'site') return (0, $8Yift.TownsquareSiteAri).parse(ari).siteId;
    } catch (error) {
        //TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492
        //We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
        if (entity === 'goal' || entity === 'project') return ari.split(':')[3] ?? '';
    }
    return '';
}
module.exports["getSiteId"] = $4caae11b2ff1f088$export$3ae2d1e732b25194;

});

parcelRegister("fxpAO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $l0Ey3 = parcelRequire("l0Ey3");


var $5aWdo = parcelRequire("5aWdo");


var $awacD = parcelRequire("awacD");


var $7EVHO = parcelRequire("7EVHO");

const $899bf2ea456708ee$var$styles = {
    chatToAgentButtonContainer: "_39xV02N91d",
    chatPillButtonInline: "_2Y7lL4FQfX",
    chatPillText: "_3W2Oc8wPeg _2fwxA5ecOK _1ANEUSlpBW",
    chatPillIconWrapper: "_4ouGXISPN1 _0jFU0VSPN1",
    chatToAgentButtonWrapper: "_3iDTPbQ4SZ _37wbyuDIqT _1kk5Tkf7mX"
};
const $899bf2ea456708ee$export$ffe1cf57f0b5db02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $899bf2ea456708ee$var$styles.chatPillIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l0Ey3.ChatPillIcon), null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $7EVHO.default).chatToAgentButton);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $899bf2ea456708ee$var$styles.chatToAgentButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            xcss: $899bf2ea456708ee$var$styles.chatPillButtonInline
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $899bf2ea456708ee$var$styles.chatPillText
        }, t2)));
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClick || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $899bf2ea456708ee$var$styles.chatToAgentButtonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick
        }, t3));
        $[5] = onClick;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $899bf2ea456708ee$var$styles.chatToAgentButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "view-agent-modal-chat-to-agent-button",
        shouldFitContainer: true,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $899bf2ea456708ee$var$styles.chatToAgentButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: $899bf2ea456708ee$var$styles.chatPillButtonInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $899bf2ea456708ee$var$styles.chatPillIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l0Ey3.ChatPillIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $899bf2ea456708ee$var$styles.chatPillText
    }, formatMessage((0, $7EVHO.default).chatToAgentButton))))));
};
const $899bf2ea456708ee$export$fc284fc0f7cc8f16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    let assistanceServiceParams;
    let baseProps;
    if ($[0] !== props) {
        ({ assistanceServiceParams: assistanceServiceParams, ...baseProps } = props);
        $[0] = props;
        $[1] = assistanceServiceParams;
        $[2] = baseProps;
    } else {
        assistanceServiceParams = $[1];
        baseProps = $[2];
    }
    let t0;
    if ($[3] !== assistanceServiceParams || $[4] !== props.agentId) {
        t0 = {
            agentId: props.agentId,
            enabled: false,
            assistanceServiceParams: assistanceServiceParams
        };
        $[3] = assistanceServiceParams;
        $[4] = props.agentId;
        $[5] = t0;
    } else t0 = $[5];
    const { refetch: refetch } = (0, $awacD.useAgentPermissions)(t0);
    let t1;
    if ($[6] !== refetch) {
        t1 = async ()=>{
            const response = await refetch();
            return {
                isCreateEnabled: response?.permissions.AGENT_CREATE?.permitted ?? false,
                isEditEnabled: response?.permissions.AGENT_UPDATE?.permitted ?? false,
                isDeleteEnabled: response?.permissions.AGENT_DEACTIVATE?.permitted ?? false
            };
        };
        $[6] = refetch;
        $[7] = t1;
    } else t1 = $[7];
    const loadAgentPermissions = t1;
    const t2 = baseProps;
    let t3;
    if ($[8] !== loadAgentPermissions || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5aWdo.AgentDropdownMenu), {
            ...t2,
            loadAgentPermissions: loadAgentPermissions
        });
        $[8] = loadAgentPermissions;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (props)=>{
    const { assistanceServiceParams: assistanceServiceParams, ...baseProps } = props;
    const { refetch: refetch } = (0, $awacD.useAgentPermissions)({
        agentId: props.agentId,
        enabled: false,
        assistanceServiceParams: assistanceServiceParams
    });
    const loadAgentPermissions = (0, $cozmU.useCallback)(async ()=>{
        const response = await refetch();
        return {
            isCreateEnabled: response?.permissions.AGENT_CREATE?.permitted ?? false,
            isEditEnabled: response?.permissions.AGENT_UPDATE?.permitted ?? false,
            isDeleteEnabled: response?.permissions.AGENT_DEACTIVATE?.permitted ?? false
        };
    }, [
        refetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5aWdo.AgentDropdownMenu // We need to typecast back to the base type because using `Omit` doesn't preserve discriminated unions, causing type errors
    ), {
        ...baseProps,
        loadAgentPermissions: loadAgentPermissions
    });
};
module.exports["ChatToAgentButton"] = $899bf2ea456708ee$export$ffe1cf57f0b5db02;
module.exports["AgentDropdownMenu"] = $899bf2ea456708ee$export$fc284fc0f7cc8f16;

});

parcelRegister("7EVHO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ab136ba628745c71$var$message = (0, $kSwu1.defineMessages)({
    chatToAgentButton: {
        id: "rovo-chat.view-agent.chat-to-agent-button",
        defaultMessage: "Chat to agent"
    }
});
var $ab136ba628745c71$export$2e2bcd8739ae039 = $ab136ba628745c71$var$message;
module.exports["default"] = $ab136ba628745c71$export$2e2bcd8739ae039;

});

parcelRegister("5pkPF", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cgTkH = parcelRequire("cgTkH");



var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $amotT = parcelRequire("amotT");



var $hA0li = parcelRequire("hA0li");


var $eoR7w = parcelRequire("eoR7w");

var $3eff726f85d07655$export$bb38bb9a1161268 = 'unmounted';
var $3eff726f85d07655$export$84cbff306f539230 = 'exited';
var $3eff726f85d07655$export$df38205c966be359 = 'entering';
var $3eff726f85d07655$export$78e9e6e3e014d60a = 'entered';
var $3eff726f85d07655$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3eff726f85d07655$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3eff726f85d07655$export$84cbff306f539230;
                _this.appearStatus = $3eff726f85d07655$export$df38205c966be359;
            } else initialStatus = $3eff726f85d07655$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3eff726f85d07655$export$bb38bb9a1161268;
        else initialStatus = $3eff726f85d07655$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3eff726f85d07655$export$bb38bb9a1161268) return {
            status: $3eff726f85d07655$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3eff726f85d07655$export$df38205c966be359 && status !== $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$df38205c966be359;
            } else if (status === $3eff726f85d07655$export$df38205c966be359 || status === $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3eff726f85d07655$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $eoR7w.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3eff726f85d07655$export$84cbff306f539230) this.setState({
            status: $3eff726f85d07655$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3eff726f85d07655$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3eff726f85d07655$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3eff726f85d07655$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3eff726f85d07655$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3eff726f85d07655$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1eVGO.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hA0li.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
$3eff726f85d07655$var$Transition.contextType = (0, $hA0li.default);
$3eff726f85d07655$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3eff726f85d07655$var$noop() {}
$3eff726f85d07655$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3eff726f85d07655$var$noop,
    onEntering: $3eff726f85d07655$var$noop,
    onEntered: $3eff726f85d07655$var$noop,
    onExit: $3eff726f85d07655$var$noop,
    onExiting: $3eff726f85d07655$var$noop,
    onExited: $3eff726f85d07655$var$noop
};
$3eff726f85d07655$var$Transition.UNMOUNTED = $3eff726f85d07655$export$bb38bb9a1161268;
$3eff726f85d07655$var$Transition.EXITED = $3eff726f85d07655$export$84cbff306f539230;
$3eff726f85d07655$var$Transition.ENTERING = $3eff726f85d07655$export$df38205c966be359;
$3eff726f85d07655$var$Transition.ENTERED = $3eff726f85d07655$export$78e9e6e3e014d60a;
$3eff726f85d07655$var$Transition.EXITING = $3eff726f85d07655$export$4aacc83d4d59139f;
var $3eff726f85d07655$export$2e2bcd8739ae039 = $3eff726f85d07655$var$Transition;
module.exports["default"] = $3eff726f85d07655$export$2e2bcd8739ae039;

});

parcelRegister("amotT", function(module, exports) {
$parcel$export(module.exports, "default", () => $78aef2ed8b5cba44$export$2e2bcd8739ae039);
var $78aef2ed8b5cba44$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("hA0li", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccc6107deb85fdd7$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var $ccc6107deb85fdd7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);

});

parcelRegister("eoR7w", function(module, exports) {
var $a7bc833148928009$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $a7bc833148928009$export$7d26bbb1236dafd6;

});

parcelRegister("6e6HL", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1HhPq = parcelRequire("1HhPq");

const $788ef638343efbc9$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $788ef638343efbc9$export$d109ab46c9575565;

});

parcelRegister("fDAOo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6270d9b7fedaa79$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $58FyF = parcelRequire("58FyF");


var $3yGK6 = parcelRequire("3yGK6");

function $b6270d9b7fedaa79$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $58FyF.default)(dirtyDate, amount * 12);
}

});

parcelRegister("8HKXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $hJozw = parcelRequire("hJozw");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $6566c3e8a339288d$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $hJozw.default),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6566c3e8a339288d$export$2e2bcd8739ae039 = $6566c3e8a339288d$var$locale;
module.exports["default"] = $6566c3e8a339288d$export$2e2bcd8739ae039;

});

parcelRegister("hJozw", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $ce89b3180b428a97$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $ce89b3180b428a97$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ce89b3180b428a97$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ce89b3180b428a97$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ce89b3180b428a97$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ce89b3180b428a97$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ce89b3180b428a97$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ce89b3180b428a97$export$2e2bcd8739ae039 = $ce89b3180b428a97$var$formatLong;
module.exports["default"] = $ce89b3180b428a97$export$2e2bcd8739ae039;

});

parcelRegister("3sXr4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE = '--gradient-angle';
const $f685837601709ec0$var$BORDER_ORANGE = "var(--ds-rovo-border-saffron, #FCA700)";
const $f685837601709ec0$var$BORDER_GREEN = "var(--ds-rovo-border-lime, #6A9A23)";
const $f685837601709ec0$var$BORDER_BLUE = "var(--ds-rovo-border-blue, #1868DB)";
const $f685837601709ec0$var$BORDER_PURPLE = "var(--ds-rovo-border-purple, #AF59E1)"; /**
                                                                * Because the aspect ratio of the actual thinking bars is very wide,
                                                                * the gradient will stretch out at each corner which would make the
                                                                * rovo colours very disproportionate.
                                                                *
                                                                * To workaround this we use a dynamic angle amplitude to narrow the angles as we approach
                                                                * 90 and 180 degrees, and we have a general aspect ratio of the expected design as
                                                                * it's not worth calculating the width and height of the actual components.
                                                                *
                                                                * Approximating the minimum edge span as inversely proportional to the expected
                                                                * wrapper aspect ratio.
                                                                *
                                                                * 360 / 48 is the approximated aspect ratio.
                                                                */ 
const $f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN = `2 * atan(1 / (360 / 48))`; /**
                                                             * Squared cosine produces a symmetric 0..1 signal based on rotation angle:
                                                             * 0 at top/bottom, 1 at left/right, which tells us how close the highlight is
                                                             * to the side edges.
                                                             */ 
const $f685837601709ec0$var$DEFAULT_SIDE_WEIGHT = `calc(cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)) * cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)))`; /**
                                                                                                                                * Interpolates the highlight span between the minimum side-edge span and a
                                                                                                                                * wider 90deg span, with amplitude scaling and side weighting for earlier/
                                                                                                                                * longer narrowing near the left and right edges.
                                                                                                                                */ 
const $f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN = `calc(${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN} + ((90deg - ${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN})  * ${$f685837601709ec0$var$DEFAULT_SIDE_WEIGHT}))`; // Conic gradient that drives both the visible border and blurred glow.
const $f685837601709ec0$var$ROVO_MOSAIC_GRADIENT_BACKGROUND = `conic-gradient(
	from calc(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg) - (${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} / 2)) at 50% 50%,
	${$f685837601709ec0$var$BORDER_ORANGE} 0deg ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN},
	${$f685837601709ec0$var$BORDER_GREEN} ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} 180deg,
	${$f685837601709ec0$var$BORDER_BLUE} 180deg calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}),
	${$f685837601709ec0$var$BORDER_PURPLE} calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}) 360deg
)`; // Rotate the custom angle property so the highlight continuously sweeps around the border.
const $f685837601709ec0$var$gradientRotation = null; // @property is required so the browser knows --gradient-angle is an interpolatable
// <angle> — without it, keyframe animation of a custom property has no effect.
const $f685837601709ec0$var$gradientAngleProperty = null;
const $f685837601709ec0$var$BLUR_SIZE = 32;
const $f685837601709ec0$var$BORDER_WIDTH = 1; // Outer position context for the decorative glow and border layers.
const $f685837601709ec0$var$wrapperBaseStyle = null; // Thinking shell uses pseudo-elements for the blurred glow and rotating gradient border.
const $f685837601709ec0$var$thinkingWrapperStyle = null;
const $f685837601709ec0$var$plainBorderStyle = null; // Shared layout/padding base for the actual content area so children can stay mounted
// while the surrounding thinking chrome changes.
const $f685837601709ec0$var$contentBaseStyle = null;
const $f685837601709ec0$export$f2f0a5c9bccb33b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isThinking: isThinking } = t0;
    const t1 = isThinking ? "rovo-thinking-bar-wrapper__thinking" : "rovo-thinking-bar-wrapper__idle";
    const t2 = isThinking && "";
    const t3 = isThinking && "";
    const t4 = isThinking && "";
    const t5 = isThinking && "_0bjKvDyzSk _4c065UHZdu _2Y7lL4HZdu _1mT5xdRAKS _39xV02N91d _2YgrGrP0S5 _1OimfudRhP _4eDJc6P4qp _2OUbymKNkB _3Ku51Iogpp _3dCYwDWVPG _3ScelFGJbM _1lBcDcGJbM _35I30Bey7F _1L3m71ey7F _3fRV4CV6HZ _0UsFEzYbGa _3qT6l0vQQr _0EnhYgdnbC _2Gfj6idRhP _2OWEWsP4qp _0h8XtNKNkB _0GBAIrogpp _2WYcYGWVPG _2tbAUcYbGa _39mJBjvQQr _32JO6cYbGa _2AwNtJYbGa";
    const t6 = !isThinking && "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _4c065UHZdu _2Y7lL4HZdu _39xV02N91d _0KLXruoI2d _2OUyjtGk8v";
    let t7;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6) {
        t7 = (0, $hekY6.default)([
            "_0bjKvDyzSk _1mT5xdRAKS _39xV02N91d",
            t2,
            t3,
            t4,
            t5,
            t6
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_0bjKvDyzSk _2Y7lL42ADO _4c065U2ADO _39xV02N91d _1mT5xdRAKS _42Yu6BdnbC _0KLXruoI2d _24h04i2Njc"
        ]);
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== children) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, children);
        $[7] = children;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t1 || $[10] !== t7 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t1,
            className: t7
        }, t9);
        $[9] = t1;
        $[10] = t7;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    return t10;
} : ({ children: children, isThinking: isThinking })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": isThinking ? 'rovo-thinking-bar-wrapper__thinking' : 'rovo-thinking-bar-wrapper__idle',
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _1mT5xdRAKS _39xV02N91d",
            isThinking && "",
            isThinking && "",
            isThinking && "",
            isThinking && "_0bjKvDyzSk _4c065UHZdu _2Y7lL4HZdu _1mT5xdRAKS _39xV02N91d _2YgrGrP0S5 _1OimfudRhP _4eDJc6P4qp _2OUbymKNkB _3Ku51Iogpp _3dCYwDWVPG _3ScelFGJbM _1lBcDcGJbM _35I30Bey7F _1L3m71ey7F _3fRV4CV6HZ _0UsFEzYbGa _3qT6l0vQQr _0EnhYgdnbC _2Gfj6idRhP _2OWEWsP4qp _0h8XtNKNkB _0GBAIrogpp _2WYcYGWVPG _2tbAUcYbGa _39mJBjvQQr _32JO6cYbGa _2AwNtJYbGa",
            !isThinking && "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _4c065UHZdu _2Y7lL4HZdu _39xV02N91d _0KLXruoI2d _2OUyjtGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _2Y7lL42ADO _4c065U2ADO _39xV02N91d _1mT5xdRAKS _42Yu6BdnbC _0KLXruoI2d _24h04i2Njc"
        ])
    }, children));
};
module.exports["RovoThinkingBarWrapper"] = $f685837601709ec0$export$f2f0a5c9bccb33b1;

});

parcelRegister("02Wb7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $353693fd10aa5589$var$message = (0, $kSwu1.defineMessages)({
    followAiMateButton: {
        id: "ai-mate.inline-chat-input.follow-button.label",
        defaultMessage: "Follow"
    },
    stopGeneratingButtonLabel: {
        id: "ai-mate.inline-chat-input.stop-generating-button.label",
        defaultMessage: "Stop generating"
    },
    thinkingText: {
        id: "ai-mate.inline-chat-input.thinking",
        defaultMessage: "Rovo is analyzing"
    },
    thinkingTextShort: {
        id: "ai-mate.inline-chat-input.thinking.short",
        defaultMessage: "Analyzing"
    },
    editingText: {
        id: "ai-mate.inline-chat-input.editing",
        defaultMessage: "Rovo is editing"
    },
    editingTextShort: {
        id: "ai-mate.inline-chat-input.editing.short",
        defaultMessage: "Editing"
    },
    thinkingReadyMessage: {
        id: "ai-mate.thinking-bar.ready.message",
        defaultMessage: "Your edits are ready"
    },
    thinkingReadyClose: {
        id: "ai-mate.thinking-bar.ready.close",
        defaultMessage: "Close"
    },
    thinkingReadyView: {
        id: "ai-mate.thinking-bar.ready.view",
        defaultMessage: "View"
    }
});
var $353693fd10aa5589$export$2e2bcd8739ae039 = $353693fd10aa5589$var$message;
module.exports["default"] = $353693fd10aa5589$export$2e2bcd8739ae039;

});

parcelRegister("kb1I3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $1pTZX = parcelRequire("1pTZX");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $1kxki = parcelRequire("1kxki");


var $2diYd = parcelRequire("2diYd");


var $02Wb7 = parcelRequire("02Wb7");


var $7VOWp = parcelRequire("7VOWp");

const $6437c80744d7a710$var$ROTATION_INTERVAL_MS = 4000;
const $6437c80744d7a710$var$rotatingMessages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "ai-mate.inline-chat-input.thinking.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "ai-mate.inline-chat-input.thinking.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.structuring-response",
        defaultMessage: "Structuring your response"
    },
    designingResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.designing-response",
        defaultMessage: "Designing your response"
    },
    addingItAllTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "ai-mate.inline-chat-input.thinking.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "ai-mate.inline-chat-input.thinking.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
/**
 * Cycles through `texts` at a fixed interval, stopping on the last item.
 *
 * When `startedAt` (epoch ms) is provided, the current index is derived from the
 * elapsed time since that shared anchor, so multiple instances driven by the same
 * session show the same message and stay in sync across mount/unmount. When
 * omitted, rotation is anchored to this mount.
 */ function $6437c80744d7a710$var$useSequentialText(texts, enabled, startedAt) {
    const indexFromStart = ()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(texts.length - 1, Math.floor(elapsed / $6437c80744d7a710$var$ROTATION_INTERVAL_MS));
    };
    const [index, setIndex] = (0, $cozmU.useState)(indexFromStart);
    const indexRef = (0, $cozmU.useRef)(index);
    indexRef.current = index;
    const textsRef = (0, $cozmU.useRef)(texts);
    textsRef.current = texts;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || textsRef.current.length <= 1) return;
        if (indexRef.current >= textsRef.current.length - 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else clearInterval(interval);
        }, $6437c80744d7a710$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        enabled,
        startedAt
    ]);
    return texts[index] ?? texts[texts.length - 1] ?? '';
}
const $6437c80744d7a710$var$styles = {
    container: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d",
    actions: "_2XsHFMIZbP",
    indicatorWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC"
};
const $6437c80744d7a710$export$6430bc5d6cac94e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { status: t1, onStop: onStop, onFollow: onFollow, useShortMessages: t2, showProgressBar: t3, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: t4, customRotatingMessages: customRotatingMessages, startedAt: startedAt, progressTarget: progressTarget } = t0;
    const status = t1 === undefined ? "analyzing" : t1;
    const useShortMessages = t2 === undefined ? false : t2;
    const showProgressBar = t3 === undefined ? false : t3;
    const useRotatingTitle = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== isComplete || $[1] !== onCompleteAnimationFinished || $[2] !== progressTarget || $[3] !== startedAt) {
        t5 = {
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            startedAt: startedAt,
            target: progressTarget
        };
        $[0] = isComplete;
        $[1] = onCompleteAnimationFinished;
        $[2] = progressTarget;
        $[3] = startedAt;
        $[4] = t5;
    } else t5 = $[4];
    const progress = (0, $7VOWp.useProgressFacade)(t5);
    const t6 = status === "editing" ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText;
    let t7;
    if ($[5] !== formatMessage || $[6] !== t6) {
        t7 = formatMessage(t6);
        $[5] = formatMessage;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const staticTitle = t7;
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    let t8;
    if ($[8] !== formatMessage) {
        t8 = formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking);
        $[8] = formatMessage;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== formatMessage) {
        t9 = formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent);
        $[10] = formatMessage;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== formatMessage) {
        t10 = formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether);
        $[12] = formatMessage;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== formatMessage) {
        t11 = formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse);
        $[14] = formatMessage;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== formatMessage) {
        t12 = formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse);
        $[16] = formatMessage;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== formatMessage) {
        t13 = formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether);
        $[18] = formatMessage;
        $[19] = t13;
    } else t13 = $[19];
    let t14;
    if ($[20] !== formatMessage) {
        t14 = formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches);
        $[20] = formatMessage;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== formatMessage) {
        t15 = formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone);
        $[22] = formatMessage;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t8 || $[31] !== t9) {
        t16 = [
            t8,
            t9,
            t10,
            t11,
            t12,
            t13,
            t14,
            t15
        ];
        $[24] = t10;
        $[25] = t11;
        $[26] = t12;
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
        $[30] = t8;
        $[31] = t9;
        $[32] = t16;
    } else t16 = $[32];
    const defaultRotatingTitles = t16;
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const rotatingTitle = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled, startedAt);
    const title = rotatingEnabled ? rotatingTitle : staticTitle;
    let t17;
    if ($[33] !== formatMessage || $[34] !== onFollow) {
        t17 = onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onFollow
        }, formatMessage((0, $02Wb7.default).followAiMateButton));
        $[33] = formatMessage;
        $[34] = onFollow;
        $[35] = t17;
    } else t17 = $[35];
    let t18;
    if ($[36] !== formatMessage) {
        t18 = formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel);
        $[36] = formatMessage;
        $[37] = t18;
    } else t18 = $[37];
    let t19;
    if ($[38] !== onStop || $[39] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            shape: "default",
            onClick: onStop,
            icon: $6437c80744d7a710$var$_temp,
            label: t18
        });
        $[38] = onStop;
        $[39] = t18;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== t17 || $[42] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "inline-chat__thinking-view",
            alignBlock: "center",
            space: "space.100",
            xcss: $6437c80744d7a710$var$styles.actions
        }, t17, t19);
        $[41] = t17;
        $[42] = t19;
        $[43] = t20;
    } else t20 = $[43];
    const actionsNode = t20;
    let t21;
    if ($[44] !== progress || $[45] !== showProgressBar || $[46] !== title) {
        t21 = showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined;
        $[44] = progress;
        $[45] = showProgressBar;
        $[46] = title;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== t21 || $[49] !== title) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.indicatorWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
            title: title,
            animation: true,
            bottomAdornment: t21
        }));
        $[48] = t21;
        $[49] = title;
        $[50] = t22;
    } else t22 = $[50];
    let t23;
    if ($[51] !== actionsNode || $[52] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.container
        }, t22, actionsNode);
        $[51] = actionsNode;
        $[52] = t22;
        $[53] = t23;
    } else t23 = $[53];
    return t23;
} : ({ status: status = 'analyzing', onStop: onStop, onFollow: onFollow, useShortMessages: useShortMessages = false, showProgressBar: showProgressBar = false, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: useRotatingTitle = false, customRotatingMessages: customRotatingMessages, startedAt: startedAt, progressTarget: progressTarget })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $7VOWp.useProgressFacade)({
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        startedAt: startedAt,
        target: progressTarget
    });
    const staticTitle = formatMessage(status === 'editing' ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText);
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    const defaultRotatingTitles = [
        formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking),
        formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent),
        formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches),
        formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone)
    ];
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const rotatingTitle = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled, startedAt);
    const title = rotatingEnabled ? rotatingTitle : staticTitle;
    const actionsNode = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: "inline-chat__thinking-view",
        alignBlock: "center",
        space: "space.100",
        xcss: $6437c80744d7a710$var$styles.actions
    }, onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onFollow
    }, formatMessage((0, $02Wb7.default).followAiMateButton)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        shape: 'default',
        onClick: onStop,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ''
            }),
        label: formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel)
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.indicatorWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
        title: title,
        animation: true,
        bottomAdornment: showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined
    })), actionsNode);
};
function $6437c80744d7a710$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}
module.exports["RovoThinkingBar"] = $6437c80744d7a710$export$6430bc5d6cac94e6;

});

parcelRegister("7VOWp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS = 30000;
const $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS = 150;
function $cccd0e8042c52039$export$c350fe90f7013d5f({ isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, estimatedDurationMs: estimatedDurationMs = $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS, startedAt: startedAt = null, target: target }) {
    const randomTargetRef = (0, $cozmU.useRef)(85 + Math.random() * 10);
    const targetValue = target ?? randomTargetRef.current;
    // When anchored to a shared start time, seed the initial value from elapsed
    // time so a freshly-mounted bar jumps to the in-progress value instead of
    // restarting the animation from 0.
    const [progress, setProgress] = (0, $cozmU.useState)(()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(1, elapsed / estimatedDurationMs) * targetValue;
    });
    const completionStartValueRef = (0, $cozmU.useRef)(0);
    const completionStartTimeRef = (0, $cozmU.useRef)(null);
    const hasCalledFinishedRef = (0, $cozmU.useRef)(false);
    const onCompleteAnimationFinishedRef = (0, $cozmU.useRef)(onCompleteAnimationFinished);
    onCompleteAnimationFinishedRef.current = onCompleteAnimationFinished;
    // Phase 1: Animate from 0 → target over estimatedDurationMs.
    // When `startedAt` is provided, elapsed is measured from that shared anchor
    // (wall-clock) so every bar agrees regardless of mount time; otherwise it is
    // measured from the first animation frame of this mount.
    (0, $cozmU.useEffect)(()=>{
        if (isComplete) return;
        let rafId;
        let mountStartTime = null;
        const tick = (timestamp)=>{
            let elapsed;
            if (startedAt != null) elapsed = Math.max(0, Date.now() - startedAt);
            else {
                if (mountStartTime === null) mountStartTime = timestamp;
                elapsed = timestamp - mountStartTime;
            }
            const linearProgress = Math.min(1, elapsed / estimatedDurationMs);
            setProgress(linearProgress * targetValue);
            if (linearProgress < 1) rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, [
        isComplete,
        estimatedDurationMs,
        startedAt,
        targetValue
    ]);
    // Phase 2: When isComplete, rapidly animate from current value → 100
    const handleCompletion = (0, $cozmU.useCallback)(()=>{
        completionStartTimeRef.current = null;
        hasCalledFinishedRef.current = false;
        let rafId;
        const tick = (timestamp)=>{
            if (completionStartTimeRef.current === null) completionStartTimeRef.current = timestamp;
            const elapsed = timestamp - completionStartTimeRef.current;
            const t = Math.min(1, elapsed / $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS);
            const startValue = completionStartValueRef.current;
            const value = startValue + (100 - startValue) * t;
            setProgress(value);
            if (t < 1) rafId = requestAnimationFrame(tick);
            else if (!hasCalledFinishedRef.current) {
                hasCalledFinishedRef.current = true;
                onCompleteAnimationFinishedRef.current?.();
            }
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isComplete) return;
        completionStartValueRef.current = progress;
        const cleanup = handleCompletion();
        return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only trigger when isComplete changes to true
    }, [
        isComplete,
        handleCompletion
    ]);
    return progress;
}
module.exports["useProgressFacade"] = $cccd0e8042c52039$export$c350fe90f7013d5f;

});

parcelRegister("bR6es", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $gMrzi = parcelRequire("gMrzi");


var $jEaFE = parcelRequire("jEaFE");


var $2Wuyj = parcelRequire("2Wuyj");

const $726c97f63f4e2017$var$styles = {
    toolbarBase: "_0bjKvDKTcp _2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    toolbar: "_0KLXruoI2d _0jFU0VnlTt _1Znuxb1Y8M _2Zuz6Q1Y8M _2OUyjtGk8v",
    toolbarResponsive: "_2YLqiK5zaO",
    primaryToolbar: "_0KLXrulfZc _4kiQYAUofl",
    toolbarSeparator: "_3RwxbwnlTt",
    hiddenSelectors: "_13h9R7YbGa _2XhVcfYbGa _2kQ26MYbGa",
    hiddenSelectorsPatch: "_2jRqDdYbGa"
};
const $726c97f63f4e2017$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
            actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline",
            children: [
                t2,
                children
            ]
        });
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel,
                children: toolbar
            });
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
            children: wrappedToolbar
        });
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
                actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
        children: wrappedToolbar
    });
}; // remove { label?: string } when cleaning up editor_a11y__primary-toolbar-aria-label_fy27
const $726c97f63f4e2017$export$7469f9986edfc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, label: label, breakpointPreset: breakpointPreset, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== label || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            "aria-label": label,
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        });
        $[1] = children;
        $[2] = label;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== breakpointPreset || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
            breakpointPreset: breakpointPreset,
            children: t2
        });
        $[5] = breakpointPreset;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, label: label, breakpointPreset: breakpointPreset, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors),
            "aria-label": label,
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        })
    });
};
module.exports["Toolbar"] = $726c97f63f4e2017$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $726c97f63f4e2017$export$7469f9986edfc2;

});

parcelRegister("gMrzi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $2pQiO = parcelRequire("2pQiO");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $a746760df070e426$var$styles = {
    responsiveContainer: "_39xV02N91d _0u2WMmrU95 _3n40gWGjUA _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    responsiveContainerFullPage: "_39xV02E6Kk _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    fullpage: "_1rq8jLYbGa _0aYpZQvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _1UwYfAYbGa _12th9UvLZJ _3EFhkHvLZJ _39JjOcvLZJ _0L5H27vLZJ _34STP7vLZJ",
    fullpageUpdated: "_3x54HuYbGa _01WCBwvLZJ _3mkwgcYbGa _4sC1oWvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _3B0hPZvLZJ _0BUt8zvLZJ _39JjOcvLZJ _2bfXdIvLZJ",
    reduced: "_1mdU70YbGa _3gHiHXvLZJ _3cgyzIvLZJ _1gaO6tYbGa _2cYx2vvLZJ _1CnDTDvLZJ _2CNPNSYbGa _0j4V1pvLZJ _2afuuivLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssue: "_2I6R9qYbGa _3d33AUvLZJ _0hNaxovLZJ _0GIckyYbGa _1EftZivLZJ _27RrwMvLZJ _3QLJlTYbGa _1MMVXavLZJ _4EWOPkvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssueUpdated: "_2I6R9qYbGa _3d33AUvLZJ _3DyQwZvLZJ _3U0x9yYbGa _3UVUXivLZJ _1pEq9LvLZJ _2nGSpMYbGa _41Ji6pvLZJ _149pM8vLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmComment: "_1QRAXcYbGa _1AFPIdvLZJ _3GGyPKvLZJ _1p8ZHhYbGa _4BiRXLvLZJ _4tAAtIvLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmCommentUpdated: "_1QRAXcYbGa _1AFPIdvLZJ _4mq0TavLZJ _1ZCm13YbGa _0NVVnzvLZJ _2GrInovLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    confluenceComment: "_2KtBBnYbGa _0PCBjdvLZJ _0vF73WvLZJ _2BIo24YbGa _0AeybuvLZJ _0PYKuevLZJ _2Y6dwmYbGa _4oeWH5vLZJ _40xblwvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    responsiveRulesWrapper: "_3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _0cHb2BYbGa _3hCVfsvLZJ _1ZeYDsYbGa _1PZiqKvLZJ _11yBoBYbGa _0obMtNvLZJ _1aaAVJYbGa _4cWoU5vLZJ _223UMPYbGa _3X9hbPvLZJ _2ZXGV7YbGa _4aIPGovLZJ"
};
const $a746760df070e426$var$presetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpage,
    reduced: $a746760df070e426$var$styles.reduced,
    'jira-issue': $a746760df070e426$var$styles.jiraIssue,
    'jsm-comment': $a746760df070e426$var$styles.jsmComment,
    'confluence-comment': $a746760df070e426$var$styles.confluenceComment
};
const $a746760df070e426$var$updatedPresetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpageUpdated,
    'jira-issue': $a746760df070e426$var$styles.jiraIssueUpdated,
    'jsm-comment': $a746760df070e426$var$styles.jsmCommentUpdated
};
const $a746760df070e426$export$e60a4704009a0009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    let t1;
    bb0: {
        if (breakpointPreset === "fullpage") {
            t1 = (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false);
            break bb0;
        }
        t1 = (0, $ieeJu.expValEquals)("platform_editor_toolbar_update_jira_config", "isEnabled", true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    }
    const isUpdatedConfig = t1;
    const t2 = breakpointPreset === "fullpage" ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer;
    const t3 = isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $w6R6I.cx)(t2, t3);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t4,
            children: children
        });
        $[3] = children;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (()=>{
        if (breakpointPreset === 'fullpage') return (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
        return (0, $ieeJu.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    })();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(breakpointPreset === 'fullpage' ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer, isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $a746760df070e426$export$fa6e408d6a7d6214 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $a746760df070e426$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $a746760df070e426$export$fa6e408d6a7d6214;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("jEaFE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");

const $3dd4b47fb9e5cae4$export$881345eb2554ea9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $1hQ0e.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $1hQ0e.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($3dd4b47fb9e5cae4$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                bb86: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb86;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb86;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb86;
                    case "Tab":
                        handleTab();
                        break bb86;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls,
            children: children
        });
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $1hQ0e.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $1hQ0e.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
function $3dd4b47fb9e5cae4$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $3dd4b47fb9e5cae4$export$881345eb2554ea9e;

});

parcelRegister("2Wuyj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $171e330111381e98$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $171e330111381e98$export$58d0f383acf77599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    (0, $cozmU.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $171e330111381e98$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $171e330111381e98$export$58d0f383acf77599;

});

parcelRegister("6PfjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $43bfeda8ce4963c3$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $43bfeda8ce4963c3$export$2e2bcd8739ae039 = $43bfeda8ce4963c3$var$createEventPayload;
module.exports["default"] = $43bfeda8ce4963c3$export$2e2bcd8739ae039;

});

parcelRegister("liM9D", function(module, exports) {
const $805653e9c9be0b26$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $805653e9c9be0b26$export$3f072f06b90c3985;

});

parcelRegister("lqRBm", function(module, exports) {
/* eslint-disable compat/compat */ const $b136b9ae0024c8d8$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $b136b9ae0024c8d8$export$51d09170c61ebe04;

});

parcelRegister("8hDyr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2iGHk = parcelRequire("2iGHk");

var $9DHhW = parcelRequire("9DHhW");


var $cMyWi = parcelRequire("cMyWi");


var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $e5274b30bf01d8e7$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $cMyWi.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("73aFv"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $e5274b30bf01d8e7$export$612752b1e088a45e;

});

parcelRegister("73aFv", function(module, exports) {

let $522116bd22dc972c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $522116bd22dc972c$var$load("90vep"),
    $522116bd22dc972c$var$load("aAJyu"),
    $522116bd22dc972c$var$load("f8Q8b"),
    $522116bd22dc972c$var$load("dXcHK")
]).then(()=>parcelRequire('3hbWh'));

});

parcelRegister("1sE44", function(module, exports) {
$parcel$export(module.exports, "default", () => $1edd959af8b178b3$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $4iudd = parcelRequire("4iudd");


var $Igylv = parcelRequire("Igylv");


var $Mf8oW = parcelRequire("Mf8oW");


var $ak92H = parcelRequire("ak92H");

/**
 * Allowlists of extension keys + layout
 * Currently, only toc with default layout allows to skip React render.
 * Extensions NOT in this list always follow the normal React render path.
 */ const $1edd959af8b178b3$var$ssrHydrationExtensionAllowlist = [
    'toc'
];
const $1edd959af8b178b3$var$ssrHydrationLayoutAllowlist = [
    'default'
];
const $1edd959af8b178b3$var$isSSRHydrationEligible = (node)=>{
    if (node.type.name !== 'extension') return false;
    const { extensionKey: extensionKey, layout: layout } = node.attrs ?? {};
    if (!$1edd959af8b178b3$var$ssrHydrationExtensionAllowlist.includes(extensionKey)) return false;
    // Treat a missing layout attr as `default` (the schema default).
    const effectiveLayout = layout ?? 'default';
    return $1edd959af8b178b3$var$ssrHydrationLayoutAllowlist.includes(effectiveLayout);
};
/**
 * Per-(EditorView, extensionKey + localId) record of which extension identities
 * have already had their initial-hydration init pass. SSR DOM reuse is only valid
 * the very first time an ExtensionNode init runs for a given identity in a given
 * editor — that is the only moment a real SSR-rendered element for that identity
 * can exist in the editor DOM.
 *
 * After the first init, any element matching the SSR selector is the previous
 * node view's React-rendered domRef that ProseMirror has not yet detached (e.g.
 * during DnD / layout resize, where ProseMirror constructs the new node view
 * BEFORE destroying the old one). Reusing it as if it were SSR DOM causes the
 * new node view to skip React rendering and leaves the extension invisible
 * (EDITOR-6613).
 */ const $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor = new WeakMap();
const $1edd959af8b178b3$var$getHydrationIdentityKey = (extensionKey, localId)=>{
    if (typeof extensionKey !== 'string' || typeof localId !== 'string') return null;
    if (extensionKey === '' || localId === '') return null;
    return `${extensionKey}::${localId}`;
};
const $1edd959af8b178b3$var$hasHydrationIdentityBeenConsumed = (view, identityKey)=>{
    const consumed = $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor.get(view);
    return consumed ? consumed.has(identityKey) : false;
};
const $1edd959af8b178b3$var$markHydrationIdentityAsConsumed = (view, identityKey)=>{
    let consumed = $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor.get(view);
    if (!consumed) {
        consumed = new Set();
        $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor.set(view, consumed);
    }
    consumed.add(identityKey);
};
class $1edd959af8b178b3$export$456a23774b90f061 extends (0, $Igylv.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    /** See {@link consumedHydrationIdentitiesByEditor}. Null when attrs are missing → SSR reuse skipped. */ getHydrationIdentityKey() {
        return $1edd959af8b178b3$var$getHydrationIdentityKey(this.node.attrs?.extensionKey, this.node.attrs?.localId);
    }
    /** True only for the first ExtensionNode of this identity in this editor. See {@link consumedHydrationIdentitiesByEditor}. */ isInInitialHydrationWindow() {
        const identityKey = this.getHydrationIdentityKey();
        if (identityKey === null) return false;
        return !$1edd959af8b178b3$var$hasHydrationIdentityBeenConsumed(this.view, identityKey);
    }
    // Reserve height by setting a minimum height for the extension node view element
    createDomRef() {
        // SSR DOM reuse takes precedence over preset height — when eligible, adopt the
        // server-rendered element directly so React hydration is deferred until update().
        if (!(0, $4iudd.isSSR)() && $1edd959af8b178b3$var$isSSRHydrationEligible(this.node) && this.isInInitialHydrationWindow() && (0, $ieeJu.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                this.didReuseSsrDom = true;
                return ssrElement;
            }
        }
        if (!(0, $iDrrr.fg)('confluence_connect_macro_preset_height')) return super.createDomRef();
        if (!this.node.isInline) {
            const htmlElement = document.createElement('div');
            const extensionHeight = this.reactComponentProps?.extensionNodeViewOptions?.getExtensionHeight?.(this.node);
            if (extensionHeight) htmlElement.style.setProperty('min-height', `${extensionHeight}px`);
            return htmlElement;
        }
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    /**
   * Attempts to find an existing SSR'd DOM element for this extension node by extensionKey and localId
   * which should uniquely identify the
   * extension node within the editor content.
   *
   * @returns The SSR'd element if found, otherwise null
   */ findSSRElement() {
        if (this.cachedSsrElement !== undefined) return this.cachedSsrElement || null;
        const extensionKey = this.node.attrs.extensionKey;
        const localId = this.node.attrs.localId;
        const editorDom = this.view.dom;
        if (extensionKey && localId) {
            const selector = `[extensionkey="${extensionKey}"][localid="${localId}"]`;
            const element = editorDom.querySelector(selector);
            if (element && element instanceof HTMLElement) {
                this.cachedSsrElement = element;
                return element;
            }
        }
        this.cachedSsrElement = null;
        return null;
    }
    /** Skip React Portal render on first init when reusing SSR DOM. See {@link consumedHydrationIdentitiesByEditor}. */ init() {
        if (!(0, $ieeJu.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) super.init();
        else {
            const isEligibleForSsrReuse = !(0, $4iudd.isSSR)() && $1edd959af8b178b3$var$isSSRHydrationEligible(this.node);
            if (isEligibleForSsrReuse && this.isInInitialHydrationWindow()) {
                const ssrElement = this.findSSRElement();
                const shouldSkipInitRender = ssrElement !== null;
                super.init(shouldSkipInitRender);
                const identityKey = this.getHydrationIdentityKey();
                if (identityKey !== null) // Close the hydration window — see {@link consumedHydrationIdentitiesByEditor}.
                $1edd959af8b178b3$var$markHydrationIdentityAsConsumed(this.view, identityKey);
            } else super.init();
        }
        return this;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // Remove extensionNodeWrapper aka span.relative if we previously reused SSR DOM
        // control is back to React afterwards
        if (this.didReuseSsrDom && (0, $ieeJu.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                const extensionNodeWrapper = ssrElement.querySelector('[data-testid="extension-node-wrapper"]');
                if (extensionNodeWrapper) extensionNodeWrapper.remove();
                this.didReuseSsrDom = false;
            }
        }
        return super.update(node, decorations, _innerDecorations, validUpdate);
    }
    /**
   * Prevents ProseMirror from handling events that belong to the extension's React UI.
   *
   * For multibodied extensions: the node consists of a React app (e.g. tab bar) that controls
   * frames, and the editable frames themselves. Events inside frames must reach ProseMirror
   * for normal editing; events in the surrounding React app (buttons, navigation) are stopped
   * so ProseMirror doesn't create a NodeSelection on the entire node.
   *
   * For other extensions: input/textarea events are stopped so users can interact
   * with form elements inside the extension body without the editor intercepting them.
   */ stopEvent(event) {
        if (this.node.type.name === 'multiBodiedExtension') {
            const target = event.target;
            if (target instanceof Element) {
                if (target.closest('[data-multibodiedextension-frames]')) return false;
                return !!target.closest('[data-multiBodiedExtension-container]');
            }
            return false;
        }
        return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
    }
    getContentDOM() {
        if (this.node.isInline) return;
        if (this.didReuseSsrDom) return;
        const contentDomWrapper = document.createElement('div');
        contentDomWrapper.className = `${this.node.type.name}-content-dom-wrapper`;
        const isBodiedExtension = this.node.type.name === 'bodiedExtension';
        const showMacroInteractionDesignUpdates = this.reactComponentProps?.macroInteractionDesignFeatureFlags?.showMacroInteractionDesignUpdates;
        if (isBodiedExtension && showMacroInteractionDesignUpdates && (0, $ieeJu.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true)) {
            // Create outer wrapper to hold space for the lozenge
            const outerWrapper = document.createElement('div');
            outerWrapper.className = `${this.node.type.name}-content-outer-wrapper`;
            // Create inner wrapper to position inner content
            const innerWrapper = document.createElement('div');
            innerWrapper.className = `${this.node.type.name}-content-inner-wrapper`;
            innerWrapper.appendChild(contentDomWrapper);
            outerWrapper.appendChild(innerWrapper);
            return {
                dom: outerWrapper,
                contentDOM: contentDomWrapper
            };
        }
        return {
            dom: contentDomWrapper
        };
    }
    render(props, forwardRef) {
        // While sitting on SSR DOM, skip the React portal — see {@link didReuseSsrDom}.
        if (this.didReuseSsrDom) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ak92H.ExtensionNodeWrapper), {
            intl: props.intl,
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $Mf8oW.Extension), {
                editorView: this.view,
                node: this.node,
                eventDispatcher: this.eventDispatcher,
                // The getPos arg is always a function when used with nodes
                // the version of the types we use has a union with the type
                // for marks.
                // This has been fixed in later versions of the definitly typed
                // types (and also in prosmirror-views inbuilt types).
                // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
                getPos: this.getPos,
                providerFactory: props.providerFactory,
                handleContentDOMRef: forwardRef,
                extensionHandlers: props.extensionHandlers,
                extensionLoadingHandlers: props.extensionLoadingHandlers,
                editorAppearance: props.extensionNodeViewOptions?.appearance,
                pluginInjectionApi: props.pluginInjectionApi,
                macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: props.rendererExtensionHandlers
            })
        });
    }
    constructor(...args){
        super(...args);
        /** True between SSR DOM adoption in `createDomRef` and the SSR→React handoff in `update`. */ this.didReuseSsrDom = false;
        /**
     * Cache for SSR element lookup to avoid repeated DOM queries.
     * undefined = not yet searched, null = searched but not found, HTMLElement = found
     */ this.cachedSsrElement = void 0;
    }
}
function $1edd959af8b178b3$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers, intl) {
    return (node, view, getPos)=>{
        return new $1edd959af8b178b3$export$456a23774b90f061(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionLoadingHandlers: extensionLoadingHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers,
            intl: intl
        }).init();
    };
}
module.exports["ExtensionNode"] = $1edd959af8b178b3$export$456a23774b90f061;

});

parcelRegister("Mf8oW", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $eNbr2 = parcelRequire("eNbr2");

var $794I6 = parcelRequire("794I6");


var $a3WdP = parcelRequire("a3WdP");

class $be16ee2984d6c6af$export$eeddbf09bb970356 extends (0, $cozmU.Component) {
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- there seems to be an existing bug where the Extension component can't be resized if this is memoised because it doesn't rerender so this can't be memoised without a larger refactor
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            const { node: node, getPos: getPos, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, extensionLoadingHandlers: extensionLoadingHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            // Extensions are not yet using the new plugin architecture, and the use of the pluginInjectionApi
            // is not type safe in editor-common.
            // @ts-ignore
            const currentState = pluginInjectionApi?.editorViewMode?.sharedState?.currentState();
            const { contentMode: contentMode, mode: mode } = currentState || {};
            const isLivePageViewMode = contentMode === 'live-view' || mode === 'view';
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a3WdP.ExtensionComponent), {
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                extensionLoadingHandlers: extensionLoadingHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: rendererExtensionHandlers,
                isLivePageViewMode: isLivePageViewMode
            });
        };
        this.providerFactory = props.providerFactory || new (0, $eNbr2.default)();
    }
}
$be16ee2984d6c6af$export$eeddbf09bb970356.displayName = 'Extension';
module.exports["Extension"] = $be16ee2984d6c6af$export$eeddbf09bb970356;

});

parcelRegister("a3WdP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $kCECX = parcelRequire("kCECX");


var $iDrrr = parcelRequire("iDrrr");


var $cd8tA = parcelRequire("cd8tA");


var $apAmb = parcelRequire("apAmb");

var $gWBVp = parcelRequire("gWBVp");


var $8QIv2 = parcelRequire("8QIv2");


var $1BETI = parcelRequire("1BETI");


var $11KBS = parcelRequire("11KBS");


var $1aF4Q = parcelRequire("1aF4Q");

const $c68c5e4214724e52$var$getBodiedExtensionContent = (node)=>{
    const bodiedExtensionContent = [];
    node.content.forEach((childNode)=>{
        bodiedExtensionContent.push((0, $gWBVp.nodeToJSON)(childNode));
    });
    return !!bodiedExtensionContent.length ? bodiedExtensionContent : node.attrs.text;
};
const $c68c5e4214724e52$export$908ff786c04d5297 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    let extensionProviderResolver;
    let node;
    let restProps;
    let showLivePagesBodiedMacrosRendererView;
    if ($[0] !== props) {
        ({ extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props);
        $[0] = props;
        $[1] = extensionProviderResolver;
        $[2] = node;
        $[3] = restProps;
        $[4] = showLivePagesBodiedMacrosRendererView;
    } else {
        extensionProviderResolver = $[1];
        node = $[2];
        restProps = $[3];
        showLivePagesBodiedMacrosRendererView = $[4];
    }
    const [extensionProvider, setExtensionProvider] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[5] !== node || $[6] !== showLivePagesBodiedMacrosRendererView) {
        t0 = !!showLivePagesBodiedMacrosRendererView?.((0, $gWBVp.nodeToJSON)(node)) && !(0, $1BETI.isEmptyBodiedMacro)(node);
        $[5] = node;
        $[6] = showLivePagesBodiedMacrosRendererView;
        $[7] = t0;
    } else t0 = $[7];
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $cozmU.useState)(t0);
    const mountedRef = (0, $cozmU.useRef)(true);
    let t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t2 = [];
        $[8] = t1;
        $[9] = t2;
    } else {
        t1 = $[8];
        t2 = $[9];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    let t4;
    if ($[10] !== extensionProviderResolver) {
        t3 = ()=>{
            extensionProviderResolver?.then((provider)=>{
                if (mountedRef.current) setExtensionProvider(provider);
            });
        };
        t4 = [
            extensionProviderResolver
        ];
        $[10] = extensionProviderResolver;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[13] !== extensionProvider || $[14] !== node || $[15] !== restProps || $[16] !== showBodiedExtensionRendererView || $[17] !== showLivePagesBodiedMacrosRendererView) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($c68c5e4214724e52$var$ExtensionComponentInner, {
            ...restProps,
            extensionProvider: extensionProvider,
            node: node,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showBodiedExtensionRendererView: showBodiedExtensionRendererView,
            setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
        });
        $[13] = extensionProvider;
        $[14] = node;
        $[15] = restProps;
        $[16] = showBodiedExtensionRendererView;
        $[17] = showLivePagesBodiedMacrosRendererView;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (props)=>{
    const { extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props;
    const [extensionProvider, setExtensionProvider] = (0, $cozmU.useState)(undefined);
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $cozmU.useState)(!!showLivePagesBodiedMacrosRendererView?.((0, $gWBVp.nodeToJSON)(node)) && !(0, $1BETI.isEmptyBodiedMacro)(node));
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        extensionProviderResolver?.then((provider)=>{
            if (mountedRef.current) setExtensionProvider(provider);
        });
    }, [
        extensionProviderResolver
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c68c5e4214724e52$var$ExtensionComponentInner, {
        ...restProps,
        extensionProvider: extensionProvider,
        node: node,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    });
};
class $c68c5e4214724e52$var$ExtensionComponentInner extends (0, $cozmU.Component) {
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
    }
    render() {
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, extensionProvider: extensionProvider, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, isLivePageViewMode: isLivePageViewMode } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $kCECX.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') {
            const allowBodiedOverride = this.state._privateProps?.__allowBodiedOverride;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1aF4Q.default), {
                node: node,
                editorView: editorView,
                getPos: getPos,
                handleContentDOMRef: handleContentDOMRef,
                tryExtensionHandler: this.tryExtensionHandler.bind(this),
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                editorAppearance: editorAppearance,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                isNodeSelected: selectedNode === node,
                isNodeHovered: this.state.isNodeHovered,
                isNodeNested: isNodeNested,
                setIsNodeHovered: this.setIsNodeHovered,
                isLivePageViewMode: isLivePageViewMode,
                allowBodiedOverride: allowBodiedOverride
            });
        }
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8QIv2.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideFrame: this.state._privateProps?.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeNested: isNodeNested,
                    showLivePagesBodiedMacrosRendererView: !!showLivePagesBodiedMacrosRendererView?.((0, $gWBVp.nodeToJSON)(node)),
                    showUpdatedLivePages1PBodiedExtensionUI: !!showUpdatedLivePages1PBodiedExtensionUI?.((0, $gWBVp.nodeToJSON)(node)),
                    showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                    setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                    isLivePageViewMode: isLivePageViewMode,
                    children: extensionHandlerResult
                });
            case 'inlineExtension':
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $11KBS.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isLivePageViewMode: isLivePageViewMode,
                    children: extensionHandlerResult
                });
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args);
        this.privatePropsParsed = false;
        this.state = {};
        // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $dOBRD.default)((0, $cd8tA.getNodeRenderer));
        this.getExtensionModuleNodePrivateProps = (0, $dOBRD.default)((0, $cd8tA.getExtensionModuleNodePrivateProps));
        this.setIsNodeHovered = (isHovered)=>{
            // Don't want to show hover interactions for live page view mode
            if (!this.props.isLivePageViewMode) this.setState({
                isNodeHovered: isHovered
            });
        };
        /**
     * Parses any private nodes once an extension provider is available.
     *
     * We do this separately from resolving a node renderer component since the
     * private props come from extension provider, rather than an extension
     * handler which only handles `render`/component concerns.
     */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.props.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
       * getExtensionModuleNodePrivateProps can throw if there are issues in the
       * manifest
       */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.props.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        };
        this.handleExtension = (pmNode, actions)=>{
            const { extensionHandlers: extensionHandlers, extensionLoadingHandlers: extensionLoadingHandlers, editorView: editorView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            const { selection: selection } = editorView.state;
            const isSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node === pmNode;
            if (isBodiedExtension && !showBodiedExtensionRendererView) return;
            const fragmentLocalId = pmNode?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const content = isBodiedExtension ? $c68c5e4214724e52$var$getBodiedExtensionContent(pmNode) : text;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: content,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            if (isBodiedExtension) {
                const rendererExtensionHandler = rendererExtensionHandlers?.[extensionType];
                // Forge bodied extensions don't get rendererExtensionHandlers passed in and use extensionHandlerFromProvider from the below logic instead
                if (rendererExtensionHandler) return (0, $apAmb.getExtensionRenderer)(rendererExtensionHandler)(node, (0, $gWBVp.toJSON)(editorView.state.doc));
            }
            let result;
            const loadingFallback = extensionLoadingHandlers?.[extensionType] ? (0, $apAmb.getExtensionRenderer)(extensionLoadingHandlers[extensionType])(node, editorView.state.doc, actions) : undefined;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $apAmb.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.props.extensionProvider && this.getNodeRenderer(this.props.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, $8aG6j.jsx)(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions,
                        loadingFallback: loadingFallback
                    });
                    return /*#__PURE__*/ (0, $8aG6j.jsx)(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        isSelected: isSelected,
                        loadingFallback: loadingFallback,
                        showUnknownMacroPlaceholder: (0, $iDrrr.fg)('tinymce_display_unknown_macro_body_content')
                    });
                }
            }
            return result ?? loadingFallback;
        };
    }
}
module.exports["ExtensionComponent"] = $c68c5e4214724e52$export$908ff786c04d5297;

});

parcelRegister("8QIv2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $3k5Tv = parcelRequire("3k5Tv");


var $g9sVl = parcelRequire("g9sVl");


var $9ECRl = parcelRequire("9ECRl");


var $h9Lux = parcelRequire("h9Lux");


var $38lMZ = parcelRequire("38lMZ");


var $bYEj1 = parcelRequire("bYEj1");


var $imFKp = parcelRequire("imFKp");


var $1BETI = parcelRequire("1BETI");


var $dBzxx = parcelRequire("dBzxx");

function $d03f27f1eb216197$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d03f27f1eb216197$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $d03f27f1eb216197$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
function $d03f27f1eb216197$var$ExtensionWithPluginState(props) {
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === 'com.atlassian.confluence.migration' && extensionNode.attrs?.extensionKey === 'legacy-content';
    const showLegacyContentHeader = (0, $iDrrr.fg)('platform_editor_legacy_content_macro_visual_update') && isLegacyContentMacroExtension(node);
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    // Some native bodied macros (e.g Content properties) have this param to hide in view mode
    // which we want to also hide in live page view mode too
    const macroParamHiddenValue = node?.attrs?.parameters?.macroParams?.hidden?.value;
    const shouldHideInLivePageViewMode = isLivePageViewMode && macroParamHiddenValue === 'true'; // it is stored as a string
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && isTopLevelNode && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const shouldBreakout = tinymceFullWidthModeEnabled ? (0, $38lMZ.shouldExtensionBreakout)({
        layout: layout,
        isTopLevelNode: isTopLevelNode,
        editorAppearance: editorAppearance
    }) : legacyShouldBreakout;
    // We don't want to show border for non-empty 1p bodied extensions in live pages
    const show1PBodiedExtensionBorder = showUpdatedLivePages1PBodiedExtensionUI ? (0, $1BETI.isEmptyBodiedMacro)(node) : true;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && (hasBody || isLegacyContentMacroExtension(node)) && !showBodiedExtensionRendererView && show1PBodiedExtensionBorder,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        [(0, $dBzxx.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-overflow-wrapper', {
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        // Adding extra padding for renderer view so users can have a touch target to click on the extension
        'with-padding-styles': showMacroInteractionDesignUpdates && showBodiedExtensionRendererView
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates,
        'hide-content': showBodiedExtensionRendererView
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        // type is destructured so that breakout styles does not include it
        const { type: _type, ...breakoutStyles } = (0, $h9Lux.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $dBzxx.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, !showLegacyContentHeader && showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody || isLegacyContentMacroExtension(node),
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-container",
        ref: handleRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dBzxx.wrapperStyleInheritedCursor),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && $d03f27f1eb216197$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-overflow-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: overflowClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dBzxx.overflowWrapperStyles),
            (0, $iDrrr.fg)('platform_fix_macro_renders_in_layouts') && $d03f27f1eb216197$var$containerStyle
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $imFKp.overlay)
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $dBzxx.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: newContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: newContentClassNames,
        "data-testid": "extension-new-content"
    }, !shouldHideInLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $dBzxx.extensionContent),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9sVl.NodeViewContentHole), {
        ref: handleContentDOMRef
    }))))));
}
const $d03f27f1eb216197$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { lineLength: lineLength, width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width ?? 0,
            lineLength: states.widthState?.lineLength
        }));
    const memoizedWidthState = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            width: width ?? 0,
            lineLength: lineLength
        }), [
        width,
        lineLength
    ]);
    const widthState = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedWidthState : {
        width: width ?? 0,
        lineLength: lineLength
    };
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $lOiVq.jsx)($d03f27f1eb216197$var$ExtensionWithPluginState, {
        widthState: widthState,
        ...props
    });
};
const $d03f27f1eb216197$var$_default_1 = (0, $9ECRl.default)($d03f27f1eb216197$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper'
});
var $d03f27f1eb216197$export$2e2bcd8739ae039 = $d03f27f1eb216197$var$_default_1;
module.exports["default"] = $d03f27f1eb216197$export$2e2bcd8739ae039;

});

parcelRegister("38lMZ", function(module, exports) {
const $a42b9e424ed492bc$var$breakoutLayouts = new Set([
    'full-width',
    'wide'
]);
const $a42b9e424ed492bc$var$shouldRespectBreakoutForAppearance = (appearance)=>{
    if (!appearance) return true;
    if (appearance === 'full-width') return false;
    if (appearance === 'max') return false;
    return true;
};
const $a42b9e424ed492bc$export$85b54d274949f309 = ({ layout: layout, isTopLevelNode: isTopLevelNode = true, editorAppearance: editorAppearance })=>{
    if (!layout || !$a42b9e424ed492bc$var$breakoutLayouts.has(layout)) return false;
    if (!isTopLevelNode) return false;
    return $a42b9e424ed492bc$var$shouldRespectBreakoutForAppearance(editorAppearance);
};
module.exports["shouldExtensionBreakout"] = $a42b9e424ed492bc$export$85b54d274949f309;

});

parcelRegister("bYEj1", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $RiJVa = parcelRequire("RiJVa");


var $imFKp = parcelRequire("imFKp");


var $kYLTP = parcelRequire("kYLTP");

class $856e67b1d1258267$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $RiJVa.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $RiJVa.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args);
        this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $lOiVq.jsx)("img", {
                css: (0, $imFKp.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        };
        this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kYLTP.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                extensionName: name,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                pluginInjectionApi: pluginInjectionApi
            });
        };
    }
}
module.exports["default"] = $856e67b1d1258267$export$2e2bcd8739ae039;

});

parcelRegister("imFKp", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

function $f9471a55d63539ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9471a55d63539ff$export$a7d01cf46bd1c5ed = '--ak-editor-extension-block-spacing';
const $f9471a55d63539ff$export$2c23939c304dcbb6 = {
    name: "1st3gh2",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #0B120E24);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $f9471a55d63539ff$export$29dd17c7f3c81c36 = {
    name: "7geot",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;top:0;left:0"
};
const $f9471a55d63539ff$export$f61e107d01719381 = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $f9471a55d63539ff$export$baa8de7b590bf812 = {
    name: "147iacu",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #6B6E76);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $f9471a55d63539ff$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};
module.exports["wrapperDefault"] = $f9471a55d63539ff$export$2c23939c304dcbb6;
module.exports["overlay"] = $f9471a55d63539ff$export$29dd17c7f3c81c36;
module.exports["placeholderFallback"] = $f9471a55d63539ff$export$f61e107d01719381;
module.exports["placeholderFallbackParams"] = $f9471a55d63539ff$export$baa8de7b590bf812;
module.exports["styledImage"] = $f9471a55d63539ff$export$83cb1da155637959;

});

parcelRegister("kYLTP", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kkFbH = parcelRequire("kkFbH");


var $imFKp = parcelRequire("imFKp");


var $aGmZp = parcelRequire("aGmZp");


var $ggmg0 = parcelRequire("ggmg0");

const $87435b85784be422$export$91a15f1424900d33 = 24;
const $87435b85784be422$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $87435b85784be422$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi })=>{
    const capitalizedTitle = $87435b85784be422$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ggmg0.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), showLivePagesBodiedMacrosRendererView && isBodiedMacro && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aGmZp.EditToggle), {
        isNodeHovered: isNodeHovered,
        setIsNodeHovered: setIsNodeHovered,
        customContainerStyles: customContainerStyles,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    }));
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $imFKp.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $87435b85784be422$export$91a15f1424900d33,
        width: $87435b85784be422$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        label: title
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $imFKp.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};
module.exports["LozengeComponent"] = $87435b85784be422$export$14bad8182dc08b5a;

});

parcelRegister("aGmZp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $eh6Ml = parcelRequire("eh6Ml");


var $gC2EJ = parcelRequire("gC2EJ");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");

function $9bf89b97db7e04ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9bf89b97db7e04ac$var$buttonContainerStyles = {
    name: "cy6p8l",
    styles: "opacity:0;line-height:1;position:absolute;width:max-content;top:-28px;display:inline-flex;justify-content:flex-end;color:var(--ds-text-subtle, #505258)"
};
const $9bf89b97db7e04ac$var$buttonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    minHeight: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    paddingRight: "var(--ds-space-150, 12px)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    '&:hover': {
        backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
    },
    outlineColor: "var(--ds-border-focused, #4688EC)",
    border: 'none',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    color: "var(--ds-text-subtle, #505258)"
});
const $9bf89b97db7e04ac$var$iconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.075'
});
const $9bf89b97db7e04ac$var$i18n = (0, $kSwu1.defineMessages)({
    doneEditing: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.done.editing",
        defaultMessage: "Done editing"
    },
    makeEdits: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.make.edits",
        defaultMessage: "Make edits"
    }
});
const $9bf89b97db7e04ac$export$2ada5dce8cd41705 = ({ customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView })=>{
    const intl = (0, $kSwu1.useIntl)();
    const text = showBodiedExtensionRendererView ? intl.formatMessage($9bf89b97db7e04ac$var$i18n.makeEdits) : intl.formatMessage($9bf89b97db7e04ac$var$i18n.doneEditing);
    const icon = showBodiedExtensionRendererView ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        testId: "edit-icon",
        label: ""
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        testId: "check-mark-icon",
        label: ""
    });
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setShowBodiedExtensionRendererView?.(!showBodiedExtensionRendererView);
    }, [
        showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter') handleClick();
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-edit-toggle-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: [
            $9bf89b97db7e04ac$var$buttonContainerStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle-container",
        onMouseOver: ()=>setIsNodeHovered?.(true),
        // @atlassian/a11y/mouse-events-have-key-events: keyboard focus is already handled by the
        // inner <button>'s onFocus/onBlur. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>setIsNodeHovered?.(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        type: "button",
        "data-testid": "edit-toggle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $9bf89b97db7e04ac$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: ()=>setIsNodeHovered?.(true),
        onBlur: ()=>setIsNodeHovered?.(false)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kA6Zo.Flex), {
        as: "span",
        xcss: $9bf89b97db7e04ac$var$iconStyles
    }, icon), text));
};
module.exports["EditToggle"] = $9bf89b97db7e04ac$export$2ada5dce8cd41705;

});

parcelRegister("ggmg0", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $kSwu1 = parcelRequire("kSwu1");


var $dPtk6 = parcelRequire("dPtk6");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");

function $9cb941e776fb1132$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9cb941e776fb1132$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $9cb941e776fb1132$var$showLabelStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $9cb941e776fb1132$var$hideLabelStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $9cb941e776fb1132$var$labelStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-28px',
    // When updating this value, make sure to also update the value in EditToggle.tsx, buttonContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-27px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    borderRadius: "var(--ds-radius-small, 3px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, #505258)",
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-left-margin': {
        marginLeft: "var(--ds-space-negative-150, -12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-nested-left-margin': {
        marginLeft: 0
    },
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-macro-live-page-styles': {
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $9cb941e776fb1132$var$spacerStyles = (0, $buxP3.xcss)({
    height: 'space.200',
    position: 'absolute',
    width: '100%'
});
const $9cb941e776fb1132$var$iconStyles = {
    name: "1s9vzwe",
    styles: "margin-left:var(--ds-space-075, 6px);&.hide-icon{display:none;}"
};
const $9cb941e776fb1132$var$bodiedMacroIconStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $9cb941e776fb1132$var$i18n = (0, $kSwu1.defineMessages)({
    configure: {
        id: "editor-common-extensibility.macro.button.configure",
        defaultMessage: "Configure {macroName}"
    }
});
const $9cb941e776fb1132$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, pluginInjectionApi: _pluginInjectionApi })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = isBodiedMacro;
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        bodied: isBodiedMacro
    });
    const labelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'with-bodied-macro-live-page-styles': isBodiedMacro && showLivePagesBodiedMacrosRendererView,
        'always-hide-label': isBodiedMacro && showBodiedExtensionRendererView,
        // Need this separate class since we don't ever want to show the label during view mode
        'remove-left-margin': !isBodiedMacro && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && !isBodiedMacro && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'extension-icon': true
    });
    const memoizedTooltipValues = (0, $cozmU.useMemo)(()=>({
            macroName: text
        }), [
        text
    ]);
    const tooltipValues = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedTooltipValues : {
        macroName: text
    };
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $9cb941e776fb1132$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseOver: ()=>{
            setIsNodeHovered?.(true);
        },
        // @atlassian/a11y/mouse-events-have-key-events: label visibility on keyboard focus is already
        // handled via the .ak-editor-selected-node CSS class applied by ProseMirror on node selection.
        // No-ops here satisfy the rule.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>{
            setIsNodeHovered?.(false);
        },
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        "data-testid": "new-lozenge-container",
        contentEditable: false
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), {
            ...$9cb941e776fb1132$var$i18n.configure,
            values: tooltipValues
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $9cb941e776fb1132$var$labelStyles,
                !showLivePagesBodiedMacrosRendererView && $9cb941e776fb1132$var$showLabelStyles,
                (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) && $9cb941e776fb1132$var$hideLabelStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: labelClassNames
        }, text, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                $9cb941e776fb1132$var$iconStyles,
                isBodiedMacro && $9cb941e776fb1132$var$bodiedMacroIconStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))), {
            label: ""
        })))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $9cb941e776fb1132$var$spacerStyles
    })));
};
module.exports["ExtensionLabel"] = $9cb941e776fb1132$export$addedb5f7f03bdb1;

});

parcelRegister("1BETI", function(module, exports) {
const $1ba924a21e00fd14$export$d01da3229dfc693b = (node)=>{
    if (node.type.name !== 'bodiedExtension') return false;
    const firstChildNode = node?.content?.firstChild;
    const firstGrandChildNode = firstChildNode?.firstChild;
    // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
    const isEmptyWithPlacholder = firstGrandChildNode?.type?.name === 'placeholder' && firstChildNode?.childCount === 1;
    const isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
    return isEmptyWithPlacholder || isEmptyWithNoContent;
};
module.exports["isEmptyBodiedMacro"] = $1ba924a21e00fd14$export$d01da3229dfc693b;

});

parcelRegister("dBzxx", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $imFKp = parcelRequire("imFKp");

const $cfb4a4c7963ce223$export$c51f29288b3ec9db = 'wider-layout';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfb4a4c7963ce223$var$wrapperStyleWithoutCursor = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
        padding: `0 ${"var(--ds-space-250, 20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.legacy-content': {
        borderRadius: `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}`
    }
});
const $cfb4a4c7963ce223$export$ebf956b2dea5bd2e = /*#__PURE__*/ (0, $lOiVq.css)($cfb4a4c7963ce223$var$wrapperStyleWithoutCursor, ".extension-overflow-wrapper:has(.extension-editable-area){cursor:inherit;}.extension-overflow-wrapper:not(:has(.extension-editable-area)){cursor:pointer;}");
const $cfb4a4c7963ce223$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $cfb4a4c7963ce223$export$a7db06668cad9adb = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $cfb4a4c7963ce223$export$16dcf8c62f81d973 = /*#__PURE__*/ (0, $lOiVq.css)({
    boxSizing: 'border-box',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $cfb4a4c7963ce223$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $cfb4a4c7963ce223$export$2ab74686abf0084 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    }
});
module.exports["widerLayoutClassName"] = $cfb4a4c7963ce223$export$c51f29288b3ec9db;
module.exports["wrapperStyleInheritedCursor"] = $cfb4a4c7963ce223$export$ebf956b2dea5bd2e;
module.exports["header"] = $cfb4a4c7963ce223$export$38e42c68cf43b5d4;
module.exports["extensionContent"] = $cfb4a4c7963ce223$export$16dcf8c62f81d973;
module.exports["contentWrapper"] = $cfb4a4c7963ce223$export$2a82ddc22e8c7fbb;
module.exports["overflowWrapperStyles"] = $cfb4a4c7963ce223$export$2ab74686abf0084;

});

parcelRegister("11KBS", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $3k5Tv = parcelRequire("3k5Tv");


var $dUm2W = parcelRequire("dUm2W");


var $bYEj1 = parcelRequire("bYEj1");


var $imFKp = parcelRequire("imFKp");


var $kMptO = parcelRequire("kMptO");

function $0b8b65b7765a8f32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0b8b65b7765a8f32$var$inlineWrapperStyles = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};
const $0b8b65b7765a8f32$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $0b8b65b7765a8f32$var$MemoizedWidthContextProvider = ({ rendererContainerWidth: rendererContainerWidth, children: children })=>{
    const widthContextValue = (0, $cozmU.useMemo)(()=>(0, $dUm2W.createWidthContext)(rendererContainerWidth), [
        rendererContainerWidth
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthContext).Provider, {
        value: widthContextValue
    }, children);
};
const $0b8b65b7765a8f32$var$LegacyWidthContextProvider = ({ rendererContainerWidth: rendererContainerWidth, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthContext).Provider, {
        value: (0, $dUm2W.createWidthContext)(rendererContainerWidth)
    }, children);
};
const $0b8b65b7765a8f32$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates
    });
    let rendererContainerWidth = 0;
    if ((0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) {
        if (width) {
            const padding = width > (0, $7Y8M5.akEditorFullPageNarrowBreakout) ? (0, $7Y8M5.akEditorGutterPaddingDynamic)() : (0, $7Y8M5.akEditorGutterPaddingReduced);
            rendererContainerWidth = width - padding * 2;
        }
    } else rendererContainerWidth = width ? width - (0, $7Y8M5.akEditorGutterPaddingDynamic)() * 2 : 0;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        node: node,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        setIsNodeHovered: setIsNodeHovered,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $kMptO.wrapperStyle),
            $0b8b65b7765a8f32$var$inlineWrapperStyles,
            showMacroInteractionDesignUpdates && !isLivePageViewMode && $0b8b65b7765a8f32$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also accessible via keyboard selection.
        // No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $imFKp.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    })));
    return (0, $ieeJu.expValEquals)('enghealth-53346_fix_redaction_marker_editor', 'isEnabled', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)($0b8b65b7765a8f32$var$MemoizedWidthContextProvider, {
        rendererContainerWidth: rendererContainerWidth
    }, inlineExtensionInternal) : /*#__PURE__*/ (0, $lOiVq.jsx)($0b8b65b7765a8f32$var$LegacyWidthContextProvider, {
        rendererContainerWidth: rendererContainerWidth
    }, inlineExtensionInternal);
};
var $0b8b65b7765a8f32$export$2e2bcd8739ae039 = $0b8b65b7765a8f32$var$InlineExtension;
module.exports["default"] = $0b8b65b7765a8f32$export$2e2bcd8739ae039;

});

parcelRegister("kMptO", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $imFKp = parcelRequire("imFKp");

const $7fb94a0aa67ad2f6$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-radius-small, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
module.exports["wrapperStyle"] = $7fb94a0aa67ad2f6$export$c4d4f06a25de97f;

});

parcelRegister("1aF4Q", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $5X6fy = parcelRequire("5X6fy");


var $kkFbH = parcelRequire("kkFbH");


var $ieeJu = parcelRequire("ieeJu");


var $3k5Tv = parcelRequire("3k5Tv");


var $4Hles = parcelRequire("4Hles");


var $h9Lux = parcelRequire("h9Lux");

var $RiJVa = parcelRequire("RiJVa");


var $bYEj1 = parcelRequire("bYEj1");


var $2bXc5 = parcelRequire("2bXc5");


var $38lMZ = parcelRequire("38lMZ");


var $1aQhm = parcelRequire("1aQhm");


var $l2oBI = parcelRequire("l2oBI");

function $9dda0932ae9d1ced$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9dda0932ae9d1ced$var$getContainerCssExtendedStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)((0, $4Hles.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`]: /*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $4Hles.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $4Hles.removeMarginsAndBorder))
    });
const $9dda0932ae9d1ced$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
const $9dda0932ae9d1ced$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $9dda0932ae9d1ced$var$hoverStylesOld = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $9dda0932ae9d1ced$var$MultiBodiedExtensionFrames = ({ articleRef: articleRef })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        "data-testid": "multiBodiedExtension--frames",
        "data-multibodiedextension-frames": true,
        ref: articleRef
    });
};
const $9dda0932ae9d1ced$var$isSelectionInsideNode = (selection, node, getPos)=>{
    const nodeStartPosition = getPos();
    if (typeof nodeStartPosition !== 'number' || !selection) return false;
    const nodeEndPosition = nodeStartPosition + node.nodeSize;
    /*
  	selection starts within MBE ||
  	selection ends within MBE ||
  	selection includes MBE
  */ return nodeStartPosition < selection.from && selection.from < nodeEndPosition || nodeStartPosition < selection.to && selection.to < nodeEndPosition || nodeStartPosition >= selection.from && selection.to >= nodeEndPosition;
};
const $9dda0932ae9d1ced$var$useIsSelectionInsideNode = (editorView, node, getPos, enabled)=>{
    const nodeRef = (0, $cozmU.useRef)(node);
    const [isSelectionInside, setIsSelectionInside] = (0, $cozmU.useState)(()=>enabled && $9dda0932ae9d1ced$var$isSelectionInsideNode(editorView.state.selection, node, getPos));
    nodeRef.current = node;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        let animationFrameId;
        const updateSelectionInsideNode = ()=>{
            setIsSelectionInside($9dda0932ae9d1ced$var$isSelectionInsideNode(editorView.state.selection, nodeRef.current, getPos));
        };
        const scheduleUpdateSelectionInsideNode = ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(updateSelectionInsideNode);
        };
        const ownerDocument = editorView.dom.ownerDocument;
        const unbindSelectionChange = (0, $cbY7C.bind)(ownerDocument, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'selectionchange'
        });
        const unbindKeyUp = (0, $cbY7C.bind)(editorView.dom, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'keyup'
        });
        const unbindMouseUp = (0, $cbY7C.bind)(editorView.dom, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'mouseup'
        });
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            unbindSelectionChange();
            unbindKeyUp();
            unbindMouseUp();
        };
    }, [
        editorView,
        getPos,
        enabled
    ]);
    return enabled && isSelectionInside;
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $9dda0932ae9d1ced$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("img", {
            css: $9dda0932ae9d1ced$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        label: title
    }), title);
};
const $9dda0932ae9d1ced$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, allowBodiedOverride: allowBodiedOverride = false })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $RiJVa.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const [activeChildIndex, setActiveChildIndex] = (0, $cozmU.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const childrenContainer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return /*#__PURE__*/ (0, $lOiVq.jsx)($9dda0932ae9d1ced$var$MultiBodiedExtensionFrames, {
            articleRef: articleRef
        });
    }, [
        articleRef
    ]);
    const actions = (0, $1aQhm.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        node: node,
        eventDispatcher: eventDispatcher,
        allowBodiedOverride: allowBodiedOverride,
        childrenContainer: childrenContainer
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $38lMZ.shouldExtensionBreakout)({
        layout: layout,
        editorAppearance: editorAppearance,
        isTopLevelNode: true
    }) : legacyShouldBreakout;
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $h9Lux.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState?.lineLength,
            widthStateWidth: widthState?.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const shouldUseUpdatedChrome = (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true);
    const isSelectionInsideMultiBodiedExtension = $9dda0932ae9d1ced$var$useIsSelectionInsideNode(editorView, node, getPos, shouldUseUpdatedChrome && !isLivePageViewMode);
    const isMultiBodiedExtensionActive = isNodeSelected || isSelectionInsideMultiBodiedExtension;
    const shouldShowChromeOnInteraction = isNodeHovered || isMultiBodiedExtensionActive;
    const shouldShowMultiBodiedExtensionChrome = shouldUseUpdatedChrome ? !isLivePageViewMode && shouldShowChromeOnInteraction : true;
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates && shouldShowMultiBodiedExtensionChrome,
        'with-selected-border': showMacroInteractionDesignUpdates && shouldUseUpdatedChrome && !isLivePageViewMode && isNodeSelected,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const bodyContainerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--body-container');
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const shouldRenderExtensionLozenge = showMacroInteractionDesignUpdates && !isLivePageViewMode && !shouldUseUpdatedChrome;
    const shouldRenderFloatingLabel = showMacroInteractionDesignUpdates && !isLivePageViewMode && shouldUseUpdatedChrome && shouldShowChromeOnInteraction;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, shouldRenderExtensionLozenge && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        node: node,
        showMacroInteractionDesignUpdates: true,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        css: [
            /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ shouldUseUpdatedChrome ? (0, $l2oBI.mbeExtensionWrapperCSSStyles) : (0, $l2oBI.mbeExtensionWrapperCSSStylesOld),
            /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage */ showMacroInteractionDesignUpdates && !isLivePageViewMode && (shouldUseUpdatedChrome ? $9dda0932ae9d1ced$var$hoverStyles : $9dda0932ae9d1ced$var$hoverStylesOld)
        ],
        "data-testid": "multiBodiedExtension--wrapper-editor",
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, shouldRenderFloatingLabel && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2bXc5.ExtensionFloatingLabel), {
        title: title,
        isSelected: isNodeSelected,
        testId: "multiBodiedExtension-floating-label"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: shouldUseUpdatedChrome ? (0, $l2oBI.overlayStyles) : (0, $l2oBI.overlayStylesOld),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $9dda0932ae9d1ced$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $9dda0932ae9d1ced$var$getContainerCssExtendedStyles(activeChildIndex, showMacroInteractionDesignUpdates),
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex
    }, allowBodiedOverride ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: bodyContainerClassNames,
        "data-testid": "multiBodiedExtension--body-container"
    }, extensionHandlerResult) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $4Hles.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), childrenContainer))));
};
const $9dda0932ae9d1ced$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { width: width, lineLength: lineLength } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $lOiVq.jsx)($9dda0932ae9d1ced$var$MultiBodiedExtensionWithWidth, {
        widthState: width === undefined ? undefined : {
            width: width,
            lineLength: lineLength
        },
        ...props
    });
};
var $9dda0932ae9d1ced$export$2e2bcd8739ae039 = $9dda0932ae9d1ced$var$MultiBodiedExtension;
module.exports["default"] = $9dda0932ae9d1ced$export$2e2bcd8739ae039;

});

parcelRegister("4Hles", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $ieeJu = parcelRequire("ieeJu");

function $63365c1923ee5a66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $63365c1923ee5a66$var$mbeExtensionContainerOld = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
// Wraps the navigation bar and extensionFrames when Native Tabs can insert block-control
// widget decorations before frame content.
const $63365c1923ee5a66$var$mbeExtensionContainerNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(.ProseMirror-widget):first-of-type, [data-extension-frame='true'] > .ProseMirror-widget + :not(.ProseMirror-widget):first-of-type": {
            marginTop: 0
        }
    }
});
const $63365c1923ee5a66$var$mbeNavigation = {
    name: "1a47qx2",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, #FFFFFF);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $63365c1923ee5a66$var$extensionFrameContent = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
// Block spacing hook variant of extensionFrameContent. Identical to extensionFrameContent except
// the extension content margins read from the `--ak-editor-extension-block-spacing` CSS custom
// property (falling back to the original token values). Selected only when
// expValEquals('platform_editor_extension_block_spacing') is enabled.
const $63365c1923ee5a66$var$extensionFrameContentWithBlockSpacing = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: `var(--ak-editor-extension-block-spacing, ${"var(--ds-space-150, 12px)"}) !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: `var(--ak-editor-extension-block-spacing, ${"var(--ds-space-100, 8px)"}) !important`
    }
});
const $63365c1923ee5a66$var$extensionFrameContentOld = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $63365c1923ee5a66$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $63365c1923ee5a66$export$9c7196ca47f67390 = {
    mbeNavigation: $63365c1923ee5a66$var$mbeNavigation,
    get mbeExtensionContainer () {
        return (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? $63365c1923ee5a66$var$mbeExtensionContainerNew : $63365c1923ee5a66$var$mbeExtensionContainerOld;
    },
    get extensionFrameContent () {
        if (!(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return $63365c1923ee5a66$var$extensionFrameContentOld;
        // Block spacing hook — when the experiment is on, use the variant whose extension content
        // margins read from --ak-editor-extension-block-spacing (falling back to the originals).
        // expValEquals always fires an exposure event.
        return (0, $ieeJu.expValEquals)('platform_editor_extension_block_spacing', 'isEnabled', true) ? $63365c1923ee5a66$var$extensionFrameContentWithBlockSpacing : $63365c1923ee5a66$var$extensionFrameContent;
    }
};
module.exports["removeMarginsAndBorder"] = $63365c1923ee5a66$export$8df0393dc2d5d656;
module.exports["sharedMultiBodiedExtensionStyles"] = $63365c1923ee5a66$export$9c7196ca47f67390;

});

parcelRegister("2bXc5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4aRua = parcelRequire("4aRua");

const $03c448c8a32873d0$var$floatingLabelStyles = {
    base: "_0bjKvDzXzM _2mHwu81Y8M _0hPCNLDIqT _0KLXrulfZc _2OUyjtYbGa _3iDTPbQ4SZ _37wbyuDIqT _1EqgXlVazu _1YKVNs7dHp _2Zuz6Q2ADO _1Znuxb2ADO _1mT5xdWVPG _4ApkO28HPE _2IhTonLYhK _0fKRyPYvD1 _42Yu6BiZR3",
    selected: "_0KLXruY9q9 _1wydGW1Y8M _0Of8r21Y8M _2IhTonF3IB"
};
const $03c448c8a32873d0$export$ed2d946cb95ebda6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isSelected: isSelected, testId: testId, title: title } = t0;
    const t1 = isSelected && $03c448c8a32873d0$var$floatingLabelStyles.selected;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $03c448c8a32873d0$var$floatingLabelStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isSelected ? "color.text.selected" : "color.text.subtle";
    let t4;
    if ($[2] !== t3 || $[3] !== title) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            size: "small",
            color: t3,
            children: title
        });
        $[2] = t3;
        $[3] = title;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t2 || $[6] !== t4 || $[7] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            contentEditable: false,
            "data-testid": testId,
            className: t2,
            children: t4
        });
        $[5] = t2;
        $[6] = t4;
        $[7] = testId;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ isSelected: isSelected, testId: testId, title: title })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        contentEditable: false,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $03c448c8a32873d0$var$floatingLabelStyles.base,
            isSelected && $03c448c8a32873d0$var$floatingLabelStyles.selected
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            size: "small",
            color: isSelected ? 'color.text.selected' : 'color.text.subtle',
            children: title
        })
    });
module.exports["ExtensionFloatingLabel"] = $03c448c8a32873d0$export$ed2d946cb95ebda6;

});

parcelRegister("1aQhm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $l5pc4 = parcelRequire("l5pc4");

const $2e65762104d9a60b$export$3c7139d93ecb4f1f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer } = t0;
    let t1;
    if ($[0] !== allowBodiedOverride || $[1] !== childrenContainer || $[2] !== editorView || $[3] !== eventDispatcher || $[4] !== getPos || $[5] !== node || $[6] !== updateActiveChild) {
        t1 = {
            changeActive (index, options) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                const selection = options?.selection ?? "none";
                if (selection === "none") return updateActiveChildResult;
                const pos = getPos();
                if (typeof pos !== "number") return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === "multiBodiedExtension" && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    let desiredPos = pos;
                    for(let i = 0; i < index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos = desiredPos + (possiblyMbeNode?.content?.child(i)?.nodeSize || 0);
                    const targetFrame = possiblyMbeNode.content.child(index);
                    if (selection === "start") dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + 1))));
                    else dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + targetFrame.nodeSize), -1)));
                    editorView.focus();
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state_0, dispatch: dispatch_0 } = editorView;
                const p = state_0.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error("Could not create paragraph");
                const frame = state_0.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos_0 = getPos();
                if (typeof pos_0 !== "number" || !frame) throw new Error("Could not create frame or position not valid");
                const insertAt = Math.min((pos_0 || 1) + node.content.size, state_0.doc.content.size);
                const tr = state_0.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch_0(tr);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index_0) {
                const pos_1 = getPos();
                if (typeof pos_1 !== "number" || typeof index_0 !== "number") throw new Error("Position or index not valid");
                const { state: state_1, dispatch: dispatch_1 } = editorView;
                if (node.content.childCount === 1) {
                    const tr_0 = state_1.tr;
                    tr_0.deleteRange(pos_1, pos_1 + node.content.size);
                    dispatch_1(tr_0);
                    return true;
                }
                const $pos = state_1.doc.resolve(pos_1);
                const $startNodePos = state_1.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index_0);
                const maybeFrameNode = state_1.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error("Could not find frame node");
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr_1 = state_1.tr;
                tr_1.deleteRange(startFramePosition, endFramePosition);
                dispatch_1(tr_1);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            reorderChildren (fromIndex, toIndex) {
                const pos_2 = getPos();
                if (typeof pos_2 !== "number" || typeof fromIndex !== "number" || typeof toIndex !== "number") throw new Error("Position or index not valid");
                if (fromIndex === toIndex) return true;
                const { state: state_2, dispatch: dispatch_2 } = editorView;
                const currentNode = state_2.doc.nodeAt(pos_2);
                if (!currentNode) throw new Error("Could not find extension node");
                const $pos_0 = state_2.doc.resolve(pos_2);
                const $startNodePos_0 = state_2.doc.resolve($pos_0.start($pos_0.depth + 1));
                const frames = [];
                currentNode.content.forEach((child)=>{
                    frames.push(child);
                });
                if (fromIndex >= frames.length || toIndex >= frames.length) throw new Error("Index out of bounds");
                const [removed] = frames.splice(fromIndex, 1);
                frames.splice(toIndex, 0, removed);
                const tr_2 = state_2.tr;
                const containerStart = $startNodePos_0.pos;
                const containerEnd = containerStart + currentNode.content.size;
                tr_2.replaceWith(containerStart, containerEnd, frames);
                dispatch_2(tr_2);
                return true;
            },
            updateParameters (parameters, analyticsChangedParam) {
                const { state: state_3, dispatch: dispatch_3 } = editorView;
                const pos_3 = getPos();
                if (typeof pos_3 !== "number") throw new Error("Position not valid");
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(0, $ieeJu.expValEquals)("confluence_native_tabs_experiment", "isEnabled", true) ? {
                            ...parameters
                        } : {
                            macroParams: parameters
                        }
                    }
                };
                const tr_3 = state_3.tr.setNodeMarkup(pos_3, null, updatedParameters);
                dispatch_3(tr_3);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).UPDATE_PARAMETERS, node, eventDispatcher, analyticsChangedParam && (0, $ieeJu.expValEquals)("confluence_native_tabs_experiment", "isEnabled", true) ? {
                    changedParams: analyticsChangedParam
                } : undefined);
                return true;
            },
            getChildren () {
                const { state: state_4 } = editorView;
                const pos_4 = getPos();
                if (typeof pos_4 !== "number") return [];
                const children = state_4.doc.nodeAt(pos_4)?.content;
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error("Could not provide children container");
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
        $[0] = allowBodiedOverride;
        $[1] = childrenContainer;
        $[2] = editorView;
        $[3] = eventDispatcher;
        $[4] = getPos;
        $[5] = node;
        $[6] = updateActiveChild;
        $[7] = t1;
    } else t1 = $[7];
    const actions = t1;
    return actions;
} : ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            changeActive (index, options) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                const selection = options?.selection ?? 'none';
                if (selection === 'none') return updateActiveChildResult;
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === 'multiBodiedExtension' && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    let desiredPos = pos;
                    for(let i = 0; i < index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos += possiblyMbeNode?.content?.child(i)?.nodeSize || 0;
                    const targetFrame = possiblyMbeNode.content.child(index);
                    if (selection === 'start') // +1 moves past the extensionFrame opening token; TextSelection.near() finds
                    // the nearest valid text cursor position from there.
                    dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + 1))));
                    else // Place cursor at the end of the target frame's content.
                    // -1 bias searches backward from the frame's closing token.
                    dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + targetFrame.nodeSize), -1)));
                    editorView.focus();
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state_0, dispatch: dispatch_0 } = editorView;
                const p = state_0.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state_0.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos_0 = getPos();
                if (typeof pos_0 !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos_0 || 1) + node.content.size, state_0.doc.content.size);
                const tr = state_0.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch_0(tr);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index_0) {
                const pos_1 = getPos();
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos_1 !== 'number' || typeof index_0 !== 'number') throw new Error('Position or index not valid');
                const { state: state_1, dispatch: dispatch_1 } = editorView;
                if (node.content.childCount === 1) {
                    const tr_0 = state_1.tr;
                    tr_0.deleteRange(pos_1, pos_1 + node.content.size);
                    dispatch_1(tr_0);
                    return true;
                }
                const $pos = state_1.doc.resolve(pos_1);
                const $startNodePos = state_1.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index_0);
                const maybeFrameNode = state_1.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr_1 = state_1.tr;
                tr_1.deleteRange(startFramePosition, endFramePosition);
                dispatch_1(tr_1);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            reorderChildren (fromIndex, toIndex) {
                const pos_2 = getPos();
                if (typeof pos_2 !== 'number' || typeof fromIndex !== 'number' || typeof toIndex !== 'number') throw new Error('Position or index not valid');
                if (fromIndex === toIndex) return true;
                const { state: state_2, dispatch: dispatch_2 } = editorView;
                // Use current node from state (not stale closure)
                const currentNode = state_2.doc.nodeAt(pos_2);
                if (!currentNode) throw new Error('Could not find extension node');
                const $pos_0 = state_2.doc.resolve(pos_2);
                const $startNodePos_0 = state_2.doc.resolve($pos_0.start($pos_0.depth + 1));
                // Collect all current frame nodes
                const frames = [];
                currentNode.content.forEach((child)=>{
                    frames.push(child);
                });
                if (fromIndex >= frames.length || toIndex >= frames.length) throw new Error('Index out of bounds');
                // Reorder the frames array in memory
                const [removed] = frames.splice(fromIndex, 1);
                frames.splice(toIndex, 0, removed);
                // Atomically replace the entire MBE content with reordered frames
                const tr_2 = state_2.tr;
                const containerStart = $startNodePos_0.pos;
                const containerEnd = containerStart + currentNode.content.size;
                tr_2.replaceWith(containerStart, containerEnd, frames);
                dispatch_2(tr_2);
                return true;
            },
            updateParameters (parameters, analyticsChangedParam) {
                const { state: state_3, dispatch: dispatch_3 } = editorView;
                const pos_3 = getPos();
                if (typeof pos_3 !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? {
                            ...parameters
                        } : {
                            macroParams: parameters
                        }
                    }
                };
                const tr_3 = state_3.tr.setNodeMarkup(pos_3, null, updatedParameters);
                dispatch_3(tr_3);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).UPDATE_PARAMETERS, node, eventDispatcher, analyticsChangedParam && (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? {
                    changedParams: analyticsChangedParam
                } : undefined);
                return true;
            },
            getChildren () {
                const { state: state_4 } = editorView;
                const pos_4 = getPos();
                if (typeof pos_4 !== 'number') return [];
                const children = state_4.doc.nodeAt(pos_4)?.content;
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error('Could not provide children container');
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher,
        allowBodiedOverride,
        childrenContainer
    ]);
    return actions;
};
module.exports["useMultiBodiedExtensionActions"] = $2e65762104d9a60b$export$3c7139d93ecb4f1f;

});

parcelRegister("l5pc4", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $fGIRV = parcelRequire("fGIRV");


var $6pnwK = parcelRequire("6pnwK");

const $d90b6fce9b402e45$export$c39676f5ca8bcb0e = (action, node, eventDispatcher, attributes)=>{
    const analyticsDispatch = (0, $fGIRV.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $6pnwK.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount,
                ...attributes
            }
        }
    });
};
module.exports["sendMBEAnalyticsEvent"] = $d90b6fce9b402e45$export$c39676f5ca8bcb0e;

});

parcelRegister("l2oBI", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $imFKp = parcelRequire("imFKp");

function $084d3298f342321b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $084d3298f342321b$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-negative-250, -20px)",
        marginRight: "var(--ds-space-negative-250, -20px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-selected-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $084d3298f342321b$export$6bb53a1c4e28a730 = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $084d3298f342321b$export$9b0df2896b2eff02 = {
    name: "1ir4r0n",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin-top:var(--ds-space-negative-100, -8px);margin-left:var(--ds-space-negative-250, -20px);}"
};
const $084d3298f342321b$export$85f4d1340338a338 = {
    name: "1jgeuox",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};
module.exports["mbeExtensionWrapperCSSStyles"] = $084d3298f342321b$export$4226a1fc882c4ef9;
module.exports["mbeExtensionWrapperCSSStylesOld"] = $084d3298f342321b$export$6bb53a1c4e28a730;
module.exports["overlayStyles"] = $084d3298f342321b$export$9b0df2896b2eff02;
module.exports["overlayStylesOld"] = $084d3298f342321b$export$85f4d1340338a338;

});

parcelRegister("ak92H", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $fngNp = parcelRequire("fngNp");


var $1caeZ = parcelRequire("1caeZ");

function $6906174335f6af7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6906174335f6af7c$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
const $6906174335f6af7c$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-container, :has(.extension-edit-toggle-container:hover) .extension-container': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-container:hover) .extension-label, :has(.extension-edit-toggle-container:hover) .extension-label, .extension-label:hover': {
        opacity: 1,
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        boxShadow: 'none',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.always-hide-label': {
            opacity: 0,
            cursor: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.with-bodied-macro-live-page-styles': {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-icon, :has(.extension-container:hover) .extension-icon, :has(.extension-edit-toggle-container:hover) .extension-icon': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-edit-toggle-container, :has(.extension-container:hover) .extension-edit-toggle-container, .extension-edit-toggle-container:hover': {
        opacity: 1
    }
});
const $6906174335f6af7c$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, intl: intl })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1caeZ.ExtensionSSRReactContextsProvider), {
        intl: intl
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "data-testid": "extension-node-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: wrapperClassNames,
        css: [
            $6906174335f6af7c$var$styles,
            $6906174335f6af7c$var$hoverStyles
        ]
    }, children, nodeType === 'inlineExtension' && (0, $fngNp.ZERO_WIDTH_SPACE)));
};
module.exports["ExtensionNodeWrapper"] = $6906174335f6af7c$export$f97fc055ac075140;

});

parcelRegister("1caeZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");


var $iAEsk = parcelRequire("iAEsk");

const $83b25d113ab31975$export$36cc1c5797436ac4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ExtensionSSRReactContextsProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, intl: intl } = t0;
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    let t1;
    if ($[0] !== children || $[1] !== intl) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
            value: intl,
            children: children
        });
        $[0] = children;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ExtensionSSRReactContextsProvider({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
        value: intl,
        children: children
    });
};
module.exports["ExtensionSSRReactContextsProvider"] = $83b25d113ab31975$export$36cc1c5797436ac4;

});

parcelRegister("6svtM", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iDrrr = parcelRequire("iDrrr");


var $c8XQL = parcelRequire("c8XQL");

function $1652590ce3e9c88a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1652590ce3e9c88a$export$be24b091af3609e7 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs9"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $1652590ce3e9c88a$export$7bc887464090036 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs8"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $1652590ce3e9c88a$export$141d6bfd196b561 = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e1b3haxs7"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $1652590ce3e9c88a$export$3644aa125e4d2449 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs6"
})({
    name: "5w7vad",
    styles: "display:flex;align-items:center;justify-content:center;width:36px;height:36px"
});
const $1652590ce3e9c88a$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $1652590ce3e9c88a$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e1b3haxs4"
})({
    name: "a6q67k",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--ds-text, #292A2E)"
});
const $1652590ce3e9c88a$export$50ad5d386685fccb = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '& > span': (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                marginRight: "var(--ds-space-negative-025, -2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                marginTop: "var(--ds-space-025, 2px)"
            } : {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $1652590ce3e9c88a$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs2"
})({
    name: "1w8issl",
    styles: "margin-left:var(--ds-space-250, 20px);flex:none;color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1652590ce3e9c88a$export$934cc98367d9ca68 = 48;
const $1652590ce3e9c88a$export$e924bd8329057f42 = 44;
const $1652590ce3e9c88a$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? "var(--ds-background-selected, #E9F2FE)" : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${props.height ?? $1652590ce3e9c88a$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $1652590ce3e9c88a$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs0"
})({
    name: "8l7ck6",
    styles: "padding-left:var(--ds-space-050, 4px);color:var(--ds-text-subtle, #505258)"
});
module.exports["RowStyle"] = $1652590ce3e9c88a$export$be24b091af3609e7;
module.exports["RowStyleNext"] = $1652590ce3e9c88a$export$7bc887464090036;
module.exports["AvatarStyle"] = $1652590ce3e9c88a$export$141d6bfd196b561;
module.exports["AvatarSkeletonWrapper"] = $1652590ce3e9c88a$export$3644aa125e4d2449;
module.exports["NameSectionStyle"] = $1652590ce3e9c88a$export$159b59de9966d2d3;
module.exports["FullNameStyle"] = $1652590ce3e9c88a$export$d1c198a7fd873fad;
module.exports["InfoSectionStyle"] = $1652590ce3e9c88a$export$50ad5d386685fccb;
module.exports["TimeStyle"] = $1652590ce3e9c88a$export$cf4c6e54e715dfd9;
module.exports["MENTION_ITEM_HEIGHT"] = $1652590ce3e9c88a$export$934cc98367d9ca68;
module.exports["MENTION_ITEM_HEIGHT_REFRESHED"] = $1652590ce3e9c88a$export$e924bd8329057f42;
module.exports["MentionItemStyle"] = $1652590ce3e9c88a$export$cf80dda9d7a88a01;
module.exports["AccessSectionStyle"] = $1652590ce3e9c88a$export$7bf9a8fa7c04527a;

});

parcelRegister("doJuV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $IOtUu = parcelRequire("IOtUu");


var $cozmU = parcelRequire("cozmU");


var $fodiz = parcelRequire("fodiz");


var $ieeJu = parcelRequire("ieeJu");


var $caelp = parcelRequire("caelp");


var $j1Rvl = parcelRequire("j1Rvl");


var $j3F9y = parcelRequire("j3F9y");


var $iD1Wv = parcelRequire("iD1Wv");


var $fdYSR = parcelRequire("fdYSR");


var $6svtM = parcelRequire("6svtM");


var $9G1o9 = parcelRequire("9G1o9");


var $hDw5O = parcelRequire("hDw5O");


var $21cx5 = parcelRequire("21cx5");


var $8Ep7E = parcelRequire("8Ep7E");


// Lazy-loaded so `@atlaskit/skeleton` (only needed for the loading
// placeholder) doesn't enter the bundle for every `@atlaskit/mention`
// consumer — only when an `isPlaceholder` mention is actually rendered.
const $dae2fb0401c0f17b$var$MentionItemPlaceholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("5rLfl")));
const $dae2fb0401c0f17b$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
function $dae2fb0401c0f17b$var$renderTag(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: lozenge,
        color: "standard",
        isRemovable: false,
        migration_fallback: "lozenge"
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        const color = appearance ? $dae2fb0401c0f17b$var$lozengeAppearanceToTagColor[appearance] : 'standard';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: text,
            color: color,
            isRemovable: false,
            migration_fallback: "lozenge"
        });
    }
    return null;
}
function $dae2fb0401c0f17b$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, lozenge);
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: appearance
        }, text);
    }
    return null;
}
function $dae2fb0401c0f17b$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.TimeStyle), null, time);
    return null;
}
class $dae2fb0401c0f17b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { mention: mention, selected: selected, forwardedRef: forwardedRef, height: height } = this.props;
        const { id: id, highlight: highlight, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        if (mention.isPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.MentionItemStyle), {
                height: height,
                "aria-hidden": true
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dae2fb0401c0f17b$var$MentionItemPlaceholder, {
            height: height,
            forwardedRef: forwardedRef,
            id: id
        })));
        const { time: time } = presence || {};
        const restricted = (0, $caelp.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
        let RowStyle = (0, $6svtM.RowStyle);
        let isAgent = false;
        if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes')) {
            RowStyle = (0, $6svtM.RowStyleNext);
            isAgent = (0, $caelp.isAgentMention)(mention);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.MentionItemStyle), {
            selected: selected,
            height: height,
            onMouseDown: this.onMentionSelected,
            onMouseMove: this.onMentionMenuItemMouseMove,
            onMouseEnter: this.onMentionMenuItemMouseEnter,
            "data-mention-item": true,
            "data-testid": `mention-item-${id}`,
            "data-mention-id": id,
            "data-mention-name": mentionName,
            "data-mention-is-agent": isAgent ? 'true' : undefined,
            "data-selected": selected,
            ref: forwardedRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RowStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.AvatarStyle), {
            restricted: restricted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Ep7E.MentionAvatar), {
            selected: selected,
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.NameSectionStyle), {
            restricted: restricted
        }, (0, $9G1o9.renderHighlight)((0, $6svtM.FullNameStyle), name, nameHighlights), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hDw5O.default), {
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.InfoSectionStyle), {
            restricted: restricted
        }, (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $dae2fb0401c0f17b$var$renderTag(lozenge) : $dae2fb0401c0f17b$var$renderLozenge(lozenge), $dae2fb0401c0f17b$var$renderTime(time)), restricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iD1Wv.default), {
            name: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.AccessSectionStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rvl.NoAccessLabel), null, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdYSR.default), {
                label: text
            }))))) : null, isXProductUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            color: xProductUserInfoIconColor,
            label: ''
        }))));
    }
    constructor(...args){
        super(...args);
        // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $j3F9y.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        };
        this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        };
        this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}
const $dae2fb0401c0f17b$export$604dabd552e94336 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dae2fb0401c0f17b$export$2e2bcd8739ae039, {
            ...props,
            forwardedRef: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dae2fb0401c0f17b$export$2e2bcd8739ae039, {
        ...props,
        forwardedRef: ref
    });
});
module.exports["default"] = $dae2fb0401c0f17b$export$2e2bcd8739ae039;
module.exports["MentionItemWithRef"] = $dae2fb0401c0f17b$export$604dabd552e94336;

});

parcelRegister("j3F9y", function(module, exports) {
function $d4691eb235268492$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $d4691eb235268492$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $d4691eb235268492$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}
module.exports["mouseLocation"] = $d4691eb235268492$export$fd3cd03f8ac42187;
module.exports["actualMouseMove"] = $d4691eb235268492$export$de744e30016241b0;
module.exports["leftClick"] = $d4691eb235268492$export$34ebdaf2c517ae75;

});

parcelRegister("fdYSR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $e8e9337ea066cb42$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("4efpo"))).then((module)=>({
            default: module.default
        })));
var $e8e9337ea066cb42$export$2e2bcd8739ae039 = $e8e9337ea066cb42$var$AsyncLockCircleIcon;
module.exports["default"] = $e8e9337ea066cb42$export$2e2bcd8739ae039;

});

parcelRegister("9G1o9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $022db5897bf17146$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReactComponent, null, prefixText, parts.map((part, index)=>{
        if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", {
            key: index
        }, part.value);
        return part.value;
    }));
}
module.exports["renderHighlight"] = $022db5897bf17146$export$2bcf43b01d5314f5;

});

parcelRegister("hDw5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $caelp = parcelRequire("caelp");


var $k6XCk = parcelRequire("k6XCk");


var $adD94 = parcelRequire("adD94");


var $016fw = parcelRequire("016fw");


var $92AHJ = parcelRequire("92AHJ");

class $ecd8f9ff3570eba7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016fw.DescriptionBylineStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $92AHJ.messages).xProductMentionDescription));
        switch(userType){
            case (0, $caelp.UserType)[(0, $caelp.UserType).TEAM]:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $adD94.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k6XCk.default), {
                    mention: this.props.mention
                });
        }
    }
}
module.exports["default"] = $ecd8f9ff3570eba7$export$2e2bcd8739ae039;

});

parcelRegister("k6XCk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9G1o9 = parcelRequire("9G1o9");


var $016fw = parcelRequire("016fw");

class $b7b06fc6f9fb609a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $9G1o9.renderHighlight)((0, $016fw.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}
module.exports["default"] = $b7b06fc6f9fb609a$export$2e2bcd8739ae039;

});

parcelRegister("016fw", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $c8XQL = parcelRequire("c8XQL");

function $b0724d5a86bed298$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b0724d5a86bed298$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e1bkpfff0"
})({
    name: "mffxab",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-025, 2px);display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});
module.exports["DescriptionBylineStyle"] = $b0724d5a86bed298$export$607100a5f9cc9977;

});

parcelRegister("adD94", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $016fw = parcelRequire("016fw");


var $92AHJ = parcelRequire("92AHJ");

class $073279505be3a44b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args);
        this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $92AHJ.messages).plus50MembersWithYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $92AHJ.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $92AHJ.messages).plus50MembersWithoutYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $92AHJ.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        };
        this.getBylineComponent = (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016fw.DescriptionBylineStyle), null, message);
    }
}
module.exports["default"] = $073279505be3a44b$export$2e2bcd8739ae039;

});

parcelRegister("8Ep7E", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");

var $dWZMi = parcelRequire("dWZMi");


var $2c3Eq = parcelRequire("2c3Eq");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $caelp = parcelRequire("caelp");

const $fdc9240587cfc5be$export$35f495c0dc0a1015 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { mention: mention, selected: selected } = t0;
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    let t1;
    if ($[0] !== presence) {
        t1 = presence || {};
        $[0] = presence;
        $[1] = t1;
    } else t1 = $[1];
    const { status: status } = t1;
    if ((0, $caelp.isTeamMention)(mention)) {
        let t2;
        if ($[2] !== avatarUrl || $[3] !== borderColor) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), {
                src: avatarUrl,
                size: "medium",
                borderColor: borderColor
            });
            $[2] = avatarUrl;
            $[3] = borderColor;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t2;
    if ($[5] !== mention) {
        t2 = (0, $caelp.isAppMention)(mention) && mention.appType === "agent" && (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents");
        $[5] = mention;
        $[6] = t2;
    } else t2 = $[6];
    const shouldRenderAgentMentionAvatar = t2;
    let t3;
    if ($[7] !== appType || $[8] !== shouldRenderAgentMentionAvatar) {
        t3 = shouldRenderAgentMentionAvatar ? "hexagon" : (0, $iDrrr.fg)("jira_ai_agent_avatar_issue_view_comment_mentions") ? (0, $dWZMi.default)(appType) : undefined;
        $[7] = appType;
        $[8] = shouldRenderAgentMentionAvatar;
        $[9] = t3;
    } else t3 = $[9];
    const avatarAppearance = t3;
    let t4;
    if ($[10] !== avatarAppearance || $[11] !== avatarUrl || $[12] !== borderColor || $[13] !== status) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "medium",
            presence: status,
            borderColor: borderColor,
            appearance: avatarAppearance
        });
        $[10] = avatarAppearance;
        $[11] = avatarUrl;
        $[12] = borderColor;
        $[13] = status;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ mention: mention, selected: selected })=>{
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    const { status: status } = presence || {};
    if ((0, $caelp.isTeamMention)(mention)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    // Agent providers can request GraphQL `identityAccount { picture }` and pass it as
    // `avatarUrl`; this component only applies the hexagon agent shape.
    const shouldRenderAgentMentionAvatar = (0, $caelp.isAppMention)(mention) && mention.appType === 'agent' && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const avatarAppearance = shouldRenderAgentMentionAvatar ? 'hexagon' : (0, $iDrrr.fg)('jira_ai_agent_avatar_issue_view_comment_mentions') ? (0, $dWZMi.default)(appType) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor,
        appearance: avatarAppearance
    });
};
module.exports["MentionAvatar"] = $fdc9240587cfc5be$export$35f495c0dc0a1015;

});

parcelRegister("5rLfl", function(module, exports) {

let $3f741f8ed946a2d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f741f8ed946a2d2$var$load("gLYf9").then(()=>parcelRequire('l5rkb'));

});

parcelRegister("1z5OI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a51ba451bb0e014332d07d25fddb7fe2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $123d927b95b85f60$var$_react = $123d927b95b85f60$var$_interopRequireDefault((parcelRequire("cozmU")));

var $123d927b95b85f60$var$_baseNew = $123d927b95b85f60$var$_interopRequireDefault((parcelRequire("gElAV")));
function $123d927b95b85f60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Telescope".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/telescope
 * Usage guidance:
 * Known uses: Discover feature in Atlassian Home
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $123d927b95b85f60$var$TelescopeIcon = (props)=>/*#__PURE__*/ $123d927b95b85f60$var$_react.default.createElement($123d927b95b85f60$var$_baseNew.default, Object.assign({
        name: "TelescopeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.687 9.505a.75.75 0 0 1 1.183.072l3.75 5.5-1.24.846L9 12.432V16H7.5l-.001-3.567-2.38 3.49-1.239-.845 3.75-5.5z"/><path fill="currentcolor" d="m10.66 2.963 1.531 2.653L14.44 4.51l-1.698-2.94zM4.414 7.146l1.032 1.787 5.396-2.654L9.411 3.8zm11.392-3.27c.397.69.13 1.571-.584 1.922L3.118 11.75a1.687 1.687 0 0 1-2.206-.67L.289 10A1.687 1.687 0 0 1 .81 7.756L12.018.249l.126-.076a1.375 1.375 0 0 1 1.83.53zM2.21 10.33c.05.085.156.117.245.074l1.64-.808-.93-1.613-1.52 1.019a.187.187 0 0 0-.058.249z"/>`
    }, props));
$123d927b95b85f60$var$TelescopeIcon.displayName = 'TelescopeIcon';
var $123d927b95b85f60$var$_default = module.exports.default = $123d927b95b85f60$var$TelescopeIcon;

});

parcelRegister("cAQ1C", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");

const $0a91b5498053916e$var$actions = {
    register: (handler)=>({ setState: setState, getState: getState })=>{
            if (getState().handlers.includes(handler)) return;
            setState({
                handlers: [
                    ...getState().handlers,
                    handler
                ]
            });
        },
    unregister: (handler)=>({ setState: setState, getState: getState })=>{
            setState({
                handlers: getState().handlers.filter((h)=>h !== handler)
            });
        },
    openFileDialog: ()=>({ getState: getState })=>{
            // Call the most recently registered handler (last mount wins)
            const { handlers: handlers } = getState();
            const lastHandler = handlers[handlers.length - 1];
            lastHandler?.();
        }
};
const $0a91b5498053916e$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    name: 'file-upload-trigger',
    initialState: {
        handlers: []
    },
    actions: $0a91b5498053916e$var$actions
});
module.exports["Store"] = $0a91b5498053916e$export$390f32400eaf98c9;

});

parcelRegister("banCF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iVxGn = parcelRequire("iVxGn");

parcelRequire("cgKJK");
var $96dZ7 = parcelRequire("96dZ7");




var $aSzLn = parcelRequire("aSzLn");


var $6nvBr = parcelRequire("6nvBr");

const $021914730fb82814$var$forEachActor = (actorRef, callback)=>{
    callback(actorRef);
    const children = actorRef.getSnapshot().children;
    if (children) Object.values(children).forEach((child)=>{
        $021914730fb82814$var$forEachActor(child, callback);
    });
};
function $021914730fb82814$var$stopRootWithRehydration(actorRef) {
    // persist snapshot here in a custom way allows us to persist inline actors and to preserve actor references
    // we do it to avoid setState in useEffect when the effect gets "reconnected"
    // this currently only happens in Strict Effects but it simulates the Offscreen aka Activity API
    // it also just allows us to end up with a somewhat more predictable behavior for the users
    const persistedSnapshots = [];
    $021914730fb82814$var$forEachActor(actorRef, (ref)=>{
        persistedSnapshots.push([
            ref,
            ref.getSnapshot()
        ]);
        // muting observers allow us to avoid `useSelector` from being notified about the stopped snapshot
        // React reconnects its subscribers (from the useSyncExternalStore) on its own
        // and userland subscibers should basically always do the same anyway
        // as each subscription should have its own cleanup logic and that should be called each such reconnect
        ref.observers = new Set();
    });
    const systemSnapshot = actorRef.system.getSnapshot?.();
    actorRef.stop();
    actorRef.system._snapshot = systemSnapshot;
    persistedSnapshots.forEach(([ref, snapshot])=>{
        ref._processingStatus = 0;
        ref._snapshot = snapshot;
    });
}
function $021914730fb82814$var$useIdleActorRef(logic, ...[options]) {
    let [[currentConfig, actorRef], setCurrent] = (0, $cozmU.useState)(()=>{
        const actorRef = (0, $96dZ7.A)(logic, options);
        return [
            logic.config,
            actorRef
        ];
    });
    if (logic.config !== currentConfig) {
        const newActorRef = (0, $96dZ7.A)(logic, {
            ...options,
            snapshot: actorRef.getPersistedSnapshot({
                __unsafeAllowInlineActors: true
            })
        });
        setCurrent([
            logic.config,
            newActorRef
        ]);
        actorRef = newActorRef;
    }
    // TODO: consider using `useAsapEffect` that would do this in `useInsertionEffect` is that's available
    (0, $iVxGn.default)(()=>{
        actorRef.logic.implementations = logic.implementations;
    });
    return actorRef;
}
function $021914730fb82814$export$e92bd910f9c89ff6(machine, ...[options, observerOrListener]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(machine, options);
    (0, $cozmU.useEffect)(()=>{
        if (!observerOrListener) return;
        const sub = actorRef.subscribe((0, $96dZ7.L)(observerOrListener));
        return ()=>{
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return actorRef;
}
function $021914730fb82814$var$defaultCompare(a, b) {
    return a === b;
}
function $021914730fb82814$export$2105062e25df4afe(actor, selector, compare = $021914730fb82814$var$defaultCompare) {
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        if (!actor) return ()=>{};
        const { unsubscribe: unsubscribe } = actor.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actor
    ]);
    const boundGetSnapshot = (0, $cozmU.useCallback)(()=>actor?.getSnapshot(), [
        actor
    ]);
    const selectedSnapshot = (0, $aSzLn.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}
function $021914730fb82814$export$72ba36f8308928ab(actorLogic, actorOptions) {
    const ReactContext = /*#__PURE__*/ $cozmU.createContext(null);
    const OriginalProvider = ReactContext.Provider;
    function Provider({ children: children, logic: providedLogic = actorLogic, machine: machine, options: providedOptions }) {
        if (machine) throw new Error(`The "machine" prop has been deprecated. Please use "logic" instead.`);
        const actor = $021914730fb82814$export$e92bd910f9c89ff6(providedLogic, {
            ...actorOptions,
            ...providedOptions
        });
        return /*#__PURE__*/ $cozmU.createElement(OriginalProvider, {
            value: actor,
            children: children
        });
    }
    // TODO: add properties to actor ref to make more descriptive
    Provider.displayName = `ActorProvider`;
    function useContext() {
        const actor = $cozmU.useContext(ReactContext);
        if (!actor) throw new Error(`You used a hook from "${Provider.displayName}" but it's not inside a <${Provider.displayName}> component.`);
        return actor;
    }
    function useSelector$1(selector, compare) {
        const actor = useContext();
        return $021914730fb82814$export$2105062e25df4afe(actor, selector, compare);
    }
    return {
        Provider: Provider,
        useActorRef: useContext,
        useSelector: useSelector$1
    };
}
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $021914730fb82814$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $021914730fb82814$export$d36bdfa510afb180(objA, objB) {
    if ($021914730fb82814$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$021914730fb82814$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $021914730fb82814$export$25c4ab29592aabd9(logic, ...[options]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(logic, options);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        return actorRef.getSnapshot();
    }, [
        actorRef
    ]);
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = actorRef.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actorRef
    ]);
    const actorSnapshot = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return [
        actorSnapshot,
        actorRef.send,
        actorRef
    ];
}
/** @alias useActor */ function $021914730fb82814$export$e0338c4153421160(machine, ...[options]) {
    return $021914730fb82814$export$25c4ab29592aabd9(machine, options);
}
module.exports["useActorRef"] = $021914730fb82814$export$e92bd910f9c89ff6;
module.exports["useSelector"] = $021914730fb82814$export$2105062e25df4afe;
module.exports["createActorContext"] = $021914730fb82814$export$72ba36f8308928ab;
module.exports["shallowEqual"] = $021914730fb82814$export$d36bdfa510afb180;
module.exports["useMachine"] = $021914730fb82814$export$e0338c4153421160;

});

parcelRegister("iVxGn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $dc77ad8576485322$export$2e2bcd8739ae039 = (0, $cozmU.useLayoutEffect);
module.exports["default"] = $dc77ad8576485322$export$2e2bcd8739ae039;

});

parcelRegister("cgKJK", function(module, exports) {
$parcel$export(module.exports, "createActor", () => (parcelRequire("96dZ7")).A);
$parcel$export(module.exports, "assign", () => (parcelRequire("dpSRg")).a);

var $eXLWP = parcelRequire("eXLWP");


var $96dZ7 = parcelRequire("96dZ7");


var $dpSRg = parcelRequire("dpSRg");

parcelRequire("e6Soq");

/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $8eeb3b9b9ffbca82$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $96dZ7.t)(type);
    if (!types.includes(event.type)) {
        const typesText = types.length === 1 ? `type "${types[0]}"` : `one of types "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
const $8eeb3b9b9ffbca82$var$cache = new WeakMap();
function $8eeb3b9b9ffbca82$var$memo(object, key, fn) {
    let memoizedData = $8eeb3b9b9ffbca82$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $8eeb3b9b9ffbca82$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $8eeb3b9b9ffbca82$var$EMPTY_OBJECT = {};
const $8eeb3b9b9ffbca82$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $8eeb3b9b9ffbca82$export$342f24f5edd47b1 {
    /** @internal */ _initialize() {
        this.transitions = (0, $96dZ7.f)(this);
        if (this.config.always) this.always = (0, $96dZ7.a)(this.config.always).map((t)=>(0, $96dZ7.b)(this, (0, $96dZ7.N), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $96dZ7.m)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>({
                    ...t,
                    actions: t.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction)
                })),
            entry: this.entry.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            exit: this.exit.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'invoke', ()=>(0, $96dZ7.t)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                const resolvedId = invokeConfig.id ?? (0, $96dZ7.c)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $96dZ7.c)(this.id, i)}`;
                return {
                    ...invokeConfig,
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError, ...invokeDefValues } = invokeConfig;
                        return {
                            ...invokeDefValues,
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        };
                    }
                };
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'delayedTransitions', ()=>(0, $96dZ7.g)(this));
    }
    get initial() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'initial', ()=>(0, $96dZ7.d)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $8eeb3b9b9ffbca82$var$memo(this, `candidates-${eventType}`, ()=>(0, $96dZ7.h)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $96dZ7.e)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const events = new Set([
            ...this.transitions.keys()
        ].filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $96dZ7.S));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $96dZ7.m)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $8eeb3b9b9ffbca82$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $96dZ7.t)(this.config.entry).slice();
        this.exit = (0, $96dZ7.t)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $96dZ7.t)(config.tags).slice();
    }
}
const $8eeb3b9b9ffbca82$var$STATE_IDENTIFIER = '#';
class $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a {
    /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(this.config, {
            actions: {
                ...actions,
                ...implementations.actions
            },
            guards: {
                ...guards,
                ...implementations.guards
            },
            actors: {
                ...actors,
                ...implementations.actors
            },
            delays: {
                ...delays,
                ...implementations.delays
            }
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $96dZ7.r)(this.root, config.value);
        const nodeSet = (0, $96dZ7.i)((0, $96dZ7.j)(this.root, resolvedStateValue));
        return (0, $96dZ7.k)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $96dZ7.l)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).microstates;
    }
    getTransitionData(snapshot, event) {
        return (0, $96dZ7.o)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */ getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $96dZ7.k)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $96dZ7.p)(preInitial, initEvent, actorScope, [
                (0, $dpSRg.a)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $96dZ7.q)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue);
        const nextState = (0, $96dZ7.s)([
            {
                target: [
                    ...(0, $96dZ7.u)(this.root)
                ],
                source: this.root,
                reenter: true,
                actions: [],
                eventType: null,
                toJSON: null // TODO: fix
            }
        ], preInitialState, actorScope, initEvent, true, internalQueue);
        const { snapshot: macroState } = (0, $96dZ7.n)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $96dZ7.v)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $96dZ7.w)(fullPath[0]) ? fullPath[0].slice($8eeb3b9b9ffbca82$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $96dZ7.x)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $96dZ7.y)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $96dZ7.z)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $96dZ7.A)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        const restoredSnapshot = (0, $96dZ7.k)({
            ...snapshot,
            children: children,
            _nodes: Array.from((0, $96dZ7.i)((0, $96dZ7.j)(this.root, snapshot.value)))
        }, this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $96dZ7.$)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        this.implementations = {
            actors: implementations?.actors ?? {},
            actions: implementations?.actions ?? {},
            delays: implementations?.delays ?? {},
            guards: implementations?.guards ?? {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(config, implementations);
}
/** @internal */ function $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic) {
    const self = (0, $96dZ7.A)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $8eeb3b9b9ffbca82$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $8eeb3b9b9ffbca82$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
function $8eeb3b9b9ffbca82$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        createMachine: (config)=>$8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8({
                ...config,
                schemas: schemas
            }, {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $8eeb3b9b9ffbca82$export$7413adad607e2cdf {
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $8eeb3b9b9ffbca82$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
const $8eeb3b9b9ffbca82$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $8eeb3b9b9ffbca82$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = {
        ...$8eeb3b9b9ffbca82$var$defaultWaitForOptions,
        ...options
    };
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal?.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub?.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}
module.exports["createMachine"] = $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8;
module.exports["setup"] = $8eeb3b9b9ffbca82$export$de27182ff8187d6c;

});

parcelRegister("eXLWP", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

parcelRequire("e6Soq");

/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return {
                ...snapshot,
                context: transition(snapshot.context, event, actorScope)
            };
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $ae4bc4d1d8af478f$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $ae4bc4d1d8af478f$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    var _callbackState;
                    (_callbackState = callbackState).receivers ?? (_callbackState.receivers = new Set());
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            const callbackState = $ae4bc4d1d8af478f$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $96dZ7.X)) {
                state = {
                    ...state,
                    status: 'stopped',
                    error: undefined
                };
                callbackState.dispose?.();
                return state;
            }
            callbackState.receivers?.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $ae4bc4d1d8af478f$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = {
                            ...snapshot,
                            context: event.data
                        };
                        return newSnapshot;
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...snapshot,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...snapshot,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    snapshot._subscription.unsubscribe();
                    return {
                        ...snapshot,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...state })=>state,
        restoreSnapshot: (state)=>({
                ...state,
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $ae4bc4d1d8af478f$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...state,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    state._subscription.unsubscribe();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...snapshot })=>snapshot,
        restoreSnapshot: (snapshot)=>({
                ...snapshot,
                _subscription: undefined
            })
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $ae4bc4d1d8af478f$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return {
                            ...state,
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        };
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined
                    };
                case 0, $96dZ7.X:
                    $ae4bc4d1d8af478f$var$controllerMap.get(scope.self)?.abort();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined
                    };
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $ae4bc4d1d8af478f$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$emptyLogic = $ae4bc4d1d8af478f$export$439a4be7208a15ca((_)=>undefined, undefined);
function $ae4bc4d1d8af478f$export$302970cd5518279b() {
    return (0, $96dZ7.A)($ae4bc4d1d8af478f$var$emptyLogic);
}
module.exports["fromCallback"] = $ae4bc4d1d8af478f$export$d0deb4828877173;
module.exports["fromObservable"] = $ae4bc4d1d8af478f$export$4b2432e2d8723823;
module.exports["fromPromise"] = $ae4bc4d1d8af478f$export$60f45028237c39d1;

});

parcelRegister("96dZ7", function(module, exports) {

var $e6Soq = parcelRequire("e6Soq");

class $69ff85b27d828958$var$Mailbox {
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldnt start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
}
const $69ff85b27d828958$export$25ce5a424b770e84 = '.';
const $69ff85b27d828958$var$TARGETLESS_KEY = '';
const $69ff85b27d828958$export$a07804094c3ecf2d = '';
const $69ff85b27d828958$var$STATE_IDENTIFIER = '#';
const $69ff85b27d828958$var$WILDCARD = '*';
const $69ff85b27d828958$var$XSTATE_INIT = 'xstate.init';
const $69ff85b27d828958$export$e7c866399fa523f5 = 'xstate.error';
const $69ff85b27d828958$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $69ff85b27d828958$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $69ff85b27d828958$export$71cec2538cb2c617(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $69ff85b27d828958$export$9e5f44173e64f162(input) {
    return {
        type: $69ff85b27d828958$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $69ff85b27d828958$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $69ff85b27d828958$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $69ff85b27d828958$export$b4171a6734a65d42(parentStateId, childStateId) {
    const parentStateValue = $69ff85b27d828958$var$toStateValue(parentStateId);
    const childStateValue = $69ff85b27d828958$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $69ff85b27d828958$export$b4171a6734a65d42(parentStateValue[key], childStateValue[key]);
    });
}
function $69ff85b27d828958$export$90a7f3efeed30595(stateId) {
    if ($69ff85b27d828958$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $69ff85b27d828958$var$toStateValue(stateValue) {
    if ($69ff85b27d828958$export$7f8ddf7c7c20b3cd(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $69ff85b27d828958$export$90a7f3efeed30595(stateValue);
    return $69ff85b27d828958$export$3466f893ebf79586(statePath);
}
function $69ff85b27d828958$export$3466f893ebf79586(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $69ff85b27d828958$export$953cecd6e717a553(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $69ff85b27d828958$var$toArrayStrict(value) {
    if ($69ff85b27d828958$var$isArray(value)) return value;
    return [
        value
    ];
}
function $69ff85b27d828958$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $69ff85b27d828958$var$toArrayStrict(value);
}
function $69ff85b27d828958$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $69ff85b27d828958$var$isArray(value) {
    return Array.isArray(value);
}
function $69ff85b27d828958$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $69ff85b27d828958$export$407448d2b89b1813(configLike) {
    return $69ff85b27d828958$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $69ff85b27d828958$var$normalizeTarget(target) {
    if (target === undefined || target === $69ff85b27d828958$var$TARGETLESS_KEY) return undefined;
    return $69ff85b27d828958$export$625550452a3fa3ec(target);
}
function $69ff85b27d828958$export$61196ced6d74a310(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $69ff85b27d828958$export$db3b6bfb95261072(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $69ff85b27d828958$export$df995fae86a55f06(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $69ff85b27d828958$export$9bb611d729802a56(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
function $69ff85b27d828958$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $69ff85b27d828958$var$idCounter = 0;
function $69ff85b27d828958$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = {
            ...event,
            rootId: rootActor.sessionId
        };
        inspectionObservers.forEach((observer)=>observer.next?.(resolvedInspectionEvent));
    };
    const system = {
        _snapshot: {
            _scheduledEvents: (options?.snapshot && options.snapshot.scheduler) ?? {}
        },
        _bookId: ()=>`x:${$69ff85b27d828958$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $69ff85b27d828958$export$61196ced6d74a310(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: {
                    ...system._snapshot._scheduledEvents
                }
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
let $69ff85b27d828958$var$executingCustomAction = false;
const $69ff85b27d828958$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $69ff85b27d828958$export$971d5caa766a69d7 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $69ff85b27d828958$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $69ff85b27d828958$export$ef35774e6d314e91 {
    _initState(persistedState) {
        try {
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = {
                ...snapshot,
                status: 'error',
                error: err
            };
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $69ff85b27d828958$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $69ff85b27d828958$export$61196ced6d74a310(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    observer.complete?.();
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $69ff85b27d828958$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $69ff85b27d828958$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this._systemId) this.system._set(this._systemId, this);
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $69ff85b27d828958$export$9e5f44173e64f162(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.NotStarted) {
            this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $69ff85b27d828958$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            observer.complete?.();
        } catch (err) {
            $69ff85b27d828958$var$reportUnhandledError(err);
        }
        this.observers.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $69ff85b27d828958$var$reportUnhandledError(err);
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError || (reportError = !errorListener);
            try {
                errorListener?.(err);
            } catch (err2) {
                $69ff85b27d828958$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        if (reportError) $69ff85b27d828958$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $69ff85b27d828958$export$71cec2538cb2c617(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $e6Soq.devToolsAdapter);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$69ff85b27d828958$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this._systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = {
            ...$69ff85b27d828958$var$defaultOptions,
            ...options
        };
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $69ff85b27d828958$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($69ff85b27d828958$export$61196ced6d74a310(inspect));
        this.sessionId = this.system._bookId();
        this.id = id ?? this.sessionId;
        this.logger = options?.logger ?? this.system._logger;
        this.clock = options?.clock ?? this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        this.src = resolvedOptions.src ?? logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)handler(emittedEvent);
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $69ff85b27d828958$var$executingCustomAction;
                    try {
                        $69ff85b27d828958$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $69ff85b27d828958$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this._systemId = systemId;
            this.system._set(systemId, this);
        }
        this._initState(options?.snapshot ?? options?.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $69ff85b27d828958$export$ebd11618f299a286(logic, ...[options]) {
    return new $69ff85b27d828958$export$ef35774e6d314e91(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $69ff85b27d828958$export$e7094788287c5e9b = $69ff85b27d828958$export$ebd11618f299a286;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $69ff85b27d828958$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $69ff85b27d828958$export$3a1a48c8f6ef640e(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $69ff85b27d828958$var$resolveCancel;
    cancel.execute = $69ff85b27d828958$var$executeCancel;
    return cancel;
}
function $69ff85b27d828958$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $69ff85b27d828958$export$df995fae86a55f06(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $69ff85b27d828958$export$ebd11618f299a286(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: {
                ...snapshot.children,
                [resolvedId]: actorRef
            }
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        actorRef.start();
    });
}
function $69ff85b27d828958$export$56c0d5a1e737357d(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $69ff85b27d828958$var$resolveSpawn;
    spawnChild1.execute = $69ff85b27d828958$var$executeSpawn;
    return spawnChild1;
}
function $69ff85b27d828958$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = {
            ...children
        };
        delete children[resolvedActorRef.id];
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $69ff85b27d828958$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    actorScope.system._unregister(actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $69ff85b27d828958$export$db202ddc8be9136(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $69ff85b27d828958$var$resolveStop;
    stop.execute = $69ff85b27d828958$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $69ff85b27d828958$export$3722cfe417b6ed86 = $69ff85b27d828958$export$db202ddc8be9136;
function $69ff85b27d828958$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $69ff85b27d828958$export$2329c99376c9d0a4(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $69ff85b27d828958$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $69ff85b27d828958$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$69ff85b27d828958$export$f1e1789686576879(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $69ff85b27d828958$export$a9c23c6ac3fc3eca(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $69ff85b27d828958$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $69ff85b27d828958$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$96f57966bedc81b4(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $69ff85b27d828958$var$checkAnd;
    and.guards = guards;
    return and;
}
function $69ff85b27d828958$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$d66501df72047452(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $69ff85b27d828958$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $69ff85b27d828958$export$f1e1789686576879(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
const $69ff85b27d828958$var$isAtomicStateNode = (stateNode)=>stateNode.type === 'atomic' || stateNode.type === 'final';
function $69ff85b27d828958$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $69ff85b27d828958$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $69ff85b27d828958$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($69ff85b27d828958$var$isAtomicStateNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $69ff85b27d828958$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $69ff85b27d828958$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $69ff85b27d828958$var$getStateValue(rootNode, stateNodes) {
    const config = $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes);
    return $69ff85b27d828958$var$getValueFromAdj(rootNode, $69ff85b27d828958$var$getAdjList(config));
}
function $69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $69ff85b27d828958$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $69ff85b27d828958$var$getChildren(stateNode).every((sn)=>$69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $69ff85b27d828958$export$efccba1c4a2ef57b = (str)=>str[0] === $69ff85b27d828958$var$STATE_IDENTIFIER;
function $69ff85b27d828958$export$dda1d9f60106f0e9(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>{
        // check if transition is a wildcard transition,
        // which matches any non-transient events
        if (eventDescriptor === $69ff85b27d828958$var$WILDCARD) return true;
        if (!eventDescriptor.endsWith('.*')) return false;
        const partialEventTokens = eventDescriptor.split('.');
        const eventTokens = receivedEventType.split('.');
        for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
            const partialEventToken = partialEventTokens[tokenIndex];
            const eventToken = eventTokens[tokenIndex];
            if (partialEventToken === '*') {
                const isLastToken = tokenIndex === partialEventTokens.length - 1;
                return isLastToken;
            }
            if (partialEventToken !== eventToken) return false;
        }
        return true;
    }).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $69ff85b27d828958$export$39b482c5e57630a8(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $69ff85b27d828958$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($69ff85b27d828958$export$c4ce752e73470fba(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($69ff85b27d828958$export$3a1a48c8f6ef640e(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $69ff85b27d828958$export$625550452a3fa3ec(resolvedTransition).map((transition)=>({
                ...transition,
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return {
            ...$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, delayedTransition.event, delayedTransition),
            delay: delay
        };
    });
}
function $69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(transitionConfig.target);
    const reenter = transitionConfig.reenter ?? false;
    const target = $69ff85b27d828958$var$resolveTarget(stateNode, normalizedTarget);
    const transition = {
        ...transitionConfig,
        actions: $69ff85b27d828958$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    };
    return transition;
}
function $69ff85b27d828958$export$2d1720544b23b823(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $69ff85b27d828958$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(transitionsConfig).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(stateNode.config.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onError).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onSnapshot).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
function $69ff85b27d828958$export$4368d992c4eafac0(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $69ff85b27d828958$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $69ff85b27d828958$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($69ff85b27d828958$export$efccba1c4a2ef57b(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $69ff85b27d828958$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, t) : t)
    };
}
function $69ff85b27d828958$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $69ff85b27d828958$export$3b14a55fb2447963(stateNode);
    for (const initialState of states)for (const ancestor of $69ff85b27d828958$var$getProperAncestors(initialState, stateNode))states.add(ancestor);
    return states;
}
function $69ff85b27d828958$export$3b14a55fb2447963(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $69ff85b27d828958$var$getStateNode(stateNode, stateKey) {
    if ($69ff85b27d828958$export$efccba1c4a2ef57b(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, statePath) {
    if (typeof statePath === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch  {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $69ff85b27d828958$export$90a7f3efeed30595(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $69ff85b27d828958$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $69ff85b27d828958$export$35e795649ee09318(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$69ff85b27d828958$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $69ff85b27d828958$export$35e795649ee09318(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $69ff85b27d828958$export$ae1af26003f05816(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $69ff85b27d828958$export$ae1af26003f05816(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $69ff85b27d828958$export$ae1af26003f05816(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $69ff85b27d828958$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $69ff85b27d828958$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $69ff85b27d828958$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $69ff85b27d828958$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($69ff85b27d828958$var$hasIntersection($69ff85b27d828958$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $69ff85b27d828958$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($69ff85b27d828958$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $69ff85b27d828958$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $69ff85b27d828958$var$getProperAncestors(head, undefined)){
        if (tail.every((sn)=>$69ff85b27d828958$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($69ff85b27d828958$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $69ff85b27d828958$var$getEffectiveTargetStates($69ff85b27d828958$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $69ff85b27d828958$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $69ff85b27d828958$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $69ff85b27d828958$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $69ff85b27d828958$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    const statesToExit = new Set();
    for (const t of transitions)if (t.target?.length) {
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($69ff85b27d828958$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $69ff85b27d828958$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    if (!transitions.length) return currentSnapshot;
    const mutStateNodeSet = new Set(currentSnapshot._nodes);
    let historyValue = currentSnapshot.historyValue;
    const filteredTransitions = $69ff85b27d828958$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
    let nextState = currentSnapshot;
    // Exit states
    if (!isInitial) [nextState, historyValue] = $69ff85b27d828958$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
    // Execute transition content
    nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
    // Enter states
    nextState = $69ff85b27d828958$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
    const nextStateNodes = [
        ...mutStateNodeSet
    ];
    if (nextState.status === 'done') nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
    // eslint-disable-next-line no-useless-catch
    try {
        if (historyValue === currentSnapshot.historyValue && $69ff85b27d828958$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return nextState;
        return $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextState, {
            _nodes: nextStateNodes,
            historyValue: historyValue
        });
    } catch (e) {
        // TODO: Refactor this once proper error handling is implemented.
        // See https://github.com/statelyai/rfcs/pull/4
        throw e;
    }
}
function $69ff85b27d828958$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $69ff85b27d828958$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $69ff85b27d828958$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $69ff85b27d828958$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $69ff85b27d828958$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $69ff85b27d828958$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($69ff85b27d828958$export$56c0d5a1e737357d(invokeDef.src, {
            ...invokeDef,
            syncSnapshot: !!invokeDef.onSnapshot
        }));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = parent?.type === 'parallel' ? parent : parent?.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if (parent?.type === 'compound') internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $69ff85b27d828958$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while(ancestorMarker?.type === 'parallel' && !completedNodes.has(ancestorMarker) && $69ff85b27d828958$export$882b5998b3b9117c(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextSnapshot, {
                status: 'done',
                output: $69ff85b27d828958$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $69ff85b27d828958$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$69ff85b27d828958$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $69ff85b27d828958$var$getProperAncestors(s, domain);
            if (domain?.type === 'parallel') ancestors.push(domain);
            $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $69ff85b27d828958$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($69ff85b27d828958$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                statesToEnter.add(s);
                if (historyDefaultTransition === stateNode.parent?.initial) statesForDefaultEntry.add(stateNode.parent);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$69ff85b27d828958$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $69ff85b27d828958$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(stateNode).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                if (!$69ff85b27d828958$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $69ff85b27d828958$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(anc).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode));
}
function $69ff85b27d828958$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $69ff85b27d828958$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $69ff85b27d828958$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$69ff85b27d828958$var$isAtomicStateNode(sn) && $69ff85b27d828958$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory ?? (changedHistory = {
            ...historyValue
        });
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$69ff85b27d828958$export$db202ddc8be9136(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $69ff85b27d828958$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $69ff85b27d828958$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries?.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $69ff85b27d828958$export$ffb5f4729a158638(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries?.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $69ff85b27d828958$export$7ccc53e8f1e7dfc5(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microstates = [];
    function addMicrostate(microstate, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: microstate,
            _transitions: transitions
        });
        microstates.push(microstate);
    }
    // Handle stop event
    if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
        nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08($69ff85b27d828958$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostate(nextSnapshot, event, []);
        return {
            snapshot: nextSnapshot,
            microstates: microstates
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $69ff85b27d828958$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $69ff85b27d828958$var$isErrorActorEvent(currentEvent);
        const transitions = $69ff85b27d828958$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldnt be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostate(nextSnapshot, currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microstates: microstates
            };
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        addMicrostate(nextSnapshot, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $69ff85b27d828958$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $69ff85b27d828958$var$selectTransitions(nextEvent, nextSnapshot);
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $69ff85b27d828958$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microstates: microstates
    };
}
function $69ff85b27d828958$var$stopChildren(nextState, event, actorScope) {
    return $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$69ff85b27d828958$export$db202ddc8be9136(child)), [], undefined);
}
function $69ff85b27d828958$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $69ff85b27d828958$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($69ff85b27d828958$var$isAtomicStateNode);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($69ff85b27d828958$var$getProperAncestors(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $69ff85b27d828958$export$f1e1789686576879(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $69ff85b27d828958$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $69ff85b27d828958$export$43caf9889c228507(rootNode, stateValue) {
    const allStateNodes = $69ff85b27d828958$export$23f2a1d2818174ef($69ff85b27d828958$export$35e795649ee09318(rootNode, stateValue));
    return $69ff85b27d828958$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $69ff85b27d828958$export$7f8ddf7c7c20b3cd(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $69ff85b27d828958$var$machineSnapshotMatches = function matches(testValue) {
    return $69ff85b27d828958$export$b4171a6734a65d42(testValue, this.value);
};
const $69ff85b27d828958$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $69ff85b27d828958$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!transitionData?.length && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $69ff85b27d828958$var$machineSnapshotToJSON = function toJSON() {
    const { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches, ...jsonValues } = this;
    return {
        ...jsonValues,
        tags: Array.from(tags)
    };
};
const $69ff85b27d828958$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $69ff85b27d828958$export$342063e11d6c3cad(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $69ff85b27d828958$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $69ff85b27d828958$var$machineSnapshotMatches,
        hasTag: $69ff85b27d828958$var$machineSnapshotHasTag,
        can: $69ff85b27d828958$var$machineSnapshotCan,
        getMeta: $69ff85b27d828958$var$machineSnapshotGetMeta,
        toJSON: $69ff85b27d828958$var$machineSnapshotToJSON
    };
}
function $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, config = {}) {
    return $69ff85b27d828958$export$342063e11d6c3cad({
        ...snapshot,
        ...config
    }, snapshot.machine);
}
function $69ff85b27d828958$export$4a5767248b18ef41(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON, ...jsonValues } = snapshot;
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child._systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = {
        ...jsonValues,
        context: $69ff85b27d828958$var$persistContext(context),
        children: childrenJson
    };
    return persisted;
}
function $69ff85b27d828958$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                    ...contextPart
                });
                copy[key] = {
                    xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $69ff85b27d828958$var$persistContext(value);
                if (result !== value) {
                    copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                        ...contextPart
                    });
                    copy[key] = result;
                }
            }
        }
    }
    return copy ?? contextPart;
}
function $69ff85b27d828958$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $69ff85b27d828958$export$c4ce752e73470fba(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options?.id;
    raise.delay = options?.delay;
    raise.resolve = $69ff85b27d828958$var$resolveRaise;
    raise.execute = $69ff85b27d828958$var$executeRaise;
    return raise;
}
module.exports["S"] = $69ff85b27d828958$export$25ce5a424b770e84;
module.exports["N"] = $69ff85b27d828958$export$a07804094c3ecf2d;
module.exports["V"] = $69ff85b27d828958$export$e7c866399fa523f5;
module.exports["X"] = $69ff85b27d828958$export$78acf4525d8a74c4;
module.exports["W"] = $69ff85b27d828958$export$71cec2538cb2c617;
module.exports["q"] = $69ff85b27d828958$export$9e5f44173e64f162;
module.exports["v"] = $69ff85b27d828958$export$90a7f3efeed30595;
module.exports["m"] = $69ff85b27d828958$export$953cecd6e717a553;
module.exports["t"] = $69ff85b27d828958$export$625550452a3fa3ec;
module.exports["a"] = $69ff85b27d828958$export$407448d2b89b1813;
module.exports["L"] = $69ff85b27d828958$export$61196ced6d74a310;
module.exports["c"] = $69ff85b27d828958$export$db3b6bfb95261072;
module.exports["z"] = $69ff85b27d828958$export$df995fae86a55f06;
module.exports["$"] = $69ff85b27d828958$export$3d8c2f653ac9d0b9;
module.exports["T"] = $69ff85b27d828958$export$971d5caa766a69d7;
module.exports["A"] = $69ff85b27d828958$export$ebd11618f299a286;
module.exports["M"] = $69ff85b27d828958$export$3a1a48c8f6ef640e;
module.exports["U"] = $69ff85b27d828958$export$3a6d5c9ae78a2c08;
module.exports["P"] = $69ff85b27d828958$export$56c0d5a1e737357d;
module.exports["R"] = $69ff85b27d828958$export$db202ddc8be9136;
module.exports["w"] = $69ff85b27d828958$export$efccba1c4a2ef57b;
module.exports["e"] = $69ff85b27d828958$export$f1e1789686576879;
module.exports["i"] = $69ff85b27d828958$export$23f2a1d2818174ef;
module.exports["l"] = $69ff85b27d828958$export$882b5998b3b9117c;
module.exports["h"] = $69ff85b27d828958$export$dda1d9f60106f0e9;
module.exports["g"] = $69ff85b27d828958$export$39b482c5e57630a8;
module.exports["O"] = $69ff85b27d828958$export$c4ce752e73470fba;
module.exports["b"] = $69ff85b27d828958$export$8b22cf2602fb60ce;
module.exports["f"] = $69ff85b27d828958$export$2d1720544b23b823;
module.exports["d"] = $69ff85b27d828958$export$4368d992c4eafac0;
module.exports["x"] = $69ff85b27d828958$export$d141bba7fdc215a3;
module.exports["u"] = $69ff85b27d828958$export$3b14a55fb2447963;
module.exports["j"] = $69ff85b27d828958$export$35e795649ee09318;
module.exports["o"] = $69ff85b27d828958$export$ae1af26003f05816;
module.exports["s"] = $69ff85b27d828958$export$2408f22a0fab9ae5;
module.exports["p"] = $69ff85b27d828958$export$ffb5f4729a158638;
module.exports["n"] = $69ff85b27d828958$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $69ff85b27d828958$export$43caf9889c228507;
module.exports["k"] = $69ff85b27d828958$export$342063e11d6c3cad;
module.exports["y"] = $69ff85b27d828958$export$4a5767248b18ef41;

});

parcelRegister("e6Soq", function(module, exports) {
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $a45bd1884ca79325$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $a45bd1884ca79325$var$getDevTools() {
    const w = $a45bd1884ca79325$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $a45bd1884ca79325$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $a45bd1884ca79325$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
};
module.exports["devToolsAdapter"] = $a45bd1884ca79325$export$3ee8010769463234;

});

parcelRegister("dpSRg", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

function $9c4829d96c0398b3$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options = {})=>{
        const { systemId: systemId, input: input } = options;
        if (typeof src === 'string') {
            const logic = (0, $96dZ7.z)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $96dZ7.A)(logic, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: typeof input === 'function' ? input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : input,
                src: src,
                systemId: systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $96dZ7.A)(src, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: options.input,
                src: src,
                systemId: systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $96dZ7.T).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $9c4829d96c0398b3$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $9c4829d96c0398b3$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $96dZ7.U)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? {
                ...snapshot.children,
                ...spawnedChildren
            } : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $9c4829d96c0398b3$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $9c4829d96c0398b3$var$resolveAssign;
    return assign;
}
function $9c4829d96c0398b3$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $9c4829d96c0398b3$export$f1e1789686576879(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $9c4829d96c0398b3$var$resolveEmit;
    emit.execute = $9c4829d96c0398b3$var$executeEmit;
    return emit;
}
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: Replace with native `NoInfer` when TS issue gets fixed:
// https://github.com/microsoft/TypeScript/pull/57673
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $9c4829d96c0398b3$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $9c4829d96c0398b3$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = extra.deferredActorIds?.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $9c4829d96c0398b3$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $96dZ7.V) ? (0, $96dZ7.W)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $9c4829d96c0398b3$export$db3b6bfb95261072(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options?.id;
    sendTo.delay = options?.delay;
    sendTo.resolve = $9c4829d96c0398b3$var$resolveSendTo;
    sendTo.retryResolve = $9c4829d96c0398b3$var$retryResolveSendTo;
    sendTo.execute = $9c4829d96c0398b3$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $9c4829d96c0398b3$export$2408f22a0fab9ae5(event, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072($9c4829d96c0398b3$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $9c4829d96c0398b3$export$2d1720544b23b823(target, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072(target, ({ event: event })=>event, options);
}
function $9c4829d96c0398b3$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push($9c4829d96c0398b3$export$407448d2b89b1813(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $96dZ7.M)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $96dZ7.O)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($9c4829d96c0398b3$export$db3b6bfb95261072(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($9c4829d96c0398b3$export$2408f22a0fab9ae5(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $96dZ7.P)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $96dZ7.R)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($9c4829d96c0398b3$export$f1e1789686576879(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $96dZ7.e)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $9c4829d96c0398b3$export$8b22cf2602fb60ce(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $9c4829d96c0398b3$var$resolveEnqueueActions;
    return enqueueActions;
}
function $9c4829d96c0398b3$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $9c4829d96c0398b3$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $9c4829d96c0398b3$var$resolveLog;
    log1.execute = $9c4829d96c0398b3$var$executeLog;
    return log1;
}
module.exports["a"] = $9c4829d96c0398b3$export$407448d2b89b1813;
module.exports["e"] = $9c4829d96c0398b3$export$f1e1789686576879;
module.exports["c"] = $9c4829d96c0398b3$export$db3b6bfb95261072;
module.exports["b"] = $9c4829d96c0398b3$export$8b22cf2602fb60ce;

});

parcelRegister("5VSNw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a59ec0f880a08336$var$styles = {
    container: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VxpxF _39xV02xpxF"
};
const $a59ec0f880a08336$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $a59ec0f880a08336$var$RovoLogoSVG = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { label: label, testId: testId } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        };
        t2 = (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ]);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: "img",
            "aria-label": label,
            "data-testid": testId,
            dangerouslySetInnerHTML: t1,
            className: t2
        });
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        },
        className: (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ])
    });
const $a59ec0f880a08336$export$4476d508de061a72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
            label: label,
            testId: testId
        });
        $[0] = label;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $a59ec0f880a08336$export$4476d508de061a72;

});

parcelRegister("3N2DH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $5VSNw = parcelRequire("5VSNw");

var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");


var $cXtTj = parcelRequire("cXtTj");


var $dTHYM = parcelRequire("dTHYM");

var $dUI0h = parcelRequire("dUI0h");


var $7sJoX = parcelRequire("7sJoX");


var $blZUD = parcelRequire("blZUD");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jPaq9 = parcelRequire("jPaq9");


var $hdBxM = parcelRequire("hdBxM");


var $4yg9g = parcelRequire("4yg9g");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kMkDS = parcelRequire("kMkDS");


var $hS1LZ = parcelRequire("hS1LZ");


var $8VrqA = parcelRequire("8VrqA");


var $lsp0E = parcelRequire("lsp0E");

const $c1b3e570a8bf3f0c$var$styles = {
    popupContainer: "_0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    formWrapper: "_43nrzT4F84",
    sendIconWrapper: "_03SyCP8HPE",
    rovoChatMoreOptionsButtonContainer: "_0GTcwR4F84",
    rovoChatOpenChatIcon: "_0LQT5EFQfX"
};
const $c1b3e570a8bf3f0c$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $6cFsl.di)((0, $cXtTj.default), (0, $hS1LZ.useRovoChatHighlightActions));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $hS1LZ.useRovoChatHighlightActionsActions)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $hS1LZ.useRovoChatHighlightActions)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $cozmU.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $cozmU.useCallback)((values, form)=>{
        const formattedPrompt = (0, $kMkDS.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $lsp0E.default).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $lsp0E.default).rovoChatExplainPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $lsp0E.default).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $lsp0E.default).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $lsp0E.default).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $lsp0E.default).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $c1b3e570a8bf3f0c$var$styles.popupContainer,
            space: "space.150"
        }, rovoChatPromptOptions.map((option)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $jPaq9.ChatPill), {
                key: option.id,
                testId: option.id,
                onClick: ()=>{
                    const formattedPrompt_0 = (0, $kMkDS.appendADFContent)(selectedContent, option.prompt);
                    if (onClickPromptOverride) {
                        onClickPromptOverride(formattedPrompt_0);
                        sendAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                            attributes: {
                                actionType: option.actionType,
                                product: product
                            }
                        });
                        return;
                    }
                    publish({
                        type: 'chat-new',
                        source: `${product}-context-menu`,
                        data: {
                            name: option.prompt.substring(0, 30),
                            dialogues: [],
                            prompt: formattedPrompt_0
                        }
                    });
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                        attributes: {
                            actionType: option.actionType,
                            product: product
                        }
                    });
                }
            }, option.optionText);
        }), (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: "prompt"
        }, ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
            ), {
                onClick: (e)=>e.stopPropagation(),
                ...fieldPropsRest,
                testId: "context-menu-rovo-chat-custom-prompt",
                id: "context-menu-rovo-chat-custom-prompt",
                autoComplete: "off",
                elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                    isDisabled: !dirty || !value,
                    label: formatMessage((0, $lsp0E.default).rovoChatCustomPromptSubmitButtonText),
                    type: "submit",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                    spacing: "compact"
                })),
                placeholder: formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder),
                "aria-label": formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder)
            }))) : /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, ({ formProps: formProps })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.formWrapper
            }, /*#__PURE__*/ $cozmU.createElement("form", formProps, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
                name: "prompt"
            }, ({ fieldProps: { value: value_0, ...fieldPropsRest_0 }, meta: { dirty: dirty_0 } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
                ), {
                    onClick: (e_0)=>e_0.stopPropagation(),
                    ...fieldPropsRest_0,
                    testId: "context-menu-rovo-chat-custom-prompt",
                    id: "context-menu-rovo-chat-custom-prompt",
                    autoComplete: "off",
                    elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                        isDisabled: !dirty_0 || !value_0,
                        label: formatMessage((0, $lsp0E.default).rovoChatCustomPromptSubmitButtonText),
                        type: "submit",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                        spacing: "compact"
                    })),
                    placeholder: formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder),
                    "aria-label": formatMessage((0, $lsp0E.default).rovoChatCustomPromptPlaceholder)
                }))))));
    };
    const isToolbarAIFCEnabled = (0, $fqVYq.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $lsp0E.default).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $5VSNw.AIChatIcon), {
            label: ""
        }),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, formatMessage((0, $lsp0E.default).rovoChatAskRovoButtonText)));
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: formatMessage((0, $lsp0E.default).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatOpenChatIcon
            }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
                size: "xsmall"
            })),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $lsp0E.default).rovoChatAskRovoButtonText)))), /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        placement: "bottom-start",
        isOpen: isMoreOptionsPopupOpen,
        onClose: onClose,
        content: renderPopupContent,
        zIndex: 600,
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatMoreOptionsButtonContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                id: "context-menu-rovo-chat-more-options",
                testId: "context-menu-rovo-chat-more-options",
                isTooltipDisabled: false,
                icon: (props)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...props,
                        label: formatMessage((0, $lsp0E.default).rovoChatMoreOptionsTooltip),
                        size: "small"
                    }),
                label: formatMessage((0, $lsp0E.default).rovoChatMoreOptionsTooltip),
                onClick: ()=>{
                    setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                        attributes: {
                            product: product
                        }
                    });
                }
            }))
    }));
};
module.exports["RovoChatHighlightActions"] = $c1b3e570a8bf3f0c$export$1ccbc9113b239d47;

});

parcelRegister("hS1LZ", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fb521c50b890daa$var$store = (0, $8s9DV.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $7fb521c50b890daa$export$6c9cf98a64763bb1 = (0, $kBr4q.createHook)($7fb521c50b890daa$var$store);
const $7fb521c50b890daa$export$f1e33ed2d48967b4 = (0, $kBr4q.createActionsHook)($7fb521c50b890daa$var$store);
module.exports["useRovoChatHighlightActions"] = $7fb521c50b890daa$export$6c9cf98a64763bb1;
module.exports["useRovoChatHighlightActionsActions"] = $7fb521c50b890daa$export$f1e33ed2d48967b4;

});

parcelRegister("lsp0E", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $47e267cfc6e317db$var$message = (0, $kSwu1.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});
var $47e267cfc6e317db$export$2e2bcd8739ae039 = $47e267cfc6e317db$var$message;
module.exports["default"] = $47e267cfc6e317db$export$2e2bcd8739ae039;

});

parcelRegister("gQ473", function(module, exports) {
$parcel$export(module.exports, "default", () => $c424b15dbb70775f$export$2e2bcd8739ae039);

var $3yGK6 = parcelRequire("3yGK6");


var $37zWd = parcelRequire("37zWd");

function $c424b15dbb70775f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $37zWd.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $37zWd.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});

parcelRegister("8EGKX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $40tBt = parcelRequire("40tBt");


var $hgJhC = parcelRequire("hgJhC");


var $8H9RO = parcelRequire("8H9RO");


var $dZfux = parcelRequire("dZfux");


var $bWxNf = parcelRequire("bWxNf");

/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $64d339aa97525480$var$locale = {
    code: 'cs',
    formatDistance: (0, $40tBt.default),
    formatLong: (0, $hgJhC.default),
    formatRelative: (0, $8H9RO.default),
    localize: (0, $dZfux.default),
    match: (0, $bWxNf.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $64d339aa97525480$export$2e2bcd8739ae039 = $64d339aa97525480$var$locale;
module.exports["default"] = $64d339aa97525480$export$2e2bcd8739ae039;

});

parcelRegister("40tBt", function(module, exports) {
var $2eae201db41c8ad0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $2eae201db41c8ad0$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $2eae201db41c8ad0$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
var $2eae201db41c8ad0$export$2e2bcd8739ae039 = $2eae201db41c8ad0$var$formatDistance;
module.exports["default"] = $2eae201db41c8ad0$export$2e2bcd8739ae039;

});

parcelRegister("hgJhC", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $c9270e9352c5dab6$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $c9270e9352c5dab6$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $c9270e9352c5dab6$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c9270e9352c5dab6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c9270e9352c5dab6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c9270e9352c5dab6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c9270e9352c5dab6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c9270e9352c5dab6$export$2e2bcd8739ae039 = $c9270e9352c5dab6$var$formatLong;
module.exports["default"] = $c9270e9352c5dab6$export$2e2bcd8739ae039;

});

parcelRegister("8H9RO", function(module, exports) {
var $6549fe45c9b430e5$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $6549fe45c9b430e5$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $6549fe45c9b430e5$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var $6549fe45c9b430e5$var$formatRelative = function formatRelative(token, date) {
    var format = $6549fe45c9b430e5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $6549fe45c9b430e5$export$2e2bcd8739ae039 = $6549fe45c9b430e5$var$formatRelative;
module.exports["default"] = $6549fe45c9b430e5$export$2e2bcd8739ae039;

});

parcelRegister("dZfux", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $a2ecfd2abd34f6a8$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $a2ecfd2abd34f6a8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $a2ecfd2abd34f6a8$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $a2ecfd2abd34f6a8$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $a2ecfd2abd34f6a8$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $a2ecfd2abd34f6a8$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $a2ecfd2abd34f6a8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $a2ecfd2abd34f6a8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $a2ecfd2abd34f6a8$var$localize = {
    ordinalNumber: $a2ecfd2abd34f6a8$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $a2ecfd2abd34f6a8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a2ecfd2abd34f6a8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a2ecfd2abd34f6a8$export$2e2bcd8739ae039 = $a2ecfd2abd34f6a8$var$localize;
module.exports["default"] = $a2ecfd2abd34f6a8$export$2e2bcd8739ae039;

});

parcelRegister("bWxNf", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $8b1f531cf9c26189$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $8b1f531cf9c26189$var$parseOrdinalNumberPattern = /\d+/i;
var $8b1f531cf9c26189$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $8b1f531cf9c26189$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $8b1f531cf9c26189$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $8b1f531cf9c26189$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8b1f531cf9c26189$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $8b1f531cf9c26189$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $8b1f531cf9c26189$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $8b1f531cf9c26189$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $8b1f531cf9c26189$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $8b1f531cf9c26189$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $8b1f531cf9c26189$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $8b1f531cf9c26189$var$matchOrdinalNumberPattern,
        parsePattern: $8b1f531cf9c26189$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8b1f531cf9c26189$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8b1f531cf9c26189$export$2e2bcd8739ae039 = $8b1f531cf9c26189$var$match;
module.exports["default"] = $8b1f531cf9c26189$export$2e2bcd8739ae039;

});

parcelRegister("fIezj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $81Sc3 = parcelRequire("81Sc3");


var $cWfr0 = parcelRequire("cWfr0");


var $4P7lC = parcelRequire("4P7lC");


var $79zCo = parcelRequire("79zCo");


var $djh8c = parcelRequire("djh8c");

/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $b7064417012119b7$var$locale = {
    code: 'da',
    formatDistance: (0, $81Sc3.default),
    formatLong: (0, $cWfr0.default),
    formatRelative: (0, $4P7lC.default),
    localize: (0, $79zCo.default),
    match: (0, $djh8c.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b7064417012119b7$export$2e2bcd8739ae039 = $b7064417012119b7$var$locale;
module.exports["default"] = $b7064417012119b7$export$2e2bcd8739ae039;

});

parcelRegister("81Sc3", function(module, exports) {
var $5d887467d929f4a1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $5d887467d929f4a1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5d887467d929f4a1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $5d887467d929f4a1$export$2e2bcd8739ae039 = $5d887467d929f4a1$var$formatDistance;
module.exports["default"] = $5d887467d929f4a1$export$2e2bcd8739ae039;

});

parcelRegister("cWfr0", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $96b6dfd15a6bf5f5$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $96b6dfd15a6bf5f5$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $96b6dfd15a6bf5f5$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $96b6dfd15a6bf5f5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $96b6dfd15a6bf5f5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $96b6dfd15a6bf5f5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $96b6dfd15a6bf5f5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $96b6dfd15a6bf5f5$export$2e2bcd8739ae039 = $96b6dfd15a6bf5f5$var$formatLong;
module.exports["default"] = $96b6dfd15a6bf5f5$export$2e2bcd8739ae039;

});

parcelRegister("4P7lC", function(module, exports) {
var $38319ff13efd02fa$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var $38319ff13efd02fa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $38319ff13efd02fa$var$formatRelativeLocale[token];
};
var $38319ff13efd02fa$export$2e2bcd8739ae039 = $38319ff13efd02fa$var$formatRelative;
module.exports["default"] = $38319ff13efd02fa$export$2e2bcd8739ae039;

});

parcelRegister("79zCo", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $535500b3982b29e7$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $535500b3982b29e7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $535500b3982b29e7$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $535500b3982b29e7$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $535500b3982b29e7$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $535500b3982b29e7$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var $535500b3982b29e7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $535500b3982b29e7$var$localize = {
    ordinalNumber: $535500b3982b29e7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $535500b3982b29e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $535500b3982b29e7$export$2e2bcd8739ae039 = $535500b3982b29e7$var$localize;
module.exports["default"] = $535500b3982b29e7$export$2e2bcd8739ae039;

});

parcelRegister("djh8c", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $9b0a569ced3d46ca$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $9b0a569ced3d46ca$var$parseOrdinalNumberPattern = /\d+/i;
var $9b0a569ced3d46ca$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $9b0a569ced3d46ca$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $9b0a569ced3d46ca$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $9b0a569ced3d46ca$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9b0a569ced3d46ca$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $9b0a569ced3d46ca$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $9b0a569ced3d46ca$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $9b0a569ced3d46ca$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $9b0a569ced3d46ca$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $9b0a569ced3d46ca$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $9b0a569ced3d46ca$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $9b0a569ced3d46ca$var$matchOrdinalNumberPattern,
        parsePattern: $9b0a569ced3d46ca$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9b0a569ced3d46ca$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9b0a569ced3d46ca$export$2e2bcd8739ae039 = $9b0a569ced3d46ca$var$match;
module.exports["default"] = $9b0a569ced3d46ca$export$2e2bcd8739ae039;

});

parcelRegister("d42EV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $7rt4j = parcelRequire("7rt4j");


var $60sGp = parcelRequire("60sGp");


var $4BSGy = parcelRequire("4BSGy");


var $gSK39 = parcelRequire("gSK39");


var $lT7Hr = parcelRequire("lT7Hr");

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $982db62359ebe24a$var$locale = {
    code: 'de',
    formatDistance: (0, $7rt4j.default),
    formatLong: (0, $60sGp.default),
    formatRelative: (0, $4BSGy.default),
    localize: (0, $gSK39.default),
    match: (0, $lT7Hr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $982db62359ebe24a$export$2e2bcd8739ae039 = $982db62359ebe24a$var$locale;
module.exports["default"] = $982db62359ebe24a$export$2e2bcd8739ae039;

});

parcelRegister("7rt4j", function(module, exports) {
var $0165f61a75650612$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $0165f61a75650612$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $0165f61a75650612$var$formatDistanceLocale[token].withPreposition : $0165f61a75650612$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $0165f61a75650612$export$2e2bcd8739ae039 = $0165f61a75650612$var$formatDistance;
module.exports["default"] = $0165f61a75650612$export$2e2bcd8739ae039;

});

parcelRegister("60sGp", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $45f8fdfd81128369$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $45f8fdfd81128369$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $45f8fdfd81128369$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $45f8fdfd81128369$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $45f8fdfd81128369$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $45f8fdfd81128369$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $45f8fdfd81128369$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $45f8fdfd81128369$export$2e2bcd8739ae039 = $45f8fdfd81128369$var$formatLong;
module.exports["default"] = $45f8fdfd81128369$export$2e2bcd8739ae039;

});

parcelRegister("4BSGy", function(module, exports) {
var $35b509852f1813a7$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $35b509852f1813a7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $35b509852f1813a7$var$formatRelativeLocale[token];
};
var $35b509852f1813a7$export$2e2bcd8739ae039 = $35b509852f1813a7$var$formatRelative;
module.exports["default"] = $35b509852f1813a7$export$2e2bcd8739ae039;

});

parcelRegister("gSK39", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $c4a569043fd278ad$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $c4a569043fd278ad$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c4a569043fd278ad$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $c4a569043fd278ad$var$formattingMonthValues = {
    narrow: $c4a569043fd278ad$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $c4a569043fd278ad$var$monthValues.wide
};
var $c4a569043fd278ad$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $c4a569043fd278ad$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $c4a569043fd278ad$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $c4a569043fd278ad$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $c4a569043fd278ad$var$localize = {
    ordinalNumber: $c4a569043fd278ad$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$monthValues,
        formattingValues: $c4a569043fd278ad$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c4a569043fd278ad$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c4a569043fd278ad$export$2e2bcd8739ae039 = $c4a569043fd278ad$var$localize;
module.exports["default"] = $c4a569043fd278ad$export$2e2bcd8739ae039;

});

parcelRegister("lT7Hr", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $fef4b50301223899$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $fef4b50301223899$var$parseOrdinalNumberPattern = /\d+/i;
var $fef4b50301223899$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $fef4b50301223899$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $fef4b50301223899$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $fef4b50301223899$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fef4b50301223899$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $fef4b50301223899$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $fef4b50301223899$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $fef4b50301223899$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $fef4b50301223899$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $fef4b50301223899$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $fef4b50301223899$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $fef4b50301223899$var$matchOrdinalNumberPattern,
        parsePattern: $fef4b50301223899$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fef4b50301223899$export$2e2bcd8739ae039 = $fef4b50301223899$var$match;
module.exports["default"] = $fef4b50301223899$export$2e2bcd8739ae039;

});

parcelRegister("gDEfH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $aijQl = parcelRequire("aijQl");


var $hrPo8 = parcelRequire("hrPo8");


var $iLJwi = parcelRequire("iLJwi");


var $1ueaT = parcelRequire("1ueaT");


var $bbeVr = parcelRequire("bbeVr");

/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $c1cf831e41f9e145$var$locale = {
    code: 'es',
    formatDistance: (0, $aijQl.default),
    formatLong: (0, $hrPo8.default),
    formatRelative: (0, $iLJwi.default),
    localize: (0, $1ueaT.default),
    match: (0, $bbeVr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c1cf831e41f9e145$export$2e2bcd8739ae039 = $c1cf831e41f9e145$var$locale;
module.exports["default"] = $c1cf831e41f9e145$export$2e2bcd8739ae039;

});

parcelRegister("aijQl", function(module, exports) {
var $77eafa43effd33b1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $77eafa43effd33b1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $77eafa43effd33b1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $77eafa43effd33b1$export$2e2bcd8739ae039 = $77eafa43effd33b1$var$formatDistance;
module.exports["default"] = $77eafa43effd33b1$export$2e2bcd8739ae039;

});

parcelRegister("hrPo8", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $cb3cd1ec4cb75b63$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $cb3cd1ec4cb75b63$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $cb3cd1ec4cb75b63$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cb3cd1ec4cb75b63$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cb3cd1ec4cb75b63$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cb3cd1ec4cb75b63$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cb3cd1ec4cb75b63$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cb3cd1ec4cb75b63$export$2e2bcd8739ae039 = $cb3cd1ec4cb75b63$var$formatLong;
module.exports["default"] = $cb3cd1ec4cb75b63$export$2e2bcd8739ae039;

});

parcelRegister("iLJwi", function(module, exports) {
var $da9fed17dc7a8697$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $da9fed17dc7a8697$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $da9fed17dc7a8697$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $da9fed17dc7a8697$var$formatRelativeLocalePlural[token];
    else return $da9fed17dc7a8697$var$formatRelativeLocale[token];
};
var $da9fed17dc7a8697$export$2e2bcd8739ae039 = $da9fed17dc7a8697$var$formatRelative;
module.exports["default"] = $da9fed17dc7a8697$export$2e2bcd8739ae039;

});

parcelRegister("1ueaT", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $1153969890f3d902$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $1153969890f3d902$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $1153969890f3d902$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $1153969890f3d902$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $1153969890f3d902$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $1153969890f3d902$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $1153969890f3d902$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $1153969890f3d902$var$localize = {
    ordinalNumber: $1153969890f3d902$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1153969890f3d902$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1153969890f3d902$export$2e2bcd8739ae039 = $1153969890f3d902$var$localize;
module.exports["default"] = $1153969890f3d902$export$2e2bcd8739ae039;

});

parcelRegister("bbeVr", function(module, exports) {

var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $823c4ca85d3538de$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $823c4ca85d3538de$var$parseOrdinalNumberPattern = /\d+/i;
var $823c4ca85d3538de$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $823c4ca85d3538de$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $823c4ca85d3538de$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $823c4ca85d3538de$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $823c4ca85d3538de$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $823c4ca85d3538de$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $823c4ca85d3538de$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $823c4ca85d3538de$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $823c4ca85d3538de$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $823c4ca85d3538de$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $823c4ca85d3538de$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $823c4ca85d3538de$var$matchOrdinalNumberPattern,
        parsePattern: $823c4ca85d3538de$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $823c4ca85d3538de$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $823c4ca85d3538de$export$2e2bcd8739ae039 = $823c4ca85d3538de$var$match;
module.exports["default"] = $823c4ca85d3538de$export$2e2bcd8739ae039;

});

parcelRegister("dqZrE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $dzVjM = parcelRequire("dzVjM");


var $aH1e9 = parcelRequire("aH1e9");


var $drlIa = parcelRequire("drlIa");


var $aWs8d = parcelRequire("aWs8d");


var $f3OWQ = parcelRequire("f3OWQ");

/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $9c7d5dc265e3b511$var$locale = {
    code: 'fi',
    formatDistance: (0, $dzVjM.default),
    formatLong: (0, $aH1e9.default),
    formatRelative: (0, $drlIa.default),
    localize: (0, $aWs8d.default),
    match: (0, $f3OWQ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9c7d5dc265e3b511$export$2e2bcd8739ae039 = $9c7d5dc265e3b511$var$locale;
module.exports["default"] = $9c7d5dc265e3b511$export$2e2bcd8739ae039;

});

parcelRegister("dzVjM", function(module, exports) {
function $9e2b01678f5bd460$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $9e2b01678f5bd460$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $9e2b01678f5bd460$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $9e2b01678f5bd460$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $9e2b01678f5bd460$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $9e2b01678f5bd460$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $9e2b01678f5bd460$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $9e2b01678f5bd460$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $9e2b01678f5bd460$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $9e2b01678f5bd460$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $9e2b01678f5bd460$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $9e2b01678f5bd460$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $9e2b01678f5bd460$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $9e2b01678f5bd460$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $9e2b01678f5bd460$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $9e2b01678f5bd460$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $9e2b01678f5bd460$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $9e2b01678f5bd460$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $9e2b01678f5bd460$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $9e2b01678f5bd460$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $9e2b01678f5bd460$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $9e2b01678f5bd460$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $9e2b01678f5bd460$var$futureYears
    }
};
var $9e2b01678f5bd460$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $9e2b01678f5bd460$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
var $9e2b01678f5bd460$export$2e2bcd8739ae039 = $9e2b01678f5bd460$var$formatDistance;
module.exports["default"] = $9e2b01678f5bd460$export$2e2bcd8739ae039;

});

parcelRegister("aH1e9", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $7c8edf3bf1d14cfc$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $7c8edf3bf1d14cfc$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $7c8edf3bf1d14cfc$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7c8edf3bf1d14cfc$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7c8edf3bf1d14cfc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7c8edf3bf1d14cfc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7c8edf3bf1d14cfc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7c8edf3bf1d14cfc$export$2e2bcd8739ae039 = $7c8edf3bf1d14cfc$var$formatLong;
module.exports["default"] = $7c8edf3bf1d14cfc$export$2e2bcd8739ae039;

});

parcelRegister("drlIa", function(module, exports) {
var $9c8ea36dc09a2f69$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var $9c8ea36dc09a2f69$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9c8ea36dc09a2f69$var$formatRelativeLocale[token];
};
var $9c8ea36dc09a2f69$export$2e2bcd8739ae039 = $9c8ea36dc09a2f69$var$formatRelative;
module.exports["default"] = $9c8ea36dc09a2f69$export$2e2bcd8739ae039;

});

parcelRegister("aWs8d", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $7f752483d584f103$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $7f752483d584f103$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $7f752483d584f103$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $7f752483d584f103$var$formattingMonthValues = {
    narrow: $7f752483d584f103$var$monthValues.narrow,
    abbreviated: $7f752483d584f103$var$monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var $7f752483d584f103$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $7f752483d584f103$var$formattingDayValues = {
    narrow: $7f752483d584f103$var$dayValues.narrow,
    short: $7f752483d584f103$var$dayValues.short,
    abbreviated: $7f752483d584f103$var$dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var $7f752483d584f103$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var $7f752483d584f103$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $7f752483d584f103$var$localize = {
    ordinalNumber: $7f752483d584f103$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $7f752483d584f103$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $7f752483d584f103$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $7f752483d584f103$export$2e2bcd8739ae039 = $7f752483d584f103$var$localize;
module.exports["default"] = $7f752483d584f103$export$2e2bcd8739ae039;

});

parcelRegister("f3OWQ", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $af6ea809f064e2be$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $af6ea809f064e2be$var$parseOrdinalNumberPattern = /\d+/i;
var $af6ea809f064e2be$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $af6ea809f064e2be$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $af6ea809f064e2be$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $af6ea809f064e2be$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $af6ea809f064e2be$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $af6ea809f064e2be$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $af6ea809f064e2be$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $af6ea809f064e2be$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $af6ea809f064e2be$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $af6ea809f064e2be$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $af6ea809f064e2be$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $af6ea809f064e2be$var$matchOrdinalNumberPattern,
        parsePattern: $af6ea809f064e2be$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $af6ea809f064e2be$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $af6ea809f064e2be$export$2e2bcd8739ae039 = $af6ea809f064e2be$var$match;
module.exports["default"] = $af6ea809f064e2be$export$2e2bcd8739ae039;

});

parcelRegister("k64l1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $9J4Kh = parcelRequire("9J4Kh");


var $9Zy0n = parcelRequire("9Zy0n");


var $drrJx = parcelRequire("drrJx");


var $97me1 = parcelRequire("97me1");


var $68FKa = parcelRequire("68FKa");

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $ea17bb9df88bab0a$var$locale = {
    code: 'fr',
    formatDistance: (0, $9J4Kh.default),
    formatLong: (0, $9Zy0n.default),
    formatRelative: (0, $drrJx.default),
    localize: (0, $97me1.default),
    match: (0, $68FKa.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ea17bb9df88bab0a$export$2e2bcd8739ae039 = $ea17bb9df88bab0a$var$locale;
module.exports["default"] = $ea17bb9df88bab0a$export$2e2bcd8739ae039;

});

parcelRegister("9J4Kh", function(module, exports) {
var $714bff5dee0f1eef$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $714bff5dee0f1eef$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $714bff5dee0f1eef$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $714bff5dee0f1eef$export$2e2bcd8739ae039 = $714bff5dee0f1eef$var$formatDistance;
module.exports["default"] = $714bff5dee0f1eef$export$2e2bcd8739ae039;

});

parcelRegister("9Zy0n", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $7464303f880586b3$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $7464303f880586b3$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7464303f880586b3$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7464303f880586b3$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7464303f880586b3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7464303f880586b3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7464303f880586b3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7464303f880586b3$export$2e2bcd8739ae039 = $7464303f880586b3$var$formatLong;
module.exports["default"] = $7464303f880586b3$export$2e2bcd8739ae039;

});

parcelRegister("drrJx", function(module, exports) {
var $9c934f486536563a$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $9c934f486536563a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9c934f486536563a$var$formatRelativeLocale[token];
};
var $9c934f486536563a$export$2e2bcd8739ae039 = $9c934f486536563a$var$formatRelative;
module.exports["default"] = $9c934f486536563a$export$2e2bcd8739ae039;

});

parcelRegister("97me1", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $6a3601f6e2effb3c$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $6a3601f6e2effb3c$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $6a3601f6e2effb3c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $6a3601f6e2effb3c$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $6a3601f6e2effb3c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $6a3601f6e2effb3c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $6a3601f6e2effb3c$var$localize = {
    ordinalNumber: $6a3601f6e2effb3c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $6a3601f6e2effb3c$export$2e2bcd8739ae039 = $6a3601f6e2effb3c$var$localize;
module.exports["default"] = $6a3601f6e2effb3c$export$2e2bcd8739ae039;

});

parcelRegister("68FKa", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4783ded8b954ffe5$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $4783ded8b954ffe5$var$parseOrdinalNumberPattern = /\d+/i;
var $4783ded8b954ffe5$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $4783ded8b954ffe5$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $4783ded8b954ffe5$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $4783ded8b954ffe5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4783ded8b954ffe5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $4783ded8b954ffe5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4783ded8b954ffe5$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $4783ded8b954ffe5$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $4783ded8b954ffe5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $4783ded8b954ffe5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $4783ded8b954ffe5$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4783ded8b954ffe5$var$matchOrdinalNumberPattern,
        parsePattern: $4783ded8b954ffe5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4783ded8b954ffe5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4783ded8b954ffe5$export$2e2bcd8739ae039 = $4783ded8b954ffe5$var$match;
module.exports["default"] = $4783ded8b954ffe5$export$2e2bcd8739ae039;

});

parcelRegister("5ykSD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $j28xN = parcelRequire("j28xN");


var $lAgOo = parcelRequire("lAgOo");


var $iPQQz = parcelRequire("iPQQz");


var $480o0 = parcelRequire("480o0");


var $dwdGx = parcelRequire("dwdGx");

/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $40b05316fb9db818$var$locale = {
    code: 'hu',
    formatDistance: (0, $j28xN.default),
    formatLong: (0, $lAgOo.default),
    formatRelative: (0, $iPQQz.default),
    localize: (0, $480o0.default),
    match: (0, $dwdGx.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $40b05316fb9db818$export$2e2bcd8739ae039 = $40b05316fb9db818$var$locale;
module.exports["default"] = $40b05316fb9db818$export$2e2bcd8739ae039;

});

parcelRegister("j28xN", function(module, exports) {
var $ddb4d4ec718cb1b7$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $ddb4d4ec718cb1b7$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $ddb4d4ec718cb1b7$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $ddb4d4ec718cb1b7$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $ddb4d4ec718cb1b7$var$withSuffixes[key][comparison] : $ddb4d4ec718cb1b7$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $ddb4d4ec718cb1b7$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $ddb4d4ec718cb1b7$export$2e2bcd8739ae039 = $ddb4d4ec718cb1b7$var$formatDistance;
module.exports["default"] = $ddb4d4ec718cb1b7$export$2e2bcd8739ae039;

});

parcelRegister("lAgOo", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $fb6a003e9d8d1645$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $fb6a003e9d8d1645$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $fb6a003e9d8d1645$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $fb6a003e9d8d1645$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $fb6a003e9d8d1645$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $fb6a003e9d8d1645$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $fb6a003e9d8d1645$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fb6a003e9d8d1645$export$2e2bcd8739ae039 = $fb6a003e9d8d1645$var$formatLong;
module.exports["default"] = $fb6a003e9d8d1645$export$2e2bcd8739ae039;

});

parcelRegister("iPQQz", function(module, exports) {
var $db65fbba084d31b5$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $db65fbba084d31b5$var$week(isFuture) {
    return function(date) {
        var weekday = $db65fbba084d31b5$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $db65fbba084d31b5$var$formatRelativeLocale = {
    lastWeek: $db65fbba084d31b5$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $db65fbba084d31b5$var$week(true),
    other: 'P'
};
var $db65fbba084d31b5$var$formatRelative = function formatRelative(token, date) {
    var format = $db65fbba084d31b5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $db65fbba084d31b5$export$2e2bcd8739ae039 = $db65fbba084d31b5$var$formatRelative;
module.exports["default"] = $db65fbba084d31b5$export$2e2bcd8739ae039;

});

parcelRegister("480o0", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $301835724098a5d1$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $301835724098a5d1$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $301835724098a5d1$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $301835724098a5d1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $301835724098a5d1$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $301835724098a5d1$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $301835724098a5d1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $301835724098a5d1$var$localize = {
    ordinalNumber: $301835724098a5d1$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $301835724098a5d1$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $301835724098a5d1$export$2e2bcd8739ae039 = $301835724098a5d1$var$localize;
module.exports["default"] = $301835724098a5d1$export$2e2bcd8739ae039;

});

parcelRegister("dwdGx", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $9d78e119f82ea9fa$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $9d78e119f82ea9fa$var$parseOrdinalNumberPattern = /\d+/i;
var $9d78e119f82ea9fa$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $9d78e119f82ea9fa$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $9d78e119f82ea9fa$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $9d78e119f82ea9fa$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $9d78e119f82ea9fa$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $9d78e119f82ea9fa$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $9d78e119f82ea9fa$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $9d78e119f82ea9fa$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $9d78e119f82ea9fa$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $9d78e119f82ea9fa$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $9d78e119f82ea9fa$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $9d78e119f82ea9fa$var$matchOrdinalNumberPattern,
        parsePattern: $9d78e119f82ea9fa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9d78e119f82ea9fa$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9d78e119f82ea9fa$export$2e2bcd8739ae039 = $9d78e119f82ea9fa$var$match;
module.exports["default"] = $9d78e119f82ea9fa$export$2e2bcd8739ae039;

});

parcelRegister("9YZs4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $ellkl = parcelRequire("ellkl");


var $9Azfr = parcelRequire("9Azfr");


var $geJmU = parcelRequire("geJmU");


var $c2vlP = parcelRequire("c2vlP");


var $bk6Tz = parcelRequire("bk6Tz");

/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $744962aa86c35b83$var$locale = {
    code: 'it',
    formatDistance: (0, $ellkl.default),
    formatLong: (0, $9Azfr.default),
    formatRelative: (0, $geJmU.default),
    localize: (0, $c2vlP.default),
    match: (0, $bk6Tz.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $744962aa86c35b83$export$2e2bcd8739ae039 = $744962aa86c35b83$var$locale;
module.exports["default"] = $744962aa86c35b83$export$2e2bcd8739ae039;

});

parcelRegister("ellkl", function(module, exports) {
var $a71391fb8b5ee549$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var $a71391fb8b5ee549$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a71391fb8b5ee549$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
var $a71391fb8b5ee549$export$2e2bcd8739ae039 = $a71391fb8b5ee549$var$formatDistance;
module.exports["default"] = $a71391fb8b5ee549$export$2e2bcd8739ae039;

});

parcelRegister("9Azfr", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $6fb2d15f95a41915$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $6fb2d15f95a41915$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6fb2d15f95a41915$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $6fb2d15f95a41915$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6fb2d15f95a41915$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6fb2d15f95a41915$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6fb2d15f95a41915$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6fb2d15f95a41915$export$2e2bcd8739ae039 = $6fb2d15f95a41915$var$formatLong;
module.exports["default"] = $6fb2d15f95a41915$export$2e2bcd8739ae039;

});

parcelRegister("geJmU", function(module, exports) {

var $gQ473 = parcelRequire("gQ473");

var $bd2125636e62d628$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $bd2125636e62d628$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $bd2125636e62d628$var$weekdays[day] + " scorso alle' p";
    }
}
function $bd2125636e62d628$var$thisWeek(day) {
    return "'" + $bd2125636e62d628$var$weekdays[day] + " alle' p";
}
function $bd2125636e62d628$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $bd2125636e62d628$var$weekdays[day] + " prossimo alle' p";
    }
}
var $bd2125636e62d628$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bd2125636e62d628$var$thisWeek(day);
        else return $bd2125636e62d628$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bd2125636e62d628$var$thisWeek(day);
        else return $bd2125636e62d628$var$_nextWeek(day);
    },
    other: 'P'
};
var $bd2125636e62d628$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $bd2125636e62d628$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $bd2125636e62d628$export$2e2bcd8739ae039 = $bd2125636e62d628$var$formatRelative;
module.exports["default"] = $bd2125636e62d628$export$2e2bcd8739ae039;

});

parcelRegister("c2vlP", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $8c3dfd96bffc0100$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $8c3dfd96bffc0100$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $8c3dfd96bffc0100$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $8c3dfd96bffc0100$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $8c3dfd96bffc0100$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $8c3dfd96bffc0100$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var $8c3dfd96bffc0100$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $8c3dfd96bffc0100$var$localize = {
    ordinalNumber: $8c3dfd96bffc0100$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8c3dfd96bffc0100$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8c3dfd96bffc0100$export$2e2bcd8739ae039 = $8c3dfd96bffc0100$var$localize;
module.exports["default"] = $8c3dfd96bffc0100$export$2e2bcd8739ae039;

});

parcelRegister("bk6Tz", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $83e6e9388f063e32$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $83e6e9388f063e32$var$parseOrdinalNumberPattern = /\d+/i;
var $83e6e9388f063e32$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $83e6e9388f063e32$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $83e6e9388f063e32$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $83e6e9388f063e32$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $83e6e9388f063e32$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $83e6e9388f063e32$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $83e6e9388f063e32$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $83e6e9388f063e32$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $83e6e9388f063e32$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $83e6e9388f063e32$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $83e6e9388f063e32$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $83e6e9388f063e32$var$matchOrdinalNumberPattern,
        parsePattern: $83e6e9388f063e32$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $83e6e9388f063e32$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $83e6e9388f063e32$export$2e2bcd8739ae039 = $83e6e9388f063e32$var$match;
module.exports["default"] = $83e6e9388f063e32$export$2e2bcd8739ae039;

});

parcelRegister("lwYCg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kdWlb = parcelRequire("kdWlb");


var $kIszH = parcelRequire("kIszH");


var $7UDTh = parcelRequire("7UDTh");


var $3tfYb = parcelRequire("3tfYb");


var $32wuN = parcelRequire("32wuN");

/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $facb9b3e95506ec3$var$locale = {
    code: 'ja',
    formatDistance: (0, $kdWlb.default),
    formatLong: (0, $kIszH.default),
    formatRelative: (0, $7UDTh.default),
    localize: (0, $3tfYb.default),
    match: (0, $32wuN.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $facb9b3e95506ec3$export$2e2bcd8739ae039 = $facb9b3e95506ec3$var$locale;
module.exports["default"] = $facb9b3e95506ec3$export$2e2bcd8739ae039;

});

parcelRegister("kdWlb", function(module, exports) {
var $eb9246cedf948188$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $eb9246cedf948188$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $eb9246cedf948188$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $eb9246cedf948188$export$2e2bcd8739ae039 = $eb9246cedf948188$var$formatDistance;
module.exports["default"] = $eb9246cedf948188$export$2e2bcd8739ae039;

});

parcelRegister("kIszH", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $f14e151245029cff$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $f14e151245029cff$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $f14e151245029cff$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $f14e151245029cff$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f14e151245029cff$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f14e151245029cff$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f14e151245029cff$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f14e151245029cff$export$2e2bcd8739ae039 = $f14e151245029cff$var$formatLong;
module.exports["default"] = $f14e151245029cff$export$2e2bcd8739ae039;

});

parcelRegister("7UDTh", function(module, exports) {
var $5c2cb4cf5416a7bc$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var $5c2cb4cf5416a7bc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5c2cb4cf5416a7bc$var$formatRelativeLocale[token];
};
var $5c2cb4cf5416a7bc$export$2e2bcd8739ae039 = $5c2cb4cf5416a7bc$var$formatRelative;
module.exports["default"] = $5c2cb4cf5416a7bc$export$2e2bcd8739ae039;

});

parcelRegister("3tfYb", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $287077c6645a281b$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $287077c6645a281b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $287077c6645a281b$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $287077c6645a281b$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $287077c6645a281b$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $287077c6645a281b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $287077c6645a281b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $287077c6645a281b$var$localize = {
    ordinalNumber: $287077c6645a281b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $287077c6645a281b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $287077c6645a281b$export$2e2bcd8739ae039 = $287077c6645a281b$var$localize;
module.exports["default"] = $287077c6645a281b$export$2e2bcd8739ae039;

});

parcelRegister("32wuN", function(module, exports) {

var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $236ac3f89cc2eda2$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $236ac3f89cc2eda2$var$parseOrdinalNumberPattern = /\d+/i;
var $236ac3f89cc2eda2$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $236ac3f89cc2eda2$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $236ac3f89cc2eda2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $236ac3f89cc2eda2$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $236ac3f89cc2eda2$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $236ac3f89cc2eda2$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $236ac3f89cc2eda2$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $236ac3f89cc2eda2$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $236ac3f89cc2eda2$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $236ac3f89cc2eda2$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $236ac3f89cc2eda2$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $236ac3f89cc2eda2$var$matchOrdinalNumberPattern,
        parsePattern: $236ac3f89cc2eda2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $236ac3f89cc2eda2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $236ac3f89cc2eda2$export$2e2bcd8739ae039 = $236ac3f89cc2eda2$var$match;
module.exports["default"] = $236ac3f89cc2eda2$export$2e2bcd8739ae039;

});

parcelRegister("458wa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $deKRb = parcelRequire("deKRb");


var $ake0I = parcelRequire("ake0I");


var $grcXB = parcelRequire("grcXB");


var $jjZxs = parcelRequire("jjZxs");


var $2xEGr = parcelRequire("2xEGr");

/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $2f8e3c8391fc083c$var$locale = {
    code: 'ko',
    formatDistance: (0, $deKRb.default),
    formatLong: (0, $ake0I.default),
    formatRelative: (0, $grcXB.default),
    localize: (0, $jjZxs.default),
    match: (0, $2xEGr.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2f8e3c8391fc083c$export$2e2bcd8739ae039 = $2f8e3c8391fc083c$var$locale;
module.exports["default"] = $2f8e3c8391fc083c$export$2e2bcd8739ae039;

});

parcelRegister("deKRb", function(module, exports) {
var $9a30edf95b41adab$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $9a30edf95b41adab$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9a30edf95b41adab$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $9a30edf95b41adab$export$2e2bcd8739ae039 = $9a30edf95b41adab$var$formatDistance;
module.exports["default"] = $9a30edf95b41adab$export$2e2bcd8739ae039;

});

parcelRegister("ake0I", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $7846a3d80bd2c7a8$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $7846a3d80bd2c7a8$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7846a3d80bd2c7a8$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7846a3d80bd2c7a8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7846a3d80bd2c7a8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7846a3d80bd2c7a8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7846a3d80bd2c7a8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7846a3d80bd2c7a8$export$2e2bcd8739ae039 = $7846a3d80bd2c7a8$var$formatLong;
module.exports["default"] = $7846a3d80bd2c7a8$export$2e2bcd8739ae039;

});

parcelRegister("grcXB", function(module, exports) {
var $bf793897b825ffd5$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var $bf793897b825ffd5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bf793897b825ffd5$var$formatRelativeLocale[token];
};
var $bf793897b825ffd5$export$2e2bcd8739ae039 = $bf793897b825ffd5$var$formatRelative;
module.exports["default"] = $bf793897b825ffd5$export$2e2bcd8739ae039;

});

parcelRegister("jjZxs", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $e10f86f8e331e148$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $e10f86f8e331e148$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $e10f86f8e331e148$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $e10f86f8e331e148$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $e10f86f8e331e148$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $e10f86f8e331e148$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $e10f86f8e331e148$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $e10f86f8e331e148$var$localize = {
    ordinalNumber: $e10f86f8e331e148$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e10f86f8e331e148$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e10f86f8e331e148$export$2e2bcd8739ae039 = $e10f86f8e331e148$var$localize;
module.exports["default"] = $e10f86f8e331e148$export$2e2bcd8739ae039;

});

parcelRegister("2xEGr", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $1d9e38c2043347f4$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $1d9e38c2043347f4$var$parseOrdinalNumberPattern = /\d+/i;
var $1d9e38c2043347f4$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $1d9e38c2043347f4$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $1d9e38c2043347f4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $1d9e38c2043347f4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1d9e38c2043347f4$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $1d9e38c2043347f4$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $1d9e38c2043347f4$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $1d9e38c2043347f4$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $1d9e38c2043347f4$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $1d9e38c2043347f4$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $1d9e38c2043347f4$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $1d9e38c2043347f4$var$matchOrdinalNumberPattern,
        parsePattern: $1d9e38c2043347f4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1d9e38c2043347f4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1d9e38c2043347f4$export$2e2bcd8739ae039 = $1d9e38c2043347f4$var$match;
module.exports["default"] = $1d9e38c2043347f4$export$2e2bcd8739ae039;

});

parcelRegister("3y6aU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $dUGAL = parcelRequire("dUGAL");


var $bIr4G = parcelRequire("bIr4G");


var $arp85 = parcelRequire("arp85");


var $e6sCi = parcelRequire("e6sCi");


var $ar39d = parcelRequire("ar39d");

/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $2959564810867a6e$var$locale = {
    code: 'nb',
    formatDistance: (0, $dUGAL.default),
    formatLong: (0, $bIr4G.default),
    formatRelative: (0, $arp85.default),
    localize: (0, $e6sCi.default),
    match: (0, $ar39d.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2959564810867a6e$export$2e2bcd8739ae039 = $2959564810867a6e$var$locale;
module.exports["default"] = $2959564810867a6e$export$2e2bcd8739ae039;

});

parcelRegister("dUGAL", function(module, exports) {
var $a2118b34269ad3cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $a2118b34269ad3cd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a2118b34269ad3cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $a2118b34269ad3cd$export$2e2bcd8739ae039 = $a2118b34269ad3cd$var$formatDistance;
module.exports["default"] = $a2118b34269ad3cd$export$2e2bcd8739ae039;

});

parcelRegister("bIr4G", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $02337f3258030beb$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $02337f3258030beb$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $02337f3258030beb$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $02337f3258030beb$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $02337f3258030beb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $02337f3258030beb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $02337f3258030beb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $02337f3258030beb$export$2e2bcd8739ae039 = $02337f3258030beb$var$formatLong;
module.exports["default"] = $02337f3258030beb$export$2e2bcd8739ae039;

});

parcelRegister("arp85", function(module, exports) {
var $799feb331933489d$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $799feb331933489d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $799feb331933489d$var$formatRelativeLocale[token];
};
var $799feb331933489d$export$2e2bcd8739ae039 = $799feb331933489d$var$formatRelative;
module.exports["default"] = $799feb331933489d$export$2e2bcd8739ae039;

});

parcelRegister("e6sCi", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $a447d2e853ed6e50$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $a447d2e853ed6e50$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $a447d2e853ed6e50$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $a447d2e853ed6e50$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $a447d2e853ed6e50$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $a447d2e853ed6e50$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $a447d2e853ed6e50$var$localize = {
    ordinalNumber: $a447d2e853ed6e50$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $a447d2e853ed6e50$export$2e2bcd8739ae039 = $a447d2e853ed6e50$var$localize;
module.exports["default"] = $a447d2e853ed6e50$export$2e2bcd8739ae039;

});

parcelRegister("ar39d", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $798ede10b5682819$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $798ede10b5682819$var$parseOrdinalNumberPattern = /\d+/i;
var $798ede10b5682819$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $798ede10b5682819$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $798ede10b5682819$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $798ede10b5682819$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $798ede10b5682819$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $798ede10b5682819$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $798ede10b5682819$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $798ede10b5682819$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $798ede10b5682819$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $798ede10b5682819$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $798ede10b5682819$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $798ede10b5682819$var$matchOrdinalNumberPattern,
        parsePattern: $798ede10b5682819$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $798ede10b5682819$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $798ede10b5682819$export$2e2bcd8739ae039 = $798ede10b5682819$var$match;
module.exports["default"] = $798ede10b5682819$export$2e2bcd8739ae039;

});

parcelRegister("i6MM7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $i3bvr = parcelRequire("i3bvr");


var $3vNPq = parcelRequire("3vNPq");


var $9kldU = parcelRequire("9kldU");


var $dfBYx = parcelRequire("dfBYx");


var $3PIgF = parcelRequire("3PIgF");

/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $d2ee9f3efedaf64f$var$locale = {
    code: 'nl',
    formatDistance: (0, $i3bvr.default),
    formatLong: (0, $3vNPq.default),
    formatRelative: (0, $9kldU.default),
    localize: (0, $dfBYx.default),
    match: (0, $3PIgF.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d2ee9f3efedaf64f$export$2e2bcd8739ae039 = $d2ee9f3efedaf64f$var$locale;
module.exports["default"] = $d2ee9f3efedaf64f$export$2e2bcd8739ae039;

});

parcelRegister("i3bvr", function(module, exports) {
var $d2416eb4c291058a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $d2416eb4c291058a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d2416eb4c291058a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $d2416eb4c291058a$export$2e2bcd8739ae039 = $d2416eb4c291058a$var$formatDistance;
module.exports["default"] = $d2416eb4c291058a$export$2e2bcd8739ae039;

});

parcelRegister("3vNPq", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $28eaeb3bab3ca544$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $28eaeb3bab3ca544$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $28eaeb3bab3ca544$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $28eaeb3bab3ca544$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $28eaeb3bab3ca544$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $28eaeb3bab3ca544$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $28eaeb3bab3ca544$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $28eaeb3bab3ca544$export$2e2bcd8739ae039 = $28eaeb3bab3ca544$var$formatLong;
module.exports["default"] = $28eaeb3bab3ca544$export$2e2bcd8739ae039;

});

parcelRegister("9kldU", function(module, exports) {
var $6ca671d192e5b220$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $6ca671d192e5b220$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6ca671d192e5b220$var$formatRelativeLocale[token];
};
var $6ca671d192e5b220$export$2e2bcd8739ae039 = $6ca671d192e5b220$var$formatRelative;
module.exports["default"] = $6ca671d192e5b220$export$2e2bcd8739ae039;

});

parcelRegister("dfBYx", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $9a5a222f29e9d1e3$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $9a5a222f29e9d1e3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $9a5a222f29e9d1e3$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $9a5a222f29e9d1e3$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $9a5a222f29e9d1e3$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $9a5a222f29e9d1e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $9a5a222f29e9d1e3$var$localize = {
    ordinalNumber: $9a5a222f29e9d1e3$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $9a5a222f29e9d1e3$export$2e2bcd8739ae039 = $9a5a222f29e9d1e3$var$localize;
module.exports["default"] = $9a5a222f29e9d1e3$export$2e2bcd8739ae039;

});

parcelRegister("3PIgF", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $2ca87932c12940c4$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $2ca87932c12940c4$var$parseOrdinalNumberPattern = /\d+/i;
var $2ca87932c12940c4$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $2ca87932c12940c4$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $2ca87932c12940c4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $2ca87932c12940c4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2ca87932c12940c4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $2ca87932c12940c4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $2ca87932c12940c4$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $2ca87932c12940c4$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $2ca87932c12940c4$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $2ca87932c12940c4$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $2ca87932c12940c4$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $2ca87932c12940c4$var$matchOrdinalNumberPattern,
        parsePattern: $2ca87932c12940c4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2ca87932c12940c4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2ca87932c12940c4$export$2e2bcd8739ae039 = $2ca87932c12940c4$var$match;
module.exports["default"] = $2ca87932c12940c4$export$2e2bcd8739ae039;

});

parcelRegister("353ym", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $j1nDA = parcelRequire("j1nDA");


var $ac9Ji = parcelRequire("ac9Ji");


var $iMn07 = parcelRequire("iMn07");


var $1TlTg = parcelRequire("1TlTg");


var $bD2YI = parcelRequire("bD2YI");

/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $23e4984b81369ddb$var$locale = {
    code: 'pl',
    formatDistance: (0, $j1nDA.default),
    formatLong: (0, $ac9Ji.default),
    formatRelative: (0, $iMn07.default),
    localize: (0, $1TlTg.default),
    match: (0, $bD2YI.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $23e4984b81369ddb$export$2e2bcd8739ae039 = $23e4984b81369ddb$var$locale;
module.exports["default"] = $23e4984b81369ddb$export$2e2bcd8739ae039;

});

parcelRegister("j1nDA", function(module, exports) {
var $dd90723ec95793c1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $dd90723ec95793c1$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $dd90723ec95793c1$var$declension(scheme, count, time) {
    var group = $dd90723ec95793c1$var$declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var $dd90723ec95793c1$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $dd90723ec95793c1$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $dd90723ec95793c1$var$declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + $dd90723ec95793c1$var$declension(scheme, count, 'future');
    else return $dd90723ec95793c1$var$declension(scheme, count, 'past') + ' temu';
};
var $dd90723ec95793c1$export$2e2bcd8739ae039 = $dd90723ec95793c1$var$formatDistance;
module.exports["default"] = $dd90723ec95793c1$export$2e2bcd8739ae039;

});

parcelRegister("ac9Ji", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $76c2927b2dbd3bc1$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $76c2927b2dbd3bc1$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $76c2927b2dbd3bc1$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $76c2927b2dbd3bc1$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $76c2927b2dbd3bc1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $76c2927b2dbd3bc1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $76c2927b2dbd3bc1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $76c2927b2dbd3bc1$export$2e2bcd8739ae039 = $76c2927b2dbd3bc1$var$formatLong;
module.exports["default"] = $76c2927b2dbd3bc1$export$2e2bcd8739ae039;

});

parcelRegister("iMn07", function(module, exports) {

var $gQ473 = parcelRequire("gQ473");

var $dabe8d3352fb27f5$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $dabe8d3352fb27f5$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $dabe8d3352fb27f5$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $dabe8d3352fb27f5$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $dabe8d3352fb27f5$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $gQ473.default)(date, baseDate, options)) adjectives = $dabe8d3352fb27f5$var$adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = $dabe8d3352fb27f5$var$adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = $dabe8d3352fb27f5$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $dabe8d3352fb27f5$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $dabe8d3352fb27f5$var$formatRelativeLocale = {
    lastWeek: $dabe8d3352fb27f5$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $dabe8d3352fb27f5$var$dayAndTimeWithAdjective,
    other: 'P'
};
var $dabe8d3352fb27f5$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $dabe8d3352fb27f5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
var $dabe8d3352fb27f5$export$2e2bcd8739ae039 = $dabe8d3352fb27f5$var$formatRelative;
module.exports["default"] = $dabe8d3352fb27f5$export$2e2bcd8739ae039;

});

parcelRegister("1TlTg", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $160be87489e0c135$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $160be87489e0c135$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $160be87489e0c135$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $160be87489e0c135$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $160be87489e0c135$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $160be87489e0c135$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $160be87489e0c135$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $160be87489e0c135$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $160be87489e0c135$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $160be87489e0c135$var$localize = {
    ordinalNumber: $160be87489e0c135$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $160be87489e0c135$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $160be87489e0c135$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $160be87489e0c135$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $160be87489e0c135$export$2e2bcd8739ae039 = $160be87489e0c135$var$localize;
module.exports["default"] = $160be87489e0c135$export$2e2bcd8739ae039;

});

parcelRegister("bD2YI", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $8775a5ad7036f19b$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $8775a5ad7036f19b$var$parseOrdinalNumberPattern = /\d+/i;
var $8775a5ad7036f19b$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $8775a5ad7036f19b$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $8775a5ad7036f19b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $8775a5ad7036f19b$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $8775a5ad7036f19b$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $8775a5ad7036f19b$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $8775a5ad7036f19b$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $8775a5ad7036f19b$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $8775a5ad7036f19b$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $8775a5ad7036f19b$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $8775a5ad7036f19b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $8775a5ad7036f19b$var$matchOrdinalNumberPattern,
        parsePattern: $8775a5ad7036f19b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8775a5ad7036f19b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8775a5ad7036f19b$export$2e2bcd8739ae039 = $8775a5ad7036f19b$var$match;
module.exports["default"] = $8775a5ad7036f19b$export$2e2bcd8739ae039;

});

parcelRegister("lBaG3", function(module, exports) {

var $llnfY = parcelRequire("llnfY");


var $huegY = parcelRequire("huegY");


var $bu7Fs = parcelRequire("bu7Fs");


var $hEcsY = parcelRequire("hEcsY");


var $hP9ya = parcelRequire("hP9ya");

/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $fb9555fb784915b0$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $llnfY.default),
    formatLong: (0, $huegY.default),
    formatRelative: (0, $bu7Fs.default),
    localize: (0, $hEcsY.default),
    match: (0, $hP9ya.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fb9555fb784915b0$export$2e2bcd8739ae039 = $fb9555fb784915b0$var$locale;
module.exports["default"] = $fb9555fb784915b0$export$2e2bcd8739ae039;

});

parcelRegister("llnfY", function(module, exports) {
var $f89d996e2905c311$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $f89d996e2905c311$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f89d996e2905c311$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $f89d996e2905c311$export$2e2bcd8739ae039 = $f89d996e2905c311$var$formatDistance;
module.exports["default"] = $f89d996e2905c311$export$2e2bcd8739ae039;

});

parcelRegister("huegY", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $cbb04f4531a0bc08$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $cbb04f4531a0bc08$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $cbb04f4531a0bc08$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cbb04f4531a0bc08$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cbb04f4531a0bc08$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cbb04f4531a0bc08$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cbb04f4531a0bc08$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cbb04f4531a0bc08$export$2e2bcd8739ae039 = $cbb04f4531a0bc08$var$formatLong;
module.exports["default"] = $cbb04f4531a0bc08$export$2e2bcd8739ae039;

});

parcelRegister("bu7Fs", function(module, exports) {
var $85c871ae3499d42c$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $85c871ae3499d42c$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $85c871ae3499d42c$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $85c871ae3499d42c$export$2e2bcd8739ae039 = $85c871ae3499d42c$var$formatRelative;
module.exports["default"] = $85c871ae3499d42c$export$2e2bcd8739ae039;

});

parcelRegister("hEcsY", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $cd8fd7aad48dd8b6$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $cd8fd7aad48dd8b6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $cd8fd7aad48dd8b6$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $cd8fd7aad48dd8b6$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $cd8fd7aad48dd8b6$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $cd8fd7aad48dd8b6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var $cd8fd7aad48dd8b6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var $cd8fd7aad48dd8b6$var$localize = {
    ordinalNumber: $cd8fd7aad48dd8b6$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cd8fd7aad48dd8b6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cd8fd7aad48dd8b6$export$2e2bcd8739ae039 = $cd8fd7aad48dd8b6$var$localize;
module.exports["default"] = $cd8fd7aad48dd8b6$export$2e2bcd8739ae039;

});

parcelRegister("hP9ya", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $cf9e9b8f54ac2e9b$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $cf9e9b8f54ac2e9b$var$parseOrdinalNumberPattern = /\d+/i;
var $cf9e9b8f54ac2e9b$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $cf9e9b8f54ac2e9b$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $cf9e9b8f54ac2e9b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $cf9e9b8f54ac2e9b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $cf9e9b8f54ac2e9b$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $cf9e9b8f54ac2e9b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $cf9e9b8f54ac2e9b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $cf9e9b8f54ac2e9b$var$matchOrdinalNumberPattern,
        parsePattern: $cf9e9b8f54ac2e9b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $cf9e9b8f54ac2e9b$export$2e2bcd8739ae039 = $cf9e9b8f54ac2e9b$var$match;
module.exports["default"] = $cf9e9b8f54ac2e9b$export$2e2bcd8739ae039;

});

parcelRegister("gYfFg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $dygkD = parcelRequire("dygkD");


var $jy9WJ = parcelRequire("jy9WJ");


var $g1Vn1 = parcelRequire("g1Vn1");


var $9Xtym = parcelRequire("9Xtym");


var $i3u0q = parcelRequire("i3u0q");

/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $c5ae669420cf1e4a$var$locale = {
    code: 'ru',
    formatDistance: (0, $dygkD.default),
    formatLong: (0, $jy9WJ.default),
    formatRelative: (0, $g1Vn1.default),
    localize: (0, $9Xtym.default),
    match: (0, $i3u0q.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c5ae669420cf1e4a$export$2e2bcd8739ae039 = $c5ae669420cf1e4a$var$locale;
module.exports["default"] = $c5ae669420cf1e4a$export$2e2bcd8739ae039;

});

parcelRegister("dygkD", function(module, exports) {
function $9ddb1e7b3e4b0f55$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $9ddb1e7b3e4b0f55$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $9ddb1e7b3e4b0f55$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $9ddb1e7b3e4b0f55$var$declension(scheme.past, count);
                else return $9ddb1e7b3e4b0f55$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $9ddb1e7b3e4b0f55$var$declension(scheme.regular, count);
    };
}
var $9ddb1e7b3e4b0f55$var$formatDistanceLocale = {
    lessThanXSeconds: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $9ddb1e7b3e4b0f55$var$formatDistance = function formatDistance(token, count, options) {
    return $9ddb1e7b3e4b0f55$var$formatDistanceLocale[token](count, options);
};
var $9ddb1e7b3e4b0f55$export$2e2bcd8739ae039 = $9ddb1e7b3e4b0f55$var$formatDistance;
module.exports["default"] = $9ddb1e7b3e4b0f55$export$2e2bcd8739ae039;

});

parcelRegister("jy9WJ", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $e3b8e8667b5854d5$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $e3b8e8667b5854d5$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $e3b8e8667b5854d5$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $e3b8e8667b5854d5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e3b8e8667b5854d5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e3b8e8667b5854d5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e3b8e8667b5854d5$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $e3b8e8667b5854d5$export$2e2bcd8739ae039 = $e3b8e8667b5854d5$var$formatLong;
module.exports["default"] = $e3b8e8667b5854d5$export$2e2bcd8739ae039;

});

parcelRegister("g1Vn1", function(module, exports) {

var $gQ473 = parcelRequire("gQ473");

var $bab93de8dcdee896$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $bab93de8dcdee896$var$_lastWeek(day) {
    var weekday = $bab93de8dcdee896$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $bab93de8dcdee896$var$thisWeek(day) {
    var weekday = $bab93de8dcdee896$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $bab93de8dcdee896$var$_nextWeek(day) {
    var weekday = $bab93de8dcdee896$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $bab93de8dcdee896$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bab93de8dcdee896$var$thisWeek(day);
        else return $bab93de8dcdee896$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bab93de8dcdee896$var$thisWeek(day);
        else return $bab93de8dcdee896$var$_nextWeek(day);
    },
    other: 'P'
};
var $bab93de8dcdee896$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $bab93de8dcdee896$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $bab93de8dcdee896$export$2e2bcd8739ae039 = $bab93de8dcdee896$var$formatRelative;
module.exports["default"] = $bab93de8dcdee896$export$2e2bcd8739ae039;

});

parcelRegister("9Xtym", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $74008c60c6ad6ba7$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $74008c60c6ad6ba7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $74008c60c6ad6ba7$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $74008c60c6ad6ba7$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $74008c60c6ad6ba7$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $74008c60c6ad6ba7$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $74008c60c6ad6ba7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $74008c60c6ad6ba7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $74008c60c6ad6ba7$var$localize = {
    ordinalNumber: $74008c60c6ad6ba7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $74008c60c6ad6ba7$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $74008c60c6ad6ba7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $74008c60c6ad6ba7$export$2e2bcd8739ae039 = $74008c60c6ad6ba7$var$localize;
module.exports["default"] = $74008c60c6ad6ba7$export$2e2bcd8739ae039;

});

parcelRegister("i3u0q", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $d24fc856082463b5$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $d24fc856082463b5$var$parseOrdinalNumberPattern = /\d+/i;
var $d24fc856082463b5$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $d24fc856082463b5$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $d24fc856082463b5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $d24fc856082463b5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d24fc856082463b5$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $d24fc856082463b5$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $d24fc856082463b5$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $d24fc856082463b5$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $d24fc856082463b5$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $d24fc856082463b5$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $d24fc856082463b5$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $d24fc856082463b5$var$matchOrdinalNumberPattern,
        parsePattern: $d24fc856082463b5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d24fc856082463b5$export$2e2bcd8739ae039 = $d24fc856082463b5$var$match;
module.exports["default"] = $d24fc856082463b5$export$2e2bcd8739ae039;

});

parcelRegister("hVF75", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $6jxap = parcelRequire("6jxap");


var $eF54L = parcelRequire("eF54L");


var $7EvN1 = parcelRequire("7EvN1");


var $cXtwP = parcelRequire("cXtwP");


var $9rdIX = parcelRequire("9rdIX");

/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $d0d7a6cbbd9931e0$var$locale = {
    code: 'sv',
    formatDistance: (0, $6jxap.default),
    formatLong: (0, $eF54L.default),
    formatRelative: (0, $7EvN1.default),
    localize: (0, $cXtwP.default),
    match: (0, $9rdIX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d0d7a6cbbd9931e0$export$2e2bcd8739ae039 = $d0d7a6cbbd9931e0$var$locale;
module.exports["default"] = $d0d7a6cbbd9931e0$export$2e2bcd8739ae039;

});

parcelRegister("6jxap", function(module, exports) {
var $498e3ea7400c79cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $498e3ea7400c79cd$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $498e3ea7400c79cd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $498e3ea7400c79cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $498e3ea7400c79cd$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $498e3ea7400c79cd$export$2e2bcd8739ae039 = $498e3ea7400c79cd$var$formatDistance;
module.exports["default"] = $498e3ea7400c79cd$export$2e2bcd8739ae039;

});

parcelRegister("eF54L", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $aac8d4f534e9817e$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $aac8d4f534e9817e$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aac8d4f534e9817e$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $aac8d4f534e9817e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $aac8d4f534e9817e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $aac8d4f534e9817e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $aac8d4f534e9817e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aac8d4f534e9817e$export$2e2bcd8739ae039 = $aac8d4f534e9817e$var$formatLong;
module.exports["default"] = $aac8d4f534e9817e$export$2e2bcd8739ae039;

});

parcelRegister("7EvN1", function(module, exports) {
var $5924ed9d0ef7328b$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $5924ed9d0ef7328b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5924ed9d0ef7328b$var$formatRelativeLocale[token];
};
var $5924ed9d0ef7328b$export$2e2bcd8739ae039 = $5924ed9d0ef7328b$var$formatRelative;
module.exports["default"] = $5924ed9d0ef7328b$export$2e2bcd8739ae039;

});

parcelRegister("cXtwP", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $96f1e67ab010045a$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $96f1e67ab010045a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $96f1e67ab010045a$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $96f1e67ab010045a$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $96f1e67ab010045a$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $96f1e67ab010045a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $96f1e67ab010045a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $96f1e67ab010045a$var$localize = {
    ordinalNumber: $96f1e67ab010045a$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $96f1e67ab010045a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $96f1e67ab010045a$export$2e2bcd8739ae039 = $96f1e67ab010045a$var$localize;
module.exports["default"] = $96f1e67ab010045a$export$2e2bcd8739ae039;

});

parcelRegister("9rdIX", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6df147ff21c266cb$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $6df147ff21c266cb$var$parseOrdinalNumberPattern = /\d+/i;
var $6df147ff21c266cb$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $6df147ff21c266cb$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $6df147ff21c266cb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $6df147ff21c266cb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6df147ff21c266cb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $6df147ff21c266cb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6df147ff21c266cb$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $6df147ff21c266cb$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $6df147ff21c266cb$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $6df147ff21c266cb$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $6df147ff21c266cb$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6df147ff21c266cb$var$matchOrdinalNumberPattern,
        parsePattern: $6df147ff21c266cb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6df147ff21c266cb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6df147ff21c266cb$export$2e2bcd8739ae039 = $6df147ff21c266cb$var$match;
module.exports["default"] = $6df147ff21c266cb$export$2e2bcd8739ae039;

});

parcelRegister("9B6Ao", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $lMyzK = parcelRequire("lMyzK");


var $69kBO = parcelRequire("69kBO");


var $ejU2g = parcelRequire("ejU2g");


var $dhTjZ = parcelRequire("dhTjZ");


var $d0lop = parcelRequire("d0lop");

/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var $6fccad97c533cd7b$var$locale = {
    code: 'th',
    formatDistance: (0, $lMyzK.default),
    formatLong: (0, $69kBO.default),
    formatRelative: (0, $ejU2g.default),
    localize: (0, $dhTjZ.default),
    match: (0, $d0lop.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $6fccad97c533cd7b$export$2e2bcd8739ae039 = $6fccad97c533cd7b$var$locale;
module.exports["default"] = $6fccad97c533cd7b$export$2e2bcd8739ae039;

});

parcelRegister("lMyzK", function(module, exports) {
var $fdb8e6ac6a228317$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var $fdb8e6ac6a228317$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fdb8e6ac6a228317$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
var $fdb8e6ac6a228317$export$2e2bcd8739ae039 = $fdb8e6ac6a228317$var$formatDistance;
module.exports["default"] = $fdb8e6ac6a228317$export$2e2bcd8739ae039;

});

parcelRegister("69kBO", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $47a391d98d38a9f6$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $47a391d98d38a9f6$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var $47a391d98d38a9f6$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $47a391d98d38a9f6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $47a391d98d38a9f6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $47a391d98d38a9f6$var$timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $47a391d98d38a9f6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $47a391d98d38a9f6$export$2e2bcd8739ae039 = $47a391d98d38a9f6$var$formatLong;
module.exports["default"] = $47a391d98d38a9f6$export$2e2bcd8739ae039;

});

parcelRegister("ejU2g", function(module, exports) {
var $a6ce4e8b6d5e4459$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var $a6ce4e8b6d5e4459$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a6ce4e8b6d5e4459$var$formatRelativeLocale[token];
};
var $a6ce4e8b6d5e4459$export$2e2bcd8739ae039 = $a6ce4e8b6d5e4459$var$formatRelative;
module.exports["default"] = $a6ce4e8b6d5e4459$export$2e2bcd8739ae039;

});

parcelRegister("dhTjZ", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $9ac7c6950e5d8543$var$eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var $9ac7c6950e5d8543$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var $9ac7c6950e5d8543$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var $9ac7c6950e5d8543$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var $9ac7c6950e5d8543$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $9ac7c6950e5d8543$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $9ac7c6950e5d8543$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $9ac7c6950e5d8543$var$localize = {
    ordinalNumber: $9ac7c6950e5d8543$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9ac7c6950e5d8543$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9ac7c6950e5d8543$export$2e2bcd8739ae039 = $9ac7c6950e5d8543$var$localize;
module.exports["default"] = $9ac7c6950e5d8543$export$2e2bcd8739ae039;

});

parcelRegister("d0lop", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $977bde944afc485c$var$matchOrdinalNumberPattern = /^\d+/i;
var $977bde944afc485c$var$parseOrdinalNumberPattern = /\d+/i;
var $977bde944afc485c$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var $977bde944afc485c$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var $977bde944afc485c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var $977bde944afc485c$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var $977bde944afc485c$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var $977bde944afc485c$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var $977bde944afc485c$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var $977bde944afc485c$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var $977bde944afc485c$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var $977bde944afc485c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var $977bde944afc485c$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $977bde944afc485c$var$matchOrdinalNumberPattern,
        parsePattern: $977bde944afc485c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $977bde944afc485c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $977bde944afc485c$export$2e2bcd8739ae039 = $977bde944afc485c$var$match;
module.exports["default"] = $977bde944afc485c$export$2e2bcd8739ae039;

});

parcelRegister("azkPO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hpsyA = parcelRequire("hpsyA");


var $1KqHk = parcelRequire("1KqHk");


var $fxwqg = parcelRequire("fxwqg");


var $jAxHK = parcelRequire("jAxHK");


var $7VIPf = parcelRequire("7VIPf");

/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $7b1d559a8c68f8a5$var$locale = {
    code: 'tr',
    formatDistance: (0, $hpsyA.default),
    formatLong: (0, $1KqHk.default),
    formatRelative: (0, $fxwqg.default),
    localize: (0, $jAxHK.default),
    match: (0, $7VIPf.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $7b1d559a8c68f8a5$export$2e2bcd8739ae039 = $7b1d559a8c68f8a5$var$locale;
module.exports["default"] = $7b1d559a8c68f8a5$export$2e2bcd8739ae039;

});

parcelRegister("hpsyA", function(module, exports) {
var $cacaec45b7fe35c8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $cacaec45b7fe35c8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cacaec45b7fe35c8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
var $cacaec45b7fe35c8$export$2e2bcd8739ae039 = $cacaec45b7fe35c8$var$formatDistance;
module.exports["default"] = $cacaec45b7fe35c8$export$2e2bcd8739ae039;

});

parcelRegister("1KqHk", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $145ecbfb5001ed36$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $145ecbfb5001ed36$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $145ecbfb5001ed36$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $145ecbfb5001ed36$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $145ecbfb5001ed36$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $145ecbfb5001ed36$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $145ecbfb5001ed36$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $145ecbfb5001ed36$export$2e2bcd8739ae039 = $145ecbfb5001ed36$var$formatLong;
module.exports["default"] = $145ecbfb5001ed36$export$2e2bcd8739ae039;

});

parcelRegister("fxwqg", function(module, exports) {
var $b503168688c0db0e$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var $b503168688c0db0e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b503168688c0db0e$var$formatRelativeLocale[token];
};
var $b503168688c0db0e$export$2e2bcd8739ae039 = $b503168688c0db0e$var$formatRelative;
module.exports["default"] = $b503168688c0db0e$export$2e2bcd8739ae039;

});

parcelRegister("jAxHK", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $e42b862c14382cbc$var$eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $e42b862c14382cbc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $e42b862c14382cbc$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $e42b862c14382cbc$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $e42b862c14382cbc$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $e42b862c14382cbc$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var $e42b862c14382cbc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $e42b862c14382cbc$var$localize = {
    ordinalNumber: $e42b862c14382cbc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e42b862c14382cbc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e42b862c14382cbc$export$2e2bcd8739ae039 = $e42b862c14382cbc$var$localize;
module.exports["default"] = $e42b862c14382cbc$export$2e2bcd8739ae039;

});

parcelRegister("7VIPf", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5c60a0b40bcb1aee$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $5c60a0b40bcb1aee$var$parseOrdinalNumberPattern = /\d+/i;
var $5c60a0b40bcb1aee$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $5c60a0b40bcb1aee$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $5c60a0b40bcb1aee$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $5c60a0b40bcb1aee$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $5c60a0b40bcb1aee$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $5c60a0b40bcb1aee$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $5c60a0b40bcb1aee$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $5c60a0b40bcb1aee$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $5c60a0b40bcb1aee$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $5c60a0b40bcb1aee$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $5c60a0b40bcb1aee$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5c60a0b40bcb1aee$var$matchOrdinalNumberPattern,
        parsePattern: $5c60a0b40bcb1aee$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5c60a0b40bcb1aee$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5c60a0b40bcb1aee$export$2e2bcd8739ae039 = $5c60a0b40bcb1aee$var$match;
module.exports["default"] = $5c60a0b40bcb1aee$export$2e2bcd8739ae039;

});

parcelRegister("baKKw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $6JVlA = parcelRequire("6JVlA");


var $daRAW = parcelRequire("daRAW");


var $h0zNw = parcelRequire("h0zNw");


var $2SVPk = parcelRequire("2SVPk");


var $aLqtZ = parcelRequire("aLqtZ");

/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $8224e45a8b2272f4$var$locale = {
    code: 'uk',
    formatDistance: (0, $6JVlA.default),
    formatLong: (0, $daRAW.default),
    formatRelative: (0, $h0zNw.default),
    localize: (0, $2SVPk.default),
    match: (0, $aLqtZ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8224e45a8b2272f4$export$2e2bcd8739ae039 = $8224e45a8b2272f4$var$locale;
module.exports["default"] = $8224e45a8b2272f4$export$2e2bcd8739ae039;

});

parcelRegister("6JVlA", function(module, exports) {
function $01442f3194056974$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $01442f3194056974$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $01442f3194056974$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $01442f3194056974$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $01442f3194056974$var$declension(scheme.past, count);
                else return $01442f3194056974$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $01442f3194056974$var$declension(scheme.regular, count);
    };
}
var $01442f3194056974$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var $01442f3194056974$var$formatDistanceLocale = {
    lessThanXSeconds: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $01442f3194056974$var$halfAtMinute,
    lessThanXMinutes: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var $01442f3194056974$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $01442f3194056974$var$formatDistanceLocale[token](count, options);
};
var $01442f3194056974$export$2e2bcd8739ae039 = $01442f3194056974$var$formatDistance;
module.exports["default"] = $01442f3194056974$export$2e2bcd8739ae039;

});

parcelRegister("daRAW", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $9975c85ba013e980$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var $9975c85ba013e980$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $9975c85ba013e980$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9975c85ba013e980$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $9975c85ba013e980$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $9975c85ba013e980$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $9975c85ba013e980$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9975c85ba013e980$export$2e2bcd8739ae039 = $9975c85ba013e980$var$formatLong;
module.exports["default"] = $9975c85ba013e980$export$2e2bcd8739ae039;

});

parcelRegister("h0zNw", function(module, exports) {

var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

var $c61e346a95348094$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $c61e346a95348094$var$lastWeek(day) {
    var weekday = $c61e346a95348094$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $c61e346a95348094$var$thisWeek(day) {
    var weekday = $c61e346a95348094$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $c61e346a95348094$var$nextWeek(day) {
    var weekday = $c61e346a95348094$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var $c61e346a95348094$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $c61e346a95348094$var$thisWeek(day);
    else return $c61e346a95348094$var$lastWeek(day);
};
var $c61e346a95348094$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $c61e346a95348094$var$thisWeek(day);
    else return $c61e346a95348094$var$nextWeek(day);
};
var $c61e346a95348094$var$formatRelativeLocale = {
    lastWeek: $c61e346a95348094$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $c61e346a95348094$var$nextWeekFormat,
    other: 'P'
};
var $c61e346a95348094$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $c61e346a95348094$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $c61e346a95348094$export$2e2bcd8739ae039 = $c61e346a95348094$var$formatRelative;
module.exports["default"] = $c61e346a95348094$export$2e2bcd8739ae039;

});

parcelRegister("2SVPk", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $219d7b23715b11fd$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var $219d7b23715b11fd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $219d7b23715b11fd$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var $219d7b23715b11fd$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var $219d7b23715b11fd$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $219d7b23715b11fd$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var $219d7b23715b11fd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var $219d7b23715b11fd$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var $219d7b23715b11fd$var$localize = {
    ordinalNumber: $219d7b23715b11fd$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $219d7b23715b11fd$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $219d7b23715b11fd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $219d7b23715b11fd$export$2e2bcd8739ae039 = $219d7b23715b11fd$var$localize;
module.exports["default"] = $219d7b23715b11fd$export$2e2bcd8739ae039;

});

parcelRegister("aLqtZ", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $7d62d6198376001a$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $7d62d6198376001a$var$parseOrdinalNumberPattern = /\d+/i;
var $7d62d6198376001a$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $7d62d6198376001a$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $7d62d6198376001a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $7d62d6198376001a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7d62d6198376001a$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $7d62d6198376001a$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $7d62d6198376001a$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $7d62d6198376001a$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $7d62d6198376001a$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $7d62d6198376001a$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $7d62d6198376001a$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $7d62d6198376001a$var$matchOrdinalNumberPattern,
        parsePattern: $7d62d6198376001a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7d62d6198376001a$export$2e2bcd8739ae039 = $7d62d6198376001a$var$match;
module.exports["default"] = $7d62d6198376001a$export$2e2bcd8739ae039;

});

parcelRegister("28ZKr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1U64X = parcelRequire("1U64X");


var $2SyVz = parcelRequire("2SyVz");


var $7v3ph = parcelRequire("7v3ph");


var $aimsi = parcelRequire("aimsi");


var $gMXnd = parcelRequire("gMXnd");

/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var $18fc39feec97f3b9$var$locale = {
    code: 'vi',
    formatDistance: (0, $1U64X.default),
    formatLong: (0, $2SyVz.default),
    formatRelative: (0, $7v3ph.default),
    localize: (0, $aimsi.default),
    match: (0, $gMXnd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
var $18fc39feec97f3b9$export$2e2bcd8739ae039 = $18fc39feec97f3b9$var$locale;
module.exports["default"] = $18fc39feec97f3b9$export$2e2bcd8739ae039;

});

parcelRegister("1U64X", function(module, exports) {
var $162fbc90404e8c33$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var $162fbc90404e8c33$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $162fbc90404e8c33$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
var $162fbc90404e8c33$export$2e2bcd8739ae039 = $162fbc90404e8c33$var$formatDistance;
module.exports["default"] = $162fbc90404e8c33$export$2e2bcd8739ae039;

});

parcelRegister("2SyVz", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $218bb7c871cdc9e5$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var $218bb7c871cdc9e5$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $218bb7c871cdc9e5$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $218bb7c871cdc9e5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $218bb7c871cdc9e5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $218bb7c871cdc9e5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $218bb7c871cdc9e5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $218bb7c871cdc9e5$export$2e2bcd8739ae039 = $218bb7c871cdc9e5$var$formatLong;
module.exports["default"] = $218bb7c871cdc9e5$export$2e2bcd8739ae039;

});

parcelRegister("7v3ph", function(module, exports) {
var $575e1228ef7548e6$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var $575e1228ef7548e6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $575e1228ef7548e6$var$formatRelativeLocale[token];
};
var $575e1228ef7548e6$export$2e2bcd8739ae039 = $575e1228ef7548e6$var$formatRelative;
module.exports["default"] = $575e1228ef7548e6$export$2e2bcd8739ae039;

});

parcelRegister("aimsi", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var $77ed00faca7972dd$var$eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var $77ed00faca7972dd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var $77ed00faca7972dd$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $77ed00faca7972dd$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var $77ed00faca7972dd$var$formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var $77ed00faca7972dd$var$dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var $77ed00faca7972dd$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var $77ed00faca7972dd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var $77ed00faca7972dd$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var $77ed00faca7972dd$var$localize = {
    ordinalNumber: $77ed00faca7972dd$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $77ed00faca7972dd$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $77ed00faca7972dd$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $77ed00faca7972dd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $77ed00faca7972dd$export$2e2bcd8739ae039 = $77ed00faca7972dd$var$localize;
module.exports["default"] = $77ed00faca7972dd$export$2e2bcd8739ae039;

});

parcelRegister("gMXnd", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $c38f2f5bc11a2ff1$var$matchOrdinalNumberPattern = /^(\d+)/i;
var $c38f2f5bc11a2ff1$var$parseOrdinalNumberPattern = /\d+/i;
var $c38f2f5bc11a2ff1$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var $c38f2f5bc11a2ff1$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var $c38f2f5bc11a2ff1$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var $c38f2f5bc11a2ff1$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var $c38f2f5bc11a2ff1$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var $c38f2f5bc11a2ff1$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var $c38f2f5bc11a2ff1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $c38f2f5bc11a2ff1$var$matchOrdinalNumberPattern,
        parsePattern: $c38f2f5bc11a2ff1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c38f2f5bc11a2ff1$export$2e2bcd8739ae039 = $c38f2f5bc11a2ff1$var$match;
module.exports["default"] = $c38f2f5bc11a2ff1$export$2e2bcd8739ae039;

});

parcelRegister("8tIg4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8CsZI = parcelRequire("8CsZI");


var $iemhR = parcelRequire("iemhR");


var $l92Sl = parcelRequire("l92Sl");


var $72BdQ = parcelRequire("72BdQ");


var $9dDLT = parcelRequire("9dDLT");

/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $62c35cf1e9047798$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $8CsZI.default),
    formatLong: (0, $iemhR.default),
    formatRelative: (0, $l92Sl.default),
    localize: (0, $72BdQ.default),
    match: (0, $9dDLT.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $62c35cf1e9047798$export$2e2bcd8739ae039 = $62c35cf1e9047798$var$locale;
module.exports["default"] = $62c35cf1e9047798$export$2e2bcd8739ae039;

});

parcelRegister("8CsZI", function(module, exports) {
var $64685d06163f4317$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $64685d06163f4317$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $64685d06163f4317$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $64685d06163f4317$export$2e2bcd8739ae039 = $64685d06163f4317$var$formatDistance;
module.exports["default"] = $64685d06163f4317$export$2e2bcd8739ae039;

});

parcelRegister("iemhR", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $d45ad2904abf1f09$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $d45ad2904abf1f09$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $d45ad2904abf1f09$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d45ad2904abf1f09$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d45ad2904abf1f09$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d45ad2904abf1f09$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d45ad2904abf1f09$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d45ad2904abf1f09$export$2e2bcd8739ae039 = $d45ad2904abf1f09$var$formatLong;
module.exports["default"] = $d45ad2904abf1f09$export$2e2bcd8739ae039;

});

parcelRegister("l92Sl", function(module, exports) {

var $gQ473 = parcelRequire("gQ473");

function $f64cab475ab54b4e$var$checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, $gQ473.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $f64cab475ab54b4e$var$formatRelativeLocale = {
    lastWeek: $f64cab475ab54b4e$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $f64cab475ab54b4e$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var $f64cab475ab54b4e$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $f64cab475ab54b4e$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $f64cab475ab54b4e$export$2e2bcd8739ae039 = $f64cab475ab54b4e$var$formatRelative;
module.exports["default"] = $f64cab475ab54b4e$export$2e2bcd8739ae039;

});

parcelRegister("72BdQ", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $520597e1b0add328$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $520597e1b0add328$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $520597e1b0add328$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $520597e1b0add328$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $520597e1b0add328$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $520597e1b0add328$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $520597e1b0add328$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $520597e1b0add328$var$localize = {
    ordinalNumber: $520597e1b0add328$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $520597e1b0add328$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $520597e1b0add328$export$2e2bcd8739ae039 = $520597e1b0add328$var$localize;
module.exports["default"] = $520597e1b0add328$export$2e2bcd8739ae039;

});

parcelRegister("9dDLT", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6b642dbf07fc44d5$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $6b642dbf07fc44d5$var$parseOrdinalNumberPattern = /\d+/i;
var $6b642dbf07fc44d5$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $6b642dbf07fc44d5$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $6b642dbf07fc44d5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $6b642dbf07fc44d5$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $6b642dbf07fc44d5$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $6b642dbf07fc44d5$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $6b642dbf07fc44d5$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $6b642dbf07fc44d5$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $6b642dbf07fc44d5$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $6b642dbf07fc44d5$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $6b642dbf07fc44d5$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6b642dbf07fc44d5$var$matchOrdinalNumberPattern,
        parsePattern: $6b642dbf07fc44d5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6b642dbf07fc44d5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6b642dbf07fc44d5$export$2e2bcd8739ae039 = $6b642dbf07fc44d5$var$match;
module.exports["default"] = $6b642dbf07fc44d5$export$2e2bcd8739ae039;

});

parcelRegister("bOvA7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gaUVc = parcelRequire("gaUVc");


var $5gP0G = parcelRequire("5gP0G");


var $iqnzA = parcelRequire("iqnzA");


var $en5dJ = parcelRequire("en5dJ");


var $5oZWK = parcelRequire("5oZWK");

/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $899cdcad6eb1a6ad$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $gaUVc.default),
    formatLong: (0, $5gP0G.default),
    formatRelative: (0, $iqnzA.default),
    localize: (0, $en5dJ.default),
    match: (0, $5oZWK.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $899cdcad6eb1a6ad$export$2e2bcd8739ae039 = $899cdcad6eb1a6ad$var$locale;
module.exports["default"] = $899cdcad6eb1a6ad$export$2e2bcd8739ae039;

});

parcelRegister("gaUVc", function(module, exports) {
var $bc69bbf0d8b7f781$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $bc69bbf0d8b7f781$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bc69bbf0d8b7f781$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $bc69bbf0d8b7f781$export$2e2bcd8739ae039 = $bc69bbf0d8b7f781$var$formatDistance;
module.exports["default"] = $bc69bbf0d8b7f781$export$2e2bcd8739ae039;

});

parcelRegister("5gP0G", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $3d6603e7605d7041$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $3d6603e7605d7041$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $3d6603e7605d7041$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $3d6603e7605d7041$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $3d6603e7605d7041$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $3d6603e7605d7041$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $3d6603e7605d7041$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3d6603e7605d7041$export$2e2bcd8739ae039 = $3d6603e7605d7041$var$formatLong;
module.exports["default"] = $3d6603e7605d7041$export$2e2bcd8739ae039;

});

parcelRegister("iqnzA", function(module, exports) {
var $d69cf0cd60e3d274$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $d69cf0cd60e3d274$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d69cf0cd60e3d274$var$formatRelativeLocale[token];
};
var $d69cf0cd60e3d274$export$2e2bcd8739ae039 = $d69cf0cd60e3d274$var$formatRelative;
module.exports["default"] = $d69cf0cd60e3d274$export$2e2bcd8739ae039;

});

parcelRegister("en5dJ", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $a7674353d7a65490$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $a7674353d7a65490$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $a7674353d7a65490$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $a7674353d7a65490$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $a7674353d7a65490$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $a7674353d7a65490$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $a7674353d7a65490$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $a7674353d7a65490$var$localize = {
    ordinalNumber: $a7674353d7a65490$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a7674353d7a65490$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a7674353d7a65490$export$2e2bcd8739ae039 = $a7674353d7a65490$var$localize;
module.exports["default"] = $a7674353d7a65490$export$2e2bcd8739ae039;

});

parcelRegister("5oZWK", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $3eef3ef16b54ac72$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $3eef3ef16b54ac72$var$parseOrdinalNumberPattern = /\d+/i;
var $3eef3ef16b54ac72$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $3eef3ef16b54ac72$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $3eef3ef16b54ac72$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $3eef3ef16b54ac72$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $3eef3ef16b54ac72$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $3eef3ef16b54ac72$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $3eef3ef16b54ac72$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $3eef3ef16b54ac72$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $3eef3ef16b54ac72$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $3eef3ef16b54ac72$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $3eef3ef16b54ac72$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $3eef3ef16b54ac72$var$matchOrdinalNumberPattern,
        parsePattern: $3eef3ef16b54ac72$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3eef3ef16b54ac72$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3eef3ef16b54ac72$export$2e2bcd8739ae039 = $3eef3ef16b54ac72$var$match;
module.exports["default"] = $3eef3ef16b54ac72$export$2e2bcd8739ae039;

});

parcelRegister("5ZJRm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



class $928d71b7a1b056f3$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("8NWgm")),
            (parcelRequire("8AV99"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
        };
    }
}
$928d71b7a1b056f3$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $928d71b7a1b056f3$export$3ce634ac4a869e2c;

});

parcelRegister("8NWgm", function(module, exports) {

let $6690181f9f2cdbab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6690181f9f2cdbab$var$load("2Bp34"),
    $6690181f9f2cdbab$var$load("90vep"),
    $6690181f9f2cdbab$var$load("fV46K"),
    $6690181f9f2cdbab$var$load("kruxh")
]).then(()=>parcelRequire('gB7FN'));

});

parcelRegister("8AV99", function(module, exports) {

let $641e03a52f2c7269$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $641e03a52f2c7269$var$load("fV46K"),
    $641e03a52f2c7269$var$load("2Bp34"),
    $641e03a52f2c7269$var$load("6OMo6"),
    $641e03a52f2c7269$var$load("aaRXj"),
    $641e03a52f2c7269$var$load("fHlIz"),
    $641e03a52f2c7269$var$load("4QwAJ"),
    $641e03a52f2c7269$var$load("3i44s"),
    $641e03a52f2c7269$var$load("5kI0b"),
    $641e03a52f2c7269$var$load("kYkz1"),
    $641e03a52f2c7269$var$load("jfYeU"),
    $641e03a52f2c7269$var$load("b4nm1"),
    $641e03a52f2c7269$var$load("geXPZ"),
    $641e03a52f2c7269$var$load("aQ5uu"),
    $641e03a52f2c7269$var$load("flY2n"),
    $641e03a52f2c7269$var$load("jOE2W"),
    $641e03a52f2c7269$var$load("jTOhL"),
    $641e03a52f2c7269$var$load("5ouIR")
]).then(()=>parcelRequire('e7T2P'));

});

parcelRegister("bXbVP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");




class $21bbc164c3f5497e$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            (parcelRequire("8NWgm")),
            (parcelRequire("aXYAG")),
            (parcelRequire("OJHVR"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $21bbc164c3f5497e$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $21bbc164c3f5497e$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $21bbc164c3f5497e$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}
$21bbc164c3f5497e$export$66201d263cd6342.displayName = 'AsyncDropzone';
$21bbc164c3f5497e$export$66201d263cd6342.Dropzone = void 0;
$21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary = void 0;
module.exports["DropzoneLoader"] = $21bbc164c3f5497e$export$66201d263cd6342;

});

parcelRegister("aXYAG", function(module, exports) {

let $7fbe6a2171c47459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7fbe6a2171c47459$var$load("fV46K"),
    $7fbe6a2171c47459$var$load("2Bp34"),
    $7fbe6a2171c47459$var$load("6OMo6"),
    $7fbe6a2171c47459$var$load("aaRXj"),
    $7fbe6a2171c47459$var$load("fHlIz"),
    $7fbe6a2171c47459$var$load("4QwAJ"),
    $7fbe6a2171c47459$var$load("3i44s"),
    $7fbe6a2171c47459$var$load("5kI0b"),
    $7fbe6a2171c47459$var$load("kYkz1"),
    $7fbe6a2171c47459$var$load("jfYeU"),
    $7fbe6a2171c47459$var$load("b4nm1"),
    $7fbe6a2171c47459$var$load("geXPZ"),
    $7fbe6a2171c47459$var$load("aQ5uu"),
    $7fbe6a2171c47459$var$load("flY2n"),
    $7fbe6a2171c47459$var$load("jOE2W"),
    $7fbe6a2171c47459$var$load("jTOhL"),
    $7fbe6a2171c47459$var$load("5FmXP")
]).then(()=>parcelRequire('ex3eO'));

});

parcelRegister("OJHVR", function(module, exports) {

let $098820335a8857e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $098820335a8857e8$var$load("246Cm").then(()=>parcelRequire('AiyH6'));

});

parcelRegister("dhtsm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e968f74392c9852a620f126dfaed814>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab3b6586bd7bdc0$var$_react = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ab3b6586bd7bdc0$var$_baseNew = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9ab3b6586bd7bdc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/field-text
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab3b6586bd7bdc0$var$FieldTextIcon = (props)=>/*#__PURE__*/ $9ab3b6586bd7bdc0$var$_react.default.createElement($9ab3b6586bd7bdc0$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$9ab3b6586bd7bdc0$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $9ab3b6586bd7bdc0$var$_default = module.exports.default = $9ab3b6586bd7bdc0$var$FieldTextIcon;

});

parcelRegister("38vK5", function(module, exports) {

var $iSrRp = parcelRequire("iSrRp");


var $50k8e = parcelRequire("50k8e");

const $13b62b9fdabf1049$var$api = (0, $50k8e.makeApi)({
    monitor: (0, $iSrRp.monitorForElements)
});
const $13b62b9fdabf1049$export$4b66ee8317094cdb = $13b62b9fdabf1049$var$api.autoScroll;
const $13b62b9fdabf1049$export$c9168f41de61f525 = $13b62b9fdabf1049$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $13b62b9fdabf1049$export$4b66ee8317094cdb;

});

parcelRegister("50k8e", function(module, exports) {

var $aDtKq = parcelRequire("aDtKq");

parcelRequire("jRbBa");
var $gEZCs = parcelRequire("gEZCs");


var $bTXWf = parcelRequire("bTXWf");


var $4SoL4 = parcelRequire("4SoL4");


var $1UuSE = parcelRequire("1UuSE");

function $f5382ac96223be68$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $aDtKq.combine)((0, $4SoL4.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $gEZCs.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $gEZCs.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $1UuSE.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $bTXWf.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $f5382ac96223be68$export$b8fa21320a811083;

});

parcelRegister("jRbBa", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("gEZCs")).once);

var $gEZCs = parcelRequire("gEZCs");


});

parcelRegister("bTXWf", function(module, exports) {
parcelRequire("66v15");
var $31Y6I = parcelRequire("31Y6I");


var $5Mj3f = parcelRequire("5Mj3f");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $d27a3192f501902b$var$schedulers = new Map();
function $d27a3192f501902b$export$5cff7ac265db316a(monitor) {
    const scheduler = $d27a3192f501902b$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $d27a3192f501902b$var$makeScheduler(monitor);
    $d27a3192f501902b$var$schedulers.set(monitor, created);
    return created;
}
function $d27a3192f501902b$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $31Y6I.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $5Mj3f.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $5Mj3f.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $d27a3192f501902b$export$5cff7ac265db316a;

});

parcelRegister("5Mj3f", function(module, exports) {
const $b507fa4d63a4635b$var$ledger = new Map();
const $b507fa4d63a4635b$var$requested = new Set();
function $b507fa4d63a4635b$export$8c764c3f2fc3d2d2(element) {
    $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element);
    const entry = $b507fa4d63a4635b$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b507fa4d63a4635b$var$ledger.set(element, fresh);
    return fresh;
}
function $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element) {
    $b507fa4d63a4635b$var$requested.add(element);
}
function $b507fa4d63a4635b$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b507fa4d63a4635b$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b507fa4d63a4635b$var$ledger.forEach((_, element)=>{
        if (!$b507fa4d63a4635b$var$requested.has(element)) $b507fa4d63a4635b$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b507fa4d63a4635b$var$requested.clear();
}
function $b507fa4d63a4635b$export$13ae770ed39b71ea() {
    $b507fa4d63a4635b$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b507fa4d63a4635b$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b507fa4d63a4635b$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b507fa4d63a4635b$export$13ae770ed39b71ea;

});

parcelRegister("4SoL4", function(module, exports) {
const $35c4ac2061d5f133$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $35c4ac2061d5f133$export$aea217a45095ce11 = `[${$35c4ac2061d5f133$export$4b152ab55cad4fd6}="true"]`;
function $35c4ac2061d5f133$export$4ec12fb57dfebd53(element) {
    element.setAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $35c4ac2061d5f133$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $35c4ac2061d5f133$export$4ec12fb57dfebd53;

});

parcelRegister("1UuSE", function(module, exports) {

var $9r8oV = parcelRequire("9r8oV");


var $5Mj3f = parcelRequire("5Mj3f");


var $4SoL4 = parcelRequire("4SoL4");


var $j0x5d = parcelRequire("j0x5d");

function $c48f25f499b57242$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $c48f25f499b57242$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $4SoL4.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $c48f25f499b57242$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
    const config = (0, $9r8oV.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $j0x5d.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $c48f25f499b57242$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
        const config = (0, $9r8oV.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $j0x5d.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $c48f25f499b57242$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $c48f25f499b57242$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(remainder)) return;
    $c48f25f499b57242$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $c48f25f499b57242$export$233199807749476d;

});

parcelRegister("9r8oV", function(module, exports) {
const $a7ed1bcd13597f53$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $a7ed1bcd13597f53$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $a7ed1bcd13597f53$export$e96028ec7ff9d079(provided) {
    return {
        ...$a7ed1bcd13597f53$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $a7ed1bcd13597f53$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $a7ed1bcd13597f53$export$e96028ec7ff9d079;

});

parcelRegister("j0x5d", function(module, exports) {

var $4PtQA = parcelRequire("4PtQA");


var $iqmUH = parcelRequire("iqmUH");


var $lIDh1 = parcelRequire("lIDh1");


var $drwMb = parcelRequire("drwMb");


var $75xM4 = parcelRequire("75xM4");


var $jNg3h = parcelRequire("jNg3h");

function $510e86c1df38ba68$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $510e86c1df38ba68$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $510e86c1df38ba68$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $iqmUH.edges).reduce((map, edge)=>{
        const hitbox = (0, $lIDh1.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $iqmUH.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $75xM4.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $jNg3h.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $4PtQA.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $510e86c1df38ba68$export$6cfa6dfe6898b98f;

});

parcelRegister("4PtQA", function(module, exports) {
const $5318802fe51175c6$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $5318802fe51175c6$export$ccd6d9407403fcad;

});

parcelRegister("iqmUH", function(module, exports) {
const $abc8f89ed9b7940d$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abc8f89ed9b7940d$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $abc8f89ed9b7940d$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $abc8f89ed9b7940d$export$7fc144124ccf8292;

});

parcelRegister("lIDh1", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $k6QYd = parcelRequire("k6QYd");

function $516f0b1290892600$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eU390.axisLookup)[axis];
        const side = (0, $k6QYd.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $516f0b1290892600$export$b9a449c20abb0e9 = {
    top: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $516f0b1290892600$export$b9a449c20abb0e9;

});

parcelRegister("eU390", function(module, exports) {
const $5b0e1b1531f93246$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $5b0e1b1531f93246$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $5b0e1b1531f93246$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $5b0e1b1531f93246$var$vertical,
        crossAxis: $5b0e1b1531f93246$var$horizontal
    },
    horizontal: {
        mainAxis: $5b0e1b1531f93246$var$horizontal,
        crossAxis: $5b0e1b1531f93246$var$vertical
    }
};
module.exports["axisLookup"] = $5b0e1b1531f93246$export$42e42cdab35a2b96;

});

parcelRegister("k6QYd", function(module, exports) {
const $51fdf9dde687ea21$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $51fdf9dde687ea21$export$a45c0cd714a4dbaa;

});

parcelRegister("drwMb", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $fYr9O = parcelRequire("fYr9O");


var $k6QYd = parcelRequire("k6QYd");

// We want a consistent scroll speed across devices, regardless of framerate
function $4d516d91c431b939$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $4d516d91c431b939$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $eU390.axisLookup)[axis];
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $4d516d91c431b939$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $4d516d91c431b939$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $4d516d91c431b939$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $fYr9O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $4d516d91c431b939$export$470a2ff46db8cee8;

});

parcelRegister("fYr9O", function(module, exports) {
function $e40a4c0dcd17caec$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $e40a4c0dcd17caec$export$1a29de000a332d74;

});

parcelRegister("75xM4", function(module, exports) {
function $21de06d925095ccb$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $21de06d925095ccb$export$7120fdbd90bd1292;

});

parcelRegister("jNg3h", function(module, exports) {
function $97331151dddf073e$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $97331151dddf073e$export$cda7a9d4399bf2e3;

});

parcelRegister("gzlgs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d1462a8ed6b073902fb71e35882aa179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10068ea3730be40$var$_react = $c10068ea3730be40$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c10068ea3730be40$var$_baseNew = $c10068ea3730be40$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c10068ea3730be40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-collapse
 * Usage guidance:
 * Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c10068ea3730be40$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $c10068ea3730be40$var$_react.default.createElement($c10068ea3730be40$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$c10068ea3730be40$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $c10068ea3730be40$var$_default = module.exports.default = $c10068ea3730be40$var$SidebarCollapseIcon;

});

parcelRegister("1pYOd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::99730993d4263175d62f8db387d720e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10874b9e5ca41beb$var$_react = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10874b9e5ca41beb$var$_baseNew = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $10874b9e5ca41beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-expand
 * Usage guidance:
 * Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10874b9e5ca41beb$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $10874b9e5ca41beb$var$_react.default.createElement($10874b9e5ca41beb$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$10874b9e5ca41beb$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $10874b9e5ca41beb$var$_default = module.exports.default = $10874b9e5ca41beb$var$SidebarExpandIcon;

});

parcelRegister("beNrf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kulje = parcelRequire("kulje");


var $bGczG = parcelRequire("bGczG");


var $1lfgq = parcelRequire("1lfgq");


var $8XrN9 = parcelRequire("8XrN9");

const $17464b89cda99436$export$92bc057879827fcf = (selector, options)=>{
    const { placementId: placementId = 'headless', messageTemplateId: messageTemplateId } = selector;
    const { match: match, validate: validate, dataSource: dataSource, queryString: queryString } = options ?? {};
    // Store match/validate in refs so inline arrow functions passed by callers don't cause
    // the useMemo to re-run on every render. The latest value is always read inside the memo.
    const matchRef = (0, $cozmU.useRef)(match);
    matchRef.current = match;
    const validateRef = (0, $cozmU.useRef)(validate);
    validateRef.current = validate;
    const { data: data, dismissedIds: dismissedIds, isLoading: isLoading, error: fetchError, dismissMessage: dismissMessage } = (0, $1lfgq.usePlacementData)(placementId, {
        dataSource: dataSource,
        queryString: queryString
    });
    const { templateMessages: templateMessages, validationError: validationError } = (0, $cozmU.useMemo)(()=>{
        if (!data) return {
            templateMessages: [],
            validationError: undefined
        };
        let candidates;
        try {
            const result = matchRef.current ? matchRef.current({
                data: data,
                matchBuilder: (0, $8XrN9.createMatchBuilder)()
            }) : data.messages ?? [];
            const resolved = (0, $8XrN9.isMatchBuilder)(result) ? result.match(data) : result;
            candidates = resolved;
        } catch (err) {
            if (err instanceof (0, $8XrN9.PlacementLocationError)) return {
                templateMessages: [],
                validationError: err
            };
            return {
                templateMessages: [],
                validationError: (0, $8XrN9.toHookError)(err)
            };
        }
        const templateMatches = candidates.filter((m)=>m.messageTemplateId === messageTemplateId);
        const guard = validateRef.current ?? (0, $8XrN9.isPlacementMessage);
        let failedCount;
        try {
            failedCount = templateMatches.filter((m_0)=>!guard(m_0)).length;
        } catch (err_0) {
            return {
                templateMessages: [],
                validationError: (0, $8XrN9.toHookError)(err_0)
            };
        }
        if (failedCount > 0) return {
            templateMessages: [],
            validationError: new (0, $8XrN9.PlacementValidationError)({
                placementId: placementId,
                failedCount: failedCount
            })
        };
        return {
            templateMessages: templateMatches,
            validationError: undefined
        };
    }, [
        data,
        messageTemplateId,
        placementId
    ]);
    const messages = (0, $cozmU.useMemo)(()=>{
        return templateMessages.filter((m_1)=>!dismissedIds.has(m_1.messageInstanceId));
    }, [
        dismissedIds,
        templateMessages
    ]);
    // Build lookup from validated template data (not dismissed-filtered messages)
    // so dismissals and data refreshes don't change PostOfficeMessageInstance identity and remount callers.
    const messageByMessageInstanceId = (0, $cozmU.useMemo)(()=>{
        const lookup = {};
        for (const message of templateMessages)lookup[message.messageInstanceId] = message;
        return lookup;
    }, [
        templateMessages
    ]);
    const messageByMessageInstanceIdRef = (0, $cozmU.useRef)({});
    messageByMessageInstanceIdRef.current = messageByMessageInstanceId;
    // Single wrapper closed over placementId + messageTemplateId.
    // messageInstanceId is passed per-render by the caller.
    const PostOfficeMessageInstance = (0, $cozmU.useMemo)(()=>{
        return (props)=>{
            const message_0 = messageByMessageInstanceIdRef.current[props.messageInstanceId];
            const messageCategory = message_0?.messageCategory;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kulje.PostOfficeMessage), {
                placementId: placementId,
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory,
                ...(0, $bGczG.transformPlacementMessageToMessageLifecycleProps)({
                    message: message_0
                }),
                ...props
            });
        };
    }, [
        messageTemplateId,
        placementId
    ]);
    return {
        messages: messages,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage
    };
};
module.exports["useMessageInstances"] = $17464b89cda99436$export$92bc057879827fcf;

});

parcelRegister("kulje", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $i3S9F = parcelRequire("i3S9F");


var $cXtTj = parcelRequire("cXtTj");


var $6NRmI = parcelRequire("6NRmI");


var $k4HA2 = parcelRequire("k4HA2");

var $4cICV = parcelRequire("4cICV");

var $kEPax = parcelRequire("kEPax");

/**
 * Fires the Post Office "viewed" analytics events on mount.
 *
 * This is a separate inner component so that it only mounts when the choreographer
 * allows the message to render. It fires all three viewed events exactly once:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed()
 *   - messageInstanceDeliveredSuccessfully()
 *
 * Must be rendered inside a MessageContextProvider and PlacementProvider so that
 * useMessageViewed() can read the required context values.
 */ const $22daedfb2bfa2f59$var$ViewedOnMount = ()=>{
    const messageViewed = (0, $kEPax.useMessageViewed)();
    (0, $cozmU.useEffect)(()=>{
        messageViewed();
    // We intentionally omit deps — this should fire exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
/**
 * Defers evaluation of the children render prop until the message is mounted.
 *
 * This ensures that any side effects in the render prop only execute when the
 * choreographer allows the message to render, not when it is blocked.
 */ const $22daedfb2bfa2f59$var$RenderedChildren = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = children();
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children());
};
const $22daedfb2bfa2f59$var$ChoreographedMessage = ({ children: children, messageId: messageId, useChoreographedRender: useChoreographedRender })=>{
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
};
/**
 * Render-time Isolated Cloud gate.
 *
 * Returns `null` when the prop is enabled AND the tenant is in an Isolated Cloud
 * environment. Mirrors the headful behaviour wired by
 * `createBasePlacementComponentV2` (`options.hideInIsolatedCloud`).
 *
 * SSR handling is delegated to `isIsolatedCloud()` itself, which falls back to
 * `globalThis.ssrContext?.isInIC` when `document` is undefined.
 */ const $22daedfb2bfa2f59$var$IsolatedCloudGate = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children, hideInIsolatedCloud: hideInIsolatedCloud } = t0;
    if (hideInIsolatedCloud && (0, $i3S9F.isIsolatedCloud)()) return null;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children, hideInIsolatedCloud: hideInIsolatedCloud })=>{
    if (hideInIsolatedCloud && (0, $i3S9F.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
/**
 * Choreographer gating using the `ChoreographerContext` provided by
 * `StableChoreographerProvider` (from `@atlassian/post-office-context/choreographer`).
 *
 * When the choreographer is disabled or its factory is not yet loaded,
 * the message renders unconditionally.
 *
 * When `disableChoreographer` is `true`, the gate short-circuits and renders
 * children unconditionally — bypassing the choreographer entirely for this message.
 */ const $22daedfb2bfa2f59$var$ChoreographerGate = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer } = t0;
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate("enable_choreographed_post_office_messages");
    if (disableChoreographer) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate("post-office_use_template_id_for_choreo");
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            let t1;
            if ($[2] !== children || $[3] !== choreographerMessageId || $[4] !== useChoreographedRender) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographedMessage, {
                    messageId: choreographerMessageId,
                    useChoreographedRender: useChoreographedRender
                }, children);
                $[2] = children;
                $[3] = choreographerMessageId;
                $[4] = useChoreographedRender;
                $[5] = t1;
            } else t1 = $[5];
            return t1;
        }
    }
    let t1;
    if ($[6] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[6] = children;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer })=>{
    // Hooks must run on every render to preserve hook order — do not short-circuit
    // before calling them, even when `disableChoreographer` is set.
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    if (disableChoreographer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographedMessage, {
                messageId: choreographerMessageId,
                useChoreographedRender: useChoreographedRender
            }, children);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $22daedfb2bfa2f59$export$7356a355af87a394 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children } = t0;
    let t1;
    if ($[0] !== configSetId || $[1] !== journeyId || $[2] !== journeyTriggerId || $[3] !== messageCategory || $[4] !== messageCreationType || $[5] !== messageInstanceId || $[6] !== messageTemplateId || $[7] !== triggerId) {
        t1 = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        };
        $[0] = configSetId;
        $[1] = journeyId;
        $[2] = journeyTriggerId;
        $[3] = messageCategory;
        $[4] = messageCreationType;
        $[5] = messageInstanceId;
        $[6] = messageTemplateId;
        $[7] = triggerId;
        $[8] = t1;
    } else t1 = $[8];
    const messageContext = t1;
    let t2;
    if ($[9] !== placementId) {
        t2 = {
            placementId: placementId
        };
        $[9] = placementId;
        $[10] = t2;
    } else t2 = $[10];
    const placementContext = t2;
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ViewedOnMount, null);
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$RenderedChildren, null, children);
        $[12] = children;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== disableChoreographer || $[15] !== messageCategory || $[16] !== messageInstanceId || $[17] !== messageTemplateId || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographerGate, {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            disableChoreographer: disableChoreographer
        }, t3, t4);
        $[14] = disableChoreographer;
        $[15] = messageCategory;
        $[16] = messageInstanceId;
        $[17] = messageTemplateId;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== messageContext || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k4HA2.MessageContextProvider), {
            value: messageContext
        }, t5);
        $[20] = messageContext;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== placementContext || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cICV.PlacementProvider), {
            value: placementContext
        }, t6);
        $[23] = placementContext;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== hideInIsolatedCloud || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$IsolatedCloudGate, {
            hideInIsolatedCloud: hideInIsolatedCloud
        }, t7);
        $[26] = hideInIsolatedCloud;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children })=>{
    const messageContext = (0, $cozmU.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        triggerId,
        messageCreationType,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const placementContext = (0, $cozmU.useMemo)(()=>({
            placementId: placementId
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$IsolatedCloudGate, {
        hideInIsolatedCloud: hideInIsolatedCloud
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cICV.PlacementProvider), {
        value: placementContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k4HA2.MessageContextProvider), {
        value: messageContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographerGate, {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        disableChoreographer: disableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ViewedOnMount, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$RenderedChildren, null, children)))));
};
module.exports["PostOfficeMessage"] = $22daedfb2bfa2f59$export$7356a355af87a394;

});

parcelRegister("bGczG", function(module, exports) {
const $5cb230a6b87dbda9$var$transformMessageCreationTypeToPostOfficeMessageCreationType = ({ messageCreationType: messageCreationType })=>{
    if (messageCreationType === 'implicit' || messageCreationType === 'explicit') return messageCreationType;
    return undefined;
};
const $5cb230a6b87dbda9$export$61e95755e67323e4 = ({ message: message })=>({
        configSetId: message?.configSetId,
        journeyId: message?.journeyId,
        journeyTriggerId: message?.journeyTriggerId,
        messageCreationType: $5cb230a6b87dbda9$var$transformMessageCreationTypeToPostOfficeMessageCreationType({
            messageCreationType: message?.messageCreationType
        }),
        triggerId: message?.triggerId
    });
module.exports["transformPlacementMessageToMessageLifecycleProps"] = $5cb230a6b87dbda9$export$61e95755e67323e4;

});

parcelRegister("1lfgq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iQwJa = parcelRequire("iQwJa");

var $di43e = parcelRequire("di43e");

var $bGVJw = parcelRequire("bGVJw");


var $gswTK = parcelRequire("gswTK");


var $iDSbf = parcelRequire("iDSbf");


var $kulje = parcelRequire("kulje");

/**
 * Foundation hook for the Post Office Headless API.
 *
 * Fetches raw Placement API data for a given `placementId` and tracks which
 * message instances have been dismissed in the current session via the Post
 * Office pub/sub system.
 *
 * All higher-level hooks (`useAllMessages`, `useMessageInstances`, `useMessageData`) compose on top
 * of this hook.
 *
 * Automatically reads the current `PostOfficeContext` (product, locale, tenantId, workspaceAri,
 * etc.) via `usePostOfficeContext` and forwards it to the Placement API request as query
 * parameters. No manual context threading is required.
 *
 * Requires `PlacementFetchingProvider` and `MessagePlacementProvider` (or
 * `PostOfficeProvider`) to be present in the React tree.
 *
 * @example
 * ```tsx
 * const { data, dismissedIds, isLoading, error, dismissMessage } = usePlacementData(
 *   'some-placement',
 * );
 *
 * const visibleMessages = data?.messages.filter(
 *   m => !dismissedIds.has(m.messageInstanceId)
 * ) ?? [];
 * ```
 *
 * @typeParam TMessage - A {@link PlacementMessageDiscriminant} or union thereof.
 *   Provide a union to model multiple template types with narrowable `context`:
 *   `usePlacementData<{ messageTemplateId: 'banner'; context: BannerCtx } | { messageTemplateId: 'flag'; context: FlagCtx }>(id)`
 * @typeParam TExtension - Additional top-level fields to expect in the `data` shape.
 * @param placementId - The ID of the placement to fetch data for. Defaults to `'headless'`.
 * @param options - Optional configuration. Pass `{ dataSource: 'DEV_SERVER' }` to point the hook
 *   at the local placement dev server (`yarn placement:v2 dev`, default port `4224`).
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/6764207116
 */ /** Base URL used when `dataSource` is `'DEV_SERVER'`. Only included in non-production builds. */ const $cbd913b69b48d9f0$var$DEV_SERVER_BASE_URL = 'http://localhost:4224';
const $cbd913b69b48d9f0$export$a9668c1d52481a0f = (placementId = 'headless', options)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const { onMessageDismiss: onMessageDismiss, dismissMessageFromPlacement: dismissMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)();
    const { dataSource: dataSource = 'PRODUCTION', queryString: queryString } = options ?? {};
    const arePlacementsGloballyDisabled = (0, $iDrrr.fg)('post-office-enable-headless-disable-placement') && (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(postOfficeContext);
    const placementIdToFetch = arePlacementsGloballyDisabled ? null : placementId;
    // When targeting the dev server, override the fetch so the request goes to
    // `http://localhost:4224` instead of the production gateway. The dev server
    // exposes the same URL path as production.
    let effectiveFetcher = fetcher;
    if (dataSource === 'DEV_SERVER') effectiveFetcher = {
        fetch: (url, init)=>{
            // Replace the origin with the dev server base URL, keeping the path intact.
            // Guard against SSR environments where window is not defined.
            const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            const originalUrl = new URL(url, origin);
            const devUrl = `${$cbd913b69b48d9f0$var$DEV_SERVER_BASE_URL}${originalUrl.pathname}${originalUrl.search}`;
            return fetcher.fetch(devUrl, init);
        }
    };
    // Merge any caller-provided `queryString` params with the PostOfficeContext params.
    // This is additive only: context values always take precedence, so callers can never
    // override the context-derived query parameters — they can only add new ones.
    // Gated behind `post-office-enable-headless-query`: when the gate is off the caller
    // `queryString` is ignored entirely and only the context-derived params are sent,
    // preserving the pre-existing request shape.
    // Memoised on the stringified queryString so the SWR request key stays stable across
    // renders when an inline object with identical contents is passed.
    const isHeadlessQueryEnabled = (0, $iDrrr.fg)('post-office-enable-headless-query');
    const queryStringKey = isHeadlessQueryEnabled && queryString ? JSON.stringify(queryString) : undefined;
    const requestContext = (0, $cozmU.useMemo)(()=>isHeadlessQueryEnabled && queryString ? {
            ...queryString,
            ...postOfficeContext
        } : postOfficeContext, // eslint-disable-next-line react-hooks/exhaustive-deps -- queryStringKey is a stable stringification of queryString
    [
        postOfficeContext,
        queryStringKey,
        isHeadlessQueryEnabled
    ]);
    const response = (0, $iDSbf.useFetchPlacementData)(placementIdToFetch, 'headless', requestContext, effectiveFetcher, undefined, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [dismissedIds, setDismissedIds] = (0, $cozmU.useState)(()=>new Set());
    // Synchronously reset dismissedIds in the render path when placementId changes.
    // A useEffect-based reset fires after paint, leaving a one-render window where
    // the new placement is painted with stale dismissed IDs from the previous one.
    // Calling setState during render causes React to discard this render and
    // immediately re-render with the new state; consumers never observe stale IDs.
    //
    // Infinite re-render safety — two independent guards prevent looping:
    //   1. prevPlacementIdRef.current is written BEFORE setDismissedIds is called.
    //      On the re-render React immediately triggers, the ref already equals
    //      placementId so the outer `if` is false — no further setState occurs.
    //   2. After the reset, dismissedIds.size === 0, so the inner size guard is
    //      also false — a second guard independent of the ref. Either alone is
    //      sufficient; both together make the loop prevention unconditional.
    // See: 'infinite re-render safety' tests in usePlacementData.test.tsx.
    const prevPlacementIdRef = (0, $cozmU.useRef)(placementId);
    const placementChanged = prevPlacementIdRef.current !== placementId;
    // Return an empty set immediately on the first render with a new placementId —
    // including the discarded render that React produces when setState is called
    // during rendering. This ensures no render ever exposes stale dismissed IDs
    // from the previous placement, even transiently.
    // Reference stability: when dismissedIds is already empty we reuse the same
    // Set reference (no new object, no unnecessary re-render).
    const effectiveDismissedIds = placementChanged && dismissedIds.size > 0 ? new Set() : dismissedIds;
    if (placementChanged) {
        prevPlacementIdRef.current = placementId;
        // Only reset if the set is non-empty to avoid an unnecessary extra render.
        if (dismissedIds.size > 0) setDismissedIds(new Set());
    }
    // Subscribe to pub/sub dismiss events on mount, unsubscribe on unmount.
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = onMessageDismiss(({ messageInstanceId: messageInstanceId })=>{
            setDismissedIds((prev)=>{
                // Guard: do not create a new Set reference if the ID is already dismissed.
                if (prev.has(messageInstanceId)) return prev;
                return new Set([
                    ...prev,
                    messageInstanceId
                ]);
            });
        });
        return unsubscribe;
    }, [
        onMessageDismiss
    ]);
    const dismissMessage = (0, $cozmU.useCallback)((messageInstanceId)=>{
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
    }, [
        dismissMessageFromPlacement
    ]);
    const { isLoading: isLoading, error: error } = response;
    const PostOfficePlacementMessage = (0, $cozmU.useMemo)(()=>({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kulje.PostOfficeMessage), {
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                placementId: placementId,
                messageCategory: messageCategory,
                triggerId: triggerId,
                messageCreationType: messageCreationType,
                journeyId: journeyId,
                journeyTriggerId: journeyTriggerId,
                configSetId: configSetId
            }, children), [
        placementId
    ]);
    return {
        data: response.data?.data,
        errors: response.data?.errors ?? [],
        dismissedIds: effectiveDismissedIds,
        isLoading: isLoading,
        error: error,
        dismissMessage: dismissMessage,
        PostOfficePlacementMessage: PostOfficePlacementMessage
    };
};
module.exports["usePlacementData"] = $cbd913b69b48d9f0$export$a9668c1d52481a0f;

});

parcelRegister("8XrN9", function(module, exports) {
/** Shared utilities for post-office headless API hooks. */ class $d7a7c6eb9fc5b129$export$70abd424e1cca8c3 extends Error {
    constructor({ placementId: placementId, failedCount: failedCount }){
        super('One or more messages failed structural validation');
        this.name = 'PlacementValidationError';
        this.placementId = void 0;
        this.failedCount = void 0;
        this.placementId = placementId;
        this.failedCount = failedCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $d7a7c6eb9fc5b129$export$fc2b8b9bcb86a0d0 extends Error {
    constructor({ placementId: placementId, messageTemplateId: messageTemplateId, instanceCount: instanceCount }){
        super('Multiple message instances found; the hook is in an unexpected state and no message will be returned. Use useMessageInstances if multiple instances are expected.');
        this.name = 'MultipleMessageInstancesError';
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.instanceCount = void 0;
        this.placementId = placementId;
        this.messageTemplateId = messageTemplateId;
        this.instanceCount = instanceCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $d7a7c6eb9fc5b129$export$17455b84f403213b extends Error {
    constructor({ locationKey: locationKey, invalidCount: invalidCount }){
        super('All items at the message location must be valid PlacementMessage objects');
        this.name = 'PlacementLocationError';
        this.locationKey = void 0;
        this.invalidCount = void 0;
        this.locationKey = locationKey;
        this.invalidCount = invalidCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $d7a7c6eb9fc5b129$export$a8ba7e6c095216ec = (item)=>{
    if (typeof item !== 'object' || item === null) return false;
    const msg = item;
    return typeof msg.messageTemplateId === 'string' && typeof msg.messageInstanceId === 'string' && typeof msg.context === 'object' && msg.context !== null;
};
const $d7a7c6eb9fc5b129$export$8364e41b11fd7d3b = (thrown, fallbackMessage = 'Hook callback threw')=>{
    if (thrown instanceof Error) return thrown;
    if (typeof thrown === 'string') return new Error(thrown);
    return new Error(fallbackMessage);
};
// Match Builder
/** @internal — used to tag match-builder objects in place of `instanceof`. */ const $d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG = Symbol('MatchBuilder');
/** @internal — creates a builder with the given accumulated state (location already resolved). */ const $d7a7c6eb9fc5b129$var$makeMatchBuilder = (locationKey, contextPredicates, dataPredicates)=>{
    const builder = {
        messageContext (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder(locationKey, [
                ...contextPredicates,
                predicate
            ], dataPredicates);
        },
        custom (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder(locationKey, contextPredicates, [
                ...dataPredicates,
                predicate
            ]);
        },
        match (data) {
            if (dataPredicates.some((p)=>!p(data))) return [];
            const raw = data[locationKey] ?? [];
            if (!Array.isArray(raw)) throw new $d7a7c6eb9fc5b129$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: 1
            });
            const items = raw;
            const invalidCount = items.filter((item)=>!$d7a7c6eb9fc5b129$export$a8ba7e6c095216ec(item)).length;
            if (invalidCount > 0) throw new $d7a7c6eb9fc5b129$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: invalidCount
            });
            const candidates = items;
            return candidates.filter((message)=>contextPredicates.every((p)=>p(message.context)));
        }
    };
    // Tag the builder with a non-enumerable symbol so isMatchBuilder can identify it without
    // relying on instanceof (which would break across module boundaries or after minification).
    Object.defineProperty(builder, $d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return builder;
};
/** @internal — creates the initial builder with `messageLocation` available. */ const $d7a7c6eb9fc5b129$var$makeInitialMatchBuilder = ()=>{
    const initial = {
        messageLocation (key) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder(key, [], []);
        },
        messageContext (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder('messages', [
                predicate
            ], []);
        },
        custom (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder('messages', [], [
                predicate
            ]);
        },
        match (data) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder('messages', [], []).match(data);
        }
    };
    Object.defineProperty(initial, $d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return initial;
};
const $d7a7c6eb9fc5b129$export$be507563b85af550 = (value)=>{
    return typeof value === 'object' && value !== null && value[$d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG] === true;
};
const $d7a7c6eb9fc5b129$export$861b204abcaa015d = ()=>$d7a7c6eb9fc5b129$var$makeInitialMatchBuilder();
module.exports["PlacementValidationError"] = $d7a7c6eb9fc5b129$export$70abd424e1cca8c3;
module.exports["MultipleMessageInstancesError"] = $d7a7c6eb9fc5b129$export$fc2b8b9bcb86a0d0;
module.exports["PlacementLocationError"] = $d7a7c6eb9fc5b129$export$17455b84f403213b;
module.exports["isPlacementMessage"] = $d7a7c6eb9fc5b129$export$a8ba7e6c095216ec;
module.exports["toHookError"] = $d7a7c6eb9fc5b129$export$8364e41b11fd7d3b;
module.exports["isMatchBuilder"] = $d7a7c6eb9fc5b129$export$be507563b85af550;
module.exports["createMatchBuilder"] = $d7a7c6eb9fc5b129$export$861b204abcaa015d;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("b6QLO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");


var $kb1I3 = parcelRequire("kb1I3");


var $3sXr4 = parcelRequire("3sXr4");

const $79c6915ee8b28dcd$var$messages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    structuringYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-content",
        defaultMessage: "Structuring your content"
    },
    designingYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-content",
        defaultMessage: "Designing your content"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance = (0, $kSwu1.defineMessages)({
    rovoIsImagining: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-imagining",
        defaultMessage: "Rovo is dreaming it up"
    },
    sketchingSomeIdeas: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.sketching-some-ideas",
        defaultMessage: "Sketching ideas"
    },
    mixingTheColors: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.mixing-the-colors",
        defaultMessage: "Mixing colors"
    },
    findingTheRightStyle: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.finding-the-right-style",
        defaultMessage: "Finding the right style"
    },
    bringingItToLife: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.bringing-it-to-life",
        defaultMessage: "Bringing it to life"
    },
    addingTheDetails: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-the-details",
        defaultMessage: "Adding details"
    },
    applyingTheFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-the-final-touches",
        defaultMessage: "Applying final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.image-almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$styles = {
    rovoWrapperFixed: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdy1CL _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _42Yu6BbFo4",
    rovoWrapperFixedContentCentered: "_1mT5xdy1CL _0Bm75G5zaO _39xV02E6Kk _1VJPcajssS _42Yu6BbFo4",
    parentDetector: "_1mT5xdWVPG _0fKRyPnQyn _1pp6NdYbGa",
    rovoWrapperAbsolute: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdWVPG _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _42Yu6BbFo4",
    rovoWrapperRelative: "_1mT5xdRAKS _0Of8r25zaO _1wydGW5zaO"
};
function $79c6915ee8b28dcd$export$d6f2d83daf5efc44({ onStop: onStop, optionType: _optionType, isRelative: isRelative = false, showProgressBar: showProgressBar = false, isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    const positionAbsolute = contentType === 'jira.issue'; // Confluence page remix uses the fixed/overlay path (no `contentType`, not `isRelative`).
    // When enabled, center the bar over the content area instead of the viewport so it stays
    // aligned when a sidenav/sidebar is open. Jira (`positionAbsolute`) is unaffected.
    const isCenterContentExpEnabled = (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_2', 'isEnabled', true);
    const shouldCenterOnContent = isCenterContentExpEnabled && shouldMeasureContentBounds; // Measure the content container (the detector marker's parent) so the fixed bar can be
    // centered on the content rather than the viewport. Re-measures on container resize, which
    // covers a sidenav/sidebar opening or closing. Stays viewport-centered until measured.
    const parentDetectorRef = (0, $cozmU.useRef)(null);
    const [contentCenterX, setContentCenterX] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldCenterOnContent) return;
        const parentContainer = parentDetectorRef.current?.parentElement;
        if (!parentContainer) return;
        const updateCenter = ()=>{
            const rect = parentContainer.getBoundingClientRect();
            setContentCenterX(rect.left + rect.width / 2);
        };
        const resizeObserver = new ResizeObserver(updateCenter);
        resizeObserver.observe(parentContainer);
        updateCenter();
        return ()=>resizeObserver.disconnect();
    }, [
        shouldCenterOnContent
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const thinkingTexts = [
        formatMessage($79c6915ee8b28dcd$var$messages.rovoIsThinking),
        formatMessage($79c6915ee8b28dcd$var$messages.analyzingContent),
        formatMessage($79c6915ee8b28dcd$var$messages.puttingPiecesTogether),
        formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? $79c6915ee8b28dcd$var$messages.structuringYourContent : $79c6915ee8b28dcd$var$messages.structuringRemix),
        formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? $79c6915ee8b28dcd$var$messages.designingYourContent : $79c6915ee8b28dcd$var$messages.designingRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.addingItAllTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.applyingFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$messages.almostDone)
    ];
    const thinkingTextsNonRemixEntrance = [
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.rovoIsImagining),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.sketchingSomeIdeas),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.mixingTheColors),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.findingTheRightStyle),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.bringingItToLife),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.addingTheDetails),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.applyingTheFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.almostDone)
    ];
    const barContent = /*#__PURE__*/ $cozmU.createElement((0, $3sXr4.RovoThinkingBarWrapper), {
        isThinking: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar), {
        onStop: onStop,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        useRotatingTitle: true,
        customRotatingMessages: isRemixEntrance ? thinkingTexts : thinkingTextsNonRemixEntrance
    })); // Content-centered fixed path (Confluence view page, gated + opted in via
    // `shouldMeasureContentBounds`). Renders a hidden marker so the content container can be
    // measured, then centers the fixed bar on the content's horizontal midpoint. Falls back to
    // viewport-centering (`left: 50%`) until the measurement resolves.
    if (!isRelative && !positionAbsolute && shouldCenterOnContent) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: parentDetectorRef,
        xcss: $79c6915ee8b28dcd$var$styles.parentDetector,
        testId: "remix-thinking-bar-parent-detector"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $79c6915ee8b28dcd$var$styles.rovoWrapperFixedContentCentered,
        style: {
            minWidth: (0, $iDrrr.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px',
            left: contentCenterX != null ? `${contentCenterX}px` : '50%'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: // eslint-disable-next-line no-nested-ternary
        isRelative ? $79c6915ee8b28dcd$var$styles.rovoWrapperRelative : positionAbsolute ? $79c6915ee8b28dcd$var$styles.rovoWrapperAbsolute : $79c6915ee8b28dcd$var$styles.rovoWrapperFixed,
        style: {
            minWidth: (0, $iDrrr.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent);
}
module.exports["RemixThinkingBar"] = $79c6915ee8b28dcd$export$d6f2d83daf5efc44;

});

parcelRegister("1qYXT", function(module, exports) {
/** Node types we never show Remix for. */ const $f654d7d76017903f$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    // Source blocks
    'bodiedSyncBlock',
    // Reference blocks
    'syncBlock',
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$DENY_SET = new Set($f654d7d76017903f$export$7004846771b000c0);
const $f654d7d76017903f$export$bf9aef57175a93a2 = (nodeType)=>$f654d7d76017903f$var$DENY_SET.has(nodeType);
const $f654d7d76017903f$export$a7b703a84f6e523d = (extensionKey, allowList)=>extensionKey !== undefined && allowList.includes(extensionKey);
module.exports["REMIX_DENY_LIST_V1"] = $f654d7d76017903f$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $f654d7d76017903f$export$bf9aef57175a93a2;
module.exports["isAllowedMBEExtensionForRemix"] = $f654d7d76017903f$export$a7b703a84f6e523d;

});

parcelRegister("loej8", function(module, exports) {

var $gJ798 = parcelRequire("gJ798");


var $eFBG8 = parcelRequire("eFBG8");


var $2lF67 = parcelRequire("2lF67");


var $lBKFk = parcelRequire("lBKFk");


var $a79Sy = parcelRequire("a79Sy");


var $9KPiA = parcelRequire("9KPiA");


var $bDjVc = parcelRequire("bDjVc");


var $iDrrr = parcelRequire("iDrrr");


var $czfXc = parcelRequire("czfXc");

/**
 * All available remix options with their sub-types (variants).
 *
 * Sub-type values match the backend `dynamicUiSubtype` parameter
 * used in the remix-content minion (see edit-with-rovo-bar).
 */ const $1b429d4516497df0$var$defaultInfographicSubTypes = [
    {
        value: 'corporate-modern',
        displayName: 'modern style infographic',
        labelMessage: (0, $czfXc.default).subTypeModernStyle,
        testId: 'remix-sub-type-corporate-modern'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
const $1b429d4516497df0$var$newInfographicSubTypes = [
    {
        value: 'charlie',
        displayName: 'bold style infographic',
        labelMessage: (0, $czfXc.default).subTypeBoldStyle,
        testId: 'remix-sub-type-charlie'
    },
    {
        value: 'minimalist',
        displayName: 'minimalist style infographic',
        labelMessage: (0, $czfXc.default).subTypeMinimalistStyle,
        testId: 'remix-sub-type-minimalist'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
function $1b429d4516497df0$export$b867d47ced1865f7() {
    return (0, $iDrrr.fg)('cc-maui-phase-2') ? $1b429d4516497df0$var$newInfographicSubTypes : $1b429d4516497df0$var$defaultInfographicSubTypes;
}
const $1b429d4516497df0$var$defaultVisualAidSubTypes = [
    {
        value: 'flip-card',
        displayName: 'flip card',
        labelMessage: (0, $czfXc.default).subTypeFlipCard,
        testId: 'remix-sub-type-flip-card'
    },
    {
        value: 'quadrant',
        displayName: 'quadrant',
        labelMessage: (0, $czfXc.default).subTypeQuadrant,
        testId: 'remix-sub-type-quadrant'
    },
    {
        value: 'tree-map',
        displayName: 'tree map',
        labelMessage: (0, $czfXc.default).subTypeTreeMap,
        testId: 'remix-sub-type-tree-map'
    },
    {
        value: 'horizontal-timeline',
        displayName: 'timeline',
        labelMessage: (0, $czfXc.default).subTypeTimeline,
        testId: 'remix-sub-type-horizontal-timeline'
    },
    {
        value: 'map',
        displayName: 'map',
        labelMessage: (0, $czfXc.default).subTypeGeographicalMap,
        testId: 'remix-sub-type-map'
    },
    {
        value: 'org-chart',
        displayName: 'org chart',
        labelMessage: (0, $czfXc.default).subTypeOrgChart,
        testId: 'remix-sub-type-org-chart'
    }
];
const $1b429d4516497df0$var$imageSubType = {
    value: 'image',
    displayName: 'image',
    labelMessage: (0, $czfXc.default).subTypeImage,
    testId: 'remix-sub-type-image',
    emitType: 'image'
};
function $1b429d4516497df0$export$b9ec4f683b57ea1d() {
    return (0, $iDrrr.fg)('cc-maui-phase-3') ? [
        ...$1b429d4516497df0$var$defaultVisualAidSubTypes,
        $1b429d4516497df0$var$imageSubType
    ] : $1b429d4516497df0$var$defaultVisualAidSubTypes;
}
const $1b429d4516497df0$export$f0ba07b8deaf6c2d = [
    {
        type: 'chart',
        displayName: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
        labelMessage: (0, $czfXc.default).remixOptionChart,
        iconAltMessage: (0, $czfXc.default).chartIconAlt,
        tooltipMessage: (0, $czfXc.default).chartTooltip,
        testId: 'remix-overlay-option-chart',
        subTypes: [
            {
                value: 'line-chart',
                displayName: 'line chart',
                labelMessage: (0, $czfXc.default).subTypeLineChart,
                testId: 'remix-sub-type-line-chart'
            },
            {
                value: 'area-chart',
                displayName: 'area chart',
                labelMessage: (0, $czfXc.default).subTypeAreaChart,
                testId: 'remix-sub-type-area-chart'
            },
            {
                value: 'bar-chart',
                displayName: 'bar chart',
                labelMessage: (0, $czfXc.default).subTypeBarChart,
                testId: 'remix-sub-type-bar-chart'
            },
            {
                value: 'funnel-chart',
                displayName: 'funnel chart',
                labelMessage: (0, $czfXc.default).subTypeFunnelChart,
                testId: 'remix-sub-type-funnel-chart'
            },
            {
                value: 'pie-chart',
                displayName: 'pie chart',
                labelMessage: (0, $czfXc.default).subTypePieChart,
                testId: 'remix-sub-type-pie-chart'
            },
            {
                value: 'gantt-chart',
                displayName: 'Gantt chart',
                labelMessage: (0, $czfXc.default).subTypeGanttChart,
                testId: 'remix-sub-type-gantt-chart'
            }
        ]
    },
    {
        type: 'diagram',
        displayName: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eFBG8))),
        labelMessage: (0, $czfXc.default).remixOptionDiagram,
        iconAltMessage: (0, $czfXc.default).diagramIconAlt,
        tooltipMessage: (0, $czfXc.default).diagramTooltip,
        testId: 'remix-overlay-option-diagram',
        subTypes: [
            {
                value: 'mindmap',
                displayName: 'mind map',
                labelMessage: (0, $czfXc.default).subTypeMindMap,
                testId: 'remix-sub-type-mindmap'
            },
            {
                value: 'flowchart',
                displayName: 'flowchart',
                labelMessage: (0, $czfXc.default).subTypeFlowChart,
                testId: 'remix-sub-type-flowchart'
            }
        ]
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    },
    {
        type: 'visual-aid',
        displayName: 'visualization',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
        labelMessage: (0, $czfXc.default).remixOptionVisualization,
        iconAltMessage: (0, $czfXc.default).visualizationIconAlt,
        tooltipMessage: (0, $czfXc.default).visualizationTooltip,
        testId: 'remix-overlay-option-visual-aid',
        subTypes: $1b429d4516497df0$var$defaultVisualAidSubTypes
    }
];
const $1b429d4516497df0$export$839e8948e17d6e68 = [
    {
        type: 'slides',
        displayName: 'slides',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9KPiA))),
        labelMessage: (0, $czfXc.default).remixOptionSlides,
        iconAltMessage: (0, $czfXc.default).slidesIconAlt,
        tooltipMessage: (0, $czfXc.default).slidesTooltip,
        testId: 'remix-overlay-option-slides',
        subTypes: [],
        iconTileAppearance: 'green'
    },
    {
        type: 'whiteboard',
        displayName: 'whiteboard',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        labelMessage: (0, $czfXc.default).remixOptionWhiteboard,
        iconAltMessage: (0, $czfXc.default).whiteboardIconAlt,
        tooltipMessage: (0, $czfXc.default).whiteboardTooltip,
        testId: 'remix-overlay-option-whiteboard',
        subTypes: [],
        iconTileAppearance: 'teal'
    },
    {
        type: 'database',
        displayName: 'database',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        labelMessage: (0, $czfXc.default).remixOptionDatabase,
        iconAltMessage: (0, $czfXc.default).databaseIconAlt,
        tooltipMessage: (0, $czfXc.default).databaseTooltip,
        testId: 'remix-overlay-option-database',
        subTypes: [],
        iconTileAppearance: 'purple'
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    }
];
function $1b429d4516497df0$var$applyGatedSubTypes(remixChoices) {
    const infographicSubTypes = $1b429d4516497df0$export$b867d47ced1865f7();
    const visualAidSubTypes = $1b429d4516497df0$export$b9ec4f683b57ea1d();
    return remixChoices.map((opt)=>{
        if (opt.type === 'infographic') return {
            ...opt,
            subTypes: infographicSubTypes
        };
        if (opt.type === 'visual-aid') return {
            ...opt,
            subTypes: visualAidSubTypes
        };
        return opt;
    });
}
function $1b429d4516497df0$export$eba289419a85029b({ source: source = {
    kind: 'preset',
    preset: 'selection'
}, excludedRemixTypes: excludedRemixTypes } = {}) {
    let sourceChoices;
    switch(source.kind){
        case 'preset':
            sourceChoices = source.preset === 'page' ? $1b429d4516497df0$export$839e8948e17d6e68 : $1b429d4516497df0$export$f0ba07b8deaf6c2d;
            break;
        case 'custom':
            sourceChoices = source.choices;
            break;
    }
    return $1b429d4516497df0$export$cf3073d90a2d0bae($1b429d4516497df0$var$applyGatedSubTypes(sourceChoices), excludedRemixTypes);
}
/** Render-time lookup reflects current feature gates */ function $1b429d4516497df0$var$getAllOptions() {
    return $1b429d4516497df0$export$eba289419a85029b({
        source: {
            kind: 'custom',
            choices: [
                ...$1b429d4516497df0$export$f0ba07b8deaf6c2d,
                ...$1b429d4516497df0$export$839e8948e17d6e68
            ]
        }
    });
}
function $1b429d4516497df0$export$cf3073d90a2d0bae(remixChoices, excludedRemixTypes) {
    if (!excludedRemixTypes?.length) return remixChoices;
    const excludedRemixTypeSet = new Set(excludedRemixTypes);
    return remixChoices.filter((choice)=>choice.type === 'custom' || !excludedRemixTypeSet.has(choice.type));
}
function $1b429d4516497df0$export$b3104233810c1e93(typeValue) {
    const match = $1b429d4516497df0$var$getAllOptions().find((option)=>option.type === typeValue);
    return match?.displayName ?? typeValue.replace(/-/g, ' ');
}
function $1b429d4516497df0$export$ca76798d0446453(subTypeValue) {
    for (const option of $1b429d4516497df0$var$getAllOptions()){
        const match = option.subTypes.find((st)=>st.value === subTypeValue);
        if (match) return match.displayName;
    }
    return subTypeValue.replace(/-/g, ' ');
}
function $1b429d4516497df0$export$bd80fc308a7bbe16(dynamicUiType, dynamicUiSubtype) {
    const allOptions = $1b429d4516497df0$var$getAllOptions();
    // First, try to find the category by matching the dynamicUiType directly.
    let matchedOption = allOptions.find((opt)=>opt.type === dynamicUiType);
    // If the direct match doesn't contain the requested sub-type (e.g. the
    // node's emitType points to a different category than where the sub-type
    // actually lives), or if no category matched at all, fall back to scanning
    // all categories for a sub-type whose value or emitType matches.
    if (dynamicUiSubtype) {
        const subtypeInMatch = matchedOption?.subTypes.some((st)=>st.value === dynamicUiSubtype);
        if (!matchedOption || !subtypeInMatch) {
            const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.value === dynamicUiSubtype || st.emitType === dynamicUiType));
            if (fallback) matchedOption = fallback;
        }
    } else if (!matchedOption) {
        // No subtype provided and no direct category match — the dynamicUiType
        // may be an emitType override (e.g. 'image' which is a sub-type in
        // 'visual-aid' with emitType: 'image'). Scan all categories for a
        // sub-type whose emitType matches.
        const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.emitType === dynamicUiType));
        if (fallback) matchedOption = fallback;
    }
    // No matching category, or category has no sub-types (e.g. slides, whiteboard)
    if (!matchedOption || matchedOption.subTypes.length === 0) return null;
    const groupLabel = matchedOption.labelMessage.defaultMessage ?? '';
    const groupLabelMessage = matchedOption.labelMessage;
    // Find the current sub-type within the matched category.
    // When dynamicUiSubtype is provided, match by value directly.
    // When only dynamicUiType is provided (no subtype), try to find a sub-type
    // whose emitType matches dynamicUiType (e.g. emitType: 'image' → the 'image' sub-type).
    let currentSubType = dynamicUiSubtype ? matchedOption.subTypes.find((st)=>st.value === dynamicUiSubtype) : matchedOption.subTypes.find((st)=>st.emitType === dynamicUiType);
    // If a subtype was provided but not found in this category, return null
    // to avoid showing a broken dropdown.
    if (dynamicUiSubtype && !currentSubType) return null;
    // Variants with `emitType` are only selectable from the remix-overlay.
    // When the active subtype has an emitType override, hide the switcher
    // entirely so the user cannot switch away from it.
    if (currentSubType?.emitType) return null;
    // Filter out emitType variants from the switcher — they should only
    // appear in the remix-overlay, not in the editor toolbar dropdown.
    const filteredSubTypes = matchedOption.subTypes.filter((st)=>!st.emitType);
    if (filteredSubTypes.length === 0) return null;
    // Fall back to category-level label if no sub-type is set
    // (e.g. "Pick for me" was used).
    const currentLabel = currentSubType ? currentSubType.labelMessage.defaultMessage ?? '' : groupLabel;
    const currentLabelMessage = currentSubType ? currentSubType.labelMessage : groupLabelMessage;
    return {
        groupLabel: groupLabel,
        groupLabelMessage: groupLabelMessage,
        currentLabel: currentLabel,
        currentLabelMessage: currentLabelMessage,
        siblingSubTypes: filteredSubTypes
    };
}
module.exports["PAGE_REMIX_OPTIONS"] = $1b429d4516497df0$export$839e8948e17d6e68;
module.exports["getRemixMenuOptions"] = $1b429d4516497df0$export$eba289419a85029b;
module.exports["getTypeDisplayName"] = $1b429d4516497df0$export$b3104233810c1e93;
module.exports["getSubTypeDisplayName"] = $1b429d4516497df0$export$ca76798d0446453;
module.exports["getRemixSwitcherInfo"] = $1b429d4516497df0$export$bd80fc308a7bbe16;

});

parcelRegister("czfXc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0a9658e5a4289f5$var$messages = (0, $kSwu1.defineMessages)({
    // ── Header ──────────────────────────────────────────────────────────────
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    createHeading: {
        id: "malleable-ui-components.remix.create-heading",
        defaultMessage: "Create"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "View this content in a new form"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge.updated",
        defaultMessage: "Labs"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    // ── Describe input ─────────────────────────────────────────────────────
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    createDescribePlaceholder: {
        id: "malleable-ui-components.remix.create-describe-placeholder",
        defaultMessage: "Or create something else\u2026"
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    // ── Top-level option labels ────────────────────────────────────────────
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Charts"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagrams"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographics"
    },
    remixOptionVisualization: {
        id: "malleable-ui-components.remix.option.visualization",
        defaultMessage: "Visualizations"
    },
    // ── Top-level option icon alts ─────────────────────────────────────────
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualizationIconAlt: {
        id: "malleable-ui-components.remix.option.visualization-icon-alt",
        defaultMessage: "Visualization icon"
    },
    // ── Top-level option tooltips ──────────────────────────────────────────
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualizationTooltip: {
        id: "malleable-ui-components.remix.option.visualization-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    // ── Sub-type labels (charts) ───────────────────────────────────────────
    subTypeLineChart: {
        id: "malleable-ui-components.remix.sub-type.line-chart",
        defaultMessage: "Line chart"
    },
    subTypeAreaChart: {
        id: "malleable-ui-components.remix.sub-type.area-chart",
        defaultMessage: "Area chart"
    },
    subTypeBarChart: {
        id: "malleable-ui-components.remix.sub-type.bar-chart",
        defaultMessage: "Bar chart"
    },
    subTypeFunnelChart: {
        id: "malleable-ui-components.remix.sub-type.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    subTypePieChart: {
        id: "malleable-ui-components.remix.sub-type.pie-chart",
        defaultMessage: "Pie chart"
    },
    subTypeGanttChart: {
        id: "malleable-ui-components.remix.sub-type.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    // ── Sub-type labels (diagrams) ─────────────────────────────────────────
    subTypeMindMap: {
        id: "malleable-ui-components.remix.sub-type.mind-map",
        defaultMessage: "Mindmap"
    },
    subTypeFlowChart: {
        id: "malleable-ui-components.remix.sub-type.flow-chart",
        defaultMessage: "Flowchart"
    },
    // ── Sub-type labels (infographics) ─────────────────────────────────────
    subTypeModernStyle: {
        id: "malleable-ui-components.remix.sub-type.modern-style",
        defaultMessage: "Modern style"
    },
    subTypeBoldStyle: {
        id: "malleable-ui-components.remix.sub-type.bold-style",
        defaultMessage: "Bold style"
    },
    subTypeSketchStyle: {
        id: "malleable-ui-components.remix.sub-type.sketch-style",
        defaultMessage: "Sketch style"
    },
    subTypeMinimalistStyle: {
        id: "malleable-ui-components.remix.sub-type.minimalist-style",
        defaultMessage: "Minimalist style"
    },
    // ── Sub-type labels (visual aids) ──────────────────────────────────────
    subTypeFlipCard: {
        id: "malleable-ui-components.remix.sub-type.flip-card",
        defaultMessage: "Flip card"
    },
    subTypeQuadrant: {
        id: "malleable-ui-components.remix.sub-type.quadrant",
        defaultMessage: "Quadrant"
    },
    subTypeTreeMap: {
        id: "malleable-ui-components.remix.sub-type.tree-map",
        defaultMessage: "Tree map"
    },
    subTypeTimeline: {
        id: "malleable-ui-components.remix.sub-type.timeline",
        defaultMessage: "Timeline"
    },
    subTypeGeographicalMap: {
        id: "malleable-ui-components.remix.sub-type.geographical-map",
        defaultMessage: "Geographical map"
    },
    subTypeOrgChart: {
        id: "malleable-ui-components.remix.sub-type.org-chart",
        defaultMessage: "Org chart"
    },
    subTypeImage: {
        id: "malleable-ui-components.remix.sub-type.image",
        defaultMessage: "Image"
    },
    pageRemixSubtitle: {
        id: "malleable-ui-components.remix.page-remix-subtitle",
        defaultMessage: "Create content inspired by this work"
    },
    remixOptionSlides: {
        id: "malleable-ui-components.remix.option.slides",
        defaultMessage: "Slides"
    },
    remixOptionWhiteboard: {
        id: "malleable-ui-components.remix.option.whiteboard",
        defaultMessage: "Whiteboard"
    },
    remixOptionDatabase: {
        id: "malleable-ui-components.remix.option.database",
        defaultMessage: "Database"
    },
    slidesIconAlt: {
        id: "malleable-ui-components.remix.option.slides-icon-alt",
        defaultMessage: "Slides icon"
    },
    whiteboardIconAlt: {
        id: "malleable-ui-components.remix.option.whiteboard-icon-alt",
        defaultMessage: "Whiteboard icon"
    },
    databaseIconAlt: {
        id: "malleable-ui-components.remix.option.database-icon-alt",
        defaultMessage: "Database icon"
    },
    slidesTooltip: {
        id: "malleable-ui-components.remix.option.slides-tooltip",
        defaultMessage: "Transform your page into a slide deck"
    },
    whiteboardTooltip: {
        id: "malleable-ui-components.remix.option.whiteboard-tooltip",
        defaultMessage: "Visualize your page on a whiteboard"
    },
    databaseTooltip: {
        id: "malleable-ui-components.remix.option.database-tooltip",
        defaultMessage: "Structure your page content as a database"
    },
    // ── Pick for me ────────────────────────────────────────────────────────
    pickForMe: {
        id: "malleable-ui-components.remix.pick-for-me",
        defaultMessage: "Pick for me"
    },
    pickForMeTooltip: {
        id: "malleable-ui-components.remix.remix-overlay.pickForMeTooltip",
        defaultMessage: "Pick {remixType, select, infographic {an infographic} diagram {a diagram} chart {a chart} visualization {a visualization} other {a remix}} for me"
    },
    // ── Unused legacy keys kept for i18n backwards compat ──────────────────
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    }
});
var $b0a9658e5a4289f5$export$2e2bcd8739ae039 = $b0a9658e5a4289f5$var$messages;
module.exports["default"] = $b0a9658e5a4289f5$export$2e2bcd8739ae039;

});

parcelRegister("1LRKz", function(module, exports) {
/* constants.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $jdqQM = parcelRequire("jdqQM");


var $a3xS2 = parcelRequire("a3xS2");


var $1qKb1 = parcelRequire("1qKb1");


var $dZaRy = parcelRequire("dZaRy");


var $i6pum = parcelRequire("i6pum");


var $hT2Mn = parcelRequire("hT2Mn");


var $7vmkU = parcelRequire("7vmkU");


var $7K13i = parcelRequire("7K13i");


var $b5QJc = parcelRequire("b5QJc");


var $5QH2j = parcelRequire("5QH2j");


var $g8eHJ = parcelRequire("g8eHJ");


var $aoAJG = parcelRequire("aoAJG");


var $6A6ao = parcelRequire("6A6ao");


var $gg5rm = parcelRequire("gg5rm");


var $av9Cl = parcelRequire("av9Cl");


var $kuWlT = parcelRequire("kuWlT");


var $7mMw3 = parcelRequire("7mMw3");


var $gP7CA = parcelRequire("gP7CA");


var $l0Xml = parcelRequire("l0Xml");


var $h7GLM = parcelRequire("h7GLM");


var $lE1xe = parcelRequire("lE1xe");


var $4VjKY = parcelRequire("4VjKY");


var $7ZPjf = parcelRequire("7ZPjf");


var $5nwSN = parcelRequire("5nwSN");


var $jDDGi = parcelRequire("jDDGi");


var $h4zH8 = parcelRequire("h4zH8");


var $5udvx = parcelRequire("5udvx");


var $glBZK = parcelRequire("glBZK");


var $eCw66 = parcelRequire("eCw66");


var $g5RPh = parcelRequire("g5RPh");


var $iAb2S = parcelRequire("iAb2S");


var $9oYVI = parcelRequire("9oYVI");


var $l1bw1 = parcelRequire("l1bw1");


var $3Mo2w = parcelRequire("3Mo2w");


var $aBRLd = parcelRequire("aBRLd");


var $gpmJ3 = parcelRequire("gpmJ3");


var $aIlia = parcelRequire("aIlia");


var $9WcaJ = parcelRequire("9WcaJ");


var $iGdgz = parcelRequire("iGdgz");


var $8IXk3 = parcelRequire("8IXk3");

const $1624994978f78343$var$iconStyles = null; // Negative margins to counteract the default padding from the Pressable tile component,
// allowing the image icon to extend edge-to-edge within the tile.
const $1624994978f78343$var$edgeToEdgeIconStyles = null;
const $1624994978f78343$var$SubTypeIcon = ({ src: src, srcDark: srcDark, alt: alt })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const resolvedSrc = colorMode === 'dark' ? srcDark : src;
    return /*#__PURE__*/ $cozmU.createElement("img", {
        src: resolvedSrc,
        alt: alt,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d _00EA0eiObl _3iDTPbvLZJ"
        ])
    });
};
const $1624994978f78343$export$e0452922cbc2989f = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j))),
        alt: alt
    });
const $1624994978f78343$export$b08434c95e3df48d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM))),
        alt: alt
    });
const $1624994978f78343$export$472946dc5493045a = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2))),
        alt: alt
    });
const $1624994978f78343$export$ccba00b0f4d667f3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn))),
        alt: alt
    });
const $1624994978f78343$export$b86b18d4ddcc0181 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl))),
        alt: alt
    });
const $1624994978f78343$export$a95ef668d7975f40 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU))),
        alt: alt
    });
const $1624994978f78343$export$4f7cb0192e7b1016 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ))),
        alt: alt
    });
const $1624994978f78343$export$2df60ac16db5f072 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum))),
        alt: alt
    });
const $1624994978f78343$export$77864082aab0bbe3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao))),
        alt: alt
    });
const $1624994978f78343$export$6fa49d5d85aab725 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1))),
        alt: alt
    });
const $1624994978f78343$export$b8c6412fcf2fe65d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9WcaJ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gP7CA))),
        alt: alt
    });
const $1624994978f78343$export$73f1bfda08325f1c = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3))),
        alt: alt
    });
const $1624994978f78343$export$1968847f71768cdf = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG))),
        alt: alt
    });
const $1624994978f78343$var$CorporateDoodleIcon = (props)=>(0, $iDrrr.fg)('cc-maui-phase-2') ? /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$73f1bfda08325f1c, props) : /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$b8c6412fcf2fe65d, props);
const $1624994978f78343$export$c02ff6805d67acb2 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy))),
        alt: alt
    });
const $1624994978f78343$export$368b8c86d4677a50 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT))),
        alt: alt
    });
const $1624994978f78343$export$23e94ddbc9d88fae = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM))),
        alt: alt
    });
const $1624994978f78343$export$e5aa73ddcf9d62e8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml))),
        alt: alt
    });
const $1624994978f78343$export$a18ea9af6c181602 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i))),
        alt: alt
    });
const $1624994978f78343$export$84442c0324e009f8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm))),
        alt: alt
    });
const $1624994978f78343$var$ImageIcon = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_313842A17z _0adFHsmW1D _1DCdHiA17z _2XsHFMmW1D"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc))),
        alt: alt
    }));
const $1624994978f78343$export$65d7e4b11d55029 = {
    // Charts
    'line-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j)))
    },
    'area-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM)))
    },
    'bar-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2)))
    },
    'funnel-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn)))
    },
    'pie-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl)))
    },
    'gantt-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU)))
    },
    // Diagrams
    mindmap: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ)))
    },
    flowchart: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum)))
    },
    // Infographics
    'corporate-modern': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao)))
    },
    'corporate-doodle': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3)))
    },
    charlie: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1)))
    },
    minimalist: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG)))
    },
    // Visual aids
    'flip-card': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy)))
    },
    quadrant: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT)))
    },
    'tree-map': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM)))
    },
    'horizontal-timeline': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml)))
    },
    map: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i)))
    },
    'org-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm)))
    },
    image: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc)))
    }
};
const $1624994978f78343$export$ebd45e32b7708bfa = {
    // Charts
    'line-chart': $1624994978f78343$export$e0452922cbc2989f,
    'area-chart': $1624994978f78343$export$b08434c95e3df48d,
    'bar-chart': $1624994978f78343$export$472946dc5493045a,
    'funnel-chart': $1624994978f78343$export$ccba00b0f4d667f3,
    'pie-chart': $1624994978f78343$export$b86b18d4ddcc0181,
    'gantt-chart': $1624994978f78343$export$a95ef668d7975f40,
    // Diagrams
    mindmap: $1624994978f78343$export$4f7cb0192e7b1016,
    flowchart: $1624994978f78343$export$2df60ac16db5f072,
    // Infographics
    'corporate-modern': $1624994978f78343$export$77864082aab0bbe3,
    'corporate-doodle': $1624994978f78343$var$CorporateDoodleIcon,
    charlie: $1624994978f78343$export$6fa49d5d85aab725,
    minimalist: $1624994978f78343$export$1968847f71768cdf,
    // Visual aids
    'flip-card': $1624994978f78343$export$c02ff6805d67acb2,
    quadrant: $1624994978f78343$export$368b8c86d4677a50,
    'tree-map': $1624994978f78343$export$23e94ddbc9d88fae,
    'horizontal-timeline': $1624994978f78343$export$e5aa73ddcf9d62e8,
    map: $1624994978f78343$export$a18ea9af6c181602,
    'org-chart': $1624994978f78343$export$84442c0324e009f8,
    image: $1624994978f78343$var$ImageIcon
};
module.exports["SUB_TYPE_ICON_URLS"] = $1624994978f78343$export$65d7e4b11d55029;
module.exports["SUB_TYPE_ICON_MAP"] = $1624994978f78343$export$ebd45e32b7708bfa;

});

parcelRegister("jdqQM", function(module, exports) {
module.exports = new URL("area-chart.55f6e465.svg", import.meta.url).toString();

});

parcelRegister("a3xS2", function(module, exports) {
module.exports = new URL("bar-chart.fd78c047.svg", import.meta.url).toString();

});

parcelRegister("1qKb1", function(module, exports) {
module.exports = new URL("bold.2cc98dbc.svg", import.meta.url).toString();

});

parcelRegister("dZaRy", function(module, exports) {
module.exports = new URL("flip-cards.5ca8ff0a.svg", import.meta.url).toString();

});

parcelRegister("i6pum", function(module, exports) {
module.exports = new URL("flowchart.be00d296.svg", import.meta.url).toString();

});

parcelRegister("hT2Mn", function(module, exports) {
module.exports = new URL("funnel-chart.c5c5ee8c.svg", import.meta.url).toString();

});

parcelRegister("7vmkU", function(module, exports) {
module.exports = new URL("gantt-chart.a8acacb3.svg", import.meta.url).toString();

});

parcelRegister("7K13i", function(module, exports) {
module.exports = new URL("geographical-map.8aed36b5.svg", import.meta.url).toString();

});

parcelRegister("b5QJc", function(module, exports) {
module.exports = new URL("image-option-dark.4ef2b9c9.png", import.meta.url).toString();

});

parcelRegister("5QH2j", function(module, exports) {
module.exports = new URL("line-chart.170f1aac.svg", import.meta.url).toString();

});

parcelRegister("g8eHJ", function(module, exports) {
module.exports = new URL("mindmap.3d2ae695.svg", import.meta.url).toString();

});

parcelRegister("aoAJG", function(module, exports) {
module.exports = new URL("minimalist.5f043ef2.svg", import.meta.url).toString();

});

parcelRegister("6A6ao", function(module, exports) {
module.exports = new URL("modern.b9c52e72.svg", import.meta.url).toString();

});

parcelRegister("gg5rm", function(module, exports) {
module.exports = new URL("org-chart.4294f091.svg", import.meta.url).toString();

});

parcelRegister("av9Cl", function(module, exports) {
module.exports = new URL("pie-chart.51f3bebf.svg", import.meta.url).toString();

});

parcelRegister("kuWlT", function(module, exports) {
module.exports = new URL("quadrant.199f7d1e.svg", import.meta.url).toString();

});

parcelRegister("7mMw3", function(module, exports) {
module.exports = new URL("sketch-v2.a013bb92.svg", import.meta.url).toString();

});

parcelRegister("gP7CA", function(module, exports) {
module.exports = new URL("sketch.450eefc9.svg", import.meta.url).toString();

});

parcelRegister("l0Xml", function(module, exports) {
module.exports = new URL("timeline.6ae6674b.svg", import.meta.url).toString();

});

parcelRegister("h7GLM", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("lE1xe", function(module, exports) {
module.exports = new URL("area-chart.5c4ca07f.svg", import.meta.url).toString();

});

parcelRegister("4VjKY", function(module, exports) {
module.exports = new URL("bar-chart.958c9357.svg", import.meta.url).toString();

});

parcelRegister("7ZPjf", function(module, exports) {
module.exports = new URL("bold.1787aad2.svg", import.meta.url).toString();

});

parcelRegister("5nwSN", function(module, exports) {
module.exports = new URL("flip-cards.429027cc.svg", import.meta.url).toString();

});

parcelRegister("jDDGi", function(module, exports) {
module.exports = new URL("flowchart.77339b70.svg", import.meta.url).toString();

});

parcelRegister("h4zH8", function(module, exports) {
module.exports = new URL("funnel-chart.12ecbc63.svg", import.meta.url).toString();

});

parcelRegister("5udvx", function(module, exports) {
module.exports = new URL("gantt-chart.1c11810d.svg", import.meta.url).toString();

});

parcelRegister("glBZK", function(module, exports) {
module.exports = new URL("geographical-map.ac5f4483.svg", import.meta.url).toString();

});

parcelRegister("eCw66", function(module, exports) {
module.exports = new URL("image-option.51f3f511.png", import.meta.url).toString();

});

parcelRegister("g5RPh", function(module, exports) {
module.exports = new URL("line-chart.57ecd877.svg", import.meta.url).toString();

});

parcelRegister("iAb2S", function(module, exports) {
module.exports = new URL("mindmap.d452b507.svg", import.meta.url).toString();

});

parcelRegister("9oYVI", function(module, exports) {
module.exports = new URL("minimalist.cbf91eb3.svg", import.meta.url).toString();

});

parcelRegister("l1bw1", function(module, exports) {
module.exports = new URL("modern.4ca836a7.svg", import.meta.url).toString();

});

parcelRegister("3Mo2w", function(module, exports) {
module.exports = new URL("org-chart.694f44ab.svg", import.meta.url).toString();

});

parcelRegister("aBRLd", function(module, exports) {
module.exports = new URL("pie-chart.0477082d.svg", import.meta.url).toString();

});

parcelRegister("gpmJ3", function(module, exports) {
module.exports = new URL("quadrant.5175de07.svg", import.meta.url).toString();

});

parcelRegister("aIlia", function(module, exports) {
module.exports = new URL("sketch-v2.79c71454.svg", import.meta.url).toString();

});

parcelRegister("9WcaJ", function(module, exports) {
module.exports = new URL("sketch.35e2121b.svg", import.meta.url).toString();

});

parcelRegister("iGdgz", function(module, exports) {
module.exports = new URL("timeline.3d28aa4e.svg", import.meta.url).toString();

});

parcelRegister("8IXk3", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("koQIB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $4nIKB = parcelRequire("4nIKB");


var $ivGQ2 = parcelRequire("ivGQ2");


var $cXtTj = parcelRequire("cXtTj");


var $bltJZ = parcelRequire("bltJZ");


var $fk0Hw = parcelRequire("fk0Hw");


var $iDrrr = parcelRequire("iDrrr");


var $dTEBe = parcelRequire("dTEBe");


var $9Zall = parcelRequire("9Zall");


var $8jXZv = parcelRequire("8jXZv");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1shFr = parcelRequire("1shFr");


var $k9mk2 = parcelRequire("k9mk2");


var $lfMWT = parcelRequire("lfMWT");


var $koH7z = parcelRequire("koH7z");


var $jdw9n = parcelRequire("jdw9n");


var $bY61u = parcelRequire("bY61u");


var $j0DuU = parcelRequire("j0DuU");


var $dY6UE = parcelRequire("dY6UE");


var $eS3l0 = parcelRequire("eS3l0");


var $c1KVP = parcelRequire("c1KVP");

const $ef750f68c6472b35$var$defaultButtonStyles = {
    paddingInline: "var(--ds-space-100, 8px)"
};
const $ef750f68c6472b35$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #0515240F)"
};
const $ef750f68c6472b35$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #0515240F)",
    color: "var(--ds-text-disabled, #080F214A)"
};
const $ef750f68c6472b35$var$conversationAssistantButtonWrapperNoOverlayStyles = null;
const $ef750f68c6472b35$var$topNavButtonFlareKeyframes = null;
const $ef750f68c6472b35$var$topNavButtonFlareAnimationStyles = null;
const $ef750f68c6472b35$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $ef750f68c6472b35$var$pulseKeyframes = null;
const $ef750f68c6472b35$var$pulseAnimationStyles = null;
const $ef750f68c6472b35$var$reduceMotionStyles = null;
const $ef750f68c6472b35$var$getAtlasChatUrl = (siteId, orgId)=>{
    const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
    return (0, $dTEBe.addRovoParamsToUrl)(`${(0, $eS3l0.getDefaultShareBaseUrl)()}${orgPath}/chat?cloudId=${encodeURIComponent(siteId)}`, {
        cloudId: siteId,
        pathway: 'chat'
    });
}; /**
    * Wraps button in a div that plays the top-nav flare animation.
    */ 
const $ef750f68c6472b35$var$AnimatedFlareWrapper = ({ productKey: productKey, children: children })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'animation',
            actionSubjectId: 'conversationAssistantButtonFlareAnimation',
            attributes: {
                productKey: productKey
            }
        });
    }, [
        sendAnalyticsEvent,
        productKey
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "animated-flare-wrapper",
        className: (0, $hekY6.default)([
            "_0ubfYRlfZc _0RxVZVy7kJ _46PhP8f7mX _0rushMd1Zr _0jh4YZy7kJ",
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbccYA _1uo2Zfx2jY _1mT5xdRAKS _4eDJc6kO4Y _3fRV4C0oWv _1iAcE9M9iZ _0YTlbl7dHp _2ofBtgjkka _2Il32FxxUt _3Ku51Iogpp _4odxdyN91d _1cR5ZLLUVw _2jTvwtdnbC _2IjmTKdnbC _0UsFEzYbGa _3dCYwDWVPG _3qT6l0dnbC _0ubfYRjOvk _0rushMjOvk _4BbId5YbGa _4bHSExdnbC"
        ])
    }, children);
};
const $ef750f68c6472b35$var$getConversationAssistantButton = (Button = (0, $ivGQ2.PrimaryButton))=>/*#__PURE__*/ (0, $cozmU.forwardRef)(({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, onMouseEnter: onMouseEnterProp, label: label, tooltipContent: tooltipContent, shortcut: shortcut, orgId: orgId, siteId: siteId, productKey: productKey, enableOnboardingSpotlight: enableOnboardingSpotlight = false }, ref)=>{
        (0, $6cFsl.di)((0, $cXtTj.default), (0, $bY61u.useInsightsStatus));
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const { start: start } = (0, $k9mk2.useConversationAssistantSpotlightActions)();
        const { PostOfficePlacement: PostOfficePlacement } = (0, $jdw9n.usePostOfficePlacement)(); // Prefetch insights status to warm the cache before the user opens chat.
        // This triggers the backend to generate insights asynchronously if not already cached.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
        (0, $bY61u.useInsightsStatus)({
            enabled: isPulseExperimentEnabled,
            assistanceServiceParams: {
                touchpointSource: 'ask-rovo-button-prefetch',
                product: productKey,
                experienceId: 'ai-mate',
                siteId: siteId
            }
        });
        const [prefersReducedMotion] = (0, $cozmU.useState)(()=>typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true);
        const [shouldShowMessage, setShouldShowMessage] = (0, $cozmU.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = enableOnboardingSpotlight && !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)(); // Capture initial prop values in a ref so the rendered event fires exactly once
        // on mount, even if reactive props like isActive/isDisabled change later.
        const renderedAttributesRef = (0, $cozmU.useRef)({
            isActive: isActive,
            isDisabled: isDisabled,
            productKey: productKey
        });
        const sendAnalyticsEventRef = (0, $cozmU.useRef)(sendAnalyticsEvent);
        sendAnalyticsEventRef.current = sendAnalyticsEvent;
        (0, $cozmU.useEffect)(()=>{
            sendAnalyticsEventRef.current({
                eventType: 'operational',
                action: 'rendered',
                actionSubject: 'rovoChatButton',
                attributes: renderedAttributesRef.current
            }); // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $cozmU.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const buttonLabel = label ?? formatMessage((0, $c1KVP.messages).rovoChatButtonLabel);
        const getChildren = ()=>{
            const button = /*#__PURE__*/ $cozmU.createElement(Button, {
                "data-spotlight-target": "rovo-chat-ask-rovo-button",
                onMouseEnter: (event)=>{
                    onMouseEnterProp?.(event);
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'hovered',
                        actionSubject: 'rovoChatButton',
                        attributes: {
                            isActive: isActive,
                            isDisabled: isDisabled,
                            productKey: productKey
                        }
                    });
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, formatMessage((0, $c1KVP.messages).rovoChatButtonLabel)),
                shortcut: shortcut,
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$ef750f68c6472b35$var$defaultButtonStyles,
                    ...!isActive && $ef750f68c6472b35$var$inactiveButtonStyles,
                    ...isDisabled && $ef750f68c6472b35$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
                    size: "xxsmall"
                }),
                interactionName: interactionName,
                ref: ref
            }, buttonLabel);
            if (Button === (0, $ivGQ2.PrimaryButton)) return /*#__PURE__*/ $cozmU.createElement("div", {
                role: "list"
            }, button);
            if (!isActive && !isDisabled) {
                const shouldAnimateTopNavButton = !prefersReducedMotion && // Targets non-MAU Rovo Chat users — once a user becomes MAU, the gate
                // resolves to false on their next session (batch trait refreshes daily).
                (0, $iDrrr.fg)('rovo_chat_non_mau_rovo_button_animation_filter') && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
                (0, $cXtTj.default).getExperimentValue('ask_rovo_top_nav_button_animation', 'isEnabled', false);
                if (shouldAnimateTopNavButton) return /*#__PURE__*/ $cozmU.createElement($ef750f68c6472b35$var$AnimatedFlareWrapper, {
                    productKey: productKey
                }, button);
                return /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        "_0ubfYRlfZc _0RxVZVy7kJ _46PhP8f7mX _0rushMd1Zr _0jh4YZy7kJ"
                    ])
                }, button);
            }
            return button;
        }; // The long-running-task PostOffice placement is anchored to the Ask Rovo
        // button (via data-spotlight-target) and must mount for every product
        // including Townsquare (productKey="atlas"), so it lives outside
        // SpotlightWrapper which only renders for products that opt into the
        // agents-onboarding coordination flow.
        // Uses <Fragment> (not <>) because this file has @jsx pragma without @jsxFrag.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isFullPageSpotlightEnabled = productKey === 'jira' && (0, $cXtTj.default).getExperimentValue('rovo_chat_full_page_chat_spotlight', 'isEnabled', false);
        return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, shouldUseCoordination || isFullPageSpotlightEnabled ? /*#__PURE__*/ $cozmU.createElement($ef750f68c6472b35$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            orgId: orgId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: (event, analyticsEvent)=>openRovoChat(event, analyticsEvent),
            isFullPageSpotlightEnabled: isFullPageSpotlightEnabled
        }) : getChildren(), PostOfficePlacement && (0, $iDrrr.fg)('rovo_chat_long_running_task_spotlight') && /*#__PURE__*/ $cozmU.createElement(PostOfficePlacement, {
            placementId: "rovo-chat-long-running-task-spotlight",
            // when React replays renders during Suspense retries.
            disableInitialData: true
        }));
    });
const $ef750f68c6472b35$var$Nav4Button = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ tooltip: tooltip, shortcut: shortcut, ...props }, forwardedRef)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: tooltip,
        shortcut: shortcut,
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true
    }, ({ ref: tooltipRef, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
            interactionName: props?.interactionName,
            ref: (0, $4nIKB.mergeRefs)([
                forwardedRef,
                tooltipRef
            ]),
            ...triggerProps,
            ...props,
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps.onClick?.(event);
            },
            iconBefore: ()=>props.iconBefore || null
        }));
});
const $ef750f68c6472b35$export$7c328c0993982813 = $ef750f68c6472b35$var$getConversationAssistantButton((0, $ivGQ2.PrimaryButton));
const $ef750f68c6472b35$export$25e85d244cbf7845 = $ef750f68c6472b35$var$getConversationAssistantButton($ef750f68c6472b35$var$Nav4Button);
const $ef750f68c6472b35$export$de76c194bfb85689 = ({ children: children, messageId: messageId, orgId: orgId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat, isFullPageSpotlightEnabled: isFullPageSpotlightEnabled = false })=>{
    (0, $6cFsl.di)((0, $1shFr.usePostOfficeCoordination));
    const { activeSpotlight: activeSpotlight } = (0, $k9mk2.useConversationAssistantSpotlightState)();
    const [onboardingStarted, stopOnboarding] = (0, $1shFr.usePostOfficeCoordination)(messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    const openFullPageRovoChat = (0, $cozmU.useCallback)(()=>{
        window.location.assign($ef750f68c6472b35$var$getAtlasChatUrl(siteId, orgId));
    }, [
        orgId,
        siteId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]); // Mutually exclusive with the onboarding spotlight — don't show both at once
    const shouldShowFullPageSpotlight = isFullPageSpotlightEnabled && !shouldShowMessage;
    return /*#__PURE__*/ $cozmU.createElement((0, $dY6UE.ConditionalWrapper), {
        condition: shouldShowMessage || shouldShowFullPageSpotlight,
        wrapper: (children)=>/*#__PURE__*/ $cozmU.createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    shouldShowMessage && activeSpotlight === null && "",
                    shouldShowMessage && activeSpotlight === null && "_0bjKvDKxmn _0nFVCGM9iZ _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
                    "_39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, children, shouldShowFullPageSpotlight && /*#__PURE__*/ $cozmU.createElement((0, $j0DuU.ChunkErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ $cozmU.createElement((0, $lfMWT.AsyncRovoFullPageSpotlightPlacement), {
                openRovoChat: openFullPageRovoChat
            }))))), /*#__PURE__*/ $cozmU.createElement((0, $koH7z.ConversationAssistantOnboardingSpotlight), {
                onDismiss: onDismissMessage,
                openRovoChat: openRovoChat
            }))
    }, children);
};
module.exports["ConversationAssistantButtonNav4"] = $ef750f68c6472b35$export$25e85d244cbf7845;

});

parcelRegister("ivGQ2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $1sXWi = parcelRequire("1sXWi");


var $6Wkr7 = parcelRequire("6Wkr7");

function $451908e5ab05faa3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $451908e5ab05faa3$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $451908e5ab05faa3$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $451908e5ab05faa3$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $451908e5ab05faa3$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $451908e5ab05faa3$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $451908e5ab05faa3$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $1sXWi.useTheme)();
    const button = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            [$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $451908e5ab05faa3$var$buttonBaseStyles,
            isHighlighted && $451908e5ab05faa3$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $6Wkr7.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $451908e5ab05faa3$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});
module.exports["PrimaryButton"] = $451908e5ab05faa3$export$ac16a6a04d9b7c84;

});

parcelRegister("6Wkr7", function(module, exports) {
const $5e6dc6455211c33f$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getPrimaryButtonTheme"] = $5e6dc6455211c33f$export$14dd6915caf431fe;

});

parcelRegister("1shFr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6m3nS = parcelRequire("6m3nS");

const $702fb6d2795d3598$export$a890021247f253fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(14);
    const { isActive: poIsActive } = (0, $6m3nS.useTrigger)(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: poRequestMessageStart } = (0, $6m3nS.useFirePostOfficeTrigger)(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: poFireDismissClick } = (0, $6m3nS.useFirePostOfficeTrigger)(t3);
    let t4;
    if ($[4] !== poRequestMessageStart) {
        t4 = ()=>{
            poRequestMessageStart({
                isActive: true
            });
        };
        $[4] = poRequestMessageStart;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== messageId || $[7] !== poRequestMessageStart) {
        t5 = [
            messageId,
            poRequestMessageStart
        ];
        $[6] = messageId;
        $[7] = poRequestMessageStart;
        $[8] = t5;
    } else t5 = $[8];
    (0, $cozmU.useEffect)(t4, t5);
    const started = poIsActive;
    let t6;
    if ($[9] !== poFireDismissClick) {
        t6 = (force)=>{
            poFireDismissClick({
                isActive: true
            });
        };
        $[9] = poFireDismissClick;
        $[10] = t6;
    } else t6 = $[10];
    const stop = t6;
    let t7;
    if ($[11] !== started || $[12] !== stop) {
        t7 = [
            started,
            stop
        ];
        $[11] = started;
        $[12] = stop;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : (messageId)=>{
    const { isActive: poIsActive } = (0, $6m3nS.useTrigger)(`${messageId}-started`);
    const { fireTrigger: poRequestMessageStart } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: poFireDismissClick } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-dismiss`
    });
    (0, $cozmU.useEffect)(()=>{
        poRequestMessageStart({
            isActive: true
        });
    }, [
        messageId,
        poRequestMessageStart
    ]);
    const started = poIsActive;
    const stop = (force)=>{
        poFireDismissClick({
            isActive: true
        });
    };
    return [
        started,
        stop
    ];
};
module.exports["usePostOfficeCoordination"] = $702fb6d2795d3598$export$a890021247f253fb;

});

parcelRegister("k9mk2", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $a103c65beb9e285f$var$initialState = {
    activeSpotlight: null
};
const $a103c65beb9e285f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $a103c65beb9e285f$var$ConversationAssistantSpotlightStore = (0, $8s9DV.createStore)({
    initialState: $a103c65beb9e285f$var$initialState,
    actions: $a103c65beb9e285f$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $a103c65beb9e285f$export$283f4929c8863814 = (0, $kBr4q.createActionsHook)($a103c65beb9e285f$var$ConversationAssistantSpotlightStore);
const $a103c65beb9e285f$export$258c2a6b93cdef4a = (0, $kBr4q.createStateHook)($a103c65beb9e285f$var$ConversationAssistantSpotlightStore);
module.exports["useConversationAssistantSpotlightActions"] = $a103c65beb9e285f$export$283f4929c8863814;
module.exports["useConversationAssistantSpotlightState"] = $a103c65beb9e285f$export$258c2a6b93cdef4a;

});

parcelRegister("lfMWT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $c7538dea34e781c7$export$2a0e9ab75aa119a4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("fWK9T")).then(({ RovoFullPageSpotlightPlacement: RovoFullPageSpotlightPlacement })=>({
            default: RovoFullPageSpotlightPlacement
        })));
$c7538dea34e781c7$export$2a0e9ab75aa119a4.displayName = 'AsyncRovoFullPageSpotlightPlacement';
module.exports["AsyncRovoFullPageSpotlightPlacement"] = $c7538dea34e781c7$export$2a0e9ab75aa119a4;

});

parcelRegister("fWK9T", function(module, exports) {

let $b9c013e752e55181$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9c013e752e55181$var$load("5F5lS"),
    $b9c013e752e55181$var$load("4qksR"),
    $b9c013e752e55181$var$load("7VzZT"),
    $b9c013e752e55181$var$load("2uWWQ")
]).then(()=>parcelRequire('eH7fb'));

});

parcelRegister("koH7z", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $3eYzF = parcelRequire("3eYzF");


var $uyMbP = parcelRequire("uyMbP");


var $gi4qj = parcelRequire("gi4qj");


var $4AC39 = parcelRequire("4AC39");


var $l3ydK = parcelRequire("l3ydK");


var $2Vz7H = parcelRequire("2Vz7H");


var $6VFk2 = parcelRequire("6VFk2");


var $4enp7 = parcelRequire("4enp7");


var $dOlTT = parcelRequire("dOlTT");


var $2K2hA = parcelRequire("2K2hA");


var $6Yblc = parcelRequire("6Yblc");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $k9mk2 = parcelRequire("k9mk2");


var $7s6Nk = parcelRequire("7s6Nk");

const $cde915fd77272962$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, onDismiss: onDismiss })=>{
    (0, $6cFsl.di)((0, $k9mk2.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { end: end } = (0, $k9mk2.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $k9mk2.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleTryChat = (event, analyticsEvent)=>{
        if (openRovoChat) openRovoChat(event, analyticsEvent);
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            // this is more of 'chatButtonClicked'
            action: 'dismissed',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    const handleDismiss = ()=>{
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissButtonClicked',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, activeSpotlight !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleDismiss,
        isVisible: activeSpotlight !== null,
        placement: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $7s6Nk.default).onboardingHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: handleDismiss
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage((0, $7s6Nk.default).onboardingDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
        onClick: handleDismiss
    }, formatMessage((0, $7s6Nk.default).dismissOnboarding)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: handleTryChat
    }, formatMessage((0, $7s6Nk.default).tryChat)))))));
};
module.exports["ConversationAssistantOnboardingSpotlight"] = $cde915fd77272962$export$e4abc8af2fc5e2ac;

});

parcelRegister("7s6Nk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7fbfde14cac529b1$var$_default_1 = (0, $kSwu1.defineMessages)({
    tryChat: {
        id: "rovo-onboarding-try-chat",
        defaultMessage: "Try Max"
    },
    dismissOnboarding: {
        id: "rovo-onboarding-dismiss",
        defaultMessage: "Dismiss"
    },
    onboardingHeading: {
        id: "rovo-onboarding-heading",
        defaultMessage: "Say hi to Max"
    },
    onboardingDescription: {
        id: "rovo-onboarding-description",
        defaultMessage: "Max takes on complex, multi-step work and comes back with a finished result."
    }
});
var $7fbfde14cac529b1$export$2e2bcd8739ae039 = $7fbfde14cac529b1$var$_default_1;
module.exports["default"] = $7fbfde14cac529b1$export$2e2bcd8739ae039;

});

parcelRegister("j0DuU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $ef1db4b7df15ed66$export$63986981e4af5143 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        // Log chunk load failures so they are detectable in production
        // eslint-disable-next-line no-console
        console.error('[ChunkErrorBoundary] Failed to load async component chunk:', error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
module.exports["ChunkErrorBoundary"] = $ef1db4b7df15ed66$export$63986981e4af5143;

});

parcelRegister("dY6UE", function(module, exports) {
const $3072ddc93b66c1bf$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
module.exports["ConditionalWrapper"] = $3072ddc93b66c1bf$export$39aecc95f0365819;

});

parcelRegister("c1KVP", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3de6994784243a7f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    rovoChatButtonLabel: {
        id: "conversation-assistant-button.ask-rovo-label",
        defaultMessage: "Ask Rovo"
    }
});
module.exports["messages"] = $3de6994784243a7f$export$defe85febe8b728c;

});

parcelRegister("6cyWf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $350c8455dc4e7cf5$export$d158fa15757a1890 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $350c8455dc4e7cf5$export$abfcaeeca4ae7a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
} : function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
};
module.exports["HasCustomThemeContext"] = $350c8455dc4e7cf5$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $350c8455dc4e7cf5$export$abfcaeeca4ae7a55;

});

parcelRegister("aXMFs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $25b427f2364d8f29$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $25b427f2364d8f29$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $25b427f2364d8f29$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $iDrrr.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps));
};
var $25b427f2364d8f29$export$2e2bcd8739ae039 = $25b427f2364d8f29$var$IconRenderer;
module.exports["default"] = $25b427f2364d8f29$export$2e2bcd8739ae039;

});

parcelRegister("5dijw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $hVZgb = parcelRequire("hVZgb");

const $33036e997e9cb956$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDzXzM _23rrnHoacQ _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8",
    rootT26Shape: "_0bjKvDKTcp",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCjOvk _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $33036e997e9cb956$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
const $33036e997e9cb956$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $33036e997e9cb956$export$66240319f1f78d74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedPressable(t0, ref) {
    const $ = (0, $bDgLe.c)(20);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $hBYtq.Pressable);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    let t2;
    if ($[8] !== appearance || $[9] !== hasBorder || $[10] !== isDisabled || $[11] !== isSelected || $[12] !== shape) {
        t2 = (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $33036e997e9cb956$var$styles.rootT26Shape, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $iDrrr.fg)("platform-dst-motion-uplift-button") && $33036e997e9cb956$var$styles.interactiveMotion);
        $[8] = appearance;
        $[9] = hasBorder;
        $[10] = isDisabled;
        $[11] = isSelected;
        $[12] = shape;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== T0 || $[15] !== isDisabled || $[16] !== ref || $[17] !== t1 || $[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            type: "button",
            xcss: t2,
            isDisabled: isDisabled
        });
        $[14] = T0;
        $[15] = isDisabled;
        $[16] = ref;
        $[17] = t1;
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $33036e997e9cb956$var$styles.rootT26Shape, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && $33036e997e9cb956$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $33036e997e9cb956$export$66240319f1f78d74;

});

parcelRegister("hVZgb", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $c03f86859c8952b6$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $c03f86859c8952b6$export$e4c95325a21f9785;

});

parcelRegister("8GyO5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $crsgV = parcelRequire("crsgV");


var $b6QLO = parcelRequire("b6QLO");

function $1babe6d267af7ec0$export$d2a66369b43f5d65({ onClose: onClose, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, hideThinkingBar: hideThinkingBar = false, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, presentation: presentation = 'modal', trigger: trigger, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, popupRepositionKey: popupRepositionKey, showProgressBar: showProgressBar = false, isComplete: isComplete = false, isThinking: controlledIsThinking, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, autoSubmitUserPrompt: autoSubmitUserPrompt, onStopThinking: onStopThinking, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    // for editor, isThinking will be passed in, which is stored in editor state
    // When autoSubmitUserPrompt is set, initialise to true so the option-picker overlay is
    // never rendered on the first frame — the prompt is submitted immediately.
    const [localIsThinking, setLocalIsThinking] = (0, $cozmU.useState)(!!autoSubmitUserPrompt);
    const isThinking = controlledIsThinking ?? localIsThinking;
    const [selectedOptionType, setSelectedOptionType] = (0, $cozmU.useState)();
    // When autoSubmitUserPrompt is set and the flow is cancelled, prevent RemixOptionsOverlay
    // from flashing by tracking whether the flow has been stopped.
    const [isCancelledAutoSubmit, setIsCancelledAutoSubmit] = (0, $cozmU.useState)(false);
    const showThinkingBar = isThinking && !isEphemeralViewVisible && !hideThinkingBar;
    // The Remix option picker is visible to the user (menu open after a Remix click) when the
    // flow is not thinking and, in popup mode, the popup is open. This is the single convergence
    // point for all Remix entry points.
    const isRemixMenuOpen = (presentation !== 'popup' || !trigger || isPopupOpen) && !isThinking;
    // Multi-variant Remix menu experiment. Keep this as an exposure-producing check at the
    // single menu-open convergence point, but do not change behaviour yet. The variant branches
    // are placeholders for follow-up PRs that will plug in the inline dropdown and Rovo menu.
    (0, $cozmU.useEffect)(()=>{
        if (!isRemixMenuOpen) return;
        const remixMenuCohort = (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        if (remixMenuCohort === 'variant1') ;
        else remixMenuCohort;
        // Keep the existing A/A exposure logic unchanged.
        (0, $cha5E.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
    }, [
        isRemixMenuOpen
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)((params)=>{
        if (!skipThinkingTypes?.has(params.type)) setLocalIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) onStopThinking?.();
        setLocalIsThinking(false);
        if (autoSubmitUserPrompt) setIsCancelledAutoSubmit(true);
        // for insertion, when cancel, the logic is from ProseMirror, we'll show the modal again and
        // - we call onRemixFlowActiveChange in useEffect to cancel the request
        // but for update, when cancel, the logic is from UI, we have to call onRemixFlowActiveChange manually
        // - cause the component tree will be unmounted and the useEffect will not be called
        onRemixFlowActiveChange?.(false);
    }, [
        autoSubmitUserPrompt,
        onRemixFlowActiveChange,
        onStopThinking
    ]);
    // only when show the thinking bar, we handle the escape key to stop the thinking
    // when the thinking bar is rendered in editor, the escape will also be handled by editor
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            if (!showThinkingBar) return;
        } else {
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (!isThinking) return;
        }
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking,
        showThinkingBar
    ]);
    // In popup mode, the trigger must always be rendered so the popup can anchor to it.
    // The popup content visibility is controlled by isPopupOpen.
    if (presentation === 'popup' && trigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixPopup), {
        isOpen: isPopupOpen && !isThinking,
        onClose: onClose,
        trigger: trigger,
        placement: popupPlacement,
        offset: popupOffset,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle,
        repositionKey: popupRepositionKey
    }), showThinkingBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        onStop: handleStopThinking,
        optionType: selectedOptionType,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        contentType: contentType,
        isRemixEntrance: isRemixEntrance,
        shouldMeasureContentBounds: shouldMeasureContentBounds
    }));
    // Modal mode (default)
    // While thinking: show thinking bar only when ephemeral is not yet visible; otherwise show nothing
    if (isThinking) {
        if (!isEphemeralViewVisible && !hideThinkingBar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            onStop: handleStopThinking,
            optionType: selectedOptionType,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            contentType: contentType,
            isRemixEntrance: isRemixEntrance,
            shouldMeasureContentBounds: shouldMeasureContentBounds
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    }
    // Suppress the option-picker if the flow was auto-submitted (pre-supplied prompt)
    // and then cancelled — the caller handles reopening via onCancel callback.
    if (isCancelledAutoSubmit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $1babe6d267af7ec0$export$d2a66369b43f5d65;

});

parcelRegister("crsgV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $dTHYM = parcelRequire("dTHYM");


var $I7hWB = parcelRequire("I7hWB");


var $2Fmt9 = parcelRequire("2Fmt9");


var $f6cdQ = parcelRequire("f6cdQ");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $aRGok = parcelRequire("aRGok");


var $2LyZS = parcelRequire("2LyZS");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $ieeJu = parcelRequire("ieeJu");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $HvNsc = parcelRequire("HvNsc");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $loej8 = parcelRequire("loej8");

const $be6de585ac044839$var$headerOuterStyle = null;
const $be6de585ac044839$var$headerOuterMinimizedStyle = null;
const $be6de585ac044839$var$labsPositionStyle = null;
const $be6de585ac044839$var$headerIconWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperMinimizedStyle = null; // 92px = space.300 (24px top padding) + 64px icon + 4px gap
const $be6de585ac044839$var$headerHeadingStyle = null; // left: 16px (space.200) + 48px icon + 8px gap = 72px
// top: vertically centered with 48px icon — icon center is at 16px + 24px = 40px,
// heading line-height ~24px, so top = 40px - 12px = 28px
const $be6de585ac044839$var$headerHeadingMinimizedStyle = null; // 120px = 92px heading top + ~28px heading height
const $be6de585ac044839$var$headerSubtitleStyle = null; // Hide subtitle in minimized state — fast fade out, delayed fade in handled by base style
const $be6de585ac044839$var$headerSubtitleMinimizedStyle = null;
const $be6de585ac044839$var$subtitleStyle = null; // 113px = 64px icon + 4px gap + ~28px heading + ~4px gap + ~13px subtitle
const $be6de585ac044839$var$headerSpacerStyle = null; // 48px = minimized icon height (no subtitle in minimized state)
const $be6de585ac044839$var$headerSpacerMinimizedStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $be6de585ac044839$var$gridStyles = {
    grid: "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2PTnU _39xV02N91d _46hvQm2ADO",
    tile: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VfI2J _0KLXruoI2d _0wOv4Q7zJH _0hPERGjOvk _1eOmH6d1Zr"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $be6de585ac044839$var$accordionStyles = {
    accordionWrapper: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d",
    accordionHeader: "_0bjKvD8fU6 _2V7sgOdnbC _4c065U2ADO _39xV02N91d _0jFU0VpJKa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0KLXru66of _0LQT5E8HPE _03SyCP8HPE _0wOv4Q7zJH",
    expandedContent: "_2Y7lL48HPE _0xmtkoPgdg",
    pickForMeWrapper: "_2Y7lL4gVvo _46hvQmgVvo _0xmtkogVvo _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _43nrzT8HPE"
};
const $be6de585ac044839$var$accordionCollapsedStyle = null;
const $be6de585ac044839$var$accordionExpandedStyle = null;
const $be6de585ac044839$var$revealContentStyle = null;
const $be6de585ac044839$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $be6de585ac044839$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $be6de585ac044839$var$subtleSlideIn = null;
const $be6de585ac044839$var$popupEnterAnimationStyle = null;
const $be6de585ac044839$var$popupStyles = {
    contentWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02sz7G _0KLXrunmFW",
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $be6de585ac044839$var$scrollableBodyStyle = null;
const $be6de585ac044839$var$remixStyles = {
    describeInputBorderWrapper: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    describeInputWrapper: "_4c065U8HPE _2Y7lL45zaO _39xV02N91d _0KLXrunmFW",
    describePromptRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS _39xV02N91d",
    describeTextAreaWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC",
    modalBodyPadding: "_2Y7lL45zaO _46hvQm1Y8M _0xmtko5zaO",
    remixOptionsStack: "_39xV02N91d"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixOverlayHeader({ subtitle: subtitle, isMinimized: isMinimized = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const subtitleMessage = subtitle ?? (0, $czfXc.default).subtitle; // Track minimized state changes to trigger the icon fade-out/fade-in animation.
    // When isMinimized changes, quickly fade out at the start, then fade back in
    // near the end of the 200ms position transition.
    const iconRef = (0, $cozmU.useRef)(null);
    const prevMinimizedRef = (0, $cozmU.useRef)(isMinimized);
    (0, $cozmU.useEffect)(()=>{
        if (prevMinimizedRef.current !== isMinimized) {
            prevMinimizedRef.current = isMinimized;
            const el = iconRef.current;
            if (el) {
                // Gently fade out (uses the 100ms ease-out opacity transition from the base style)
                el.style.opacity = '0'; // Near the end of the 200ms position transition, fade back in
                const timer = setTimeout(()=>{
                    el.style.opacity = '1';
                }, 130);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        isMinimized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHTaix _1mT5xdRAKS _39xV02N91d _46hvQmNHnM _0xmtkoNHnM",
            isMinimized && "_46hvQm5zaO _0xmtko5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $czfXc.default).labsLozengeTooltip),
        position: "top",
        delay: 0
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTon5zaO _4ApkO25zaO _0wOv4Q18ZR _42Yu6B7dHp"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            ...tooltipProps,
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $czfXc.default).labsLozenge))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: iconRef,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_23rrnHxGK8 _1mT5xdWVPG _3OE6xY715P _2IhTonNHnM _1VJPcajssS _39xV029LX5 _0jFU0V9LX5",
            isMinimized && "_3OE6xY5zaO _2IhTon5zaO _1VJPcalna5 _39xV02pJKa _0jFU0VpJKa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
        alt: formatMessage((0, $czfXc.default).remixIconAlt),
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHYjhE _1mT5xdWVPG _3OE6xY715P _2IhTonaXQy _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_3OE6xYUudP _2IhToncM5X _1VJPcalna5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: isMinimized ? 'medium' : 'large'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createHeading : (0, $czfXc.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHZWJM _1mT5xdWVPG _3OE6xY715P _2IhTonv6H3 _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_23rrnH52bh _1YKVNsdnbC _1pp6NdYbGa",
            "_1UtDYzKGUX"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), subtitleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHRiH9 _0jFU0VU9z0",
            isMinimized && "_0jFU0VpJKa"
        ])
    }));
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixSubTypeGrid({ subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$gridStyles.grid
    }, subTypes.map((subType)=>{
        const IconComponent = (0, $1LRKz.SUB_TYPE_ICON_MAP)[subType.value];
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: subType.value,
            content: label,
            position: "top",
            delay: 0,
            ignoreTooltipPointerEvents: true
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...tooltipProps,
                xcss: $be6de585ac044839$var$gridStyles.tile,
                onClick: ()=>onSubTypeSelect(subType.value),
                testId: subType.testId,
                "aria-label": label
            }, IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                alt: label
            }) : null));
    }));
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $be6de585ac044839$var$animationConfig = {
    duration: ()=>450
}; // Tracks which option types have already been preloaded to avoid duplicate work.
const $be6de585ac044839$var$preloadedTypes = new Set(); /**
                                                    * Preloads sub-type icon images for a remix option so they display instantly
                                                    * when the accordion expands. Only fetches icons for the active color mode.
                                                    */ 
function $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode) {
    if ($be6de585ac044839$var$preloadedTypes.has(option.type)) return;
    $be6de585ac044839$var$preloadedTypes.add(option.type);
    const isDark = colorMode === 'dark';
    for (const subType of option.subTypes){
        const urls = (0, $1LRKz.SUB_TYPE_ICON_URLS)[subType.value];
        if (urls) {
            const img = new window.Image();
            img.src = isDark ? urls.dark : urls.light;
        }
    }
}
const $be6de585ac044839$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
        icon: option.icon,
        label: alt,
        appearance: option.iconTileAppearance ?? 'gray',
        size: "small"
    });
};
function $be6de585ac044839$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, colorMode: colorMode }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const smoothResizer = (0, $2LyZS.useResizingHeight)($be6de585ac044839$var$animationConfig);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode);
    }, [
        option,
        colorMode
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
            const subTypeDef = option.subTypes.find((st)=>st.value === subTypeValue);
            onSubTypeSelect(subTypeDef?.emitType ?? option.type, subTypeValue);
            return;
        }
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type,
        option.subTypes
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isExpanded ? "_0bjKvD8fU6 _0KLXruoI2d" : "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleToggle,
        onMouseEnter: handleMouseEnter,
        testId: option.testId,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: smoothResizer.ref,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixSubTypeGrid, {
        subTypes: option.subTypes,
        onSubTypeSelect: handleSubTypeSelect
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.pickForMeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mpnYbKxmn _46PhP8u7m9 _2FH9z4N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePickForMe,
        testId: `${option.testId}-pick-for-me`
    }, formatMessage((0, $czfXc.default).pickForMe))))))));
}
const $be6de585ac044839$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleClick,
        testId: option.testId,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))))));
};
function $be6de585ac044839$export$ced6b2e82a17b9f6({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const [expandedOption, setExpandedOption] = (0, $cozmU.useState)(null);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const describeTextAreaRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Use requestAnimationFrame to auto-focus on the describe text area after the modal fully mounts.
        // This deselects the highlighted text in the editor.
        const raf = requestAnimationFrame(()=>{
            describeTextAreaRef.current?.focus();
        });
        return ()=>cancelAnimationFrame(raf);
    }, []);
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions
        }), [
        hiddenOptions,
        options
    ]);
    const handleDescribeSubmit = (0, $cozmU.useCallback)(()=>{
        if (describeValue?.trim()) onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleDescribeKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleDescribeSubmit();
        }
    }, [
        handleDescribeSubmit
    ]);
    const handleToggle = (0, $cozmU.useCallback)((type)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixOverlaySection',
            attributes: {
                sectionType: type
            }
        });
        setExpandedOption((prev)=>prev === type ? null : type);
    }, [
        sendAnalyticsEvent
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((type, subType)=>{
        const trimmedDescribe = describeValue?.trim();
        const userPrompt = trimmedDescribe && (0, $4o0zT.isExperimentEnabled)('cc_maui_remix_combine_type_and_prompt') ? trimmedDescribe : undefined;
        onOptionSelect?.({
            type: type,
            subType: subType,
            userPrompt: userPrompt
        });
    }, [
        onOptionSelect,
        describeValue
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOverlayHeader, {
        subtitle: subtitle,
        isMinimized: expandedOption !== null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2WAcuGIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.modalBodyPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "stretch",
        xcss: $be6de585ac044839$var$remixStyles.remixOptionsStack
    }, resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixAccordionOption, {
            key: option.type,
            option: option,
            isExpanded: expandedOption === option.type,
            onToggle: handleToggle,
            onSubTypeSelect: handleSubTypeSelect,
            onPickForMe: handlePickForMe,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixFlatOption, {
            key: option.type,
            option: option,
            onSelect: handlePickForMe
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputBorderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleDescribeSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $be6de585ac044839$var$remixStyles.describePromptRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeTextAreaWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        ref: describeTextAreaRef,
        appearance: "none",
        placeholder: formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createDescribePlaceholder : (0, $czfXc.default).describePlaceholder),
        value: describeValue,
        onChange: (e)=>setDescribeValue(e.currentTarget.value),
        onKeyDown: handleDescribeKeyDown,
        isCompact: true,
        minimumRows: 1,
        maxHeight: "200px",
        resize: "smart",
        "aria-label": formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createDescribePlaceholder : (0, $czfXc.default).describePlaceholder),
        testId: "remix-overlay-describe-input",
        name: "remix-overlay-describe"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !describeValue?.trim(),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $czfXc.default).describeSubmitLabel),
        testId: "remix-overlay-describe-submit"
    }))))));
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $be6de585ac044839$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: 320,
        testId: "remix-overlay",
        shouldReturnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvDOLYo _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
        onOptionSelect: onOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    })))));
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $be6de585ac044839$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $cozmU.useRef)(repositionKey);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $be6de585ac044839$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement,
        offset: offset,
        label: formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createHeading : (0, $czfXc.default).heading),
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$PopupRepositionOnKeyChange, {
                repositionKey: repositionKey,
                update: update
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $be6de585ac044839$var$popupStyles.contentWrapper,
                testId: "remix-popup"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $be6de585ac044839$var$popupStyles.body
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                subtitle: subtitle
            }))))),
        trigger: (triggerProps)=>trigger(triggerProps)
    });
}
module.exports["RemixOverlay"] = $be6de585ac044839$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $be6de585ac044839$export$a8b0b54f368ecbb0;

});

parcelRegister("HvNsc", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("eytcg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2c6792bc438bfd46$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $2c6792bc438bfd46$export$defe85febe8b728c;

});

parcelRegister("8nGJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Doctype = module.exports.CDATA = module.exports.Tag = module.exports.Style = module.exports.Script = module.exports.Comment = module.exports.Directive = module.exports.Text = module.exports.Root = module.exports.isTag = module.exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */ var $61a19feb85368e05$var$ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($61a19feb85368e05$var$ElementType = module.exports.ElementType || (module.exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $61a19feb85368e05$var$isTag(elem) {
    return elem.type === $61a19feb85368e05$var$ElementType.Tag || elem.type === $61a19feb85368e05$var$ElementType.Script || elem.type === $61a19feb85368e05$var$ElementType.Style;
}
module.exports.isTag = $61a19feb85368e05$var$isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */ module.exports.Root = $61a19feb85368e05$var$ElementType.Root;
/** Type for Text */ module.exports.Text = $61a19feb85368e05$var$ElementType.Text;
/** Type for <? ... ?> */ module.exports.Directive = $61a19feb85368e05$var$ElementType.Directive;
/** Type for <!-- ... --> */ module.exports.Comment = $61a19feb85368e05$var$ElementType.Comment;
/** Type for <script> tags */ module.exports.Script = $61a19feb85368e05$var$ElementType.Script;
/** Type for <style> tags */ module.exports.Style = $61a19feb85368e05$var$ElementType.Style;
/** Type for Any tag */ module.exports.Tag = $61a19feb85368e05$var$ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */ module.exports.CDATA = $61a19feb85368e05$var$ElementType.CDATA;
/** Type for <!doctype ...> */ module.exports.Doctype = $61a19feb85368e05$var$ElementType.Doctype;

});

parcelRegister("iuuxi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $RfroO = parcelRequire("RfroO");


var $iMnC5 = parcelRequire("iMnC5");


var $6Pqow = parcelRequire("6Pqow");


var $8kG9u = parcelRequire("8kG9u");

const $5d23c774a8ae5aa2$var$styles = {
    textWrapper: "_2YLqiKIZbP _1EqgXldoBh _3iDTPbvbI6",
    imageWrapper: "_1wydGWS40j"
};
function $5d23c774a8ae5aa2$export$618cc98292cae482({ testId: testId = 'navigation-empty-state', renderImage: renderImage = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5d23c774a8ae5aa2$var$styles.imageWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $8kG9u.GenericErrorIcon), null)), description: description, ...restProps }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        ...restProps,
        testId: testId,
        renderImage: renderImage,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $5d23c774a8ae5aa2$var$styles.textWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
            size: "small",
            color: "color.text.subtle"
        }, description))
    });
}
module.exports["NavEmptyState"] = $5d23c774a8ae5aa2$export$618cc98292cae482;

});

parcelRegister("8kG9u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2ltBS = parcelRequire("2ltBS");

const $56c648a5d052c63d$export$f370712d0ce7173b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const theme = (0, $2ltBS.useColorMode)();
    const isDarkTheme = theme === "dark";
    const fillColour = isDarkTheme ? "#4B4D51" : "#DDDEE1";
    const innerColour = isDarkTheme ? "#101214" : "white";
    let t0;
    if ($[0] !== fillColour) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
            fill: fillColour
        });
        $[0] = fillColour;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    let t2;
    if ($[2] !== innerColour) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
            fill: innerColour
        });
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
            fill: innerColour
        });
        $[2] = innerColour;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    let t3;
    if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            "data-testid": "navigation-empty-state--generic-error-icon",
            width: "57",
            height: "53",
            viewBox: "0 0 57 53",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, t1, t2);
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ()=>{
    const theme = (0, $2ltBS.useColorMode)();
    const isDarkTheme = theme === 'dark';
    const fillColour = isDarkTheme ? '#4B4D51' : '#DDDEE1';
    const innerColour = isDarkTheme ? '#101214' : 'white';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": "navigation-empty-state--generic-error-icon",
        width: "57",
        height: "53",
        viewBox: "0 0 57 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
        fill: fillColour
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
        fill: innerColour
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
        fill: innerColour
    }));
};
module.exports["GenericErrorIcon"] = $56c648a5d052c63d$export$f370712d0ce7173b;

});

parcelRegister("iZ8sH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $7akNQ = parcelRequire("7akNQ");


var $cN3xQ = parcelRequire("cN3xQ");


var $dkYuP = parcelRequire("dkYuP");


var $bYqIl = parcelRequire("bYqIl");


var $hx8ly = parcelRequire("hx8ly");


var $bfjGk = parcelRequire("bfjGk");


var $fniLm = parcelRequire("fniLm");

const $447f2ed187e945aa$export$afc779e659fd533f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NavErrorBoundary(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($447f2ed187e945aa$var$InnerErrorBoundary, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function NavErrorBoundary(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($447f2ed187e945aa$var$InnerErrorBoundary, props));
};
const $447f2ed187e945aa$var$InnerErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? function InnerErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(36);
    const { disableAnalytics: t1, disableSentry: t2, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, errorMessages: errorMessages, errorMessageValues: errorMessageValues, interactionId: interactionId, location: t3, onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName } = t0;
    const disableAnalytics = t1 === undefined ? false : t1;
    const disableSentry = t2 === undefined ? false : t2;
    const location = t3 === undefined ? "unknown" : t3;
    let t4;
    if ($[0] !== errorMessageValues || $[1] !== errorMessages) {
        t4 = {
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        };
        $[0] = errorMessageValues;
        $[1] = errorMessages;
        $[2] = t4;
    } else t4 = $[2];
    const { header: header, description: description, values: values } = (0, $dkYuP.useBoundaryMessages)(t4);
    let t5;
    if ($[3] !== showFlags) {
        t5 = {
            showFlags: showFlags
        };
        $[3] = showFlags;
        $[4] = t5;
    } else t5 = $[4];
    const flags = (0, $hx8ly.useMessageFlags)(t5);
    const emitFailureFlag = (0, $bYqIl.useFailureFlagEmitter)(flags);
    let t6;
    if ($[5] !== interactionId || $[6] !== ufoInteractionName) {
        t6 = {
            interactionId: interactionId,
            ufoInteractionName: ufoInteractionName
        };
        $[5] = interactionId;
        $[6] = ufoInteractionName;
        $[7] = t6;
    } else t6 = $[7];
    const reportInteractionError = (0, $bfjGk.useReportInteractionError)(t6);
    let t7;
    if ($[8] !== description || $[9] !== emitFailureFlag || $[10] !== header || $[11] !== onError || $[12] !== reportInteractionError || $[13] !== values) {
        t7 = (error)=>{
            emitFailureFlag({
                header: header,
                description: description,
                values: values
            });
            reportInteractionError(error);
            onError?.(error);
        };
        $[8] = description;
        $[9] = emitFailureFlag;
        $[10] = header;
        $[11] = onError;
        $[12] = reportInteractionError;
        $[13] = values;
        $[14] = t7;
    } else t7 = $[14];
    const onErrorUIHandler = t7;
    let t8;
    if ($[15] !== disableAnalytics || $[16] !== disableSentry || $[17] !== interactionId || $[18] !== location || $[19] !== onErrorUIHandler || $[20] !== sentryConfig || $[21] !== tags) {
        t8 = {
            disableAnalytics: disableAnalytics,
            disableSentry: disableSentry,
            interactionId: interactionId,
            location: location,
            onError: onErrorUIHandler,
            sentryConfig: sentryConfig,
            tags: tags
        };
        $[15] = disableAnalytics;
        $[16] = disableSentry;
        $[17] = interactionId;
        $[18] = location;
        $[19] = onErrorUIHandler;
        $[20] = sentryConfig;
        $[21] = tags;
        $[22] = t8;
    } else t8 = $[22];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t8);
    let t9;
    if ($[23] !== disableAnalytics || $[24] !== errorActionUI || $[25] !== errorFallbackUI || $[26] !== errorMessageValues || $[27] !== errorMessages || $[28] !== flags || $[29] !== location || $[30] !== silent) {
        t9 = silent || flags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fniLm.ErrorBoundaryUI), {
            disableAnalytics: disableAnalytics,
            errorActionUI: errorActionUI,
            errorFallbackUI: errorFallbackUI,
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues,
            location: location
        });
        $[23] = disableAnalytics;
        $[24] = errorActionUI;
        $[25] = errorFallbackUI;
        $[26] = errorMessageValues;
        $[27] = errorMessages;
        $[28] = flags;
        $[29] = location;
        $[30] = silent;
        $[31] = t9;
    } else t9 = $[31];
    const errorComponent = t9;
    let t10;
    if ($[32] !== children || $[33] !== errorComponent || $[34] !== handleError) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            onError: handleError,
            fallback: errorComponent
        }, children);
        $[32] = children;
        $[33] = errorComponent;
        $[34] = handleError;
        $[35] = t10;
    } else t10 = $[35];
    return t10;
} : function InnerErrorBoundary({ disableAnalytics: disableAnalytics = false, disableSentry: disableSentry = false, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, errorMessages: errorMessages, errorMessageValues: errorMessageValues, interactionId: interactionId, location: location = 'unknown', onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName }) {
    const { header: header, description: description, values: values } = (0, $dkYuP.useBoundaryMessages)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    const flags = (0, $hx8ly.useMessageFlags)({
        showFlags: showFlags
    });
    const emitFailureFlag = (0, $bYqIl.useFailureFlagEmitter)(flags);
    const reportInteractionError = (0, $bfjGk.useReportInteractionError)({
        interactionId: interactionId,
        ufoInteractionName: ufoInteractionName
    });
    const onErrorUIHandler = (0, $cozmU.useCallback)((error)=>{
        emitFailureFlag({
            header: header,
            description: description,
            values: values
        });
        reportInteractionError(error);
        onError?.(error);
    }, [
        emitFailureFlag,
        reportInteractionError,
        header,
        description,
        values,
        onError
    ]);
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        disableAnalytics: disableAnalytics,
        disableSentry: disableSentry,
        interactionId: interactionId,
        location: location,
        onError: onErrorUIHandler,
        sentryConfig: sentryConfig,
        tags: tags
    });
    // When `silent` is true or `flags` are enabled, we don't want to show any UI on error
    const errorComponent = silent || flags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fniLm.ErrorBoundaryUI), {
        disableAnalytics: disableAnalytics,
        errorActionUI: errorActionUI,
        errorFallbackUI: errorFallbackUI,
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues,
        location: location
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: handleError,
        fallback: errorComponent
    }, children);
};
module.exports["NavErrorBoundary"] = $447f2ed187e945aa$export$afc779e659fd533f;

});

parcelRegister("dkYuP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lBupX = parcelRequire("lBupX");

const $de5f42b79a2733de$export$dd28f26aa5199f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBoundaryMessages(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { errorMessages: errorMessages, errorMessageValues: errorMessageValues } = t0;
    let t1;
    if ($[0] !== errorMessageValues || $[1] !== errorMessages) {
        t1 = (0, $lBupX.getMessages)({
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        });
        $[0] = errorMessageValues;
        $[1] = errorMessages;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function useBoundaryMessages({ errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    return (0, $cozmU.useMemo)(()=>{
        return (0, $lBupX.getMessages)({
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        });
    }, [
        errorMessages,
        errorMessageValues
    ]);
};
module.exports["useBoundaryMessages"] = $de5f42b79a2733de$export$dd28f26aa5199f5;

});

parcelRegister("lBupX", function(module, exports) {
function $262975364d45b3c9$export$8c20ab16ac9cf14f({ errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    return errorMessages ? {
        header: errorMessages.header,
        description: errorMessages.description,
        values: errorMessageValues
    } : {};
}
module.exports["getMessages"] = $262975364d45b3c9$export$8c20ab16ac9cf14f;

});

parcelRegister("bYqIl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $faee39858219e5fe$export$bc7f29bc4d00b60a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFailureFlagEmitter(flags) {
    const $ = (0, $bDgLe.c)(10);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pendingFlagRef = (0, $cozmU.useRef)(null);
    const dismissPendingFlagRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage) {
        t0 = ()=>{
            const pending = pendingFlagRef.current;
            if (!flags || !pending) return;
            dismissPendingFlagRef.current?.();
            const dismiss = flags.showFailure({
                title: formatMessage(pending.header, pending.values),
                description: formatMessage(pending.description, pending.values)
            });
            dismissPendingFlagRef.current = typeof dismiss === "function" ? dismiss : null;
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = t0;
    } else t0 = $[2];
    const reEmitPendingFlag = t0;
    let t1;
    let t2;
    if ($[3] !== reEmitPendingFlag) {
        t1 = ()=>{
            if (pendingFlagRef.current) reEmitPendingFlag();
        };
        t2 = [
            reEmitPendingFlag
        ];
        $[3] = reEmitPendingFlag;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>()=>{
                dismissPendingFlagRef.current?.();
                dismissPendingFlagRef.current = null;
                pendingFlagRef.current = null;
            };
        t4 = [];
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] !== reEmitPendingFlag) {
        t5 = (pending_0)=>{
            pendingFlagRef.current = pending_0;
            reEmitPendingFlag();
        };
        $[8] = reEmitPendingFlag;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : function useFailureFlagEmitter(flags) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pendingFlagRef = (0, $cozmU.useRef)(null);
    const dismissPendingFlagRef = (0, $cozmU.useRef)(null);
    const reEmitPendingFlag = (0, $cozmU.useCallback)(()=>{
        const pending = pendingFlagRef.current;
        if (!flags || !pending) return;
        dismissPendingFlagRef.current?.();
        const dismiss = flags.showFailure({
            title: formatMessage(pending.header, pending.values),
            description: formatMessage(pending.description, pending.values)
        });
        dismissPendingFlagRef.current = typeof dismiss === 'function' ? dismiss : null;
    }, [
        flags,
        formatMessage
    ]);
    // Re-emit whenever `formatMessage` identity changes (i.e. the inner
    // IntlProvider has re-rendered with a new messages map after the async
    // load). No-op when the gate is OFF or no error has fired yet.
    (0, $cozmU.useEffect)(()=>{
        if (pendingFlagRef.current) reEmitPendingFlag();
    }, [
        reEmitPendingFlag
    ]);
    // On unmount, dismiss any flag we own so we don't leak it into the host
    // app's FlagGroup after this boundary goes away.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            dismissPendingFlagRef.current?.();
            dismissPendingFlagRef.current = null;
            pendingFlagRef.current = null;
        };
    }, []);
    return (0, $cozmU.useCallback)((pending_0)=>{
        // Capture the descriptor inputs so the locale-change effect can
        // re-emit a re-localised flag once messages finish loading.
        // Emit immediately (possibly in the default language) so the
        // user gets visible feedback right away.
        pendingFlagRef.current = pending_0;
        reEmitPendingFlag();
    }, [
        reEmitPendingFlag
    ]);
};
module.exports["useFailureFlagEmitter"] = $faee39858219e5fe$export$bc7f29bc4d00b60a;

});

parcelRegister("hx8ly", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4MnFz = parcelRequire("4MnFz");


var $5avUB = parcelRequire("5avUB");

const $bf593926feff8e14$export$ad59d437e6db3634 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessageFlags(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { showFlags: t1 } = t0;
    const showFlags = t1 === undefined ? false : t1;
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    let t2;
    if ($[0] !== showFlag) {
        t2 = {
            showFailure: (t3)=>{
                const { title: title, description: description, actions: actions } = t3;
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $bf593926feff8e14$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $bf593926feff8e14$var$flagsIds.failure,
                    title: title
                });
            }
        };
        $[0] = showFlag;
        $[1] = t2;
    } else t2 = $[1];
    const flags = t2;
    return !showFlags ? undefined : flags;
} : function useMessageFlags({ showFlags: showFlags = false }) {
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const flags = (0, $cozmU.useMemo)(()=>({
            showFailure: ({ title: title, description: description, actions: actions })=>{
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $bf593926feff8e14$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $bf593926feff8e14$var$flagsIds.failure,
                    title: title
                });
            }
        }), [
        showFlag
    ]);
    return !showFlags ? undefined : flags;
};
const $bf593926feff8e14$var$flagsIds = {
    failure: 'nav-error-boundary-failure-flag'
};
module.exports["useMessageFlags"] = $bf593926feff8e14$export$ad59d437e6db3634;

});

parcelRegister("bfjGk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $h6BA0 = parcelRequire("h6BA0");


var $fAint = parcelRequire("fAint");

function $d1beced314957844$export$2139d636391467cf({ interactionId: interactionId, ufoInteractionName: ufoInteractionName }) {
    const reportError = (0, $h6BA0.useUFOReportError)();
    const reportErrorRef = (0, $cozmU.useRef)(reportError);
    reportErrorRef.current = reportError;
    return (0, $cozmU.useCallback)((error)=>{
        const name = ufoInteractionName ? ufoInteractionName : interactionId ? (0, $fAint.NavigationExperienceId)[interactionId].experienceId : undefined;
        if (!name) return;
        reportErrorRef.current({
            name: name,
            errorMessage: error.message,
            errorStack: error.stack,
            errorStatusCode: error instanceof Response ? error?.status : undefined
        });
    }, [
        interactionId,
        ufoInteractionName
    ]);
}
module.exports["useReportInteractionError"] = $d1beced314957844$export$2139d636391467cf;

});

parcelRegister("fniLm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iuuxi = parcelRequire("iuuxi");


var $4fwrR = parcelRequire("4fwrR");


var $lBupX = parcelRequire("lBupX");

const $6655ae61539b26f8$export$ed65a7143a39e5b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundaryUI(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location, errorMessages: errorMessages, errorMessageValues: errorMessageValues } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    const { header: header, description: description, values: values } = (0, $lBupX.getMessages)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    let t1;
    let t2;
    if ($[0] !== disableAnalytics || $[1] !== errorFallbackUI || $[2] !== fireEvent || $[3] !== location) {
        t1 = ()=>{
            if (!disableAnalytics) fireEvent("ui.errorBoundary.viewed.errorBoundaryUI", {
                location: location,
                isFallbackUI: !!errorFallbackUI
            });
        };
        t2 = [
            disableAnalytics,
            errorFallbackUI,
            fireEvent,
            location
        ];
        $[0] = disableAnalytics;
        $[1] = errorFallbackUI;
        $[2] = fireEvent;
        $[3] = location;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    if (errorFallbackUI) return errorFallbackUI({
        header: formatMessage(header, values),
        description: formatMessage(description, values)
    });
    const T0 = (0, $iuuxi.NavEmptyState);
    const t3 = "navigation-error-boundary-ui";
    const t4 = formatMessage(header, values);
    const t5 = formatMessage(description, values);
    let t6;
    if ($[6] !== T0 || $[7] !== errorActionUI || $[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            testId: t3,
            header: t4,
            description: t5,
            primaryAction: errorActionUI
        });
        $[6] = T0;
        $[7] = errorActionUI;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : function ErrorBoundaryUI({ disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location, errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    // Message precedence: errorMessages (consumer-provided) > location-based lookup
    const { header: header, description: description, values: values } = (0, $lBupX.getMessages)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!disableAnalytics) fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
            location: location,
            isFallbackUI: !!errorFallbackUI
        });
    }, [
        disableAnalytics,
        errorFallbackUI,
        fireEvent,
        location
    ]);
    // If a custom fallback UI is provided, render it directly at risk of consumer
    if (errorFallbackUI) return errorFallbackUI({
        header: formatMessage(header, values),
        description: formatMessage(description, values)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuuxi.NavEmptyState), {
        testId: "navigation-error-boundary-ui",
        header: formatMessage(header, values),
        description: formatMessage(description, values),
        primaryAction: errorActionUI
    });
};
module.exports["ErrorBoundaryUI"] = $6655ae61539b26f8$export$ed65a7143a39e5b6;

});

parcelRegister("aibb0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");

function $5a198a38a6368eba$export$6fa362ed4e835606({ defaultMessages: defaultMessages, asyncLanguages: asyncLanguages, onLoadError: onLoadError }) {
    const fetchMessagesForLocale = async (locale)=>{
        try {
            // Fallback to the generic locale (e.g. `de`) if the specified
            // region-qualified locale (e.g. `de-DE`) is not present in the map.
            const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';
            const localeMessages = await asyncLanguages[languageLocale]?.();
            return localeMessages?.default ?? defaultMessages;
        } catch (e) {
            onLoadError?.(locale, e);
        }
        return defaultMessages;
    };
    return function AsyncIntlProvider({ children: children, disabled: disabled = false }) {
        if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        // `fetchMessagesForLocale` is defined once at factory-call time and
        // closed over here, so its identity is already stable across renders
        // of this returned component — no `useCallback` needed.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: defaultMessages,
            loaderFn: fetchMessagesForLocale
        }, children);
    };
}
module.exports["createAsyncIntlProvider"] = $5a198a38a6368eba$export$6fa362ed4e835606;

});

parcelRegister("cV7Sf", function(module, exports) {

var $9qkHq = parcelRequire("9qkHq");


var $cozmU = parcelRequire("cozmU");


var $huGTe = parcelRequire("huGTe");


var $6SsN4 = parcelRequire("6SsN4");


var $cXPtd = parcelRequire("cXPtd");

const $8fc466faee27ed0c$export$2dc34b66082250f3 = ({ queryRef: queryRef, cloudId: cloudId, onError: onError, shortcutsConfig: shortcutsConfig, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $cozmU.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    /* eslint-disable @atlassian/relay/graphql-naming */ /* eslint-disable @atlassian/relay/no-wrapping-hooks */ const fragmentData = (0, $6SsN4.useFragment)((0, $9qkHq.default), queryRef);
    /* eslint-enable @atlassian/relay/graphql-naming */ /* eslint-enable @atlassian/relay/no-wrapping-hooks */ const appSwitcherResult = fragmentData?.appSwitcher_availableProductsBySite;
    (0, $cozmU.useEffect)(()=>{
        if (appSwitcherResult?.__typename === 'QueryError') onError?.(new Error(appSwitcherResult.message ?? 'appSwitcher_availableProductsBySite failed'));
    }, [
        appSwitcherResult,
        onError
    ]);
    const { productLinksByProductType: productLinksByProductType_0, productLinksRequestStatus: productLinksRequestStatus_0 } = (0, $cozmU.useMemo)(()=>{
        const productLinksRequestStatus = !appSwitcherResult ? (0, $cXPtd.RequestStatus).INIT : appSwitcherResult.__typename === 'QueryError' ? (0, $cXPtd.RequestStatus).ERROR : appSwitcherResult.__typename === 'AppSwitcherAvailableProductsBySite' ? (0, $cXPtd.RequestStatus).COMPLETE : (0, $cXPtd.RequestStatus).INIT;
        const productLinksByProductType = new Map();
        if (appSwitcherResult?.__typename === 'AppSwitcherAvailableProductsBySite') {
            const products = appSwitcherResult.products;
            if (products?.length) for (const product of products){
                if (product.__typename === 'AppSwitcherSingleUrlProduct') {
                    if (product.url) productLinksByProductType.set(product.productType, [
                        {
                            url: product.url
                        }
                    ]);
                } else if (product.__typename === 'AppSwitcherSiteScopedProduct') {
                    const links = (product.sites ?? []).filter((site)=>Boolean(site.url)).map((site_0)=>({
                            cloudId: site_0.siteId,
                            url: site_0.url
                        }));
                    if (links.length) productLinksByProductType.set(product.productType, links);
                }
            }
        }
        return {
            productLinksByProductType: productLinksByProductType,
            productLinksRequestStatus: productLinksRequestStatus
        };
    }, [
        appSwitcherResult
    ]);
    const lastCompleteProductLinksByTypeRef = (0, $cozmU.useRef)(new Map());
    if (productLinksRequestStatus_0 === (0, $cXPtd.RequestStatus).COMPLETE) lastCompleteProductLinksByTypeRef.current = new Map(productLinksByProductType_0);
    const getRelayProductLinksForKey = (0, $cozmU.useCallback)((apsKey)=>({
            links: lastCompleteProductLinksByTypeRef.current.get(apsKey) ?? [],
            status: (0, $cXPtd.RequestStatus).COMPLETE
        }), []);
    (0, $cozmU.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (productLinksRequestStatus_0 !== (0, $cXPtd.RequestStatus).COMPLETE) return;
        onUpdateGetFilteredProductLinksRef.current(getRelayProductLinksForKey);
    }, [
        getRelayProductLinksForKey,
        productLinksRequestStatus_0,
        productLinksByProductType_0
    ]);
    const productUrlMap = (0, $cozmU.useMemo)(()=>{
        const urlByProductType = new Map();
        for (const [productType, links_0] of productLinksByProductType_0.entries()){
            if (!links_0.length) continue;
            const match = cloudId ? links_0.find((l)=>l.cloudId === cloudId) : undefined;
            const chosen = match ?? links_0[0];
            if (chosen?.url) urlByProductType.set(productType, chosen.url);
        }
        return urlByProductType;
    }, [
        productLinksByProductType_0,
        cloudId
    ]);
    const appShortcuts = (0, $cozmU.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (!productUrlMap.size) return shortcutsConfig;
        const isArray = Array.isArray(config);
        if (isArray) return config.reduce((acc, item)=>{
            if (item.type !== 'link' || !item.apsKey) {
                acc.push(item);
                return acc;
            }
            const url = productUrlMap.get(item.apsKey);
            if (url) acc.push({
                ...item,
                url: url
            });
            return acc;
        }, []);
        const entries = Object.entries(config);
        return entries.reduce((acc_0, [key, value])=>{
            if (value.type !== 'link' || !value.apsKey) {
                acc_0[key] = value;
                return acc_0;
            }
            const url_0 = productUrlMap.get(value.apsKey);
            if (url_0) acc_0[key] = {
                ...value,
                url: url_0
            };
            return acc_0;
        }, {});
    }, [
        productUrlMap,
        shortcutsConfig
    ]);
    return appShortcuts;
};
module.exports["useGlobalShortcutsDataRelay"] = $8fc466faee27ed0c$export$2dc34b66082250f3;

});

parcelRegister("9qkHq", function(module, exports) {
/**
 * @generated SignedSource<<c5ca11060b3f01d0eef237e6ba896387>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b53acbdb9b25f3a8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "useGlobalShortcutsDataRelay",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "appSwitcher_availableProductsBySite",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "type": "AppSwitcherSingleUrlProduct"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "concreteType": "AppSwitcherProductSite",
                                                "kind": "LinkedField",
                                                "name": "sites",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "siteId"
                                                    },
                                                    v2 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "AppSwitcherSiteScopedProduct"
                                    }
                                ]
                            }
                        ],
                        "type": "AppSwitcherAvailableProductsBySite"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "QueryError"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$b53acbdb9b25f3a8$var$node.hash = "c8b29534eaae104f3d284f0f36fda276";
var $b53acbdb9b25f3a8$export$2e2bcd8739ae039 = $b53acbdb9b25f3a8$var$node;
module.exports["default"] = $b53acbdb9b25f3a8$export$2e2bcd8739ae039;

});

parcelRegister("cXPtd", function(module, exports) {
var $ae53bce35cc1f1d1$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
var $ae53bce35cc1f1d1$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_ALIGN"] = "ALIGN";
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["CUSTOMER_SERVICE_MANAGEMENT"] = "JIRA_CUSTOMER_SERVICE";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    Products["FEEDBACK"] = "FEEDBACK";
    return Products;
}({});
const $ae53bce35cc1f1d1$export$85183a312807388d = 'navigation';
module.exports["RequestStatus"] = $ae53bce35cc1f1d1$export$600e7c1f9e0414e1;
module.exports["Products"] = $ae53bce35cc1f1d1$export$92e44ea1079b9ec6;
module.exports["ANALYTICS_CHANNEL"] = $ae53bce35cc1f1d1$export$85183a312807388d;

});

parcelRegister("9kVQp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $ind1R = parcelRequire("ind1R");


var $cozmU = parcelRequire("cozmU");


var $huGTe = parcelRequire("huGTe");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $d5gEx = parcelRequire("d5gEx");


var $cV7Sf = parcelRequire("cV7Sf");

const $8bbd0498031e8196$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function HydrationSafeSuspenseContent(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, fallback: fallback } = t0;
    let t1;
    if ($[0] !== children || $[1] !== fallback) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: fallback
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block prop propagation into the Suspense boundary while locked (during hydration)
    return nextProps.isLocked;
});
const $8bbd0498031e8196$var$HydrationSafeSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HydrationSafeSuspense(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { fallback: t1, children: children } = t0;
    const fallback = t1 === undefined ? null : t1;
    const [isLocked, setIsLocked] = (0, $cozmU.useState)(true);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsLocked(false);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== children || $[3] !== fallback || $[4] !== isLocked) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspenseContent, {
            isLocked: isLocked,
            fallback: fallback
        }, children);
        $[2] = children;
        $[3] = fallback;
        $[4] = isLocked;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function HydrationSafeSuspense({ fallback: fallback = null, children: children }) {
    // Always start locked (true) regardless of SSR or CSR — this covers both SSR hydration
    // AND client-side transitions (e.g. edit mode) where process.env.REACT_SSR is false
    // but React still needs the boundary to stay stable until after the first mount.
    const [isLocked, setIsLocked] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        setIsLocked(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspenseContent, {
        isLocked: isLocked,
        fallback: fallback
    }, children);
};
const $8bbd0498031e8196$var$emptySubscribe = ()=>()=>{};
/**
 * Returns `false` during SSR and the client's hydrating render, then `true` once React has finished
 * hydrating this subtree
 */ const $8bbd0498031e8196$var$useIsHydrated = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useIsHydrated() {
    return (0, $cozmU.useSyncExternalStore)($8bbd0498031e8196$var$emptySubscribe, $8bbd0498031e8196$var$_temp, $8bbd0498031e8196$var$_temp2);
} : function useIsHydrated() {
    return (0, $cozmU.useSyncExternalStore)($8bbd0498031e8196$var$emptySubscribe, ()=>true, ()=>false);
};
/**
 * Standalone GAS Relay entry: includes `RelayEnvironmentProvider` and `HydrationSafeSuspense`
 * so callers do not need to wrap the tree.
 *
 * Guards against React error #421 ("Suspense boundary received an update before it finished
 * hydrating"). When the `navx-4463-gas-agg-migration` gate is on, `GlobalShortcutsRelayClientImpl`
 * calls `loadQuery()` inside a `useEffect` on mount, which updates Relay's query-loader state while
 * the surrounding boundary is still hydrating.
 *
 * Behind the `confluence_global_shortcuts_hydration` gate we render the non-suspending
 * `GlobalShortcutsRelayClientSkip` until after the first mount (`isHydrated`), so the data-fetching
 * `HydrationSafeSuspense` boundary only mounts post-hydration and can never trip #421. With the
 * gate off, the `HydrationSafeSuspense` lock alone is the (best-effort) guard.
 *
 * Fallback uses `GlobalShortcutsRelayClientSkip` (no preload, same merge path).
 */ function $8bbd0498031e8196$var$_temp2() {
    return false;
}
function $8bbd0498031e8196$var$_temp() {
    return true;
}
const $8bbd0498031e8196$var$GlobalShortcutsRelayClient = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClient(props) {
    const $ = (0, $bDgLe.c)(3);
    const isHydrated = $8bbd0498031e8196$var$useIsHydrated();
    let t0;
    if ($[0] !== isHydrated || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.RelayEnvironmentProvider), null, !isHydrated && (0, $iDrrr.fg)("confluence_global_shortcuts_hydration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspense, {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientImpl, props)));
        $[0] = isHydrated;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function GlobalShortcutsRelayClient(props) {
    const isHydrated = $8bbd0498031e8196$var$useIsHydrated();
    // Render Skip until after mount so the Suspense boundary only mounts post-hydration (avoids #421).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.RelayEnvironmentProvider), null, !isHydrated && (0, $iDrrr.fg)('confluence_global_shortcuts_hydration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientImpl, props)));
};
var $8bbd0498031e8196$export$2e2bcd8739ae039 = $8bbd0498031e8196$var$GlobalShortcutsRelayClient;
const $8bbd0498031e8196$var$GlobalShortcutsRelayClientImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClientImpl(props) {
    const $ = (0, $bDgLe.c)(14);
    let t0;
    if ($[0] !== props.cloudId || $[1] !== props.isShortcutsStatic || $[2] !== props.shortcutsConfig) {
        t0 = Boolean(props.cloudId) && !props.isShortcutsStatic && !(0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(props.shortcutsConfig);
        $[0] = props.cloudId;
        $[1] = props.isShortcutsStatic;
        $[2] = props.shortcutsConfig;
        $[3] = t0;
    } else t0 = $[3];
    const shouldFetch = t0;
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $ind1R.default));
    let t1;
    let t2;
    if ($[4] !== loadQuery || $[5] !== props.cloudId || $[6] !== shouldFetch) {
        t1 = ()=>{
            if (!shouldFetch) return;
            (0, $cozmU.startTransition)(()=>{
                loadQuery({
                    cloudId: props.cloudId ?? ""
                });
            });
        };
        t2 = [
            shouldFetch,
            props.cloudId,
            loadQuery
        ];
        $[4] = loadQuery;
        $[5] = props.cloudId;
        $[6] = shouldFetch;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!shouldFetch || queryRef == null) {
        let t3;
        if ($[9] !== props) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props);
            $[9] = props;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] !== props || $[12] !== queryRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientPreloaded, {
            queryRef: queryRef,
            ...props
        });
        $[11] = props;
        $[12] = queryRef;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function GlobalShortcutsRelayClientImpl(props) {
    const shouldFetch = Boolean(props.cloudId) && !props.isShortcutsStatic && !(0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(props.shortcutsConfig);
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $ind1R.default));
    (0, $cozmU.useEffect)(()=>{
        if (!shouldFetch) return;
        (0, $cozmU.startTransition)(()=>{
            loadQuery({
                cloudId: props.cloudId ?? ''
            });
        });
    }, [
        shouldFetch,
        props.cloudId,
        loadQuery
    ]);
    if (!shouldFetch || queryRef == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientPreloaded, {
        queryRef: queryRef,
        ...props
    });
};
const $8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClientSkip(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks } = t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== onError || $[2] !== onUpdateGetFilteredProductLinks || $[3] !== product || $[4] !== shortcutsConfig) {
        t1 = {
            queryRef: undefined,
            shortcutsConfig: shortcutsConfig,
            cloudId: cloudId,
            onError: onError,
            product: product,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
        };
        $[0] = cloudId;
        $[1] = onError;
        $[2] = onUpdateGetFilteredProductLinks;
        $[3] = product;
        $[4] = shortcutsConfig;
        $[5] = t1;
    } else t1 = $[5];
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)(t1);
    const t2 = shortcutItems;
    let t3;
    if ($[6] !== children || $[7] !== t2) {
        t3 = children(t2);
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function GlobalShortcutsRelayClientSkip({ children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)({
        queryRef: undefined,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(shortcutItems));
};
const $8bbd0498031e8196$var$GlobalShortcutsRelayClientPreloaded = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClientPreloaded(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { queryRef: queryRef, children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks } = t0;
    const queryData = (0, $6SsN4.usePreloadedQuery)((0, $ind1R.default), queryRef);
    let t1;
    if ($[0] !== cloudId || $[1] !== onError || $[2] !== onUpdateGetFilteredProductLinks || $[3] !== product || $[4] !== queryData || $[5] !== shortcutsConfig) {
        t1 = {
            queryRef: queryData,
            shortcutsConfig: shortcutsConfig,
            cloudId: cloudId,
            onError: onError,
            product: product,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
        };
        $[0] = cloudId;
        $[1] = onError;
        $[2] = onUpdateGetFilteredProductLinks;
        $[3] = product;
        $[4] = queryData;
        $[5] = shortcutsConfig;
        $[6] = t1;
    } else t1 = $[6];
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)(t1);
    const t2 = shortcutItems;
    let t3;
    if ($[7] !== children || $[8] !== t2) {
        t3 = children(t2);
        $[7] = children;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : function GlobalShortcutsRelayClientPreloaded({ queryRef: queryRef, children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const queryData = (0, $6SsN4.usePreloadedQuery)((0, $ind1R.default), queryRef);
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)({
        queryRef: queryData,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(shortcutItems));
};
module.exports["default"] = $8bbd0498031e8196$export$2e2bcd8739ae039;

});

parcelRegister("ind1R", function(module, exports) {
/**
 * @generated SignedSource<<8307d24646dec2179f7b4020c61d570b>>
 * @relayHash 86994beb11f4ef7c8af21523816aa062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c
const $5296e6a3c12ed06f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useGlobalShortcutsDataRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "appSwitcher_availableProductsBySite",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "products",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ],
                                            "type": "AppSwitcherSingleUrlProduct"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "AppSwitcherProductSite",
                                                    "kind": "LinkedField",
                                                    "name": "sites",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "siteId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "AppSwitcherSiteScopedProduct"
                                        }
                                    ]
                                }
                            ],
                            "type": "AppSwitcherAvailableProductsBySite"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c",
            "metadata": {},
            "name": "GlobalShortcutsRelayClientQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5296e6a3c12ed06f$var$node.hash = "293957e10078d4cb40237c0fdc35aadd";
var $5296e6a3c12ed06f$export$2e2bcd8739ae039 = $5296e6a3c12ed06f$var$node;
module.exports["default"] = $5296e6a3c12ed06f$export$2e2bcd8739ae039;

});

parcelRegister("gOXu0", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsDataBFF", () => (parcelRequire("3vXmx")).useGlobalShortcutsDataBFF);
/* eslint-disable import/order */ 
var $3vXmx = parcelRequire("3vXmx");


var $cV7Sf = parcelRequire("cV7Sf");

const $3aa12f212f3c971e$export$bc8645ef40313f94 = (0, $3vXmx.useGlobalShortcutsDataBFF);

});

parcelRegister("3vXmx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $huGTe = parcelRequire("huGTe");


var $6RQcq = parcelRequire("6RQcq");


var $cXPtd = parcelRequire("cXPtd");


var $2be25 = parcelRequire("2be25");

const $5076d2e48ef5ec58$export$716312c3742c01a3 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, isShortcutsStatic: isShortcutsStatic, onError: onError })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $cozmU.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks, error: error } = (0, $6RQcq.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        forceStatic: isShortcutsStatic,
        product: product
    });
    const lastCompleteProductLinksRef = (0, $cozmU.useRef)({});
    if (status === (0, $cXPtd.RequestStatus).COMPLETE) lastCompleteProductLinksRef.current = {
        ...productLinks
    };
    const getBffProductLinksForKey = (0, $cozmU.useCallback)((apsKey)=>({
            links: lastCompleteProductLinksRef.current[apsKey] ?? [],
            status: (0, $cXPtd.RequestStatus).COMPLETE
        }), []);
    (0, $cozmU.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (status !== (0, $cXPtd.RequestStatus).COMPLETE) return;
        onUpdateGetFilteredProductLinksRef.current(getBffProductLinksForKey);
    }, [
        getBffProductLinksForKey,
        status,
        productLinks
    ]);
    // fetch the data from the bff if required
    (0, $cozmU.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(shortcutsConfig) || isShortcutsStatic || !cloudId) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        cloudId,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status === (0, $cXPtd.RequestStatus).ERROR && error) onError?.(error);
    }, [
        status,
        error,
        onError
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $cozmU.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (status === (0, $cXPtd.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const isArray = Array.isArray(config);
            if (isArray) return config.reduce((acc, item)=>{
                // if config does not need a data reference, just return the value
                if (item.type !== 'link' || !item.apsKey) {
                    acc.push(item);
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[item.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $2be25.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc.push({
                        ...item,
                        url: filteredProductLink.url
                    });
                }
                return acc;
            }, []);
            const entries = Object.entries(config);
            return entries.reduce((acc_0, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (value.type !== 'link' || !value.apsKey) {
                    acc_0[key] = value;
                    return acc_0;
                }
                // if config requires the bff to determine the data reference
                const productLink_0 = productLinks[value.apsKey];
                if (productLink_0) {
                    const filteredProductLink_0 = cloudId ? productLink_0.filter((0, $2be25.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink_0[0];
                    acc_0[key] = {
                        ...value,
                        url: filteredProductLink_0.url
                    };
                    return acc_0;
                }
                return acc_0;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};
module.exports["useGlobalShortcutsDataBFF"] = $5076d2e48ef5ec58$export$716312c3742c01a3;

});

parcelRegister("6RQcq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");


var $9Kv4c = parcelRequire("9Kv4c");


var $8PNRl = parcelRequire("8PNRl");


var $izZjw = parcelRequire("izZjw");


var $hrm0L = parcelRequire("hrm0L");


var $2nIbk = parcelRequire("2nIbk");

async function $ea54d8a6b0272f84$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $ea54d8a6b0272f84$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $8PNRl.useCache)();
    const { status: status, error: error, setStatus: setStatus } = (0, $hrm0L.useStatus)();
    const { productLinks: productLinks } = (0, $izZjw.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $2nIbk.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const currentRequest = (0, $cozmU.useRef)(null);
    const fetchData = (0, $cozmU.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        // Always clear error status at the start of a new request
        setStatus((0, $3ePvn.RequestStatus).LOADING, (0, $3ePvn.BFF_REQUEST_STATUS_KEY), undefined);
        try {
            const response = await (0, $9Kv4c.fetchJSON)(url, {});
            switch(response.status){
                case (0, $3ePvn.RequestStatus).ERROR:
                    throw response.error;
                case (0, $3ePvn.RequestStatus).COMPLETE:
                    setStatus((0, $3ePvn.RequestStatus).COMPLETE, (0, $3ePvn.BFF_REQUEST_STATUS_KEY), undefined);
                    currentRequest.current = null;
                    return response.data;
            }
        } catch (error_0) {
            const maxAttempts = request?.maxAttempts ?? (0, $3ePvn.MAX_ATTEMPTS_NEW_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                const baseInterval = request?.attemptInterval ?? (0, $3ePvn.RETRY_INTERVAL_DEFAULT);
                // Exponential backoff: delay doubles with each attempt (1x, 2x, 4x)
                const delay = request?.enableExponentialDelay ? baseInterval * Math.pow(2, attemptCount - 1) : baseInterval;
                await $ea54d8a6b0272f84$var$wait(delay);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $3ePvn.RequestStatus).ERROR, undefined, error_0 instanceof Error ? error_0 : new Error(String(error_0)));
                throw error_0;
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        request?.enableExponentialDelay,
        setStatus
    ]);
    /**
   * Helper function to build a URL and fetch data.
   */ const buildURLAndFetchData = (0, $cozmU.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, undefined);
            const fetchedData = await currentRequest.current;
            if (!!fetchedData?.sites?.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        error: error,
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}
module.exports["useBFFDataProvider"] = $ea54d8a6b0272f84$export$a00b492c9c3c66db;

});

parcelRegister("izZjw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hp074 = parcelRequire("hp074");


var $jH9cM = parcelRequire("jH9cM");


var $3ePvn = parcelRequire("3ePvn");


var $iFf4X = parcelRequire("iFf4X");


var $9oc6O = parcelRequire("9oc6O");


var $8PNRl = parcelRequire("8PNRl");


var $hrm0L = parcelRequire("hrm0L");

function $0a5e899f2d5517f1$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $0a5e899f2d5517f1$var$flightdeckClient = new (0, $hp074.default)('atlassian-navigagtion-bff-data-provider');
function $0a5e899f2d5517f1$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $8PNRl.useCache)();
    const { setStatus: setStatus } = (0, $hrm0L.useStatus)();
    const [fdResponse, setFdResponse] = (0, $cozmU.useState)(null);
    const [productConfig, setProductConfig] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $3ePvn.RequestStatus).LOADING, (0, $3ePvn.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse_0 = await $0a5e899f2d5517f1$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $jH9cM.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse_0);
                setStatus((0, $3ePvn.RequestStatus).COMPLETE, (0, $3ePvn.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch  {
                setStatus((0, $3ePvn.RequestStatus).ERROR, (0, $3ePvn.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $9oc6O.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $9oc6O.formatText)(rebrandedDisplayName),
                description: (0, $9oc6O.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $3ePvn.ASSETS_APP_KEY]) config[0, $3ePvn.ASSETS_APP_KEY] = {
                key: (0, $3ePvn.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                // make sure assets is below jsm
                label: (0, $9oc6O.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $cozmU.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $cozmU.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType_0 })=>$0a5e899f2d5517f1$var$checkShouldRemoveJWM(productType_0));
        });
        items.forEach((item_0)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl_0, displayName: displayName_0, org: org } = item_0;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product_0)=>{
                const { url: productUrl_0 } = product_0;
                let { productType: productType_1 } = product_0;
                const isExcludeJiraBusiness = productType_1 === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType_1 = 'JIRA_SOFTWARE';
                if (!products[productType_1]) products[productType_1] = [];
                if (!isExcludeJiraBusiness) products[productType_1].push({
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    displayName: displayName_0,
                    url: getProductLinkForItem(productType_1, siteUrl_0, productUrl_0),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $iFf4X.sortArraysInObject)(products, (a, b)=>{
            return (0, $9oc6O.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}
module.exports["useProductLinks"] = $0a5e899f2d5517f1$export$79322ba781a26ce1;

});

parcelRegister("iFf4X", function(module, exports) {
function $d7684f9e0b21a4d6$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}
module.exports["sortArraysInObject"] = $d7684f9e0b21a4d6$export$3e8bbf689f8e6cad;

});

parcelRegister("9oc6O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $78d7c3a0068f3aa2$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), text);
};
const $78d7c3a0068f3aa2$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $78d7c3a0068f3aa2$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};
module.exports["formatText"] = $78d7c3a0068f3aa2$export$905fe28a7c283e1d;
module.exports["sortAlphabetically"] = $78d7c3a0068f3aa2$export$60f5d4abb43a14b3;

});

parcelRegister("2be25", function(module, exports) {
const $4162cd98cfbbb9d0$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };
module.exports["productLinksWorkspaceCloudIdFilter"] = $4162cd98cfbbb9d0$export$54a1da5292674ec8;

});

parcelRegister("jHtN7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $17592f56d6d8f4dd$var$styles = {
    root: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67"
}; /**
    * The bottom part of the side nav.
    */ 
const $17592f56d6d8f4dd$export$b773c4c9cf740fbe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, xcss: xcss } = t0;
    let t1;
    if ($[0] !== xcss) {
        t1 = (0, $hekY6.default)([
            $17592f56d6d8f4dd$var$styles.root,
            xcss
        ]);
        $[0] = xcss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $17592f56d6d8f4dd$var$styles.root,
            xcss
        ])
    }, children);
};
module.exports["SideNavFooter"] = $17592f56d6d8f4dd$export$b773c4c9cf740fbe;

});

parcelRegister("kynDG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $15dbae337da11376$var$styles = {
    root: "_2Y7lL48HPE _46hvQm8HPE _0xmtko1Y8M"
}; /**
    * The top part of the side nav.
    */ 
const $15dbae337da11376$export$9d28ff3a0d89869c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $15dbae337da11376$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $15dbae337da11376$var$styles.root
        ])
    }, children);
};
module.exports["SideNavHeader"] = $15dbae337da11376$export$9d28ff3a0d89869c;

});

parcelRegister("jYwSK", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $gP8zs = parcelRequire("gP8zs");

module.exports = Object.assign({}, $gP8zs, {
    SideNavContent: $gP8zs.SideNavBody
});
if ($gP8zs.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("gP8zs", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("eCqXP")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("kynDG")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("4oUV5")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("jHtN7")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("dtHQ4")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("6NDDH")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("aFvBm")).useExpandSideNav);
$parcel$export(module.exports, "useSideNavRef", () => (parcelRequire("1gX7M")).useSideNavRef);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("5Pqwh")).SideNavPanelSplitter);

var $eCqXP = parcelRequire("eCqXP");


var $kynDG = parcelRequire("kynDG");


var $4oUV5 = parcelRequire("4oUV5");


var $jHtN7 = parcelRequire("jHtN7");


var $dtHQ4 = parcelRequire("dtHQ4");


var $6NDDH = parcelRequire("6NDDH");


var $aFvBm = parcelRequire("aFvBm");


var $1gX7M = parcelRequire("1gX7M");


var $5Pqwh = parcelRequire("5Pqwh");


});

parcelRegister("dtHQ4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9DHhW = parcelRequire("9DHhW");


var $gzlgs = parcelRequire("gzlgs");


var $1pYOd = parcelRequire("1pYOd");


var $kgGsB = parcelRequire("kgGsB");


var $1fHIr = parcelRequire("1fHIr");


var $bZTfQ = parcelRequire("bZTfQ");


var $lu8mP = parcelRequire("lu8mP");


var $8CGNp = parcelRequire("8CGNp");


var $5rNCB = parcelRequire("5rNCB");


var $d8d8E = parcelRequire("d8d8E");


var $gjVTm = parcelRequire("gjVTm");


var $6NDDH = parcelRequire("6NDDH");

const $ee8db6bac2a63753$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
}; // For duplicate "mouseenter" issue when changing icons (see below)
const $ee8db6bac2a63753$var$silentIconStyles = null; /**
                                * __SideNavToggleButton__
                                *
                                * Button for toggling the side nav. It should be used in the top bar.
                                */ 
const $ee8db6bac2a63753$export$8bd77667631fec25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { defaultCollapsed: t1, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick } = t0;
    const defaultCollapsed = t1 === undefined ? false : t1;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    let t2;
    if ($[0] !== defaultCollapsed) {
        t2 = {
            defaultCollapsed: defaultCollapsed
        };
        $[0] = defaultCollapsed;
        $[1] = t2;
    } else t2 = $[1];
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $gjVTm.useSideNavVisibility)(t2);
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $cozmU.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $cozmU.useContext)((0, $lu8mP.SideNavToggleButtonAttachRef));
    const [element, setElement] = (0, $cozmU.useState)(null);
    let t3;
    let t4;
    if ($[2] !== element || $[3] !== ref) {
        t3 = ()=>{
            ref(element);
        };
        t4 = [
            element,
            ref
        ];
        $[2] = element;
        $[3] = ref;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[6] !== isSideNavExpandedOnDesktop || $[7] !== isSideNavExpandedOnMobile) {
        t5 = ()=>{
            const { matches: matches } = window.matchMedia("(min-width: 64rem)");
            setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
        };
        t6 = [
            isSideNavExpandedOnDesktop,
            isSideNavExpandedOnMobile
        ];
        $[6] = isSideNavExpandedOnDesktop;
        $[7] = isSideNavExpandedOnMobile;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[10] !== isSideNavExpandedOnDesktop || $[11] !== isSideNavExpandedOnMobile) {
        t7 = ()=>{
            const mediaQueryList = window.matchMedia("(min-width: 64rem)");
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener () {
                    setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
                }
            });
        };
        t8 = [
            isSideNavExpandedOnDesktop,
            isSideNavExpandedOnMobile
        ];
        $[10] = isSideNavExpandedOnDesktop;
        $[11] = isSideNavExpandedOnMobile;
        $[12] = t7;
        $[13] = t8;
    } else {
        t7 = $[12];
        t8 = $[13];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            trigger: "toggle-button"
        };
        $[14] = t9;
    } else t9 = $[14];
    const toggleVisibility = (0, $6NDDH.useToggleSideNav)(t9);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    let t10;
    if ($[15] !== isFhsEnabled || $[16] !== isSideNavExpanded || $[17] !== onClick || $[18] !== openLayerObserver || $[19] !== toggleVisibility) {
        t10 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent, {
                isSideNavVisible: isSideNavExpanded
            });
            toggleVisibility();
            if (isFhsEnabled) openLayerObserver?.closeLayers();
        };
        $[15] = isFhsEnabled;
        $[16] = isSideNavExpanded;
        $[17] = onClick;
        $[18] = openLayerObserver;
        $[19] = toggleVisibility;
        $[20] = t10;
    } else t10 = $[20];
    const handleClick = t10;
    let t11;
    if ($[21] !== createAnalyticsEvent || $[22] !== isSideNavExpanded) {
        t11 = ()=>{
            const isDesktop = window.matchMedia("(min-width: 64rem)").matches;
            if (!isDesktop) return;
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: "topNav",
                actionSubject: "sideNav",
                action: "hovered",
                actionSubjectId: "sideNavButton",
                attributes: {
                    itemState: isSideNavExpanded ? "expanded" : "collapsed",
                    screen: "desktop"
                }
            });
            navigationAnalyticsEvent.fire("navigation");
        };
        $[21] = createAnalyticsEvent;
        $[22] = isSideNavExpanded;
        $[23] = t11;
    } else t11 = $[23];
    const handlePointerEnter = t11;
    let t12;
    if ($[24] !== isSideNavExpanded) {
        t12 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbcK7c _1pp6NdYbGa"
                ])
            }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gzlgs))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pYOd))), props));
        $[24] = isSideNavExpanded;
        $[25] = t12;
    } else t12 = $[25];
    const icon = t12;
    const isShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    let t13;
    bb0: {
        if (isFhsEnabled) {
            const t14 = isShortcutEnabled ? (0, $8CGNp.sideNavToggleTooltipKeyboardShortcut) : undefined;
            let t15;
            if ($[26] !== t14) {
                t15 = {
                    ...$ee8db6bac2a63753$var$toggleButtonTooltipOptions,
                    shortcut: t14
                };
                $[26] = t14;
                $[27] = t15;
            } else t15 = $[27];
            t13 = t15;
            break bb0;
        }
        t13 = $ee8db6bac2a63753$var$toggleButtonTooltipOptions;
    }
    const tooltipProps = t13;
    const t14 = isSideNavExpanded ? collapseLabel : expandLabel;
    let t15;
    if ($[28] !== handleClick || $[29] !== handlePointerEnter || $[30] !== icon || $[31] !== interactionName || $[32] !== t14 || $[33] !== testId || $[34] !== tooltipProps) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
            appearance: "subtle",
            label: t14,
            icon: icon,
            onClick: handleClick,
            onPointerEnter: handlePointerEnter,
            testId: testId,
            isTooltipDisabled: false,
            interactionName: interactionName,
            ref: setElement,
            tooltip: tooltipProps
        });
        $[28] = handleClick;
        $[29] = handlePointerEnter;
        $[30] = icon;
        $[31] = interactionName;
        $[32] = t14;
        $[33] = testId;
        $[34] = tooltipProps;
        $[35] = t15;
    } else t15 = $[35];
    return t15;
} : ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $gjVTm.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState)); // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $cozmU.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $cozmU.useContext)((0, $lu8mP.SideNavToggleButtonAttachRef)); /**
                                                         * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
                                                         *
                                                         * My theory is that something to do with SSR, hydration and suspense was causing the
                                                         * underlying HTML element to change but without causing the toggle button to remount.
                                                         *
                                                         * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
                                                         */ 
    const [element, setElement] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $cozmU.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $cozmU.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $6NDDH.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        if (isFhsEnabled) openLayerObserver?.closeLayers();
    }, [
        isFhsEnabled,
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $cozmU.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]); /**
                                                  * ## Behaviour
                                                  * It is intentional that collapse icon will be used while the flyout is open.
                                                  * The icon is tied to the expanded / collapse state, and not the flyout state.
                                                  *
                                                  * ## Why a function?
                                                  * Unfortunately, changing the icon inside an <IconButton> when the user is over
                                                  * the button will cause the svg element to be replaced, which can trigger a
                                                  * "mouseenter" event. This is problematic when the user is already over the button,
                                                  * as it can result in a "mouseenter" event after the user manually entered the button.
                                                  *
                                                  * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
                                                  * memoize it, or pull it out into a new function
                                                  */ 
    const icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbcK7c _1pp6NdYbGa"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gzlgs))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pYOd))), props));
    const isShortcutEnabled = (0, $d8d8E.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $cozmU.useMemo)(()=>{
        if (isFhsEnabled) return {
            ...$ee8db6bac2a63753$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $8CGNp.sideNavToggleTooltipKeyboardShortcut) : undefined
        };
        return $ee8db6bac2a63753$var$toggleButtonTooltipOptions;
    }, [
        isFhsEnabled,
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};
module.exports["SideNavToggleButton"] = $ee8db6bac2a63753$export$8bd77667631fec25;

});

parcelRegister("bZTfQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $6cyWf = parcelRequire("6cyWf");


var $hemOQ = parcelRequire("hemOQ");

const $0f0eeda6a04bd532$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $hemOQ.ThemedIconButton) : (0, $1sCHt.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $hemOQ.ThemedIconButton) : (0, $1sCHt.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["IconButton"] = $0f0eeda6a04bd532$export$c25acd513dcc8062;

});

parcelRegister("hemOQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $aXMFs = parcelRequire("aXMFs");


var $5dijw = parcelRequire("5dijw");

const $1521ff7d48cd2b50$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedIconButton(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let Icon;
    let label;
    let props;
    let tooltip;
    if ($[0] !== t0) {
        ({ icon: Icon, label: label, tooltip: tooltip, ...props } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = label;
        $[3] = props;
        $[4] = tooltip;
    } else {
        Icon = $[1];
        label = $[2];
        props = $[3];
        tooltip = $[4];
    }
    const t1 = tooltip?.content ?? label;
    let t2;
    if ($[5] !== Icon || $[6] !== label || $[7] !== props || $[8] !== ref) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e_0)=>{
                    triggerProps.onMouseOut?.(e_0);
                    props.onMouseOut?.(e_0);
                },
                onMouseMove: (e_1)=>{
                    triggerProps.onMouseMove?.(e_1);
                    props.onMouseMove?.(e_1);
                },
                onMouseDown: (e_2)=>{
                    triggerProps.onMouseDown?.(e_2);
                    props.onMouseDown?.(e_2);
                },
                onFocus: (e_3)=>{
                    triggerProps.onFocus?.(e_3);
                    props.onFocus?.(e_3);
                },
                onBlur: (e_4)=>{
                    triggerProps.onBlur?.(e_4);
                    props.onBlur?.(e_4);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
                icon: Icon
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label));
        $[5] = Icon;
        $[6] = label;
        $[7] = props;
        $[8] = ref;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2 || $[12] !== tooltip) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            ...tooltip,
            content: t1
        }, t2);
        $[10] = t1;
        $[11] = t2;
        $[12] = tooltip;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
            ...props,
            shape: "square",
            ref: (0, $lmzCg.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                props.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                props.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                props.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                props.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                props.onBlur?.(e_4);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
            icon: Icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label)));
});
module.exports["ThemedIconButton"] = $1521ff7d48cd2b50$export$d9c2d067feb61447;

});

parcelRegister("lu8mP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $50234bf2386dee1f$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["SideNavToggleButtonAttachRef"] = $50234bf2386dee1f$export$fb8fa9a80240785e;

});

parcelRegister("5Pqwh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $kgGsB = parcelRequire("kgGsB");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $6NDDH = parcelRequire("6NDDH");


var $eoCwK = parcelRequire("eoCwK");


var $jsuJ9 = parcelRequire("jsuJ9");


var $kdCH7 = parcelRequire("kdCH7");

/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $07b49ae768269ee7$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $liCgE.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $liCgE.openLayerObserverTopNavStartNamespace),
    (0, $liCgE.openLayerObserverTopNavMiddleNamespace),
    (0, $liCgE.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ const $07b49ae768269ee7$var$useHasOpenPopupsInSideNavOrTopNav = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasOpenPopupsInSideNavOrTopNav() {
    const $ = (0, $bDgLe.c)(4);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    const [hasOpenPopups, setHasOpenPopups] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== isFhsEnabled || $[1] !== openLayerObserver) {
        t0 = ()=>{
            if (!openLayerObserver || !isFhsEnabled) return;
            const updateState = function updateState() {
                if (!openLayerObserver) return;
                const hasAnyOpenLayers = $07b49ae768269ee7$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                        namespace: namespace,
                        type: "popup"
                    }) > 0);
                setHasOpenPopups(hasAnyOpenLayers);
            };
            updateState();
            const cleanups = $07b49ae768269ee7$var$openLayerNamespacesToCheck.map((namespace_0)=>openLayerObserver.onChange(updateState, {
                    namespace: namespace_0
                }));
            return function cleanupHook() {
                cleanups.forEach($07b49ae768269ee7$var$_temp);
            };
        };
        t1 = [
            isFhsEnabled,
            openLayerObserver
        ];
        $[0] = isFhsEnabled;
        $[1] = openLayerObserver;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return hasOpenPopups;
} : function useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const openLayerObserver = (0, $kgGsB.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $07b49ae768269ee7$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $07b49ae768269ee7$var$openLayerNamespacesToCheck.map((namespace_0)=>openLayerObserver.onChange(updateState, {
                namespace: namespace_0
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
};
function $07b49ae768269ee7$var$_temp(cleanup) {
    return cleanup();
}
const $07b49ae768269ee7$export$5f595addf4e50d58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: t1, tooltipContent: tooltipContent } = t0;
    const shouldCollapseOnDoubleClick = t1 === undefined ? true : t1;
    const context = (0, $cozmU.useContext)((0, $kdCH7.PanelSplitterContext));
    (0, $bB0i2.default)(context?.panelId === (0, $liCgE.sideNavPanelSplitterId), "SideNavPanelSplitter must be rendered as a child of <SideNav />.");
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            trigger: "double-click"
        };
        $[0] = t2;
    } else t2 = $[0];
    const toggleSideNav = (0, $6NDDH.useToggleSideNav)(t2);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const hasOpenLayersInSideNavOrTopNav = $07b49ae768269ee7$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    const t3 = shouldCollapseOnDoubleClick ? toggleSideNav : undefined;
    const t4 = shouldCollapseOnDoubleClick ? tooltipContent : undefined;
    let t5;
    if ($[1] !== label || $[2] !== onResizeEnd || $[3] !== onResizeStart || $[4] !== t4 || $[5] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: t4
        });
        $[1] = label;
        $[2] = onResizeEnd;
        $[3] = onResizeStart;
        $[4] = t4;
        $[5] = testId;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t3 || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eoCwK.OnDoubleClickContext).Provider, {
            value: t3
        }, t5);
        $[7] = t3;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $cozmU.useContext)((0, $kdCH7.PanelSplitterContext));
    (0, $bB0i2.default)(context?.panelId === (0, $liCgE.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $6NDDH.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $07b49ae768269ee7$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eoCwK.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
        // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
        shouldCollapseOnDoubleClick ? tooltipContent : undefined
    }));
};
module.exports["SideNavPanelSplitter"] = $07b49ae768269ee7$export$5f595addf4e50d58;

});

parcelRegister("1PREo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8AWCX = parcelRequire("8AWCX");

const $46d0283d8d2da690$var$styles = {
    root: "_0jFU0V8HPE"
}; /**
    * Use this component to create visual separation between the:
    *
    * - global app shortcut section
    * - 'more' button menu item
    * - starred spaces (in Confluence)
    *
    * Only use this component in the top level of the menu,
    * and exercise caution when using it in new situations.
    *
    * This component exists to fulfil product design requirements but has not yet
    * been consolidated into the wider navigation system.
    *
    * It may not exist in the future when global apps are no longer in the side navigation.
    */ 
const $46d0283d8d2da690$export$5776f68925982056 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopLevelSpacer() {
    const $ = (0, $bDgLe.c)(4);
    const level = (0, $8AWCX.useLevel)();
    let t0;
    let t1;
    if ($[0] !== level) {
        t0 = ()=>{};
        t1 = [
            level
        ];
        $[0] = level;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $46d0283d8d2da690$var$styles.root
            ])
        });
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TopLevelSpacer() {
    const level = (0, $8AWCX.useLevel)();
    (0, $cozmU.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $46d0283d8d2da690$var$styles.root
        ])
    });
};
module.exports["TopLevelSpacer"] = $46d0283d8d2da690$export$5776f68925982056;

});

parcelRegister("1FFRr", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $79D42 = parcelRequire("79D42");


var $gGzL7 = parcelRequire("gGzL7");


var $jG16D = parcelRequire("jG16D");

/** Used as the size to enable large array optimizations. */ var $137a177bdcb6c988$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $137a177bdcb6c988$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $gqaVn, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $79D42(values, $gGzL7(iteratee));
    if (comparator) {
        includes = $3wyDU;
        isCommon = false;
    } else if (values.length >= $137a177bdcb6c988$var$LARGE_ARRAY_SIZE) {
        includes = $jG16D;
        isCommon = false;
        values = new $dLza3(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $137a177bdcb6c988$var$baseDifference;

});

parcelRegister("gq8Du", function(module, exports) {
const $3f8db0f27a859e4a$export$72b069d0875dccc = {
    MENU: 'L1MenuGroup',
    SHORTCUTS: 'L1ShortcutsGroup'
};
module.exports["L1_MENU_GROUPS"] = $3f8db0f27a859e4a$export$72b069d0875dccc;

});

parcelRegister("pl8ng", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");

// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $12af1507b626ad3d$var$MORE_MENU_ID = Symbol('moreMenuId');
function $12af1507b626ad3d$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $12af1507b626ad3d$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($12af1507b626ad3d$var$MORE_MENU_ID);
    }
    return {
        getL1ItemElement: getL1ItemElement,
        getMoreMenuElement: getMoreMenuElement,
        registerL1Item: registerL1Item,
        registerMoreMenuItem: registerMoreMenuItem
    };
}
const $12af1507b626ad3d$var$ElementRegistryContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $12af1507b626ad3d$export$ce0cc6a5e9b6a71a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ElementRegistryProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, registry: registry } = t0;
    let t1;
    if ($[0] !== children || $[1] !== registry) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12af1507b626ad3d$var$ElementRegistryContext.Provider, {
            value: registry
        }, children);
        $[0] = children;
        $[1] = registry;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ElementRegistryProvider({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12af1507b626ad3d$var$ElementRegistryContext.Provider, {
        value: registry
    }, children);
};
const $12af1507b626ad3d$export$9a176103b34f9da9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useElementRegistry() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($12af1507b626ad3d$var$ElementRegistryContext);
    (0, $bB0i2.default)(elementRegistry, "useElementRegistry must be used within an ElementRegistryProvider");
    return elementRegistry;
} : function useElementRegistry() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($12af1507b626ad3d$var$ElementRegistryContext);
    (0, $bB0i2.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
};
module.exports["createElementRegistry"] = $12af1507b626ad3d$export$b8d30beb0c187a7;
module.exports["ElementRegistryProvider"] = $12af1507b626ad3d$export$ce0cc6a5e9b6a71a;
module.exports["useElementRegistry"] = $12af1507b626ad3d$export$9a176103b34f9da9;

});

parcelRegister("g6KTr", function(module, exports) {

var $cchFE = parcelRequire("cchFE");

let $2b230915474122a8$var$node = null;
const $2b230915474122a8$var$size = '1px';
const $2b230915474122a8$var$visuallyHiddenStyles = {
    // Standard visually hidden styles.
    // Copied from our VisuallyHidden (react) package.
    width: $2b230915474122a8$var$size,
    height: $2b230915474122a8$var$size,
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: `rect(${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // Pulling upwards slightly to prevent the page
    // from growing when appended to a body that contains
    // an element with height:100%
    marginTop: `-${$2b230915474122a8$var$size}`,
    // Just being safe and letting this element not interfere with hitboxes
    pointerEvents: 'none'
};
/**
 * Creates a live region node, appends it to the body, and returns it.
 */ function $2b230915474122a8$var$createNode() {
    const node = document.createElement('div');
    /**
   * Using `role="status"` instead of `role="alert"` so that the message
   * can be queued and read when able.
   *
   * We found with `role="alert"` the message was not reliably read when
   * focus changed.
   */ node.setAttribute('role', 'status');
    Object.assign(node.style, $2b230915474122a8$var$visuallyHiddenStyles);
    document.body.append(node);
    return node;
}
/**
 * Returns the live region node, creating one if necessary.
 */ function $2b230915474122a8$var$getNode() {
    if ($2b230915474122a8$var$node === null) $2b230915474122a8$var$node = $2b230915474122a8$var$createNode();
    return $2b230915474122a8$var$node;
}
let $2b230915474122a8$var$timerId = null;
function $2b230915474122a8$var$tryClearTimer() {
    if ($2b230915474122a8$var$timerId !== null) clearTimeout($2b230915474122a8$var$timerId);
    $2b230915474122a8$var$timerId = null;
}
function $2b230915474122a8$export$a9b970dcc4ae71a9(message) {
    /**
   * Calling this immediately to ensure a node exists and has time to be parsed
   * and exposed in the accessibility tree.
   */ $2b230915474122a8$var$getNode();
    /**
   * Updating the message in a timeout so that it's less likely to be interrupted.
   *
   * This function is often called right before focus changes,
   * because the user has just taken an action.
   * This focus change would often cause the message to be skipped / interrupted.
   */ $2b230915474122a8$var$tryClearTimer();
    $2b230915474122a8$var$timerId = setTimeout(()=>{
        $2b230915474122a8$var$timerId = null;
        const node = $2b230915474122a8$var$getNode();
        node.textContent = message;
    }, (0, $cchFE.announceDelay));
    return;
}
function $2b230915474122a8$export$de863c629cb9919d() {
    $2b230915474122a8$var$tryClearTimer();
    $2b230915474122a8$var$node?.remove();
    $2b230915474122a8$var$node = null;
}
module.exports["announce"] = $2b230915474122a8$export$a9b970dcc4ae71a9;
module.exports["cleanup"] = $2b230915474122a8$export$de863c629cb9919d;

});

parcelRegister("cchFE", function(module, exports) {
/**
 * Delay until the text content of the live region is updated.
 *
 * This value was reached through some experimentation, and may need tweaking in the future.
 */ const $714f0bc45b620f55$export$a88f30567ea7367a = 1000;
module.exports["announceDelay"] = $714f0bc45b620f55$export$a88f30567ea7367a;

});

parcelRegister("6ZNK7", function(module, exports) {
const $56362c6cc63b01d8$var$l1ItemKey = Symbol('l1ItemKey');
const $56362c6cc63b01d8$var$nestedItemKey = Symbol('nestedItemKey');
const $56362c6cc63b01d8$var$moreMenuKey = Symbol('moreMenuKey');
const $56362c6cc63b01d8$export$a1dfda61267432e5 = (data)=>({
        ...data,
        type: 'menu-item',
        [$56362c6cc63b01d8$var$l1ItemKey]: true
    });
const $56362c6cc63b01d8$export$e9f7c92759d0f281 = (data)=>({
        ...data
    });
const $56362c6cc63b01d8$export$e52c346726a16591 = (data)=>{
    return data[$56362c6cc63b01d8$var$l1ItemKey] === true;
};
const $56362c6cc63b01d8$export$9d9fcc463b545806 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $56362c6cc63b01d8$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $56362c6cc63b01d8$export$e74f096ffe08821d() {
    return {
        menuItemId: $56362c6cc63b01d8$export$7960450fbf5a0a72,
        [$56362c6cc63b01d8$var$moreMenuKey]: true
    };
}
function $56362c6cc63b01d8$export$e37de48254c6595e(data) {
    return data[$56362c6cc63b01d8$var$moreMenuKey] === true;
}
const $56362c6cc63b01d8$export$fe7d1a1bab9e2488 = (data)=>({
        ...data,
        type: 'menu-item',
        [$56362c6cc63b01d8$var$nestedItemKey]: true
    });
const $56362c6cc63b01d8$export$db162439b96bd9a8 = (data)=>{
    return {
        ...data,
        [$56362c6cc63b01d8$var$nestedItemKey]: true
    };
};
const $56362c6cc63b01d8$export$23cae75a8064fbc1 = (data)=>{
    return data[$56362c6cc63b01d8$var$nestedItemKey] === true;
};
const $56362c6cc63b01d8$export$a3f9aca82641b845 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $56362c6cc63b01d8$export$98ff4de2f070152d = {
    MOVE_TO_TOP: 'MOVE_TO_TOP',
    MOVE_UP: 'MOVE_UP',
    MOVE_DOWN: 'MOVE_DOWN',
    MOVE_TO_BOTTOM: 'MOVE_TO_BOTTOM',
    BEFORE: 'reorder-before',
    AFTER: 'reorder-after'
};
module.exports["createL1ItemData"] = $56362c6cc63b01d8$export$a1dfda61267432e5;
module.exports["getL1ItemData"] = $56362c6cc63b01d8$export$e9f7c92759d0f281;
module.exports["isL1ItemData"] = $56362c6cc63b01d8$export$e52c346726a16591;
module.exports["isL1ItemDataInGroup"] = $56362c6cc63b01d8$export$9d9fcc463b545806;
module.exports["getMoreMenuData"] = $56362c6cc63b01d8$export$e74f096ffe08821d;
module.exports["isMoreMenuData"] = $56362c6cc63b01d8$export$e37de48254c6595e;

});

parcelRegister("91jNq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $5Dlqn = parcelRequire("5Dlqn");


var $6iJ3v = parcelRequire("6iJ3v");


var $InD31 = parcelRequire("InD31");


var $h11I1 = parcelRequire("h11I1");


var $1TBPy = parcelRequire("1TBPy");

const $a83ddc93d6b30790$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(24);
    const { children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: t1, onOpenChange: onOpenChange } = t0;
    const isDefaultOpen = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDefaultOpen) {
        t2 = ()=>isDefaultOpen;
        $[0] = isDefaultOpen;
        $[1] = t2;
    } else t2 = $[1];
    const [isOpen, setIsOpen] = (0, $5Dlqn.default)(isOpenControlled, t2);
    const titleId = (0, $cozmU.useId)();
    const previousIsOpen = (0, $6iJ3v.default)(isOpen);
    const onCloseRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOpen || $[4] !== onOpenChange || $[5] !== previousIsOpen) {
        t3 = ()=>{
            if (previousIsOpen === undefined || previousIsOpen === isOpen) return;
            if (isOpen && previousIsOpen === false) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: "sideNav",
                    actionSubject: "flyoutMenu",
                    action: "opened"
                });
                navigationAnalyticsEvent.fire("navigation");
            }
            onOpenChange?.(isOpen);
        };
        t4 = [
            isOpen,
            onOpenChange,
            previousIsOpen,
            createAnalyticsEvent
        ];
        $[2] = createAnalyticsEvent;
        $[3] = isOpen;
        $[4] = onOpenChange;
        $[5] = previousIsOpen;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] !== children || $[9] !== id || $[10] !== isOpen) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $InD31.Popup), {
            id: id,
            isOpen: isOpen,
            role: "dialog"
        }, children);
        $[8] = children;
        $[9] = id;
        $[10] = isOpen;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== forwardedRef || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
            ref: forwardedRef
        }, t5);
        $[12] = forwardedRef;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t6 || $[16] !== titleId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.OnCloseContext).Provider, {
            value: onCloseRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.TitleIdContextProvider), {
            value: titleId
        }, t6));
        $[15] = t6;
        $[16] = titleId;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== setIsOpen || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.SetIsOpenContext).Provider, {
            value: setIsOpen
        }, t7);
        $[18] = setIsOpen;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== isOpen || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.IsOpenContext).Provider, {
            value: isOpen
        }, t8);
        $[21] = isOpen;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
} : ({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $5Dlqn.default)(isOpenControlled, ()=>isDefaultOpen);
    const titleId = (0, $cozmU.useId)();
    const previousIsOpen = (0, $6iJ3v.default)(isOpen);
    const onCloseRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        // When flyout menu is opened, fire analytics event
        if (isOpen && previousIsOpen === false) {
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: 'sideNav',
                actionSubject: 'flyoutMenu',
                action: 'opened'
            });
            navigationAnalyticsEvent.fire('navigation');
        }
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.IsOpenContext).Provider, {
        value: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.SetIsOpenContext).Provider, {
        value: setIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.OnCloseContext).Provider, {
        value: onCloseRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.TitleIdContextProvider), {
        value: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        ref: forwardedRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $InD31.Popup), {
        id: id,
        isOpen: isOpen,
        role: "dialog"
    }, children))))));
});
module.exports["FlyoutMenuItem"] = $a83ddc93d6b30790$export$34e3b4eaa687835;

});

parcelRegister("InD31", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $iDrrr = parcelRequire("iDrrr");


var $akErP = parcelRequire("akErP");


var $dpUmv = parcelRequire("dpUmv");


var $hj0rK = parcelRequire("hj0rK");


var $iKSY4 = parcelRequire("iKSY4");


var $dY7Kg = parcelRequire("dY7Kg");


var $EZmp0 = parcelRequire("EZmp0");


var $a9KY5 = parcelRequire("a9KY5");


var $7tDc6 = parcelRequire("7tDc6");

const $bac0d0bd018ab01d$export$129a32eedafa97c5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, id: providedId, isOpen: t1, role: role } = t0;
    const isOpen = t1 === undefined ? false : t1;
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    const triggerRefObject = (0, $cozmU.useRef)(null);
    const generatedId = (0, $6JrSr.useId)();
    const id = providedId || generatedId;
    let t2;
    if ($[0] !== children) {
        t2 = (0, $iDrrr.fg)("platform-dst-top-layer") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7tDc6.TriggerRefObjectContext).Provider, {
            value: triggerRefObject
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, children);
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== isOpen || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $EZmp0.SetTriggerRefContext).Provider, {
            value: setTriggerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSY4.IsOpenContext).Provider, {
            value: isOpen
        }, t2));
        $[2] = isOpen;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3 || $[6] !== triggerRef) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9KY5.TriggerRefContext).Provider, {
            value: triggerRef
        }, t3);
        $[5] = t3;
        $[6] = triggerRef;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== id || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hj0rK.EnsureIsInsidePopupContext).Provider, {
            value: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dpUmv.IdContext).Provider, {
            value: id
        }, t4));
        $[8] = id;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== role || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dY7Kg.RoleContext).Provider, {
            value: role
        }, t5);
        $[11] = role;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ children: children, id: providedId, isOpen: isOpen = false, role: role })=>{
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    // When the top-layer flag is on, we maintain a stable RefObject for the
    // trigger element, provided through TriggerRefObjectContext. Unlike the
    // state-based triggerRef (which causes a re-render when the trigger mounts),
    // this ref has a stable identity so useAnchorPosition's useLayoutEffect dep
    // array never changes — the effect runs once on mount when the trigger element
    // is already populated. PopupTrigger sets this ref directly instead of calling
    // the state setter, avoiding an unnecessary re-render.
    const triggerRefObject = (0, $cozmU.useRef)(null);
    const generatedId = (0, $6JrSr.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dY7Kg.RoleContext).Provider, {
        value: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hj0rK.EnsureIsInsidePopupContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dpUmv.IdContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9KY5.TriggerRefContext).Provider, {
        value: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $EZmp0.SetTriggerRefContext).Provider, {
        value: setTriggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSY4.IsOpenContext).Provider, {
        value: isOpen
    }, (0, $iDrrr.fg)('platform-dst-top-layer') ? // Skip Popper's <Manager> when Top Layer is being used.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7tDc6.TriggerRefObjectContext).Provider, {
        value: triggerRefObject
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, children)))))));
};
module.exports["Popup"] = $bac0d0bd018ab01d$export$129a32eedafa97c5;

});

parcelRegister("dpUmv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9e651d72fc8dd188$export$26537912ea160acd = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["IdContext"] = $9e651d72fc8dd188$export$26537912ea160acd;

});

parcelRegister("hj0rK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f499b3e197d95cf$export$2d7d3979eeceb992 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["EnsureIsInsidePopupContext"] = $1f499b3e197d95cf$export$2d7d3979eeceb992;

});

parcelRegister("iKSY4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $3b144472abeb9c2f$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["IsOpenContext"] = $3b144472abeb9c2f$export$efa4d9670e96ac31;

});

parcelRegister("dY7Kg", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $1c6b30c4b798fcf7$export$a8c52551eddf6b9 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["RoleContext"] = $1c6b30c4b798fcf7$export$a8c52551eddf6b9;

});

parcelRegister("EZmp0", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $693c50194f3dcf5f$export$85b81def7d2cbc37 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["SetTriggerRefContext"] = $693c50194f3dcf5f$export$85b81def7d2cbc37;

});

parcelRegister("a9KY5", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $32cab1fd0861be84$export$53ee23205ed2541e = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TriggerRefContext"] = $32cab1fd0861be84$export$53ee23205ed2541e;

});

parcelRegister("7tDc6", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $4afa9584bc62943e$export$37438ea5f80ca91e = /*#__PURE__*/ (0, $cozmU.createContext)({
    current: null
});
module.exports["TriggerRefObjectContext"] = $4afa9584bc62943e$export$37438ea5f80ca91e;

});

parcelRegister("cVdZm", function(module, exports) {
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $lmzCg = parcelRequire("lmzCg");


var $iDrrr = parcelRequire("iDrrr");


var $QodSn = parcelRequire("QodSn");


var $1TBPy = parcelRequire("1TBPy");

const $b8cce1e6327914dc$var$FLYOUT_MENU_VERTICAL_OFFSET_PX = 26; /**
                                            * The maximum height of the flyout menu in pixels, following the Confluence standard maximum
                                            * height of 760px.
                                            */ 
const $b8cce1e6327914dc$var$FLYOUT_MENU_MAX_HEIGHT_PX = 760;
const $b8cce1e6327914dc$var$FLYOUT_MENU_PADDING = "var(--ds-space-100, 8px)"; /**
                                                         * The margin around the flyout menu popup when it has its modal appearance on mobile screen sizes.
                                                         */ 
const $b8cce1e6327914dc$var$FLYOUT_MENU_MODAL_MARGIN = 4;
const $b8cce1e6327914dc$var$maxHeightCssVar = '--max-height';
const $b8cce1e6327914dc$var$flyoutMenuItemContentStyles = {
    root: "_46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _2EWYUbHakr"
};
const $b8cce1e6327914dc$var$flyoutMenuItemContentContainerStyles = {
    container: "_3iDTPbQ4SZ _0jFU0VN91d _0aFT5vbt8w _0NUa3rsyJk _3FSaCfi2Tb"
};
const $b8cce1e6327914dc$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus, maxHeight: maxHeight = $b8cce1e6327914dc$var$FLYOUT_MENU_MAX_HEIGHT_PX }, forwardedRef)=>{
    const setIsOpen = (0, $cozmU.useContext)((0, $1TBPy.SetIsOpenContext));
    const onCloseRef = (0, $cozmU.useContext)((0, $1TBPy.OnCloseContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)(); // The source of the close is not accessible to the consumer, it is determined within the
    // handleClose function, or passed in as a parameter in FlyoutMenuItemTrigger (outside-click),
    // or FlyoutHeader (close-button).
    const handleClose = (0, $cozmU.useCallback)((event, source)=>{
        // Use the passed source if provided, otherwise determine from event
        let determinedSource = source || 'other';
        if (!source) {
            if (event instanceof KeyboardEvent) {
                const keyboardEvent = event;
                if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') determinedSource = 'escape-key';
            } else if (event instanceof MouseEvent) {
                if (event && 'type' in event && event.type === 'click') determinedSource = 'outside-click';
            }
        } // When flyout menu is closed, fire analytics event
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'sideNav',
            actionSubject: 'flyoutMenu',
            action: 'closed',
            attributes: {
                closeSource: determinedSource
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose,
        createAnalyticsEvent
    ]); // Register handleClose in the ref to allow the FlyoutMenuItemTrigger to access it
    (0, $cozmU.useEffect)(()=>{
        onCloseRef.current = handleClose;
    }, [
        handleClose,
        onCloseRef
    ]);
    const titleId = (0, $1TBPy.useTitleId)();
    const computedMaxHeight = (0, $cozmU.useMemo)(()=>/**
   * The max height of the flyout menu needs to factor in the top nav and banner, as it will be layered
   * beneath them and would otherwise be clipped.
   *
   * We can remove these navigation variables once layering has been addressed holistically (e.g. using Top Layer).
   *
   * Not using the UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY variable from `@atlaskit/navigation-system`
   * to avoid a circular dependency, as that package imports this one for re-exporting components.
   */ `min(calc(100vh - ${$b8cce1e6327914dc$var$FLYOUT_MENU_VERTICAL_OFFSET_PX}px - var(--n_tNvM, 0px) - var(--n_bnrM, 0px)), ${maxHeight}px)`, [
        maxHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QodSn.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: true,
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $b8cce1e6327914dc$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        role: "dialog",
        titleId: (0, $iDrrr.fg)('navx-5180-flyout-dialog-aria-label') ? titleId : undefined,
        shouldDisableGpuAcceleration: true,
        shouldRenderToParent: true
    }, ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8cce1e6327914dc$var$UpdatePopperOnContentResize, {
            ref: forwardedRef,
            update: update
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.TitleIdContextProvider), {
            value: titleId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                [$b8cce1e6327914dc$var$maxHeightCssVar]: computedMaxHeight
            },
            "data-testid": containerTestId ? `${containerTestId}--container` : undefined,
            className: (0, $hekY6.default)([
                $b8cce1e6327914dc$var$flyoutMenuItemContentContainerStyles.container
            ])
        }, children))));
});
function $b8cce1e6327914dc$var$createResizeObserver(update) {
    return new ResizeObserver(update);
} /**
   * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
   * This is the size of the scroll container, NOT the scroll content.
   *
   * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
   * reasons to keep it scoped to flyout menus for now:
   *
   * 1. It's easier to unwind
   * 2. We've only had bug reports for flyout menus
   * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
   * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
   */ 
const $b8cce1e6327914dc$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $cozmU.useRef)(update);
    (0, $cozmU.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]); /**
                 * Stable function that calls the latest `update` function by calling it through the stable ref.
                 */ 
    const triggerUpdate = (0, $cozmU.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $cozmU.useState)(()=>$b8cce1e6327914dc$var$createResizeObserver(triggerUpdate)); /**
                                                                                 * This is a callback ref that will update which `HTMLElement` we are observing,
                                                                                 * if or when the underlying `HTMLElement` changes or unmounts.
                                                                                 */ 
    const observeCallbackRef = (0, $cozmU.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]); /**
                         * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
                         *
                         * This stems from ResizeObserver firing once after calling `.observe()` even if there
                         * was no resize.
                         *
                         * Without memoizing the ref, the update causes a rerender, which causes the ref to
                         * get recreated, which triggers an update and so on in a loop.
                         */ 
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref
    }, children);
});
module.exports["FlyoutMenuItemContent"] = $b8cce1e6327914dc$export$2ca9a13c57a8839a;

});

parcelRegister("QodSn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1ZDKy = parcelRequire("1ZDKy");


var $5Tdig = parcelRequire("5Tdig");


var $iDrrr = parcelRequire("iDrrr");


var $cK21K = parcelRequire("cK21K");


var $lVRRo = parcelRequire("lVRRo");


var $bzkge = parcelRequire("bzkge");


var $dpUmv = parcelRequire("dpUmv");


var $iKSY4 = parcelRequire("iKSY4");


var $gC8BK = parcelRequire("gC8BK");


var $a9KY5 = parcelRequire("a9KY5");


var $2HzLc = parcelRequire("2HzLc");

const $802cf4f8c4db792b$var$defaultLayer = 400;
const $802cf4f8c4db792b$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
/**
 * Legacy (Popper + Portal) implementation of the compositional PopupContent.
 *
 * Renders when the `platform-dst-top-layer` flag is off. This component owns
 * the open layer observer registration, which on the top-layer path is handled
 * by the `Popover` primitive inside `PopupContentTopLayer` instead.
 */ const $802cf4f8c4db792b$var$PopupContentLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PopupContentLegacy(t0) {
    const $ = (0, $bDgLe.c)(38);
    const { xcss: xcss, appearance: t1, children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: t2, shouldFlip: t3, placement: t4, fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: t5, zIndex: t6, shouldUseCaptureOnOutsideClick: t7, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: t8, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: t9, role: role, titleId: titleId, isOpen: isOpen, id: id } = t0;
    const inAppearance = t1 === undefined ? "default" : t1;
    const rootBoundary = t2 === undefined ? "viewport" : t2;
    const shouldFlip = t3 === undefined ? true : t3;
    const placement = t4 === undefined ? "auto" : t4;
    const autoFocus = t5 === undefined ? true : t5;
    const zIndex = t6 === undefined ? $802cf4f8c4db792b$var$defaultLayer : t6;
    const shouldUseCaptureOnOutsideClick = t7 === undefined ? false : t7;
    const shouldDisableFocusLock = t8 === undefined ? false : t8;
    const shouldDisableGpuAcceleration = t9 === undefined ? false : t9;
    const triggerRef = (0, $cozmU.useContext)((0, $a9KY5.TriggerRefContext));
    let t10;
    if ($[0] !== inAppearance || $[1] !== inShouldRenderToParent) {
        t10 = {
            appearance: inAppearance,
            shouldRenderToParent: inShouldRenderToParent
        };
        $[0] = inAppearance;
        $[1] = inShouldRenderToParent;
        $[2] = t10;
    } else t10 = $[2];
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $bzkge.usePopupAppearance)(t10);
    let t11;
    if ($[3] !== onClose) {
        t11 = ()=>{
            onClose?.(null);
        };
        $[3] = onClose;
        $[4] = t11;
    } else t11 = $[4];
    const handleOpenLayerObserverCloseSignal = t11;
    let t12;
    if ($[5] !== handleOpenLayerObserverCloseSignal || $[6] !== isOpen) {
        t12 = {
            isOpen: isOpen,
            onClose: handleOpenLayerObserverCloseSignal,
            type: "popup"
        };
        $[5] = handleOpenLayerObserverCloseSignal;
        $[6] = isOpen;
        $[7] = t12;
    } else t12 = $[7];
    (0, $5Tdig.useNotifyOpenLayerObserver)(t12);
    if (!isOpen) return null;
    const t13 = shouldDisableGpuAcceleration ? $802cf4f8c4db792b$var$shouldDisableGpuAccelerationModifiers : undefined;
    let t14;
    if ($[8] !== appearance || $[9] !== autoFocus || $[10] !== boundary || $[11] !== children || $[12] !== fallbackPlacements || $[13] !== id || $[14] !== isOpen || $[15] !== offset || $[16] !== onClose || $[17] !== placement || $[18] !== popupComponent || $[19] !== role || $[20] !== rootBoundary || $[21] !== shouldDisableFocusLock || $[22] !== shouldFitContainer || $[23] !== shouldFitViewport || $[24] !== shouldFlip || $[25] !== shouldIgnoreCloseEvent || $[26] !== shouldRenderToParent || $[27] !== shouldUseCaptureOnOutsideClick || $[28] !== strategy || $[29] !== t13 || $[30] !== testId || $[31] !== titleId || $[32] !== triggerRef || $[33] !== xcss) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ZDKy.Layering), {
            isDisabled: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lVRRo.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: t13,
            role: role,
            titleId: titleId
        }));
        $[8] = appearance;
        $[9] = autoFocus;
        $[10] = boundary;
        $[11] = children;
        $[12] = fallbackPlacements;
        $[13] = id;
        $[14] = isOpen;
        $[15] = offset;
        $[16] = onClose;
        $[17] = placement;
        $[18] = popupComponent;
        $[19] = role;
        $[20] = rootBoundary;
        $[21] = shouldDisableFocusLock;
        $[22] = shouldFitContainer;
        $[23] = shouldFitViewport;
        $[24] = shouldFlip;
        $[25] = shouldIgnoreCloseEvent;
        $[26] = shouldRenderToParent;
        $[27] = shouldUseCaptureOnOutsideClick;
        $[28] = strategy;
        $[29] = t13;
        $[30] = testId;
        $[31] = titleId;
        $[32] = triggerRef;
        $[33] = xcss;
        $[34] = t14;
    } else t14 = $[34];
    const popperWrapper = t14;
    if (shouldRenderToParent) return popperWrapper;
    let t15;
    if ($[35] !== popperWrapper || $[36] !== zIndex) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: zIndex
        }, popperWrapper);
        $[35] = popperWrapper;
        $[36] = zIndex;
        $[37] = t15;
    } else t15 = $[37];
    return t15;
} : function PopupContentLegacy({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $802cf4f8c4db792b$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false, role: role, titleId: titleId, isOpen: isOpen, id: id }) {
    const triggerRef = (0, $cozmU.useContext)((0, $a9KY5.TriggerRefContext));
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $bzkge.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $cozmU.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ZDKy.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lVRRo.default), {
        xcss: xcss,
        appearance: appearance,
        content: children,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: popupComponent,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldFitContainer: shouldFitContainer,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        modifiers: shouldDisableGpuAcceleration ? $802cf4f8c4db792b$var$shouldDisableGpuAccelerationModifiers : undefined,
        role: role,
        titleId: titleId
    }));
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: zIndex
    }, popperWrapper);
};
const $802cf4f8c4db792b$export$2a2c7ba12d3231e3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PopupContent(props) {
    const $ = (0, $bDgLe.c)(8);
    (0, $2HzLc.useEnsureIsInsidePopup)();
    const isOpen = (0, $cozmU.useContext)((0, $iKSY4.IsOpenContext));
    const id = (0, $cozmU.useContext)((0, $dpUmv.IdContext));
    if ((0, $iDrrr.fg)("platform-dst-top-layer")) {
        let t0;
        if ($[0] !== id || $[1] !== isOpen || $[2] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gC8BK.PopupContentTopLayer), {
                ...props,
                isOpen: isOpen,
                id: id
            });
            $[0] = id;
            $[1] = isOpen;
            $[2] = props;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    let t0;
    if ($[4] !== id || $[5] !== isOpen || $[6] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($802cf4f8c4db792b$var$PopupContentLegacy, {
            ...props,
            isOpen: isOpen,
            id: id
        });
        $[4] = id;
        $[5] = isOpen;
        $[6] = props;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : function PopupContent(props) {
    (0, $2HzLc.useEnsureIsInsidePopup)();
    const isOpen = (0, $cozmU.useContext)((0, $iKSY4.IsOpenContext));
    const id = (0, $cozmU.useContext)((0, $dpUmv.IdContext));
    // Select the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks, so a runtime feature-flag change swaps component types (a clean
    // remount) instead of changing the hook order of a mounted component.
    //
    // Forwarding the full props onto the chosen implementation is intentional:
    // both implementations declare explicit prop types, so the forward is type
    // checked rather than an unbounded API.
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) // The top-layer Popover registers with the open layer observer itself.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- intentional forward to a typed implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gC8BK.PopupContentTopLayer), {
        ...props,
        isOpen: isOpen,
        id: id
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- intentional forward to a typed implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($802cf4f8c4db792b$var$PopupContentLegacy, {
        ...props,
        isOpen: isOpen,
        id: id
    });
};
module.exports["PopupContent"] = $802cf4f8c4db792b$export$2a2c7ba12d3231e3;

});

parcelRegister("gC8BK", function(module, exports) {
/* popup-content-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $dpsRj = parcelRequire("dpsRj");


var $aRDbl = parcelRequire("aRDbl");


var $2uGA5 = parcelRequire("2uGA5");

var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");


var $hPK4E = parcelRequire("hPK4E");


var $KvoGn = parcelRequire("KvoGn");


var $7tDc6 = parcelRequire("7tDc6");

const $0fb6df9fc708ed8d$var$overflowAutoStyles = null; // Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $0fb6df9fc708ed8d$var$EMPTY_STYLE = {}; /**
                                        * Top-layer implementation of the compositional PopupContent.
                                        *
                                        * Reads isOpen, id, triggerRef from the legacy compositional Popup context,
                                        * then renders via @atlaskit/top-layer's Popup compound.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
function $0fb6df9fc708ed8d$export$a126ab411f00d484({ xcss: xcss, children: children, offset: offsetProp, onClose: onClose, testId: testId, placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, role: role, label: label, titleId: titleId, isOpen: isOpen, id: providedId, // ── No-op props ──
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, // top-layer: shouldFlip handled by CSS position-try fallbacks.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldFlip: _shouldFlip, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance, // top-layer: GPU acceleration is not applicable.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableGpuAcceleration: _shouldDisableGpuAcceleration }) {
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy compositional `PopupContent` surfaced
   * `setInitialFocusRef` on the content children render prop with a
   * `Dispatch<SetStateAction<HTMLElement | null>>` signature so it
   * could be passed as a React `ref` callback. We keep the same shape
   * for API compatibility, but store the value in a ref rather than
   * component state. Flipping state on every open caused a needless
   * re-render and, more importantly, raced the initial-focus effect
   * below. The ref is read in the open-side effect to override the
   * role-based default focus chosen by `useInitialFocus` inside the
   * underlying `Popover`.
   */ const consumerInitialFocusRef = (0, $cozmU.useRef)(null);
    const setInitialFocusRef = (0, $cozmU.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []); // Placement conversion
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape.
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]); // ── onClose bridge ──
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: reason })=>{
        if (!onClose) return;
        onClose((0, $2uGA5.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]); // ── Content render-prop bridge ──
    const contentProps = (0, $cozmU.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $dpsRj.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]); // ── Role mapping ──
    const roleProps = (0, $KvoGn.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const popoverRef = (0, $cozmU.useRef)(null);
    const anchorRef = (0, $cozmU.useContext)((0, $7tDc6.TriggerRefObjectContext)); /**
                                                          * Override the role-based initial focus chosen by the underlying
                                                          * `Popover` (its internal `useInitialFocus`).
                                                          *
                                                          * React flushes child effects before parent effects, so by the time
                                                          * this effect runs the role-based default focus has already moved.
                                                          * We then apply the legacy `Popup` contract:
                                                          *
                                                          * 1. If the consumer wired `setInitialFocusRef`, focus that element
                                                          *    (escape hatch wins).
                                                          * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
                                                          *    The `autoFocus` prop on `Popup` opts out of any initial-focus
                                                          *    movement, even for roles like `dialog`.
                                                          *
                                                          * When neither applies the role-based default from the underlying
                                                          * `Popover` stays in place.
                                                          */ 
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            const trigger = anchorRef?.current ?? null;
            if (trigger && trigger.isConnected) trigger.focus();
        }
    }, [
        isOpen,
        autoFocus,
        anchorRef
    ]); // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    (0, $hPK4E.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'match-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: anchorRef,
        isOpen: isOpen
    }); // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    return /*#__PURE__*/ $cozmU.createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        ...roleProps,
        isOpen: isOpen,
        shouldAnimate: true,
        placement: topLayerPlacement,
        onClose: handleOnClose,
        testId: testId && `${testId}--content`
    }, Container ? /*#__PURE__*/ $cozmU.createElement(Container, {
        style: $0fb6df9fc708ed8d$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss
    }, children(contentProps)) : /*#__PURE__*/ $cozmU.createElement((0, $juXYb.PopoverSurface), null, /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            shouldFitViewport && "_4bt5LAIZbP _2WAcuGIZbP",
            (0, $hekY6.default)([
                xcss
            ])
        ])
    }, children(contentProps))));
}
module.exports["PopupContentTopLayer"] = $0fb6df9fc708ed8d$export$a126ab411f00d484;

});

parcelRegister("2HzLc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $hj0rK = parcelRequire("hj0rK");

const $318a1d6f64917d1a$export$421fc1dbb5b2c905 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useEnsureIsInsidePopup() {
    const context = (0, $cozmU.useContext)((0, $hj0rK.EnsureIsInsidePopupContext));
    (0, $bB0i2.default)(context, "PopupTrigger and PopupContent components must be used within a Popup");
} : function useEnsureIsInsidePopup() {
    const context = (0, $cozmU.useContext)((0, $hj0rK.EnsureIsInsidePopupContext));
    (0, $bB0i2.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
module.exports["useEnsureIsInsidePopup"] = $318a1d6f64917d1a$export$421fc1dbb5b2c905;

});

parcelRegister("9aB3o", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $aDSIl = parcelRequire("aDSIl");


var $cwlZp = parcelRequire("cwlZp");


var $KuePV = parcelRequire("KuePV");


var $1TBPy = parcelRequire("1TBPy");

const $e2116a94027fcdfd$var$elemAfterStyles = {
    root: "_2Y7lL4gVvo _4lYzgRyz1h"
};
const $e2116a94027fcdfd$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const isOpen = (0, $cozmU.useContext)((0, $1TBPy.IsOpenContext));
    const onCloseRef = (0, $cozmU.useContext)((0, $1TBPy.OnCloseContext));
    let t1;
    if ($[0] !== isOpen || $[1] !== onClick || $[2] !== onCloseRef) {
        t1 = (event, analyticsEvent)=>{
            if (isOpen && onCloseRef.current) onCloseRef.current(event, "outside-click");
            onClick?.(event, analyticsEvent);
        };
        $[0] = isOpen;
        $[1] = onClick;
        $[2] = onCloseRef;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== children || $[5] !== dropIndicator || $[6] !== elemBefore || $[7] !== forwardedRef || $[8] !== handleClick || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDragging || $[13] !== isSelected || $[14] !== testId || $[15] !== visualContentRef) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $cwlZp.PopupTrigger), null, (t3)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = t3;
            return /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
                testId: testId,
                ref: (0, $lmzCg.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        $e2116a94027fcdfd$var$elemAfterStyles.root
                    ])
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "currentColor",
                    size: "small"
                })),
                onClick: handleClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator
            }, children);
        });
        $[4] = children;
        $[5] = dropIndicator;
        $[6] = elemBefore;
        $[7] = forwardedRef;
        $[8] = handleClick;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDragging;
        $[13] = isSelected;
        $[14] = testId;
        $[15] = visualContentRef;
        $[16] = t2;
    } else t2 = $[16];
    return t2;
} : ({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const isOpen = (0, $cozmU.useContext)((0, $1TBPy.IsOpenContext));
    const onCloseRef = (0, $cozmU.useContext)((0, $1TBPy.OnCloseContext));
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (isOpen && onCloseRef.current) onCloseRef.current(event, 'outside-click');
        onClick?.(event, analyticsEvent);
    }, [
        isOpen,
        onCloseRef,
        onClick
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cwlZp.PopupTrigger), null, ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            ref: (0, $lmzCg.default)([
                ref,
                forwardedRef
            ]),
            visualContentRef: visualContentRef,
            elemBefore: elemBefore,
            elemAfter: /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $e2116a94027fcdfd$var$elemAfterStyles.root
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                label: "",
                color: "currentColor",
                size: "small"
            })),
            onClick: handleClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isSelected: isSelected,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children));
});
module.exports["FlyoutMenuItemTrigger"] = $e2116a94027fcdfd$export$9f59f399fe37b6ca;

});

parcelRegister("cwlZp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $kN1yU = parcelRequire("kN1yU");


var $dfu3d = parcelRequire("dfu3d");


var $dpUmv = parcelRequire("dpUmv");


var $iKSY4 = parcelRequire("iKSY4");


var $dY7Kg = parcelRequire("dY7Kg");


var $EZmp0 = parcelRequire("EZmp0");


var $7tDc6 = parcelRequire("7tDc6");


var $2HzLc = parcelRequire("2HzLc");

const $aa081c2f921263f0$export$95d4acdbab2fc6ef = ({ children: children })=>{
    (0, $2HzLc.useEnsureIsInsidePopup)();
    const id = (0, $cozmU.useContext)((0, $dpUmv.IdContext));
    const setTriggerRef = (0, $cozmU.useContext)((0, $EZmp0.SetTriggerRefContext));
    const triggerRefObject = (0, $cozmU.useContext)((0, $7tDc6.TriggerRefObjectContext));
    const isOpen = (0, $cozmU.useContext)((0, $iKSY4.IsOpenContext));
    const getMergedTriggerRef = (0, $dfu3d.useGetMemoizedMergedTriggerRefNew)();
    const role = (0, $cozmU.useContext)((0, $dY7Kg.RoleContext));
    // Stable ref callback — avoids creating a new function instance on every render,
    // which would cause React to detach and reattach the ref unnecessarily.
    // triggerRefObject is a MutableRefObject (from useRef) so its identity never changes,
    // meaning this callback is effectively created once per mount.
    const triggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRefObject.current = node;
    }, [
        triggerRefObject
    ]);
    const ariaHasPopup = role === 'dialog' ? 'dialog' : true;
    // When the top-layer flag is on, bypass Popper's <Reference> entirely.
    // We only need to set triggerRefObject.current — no Popper ref merging needed.
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        ref: triggerRef,
        'aria-controls': id,
        'aria-expanded': isOpen,
        'aria-haspopup': ariaHasPopup
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kN1yU.Reference), null, ({ ref: ref })=>children({
            ref: getMergedTriggerRef(ref, setTriggerRef),
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': ariaHasPopup
        }));
};
module.exports["PopupTrigger"] = $aa081c2f921263f0$export$95d4acdbab2fc6ef;

});

parcelRegister("igMdc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ZNK7 = parcelRequire("6ZNK7");


var $inECq = parcelRequire("inECq");

const $d62f75864882af78$export$f8cda0f87a8e0691 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useL1ItemDragAndDrop(t0) {
    const $ = (0, $bDgLe.c)(29);
    const { item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group } = t0;
    const t1 = item.isHideable !== false;
    const t2 = item.isReorderable !== false;
    let t3;
    if ($[0] !== group || $[1] !== id || $[2] !== item.label || $[3] !== t1 || $[4] !== t2) {
        t3 = (0, $6ZNK7.createL1ItemData)({
            menuItemId: id,
            group: group,
            isHidden: false,
            isHideable: t1,
            label: item.label,
            isReorderable: t2
        });
        $[0] = group;
        $[1] = id;
        $[2] = item.label;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const data = t3;
    let t4;
    if ($[6] !== item.isDraggable || $[7] !== item.isHideable || $[8] !== item.isReorderable || $[9] !== item.type || $[10] !== l1DragAndDropEnabled || $[11] !== peek) {
        t4 = ()=>!!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== "custom" || !!item.isDraggable);
        $[6] = item.isDraggable;
        $[7] = item.isHideable;
        $[8] = item.isReorderable;
        $[9] = item.type;
        $[10] = l1DragAndDropEnabled;
        $[11] = peek;
        $[12] = t4;
    } else t4 = $[12];
    const isItemDraggable = t4;
    let t5;
    if ($[13] !== item.isDraggable || $[14] !== item.type || $[15] !== l1DragAndDropEnabled || $[16] !== peek) {
        t5 = ()=>!!l1DragAndDropEnabled && !peek && (item.type !== "custom" || !!item.isDraggable);
        $[13] = item.isDraggable;
        $[14] = item.type;
        $[15] = l1DragAndDropEnabled;
        $[16] = peek;
        $[17] = t5;
    } else t5 = $[17];
    const isItemDroppable = t5;
    let t6;
    if ($[18] !== data || $[19] !== group || $[20] !== id || $[21] !== isExpandOrFlyoutOpen || $[22] !== isExpandable || $[23] !== isItemDraggable || $[24] !== isItemDroppable || $[25] !== item || $[26] !== l1DragAndDropEnabled || $[27] !== onExpandFlyoutToggle) {
        t6 = {
            data: data,
            getItemData: (0, $6ZNK7.getL1ItemData),
            group: group,
            id: id,
            item: item,
            isDragAndDropEnabled: l1DragAndDropEnabled,
            isExpandable: isExpandable,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            isItemData: (0, $6ZNK7.isL1ItemData),
            isItemDataInGroup: (0, $6ZNK7.isL1ItemDataInGroup),
            isItemDraggable: isItemDraggable,
            isItemDroppable: isItemDroppable,
            onExpandFlyoutToggle: onExpandFlyoutToggle
        };
        $[18] = data;
        $[19] = group;
        $[20] = id;
        $[21] = isExpandOrFlyoutOpen;
        $[22] = isExpandable;
        $[23] = isItemDraggable;
        $[24] = isItemDroppable;
        $[25] = item;
        $[26] = l1DragAndDropEnabled;
        $[27] = onExpandFlyoutToggle;
        $[28] = t6;
    } else t6 = $[28];
    return (0, $inECq.useItemDragAndDrop)(t6);
} : function useL1ItemDragAndDrop({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group }) {
    const data = (0, $cozmU.useMemo)(()=>(0, $6ZNK7.createL1ItemData)({
            menuItemId: id,
            group: group,
            isHidden: false,
            isHideable: item.isHideable !== false,
            label: item.label,
            isReorderable: item.isReorderable !== false
        }), [
        group,
        id,
        item.isHideable,
        item.isReorderable,
        item.label
    ]);
    const isItemDraggable = (0, $cozmU.useCallback)(()=>{
        return !!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== 'custom' || !!item.isDraggable);
    }, [
        item.isDraggable,
        item.isHideable,
        item.isReorderable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    const isItemDroppable = (0, $cozmU.useCallback)(()=>!!l1DragAndDropEnabled && !peek && (item.type !== 'custom' || !!item.isDraggable), [
        item.isDraggable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    return (0, $inECq.useItemDragAndDrop)({
        data: data,
        getItemData: (0, $6ZNK7.getL1ItemData),
        group: group,
        id: id,
        item: item,
        isDragAndDropEnabled: l1DragAndDropEnabled,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        isItemData: (0, $6ZNK7.isL1ItemData),
        isItemDataInGroup: (0, $6ZNK7.isL1ItemDataInGroup),
        isItemDraggable: isItemDraggable,
        isItemDroppable: isItemDroppable,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    });
};
module.exports["useL1ItemDragAndDrop"] = $d62f75864882af78$export$f8cda0f87a8e0691;

});

parcelRegister("inECq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iY6Oi = parcelRequire("iY6Oi");


var $pl8ng = parcelRequire("pl8ng");


var $kEQ10 = parcelRequire("kEQ10");

const $4201c0da7c132263$export$4696d1da23170d9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useItemDragAndDrop(props) {
    const $ = (0, $bDgLe.c)(62);
    const { data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData } = props;
    let t0;
    if ($[0] !== data || $[1] !== isDragAndDropEnabled || $[2] !== isItemDraggable) {
        t0 = isItemDraggable?.(data) ?? !!isDragAndDropEnabled;
        $[0] = data;
        $[1] = isDragAndDropEnabled;
        $[2] = isItemDraggable;
        $[3] = t0;
    } else t0 = $[3];
    const itemIsDraggable = t0;
    let t1;
    if ($[4] !== data || $[5] !== isDragAndDropEnabled || $[6] !== isItemDroppable) {
        t1 = isItemDroppable?.(data) ?? !!isDragAndDropEnabled;
        $[4] = data;
        $[5] = isDragAndDropEnabled;
        $[6] = isItemDroppable;
        $[7] = t1;
    } else t1 = $[7];
    const itemIsDroppable = t1;
    let t2;
    if ($[8] !== data || $[9] !== getItemData || $[10] !== group || $[11] !== id) {
        t2 = ()=>getItemData({
                ...data,
                menuItemId: id,
                group: group
            });
        $[8] = data;
        $[9] = getItemData;
        $[10] = group;
        $[11] = id;
        $[12] = t2;
    } else t2 = $[12];
    const getInitialData = t2;
    let t3;
    if ($[13] !== data?.label || $[14] !== item) {
        t3 = ()=>({
                elemBefore: (0, $kEQ10.getElemBeforeForItem)(item),
                content: (0, $kEQ10.getDragPreviewContentForItem)(item, data?.label)
            });
        $[13] = data?.label;
        $[14] = item;
        $[15] = t3;
    } else t3 = $[15];
    data?.label;
    const getDragPreviewPieces = t3;
    let t4;
    if ($[16] !== data || $[17] !== isDragAndDropEnabled || $[18] !== isItemDraggable) {
        t4 = ()=>isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled;
        $[16] = data;
        $[17] = isDragAndDropEnabled;
        $[18] = isItemDraggable;
        $[19] = t4;
    } else t4 = $[19];
    const canDrag = t4;
    let t5;
    if ($[20] !== data || $[21] !== getItemData || $[22] !== id) {
        t5 = (args)=>{
            const { source: source } = args;
            return getItemData({
                ...data,
                menuItemId: id,
                group: source?.data?.group
            });
        };
        $[20] = data;
        $[21] = getItemData;
        $[22] = id;
        $[23] = t5;
    } else t5 = $[23];
    const getData = t5;
    let t6;
    if ($[24] !== itemIsDraggable) {
        t6 = ()=>({
                "reorder-before": itemIsDraggable ? "available" : undefined,
                "reorder-after": "available"
            });
        $[24] = itemIsDraggable;
        $[25] = t6;
    } else t6 = $[25];
    const getOperations = t6;
    let t7;
    if ($[26] !== group || $[27] !== id || $[28] !== isItemData || $[29] !== isItemDataInGroup) {
        t7 = (args_0)=>{
            const { source: source_0 } = args_0;
            return isItemData(source_0.data) && source_0.data.menuItemId !== id && isItemDataInGroup(source_0.data, group);
        };
        $[26] = group;
        $[27] = id;
        $[28] = isItemData;
        $[29] = isItemDataInGroup;
        $[30] = t7;
    } else t7 = $[30];
    const canDrop = t7;
    let t8;
    bb0: {
        if (isDragAndDropEnabled && itemIsDraggable) {
            let t9;
            if ($[31] !== canDrag || $[32] !== getDragPreviewPieces || $[33] !== getInitialData) {
                t9 = {
                    canDrag: canDrag,
                    getInitialData: getInitialData,
                    getDragPreviewPieces: getDragPreviewPieces
                };
                $[31] = canDrag;
                $[32] = getDragPreviewPieces;
                $[33] = getInitialData;
                $[34] = t9;
            } else t9 = $[34];
            t8 = t9;
            break bb0;
        }
        t8 = undefined;
    }
    const draggable = t8;
    let t9;
    bb1: {
        if (isDragAndDropEnabled && itemIsDroppable) {
            let t10;
            if ($[35] !== canDrop || $[36] !== getData || $[37] !== getOperations) {
                t10 = {
                    canDrop: canDrop,
                    getData: getData,
                    getOperations: getOperations
                };
                $[35] = canDrop;
                $[36] = getData;
                $[37] = getOperations;
                $[38] = t10;
            } else t10 = $[38];
            t9 = t10;
            break bb1;
        }
        t9 = undefined;
    }
    const dropTarget = t9;
    let t10;
    if ($[39] !== draggable || $[40] !== dropTarget) {
        t10 = {
            draggable: draggable,
            dropTarget: dropTarget
        };
        $[39] = draggable;
        $[40] = dropTarget;
        $[41] = t10;
    } else t10 = $[41];
    const memoizedHookProps = t10;
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $iY6Oi.useMenuItemDragAndDrop)(memoizedHookProps);
    const registry = (0, $pl8ng.useElementRegistry)();
    const registrationRef = (0, $cozmU.useRef)(null);
    let t11;
    if ($[42] !== draggableAnchorRef || $[43] !== draggableButtonRef || $[44] !== id || $[45] !== registry) {
        t11 = (element)=>{
            if (!element) {
                registrationRef.current?.();
                registrationRef.current = null;
                draggableAnchorRef.current = null;
                draggableButtonRef.current = null;
                return;
            }
            if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
            else draggableButtonRef.current = element;
            if (registrationRef.current) registrationRef.current();
            registrationRef.current = registry.registerL1Item({
                id: id,
                element: element
            });
        };
        $[42] = draggableAnchorRef;
        $[43] = draggableButtonRef;
        $[44] = id;
        $[45] = registry;
        $[46] = t11;
    } else t11 = $[46];
    const draggableRef = t11;
    const isDragging = !!itemIsDraggable && dragState.type === "dragging";
    const expandableClosedForDrag = (0, $cozmU.useRef)(false);
    let t12;
    let t13;
    if ($[47] !== isDragging || $[48] !== isExpandOrFlyoutOpen || $[49] !== isExpandable || $[50] !== itemIsDraggable || $[51] !== onExpandFlyoutToggle) {
        t12 = ()=>{
            if (!isExpandable || !itemIsDraggable) return;
            if (isDragging && isExpandOrFlyoutOpen) {
                onExpandFlyoutToggle(false);
                expandableClosedForDrag.current = true;
            } else if (!isDragging && expandableClosedForDrag.current) {
                onExpandFlyoutToggle(true);
                expandableClosedForDrag.current = false;
            }
        };
        t13 = [
            isDragging,
            isExpandable,
            isExpandOrFlyoutOpen,
            itemIsDraggable,
            expandableClosedForDrag,
            onExpandFlyoutToggle
        ];
        $[47] = isDragging;
        $[48] = isExpandOrFlyoutOpen;
        $[49] = isExpandable;
        $[50] = itemIsDraggable;
        $[51] = onExpandFlyoutToggle;
        $[52] = t12;
        $[53] = t13;
    } else {
        t12 = $[52];
        t13 = $[53];
    }
    (0, $cozmU.useLayoutEffect)(t12, t13);
    const t14 = itemIsDraggable ? draggableRef : undefined;
    const t15 = itemIsDroppable ? dropTargetRef : undefined;
    const t16 = itemIsDroppable ? dropIndicator : undefined;
    const t17 = itemIsDraggable ? dragPreview : null;
    let t18;
    if ($[54] !== isDragging || $[55] !== itemIsDraggable || $[56] !== itemIsDroppable || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17) {
        t18 = {
            draggableRef: t14,
            isItemDraggable: itemIsDraggable,
            isItemDroppable: itemIsDroppable,
            isDragging: isDragging,
            dropTargetRef: t15,
            dropIndicator: t16,
            maybeDragPreview: t17
        };
        $[54] = isDragging;
        $[55] = itemIsDraggable;
        $[56] = itemIsDroppable;
        $[57] = t14;
        $[58] = t15;
        $[59] = t16;
        $[60] = t17;
        $[61] = t18;
    } else t18 = $[61];
    return t18;
} : function useItemDragAndDrop(props) {
    const { data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData } = props;
    const itemIsDraggable = isItemDraggable?.(data) ?? !!isDragAndDropEnabled;
    const itemIsDroppable = isItemDroppable?.(data) ?? !!isDragAndDropEnabled;
    const getInitialData = (0, $cozmU.useCallback)(()=>getItemData({
            ...data,
            menuItemId: id,
            group: group
        }), [
        data,
        getItemData,
        group,
        id
    ]);
    const getDragPreviewPieces = (0, $cozmU.useCallback)(()=>({
            elemBefore: (0, $kEQ10.getElemBeforeForItem)(item),
            content: (0, $kEQ10.getDragPreviewContentForItem)(item, data?.label)
        }), [
        data?.label,
        item
    ]);
    const canDrag = (0, $cozmU.useCallback)(()=>isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled, [
        data,
        isDragAndDropEnabled,
        isItemDraggable
    ]);
    const getData = (0, $cozmU.useCallback)((args)=>{
        const { source: source } = args;
        return getItemData({
            ...data,
            menuItemId: id,
            group: source?.data?.group
        });
    }, [
        data,
        getItemData,
        id
    ]);
    const getOperations = (0, $cozmU.useCallback)(()=>({
            'reorder-before': itemIsDraggable ? 'available' : undefined,
            'reorder-after': 'available'
        }), [
        itemIsDraggable
    ]);
    const canDrop = (0, $cozmU.useCallback)((args_0)=>{
        const { source: source_0 } = args_0;
        return isItemData(source_0.data) && source_0.data.menuItemId !== id && isItemDataInGroup(source_0.data, group);
    }, [
        group,
        id,
        isItemData,
        isItemDataInGroup
    ]);
    const draggable = (0, $cozmU.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDraggable) return {
            canDrag: canDrag,
            getInitialData: getInitialData,
            getDragPreviewPieces: getDragPreviewPieces
        };
    }, [
        canDrag,
        getInitialData,
        getDragPreviewPieces,
        isDragAndDropEnabled,
        itemIsDraggable
    ]);
    const dropTarget = (0, $cozmU.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDroppable) return {
            canDrop: canDrop,
            getData: getData,
            getOperations: getOperations
        };
    }, [
        canDrop,
        getData,
        getOperations,
        isDragAndDropEnabled,
        itemIsDroppable
    ]);
    const memoizedHookProps = (0, $cozmU.useMemo)(()=>({
            draggable: draggable,
            dropTarget: dropTarget
        }), [
        draggable,
        dropTarget
    ]);
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $iY6Oi.useMenuItemDragAndDrop)(memoizedHookProps);
    const registry = (0, $pl8ng.useElementRegistry)();
    const registrationRef = (0, $cozmU.useRef)(null);
    const draggableRef = (0, $cozmU.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        if (registrationRef.current) registrationRef.current();
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = !!itemIsDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, $cozmU.useRef)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isExpandable || !itemIsDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            onExpandFlyoutToggle(false);
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        itemIsDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return (0, $cozmU.useMemo)(()=>({
            draggableRef: itemIsDraggable ? draggableRef : undefined,
            isItemDraggable: itemIsDraggable,
            isItemDroppable: itemIsDroppable,
            isDragging: isDragging,
            dropTargetRef: itemIsDroppable ? dropTargetRef : undefined,
            dropIndicator: itemIsDroppable ? dropIndicator : undefined,
            maybeDragPreview: itemIsDraggable ? dragPreview : null
        }), [
        draggableRef,
        dragPreview,
        dropIndicator,
        dropTargetRef,
        isDragging,
        itemIsDraggable,
        itemIsDroppable
    ]);
};
module.exports["useItemDragAndDrop"] = $4201c0da7c132263$export$4696d1da23170d9a;

});

parcelRegister("iY6Oi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $iSrRp = parcelRequire("iSrRp");

parcelRequire("fYWmN");
var $1bRPL = parcelRequire("1bRPL");

parcelRequire("cDMxg");
var $deUyp = parcelRequire("deUyp");


var $8wghk = parcelRequire("8wghk");


var $8h0nV = parcelRequire("8h0nV");


var $htuV6 = parcelRequire("htuV6");

const $238e7fcc46931eb1$var$idle = {
    type: 'idle'
};
const $238e7fcc46931eb1$export$fe281fdb09fbf0c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMenuItemDragAndDrop(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { draggable: draggableArgs, dropTarget: dropTargetArgs } = t0;
    const draggableAnchorRef = (0, $cozmU.useRef)(null);
    const draggableButtonRef = (0, $cozmU.useRef)(null);
    const dropTargetRef = (0, $cozmU.useRef)(null);
    const [internalState, setInternalState] = (0, $cozmU.useState)($238e7fcc46931eb1$var$idle);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
        $[0] = t1;
    } else t1 = $[0];
    const getDraggableElement = t1;
    let t2;
    let t3;
    if ($[1] !== draggableArgs) {
        t2 = ()=>{
            if (!draggableArgs) return;
            const element = getDraggableElement();
            if (!element) return;
            return (0, $iSrRp.draggable)({
                element: element,
                getInitialData: draggableArgs.getInitialData,
                canDrag: draggableArgs.canDrag,
                onGenerateDragPreview (t4) {
                    const { nativeSetDragImage: nativeSetDragImage, source: source, location: location } = t4;
                    (0, $deUyp.setCustomNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage,
                        getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                            x: "var(--ds-space-200, 16px)",
                            y: "var(--ds-space-100, 8px)"
                        }),
                        render (t5) {
                            const { container: container } = t5;
                            const args = {
                                dragHandle: source.dragHandle,
                                element: source.element,
                                input: location.current.input
                            };
                            setInternalState({
                                type: "preview",
                                container: container,
                                ui: draggableArgs.getDragPreviewPieces(args)
                            });
                        }
                    });
                },
                onDragStart () {
                    setInternalState({
                        type: "dragging"
                    });
                },
                onDrop () {
                    setInternalState($238e7fcc46931eb1$var$idle);
                }
            });
        };
        t3 = [
            draggableArgs,
            getDraggableElement
        ];
        $[1] = draggableArgs;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[4] !== dropTargetArgs) {
        t4 = ()=>{
            if (!dropTargetArgs) return;
            const draggableElement = getDraggableElement();
            const dropTarget = dropTargetRef.current;
            if (!dropTarget) return;
            return (0, $iSrRp.dropTargetForElements)({
                element: dropTarget,
                canDrop: (args_0)=>{
                    if (args_0.source.element === draggableElement) return false;
                    if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args_0);
                    return true;
                },
                getIsSticky: $238e7fcc46931eb1$var$_temp,
                getData (args_1) {
                    const data = dropTargetArgs.getData?.(args_1) ?? {};
                    const operations = dropTargetArgs.getOperations(args_1);
                    return (0, $htuV6.attachInstruction)(data, {
                        input: args_1.input,
                        element: args_1.element,
                        operations: operations
                    });
                },
                onDragStart (t6) {
                    const { self: self } = t6;
                    const instruction = (0, $htuV6.extractInstruction)(self.data);
                    setInternalState({
                        type: "is-over",
                        instruction: instruction
                    });
                },
                onDrag (t7) {
                    const { self: self_0 } = t7;
                    const instruction_0 = (0, $htuV6.extractInstruction)(self_0.data);
                    setInternalState((current)=>{
                        if (current.type === "is-over" && instruction_0?.operation === current.instruction?.operation && instruction_0?.blocked === current.instruction?.blocked) return current;
                        return {
                            type: "is-over",
                            instruction: instruction_0
                        };
                    });
                },
                onDragLeave () {
                    setInternalState($238e7fcc46931eb1$var$idle);
                },
                onDrop () {
                    setInternalState($238e7fcc46931eb1$var$idle);
                },
                onDragEnter (t8) {
                    const { self: self_1 } = t8;
                    const instruction_1 = (0, $htuV6.extractInstruction)(self_1.data);
                    setInternalState({
                        type: "is-over",
                        instruction: instruction_1
                    });
                }
            });
        };
        t5 = [
            dropTargetArgs,
            getDraggableElement
        ];
        $[4] = dropTargetArgs;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    bb0: {
        if (internalState.type !== "preview") {
            t6 = null;
            break bb0;
        }
        let t7;
        if ($[7] !== internalState.ui.content || $[8] !== internalState.ui.elemBefore) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $8wghk.DragPreview), {
                elemBefore: internalState.ui.elemBefore
            }, internalState.ui.content);
            $[7] = internalState.ui.content;
            $[8] = internalState.ui.elemBefore;
            $[9] = t7;
        } else t7 = $[9];
        let t8;
        if ($[10] !== internalState.container || $[11] !== t7) {
            t8 = /*#__PURE__*/ (0, $9kbTQ.createPortal)(t7, internalState.container);
            $[10] = internalState.container;
            $[11] = t7;
            $[12] = t8;
        } else t8 = $[12];
        t6 = t8;
    }
    const dragPreview = t6;
    let t7;
    if ($[13] !== internalState.instruction || $[14] !== internalState.type) {
        t7 = internalState.type === "is-over" && internalState.instruction && /*#__PURE__*/ $cozmU.createElement((0, $8h0nV.DropIndicator), {
            instruction: internalState.instruction
        });
        $[13] = internalState.instruction;
        $[14] = internalState.type;
        $[15] = t7;
    } else t7 = $[15];
    const dropIndicator = t7;
    let t8;
    bb1: {
        if (internalState.type === "preview") {
            let t9;
            if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = {
                    type: "preview"
                };
                $[16] = t9;
            } else t9 = $[16];
            t8 = t9;
            break bb1;
        }
        let t9;
        if ($[17] !== internalState) {
            t9 = {
                ...internalState
            };
            $[17] = internalState;
            $[18] = t9;
        } else t9 = $[18];
        t8 = t9;
    }
    const state = t8;
    let t9;
    if ($[19] !== dragPreview || $[20] !== dropIndicator || $[21] !== state) {
        t9 = {
            state: state,
            draggableButtonRef: draggableButtonRef,
            dropTargetRef: dropTargetRef,
            draggableAnchorRef: draggableAnchorRef,
            dragPreview: dragPreview,
            dropIndicator: dropIndicator
        };
        $[19] = dragPreview;
        $[20] = dropIndicator;
        $[21] = state;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : function useMenuItemDragAndDrop({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $cozmU.useRef)(null);
    const draggableButtonRef = (0, $cozmU.useRef)(null);
    const dropTargetRef = (0, $cozmU.useRef)(null);
    const [internalState, setInternalState] = (0, $cozmU.useState)($238e7fcc46931eb1$var$idle);
    const getDraggableElement = (0, $cozmU.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []); // Set up draggable
    (0, $cozmU.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement(); // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error.
        if (!element) return;
        return (0, $iSrRp.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $deUyp.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($238e7fcc46931eb1$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $cozmU.useEffect)(()=>{
        if (!dropTargetArgs) return;
         // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current; // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error
        if (!dropTarget) return;
        return (0, $iSrRp.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args_0)=>{
                // cannot drop on self
                if (args_0.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args_0);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args_1) {
                const data = dropTargetArgs.getData?.(args_1) ?? {};
                const operations = dropTargetArgs.getOperations(args_1);
                return (0, $htuV6.attachInstruction)(data, {
                    input: args_1.input,
                    element: args_1.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $htuV6.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self_0 }) {
                const instruction_0 = (0, $htuV6.extractInstruction)(self_0.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction_0?.operation === current.instruction?.operation && instruction_0?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction_0
                    };
                });
            },
            onDragLeave () {
                setInternalState($238e7fcc46931eb1$var$idle);
            },
            onDrop () {
                setInternalState($238e7fcc46931eb1$var$idle);
            },
            onDragEnter ({ self: self_1 }) {
                const instruction_1 = (0, $htuV6.extractInstruction)(self_1.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction_1
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ $cozmU.createElement((0, $8wghk.DragPreview), {
            elemBefore: internalState.ui.elemBefore
        }, internalState.ui.content), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ $cozmU.createElement((0, $8h0nV.DropIndicator), {
        instruction: internalState.instruction
    });
    const state = (0, $cozmU.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
         // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
};
function $238e7fcc46931eb1$var$_temp() {
    return true;
}
module.exports["useMenuItemDragAndDrop"] = $238e7fcc46931eb1$export$fe281fdb09fbf0c8;

});

parcelRegister("8wghk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $6q25I = parcelRequire("6q25I");


var $KuePV = parcelRequire("KuePV");


var $3TF4i = parcelRequire("3TF4i");

function $01f2684e06d1e32f$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $01f2684e06d1e32f$var$dragPreviewStyles = {
    root: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8 _0KLXrulfZc _03SyCP1Y8M _1EqgXle7g8",
    rootT26Shape: "_0bjKvDKTcp",
    safariFix: "_4ouGXIgZxp"
}; /**
    * A drag preview for sidebar menu items.
    *
    * The limited API corresponds with the limited amount of information we
    * want to show in drag previews. Only essential information is shown.
    *
    * If no `elemBefore` is provided, then the `elemBefore` will automatically collapse.
    * There is no need to pass in `COLLAPSE_ELEM_BEFORE`. We do this as there is no
    * need to maintain vertical side navigation vertical alignment in the drag preview.
    *
    * Please ensure the drag preview is pushed away from the users pointer
    * (with `pointerOutsideOfPreview()` from Pragmatic drag and drop) by our
    * standard amount (`{x: token('space.200'), y: token('space.100')`)
    */ 
const $01f2684e06d1e32f$export$905ab40ac2179daa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DragPreview(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { elemBefore: elemBefore, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $01f2684e06d1e32f$var$dragPreviewStyles.root,
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $01f2684e06d1e32f$var$dragPreviewStyles.rootT26Shape,
            $01f2684e06d1e32f$var$isSafari() && $01f2684e06d1e32f$var$dragPreviewStyles.safariFix
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = elemBefore ?? (0, $3TF4i.COLLAPSE_ELEM_BEFORE);
    let t3;
    if ($[1] !== children || $[2] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6q25I.ExpandableMenuItemLevelContext).Provider, {
            value: 0
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            elemBefore: t2
        }, children)));
        $[1] = children;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function DragPreview({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ $cozmU.createElement((0, $6q25I.ExpandableMenuItemLevelContext).Provider, {
        value: 0
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $01f2684e06d1e32f$var$dragPreviewStyles.root,
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $01f2684e06d1e32f$var$dragPreviewStyles.rootT26Shape,
            $01f2684e06d1e32f$var$isSafari() && $01f2684e06d1e32f$var$dragPreviewStyles.safariFix
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        elemBefore: elemBefore ?? (0, $3TF4i.COLLAPSE_ELEM_BEFORE)
    }, children))));
};
module.exports["DragPreview"] = $01f2684e06d1e32f$export$905ab40ac2179daa;

});

parcelRegister("8h0nV", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $9AuSX = parcelRequire("9AuSX");


var $vZEJe = parcelRequire("vZEJe");

const $c6b0b810afe42c2b$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
const $c6b0b810afe42c2b$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { instruction: instruction, lineGap: lineGap, lineType: lineType } = t0;
    const appearance = instruction.blocked ? "warning" : "default";
    const axis = $c6b0b810afe42c2b$var$axisLookup[instruction.axis];
    if (instruction.operation === "combine") {
        let t1;
        if ($[0] !== appearance) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9AuSX.DropIndicator), {
                appearance: appearance
            });
            $[0] = appearance;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (instruction.operation === "reorder-before") {
        let t1;
        if ($[2] !== appearance || $[3] !== axis.start || $[4] !== lineGap || $[5] !== lineType) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
                edge: axis.start,
                appearance: appearance,
                gap: lineGap,
                type: lineType
            });
            $[2] = appearance;
            $[3] = axis.start;
            $[4] = lineGap;
            $[5] = lineType;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    if (instruction.operation === "reorder-after") {
        let t1;
        if ($[7] !== appearance || $[8] !== axis.end || $[9] !== lineGap || $[10] !== lineType) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
                edge: axis.end,
                appearance: appearance,
                gap: lineGap,
                type: lineType
            });
            $[7] = appearance;
            $[8] = axis.end;
            $[9] = lineGap;
            $[10] = lineType;
            $[11] = t1;
        } else t1 = $[11];
        return t1;
    }
    return null;
} : function DropIndicator({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $c6b0b810afe42c2b$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9AuSX.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
};
module.exports["DropIndicator"] = $c6b0b810afe42c2b$export$62ed72bc21f6b8a6;

});

parcelRegister("9AuSX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $guH5C = parcelRequire("guH5C");


var $hHzd2 = parcelRequire("hHzd2");

const $471650b8def160c1$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { appearance: t1, indent: indent } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== indent || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $guH5C.Border), {
            strokeColor: t2,
            indent: indent
        });
        $[0] = indent;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $guH5C.Border), {
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        indent: indent
    });
};
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$471650b8def160c1$export$2e2bcd8739ae039 = $471650b8def160c1$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $471650b8def160c1$export$62ed72bc21f6b8a6;

});

parcelRegister("guH5C", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $ff42c94e2588d608$var$styles = null;
const $ff42c94e2588d608$export$d8e9c9d63e86d41e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Border(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { strokeColor: t1, strokeWidth: t2, borderRadius: t3, indent: t4 } = t0;
    const strokeColor = t1 === undefined ? (0, $hHzd2.presetStrokeColors).default : t1;
    const strokeWidth = t2 === undefined ? (0, $hHzd2.presetStrokeWidth) : t2;
    const borderRadius = t3 === undefined ? "3px" : t3;
    const indent = t4 === undefined ? "0px" : t4;
    let t5;
    if ($[0] !== borderRadius || $[1] !== indent || $[2] !== strokeColor || $[3] !== strokeWidth) {
        t5 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--border-radius": borderRadius,
            "--indent": indent
        };
        $[0] = borderRadius;
        $[1] = indent;
        $[2] = strokeColor;
        $[3] = strokeWidth;
        $[4] = t5;
    } else t5 = $[4];
    const t6 = t5;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_30huDKTp3k _0bjKvDY715 _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _1OKFqYdnbC _3iC0zd3NlV _1pp6NdYbGa"
        ]);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== t6) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t6,
            className: t7
        });
        $[6] = t6;
        $[7] = t8;
    } else t8 = $[7];
    return t8;
} : function Border({ strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $hekY6.default)([
            "_30huDKTp3k _0bjKvDY715 _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _1OKFqYdnbC _3iC0zd3NlV _1pp6NdYbGa"
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ff42c94e2588d608$export$2e2bcd8739ae039 = $ff42c94e2588d608$export$d8e9c9d63e86d41e;
module.exports["Border"] = $ff42c94e2588d608$export$d8e9c9d63e86d41e;

});

parcelRegister("htuV6", function(module, exports) {

var $aYBoi = parcelRequire("aYBoi");

// using a symbol so we can guarantee a key with a unique value
const $0738bd52d113a521$var$uniqueKey = Symbol('list-item-instruction');
const $0738bd52d113a521$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $0738bd52d113a521$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $0738bd52d113a521$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $0738bd52d113a521$var$memoizeInstruction = (0, $aYBoi.stable)();
function $0738bd52d113a521$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $0738bd52d113a521$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $0738bd52d113a521$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $0738bd52d113a521$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$0738bd52d113a521$var$isPossible(combine)) {
            // can reorder above and below
            if ($0738bd52d113a521$var$isPossible(reorderAbove, reorderBelow)) return $0738bd52d113a521$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($0738bd52d113a521$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($0738bd52d113a521$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $0738bd52d113a521$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $0738bd52d113a521$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $0738bd52d113a521$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $0738bd52d113a521$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$0738bd52d113a521$var$uniqueKey]: memoized
    };
}
function $0738bd52d113a521$export$c8ffecbe249dc8f8(userData) {
    return userData[$0738bd52d113a521$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $0738bd52d113a521$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $0738bd52d113a521$export$c8ffecbe249dc8f8;

});

parcelRegister("aYBoi", function(module, exports) {
function $2c3066724b467bc7$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $2c3066724b467bc7$export$3f55479a3469259f(isEqual = $2c3066724b467bc7$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["isShallowEqual"] = $2c3066724b467bc7$export$2225b4c39d37f8b3;
module.exports["stable"] = $2c3066724b467bc7$export$3f55479a3469259f;

});

parcelRegister("kEQ10", function(module, exports) {
function $bfc807f883e56bab$export$9d7e63760538f47f(item) {
    if (!item || item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $bfc807f883e56bab$export$d5d05b25e1604a8f(item, name) {
    if (!item) {
        if (name) return name;
        return undefined;
    }
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}
module.exports["getElemBeforeForItem"] = $bfc807f883e56bab$export$9d7e63760538f47f;
module.exports["getDragPreviewContentForItem"] = $bfc807f883e56bab$export$d5d05b25e1604a8f;

});

parcelRegister("czzzJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eq1BO = parcelRequire("eq1BO");


var $rECdA = parcelRequire("rECdA");


var $dinVW = parcelRequire("dinVW");


var $a1L5E = parcelRequire("a1L5E");


var $iDdJP = parcelRequire("iDdJP");


var $3ePvn = parcelRequire("3ePvn");

var $iBJls = parcelRequire("iBJls");


var $54XHB = parcelRequire("54XHB");

var $iZ8sH = parcelRequire("iZ8sH");

var $cN3xQ = parcelRequire("cN3xQ");


var $9kVQp = parcelRequire("9kVQp");


var $d5yLW = parcelRequire("d5yLW");


var $2vUiM = parcelRequire("2vUiM");

parcelRequire("gOXu0");
var $3vXmx = parcelRequire("3vXmx");


var $3bmmh = parcelRequire("3bmmh");


var $9BFBd = parcelRequire("9BFBd");


var $eaC3G = parcelRequire("eaC3G");


var $cj1JI = parcelRequire("cj1JI");

const $67bfded25ae19901$export$9da1f15784a2a312 = $67bfded25ae19901$var$GlobalShortcutsRelay;
const $67bfded25ae19901$export$bae2da217bf9db6 = (0, $rECdA.componentWithFG)('navx-4463-gas-agg-migration', $67bfded25ae19901$var$GlobalShortcutsRelay, $67bfded25ae19901$var$GlobalShortcutsBFF);
const $67bfded25ae19901$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $67bfded25ae19901$var$GlobalShortcutsRelay_optimized(props) {
    const $ = (0, $bDgLe.c)(7);
    const { product: product } = props;
    let t0;
    if ($[0] !== product) {
        t0 = {
            product: product
        };
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerRelay, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $9BFBd.defaultMessages),
            sentryConfig: t0,
            silent: true,
            ufoInteractionName: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
        }, t1));
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
}
function $67bfded25ae19901$var$GlobalShortcutsRelay_unoptimized(props) {
    const { product: product } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorMessages: (0, $9BFBd.defaultMessages),
        sentryConfig: {
            product: product
        },
        silent: true,
        ufoInteractionName: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerRelay, props)));
}
function $67bfded25ae19901$var$GlobalShortcutsRelay(arg0) {
    if ($67bfded25ae19901$var$isReactCompilerActivePlatform_result) return $67bfded25ae19901$var$GlobalShortcutsRelay_optimized(arg0);
    else return $67bfded25ae19901$var$GlobalShortcutsRelay_unoptimized(arg0);
}
const $67bfded25ae19901$var$_isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $67bfded25ae19901$var$GlobalShortcutsBFF_optimized(props) {
    const $ = (0, $bDgLe.c)(7);
    const { product: product } = props;
    let t0;
    if ($[0] !== product) {
        t0 = {
            product: product
        };
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerBFF, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
            consumer: (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $9BFBd.defaultMessages),
            sentryConfig: t0,
            silent: true,
            ufoInteractionName: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
        }, t1)));
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
}
function $67bfded25ae19901$var$GlobalShortcutsBFF_unoptimized(props) {
    const { product: product } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
        consumer: (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorMessages: (0, $9BFBd.defaultMessages),
        sentryConfig: {
            product: product
        },
        silent: true,
        ufoInteractionName: (0, $2vUiM.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerBFF, props))));
}
function $67bfded25ae19901$var$GlobalShortcutsBFF(arg0) {
    if ($67bfded25ae19901$var$_isReactCompilerActivePlatform_result) return $67bfded25ae19901$var$GlobalShortcutsBFF_optimized(arg0);
    else return $67bfded25ae19901$var$GlobalShortcutsBFF_unoptimized(arg0);
}
const $67bfded25ae19901$var$GlobalShortcutsInnerRelay = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsInnerRelay(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab } = t0;
    let t1;
    if ($[0] !== product) {
        t1 = {
            location: (0, $54XHB.ERROR_LOCATION__GLOBAL_SHORTCUTS),
            sentryConfig: {
                product: product
            },
            disableAnalytics: true
        };
        $[0] = product;
        $[1] = t1;
    } else t1 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t1);
    let t2;
    if ($[2] !== enableDragAndDrop || $[3] !== openInSameTab || $[4] !== product || $[5] !== testId || $[6] !== viewAllAppsConfig) {
        t2 = (shortcutItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
                enableDragAndDrop: enableDragAndDrop,
                openInSameTab: openInSameTab,
                product: product,
                shortcutItems: shortcutItems,
                testId: testId,
                viewAllAppsConfig: viewAllAppsConfig
            });
        $[2] = enableDragAndDrop;
        $[3] = openInSameTab;
        $[4] = product;
        $[5] = testId;
        $[6] = viewAllAppsConfig;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== cloudId || $[9] !== handleError || $[10] !== onUpdateGetFilteredProductLinks || $[11] !== product || $[12] !== rawShortcutItems || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9kVQp.default), {
            cloudId: cloudId,
            onError: handleError,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
            product: product,
            shortcutsConfig: rawShortcutItems
        }, t2);
        $[8] = cloudId;
        $[9] = handleError;
        $[10] = onUpdateGetFilteredProductLinks;
        $[11] = product;
        $[12] = rawShortcutItems;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : function GlobalShortcutsInnerRelay({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: (0, $54XHB.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9kVQp.default), {
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product,
        shortcutsConfig: rawShortcutItems
    }, (shortcutItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
            enableDragAndDrop: enableDragAndDrop,
            openInSameTab: openInSameTab,
            product: product,
            shortcutItems: shortcutItems,
            testId: testId,
            viewAllAppsConfig: viewAllAppsConfig
        }));
};
const $67bfded25ae19901$var$GlobalShortcutsInnerBFF = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsInnerBFF(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab } = t0;
    let t1;
    if ($[0] !== product) {
        t1 = {
            location: (0, $54XHB.ERROR_LOCATION__GLOBAL_SHORTCUTS),
            sentryConfig: {
                product: product
            },
            disableAnalytics: true
        };
        $[0] = product;
        $[1] = t1;
    } else t1 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t1);
    let t2;
    if ($[2] !== cloudId || $[3] !== handleError || $[4] !== onUpdateGetFilteredProductLinks || $[5] !== product || $[6] !== rawShortcutItems) {
        t2 = {
            shortcutsConfig: rawShortcutItems,
            cloudId: cloudId,
            onError: handleError,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
            product: product
        };
        $[2] = cloudId;
        $[3] = handleError;
        $[4] = onUpdateGetFilteredProductLinks;
        $[5] = product;
        $[6] = rawShortcutItems;
        $[7] = t2;
    } else t2 = $[7];
    const shortcutItems = (0, $3vXmx.useGlobalShortcutsDataBFF)(t2);
    let t3;
    if ($[8] !== enableDragAndDrop || $[9] !== openInSameTab || $[10] !== product || $[11] !== shortcutItems || $[12] !== testId || $[13] !== viewAllAppsConfig) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
            enableDragAndDrop: enableDragAndDrop,
            openInSameTab: openInSameTab,
            product: product,
            shortcutItems: shortcutItems,
            testId: testId,
            viewAllAppsConfig: viewAllAppsConfig
        });
        $[8] = enableDragAndDrop;
        $[9] = openInSameTab;
        $[10] = product;
        $[11] = shortcutItems;
        $[12] = testId;
        $[13] = viewAllAppsConfig;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : function GlobalShortcutsInnerBFF({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: (0, $54XHB.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    const shortcutItems = (0, $3vXmx.useGlobalShortcutsDataBFF)({
        shortcutsConfig: rawShortcutItems,
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
        enableDragAndDrop: enableDragAndDrop,
        openInSameTab: openInSameTab,
        product: product,
        shortcutItems: shortcutItems,
        testId: testId,
        viewAllAppsConfig: viewAllAppsConfig
    });
}; // This is the GAS UI component. In apps, it is typically surrounded by one of the data components
const $67bfded25ae19901$export$d64b9883b9bde88c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsMenu(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { testId: testId, shortcutItems: t1, product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: t2, openInSameTab: openInSameTab, intlMode: t3 } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const shortcutItems = t4;
    let t5;
    if ($[2] !== t2) {
        t5 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t5;
    } else t5 = $[3];
    const viewAllAppsConfig = t5;
    const intlMode = t3 === undefined ? "async" : t3;
    const IntlWrapper = intlMode === "inherit" ? (0, $cozmU.Fragment) : (0, $d5yLW.GlobalShortcutsWithIntlProvider);
    let t6;
    if ($[4] !== shortcutItems) {
        t6 = shortcutItems.map($67bfded25ae19901$var$_temp);
        $[4] = shortcutItems;
        $[5] = t6;
    } else t6 = $[5];
    const mappedShortcutItems = t6;
    let t7;
    if ($[6] !== enableDragAndDrop || $[7] !== openInSameTab || $[8] !== product) {
        t7 = (shortcut)=>{
            if (shortcut.type === "component") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
                key: shortcut.key,
                shortcut: shortcut,
                dragAndDropEnabled: enableDragAndDrop
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
                key: shortcut.key,
                shortcut: shortcut,
                openInSameTab: openInSameTab,
                product: product
            });
        };
        $[6] = enableDragAndDrop;
        $[7] = openInSameTab;
        $[8] = product;
        $[9] = t7;
    } else t7 = $[9];
    const createLinkItem = t7;
    let t8;
    if ($[10] !== createLinkItem || $[11] !== mappedShortcutItems) {
        t8 = mappedShortcutItems?.map(createLinkItem);
        $[10] = createLinkItem;
        $[11] = mappedShortcutItems;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== product || $[14] !== viewAllAppsConfig) {
        t9 = viewAllAppsConfig?.path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cj1JI.ViewAllAppsItem), {
            ...viewAllAppsConfig,
            product: product
        });
        $[13] = product;
        $[14] = viewAllAppsConfig;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t8 || $[17] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, t8, t9);
        $[16] = t8;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    const shortcutList = t10;
    let t11;
    if ($[19] !== product) {
        t11 = {
            product: product
        };
        $[19] = product;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== enableDragAndDrop || $[22] !== shortcutList) {
        t12 = enableDragAndDrop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bmmh.DragAndDropOptionsProvider), {
            enabled: enableDragAndDrop
        }, shortcutList) : shortcutList;
        $[21] = enableDragAndDrop;
        $[22] = shortcutList;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t12 || $[25] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: testId
        }, t12);
        $[24] = t12;
        $[25] = testId;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t11 || $[28] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
            data: t11
        }, t13);
        $[27] = t11;
        $[28] = t13;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== IntlWrapper || $[31] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntlWrapper, null, t14);
        $[30] = IntlWrapper;
        $[31] = t14;
        $[32] = t15;
    } else t15 = $[32];
    return t15;
} : function GlobalShortcutsMenu({ testId: testId, shortcutItems: shortcutItems = [], product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig = {}, openInSameTab: openInSameTab, intlMode: intlMode = 'async' }) {
    const IntlWrapper = intlMode === 'inherit' ? (0, $cozmU.Fragment) : (0, $d5yLW.GlobalShortcutsWithIntlProvider);
    const mappedShortcutItems = (0, $cozmU.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            let key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            if (item.type === 'component') key = item?.apsKey ?? item.menuItemId ?? `shortcut-${index}`;
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems
    ]);
    const createLinkItem = (0, $cozmU.useCallback)((shortcut)=>{
        if (shortcut.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            dragAndDropEnabled: enableDragAndDrop
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            product: product
        });
    }, [
        product,
        openInSameTab,
        enableDragAndDrop
    ]);
    const shortcutList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, mappedShortcutItems?.map(createLinkItem), viewAllAppsConfig?.path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cj1JI.ViewAllAppsItem), {
        ...viewAllAppsConfig,
        product: product
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntlWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
        data: {
            product: product
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: testId
    }, enableDragAndDrop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bmmh.DragAndDropOptionsProvider), {
        enabled: enableDragAndDrop
    }, shortcutList) : shortcutList)));
};
function $67bfded25ae19901$var$_temp(item, index) {
    let key = item.type === "link" && item.apsKey || `shortcut-${index}`;
    if (item.type === "component") key = item?.apsKey ?? item.menuItemId ?? `shortcut-${index}`;
    return {
        ...item,
        key: key
    };
}
module.exports["GlobalShortcuts"] = $67bfded25ae19901$export$bae2da217bf9db6;
module.exports["GlobalShortcutsMenu"] = $67bfded25ae19901$export$d64b9883b9bde88c;

});

parcelRegister("54XHB", function(module, exports) {
/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */ const $1fb207aeb440c1b4$export$1cb3fe63ec81f460 = 'global-shortcuts';
const $1fb207aeb440c1b4$export$7b1d5fb8b81e96a9 = 'ribbon';
module.exports["ERROR_LOCATION__GLOBAL_SHORTCUTS"] = $1fb207aeb440c1b4$export$1cb3fe63ec81f460;

});

parcelRegister("d5yLW", function(module, exports) {

var $aibb0 = parcelRequire("aibb0");


var $fFpVm = parcelRequire("fFpVm");


var $lwnzd = parcelRequire("lwnzd");

const $975aaa55cf040e52$export$6b89dea1a4334953 = (0, $aibb0.createAsyncIntlProvider)({
    defaultMessages: (0, $fFpVm.default),
    asyncLanguages: $lwnzd.asyncLanguages
});
module.exports["GlobalShortcutsWithIntlProvider"] = $975aaa55cf040e52$export$6b89dea1a4334953;

});

parcelRegister("fFpVm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1a28f47cf5f7164d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $f95Dj = parcelRequire("f95Dj");

var $1a28f47cf5f7164d$export$2e2bcd8739ae039 = (0, $f95Dj.default);

});

parcelRegister("f95Dj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f2c84f88927a58d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $0f2c84f88927a58d$export$2e2bcd8739ae039 = {
    'navigation.error.description.default': 'Refresh the page and try again',
    'navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.customer-service-management': 'Customer Service Management',
    'navigation.global-shortcuts.apps.feedback': 'Feedback',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.error.description': 'Refresh the page and try again',
    'navigation.global-shortcuts.error.header': "We couldn\u2019t load the shortcut for {menuId}",
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.view-all-apps.label': 'View all apps'
};

});

parcelRegister("lwnzd", function(module, exports) {
// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)































const $4d47e9f115d5dd6f$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("4j4rL")),
    da: ()=>(parcelRequire("f0LhV")),
    de: ()=>(parcelRequire("h81jj")),
    en: ()=>(parcelRequire("fFpVm")),
    'en-GB': ()=>(parcelRequire("g3qxk")),
    'en-ZZ': ()=>(parcelRequire("5mLgC")),
    es: ()=>(parcelRequire("7CQV7")),
    fi: ()=>(parcelRequire("kSdaQ")),
    fr: ()=>(parcelRequire("6tYZv")),
    hr: ()=>(parcelRequire("jnF3u")),
    hu: ()=>(parcelRequire("dqbNs")),
    it: ()=>(parcelRequire("4SnN5")),
    ja: ()=>(parcelRequire("inwvB")),
    ko: ()=>(parcelRequire("kdmFj")),
    nb: ()=>(parcelRequire("7pHIz")),
    nl: ()=>(parcelRequire("a1UvA")),
    pl: ()=>(parcelRequire("ghRyq")),
    'pt-BR': ()=>(parcelRequire("dGCKu")),
    ru: ()=>(parcelRequire("lQ72w")),
    sk: ()=>(parcelRequire("eAKef")),
    sl: ()=>(parcelRequire("6aBQf")),
    sr: ()=>(parcelRequire("ghign")),
    'sr-RS': ()=>(parcelRequire("3rITN")),
    'sr-YR': ()=>(parcelRequire("kLFqZ")),
    sv: ()=>(parcelRequire("6Emph")),
    th: ()=>(parcelRequire("9XRm2")),
    tr: ()=>(parcelRequire("kuuW3")),
    uk: ()=>(parcelRequire("jDVbl")),
    vi: ()=>(parcelRequire("7Q3nl")),
    zh: ()=>(parcelRequire("60PM3")),
    'zh-TW': ()=>(parcelRequire("4jaDQ"))
};
module.exports["asyncLanguages"] = $4d47e9f115d5dd6f$export$3770c7a7737d463c;

});

parcelRegister("4j4rL", function(module, exports) {

let $322c62ccfb99f2b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $322c62ccfb99f2b8$var$load("1JYrd"),
    $322c62ccfb99f2b8$var$load("cip6w"),
    $322c62ccfb99f2b8$var$load("gAG2n"),
    $322c62ccfb99f2b8$var$load("hFpP9"),
    $322c62ccfb99f2b8$var$load("3feYV"),
    $322c62ccfb99f2b8$var$load("cwjU2"),
    $322c62ccfb99f2b8$var$load("3Ff1R"),
    $322c62ccfb99f2b8$var$load("423Ga")
]).then(()=>parcelRequire('kP9PO'));

});

parcelRegister("f0LhV", function(module, exports) {

let $aedb898aa1184d90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aedb898aa1184d90$var$load("30242"),
    $aedb898aa1184d90$var$load("3qBwQ"),
    $aedb898aa1184d90$var$load("cYGDU"),
    $aedb898aa1184d90$var$load("ddSTH"),
    $aedb898aa1184d90$var$load("7Q1SM"),
    $aedb898aa1184d90$var$load("33Iaa"),
    $aedb898aa1184d90$var$load("blA7x"),
    $aedb898aa1184d90$var$load("gJroP")
]).then(()=>parcelRequire('2OXDF'));

});

parcelRegister("h81jj", function(module, exports) {

let $c784333be5f9871c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c784333be5f9871c$var$load("15aAJ"),
    $c784333be5f9871c$var$load("8rREG"),
    $c784333be5f9871c$var$load("dgXJL"),
    $c784333be5f9871c$var$load("9d8JZ"),
    $c784333be5f9871c$var$load("7JdzX"),
    $c784333be5f9871c$var$load("6681T"),
    $c784333be5f9871c$var$load("3dn3H"),
    $c784333be5f9871c$var$load("cYXvt")
]).then(()=>parcelRequire('4z1H6'));

});

parcelRegister("g3qxk", function(module, exports) {

let $bb0182c106f15345$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bb0182c106f15345$var$load("6Hcvs"),
    $bb0182c106f15345$var$load("bzMpd")
]).then(()=>parcelRequire('iM4np'));

});

parcelRegister("5mLgC", function(module, exports) {

let $3e83ac15c6b989e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3e83ac15c6b989e8$var$load("bbv9t"),
    $3e83ac15c6b989e8$var$load("9fQoJ"),
    $3e83ac15c6b989e8$var$load("lTboH"),
    $3e83ac15c6b989e8$var$load("gBDXQ"),
    $3e83ac15c6b989e8$var$load("cnlNg"),
    $3e83ac15c6b989e8$var$load("d3Phe"),
    $3e83ac15c6b989e8$var$load("lASLx"),
    $3e83ac15c6b989e8$var$load("bIXgz")
]).then(()=>parcelRequire('jKPRe'));

});

parcelRegister("7CQV7", function(module, exports) {

let $58d521e23ad61c22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58d521e23ad61c22$var$load("7p4je"),
    $58d521e23ad61c22$var$load("8SZbD"),
    $58d521e23ad61c22$var$load("iE05k"),
    $58d521e23ad61c22$var$load("lv5aU"),
    $58d521e23ad61c22$var$load("9Uf61"),
    $58d521e23ad61c22$var$load("3Yk1e"),
    $58d521e23ad61c22$var$load("5lJyy"),
    $58d521e23ad61c22$var$load("9w9df")
]).then(()=>parcelRequire('llNjh'));

});

parcelRegister("kSdaQ", function(module, exports) {

let $f32311e17b3c2bb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f32311e17b3c2bb5$var$load("1jQRQ"),
    $f32311e17b3c2bb5$var$load("5pOQA"),
    $f32311e17b3c2bb5$var$load("5GSny"),
    $f32311e17b3c2bb5$var$load("cQump"),
    $f32311e17b3c2bb5$var$load("fJSEb"),
    $f32311e17b3c2bb5$var$load("ajzkj"),
    $f32311e17b3c2bb5$var$load("eyysG"),
    $f32311e17b3c2bb5$var$load("27gvR")
]).then(()=>parcelRequire('cMzEL'));

});

parcelRegister("6tYZv", function(module, exports) {

let $4b84c312cbfd897b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4b84c312cbfd897b$var$load("km37l"),
    $4b84c312cbfd897b$var$load("gbksI"),
    $4b84c312cbfd897b$var$load("j2X7f"),
    $4b84c312cbfd897b$var$load("fE8pi"),
    $4b84c312cbfd897b$var$load("9TeWr"),
    $4b84c312cbfd897b$var$load("kUZ7k"),
    $4b84c312cbfd897b$var$load("dJQL7"),
    $4b84c312cbfd897b$var$load("czj6d")
]).then(()=>parcelRequire('5jn90'));

});

parcelRegister("jnF3u", function(module, exports) {

let $e1c0030345fb69e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1c0030345fb69e8$var$load("hi9NG").then(()=>parcelRequire('k55sK'));

});

parcelRegister("dqbNs", function(module, exports) {

let $9c56daa59052f116$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9c56daa59052f116$var$load("lTbXI"),
    $9c56daa59052f116$var$load("a98cw"),
    $9c56daa59052f116$var$load("e40mE"),
    $9c56daa59052f116$var$load("btBGI"),
    $9c56daa59052f116$var$load("fOGnR"),
    $9c56daa59052f116$var$load("cDQOq"),
    $9c56daa59052f116$var$load("8upye"),
    $9c56daa59052f116$var$load("GlmUM")
]).then(()=>parcelRequire('fIWFi'));

});

parcelRegister("4SnN5", function(module, exports) {

let $38cea8e3ed39ec7c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $38cea8e3ed39ec7c$var$load("iUyZj"),
    $38cea8e3ed39ec7c$var$load("4PDaO"),
    $38cea8e3ed39ec7c$var$load("lMhbw"),
    $38cea8e3ed39ec7c$var$load("amTTV"),
    $38cea8e3ed39ec7c$var$load("8nEeY"),
    $38cea8e3ed39ec7c$var$load("kLZKK"),
    $38cea8e3ed39ec7c$var$load("c7GMc"),
    $38cea8e3ed39ec7c$var$load("bnhJ1")
]).then(()=>parcelRequire('1xWNv'));

});

parcelRegister("inwvB", function(module, exports) {

let $d613978de75cf8a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d613978de75cf8a1$var$load("kPlMQ"),
    $d613978de75cf8a1$var$load("ervs7"),
    $d613978de75cf8a1$var$load("8CX31"),
    $d613978de75cf8a1$var$load("kYd4i"),
    $d613978de75cf8a1$var$load("fzzMQ"),
    $d613978de75cf8a1$var$load("33S6H"),
    $d613978de75cf8a1$var$load("kFae4"),
    $d613978de75cf8a1$var$load("iZWpE")
]).then(()=>parcelRequire('7kLVY'));

});

parcelRegister("kdmFj", function(module, exports) {

let $eb769a6606784caa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eb769a6606784caa$var$load("iT2sv"),
    $eb769a6606784caa$var$load("iMMtn"),
    $eb769a6606784caa$var$load("23VWs"),
    $eb769a6606784caa$var$load("e1KaU"),
    $eb769a6606784caa$var$load("3gNEO"),
    $eb769a6606784caa$var$load("93obY"),
    $eb769a6606784caa$var$load("6Y9jE"),
    $eb769a6606784caa$var$load("cUTaY")
]).then(()=>parcelRequire('7nirx'));

});

parcelRegister("7pHIz", function(module, exports) {

let $565cc7a56cc1b500$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $565cc7a56cc1b500$var$load("lyPpF"),
    $565cc7a56cc1b500$var$load("eX5n7"),
    $565cc7a56cc1b500$var$load("aiYuN"),
    $565cc7a56cc1b500$var$load("gqMCT"),
    $565cc7a56cc1b500$var$load("gvylW"),
    $565cc7a56cc1b500$var$load("bxfRe"),
    $565cc7a56cc1b500$var$load("ed6s8"),
    $565cc7a56cc1b500$var$load("lAuJd")
]).then(()=>parcelRequire('ajRx2'));

});

parcelRegister("a1UvA", function(module, exports) {

let $74d5d4c318f41eb4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $74d5d4c318f41eb4$var$load("iN3cj"),
    $74d5d4c318f41eb4$var$load("3nHdy"),
    $74d5d4c318f41eb4$var$load("gDEvm"),
    $74d5d4c318f41eb4$var$load("5MwHB"),
    $74d5d4c318f41eb4$var$load("80OLx"),
    $74d5d4c318f41eb4$var$load("1EVcg"),
    $74d5d4c318f41eb4$var$load("96q1k"),
    $74d5d4c318f41eb4$var$load("XQtfV")
]).then(()=>parcelRequire('5OzV9'));

});

parcelRegister("ghRyq", function(module, exports) {

let $bdb7c6a5a0d05d85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bdb7c6a5a0d05d85$var$load("eC1OL"),
    $bdb7c6a5a0d05d85$var$load("ilL9c"),
    $bdb7c6a5a0d05d85$var$load("64nco"),
    $bdb7c6a5a0d05d85$var$load("9cx6P"),
    $bdb7c6a5a0d05d85$var$load("e4s0V"),
    $bdb7c6a5a0d05d85$var$load("28EXy"),
    $bdb7c6a5a0d05d85$var$load("7RZp5"),
    $bdb7c6a5a0d05d85$var$load("leyTH")
]).then(()=>parcelRequire('jIQoK'));

});

parcelRegister("dGCKu", function(module, exports) {

let $9f6d414f22be2986$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9f6d414f22be2986$var$load("4NJ49"),
    $9f6d414f22be2986$var$load("bfOZL"),
    $9f6d414f22be2986$var$load("jLbRX"),
    $9f6d414f22be2986$var$load("5g0HW"),
    $9f6d414f22be2986$var$load("4dPO1"),
    $9f6d414f22be2986$var$load("gg8tK"),
    $9f6d414f22be2986$var$load("eF54W"),
    $9f6d414f22be2986$var$load("3hnPt")
]).then(()=>parcelRequire('7FCSx'));

});

parcelRegister("lQ72w", function(module, exports) {

let $fe63ea3ff2d91070$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe63ea3ff2d91070$var$load("g9gkE"),
    $fe63ea3ff2d91070$var$load("jYdbS"),
    $fe63ea3ff2d91070$var$load("6ncWv"),
    $fe63ea3ff2d91070$var$load("gFneG"),
    $fe63ea3ff2d91070$var$load("ltrgi"),
    $fe63ea3ff2d91070$var$load("fu25G"),
    $fe63ea3ff2d91070$var$load("iQGcz"),
    $fe63ea3ff2d91070$var$load("ar4uw")
]).then(()=>parcelRequire('ccQsw'));

});

parcelRegister("eAKef", function(module, exports) {

let $a9f8498e0e589cdf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9f8498e0e589cdf$var$load("kumDk").then(()=>parcelRequire('fUVCV'));

});

parcelRegister("6aBQf", function(module, exports) {

let $47e107d007426b65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47e107d007426b65$var$load("9pnOF").then(()=>parcelRequire('8ONDR'));

});

parcelRegister("ghign", function(module, exports) {

let $bd9c66870333986e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd9c66870333986e$var$load("agpzZ").then(()=>parcelRequire('d8oe4'));

});

parcelRegister("3rITN", function(module, exports) {

let $2826b8b67d0489f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2826b8b67d0489f5$var$load("98iHR").then(()=>parcelRequire('3Ix5E'));

});

parcelRegister("kLFqZ", function(module, exports) {

let $f1e856731ca48d6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1e856731ca48d6f$var$load("adgrV").then(()=>parcelRequire('dGChK'));

});

parcelRegister("6Emph", function(module, exports) {

let $4d77dc000fa22c2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d77dc000fa22c2a$var$load("jhikU"),
    $4d77dc000fa22c2a$var$load("f0i3H"),
    $4d77dc000fa22c2a$var$load("bvBAp"),
    $4d77dc000fa22c2a$var$load("9kqmW"),
    $4d77dc000fa22c2a$var$load("69YlM"),
    $4d77dc000fa22c2a$var$load("cyTsc"),
    $4d77dc000fa22c2a$var$load("kXCsp"),
    $4d77dc000fa22c2a$var$load("disCG")
]).then(()=>parcelRequire('7N28Q'));

});

parcelRegister("9XRm2", function(module, exports) {

let $741302ce7102eeb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $741302ce7102eeb3$var$load("dkKxo"),
    $741302ce7102eeb3$var$load("jMiyA")
]).then(()=>parcelRequire('3InBG'));

});

parcelRegister("kuuW3", function(module, exports) {

let $eeae9b1dc74e064e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eeae9b1dc74e064e$var$load("4TdLB"),
    $eeae9b1dc74e064e$var$load("7bwdR")
]).then(()=>parcelRequire('lsR5A'));

});

parcelRegister("jDVbl", function(module, exports) {

let $e4ce03fb8633dad0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4ce03fb8633dad0$var$load("hUWr2"),
    $e4ce03fb8633dad0$var$load("fVBSK")
]).then(()=>parcelRequire('6WqWy'));

});

parcelRegister("7Q3nl", function(module, exports) {

let $5b50020818936e8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5b50020818936e8b$var$load("fgPWL"),
    $5b50020818936e8b$var$load("i8oT3")
]).then(()=>parcelRequire('4QPRO'));

});

parcelRegister("60PM3", function(module, exports) {

let $460ae76c1f81816b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $460ae76c1f81816b$var$load("708J7"),
    $460ae76c1f81816b$var$load("kVqUf"),
    $460ae76c1f81816b$var$load("2IMxh"),
    $460ae76c1f81816b$var$load("98tcg"),
    $460ae76c1f81816b$var$load("j03Pa"),
    $460ae76c1f81816b$var$load("kke1I"),
    $460ae76c1f81816b$var$load("gOwMq"),
    $460ae76c1f81816b$var$load("6GfaN")
]).then(()=>parcelRequire('7iP7s'));

});

parcelRegister("4jaDQ", function(module, exports) {

let $323130fe6173fb27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $323130fe6173fb27$var$load("d91RK"),
    $323130fe6173fb27$var$load("f7hfJ"),
    $323130fe6173fb27$var$load("QI1kr"),
    $323130fe6173fb27$var$load("5LvhC"),
    $323130fe6173fb27$var$load("brdRT"),
    $323130fe6173fb27$var$load("lWBlc"),
    $323130fe6173fb27$var$load("s2EmI"),
    $323130fe6173fb27$var$load("jc0YL")
]).then(()=>parcelRequire('1mk9s'));

});

parcelRegister("2vUiM", function(module, exports) {
const $7a2adbeb1f70395e$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $7a2adbeb1f70395e$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';
module.exports["UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME"] = $7a2adbeb1f70395e$export$fe240e33002221f;

});

parcelRegister("3bmmh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $240ec326a31eadae$export$c69308b19dea1022 = /*#__PURE__*/ (0, $cozmU.createContext)({
    enabled: false
});
const $240ec326a31eadae$export$b40e2d2385213009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, enabled: t1 } = t0;
    const enabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== enabled) {
        t2 = {
            enabled: enabled
        };
        $[0] = enabled;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($240ec326a31eadae$export$c69308b19dea1022.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, enabled: enabled = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($240ec326a31eadae$export$c69308b19dea1022.Provider, {
        value: {
            enabled: enabled
        }
    }, children);
};
module.exports["DragAndDropOptionsContext"] = $240ec326a31eadae$export$c69308b19dea1022;
module.exports["DragAndDropOptionsProvider"] = $240ec326a31eadae$export$b40e2d2385213009;

});

parcelRegister("9BFBd", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c3a7472dc0188501$export$628f6f7219a6b8b6 = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.error.header.default",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.error.description.default",
        defaultMessage: "Refresh the page and try again"
    }
});
module.exports["defaultMessages"] = $c3a7472dc0188501$export$628f6f7219a6b8b6;

});

parcelRegister("eaC3G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $iZ8sH = parcelRequire("iZ8sH");


var $6L2pn = parcelRequire("6L2pn");


var $5ngxU = parcelRequire("5ngxU");


var $dyUNt = parcelRequire("dyUNt");


var $jXuWV = parcelRequire("jXuWV");

const $3ee0708e488dd620$export$af94fce1535255cc = /*#__PURE__*/ (0, $cozmU.memo)($3ee0708e488dd620$var$ShortcutMenuItemInner);
const $3ee0708e488dd620$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $3ee0708e488dd620$var$ShortcutMenuItemInner_optimized(props) {
    const $ = (0, $bDgLe.c)(8);
    const menuId = props.shortcut.key;
    let t0;
    if ($[0] !== menuId) {
        t0 = {
            menuId: menuId
        };
        $[0] = menuId;
        $[1] = t0;
    } else t0 = $[1];
    const errorMessageValues = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ee0708e488dd620$var$ShortcutMenuItemWithoutErrorBoundary, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== errorMessageValues || $[5] !== menuId || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            key: menuId,
            errorMessages: (0, $jXuWV.menuErrorMessages),
            errorMessageValues: errorMessageValues,
            showFlags: true
        }, t1);
        $[4] = errorMessageValues;
        $[5] = menuId;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
}
function $3ee0708e488dd620$export$61fd8e200e2caa97(props) {
    const menuId = props.shortcut.key;
    const errorMessageValues = (0, $cozmU.useMemo)(()=>({
            menuId: menuId
        }), [
        menuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        key: menuId,
        errorMessages: (0, $jXuWV.menuErrorMessages),
        errorMessageValues: errorMessageValues,
        showFlags: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ee0708e488dd620$var$ShortcutMenuItemWithoutErrorBoundary, props));
}
function $3ee0708e488dd620$var$ShortcutMenuItemInner(arg0) {
    if ($3ee0708e488dd620$var$isReactCompilerActivePlatform_result) return $3ee0708e488dd620$var$ShortcutMenuItemInner_optimized(arg0);
    else return $3ee0708e488dd620$export$61fd8e200e2caa97(arg0);
}
const $3ee0708e488dd620$var$ShortcutMenuItemWithoutErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ShortcutMenuItemWithoutErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(52);
    const { shortcut: shortcut, dragAndDropEnabled: dragAndDropEnabled, product: product, openInSameTab: openInSameTab, isInMoreMenu: isInMoreMenu } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const labelText = shortcut.label;
    const analyticsName = shortcut.analyticsName || `unknown_${labelText}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    let t1;
    if ($[0] !== analyticsName || $[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $dyUNt.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
        };
        $[0] = analyticsName;
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const customComponentDraggableOnClick = t1;
    if (shortcut.type === "component") {
        let t2;
        if ($[3] !== customComponentDraggableOnClick || $[4] !== dragAndDropEnabled || $[5] !== isInMoreMenu || $[6] !== shortcut) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ngxU.MenuComponentItem), {
                shortcut: shortcut,
                dragAndDropEnabled: dragAndDropEnabled,
                isInMoreMenu: isInMoreMenu,
                onClick: customComponentDraggableOnClick
            });
            $[3] = customComponentDraggableOnClick;
            $[4] = dragAndDropEnabled;
            $[5] = isInMoreMenu;
            $[6] = shortcut;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    if (shortcut.type === "internal") {
        const t2 = shortcut.key;
        const t3 = shortcut.icon;
        const t4 = shortcut.isSelected;
        const t5 = shortcut.isReorderable;
        const t6 = shortcut.labelElem;
        const t7 = shortcut.onClick;
        const t8 = shortcut.onRightClick;
        let t9;
        if ($[8] !== shortcut) {
            t9 = (0, $6L2pn.getUrlMaybe)(shortcut);
            $[8] = shortcut;
            $[9] = t9;
        } else t9 = $[9];
        let t10;
        if ($[10] !== analyticsName || $[11] !== labelText || $[12] !== product || $[13] !== shortcut.icon || $[14] !== shortcut.isReorderable || $[15] !== shortcut.isSelected || $[16] !== shortcut.key || $[17] !== shortcut.labelElem || $[18] !== shortcut.onClick || $[19] !== shortcut.onRightClick || $[20] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dyUNt.MenuLinkItem), {
                analyticsName: analyticsName,
                key: t2,
                icon: t3,
                isSelected: t4,
                isReorderable: t5,
                label: labelText,
                labelElem: t6,
                openInSameTab: true,
                onClick: t7,
                onRightClick: t8,
                product: product,
                url: t9
            });
            $[10] = analyticsName;
            $[11] = labelText;
            $[12] = product;
            $[13] = shortcut.icon;
            $[14] = shortcut.isReorderable;
            $[15] = shortcut.isSelected;
            $[16] = shortcut.key;
            $[17] = shortcut.labelElem;
            $[18] = shortcut.onClick;
            $[19] = shortcut.onRightClick;
            $[20] = t9;
            $[21] = t10;
        } else t10 = $[21];
        let t11;
        if ($[22] !== ItemWrapper || $[23] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t10);
            $[22] = ItemWrapper;
            $[23] = t10;
            $[24] = t11;
        } else t11 = $[24];
        return t11;
    }
    const t2 = shortcut.actions;
    let t3;
    if ($[25] !== formatMessage || $[26] !== labelText) {
        t3 = formatMessage((0, $jXuWV.messages).menuLinkItemAriaLabel, {
            appName: labelText,
            siteName: ""
        });
        $[25] = formatMessage;
        $[26] = labelText;
        $[27] = t3;
    } else t3 = $[27];
    const t4 = shortcut.icon;
    const t5 = shortcut.isReorderable;
    const t6 = shortcut.key;
    const t7 = shortcut.labelElem;
    const t8 = shortcut.menuItemId;
    const t9 = shortcut.onClick;
    const t10 = shortcut.onFocus;
    const t11 = shortcut.onMouseEnter;
    const t12 = shortcut.onRightClick;
    const t13 = shortcut.ref;
    const t14 = shortcut.optionsMenuElem;
    let t15;
    if ($[28] !== shortcut) {
        t15 = (0, $6L2pn.getUrlMaybe)(shortcut);
        $[28] = shortcut;
        $[29] = t15;
    } else t15 = $[29];
    let t16;
    if ($[30] !== analyticsName || $[31] !== labelText || $[32] !== openInSameTab || $[33] !== product || $[34] !== shortcut.actions || $[35] !== shortcut.icon || $[36] !== shortcut.isReorderable || $[37] !== shortcut.key || $[38] !== shortcut.labelElem || $[39] !== shortcut.menuItemId || $[40] !== shortcut.onClick || $[41] !== shortcut.onFocus || $[42] !== shortcut.onMouseEnter || $[43] !== shortcut.onRightClick || $[44] !== shortcut.optionsMenuElem || $[45] !== shortcut.ref || $[46] !== t15 || $[47] !== t3) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dyUNt.MenuLinkItem), {
            actions: t2,
            analyticsName: analyticsName,
            ariaLabel: t3,
            icon: t4,
            isReorderable: t5,
            key: t6,
            label: labelText,
            labelElem: t7,
            menuItemId: t8,
            onClick: t9,
            onFocus: t10,
            onMouseEnter: t11,
            onRightClick: t12,
            openInSameTab: openInSameTab,
            optionalRef: t13,
            optionsMenuElem: t14,
            product: product,
            url: t15
        });
        $[30] = analyticsName;
        $[31] = labelText;
        $[32] = openInSameTab;
        $[33] = product;
        $[34] = shortcut.actions;
        $[35] = shortcut.icon;
        $[36] = shortcut.isReorderable;
        $[37] = shortcut.key;
        $[38] = shortcut.labelElem;
        $[39] = shortcut.menuItemId;
        $[40] = shortcut.onClick;
        $[41] = shortcut.onFocus;
        $[42] = shortcut.onMouseEnter;
        $[43] = shortcut.onRightClick;
        $[44] = shortcut.optionsMenuElem;
        $[45] = shortcut.ref;
        $[46] = t15;
        $[47] = t3;
        $[48] = t16;
    } else t16 = $[48];
    let t17;
    if ($[49] !== ItemWrapper || $[50] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t16);
        $[49] = ItemWrapper;
        $[50] = t16;
        $[51] = t17;
    } else t17 = $[51];
    return t17;
} : function ShortcutMenuItemWithoutErrorBoundary({ shortcut: shortcut, dragAndDropEnabled: dragAndDropEnabled, product: product, openInSameTab: openInSameTab, isInMoreMenu: isInMoreMenu }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const labelText = shortcut.label;
    const analyticsName = shortcut.analyticsName || `unknown_${labelText}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const customComponentDraggableOnClick = (0, $cozmU.useCallback)(()=>{
        (0, $dyUNt.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
    }, [
        analyticsName,
        createAnalyticsEvent
    ]);
    if (shortcut.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ngxU.MenuComponentItem), {
        shortcut: shortcut,
        dragAndDropEnabled: dragAndDropEnabled,
        isInMoreMenu: isInMoreMenu,
        onClick: customComponentDraggableOnClick
    });
    if (shortcut.type === 'internal') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dyUNt.MenuLinkItem), {
        analyticsName: analyticsName,
        key: shortcut.key,
        icon: shortcut.icon,
        isSelected: shortcut.isSelected,
        isReorderable: shortcut.isReorderable,
        label: labelText,
        labelElem: shortcut.labelElem,
        openInSameTab: true,
        onClick: shortcut.onClick,
        onRightClick: shortcut.onRightClick,
        product: product,
        url: (0, $6L2pn.getUrlMaybe)(shortcut)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dyUNt.MenuLinkItem), {
        actions: shortcut.actions,
        analyticsName: analyticsName,
        ariaLabel: formatMessage((0, $jXuWV.messages).menuLinkItemAriaLabel, {
            appName: labelText,
            siteName: ''
        }),
        icon: shortcut.icon,
        isReorderable: shortcut.isReorderable,
        key: shortcut.key,
        label: labelText,
        labelElem: shortcut.labelElem,
        menuItemId: shortcut.menuItemId,
        onClick: shortcut.onClick,
        onFocus: shortcut.onFocus,
        onMouseEnter: shortcut.onMouseEnter,
        onRightClick: shortcut.onRightClick,
        openInSameTab: openInSameTab,
        optionalRef: shortcut.ref,
        optionsMenuElem: shortcut.optionsMenuElem,
        product: product,
        url: (0, $6L2pn.getUrlMaybe)(shortcut)
    }));
};
module.exports["ShortcutMenuItem"] = $3ee0708e488dd620$export$af94fce1535255cc;

});

parcelRegister("6L2pn", function(module, exports) {

var $6N33m = parcelRequire("6N33m");

const $7debef14dbb0f4c8$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $6N33m.getFallbackUrlMaybe)(options.fallbackUrl);
module.exports["getUrlMaybe"] = $7debef14dbb0f4c8$export$ac51fdc0c7ed862d;

});

parcelRegister("6N33m", function(module, exports) {

var $cQbxl = parcelRequire("cQbxl");

const $eed1b6b355e7decd$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $cQbxl.getFallbackUrl)(fallbackUrl);
};
module.exports["getFallbackUrlMaybe"] = $eed1b6b355e7decd$export$1f32ba41e2b31f39;

});

parcelRegister("cQbxl", function(module, exports) {
const $e3979d392b20e279$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};
module.exports["getFallbackUrl"] = $e3979d392b20e279$export$739b3f561aa47bc9;

});

parcelRegister("5ngxU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $gq8Du = parcelRequire("gq8Du");


var $2BRCn = parcelRequire("2BRCn");

var $igMdc = parcelRequire("igMdc");

const $28ae02d101b3371f$var$isMenuComponentDraggableItemConfig = (shortcut)=>{
    return !!(shortcut?.isReorderable && shortcut?.menuItemId);
};
const $28ae02d101b3371f$export$9de4dadf420d5c24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuComponentItem(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { shortcut: shortcut, onClick: onClick, dragAndDropEnabled: dragAndDropEnabled, isInMoreMenu: isInMoreMenu } = t0;
    let t1;
    if ($[0] !== onClick || $[1] !== shortcut) {
        t1 = ()=>{
            onClick?.();
            shortcut.onClick?.();
        };
        $[0] = onClick;
        $[1] = shortcut;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    if (dragAndDropEnabled && $28ae02d101b3371f$var$isMenuComponentDraggableItemConfig(shortcut)) {
        let t2;
        if ($[3] !== handleClick || $[4] !== isInMoreMenu || $[5] !== shortcut) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentDraggableItem, {
                shortcut: shortcut,
                onClick: handleClick,
                isInMoreMenu: isInMoreMenu
            });
            $[3] = handleClick;
            $[4] = isInMoreMenu;
            $[5] = shortcut;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    let t2;
    if ($[7] !== handleClick || $[8] !== isInMoreMenu || $[9] !== shortcut) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
            onClick: handleClick,
            shortcut: shortcut,
            isInMoreMenu: isInMoreMenu
        });
        $[7] = handleClick;
        $[8] = isInMoreMenu;
        $[9] = shortcut;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function MenuComponentItem({ shortcut: shortcut, onClick: onClick, dragAndDropEnabled: dragAndDropEnabled, isInMoreMenu: isInMoreMenu }) {
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick?.();
        shortcut.onClick?.();
    }, [
        onClick,
        shortcut
    ]);
    if (dragAndDropEnabled && $28ae02d101b3371f$var$isMenuComponentDraggableItemConfig(shortcut)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentDraggableItem, {
        shortcut: shortcut,
        onClick: handleClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
        onClick: handleClick,
        shortcut: shortcut,
        isInMoreMenu: isInMoreMenu
    });
};
const $28ae02d101b3371f$var$MenuComponentNonDraggableItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuComponentNonDraggableItem(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu } = t0;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const Component = shortcut.component;
    let t1;
    if ($[0] !== Component || $[1] !== isInMoreMenu || $[2] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            onClick: onClick,
            isInMoreMenu: isInMoreMenu
        });
        $[0] = Component;
        $[1] = isInMoreMenu;
        $[2] = onClick;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== ItemWrapper || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t1);
        $[4] = ItemWrapper;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function MenuComponentNonDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const Component = shortcut.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    }));
};
const $28ae02d101b3371f$var$MenuComponentDraggableItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuComponentDraggableItem(t0) {
    const $ = (0, $bDgLe.c)(32);
    const { shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu } = t0;
    const Component = shortcut.component;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (open)=>{
            setIsExpandOrFlyoutOpen(open);
        };
        $[0] = t1;
    } else t1 = $[0];
    const onExpandFlyoutToggle = t1;
    let t2;
    if ($[1] !== Component || $[2] !== shortcut.isReorderable || $[3] !== shortcut.label || $[4] !== shortcut.labelElem) {
        t2 = {
            type: "custom",
            elemBefore: null,
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            isReorderable: shortcut.isReorderable,
            Component: Component,
            isDraggable: true
        };
        $[1] = Component;
        $[2] = shortcut.isReorderable;
        $[3] = shortcut.label;
        $[4] = shortcut.labelElem;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== isExpandOrFlyoutOpen || $[7] !== shortcut.menuItemId || $[8] !== t2) {
        t3 = {
            id: shortcut.menuItemId,
            isExpandable: true,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            l1DragAndDropEnabled: true,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: false,
            item: t2,
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        };
        $[6] = isExpandOrFlyoutOpen;
        $[7] = shortcut.menuItemId;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const hookProps = t3;
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)(hookProps);
    if (draggableRef === undefined || dropIndicator === undefined || dropTargetRef === undefined) {
        let t4;
        if ($[10] !== isInMoreMenu || $[11] !== onClick || $[12] !== shortcut) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
                shortcut: shortcut,
                onClick: onClick,
                isInMoreMenu: isInMoreMenu
            });
            $[10] = isInMoreMenu;
            $[11] = onClick;
            $[12] = shortcut;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    const t4 = shortcut?.ref;
    let t5;
    if ($[14] !== draggableRef || $[15] !== t4) {
        t5 = (0, $lmzCg.default)([
            draggableRef,
            t4
        ]);
        $[14] = draggableRef;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== Component || $[18] !== dropIndicator || $[19] !== dropTargetRef || $[20] !== isDragging || $[21] !== isExpandOrFlyoutOpen || $[22] !== isInMoreMenu || $[23] !== onClick || $[24] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            draggableRef: t5,
            dropIndicator: dropIndicator,
            hasDragIndicator: true,
            isDragging: isDragging,
            visualContentRef: dropTargetRef,
            onClick: onClick,
            isInMoreMenu: isInMoreMenu,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            onExpandFlyoutToggle: onExpandFlyoutToggle
        });
        $[17] = Component;
        $[18] = dropIndicator;
        $[19] = dropTargetRef;
        $[20] = isDragging;
        $[21] = isExpandOrFlyoutOpen;
        $[22] = isInMoreMenu;
        $[23] = onClick;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== ItemWrapper || $[27] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t6);
        $[26] = ItemWrapper;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    let t8;
    if ($[29] !== maybeDragPreview || $[30] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2BRCn.DragIndicatorWrapper), {
            hasDragIndicator: true
        }, t7, maybeDragPreview);
        $[29] = maybeDragPreview;
        $[30] = t7;
        $[31] = t8;
    } else t8 = $[31];
    return t8;
} : function MenuComponentDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const Component = shortcut.component;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $cozmU.useState)(false);
    const onExpandFlyoutToggle = (0, $cozmU.useCallback)((open)=>{
        setIsExpandOrFlyoutOpen(open);
    }, []);
    const hookProps = (0, $cozmU.useMemo)(()=>({
            id: shortcut.menuItemId,
            isExpandable: true,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            l1DragAndDropEnabled: true,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: false,
            item: {
                type: 'custom',
                elemBefore: null,
                label: shortcut.label,
                labelElem: shortcut.labelElem,
                isReorderable: shortcut.isReorderable,
                Component: Component,
                isDraggable: true
            },
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        }), [
        shortcut.label,
        shortcut.menuItemId,
        shortcut.labelElem,
        Component,
        shortcut.isReorderable,
        isExpandOrFlyoutOpen,
        onExpandFlyoutToggle
    ]);
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)(hookProps);
    if (draggableRef === undefined || dropIndicator === undefined || dropTargetRef === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
        shortcut: shortcut,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2BRCn.DragIndicatorWrapper), {
        hasDragIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        draggableRef: (0, $lmzCg.default)([
            draggableRef,
            shortcut?.ref
        ]),
        dropIndicator: dropIndicator,
        hasDragIndicator: true,
        isDragging: isDragging,
        visualContentRef: dropTargetRef,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    })), maybeDragPreview);
};
module.exports["MenuComponentItem"] = $28ae02d101b3371f$export$9de4dadf420d5c24;

});

parcelRegister("2BRCn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $iMnC5 = parcelRequire("iMnC5");


var $8VFFa = parcelRequire("8VFFa");

// Note: this is also used in `drag-handle.tsx`
const $b9dab4e96f655813$var$dragHandleDisplayVar = '--drag-handle-display';
const $b9dab4e96f655813$var$dragCursorAnimation = null;
const $b9dab4e96f655813$var$topLevelSiblingStyles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $b9dab4e96f655813$var$styles = {
    hasDragIndicator: "_3AKos1YbGa _3elJEbYbGa _0VlJ1yQ4SZ _13ewlZOIol _0Iy21FUiLg _4csbn4Mcca _2zVyXEgRhm"
};
const $b9dab4e96f655813$export$f9bcea5c2cbf8443 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DragIndicatorWrapper(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, hasDragIndicator: hasDragIndicator } = t0;
    if (hasDragIndicator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $k12R1.cx)($b9dab4e96f655813$var$topLevelSiblingStyles.root, $b9dab4e96f655813$var$styles.hasDragIndicator);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null);
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t1
            }, children, t2);
            $[2] = children;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    let t1;
    if ($[4] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[4] = children;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : function DragIndicatorWrapper({ children: children, hasDragIndicator: hasDragIndicator }) {
    if (hasDragIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($b9dab4e96f655813$var$topLevelSiblingStyles.root, $b9dab4e96f655813$var$styles.hasDragIndicator)
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["DragIndicatorWrapper"] = $b9dab4e96f655813$export$f9bcea5c2cbf8443;

});

parcelRegister("dyUNt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $lmzCg = parcelRequire("lmzCg");


var $V3JOP = parcelRequire("V3JOP");


var $huaOC = parcelRequire("huaOC");


var $gq8Du = parcelRequire("gq8Du");


var $igMdc = parcelRequire("igMdc");


var $cXPtd = parcelRequire("cXPtd");


var $gZ0N0 = parcelRequire("gZ0N0");


var $5b35Z = parcelRequire("5b35Z");


var $hVySk = parcelRequire("hVySk");

const $4436fe58c5f22254$export$68ef190193a37bc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuLinkItem(t0) {
    const $ = (0, $bDgLe.c)(30);
    const { analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: t1, openInSameTab: openInSameTab } = t0;
    const product = t1 === undefined ? "globalNavigation" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { enabled: dndEnabled } = (0, $5b35Z.useDragAndDropOptions)();
    let t2;
    if ($[0] !== product) {
        t2 = {
            bridge: "globalShortcuts",
            product: product
        };
        $[0] = product;
        $[1] = t2;
    } else t2 = $[1];
    const analyticsUrlWrapper = (0, $aIlZA.default)(t2);
    let t3;
    if ($[2] !== analyticsUrlWrapper) {
        t3 = (url_0)=>{
            if (!$4436fe58c5f22254$var$isValidUrl(url_0)) return url_0;
            try {
                const parsedUrl = new URL(url_0);
                const continueParam = parsedUrl.searchParams.get("continue");
                if (!continueParam) return analyticsUrlWrapper(url_0);
                const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
                parsedUrl.searchParams.set("continue", wrappedContinueUrl);
                return parsedUrl.toString();
            } catch  {
                return url_0;
            }
        };
        $[2] = analyticsUrlWrapper;
        $[3] = t3;
    } else t3 = $[3];
    const getTargetUrl = t3;
    let t4;
    if ($[4] !== analyticsName || $[5] !== createAnalyticsEvent || $[6] !== onClick) {
        t4 = (event)=>{
            $4436fe58c5f22254$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
            onClick?.(event);
        };
        $[4] = analyticsName;
        $[5] = createAnalyticsEvent;
        $[6] = onClick;
        $[7] = t4;
    } else t4 = $[7];
    const onClickMenuLinkItem = t4;
    if (!url) return null;
    let t5;
    if ($[8] !== getTargetUrl || $[9] !== url) {
        t5 = getTargetUrl(url);
        $[8] = getTargetUrl;
        $[9] = url;
        $[10] = t5;
    } else t5 = $[10];
    const targetUrl = t5;
    let t6;
    if ($[11] !== actions || $[12] !== ariaLabel || $[13] !== dndEnabled || $[14] !== icon || $[15] !== isReorderable || $[16] !== isSelected || $[17] !== label || $[18] !== labelElem || $[19] !== menuItemId || $[20] !== onClickMenuLinkItem || $[21] !== openInSameTab || $[22] !== optionalRef || $[23] !== targetUrl) {
        t6 = dndEnabled && menuItemId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemDraggableComponent, {
            actions: actions,
            ariaLabel: ariaLabel,
            icon: icon,
            isReorderable: isReorderable,
            isSelected: isSelected,
            label: label,
            labelElem: labelElem,
            menuItemId: menuItemId,
            onClick: onClickMenuLinkItem,
            openInSameTab: openInSameTab,
            optionalRef: optionalRef,
            url: targetUrl
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemComponent, {
            actions: actions,
            ariaLabel: ariaLabel,
            icon: icon,
            isReorderable: isReorderable,
            isSelected: isSelected,
            label: label,
            labelElem: labelElem,
            onClick: onClickMenuLinkItem,
            openInSameTab: openInSameTab,
            optionalRef: optionalRef,
            url: targetUrl
        });
        $[11] = actions;
        $[12] = ariaLabel;
        $[13] = dndEnabled;
        $[14] = icon;
        $[15] = isReorderable;
        $[16] = isSelected;
        $[17] = label;
        $[18] = labelElem;
        $[19] = menuItemId;
        $[20] = onClickMenuLinkItem;
        $[21] = openInSameTab;
        $[22] = optionalRef;
        $[23] = targetUrl;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== onFocus || $[26] !== onMouseEnter || $[27] !== onRightClick || $[28] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gZ0N0.ElementEventListener), {
            onRightClick: onRightClick,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus
        }, t6);
        $[25] = onFocus;
        $[26] = onMouseEnter;
        $[27] = onRightClick;
        $[28] = t6;
        $[29] = t7;
    } else t7 = $[29];
    return t7;
} : function MenuLinkItem({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: product = 'globalNavigation', openInSameTab: openInSameTab }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { enabled: dndEnabled } = (0, $5b35Z.useDragAndDropOptions)();
    const analyticsUrlWrapper = (0, $aIlZA.default)({
        bridge: 'globalShortcuts',
        product: product
    });
    const getTargetUrl = (0, $cozmU.useCallback)((url_0)=>{
        // For SPA links, we don't want to wrap the URL
        if (!$4436fe58c5f22254$var$isValidUrl(url_0)) return url_0;
        try {
            const parsedUrl = new URL(url_0);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url_0);
            // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
            // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch  {
            // Gracefully handle any URL parsing errors by returning the original URL
            // TODO: Log error to Sentry
            return url_0;
        }
    }, [
        analyticsUrlWrapper
    ]);
    const onClickMenuLinkItem = (0, $cozmU.useCallback)((event)=>{
        $4436fe58c5f22254$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.(event);
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]);
    // If a shortcut doesn't have a URL, don't show it. This is a change from earlier behaviour in which
    // the shortcut would be shown, but greyed-out (disabled).
    if (!url) return null;
    const targetUrl = getTargetUrl(url);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gZ0N0.ElementEventListener), {
        onRightClick: onRightClick,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, dndEnabled && menuItemId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemDraggableComponent, {
        actions: actions,
        ariaLabel: ariaLabel,
        icon: icon,
        isReorderable: isReorderable,
        isSelected: isSelected,
        label: label,
        labelElem: labelElem,
        menuItemId: menuItemId,
        onClick: onClickMenuLinkItem,
        openInSameTab: openInSameTab,
        optionalRef: optionalRef,
        url: targetUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemComponent, {
        actions: actions,
        ariaLabel: ariaLabel,
        icon: icon,
        isReorderable: isReorderable,
        isSelected: isSelected,
        label: label,
        labelElem: labelElem,
        onClick: onClickMenuLinkItem,
        openInSameTab: openInSameTab,
        optionalRef: optionalRef,
        url: targetUrl
    }));
};
function $4436fe58c5f22254$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName) {
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $cXPtd.ANALYTICS_CHANNEL));
}
/**
 * Utility to return whether actions and options should be shown
 */ function $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem) {
    return actions && actions.length >= 0 || !!optionsMenuElem;
}
/**
 * Actions and Options component to render both the action menu and options menu
 * beside each other on hover/focus
 */ const $4436fe58c5f22254$var$ActionsAndOptions = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ActionsAndOptions(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== analyticsName) {
        t1 = actions && actions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hVySk.ShortcutActionMenu), {
            actions: actions,
            analyticsName: analyticsName
        });
        $[0] = actions;
        $[1] = analyticsName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== optionsMenuElem || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, optionsMenuElem);
        $[3] = optionsMenuElem;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ActionsAndOptions({ actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, actions && actions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hVySk.ShortcutActionMenu), {
        actions: actions,
        analyticsName: analyticsName
    }), optionsMenuElem);
};
const $4436fe58c5f22254$var$MenuLinkItemComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuLinkItemComponent(t0) {
    const $ = (0, $bDgLe.c)(25);
    const { url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName } = t0;
    let t1;
    if ($[0] !== optionalRef) {
        t1 = (0, $lmzCg.default)(optionalRef ? [
            optionalRef
        ] : []);
        $[0] = optionalRef;
        $[1] = t1;
    } else t1 = $[1];
    const mergedRefs = t1;
    let t2;
    if ($[2] !== actions || $[3] !== optionsMenuElem) {
        t2 = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
        $[2] = actions;
        $[3] = optionsMenuElem;
        $[4] = t2;
    } else t2 = $[4];
    const shouldShowActionsAndOptions = t2;
    let t3;
    if ($[5] !== actions || $[6] !== analyticsName || $[7] !== optionsMenuElem || $[8] !== shouldShowActionsAndOptions) {
        t3 = shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        });
        $[5] = actions;
        $[6] = analyticsName;
        $[7] = optionsMenuElem;
        $[8] = shouldShowActionsAndOptions;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== openInSameTab) {
        t4 = !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: "",
            size: "small",
            spacing: "spacious"
        });
        $[10] = openInSameTab;
        $[11] = t4;
    } else t4 = $[11];
    const t5 = url || "";
    const t6 = openInSameTab ? "_self" : "_blank";
    const t7 = labelElem ?? label;
    let t8;
    if ($[12] !== ariaLabel || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": ariaLabel
        }, t7);
        $[12] = ariaLabel;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== icon || $[16] !== isSelected || $[17] !== mergedRefs || $[18] !== onClick || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            actionsOnHover: t3,
            elemBefore: icon,
            elemAfter: t4,
            href: t5,
            isSelected: isSelected,
            onClick: onClick,
            ref: mergedRefs,
            target: t6
        }, t8);
        $[15] = icon;
        $[16] = isSelected;
        $[17] = mergedRefs;
        $[18] = onClick;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t6;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : function MenuLinkItemComponent({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName }) {
    const mergedRefs = (0, $lmzCg.default)(optionalRef ? [
        optionalRef
    ] : []);
    const shouldShowActionsAndOptions = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: "",
            size: "small",
            spacing: "spacious"
        }),
        href: url || '',
        isSelected: isSelected,
        onClick: onClick,
        ref: mergedRefs,
        target: openInSameTab ? '_self' : '_blank'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-label": ariaLabel
    }, labelElem ?? label));
};
const $4436fe58c5f22254$var$MenuLinkItemDraggableComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuLinkItemDraggableComponent(t0) {
    const $ = (0, $bDgLe.c)(42);
    const { url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected } = t0;
    const { enabled: enabled } = (0, $5b35Z.useDragAndDropOptions)();
    const t1 = url || "";
    let t2;
    if ($[0] !== icon || $[1] !== isReorderable || $[2] !== label || $[3] !== labelElem || $[4] !== t1) {
        t2 = {
            type: "link",
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: t1,
            isReorderable: isReorderable
        };
        $[0] = icon;
        $[1] = isReorderable;
        $[2] = label;
        $[3] = labelElem;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== enabled || $[7] !== menuItemId || $[8] !== t2) {
        t3 = {
            id: menuItemId,
            isExpandable: false,
            isExpandOrFlyoutOpen: false,
            l1DragAndDropEnabled: enabled,
            onExpandFlyoutToggle: $4436fe58c5f22254$var$_temp,
            peek: false,
            item: t2,
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        };
        $[6] = enabled;
        $[7] = menuItemId;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)(t3);
    let t4;
    if ($[10] !== draggableRef || $[11] !== optionalRef) {
        const draggableRefCollection = draggableRef ? [
            draggableRef
        ] : [];
        t4 = (0, $lmzCg.default)(optionalRef ? [
            optionalRef,
            ...draggableRefCollection
        ] : [
            ...draggableRefCollection
        ]);
        $[10] = draggableRef;
        $[11] = optionalRef;
        $[12] = t4;
    } else t4 = $[12];
    const mergedRefs = t4;
    let t5;
    if ($[13] !== actions || $[14] !== optionsMenuElem) {
        t5 = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
        $[13] = actions;
        $[14] = optionsMenuElem;
        $[15] = t5;
    } else t5 = $[15];
    const shouldShowActionsAndOptions = t5;
    let t6;
    if ($[16] !== actions || $[17] !== analyticsName || $[18] !== optionsMenuElem || $[19] !== shouldShowActionsAndOptions) {
        t6 = shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        });
        $[16] = actions;
        $[17] = analyticsName;
        $[18] = optionsMenuElem;
        $[19] = shouldShowActionsAndOptions;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== openInSameTab) {
        t7 = !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: "",
            size: "small",
            spacing: "spacious"
        });
        $[21] = openInSameTab;
        $[22] = t7;
    } else t7 = $[22];
    const t8 = url || "";
    const t9 = openInSameTab ? "_self" : "_blank";
    const t10 = labelElem ?? label;
    let t11;
    if ($[23] !== ariaLabel || $[24] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": ariaLabel
        }, t10);
        $[23] = ariaLabel;
        $[24] = t10;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== dropIndicator || $[27] !== dropTargetRef || $[28] !== icon || $[29] !== isDragging || $[30] !== isSelected || $[31] !== mergedRefs || $[32] !== onClick || $[33] !== t11 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            actionsOnHover: t6,
            dropIndicator: dropIndicator,
            elemBefore: icon,
            elemAfter: t7,
            isDragging: isDragging,
            hasDragIndicator: true,
            href: t8,
            isSelected: isSelected,
            onClick: onClick,
            ref: mergedRefs,
            target: t9,
            visualContentRef: dropTargetRef
        }, t11);
        $[26] = dropIndicator;
        $[27] = dropTargetRef;
        $[28] = icon;
        $[29] = isDragging;
        $[30] = isSelected;
        $[31] = mergedRefs;
        $[32] = onClick;
        $[33] = t11;
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
        $[37] = t9;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== maybeDragPreview || $[40] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, maybeDragPreview);
        $[39] = maybeDragPreview;
        $[40] = t12;
        $[41] = t13;
    } else t13 = $[41];
    return t13;
} : function MenuLinkItemDraggableComponent({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected }) {
    const { enabled: enabled } = (0, $5b35Z.useDragAndDropOptions)();
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)({
        id: menuItemId,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        l1DragAndDropEnabled: enabled,
        onExpandFlyoutToggle: ()=>{},
        peek: false,
        item: {
            type: 'link',
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: url || '',
            isReorderable: isReorderable
        },
        group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
    });
    // Can possibly be undefined
    const draggableRefCollection = draggableRef ? [
        draggableRef
    ] : [];
    const mergedRefs = (0, $lmzCg.default)(optionalRef ? [
        optionalRef,
        ...draggableRefCollection
    ] : [
        ...draggableRefCollection
    ]);
    const shouldShowActionsAndOptions = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        dropIndicator: dropIndicator,
        elemBefore: icon,
        elemAfter: !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: "",
            size: "small",
            spacing: "spacious"
        }),
        isDragging: isDragging,
        hasDragIndicator: true,
        href: url || '',
        isSelected: isSelected,
        onClick: onClick,
        ref: mergedRefs,
        target: openInSameTab ? '_self' : '_blank',
        visualContentRef: dropTargetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-label": ariaLabel
    }, labelElem ?? label)), maybeDragPreview);
};
function $4436fe58c5f22254$var$_temp() {}
function $4436fe58c5f22254$var$isValidUrl(urlString) {
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch  {
        return false;
    }
}
module.exports["MenuLinkItem"] = $4436fe58c5f22254$export$68ef190193a37bc2;
module.exports["fireMenuLinkItemClickAnalyticsEvent"] = $4436fe58c5f22254$export$18a13ecc162cd5c2;

});

parcelRegister("gZ0N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

const $e74a3fb6aa1e8ce6$export$8209b3c2d1620841 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== onRightClick) {
        t1 = ()=>{
            if (!wrapperRef.current || !onRightClick) return;
            const handleMouseDown = (e)=>{
                const isLink = e.target.closest("a");
                if (isLink && e.button !== 0) onRightClick();
            };
            const unbind = (0, $cbY7C.bind)(wrapperRef.current, {
                type: "mousedown",
                listener: handleMouseDown
            });
            return unbind;
        };
        t2 = [
            onRightClick
        ];
        $[0] = onRightClick;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== onFocus || $[5] !== onMouseEnter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: wrapperRef,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus
        }, children);
        $[3] = children;
        $[4] = onFocus;
        $[5] = onMouseEnter;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !onRightClick) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) onRightClick();
        };
        const unbind = (0, $cbY7C.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        onRightClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: wrapperRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, children);
};
module.exports["ElementEventListener"] = $e74a3fb6aa1e8ce6$export$8209b3c2d1620841;

});

parcelRegister("5b35Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3bmmh = parcelRequire("3bmmh");

const $552721561f4f1f78$export$eae7963fc47ca0d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useDragAndDropOptions() {
    const $ = (0, $bDgLe.c)(3);
    const context = (0, $cozmU.useContext)((0, $3bmmh.DragAndDropOptionsContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                enabled: false
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.enabled) {
        t0 = {
            enabled: context.enabled
        };
        $[1] = context.enabled;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useDragAndDropOptions() {
    const context = (0, $cozmU.useContext)((0, $3bmmh.DragAndDropOptionsContext));
    if (!context) return {
        enabled: false
    };
    return {
        enabled: context.enabled
    };
};
module.exports["useDragAndDropOptions"] = $552721561f4f1f78$export$eae7963fc47ca0d0;

});

parcelRegister("hVySk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $1sCHt = parcelRequire("1sCHt");


var $gFEZF = parcelRequire("gFEZF");


var $9d7Pd = parcelRequire("9d7Pd");

var $6IL1T = parcelRequire("6IL1T");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $cXPtd = parcelRequire("cXPtd");


var $4D42q = parcelRequire("4D42q");

const $cf64808be0ffbc08$export$7e648395389e18b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { actions: actions, analyticsName: analyticsName } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== analyticsName || $[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            setIsOpen(true);
            $cf64808be0ffbc08$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
        };
        $[0] = analyticsName;
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent) {
        t2 = (itemId)=>{
            $cf64808be0ffbc08$var$fireShortcutActionDropdownItemClickedAnalyticsEvent(createAnalyticsEvent, itemId);
        };
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const handleDropdownItemClick = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== actions || $[7] !== handleDropdownItemClick) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf64808be0ffbc08$var$ButtonItemWithAnalytics, {
                    index: index,
                    action: action,
                    fireShortcutActionDropdownItemClickedAnalyticsEvent: handleDropdownItemClick,
                    setIsOpen: setIsOpen
                })));
        $[6] = actions;
        $[7] = handleDropdownItemClick;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage || $[10] !== handleClick) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: $cf64808be0ffbc08$var$_temp,
                label: formatMessage((0, $4D42q.messages).shortcutActionOpenMenuLabel),
                onClick: handleClick
            });
        $[9] = formatMessage;
        $[10] = handleClick;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== isOpen || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            content: t4,
            trigger: t5
        });
        $[12] = isOpen;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ actions: actions, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setIsOpen(true);
        $cf64808be0ffbc08$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName,
        setIsOpen
    ]);
    const handleDropdownItemClick = (0, $cozmU.useCallback)((itemId)=>{
        $cf64808be0ffbc08$var$fireShortcutActionDropdownItemClickedAnalyticsEvent(createAnalyticsEvent, itemId);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf64808be0ffbc08$var$ButtonItemWithAnalytics, {
                    index: index,
                    action: action,
                    fireShortcutActionDropdownItemClickedAnalyticsEvent: handleDropdownItemClick,
                    setIsOpen: setIsOpen
                }))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $4D42q.messages).shortcutActionOpenMenuLabel),
                onClick: handleClick
            })
    });
};
const $cf64808be0ffbc08$var$ButtonItemWithAnalytics = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { index: index, action: action, fireShortcutActionDropdownItemClickedAnalyticsEvent: fireShortcutActionDropdownItemClickedAnalyticsEvent, setIsOpen: setIsOpen } = t0;
    let t1;
    if ($[0] !== action || $[1] !== fireShortcutActionDropdownItemClickedAnalyticsEvent || $[2] !== setIsOpen) {
        t1 = (e)=>{
            e.preventDefault();
            action.onClick?.();
            if ((0, $iDrrr.fg)("navx-global-side-nav-confluence")) fireShortcutActionDropdownItemClickedAnalyticsEvent(action.itemId);
            setIsOpen(false);
        };
        $[0] = action;
        $[1] = fireShortcutActionDropdownItemClickedAnalyticsEvent;
        $[2] = setIsOpen;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== action.component || $[5] !== handleClick || $[6] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: index,
            onClick: handleClick
        }, action.component);
        $[4] = action.component;
        $[5] = handleClick;
        $[6] = index;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ index: index, action: action, fireShortcutActionDropdownItemClickedAnalyticsEvent: fireShortcutActionDropdownItemClickedAnalyticsEvent, setIsOpen: setIsOpen })=>{
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        action.onClick?.();
        if ((0, $iDrrr.fg)('navx-global-side-nav-confluence')) fireShortcutActionDropdownItemClickedAnalyticsEvent(action.itemId);
        setIsOpen(false);
    }, [
        action,
        fireShortcutActionDropdownItemClickedAnalyticsEvent,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        key: index,
        onClick: handleClick
    }, action.component);
};
const $cf64808be0ffbc08$var$fireShortcutActionMenuClickedAnalyticsEvent = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionMenu',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $cXPtd.ANALYTICS_CHANNEL));
};
const $cf64808be0ffbc08$var$fireShortcutActionDropdownItemClickedAnalyticsEvent = (createAnalyticsEvent, itemId)=>{
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionDropdownItem',
        attributes: {
            itemId: itemId
        }
    }).fire((0, $cXPtd.ANALYTICS_CHANNEL));
};
function $cf64808be0ffbc08$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        ...props,
        size: "small"
    });
}
module.exports["ShortcutActionMenu"] = $cf64808be0ffbc08$export$7e648395389e18b0;

});

parcelRegister("4D42q", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $57358e7cb8a2df4e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: "navigation.global-shortcuts.shortcut-action.open-menu-label",
        defaultMessage: "open menu"
    }
});
module.exports["messages"] = $57358e7cb8a2df4e$export$defe85febe8b728c;

});

parcelRegister("jXuWV", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8d671dcba983b0f5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    menuLinkItemAriaLabel: {
        id: "navigation.global-shortcuts.shortcut-link-item.aria-label",
        defaultMessage: "{appName}{siteName}"
    }
});
const $8d671dcba983b0f5$export$b010a30b3233e0c5 = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.global-shortcuts.error.header",
        defaultMessage: "We couldn\u2019t load the shortcut for {menuId}"
    },
    description: {
        id: "navigation.global-shortcuts.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});
module.exports["messages"] = $8d671dcba983b0f5$export$defe85febe8b728c;
module.exports["menuErrorMessages"] = $8d671dcba983b0f5$export$b010a30b3233e0c5;

});

parcelRegister("cj1JI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $f922E = parcelRequire("f922E");


var $eaC3G = parcelRequire("eaC3G");


var $5br5V = parcelRequire("5br5V");

const $6e4658e1d77eae7a$var$analyticsName = 'VIEW_ALL_APPS';
const $6e4658e1d77eae7a$export$84e063904618ed06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewAllAppsItem(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { path: path, isSelected: isSelected, product: product, onNavigate: onNavigate } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $5br5V.messages).viewAllAppsLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== isSelected || $[4] !== onNavigate || $[5] !== path || $[6] !== t1) {
        t3 = {
            key: $6e4658e1d77eae7a$var$analyticsName,
            analyticsName: $6e4658e1d77eae7a$var$analyticsName,
            label: t1,
            icon: t2,
            url: path,
            isReorderable: false,
            type: "internal",
            isSelected: isSelected,
            onClick: onNavigate
        };
        $[3] = isSelected;
        $[4] = onNavigate;
        $[5] = path;
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    const shortcut = t3;
    if (!path || path.trim().length < 1) return null;
    let t4;
    if ($[8] !== product || $[9] !== shortcut) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            shortcut: shortcut,
            product: product
        });
        $[8] = product;
        $[9] = shortcut;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function ViewAllAppsItem({ path: path, isSelected: isSelected, product: product, onNavigate: onNavigate }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Memoise the `shortcut` object so the
    // memoised `ShortcutMenuItem` isn't handed a brand-new object (with a fresh
    // icon element) on every render, which would defeat its memo. Hooks must run
    // unconditionally, so this is computed before the early `path` guard below.
    const shortcut = (0, $cozmU.useMemo)(()=>({
            key: $6e4658e1d77eae7a$var$analyticsName,
            analyticsName: $6e4658e1d77eae7a$var$analyticsName,
            label: formatMessage((0, $5br5V.messages).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: 'internal',
            isSelected: isSelected,
            onClick: onNavigate
        }), [
        formatMessage,
        path,
        isSelected,
        onNavigate
    ]);
    if (!path || path.trim().length < 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
        shortcut: shortcut,
        product: product
    });
};
module.exports["ViewAllAppsItem"] = $6e4658e1d77eae7a$export$84e063904618ed06;

});

parcelRegister("5br5V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a6622c6f778415fb$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    viewAllAppsLabel: {
        id: "navigation.global-shortcuts.view-all-apps.label",
        defaultMessage: "View all apps"
    }
});
module.exports["messages"] = $a6622c6f778415fb$export$defe85febe8b728c;

});

parcelRegister("93Gae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $6UvXN = parcelRequire("6UvXN");

const $081573ec09156b80$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    isFullScreenModalAvailable: false,
    initialPrompt: undefined,
    openWithChatHistory: false,
    targetConversationId: null,
    autoFocusInput: true,
    wasAutoOpened: false,
    editorHadFocusBeforeChatOpen: false
};
const $081573ec09156b80$var$store = (0, $8s9DV.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $081573ec09156b80$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($081573ec09156b80$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setTargetConversationId: (targetConversationId)=>({ setState: setState })=>{
                setState({
                    targetConversationId: targetConversationId
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        setEditorHadFocusBeforeChatOpen: (editorHadFocusBeforeChatOpen)=>({ setState: setState })=>{
                setState({
                    editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        autoFocusInput: true,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            },
        setIsFullScreenModalAvailable: (isFullScreenModalAvailable)=>({ setState: setState })=>{
                setState({
                    isFullScreenModalAvailable: isFullScreenModalAvailable
                });
            }
    }
});
const $081573ec09156b80$var$useStore = (0, $kBr4q.createHook)($081573ec09156b80$var$store);
const $081573ec09156b80$export$37440b51449f7ac6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(22);
    const [t0, t1] = $081573ec09156b80$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable } = t1;
    let t2;
    if ($[0] !== autoFocusInput || $[1] !== clearInitialPrompt || $[2] !== editorHadFocusBeforeChatOpen || $[3] !== initialPrompt || $[4] !== isFullScreenModalAvailable || $[5] !== isMiniModalAvailable || $[6] !== isSidebarAvailable || $[7] !== mode || $[8] !== openConversationAssistantUIMode || $[9] !== openWithChatHistory || $[10] !== reset || $[11] !== setEditorHadFocusBeforeChatOpen || $[12] !== setIsFullScreenModalAvailable || $[13] !== setIsMiniModalAvailable || $[14] !== setIsSidebarAvailable || $[15] !== setOpenWithChatHistory || $[16] !== setTargetConversationId || $[17] !== setWasAutoOpened || $[18] !== targetConversationId || $[19] !== toggleConversationAssistantUIMode || $[20] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            openWithChatHistory: openWithChatHistory,
            targetConversationId: targetConversationId,
            autoFocusInput: autoFocusInput,
            wasAutoOpened: wasAutoOpened,
            editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setOpenWithChatHistory: setOpenWithChatHistory,
            setTargetConversationId: setTargetConversationId,
            setWasAutoOpened: setWasAutoOpened,
            setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        };
        $[0] = autoFocusInput;
        $[1] = clearInitialPrompt;
        $[2] = editorHadFocusBeforeChatOpen;
        $[3] = initialPrompt;
        $[4] = isFullScreenModalAvailable;
        $[5] = isMiniModalAvailable;
        $[6] = isSidebarAvailable;
        $[7] = mode;
        $[8] = openConversationAssistantUIMode;
        $[9] = openWithChatHistory;
        $[10] = reset;
        $[11] = setEditorHadFocusBeforeChatOpen;
        $[12] = setIsFullScreenModalAvailable;
        $[13] = setIsMiniModalAvailable;
        $[14] = setIsSidebarAvailable;
        $[15] = setOpenWithChatHistory;
        $[16] = setTargetConversationId;
        $[17] = setWasAutoOpened;
        $[18] = targetConversationId;
        $[19] = toggleConversationAssistantUIMode;
        $[20] = wasAutoOpened;
        $[21] = t2;
    } else t2 = $[21];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable }] = $081573ec09156b80$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        targetConversationId: targetConversationId,
        autoFocusInput: autoFocusInput,
        wasAutoOpened: wasAutoOpened,
        editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setTargetConversationId: setTargetConversationId,
        setWasAutoOpened: setWasAutoOpened,
        setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable,
        isFullScreenModalAvailable: isFullScreenModalAvailable
    };
};
const $081573ec09156b80$export$66cf76b7e04da11f = (0, $kBr4q.createActionsHook)($081573ec09156b80$var$store);
module.exports["useRovoExperienceAPIStore"] = $081573ec09156b80$export$37440b51449f7ac6;

});

parcelRegister("6UvXN", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $7c0481f515a47ac9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $7c0481f515a47ac9$export$bc36ebf73899a71d;

});

parcelRegister("2bR8c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $cozmU.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("1AJi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPoYT = parcelRequire("dPoYT");


var $kQqCc = parcelRequire("kQqCc");


var $93Gae = parcelRequire("93Gae");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("3rRes", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $1qYXT = parcelRequire("1qYXT");

const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $jTt8P.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $1qYXT.isRemixRestrictedNodeType)(adfNode.type)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;

});

parcelRegister("caVF7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1118b6b7a2cd5d89$export$c8a930cce8a67fba = ({ onOpenPreview: onOpenPreview })=>{
    const [isComplete, setIsComplete] = (0, $cozmU.useState)(false);
    const signalActionReady = (0, $cozmU.useCallback)(()=>{
        // Defer opening the preview until the progress bar fills to 100%.
        setIsComplete(true);
    }, []);
    const resetCompletion = (0, $cozmU.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            showProgressBar: true,
            isComplete: isComplete,
            onCompleteAnimationFinished: onOpenPreview,
            signalActionReady: signalActionReady,
            resetCompletion: resetCompletion
        }), [
        isComplete,
        onOpenPreview,
        signalActionReady,
        resetCompletion
    ]);
};
module.exports["useRemixThinkingBarProgress"] = $1118b6b7a2cd5d89$export$c8a930cce8a67fba;

});

parcelRegister("7eOZ4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $iDrrr = parcelRequire("iDrrr");


var $kNXXO = parcelRequire("kNXXO");


var $c5wKe = parcelRequire("c5wKe");


var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $loej8 = parcelRequire("loej8");


var $ew8wg = parcelRequire("ew8wg");


var $6mKj3 = parcelRequire("6mKj3");


var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");


var $htsj6 = parcelRequire("htsj6");


var $ficwO = parcelRequire("ficwO");


var $jyA9t = parcelRequire("jyA9t");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    let hasActionCompleteStep = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') {
            hasActionCompleteStep = true;
            break;
        }
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    const lastPlannedAIFCAction = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned');
    const hasCompletedAction = lastPlannedAIFCAction !== undefined;
    if ((0, $iDrrr.fg)('remix_product_modal_rovo_chat')) return hasActionCompleteStep || hasCompletedAction;
    else return hasActionCompleteStep;
};
/**
 * True when the latest turn contains ACTION_PREPARE but no ACTION_COMPLETE.
 * This happens when AdfEditorMinion early-exits with "no operations returned
 * by LLM" — the stream completes but the action is never sealed.
 */ const $1e31de274ed01603$var$hasActionPrepareWithoutComplete = (chatMessages)=>{
    let hasActionPrepare = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return false;
        if (message.type === 'ACTION_PREPARE') hasActionPrepare = !!message.action && (0, $aYC8J.isRemixGeneratedFlow)(message.action);
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    return hasActionPrepare;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') {
            if (!message.action) return false;
            if (!(0, $aYC8J.isRemixGeneratedFlow)(message.action)) return false;
            if ($1e31de274ed01603$var$isWhiteboardRemixActionKey(message.action.key) && !(0, $aYC8J.getDynamicUiSubtype)(message.action)) return false;
            return true;
        }
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady, stagingAreaTargetMode: stagingAreaTargetMode = 'current-content' } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setUserSelectedDynamicUiSubtype: setUserSelectedDynamicUiSubtype, setInteractionSource: setInteractionSource, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraftPage = contentStatus === 'draft';
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $cozmU.useState)(undefined);
    const resetRemixConversationId = (0, $cozmU.useCallback)(()=>{
        setRemixConversationId(undefined);
    }, []);
    const activeRemixConversation = activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: activeRemixConversation?.id ?? ''
    });
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $igOtY.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const isRemixAborted = !isRemixError && activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !$1e31de274ed01603$var$isActionComplete(chatMessages) && !$1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages) && chatMessages.some((0, $igOtY.isStoreAssistant));
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $cozmU.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $cozmU.useRef)(activeRemixConversation?.id);
    (0, $cozmU.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming` (early trigger so
    //   the whiteboard preview can start rendering while data is still arriving).
    // - For all other actions: when FINAL_RESPONSE is received from the stream,
    //   indicated by the conversation status transitioning to `idle`.
    // - Fallback: when the stream completed (idle) with ACTION_PREPARE but no
    //   ACTION_COMPLETE (AdfEditorMinion early-exit).
    (0, $cozmU.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const finalResponseReceived = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$isActionComplete(chatMessages);
        const actionPreparedButNotCompleted = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages);
        if (whiteboardStreamingDetected || finalResponseReceived || actionPreparedButNotCompleted) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady,
        activeRemixConversation?.status
    ]);
    const stopRemixing = (0, $cozmU.useCallback)(()=>{
        abortRequests?.({
            conversationId: activeRemixConversation?.id
        });
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $cozmU.useCallback)((options)=>{
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId && !isDraftPage ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            // `stagingAreaTargetMode` decides whether the current content is also
            // registered as staging-area content, or preserved only as parent/source
            // context for generated-content flows.
            ...stagingAreaTargetMode === 'current-content' && contentId ? {
                content: {
                    id: contentId,
                    type: contentType ?? 'page',
                    subType: isLivePage ? 'live' : null
                }
            } : {},
            // Pass a submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{
                    // Refresh the page tree for ephemeral previews only when the experiment is enabled.
                    if (!(0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) return;
                    if (contentId) (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
                        parentId: contentId
                    });
                }
            } : {}
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        isDraftPage,
        activeRemixConversation?.id,
        setForceSkipAutoConversationSelection,
        chatMessages,
        stagingAreaTargetMode
    ]);
    const sendAIFCPrompt = (0, $cozmU.useCallback)(async ({ userPrompt: userPrompt, promptText: promptTextOverride, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, forcedContentType: forcedContentType, additionalCreationContextParams: additionalCreationContextParams })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $loej8.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $loej8.getTypeDisplayName)(dynamicUiType);
        const autoText = promptTextOverride ?? `Remix the selected content as a ${selectedDisplayName}`;
        let promptText;
        if (dynamicUiType === 'custom') promptText = userPrompt ?? defaultPromptText;
        else promptText = userPrompt ? `${autoText}. ${userPrompt}` : autoText;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        await createConversationOptimistically({
            id: newConversationId
        });
        let creationContextExperienceParams = {};
        if (!additionalCreationContextParams) {
            if (dynamicUiType === 'custom') creationContextExperienceParams = {
                experience: 'remix_custom'
            };
            else creationContextExperienceParams = {
                experience: 'remix',
                blocks: [
                    dynamicUiType
                ]
            };
        }
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                ...creationContextExperienceParams,
                ...forcedContentType ? {
                    forcedContentType: forcedContentType
                } : {},
                ...additionalCreationContextParams,
                ...dynamicUiType !== 'custom' && userPrompt ? {
                    hasUserInstruction: true
                } : {}
            }
        });
        // Store the prompt text for display in the staging area header.
        // Always show the brand keyword regardless of the user's custom prompt.
        // cc_maui_create_keyword: swap "Remix" -> "Create". Use the no-exposure variant since the
        // create-keyword exposure has already fired upstream when the remix flow was triggered.
        setPrompt((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_create_keyword', 'isEnabled', true) ? 'Create' : 'Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSource);
        // Keep the user's pick; setDynamicUiContext above gets overwritten with the
        // backend subtype on response, and EditWithRovoBar needs both to flag a mismatch.
        setUserSelectedDynamicUiSubtype(dynamicUiSubtype);
        setInteractionSource(interactionSource);
        return newConversationId;
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        setUserSelectedDynamicUiSubtype,
        setInteractionSource,
        preferences.storeUserMessages
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        resetRemixConversationId: resetRemixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});

parcelRegister("ew8wg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $duklN = parcelRequire("duklN");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), {
        ...t1,
        __callerPackage__: "content-title"
    });
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});

parcelRegister("hxqA6", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $kqIWy = parcelRequire("kqIWy");

const $37285b1cb0d2d316$var$HIDDEN_DIAGRAM_OPTIONS = [
    'diagram'
];
const $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS = [];
const $37285b1cb0d2d316$export$ddcfdb99d720c6b3 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: spaceDetail } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        includeSpaceTypeSettings: true
    });
    const isWhiteboardsEnabled = spaceDetail?.typeSettings?.enabledContentTypes?.isWhiteboardsEnabled ?? false;
    // Only hide the diagram option when whiteboards are unavailable for the space
    if (!isWhiteboardsEnabled && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_2', 'isEnabled', false)) return $37285b1cb0d2d316$var$HIDDEN_DIAGRAM_OPTIONS;
    return $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS;
};
module.exports["useShouldHideDiagramRemixOption"] = $37285b1cb0d2d316$export$ddcfdb99d720c6b3;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            if ((0, $9wGTI.fg)("cc_record_non_content_macros")) (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data || loading && !(0, $9wGTI.fg)('confluence_web_panel_location_render_loading')) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $cozmU.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $cozmU.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const renderChildren = (0, $cozmU.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $cozmU.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY) && // Keep watching query for home route to avoid VC90 regression
    (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("bLswh");
var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
parcelRequire("9iaDP");
var $2zscg = parcelRequire("2zscg");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2zscg")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
$parcel$export(module.exports, "GlobalExtension", () => (parcelRequire("2zscg")).GlobalExtension);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("13PMQ", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $0c5e3e04f495ba65$var$ch2 = {};
var $0c5e3e04f495ba65$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($0c5e3e04f495ba65$var$ch2[id] || ($0c5e3e04f495ba65$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $0c5e3e04f495ba65$var$u8 = Uint8Array, $0c5e3e04f495ba65$var$u16 = Uint16Array, $0c5e3e04f495ba65$var$i32 = Int32Array;
// fixed length extra bits
var $0c5e3e04f495ba65$var$fleb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $0c5e3e04f495ba65$var$fdeb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $0c5e3e04f495ba65$var$clim = new $0c5e3e04f495ba65$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $0c5e3e04f495ba65$var$freb = function(eb, start) {
    var b = new $0c5e3e04f495ba65$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $0c5e3e04f495ba65$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $0c5e3e04f495ba65$var$_a = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fleb, 2), $0c5e3e04f495ba65$var$fl = $0c5e3e04f495ba65$var$_a.b, $0c5e3e04f495ba65$var$revfl = $0c5e3e04f495ba65$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$0c5e3e04f495ba65$var$fl[28] = 258, $0c5e3e04f495ba65$var$revfl[258] = 28;
var $0c5e3e04f495ba65$var$_b = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fdeb, 0), $0c5e3e04f495ba65$var$fd = $0c5e3e04f495ba65$var$_b.b, $0c5e3e04f495ba65$var$revfd = $0c5e3e04f495ba65$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $0c5e3e04f495ba65$var$rev = new $0c5e3e04f495ba65$var$u16(32768);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32768; ++$0c5e3e04f495ba65$var$i){
    // reverse table algorithm from SO
    var $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$i & 0xAAAA) >> 1 | ($0c5e3e04f495ba65$var$i & 0x5555) << 1;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xCCCC) >> 2 | ($0c5e3e04f495ba65$var$x & 0x3333) << 2;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xF0F0) >> 4 | ($0c5e3e04f495ba65$var$x & 0x0F0F) << 4;
    $0c5e3e04f495ba65$var$rev[$0c5e3e04f495ba65$var$i] = (($0c5e3e04f495ba65$var$x & 0xFF00) >> 8 | ($0c5e3e04f495ba65$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $0c5e3e04f495ba65$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $0c5e3e04f495ba65$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $0c5e3e04f495ba65$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $0c5e3e04f495ba65$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$0c5e3e04f495ba65$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $0c5e3e04f495ba65$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $0c5e3e04f495ba65$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $0c5e3e04f495ba65$var$flt = new $0c5e3e04f495ba65$var$u8(288);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 144; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
for(var $0c5e3e04f495ba65$var$i = 144; $0c5e3e04f495ba65$var$i < 256; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 9;
for(var $0c5e3e04f495ba65$var$i = 256; $0c5e3e04f495ba65$var$i < 280; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 7;
for(var $0c5e3e04f495ba65$var$i = 280; $0c5e3e04f495ba65$var$i < 288; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
// fixed distance tree
var $0c5e3e04f495ba65$var$fdt = new $0c5e3e04f495ba65$var$u8(32);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$fdt[$0c5e3e04f495ba65$var$i] = 5;
// fixed length map
var $0c5e3e04f495ba65$var$flm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 0), $0c5e3e04f495ba65$var$flrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 1);
// fixed distance map
var $0c5e3e04f495ba65$var$fdm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 0), $0c5e3e04f495ba65$var$fdrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 1);
// find max of array
var $0c5e3e04f495ba65$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $0c5e3e04f495ba65$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $0c5e3e04f495ba65$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $0c5e3e04f495ba65$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $0c5e3e04f495ba65$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $0c5e3e04f495ba65$var$u8(v.subarray(s, e));
};
var $0c5e3e04f495ba65$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $0c5e3e04f495ba65$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $0c5e3e04f495ba65$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $0c5e3e04f495ba65$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $0c5e3e04f495ba65$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $0c5e3e04f495ba65$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $0c5e3e04f495ba65$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $0c5e3e04f495ba65$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $0c5e3e04f495ba65$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $0c5e3e04f495ba65$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $0c5e3e04f495ba65$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $0c5e3e04f495ba65$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $0c5e3e04f495ba65$var$flrm, dm = $0c5e3e04f495ba65$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $0c5e3e04f495ba65$var$bits(dat, pos, 31) + 257, hcLen = $0c5e3e04f495ba65$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $0c5e3e04f495ba65$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $0c5e3e04f495ba65$var$u8(tl);
                // code length tree
                var clt = new $0c5e3e04f495ba65$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$0c5e3e04f495ba65$var$clim[i]] = $0c5e3e04f495ba65$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $0c5e3e04f495ba65$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $0c5e3e04f495ba65$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$0c5e3e04f495ba65$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $0c5e3e04f495ba65$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $0c5e3e04f495ba65$var$max(lt);
                // max dist bits
                dbt = $0c5e3e04f495ba65$var$max(dt);
                lm = $0c5e3e04f495ba65$var$hMap(lt, lbt, 1);
                dm = $0c5e3e04f495ba65$var$hMap(dt, dbt, 1);
            } else $0c5e3e04f495ba65$var$err(1);
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$0c5e3e04f495ba65$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
            if (!c) $0c5e3e04f495ba65$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $0c5e3e04f495ba65$var$fleb[i];
                    add = $0c5e3e04f495ba65$var$bits(dat, pos, (1 << b) - 1) + $0c5e3e04f495ba65$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$0c5e3e04f495ba65$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $0c5e3e04f495ba65$var$err(3);
                pos += d & 15;
                var dt = $0c5e3e04f495ba65$var$fd[dsym];
                if (dsym > 3) {
                    var b = $0c5e3e04f495ba65$var$fdeb[dsym];
                    dt += $0c5e3e04f495ba65$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $0c5e3e04f495ba65$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $0c5e3e04f495ba65$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $0c5e3e04f495ba65$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $0c5e3e04f495ba65$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $0c5e3e04f495ba65$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $0c5e3e04f495ba65$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $0c5e3e04f495ba65$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $0c5e3e04f495ba65$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $0c5e3e04f495ba65$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $0c5e3e04f495ba65$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $0c5e3e04f495ba65$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($0c5e3e04f495ba65$var$ln(n.l, l, d + 1), $0c5e3e04f495ba65$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $0c5e3e04f495ba65$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $0c5e3e04f495ba65$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $0c5e3e04f495ba65$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $0c5e3e04f495ba65$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $0c5e3e04f495ba65$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $0c5e3e04f495ba65$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $0c5e3e04f495ba65$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $0c5e3e04f495ba65$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $0c5e3e04f495ba65$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $0c5e3e04f495ba65$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $0c5e3e04f495ba65$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $0c5e3e04f495ba65$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $0c5e3e04f495ba65$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$0c5e3e04f495ba65$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $0c5e3e04f495ba65$var$clen(lf, $0c5e3e04f495ba65$var$flt) + $0c5e3e04f495ba65$var$clen(df, $0c5e3e04f495ba65$var$fdt) + eb;
    var dtlen = $0c5e3e04f495ba65$var$clen(lf, dlt) + $0c5e3e04f495ba65$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $0c5e3e04f495ba65$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $0c5e3e04f495ba65$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $0c5e3e04f495ba65$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $0c5e3e04f495ba65$var$hMap(dlt, mlb, 0), ll = dlt, dm = $0c5e3e04f495ba65$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $0c5e3e04f495ba65$var$hMap(lct, mlcb, 0);
        $0c5e3e04f495ba65$var$wbits(out, p, nlc - 257);
        $0c5e3e04f495ba65$var$wbits(out, p + 5, ndc - 1);
        $0c5e3e04f495ba65$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$0c5e3e04f495ba65$var$wbits(out, p + 3 * i, lct[$0c5e3e04f495ba65$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $0c5e3e04f495ba65$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $0c5e3e04f495ba65$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $0c5e3e04f495ba65$var$flm, ll = $0c5e3e04f495ba65$var$flt, dm = $0c5e3e04f495ba65$var$fdm, dl = $0c5e3e04f495ba65$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $0c5e3e04f495ba65$var$wbits(out, p, sym >> 23 & 31), p += $0c5e3e04f495ba65$var$fleb[len];
            var dst = sym & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $0c5e3e04f495ba65$var$wbits16(out, p, sym >> 5 & 8191), p += $0c5e3e04f495ba65$var$fdeb[dst];
        } else $0c5e3e04f495ba65$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $0c5e3e04f495ba65$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $0c5e3e04f495ba65$var$deo = /*#__PURE__*/ new $0c5e3e04f495ba65$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $0c5e3e04f495ba65$var$et = /*#__PURE__*/ new $0c5e3e04f495ba65$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $0c5e3e04f495ba65$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $0c5e3e04f495ba65$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $0c5e3e04f495ba65$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $0c5e3e04f495ba65$var$u16(32768), head = st.h || new $0c5e3e04f495ba65$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $0c5e3e04f495ba65$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $0c5e3e04f495ba65$var$u16(288), df = new $0c5e3e04f495ba65$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $0c5e3e04f495ba65$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $0c5e3e04f495ba65$var$revfl[l] << 18 | $0c5e3e04f495ba65$var$revfd[d];
                    var lin = $0c5e3e04f495ba65$var$revfl[l] & 31, din = $0c5e3e04f495ba65$var$revfd[d] & 31;
                    eb += $0c5e3e04f495ba65$var$fleb[lin] + $0c5e3e04f495ba65$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $0c5e3e04f495ba65$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $0c5e3e04f495ba65$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $0c5e3e04f495ba65$var$slc(o, 0, pre + $0c5e3e04f495ba65$var$shft(pos) + post);
};
// CRC32 table
var $0c5e3e04f495ba65$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $0c5e3e04f495ba65$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $0c5e3e04f495ba65$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $0c5e3e04f495ba65$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $0c5e3e04f495ba65$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $0c5e3e04f495ba65$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $0c5e3e04f495ba65$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $0c5e3e04f495ba65$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $0c5e3e04f495ba65$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $0c5e3e04f495ba65$var$ch = [];
// clone bufs
var $0c5e3e04f495ba65$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $0c5e3e04f495ba65$var$wrkr = function(fns, init, id, cb) {
    if (!$0c5e3e04f495ba65$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $0c5e3e04f495ba65$var$wcln(fns[i], fnStr, td_1);
        $0c5e3e04f495ba65$var$ch[id] = {
            c: $0c5e3e04f495ba65$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $0c5e3e04f495ba65$var$mrg({}, $0c5e3e04f495ba65$var$ch[id].e);
    return $0c5e3e04f495ba65$var$wk($0c5e3e04f495ba65$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $0c5e3e04f495ba65$var$cbfs(td), cb);
};
// base async inflate fn
var $0c5e3e04f495ba65$var$bInflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$fl,
        $0c5e3e04f495ba65$var$fd,
        $0c5e3e04f495ba65$var$flrm,
        $0c5e3e04f495ba65$var$fdrm,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$ec,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$max,
        $0c5e3e04f495ba65$var$bits,
        $0c5e3e04f495ba65$var$bits16,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$err,
        $0c5e3e04f495ba65$var$inflt,
        $0c5e3e04f495ba65$export$90366d8b308ba94a,
        $0c5e3e04f495ba65$var$pbf,
        $0c5e3e04f495ba65$var$gopt
    ];
};
var $0c5e3e04f495ba65$var$bDflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$revfl,
        $0c5e3e04f495ba65$var$revfd,
        $0c5e3e04f495ba65$var$flm,
        $0c5e3e04f495ba65$var$flt,
        $0c5e3e04f495ba65$var$fdm,
        $0c5e3e04f495ba65$var$fdt,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$deo,
        $0c5e3e04f495ba65$var$et,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$wbits,
        $0c5e3e04f495ba65$var$wbits16,
        $0c5e3e04f495ba65$var$hTree,
        $0c5e3e04f495ba65$var$ln,
        $0c5e3e04f495ba65$var$lc,
        $0c5e3e04f495ba65$var$clen,
        $0c5e3e04f495ba65$var$wfblk,
        $0c5e3e04f495ba65$var$wblk,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$dflt,
        $0c5e3e04f495ba65$var$dopt,
        $0c5e3e04f495ba65$export$21533ff51b8a0b4a,
        $0c5e3e04f495ba65$var$pbf
    ];
};
// gzip extra
var $0c5e3e04f495ba65$var$gze = function() {
    return [
        $0c5e3e04f495ba65$var$gzh,
        $0c5e3e04f495ba65$var$gzhl,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$crc,
        $0c5e3e04f495ba65$var$crct
    ];
};
// gunzip extra
var $0c5e3e04f495ba65$var$guze = function() {
    return [
        $0c5e3e04f495ba65$var$gzs,
        $0c5e3e04f495ba65$var$gzl
    ];
};
// zlib extra
var $0c5e3e04f495ba65$var$zle = function() {
    return [
        $0c5e3e04f495ba65$var$zlh,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$adler
    ];
};
// unzlib extra
var $0c5e3e04f495ba65$var$zule = function() {
    return [
        $0c5e3e04f495ba65$var$zls
    ];
};
// post buf
var $0c5e3e04f495ba65$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $0c5e3e04f495ba65$var$gopt = function(o) {
    return o && {
        out: o.size && new $0c5e3e04f495ba65$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $0c5e3e04f495ba65$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $0c5e3e04f495ba65$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $0c5e3e04f495ba65$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $0c5e3e04f495ba65$var$err(5);
        if (t) strm.ondata($0c5e3e04f495ba65$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $0c5e3e04f495ba65$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $0c5e3e04f495ba65$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $0c5e3e04f495ba65$var$b8 = function(d, b) {
    return $0c5e3e04f495ba65$var$b4(d, b) + $0c5e3e04f495ba65$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $0c5e3e04f495ba65$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $0c5e3e04f495ba65$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $0c5e3e04f495ba65$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $0c5e3e04f495ba65$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $0c5e3e04f495ba65$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $0c5e3e04f495ba65$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $0c5e3e04f495ba65$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $0c5e3e04f495ba65$var$adler();
        h.p(o.dictionary);
        $0c5e3e04f495ba65$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $0c5e3e04f495ba65$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $0c5e3e04f495ba65$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $0c5e3e04f495ba65$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($0c5e3e04f495ba65$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $0c5e3e04f495ba65$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $0c5e3e04f495ba65$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $0c5e3e04f495ba65$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $0c5e3e04f495ba65$var$wfblk(c, this.s.r, $0c5e3e04f495ba65$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$ae157b6234afe138(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $0c5e3e04f495ba65$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $0c5e3e04f495ba65$export$21533ff51b8a0b4a(data, opts) {
    return $0c5e3e04f495ba65$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $0c5e3e04f495ba65$var$u8(32768);
        this.p = new $0c5e3e04f495ba65$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $0c5e3e04f495ba65$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $0c5e3e04f495ba65$var$inflt(this.p, this.s, this.o);
        this.ondata($0c5e3e04f495ba65$var$slc(dt, bts, this.s.b), this.d);
        this.o = $0c5e3e04f495ba65$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $0c5e3e04f495ba65$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$90366d8b308ba94a(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$crc();
        this.l = 0;
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && $0c5e3e04f495ba65$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $0c5e3e04f495ba65$var$gzh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 8, this.c.d()), $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$gze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$8e4b66d280bf8342
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$8e4b66d280bf8342(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $0c5e3e04f495ba65$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$gze,
        function() {
            return [
                $0c5e3e04f495ba65$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $0c5e3e04f495ba65$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $0c5e3e04f495ba65$var$crc(), l = data.length;
    c.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, $0c5e3e04f495ba65$var$gzhl(opts), 8), s = d.length;
    return $0c5e3e04f495ba65$var$gzh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, s - 8, c.d()), $0c5e3e04f495ba65$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $0c5e3e04f495ba65$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $0c5e3e04f495ba65$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $0c5e3e04f495ba65$var$u8(0);
            this.push(new $0c5e3e04f495ba65$var$u8(0), final);
        } else if (final) $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$guze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$4cb607de6db70415
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$guze,
        function() {
            return [
                $0c5e3e04f495ba65$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) {
    var st = $0c5e3e04f495ba65$var$gzs(data);
    if (st + 8 > data.length) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    return $0c5e3e04f495ba65$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $0c5e3e04f495ba65$var$u8($0c5e3e04f495ba65$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$adler();
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $0c5e3e04f495ba65$var$zlh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$zle,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$4187ccf2467013b9
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4187ccf2467013b9(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $0c5e3e04f495ba65$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$zle,
        function() {
            return [
                $0c5e3e04f495ba65$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $0c5e3e04f495ba65$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $0c5e3e04f495ba65$var$adler();
    a.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $0c5e3e04f495ba65$var$zlh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($0c5e3e04f495ba65$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$zule,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$af2424f875ff1b17
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$af2424f875ff1b17(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$zule,
        function() {
            return [
                $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data.subarray($0c5e3e04f495ba65$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $0c5e3e04f495ba65$export$4cb607de6db70415;
        this.I = $0c5e3e04f495ba65$export$d1de70a877d6e43c;
        this.Z = $0c5e3e04f495ba65$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $0c5e3e04f495ba65$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $0c5e3e04f495ba65$export$d5adcdd968132151;
        this.I = $0c5e3e04f495ba65$export$fff8358d6dbaa9cc;
        this.Z = $0c5e3e04f495ba65$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $0c5e3e04f495ba65$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $0c5e3e04f495ba65$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) : $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb);
}
function $0c5e3e04f495ba65$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) : $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $0c5e3e04f495ba65$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $0c5e3e04f495ba65$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $0c5e3e04f495ba65$var$u8(0),
                op
            ];
            $0c5e3e04f495ba65$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $0c5e3e04f495ba65$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $0c5e3e04f495ba65$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $0c5e3e04f495ba65$var$tds = 0;
try {
    $0c5e3e04f495ba65$var$td.decode($0c5e3e04f495ba65$var$et, {
        stream: true
    });
    $0c5e3e04f495ba65$var$tds = 1;
} catch (e) {}
// decode UTF8
var $0c5e3e04f495ba65$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $0c5e3e04f495ba65$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $0c5e3e04f495ba65$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($0c5e3e04f495ba65$var$tds) this.t = new TextDecoder();
        else this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $0c5e3e04f495ba65$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        var dat = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $0c5e3e04f495ba65$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $0c5e3e04f495ba65$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        this.ondata($0c5e3e04f495ba65$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $0c5e3e04f495ba65$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $0c5e3e04f495ba65$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($0c5e3e04f495ba65$var$te) return $0c5e3e04f495ba65$var$te.encode(str);
    var l = str.length;
    var ar = new $0c5e3e04f495ba65$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $0c5e3e04f495ba65$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $0c5e3e04f495ba65$var$slc(ar, 0, ai);
}
function $0c5e3e04f495ba65$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($0c5e3e04f495ba65$var$td) return $0c5e3e04f495ba65$var$td.decode(dat);
    else {
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $0c5e3e04f495ba65$var$err(8);
        return s;
    }
}
// deflate bit flag
var $0c5e3e04f495ba65$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $0c5e3e04f495ba65$var$slzh = function(d, b) {
    return b + 30 + $0c5e3e04f495ba65$var$b2(d, b + 26) + $0c5e3e04f495ba65$var$b2(d, b + 28);
};
// read zip header
var $0c5e3e04f495ba65$var$zh = function(d, b, z) {
    var fnl = $0c5e3e04f495ba65$var$b2(d, b + 28), efl = $0c5e3e04f495ba65$var$b2(d, b + 30), fn = $0c5e3e04f495ba65$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($0c5e3e04f495ba65$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $0c5e3e04f495ba65$var$z64hs(d, es, efl, z, $0c5e3e04f495ba65$var$b4(d, b + 20), $0c5e3e04f495ba65$var$b4(d, b + 24), $0c5e3e04f495ba65$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $0c5e3e04f495ba65$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $0c5e3e04f495ba65$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $0c5e3e04f495ba65$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $0c5e3e04f495ba65$var$b2(d, b + 2)){
            if ($0c5e3e04f495ba65$var$b2(d, b) == 1) return [
                nsc ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $0c5e3e04f495ba65$var$b8(d, b + 4) : su,
                noff ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $0c5e3e04f495ba65$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $0c5e3e04f495ba65$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $0c5e3e04f495ba65$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $0c5e3e04f495ba65$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $0c5e3e04f495ba65$var$exfl(ex);
    $0c5e3e04f495ba65$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $0c5e3e04f495ba65$var$err(10);
    $0c5e3e04f495ba65$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $0c5e3e04f495ba65$var$wbytes(d, b, f.crc);
        $0c5e3e04f495ba65$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $0c5e3e04f495ba65$var$wbytes(d, b + 8, f.size);
    }
    $0c5e3e04f495ba65$var$wbytes(d, b + 12, fl);
    $0c5e3e04f495ba65$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $0c5e3e04f495ba65$var$wbytes(d, b, col);
        $0c5e3e04f495ba65$var$wbytes(d, b + 6, f.attrs);
        $0c5e3e04f495ba65$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $0c5e3e04f495ba65$var$wbytes(d, b, +k);
        $0c5e3e04f495ba65$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $0c5e3e04f495ba65$var$wzf = function(o, b, c, d, e) {
    $0c5e3e04f495ba65$var$wbytes(o, b, 0x6054B50); // skip disk
    $0c5e3e04f495ba65$var$wbytes(o, b + 8, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 10, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 12, d);
    $0c5e3e04f495ba65$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $0c5e3e04f495ba65$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $0c5e3e04f495ba65$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $0c5e3e04f495ba65$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $0c5e3e04f495ba65$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $0c5e3e04f495ba65$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $0c5e3e04f495ba65$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($0c5e3e04f495ba65$var$err(11, 0, 1), null, false);
            var header = new $0c5e3e04f495ba65$var$u8(hl_1);
            $0c5e3e04f495ba65$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $0c5e3e04f495ba65$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $0c5e3e04f495ba65$var$u8(16);
                        $0c5e3e04f495ba65$var$wbytes(dd, 0, 0x8074B50);
                        $0c5e3e04f495ba65$var$wbytes(dd, 4, file.crc);
                        $0c5e3e04f495ba65$var$wbytes(dd, 8, cl_1);
                        $0c5e3e04f495ba65$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $0c5e3e04f495ba65$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $0c5e3e04f495ba65$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $0c5e3e04f495ba65$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $0c5e3e04f495ba65$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var r = {};
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $0c5e3e04f495ba65$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $0c5e3e04f495ba65$var$crc(), size = file.length;
        c.p(file);
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $0c5e3e04f495ba65$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($0c5e3e04f495ba65$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($0c5e3e04f495ba65$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $0c5e3e04f495ba65$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        if (s > 65535) $0c5e3e04f495ba65$var$err(11);
        var d = compression ? $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $0c5e3e04f495ba65$var$crc();
        c.p(file);
        files.push($0c5e3e04f495ba65$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $0c5e3e04f495ba65$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $0c5e3e04f495ba65$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $0c5e3e04f495ba65$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $0c5e3e04f495ba65$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $0c5e3e04f495ba65$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf
        };
        this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $0c5e3e04f495ba65$var$err(5);
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $0c5e3e04f495ba65$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $0c5e3e04f495ba65$var$b2(buf, i + 6), cmp_1 = $0c5e3e04f495ba65$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $0c5e3e04f495ba65$var$b2(buf, i + 26), es = $0c5e3e04f495ba65$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $0c5e3e04f495ba65$var$b4(buf, i + 18), lsu = $0c5e3e04f495ba65$var$b4(buf, i + 22);
                        var fn_1 = $0c5e3e04f495ba65$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $0c5e3e04f495ba65$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $0c5e3e04f495ba65$var$err(5);
                                if (!sc_1) file_1.ondata(null, $0c5e3e04f495ba65$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($0c5e3e04f495ba65$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $0c5e3e04f495ba65$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($0c5e3e04f495ba65$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $0c5e3e04f495ba65$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $0c5e3e04f495ba65$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $0c5e3e04f495ba65$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($0c5e3e04f495ba65$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
        var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
            z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $0c5e3e04f495ba65$var$b4(data, ze + 32);
                o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $0c5e3e04f495ba65$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $0c5e3e04f495ba65$export$90366d8b308ba94a(infl, {
                            out: new $0c5e3e04f495ba65$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($0c5e3e04f495ba65$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $0c5e3e04f495ba65$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $0c5e3e04f495ba65$var$err(13);
    var c = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (!c) return {};
    var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
    var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
        z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $0c5e3e04f495ba65$var$b4(data, ze + 32);
            o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $0c5e3e04f495ba65$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $0c5e3e04f495ba65$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $0c5e3e04f495ba65$var$u8(su)
            });
            else $0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $0c5e3e04f495ba65$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $0c5e3e04f495ba65$export$c80456f7aaba691c;

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $852mP = parcelRequire("852mP");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
// Merge forgeUIAttributes from outermost to innermost analytics contexts, so child contexts can
// override parent values in the final payload. If an inner context replaces extensionKey, keep the
// previous extensionKey separately so embedded macro events can report it as parentExtensionKey.
function $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(contexts) {
    return contexts.reduce((prev, curr)=>{
        // Only extract attributes passed as an object via the forgeUIAttributes key
        const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
        const previousExtensionKey = prev.forgeUIAttributes.extensionKey;
        const nextExtensionKey = forgeUIAttributes.extensionKey;
        const isExtensionKeyOverridden = Boolean(previousExtensionKey && nextExtensionKey && previousExtensionKey !== nextExtensionKey);
        // Capture the first extensionKey that gets replaced by a nested context. That replaced
        // value is the parent macro key once a child renderer context contributes its own key.
        const overriddenExtensionKey = prev.overriddenExtensionKey ?? (isExtensionKeyOverridden ? previousExtensionKey : undefined);
        const overriddenLocalId = prev.overriddenLocalId ?? (isExtensionKeyOverridden ? prev.forgeUIAttributes.localId : undefined);
        return {
            forgeUIAttributes: {
                ...prev.forgeUIAttributes,
                ...forgeUIAttributes
            },
            overriddenExtensionKey: overriddenExtensionKey,
            overriddenLocalId: overriddenLocalId
        };
    }, {
        forgeUIAttributes: {}
    });
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            let nestingAnalyticsAttributes;
            if ((0, $cXtTj.default).getExperimentValue("platform_forge_nesting_analytics", "isEnabled", false)) {
                const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
                let parentExtensionKey = {};
                if (action === "rendered" && actionSubject === "forge.ui.renderer" && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) parentExtensionKey = {
                    parentExtensionKey: overriddenExtensionKey
                };
                else if (action === "rendered" && actionSubject === "forge.ui.embedded_nonforge_macro" && attributes?.extensionKey && forgeUIAttributes.extensionKey) parentExtensionKey = {
                    parentExtensionKey: forgeUIAttributes.extensionKey
                };
                nestingAnalyticsAttributes = {
                    ...forgeUIAttributes,
                    ...parentExtensionKey
                };
            }
            if (action === "failed" && actionSubject === "forge.ui.renderer" && (0, $iDrrr.fg)("confluence_forge_nesting_logs")) {
                const { forgeUIAttributes: forgeUIAttributes_0, overriddenExtensionKey: overriddenExtensionKey_0, overriddenLocalId: overriddenLocalId } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
                if (forgeUIAttributes_0.isEmbeddedMacro) nestingAnalyticsAttributes = {
                    ...nestingAnalyticsAttributes ?? forgeUIAttributes_0,
                    isNestedForgeMacroFailure: true,
                    ...overriddenExtensionKey_0 ? {
                        parentExtensionKey: overriddenExtensionKey_0
                    } : {},
                    ...overriddenLocalId ? {
                        parentLocalId: overriddenLocalId
                    } : {}
                };
            }
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...nestingAnalyticsAttributes ?? event.context.reduce($a3a18abb8f8abee5$var$_temp, {}),
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        // Use the merged nested context attributes and add parentExtensionKey for embedded macro
        // events that override extensionKey.
        let nestingAnalyticsAttributes;
        if ((0, $cXtTj.default).getExperimentValue('platform_forge_nesting_analytics', 'isEnabled', false)) {
            const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            let parentExtensionKey = {};
            if (action === 'rendered' && actionSubject === 'forge.ui.renderer' && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) // Child Forge renderer contexts replace extensionKey with the child macro key, so the
            // parent key is the previous extensionKey captured during context merging.
            parentExtensionKey = {
                parentExtensionKey: overriddenExtensionKey
            };
            else if (action === 'rendered' && actionSubject === 'forge.ui.embedded_nonforge_macro' && attributes?.extensionKey && forgeUIAttributes.extensionKey) // Embedded macro events carry the child macro key on the event attributes, while the
            // surrounding context still carries the parent macro extensionKey.
            parentExtensionKey = {
                parentExtensionKey: forgeUIAttributes.extensionKey
            };
            nestingAnalyticsAttributes = {
                ...forgeUIAttributes,
                ...parentExtensionKey
            };
        }
        if (action === 'failed' && actionSubject === 'forge.ui.renderer' && (0, $iDrrr.fg)('confluence_forge_nesting_logs')) {
            const { forgeUIAttributes: forgeUIAttributes_0, overriddenExtensionKey: overriddenExtensionKey_0, overriddenLocalId: overriddenLocalId } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            if (forgeUIAttributes_0.isEmbeddedMacro) nestingAnalyticsAttributes = {
                ...nestingAnalyticsAttributes ?? forgeUIAttributes_0,
                isNestedForgeMacroFailure: true,
                ...overriddenExtensionKey_0 ? {
                    parentExtensionKey: overriddenExtensionKey_0
                } : {},
                ...overriddenLocalId ? {
                    parentLocalId: overriddenLocalId
                } : {}
            };
        }
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...nestingAnalyticsAttributes ?? event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes_1 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes_1
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
function $a3a18abb8f8abee5$var$_temp(prev, curr) {
    const forgeUIAttributes_1 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === "object" ? curr.forgeUIAttributes : {};
    return {
        ...prev,
        ...forgeUIAttributes_1
    };
}
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $iDrrr = parcelRequire("iDrrr");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}sandboxPolicies scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7EPz1 = parcelRequire("7EPz1");


var $ix7El = parcelRequire("ix7El");


var $DIyeF = parcelRequire("DIyeF");


var $2rD5H = parcelRequire("2rD5H");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");


var $iGKcz = parcelRequire("iGKcz");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$fetchRequests = new Map();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== types) {
        t1 = ()=>{
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        t2 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment
        ];
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = types;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== extensions || $[10] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = extensions;
        $[10] = page;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== error || $[15] !== extensions || $[16] !== page) {
        t5 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[13] = createAnalyticsEvent;
        $[14] = error;
        $[15] = extensions;
        $[16] = page;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== extensions) {
        t7 = extensions || [];
        $[19] = extensions;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== error || $[22] !== loading || $[23] !== t7) {
        t8 = {
            extensions: t7,
            loading: loading,
            error: error
        };
        $[21] = error;
        $[22] = loading;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<0f5c3c24344d3900f0ac53d7aab68fae>>
 * @relayHash 3c7314efdc53f274caf83358ee897ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 904e5a459b011295a8e77317b65201f644f4b1769c4e8d76d1712b4870225d5e
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "904e5a459b011295a8e77317b65201f644f4b1769c4e8d76d1712b4870225d5e",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "1b992f547bdf43b63a7ddd13074a26b2";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("6OJ9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $6rwn6 = parcelRequire("6rwn6");


var $5BOJB = parcelRequire("5BOJB");


var $dPoYT = parcelRequire("dPoYT");


var $6iWVH = parcelRequire("6iWVH");


var $93Gae = parcelRequire("93Gae");

const $62e5728ac53bbc83$export$9528cfa6bffa612c = (sidebarApi, product)=>{
    (0, $6cFsl.di)((0, $5BOJB.useActiveAction), (0, $hdBxM.usePublish), (0, $93Gae.useRovoExperienceAPIStore));
    const { setActiveAction: setActiveAction, activeAction: activeAction } = (0, $5BOJB.useActiveAction)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { isMiniModalAvailable: isMiniModalAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, mode: currentMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const triggerAction = (0, $cozmU.useCallback)((action, mode)=>{
        if (action.onClick) {
            action.onClick();
            return;
        }
        const setNewActiveAction = (actionToSet)=>{
            switch(actionToSet.handleType){
                case (0, $6iWVH.HandleActionType).Nested:
                    return;
                case (0, $6iWVH.HandleActionType).Skill:
                    if ('staticPrompt' in actionToSet) {
                        publish({
                            type: 'chat-new',
                            product: product,
                            source: 'rovo-action-trigger',
                            openChat: false,
                            data: {
                                prompt: actionToSet.staticPrompt ? (0, $6rwn6.encodeSkillPromptToAdf)(actionToSet.staticPrompt).adf : '',
                                dialogues: []
                            },
                            openChatMode: mode ?? 'mini-modal'
                        });
                        return;
                    }
                    if ('dynamicPrompt' in actionToSet && (0, $6iWVH.LEGACY_DYNAMIC_SKILL_IDS).has(actionToSet.id) && (0, $iDrrr.fg)('fix_dynamic_prompts_in_rovo_action_trigger')) {
                        publish({
                            type: 'insert-prompt',
                            product: product,
                            source: 'rovo-action-trigger',
                            openChat: false,
                            data: {
                                prompt: actionToSet.dynamicPrompt ?? '',
                                placeholderType: 'skill',
                                overrideAutoSend: true
                            },
                            openChatMode: mode ?? 'mini-modal'
                        });
                        return;
                    }
                    break;
                case (0, $6iWVH.HandleActionType).Chat:
                    if ('staticPrompt' in actionToSet) {
                        publish({
                            type: 'chat-new',
                            product: product,
                            source: 'rovo-action-trigger',
                            openChat: false,
                            data: {
                                prompt: actionToSet.staticPrompt ?? '',
                                dialogues: []
                            },
                            openChatMode: mode ?? 'mini-modal'
                        });
                        return;
                    }
                    if ('dynamicPrompt' in actionToSet && (0, $iDrrr.fg)('fix_dynamic_prompts_in_rovo_action_trigger')) {
                        const actionFiles = 'uploadedFiles' in actionToSet ? actionToSet.uploadedFiles : undefined;
                        const actionPromptAdf = 'dynamicPromptAdf' in actionToSet ? actionToSet.dynamicPromptAdf : undefined;
                        publish({
                            type: 'insert-prompt',
                            product: product,
                            source: 'rovo-action-trigger',
                            openChat: false,
                            data: {
                                prompt: actionToSet.dynamicPrompt ?? '',
                                overrideAutoSend: true,
                                ...actionPromptAdf ? {
                                    promptAdf: actionPromptAdf
                                } : {},
                                ...actionFiles?.length ? {
                                    files: actionFiles
                                } : {},
                                ...actionToSet.encodeDynamicPromptAsSkill ? {
                                    placeholderType: 'skill'
                                } : {}
                            },
                            openChatMode: mode ?? 'mini-modal'
                        });
                        return;
                    }
                    break;
                case (0, $6iWVH.HandleActionType).Base:
                    if (actionToSet.viewConfig) setActiveAction(actionToSet);
                    break;
                default:
                    break;
            }
        };
        const targetMode = (0, $iDrrr.fg)('agent_session_experience_fg') ? $62e5728ac53bbc83$var$calculateTargetMode(isMiniModalAvailable, isFullScreenModalAvailable, mode) : $62e5728ac53bbc83$var$calculateTargetMode(isMiniModalAvailable, undefined, mode);
        //If there's an existing active action or the target mode is different from the current mode, set to undefined first and/or set the new mode first
        if (activeAction || targetMode !== currentMode) {
            if (activeAction) setActiveAction(undefined);
            if (targetMode !== currentMode) toggleConversationAssistantUIMode({
                targetMode: targetMode,
                sidebarApi: sidebarApi
            });
            setTimeout(()=>{
                setNewActiveAction(action);
            }, 0);
            return;
        }
        setNewActiveAction(action);
    }, [
        setActiveAction,
        activeAction,
        toggleConversationAssistantUIMode,
        isMiniModalAvailable,
        isFullScreenModalAvailable,
        sidebarApi,
        currentMode,
        product,
        publish
    ]);
    return (0, $cozmU.useMemo)(()=>({
            triggerAction: triggerAction
        }), [
        triggerAction
    ]);
};
const $62e5728ac53bbc83$var$calculateTargetMode = (isMiniModalAvailable, isFullScreenModalAvailable, requestedMode)=>{
    // Full-screen modal is opt-in via FG and only honoured when the host has declared availability.
    // If either is missing, fall back to the standard mini-modal/sidebar precedence.
    if (requestedMode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (!isFullScreenModalAvailable || !(0, $iDrrr.fg)('agent_session_experience_fg'))) return isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR;
    if (requestedMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL && !isMiniModalAvailable) return (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR;
    if (requestedMode) return requestedMode;
    return isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR;
};
module.exports["useRovoActionTrigger"] = $62e5728ac53bbc83$export$9528cfa6bffa612c;

});

parcelRegister("ez9xU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $jmUhx = parcelRequire("jmUhx");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $eytcg = parcelRequire("eytcg");

const $c25508467e1a19ee$var$triggerStyles = {
    button: "_3hxITiYbGa _0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _0KLXrujOvk _0wOv4Q7zJH _39xV02N91d _1eOmH6o126",
    text: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $c25508467e1a19ee$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $c25508467e1a19ee$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c25508467e1a19ee$var$triggerStyles.text
    }, formatMessage((0, $eytcg.messages).defaultTriggerLabel))));
};

const $c25508467e1a19ee$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("5vSA9")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $c25508467e1a19ee$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $cozmU.useState)(false);
    const pendingOpenOptions = (0, $cozmU.useRef)(undefined);
    const openModalRef = (0, $cozmU.useRef)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $c25508467e1a19ee$export$f2c3f3e62df426ba;

});

parcelRegister("5vSA9", function(module, exports) {

let $403a2fdfe823ee89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $403a2fdfe823ee89$var$load("6Vp6A"),
    $403a2fdfe823ee89$var$load("6wr18"),
    $403a2fdfe823ee89$var$load("7EorR"),
    $403a2fdfe823ee89$var$load("ffEVr"),
    $403a2fdfe823ee89$var$load("bbLnX"),
    $403a2fdfe823ee89$var$load("1UUnk"),
    $403a2fdfe823ee89$var$load("90vep"),
    $403a2fdfe823ee89$var$load("ixrKS"),
    $403a2fdfe823ee89$var$load("fdLC1"),
    $403a2fdfe823ee89$var$load("hhss7"),
    $403a2fdfe823ee89$var$load("Wowvf"),
    $403a2fdfe823ee89$var$load("aAJyu"),
    $403a2fdfe823ee89$var$load("f8Q8b"),
    $403a2fdfe823ee89$var$load("cKDij")
]).then(()=>parcelRequire('7bLo5'));

});

parcelRegister("k4g8h", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

function $c96a99d0f4ee3b3b$export$6c91fec22056810a(error) {
    return error?.type === 'rateLimited';
}
function $c96a99d0f4ee3b3b$export$f2905d128e30c457(error) {
    return error ? [
        'conversationNotFound',
        'conversationEmptyOrNotPresentInStore',
        'hipaa',
        'generic'
    ].includes(error.type) : false;
}
function $c96a99d0f4ee3b3b$export$a44d3d1877743c92(error) {
    return $c96a99d0f4ee3b3b$export$6c91fec22056810a(error) ? error.rateLimitedActionType : undefined;
}
const $c96a99d0f4ee3b3b$var$store = (0, $8s9DV.createStore)({
    name: 'rovoChatSignals',
    initialState: {
        conversationError: undefined,
        status: 'launching'
    },
    actions: {
        setConversationError: (conversationError)=>({ setState: setState })=>{
                setState({
                    conversationError: conversationError
                });
            },
        setStatus: (status)=>({ setState: setState })=>{
                setState({
                    status: status
                });
            }
    }
});
const $c96a99d0f4ee3b3b$export$63ceb69e3e2574ee = (0, $kBr4q.createActionsHook)($c96a99d0f4ee3b3b$var$store);
const $c96a99d0f4ee3b3b$export$4eeff361c6b400be = (0, $kBr4q.createHook)($c96a99d0f4ee3b3b$var$store, {
    selector: (state)=>({
            conversationError: state.conversationError,
            status: state.status
        })
});
module.exports["isRateLimited"] = $c96a99d0f4ee3b3b$export$6c91fec22056810a;
module.exports["isFullScreenError"] = $c96a99d0f4ee3b3b$export$f2905d128e30c457;
module.exports["getRateLimitedActionType"] = $c96a99d0f4ee3b3b$export$a44d3d1877743c92;
module.exports["useChatSignalsActions"] = $c96a99d0f4ee3b3b$export$63ceb69e3e2574ee;
module.exports["useChatSignals"] = $c96a99d0f4ee3b3b$export$4eeff361c6b400be;

});

parcelRegister("8KiU9", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4b7a70d334529286$var$message = (0, $kSwu1.defineMessages)({
    conversationForbiddenTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.title",
        defaultMessage: "This conversation is not available"
    },
    conversationForbiddenDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.description",
        defaultMessage: "The conversation you tried to open may belong to another user or you may not have permission to view it."
    },
    conversationHistoryLoadFailedTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-history-load-failed.title",
        defaultMessage: "We couldn't load your conversations"
    },
    conversationHistoryLoadFailedDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-history-load-failed.description",
        defaultMessage: "You can keep chatting with Rovo, but your conversation history may be out of date."
    },
    followUpAgentUnavailableTitle: {
        id: "conversation-assistant.followUpAgentUnavailableTitle",
        defaultMessage: "This follow-up can't be sent"
    },
    followUpAgentUnavailableDescription: {
        id: "conversation-assistant.followUpAgentUnavailableDescription",
        defaultMessage: "The responding agent is unavailable. Choose an agent and try again."
    },
    autoConversationPrompt: {
        id: "ai-mate.conversation-assistant.auto-conversation.prompt",
        defaultMessage: "Hey Rovo, list three things you can do with my work that will make me more effective this week."
    }
});
var $4b7a70d334529286$export$2e2bcd8739ae039 = $4b7a70d334529286$var$message;
module.exports["default"] = $4b7a70d334529286$export$2e2bcd8739ae039;

});

parcelRegister("20Kr8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hVu9y = parcelRequire("hVu9y");

const $ced7807ecaf30a36$export$a01f89f33dbfe1bd = (0, $cozmU.createContext)((0, $hVu9y.backBehaviorOverrideDefaultValue));
module.exports["BackBehaviorOverrideContext"] = $ced7807ecaf30a36$export$a01f89f33dbfe1bd;

});

parcelRegister("hJC44", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $00c33fe8f91cd74f$var$StoreErrorFlagContext = (0, $cozmU.createContext)(undefined);
var $00c33fe8f91cd74f$export$2e2bcd8739ae039 = $00c33fe8f91cd74f$var$StoreErrorFlagContext;
module.exports["default"] = $00c33fe8f91cd74f$export$2e2bcd8739ae039;

});

parcelRegister("atEX8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a771a20ee041d8be$export$33f9eded602e3caf = (0, $cozmU.createContext)(undefined);
module.exports["SideNavContext"] = $a771a20ee041d8be$export$33f9eded602e3caf;

});

parcelRegister("j180q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $89QZA = parcelRequire("89QZA");


var $bGNkz = parcelRequire("bGNkz");


var $eKjv9 = parcelRequire("eKjv9");


var $dSCNl = parcelRequire("dSCNl");


var $n71o5 = parcelRequire("n71o5");


var $5wAPd = parcelRequire("5wAPd");

const $044e4eae4d9054a7$export$18774f6b5154d8f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { mode: mode } = t0;
    const [t1] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId } = t1;
    const { experienceId: experienceId, productKey: productKey, productHeader: productHeader, assistanceServiceConfig: assistanceServiceConfig, inProductExperience: inProductExperience } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [t2] = (0, $bGNkz.useSelectedSpaceSelector)();
    const { selectedSpace: selectedSpace } = t2;
    const modeVal = fullScreen ? "fullscreen" : mode;
    const resolvedSpaceId = (0, $cXtTj.default).getExperimentValue("rovo_chat_spaces_experiment", "isEnabled", false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined;
    const agentAttributes = {
        agentCreatorType: selectedAgent?.creator_type ?? null,
        agentId: selectedAgent?.id ?? null,
        agentVisibility: selectedAgent?.visibility ?? null,
        agentExternalConfigReference: selectedAgent?.external_config_reference ?? null,
        agentActions: ((0, $iDrrr.fg)("rovo_autodev_analytics_track_actions") ? selectedAgent?.action_config?.map($044e4eae4d9054a7$var$_temp) : []) ?? [],
        agentIsDefault: selectedAgent?.is_default ?? null,
        agentIsVerified: selectedAgent?.is_verified ?? null
    };
    setAnalyticsPropertiesWithoutRerender({
        ...agentAttributes,
        conversationChannelId: currentConversationId,
        experienceId: experienceId,
        fullScreen: fullScreen,
        mode: modeVal,
        product: productKey,
        productHeader: productHeader,
        inProductExperience: inProductExperience,
        singleInstrumentationID: currentConversationId,
        ...(0, $iDrrr.fg)("additional-analytics-params-for-sa") ? {
            assistanceServiceConfigMinionAlias: assistanceServiceConfig?.minionAlias ?? null
        } : {},
        spaceId: resolvedSpaceId,
        ...(0, $iDrrr.fg)("add_launchsource_to_rovo_chat_analytics") ? {
            launchSource: conversation?.resultAttributionContext?.launchSource
        } : {}
    });
    return null;
} : ({ mode: mode })=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const { experienceId: experienceId, productKey: productKey, productHeader: productHeader, assistanceServiceConfig: assistanceServiceConfig, inProductExperience: inProductExperience } = (0, $eKjv9.useGlobalConfig)();
    const { selectedAgent: selectedAgent, conversation: conversation } = (0, $5wAPd.useConversation)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [{ selectedSpace: selectedSpace }] = (0, $bGNkz.useSelectedSpaceSelector)();
    const modeVal = fullScreen ? 'fullscreen' : mode;
    // When the chat is scoped to a Rovo Space, tag every fired event with the
    // spaceId (mirrors the resolution used at message-send time in
    // chat-input-refresh) so "Space MAU" — unique users who initiate a chat in a
    // space — is measurable from the standard AI MAU `initiated`/`viewed` events.
    // Resolves to `undefined` (never `null`) when there is no active space so the
    // attribute is omitted from non-space events, and — because it is always
    // written below — a previously-set spaceId is cleared when the user moves from
    // a space-scoped chat back to a general one.
    const resolvedSpaceId = (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? selectedSpace?.id ?? conversation?.rovoSpaceId : undefined;
    const agentAttributes = {
        agentCreatorType: selectedAgent?.creator_type ?? null,
        agentId: selectedAgent?.id ?? null,
        agentVisibility: selectedAgent?.visibility ?? null,
        agentExternalConfigReference: selectedAgent?.external_config_reference ?? null,
        agentActions: ((0, $iDrrr.fg)('rovo_autodev_analytics_track_actions') ? selectedAgent?.action_config?.map((config)=>config.id) : []) ?? [],
        agentIsDefault: selectedAgent?.is_default ?? null,
        agentIsVerified: selectedAgent?.is_verified ?? null
    };
    setAnalyticsPropertiesWithoutRerender({
        ...agentAttributes,
        conversationChannelId: currentConversationId,
        experienceId: experienceId,
        fullScreen: fullScreen,
        mode: modeVal,
        product: productKey,
        productHeader: productHeader,
        inProductExperience: inProductExperience,
        singleInstrumentationID: currentConversationId,
        ...(0, $iDrrr.fg)('additional-analytics-params-for-sa') ? {
            assistanceServiceConfigMinionAlias: assistanceServiceConfig?.minionAlias ?? null
        } : {},
        // Always written (not conditionally spread) so switching away from a space
        // clears the previous spaceId; `undefined` is omitted from event payloads.
        spaceId: resolvedSpaceId,
        // Launch source from the conversation, surfaced on all fired events.
        ...(0, $iDrrr.fg)('add_launchsource_to_rovo_chat_analytics') ? {
            launchSource: conversation?.resultAttributionContext?.launchSource
        } : {}
    });
    return null;
};
function $044e4eae4d9054a7$var$_temp(config) {
    return config.id;
}
module.exports["AnalyticsPropertiesUpdater"] = $044e4eae4d9054a7$export$18774f6b5154d8f2;

});

parcelRegister("jqg1p", function(module, exports) {
const $cd16886f2e0e6e79$export$a89b9c1bf34c03e5 = (current, next)=>{
    if (current === next) return true;
    if (!current || !next || current.length !== next.length) return false;
    return current.every((value, index)=>value === next[index]);
};
module.exports["areStringArraysEqual"] = $cd16886f2e0e6e79$export$a89b9c1bf34c03e5;

});

parcelRegister("jAZYc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0165172f0f6448b6$export$8cc6a5423ea2e47d = (value, isEnabled, areEqual)=>{
    const stableValueRef = (0, $cozmU.useRef)(value);
    if (!isEnabled) {
        stableValueRef.current = value;
        return value;
    }
    if (!areEqual(stableValueRef.current, value)) stableValueRef.current = value;
    return stableValueRef.current;
};
module.exports["useSemanticStableValue"] = $0165172f0f6448b6$export$8cc6a5423ea2e47d;

});

parcelRegister("hSR6U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $vQngM = parcelRequire("vQngM");


var $lTU4O = parcelRequire("lTU4O");

const $24e6e2aaa4cab039$export$89877538e672d96b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { assistanceServiceParams: assistanceServiceParams } = t0;
    const { preferences: preferences, setStoreUserMessages: setLocalStoreUserMessages, markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE } = (0, $lTU4O.useUserPreferences)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("ai_mate_store_messages_be_driven");
        $[0] = t1;
    } else t1 = $[0];
    const useBackendPreference = t1;
    let t2;
    if ($[1] !== assistanceServiceParams) {
        t2 = {
            assistanceServiceParams: assistanceServiceParams,
            enabled: useBackendPreference
        };
        $[1] = assistanceServiceParams;
        $[2] = t2;
    } else t2 = $[2];
    const { settings: settings, updateSettings: updateSettings } = (0, $vQngM.useRovoUserSettings)(t2);
    let t3;
    if ($[3] !== updateSettings) {
        t3 = (storeUserMessages, callbacks)=>updateSettings({
                storeUserMessages: storeUserMessages
            }, callbacks);
        $[3] = updateSettings;
        $[4] = t3;
    } else t3 = $[4];
    const updateBackendStoreUserMessages = t3;
    let t4;
    if ($[5] !== setLocalStoreUserMessages || $[6] !== updateBackendStoreUserMessages) {
        t4 = (storeUserMessages_0)=>{
            setLocalStoreUserMessages(storeUserMessages_0);
            if (useBackendPreference) updateBackendStoreUserMessages(storeUserMessages_0);
        };
        $[5] = setLocalStoreUserMessages;
        $[6] = updateBackendStoreUserMessages;
        $[7] = t4;
    } else t4 = $[7];
    const setStoreUserMessages = t4;
    const backendSettingsLoaded = settings !== null;
    const backendStoreUserMessages = settings?.storeUserMessagesEligible ? settings.storeUserMessages ?? false : false;
    const storeUserMessages_1 = useBackendPreference && backendSettingsLoaded ? backendStoreUserMessages : preferences.storeUserMessages;
    let t5;
    if ($[8] !== settings?.storeUserMessagesEligible) {
        t5 = useBackendPreference ? settings?.storeUserMessagesEligible ?? false : (0, $iDrrr.fg)("ai_mate_show_store_messages");
        $[8] = settings?.storeUserMessagesEligible;
        $[9] = t5;
    } else t5 = $[9];
    const storeUserMessagesEligible = t5;
    let t6;
    if ($[10] !== markStoreUserMessageMigratedToBE || $[11] !== preferences.storeUserMessageMigratedToBE || $[12] !== preferences.storeUserMessages || $[13] !== setStoreUserMessages || $[14] !== storeUserMessagesEligible || $[15] !== storeUserMessages_1 || $[16] !== updateBackendStoreUserMessages) {
        t6 = {
            storeUserMessages: storeUserMessages_1,
            storeUserMessagesEligible: storeUserMessagesEligible,
            localStoreUserMessages: preferences.storeUserMessages,
            storeUserMessageMigratedToBE: preferences.storeUserMessageMigratedToBE,
            setStoreUserMessages: setStoreUserMessages,
            markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE,
            updateBackendStoreUserMessages: updateBackendStoreUserMessages
        };
        $[10] = markStoreUserMessageMigratedToBE;
        $[11] = preferences.storeUserMessageMigratedToBE;
        $[12] = preferences.storeUserMessages;
        $[13] = setStoreUserMessages;
        $[14] = storeUserMessagesEligible;
        $[15] = storeUserMessages_1;
        $[16] = updateBackendStoreUserMessages;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ assistanceServiceParams: assistanceServiceParams })=>{
    const { preferences: preferences, setStoreUserMessages: setLocalStoreUserMessages, markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE } = (0, $lTU4O.useUserPreferences)();
    const useBackendPreference = (0, $iDrrr.fg)('ai_mate_store_messages_be_driven');
    const { settings: settings, updateSettings: updateSettings } = (0, $vQngM.useRovoUserSettings)({
        assistanceServiceParams: assistanceServiceParams,
        enabled: useBackendPreference
    });
    const updateBackendStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages, callbacks)=>updateSettings({
            storeUserMessages: storeUserMessages
        }, callbacks), [
        updateSettings
    ]);
    const setStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages_0)=>{
        // Keep the local value up to date as a rollback fallback while the
        // BE-driven mode is being rolled out.
        setLocalStoreUserMessages(storeUserMessages_0);
        if (useBackendPreference) updateBackendStoreUserMessages(storeUserMessages_0);
    }, [
        setLocalStoreUserMessages,
        updateBackendStoreUserMessages,
        useBackendPreference
    ]);
    const backendSettingsLoaded = settings !== null;
    const backendStoreUserMessages = settings?.storeUserMessagesEligible ? settings.storeUserMessages ?? false : false;
    const storeUserMessages_1 = useBackendPreference && backendSettingsLoaded ? backendStoreUserMessages : preferences.storeUserMessages;
    const storeUserMessagesEligible = useBackendPreference ? settings?.storeUserMessagesEligible ?? false : (0, $iDrrr.fg)('ai_mate_show_store_messages');
    return {
        storeUserMessages: storeUserMessages_1,
        storeUserMessagesEligible: storeUserMessagesEligible,
        localStoreUserMessages: preferences.storeUserMessages,
        storeUserMessageMigratedToBE: preferences.storeUserMessageMigratedToBE,
        setStoreUserMessages: setStoreUserMessages,
        markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE,
        updateBackendStoreUserMessages: updateBackendStoreUserMessages
    };
};
const $24e6e2aaa4cab039$export$99abe0224d607f0e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isCurrentUserMigrated: isCurrentUserMigrated, markCurrentUserAsMigrated: markCurrentUserAsMigrated, currentUserStoreMessagesPreference: currentUserStoreMessagesPreference, updateBackendStoreUserMessages: updateBackendStoreUserMessages } = t0;
    const hasAttemptedRef = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== currentUserStoreMessagesPreference || $[1] !== isCurrentUserMigrated || $[2] !== markCurrentUserAsMigrated || $[3] !== updateBackendStoreUserMessages) {
        t1 = ()=>{
            const migrated = isCurrentUserMigrated;
            if (hasAttemptedRef.current || migrated === undefined) return;
            if (migrated) {
                hasAttemptedRef.current = true;
                return;
            }
            if (currentUserStoreMessagesPreference === false) updateBackendStoreUserMessages(false, {
                onSuccess: ()=>{
                    hasAttemptedRef.current = true;
                    markCurrentUserAsMigrated();
                }
            });
            else {
                hasAttemptedRef.current = true;
                markCurrentUserAsMigrated();
            }
        };
        t2 = [
            isCurrentUserMigrated,
            markCurrentUserAsMigrated,
            updateBackendStoreUserMessages,
            currentUserStoreMessagesPreference
        ];
        $[0] = currentUserStoreMessagesPreference;
        $[1] = isCurrentUserMigrated;
        $[2] = markCurrentUserAsMigrated;
        $[3] = updateBackendStoreUserMessages;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ isCurrentUserMigrated: isCurrentUserMigrated, markCurrentUserAsMigrated: markCurrentUserAsMigrated, currentUserStoreMessagesPreference: currentUserStoreMessagesPreference, updateBackendStoreUserMessages: updateBackendStoreUserMessages })=>{
    const hasAttemptedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const migrated = isCurrentUserMigrated;
        if (hasAttemptedRef.current || migrated === undefined) return;
        if (migrated) {
            hasAttemptedRef.current = true;
            return;
        }
        // Only explicit local opt-outs need to be migrated because BE defaults eligible users to true.
        if (currentUserStoreMessagesPreference === false) updateBackendStoreUserMessages(false, {
            onSuccess: ()=>{
                hasAttemptedRef.current = true;
                markCurrentUserAsMigrated();
            }
        });
        else {
            hasAttemptedRef.current = true;
            markCurrentUserAsMigrated();
        }
    }, [
        isCurrentUserMigrated,
        markCurrentUserAsMigrated,
        updateBackendStoreUserMessages,
        currentUserStoreMessagesPreference
    ]);
    return null;
};
module.exports["useStoreUserMessagesPreference"] = $24e6e2aaa4cab039$export$89877538e672d96b;
module.exports["StoreUserMessagesMigrationRunner"] = $24e6e2aaa4cab039$export$99abe0224d607f0e;

});

parcelRegister("bWJgt", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $bxkJA = parcelRequire("bxkJA");


var $6qEY9 = parcelRequire("6qEY9");


var $agNYn = parcelRequire("agNYn");


var $lSlzj = parcelRequire("lSlzj");


var $28iKH = parcelRequire("28iKH");


var $6eAtL = parcelRequire("6eAtL");


var $4bR59 = parcelRequire("4bR59");


var $bhC2w = parcelRequire("bhC2w");


var $7ba4g = parcelRequire("7ba4g");


var $9ay61 = parcelRequire("9ay61");


var $5xVNS = parcelRequire("5xVNS");


var $3w05Y = parcelRequire("3w05Y");


var $hpptZ = parcelRequire("hpptZ");


var $17TPK = parcelRequire("17TPK");


var $fSEmd = parcelRequire("fSEmd");


var $28dO3 = parcelRequire("28dO3");


var $764BO = parcelRequire("764BO");

const $a88caf8a3c6dcb78$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        resetHasReceivedAnswerPart: ({ messageId: messageId })=>({ dispatch: dispatch })=>{
                dispatch((0, $9ay61.resetHasReceivedAnswerPart)({
                    messageId: messageId
                }));
            },
        addImplicitResearchPlan: ({ messageId: messageId, content: content, roundId: roundId })=>({ dispatch: dispatch })=>{
                dispatch((0, $bhC2w.initResearchMessage)({
                    messageId: messageId
                }));
                dispatch((0, $6qEY9.addResearchPlan)({
                    messageId: messageId,
                    content: content,
                    title: 'Research Plan',
                    roundId: roundId
                }));
            },
        processStreamResearch: ({ messageId: messageId, streamMessage: streamMessage, isDeepResearch: isDeepResearch = false })=>({ dispatch: dispatch, getState: getState })=>{
                // Check if this is a THINK_DEEPER_TRIGGERED trace
                if ((0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) dispatch((0, $5xVNS.setHasThinkDeeperTriggered)({
                    messageId: messageId,
                    triggered: true
                }));
                if ((0, $bxkJA.isStreamResearchPlan)(streamMessage)) {
                    dispatch((0, $bhC2w.initResearchMessage)({
                        messageId: messageId
                    }));
                    dispatch((0, $6qEY9.addResearchPlan)({
                        messageId: messageId,
                        content: streamMessage.message.content,
                        title: 'Research Plan',
                        roundId: streamMessage.message.roundId
                    }));
                }
                if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) dispatch((0, $7ba4g.markAnswerPartReceived)({
                    messageId: messageId
                }));
                if ((0, $bxkJA.isStreamResearchBeginningTrace)(streamMessage)) dispatch((0, $bhC2w.initResearchMessage)({
                    messageId: messageId
                }));
                if ((0, $bxkJA.isStreamResearchStepContent)(streamMessage) || (0, $bxkJA.isStreamReasoningPart)(streamMessage)) {
                    const { stepId: stepId, content: content } = streamMessage.message;
                    const roundId = (0, $bxkJA.isStreamResearchStepContent)(streamMessage) ? streamMessage.message.roundId : getState()[messageId]?.steps[stepId]?.roundId ?? 0;
                    // append the stream chunk content to the correct step data
                    dispatch((0, $agNYn.appendStepContent)({
                        messageId: messageId,
                        stepId: stepId,
                        roundId: Number(roundId),
                        isStreamed: (0, $bxkJA.isStreamReasoningPart)(streamMessage),
                        // Show reasoning parts steps (e.g. "Creating a plan") immediately
                        // to avoid artificial delays in UI from queued step logic
                        immediate: (0, $bxkJA.isStreamReasoningPart)(streamMessage),
                        content: content
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepTitle)(streamMessage) || (0, $bxkJA.isStreamResearchStepTitleShort)(streamMessage)) {
                    const { roundId: roundId, stepId: stepId, title: title, toolIcon: toolIcon, toolName: toolName } = streamMessage.message;
                    dispatch((0, $fSEmd.setStepTitle)({
                        messageId: messageId,
                        stepId: stepId,
                        title: title,
                        roundId: Number(roundId),
                        immediate: false,
                        toolIcon: toolIcon,
                        toolName: toolName
                    }));
                }
                if ((0, $bxkJA.isStreamSkillStart)(streamMessage)) {
                    const { skill_status_metadata: skill_status_metadata } = streamMessage.message;
                    dispatch((0, $fSEmd.setStepTitle)({
                        messageId: messageId,
                        // random UUID since skills do not send stepIds, this should not matter for the step title
                        stepId: '68df4a4e-a42b-4d77-851f-6ac5d91bf38a',
                        title: skill_status_metadata?.aliases?.[0],
                        roundId: 0,
                        immediate: true,
                        isSkill: true
                    }));
                }
                if ((0, $bxkJA.isStreamSkillEnd)(streamMessage)) dispatch((0, $764BO.updateStep)({
                    messageId: messageId,
                    stepId: '12345',
                    updater: (step)=>({
                            ...step,
                            completed: true
                        })
                }));
                if ((0, $bxkJA.isStreamResearchStepSource)(streamMessage)) {
                    const { message: { sources: sources, stepId: stepId } } = streamMessage;
                    dispatch((0, $17TPK.setStepSources)({
                        messageId: messageId,
                        stepId: stepId,
                        sources: sources
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepIcons)(streamMessage)) {
                    const { products: products, stepId: stepId } = streamMessage.message;
                    const ICON_BASE_URL = '/gateway/api/assist/rovo/v1/resources/icon/';
                    dispatch((0, $hpptZ.setStepSourceIcons)({
                        messageId: messageId,
                        stepId: stepId,
                        // Backend returns short names like "jira" — prepend the full gateway path.
                        // If the path already starts with "/" or is a data URI, use it as-is.
                        sourceIcons: products.map((product)=>product.startsWith('/') || product.startsWith('data:') ? product : `${ICON_BASE_URL}${product}`)
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepDocument)(streamMessage)) {
                    const { title: title, url: url, product: product, toolName: toolName, stepId: stepId } = streamMessage.message;
                    dispatch((0, $lSlzj.appendStepDocument)({
                        messageId: messageId,
                        stepId: stepId,
                        document: {
                            stepId: stepId,
                            title: title,
                            url: url,
                            product: product,
                            toolName: toolName
                        }
                    }));
                }
                if ((0, $bxkJA.isStreamResearchStepCompleted)(streamMessage)) {
                    const { stepId: stepId } = streamMessage.message;
                    dispatch((0, $764BO.updateStep)({
                        messageId: messageId,
                        stepId: stepId,
                        updater: (step)=>({
                                ...step,
                                completed: true
                            })
                    }));
                }
                // Fail safe to complete all steps so the UI doesn't appear incomplete if there are missing chunks in the payload
                if ((0, $bxkJA.isStreamResponse)(streamMessage)) dispatch((0, $4bR59.completeAllSteps)({
                    messageId: messageId
                }));
                if (isDeepResearch) dispatch((0, $3w05Y.setIsDeepResearch)({
                    messageId: messageId
                }));
            },
        updateResearchMessageId: ({ messageId: messageId, newMessageId: newMessageId })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    [newMessageId]: getState()[messageId],
                    [messageId]: undefined
                });
            },
        incrementProgressArtificially: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const currentMessage = currentState[messageId];
                setState({
                    ...currentState,
                    [messageId]: {
                        ...currentMessage,
                        currentProgress: (0, $6eAtL.ceiledIncrement)(currentMessage?.currentProgress ?? (0, $28dO3.STARTING_PROGRESS), (0, $28iKH.ARTIFICIAL_PROGRESS_RATE))
                    }
                });
            },
        markIncompleteResearchesErrored: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const message = currentState[messageId];
                if (message && (message.currentProgress ?? 0) > 0 && !message.researchCompleted && !message.errored) setState({
                    ...currentState,
                    [messageId]: {
                        ...message,
                        errored: true
                    }
                });
            },
        completeAllSteps: ({ messageId: messageId })=>({ dispatch: dispatch })=>{
                dispatch((0, $4bR59.completeAllSteps)({
                    messageId: messageId
                }));
            },
        getMessageResearchById: ({ messageId: messageId })=>({ getState: getState })=>{
                return getState()[messageId];
            },
        /**
     * Clears all research data for a specific message.
     * Used when Answer Now is triggered to reset the research state.
     */ clearMessageResearch: ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
                const currentState = getState();
                const { [messageId]: _, ...rest } = currentState;
                setState({
                    [messageId]: undefined,
                    ...rest
                });
            }
    }
});
module.exports["store"] = $a88caf8a3c6dcb78$export$6f57813fe9f31bf9;

});

parcelRegister("guRLk", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bWJgt = parcelRequire("bWJgt");

const $94ac7e79844e2709$export$b2f14d06b1eb724e = (0, $kBr4q.createActionsHook)((0, $bWJgt.store));
module.exports["useChatMessageResearchActions"] = $94ac7e79844e2709$export$b2f14d06b1eb724e;

});

parcelRegister("O96nq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5c06eb0f3ede4a6c$export$ba3e2fddf5af0178 = (0, $cozmU.createContext)(null);
module.exports["ViewDeadAirContext"] = $5c06eb0f3ede4a6c$export$ba3e2fddf5af0178;

});

parcelRegister("j9ljO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a9e914dc295f656d544f39af86b0bf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df0f65070cf6d9c9$var$_react = $df0f65070cf6d9c9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $df0f65070cf6d9c9$var$_baseNew = $df0f65070cf6d9c9$var$_interopRequireDefault((parcelRequire("gElAV")));
function $df0f65070cf6d9c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pin-strikethrough
 * Usage guidance:
 * Known uses: Unpinning comments in Jira
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df0f65070cf6d9c9$var$PinStrikethroughIcon = (props)=>/*#__PURE__*/ $df0f65070cf6d9c9$var$_react.default.createElement($df0f65070cf6d9c9$var$_baseNew.default, Object.assign({
        name: "PinStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.18 7.54c.84.6 1.67 1.62 1.8 3.26L9.5 6.32V3.25a.75.75 0 0 1 .11-.39l.82-1.36H5.58l.82 1.36a.75.75 0 0 1 .11.39v.07L4.07.89A1.37 1.37 0 0 1 5.35 0h5.29a1.38 1.38 0 0 1 1.18 2.08L11 3.46v3.48c.33.12.75.31 1.18.61m-8.03-.22 1.11 1.11c-.18.08-.38.19-.58.33a2.7 2.7 0 0 0-1.11 1.73h3.75l1.5 1.5h-.07v4h-1.5v-4h-4.5a.75.75 0 0 1-.75-.75c0-1.9.9-3.05 1.82-3.71a5 5 0 0 1 .33-.21M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$df0f65070cf6d9c9$var$PinStrikethroughIcon.displayName = 'PinStrikethroughIcon';
var $df0f65070cf6d9c9$var$_default = module.exports.default = $df0f65070cf6d9c9$var$PinStrikethroughIcon;

});

parcelRegister("c5NbL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f33b7fd57322203150cd946304924e06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cdc1b802873a28d$var$_react = $8cdc1b802873a28d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8cdc1b802873a28d$var$_baseNew = $8cdc1b802873a28d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8cdc1b802873a28d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/reply-right
 * Usage guidance:
 * Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cdc1b802873a28d$var$ReplyRightIcon = (props)=>/*#__PURE__*/ $8cdc1b802873a28d$var$_react.default.createElement($8cdc1b802873a28d$var$_baseNew.default, Object.assign({
        name: "ReplyRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.22 2.28 3.22 3.219H8.5a8.5 8.5 0 0 0-8.5 8.5h1.5a7 7 0 0 1 7-7h4.94l-3.22 3.22 1.06 1.06 4.5-4.5a.75.75 0 0 0 0-1.06l-4.5-4.5z"/>`
    }, props));
$8cdc1b802873a28d$var$ReplyRightIcon.displayName = 'ReplyRightIcon';
var $8cdc1b802873a28d$var$_default = module.exports.default = $8cdc1b802873a28d$var$ReplyRightIcon;

});

parcelRegister("f8GSD", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("2OMPZ")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("kkLpw")).useRouterActions);

var $lfYWT = parcelRequire("lfYWT");


var $5rI5d = parcelRequire("5rI5d");


var $fi2Nk = parcelRequire("fi2Nk");


var $3Xv6j = parcelRequire("3Xv6j");


var $bBrxp = parcelRequire("bBrxp");


var $4zVkh = parcelRequire("4zVkh");


var $h4TbX = parcelRequire("h4TbX");


var $2OMPZ = parcelRequire("2OMPZ");


var $kkLpw = parcelRequire("kkLpw");


var $3klhU = parcelRequire("3klhU");


});

parcelRegister("9CUrz", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("5SM4Y")).default);

var $5SM4Y = parcelRequire("5SM4Y");


var $4Vdw7 = parcelRequire("4Vdw7");


});

parcelRegister("7nLGD", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("2MPqa")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("4dkdA")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("1HIWn")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("3bnxh")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("6R2v1")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("6R2v1")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("lk3rn")).isSameRouteMatch);

var $hW5be = parcelRequire("hW5be");


var $2MPqa = parcelRequire("2MPqa");


var $4dkdA = parcelRequire("4dkdA");


var $1HIWn = parcelRequire("1HIWn");


var $3bnxh = parcelRequire("3bnxh");


var $6R2v1 = parcelRequire("6R2v1");


var $lk3rn = parcelRequire("lk3rn");


});

parcelRegister("jfJRg", function(module, exports) {
parcelRequire("7nLGD");
var $6R2v1 = parcelRequire("6R2v1");

const $e042fd7ebcf333c2$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $6R2v1.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("bBrxp", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $iTvlA = parcelRequire("iTvlA");

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $6ZZh7 = parcelRequire("6ZZh7");

parcelRequire("7nLGD");
var $6R2v1 = parcelRequire("6R2v1");
var $2MPqa = parcelRequire("2MPqa");
var $4dkdA = parcelRequire("4dkdA");
var $1HIWn = parcelRequire("1HIWn");
var $3bnxh = parcelRequire("3bnxh");


var $4NiRC = parcelRequire("4NiRC");

parcelRequire("7nLGD");
var $lk3rn = parcelRequire("lk3rn");

const $6c0a20f08dd3a1a7$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $6c0a20f08dd3a1a7$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $6c0a20f08dd3a1a7$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $6c0a20f08dd3a1a7$var$stripTrailingSlash(prefix);
        prefix = $6c0a20f08dd3a1a7$var$addLeadingSlash(prefix);
        path = $6c0a20f08dd3a1a7$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $6c0a20f08dd3a1a7$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $6c0a20f08dd3a1a7$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$6c0a20f08dd3a1a7$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $6c0a20f08dd3a1a7$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$6c0a20f08dd3a1a7$export$e83e3719fc818ee5(path)) {
        path = $6c0a20f08dd3a1a7$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $6c0a20f08dd3a1a7$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $6c0a20f08dd3a1a7$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $6c0a20f08dd3a1a7$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $lk3rn.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $872882dff5e02243$export$36d128238e6b60f5 = {
    action: (0, $6ZZh7.DEFAULT_ACTION),
    basePath: '',
    location: (0, $6ZZh7.DEFAULT_HISTORY).location,
    history: (0, $6ZZh7.DEFAULT_HISTORY),
    match: (0, $6ZZh7.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $6ZZh7.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $872882dff5e02243$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $6R2v1.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $1HIWn.isServerEnvironment)()) dispatch($872882dff5e02243$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $6R2v1.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $6c0a20f08dd3a1a7$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iTvlA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $eb3ax.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $6c0a20f08dd3a1a7$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $6c0a20f08dd3a1a7$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $2MPqa.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $3bnxh.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $6c0a20f08dd3a1a7$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $6c0a20f08dd3a1a7$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $2MPqa.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $3bnxh.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $eb3ax.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $6c0a20f08dd3a1a7$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $6c0a20f08dd3a1a7$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $eb3ax.default)({}, existingPathParams, params);
            const updatedPath = (0, $4dkdA.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $eb3ax.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $6c0a20f08dd3a1a7$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $6c0a20f08dd3a1a7$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $872882dff5e02243$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $6c0a20f08dd3a1a7$export$2fa6dede99f181e5)(path)) {
                const location = (0, $lI7ls.parsePath)((0, $6c0a20f08dd3a1a7$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $6R2v1.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iTvlA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $872882dff5e02243$export$1cf0ecab63b1963c = (0, $8s9DV.createStore)({
    initialState: $872882dff5e02243$export$36d128238e6b60f5,
    actions: $872882dff5e02243$var$actions,
    name: 'router'
});
const $872882dff5e02243$export$d6b817abe7a77ea5 = (0, $j8on0.createContainer)($872882dff5e02243$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($872882dff5e02243$var$actions.bootstrapStore(props));
            !(0, $1HIWn.isServerEnvironment)() && dispatch($872882dff5e02243$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $1HIWn.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $872882dff5e02243$export$9569010eab09ae9e = (0, $kBr4q.createHook)($872882dff5e02243$export$1cf0ecab63b1963c);
const $872882dff5e02243$export$ada49399abf7a3a1 = (0, $kBr4q.createActionsHook)($872882dff5e02243$export$1cf0ecab63b1963c);
function $872882dff5e02243$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kBr4q.createHook)($872882dff5e02243$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $872882dff5e02243$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $c6StJ.defaultRegistry).getStore($872882dff5e02243$export$1cf0ecab63b1963c);
const $872882dff5e02243$export$ebf37f7e180b13a9 = ()=>$872882dff5e02243$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $872882dff5e02243$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $872882dff5e02243$export$d6b817abe7a77ea5;
module.exports["useRouterStore"] = $872882dff5e02243$export$9569010eab09ae9e;
module.exports["useRouterStoreActions"] = $872882dff5e02243$export$ada49399abf7a3a1;

});

parcelRegister("6ZZh7", function(module, exports) {

var $eO7Xs = parcelRequire("eO7Xs");


var $hW5be = parcelRequire("hW5be");

const $5187f8852b6ad66f$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $5187f8852b6ad66f$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $5187f8852b6ad66f$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $5187f8852b6ad66f$export$39607c9878cf5148 = (0, $hW5be.createLegacyHistory)();
const $5187f8852b6ad66f$export$1515254c8c90bebb = {
    location: $5187f8852b6ad66f$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $5187f8852b6ad66f$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $5187f8852b6ad66f$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $5187f8852b6ad66f$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $5187f8852b6ad66f$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $5187f8852b6ad66f$export$fa440ddf675c8a93;

});

parcelRegister("6QmsE", function(module, exports) {

var $22qkM = parcelRequire("22qkM");


var $iMCza = parcelRequire("iMCza");


var $iX7oN = parcelRequire("iX7oN");


var $1UAja = parcelRequire("1UAja");


var $5HsaE = parcelRequire("5HsaE");





var $gOGAf = parcelRequire("gOGAf");


});

parcelRegister("hPeO7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c81723fa3fd57974d459c11ad20a8499>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa2af89e0532b6d$var$_react = $cfa2af89e0532b6d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cfa2af89e0532b6d$var$_baseNew = $cfa2af89e0532b6d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $cfa2af89e0532b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Views".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/views
 * Usage guidance:
 * Reserved for representing saved views.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa2af89e0532b6d$var$ViewsIcon = (props)=>/*#__PURE__*/ $cfa2af89e0532b6d$var$_react.default.createElement($cfa2af89e0532b6d$var$_baseNew.default, Object.assign({
        name: "ViewsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 5.5H6v6h5a.5.5 0 0 0 .5-.5zm-9 5.5a.5.5 0 0 0 .5.5h1.5v-6h-2zm9-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1h9zm1.5 8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 12.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$cfa2af89e0532b6d$var$ViewsIcon.displayName = 'ViewsIcon';
var $cfa2af89e0532b6d$var$_default = module.exports.default = $cfa2af89e0532b6d$var$ViewsIcon;

});

parcelRegister("GMBc0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1c0fe40435a20d97ee628d09278e96a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08099f1583ed1293$var$_react = $08099f1583ed1293$var$_interopRequireDefault((parcelRequire("cozmU")));

var $08099f1583ed1293$var$_baseNew = $08099f1583ed1293$var$_interopRequireDefault((parcelRequire("gElAV")));
function $08099f1583ed1293$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonLockLocked".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/person-lock-locked
 * Usage guidance:
 * Reserved for restricted user permissions or access.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08099f1583ed1293$var$PersonLockLockedIcon = (props)=>/*#__PURE__*/ $08099f1583ed1293$var$_react.default.createElement($08099f1583ed1293$var$_baseNew.default, Object.assign({
        name: "PersonLockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0"/><path fill="currentcolor" fill-rule="evenodd" d="M13 8.5a2 2 0 0 1 2 2v1.253c.558.032 1 .494 1 1.06v2.124c0 .587-.476 1.063-1.062 1.063h-3.876A1.063 1.063 0 0 1 10 14.938v-2.126c0-.565.442-1.027 1-1.06V10.5a2 2 0 0 1 2-2m0 1.5a.5.5 0 0 0-.5.5v1.25h1V10.5a.5.5 0 0 0-.5-.5" clip-rule="evenodd"/>`
    }, props));
$08099f1583ed1293$var$PersonLockLockedIcon.displayName = 'PersonLockLockedIcon';
var $08099f1583ed1293$var$_default = module.exports.default = $08099f1583ed1293$var$PersonLockLockedIcon;

});

parcelRegister("brN3F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9fe894d132a690d4$export$ffc3a5a41117aa99 = (0, $cozmU.createContext)(null);
module.exports["PlaceholderOverrideDispatchContext"] = $9fe894d132a690d4$export$ffc3a5a41117aa99;

});

parcelRegister("5RYbF", function(module, exports) {
const $48996eab5175a484$var$SHARE_PROMPTS_URL = 'https://rovo.com/';
const $48996eab5175a484$export$5a15fc2945662334 = (promptIds)=>{
    const ids = Array.isArray(promptIds) ? promptIds : [
        promptIds
    ];
    const url = new URL($48996eab5175a484$var$SHARE_PROMPTS_URL);
    url.searchParams.set('promptIds', ids.join(','));
    return url.toString();
};
module.exports["generateShareLink"] = $48996eab5175a484$export$5a15fc2945662334;

});

parcelRegister("637t4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $91ZZN = parcelRequire("91ZZN");


var $dw75i = parcelRequire("dw75i");


var $9K1UB = parcelRequire("9K1UB");


var $5Wcst = parcelRequire("5Wcst");


var $bBgYs = parcelRequire("bBgYs");


var $e02Sx = parcelRequire("e02Sx");

const $5bbec4007835f4f8$var$CONVO_AI_DEDICATED_RENDERER_KEYS = new Set([
    (0, $dw75i.ActionKeys).ExecutePython,
    (0, $dw75i.ActionKeys).PlanComplete,
    (0, $dw75i.ActionKeys).AskQuestion,
    (0, $dw75i.ActionKeys).AgenticPlanTool,
    (0, $dw75i.ActionKeys).JiraAdminAgent,
    (0, $dw75i.ActionKeys).MultipleChoiceQuestionsTool
]);
const $5bbec4007835f4f8$var$ROVO_TOOLS_RESUMPTION_MIGRATED_RENDERER_KEYS = new Set([
    (0, $dw75i.ActionKeys).GoogleCalendarEventCreate,
    (0, $dw75i.ActionKeys).GoogleDocCreate,
    (0, $dw75i.ActionKeys).SlackSendChannelMessage,
    (0, $dw75i.ActionKeys).ConfluencePageCreate,
    (0, $dw75i.ActionKeys).ConfluencePageComment,
    (0, $dw75i.ActionKeys).ConfluencePageAddLabel,
    (0, $dw75i.ActionKeys).ConfluencePageRename,
    (0, $dw75i.ActionKeys).ConfluencePageMove,
    (0, $dw75i.ActionKeys).AifcAdfUpdate
]);
const $5bbec4007835f4f8$var$ROVO_TOOLS_RESUMPTION_CONDITIONED_RENDERER_KEYS = new Set([
    (0, $dw75i.ActionKeys).GoogleCalendarEventCreate,
    (0, $dw75i.ActionKeys).GoogleDocCreate,
    (0, $dw75i.ActionKeys).SlackSendChannelMessage
]);
const $5bbec4007835f4f8$var$hasConvoAiDedicatedRenderer = (actionKey, isRovoToolsResumptionMigrationEnabled)=>{
    return $5bbec4007835f4f8$var$CONVO_AI_DEDICATED_RENDERER_KEYS.has(actionKey) || $5bbec4007835f4f8$var$ROVO_TOOLS_RESUMPTION_MIGRATED_RENDERER_KEYS.has(actionKey) && isRovoToolsResumptionMigrationEnabled || actionKey === (0, $dw75i.ActionKeys).ConfluenceFolderCreate && (0, $iDrrr.fg)('confluence_folder_create_action_custom_ui');
};
const $5bbec4007835f4f8$var$getActionGroupKey = (action, isRovoToolsResumptionMigrationEnabled)=>{
    const jiraPlansCustomUiActionKey = (0, $5Wcst.jiraPlansActionData).getCustomUiActionKey(action);
    const shouldRouteToJiraPlansCustomUi = jiraPlansCustomUiActionKey !== undefined && ((0, $5Wcst.jiraPlansActionData).isAnthropicActionKey(jiraPlansCustomUiActionKey) || (0, $5Wcst.jiraPlansActionData).isLegacyActionKey(jiraPlansCustomUiActionKey));
    if (Boolean(action.toolSource) && !$5bbec4007835f4f8$var$hasConvoAiDedicatedRenderer(action.key, isRovoToolsResumptionMigrationEnabled) && action.key !== (0, $dw75i.JSM_CREATE_REQUEST_KEY) && action.key !== (0, $dw75i.JSM_CREATE_REQUEST_V2_KEY) && action.key !== (0, $dw75i.HIRING_MANAGER_TOOL_KEY) && action.key !== (0, $dw75i.CREATE_REQUEST_KEY) && !(action.key === (0, $dw75i.FOCUS_CREATE_ASK_KEY) && (0, $iDrrr.fg)('display_components_for_create-focus-ask_skill')) && !(action.key === (0, $dw75i.ActionKeys).JiraCreateSprint || action.key === (0, $dw75i.ActionKeys).JiraStartSprint || action.key === (0, $dw75i.ActionKeys).JiraMoveToSprint) && !shouldRouteToJiraPlansCustomUi) return (0, $dw75i.ActionPredicateKeys).Resumption;
    return jiraPlansCustomUiActionKey ?? action.key;
};
const $5bbec4007835f4f8$var$groupActionsByKey = (actions, getActionGroupKey)=>{
    return actions.reduce((groups, action)=>{
        const key = getActionGroupKey?.(action) || action.key;
        if (!groups[key]) groups[key] = [];
        groups[key].push(action);
        return groups;
    }, {});
};
const $5bbec4007835f4f8$export$3e7a34d0e98b0c66 = (actions, props, actionAnalytics)=>{
    (0, $6cFsl.di)((0, $7akNQ.FlagsProvider), (0, $e02Sx.useActionRenderer), (0, $kSwu1.useIntl));
    const normalizedActions = (0, $5Wcst.jiraPlansActionData).normalizeCustomUiActions(actions);
    const shouldEvaluateRovoToolsResumptionMigration = normalizedActions.some((action)=>$5bbec4007835f4f8$var$ROVO_TOOLS_RESUMPTION_CONDITIONED_RENDERER_KEYS.has(action.key) || Boolean(action.toolSource) && $5bbec4007835f4f8$var$ROVO_TOOLS_RESUMPTION_MIGRATED_RENDERER_KEYS.has(action.key));
    const isRovoToolsResumptionMigrationEnabled = shouldEvaluateRovoToolsResumptionMigration && (0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false);
    const getRovoToolsResumptionMigrationEnabled = (0, $cozmU.useCallback)(()=>isRovoToolsResumptionMigrationEnabled, [
        isRovoToolsResumptionMigrationEnabled
    ]);
    const { getActionRenderer: getActionRenderer } = (0, $e02Sx.useActionRenderer)(getRovoToolsResumptionMigrationEnabled);
    if (!normalizedActions.length || !normalizedActions[0]) return null;
    const groupedActions = $5bbec4007835f4f8$var$groupActionsByKey(normalizedActions, (action_0)=>$5bbec4007835f4f8$var$getActionGroupKey(action_0, isRovoToolsResumptionMigrationEnabled));
    const nodes = Object.entries(groupedActions).flatMap(([groupKey, actions_0])=>{
        const { ActionRenderer: ActionRenderer, ActionRendererFallback: ActionRendererFallback } = getActionRenderer(groupKey, actions_0);
        if (ActionRenderer) {
            const Fallback = ActionRendererFallback ?? (0, $9K1UB.DefaultActionRendererSkeleton);
            return [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBgYs.ErrorBoundaryWithAnalytics), {
                    key: groupKey,
                    action: actions_0[0],
                    onError: actionAnalytics?.onErrorRender
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                    interactionName: `rovo-conversation-assistant-message-action-${groupKey}`,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Fallback, null)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActionRenderer, {
                    actions: actions_0,
                    ...props
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBgYs.SuccessEventComponent), {
                    action: actions_0[0],
                    onSuccess: actionAnalytics?.onSuccessRender
                })))
            ];
        }
        return [];
    });
    if (nodes.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, nodes));
    return undefined;
};
const $5bbec4007835f4f8$export$ef8aa45067b257a9 = [
    (0, $dw75i.JIRA_FIND_ISSUES_KEY),
    (0, $dw75i.JIRA_EPICS_SUGGEST_KEY),
    (0, $dw75i.JIRA_ISSUE_DELETE_KEY),
    (0, $dw75i.JIRA_ISSUE_MOVE_KEY)
];
const $5bbec4007835f4f8$var$isConfluenceRenamePageActionEnabled = // eslint-disable-next-line @atlaskit/platform/no-module-level-eval, @atlaskit/platform/use-recommended-utils
(0, $cXtTj.default).getExperimentValue('confluence_rename_page_rovo_action_custom_ui', 'isEnabled', false, {
    fireExperimentExposure: false
});
const $5bbec4007835f4f8$var$isConfluenceAddLabelActionEnabled = // eslint-disable-next-line @atlaskit/platform/no-module-level-eval, @atlaskit/platform/use-recommended-utils
(0, $cXtTj.default).getExperimentValue('confluence_add_page_label_rovo_action_custom_ui', 'isEnabled', false, {
    fireExperimentExposure: false
});
const $5bbec4007835f4f8$var$isConfluencePageMoveActionEnabled = // eslint-disable-next-line @atlaskit/platform/no-module-level-eval, @atlaskit/platform/use-recommended-utils
(0, $cXtTj.default).getExperimentValue('confluence_move_page_rovo_action_custom_ui', 'isEnabled', false, {
    fireExperimentExposure: false
});
const $5bbec4007835f4f8$export$fa4ffbced68d364c = ()=>[
        (0, $dw75i.CONFLUENCE_PAGE_CREATE_KEY),
        (0, $dw75i.CONFLUENCE_PAGE_COMMENT_KEY),
        $5bbec4007835f4f8$var$isConfluenceRenamePageActionEnabled && (0, $dw75i.CONFLUENCE_PAGE_RENAME_KEY),
        $5bbec4007835f4f8$var$isConfluenceAddLabelActionEnabled && (0, $dw75i.CONFLUENCE_PAGE_ADD_LABEL_KEY),
        $5bbec4007835f4f8$var$isConfluencePageMoveActionEnabled && (0, $dw75i.CONFLUENCE_PAGE_MOVE_KEY),
        (0, $iDrrr.fg)('rovo_chat_store_recommendation_action') && (0, $dw75i.STORE_RECOMMENDATION_ACTION_KEY),
        (0, $iDrrr.fg)('surveys-aifc') && (0, $dw75i.JSM_CREATE_SURVEY_KEY),
        (0, $iDrrr.fg)('display_components_for_create-focus-ask_skill') && (0, $dw75i.FOCUS_CREATE_ASK_KEY),
        (0, $iDrrr.fg)('rovo_chat_jira_create_view_skill') && (0, $dw75i.JIRA_VIEW_CREATE_AND_CONFIGURE_KEY)
    ];
const $5bbec4007835f4f8$export$40fa765365f5725a = (action)=>{
    if ($5bbec4007835f4f8$export$fa4ffbced68d364c().includes(action.key)) return true;
    return (0, $5Wcst.jiraPlansActionData).shouldNotRenderLLMContentForAction(action);
};
module.exports["useCustomMessageActionBroker"] = $5bbec4007835f4f8$export$3e7a34d0e98b0c66;
module.exports["shouldNotRenderLLMContentForAction"] = $5bbec4007835f4f8$export$40fa765365f5725a;

});

parcelRegister("e02Sx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $2d34v = parcelRequire("2d34v");


var $9hOLl = parcelRequire("9hOLl");


var $3OVMn = parcelRequire("3OVMn");


var $19ZSn = parcelRequire("19ZSn");


var $aYC8J = parcelRequire("aYC8J");


var $hlvTd = parcelRequire("hlvTd");


var $8DILb = parcelRequire("8DILb");


var $dw75i = parcelRequire("dw75i");


var $5ZPoU = parcelRequire("5ZPoU");


var $3kSZk = parcelRequire("3kSZk");


var $j56L4 = parcelRequire("j56L4");


var $4yZQ6 = parcelRequire("4yZQ6");


var $gIOr8 = parcelRequire("gIOr8");


var $5I0Ux = parcelRequire("5I0Ux");


var $2TX7O = parcelRequire("2TX7O");


var $5Wcst = parcelRequire("5Wcst");


var $4w5r5 = parcelRequire("4w5r5");


var $30m9b = parcelRequire("30m9b");


var $aGfhs = parcelRequire("aGfhs");


var $4uwm1 = parcelRequire("4uwm1");


var $iWLwj = parcelRequire("iWLwj");


var $7m0gB = parcelRequire("7m0gB");


var $01ZUS = parcelRequire("01ZUS");


var $kHCjc = parcelRequire("kHCjc");


var $j4dZf = parcelRequire("j4dZf");


var $boM6r = parcelRequire("boM6r");


var $1XOZs = parcelRequire("1XOZs");


var $9XLO4 = parcelRequire("9XLO4");


var $2rhig = parcelRequire("2rhig");


var $a5Acp = parcelRequire("a5Acp");


var $7rNAq = parcelRequire("7rNAq");


var $8sOc2 = parcelRequire("8sOc2");


var $3kRwn = parcelRequire("3kRwn");


var $l4RVM = parcelRequire("l4RVM");


var $kkxnf = parcelRequire("kkxnf");


var $kO9z8 = parcelRequire("kO9z8");


var $lbVAr = parcelRequire("lbVAr");


var $8qYrI = parcelRequire("8qYrI");


var $8wx27 = parcelRequire("8wx27");


var $ggoXy = parcelRequire("ggoXy");


var $htorK = parcelRequire("htorK");


var $ds1P0 = parcelRequire("ds1P0");


var $lBUo6 = parcelRequire("lBUo6");


var $826v6 = parcelRequire("826v6");


var $dGil5 = parcelRequire("dGil5");


var $7xBPz = parcelRequire("7xBPz");


var $4kt37 = parcelRequire("4kt37");


var $3cDnE = parcelRequire("3cDnE");


var $jw6cP = parcelRequire("jw6cP");


var $lLxBZ = parcelRequire("lLxBZ");


var $8TK0r = parcelRequire("8TK0r");


var $9bgOM = parcelRequire("9bgOM");


var $9e8iJ = parcelRequire("9e8iJ");


var $6AKbq = parcelRequire("6AKbq");


var $bKD9u = parcelRequire("bKD9u");


var $48tRp = parcelRequire("48tRp");


var $eMnb3 = parcelRequire("eMnb3");


var $1Bv1o = parcelRequire("1Bv1o");


var $lA8Lt = parcelRequire("lA8Lt");


var $gnApE = parcelRequire("gnApE");


var $6VP9j = parcelRequire("6VP9j");


var $c9HnQ = parcelRequire("c9HnQ");


var $d7n6A = parcelRequire("d7n6A");


var $2YoWj = parcelRequire("2YoWj");


var $7hpvX = parcelRequire("7hpvX");


var $iaX6U = parcelRequire("iaX6U");


var $zlRck = parcelRequire("zlRck");


var $lKXhN = parcelRequire("lKXhN");


var $iSPda = parcelRequire("iSPda");


var $kWSOP = parcelRequire("kWSOP");


var $2ZDVq = parcelRequire("2ZDVq");


var $4hmYp = parcelRequire("4hmYp");


var $57C1v = parcelRequire("57C1v");


var $dG9ot = parcelRequire("dG9ot");


var $jJX9i = parcelRequire("jJX9i");


var $e047Q = parcelRequire("e047Q");


var $2ir3c = parcelRequire("2ir3c");


var $4OXVs = parcelRequire("4OXVs");


var $bG2tP = parcelRequire("bG2tP");


var $3D4BT = parcelRequire("3D4BT");


var $43hIk = parcelRequire("43hIk");


var $9253K = parcelRequire("9253K");


var $7MXyP = parcelRequire("7MXyP");


var $6Unds = parcelRequire("6Unds");


var $ahA41 = parcelRequire("ahA41");


var $3eC2G = parcelRequire("3eC2G");


var $6RfAT = parcelRequire("6RfAT");


var $ccGNc = parcelRequire("ccGNc");


var $9Ac08 = parcelRequire("9Ac08");

const $349c7a2c19bab36d$var$jiraGatedRegistery = {
    [(0, $dw75i.ActionKeys).UpdateWorkItemFields]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkItemFields,
        renderer: (0, $gIOr8.JiraUpdateWorkItemFieldsActionRenderer),
        fallback: (0, $5I0Ux.JiraUpdateWorkItemFieldsActionSkeleton),
        validate: (0, $2TX7O.validateJiraUpdateWorkItemFieldsAction),
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'work-item',
                    objectId: action.data.issueId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).CreateProjectProgressUpdate]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createProjectProgressUpdate,
        renderer: (0, $aGfhs.CreateProjectProgressUpdateActionRenderer),
        fallback: (0, $4uwm1.CreateProjectProgressUpdateActionSkeleton),
        validate: (0, $iWLwj.validateCreateProjectProgressUpdateAction),
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'project',
                    objectId: action.data.projectId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkItems,
        renderer: (0, $3kSZk.JiraUpdateWorkItemAllFieldTypesActionRenderer),
        fallback: (0, $j56L4.JiraUpdateWorkItemAllFieldTypesActionSkeleton),
        validate: (0, $4yZQ6.validateJiraUpdateWorkAllFieldTypesAction),
        getAdoptedObjects: (action)=>(action.data.updates ?? []).map((update)=>({
                    objectType: 'work-item',
                    objectId: update.issueIdOrKey
                }))
    }
};
const $349c7a2c19bab36d$var$hamOnboardingSetupCompleteEntry = {
    readonlyTitle: (0, $9Ac08.readonlyTitleMessages).completeSetup,
    readonlyProduct: 'jsm',
    condition: ()=>(0, $iDrrr.fg)('itam_ftw'),
    renderer: (props)=>{
        (0, $6cFsl.di)((0, $kO9z8.HamOnboardingHardwareLink));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kO9z8.HamOnboardingHardwareLink), props);
    }
};
const $349c7a2c19bab36d$var$defaultGetRovoToolsResumptionMigrationEnabled = ()=>(0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false);
const $349c7a2c19bab36d$var$createRovoToolsResumptionMigrationRegistry = (getRovoToolsResumptionMigrationEnabled)=>({
        [(0, $dw75i.ActionKeys).SlackSendChannelMessage]: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).sendSlackMessage,
            readonlyProduct: 'slack',
            renderer: (0, $4OXVs.SlackSendChannelMessageRendererAsync),
            condition: getRovoToolsResumptionMigrationEnabled
        },
        [(0, $dw75i.ActionKeys).GoogleCalendarEventCreate]: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createCalendarEvent,
            readonlyProduct: 'google-calendar',
            renderer: (0, $l4RVM.GoogleCalendarEventCreateRendererAsync),
            condition: getRovoToolsResumptionMigrationEnabled
        },
        [(0, $dw75i.ActionKeys).GoogleDocCreate]: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createDocument,
            readonlyProduct: 'google-doc',
            renderer: (0, $kkxnf.GoogleDocCreateRendererAsync),
            condition: getRovoToolsResumptionMigrationEnabled
        }
    });
const $349c7a2c19bab36d$var$unifiedRegistery = {
    // Jira Actions
    [(0, $dw75i.ActionKeys).JiraFindIssues]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).findWorkItems,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $ds1P0.JiraFindIssuesAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ds1P0.JiraFindIssuesAction), props);
        }
    },
    [(0, $dw75i.ActionKeys).JiraSmartIssueCreateAllField]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createWorkItem,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider), (0, $ggoXy.JiraSmartIssueCreateAllFieldAction));
            if ((0, $iDrrr.fg)('jira-aifc-migrate-action-renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ggoXy.JiraSmartIssueCreateAllFieldAction), props);
            // Otherwise defer to the streaming action renderer
            return undefined;
        }
    },
    [(0, $dw75i.ActionKeys).JiraAdminAgent]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).jiraAdminAction,
        renderer: (props)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $19ZSn.JiraAdminAgentRenderer), props);
        },
        validate: (action)=>{
            const payload = (0, $3OVMn.validateJiraAdminAgentAction)(action.data);
            if (payload) return {
                isValid: true,
                action: action
            };
            return {
                isValid: false,
                error: new Error(`Invalid ${action.key || ''} action payload`)
            };
        },
        condition: ()=>(0, $iDrrr.fg)('fe_jira_admin_agent_eap')
    },
    [(0, $dw75i.ActionKeys).JiraIssueTransition]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).transitionWorkItem,
        renderer: (0, $7xBPz.JiraIssueTransitionAction),
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'work-item',
                    objectId: action.data.ari
                }
            ]
    },
    [(0, $dw75i.ActionKeys).JiraEpicsSuggest]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).suggestEpics,
        renderer: (0, $htorK.JiraEpicsSuggestAction)
    },
    [(0, $dw75i.ActionKeys).JiraIssueDelete]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).deleteWorkItem,
        renderer: (0, $826v6.JiraIssueDeleteAction),
        getAdoptedObjects: (action)=>(action.data.issues ?? []).map((issue)=>({
                    objectType: 'work-item',
                    objectId: issue.issueKey
                }))
    },
    [(0, $dw75i.ActionKeys).JiraIssueMove]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).moveWorkItem,
        renderer: (0, $dGil5.JiraIssueMoveAction),
        getAdoptedObjects: (action)=>(action.data.issues ?? []).map((issue)=>({
                    objectType: 'work-item',
                    objectId: issue.issueKey
                }))
    },
    [(0, $dw75i.ActionKeys).JiraIssueAssign]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).assignWorkItem,
        renderer: (0, $lBUo6.JiraIssueAssignAction),
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'work-item',
                    objectId: action.data.ari
                }
            ]
    },
    [(0, $dw75i.ActionKeys).JiraVersionCreate]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRelease,
        renderer: (0, $eMnb3.JiraVersionCreateAction)
    },
    [(0, $dw75i.ActionKeys).JiraViewCreateAndConfigure]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createView,
        renderer: (0, $1Bv1o.JiraViewCreateAndConfigureAction)
    },
    [(0, $dw75i.ActionKeys).JiraCreateSprint]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createSprint,
        renderer: (0, $8wx27.JiraCreateSprintAction)
    },
    [(0, $dw75i.ActionKeys).JiraStartSprint]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).startSprint,
        renderer: (0, $48tRp.JiraStartSprintAction)
    },
    [(0, $dw75i.ActionKeys).JiraMoveToSprint]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).moveToSprint,
        renderer: (0, $4kt37.JiraMoveToSprintAction)
    },
    [(0, $dw75i.ActionKeys).ManageCapacityPlan]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).manageCapacityPlan,
        readonlyProduct: 'capacity-planning',
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider));
            return (0, $iDrrr.fg)('ai_features_in_icp_m1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01ZUS.CapacityPlanningActionRenderer), props) : undefined;
        }
    },
    [(0, $dw75i.ActionKeys).JiraWorkflowEditor]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkflow,
        renderer: (0, $lA8Lt.JiraWorkflowEditorUIAction)
    },
    // Confluence Actions
    [(0, $dw75i.ActionKeys).ConfluencePageCreate]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createPage,
        readonlyProduct: 'confluence',
        renderer: (0, $9XLO4.ConfluencePageCreateAction)
    },
    [(0, $dw75i.ActionKeys).ConfluenceFolderCreate]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createFolder,
        readonlyProduct: 'confluence',
        renderer: (0, $j4dZf.ConfluenceFolderCreateAction),
        condition: ()=>(0, $iDrrr.fg)('confluence_folder_create_action_custom_ui')
    },
    [(0, $dw75i.ActionKeys).ConfluencePageComment]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).commentOnPage,
        readonlyProduct: 'confluence',
        renderer: (0, $1XOZs.ConfluencePageCommentAction),
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'page',
                    objectId: action.data.contentId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).AifcAdfUpdate]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).editContent,
        readonlyProduct: 'confluence',
        renderer: (props)=>// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            (0, $cXtTj.default).checkGate('aifc_adf_update_tool') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kHCjc.ConfluenceAifcAdfUpdateAction), props) : undefined,
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'page',
                    objectId: action.data.contentId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).ConfluencePageAddLabel]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).addLabel,
        readonlyProduct: 'confluence',
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider));
            // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            return (0, $cXtTj.default).getExperimentValue('confluence_add_page_label_rovo_action_custom_ui', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $boM6r.ConfluencePageAddLabelAction), props) : undefined;
        },
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'page',
                    objectId: action.data.id
                }
            ]
    },
    [(0, $dw75i.ActionKeys).ConfluencePageRename]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).renamePage,
        readonlyProduct: 'confluence',
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        condition: ()=>(0, $cXtTj.default).getExperimentValue('confluence_rename_page_rovo_action_custom_ui', 'isEnabled', false),
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $a5Acp.ConfluencePageRenameAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5Acp.ConfluencePageRenameAction), props);
        },
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'page',
                    objectId: action.data.documentId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).ConfluencePageMove]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).movePage,
        readonlyProduct: 'confluence',
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        condition: ()=>(0, $cXtTj.default).getExperimentValue('confluence_move_page_rovo_action_custom_ui', 'isEnabled', false),
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $2rhig.ConfluencePageMoveAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2rhig.ConfluencePageMoveAction), props);
        },
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'page',
                    objectId: action.data.documentId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).JsmJourneyBuilder]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequest,
        readonlyProduct: 'jsm',
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7hpvX.JsmJourneyBuilderUIActionAsync));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hpvX.JsmJourneyBuilderUIActionAsync), props);
        }
    },
    [(0, $dw75i.ActionKeys).JsmCreateRequest]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequest,
        readonlyProduct: 'jsm',
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider), (0, $d7n6A.JsmCreateRequestAction));
            return (0, $iDrrr.fg)('service_agent_jsm_request_custom_ui') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7n6A.JsmCreateRequestAction), props) : undefined;
        }
    },
    [(0, $dw75i.ActionKeys).JsmCreateRequestV2]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequest,
        readonlyProduct: 'jsm',
        renderer: (0, $d7n6A.JsmCreateRequestAction)
    },
    [(0, $dw75i.ActionKeys).CreateRequest]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequest,
        readonlyProduct: 'jsm',
        renderer: (0, $d7n6A.JsmCreateRequestAction)
    },
    [(0, $dw75i.ActionKeys).JsmCreateEmbeddedRequest]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequest,
        readonlyProduct: 'jsm',
        renderer: (0, $gnApE.JsmCreateEmbeddedRequestAction)
    },
    [(0, $dw75i.ActionKeys).JsmSolutionComposerPlanSummary]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).buildSolution,
        readonlyProduct: 'jsm',
        renderer: (0, $lKXhN.JsmSolutionComposerPlanAction)
    },
    [(0, $dw75i.ActionKeys).JsmSuggestAndAddFieldsToRequestType]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateRequestType,
        readonlyProduct: 'jsm',
        renderer: (0, $2ZDVq.JsmUpdateRequestTypeAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianProjectCreateJsmRequestTypeWithFields]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequestType,
        readonlyProduct: 'jsm',
        renderer: (0, $2YoWj.JsmCreateRequestTypeAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianProjectCreateJsmQueue]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createQueue,
        readonlyProduct: 'jsm',
        renderer: (0, $6VP9j.JsmCreateQueueAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianProjectCreateJsmQueueGroup]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createQueueGroup,
        readonlyProduct: 'jsm',
        renderer: (0, $c9HnQ.JsmCreateQueueGroupAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianProjectUpdateJsmQueue]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateQueue,
        readonlyProduct: 'jsm',
        renderer: (0, $iSPda.JsmUpdateQueueAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianProjectUpdateJsmQueueGroup]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateQueueGroup,
        readonlyProduct: 'jsm',
        renderer: (0, $kWSOP.JsmUpdateQueueGroupAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianProjectUpdateRequestTypePortalGroups]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updatePortalGroups,
        readonlyProduct: 'jsm',
        renderer: (0, $4hmYp.JsmUpdateRequestTypePortalGroupsAction)
    },
    [(0, $dw75i.ActionKeys).JsmAtlassianRequestTypeUpdateWorkflow]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateRequestTypeWorkflow,
        readonlyProduct: 'jsm',
        renderer: (0, $57C1v.JsmUpdateRequestTypeWorkflowAction)
    },
    [(0, $dw75i.ActionKeys).JsmSelectHardwareTypes]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).selectHardwareTypes,
        readonlyProduct: 'jsm',
        condition: ()=>(0, $iDrrr.fg)('itam_ftw'),
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider), (0, $zlRck.JsmSelectHardwareTypesAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $zlRck.JsmSelectHardwareTypesAction), props);
        }
    },
    [(0, $dw75i.ActionKeys).JsmSelectHardwareTypesSkill]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).selectHardwareTypes,
        readonlyProduct: 'jsm',
        condition: ()=>(0, $iDrrr.fg)('itam_ftw'),
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider), (0, $zlRck.JsmSelectHardwareTypesAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $zlRck.JsmSelectHardwareTypesAction), props);
        }
    },
    [(0, $dw75i.ActionKeys).HamOnboardingSetupComplete]: $349c7a2c19bab36d$var$hamOnboardingSetupCompleteEntry,
    [(0, $dw75i.ActionKeys).HamOnboardingSetupCompleteSkill]: $349c7a2c19bab36d$var$hamOnboardingSetupCompleteEntry,
    // Deep Research Actions
    [(0, $dw75i.ActionKeys).DeepResearchCreatePageAction]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).deepResearchReport,
        readonlyProduct: 'confluence',
        renderer: (0, $7rNAq.DeepResearchActions)
    },
    // Studio Actions
    [(0, $dw75i.ActionKeys).StudioAutomationTriggerRuleBuild]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).buildSolution,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $43hIk.StudioAutomationTriggerRuleBuildAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43hIk.StudioAutomationTriggerRuleBuildAction), props);
        }
    },
    [(0, $dw75i.ActionKeys).StudioAutomationCreateRule]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createAutomationRule,
        condition: ()=>(0, $iDrrr.fg)('sltns-1087-automation-create-rule-card'),
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $3D4BT.StudioAutomationCreateRuleAction));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3D4BT.StudioAutomationCreateRuleAction), props);
        }
    },
    [(0, $dw75i.ActionKeys).StudioTriggerSolutionPlan]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).buildSolution,
        renderer: (0, $ahA41.StudioTriggerSolutionBuildAction)
    },
    [(0, $dw75i.ActionKeys).RequireInformationTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).respondToPrompt,
        renderer: (0, $jJX9i.RequireInformationUIAction)
    },
    [(0, $dw75i.ActionKeys).HiringManagerTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).hiringManagerAction,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider));
            return (0, $iDrrr.fg)('hiring_manager_action_button_choices_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lbVAr.HiringManagerToolUIAction), props) : null;
        }
    },
    [(0, $dw75i.ActionKeys).StudioUpdateAgentDraft]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateAgentDraft,
        renderer: (0, $3eC2G.StudioUpdateAgentDraftAction)
    },
    [(0, $dw75i.ActionKeys).UpdateAgentConfigurationTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateAgentConfiguration,
        renderer: (0, $6RfAT.UpdateAgentConfigurationAction)
    },
    [(0, $dw75i.ActionKeys).StudioWorkspaceUpdateAgentDraft]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateAgentDraft,
        renderer: (0, $ccGNc.StudioWorkspaceUpdateAgentDraftAction)
    },
    [(0, $dw75i.ActionKeys).StudioCreateAgent]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createAgent,
        renderer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9253K.StudioCreateAgentRenderer), props)
    },
    [(0, $dw75i.ActionKeys).StoreRecommendationCard]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).viewRecommendation,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider));
            return (0, $iDrrr.fg)('rovo_chat_store_recommendation_action') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bG2tP.StoreRecommendationAction), props) : undefined;
        }
    },
    [(0, $dw75i.ActionKeys).StudioLandingPageRedirect]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).openStudio,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $6Unds.StudioLandingPageRedirect));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Unds.StudioLandingPageRedirect), props);
        }
    },
    [(0, $dw75i.ActionKeys).AtlassianTeamUpdateArchive]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).archiveTeam,
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider));
            return (0, $iDrrr.fg)('enable_clean_up_teams_agentic_skill') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m0gB.AtlassianTeamUpdateArchiveAction), props) : undefined;
        },
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'team',
                    objectId: action.data.teamId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).FocusCreateAsk]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createAsks,
        readonlyProduct: 'focus-ask',
        renderer: (props)=>{
            (0, $6cFsl.di)((0, $7akNQ.FlagsProvider), (0, $3kRwn.FocusAskCreateAction));
            if (!(0, $iDrrr.fg)('display_components_for_create-focus-ask_skill') || !props.orgId) return undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3kRwn.FocusAskCreateAction), {
                ...props,
                orgId: props.orgId
            });
        }
    },
    [(0, $dw75i.ActionKeys).ScheduledChat]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).scheduleChat,
        readonlyProduct: 'schedule',
        renderer: (props)=>// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            (0, $cXtTj.default).getExperimentValue('rovo_chat_scheduled_chat', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ir3c.ScheduledChatAction), props) : undefined
    },
    [(0, $dw75i.ActionKeys).MultipleChoiceQuestionsTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).reviewChoices,
        readonlyProduct: 'ask-question',
        renderer: (props)=>(0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9hOLl.MultipleChoiceQuestionsToolInChat), {
                ...props,
                AskQuestionCompletedView: (0, $4w5r5.AskQuestionCompletedView)
            }) : undefined
    },
    [(0, $dw75i.ActionKeys).AgenticPlanTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).completePlan,
        readonlyProduct: 'plan',
        renderer: (props)=>(0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d34v.AgenticPlanToolInChat), props) : undefined
    },
    // Convo AI agent tools
    [(0, $dw75i.ActionKeys).ExecutePython]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).respondToPrompt,
        renderer: (0, $8sOc2.ExecutePythonRendererAsync)
    },
    [(0, $dw75i.ActionKeys).PlanComplete]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).completePlan,
        readonlyProduct: 'plan',
        readonlyRenderer: (0, $dG9ot.PlanCompleteReadOnlyRendererAsync),
        renderer: (0, $dG9ot.PlanCompleteRendererAsync)
    },
    [(0, $dw75i.ActionKeys).AskQuestion]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).askQuestion,
        readonlyProduct: 'ask-question',
        readonlyRenderer: (0, $30m9b.AskQuestionReadOnlyRendererAsync),
        renderer: (0, $30m9b.AskQuestionRendererAsync)
    },
    [(0, $dw75i.ActionKeys).ImageSearch]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).searchImages,
        renderer: (0, $8qYrI.ImageSearchActionAsync)
    },
    // Bitbucket
    [(0, $dw75i.ActionKeys).BitbucketPullRequestComment]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).commentOnPullRequest,
        renderer: undefined,
        getAdoptedObjects: (action)=>[
                {
                    objectType: 'pull-request',
                    objectId: action.data.pullRequestId
                }
            ]
    },
    [(0, $dw75i.ActionKeys).CreateKBCard]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createKnowledgeBaseContent,
        renderer: (0, $8DILb.CreateKBCard)
    },
    [(0, $dw75i.ActionKeys).CreateKbArticlesCard]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createKnowledgeBaseContent,
        renderer: (0, $8DILb.CreateKBCard)
    },
    [(0, $dw75i.ActionKeys).CreateCustomSkillTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createCustomSkill,
        renderer: (props)=>{
            if (!(0, $iDrrr.fg)('studio_custom_skills_m1_frontend')) return undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7MXyP.StudioCustomSkillRenderer), props);
        }
    },
    [(0, $dw75i.ActionKeys).UpdateCustomSkillTool]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateCustomSkill,
        renderer: (props)=>{
            if (!(0, $iDrrr.fg)('studio_custom_skills_m1_frontend')) return undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7MXyP.StudioCustomSkillRenderer), props);
        }
    }
};
const $349c7a2c19bab36d$var$jiraPlansRendererEntries = [
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_update_work_sources',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansUpdateWorkSource,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkItems,
            renderer: (0, $bKD9u.UpdateWorkSourceAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_add_program_board',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansCreateProgramBoard,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createView,
            renderer: (0, $jw6cP.AddProgramBoardAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_delete_program_board',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansDeleteProgramBoard,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkItems,
            renderer: (0, $9bgOM.DeleteProgramBoardAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_create_work_item',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansCreateWorkItem,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createWorkItem,
            renderer: (0, $8TK0r.CreateWorkItemAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_create_release',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansCreateRelease,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRelease,
            renderer: (0, $lLxBZ.CreateReleaseAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_set_release_enabled',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansManageFeatures,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).manageCapacityPlan,
            renderer: (0, $9e8iJ.ManageFeaturesAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_add_work_item_dependencies',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansAddDependency,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkItems,
            renderer: (0, $3cDnE.AddDependencyAction)
        }
    },
    {
        anthropicKey: 'execute_is.jira_atlassian_plan_remove_work_item_dependencies',
        legacyKey: (0, $dw75i.ActionKeys).JiraPlansRemoveDependency,
        registryEntry: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).updateWorkItems,
            renderer: (0, $6AKbq.RemoveDependencyAction)
        }
    }
];
const $349c7a2c19bab36d$var$jiraPlansRegistry = Object.fromEntries($349c7a2c19bab36d$var$jiraPlansRendererEntries.flatMap(({ anthropicKey: anthropicKey, legacyKey: legacyKey, registryEntry: registryEntry })=>[
        [
            anthropicKey,
            {
                ...registryEntry,
                condition: ()=>(0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration')
            }
        ],
        [
            anthropicKey.replace('execute_is.', 'is.'),
            {
                ...registryEntry,
                condition: ()=>(0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration')
            }
        ],
        [
            legacyKey,
            {
                ...registryEntry,
                condition: ()=>!(0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration')
            }
        ]
    ]));
const $349c7a2c19bab36d$var$createPredicateRegistry = (getRovoToolsResumptionMigrationEnabled)=>({
        [(0, $dw75i.ActionPredicateKeys).Resumption]: {
            readonlyTitle: (0, $9Ac08.readonlyTitleMessages).respondToPrompt,
            predicate: (actions)=>actions.every((action)=>Boolean(action.toolSource) && !(action.key === (0, $dw75i.ActionKeys).JiraCreateSprint || action.key === (0, $dw75i.ActionKeys).JiraStartSprint || action.key === (0, $dw75i.ActionKeys).JiraMoveToSprint || action.key === (0, $dw75i.ActionKeys).GoogleDocCreate && !getRovoToolsResumptionMigrationEnabled()) && !((0, $5Wcst.jiraPlansActionData).isLegacyActionKey(action.key) || (0, $5Wcst.jiraPlansActionData).isCustomUiActionKey(action.key)) && !(action.key === (0, $dw75i.ActionKeys).ConfluenceFolderCreate && (0, $iDrrr.fg)('confluence_folder_create_action_custom_ui'))),
            renderer: (0, $e047Q.ResumptionRendererAsync)
        }
    });
const $349c7a2c19bab36d$var$defaultGetActionRenderer = {
    ActionRenderer: undefined,
    ActionRendererFallback: undefined,
    readonlyTitle: undefined,
    ReadOnlyActionRenderer: undefined
};
function $349c7a2c19bab36d$var$logAndFallback(result, action) {
    (0, $hlvTd.logException)({
        exception: result.error,
        name: 'conversation-assistant.useActionRenderer.getActionRenderer.validation-failed',
        tags: {
            component: 'useActionRenderer',
            actionKey: action.key,
            invocationId: action.invocationId,
            actionId: String(action.actionId),
            status: String(action.status)
        }
    });
    return $349c7a2c19bab36d$var$defaultGetActionRenderer;
}
const $349c7a2c19bab36d$var$liveChatRegistry = {
    [(0, $dw75i.ActionKeys).JsmLivechat]: {
        readonlyTitle: (0, $9Ac08.readonlyTitleMessages).createRequest,
        readonlyProduct: 'jsm',
        renderer: (0, $iaX6U.JsmLivechatAction)
    }
};
const $349c7a2c19bab36d$var$createActionRendererRegistry = (getRovoToolsResumptionMigrationEnabled = $349c7a2c19bab36d$var$defaultGetRovoToolsResumptionMigrationEnabled)=>({
        ...$349c7a2c19bab36d$var$jiraGatedRegistery,
        ...$349c7a2c19bab36d$var$unifiedRegistery,
        ...$349c7a2c19bab36d$var$createRovoToolsResumptionMigrationRegistry(getRovoToolsResumptionMigrationEnabled),
        ...$349c7a2c19bab36d$var$jiraPlansRegistry,
        ...$349c7a2c19bab36d$var$liveChatRegistry
    });
let $349c7a2c19bab36d$var$defaultActionRendererRegistry;
const $349c7a2c19bab36d$var$getDefaultActionRendererRegistry = ()=>{
    $349c7a2c19bab36d$var$defaultActionRendererRegistry ?? ($349c7a2c19bab36d$var$defaultActionRendererRegistry = $349c7a2c19bab36d$var$createActionRendererRegistry());
    return $349c7a2c19bab36d$var$defaultActionRendererRegistry;
};
const $349c7a2c19bab36d$var$streamActionReadonlyTitleByKey = {
    [(0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createPage,
    [(0, $aYC8J.CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).deepResearchReport,
    [(0, $aYC8J.CONFLUENCE_AIFC_PAGE_UPDATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).editContent,
    [(0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createWhiteboard,
    [(0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateWhiteboard,
    [(0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createPage,
    [(0, $aYC8J.CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateWhiteboard,
    [(0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateWhiteboard,
    [(0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateWhiteboard,
    [(0, $aYC8J.CONFLUENCE_AIFC_SLIDES_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createSlides,
    [(0, $aYC8J.CONFLUENCE_AIFC_SLIDES_UPDATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateSlides,
    [(0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createDatabase,
    [(0, $aYC8J.CONFLUENCE_AIFC_DATABASE_UPDATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateDatabase,
    [(0, $aYC8J.CONFLUENCE_AIFC_SPACE_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createSpace,
    [(0, $aYC8J.CONFLUENCE_AIFC_SPACE_UPDATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).updateSpace,
    [(0, $aYC8J.DYNAMIC_UI_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createDynamicUi,
    [(0, $aYC8J.IMAGE_CREATE_KEY)]: (0, $9Ac08.readonlyTitleMessages).createImage,
    [(0, $dw75i.JSM_CREATE_SURVEY_KEY)]: (0, $9Ac08.readonlyTitleMessages).createSurvey
};
const $349c7a2c19bab36d$var$streamActionReadonlyProductByKey = {
    [(0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_PAGE_UPDATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY)]: 'confluence',
    [(0, $aYC8J.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY)]: 'confluence',
    [(0, $aYC8J.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_SLIDES_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_SLIDES_UPDATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_DATABASE_UPDATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_SPACE_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.CONFLUENCE_AIFC_SPACE_UPDATE_KEY)]: 'confluence',
    [(0, $aYC8J.DYNAMIC_UI_CREATE_KEY)]: 'confluence',
    [(0, $aYC8J.IMAGE_CREATE_KEY)]: 'confluence',
    [(0, $dw75i.JSM_CREATE_SURVEY_KEY)]: 'jsm'
};
const $349c7a2c19bab36d$var$inferReadonlyActionProduct = (actionKey)=>{
    const normalizedActionKey = actionKey.toLowerCase();
    if (normalizedActionKey.includes('jira') || normalizedActionKey.includes('work-item') || normalizedActionKey.includes('issue')) return 'jira';
    if (normalizedActionKey.includes('confluence')) return 'confluence';
    if (normalizedActionKey.includes('jsm') || normalizedActionKey.includes('request-type')) return 'jsm';
    return undefined;
};
const $349c7a2c19bab36d$export$36326d4fbd7c87d5 = (actionKey)=>{
    const registeredTitle = $349c7a2c19bab36d$var$getDefaultActionRendererRegistry()[actionKey]?.readonlyTitle;
    return registeredTitle ?? $349c7a2c19bab36d$var$streamActionReadonlyTitleByKey[actionKey];
};
const $349c7a2c19bab36d$export$5f464e29ed7f4a4d = (actionKey)=>{
    const registeredProduct = $349c7a2c19bab36d$var$getDefaultActionRendererRegistry()[actionKey]?.readonlyProduct;
    return registeredProduct ?? $349c7a2c19bab36d$var$streamActionReadonlyProductByKey[actionKey] ?? $349c7a2c19bab36d$var$inferReadonlyActionProduct(actionKey);
};
const $349c7a2c19bab36d$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $349c7a2c19bab36d$var$hasReadonlyPlanCompleteData = (action)=>$349c7a2c19bab36d$var$isObject(action.data) && typeof action.data.plan === 'string' || typeof action.confirmationMessage === 'string' && action.confirmationMessage.trim().length > 0;
const $349c7a2c19bab36d$var$canRenderReadonlyAction = (action)=>{
    if (action.key === (0, $dw75i.ActionKeys).PlanComplete) return $349c7a2c19bab36d$var$hasReadonlyPlanCompleteData(action);
    return true;
};
const $349c7a2c19bab36d$export$f388a6aad6b2020a = (action)=>{
    const registryEntry = $349c7a2c19bab36d$var$getDefaultActionRendererRegistry()[action.key];
    if (!$349c7a2c19bab36d$var$canRenderReadonlyAction(action)) return undefined;
    if (registryEntry?.condition?.()) return registryEntry.readonlyRenderer;
    if (registryEntry?.condition) return undefined;
    return registryEntry?.readonlyRenderer;
};
const $349c7a2c19bab36d$export$7d3f6ea37762dd47 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const getRovoToolsResumptionMigrationEnabled = t0 === undefined ? $349c7a2c19bab36d$var$defaultGetRovoToolsResumptionMigrationEnabled : t0;
    let t1;
    if ($[0] !== getRovoToolsResumptionMigrationEnabled) {
        t1 = $349c7a2c19bab36d$var$createActionRendererRegistry(getRovoToolsResumptionMigrationEnabled);
        $[0] = getRovoToolsResumptionMigrationEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const registry = t1;
    let t2;
    if ($[2] !== getRovoToolsResumptionMigrationEnabled) {
        t2 = $349c7a2c19bab36d$var$createPredicateRegistry(getRovoToolsResumptionMigrationEnabled);
        $[2] = getRovoToolsResumptionMigrationEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const predicateRegistry = t2;
    const { getActionRenderer: getActionRendererWithRegistry } = (0, $5ZPoU.useActionRenderer)(registry, predicateRegistry);
    let t3;
    if ($[4] !== getActionRendererWithRegistry) {
        t3 = (actionKey, actions)=>{
            try {
                return getActionRendererWithRegistry(actionKey, actions);
            } catch (t4) {
                const error = t4;
                if ((0, $5ZPoU.isActionValidationFailureError)(error)) return $349c7a2c19bab36d$var$logAndFallback(error.validationFailure, error.action);
                return $349c7a2c19bab36d$var$defaultGetActionRenderer;
            }
        };
        $[4] = getActionRendererWithRegistry;
        $[5] = t3;
    } else t3 = $[5];
    const getActionRenderer = t3;
    let t4;
    if ($[6] !== getActionRenderer) {
        t4 = {
            getActionRenderer: getActionRenderer
        };
        $[6] = getActionRenderer;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (getRovoToolsResumptionMigrationEnabled = $349c7a2c19bab36d$var$defaultGetRovoToolsResumptionMigrationEnabled)=>{
    const registry = (0, $cozmU.useMemo)(()=>$349c7a2c19bab36d$var$createActionRendererRegistry(getRovoToolsResumptionMigrationEnabled), [
        getRovoToolsResumptionMigrationEnabled
    ]);
    const predicateRegistry = (0, $cozmU.useMemo)(()=>$349c7a2c19bab36d$var$createPredicateRegistry(getRovoToolsResumptionMigrationEnabled), [
        getRovoToolsResumptionMigrationEnabled
    ]);
    const { getActionRenderer: getActionRendererWithRegistry } = (0, $5ZPoU.useActionRenderer)(registry, predicateRegistry);
    const getActionRenderer = (0, $cozmU.useCallback)((actionKey, actions)=>{
        try {
            return getActionRendererWithRegistry(actionKey, actions);
        } catch (error) {
            if ((0, $5ZPoU.isActionValidationFailureError)(error)) return $349c7a2c19bab36d$var$logAndFallback(error.validationFailure, error.action);
            return $349c7a2c19bab36d$var$defaultGetActionRenderer;
        }
    }, [
        getActionRendererWithRegistry
    ]);
    return {
        getActionRenderer: getActionRenderer
    };
};
module.exports["getReadonlyActionTitle"] = $349c7a2c19bab36d$export$36326d4fbd7c87d5;
module.exports["getReadonlyActionProduct"] = $349c7a2c19bab36d$export$5f464e29ed7f4a4d;
module.exports["getReadonlyActionRenderer"] = $349c7a2c19bab36d$export$f388a6aad6b2020a;
module.exports["useActionRenderer"] = $349c7a2c19bab36d$export$7d3f6ea37762dd47;

});

parcelRegister("2429E", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $66399c58136cc237$var$store = (0, $8s9DV.createStore)({
    name: 'current-action-auth',
    initialState: {
        currentAuth: null
    },
    actions: {
        setAuth: ({ url: url, authType: authType, agentMessageId: agentMessageId })=>({ setState: setState })=>{
                setState({
                    currentAuth: {
                        url: url,
                        authType: authType,
                        agentMessageId: agentMessageId
                    }
                });
            },
        clearAuth: ()=>({ setState: setState })=>{
                setState({
                    currentAuth: null
                });
            }
    }
});
const $66399c58136cc237$var$useStore = (0, $kBr4q.createHook)($66399c58136cc237$var$store);
const $66399c58136cc237$export$a43cecb49bca3981 = (0, $kBr4q.createActionsHook)($66399c58136cc237$var$store);
const $66399c58136cc237$export$2b44aa940e4ce13f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const store = $66399c58136cc237$var$useStore();
    return store;
} : ()=>{
    const store = $66399c58136cc237$var$useStore();
    return store;
};
module.exports["useCurrentActionAuthActions"] = $66399c58136cc237$export$a43cecb49bca3981;
module.exports["useCurrentActionAuth"] = $66399c58136cc237$export$2b44aa940e4ce13f;

});

parcelRegister("2knbJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $8a45db08fe1cf19a$var$createFeedbackKey = (conversationId, messageId)=>conversationId ? `${conversationId}:${messageId}` : messageId;
const $8a45db08fe1cf19a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        feedbackSentIds: [],
        feedbackMap: {}
    },
    actions: {
        setFeedbackSent: (messageId, feedbackType, conversationId)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const newFeedbackSentIds = state.feedbackSentIds.includes(messageId) ? state.feedbackSentIds : [
                    ...state.feedbackSentIds,
                    messageId
                ];
                let newFeedbackMap = state.feedbackMap;
                if (feedbackType && conversationId) {
                    const key = $8a45db08fe1cf19a$var$createFeedbackKey(conversationId, messageId);
                    newFeedbackMap = {
                        ...state.feedbackMap,
                        [key]: feedbackType
                    };
                }
                setState({
                    feedbackSentIds: newFeedbackSentIds,
                    feedbackMap: newFeedbackMap
                });
            }
    }
});
const $8a45db08fe1cf19a$var$useStoreActions = (0, $kBr4q.createActionsHook)($8a45db08fe1cf19a$var$store);
const $8a45db08fe1cf19a$var$useIsFeedbackSent = (0, $kBr4q.createStateHook)($8a45db08fe1cf19a$var$store, {
    selector: (state, messageId)=>state.feedbackSentIds.includes(messageId)
});
const $8a45db08fe1cf19a$var$useFeedbackMap = (0, $kBr4q.createStateHook)($8a45db08fe1cf19a$var$store, {
    selector: (state)=>state.feedbackMap
});
const $8a45db08fe1cf19a$export$7ff2f4da5ac39133 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $8a45db08fe1cf19a$var$useStoreActions().setFeedbackSent;
} : ()=>$8a45db08fe1cf19a$var$useStoreActions().setFeedbackSent;
const $8a45db08fe1cf19a$export$b60c07959edb9b85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    return $8a45db08fe1cf19a$var$useIsFeedbackSent(messageId);
} : (messageId)=>$8a45db08fe1cf19a$var$useIsFeedbackSent(messageId);
const $8a45db08fe1cf19a$export$44f5a82ef7d69d93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId, conversationId)=>{
    const feedbackMap = $8a45db08fe1cf19a$var$useFeedbackMap();
    const key = $8a45db08fe1cf19a$var$createFeedbackKey(conversationId, messageId);
    return feedbackMap[key];
} : (messageId, conversationId)=>{
    const feedbackMap = $8a45db08fe1cf19a$var$useFeedbackMap();
    const key = $8a45db08fe1cf19a$var$createFeedbackKey(conversationId, messageId);
    return feedbackMap[key];
};
module.exports["useSetMessageFeedbackSent"] = $8a45db08fe1cf19a$export$7ff2f4da5ac39133;
module.exports["useIsMessageFeedbackSent"] = $8a45db08fe1cf19a$export$b60c07959edb9b85;
module.exports["useGetMessageFeedbackType"] = $8a45db08fe1cf19a$export$44f5a82ef7d69d93;

});

parcelRegister("4NVkH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $38ea6b9a23a9eb3f$var$styles = {
    content: "_0bjKvD8fU6",
    padding: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    margin: "_3SamIH8HPE _2YLqiKdnbC",
    accent: "_0KLXruVva3",
    accentV2: "_0bjKvDyzSk _0KLXrutfbE",
    accentV2Hovered: "_0KLXruupqB"
};
const $38ea6b9a23a9eb3f$var$pinchCornerStyles = {
    topLeft: "_2C2kUQcjp5",
    topRight: "_1Lz9locjp5",
    bottomLeft: "_1v9SsVcjp5",
    bottomRight: "_3XDz3Bcjp5"
};
const $38ea6b9a23a9eb3f$var$pinchCornerV2Styles = {
    topLeft: "_2C2kUQKxmn",
    topRight: "_1Lz9loKxmn",
    bottomLeft: "_1v9SsVKxmn",
    bottomRight: "_3XDz3BKxmn"
};
const $38ea6b9a23a9eb3f$export$e01703dff029898a = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, verticalSpace: t1, pinchCorner: t2, style: style, variant: variant, testId: testId, showPadding: t3, mode: mode, isHovered: t4 } = t0;
    const verticalSpace = t1 === undefined ? true : t1;
    const pinchCorner = t2 === undefined ? "none" : t2;
    const showPadding = t3 === undefined ? true : t3;
    const isHovered = t4 === undefined ? false : t4;
    let t5;
    if ($[0] !== mode || $[1] !== variant) {
        t5 = ()=>{
            if (mode?.toLowerCase() === "mini-modal") return "elevation.surface.raised";
            if (variant === "accent") return "color.background.accent.blue.subtlest";
            if (variant === "neutral") return "elevation.surface";
            return "elevation.surface";
        };
        $[0] = mode;
        $[1] = variant;
        $[2] = t5;
    } else t5 = $[2];
    const getBackgroundColor = t5;
    const t6 = variant === "accentV2" || variant === "accent" ? undefined : getBackgroundColor();
    const t7 = showPadding && $38ea6b9a23a9eb3f$var$styles.padding;
    const t8 = verticalSpace && $38ea6b9a23a9eb3f$var$styles.margin;
    const t9 = variant === "accent" && $38ea6b9a23a9eb3f$var$styles.accent;
    const t10 = variant === "accentV2" && $38ea6b9a23a9eb3f$var$styles.accentV2;
    const t11 = isHovered && variant === "accentV2" && $38ea6b9a23a9eb3f$var$styles.accentV2Hovered;
    const t12 = pinchCorner && pinchCorner !== "none" ? variant === "accentV2" ? $38ea6b9a23a9eb3f$var$pinchCornerV2Styles[pinchCorner] : $38ea6b9a23a9eb3f$var$pinchCornerStyles[pinchCorner] : false;
    let t13;
    if ($[3] !== t10 || $[4] !== t11 || $[5] !== t12 || $[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
        t13 = (0, $w6R6I.cx)($38ea6b9a23a9eb3f$var$styles.content, t7, t8, t9, t10, t11, t12);
        $[3] = t10;
        $[4] = t11;
        $[5] = t12;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
        $[9] = t13;
    } else t13 = $[9];
    let t14;
    if ($[10] !== children || $[11] !== ref || $[12] !== style || $[13] !== t13 || $[14] !== t6 || $[15] !== testId) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ref: ref,
            style: style,
            backgroundColor: t6,
            xcss: t13,
            testId: testId
        }, children);
        $[10] = children;
        $[11] = ref;
        $[12] = style;
        $[13] = t13;
        $[14] = t6;
        $[15] = testId;
        $[16] = t14;
    } else t14 = $[16];
    return t14;
} : ({ children: children, verticalSpace: verticalSpace = true, pinchCorner: pinchCorner = 'none', style: style, variant: variant, testId: testId, showPadding: showPadding = true, mode: mode, isHovered: isHovered = false }, ref)=>{
    const getBackgroundColor = ()=>{
        if (mode?.toLowerCase() === 'mini-modal') return 'elevation.surface.raised';
        if (variant === 'accent') return 'color.background.accent.blue.subtlest';
        if (variant === 'neutral') return 'elevation.surface';
        return 'elevation.surface';
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: ref,
        style: style,
        backgroundColor: variant === 'accentV2' || variant === 'accent' ? undefined : getBackgroundColor(),
        xcss: (0, $w6R6I.cx)($38ea6b9a23a9eb3f$var$styles.content, showPadding && $38ea6b9a23a9eb3f$var$styles.padding, verticalSpace && $38ea6b9a23a9eb3f$var$styles.margin, variant === 'accent' && $38ea6b9a23a9eb3f$var$styles.accent, variant === 'accentV2' && $38ea6b9a23a9eb3f$var$styles.accentV2, isHovered && variant === 'accentV2' && $38ea6b9a23a9eb3f$var$styles.accentV2Hovered, pinchCorner && pinchCorner !== 'none' ? variant === 'accentV2' ? $38ea6b9a23a9eb3f$var$pinchCornerV2Styles[pinchCorner] : $38ea6b9a23a9eb3f$var$pinchCornerStyles[pinchCorner] : false),
        testId: testId
    }, children);
});
const $38ea6b9a23a9eb3f$export$764e10489d478164 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    let contentUnder;
    let message;
    let restProps;
    let t1;
    if ($[0] !== t0) {
        ({ message: message, contentUnder: contentUnder, hideIcon: t1, ...restProps } = t0);
        $[0] = t0;
        $[1] = contentUnder;
        $[2] = message;
        $[3] = restProps;
        $[4] = t1;
    } else {
        contentUnder = $[1];
        message = $[2];
        restProps = $[3];
        t1 = $[4];
    }
    const hideIcon = t1 === undefined ? false : t1;
    let t2;
    if ($[5] !== hideIcon) {
        t2 = !hideIcon && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-danger)"
        });
        $[5] = hideIcon;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== message) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, message);
        $[7] = message;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t2, t3);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== contentUnder || $[13] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t4, contentUnder);
        $[12] = contentUnder;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== restProps || $[16] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement($38ea6b9a23a9eb3f$export$e01703dff029898a, restProps, t5);
        $[15] = restProps;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ message: message, contentUnder: contentUnder, hideIcon: hideIcon = false, ...restProps })=>{
    return /*#__PURE__*/ $cozmU.createElement($38ea6b9a23a9eb3f$export$e01703dff029898a, restProps, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, !hideIcon && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, message)), contentUnder));
};
module.exports["Paper"] = $38ea6b9a23a9eb3f$export$e01703dff029898a;
module.exports["PaperErrorMessage"] = $38ea6b9a23a9eb3f$export$764e10489d478164;

});

parcelRegister("4AQlH", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");

const $89b24e44c75d1e38$export$9a306d6d1c8510c2 = (value)=>{
    const trimmedValue = value?.trim();
    if (!trimmedValue) return undefined;
    return trimmedValue === (0, $2yWJZ.DEFAULT_AGENT_NAMED_ID) || trimmedValue === (0, $2yWJZ.DEFAULT_AGENT_UUID) ? undefined : trimmedValue;
};
module.exports["normalizeAgentIdentityValue"] = $89b24e44c75d1e38$export$9a306d6d1c8510c2;

});

parcelRegister("75YqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $gzMZq = parcelRequire("gzMZq");


var $fsbzy = parcelRequire("fsbzy");


var $1PPOl = parcelRequire("1PPOl");


var $hI1dm = parcelRequire("hI1dm");


var $cUElk = parcelRequire("cUElk");

const $dffb977fb826d179$export$23607f376668a179 = ({ hideThumbs: hideThumbs, onThumbClick: onThumbClick, onCopyClick: onCopyClick, insertReplaceContent: insertReplaceContent, selectedAgentId: selectedAgentId, onClickInsertReplace: onClickInsertReplace, hideInsertButton: hideInsertButton = false, showDebugButton: showDebugButton = false, onClickDebug: onClickDebug, feedbackType: feedbackType, markdownData: markdownData, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $gzMZq.useChatContextEditorContext));
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const showInsertButton = !hideInsertButton && !!insertReplaceContent && !!editorContext?.document && !editorContext?.isViewMode;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fsbzy.MessageFooterButtons), {
        hideThumbs: hideThumbs,
        feedbackType: feedbackType,
        thumbsTestId: (0, $1PPOl.POLLINATOR_TEST_IDS).THUMBS_UP_BUTTON,
        onThumbClick: (value, event)=>{
            sendAnalyticsEvent(event.update({
                actionSubjectId: value ? 'goodAnswerButton' : 'badAnswerButton'
            }));
            onThumbClick(value);
        },
        onCopyClick: (event_0)=>{
            sendAnalyticsEvent(event_0.update({
                actionSubjectId: 'copyResponseButton'
            }));
            onCopyClick();
        },
        showDebugButton: showDebugButton,
        onClickDebug: (event_1)=>{
            sendAnalyticsEvent(event_1.update({
                actionSubjectId: 'debugButton'
            }));
            onClickDebug?.();
        },
        insertSlot: showInsertButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hI1dm.InsertReplaceButton), {
            content: insertReplaceContent,
            agentId: selectedAgentId,
            onClick: onClickInsertReplace,
            markdownData: markdownData
        }) : undefined,
        shareSlot: messageId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cUElk.ShareUpToMessageButton), {
            messageId: messageId
        }) : undefined
    });
};
module.exports["MessageFooterButtons"] = $dffb977fb826d179$export$23607f376668a179;

});

parcelRegister("3hnlP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $2uDbg = parcelRequire("2uDbg");


var $7BfeF = parcelRequire("7BfeF");

var $hpa99 = parcelRequire("hpa99");


var $iZMIZ = parcelRequire("iZMIZ");


var $l3wuH = parcelRequire("l3wuH");


var $i1t43 = parcelRequire("i1t43");


var $iODl6 = parcelRequire("iODl6");

var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $9GVkD = parcelRequire("9GVkD");


var $lTU4O = parcelRequire("lTU4O");


var $l3d45 = parcelRequire("l3d45");


var $eKjv9 = parcelRequire("eKjv9");


var $cWQ7I = parcelRequire("cWQ7I");


var $dEP8O = parcelRequire("dEP8O");


var $dSCNl = parcelRequire("dSCNl");


var $2zDNQ = parcelRequire("2zDNQ");

const $f9353d9f66579323$var$leftAlignPadding = "var(--ds-space-300, 24px)";
const $f9353d9f66579323$var$styles = {
    bannerContainer: "_0bjKvDyzSk _30huDKOeNX _3138425zaO _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _2K49XhN91d _01loHRxf28 _0GTcwRIZbP _2xTnZxIZbP",
    categoryButtons: "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE",
    optInButton: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0KLXru66of",
    alignedWithText: "_2Zuz6QNHnM",
    textWithMaxWidth: "_2Zuz6QNHnM _1EqgXlE1Ft",
    subtleHeading: "_2sNsIgEqul",
    textAreaWrap: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _2Y7lL41Y8M _4c065U1Y8M _0KLXru7Cj1 _1jJ2xknXvL _4j5xbavc3e"
};
const $f9353d9f66579323$var$CATEGORY_MESSAGE_MAP = {
    upToDate: 'categoryUpToDate',
    accurate: 'categoryAccurate',
    helpful: 'categoryHelpful',
    onBrief: 'categoryOnBrief',
    wellSourced: 'categoryWellSourced',
    other: 'categoryOther',
    outOfDate: 'categoryOutOfDate',
    inaccurate: 'categoryInaccurate',
    tooLong: 'categoryTooLong',
    tooShort: 'categoryTooShort',
    poorlySourced: 'categoryPoorlySourced',
    inappropriate: 'categoryInappropriate',
    // Studio-specific categories
    goodPlan: 'categoryGoodPlan',
    askedGoodQuestions: 'categoryAskedGoodQuestions',
    reasonableAssumptions: 'categoryReasonableAssumptions',
    showedMeSomethingNew: 'categoryShowedMeSomethingNew',
    tooManyQuestions: 'categoryTooManyQuestions',
    notEnoughQuestions: 'categoryNotEnoughQuestions',
    incorrectPlan: 'categoryIncorrectPlan',
    buildFailed: 'categoryBuildFailed',
    tooWordy: 'categoryTooWordy',
    badAssumptions: 'categoryBadAssumptions'
};
const $f9353d9f66579323$var$POSITIVE_CATEGORIES = [
    'upToDate',
    'accurate',
    'helpful',
    'onBrief',
    'wellSourced',
    'other'
];
const $f9353d9f66579323$var$NEGATIVE_CATEGORIES = [
    'outOfDate',
    'inaccurate',
    'tooLong',
    'tooShort',
    'poorlySourced',
    'inappropriate',
    'other'
];
const $f9353d9f66579323$var$PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy';
const $f9353d9f66579323$var$BannerHeader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { messageKey: messageKey, onDismiss: onDismiss } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        });
        $[0] = t1;
    } else t1 = $[0];
    const t2 = (0, $2zDNQ.default)[messageKey];
    let t3;
    if ($[1] !== formatMessage || $[2] !== t2) {
        t3 = formatMessage(t2);
        $[1] = formatMessage;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, t3));
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== formatMessage) {
        t5 = formatMessage((0, $2zDNQ.default).dismissBanner);
        $[6] = formatMessage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== onDismiss || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $f9353d9f66579323$var$_temp,
            label: t5,
            onClick: onDismiss,
            spacing: "compact",
            isTooltipDisabled: false
        });
        $[8] = onDismiss;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t4 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, t4, t6);
        $[11] = t4;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ messageKey: messageKey, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage((0, $2zDNQ.default)[messageKey]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                size: "small",
                ...props
            }),
        label: formatMessage((0, $2zDNQ.default).dismissBanner),
        onClick: onDismiss,
        spacing: "compact",
        isTooltipDisabled: false
    }));
};
const $f9353d9f66579323$var$ThankYouMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { onDismiss: onDismiss } = t0;
    let t1;
    if ($[0] !== onDismiss) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$BannerHeader, {
            messageKey: "thankYouMessage",
            onDismiss: onDismiss
        });
        $[0] = onDismiss;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ onDismiss: onDismiss })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$BannerHeader, {
        messageKey: "thankYouMessage",
        onDismiss: onDismiss
    });
const $f9353d9f66579323$var$ThankYouOptInPrompt = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { onDismiss: onDismiss, onOptIn: onOptIn, onAdditionalFeedback: onAdditionalFeedback } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onDismiss) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$BannerHeader, {
            messageKey: "thankYouMessage",
            onDismiss: onDismiss
        });
        $[0] = onDismiss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f9353d9f66579323$var$styles.textWithMaxWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $2zDNQ.default).optInQuestion,
            values: {
                b: $f9353d9f66579323$var$_temp2
            }
        })));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== formatMessage) {
        t3 = formatMessage((0, $2zDNQ.default).yesOptIn);
        $[3] = formatMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onOptIn || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f9353d9f66579323$var$styles.optInButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onOptIn
        }, t3));
        $[5] = onOptIn;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage((0, $2zDNQ.default).additionalFeedbackButton);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== onAdditionalFeedback || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f9353d9f66579323$var$styles.optInButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onAdditionalFeedback
        }, t5));
        $[10] = onAdditionalFeedback;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t4 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f9353d9f66579323$var$styles.alignedWithText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t4, t6));
        $[13] = t4;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t1 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t1, t2, t7);
        $[16] = t1;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ onDismiss: onDismiss, onOptIn: onOptIn, onAdditionalFeedback: onAdditionalFeedback })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$BannerHeader, {
        messageKey: "thankYouMessage",
        onDismiss: onDismiss
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f9353d9f66579323$var$styles.textWithMaxWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $2zDNQ.default).optInQuestion,
        values: {
            b: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "span",
                    weight: "bold"
                }, text)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f9353d9f66579323$var$styles.alignedWithText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f9353d9f66579323$var$styles.optInButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onOptIn
    }, formatMessage((0, $2zDNQ.default).yesOptIn))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f9353d9f66579323$var$styles.optInButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onAdditionalFeedback
    }, formatMessage((0, $2zDNQ.default).additionalFeedbackButton))))));
};
const $f9353d9f66579323$var$OptedInMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { onDismiss: onDismiss, onAdditionalFeedback: onAdditionalFeedback } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onDismiss) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$BannerHeader, {
            messageKey: "optedInMessage",
            onDismiss: onDismiss
        });
        $[0] = onDismiss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $2zDNQ.default).provideAdditionalFeedback);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onAdditionalFeedback || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onAdditionalFeedback,
            shouldFitContainer: true,
            appearance: "default"
        }, t2);
        $[4] = onAdditionalFeedback;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t1, t3);
        $[7] = t1;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ onDismiss: onDismiss, onAdditionalFeedback: onAdditionalFeedback })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$BannerHeader, {
        messageKey: "optedInMessage",
        onDismiss: onDismiss
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onAdditionalFeedback,
        shouldFitContainer: true,
        appearance: "default"
    }, formatMessage((0, $2zDNQ.default).provideAdditionalFeedback)));
};
const $f9353d9f66579323$var$ExpandedFeedbackForm = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { feedbackType: feedbackType, onDismiss: onDismiss, categories: categories, selectedCategories: selectedCategories, toggleCategory: toggleCategory, additionalFeedback: additionalFeedback, setAdditionalFeedback: setAdditionalFeedback, includeMessages: includeMessages, setIncludeMessages: setIncludeMessages, enrollInResearch: enrollInResearch, setEnrollInResearch: setEnrollInResearch, handleSubmit: handleSubmit, showValidationError: showValidationError, clearValidationError: clearValidationError, shouldHideCheckboxes: shouldHideCheckboxes, isInternalUser: isInternalUser, textAreaRef: textAreaRef, headingRef: headingRef, restartAutoDismiss: restartAutoDismiss, pauseAutoDismiss: pauseAutoDismiss } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorMessageId = (0, $cozmU.useId)();
    let t1;
    if ($[0] !== selectedCategories) {
        t1 = selectedCategories.includes("other");
        $[0] = selectedCategories;
        $[1] = t1;
    } else t1 = $[1];
    const isOtherSelected = t1;
    let t2;
    if ($[2] !== additionalFeedback || $[3] !== isOtherSelected || $[4] !== showValidationError) {
        t2 = showValidationError && isOtherSelected && !additionalFeedback.trim();
        $[2] = additionalFeedback;
        $[3] = isOtherSelected;
        $[4] = showValidationError;
        $[5] = t2;
    } else t2 = $[5];
    const showError = t2;
    const isHoveredRef = (0, $cozmU.useRef)(false);
    const isFocusedRef = (0, $cozmU.useRef)(false);
    let t3;
    if ($[6] !== restartAutoDismiss) {
        t3 = ()=>{
            if (!isHoveredRef.current && !isFocusedRef.current) restartAutoDismiss?.();
        };
        $[6] = restartAutoDismiss;
        $[7] = t3;
    } else t3 = $[7];
    const resumeIfIdle = t3;
    let t4;
    if ($[8] !== pauseAutoDismiss) {
        t4 = ()=>{
            isHoveredRef.current = true;
            pauseAutoDismiss?.();
        };
        $[8] = pauseAutoDismiss;
        $[9] = t4;
    } else t4 = $[9];
    const handleMouseOverCapture = t4;
    let t5;
    if ($[10] !== resumeIfIdle) {
        t5 = (event)=>{
            const next = event.relatedTarget;
            if (next && event.currentTarget.contains(next)) return;
            isHoveredRef.current = false;
            resumeIfIdle();
        };
        $[10] = resumeIfIdle;
        $[11] = t5;
    } else t5 = $[11];
    const handleMouseOutCapture = t5;
    let t6;
    if ($[12] !== pauseAutoDismiss) {
        t6 = ()=>{
            isFocusedRef.current = true;
            pauseAutoDismiss?.();
        };
        $[12] = pauseAutoDismiss;
        $[13] = t6;
    } else t6 = $[13];
    const handleFocusCapture = t6;
    let t7;
    if ($[14] !== resumeIfIdle) {
        t7 = (event_0)=>{
            const next_0 = event_0.relatedTarget;
            if (next_0 && event_0.currentTarget.contains(next_0)) return;
            isFocusedRef.current = false;
            resumeIfIdle();
        };
        $[14] = resumeIfIdle;
        $[15] = t7;
    } else t7 = $[15];
    const handleBlurCapture = t7;
    let t8;
    if ($[16] !== additionalFeedback || $[17] !== categories || $[18] !== clearValidationError || $[19] !== enrollInResearch || $[20] !== errorMessageId || $[21] !== feedbackType || $[22] !== formatMessage || $[23] !== handleBlurCapture || $[24] !== handleFocusCapture || $[25] !== handleMouseOutCapture || $[26] !== handleMouseOverCapture || $[27] !== handleSubmit || $[28] !== headingRef || $[29] !== includeMessages || $[30] !== isInternalUser || $[31] !== isOtherSelected || $[32] !== onDismiss || $[33] !== selectedCategories || $[34] !== setAdditionalFeedback || $[35] !== setEnrollInResearch || $[36] !== setIncludeMessages || $[37] !== shouldHideCheckboxes || $[38] !== showError || $[39] !== textAreaRef || $[40] !== toggleCategory) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            duration: "large"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                onMouseOverCapture: handleMouseOverCapture,
                onMouseOutCapture: handleMouseOutCapture,
                onFocusCapture: handleFocusCapture,
                onBlurCapture: handleBlurCapture
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.100",
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "h2",
                xcss: $f9353d9f66579323$var$styles.subtleHeading,
                ref: headingRef,
                tabIndex: -1
            }, formatMessage(feedbackType === "like" ? (0, $2zDNQ.default).whatWorkedQuestion : (0, $2zDNQ.default).whatDidntWorkQuestion)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: $f9353d9f66579323$var$_temp3,
                label: formatMessage((0, $2zDNQ.default).dismissBanner),
                onClick: onDismiss,
                spacing: "compact",
                isTooltipDisabled: false
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest",
                weight: "bold"
            }, formatMessage((0, $2zDNQ.default).itWasLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f9353d9f66579323$var$styles.categoryButtons,
                role: "group",
                "aria-label": formatMessage((0, $2zDNQ.default).itWasLabel)
            }, categories.map((category)=>{
                const messageKey = $f9353d9f66579323$var$CATEGORY_MESSAGE_MAP[category];
                const isSelected = selectedCategories.includes(category);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    key: category,
                    appearance: isSelected ? "primary" : "default",
                    onClick: ()=>toggleCategory(category),
                    isSelected: isSelected,
                    "aria-pressed": isSelected
                }, formatMessage((0, $2zDNQ.default)[messageKey]));
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest",
                weight: "bold"
            }, formatMessage((0, $2zDNQ.default).additionalFeedbackLabel), isOtherSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f9353d9f66579323$var$styles.textAreaWrap
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ref: textAreaRef,
                appearance: "none",
                placeholder: formatMessage((0, $2zDNQ.default).additionalFeedbackPlaceholder),
                value: additionalFeedback,
                onChange: (e)=>{
                    setAdditionalFeedback(e.target.value);
                    clearValidationError();
                },
                minimumRows: 2,
                "aria-label": formatMessage((0, $2zDNQ.default).additionalFeedbackLabel),
                "aria-required": isOtherSelected,
                "aria-invalid": showError,
                "aria-describedby": showError ? errorMessageId : undefined
            })), showError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                id: errorMessageId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $2zDNQ.default).additionalFeedbackRequired)))), !shouldHideCheckboxes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                label: formatMessage((0, $2zDNQ.default).includeMessagesCheckbox),
                isChecked: includeMessages,
                onChange: (e_0)=>setIncludeMessages(e_0.target.checked)
            }), !isInternalUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage((0, $2zDNQ.default).enrollInResearchCheckbox, {
                    privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: $f9353d9f66579323$var$PRIVACY_POLICY_URL,
                        target: "_blank"
                    }, formatMessage((0, $2zDNQ.default).privacyPolicyLink))
                })),
                isChecked: enrollInResearch,
                onChange: (e_1)=>setEnrollInResearch(e_1.target.checked)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: handleSubmit,
                shouldFitContainer: true
            }, formatMessage((0, $2zDNQ.default).submitFeedback)), (0, $iDrrr.fg)("rovo_send_detailed_feedback_to_convo_ai") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage((0, $2zDNQ.default).feedbackPrivacyDisclaimer))))));
        $[16] = additionalFeedback;
        $[17] = categories;
        $[18] = clearValidationError;
        $[19] = enrollInResearch;
        $[20] = errorMessageId;
        $[21] = feedbackType;
        $[22] = formatMessage;
        $[23] = handleBlurCapture;
        $[24] = handleFocusCapture;
        $[25] = handleMouseOutCapture;
        $[26] = handleMouseOverCapture;
        $[27] = handleSubmit;
        $[28] = headingRef;
        $[29] = includeMessages;
        $[30] = isInternalUser;
        $[31] = isOtherSelected;
        $[32] = onDismiss;
        $[33] = selectedCategories;
        $[34] = setAdditionalFeedback;
        $[35] = setEnrollInResearch;
        $[36] = setIncludeMessages;
        $[37] = shouldHideCheckboxes;
        $[38] = showError;
        $[39] = textAreaRef;
        $[40] = toggleCategory;
        $[41] = t8;
    } else t8 = $[41];
    return t8;
} : ({ feedbackType: feedbackType, onDismiss: onDismiss, categories: categories, selectedCategories: selectedCategories, toggleCategory: toggleCategory, additionalFeedback: additionalFeedback, setAdditionalFeedback: setAdditionalFeedback, includeMessages: includeMessages, setIncludeMessages: setIncludeMessages, enrollInResearch: enrollInResearch, setEnrollInResearch: setEnrollInResearch, handleSubmit: handleSubmit, showValidationError: showValidationError, clearValidationError: clearValidationError, shouldHideCheckboxes: shouldHideCheckboxes, isInternalUser: isInternalUser, textAreaRef: textAreaRef, headingRef: headingRef, restartAutoDismiss: restartAutoDismiss, pauseAutoDismiss: pauseAutoDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorMessageId = (0, $cozmU.useId)();
    const isOtherSelected = selectedCategories.includes('other');
    const showError = showValidationError && isOtherSelected && !additionalFeedback.trim(); // Pause auto-dismiss while pointer OR keyboard focus is inside the form;
    // resume only when both have left. The `relatedTarget` guard on
    // `mouseout` / `blur` is required because those events bubble and fire on
    // every internal boundary crossing.
    const isHoveredRef = (0, $cozmU.useRef)(false);
    const isFocusedRef = (0, $cozmU.useRef)(false);
    const resumeIfIdle = (0, $cozmU.useCallback)(()=>{
        if (!isHoveredRef.current && !isFocusedRef.current) restartAutoDismiss?.();
    }, [
        restartAutoDismiss
    ]);
    const handleMouseOverCapture = (0, $cozmU.useCallback)(()=>{
        isHoveredRef.current = true;
        pauseAutoDismiss?.();
    }, [
        pauseAutoDismiss
    ]);
    const handleMouseOutCapture = (0, $cozmU.useCallback)((event)=>{
        const next = event.relatedTarget;
        if (next && event.currentTarget.contains(next)) return;
        isHoveredRef.current = false;
        resumeIfIdle();
    }, [
        resumeIfIdle
    ]);
    const handleFocusCapture = (0, $cozmU.useCallback)(()=>{
        isFocusedRef.current = true;
        pauseAutoDismiss?.();
    }, [
        pauseAutoDismiss
    ]);
    const handleBlurCapture = (0, $cozmU.useCallback)((event_0)=>{
        const next_0 = event_0.relatedTarget;
        if (next_0 && event_0.currentTarget.contains(next_0)) return;
        isFocusedRef.current = false;
        resumeIfIdle();
    }, [
        resumeIfIdle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        duration: "large"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            onMouseOverCapture: handleMouseOverCapture,
            onMouseOutCapture: handleMouseOutCapture,
            onFocusCapture: handleFocusCapture,
            onBlurCapture: handleBlurCapture
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "h2",
            xcss: $f9353d9f66579323$var$styles.subtleHeading,
            ref: headingRef,
            tabIndex: -1
        }, formatMessage(feedbackType === 'like' ? (0, $2zDNQ.default).whatWorkedQuestion : (0, $2zDNQ.default).whatDidntWorkQuestion)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    size: "small",
                    ...props_0
                }),
            label: formatMessage((0, $2zDNQ.default).dismissBanner),
            onClick: onDismiss,
            spacing: "compact",
            isTooltipDisabled: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold"
        }, formatMessage((0, $2zDNQ.default).itWasLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f9353d9f66579323$var$styles.categoryButtons,
            role: "group",
            "aria-label": formatMessage((0, $2zDNQ.default).itWasLabel)
        }, categories.map((category)=>{
            const messageKey = $f9353d9f66579323$var$CATEGORY_MESSAGE_MAP[category];
            const isSelected = selectedCategories.includes(category);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                key: category,
                appearance: isSelected ? 'primary' : 'default',
                onClick: ()=>toggleCategory(category),
                isSelected: isSelected,
                "aria-pressed": isSelected
            }, formatMessage((0, $2zDNQ.default)[messageKey]));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold"
        }, formatMessage((0, $2zDNQ.default).additionalFeedbackLabel), isOtherSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f9353d9f66579323$var$styles.textAreaWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ref: textAreaRef,
            appearance: "none",
            placeholder: formatMessage((0, $2zDNQ.default).additionalFeedbackPlaceholder),
            value: additionalFeedback,
            onChange: (e)=>{
                setAdditionalFeedback(e.target.value);
                clearValidationError();
            },
            minimumRows: 2,
            "aria-label": formatMessage((0, $2zDNQ.default).additionalFeedbackLabel),
            "aria-required": isOtherSelected,
            "aria-invalid": showError,
            "aria-describedby": showError ? errorMessageId : undefined
        })), showError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: errorMessageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $2zDNQ.default).additionalFeedbackRequired)))), !shouldHideCheckboxes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $2zDNQ.default).includeMessagesCheckbox),
            isChecked: includeMessages,
            onChange: (e_0)=>setIncludeMessages(e_0.target.checked)
        }), !isInternalUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage((0, $2zDNQ.default).enrollInResearchCheckbox, {
                privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $f9353d9f66579323$var$PRIVACY_POLICY_URL,
                    target: "_blank"
                }, formatMessage((0, $2zDNQ.default).privacyPolicyLink))
            })),
            isChecked: enrollInResearch,
            onChange: (e_1)=>setEnrollInResearch(e_1.target.checked)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleSubmit,
            shouldFitContainer: true
        }, formatMessage((0, $2zDNQ.default).submitFeedback)), (0, $iDrrr.fg)('rovo_send_detailed_feedback_to_convo_ai') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $2zDNQ.default).feedbackPrivacyDisclaimer))))));
};
function $f9353d9f66579323$var$getBannerViewState({ isOptedIn: isOptedIn, isExpanded: isExpanded, isSubmitted: isSubmitted, showOptInPrompt: showOptInPrompt }) {
    if (!isSubmitted && isExpanded) return 'expanded-form';
    if (showOptInPrompt) return 'opt-in-prompt';
    if (isOptedIn && !isExpanded) return 'opted-in';
    if (isSubmitted) return 'thank-you';
    return 'initial';
}
const $f9353d9f66579323$export$b396d0937ee27ce8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(76);
    const { onProvideAdditionalFeedback: onProvideAdditionalFeedback, onDismiss: onDismiss, isVisible: isVisible, feedbackType: feedbackType, onSubmit: onSubmit, customCategories: customCategoriesOverride, userEmail: userEmailOverride, onIncludeMessagesChecked: onIncludeMessagesChecked, shouldHideCheckboxes: shouldHideCheckboxesOverride, storeUserMessages: storeUserMessagesOverride, onOptIn: onOptIn, isOptedIn: isOptedIn, hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt, onOptInPromptActioned: onOptInPromptActioned, restartAutoDismiss: restartAutoDismiss, pauseAutoDismiss: pauseAutoDismiss, csatRating: csatRating } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { profileData: t1 } = (0, $eKjv9.useGlobalConfig)();
    const { email: globalEmail } = t1;
    const { customFeedbackCategories: customFeedbackCategories } = (0, $dSCNl.useUIConfig)();
    const { preferences: t2 } = (0, $lTU4O.useUserPreferences)();
    const { storeUserMessages: prefsStoreUserMessages } = t2;
    const userEmail = userEmailOverride ?? globalEmail;
    const storeUserMessages = storeUserMessagesOverride ?? prefsStoreUserMessages;
    let t3;
    if ($[0] !== shouldHideCheckboxesOverride || $[1] !== storeUserMessages || $[2] !== userEmail) {
        t3 = shouldHideCheckboxesOverride ?? (0, $cWQ7I.isInternalUserWithAutoIncludeHistory)(userEmail, storeUserMessages);
        $[0] = shouldHideCheckboxesOverride;
        $[1] = storeUserMessages;
        $[2] = userEmail;
        $[3] = t3;
    } else t3 = $[3];
    const shouldHideCheckboxes = t3;
    let t4;
    if ($[4] !== userEmail) {
        t4 = (0, $dEP8O.shouldShowOptInPrompt)(userEmail);
        $[4] = userEmail;
        $[5] = t4;
    } else t4 = $[5];
    const shouldShowOptIn = t4;
    const shouldOfferOptInPromptByDefault = storeUserMessages === false && !hasSeenFeedbackOptInPrompt && !!onOptIn && shouldShowOptIn;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isSubmitted, setIsSubmitted] = (0, $cozmU.useState)(false);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[6] = t5;
    } else t5 = $[6];
    const [selectedCategories, setSelectedCategories] = (0, $cozmU.useState)(t5);
    const [additionalFeedback, setAdditionalFeedback] = (0, $cozmU.useState)("");
    let t6;
    if ($[7] !== userEmail) {
        t6 = (0, $l3d45.isAtlassianEmployee)(userEmail);
        $[7] = userEmail;
        $[8] = t6;
    } else t6 = $[8];
    const [includeMessages, setIncludeMessages] = (0, $cozmU.useState)(t6);
    const [enrollInResearch, setEnrollInResearch] = (0, $cozmU.useState)(false);
    const [showValidationError, setShowValidationError] = (0, $cozmU.useState)(false);
    const textAreaRef = (0, $cozmU.useRef)(null);
    const expandedFormHeadingRef = (0, $cozmU.useRef)(null);
    const hasEvaluatedDirectFeedbackTreatmentRef = (0, $cozmU.useRef)(false);
    const showOptInPrompt = !isOptedIn && !isExpanded && !isSubmitted && shouldOfferOptInPromptByDefault;
    let t7;
    let t8;
    if ($[9] !== csatRating || $[10] !== isExpanded || $[11] !== isOptedIn || $[12] !== isSubmitted || $[13] !== isVisible || $[14] !== shouldOfferOptInPromptByDefault) {
        t7 = ()=>{
            if (!isVisible) {
                hasEvaluatedDirectFeedbackTreatmentRef.current = false;
                return;
            }
            if (csatRating != null && !isExpanded && !isSubmitted) {
                setIsExpanded(true);
                return;
            }
            const isAtTreatmentDecisionPoint = !isSubmitted && !isExpanded && !isOptedIn && !shouldOfferOptInPromptByDefault;
            if (!isAtTreatmentDecisionPoint || hasEvaluatedDirectFeedbackTreatmentRef.current) return;
            hasEvaluatedDirectFeedbackTreatmentRef.current = true;
            setIsExpanded(true);
        };
        t8 = [
            isVisible,
            isSubmitted,
            isExpanded,
            isOptedIn,
            shouldOfferOptInPromptByDefault,
            csatRating
        ];
        $[9] = csatRating;
        $[10] = isExpanded;
        $[11] = isOptedIn;
        $[12] = isSubmitted;
        $[13] = isVisible;
        $[14] = shouldOfferOptInPromptByDefault;
        $[15] = t7;
        $[16] = t8;
    } else {
        t7 = $[15];
        t8 = $[16];
    }
    (0, $cozmU.useLayoutEffect)(t7, t8);
    const t9 = !!showOptInPrompt;
    let t10;
    if ($[17] !== isExpanded || $[18] !== isOptedIn || $[19] !== isSubmitted || $[20] !== t9) {
        t10 = $f9353d9f66579323$var$getBannerViewState({
            isOptedIn: isOptedIn,
            isExpanded: isExpanded,
            isSubmitted: isSubmitted,
            showOptInPrompt: t9
        });
        $[17] = isExpanded;
        $[18] = isOptedIn;
        $[19] = isSubmitted;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    const bannerView = t10;
    let t11;
    if ($[22] !== onProvideAdditionalFeedback) {
        t11 = ()=>{
            setIsExpanded(true);
            onProvideAdditionalFeedback();
        };
        $[22] = onProvideAdditionalFeedback;
        $[23] = t11;
    } else t11 = $[23];
    const handleProvideAdditionalFeedback = t11;
    let t12;
    let t13;
    if ($[24] !== isExpanded) {
        t12 = ()=>{
            if (isExpanded) expandedFormHeadingRef.current?.focus();
        };
        t13 = [
            isExpanded
        ];
        $[24] = isExpanded;
        $[25] = t12;
        $[26] = t13;
    } else {
        t12 = $[25];
        t13 = $[26];
    }
    (0, $cozmU.useLayoutEffect)(t12, t13);
    let t14;
    if ($[27] !== onOptIn || $[28] !== onOptInPromptActioned) {
        t14 = ()=>{
            onOptInPromptActioned?.();
            onOptIn?.();
        };
        $[27] = onOptIn;
        $[28] = onOptInPromptActioned;
        $[29] = t14;
    } else t14 = $[29];
    const handleOptInWithMarkSeen = t14;
    let t15;
    if ($[30] !== onDismiss || $[31] !== onOptInPromptActioned) {
        t15 = ()=>{
            onOptInPromptActioned?.();
            onDismiss();
        };
        $[30] = onDismiss;
        $[31] = onOptInPromptActioned;
        $[32] = t15;
    } else t15 = $[32];
    const handleDismissWithMarkSeen = t15;
    let t16;
    if ($[33] !== handleProvideAdditionalFeedback || $[34] !== onOptInPromptActioned) {
        t16 = ()=>{
            onOptInPromptActioned?.();
            handleProvideAdditionalFeedback();
        };
        $[33] = handleProvideAdditionalFeedback;
        $[34] = onOptInPromptActioned;
        $[35] = t16;
    } else t16 = $[35];
    const handleAdditionalFeedbackWithMarkSeen = t16;
    customFeedbackCategories?.positive;
    customFeedbackCategories?.negative;
    let t17;
    bb0: {
        if (customCategoriesOverride) {
            t17 = customCategoriesOverride;
            break bb0;
        }
        if (customFeedbackCategories?.positive && customFeedbackCategories?.negative) {
            t17 = feedbackType === "like" ? customFeedbackCategories.positive : customFeedbackCategories.negative;
            break bb0;
        }
        t17 = feedbackType === "like" ? $f9353d9f66579323$var$POSITIVE_CATEGORIES : $f9353d9f66579323$var$NEGATIVE_CATEGORIES;
    }
    const categories = t17;
    let t18;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = (category)=>{
            setSelectedCategories((prev)=>prev.includes(category) ? prev.filter((c)=>c !== category) : [
                    ...prev,
                    category
                ]);
            setShowValidationError(false);
        };
        $[36] = t18;
    } else t18 = $[36];
    const toggleCategory = t18;
    let t19;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = ()=>{
            setShowValidationError(false);
        };
        $[37] = t19;
    } else t19 = $[37];
    const clearValidationError = t19;
    let t20;
    if ($[38] !== additionalFeedback || $[39] !== enrollInResearch || $[40] !== includeMessages || $[41] !== onIncludeMessagesChecked || $[42] !== onSubmit || $[43] !== selectedCategories) {
        t20 = ()=>{
            if (selectedCategories.includes("other") && !additionalFeedback.trim()) {
                setShowValidationError(true);
                textAreaRef.current?.focus();
                return;
            }
            if (includeMessages && onIncludeMessagesChecked) onIncludeMessagesChecked();
            onSubmit({
                categories: selectedCategories,
                additionalFeedback: additionalFeedback,
                includeMessages: includeMessages,
                enrollInResearch: enrollInResearch
            });
            setIsSubmitted(true);
            setIsExpanded(false);
        };
        $[38] = additionalFeedback;
        $[39] = enrollInResearch;
        $[40] = includeMessages;
        $[41] = onIncludeMessagesChecked;
        $[42] = onSubmit;
        $[43] = selectedCategories;
        $[44] = t20;
    } else t20 = $[44];
    const handleSubmit = t20;
    let t21;
    if ($[45] !== formatMessage || $[46] !== isSubmitted) {
        t21 = isSubmitted && formatMessage((0, $2zDNQ.default).thankYouMessage);
        $[45] = formatMessage;
        $[46] = isSubmitted;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true"
        }, t21);
        $[48] = t21;
        $[49] = t22;
    } else t22 = $[49];
    let t23;
    if ($[50] !== additionalFeedback || $[51] !== bannerView || $[52] !== categories || $[53] !== enrollInResearch || $[54] !== feedbackType || $[55] !== formatMessage || $[56] !== handleAdditionalFeedbackWithMarkSeen || $[57] !== handleDismissWithMarkSeen || $[58] !== handleOptInWithMarkSeen || $[59] !== handleProvideAdditionalFeedback || $[60] !== handleSubmit || $[61] !== includeMessages || $[62] !== isVisible || $[63] !== onDismiss || $[64] !== pauseAutoDismiss || $[65] !== restartAutoDismiss || $[66] !== selectedCategories || $[67] !== shouldHideCheckboxes || $[68] !== shouldShowOptIn || $[69] !== showValidationError) {
        t23 = isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            exitDirection: "top",
            duration: "large"
        }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.200",
                xcss: $f9353d9f66579323$var$styles.bannerContainer
            }, bannerView === "opted-in" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$OptedInMessage, {
                onDismiss: onDismiss,
                onAdditionalFeedback: handleProvideAdditionalFeedback
            }), bannerView === "opt-in-prompt" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$ThankYouOptInPrompt, {
                onDismiss: handleDismissWithMarkSeen,
                onOptIn: handleOptInWithMarkSeen,
                onAdditionalFeedback: handleAdditionalFeedbackWithMarkSeen
            }), (bannerView === "thank-you" || bannerView === "initial") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$ThankYouMessage, {
                onDismiss: onDismiss
            }), bannerView === "initial" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleProvideAdditionalFeedback,
                shouldFitContainer: true
            }, formatMessage((0, $2zDNQ.default).provideAdditionalFeedback)), bannerView === "expanded-form" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$ExpandedFeedbackForm, {
                feedbackType: feedbackType,
                onDismiss: onDismiss,
                categories: categories,
                selectedCategories: selectedCategories,
                toggleCategory: toggleCategory,
                additionalFeedback: additionalFeedback,
                setAdditionalFeedback: setAdditionalFeedback,
                includeMessages: includeMessages,
                setIncludeMessages: setIncludeMessages,
                enrollInResearch: enrollInResearch,
                setEnrollInResearch: setEnrollInResearch,
                handleSubmit: handleSubmit,
                showValidationError: showValidationError,
                clearValidationError: clearValidationError,
                shouldHideCheckboxes: shouldHideCheckboxes ?? false,
                isInternalUser: shouldShowOptIn,
                textAreaRef: textAreaRef,
                headingRef: expandedFormHeadingRef,
                restartAutoDismiss: restartAutoDismiss,
                pauseAutoDismiss: pauseAutoDismiss
            }))));
        $[50] = additionalFeedback;
        $[51] = bannerView;
        $[52] = categories;
        $[53] = enrollInResearch;
        $[54] = feedbackType;
        $[55] = formatMessage;
        $[56] = handleAdditionalFeedbackWithMarkSeen;
        $[57] = handleDismissWithMarkSeen;
        $[58] = handleOptInWithMarkSeen;
        $[59] = handleProvideAdditionalFeedback;
        $[60] = handleSubmit;
        $[61] = includeMessages;
        $[62] = isVisible;
        $[63] = onDismiss;
        $[64] = pauseAutoDismiss;
        $[65] = restartAutoDismiss;
        $[66] = selectedCategories;
        $[67] = shouldHideCheckboxes;
        $[68] = shouldShowOptIn;
        $[69] = showValidationError;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, t23);
        $[71] = t23;
        $[72] = t24;
    } else t24 = $[72];
    let t25;
    if ($[73] !== t22 || $[74] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t22, t24);
        $[73] = t22;
        $[74] = t24;
        $[75] = t25;
    } else t25 = $[75];
    return t25;
} : ({ onProvideAdditionalFeedback: onProvideAdditionalFeedback, onDismiss: onDismiss, isVisible: isVisible, feedbackType: feedbackType, onSubmit: onSubmit, customCategories: customCategoriesOverride, userEmail: userEmailOverride, onIncludeMessagesChecked: onIncludeMessagesChecked, shouldHideCheckboxes: shouldHideCheckboxesOverride, storeUserMessages: storeUserMessagesOverride, onOptIn: onOptIn, isOptedIn: isOptedIn, hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt, onOptInPromptActioned: onOptInPromptActioned, restartAutoDismiss: restartAutoDismiss, pauseAutoDismiss: pauseAutoDismiss, csatRating: csatRating })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { profileData: { email: globalEmail } } = (0, $eKjv9.useGlobalConfig)();
    const { customFeedbackCategories: customFeedbackCategories } = (0, $dSCNl.useUIConfig)();
    const { preferences: { storeUserMessages: prefsStoreUserMessages } } = (0, $lTU4O.useUserPreferences)();
    const userEmail = userEmailOverride ?? globalEmail;
    const storeUserMessages = storeUserMessagesOverride ?? prefsStoreUserMessages;
    const shouldHideCheckboxes = shouldHideCheckboxesOverride ?? (0, $cWQ7I.isInternalUserWithAutoIncludeHistory)(userEmail, storeUserMessages);
    const shouldShowOptIn = (0, $dEP8O.shouldShowOptInPrompt)(userEmail);
    const shouldOfferOptInPromptByDefault = storeUserMessages === false && !hasSeenFeedbackOptInPrompt && !!onOptIn && shouldShowOptIn;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isSubmitted, setIsSubmitted] = (0, $cozmU.useState)(false);
    const [selectedCategories, setSelectedCategories] = (0, $cozmU.useState)([]);
    const [additionalFeedback, setAdditionalFeedback] = (0, $cozmU.useState)('');
    const [includeMessages, setIncludeMessages] = (0, $cozmU.useState)((0, $l3d45.isAtlassianEmployee)(userEmail));
    const [enrollInResearch, setEnrollInResearch] = (0, $cozmU.useState)(false);
    const [showValidationError, setShowValidationError] = (0, $cozmU.useState)(false);
    const textAreaRef = (0, $cozmU.useRef)(null);
    const expandedFormHeadingRef = (0, $cozmU.useRef)(null);
    const hasEvaluatedDirectFeedbackTreatmentRef = (0, $cozmU.useRef)(false);
    const showOptInPrompt = !isOptedIn && !isExpanded && !isSubmitted && shouldOfferOptInPromptByDefault;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isVisible) {
            hasEvaluatedDirectFeedbackTreatmentRef.current = false;
            return;
        }
        if (csatRating != null && !isExpanded && !isSubmitted) {
            setIsExpanded(true);
            return;
        }
        const isAtTreatmentDecisionPoint = !isSubmitted && !isExpanded && !isOptedIn && !shouldOfferOptInPromptByDefault;
        if (!isAtTreatmentDecisionPoint || hasEvaluatedDirectFeedbackTreatmentRef.current) return;
        hasEvaluatedDirectFeedbackTreatmentRef.current = true;
        setIsExpanded(true);
    }, [
        isVisible,
        isSubmitted,
        isExpanded,
        isOptedIn,
        shouldOfferOptInPromptByDefault,
        csatRating
    ]);
    const bannerView = $f9353d9f66579323$var$getBannerViewState({
        isOptedIn: isOptedIn,
        isExpanded: isExpanded,
        isSubmitted: isSubmitted,
        showOptInPrompt: !!showOptInPrompt
    });
    const handleProvideAdditionalFeedback = (0, $cozmU.useCallback)(()=>{
        setIsExpanded(true);
        onProvideAdditionalFeedback();
    }, [
        onProvideAdditionalFeedback
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isExpanded) expandedFormHeadingRef.current?.focus();
    }, [
        isExpanded
    ]);
    const handleOptInWithMarkSeen = (0, $cozmU.useCallback)(()=>{
        onOptInPromptActioned?.();
        onOptIn?.();
    }, [
        onOptInPromptActioned,
        onOptIn
    ]);
    const handleDismissWithMarkSeen = (0, $cozmU.useCallback)(()=>{
        onOptInPromptActioned?.();
        onDismiss();
    }, [
        onOptInPromptActioned,
        onDismiss
    ]);
    const handleAdditionalFeedbackWithMarkSeen = (0, $cozmU.useCallback)(()=>{
        onOptInPromptActioned?.();
        handleProvideAdditionalFeedback();
    }, [
        onOptInPromptActioned,
        handleProvideAdditionalFeedback
    ]);
    const categories = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (customCategoriesOverride) return customCategoriesOverride;
        if (customFeedbackCategories?.positive && customFeedbackCategories?.negative) return feedbackType === 'like' ? customFeedbackCategories.positive : customFeedbackCategories.negative;
        return feedbackType === 'like' ? $f9353d9f66579323$var$POSITIVE_CATEGORIES : $f9353d9f66579323$var$NEGATIVE_CATEGORIES;
    }, [
        feedbackType,
        customCategoriesOverride,
        customFeedbackCategories?.positive,
        customFeedbackCategories?.negative
    ]);
    const toggleCategory = (0, $cozmU.useCallback)((category)=>{
        setSelectedCategories((prev)=>prev.includes(category) ? prev.filter((c)=>c !== category) : [
                ...prev,
                category
            ]);
        setShowValidationError(false);
    }, []);
    const clearValidationError = (0, $cozmU.useCallback)(()=>{
        setShowValidationError(false);
    }, []);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if (selectedCategories.includes('other') && !additionalFeedback.trim()) {
            setShowValidationError(true);
            textAreaRef.current?.focus();
            return;
        } // Fire analytic if includeMessages checkbox is checked when submitting
        if (includeMessages && onIncludeMessagesChecked) onIncludeMessagesChecked();
        onSubmit({
            categories: selectedCategories,
            additionalFeedback: additionalFeedback,
            includeMessages: includeMessages,
            enrollInResearch: enrollInResearch
        });
        setIsSubmitted(true);
        setIsExpanded(false);
    }, [
        selectedCategories,
        additionalFeedback,
        includeMessages,
        enrollInResearch,
        onSubmit,
        onIncludeMessagesChecked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, isSubmitted && formatMessage((0, $2zDNQ.default).thankYouMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        exitDirection: "top",
        duration: "large"
    }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            xcss: $f9353d9f66579323$var$styles.bannerContainer
        }, bannerView === 'opted-in' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$OptedInMessage, {
            onDismiss: onDismiss,
            onAdditionalFeedback: handleProvideAdditionalFeedback
        }), bannerView === 'opt-in-prompt' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$ThankYouOptInPrompt, {
            onDismiss: handleDismissWithMarkSeen,
            onOptIn: handleOptInWithMarkSeen,
            onAdditionalFeedback: handleAdditionalFeedbackWithMarkSeen
        }), (bannerView === 'thank-you' || bannerView === 'initial') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$ThankYouMessage, {
            onDismiss: onDismiss
        }), bannerView === 'initial' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleProvideAdditionalFeedback,
            shouldFitContainer: true
        }, formatMessage((0, $2zDNQ.default).provideAdditionalFeedback)), bannerView === 'expanded-form' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9353d9f66579323$var$ExpandedFeedbackForm, {
            feedbackType: feedbackType,
            onDismiss: onDismiss,
            categories: categories,
            selectedCategories: selectedCategories,
            toggleCategory: toggleCategory,
            additionalFeedback: additionalFeedback,
            setAdditionalFeedback: setAdditionalFeedback,
            includeMessages: includeMessages,
            setIncludeMessages: setIncludeMessages,
            enrollInResearch: enrollInResearch,
            setEnrollInResearch: setEnrollInResearch,
            handleSubmit: handleSubmit,
            showValidationError: showValidationError,
            clearValidationError: clearValidationError,
            shouldHideCheckboxes: shouldHideCheckboxes ?? false,
            isInternalUser: shouldShowOptIn,
            textAreaRef: textAreaRef,
            headingRef: expandedFormHeadingRef,
            restartAutoDismiss: restartAutoDismiss,
            pauseAutoDismiss: pauseAutoDismiss
        }))))));
};
function $f9353d9f66579323$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        size: "small",
        ...props
    });
}
function $f9353d9f66579323$var$_temp2(text) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "bold"
    }, text);
}
function $f9353d9f66579323$var$_temp3(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        size: "small",
        ...props_0
    });
}
module.exports["FeedbackConfirmationBanner"] = $f9353d9f66579323$export$b396d0937ee27ce8;

});

parcelRegister("2zDNQ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $84a883ad0d97bf1a$var$message = (0, $kSwu1.defineMessages)({
    thankYouMessage: {
        id: "ai-mate.feedback-confirmation-banner.thank-you-message",
        defaultMessage: "Thank you for your feedback!"
    },
    provideAdditionalFeedback: {
        id: "ai-mate.feedback-confirmation-banner.provide-additional-feedback",
        defaultMessage: "Provide additional feedback"
    },
    optInQuestion: {
        id: "ai-mate.feedback-confirmation-banner.opt-in-question",
        defaultMessage: "Do you want to <b>include recent messages from this conversation</b> to help Atlassian debug issues? Atlassian may contact you in order to debug the reported issues."
    },
    yesOptIn: {
        id: "ai-mate.feedback-confirmation-banner.yes-opt-in",
        defaultMessage: "Yes, opt in"
    },
    additionalFeedbackButton: {
        id: "ai-mate.feedback-confirmation-banner.additional-feedback-button",
        defaultMessage: "Additional feedback"
    },
    optedInMessage: {
        id: "ai-mate.feedback-confirmation-banner.opted-in-message",
        defaultMessage: "Thanks for opting in to share feedback!"
    },
    dismissBanner: {
        id: "ai-mate.feedback-confirmation-banner.dismiss-banner",
        defaultMessage: "Dismiss"
    },
    whatWorkedQuestion: {
        id: "ai-mate.feedback-confirmation-banner.what-worked-question",
        defaultMessage: "What worked about this response?"
    },
    whatDidntWorkQuestion: {
        id: "ai-mate.feedback-confirmation-banner.what-didnt-work-question",
        defaultMessage: "What didn't work about this response?"
    },
    itWasLabel: {
        id: "ai-mate.feedback-confirmation-banner.it-was-label",
        defaultMessage: "It was..."
    },
    categoryUpToDate: {
        id: "ai-mate.feedback-confirmation-banner.category-up-to-date",
        defaultMessage: "Up to date"
    },
    categoryAccurate: {
        id: "ai-mate.feedback-confirmation-banner.category-accurate",
        defaultMessage: "Accurate"
    },
    categoryHelpful: {
        id: "ai-mate.feedback-confirmation-banner.category-helpful",
        defaultMessage: "Helpful"
    },
    categoryOnBrief: {
        id: "ai-mate.feedback-confirmation-banner.category-on-brief",
        defaultMessage: "On-brief"
    },
    categoryWellSourced: {
        id: "ai-mate.feedback-confirmation-banner.category-well-sourced",
        defaultMessage: "Well-sourced"
    },
    categoryOther: {
        id: "ai-mate.feedback-confirmation-banner.category-other",
        defaultMessage: "Other"
    },
    categoryOutOfDate: {
        id: "ai-mate.feedback-confirmation-banner.category-out-of-date",
        defaultMessage: "Out of date"
    },
    categoryInaccurate: {
        id: "ai-mate.feedback-confirmation-banner.category-inaccurate",
        defaultMessage: "Inaccurate"
    },
    categoryTooLong: {
        id: "ai-mate.feedback-confirmation-banner.category-too-long",
        defaultMessage: "Too long"
    },
    categoryTooShort: {
        id: "ai-mate.feedback-confirmation-banner.category-too-short",
        defaultMessage: "Too short"
    },
    categoryPoorlySourced: {
        id: "ai-mate.feedback-confirmation-banner.category-poorly-sourced",
        defaultMessage: "Poorly-sourced"
    },
    categoryInappropriate: {
        id: "ai-mate.feedback-confirmation-banner.category-inappropriate",
        defaultMessage: "Inappropriate or harmful"
    },
    categoryGoodPlan: {
        id: "ai-mate.feedback-confirmation-banner.category-good-plan",
        defaultMessage: "Good plan"
    },
    categoryAskedGoodQuestions: {
        id: "ai-mate.feedback-confirmation-banner.category-asked-good-questions",
        defaultMessage: "Asking good questions"
    },
    categoryReasonableAssumptions: {
        id: "ai-mate.feedback-confirmation-banner.category-reasonable-assumptions",
        defaultMessage: "Making good assumptions"
    },
    categoryShowedMeSomethingNew: {
        id: "ai-mate.feedback-confirmation-banner.category-showed-me-something-new",
        defaultMessage: "Educational"
    },
    categoryTooManyQuestions: {
        id: "ai-mate.feedback-confirmation-banner.category-too-many-questions",
        defaultMessage: "Asking lots of questions"
    },
    categoryNotEnoughQuestions: {
        id: "ai-mate.feedback-confirmation-banner.category-not-enough-questions",
        defaultMessage: "Not enough questions"
    },
    categoryIncorrectPlan: {
        id: "ai-mate.feedback-confirmation-banner.category-incorrect-plan",
        defaultMessage: "Incorrect"
    },
    categoryBuildFailed: {
        id: "ai-mate.feedback-confirmation-banner.category-build-failed",
        defaultMessage: "Not working (build failed)"
    },
    categoryTooWordy: {
        id: "ai-mate.feedback-confirmation-banner.category-too-wordy",
        defaultMessage: "Too wordy"
    },
    categoryBadAssumptions: {
        id: "ai-mate.feedback-confirmation-banner.category-bad-assumptions",
        defaultMessage: "Making bad assumptions"
    },
    additionalFeedbackLabel: {
        id: "ai-mate.feedback-confirmation-banner.additional-feedback-label",
        defaultMessage: "Additional feedback"
    },
    additionalFeedbackPlaceholder: {
        id: "ai-mate.feedback-confirmation-banner.additional-feedback-placeholder",
        defaultMessage: "Tell us more"
    },
    includeMessagesCheckbox: {
        id: "ai-mate.feedback-confirmation-banner.include-messages-checkbox",
        defaultMessage: "Yes, include recent messages from this conversation to help Atlassian debug issues. Atlassian may contact me in order to debug the reported issue."
    },
    enrollInResearchCheckbox: {
        id: "ai-mate.feedback-confirmation-banner.enroll-in-research-checkbox",
        defaultMessage: "Yes, Atlassian may contact me to learn more about my experience and improve Atlassian apps and services. I acknowledge the {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "ai-mate.feedback-confirmation-banner.privacy-policy-link",
        defaultMessage: "Atlassian Privacy Policy"
    },
    submitFeedback: {
        id: "ai-mate.feedback-confirmation-banner.submit-feedback",
        defaultMessage: "Submit feedback"
    },
    additionalFeedbackRequired: {
        id: "ai-mate.feedback-confirmation-banner.additional-feedback-required",
        defaultMessage: "Please provide additional details when selecting \"Other\""
    },
    feedbackPrivacyDisclaimer: {
        id: "ai-mate.feedback-confirmation-banner.feedback-privacy-disclaimer",
        defaultMessage: "Your feedback will be visible to agent owners and admins in studio for up to 28 days."
    }
});
var $84a883ad0d97bf1a$export$2e2bcd8739ae039 = $84a883ad0d97bf1a$var$message;
module.exports["default"] = $84a883ad0d97bf1a$export$2e2bcd8739ae039;

});

parcelRegister("lCO2g", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $cXtTj = parcelRequire("cXtTj");

// Regex patterns for AVP charts that should always render as embed
const $93634853593d7d25$var$avpRovoSkillsChartPattern = /^https?:\/\/(?:www\.)?avp-rovo-skills\.[-\w]+\.frontend\.public\.atl-paas\.net\/v1\/chart/;
const $93634853593d7d25$var$avpChartsPattern = /^https?:\/\/(?:www\.)?.*?\/avpviz\/c\/[^/]+/;
/**
 * Checks if a URL is an AVP chart that should remain as embed
 */ const $93634853593d7d25$var$isAvpChartUrl = (url)=>{
    if (!url) return false;
    return $93634853593d7d25$var$avpRovoSkillsChartPattern.test(url) || $93634853593d7d25$var$avpChartsPattern.test(url);
};
/**
 * Checks if a paragraph node ends with a hardBreak
 */ const $93634853593d7d25$var$endsWithHardBreak = (node)=>{
    if (node.type !== 'paragraph' || !node.content?.length) return false;
    const lastChild = node.content[node.content.length - 1];
    return lastChild?.type === 'hardBreak';
};
/**
 * Converts an embedCard node to an inlineCard node
 */ const $93634853593d7d25$var$convertToInlineCard = (embedCard)=>({
        type: 'inlineCard',
        attrs: {
            url: embedCard.attrs?.url
        }
    });
/**
 * Strips the non-ADF-schema `isStandalone` marker attribute from an embedCard
 * before it is returned to downstream consumers (renderer, serialisers, persistence).
 * The marker is only used internally by this plugin to detect standalone-line URLs.
 */ const $93634853593d7d25$var$stripStandaloneMarker = (node)=>{
    if (!node.attrs || !('isStandalone' in node.attrs)) return node;
    const { isStandalone: _isStandalone, ...restAttrs } = node.attrs;
    return {
        ...node,
        attrs: restAttrs
    };
};
const $93634853593d7d25$export$8a2982daa3f63bd0 = (adf)=>{
    if (!adf.content || adf.content.length === 0) return adf;
    // CRCS-5223: When the new-3P experiment is on, all embedCards at doc level
    // are intentional block-level cards produced from standalone-line URLs.
    // The downgrade-and-merge path must be skipped entirely so that their
    // position in the document is never changed.
    const experimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_smartlink_new_third_parties', 'isEnabled', false);
    // Track the last paragraph we've seen at doc level
    let lastParagraph = null;
    const result = (0, $jTt8P.traverse)(adf, {
        paragraph: (node, parent)=>{
            // Only track paragraphs at doc level to avoid merging into nested paragraphs
            if (parent.node?.type === 'doc') lastParagraph = node;
            return node;
        },
        embedCard: (node)=>{
            const url = node.attrs?.url;
            // AVP charts should always remain as embed cards
            if ($93634853593d7d25$var$isAvpChartUrl(url)) return $93634853593d7d25$var$stripStandaloneMarker(node);
            // Check if we have a previous paragraph that ends with hardBreak
            if (lastParagraph && $93634853593d7d25$var$endsWithHardBreak(lastParagraph)) {
                // Remove the trailing hardBreak since embed will be a block element
                if (lastParagraph.content) lastParagraph.content = lastParagraph.content.slice(0, -1);
                // Keep the embedCard as-is (without leaking the internal marker)
                return $93634853593d7d25$var$stripStandaloneMarker(node);
            }
            // Skip the downgrade-and-merge for embedCards that were produced from a standalone-line URL (marked
            // with isStandalone by the md-plugin-smartlink tokenizer).
            // Mid-sentence embeds (where text precedes the URL on the same line) must still be
            // downgraded and merged so the sentence reads naturally as an inlineCard.
            // When the experiment is off, the original behaviour is fully preserved.
            if (experimentEnabled && node.attrs?.isStandalone === 'true') return $93634853593d7d25$var$stripStandaloneMarker(node);
            if (lastParagraph) {
                // No hardBreak - convert to inline and append to previous paragraph
                const inlineCard = $93634853593d7d25$var$convertToInlineCard(node);
                // Add a space before the inline card to preserve text separation
                const spaceNode = {
                    type: 'text',
                    text: ' '
                };
                if (lastParagraph.content) lastParagraph.content.push(spaceNode, inlineCard);
                else lastParagraph.content = [
                    spaceNode,
                    inlineCard
                ];
                // Drop the embedCard from the document
                return false;
            }
            // No previous paragraph — keep the embedCard in its original position
            // (without leaking the internal marker).
            return $93634853593d7d25$var$stripStandaloneMarker(node);
        }
    });
    return result || adf;
};
module.exports["adfSmartlinksPlugin"] = $93634853593d7d25$export$8a2982daa3f63bd0;

});

parcelRegister("aiNUD", function(module, exports) {
const $e1f85eed29785901$export$e7677c07caaad319 = ()=>{
    if (typeof window === 'undefined') return;
    try {
        return window.origin;
    } catch  {
        return undefined;
    }
};
module.exports["getCurrentOrigin"] = $e1f85eed29785901$export$e7677c07caaad319;

});

parcelRegister("SJycm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b4SfK = parcelRequire("b4SfK");


var $cMyWi = parcelRequire("cMyWi");


var $iDrrr = parcelRequire("iDrrr");


var $eKjv9 = parcelRequire("eKjv9");

const $336fb3c76d1779ce$var$FALLBACK_BRIDGE = 'rovo-chat';
const $336fb3c76d1779ce$export$5a88988daf806ad1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    const { bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $cMyWi.useSmartLinkContext)();
    const effectiveProduct = xpcProduct || productKey || $336fb3c76d1779ce$var$FALLBACK_BRIDGE;
    const t0 = bridgeProduct ?? $336fb3c76d1779ce$var$FALLBACK_BRIDGE;
    let t1;
    if ($[0] !== xpcSubProduct) {
        t1 = xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {};
        $[0] = xpcSubProduct;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== effectiveProduct || $[3] !== t0 || $[4] !== t1) {
        t2 = {
            bridge: t0,
            product: effectiveProduct,
            ...t1
        };
        $[2] = effectiveProduct;
        $[3] = t0;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const wrapUrl = (0, $b4SfK.default)(t2);
    const isEnabled = (0, $iDrrr.fg)("platform_smartlink_xpc_url_wrapping");
    let t3;
    if ($[6] !== wrapUrl) {
        t3 = (url, stripOnly)=>{
            try {
                const parsed = new URL(url);
                if (parsed.searchParams.get("datasource") !== "1p") return url;
                parsed.searchParams.delete("datasource");
                if (stripOnly) return parsed.toString();
                return wrapUrl(parsed.toString());
            } catch  {
                return url;
            }
        };
        $[6] = wrapUrl;
        $[7] = t3;
    } else t3 = $[7];
    const callback = t3;
    return isEnabled ? callback : undefined;
} : ()=>{
    const { productKey: productKey } = (0, $eKjv9.useGlobalConfig)();
    const { bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $cMyWi.useSmartLinkContext)();
    // Mirror the precedence used by `useSmartLinkCrossProductUrlWrapper`:
    // xpcProduct overrides productKey for XPC analytics only.
    // Treat empty strings as missing so the wrapper always receives a usable product.
    const effectiveProduct = xpcProduct || productKey || $336fb3c76d1779ce$var$FALLBACK_BRIDGE;
    const wrapUrl = (0, $b4SfK.default)({
        bridge: bridgeProduct ?? $336fb3c76d1779ce$var$FALLBACK_BRIDGE,
        product: effectiveProduct,
        ...xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {}
    });
    const isEnabled = (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping');
    const callback = (0, $cozmU.useCallback)((url, stripOnly)=>{
        try {
            const parsed = new URL(url);
            if (parsed.searchParams.get('datasource') !== '1p') return url;
            parsed.searchParams.delete('datasource');
            if (stripOnly) return parsed.toString();
            return wrapUrl(parsed.toString());
        } catch  {
            // Non-parseable URL — return as-is
            return url;
        }
    }, [
        wrapUrl
    ]);
    return isEnabled ? callback : undefined;
};
module.exports["useXpcLinkWrapper"] = $336fb3c76d1779ce$export$5a88988daf806ad1;

});

parcelRegister("igyuJ", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");

const $9108b9f62ad10a05$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    name: 'agentDebugModal',
    initialState: {
        isOpen: false,
        data: null
    },
    actions: {
        openModal: ({ messageId: messageId, conversationId: conversationId })=>async ({ setState: setState })=>{
                setState({
                    isOpen: true,
                    data: {
                        messageId: messageId,
                        conversationId: conversationId
                    }
                });
            },
        closeModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false,
                    data: null
                });
            }
    }
});
module.exports["store"] = $9108b9f62ad10a05$export$6f57813fe9f31bf9;

});

parcelRegister("eudbX", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");

const $2746d6f36d01c346$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    name: 'dataSculptorModal',
    initialState: {
        isOpen: false,
        data: null
    },
    actions: {
        openModal: (data)=>({ setState: setState })=>{
                setState({
                    isOpen: true,
                    data: data
                });
            },
        closeModal: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false,
                    data: null
                });
            }
    }
});
module.exports["store"] = $2746d6f36d01c346$export$6f57813fe9f31bf9;

});

parcelRegister("5l24t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $2knbJ = parcelRequire("2knbJ");


var $1X2GM = parcelRequire("1X2GM");


var $aiNUD = parcelRequire("aiNUD");


var $l3d45 = parcelRequire("l3d45");


var $cWQ7I = parcelRequire("cWQ7I");


var $dEP8O = parcelRequire("dEP8O");


var $8SDpb = parcelRequire("8SDpb");


var $cMq9g = parcelRequire("cMq9g");


var $gg9X0 = parcelRequire("gg9X0");

const $c91601488d8dc0e6$var$DEFAULT_AUTO_DISMISS_DELAY = 10000;
const $c91601488d8dc0e6$var$QUICK_FEEDBACK_AUTO_DISMISS_DELAY = 20000;
const $c91601488d8dc0e6$var$EMPTY_FEEDBACK_TRIGGER_PROPS = {};
const $c91601488d8dc0e6$export$7b1c91e3e7793727 = (config)=>{
    const { entryPointId: entryPointId, aaid: aaid, name: name, email: email, productKey: productKey, stagingAreaEnabled: stagingAreaEnabled, agentMessageId: agentMessageId, messageRequestId: messageRequestId, conversationId: conversationId, selectedAgent: selectedAgent, history: history, analyticsMessageActions: analyticsMessageActions, autoDismissDelay: autoDismissDelay, traceId: traceId, isAUPError: isAUPError, minionAlias: minionAlias, storeUserMessages: storeUserMessages, siteId: siteId, experienceId: experienceId, productHeader: productHeader, setStoreUserMessages: setStoreUserMessages, detailedFeedbackSource: detailedFeedbackSource, interactionModeExecuted: interactionModeExecuted, feedbackTrigger: feedbackTrigger } = config;
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const interactionModeExecutedAttributes = (0, $cozmU.useMemo)(()=>interactionModeExecuted ? {
            interactionModeExecuted: interactionModeExecuted
        } : {}, [
        interactionModeExecuted
    ]);
    const feedbackTriggerProps = (0, $cozmU.useMemo)(()=>feedbackTrigger ? {
            feedbackTrigger: feedbackTrigger
        } : $c91601488d8dc0e6$var$EMPTY_FEEDBACK_TRIGGER_PROPS, [
        feedbackTrigger
    ]);
    const shouldAutoInclude = (0, $cWQ7I.isInternalUserWithAutoIncludeHistory)(email, storeUserMessages);
    const feedbackType = (0, $2knbJ.useGetMessageFeedbackType)(agentMessageId, conversationId) ?? null;
    const setMessageFeedbackSent = (0, $2knbJ.useSetMessageFeedbackSent)();
    const hasSubmittedDetailedFeedbackRef = (0, $cozmU.useRef)(false);
    const [isOptedIn, setIsOptedIn] = (0, $cozmU.useState)(false);
    const [csatRating, setCsatRating] = (0, $cozmU.useState)(null);
    const submitQuickFeedback = (0, $cozmU.useCallback)(()=>{
        if (isAUPError) return;
        if (!hasSubmittedDetailedFeedbackRef.current && feedbackType !== null) {
            const includeMessages = shouldAutoInclude;
            const enrollInResearch = (0, $dEP8O.shouldShowOptInPrompt)(email);
            (0, $cMq9g.submitQuickFeedbackToJSM)({
                entryPointId: entryPointId,
                metadata: {
                    aaid: aaid ?? 'unknown',
                    answerQuality: feedbackType === 'like' ? 'good' : 'bad',
                    assistantResponseId: agentMessageId,
                    messageRequestId: messageRequestId,
                    origin: (0, $aiNUD.getCurrentOrigin)() ?? 'unknown',
                    feedbackSource: `${productKey}-v2-quick-feedback`,
                    ...feedbackTriggerProps,
                    selectedAgent: selectedAgent ? {
                        id: selectedAgent.id,
                        externalConfigReference: selectedAgent.external_config_reference
                    } : undefined,
                    conversationId: conversationId,
                    isDetailedFeedback: false,
                    minionAlias: minionAlias,
                    includeMessages: includeMessages,
                    enrollInResearch: enrollInResearch,
                    history: includeMessages ? history : undefined,
                    csatRating: csatRating ?? undefined
                },
                customerName: name || 'unknown',
                email: email
            }).then(()=>{
                sendAnalyticsEvent({
                    action: 'submitted',
                    actionSubject: 'quickFeedback',
                    actionSubjectId: 'feedbackConfirmationBanner',
                    attributes: {
                        feedbackType: feedbackType === 'like' ? 'like' : 'dislike',
                        messageId: agentMessageId,
                        storeUserMessages: shouldAutoInclude,
                        ...feedbackTriggerProps
                    }
                });
            }).catch((error)=>{
                sendAnalyticsEvent({
                    action: 'failed',
                    actionSubject: 'feedbackSubmission',
                    actionSubjectId: 'jsmQuickFeedback',
                    attributes: {
                        errorMessage: error?.message ?? 'Unknown error',
                        feedbackType: feedbackType === 'like' ? 'like' : 'dislike',
                        messageId: agentMessageId,
                        ...feedbackTriggerProps
                    }
                });
            });
        }
    }, [
        feedbackType,
        entryPointId,
        aaid,
        agentMessageId,
        messageRequestId,
        productKey,
        selectedAgent,
        conversationId,
        name,
        email,
        sendAnalyticsEvent,
        isAUPError,
        minionAlias,
        shouldAutoInclude,
        history,
        csatRating,
        feedbackTriggerProps
    ]);
    const { isVisible: isBannerVisible, showWithoutTimer: showBannerWithoutTimer, hide: hideBanner, cancelTimer: cancelAutoDismiss, restartTimer: restartAutoDismiss } = (0, $1X2GM.useAutoDismiss)({
        delay: autoDismissDelay ?? $c91601488d8dc0e6$var$QUICK_FEEDBACK_AUTO_DISMISS_DELAY,
        onAutoDismiss: ()=>submitQuickFeedback()
    });
    const { isVisible: isAUPThumbsDownBannerVisible, showWithoutTimer: showAUPThumbsDownBannerWithoutTimer, show: showAUPThumbsDownThankYou, hide: hideAUPThumbsDownBanner } = (0, $1X2GM.useAutoDismiss)({
        delay: autoDismissDelay ?? $c91601488d8dc0e6$var$DEFAULT_AUTO_DISMISS_DELAY
    });
    const handleThumbClick = (0, $cozmU.useCallback)((isLike)=>{
        setCsatRating(null);
        const newFeedbackType = isLike ? 'like' : 'dislike';
        setMessageFeedbackSent(agentMessageId, newFeedbackType, conversationId);
        hasSubmittedDetailedFeedbackRef.current = false;
        setIsOptedIn(false);
        showBannerWithoutTimer();
        restartAutoDismiss();
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'clicked',
            actionSubject: 'thumbButton',
            attributes: {
                feedbackValue: isLike ? 'like' : 'dislike',
                conversationId: conversationId,
                messageId: agentMessageId
            }
        });
        trackAIMAUEvent({
            type: 'feedback',
            feedbackResult: isLike ? 'up' : 'down',
            proactive: false,
            messageId: agentMessageId,
            messageActions: analyticsMessageActions,
            singleInstrumentationID: agentMessageId,
            attributes: {
                ...interactionModeExecutedAttributes,
                ...feedbackTriggerProps
            }
        });
        if (conversationId && siteId && experienceId && productHeader && (0, $iDrrr.fg)('service_agent_send_feedback_to_convo_ai_on_thumb')) (0, $gg9X0.sendConvoAIFeedback)({
            conversationId: conversationId,
            messageId: agentMessageId,
            feedbackValue: isLike ? 'LIKE' : 'DISLIKE',
            productHeader: productHeader,
            experienceId: experienceId,
            channelId: config.channelId ?? 'rovo-chat',
            cloudId: siteId
        }).catch(()=>{
        // TODO RSA-569: send analytics event for feedback to Convo AI failed
        });
    }, [
        setMessageFeedbackSent,
        agentMessageId,
        conversationId,
        sendAnalyticsEvent,
        trackAIMAUEvent,
        analyticsMessageActions,
        siteId,
        experienceId,
        productHeader,
        showBannerWithoutTimer,
        restartAutoDismiss,
        config.channelId,
        interactionModeExecutedAttributes,
        feedbackTriggerProps
    ]);
    const handleCsatFeedback = (0, $cozmU.useCallback)((rating)=>{
        setCsatRating(rating);
        const isLike_0 = rating === 'completely' || rating === 'mostly';
        const newFeedbackType_0 = isLike_0 ? 'like' : 'dislike';
        setMessageFeedbackSent(agentMessageId, newFeedbackType_0, conversationId);
        hasSubmittedDetailedFeedbackRef.current = false;
        setIsOptedIn(false);
        showBannerWithoutTimer();
        restartAutoDismiss();
        return isLike_0;
    }, [
        setMessageFeedbackSent,
        agentMessageId,
        conversationId,
        showBannerWithoutTimer,
        restartAutoDismiss
    ]);
    const handleProvideAdditionalFeedback = (0, $cozmU.useCallback)(()=>{
        cancelAutoDismiss();
    }, [
        cancelAutoDismiss
    ]);
    const handleFeedbackSubmit = (0, $cozmU.useCallback)(async (data)=>{
        cancelAutoDismiss();
        hasSubmittedDetailedFeedbackRef.current = true;
        const shouldIncludeHistory = shouldAutoInclude || data.includeMessages;
        const shouldEnrollInResearch = (0, $dEP8O.shouldShowOptInPrompt)(email) || data.enrollInResearch;
        // Route "inappropriate" (harmful content) category to AUP endpoint
        if (data.categories.includes('inappropriate')) {
            try {
                await (0, $8SDpb.submitAUPFeedbackToJSM)({
                    metadata: {
                        aaid: aaid ?? 'unknown',
                        assistantResponseId: agentMessageId,
                        messageRequestId: messageRequestId,
                        origin: (0, $aiNUD.getCurrentOrigin)() ?? 'unknown',
                        feedbackSource: `${productKey}-v2-harmful-content`,
                        ...feedbackTriggerProps,
                        conversationId: conversationId,
                        history: shouldIncludeHistory ? history : undefined,
                        isAupFeedback: true,
                        minionAlias: minionAlias
                    },
                    customerName: name || 'unknown',
                    email: email,
                    feedbackText: data.additionalFeedback,
                    includeInput: shouldIncludeHistory,
                    enrollInResearch: shouldEnrollInResearch
                });
                trackAIMAUEvent({
                    type: 'feedback',
                    feedbackResult: 'down',
                    proactive: false,
                    messageId: agentMessageId,
                    messageActions: analyticsMessageActions,
                    singleInstrumentationID: agentMessageId,
                    attributes: {
                        ...interactionModeExecutedAttributes,
                        ...feedbackTriggerProps
                    }
                });
                sendAnalyticsEvent({
                    action: 'submitted',
                    actionSubject: 'aupFeedback',
                    actionSubjectId: 'harmfulContentReport',
                    attributes: {
                        hasAdditionalFeedback: !!data.additionalFeedback,
                        includeMessages: shouldIncludeHistory,
                        enrollInResearch: shouldEnrollInResearch
                    }
                });
                restartAutoDismiss();
            } catch (error_0) {
                (0, $hlvTd.logException)({
                    name: 'harmfulContentSubmission',
                    exception: error_0 instanceof Error ? error_0 : new Error('Failed to submit harmful content feedback'),
                    tags: {
                        component: 'FeedbackConfirmationBanner',
                        feedbackType: feedbackType ?? 'unknown',
                        messageId: agentMessageId
                    }
                });
                sendAnalyticsEvent({
                    action: 'failed',
                    actionSubject: 'aupFeedback',
                    actionSubjectId: 'harmfulContentReport',
                    attributes: {
                        errorMessage: error_0 instanceof Error ? error_0.message : 'Unknown error',
                        messageId: agentMessageId
                    }
                });
                restartAutoDismiss();
            }
            // Send AUP feedback to Convo AI as well — fire-and-forget
            if (conversationId && siteId && experienceId && productHeader && feedbackType && (0, $iDrrr.fg)('rovo_send_detailed_feedback_to_convo_ai')) (0, $gg9X0.sendConvoAIFeedback)({
                conversationId: conversationId,
                messageId: agentMessageId,
                feedbackValue: feedbackType === 'like' ? 'LIKE' : 'DISLIKE',
                feedbackText: data.additionalFeedback || undefined,
                feedbackCategories: data.categories.length > 0 ? data.categories : undefined,
                productHeader: productHeader,
                experienceId: experienceId,
                channelId: config.channelId ?? 'rovo-chat',
                cloudId: siteId
            }).catch(()=>{
            // Non-blocking
            });
            return;
        }
        try {
            const hasDetailedContent = data.categories.length > 0 || !!data.additionalFeedback || data.includeMessages || data.enrollInResearch;
            await (0, $cMq9g.submitQuickFeedbackToJSM)({
                entryPointId: entryPointId,
                metadata: {
                    aaid: aaid ?? 'unknown',
                    answerQuality: feedbackType === 'like' ? 'good' : 'bad',
                    assistantResponseId: agentMessageId,
                    messageRequestId: messageRequestId,
                    origin: (0, $aiNUD.getCurrentOrigin)() ?? 'unknown',
                    feedbackSource: detailedFeedbackSource ?? (stagingAreaEnabled ? `${productKey}-staging-v2-detailed` : `${productKey}-v2-detailed`),
                    conversationId: conversationId,
                    selectedAgent: selectedAgent ? {
                        id: selectedAgent.id,
                        externalConfigReference: selectedAgent.external_config_reference
                    } : undefined,
                    categories: data.categories,
                    additionalFeedback: data.additionalFeedback,
                    includeMessages: shouldIncludeHistory,
                    enrollInResearch: shouldEnrollInResearch,
                    history: shouldIncludeHistory ? history : undefined,
                    isDetailedFeedback: hasDetailedContent,
                    minionAlias: minionAlias,
                    csatRating: csatRating ?? undefined,
                    ...feedbackTriggerProps
                },
                customerName: name || 'unknown',
                email: email
            });
            trackAIMAUEvent({
                type: 'feedback',
                feedbackResult: feedbackType === 'like' ? 'up' : 'down',
                proactive: false,
                messageId: agentMessageId,
                messageActions: analyticsMessageActions,
                singleInstrumentationID: agentMessageId,
                attributes: {
                    ...interactionModeExecutedAttributes,
                    ...feedbackTriggerProps
                }
            });
            sendAnalyticsEvent({
                action: 'submitted',
                actionSubject: 'detailedFeedback',
                actionSubjectId: 'feedbackConfirmationBanner',
                attributes: {
                    feedbackType: feedbackType,
                    feedbackOrigin: csatRating ? 'csat' : 'thumb',
                    categories: data.categories,
                    categoriesCount: data.categories.length,
                    hasAdditionalFeedback: !!data.additionalFeedback,
                    includeMessages: shouldIncludeHistory,
                    enrollInResearch: shouldEnrollInResearch,
                    isInternalUser: (0, $l3d45.isAtlassianEmployee)(email),
                    storeUserMessages: !!shouldAutoInclude,
                    ...feedbackTriggerProps
                }
            });
            restartAutoDismiss();
        } catch (error_1) {
            (0, $hlvTd.logException)({
                name: 'detailedFeedbackSubmission',
                exception: error_1 instanceof Error ? error_1 : new Error('Failed to submit detailed feedback'),
                tags: {
                    component: 'FeedbackConfirmationBanner',
                    feedbackType: feedbackType ?? 'unknown',
                    messageId: agentMessageId,
                    categoriesCount: String(data.categories.length),
                    hasAdditionalFeedback: String(!!data.additionalFeedback),
                    includeMessages: String(data.includeMessages),
                    enrollInResearch: String(data.enrollInResearch)
                }
            });
            sendAnalyticsEvent({
                action: 'failed',
                actionSubject: 'detailedFeedback',
                actionSubjectId: 'feedbackConfirmationBanner',
                attributes: {
                    errorMessage: error_1 instanceof Error ? error_1.message : 'Unknown error',
                    feedbackType: feedbackType,
                    messageId: agentMessageId,
                    ...feedbackTriggerProps
                }
            });
            restartAutoDismiss();
        }
        // Send detailed feedback (text + categories) to Convo AI — fire-and-forget
        if (conversationId && siteId && experienceId && productHeader && feedbackType && (0, $iDrrr.fg)('rovo_send_detailed_feedback_to_convo_ai')) (0, $gg9X0.sendConvoAIFeedback)({
            conversationId: conversationId,
            messageId: agentMessageId,
            feedbackValue: feedbackType === 'like' ? 'LIKE' : 'DISLIKE',
            feedbackText: data.additionalFeedback || undefined,
            feedbackCategories: data.categories.length > 0 ? data.categories : undefined,
            productHeader: productHeader,
            experienceId: experienceId,
            channelId: config.channelId ?? 'rovo-chat',
            cloudId: siteId
        }).catch(()=>{
        // Non-blocking — don't fail the feedback submission if convo-ai call fails
        });
    }, [
        cancelAutoDismiss,
        restartAutoDismiss,
        entryPointId,
        aaid,
        name,
        email,
        feedbackType,
        agentMessageId,
        messageRequestId,
        productKey,
        stagingAreaEnabled,
        conversationId,
        selectedAgent,
        history,
        trackAIMAUEvent,
        analyticsMessageActions,
        sendAnalyticsEvent,
        minionAlias,
        shouldAutoInclude,
        interactionModeExecutedAttributes,
        feedbackTriggerProps,
        siteId,
        experienceId,
        productHeader,
        config.channelId,
        csatRating,
        detailedFeedbackSource
    ]);
    const handleDismissBanner = (0, $cozmU.useCallback)(()=>{
        hideBanner();
        submitQuickFeedback();
    }, [
        hideBanner,
        submitQuickFeedback
    ]);
    const handleAUPIncorrectFlagSubmit = (0, $cozmU.useCallback)(async (data_0)=>{
        showAUPThumbsDownThankYou();
        const shouldIncludeHistory_0 = shouldAutoInclude || data_0.includeInput;
        const shouldEnrollInResearch_0 = shouldAutoInclude || data_0.enrollInResearch;
        try {
            await (0, $8SDpb.submitAUPFeedbackToJSM)({
                metadata: {
                    aaid: aaid ?? 'unknown',
                    assistantResponseId: agentMessageId,
                    origin: (0, $aiNUD.getCurrentOrigin)() ?? 'unknown',
                    feedbackSource: `${productKey}-v2-incorrect-flag`,
                    ...feedbackTriggerProps,
                    conversationId: conversationId,
                    history: shouldIncludeHistory_0 ? history : undefined,
                    traceId: traceId,
                    isAupFeedback: true,
                    minionAlias: minionAlias
                },
                customerName: name || 'unknown',
                email: email,
                feedbackText: data_0.feedbackText,
                includeInput: shouldIncludeHistory_0,
                enrollInResearch: shouldEnrollInResearch_0
            });
            trackAIMAUEvent({
                type: 'feedback',
                feedbackResult: 'down',
                proactive: false,
                messageId: agentMessageId,
                messageActions: analyticsMessageActions,
                singleInstrumentationID: agentMessageId,
                attributes: {
                    ...interactionModeExecutedAttributes,
                    ...feedbackTriggerProps
                }
            });
            sendAnalyticsEvent({
                action: 'submitted',
                actionSubject: 'aupFeedback',
                actionSubjectId: 'incorrectFlagReport',
                attributes: {
                    hasAdditionalFeedback: !!data_0.feedbackText,
                    includeInput: shouldIncludeHistory_0,
                    enrollInResearch: shouldEnrollInResearch_0,
                    feedbackVersion: 'v2',
                    ...feedbackTriggerProps
                }
            });
        } catch (error_2) {
            sendAnalyticsEvent({
                action: 'failed',
                actionSubject: 'aupFeedback',
                actionSubjectId: 'incorrectFlagReport',
                attributes: {
                    errorMessage: error_2 instanceof Error ? error_2.message : 'Unknown error',
                    feedbackVersion: 'v2',
                    ...feedbackTriggerProps
                }
            });
        }
    }, [
        aaid,
        agentMessageId,
        productKey,
        conversationId,
        history,
        traceId,
        name,
        email,
        trackAIMAUEvent,
        analyticsMessageActions,
        sendAnalyticsEvent,
        showAUPThumbsDownThankYou,
        minionAlias,
        shouldAutoInclude,
        interactionModeExecutedAttributes,
        feedbackTriggerProps
    ]);
    const handleIncludeMessagesChecked = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'checked',
            actionSubject: 'includeMessagesCheckbox',
            actionSubjectId: 'feedbackConfirmationBanner',
            attributes: {
                feedbackType: feedbackType ?? 'unknown',
                messageId: agentMessageId
            }
        });
    }, [
        sendAnalyticsEvent,
        feedbackType,
        agentMessageId
    ]);
    const handleOptIn = (0, $cozmU.useCallback)(()=>{
        setStoreUserMessages?.(true);
        setIsOptedIn(true);
    }, [
        setStoreUserMessages
    ]);
    return {
        feedbackType: feedbackType,
        isBannerVisible: isBannerVisible,
        shouldHideCheckboxes: shouldAutoInclude,
        handleThumbClick: handleThumbClick,
        handleCsatFeedback: handleCsatFeedback,
        restartAutoDismiss: restartAutoDismiss,
        pauseAutoDismiss: cancelAutoDismiss,
        csatRating: csatRating,
        handleProvideAdditionalFeedback: handleProvideAdditionalFeedback,
        handleFeedbackSubmit: handleFeedbackSubmit,
        handleDismissBanner: handleDismissBanner,
        handleIncludeMessagesChecked: handleIncludeMessagesChecked,
        handleOptIn: handleOptIn,
        isOptedIn: isOptedIn,
        isAUPThumbsDownBannerVisible: isAUPThumbsDownBannerVisible,
        showAUPThumbsDownBanner: showAUPThumbsDownBannerWithoutTimer,
        hideAUPThumbsDownBanner: hideAUPThumbsDownBanner,
        handleAUPIncorrectFlagSubmit: handleAUPIncorrectFlagSubmit
    };
};
module.exports["useFeedbackV2"] = $c91601488d8dc0e6$export$7b1c91e3e7793727;

});

parcelRegister("3Ofxv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $5BOJB = parcelRequire("5BOJB");


var $bQupv = parcelRequire("bQupv");


var $fqtnH = parcelRequire("fqtnH");


var $5wAPd = parcelRequire("5wAPd");

const $30480858176f6c37$export$7f3fcf67835aa917 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { activeAction: activeAction } = (0, $5BOJB.useActiveAction)();
    if (conversation?.tags?.includes((0, $fqtnH.TAGS).INSIGHTS) || (0, $bQupv.getActionSeededConversationOptions)(activeAction)?.tags?.includes((0, $fqtnH.TAGS).INSIGHTS)) return "rovoInsights";
} : ()=>{
    const { conversation: conversation } = (0, $5wAPd.useConversation)();
    const { activeAction: activeAction } = (0, $5BOJB.useActiveAction)();
    if (conversation?.tags?.includes((0, $fqtnH.TAGS).INSIGHTS) || (0, $bQupv.getActionSeededConversationOptions)(activeAction)?.tags?.includes((0, $fqtnH.TAGS).INSIGHTS)) return 'rovoInsights';
    return undefined;
};
module.exports["useFeedbackTrigger"] = $30480858176f6c37$export$7f3fcf67835aa917;

});

parcelRegister("4JJQd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $lNd2W = parcelRequire("lNd2W");


var $4RgKV = parcelRequire("4RgKV");


var $1oo4W = parcelRequire("1oo4W");


var $n71o5 = parcelRequire("n71o5");

const $7c294754bad40617$var$MAX_HISTORY_CHARS = 30000;
const $7c294754bad40617$var$omitField = (item, field)=>{
    if (!item || typeof item !== 'object') return item;
    const record = item;
    // StreamResponse format: item.message.message.<field>
    if (record.message?.message && field in record.message.message) {
        const { [field]: _omitted, ...rest } = record.message.message;
        return {
            ...record,
            message: {
                ...record.message,
                message: rest
            }
        };
    }
    // Flat format: item.<field>
    if (field in record) {
        const { [field]: _omitted, ...rest } = record;
        return rest;
    }
    return item;
};
/**
 * Fields stripped, in order of least to most useful for debugging. Strip cascade
 * stops as soon as the payload fits under MAX_HISTORY_CHARS — so normal-sized
 * conversations have nothing removed, and only oversized payloads lose data.
 */ const $7c294754bad40617$var$TRIMMABLE_FIELDS = [
    'minion_outputs',
    'orchestration_graphs',
    'subagent_invocations',
    'agent_user_context',
    'appendices',
    'sources',
    'actions',
    'usage_data',
    'memory'
];
/**
 * Converts ADF content to plain text within a message, preserving all other fields.
 * Only used as a last resort when dropping messages alone isn't enough.
 */ const $7c294754bad40617$var$flattenAdfContent = (item)=>{
    const toText = (content)=>{
        if (typeof content === 'string') return content;
        if (content && typeof content === 'object' && content.type === 'doc') return (0, $lNd2W.extractPlainTextFromAdf)(content);
        return content;
    };
    if (!item || typeof item !== 'object') return item;
    const record = item;
    if (record.message?.message?.content !== undefined) return {
        ...record,
        message: {
            ...record.message,
            message: {
                ...record.message.message,
                content: toText(record.message.message.content)
            }
        }
    };
    if (record.content !== undefined) return {
        ...record,
        content: toText(record.content)
    };
    return item;
};
const $7c294754bad40617$export$c403ccc58f9f4d1d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { canAttachMessages: canAttachMessages, answerId: answerId } = t0;
    const [t1] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId } = t1;
    let t2;
    if ($[0] !== currentConversationId) {
        t2 = {
            conversationId: currentConversationId
        };
        $[0] = currentConversationId;
        $[1] = t2;
    } else t2 = $[1];
    const [messages] = (0, $iW40i.useChatMessages)(t2);
    let t3;
    if ($[2] !== answerId || $[3] !== canAttachMessages || $[4] !== messages) {
        bb0: {
            if (!canAttachMessages) {
                let t4;
                if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = [];
                    $[6] = t4;
                } else t4 = $[6];
                t3 = t4;
                break bb0;
            }
            let items = (0, $4RgKV.getMessageHistory)(messages, answerId, 5).filter($7c294754bad40617$var$_temp).map($7c294754bad40617$var$_temp2);
            if (JSON.stringify(items).length <= $7c294754bad40617$var$MAX_HISTORY_CHARS) {
                t3 = items;
                break bb0;
            }
            const allItems = items;
            for(let numToKeep = allItems.length; numToKeep >= 2; numToKeep--){
                items = allItems.slice(-numToKeep);
                if (JSON.stringify(items).length <= $7c294754bad40617$var$MAX_HISTORY_CHARS) {
                    t3 = items;
                    break bb0;
                }
            }
            for (const field of $7c294754bad40617$var$TRIMMABLE_FIELDS){
                items = items.map((item)=>$7c294754bad40617$var$omitField(item, field));
                if (JSON.stringify(items).length <= $7c294754bad40617$var$MAX_HISTORY_CHARS) {
                    t3 = items;
                    break bb0;
                }
            }
            if (JSON.stringify(items).length > $7c294754bad40617$var$MAX_HISTORY_CHARS) {
                items = items.map($7c294754bad40617$var$flattenAdfContent);
                const maxPerMsg = Math.max(200, Math.floor($7c294754bad40617$var$MAX_HISTORY_CHARS / items.length) - 500);
                let t4;
                if ($[7] !== maxPerMsg) {
                    t4 = (item_0)=>{
                        if (!item_0 || typeof item_0 !== "object") return item_0;
                        const record = item_0;
                        if (typeof record.message?.message?.content === "string" && record.message.message.content.length > maxPerMsg) return {
                            ...record,
                            message: {
                                ...record.message,
                                message: {
                                    ...record.message.message,
                                    content: `${record.message.message.content.slice(0, maxPerMsg)}... [truncated]`
                                }
                            }
                        };
                        if (typeof record.content === "string" && record.content.length > maxPerMsg) return {
                            ...record,
                            content: `${record.content.slice(0, maxPerMsg)}... [truncated]`
                        };
                        return item_0;
                    };
                    $[7] = maxPerMsg;
                    $[8] = t4;
                } else t4 = $[8];
                items = items.map(t4);
            }
            t3 = items;
        }
        $[2] = answerId;
        $[3] = canAttachMessages;
        $[4] = messages;
        $[5] = t3;
    } else t3 = $[5];
    const history = t3;
    return history;
} : ({ canAttachMessages: canAttachMessages, answerId: answerId })=>{
    const [{ currentConversationId: currentConversationId }] = (0, $n71o5.useChatStore)();
    const [messages] = (0, $iW40i.useChatMessages)({
        conversationId: currentConversationId
    });
    const history = (0, $cozmU.useMemo)(()=>{
        if (!canAttachMessages) return [];
        let items = (0, $4RgKV.getMessageHistory)(messages, answerId, 5).filter((storeChatItem)=>'content' in storeChatItem).map((storeChatItem_0)=>{
            if ((0, $igOtY.isStoreAssistant)(storeChatItem_0)) return (0, $1oo4W.removeSensitiveData)(storeChatItem_0).content;
            return storeChatItem_0.content;
        });
        if (JSON.stringify(items).length <= $7c294754bad40617$var$MAX_HISTORY_CHARS) return items;
        const allItems = items;
        for(let numToKeep = allItems.length; numToKeep >= 2; numToKeep--){
            items = allItems.slice(-numToKeep);
            if (JSON.stringify(items).length <= $7c294754bad40617$var$MAX_HISTORY_CHARS) return items;
        }
        for (const field of $7c294754bad40617$var$TRIMMABLE_FIELDS){
            items = items.map((item)=>$7c294754bad40617$var$omitField(item, field));
            if (JSON.stringify(items).length <= $7c294754bad40617$var$MAX_HISTORY_CHARS) return items;
        }
        if (JSON.stringify(items).length > $7c294754bad40617$var$MAX_HISTORY_CHARS) {
            items = items.map($7c294754bad40617$var$flattenAdfContent);
            const maxPerMsg = Math.max(200, Math.floor($7c294754bad40617$var$MAX_HISTORY_CHARS / items.length) - 500);
            items = items.map((item_0)=>{
                if (!item_0 || typeof item_0 !== 'object') return item_0;
                const record = item_0;
                if (typeof record.message?.message?.content === 'string' && record.message.message.content.length > maxPerMsg) return {
                    ...record,
                    message: {
                        ...record.message,
                        message: {
                            ...record.message.message,
                            content: `${record.message.message.content.slice(0, maxPerMsg)}... [truncated]`
                        }
                    }
                };
                if (typeof record.content === 'string' && record.content.length > maxPerMsg) return {
                    ...record,
                    content: `${record.content.slice(0, maxPerMsg)}... [truncated]`
                };
                return item_0;
            });
        }
        return items;
    }, [
        canAttachMessages,
        messages,
        answerId
    ]);
    return history;
};
function $7c294754bad40617$var$_temp(storeChatItem) {
    return "content" in storeChatItem;
}
function $7c294754bad40617$var$_temp2(storeChatItem_0) {
    if ((0, $igOtY.isStoreAssistant)(storeChatItem_0)) return (0, $1oo4W.removeSensitiveData)(storeChatItem_0).content;
    return storeChatItem_0.content;
}
module.exports["useMessageHistory"] = $7c294754bad40617$export$c403ccc58f9f4d1d;

});

parcelRegister("ari4I", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bltJZ = parcelRequire("bltJZ");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $ic2nu = parcelRequire("ic2nu");

const $a8e2bf07dcddb1e5$var$styles = {
    enforcementRow: "_2sNsIg7NXe _4c065U8HPE _1UtDYzZpcK"
}; /**
    * Renders the enforcement row shown below the redacted message bubble:
    * GuardIcon + "Redacted by your organization".
    */ 
const $a8e2bf07dcddb1e5$export$e1d0a2de2a4e5fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { alignInline: t1 } = t0;
    const alignInline = t1 === undefined ? "end" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.GuardIcon), {
            appearance: "brand",
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        });
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== formatMessage) {
        t3 = formatMessage((0, $ic2nu.messages).enforcementMessage);
        $[1] = formatMessage;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t3);
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== alignInline || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: alignInline,
            xcss: $a8e2bf07dcddb1e5$var$styles.enforcementRow
        }, t2, t4);
        $[5] = alignInline;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ alignInline: alignInline = 'end' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: alignInline,
        xcss: $a8e2bf07dcddb1e5$var$styles.enforcementRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.GuardIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $ic2nu.messages).enforcementMessage)));
};
module.exports["RedactionEnforcementMessage"] = $a8e2bf07dcddb1e5$export$e1d0a2de2a4e5fb;

});

parcelRegister("aGWMb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $5myly = parcelRequire("5myly");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $eFbDl = parcelRequire("eFbDl");


var $4o0zT = parcelRequire("4o0zT");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $1EipK = parcelRequire("1EipK");


var $4Sb8b = parcelRequire("4Sb8b");


var $9qjJ9 = parcelRequire("9qjJ9");


var $j0wI2 = parcelRequire("j0wI2");

const $2e938799a8e52cf2$var$AgentResponseHatFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "72px",
            height: "12px",
            borderRadius: "var(--ds-radius-xsmall, 2px)",
            isShimmering: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
        appearance: "hexagon",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "72px",
        height: "12px",
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        isShimmering: true
    }));
const $2e938799a8e52cf2$var$AgentResponseHatMetadata = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { identityAccount: identityAccount } = t0;
    let t1;
    if ($[0] !== identityAccount.name) {
        t1 = identityAccount.name?.trim();
        $[0] = identityAccount.name;
        $[1] = t1;
    } else t1 = $[1];
    const relayName = t1;
    let t2;
    if ($[2] !== identityAccount || $[3] !== relayName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
            userFragment: identityAccount,
            size: "small",
            name: relayName
        });
        $[2] = identityAccount;
        $[3] = relayName;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== relayName) {
        t3 = relayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium",
            color: "color.text.subtle"
        }, relayName) : null;
        $[5] = relayName;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ identityAccount: identityAccount })=>{
    const relayName = identityAccount.name?.trim();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Sb8b.AvatarRelay), {
        userFragment: identityAccount,
        size: "small",
        name: relayName
    }), relayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, relayName) : null);
};
const $2e938799a8e52cf2$var$AgentResponseHatMetadataFromIdentityAccount = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { identityAccountId: identityAccountId } = t0;
    let t1;
    if ($[0] !== identityAccountId) {
        t1 = {
            identityAccountId: identityAccountId
        };
        $[0] = identityAccountId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $5myly.default), t1, t2);
    let t3;
    if ($[3] !== data.user) {
        t3 = data.user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatMetadata, {
            identityAccount: data.user
        }) : null;
        $[3] = data.user;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ identityAccountId: identityAccountId })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $5myly.default), {
        identityAccountId: identityAccountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    return data.user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatMetadata, {
        identityAccount: data.user
    }) : null;
};
const $2e938799a8e52cf2$var$getAccountIdFromIdentityAccountId = (value)=>{
    const trimmedValue = value?.trim();
    if (!trimmedValue) return undefined;
    const identityUserAriPrefix = 'ari:cloud:identity::user/';
    if (trimmedValue.startsWith(identityUserAriPrefix)) return trimmedValue.slice(identityUserAriPrefix.length);
    return trimmedValue.startsWith('ari:') ? undefined : trimmedValue;
};
const $2e938799a8e52cf2$export$edc1038fd457589a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { isDefaultRovo: isDefaultRovo, agentIdentityAccountId: agentIdentityAccountId, isIdentityHydrating: isIdentityHydrating, cloudId: cloudId, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolvedIsDefaultRovo = isDefaultRovo ?? !agentIdentityAccountId;
    let t1;
    if ($[0] !== agentIdentityAccountId) {
        t1 = $2e938799a8e52cf2$var$getAccountIdFromIdentityAccountId(agentIdentityAccountId);
        $[0] = agentIdentityAccountId;
        $[1] = t1;
    } else t1 = $[1];
    const agentAccountId = t1;
    if (isIdentityHydrating && !resolvedIsDefaultRovo) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatFallback, null);
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== testId) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center",
                testId: testId
            }, t2);
            $[3] = testId;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (!resolvedIsDefaultRovo) {
        if (!agentAccountId) return null;
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatFallback, null);
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] !== agentAccountId) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: t2
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatMetadataFromIdentityAccount, {
                identityAccountId: agentAccountId
            }));
            $[6] = agentAccountId;
            $[7] = t3;
        } else t3 = $[7];
        let t4;
        if ($[8] !== t3 || $[9] !== testId) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center",
                testId: testId
            }, t3);
            $[8] = t3;
            $[9] = testId;
            $[10] = t4;
        } else t4 = $[10];
        const hatContent = t4;
        if (cloudId && agentIdentityAccountId && (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents")) {
            let t5;
            if ($[11] !== agentIdentityAccountId || $[12] !== cloudId || $[13] !== hatContent) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1EipK.AgentProfileCardWithTrigger), {
                    trigger: "hover",
                    identityAccountId: agentIdentityAccountId,
                    cloudId: cloudId,
                    hideConversationStarters: true
                }, hatContent);
                $[11] = agentIdentityAccountId;
                $[12] = cloudId;
                $[13] = hatContent;
                $[14] = t5;
            } else t5 = $[14];
            return t5;
        }
        return hatContent;
    }
    let t2;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qjJ9.DefaultRovoAvatar), {
            size: "small"
        });
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] !== formatMessage) {
        t3 = formatMessage((0, $j0wI2.default).defaultRovoName);
        $[16] = formatMessage;
        $[17] = t3;
    } else t3 = $[17];
    let t4;
    if ($[18] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium",
            color: "color.text.subtle"
        }, t3);
        $[18] = t3;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== t4 || $[21] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            testId: testId
        }, t2, t4);
        $[20] = t4;
        $[21] = testId;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
} : ({ isDefaultRovo: isDefaultRovo, agentIdentityAccountId: agentIdentityAccountId, isIdentityHydrating: isIdentityHydrating, cloudId: cloudId, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolvedIsDefaultRovo = isDefaultRovo ?? !agentIdentityAccountId;
    const agentAccountId = $2e938799a8e52cf2$var$getAccountIdFromIdentityAccountId(agentIdentityAccountId);
    if (isIdentityHydrating && !resolvedIsDefaultRovo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatFallback, null));
    if (!resolvedIsDefaultRovo) {
        if (!agentAccountId) return null;
        const hatContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatFallback, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e938799a8e52cf2$var$AgentResponseHatMetadataFromIdentityAccount, {
            identityAccountId: agentAccountId
        })));
        if (cloudId && agentIdentityAccountId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1EipK.AgentProfileCardWithTrigger), {
            trigger: "hover",
            identityAccountId: agentIdentityAccountId,
            cloudId: cloudId,
            hideConversationStarters: true
        }, hatContent);
        return hatContent;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qjJ9.DefaultRovoAvatar), {
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $j0wI2.default).defaultRovoName)));
};
module.exports["AgentResponseHat"] = $2e938799a8e52cf2$export$edc1038fd457589a;

});

parcelRegister("gIoZF", function(module, exports) {

var $6rwn6 = parcelRequire("6rwn6");


var $5L9X9 = parcelRequire("5L9X9");


var $kjJc7 = parcelRequire("kjJc7");


var $TBobf = parcelRequire("TBobf");


var $7lDGY = parcelRequire("7lDGY");

const $f13c91c4f7b67f69$export$d2452b07d5d6a737 = (content, markdownData)=>{
    try {
        if ((0, $kjJc7.isAdfDoc)(content)) {
            if (!content.content || content.content.length === 0) return null;
            return content;
        }
        const rawPlain = typeof content === 'string' ? content : String(content);
        const splicedForParse = (0, $7lDGY.splicePlaceholders)(rawPlain, markdownData);
        const chunks = (0, $TBobf.segmentLuminaAndProse)(splicedForParse);
        // Prose chunks use the markdown encoder; Lumina XML chunks use the Lumina converter.
        // The resulting top-level ADF content is merged into one document.
        const mergedContent = [];
        for (const chunk of chunks)if (chunk.kind === 'prose') {
            const proseDoc = (0, $6rwn6.adfEncoder).encode(chunk.text);
            if (proseDoc.content) mergedContent.push(...proseDoc.content);
        } else {
            const luminaXml = chunk.kind === 'lumina-document' ? chunk.text : `<section layout="one-column">${chunk.text}</section>`;
            const luminaDoc = (0, $5L9X9.luminaToAdf)(luminaXml);
            if (luminaDoc.content) mergedContent.push(...luminaDoc.content);
        }
        if (mergedContent.length === 0) return null;
        return {
            version: 1,
            type: 'doc',
            content: mergedContent
        };
    } catch  {
        return null;
    }
};
module.exports["buildAdfDocForRichText"] = $f13c91c4f7b67f69$export$d2452b07d5d6a737;

});

parcelRegister("eAl7N", function(module, exports) {

var $8YXeh = parcelRequire("8YXeh");

const $8b1487b0d8770452$var$REDACTED_PATTERN = /(\[REDACT(?:ED)?\])/g;
function $8b1487b0d8770452$var$splitTextNode(node) {
    const text = node.text ?? '';
    // Reset lastIndex for the global regex
    $8b1487b0d8770452$var$REDACTED_PATTERN.lastIndex = 0;
    const parts = text.split($8b1487b0d8770452$var$REDACTED_PATTERN);
    return parts.flatMap((part)=>{
        if (!part) return [];
        if (/^\[REDACT(?:ED)?\]$/.test(part)) return [
            {
                type: 'inlineExtension',
                attrs: {
                    extensionType: (0, $8YXeh.REDACT_EXTENSION_TYPE),
                    extensionKey: (0, $8YXeh.REDACT_EXTENSION_KEY),
                    parameters: {},
                    text: ''
                }
            }
        ];
        return [
            {
                type: 'text',
                text: part,
                ...node.marks ? {
                    marks: node.marks
                } : {}
            }
        ];
    });
}
function $8b1487b0d8770452$var$walkNode(node) {
    if (!node.content) return node;
    const newContent = [];
    for (const child of node.content)if (child.type === 'text' && child.text && $8b1487b0d8770452$var$REDACTED_PATTERN.test(child.text)) {
        $8b1487b0d8770452$var$REDACTED_PATTERN.lastIndex = 0;
        newContent.push(...$8b1487b0d8770452$var$splitTextNode(child));
    } else newContent.push($8b1487b0d8770452$var$walkNode(child));
    return {
        ...node,
        content: newContent
    };
}
function $8b1487b0d8770452$export$6cc68ffc92ff716a(adf) {
    return $8b1487b0d8770452$var$walkNode(adf);
}
module.exports["injectRedactScribbles"] = $8b1487b0d8770452$export$6cc68ffc92ff716a;

});

parcelRegister("g23UR", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("kkLpw")).useRouterActions);
$parcel$export(module.exports, "Link", () => (parcelRequire("5SM4Y")).default);

parcelRequire("f8GSD");
var $kkLpw = parcelRequire("kkLpw");

parcelRequire("9CUrz");
var $5SM4Y = parcelRequire("5SM4Y");

parcelRequire("7nLGD");
var $hW5be = parcelRequire("hW5be");
var $6R2v1 = parcelRequire("6R2v1");
var $4dkdA = parcelRequire("4dkdA");
var $7nLGD = parcelRequire("7nLGD");


var $jfJRg = parcelRequire("jfJRg");


var $bBrxp = parcelRequire("bBrxp");


var $6ZZh7 = parcelRequire("6ZZh7");

parcelRequire("6QmsE");
var $5HsaE = parcelRequire("5HsaE");
var $iMCza = parcelRequire("iMCza");
var $iX7oN = parcelRequire("iX7oN");


});

parcelRegister("jKT15", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $9NPFC = parcelRequire("9NPFC");

const $40b8480b34e7939a$var$messages = (0, $kSwu1.defineMessages)({
    expandSuggestions: {
        id: "conversation-assistant.common.ui.base-preview-card.expand-suggestion",
        defaultMessage: "Expand suggestion"
    },
    collapseSuggestions: {
        id: "conversation-assistant.common.ui.base-preview-card.collapse-suggestion",
        defaultMessage: "Collapse suggestion"
    }
});
// Redefining so we can import the width from the common constants file
const $40b8480b34e7939a$var$styles = {
    pressable: "_39xV02N91d _3iDTPbvLZJ _2fwxA5ecOK _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg",
    containerBase: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3138425zaO _1DCdHi5zaO _3fSdSTGk8v",
    layoutPadding: "_0Of8r28HPE _1wydGW8HPE _1Znuxb5zaO _2Zuz6Q5zaO",
    headerLayoutPadding: "_0Of8r28HPE _1wydGW8HPE _1Znuxb5zaO _2Zuz6Q2ADO",
    contentPadding: "_0Of8r25zaO _1wydGW5zaO _1Znuxb5zaO _2Zuz6Q5zaO",
    multiWorkItemContentPadding: "_0Of8r22ADO _1wydGW2ADO _1Znuxb2ADO _2Zuz6Q2ADO",
    containerTransparentBorder: "_3vBAKH9r67",
    containerWithBorder: "_3vBAKHnXvL",
    header: "_1x1D3gOeNX",
    footer: "_2bqfgdOeNX _39xV02N91d"
};
const $40b8480b34e7939a$var$Header = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isExpanded: isExpanded, isCreated: isCreated, onExpandClick: onExpandClick, previewProductLogo: previewProductLogo, previewHeaderTitle: previewHeaderTitle, isSingleWorkItem: t1 } = t0;
    const isSingleWorkItem = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t2 = isExpanded && $40b8480b34e7939a$var$styles.header;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2, $40b8480b34e7939a$var$styles.headerLayoutPadding);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== previewProductLogo) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            size: "medium",
            hasBorder: true,
            backgroundColor: "transparent"
        }, previewProductLogo);
        $[2] = previewProductLogo;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== previewHeaderTitle || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, t4, previewHeaderTitle);
        $[4] = previewHeaderTitle;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== formatMessage || $[8] !== isCreated || $[9] !== isExpanded || $[10] !== isSingleWorkItem || $[11] !== onExpandClick) {
        t6 = (!isSingleWorkItem || !isCreated) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
            label: isExpanded ? formatMessage($40b8480b34e7939a$var$messages.collapseSuggestions) : formatMessage($40b8480b34e7939a$var$messages.expandSuggestions),
            onClick: onExpandClick,
            appearance: "subtle",
            spacing: "compact",
            testId: "conversation-assistant.base-preview-card.expand-collapse-button",
            isTooltipDisabled: false,
            onMouseDown: $40b8480b34e7939a$var$_temp
        });
        $[7] = formatMessage;
        $[8] = isCreated;
        $[9] = isExpanded;
        $[10] = isSingleWorkItem;
        $[11] = onExpandClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            xcss: t3
        }, t5, t6);
        $[13] = t3;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ isExpanded: isExpanded, isCreated: isCreated, onExpandClick: onExpandClick, previewProductLogo: previewProductLogo, previewHeaderTitle: previewHeaderTitle, isSingleWorkItem: isSingleWorkItem = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        xcss: (0, $w6R6I.cx)(isExpanded && $40b8480b34e7939a$var$styles.header, $40b8480b34e7939a$var$styles.headerLayoutPadding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        size: "medium",
        hasBorder: true,
        backgroundColor: "transparent"
    }, previewProductLogo), previewHeaderTitle), (!isSingleWorkItem || !isCreated) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: isExpanded ? formatMessage($40b8480b34e7939a$var$messages.collapseSuggestions) : formatMessage($40b8480b34e7939a$var$messages.expandSuggestions),
        onClick: onExpandClick,
        appearance: "subtle",
        spacing: "compact",
        testId: "conversation-assistant.base-preview-card.expand-collapse-button",
        isTooltipDisabled: false,
        // if a user hovers off the header after clicking these buttons, the buttons are not visible - before, they would remain
        // visible as they were still in focus.
        onMouseDown: (e)=>e.preventDefault()
    }));
};
const $40b8480b34e7939a$var$HeaderWithWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    let isCreated;
    let onHeaderClick;
    let props;
    if ($[0] !== t0) {
        ({ onHeaderClick: onHeaderClick, isCreated: isCreated, ...props } = t0);
        $[0] = t0;
        $[1] = isCreated;
        $[2] = onHeaderClick;
        $[3] = props;
    } else {
        isCreated = $[1];
        onHeaderClick = $[2];
        props = $[3];
    }
    if (isCreated && onHeaderClick) {
        let t1;
        if ($[4] !== isCreated || $[5] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($40b8480b34e7939a$var$Header, {
                isCreated: isCreated,
                ...props
            });
            $[4] = isCreated;
            $[5] = props;
            $[6] = t1;
        } else t1 = $[6];
        let t2;
        if ($[7] !== onHeaderClick || $[8] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                onClick: onHeaderClick,
                xcss: $40b8480b34e7939a$var$styles.pressable
            }, t1);
            $[7] = onHeaderClick;
            $[8] = t1;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    }
    let t1;
    if ($[10] !== isCreated || $[11] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($40b8480b34e7939a$var$Header, {
            isCreated: isCreated,
            ...props
        });
        $[10] = isCreated;
        $[11] = props;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ onHeaderClick: onHeaderClick, isCreated: isCreated, ...props })=>{
    if (isCreated && onHeaderClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onHeaderClick,
        xcss: $40b8480b34e7939a$var$styles.pressable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($40b8480b34e7939a$var$Header, {
        isCreated: isCreated,
        ...props
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($40b8480b34e7939a$var$Header, {
        isCreated: isCreated,
        ...props
    });
}; /**
    * The skeleton of the preview card, with the header, content and footer.
    * Allows different experiences to pass their own content and actions.
    */ 
const $40b8480b34e7939a$export$210d967b07d87ae5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { previewProductLogo: previewProductLogo, isLoading: t1, isSelected: isSelected, isEnabled: t2, isCreated: t3, previewHeaderTitle: previewHeaderTitle, previewContent: previewContent, previewFooterActions: previewFooterActions, testId: testId, onCardClick: onCardClick, isSingleWorkItem: t4, isCollapsible: t5, noPadding: t6 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    const isEnabled = t2 === undefined ? true : t2;
    const isCreated = t3 === undefined ? false : t3;
    const isSingleWorkItem = t4 === undefined ? false : t4;
    const isCollapsible = t5 === undefined ? true : t5;
    const noPadding = t6 === undefined ? false : t6;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(!isCreated);
    const isFirstRender = (0, $cozmU.useRef)(true);
    let t7;
    let t8;
    if ($[0] !== isCreated) {
        t7 = ()=>{
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
            }
            setIsExpanded(!isCreated);
        };
        t8 = [
            isCreated
        ];
        $[0] = isCreated;
        $[1] = t7;
        $[2] = t8;
    } else {
        t7 = $[1];
        t8 = $[2];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const hasFocusBorder = isSelected && isEnabled;
    let t9;
    if ($[3] !== isExpanded) {
        t9 = ()=>{
            setIsExpanded?.(!isExpanded);
        };
        $[3] = isExpanded;
        $[4] = t9;
    } else t9 = $[4];
    const onExpandClick = t9;
    const t10 = hasFocusBorder ? $40b8480b34e7939a$var$styles.containerWithBorder : $40b8480b34e7939a$var$styles.containerTransparentBorder;
    let t11;
    if ($[5] !== t10) {
        t11 = (0, $w6R6I.cx)($40b8480b34e7939a$var$styles.containerBase, t10);
        $[5] = t10;
        $[6] = t11;
    } else t11 = $[6];
    let t12;
    if ($[7] !== isCollapsible || $[8] !== isCreated || $[9] !== isExpanded || $[10] !== isSingleWorkItem || $[11] !== onCardClick || $[12] !== onExpandClick || $[13] !== previewHeaderTitle || $[14] !== previewProductLogo) {
        t12 = isCollapsible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($40b8480b34e7939a$var$HeaderWithWrapper, {
            isExpanded: isExpanded,
            isCreated: isCreated,
            onHeaderClick: onCardClick,
            onExpandClick: onExpandClick,
            previewProductLogo: previewProductLogo,
            previewHeaderTitle: previewHeaderTitle,
            isSingleWorkItem: isSingleWorkItem
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "start",
            space: "space.075",
            xcss: (0, $w6R6I.cx)($40b8480b34e7939a$var$styles.header, $40b8480b34e7939a$var$styles.layoutPadding)
        }, previewProductLogo, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, previewHeaderTitle));
        $[7] = isCollapsible;
        $[8] = isCreated;
        $[9] = isExpanded;
        $[10] = isSingleWorkItem;
        $[11] = onCardClick;
        $[12] = onExpandClick;
        $[13] = previewHeaderTitle;
        $[14] = previewProductLogo;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== isCollapsible || $[17] !== isCreated || $[18] !== isExpanded || $[19] !== isLoading || $[20] !== isSingleWorkItem || $[21] !== noPadding || $[22] !== previewContent || $[23] !== previewFooterActions) {
        t13 = isExpanded && (!isSingleWorkItem || !isCreated) && isCollapsible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: !noPadding && (!isSingleWorkItem ? $40b8480b34e7939a$var$styles.multiWorkItemContentPadding : $40b8480b34e7939a$var$styles.contentPadding)
        }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "24px"
        }) : previewContent), previewFooterActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "end",
            alignInline: "end",
            xcss: (0, $w6R6I.cx)($40b8480b34e7939a$var$styles.footer, $40b8480b34e7939a$var$styles.layoutPadding)
        }, previewFooterActions));
        $[16] = isCollapsible;
        $[17] = isCreated;
        $[18] = isExpanded;
        $[19] = isLoading;
        $[20] = isSingleWorkItem;
        $[21] = noPadding;
        $[22] = previewContent;
        $[23] = previewFooterActions;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== t12 || $[26] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, t12, t13);
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== t11 || $[29] !== t14 || $[30] !== testId) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t11,
            tabIndex: (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
                fireExperimentExposure: false
            }) ? undefined : 0,
            testId: testId
        }, t14);
        $[28] = t11;
        $[29] = t14;
        $[30] = testId;
        $[31] = t15;
    } else t15 = $[31];
    return t15;
} : ({ previewProductLogo: previewProductLogo, isLoading: isLoading = false, isSelected: isSelected, isEnabled: isEnabled = true, isCreated: isCreated = false, previewHeaderTitle: previewHeaderTitle, previewContent: previewContent, previewFooterActions: previewFooterActions, testId: testId, onCardClick: onCardClick, isSingleWorkItem: isSingleWorkItem = false, isCollapsible: isCollapsible = true, noPadding: noPadding = false })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(!isCreated);
    const isFirstRender = (0, $cozmU.useRef)(true); // Update isExpanded when defaultIsExpanded changes on subsequent renders
    (0, $cozmU.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        } // If the work item has been created, we don't want to expand the preview card by default
        setIsExpanded(!isCreated);
    }, [
        isCreated
    ]);
    const hasFocusBorder = isSelected && isEnabled;
    const onExpandClick = ()=>{
        setIsExpanded?.(!isExpanded);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($40b8480b34e7939a$var$styles.containerBase, hasFocusBorder ? $40b8480b34e7939a$var$styles.containerWithBorder : $40b8480b34e7939a$var$styles.containerTransparentBorder),
        tabIndex: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? undefined : 0,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, isCollapsible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($40b8480b34e7939a$var$HeaderWithWrapper, {
        isExpanded: isExpanded,
        isCreated: isCreated,
        onHeaderClick: onCardClick,
        onExpandClick: onExpandClick,
        previewProductLogo: previewProductLogo,
        previewHeaderTitle: previewHeaderTitle,
        isSingleWorkItem: isSingleWorkItem
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "start",
        space: "space.075",
        xcss: (0, $w6R6I.cx)($40b8480b34e7939a$var$styles.header, $40b8480b34e7939a$var$styles.layoutPadding)
    }, previewProductLogo, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "bold"
    }, previewHeaderTitle)), isExpanded && (!isSingleWorkItem || !isCreated) && isCollapsible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: !noPadding && (!isSingleWorkItem ? $40b8480b34e7939a$var$styles.multiWorkItemContentPadding : $40b8480b34e7939a$var$styles.contentPadding)
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "24px"
    }) : previewContent), previewFooterActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "end",
        alignInline: "end",
        xcss: (0, $w6R6I.cx)($40b8480b34e7939a$var$styles.footer, $40b8480b34e7939a$var$styles.layoutPadding)
    }, previewFooterActions))));
};
function $40b8480b34e7939a$var$_temp(e) {
    return e.preventDefault();
}
module.exports["BasePreviewCard"] = $40b8480b34e7939a$export$210d967b07d87ae5;

});

parcelRegister("gHaaj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $6QFj4 = parcelRequire("6QFj4");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $hdBxM = parcelRequire("hdBxM");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $iuCeV = parcelRequire("iuCeV");


var $euW6K = parcelRequire("euW6K");


var $fkQpA = parcelRequire("fkQpA");


var $2Ueo4 = parcelRequire("2Ueo4");


var $8avtg = parcelRequire("8avtg");


var $cKMeF = parcelRequire("cKMeF");


var $6yxNO = parcelRequire("6yxNO");


var $frwr8 = parcelRequire("frwr8");


var $3EjfV = parcelRequire("3EjfV");


var $9XT2p = parcelRequire("9XT2p");


var $4AALj = parcelRequire("4AALj");


var $aZB6I = parcelRequire("aZB6I");


var $7ChxK = parcelRequire("7ChxK");


var $lwkg1 = parcelRequire("lwkg1");


var $fqVHc = parcelRequire("fqVHc");


var $3M2fw = parcelRequire("3M2fw");


var $cymH2 = parcelRequire("cymH2");


var $hTDfT = parcelRequire("hTDfT");

const $a216ef3eabbe428d$var$messages = (0, $kSwu1.defineMessages)({
    createdSuggestedWorkItem: {
        id: "jiraCreateWithRovoPreviewCard.createdSuggestedWorkItem",
        defaultMessage: "You've created {issueKey} {summary}"
    },
    createdMultiWorkItem: {
        id: "jiraCreateWithRovoPreviewCard.createdMultiWorkItem",
        defaultMessage: "You've created {count} work items"
    },
    dismissedSuggestedWorkItem: {
        id: "jiraCreateWithRovoPreviewCard.dismissedSuggestedWorkItem",
        defaultMessage: "You've dismissed all suggested work items"
    },
    singleWorkItemPreviewHeaderTitle: {
        id: "jiraCreateWithRovoPreviewCard.singleWorkItemPreviewHeaderTitle",
        defaultMessage: "Create work item"
    },
    multiWorkItemPreviewHeaderTitle: {
        id: "jiraCreateWithRovoPreviewCard.multiWorkItemPreviewHeaderTitle",
        defaultMessage: "Create work items"
    },
    projectChangePrompt: {
        id: "jiraCreateWithRovoPreviewCard.projectChangePrompt",
        defaultMessage: "Change the project to {projectKey}"
    }
});
// The maximum time to display the fallback preview card when waiting for the BE inline edits to be fetched.
// If the fetch is resolved before this time, the list will be rendered normally.
// Once this time is elapsed, the list will be rendered normally regardless.
// If the fetch resolves later, overrides still apply without the loading state.
// Time of 1000ms is arbitrarily chosen - can be adjusted.
const $a216ef3eabbe428d$var$FETCH_EDITS_LOADING_TIME = 1000;
const $a216ef3eabbe428d$var$JIRA_PREVIEW_CARD_ENTRY_POINT = 'rovoChatPreviewCard';
/**
 * Renders the single work item when there is a single work item suggestion
 * and the mini list view when there are multiple work item suggestions
 */ const $a216ef3eabbe428d$var$JiraCreateWithRovoPreviewCardNew = ({ product: product, actions: initialActions, messageId: messageId, cloudId: cloudId, conversationId: conversationId, isSelected: isSelected, isEnabled: isEnabled, onPreviewClick: onPreviewClick, resolveActions: resolveActions, isStagingArea: isStagingArea, showSuccessFlagOnCreate: showSuccessFlagOnCreate })=>{
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    const { sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = (0, $cKMeF.useAifcAnalytics)(messageId);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const actionKey = initialActions[0]?.key;
    const projectIdOrKey = initialActions[0]?.data?.projectIdOrKey ?? '';
    const queryRef = (0, $6SsN4.useLazyLoadQuery)((0, $6QFj4.default), {
        cloudId: cloudId,
        projectIdOrKey: projectIdOrKey
    });
    (0, $cozmU.useEffect)(()=>{
        if (!hasFiredViewEvent.current) {
            hasFiredViewEvent.current = true;
            sendAifcAnalyticsEvent({
                action: 'rendered',
                actionSubject: 'component',
                actionSubjectId: 'createWorkItemsPreviewCard',
                attributes: {
                    itemCount: initialActions.length,
                    isSingleWorkItem: initialActions.length === 1,
                    isStagingArea: isStagingArea
                }
            });
        }
    // Empty dependency array to ensure that we only fire the analytics event once when the component renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { draftWorkItems: draftWorkItems, isStoreReady: isStoreReady, onDismissAllDraftWorkItems: onDismissAllDraftWorkItems, onFieldChange: onFieldChange, onWorkItemsCreated: onWorkItemsCreated, removeWorkItem: removeWorkItem } = (0, $8avtg.useAiCreateProjectContext)({
        project: queryRef,
        actions: initialActions,
        isActiveMessage: isEnabled,
        messageId: messageId,
        conversationId: conversationId,
        cloudId: cloudId,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    });
    const isCreated = (0, $fkQpA.useAreAllCreated)(messageId);
    const isDismissed = (0, $fkQpA.useAreAllDismissed)(messageId);
    const activeChildrenInvocationIdsNew = (0, $fkQpA.useGetActivePlannedChildInvocationIdsByParent)(messageId);
    const activeOrFinishedDraftWorkItemsCount = (0, $fkQpA.useGetActiveOrFinishedDraftWorkItemsCount)(messageId);
    const { getDraftWorkItemsWithoutHierarchy: getDraftWorkItemsWithoutHierarchy, getAllActiveInvocationIds: getAllActiveInvocationIds, setDraftWorkItems: setDraftWorkItems } = (0, $euW6K.useDraftWorkItemsActions)();
    // On mount, we fetch the BE state of the draft work items and apply it to the sweet state.
    // We use sweet state (hasAppliedDraftEdits) instead of a ref so the flag persists across remounts.
    const hasAppliedDraftEdits = (0, $fkQpA.useHasAppliedDraftEdits)(messageId);
    // Show a loading state while waiting for BE draft overrides, for a maximum of 1000ms.
    // If we've already applied draft edits (hasAppliedDraftEdits = true), skip the loading state entirely.
    const [isFetchingDraftWorkItems, setisFetchingDraftWorkItems] = (0, $cozmU.useState)(!hasAppliedDraftEdits);
    (0, $cozmU.useEffect)(()=>{
        if (// Ensure the store is ready before applying the draft overrides.
        !isStoreReady || hasAppliedDraftEdits || !conversationId || !messageId) return;
        const timeout = setTimeout(()=>setisFetchingDraftWorkItems(false), $a216ef3eabbe428d$var$FETCH_EDITS_LOADING_TIME);
        (0, $2Ueo4.getOrFetchDraftWorkItemsWithEdits)(cloudId, conversationId, messageId, sendAifcAnalyticsEvent).then((draftActions)=>{
            clearTimeout(timeout);
            setisFetchingDraftWorkItems(false);
            if (!draftActions?.length) return;
            const currentItems = getDraftWorkItemsWithoutHierarchy(messageId);
            if (!currentItems.length) return;
            const updatedItems = Object.fromEntries(currentItems.map((item)=>[
                    item.invocationId,
                    item
                ]));
            // Replace items via their invocationId.
            for (const { invocationId: invocationId, data: data } of draftActions)if (updatedItems[invocationId]) {
                // Filter out any work items that were previously cancelled and persisted to the monolith.
                if (data.resolution === (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel && (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
                    fireExperimentExposure: false
                })) {
                    // Cancel all child work items of the parent work item
                    updatedItems[invocationId]?.childInvocationIds?.forEach((childInvocationId)=>{
                        delete updatedItems[childInvocationId];
                    });
                    delete updatedItems[invocationId];
                    continue;
                }
                const oldSummary = updatedItems[invocationId].summary;
                const newSummary = data.summary ?? oldSummary;
                // Update a work item's parent summary to ensure the parent <=> child mapping stays stable to be used within recalculateHierarchy.
                if (oldSummary !== newSummary) Object.values(updatedItems).forEach((item)=>{
                    if (item.fields.parent === oldSummary) item.fields = {
                        ...item.fields,
                        parent: newSummary
                    };
                });
                // The createdIssueKey is only saved in the actions array, so ensure we preserve this value if it exists.
                const createdIssueKey = updatedItems[invocationId]?.createdIssueKey;
                updatedItems[invocationId] = {
                    invocationId: invocationId,
                    ...createdIssueKey && {
                        createdIssueKey: createdIssueKey
                    },
                    ...data
                };
            }
            // If all work items are cancelled, there should be no items in the store.
            if (!Object.keys(updatedItems).length && (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
                fireExperimentExposure: false
            })) {
                setDraftWorkItems(messageId, {}, []);
                return;
            }
            // Resolve hierarchy before setting store state, since parent summaries may have
            // changed and children's fields.parent needs to be re-resolved.
            const { newMap: newMap, childInvocationIdsSet: childInvocationIdsSet } = (0, $frwr8.recalculateHierarchy)({
                itemsMap: updatedItems
            });
            const topLevelInvocationIds = Object.values(newMap).filter((item)=>item.status !== 'cancelled' && !childInvocationIdsSet.has(item.invocationId)).map((item)=>item.invocationId);
            setDraftWorkItems(messageId, newMap, topLevelInvocationIds);
        });
    }, [
        draftWorkItems,
        conversationId,
        messageId,
        getDraftWorkItemsWithoutHierarchy,
        getAllActiveInvocationIds,
        setDraftWorkItems,
        cloudId,
        sendAifcAnalyticsEvent,
        isStoreReady,
        hasAppliedDraftEdits
    ]);
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)(undefined);
    const [isProjectChangePending, setIsProjectChangePending] = (0, $cozmU.useState)(false);
    const [selectedItems, setSelectedItems] = (0, $cozmU.useState)(new Set());
    const [isCreating, setIsCreating] = (0, $cozmU.useState)(false);
    const onToggleSelect = (0, $cozmU.useCallback)((invocationId, newValue)=>{
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            if (newValue) next.add(invocationId);
            else {
                next.delete(invocationId);
                // If the parent has child subtasks, uncheck them.
                const parentItem = draftWorkItems.find((item)=>item.invocationId === invocationId);
                parentItem?.childWorkItems?.forEach((child)=>{
                    if ((0, $7ChxK.isSubTask)(child)) next.delete(child.invocationId);
                });
            }
            return next;
        });
    }, [
        draftWorkItems
    ]);
    const hasAnyCreatedItems = (0, $cozmU.useMemo)(()=>(0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
            fireExperimentExposure: false
        }) === 'checkboxes' && draftWorkItems.some((item)=>Boolean(item.createdIssueKey) || item.childWorkItems?.some((child)=>Boolean(child.createdIssueKey))), [
        draftWorkItems
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { openPreviewPanel: openPreviewPanel } = (0, $3EjfV.useWorkItemPreviewPanel)();
    const cloudUrl = queryRef.tenantContexts?.[0]?.cloudUrl ?? '';
    const primaryDraftWorkItem = getDraftWorkItemsWithoutHierarchy(messageId)?.[0];
    // Handles any side effects that need to be performed after work item creation
    const onCreateSuccess = (0, $cozmU.useCallback)(({ invocationIdToCreatedIssueKey: invocationIdToCreatedIssueKey })=>{
        setIsCreating(false);
        const createdIssueKeys = Object.values(invocationIdToCreatedIssueKey);
        if (createdIssueKeys.length > 0) {
            resolveActions?.(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).actioned, Object.keys(invocationIdToCreatedIssueKey), invocationIdToCreatedIssueKey);
            onWorkItemsCreated({
                invocationIdToCreatedIssueKey: invocationIdToCreatedIssueKey
            });
            setErrorMessage(undefined);
        }
    }, [
        actionKey,
        onWorkItemsCreated,
        resolveActions
    ]);
    const onCreateError = (0, $cozmU.useCallback)(({ errorMessage: errorMessage })=>{
        setIsCreating(false);
        setErrorMessage(errorMessage);
        sendAifcAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsError',
            attributes: {
                errorMessage: errorMessage,
                isSingleWorkItem: initialActions.length === 1,
                isStagingArea: isStagingArea
            }
        });
    }, [
        sendAifcAnalyticsEvent,
        initialActions.length,
        isStagingArea
    ]);
    const createDraftWorkItems = (0, $6yxNO.useCreateDraftWorkItems)({
        onSuccess: onCreateSuccess,
        onError: onCreateError,
        cloudId: cloudId,
        cloudUrl: cloudUrl,
        projectIdOrKey: projectIdOrKey,
        showErrorsInFlag: false,
        showSuccessFlagOnCreate: showSuccessFlagOnCreate,
        isStagingArea: isStagingArea,
        entryPoint: $a216ef3eabbe428d$var$JIRA_PREVIEW_CARD_ENTRY_POINT,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    });
    const onBulkAccept = (0, $cozmU.useCallback)(()=>{
        if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
            fireExperimentExposure: false
        }) === 'checkboxes') setIsCreating(true);
        const draftWorkItemsToCreate = getDraftWorkItemsWithoutHierarchy(messageId);
        // If no items are selected for the checkbox variant, we will create all visible work items. Otherwise,
        // the count will be the number of selected items.
        const checkboxCount = selectedItems.size === 0 ? draftWorkItemsToCreate.length : selectedItems.size;
        sendAifcAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: initialActions.length === 1 ? 'createWorkItemsSingleCreate' : 'createWorkItemsBulkCreate',
            attributes: {
                itemCount: (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
                    fireExperimentExposure: false
                }) === 'checkboxes' ? checkboxCount : draftWorkItemsToCreate.length,
                isSingleWorkItem: initialActions.length === 1,
                isStagingArea: isStagingArea,
                totalCount: initialActions.length
            }
        });
    }, [
        getDraftWorkItemsWithoutHierarchy,
        messageId,
        sendAifcAnalyticsEvent,
        initialActions.length,
        isStagingArea,
        selectedItems
    ]);
    const onInlineAccept = (0, $cozmU.useCallback)(({ draftWorkItem: draftWorkItem })=>{
        sendAifcAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsSingleCreate',
            attributes: {
                itemCount: 1,
                isSingleWorkItem: false,
                isStagingArea: isStagingArea
            }
        });
        return createDraftWorkItems({
            draftWorkItems: [
                draftWorkItem
            ]
        });
    }, [
        createDraftWorkItems,
        sendAifcAnalyticsEvent,
        isStagingArea
    ]);
    const onDismissAll = (0, $cozmU.useCallback)(()=>{
        const draftItemsWithoutHierarchy = getDraftWorkItemsWithoutHierarchy(messageId);
        const activeInvocationIds = getAllActiveInvocationIds(messageId);
        if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
            fireExperimentExposure: false
        })) for (const invocationId of activeInvocationIds){
            const storeItem = draftItemsWithoutHierarchy.find((item)=>item.invocationId === invocationId);
            if (storeItem) {
                // For workflow resumption, we don't want to resolve decline within Convo-AI, so we will
                // post the status to the Jira monolith.
                const draftAction = (0, $2Ueo4.mapStoreItemToDraftWorkItemWithEdits)(storeItem);
                (0, $2Ueo4.resolveDraftWorkItemInMonolith)(cloudId, conversationId, messageId, draftAction, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, sendAifcAnalyticsEvent, experienceTracker);
            }
        }
        else resolveActions?.(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, activeInvocationIds);
        onDismissAllDraftWorkItems();
        setErrorMessage(undefined);
        sendAifcAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: initialActions.length === 1 ? 'createWorkItemsSingleDismiss' : 'createWorkItemsBulkDismiss',
            attributes: {
                itemCount: activeInvocationIds.length,
                isSingleWorkItem: initialActions.length === 1,
                isStagingArea: isStagingArea
            }
        });
    }, [
        actionKey,
        getAllActiveInvocationIds,
        messageId,
        onDismissAllDraftWorkItems,
        resolveActions,
        sendAifcAnalyticsEvent,
        initialActions.length,
        isStagingArea,
        conversationId,
        cloudId,
        experienceTracker,
        getDraftWorkItemsWithoutHierarchy
    ]);
    const onDeclineWorkItem = (0, $cozmU.useCallback)(({ invocationId: invocationId })=>{
        const draftItemsWithoutHierarchy = getDraftWorkItemsWithoutHierarchy(messageId);
        const workItemsToDecline = [
            invocationId,
            ...activeChildrenInvocationIdsNew[invocationId] ?? []
        ];
        if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
            fireExperimentExposure: false
        })) {
            const storeItem = draftItemsWithoutHierarchy.find((item)=>item.invocationId === invocationId);
            if (storeItem) {
                // For workflow resumption, we don't want to resolve decline within Convo-AI, so we will
                // post the status to the Jira monolith.
                const draftAction = (0, $2Ueo4.mapStoreItemToDraftWorkItemWithEdits)(storeItem);
                (0, $2Ueo4.resolveDraftWorkItemInMonolith)(cloudId, conversationId, messageId, draftAction, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, sendAifcAnalyticsEvent, experienceTracker);
            }
        } else resolveActions?.(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, workItemsToDecline);
        removeWorkItem(invocationId);
        sendAifcAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsSingleDismiss',
            attributes: {
                // If an epic is declined, we remove all child work items too
                itemCount: workItemsToDecline.length,
                isSingleWorkItem: initialActions.length === 1,
                isStagingArea: isStagingArea
            }
        });
    }, [
        actionKey,
        initialActions.length,
        resolveActions,
        removeWorkItem,
        sendAifcAnalyticsEvent,
        isStagingArea,
        activeChildrenInvocationIdsNew,
        cloudId,
        conversationId,
        messageId,
        experienceTracker,
        getDraftWorkItemsWithoutHierarchy
    ]);
    const showSingleWorkItemCard = Boolean(initialActions.length === 1 && initialActions[0]);
    const gicEntryPointProps = (0, $cozmU.useMemo)(()=>({
            projectId: undefined,
            actionKey: actionKey,
            cloudId: cloudId,
            onWorkItemsCreated: onWorkItemsCreated,
            resolveActions: resolveActions,
            clearErrors: ()=>setErrorMessage(undefined),
            conversationId: conversationId,
            messageId: messageId,
            showSuccessFlagOnCreate: showSuccessFlagOnCreate
        }), [
        actionKey,
        cloudId,
        onWorkItemsCreated,
        resolveActions,
        setErrorMessage,
        conversationId,
        messageId,
        showSuccessFlagOnCreate
    ]);
    const FooterActions = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fqVHc.PreviewFooterActions), {
            product: product,
            query: queryRef,
            project: queryRef.jira_projectByIdOrKey,
            areButtonsDisabled: isSelected || !isEnabled || isCreated || isProjectChangePending,
            cloudId: cloudId,
            messageId: messageId,
            projectIdOrKey: projectIdOrKey,
            isSingleWorkItem: showSingleWorkItemCard,
            onCreateSuccess: onCreateSuccess,
            onCreateError: onCreateError,
            onDismiss: onDismissAll,
            onPreviewClick: onPreviewClick,
            gicEntryPointProps: gicEntryPointProps,
            onBulkAccept: onBulkAccept,
            isStagingArea: isStagingArea,
            entryPoint: $a216ef3eabbe428d$var$JIRA_PREVIEW_CARD_ENTRY_POINT,
            showSuccessFlagOnCreate: showSuccessFlagOnCreate,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }), [
        product,
        queryRef,
        cloudId,
        isCreated,
        isEnabled,
        isSelected,
        isProjectChangePending,
        onCreateSuccess,
        onCreateError,
        onDismissAll,
        onPreviewClick,
        projectIdOrKey,
        showSingleWorkItemCard,
        gicEntryPointProps,
        onBulkAccept,
        isStagingArea,
        messageId,
        showSuccessFlagOnCreate,
        sendAifcAnalyticsEvent
    ]);
    const memoizedFooterActions = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fqVHc.PreviewFooterActions), {
            product: product,
            query: queryRef,
            project: queryRef.jira_projectByIdOrKey,
            areButtonsDisabled: isSelected || !isEnabled || isCreated || isProjectChangePending,
            cloudId: cloudId,
            messageId: messageId,
            projectIdOrKey: projectIdOrKey,
            isSingleWorkItem: showSingleWorkItemCard,
            onCreateSuccess: onCreateSuccess,
            onCreateError: onCreateError,
            onDismiss: onDismissAll,
            onPreviewClick: onPreviewClick,
            gicEntryPointProps: gicEntryPointProps,
            onBulkAccept: onBulkAccept,
            isStagingArea: isStagingArea,
            entryPoint: $a216ef3eabbe428d$var$JIRA_PREVIEW_CARD_ENTRY_POINT,
            showSuccessFlagOnCreate: showSuccessFlagOnCreate,
            selectedItems: selectedItems,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }), [
        product,
        queryRef,
        cloudId,
        isCreated,
        isEnabled,
        isSelected,
        isProjectChangePending,
        onCreateSuccess,
        onCreateError,
        onDismissAll,
        onPreviewClick,
        projectIdOrKey,
        showSingleWorkItemCard,
        gicEntryPointProps,
        onBulkAccept,
        isStagingArea,
        messageId,
        showSuccessFlagOnCreate,
        selectedItems,
        sendAifcAnalyticsEvent
    ]);
    const footerActions = (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'checkboxes' ? memoizedFooterActions : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FooterActions, null);
    // Opens the work item view in the global preview panel
    const openWorkItemView = (0, $cozmU.useCallback)((createdIssueKey)=>{
        if (!createdIssueKey || isStagingArea) return;
        sendAifcAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'createdWorkItem',
            actionSubjectId: 'createWorkItemsPreviewPanelOpened',
            attributes: {
                itemCount: initialActions.length,
                isSingleWorkItem: initialActions.length === 1,
                isStagingArea: isStagingArea
            }
        });
        openPreviewPanel({
            ari: (0, $7ChxK.createWorkItemAri)(cloudId, createdIssueKey),
            name: 'Jira work item',
            url: `/browse/${createdIssueKey}`
        });
    }, [
        cloudId,
        openPreviewPanel,
        sendAifcAnalyticsEvent,
        initialActions.length,
        isStagingArea
    ]);
    const getSystemMessage = (0, $cozmU.useCallback)(()=>{
        if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
            fireExperimentExposure: false
        }) === 'checkboxes') {
            const displayCount = draftWorkItems.reduce((count, item)=>count + (item.createdIssueKey ? 1 : 0) + (item.childWorkItems?.filter((child)=>Boolean(child.createdIssueKey)).length ?? 0), 0);
            return displayCount === 1 && primaryDraftWorkItem ? formatMessage($a216ef3eabbe428d$var$messages.createdSuggestedWorkItem, {
                issueKey: primaryDraftWorkItem.createdIssueKey ?? '',
                summary: primaryDraftWorkItem.summary ?? ''
            }) : formatMessage($a216ef3eabbe428d$var$messages.createdMultiWorkItem, {
                count: displayCount
            });
        }
        return activeOrFinishedDraftWorkItemsCount === 1 && primaryDraftWorkItem ? formatMessage($a216ef3eabbe428d$var$messages.createdSuggestedWorkItem, {
            issueKey: primaryDraftWorkItem.createdIssueKey ?? '',
            summary: primaryDraftWorkItem.summary ?? ''
        }) : formatMessage($a216ef3eabbe428d$var$messages.createdMultiWorkItem, {
            count: activeOrFinishedDraftWorkItemsCount
        });
    }, [
        activeOrFinishedDraftWorkItemsCount,
        formatMessage,
        primaryDraftWorkItem,
        draftWorkItems
    ]);
    const sendChatMessageForProjectChange = (0, $cozmU.useCallback)((projectKey)=>{
        if (!(0, $cXtTj.default).getExperimentValue('jira-aifc-project-selector-in-chat-exp', 'isEnabled', false, {
            fireExperimentExposure: false
        })) return;
        publish({
            type: 'insert-prompt',
            source: 'ai-mate',
            // The chat is already open so suppress the chat-opener side effect. Without this,
            // ChatOpenerSubscriber promotes the chat to MINI_MODAL whenever an 'ai-mate'-sourced event is published.
            openChat: false,
            data: {
                prompt: `/create-work-items ${formatMessage($a216ef3eabbe428d$var$messages.projectChangePrompt, {
                    projectKey: projectKey
                })}`,
                placeholderType: 'skill'
            }
        });
        sendAifcAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option',
            actionSubjectId: 'jiraAifcPreviewCardProjectSelector'
        });
        // Disable the footer actions while the new chat turn for the project change is created.
        setIsProjectChangePending(true);
    }, [
        publish,
        formatMessage,
        sendAifcAnalyticsEvent
    ]);
    // Show loading state in preview card while the store is being initialised or the BE is still fetching any saved state
    if (!isCreated && (isFetchingDraftWorkItems || !isStoreReady)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lwkg1.FallbackPreviewCard), {
        isSelected: isSelected,
        showSingleWorkItemCard: showSingleWorkItemCard
    });
    if (isDismissed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        message: formatMessage($a216ef3eabbe428d$var$messages.dismissedSuggestedWorkItem),
        isSuccessMessage: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, (0, $iDrrr.fg)('rovo_skills_work_item_reliability_ufo') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE
    }), showSingleWorkItemCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cymH2.JiraSingleWorkItemPreviewCard), {
        cloudId: cloudId,
        queryRef: queryRef,
        draftWorkItems: draftWorkItems,
        isSelected: isSelected,
        isEnabled: isEnabled,
        isCreated: isCreated,
        previewFooterActions: footerActions,
        onFieldChange: onFieldChange,
        openWorkItemView: openWorkItemView,
        isStagingArea: isStagingArea,
        messageId: messageId,
        onProjectChange: sendChatMessageForProjectChange,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3M2fw.JiraMultiWorkItemPreviewCard), {
        cloudId: cloudId,
        project: queryRef.jira_projectByIdOrKey,
        projectKey: projectIdOrKey,
        draftWorkItems: draftWorkItems,
        isCreated: isCreated,
        isSelected: isSelected,
        isEnabled: isEnabled,
        previewFooterActions: footerActions,
        onDeclineWorkItem: onDeclineWorkItem,
        hideInlineButtons: isSelected || !isEnabled || isCreated || isProjectChangePending || hasAnyCreatedItems,
        openWorkItemView: openWorkItemView,
        onInlineAccept: onInlineAccept,
        gicEntryPointProps: gicEntryPointProps,
        isStagingArea: isStagingArea,
        onProjectChange: sendChatMessageForProjectChange,
        selectedItems: selectedItems,
        onToggleSelect: onToggleSelect,
        hasAnyCreatedItems: hasAnyCreatedItems,
        isCreating: (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
            fireExperimentExposure: false
        }) === 'checkboxes' && isCreating,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    }), ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'checkboxes' ? hasAnyCreatedItems : isCreated) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        message: getSystemMessage()
    }), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AALj.ErrorMessage), {
        errorMessage: errorMessage
    }));
};
const $a216ef3eabbe428d$export$a8a466e02df56e4e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { product: product, actions: actions, messageId: messageId, invokedActions: invokedActions, cloudId: cloudId, isSelected: isSelected, isEnabled: isEnabled, isLastMessage: isLastMessage, onPreviewClick: onPreviewClick, resolveActions: resolveActions, isStagingArea: isStagingArea, conversationId: conversationId, showSuccessFlagOnCreate: showSuccessFlagOnCreate } = t0;
    const hasFetchedDraftActions = (0, $cozmU.useRef)(false);
    const { sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = (0, $cKMeF.useAifcAnalytics)(messageId);
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== conversationId || $[2] !== isLastMessage || $[3] !== messageId || $[4] !== sendAifcAnalyticsEvent) {
        t1 = ()=>{
            if (!cloudId || !conversationId || !messageId || !isLastMessage || hasFetchedDraftActions.current) return;
            hasFetchedDraftActions.current = true;
            (0, $2Ueo4.getOrFetchDraftWorkItemsWithEdits)(cloudId, conversationId, messageId, sendAifcAnalyticsEvent);
        };
        t2 = [
            cloudId,
            conversationId,
            messageId,
            isLastMessage,
            sendAifcAnalyticsEvent
        ];
        $[0] = cloudId;
        $[1] = conversationId;
        $[2] = isLastMessage;
        $[3] = messageId;
        $[4] = sendAifcAnalyticsEvent;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (actions.length === 0 || !actions[0]) return null;
    const showSingleWorkItemCard = Boolean(actions.length === 1 && actions[0]);
    let t3;
    if ($[7] !== invokedActions) {
        t3 = invokedActions ?? {};
        $[7] = invokedActions;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = isLastMessage ?? false;
    let t5;
    if ($[9] !== actions.length || $[10] !== cloudId || $[11] !== conversationId || $[12] !== isEnabled || $[13] !== isSelected || $[14] !== isStagingArea || $[15] !== messageId || $[16] !== onPreviewClick || $[17] !== product || $[18] !== resolveActions || $[19] !== showSingleWorkItemCard || $[20] !== showSuccessFlagOnCreate) {
        t5 = (t6)=>{
            const { actions: mappedActions } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $iDrrr.fg)("rovo_skills_work_item_reliability_ufo") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
                name: (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
                attributes: {
                    isStagingArea: isStagingArea,
                    totalCount: actions.length
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lwkg1.FallbackPreviewCard), {
                    isSelected: isSelected,
                    showSingleWorkItemCard: showSingleWorkItemCard
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a216ef3eabbe428d$var$JiraCreateWithRovoPreviewCardNew, {
                product: product,
                actions: mappedActions,
                messageId: messageId,
                cloudId: cloudId,
                conversationId: conversationId,
                isSelected: isSelected,
                isEnabled: isEnabled,
                onPreviewClick: onPreviewClick,
                resolveActions: resolveActions,
                isStagingArea: isStagingArea,
                showSuccessFlagOnCreate: showSuccessFlagOnCreate
            })));
        };
        $[9] = actions.length;
        $[10] = cloudId;
        $[11] = conversationId;
        $[12] = isEnabled;
        $[13] = isSelected;
        $[14] = isStagingArea;
        $[15] = messageId;
        $[16] = onPreviewClick;
        $[17] = product;
        $[18] = resolveActions;
        $[19] = showSingleWorkItemCard;
        $[20] = showSuccessFlagOnCreate;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== actions || $[23] !== resolveActions || $[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTDfT.ModalSyncBridgeAPI), {
            actions: actions,
            invokedActions: t3,
            resolveActions: resolveActions,
            isLastMessage: t4
        }, t5);
        $[22] = actions;
        $[23] = resolveActions;
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
    } else t6 = $[27];
    return t6;
} : ({ product: product, actions: actions, messageId: messageId, invokedActions: invokedActions, cloudId: cloudId, isSelected: isSelected, isEnabled: isEnabled, isLastMessage: isLastMessage, onPreviewClick: onPreviewClick, resolveActions: resolveActions, isStagingArea: isStagingArea, conversationId: conversationId, showSuccessFlagOnCreate: showSuccessFlagOnCreate })=>{
    const hasFetchedDraftActions = (0, $cozmU.useRef)(false);
    const { sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = (0, $cKMeF.useAifcAnalytics)(messageId);
    // Try fetch the draft work items from the backend as soon as this outer component mounts so it can be ready
    // before JiraCreateWithRovoPreviewCardNew's query is complete.
    (0, $cozmU.useEffect)(()=>{
        if (!cloudId || !conversationId || !messageId || !isLastMessage || hasFetchedDraftActions.current) return;
        hasFetchedDraftActions.current = true;
        (0, $2Ueo4.getOrFetchDraftWorkItemsWithEdits)(cloudId, conversationId, messageId, sendAifcAnalyticsEvent);
    }, [
        cloudId,
        conversationId,
        messageId,
        isLastMessage,
        sendAifcAnalyticsEvent
    ]);
    if (actions.length === 0 || !actions[0]) return null;
    const showSingleWorkItemCard = Boolean(actions.length === 1 && actions[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTDfT.ModalSyncBridgeAPI), {
        actions: actions,
        invokedActions: invokedActions ?? {},
        resolveActions: resolveActions,
        isLastMessage: isLastMessage ?? false
    }, ({ actions: mappedActions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $iDrrr.fg)('rovo_skills_work_item_reliability_ufo') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
            attributes: {
                isStagingArea: isStagingArea,
                totalCount: actions.length
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lwkg1.FallbackPreviewCard), {
                isSelected: isSelected,
                showSingleWorkItemCard: showSingleWorkItemCard
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a216ef3eabbe428d$var$JiraCreateWithRovoPreviewCardNew, {
            product: product,
            actions: mappedActions,
            messageId: messageId,
            cloudId: cloudId,
            conversationId: conversationId,
            isSelected: isSelected,
            isEnabled: isEnabled,
            onPreviewClick: onPreviewClick,
            resolveActions: resolveActions,
            isStagingArea: isStagingArea,
            showSuccessFlagOnCreate: showSuccessFlagOnCreate
        }))));
};
module.exports["JiraCreateWithRovoPreviewCard"] = $a216ef3eabbe428d$export$a8a466e02df56e4e;

});

parcelRegister("aZB6I", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $9f44aedcc5e6a361$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $9f44aedcc5e6a361$export$3f91b0466c5e5f77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { message: message, isSuccessMessage: t1 } = t0;
    const isSuccessMessage = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== isSuccessMessage) {
        t2 = isSuccessMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        });
        $[0] = isSuccessMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== message) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, message);
        $[2] = message;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $9f44aedcc5e6a361$var$styles.explainerContainer,
            alignItems: "center",
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $9f44aedcc5e6a361$var$styles.explainer,
            alignBlock: "center",
            alignInline: "center"
        }, t2, t3));
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ message: message, isSuccessMessage: isSuccessMessage = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $9f44aedcc5e6a361$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $9f44aedcc5e6a361$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, isSuccessMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, message)));
};
module.exports["SystemMessage"] = $9f44aedcc5e6a361$export$3f91b0466c5e5f77;

});

parcelRegister("6j4UZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ic2nu = parcelRequire("ic2nu");


var $h8IcZ = parcelRequire("h8IcZ");


var $8YXeh = parcelRequire("8YXeh");

const $57ccd8c3843f12ad$export$4410a4d5e185307e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { extensionType: extensionType, extensionKey: extensionKey, content: content } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (extensionType === (0, $8YXeh.REDACT_EXTENSION_TYPE) && extensionKey === (0, $8YXeh.REDACT_EXTENSION_KEY)) {
        let t1;
        if ($[0] !== formatMessage) {
            t1 = formatMessage((0, $ic2nu.messages).redactedAriaLabel);
            $[0] = formatMessage;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h8IcZ.RedactedToken), {
                ariaLabel: t1,
                delay: 0
            });
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    return content;
} : ({ extensionType: extensionType, extensionKey: extensionKey, content: content })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (extensionType === (0, $8YXeh.REDACT_EXTENSION_TYPE) && extensionKey === (0, $8YXeh.REDACT_EXTENSION_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h8IcZ.RedactedToken), {
        ariaLabel: formatMessage((0, $ic2nu.messages).redactedAriaLabel),
        delay: 0
    });
    return content;
};
module.exports["RedactScribbleExtension"] = $57ccd8c3843f12ad$export$4410a4d5e185307e;

});

parcelRegister("b6ezN", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $3z1p5 = parcelRequire("3z1p5");


var $3UaYh = parcelRequire("3UaYh");


var $5zEJP = parcelRequire("5zEJP");

const $716480d1ec16e39b$var$IDENTITY_USER_ARI_PREFIX = 'ari:cloud:identity::user/';
const $716480d1ec16e39b$var$getIdentityUserAri = (ari)=>{
    const trimmed = ari?.trim();
    return trimmed?.startsWith($716480d1ec16e39b$var$IDENTITY_USER_ARI_PREFIX) ? trimmed : undefined;
};
const $716480d1ec16e39b$export$c26826a8e112dc41 = ({ storeAssistant: storeAssistant, previousAssistantAuthor: previousAssistantAuthor, shouldEnableAgentResponseHat: shouldEnableAgentResponseHat, isConversationActivelyGenerating: isConversationActivelyGenerating, canRenderAfterThinking: canRenderAfterThinking, hasAnswerContent: hasAnswerContent, assistanceServiceParams: assistanceServiceParams })=>{
    (0, $6cFsl.di)((0, $3z1p5.useAgentsPaginatedByAgentId));
    const { content: { message: { message: { author: author } }, streamingComplete: streamingComplete = true } } = storeAssistant;
    const currentAuthor = (0, $3UaYh.deriveResponseAuthorIdentity)(storeAssistant);
    const { agent: responseAuthorAgent } = (0, $3z1p5.useAgentsPaginatedByAgentId)({
        agentId: shouldEnableAgentResponseHat && !currentAuthor.isDefault ? currentAuthor.id : undefined,
        assistanceServiceParams: assistanceServiceParams
    });
    const renderState = (0, $5zEJP.getResponseHatRenderState)({
        shouldEnableAgentResponseHat: shouldEnableAgentResponseHat,
        canRenderAfterThinking: canRenderAfterThinking,
        currentResponseAuthor: currentAuthor,
        previousAssistantAuthor: previousAssistantAuthor,
        responseAuthorAgent: responseAuthorAgent,
        backendAuthorIdentityAccountId: author?.identity_account_id ?? $716480d1ec16e39b$var$getIdentityUserAri(author?.ari),
        isConversationActivelyGenerating: isConversationActivelyGenerating,
        streamingComplete: Boolean(streamingComplete),
        hasAnswerContent: hasAnswerContent
    });
    return {
        shouldRender: renderState.shouldRenderAgentResponseHat,
        isDefaultRovo: renderState.isDefaultRovo,
        identityAccountId: renderState.agentIdentityAccountId,
        isHydrating: renderState.isIdentityHydrating
    };
};
module.exports["useResponseHatState"] = $716480d1ec16e39b$export$c26826a8e112dc41;

});

parcelRegister("1PvMy", function(module, exports) {
const $2971620c4bbec294$export$57924f9f994c073d = '$default';
module.exports["DEFAULT_INSTANCE_ID"] = $2971620c4bbec294$export$57924f9f994c073d;

});

parcelRegister("7wD0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::672f54867b49b1c7238efddca8a55688>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57a9c777c9766f2c$var$_react = $57a9c777c9766f2c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $57a9c777c9766f2c$var$_baseNew = $57a9c777c9766f2c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $57a9c777c9766f2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Ask".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ask
 * Usage guidance:
 * Reserved for representing Asks in Focus. An ask is structured request made by one team or user to another, representing work needed to complete other work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57a9c777c9766f2c$var$AskIcon = (props)=>/*#__PURE__*/ $57a9c777c9766f2c$var$_react.default.createElement($57a9c777c9766f2c$var$_baseNew.default, Object.assign({
        name: "AskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.838 1c.38 0 .755.083 1.1.242l2.447 1.13.12-.965 1.49.186-.694 5.545a1.93 1.93 0 0 1-.923 1.43l.027.027a2.34 2.34 0 0 1-2.16 3.938q-.069.1-.156.19l-.483.481a2.62 2.62 0 0 1-2.658.642 1 1 0 0 1-.11.127l-.266.265a2.625 2.625 0 0 1-3.664.047l-2.686-2.553A4.5 4.5 0 0 1 .85 8.982L.005 1.584l1.49-.17.12 1.053L7.2 2.03l.201-.21A2.63 2.63 0 0 1 9.307 1zM1.786 3.96l.555 4.85a3 3 0 0 0 .914 1.835l2.686 2.552c.443.42 1.14.412 1.57-.02L7.689 13 6.22 11.53l1.06-1.06 1.559 1.557.008.01.107.107c.44.439 1.153.439 1.592 0l.393-.394-2.22-2.22L9.78 8.47l2.309 2.307.008.01.058.058a.84.84 0 1 0 1.19-1.19l-3.078-3.078a.5.5 0 0 0-.67-.034L7.529 8.225a2.258 2.258 0 0 1-3.063-3.307L5.66 3.656zm7.52-1.46c-.308 0-.603.127-.816.352L5.554 5.95a.759.759 0 0 0 1.029 1.11l2.07-1.681a2 2 0 0 1 2.674.138L13.03 7.22l.053.046a.46.46 0 0 0 .73-.315l.377-3.017-2.88-1.33a1.1 1.1 0 0 0-.472-.104z"/>`
    }, props));
$57a9c777c9766f2c$var$AskIcon.displayName = 'AskIcon';
var $57a9c777c9766f2c$var$_default = module.exports.default = $57a9c777c9766f2c$var$AskIcon;

});

parcelRegister("frwr8", function(module, exports) {

var $bcdSN = parcelRequire("bcdSN");

const $77025aded183059f$export$b43a25461d0ee688 = ({ itemsMap: itemsMap, issueTypeMap: issueTypeMap })=>{
    const items = Object.values(itemsMap);
    // First pass: build summary → invocationId lookup and reset childInvocationIds.
    // We must fully populate the summary map before resolving parent-child relationships,
    // since items have a flat structure (a child may appear before its parent).
    const summaryToInvocationId = {};
    const newMap = {};
    items.forEach((item)=>{
        summaryToInvocationId[item.summary] = item.invocationId;
        newMap[item.invocationId] = {
            ...item,
            childInvocationIds: undefined
        };
    });
    // Second pass: resolve parent-child relationships using the fully-populated summary map.
    const childInvocationIdsSet = new Set();
    items.forEach((item)=>{
        const parentSummary = item.fields[0, $bcdSN.PARENT_FIELD_ID];
        if (typeof parentSummary !== 'string') return;
        const parentInvocationId = summaryToInvocationId[parentSummary];
        if (!parentInvocationId || parentInvocationId === item.invocationId) return;
        const parentItem = newMap[parentInvocationId];
        // Validate hierarchy levels — items at the same level cannot be parent-child.
        // Only applies when issueTypeMap is provided.
        if (issueTypeMap) {
            const childHierarchyLevel = issueTypeMap[item.issueTypeId]?.hierarchyLevel ?? 0;
            const parentHierarchyLevel = issueTypeMap[parentItem.issueTypeId]?.hierarchyLevel ?? 0;
            if (childHierarchyLevel === parentHierarchyLevel) {
                // This is a child work item at the same hierarchy level as parent
                // Remove the parent field and promote it to the top level
                delete newMap[item.invocationId].fields[0, $bcdSN.PARENT_FIELD_ID];
                return;
            }
        }
        // Assign this item as a child of its parent.
        parentItem.childInvocationIds = [
            ...parentItem.childInvocationIds ?? [],
            item.invocationId
        ];
        childInvocationIdsSet.add(item.invocationId);
        // If the parent has already been created, rewrite the child's `fields.parent`
        // to the parent's createdIssueKey.
        if (parentItem.createdIssueKey) newMap[item.invocationId] = {
            ...newMap[item.invocationId],
            fields: {
                ...newMap[item.invocationId].fields,
                [(0, $bcdSN.PARENT_FIELD_ID)]: parentItem.createdIssueKey
            }
        };
    });
    return {
        newMap: newMap,
        childInvocationIdsSet: childInvocationIdsSet
    };
};
module.exports["recalculateHierarchy"] = $77025aded183059f$export$b43a25461d0ee688;

});

parcelRegister("6yxNO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $hlvTd = parcelRequire("hlvTd");


var $lTupu = parcelRequire("lTupu");


var $f8NKz = parcelRequire("f8NKz");


var $ckYNb = parcelRequire("ckYNb");

const $346a57d5f9c438a3$var$messages = (0, $kSwu1.defineMessages)({
    creationErrorTitle: {
        id: "jira-create-work-items.create-button.error-flag.title",
        defaultMessage: "Couldn't create these work items"
    }
});
const $346a57d5f9c438a3$var$resolveDraftIssueType = ({ issueTypeId: issueTypeId }, issueTypeToFieldsConfigMap)=>{
    if (!(0, $iDrrr.fg)('aiwc_add_issuetype_icon_to_optimistic_updates')) return undefined;
    if (!issueTypeId) return undefined;
    const issueType = issueTypeToFieldsConfigMap[issueTypeId];
    if (!issueType?.avatarUrl) return undefined;
    return {
        id: issueTypeId,
        name: issueType.name,
        iconUrl: issueType.avatarUrl
    };
};
const $346a57d5f9c438a3$var$pickCreatingDraft = (source, issueTypeToFieldsConfigMap)=>{
    const issueType = $346a57d5f9c438a3$var$resolveDraftIssueType(source, issueTypeToFieldsConfigMap);
    return {
        invocationId: source.invocationId,
        summary: source.summary,
        ...issueType ? {
            issueType: issueType
        } : {}
    };
};
/**
 * Flattens the validated draft work items into the shape broadcast on the `creating` event: each
 * parent followed by its (one level of) children, mirroring how `useCreateIssues` creates them.
 */ const $346a57d5f9c438a3$var$toCreatingDrafts = (items, issueTypeToFieldsConfigMap)=>items.flatMap((item)=>[
            $346a57d5f9c438a3$var$pickCreatingDraft(item, issueTypeToFieldsConfigMap),
            ...(item.childWorkItems ?? []).map((child)=>$346a57d5f9c438a3$var$pickCreatingDraft(child, issueTypeToFieldsConfigMap))
        ]);
const $346a57d5f9c438a3$export$a03522acab23bd76 = ({ onSuccess: onSuccess, onError: onError, cloudId: cloudId, cloudUrl: cloudUrl = '', projectIdOrKey: projectIdOrKey, showErrorsInFlag: showErrorsInFlag = true, showSuccessFlagOnCreate: showSuccessFlagOnCreate = true, isStagingArea: isStagingArea, entryPoint: entryPoint, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const showSuccessFlag = (0, $f8NKz.useCreateIssuesSuccessFlags)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)((0, $k1Pvg.Topics).AI_MATE_ACTIONS);
    const { validateIssuesToCreate: validateIssuesToCreate } = (0, $ckYNb.useValidateIssuesToCreate)({
        cloudId: cloudId,
        projectIdOrKey: projectIdOrKey,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    });
    const handleError = (0, $cozmU.useCallback)((args)=>{
        const { shouldLogError: shouldLogError, errorMessage: errorMessage } = args;
        if (shouldLogError) (0, $hlvTd.logException)({
            exception: errorMessage,
            name: 'SendJiraDraftDataForCreateAllCommandError'
        });
        if (showErrorsInFlag) showFlag({
            id: 'jira-create-work-items.create-button.error-flag',
            // Title falls back to the default error message
            title: formatMessage($346a57d5f9c438a3$var$messages.creationErrorTitle),
            description: errorMessage,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                color: "var(--ds-icon-danger, #C9372C)",
                size: "small",
                label: ""
            }),
            isAutoDismiss: false
        });
        // The consumer's error handling
        onError?.({
            errorMessage: errorMessage
        });
    }, [
        formatMessage,
        showFlag,
        showErrorsInFlag,
        onError
    ]);
    const { createIssues: createIssues } = (0, $lTupu.useCreateIssues)({
        cloudId: cloudId,
        isStagingArea: isStagingArea,
        entryPoint: entryPoint
    });
    return (0, $cozmU.useCallback)(async ({ draftWorkItems: draftWorkItems })=>{
        // Correlates the `creating`/`created`/`failed` lifecycle events for this batch so
        // subscribers (e.g. the list view) can match the optimistic rows they rendered from the
        // drafts with the eventual result. Conceptually this is a per-batch id, distinct from the
        // per-suggestion ids carried on each draft (and keyed in `invocationIdToCreatedIssueKey`).
        // On the FE we derive it from the first draft's invocationId, which is unique per submission
        // and stable across the three publishes below.
        const batchInvocationId = draftWorkItems?.[0]?.invocationId;
        // Tracks whether we announced the batch via the `creating` event, so we only publish a
        // matching `failed` event (to revert optimistic rows) when there is something to revert.
        let hasAnnouncedCreating = false;
        try {
            const validationResult = await validateIssuesToCreate(draftWorkItems);
            if (!validationResult?.success || validationResult?.error) {
                handleError({
                    shouldLogError: false,
                    errorMessage: validationResult?.error ?? formatMessage($346a57d5f9c438a3$var$messages.creationErrorTitle)
                });
                return;
            } else {
                if (batchInvocationId) {
                    publish({
                        type: (0, $k1Pvg.JIRA_WORK_ITEMS_CREATING_EVENT),
                        source: 'jira-create-work-items',
                        data: {
                            invocationId: batchInvocationId,
                            draftWorkItems: $346a57d5f9c438a3$var$toCreatingDrafts(validationResult.context.draftWorkItems, validationResult.context.issueTypeToFieldsConfigMap)
                        }
                    });
                    hasAnnouncedCreating = true;
                }
                const result = await createIssues({
                    draftWorkItems: validationResult?.context.draftWorkItems
                });
                if (!result.isSuccess) {
                    if (batchInvocationId) publish({
                        type: (0, $k1Pvg.JIRA_WORK_ITEMS_CREATE_FAILED_EVENT),
                        source: 'jira-create-work-items',
                        data: {
                            invocationId: batchInvocationId
                        }
                    });
                    // no issues were created
                    handleError({
                        shouldLogError: false,
                        errorMessage: result.errorMessage ?? formatMessage($346a57d5f9c438a3$var$messages.creationErrorTitle)
                    });
                    return;
                }
                if (showSuccessFlagOnCreate) {
                    const createdIssueKeys = Object.values(result.invocationIdToCreatedIssueKey);
                    showSuccessFlag({
                        createdIssueKeys: createdIssueKeys,
                        cloudUrl: cloudUrl
                    });
                }
                if (batchInvocationId) publish({
                    type: (0, $k1Pvg.JIRA_WORK_ITEMS_CREATED_EVENT),
                    source: 'jira-create-work-items',
                    data: {
                        invocationId: batchInvocationId,
                        createdIssueIds: result.createdIssueIds
                    }
                });
                await onSuccess?.({
                    invocationIdToCreatedIssueKey: result.invocationIdToCreatedIssueKey,
                    cloudUrl: cloudUrl
                });
            }
        } catch (error) {
            if (batchInvocationId && hasAnnouncedCreating) publish({
                type: (0, $k1Pvg.JIRA_WORK_ITEMS_CREATE_FAILED_EVENT),
                source: 'jira-create-work-items',
                data: {
                    invocationId: batchInvocationId
                }
            });
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SendJiraDraftDataForCreateAllCommandError'
            });
            onError?.({
                errorMessage: formatMessage($346a57d5f9c438a3$var$messages.creationErrorTitle)
            });
            return undefined;
        }
    }, [
        createIssues,
        formatMessage,
        handleError,
        onError,
        onSuccess,
        publish,
        showSuccessFlag,
        showSuccessFlagOnCreate,
        validateIssuesToCreate,
        cloudUrl
    ]);
};
module.exports["useCreateDraftWorkItems"] = $346a57d5f9c438a3$export$a03522acab23bd76;

});

parcelRegister("gVzkK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $hcOES = parcelRequire("hcOES");

const $c03b584f539f0510$var$messages = (0, $kSwu1.defineMessages)({
    isRequiredError: {
        id: "jira.jira.jira-platform-fields.is-required-error",
        defaultMessage: "{fieldName} is required"
    },
    errorLabel: {
        id: "jira.jira.jira-platform-fields.validation-popup.error-label",
        defaultMessage: "Error"
    }
});
const $c03b584f539f0510$export$99f6507637a953a2 = ({ isRequired: isRequired, isEditable: isEditable, fieldName: fieldName, fieldTypeForAnalytics: fieldTypeForAnalytics })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)((value)=>{
        const isEmpty = value == null || typeof value === 'string' && value.trim() === '' || Array.isArray(value) && value.length === 0;
        if (isEmpty && isRequired) {
            (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
                action: 'validationError',
                actionSubject: 'inlineEdit'
            }), {
                fieldName: fieldName,
                fieldType: fieldTypeForAnalytics,
                isRequired: isRequired,
                isEditable: isEditable
            });
            return formatMessage($c03b584f539f0510$var$messages.isRequiredError, {
                fieldName: fieldName
            });
        }
        return undefined;
    }, [
        isRequired,
        formatMessage,
        fieldName,
        createAnalyticsEvent,
        isEditable,
        fieldTypeForAnalytics
    ]);
};
module.exports["useValidateRequiredField"] = $c03b584f539f0510$export$99f6507637a953a2;

});

parcelRegister("2v5cF", function(module, exports) {
/* ValidationPopup.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $24dy7 = parcelRequire("24dy7");


var $57p4j = parcelRequire("57p4j");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $jp2Q3 = parcelRequire("jp2Q3");

const $1613a3ac1dc5f526$var$messages = (0, $kSwu1.defineMessages)({
    errorLabel: {
        id: "jira.jira.jira-platform-fields.error-label",
        defaultMessage: "Error"
    }
});
const $1613a3ac1dc5f526$var$styles = {
    errorContainer: "_0bjKvDKTcp _3iDTPbQ4SZ _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _24h04i2Njc _1EqgXln5H1 _0KLXruoI2d _2OUyjtGk8v _39xV02E6Kk"
};
const $1613a3ac1dc5f526$var$ValidationContent = ({ errorMessage: errorMessage, errorId: errorId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1613a3ac1dc5f526$var$styles.errorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        spacing: "spacious",
        label: formatMessage($1613a3ac1dc5f526$var$messages.errorLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    }), (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
        fireExperimentExposure: false
    }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        id: errorId
    }, errorMessage) : errorMessage));
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $1613a3ac1dc5f526$var$getDirectionFromPlacement = (placement)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    placement.split('-')[0]; // Inverts motion direction
const $1613a3ac1dc5f526$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $1613a3ac1dc5f526$var$POPPER_Z_INDEX = 9999;
const $1613a3ac1dc5f526$export$d73a2dad52f62293 = ({ showInvalidPopup: showInvalidPopup, trigger: trigger, errorMessage: errorMessage, placement: placement = 'right' })=>{
    const [referenceElement, setReferenceElement] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null); // One ID per instance of the popup
    const errorId = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useId();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, trigger({
        ref: setReferenceElement,
        errorId: errorId
    }), showInvalidPopup && referenceElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: $1613a3ac1dc5f526$var$POPPER_Z_INDEX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
        referenceElement: referenceElement,
        placement: placement,
        strategy: "fixed"
    }, ({ ref: ref, style: style, placement: popperPlacement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: $1613a3ac1dc5f526$var$invertedDirection[$1613a3ac1dc5f526$var$getDirectionFromPlacement(popperPlacement)]
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: ref,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    ...style,
                    zIndex: (0, $jp2Q3.layers).layer()
                },
                "data-placement": popperPlacement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: className,
                role: "alert",
                "aria-live": "assertive"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1613a3ac1dc5f526$var$ValidationContent, {
                errorMessage: errorMessage,
                errorId: errorId
            })))))));
};
module.exports["ValidationPopup"] = $1613a3ac1dc5f526$export$d73a2dad52f62293;

});

parcelRegister("7nqlz", function(module, exports) {
/* ListWithPopup.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $3jUgE = parcelRequire("3jUgE");

const $c1501156a16799fc$var$ListWithPopup = ({ items: items, ItemComponent: ItemComponent, maxLimit: maxLimit, initialIsOpen: initialIsOpen, isHoverPopoverEnabled: isHoverPopoverEnabled, ...restProps })=>{
    const [firstItem, ...restItems] = items;
    const ShowMorePopupRenderer = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jUgE.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        }), [
        ItemComponent,
        initialIsOpen,
        isHoverPopoverEnabled,
        maxLimit,
        restItems,
        restProps
    ]);
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isHoverPopoverEnabled,
        xcss: isHoverPopoverEnabled && $c1501156a16799fc$var$styles.hoverPopover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, {
        ...firstItem,
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }), restItems.length >= 1 && ShowMorePopupRenderer());
};
const $c1501156a16799fc$var$styles = {
    hoverPopover: "_1Znuxb1Y8M _39xV02N91d"
};
var $c1501156a16799fc$export$2e2bcd8739ae039 = $c1501156a16799fc$var$ListWithPopup;
module.exports["default"] = $c1501156a16799fc$export$2e2bcd8739ae039;

});

parcelRegister("5r5PB", function(module, exports) {
/* TagItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $ekCm6 = parcelRequire("ekCm6");

var $arQY7 = parcelRequire("arQY7");

var $eFbDl = parcelRequire("eFbDl");


var $iQxQk = parcelRequire("iQxQk");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $IOtUu = parcelRequire("IOtUu");


var $k8Uuy = parcelRequire("k8Uuy");


var $jXedL = parcelRequire("jXedL");

const $22a1f2dce0c8458b$var$AVATAR_SIZE = 'xxsmall';
const $22a1f2dce0c8458b$var$AVATAR_APPEARANCE = 'square';
const $22a1f2dce0c8458b$var$styles = {
    tagWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _3138425UaJ _1DCdHi5UaJ _0adFHs5UaJ _2XsHFM5UaJ _1ANEUSLRg7 _39xV02W9qI _1EqgXlWD6W",
    truncatedText: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _3iDTPbvbI6 _1EqgXlN91d"
};
const $22a1f2dce0c8458b$var$TagItemAvatar = ({ src: src, testId: testId = 'list-with-popup.ui.tag-item.avatar' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: $22a1f2dce0c8458b$var$AVATAR_APPEARANCE,
        size: $22a1f2dce0c8458b$var$AVATAR_SIZE,
        src: src,
        borderColor: "transparent",
        testId: testId
    });
const $22a1f2dce0c8458b$var$TagItemMediaImage = ({ mediaImage: mediaImage, fallbackSrc: fallbackSrc })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iQxQk.MediaImageWithErrorBoundary), {
        identifier: mediaImage.identifier,
        mediaClientConfig: mediaImage.mediaClientConfig,
        apiConfig: {
            ...mediaImage.apiConfig,
            width: (0, $ekCm6.AVATAR_SIZES)[$22a1f2dce0c8458b$var$AVATAR_SIZE],
            height: (0, $ekCm6.AVATAR_SIZES)[$22a1f2dce0c8458b$var$AVATAR_SIZE]
        }
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: $22a1f2dce0c8458b$var$AVATAR_APPEARANCE,
            size: $22a1f2dce0c8458b$var$AVATAR_SIZE
        });
        if (error || !data?.src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22a1f2dce0c8458b$var$TagItemAvatar, {
            src: fallbackSrc,
            testId: "list-with-popup.ui.tag-item.media-image-error"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22a1f2dce0c8458b$var$TagItemAvatar, {
            src: data?.src,
            testId: "list-with-popup.ui.tag-item.media-image-avatar"
        });
    });
const $22a1f2dce0c8458b$var$TagItemIcon = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, icon?.mediaImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22a1f2dce0c8458b$var$TagItemMediaImage, {
        mediaImage: icon.mediaImage,
        fallbackSrc: icon.url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22a1f2dce0c8458b$var$TagItemAvatar, {
        src: icon?.url
    }));
const $22a1f2dce0c8458b$export$32a09b7581f7fd80 = ({ name: name, href: href, icon: icon, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isColored: isColored, color: color, openLinksInNewTab: openLinksInNewTab })=>{
    const LinkWithProps = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXedL.default), {
            ...props,
            shouldDisplayStrikethrough: shouldDisplayStrikethrough,
            openLinksInNewTab: openLinksInNewTab
        }, children);
    const baseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        testId: "list-with-popup.ui.tag-item.tag-item",
        xcss: $22a1f2dce0c8458b$var$styles.tagWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22a1f2dce0c8458b$var$TagItemIcon, {
            icon: icon
        }) : undefined,
        text: name,
        href: href,
        linkComponent: LinkWithProps,
        isRemovable: false
    }));
    const tagNode = isColored && color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        testId: "list-with-popup.ui.tag-item.tag-item",
        xcss: $22a1f2dce0c8458b$var$styles.tagWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k8Uuy.default), {
        labelName: name,
        href: href ?? undefined,
        color: color,
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22a1f2dce0c8458b$var$TagItemIcon, {
            icon: icon
        }) : undefined,
        contentXcss: $22a1f2dce0c8458b$var$styles.truncatedText,
        openLinksInNewTab: openLinksInNewTab
    })) : baseTag;
    return tagNode;
};
const $22a1f2dce0c8458b$export$c9925310d93bfb2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        shouldWrap: true
    }, children);
module.exports["TagItem"] = $22a1f2dce0c8458b$export$32a09b7581f7fd80;
module.exports["TagItemPopupContentWrapper"] = $22a1f2dce0c8458b$export$c9925310d93bfb2;

});

parcelRegister("3Yuw9", function(module, exports) {
/* BaseDateField.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $k5sGX = parcelRequire("k5sGX");


var $kSwu1 = parcelRequire("kSwu1");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $gVzkK = parcelRequire("gVzkK");


var $2v5cF = parcelRequire("2v5cF");

const $29b0bd4dec69923e$var$messages = (0, $kSwu1.defineMessages)({
    none: {
        id: "jira.jira-platform-fields.base-date-field.none",
        defaultMessage: "None"
    }
});
const $29b0bd4dec69923e$var$styles = {
    container: "_39xV02N91d _3138424F84",
    readView: "_39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb2ADO _2Zuz6Q2ADO",
    editableReadView: "_0wOv4Q7zJH _0jFU0VnlTt"
};
const $29b0bd4dec69923e$var$parseDate = (dateString)=>{
    if (dateString) {
        const date = (0, $k5sGX.default)(dateString);
        if (date.toString() !== 'Invalid Date') return date;
    }
    return null;
};
const $29b0bd4dec69923e$var$ReadView = ({ dateString: dateString, includeTime: includeTime, isEditable: isEditable })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const date = $29b0bd4dec69923e$var$parseDate(dateString);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($29b0bd4dec69923e$var$styles.readView, isEditable && $29b0bd4dec69923e$var$styles.editableReadView)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "start",
        color: date ? 'color.text' : 'color.text.subtle',
        maxLines: 1
    }, date ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
        value: date,
        year: "numeric",
        month: "short",
        day: "2-digit",
        ...includeTime ? {
            hour: '2-digit',
            minute: '2-digit'
        } : {}
    }) : formatMessage($29b0bd4dec69923e$var$messages.none)));
};
const $29b0bd4dec69923e$export$cb1c8784e742222c = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldName: fieldName, labelText: labelText, isEditable: isEditable, isRequired: isRequired, currentValue: currentValue, defaultValue: defaultValue, includeTime: includeTime = false, onChange: onChange, renderPicker: renderPicker })=>{
    const { locale: locale, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const validate = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: fieldName || labelText,
        fieldTypeForAnalytics: 'DateField'
    });
    const placeholder = (0, $cozmU.useMemo)(()=>formatDate(new Date()), [
        formatDate
    ]);
    const handleOnConfirm = (0, $cozmU.useCallback)((newValue)=>{
        onChange?.(newValue ?? null);
    }, [
        onChange
    ]);
    const readView = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29b0bd4dec69923e$var$ReadView, {
            dateString: currentValue,
            includeTime: includeTime,
            isEditable: isEditable
        });
    }, [
        currentValue,
        includeTime,
        isEditable
    ]); // Allows us to make sure we only fall back to default value once, on initial render
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // If the passed down value is empty and a default value is available, tell the upstream
        if (!currentValue && defaultValue != null && isFirstRenderRef.current) onChange?.(defaultValue);
        isFirstRenderRef.current = false;
    }, [
        currentValue,
        defaultValue,
        onChange
    ]);
    if (!isEditable) return readView;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $29b0bd4dec69923e$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
        defaultValue: currentValue || '',
        readView: ()=>readView,
        editView: ({ errorMessage: errorMessage, isInvalid: isInvalid, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2v5cF.ValidationPopup), {
                errorMessage: errorMessage,
                showInvalidPopup: Boolean(isInvalid && errorMessage),
                trigger: ({ ref: ref, errorId: errorId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        ref: ref
                    }, renderPicker({
                        ...fieldProps,
                        errorId: errorId,
                        isInvalid: isInvalid,
                        isRequired: isRequired,
                        placeholder: placeholder,
                        locale: locale,
                        autoFocus: true
                    }))
            }),
        validate: validate,
        onConfirm: handleOnConfirm,
        hideActionButtons: true,
        readViewFitContainerWidth: true,
        editButtonLabel: currentValue ?? undefined
    }));
});
module.exports["BaseDateField"] = $29b0bd4dec69923e$export$cb1c8784e742222c;

});

parcelRegister("4ZN5q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $720f560450bf949a$export$3cfab3cce9f03f6 = (stringArray, { sort: sort, deduplicate: deduplicate, sortFunction: sortFunction = (a, b)=>a.localeCompare(b) })=>{
    const separator = '___@@@$$@@@___'; // unique separator to avoid conflicts with other strings
    const stableItemsString = (0, $cozmU.useMemo)(()=>{
        let items = [
            ...stringArray
        ];
        if (deduplicate) items = [
            ...new Set(items)
        ];
        if (sort) items.sort(sortFunction);
        return items.join(separator);
    }, [
        stringArray,
        sort,
        separator,
        deduplicate,
        sortFunction
    ]);
    return (0, $cozmU.useMemo)(()=>stableItemsString.length ? stableItemsString.split(separator) : [], [
        stableItemsString
    ]);
};
module.exports["useStableArray"] = $720f560450bf949a$export$3cfab3cce9f03f6;

});

parcelRegister("aLI5J", function(module, exports) {
/* UserPickerComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $bcDqz = parcelRequire("bcDqz");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $jp2Q3 = parcelRequire("jp2Q3");


var $kfLla = parcelRequire("kfLla");


var $4ZN5q = parcelRequire("4ZN5q");


var $14F6V = parcelRequire("14F6V");


var $hCHQD = parcelRequire("hCHQD");

const $1989bda4ec720859$var$controlBaseStyles = {
    backgroundColor: 'transparent',
    minHeight: 40,
    // overrides default 44px min height
    paddingTop: 0,
    paddingBottom: 0,
    '&:active': {
        borderWidth: "var(--ds-border-width-focused, 2px)",
        borderColor: "var(--ds-border-focused, #4688EC)"
    },
    '&:focus-within': {
        borderWidth: "var(--ds-border-width-focused, 2px)",
        borderColor: "var(--ds-border-focused, #4688EC)"
    }
};
const $1989bda4ec720859$export$acf45ab5e2fd1e5b = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $jp2Q3.layers).modal)
        }),
    control: (base)=>({
            ...base,
            ...$1989bda4ec720859$var$controlBaseStyles,
            height: 40 // overrides default 44px height
        }),
    valueContainer: (base)=>({
            ...base,
            paddingTop: 0,
            paddingBottom: 0
        }),
    input: (base)=>({
            ...base,
            margin: 0,
            paddingTop: 0,
            paddingBottom: 0
        })
};
const $1989bda4ec720859$var$userPickerStylesMulti = {
    ...$1989bda4ec720859$export$acf45ab5e2fd1e5b,
    control: (base)=>({
            ...base,
            ...$1989bda4ec720859$var$controlBaseStyles // No set height for multi-select picker
        })
};
const $1989bda4ec720859$var$messages = (0, $kSwu1.defineMessages)({
    selectLabel: {
        id: "jira.jira.jira-platform-fields.single-select-user-picker.select.label",
        defaultMessage: "Select user"
    },
    emptyLabel: {
        id: "jira.jira.jira-platform-fields.single-select-user-picker.empty.label",
        defaultMessage: "Unassigned"
    }
});
const $1989bda4ec720859$var$styles = {
    container: "_39xV02N91d",
    readViewButton: "_0bjKvDKTcp _23rrnHIpct _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrujOvk _39xV02N91d _0jFU0VUF4f _2Zuz6QPgdg _34b3D2Ll21 _1eOmH6o126",
    readOnlyViewContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q2ADO _1Znuxb2ADO _39xV02N91d _0jFU0VUF4f"
};
const $1989bda4ec720859$export$9c1a02a764f91e4c = /*#__PURE__*/ (0, $cozmU.memo)(({ fieldId: fieldId, fieldValue: fieldValue, projectKey: projectKey, defaultUsers: defaultUsers, isEditable: isEditable, isRequired: isRequired, isMulti: isMulti, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const emptyUser = (0, $cozmU.useMemo)(()=>({
            id: '0',
            name: formatMessage($1989bda4ec720859$var$messages.emptyLabel),
            accountId: '',
            avatarUrl: ''
        }), [
        formatMessage
    ]);
    const [selectedUsers, setSelectedUsers] = (0, $cozmU.useState)([]);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const hasUserChangedSelectionRef = (0, $cozmU.useRef)(false);
    const hydratedUsers = (0, $cozmU.useMemo)(()=>{
        if (!fieldValue) return [];
        return (Array.isArray(fieldValue) ? fieldValue : [
            fieldValue
        ]).map((userWithWrapper)=>(0, $hCHQD.parseUser)(userWithWrapper)).filter((value)=>value != null);
    }, [
        fieldValue
    ]);
    const stableAccountIds = (0, $4ZN5q.useStableArray)(hydratedUsers.map((user)=>user.user?.accountId).filter((accountId)=>accountId != null), {
        sort: true,
        deduplicate: false
    });
    const areHydratedUsersReady = (0, $cozmU.useMemo)(()=>hydratedUsers.every((hydratedUser)=>hydratedUser.status === 'READY' && hydratedUser.error === null), [
        hydratedUsers
    ]);
    const mappedHydratedUsers = (0, $cozmU.useMemo)(()=>hydratedUsers.filter((hydratedUser)=>Boolean(hydratedUser.status === 'READY' && hydratedUser.error === null && hydratedUser.user?.accountId && hydratedUser.user?.name)).map(({ user: user })=>{
            if (!user) // This should never happen because we filter out users with no accountId or name
            // This is just to make typescript happy
            return emptyUser;
            return {
                id: user.accountId,
                name: user.name,
                avatarUrl: user.avatarUrl ?? undefined,
                // undefined is allowed, but not null
                accountId: user.accountId
            };
        }), [
        hydratedUsers,
        emptyUser
    ]);
    const effectiveFallbackUsers = (0, $cozmU.useMemo)(()=>{
        return (mappedHydratedUsers?.length ? mappedHydratedUsers : null) || // fallback to default users when available
        (defaultUsers?.length ? defaultUsers : null) || [];
    }, [
        mappedHydratedUsers,
        defaultUsers
    ]);
    const effectiveFallbackAccountIds = (0, $4ZN5q.useStableArray)(effectiveFallbackUsers?.map((user)=>user.accountId).filter(Boolean), {
        sort: true,
        deduplicate: false
    });
    const handleChange = (0, $cozmU.useCallback)((newValue, skipFireAnalytics)=>{
        let newUserMaybeArray;
        if (newValue != null) newUserMaybeArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        else newUserMaybeArray = isMulti ? [] : [
            emptyUser
        ];
        hasUserChangedSelectionRef.current = true;
        setSelectedUsers(newUserMaybeArray);
        const newUserValue = isMulti ? newUserMaybeArray.map((user)=>{
            const result = {
                accountIdOrAri: user.accountId ?? '',
                user: user,
                status: 'READY',
                error: null
            };
            return result;
        }) : {
            accountIdOrAri: newUserMaybeArray[0].accountId ?? '',
            user: newUserMaybeArray[0],
            status: 'READY',
            error: null
        };
        onChange(newUserValue, skipFireAnalytics === true);
        setIsEditing(false);
    }, [
        isMulti,
        onChange,
        emptyUser
    ]);
    const handleUserPickerChange = (0, $cozmU.useCallback)((newValue)=>{
        handleChange(newValue);
    }, [
        handleChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Only need to sync with upstream if user hasn't interacted yet. Otherwise the
        // upstream has already been synced via the `handleChange` handler.
        if (!hasUserChangedSelectionRef.current && !selectedUsers?.length && areHydratedUsersReady && JSON.stringify([
            ...stableAccountIds
        ].sort()) !== JSON.stringify([
            ...effectiveFallbackAccountIds
        ].sort())) // We skip firing analytics here since this is the first load
        // and not a user interaction
        handleChange(effectiveFallbackUsers, true);
    }, [
        handleChange,
        stableAccountIds,
        effectiveFallbackAccountIds,
        areHydratedUsersReady,
        selectedUsers?.length,
        effectiveFallbackUsers
    ]);
    const effectiveUsers = (0, $cozmU.useMemo)(()=>{
        // If user has interacted, always use their selection (even if empty).
        if (hasUserChangedSelectionRef.current) {
            if (selectedUsers?.length) return selectedUsers;
            return isMulti ? [] : [
                emptyUser
            ];
        } // Otherwise follow the order of preference below
        return(// First preference to selected users in state
        (selectedUsers?.length ? selectedUsers : null) || // If users list is empty, use hydrated users
        (effectiveFallbackUsers?.length ? effectiveFallbackUsers : null) || // fallback to empty user when not multi-select
        (isMulti ? [] : [
            emptyUser
        ]));
    }, [
        selectedUsers,
        effectiveFallbackUsers,
        isMulti,
        emptyUser
    ]); // Custom compact read view for uniform row height; click to enter edit mode if editable
    const renderReadView = (0, $cozmU.useCallback)(()=>{
        const usersList = Array.isArray(effectiveUsers) ? effectiveUsers : [];
        if (usersList.length === 0) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $1989bda4ec720859$var$styles.readOnlyViewContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            size: "small",
            name: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? '' : formatMessage($1989bda4ec720859$var$messages.emptyLabel),
            "aria-hidden": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? true : undefined
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, formatMessage($1989bda4ec720859$var$messages.emptyLabel))));
        if (usersList.length === 1) {
            const user = usersList[0];
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $1989bda4ec720859$var$styles.readOnlyViewContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                size: "small",
                src: user.avatarUrl,
                name: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? '' : user.name,
                "aria-hidden": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? true : undefined
            }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                maxLines: 1
            }, user.name)));
        }
        const data = usersList.map((u)=>({
                name: u.name,
                src: u.avatarUrl
            }));
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $1989bda4ec720859$var$styles.readOnlyViewContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
            appearance: "stack",
            size: "small",
            data: data,
            maxCount: 4
        }));
    }, [
        effectiveUsers,
        formatMessage
    ]);
    const handleEnterEditMode = (0, $cozmU.useCallback)(()=>{
        setIsEditing(true);
    }, []);
    const firstEffectiveUserDisplayName = effectiveUsers?.[0]?.name;
    const onFetchSuggestions = (0, $cozmU.useCallback)(async (query)=>{
        let term = query ?? ''; // If the user is not multi-select and the query is the same as the first effective user's display name, set the query to an empty string.
        // This way we show all users in the dropdown when a user is already selected, and the user tries to select a different user.
        if (!isMulti && query === firstEffectiveUserDisplayName) term = '';
        const results = await (0, $14F6V.fetchSuggestions)(term, projectKey);
        return isRequired ? results : [
            emptyUser,
            ...results
        ];
    }, [
        projectKey,
        isRequired,
        emptyUser,
        isMulti,
        firstEffectiveUserDisplayName
    ]);
    const setIsEditingFalse = (0, $cozmU.useCallback)(()=>{
        setIsEditing(false);
    }, []);
    const renderUserPicker = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ $cozmU.createElement((0, $kfLla.UserPicker), {
            fieldId: fieldId,
            appearance: "normal",
            width: "100%",
            menuMinWidth: 200,
            onChange: handleUserPickerChange,
            onBlur: setIsEditingFalse,
            placeholder: formatMessage($1989bda4ec720859$var$messages.selectLabel),
            value: isMulti ? effectiveUsers : effectiveUsers?.[0],
            isDisabled: !isEditable,
            required: isRequired,
            noBorder: true,
            styles: isMulti ? $1989bda4ec720859$var$userPickerStylesMulti : $1989bda4ec720859$export$acf45ab5e2fd1e5b,
            isMulti: isMulti,
            loadOptions: onFetchSuggestions,
            isClearable: isEditable && !isRequired,
            menuPosition: "fixed",
            openMenuOnClick: false,
            autoFocus: true // avoids using built-in read view since we already have our own
            ,
            menuIsOpen: isEditing
        }), [
        fieldId,
        handleUserPickerChange,
        formatMessage,
        isEditable,
        isRequired,
        isMulti,
        effectiveUsers,
        isEditing,
        onFetchSuggestions,
        setIsEditingFalse
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $1989bda4ec720859$var$styles.container
    }, isEditable && isEditing && renderUserPicker(), isEditable && !isEditing && /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $1989bda4ec720859$var$styles.readViewButton,
        onClick: handleEnterEditMode
    }, renderReadView()), !isEditable && renderReadView());
});
module.exports["UserPickerComponent"] = $1989bda4ec720859$export$9c1a02a764f91e4c;

});

parcelRegister("jFZPQ", function(module, exports) {
/* CustomTextField.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $bB0i2 = parcelRequire("bB0i2");


var $9DHhW = parcelRequire("9DHhW");


var $I7hWB = parcelRequire("I7hWB");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $hcOES = parcelRequire("hcOES");


var $2nJYx = parcelRequire("2nJYx");


var $gVzkK = parcelRequire("gVzkK");


var $9XiTB = parcelRequire("9XiTB");


var $2v5cF = parcelRequire("2v5cF");

const $8d3b584294198da6$var$styles = {
    standardHeight: "_0jFU0VUF4f",
    fullWidthHeight: "_4kiQYAUF4f",
    editableTextFieldContainer: "_39xV02N91d _3138424F84",
    fullWidthContainer: "_2XsHFMTUhv",
    textField: "_39xV02N91d",
    headingEditView: "_0GmikjWSk4",
    headingFullWidthEditView: "_4hiDxTWSk4 _1gYn9cy7kJ _0o8TGowPeg _1FXUNPnQyn",
    readViewBase: "_39xV02N91d _0hPCNLDIqT _3iDTPbQ4SZ",
    standardReadView: "_0jFU0VUF4f _1Znuxb2ADO _2Zuz6Q2ADO",
    fullWidthReadView: "_4kiQYAR4us _1Znuxb1Y8M _2Zuz6Q1Y8M _1ANEUS77fC",
    editablePointer: "_0wOv4Q7zJH",
    editableReadViewHeight: "_0jFU0VnlTt",
    editableReadViewMinHeight: "_4kiQYAuNcX"
};
const $8d3b584294198da6$var$ReadView = /*#__PURE__*/ (0, $cozmU.memo)(({ text: text, isEditable: isEditable, as: as = 'default', isFullWidth: isFullWidth = false })=>{
    const textRef = (0, $cozmU.useRef)(null);
    const canAppear = (0, $cozmU.useCallback)(()=>{
        const element = textRef.current;
        (0, $bB0i2.default)(element); // Only showing the tooltip for this item when
        // the element has been clamped.
        return element.scrollHeight > element.clientHeight;
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        component: (0, $9XiTB.CustomTooltip),
        content: text,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canAppear
    }, (props)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ...props,
            xcss: (0, $k12R1.cx)($8d3b584294198da6$var$styles.readViewBase, isFullWidth ? $8d3b584294198da6$var$styles.fullWidthReadView : $8d3b584294198da6$var$styles.standardReadView, isEditable && $8d3b584294198da6$var$styles.editablePointer, isEditable && !isFullWidth && $8d3b584294198da6$var$styles.editableReadViewHeight, isEditable && isFullWidth && as !== 'heading' && $8d3b584294198da6$var$styles.editableReadViewMinHeight)
        }, as === 'heading' ? /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            ref: textRef,
            size: "medium"
        }, text) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            ref: textRef,
            maxLines: isFullWidth ? undefined : 1
        }, text)));
});
const $8d3b584294198da6$var$FIELD_TYPE_FOR_ANALYTICS = 'TextField';
const $8d3b584294198da6$var$createEditView = (inputType, as, isFullWidth, onConfirm)=>({ errorMessage: errorMessage, isInvalid: isInvalid, ...fieldProps })=>{
        const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
            if (as === 'heading' && e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                onConfirm(e.currentTarget.value);
            }
        }, []);
        return /*#__PURE__*/ $cozmU.createElement((0, $2v5cF.ValidationPopup), {
            errorMessage: errorMessage,
            showInvalidPopup: Boolean(isInvalid && errorMessage),
            trigger: ({ ref: ref, ...triggerProps })=>isFullWidth ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: as === 'heading' && $8d3b584294198da6$var$styles.headingFullWidthEditView
                }, /*#__PURE__*/ $cozmU.createElement((0, $e3Wrf.default), {
                    ...fieldProps,
                    onChange: (e)=>fieldProps.onChange(e.currentTarget.value),
                    onKeyDown: handleKeyDown,
                    autoFocus: true,
                    ref: ref,
                    isInvalid: isInvalid,
                    "aria-invalid": isInvalid || undefined,
                    "aria-describedby": isInvalid ? triggerProps.errorId : undefined,
                    "aria-errormessage": isInvalid ? errorMessage : undefined,
                    minimumRows: 1
                })) : /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                    ...fieldProps,
                    type: inputType ?? 'text',
                    autoFocus: true,
                    ref: ref,
                    isInvalid: isInvalid,
                    "aria-invalid": isInvalid || undefined,
                    "aria-describedby": isInvalid ? triggerProps.errorId : undefined,
                    "aria-errormessage": isInvalid ? errorMessage : undefined,
                    className: (0, $hekY6.default)([
                        $8d3b584294198da6$var$styles.textField,
                        as === 'heading' && $8d3b584294198da6$var$styles.headingEditView
                    ])
                })
        });
    };
const $8d3b584294198da6$export$97160f6ad111287f = ({ as: as = 'default', isEditable: isEditable, isFullWidth: isFullWidth = false, isRequired: isRequired, currentValue: currentValue, fieldName: fieldName, onChange: onChange, inputType: inputType = 'text' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const validate = (0, $gVzkK.useValidateRequiredField)({
        isRequired: isRequired,
        isEditable: isEditable,
        fieldName: fieldName,
        fieldTypeForAnalytics: $8d3b584294198da6$var$FIELD_TYPE_FOR_ANALYTICS
    });
    const onEdit = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'initiated',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: $8d3b584294198da6$var$FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsEditing(true);
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable
    ]);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        (0, $hcOES.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'inlineEdit'
        }), {
            fieldName: fieldName,
            fieldType: $8d3b584294198da6$var$FIELD_TYPE_FOR_ANALYTICS,
            isRequired: isRequired,
            isEditable: isEditable
        });
        setIsEditing(false);
    }, [
        createAnalyticsEvent,
        fieldName,
        isRequired,
        isEditable
    ]);
    const onConfirm = (0, $cozmU.useCallback)((newValue)=>{
        setIsEditing(false);
        if (newValue !== currentValue) onChange(newValue);
    }, [
        onChange,
        currentValue
    ]);
    const EditView = (0, $cozmU.useMemo)(()=>$8d3b584294198da6$var$createEditView(inputType, as, isFullWidth, onConfirm), [
        inputType,
        as,
        isFullWidth,
        onConfirm
    ]); // Creating components on render sucks
    // Ideally the values for text and isEditable would be passed as props to the ReadView component
    // But the atlaskit InlineEdit component doesn't support passing props to the read view component
    // Hence we do the bare minimum of using useCallback to memoize the ReadView component
    const ReadViewComponent = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ $cozmU.createElement($8d3b584294198da6$var$ReadView, {
            text: currentValue,
            isEditable: isEditable,
            as: as,
            isFullWidth: isFullWidth
        });
    }, [
        currentValue,
        isEditable,
        as,
        isFullWidth
    ]);
    if (!isEditable) return /*#__PURE__*/ $cozmU.createElement(ReadViewComponent, null);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "data-attr": (0, $2nJYx.CUSTOM_TEXT_FIELD_ID),
        xcss: (0, $k12R1.cx)($8d3b584294198da6$var$styles.editableTextFieldContainer, isFullWidth && $8d3b584294198da6$var$styles.fullWidthContainer, isFullWidth ? $8d3b584294198da6$var$styles.fullWidthHeight : $8d3b584294198da6$var$styles.standardHeight)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        isEditing: isEditing,
        defaultValue: currentValue,
        editButtonLabel: currentValue,
        editView: EditView,
        readView: ReadViewComponent,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onEdit: onEdit,
        hideActionButtons: false,
        readViewFitContainerWidth: true,
        validate: validate
    }));
};
module.exports["CustomTextField"] = $8d3b584294198da6$export$97160f6ad111287f;

});

parcelRegister("gBLwY", function(module, exports) {

var $iPm7V = parcelRequire("iPm7V");

const $9632deed844d28c7$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $iPm7V.GREY_META;
    return (0, $iPm7V.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $iPm7V.GREY_META);
};
const $9632deed844d28c7$export$4ef6b7574883e63d = ()=>(0, $iPm7V.OPTION_COLOR_THEMES).map((item)=>item.name);
module.exports["getColorMetadata"] = $9632deed844d28c7$export$49fce7fdcf55f26d;

});

parcelRegister("4Qaxv", function(module, exports) {
function $e23d031367b4a69d$export$ec63a4108685a0aa(limit = 5) {
    const cache = new Map();
    return {
        get: (key)=>cache.get(key),
        set: (key, value)=>{
            cache.set(key, {
                lastAccessed: Date.now(),
                value: value
            });
            if (cache.size <= limit) return;
            // limit the cache size based on the oldest entry based on lastAccessed time
            let oldestKey = null;
            let oldestLastAccessed = null;
            for (const [key_, value_] of cache.entries())if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
                oldestKey = key_;
                oldestLastAccessed = value_.lastAccessed;
            }
            if (oldestKey) cache.delete(oldestKey);
        },
        delete: (key)=>{
            cache.delete(key);
        },
        clear: ()=>{
            cache.clear();
        }
    };
}
module.exports["LruCache"] = $e23d031367b4a69d$export$ec63a4108685a0aa;

});

parcelRegister("fESy2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $80e26d1d4c0bc681$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.message-actions.scheduled-chat.card-title",
        defaultMessage: "Scheduled chat"
    },
    scheduledChatNameLabel: {
        id: "ai-mate.message-actions.scheduled-chat.name-label",
        defaultMessage: "Scheduled name"
    },
    scheduledChatNamePlaceholder: {
        id: "ai-mate.message-actions.scheduled-chat.name-placeholder",
        defaultMessage: "Enter a name for this scheduled chat"
    },
    promptLabel: {
        id: "ai-mate.message-actions.scheduled-chat.prompt-label",
        defaultMessage: "Prompt"
    },
    promptPlaceholder: {
        id: "ai-mate.message-actions.scheduled-chat.prompt-placeholder",
        defaultMessage: "Enter the prompt for this scheduled chat"
    },
    frequencyLabel: {
        id: "ai-mate.message-actions.scheduled-chat.frequency-label",
        defaultMessage: "Frequency"
    },
    frequencyOptionHourly: {
        id: "ai-mate.message-actions.scheduled-chat.frequency-option.hourly",
        defaultMessage: "Hourly"
    },
    frequencyOptionDaily: {
        id: "ai-mate.message-actions.scheduled-chat.frequency-option.daily",
        defaultMessage: "Daily"
    },
    frequencyOptionWeekdays: {
        id: "ai-mate.message-actions.scheduled-chat.frequency-option.weekdays",
        defaultMessage: "Weekdays"
    },
    frequencyOptionCustom: {
        id: "ai-mate.message-actions.scheduled-chat.frequency-option.custom",
        defaultMessage: "Custom"
    },
    daysLabel: {
        id: "ai-mate.message-actions.scheduled-chat.days-label",
        defaultMessage: "Days"
    },
    timeLabel: {
        id: "ai-mate.message-actions.scheduled-chat.time-label",
        defaultMessage: "Time"
    },
    createButton: {
        id: "ai-mate.message-actions.scheduled-chat.create-button",
        defaultMessage: "Create"
    },
    saveButton: {
        id: "ai-mate.message-actions.scheduled-chat.save-button",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "ai-mate.message-actions.scheduled-chat.cancel-button",
        defaultMessage: "Cancel"
    },
    createModalTitle: {
        id: "ai-mate.message-actions.scheduled-chat.create-modal-title",
        defaultMessage: "Create scheduled chat"
    },
    editModalTitle: {
        id: "ai-mate.message-actions.scheduled-chat.edit-modal-title",
        defaultMessage: "Edit scheduled chat"
    },
    renameModalTitle: {
        id: "ai-mate.message-actions.scheduled-chat.rename-modal-title",
        defaultMessage: "Rename scheduled chat"
    },
    editModalPause: {
        id: "ai-mate.message-actions.scheduled-chat.edit-modal-pause",
        defaultMessage: "Pause scheduled chat"
    },
    editModalNextRunAt: {
        id: "ai-mate.message-actions.scheduled-chat.edit-modal-next-run-at",
        defaultMessage: "Next run {nextRunLabel}"
    },
    frequencyAtTime: {
        id: "ai-mate.message-actions.scheduled-chat.frequency-at-time",
        defaultMessage: "{frequency} at {time}"
    },
    dateAtTime: {
        id: "ai-mate.message-actions.scheduled-chat.date-at-time",
        defaultMessage: "{date} at {time}"
    },
    editModalDelete: {
        id: "ai-mate.message-actions.scheduled-chat.edit-modal-delete",
        defaultMessage: "Delete"
    },
    deleteModalTitle: {
        id: "ai-mate.message-actions.scheduled-chat.delete-modal.title",
        defaultMessage: "Delete scheduled chat?"
    },
    deleteModalDescription: {
        id: "ai-mate.message-actions.scheduled-chat.delete-modal.description",
        defaultMessage: "Are you sure you want to delete \"{name}\"? This action cannot be undone."
    },
    deleteModalCancel: {
        id: "ai-mate.message-actions.scheduled-chat.delete-modal.cancel",
        defaultMessage: "Cancel"
    },
    deleteModalConfirm: {
        id: "ai-mate.message-actions.scheduled-chat.delete-modal.confirm",
        defaultMessage: "Delete"
    }
});
var $80e26d1d4c0bc681$export$2e2bcd8739ae039 = $80e26d1d4c0bc681$var$messages;
module.exports["default"] = $80e26d1d4c0bc681$export$2e2bcd8739ae039;

});

parcelRegister("9krqg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2uDbg = parcelRequire("2uDbg");


var $3sqHc = parcelRequire("3sqHc");


var $kB5K2 = parcelRequire("kB5K2");

var $hpa99 = parcelRequire("hpa99");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $SJBPH = parcelRequire("SJBPH");


var $fjEgq = parcelRequire("fjEgq");


var $fESy2 = parcelRequire("fESy2");


var $KvxxC = parcelRequire("KvxxC");

const $47ec9d0552b9fc57$var$styles = {
    menuPortal: "_42Yu6BA6TK",
    fieldStack: "_39xV02N91d",
    scheduleRow: "_2mHwu88HPE _3iDTPbgBM8 _39xV02N91d _0hPCNL7p2s _2iEGP28wUV",
    scheduleRowDouble: "_2mHwu88HPE _3iDTPbgBM8 _39xV02N91d _0hPCNL7p2s _2iEGP27s7Z",
    scheduleRowTriple: "_2mHwu88HPE _3iDTPbgBM8 _39xV02N91d _0hPCNL7p2s _2iEGP2byVk",
    scheduleField: "_4ouGXIdnbC"
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $47ec9d0552b9fc57$var$DayMultiOption = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isSelected: isSelected } = props;
    const t0 = children;
    let t1;
    if ($[0] !== isSelected || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            isChecked: isSelected,
            label: t0
        });
        $[0] = isSelected;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, t1);
        $[3] = props;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (props)=>{
    const { children: children, isSelected: isSelected } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: isSelected,
        label: children
    }));
};
const $47ec9d0552b9fc57$export$bad383a0d030be0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(92);
    const { formatMessage: formatMessage, formatDate: formatDate, readonly: readonly, isActionLoading: isActionLoading, name: name, prompt: prompt, frequency: frequency, daysOfWeek: daysOfWeek, time: time, onNameChange: onNameChange, onPromptChange: onPromptChange, onFrequencyChange: onFrequencyChange, onDaysOfWeekChange: onDaysOfWeekChange, onTimeChange: onTimeChange } = t0;
    let frequencyOptions;
    let t1;
    if ($[0] !== formatMessage || $[1] !== frequency) {
        let t2;
        if ($[4] !== formatMessage) {
            t2 = (freq)=>({
                    value: freq,
                    label: (0, $KvxxC.frequencyLabelFor)(freq, formatMessage)
                });
            $[4] = formatMessage;
            $[5] = t2;
        } else t2 = $[5];
        frequencyOptions = (0, $fjEgq.FREQUENCY_VALUES).map(t2);
        let t3;
        if ($[6] !== frequency) {
            t3 = (opt)=>opt.value === frequency;
            $[6] = frequency;
            $[7] = t3;
        } else t3 = $[7];
        t1 = frequencyOptions.find(t3);
        $[0] = formatMessage;
        $[1] = frequency;
        $[2] = frequencyOptions;
        $[3] = t1;
    } else {
        frequencyOptions = $[2];
        t1 = $[3];
    }
    const selectedFrequency = t1;
    let dayOptions;
    let t2;
    if ($[8] !== daysOfWeek || $[9] !== formatDate) {
        let t3;
        if ($[12] !== formatDate) {
            t3 = (day)=>({
                    value: day,
                    label: (0, $KvxxC.weekdayLabelFor)(day, formatDate)
                });
            $[12] = formatDate;
            $[13] = t3;
        } else t3 = $[13];
        dayOptions = (0, $SJBPH.SCHEDULED_CHAT_DAYS).map(t3);
        let t4;
        if ($[14] !== daysOfWeek) {
            t4 = (opt_0)=>daysOfWeek.includes(opt_0.value);
            $[14] = daysOfWeek;
            $[15] = t4;
        } else t4 = $[15];
        t2 = dayOptions.filter(t4);
        $[8] = daysOfWeek;
        $[9] = formatDate;
        $[10] = dayOptions;
        $[11] = t2;
    } else {
        dayOptions = $[10];
        t2 = $[11];
    }
    const selectedCustomDays = t2;
    const isCustom = frequency === "custom";
    const isHourly = frequency === "hourly";
    const showTimeField = !isHourly;
    const showCustomDaysField = isCustom;
    let t3;
    if ($[16] !== formatMessage) {
        t3 = formatMessage((0, $fESy2.default).scheduledChatNameLabel);
        $[16] = formatMessage;
        $[17] = t3;
    } else t3 = $[17];
    const t4 = t3;
    let t5;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null);
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "scheduled-chat-name"
        }, t4, t5);
        $[19] = t4;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== onNameChange) {
        t7 = (e)=>onNameChange(e.currentTarget.value);
        $[21] = onNameChange;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== formatMessage) {
        t8 = formatMessage((0, $fESy2.default).scheduledChatNamePlaceholder);
        $[23] = formatMessage;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== isActionLoading || $[26] !== name || $[27] !== readonly || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            id: "scheduled-chat-name",
            testId: "scheduled-chat-name",
            value: name,
            onChange: t7,
            placeholder: t8,
            isReadOnly: readonly,
            isDisabled: isActionLoading
        });
        $[25] = isActionLoading;
        $[26] = name;
        $[27] = readonly;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== t6 || $[32] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t6, t9);
        $[31] = t6;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    let t11;
    if ($[34] !== formatMessage) {
        t11 = formatMessage((0, $fESy2.default).promptLabel);
        $[34] = formatMessage;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "scheduled-chat-prompt"
        }, t11);
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== onPromptChange) {
        t13 = (e_0)=>onPromptChange(e_0.currentTarget.value);
        $[38] = onPromptChange;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== formatMessage) {
        t14 = formatMessage((0, $fESy2.default).promptPlaceholder);
        $[40] = formatMessage;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== isActionLoading || $[43] !== prompt || $[44] !== readonly || $[45] !== t13 || $[46] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            id: "scheduled-chat-prompt",
            testId: "scheduled-chat-prompt",
            value: prompt,
            onChange: t13,
            placeholder: t14,
            isReadOnly: readonly,
            isDisabled: isActionLoading,
            minimumRows: 4
        });
        $[42] = isActionLoading;
        $[43] = prompt;
        $[44] = readonly;
        $[45] = t13;
        $[46] = t14;
        $[47] = t15;
    } else t15 = $[47];
    let t16;
    if ($[48] !== t12 || $[49] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t12, t15);
        $[48] = t12;
        $[49] = t15;
        $[50] = t16;
    } else t16 = $[50];
    const t17 = isHourly ? $47ec9d0552b9fc57$var$styles.scheduleRow : isCustom ? $47ec9d0552b9fc57$var$styles.scheduleRowTriple : $47ec9d0552b9fc57$var$styles.scheduleRowDouble;
    let t18;
    if ($[51] !== formatMessage) {
        t18 = formatMessage((0, $fESy2.default).frequencyLabel);
        $[51] = formatMessage;
        $[52] = t18;
    } else t18 = $[52];
    let t19;
    if ($[53] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "scheduled-chat-frequency"
        }, t18);
        $[53] = t18;
        $[54] = t19;
    } else t19 = $[54];
    let t20;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = {
            MenuPortal: $47ec9d0552b9fc57$var$_temp
        };
        $[55] = t20;
    } else t20 = $[55];
    let t21;
    if ($[56] !== daysOfWeek || $[57] !== onDaysOfWeekChange || $[58] !== onFrequencyChange) {
        t21 = (opt_1)=>{
            const next = opt_1?.value;
            if (typeof next === "string") {
                const nextFrequency = next;
                onFrequencyChange(nextFrequency);
                if (nextFrequency === "custom" && daysOfWeek.length === 0) onDaysOfWeekChange([
                    (0, $SJBPH.SCHEDULED_CHAT_DAYS)[0]
                ]);
            }
        };
        $[56] = daysOfWeek;
        $[57] = onDaysOfWeekChange;
        $[58] = onFrequencyChange;
        $[59] = t21;
    } else t21 = $[59];
    const t22 = readonly || isActionLoading;
    let t23;
    if ($[60] !== frequencyOptions || $[61] !== selectedFrequency || $[62] !== t21 || $[63] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            inputId: "scheduled-chat-frequency",
            testId: "scheduled-chat-frequency",
            menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
            components: t20,
            options: frequencyOptions,
            value: selectedFrequency,
            onChange: t21,
            isDisabled: t22
        });
        $[60] = frequencyOptions;
        $[61] = selectedFrequency;
        $[62] = t21;
        $[63] = t22;
        $[64] = t23;
    } else t23 = $[64];
    let t24;
    if ($[65] !== t19 || $[66] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            xcss: $47ec9d0552b9fc57$var$styles.scheduleField
        }, t19, t23);
        $[65] = t19;
        $[66] = t23;
        $[67] = t24;
    } else t24 = $[67];
    let t25;
    if ($[68] !== dayOptions || $[69] !== formatMessage || $[70] !== isActionLoading || $[71] !== onDaysOfWeekChange || $[72] !== readonly || $[73] !== selectedCustomDays || $[74] !== showCustomDaysField) {
        t25 = showCustomDaysField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            xcss: $47ec9d0552b9fc57$var$styles.scheduleField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "scheduled-chat-days"
        }, formatMessage((0, $fESy2.default).daysLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            inputId: "scheduled-chat-days",
            testId: "scheduled-chat-days",
            menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
            isMulti: true,
            isClearable: false,
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            options: dayOptions,
            value: selectedCustomDays,
            components: {
                Option: $47ec9d0552b9fc57$var$DayMultiOption,
                MenuPortal: $47ec9d0552b9fc57$var$_temp2
            },
            onChange: (selected)=>{
                const nextValues = Array.isArray(selected) ? selected.map($47ec9d0552b9fc57$var$_temp3).filter($47ec9d0552b9fc57$var$_temp4) : [];
                const nextSet = new Set(nextValues);
                onDaysOfWeekChange((0, $SJBPH.SCHEDULED_CHAT_DAYS).filter((day_0)=>nextSet.has(day_0)));
            },
            isDisabled: readonly || isActionLoading
        })) : null;
        $[68] = dayOptions;
        $[69] = formatMessage;
        $[70] = isActionLoading;
        $[71] = onDaysOfWeekChange;
        $[72] = readonly;
        $[73] = selectedCustomDays;
        $[74] = showCustomDaysField;
        $[75] = t25;
    } else t25 = $[75];
    let t26;
    if ($[76] !== formatMessage || $[77] !== isActionLoading || $[78] !== onTimeChange || $[79] !== readonly || $[80] !== showTimeField || $[81] !== time) {
        t26 = showTimeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050",
            xcss: $47ec9d0552b9fc57$var$styles.scheduleField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "scheduled-chat-time"
        }, formatMessage((0, $fESy2.default).timeLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sqHc.default), {
            id: "scheduled-chat-time",
            testId: "scheduled-chat-time",
            label: "",
            value: time,
            onChange: (next_0)=>onTimeChange(next_0),
            isDisabled: readonly || isActionLoading,
            timeIsEditable: true,
            selectProps: {
                isClearable: false
            }
        })) : null;
        $[76] = formatMessage;
        $[77] = isActionLoading;
        $[78] = onTimeChange;
        $[79] = readonly;
        $[80] = showTimeField;
        $[81] = time;
        $[82] = t26;
    } else t26 = $[82];
    let t27;
    if ($[83] !== t17 || $[84] !== t24 || $[85] !== t25 || $[86] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t17
        }, t24, t25, t26);
        $[83] = t17;
        $[84] = t24;
        $[85] = t25;
        $[86] = t26;
        $[87] = t27;
    } else t27 = $[87];
    let t28;
    if ($[88] !== t10 || $[89] !== t16 || $[90] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $47ec9d0552b9fc57$var$styles.fieldStack
        }, t10, t16, t27);
        $[88] = t10;
        $[89] = t16;
        $[90] = t27;
        $[91] = t28;
    } else t28 = $[91];
    return t28;
} : ({ formatMessage: formatMessage, formatDate: formatDate, readonly: readonly, isActionLoading: isActionLoading, name: name, prompt: prompt, frequency: frequency, daysOfWeek: daysOfWeek, time: time, onNameChange: onNameChange, onPromptChange: onPromptChange, onFrequencyChange: onFrequencyChange, onDaysOfWeekChange: onDaysOfWeekChange, onTimeChange: onTimeChange })=>{
    const frequencyOptions = (0, $fjEgq.FREQUENCY_VALUES).map((freq)=>({
            value: freq,
            label: (0, $KvxxC.frequencyLabelFor)(freq, formatMessage)
        }));
    const selectedFrequency = frequencyOptions.find((opt)=>opt.value === frequency);
    const dayOptions = (0, $SJBPH.SCHEDULED_CHAT_DAYS).map((day)=>({
            value: day,
            label: (0, $KvxxC.weekdayLabelFor)(day, formatDate)
        }));
    const selectedCustomDays = dayOptions.filter((opt_0)=>daysOfWeek.includes(opt_0.value));
    const isCustom = frequency === 'custom';
    const isHourly = frequency === 'hourly';
    const showTimeField = !isHourly;
    const showCustomDaysField = isCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $47ec9d0552b9fc57$var$styles.fieldStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "scheduled-chat-name"
    }, formatMessage((0, $fESy2.default).scheduledChatNameLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: "scheduled-chat-name",
        testId: "scheduled-chat-name",
        value: name,
        onChange: (e)=>onNameChange(e.currentTarget.value),
        placeholder: formatMessage((0, $fESy2.default).scheduledChatNamePlaceholder),
        isReadOnly: readonly,
        isDisabled: isActionLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "scheduled-chat-prompt"
    }, formatMessage((0, $fESy2.default).promptLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        id: "scheduled-chat-prompt",
        testId: "scheduled-chat-prompt",
        value: prompt,
        onChange: (e_0)=>onPromptChange(e_0.currentTarget.value),
        placeholder: formatMessage((0, $fESy2.default).promptPlaceholder),
        isReadOnly: readonly,
        isDisabled: isActionLoading,
        minimumRows: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isHourly ? $47ec9d0552b9fc57$var$styles.scheduleRow : isCustom ? $47ec9d0552b9fc57$var$styles.scheduleRowTriple : $47ec9d0552b9fc57$var$styles.scheduleRowDouble
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $47ec9d0552b9fc57$var$styles.scheduleField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "scheduled-chat-frequency"
    }, formatMessage((0, $fESy2.default).frequencyLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        inputId: "scheduled-chat-frequency",
        testId: "scheduled-chat-frequency",
        menuPortalTarget: typeof document !== 'undefined' ? document.body : undefined,
        components: {
            MenuPortal: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuPortal, {
                    ...props,
                    xcss: $47ec9d0552b9fc57$var$styles.menuPortal
                })
        },
        options: frequencyOptions,
        value: selectedFrequency,
        onChange: (opt_1)=>{
            const next = opt_1?.value;
            if (typeof next === 'string') {
                const nextFrequency = next;
                onFrequencyChange(nextFrequency);
                if (nextFrequency === 'custom' && daysOfWeek.length === 0) onDaysOfWeekChange([
                    (0, $SJBPH.SCHEDULED_CHAT_DAYS)[0]
                ]);
            }
        },
        isDisabled: readonly || isActionLoading
    })), showCustomDaysField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $47ec9d0552b9fc57$var$styles.scheduleField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "scheduled-chat-days"
    }, formatMessage((0, $fESy2.default).daysLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        inputId: 'scheduled-chat-days',
        testId: 'scheduled-chat-days',
        menuPortalTarget: typeof document !== 'undefined' ? document.body : undefined,
        isMulti: true,
        isClearable: false,
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        options: dayOptions,
        value: selectedCustomDays,
        components: {
            Option: $47ec9d0552b9fc57$var$DayMultiOption,
            MenuPortal: (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuPortal, {
                    ...props_0,
                    xcss: $47ec9d0552b9fc57$var$styles.menuPortal
                })
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange: (selected)=>{
            const nextValues = Array.isArray(selected) ? selected // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((option)=>option.value).filter((value)=>typeof value === 'string' && (0, $SJBPH.SCHEDULED_CHAT_DAYS).includes(value)) : [];
            const nextSet = new Set(nextValues);
            onDaysOfWeekChange((0, $SJBPH.SCHEDULED_CHAT_DAYS).filter((day_0)=>nextSet.has(day_0)));
        },
        isDisabled: readonly || isActionLoading // eslint-disable-next-line @typescript-eslint/no-explicit-any
    })) : null, showTimeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $47ec9d0552b9fc57$var$styles.scheduleField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "scheduled-chat-time"
    }, formatMessage((0, $fESy2.default).timeLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sqHc.default), {
        id: "scheduled-chat-time",
        testId: "scheduled-chat-time",
        label: "",
        value: time,
        onChange: (next_0)=>onTimeChange(next_0),
        isDisabled: readonly || isActionLoading,
        timeIsEditable: true,
        selectProps: {
            isClearable: false
        }
    })) : null));
};
function $47ec9d0552b9fc57$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuPortal, {
        ...props,
        xcss: $47ec9d0552b9fc57$var$styles.menuPortal
    });
}
function $47ec9d0552b9fc57$var$_temp2(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuPortal, {
        ...props_0,
        xcss: $47ec9d0552b9fc57$var$styles.menuPortal
    });
}
function $47ec9d0552b9fc57$var$_temp3(option) {
    return option.value;
}
function $47ec9d0552b9fc57$var$_temp4(value) {
    return typeof value === "string" && (0, $SJBPH.SCHEDULED_CHAT_DAYS).includes(value);
}
module.exports["ScheduledChatFormFields"] = $47ec9d0552b9fc57$export$bad383a0d030be0;

});

parcelRegister("2c3E0", function(module, exports) {
/**
 * In-memory LRU cache for storing File objects by their ID.
 * Used to enable thumbnail display after a message is sent (within the same session).
 *
 * Max cache size of 100 files to prevent excessive memory usage.
 */ class $8d19f6098af8da03$var$FileCache {
    set(id, file) {
        if (this.cache.has(id)) this.accessOrder = this.accessOrder.filter((existingId)=>existingId !== id);
        this.cache.set(id, file);
        this.accessOrder.push(id);
        if (this.cache.size > this.maxSize) {
            const lruId = this.accessOrder.shift();
            if (lruId) this.cache.delete(lruId);
        }
    }
    get(id) {
        const file = this.cache.get(id);
        if (file) {
            this.accessOrder = this.accessOrder.filter((existingId)=>existingId !== id);
            this.accessOrder.push(id);
        }
        return file;
    }
    delete(id) {
        this.cache.delete(id);
        this.accessOrder = this.accessOrder.filter((existingId)=>existingId !== id);
    }
    clear() {
        this.cache.clear();
        this.accessOrder = [];
    }
    constructor(){
        this.cache = new Map();
        this.accessOrder = [];
        this.maxSize = 100;
    }
}
const $8d19f6098af8da03$export$5c1f80f928f4efcd = new $8d19f6098af8da03$var$FileCache();
module.exports["fileCache"] = $8d19f6098af8da03$export$5c1f80f928f4efcd;

});

parcelRegister("hVu9y", function(module, exports) {
const $dab591e1852df37c$export$4c9ccf8a18d8ec6e = {
    override: null,
    setOverride: ()=>{}
};
module.exports["backBehaviorOverrideDefaultValue"] = $dab591e1852df37c$export$4c9ccf8a18d8ec6e;

});

parcelRegister("6qEY9", function(module, exports) {

var $28dO3 = parcelRequire("28dO3");

const $80497cf038e22e03$export$62617f3d98f45616 = ({ messageId: messageId, content: content, title: title = 'Research Plan', roundId: roundId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        // Set the research plan on the message
        setState({
            ...currentState,
            [messageId]: {
                ...message ?? {
                    currentProgress: (0, $28dO3.STARTING_PROGRESS),
                    steps: {},
                    researchPlans: {}
                },
                researchPlans: {
                    ...message?.researchPlans,
                    [roundId]: {
                        title: title,
                        content: content,
                        roundId: roundId
                    }
                }
            }
        });
    };
module.exports["addResearchPlan"] = $80497cf038e22e03$export$62617f3d98f45616;

});

parcelRegister("agNYn", function(module, exports) {

var $764BO = parcelRequire("764BO");

const $52c6649b0e0b7a84$export$a55635553828f889 = ({ messageId: messageId, stepId: stepId, content: content, isStreamed: isStreamed, immediate: immediate, roundId: roundId })=>({ dispatch: dispatch })=>{
        dispatch((0, $764BO.updateStep)({
            messageId: messageId,
            stepId: stepId,
            updater: (step, isNewStep)=>{
                // Concat once and reuse to halve per-event allocation.
                const concatenatedContent = (step.content ?? '') + content;
                // streamed: single concatenated child; non-streamed: each chunk as a separate array item
                const separatedContent = isStreamed ? [
                    concatenatedContent
                ] : [
                    ...step.separatedContent,
                    content
                ];
                return {
                    ...step,
                    roundId: roundId,
                    content: concatenatedContent,
                    separatedContent: separatedContent,
                    immediate: immediate,
                    // If a step content arrives for a step that was never introduced with a title,
                    // consider it completed immediately — it's an orphan content step that won't
                    // receive a RESEARCH_STEP_COMPLETE message.
                    // Otherwise, it cannot be complete if we're still appending content.
                    completed: isNewStep && !step.title ? true : false,
                    isStreamed: // Track whether this step's content is streamed or discrete
                    isStreamed
                };
            }
        }));
    };
module.exports["appendStepContent"] = $52c6649b0e0b7a84$export$a55635553828f889;

});

parcelRegister("lSlzj", function(module, exports) {

var $764BO = parcelRequire("764BO");

const $c0ef94996608e7a5$export$7d99c23b07ac0974 = ({ messageId: messageId, stepId: stepId, document: document })=>({ dispatch: dispatch })=>{
        dispatch((0, $764BO.updateStep)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    documents: [
                        ...step.documents ?? [],
                        document
                    ]
                })
        }));
    };
module.exports["appendStepDocument"] = $c0ef94996608e7a5$export$7d99c23b07ac0974;

});

parcelRegister("28iKH", function(module, exports) {
const $627ddeb671c41e26$export$872f148557cf8bf5 = 0.001;
module.exports["ARTIFICIAL_PROGRESS_RATE"] = $627ddeb671c41e26$export$872f148557cf8bf5;

});

parcelRegister("6eAtL", function(module, exports) {

var $3CoEp = parcelRequire("3CoEp");

const $bc7bf914d1a438d1$export$4c442435645f2043 = (currentProgress, weight = (0, $3CoEp.STEP_WEIGHT))=>Math.min(0.95, currentProgress + 0.95 * weight);
module.exports["ceiledIncrement"] = $bc7bf914d1a438d1$export$4c442435645f2043;

});

parcelRegister("4bR59", function(module, exports) {
const $6a418f740b9b0640$export$2e0130e7f5800320 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        if (message && !message.researchCompleted) {
            const updatedSteps = Object.entries(message.steps).reduce((acc, [stepId, step])=>({
                    ...acc,
                    [stepId]: {
                        ...step,
                        completed: true
                    }
                }), {});
            setState({
                ...currentState,
                [messageId]: {
                    ...message,
                    steps: updatedSteps,
                    currentProgress: undefined,
                    researchCompleted: true
                }
            });
        }
    };
module.exports["completeAllSteps"] = $6a418f740b9b0640$export$2e0130e7f5800320;

});

parcelRegister("bhC2w", function(module, exports) {

var $28dO3 = parcelRequire("28dO3");

const $a874628146faf38d$export$fd530ec9d7995e3e = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (!message) setState({
            [messageId]: {
                currentProgress: (0, $28dO3.STARTING_PROGRESS),
                steps: {},
                researchPlans: {}
            }
        });
    };
module.exports["initResearchMessage"] = $a874628146faf38d$export$fd530ec9d7995e3e;

});

parcelRegister("7ba4g", function(module, exports) {
const $af1e39fe228c220f$export$6514c23d684eadd8 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (message && !message.hasReceivedAnswerPart) setState({
            [messageId]: {
                ...message,
                hasReceivedAnswerPart: true
            }
        });
    };
module.exports["markAnswerPartReceived"] = $af1e39fe228c220f$export$6514c23d684eadd8;

});

parcelRegister("9ay61", function(module, exports) {
const $0fd66ab30ab57c5a$export$8f77fbc4cfe15534 = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        if (message && message.hasReceivedAnswerPart) setState({
            [messageId]: {
                ...message,
                hasReceivedAnswerPart: false
            }
        });
    };
module.exports["resetHasReceivedAnswerPart"] = $0fd66ab30ab57c5a$export$8f77fbc4cfe15534;

});

parcelRegister("5xVNS", function(module, exports) {
const $06f681cd30867526$export$5cf35e65df857124 = ({ messageId: messageId, triggered: triggered })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        setState({
            [messageId]: {
                ...message ?? {
                    steps: {},
                    researchPlans: {}
                },
                hasThinkDeeperTriggered: triggered
            }
        });
    };
module.exports["setHasThinkDeeperTriggered"] = $06f681cd30867526$export$5cf35e65df857124;

});

parcelRegister("3w05Y", function(module, exports) {
const $5ff0c09ec43395a4$export$d035a949bdd52aff = ({ messageId: messageId })=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const message = currentState[messageId];
        setState({
            [messageId]: {
                ...message ?? {
                    steps: {},
                    researchPlans: {}
                },
                isDeepResearch: true
            }
        });
    };
module.exports["setIsDeepResearch"] = $5ff0c09ec43395a4$export$d035a949bdd52aff;

});

parcelRegister("hpptZ", function(module, exports) {

var $764BO = parcelRequire("764BO");

const $8d246a514926505b$export$b9aadbf5032a78e5 = ({ messageId: messageId, stepId: stepId, sourceIcons: sourceIcons })=>({ dispatch: dispatch })=>{
        dispatch((0, $764BO.updateStep)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    sourceIcons: sourceIcons
                })
        }));
    };
module.exports["setStepSourceIcons"] = $8d246a514926505b$export$b9aadbf5032a78e5;

});

parcelRegister("17TPK", function(module, exports) {

var $764BO = parcelRequire("764BO");

const $445c0b1f98ced811$export$32f8a965bfa76f84 = ({ messageId: messageId, stepId: stepId, sources: sources })=>({ dispatch: dispatch })=>{
        dispatch((0, $764BO.updateStep)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    sources: sources
                })
        }));
    };
module.exports["setStepSources"] = $445c0b1f98ced811$export$32f8a965bfa76f84;

});

parcelRegister("fSEmd", function(module, exports) {

var $764BO = parcelRequire("764BO");

const $37e6411255737e57$export$f6ef21396b0d3d6d = ({ messageId: messageId, stepId: stepId, title: title, roundId: roundId, immediate: immediate, isSkill: isSkill = false, toolIcon: toolIcon, toolName: toolName })=>({ dispatch: dispatch })=>{
        dispatch((0, $764BO.updateStep)({
            messageId: messageId,
            stepId: stepId,
            updater: (step)=>({
                    ...step,
                    title: title,
                    roundId: roundId,
                    isSkill: isSkill,
                    immediate: immediate,
                    completed: false,
                    toolIcon: toolIcon,
                    toolName: toolName
                })
        }));
    };
module.exports["setStepTitle"] = $37e6411255737e57$export$f6ef21396b0d3d6d;

});

parcelRegister("28dO3", function(module, exports) {
const $0ae2e85c06c407f6$export$d4032e5b8e7b1dac = 0.01;
module.exports["STARTING_PROGRESS"] = $0ae2e85c06c407f6$export$d4032e5b8e7b1dac;

});

parcelRegister("764BO", function(module, exports) {

var $6eAtL = parcelRequire("6eAtL");


var $lNAt2 = parcelRequire("lNAt2");


var $28dO3 = parcelRequire("28dO3");

const $37a7a07adcd579ae$export$b9dd42b4e24f01b4 = ({ messageId: messageId, stepId: stepId, updater: updater })=>({ getState: getState, setState: setState })=>{
        const message = getState()[messageId];
        const step = message?.steps[stepId];
        const isNewStep = !step;
        // reuse existing order if the step exists, otherwise create a new one with the next order
        const order = step?.order ?? (0, $lNAt2.getLastStepOrder)(Object.values(message?.steps ?? {})) + 1;
        const separatedContent = step?.separatedContent ?? [];
        const updatedStep = updater({
            ...message?.steps[stepId],
            separatedContent: separatedContent,
            stepId: stepId,
            order: order
        }, isNewStep);
        setState({
            [messageId]: {
                ...message ?? {
                    currentProgress: (0, $28dO3.STARTING_PROGRESS)
                },
                steps: {
                    ...message?.steps,
                    [stepId]: updatedStep
                },
                // Consider total researchCompleted:false if any step is updated to completed:false
                // This covers any new rounds that may stream in after the others have been completed
                ...!updatedStep.completed ? {
                    researchCompleted: false
                } : {},
                ...updatedStep.completed ? {
                    currentProgress: (0, $6eAtL.ceiledIncrement)(message?.currentProgress ?? (0, $28dO3.STARTING_PROGRESS))
                } : {}
            }
        });
    };
module.exports["updateStep"] = $37a7a07adcd579ae$export$b9dd42b4e24f01b4;

});

parcelRegister("lfYWT", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $ccS36 = parcelRequire("ccS36");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("7nLGD");
var $2MPqa = parcelRequire("2MPqa");


var $2OMPZ = parcelRequire("2OMPZ");

class $f79a46dc07025615$var$Redirector extends (0, $cozmU.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $lI7ls.createPath)((0, $2MPqa.generateLocationFromPath)(to.path, routeAttributes)) : (0, $lI7ls.createPath)(to) : to;
        const currentPath = (0, $lI7ls.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ccS36.default)($f79a46dc07025615$var$Redirector, "defaultProps", {
    push: false
});
const $f79a46dc07025615$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $2OMPZ.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f79a46dc07025615$var$Redirector, (0, $eb3ax.default)({
        actions: actions,
        location: location
    }, props));
};

});

parcelRegister("5rI5d", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");


var $bBrxp = parcelRequire("bBrxp");

const $3f71ab5ee3b89287$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBrxp.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $3f71ab5ee3b89287$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $cozmU.useMemo)(()=>(0, $lI7ls.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3f71ab5ee3b89287$export$55185c17a0fcbe46, (0, $eb3ax.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("fi2Nk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkLpw = parcelRequire("kkLpw");

const $b21ab4669cde867b$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $kkLpw.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
};
$b21ab4669cde867b$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("3Xv6j", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");

parcelRequire("7nLGD");
var $1HIWn = parcelRequire("1HIWn");


var $bBrxp = parcelRequire("bBrxp");

const $2e1f01bcef6f941c$var$_excluded = [
    "listen"
];
const $2e1f01bcef6f941c$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $bBrxp.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1eVGO.default)(_ref, $2e1f01bcef6f941c$var$_excluded);
    if (!state.unlisten && !(0, $1HIWn.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
};

});

parcelRegister("4zVkh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $bBrxp = parcelRequire("bBrxp");

const $3556e613e925e32d$var$createPathParamHook = (0, $kBr4q.createHook)((0, $bBrxp.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $3556e613e925e32d$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $3556e613e925e32d$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("h4TbX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $bBrxp = parcelRequire("bBrxp");

const $c6ed9f537933475b$var$createQueryParamHook = (0, $kBr4q.createHook)((0, $bBrxp.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $c6ed9f537933475b$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $c6ed9f537933475b$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("2OMPZ", function(module, exports) {

var $bBrxp = parcelRequire("bBrxp");

const $20d62268ffa187b8$export$9a302a45f65d0572 = (0, $bBrxp.useRouterStore);
module.exports["useRouter"] = $20d62268ffa187b8$export$9a302a45f65d0572;

});

parcelRegister("kkLpw", function(module, exports) {

var $bBrxp = parcelRequire("bBrxp");

const $ecda73a873049d3f$export$402e82ff1b20594b = (0, $bBrxp.useRouterStoreActions);
module.exports["useRouterActions"] = $ecda73a873049d3f$export$402e82ff1b20594b;

});

parcelRegister("3klhU", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $bBrxp = parcelRequire("bBrxp");

const $26c3c0b196cb688e$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $26c3c0b196cb688e$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $26c3c0b196cb688e$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $bBrxp.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("5SM4Y", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("7nLGD");
var $6R2v1 = parcelRequire("6R2v1");
var $2MPqa = parcelRequire("2MPqa");


var $bBrxp = parcelRequire("bBrxp");




const $4b9a15468ce772dd$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $cozmU.useRef)();
    const schedule = (0, $cozmU.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $cozmU.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};





var $eOncg = parcelRequire("eOncg");


var $SgG5A = parcelRequire("SgG5A");



const $44874a68812b7528$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $44874a68812b7528$var$PREFETCH_DELAY = 225;
const $44874a68812b7528$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1eVGO.default)(_ref, $44874a68812b7528$var$_excluded);
    const routerActions = (0, $bBrxp.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $4b9a15468ce772dd$export$d8e6abf214c9ec0f)($44874a68812b7528$var$PREFETCH_DELAY);
    const validLinkType = (0, $eOncg.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $cozmU.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $lI7ls.createPath)((0, $2MPqa.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $6R2v1.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $SgG5A.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $cozmU.createElement)(validLinkType, (0, $eb3ax.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$44874a68812b7528$var$Link.displayName = 'Link';
var $44874a68812b7528$export$2e2bcd8739ae039 = $44874a68812b7528$var$Link;
module.exports["default"] = $44874a68812b7528$export$2e2bcd8739ae039;

});

parcelRegister("4Vdw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("f8GSD");
var $2OMPZ = parcelRequire("2OMPZ");

const $3956f884be1d184a$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $2OMPZ.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("hW5be", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $7SeeH = parcelRequire("7SeeH");


var $eO7Xs = parcelRequire("eO7Xs");

const $d0ebdf1bdff90fd5$var$hasWindow = ()=>typeof window !== 'undefined';
const $d0ebdf1bdff90fd5$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $d0ebdf1bdff90fd5$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $d0ebdf1bdff90fd5$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $d0ebdf1bdff90fd5$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($7SeeH)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $d0ebdf1bdff90fd5$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $d0ebdf1bdff90fd5$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $d0ebdf1bdff90fd5$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $eb3ax.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $d0ebdf1bdff90fd5$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $d0ebdf1bdff90fd5$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $d0ebdf1bdff90fd5$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
        createHref: (location)=>(0, $lI7ls.createPath)(location)
    } : $d0ebdf1bdff90fd5$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $d0ebdf1bdff90fd5$export$883c3f3b6c000133;

});

parcelRegister("2MPqa", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");


var $4NiRC = parcelRequire("4NiRC");

function $2077f39fa2c2945f$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $2077f39fa2c2945f$export$37e0729cc751960b;

});

parcelRegister("4dkdA", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");

const $31180f33cfbc3bc1$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
module.exports["generatePath"] = $31180f33cfbc3bc1$export$82476f982757e71e;

});

parcelRegister("1HIWn", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $1P2f3 = parcelRequire("1P2f3");

const $13dcaad93a1827a8$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $13dcaad93a1827a8$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $1P2f3 !== 'undefined' && $1P2f3.versions != null && $1P2f3.versions.node != null) return true;
    if ($13dcaad93a1827a8$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $13dcaad93a1827a8$export$455cc18296abe008;

});

parcelRegister("3bnxh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2514a7e01fad6124$export$2e2bcd8739ae039);

var $4NiRC = parcelRequire("4NiRC");


var $eb3ax = parcelRequire("eb3ax");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6XX9c = parcelRequire("6XX9c");

const $a4df6f5f3f26ced2$var$cache = {};
const $a4df6f5f3f26ced2$var$cacheLimit = 10000;
let $a4df6f5f3f26ced2$var$cacheCount = 0;
function $a4df6f5f3f26ced2$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $a4df6f5f3f26ced2$var$cache[cacheKey] || ($a4df6f5f3f26ced2$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6XX9c.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($a4df6f5f3f26ced2$var$cacheCount < $a4df6f5f3f26ced2$var$cacheLimit) {
        pathCache[path] = result;
        $a4df6f5f3f26ced2$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $a4df6f5f3f26ced2$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $a4df6f5f3f26ced2$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $a4df6f5f3f26ced2$export$2e2bcd8739ae039 = $a4df6f5f3f26ced2$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $f9bf0b400cc4f4e2$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $eb3ax.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $f9bf0b400cc4f4e2$export$2e2bcd8739ae039 = $f9bf0b400cc4f4e2$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $85e1d56ec4517d72$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $85e1d56ec4517d72$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $a4df6f5f3f26ced2$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $85e1d56ec4517d72$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $f9bf0b400cc4f4e2$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $eb3ax.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $85e1d56ec4517d72$export$2e2bcd8739ae039 = $85e1d56ec4517d72$var$execRouteMatching;


const $14ba6fbf0eaa30a5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $14ba6fbf0eaa30a5$var$MAX_CACHE_SIZE = 1000;
function $14ba6fbf0eaa30a5$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$14ba6fbf0eaa30a5$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $14ba6fbf0eaa30a5$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($14ba6fbf0eaa30a5$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $14ba6fbf0eaa30a5$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $14ba6fbf0eaa30a5$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $2514a7e01fad6124$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $4NiRC.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $14ba6fbf0eaa30a5$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $85e1d56ec4517d72$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $14ba6fbf0eaa30a5$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $2514a7e01fad6124$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$2514a7e01fad6124$var$matchRoute(routes, pathname, queryParams, basePath);
const $2514a7e01fad6124$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $2514a7e01fad6124$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $2514a7e01fad6124$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$2514a7e01fad6124$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $2514a7e01fad6124$export$4e76f1d455ef7c95;

});

parcelRegister("6R2v1", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");


var $6ZZh7 = parcelRequire("6ZZh7");


var $4dkdA = parcelRequire("4dkdA");


var $3bnxh = parcelRequire("3bnxh");

const $4fd9a1a7528d60ec$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $4dkdA.generatePath)(route.path, params);
    const matchedRoute = (0, $3bnxh.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $6ZZh7.DEFAULT_MATCH),
        query: query
    };
};
const $4fd9a1a7528d60ec$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $4NiRC.qs).parse(search);
    const matchedRoute = (0, $3bnxh.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $6ZZh7.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $6ZZh7.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $4fd9a1a7528d60ec$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $4fd9a1a7528d60ec$export$a0bd0313cbeabd49;

});

parcelRegister("lk3rn", function(module, exports) {
const $f85e2270d8bae6ba$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $f85e2270d8bae6ba$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f85e2270d8bae6ba$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f85e2270d8bae6ba$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
module.exports["isSameRouteMatch"] = $f85e2270d8bae6ba$export$5997e70fc4543270;

});

parcelRegister("22qkM", function(module, exports) {

var $5HsaE = parcelRequire("5HsaE");

parcelRequire("lRtsS");
var $6HMxd = parcelRequire("6HMxd");

const $17c0321b7f856dab$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $17c0321b7f856dab$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $5HsaE.getResourceStore)().actions;
    const nextResources = (0, $6HMxd.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $17c0321b7f856dab$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $5HsaE.getResourceStore)().actions;
    const nextResources = (0, $6HMxd.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $17c0321b7f856dab$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $5HsaE.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $17c0321b7f856dab$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $17c0321b7f856dab$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $17c0321b7f856dab$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $5HsaE.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $5HsaE.getResourceStore)().actions;
            const nextResources = (0, $6HMxd.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $5HsaE.getResourceStore)().actions.getSafeData();
        }
    };
};

});

parcelRegister("iMCza", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iX7oN = parcelRequire("iX7oN");

const $dacaa02203baac79$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $iX7oN.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
};

});

parcelRegister("iX7oN", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $bBrxp = parcelRequire("bBrxp");


var $5HsaE = parcelRequire("5HsaE");

const $dcc379f656a919ae$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $5HsaE.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $bBrxp.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $cozmU.useMemo)(()=>(0, $kBr4q.createHook)((0, $bBrxp.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $5HsaE.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $cozmU.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $cozmU.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $cozmU.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eb3ax.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $dcc379f656a919ae$export$9f6abfd74295843b;

});

parcelRegister("1UAja", function(module, exports) {

var $5HsaE = parcelRequire("5HsaE");

const $16472f6f9d79b719$export$dee7bf9fc0ff48c3 = (fn)=>(0, $5HsaE.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("5HsaE", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");

parcelRequire("7nLGD");
var $1HIWn = parcelRequire("1HIWn");




parcelRequire("lRtsS");
var $1E1qs = parcelRequire("1E1qs");

const $29a11e8e33fc800b$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $eb3ax.default)({}, slice) : (0, $1E1qs.getDefaultStateSlice)();
};
const $29a11e8e33fc800b$export$6a0b1779210de0ee = (state)=>state.context;


parcelRequire("lRtsS");
var $8QX4p = parcelRequire("8QX4p");
var $e9sRm = parcelRequire("e9sRm");
var $3MfCJ = parcelRequire("3MfCJ");
var $bx2PP = parcelRequire("bx2PP");
var $6xGiN = parcelRequire("6xGiN");
var $dwFAv = parcelRequire("dwFAv");
var $c35iW = parcelRequire("c35iW");
var $8Bqvb = parcelRequire("8Bqvb");
var $dWqqf = parcelRequire("dWqqf");
var $gX50G = parcelRequire("gX50G");
var $8saqi = parcelRequire("8saqi");

const $4266d203c89711b1$var$_excluded = [
    "context"
], $4266d203c89711b1$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $4266d203c89711b1$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $3MfCJ.deleteResourceState)(type, key));
                dispatch((0, $8QX4p.executeForDependents)(resource, (dependentResource)=>$4266d203c89711b1$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $3MfCJ.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1eVGO.default)(_getState, $4266d203c89711b1$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $29a11e8e33fc800b$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $eb3ax.default)({}, prevSlice, changes, {
                expiresAt: (0, $dwFAv.getExpiresAt)(maxAge),
                accessedAt: (0, $6xGiN.getAccessedAt)()
            });
            dispatch((0, $3MfCJ.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $8QX4p.executeForDependents)(resource, (dependentResource)=>$4266d203c89711b1$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $3MfCJ.getResourceState)(type, key));
            if (cached && (0, $c35iW.shouldUseCache)(cached)) {
                if ((0, $c35iW.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $8Bqvb.setSsrDataPromise)(cached);
                    cached = (0, $dwFAv.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $6xGiN.getAccessedAt)();
                dispatch((0, $3MfCJ.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($4266d203c89711b1$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $3MfCJ.getResourceState)(type, key)) || (0, $1E1qs.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $8saqi.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $3MfCJ.getPrefetchSlice)(type, key)) || (0, $e9sRm.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8QX4p.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $3MfCJ.setResourceState)(type, key, (0, $eb3ax.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $6xGiN.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $8QX4p.executeForDependents)(resource, (dependentResource)=>$4266d203c89711b1$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $dWqqf.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $3MfCJ.getResourceState)(type, key));
            const finalSlice = (0, $eb3ax.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $6xGiN.getAccessedAt)(),
                expiresAt: (0, $dwFAv.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $3MfCJ.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $3MfCJ.getPrefetchSlice)(type, key)) || (0, $e9sRm.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8QX4p.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $3MfCJ.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $8QX4p.executeForDependents)(resource, (dependentResource)=>$4266d203c89711b1$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $4266d203c89711b1$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $8QX4p.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $4266d203c89711b1$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $8QX4p.actionWithDependencies)(routerStoreContext.route.resources, resource, $4266d203c89711b1$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $8QX4p.actionWithDependencies)(routerStoreContext.route.resources, resource, $4266d203c89711b1$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $8QX4p.actionWithDependencies)(routerStoreContext.route.resources, resource, $4266d203c89711b1$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($4266d203c89711b1$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $3MfCJ.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $3MfCJ.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $1HIWn.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $8QX4p.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$4266d203c89711b1$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $8QX4p.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$4266d203c89711b1$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $eb3ax.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $gX50G.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1eVGO.default)(_ref, $4266d203c89711b1$var$_excluded2);
                const deserializedError = !error ? null : (0, $bx2PP.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $eb3ax.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $gX50G.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $bx2PP.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $dWqqf.TimeoutError) ? loading : false
                }))
};
const $4266d203c89711b1$export$94f50dade551bd01 = (0, $8s9DV.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $4266d203c89711b1$export$e324594224ef24da,
    name: 'router-resources'
});
const $4266d203c89711b1$export$cc90fb9c37c5589d = (0, $j8on0.createContainer)($4266d203c89711b1$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $4266d203c89711b1$export$fee1a6213543bd78 = (0, $5GOpG.createSubscriber)($4266d203c89711b1$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $29a11e8e33fc800b$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $4266d203c89711b1$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $c6StJ.defaultRegistry).getStore($4266d203c89711b1$export$94f50dade551bd01);
const $4266d203c89711b1$export$ac3608e0bb357c7 = (0, $kBr4q.createHook)($4266d203c89711b1$export$94f50dade551bd01, {
    selector: (0, $29a11e8e33fc800b$export$c9ed509724feb827)
});
const $4266d203c89711b1$export$98e41a62c9bef75e = (0, $kBr4q.createActionsHook)($4266d203c89711b1$export$94f50dade551bd01);
const $4266d203c89711b1$export$e59f52df235ac7b3 = (0, $kBr4q.createHook)($4266d203c89711b1$export$94f50dade551bd01, {
    selector: (0, $29a11e8e33fc800b$export$6a0b1779210de0ee)
});
module.exports["getResourceStore"] = $4266d203c89711b1$export$6f6057d42352becb;
module.exports["useResourceStore"] = $4266d203c89711b1$export$ac3608e0bb357c7;
module.exports["useResourceStoreActions"] = $4266d203c89711b1$export$98e41a62c9bef75e;

});

parcelRegister("gOGAf", function(module, exports) {
const $c3e25911562acd60$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});

parcelRegister("9K1UB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $cedb5ed83a1df039$export$460b856701295621 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "200px",
            height: "80px"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "80px"
    });
};
module.exports["DefaultActionRendererSkeleton"] = $cedb5ed83a1df039$export$460b856701295621;

});

parcelRegister("5Wcst", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");

const $f20ca30833613f0e$var$parseActionData = (data)=>{
    if (typeof data !== 'string') return data;
    try {
        return JSON.parse(data);
    } catch  {
        return data;
    }
};
const $f20ca30833613f0e$var$hasObjectKeys = (data, keys)=>data !== null && typeof data === 'object' && keys.every((key)=>key in data);
const $f20ca30833613f0e$var$getPayloadCandidate = (data)=>{
    if (data !== null && typeof data === 'object' && 'input' in data && data.input !== null && typeof data.input === 'object') return data.input;
    return data;
};
const $f20ca30833613f0e$var$getToolName = (action)=>{
    const data = $f20ca30833613f0e$var$parseActionData(action.data);
    if (data !== null && typeof data === 'object' && 'tool_name' in data) {
        const toolName = data.tool_name;
        return typeof toolName === 'string' ? toolName : undefined;
    }
    return undefined;
};
const $f20ca30833613f0e$var$JIRA_PLANS_LEGACY_KEY_TO_ANTHROPIC_MIGRATION_KEY = {
    [(0, $dw75i.JIRA_PLANS_CREATE_WORK_ITEM_KEY)]: 'execute_is.jira_atlassian_plan_create_work_item',
    [(0, $dw75i.JIRA_PLANS_CREATE_RELEASE_KEY)]: 'execute_is.jira_atlassian_plan_create_release',
    [(0, $dw75i.JIRA_PLANS_UPDATE_WORK_SOURCE_KEY)]: 'execute_is.jira_atlassian_plan_update_work_sources',
    [(0, $dw75i.JIRA_PLANS_MANAGE_FEATURES_KEY)]: 'execute_is.jira_atlassian_plan_set_release_enabled',
    [(0, $dw75i.JIRA_PLANS_ADD_DEPENDENCY_KEY)]: 'execute_is.jira_atlassian_plan_add_work_item_dependencies',
    [(0, $dw75i.JIRA_PLANS_REMOVE_DEPENDENCY_KEY)]: 'execute_is.jira_atlassian_plan_remove_work_item_dependencies',
    [(0, $dw75i.JIRA_PLANS_ADD_PROGRAM_BOARD_KEY)]: 'execute_is.jira_atlassian_plan_add_program_board',
    [(0, $dw75i.JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY)]: 'execute_is.jira_atlassian_plan_delete_program_board'
};
const $f20ca30833613f0e$var$JIRA_PLANS_ANTHROPIC_KEY_TO_LEGACY_KEY = Object.fromEntries(Object.entries($f20ca30833613f0e$var$JIRA_PLANS_LEGACY_KEY_TO_ANTHROPIC_MIGRATION_KEY).flatMap(([legacyKey, anthropicKey])=>[
        [
            anthropicKey,
            legacyKey
        ],
        [
            anthropicKey.replace('execute_is.', 'is.'),
            legacyKey
        ]
    ]));
const $f20ca30833613f0e$var$JIRA_PLANS_CUSTOM_UI_LEGACY_KEYS = new Set(Object.keys($f20ca30833613f0e$var$JIRA_PLANS_LEGACY_KEY_TO_ANTHROPIC_MIGRATION_KEY));
const $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey = (legacyKey)=>$f20ca30833613f0e$var$JIRA_PLANS_LEGACY_KEY_TO_ANTHROPIC_MIGRATION_KEY[legacyKey];
const $f20ca30833613f0e$var$resolveJiraPlansAnthropicActionKey = (actionKey)=>$f20ca30833613f0e$var$JIRA_PLANS_ANTHROPIC_KEY_TO_LEGACY_KEY[actionKey];
const $f20ca30833613f0e$var$isJiraPlansAnthropicActionKey = (actionKey)=>actionKey in $f20ca30833613f0e$var$JIRA_PLANS_ANTHROPIC_KEY_TO_LEGACY_KEY;
const $f20ca30833613f0e$var$isJiraPlansLegacyActionKey = (actionKey)=>$f20ca30833613f0e$var$JIRA_PLANS_CUSTOM_UI_LEGACY_KEYS.has(actionKey);
const $f20ca30833613f0e$var$isJiraPlansCustomUiActionKey = (actionKey)=>$f20ca30833613f0e$var$isJiraPlansLegacyActionKey(actionKey) || $f20ca30833613f0e$var$isJiraPlansAnthropicActionKey(actionKey);
const $f20ca30833613f0e$var$getJiraPlansAnthropicKeyFromPayload = (action)=>{
    const data = $f20ca30833613f0e$var$getPayloadCandidate($f20ca30833613f0e$var$parseActionData(action.data));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'programBoardId',
        'programBoardName',
        'start',
        'iterationsCount',
        'iterationLength'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'planName',
        'name',
        'start',
        'iterationsCount',
        'iterationLength'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_ADD_PROGRAM_BOARD_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'scenarioId',
        'dependencyType',
        'sourceItemKey',
        'sourceItemId',
        'targetItemKey',
        'targetItemId'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_ADD_DEPENDENCY_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'scenarioId',
        'dependencyType',
        'sourceItemKey',
        'targetItemKey'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_REMOVE_DEPENDENCY_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'scenarioId',
        'projectId',
        'sourceName',
        'summary',
        'issueTypeId',
        'workType'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_CREATE_WORK_ITEM_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'scenarioId',
        'projectId',
        'projectName',
        'name',
        'start',
        'end'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_CREATE_RELEASE_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'isReleaseEnabled'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_MANAGE_FEATURES_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'deleteIssueSourceId'
    ])) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_UPDATE_WORK_SOURCE_KEY));
    if ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'planId',
        'title',
        'type'
    ]) && ($f20ca30833613f0e$var$hasObjectKeys(data, [
        'projectId'
    ]) || $f20ca30833613f0e$var$hasObjectKeys(data, [
        'rowId'
    ]))) return $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey((0, $dw75i.JIRA_PLANS_UPDATE_WORK_SOURCE_KEY));
    return undefined;
};
const $f20ca30833613f0e$var$getJiraPlansCustomUiActionKey = (action)=>{
    if ($f20ca30833613f0e$var$isJiraPlansAnthropicActionKey(action.key)) return action.key;
    const toolName = $f20ca30833613f0e$var$getToolName(action);
    if (toolName && $f20ca30833613f0e$var$isJiraPlansAnthropicActionKey(toolName)) return toolName;
    if ((0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration')) {
        const anthropicKeyFromPayload = $f20ca30833613f0e$var$getJiraPlansAnthropicKeyFromPayload(action);
        if (anthropicKeyFromPayload) return anthropicKeyFromPayload;
        const anthropicKeyFromLegacyKey = $f20ca30833613f0e$var$getAnthropicKeyFromLegacyKey(action.key);
        if (anthropicKeyFromLegacyKey) return anthropicKeyFromLegacyKey;
    }
    return $f20ca30833613f0e$var$isJiraPlansLegacyActionKey(action.key) ? action.key : undefined;
};
const $f20ca30833613f0e$var$normalizeJiraPlansCustomUiAction = (action)=>{
    const customUiActionKey = $f20ca30833613f0e$var$getJiraPlansCustomUiActionKey(action);
    if (!customUiActionKey || customUiActionKey === action.key) return action;
    return {
        ...action,
        key: customUiActionKey,
        jiraPlansOriginalActionKey: action.key
    };
};
const $f20ca30833613f0e$var$normalizeJiraPlansCustomUiActions = (actions)=>(0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration') ? actions.map($f20ca30833613f0e$var$normalizeJiraPlansCustomUiAction) : actions;
const $f20ca30833613f0e$var$JIRA_PLANS_ACTION_KEYS_TO_NOT_RENDER_LLM_CONTENT = new Set([
    (0, $dw75i.JIRA_PLANS_ADD_DEPENDENCY_KEY),
    (0, $dw75i.JIRA_PLANS_ADD_PROGRAM_BOARD_KEY),
    (0, $dw75i.JIRA_PLANS_CREATE_RELEASE_KEY),
    (0, $dw75i.JIRA_PLANS_CREATE_WORK_ITEM_KEY),
    (0, $dw75i.JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY),
    (0, $dw75i.JIRA_PLANS_MANAGE_FEATURES_KEY),
    (0, $dw75i.JIRA_PLANS_REMOVE_DEPENDENCY_KEY),
    (0, $dw75i.JIRA_PLANS_UPDATE_WORK_SOURCE_KEY),
    ...Object.values($f20ca30833613f0e$var$JIRA_PLANS_LEGACY_KEY_TO_ANTHROPIC_MIGRATION_KEY)
]);
const $f20ca30833613f0e$var$shouldNotRenderLLMContentForJiraPlansAction = (action)=>{
    const jiraPlansCustomUiActionKey = $f20ca30833613f0e$var$getJiraPlansCustomUiActionKey(action);
    return Boolean(jiraPlansCustomUiActionKey && $f20ca30833613f0e$var$JIRA_PLANS_ACTION_KEYS_TO_NOT_RENDER_LLM_CONTENT.has(jiraPlansCustomUiActionKey));
};
/**
 * The Anthropic version of the Jira Plans skills delivers the tool arguments
 * wrapped in `{ tool_name, input }` instead of passing the flat payload directly
 * as `action.data`. Unwrap `input` so the existing plan renderers keep reading
 * their typed payload fields off `data`.
 *
 * Falls back to treating `data` as the payload itself, so this is safe for both
 * the legacy (flat) and new (wrapped) shapes regardless of which one is flowing.
 */ const $f20ca30833613f0e$var$getPlanActionData = (data)=>{
    const parsedData = $f20ca30833613f0e$var$parseActionData(data);
    const isWrappedPayload = parsedData !== null && typeof parsedData === 'object' && 'input' in parsedData && parsedData.input !== null && typeof parsedData.input === 'object';
    if (isWrappedPayload) return parsedData.input;
    return parsedData;
};
/**
 * Re-wraps a (possibly modified) plan payload back into the Anthropic
 * `{ tool_name, input }` envelope when the original `data` used that shape, so
 * confirm/actioned callbacks forward the same contract the backend sent. When
 * the original `data` was the legacy flat payload, the payload is returned as-is.
 */ const $f20ca30833613f0e$var$withPlanActionData = (originalData, payload)=>{
    const parsedOriginalData = $f20ca30833613f0e$var$parseActionData(originalData);
    if (parsedOriginalData !== null && typeof parsedOriginalData === 'object' && 'input' in parsedOriginalData) {
        const wrappedPayload = {
            ...parsedOriginalData,
            input: payload
        };
        return typeof originalData === 'string' ? JSON.stringify(wrappedPayload) : wrappedPayload;
    }
    return payload;
};
const $f20ca30833613f0e$var$isPlanActionKeyForRenderer = (actionKey, legacyActionKey)=>{
    if ($f20ca30833613f0e$var$resolveJiraPlansAnthropicActionKey(actionKey) === legacyActionKey) return (0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration');
    if (actionKey === legacyActionKey) return !(0, $iDrrr.fg)('rovo_chat_jira_plans_anthropic_migration');
    return false;
};
const $f20ca30833613f0e$export$14e89bc0bdbf7136 = {
    isCustomUiActionKey: $f20ca30833613f0e$var$isJiraPlansCustomUiActionKey,
    isLegacyActionKey: $f20ca30833613f0e$var$isJiraPlansLegacyActionKey,
    isAnthropicActionKey: $f20ca30833613f0e$var$isJiraPlansAnthropicActionKey,
    resolveAnthropicActionKey: $f20ca30833613f0e$var$resolveJiraPlansAnthropicActionKey,
    getCustomUiActionKey: $f20ca30833613f0e$var$getJiraPlansCustomUiActionKey,
    normalizeCustomUiActions: $f20ca30833613f0e$var$normalizeJiraPlansCustomUiActions,
    shouldNotRenderLLMContentForAction: $f20ca30833613f0e$var$shouldNotRenderLLMContentForJiraPlansAction,
    getPlanActionData: $f20ca30833613f0e$var$getPlanActionData,
    withPlanActionData: $f20ca30833613f0e$var$withPlanActionData,
    isPlanActionKeyForRenderer: $f20ca30833613f0e$var$isPlanActionKeyForRenderer
};
module.exports["jiraPlansActionData"] = $f20ca30833613f0e$export$14e89bc0bdbf7136;

});

parcelRegister("bBgYs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $hMLWD = parcelRequire("hMLWD");

const $259948fd8687928a$export$8de27c246144bed0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { action: action, onSuccess: onSuccess } = t0;
    const fired = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== action || $[1] !== onSuccess) {
        t1 = ()=>{
            if (fired.current === true || !action) return;
            fired.current = true;
            onSuccess?.(action);
        };
        t2 = [
            onSuccess,
            action
        ];
        $[0] = action;
        $[1] = onSuccess;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ action: action, onSuccess: onSuccess })=>{
    const fired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (fired.current === true || !action) return;
        fired.current = true;
        onSuccess?.(action);
    }, [
        onSuccess,
        action
    ]);
    return null;
};
const $259948fd8687928a$export$7e4d4d0557422b28 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, action: action, onError: onError } = t0;
    let t1;
    if ($[0] !== action || $[1] !== onError) {
        t1 = (error, info)=>{
            onError?.(action, {
                error: error,
                info: info
            });
        };
        $[0] = action;
        $[1] = onError;
        $[2] = t1;
    } else t1 = $[2];
    const onErrorCallback = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== children || $[5] !== onErrorCallback) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t2,
            onError: onErrorCallback
        }, children);
        $[4] = children;
        $[5] = onErrorCallback;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, action: action, onError: onError })=>{
    const onErrorCallback = (0, $cozmU.useCallback)((error, info)=>{
        onError?.(action, {
            error: error,
            info: info
        });
    }, [
        onError,
        action
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        }),
        onError: onErrorCallback
    }, children);
};
module.exports["SuccessEventComponent"] = $259948fd8687928a$export$8de27c246144bed0;
module.exports["ErrorBoundaryWithAnalytics"] = $259948fd8687928a$export$7e4d4d0557422b28;

});

parcelRegister("2d34v", function(module, exports) {

var $i642l = parcelRequire("i642l");


var $8PIsi = parcelRequire("8PIsi");


var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $arQY7 = parcelRequire("arQY7");


var $ad7Ou = parcelRequire("ad7Ou");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $i1t43 = parcelRequire("i1t43");


var $kp580 = parcelRequire("kp580");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $4n04n = parcelRequire("4n04n");


var $kFTt2 = parcelRequire("kFTt2");


var $2xjCL = parcelRequire("2xjCL");


var $5Tn11 = parcelRequire("5Tn11");


var $2xH7b = parcelRequire("2xH7b");


var $85mU8 = parcelRequire("85mU8");


var $bJveX = parcelRequire("bJveX");


var $domWY = parcelRequire("domWY");


var $7kKC5 = parcelRequire("7kKC5");


var $53mTv = parcelRequire("53mTv");


var $gFn8K = parcelRequire("gFn8K");


var $7xhu8 = parcelRequire("7xhu8");

const $d75ab55b51986705$var$styles = {
    loadingHeaderOffset: "_46hvQm1Y8M _0xmtko1Y8M"
};
const $d75ab55b51986705$var$RovoHeaderIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        size: "small",
        name: "Rovo",
        appearance: "hexagon",
        src: (0, $kp580.rovoHexIcon),
        borderColor: "var(--ds-surface, #FFFFFF)",
        testId: "rovo-header-icon"
    });
const $d75ab55b51986705$var$subtitleMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant.agenticPlanTool.subtitle",
    defaultMessage: "Plan for <link>{issueKey}</link>"
});
const $d75ab55b51986705$var$errorFallbackTitleMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant.agenticPlanTool.errorFallbackTitle",
    defaultMessage: "Plan for {issueKey}"
});
const $d75ab55b51986705$var$planDismissedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant.agenticPlanTool.planDismissed",
    defaultMessage: "Plan dismissed"
});
const $d75ab55b51986705$var$dismissButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.in-chat.dismiss-button",
    defaultMessage: "Dismiss"
});
const $d75ab55b51986705$var$planAcceptedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant.agenticPlanTool.planAccepted",
    defaultMessage: "Plan accepted"
});
const $d75ab55b51986705$var$completeConversationErrorTitle = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanToolInChat.completeConversationErrorTitle",
    defaultMessage: "Something went wrong"
});
const $d75ab55b51986705$var$completeConversationErrorContent = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanToolInChat.completeConversationErrorContent",
    defaultMessage: "We couldn't finish the agent session. Please try again."
});
const $d75ab55b51986705$var$getIssueKeyFromAction = (action)=>{
    const actionData = action?.data;
    const issueKeyFromData = typeof actionData === 'object' && actionData !== null && 'issueKey' in actionData ? actionData.issueKey : undefined;
    if (typeof issueKeyFromData !== 'string' || !issueKeyFromData) throw new Error('AgenticPlanToolInChat: issueKey is required but was not found in message actions');
    return issueKeyFromData;
};
const $d75ab55b51986705$var$broadcastPlanPublished = ()=>{
    try {
        const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
        bridgeAPI.broadcast((0, $2xH7b.RovoBroadcastConfirmedActionsCommand), {
            key: 'AgenticPlanTool',
            senderId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        }, {
            filter: (0, $2xjCL.isRovoBroadcastConfirmedActions)
        });
    } catch  {}
};
const $d75ab55b51986705$var$AgenticPlanToolInner = ({ agentName: agentName, message: message, onConfirm: onConfirm, handleOnDismiss: handleOnDismiss, localActionState: localActionState, markFinished: markFinished, onCompleteConversation: onCompleteConversation, isLastMessage: isLastMessage, issueRef: issueRef, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleOnExecuteAgent = (currentPlan, issueKey, savedToDescription = false, planEditLevel)=>{
        const markdown = (0, $4n04n.adfToMarkdownPlus)(currentPlan, {
            markdownPlus: false
        }).markdown;
        if ((0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent')) {
            // OOTB: publishing records the plan and completes the conversation
            // (onCompleteConversation), instead of resuming the agent via onConfirm.
            // The plan is already saved to the description by the tool.
            $d75ab55b51986705$var$broadcastPlanPublished();
            onCompleteConversation(markdown, issueKey);
            markFinished();
            return;
        }
        const actions = [
            {
                ...message.actions[0],
                data: {
                    content: markdown,
                    issueKey: issueKey
                }
            }
        ];
        if (savedToDescription) $d75ab55b51986705$var$broadcastPlanPublished();
        onConfirm({
            actions: actions
        }, {
            savedToDescription: savedToDescription,
            planEditLevel: planEditLevel
        });
    };
    const footer = (0, $cozmU.useCallback)((actionButtons)=>(0, $gFn8K.defaultFooter)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, actionButtons, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleOnDismiss
        }, formatMessage($d75ab55b51986705$var$dismissButtonLabel)))), [
        handleOnDismiss,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJveX.AgenticPlanTool), {
        agentSessionInfo: {
            agentName: agentName ?? ''
        },
        isFromChat: true,
        message: message,
        onExecuteAgent: handleOnExecuteAgent,
        onDismissSession: handleOnDismiss,
        onOpenRovoChat: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83))),
        hideFooter: localActionState === 'finished' || isLastMessage === false,
        issueRef: issueRef,
        isLoadingIssue: isLoading,
        footer: footer
    });
};
const $d75ab55b51986705$var$AgenticPlanToolWithIssueData = ({ message: message, cloudId: cloudId, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const issueKey = $d75ab55b51986705$var$getIssueKeyFromAction(message.actions[0]);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $8PIsi.default), {
        cloudId: cloudId,
        issueKey: issueKey
    }, {
        fetchPolicy: 'store-or-network'
    });
    const issue = data?.jira?.issueByKey;
    const subtitle = formatMessage($d75ab55b51986705$var$subtitleMessage, {
        issueKey: issueKey,
        link: (chunks)=>issue?.webUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: issue.webUrl,
                appearance: "subtle"
            }, `${chunks}`) : chunks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7kKC5.CollapsibleCard), {
        defaultExpanded: props.localActionState === 'planned',
        isExpandable: true,
        title: issue?.summary ?? undefined,
        subtitle: subtitle,
        headerIcon: (0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent') ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$RovoHeaderIcon, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$AgenticPlanToolInner, {
        cloudId: cloudId,
        message: message,
        issueRef: issue,
        ...props
    })), props.localActionState === 'finished' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xhu8.SystemMessage), {
        message: formatMessage($d75ab55b51986705$var$planAcceptedMessage)
    }));
};
const $d75ab55b51986705$var$AgenticPlanToolWithErrorFallback = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const issueKey = $d75ab55b51986705$var$getIssueKeyFromAction(props.message.actions[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7kKC5.CollapsibleCard), {
        defaultExpanded: props.localActionState === 'planned',
        isExpandable: true,
        title: formatMessage($d75ab55b51986705$var$errorFallbackTitleMessage, {
            issueKey: issueKey
        }),
        headerIcon: (0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent') ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$RovoHeaderIcon, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$AgenticPlanToolInner, props));
};
const $d75ab55b51986705$var$AgenticPlanToolWithHeaderLoading = (props)=>{
    const skeletonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d75ab55b51986705$var$styles.loadingHeaderOffset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }));
    const skeletonSubtitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $d75ab55b51986705$var$styles.loadingHeaderOffset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "180px",
        height: "14px",
        borderRadius: "var(--ds-radius-xsmall, 2px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100px",
        height: "12px",
        borderRadius: "var(--ds-radius-xsmall, 2px)"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7kKC5.CollapsibleCard), {
        defaultExpanded: props.localActionState === 'planned',
        isExpandable: true,
        headerIcon: skeletonIcon,
        subtitle: skeletonSubtitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$AgenticPlanToolInner, {
        ...props,
        isLoading: true
    }));
};
const $d75ab55b51986705$export$9a453395da885e0 = (props)=>{
    const { actions: actions, cloudId: cloudId, conversationId: conversationId, onCustomDataActioned: onCustomDataActioned } = props;
    const firstAction = actions[0];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const [commitCompleteConversation] = (0, $6SsN4.useMutation)((0, $i642l.default));
    const showCompleteConversationErrorFlag = (0, $cozmU.useCallback)(()=>{
        (0, $kFTt2.default)({
            meta: {
                id: 'agenticPlanToolInChatCompleteConversation',
                packageName: (0, $53mTv.PACKAGE_NAME),
                teamName: (0, $53mTv.TEAM_NAME)
            },
            attributes: {
                conversationId: conversationId
            }
        });
        showFlag({
            id: 'agentic-plan-tool-in-chat-complete-conversation-error',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
            title: formatMessage($d75ab55b51986705$var$completeConversationErrorTitle),
            description: formatMessage($d75ab55b51986705$var$completeConversationErrorContent)
        });
    }, [
        formatMessage,
        showFlag,
        conversationId
    ]);
    const handleCompleteConversation = (0, $cozmU.useCallback)((markdown, issueKey)=>{
        if (!firstAction || !conversationId) return;
         // Record the published plan
        onCustomDataActioned(firstAction, {
            content: markdown,
            issueKey: issueKey
        }, markdown);
        commitCompleteConversation({
            variables: {
                cloudId: cloudId,
                conversationId: conversationId
            },
            onCompleted: (response)=>{
                const result = response.convoAi_completeConversation;
                if (!result?.success || result.errors && result.errors.length > 0) showCompleteConversationErrorFlag();
            },
            onError: showCompleteConversationErrorFlag
        });
    }, [
        commitCompleteConversation,
        cloudId,
        conversationId,
        firstAction,
        onCustomDataActioned,
        showCompleteConversationErrorFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $domWY.AgenticPlanWrapperInChat), {
        ...props,
        key: firstAction?.invocationId,
        interactionSource: "agenticPlanToolRenderer"
    }, (wrapperProps)=>{
        if (wrapperProps.localActionState === 'cancelled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xhu8.SystemMessage), {
            message: formatMessage($d75ab55b51986705$var$planDismissedMessage),
            isSuccessMessage: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$AgenticPlanToolWithErrorFallback, {
                    ...wrapperProps,
                    cloudId: props.cloudId,
                    onCompleteConversation: handleCompleteConversation
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$AgenticPlanToolWithHeaderLoading, {
                ...wrapperProps,
                cloudId: props.cloudId,
                isLastMessage: props.isLastMessage,
                onCompleteConversation: handleCompleteConversation
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d75ab55b51986705$var$AgenticPlanToolWithIssueData, {
            ...wrapperProps,
            cloudId: props.cloudId,
            messageId: props.messageId,
            isLastMessage: props.isLastMessage,
            onCompleteConversation: handleCompleteConversation
        })));
    });
};
module.exports["AgenticPlanToolInChat"] = $d75ab55b51986705$export$9a453395da885e0;

});

parcelRegister("9hOLl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");


var $domWY = parcelRequire("domWY");


var $7kKC5 = parcelRequire("7kKC5");


var $cr6ly = parcelRequire("cr6ly");


var $8N6QU = parcelRequire("8N6QU");

const $c05eb236d1d516e2$var$hasActionsPayload = (payload)=>Boolean(payload && 'actions' in payload && Array.isArray(payload.actions) && payload.actions.length > 0);
const $c05eb236d1d516e2$var$MultipleChoiceQuestionsToolInChatComponent = ({ message: message, onConfirm: onConfirm, handleOnDismiss: handleOnDismiss, recipientAgentName: recipientAgentName, localActionState: localActionState, ContentRenderer: ContentRenderer, productKey: productKey, cloudId: cloudId, messageId: messageId, AskQuestionCompletedView: AskQuestionCompletedView })=>{
    const [confirmedAnswers, setConfirmedAnswers] = (0, $cozmU.useState)({});
    const action = (0, $cozmU.useMemo)(()=>message.actions[0], [
        message.actions
    ]);
    const handleOnConfirm = (0, $cozmU.useCallback)((_event, _analyticsEvent, payload, analyticsAttributes)=>{
        if ($c05eb236d1d516e2$var$hasActionsPayload(payload)) {
            setConfirmedAnswers((0, $cr6ly.parseAnswersByQuestionId)(payload.actions[0]?.data));
            onConfirm({
                actions: payload.actions
            }, {
                actionKey: action?.key,
                ...analyticsAttributes
            });
        }
        return Promise.resolve();
    }, [
        onConfirm,
        action.key
    ]);
    if (localActionState === 'finished') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cr6ly.MultipleChoiceAnswers), {
        action: action,
        confirmedAnswers: confirmedAnswers,
        ContentRenderer: ContentRenderer,
        productKey: productKey,
        cloudId: cloudId,
        messageId: messageId,
        AskQuestionCompletedView: AskQuestionCompletedView
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7kKC5.CollapsibleCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8N6QU.MultipleChoiceQuestionsTool), {
        agentSessionInfo: {
            agentName: recipientAgentName ?? ''
        },
        message: message,
        onConfirm: handleOnConfirm,
        onDismissSession: handleOnDismiss,
        onOpenRovoChat: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
    }));
};
const $c05eb236d1d516e2$export$a09b005852a6dd5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $domWY.AgenticPlanWrapperInChat), {
        ...props,
        key: props.actions[0]?.invocationId,
        interactionSource: "multipleChoiceQuestionsToolRenderer"
    }, (wrapperProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c05eb236d1d516e2$var$MultipleChoiceQuestionsToolInChatComponent, {
            ...wrapperProps,
            recipientAgentName: props.recipientAgentName,
            ContentRenderer: props.ContentRenderer,
            productKey: props.productKey,
            cloudId: props.cloudId,
            messageId: props.messageId,
            AskQuestionCompletedView: props.AskQuestionCompletedView
        }));
module.exports["MultipleChoiceQuestionsToolInChat"] = $c05eb236d1d516e2$export$a09b005852a6dd5;

});

parcelRegister("3OVMn", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $iDrrr = parcelRequire("iDrrr");

const $4788ec995ed5539c$var$severitySchema = (0, $87Lnp.z).enum([
    'INFO',
    'WARNING',
    'ERROR'
]);
const $4788ec995ed5539c$var$affectedEntitySchema = (0, $87Lnp.z).object({
    entityType: (0, $87Lnp.z).enum([
        'SPACE',
        'JQL_FILTER',
        'BOARD',
        'DASHBOARD'
    ]),
    count: (0, $87Lnp.z).number(),
    severity: $4788ec995ed5539c$var$severitySchema.optional()
});
const $4788ec995ed5539c$var$blastRadiusSchema = (0, $87Lnp.z).object({
    analysisId: (0, $87Lnp.z).string().optional(),
    operationId: (0, $87Lnp.z).string().optional(),
    summary: (0, $87Lnp.z).string().optional(),
    affectedEntities: (0, $87Lnp.z).array($4788ec995ed5539c$var$affectedEntitySchema).optional()
});
const $4788ec995ed5539c$var$metadataSchema = (0, $87Lnp.z).record((0, $87Lnp.z).unknown()).optional();
const $4788ec995ed5539c$var$jiraEntitySchema = (0, $87Lnp.z).object({
    id: (0, $87Lnp.z).string(),
    name: (0, $87Lnp.z).string(),
    iconUrl: (0, $87Lnp.z).string().optional()
});
const $4788ec995ed5539c$var$entitiesSchema = (0, $87Lnp.z).object({
    fields: (0, $87Lnp.z).array($4788ec995ed5539c$var$jiraEntitySchema).optional(),
    spaces: (0, $87Lnp.z).array($4788ec995ed5539c$var$jiraEntitySchema).optional(),
    workTypes: (0, $87Lnp.z).array($4788ec995ed5539c$var$jiraEntitySchema).optional()
});
const $4788ec995ed5539c$var$planPayloadSchema = (0, $87Lnp.z).object({
    actionType: (0, $87Lnp.z).literal('plan'),
    id: (0, $87Lnp.z).string(),
    parentId: (0, $87Lnp.z).string().optional(),
    payload: (0, $87Lnp.z).object({
        title: (0, $87Lnp.z).string(),
        subtext: (0, $87Lnp.z).string().optional(),
        entities: $4788ec995ed5539c$var$entitiesSchema.optional(),
        blastRadius: $4788ec995ed5539c$var$blastRadiusSchema.optional(),
        metadata: $4788ec995ed5539c$var$metadataSchema
    })
});
const $4788ec995ed5539c$var$fieldOptionSchema = (0, $87Lnp.z).object({
    optionId: (0, $87Lnp.z).string().optional(),
    optionName: (0, $87Lnp.z).string()
});
const $4788ec995ed5539c$var$fieldChangeSchema = (0, $87Lnp.z).object({
    new: $4788ec995ed5539c$var$fieldOptionSchema.optional(),
    old: $4788ec995ed5539c$var$fieldOptionSchema.optional()
});
const $4788ec995ed5539c$var$fieldOptionsStepPayloadSchema = (0, $87Lnp.z).object({
    actionType: (0, $87Lnp.z).literal('step'),
    parentId: (0, $87Lnp.z).string().optional(),
    actionSubject: (0, $87Lnp.z).literal('field-options'),
    payload: (0, $87Lnp.z).object({
        operation: (0, $87Lnp.z).enum([
            'create',
            'update',
            'disable'
        ]),
        changes: (0, $87Lnp.z).array($4788ec995ed5539c$var$fieldChangeSchema),
        fieldId: (0, $87Lnp.z).string(),
        fieldName: (0, $87Lnp.z).string(),
        blastRadius: $4788ec995ed5539c$var$blastRadiusSchema,
        metadata: $4788ec995ed5539c$var$metadataSchema
    })
});
const $4788ec995ed5539c$var$fieldStepPayloadSchema = (0, $87Lnp.z).object({
    actionType: (0, $87Lnp.z).literal('step'),
    parentId: (0, $87Lnp.z).string().optional(),
    actionSubject: (0, $87Lnp.z).literal('field'),
    payload: (0, $87Lnp.z).object({
        operation: (0, $87Lnp.z).enum([
            'create',
            'delete'
        ]),
        fieldId: (0, $87Lnp.z).string().optional(),
        fieldName: (0, $87Lnp.z).string(),
        fieldOptions: (0, $87Lnp.z).array((0, $87Lnp.z).string()).optional(),
        fieldType: (0, $87Lnp.z).string().optional(),
        blastRadius: $4788ec995ed5539c$var$blastRadiusSchema,
        metadata: $4788ec995ed5539c$var$metadataSchema
    })
});
const $4788ec995ed5539c$var$fieldFieldSchemeStepPayloadSchema = (0, $87Lnp.z).object({
    actionType: (0, $87Lnp.z).literal('step'),
    parentId: (0, $87Lnp.z).string().optional(),
    actionSubject: (0, $87Lnp.z).literal('field-field-scheme'),
    payload: (0, $87Lnp.z).object({
        operation: (0, $87Lnp.z).enum([
            'create',
            'remove'
        ]),
        blastRadius: $4788ec995ed5539c$var$blastRadiusSchema,
        metadata: $4788ec995ed5539c$var$metadataSchema
    })
});
const $4788ec995ed5539c$var$fieldFieldScreenStepPayloadSchema = (0, $87Lnp.z).object({
    actionType: (0, $87Lnp.z).literal('step'),
    parentId: (0, $87Lnp.z).string().optional(),
    actionSubject: (0, $87Lnp.z).literal('field-field-screen'),
    payload: (0, $87Lnp.z).object({
        operation: (0, $87Lnp.z).enum([
            'create',
            'remove'
        ]),
        blastRadius: $4788ec995ed5539c$var$blastRadiusSchema,
        metadata: $4788ec995ed5539c$var$metadataSchema
    })
});
const $4788ec995ed5539c$var$fieldWorkItemLayoutStepPayloadSchema = (0, $87Lnp.z).object({
    actionType: (0, $87Lnp.z).literal('step'),
    parentId: (0, $87Lnp.z).string().optional(),
    actionSubject: (0, $87Lnp.z).literal('field-work-item-layout'),
    payload: (0, $87Lnp.z).object({
        operation: (0, $87Lnp.z).enum([
            'create',
            'remove'
        ]),
        blastRadius: $4788ec995ed5539c$var$blastRadiusSchema,
        metadata: $4788ec995ed5539c$var$metadataSchema
    })
});
const $4788ec995ed5539c$var$stepPayloadSchema = (0, $87Lnp.z).discriminatedUnion('actionSubject', [
    $4788ec995ed5539c$var$fieldOptionsStepPayloadSchema,
    $4788ec995ed5539c$var$fieldStepPayloadSchema,
    $4788ec995ed5539c$var$fieldFieldSchemeStepPayloadSchema,
    $4788ec995ed5539c$var$fieldFieldScreenStepPayloadSchema,
    $4788ec995ed5539c$var$fieldWorkItemLayoutStepPayloadSchema
]);
const $4788ec995ed5539c$var$payloadSchema = (0, $87Lnp.z).union([
    $4788ec995ed5539c$var$planPayloadSchema,
    $4788ec995ed5539c$var$stepPayloadSchema
]);
function $4788ec995ed5539c$export$5fcee789d2d7f477(data) {
    if ((0, $iDrrr.fg)('fe_jira_admin_agent_safe_parse_action')) {
        const parsed = $4788ec995ed5539c$var$payloadSchema.safeParse(data);
        return parsed.success ? {
            ...parsed.data,
            validated: true
        } : {
            ...data,
            validated: false
        };
    }
    return data;
}
module.exports["validateJiraAdminAgentAction"] = $4788ec995ed5539c$export$5fcee789d2d7f477;

});

parcelRegister("19ZSn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $cLuNh = parcelRequire("cLuNh");


var $5sRAM = parcelRequire("5sRAM");


var $gKKIc = parcelRequire("gKKIc");


var $1hUUd = parcelRequire("1hUUd");


var $8HjAL = parcelRequire("8HjAL");


var $8Fgjj = parcelRequire("8Fgjj");

const $fd127a26b3687bb4$var$invalidPayloadMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.JiraAdminAgentRenderer.invalidPayload.non-final",
    defaultMessage: "We couldn't load the response. Wait a few minutes or try again."
});
const $fd127a26b3687bb4$export$2529d66f47eabadf = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [entry, { open: open, close: close }] = (0, $5sRAM.useRovodal)((0, $gKKIc.RovodalStoreKeys).jiraAdminAgentCanvas);
    const isCanvasOpen = entry?.isOpen ?? false;
    const isCanvasLoading = isCanvasOpen && !(entry?.state?.loaded ?? false);
    const { messageId: messageId, conversationId: conversationId, recipientAgentId: recipientAgentId, isHistoricalMessage: isHistoricalMessage, isLastMessage: isLastMessage, cloudId: cloudId, productKey: productKey, actions: actions } = props;
    const convertedPlan = (0, $8HjAL.useConvertActionsToPlan)({
        actions: actions
    });
    const openCanvas = (0, $cozmU.useCallback)(()=>{
        open({
            canvasKey: (0, $cLuNh.RovodalCanvasKeys).jiraAdminAgentBlastRadiusCanvas,
            fullSizeModal: true,
            title: convertedPlan.topLevelPlan?.payload.title,
            actions: actions,
            messageId: messageId,
            conversationId: conversationId,
            recipientAgentId: recipientAgentId,
            isHistoricalMessage: isHistoricalMessage,
            isLastMessage: isLastMessage,
            cloudId: cloudId,
            productKey: productKey,
            sendMessageConfirmedTools: props.sendMessageConfirmedTools,
            readOnlyAgentHeader: {
                name: 'Jira Admin Agent',
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($1hUUd)))
            },
            chatOverrides: {
                agentsConfig: {
                    defaultAgentId: 'jira-admin-agent',
                    filter: [
                        'jira-admin-agent'
                    ]
                },
                uiConfig: {
                    externalEmbed: true,
                    fullScreen: false,
                    isContentPreviewSupported: true,
                    elements: {
                        mainChatHeader: false,
                        browseAgentsButton: false,
                        closeButton: false,
                        fullscreenButton: false,
                        newChatButton: false,
                        createAgentButton: false,
                        agentsMenu: false,
                        navbar: false,
                        stagingAreaEnabled: false,
                        voiceDictationButton: false,
                        chatModeMenuButton: false,
                        fileUploadButton: false,
                        forceFullscreenHeader: false
                    }
                }
            }
        });
    }, [
        open,
        messageId,
        conversationId,
        recipientAgentId,
        isHistoricalMessage,
        isLastMessage,
        cloudId,
        productKey,
        actions,
        convertedPlan.topLevelPlan?.payload.title,
        props.sendMessageConfirmedTools
    ]);
    const onDismissed = (0, $cozmU.useCallback)(()=>{
        // Dismissing the plan should not leave a stale review canvas open.
        if (isCanvasOpen) close();
    }, [
        close,
        isCanvasOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, convertedPlan.topLevelPlan ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Fgjj.JiraAdminAgentActionPlanCard), {
        ...props,
        convertedPlan: convertedPlan,
        openCanvas: openCanvas,
        onDismissed: onDismissed,
        isCanvasOpen: isCanvasOpen,
        isCanvasLoading: isCanvasLoading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($fd127a26b3687bb4$var$invalidPayloadMessage))));
};
module.exports["JiraAdminAgentRenderer"] = $fd127a26b3687bb4$export$2529d66f47eabadf;

});

parcelRegister("8DILb", function(module, exports) {
/* CreateKBCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $hdBxM = parcelRequire("hdBxM");


var $hlvTd = parcelRequire("hlvTd");


var $dw75i = parcelRequire("dw75i");


var $gzMZq = parcelRequire("gzMZq");


var $9Wwnb = parcelRequire("9Wwnb");


var $8JVOU = parcelRequire("8JVOU");


var $eDWhq = parcelRequire("eDWhq");


var $bCDPT = parcelRequire("bCDPT");


var $5ScJC = parcelRequire("5ScJC");


var $hEg6t = parcelRequire("hEg6t");


var $c7JuL = parcelRequire("c7JuL");


var $1CPzM = parcelRequire("1CPzM");


var $5COam = parcelRequire("5COam");


var $44v3s = parcelRequire("44v3s");


var $hJIl5 = parcelRequire("hJIl5");


var $64qm3 = parcelRequire("64qm3");


var $kiRnH = parcelRequire("kiRnH");


var $aceGc = parcelRequire("aceGc");


var $cXeLJ = parcelRequire("cXeLJ");


var $9Kqv9 = parcelRequire("9Kqv9");


var $k5EPe = parcelRequire("k5EPe");


var $icLLU = parcelRequire("icLLU");

const $664ffffc05cd7c78$var$styles = {
    cardContainer: "_30huDKOeNX _0bjKvDhuDr _4bt5LAnQyn _2WAcuGnQyn _0KLXruoI2d _2OUyjtzwhj _1EqgXlHakr",
    errorRow: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLchRC _0Of8r25zaO _1ZnuxbkG2W _1wydGW5zaO _2Zuz6QkG2W"
};
const $664ffffc05cd7c78$var$CREATE_KB_CARD_VIEWS = {
    IMAGE_PREVIEW: 'IMAGE_PREVIEW',
    CREATE_SPACE_FORM: 'CREATE_SPACE_FORM',
    PUBLISH_FORM: 'PUBLISH_FORM'
};
const $664ffffc05cd7c78$export$76bc1e7d849d0df1 = ({ actions: actions, cloudId: cloudId, aaid: aaid, isLastActionMessage: isLastActionMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const data = actions?.[0]?.data;
    const projectId = data.projectId;
    const jsmActivationId = (0, $hJIl5.useCreateKbActivationId)({
        cloudId: cloudId
    });
    const projectIdentifier = (0, $kiRnH.useCreateKbProjectIdentifier)({
        projectId: projectId
    });
    const appLinkId = (0, $cXeLJ.useCreateKbServerAppLinkId)({
        cloudId: cloudId,
        projectIdentifier: projectIdentifier
    });
    const { stagingAreaArticles: stagingAreaArticles, setupHandler: setupHandler } = (0, $k5EPe.useCreateKbStagingAreaSync)({
        articleIds: data.articleIds ?? [],
        projectId: projectId,
        activationId: jsmActivationId ?? undefined,
        isLastActionMessage: isLastActionMessage
    });
    const key = actions?.[0]?.key;
    const isArticlesCard = key === (0, $dw75i.JSM_CREATE_KB_ARTICLES_KEY);
    const initialType = (0, $cozmU.useMemo)(()=>({
            label: formatMessage((0, $44v3s.createKbMessages).typeInternalMessage),
            value: 'INTERNAL'
        }), [
        formatMessage
    ]);
    const [selectedType, setSelectedType] = (0, $cozmU.useState)(initialType);
    const [isCreateDraftsLoading, setIsCreateDraftsLoading] = (0, $cozmU.useState)(false);
    const [hasLinkSourceAlreadyHasContentError, setHasLinkSourceAlreadyHasContentError] = (0, $cozmU.useState)(false);
    const [hasGenericActionError, setHasGenericActionError] = (0, $cozmU.useState)(false);
    const [canCreateSpace, setCanCreateSpace] = (0, $cozmU.useState)(()=>!appLinkId || !(0, $iDrrr.fg)('jsm_kb_from_scratch_check_space_creation'));
    const [isFetchingCreateSpacePermission, setIsFetchingCreateSpacePermission] = (0, $cozmU.useState)(()=>Boolean(appLinkId) && (0, $iDrrr.fg)('jsm_kb_from_scratch_check_space_creation'));
    const { send: send, ready: ready } = (0, $eDWhq.useRovoContentBridgeAPI)((0, $9Wwnb.JSM_KB_CARD_CLIENT_ID), setupHandler);
    const { linkSpaceToKnowledgeBase: linkSpaceToKnowledgeBase } = (0, $9Kqv9.useCreateKbSourceLinking)();
    const { prefetchedSpaceOptions: prefetchedSpaceOptions, isPrefetchedSpaceOptionsLoading: isPrefetchedSpaceOptionsLoading } = (0, $icLLU.usePrefetchedSpaceOptions)({
        cloudId: cloudId,
        userId: aaid
    });
    (0, $cozmU.useEffect)(()=>{
        ready();
    }, [
        ready
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setAIFeatureContext({
                contextKey: (0, $dw75i.JSM_CREATE_KB_TOPICS_KEY),
                setContext: (_existingContext)=>undefined
            });
            setAIFeatureContext({
                contextKey: (0, $dw75i.JSM_CREATE_KB_ARTICLES_KEY),
                setContext: (_existingContext)=>undefined
            });
        };
    }, [
        setAIFeatureContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!appLinkId || !(0, $iDrrr.fg)('jsm_kb_from_scratch_check_space_creation')) {
            setCanCreateSpace(true);
            setIsFetchingCreateSpacePermission(false);
            return;
        }
        let isCancelled = false;
        const fetchCreateSpacePermission = async ()=>{
            setIsFetchingCreateSpacePermission(true);
            setCanCreateSpace(false);
            try {
                const hasCreateSpacePermission = await (0, $bCDPT.createKbApi).canCurrentConfluenceUserCreateSpace({
                    cloudId: cloudId
                });
                if (!isCancelled) setCanCreateSpace(hasCreateSpacePermission);
            } catch  {
                if (!isCancelled) setCanCreateSpace(false);
            } finally{
                if (!isCancelled) setIsFetchingCreateSpacePermission(false);
            }
        };
        fetchCreateSpacePermission();
        return ()=>{
            isCancelled = true;
        };
    }, [
        appLinkId,
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!stagingAreaArticles.length) return;
        send((0, $8JVOU.JSMKbCardEventCommand), {
            receiverId: (0, $9Wwnb.JSM_CREATE_KB_STAGING_AREA_CLIENT_ID),
            senderId: (0, $9Wwnb.JSM_KB_CARD_CLIENT_ID),
            type: 'ARTICLES',
            data: {
                articles: stagingAreaArticles
            }
        });
    }, [
        stagingAreaArticles,
        send
    ]);
    const closeModal = (0, $cozmU.useCallback)(()=>{
        send((0, $8JVOU.JSMKbCardEventCommand), {
            data: {
                close: true
            },
            receiverId: (0, $9Wwnb.JSM_CREATE_KB_CLIENT_ID),
            senderId: (0, $9Wwnb.JSM_KB_CARD_CLIENT_ID),
            type: 'closeModal'
        });
    }, [
        send
    ]);
    const { isConfirmLoading: isConfirmLoading, handleConfirmCreateSpace: handleConfirmCreateSpace, handlePublish: handlePublish } = (0, $aceGc.useCreateKbPublishHandlers)({
        cloudId: cloudId,
        projectId: projectId,
        projectIdentifier: projectIdentifier,
        jiraActivationId: jsmActivationId ?? undefined,
        appLinkId: appLinkId,
        stagingAreaArticles: stagingAreaArticles,
        linkSpaceToKnowledgeBase: linkSpaceToKnowledgeBase,
        closeModal: closeModal,
        onLinkSourceAlreadyHasContentErrorChange: setHasLinkSourceAlreadyHasContentError,
        onGenericPublishErrorChange: setHasGenericActionError
    });
    const { cardView: cardView, spaceName: spaceName, setSpaceName: setSpaceName, selectedSpace: selectedSpace, setSelectedSpace: setSelectedSpace, publishNewSpaceName: publishNewSpaceName, isPublishConsentChecked: isPublishConsentChecked, handlePublishConsentChange: handlePublishConsentChange, handlePublishTargetChange: handlePublishTargetChange, handleSaveForLater: handleSaveForLaterFromViewState, handlePublishAll: handlePublishAllFromViewState, handleBackToInitial: handleBackToInitial, footerMode: footerMode, isConfirmDisabled: isConfirmDisabled, isPublishDisabled: isPublishDisabled } = (0, $64qm3.useCreateKbCardViewState)({
        isArticlesCard: isArticlesCard,
        isConfirmLoading: isConfirmLoading,
        projectIdentifier: projectIdentifier
    });
    const handleCreateDrafts = (0, $cozmU.useCallback)(async ()=>{
        if (isCreateDraftsLoading) return;
        setIsCreateDraftsLoading(true);
        try {
            setHasGenericActionError(false);
            setHasLinkSourceAlreadyHasContentError(false);
            setAIFeatureContext({
                contextKey: (0, $dw75i.JSM_CREATE_KB_TOPICS_KEY),
                setContext: (_existingContext)=>({
                        articles: stagingAreaArticles
                    })
            });
            await Promise.resolve(publish({
                type: 'message-send',
                source: 'create-kb-preview-card',
                data: {
                    prompt: formatMessage((0, $44v3s.createKbMessages).ctaMessage),
                    productKey: 'jsm'
                }
            }));
        } catch (error) {
            setHasGenericActionError(true);
            (0, $hlvTd.logException)({
                exception: error,
                name: 'CreateKbCardCreateDraftsError'
            });
        } finally{
            setIsCreateDraftsLoading(false);
        }
    }, [
        isCreateDraftsLoading,
        stagingAreaArticles,
        formatMessage,
        publish,
        setAIFeatureContext
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        setHasGenericActionError(false);
        setHasLinkSourceAlreadyHasContentError(false);
        handleBackToInitial();
    }, [
        handleBackToInitial
    ]);
    const handleSaveForLater = (0, $cozmU.useCallback)(()=>{
        setHasGenericActionError(false);
        setHasLinkSourceAlreadyHasContentError(false);
        handleSaveForLaterFromViewState();
    }, [
        handleSaveForLaterFromViewState
    ]);
    const handlePublishAll = (0, $cozmU.useCallback)(()=>{
        setHasGenericActionError(false);
        setHasLinkSourceAlreadyHasContentError(false);
        handlePublishAllFromViewState();
    }, [
        handlePublishAllFromViewState
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $664ffffc05cd7c78$var$styles.cardContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $c7JuL.CreateKBCardHeader), null), cardView === $664ffffc05cd7c78$var$CREATE_KB_CARD_VIEWS.CREATE_SPACE_FORM ? /*#__PURE__*/ $cozmU.createElement((0, $hEg6t.CreateKBCardForm), {
        spaceName: spaceName,
        onSpaceNameChange: setSpaceName
    }) : cardView === $664ffffc05cd7c78$var$CREATE_KB_CARD_VIEWS.PUBLISH_FORM ? /*#__PURE__*/ $cozmU.createElement((0, $5COam.CreateKBCardPublishForm), {
        selectedType: selectedType,
        onSelectedTypeChange: setSelectedType,
        selectedSpace: selectedSpace,
        appLinkId: appLinkId,
        prefetchedSpaceOptions: prefetchedSpaceOptions,
        isPrefetchedSpaceOptionsLoading: isPrefetchedSpaceOptionsLoading,
        onSelectedSpaceChange: setSelectedSpace,
        onPublishConsentChange: handlePublishConsentChange,
        onPublishTargetChange: handlePublishTargetChange,
        userId: aaid,
        cloudId: cloudId,
        canCreateSpace: canCreateSpace,
        isFetchingCreateSpacePermission: isFetchingCreateSpacePermission,
        hasLinkSourceAlreadyHasContentError: hasLinkSourceAlreadyHasContentError,
        hasGenericActionError: hasGenericActionError
    }) : /*#__PURE__*/ $cozmU.createElement((0, $1CPzM.CreateKBCardImagePreview), null), hasGenericActionError && cardView !== $664ffffc05cd7c78$var$CREATE_KB_CARD_VIEWS.PUBLISH_FORM ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $664ffffc05cd7c78$var$styles.errorRow
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text"
    }, formatMessage((0, $44v3s.createKbMessages).genericActionErrorMessage))) : null, /*#__PURE__*/ $cozmU.createElement((0, $5ScJC.CreateKBCardFooter), {
        mode: footerMode,
        onCreateDrafts: handleCreateDrafts,
        onSaveForLater: handleSaveForLater,
        onPublishAll: handlePublishAll,
        onConfirm: ()=>handleConfirmCreateSpace({
                spaceName: spaceName,
                selectedTypeValue: 'EXTERNAL'
            }),
        onBack: handleBack,
        isCreateDraftsLoading: isCreateDraftsLoading,
        isConfirmLoading: isConfirmLoading,
        isPublishLoading: isConfirmLoading,
        isConfirmDisabled: isConfirmDisabled,
        isPublishDisabled: isPublishDisabled,
        onPublish: ()=>handlePublish({
                publishNewSpaceName: publishNewSpaceName,
                isPublishToNewSpaceChecked: isPublishConsentChecked,
                selectedSpace: selectedSpace,
                selectedTypeValue: selectedType.value
            })
    }));
};
module.exports["CreateKBCard"] = $664ffffc05cd7c78$export$76bc1e7d849d0df1;

});

parcelRegister("5ZPoU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $aa7719a8970a1495$var$isKnownActionKey(key, registry) {
    return Object.prototype.hasOwnProperty.call(registry, key);
}
const $aa7719a8970a1495$var$defaultGetActionRenderer = {
    ActionRenderer: undefined,
    ActionRendererFallback: undefined,
    readonlyTitle: undefined,
    ReadOnlyActionRenderer: undefined,
    getAdoptedObjects: undefined
};
const $aa7719a8970a1495$var$resolveRegistryEntry = (entry, actions)=>{
    if (!entry) return undefined;
    const { renderer: renderer, fallback: fallback, readonlyTitle: readonlyTitle, readonlyRenderer: readonlyRenderer, validate: validate, condition: condition, getAdoptedObjects: getAdoptedObjects } = entry;
    if (condition && !condition()) return undefined;
    if (validate) for (const action of actions){
        const result = validate(action);
        if (!result.isValid) throw new $aa7719a8970a1495$var$ActionValidationFailureErrorImpl(result, action); // invalid payload shape
    }
    return {
        ActionRenderer: renderer,
        ActionRendererFallback: fallback,
        readonlyTitle: readonlyTitle,
        ReadOnlyActionRenderer: readonlyRenderer,
        getAdoptedObjects: getAdoptedObjects
    };
};
const $aa7719a8970a1495$var$resolvePredicateEntry = (entry, actions)=>{
    if (!entry || !entry.predicate(actions)) return undefined;
    return $aa7719a8970a1495$var$resolveRegistryEntry(entry, actions);
};
const $aa7719a8970a1495$export$7d3f6ea37762dd47 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (registry, predicateRegistry)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== predicateRegistry || $[1] !== registry) {
        t0 = (actionKey, actions)=>{
            if (!actions?.length) return $aa7719a8970a1495$var$defaultGetActionRenderer;
            if ($aa7719a8970a1495$var$isKnownActionKey(actionKey, registry)) {
                const actionsWithKey = actions.filter((action)=>action.key === actionKey);
                if (actionsWithKey.length) {
                    const entry = registry[actionKey];
                    const keyedEntry = $aa7719a8970a1495$var$resolveRegistryEntry(entry, actionsWithKey);
                    if (keyedEntry) return keyedEntry;
                }
            }
            for (const predicate of Object.values(predicateRegistry || {})){
                const predicateMatch = $aa7719a8970a1495$var$resolvePredicateEntry(predicate, actions);
                if (predicateMatch) return predicateMatch;
            }
            return $aa7719a8970a1495$var$defaultGetActionRenderer;
        };
        $[0] = predicateRegistry;
        $[1] = registry;
        $[2] = t0;
    } else t0 = $[2];
    const getActionRenderer = t0;
    let t1;
    if ($[3] !== getActionRenderer) {
        t1 = {
            getActionRenderer: getActionRenderer
        };
        $[3] = getActionRenderer;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (registry, predicateRegistry)=>{
    const getActionRenderer = (0, $cozmU.useCallback)((actionKey, actions)=>{
        if (!actions?.length) return $aa7719a8970a1495$var$defaultGetActionRenderer;
        if ($aa7719a8970a1495$var$isKnownActionKey(actionKey, registry)) {
            const actionsWithKey = actions.filter((action)=>action.key === actionKey);
            if (actionsWithKey.length) {
                const entry = registry[actionKey];
                const keyedEntry = $aa7719a8970a1495$var$resolveRegistryEntry(entry, actionsWithKey);
                if (keyedEntry) return keyedEntry;
            }
        }
        for (const predicate of Object.values(predicateRegistry || {})){
            const predicateMatch = $aa7719a8970a1495$var$resolvePredicateEntry(predicate, actions);
            if (predicateMatch) return predicateMatch;
        }
        return $aa7719a8970a1495$var$defaultGetActionRenderer;
    }, [
        registry,
        predicateRegistry
    ]);
    return {
        getActionRenderer: getActionRenderer
    };
};
class $aa7719a8970a1495$var$ActionValidationFailureErrorImpl extends Error {
    constructor(validationFailure, action){
        super();
        this.validationFailure = void 0;
        this.action = void 0;
        this.validationFailure = validationFailure;
        this.action = action;
    }
}
function $aa7719a8970a1495$export$e374f7926097f57a(error) {
    return error !== null && typeof error === 'object' && 'validationFailure' in error && 'action' in error;
}
module.exports["useActionRenderer"] = $aa7719a8970a1495$export$7d3f6ea37762dd47;
module.exports["isActionValidationFailureError"] = $aa7719a8970a1495$export$e374f7926097f57a;

});

parcelRegister("3kSZk", function(module, exports) {

var $ENvWX = parcelRequire("ENvWX");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");


var $amxY5 = parcelRequire("amxY5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $buzLI = parcelRequire("buzLI");


var $hPfeh = parcelRequire("hPfeh");


var $2esis = parcelRequire("2esis");


var $jtMHU = parcelRequire("jtMHU");


var $7832B = parcelRequire("7832B");


var $1johS = parcelRequire("1johS");


var $1inBu = parcelRequire("1inBu");


var $4yZQ6 = parcelRequire("4yZQ6");

const $ccdf9905c07629e4$var$styles = {
    cardGroup: "_23rrnH2HTN _0bjKvD8fU6 _0aFT5vbt8w _1UtDYzy7kJ _0KLXruqi9L _2OUyjtzwhj",
    cardsContainer: "_0Of8r22ADO _1wydGW2ADO"
};
const $ccdf9905c07629e4$export$eb362734876d260b = /*#__PURE__*/ (0, $cozmU.memo)(({ cloudId: cloudId, actions: actions, messageId: messageId, onCustomDataConfirm: onCustomDataConfirm, onCancel: onCancel, getStatus: getStatus, getReadonly: getReadonly, jiraActivationId: jiraActivationId, showFooter: showFooter = true, showButtons: showButtons = true, ...props })=>{
    (0, $6cFsl.di)((0, $hPfeh.ActionCard), (0, $jtMHU.CardGroupFooter));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isBulkActioning, setisBulkActioning] = (0, $cozmU.useState)(false); // Track which actions should be marked as finished or errored using lookup keys "fieldKey:issueId"
    const [bulkAcceptedActionKeys, setBulkAcceptedActionKeys] = (0, $cozmU.useState)(new Set());
    const [bulkErroredActionKeys, setBulkErroredActionKeys] = (0, $cozmU.useState)(new Set());
    const [invalidActionKeys, setInvalidActionKeys] = (0, $cozmU.useState)(new Set()); // Helper function get "effective" status of an single field action, which takes in consideration whether
    // a field has been accepted or errored by the bulk `update-all-field-types` action. This wraps getStatus to add
    // finished or errored keys tracking without mutating the `actions` array itself. This ensures we aren't
    // continually looping over and updating the `actions` array for each render of our component.
    const getEffectiveStatus = (0, $cozmU.useCallback)((action)=>{
        if ((0, $4yZQ6.isUpdateWorkItemAllFieldsAction)(action)) {
            const { issueIdOrKey: issueIdOrKey, fields: fields } = action.data.updates?.[0] ?? {}; // Single field actions only should be overriden in case they have been bulk actioned
            if (Object.keys(fields).length === 1) {
                const { fieldKey: fieldKey } = (0, $4yZQ6.getActionData)(action);
                const lookupKey = (0, $4yZQ6.createLookupKey)(fieldKey, issueIdOrKey); // If the action is marked as invalid, return its status as 'cancelled'
                if (invalidActionKeys.has(lookupKey)) return 'cancelled';
                 // If the action is marked as being successfully bulk accepted, return its status as 'finished'
                if (bulkAcceptedActionKeys.has(lookupKey)) return 'finished';
                 // If the action is marked as being bulk errored, return its status as 'errored'
                if (bulkErroredActionKeys.has(lookupKey)) return 'errored';
            }
        }
        return getStatus(action);
    }, [
        bulkAcceptedActionKeys,
        bulkErroredActionKeys,
        getStatus,
        invalidActionKeys
    ]); // We add invalid actions to the invalidActionKeys set so that we can return a "cancelled" status for the action so it does not render empty fields.
    // This is only passed in for fields which require hydration, as it is these fields (when invalid values are provided by the LLM) which mainl
    // cause empty fields to be rendered. For all other fields which rely on the Relay query, even if the value is invalid, they render successfully
    // but just cannot be executed successfully.
    const onInvalidAction = (0, $cozmU.useCallback)((action)=>{
        const { issueIdOrKey: issueIdOrKey } = action.data.updates?.[0] ?? {};
        const fieldKey = (0, $4yZQ6.getActionData)(action).fieldKey;
        const lookupKey = (0, $4yZQ6.createLookupKey)(fieldKey, issueIdOrKey); // Track the invalid action keys to be used for analytics + rendering the correct system message
        setInvalidActionKeys((prev)=>{
            const updated = new Set(prev);
            updated.add(lookupKey);
            return updated;
        });
    }, [
        setInvalidActionKeys
    ]);
    const validActions = (0, $cozmU.useMemo)(()=>{
        const filteredActions = actions.filter((action)=>(0, $4yZQ6.validateJiraUpdateWorkAllFieldTypesAction)(action).isValid);
        return (0, $4yZQ6.deduplicateActions)(filteredActions);
    }, [
        actions
    ]);
    const numInvalidActions = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('jira-track-invalid-update-workitem-actions')) return 0;
        return actions.filter((action)=>!(0, $4yZQ6.validateJiraUpdateWorkAllFieldTypesAction)(action).isValid).length;
    }, [
        actions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (numInvalidActions === 0) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'detected',
            actionSubject: 'invalidActions',
            actionSubjectId: 'updateWorkActionRenderer',
            attributes: {
                numActions: actions.length,
                numInvalidActions: numInvalidActions,
                messageId: messageId
            }
        });
    }, [
        actions.length,
        numInvalidActions,
        messageId,
        sendAnalyticsEvent
    ]); // An "active action" is one that is not cancelled (so idle, accepted, or failed). We filter out cancelled actions so they are removed from view
    // as per product requirements. If an action card has no active actions, it will be unmounted.
    const validNonCancelledActions = (0, $cozmU.useMemo)(()=>validActions.filter((action)=>!(action.status === 'cancelled' || getEffectiveStatus(action) === 'cancelled') && !invalidActionKeys.has((0, $4yZQ6.createLookupKey)((0, $4yZQ6.getActionData)(action).fieldKey, (0, $4yZQ6.getActionData)(action).issueIdOrKey))), [
        validActions,
        getEffectiveStatus,
        invalidActionKeys
    ]);
    const cancelledActions = (0, $cozmU.useMemo)(()=>validActions.filter((action)=>action.status === 'cancelled' || getEffectiveStatus(action) === 'cancelled'), [
        validActions,
        getEffectiveStatus
    ]);
    const { singleActions: singleActions, bulkActions: bulkActions } = (0, $cozmU.useMemo)(()=>(0, $4yZQ6.getSingleAndBulkActions)(validNonCancelledActions), [
        validNonCancelledActions
    ]); // `allActionsAccepted` and `allActionsCancelled` are used to determine whether to render the system message for all actions accepted or cancelled.
    // Note that we consider the single actions only, as the bulk actions themselves are not rendered for the user. This does however consider the case
    // where a bulk action is accepted/cancelled, in which case the status of the single actions will be updated to calculate these two values.
    const allActionsAccepted = (0, $cozmU.useMemo)(()=>singleActions.every((action)=>action.status === 'finished' || getEffectiveStatus(action) === 'finished'), [
        singleActions,
        getEffectiveStatus
    ]);
    const allActionsCancelled = (0, $cozmU.useMemo)(()=>singleActions.length === 0, [
        singleActions
    ]); // Using validActions instead of validNonCancelledActions as if validNonCancelledActions changes when a user dismisses all suggestions for an issue, we would
    // re-fetch the Relay query, and see an unexpected loading skeleton, which may be more expensive than fetching some unused data.
    const jqlString = (0, $cozmU.useMemo)(()=>(0, $4yZQ6.buildJqlForActions)(validActions), [
        validActions
    ]); // Retrieve a list of field keys to fetch in our relay query
    const fieldsToUpdate = (0, $cozmU.useMemo)(()=>{
        const fieldKeysSet = new Set(validActions.map((action)=>Object.keys(action.data.updates?.[0]?.fields ?? {})).flat()); // As timespent is a custom field but we still need to fetch data from JiraTimeTrackingField, we manually add the
        // field id to the list of fields to fetch.
        if (validActions.some((action)=>action.data.updates?.[0]?.fields?.hasOwnProperty('timespent'))) {
            // Swap out timespent for timetracking to fetch the correct data from JiraTimeTrackingField. timespent will map
            // to a JiraDurationField which is not relevant for this action, and will hence render a second unrelated field suggestion.
            fieldKeysSet.add('timetracking');
            fieldKeysSet.delete('timespent');
        }
        return Array.from(fieldKeysSet).sort();
    }, [
        validActions
    ]); // A list of sprint ARIs to pass in to retrieve sprint names for the sprint field fragment.
    const sprintAris = (0, $cozmU.useMemo)(()=>{
        const set = validActions.reduce((acc, action)=>{
            const { fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action); // Note that we are checking whether the field value itself is an integer instead of whether the field key
            // is "sprint", as sprint is a custom field and can have its key as `customfield_10001` etc.
            // Ideally, we could use the actionToFieldTypeMap to determine whether the field is a sprint, but it creates a circular
            // dependency as the actionToFieldTypeMap depends on the Relay query, but we need to pass the sprint ARIs into the query
            // as a variable.
            // For fields with values that are also integers (e.g story points), this means we create unused ARIs. As the ARI creation
            // is cheap and such dummy ARIs would not return a valid sprint in the Relay query, we can safely ignore these.
            const maybeSprintId = Number.isInteger(Number(fieldValue)) ? fieldValue?.toString() : null;
            if (!maybeSprintId || !jiraActivationId) return acc;
            acc.add((0, $amxY5.JiraSprintAri).create({
                siteId: cloudId,
                activationId: jiraActivationId,
                sprintId: maybeSprintId
            }).toString());
            return acc;
        }, new Set());
        return Array.from(set);
    }, [
        validActions,
        cloudId,
        jiraActivationId
    ]);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $ENvWX.default), {
        cloudId: cloudId,
        jql: jqlString,
        fieldIdsOrAliases: fieldsToUpdate,
        sprintAris: sprintAris
    });
    const groupedActions = (0, $cozmU.useMemo)(()=>(0, $4yZQ6.groupActionsByIssue)(singleActions, cloudId, data.jira?.issueSearch?.edges), [
        singleActions,
        cloudId,
        data.jira?.issueSearch?.edges
    ]); // On each render, check all `update-all-field-types` actions to see if they have 'finished', 'errored' or 'cancelled'. If so,
    // we mark the corresponding single field actions as 'finished', 'errored' or 'cancelled' respectively.
    (0, $cozmU.useEffect)(()=>{
        // Track single field actions that should be marked as finished or errored.
        const actionsToFinish = new Set();
        const actionsToError = new Set();
        for (const bulkAction of bulkActions){
            const { issueIdOrKey: issueIdOrKey } = bulkAction.data.updates?.[0] ?? {}; // Get fieldKeys for the bulk action which are still planned and idle
            const fieldKeysForBulkAction = validActions.filter((action)=>action.data.updates?.[0]?.issueIdOrKey === issueIdOrKey && action.status === 'planned' && getEffectiveStatus(action) === 'idle').map((action)=>(0, $4yZQ6.getActionData)(action).fieldKey); // Retrieve field keys from the sanitized `update-all-field-types` action, and depending
            // on the status of the `update-all-field-types` action, we mark the corresponding single
            // field actions as 'finished' or 'errored' if necessary.
            fieldKeysForBulkAction.forEach((fieldKey)=>{
                const lookupKey = (0, $4yZQ6.createLookupKey)(fieldKey, issueIdOrKey);
                if (bulkAction.status === 'finished' || getStatus(bulkAction) === 'finished') actionsToFinish.add(lookupKey);
                else if (bulkAction.status === 'errored' || getStatus(bulkAction) === 'errored') actionsToError.add(lookupKey);
            });
        } // Update state if there are new finished or erroredactions
        if (actionsToFinish.size > 0) setBulkAcceptedActionKeys((prev)=>{
            const updated = new Set(prev);
            actionsToFinish.forEach((key)=>updated.add(key));
            return updated;
        });
        if (actionsToError.size > 0) setBulkErroredActionKeys((prev)=>{
            const updated = new Set(prev);
            actionsToError.forEach((key)=>updated.add(key));
            return updated;
        });
    }, [
        validActions,
        bulkActions,
        setBulkAcceptedActionKeys,
        setBulkErroredActionKeys,
        getEffectiveStatus,
        getStatus
    ]); // Create a mapping from action to fieldType using the key format `issueId-fieldKey` to be used in analytics.
    const actionToFieldTypeMap = (0, $cozmU.useMemo)(()=>{
        const map = new Map();
        const issueSearch = data.jira?.issueSearch;
        if (!issueSearch?.edges) return map;
        validActions.forEach((action)=>{
            const issueAri = (0, $4yZQ6.actionToIssueAri)(action, cloudId, data.jira?.issueSearch?.edges);
            if (!issueAri) return;
            if (!map.has(issueAri)) map.set(issueAri, new Map());
             // Find matching edge with ARI
            const matchingEdge = issueSearch?.edges?.find((edge)=>edge?.node?.id === issueAri);
            const fieldKeys = Object.keys(action.data.updates?.[0]?.fields ?? {});
            if (matchingEdge?.node?.fieldsByIdOrAlias) fieldKeys.forEach((fieldKey)=>{
                const matchingField = matchingEdge?.node?.fieldsByIdOrAlias?.find((field)=>field?.fieldId === fieldKey);
                if (matchingField?.type) map.get(issueAri)?.set(fieldKey, matchingField.type);
            });
        });
        return map;
    }, [
        data.jira?.issueSearch,
        validActions,
        cloudId
    ]); // Helper function used to get the field type for each action - used for sending meaningful analytics events.
    // Only for single field actions
    const getFieldTypeForFieldKey = (0, $cozmU.useCallback)((action, fieldKey)=>{
        const issueAri = (0, $4yZQ6.actionToIssueAri)(action, cloudId, data.jira?.issueSearch?.edges);
        if (!issueAri) return undefined;
        return actionToFieldTypeMap.get(issueAri)?.get(fieldKey) ?? fieldKey;
    }, [
        actionToFieldTypeMap,
        cloudId,
        data.jira?.issueSearch?.edges
    ]);
    const getAllFieldTypesForAction = (0, $cozmU.useCallback)((action)=>{
        const issueAri = (0, $4yZQ6.actionToIssueAri)(action, cloudId, data.jira?.issueSearch?.edges);
        if (!issueAri) return [];
        const fieldKeys = Object.keys(action.data.updates?.[0]?.fields ?? {});
        return fieldKeys.map((fieldKey)=>actionToFieldTypeMap.get(issueAri)?.get(fieldKey) ?? fieldKey);
    }, [
        actionToFieldTypeMap,
        cloudId,
        data.jira?.issueSearch?.edges
    ]);
    const onApplyAll = (0, $cozmU.useCallback)(async ()=>{
        setisBulkActioning(true); // Group by field type to be used for analytics
        const fields = bulkActions.filter((action)=>action.status === 'planned' && getEffectiveStatus(action) === 'idle').map((action)=>getAllFieldTypesForAction(action)).flat();
        const fieldTypeCounts = fields.reduce((acc, fieldType)=>{
            acc[fieldType] = (acc[fieldType] || 0) + 1;
            return acc;
        }, {}); // Fire event for Apply all button being clicked
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'updateWorkApplyAll',
            attributes: {
                numFields: fields.length,
                fieldTypeCounts: fieldTypeCounts
            }
        }); // Fire confirm events for all idle actions and wait for them to complete
        const edges = data.jira?.issueSearch?.edges ?? [];
        await Promise.all(bulkActions.filter((action)=>action.status === 'planned' && getEffectiveStatus(action) === 'idle').map(async (action)=>{
            const cleanedAction = (0, $4yZQ6.cleanFieldsForBulkAction)(action, validActions, getEffectiveStatus);
            let fieldKeys;
            let payloadToSend;
            const validFieldIds = (0, $4yZQ6.getValidFieldIdsForAction)(action, cloudId, edges);
            const cleanedFields = cleanedAction.data.updates?.[0]?.fields ?? {};
            const filteredFields = Object.fromEntries(Object.entries(cleanedFields).filter(([key])=>validFieldIds.has(key)));
            fieldKeys = Object.keys(filteredFields);
            if (fieldKeys.length > 0) {
                const update = cleanedAction.data.updates[0];
                payloadToSend = {
                    updates: [
                        {
                            issueIdOrKey: update?.issueIdOrKey ?? (0, $4yZQ6.getActionData)(action).issueIdOrKey,
                            fields: filteredFields
                        }
                    ],
                    ...action.data.sourceUrl && {
                        sourceUrl: action.data.sourceUrl
                    }
                };
            } else payloadToSend = undefined;
            if (payloadToSend && fieldKeys.length > 0) {
                await onCustomDataConfirm(action, payloadToSend);
                for (const fieldKey of fieldKeys)sendAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'updateWorkAccept',
                    attributes: {
                        fieldType: getFieldTypeForFieldKey(action, fieldKey),
                        hasReasoning: !!action.data.updates?.[0]?.fieldReasoning?.[fieldKey],
                        hasSourceUrl: !!action.data?.sourceUrl,
                        ...(0, $iDrrr.fg)('add-source-in-update-workitem-analytics') ? {
                            sourceUrlType: (0, $buzLI.classifySourceUrl)(action.data?.sourceUrl)
                        } : {},
                        bulkActioned: true
                    }
                });
            }
        }));
        setisBulkActioning(false);
    }, [
        bulkActions,
        validActions,
        onCustomDataConfirm,
        sendAnalyticsEvent,
        getFieldTypeForFieldKey,
        getAllFieldTypesForAction,
        getEffectiveStatus,
        cloudId,
        data?.jira?.issueSearch?.edges
    ]);
    const onDismissAll = (0, $cozmU.useCallback)(async ()=>{
        setisBulkActioning(true); // Group by field type to be used for analytics
        const fields = singleActions.filter((action)=>action.status === 'planned' && getEffectiveStatus(action) === 'idle').map((action)=>getAllFieldTypesForAction(action)).flat();
        const fieldTypeCounts = fields.reduce((acc, fieldType)=>{
            acc[fieldType] = (acc[fieldType] || 0) + 1;
            return acc;
        }, {}); // Fire event for Dismiss all button being clicked
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'updateWorkDismissAll',
            attributes: {
                numFields: fields.length,
                fieldTypeCounts: fieldTypeCounts
            }
        }); // Fire cancel events for all idle actions
        await Promise.all(singleActions.filter((action)=>action.status === 'planned' && getEffectiveStatus(action) === 'idle').map(async (action)=>{
            await onCancel(action);
            const { fieldKey: fieldKey } = (0, $4yZQ6.getActionData)(action);
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'updateWorkDismiss',
                attributes: {
                    fieldType: getFieldTypeForFieldKey(action, fieldKey),
                    hasReasoning: !!action.data.updates?.[0]?.fieldReasoning?.[fieldKey],
                    hasSourceUrl: !!action.data?.sourceUrl,
                    bulkActioned: true
                }
            });
        }));
        setisBulkActioning(false);
    }, [
        onCancel,
        sendAnalyticsEvent,
        getFieldTypeForFieldKey,
        getAllFieldTypesForAction,
        getEffectiveStatus,
        singleActions
    ]);
    const areActionButtonsDisabled = (0, $cozmU.useMemo)(()=>(0, $4yZQ6.areBulkActionButtonsDisabled)(singleActions, getStatus, getReadonly), [
        singleActions,
        getStatus,
        getReadonly
    ]);
    const actionCards = (0, $cozmU.useMemo)(()=>{
        if (validNonCancelledActions.length === 0) return null;
        const issueSearch = data.jira?.issueSearch;
        if (!issueSearch) return null;
         // When FG is on: only show a card for an issue if at least one of its actions has a field returned by the API (fieldsByIdOrAlias).
        // Otherwise we would render an empty card (header with no field rows).
        return issueSearch?.edges?.reduce((cards, edge)=>{
            if (!edge?.node) return cards;
            const issueActions = groupedActions.get(edge.node.id);
            if (!issueActions || issueActions.length === 0) return cards;
            if (issueActions.every((action)=>action.status === 'cancelled' || getEffectiveStatus(action) === 'cancelled')) return cards;
            const apiFieldIds = new Set(edge.node.fieldsByIdOrAlias?.map((f)=>f?.fieldId).filter((id)=>typeof id === 'string') ?? []);
            apiFieldIds.add('comment');
            apiFieldIds.add('issuelinks');
            if (apiFieldIds.has('timetracking')) apiFieldIds.add('timespent');
            const hasAtLeastOneVisibleField = issueActions.some((action)=>{
                const fieldKeys = Object.keys(action.data.updates?.[0]?.fields ?? {});
                return fieldKeys.some((fk)=>apiFieldIds.has(fk));
            });
            if (!hasAtLeastOneVisibleField) return cards;
            cards.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: `${edge.node.id}-${edge.node.key}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hPfeh.ActionCard), {
                cloudId: cloudId,
                queryRef: edge.node,
                actions: issueActions,
                onCustomDataConfirm: onCustomDataConfirm,
                onCancel: onCancel,
                getStatus: getEffectiveStatus,
                getReadonly: getReadonly,
                shouldExpand: cards.length === 0,
                isBulkActioning: isBulkActioning,
                showButtons: showButtons,
                onInvalidAction: onInvalidAction,
                ...props
            })));
            return cards;
        }, []);
    }, [
        data.jira?.issueSearch,
        validNonCancelledActions,
        cloudId,
        onCustomDataConfirm,
        onCancel,
        getEffectiveStatus,
        getReadonly,
        props,
        isBulkActioning,
        groupedActions,
        onInvalidAction,
        showButtons
    ]); // Use validActions instead of validNonCancelledActions as a cancelled action may contain a sourceUrl which provides context for the suggestions.
    const canonicalSourceUrlBase = (0, $cozmU.useMemo)(()=>{
        const urls = validActions?.map((action)=>(0, $4yZQ6.getActionData)(action).sourceUrl)?.filter((url)=>typeof url === 'string' && url.length > 0) ?? [];
        if (urls.length === 0) return undefined;
        const groupedUrlsByFrequency = (0, $1inBu.groupUrlsByFrequency)(urls, {
            ignoreInvalid: true
        }); // Return the most frequent URL's base (origin + pathname)
        return groupedUrlsByFrequency?.[0]?.base;
    }, [
        validActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (actionCards && actionCards.length > 0) {
            const fields = validActions.filter((action)=>action.status === 'planned' && getEffectiveStatus(action) === 'idle').filter((action)=>Object.keys(action.data.updates?.[0]?.fields ?? {}).length === 1).map((action)=>getAllFieldTypesForAction(action)).flat(); // Group by field type to be used for analytics
            const fieldTypeCounts = fields.reduce((acc, fieldType)=>{
                acc[fieldType] = (acc[fieldType] || 0) + 1;
                return acc;
            }, {});
            const sourceUrlAttributes = (0, $iDrrr.fg)('add-source-in-update-workitem-analytics') ? {
                hasSourceUrl: canonicalSourceUrlBase !== undefined,
                sourceUrlType: (0, $buzLI.classifySourceUrl)(canonicalSourceUrlBase)
            } : {};
            sendAnalyticsEvent({
                action: 'rendered',
                actionSubject: 'component',
                actionSubjectId: 'updateWorkActionRenderer',
                attributes: {
                    numActionCards: actionCards.length,
                    numFields: fields.length,
                    fieldTypeCounts: fieldTypeCounts,
                    ...sourceUrlAttributes
                }
            });
        } // Empty dependency array to ensure that we only fire the analytics event once when the component renders and there are action cards.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // This single field action counts includes cancelled actions (whereas the singleActions variable does not). This helps
    // to deduce whether we are cancelling because of invalid fields or because a user actually dismissed an issue.
    const singleFieldActionCount = actions.filter((action)=>Object.keys(action.data.updates?.[0]?.fields ?? {}).length === 1).length; // When all valid actions are cancelled, render the system message
    if (cancelledActions.length && allActionsCancelled && invalidActionKeys.size !== singleFieldActionCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1johS.SystemMessage), {
        message: formatMessage((0, $7832B.messages).allActionsDismissed)
    });
     // When no cards are shown (e.g. all filtered out due to no visible fields) but we have valid actions, show message
    if (actionCards?.length === 0 || !actionCards) {
        if (validNonCancelledActions.length > 0 || invalidActionKeys.size === singleFieldActionCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1johS.SystemMessage), {
            message: formatMessage((0, $7832B.messages).noValidSuggestionsProvided),
            variant: "error"
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2esis.CardGroupContext), {
        sourceUrl: canonicalSourceUrlBase
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $ccdf9905c07629e4$var$styles.cardGroup,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $ccdf9905c07629e4$var$styles.cardsContainer
    }, actionCards), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jtMHU.CardGroupFooter), {
        onDismiss: onDismissAll,
        onApplyUpdates: onApplyAll,
        isDisabled: areActionButtonsDisabled,
        allActionsApplied: allActionsAccepted,
        isBulkActioning: isBulkActioning
    })), allActionsAccepted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1johS.SystemMessage), {
        message: formatMessage((0, $7832B.messages).allActionsAccepted)
    }));
});
module.exports["JiraUpdateWorkItemAllFieldTypesActionRenderer"] = $ccdf9905c07629e4$export$eb362734876d260b;

});

parcelRegister("j56L4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $84af05fa8fc91a07$export$d30b0267e3217ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            testId: "conversation-assistant.ui.card-renderer-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "16px",
            height: "16px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "170px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "200px",
            height: "16px"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        testId: "conversation-assistant.ui.card-renderer-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "16px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "170px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "16px"
    }));
};
module.exports["JiraUpdateWorkItemAllFieldTypesActionSkeleton"] = $84af05fa8fc91a07$export$d30b0267e3217ff;

});

parcelRegister("4yZQ6", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $3iWYJ = parcelRequire("3iWYJ");

var $a0unS = parcelRequire("a0unS");

var $1eov5 = parcelRequire("1eov5");

var $9LE5K = parcelRequire("9LE5K");


var $fjKr7 = parcelRequire("fjKr7");


var $dw75i = parcelRequire("dw75i");

const $8f30fc7e095b8bf4$export$ef953aafdc8d048e = 'id';
const $8f30fc7e095b8bf4$export$6421c8415cdbc817 = 'key';
const $8f30fc7e095b8bf4$var$serializableValueSchema = (0, $87Lnp.z).lazy(()=>(0, $87Lnp.z).union([
        (0, $87Lnp.z).string(),
        (0, $87Lnp.z).number(),
        (0, $87Lnp.z).boolean(),
        (0, $87Lnp.z).null(),
        (0, $87Lnp.z).undefined(),
        (0, $87Lnp.z).array($8f30fc7e095b8bf4$var$serializableValueSchema),
        (0, $87Lnp.z).record($8f30fc7e095b8bf4$var$serializableValueSchema)
    ]));
const $8f30fc7e095b8bf4$var$payloadSchema = (0, $87Lnp.z).object({
    issueIdOrKey: (0, $87Lnp.z).string(),
    fields: (0, $87Lnp.z).record((0, $87Lnp.z).string(), $8f30fc7e095b8bf4$var$serializableValueSchema).refine((obj)=>Object.keys(obj).length > 0, {
        message: 'fields object cannot be empty'
    }),
    fieldReasoning: (0, $87Lnp.z).record((0, $87Lnp.z).string(), (0, $87Lnp.z).string()).optional()
});
const $8f30fc7e095b8bf4$var$actionSchema = (0, $87Lnp.z).object({
    key: (0, $87Lnp.z).literal((0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes),
    data: (0, $87Lnp.z).object({
        updates: (0, $87Lnp.z).array($8f30fc7e095b8bf4$var$payloadSchema).refine((updates)=>updates.length > 0, {
            message: 'updates array cannot be empty'
        }),
        sourceUrl: (0, $87Lnp.z).string().optional()
    })
});
const $8f30fc7e095b8bf4$export$dfdc9568453d2c31 = (fieldKey, issueIdOrKey)=>`${fieldKey}:${issueIdOrKey}`;
const $8f30fc7e095b8bf4$export$19491bbdba92da19 = (action)=>{
    const { fields: fields, fieldReasoning: fieldReasoning, issueIdOrKey: issueIdOrKey } = action.data.updates[0];
    const { sourceUrl: sourceUrl } = action.data ?? {};
    const fieldKey = Object.keys(fields)?.[0] || '';
    const fieldValue = fieldKey ? fields[fieldKey] : '';
    const reasoning = fieldKey && fieldReasoning ? fieldReasoning[fieldKey] : '';
    return {
        issueIdOrKey: issueIdOrKey,
        fieldKey: fieldKey,
        fieldValue: fieldValue,
        fieldReasoning: reasoning,
        sourceUrl: sourceUrl
    };
};
const $8f30fc7e095b8bf4$export$a67159d3a7facf9e = (issueKey)=>issueKey.match(/^[A-Za-z0-9]+-\d+$/) !== null;
const $8f30fc7e095b8bf4$export$b05a5cf95fb70bbf = (issueId)=>Number.isInteger(Number(issueId));
function $8f30fc7e095b8bf4$export$d27b84887f7a6e1f(action) {
    const parsed = $8f30fc7e095b8bf4$var$actionSchema.safeParse(action);
    if (parsed.success) return {
        isValid: true,
        action: action
    };
    return {
        isValid: false,
        error: new Error(`Invalid ${action.key || 'unkown'} action payload: ${parsed.error.message}`)
    };
}
const $8f30fc7e095b8bf4$var$SUPPORTED_FIELD_KEYS = new Set([
    'summary',
    'description',
    'assignee',
    'reporter',
    'priority',
    'status',
    'labels',
    'parent',
    'duedate',
    'comment',
    'issuelinks',
    'issuetype',
    'timespent'
]);
const $8f30fc7e095b8bf4$var$OTHER_FIELD_TYPE = 'other';
const $8f30fc7e095b8bf4$var$CUSTOM_FIELD_TYPE = 'customfield';
const $8f30fc7e095b8bf4$var$CUSTOM_FIELD_KEY_PATTERN = /^customfield_\d+$/;
const $8f30fc7e095b8bf4$export$8979f760d37446e7 = (fieldKey)=>{
    if ($8f30fc7e095b8bf4$var$SUPPORTED_FIELD_KEYS.has(fieldKey)) return fieldKey;
    if ($8f30fc7e095b8bf4$var$CUSTOM_FIELD_KEY_PATTERN.test(fieldKey)) return $8f30fc7e095b8bf4$var$CUSTOM_FIELD_TYPE;
    return $8f30fc7e095b8bf4$var$OTHER_FIELD_TYPE;
};
const $8f30fc7e095b8bf4$export$9c8227fe89c4f5a1 = (validActions, cloudId, edges = [])=>{
    const groupedActions = new Map();
    for (const action of validActions){
        // Actions with multiple fields are bulk actions and hence should not render, but should be marked as bulk actions
        const issueAri = $8f30fc7e095b8bf4$export$79cf32c9542284db(action, cloudId, edges);
        if (issueAri) {
            const existingActions = groupedActions.get(issueAri) || [];
            groupedActions.set(issueAri, [
                ...existingActions,
                action
            ]);
        }
    }
    return groupedActions;
};
const $8f30fc7e095b8bf4$export$98957c25de2a7b7 = (actions)=>{
    // Retrieve the issueIds or issueKeys to formulate the JQL in our relay query
    const issueIdsOrKeys = Array.from(new Set(actions.map((action)=>$8f30fc7e095b8bf4$export$19491bbdba92da19(action).issueIdOrKey)));
    const issueIds = issueIdsOrKeys.filter((issueId)=>$8f30fc7e095b8bf4$export$b05a5cf95fb70bbf(issueId));
    const issueKeys = issueIdsOrKeys.filter((issueKey)=>$8f30fc7e095b8bf4$export$a67159d3a7facf9e(issueKey));
    const jqlQuery = (0, $a0unS.default).query();
    if (issueIds.length > 0) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field($8f30fc7e095b8bf4$export$ef953aafdc8d048e), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_IN)), (0, $a0unS.default).listOperand(issueIds.map((0, $a0unS.default).valueOperand))), (0, $3iWYJ.COMPOUND_OPERATOR_OR));
    if (issueKeys.length > 0) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field($8f30fc7e095b8bf4$export$6421c8415cdbc817), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_IN)), (0, $a0unS.default).listOperand(issueKeys.map((0, $a0unS.default).valueOperand))), (0, $3iWYJ.COMPOUND_OPERATOR_OR));
    const jast = (0, $a0unS.default).jast(jqlQuery);
    return (0, $9LE5K.print)(jast);
};
function $8f30fc7e095b8bf4$export$bc23bfcf126e93ae(actions, getStatus, getReadonly) {
    if (actions.length === 0) return true;
    return actions.some((action)=>{
        if (!(getStatus(action) === 'idle' || getStatus(action) === 'finished' || action.status === 'finished')) return true;
        if (getReadonly(action) && !(getStatus(action) === 'finished' || action.status === 'finished')) return true;
        return false;
    });
}
const $8f30fc7e095b8bf4$export$73a9a601a4562451 = (actions)=>{
    const singleActions = actions.filter((action)=>Object.keys(action.data.updates?.[0]?.fields ?? {}).length === 1);
    const bulkActions = actions.filter((action)=>Object.keys(action.data.updates?.[0]?.fields ?? {}).length > 1);
    const bulkActionKeys = new Set(bulkActions.map((action)=>$8f30fc7e095b8bf4$export$19491bbdba92da19(action).issueIdOrKey));
    // Single actions whose issue has no bulk action are also shown as "bulk" (single-issue group).
    singleActions.filter((action)=>!bulkActionKeys.has($8f30fc7e095b8bf4$export$19491bbdba92da19(action).issueIdOrKey)).forEach((action)=>bulkActions.push(action));
    return {
        singleActions: singleActions,
        bulkActions: bulkActions
    };
};
const $8f30fc7e095b8bf4$export$79cf32c9542284db = (action, cloudId, edges = [])=>{
    const issueIdOrKey = $8f30fc7e095b8bf4$export$19491bbdba92da19(action).issueIdOrKey;
    if ($8f30fc7e095b8bf4$export$b05a5cf95fb70bbf(issueIdOrKey)) return (0, $fjKr7.JiraIssueAri).create({
        siteId: cloudId,
        issueId: issueIdOrKey
    }).toString();
    if ($8f30fc7e095b8bf4$export$a67159d3a7facf9e(issueIdOrKey)) {
        const issue = edges?.find((edge)=>edge?.node?.key === issueIdOrKey);
        // If issue can be found, use its ARI, otherwise return null.
        if (issue?.node?.id) return issue?.node?.id;
    }
    return null;
};
const $8f30fc7e095b8bf4$export$72fb9a87f8ed6ccf = (actions)=>{
    const deduplicatedActions = [];
    const seenActions = new Set();
    for (const action of actions){
        const { issueIdOrKey: issueIdOrKey } = $8f30fc7e095b8bf4$export$19491bbdba92da19(action);
        const fieldKeys = Object.keys(action.data.updates[0].fields);
        const uniqueKey = `${fieldKeys.join(',')}:${issueIdOrKey}`;
        if (!seenActions.has(uniqueKey)) {
            seenActions.add(uniqueKey);
            deduplicatedActions.push(action);
        }
    }
    return deduplicatedActions;
};
const $8f30fc7e095b8bf4$export$18a326c7a5e3e9fd = (action)=>action.key === (0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes;
const $8f30fc7e095b8bf4$export$a1deaf62d7c20f9d = (bulkAction, actions, getEffectiveStatus)=>{
    const { issueIdOrKey: issueIdOrKey } = $8f30fc7e095b8bf4$export$19491bbdba92da19(bulkAction);
    const fieldsToRemove = new Set(actions.filter((action)=>Object.keys(action.data.updates?.[0]?.fields ?? {}).length === 1).filter((action)=>$8f30fc7e095b8bf4$export$19491bbdba92da19(action).issueIdOrKey === issueIdOrKey).filter((action)=>!(action.status === 'planned' && getEffectiveStatus(action) === 'idle')).map((action)=>$8f30fc7e095b8bf4$export$19491bbdba92da19(action).fieldKey));
    const updatedFields = Object.fromEntries(Object.entries(bulkAction.data.updates[0].fields).filter(([key])=>!fieldsToRemove.has(key)));
    return {
        data: {
            updates: [
                {
                    issueIdOrKey: issueIdOrKey,
                    fields: updatedFields
                }
            ]
        }
    };
};
const $8f30fc7e095b8bf4$export$408f85e80f682de1 = (action, cloudId, edges = [])=>{
    const issueAri = $8f30fc7e095b8bf4$export$79cf32c9542284db(action, cloudId, edges);
    if (!issueAri) return new Set();
    const edge = edges?.find((e)=>e?.node?.id === issueAri);
    const fieldIds = edge?.node?.fieldsByIdOrAlias?.map((f)=>f?.fieldId) ?? [];
    const apiFieldIds = new Set(fieldIds.filter((id)=>typeof id === 'string'));
    // 'comment' is not in fieldsByIdOrAlias but is always valid for the payload.
    apiFieldIds.add('comment');
    // 'issuelinks' is not in fieldsByIdOrAlias but is always valid for the payload.
    apiFieldIds.add('issuelinks');
    // timespent is requested as timetracking in the query; if API returned timetracking, allow timespent in payload.
    if (apiFieldIds.has('timetracking')) apiFieldIds.add('timespent');
    return apiFieldIds;
};
module.exports["ISSUE_ID_FIELD_KEY"] = $8f30fc7e095b8bf4$export$ef953aafdc8d048e;
module.exports["ISSUE_KEY_FIELD_KEY"] = $8f30fc7e095b8bf4$export$6421c8415cdbc817;
module.exports["createLookupKey"] = $8f30fc7e095b8bf4$export$dfdc9568453d2c31;
module.exports["getActionData"] = $8f30fc7e095b8bf4$export$19491bbdba92da19;
module.exports["isIssueKey"] = $8f30fc7e095b8bf4$export$a67159d3a7facf9e;
module.exports["isIssueId"] = $8f30fc7e095b8bf4$export$b05a5cf95fb70bbf;
module.exports["validateJiraUpdateWorkAllFieldTypesAction"] = $8f30fc7e095b8bf4$export$d27b84887f7a6e1f;
module.exports["toReportableFieldType"] = $8f30fc7e095b8bf4$export$8979f760d37446e7;
module.exports["groupActionsByIssue"] = $8f30fc7e095b8bf4$export$9c8227fe89c4f5a1;
module.exports["actionToIssueAri"] = $8f30fc7e095b8bf4$export$79cf32c9542284db;
module.exports["buildJqlForActions"] = $8f30fc7e095b8bf4$export$98957c25de2a7b7;
module.exports["areBulkActionButtonsDisabled"] = $8f30fc7e095b8bf4$export$bc23bfcf126e93ae;
module.exports["getSingleAndBulkActions"] = $8f30fc7e095b8bf4$export$73a9a601a4562451;
module.exports["deduplicateActions"] = $8f30fc7e095b8bf4$export$72fb9a87f8ed6ccf;
module.exports["isUpdateWorkItemAllFieldsAction"] = $8f30fc7e095b8bf4$export$18a326c7a5e3e9fd;
module.exports["cleanFieldsForBulkAction"] = $8f30fc7e095b8bf4$export$a1deaf62d7c20f9d;
module.exports["getValidFieldIdsForAction"] = $8f30fc7e095b8bf4$export$408f85e80f682de1;

});

parcelRegister("gIOr8", function(module, exports) {

var $anCkD = parcelRequire("anCkD");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $buzLI = parcelRequire("buzLI");


var $7s5qz = parcelRequire("7s5qz");


var $iFSBV = parcelRequire("iFSBV");


var $jEnev = parcelRequire("jEnev");


var $gYXXv = parcelRequire("gYXXv");


var $9hll1 = parcelRequire("9hll1");


var $h0dXJ = parcelRequire("h0dXJ");


var $2TX7O = parcelRequire("2TX7O");

const $1ebe335e96039c53$var$styles = {
    cardGroup: "_23rrnH2HTN _0bjKvD8fU6 _0aFT5vbt8w _1UtDYzy7kJ _0KLXruqi9L _2OUyjtzwhj",
    cardsContainer: "_0Of8r22ADO _1wydGW2ADO"
};
const $1ebe335e96039c53$export$3da1cba73e070ce0 = /*#__PURE__*/ (0, $cozmU.memo)(({ cloudId: cloudId, actions: actions, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, getReadonly: getReadonly, showFooter: showFooter = true, showButtons: showButtons = true, ...props })=>{
    (0, $6cFsl.di)((0, $7s5qz.ActionCard), (0, $jEnev.CardGroupFooter));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isBulkActioning, setisBulkActioning] = (0, $cozmU.useState)(false);
    const validActions = (0, $cozmU.useMemo)(()=>{
        const filteredActions = actions.filter((action)=>(0, $2TX7O.validateJiraUpdateWorkItemFieldsAction)(action).isValid); // Ensure issueIds are capitalised so that if an issue key provided by the LLM is in lowercase, it can still
        // be matched to an issue.
        const capitalisedIssueIdActions = (0, $2TX7O.capitaliseActionIssueIds)(filteredActions);
        return (0, $2TX7O.deduplicateActions)(capitalisedIssueIdActions);
    }, [
        actions
    ]); // An "active action" is one that is not cancelled (so idle, accepted, or failed). We filter out cancelled actions so they are removed from view
    // as per product requirements. If an action card has no active actions, it will be unmounted.
    const validNonCancelledActions = (0, $cozmU.useMemo)(()=>validActions.filter((action)=>!(action.status === 'cancelled' || getStatus(action) === 'cancelled')), [
        validActions,
        getStatus
    ]);
    const allActionsCancelled = (0, $cozmU.useMemo)(()=>validActions.every((action)=>action.status === 'cancelled' || getStatus(action) === 'cancelled'), [
        validActions,
        getStatus
    ]);
    const allActionsApplied = (0, $cozmU.useMemo)(()=>validNonCancelledActions.every((action)=>action.status === 'finished' || getStatus(action) === 'finished'), [
        validNonCancelledActions,
        getStatus
    ]); // Using validActions instead of validNonCancelledActions as if validNonCancelledActions changes when a user dismisses all suggestions for an issue, we would
    // re-fetch the Relay query, and see an unexpected loading skeleton, which may be more expensive than fetching some unused data.
    const jqlString = (0, $cozmU.useMemo)(()=>(0, $2TX7O.buildJqlForActions)(validActions), [
        validActions
    ]); // Retrieve a list of field keys to fetch in our relay query
    const fieldsToUpdate = (0, $cozmU.useMemo)(()=>{
        const fieldKeysSet = new Set(validActions.map((action)=>action.data.fieldKey)); // As timespent is a custom field but we still need to fetch data from JiraTimeTrackingField, we manually add the
        // field id to the list of fields to fetch.
        if (validActions.some((action)=>action.data.fieldKey === 'timespent')) {
            // Swap out timespent for timetracking to fetch the correct data from JiraTimeTrackingField. timespent will map
            // to a JiraDurationField which is not relevant for this action, and will hence render a second unrelated field suggestion.
            fieldKeysSet.add('timetracking');
            fieldKeysSet.delete('timespent');
        }
        return Array.from(fieldKeysSet).sort();
    }, [
        validActions
    ]);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $anCkD.default), {
        cloudId: cloudId,
        jql: jqlString,
        fieldIdsOrAliases: fieldsToUpdate
    }); // Create a mapping from action to fieldType using the key format `issueId-fieldKey` to be used in analytics.
    const actionToFieldTypeMap = (0, $cozmU.useMemo)(()=>{
        const map = new Map();
        const issueSearch = data.jira?.issueSearch;
        if (!issueSearch?.edges) return map;
        validActions.forEach((action)=>{
            const issueAri = (0, $2TX7O.actionToIssueAri)(action, cloudId, data.jira?.issueSearch?.edges);
            if (!issueAri) return;
             // Find matching edge with ARI
            const matchingEdge = issueSearch?.edges?.find((edge)=>edge?.node?.id === issueAri);
            if (matchingEdge?.node?.fieldsByIdOrAlias) {
                // Find the field that matches the action's fieldKey
                const matchingField = matchingEdge?.node?.fieldsByIdOrAlias?.find((field)=>field?.fieldId === action.data.fieldKey); // Extract field type to be used in analytics
                if (matchingField?.type) map.set(issueAri, matchingField.type);
            }
        });
        return map;
    }, [
        data.jira?.issueSearch,
        validActions,
        cloudId
    ]); // Helper function used to get the field type for each action - used for sending meaningful analytics events.
    const getFieldTypeForAction = (0, $cozmU.useCallback)((action)=>{
        const issueAri = (0, $2TX7O.actionToIssueAri)(action, cloudId, data.jira?.issueSearch?.edges);
        if (!issueAri) return action.data.fieldKey;
        return actionToFieldTypeMap.get(issueAri) ?? action.data.fieldKey;
    }, [
        actionToFieldTypeMap,
        cloudId,
        data.jira?.issueSearch?.edges
    ]);
    const onApplyAll = (0, $cozmU.useCallback)(async ()=>{
        setisBulkActioning(true); // Group by field type to be used for analytics
        const fields = validNonCancelledActions?.filter((action)=>action.status === 'planned' && getStatus(action) === 'idle').map((action)=>getFieldTypeForAction(action));
        const fieldTypeCounts = fields.reduce((acc, fieldType)=>{
            acc[fieldType] = (acc[fieldType] || 0) + 1;
            return acc;
        }, {}); // Fire event for Apply all button being clicked
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'updateWorkApplyAll',
            attributes: {
                numFields: fields.length,
                fieldTypeCounts: fieldTypeCounts
            }
        }); // Fire confirm events for all idle actions and wait for them to complete
        await Promise.all(validNonCancelledActions.filter((action)=>action.status === 'planned' && getStatus(action) === 'idle').map(async (action)=>{
            await onConfirm(action);
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'updateWorkAccept',
                attributes: {
                    fieldType: getFieldTypeForAction(action),
                    hasReasoning: !!action.data.reasoning,
                    hasSourceUrl: !!action.data.sourceUrl,
                    ...(0, $iDrrr.fg)('add-source-in-update-workitem-analytics') ? {
                        sourceUrlType: (0, $buzLI.classifySourceUrl)(action.data.sourceUrl)
                    } : {},
                    bulkActioned: true
                }
            });
        }));
        setisBulkActioning(false);
    }, [
        validNonCancelledActions,
        onConfirm,
        sendAnalyticsEvent,
        getFieldTypeForAction,
        getStatus
    ]);
    const onDismissAll = (0, $cozmU.useCallback)(async ()=>{
        setisBulkActioning(true); // Group by field type to be used for analytics
        const fields = validNonCancelledActions?.filter((action)=>action.status === 'planned' && getStatus(action) === 'idle').map((action)=>getFieldTypeForAction(action));
        const fieldTypeCounts = fields.reduce((acc, fieldType)=>{
            acc[fieldType] = (acc[fieldType] || 0) + 1;
            return acc;
        }, {}); // Fire event for Dismiss all button being clicked
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'updateWorkDismissAll',
            attributes: {
                numFields: fields.length,
                fieldTypeCounts: fieldTypeCounts
            }
        }); // Fire cancel events for all idle actions
        await Promise.all(validNonCancelledActions.filter((action)=>action.status === 'planned' && getStatus(action) === 'idle').map(async (action)=>{
            await onCancel(action);
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'updateWorkDismiss',
                attributes: {
                    fieldType: getFieldTypeForAction(action),
                    hasReasoning: !!action.data.reasoning,
                    hasSourceUrl: !!action.data.sourceUrl,
                    bulkActioned: true
                }
            });
        }));
        setisBulkActioning(false);
    }, [
        validNonCancelledActions,
        onCancel,
        sendAnalyticsEvent,
        getFieldTypeForAction,
        getStatus
    ]);
    const areActionButtonsDisabled = (0, $cozmU.useMemo)(()=>(0, $2TX7O.areBulkActionButtonsDisabled)(validNonCancelledActions, getStatus, getReadonly), [
        validNonCancelledActions,
        getStatus,
        getReadonly
    ]);
    const actionCards = (0, $cozmU.useMemo)(()=>{
        if (validNonCancelledActions.length === 0) return null;
        const issueSearch = data.jira?.issueSearch;
        if (!issueSearch) return null;
        const groupedActions = (0, $2TX7O.groupActionsByIssue)(validNonCancelledActions, cloudId, issueSearch?.edges ?? []); // Use reduce to build the array of action cards and filter out null values. This is so we can simply expand the first action card by default.
        return issueSearch?.edges?.reduce((cards, edge)=>{
            if (!edge?.node) return cards;
            const issueActions = groupedActions.get(edge.node.id);
            if (!issueActions) return cards;
            cards.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: `${edge.node.id}-${edge.node.key}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7s5qz.ActionCard), {
                cloudId: cloudId,
                queryRef: edge.node,
                actions: issueActions,
                onConfirm: onConfirm,
                onCancel: onCancel,
                getStatus: getStatus,
                getReadonly: getReadonly,
                shouldExpand: cards.length === 0,
                showButtons: showButtons,
                ...props
            })));
            return cards;
        }, []);
    }, [
        data.jira?.issueSearch,
        validNonCancelledActions,
        cloudId,
        onConfirm,
        onCancel,
        getStatus,
        getReadonly,
        showButtons,
        props
    ]); // Use validActions instead of validNonCancelledActions as a cancelled action may contain a sourceUrl which provides context for the suggestions.
    const canonicalSourceUrlBase = (0, $cozmU.useMemo)(()=>{
        const urls = validActions?.map((action)=>action?.data?.sourceUrl)?.filter((url)=>typeof url === 'string' && url.length > 0) ?? [];
        if (urls.length === 0) return undefined;
        const groupedUrlsByFrequency = (0, $h0dXJ.groupUrlsByFrequency)(urls, {
            ignoreInvalid: true
        }); // Return the most frequent URL's base (origin + pathname)
        return groupedUrlsByFrequency?.[0]?.base;
    }, [
        validActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (actionCards && actionCards.length > 0) {
            const fields = validActions.filter((action)=>action.status === 'planned' && getStatus(action) === 'idle').map((action)=>getFieldTypeForAction?.(action)); // Group by field type to be used for analytics
            const fieldTypeCounts = fields.reduce((acc, fieldType)=>{
                acc[fieldType] = (acc[fieldType] || 0) + 1;
                return acc;
            }, {});
            const sourceUrlAttributes = (0, $iDrrr.fg)('add-source-in-update-workitem-analytics') ? {
                hasSourceUrl: canonicalSourceUrlBase !== undefined,
                sourceUrlType: (0, $buzLI.classifySourceUrl)(canonicalSourceUrlBase)
            } : {};
            sendAnalyticsEvent({
                action: 'rendered',
                actionSubject: 'component',
                actionSubjectId: 'updateWorkActionRenderer',
                attributes: {
                    numActionCards: actionCards.length,
                    numFields: fields.length,
                    fieldTypeCounts: fieldTypeCounts,
                    ...sourceUrlAttributes
                }
            });
        } // Empty dependency array to ensure that we only fire the analytics event once when the component renders and there are action cards.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // When all valid actions are cancelled, render the system message
    if (allActionsCancelled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9hll1.SystemMessage), {
        message: formatMessage((0, $gYXXv.messages).allActionsDismissed)
    });
    if (actionCards?.length === 0 || !actionCards) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFSBV.CardGroupContext), {
        sourceUrl: canonicalSourceUrlBase
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $1ebe335e96039c53$var$styles.cardGroup,
        testId: "update-work-item-fields-action-renderer.ui.action-card-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $1ebe335e96039c53$var$styles.cardsContainer
    }, actionCards), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jEnev.CardGroupFooter), {
        onDismiss: onDismissAll,
        onApplyUpdates: onApplyAll,
        isDisabled: areActionButtonsDisabled,
        allActionsApplied: allActionsApplied,
        isBulkActioning: isBulkActioning
    })), allActionsApplied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9hll1.SystemMessage), {
        message: formatMessage((0, $gYXXv.messages).allActionsAccepted)
    }));
});
module.exports["JiraUpdateWorkItemFieldsActionRenderer"] = $1ebe335e96039c53$export$3da1cba73e070ce0;

});

parcelRegister("5I0Ux", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $a697d6d507357efb$export$cdc4c82269dec2ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            testId: "conversation-assistant.ui.card-renderer-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "16px",
            height: "16px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "170px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "200px",
            height: "16px"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        testId: "conversation-assistant.ui.card-renderer-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "16px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "170px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "16px"
    }));
};
module.exports["JiraUpdateWorkItemFieldsActionSkeleton"] = $a697d6d507357efb$export$cdc4c82269dec2ed;

});

parcelRegister("2TX7O", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $3iWYJ = parcelRequire("3iWYJ");

var $a0unS = parcelRequire("a0unS");

var $1eov5 = parcelRequire("1eov5");

var $9LE5K = parcelRequire("9LE5K");


var $fjKr7 = parcelRequire("fjKr7");


var $dw75i = parcelRequire("dw75i");

const $51ea95642df64f3b$export$ef953aafdc8d048e = 'id';
const $51ea95642df64f3b$export$6421c8415cdbc817 = 'key';
const $51ea95642df64f3b$var$serializableValueSchema = (0, $87Lnp.z).lazy(()=>(0, $87Lnp.z).union([
        (0, $87Lnp.z).string(),
        (0, $87Lnp.z).number(),
        (0, $87Lnp.z).boolean(),
        (0, $87Lnp.z).null(),
        (0, $87Lnp.z).undefined(),
        (0, $87Lnp.z).array($51ea95642df64f3b$var$serializableValueSchema),
        (0, $87Lnp.z).record($51ea95642df64f3b$var$serializableValueSchema)
    ]));
const $51ea95642df64f3b$var$payloadSchema = (0, $87Lnp.z).object({
    issueId: (0, $87Lnp.z).string(),
    fieldKey: (0, $87Lnp.z).string().nonempty(),
    fieldValue: $51ea95642df64f3b$var$serializableValueSchema,
    sourceUrl: (0, $87Lnp.z).string().optional(),
    reasoning: (0, $87Lnp.z).string().optional()
});
const $51ea95642df64f3b$var$actionSchema = (0, $87Lnp.z).object({
    key: (0, $87Lnp.z).literal((0, $dw75i.ActionKeys).UpdateWorkItemFields),
    data: $51ea95642df64f3b$var$payloadSchema
});
const $51ea95642df64f3b$export$a67159d3a7facf9e = (issueKey)=>issueKey.match(/^[A-Za-z0-9]+-\d+$/) !== null;
const $51ea95642df64f3b$export$b05a5cf95fb70bbf = (issueId)=>Number.isInteger(Number(issueId));
function $51ea95642df64f3b$export$b06e0bb6f4acbdd2(action) {
    const parsed = $51ea95642df64f3b$var$actionSchema.safeParse(action);
    if (parsed.success) return {
        isValid: true,
        action: action
    };
    return {
        isValid: false,
        error: new Error(`Invalid ${action.key || 'unkown'} action payload: ${parsed.error.message}`)
    };
}
const $51ea95642df64f3b$export$9c8227fe89c4f5a1 = (validActions, cloudId, edges = [])=>validActions.reduce((groupedActions, action)=>{
        const issueAri = $51ea95642df64f3b$export$79cf32c9542284db(action, cloudId, edges);
        if (!issueAri) return groupedActions;
        const existingActions = groupedActions.get(issueAri) || [];
        groupedActions.set(issueAri, [
            ...existingActions,
            action
        ]);
        return groupedActions;
    }, new Map());
const $51ea95642df64f3b$export$98957c25de2a7b7 = (actions)=>{
    // Retrieve the issueIds or issueKeys to formulate the JQL in our relay query
    const issueIdsOrKeys = Array.from(new Set(actions.map((action)=>action.data.issueId)));
    const issueIds = issueIdsOrKeys.filter((issueId)=>$51ea95642df64f3b$export$b05a5cf95fb70bbf(issueId));
    const issueKeys = issueIdsOrKeys.filter((issueKey)=>$51ea95642df64f3b$export$a67159d3a7facf9e(issueKey));
    const jqlQuery = (0, $a0unS.default).query();
    if (issueIds.length > 0) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field($51ea95642df64f3b$export$ef953aafdc8d048e), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_IN)), (0, $a0unS.default).listOperand(issueIds.map((0, $a0unS.default).valueOperand))), (0, $3iWYJ.COMPOUND_OPERATOR_OR));
    if (issueKeys.length > 0) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field($51ea95642df64f3b$export$6421c8415cdbc817), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_IN)), (0, $a0unS.default).listOperand(issueKeys.map((0, $a0unS.default).valueOperand))), (0, $3iWYJ.COMPOUND_OPERATOR_OR));
    const jast = (0, $a0unS.default).jast(jqlQuery);
    return (0, $9LE5K.print)(jast);
};
function $51ea95642df64f3b$export$bc23bfcf126e93ae(actions, getStatus, getReadonly) {
    if (actions.length === 0) return true;
    return actions.some((action)=>{
        if (!(getStatus(action) === 'idle' || getStatus(action) === 'finished')) return true;
        if (getReadonly(action) && getStatus(action) !== 'finished') return true;
        return false;
    });
}
const $51ea95642df64f3b$export$79cf32c9542284db = (action, cloudId, edges = [])=>{
    const issueIdOrKey = action.data.issueId;
    if ($51ea95642df64f3b$export$b05a5cf95fb70bbf(issueIdOrKey)) return (0, $fjKr7.JiraIssueAri).create({
        siteId: cloudId,
        issueId: issueIdOrKey
    }).toString();
    if ($51ea95642df64f3b$export$a67159d3a7facf9e(issueIdOrKey)) {
        const issue = edges?.find((edge)=>edge?.node?.key === action.data.issueId);
        // If issue can be found, use its ARI, otherwise return null.
        if (issue?.node?.id) return issue?.node?.id;
    }
    return null;
};
const $51ea95642df64f3b$export$72fb9a87f8ed6ccf = (actions)=>{
    const deduplicatedActions = [];
    const seenActions = new Set();
    for (const action of actions){
        const { fieldKey: fieldKey, issueId: issueId } = action.data;
        const uniqueKey = `${fieldKey}:${issueId}`;
        if (!seenActions.has(uniqueKey)) {
            seenActions.add(uniqueKey);
            deduplicatedActions.push(action);
        }
    }
    return deduplicatedActions;
};
const $51ea95642df64f3b$export$8c57b7176c3bb320 = (actions)=>actions.map((action)=>({
            ...action,
            data: {
                ...action.data,
                issueId: action.data.issueId.toUpperCase()
            }
        }));
module.exports["ISSUE_ID_FIELD_KEY"] = $51ea95642df64f3b$export$ef953aafdc8d048e;
module.exports["ISSUE_KEY_FIELD_KEY"] = $51ea95642df64f3b$export$6421c8415cdbc817;
module.exports["isIssueKey"] = $51ea95642df64f3b$export$a67159d3a7facf9e;
module.exports["isIssueId"] = $51ea95642df64f3b$export$b05a5cf95fb70bbf;
module.exports["validateJiraUpdateWorkItemFieldsAction"] = $51ea95642df64f3b$export$b06e0bb6f4acbdd2;
module.exports["groupActionsByIssue"] = $51ea95642df64f3b$export$9c8227fe89c4f5a1;
module.exports["actionToIssueAri"] = $51ea95642df64f3b$export$79cf32c9542284db;
module.exports["buildJqlForActions"] = $51ea95642df64f3b$export$98957c25de2a7b7;
module.exports["areBulkActionButtonsDisabled"] = $51ea95642df64f3b$export$bc23bfcf126e93ae;
module.exports["deduplicateActions"] = $51ea95642df64f3b$export$72fb9a87f8ed6ccf;
module.exports["capitaliseActionIssueIds"] = $51ea95642df64f3b$export$8c57b7176c3bb320;

});

parcelRegister("30m9b", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $4c78b0d5cc80e020$export$586abe0dcbd205c9 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7Fn78")).then((m)=>({
            default: m.AskQuestionRenderer
        })));

const $4c78b0d5cc80e020$export$5edc8e4b86a5a832 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7Fn78")).then((m)=>({
            default: m.AskQuestionReadOnlyRenderer
        })));
module.exports["AskQuestionRendererAsync"] = $4c78b0d5cc80e020$export$586abe0dcbd205c9;
module.exports["AskQuestionReadOnlyRendererAsync"] = $4c78b0d5cc80e020$export$5edc8e4b86a5a832;

});

parcelRegister("aGfhs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");


var $8Me03 = parcelRequire("8Me03");


var $iWLwj = parcelRequire("iWLwj");

const $5a952a68b06d0ddd$var$styles = {
    container: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $5a952a68b06d0ddd$var$CreateProjectProgressUpdateActionRendererImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let actions;
    let props;
    if ($[0] !== t0) {
        ({ actions: actions, ...props } = t0);
        $[0] = t0;
        $[1] = actions;
        $[2] = props;
    } else {
        actions = $[1];
        props = $[2];
    }
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[3] !== actions || $[4] !== props) {
        t3 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const validActions = actions.filter($5a952a68b06d0ddd$var$_temp);
            if (!validActions.length) {
                t3 = null;
                break bb0;
            }
            T0 = (0, $dinVW.Stack);
            t1 = $5a952a68b06d0ddd$var$styles.container;
            let t4;
            if ($[9] !== props) {
                t4 = (action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Me03.ActionCard), {
                        key: action.actionId,
                        action: action,
                        ...props
                    });
                $[9] = props;
                $[10] = t4;
            } else t4 = $[10];
            t2 = validActions.map(t4);
        }
        $[3] = actions;
        $[4] = props;
        $[5] = T0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else {
        T0 = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
    }
    if (t3 !== Symbol.for("react.early_return_sentinel")) return t3;
    let t4;
    if ($[11] !== T0 || $[12] !== t1 || $[13] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t1
        }, t2);
        $[11] = T0;
        $[12] = t1;
        $[13] = t2;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ actions: actions, ...props })=>{
    const validActions = actions.filter((a)=>(0, $iWLwj.validateCreateProjectProgressUpdateAction)(a).isValid);
    if (!validActions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $5a952a68b06d0ddd$var$styles.container
    }, validActions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Me03.ActionCard), {
            key: action.actionId,
            action: action,
            ...props
        })));
};
const $5a952a68b06d0ddd$export$a3da20066f29f5af = /*#__PURE__*/ (0, $cozmU.memo)($5a952a68b06d0ddd$var$CreateProjectProgressUpdateActionRendererImpl);
function $5a952a68b06d0ddd$var$_temp(a) {
    return (0, $iWLwj.validateCreateProjectProgressUpdateAction)(a).isValid;
}
module.exports["CreateProjectProgressUpdateActionRenderer"] = $5a952a68b06d0ddd$export$a3da20066f29f5af;

});

parcelRegister("4uwm1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $3ea2404bd34ac1fb$var$styles = {
    card: "_0bjKvDKxmn _2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0KLXruqi9L _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _2OUyjtzwhj",
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $3ea2404bd34ac1fb$export$5e8078faa73d2c85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "30px"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "80px"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $3ea2404bd34ac1fb$var$styles.card,
            testId: "project-status-update-action-renderer.ui.skeleton"
        }, t0, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $3ea2404bd34ac1fb$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "80px",
            height: "32px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100px",
            height: "32px"
        })));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $3ea2404bd34ac1fb$var$styles.card,
        testId: "project-status-update-action-renderer.ui.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "30px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "80px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $3ea2404bd34ac1fb$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "80px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100px",
        height: "32px"
    })));
};
module.exports["CreateProjectProgressUpdateActionSkeleton"] = $3ea2404bd34ac1fb$export$5e8078faa73d2c85;

});

parcelRegister("iWLwj", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $dw75i = parcelRequire("dw75i");

const $0b7942d2e1945225$var$payloadSchema = (0, $87Lnp.z).object({
    projectId: (0, $87Lnp.z).string(),
    phase: (0, $87Lnp.z).enum([
        'paused',
        'pending',
        'in_progress',
        'done',
        'cancelled'
    ]).optional(),
    status: (0, $87Lnp.z).enum([
        'on_track',
        'at_risk',
        'off_track'
    ]).optional(),
    summary: (0, $87Lnp.z).string().optional(),
    targetDate: (0, $87Lnp.z).object({
        date: (0, $87Lnp.z).string().optional(),
        confidence: (0, $87Lnp.z).string().transform((val)=>val.toUpperCase()).pipe((0, $87Lnp.z).enum([
            'DAY',
            'MONTH',
            'QUARTER'
        ])).optional()
    }).optional(),
    updateNote: (0, $87Lnp.z).object({
        summary: (0, $87Lnp.z).string().optional(),
        description: (0, $87Lnp.z).string()
    }).optional(),
    highlightLearning: (0, $87Lnp.z).object({
        summary: (0, $87Lnp.z).string(),
        description: (0, $87Lnp.z).string(),
        type: (0, $87Lnp.z).string().transform((val)=>val.toUpperCase()).pipe((0, $87Lnp.z).literal('LEARNING'))
    }).optional(),
    highlightRisk: (0, $87Lnp.z).object({
        summary: (0, $87Lnp.z).string(),
        description: (0, $87Lnp.z).string(),
        type: (0, $87Lnp.z).string().transform((val)=>val.toUpperCase()).pipe((0, $87Lnp.z).literal('RISK'))
    }).optional(),
    highlightDecision: (0, $87Lnp.z).object({
        summary: (0, $87Lnp.z).string(),
        description: (0, $87Lnp.z).string(),
        type: (0, $87Lnp.z).string().transform((val)=>val.toUpperCase()).pipe((0, $87Lnp.z).literal('DECISION'))
    }).optional()
});
const $0b7942d2e1945225$var$actionSchema = (0, $87Lnp.z).object({
    key: (0, $87Lnp.z).literal((0, $dw75i.ActionKeys).CreateProjectProgressUpdate),
    data: $0b7942d2e1945225$var$payloadSchema
});
function $0b7942d2e1945225$export$54fe109509978f41(action) {
    const parsed = $0b7942d2e1945225$var$actionSchema.safeParse(action);
    if (parsed.success) return {
        isValid: true,
        action: action
    };
    return {
        isValid: false,
        error: new Error(`Invalid ${action.key || ''} action payload: ${parsed.error.message}`)
    };
}
module.exports["validateCreateProjectProgressUpdateAction"] = $0b7942d2e1945225$export$54fe109509978f41;

});

parcelRegister("7m0gB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dw75i = parcelRequire("dw75i");


var $epG7a = parcelRequire("epG7a");

const $b5cf6ec844c2d643$var$assertIsAtlassianTeamUpdateArchiveAction = (action)=>{
    if (action.key !== (0, $dw75i.ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY)) throw new Error('Invalid action key for atlassian team update archive action');
    return action;
};
const $b5cf6ec844c2d643$export$79062c7708593863 = (actions)=>{
    const filteredActions = actions.filter($b5cf6ec844c2d643$var$assertIsAtlassianTeamUpdateArchiveAction);
    return filteredActions;
};
const $b5cf6ec844c2d643$export$3e2c41435461798c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epG7a.ArchiveTeamsCard), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epG7a.ArchiveTeamsCard), props);
};
module.exports["AtlassianTeamUpdateArchiveAction"] = $b5cf6ec844c2d643$export$3e2c41435461798c;

});

parcelRegister("01ZUS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $88RF3 = parcelRequire("88RF3");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $b0L5M = parcelRequire("b0L5M");


var $iOVAY = parcelRequire("iOVAY");


var $9wJps = parcelRequire("9wJps");


var $ifC4g = parcelRequire("ifC4g");


var $fBbRq = parcelRequire("fBbRq");


var $1WhA9 = parcelRequire("1WhA9");


var $MjdYo = parcelRequire("MjdYo");


var $kPnHr = parcelRequire("kPnHr");

const $a93937173e034593$var$actionCardTitleMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-card-title.non-final",
    defaultMessage: "Manage capacity plan"
});
const $a93937173e034593$var$subtitleMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.updated-in-board.non-final",
    defaultMessage: "Updated in {boardLink}"
});
const $a93937173e034593$var$unableToProcessMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.unable-to-process.non-final",
    defaultMessage: "We were unable to process your request. Please try again later."
});
const $a93937173e034593$var$showMoreMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.show-more.non-final",
    defaultMessage: "Show more"
});
const $a93937173e034593$var$ANIMATION_DURATION = '350ms';
const $a93937173e034593$var$MAX_CONTENT_HEIGHT = '320px';
const $a93937173e034593$var$contentStyles = {
    collapsible: "_4bt5LAoWuR _2WAcuGoWuR _23rrnHLaAG _0NUa3rsz7G _1mT5xdRAKS _0qk6IKN8t6 _3Z9K0wngV3",
    expanded: "_0NUa3rW9qI",
    gradientSkrim: "_23rrnH9v2r _1mT5xdWVPG _0Bm75GdnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VfI2J _42Yu6BgtVO _0qk6IKN8t6 _3Z9K0wngV3",
    showMoreButtonContainer: "_0bjKvDS5Zs _23rrnH9v2r _0KLXrulfZc _2OUyjtrvhE _0qk6IKN8t6 _3Z9K0wngV3"
};
const $a93937173e034593$var$nativeContentStyles = {
    collapsible: "_1YjuKt1Z7S",
    gradientSkrim: "_3CkH9ort2G"
};
function $a93937173e034593$var$getScopeId(action) {
    const data = action.data;
    return data.capacityPlanContext.scopeId;
}
const $a93937173e034593$var$Subtitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Subtitle(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { board: board } = t0;
    let t1;
    if ($[0] !== board.name || $[1] !== board.url) {
        t1 = board.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: board.url,
            target: "_blank",
            rel: "noopener noreferrer"
        }, board.name) : board.name;
        $[0] = board.name;
        $[1] = board.url;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a93937173e034593$var$subtitleMessage,
            values: {
                boardLink: t1
            }
        });
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function Subtitle({ board: board }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a93937173e034593$var$subtitleMessage,
        values: {
            boardLink: board.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                href: board.url,
                target: "_blank",
                rel: "noopener noreferrer"
            }, board.name) : board.name
        }
    });
};
function $a93937173e034593$var$UnableToProcess({ viewType: viewType }) {
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'unableToProcess',
            actionSubject: 'component',
            actionSubjectId: 'capacityPlanningPreviewCard',
            eventType: 'ui',
            attributes: {
                viewType: viewType
            }
        });
    }, [
        sendAnalyticsEvent,
        viewType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a93937173e034593$var$unableToProcessMessage)));
}
const $a93937173e034593$var$skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
    width: "100%",
    height: "320px"
});
const $a93937173e034593$export$225022f8b7dd090d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    let t0;
    if ($[0] !== props.actions) {
        t0 = (0, $iOVAY.getIdsForHydration)(props.actions.filter($a93937173e034593$var$_temp));
        $[0] = props.actions;
        $[1] = t0;
    } else t0 = $[1];
    const ids = t0;
    if (props.actions.length === 0) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, null);
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== props.actions[0]) {
        t1 = $a93937173e034593$var$getScopeId(props.actions[0]);
        $[3] = props.actions[0];
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== ids || $[6] !== props) {
        t2 = (board)=>!board?.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9wJps.CapacityPlanningDataQuery), {
                contributorIds: ids.contributorIds,
                workIds: ids.workIds
            }, (t3)=>{
                const { usersByAccountId: usersByAccountId, workById: workById } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$CapacityPlanningContent, {
                    ...props,
                    subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$Subtitle, {
                        board: board
                    }),
                    usersByAccountId: usersByAccountId,
                    workById: workById,
                    expandAllGroups: props.expandAllGroups
                });
            });
        $[5] = ids;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: $a93937173e034593$var$_temp2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: $a93937173e034593$var$skeleton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0L5M.BoardQuery), {
            scopeId: t1
        }, t2)));
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (props)=>{
    const ids = (0, $cozmU.useMemo)(()=>(0, $iOVAY.getIdsForHydration)(props.actions.filter((a)=>a.status !== 'cancelled')), [
        props.actions
    ]);
    if (props.actions.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: $a93937173e034593$var$skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0L5M.BoardQuery), {
        scopeId: $a93937173e034593$var$getScopeId(props.actions[0])
    }, (board)=>!board?.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9wJps.CapacityPlanningDataQuery), {
            contributorIds: ids.contributorIds,
            workIds: ids.workIds
        }, ({ usersByAccountId: usersByAccountId, workById: workById })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$CapacityPlanningContent, {
                ...props,
                subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$Subtitle, {
                    board: board
                }),
                usersByAccountId: usersByAccountId,
                workById: workById,
                expandAllGroups: props.expandAllGroups
            })))));
};
const $a93937173e034593$var$CollapsibleContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CollapsibleContent(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contentRef = (0, $cozmU.useRef)(null);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isOverflowed, setIsOverflowed] = (0, $cozmU.useState)(true);
    let t1;
    let t2;
    if ($[0] !== isExpanded) {
        t1 = ()=>{
            const content = contentRef.current;
            if (!content || isExpanded) return;
            const checkOverflow = ()=>setIsOverflowed(content.scrollHeight > content.clientHeight);
            checkOverflow();
            const observer = new ResizeObserver(checkOverflow);
            observer.observe(content);
            return ()=>observer.disconnect();
        };
        t2 = [
            isExpanded
        ];
        $[0] = isExpanded;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const t3 = isExpanded && $a93937173e034593$var$contentStyles.expanded;
    let t4;
    if ($[3] !== t3) {
        t4 = (0, $w6R6I.cx)($a93937173e034593$var$contentStyles.collapsible, t3, $a93937173e034593$var$nativeContentStyles.collapsible);
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== formatMessage || $[6] !== isExpanded || $[7] !== isOverflowed) {
        t5 = !isExpanded && isOverflowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "center",
            xcss: (0, $w6R6I.cx)($a93937173e034593$var$contentStyles.gradientSkrim, $a93937173e034593$var$nativeContentStyles.gradientSkrim)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "center",
            xcss: $a93937173e034593$var$contentStyles.showMoreButtonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: ()=>{
                setIsExpanded(true);
            },
            testId: "capacity-planning-show-more-button"
        }, formatMessage($a93937173e034593$var$showMoreMessage))));
        $[5] = formatMessage;
        $[6] = isExpanded;
        $[7] = isOverflowed;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== children || $[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentRef,
            xcss: t4,
            testId: "capacity-planning-collapsible-content"
        }, children, t5);
        $[9] = children;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function CollapsibleContent({ children: children }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contentRef = (0, $cozmU.useRef)(null);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isOverflowed, setIsOverflowed] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        const content = contentRef.current;
        if (!content || isExpanded) return;
        const checkOverflow = ()=>setIsOverflowed(content.scrollHeight > content.clientHeight);
        checkOverflow();
        const observer = new ResizeObserver(checkOverflow);
        observer.observe(content);
        return ()=>observer.disconnect();
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentRef,
        xcss: (0, $w6R6I.cx)($a93937173e034593$var$contentStyles.collapsible, isExpanded && $a93937173e034593$var$contentStyles.expanded, $a93937173e034593$var$nativeContentStyles.collapsible),
        testId: "capacity-planning-collapsible-content"
    }, children, !isExpanded && isOverflowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "center",
        xcss: (0, $w6R6I.cx)($a93937173e034593$var$contentStyles.gradientSkrim, $a93937173e034593$var$nativeContentStyles.gradientSkrim)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $a93937173e034593$var$contentStyles.showMoreButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>{
            setIsExpanded(true);
        },
        testId: "capacity-planning-show-more-button"
    }, formatMessage($a93937173e034593$var$showMoreMessage)))));
};
function $a93937173e034593$var$CapacityPlanningContent({ actions: actions, subtitle: subtitle, usersByAccountId: usersByAccountId, workById: workById, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, expandAllGroups: expandAllGroups = false }) {
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [selectedKeys, setSelectedKeys] = (0, $cozmU.useState)(new Set());
    const validNonCancelledActions = (0, $cozmU.useMemo)(()=>actions.filter((action)=>!(action.status === 'cancelled' || getStatus(action) === 'cancelled' || (0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(action.data))), [
        actions,
        getStatus
    ]);
    const isPeopleView = (0, $cozmU.useMemo)(()=>{
        return !validNonCancelledActions.some((action_0)=>action_0?.data?.capacityPlanContext?.view === (0, $MjdYo.VIEW_TYPE).WORK);
    }, [
        validNonCancelledActions
    ]);
    const viewType = isPeopleView ? (0, $MjdYo.VIEW_TYPE).PEOPLE : (0, $MjdYo.VIEW_TYPE).WORK;
    const hasRenderedAnalyticsFired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasRenderedAnalyticsFired.current) return;
        hasRenderedAnalyticsFired.current = true;
        sendAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'component',
            actionSubjectId: 'capacityPlanningPreviewCard',
            eventType: 'ui',
            attributes: {
                viewType: viewType,
                actionsCount: validNonCancelledActions.length
            }
        });
    }, [
        sendAnalyticsEvent,
        viewType,
        validNonCancelledActions.length
    ]);
    const { actionsByContributorId: actionsByContributorId, actionsByWorkId: actionsByWorkId } = (0, $cozmU.useMemo)(()=>(0, $iOVAY.filterActionsByIndexWithHydration)(validNonCancelledActions, usersByAccountId, workById, isPeopleView ? (0, $MjdYo.VIEW_TYPE).PEOPLE : (0, $MjdYo.VIEW_TYPE).WORK), [
        validNonCancelledActions,
        usersByAccountId,
        workById,
        isPeopleView
    ]);
    const actionsByIndex = (0, $cozmU.useMemo)(()=>({
            actionsByContributorId: actionsByContributorId,
            actionsByWorkId: actionsByWorkId
        }), [
        actionsByContributorId,
        actionsByWorkId
    ]);
    const displayedActions = (0, $cozmU.useMemo)(()=>{
        if (isPeopleView) return Array.from(actionsByContributorId.values()).flat();
        return Array.from(actionsByWorkId.values()).flat();
    }, [
        actionsByContributorId,
        actionsByWorkId,
        isPeopleView
    ]);
    const handleSelectionChange = (0, $cozmU.useCallback)((invocationId, isSelected)=>{
        setSelectedKeys((prevSelectedKeys)=>{
            const updatedKeys = new Set(prevSelectedKeys);
            isSelected ? updatedKeys.add(invocationId) : updatedKeys.delete(invocationId);
            return updatedKeys;
        });
    }, []);
    const clearSelection = (0, $cozmU.useCallback)(()=>setSelectedKeys(new Set()), []); // If there are no renderable actions, determine whether to show success or error
    if (displayedActions.length === 0) {
        // User has interacted with at least one action — show success capsule
        const userHasInteracted = actions.some((action_1)=>(0, $iOVAY.isActionCompleted)(action_1, getStatus));
        return userHasInteracted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1WhA9.SuccessMessage), {
            actions: actions,
            getStatus: getStatus
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, {
            viewType: viewType
        });
    }
    const allActionsApplied = displayedActions.every((action_2)=>(0, $iOVAY.isActionCompleted)(action_2, getStatus));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage($a93937173e034593$var$actionCardTitleMessage),
        subtitle: subtitle,
        product: "capacity-planning",
        isExpandable: true,
        defaultExpanded: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$CollapsibleContent, null, isPeopleView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fBbRq.PeopleView), {
        actionsByIndex: actionsByIndex,
        hydratedUsers: usersByAccountId,
        workById: workById,
        selectedKeys: selectedKeys,
        onSelectionChange: handleSelectionChange,
        onConfirm: onConfirm,
        onCancel: onCancel,
        getStatus: getStatus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kPnHr.WorkView), {
        actionsByIndex: actionsByIndex,
        hydratedUsers: usersByAccountId,
        workById: workById,
        selectedKeys: selectedKeys,
        onSelectionChange: handleSelectionChange,
        onConfirm: onConfirm,
        onCancel: onCancel,
        getStatus: getStatus,
        expandAllGroups: expandAllGroups
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifC4g.CapacityPlanningCardFooter), {
        displayedActions: displayedActions,
        selectedKeys: selectedKeys,
        getStatus: getStatus,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onClearSelection: clearSelection,
        allActionsApplied: allActionsApplied,
        viewType: viewType
    })), allActionsApplied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1WhA9.SuccessMessage), {
        actions: displayedActions,
        getStatus: getStatus
    }));
}
function $a93937173e034593$var$_temp(a) {
    return a.status !== "cancelled";
}
function $a93937173e034593$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a93937173e034593$var$UnableToProcess, null);
}
module.exports["CapacityPlanningActionRenderer"] = $a93937173e034593$export$225022f8b7dd090d;

});

parcelRegister("kHCjc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $i321f = parcelRequire("i321f");

const $5ede2d8d3fc45ec2$export$17fb4255f1d783c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    const { onConfirm: onConfirm, onCancel: onCancel, actions: actions, getStatus: getStatus, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    let t1;
    if ($[0] !== firstAction || $[1] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[0] = firstAction;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== getStatus) {
        t2 = getStatus(firstAction);
        $[3] = firstAction;
        $[4] = getStatus;
        $[5] = t2;
    } else t2 = $[5];
    const status = t2;
    const isDisabled = status !== "idle" || readonly;
    const isSubmitting = status === "started";
    let t3;
    if ($[6] !== actions || $[7] !== conversationId || $[8] !== firstAction || $[9] !== getStatus || $[10] !== messageId || $[11] !== onConfirm || $[12] !== recipientAgentId || $[13] !== sendMessageConfirmedTools) {
        t3 = ()=>{
            if ((0, $iDrrr.fg)("rovo_tools_resumption_migration_phase2")) {
                const plannedActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "confluenceAifcAdfUpdateRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[6] = actions;
        $[7] = conversationId;
        $[8] = firstAction;
        $[9] = getStatus;
        $[10] = messageId;
        $[11] = onConfirm;
        $[12] = recipientAgentId;
        $[13] = sendMessageConfirmedTools;
        $[14] = t3;
    } else t3 = $[14];
    const handleConfirm = t3;
    let t4;
    if ($[15] !== actions || $[16] !== conversationId || $[17] !== firstAction || $[18] !== getStatus || $[19] !== messageId || $[20] !== onCancel || $[21] !== recipientAgentId || $[22] !== sendMessageConfirmedTools) {
        t4 = ()=>{
            if ((0, $iDrrr.fg)("rovo_tools_resumption_migration_phase2")) {
                const plannedActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "confluenceAifcAdfUpdateRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: plannedActions_0.map($5ede2d8d3fc45ec2$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[15] = actions;
        $[16] = conversationId;
        $[17] = firstAction;
        $[18] = getStatus;
        $[19] = messageId;
        $[20] = onCancel;
        $[21] = recipientAgentId;
        $[22] = sendMessageConfirmedTools;
        $[23] = t4;
    } else t4 = $[23];
    const handleCancel = t4;
    if (!data.adf) return null;
    let t5;
    if ($[24] !== formatMessage) {
        t5 = formatMessage((0, $i321f.default).actionMessage, {
            bold: $5ede2d8d3fc45ec2$var$_temp2
        });
        $[24] = formatMessage;
        $[25] = t5;
    } else t5 = $[25];
    let t6;
    if ($[26] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t5);
        $[26] = t5;
        $[27] = t6;
    } else t6 = $[27];
    let t7;
    if ($[28] !== formatMessage) {
        t7 = formatMessage((0, $i321f.default).actionCardTitle);
        $[28] = formatMessage;
        $[29] = t7;
    } else t7 = $[29];
    let t8;
    if ($[30] !== data.summary) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, data.summary));
        $[30] = data.summary;
        $[31] = t8;
    } else t8 = $[31];
    let t9;
    if ($[32] !== formatMessage) {
        t9 = formatMessage((0, $i321f.default).confirmButton);
        $[32] = formatMessage;
        $[33] = t9;
    } else t9 = $[33];
    let t10;
    if ($[34] !== handleConfirm || $[35] !== isDisabled || $[36] !== isSubmitting || $[37] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: isDisabled,
            isLoading: isSubmitting,
            onClick: handleConfirm,
            testId: "confluence-aifc-adf-update-confirm-button"
        }, t9);
        $[34] = handleConfirm;
        $[35] = isDisabled;
        $[36] = isSubmitting;
        $[37] = t9;
        $[38] = t10;
    } else t10 = $[38];
    let t11;
    if ($[39] !== formatMessage) {
        t11 = formatMessage((0, $i321f.default).cancelButton);
        $[39] = formatMessage;
        $[40] = t11;
    } else t11 = $[40];
    let t12;
    if ($[41] !== handleCancel || $[42] !== isDisabled || $[43] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            isDisabled: isDisabled,
            onClick: handleCancel,
            testId: "confluence-aifc-adf-update-cancel-button"
        }, t11);
        $[41] = handleCancel;
        $[42] = isDisabled;
        $[43] = t11;
        $[44] = t12;
    } else t12 = $[44];
    let t13;
    if ($[45] !== t10 || $[46] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t10, t12));
        $[45] = t10;
        $[46] = t12;
        $[47] = t13;
    } else t13 = $[47];
    let t14;
    if ($[48] !== t13 || $[49] !== t7 || $[50] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: t7,
            product: "confluence"
        }, t8, t13);
        $[48] = t13;
        $[49] = t7;
        $[50] = t8;
        $[51] = t14;
    } else t14 = $[51];
    let t15;
    if ($[52] !== t14 || $[53] !== t6) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.250",
            testId: "confluence-aifc-adf-update-action"
        }, t6, t14);
        $[52] = t14;
        $[53] = t6;
        $[54] = t15;
    } else t15 = $[54];
    return t15;
} : ({ onConfirm: onConfirm, onCancel: onCancel, actions: actions, getStatus: getStatus, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const isDisabled = status !== 'idle' || readonly;
    const isSubmitting = status === 'started';
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('rovo_tools_resumption_migration_phase2')) {
            const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluenceAifcAdfUpdateRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    // Confirm the submitted action; cancel every other queued action.
                    tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        onConfirm,
        firstAction,
        actions,
        sendMessageConfirmedTools,
        getStatus,
        recipientAgentId,
        conversationId,
        messageId
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('rovo_tools_resumption_migration_phase2')) {
            const plannedActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluenceAifcAdfUpdateRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: plannedActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        onCancel,
        firstAction,
        actions,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        getStatus
    ]);
    // In FE mode (no adf in data), edits are streamed directly to the editor
    // so no confirmation card is needed. Only render in backend mode where the
    // user must explicitly confirm before the hook applies changes.
    if (!data.adf) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.250",
        testId: "confluence-aifc-adf-update-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $i321f.default).actionMessage, {
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $i321f.default).actionCardTitle),
        product: "confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, data.summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: isDisabled,
        isLoading: isSubmitting,
        onClick: handleConfirm,
        testId: "confluence-aifc-adf-update-confirm-button"
    }, formatMessage((0, $i321f.default).confirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        isDisabled: isDisabled,
        onClick: handleCancel,
        testId: "confluence-aifc-adf-update-cancel-button"
    }, formatMessage((0, $i321f.default).cancelButton))))));
};
function $5ede2d8d3fc45ec2$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
function $5ede2d8d3fc45ec2$var$_temp2(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks);
}
module.exports["ConfluenceAifcAdfUpdateAction"] = $5ede2d8d3fc45ec2$export$17fb4255f1d783c3;

});

parcelRegister("j4dZf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $2uDbg = parcelRequire("2uDbg");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $1HjbK = parcelRequire("1HjbK");


var $icMUY = parcelRequire("icMUY");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $dKH1M = parcelRequire("dKH1M");

const $fe87962c8b6226f5$export$59c80794493ae3b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(65);
    const { actions: actions, cloudId: cloudId, conversationId: conversationId, getStatus: getStatus, messageId: messageId, recipientAgentId: recipientAgentId, sendMessageConfirmedTools: sendMessageConfirmedTools } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isMulti = actions.length > 1;
    let t1;
    if ($[0] !== actions) {
        t1 = ()=>new Set(actions.filter($fe87962c8b6226f5$var$_temp).map($fe87962c8b6226f5$var$_temp2));
        $[0] = actions;
        $[1] = t1;
    } else t1 = $[1];
    const [selectedIds, setSelectedIds] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (invocationId)=>{
            setSelectedIds((prev)=>{
                const next = new Set(prev);
                if (next.has(invocationId)) next.delete(invocationId);
                else next.add(invocationId);
                return next;
            });
        };
        $[2] = t2;
    } else t2 = $[2];
    const toggle = t2;
    let t3;
    if ($[3] !== getStatus) {
        t3 = (action_1)=>!$fe87962c8b6226f5$var$isPlanned(action_1) || getStatus(action_1) !== "idle";
        $[3] = getStatus;
        $[4] = t3;
    } else t3 = $[4];
    const isLocked = t3;
    let t4;
    if ($[5] !== actions) {
        t4 = actions.some($fe87962c8b6226f5$var$isPlanned);
        $[5] = actions;
        $[6] = t4;
    } else t4 = $[6];
    const hasPlanned = t4;
    let t5;
    if ($[7] !== actions || $[8] !== getStatus) {
        let t6;
        if ($[10] !== getStatus) {
            t6 = (action_2)=>getStatus(action_2) === "started";
            $[10] = getStatus;
            $[11] = t6;
        } else t6 = $[11];
        t5 = actions.some(t6);
        $[7] = actions;
        $[8] = getStatus;
        $[9] = t5;
    } else t5 = $[9];
    const isSubmitting = t5;
    let t6;
    if ($[12] !== actions || $[13] !== selectedIds) {
        let t7;
        if ($[15] !== selectedIds) {
            t7 = (action_3)=>$fe87962c8b6226f5$var$isPlanned(action_3) && selectedIds.has(action_3.invocationId);
            $[15] = selectedIds;
            $[16] = t7;
        } else t7 = $[16];
        t6 = actions.some(t7);
        $[12] = actions;
        $[13] = selectedIds;
        $[14] = t6;
    } else t6 = $[14];
    const hasActionableSelection = t6;
    const isCreateDisabled = !hasActionableSelection || isSubmitting;
    let t7;
    if ($[17] !== actions || $[18] !== conversationId || $[19] !== messageId || $[20] !== recipientAgentId || $[21] !== selectedIds || $[22] !== sendMessageConfirmedTools) {
        t7 = (confirm)=>{
            const plannedActions = actions.filter($fe87962c8b6226f5$var$isPlanned);
            const isConfirmed = (action_4)=>confirm && selectedIds.has(action_4.invocationId);
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: "confluenceFolderCreateRenderer"
                },
                confirmed_tools: {
                    message_id: messageId ?? "",
                    tools: plannedActions.map((action_5)=>(0, $7eUSO.buildToolFromAction)(action_5, isConfirmed(action_5) ? "confirmed" : "cancelled"))
                },
                resolutionType: plannedActions.some(isConfirmed) ? "confirmed" : "cancelled"
            });
        };
        $[17] = actions;
        $[18] = conversationId;
        $[19] = messageId;
        $[20] = recipientAgentId;
        $[21] = selectedIds;
        $[22] = sendMessageConfirmedTools;
        $[23] = t7;
    } else t7 = $[23];
    const resolve = t7;
    let t8;
    if ($[24] !== actions.length || $[25] !== formatMessage) {
        t8 = formatMessage((0, $dKH1M.default).cardTitle, {
            count: actions.length
        });
        $[24] = actions.length;
        $[25] = formatMessage;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== actions || $[28] !== getEntity || $[29] !== isLocked || $[30] !== isMulti || $[31] !== selectedIds) {
        let t10;
        if ($[33] !== getEntity || $[34] !== isLocked || $[35] !== isMulti || $[36] !== selectedIds) {
            t10 = (action_6)=>{
                const folderElement = /*#__PURE__*/ $cozmU.createElement($fe87962c8b6226f5$var$FolderComponent, {
                    action: action_6,
                    getEntity: getEntity
                });
                return isMulti ? /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
                    key: action_6.invocationId
                }, /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
                    isChecked: selectedIds.has(action_6.invocationId),
                    onChange: ()=>toggle(action_6.invocationId),
                    isDisabled: isLocked(action_6),
                    label: folderElement
                })) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    key: action_6.invocationId
                }, folderElement);
            };
            $[33] = getEntity;
            $[34] = isLocked;
            $[35] = isMulti;
            $[36] = selectedIds;
            $[37] = t10;
        } else t10 = $[37];
        t9 = actions.map(t10);
        $[27] = actions;
        $[28] = getEntity;
        $[29] = isLocked;
        $[30] = isMulti;
        $[31] = selectedIds;
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[38] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t9);
        $[38] = t9;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== resolve) {
        t11 = ()=>resolve(true);
        $[40] = resolve;
        $[41] = t11;
    } else t11 = $[41];
    const t12 = isMulti ? (0, $dKH1M.default).createSelectedButton : (0, $dKH1M.default).createButton;
    let t13;
    if ($[42] !== formatMessage || $[43] !== t12) {
        t13 = formatMessage(t12);
        $[42] = formatMessage;
        $[43] = t12;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== isCreateDisabled || $[46] !== isSubmitting || $[47] !== t11 || $[48] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isLoading: isSubmitting,
            isDisabled: isCreateDisabled,
            onClick: t11
        }, t13);
        $[45] = isCreateDisabled;
        $[46] = isSubmitting;
        $[47] = t11;
        $[48] = t13;
        $[49] = t14;
    } else t14 = $[49];
    const t15 = isSubmitting || !hasPlanned;
    let t16;
    if ($[50] !== resolve) {
        t16 = ()=>resolve(false);
        $[50] = resolve;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== formatMessage) {
        t17 = formatMessage((0, $dKH1M.default).cancelButton);
        $[52] = formatMessage;
        $[53] = t17;
    } else t17 = $[53];
    let t18;
    if ($[54] !== t15 || $[55] !== t16 || $[56] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            isDisabled: t15,
            onClick: t16
        }, t17);
        $[54] = t15;
        $[55] = t16;
        $[56] = t17;
        $[57] = t18;
    } else t18 = $[57];
    let t19;
    if ($[58] !== t14 || $[59] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $fe87962c8b6226f5$var$styles.footer
        }, t14, t18));
        $[58] = t14;
        $[59] = t18;
        $[60] = t19;
    } else t19 = $[60];
    let t20;
    if ($[61] !== t10 || $[62] !== t19 || $[63] !== t8) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            title: t8,
            product: "confluence"
        }, t10, t19);
        $[61] = t10;
        $[62] = t19;
        $[63] = t8;
        $[64] = t20;
    } else t20 = $[64];
    return t20;
} : ({ actions: actions, cloudId: cloudId, conversationId: conversationId, getStatus: getStatus, messageId: messageId, recipientAgentId: recipientAgentId, sendMessageConfirmedTools: sendMessageConfirmedTools })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isMulti = actions.length > 1; // Planned and finished folders start checked (matching ResumptionRenderer) — finished ones render
    // checked-but-locked. In single mode the sole folder stays selected (no checkbox is shown), so the
    // confirm logic below is identical for both.
    const [selectedIds, setSelectedIds] = (0, $cozmU.useState)(()=>new Set(actions.filter((action)=>$fe87962c8b6226f5$var$isPlanned(action) || action.status === 'finished').map((action_0)=>action_0.invocationId)));
    const toggle = (0, $cozmU.useCallback)((invocationId)=>{
        setSelectedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(invocationId)) next.delete(invocationId);
            else next.add(invocationId);
            return next;
        });
    }, []); // A folder's checkbox is locked once it's no longer planned, or while/after it's being submitted.
    const isLocked = (0, $cozmU.useCallback)((action_1)=>!$fe87962c8b6226f5$var$isPlanned(action_1) || getStatus(action_1) !== 'idle', [
        getStatus
    ]);
    const hasPlanned = actions.some($fe87962c8b6226f5$var$isPlanned);
    const isSubmitting = actions.some((action_2)=>getStatus(action_2) === 'started');
    const hasActionableSelection = actions.some((action_3)=>$fe87962c8b6226f5$var$isPlanned(action_3) && selectedIds.has(action_3.invocationId));
    const isCreateDisabled = !hasActionableSelection || isSubmitting; // Confirm/cancel via workflow resumption, forwarding the ORIGINAL data (raw `container` preserved).
    // Only still-planned folders are sent; selection is encoded per-tool (selected -> confirmed).
    const resolve = (0, $cozmU.useCallback)((confirm)=>{
        const plannedActions = actions.filter($fe87962c8b6226f5$var$isPlanned);
        const isConfirmed = (action_4)=>confirm && selectedIds.has(action_4.invocationId);
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'confluenceFolderCreateRenderer'
            },
            confirmed_tools: {
                message_id: messageId ?? '',
                tools: plannedActions.map((action_5)=>(0, $7eUSO.buildToolFromAction)(action_5, isConfirmed(action_5) ? 'confirmed' : 'cancelled'))
            },
            resolutionType: plannedActions.some(isConfirmed) ? 'confirmed' : 'cancelled'
        });
    }, [
        actions,
        conversationId,
        messageId,
        recipientAgentId,
        selectedIds,
        sendMessageConfirmedTools
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $dKH1M.default).cardTitle, {
            count: actions.length
        }),
        product: "confluence"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, actions.map((action_6)=>{
        const folderElement = /*#__PURE__*/ $cozmU.createElement($fe87962c8b6226f5$var$FolderComponent, {
            action: action_6,
            getEntity: getEntity
        }); // Single folder renders inline; multiple folders each get their own bordered card
        // (a title-less nested ActionCardWrapper) for clearer visual separation, matching the
        // generic ResumptionRenderer.
        return isMulti ? /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            key: action_6.invocationId
        }, /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
            isChecked: selectedIds.has(action_6.invocationId),
            onChange: ()=>toggle(action_6.invocationId),
            isDisabled: isLocked(action_6),
            label: folderElement
        })) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: action_6.invocationId
        }, folderElement);
    })), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $fe87962c8b6226f5$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: isCreateDisabled,
        onClick: ()=>resolve(true)
    }, formatMessage(isMulti ? (0, $dKH1M.default).createSelectedButton : (0, $dKH1M.default).createButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        isDisabled: isSubmitting || !hasPlanned,
        onClick: ()=>resolve(false)
    }, formatMessage((0, $dKH1M.default).cancelButton)))));
};
// Shared per-folder display — identical whether rendered standalone (single) or as a checkbox label (multi).
const $fe87962c8b6226f5$var$FolderComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { action: action, getEntity: getEntity } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { data: data } = action;
    const [space, setSpace] = (0, $cozmU.useState)(undefined);
    let t1;
    let t2;
    if ($[0] !== data.container || $[1] !== getEntity) {
        t1 = ()=>{
            let ignore = false;
            const fetchSpace = async ()=>{
                if (data.container) {
                    const resolved = await getEntity(data.container, "space");
                    if (resolved && !ignore) setSpace({
                        name: resolved.name,
                        iconPath: resolved.icon?.path
                    });
                }
            };
            fetchSpace();
            return ()=>{
                ignore = true;
            };
        };
        t2 = [
            data.container,
            getEntity
        ];
        $[0] = data.container;
        $[1] = getEntity;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== data.container || $[5] !== space) {
        t3 = space ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $icMUY.OptionIcon), {
            type: "space",
            iconPath: space.iconPath
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, space.name)) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, data.container);
        $[4] = data.container;
        $[5] = space;
        $[6] = t3;
    } else t3 = $[6];
    const spaceElement = t3;
    let t4;
    if ($[7] !== formatMessage) {
        t4 = formatMessage((0, $dKH1M.default).spaceLabel);
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $fe87962c8b6226f5$var$styles.label
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "bold"
        }, t4, ":"));
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== spaceElement || $[12] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t5, spaceElement);
        $[11] = spaceElement;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== formatMessage) {
        t7 = formatMessage((0, $dKH1M.default).folderNameLabel);
        $[14] = formatMessage;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $fe87962c8b6226f5$var$styles.label
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "bold"
        }, t7, ":"));
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== data.name) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, data.name);
        $[18] = data.name;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t8 || $[21] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t8, t9);
        $[20] = t8;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t6) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, t10);
        $[23] = t10;
        $[24] = t6;
        $[25] = t11;
    } else t11 = $[25];
    return t11;
} : ({ action: action, getEntity: getEntity })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { data: data } = action;
    const [space, setSpace] = (0, $cozmU.useState)(undefined); // Resolve the raw container id to a human-readable space icon and name for display.
    (0, $cozmU.useEffect)(()=>{
        let ignore = false;
        const fetchSpace = async ()=>{
            if (data.container) {
                const resolved = await getEntity(data.container, 'space');
                if (resolved && !ignore) setSpace({
                    name: resolved.name,
                    iconPath: resolved.icon?.path
                });
            }
        };
        fetchSpace();
        return ()=>{
            ignore = true;
        };
    }, [
        data.container,
        getEntity
    ]);
    const spaceElement = space ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $icMUY.OptionIcon), {
        type: "space",
        iconPath: space.iconPath
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, space.name)) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, data.container);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $fe87962c8b6226f5$var$styles.label
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $dKH1M.default).spaceLabel), ":")), spaceElement), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $fe87962c8b6226f5$var$styles.label
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $dKH1M.default).folderNameLabel), ":")), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, data.name)));
};
// A folder is actionable only while its backend status is `planned`; any other status is locked.
const $fe87962c8b6226f5$var$isPlanned = (action)=>action.status === 'planned';
const $fe87962c8b6226f5$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS",
    label: "_1ANEUSLRg7"
};
function $fe87962c8b6226f5$var$_temp(action) {
    return $fe87962c8b6226f5$var$isPlanned(action) || action.status === "finished";
}
function $fe87962c8b6226f5$var$_temp2(action_0) {
    return action_0.invocationId;
}
module.exports["ConfluenceFolderCreateAction"] = $fe87962c8b6226f5$export$59c80794493ae3b1;

});

parcelRegister("boM6r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $c3tf0 = parcelRequire("c3tf0");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $1HjbK = parcelRequire("1HjbK");


var $g3R09 = parcelRequire("g3R09");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $kN5Cw = parcelRequire("kN5Cw");

const $1a12f3f75aa483da$export$21b8e778af961c9 = (actions)=>{
    const filteredActions = actions.filter($1a12f3f75aa483da$var$assertIsConfluencePageAddLabelAction);
    return filteredActions;
};
const $1a12f3f75aa483da$var$assertIsConfluencePageAddLabelAction = (action)=>{
    if (action.key !== (0, $dw75i.CONFLUENCE_PAGE_ADD_LABEL_KEY)) throw new Error('Invalid action key for ConfluencePageAddLabelAction');
    return action;
};
const $1a12f3f75aa483da$export$e092d6a6b15f8938 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(61);
    const { onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const [labelName, setLabelName] = (0, $cozmU.useState)(data.name);
    let t1;
    if ($[0] !== firstAction || $[1] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[0] = firstAction;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== getStatus) {
        t2 = getStatus(firstAction);
        $[3] = firstAction;
        $[4] = getStatus;
        $[5] = t2;
    } else t2 = $[5];
    const status = t2;
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const [selectedEntity, setSelectedEntity] = (0, $cozmU.useState)(undefined);
    const isDisabled = status !== "idle" || readonly || !selectedEntity || !labelName;
    const isSubmitting = status === "started";
    let t3;
    let t4;
    if ($[6] !== data.id || $[7] !== getEntity) {
        t3 = ()=>{
            const fetchPage = async ()=>{
                if (data.id) {
                    const entity = await getEntity(data.id, "page");
                    if (entity) setSelectedEntity({
                        label: entity.name,
                        value: entity.id,
                        type: "page"
                    });
                }
            };
            fetchPage();
        };
        t4 = [
            data.id,
            getEntity
        ];
        $[6] = data.id;
        $[7] = getEntity;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[10] !== actions || $[11] !== conversationId || $[12] !== data || $[13] !== firstAction || $[14] !== getStatus || $[15] !== labelName || $[16] !== messageId || $[17] !== onCustomDataConfirm || $[18] !== recipientAgentId || $[19] !== selectedEntity?.type || $[20] !== selectedEntity?.value || $[21] !== sendMessageConfirmedTools) {
        t5 = ()=>{
            const mergedData = {
                ...data,
                name: labelName,
                id: selectedEntity?.value,
                contentType: selectedEntity?.type ?? "page"
            };
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const plannedActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "confluencePageAddLabelRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onCustomDataConfirm(firstAction, mergedData);
        };
        $[10] = actions;
        $[11] = conversationId;
        $[12] = data;
        $[13] = firstAction;
        $[14] = getStatus;
        $[15] = labelName;
        $[16] = messageId;
        $[17] = onCustomDataConfirm;
        $[18] = recipientAgentId;
        $[19] = selectedEntity?.type;
        $[20] = selectedEntity?.value;
        $[21] = sendMessageConfirmedTools;
        $[22] = t5;
    } else t5 = $[22];
    selectedEntity?.value;
    selectedEntity?.type;
    const handleSubmit = t5;
    const t6 = selectedEntity?.label ?? "";
    let t7;
    if ($[23] !== formatMessage || $[24] !== t6) {
        t7 = formatMessage((0, $kN5Cw.default).actionMessage, {
            name: t6,
            bold: $1a12f3f75aa483da$var$_temp
        });
        $[23] = formatMessage;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t7);
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== formatMessage) {
        t9 = formatMessage((0, $kN5Cw.default).pageSelectorLabel);
        $[28] = formatMessage;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t9);
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== cloudId || $[33] !== isDisabled || $[34] !== selectedEntity || $[35] !== sendAnalyticsEvent) {
        t11 = !selectedEntity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            height: 30,
            width: 200,
            borderRadius: "var(--ds-radius-large, 8px)",
            testId: "confluence-page-add-label-page-selector-skeleton"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
            cloudId: cloudId,
            testId: "confluence-page-add-label-page-selector",
            contentTypes: [
                "page",
                "blogPost"
            ],
            isDisabled: isDisabled,
            onMenuOpen: ()=>{
                sendAnalyticsEvent({
                    action: "opened",
                    actionSubject: "dropdown",
                    actionSubjectId: "rovoConfluenceAddLabelPageSelector"
                });
            },
            isRequired: true,
            onChange: (option)=>{
                if (option) {
                    setSelectedEntity(option);
                    sendAnalyticsEvent({
                        action: "selected",
                        actionSubject: "dropdown",
                        actionSubjectId: "rovoConfluenceAddLabelPageSelector"
                    });
                }
            },
            value: selectedEntity
        });
        $[32] = cloudId;
        $[33] = isDisabled;
        $[34] = selectedEntity;
        $[35] = sendAnalyticsEvent;
        $[36] = t11;
    } else t11 = $[36];
    let t12;
    if ($[37] !== t10 || $[38] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t10, t11);
        $[37] = t10;
        $[38] = t11;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== formatMessage || $[41] !== isDisabled || $[42] !== labelName || $[43] !== sendAnalyticsEvent) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, labelName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3tf0.default), {
            testId: "confluence-page-add-label-name-input-field",
            isRequired: true,
            isCompact: true,
            readViewFitContainerWidth: true,
            defaultValue: labelName,
            label: formatMessage((0, $kN5Cw.default).labelNameLabel),
            onConfirm: (value)=>{
                setLabelName(value);
                sendAnalyticsEvent({
                    action: "edited",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluenceAddLabel"
                });
            },
            onCancel: ()=>{
                sendAnalyticsEvent({
                    action: "cancelled",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluenceAddLabel"
                });
            },
            placeholder: formatMessage((0, $kN5Cw.default).labelPlaceholder)
        }));
        $[40] = formatMessage;
        $[41] = isDisabled;
        $[42] = labelName;
        $[43] = sendAnalyticsEvent;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== t12 || $[46] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t12, t13);
        $[45] = t12;
        $[46] = t13;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] !== formatMessage) {
        t15 = formatMessage((0, $kN5Cw.default).addLabelButton);
        $[48] = formatMessage;
        $[49] = t15;
    } else t15 = $[49];
    let t16;
    if ($[50] !== handleSubmit || $[51] !== isDisabled || $[52] !== isSubmitting || $[53] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: isDisabled,
            isLoading: isSubmitting,
            onClick: handleSubmit
        }, t15));
        $[50] = handleSubmit;
        $[51] = isDisabled;
        $[52] = isSubmitting;
        $[53] = t15;
        $[54] = t16;
    } else t16 = $[54];
    let t17;
    if ($[55] !== t14 || $[56] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: "Add Label",
            product: "confluence"
        }, t14, t16);
        $[55] = t14;
        $[56] = t16;
        $[57] = t17;
    } else t17 = $[57];
    let t18;
    if ($[58] !== t17 || $[59] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.250",
            testId: "confluence-page-add-label-action"
        }, t8, t17);
        $[58] = t17;
        $[59] = t8;
        $[60] = t18;
    } else t18 = $[60];
    return t18;
} : ({ onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const [labelName, setLabelName] = (0, $cozmU.useState)(data.name);
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const [selectedEntity, setSelectedEntity] = (0, $cozmU.useState)(undefined);
    const isDisabled = status !== 'idle' || readonly || !selectedEntity || !labelName;
    const isSubmitting = status === 'started';
    (0, $cozmU.useEffect)(()=>{
        const fetchPage = async ()=>{
            if (data.id) {
                const entity = await getEntity(data.id, 'page');
                if (entity) setSelectedEntity({
                    label: entity.name,
                    value: entity.id,
                    type: 'page'
                });
            }
        };
        fetchPage();
    }, [
        data.id,
        getEntity
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        const mergedData = {
            ...data,
            name: labelName,
            id: selectedEntity?.value,
            contentType: selectedEntity?.type ?? 'page'
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluencePageAddLabelRenderer'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onCustomDataConfirm(firstAction, mergedData);
    }, [
        onCustomDataConfirm,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        data,
        labelName,
        selectedEntity?.value,
        selectedEntity?.type,
        firstAction,
        actions,
        getStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.250",
        testId: "confluence-page-add-label-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $kN5Cw.default).actionMessage, {
        name: selectedEntity?.label ?? '',
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: "Add Label",
        product: "confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $kN5Cw.default).pageSelectorLabel)), !selectedEntity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 30,
        width: 200,
        borderRadius: "var(--ds-radius-large, 8px)",
        testId: "confluence-page-add-label-page-selector-skeleton"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
        cloudId: cloudId,
        testId: "confluence-page-add-label-page-selector",
        contentTypes: [
            'page',
            'blogPost'
        ],
        isDisabled: isDisabled,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoConfluenceAddLabelPageSelector'
            });
        },
        isRequired: true,
        onChange: (option)=>{
            if (option) {
                setSelectedEntity(option);
                sendAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoConfluenceAddLabelPageSelector'
                });
            }
        },
        value: selectedEntity
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, labelName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3tf0.default), {
        testId: "confluence-page-add-label-name-input-field",
        isRequired: true,
        isCompact: true,
        readViewFitContainerWidth: true,
        defaultValue: labelName,
        label: formatMessage((0, $kN5Cw.default).labelNameLabel),
        onConfirm: (value)=>{
            setLabelName(value);
            sendAnalyticsEvent({
                action: 'edited',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceAddLabel'
            });
        },
        onCancel: ()=>{
            sendAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceAddLabel'
            });
        },
        placeholder: formatMessage((0, $kN5Cw.default).labelPlaceholder)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: isDisabled,
        isLoading: isSubmitting,
        onClick: handleSubmit
    }, formatMessage((0, $kN5Cw.default).addLabelButton)))));
};
function $1a12f3f75aa483da$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks);
}
module.exports["ConfluencePageAddLabelAction"] = $1a12f3f75aa483da$export$e092d6a6b15f8938;

});

parcelRegister("1XOZs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $bcDqz = parcelRequire("bcDqz");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $eDtFr = parcelRequire("eDtFr");


var $lSQgn = parcelRequire("lSQgn");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $e3Wrf = parcelRequire("e3Wrf");


var $ieeJu = parcelRequire("ieeJu");


var $aihbI = parcelRequire("aihbI");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1HjbK = parcelRequire("1HjbK");


var $isp1U = parcelRequire("isp1U");


var $g3R09 = parcelRequire("g3R09");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $7cWmx = parcelRequire("7cWmx");


const $2475fca3cd5c8a8a$var$MarkdownRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("039lM")).then(({ default: ReactMarkdown })=>({
            default: ReactMarkdown
        })));
const $2475fca3cd5c8a8a$var$styles = {
    readView: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL4gVvo _4c065U2ADO _4kiQYA7hsp",
    messageBox: "_313842UgYP _1DCdHi5UaJ",
    pageSelectorWrapper: "_2O5Vij7dHp",
    inlineTextSelectionBox: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _39xV02N91d _0KLXrulfZc",
    inlineTextSelectionHighlighted: "_0KLXru56u3 _3hhsrrNvrM _3BoeID6wH8 _3XVgLM20Gf",
    replyingAsBox: "_2YLqiK2ADO _3138425UaJ _1DCdHi2ADO"
};
const $2475fca3cd5c8a8a$export$93ab3e259f6f178e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2475fca3cd5c8a8a$var$ConfluencePageCommentActionNewLayout, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2475fca3cd5c8a8a$var$ConfluencePageCommentActionNewLayout, props);
};
const $2475fca3cd5c8a8a$var$ConfluencePageCommentActionNewLayout = ({ onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $1HjbK.useConfluenceEntities), (0, $aihbI.useProfileResolution));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const [selectedEntity, setSelectedEntity] = (0, $cozmU.useState)(undefined);
    const [comment, setComment] = (0, $cozmU.useState)(data.comment ?? '');
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isSubmitting = status === 'started';
    const isActionEnhancementsEnabled = (0, $ieeJu.expValEquals)('platform_rovo_support_create_inline_comment', 'isEnabled', true);
    const isReply = isActionEnhancementsEnabled && !!data.parentCommentId;
    const isReplyWithAgent = isReply && !!data.systemAccountId;
    const isInlineComment = isActionEnhancementsEnabled && !isReply && !!data.inlineTextSelection;
    const isCommentEmpty = isActionEnhancementsEnabled && (!comment || comment.trim() === '');
    const resolvedContentType = data.contentType === 'blogpost' ? 'blogPost' : data.contentType;
    const fallbackSelectedEntity = data.contentId && resolvedContentType ? {
        label: '',
        value: data.contentId,
        type: resolvedContentType
    } : undefined;
    const submitTargetEntity = selectedEntity ?? (isReply ? fallbackSelectedEntity : undefined);
    const isDisabled = status !== 'idle' || readonly || !submitTargetEntity || !comment;
    (0, $cozmU.useEffect)(()=>{
        const fetchPage = async ()=>{
            if (data.contentId) {
                const entity = await getEntity(data.contentId, resolvedContentType);
                if (entity) setSelectedEntity({
                    label: entity.name,
                    value: entity.id,
                    type: resolvedContentType === 'page' ? 'page' : 'blogPost'
                });
            }
        };
        fetchPage();
    }, [
        data.contentId,
        resolvedContentType,
        getEntity
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluencePageCommentRenderer'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', {
                            ...data,
                            comment: comment,
                            contentId: submitTargetEntity?.value,
                            contentType: submitTargetEntity?.type ?? 'page'
                        }) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onCustomDataConfirm(firstAction, {
            ...data,
            comment: comment,
            contentId: submitTargetEntity?.value,
            contentType: submitTargetEntity?.type ?? 'page'
        });
    }, [
        onCustomDataConfirm,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        data,
        comment,
        submitTargetEntity?.value,
        submitTargetEntity?.type,
        firstAction,
        actions,
        getStatus
    ]);
    const currentUser = (0, $isp1U.useProfileController)();
    const { profile: systemProfile } = (0, $aihbI.useProfileResolution)(data.systemAccountId ?? '', cloudId, /* shouldFetch = */ isReplyWithAgent);
    const systemUser = (0, $cozmU.useMemo)(()=>{
        return {
            displayName: systemProfile.data?.nickname ?? systemProfile.data?.fullName ?? '',
            avatarUrl: systemProfile.data?.avatarUrl ?? ''
        };
    }, [
        systemProfile.data
    ]);
    const getActionCardTitleMessage = (0, $cozmU.useCallback)(()=>{
        if (isReply) return (0, $7cWmx.default).confluenceCommentCreateReplyActionCardTitle;
        if (isInlineComment) return (0, $7cWmx.default).confluenceCommentCreateInlineActionCardTitle;
        return (0, $7cWmx.default).confluenceCommentCreateActionCardTitle;
    }, [
        isReply,
        isInlineComment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $7cWmx.default).actionMessage, {
        name: selectedEntity?.label ?? '',
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage(getActionCardTitleMessage()),
        product: "confluence",
        headerIcon: isActionEnhancementsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            label: "",
            testId: "confluence-page-comment-header-icon",
            appearance: "blue",
            size: "medium"
        }) : undefined,
        isTitleBold: isActionEnhancementsEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, !isReplyWithAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $7cWmx.default).pageSelectorLabel)), !selectedEntity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 30,
        width: 200,
        borderRadius: "var(--ds-radius-large, 8px)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2475fca3cd5c8a8a$var$styles.pageSelectorWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
        cloudId: cloudId,
        testId: "confluence-page-comment-page-selector",
        contentTypes: [
            'page',
            'blogPost'
        ],
        isDisabled: isDisabled || isInlineComment || isReply,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoConfluenceCommentCreatePageSelector'
            });
        },
        isRequired: true,
        onChange: (option)=>{
            if (option) {
                setSelectedEntity(option);
                sendAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoConfluenceCommentCreatePageSelector'
                });
            }
        },
        value: selectedEntity
    }))), isInlineComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "inlineTextSelection-container",
        xcss: $2475fca3cd5c8a8a$var$styles.inlineTextSelectionBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testId": "inlineTextSelection-text",
        className: (0, $hekY6.default)([
            !isDisabled && $2475fca3cd5c8a8a$var$styles.inlineTextSelectionHighlighted
        ])
    }, data.inlineTextSelection))), isReplyWithAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, formatMessage((0, $7cWmx.default).replyingAsLabel)), isReplyWithAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2475fca3cd5c8a8a$var$styles.replyingAsBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        appearance: "stack",
        data: [
            {
                appearance: 'hexagon',
                // use hexagon shape for agent avatar
                name: systemUser.displayName,
                src: systemUser.avatarUrl,
                stackIndex: 0,
                testId: 'replying-as-avatar-agent'
            },
            {
                appearance: 'circle',
                name: currentUser.displayName ?? '',
                src: currentUser.avatarUrl,
                stackIndex: 1,
                testId: 'replying-as-avatar-current-user'
            }
        ],
        size: "small",
        maxCount: 2,
        testId: "replying-as-avatar-group"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $7cWmx.default).replyWithAgentText, {
        userName: systemUser.displayName || 'Agent'
    })))), isActionEnhancementsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, formatMessage((0, $7cWmx.default).commentMessageLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2475fca3cd5c8a8a$var$styles.messageBox
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2475fca3cd5c8a8a$var$styles.readView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2475fca3cd5c8a8a$var$MarkdownRenderer, null, comment))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
        defaultValue: comment,
        onConfirm: (value)=>{
            setComment(value ?? '');
            sendAnalyticsEvent({
                action: 'edited',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceCommentCreateContent'
            });
        },
        onEdit: ()=>{
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceCommentCreateContent'
            });
        },
        onCancel: ()=>{
            sendAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceCommentCreateContent'
            });
        },
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $2475fca3cd5c8a8a$var$styles.readView
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2475fca3cd5c8a8a$var$MarkdownRenderer, null, comment))),
        editView: ({ errorMessage: _errorMessage, ...fieldProps }, ref)=>// @ts-expect-error - TextArea onChange: string | FormEvent but @atlaskit/textarea expects ChangeEvent; upstream type gap
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                isReadOnly: readonly,
                ref: ref
            }),
        isRequired: true,
        hideActionButtons: readonly,
        readViewFitContainerWidth: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: isDisabled || isCommentEmpty,
        onClick: (_, e)=>{
            handleSubmit();
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'rovoConfluenceCommentCreateSubmit'
            }));
        }
    }, formatMessage(isReply ? (0, $7cWmx.default).replyButton : (0, $7cWmx.default).publishButton))))));
};
module.exports["ConfluencePageCommentAction"] = $2475fca3cd5c8a8a$export$93ab3e259f6f178e;

});

parcelRegister("9XLO4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $6RwwD = parcelRequire("6RwwD");


var $jlRK6 = parcelRequire("jlRK6");


var $4nt1R = parcelRequire("4nt1R");


var $dVPAB = parcelRequire("dVPAB");


var $40ukF = parcelRequire("40ukF");


var $8PVlW = parcelRequire("8PVlW");


var $iVGec = parcelRequire("iVGec");


var $hFvHs = parcelRequire("hFvHs");


var $2ZvWx = parcelRequire("2ZvWx");


var $2hEu6 = parcelRequire("2hEu6");


var $gUZEQ = parcelRequire("gUZEQ");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $kLlYX = parcelRequire("kLlYX");


var $hMaHH = parcelRequire("hMaHH");


var $1JERl = parcelRequire("1JERl");

var $c3tf0 = parcelRequire("c3tf0");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1HjbK = parcelRequire("1HjbK");


var $cDpdq = parcelRequire("cDpdq");


var $fuTaJ = parcelRequire("fuTaJ");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $3sxic = parcelRequire("3sxic");

const $8228cfce64e3bfe8$var$styles = {
    pageIcon: "_0Of8r2FQfX",
    pageTitleWrapper: "_2O5Vij7dHp _3138424F84",
    contentWrapper: "_313842UgYP _1DCdHi4F84",
    pageTitleReadView: "_2sNsIgmnOE _4c065U1Y8M _2Y7lL4gVvo _3iDTPbQ4SZ _1EqgXlN91d _3W2Oc8wPeg"
};
const $8228cfce64e3bfe8$var$ConfluencePageCreateActionNewLayout = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(92);
    const { onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, aaid: aaid, productKey: productKey, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    (0, $6cFsl.di)((0, $jlRK6.ComposableEditor));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    let t1;
    if ($[0] !== firstAction || $[1] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[0] = firstAction;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== getStatus) {
        t2 = getStatus(firstAction);
        $[3] = firstAction;
        $[4] = getStatus;
        $[5] = t2;
    } else t2 = $[5];
    const status = t2;
    const [name, setName] = (0, $cozmU.useState)(data.name);
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(undefined);
    let t3;
    if ($[6] !== data.content) {
        t3 = data.content?.length ? JSON.parse(data.content) : undefined;
        $[6] = data.content;
        $[7] = t3;
    } else t3 = $[7];
    const [content, setContent] = (0, $cozmU.useState)(t3);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isActionLoading = status !== "idle";
    const isPublishDisabled = isActionLoading || readonly || !name || !selectedSpace || !content;
    const isEditorDisabled = isActionLoading || readonly || !name;
    const isSubmitting = status === "started";
    let t4;
    if ($[8] !== cloudId || $[9] !== productKey) {
        t4 = {
            cloudId: cloudId,
            product: productKey
        };
        $[8] = cloudId;
        $[9] = productKey;
        $[10] = t4;
    } else t4 = $[10];
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(undefined, t4);
    let t5;
    if ($[11] !== formatMessage || $[12] !== linkPicker) {
        t5 = ()=>(0, $4nt1R.createDefaultPreset)({
                placeholder: {
                    placeholder: formatMessage((0, $3sxic.default).pageContentPlaceholder)
                }
            }).add((0, $8PVlW.contentInsertionPlugin)).add([
                (0, $gUZEQ.default),
                {
                    isChromelessEditor: true,
                    tableOptions: {}
                }
            ]).add((0, $2ZvWx.mentionsPlugin)).add((0, $iVGec.gridPlugin)).add([
                (0, $40ukF.cardPlugin),
                {
                    allowBlockCards: false,
                    allowEmbeds: false,
                    linkPicker: linkPicker,
                    provider: Promise.resolve((0, $6RwwD.editorCardProvider))
                }
            ]).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin));
        $[11] = formatMessage;
        $[12] = linkPicker;
        $[13] = t5;
    } else t5 = $[13];
    const { preset: preset } = (0, $dVPAB.usePreset)(t5);
    let t6;
    let t7;
    if ($[14] !== data.folder || $[15] !== getEntity) {
        t6 = ()=>{
            const fetchSpace = async ()=>{
                if (data.folder) {
                    const space = await getEntity(data.folder, "space");
                    if (space) setSelectedSpace({
                        label: space.name,
                        value: space.id,
                        iconPath: space.icon?.path,
                        key: space.key
                    });
                }
            };
            fetchSpace();
        };
        t7 = [
            data.folder,
            getEntity
        ];
        $[14] = data.folder;
        $[15] = getEntity;
        $[16] = t6;
        $[17] = t7;
    } else {
        t6 = $[16];
        t7 = $[17];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[18] !== actions || $[19] !== content || $[20] !== conversationId || $[21] !== data || $[22] !== firstAction || $[23] !== getStatus || $[24] !== messageId || $[25] !== name || $[26] !== onCustomDataConfirm || $[27] !== recipientAgentId || $[28] !== selectedSpace?.value || $[29] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            const mergedData = {
                ...data,
                extraInputs: {
                    ...data.extraInputs,
                    representation: "atlas_doc_format"
                },
                name: name,
                folder: selectedSpace?.value,
                content: JSON.stringify(content)
            };
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const plannedActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "confluencePageCreateRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onCustomDataConfirm(firstAction, mergedData);
        };
        $[18] = actions;
        $[19] = content;
        $[20] = conversationId;
        $[21] = data;
        $[22] = firstAction;
        $[23] = getStatus;
        $[24] = messageId;
        $[25] = name;
        $[26] = onCustomDataConfirm;
        $[27] = recipientAgentId;
        $[28] = selectedSpace?.value;
        $[29] = sendMessageConfirmedTools;
        $[30] = t8;
    } else t8 = $[30];
    selectedSpace?.value;
    const handleSubmit = t8;
    let t9;
    if ($[31] !== data.extraInputs) {
        t9 = data.extraInputs?.subtype === "live" && (0, $iDrrr.fg)("rovo_create_page_action_enable_live_doc_creation");
        $[31] = data.extraInputs;
        $[32] = t9;
    } else t9 = $[32];
    const shouldRenderLiveDocUI = t9;
    let t10;
    if ($[33] !== formatMessage || $[34] !== selectedSpace?.label || $[35] !== shouldRenderLiveDocUI) {
        t10 = shouldRenderLiveDocUI ? formatMessage((0, $3sxic.default).actionMessageLiveDoc, {
            spaceName: selectedSpace?.label ?? "",
            bold: $8228cfce64e3bfe8$var$_temp
        }) : formatMessage((0, $3sxic.default).actionMessage, {
            spaceName: selectedSpace?.label ?? "",
            bold: $8228cfce64e3bfe8$var$_temp2
        });
        $[33] = formatMessage;
        $[34] = selectedSpace?.label;
        $[35] = shouldRenderLiveDocUI;
        $[36] = t10;
    } else t10 = $[36];
    let t11;
    if ($[37] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, t10);
        $[37] = t10;
        $[38] = t11;
    } else t11 = $[38];
    let t12;
    if ($[39] !== formatMessage) {
        t12 = formatMessage((0, $3sxic.default).confluencePageCreateActionCardTitle);
        $[39] = formatMessage;
        $[40] = t12;
    } else t12 = $[40];
    let t13;
    if ($[41] !== formatMessage) {
        t13 = formatMessage((0, $3sxic.default).spaceSelectorLabel);
        $[41] = formatMessage;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t13);
        $[43] = t13;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== aaid || $[46] !== cloudId || $[47] !== isActionLoading || $[48] !== isEditorDisabled || $[49] !== selectedSpace || $[50] !== sendAnalyticsEvent) {
        t15 = isActionLoading ? /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            height: 30,
            width: 200,
            borderRadius: "var(--ds-radius-large, 8px)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, $fuTaJ.ConfluenceSpaceSelector), {
            cloudId: cloudId,
            userId: aaid,
            testId: "confluence-page-create-space-selector",
            isDisabled: isEditorDisabled,
            onMenuOpen: ()=>{
                sendAnalyticsEvent({
                    action: "opened",
                    actionSubject: "dropdown",
                    actionSubjectId: "rovoConfluencePageCreateSpaceSelector"
                });
            },
            isRequired: true,
            onChange: (option)=>{
                if (option) {
                    setSelectedSpace(option);
                    sendAnalyticsEvent({
                        action: "selected",
                        actionSubject: "dropdown",
                        actionSubjectId: "rovoConfluencePageCreateSpaceSelector"
                    });
                }
            },
            value: selectedSpace
        });
        $[45] = aaid;
        $[46] = cloudId;
        $[47] = isActionLoading;
        $[48] = isEditorDisabled;
        $[49] = selectedSpace;
        $[50] = sendAnalyticsEvent;
        $[51] = t15;
    } else t15 = $[51];
    let t16;
    if ($[52] !== t14 || $[53] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t14, t15);
        $[52] = t14;
        $[53] = t15;
        $[54] = t16;
    } else t16 = $[54];
    let t17;
    if ($[55] !== shouldRenderLiveDocUI) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8228cfce64e3bfe8$var$styles.pageIcon
        }, shouldRenderLiveDocUI ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon-brand)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon-brand)"
        }));
        $[55] = shouldRenderLiveDocUI;
        $[56] = t17;
    } else t17 = $[56];
    let t18;
    if ($[57] !== formatMessage || $[58] !== isEditorDisabled || $[59] !== name || $[60] !== sendAnalyticsEvent) {
        t18 = isEditorDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8228cfce64e3bfe8$var$styles.pageTitleReadView
        }, name || formatMessage((0, $3sxic.default).pageContentPlaceholder)) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8228cfce64e3bfe8$var$styles.pageTitleWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $c3tf0.default), {
            testId: "page-name-input-field",
            isRequired: true,
            isCompact: true,
            readViewFitContainerWidth: true,
            defaultValue: name,
            onConfirm: (value)=>{
                setName(value);
                sendAnalyticsEvent({
                    action: "edited",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluencePageCreateTitle"
                });
            },
            onCancel: ()=>{
                sendAnalyticsEvent({
                    action: "cancelled",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluencePageCreateTitle"
                });
            },
            placeholder: formatMessage((0, $3sxic.default).pageContentPlaceholder)
        }));
        $[57] = formatMessage;
        $[58] = isEditorDisabled;
        $[59] = name;
        $[60] = sendAnalyticsEvent;
        $[61] = t18;
    } else t18 = $[61];
    let t19;
    if ($[62] !== t17 || $[63] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.025",
            alignBlock: "center",
            xcss: $8228cfce64e3bfe8$var$styles.pageTitleWrapper
        }, t17, t18);
        $[62] = t17;
        $[63] = t18;
        $[64] = t19;
    } else t19 = $[64];
    let t20;
    if ($[65] !== content || $[66] !== isEditorDisabled || $[67] !== preset || $[68] !== sendAnalyticsEvent) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8228cfce64e3bfe8$var$styles.contentWrapper
        }, isEditorDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
            disabled: isEditorDisabled,
            appearance: "chromeless",
            preset: preset,
            defaultValue: content
        }) : /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            isRequired: true,
            defaultValue: content,
            readViewFitContainerWidth: true,
            readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                    appearance: "chromeless",
                    preset: preset,
                    defaultValue: content
                }),
            editView: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                    ...props,
                    shouldFocus: true,
                    appearance: "chromeless",
                    preset: preset,
                    onChange: (e)=>{
                        props.onChange(e.state.doc.toJSON());
                    },
                    defaultValue: content
                }),
            onEdit: ()=>{
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluencePageCreateContent"
                });
            },
            onConfirm: (value_0)=>{
                setContent(value_0);
                sendAnalyticsEvent({
                    action: "edited",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluencePageCreateContent"
                });
            },
            onCancel: ()=>{
                sendAnalyticsEvent({
                    action: "cancelled",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluencePageCreateContent"
                });
            }
        }));
        $[65] = content;
        $[66] = isEditorDisabled;
        $[67] = preset;
        $[68] = sendAnalyticsEvent;
        $[69] = t20;
    } else t20 = $[69];
    let t21;
    if ($[70] !== t16 || $[71] !== t19 || $[72] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t16, t19, t20);
        $[70] = t16;
        $[71] = t19;
        $[72] = t20;
        $[73] = t21;
    } else t21 = $[73];
    let t22;
    if ($[74] !== handleSubmit || $[75] !== sendAnalyticsEvent) {
        t22 = (_, e_0)=>{
            handleSubmit();
            sendAnalyticsEvent(e_0.update({
                actionSubjectId: "rovoConfluencePageCreateSubmit"
            }));
        };
        $[74] = handleSubmit;
        $[75] = sendAnalyticsEvent;
        $[76] = t22;
    } else t22 = $[76];
    let t23;
    if ($[77] !== formatMessage || $[78] !== shouldRenderLiveDocUI) {
        t23 = shouldRenderLiveDocUI ? formatMessage((0, $3sxic.default).createLiveDocButton) : formatMessage((0, $3sxic.default).publishPageButton);
        $[77] = formatMessage;
        $[78] = shouldRenderLiveDocUI;
        $[79] = t23;
    } else t23 = $[79];
    let t24;
    if ($[80] !== isPublishDisabled || $[81] !== isSubmitting || $[82] !== t22 || $[83] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isLoading: isSubmitting,
            isDisabled: isPublishDisabled,
            onClick: t22
        }, t23));
        $[80] = isPublishDisabled;
        $[81] = isSubmitting;
        $[82] = t22;
        $[83] = t23;
        $[84] = t24;
    } else t24 = $[84];
    let t25;
    if ($[85] !== t12 || $[86] !== t21 || $[87] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            title: t12,
            product: "confluence"
        }, t21, t24);
        $[85] = t12;
        $[86] = t21;
        $[87] = t24;
        $[88] = t25;
    } else t25 = $[88];
    let t26;
    if ($[89] !== t11 || $[90] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.250"
        }, t11, t25);
        $[89] = t11;
        $[90] = t25;
        $[91] = t26;
    } else t26 = $[91];
    return t26;
} : ({ onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, aaid: aaid, productKey: productKey, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $jlRK6.ComposableEditor));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const [name, setName] = (0, $cozmU.useState)(data.name);
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(undefined);
    const [content, setContent] = (0, $cozmU.useState)(data.content?.length ? JSON.parse(data.content) : undefined);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isActionLoading = status !== 'idle';
    const isPublishDisabled = isActionLoading || readonly || !name || !selectedSpace || !content;
    const isEditorDisabled = isActionLoading || readonly || !name;
    const isSubmitting = status === 'started';
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(undefined, {
        cloudId: cloudId,
        product: productKey
    });
    const { preset: preset } = (0, $dVPAB.usePreset)(()=>(0, $4nt1R.createDefaultPreset)({
            placeholder: {
                placeholder: formatMessage((0, $3sxic.default).pageContentPlaceholder)
            }
        }).add((0, $8PVlW.contentInsertionPlugin)).add([
            (0, $gUZEQ.default),
            {
                isChromelessEditor: true,
                tableOptions: {}
            }
        ]).add((0, $2ZvWx.mentionsPlugin)).add((0, $iVGec.gridPlugin)).add([
            (0, $40ukF.cardPlugin),
            {
                allowBlockCards: false,
                allowEmbeds: false,
                linkPicker: linkPicker,
                provider: Promise.resolve((0, $6RwwD.editorCardProvider))
            }
        ]).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin)));
    (0, $cozmU.useEffect)(()=>{
        const fetchSpace = async ()=>{
            if (data.folder) {
                const space = await getEntity(data.folder, 'space');
                if (space) setSelectedSpace({
                    label: space.name,
                    value: space.id,
                    iconPath: space.icon?.path,
                    key: space.key
                });
            }
        };
        fetchSpace();
    }, [
        data.folder,
        getEntity
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        const mergedData = {
            ...data,
            extraInputs: {
                ...data.extraInputs,
                representation: 'atlas_doc_format'
            },
            name: name,
            folder: selectedSpace?.value,
            content: JSON.stringify(content)
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluencePageCreateRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onCustomDataConfirm(firstAction, mergedData);
    }, [
        onCustomDataConfirm,
        data,
        name,
        selectedSpace?.value,
        content,
        firstAction,
        actions,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        getStatus
    ]); // determine if we should render the live doc elements
    const shouldRenderLiveDocUI = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.extraInputs?.subtype === 'live' && (0, $iDrrr.fg)('rovo_create_page_action_enable_live_doc_creation');
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, shouldRenderLiveDocUI ? formatMessage((0, $3sxic.default).actionMessageLiveDoc, {
        spaceName: selectedSpace?.label ?? '',
        bold: (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks)
    }) : formatMessage((0, $3sxic.default).actionMessage, {
        spaceName: selectedSpace?.label ?? '',
        bold: (chunks_0)=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks_0)
    })), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $3sxic.default).confluencePageCreateActionCardTitle),
        product: "confluence"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $3sxic.default).spaceSelectorLabel)), isActionLoading ? /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        height: 30,
        width: 200,
        borderRadius: "var(--ds-radius-large, 8px)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, $fuTaJ.ConfluenceSpaceSelector), {
        cloudId: cloudId,
        userId: aaid,
        testId: "confluence-page-create-space-selector",
        isDisabled: isEditorDisabled,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoConfluencePageCreateSpaceSelector'
            });
        },
        isRequired: true,
        onChange: (option)=>{
            if (option) {
                setSelectedSpace(option);
                sendAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoConfluencePageCreateSpaceSelector'
                });
            }
        },
        value: selectedSpace
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.025",
        alignBlock: "center",
        xcss: $8228cfce64e3bfe8$var$styles.pageTitleWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8228cfce64e3bfe8$var$styles.pageIcon
    }, shouldRenderLiveDocUI ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon-brand)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon-brand)"
    })), isEditorDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8228cfce64e3bfe8$var$styles.pageTitleReadView
    }, name || formatMessage((0, $3sxic.default).pageContentPlaceholder)) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8228cfce64e3bfe8$var$styles.pageTitleWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $c3tf0.default), {
        testId: "page-name-input-field",
        isRequired: true,
        isCompact: true,
        readViewFitContainerWidth: true,
        defaultValue: name,
        onConfirm: (value)=>{
            setName(value);
            sendAnalyticsEvent({
                action: 'edited',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluencePageCreateTitle'
            });
        },
        onCancel: ()=>{
            sendAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluencePageCreateTitle'
            });
        },
        placeholder: formatMessage((0, $3sxic.default).pageContentPlaceholder)
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8228cfce64e3bfe8$var$styles.contentWrapper
    }, isEditorDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
        disabled: isEditorDisabled,
        appearance: "chromeless",
        preset: preset,
        defaultValue: content
    }) : /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        isRequired: true,
        defaultValue: content,
        readViewFitContainerWidth: true,
        readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                appearance: "chromeless",
                preset: preset,
                defaultValue: content
            }),
        editView: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                ...props,
                shouldFocus: true,
                appearance: "chromeless",
                preset: preset,
                onChange: (e)=>{
                    props.onChange(e.state.doc.toJSON());
                },
                defaultValue: content
            }),
        onEdit: ()=>{
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluencePageCreateContent'
            });
        },
        onConfirm: (value_0)=>{
            setContent(value_0);
            sendAnalyticsEvent({
                action: 'edited',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluencePageCreateContent'
            });
        },
        onCancel: ()=>{
            sendAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluencePageCreateContent'
            });
        }
    }))), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: isPublishDisabled,
        onClick: (_, e_0)=>{
            handleSubmit();
            sendAnalyticsEvent(e_0.update({
                actionSubjectId: 'rovoConfluencePageCreateSubmit'
            }));
        }
    }, shouldRenderLiveDocUI ? formatMessage((0, $3sxic.default).createLiveDocButton) : formatMessage((0, $3sxic.default).publishPageButton)))));
};
const $8228cfce64e3bfe8$export$1cc32a5f37fc3b43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($8228cfce64e3bfe8$var$ConfluencePageCreateActionNewLayout, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($8228cfce64e3bfe8$var$ConfluencePageCreateActionNewLayout, props);
};
function $8228cfce64e3bfe8$var$_temp(chunks) {
    return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks);
}
function $8228cfce64e3bfe8$var$_temp2(chunks_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks_0);
}
module.exports["ConfluencePageCreateAction"] = $8228cfce64e3bfe8$export$1cc32a5f37fc3b43;

});

parcelRegister("2rhig", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $kB5K2 = parcelRequire("kB5K2");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $5OelY = parcelRequire("5OelY");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $1HjbK = parcelRequire("1HjbK");


var $g3R09 = parcelRequire("g3R09");


var $fuTaJ = parcelRequire("fuTaJ");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $gQM67 = parcelRequire("gQM67");

const $f9d3aab52f60d89e$export$bb94aa48518d2e3 = (actions)=>{
    const filteredActions = actions.filter($f9d3aab52f60d89e$var$assertIsConfluencePageMoveAction);
    return filteredActions;
};
const $f9d3aab52f60d89e$var$assertIsConfluencePageMoveAction = (action)=>{
    if (action.key !== (0, $dw75i.CONFLUENCE_PAGE_MOVE_KEY)) throw new Error('Invalid action key for ConfluencePageMoveAction');
    return action;
};
const $f9d3aab52f60d89e$export$4d70762bf18a1585 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(87);
    const { onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, aaid: aaid, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    let t1;
    if ($[0] !== firstAction || $[1] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[0] = firstAction;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== getStatus) {
        t2 = getStatus(firstAction);
        $[3] = firstAction;
        $[4] = getStatus;
        $[5] = t2;
    } else t2 = $[5];
    const status = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fetchHomepage: true
        };
        $[6] = t3;
    } else t3 = $[6];
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId, t3);
    const [selectedPage, setSelectedPage] = (0, $cozmU.useState)(undefined);
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(undefined);
    const isDisabled = status !== "idle" || readonly || !selectedPage;
    const isSubmitting = status === "started";
    let t4;
    if ($[7] !== data.targetId || $[8] !== getEntity) {
        t4 = ()=>{
            const fetchPage = async ()=>{
                if (data.targetId) {
                    const page = await getEntity(data.targetId, "page");
                    const space = await getEntity(data.targetId, "space");
                    if (page) {
                        setSelectedPage({
                            label: page.name,
                            value: page.id,
                            type: "page"
                        });
                        if (page.space?.id) {
                            const spaceId = (0, $5OelY.ConfluenceSpaceAri).parse(page.space.id).spaceId;
                            setSelectedSpace({
                                label: page.space.name ?? "",
                                value: spaceId,
                                key: page.space.key ?? "",
                                iconPath: page.space.icon?.path ?? ""
                            });
                        }
                    } else if (space) {
                        setSelectedSpace({
                            label: space.name,
                            value: space.id,
                            key: space.key,
                            iconPath: space.icon?.path
                        });
                        setSelectedPage({
                            label: space.homepage?.name ?? "",
                            value: space.homepage?.id ?? "",
                            type: "page"
                        });
                    }
                }
            };
            fetchPage();
        };
        $[7] = data.targetId;
        $[8] = getEntity;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== data || $[11] !== getEntity) {
        t5 = [
            data,
            getEntity
        ];
        $[10] = data;
        $[11] = getEntity;
        $[12] = t5;
    } else t5 = $[12];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[13] !== actions || $[14] !== conversationId || $[15] !== data || $[16] !== firstAction || $[17] !== getStatus || $[18] !== messageId || $[19] !== onCustomDataConfirm || $[20] !== recipientAgentId || $[21] !== selectedPage?.type || $[22] !== selectedPage?.value || $[23] !== sendMessageConfirmedTools) {
        t6 = ()=>{
            const mergedData = {
                ...data,
                targetId: selectedPage?.value,
                contentType: selectedPage?.type ?? "page"
            };
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const plannedActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "confluencePageMoveRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onCustomDataConfirm(firstAction, mergedData);
        };
        $[13] = actions;
        $[14] = conversationId;
        $[15] = data;
        $[16] = firstAction;
        $[17] = getStatus;
        $[18] = messageId;
        $[19] = onCustomDataConfirm;
        $[20] = recipientAgentId;
        $[21] = selectedPage?.type;
        $[22] = selectedPage?.value;
        $[23] = sendMessageConfirmedTools;
        $[24] = t6;
    } else t6 = $[24];
    const handleSubmit = t6;
    const t7 = selectedPage?.label ?? "";
    let t8;
    if ($[25] !== formatMessage || $[26] !== t7) {
        t8 = formatMessage((0, $gQM67.default).actionMessage, {
            name: t7,
            bold: $f9d3aab52f60d89e$var$_temp
        });
        $[25] = formatMessage;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t8);
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== formatMessage) {
        t10 = formatMessage((0, $gQM67.default).confluencePageMoveActionCardTitle);
        $[30] = formatMessage;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== formatMessage) {
        t11 = formatMessage((0, $gQM67.default).spaceSelectorLabel);
        $[32] = formatMessage;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "confluence-page-move-space-selector"
        }, t11);
        $[34] = t11;
        $[35] = t12;
    } else t12 = $[35];
    let t13;
    if ($[36] !== sendAnalyticsEvent) {
        t13 = ()=>{
            sendAnalyticsEvent({
                action: "opened",
                actionSubject: "dropdown",
                actionSubjectId: "rovoConfluencePageMoveSpaceSelector"
            });
        };
        $[36] = sendAnalyticsEvent;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== sendAnalyticsEvent) {
        t14 = (option)=>{
            if (option) {
                setSelectedSpace(option);
                setSelectedPage({
                    label: option.homepage?.label ?? "",
                    value: option.homepage?.value ?? "",
                    type: option.homepage?.type ?? "page"
                });
                sendAnalyticsEvent({
                    action: "selected",
                    actionSubject: "dropdown",
                    actionSubjectId: "rovoConfluencePageMoveSpaceSelector"
                });
            }
        };
        $[38] = sendAnalyticsEvent;
        $[39] = t14;
    } else t14 = $[39];
    let t15;
    if ($[40] !== aaid || $[41] !== cloudId || $[42] !== isDisabled || $[43] !== selectedSpace || $[44] !== t13 || $[45] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuTaJ.ConfluenceSpaceSelector), {
            cloudId: cloudId,
            userId: aaid,
            testId: "confluence-page-move-space-selector",
            onMenuOpen: t13,
            isDisabled: isDisabled,
            isRequired: true,
            onChange: t14,
            fetchHomepage: true,
            value: selectedSpace
        });
        $[40] = aaid;
        $[41] = cloudId;
        $[42] = isDisabled;
        $[43] = selectedSpace;
        $[44] = t13;
        $[45] = t14;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== t12 || $[48] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t12, t15);
        $[47] = t12;
        $[48] = t15;
        $[49] = t16;
    } else t16 = $[49];
    let t17;
    if ($[50] !== formatMessage) {
        t17 = formatMessage((0, $gQM67.default).pageSelectorLabel);
        $[50] = formatMessage;
        $[51] = t17;
    } else t17 = $[51];
    let t18;
    if ($[52] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "confluence-page-move-page-selector"
        }, t17);
        $[52] = t17;
        $[53] = t18;
    } else t18 = $[53];
    let t19;
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = [
            "page",
            "blogPost"
        ];
        $[54] = t19;
    } else t19 = $[54];
    const t20 = isDisabled || !selectedSpace || !selectedPage;
    const t21 = `pageSelector-${selectedSpace?.value}`;
    const t22 = selectedSpace?.value;
    let t23;
    if ($[55] !== sendAnalyticsEvent) {
        t23 = ()=>{
            sendAnalyticsEvent({
                action: "opened",
                actionSubject: "dropdown",
                actionSubjectId: "rovoConfluencePageMovePageSelector"
            });
        };
        $[55] = sendAnalyticsEvent;
        $[56] = t23;
    } else t23 = $[56];
    let t24;
    if ($[57] !== sendAnalyticsEvent) {
        t24 = (option_0)=>{
            if (option_0) {
                setSelectedPage(option_0);
                sendAnalyticsEvent({
                    action: "selected",
                    actionSubject: "dropdown",
                    actionSubjectId: "rovoConfluencePageMovePageSelector"
                });
            }
        };
        $[57] = sendAnalyticsEvent;
        $[58] = t24;
    } else t24 = $[58];
    let t25;
    if ($[59] !== cloudId || $[60] !== selectedPage || $[61] !== t20 || $[62] !== t21 || $[63] !== t22 || $[64] !== t23 || $[65] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
            cloudId: cloudId,
            testId: "confluence-page-move-page-selector",
            contentTypes: t19,
            isDisabled: t20,
            key: t21,
            spaceId: t22,
            onMenuOpen: t23,
            isRequired: true,
            onChange: t24,
            value: selectedPage
        });
        $[59] = cloudId;
        $[60] = selectedPage;
        $[61] = t20;
        $[62] = t21;
        $[63] = t22;
        $[64] = t23;
        $[65] = t24;
        $[66] = t25;
    } else t25 = $[66];
    let t26;
    if ($[67] !== t18 || $[68] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t18, t25);
        $[67] = t18;
        $[68] = t25;
        $[69] = t26;
    } else t26 = $[69];
    let t27;
    if ($[70] !== t16 || $[71] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t16, t26);
        $[70] = t16;
        $[71] = t26;
        $[72] = t27;
    } else t27 = $[72];
    let t28;
    if ($[73] !== formatMessage) {
        t28 = formatMessage((0, $gQM67.default).movePageButton);
        $[73] = formatMessage;
        $[74] = t28;
    } else t28 = $[74];
    let t29;
    if ($[75] !== handleSubmit || $[76] !== isDisabled || $[77] !== isSubmitting || $[78] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: isDisabled,
            isLoading: isSubmitting,
            onClick: handleSubmit
        }, t28));
        $[75] = handleSubmit;
        $[76] = isDisabled;
        $[77] = isSubmitting;
        $[78] = t28;
        $[79] = t29;
    } else t29 = $[79];
    let t30;
    if ($[80] !== t10 || $[81] !== t27 || $[82] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: t10,
            product: "confluence"
        }, t27, t29);
        $[80] = t10;
        $[81] = t27;
        $[82] = t29;
        $[83] = t30;
    } else t30 = $[83];
    let t31;
    if ($[84] !== t30 || $[85] !== t9) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.250",
            testId: "confluence-page-add-label-action"
        }, t9, t30);
        $[84] = t30;
        $[85] = t9;
        $[86] = t31;
    } else t31 = $[86];
    return t31;
} : ({ onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, aaid: aaid, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId, {
        fetchHomepage: true
    });
    const [selectedPage, setSelectedPage] = (0, $cozmU.useState)(undefined);
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(undefined);
    const isDisabled = status !== 'idle' || readonly || !selectedPage;
    const isSubmitting = status === 'started';
    (0, $cozmU.useEffect)(()=>{
        const fetchPage = async ()=>{
            if (data.targetId) {
                const page = await getEntity(data.targetId, 'page');
                const space = await getEntity(data.targetId, 'space');
                // Currently, the BE only returns one ID and we don't know if it's a page or spaceId so we need to check both and handle each case.
                if (page) {
                    setSelectedPage({
                        label: page.name,
                        value: page.id,
                        type: 'page'
                    });
                    if (page.space?.id) {
                        const spaceId = (0, $5OelY.ConfluenceSpaceAri).parse(page.space.id).spaceId;
                        setSelectedSpace({
                            label: page.space.name ?? '',
                            value: spaceId,
                            key: page.space.key ?? '',
                            iconPath: page.space.icon?.path ?? ''
                        });
                    }
                } else if (space) {
                    setSelectedSpace({
                        label: space.name,
                        value: space.id,
                        key: space.key,
                        iconPath: space.icon?.path
                    });
                    setSelectedPage({
                        label: space.homepage?.name ?? '',
                        value: space.homepage?.id ?? '',
                        type: 'page'
                    });
                }
            }
        };
        fetchPage();
    }, [
        data,
        getEntity
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        const mergedData = {
            ...data,
            targetId: selectedPage?.value,
            contentType: selectedPage?.type ?? 'page'
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluencePageMoveRenderer'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onCustomDataConfirm(firstAction, mergedData);
    }, [
        onCustomDataConfirm,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        data,
        selectedPage,
        firstAction,
        actions,
        getStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.250",
        testId: "confluence-page-add-label-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $gQM67.default).actionMessage, {
        name: selectedPage?.label ?? '',
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $gQM67.default).confluencePageMoveActionCardTitle),
        product: "confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "confluence-page-move-space-selector"
    }, formatMessage((0, $gQM67.default).spaceSelectorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuTaJ.ConfluenceSpaceSelector), {
        cloudId: cloudId,
        userId: aaid,
        testId: "confluence-page-move-space-selector",
        // If the editor is disabled then the selector should be disabled rather than hidden.
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoConfluencePageMoveSpaceSelector'
            });
        },
        isDisabled: isDisabled,
        isRequired: true,
        onChange: (option)=>{
            if (option) {
                setSelectedSpace(option);
                setSelectedPage({
                    label: option.homepage?.label ?? '',
                    value: option.homepage?.value ?? '',
                    type: option.homepage?.type ?? 'page'
                });
                sendAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoConfluencePageMoveSpaceSelector'
                });
            }
        },
        fetchHomepage: true,
        value: selectedSpace
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "confluence-page-move-page-selector"
    }, formatMessage((0, $gQM67.default).pageSelectorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
        cloudId: cloudId,
        testId: "confluence-page-move-page-selector",
        contentTypes: [
            'page',
            'blogPost'
        ],
        isDisabled: isDisabled || !selectedSpace || !selectedPage,
        // Using selectedSpaceId in the key causes ConfluencePageSelector to remount whenever the space is changed.
        // This clears the cache of dropdown options and refetches defaultOptions for that space.
        key: `pageSelector-${selectedSpace?.value}`,
        spaceId: selectedSpace?.value,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoConfluencePageMovePageSelector'
            });
        },
        isRequired: true,
        onChange: (option_0)=>{
            if (option_0) {
                setSelectedPage(option_0);
                sendAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoConfluencePageMovePageSelector'
                });
            }
        },
        value: selectedPage
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: isDisabled,
        isLoading: isSubmitting,
        onClick: handleSubmit
    }, formatMessage((0, $gQM67.default).movePageButton)))));
};
function $f9d3aab52f60d89e$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks);
}
module.exports["ConfluencePageMoveAction"] = $f9d3aab52f60d89e$export$4d70762bf18a1585;

});

parcelRegister("a5Acp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $kB5K2 = parcelRequire("kB5K2");


var $I7hWB = parcelRequire("I7hWB");


var $c3tf0 = parcelRequire("c3tf0");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $1HjbK = parcelRequire("1HjbK");


var $g3R09 = parcelRequire("g3R09");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $gHpCf = parcelRequire("gHpCf");

const $602eee0afdea28a2$var$styles = {
    readOnlyTitle: "_4c065U1Y8M _2Y7lL4gVvo",
    readOnlyTitleWrapper: "_3138422ADO"
};
const $602eee0afdea28a2$export$3902d4e18794dca5 = (actions)=>{
    const filteredActions = actions.filter($602eee0afdea28a2$var$assertIsConfluencePageRenameAction);
    return filteredActions;
};
const $602eee0afdea28a2$var$assertIsConfluencePageRenameAction = (action)=>{
    if (action.key !== (0, $dw75i.CONFLUENCE_PAGE_RENAME_KEY)) throw new Error('Invalid action key for ConfluencePageRenameAction');
    return action;
};
const $602eee0afdea28a2$export$f5bca33334da2cf8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(64);
    const { onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const [title, setTitle] = (0, $cozmU.useState)(data.title);
    let t1;
    if ($[0] !== firstAction || $[1] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[0] = firstAction;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== getStatus) {
        t2 = getStatus(firstAction);
        $[3] = firstAction;
        $[4] = getStatus;
        $[5] = t2;
    } else t2 = $[5];
    const status = t2;
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const [selectedEntity, setSelectedEntity] = (0, $cozmU.useState)(undefined);
    const isDisabled = status !== "idle" || readonly || !selectedEntity || !title;
    const isSubmitting = status === "started";
    let t3;
    let t4;
    if ($[6] !== data.documentId || $[7] !== getEntity) {
        t3 = ()=>{
            const fetchPage = async ()=>{
                if (data.documentId) {
                    const entity = await getEntity(data.documentId, "page");
                    if (entity) setSelectedEntity({
                        label: entity.name,
                        value: entity.id,
                        type: "page"
                    });
                }
            };
            fetchPage();
        };
        t4 = [
            data.documentId,
            getEntity
        ];
        $[6] = data.documentId;
        $[7] = getEntity;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[10] !== actions || $[11] !== conversationId || $[12] !== data || $[13] !== firstAction || $[14] !== getStatus || $[15] !== messageId || $[16] !== onCustomDataConfirm || $[17] !== recipientAgentId || $[18] !== selectedEntity?.type || $[19] !== selectedEntity?.value || $[20] !== sendMessageConfirmedTools || $[21] !== title) {
        t5 = ()=>{
            const mergedData = {
                ...data,
                title: title,
                documentId: selectedEntity?.value,
                contentType: selectedEntity?.type ?? "page"
            };
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const plannedActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "confluencePageRenameRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onCustomDataConfirm(firstAction, mergedData);
        };
        $[10] = actions;
        $[11] = conversationId;
        $[12] = data;
        $[13] = firstAction;
        $[14] = getStatus;
        $[15] = messageId;
        $[16] = onCustomDataConfirm;
        $[17] = recipientAgentId;
        $[18] = selectedEntity?.type;
        $[19] = selectedEntity?.value;
        $[20] = sendMessageConfirmedTools;
        $[21] = title;
        $[22] = t5;
    } else t5 = $[22];
    selectedEntity?.value;
    selectedEntity?.type;
    const handleSubmit = t5;
    const t6 = selectedEntity?.label ?? "";
    let t7;
    if ($[23] !== formatMessage || $[24] !== t6) {
        t7 = formatMessage((0, $gHpCf.default).actionMessage, {
            name: t6,
            bold: $602eee0afdea28a2$var$_temp
        });
        $[23] = formatMessage;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t7);
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== formatMessage) {
        t9 = formatMessage((0, $gHpCf.default).confluencePageRenameActionCardTitle);
        $[28] = formatMessage;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== formatMessage) {
        t10 = formatMessage((0, $gHpCf.default).pageSelectorLabel);
        $[30] = formatMessage;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t10);
        $[32] = t10;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== cloudId || $[35] !== isDisabled || $[36] !== selectedEntity || $[37] !== sendAnalyticsEvent) {
        t12 = !selectedEntity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            height: 30,
            width: 200,
            borderRadius: "var(--ds-radius-large, 8px)",
            testId: "confluence-page-rename-page-selector-skeleton"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
            cloudId: cloudId,
            testId: "confluence-page-rename-page-selector",
            contentTypes: [
                "page",
                "blogPost"
            ],
            isDisabled: isDisabled,
            onMenuOpen: ()=>{
                sendAnalyticsEvent({
                    action: "opened",
                    actionSubject: "dropdown",
                    actionSubjectId: "rovoConfluenceRenamePageSelector"
                });
            },
            isRequired: true,
            onChange: (option)=>{
                if (option) {
                    setSelectedEntity(option);
                    sendAnalyticsEvent({
                        action: "selected",
                        actionSubject: "dropdown",
                        actionSubjectId: "rovoConfluenceRenamePageSelector"
                    });
                }
            },
            value: selectedEntity
        });
        $[34] = cloudId;
        $[35] = isDisabled;
        $[36] = selectedEntity;
        $[37] = sendAnalyticsEvent;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== t11 || $[40] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t11, t12);
        $[39] = t11;
        $[40] = t12;
        $[41] = t13;
    } else t13 = $[41];
    let t14;
    if ($[42] !== formatMessage || $[43] !== isDisabled || $[44] !== sendAnalyticsEvent || $[45] !== title) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $602eee0afdea28a2$var$styles.readOnlyTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: "confluence-page-rename-title-text"
        }, formatMessage((0, $gHpCf.default).titleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            id: "confluence-page-rename-title-text",
            xcss: $602eee0afdea28a2$var$styles.readOnlyTitle
        }, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3tf0.default), {
            testId: "confluence-page-rename-title-input-field",
            isRequired: true,
            isCompact: true,
            readViewFitContainerWidth: true,
            defaultValue: title,
            label: formatMessage((0, $gHpCf.default).titleLabel),
            onConfirm: (value)=>{
                setTitle(value);
                sendAnalyticsEvent({
                    action: "edited",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluenceRename"
                });
            },
            onCancel: ()=>{
                sendAnalyticsEvent({
                    action: "cancelled",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoConfluenceRename"
                });
            },
            placeholder: formatMessage((0, $gHpCf.default).titlePlaceholder)
        }));
        $[42] = formatMessage;
        $[43] = isDisabled;
        $[44] = sendAnalyticsEvent;
        $[45] = title;
        $[46] = t14;
    } else t14 = $[46];
    let t15;
    if ($[47] !== t13 || $[48] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t13, t14);
        $[47] = t13;
        $[48] = t14;
        $[49] = t15;
    } else t15 = $[49];
    let t16;
    if ($[50] !== formatMessage) {
        t16 = formatMessage((0, $gHpCf.default).addLabelButton);
        $[50] = formatMessage;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== handleSubmit || $[53] !== isDisabled || $[54] !== isSubmitting || $[55] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: isDisabled,
            isLoading: isSubmitting,
            onClick: handleSubmit
        }, t16));
        $[52] = handleSubmit;
        $[53] = isDisabled;
        $[54] = isSubmitting;
        $[55] = t16;
        $[56] = t17;
    } else t17 = $[56];
    let t18;
    if ($[57] !== t15 || $[58] !== t17 || $[59] !== t9) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: t9,
            product: "confluence"
        }, t15, t17);
        $[57] = t15;
        $[58] = t17;
        $[59] = t9;
        $[60] = t18;
    } else t18 = $[60];
    let t19;
    if ($[61] !== t18 || $[62] !== t8) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.250",
            testId: "confluence-page-rename-action"
        }, t8, t18);
        $[61] = t18;
        $[62] = t8;
        $[63] = t19;
    } else t19 = $[63];
    return t19;
} : ({ onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const [title, setTitle] = (0, $cozmU.useState)(data.title);
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const [selectedEntity, setSelectedEntity] = (0, $cozmU.useState)(undefined);
    const isDisabled = status !== 'idle' || readonly || !selectedEntity || !title;
    const isSubmitting = status === 'started';
    (0, $cozmU.useEffect)(()=>{
        const fetchPage = async ()=>{
            if (data.documentId) {
                const entity = await getEntity(data.documentId, 'page');
                if (entity) setSelectedEntity({
                    label: entity.name,
                    value: entity.id,
                    type: 'page'
                });
            }
        };
        fetchPage();
    }, [
        data.documentId,
        getEntity
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        const mergedData = {
            ...data,
            title: title,
            documentId: selectedEntity?.value,
            contentType: selectedEntity?.type ?? 'page'
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'confluencePageRenameRenderer'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onCustomDataConfirm(firstAction, mergedData);
    }, [
        onCustomDataConfirm,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        data,
        title,
        selectedEntity?.value,
        selectedEntity?.type,
        firstAction,
        actions,
        getStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.250",
        testId: "confluence-page-rename-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $gHpCf.default).actionMessage, {
        name: selectedEntity?.label ?? '',
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $gHpCf.default).confluencePageRenameActionCardTitle),
        product: "confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $gHpCf.default).pageSelectorLabel)), !selectedEntity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 30,
        width: 200,
        borderRadius: "var(--ds-radius-large, 8px)",
        testId: "confluence-page-rename-page-selector-skeleton"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g3R09.ConfluencePageSelector), {
        cloudId: cloudId,
        testId: "confluence-page-rename-page-selector",
        contentTypes: [
            'page',
            'blogPost'
        ],
        isDisabled: isDisabled,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoConfluenceRenamePageSelector'
            });
        },
        isRequired: true,
        onChange: (option)=>{
            if (option) {
                setSelectedEntity(option);
                sendAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoConfluenceRenamePageSelector'
                });
            }
        },
        value: selectedEntity
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $602eee0afdea28a2$var$styles.readOnlyTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "confluence-page-rename-title-text"
    }, formatMessage((0, $gHpCf.default).titleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: "confluence-page-rename-title-text",
        xcss: $602eee0afdea28a2$var$styles.readOnlyTitle
    }, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3tf0.default), {
        testId: "confluence-page-rename-title-input-field",
        isRequired: true,
        isCompact: true,
        readViewFitContainerWidth: true,
        defaultValue: title,
        label: formatMessage((0, $gHpCf.default).titleLabel),
        onConfirm: (value)=>{
            setTitle(value);
            sendAnalyticsEvent({
                action: 'edited',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceRename'
            });
        },
        onCancel: ()=>{
            sendAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoConfluenceRename'
            });
        },
        placeholder: formatMessage((0, $gHpCf.default).titlePlaceholder)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: isDisabled,
        isLoading: isSubmitting,
        onClick: handleSubmit
    }, formatMessage((0, $gHpCf.default).addLabelButton)))));
};
function $602eee0afdea28a2$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, chunks);
}
module.exports["ConfluencePageRenameAction"] = $602eee0afdea28a2$export$f5bca33334da2cf8;

});

parcelRegister("7rNAq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $hMaHH = parcelRequire("hMaHH");


var $c3tf0 = parcelRequire("c3tf0");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1HjbK = parcelRequire("1HjbK");


var $fuTaJ = parcelRequire("fuTaJ");


var $7puYn = parcelRequire("7puYn");


var $7eUSO = parcelRequire("7eUSO");


var $Vkwix = parcelRequire("Vkwix");

const $d9e5ab3e36456c99$var$styles = {
    pageIcon: "_0Of8r2FQfX",
    pageTitleWrapper: "_2O5Vij7dHp _3138424F84",
    pageTitleReadView: "_2sNsIgmnOE _4c065U1Y8M _2Y7lL4gVvo _3iDTPbQ4SZ _1EqgXlN91d _3W2Oc8wPeg",
    spaceSelector: "_39xV02gZxp"
};
const $d9e5ab3e36456c99$export$ae38925e7cadad29 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { onCustomDataConfirm: onCustomDataConfirm, getReadonly: getReadonly, getStatus: getStatus, cloudId: cloudId, aaid: aaid, actions: actions, interactionModeExecuted: interactionModeExecuted, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showPublishUI, setShowPublishUI] = (0, $cozmU.useState)(false);
    const firstAction = actions[0];
    let t1;
    if ($[0] !== firstAction || $[1] !== getStatus) {
        t1 = getStatus(firstAction);
        $[0] = firstAction;
        $[1] = getStatus;
        $[2] = t1;
    } else t1 = $[2];
    const status = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t2 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t2;
    } else t2 = $[5];
    const readonly = t2;
    const isDisabled = status === "started" || readonly;
    let t3;
    if ($[6] !== interactionModeExecuted || $[7] !== sendAnalyticsEvent || $[8] !== trackAIMAUEvent) {
        t3 = (_, e)=>{
            setShowPublishUI(true);
            sendAnalyticsEvent(e.update({
                actionSubjectId: "rovoDRConfluencePageExportToPageButton"
            }));
            trackAIMAUEvent({
                type: "actioned",
                actionResult: "exportToPageButtonClicked",
                proactive: false,
                subjectId: "rovoDRConfluencePageExportToPageButton",
                attributes: {
                    ...interactionModeExecuted ? {
                        interactionModeExecuted: interactionModeExecuted
                    } : {}
                }
            });
        };
        $[6] = interactionModeExecuted;
        $[7] = sendAnalyticsEvent;
        $[8] = trackAIMAUEvent;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== formatMessage) {
        t4 = formatMessage((0, $Vkwix.default).exportToPageButton);
        $[10] = formatMessage;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isDisabled || $[13] !== showPublishUI || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "dr-confluence-page-create-export-to-page-button",
            appearance: "primary",
            isDisabled: isDisabled,
            "aria-expanded": showPublishUI,
            onClick: t3
        }, t4));
        $[12] = isDisabled;
        $[13] = showPublishUI;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== aaid || $[18] !== actions || $[19] !== cloudId || $[20] !== conversationId || $[21] !== getStatus || $[22] !== messageId || $[23] !== onCustomDataConfirm || $[24] !== readonly || $[25] !== recipientAgentId || $[26] !== sendMessageConfirmedTools || $[27] !== showPublishUI) {
        t6 = showPublishUI && !readonly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9e5ab3e36456c99$var$DeepResearchPublishUI, {
            onCustomDataConfirm: onCustomDataConfirm,
            getStatus: getStatus,
            cloudId: cloudId,
            aaid: aaid,
            actions: actions,
            sendMessageConfirmedTools: sendMessageConfirmedTools,
            recipientAgentId: recipientAgentId,
            conversationId: conversationId,
            messageId: messageId
        });
        $[17] = aaid;
        $[18] = actions;
        $[19] = cloudId;
        $[20] = conversationId;
        $[21] = getStatus;
        $[22] = messageId;
        $[23] = onCustomDataConfirm;
        $[24] = readonly;
        $[25] = recipientAgentId;
        $[26] = sendMessageConfirmedTools;
        $[27] = showPublishUI;
        $[28] = t6;
    } else t6 = $[28];
    let t7;
    if ($[29] !== t5 || $[30] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t5, t6);
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
    } else t7 = $[31];
    return t7;
} : ({ onCustomDataConfirm: onCustomDataConfirm, getReadonly: getReadonly, getStatus: getStatus, cloudId: cloudId, aaid: aaid, actions: actions, interactionModeExecuted: interactionModeExecuted, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showPublishUI, setShowPublishUI] = (0, $cozmU.useState)(false);
    const firstAction = actions[0];
    const status = getStatus(firstAction);
    const readonly = getReadonly(firstAction); // Used to disable export to page button if message action is readonly OR if message action is currently being submitted
    const isDisabled = status === 'started' || readonly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "dr-confluence-page-create-export-to-page-button",
        appearance: "primary",
        isDisabled: isDisabled,
        "aria-expanded": showPublishUI,
        onClick: (_, e)=>{
            setShowPublishUI(true);
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'rovoDRConfluencePageExportToPageButton'
            }));
            trackAIMAUEvent({
                type: 'actioned',
                actionResult: 'exportToPageButtonClicked',
                proactive: false,
                subjectId: 'rovoDRConfluencePageExportToPageButton',
                attributes: {
                    ...interactionModeExecuted ? {
                        interactionModeExecuted: interactionModeExecuted
                    } : {}
                }
            });
        }
    }, formatMessage((0, $Vkwix.default).exportToPageButton))), showPublishUI && !readonly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9e5ab3e36456c99$var$DeepResearchPublishUI, {
        onCustomDataConfirm: onCustomDataConfirm,
        getStatus: getStatus,
        cloudId: cloudId,
        aaid: aaid,
        actions: actions,
        sendMessageConfirmedTools: sendMessageConfirmedTools,
        recipientAgentId: recipientAgentId,
        conversationId: conversationId,
        messageId: messageId
    }));
};
const $d9e5ab3e36456c99$var$DeepResearchPublishUI = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { onCustomDataConfirm: onCustomDataConfirm, getStatus: getStatus, cloudId: cloudId, aaid: aaid, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    let t1;
    if ($[0] !== firstAction || $[1] !== getStatus) {
        t1 = getStatus(firstAction);
        $[0] = firstAction;
        $[1] = getStatus;
        $[2] = t1;
    } else t1 = $[2];
    const status = t1;
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(undefined);
    const { data: data } = firstAction;
    const [name, setName] = (0, $cozmU.useState)(data.name);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isDisabled = status !== "idle" || !name || !selectedSpace;
    const isSubmitting = status === "started";
    let t2;
    let t3;
    if ($[3] !== data.folder || $[4] !== getEntity) {
        t2 = ()=>{
            const fetchSpace = async ()=>{
                if (data.folder) {
                    const space = await getEntity(data.folder, "space");
                    if (space) setSelectedSpace({
                        label: space.name,
                        value: space.id,
                        key: space.key
                    });
                }
            };
            fetchSpace();
        };
        t3 = [
            data.folder,
            getEntity
        ];
        $[3] = data.folder;
        $[4] = getEntity;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== actions || $[8] !== conversationId || $[9] !== data || $[10] !== firstAction || $[11] !== getStatus || $[12] !== messageId || $[13] !== name || $[14] !== onCustomDataConfirm || $[15] !== recipientAgentId || $[16] !== selectedSpace?.value || $[17] !== sendMessageConfirmedTools) {
        t4 = ()=>{
            const mergedData = {
                ...data,
                name: name,
                folder: selectedSpace?.value
            };
            if ((0, $iDrrr.fg)("rovo_tools_resumption_migration_phase2")) {
                const actionableActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "deepResearchConfluencePageCreateRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: actionableActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onCustomDataConfirm(firstAction, mergedData);
        };
        $[7] = actions;
        $[8] = conversationId;
        $[9] = data;
        $[10] = firstAction;
        $[11] = getStatus;
        $[12] = messageId;
        $[13] = name;
        $[14] = onCustomDataConfirm;
        $[15] = recipientAgentId;
        $[16] = selectedSpace?.value;
        $[17] = sendMessageConfirmedTools;
        $[18] = t4;
    } else t4 = $[18];
    selectedSpace?.value;
    const handleSubmit = t4;
    let t5;
    if ($[19] !== formatMessage) {
        t5 = formatMessage((0, $Vkwix.default).spaceSelectorLabel);
        $[19] = formatMessage;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h4"
        }, t5);
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== aaid || $[24] !== cloudId || $[25] !== isDisabled || $[26] !== selectedSpace || $[27] !== sendAnalyticsEvent) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d9e5ab3e36456c99$var$styles.spaceSelector
        }, !selectedSpace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            height: 30,
            width: 200,
            borderRadius: "var(--ds-radius-large, 8px)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuTaJ.ConfluenceSpaceSelector), {
            cloudId: cloudId,
            userId: aaid,
            testId: "dr-confluence-page-create-space-selector",
            isDisabled: isDisabled,
            spacing: "compact",
            onMenuOpen: ()=>{
                sendAnalyticsEvent({
                    action: "opened",
                    actionSubject: "dropdown",
                    actionSubjectId: "rovoDRConfluencePageCreateSpaceSelector"
                });
            },
            isRequired: true,
            onChange: (option)=>{
                if (option) {
                    setSelectedSpace(option);
                    sendAnalyticsEvent({
                        action: "opened",
                        actionSubject: "dropdown",
                        actionSubjectId: "rovoDRConfluencePageCreateSpaceSelector"
                    });
                }
            },
            value: selectedSpace
        }));
        $[23] = aaid;
        $[24] = cloudId;
        $[25] = isDisabled;
        $[26] = selectedSpace;
        $[27] = sendAnalyticsEvent;
        $[28] = t7;
    } else t7 = $[28];
    let t8;
    if ($[29] !== t6 || $[30] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t6, t7);
        $[29] = t6;
        $[30] = t7;
        $[31] = t8;
    } else t8 = $[31];
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d9e5ab3e36456c99$var$styles.pageIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon-brand)"
        }));
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== formatMessage || $[34] !== isDisabled || $[35] !== name || $[36] !== sendAnalyticsEvent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.025",
            alignBlock: "center",
            xcss: $d9e5ab3e36456c99$var$styles.pageTitleWrapper
        }, t9, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d9e5ab3e36456c99$var$styles.pageTitleReadView
        }, name || formatMessage((0, $Vkwix.default).pageTitlePlaceholder)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d9e5ab3e36456c99$var$styles.pageTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3tf0.default), {
            testId: "dr-page-name-input-field",
            isRequired: true,
            isCompact: true,
            readViewFitContainerWidth: true,
            defaultValue: name,
            label: formatMessage((0, $Vkwix.default).pageTitleLabel),
            editButtonLabel: formatMessage((0, $Vkwix.default).editPageNameButtonLabel),
            onConfirm: (value)=>{
                setName(value);
                sendAnalyticsEvent({
                    action: "edited",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoDRConfluencePageCreateTitle"
                });
            },
            onCancel: ()=>{
                sendAnalyticsEvent({
                    action: "cancelled",
                    actionSubject: "inlineEdit",
                    actionSubjectId: "rovoDRConfluencePageCreateTitle"
                });
            },
            placeholder: formatMessage((0, $Vkwix.default).pageTitlePlaceholder)
        })));
        $[33] = formatMessage;
        $[34] = isDisabled;
        $[35] = name;
        $[36] = sendAnalyticsEvent;
        $[37] = t10;
    } else t10 = $[37];
    let t11;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7puYn.Divider), null);
        $[38] = t11;
    } else t11 = $[38];
    let t12;
    if ($[39] !== handleSubmit || $[40] !== sendAnalyticsEvent) {
        t12 = (_, e)=>{
            handleSubmit();
            sendAnalyticsEvent(e.update({
                actionSubjectId: "rovoDRConfluencePageCreateSubmit"
            }));
        };
        $[39] = handleSubmit;
        $[40] = sendAnalyticsEvent;
        $[41] = t12;
    } else t12 = $[41];
    let t13;
    if ($[42] !== formatMessage) {
        t13 = formatMessage((0, $Vkwix.default).publishPageButton);
        $[42] = formatMessage;
        $[43] = t13;
    } else t13 = $[43];
    let t14;
    if ($[44] !== isDisabled || $[45] !== isSubmitting || $[46] !== t12 || $[47] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isLoading: isSubmitting,
            isDisabled: isDisabled,
            onClick: t12
        }, t13));
        $[44] = isDisabled;
        $[45] = isSubmitting;
        $[46] = t12;
        $[47] = t13;
        $[48] = t14;
    } else t14 = $[48];
    let t15;
    if ($[49] !== t10 || $[50] !== t14 || $[51] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t8, t10, t11, t14);
        $[49] = t10;
        $[50] = t14;
        $[51] = t8;
        $[52] = t15;
    } else t15 = $[52];
    return t15;
} : ({ onCustomDataConfirm: onCustomDataConfirm, getStatus: getStatus, cloudId: cloudId, aaid: aaid, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const status = getStatus(firstAction);
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(undefined);
    const { data: data } = firstAction;
    const [name, setName] = (0, $cozmU.useState)(data.name);
    const { getEntity: getEntity } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const isDisabled = status !== 'idle' || !name || !selectedSpace;
    const isSubmitting = status === 'started';
    (0, $cozmU.useEffect)(()=>{
        const fetchSpace = async ()=>{
            if (data.folder) {
                const space = await getEntity(data.folder, 'space');
                if (space) setSelectedSpace({
                    label: space.name,
                    value: space.id,
                    key: space.key
                });
            }
        };
        fetchSpace();
    }, [
        data.folder,
        getEntity
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        const mergedData = {
            ...data,
            name: name,
            folder: selectedSpace?.value
        };
        if ((0, $iDrrr.fg)('rovo_tools_resumption_migration_phase2')) {
            const actionableActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'deepResearchConfluencePageCreateRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    // Confirm the submitted action; cancel every other queued action.
                    tools: actionableActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', mergedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onCustomDataConfirm(firstAction, mergedData);
    }, [
        onCustomDataConfirm,
        data,
        name,
        selectedSpace?.value,
        firstAction,
        actions,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        getStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h4"
    }, formatMessage((0, $Vkwix.default).spaceSelectorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d9e5ab3e36456c99$var$styles.spaceSelector
    }, !selectedSpace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 30,
        width: 200,
        borderRadius: "var(--ds-radius-large, 8px)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuTaJ.ConfluenceSpaceSelector), {
        cloudId: cloudId,
        userId: aaid,
        testId: "dr-confluence-page-create-space-selector",
        isDisabled: isDisabled,
        spacing: "compact",
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoDRConfluencePageCreateSpaceSelector'
            });
        },
        isRequired: true,
        onChange: (option)=>{
            if (option) {
                setSelectedSpace(option);
                sendAnalyticsEvent({
                    action: 'opened',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'rovoDRConfluencePageCreateSpaceSelector'
                });
            }
        },
        value: selectedSpace
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.025",
        alignBlock: "center",
        xcss: $d9e5ab3e36456c99$var$styles.pageTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d9e5ab3e36456c99$var$styles.pageIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon-brand)"
    })), isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d9e5ab3e36456c99$var$styles.pageTitleReadView
    }, name || formatMessage((0, $Vkwix.default).pageTitlePlaceholder)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d9e5ab3e36456c99$var$styles.pageTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3tf0.default), {
        testId: "dr-page-name-input-field",
        isRequired: true,
        isCompact: true,
        readViewFitContainerWidth: true,
        defaultValue: name,
        label: formatMessage((0, $Vkwix.default).pageTitleLabel),
        editButtonLabel: formatMessage((0, $Vkwix.default).editPageNameButtonLabel),
        onConfirm: (value)=>{
            setName(value);
            sendAnalyticsEvent({
                action: 'edited',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoDRConfluencePageCreateTitle'
            });
        },
        onCancel: ()=>{
            sendAnalyticsEvent({
                action: 'cancelled',
                actionSubject: 'inlineEdit',
                actionSubjectId: 'rovoDRConfluencePageCreateTitle'
            });
        },
        placeholder: formatMessage((0, $Vkwix.default).pageTitlePlaceholder)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7puYn.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: isDisabled,
        onClick: (_, e)=>{
            handleSubmit();
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'rovoDRConfluencePageCreateSubmit'
            }));
        }
    }, formatMessage((0, $Vkwix.default).publishPageButton))));
};
module.exports["DeepResearchActions"] = $d9e5ab3e36456c99$export$ae38925e7cadad29;

});

parcelRegister("8sOc2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $77bfd81f603a2f0f$export$af6f4afcabc5503a = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6STLT")).then((m)=>({
            default: m.ExecutePythonRenderer
        })));
module.exports["ExecutePythonRendererAsync"] = $77bfd81f603a2f0f$export$af6f4afcabc5503a;

});

parcelRegister("3kRwn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $7eUSO = parcelRequire("7eUSO");


var $aM39D = parcelRequire("aM39D");


var $1WLQN = parcelRequire("1WLQN");


var $lCyXM = parcelRequire("lCyXM");


var $lp8ZK = parcelRequire("lp8ZK");


var $iATgb = parcelRequire("iATgb");

const $d80e26b0c675051e$var$SingleFocusAskCreateAction = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(31);
    const { actions: actions, cloudId: cloudId, orgId: orgId, getReadonly: getReadonly, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = props;
    const action = actions[0];
    const t0 = action?.data;
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $lCyXM.extractAsks)(t0);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const asks = t1;
    const singleAsk = asks[0];
    let t2;
    if ($[2] !== singleAsk) {
        t2 = (0, $iATgb.normalizeFocusAskPayload)(singleAsk);
        $[2] = singleAsk;
        $[3] = t2;
    } else t2 = $[3];
    const normalized = t2;
    let t3;
    if ($[4] !== action || $[5] !== normalized) {
        t3 = action ? {
            invocationId: action.invocationId,
            status: action.status,
            data: normalized
        } : {
            invocationId: "",
            data: normalized
        };
        $[4] = action;
        $[5] = normalized;
        $[6] = t3;
    } else t3 = $[6];
    const actionForRenderer = t3;
    let t4;
    if ($[7] !== action || $[8] !== actions || $[9] !== conversationId || $[10] !== getStatus || $[11] !== messageId || $[12] !== onCustomDataConfirm || $[13] !== recipientAgentId || $[14] !== sendMessageConfirmedTools || $[15] !== singleAsk) {
        t4 = async (_action, formData)=>{
            if (!action) return;
            const data = {
                asks: [
                    (0, $lp8ZK.mergeFocusAskFormIntoPayload)(singleAsk, formData)
                ]
            };
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const idleActions = actions.filter((action_0)=>getStatus(action_0) === "idle");
                await sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "focusAskCreateAction"
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: idleActions.map((idleAction)=>idleAction.invocationId === action.invocationId ? (0, $7eUSO.buildToolFromAction)(idleAction, "confirmed", data) : (0, $7eUSO.buildToolFromAction)(idleAction, "cancelled"))
                    }
                });
                return;
            }
            await onCustomDataConfirm(action, data);
        };
        $[7] = action;
        $[8] = actions;
        $[9] = conversationId;
        $[10] = getStatus;
        $[11] = messageId;
        $[12] = onCustomDataConfirm;
        $[13] = recipientAgentId;
        $[14] = sendMessageConfirmedTools;
        $[15] = singleAsk;
        $[16] = t4;
    } else t4 = $[16];
    const handleConfirm = t4;
    if (!action) return null;
    let t5;
    if ($[17] !== action || $[18] !== getReadonly) {
        t5 = getReadonly(action);
        $[17] = action;
        $[18] = getReadonly;
        $[19] = t5;
    } else t5 = $[19];
    const readonly = t5;
    let t6;
    if ($[20] !== action || $[21] !== getStatus) {
        t6 = getStatus(action);
        $[20] = action;
        $[21] = getStatus;
        $[22] = t6;
    } else t6 = $[22];
    const status = t6;
    const isSubmitting = status === "started";
    const isFinished = status === "finished" || action.status === "finished";
    let t7;
    if ($[23] !== actionForRenderer || $[24] !== cloudId || $[25] !== handleConfirm || $[26] !== isFinished || $[27] !== isSubmitting || $[28] !== orgId || $[29] !== readonly) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aM39D.FocusAskCreateRenderer), {
            action: actionForRenderer,
            cloudId: cloudId,
            orgId: orgId,
            readonly: readonly,
            isActionFinished: isFinished,
            isSubmitting: isSubmitting,
            onConfirm: handleConfirm
        });
        $[23] = actionForRenderer;
        $[24] = cloudId;
        $[25] = handleConfirm;
        $[26] = isFinished;
        $[27] = isSubmitting;
        $[28] = orgId;
        $[29] = readonly;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : (props)=>{
    const { actions: actions, cloudId: cloudId, orgId: orgId, getReadonly: getReadonly, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = props;
    const action = actions[0];
    const asks = (0, $cozmU.useMemo)(()=>(0, $lCyXM.extractAsks)(action?.data), [
        action
    ]);
    const singleAsk = asks[0];
    const normalized = (0, $cozmU.useMemo)(()=>(0, $iATgb.normalizeFocusAskPayload)(singleAsk), [
        singleAsk
    ]);
    const actionForRenderer = (0, $cozmU.useMemo)(()=>action ? {
            invocationId: action.invocationId,
            status: action.status,
            data: normalized
        } : {
            invocationId: '',
            data: normalized
        }, [
        action,
        normalized
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(async (_action, formData)=>{
        if (!action) return;
        const data = {
            asks: [
                (0, $lp8ZK.mergeFocusAskFormIntoPayload)(singleAsk, formData)
            ]
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action_0)=>getStatus(action_0) === 'idle');
            await sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'focusAskCreateAction'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: idleActions.map((idleAction)=>idleAction.invocationId === action.invocationId ? (0, $7eUSO.buildToolFromAction)(idleAction, 'confirmed', data) : (0, $7eUSO.buildToolFromAction)(idleAction, 'cancelled'))
                }
            });
            return;
        }
        await onCustomDataConfirm(action, data);
    }, [
        action,
        singleAsk,
        onCustomDataConfirm,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        actions,
        getStatus
    ]);
    if (!action) return null;
    const readonly = getReadonly(action);
    const status = getStatus(action);
    const isSubmitting = status === 'started';
    const isFinished = status === 'finished' || action.status === 'finished';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aM39D.FocusAskCreateRenderer), {
        action: actionForRenderer,
        cloudId: cloudId,
        orgId: orgId,
        readonly: readonly,
        isActionFinished: isFinished,
        isSubmitting: isSubmitting,
        onConfirm: handleConfirm
    });
};
const $d80e26b0c675051e$export$5caf0268e9087f8b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { actions: actions } = props;
    const action = actions[0];
    const asks = (0, $lCyXM.extractAsks)(action?.data);
    if (!action || asks.length === 0) return null;
    if (asks.length === 1) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d80e26b0c675051e$var$SingleFocusAskCreateAction, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1WLQN.BulkFocusAskCreateAction), props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { actions: actions } = props;
    const action = actions[0];
    const asks = (0, $cozmU.useMemo)(()=>(0, $lCyXM.extractAsks)(action?.data), [
        action
    ]);
    if (!action || asks.length === 0) return null;
    if (asks.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d80e26b0c675051e$var$SingleFocusAskCreateAction, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1WLQN.BulkFocusAskCreateAction), props);
};
module.exports["FocusAskCreateAction"] = $d80e26b0c675051e$export$5caf0268e9087f8b;

});

parcelRegister("l4RVM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $197d0be9eeb3febb$export$52723173283120fe = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("haZfQ")).then((m)=>({
            default: m.GoogleCalendarEventCreateAction
        })));
module.exports["GoogleCalendarEventCreateRendererAsync"] = $197d0be9eeb3febb$export$52723173283120fe;

});

parcelRegister("kkxnf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $71946d98d7c9765a$export$f054c2851379a107 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cX2Om")).then((m)=>({
            default: m.GoogleDocCreateAction
        })));
module.exports["GoogleDocCreateRendererAsync"] = $71946d98d7c9765a$export$f054c2851379a107;

});

parcelRegister("kO9z8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");

parcelRequire("g23UR");
var $kkLpw = parcelRequire("kkLpw");


var $i1t43 = parcelRequire("i1t43");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $8eTnP = parcelRequire("8eTnP");


var $9zEp7 = parcelRequire("9zEp7");

const $654452e98196a0f5$var$isOnHardwareRoute = ()=>typeof window !== 'undefined' && window.location.pathname.endsWith((0, $8eTnP.HARDWARE_ROUTE_PATH));
const $654452e98196a0f5$export$4afa11016b69fff6 = ({ actions: actions, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $kSwu1.useIntl), (0, $kkLpw.useRouterActions), (0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $kkLpw.useRouterActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const hasTrackedViewedRef = (0, $cozmU.useRef)(false);
    const isRendered = actions.length > 0;
    (0, $cozmU.useEffect)(()=>{
        if (!isRendered || hasTrackedViewedRef.current) return;
        hasTrackedViewedRef.current = true;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'hamOnboardingHardwareLink',
            actionSubjectId: 'hamEnabled',
            attributes: {
                conversationId: conversationId ?? '',
                messageId: messageId ?? ''
            }
        });
    }, [
        conversationId,
        isRendered,
        messageId,
        sendAnalyticsEvent
    ]);
    if (!isRendered) return null;
    // On the hardware route the link re-enters the current route so the Jira/JSM SPA
    // refetches its data without a full browser reload; elsewhere it navigates to hardware.
    const handleClick = (event, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'hardwareLink',
            attributes: {
                ...analyticsEvent.payload?.attributes,
                conversationId: conversationId ?? '',
                messageId: messageId ?? ''
            }
        }));
        if ($654452e98196a0f5$var$isOnHardwareRoute()) {
            event.preventDefault();
            push(`${window.location.pathname}${window.location.search}`);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $9zEp7.messages).leadInText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: (0, $8eTnP.HARDWARE_ROUTE_PATH),
        onClick: handleClick,
        testId: "ham-onboarding-hardware-link.link"
    }, formatMessage((0, $9zEp7.messages).hardwareLinkLabel)));
};
module.exports["HamOnboardingHardwareLink"] = $654452e98196a0f5$export$4afa11016b69fff6;

});

parcelRegister("lbVAr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $1l0kj = parcelRequire("1l0kj");


var $hdBxM = parcelRequire("hdBxM");

// Primary button keys that should appear as blue (primary) buttons
const $ae1444f67c850e8b$var$PRIMARY_BUTTON_KEYS = [
    'confirm',
    'yes',
    'approve'
];
const $ae1444f67c850e8b$var$renderButtons = (choices, onButtonClick, isDisabled, isLoading, invocationId)=>{
    return choices.map((choice)=>{
        const isPrimary = $ae1444f67c850e8b$var$PRIMARY_BUTTON_KEYS.includes(choice.key.toLowerCase());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: `${invocationId}-${choice.key}`,
            appearance: isPrimary ? 'primary' : 'default',
            onClick: ()=>onButtonClick(choice),
            isDisabled: isDisabled,
            isLoading: isLoading
        }, choice.title);
    });
};
const $ae1444f67c850e8b$export$1b0c9083ee8c7d4d = ({ actions: actions, getStatus: getStatus })=>{
    (0, $6cFsl.di)((0, $hdBxM.usePublish));
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const firstAction = actions[0];
    const status = getStatus(firstAction);
    const isDisabled = status !== 'idle';
    const isLoading = status === 'started';
    const invocationId = firstAction.invocationId ?? firstAction.actionId ?? 'hiring-manager-tool';
    const handleButtonClick = (0, $cozmU.useCallback)((choice)=>{
        // Use 'insert-prompt' to ensure agentId is included for tool calls
        publish({
            type: 'insert-prompt',
            source: 'ai-mate',
            data: {
                prompt: choice.title
            }
        });
    }, [
        publish
    ]);
    const choices = firstAction.data?.choices ?? [];
    if (choices.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, $ae1444f67c850e8b$var$renderButtons(choices, handleButtonClick, isDisabled, isLoading, invocationId));
};
module.exports["HiringManagerToolUIAction"] = $ae1444f67c850e8b$export$1b0c9083ee8c7d4d;

});

parcelRegister("8qYrI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $17e4711f7dd8a1a9$export$ed27ab5b1ba9a421 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eLaen")).then((m)=>({
            default: m.ImageSearchAction
        })));
module.exports["ImageSearchActionAsync"] = $17e4711f7dd8a1a9$export$ed27ab5b1ba9a421;

});

parcelRegister("8wx27", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $jerDQ = parcelRequire("jerDQ");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $5wTq5 = parcelRequire("5wTq5");


var $c8XPX = parcelRequire("c8XPX");


var $UlvU3 = parcelRequire("UlvU3");

const $f2815b0272ba43c9$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $f2815b0272ba43c9$var$sprintIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jerDQ))),
    label: "",
    appearance: "gray",
    size: "small"
});
const $f2815b0272ba43c9$export$a67cdfe68631d1bb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { actions: actions, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const action = actions[0];
    const { data: data } = action;
    let t1;
    if ($[0] !== action || $[1] !== getReadonly) {
        t1 = getReadonly(action);
        $[0] = action;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    const [isActioned, setIsActioned] = (0, $cozmU.useState)(false);
    const buttonsDisabled = isActioned || readonly;
    let t2;
    if ($[3] !== action.actionId || $[4] !== action.data || $[5] !== action.humanMessageId || $[6] !== action.invocationId || $[7] !== action.key || $[8] !== action.toolSource || $[9] !== conversationId || $[10] !== messageId || $[11] !== recipientAgentId || $[12] !== sendAnalyticsEvent || $[13] !== sendMessageConfirmedTools) {
        t2 = (resolutionType)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: resolutionType === "confirmed" ? "confirmCreateSprintButton" : "cancelCreateSprintButton"
            });
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: "jiraCreateSprintAction"
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        {
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            resolution: {
                                type: resolutionType
                            },
                            data: {
                                human_message_id: action.humanMessageId ?? "",
                                arguments: action.data
                            }
                        }
                    ]
                },
                resolutionType: resolutionType
            });
            setIsActioned(true);
        };
        $[3] = action.actionId;
        $[4] = action.data;
        $[5] = action.humanMessageId;
        $[6] = action.invocationId;
        $[7] = action.key;
        $[8] = action.toolSource;
        $[9] = conversationId;
        $[10] = messageId;
        $[11] = recipientAgentId;
        $[12] = sendAnalyticsEvent;
        $[13] = sendMessageConfirmedTools;
        $[14] = t2;
    } else t2 = $[14];
    const handleAction = t2;
    let t3;
    if ($[15] !== handleAction) {
        t3 = ()=>handleAction("confirmed");
        $[15] = handleAction;
        $[16] = t3;
    } else t3 = $[16];
    const handleConfirm = t3;
    let t4;
    if ($[17] !== handleAction) {
        t4 = ()=>handleAction("cancelled");
        $[17] = handleAction;
        $[18] = t4;
    } else t4 = $[18];
    const handleCancel = t4;
    let t5;
    if ($[19] !== formatMessage) {
        t5 = formatMessage((0, $UlvU3.messages).title);
        $[19] = formatMessage;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== formatMessage) {
        t6 = formatMessage((0, $UlvU3.messages).nameLabel);
        $[21] = formatMessage;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== data.name || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: t6,
            value: data.name
        });
        $[23] = data.name;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== data.goal || $[27] !== formatMessage) {
        t8 = data.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: formatMessage((0, $UlvU3.messages).goalLabel),
            value: data.goal
        });
        $[26] = data.goal;
        $[27] = formatMessage;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== data.startDate || $[30] !== formatMessage) {
        t9 = data.startDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: formatMessage((0, $UlvU3.messages).startDateLabel),
            value: (0, $c8XPX.formatDate)(data.startDate)
        });
        $[29] = data.startDate;
        $[30] = formatMessage;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== data.endDate || $[33] !== formatMessage) {
        t10 = data.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: formatMessage((0, $UlvU3.messages).endDateLabel),
            value: (0, $c8XPX.formatDate)(data.endDate)
        });
        $[32] = data.endDate;
        $[33] = formatMessage;
        $[34] = t10;
    } else t10 = $[34];
    let t11;
    if ($[35] !== t10 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGrid), null, t7, t8, t9, t10);
        $[35] = t10;
        $[36] = t7;
        $[37] = t8;
        $[38] = t9;
        $[39] = t11;
    } else t11 = $[39];
    let t12;
    if ($[40] !== formatMessage) {
        t12 = formatMessage((0, $UlvU3.messages).cancelButton);
        $[40] = formatMessage;
        $[41] = t12;
    } else t12 = $[41];
    let t13;
    if ($[42] !== buttonsDisabled || $[43] !== handleCancel || $[44] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, t12);
        $[42] = buttonsDisabled;
        $[43] = handleCancel;
        $[44] = t12;
        $[45] = t13;
    } else t13 = $[45];
    let t14;
    if ($[46] !== formatMessage) {
        t14 = formatMessage((0, $UlvU3.messages).confirmButton);
        $[46] = formatMessage;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] !== buttonsDisabled || $[49] !== handleConfirm || $[50] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled
        }, t14);
        $[48] = buttonsDisabled;
        $[49] = handleConfirm;
        $[50] = t14;
        $[51] = t15;
    } else t15 = $[51];
    let t16;
    if ($[52] !== t13 || $[53] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f2815b0272ba43c9$var$styles.footer
        }, t13, t15));
        $[52] = t13;
        $[53] = t15;
        $[54] = t16;
    } else t16 = $[54];
    let t17;
    if ($[55] !== t11 || $[56] !== t16 || $[57] !== t5) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: t5,
            headerIcon: $f2815b0272ba43c9$var$sprintIcon
        }, t11, t16);
        $[55] = t11;
        $[56] = t16;
        $[57] = t5;
        $[58] = t17;
    } else t17 = $[58];
    return t17;
} : ({ actions: actions, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const action = actions[0];
    const { data: data } = action;
    const readonly = getReadonly(action);
    const [isActioned, setIsActioned] = (0, $cozmU.useState)(false);
    const buttonsDisabled = isActioned || readonly;
    const handleAction = (0, $cozmU.useCallback)((resolutionType)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: resolutionType === 'confirmed' ? 'confirmCreateSprintButton' : 'cancelCreateSprintButton'
        });
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'jiraCreateSprintAction'
            },
            confirmed_tools: {
                message_id: messageId,
                tools: [
                    {
                        key: action.key,
                        tool_id: action.actionId,
                        tool_source: action.toolSource,
                        invocation_id: action.invocationId,
                        resolution: {
                            type: resolutionType
                        },
                        data: {
                            human_message_id: action.humanMessageId ?? '',
                            arguments: action.data
                        }
                    }
                ]
            },
            resolutionType: resolutionType
        });
        setIsActioned(true);
    }, [
        sendAnalyticsEvent,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        action
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(()=>handleAction('confirmed'), [
        handleAction
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>handleAction('cancelled'), [
        handleAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $UlvU3.messages).title),
        headerIcon: $f2815b0272ba43c9$var$sprintIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGrid), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $UlvU3.messages).nameLabel),
        value: data.name
    }), data.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $UlvU3.messages).goalLabel),
        value: data.goal
    }), data.startDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $UlvU3.messages).startDateLabel),
        value: (0, $c8XPX.formatDate)(data.startDate)
    }), data.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $UlvU3.messages).endDateLabel),
        value: (0, $c8XPX.formatDate)(data.endDate)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f2815b0272ba43c9$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $UlvU3.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $UlvU3.messages).confirmButton)))));
};
module.exports["JiraCreateSprintAction"] = $f2815b0272ba43c9$export$a67cdfe68631d1bb;

});

parcelRegister("ggoXy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $9yffN = parcelRequire("9yffN");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $gHaaj = parcelRequire("gHaaj");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $8akfd = parcelRequire("8akfd");


var $d5gEx = parcelRequire("d5gEx");

// Returns the id of the last assistant message that contains Jira creatable actions, ignoring
// other unrelated messages.
const $8d49bc74e51d5f68$var$getLastCreatableActionMessageId = (messages)=>{
    const assistantMessagesWithCreatableActions = messages?.filter((msg)=>{
        if (!(0, $igOtY.isStoreAssistant)(msg)) return false;
        const messageActions = msg.content?.message?.message?.actions;
        return Boolean(messageActions?.[0] && (0, $9yffN.isJiraCreatableAction)(messageActions[0]));
    }) ?? [];
    const lastMessageWithCreatableActions = assistantMessagesWithCreatableActions.length > 0 ? assistantMessagesWithCreatableActions[assistantMessagesWithCreatableActions.length - 1] : undefined;
    return lastMessageWithCreatableActions?.content?.message?.message?.id ?? '';
};
const $8d49bc74e51d5f68$export$4dbf04f0761e3644 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { actions: actions, cloudId: cloudId, conversationId: conversationId, messageId: messageId, isLastMessage: isLastMessage, productKey: productKey, onCancel: onCancel, onCustomDataActioned: onCustomDataActioned, resolveActionsBulk: resolveActionsBulk } = t0;
    (0, $6cFsl.di)((0, $gHaaj.JiraCreateWithRovoPreviewCard));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { messageIdSelectedForPreview: messageIdSelectedForPreview, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const { setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, setStagingAreaMode: setStagingAreaMode } = (0, $8akfd.useStagingAreaActions)();
    const t1 = conversationId ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            conversationId: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const [chatMessages] = (0, $iW40i.useChatMessages)(t2);
    const firstInvocationId = actions[0]?.invocationId;
    let t3;
    if ($[2] !== chatMessages) {
        t3 = $8d49bc74e51d5f68$var$getLastCreatableActionMessageId(chatMessages);
        $[2] = chatMessages;
        $[3] = t3;
    } else t3 = $[3];
    const lastCreatableActionMessageId = t3;
    const effectiveIsLastMessage = lastCreatableActionMessageId ? lastCreatableActionMessageId === messageId : Boolean(isLastMessage);
    const isSelected = messageIdSelectedForPreview === messageId || !!invocationIdSelectedForPreview && invocationIdSelectedForPreview === firstInvocationId;
    const isEnabled = messageIdSelectedForPreview === null && effectiveIsLastMessage;
    const isStagingArea = !!messageIdSelectedForPreview || !!invocationIdSelectedForPreview;
    let t4;
    if ($[4] !== actions || $[5] !== onCancel || $[6] !== onCustomDataActioned) {
        t4 = (_actionKey, actionResolution, invocationIds, invocationIdToCreatedIssueKey)=>{
            invocationIds.forEach((invocationId)=>{
                const action = actions.find((a)=>a.invocationId === invocationId);
                if (!action) return;
                if (actionResolution === "cancel") {
                    onCancel(action);
                    return;
                }
                onCustomDataActioned(action, {
                    ...action.data,
                    ...invocationIdToCreatedIssueKey ? {
                        createdIssueKey: invocationIdToCreatedIssueKey[invocationId]
                    } : {}
                }, undefined, true);
            });
        };
        $[4] = actions;
        $[5] = onCancel;
        $[6] = onCustomDataActioned;
        $[7] = t4;
    } else t4 = $[7];
    const resolveActions = t4;
    let t5;
    if ($[8] !== actions.length || $[9] !== firstInvocationId || $[10] !== isStagingArea || $[11] !== messageId || $[12] !== sendAnalyticsEvent || $[13] !== setInvocationIdSelectedForPreview || $[14] !== setMessageIdSelectedForPreview || $[15] !== setStagingAreaMode) {
        t5 = (e)=>{
            e.preventDefault();
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "createWorkItemsAifcPreviewOpened",
                attributes: {
                    itemCount: actions.length,
                    isSingleWorkItem: actions.length === 1,
                    isStagingArea: isStagingArea
                }
            });
            if (firstInvocationId) setInvocationIdSelectedForPreview(firstInvocationId);
            setMessageIdSelectedForPreview(messageId);
            setStagingAreaMode("modal", "rovoChatPreviewCard");
        };
        $[8] = actions.length;
        $[9] = firstInvocationId;
        $[10] = isStagingArea;
        $[11] = messageId;
        $[12] = sendAnalyticsEvent;
        $[13] = setInvocationIdSelectedForPreview;
        $[14] = setMessageIdSelectedForPreview;
        $[15] = setStagingAreaMode;
        $[16] = t5;
    } else t5 = $[16];
    const onPreviewClick = t5;
    if (actions.length === 0) return null;
    const t6 = conversationId ?? "";
    const t7 = resolveActionsBulk ?? resolveActions;
    let t8;
    if ($[17] !== actions || $[18] !== cloudId || $[19] !== effectiveIsLastMessage || $[20] !== isEnabled || $[21] !== isSelected || $[22] !== isStagingArea || $[23] !== messageId || $[24] !== onPreviewClick || $[25] !== productKey || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gHaaj.JiraCreateWithRovoPreviewCard), {
            product: productKey,
            actions: actions,
            messageId: messageId,
            cloudId: cloudId,
            conversationId: t6,
            isSelected: isSelected,
            isEnabled: isEnabled,
            isLastMessage: effectiveIsLastMessage,
            onPreviewClick: onPreviewClick,
            resolveActions: t7,
            isStagingArea: isStagingArea
        }));
        $[17] = actions;
        $[18] = cloudId;
        $[19] = effectiveIsLastMessage;
        $[20] = isEnabled;
        $[21] = isSelected;
        $[22] = isStagingArea;
        $[23] = messageId;
        $[24] = onPreviewClick;
        $[25] = productKey;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ actions: actions, cloudId: cloudId, conversationId: conversationId, messageId: messageId, isLastMessage: isLastMessage, productKey: productKey, onCancel: onCancel, onCustomDataActioned: onCustomDataActioned, resolveActionsBulk: resolveActionsBulk })=>{
    (0, $6cFsl.di)((0, $gHaaj.JiraCreateWithRovoPreviewCard));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { messageIdSelectedForPreview: messageIdSelectedForPreview, invocationIdSelectedForPreview: invocationIdSelectedForPreview } = (0, $8akfd.useStagingAreaState)();
    const { setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, setStagingAreaMode: setStagingAreaMode } = (0, $8akfd.useStagingAreaActions)();
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId ?? ''
    });
    const firstInvocationId = actions[0]?.invocationId;
    // Derive "is this the active AIFC message" from chat messages rather than the naive isLastMessage
    // prop. Resolving a sibling action on the same message (e.g. an Update work items action) appends
    // an optimistic assistant response, which would otherwise flip the prop to false and incorrectly
    // disable this card. We fall back to the prop when messages aren't available.
    const lastCreatableActionMessageId = $8d49bc74e51d5f68$var$getLastCreatableActionMessageId(chatMessages);
    const effectiveIsLastMessage = lastCreatableActionMessageId ? lastCreatableActionMessageId === messageId : Boolean(isLastMessage);
    const isSelected = messageIdSelectedForPreview === messageId || !!invocationIdSelectedForPreview && invocationIdSelectedForPreview === firstInvocationId;
    // The preview card is interactive only when the staging area/canvas isn't open and this is the
    // most recent message that can create work items.
    const isEnabled = messageIdSelectedForPreview === null && effectiveIsLastMessage;
    const isStagingArea = !!messageIdSelectedForPreview || !!invocationIdSelectedForPreview;
    const resolveActions = (0, $cozmU.useCallback)((_actionKey, actionResolution, invocationIds, invocationIdToCreatedIssueKey)=>{
        invocationIds.forEach((invocationId)=>{
            const action = actions.find((a)=>a.invocationId === invocationId);
            if (!action) return;
            if (actionResolution === 'cancel') {
                onCancel(action);
                return;
            }
            onCustomDataActioned(action, {
                ...action.data,
                ...invocationIdToCreatedIssueKey ? {
                    createdIssueKey: invocationIdToCreatedIssueKey[invocationId]
                } : {}
            }, undefined, true // Skip the optimistic assistant response
            );
        });
    }, [
        actions,
        onCancel,
        onCustomDataActioned
    ]);
    const onPreviewClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsAifcPreviewOpened',
            attributes: {
                itemCount: actions.length,
                isSingleWorkItem: actions.length === 1,
                isStagingArea: isStagingArea
            }
        });
        if (firstInvocationId) setInvocationIdSelectedForPreview(firstInvocationId);
        setMessageIdSelectedForPreview(messageId);
        setStagingAreaMode('modal', 'rovoChatPreviewCard');
    }, [
        actions.length,
        firstInvocationId,
        isStagingArea,
        messageId,
        sendAnalyticsEvent,
        setInvocationIdSelectedForPreview,
        setMessageIdSelectedForPreview,
        setStagingAreaMode
    ]);
    if (actions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gHaaj.JiraCreateWithRovoPreviewCard), {
        product: productKey,
        actions: actions,
        messageId: messageId,
        cloudId: cloudId,
        conversationId: conversationId ?? '',
        isSelected: isSelected,
        isEnabled: isEnabled,
        isLastMessage: effectiveIsLastMessage,
        onPreviewClick: onPreviewClick,
        resolveActions: resolveActionsBulk ?? resolveActions,
        isStagingArea: isStagingArea
    }));
};
module.exports["JiraSmartIssueCreateAllFieldAction"] = $8d49bc74e51d5f68$export$4dbf04f0761e3644;

});

parcelRegister("htorK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $lMGh1 = parcelRequire("lMGh1");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $9qyl6 = parcelRequire("9qyl6");


var $e3ecr = parcelRequire("e3ecr");


var $7eUSO = parcelRequire("7eUSO");


var $gK83Z = parcelRequire("gK83Z");


var $c8XPX = parcelRequire("c8XPX");


var $1hB0U = parcelRequire("1hB0U");

const $c7a5b44373a6de6f$var$styles = {
    errorMessage: "_0LQT5EFQfX",
    epicIssueSelector: "_2Zuz6Q5zaO _3138422ADO",
    actionsWrapper: "_3138422ADO",
    assignButton: "_39xV02E6Kk"
};
const $c7a5b44373a6de6f$export$c17c71314c0e408b = (actions)=>{
    const filteredActions = actions.filter($c7a5b44373a6de6f$var$assertIsJiraEpicsSuggestAction);
    return filteredActions;
};
const $c7a5b44373a6de6f$var$assertIsJiraEpicsSuggestAction = (action)=>{
    // TODO: assert action.key === JIRA_EPICS_SUGGEST_KEY
    // or other minimal sanity
    if (action.key !== (0, $dw75i.JIRA_EPICS_SUGGEST_KEY)) throw new Error('Invalid action key for JiraEpicsSuggestAction');
    return action;
};
const $c7a5b44373a6de6f$var$JIRA_EPICS_SUGGEST_INTERACTION_SOURCE = 'jiraEpicsSuggestRenderer';
const $c7a5b44373a6de6f$export$9265d1e6d562f3d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($c7a5b44373a6de6f$export$fa14b3fc2d694332, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($c7a5b44373a6de6f$export$fa14b3fc2d694332, props);
};
const $c7a5b44373a6de6f$export$fa14b3fc2d694332 = ({ actions: actions, getStatus: getStatus, getReadonly: getReadonly, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId, onCustomDataActioned: onCustomDataActioned, onActioned: onActioned, sendMessageConfirmedTools: sendMessageConfirmedTools, cloudId: cloudId })=>{
    (0, $6cFsl.di)((0, $e3ecr.IssueSelector));
    (0, $6cFsl.di)((0, $gK83Z.useBulkAssignIssuesToEpic));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const epics = firstAction.data.epics;
    const isUnableToMatchEpics = epics.length === 0; // TODO: use just issueAris instead across controller to avoid conversions, but first we need to make sure IssueSelector adopts that
    //   which requires CustomActinos adopt that
    const [selectedIssueKeysByEpic, setSelectedIssueKeysByEpic] = (0, $cozmU.useState)({});
    const epicWithSelectedIssuesCount = Object.values(selectedIssueKeysByEpic).filter((issues)=>issues.length > 0).length;
    const hasSelectedAtLeastOneIssue = epicWithSelectedIssuesCount > 0;
    const { loading: loading, initiateBulkOperation: initiateBulkOperation } = (0, $gK83Z.useBulkAssignIssuesToEpic)();
    const [shouldShowAssignErrorMessage, setShouldShowAssignErrorMessage] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleIssuesSelected = (0, $cozmU.useCallback)((epicKey, issueKeys)=>{
        setSelectedIssueKeysByEpic((prevState)=>{
            const newState = {
                ...prevState,
                [epicKey]: issueKeys
            };
            if (shouldShowAssignErrorMessage && hasSelectedAtLeastOneIssue) setShouldShowAssignErrorMessage(false);
            return newState;
        });
    }, [
        shouldShowAssignErrorMessage,
        hasSelectedAtLeastOneIssue
    ]);
    if (isUnableToMatchEpics) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, firstAction.data.resultSummary);
    const handleBulkOperation = async ()=>{
        if (!hasSelectedAtLeastOneIssue) {
            setShouldShowAssignErrorMessage(true);
            return;
        }
        const selectedIssueArisByEpic = Object.entries(selectedIssueKeysByEpic).reduce((acc, [epicKey_0, issueAris])=>{
            const issues_0 = epics.find((epic)=>epic.issueKey === epicKey_0)?.issues || [];
            const issueKeys_0 = issueAris.map((issueAri)=>(0, $c8XPX.findIssueAri)(issues_0, issueAri));
            if (issueKeys_0.length > 0) acc[epicKey_0] = issueKeys_0;
            return acc;
        }, {});
        const selectedEpics = Object.keys(selectedIssueArisByEpic);
        const updatedData = {
            ...firstAction.data,
            customData: {
                organisedIssueKeys: selectedIssueKeysByEpic
            }
        };
        const sendClickAnalytics = ()=>{
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'epicSuggestActionButton',
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: (0, $dw75i.JIRA_EPICS_SUGGEST_KEY),
                    selectedEpicCount: selectedEpics.length,
                    totalEpicCount: epics.length,
                    selectedIssueCount: selectedIssueKeysByEpic.length,
                    totalIssueCount: firstAction.data.providedIssues.length - firstAction.data.unorganisedIssues.length,
                    unOrganisedIssueCount: firstAction.data.unorganisedIssues.length
                }
            });
        };
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            sendClickAnalytics();
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $c7a5b44373a6de6f$var$JIRA_EPICS_SUGGEST_INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        (0, $7eUSO.buildToolFromAction)(firstAction, 'confirmed', updatedData)
                    ]
                }
            });
            return;
        }
        try {
            await initiateBulkOperation(selectedIssueArisByEpic, cloudId);
            sendClickAnalytics();
            onCustomDataActioned(firstAction, updatedData, formatMessage((0, $1hB0U.default).jiraAssignIssueSuccessMessageText, {
                epicLinks: epics.filter((epic_0)=>selectedEpics.includes(epic_0.issueKey)).map((epic_1, index)=>`${index + 1}. ${epic_1.url}`).join('\n'),
                totalEpics: selectedEpics.length
            }));
        } catch (e) {
            if (e instanceof Error) onActioned(firstAction, e.message);
            else onActioned(firstAction, formatMessage((0, $1hB0U.default).jiraBulkAssignIssueUnexpectedErrorMessageText));
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, firstAction.data.resultSummary), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $1hB0U.default).jiraEpicSuggestActionCardTitle),
        product: "jira"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $1hB0U.default).jiraEpicSuggestSubtitleText, {
        epicsCount: firstAction.data.epics.length
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "ol",
        xcss: $c7a5b44373a6de6f$var$styles.epicIssueSelector
    }, epics.map((epic_2)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
            key: epic_2.issueKey
        }, /*#__PURE__*/ $cozmU.createElement("li", null, /*#__PURE__*/ $cozmU.createElement((0, $l8wPz.Card), {
            url: epic_2.url,
            appearance: "inline",
            platform: "web",
            showHoverPreview: true
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingBlock: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.IssueSelector), {
            initialIssues: epic_2.issues,
            title: formatMessage((0, $1hB0U.default).jiraIssuesDropdownTitleText),
            isInitiallyExpanded: true,
            epicKey: epic_2.issueKey,
            selectedIssuesByEpic: selectedIssueKeysByEpic,
            onIssuesSelected: (issueKeys_1)=>{
                handleIssuesSelected(epic_2.issueKey, issueKeys_1);
            },
            initialSelectedIssues: firstAction.data.customData?.organisedIssueKeys[epic_2.issueKey],
            readonly: readonly
        }))))))), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: readonly || status !== 'idle',
        isLoading: loading,
        onClick: handleBulkOperation
    }, formatMessage((0, $1hB0U.default).jiraEpicAssignButton, {
        epicCount: epicWithSelectedIssuesCount
    })))), /*#__PURE__*/ $cozmU.createElement("div", {
        role: "region",
        "aria-live": "polite"
    }, shouldShowAssignErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075",
        xcss: $c7a5b44373a6de6f$var$styles.errorMessage
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, formatMessage((0, $1hB0U.default).jiraAssignIssueErrorMessageText)))));
};
module.exports["JiraEpicsSuggestAction"] = $c7a5b44373a6de6f$export$9265d1e6d562f3d6;

});

parcelRegister("ds1P0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l8wPz = parcelRequire("l8wPz");


var $dw75i = parcelRequire("dw75i");

const $46a35c1c947a5783$export$39b0527080bea23c = (actions)=>{
    const filteredActions = actions.filter($46a35c1c947a5783$var$assertIsJiraFindIssuesAction);
    return filteredActions;
};
const $46a35c1c947a5783$var$assertIsJiraFindIssuesAction = (action)=>{
    if (action.key !== (0, $dw75i.JIRA_FIND_ISSUES_KEY)) throw new Error('Invalid action key for JiraFindIssuesAction');
    return action;
};
const $46a35c1c947a5783$export$9a1ec73cafca1d65 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { actions: actions } = t0;
    const firstAction = actions[0];
    const { data: t1 } = firstAction;
    const { issues: issues } = t1;
    let t2;
    if ($[0] !== issues) {
        t2 = issues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", null, issues.map($46a35c1c947a5783$var$_temp)) : null;
        $[0] = issues;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ actions: actions })=>{
    const firstAction = actions[0];
    const { data: { issues: issues } } = firstAction;
    return issues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", null, issues.map((issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: issue.issueKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            url: issue.url,
            appearance: "inline",
            onClick: (e)=>{
                e.preventDefault();
                window.open(issue.url, '_blank');
            }
        })))) : null;
};
function $46a35c1c947a5783$var$_temp(issue) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        key: issue.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        url: issue.url,
        appearance: "inline",
        onClick: (e)=>{
            e.preventDefault();
            window.open(issue.url, "_blank");
        }
    }));
}
module.exports["JiraFindIssuesAction"] = $46a35c1c947a5783$export$9a1ec73cafca1d65;

});

parcelRegister("lBUo6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $24tIi = parcelRequire("24tIi");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $e3ecr = parcelRequire("e3ecr");


var $7eUSO = parcelRequire("7eUSO");


var $lo1na = parcelRequire("lo1na");

const $2d908c1adf6676ac$var$styles = {
    negativeMarginTop: "_313842B0rP",
    wrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
};
const $2d908c1adf6676ac$var$JiraIssueAssignActionNewLayout = ({ actions: actions, getReadonly: getReadonly, onCustomDataConfirm: onCustomDataConfirm, cloudId: cloudId, onActioned: onActioned, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $e3ecr.BulkIssueSelector));
    (0, $6cFsl.di)((0, $24tIi.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [selectedAssignee, setSelectedAssignee] = (0, $cozmU.useState)(undefined);
    const [selectedIssues, setSelectedIssues] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false); //Use assignee id of first action as default assignee id
    const defaultAssigneeId = actions[0].data.assignee;
    const allActionsAreReadonly = actions.every((action)=>getReadonly(action));
    const initialIssues = actions.map((action_0)=>{
        return {
            issueKey: action_0.data.key,
            readonly: getReadonly(action_0),
            url: action_0.data.url
        };
    });
    const handleSubmit = (0, $cozmU.useCallback)(async ()=>{
        if (!selectedIssues.length || allActionsAreReadonly) return;
        let actionsToSubmit = [];
        setIsLoading(true);
        try {
            const actionsMap = new Map(actions.map((action_3)=>[
                    action_3.data.key,
                    action_3
                ]));
            actionsToSubmit = selectedIssues.map((issueKey)=>actionsMap.get(issueKey)).filter((action_4)=>action_4 !== undefined).filter((action_5)=>!getReadonly(action_5));
            if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
                const plannedActions = actions.filter((action_6)=>action_6.status === 'planned');
                const actionsToSubmitKeys = new Set(actionsToSubmit.map((action_7)=>action_7.data.key));
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: 'jiraIssueAssignRenderer'
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: plannedActions.map((action_8)=>actionsToSubmitKeys.has(action_8.data.key) ? (0, $7eUSO.buildToolFromAction)(action_8, 'confirmed', {
                                key: action_8.data.key,
                                assignee: selectedAssignee?.id || defaultAssigneeId,
                                url: action_8.data.url,
                                ari: action_8.data.ari
                            }) : (0, $7eUSO.buildToolFromAction)(action_8, 'cancelled'))
                    }
                });
                sendAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'rovoJiraIssueAssignSubmit',
                    attributes: {
                        issueCount: actionsToSubmit.length
                    }
                });
                return;
            }
            const submissionPromises = actionsToSubmit.map(async (action_9)=>{
                await onCustomDataConfirm(action_9, {
                    key: action_9.data.key,
                    assignee: selectedAssignee?.id || defaultAssigneeId,
                    url: action_9.data.url,
                    ari: action_9.data.ari
                });
            });
            await Promise.all(submissionPromises);
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'rovoJiraIssueAssignSubmit',
                attributes: {
                    issueCount: actionsToSubmit.length
                }
            });
        } catch (e) {
            // TODO: remove catch block once resumption is cleaned up
            if (e instanceof Error) actionsToSubmit.forEach((action_1)=>{
                onActioned(action_1, e.message);
            });
            else actionsToSubmit.forEach((action_2)=>{
                onActioned(action_2, formatMessage((0, $lo1na.default).jiraBulkIssueAssignErrorMessage));
            });
        } finally{
            setIsLoading(false);
        }
    }, [
        selectedIssues,
        allActionsAreReadonly,
        actions,
        sendAnalyticsEvent,
        getReadonly,
        onCustomDataConfirm,
        selectedAssignee?.id,
        defaultAssigneeId,
        onActioned,
        formatMessage,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) return;
        const plannedActions_0 = actions.filter((action_10)=>action_10.status === 'planned');
        if (!plannedActions_0.length) return;
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'jiraIssueAssignRenderer'
            },
            confirmed_tools: {
                message_id: messageId,
                tools: plannedActions_0.map((action_11)=>(0, $7eUSO.buildToolFromAction)(action_11, 'cancelled'))
            }
        });
    }, [
        actions,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId
    ]);
    const handleSelectIssue = (0, $cozmU.useCallback)((issueKeys)=>{
        setSelectedIssues(issueKeys);
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $2d908c1adf6676ac$var$styles.negativeMarginTop
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $lo1na.default).jiraIssueAssignTitle)), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $lo1na.default).jiraIssueAssignActionCardTitle),
        product: "jira"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lo1na.default).jiraIssueAssigneeTitle)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2d908c1adf6676ac$var$styles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $24tIi.default), {
        defaultValue: {
            id: defaultAssigneeId,
            type: 'user'
        },
        isClearable: false,
        prefetch: true,
        fieldId: "assignee",
        productKey: "people",
        siteId: cloudId,
        width: "100%",
        includeGroups: false,
        includeTeams: false,
        value: selectedAssignee,
        onChange: (newValue)=>{
            setSelectedAssignee(newValue);
        },
        appearance: "compact",
        maxOptions: 10
    }))), /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.BulkIssueSelector), {
        initialIssues: initialIssues,
        title: formatMessage((0, $lo1na.default).jiraIssueAssignSelectIssuesTitle),
        onIssuesSelected: handleSelectIssue,
        readonly: allActionsAreReadonly
    })), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignInline: "end"
    }, (0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false) && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        isDisabled: allActionsAreReadonly,
        onClick: (_, e_0)=>{
            handleCancel();
            sendAnalyticsEvent(e_0.update({
                actionSubjectId: 'rovoJiraIssueAssignCancel'
            }));
        }
    }, formatMessage((0, $lo1na.default).jiraIssueAssignCancel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: allActionsAreReadonly || !selectedIssues.length,
        isLoading: isLoading,
        onClick: (__0, e_1)=>{
            handleSubmit();
            sendAnalyticsEvent(e_1.update({
                actionSubjectId: 'rovoJiraIssueAssign'
            }));
        },
        interactionName: "ai-mate.issue-bulk-assign"
    }, formatMessage((0, $lo1na.default).jiraIssueAssignUpdateSelectedIssues))))));
};
const $2d908c1adf6676ac$export$9ad54b928f5d271 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($2d908c1adf6676ac$var$JiraIssueAssignActionNewLayout, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($2d908c1adf6676ac$var$JiraIssueAssignActionNewLayout, props);
};
module.exports["JiraIssueAssignAction"] = $2d908c1adf6676ac$export$9ad54b928f5d271;

});

parcelRegister("826v6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $24dy7 = parcelRequire("24dy7");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iDrrr = parcelRequire("iDrrr");


var $4ez2K = parcelRequire("4ez2K");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $9qyl6 = parcelRequire("9qyl6");


var $e3ecr = parcelRequire("e3ecr");


var $7eUSO = parcelRequire("7eUSO");


var $418I8 = parcelRequire("418I8");

const $021e26c3c838bc8a$var$styles = {
    errorMessage: "_0LQT5EFQfX",
    grid: "_39xV02N91d _3NN0tO4BLX",
    titleContainer: "_1xC2CJifeI"
};
const $021e26c3c838bc8a$var$confirmIssueDelete = ({ actions: actions, firstAction: firstAction, getStatus: getStatus, selectedIssuesData: selectedIssuesData, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    if ((0, $iDrrr.fg)('rovo_tools_resumption_migration_phase2')) {
        const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'jiraIssueDeleteRenderer'
            },
            confirmed_tools: {
                message_id: messageId,
                tools: plannedActions.map((action)=>action.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action, 'confirmed', {
                        ...action.data,
                        issues: selectedIssuesData
                    }) : (0, $7eUSO.buildToolFromAction)(action, 'cancelled'))
            }
        });
        return;
    }
    onCustomDataConfirm(firstAction, {
        issues: selectedIssuesData
    });
};
const $021e26c3c838bc8a$export$fdffd325f95d4a56 = (actions)=>{
    return actions.filter($021e26c3c838bc8a$var$assertIsJiraIssueDeleteAction);
};
const $021e26c3c838bc8a$var$assertIsJiraIssueDeleteAction = (action)=>{
    if (action.key !== (0, $dw75i.JIRA_ISSUE_DELETE_KEY)) throw new Error('Invalid action key for JiraIssueDeleteAction');
    return action;
};
const $021e26c3c838bc8a$export$9811b0441d4d7149 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($021e26c3c838bc8a$export$966545732c12a84f, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($021e26c3c838bc8a$export$966545732c12a84f, props);
};
const $021e26c3c838bc8a$export$966545732c12a84f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { actions: actions, getStatus: getStatus, getReadonly: getReadonly, recipientAgentNamedId: recipientAgentNamedId, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId, onCustomDataConfirm: onCustomDataConfirm, onCancel: onCancel, sendMessageConfirmedTools: sendMessageConfirmedTools } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [selectedIssues, setSelectedIssues] = (0, $cozmU.useState)(t1);
    const [shouldShowErrorMessage, setShouldShowErrorMessage] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: t2 } = firstAction;
    const { issues: issues } = t2;
    let t3;
    if ($[1] !== firstAction || $[2] !== getReadonly) {
        t3 = getReadonly(firstAction);
        $[1] = firstAction;
        $[2] = getReadonly;
        $[3] = t3;
    } else t3 = $[3];
    const readonly = t3;
    let t4;
    if ($[4] !== firstAction || $[5] !== getStatus) {
        t4 = getStatus(firstAction);
        $[4] = firstAction;
        $[5] = getStatus;
        $[6] = t4;
    } else t4 = $[6];
    const status = t4;
    let t5;
    if ($[7] !== recipientAgentNamedId || $[8] !== sendAnalyticsEvent) {
        t5 = ()=>{
            sendAnalyticsEvent({
                action: "appeared",
                actionSubject: "dialog",
                actionSubjectId: "confirmDeleteModal",
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: (0, $dw75i.JIRA_ISSUE_DELETE_KEY)
                }
            });
            setIsModalOpen(true);
        };
        $[7] = recipientAgentNamedId;
        $[8] = sendAnalyticsEvent;
        $[9] = t5;
    } else t5 = $[9];
    const openDeleteModal = t5;
    let t6;
    if ($[10] !== firstAction || $[11] !== onCancel) {
        t6 = ()=>{
            onCancel(firstAction);
            setIsModalOpen(false);
        };
        $[10] = firstAction;
        $[11] = onCancel;
        $[12] = t6;
    } else t6 = $[12];
    const closeDeleteModal = t6;
    let t7;
    if ($[13] !== shouldShowErrorMessage) {
        t7 = (issueKeys)=>{
            setSelectedIssues(issueKeys);
            if (shouldShowErrorMessage) setShouldShowErrorMessage(issueKeys.length === 0);
        };
        $[13] = shouldShowErrorMessage;
        $[14] = t7;
    } else t7 = $[14];
    const handleSelectIssue = t7;
    let t8;
    if ($[15] !== issues.length || $[16] !== openDeleteModal || $[17] !== recipientAgentNamedId || $[18] !== selectedIssues.length || $[19] !== sendAnalyticsEvent) {
        t8 = ()=>{
            const canOpenModal = selectedIssues.length > 0;
            if (canOpenModal) {
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "deleteActionButton",
                    attributes: {
                        recipientAgentNamedId: recipientAgentNamedId,
                        actionKey: (0, $dw75i.JIRA_ISSUE_DELETE_KEY),
                        selectedIssueCount: selectedIssues.length,
                        totalIssueCount: issues.length
                    }
                });
                openDeleteModal();
            }
            setShouldShowErrorMessage(!canOpenModal);
        };
        $[15] = issues.length;
        $[16] = openDeleteModal;
        $[17] = recipientAgentNamedId;
        $[18] = selectedIssues.length;
        $[19] = sendAnalyticsEvent;
        $[20] = t8;
    } else t8 = $[20];
    const handleDeleteButton = t8;
    let t9;
    if ($[21] !== actions || $[22] !== conversationId || $[23] !== firstAction || $[24] !== getStatus || $[25] !== issues || $[26] !== messageId || $[27] !== onCustomDataConfirm || $[28] !== recipientAgentId || $[29] !== recipientAgentNamedId || $[30] !== selectedIssues || $[31] !== sendAnalyticsEvent || $[32] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            const selectedIssuesData = issues.filter((t10)=>{
                const { issueKey: issueKey } = t10;
                return selectedIssues.includes(issueKey);
            });
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "deleteActionConfirmButton",
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: (0, $dw75i.JIRA_ISSUE_DELETE_KEY)
                }
            });
            $021e26c3c838bc8a$var$confirmIssueDelete({
                actions: actions,
                firstAction: firstAction,
                getStatus: getStatus,
                selectedIssuesData: selectedIssuesData,
                onCustomDataConfirm: onCustomDataConfirm,
                sendMessageConfirmedTools: sendMessageConfirmedTools,
                recipientAgentId: recipientAgentId,
                conversationId: conversationId,
                messageId: messageId
            });
            setIsModalOpen(false);
        };
        $[21] = actions;
        $[22] = conversationId;
        $[23] = firstAction;
        $[24] = getStatus;
        $[25] = issues;
        $[26] = messageId;
        $[27] = onCustomDataConfirm;
        $[28] = recipientAgentId;
        $[29] = recipientAgentNamedId;
        $[30] = selectedIssues;
        $[31] = sendAnalyticsEvent;
        $[32] = sendMessageConfirmedTools;
        $[33] = t9;
    } else t9 = $[33];
    const deleteConfirm = t9;
    if (issues.length <= 0) return null;
    let t10;
    if ($[34] !== formatMessage) {
        t10 = formatMessage((0, $418I8.default).jiraIssueDeleteActionCardTitle);
        $[34] = formatMessage;
        $[35] = t10;
    } else t10 = $[35];
    let t11;
    if ($[36] !== formatMessage) {
        t11 = formatMessage((0, $418I8.default).jiraIssueDeleteListTitleText);
        $[36] = formatMessage;
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== handleSelectIssue || $[39] !== issues || $[40] !== readonly || $[41] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.IssueSelector), {
            initialIssues: issues,
            title: t11,
            isInitiallyExpanded: true,
            onIssuesSelected: handleSelectIssue,
            readonly: readonly
        });
        $[38] = handleSelectIssue;
        $[39] = issues;
        $[40] = readonly;
        $[41] = t11;
        $[42] = t12;
    } else t12 = $[42];
    const t13 = readonly || status !== "idle";
    let t14;
    if ($[43] !== formatMessage) {
        t14 = formatMessage((0, $418I8.default).jiraIssueDeleteButtonLabelText);
        $[43] = formatMessage;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== handleDeleteButton || $[46] !== t13 || $[47] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: t13,
            onClick: handleDeleteButton
        }, t14));
        $[45] = handleDeleteButton;
        $[46] = t13;
        $[47] = t14;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== t12 || $[50] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t12, t15);
        $[49] = t12;
        $[50] = t15;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== t10 || $[53] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            product: "jira",
            title: t10
        }, t16);
        $[52] = t10;
        $[53] = t16;
        $[54] = t17;
    } else t17 = $[54];
    let t18;
    if ($[55] !== formatMessage || $[56] !== shouldShowErrorMessage) {
        t18 = shouldShowErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            xcss: $021e26c3c838bc8a$var$styles.errorMessage
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            size: "small"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.danger",
            size: "small"
        }, formatMessage((0, $418I8.default).jiraIssueDeleteButtonErrorMessageText)));
        $[55] = formatMessage;
        $[56] = shouldShowErrorMessage;
        $[57] = t18;
    } else t18 = $[57];
    let t19;
    if ($[58] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "region",
            "aria-live": "polite"
        }, t18);
        $[58] = t18;
        $[59] = t19;
    } else t19 = $[59];
    let t20;
    if ($[60] !== closeDeleteModal || $[61] !== deleteConfirm || $[62] !== formatMessage || $[63] !== isModalOpen || $[64] !== selectedIssues) {
        t20 = isModalOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: closeDeleteModal
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $3pCca.Grid), {
            gap: "space.200",
            xcss: $021e26c3c838bc8a$var$styles.grid
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $021e26c3c838bc8a$var$styles.titleContainer,
            justifyContent: "start"
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), {
            appearance: "danger"
        }, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogTitleText))))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogBodyText, {
            s: selectedIssues && selectedIssues.length > 1 ? "s" : ""
        }))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: closeDeleteModal
        }, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogCancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "danger",
            onClick: deleteConfirm
        }, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogConfirmButton))));
        $[60] = closeDeleteModal;
        $[61] = deleteConfirm;
        $[62] = formatMessage;
        $[63] = isModalOpen;
        $[64] = selectedIssues;
        $[65] = t20;
    } else t20 = $[65];
    let t21;
    if ($[66] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t20);
        $[66] = t20;
        $[67] = t21;
    } else t21 = $[67];
    let t22;
    if ($[68] !== t17 || $[69] !== t19 || $[70] !== t21) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.250"
        }, t17, t19, t21);
        $[68] = t17;
        $[69] = t19;
        $[70] = t21;
        $[71] = t22;
    } else t22 = $[71];
    return t22;
} : ({ actions: actions, getStatus: getStatus, getReadonly: getReadonly, recipientAgentNamedId: recipientAgentNamedId, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId, onCustomDataConfirm: onCustomDataConfirm, onCancel: onCancel, sendMessageConfirmedTools: sendMessageConfirmedTools })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [selectedIssues, setSelectedIssues] = (0, $cozmU.useState)([]);
    const [shouldShowErrorMessage, setShouldShowErrorMessage] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: { issues: issues } } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const openDeleteModal = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'appeared',
            actionSubject: 'dialog',
            actionSubjectId: 'confirmDeleteModal',
            attributes: {
                recipientAgentNamedId: recipientAgentNamedId,
                actionKey: (0, $dw75i.JIRA_ISSUE_DELETE_KEY)
            }
        });
        setIsModalOpen(true);
    }, [
        sendAnalyticsEvent,
        recipientAgentNamedId
    ]);
    const closeDeleteModal = (0, $cozmU.useCallback)(()=>{
        onCancel(firstAction);
        setIsModalOpen(false);
    }, [
        firstAction,
        onCancel
    ]);
    const handleSelectIssue = (0, $cozmU.useCallback)((issueKeys)=>{
        setSelectedIssues(issueKeys);
        if (shouldShowErrorMessage) setShouldShowErrorMessage(issueKeys.length === 0);
    }, [
        shouldShowErrorMessage
    ]);
    const handleDeleteButton = (0, $cozmU.useCallback)(()=>{
        const canOpenModal = selectedIssues.length > 0;
        if (canOpenModal) {
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'deleteActionButton',
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: (0, $dw75i.JIRA_ISSUE_DELETE_KEY),
                    selectedIssueCount: selectedIssues.length,
                    totalIssueCount: issues.length
                }
            });
            openDeleteModal();
        }
        setShouldShowErrorMessage(!canOpenModal);
    }, [
        issues.length,
        openDeleteModal,
        recipientAgentNamedId,
        selectedIssues.length,
        sendAnalyticsEvent
    ]);
    const deleteConfirm = ()=>{
        const selectedIssuesData = issues.filter(({ issueKey: issueKey })=>selectedIssues.includes(issueKey));
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'deleteActionConfirmButton',
            attributes: {
                recipientAgentNamedId: recipientAgentNamedId,
                actionKey: (0, $dw75i.JIRA_ISSUE_DELETE_KEY)
            }
        });
        $021e26c3c838bc8a$var$confirmIssueDelete({
            actions: actions,
            firstAction: firstAction,
            getStatus: getStatus,
            selectedIssuesData: selectedIssuesData,
            onCustomDataConfirm: onCustomDataConfirm,
            sendMessageConfirmedTools: sendMessageConfirmedTools,
            recipientAgentId: recipientAgentId,
            conversationId: conversationId,
            messageId: messageId
        });
        setIsModalOpen(false);
    };
    if (issues.length <= 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        product: "jira",
        title: formatMessage((0, $418I8.default).jiraIssueDeleteActionCardTitle)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.IssueSelector), {
        initialIssues: issues,
        title: formatMessage((0, $418I8.default).jiraIssueDeleteListTitleText),
        isInitiallyExpanded: true,
        onIssuesSelected: handleSelectIssue,
        readonly: readonly
    }), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: readonly || status !== 'idle',
        onClick: handleDeleteButton
    }, formatMessage((0, $418I8.default).jiraIssueDeleteButtonLabelText))))), /*#__PURE__*/ $cozmU.createElement("div", {
        role: "region",
        "aria-live": "polite"
    }, shouldShowErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075",
        xcss: $021e26c3c838bc8a$var$styles.errorMessage
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.danger",
        size: "small"
    }, formatMessage((0, $418I8.default).jiraIssueDeleteButtonErrorMessageText)))), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isModalOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: closeDeleteModal
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $3pCca.Grid), {
        gap: "space.200",
        xcss: $021e26c3c838bc8a$var$styles.grid
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $021e26c3c838bc8a$var$styles.titleContainer,
        justifyContent: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), {
        appearance: "danger"
    }, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogTitleText))))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogBodyText, {
        s: selectedIssues && selectedIssues.length > 1 ? 's' : ''
    }))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeDeleteModal
    }, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogCancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "danger",
        onClick: deleteConfirm
    }, formatMessage((0, $418I8.default).jiraIssueDeleteModalDialogConfirmButton))))));
};
module.exports["JiraIssueDeleteAction"] = $021e26c3c838bc8a$export$9811b0441d4d7149;

});

parcelRegister("dGil5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $24dy7 = parcelRequire("24dy7");


var $9KSWX = parcelRequire("9KSWX");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $4ikjJ = parcelRequire("4ikjJ");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $9qyl6 = parcelRequire("9qyl6");


var $e3ecr = parcelRequire("e3ecr");


var $7eUSO = parcelRequire("7eUSO");


var $i4ehy = parcelRequire("i4ehy");

const $5ea541ce66c636f5$var$styles = {
    errorMessage: "_0LQT5EFQfX"
};
const $5ea541ce66c636f5$var$JIRA_ISSUE_MOVE_INTERACTION_SOURCE = 'jiraIssueMoveRenderer';
const $5ea541ce66c636f5$export$5f3d71500b93ebf9 = (actions)=>{
    const filteredActions = actions.filter($5ea541ce66c636f5$var$assertIsJiraIssueMoveAction);
    return filteredActions;
};
const $5ea541ce66c636f5$var$assertIsJiraIssueMoveAction = (action)=>{
    if (action.key !== (0, $dw75i.JIRA_ISSUE_MOVE_KEY)) throw new Error('Invalid action key for JiraIssueMoveAction');
    return action;
};
const $5ea541ce66c636f5$export$622c113241252e2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($5ea541ce66c636f5$export$984c19611d867191, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($5ea541ce66c636f5$export$984c19611d867191, props);
};
const $5ea541ce66c636f5$export$984c19611d867191 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(78);
    const { actions: actions, getStatus: getStatus, getReadonly: getReadonly, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [selectedIssues, setSelectedIssues] = (0, $cozmU.useState)(t1);
    const [selectedSprint, setSelectedSprint] = (0, $cozmU.useState)("");
    const [shouldShowErrorMessage, setShouldShowErrorMessage] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: t2 } = firstAction;
    const { issues: issues, sprints: sprints } = t2;
    let t3;
    if ($[1] !== firstAction || $[2] !== getReadonly) {
        t3 = getReadonly(firstAction);
        $[1] = firstAction;
        $[2] = getReadonly;
        $[3] = t3;
    } else t3 = $[3];
    const readonly = t3;
    let t4;
    if ($[4] !== firstAction || $[5] !== getStatus) {
        t4 = getStatus(firstAction);
        $[4] = firstAction;
        $[5] = getStatus;
        $[6] = t4;
    } else t4 = $[6];
    const status = t4;
    let t5;
    if ($[7] !== selectedIssues.length || $[8] !== shouldShowErrorMessage) {
        t5 = (t6)=>{
            const { currentTarget: t7 } = t6;
            const { value: value } = t7;
            setSelectedSprint(value);
            if (shouldShowErrorMessage) setShouldShowErrorMessage(selectedIssues.length === 0 || value === "");
        };
        $[7] = selectedIssues.length;
        $[8] = shouldShowErrorMessage;
        $[9] = t5;
    } else t5 = $[9];
    const onChangeSprint = t5;
    let t6;
    if ($[10] !== selectedSprint || $[11] !== shouldShowErrorMessage) {
        t6 = (issueKeys)=>{
            setSelectedIssues(issueKeys);
            if (shouldShowErrorMessage) setShouldShowErrorMessage(issueKeys.length === 0 || selectedSprint === "");
        };
        $[10] = selectedSprint;
        $[11] = shouldShowErrorMessage;
        $[12] = t6;
    } else t6 = $[12];
    const handleSelectIssue = t6;
    let t7;
    if ($[13] !== selectedSprint) {
        t7 = (sprints_0)=>{
            let sprintIndex;
            const sprint = sprints_0.find((t8, index)=>{
                const { sprintId: sprintId } = t8;
                sprintIndex = index;
                return sprintId === selectedSprint;
            });
            return [
                sprint,
                sprintIndex
            ];
        };
        $[13] = selectedSprint;
        $[14] = t7;
    } else t7 = $[14];
    const getSprintAnalytics = t7;
    let t8;
    if ($[15] !== conversationId || $[16] !== firstAction || $[17] !== getSprintAnalytics || $[18] !== issues || $[19] !== messageId || $[20] !== onCustomDataConfirm || $[21] !== recipientAgentId || $[22] !== recipientAgentNamedId || $[23] !== selectedIssues || $[24] !== selectedSprint || $[25] !== sendAnalyticsEvent || $[26] !== sendMessageConfirmedTools || $[27] !== sprints) {
        t8 = ()=>{
            const canMove = selectedIssues.length > 0 && selectedSprint !== "";
            if (canMove) {
                const [sprint_0, sprintIndex_0] = getSprintAnalytics(sprints);
                const moveData = {
                    issues: issues.filter((t9)=>{
                        const { issueKey: issueKey } = t9;
                        return selectedIssues.includes(issueKey);
                    }),
                    sprintId: selectedSprint
                };
                sendAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "moveActionButton",
                    attributes: {
                        recipientAgentNamedId: recipientAgentNamedId,
                        actionKey: (0, $dw75i.JIRA_ISSUE_MOVE_KEY),
                        selectedIssueCount: selectedIssues.length,
                        totalIssueCount: issues.length,
                        sprintState: sprint_0?.sprintState,
                        sprintIndex: sprintIndex_0
                    }
                });
                if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $5ea541ce66c636f5$var$JIRA_ISSUE_MOVE_INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: [
                            (0, $7eUSO.buildToolFromAction)(firstAction, "confirmed", moveData)
                        ]
                    }
                });
                else onCustomDataConfirm(firstAction, moveData);
            }
            setShouldShowErrorMessage(!canMove);
        };
        $[15] = conversationId;
        $[16] = firstAction;
        $[17] = getSprintAnalytics;
        $[18] = issues;
        $[19] = messageId;
        $[20] = onCustomDataConfirm;
        $[21] = recipientAgentId;
        $[22] = recipientAgentNamedId;
        $[23] = selectedIssues;
        $[24] = selectedSprint;
        $[25] = sendAnalyticsEvent;
        $[26] = sendMessageConfirmedTools;
        $[27] = sprints;
        $[28] = t8;
    } else t8 = $[28];
    const moveConfirm = t8;
    if (issues.length <= 0 || sprints.length <= 0) return null;
    let t9;
    if ($[29] !== formatMessage) {
        t9 = formatMessage((0, $i4ehy.default).jiraIssueMoveActionCardTitle);
        $[29] = formatMessage;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== formatMessage) {
        t10 = formatMessage((0, $i4ehy.default).jiraIssueMoveListMessageText);
        $[31] = formatMessage;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, t10);
        $[33] = t10;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== formatMessage) {
        t12 = formatMessage((0, $i4ehy.default).jiraIssueMoveListTitleText);
        $[35] = formatMessage;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== handleSelectIssue || $[38] !== issues || $[39] !== readonly || $[40] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.IssueSelector), {
            initialIssues: issues,
            title: t12,
            isInitiallyExpanded: true,
            onIssuesSelected: handleSelectIssue,
            readonly: readonly
        });
        $[37] = handleSelectIssue;
        $[38] = issues;
        $[39] = readonly;
        $[40] = t12;
        $[41] = t13;
    } else t13 = $[41];
    let t14;
    if ($[42] !== formatMessage) {
        t14 = formatMessage((0, $i4ehy.default).jiraIssueMoveSprintSelectorText);
        $[42] = formatMessage;
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, t14);
        $[44] = t14;
        $[45] = t15;
    } else t15 = $[45];
    let t16;
    if ($[46] !== onChangeSprint || $[47] !== readonly || $[48] !== selectedSprint || $[49] !== sprints) {
        let t17;
        if ($[51] !== onChangeSprint || $[52] !== readonly || $[53] !== selectedSprint) {
            t17 = (t18)=>{
                const { sprintId: sprintId_0, sprintName: sprintName, sprintState: sprintState } = t18;
                return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    key: sprintId_0,
                    space: "space.100",
                    alignInline: "start",
                    alignBlock: "center"
                }, /*#__PURE__*/ $cozmU.createElement((0, $4ikjJ.default), {
                    isChecked: sprintId_0 === selectedSprint,
                    isDisabled: readonly,
                    onChange: onChangeSprint,
                    name: sprintName,
                    label: sprintName,
                    value: sprintId_0
                }), /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                    appearance: sprintState === "ACTIVE" ? "information" : "neutral"
                }, sprintState));
            };
            $[51] = onChangeSprint;
            $[52] = readonly;
            $[53] = selectedSprint;
            $[54] = t17;
        } else t17 = $[54];
        t16 = sprints.map(t17);
        $[46] = onChangeSprint;
        $[47] = readonly;
        $[48] = selectedSprint;
        $[49] = sprints;
        $[50] = t16;
    } else t16 = $[50];
    let t17;
    if ($[55] !== t11 || $[56] !== t13 || $[57] !== t15 || $[58] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t11, t13, t15, t16);
        $[55] = t11;
        $[56] = t13;
        $[57] = t15;
        $[58] = t16;
        $[59] = t17;
    } else t17 = $[59];
    const t18 = readonly || status !== "idle";
    let t19;
    if ($[60] !== formatMessage) {
        t19 = formatMessage((0, $i4ehy.default).jiraIssueMoveButtonLabelText);
        $[60] = formatMessage;
        $[61] = t19;
    } else t19 = $[61];
    let t20;
    if ($[62] !== moveConfirm || $[63] !== t18 || $[64] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: t18,
            onClick: moveConfirm
        }, t19));
        $[62] = moveConfirm;
        $[63] = t18;
        $[64] = t19;
        $[65] = t20;
    } else t20 = $[65];
    let t21;
    if ($[66] !== t17 || $[67] !== t20 || $[68] !== t9) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            title: t9,
            product: "jira"
        }, t17, t20);
        $[66] = t17;
        $[67] = t20;
        $[68] = t9;
        $[69] = t21;
    } else t21 = $[69];
    let t22;
    if ($[70] !== formatMessage || $[71] !== shouldShowErrorMessage) {
        t22 = shouldShowErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            xcss: $5ea541ce66c636f5$var$styles.errorMessage
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            size: "small"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.danger",
            size: "small"
        }, formatMessage((0, $i4ehy.default).jiraIssueMoveButtonErrorMessageText)));
        $[70] = formatMessage;
        $[71] = shouldShowErrorMessage;
        $[72] = t22;
    } else t22 = $[72];
    let t23;
    if ($[73] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "region",
            "aria-live": "polite"
        }, t22);
        $[73] = t22;
        $[74] = t23;
    } else t23 = $[74];
    let t24;
    if ($[75] !== t21 || $[76] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.250"
        }, t21, t23);
        $[75] = t21;
        $[76] = t23;
        $[77] = t24;
    } else t24 = $[77];
    return t24;
} : ({ actions: actions, getStatus: getStatus, getReadonly: getReadonly, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedIssues, setSelectedIssues] = (0, $cozmU.useState)([]);
    const [selectedSprint, setSelectedSprint] = (0, $cozmU.useState)('');
    const [shouldShowErrorMessage, setShouldShowErrorMessage] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const firstAction = actions[0];
    const { data: { issues: issues, sprints: sprints } } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const onChangeSprint = (0, $cozmU.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ currentTarget: { value: value } })=>{
        setSelectedSprint(value);
        if (shouldShowErrorMessage) setShouldShowErrorMessage(selectedIssues.length === 0 || value === '');
    }, [
        selectedIssues.length,
        shouldShowErrorMessage
    ]);
    const handleSelectIssue = (0, $cozmU.useCallback)((issueKeys)=>{
        setSelectedIssues(issueKeys);
        if (shouldShowErrorMessage) setShouldShowErrorMessage(issueKeys.length === 0 || selectedSprint === '');
    }, [
        selectedSprint,
        shouldShowErrorMessage
    ]);
    const getSprintAnalytics = (0, $cozmU.useCallback)((sprints_0)=>{
        let sprintIndex;
        const sprint = sprints_0.find(({ sprintId: sprintId }, index)=>{
            sprintIndex = index;
            return sprintId === selectedSprint;
        });
        return [
            sprint,
            sprintIndex
        ];
    }, [
        selectedSprint
    ]);
    const moveConfirm = ()=>{
        const canMove = selectedIssues.length > 0 && selectedSprint !== '';
        if (canMove) {
            const [sprint_0, sprintIndex_0] = getSprintAnalytics(sprints);
            const moveData = {
                issues: issues.filter(({ issueKey: issueKey })=>selectedIssues.includes(issueKey)),
                sprintId: selectedSprint
            };
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveActionButton',
                attributes: {
                    recipientAgentNamedId: recipientAgentNamedId,
                    actionKey: (0, $dw75i.JIRA_ISSUE_MOVE_KEY),
                    selectedIssueCount: selectedIssues.length,
                    totalIssueCount: issues.length,
                    sprintState: sprint_0?.sprintState,
                    sprintIndex: sprintIndex_0
                }
            });
            if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $5ea541ce66c636f5$var$JIRA_ISSUE_MOVE_INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        (0, $7eUSO.buildToolFromAction)(firstAction, 'confirmed', moveData)
                    ]
                }
            });
            else onCustomDataConfirm(firstAction, moveData);
        }
        setShouldShowErrorMessage(!canMove);
    };
    if (issues.length <= 0 || sprints.length <= 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $i4ehy.default).jiraIssueMoveActionCardTitle),
        product: "jira"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $i4ehy.default).jiraIssueMoveListMessageText)), /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.IssueSelector), {
        initialIssues: issues,
        title: formatMessage((0, $i4ehy.default).jiraIssueMoveListTitleText),
        isInitiallyExpanded: true,
        onIssuesSelected: handleSelectIssue,
        readonly: readonly
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $i4ehy.default).jiraIssueMoveSprintSelectorText)), sprints.map(({ sprintId: sprintId_0, sprintName: sprintName, sprintState: sprintState })=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            key: sprintId_0,
            space: "space.100",
            alignInline: "start",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ikjJ.default), {
            isChecked: sprintId_0 === selectedSprint,
            isDisabled: readonly,
            onChange: onChangeSprint,
            name: sprintName,
            label: sprintName,
            value: sprintId_0
        }), /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: sprintState === 'ACTIVE' ? 'information' : 'neutral'
        }, sprintState)))), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: readonly || status !== 'idle',
        onClick: moveConfirm
    }, formatMessage((0, $i4ehy.default).jiraIssueMoveButtonLabelText)))), /*#__PURE__*/ $cozmU.createElement("div", {
        role: "region",
        "aria-live": "polite"
    }, shouldShowErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075",
        xcss: $5ea541ce66c636f5$var$styles.errorMessage
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.danger",
        size: "small"
    }, formatMessage((0, $i4ehy.default).jiraIssueMoveButtonErrorMessageText)))));
};
module.exports["JiraIssueMoveAction"] = $5ea541ce66c636f5$export$622c113241252e2c;

});

parcelRegister("7xBPz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $e3ecr = parcelRequire("e3ecr");


var $7eUSO = parcelRequire("7eUSO");


var $d6lfC = parcelRequire("d6lfC");


var $4gYQi = parcelRequire("4gYQi");

const $ebc6bc6fc4c58e58$var$styles = {
    negativeMarginTop: "_313842B0rP"
};
const $ebc6bc6fc4c58e58$var$JiraIssueTransitionActionNewLayout = ({ actions: actions, getReadonly: getReadonly, onCustomDataConfirm: onCustomDataConfirm, onActioned: onActioned, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $e3ecr.IssueSelector));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [selectedTransition, setSelectedTransition] = (0, $cozmU.useState)(undefined);
    const [selectedIssues, setSelectedIssues] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false); //Use transition id of first action as default transition id
    const defaultTransitionId = actions[0].data.status;
    const allActionsAreReadonly = actions.every((action)=>getReadonly(action));
    const initialIssues = actions.map((action_0)=>{
        return {
            issueKey: action_0.data.key,
            readonly: getReadonly(action_0),
            url: action_0.data.url
        };
    });
    const handleSubmit = (0, $cozmU.useCallback)(async ()=>{
        if (!selectedIssues.length || allActionsAreReadonly) return;
        let actionsToSubmit = [];
        setIsLoading(true);
        try {
            const actionsMap = new Map(actions.map((action_3)=>[
                    action_3.data.key,
                    action_3
                ]));
            actionsToSubmit = selectedIssues.map((issueKey)=>actionsMap.get(issueKey)).filter((action_4)=>action_4 !== undefined).filter((action_5)=>!getReadonly(action_5));
            if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
                const plannedActions = actions.filter((action_6)=>action_6.status === 'planned');
                const actionsToSubmitKeys = new Set(actionsToSubmit.map((action_7)=>action_7.data.key));
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: 'jiraIssueTransitionRenderer'
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: plannedActions.map((action_8)=>actionsToSubmitKeys.has(action_8.data.key) ? (0, $7eUSO.buildToolFromAction)(action_8, 'confirmed', {
                                key: action_8.data.key,
                                status: selectedTransition?.value,
                                url: action_8.data.url,
                                ari: action_8.data.ari
                            }) : (0, $7eUSO.buildToolFromAction)(action_8, 'cancelled'))
                    }
                });
                sendAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'rovoJiraIssueTransition',
                    attributes: {
                        issueCount: actionsToSubmit.length
                    }
                });
                return;
            }
            const submissionPromises = actionsToSubmit.map(async (action_9)=>{
                await onCustomDataConfirm(action_9, {
                    key: action_9.data.key,
                    status: selectedTransition?.value,
                    url: action_9.data.url,
                    ari: action_9.data.ari
                });
            });
            await Promise.all(submissionPromises);
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'rovoJiraIssueTransition',
                attributes: {
                    issueCount: actionsToSubmit.length
                }
            });
        } catch (e) {
            // TODO: remove catch block once resumption is cleaned up
            if (e instanceof Error) actionsToSubmit.forEach((action_1)=>{
                onActioned(action_1, e.message);
            });
            else actionsToSubmit.forEach((action_2)=>{
                onActioned(action_2, formatMessage((0, $d6lfC.default).jiraBulkIssueTransitionErrorMessage));
            });
        } finally{
            setIsLoading(false);
        }
    }, [
        selectedIssues,
        allActionsAreReadonly,
        actions,
        sendAnalyticsEvent,
        getReadonly,
        onCustomDataConfirm,
        selectedTransition?.value,
        onActioned,
        formatMessage,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) return;
        const plannedActions_0 = actions.filter((action_10)=>action_10.status === 'planned');
        if (!plannedActions_0.length) return;
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'jiraIssueTransitionRenderer'
            },
            confirmed_tools: {
                message_id: messageId,
                tools: plannedActions_0.map((action_11)=>(0, $7eUSO.buildToolFromAction)(action_11, 'cancelled'))
            }
        });
    }, [
        actions,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId
    ]);
    const handleSelectIssue = (0, $cozmU.useCallback)((issueKeys)=>{
        setSelectedIssues(issueKeys);
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250",
        xcss: $ebc6bc6fc4c58e58$var$styles.negativeMarginTop
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $d6lfC.default).jiraIssueTransitionTitle)), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $d6lfC.default).jiraIssueTransitionActionCardTitle),
        product: "jira"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $d6lfC.default).jiraIssueTransitionStatusTitle)), /*#__PURE__*/ $cozmU.createElement((0, $4gYQi.TransitionSelector), {
        issueAris: actions.map((action_12)=>action_12.data.ari),
        setSelectedTransition: setSelectedTransition,
        defaultTransitionId: defaultTransitionId,
        selectedTransition: selectedTransition,
        isDisabled: allActionsAreReadonly
    })), /*#__PURE__*/ $cozmU.createElement((0, $e3ecr.BulkIssueSelector), {
        initialIssues: initialIssues,
        title: formatMessage((0, $d6lfC.default).jiraIssueTransitionSelectIssuesTitle),
        onIssuesSelected: handleSelectIssue,
        readonly: allActionsAreReadonly
    })), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignInline: "end"
    }, (0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false) && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        isDisabled: allActionsAreReadonly,
        onClick: (_, e_0)=>{
            handleCancel();
            sendAnalyticsEvent(e_0.update({
                actionSubjectId: 'rovoJiraIssueTransitionCancel'
            }));
        }
    }, formatMessage((0, $d6lfC.default).jiraIssueTransitionCancel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: allActionsAreReadonly || !selectedIssues.length,
        isLoading: isLoading,
        onClick: (__0, e_1)=>{
            handleSubmit();
            sendAnalyticsEvent(e_1.update({
                actionSubjectId: 'rovoJiraIssueTransitionSubmit'
            }));
        },
        interactionName: "ai-mate.issue-bulk-transition"
    }, formatMessage((0, $d6lfC.default).jiraIssueTransitionUpdateSelectedIssues))))));
};
const $ebc6bc6fc4c58e58$export$97966b0f3cb44789 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($ebc6bc6fc4c58e58$var$JiraIssueTransitionActionNewLayout, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($ebc6bc6fc4c58e58$var$JiraIssueTransitionActionNewLayout, props);
};
module.exports["JiraIssueTransitionAction"] = $ebc6bc6fc4c58e58$export$97966b0f3cb44789;

});

parcelRegister("4kt37", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $jerDQ = parcelRequire("jerDQ");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $5wTq5 = parcelRequire("5wTq5");


var $auJoE = parcelRequire("auJoE");

const $50862b8f9972ab60$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $50862b8f9972ab60$var$sprintIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jerDQ))),
    label: "",
    appearance: "gray",
    size: "small"
});
const $50862b8f9972ab60$export$f40db127922b0641 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { actions: actions, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const action = actions[0];
    const { data: data } = action;
    let t1;
    if ($[0] !== action || $[1] !== getReadonly) {
        t1 = getReadonly(action);
        $[0] = action;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    const [isActioned, setIsActioned] = (0, $cozmU.useState)(false);
    const buttonsDisabled = isActioned || readonly;
    let t2;
    if ($[3] !== action.actionId || $[4] !== action.data || $[5] !== action.humanMessageId || $[6] !== action.invocationId || $[7] !== action.key || $[8] !== action.toolSource || $[9] !== conversationId || $[10] !== messageId || $[11] !== recipientAgentId || $[12] !== sendAnalyticsEvent || $[13] !== sendMessageConfirmedTools) {
        t2 = (resolutionType)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: resolutionType === "confirmed" ? "confirmMoveToSprintButton" : "cancelMoveToSprintButton"
            });
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: "jiraMoveToSprintAction"
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        {
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            resolution: {
                                type: resolutionType
                            },
                            data: {
                                human_message_id: action.humanMessageId ?? "",
                                arguments: action.data
                            }
                        }
                    ]
                },
                resolutionType: resolutionType
            });
            setIsActioned(true);
        };
        $[3] = action.actionId;
        $[4] = action.data;
        $[5] = action.humanMessageId;
        $[6] = action.invocationId;
        $[7] = action.key;
        $[8] = action.toolSource;
        $[9] = conversationId;
        $[10] = messageId;
        $[11] = recipientAgentId;
        $[12] = sendAnalyticsEvent;
        $[13] = sendMessageConfirmedTools;
        $[14] = t2;
    } else t2 = $[14];
    const handleAction = t2;
    let t3;
    if ($[15] !== handleAction) {
        t3 = ()=>handleAction("confirmed");
        $[15] = handleAction;
        $[16] = t3;
    } else t3 = $[16];
    const handleConfirm = t3;
    let t4;
    if ($[17] !== handleAction) {
        t4 = ()=>handleAction("cancelled");
        $[17] = handleAction;
        $[18] = t4;
    } else t4 = $[18];
    const handleCancel = t4;
    let t5;
    if ($[19] !== formatMessage) {
        t5 = formatMessage((0, $auJoE.messages).title);
        $[19] = formatMessage;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== formatMessage) {
        t6 = formatMessage((0, $auJoE.messages).sprintLabel);
        $[21] = formatMessage;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== data.sprintId || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: t6,
            value: data.sprintId
        });
        $[23] = data.sprintId;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== data.issues || $[27] !== formatMessage) {
        t8 = data.issues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: formatMessage((0, $auJoE.messages).issuesLabel, {
                count: data.issues.length
            }),
            value: data.issues.join(", ")
        });
        $[26] = data.issues;
        $[27] = formatMessage;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== t7 || $[30] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGrid), null, t7, t8);
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== formatMessage) {
        t10 = formatMessage((0, $auJoE.messages).cancelButton);
        $[32] = formatMessage;
        $[33] = t10;
    } else t10 = $[33];
    let t11;
    if ($[34] !== buttonsDisabled || $[35] !== handleCancel || $[36] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, t10);
        $[34] = buttonsDisabled;
        $[35] = handleCancel;
        $[36] = t10;
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== formatMessage) {
        t12 = formatMessage((0, $auJoE.messages).confirmButton);
        $[38] = formatMessage;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== buttonsDisabled || $[41] !== handleConfirm || $[42] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled
        }, t12);
        $[40] = buttonsDisabled;
        $[41] = handleConfirm;
        $[42] = t12;
        $[43] = t13;
    } else t13 = $[43];
    let t14;
    if ($[44] !== t11 || $[45] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $50862b8f9972ab60$var$styles.footer
        }, t11, t13));
        $[44] = t11;
        $[45] = t13;
        $[46] = t14;
    } else t14 = $[46];
    let t15;
    if ($[47] !== t14 || $[48] !== t5 || $[49] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: t5,
            headerIcon: $50862b8f9972ab60$var$sprintIcon
        }, t9, t14);
        $[47] = t14;
        $[48] = t5;
        $[49] = t9;
        $[50] = t15;
    } else t15 = $[50];
    return t15;
} : ({ actions: actions, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const action = actions[0];
    const { data: data } = action;
    const readonly = getReadonly(action);
    const [isActioned, setIsActioned] = (0, $cozmU.useState)(false);
    const buttonsDisabled = isActioned || readonly;
    const handleAction = (0, $cozmU.useCallback)((resolutionType)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: resolutionType === 'confirmed' ? 'confirmMoveToSprintButton' : 'cancelMoveToSprintButton'
        });
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'jiraMoveToSprintAction'
            },
            confirmed_tools: {
                message_id: messageId,
                tools: [
                    {
                        key: action.key,
                        tool_id: action.actionId,
                        tool_source: action.toolSource,
                        invocation_id: action.invocationId,
                        resolution: {
                            type: resolutionType
                        },
                        data: {
                            human_message_id: action.humanMessageId ?? '',
                            arguments: action.data
                        }
                    }
                ]
            },
            resolutionType: resolutionType
        });
        setIsActioned(true);
    }, [
        sendAnalyticsEvent,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        action
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(()=>handleAction('confirmed'), [
        handleAction
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>handleAction('cancelled'), [
        handleAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $auJoE.messages).title),
        headerIcon: $50862b8f9972ab60$var$sprintIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGrid), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $auJoE.messages).sprintLabel),
        value: data.sprintId
    }), data.issues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $auJoE.messages).issuesLabel, {
            count: data.issues.length
        }),
        value: data.issues.join(', ')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $50862b8f9972ab60$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $auJoE.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $auJoE.messages).confirmButton)))));
};
module.exports["JiraMoveToSprintAction"] = $50862b8f9972ab60$export$f40db127922b0641;

});

parcelRegister("3cDnE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $dgT8C = parcelRequire("dgT8C");

const $dfcb2edcc0dba006$var$INTERACTION_SOURCE = 'jiraPlansAddDependencyRenderer';
const $dfcb2edcc0dba006$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS",
    cardWrapper: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    issueCard: "_2mHwu82ADO _30huDKOeNX _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE",
    issueTypeIcon: "_39xV02ey7F _0jFU0Vey7F",
    line: "_39xV024Jdh _0jFU0VxpxF _0KLXru4YkS",
    iconCircle: "_0bjKvDS5Zs _39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXru4YkS _1UtDYze5R3",
    separatorColumn: "_0GTcwR2ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
};
const $dfcb2edcc0dba006$export$ea7294906518b041 = (actions)=>{
    const filteredActions = actions.filter((action)=>$dfcb2edcc0dba006$var$assertIsAddDependencyAction(action));
    return filteredActions;
};
const $dfcb2edcc0dba006$var$assertIsAddDependencyAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_ADD_DEPENDENCY_KEY))) throw new Error('Invalid action key for AddDependencyAction');
    return action;
};
const $dfcb2edcc0dba006$export$e059c8cf08df5017 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $dfcb2edcc0dba006$export$ea7294906518b041(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($dfcb2edcc0dba006$var$AddDependencyActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$dfcb2edcc0dba006$export$ea7294906518b041(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($dfcb2edcc0dba006$var$AddDependencyActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $dfcb2edcc0dba006$var$AddDependencyActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(76);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== data) {
        t1 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[3] = data;
        $[4] = t1;
    } else t1 = $[4];
    const actionData = t1;
    let t2;
    if ($[5] !== firstAction || $[6] !== getReadonly) {
        t2 = getReadonly(firstAction);
        $[5] = firstAction;
        $[6] = getReadonly;
        $[7] = t2;
    } else t2 = $[7];
    const readonly = t2;
    let t3;
    if ($[8] !== firstAction || $[9] !== getStatus) {
        t3 = getStatus(firstAction);
        $[8] = firstAction;
        $[9] = getStatus;
        $[10] = t3;
    } else t3 = $[10];
    const status = t3;
    const t4 = String(status ?? "");
    let t5;
    if ($[11] !== t4) {
        t5 = t4.toLowerCase();
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const invocationStatus = t5;
    const t6 = String(firstAction.status ?? "");
    let t7;
    if ($[13] !== t6) {
        t7 = t6.toLowerCase();
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const actionStatus = t7;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t8;
    if ($[15] !== actionData.planId || $[16] !== actionData.scenarioId || $[17] !== actions || $[18] !== conversationId || $[19] !== firstAction || $[20] !== getStatus || $[21] !== isCustomAgent || $[22] !== messageId || $[23] !== onConfirm || $[24] !== recipientAgentId || $[25] !== sendAnalyticsEvent || $[26] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-add-dependency-confirm",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $dfcb2edcc0dba006$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.planId;
        $[16] = actionData.scenarioId;
        $[17] = actions;
        $[18] = conversationId;
        $[19] = firstAction;
        $[20] = getStatus;
        $[21] = isCustomAgent;
        $[22] = messageId;
        $[23] = onConfirm;
        $[24] = recipientAgentId;
        $[25] = sendAnalyticsEvent;
        $[26] = sendMessageConfirmedTools;
        $[27] = t8;
    } else t8 = $[27];
    const handleConfirm = t8;
    let t9;
    if ($[28] !== actionData.planId || $[29] !== actionData.scenarioId || $[30] !== actions || $[31] !== conversationId || $[32] !== firstAction || $[33] !== getStatus || $[34] !== isCustomAgent || $[35] !== messageId || $[36] !== onCancel || $[37] !== recipientAgentId || $[38] !== sendAnalyticsEvent || $[39] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-add-dependency-cancel",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $dfcb2edcc0dba006$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($dfcb2edcc0dba006$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[28] = actionData.planId;
        $[29] = actionData.scenarioId;
        $[30] = actions;
        $[31] = conversationId;
        $[32] = firstAction;
        $[33] = getStatus;
        $[34] = isCustomAgent;
        $[35] = messageId;
        $[36] = onCancel;
        $[37] = recipientAgentId;
        $[38] = sendAnalyticsEvent;
        $[39] = sendMessageConfirmedTools;
        $[40] = t9;
    } else t9 = $[40];
    const handleCancel = t9;
    const issueCard = $dfcb2edcc0dba006$var$_temp2;
    let t10;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.separatorColumn
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.line
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.iconCircle
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        })), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.line
            ])
        }));
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== actionData.dependencyTypeName || $[43] !== formatMessage) {
        t11 = actionData.dependencyTypeName ?? formatMessage((0, $dgT8C.default).dependencyTypeBlocks);
        $[42] = actionData.dependencyTypeName;
        $[43] = formatMessage;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t10, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, t11));
        $[45] = t11;
        $[46] = t12;
    } else t12 = $[46];
    const separator = t12;
    if (!actionData.planId) return null;
    let t13;
    if ($[47] !== formatMessage) {
        t13 = formatMessage((0, $dgT8C.default).cardTitle);
        $[47] = formatMessage;
        $[48] = t13;
    } else t13 = $[48];
    let t14;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $hekY6.default)([
            $dfcb2edcc0dba006$var$styles.cardWrapper
        ]);
        $[49] = t14;
    } else t14 = $[49];
    let t15;
    if ($[50] !== actionData.sourceItemKey || $[51] !== actionData.sourceItemSummary || $[52] !== actionData.sourceItemTypeIcon) {
        t15 = issueCard(actionData.sourceItemKey, actionData.sourceItemSummary, actionData.sourceItemTypeIcon);
        $[50] = actionData.sourceItemKey;
        $[51] = actionData.sourceItemSummary;
        $[52] = actionData.sourceItemTypeIcon;
        $[53] = t15;
    } else t15 = $[53];
    let t16;
    if ($[54] !== actionData.targetItemKey || $[55] !== actionData.targetItemSummary || $[56] !== actionData.targetItemTypeIcon) {
        t16 = issueCard(actionData.targetItemKey, actionData.targetItemSummary, actionData.targetItemTypeIcon);
        $[54] = actionData.targetItemKey;
        $[55] = actionData.targetItemSummary;
        $[56] = actionData.targetItemTypeIcon;
        $[57] = t16;
    } else t16 = $[57];
    let t17;
    if ($[58] !== separator || $[59] !== t15 || $[60] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: "space.0"
        }, t15, separator, t16);
        $[58] = separator;
        $[59] = t15;
        $[60] = t16;
        $[61] = t17;
    } else t17 = $[61];
    let t18;
    if ($[62] !== t14 || $[63] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t14
        }, t17);
        $[62] = t14;
        $[63] = t17;
        $[64] = t18;
    } else t18 = $[64];
    let t19;
    if ($[65] !== buttonsDisabled || $[66] !== formatMessage || $[67] !== handleCancel || $[68] !== handleConfirm || $[69] !== isActionFinished || $[70] !== isSubmitting) {
        t19 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dfcb2edcc0dba006$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $dgT8C.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $dgT8C.default).confirmButton))));
        $[65] = buttonsDisabled;
        $[66] = formatMessage;
        $[67] = handleCancel;
        $[68] = handleConfirm;
        $[69] = isActionFinished;
        $[70] = isSubmitting;
        $[71] = t19;
    } else t19 = $[71];
    let t20;
    if ($[72] !== t13 || $[73] !== t18 || $[74] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t13,
            product: "plan"
        }, t18, t19);
        $[72] = t13;
        $[73] = t18;
        $[74] = t19;
        $[75] = t20;
    } else t20 = $[75];
    return t20;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-add-dependency-confirm',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $dfcb2edcc0dba006$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-add-dependency-cancel',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $dfcb2edcc0dba006$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const issueCard = (0, $cozmU.useCallback)((itemKey, itemSummary, itemTypeIcon)=>/*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.issueCard
            ])
        }, itemTypeIcon ? /*#__PURE__*/ $cozmU.createElement("img", {
            src: itemTypeIcon,
            alt: "",
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.issueTypeIcon
            ])
        }) : null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.accent.blue",
            weight: "semibold"
        }, itemKey), itemSummary ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, itemSummary) : null), []);
    const separator = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.separatorColumn
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.line
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.iconCircle
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        })), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dfcb2edcc0dba006$var$styles.line
            ])
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, actionData.dependencyTypeName ?? formatMessage((0, $dgT8C.default).dependencyTypeBlocks))), [
        actionData.dependencyTypeName,
        formatMessage
    ]);
    if (!actionData.planId) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $dgT8C.default).cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $dfcb2edcc0dba006$var$styles.cardWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: "space.0"
    }, issueCard(actionData.sourceItemKey, actionData.sourceItemSummary, actionData.sourceItemTypeIcon), separator, issueCard(actionData.targetItemKey, actionData.targetItemSummary, actionData.targetItemTypeIcon))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $dfcb2edcc0dba006$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $dgT8C.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $dgT8C.default).confirmButton)))));
};
function $dfcb2edcc0dba006$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
function $dfcb2edcc0dba006$var$_temp2(itemKey, itemSummary, itemTypeIcon) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $dfcb2edcc0dba006$var$styles.issueCard
        ])
    }, itemTypeIcon ? /*#__PURE__*/ $cozmU.createElement("img", {
        src: itemTypeIcon,
        alt: "",
        className: (0, $hekY6.default)([
            $dfcb2edcc0dba006$var$styles.issueTypeIcon
        ])
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.accent.blue",
        weight: "semibold"
    }, itemKey), itemSummary ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, itemSummary) : null);
}
module.exports["AddDependencyAction"] = $dfcb2edcc0dba006$export$e059c8cf08df5017;

});

parcelRegister("jw6cP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $4MdqE = parcelRequire("4MdqE");


var $lSQgn = parcelRequire("lSQgn");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $esN88 = parcelRequire("esN88");


var $lRbe2 = parcelRequire("lRbe2");


var $5wTq5 = parcelRequire("5wTq5");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $7PIET = parcelRequire("7PIET");

const $76753ef3bbc23d86$var$INTERACTION_SOURCE = 'jiraPlansAddProgramBoardRenderer';
const $76753ef3bbc23d86$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $76753ef3bbc23d86$export$5bc0a11662274da9 = (actions)=>{
    const filteredActions = actions.filter((action)=>$76753ef3bbc23d86$var$assertIsAddProgramBoardAction(action));
    return filteredActions;
};
const $76753ef3bbc23d86$var$assertIsAddProgramBoardAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_ADD_PROGRAM_BOARD_KEY))) throw new Error('Invalid action key for AddProgramBoardAction');
    return action;
};
const $76753ef3bbc23d86$export$a265c3129516547e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $76753ef3bbc23d86$export$5bc0a11662274da9(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($76753ef3bbc23d86$var$AddProgramBoardActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$76753ef3bbc23d86$export$5bc0a11662274da9(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($76753ef3bbc23d86$var$AddProgramBoardActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $76753ef3bbc23d86$var$AddProgramBoardActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(88);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t1;
    } else t1 = $[5];
    const readonly = t1;
    let t2;
    if ($[6] !== firstAction || $[7] !== getStatus) {
        t2 = getStatus(firstAction);
        $[6] = firstAction;
        $[7] = getStatus;
        $[8] = t2;
    } else t2 = $[8];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[9] !== t3) {
        t4 = t3.toLowerCase();
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[11] !== t5) {
        t6 = t5.toLowerCase();
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actionStatus = t6;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t7;
    if ($[13] !== data) {
        t7 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[13] = data;
        $[14] = t7;
    } else t7 = $[14];
    const actionData = t7;
    let t8;
    if ($[15] !== actionData.name || $[16] !== actionData.planId || $[17] !== actionData.planName || $[18] !== actions || $[19] !== conversationId || $[20] !== firstAction || $[21] !== getStatus || $[22] !== isCustomAgent || $[23] !== messageId || $[24] !== onConfirm || $[25] !== recipientAgentId || $[26] !== sendAnalyticsEvent || $[27] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-add-program-board-confirm",
                    planId: actionData.planId,
                    planName: actionData.planName,
                    programBoardName: actionData.name
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $76753ef3bbc23d86$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.name;
        $[16] = actionData.planId;
        $[17] = actionData.planName;
        $[18] = actions;
        $[19] = conversationId;
        $[20] = firstAction;
        $[21] = getStatus;
        $[22] = isCustomAgent;
        $[23] = messageId;
        $[24] = onConfirm;
        $[25] = recipientAgentId;
        $[26] = sendAnalyticsEvent;
        $[27] = sendMessageConfirmedTools;
        $[28] = t8;
    } else t8 = $[28];
    const handleConfirm = t8;
    let t9;
    if ($[29] !== actionData.planId || $[30] !== actionData.planName || $[31] !== actions || $[32] !== conversationId || $[33] !== firstAction || $[34] !== getStatus || $[35] !== isCustomAgent || $[36] !== messageId || $[37] !== onCancel || $[38] !== recipientAgentId || $[39] !== sendAnalyticsEvent || $[40] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-add-program-board-cancel",
                    planId: actionData.planId,
                    planName: actionData.planName
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $76753ef3bbc23d86$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($76753ef3bbc23d86$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[29] = actionData.planId;
        $[30] = actionData.planName;
        $[31] = actions;
        $[32] = conversationId;
        $[33] = firstAction;
        $[34] = getStatus;
        $[35] = isCustomAgent;
        $[36] = messageId;
        $[37] = onCancel;
        $[38] = recipientAgentId;
        $[39] = sendAnalyticsEvent;
        $[40] = sendMessageConfirmedTools;
        $[41] = t9;
    } else t9 = $[41];
    const handleCancel = t9;
    let t10;
    if ($[42] !== formatDate) {
        t10 = (start)=>formatDate(start, {
                month: "numeric",
                day: "numeric",
                year: "2-digit",
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            }).replace("AM", "am").replace("PM", "pm");
        $[42] = formatDate;
        $[43] = t10;
    } else t10 = $[43];
    const formatStartDate = t10;
    if (!actionData.name || actionData.start === undefined || actionData.iterationLength === undefined || actionData.iterationsCount === undefined) return null;
    let t11;
    if ($[44] !== formatMessage) {
        t11 = formatMessage((0, $7PIET.default).cardTitle);
        $[44] = formatMessage;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
        });
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] !== actionData.name) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
            icon: t12,
            title: actionData.name
        });
        $[47] = actionData.name;
        $[48] = t13;
    } else t13 = $[48];
    let t14;
    if ($[49] !== formatMessage) {
        t14 = formatMessage((0, $7PIET.default).startDateLabel);
        $[49] = formatMessage;
        $[50] = t14;
    } else t14 = $[50];
    const t15 = `${t14}:`;
    let t16;
    if ($[51] !== actionData.start || $[52] !== formatStartDate) {
        t16 = formatStartDate(actionData.start);
        $[51] = actionData.start;
        $[52] = formatStartDate;
        $[53] = t16;
    } else t16 = $[53];
    let t17;
    if ($[54] !== t15 || $[55] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t15,
            value: t16
        });
        $[54] = t15;
        $[55] = t16;
        $[56] = t17;
    } else t17 = $[56];
    let t18;
    if ($[57] !== formatMessage) {
        t18 = formatMessage((0, $7PIET.default).columnDurationLabel);
        $[57] = formatMessage;
        $[58] = t18;
    } else t18 = $[58];
    const t19 = `${t18}:`;
    let t20;
    if ($[59] !== actionData.iterationLength || $[60] !== formatMessage) {
        t20 = formatMessage((0, $7PIET.default).columnDurationValue, {
            count: actionData.iterationLength
        });
        $[59] = actionData.iterationLength;
        $[60] = formatMessage;
        $[61] = t20;
    } else t20 = $[61];
    let t21;
    if ($[62] !== t19 || $[63] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t19,
            value: t20
        });
        $[62] = t19;
        $[63] = t20;
        $[64] = t21;
    } else t21 = $[64];
    let t22;
    if ($[65] !== formatMessage) {
        t22 = formatMessage((0, $7PIET.default).numberOfColumnsLabel);
        $[65] = formatMessage;
        $[66] = t22;
    } else t22 = $[66];
    const t23 = `${t22}:`;
    const t24 = String(actionData.iterationsCount);
    let t25;
    if ($[67] !== t23 || $[68] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t23,
            value: t24
        });
        $[67] = t23;
        $[68] = t24;
        $[69] = t25;
    } else t25 = $[69];
    let t26;
    if ($[70] !== t17 || $[71] !== t21 || $[72] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, t17, t21, t25);
        $[70] = t17;
        $[71] = t21;
        $[72] = t25;
        $[73] = t26;
    } else t26 = $[73];
    let t27;
    if ($[74] !== t13 || $[75] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, t13, t26);
        $[74] = t13;
        $[75] = t26;
        $[76] = t27;
    } else t27 = $[76];
    let t28;
    if ($[77] !== buttonsDisabled || $[78] !== formatMessage || $[79] !== handleCancel || $[80] !== handleConfirm || $[81] !== isActionFinished || $[82] !== isSubmitting) {
        t28 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $76753ef3bbc23d86$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $7PIET.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $7PIET.default).confirmButton))));
        $[77] = buttonsDisabled;
        $[78] = formatMessage;
        $[79] = handleCancel;
        $[80] = handleConfirm;
        $[81] = isActionFinished;
        $[82] = isSubmitting;
        $[83] = t28;
    } else t28 = $[83];
    let t29;
    if ($[84] !== t11 || $[85] !== t27 || $[86] !== t28) {
        t29 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t11,
            product: "plan"
        }, t27, t28);
        $[84] = t11;
        $[85] = t27;
        $[86] = t28;
        $[87] = t29;
    } else t29 = $[87];
    return t29;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-add-program-board-confirm',
                planId: actionData.planId,
                planName: actionData.planName,
                programBoardName: actionData.name
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $76753ef3bbc23d86$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-add-program-board-cancel',
                planId: actionData.planId,
                planName: actionData.planName
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $76753ef3bbc23d86$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const formatStartDate = (0, $cozmU.useCallback)((start)=>formatDate(start, {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).replace('AM', 'am').replace('PM', 'pm'), [
        formatDate
    ]);
    if (!actionData.name || actionData.start === undefined || actionData.iterationLength === undefined || actionData.iterationsCount === undefined) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $7PIET.default).cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
        icon: /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
        }),
        title: actionData.name
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $7PIET.default).startDateLabel)}:`,
        value: formatStartDate(actionData.start)
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $7PIET.default).columnDurationLabel)}:`,
        value: formatMessage((0, $7PIET.default).columnDurationValue, {
            count: actionData.iterationLength
        })
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $7PIET.default).numberOfColumnsLabel)}:`,
        value: String(actionData.iterationsCount)
    }))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $76753ef3bbc23d86$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $7PIET.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $7PIET.default).confirmButton)))));
};
function $76753ef3bbc23d86$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
module.exports["AddProgramBoardAction"] = $76753ef3bbc23d86$export$a265c3129516547e;

});

parcelRegister("lLxBZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iFXu4 = parcelRequire("iFXu4");


var $2F2yY = parcelRequire("2F2yY");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $9NPFC = parcelRequire("9NPFC");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $esN88 = parcelRequire("esN88");


var $lRbe2 = parcelRequire("lRbe2");


var $5wTq5 = parcelRequire("5wTq5");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $ldf48 = parcelRequire("ldf48");

const $c5128a99788e4eac$var$INTERACTION_SOURCE = 'jiraPlansCreateReleaseRenderer';
const $c5128a99788e4eac$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $c5128a99788e4eac$var$parsePlanDate = (date)=>{
    if (!date) return undefined;
    const [year, month, day] = date.split('-').map(Number);
    if (!year || !month || !day) return undefined;
    return new Date(year, month - 1, day);
};
const $c5128a99788e4eac$export$35d510b28e164adf = (actions)=>{
    const filteredActions = actions.filter((action)=>$c5128a99788e4eac$var$assertIsCreateReleaseAction(action));
    return filteredActions;
};
const $c5128a99788e4eac$var$assertIsCreateReleaseAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_CREATE_RELEASE_KEY))) throw new Error('Invalid action key for CreateReleaseAction');
    return action;
};
const $c5128a99788e4eac$export$25a4d69c8b85b40e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $c5128a99788e4eac$export$35d510b28e164adf(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($c5128a99788e4eac$var$CreateReleaseActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$c5128a99788e4eac$export$35d510b28e164adf(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($c5128a99788e4eac$var$CreateReleaseActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $c5128a99788e4eac$var$CreateReleaseActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(92);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t1;
    } else t1 = $[5];
    const readonly = t1;
    let t2;
    if ($[6] !== firstAction || $[7] !== getStatus) {
        t2 = getStatus(firstAction);
        $[6] = firstAction;
        $[7] = getStatus;
        $[8] = t2;
    } else t2 = $[8];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[9] !== t3) {
        t4 = t3.toLowerCase();
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[11] !== t5) {
        t6 = t5.toLowerCase();
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actionStatus = t6;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t7;
    if ($[13] !== data) {
        t7 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[13] = data;
        $[14] = t7;
    } else t7 = $[14];
    const actionData = t7;
    let t8;
    if ($[15] !== actionData.name || $[16] !== actionData.planId || $[17] !== actionData.scenarioId || $[18] !== actions || $[19] !== conversationId || $[20] !== firstAction || $[21] !== getStatus || $[22] !== isCustomAgent || $[23] !== messageId || $[24] !== onConfirm || $[25] !== recipientAgentId || $[26] !== sendAnalyticsEvent || $[27] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-create-release-confirm",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId,
                    name: actionData.name
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $c5128a99788e4eac$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.name;
        $[16] = actionData.planId;
        $[17] = actionData.scenarioId;
        $[18] = actions;
        $[19] = conversationId;
        $[20] = firstAction;
        $[21] = getStatus;
        $[22] = isCustomAgent;
        $[23] = messageId;
        $[24] = onConfirm;
        $[25] = recipientAgentId;
        $[26] = sendAnalyticsEvent;
        $[27] = sendMessageConfirmedTools;
        $[28] = t8;
    } else t8 = $[28];
    const handleConfirm = t8;
    let t9;
    if ($[29] !== actionData.planId || $[30] !== actionData.scenarioId || $[31] !== actions || $[32] !== conversationId || $[33] !== firstAction || $[34] !== getStatus || $[35] !== isCustomAgent || $[36] !== messageId || $[37] !== onCancel || $[38] !== recipientAgentId || $[39] !== sendAnalyticsEvent || $[40] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-create-release-cancel",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $c5128a99788e4eac$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($c5128a99788e4eac$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[29] = actionData.planId;
        $[30] = actionData.scenarioId;
        $[31] = actions;
        $[32] = conversationId;
        $[33] = firstAction;
        $[34] = getStatus;
        $[35] = isCustomAgent;
        $[36] = messageId;
        $[37] = onCancel;
        $[38] = recipientAgentId;
        $[39] = sendAnalyticsEvent;
        $[40] = sendMessageConfirmedTools;
        $[41] = t9;
    } else t9 = $[41];
    const handleCancel = t9;
    let t10;
    if ($[42] !== actionData.projectAvatarUrl) {
        t10 = actionData.projectAvatarUrl ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "xsmall",
            isInset: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.projectAvatarUrl,
            alt: ""
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "xsmall",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFXu4)))
        });
        $[42] = actionData.projectAvatarUrl;
        $[43] = t10;
    } else t10 = $[43];
    let t11;
    if ($[44] !== actionData.projectName) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, actionData.projectName);
        $[44] = actionData.projectName;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== t10 || $[47] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t10, t11);
        $[46] = t10;
        $[47] = t11;
        $[48] = t12;
    } else t12 = $[48];
    const space = t12;
    let startDateValue;
    let t13;
    if ($[49] !== actionData.end || $[50] !== actionData.start || $[51] !== formatDate || $[52] !== formatMessage) {
        const startDate = $c5128a99788e4eac$var$parsePlanDate(actionData.start);
        const releaseDate = $c5128a99788e4eac$var$parsePlanDate(actionData.end);
        startDateValue = startDate ? formatDate(startDate, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        }) : formatMessage((0, $ldf48.default).asEarlyAsPossible);
        t13 = releaseDate ? formatDate(releaseDate, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        }) : formatMessage((0, $ldf48.default).noReleaseDate);
        $[49] = actionData.end;
        $[50] = actionData.start;
        $[51] = formatDate;
        $[52] = formatMessage;
        $[53] = startDateValue;
        $[54] = t13;
    } else {
        startDateValue = $[53];
        t13 = $[54];
    }
    const releaseDateValue = t13;
    if (!actionData.name) return null;
    let t14;
    if ($[55] !== formatMessage) {
        t14 = formatMessage((0, $ldf48.default).cardTitle);
        $[55] = formatMessage;
        $[56] = t14;
    } else t14 = $[56];
    let t15;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2F2yY)))
        });
        $[57] = t15;
    } else t15 = $[57];
    let t16;
    if ($[58] !== actionData.name) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
            icon: t15,
            title: actionData.name
        });
        $[58] = actionData.name;
        $[59] = t16;
    } else t16 = $[59];
    let t17;
    if ($[60] !== actionData.projectName || $[61] !== formatMessage || $[62] !== space) {
        t17 = actionData.projectName && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: `${formatMessage((0, $ldf48.default).spaceLabel)}:`,
            value: space
        });
        $[60] = actionData.projectName;
        $[61] = formatMessage;
        $[62] = space;
        $[63] = t17;
    } else t17 = $[63];
    let t18;
    if ($[64] !== formatMessage) {
        t18 = formatMessage((0, $ldf48.default).startDateLabel);
        $[64] = formatMessage;
        $[65] = t18;
    } else t18 = $[65];
    const t19 = `${t18}:`;
    let t20;
    if ($[66] !== startDateValue || $[67] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t19,
            value: startDateValue
        });
        $[66] = startDateValue;
        $[67] = t19;
        $[68] = t20;
    } else t20 = $[68];
    let t21;
    if ($[69] !== formatMessage) {
        t21 = formatMessage((0, $ldf48.default).releaseDateLabel);
        $[69] = formatMessage;
        $[70] = t21;
    } else t21 = $[70];
    const t22 = `${t21}:`;
    let t23;
    if ($[71] !== releaseDateValue || $[72] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t22,
            value: releaseDateValue
        });
        $[71] = releaseDateValue;
        $[72] = t22;
        $[73] = t23;
    } else t23 = $[73];
    let t24;
    if ($[74] !== t17 || $[75] !== t20 || $[76] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, t17, t20, t23);
        $[74] = t17;
        $[75] = t20;
        $[76] = t23;
        $[77] = t24;
    } else t24 = $[77];
    let t25;
    if ($[78] !== t16 || $[79] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, t16, t24);
        $[78] = t16;
        $[79] = t24;
        $[80] = t25;
    } else t25 = $[80];
    let t26;
    if ($[81] !== buttonsDisabled || $[82] !== formatMessage || $[83] !== handleCancel || $[84] !== handleConfirm || $[85] !== isActionFinished || $[86] !== isSubmitting) {
        t26 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c5128a99788e4eac$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $ldf48.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $ldf48.default).confirmButton))));
        $[81] = buttonsDisabled;
        $[82] = formatMessage;
        $[83] = handleCancel;
        $[84] = handleConfirm;
        $[85] = isActionFinished;
        $[86] = isSubmitting;
        $[87] = t26;
    } else t26 = $[87];
    let t27;
    if ($[88] !== t14 || $[89] !== t25 || $[90] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t14,
            product: "plan"
        }, t25, t26);
        $[88] = t14;
        $[89] = t25;
        $[90] = t26;
        $[91] = t27;
    } else t27 = $[91];
    return t27;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-create-release-confirm',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId,
                name: actionData.name
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $c5128a99788e4eac$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-create-release-cancel',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $c5128a99788e4eac$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const space = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, actionData.projectAvatarUrl ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "xsmall",
            isInset: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.projectAvatarUrl,
            alt: ""
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "xsmall",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFXu4)))
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, actionData.projectName)), [
        actionData.projectAvatarUrl,
        actionData.projectName
    ]);
    const startDate = $c5128a99788e4eac$var$parsePlanDate(actionData.start);
    const releaseDate = $c5128a99788e4eac$var$parsePlanDate(actionData.end);
    const startDateValue = startDate ? formatDate(startDate, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }) : formatMessage((0, $ldf48.default).asEarlyAsPossible);
    const releaseDateValue = releaseDate ? formatDate(releaseDate, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }) : formatMessage((0, $ldf48.default).noReleaseDate);
    if (!actionData.name) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $ldf48.default).cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
        icon: /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2F2yY)))
        }),
        title: actionData.name
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, actionData.projectName && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $ldf48.default).spaceLabel)}:`,
        value: space
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $ldf48.default).startDateLabel)}:`,
        value: startDateValue
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $ldf48.default).releaseDateLabel)}:`,
        value: releaseDateValue
    }))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c5128a99788e4eac$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $ldf48.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $ldf48.default).confirmButton)))));
};
function $c5128a99788e4eac$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
module.exports["CreateReleaseAction"] = $c5128a99788e4eac$export$25a4d69c8b85b40e;

});

parcelRegister("8TK0r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iFXu4 = parcelRequire("iFXu4");


var $iRFKG = parcelRequire("iRFKG");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $9NPFC = parcelRequire("9NPFC");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $esN88 = parcelRequire("esN88");


var $lRbe2 = parcelRequire("lRbe2");


var $5wTq5 = parcelRequire("5wTq5");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $99tpl = parcelRequire("99tpl");

const $6e8114e9e687d8e8$var$INTERACTION_SOURCE = 'jiraPlansCreateWorkItemRenderer';
const $6e8114e9e687d8e8$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $6e8114e9e687d8e8$export$7a5cfcb3281dd4f1 = (actions)=>{
    const filteredActions = actions.filter((action)=>$6e8114e9e687d8e8$var$assertIsCreateWorkItemAction(action));
    return filteredActions;
};
const $6e8114e9e687d8e8$var$assertIsCreateWorkItemAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_CREATE_WORK_ITEM_KEY))) throw new Error('Invalid action key for CreateWorkItemAction');
    return action;
};
const $6e8114e9e687d8e8$export$d570fa642ea18e5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $6e8114e9e687d8e8$export$7a5cfcb3281dd4f1(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($6e8114e9e687d8e8$var$CreateWorkItemActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$6e8114e9e687d8e8$export$7a5cfcb3281dd4f1(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($6e8114e9e687d8e8$var$CreateWorkItemActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $6e8114e9e687d8e8$var$CreateWorkItemActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(85);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t1;
    } else t1 = $[5];
    const readonly = t1;
    let t2;
    if ($[6] !== firstAction || $[7] !== getStatus) {
        t2 = getStatus(firstAction);
        $[6] = firstAction;
        $[7] = getStatus;
        $[8] = t2;
    } else t2 = $[8];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[9] !== t3) {
        t4 = t3.toLowerCase();
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[11] !== t5) {
        t6 = t5.toLowerCase();
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actionStatus = t6;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t7;
    if ($[13] !== data) {
        t7 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[13] = data;
        $[14] = t7;
    } else t7 = $[14];
    const actionData = t7;
    let t8;
    if ($[15] !== actionData.planId || $[16] !== actionData.scenarioId || $[17] !== actionData.summary || $[18] !== actions || $[19] !== conversationId || $[20] !== firstAction || $[21] !== getStatus || $[22] !== isCustomAgent || $[23] !== messageId || $[24] !== onConfirm || $[25] !== recipientAgentId || $[26] !== sendAnalyticsEvent || $[27] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-create-work-item-confirm",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId,
                    summary: actionData.summary
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $6e8114e9e687d8e8$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.planId;
        $[16] = actionData.scenarioId;
        $[17] = actionData.summary;
        $[18] = actions;
        $[19] = conversationId;
        $[20] = firstAction;
        $[21] = getStatus;
        $[22] = isCustomAgent;
        $[23] = messageId;
        $[24] = onConfirm;
        $[25] = recipientAgentId;
        $[26] = sendAnalyticsEvent;
        $[27] = sendMessageConfirmedTools;
        $[28] = t8;
    } else t8 = $[28];
    const handleConfirm = t8;
    let t9;
    if ($[29] !== actionData.planId || $[30] !== actionData.scenarioId || $[31] !== actions || $[32] !== conversationId || $[33] !== firstAction || $[34] !== getStatus || $[35] !== isCustomAgent || $[36] !== messageId || $[37] !== onCancel || $[38] !== recipientAgentId || $[39] !== sendAnalyticsEvent || $[40] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-create-work-item-cancel",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $6e8114e9e687d8e8$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($6e8114e9e687d8e8$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[29] = actionData.planId;
        $[30] = actionData.scenarioId;
        $[31] = actions;
        $[32] = conversationId;
        $[33] = firstAction;
        $[34] = getStatus;
        $[35] = isCustomAgent;
        $[36] = messageId;
        $[37] = onCancel;
        $[38] = recipientAgentId;
        $[39] = sendAnalyticsEvent;
        $[40] = sendMessageConfirmedTools;
        $[41] = t9;
    } else t9 = $[41];
    const handleCancel = t9;
    let t10;
    if ($[42] !== actionData.workTypeIconUrl) {
        t10 = actionData.workTypeIconUrl ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.workTypeIconUrl,
            alt: ""
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG)))
        });
        $[42] = actionData.workTypeIconUrl;
        $[43] = t10;
    } else t10 = $[43];
    const icon = t10;
    let t11;
    if ($[44] !== actionData.sourceAvatarUrl) {
        t11 = actionData.sourceAvatarUrl ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "xsmall",
            isInset: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.sourceAvatarUrl,
            alt: ""
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "xsmall",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFXu4)))
        });
        $[44] = actionData.sourceAvatarUrl;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== actionData.sourceName) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, actionData.sourceName);
        $[46] = actionData.sourceName;
        $[47] = t12;
    } else t12 = $[47];
    let t13;
    if ($[48] !== t11 || $[49] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t11, t12);
        $[48] = t11;
        $[49] = t12;
        $[50] = t13;
    } else t13 = $[50];
    const space = t13;
    if (!actionData.summary || !actionData.sourceName) return null;
    let t14;
    if ($[51] !== formatMessage) {
        t14 = formatMessage((0, $99tpl.default).cardTitle);
        $[51] = formatMessage;
        $[52] = t14;
    } else t14 = $[52];
    let t15;
    if ($[53] !== actionData.summary || $[54] !== icon) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
            icon: icon,
            title: actionData.summary
        });
        $[53] = actionData.summary;
        $[54] = icon;
        $[55] = t15;
    } else t15 = $[55];
    let t16;
    if ($[56] !== formatMessage) {
        t16 = formatMessage((0, $99tpl.default).spaceLabel);
        $[56] = formatMessage;
        $[57] = t16;
    } else t16 = $[57];
    const t17 = `${t16}:`;
    let t18;
    if ($[58] !== space || $[59] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t17,
            value: space
        });
        $[58] = space;
        $[59] = t17;
        $[60] = t18;
    } else t18 = $[60];
    let t19;
    if ($[61] !== actionData.priority || $[62] !== formatMessage) {
        t19 = actionData.priority && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: `${formatMessage((0, $99tpl.default).priorityLabel)}:`,
            value: actionData.priority
        });
        $[61] = actionData.priority;
        $[62] = formatMessage;
        $[63] = t19;
    } else t19 = $[63];
    let t20;
    if ($[64] !== actionData.assigneeName || $[65] !== formatMessage) {
        t20 = actionData.assigneeName && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: `${formatMessage((0, $99tpl.default).assigneeLabel)}:`,
            value: actionData.assigneeName
        });
        $[64] = actionData.assigneeName;
        $[65] = formatMessage;
        $[66] = t20;
    } else t20 = $[66];
    let t21;
    if ($[67] !== t18 || $[68] !== t19 || $[69] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, t18, t19, t20);
        $[67] = t18;
        $[68] = t19;
        $[69] = t20;
        $[70] = t21;
    } else t21 = $[70];
    let t22;
    if ($[71] !== t15 || $[72] !== t21) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, t15, t21);
        $[71] = t15;
        $[72] = t21;
        $[73] = t22;
    } else t22 = $[73];
    let t23;
    if ($[74] !== buttonsDisabled || $[75] !== formatMessage || $[76] !== handleCancel || $[77] !== handleConfirm || $[78] !== isActionFinished || $[79] !== isSubmitting) {
        t23 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6e8114e9e687d8e8$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $99tpl.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $99tpl.default).confirmButton))));
        $[74] = buttonsDisabled;
        $[75] = formatMessage;
        $[76] = handleCancel;
        $[77] = handleConfirm;
        $[78] = isActionFinished;
        $[79] = isSubmitting;
        $[80] = t23;
    } else t23 = $[80];
    let t24;
    if ($[81] !== t14 || $[82] !== t22 || $[83] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t14,
            product: "plan"
        }, t22, t23);
        $[81] = t14;
        $[82] = t22;
        $[83] = t23;
        $[84] = t24;
    } else t24 = $[84];
    return t24;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-create-work-item-confirm',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId,
                summary: actionData.summary
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $6e8114e9e687d8e8$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-create-work-item-cancel',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $6e8114e9e687d8e8$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const icon = (0, $cozmU.useMemo)(()=>actionData.workTypeIconUrl ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.workTypeIconUrl,
            alt: ""
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG)))
        }), [
        actionData.workTypeIconUrl
    ]);
    const space = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, actionData.sourceAvatarUrl ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "xsmall",
            isInset: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.sourceAvatarUrl,
            alt: ""
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "xsmall",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFXu4)))
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, actionData.sourceName)), [
        actionData.sourceAvatarUrl,
        actionData.sourceName
    ]);
    if (!actionData.summary || !actionData.sourceName) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $99tpl.default).cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
        icon: icon,
        title: actionData.summary
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $99tpl.default).spaceLabel)}:`,
        value: space
    }), actionData.priority && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $99tpl.default).priorityLabel)}:`,
        value: actionData.priority
    }), actionData.assigneeName && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $99tpl.default).assigneeLabel)}:`,
        value: actionData.assigneeName
    }))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6e8114e9e687d8e8$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $99tpl.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $99tpl.default).confirmButton)))));
};
function $6e8114e9e687d8e8$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
module.exports["CreateWorkItemAction"] = $6e8114e9e687d8e8$export$d570fa642ea18e5d;

});

parcelRegister("9bgOM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $4MdqE = parcelRequire("4MdqE");


var $lSQgn = parcelRequire("lSQgn");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $esN88 = parcelRequire("esN88");


var $lRbe2 = parcelRequire("lRbe2");


var $5wTq5 = parcelRequire("5wTq5");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $3Zygi = parcelRequire("3Zygi");

const $85fa6ed24f6a7de3$var$INTERACTION_SOURCE = 'jiraPlansDeleteProgramBoardRenderer';
const $85fa6ed24f6a7de3$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $85fa6ed24f6a7de3$export$d392788c2987c3f6 = (actions)=>{
    const filteredActions = actions.filter((action)=>$85fa6ed24f6a7de3$var$assertIsDeleteProgramBoardAction(action));
    return filteredActions;
};
const $85fa6ed24f6a7de3$var$assertIsDeleteProgramBoardAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY))) throw new Error('Invalid action key for DeleteProgramBoardAction');
    return action;
};
const $85fa6ed24f6a7de3$export$901320364cfbbf9f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $85fa6ed24f6a7de3$export$d392788c2987c3f6(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($85fa6ed24f6a7de3$var$DeleteProgramBoardActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$85fa6ed24f6a7de3$export$d392788c2987c3f6(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($85fa6ed24f6a7de3$var$DeleteProgramBoardActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $85fa6ed24f6a7de3$var$DeleteProgramBoardActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(88);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t1;
    } else t1 = $[5];
    const readonly = t1;
    let t2;
    if ($[6] !== firstAction || $[7] !== getStatus) {
        t2 = getStatus(firstAction);
        $[6] = firstAction;
        $[7] = getStatus;
        $[8] = t2;
    } else t2 = $[8];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[9] !== t3) {
        t4 = t3.toLowerCase();
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[11] !== t5) {
        t6 = t5.toLowerCase();
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actionStatus = t6;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t7;
    if ($[13] !== data) {
        t7 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[13] = data;
        $[14] = t7;
    } else t7 = $[14];
    const actionData = t7;
    let t8;
    if ($[15] !== actionData.planId || $[16] !== actionData.programBoardId || $[17] !== actionData.programBoardName || $[18] !== actions || $[19] !== conversationId || $[20] !== firstAction || $[21] !== getStatus || $[22] !== isCustomAgent || $[23] !== messageId || $[24] !== onConfirm || $[25] !== recipientAgentId || $[26] !== sendAnalyticsEvent || $[27] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-delete-program-board-confirm",
                    planId: actionData.planId,
                    programBoardId: actionData.programBoardId,
                    programBoardName: actionData.programBoardName
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $85fa6ed24f6a7de3$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.planId;
        $[16] = actionData.programBoardId;
        $[17] = actionData.programBoardName;
        $[18] = actions;
        $[19] = conversationId;
        $[20] = firstAction;
        $[21] = getStatus;
        $[22] = isCustomAgent;
        $[23] = messageId;
        $[24] = onConfirm;
        $[25] = recipientAgentId;
        $[26] = sendAnalyticsEvent;
        $[27] = sendMessageConfirmedTools;
        $[28] = t8;
    } else t8 = $[28];
    const handleConfirm = t8;
    let t9;
    if ($[29] !== actionData.planId || $[30] !== actionData.programBoardName || $[31] !== actions || $[32] !== conversationId || $[33] !== firstAction || $[34] !== getStatus || $[35] !== isCustomAgent || $[36] !== messageId || $[37] !== onCancel || $[38] !== recipientAgentId || $[39] !== sendAnalyticsEvent || $[40] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-delete-program-board-cancel",
                    planId: actionData.planId,
                    programBoardName: actionData.programBoardName
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $85fa6ed24f6a7de3$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($85fa6ed24f6a7de3$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[29] = actionData.planId;
        $[30] = actionData.programBoardName;
        $[31] = actions;
        $[32] = conversationId;
        $[33] = firstAction;
        $[34] = getStatus;
        $[35] = isCustomAgent;
        $[36] = messageId;
        $[37] = onCancel;
        $[38] = recipientAgentId;
        $[39] = sendAnalyticsEvent;
        $[40] = sendMessageConfirmedTools;
        $[41] = t9;
    } else t9 = $[41];
    const handleCancel = t9;
    let t10;
    if ($[42] !== formatDate) {
        t10 = (start)=>formatDate(start, {
                month: "numeric",
                day: "numeric",
                year: "2-digit",
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            }).replace("AM", "am").replace("PM", "pm");
        $[42] = formatDate;
        $[43] = t10;
    } else t10 = $[43];
    const formatStartDate = t10;
    if (!actionData.programBoardName) return null;
    let t11;
    if ($[44] !== formatMessage) {
        t11 = formatMessage((0, $3Zygi.default).cardTitle);
        $[44] = formatMessage;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
        });
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] !== actionData.programBoardName) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
            icon: t12,
            title: actionData.programBoardName
        });
        $[47] = actionData.programBoardName;
        $[48] = t13;
    } else t13 = $[48];
    let t14;
    if ($[49] !== formatMessage) {
        t14 = formatMessage((0, $3Zygi.default).startDateLabel);
        $[49] = formatMessage;
        $[50] = t14;
    } else t14 = $[50];
    const t15 = `${t14}:`;
    let t16;
    if ($[51] !== actionData.start || $[52] !== formatStartDate) {
        t16 = formatStartDate(actionData.start);
        $[51] = actionData.start;
        $[52] = formatStartDate;
        $[53] = t16;
    } else t16 = $[53];
    let t17;
    if ($[54] !== t15 || $[55] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t15,
            value: t16
        });
        $[54] = t15;
        $[55] = t16;
        $[56] = t17;
    } else t17 = $[56];
    let t18;
    if ($[57] !== formatMessage) {
        t18 = formatMessage((0, $3Zygi.default).columnDurationLabel);
        $[57] = formatMessage;
        $[58] = t18;
    } else t18 = $[58];
    const t19 = `${t18}:`;
    let t20;
    if ($[59] !== actionData.iterationLength || $[60] !== formatMessage) {
        t20 = formatMessage((0, $3Zygi.default).columnDurationValue, {
            count: actionData.iterationLength
        });
        $[59] = actionData.iterationLength;
        $[60] = formatMessage;
        $[61] = t20;
    } else t20 = $[61];
    let t21;
    if ($[62] !== t19 || $[63] !== t20) {
        t21 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t19,
            value: t20
        });
        $[62] = t19;
        $[63] = t20;
        $[64] = t21;
    } else t21 = $[64];
    let t22;
    if ($[65] !== formatMessage) {
        t22 = formatMessage((0, $3Zygi.default).numberOfColumnsLabel);
        $[65] = formatMessage;
        $[66] = t22;
    } else t22 = $[66];
    const t23 = `${t22}:`;
    const t24 = String(actionData.iterationsCount);
    let t25;
    if ($[67] !== t23 || $[68] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: t23,
            value: t24
        });
        $[67] = t23;
        $[68] = t24;
        $[69] = t25;
    } else t25 = $[69];
    let t26;
    if ($[70] !== t17 || $[71] !== t21 || $[72] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, t17, t21, t25);
        $[70] = t17;
        $[71] = t21;
        $[72] = t25;
        $[73] = t26;
    } else t26 = $[73];
    let t27;
    if ($[74] !== t13 || $[75] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, t13, t26);
        $[74] = t13;
        $[75] = t26;
        $[76] = t27;
    } else t27 = $[76];
    let t28;
    if ($[77] !== buttonsDisabled || $[78] !== formatMessage || $[79] !== handleCancel || $[80] !== handleConfirm || $[81] !== isActionFinished || $[82] !== isSubmitting) {
        t28 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $85fa6ed24f6a7de3$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $3Zygi.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "danger",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $3Zygi.default).confirmButton))));
        $[77] = buttonsDisabled;
        $[78] = formatMessage;
        $[79] = handleCancel;
        $[80] = handleConfirm;
        $[81] = isActionFinished;
        $[82] = isSubmitting;
        $[83] = t28;
    } else t28 = $[83];
    let t29;
    if ($[84] !== t11 || $[85] !== t27 || $[86] !== t28) {
        t29 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t11,
            product: "plan"
        }, t27, t28);
        $[84] = t11;
        $[85] = t27;
        $[86] = t28;
        $[87] = t29;
    } else t29 = $[87];
    return t29;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-delete-program-board-confirm',
                planId: actionData.planId,
                programBoardId: actionData.programBoardId,
                programBoardName: actionData.programBoardName
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $85fa6ed24f6a7de3$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-delete-program-board-cancel',
                planId: actionData.planId,
                programBoardName: actionData.programBoardName
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $85fa6ed24f6a7de3$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const formatStartDate = (0, $cozmU.useCallback)((start)=>formatDate(start, {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).replace('AM', 'am').replace('PM', 'pm'), [
        formatDate
    ]);
    if (!actionData.programBoardName) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $3Zygi.default).cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
        icon: /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
        }),
        title: actionData.programBoardName
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $3Zygi.default).startDateLabel)}:`,
        value: formatStartDate(actionData.start)
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $3Zygi.default).columnDurationLabel)}:`,
        value: formatMessage((0, $3Zygi.default).columnDurationValue, {
            count: actionData.iterationLength
        })
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $3Zygi.default).numberOfColumnsLabel)}:`,
        value: String(actionData.iterationsCount)
    }))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $85fa6ed24f6a7de3$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $3Zygi.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "danger",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $3Zygi.default).confirmButton)))));
};
function $85fa6ed24f6a7de3$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
module.exports["DeleteProgramBoardAction"] = $85fa6ed24f6a7de3$export$901320364cfbbf9f;

});

parcelRegister("9e8iJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $ioa75 = parcelRequire("ioa75");

const $dfca6ce3c6abe60c$var$INTERACTION_SOURCE = 'jiraPlansManageFeaturesRenderer';
const $dfca6ce3c6abe60c$var$releasesFeatureIcon = 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTYgOTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cgo8cGF0aCBkPSJNMjIgMzRINjEuNUw3MCA2NUgyMlYzNFoiIGZpbGw9IiM4MkI1MzYiLz4KPHBhdGggZD0iTTE1LjQxOTYgNzlMOSA1OUg0OC41TDYwLjgyOCA0OUg4Nkw3OC41OTY1IDc5SDE1LjQxOTZaIiBmaWxsPSIjNjY5REYxIi8+CjxyZWN0IHg9IjI5IiB5PSIzNCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIGZpbGw9IiMxNjRCMzUiLz4KPHJlY3QgeD0iNDYiIHk9IjIzIiB3aWR0aD0iMTAiIGhlaWdodD0iMTUiIGZpbGw9IiNGQ0E3MDAiLz4KPHJlY3QgeD0iNDYiIHk9IjM0IiB3aWR0aD0iMTAiIGhlaWdodD0iNiIgZmlsbD0iIzE2NEIzNSIvPgo8cGF0aCBkPSJNMjIgNjdWNTlINDguNUw2MC41IDQ5SDY1LjYwOTRMNzAgNjdIMjJaIiBmaWxsPSIjMDkzMjZDIi8+CjxwYXRoIGQ9Ik02MiA2OUg1OUw1NSA3M0w1OSA3N0g2Mkw1OCA3M0w2MiA2OVoiIGZpbGw9IiMxRjFGMjEiLz4KPHBhdGggZD0iTTcwIDY5SDczTDc3IDczTDczIDc3SDcwTDc0IDczTDcwIDY5WiIgZmlsbD0iIzFGMUYyMSIvPgo8cGF0aCBkPSJNNjkgNjlINjYuNUw2MyA3N0g2Nkw2OSA2OVoiIGZpbGw9IiMxRjFGMjEiLz4KPHBhdGggZD0iTTI5Ljk3NTYgMTMuMTY1MkMyOS44NDggMTMuMTY1MiAyOS43MjA0IDEzLjE2NzEgMjkuNTk0NyAxMy4xNzI3QzI3LjY1MjUgNy40MTAzIDIzLjU3NDIgNSAxNy40OTYyIDVDOC43ODA4MSA1IDQgMTAuMDQ3NyA0IDIzSDM5QzM4LjAxMzcgMTYuNTU4MyAzNC42ODA5IDEzLjE2NzEgMjkuOTc3NCAxMy4xNjcxTDI5Ljk3NTYgMTMuMTY1MloiIGZpbGw9IiM0QjRENTEiLz4KPHBhdGggZD0iTS01LjE4ODIxIDIzSDEwQzguNjM4ODggMTUuNzk0NSA0LjA0MzkzIDEyIC0yLjQ0MDE2IDEyQy04LjQ3ODM2IDEyIC0xMi41NzM1IDE0Ljg4IC0xNSAyM0gtNS4xODU4NkgtNS4xODgyMVoiIGZpbGw9IiM0QjRENTEiLz4KPHBhdGggZD0iTTMuMjA0MjYgMjJIMTlDMTcuNTg0NCAyOS44NjA2IDEyLjgwNTcgMzQgNi4wNjIyMyAzNEMtMC4yMTc0OTggMzQgLTQuNDc2MzkgMzAuODU4MiAtNyAyMkgzLjIwNjdIMy4yMDQyNloiIGZpbGw9IiM0QjRENTEiLz4KPC9zdmc+Cg==';
const $dfca6ce3c6abe60c$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS",
    featureCard: "_30huDKOeNX _0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE",
    featureCardWrapper: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M"
};
const $dfca6ce3c6abe60c$export$39d182fe5e198462 = (actions)=>{
    const filteredActions = actions.filter((action)=>$dfca6ce3c6abe60c$var$assertIsManageFeaturesAction(action));
    return filteredActions;
};
const $dfca6ce3c6abe60c$var$assertIsManageFeaturesAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_MANAGE_FEATURES_KEY))) throw new Error('Invalid action key for ManageFeaturesAction');
    return action;
};
const $dfca6ce3c6abe60c$export$6683597f77c8b923 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $dfca6ce3c6abe60c$export$39d182fe5e198462(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($dfca6ce3c6abe60c$var$ManageFeaturesActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$dfca6ce3c6abe60c$export$39d182fe5e198462(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($dfca6ce3c6abe60c$var$ManageFeaturesActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $dfca6ce3c6abe60c$var$ManageFeaturesActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(68);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t1;
    } else t1 = $[5];
    const readonly = t1;
    let t2;
    if ($[6] !== firstAction || $[7] !== getStatus) {
        t2 = getStatus(firstAction);
        $[6] = firstAction;
        $[7] = getStatus;
        $[8] = t2;
    } else t2 = $[8];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[9] !== t3) {
        t4 = t3.toLowerCase();
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[11] !== t5) {
        t6 = t5.toLowerCase();
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actionStatus = t6;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t7;
    if ($[13] !== data) {
        t7 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[13] = data;
        $[14] = t7;
    } else t7 = $[14];
    const actionData = t7;
    const isEnabling = actionData.isReleaseEnabled;
    let t8;
    if ($[15] !== actionData.isReleaseEnabled || $[16] !== actionData.planId || $[17] !== actions || $[18] !== conversationId || $[19] !== firstAction || $[20] !== getStatus || $[21] !== isCustomAgent || $[22] !== messageId || $[23] !== onConfirm || $[24] !== recipientAgentId || $[25] !== sendAnalyticsEvent || $[26] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-manage-features-confirm",
                    planId: actionData.planId,
                    isReleaseEnabled: actionData.isReleaseEnabled
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $dfca6ce3c6abe60c$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.isReleaseEnabled;
        $[16] = actionData.planId;
        $[17] = actions;
        $[18] = conversationId;
        $[19] = firstAction;
        $[20] = getStatus;
        $[21] = isCustomAgent;
        $[22] = messageId;
        $[23] = onConfirm;
        $[24] = recipientAgentId;
        $[25] = sendAnalyticsEvent;
        $[26] = sendMessageConfirmedTools;
        $[27] = t8;
    } else t8 = $[27];
    const handleConfirm = t8;
    let t9;
    if ($[28] !== actionData.planId || $[29] !== actions || $[30] !== conversationId || $[31] !== firstAction || $[32] !== getStatus || $[33] !== isCustomAgent || $[34] !== messageId || $[35] !== onCancel || $[36] !== recipientAgentId || $[37] !== sendAnalyticsEvent || $[38] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-manage-features-cancel",
                    planId: actionData.planId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $dfca6ce3c6abe60c$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($dfca6ce3c6abe60c$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[28] = actionData.planId;
        $[29] = actions;
        $[30] = conversationId;
        $[31] = firstAction;
        $[32] = getStatus;
        $[33] = isCustomAgent;
        $[34] = messageId;
        $[35] = onCancel;
        $[36] = recipientAgentId;
        $[37] = sendAnalyticsEvent;
        $[38] = sendMessageConfirmedTools;
        $[39] = t9;
    } else t9 = $[39];
    const handleCancel = t9;
    let t10;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: $dfca6ce3c6abe60c$var$releasesFeatureIcon,
            alt: "",
            height: "24px",
            width: "24px"
        });
        $[40] = t10;
    } else t10 = $[40];
    let t11;
    if ($[41] !== formatMessage) {
        t11 = formatMessage((0, $ioa75.default).releasesLabel);
        $[41] = formatMessage;
        $[42] = t11;
    } else t11 = $[42];
    let t12;
    if ($[43] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t10, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, t11));
        $[43] = t11;
        $[44] = t12;
    } else t12 = $[44];
    const t13 = isEnabling ? "success" : "danger";
    let t14;
    if ($[45] !== formatMessage || $[46] !== isEnabling) {
        t14 = isEnabling ? formatMessage((0, $ioa75.default).statusOn) : formatMessage((0, $ioa75.default).statusOff);
        $[45] = formatMessage;
        $[46] = isEnabling;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] !== t13 || $[49] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: t13
        }, t14);
        $[48] = t13;
        $[49] = t14;
        $[50] = t15;
    } else t15 = $[50];
    let t16;
    if ($[51] !== t12 || $[52] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dfca6ce3c6abe60c$var$styles.featureCardWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dfca6ce3c6abe60c$var$styles.featureCard
        }, t12, t15));
        $[51] = t12;
        $[52] = t15;
        $[53] = t16;
    } else t16 = $[53];
    const featureCard = t16;
    if (!actionData.planId || typeof actionData.isReleaseEnabled !== "boolean") return null;
    let t17;
    if ($[54] !== formatMessage) {
        t17 = formatMessage((0, $ioa75.default).cardTitle);
        $[54] = formatMessage;
        $[55] = t17;
    } else t17 = $[55];
    let t18;
    if ($[56] !== buttonsDisabled || $[57] !== formatMessage || $[58] !== handleCancel || $[59] !== handleConfirm || $[60] !== isActionFinished || $[61] !== isEnabling || $[62] !== isSubmitting) {
        t18 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dfca6ce3c6abe60c$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $ioa75.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: isEnabling ? "primary" : "danger",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, isEnabling ? formatMessage((0, $ioa75.default).turnOnButton) : formatMessage((0, $ioa75.default).turnOffButton))));
        $[56] = buttonsDisabled;
        $[57] = formatMessage;
        $[58] = handleCancel;
        $[59] = handleConfirm;
        $[60] = isActionFinished;
        $[61] = isEnabling;
        $[62] = isSubmitting;
        $[63] = t18;
    } else t18 = $[63];
    let t19;
    if ($[64] !== featureCard || $[65] !== t17 || $[66] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t17,
            product: "plan"
        }, featureCard, t18);
        $[64] = featureCard;
        $[65] = t17;
        $[66] = t18;
        $[67] = t19;
    } else t19 = $[67];
    return t19;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const isEnabling = actionData.isReleaseEnabled;
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-manage-features-confirm',
                planId: actionData.planId,
                isReleaseEnabled: actionData.isReleaseEnabled
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $dfca6ce3c6abe60c$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-manage-features-cancel',
                planId: actionData.planId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $dfca6ce3c6abe60c$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const featureCard = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dfca6ce3c6abe60c$var$styles.featureCardWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dfca6ce3c6abe60c$var$styles.featureCard
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: $dfca6ce3c6abe60c$var$releasesFeatureIcon,
            alt: "",
            height: "24px",
            width: "24px"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $ioa75.default).releasesLabel))), /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: isEnabling ? 'success' : 'danger'
        }, isEnabling ? formatMessage((0, $ioa75.default).statusOn) : formatMessage((0, $ioa75.default).statusOff)))), [
        isEnabling,
        formatMessage
    ]);
    if (!actionData.planId || typeof actionData.isReleaseEnabled !== 'boolean') return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $ioa75.default).cardTitle),
        product: "plan"
    }, featureCard, !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $dfca6ce3c6abe60c$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $ioa75.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: isEnabling ? 'primary' : 'danger',
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, isEnabling ? formatMessage((0, $ioa75.default).turnOnButton) : formatMessage((0, $ioa75.default).turnOffButton)))));
};
function $dfca6ce3c6abe60c$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
module.exports["ManageFeaturesAction"] = $dfca6ce3c6abe60c$export$6683597f77c8b923;

});

parcelRegister("6AKbq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $8y86q = parcelRequire("8y86q");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $lTpqN = parcelRequire("lTpqN");

const $d5384916e44e66e5$var$INTERACTION_SOURCE = 'jiraPlansRemoveDependencyRenderer';
const $d5384916e44e66e5$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS",
    cardWrapper: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    issueCard: "_2mHwu82ADO _30huDKOeNX _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE",
    issueTypeIcon: "_39xV02ey7F _0jFU0Vey7F",
    line: "_39xV024Jdh _0jFU0VxpxF _0KLXru7j8z",
    iconCircle: "_0bjKvDS5Zs _39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXru7j8z _1UtDYze5R3",
    separatorColumn: "_0GTcwR2ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
};
const $d5384916e44e66e5$export$d4a51cd7482360b0 = (actions)=>{
    const filteredActions = actions.filter((action)=>$d5384916e44e66e5$var$assertIsRemoveDependencyAction(action));
    return filteredActions;
};
const $d5384916e44e66e5$var$assertIsRemoveDependencyAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_REMOVE_DEPENDENCY_KEY))) throw new Error('Invalid action key for RemoveDependencyAction');
    return action;
};
const $d5384916e44e66e5$export$5de64d9da8c5fc0d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $d5384916e44e66e5$export$d4a51cd7482360b0(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($d5384916e44e66e5$var$RemoveDependencyActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$d5384916e44e66e5$export$d4a51cd7482360b0(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($d5384916e44e66e5$var$RemoveDependencyActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $d5384916e44e66e5$var$RemoveDependencyActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(76);
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[3] !== firstAction.data) {
        t1 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(firstAction.data);
        $[3] = firstAction.data;
        $[4] = t1;
    } else t1 = $[4];
    const actionData = t1;
    let t2;
    if ($[5] !== firstAction || $[6] !== getStatus) {
        t2 = getStatus(firstAction);
        $[5] = firstAction;
        $[6] = getStatus;
        $[7] = t2;
    } else t2 = $[7];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[8] !== t3) {
        t4 = t3.toLowerCase();
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[10] !== t5) {
        t6 = t5.toLowerCase();
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    const actionStatus = t6;
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    let t7;
    if ($[12] !== firstAction || $[13] !== getReadonly) {
        t7 = getReadonly(firstAction);
        $[12] = firstAction;
        $[13] = getReadonly;
        $[14] = t7;
    } else t7 = $[14];
    const isReadonly = t7;
    const buttonsDisabled = isSubmitting || isReadonly;
    let t8;
    if ($[15] !== actionData.planId || $[16] !== actionData.scenarioId || $[17] !== actions || $[18] !== conversationId || $[19] !== firstAction || $[20] !== getStatus || $[21] !== isCustomAgent || $[22] !== messageId || $[23] !== onConfirm || $[24] !== recipientAgentId || $[25] !== sendAnalyticsEvent || $[26] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-remove-dependency-confirm",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $d5384916e44e66e5$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            onConfirm(firstAction);
        };
        $[15] = actionData.planId;
        $[16] = actionData.scenarioId;
        $[17] = actions;
        $[18] = conversationId;
        $[19] = firstAction;
        $[20] = getStatus;
        $[21] = isCustomAgent;
        $[22] = messageId;
        $[23] = onConfirm;
        $[24] = recipientAgentId;
        $[25] = sendAnalyticsEvent;
        $[26] = sendMessageConfirmedTools;
        $[27] = t8;
    } else t8 = $[27];
    const handleConfirm = t8;
    let t9;
    if ($[28] !== actionData.planId || $[29] !== actionData.scenarioId || $[30] !== actions || $[31] !== conversationId || $[32] !== firstAction || $[33] !== getStatus || $[34] !== isCustomAgent || $[35] !== messageId || $[36] !== onCancel || $[37] !== recipientAgentId || $[38] !== sendAnalyticsEvent || $[39] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: "rovo-chat-jira-plans-remove-dependency-cancel",
                    planId: actionData.planId,
                    scenarioId: actionData.scenarioId
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $d5384916e44e66e5$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($d5384916e44e66e5$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[28] = actionData.planId;
        $[29] = actionData.scenarioId;
        $[30] = actions;
        $[31] = conversationId;
        $[32] = firstAction;
        $[33] = getStatus;
        $[34] = isCustomAgent;
        $[35] = messageId;
        $[36] = onCancel;
        $[37] = recipientAgentId;
        $[38] = sendAnalyticsEvent;
        $[39] = sendMessageConfirmedTools;
        $[40] = t9;
    } else t9 = $[40];
    const handleCancel = t9;
    const issueCard = $d5384916e44e66e5$var$_temp2;
    let t10;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.separatorColumn
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.line
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.iconCircle
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8y86q))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        })), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.line
            ])
        }));
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== actionData.dependencyTypeName || $[43] !== formatMessage) {
        t11 = actionData.dependencyTypeName ?? formatMessage((0, $lTpqN.default).dependencyTypeBlocks);
        $[42] = actionData.dependencyTypeName;
        $[43] = formatMessage;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t10, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, t11));
        $[45] = t11;
        $[46] = t12;
    } else t12 = $[46];
    const separator = t12;
    if (!actionData.planId) return null;
    let t13;
    if ($[47] !== formatMessage) {
        t13 = formatMessage((0, $lTpqN.default).cardTitle);
        $[47] = formatMessage;
        $[48] = t13;
    } else t13 = $[48];
    let t14;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $hekY6.default)([
            $d5384916e44e66e5$var$styles.cardWrapper
        ]);
        $[49] = t14;
    } else t14 = $[49];
    let t15;
    if ($[50] !== actionData.sourceItemKey || $[51] !== actionData.sourceItemSummary || $[52] !== actionData.sourceItemTypeIcon) {
        t15 = issueCard(actionData.sourceItemKey, actionData.sourceItemSummary, actionData.sourceItemTypeIcon);
        $[50] = actionData.sourceItemKey;
        $[51] = actionData.sourceItemSummary;
        $[52] = actionData.sourceItemTypeIcon;
        $[53] = t15;
    } else t15 = $[53];
    let t16;
    if ($[54] !== actionData.targetItemKey || $[55] !== actionData.targetItemSummary || $[56] !== actionData.targetItemTypeIcon) {
        t16 = issueCard(actionData.targetItemKey, actionData.targetItemSummary, actionData.targetItemTypeIcon);
        $[54] = actionData.targetItemKey;
        $[55] = actionData.targetItemSummary;
        $[56] = actionData.targetItemTypeIcon;
        $[57] = t16;
    } else t16 = $[57];
    let t17;
    if ($[58] !== separator || $[59] !== t15 || $[60] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: "space.0"
        }, t15, separator, t16);
        $[58] = separator;
        $[59] = t15;
        $[60] = t16;
        $[61] = t17;
    } else t17 = $[61];
    let t18;
    if ($[62] !== t14 || $[63] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t14
        }, t17);
        $[62] = t14;
        $[63] = t17;
        $[64] = t18;
    } else t18 = $[64];
    let t19;
    if ($[65] !== buttonsDisabled || $[66] !== formatMessage || $[67] !== handleCancel || $[68] !== handleConfirm || $[69] !== isActionFinished || $[70] !== isSubmitting) {
        t19 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d5384916e44e66e5$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $lTpqN.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $lTpqN.default).confirmButton))));
        $[65] = buttonsDisabled;
        $[66] = formatMessage;
        $[67] = handleCancel;
        $[68] = handleConfirm;
        $[69] = isActionFinished;
        $[70] = isSubmitting;
        $[71] = t19;
    } else t19 = $[71];
    let t20;
    if ($[72] !== t13 || $[73] !== t18 || $[74] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t13,
            product: "plan"
        }, t18, t19);
        $[72] = t13;
        $[73] = t18;
        $[74] = t19;
        $[75] = t20;
    } else t20 = $[75];
    return t20;
} : (props)=>{
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(firstAction.data);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const isReadonly = getReadonly(firstAction);
    const buttonsDisabled = isSubmitting || isReadonly;
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-remove-dependency-confirm',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $d5384916e44e66e5$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        onConfirm(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: 'rovo-chat-jira-plans-remove-dependency-cancel',
                planId: actionData.planId,
                scenarioId: actionData.scenarioId
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $d5384916e44e66e5$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        onCancel,
        isCustomAgent
    ]);
    const issueCard = (0, $cozmU.useCallback)((itemKey, itemSummary, itemTypeIcon)=>/*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.issueCard
            ])
        }, itemTypeIcon ? /*#__PURE__*/ $cozmU.createElement("img", {
            src: itemTypeIcon,
            alt: "",
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.issueTypeIcon
            ])
        }) : null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.accent.blue",
            weight: "semibold"
        }, itemKey), itemSummary ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1
        }, itemSummary) : null), []);
    const separator = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.separatorColumn
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.line
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.iconCircle
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8y86q))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        })), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $d5384916e44e66e5$var$styles.line
            ])
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, actionData.dependencyTypeName ?? formatMessage((0, $lTpqN.default).dependencyTypeBlocks))), [
        actionData.dependencyTypeName,
        formatMessage
    ]);
    if (!actionData.planId) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage((0, $lTpqN.default).cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $d5384916e44e66e5$var$styles.cardWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: "space.0"
    }, issueCard(actionData.sourceItemKey, actionData.sourceItemSummary, actionData.sourceItemTypeIcon), separator, issueCard(actionData.targetItemKey, actionData.targetItemSummary, actionData.targetItemTypeIcon))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d5384916e44e66e5$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $lTpqN.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $lTpqN.default).confirmButton)))));
};
function $d5384916e44e66e5$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
function $d5384916e44e66e5$var$_temp2(itemKey, itemSummary, itemTypeIcon) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $d5384916e44e66e5$var$styles.issueCard
        ])
    }, itemTypeIcon ? /*#__PURE__*/ $cozmU.createElement("img", {
        src: itemTypeIcon,
        alt: "",
        className: (0, $hekY6.default)([
            $d5384916e44e66e5$var$styles.issueTypeIcon
        ])
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.accent.blue",
        weight: "semibold"
    }, itemKey), itemSummary ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, itemSummary) : null);
}
module.exports["RemoveDependencyAction"] = $d5384916e44e66e5$export$5de64d9da8c5fc0d;

});

parcelRegister("bKD9u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $aOjGz = parcelRequire("aOjGz");


var $4MdqE = parcelRequire("4MdqE");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $9NPFC = parcelRequire("9NPFC");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $2yWJZ = parcelRequire("2yWJZ");


var $9qyl6 = parcelRequire("9qyl6");


var $esN88 = parcelRequire("esN88");


var $lRbe2 = parcelRequire("lRbe2");


var $5wTq5 = parcelRequire("5wTq5");


var $7eUSO = parcelRequire("7eUSO");


var $5Wcst = parcelRequire("5Wcst");


var $dyQKF = parcelRequire("dyQKF");

const $d72dc5128434f09d$var$INTERACTION_SOURCE = 'jiraPlansUpdateWorkSourceRenderer';
const $d72dc5128434f09d$var$normalizeWorkSourceType = (type)=>{
    const lowerCaseType = type?.toLowerCase();
    return lowerCaseType === 'space' || lowerCaseType === 'project' ? 'Project' : 'Board';
};
const $d72dc5128434f09d$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $d72dc5128434f09d$export$2734397d1cb00ac9 = (actions)=>{
    const filteredActions = actions.filter((action)=>$d72dc5128434f09d$var$assertIsUpdateWorkSourceAction(action));
    return filteredActions;
};
const $d72dc5128434f09d$var$assertIsUpdateWorkSourceAction = (action)=>{
    if (!(0, $5Wcst.jiraPlansActionData).isPlanActionKeyForRenderer(action.key, (0, $dw75i.JIRA_PLANS_UPDATE_WORK_SOURCE_KEY))) throw new Error('Invalid action key for WorkSourceAction');
    return action;
};
const $d72dc5128434f09d$export$eb2d5f28ebf891dc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actions: actions } = props;
    let t0;
    if ($[0] !== actions) {
        t0 = $d72dc5128434f09d$export$2734397d1cb00ac9(actions);
        $[0] = actions;
        $[1] = t0;
    } else t0 = $[1];
    const firstAction = t0[0];
    if (!firstAction) return null;
    let t1;
    if ($[2] !== firstAction || $[3] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement($d72dc5128434f09d$var$UpdateWorkSourceActionContent, {
            ...props,
            firstAction: firstAction
        });
        $[2] = firstAction;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { actions: actions } = props;
    const firstAction = (0, $cozmU.useMemo)(()=>$d72dc5128434f09d$export$2734397d1cb00ac9(actions)[0], [
        actions
    ]);
    if (!firstAction) return null;
    return /*#__PURE__*/ $cozmU.createElement($d72dc5128434f09d$var$UpdateWorkSourceActionContent, {
        ...props,
        firstAction: firstAction
    });
};
const $d72dc5128434f09d$var$UpdateWorkSourceActionContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(85);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    let t0;
    if ($[0] !== recipientAgentId || $[1] !== recipientAgentNamedId) {
        t0 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: recipientAgentId,
            agentNamedId: recipientAgentNamedId
        });
        $[0] = recipientAgentId;
        $[1] = recipientAgentNamedId;
        $[2] = t0;
    } else t0 = $[2];
    const isCustomAgent = !t0;
    const { data: data } = firstAction;
    let t1;
    if ($[3] !== firstAction || $[4] !== getReadonly) {
        t1 = getReadonly(firstAction);
        $[3] = firstAction;
        $[4] = getReadonly;
        $[5] = t1;
    } else t1 = $[5];
    const readonly = t1;
    let t2;
    if ($[6] !== firstAction || $[7] !== getStatus) {
        t2 = getStatus(firstAction);
        $[6] = firstAction;
        $[7] = getStatus;
        $[8] = t2;
    } else t2 = $[8];
    const status = t2;
    const t3 = String(status ?? "");
    let t4;
    if ($[9] !== t3) {
        t4 = t3.toLowerCase();
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const invocationStatus = t4;
    const t5 = String(firstAction.status ?? "");
    let t6;
    if ($[11] !== t5) {
        t6 = t5.toLowerCase();
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actionStatus = t6;
    const isActionLoading = invocationStatus !== "idle";
    const isSubmitting = invocationStatus === "started";
    const isActionFinished = invocationStatus === "finished" || actionStatus === "finished";
    const buttonsDisabled = isActionLoading || readonly;
    let t7;
    if ($[13] !== data) {
        t7 = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
        $[13] = data;
        $[14] = t7;
    } else t7 = $[14];
    const actionData = t7;
    const isRemove = actionData.deleteIssueSourceId !== undefined;
    const cardTitle = isRemove ? (0, $dyQKF.default).removeCardTitle : (0, $dyQKF.default).addCardTitle;
    const confirmButtonLabel = isRemove ? (0, $dyQKF.default).removeButton : (0, $dyQKF.default).addButton;
    let t8;
    if ($[15] !== actionData || $[16] !== actions || $[17] !== conversationId || $[18] !== firstAction || $[19] !== getStatus || $[20] !== isCustomAgent || $[21] !== isRemove || $[22] !== messageId || $[23] !== onConfirm || $[24] !== recipientAgentId || $[25] !== sendAnalyticsEvent || $[26] !== sendMessageConfirmedTools) {
        t8 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: `rovo-chat-jira-plans-work-source-${isRemove ? "remove" : "add"}-confirm`,
                    workSourceId: actionData.projectId,
                    planId: actionData.planId,
                    planName: actionData.planName,
                    workSourceName: actionData.title,
                    type: actionData.type
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const argumentsOverride = isRemove ? {
                    deleteIssueSourceId: actionData.deleteIssueSourceId,
                    planId: actionData.planId,
                    planName: actionData.planName
                } : {
                    ...actionData,
                    type: $d72dc5128434f09d$var$normalizeWorkSourceType(actionData.type)
                };
                const confirmedData = (0, $5Wcst.jiraPlansActionData).withPlanActionData(firstAction.data, argumentsOverride);
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $d72dc5128434f09d$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", confirmedData) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
                return;
            }
            if (isRemove) {
                const argumentsOverride_0 = {
                    deleteIssueSourceId: actionData.deleteIssueSourceId,
                    planId: actionData.planId,
                    planName: actionData.planName
                };
                onConfirm({
                    ...firstAction,
                    data: (0, $5Wcst.jiraPlansActionData).withPlanActionData(firstAction.data, argumentsOverride_0)
                });
            } else {
                const normalizedType = actionData.type != null && (actionData.type.toLowerCase() === "space" || actionData.type.toLowerCase() === "project") ? "Project" : "Board";
                const argumentsOverride_1 = {
                    ...actionData,
                    type: normalizedType
                };
                onConfirm({
                    ...firstAction,
                    data: (0, $5Wcst.jiraPlansActionData).withPlanActionData(firstAction.data, argumentsOverride_1)
                });
            }
        };
        $[15] = actionData;
        $[16] = actions;
        $[17] = conversationId;
        $[18] = firstAction;
        $[19] = getStatus;
        $[20] = isCustomAgent;
        $[21] = isRemove;
        $[22] = messageId;
        $[23] = onConfirm;
        $[24] = recipientAgentId;
        $[25] = sendAnalyticsEvent;
        $[26] = sendMessageConfirmedTools;
        $[27] = t8;
    } else t8 = $[27];
    const handleConfirm = t8;
    let t9;
    if ($[28] !== actionData.planId || $[29] !== actionData.planName || $[30] !== actionData.projectId || $[31] !== actions || $[32] !== conversationId || $[33] !== firstAction || $[34] !== getStatus || $[35] !== isCustomAgent || $[36] !== isRemove || $[37] !== messageId || $[38] !== onCancel || $[39] !== recipientAgentId || $[40] !== sendAnalyticsEvent || $[41] !== sendMessageConfirmedTools) {
        t9 = ()=>{
            sendAnalyticsEvent({
                actionSubjectId: firstAction.actionId,
                action: "clicked",
                actionSubject: "button",
                attributes: {
                    actionSubjectId: `rovo-chat-jira-plans-work-source-${isRemove ? "remove" : "add"}-cancel`,
                    workSourceId: actionData.projectId,
                    planId: actionData.planId,
                    planName: actionData.planName
                }
            });
            if ((0, $iDrrr.fg)("jira_plans_rovo_tools_resumption_migration") || isCustomAgent && (0, $iDrrr.fg)("enable_skills_ga_tools_in_studio")) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $d72dc5128434f09d$var$INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($d72dc5128434f09d$var$_temp)
                    }
                });
                return;
            }
            onCancel(firstAction);
        };
        $[28] = actionData.planId;
        $[29] = actionData.planName;
        $[30] = actionData.projectId;
        $[31] = actions;
        $[32] = conversationId;
        $[33] = firstAction;
        $[34] = getStatus;
        $[35] = isCustomAgent;
        $[36] = isRemove;
        $[37] = messageId;
        $[38] = onCancel;
        $[39] = recipientAgentId;
        $[40] = sendAnalyticsEvent;
        $[41] = sendMessageConfirmedTools;
        $[42] = t9;
    } else t9 = $[42];
    const handleCancel = t9;
    let t10;
    if ($[43] !== actionData.avatarUrl || $[44] !== actionData.type) {
        bb0: {
            const sourceType = actionData.type?.toLowerCase();
            if (actionData.avatarUrl) {
                let t11;
                if ($[46] !== actionData.avatarUrl) {
                    t11 = /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
                        label: "",
                        size: "small",
                        isInset: false
                    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                        src: actionData.avatarUrl,
                        alt: ""
                    }));
                    $[46] = actionData.avatarUrl;
                    $[47] = t11;
                } else t11 = $[47];
                t10 = t11;
                break bb0;
            }
            if (sourceType?.includes("board")) {
                let t11;
                if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
                    t11 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
                        label: "",
                        appearance: "gray",
                        size: "small",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
                    });
                    $[48] = t11;
                } else t11 = $[48];
                t10 = t11;
                break bb0;
            }
            if (sourceType?.includes("project") || sourceType?.includes("space")) {
                let t11;
                if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
                    t11 = /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
                        label: "",
                        appearance: "gray",
                        size: "small",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aOjGz)))
                    });
                    $[49] = t11;
                } else t11 = $[49];
                t10 = t11;
                break bb0;
            }
            t10 = null;
        }
        $[43] = actionData.avatarUrl;
        $[44] = actionData.type;
        $[45] = t10;
    } else t10 = $[45];
    const icon = t10;
    if (!actionData.planId) return null;
    let t11;
    if ($[50] !== cardTitle || $[51] !== formatMessage) {
        t11 = formatMessage(cardTitle);
        $[50] = cardTitle;
        $[51] = formatMessage;
        $[52] = t11;
    } else t11 = $[52];
    let t12;
    if ($[53] !== actionData.projectId || $[54] !== actionData.title || $[55] !== formatMessage) {
        t12 = actionData.title ?? actionData.projectId ?? formatMessage((0, $dyQKF.default).workSource);
        $[53] = actionData.projectId;
        $[54] = actionData.title;
        $[55] = formatMessage;
        $[56] = t12;
    } else t12 = $[56];
    let t13;
    if ($[57] !== icon || $[58] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
            icon: icon,
            title: t12
        });
        $[57] = icon;
        $[58] = t12;
        $[59] = t13;
    } else t13 = $[59];
    let t14;
    if ($[60] !== actionData.type || $[61] !== formatMessage) {
        t14 = actionData.type != null && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: `${formatMessage((0, $dyQKF.default).sourceTypeLabel)}:`,
            value: actionData.type
        });
        $[60] = actionData.type;
        $[61] = formatMessage;
        $[62] = t14;
    } else t14 = $[62];
    let t15;
    if ($[63] !== actionData.workItemCount || $[64] !== formatMessage) {
        t15 = actionData.workItemCount != null && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
            label: `${formatMessage((0, $dyQKF.default).workItemsLabel)}:`,
            value: String(actionData.workItemCount)
        });
        $[63] = actionData.workItemCount;
        $[64] = formatMessage;
        $[65] = t15;
    } else t15 = $[65];
    let t16;
    if ($[66] !== t14 || $[67] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, t14, t15);
        $[66] = t14;
        $[67] = t15;
        $[68] = t16;
    } else t16 = $[68];
    let t17;
    if ($[69] !== t13 || $[70] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, t13, t16);
        $[69] = t13;
        $[70] = t16;
        $[71] = t17;
    } else t17 = $[71];
    let t18;
    if ($[72] !== buttonsDisabled || $[73] !== confirmButtonLabel || $[74] !== formatMessage || $[75] !== handleCancel || $[76] !== handleConfirm || $[77] !== isActionFinished || $[78] !== isRemove || $[79] !== isSubmitting) {
        t18 = !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d72dc5128434f09d$var$styles.footer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $dyQKF.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: isRemove ? "warning" : "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled,
            isLoading: isSubmitting
        }, formatMessage(confirmButtonLabel))));
        $[72] = buttonsDisabled;
        $[73] = confirmButtonLabel;
        $[74] = formatMessage;
        $[75] = handleCancel;
        $[76] = handleConfirm;
        $[77] = isActionFinished;
        $[78] = isRemove;
        $[79] = isSubmitting;
        $[80] = t18;
    } else t18 = $[80];
    let t19;
    if ($[81] !== t11 || $[82] !== t17 || $[83] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            title: t11,
            product: "plan"
        }, t17, t18);
        $[81] = t11;
        $[82] = t17;
        $[83] = t18;
        $[84] = t19;
    } else t19 = $[84];
    return t19;
} : (props)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getStatus: getStatus, getReadonly: getReadonly, firstAction: firstAction, onConfirm: onConfirm, onCancel: onCancel, actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, recipientAgentNamedId: recipientAgentNamedId, conversationId: conversationId, messageId: messageId } = props;
    const isCustomAgent = !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: recipientAgentId,
        agentNamedId: recipientAgentNamedId
    });
    const { data: data } = firstAction;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const invocationStatus = String(status ?? '').toLowerCase();
    const actionStatus = String(firstAction.status ?? '').toLowerCase();
    const isActionLoading = invocationStatus !== 'idle';
    const isSubmitting = invocationStatus === 'started';
    const isActionFinished = invocationStatus === 'finished' || actionStatus === 'finished';
    const buttonsDisabled = isActionLoading || readonly;
    const actionData = (0, $5Wcst.jiraPlansActionData).getPlanActionData(data);
    const isRemove = actionData.deleteIssueSourceId !== undefined;
    const cardTitle = isRemove ? (0, $dyQKF.default).removeCardTitle : (0, $dyQKF.default).addCardTitle;
    const confirmButtonLabel = isRemove ? (0, $dyQKF.default).removeButton : (0, $dyQKF.default).addButton;
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: `rovo-chat-jira-plans-work-source-${isRemove ? 'remove' : 'add'}-confirm`,
                workSourceId: actionData.projectId,
                planId: actionData.planId,
                planName: actionData.planName,
                workSourceName: actionData.title,
                type: actionData.type
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const argumentsOverride = isRemove ? {
                deleteIssueSourceId: actionData.deleteIssueSourceId,
                planId: actionData.planId,
                planName: actionData.planName
            } : {
                ...actionData,
                type: $d72dc5128434f09d$var$normalizeWorkSourceType(actionData.type)
            };
            const confirmedData = (0, $5Wcst.jiraPlansActionData).withPlanActionData(firstAction.data, argumentsOverride);
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $d72dc5128434f09d$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', confirmedData) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
            return;
        }
        if (isRemove) {
            const argumentsOverride_0 = {
                deleteIssueSourceId: actionData.deleteIssueSourceId,
                planId: actionData.planId,
                planName: actionData.planName
            };
            onConfirm({
                ...firstAction,
                data: (0, $5Wcst.jiraPlansActionData).withPlanActionData(firstAction.data, argumentsOverride_0)
            });
        } else {
            const normalizedType = actionData.type != null && (actionData.type.toLowerCase() === 'space' || actionData.type.toLowerCase() === 'project') ? 'Project' : 'Board';
            const argumentsOverride_1 = {
                ...actionData,
                type: normalizedType
            };
            onConfirm({
                ...firstAction,
                data: (0, $5Wcst.jiraPlansActionData).withPlanActionData(firstAction.data, argumentsOverride_1)
            });
        }
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        isRemove,
        onConfirm,
        isCustomAgent
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            actionSubjectId: firstAction.actionId,
            action: 'clicked',
            actionSubject: 'button',
            attributes: {
                actionSubjectId: `rovo-chat-jira-plans-work-source-${isRemove ? 'remove' : 'add'}-cancel`,
                workSourceId: actionData.projectId,
                planId: actionData.planId,
                planName: actionData.planName
            }
        });
        if ((0, $iDrrr.fg)('jira_plans_rovo_tools_resumption_migration') || isCustomAgent && (0, $iDrrr.fg)('enable_skills_ga_tools_in_studio')) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $d72dc5128434f09d$var$INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
            return;
        }
        onCancel(firstAction);
    }, [
        firstAction,
        actions,
        actionData,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        sendAnalyticsEvent,
        isRemove,
        onCancel,
        isCustomAgent
    ]);
    const icon = (0, $cozmU.useMemo)(()=>{
        const sourceType = actionData.type?.toLowerCase(); // If the backend provides an avatar, prefer rendering it regardless of source type casing/value.
        if (actionData.avatarUrl) return /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: "",
            size: "small",
            isInset: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: actionData.avatarUrl,
            alt: ""
        }));
        if (sourceType?.includes('board')) return /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
        });
        if (sourceType?.includes('project') || sourceType?.includes('space')) return /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
            label: "",
            appearance: "gray",
            size: "small",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aOjGz)))
        });
        return null;
    }, [
        actionData.avatarUrl,
        actionData.type
    ]);
    if (!actionData.planId) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        title: formatMessage(cardTitle),
        product: "plan"
    }, /*#__PURE__*/ $cozmU.createElement((0, $esN88.EntityCard), null, /*#__PURE__*/ $cozmU.createElement((0, $lRbe2.EntityTitle), {
        icon: icon,
        title: actionData.title ?? actionData.projectId ?? formatMessage((0, $dyQKF.default).workSource)
    }), /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGrid), null, actionData.type != null && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $dyQKF.default).sourceTypeLabel)}:`,
        value: actionData.type
    }), actionData.workItemCount != null && /*#__PURE__*/ $cozmU.createElement((0, $5wTq5.EntityValueGridRow), {
        label: `${formatMessage((0, $dyQKF.default).workItemsLabel)}:`,
        value: String(actionData.workItemCount)
    }))), !isActionFinished && /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d72dc5128434f09d$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $dyQKF.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: isRemove ? 'warning' : 'primary',
        onClick: handleConfirm,
        isDisabled: buttonsDisabled,
        isLoading: isSubmitting
    }, formatMessage(confirmButtonLabel)))));
};
function $d72dc5128434f09d$var$_temp(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
module.exports["UpdateWorkSourceAction"] = $d72dc5128434f09d$export$eb2d5f28ebf891dc;

});

parcelRegister("48tRp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $jerDQ = parcelRequire("jerDQ");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $5wTq5 = parcelRequire("5wTq5");


var $c8XPX = parcelRequire("c8XPX");


var $h6odf = parcelRequire("h6odf");

const $cf2b2d6a7abcb2f0$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $cf2b2d6a7abcb2f0$var$sprintIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jerDQ))),
    label: "",
    appearance: "gray",
    size: "small"
});
const $cf2b2d6a7abcb2f0$export$529766f856c81bb2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { actions: actions, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const action = actions[0];
    const { data: data } = action;
    let t1;
    if ($[0] !== action || $[1] !== getReadonly) {
        t1 = getReadonly(action);
        $[0] = action;
        $[1] = getReadonly;
        $[2] = t1;
    } else t1 = $[2];
    const readonly = t1;
    const [isActioned, setIsActioned] = (0, $cozmU.useState)(false);
    const buttonsDisabled = isActioned || readonly;
    let t2;
    if ($[3] !== action.actionId || $[4] !== action.data || $[5] !== action.humanMessageId || $[6] !== action.invocationId || $[7] !== action.key || $[8] !== action.toolSource || $[9] !== conversationId || $[10] !== messageId || $[11] !== recipientAgentId || $[12] !== sendAnalyticsEvent || $[13] !== sendMessageConfirmedTools) {
        t2 = (resolutionType)=>{
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: resolutionType === "confirmed" ? "confirmStartSprintButton" : "cancelStartSprintButton"
            });
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: "jiraStartSprintAction"
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        {
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            resolution: {
                                type: resolutionType
                            },
                            data: {
                                human_message_id: action.humanMessageId ?? "",
                                arguments: action.data
                            }
                        }
                    ]
                },
                resolutionType: resolutionType
            });
            setIsActioned(true);
        };
        $[3] = action.actionId;
        $[4] = action.data;
        $[5] = action.humanMessageId;
        $[6] = action.invocationId;
        $[7] = action.key;
        $[8] = action.toolSource;
        $[9] = conversationId;
        $[10] = messageId;
        $[11] = recipientAgentId;
        $[12] = sendAnalyticsEvent;
        $[13] = sendMessageConfirmedTools;
        $[14] = t2;
    } else t2 = $[14];
    const handleAction = t2;
    let t3;
    if ($[15] !== handleAction) {
        t3 = ()=>handleAction("confirmed");
        $[15] = handleAction;
        $[16] = t3;
    } else t3 = $[16];
    const handleConfirm = t3;
    let t4;
    if ($[17] !== handleAction) {
        t4 = ()=>handleAction("cancelled");
        $[17] = handleAction;
        $[18] = t4;
    } else t4 = $[18];
    const handleCancel = t4;
    const isCompletingSprint = data.state === "closed";
    const t5 = isCompletingSprint ? (0, $h6odf.messages).completeTitle : (0, $h6odf.messages).title;
    let t6;
    if ($[19] !== formatMessage || $[20] !== t5) {
        t6 = formatMessage(t5);
        $[19] = formatMessage;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== formatMessage) {
        t7 = formatMessage((0, $h6odf.messages).nameLabel);
        $[22] = formatMessage;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== data.name || $[25] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: t7,
            value: data.name
        });
        $[24] = data.name;
        $[25] = t7;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== data.startDate || $[28] !== formatMessage) {
        t9 = data.startDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: formatMessage((0, $h6odf.messages).startDateLabel),
            value: (0, $c8XPX.formatDate)(data.startDate)
        });
        $[27] = data.startDate;
        $[28] = formatMessage;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== data.endDate || $[31] !== formatMessage) {
        t10 = data.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
            label: formatMessage((0, $h6odf.messages).endDateLabel),
            value: (0, $c8XPX.formatDate)(data.endDate)
        });
        $[30] = data.endDate;
        $[31] = formatMessage;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== t10 || $[34] !== t8 || $[35] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGrid), null, t8, t9, t10);
        $[33] = t10;
        $[34] = t8;
        $[35] = t9;
        $[36] = t11;
    } else t11 = $[36];
    let t12;
    if ($[37] !== formatMessage) {
        t12 = formatMessage((0, $h6odf.messages).cancelButton);
        $[37] = formatMessage;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== buttonsDisabled || $[40] !== handleCancel || $[41] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: handleCancel,
            isDisabled: buttonsDisabled
        }, t12);
        $[39] = buttonsDisabled;
        $[40] = handleCancel;
        $[41] = t12;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] !== formatMessage) {
        t14 = formatMessage((0, $h6odf.messages).confirmButton);
        $[43] = formatMessage;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== buttonsDisabled || $[46] !== handleConfirm || $[47] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: buttonsDisabled
        }, t14);
        $[45] = buttonsDisabled;
        $[46] = handleConfirm;
        $[47] = t14;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== t13 || $[50] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cf2b2d6a7abcb2f0$var$styles.footer
        }, t13, t15));
        $[49] = t13;
        $[50] = t15;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== t11 || $[53] !== t16 || $[54] !== t6) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            title: t6,
            headerIcon: $cf2b2d6a7abcb2f0$var$sprintIcon
        }, t11, t16);
        $[52] = t11;
        $[53] = t16;
        $[54] = t6;
        $[55] = t17;
    } else t17 = $[55];
    return t17;
} : ({ actions: actions, getReadonly: getReadonly, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const action = actions[0];
    const { data: data } = action;
    const readonly = getReadonly(action);
    const [isActioned, setIsActioned] = (0, $cozmU.useState)(false);
    const buttonsDisabled = isActioned || readonly;
    const handleAction = (0, $cozmU.useCallback)((resolutionType)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: resolutionType === 'confirmed' ? 'confirmStartSprintButton' : 'cancelStartSprintButton'
        });
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'jiraStartSprintAction'
            },
            confirmed_tools: {
                message_id: messageId,
                tools: [
                    {
                        key: action.key,
                        tool_id: action.actionId,
                        tool_source: action.toolSource,
                        invocation_id: action.invocationId,
                        resolution: {
                            type: resolutionType
                        },
                        data: {
                            human_message_id: action.humanMessageId ?? '',
                            arguments: action.data
                        }
                    }
                ]
            },
            resolutionType: resolutionType
        });
        setIsActioned(true);
    }, [
        sendAnalyticsEvent,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        action
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(()=>handleAction('confirmed'), [
        handleAction
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>handleAction('cancelled'), [
        handleAction
    ]);
    const isCompletingSprint = data.state === 'closed';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage(isCompletingSprint ? (0, $h6odf.messages).completeTitle : (0, $h6odf.messages).title),
        headerIcon: $cf2b2d6a7abcb2f0$var$sprintIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGrid), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $h6odf.messages).nameLabel),
        value: data.name
    }), data.startDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $h6odf.messages).startDateLabel),
        value: (0, $c8XPX.formatDate)(data.startDate)
    }), data.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wTq5.EntityValueGridRow), {
        label: formatMessage((0, $h6odf.messages).endDateLabel),
        value: (0, $c8XPX.formatDate)(data.endDate)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cf2b2d6a7abcb2f0$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleCancel,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $h6odf.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $h6odf.messages).confirmButton)))));
};
module.exports["JiraStartSprintAction"] = $cf2b2d6a7abcb2f0$export$529766f856c81bb2;

});

parcelRegister("1Bv1o", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $hPeO7 = parcelRequire("hPeO7");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $IOtUu = parcelRequire("IOtUu");


var $9qyl6 = parcelRequire("9qyl6");


var $7CSGi = parcelRequire("7CSGi");


var $43bN1 = parcelRequire("43bN1");


var $20KBU = parcelRequire("20KBU");

const $84536422a2f72f79$var$styles = {
    rovoHint: "_0Of8r2kG2W _2Zuz6Q8HPE"
}; // Literal JQL emits for the `currentUser()` function; substituted with the viewer's aaid before hydration.
const $84536422a2f72f79$var$CURRENT_USER_JQL_LITERAL = 'currentUser()'; // JQL fields whose values are user identifiers. Only these are worth resolving via the
// user-hydration lookup; other fields' literals (dates, labels, priorities, etc) are not accountIds.
const $84536422a2f72f79$var$USER_FIELDS = new Set([
    'assignee',
    'reporter',
    'creator',
    'voter',
    'watcher',
    'watchers'
]);
const $84536422a2f72f79$var$cardTitle = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.card-title",
    defaultMessage: "AI view create"
});
const $84536422a2f72f79$var$confirmButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.confirm-button",
    defaultMessage: "Create view"
});
const $84536422a2f72f79$var$dismissButton = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.dismiss-button",
    defaultMessage: "Dismiss"
});
const $84536422a2f72f79$var$filterLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.filter-label",
    defaultMessage: "Filter"
});
const $84536422a2f72f79$var$jqlLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.jql-label",
    defaultMessage: "JQL"
});
const $84536422a2f72f79$var$groupByLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.group-by-label",
    defaultMessage: "Group"
});
const $84536422a2f72f79$var$sortByLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.sort-by-label",
    defaultMessage: "Sort"
});
const $84536422a2f72f79$var$hideDoneLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.hide-done-label",
    defaultMessage: "Hide done"
});
const $84536422a2f72f79$var$showHierarchyLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.show-hierarchy-label",
    defaultMessage: "Show hierarchy"
});
const $84536422a2f72f79$var$yesValue = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.yes-value",
    defaultMessage: "Yes"
});
const $84536422a2f72f79$var$rovoHint = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.jira-view-create-and-configure.rovo-hint",
    defaultMessage: "Use Rovo to make more changes to your view."
});
const $84536422a2f72f79$export$bcb22fe5eff1f832 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { actions: actions, getStatus: getStatus, getReadonly: getReadonly, onConfirm: onConfirm, onCancel: onCancel, cloudId: cloudId, aaid: aaid } = t0;
    const firstAction = actions[0];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== firstAction || $[1] !== onConfirm) {
        t1 = ()=>{
            onConfirm(firstAction);
        };
        $[0] = firstAction;
        $[1] = onConfirm;
        $[2] = t1;
    } else t1 = $[2];
    const handleConfirm = t1;
    let t2;
    if ($[3] !== firstAction || $[4] !== onCancel) {
        t2 = ()=>{
            onCancel(firstAction);
        };
        $[3] = firstAction;
        $[4] = onCancel;
        $[5] = t2;
    } else t2 = $[5];
    const handleDismiss = t2;
    const jql = firstAction?.data.jql;
    let t3;
    if ($[6] !== jql) {
        t3 = jql ? (0, $7CSGi.parseViewJql)(jql) : {
            clauses: [],
            isComplex: false,
            sortBy: undefined
        };
        $[6] = jql;
        $[7] = t3;
    } else t3 = $[7];
    const { clauses: parsedClauses, isComplex: isJqlComplex, sortBy: sortBy } = t3;
    const shouldRenderRawJql = Boolean(jql) && (isJqlComplex || parsedClauses.length === 0);
    let t4;
    if ($[8] !== aaid || $[9] !== parsedClauses) {
        const literals = parsedClauses.filter($84536422a2f72f79$var$_temp).flatMap($84536422a2f72f79$var$_temp2);
        let t5;
        if ($[11] !== aaid) {
            t5 = (literal)=>literal.toLowerCase() === $84536422a2f72f79$var$CURRENT_USER_JQL_LITERAL.toLowerCase() && aaid ? aaid : literal;
            $[11] = aaid;
            $[12] = t5;
        } else t5 = $[12];
        const substituted = literals.map(t5);
        t4 = Array.from(new Set(substituted));
        $[8] = aaid;
        $[9] = parsedClauses;
        $[10] = t4;
    } else t4 = $[10];
    const idsToHydrate = t4;
    const { users: hydratedUsers } = (0, $43bN1.useHydratedFilterUsers)(idsToHydrate, cloudId);
    let map;
    if ($[13] !== aaid || $[14] !== hydratedUsers || $[15] !== parsedClauses) {
        map = new Map();
        for (const user of hydratedUsers)map.set(user.id, user.name);
        if (aaid) {
            const viewerName = map.get(aaid);
            if (viewerName) {
                let t5;
                if ($[17] !== parsedClauses) {
                    t5 = new Set(parsedClauses.filter($84536422a2f72f79$var$_temp3).flatMap($84536422a2f72f79$var$_temp4).filter($84536422a2f72f79$var$_temp5));
                    $[17] = parsedClauses;
                    $[18] = t5;
                } else t5 = $[18];
                const currentUserLiterals = t5;
                for (const literal_1 of currentUserLiterals)map.set(literal_1, viewerName);
            }
        }
        $[13] = aaid;
        $[14] = hydratedUsers;
        $[15] = parsedClauses;
        $[16] = map;
    } else map = $[16];
    const hydratedUserNamesById = map;
    if (!firstAction) return null;
    let t5;
    if ($[19] !== firstAction || $[20] !== getReadonly) {
        t5 = getReadonly(firstAction);
        $[19] = firstAction;
        $[20] = getReadonly;
        $[21] = t5;
    } else t5 = $[21];
    const readonly = t5;
    let t6;
    if ($[22] !== firstAction || $[23] !== getStatus) {
        t6 = getStatus(firstAction);
        $[22] = firstAction;
        $[23] = getStatus;
        $[24] = t6;
    } else t6 = $[24];
    const status = t6;
    const isFinished = status === "finished";
    const isInProgress = status === "started";
    const { groupBy: groupBy, hideDone: hideDone, hierarchyEnabled: hierarchyEnabled, fields: fields } = firstAction.data;
    let t7;
    if ($[25] !== formatMessage) {
        t7 = formatMessage($84536422a2f72f79$var$cardTitle);
        $[25] = formatMessage;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPeO7))), {
            label: ""
        });
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== fields || $[29] !== formatMessage || $[30] !== hydratedUserNamesById || $[31] !== jql || $[32] !== parsedClauses || $[33] !== shouldRenderRawJql) {
        t9 = jql && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "small",
            color: "color.text.subtle"
        }, formatMessage(shouldRenderRawJql ? $84536422a2f72f79$var$jqlLabel : $84536422a2f72f79$var$filterLabel)), shouldRenderRawJql ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, jql) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20KBU.ViewFilterChips), {
            clauses: parsedClauses,
            fields: fields,
            hydratedUserNamesById: hydratedUserNamesById
        }));
        $[28] = fields;
        $[29] = formatMessage;
        $[30] = hydratedUserNamesById;
        $[31] = jql;
        $[32] = parsedClauses;
        $[33] = shouldRenderRawJql;
        $[34] = t9;
    } else t9 = $[34];
    let t10;
    if ($[35] !== fields || $[36] !== formatMessage || $[37] !== groupBy) {
        t10 = groupBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($84536422a2f72f79$var$groupByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20KBU.ViewGroupChip), {
            groupBy: groupBy,
            fields: fields
        }));
        $[35] = fields;
        $[36] = formatMessage;
        $[37] = groupBy;
        $[38] = t10;
    } else t10 = $[38];
    let t11;
    if ($[39] !== fields || $[40] !== formatMessage || $[41] !== shouldRenderRawJql || $[42] !== sortBy) {
        t11 = sortBy && !shouldRenderRawJql && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($84536422a2f72f79$var$sortByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20KBU.ViewSortChip), {
            field: sortBy.field,
            direction: sortBy.direction,
            fields: fields
        }));
        $[39] = fields;
        $[40] = formatMessage;
        $[41] = shouldRenderRawJql;
        $[42] = sortBy;
        $[43] = t11;
    } else t11 = $[43];
    let t12;
    if ($[44] !== formatMessage || $[45] !== hideDone) {
        t12 = hideDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($84536422a2f72f79$var$hideDoneLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: formatMessage($84536422a2f72f79$var$yesValue),
            isRemovable: false,
            color: "standard",
            hasMargin: false
        })));
        $[44] = formatMessage;
        $[45] = hideDone;
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] !== formatMessage || $[48] !== hierarchyEnabled) {
        t13 = hierarchyEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($84536422a2f72f79$var$showHierarchyLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: formatMessage($84536422a2f72f79$var$yesValue),
            isRemovable: false,
            color: "standard",
            hasMargin: false
        })));
        $[47] = formatMessage;
        $[48] = hierarchyEnabled;
        $[49] = t13;
    } else t13 = $[49];
    let t14;
    if ($[50] !== formatMessage || $[51] !== handleConfirm || $[52] !== handleDismiss || $[53] !== isFinished || $[54] !== isInProgress || $[55] !== readonly) {
        t14 = !readonly && !isFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), {
            testId: "jira-view-create-and-configure-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignInline: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleDismiss,
            isDisabled: isInProgress,
            testId: "jira-view-create-and-configure-dismiss-button"
        }, formatMessage($84536422a2f72f79$var$dismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: isInProgress,
            testId: "jira-view-create-and-configure-confirm-button"
        }, formatMessage($84536422a2f72f79$var$confirmButton))));
        $[50] = formatMessage;
        $[51] = handleConfirm;
        $[52] = handleDismiss;
        $[53] = isFinished;
        $[54] = isInProgress;
        $[55] = readonly;
        $[56] = t14;
    } else t14 = $[56];
    let t15;
    if ($[57] !== t10 || $[58] !== t11 || $[59] !== t12 || $[60] !== t13 || $[61] !== t14 || $[62] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t9, t10, t11, t12, t13, t14);
        $[57] = t10;
        $[58] = t11;
        $[59] = t12;
        $[60] = t13;
        $[61] = t14;
        $[62] = t9;
        $[63] = t15;
    } else t15 = $[63];
    let t16;
    if ($[64] !== t15 || $[65] !== t7) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
            product: "jira",
            title: t7,
            defaultExpanded: true,
            isTitleBold: true,
            invertChevron: true,
            headerIcon: t8
        }, t15);
        $[64] = t15;
        $[65] = t7;
        $[66] = t16;
    } else t16 = $[66];
    let t17;
    if ($[67] !== formatMessage) {
        t17 = formatMessage($84536422a2f72f79$var$rovoHint);
        $[67] = formatMessage;
        $[68] = t17;
    } else t17 = $[68];
    let t18;
    if ($[69] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $84536422a2f72f79$var$styles.rovoHint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, t17));
        $[69] = t17;
        $[70] = t18;
    } else t18 = $[70];
    let t19;
    if ($[71] !== t16 || $[72] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t16, t18);
        $[71] = t16;
        $[72] = t18;
        $[73] = t19;
    } else t19 = $[73];
    return t19;
} : ({ actions: actions, getStatus: getStatus, getReadonly: getReadonly, onConfirm: onConfirm, onCancel: onCancel, cloudId: cloudId, aaid: aaid })=>{
    const firstAction = actions[0];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        onConfirm(firstAction);
    }, [
        firstAction,
        onConfirm
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        onCancel(firstAction);
    }, [
        firstAction,
        onCancel
    ]);
    const jql = firstAction?.data.jql;
    const { clauses: parsedClauses, isComplex: isJqlComplex, sortBy: sortBy } = (0, $cozmU.useMemo)(()=>jql ? (0, $7CSGi.parseViewJql)(jql) : {
            clauses: [],
            isComplex: false,
            sortBy: undefined
        }, [
        jql
    ]); // True when the JQL is structurally too complex to represent as filter chips (compound
    // AND/OR nesting, NOT), or when parsing produced no usable clauses at all. In both cases,
    // fall back to rendering the raw JQL string instead of silently rendering nothing.
    const shouldRenderRawJql = Boolean(jql) && (isJqlComplex || parsedClauses.length === 0);
    const idsToHydrate = (0, $cozmU.useMemo)(()=>{
        const literals = parsedClauses.filter((clause)=>$84536422a2f72f79$var$USER_FIELDS.has(clause.field.toLowerCase())).flatMap((clause_0)=>clause_0.value);
        const substituted = literals.map((literal)=>literal.toLowerCase() === $84536422a2f72f79$var$CURRENT_USER_JQL_LITERAL.toLowerCase() && aaid ? aaid : literal);
        return Array.from(new Set(substituted));
    }, [
        parsedClauses,
        aaid
    ]);
    const { users: hydratedUsers } = (0, $43bN1.useHydratedFilterUsers)(idsToHydrate, cloudId);
    const hydratedUserNamesById = (0, $cozmU.useMemo)(()=>{
        const map = new Map();
        for (const user of hydratedUsers)map.set(user.id, user.name);
        if (aaid) {
            const viewerName = map.get(aaid);
            if (viewerName) {
                // JQL function names are case-insensitive, so map every casing variant of
                // currentUser() actually present in the clauses, not just the canonical spelling.
                const currentUserLiterals = new Set(parsedClauses.filter((clause_1)=>$84536422a2f72f79$var$USER_FIELDS.has(clause_1.field.toLowerCase())).flatMap((clause_2)=>clause_2.value).filter((literal_0)=>literal_0.toLowerCase() === $84536422a2f72f79$var$CURRENT_USER_JQL_LITERAL.toLowerCase()));
                for (const literal_1 of currentUserLiterals)map.set(literal_1, viewerName);
            }
        }
        return map;
    }, [
        hydratedUsers,
        aaid,
        parsedClauses
    ]);
    if (!firstAction) return null;
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const isFinished = status === 'finished';
    const isInProgress = status === 'started';
    const { groupBy: groupBy, hideDone: hideDone, hierarchyEnabled: hierarchyEnabled, fields: fields } = firstAction.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        product: "jira",
        title: formatMessage($84536422a2f72f79$var$cardTitle),
        defaultExpanded: true,
        isTitleBold: true,
        invertChevron: true,
        headerIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPeO7))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, jql && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "small",
        color: "color.text.subtle"
    }, formatMessage(shouldRenderRawJql ? $84536422a2f72f79$var$jqlLabel : $84536422a2f72f79$var$filterLabel)), shouldRenderRawJql ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, jql) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20KBU.ViewFilterChips), {
        clauses: parsedClauses,
        fields: fields,
        hydratedUserNamesById: hydratedUserNamesById
    })), groupBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($84536422a2f72f79$var$groupByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20KBU.ViewGroupChip), {
        groupBy: groupBy,
        fields: fields
    })), sortBy && !shouldRenderRawJql && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($84536422a2f72f79$var$sortByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20KBU.ViewSortChip), {
        field: sortBy.field,
        direction: sortBy.direction,
        fields: fields
    })), hideDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($84536422a2f72f79$var$hideDoneLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: formatMessage($84536422a2f72f79$var$yesValue),
        isRemovable: false,
        color: "standard",
        hasMargin: false
    }))), hierarchyEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($84536422a2f72f79$var$showHierarchyLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: formatMessage($84536422a2f72f79$var$yesValue),
        isRemovable: false,
        color: "standard",
        hasMargin: false
    }))), !readonly && !isFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), {
        testId: "jira-view-create-and-configure-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleDismiss,
        isDisabled: isInProgress,
        testId: "jira-view-create-and-configure-dismiss-button"
    }, formatMessage($84536422a2f72f79$var$dismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: isInProgress,
        testId: "jira-view-create-and-configure-confirm-button"
    }, formatMessage($84536422a2f72f79$var$confirmButton)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $84536422a2f72f79$var$styles.rovoHint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage($84536422a2f72f79$var$rovoHint))));
};
function $84536422a2f72f79$var$_temp(clause) {
    return $84536422a2f72f79$var$USER_FIELDS.has(clause.field.toLowerCase());
}
function $84536422a2f72f79$var$_temp2(clause_0) {
    return clause_0.value;
}
function $84536422a2f72f79$var$_temp3(clause_1) {
    return $84536422a2f72f79$var$USER_FIELDS.has(clause_1.field.toLowerCase());
}
function $84536422a2f72f79$var$_temp4(clause_2) {
    return clause_2.value;
}
function $84536422a2f72f79$var$_temp5(literal_0) {
    return literal_0.toLowerCase() === $84536422a2f72f79$var$CURRENT_USER_JQL_LITERAL.toLowerCase();
}
module.exports["JiraViewCreateAndConfigureAction"] = $84536422a2f72f79$export$bcb22fe5eff1f832;

});

parcelRegister("lA8Lt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $eKMV3 = parcelRequire("eKMV3");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $hdBxM = parcelRequire("hdBxM");


var $dTEBe = parcelRequire("dTEBe");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $70CKC = parcelRequire("70CKC");


var $5STmA = parcelRequire("5STmA");


var $clJ5E = parcelRequire("clJ5E");


var $hyIrx = parcelRequire("hyIrx");


var $48y3r = parcelRequire("48y3r");

const $753ce4a42109723a$export$22fab0336b5c879b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { actions: actions, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, conversationId: conversationId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, messageId: messageId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const primaryAction = actions[0];
    let t1;
    if ($[0] !== getStatus || $[1] !== primaryAction) {
        t1 = getStatus(primaryAction);
        $[0] = getStatus;
        $[1] = primaryAction;
        $[2] = t1;
    } else t1 = $[2];
    const status = t1;
    const isDisabled = status === "finished" || status === "cancelled";
    const redirectOperations = primaryAction.data.operations.filter($753ce4a42109723a$var$_temp);
    const workflowOperations = primaryAction.data.operations.filter($753ce4a42109723a$var$_temp2);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t2;
    if ($[3] !== actions || $[4] !== conversationId || $[5] !== getStatus || $[6] !== messageId || $[7] !== onConfirm || $[8] !== primaryAction || $[9] !== publish || $[10] !== recipientAgentId || $[11] !== sendAnalyticsEvent || $[12] !== sendMessageConfirmedTools) {
        t2 = ()=>{
            publish({
                type: "jira-workflow-wizard-actions",
                source: "ai-mate",
                data: {
                    invocationId: primaryAction.invocationId,
                    operations: primaryAction.data.operations
                }
            });
            primaryAction.data.operations.forEach((operation_1)=>{
                sendAnalyticsEvent({
                    eventType: "track",
                    action: "applied",
                    actionSubject: "jiraWorkflowBuilderAction",
                    attributes: {
                        invocationId: primaryAction.invocationId,
                        operationType: operation_1.operationType,
                        ...operation_1.operationType === "ADD_RULE" ? {
                            ruleTemplateKey: operation_1.payload.ruleTemplateKey
                        } : {}
                    }
                });
            });
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "jiraWorkflowEditorRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === primaryAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed") : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
            } else onConfirm(primaryAction);
        };
        $[3] = actions;
        $[4] = conversationId;
        $[5] = getStatus;
        $[6] = messageId;
        $[7] = onConfirm;
        $[8] = primaryAction;
        $[9] = publish;
        $[10] = recipientAgentId;
        $[11] = sendAnalyticsEvent;
        $[12] = sendMessageConfirmedTools;
        $[13] = t2;
    } else t2 = $[13];
    const onConfirmAction = t2;
    let t3;
    if ($[14] !== actions || $[15] !== conversationId || $[16] !== getStatus || $[17] !== messageId || $[18] !== onCancel || $[19] !== primaryAction || $[20] !== recipientAgentId || $[21] !== sendMessageConfirmedTools) {
        t3 = ()=>{
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "jiraWorkflowEditorRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions_0.map($753ce4a42109723a$var$_temp3)
                    }
                });
            } else onCancel(primaryAction);
        };
        $[14] = actions;
        $[15] = conversationId;
        $[16] = getStatus;
        $[17] = messageId;
        $[18] = onCancel;
        $[19] = primaryAction;
        $[20] = recipientAgentId;
        $[21] = sendMessageConfirmedTools;
        $[22] = t3;
    } else t3 = $[22];
    const onCancelAction = t3;
    const t4 = redirectOperations.length > 0 && workflowOperations.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, redirectOperations.map((operation_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            shouldFitContainer: false,
            href: (0, $dTEBe.addRovoParamsToUrl)(operation_2.payload.url, {
                conversationId: conversationId || operation_2.payload.conversationId,
                pathway: "chat"
            })
        }, formatMessage((0, $5STmA.default).redirectToWorkflow))));
    const t5 = workflowOperations.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70CKC.WithGenericExternalActionError), {
        invocationId: primaryAction.invocationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $5STmA.default).jiraWorkflowEditorUIActionTitle),
        product: "jira"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, workflowOperations.map($753ce4a42109723a$var$_temp4), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onConfirmAction,
        isDisabled: isDisabled
    }, formatMessage((0, $5STmA.default).applyToWorkflow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onCancelAction,
        isDisabled: isDisabled
    }, formatMessage((0, $5STmA.default).cancelAction)))))));
    let t6;
    if ($[23] !== t4 || $[24] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[23] = t4;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ actions: actions, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, conversationId: conversationId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, messageId: messageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const primaryAction = actions[0];
    const status = getStatus(primaryAction);
    const isDisabled = status === 'finished' || status === 'cancelled';
    const redirectOperations = primaryAction.data.operations.filter((operation)=>operation.operationType === 'REDIRECT_TO_WORKFLOW');
    const workflowOperations = primaryAction.data.operations.filter((operation_0)=>operation_0.operationType !== 'REDIRECT_TO_WORKFLOW');
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const onConfirmAction = (0, $cozmU.useCallback)(()=>{
        publish({
            type: 'jira-workflow-wizard-actions',
            source: 'ai-mate',
            data: {
                invocationId: primaryAction.invocationId,
                operations: primaryAction.data.operations
            }
        });
        primaryAction.data.operations.forEach((operation_1)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'applied',
                actionSubject: 'jiraWorkflowBuilderAction',
                attributes: {
                    invocationId: primaryAction.invocationId,
                    operationType: operation_1.operationType,
                    ...operation_1.operationType === 'ADD_RULE' ? {
                        ruleTemplateKey: operation_1.payload.ruleTemplateKey
                    } : {}
                }
            });
        });
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'jiraWorkflowEditorRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === primaryAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed') : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
        } else onConfirm(primaryAction);
    }, [
        actions,
        conversationId,
        getStatus,
        messageId,
        onConfirm,
        primaryAction,
        publish,
        recipientAgentId,
        sendAnalyticsEvent,
        sendMessageConfirmedTools
    ]);
    const onCancelAction = (0, $cozmU.useCallback)(()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions_0 = actions.filter((action_1)=>getStatus(action_1) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'jiraWorkflowEditorRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions_0.map((action_2)=>(0, $7eUSO.buildToolFromAction)(action_2, 'cancelled'))
                }
            });
        } else onCancel(primaryAction);
    }, [
        actions,
        conversationId,
        getStatus,
        messageId,
        onCancel,
        primaryAction,
        recipientAgentId,
        sendMessageConfirmedTools
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, redirectOperations.length > 0 && workflowOperations.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, redirectOperations.map((operation_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            shouldFitContainer: false,
            href: (0, $dTEBe.addRovoParamsToUrl)(operation_2.payload.url, {
                conversationId: conversationId || operation_2.payload.conversationId,
                pathway: 'chat'
            })
        }, formatMessage((0, $5STmA.default).redirectToWorkflow)))), workflowOperations.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70CKC.WithGenericExternalActionError), {
        invocationId: primaryAction.invocationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $5STmA.default).jiraWorkflowEditorUIActionTitle),
        product: "jira"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, workflowOperations.map((operation_3)=>{
        switch(operation_3.operationType){
            case 'ADD_STATUS':
            case 'DELETE_STATUS':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hyIrx.StatusAction), operation_3.payload);
            case 'ADD_TRANSITION':
            case 'UPDATE_TRANSITION':
            case 'DELETE_TRANSITION':
                if (operation_3.operationType === 'DELETE_TRANSITION' && !(0, $iDrrr.fg)('hix-7888_-_delete_transition_expanded_fields')) return null;
                // @ts-expect-error - AddNew/Update/DeleteTransitionRovoPayload union not narrowed at call site; discriminated union needed
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48y3r.TransitionAction), operation_3.payload);
            case 'ADD_RULE':
            case 'DELETE_RULE':
                if (operation_3.operationType === 'DELETE_RULE' && !(0, $iDrrr.fg)('hix-7888_-_delete_transition_expanded_fields')) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $clJ5E.RuleAction), operation_3.payload);
            default:
                return null;
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onConfirmAction,
        isDisabled: isDisabled
    }, formatMessage((0, $5STmA.default).applyToWorkflow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onCancelAction,
        isDisabled: isDisabled
    }, formatMessage((0, $5STmA.default).cancelAction))))))));
};
function $753ce4a42109723a$var$_temp(operation) {
    return operation.operationType === "REDIRECT_TO_WORKFLOW";
}
function $753ce4a42109723a$var$_temp2(operation_0) {
    return operation_0.operationType !== "REDIRECT_TO_WORKFLOW";
}
function $753ce4a42109723a$var$_temp3(action_2) {
    return (0, $7eUSO.buildToolFromAction)(action_2, "cancelled");
}
function $753ce4a42109723a$var$_temp4(operation_3) {
    switch(operation_3.operationType){
        case "ADD_STATUS":
        case "DELETE_STATUS":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hyIrx.StatusAction), operation_3.payload);
        case "ADD_TRANSITION":
        case "UPDATE_TRANSITION":
        case "DELETE_TRANSITION":
            if (operation_3.operationType === "DELETE_TRANSITION" && !(0, $iDrrr.fg)("hix-7888_-_delete_transition_expanded_fields")) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48y3r.TransitionAction), operation_3.payload);
        case "ADD_RULE":
        case "DELETE_RULE":
            if (operation_3.operationType === "DELETE_RULE" && !(0, $iDrrr.fg)("hix-7888_-_delete_transition_expanded_fields")) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $clJ5E.RuleAction), operation_3.payload);
        default:
            return null;
    }
}
module.exports["JiraWorkflowEditorUIAction"] = $753ce4a42109723a$export$22fab0336b5c879b;

});

parcelRegister("gnApE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5HApy = parcelRequire("5HApy");


var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");


var $dw75i = parcelRequire("dw75i");


var $8QpHg = parcelRequire("8QpHg");


var $5Tn11 = parcelRequire("5Tn11");


var $l8U6Q = parcelRequire("l8U6Q");


var $85mU8 = parcelRequire("85mU8");


var $kIlwI = parcelRequire("kIlwI");


var $fWQmA = parcelRequire("fWQmA");

const $c303cb08a149118b$export$8c5ad5606e333469 = (props)=>{
    const { onActioned: onActioned } = props;
    const action = props.actions?.[0];
    const isActionEnded = props.getReadonly(action);
    const actionStatus = props.getStatus(action);
    const url = action?.data?.url;
    const bridgeAPI = (0, $85mU8.getBrowserBridgeAPI)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const createdRequestUrl = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!action) return;
        bridgeAPI.on((0, $5Tn11.ROVO_CHAT_CLIENT_ID), (0, $l8U6Q.NotifySuccessCommand), (command)=>{
            if (command.action !== action.invocationId) return;
            createdRequestUrl.current = command.requestUrl;
            onActioned(action, `${formatMessage((0, $fWQmA.default).jsmRequestCreatedDescription)} \n ${command.requestUrl}`);
        });
        // handlers have been setup - now we can mark ourselves as 'ready' to handle incoming messages
        bridgeAPI.ready((0, $5Tn11.ROVO_CHAT_CLIENT_ID));
    }, [
        bridgeAPI,
        onActioned,
        action,
        formatMessage
    ]);
    const senderClientId = (0, $8QpHg.HELP_CENTER_FORM_REQUEST_CLIENT_ID);
    // Callback ref to set attributes when iframe is mounted
    const onIframeRefAvailable = (0, $cozmU.useCallback)((iframe)=>{
        if (iframe) // needed for BRIDGE API to work across cross origin
        iframe.setAttribute('data-rovo-receiver-id', senderClientId);
    }, [
        senderClientId
    ]);
    if (!action || !url) return null;
    const urlWithActionParam = (0, $kIlwI.addQueryParam)(url, 'rovoChatTriggeringAction', action.invocationId);
    if (actionStatus === 'errored' && createdRequestUrl.current) // if some how there is an error while resolving the action,
    // we still want to show the user the request url because it was created successfully just not recorded in conversation assistant
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $fWQmA.default).jsmRequestCreatedDescription), " ", createdRequestUrl.current);
    if (isActionEnded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        key: urlWithActionParam,
        appearance: "embed",
        url: urlWithActionParam,
        showHoverPreview: true,
        embedIframeRef: onIframeRefAvailable,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick: (event)=>{
            event.preventDefault();
            window.open(urlWithActionParam, '_blank', 'noopener, noreferrer');
        }
    }));
};
const $c303cb08a149118b$export$53b8c24ae1ea67e5 = (actions)=>{
    return actions.filter($c303cb08a149118b$var$assertIsJsmCreateEmbeddedRequestAction);
};
const $c303cb08a149118b$var$assertIsJsmCreateEmbeddedRequestAction = (action)=>{
    if (action.key !== (0, $dw75i.JSM_CREATE_EMBEDDED_REQUEST_KEY)) throw new Error('Invalid action key for JsmCreateRequestAction');
    return action;
};
module.exports["JsmCreateEmbeddedRequestAction"] = $c303cb08a149118b$export$8c5ad5606e333469;

});

parcelRegister("6VP9j", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $kclKa = parcelRequire("kclKa");


var $y3pjR = parcelRequire("y3pjR");

const $cf550721e6518734$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $cf550721e6518734$var$ACTION_SUBJECT = 'jsmCreateQueueCard';
const $cf550721e6518734$export$aa93dd6312c8d088 = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_create_queue_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $cf550721e6518734$var$ACTION_SUBJECT,
                actionSubjectId: $cf550721e6518734$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $kclKa.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $cf550721e6518734$var$ACTION_SUBJECT,
            actionSubjectId: `${$cf550721e6518734$var$ACTION_SUBJECT}CreateButton`,
            attributes: {
                ...(0, $kclKa.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $cf550721e6518734$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $cf550721e6518734$var$ACTION_SUBJECT,
                actionSubjectId: `${$cf550721e6518734$var$ACTION_SUBJECT}CreateRequest`,
                attributes: {
                    ...(0, $kclKa.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $cf550721e6518734$var$ACTION_SUBJECT,
                actionSubjectId: `${$cf550721e6518734$var$ACTION_SUBJECT}CreateRequest`,
                attributes: {
                    ...(0, $kclKa.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $y3pjR.CreateQueueCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmCreateQueueAction"] = $cf550721e6518734$export$aa93dd6312c8d088;

});

parcelRegister("c9HnQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $6RlNM = parcelRequire("6RlNM");


var $R76XZ = parcelRequire("R76XZ");

const $4a69f0b88c12d01e$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $4a69f0b88c12d01e$var$ACTION_SUBJECT = 'jsmCreateQueueGroupCard';
const $4a69f0b88c12d01e$export$613bad214f97810e = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_create_queue_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $4a69f0b88c12d01e$var$ACTION_SUBJECT,
                actionSubjectId: $4a69f0b88c12d01e$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $6RlNM.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $4a69f0b88c12d01e$var$ACTION_SUBJECT,
            actionSubjectId: `${$4a69f0b88c12d01e$var$ACTION_SUBJECT}CreateButton`,
            attributes: {
                ...(0, $6RlNM.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $4a69f0b88c12d01e$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $4a69f0b88c12d01e$var$ACTION_SUBJECT,
                actionSubjectId: `${$4a69f0b88c12d01e$var$ACTION_SUBJECT}CreateRequest`,
                attributes: {
                    ...(0, $6RlNM.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $4a69f0b88c12d01e$var$ACTION_SUBJECT,
                actionSubjectId: `${$4a69f0b88c12d01e$var$ACTION_SUBJECT}CreateRequest`,
                attributes: {
                    ...(0, $6RlNM.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $R76XZ.CreateQueueGroupCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmCreateQueueGroupAction"] = $4a69f0b88c12d01e$export$613bad214f97810e;

});

parcelRegister("d7n6A", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dw75i = parcelRequire("dw75i");


var $egY3r = parcelRequire("egY3r");

const $863ca82da5b6be5b$export$57a5c5aa0651b43b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $egY3r.JsmCreateRequestActionUnifiedRenderer), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $egY3r.JsmCreateRequestActionUnifiedRenderer), props);
const $863ca82da5b6be5b$export$f66099e378da1467 = (actions)=>{
    return actions.filter($863ca82da5b6be5b$var$assertIsJsmCreateRequestAction);
};
const $863ca82da5b6be5b$var$assertIsJsmCreateRequestAction = (action)=>{
    if (action.key !== (0, $dw75i.JSM_CREATE_REQUEST_KEY) && action.key !== (0, $dw75i.JSM_CREATE_REQUEST_V2_KEY) && action.key !== (0, $dw75i.CREATE_REQUEST_KEY)) throw new Error('Invalid action key for JsmCreateRequestAction');
    return action;
};
module.exports["JsmCreateRequestAction"] = $863ca82da5b6be5b$export$57a5c5aa0651b43b;

});

parcelRegister("2YoWj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $5tB2a = parcelRequire("5tB2a");


var $fm7Eo = parcelRequire("fm7Eo");

const $f16bee1dabfa24fa$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $f16bee1dabfa24fa$var$ACTION_SUBJECT = 'jsmCreateRequestTypeCard';
const $f16bee1dabfa24fa$export$f4b321fb2674e26f = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_manage_request_type_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $f16bee1dabfa24fa$var$ACTION_SUBJECT,
                actionSubjectId: $f16bee1dabfa24fa$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $5tB2a.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $f16bee1dabfa24fa$var$ACTION_SUBJECT,
            actionSubjectId: `${$f16bee1dabfa24fa$var$ACTION_SUBJECT}CreateButton`,
            attributes: {
                ...(0, $5tB2a.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $f16bee1dabfa24fa$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $f16bee1dabfa24fa$var$ACTION_SUBJECT,
                actionSubjectId: `${$f16bee1dabfa24fa$var$ACTION_SUBJECT}CreateRequest`,
                attributes: {
                    ...(0, $5tB2a.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $f16bee1dabfa24fa$var$ACTION_SUBJECT,
                actionSubjectId: `${$f16bee1dabfa24fa$var$ACTION_SUBJECT}CreateRequest`,
                attributes: {
                    ...(0, $5tB2a.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fm7Eo.CreateRequestTypeCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmCreateRequestTypeAction"] = $f16bee1dabfa24fa$export$f4b321fb2674e26f;

});

parcelRegister("7hpvX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $138c878d0f346615$export$fc4f9801eb323fe1 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cxFP3")).then((m)=>({
            default: m.JsmJourneyBuilderUIAction
        })));
module.exports["JsmJourneyBuilderUIActionAsync"] = $138c878d0f346615$export$fc4f9801eb323fe1;

});

parcelRegister("iaX6U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cf3SG = parcelRequire("cf3SG");

const $f75fe876ea0aed4e$export$fdcc765cd79a1c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf3SG.JsmLivechatActionRenderer), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf3SG.JsmLivechatActionRenderer), props);
module.exports["JsmLivechatAction"] = $f75fe876ea0aed4e$export$fdcc765cd79a1c18;

});

parcelRegister("zlRck", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $eexG9 = parcelRequire("eexG9");

const $9b6496cc552c9f28$var$ACTION_SUBJECT = 'jsmSelectHardwareTypesCard';
const $9b6496cc552c9f28$export$87e0b3b1659a39a9 = ({ actions: actions, getStatus: getStatus, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId, isHistoricalMessage: isHistoricalMessage })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededInvocationIds, setSucceededInvocationIds] = (0, $cozmU.useState)(new Set());
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $9b6496cc552c9f28$var$ACTION_SUBJECT,
                actionSubjectId: $9b6496cc552c9f28$var$ACTION_SUBJECT,
                attributes: {
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        isHistoricalMessage,
        messageId,
        sendAnalyticsEvent
    ]);
    const sendCardInteractionEvent = (0, $cozmU.useCallback)((actionSubjectId, attributes)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $9b6496cc552c9f28$var$ACTION_SUBJECT,
            actionSubjectId: actionSubjectId,
            attributes: {
                conversationId: conversationId,
                messageId: messageId,
                ...attributes
            }
        });
    }, [
        conversationId,
        messageId,
        sendAnalyticsEvent
    ]);
    const handleExpandToggle = (0, $cozmU.useCallback)((isExpanded)=>{
        sendCardInteractionEvent(`${$9b6496cc552c9f28$var$ACTION_SUBJECT}ExpandToggle`, {
            isExpanded: isExpanded
        });
    }, [
        sendCardInteractionEvent
    ]);
    const handleHardwareTypeToggle = (0, $cozmU.useCallback)((hardwareTypeName, isSelected)=>{
        sendCardInteractionEvent(`${$9b6496cc552c9f28$var$ACTION_SUBJECT}HardwareTypeCheckbox`, {
            hardwareTypeName: hardwareTypeName,
            isSelected: isSelected
        });
    }, [
        sendCardInteractionEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0, selectedHardwareTypes)=>{
        sendCardInteractionEvent(`${$9b6496cc552c9f28$var$ACTION_SUBJECT}NextButton`);
        if (!sendMessageConfirmedTools || !conversationId || !messageId) return;
        setAwaitingInvocationId(action_0.invocationId);
        try {
            await sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'jsmSelectHardwareTypesAction'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        {
                            key: action_0.key,
                            tool_id: action_0.actionId,
                            tool_source: action_0.toolSource,
                            invocation_id: action_0.invocationId,
                            data: {
                                human_message_id: action_0.humanMessageId ?? '',
                                arguments: {
                                    inputs: {
                                        projectId: action_0.data.projectId,
                                        userInput: `I want to track ${selectedHardwareTypes.join(', ')}`
                                    }
                                }
                            }
                        }
                    ]
                }
            });
            setSucceededInvocationIds((prev)=>new Set(prev).add(action_0.invocationId));
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'succeeded',
                actionSubject: $9b6496cc552c9f28$var$ACTION_SUBJECT,
                actionSubjectId: `${$9b6496cc552c9f28$var$ACTION_SUBJECT}ConfirmRequest`,
                attributes: {
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'success'
                }
            });
        } catch  {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $9b6496cc552c9f28$var$ACTION_SUBJECT,
                actionSubjectId: `${$9b6496cc552c9f28$var$ACTION_SUBJECT}ConfirmRequest`,
                attributes: {
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        sendCardInteractionEvent,
        sendAnalyticsEvent,
        sendMessageConfirmedTools,
        conversationId,
        messageId,
        recipientAgentId
    ]);
    if (!actions.length) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededInvocationIds.has(action_1.invocationId) || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eexG9.SelectHardwareTypesCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: (selectedHardwareTypes_0)=>handleNextForAction(action_1, selectedHardwareTypes_0),
            onExpandToggle: handleExpandToggle,
            onHardwareTypeToggle: handleHardwareTypeToggle,
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmSelectHardwareTypesAction"] = $9b6496cc552c9f28$export$87e0b3b1659a39a9;

});

parcelRegister("lKXhN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $aZB6I = parcelRequire("aZB6I");


var $gzMZq = parcelRequire("gzMZq");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $g9AEK = parcelRequire("g9AEK");


var $ceCEH = parcelRequire("ceCEH");

const $7bcf4dabb2703bd1$var$successMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.jsm-solution-composer-plan.success",
    defaultMessage: "You created {title} space"
});
const $7bcf4dabb2703bd1$export$c09aa0dea3978269 = ({ actions: actions, sendMessageConfirmedTools: sendMessageConfirmedTools, conversationId: conversationId, messageId: messageId, recipientAgentId: recipientAgentId, isHistoricalMessage: isHistoricalMessage })=>{
    (0, $6cFsl.di)((0, $ceCEH.TaskCard));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { getAIFeatureContext: getAIFeatureContext, setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const [conversationMessages] = (0, $iW40i.useChatMessages)({
        conversationId: conversationId ?? ''
    });
    const isSuperseded = (0, $cozmU.useMemo)(()=>{
        if (!messageId) return false;
        const myIndex = conversationMessages.findIndex((m)=>(0, $igOtY.isStoreAssistant)(m) && m.content.message.message.id === messageId);
        if (myIndex === -1) return false;
        return conversationMessages.slice(myIndex + 1).some((m_0)=>(0, $igOtY.isStoreAssistant)(m_0) && m_0.content.message.message.actions?.some((a)=>a.key === (0, $dw75i.ActionKeys).JsmSolutionComposerPlanSummary));
    }, [
        conversationMessages,
        messageId
    ]);
    const firstAction = actions[0];
    const handleCreateSpace = (0, $cozmU.useCallback)(async ()=>{
        if (!firstAction || !sendMessageConfirmedTools || !conversationId || !messageId) return;
        const previousSolutionComposerContext = getAIFeatureContext()?.solutionComposerContext;
        setAIFeatureContext({
            contextKey: 'solutionComposerContext',
            setContext: (_)=>({
                    domainType: 'SERVICE',
                    skillTypes: null
                })
        });
        try {
            await sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'jsmCreateSpaceAction'
                },
                includeAIFeatureContext: true,
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        {
                            key: firstAction.key,
                            tool_id: firstAction.actionId,
                            tool_source: firstAction.toolSource,
                            invocation_id: firstAction.invocationId,
                            data: {
                                human_message_id: firstAction.humanMessageId ?? '',
                                arguments: {
                                    type: 'confirm'
                                }
                            }
                        }
                    ]
                }
            });
        } finally{
            setAIFeatureContext({
                contextKey: 'solutionComposerContext',
                setContext: (_)=>previousSolutionComposerContext
            });
        }
    }, [
        firstAction,
        sendMessageConfirmedTools,
        conversationId,
        messageId,
        recipientAgentId,
        getAIFeatureContext,
        setAIFeatureContext
    ]);
    const isFeatureGateEnabled = (0, $iDrrr.fg)('solution_composer_master');
    const isSpaceKeyValidationEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_composer_s2_space_key_validation');
    const isExecuted = firstAction?.data?.executed;
    const validatedProjectKey = isSpaceKeyValidationEnabled ? firstAction?.data?.projectKey : undefined;
    const projectKey = isExecuted ? firstAction?.data?.key : validatedProjectKey;
    const hasCreatedSpace = Boolean(isExecuted && projectKey);
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    const hasFiredAdoptedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!firstAction || !isFeatureGateEnabled || isHistoricalMessage) return;
        if (!hasCreatedSpace && !hasFiredViewedRef.current) {
            hasFiredViewedRef.current = true;
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: 'jsmSolutionComposerPlanCard',
                actionSubjectId: 'jsmSolutionComposerPlanCard',
                attributes: {
                    ...(0, $g9AEK.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        }
        if (hasCreatedSpace && !hasFiredAdoptedRef.current) {
            hasFiredAdoptedRef.current = true;
            // added adopted event here as this is tracked after sendMessageConfirmedTools
            trackAIMAUEvent({
                type: 'adopted',
                actionKey: firstAction.key,
                proactive: true,
                rovoModifiedObjects: [
                    {
                        objectType: 'jsm-project',
                        objectId: projectKey
                    }
                ],
                messageId: messageId,
                attributes: (0, $g9AEK.analyticsAttributes)
            });
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: 'jsmSolutionComposerSpaceCard',
                actionSubjectId: 'jsmSolutionComposerSpaceCard',
                attributes: {
                    ...(0, $g9AEK.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        }
    }, [
        firstAction,
        isFeatureGateEnabled,
        isHistoricalMessage,
        hasCreatedSpace,
        projectKey,
        messageId,
        conversationId,
        trackAIMAUEvent,
        sendAnalyticsEvent
    ]);
    if (!firstAction || !isFeatureGateEnabled) return null;
    const title = firstAction.data.name ?? '';
    const projectName = firstAction.data.projectName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ceCEH.TaskCard), {
        title: title,
        sections: firstAction.data.sections ?? [],
        onCreateSpace: handleCreateSpace,
        isExecuted: isExecuted,
        projectKey: projectKey,
        projectName: projectName,
        isDisabled: isSuperseded
    }), hasCreatedSpace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        message: formatMessage($7bcf4dabb2703bd1$var$successMessage, {
            title: title
        })
    }) : null);
};
module.exports["JsmSolutionComposerPlanAction"] = $7bcf4dabb2703bd1$export$c09aa0dea3978269;

});

parcelRegister("iSPda", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $cp2w0 = parcelRequire("cp2w0");


var $3M9ch = parcelRequire("3M9ch");

const $0bc9b12b002c3b72$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $0bc9b12b002c3b72$var$ACTION_SUBJECT = 'jsmUpdateQueueCard';
const $0bc9b12b002c3b72$export$e175d61232be9482 = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_create_queue_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $0bc9b12b002c3b72$var$ACTION_SUBJECT,
                actionSubjectId: $0bc9b12b002c3b72$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $cp2w0.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $0bc9b12b002c3b72$var$ACTION_SUBJECT,
            actionSubjectId: `${$0bc9b12b002c3b72$var$ACTION_SUBJECT}UpdateButton`,
            attributes: {
                ...(0, $cp2w0.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $0bc9b12b002c3b72$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $0bc9b12b002c3b72$var$ACTION_SUBJECT,
                actionSubjectId: `${$0bc9b12b002c3b72$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $cp2w0.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $0bc9b12b002c3b72$var$ACTION_SUBJECT,
                actionSubjectId: `${$0bc9b12b002c3b72$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $cp2w0.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3M9ch.UpdateQueueCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmUpdateQueueAction"] = $0bc9b12b002c3b72$export$e175d61232be9482;

});

parcelRegister("kWSOP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $856Cd = parcelRequire("856Cd");


var $j1Rh2 = parcelRequire("j1Rh2");

const $8789533acb6dc926$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $8789533acb6dc926$var$ACTION_SUBJECT = 'jsmUpdateQueueGroupCard';
const $8789533acb6dc926$export$c0b576d5a15e1804 = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_create_queue_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $8789533acb6dc926$var$ACTION_SUBJECT,
                actionSubjectId: $8789533acb6dc926$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $856Cd.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $8789533acb6dc926$var$ACTION_SUBJECT,
            actionSubjectId: `${$8789533acb6dc926$var$ACTION_SUBJECT}UpdateButton`,
            attributes: {
                ...(0, $856Cd.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $8789533acb6dc926$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $8789533acb6dc926$var$ACTION_SUBJECT,
                actionSubjectId: `${$8789533acb6dc926$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $856Cd.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $8789533acb6dc926$var$ACTION_SUBJECT,
                actionSubjectId: `${$8789533acb6dc926$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $856Cd.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rh2.UpdateQueueGroupCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmUpdateQueueGroupAction"] = $8789533acb6dc926$export$c0b576d5a15e1804;

});

parcelRegister("2ZDVq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $9SCtB = parcelRequire("9SCtB");


var $5NIGF = parcelRequire("5NIGF");

const $bfee5a2af1dc33e1$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $bfee5a2af1dc33e1$var$ACTION_SUBJECT = 'jsmUpdateRequestTypeCard';
const $bfee5a2af1dc33e1$export$e37b19ce7e46a00e = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_manage_request_type_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $bfee5a2af1dc33e1$var$ACTION_SUBJECT,
                actionSubjectId: $bfee5a2af1dc33e1$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $9SCtB.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $bfee5a2af1dc33e1$var$ACTION_SUBJECT,
            actionSubjectId: `${$bfee5a2af1dc33e1$var$ACTION_SUBJECT}UpdateButton`,
            attributes: {
                ...(0, $9SCtB.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $bfee5a2af1dc33e1$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $bfee5a2af1dc33e1$var$ACTION_SUBJECT,
                actionSubjectId: `${$bfee5a2af1dc33e1$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $9SCtB.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $bfee5a2af1dc33e1$var$ACTION_SUBJECT,
                actionSubjectId: `${$bfee5a2af1dc33e1$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $9SCtB.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5NIGF.UpdateRequestTypeCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmUpdateRequestTypeAction"] = $bfee5a2af1dc33e1$export$e37b19ce7e46a00e;

});

parcelRegister("4hmYp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $D6UqO = parcelRequire("D6UqO");


var $b3xba = parcelRequire("b3xba");

const $c84eb8adb276abe6$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $c84eb8adb276abe6$var$ACTION_SUBJECT = 'jsmUpdateRequestTypePortalGroupsCard';
const $c84eb8adb276abe6$export$dc6144225d4db74f = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_manage_request_type_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $c84eb8adb276abe6$var$ACTION_SUBJECT,
                actionSubjectId: $c84eb8adb276abe6$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $D6UqO.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $c84eb8adb276abe6$var$ACTION_SUBJECT,
            actionSubjectId: `${$c84eb8adb276abe6$var$ACTION_SUBJECT}UpdateButton`,
            attributes: {
                ...(0, $D6UqO.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $c84eb8adb276abe6$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $c84eb8adb276abe6$var$ACTION_SUBJECT,
                actionSubjectId: `${$c84eb8adb276abe6$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $D6UqO.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $c84eb8adb276abe6$var$ACTION_SUBJECT,
                actionSubjectId: `${$c84eb8adb276abe6$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $D6UqO.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3xba.UpdateRequestTypePortalGroupsCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmUpdateRequestTypePortalGroupsAction"] = $c84eb8adb276abe6$export$dc6144225d4db74f;

});

parcelRegister("57C1v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bxkJA = parcelRequire("bxkJA");


var $kyUYu = parcelRequire("kyUYu");


var $8eC5Y = parcelRequire("8eC5Y");

const $4ede9e4062286827$var$actionResponseIndicatesSuccess = (message)=>(0, $bxkJA.isActionExecutedSuccessfully)(message);
const $4ede9e4062286827$var$ACTION_SUBJECT = 'jsmUpdateRequestTypeWorkflowCard';
const $4ede9e4062286827$export$3150b2130b578e3f = ({ actions: actions, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [awaitingInvocationId, setAwaitingInvocationId] = (0, $cozmU.useState)(null);
    const [succeededFromResponseByInvocationId, setSucceededFromResponseByInvocationId] = (0, $cozmU.useState)({});
    const isFeatureGateEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_manage_request_type_anthropic');
    const viewedInvocationIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureGateEnabled || isHistoricalMessage || actions.length === 0) return;
        actions.forEach((action)=>{
            if (viewedInvocationIdsRef.current.has(action.invocationId)) return;
            viewedInvocationIdsRef.current.add(action.invocationId);
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: $4ede9e4062286827$var$ACTION_SUBJECT,
                actionSubjectId: $4ede9e4062286827$var$ACTION_SUBJECT,
                attributes: {
                    ...(0, $kyUYu.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId
                }
            });
        });
    }, [
        actions,
        conversationId,
        messageId,
        isHistoricalMessage,
        isFeatureGateEnabled,
        sendAnalyticsEvent
    ]);
    const handleNextForAction = (0, $cozmU.useCallback)(async (action_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $4ede9e4062286827$var$ACTION_SUBJECT,
            actionSubjectId: `${$4ede9e4062286827$var$ACTION_SUBJECT}UpdateButton`,
            attributes: {
                ...(0, $kyUYu.analyticsAttributes),
                conversationId: conversationId,
                messageId: messageId
            }
        });
        setAwaitingInvocationId(action_0.invocationId);
        try {
            const processorResult = await onCustomDataConfirm(action_0, action_0.data, $4ede9e4062286827$var$actionResponseIndicatesSuccess);
            const succeeded = processorResult === true;
            setSucceededFromResponseByInvocationId((prev)=>({
                    ...prev,
                    [action_0.invocationId]: succeeded
                }));
            sendAnalyticsEvent({
                eventType: 'track',
                action: succeeded ? 'succeeded' : 'failed',
                actionSubject: $4ede9e4062286827$var$ACTION_SUBJECT,
                actionSubjectId: `${$4ede9e4062286827$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $kyUYu.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: succeeded ? 'success' : 'error'
                }
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: $4ede9e4062286827$var$ACTION_SUBJECT,
                actionSubjectId: `${$4ede9e4062286827$var$ACTION_SUBJECT}UpdateRequest`,
                attributes: {
                    ...(0, $kyUYu.analyticsAttributes),
                    conversationId: conversationId,
                    messageId: messageId,
                    outcome: 'error'
                }
            });
            throw error;
        } finally{
            setAwaitingInvocationId(null);
        }
    }, [
        onCustomDataConfirm,
        sendAnalyticsEvent,
        conversationId,
        messageId
    ]);
    if (!actions.length || !isFeatureGateEnabled) return null;
    const anyConfirmInFlight = awaitingInvocationId !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, actions.map((action_1)=>{
        const actionFinishedPersisted = getStatus(action_1) === 'finished' || action_1.status === 'finished';
        const isSuccess = succeededFromResponseByInvocationId[action_1.invocationId] === true || actionFinishedPersisted;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8eC5Y.UpdateRequestTypeWorkflowCard), {
            key: action_1.invocationId,
            payload: action_1.data,
            onNext: ()=>handleNextForAction(action_1),
            isNextLoading: awaitingInvocationId === action_1.invocationId,
            isNextDisabled: anyConfirmInFlight || isSuccess,
            isSuccess: isSuccess
        });
    }));
};
module.exports["JsmUpdateRequestTypeWorkflowAction"] = $4ede9e4062286827$export$3150b2130b578e3f;

});

parcelRegister("dG9ot", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $cf0c86a1ae40c7f2$export$ef805a0d9eece069 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("d6fii")).then((m)=>({
            default: m.PlanCompleteRenderer
        })));

const $cf0c86a1ae40c7f2$export$8c7839d4fa3cee28 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("d6fii")).then((m)=>({
            default: m.PlanCompleteReadOnlyRenderer
        })));
module.exports["PlanCompleteRendererAsync"] = $cf0c86a1ae40c7f2$export$ef805a0d9eece069;
module.exports["PlanCompleteReadOnlyRendererAsync"] = $cf0c86a1ae40c7f2$export$8c7839d4fa3cee28;

});

parcelRegister("jJX9i", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $hdBxM = parcelRequire("hdBxM");


var $dw75i = parcelRequire("dw75i");


var $oUCjh = parcelRequire("oUCjh");

const $a3c094983de2ac21$var$assertIsRequireInformationAction = (action)=>{
    if (action.key !== (0, $dw75i.REQUIRE_INFORMATION_TOOL)) throw new Error('Invalid action key for RequireInformationTool');
    return action;
};
const $a3c094983de2ac21$export$d3444d1eac07b488 = (actions)=>{
    return actions.filter($a3c094983de2ac21$var$assertIsRequireInformationAction);
};
const $a3c094983de2ac21$export$a768640d5638f033 = ({ actions: actions, cloudId: cloudId, productKey: productKey })=>{
    (0, $6cFsl.di)((0, $oUCjh.ProjectSelector), (0, $hdBxM.usePublish));
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const firstAction = actions[0];
    const sendConfirmMessage = (0, $cozmU.useCallback)((message)=>{
        publish({
            type: 'message-send',
            source: 'ai-mate',
            data: {
                prompt: message,
                productKey: productKey
            }
        });
    }, [
        publish,
        productKey
    ]);
    const renderTool = ()=>{
        switch(firstAction.data?.toolName){
            case 'JiraProjectSearchTool':
                return /*#__PURE__*/ $cozmU.createElement((0, $oUCjh.ProjectSelector), {
                    siteId: cloudId,
                    setProject: ({ projectName: projectName })=>sendConfirmMessage(projectName)
                });
            default:
                return null;
        }
    };
    return renderTool();
};
module.exports["RequireInformationUIAction"] = $a3c094983de2ac21$export$a768640d5638f033;

});

parcelRegister("e047Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a29a730bef381ecc$export$707f87d8825b2bcc = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1f0MK")).then((m)=>({
            default: m.ResumptionRenderer
        })));
module.exports["ResumptionRendererAsync"] = $a29a730bef381ecc$export$707f87d8825b2bcc;

});

parcelRegister("2ir3c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $dw75i = parcelRequire("dw75i");


var $SJBPH = parcelRequire("SJBPH");


var $b11DE = parcelRequire("b11DE");


var $aZB6I = parcelRequire("aZB6I");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $6iyQh = parcelRequire("6iyQh");


var $fESy2 = parcelRequire("fESy2");


var $8KSQx = parcelRequire("8KSQx");


var $9krqg = parcelRequire("9krqg");


var $KvxxC = parcelRequire("KvxxC");

const $e88b2964dc5e1521$var$DAY_ORDER = (0, $SJBPH.SCHEDULED_CHAT_DAYS);
const $e88b2964dc5e1521$var$SCHEDULED_CHAT_INTERACTION_SOURCE = 'scheduledChatRenderer';
const $e88b2964dc5e1521$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS"
};
const $e88b2964dc5e1521$export$7e7d14613c742e23 = (actions)=>{
    const filtered = actions.filter((action)=>{
        if (action.key !== (0, $dw75i.SCHEDULED_CHAT_KEY)) throw new Error('Invalid action key for ScheduledChatAction');
        return true;
    });
    return filtered;
};
const $e88b2964dc5e1521$var$ScheduledChatActionFooter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isSubmitting: isSubmitting, isSaveDisabled: isSaveDisabled, onSave: onSave } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $fESy2.default).createButton);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== isSaveDisabled || $[3] !== isSubmitting || $[4] !== onSave || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e88b2964dc5e1521$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onSave,
            isLoading: isSubmitting,
            isDisabled: isSaveDisabled,
            testId: "scheduled-chat-create"
        }, t1));
        $[2] = isSaveDisabled;
        $[3] = isSubmitting;
        $[4] = onSave;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ isSubmitting: isSubmitting, isSaveDisabled: isSaveDisabled, onSave: onSave })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e88b2964dc5e1521$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onSave,
        isLoading: isSubmitting,
        isDisabled: isSaveDisabled,
        testId: "scheduled-chat-create"
    }, formatMessage((0, $fESy2.default).createButton)));
};
const $e88b2964dc5e1521$export$64d1cadd42271bab = (props)=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { actions: actions, getReadonly: getReadonly, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, productKey: productKey, cloudId: cloudId, experienceId: experienceId, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = props;
    const firstAction = actions[0];
    const readonly = getReadonly(firstAction);
    const status = getStatus(firstAction);
    const isActionLoading = status !== 'idle';
    const isSubmitting = status === 'started';
    const isFinished = status === 'finished' || firstAction.status === 'finished';
    const data = firstAction.data;
    const frontendData = (0, $cozmU.useMemo)(()=>(0, $SJBPH.convertFromBackendPayload)(data), [
        data
    ]);
    const [name, setName] = (0, $cozmU.useState)(frontendData.name);
    const [prompt, setPrompt] = (0, $cozmU.useState)(frontendData.prompt);
    const [frequency, setFrequency] = (0, $cozmU.useState)(frontendData.frequency);
    const [daysOfWeek, setDaysOfWeek] = (0, $cozmU.useState)(frontendData.daysOfWeek.length ? frontendData.daysOfWeek : [
        $e88b2964dc5e1521$var$DAY_ORDER[0]
    ]);
    const [time, setTime] = (0, $cozmU.useState)(frontendData.time);
    const [isEditorModalOpen, setIsEditorModalOpen] = (0, $cozmU.useState)(false);
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(false);
    const [studioWorkspaceId, setStudioWorkspaceId] = (0, $cozmU.useState)(undefined);
    const [studioSpaceId, setStudioSpaceId] = (0, $cozmU.useState)(undefined); // Fetch once on mount (or if product/site context changes) to resolve
    // the Studio workspace and space IDs needed for edit/delete operations.
    (0, $cozmU.useEffect)(()=>{
        if (!experienceId) return;
        let cancelled = false;
        (0, $SJBPH.fetchScheduledChatStudioInfo)({
            productHeader: productKey,
            experienceId: experienceId,
            cloudId: cloudId
        }).then((info)=>{
            if (!cancelled && info) {
                setStudioWorkspaceId(info.workspaceId);
                setStudioSpaceId(info.spaceId);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        productKey,
        cloudId,
        experienceId
    ]);
    const selectedDays = (0, $cozmU.useMemo)(()=>frequency === 'custom' ? daysOfWeek : daysOfWeek.slice(0, 1), [
        daysOfWeek,
        frequency
    ]);
    const currentFrontendPayload = (0, $cozmU.useMemo)(()=>({
            name: name.trim(),
            prompt: prompt.trim(),
            frequency: frequency,
            daysOfWeek: selectedDays,
            time: time
        }), [
        frequency,
        name,
        prompt,
        selectedDays,
        time
    ]);
    const currentBackendPayload = (0, $cozmU.useMemo)(()=>{
        try {
            return (0, $SJBPH.convertToBackendPayload)(currentFrontendPayload);
        } catch  {
            return null;
        }
    }, [
        currentFrontendPayload
    ]);
    const [pendingDelete, setPendingDelete] = (0, $cozmU.useState)(null);
    const [isDeletingScheduledChat, setIsDeletingScheduledChat] = (0, $cozmU.useState)(false);
    const studioRuleId = (0, $cozmU.useMemo)(()=>{
        const raw = firstAction.data.ruleIdUuid;
        return typeof raw === 'string' && raw.trim() !== '' ? raw.trim() : undefined;
    }, [
        firstAction.data
    ]);
    const harvestedRRule = (0, $cozmU.useMemo)(()=>{
        const raw_0 = firstAction.data.rRule;
        return typeof raw_0 === 'string' && raw_0.trim() !== '' ? raw_0.trim() : undefined;
    }, [
        firstAction.data
    ]);
    const openDeleteModal = (0, $cozmU.useCallback)(()=>{
        if (!studioRuleId) return;
        setPendingDelete({
            id: studioRuleId,
            title: currentFrontendPayload.name
        });
    }, [
        studioRuleId,
        currentFrontendPayload.name
    ]);
    const closeDeleteModal = (0, $cozmU.useCallback)(()=>{
        if (!isDeletingScheduledChat) setPendingDelete(null);
    }, [
        isDeletingScheduledChat
    ]);
    const confirmDelete = (0, $cozmU.useCallback)(()=>{
        const target = pendingDelete;
        if (!target) return;
        if (studioWorkspaceId === undefined || studioSpaceId === undefined) return;
        const workspaceId = studioWorkspaceId;
        const spaceId = studioSpaceId;
        (async ()=>{
            setIsDeletingScheduledChat(true);
            try {
                const res = await (0, $SJBPH.deleteStudioSc3Rule)({
                    workspaceId: workspaceId,
                    spaceId: spaceId,
                    ruleId: target.id
                });
                if (!res.ok) return;
                setPendingDelete(null);
            } catch  {} finally{
                setIsDeletingScheduledChat(false);
            }
        })();
    }, [
        pendingDelete,
        studioWorkspaceId,
        studioSpaceId
    ]);
    const isSaveDisabled = readonly || isActionLoading || !name.trim() || !prompt.trim() || frequency !== 'hourly' && !time.trim() || frequency === 'custom' && daysOfWeek.length === 0;
    const handleSave = (0, $cozmU.useCallback)(async ()=>{
        if (!currentBackendPayload) return;
        try {
            if ((0, $iDrrr.fg)('rovo_tools_resumption_migration_phase2')) {
                const plannedActions = actions.filter((action)=>getStatus(action) === 'idle');
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: $e88b2964dc5e1521$var$SCHEDULED_CHAT_INTERACTION_SOURCE
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: plannedActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', currentBackendPayload) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                    }
                });
                return;
            } // Rule creation is performed by the message-action / assist resolution path; we only confirm the payload.
            await onCustomDataConfirm(firstAction, currentBackendPayload);
        } catch (error) {
            throw new Error(`Failed to create scheduled chat: ${error instanceof Error ? error.message : 'Unknown error'}`);
        }
    }, [
        actions,
        conversationId,
        currentBackendPayload,
        firstAction,
        getStatus,
        messageId,
        onCustomDataConfirm,
        recipientAgentId,
        sendMessageConfirmedTools
    ]);
    const [isSavingEdit, setIsSavingEdit] = (0, $cozmU.useState)(false);
    const handleModalSubmit = (0, $cozmU.useCallback)((payload, context)=>{
        const nextPaused = context?.isPaused ?? isPaused;
        const applyLocalState = ()=>{
            setName(payload.name);
            setPrompt(payload.prompt);
            setFrequency(payload.frequency);
            setDaysOfWeek(payload.daysOfWeek);
            setTime(payload.time);
            setIsPaused(nextPaused);
            setIsEditorModalOpen(false);
        };
        if (!studioRuleId || studioWorkspaceId === undefined || studioSpaceId === undefined) {
            applyLocalState();
            return;
        }
        const workspaceId_0 = studioWorkspaceId;
        const spaceId_0 = studioSpaceId;
        const automationState = context?.isPaused ? 'DISABLED' : 'ENABLED';
        (async ()=>{
            setIsSavingEdit(true);
            try {
                const rawRule = await (0, $SJBPH.fetchStudioSc3Rule)({
                    workspaceId: workspaceId_0,
                    spaceId: spaceId_0,
                    ruleId: studioRuleId
                });
                if (rawRule) {
                    const patchOps = (0, $SJBPH.buildScheduledChatStudioSc3RuleJsonPatch)(rawRule, payload, automationState);
                    if (patchOps) await (0, $SJBPH.patchStudioSc3RuleJsonPatch)({
                        workspaceId: workspaceId_0,
                        spaceId: spaceId_0,
                        ruleId: studioRuleId,
                        patch: patchOps
                    }); // TODO: Add error boundary
                }
            } catch  {} finally{
                applyLocalState();
                setIsSavingEdit(false);
            }
        })();
    }, [
        studioRuleId,
        studioWorkspaceId,
        studioSpaceId,
        isPaused
    ]);
    const nextRunIso = (0, $cozmU.useMemo)(()=>(0, $6iyQh.deduceNextRunAtIsoFromRRuleRaw)(harvestedRRule), [
        harvestedRRule
    ]);
    const repeatLabel = (0, $cozmU.useMemo)(()=>{
        const frequencyText = (0, $KvxxC.frequencyLabelFor)(currentFrontendPayload.frequency, formatMessage);
        if (currentFrontendPayload.frequency === 'hourly') return frequencyText;
        let timeLabel;
        if (nextRunIso) timeLabel = formatDate(nextRunIso, {
            hour: 'numeric',
            minute: '2-digit'
        });
        else {
            const [hour, minute] = currentFrontendPayload.time.split(':').map((v)=>Number.parseInt(v, 10));
            const sample = new Date();
            sample.setHours(Number.isFinite(hour) ? hour : 0, Number.isFinite(minute) ? minute : 0, 0, 0);
            timeLabel = formatDate(sample, {
                hour: 'numeric',
                minute: '2-digit'
            });
        }
        return formatMessage((0, $fESy2.default).frequencyAtTime, {
            frequency: frequencyText,
            time: timeLabel
        });
    }, [
        currentFrontendPayload.frequency,
        currentFrontendPayload.time,
        nextRunIso,
        formatMessage,
        formatDate
    ]);
    const nextRunLabel = (0, $cozmU.useMemo)(()=>{
        if (nextRunIso) {
            const dateLabel = formatDate(nextRunIso, {
                day: 'numeric',
                month: 'short'
            });
            const timeLabel_0 = formatDate(nextRunIso, {
                hour: 'numeric',
                minute: '2-digit'
            });
            return formatMessage((0, $fESy2.default).dateAtTime, {
                date: dateLabel,
                time: timeLabel_0
            });
        }
        const [hour_0, minute_0] = currentFrontendPayload.time.split(':').map((v_0)=>Number.parseInt(v_0, 10));
        const sample_0 = new Date();
        sample_0.setHours(Number.isFinite(hour_0) ? hour_0 : 0, Number.isFinite(minute_0) ? minute_0 : 0, 0, 0);
        return formatDate(sample_0, {
            hour: 'numeric',
            minute: '2-digit'
        });
    }, [
        nextRunIso,
        currentFrontendPayload.time,
        formatDate,
        formatMessage
    ]);
    const statusMessage = (0, $cozmU.useMemo)(()=>{
        if (!currentBackendPayload) throw new Error('No backend payload');
        const formattedData = (0, $SJBPH.convertFromBackendPayload)(currentBackendPayload);
        if (formattedData.frequency === 'hourly') return `Scheduled ${formattedData.frequency} ${formattedData.name}`;
        return `Scheduled ${formattedData.frequency} ${formattedData.name} at ${formattedData.time}`;
    }, [
        currentBackendPayload
    ]);
    if (isFinished) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZB6I.SystemMessage), {
        message: statusMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11DE.ScheduledChatPreviewCard), {
        title: currentFrontendPayload.name,
        repeatLabel: repeatLabel,
        nextRunLabel: nextRunLabel,
        isSelected: false,
        isEnabled: !isPaused,
        onDeleteClick: openDeleteModal,
        onEditClick: ()=>{
            setIsEditorModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8KSQx.ScheduledChatEditorModal), {
        isOpen: isEditorModalOpen,
        mode: "edit",
        initialPayload: currentFrontendPayload,
        initialPaused: isPaused,
        rRule: harvestedRRule,
        isSubmitting: isSavingEdit,
        readonly: false,
        onClose: ()=>setIsEditorModalOpen(false),
        onSubmit: handleModalSubmit,
        onDelete: (payload_0)=>{
            setIsEditorModalOpen(false);
            openDeleteModal();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, pendingDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        shouldCloseOnEscapePress: !isDeletingScheduledChat,
        shouldCloseOnOverlayClick: !isDeletingScheduledChat,
        onClose: closeDeleteModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: !isDeletingScheduledChat
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $fESy2.default).deleteModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $fESy2.default).deleteModalDescription, {
        name: pendingDelete.title
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "default",
        onClick: closeDeleteModal,
        isDisabled: isDeletingScheduledChat
    }, formatMessage((0, $fESy2.default).deleteModalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "danger",
        spacing: "default",
        onClick: confirmDelete,
        isDisabled: isDeletingScheduledChat
    }, formatMessage((0, $fESy2.default).deleteModalConfirm))))) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $fESy2.default).cardTitle),
        product: "schedule"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9krqg.ScheduledChatFormFields), {
        formatMessage: formatMessage,
        formatDate: formatDate,
        readonly: readonly,
        isActionLoading: isActionLoading,
        name: name,
        prompt: prompt,
        frequency: frequency,
        daysOfWeek: daysOfWeek,
        time: time,
        onNameChange: setName,
        onPromptChange: setPrompt,
        onFrequencyChange: setFrequency,
        onDaysOfWeekChange: setDaysOfWeek,
        onTimeChange: setTime
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e88b2964dc5e1521$var$ScheduledChatActionFooter, {
        isSubmitting: isSubmitting,
        isSaveDisabled: isSaveDisabled,
        onSave: handleSave
    })));
};
module.exports["ScheduledChatAction"] = $e88b2964dc5e1521$export$64d1cadd42271bab;

});

parcelRegister("4OXVs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $b43a58d3a9bfe258$export$964332088344b308 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("agNz3")).then((m)=>({
            default: m.SlackSendChannelMessageAction
        })));
module.exports["SlackSendChannelMessageRendererAsync"] = $b43a58d3a9bfe258$export$964332088344b308;

});

parcelRegister("bG2tP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9KSWX = parcelRequire("9KSWX");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $dw75i = parcelRequire("dw75i");

const $b30aac0df57f9a6f$var$recommendationStyles = {
    list: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d",
    card: "_2mHwu82ADO _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065U2ADO _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3 _39xV02N91d _0KLXru66of _24h04i2Njc _1UtDYzy7kJ",
    title: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    content: "_2mHwu81Y8M _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w",
    description: "_1ANEUSzUZr _3zvHkHdC7N _1UtDYzZpcK"
};
function $b30aac0df57f9a6f$var$getRecommendationTypeLabel(type) {
    switch(type){
        case 'solution':
            return 'SOLUTION';
        case 'agent':
            return 'AGENT';
        default:
            return 'APP';
    }
}
function $b30aac0df57f9a6f$var$getRecommendationLozengeAppearance(type) {
    switch(type){
        case 'solution':
            return 'neutral';
        case 'agent':
            return 'discovery';
        default:
            return 'information';
    }
}
const $b30aac0df57f9a6f$export$22bbb4ddf3e60ca = (actions)=>{
    const filteredActions = actions.filter($b30aac0df57f9a6f$var$assertIsStoreRecommendationAction);
    return filteredActions;
};
const $b30aac0df57f9a6f$var$assertIsStoreRecommendationAction = (action)=>{
    if (action.key !== (0, $dw75i.STORE_RECOMMENDATION_ACTION_KEY)) throw new Error('Invalid action key for StoreRecommendationAction');
    return action;
};
const $b30aac0df57f9a6f$export$9fefe9f955009dc9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { actions: actions } = t0;
    const firstAction = actions[0];
    if (!firstAction || !firstAction.data || !Array.isArray(firstAction.data.items)) return null;
    const recommendations = firstAction.data.items;
    if (recommendations.length === 0) return null;
    let t1;
    if ($[0] !== recommendations) {
        t1 = recommendations.map($b30aac0df57f9a6f$var$_temp);
        $[0] = recommendations;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.list
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ actions: actions })=>{
    const firstAction = actions[0];
    if (!firstAction || !firstAction.data || !Array.isArray(firstAction.data.items)) return null;
    const recommendations = firstAction.data.items;
    if (recommendations.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.list
    }, recommendations.map((recommendation, index)=>{
        const key = recommendation.id || `${0, $dw75i.STORE_RECOMMENDATION_ACTION_KEY}-${index}`;
        const typeLabel = $b30aac0df57f9a6f$var$getRecommendationTypeLabel(recommendation.type);
        const appearance = $b30aac0df57f9a6f$var$getRecommendationLozengeAppearance(recommendation.type);
        if (recommendation.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            key: key,
            href: recommendation.href,
            target: "_blank",
            rel: "noopener noreferrer",
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.name)), recommendation.description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.description
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.description)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: appearance
        }, typeLabel));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: key,
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.name)), recommendation.description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b30aac0df57f9a6f$var$recommendationStyles.description
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.description)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: appearance
        }, typeLabel));
    }));
};
function $b30aac0df57f9a6f$var$_temp(recommendation, index) {
    const key = recommendation.id || `${0, $dw75i.STORE_RECOMMENDATION_ACTION_KEY}-${index}`;
    const typeLabel = $b30aac0df57f9a6f$var$getRecommendationTypeLabel(recommendation.type);
    const appearance = $b30aac0df57f9a6f$var$getRecommendationLozengeAppearance(recommendation.type);
    if (recommendation.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        key: key,
        href: recommendation.href,
        target: "_blank",
        rel: "noopener noreferrer",
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.name)), recommendation.description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.description)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance
    }, typeLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: key,
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.name)), recommendation.description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b30aac0df57f9a6f$var$recommendationStyles.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, recommendation.description)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance
    }, typeLabel));
}
module.exports["StoreRecommendationAction"] = $b30aac0df57f9a6f$export$9fefe9f955009dc9;

});

parcelRegister("3D4BT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $4MnFz = parcelRequire("4MnFz");


var $5avUB = parcelRequire("5avUB");


var $fa8WQ = parcelRequire("fa8WQ");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $hMLWD = parcelRequire("hMLWD");


var $1cBj4 = parcelRequire("1cBj4");


var $bxtuo = parcelRequire("bxtuo");


var $7CT2C = parcelRequire("7CT2C");

const $4a76d84f774e7d4f$var$STUDIO_SPACE_ARI_PREFIX = 'ari:cloud:studio::space/';
const $4a76d84f774e7d4f$var$parseStudioSpaceResource = (resource)=>{
    if (!resource?.startsWith($4a76d84f774e7d4f$var$STUDIO_SPACE_ARI_PREFIX)) return undefined;
    const [workspaceId, spaceId, ...rest] = resource.slice($4a76d84f774e7d4f$var$STUDIO_SPACE_ARI_PREFIX.length).split('/');
    if (!workspaceId || !spaceId || rest.length > 0) return undefined;
    return {
        workspaceId: workspaceId,
        spaceId: spaceId
    };
};
const $4a76d84f774e7d4f$export$c906abb2793392ac = (actionRenderer)=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { actions: actions, onCustomDataConfirm: onCustomDataConfirm, getStatus: getStatus, productKey: productKey, cloudId: cloudId, ContentRenderer: ContentRenderer, conversationId: conversationId, messageId: messageId } = actionRenderer;
    const firstAction = actions[0];
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const commonAttributes = (0, $cozmU.useCallback)(()=>({
            conversationId: conversationId,
            invocationId: firstAction?.invocationId,
            messageId: messageId,
            actionKey: firstAction?.key
        }), [
        conversationId,
        firstAction?.invocationId,
        firstAction?.key,
        messageId
    ]);
    if (!firstAction) return null;
    const { overview: overview = '', rule: rule } = firstAction.data ?? {};
    const ruleName = (typeof rule?.name === 'string' ? rule.name : undefined) || formatMessage((0, $bxtuo.default).cardTitle);
    const status = getStatus(firstAction);
    const isDisabled = status !== 'idle' || Boolean(firstAction.status && [
        'errored',
        'cancelled',
        'finished'
    ].includes(firstAction.status));
    const isSubmitting = status === 'started';
    const handleConfirm = async ()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/104742
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createFlowButton',
            attributes: commonAttributes()
        });
        try {
            const result = await onCustomDataConfirm(firstAction, firstAction.data, (message)=>{
                return message.message_metadata.actionOutput;
            });
            const studioSpace = $4a76d84f774e7d4f$var$parseStudioSpaceResource(result?.ruleScope?.resources?.[0]);
            if (!result?.ruleUuid || !studioSpace) throw new Error('Missing automation redirect data');
            const editUrl = (0, $fa8WQ.getAtlassianStudioAutomationRuleEditUrl)(studioSpace.workspaceId, studioSpace.spaceId, result.ruleUuid);
            // https://data-portal.internal.atlassian.com/analytics/registry/104745
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'createRule',
                actionSubject: 'rule',
                attributes: commonAttributes()
            });
            window.location.assign(editUrl);
        } catch (error) {
            // https://data-portal.internal.atlassian.com/analytics/registry/104744
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'createFlowError',
                actionSubject: 'rule',
                attributes: commonAttributes()
            });
            (0, $hlvTd.logException)({
                exception: error instanceof Error ? error : new Error('Unknown error'),
                name: 'studio-automation-create-rule-action-button-error',
                tags: {
                    component: 'StudioAutomationCreateRuleAction',
                    actionKey: firstAction.key,
                    invocationId: firstAction.invocationId
                }
            });
            showFlag({
                title: formatMessage((0, $bxtuo.default).buildAutomationErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                }),
                description: formatMessage((0, $bxtuo.default).buildAutomationErrorDescription),
                isAutoDismiss: true
            });
        }
    };
    const handleError = (error_0)=>{
        (0, $hlvTd.logException)({
            exception: error_0,
            name: 'studio-automation-create-rule-render-error',
            tags: {
                component: 'StudioAutomationCreateRuleAction',
                actionKey: firstAction.key,
                invocationId: firstAction.invocationId
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        }),
        onError: handleError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7CT2C.RulePlanAnalytics), {
        actionRenderer: actionRenderer
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1cBj4.AutomationCreateRuleCard), {
        ruleName: ruleName,
        overview: overview,
        ContentRenderer: ContentRenderer,
        onConfirm: handleConfirm,
        isSubmitting: isSubmitting,
        isDisabled: isDisabled,
        productKey: productKey,
        siteId: cloudId
    }));
};
module.exports["StudioAutomationCreateRuleAction"] = $4a76d84f774e7d4f$export$c906abb2793392ac;

});

parcelRegister("43hIk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $dw75i = parcelRequire("dw75i");


var $eOfip = parcelRequire("eOfip");

const $b75d011f9861fd64$export$8368ee42929bcb54 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { actions: actions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    let t1;
    if ($[0] !== firstAction.data) {
        t1 = firstAction.data ?? {};
        $[0] = firstAction.data;
        $[1] = t1;
    } else t1 = $[1];
    const { buildId: buildId, succeeded: t2 } = t1;
    const succeeded = t2 === undefined ? false : t2;
    let t3;
    let t4;
    if ($[2] !== buildId || $[3] !== succeeded) {
        t3 = ()=>{
            if (!buildId) return;
            window.dispatchEvent(new MessageEvent("message", {
                data: {
                    type: "studio-automation-build-updated",
                    buildId: buildId,
                    succeeded: succeeded
                }
            }));
        };
        t4 = [
            buildId,
            succeeded
        ];
        $[2] = buildId;
        $[3] = succeeded;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (succeeded) {
        let t5;
        if ($[6] !== formatMessage) {
            t5 = formatMessage((0, $eOfip.default).actionMessage);
            $[6] = formatMessage;
            $[7] = t5;
        } else t5 = $[7];
        let t6;
        if ($[8] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t5));
            $[8] = t5;
            $[9] = t6;
        } else t6 = $[9];
        return t6;
    }
    return null;
} : ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstAction = actions[0];
    const { buildId: buildId, succeeded: succeeded = false } = firstAction.data ?? {};
    (0, $cozmU.useEffect)(()=>{
        if (!buildId) return;
        window.dispatchEvent(new MessageEvent('message', {
            data: {
                type: 'studio-automation-build-updated',
                buildId: buildId,
                succeeded: succeeded
            }
        }));
    }, [
        buildId,
        succeeded
    ]);
    if (succeeded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $eOfip.default).actionMessage)));
    return null;
};
const $b75d011f9861fd64$export$f4b902d971e240c = (actions)=>{
    const filteredActions = actions.filter((action)=>{
        if (action.key !== (0, $dw75i.STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY)) throw new Error(`Invalid action key for ${(0, $dw75i.STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY)}`);
        return action;
    });
    return filteredActions;
};
module.exports["StudioAutomationTriggerRuleBuildAction"] = $b75d011f9861fd64$export$8368ee42929bcb54;

});

parcelRegister("9253K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $4MnFz = parcelRequire("4MnFz");


var $mfdwv = parcelRequire("mfdwv");


var $V3JOP = parcelRequire("V3JOP");


var $iDrrr = parcelRequire("iDrrr");


var $iA8l9 = parcelRequire("iA8l9");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $fa8WQ = parcelRequire("fa8WQ");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bjY3F = parcelRequire("bjY3F");


var $iuCeV = parcelRequire("iuCeV");


var $hMLWD = parcelRequire("hMLWD");


var $kQyXl = parcelRequire("kQyXl");


var $jz5To = parcelRequire("jz5To");


var $lRJVo = parcelRequire("lRJVo");


var $gbT5P = parcelRequire("gbT5P");


var $duz5q = parcelRequire("duz5q");


var $aJUzF = parcelRequire("aJUzF");


var $e6wkD = parcelRequire("e6wkD");


var $gmat6 = parcelRequire("gmat6");


var $igxiP = parcelRequire("igxiP");


var $73C0I = parcelRequire("73C0I");


var $fCOel = parcelRequire("fCOel");

const $9bef0eda68c35c51$var$refineInStudioLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.refineInStudioLabel",
    defaultMessage: "Refine in Studio"
});
const $9bef0eda68c35c51$var$viewInStudioLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.viewInStudioLabel",
    defaultMessage: "View in Studio"
});
const $9bef0eda68c35c51$var$assignAgentLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.assignAgentLabel",
    defaultMessage: "Assign agent"
});
const $9bef0eda68c35c51$var$buildAndInvokeLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.buildAndInvokeLabel",
    defaultMessage: "Start session"
});
const $9bef0eda68c35c51$var$buildAndChatLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.buildAndChatLabel",
    defaultMessage: "Start chat"
});
const $9bef0eda68c35c51$var$chatWithAgentLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.chatWithAgentLabel",
    defaultMessage: "Chat with agent"
});
const $9bef0eda68c35c51$var$buildLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.buildLabel",
    defaultMessage: "Build"
});
const $9bef0eda68c35c51$var$buildAgentLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.buildAgentLabel",
    defaultMessage: "Build agent"
});
const $9bef0eda68c35c51$var$assigningFlagTitle = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.assigningFlagTitle",
    defaultMessage: "Agent created"
});
const $9bef0eda68c35c51$var$assigningFlagDescription = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.assigningFlagDescription",
    defaultMessage: "It's being assigned to the work item. This may take a minute or two."
});
const $9bef0eda68c35c51$var$assignedFlagTitle = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.assignedFlagTitle",
    defaultMessage: "Agent assigned"
});
const $9bef0eda68c35c51$var$assignedFlagDescription = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.StudioCreateAgentRenderer.assignedFlagDescription",
    defaultMessage: "We've assigned it to the work item."
});
/** Values sent for `chosenOption`, matching the `actionTaken` field on `executedData`. */ const $9bef0eda68c35c51$var$CHOSEN_OPTION = {
    BUILD_DRAFT: 'build_draft',
    BUILD_AND_APPLY: 'build_and_apply',
    BUILD_AND_CHAT: 'build_and_chat',
    REFINE_IN_STUDIO: 'refine_in_studio'
};
/** Stable `flowKey` discriminants emitted by the BE on create-agent metadata. */ const $9bef0eda68c35c51$var$FLOW_KEY = {
    ISSUE_ASSIGN: 'issue_assign',
    ISSUE_INVOKE: 'issue_invoke',
    BUILD_AND_CHAT: 'build_and_chat'
};
/**
 * Flattens the BE's per-source nested `filters` shape into the flat shape that
 * `KnowledgePillList` expects.
 */ const $9bef0eda68c35c51$var$toPillListKnowledge = (knowledgeSources)=>{
    if (!knowledgeSources) return [];
    const flatSources = knowledgeSources.sources?.map((src)=>{
        const nestedFilter = src?.filters ? Object.values(src.filters).find((f)=>f !== null && f !== undefined) : undefined;
        return {
            ...src,
            filters: nestedFilter ?? {}
        };
    });
    return [
        {
            ...knowledgeSources,
            sources: flatSources
        }
    ];
};
const $9bef0eda68c35c51$var$mapToolsToCardTools = (tools)=>{
    if (!tools?.length) return [];
    const result = [];
    for(let i = 0; i < tools.length; i++){
        const tool = tools[i];
        const id = tool.toolId ?? tool.definitionId ?? `${tool.displayName ?? 'tool'}-${i}`;
        const displayName = tool.displayName ?? tool.toolId ?? tool.definitionId;
        if (!id || !displayName) continue;
        result.push({
            id: id,
            displayName: displayName,
            iconUrl: tool.iconUrl ?? undefined,
            tags: tool.tags ?? undefined,
            isActive: true
        });
    }
    return result;
};
const $9bef0eda68c35c51$var$getResultMessageFromExecutedData = (executedData)=>{
    if (executedData?.isSuccess === false) return {
        type: 'create_failed'
    };
    if ((executedData?.chosenOption === $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_AND_APPLY || executedData?.chosenOption === $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_AND_CHAT) && executedData.isPublished === false) return {
        type: 'draft_publish_failed'
    };
    return undefined;
};
const $9bef0eda68c35c51$export$15a0fc18955ab741 = (actionRenderer)=>{
    (0, $6cFsl.di)((0, $igxiP.useAssignAgent), (0, $73C0I.useInvokeAgent), (0, $bjY3F.useAIMateExperienceTracker));
    const firstAction = actionRenderer.actions[0];
    const issueId = firstAction?.data?.agentMetadata?.jiraMetadata?.issueId;
    const flowKey = firstAction?.data?.agentMetadata?.jiraMetadata?.flowKey ?? undefined;
    const [isPrimaryActionLoading, setIsPrimaryActionLoading] = (0, $cozmU.useState)(false);
    const [isSecondaryActionLoading, setIsSecondaryActionLoading] = (0, $cozmU.useState)(false);
    const [followUpResult, setFollowUpResult] = (0, $cozmU.useState)(undefined);
    const [agentAri, setAgentAri] = (0, $cozmU.useState)(()=>{
        const initial = firstAction?.executedData;
        return initial?.agentAri ?? undefined;
    });
    const [confirmedChosenOption, setConfirmedChosenOption] = (0, $cozmU.useState)(()=>{
        const initial_0 = firstAction?.executedData;
        return initial_0?.chosenOption;
    });
    const [actionResultMessage, setActionResultMessage] = (0, $cozmU.useState)(()=>$9bef0eda68c35c51$var$getResultMessageFromExecutedData(firstAction?.executedData));
    const publishActionEvent = (0, $hdBxM.usePublish)((0, $k1Pvg.Topics).AI_MATE_ACTIONS);
    const publishChatEvent = (0, $hdBxM.usePublish)((0, $k1Pvg.Topics).AI_MATE);
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { conversationId: conversationId, messageId: messageId } = actionRenderer;
    const { invocationId: invocationId } = firstAction ?? {};
    const agent = firstAction?.data?.agent;
    const isBuildAndChatFlow = flowKey === $9bef0eda68c35c51$var$FLOW_KEY.BUILD_AND_CHAT;
    const isBuildAndChatMultiStepEnabled = isBuildAndChatFlow && (0, $iDrrr.fg)('rovo_chat_multi_step_build_studio_create_agent');
    // The build-and-chat multi-step flow reaches the persisted card via two paths: the
    // primary "Build agent" (BUILD_AND_CHAT) and the secondary "Refine in Studio"
    // (REFINE_IN_STUDIO). Both create the agent, so both must surface the chat /
    // view-in-studio actions once it exists — not just the primary path.
    const isBuildAndChatAgentConfirmed = confirmedChosenOption === $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_AND_CHAT || confirmedChosenOption === $9bef0eda68c35c51$var$CHOSEN_OPTION.REFINE_IN_STUDIO;
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({
        touchPoint: (0, $duz5q.GASV3_ANALYTICS_TOUCHPOINT_NAME),
        actionGroup: 'createFlow'
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const isInvokeFlow = flowKey === $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_INVOKE;
    let ufoExperienceName = (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT;
    switch(flowKey){
        case $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_ASSIGN:
            ufoExperienceName = (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_ASSIGN;
            break;
        case $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_INVOKE:
            ufoExperienceName = (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_INVOKE;
            break;
        case $9bef0eda68c35c51$var$FLOW_KEY.BUILD_AND_CHAT:
            ufoExperienceName = (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_BUILD_AND_CHAT;
            break;
        default:
            ufoExperienceName = (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT;
    }
    const commonAttributes = (0, $cozmU.useMemo)(()=>({
            ...agent ? (0, $gbT5P.getPlanAnalyticsAttributes)(agent) : {},
            conversationId: conversationId,
            invocationId: invocationId,
            messageId: messageId,
            ...(0, $lRJVo.getCreateAgentAnalyticsAttributes)({
                flowKey: flowKey,
                issueId: issueId
            })
        }), [
        agent,
        conversationId,
        invocationId,
        messageId,
        issueId,
        flowKey
    ]);
    const { assignAgent: assignAgent } = (0, $igxiP.useAssignAgent)({
        conversationId: conversationId,
        invocationId: invocationId,
        messageId: messageId
    });
    const { invokeAgent: invokeAgent } = (0, $73C0I.useInvokeAgent)({
        conversationId: conversationId,
        invocationId: invocationId,
        messageId: messageId
    });
    const fireConfirmAnalytics = (0, $cozmU.useCallback)((result)=>{
        const analyticsAttributes = {
            ...commonAttributes,
            ...(0, $gbT5P.getPlanAnalyticsAttributes)(agent),
            agentId: (0, $fCOel.getAgentIdFromAri)(result.agentAri) ?? undefined
        };
        if (result.agentAri) trackAgentEvent({
            action: 'createAgentRecord',
            actionSubject: 'rovoAgent',
            attributes: analyticsAttributes
        });
        if (result.isPublished) trackAgentEvent({
            action: 'published',
            actionSubject: 'rovoAgent',
            attributes: {
                ...analyticsAttributes,
                isFirstPublish: true,
                agentVersionNumber: 1
            }
        });
        if (result.isPublished) trackAgentEvent({
            action: 'success',
            actionSubject: 'setIsAgentAssignable',
            attributes: {
                ...analyticsAttributes,
                value: true
            }
        });
    }, [
        trackAgentEvent,
        commonAttributes,
        agent
    ]);
    const fireConfirmErrorAnalytics = (0, $cozmU.useCallback)(()=>{
        trackAgentEvent({
            action: 'createFlowError',
            actionSubject: 'rovoAgent',
            attributes: {
                conversationId: conversationId,
                invocationId: invocationId,
                messageId: messageId,
                ...(0, $lRJVo.getCreateAgentAnalyticsAttributes)({
                    flowKey: flowKey,
                    issueId: issueId
                })
            }
        });
    }, [
        trackAgentEvent,
        conversationId,
        invocationId,
        messageId,
        issueId,
        flowKey
    ]);
    const confirmCreateAgent = (0, $cozmU.useCallback)(async ({ chosenOption: chosenOption, shouldPublish: shouldPublish })=>{
        if (!firstAction) return {};
        const payload = firstAction.data;
        let result_0;
        try {
            result_0 = await actionRenderer.onCustomDataConfirm(firstAction, {
                ...payload,
                shouldPublish: shouldPublish,
                chosenOption: chosenOption,
                isResultCustomMarkdown: true
            }, (message)=>{
                const metadata = message.message_metadata;
                return metadata.createAgentResult;
            }) ?? {};
        } catch (error) {
            fireConfirmErrorAnalytics();
            throw error;
        }
        if (result_0.isSuccess === false) fireConfirmErrorAnalytics();
        else fireConfirmAnalytics(result_0);
        return result_0;
    }, [
        actionRenderer,
        firstAction,
        fireConfirmAnalytics,
        fireConfirmErrorAnalytics
    ]);
    const status = firstAction ? actionRenderer.getStatus(firstAction) : 'idle';
    const isReadonly = firstAction ? actionRenderer.getReadonly(firstAction) : false;
    const isSubmitting = status === 'started';
    const renderPrimaryAction = (0, $cozmU.useCallback)(({ isPublished: isPublished } = {})=>{
        const shouldShowBuildAndChatPublishedActions = isBuildAndChatMultiStepEnabled && agentAri && isBuildAndChatAgentConfirmed && isPublished === true;
        const shouldShowBuildAndChatDraftActions = isBuildAndChatMultiStepEnabled && agentAri && isBuildAndChatAgentConfirmed && isPublished === false;
        if (shouldShowBuildAndChatPublishedActions) {
            const onStartChatAction = (_, analyticsEvent)=>{
                sendAnalyticsEvent(analyticsEvent.update({
                    actionSubjectId: 'startChatWithAgent',
                    attributes: {
                        analyticsSource: 'inline-create-agent-card',
                        ...commonAttributes
                    }
                }));
                const agentId = (0, $fCOel.getAgentIdFromAri)(agentAri);
                if (!agentId) {
                    setFollowUpResult({
                        type: 'build_and_chat_failed'
                    });
                    experienceTracker.fail({
                        name: ufoExperienceName,
                        error: new Error(`agentId not available for ${$9bef0eda68c35c51$var$FLOW_KEY.BUILD_AND_CHAT} flow`),
                        attributes: commonAttributes
                    });
                    return;
                }
                publishChatEvent({
                    type: 'chat-new',
                    source: 'inline-agent-creation',
                    data: {
                        agentId: agentId,
                        dialogues: []
                    }
                });
                setFollowUpResult({
                    type: 'build_and_chat',
                    agentName: agent?.name ?? ''
                });
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))),
                isDisabled: isSubmitting || isPrimaryActionLoading || isSecondaryActionLoading,
                onClick: onStartChatAction,
                testId: "rovo-create-agent-card-start-chat"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9bef0eda68c35c51$var$chatWithAgentLabel));
        }
        if (shouldShowBuildAndChatDraftActions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))),
            isDisabled: true,
            testId: "rovo-create-agent-card-start-chat"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9bef0eda68c35c51$var$chatWithAgentLabel));
        if (isBuildAndChatMultiStepEnabled && agentAri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: true,
            testId: "rovo-create-agent-card-build"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9bef0eda68c35c51$var$buildAgentLabel));
        // Per Tech Spec V2 "Actions Mapped to Flow":
        //   - `issue_assign` → primary `[Assign agent]`  → assignAgent
        //   - `issue_invoke` → primary `[Start session]` → invokeAgent
        //   - `build_and_chat` → primary `[Start chat]`  → open a new Rovo chat
        //     (or gated `[Build]` → publish first, then show `[Start chat]` on the published card)
        //   - fallthrough     → primary `[Build]`         → no follow-up
        const config = (()=>{
            switch(flowKey){
                case $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_ASSIGN:
                    return {
                        label: $9bef0eda68c35c51$var$assignAgentLabel,
                        testId: 'rovo-create-agent-card-assign-agent',
                        chosenOption: $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_AND_APPLY,
                        shouldPublish: true,
                        followUp: assignAgent,
                        shouldPublishAssignedEvent: true,
                        actionSubjectId: 'buildAndAssignAgent',
                        shouldOpenChat: false
                    };
                case $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_INVOKE:
                    return {
                        label: $9bef0eda68c35c51$var$buildAndInvokeLabel,
                        testId: 'rovo-create-agent-card-start-session',
                        chosenOption: $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_AND_APPLY,
                        shouldPublish: true,
                        followUp: invokeAgent,
                        shouldPublishAssignedEvent: false,
                        actionSubjectId: 'buildAndInvokeAgent',
                        shouldOpenChat: false
                    };
                case $9bef0eda68c35c51$var$FLOW_KEY.BUILD_AND_CHAT:
                    return {
                        label: isBuildAndChatMultiStepEnabled ? $9bef0eda68c35c51$var$buildAgentLabel : $9bef0eda68c35c51$var$buildAndChatLabel,
                        testId: isBuildAndChatMultiStepEnabled ? 'rovo-create-agent-card-build' : 'rovo-create-agent-card-start-chat',
                        chosenOption: $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_AND_CHAT,
                        shouldPublish: true,
                        followUp: undefined,
                        shouldPublishAssignedEvent: false,
                        actionSubjectId: 'buildAndChatAgent',
                        shouldOpenChat: !isBuildAndChatMultiStepEnabled
                    };
                default:
                    return {
                        label: $9bef0eda68c35c51$var$buildLabel,
                        testId: 'rovo-create-agent-card-build',
                        chosenOption: $9bef0eda68c35c51$var$CHOSEN_OPTION.BUILD_DRAFT,
                        shouldPublish: false,
                        followUp: undefined,
                        shouldPublishAssignedEvent: false,
                        actionSubjectId: 'buildAgent',
                        shouldOpenChat: false
                    };
            }
        })();
        // Draft state for fallback non-Jira issue flow.
        if (!flowKey && agentAri) return undefined;
        const onPrimaryAction = async (__0, analyticsEvent_0)=>{
            sendAnalyticsEvent(analyticsEvent_0.update({
                actionSubjectId: config.actionSubjectId,
                attributes: {
                    analyticsSource: 'inline-create-agent-card',
                    ...commonAttributes
                }
            }));
            setIsPrimaryActionLoading(true);
            let didSetActionResultMessage = false;
            try {
                if (isReadonly) return;
                experienceTracker.start({
                    id: ufoExperienceName,
                    name: ufoExperienceName,
                    attributes: commonAttributes
                });
                const result_1 = await confirmCreateAgent({
                    chosenOption: config.chosenOption,
                    shouldPublish: config.shouldPublish
                });
                if (result_1.agentAri) setAgentAri(result_1.agentAri);
                if (result_1.isSuccess === false) {
                    didSetActionResultMessage = true;
                    setActionResultMessage({
                        type: 'create_failed'
                    });
                    throw new Error('Agent creation failed');
                }
                if (config.shouldPublish && result_1.isPublished === false) {
                    didSetActionResultMessage = true;
                    setActionResultMessage({
                        type: 'draft_publish_failed'
                    });
                    throw new Error('Agent draft publish failed');
                }
                setConfirmedChosenOption(config.chosenOption);
                if (config.shouldOpenChat) {
                    const agentId_0 = (0, $fCOel.getAgentIdFromAri)(result_1.agentAri);
                    if (!agentId_0) {
                        setFollowUpResult({
                            type: 'build_and_chat_failed'
                        });
                        experienceTracker.fail({
                            name: ufoExperienceName,
                            error: new Error(`agentId not available for ${$9bef0eda68c35c51$var$FLOW_KEY.BUILD_AND_CHAT} flow`),
                            attributes: commonAttributes
                        });
                        return;
                    }
                    publishChatEvent({
                        type: 'chat-new',
                        source: 'inline-agent-creation',
                        data: {
                            agentId: agentId_0,
                            dialogues: []
                        }
                    });
                    setFollowUpResult({
                        type: 'build_and_chat',
                        agentName: agent?.name ?? ''
                    });
                    experienceTracker.succeed({
                        name: ufoExperienceName,
                        attributes: {
                            ...commonAttributes,
                            agentId: agentId_0
                        }
                    });
                    return;
                }
                if (!config.followUp) {
                    // Mainly for fallback non-Jira issue flow where we don't have any follow-up.
                    experienceTracker.succeed({
                        name: ufoExperienceName,
                        attributes: {
                            ...commonAttributes,
                            agentId: (0, $fCOel.getAgentIdFromAri)(result_1.agentAri) ?? undefined
                        }
                    });
                    // Redirect fallback drafts to Studio so the user can move the agent out of draft.
                    if (!flowKey && (0, $iDrrr.fg)('sltns-1247-redirect-on-agent-build')) {
                        if (result_1.agentAri) {
                            const agentId_1 = (0, $fCOel.getAgentIdFromAri)(result_1.agentAri);
                            if (agentId_1) {
                                const editUrl = (0, $fa8WQ.getAtlassianStudioAgentEditUrl)(actionRenderer.cloudId, agentId_1, (0, $duz5q.STUDIO_NAVIGATION_SOURCE));
                                window.location.assign(editUrl);
                            }
                        }
                    }
                    return;
                }
                // Show an info flag while assigning (assign flow only) — assign can take up to 90s.
                if (flowKey === $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_ASSIGN) showFlag({
                    testId: 'rovo-agent-assigning',
                    title: formatMessage($9bef0eda68c35c51$var$assigningFlagTitle),
                    description: formatMessage($9bef0eda68c35c51$var$assigningFlagDescription),
                    isAutoDismiss: true,
                    // Assign can take up to 90 seconds — keep the info flag visible for that duration.
                    autoDismissSeconds: 90
                });
                try {
                    if (!result_1.identityAccountId) throw new Error(`identityAccountId not available for ${flowKey} flow`);
                    if (issueId) {
                        await config.followUp({
                            cloudId: actionRenderer.cloudId,
                            issueId: issueId,
                            identityAccountId: result_1.identityAccountId,
                            agentId: (0, $fCOel.getAgentIdFromAri)(result_1.agentAri)
                        });
                        // Follow-up mutation succeeded — show contextual success text below the card.
                        setFollowUpResult({
                            type: isInvokeFlow ? 'invoke' : 'assigned',
                            agentName: agent?.name ?? ''
                        });
                    }
                    experienceTracker.succeed({
                        name: ufoExperienceName,
                        attributes: {
                            ...commonAttributes,
                            agentId: (0, $fCOel.getAgentIdFromAri)(result_1.agentAri) ?? undefined
                        }
                    });
                    // Follow-up mutation succeeded — show contextual success text below the card.
                    setFollowUpResult({
                        type: flowKey === $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_INVOKE ? 'invoke' : 'assigned',
                        agentName: agent?.name ?? ''
                    });
                    // Show success flag (assign flow only).
                    if (flowKey === $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_ASSIGN) showFlag({
                        testId: 'rovo-agent-assigned',
                        appearance: 'success',
                        title: formatMessage($9bef0eda68c35c51$var$assignedFlagTitle),
                        description: formatMessage($9bef0eda68c35c51$var$assignedFlagDescription),
                        isAutoDismiss: true
                    });
                    if (config.shouldPublishAssignedEvent && issueId) publishActionEvent({
                        type: (0, $k1Pvg.JIRA_INLINE_AGENT_CREATION_AGENT_ASSIGNED_EVENT),
                        source: 'inline-agent-creation',
                        data: {
                            issueId: issueId
                        }
                    });
                } catch (followUpError) {
                    // Follow-up mutation failed — agent was built but assign/invoke did not complete.
                    setFollowUpResult({
                        type: isInvokeFlow ? 'invoke_failed' : 'assign_failed'
                    });
                    const followUpErr = followUpError instanceof Error ? followUpError : new Error(String(followUpError));
                    const statusCode = followUpError instanceof (0, $igxiP.AssignAgentError) ? followUpError.statusCode : undefined;
                    // 4xx errors are expected/known conditions — abort rather than fail the experience.
                    if (statusCode !== undefined && statusCode >= 400 && statusCode < 500) experienceTracker.abort({
                        name: ufoExperienceName,
                        reason: `Failed with status ${statusCode}`,
                        attributes: {
                            ...commonAttributes,
                            statusCode: statusCode
                        }
                    });
                    else experienceTracker.fail({
                        name: ufoExperienceName,
                        error: followUpErr,
                        attributes: {
                            ...commonAttributes,
                            ...statusCode !== undefined && {
                                statusCode: statusCode
                            }
                        }
                    });
                }
            } catch  {
                // confirmCreateAgent itself failed — analytics already fired in confirmCreateAgent.
                if (config.shouldOpenChat && !didSetActionResultMessage) setFollowUpResult({
                    type: 'build_and_chat_failed'
                });
                experienceTracker.fail({
                    name: ufoExperienceName,
                    error: new Error('confirmCreateAgent failed'),
                    attributes: commonAttributes
                });
            } finally{
                setIsPrimaryActionLoading(false);
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            iconBefore: config.shouldOpenChat ? (0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))) : undefined,
            isLoading: isPrimaryActionLoading,
            isDisabled: !!agentAri || isReadonly || isSubmitting || isPrimaryActionLoading || isSecondaryActionLoading,
            onClick: onPrimaryAction,
            testId: config.testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), config.label));
    }, [
        flowKey,
        agentAri,
        isReadonly,
        isSubmitting,
        isPrimaryActionLoading,
        isSecondaryActionLoading,
        isBuildAndChatMultiStepEnabled,
        confirmCreateAgent,
        assignAgent,
        invokeAgent,
        issueId,
        actionRenderer.cloudId,
        publishActionEvent,
        publishChatEvent,
        sendAnalyticsEvent,
        agent,
        setFollowUpResult,
        showFlag,
        formatMessage,
        experienceTracker,
        commonAttributes,
        isInvokeFlow,
        ufoExperienceName,
        isBuildAndChatAgentConfirmed
    ]);
    const primaryAction = (0, $cozmU.useMemo)(()=>renderPrimaryAction(), [
        renderPrimaryAction
    ]);
    const renderSecondaryAction = (0, $cozmU.useCallback)(({ isPublished: isPublished_0 } = {})=>{
        if (!firstAction) return undefined;
        const shouldShowBuildAndChatPublishedActions_0 = isBuildAndChatMultiStepEnabled && agentAri && isBuildAndChatAgentConfirmed && isPublished_0 === true;
        const refineInStudioFlowKey = flowKey === $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_ASSIGN || flowKey === $9bef0eda68c35c51$var$FLOW_KEY.ISSUE_INVOKE || flowKey === $9bef0eda68c35c51$var$FLOW_KEY.BUILD_AND_CHAT ? flowKey : undefined;
        if (!agentAri && !refineInStudioFlowKey) return undefined;
        const onSecondaryAction = async (__1, analyticsEvent_1)=>{
            sendAnalyticsEvent(analyticsEvent_1.update({
                actionSubjectId: 'refineInStudio',
                attributes: {
                    analyticsSource: 'inline-create-agent-card',
                    conversationId: conversationId,
                    invocationId: invocationId,
                    messageId: messageId,
                    ...(0, $lRJVo.getCreateAgentAnalyticsAttributes)({
                        flowKey: flowKey,
                        issueId: issueId
                    }),
                    ...(0, $gbT5P.getPlanAnalyticsAttributes)(agent)
                }
            }));
            setIsSecondaryActionLoading(true);
            try {
                let nextAri = agentAri;
                if (!nextAri && !isReadonly) {
                    experienceTracker.start({
                        id: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_REFINE_IN_STUDIO,
                        name: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_REFINE_IN_STUDIO,
                        attributes: commonAttributes
                    });
                    const result_2 = await confirmCreateAgent({
                        chosenOption: $9bef0eda68c35c51$var$CHOSEN_OPTION.REFINE_IN_STUDIO,
                        shouldPublish: false
                    });
                    if (result_2.isSuccess === false) {
                        setActionResultMessage({
                            type: 'create_failed'
                        });
                        throw new Error('Agent creation failed');
                    }
                    if (!result_2.agentAri) throw new Error('agentAri not available for refine in studio flow');
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_REFINE_IN_STUDIO,
                        attributes: {
                            ...commonAttributes,
                            agentId: (0, $fCOel.getAgentIdFromAri)(result_2.agentAri) ?? undefined
                        }
                    });
                    setAgentAri(result_2.agentAri);
                    setConfirmedChosenOption($9bef0eda68c35c51$var$CHOSEN_OPTION.REFINE_IN_STUDIO);
                    nextAri = result_2.agentAri;
                }
                const agentId_2 = (0, $fCOel.getAgentIdFromAri)(nextAri);
                if (!agentId_2) return;
                const editUrl_0 = (0, $fa8WQ.getAtlassianStudioAgentEditUrl)(actionRenderer.cloudId, agentId_2, (0, $duz5q.STUDIO_NAVIGATION_SOURCE));
                window.open(editUrl_0, '_blank', 'noopener,noreferrer');
                if (refineInStudioFlowKey && !shouldShowBuildAndChatPublishedActions_0) // Show contextual follow-up text so the user knows what to do next in Studio.
                setFollowUpResult({
                    type: 'refine_in_studio',
                    flowKey: refineInStudioFlowKey
                });
            } catch (error_0) {
                // confirmCreateAgent failed — analytics already fired in confirmCreateAgent.
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_REFINE_IN_STUDIO,
                    error: error_0 instanceof Error ? error_0 : new Error(String(error_0)),
                    attributes: commonAttributes
                });
            } finally{
                setIsSecondaryActionLoading(false);
            }
        };
        const secondaryActionLabel = shouldShowBuildAndChatPublishedActions_0 ? $9bef0eda68c35c51$var$viewInStudioLabel : $9bef0eda68c35c51$var$refineInStudioLabel;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            isLoading: isSecondaryActionLoading,
            isDisabled: isSubmitting || isPrimaryActionLoading || isSecondaryActionLoading,
            onClick: onSecondaryAction,
            testId: "rovo-create-agent-card-refine-in-studio"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryActionLabel));
    }, [
        firstAction,
        flowKey,
        isReadonly,
        isSubmitting,
        isPrimaryActionLoading,
        isSecondaryActionLoading,
        agentAri,
        confirmCreateAgent,
        actionRenderer.cloudId,
        sendAnalyticsEvent,
        conversationId,
        invocationId,
        messageId,
        issueId,
        agent,
        setFollowUpResult,
        experienceTracker,
        commonAttributes,
        isBuildAndChatMultiStepEnabled,
        isBuildAndChatAgentConfirmed
    ]);
    const secondaryAction = (0, $cozmU.useMemo)(()=>renderSecondaryAction(), [
        renderSecondaryAction
    ]);
    const handleRenderError = (0, $cozmU.useCallback)((error_1)=>{
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_RENDER,
            error: error_1,
            attributes: commonAttributes
        });
    }, [
        experienceTracker,
        commonAttributes
    ]);
    if (!firstAction || !agent) return null;
    const cardProps = {
        cloudId: actionRenderer.cloudId,
        agentName: agent.name,
        description: agent.description ?? '',
        instructions: agent.instructions ?? '',
        knowledge: $9bef0eda68c35c51$var$toPillListKnowledge(agent.knowledgeSources),
        tools: $9bef0eda68c35c51$var$mapToolsToCardTools(agent.tools),
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        renderExperienceName: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_RENDER,
        shouldRenderDetailedPublishedCard: isBuildAndChatMultiStepEnabled
    };
    if (!agentAri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_RENDER,
        attributes: {
            ...commonAttributes,
            state: 'plan'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        }),
        onError: handleRenderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jz5To.AgentPlanAnalytics), {
        actionRenderer: actionRenderer
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aJUzF.CreateAgentCard), cardProps), actionResultMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQyXl.AgentCreationFollowUpText), {
        followUpResult: actionResultMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQyXl.AgentCreationFollowUpText), {
        followUpResult: followUpResult
    })));
    // For draft/published states fetch the persisted agent so we render
    // hydrated values (name, description, instructions, icon, publish status).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).STUDIO_CREATE_AGENT_RENDER,
        attributes: {
            ...commonAttributes,
            state: 'persisted'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        }),
        onError: handleRenderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6wkD.CreateAgentCardSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmat6.CreateAgentCardWithQuery), {
        agentAri: agentAri,
        ...cardProps,
        renderPrimaryAction: renderPrimaryAction,
        renderSecondaryAction: renderSecondaryAction
    })), actionResultMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQyXl.AgentCreationFollowUpText), {
        followUpResult: actionResultMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQyXl.AgentCreationFollowUpText), {
        followUpResult: followUpResult
    })));
};
module.exports["StudioCreateAgentRenderer"] = $9bef0eda68c35c51$export$15a0fc18955ab741;

});

parcelRegister("7MXyP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $n2nLe = parcelRequire("n2nLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $kTGj5 = parcelRequire("kTGj5");


var $dw75i = parcelRequire("dw75i");


var $bxkJA = parcelRequire("bxkJA");


var $lJ6db = parcelRequire("lJ6db");


var $hMLWD = parcelRequire("hMLWD");


var $1Bxlw = parcelRequire("1Bxlw");


var $fZEQY = parcelRequire("fZEQY");


var $lvrah = parcelRequire("lvrah");


var $fqeYe = parcelRequire("fqeYe");


var $l4Yt3 = parcelRequire("l4Yt3");


var $l7t3l = parcelRequire("l7t3l");

const $7f4fb469cf8e3c8f$var$isSkillActionResult = (data)=>Boolean(data && typeof data === 'object' && 'skillAri' in data);
const $7f4fb469cf8e3c8f$var$getSkillExecutedDataWithSkillAri = (data)=>{
    if (!data || typeof data !== 'object' || 'skillAri' in data || !('id' in data) || typeof data.id !== 'string') return data;
    return {
        ...data,
        skillAri: data.id
    };
};
const $7f4fb469cf8e3c8f$var$SkillDetailsCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkillDetailsCard(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { skillAri: skillAri, cloudId: cloudId, cardProps: cardProps } = t0;
    let t1;
    if ($[0] !== cloudId) {
        t1 = (0, $kTGj5.PlatformSiteAri).create({
            siteId: cloudId
        }).toString();
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const contextAri = t1;
    const [updatedSkill, setUpdatedSkill] = (0, $cozmU.useState)(null);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            topic: "ai-mate"
        };
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== skillAri) {
        t3 = (payload)=>{
            if (payload.type === "custom-skill-update" && payload.data.skillAri === skillAri) setUpdatedSkill(payload.data);
        };
        $[3] = skillAri;
        $[4] = t3;
    } else t3 = $[4];
    (0, $hdBxM.useSubscribe)(t2, t3);
    let t4;
    if ($[5] !== contextAri || $[6] !== skillAri) {
        t4 = {
            skillAri: skillAri,
            contextAri: contextAri
        };
        $[5] = contextAri;
        $[6] = skillAri;
        $[7] = t4;
    } else t4 = $[7];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $n2nLe.default), t4);
    const skill = data.graphIntegration_skill;
    if (!skill) {
        let t5;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
                errorType: "generic"
            });
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    const t5 = updatedSkill?.displayName ?? skill?.uiMetadata?.displayName ?? skill?.name ?? cardProps.displayName;
    const t6 = updatedSkill?.helpText ?? skill?.uiMetadata?.helpText ?? cardProps.helpText;
    const t7 = updatedSkill?.description ?? skill?.description ?? cardProps.description;
    const t8 = updatedSkill?.instructions ?? skill?.instructions ?? cardProps.instructions;
    let t9;
    if ($[9] !== cardProps || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fZEQY.CustomSkillCard), {
            ...cardProps,
            displayName: t5,
            helpText: t6,
            description: t7,
            instructions: t8
        });
        $[9] = cardProps;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    return t9;
} : function SkillDetailsCard({ skillAri: skillAri, cloudId: cloudId, cardProps: cardProps }) {
    const contextAri = (0, $cozmU.useMemo)(()=>(0, $kTGj5.PlatformSiteAri).create({
            siteId: cloudId
        }).toString(), [
        cloudId
    ]);
    // When the skill is edited from the edit-skill modal it broadcasts the newly persisted content.
    // We apply that payload directly (no refetch), keeping every card for the same skill in sync.
    const [updatedSkill, setUpdatedSkill] = (0, $cozmU.useState)(null);
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate'
    }, (payload)=>{
        if (payload.type === 'custom-skill-update' && payload.data.skillAri === skillAri) setUpdatedSkill(payload.data);
    });
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $n2nLe.default), {
        skillAri: skillAri,
        contextAri: contextAri
    });
    const skill = data.graphIntegration_skill;
    if (!skill) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
        errorType: "generic"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fZEQY.CustomSkillCard), {
        ...cardProps,
        displayName: updatedSkill?.displayName ?? skill?.uiMetadata?.displayName ?? skill?.name ?? cardProps.displayName,
        helpText: updatedSkill?.helpText ?? skill?.uiMetadata?.helpText ?? cardProps.helpText,
        description: updatedSkill?.description ?? skill?.description ?? cardProps.description,
        instructions: updatedSkill?.instructions ?? skill?.instructions ?? cardProps.instructions
    });
};
function $7f4fb469cf8e3c8f$export$acd6a24d76c8d54a(actionRenderer) {
    const { invalidateSkillLibrary: invalidateSkillLibrary } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const assistanceService = (0, $lJ6db.useAssistanceService)();
    const firstAction = actionRenderer.actions[0];
    const invocationId = firstAction?.invocationId;
    const executedData = $7f4fb469cf8e3c8f$var$getSkillExecutedDataWithSkillAri(firstAction?.executedData);
    const hasExecutedSkillAri = $7f4fb469cf8e3c8f$var$isSkillActionResult(executedData);
    // Seeded from the cache: a remount would otherwise lose the ari, and with it the Edit button.
    const [resolvedSkillAri, setResolvedSkillAri] = (0, $cozmU.useState)(()=>(0, $l7t3l.getResolvedSkillAri)(invocationId));
    const [isConfirming, setIsConfirming] = (0, $cozmU.useState)(false);
    // The action carries the ari itself now, so the cached copy is dead weight.
    (0, $cozmU.useEffect)(()=>{
        if (hasExecutedSkillAri && invocationId) (0, $l7t3l.forgetResolvedSkillAri)(invocationId);
    }, [
        hasExecutedSkillAri,
        invocationId
    ]);
    if (!firstAction) return null;
    const { cloudId: cloudId, conversationId: conversationId, getStatus: getStatus, onConfirm: onConfirm, onCustomDataConfirm: onCustomDataConfirm } = actionRenderer;
    const { displayName: displayName, description: description, instructions: instructions, helpText: helpText } = firstAction.data;
    const status = getStatus(firstAction);
    const isUpdateAction = firstAction.key === (0, $dw75i.ActionKeys).UpdateCustomSkillTool;
    // `firstAction.status` is set for a historical action; `status` reflects an in-session
    // resolution. Also a success signal — `deriveInvocationStatus` reports 'errored' unless
    // `isActionExecutedSuccessfully` holds.
    const hasFinishedSuccessfully = status === 'finished' || firstAction.status === 'finished';
    const dataSkillAri = $7f4fb469cf8e3c8f$var$isSkillActionResult(firstAction.data) ? firstAction.data.skillAri : undefined;
    const executedSkillAri = hasExecutedSkillAri ? executedData.skillAri : undefined;
    // update card uses skill ari from `.data`. create card uses skill ari from executedData OR from cache
    const skillAri = isUpdateAction ? dataSkillAri : executedSkillAri ?? resolvedSkillAri;
    const persistedSkillAri = hasFinishedSuccessfully ? skillAri : undefined;
    const showEditButton = Boolean(persistedSkillAri) && (0, $iDrrr.fg)('chat_edit_skill_modal');
    const isDisabled = !showEditButton && (status !== 'idle' || firstAction.status && [
        'errored',
        'cancelled',
        'finished'
    ].includes(firstAction.status));
    const isSubmitting = status === 'started' || isConfirming;
    /**
   * The resolve response carries no result for these tools, so a newly created skill's ARI is only
   * readable from the persisted action in history. Silent on failure: the skill was still created,
   * and the ARI is picked up on the next page load.
   */ const resolveSkillAriFromHistory = async ()=>{
        // Surfaces without a configured service get the context default, which has no base URL.
        if (!conversationId || !assistanceService.getConfig().baseUrl) return;
        try {
            const chat = await assistanceService.getChat(conversationId);
            const persistedData = $7f4fb469cf8e3c8f$var$getSkillExecutedDataWithSkillAri((0, $fqeYe.getExecutedDataFromChat)(chat, firstAction.invocationId));
            if ($7f4fb469cf8e3c8f$var$isSkillActionResult(persistedData)) {
                setResolvedSkillAri(persistedData.skillAri);
                (0, $l7t3l.cacheResolvedSkillAri)(firstAction.invocationId, persistedData.skillAri);
            }
        } catch  {
        // Non-fatal, see above.
        }
    };
    const handleConfirm = async ()=>{
        setIsConfirming(true);
        try {
            // A skill update must only be reflected in the UI when the backend tool actually
            // succeeded. `onConfirm` resolves even when the tool returns a failure result, so for
            // the sync path we resolve via `onCustomDataConfirm`, whose content processor reports
            // execution success — the same signal the backend success broadcast keys off.
            const syncSkillUpdate = firstAction.key === (0, $dw75i.ActionKeys).UpdateCustomSkillTool && (0, $iDrrr.fg)('studio_sync_custom_skill_chat_update');
            let updateSucceeded = false;
            if (syncSkillUpdate) updateSucceeded = await onCustomDataConfirm(firstAction, firstAction.data, (0, $bxkJA.isActionExecutedSuccessfully)) === true;
            else await onConfirm(firstAction);
            invalidateSkillLibrary();
            // The lookup only exists to discover the ari, so knowing one already makes it dead work —
            // an update reads it off its payload, and a create's own result carries it after a reload.
            if (!skillAri && (0, $iDrrr.fg)('chat_edit_skill_modal')) await resolveSkillAriFromHistory();
            // `updateSucceeded` is only ever true for a confirmed, successful skill update. The
            // `'skillAri' in` check narrows `firstAction.data` to the update payload with no cast;
            // the action isn't a key-discriminated union, so a `key ===` check would not narrow.
            if (updateSucceeded && 'skillAri' in firstAction.data) {
                const { skillAri: skillAri, name: name, tools: tools } = firstAction.data;
                publish({
                    type: 'custom-skill-update',
                    source: 'studio-custom-skill-action-ui',
                    data: {
                        skillAri: skillAri,
                        name: name,
                        displayName: displayName,
                        helpText: helpText,
                        description: description,
                        instructions: instructions,
                        tools: tools
                    }
                });
            }
        } finally{
            setIsConfirming(false);
        }
    };
    const cardProps = {
        displayName: displayName,
        helpText: helpText,
        description: description,
        instructions: instructions,
        headerLabel: isUpdateAction ? (0, $l4Yt3.messages).updateSkillHeaderLabel : (0, $l4Yt3.messages).createSkillHeaderLabel,
        confirmLabel: isUpdateAction ? (0, $l4Yt3.messages).updateLabel : (0, $l4Yt3.messages).confirmLabel,
        isDisabled: isDisabled,
        isSubmitting: isSubmitting,
        onConfirm: handleConfirm,
        confirmSlot: showEditButton && persistedSkillAri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lvrah.EditSkillModalButton), {
            cloudId: cloudId,
            skillAri: persistedSkillAri,
            cardType: isUpdateAction ? 'update' : 'create'
        }) : undefined
    };
    if (persistedSkillAri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fZEQY.CustomSkillCard), {
            ...cardProps,
            isLoadingDetails: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f4fb469cf8e3c8f$var$SkillDetailsCard, {
        skillAri: persistedSkillAri,
        cloudId: cloudId,
        cardProps: cardProps
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fZEQY.CustomSkillCard), cardProps);
}
module.exports["StudioCustomSkillRenderer"] = $7f4fb469cf8e3c8f$export$acd6a24d76c8d54a;

});

parcelRegister("6Unds", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $4ez2K = parcelRequire("4ez2K");


var $hdBxM = parcelRequire("hdBxM");


var $7eUSO = parcelRequire("7eUSO");


var $9ZloL = parcelRequire("9ZloL");

const $c6268f852aed3f81$var$disabledActions = [
    'finished',
    'cancelled',
    'errored'
];
const $c6268f852aed3f81$export$3b79ee2c9637431c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(37);
    (0, $6cFsl.di)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { actions: actions, onCancel: onCancel, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = props;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const firstAction = actions[0];
    const { data: data } = firstAction;
    let t0;
    if ($[0] !== firstAction || $[1] !== getStatus) {
        t0 = getStatus(firstAction);
        $[0] = firstAction;
        $[1] = getStatus;
        $[2] = t0;
    } else t0 = $[2];
    const status = t0;
    let t1;
    if ($[3] !== firstAction.status || $[4] !== status) {
        t1 = status !== "idle" || $c6268f852aed3f81$var$disabledActions.includes(firstAction.status);
        $[3] = firstAction.status;
        $[4] = status;
        $[5] = t1;
    } else t1 = $[5];
    const isDisabled = t1;
    const isSubmitting = status === "started";
    let t2;
    if ($[6] !== actions || $[7] !== conversationId || $[8] !== data || $[9] !== firstAction || $[10] !== getStatus || $[11] !== messageId || $[12] !== onCustomDataConfirm || $[13] !== publish || $[14] !== recipientAgentId || $[15] !== sendMessageConfirmedTools) {
        t2 = async ()=>{
            if ((0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false)) {
                const idleActions = actions.filter((action)=>getStatus(action) === "idle");
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: "studioLandingPageRedirectRenderer"
                    },
                    confirmed_tools: {
                        message_id: messageId ?? "",
                        tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, "confirmed", data) : (0, $7eUSO.buildToolFromAction)(action_0, "cancelled"))
                    }
                });
            } else await onCustomDataConfirm(firstAction, data);
            const { ari: ari, prompt: prompt } = data;
            publish({
                type: "studio-landing-page-redirect",
                data: {
                    ari: ari,
                    prompt: prompt
                },
                source: "studio-landing-page-redirect-action-ui"
            });
        };
        $[6] = actions;
        $[7] = conversationId;
        $[8] = data;
        $[9] = firstAction;
        $[10] = getStatus;
        $[11] = messageId;
        $[12] = onCustomDataConfirm;
        $[13] = publish;
        $[14] = recipientAgentId;
        $[15] = sendMessageConfirmedTools;
        $[16] = t2;
    } else t2 = $[16];
    const onClick = t2;
    let t3;
    if ($[17] !== formatMessage) {
        t3 = formatMessage((0, $9ZloL.messages).confirmButton);
        $[17] = formatMessage;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== isDisabled || $[20] !== isSubmitting || $[21] !== onClick || $[22] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: onClick,
            isDisabled: isDisabled,
            isLoading: isSubmitting
        }, t3);
        $[19] = isDisabled;
        $[20] = isSubmitting;
        $[21] = onClick;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    let t5;
    if ($[24] !== firstAction || $[25] !== onCancel) {
        t5 = ()=>onCancel(firstAction);
        $[24] = firstAction;
        $[25] = onCancel;
        $[26] = t5;
    } else t5 = $[26];
    let t6;
    if ($[27] !== formatMessage) {
        t6 = formatMessage((0, $9ZloL.messages).cancelButton);
        $[27] = formatMessage;
        $[28] = t6;
    } else t6 = $[28];
    let t7;
    if ($[29] !== isDisabled || $[30] !== isSubmitting || $[31] !== t5 || $[32] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: t5,
            isDisabled: isDisabled,
            isLoading: isSubmitting
        }, t6);
        $[29] = isDisabled;
        $[30] = isSubmitting;
        $[31] = t5;
        $[32] = t6;
        $[33] = t7;
    } else t7 = $[33];
    let t8;
    if ($[34] !== t4 || $[35] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            testId: "conversation-assistant-message-actions.studio-landing-page-redirect",
            gap: "space.100"
        }, t4, t7);
        $[34] = t4;
        $[35] = t7;
        $[36] = t8;
    } else t8 = $[36];
    return t8;
} : (props)=>{
    (0, $6cFsl.di)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { actions: actions, onCancel: onCancel, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = props;
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const status = getStatus(firstAction);
    const isDisabled = status !== 'idle' || $c6268f852aed3f81$var$disabledActions.includes(firstAction.status);
    const isSubmitting = status === 'started';
    const onClick = async ()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'studioLandingPageRedirectRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', data) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
        } else await onCustomDataConfirm(firstAction, data);
        const { ari: ari, prompt: prompt } = data;
        publish({
            type: 'studio-landing-page-redirect',
            data: {
                ari: ari,
                prompt: prompt
            },
            source: 'studio-landing-page-redirect-action-ui'
        });
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        testId: "conversation-assistant-message-actions.studio-landing-page-redirect",
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $9ZloL.messages).confirmButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>onCancel(firstAction),
        isDisabled: isDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $9ZloL.messages).cancelButton)));
};
module.exports["StudioLandingPageRedirect"] = $c6268f852aed3f81$export$3b79ee2c9637431c;

});

parcelRegister("ahA41", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kz8pi = parcelRequire("kz8pi");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $d6044 = parcelRequire("d6044");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $2MD0u = parcelRequire("2MD0u");


var $1zNQN = parcelRequire("1zNQN");


var $l3JZO = parcelRequire("l3JZO");


var $4Jq8D = parcelRequire("4Jq8D");


var $lzU6z = parcelRequire("lzU6z");

const $c3d55f5dd1514200$var$PlanCardRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { planCardProps: planCardProps, actionRendererProps: t1, shouldTriggerSolutionPlanEvent: shouldTriggerSolutionPlanEvent } = t0;
    const { actions: actions, productKey: productKey, cloudId: cloudId, renderingTouchpoint: renderingTouchpoint, aaid: aaid } = t1;
    (0, $6cFsl.di)();
    const firstAction = actions[0];
    const { solutionId: solutionId, workspaceId: workspaceId } = firstAction.data;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t2;
    let t3;
    if ($[0] !== sendAnalyticsEvent || $[1] !== shouldTriggerSolutionPlanEvent) {
        t2 = ()=>{
            if (!shouldTriggerSolutionPlanEvent) return;
            sendAnalyticsEvent({
                eventType: "track",
                action: "generated",
                actionSubject: "solutionPlan"
            });
        };
        t3 = [
            sendAnalyticsEvent,
            shouldTriggerSolutionPlanEvent
        ];
        $[0] = sendAnalyticsEvent;
        $[1] = shouldTriggerSolutionPlanEvent;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== aaid || $[6] !== cloudId || $[7] !== firstAction.data.solutionVersion || $[8] !== firstAction.data.title || $[9] !== planCardProps || $[10] !== productKey || $[11] !== renderingTouchpoint || $[12] !== solutionId || $[13] !== workspaceId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zNQN.PlanCard), {
            isLoading: false,
            name: firstAction.data.title,
            solutionVersion: firstAction.data.solutionVersion,
            builds: t4,
            productKey: productKey,
            cloudId: cloudId,
            aaid: aaid,
            refetchSolutionPlan: $c3d55f5dd1514200$var$_temp,
            currentBuildNumber: 0,
            solutionId: solutionId,
            experienceTracker: null,
            workspaceId: workspaceId,
            renderingTouchpoint: renderingTouchpoint,
            solutionState: "DRAFT",
            ...planCardProps
        });
        $[5] = aaid;
        $[6] = cloudId;
        $[7] = firstAction.data.solutionVersion;
        $[8] = firstAction.data.title;
        $[9] = planCardProps;
        $[10] = productKey;
        $[11] = renderingTouchpoint;
        $[12] = solutionId;
        $[13] = workspaceId;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ planCardProps: planCardProps, actionRendererProps: { actions: actions, productKey: productKey, cloudId: cloudId, renderingTouchpoint: renderingTouchpoint, aaid: aaid }, shouldTriggerSolutionPlanEvent: shouldTriggerSolutionPlanEvent })=>{
    (0, $6cFsl.di)();
    const firstAction = actions[0];
    const { solutionId: solutionId, workspaceId: workspaceId } = firstAction.data;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        if (!shouldTriggerSolutionPlanEvent) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'generated',
            actionSubject: 'solutionPlan'
        });
    }, [
        sendAnalyticsEvent,
        shouldTriggerSolutionPlanEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zNQN.PlanCard), {
        isLoading: false,
        name: firstAction.data.title,
        solutionVersion: firstAction.data.solutionVersion,
        builds: [],
        productKey: productKey,
        cloudId: cloudId,
        aaid: aaid,
        refetchSolutionPlan: ()=>{},
        currentBuildNumber: 0,
        solutionId: solutionId,
        experienceTracker: null,
        workspaceId: workspaceId,
        renderingTouchpoint: renderingTouchpoint,
        solutionState: 'DRAFT',
        ...planCardProps
    });
};
const $c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionInner = ({ refetch: refetch, queryRef: queryRef, actionRendererProps: actionRendererProps })=>{
    (0, $6cFsl.di)();
    const { actions: actions, productKey: productKey, cloudId: cloudId, renderingTouchpoint: renderingTouchpoint } = actionRendererProps;
    const firstAction = actions[0];
    const { solutionId: solutionId, solutionVersion: solutionVersion, title: title, workspaceId: workspaceId } = firstAction.data;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const data = (0, $6SsN4.usePreloadedQuery)((0, $kz8pi.default), queryRef);
    const solutionPlan = data?.studio_solutionPlan;
    const builds = (0, $cozmU.useMemo)(()=>{
        const isStateValue = (state)=>{
            return (0, $4Jq8D.BuildStateValues).includes(state ?? '');
        };
        const isTypeValue = (type)=>{
            return (0, $4Jq8D.BuildTypeValues).includes(type ?? '');
        };
        if ((0, $iDrrr.fg)('sltns-1183-order-builds')) return solutionPlan?.builds?.sequence?.filter(Boolean).map((build)=>({
                id: build?.buildId ?? '',
                dependencies: build?.dependencies?.filter((dependency)=>!!(dependency ?? false)) ?? [],
                name: build?.name ?? '',
                number: build?.number ?? 0,
                overview: build?.overview ?? '',
                state: isStateValue(build?.state) ? build.state : 'FAILED',
                // AGG Should return the state, otherwise we force it for FAILED
                type: isTypeValue(build?.type) ? build.type : 'AUTOMATION_RULE',
                // AGG Should return the type, otherwise we force it for AUTOMATION_RULE
                conversationId: solutionPlan?.conversationId ?? '',
                solutionId: solutionPlan?.solutionId ?? '',
                solutionVersion: `${solutionPlan?.solutionVersion ?? ''}`,
                ...(0, $iDrrr.fg)('rovo_agent_versioning_enabled') && {
                    ari: build?.associatedObjectAri
                }
            })).sort((a, b)=>a.number - b.number) || [];
        return solutionPlan?.builds?.sequence?.filter(Boolean).map((build_0)=>({
                id: build_0?.buildId ?? '',
                dependencies: build_0?.dependencies?.filter((dependency_0)=>!!(dependency_0 ?? false)) ?? [],
                name: build_0?.name ?? '',
                number: build_0?.number ?? 0,
                overview: build_0?.overview ?? '',
                state: isStateValue(build_0?.state) ? build_0.state : 'FAILED',
                // AGG Should return the state, otherwise we force it for FAILED
                type: isTypeValue(build_0?.type) ? build_0.type : 'AUTOMATION_RULE',
                // AGG Should return the type, otherwise we force it for AUTOMATION_RULE
                conversationId: solutionPlan?.conversationId ?? '',
                solutionId: solutionPlan?.solutionId ?? '',
                solutionVersion: `${solutionPlan?.solutionVersion ?? ''}`,
                ...(0, $iDrrr.fg)('rovo_agent_versioning_enabled') && {
                    ari: build_0?.associatedObjectAri
                }
            })) || [];
    }, [
        solutionPlan
    ]);
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
            name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN
        });
        if (!workspaceId) experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
            error: new Error('Missing workspaceId')
        });
    }, [
        experienceTracker,
        workspaceId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (solutionPlan) {
            const solutionTypes = [
                ...new Set(solutionPlan?.builds?.sequence?.map((build_1)=>build_1?.type).filter((buildType)=>Boolean(buildType))) ?? []
            ];
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'viewed',
                actionSubject: 'solutionPlan',
                attributes: {
                    solutionId: solutionId,
                    solutionVersion: solutionPlan?.solutionVersion,
                    solutionTypes: solutionTypes,
                    buildCount: solutionPlan?.builds?.sequence?.length || 0
                }
            });
        }
    }, [
        solutionPlan,
        solutionId,
        sendAnalyticsEvent
    ]);
    const solutionState = (0, $cozmU.useMemo)(()=>{
        const isPlanState = (value)=>(0, $4Jq8D.PlanStateValues).includes(value);
        return isPlanState(solutionPlan?.state) ? solutionPlan.state : undefined;
    }, [
        solutionPlan?.state
    ]);
    if (!workspaceId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2MD0u.SolutionPlanStateUpdateListener), {
        refetch: refetch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$PlanCardRenderer, {
        planCardProps: {
            name: solutionPlan?.name ?? title,
            solutionVersion: `${solutionPlan?.solutionVersion ?? solutionVersion}`,
            builds: builds,
            productKey: productKey,
            cloudId: cloudId,
            refetchSolutionPlan: refetch,
            currentBuildNumber: solutionPlan?.currentBuildNumber ?? 0,
            solutionId: solutionId,
            experienceTracker: experienceTracker,
            spaceId: solutionPlan?.spaceId ?? undefined,
            workspaceId: workspaceId,
            renderingTouchpoint: renderingTouchpoint,
            solutionState: solutionState ?? 'DRAFT'
        },
        actionRendererProps: actionRendererProps
    }));
};
const $c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionOld = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { actions: actions, productKey: productKey, cloudId: cloudId, aaid: aaid, isHistoricalMessage: isHistoricalMessage } = t0;
    (0, $6cFsl.di)();
    const firstAction = actions[0];
    const { solutionId: solutionId, solutionVersion: solutionVersion, title: title, workspaceId: workspaceIdFromActionData } = firstAction.data;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $lzU6z.getWorkspaceIdFromUrl)();
        $[0] = t1;
    } else t1 = $[0];
    const workspaceId = t1;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    let t2;
    let t3;
    if ($[1] !== solutionId || $[2] !== solutionVersion) {
        t2 = [
            "fetchSolutionPlan",
            solutionId,
            solutionVersion
        ];
        t3 = ()=>(0, $l3JZO.fetchSolutionPlan)(workspaceId ?? "", solutionId, solutionVersion);
        $[1] = solutionId;
        $[2] = solutionVersion;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    const t4 = !!workspaceId && !!solutionId && !!solutionVersion;
    let t5;
    if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
        t5 = {
            queryKey: t2,
            queryFn: t3,
            enabled: t4
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const { data: solutionPlan, isFetching: isFetching, refetch: refetch } = (0, $5SS4O.useQuery)(t5);
    const hasSolutionPlan = !!solutionPlan;
    let t6;
    let t7;
    if ($[9] !== hasSolutionPlan || $[10] !== isFetching || $[11] !== isHistoricalMessage || $[12] !== sendAnalyticsEvent) {
        t6 = ()=>{
            if (isFetching && !hasSolutionPlan && !isHistoricalMessage) sendAnalyticsEvent({
                eventType: "track",
                action: "generated",
                actionSubject: "solutionPlan"
            });
        };
        t7 = [
            isFetching,
            hasSolutionPlan,
            isHistoricalMessage,
            sendAnalyticsEvent
        ];
        $[9] = hasSolutionPlan;
        $[10] = isFetching;
        $[11] = isHistoricalMessage;
        $[12] = sendAnalyticsEvent;
        $[13] = t6;
        $[14] = t7;
    } else {
        t6 = $[13];
        t7 = $[14];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[15] !== experienceTracker) {
        t8 = ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
                name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN
            });
            if (!workspaceId) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
                error: new Error("Missing workspaceId")
            });
        };
        t9 = [
            experienceTracker,
            workspaceId
        ];
        $[15] = experienceTracker;
        $[16] = t8;
        $[17] = t9;
    } else {
        t8 = $[16];
        t9 = $[17];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    let t11;
    if ($[18] !== isFetching || $[19] !== sendAnalyticsEvent || $[20] !== solutionId || $[21] !== solutionPlan) {
        t10 = ()=>{
            if (solutionPlan && !isFetching) {
                const solutionTypes = [
                    ...new Set(solutionPlan.builds.map($c3d55f5dd1514200$var$_temp0))
                ];
                sendAnalyticsEvent({
                    eventType: "track",
                    action: "viewed",
                    actionSubject: "solutionPlan",
                    attributes: {
                        solutionId: solutionId,
                        solutionVersion: solutionPlan.solutionVersion,
                        solutionTypes: solutionTypes,
                        buildCount: solutionPlan.builds.length || 0
                    }
                });
            }
        };
        t11 = [
            solutionPlan,
            isFetching,
            solutionId,
            sendAnalyticsEvent
        ];
        $[18] = isFetching;
        $[19] = sendAnalyticsEvent;
        $[20] = solutionId;
        $[21] = solutionPlan;
        $[22] = t10;
        $[23] = t11;
    } else {
        t10 = $[22];
        t11 = $[23];
    }
    (0, $cozmU.useEffect)(t10, t11);
    if (!workspaceId) return null;
    let t12;
    if ($[24] !== refetch) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2MD0u.SolutionPlanStateUpdateListener), {
            refetch: refetch
        });
        $[24] = refetch;
        $[25] = t12;
    } else t12 = $[25];
    const t13 = solutionPlan?.name ?? title;
    const t14 = solutionPlan?.solutionVersion ?? solutionVersion;
    let t15;
    if ($[26] !== solutionPlan?.builds) {
        t15 = solutionPlan?.builds ?? [];
        $[26] = solutionPlan?.builds;
        $[27] = t15;
    } else t15 = $[27];
    const t16 = solutionPlan?.spaceId;
    const t17 = solutionPlan?.currentBuildNumber ?? 0;
    const t18 = solutionPlan?.state ?? "DRAFT";
    let t19;
    if ($[28] !== aaid || $[29] !== cloudId || $[30] !== experienceTracker || $[31] !== isFetching || $[32] !== productKey || $[33] !== refetch || $[34] !== solutionId || $[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== t18 || $[41] !== workspaceIdFromActionData) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zNQN.PlanCard), {
            isLoading: isFetching,
            name: t13,
            solutionVersion: t14,
            builds: t15,
            productKey: productKey,
            cloudId: cloudId,
            aaid: aaid,
            spaceId: t16,
            refetchSolutionPlan: refetch,
            currentBuildNumber: t17,
            solutionId: solutionId,
            workspaceId: workspaceIdFromActionData,
            experienceTracker: experienceTracker,
            solutionState: t18
        });
        $[28] = aaid;
        $[29] = cloudId;
        $[30] = experienceTracker;
        $[31] = isFetching;
        $[32] = productKey;
        $[33] = refetch;
        $[34] = solutionId;
        $[35] = t13;
        $[36] = t14;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
        $[40] = t18;
        $[41] = workspaceIdFromActionData;
        $[42] = t19;
    } else t19 = $[42];
    let t20;
    if ($[43] !== t12 || $[44] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, t19);
        $[43] = t12;
        $[44] = t19;
        $[45] = t20;
    } else t20 = $[45];
    return t20;
} : ({ actions: actions, productKey: productKey, cloudId: cloudId, aaid: aaid, isHistoricalMessage: isHistoricalMessage })=>{
    (0, $6cFsl.di)();
    const firstAction = actions[0];
    const { solutionId: solutionId, solutionVersion: solutionVersion, title: title, workspaceId: workspaceIdFromActionData } = firstAction.data;
    const workspaceId = (0, $lzU6z.getWorkspaceIdFromUrl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { data: solutionPlan, isFetching: isFetching, refetch: refetch } = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchSolutionPlan',
            solutionId,
            solutionVersion
        ],
        queryFn: ()=>(0, $l3JZO.fetchSolutionPlan)(workspaceId ?? '', solutionId, solutionVersion),
        enabled: !!workspaceId && !!solutionId && !!solutionVersion
    });
    const hasSolutionPlan = !!solutionPlan;
    (0, $cozmU.useEffect)(()=>{
        /**
     * This event should only happen once when the data was just streamed.
     * If the user closes the chat and re-open, the message will still return as no historical
     * As it was saved in store from the stream. So to avoid duplication, we check if solution plan
     * is not cached. If it is cached it means the user already saw the solution plan card, and we won't send generated event again.
     */ if (isFetching && !hasSolutionPlan && !isHistoricalMessage) sendAnalyticsEvent({
            eventType: 'track',
            action: 'generated',
            actionSubject: 'solutionPlan'
        });
    }, [
        isFetching,
        hasSolutionPlan,
        isHistoricalMessage,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
            name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN
        });
        if (!workspaceId) experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
            error: new Error('Missing workspaceId')
        });
    }, [
        experienceTracker,
        workspaceId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (solutionPlan && !isFetching) {
            const solutionTypes = [
                ...new Set(solutionPlan.builds.map((build)=>build.type))
            ];
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'viewed',
                actionSubject: 'solutionPlan',
                attributes: {
                    solutionId: solutionId,
                    solutionVersion: solutionPlan.solutionVersion,
                    solutionTypes: solutionTypes,
                    buildCount: solutionPlan.builds.length || 0
                }
            });
        }
    }, [
        solutionPlan,
        isFetching,
        solutionId,
        sendAnalyticsEvent
    ]);
    if (!workspaceId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2MD0u.SolutionPlanStateUpdateListener), {
        refetch: refetch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zNQN.PlanCard), {
        isLoading: isFetching,
        name: solutionPlan?.name ?? title,
        solutionVersion: solutionPlan?.solutionVersion ?? solutionVersion,
        builds: solutionPlan?.builds ?? [],
        productKey: productKey,
        cloudId: cloudId,
        aaid: aaid,
        spaceId: solutionPlan?.spaceId,
        refetchSolutionPlan: refetch,
        currentBuildNumber: solutionPlan?.currentBuildNumber ?? 0,
        solutionId: solutionId,
        workspaceId: workspaceIdFromActionData,
        experienceTracker: experienceTracker,
        solutionState: solutionPlan?.state ?? 'DRAFT'
    }));
};
const $c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(21);
    const { actions: actions, isHistoricalMessage: isHistoricalMessage } = props;
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $kz8pi.default));
    const firstAction = actions[0];
    const { solutionId: solutionId, solutionVersion: solutionVersion, workspaceId: workspaceId } = firstAction.data;
    let t0;
    if ($[0] !== workspaceId) {
        t0 = (0, $d6044.StudioWorkspaceAri).create({
            workspaceId: workspaceId
        }).toString();
        $[0] = workspaceId;
        $[1] = t0;
    } else t0 = $[1];
    const workspaceAri = t0;
    let t1;
    if ($[2] !== solutionId || $[3] !== solutionVersion || $[4] !== workspaceAri) {
        t1 = ()=>({
                workspaceAri: workspaceAri ?? "",
                solutionId: solutionId,
                solutionVersion: Number(solutionVersion),
                skip: !workspaceAri,
                shouldIncludeAri: (0, $iDrrr.fg)("rovo_agent_versioning_enabled")
            });
        $[2] = solutionId;
        $[3] = solutionVersion;
        $[4] = workspaceAri;
        $[5] = t1;
    } else t1 = $[5];
    const getQueryAttributes = t1;
    let t2;
    let t3;
    if ($[6] !== getQueryAttributes || $[7] !== loadQuery) {
        t2 = ()=>{
            loadQuery(getQueryAttributes());
        };
        t3 = [
            getQueryAttributes,
            loadQuery
        ];
        $[6] = getQueryAttributes;
        $[7] = loadQuery;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[10] !== getQueryAttributes || $[11] !== loadQuery) {
        t4 = async ()=>{
            loadQuery(getQueryAttributes(), {
                fetchPolicy: "network-only"
            });
        };
        $[10] = getQueryAttributes;
        $[11] = loadQuery;
        $[12] = t4;
    } else t4 = $[12];
    const refetch = t4;
    let t5;
    if ($[13] !== props) {
        t5 = (shouldTriggerSolutionPlanEvent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$PlanCardRenderer, {
                planCardProps: {
                    isLoading: true
                },
                actionRendererProps: props,
                shouldTriggerSolutionPlanEvent: shouldTriggerSolutionPlanEvent
            });
        $[13] = props;
        $[14] = t5;
    } else t5 = $[14];
    const getSkeleton = t5;
    let t6;
    if ($[15] !== getSkeleton || $[16] !== isHistoricalMessage || $[17] !== props || $[18] !== queryRef || $[19] !== refetch) {
        t6 = queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: getSkeleton(!isHistoricalMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionInner, {
            actionRendererProps: props,
            isFetching: true,
            queryRef: queryRef,
            refetch: refetch
        })) : getSkeleton();
        $[15] = getSkeleton;
        $[16] = isHistoricalMessage;
        $[17] = props;
        $[18] = queryRef;
        $[19] = refetch;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
} : (props)=>{
    const { actions: actions, isHistoricalMessage: isHistoricalMessage } = props;
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $kz8pi.default));
    const firstAction = actions[0];
    const { solutionId: solutionId, solutionVersion: solutionVersion, workspaceId: workspaceId } = firstAction.data;
    const workspaceAri = (0, $cozmU.useMemo)(()=>(0, $d6044.StudioWorkspaceAri).create({
            workspaceId: workspaceId
        }).toString(), [
        workspaceId
    ]);
    const getQueryAttributes = (0, $cozmU.useCallback)(()=>({
            workspaceAri: workspaceAri ?? '',
            solutionId: solutionId,
            solutionVersion: Number(solutionVersion),
            skip: !workspaceAri,
            shouldIncludeAri: (0, $iDrrr.fg)('rovo_agent_versioning_enabled')
        }), [
        solutionId,
        solutionVersion,
        workspaceAri
    ]);
    (0, $cozmU.useEffect)(()=>{
        loadQuery(getQueryAttributes());
    }, [
        getQueryAttributes,
        loadQuery
    ]);
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        loadQuery(getQueryAttributes(), {
            fetchPolicy: 'network-only'
        });
    }, [
        getQueryAttributes,
        loadQuery
    ]);
    const getSkeleton = (shouldTriggerSolutionPlanEvent)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$PlanCardRenderer, {
            planCardProps: {
                isLoading: true
            },
            actionRendererProps: props,
            shouldTriggerSolutionPlanEvent: shouldTriggerSolutionPlanEvent
        });
    };
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: getSkeleton(!isHistoricalMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionInner, {
        actionRendererProps: props,
        isFetching: true,
        queryRef: queryRef,
        refetch: refetch
    })) : getSkeleton();
};
const $c3d55f5dd1514200$export$914747a507726a33 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("fe_enable_sa_externally") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionNew, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionOld, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $iDrrr.fg)('fe_enable_sa_externally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionNew, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3d55f5dd1514200$var$StudioTriggerSolutionBuildActionOld, props);
};
function $c3d55f5dd1514200$var$_temp() {}
function $c3d55f5dd1514200$var$_temp0(build) {
    return build.type;
}
module.exports["StudioTriggerSolutionBuildAction"] = $c3d55f5dd1514200$export$914747a507726a33;

});

parcelRegister("3eC2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");


var $hdBxM = parcelRequire("hdBxM");


var $7eUSO = parcelRequire("7eUSO");


var $6eH8m = parcelRequire("6eH8m");

const $e7bed0f863b4c095$var$STUDIO_UPDATE_AGENT_DRAFT_INTERACTION_SOURCE = 'studioUpdateAgentDraftRenderer';
const $e7bed0f863b4c095$export$ca53a843d12af9c1 = ({ actions: actions, getCancelButton: getCancelButton, getStatus: getStatus, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId, onCustomDataConfirm: onCustomDataConfirm, sendMessageConfirmedTools: sendMessageConfirmedTools })=>{
    (0, $6cFsl.di)((0, $hdBxM.usePublish));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const status = getStatus(firstAction);
    const { buildId: buildId, draftContent: draftContent } = data;
    const isDisabled = status !== 'idle';
    const isSubmitting = status === 'started';
    const onClick = async ()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: $e7bed0f863b4c095$var$STUDIO_UPDATE_AGENT_DRAFT_INTERACTION_SOURCE
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', data) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
        } else await onCustomDataConfirm(firstAction, data);
        publish({
            type: 'solution-draft-agent-update',
            data: {
                buildId: buildId,
                draftContent: draftContent
            },
            source: 'update-agent-draft-action-ui'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, getCancelButton(firstAction, isDisabled), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: isDisabled,
        onClick: onClick
    }, formatMessage((0, $6eH8m.default).confirmButton)));
};
module.exports["StudioUpdateAgentDraftAction"] = $e7bed0f863b4c095$export$ca53a843d12af9c1;

});

parcelRegister("6RfAT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $iGaH9 = parcelRequire("iGaH9");

const $877913c3c4bd3bbd$export$bd5677d08af694a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (actionRenderer)=>{
    const $ = (0, $bDgLe.c)(5);
    (0, $6cFsl.di)();
    const { ari: ari } = actionRenderer.actions[0].data;
    let t0;
    if ($[0] !== ari) {
        t0 = {
            type: "agent-configuration-update",
            data: {
                ari: ari
            },
            source: "update-agent-configuration-action-ui"
        };
        $[0] = ari;
        $[1] = t0;
    } else t0 = $[1];
    const payload = t0;
    let t1;
    if ($[2] !== actionRenderer || $[3] !== payload) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iGaH9.UpdateAgentBase), {
            actionRenderer: actionRenderer,
            payload: payload
        });
        $[2] = actionRenderer;
        $[3] = payload;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (actionRenderer)=>{
    (0, $6cFsl.di)();
    const { ari: ari } = actionRenderer.actions[0].data;
    const payload = {
        type: 'agent-configuration-update',
        data: {
            ari: ari
        },
        source: 'update-agent-configuration-action-ui'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iGaH9.UpdateAgentBase), {
        actionRenderer: actionRenderer,
        payload: payload
    });
};
module.exports["UpdateAgentConfigurationAction"] = $877913c3c4bd3bbd$export$bd5677d08af694a1;

});

parcelRegister("ccGNc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $iGaH9 = parcelRequire("iGaH9");

const $4d9a1c6471096431$export$3d18b3f073575332 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (actionRenderer)=>{
    const $ = (0, $bDgLe.c)(6);
    (0, $6cFsl.di)();
    const { buildId: buildId, draftContent: draftContent } = actionRenderer.actions[0].data;
    let t0;
    if ($[0] !== buildId || $[1] !== draftContent) {
        t0 = {
            type: "solution-draft-agent-update",
            data: {
                buildId: buildId,
                draftContent: draftContent
            },
            source: "update-agent-draft-action-ui"
        };
        $[0] = buildId;
        $[1] = draftContent;
        $[2] = t0;
    } else t0 = $[2];
    const payload = t0;
    let t1;
    if ($[3] !== actionRenderer || $[4] !== payload) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iGaH9.UpdateAgentBase), {
            actionRenderer: actionRenderer,
            payload: payload
        });
        $[3] = actionRenderer;
        $[4] = payload;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : (actionRenderer)=>{
    (0, $6cFsl.di)();
    const { buildId: buildId, draftContent: draftContent } = actionRenderer.actions[0].data;
    const payload = {
        type: 'solution-draft-agent-update',
        data: {
            buildId: buildId,
            draftContent: draftContent
        },
        source: 'update-agent-draft-action-ui'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iGaH9.UpdateAgentBase), {
        actionRenderer: actionRenderer,
        payload: payload
    });
};
module.exports["StudioWorkspaceUpdateAgentDraftAction"] = $4d9a1c6471096431$export$3d18b3f073575332;

});

parcelRegister("9Ac08", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dd10732022571ed8$export$15217db592d92f36 = (0, $kSwu1.defineMessages)({
    updateWorkItemFields: {
        id: "conversation-assistant-message-actions.readonly-title.update-work-item-fields",
        defaultMessage: "Update work item"
    },
    createProjectProgressUpdate: {
        id: "conversation-assistant-message-actions.readonly-title.create-project-progress-update",
        defaultMessage: "Create project update"
    },
    updateWorkItems: {
        id: "conversation-assistant-message-actions.readonly-title.update-work-items",
        defaultMessage: "Update work items"
    },
    findWorkItems: {
        id: "conversation-assistant-message-actions.readonly-title.find-work-items",
        defaultMessage: "Find work items"
    },
    createWorkItem: {
        id: "conversation-assistant-message-actions.readonly-title.create-work-item",
        defaultMessage: "Create work item"
    },
    jiraAdminAction: {
        id: "conversation-assistant-message-actions.readonly-title.jira-admin-action",
        defaultMessage: "Jira admin action"
    },
    transitionWorkItem: {
        id: "conversation-assistant-message-actions.readonly-title.transition-work-item",
        defaultMessage: "Transition work item"
    },
    suggestEpics: {
        id: "conversation-assistant-message-actions.readonly-title.suggest-epics",
        defaultMessage: "Suggest epics"
    },
    deleteWorkItem: {
        id: "conversation-assistant-message-actions.readonly-title.delete-work-item",
        defaultMessage: "Delete work item"
    },
    moveWorkItem: {
        id: "conversation-assistant-message-actions.readonly-title.move-work-item",
        defaultMessage: "Move work item"
    },
    assignWorkItem: {
        id: "conversation-assistant-message-actions.readonly-title.assign-work-item",
        defaultMessage: "Assign work item"
    },
    createRelease: {
        id: "conversation-assistant-message-actions.readonly-title.create-release",
        defaultMessage: "Create release"
    },
    createView: {
        id: "conversation-assistant-message-actions.readonly-title.create-view",
        defaultMessage: "Create view"
    },
    createSprint: {
        id: "conversation-assistant-message-actions.readonly-title.create-sprint",
        defaultMessage: "Create sprint"
    },
    startSprint: {
        id: "conversation-assistant-message-actions.readonly-title.start-sprint",
        defaultMessage: "Start sprint"
    },
    moveToSprint: {
        id: "conversation-assistant-message-actions.readonly-title.move-to-sprint",
        defaultMessage: "Move to sprint"
    },
    manageCapacityPlan: {
        id: "conversation-assistant-message-actions.readonly-title.manage-capacity-plan",
        defaultMessage: "Manage capacity plan"
    },
    updateWorkflow: {
        id: "conversation-assistant-message-actions.readonly-title.update-workflow",
        defaultMessage: "Update workflow"
    },
    createPage: {
        id: "conversation-assistant-message-actions.readonly-title.create-page",
        defaultMessage: "Create page"
    },
    createFolder: {
        id: "conversation-assistant-message-actions.readonly-title.create-folder",
        defaultMessage: "Create folder"
    },
    commentOnPage: {
        id: "conversation-assistant-message-actions.readonly-title.comment-on-page",
        defaultMessage: "Comment on page"
    },
    editContent: {
        id: "conversation-assistant-message-actions.readonly-title.edit-content",
        defaultMessage: "Edit content"
    },
    addLabel: {
        id: "conversation-assistant-message-actions.readonly-title.add-label",
        defaultMessage: "Add label"
    },
    renamePage: {
        id: "conversation-assistant-message-actions.readonly-title.rename-page",
        defaultMessage: "Rename page"
    },
    movePage: {
        id: "conversation-assistant-message-actions.readonly-title.move-page",
        defaultMessage: "Move page"
    },
    createWhiteboard: {
        id: "conversation-assistant-message-actions.readonly-title.create-whiteboard",
        defaultMessage: "Create whiteboard"
    },
    updateWhiteboard: {
        id: "conversation-assistant-message-actions.readonly-title.update-whiteboard",
        defaultMessage: "Update whiteboard"
    },
    createSlides: {
        id: "conversation-assistant-message-actions.readonly-title.create-slides",
        defaultMessage: "Create slides"
    },
    updateSlides: {
        id: "conversation-assistant-message-actions.readonly-title.update-slides",
        defaultMessage: "Update slides"
    },
    createDatabase: {
        id: "conversation-assistant-message-actions.readonly-title.create-database",
        defaultMessage: "Create database"
    },
    updateDatabase: {
        id: "conversation-assistant-message-actions.readonly-title.update-database",
        defaultMessage: "Update database"
    },
    createSpace: {
        id: "conversation-assistant-message-actions.readonly-title.create-space",
        defaultMessage: "Create space"
    },
    updateSpace: {
        id: "conversation-assistant-message-actions.readonly-title.update-space",
        defaultMessage: "Update space"
    },
    createDynamicUi: {
        id: "conversation-assistant-message-actions.readonly-title.create-dynamic-ui",
        defaultMessage: "Create app"
    },
    createImage: {
        id: "conversation-assistant-message-actions.readonly-title.create-image",
        defaultMessage: "Create image"
    },
    createRequest: {
        id: "conversation-assistant-message-actions.readonly-title.create-request",
        defaultMessage: "Create request"
    },
    createSurvey: {
        id: "conversation-assistant-message-actions.readonly-title.create-survey",
        defaultMessage: "Create survey"
    },
    createQueue: {
        id: "conversation-assistant-message-actions.readonly-title.create-queue",
        defaultMessage: "Create queue"
    },
    createQueueGroup: {
        id: "conversation-assistant-message-actions.readonly-title.create-queue-group",
        defaultMessage: "Create queue group"
    },
    updateQueue: {
        id: "conversation-assistant-message-actions.readonly-title.update-queue",
        defaultMessage: "Update queue"
    },
    updateQueueGroup: {
        id: "conversation-assistant-message-actions.readonly-title.update-queue-group",
        defaultMessage: "Update queue group"
    },
    createRequestType: {
        id: "conversation-assistant-message-actions.readonly-title.create-request-type",
        defaultMessage: "Create request type"
    },
    updateRequestType: {
        id: "conversation-assistant-message-actions.readonly-title.update-request-type",
        defaultMessage: "Update request type"
    },
    updatePortalGroups: {
        id: "conversation-assistant-message-actions.readonly-title.update-portal-groups",
        defaultMessage: "Update portal groups"
    },
    updateRequestTypeWorkflow: {
        id: "conversation-assistant-message-actions.readonly-title.update-request-type-workflow",
        defaultMessage: "Update request type workflow"
    },
    selectHardwareTypes: {
        id: "conversation-assistant-message-actions.readonly-title.select-hardware-types",
        defaultMessage: "Select hardware types"
    },
    completeSetup: {
        id: "conversation-assistant-message-actions.readonly-title.complete-setup",
        defaultMessage: "Complete setup"
    },
    createKnowledgeBaseContent: {
        id: "conversation-assistant-message-actions.readonly-title.create-knowledge-base-content",
        defaultMessage: "Create knowledge base content"
    },
    createDashboard: {
        id: "conversation-assistant-message-actions.readonly-title.create-dashboard",
        defaultMessage: "Create dashboard"
    },
    createChart: {
        id: "conversation-assistant-message-actions.readonly-title.create-chart",
        defaultMessage: "Create chart"
    },
    createFilterExpression: {
        id: "conversation-assistant-message-actions.readonly-title.create-filter-expression",
        defaultMessage: "Create filter expression"
    },
    deepResearchReport: {
        id: "conversation-assistant-message-actions.readonly-title.deep-research-report",
        defaultMessage: "Create report"
    },
    buildSolution: {
        id: "conversation-assistant-message-actions.readonly-title.build-solution",
        defaultMessage: "Build solution"
    },
    createAutomationRule: {
        id: "conversation-assistant-message-actions.readonly-title.create-automation-rule",
        defaultMessage: "Create automation rule"
    },
    respondToPrompt: {
        id: "conversation-assistant-message-actions.readonly-title.respond-to-prompt",
        defaultMessage: "Respond to prompt"
    },
    reviewChoices: {
        id: "conversation-assistant-message-actions.readonly-title.review-choices",
        defaultMessage: "Review choices"
    },
    hiringManagerAction: {
        id: "conversation-assistant-message-actions.readonly-title.hiring-manager-action",
        defaultMessage: "Hiring manager action"
    },
    updateAgentDraft: {
        id: "conversation-assistant-message-actions.readonly-title.update-agent-draft",
        defaultMessage: "Update agent draft"
    },
    updateAgentConfiguration: {
        id: "conversation-assistant-message-actions.readonly-title.update-agent-configuration",
        defaultMessage: "Update agent configuration"
    },
    createAgent: {
        id: "conversation-assistant-message-actions.readonly-title.create-agent",
        defaultMessage: "Create agent"
    },
    openStudio: {
        id: "conversation-assistant-message-actions.readonly-title.open-studio",
        defaultMessage: "Open Studio"
    },
    viewRecommendation: {
        id: "conversation-assistant-message-actions.readonly-title.view-recommendation",
        defaultMessage: "View recommendation"
    },
    archiveTeam: {
        id: "conversation-assistant-message-actions.readonly-title.archive-team",
        defaultMessage: "Archive team"
    },
    createAsks: {
        id: "conversation-assistant-message-actions.readonly-title.create-asks",
        defaultMessage: "Create asks"
    },
    scheduleChat: {
        id: "conversation-assistant-message-actions.readonly-title.schedule-chat",
        defaultMessage: "Schedule chat"
    },
    completePlan: {
        id: "conversation-assistant-message-actions.readonly-title.complete-plan",
        defaultMessage: "Complete plan"
    },
    askQuestion: {
        id: "conversation-assistant-message-actions.readonly-title.ask-question",
        defaultMessage: "Ask question"
    },
    searchImages: {
        id: "conversation-assistant-message-actions.readonly-title.search-images",
        defaultMessage: "Search images"
    },
    sendSlackMessage: {
        id: "conversation-assistant-message-actions.readonly-title.send-slack-message",
        defaultMessage: "Send Slack message"
    },
    commentOnPullRequest: {
        id: "conversation-assistant-message-actions.readonly-title.comment-on-pull-request",
        defaultMessage: "Comment on pull request"
    },
    createCustomSkill: {
        id: "conversation-assistant-message-actions.readonly-title.create-custom-skill",
        defaultMessage: "Create custom skill"
    },
    updateCustomSkill: {
        id: "conversation-assistant-message-actions.readonly-title.update-custom-skill",
        defaultMessage: "Update custom skill"
    },
    createCalendarEvent: {
        id: "conversation-assistant-message-actions.readonly-title.create-calendar-event",
        defaultMessage: "Create calendar event"
    },
    createDocument: {
        id: "conversation-assistant-message-actions.readonly-title.create-document",
        defaultMessage: "Create document"
    },
    actionUnavailable: {
        id: "conversation-assistant-message-actions.readonly-title.action-unavailable",
        defaultMessage: "Action unavailable"
    }
});
module.exports["readonlyTitleMessages"] = $dd10732022571ed8$export$15217db592d92f36;

});

parcelRegister("fsbzy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $l65d3 = parcelRequire("l65d3");


var $1a3X7 = parcelRequire("1a3X7");


var $eBtjL = parcelRequire("eBtjL");


var $a6xuq = parcelRequire("a6xuq");

const $4285820539a63379$var$styles = {
    messageFooterButtonUnorderedList: "_1LMyvKOiJt _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC",
    listItem: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC"
};
const $4285820539a63379$export$23607f376668a179 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { hideThumbs: hideThumbs, onThumbClick: onThumbClick, onCopyClick: onCopyClick, showDebugButton: t1, onClickDebug: onClickDebug, feedbackType: feedbackType, thumbsTestId: thumbsTestId, insertSlot: insertSlot, shareSlot: shareSlot } = t0;
    const showDebugButton = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== feedbackType || $[1] !== hideThumbs || $[2] !== onThumbClick || $[3] !== thumbsTestId) {
        t2 = !hideThumbs && /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $4285820539a63379$var$styles.listItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $a6xuq.LikeAnswer), {
            onClick: (event)=>onThumbClick(true, event),
            isSelected: feedbackType === "like",
            spacing: "default",
            testId: thumbsTestId
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $4285820539a63379$var$styles.listItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $eBtjL.DislikeAnswer), {
            onClick: (event_0)=>onThumbClick(false, event_0),
            isSelected: feedbackType === "dislike",
            spacing: "default",
            testId: thumbsTestId
        })));
        $[0] = feedbackType;
        $[1] = hideThumbs;
        $[2] = onThumbClick;
        $[3] = thumbsTestId;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== onCopyClick) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $4285820539a63379$var$styles.listItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $l65d3.CopyResponse), {
            onClick: (event_1)=>onCopyClick(event_1),
            spacing: "default"
        }));
        $[5] = onCopyClick;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== shareSlot) {
        t4 = shareSlot && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $4285820539a63379$var$styles.listItem
        }, shareSlot);
        $[7] = shareSlot;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== onClickDebug || $[10] !== showDebugButton) {
        t5 = showDebugButton && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $4285820539a63379$var$styles.listItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $1a3X7.DebugButton), {
            onClick: (event_2)=>onClickDebug?.(event_2)
        }));
        $[9] = onClickDebug;
        $[10] = showDebugButton;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== insertSlot) {
        t6 = insertSlot && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            xcss: $4285820539a63379$var$styles.listItem
        }, insertSlot);
        $[12] = insertSlot;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignInline: "start",
            alignBlock: "center",
            space: "space.050",
            as: "ul",
            xcss: $4285820539a63379$var$styles.messageFooterButtonUnorderedList
        }, t2, t3, t4, t5, t6);
        $[14] = t2;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
} : ({ hideThumbs: hideThumbs, onThumbClick: onThumbClick, onCopyClick: onCopyClick, showDebugButton: showDebugButton = false, onClickDebug: onClickDebug, feedbackType: feedbackType, thumbsTestId: thumbsTestId, insertSlot: insertSlot, shareSlot: shareSlot })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignInline: "start",
        alignBlock: "center",
        space: "space.050",
        as: "ul",
        xcss: $4285820539a63379$var$styles.messageFooterButtonUnorderedList
    }, !hideThumbs && /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $4285820539a63379$var$styles.listItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $a6xuq.LikeAnswer), {
        onClick: (event)=>onThumbClick(true, event),
        isSelected: feedbackType === 'like',
        spacing: "default",
        testId: thumbsTestId
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $4285820539a63379$var$styles.listItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $eBtjL.DislikeAnswer), {
        onClick: (event_0)=>onThumbClick(false, event_0),
        isSelected: feedbackType === 'dislike',
        spacing: "default",
        testId: thumbsTestId
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $4285820539a63379$var$styles.listItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $l65d3.CopyResponse), {
        onClick: (event_1)=>onCopyClick(event_1),
        spacing: "default"
    })), shareSlot && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $4285820539a63379$var$styles.listItem
    }, shareSlot), showDebugButton && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $4285820539a63379$var$styles.listItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $1a3X7.DebugButton), {
        onClick: (event_2)=>onClickDebug?.(event_2)
    })), insertSlot && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $4285820539a63379$var$styles.listItem
    }, insertSlot));
};
module.exports["MessageFooterButtons"] = $4285820539a63379$export$23607f376668a179;

});

parcelRegister("1PPOl", function(module, exports) {
const $55a03f67d15fe258$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button'
};
module.exports["POLLINATOR_TEST_IDS"] = $55a03f67d15fe258$export$900371d5fadf47e7;

});

parcelRegister("hI1dm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $hdBxM = parcelRequire("hdBxM");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $gzMZq = parcelRequire("gzMZq");


var $hf8wM = parcelRequire("hf8wM");


var $eKjv9 = parcelRequire("eKjv9");


var $bp00X = parcelRequire("bp00X");


var $jkyLh = parcelRequire("jkyLh");


var $hKEkM = parcelRequire("hKEkM");

const $362621ed7171953b$var$LUMINA_PLACEHOLDER_RE = /\[\^lumina(?:-\d+)?\^\]/;
const $362621ed7171953b$export$6d94b953f1069819 = ({ content: content, agentId: agentId, onClick: onClick, markdownData: markdownData })=>{
    (0, $6cFsl.di)((0, $gzMZq.useChatContextEditorContext), (0, $hdBxM.usePublish), (0, $hf8wM.useChartApiService));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { productKey: productKey, siteId: siteId } = (0, $eKjv9.useGlobalConfig)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const chartApiService = (0, $hf8wM.useChartApiService)(siteId);
    const [context] = (0, $gzMZq.useChatContextEditorContext)();
    const [isProcessing, setIsProcessing] = (0, $cozmU.useState)(false);
    const isSelection = !!context?.selection?.content?.length;
    const mode = isSelection ? 'replace' : 'insert';
    const isDisabled = !context?.document;
    const getInsertButtonLabel = (0, $cozmU.useCallback)(()=>{
        switch(productKey){
            case 'confluence':
                return (0, $hKEkM.default).confluenceInsertButtonLabel;
            case 'jira':
                return (0, $hKEkM.default).jiraInsertButtonLabel;
            default:
                return (0, $hKEkM.default).genericInsertButtonLabel;
        }
    }, [
        productKey
    ]);
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        let finalContent = content.toString();
        const isChartPath = !!markdownData?.['chart-0'] && finalContent.includes('[^chart^]');
        let richContent;
        if (!isChartPath && markdownData && $362621ed7171953b$var$LUMINA_PLACEHOLDER_RE.test(finalContent) && (0, $iDrrr.fg)('kd_lumina_insert_replace_response_as_adf')) {
            const richAdfContent = (0, $jkyLh.buildEditorInsertAdfFragment)(finalContent, markdownData);
            if (richAdfContent) richContent = {
                type: 'text/adf',
                version: 1,
                content: richAdfContent
            };
        }
        if (isChartPath) {
            setIsProcessing(true);
            sendAnalyticsEvent({
                action: 'insertedIntoPage',
                actionSubjectId: 'vizPluginChart',
                eventType: 'track',
                attributes: {
                    mode: mode,
                    productKey: productKey
                }
            });
            finalContent = await (0, $bp00X.replaceChartPlaceholdersWithSmartLinks)(finalContent, markdownData, chartApiService);
        }
        publish({
            type: 'editor-suggestion',
            source: 'ai-mate',
            data: {
                mode: mode,
                content: finalContent,
                agentId: agentId,
                ...richContent ? {
                    richContent: richContent
                } : {}
            }
        });
        onClick?.(mode);
        setIsProcessing(false);
    }, [
        publish,
        mode,
        content,
        agentId,
        onClick,
        markdownData,
        chartApiService,
        sendAnalyticsEvent,
        productKey
    ]);
    const onButtonHovered = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'hovered',
            actionSubjectId: 'improvedInsertReplaceButton',
            attributes: {
                isDisabled: isDisabled
            }
        });
    }, [
        sendAnalyticsEvent,
        isDisabled
    ]);
    if (!context?.document || context?.isViewMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: onButtonHovered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: formatMessage((0, $hKEkM.default).tooltipMessage),
        canAppear: ()=>isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isDisabled: isDisabled,
        isLoading: isProcessing,
        onClick: (_, e)=>{
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'improvedInsertReplaceButton',
                attributes: {
                    mode: isSelection ? 'replace' : 'insert'
                }
            }));
            handleClick();
        },
        spacing: "compact",
        appearance: "subtle",
        testId: "InsertReplaceButton"
    }, formatMessage(isSelection ? (0, $hKEkM.default).replaceButtonLabel : getInsertButtonLabel()))));
};
module.exports["InsertReplaceButton"] = $362621ed7171953b$export$6d94b953f1069819;

});

parcelRegister("cUElk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $bh4C9 = parcelRequire("bh4C9");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $eQC44 = parcelRequire("eQC44");


var $hUHHK = parcelRequire("hUHHK");


var $5Utui = parcelRequire("5Utui");

const $754bf9ebef4c6975$export$a8a2fa2f79d60d2b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { messageId: messageId, appearance: t1, spacing: t2, shape: t3, testId: testId } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const shape = t3 === undefined ? "default" : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const shareContext = (0, $hUHHK.useShareUpToMessage)();
    if (!shareContext || !messageId) return null;
    const { shareUpToMessage: shareUpToMessage, isMessageShareable: isMessageShareable, shareDisabledReason: shareDisabledReason } = shareContext;
    let t4;
    if ($[0] !== isMessageShareable || $[1] !== messageId) {
        t4 = isMessageShareable(messageId);
        $[0] = isMessageShareable;
        $[1] = messageId;
        $[2] = t4;
    } else t4 = $[2];
    const isDisabled = !t4;
    let t5;
    if ($[3] !== formatMessage || $[4] !== isDisabled || $[5] !== shareDisabledReason) {
        t5 = isDisabled ? (0, $eQC44.getShareButtonLabel)(shareDisabledReason ?? "missing-valid-response", formatMessage) : formatMessage((0, $5Utui.default).shareUpToMessageLabel);
        $[3] = formatMessage;
        $[4] = isDisabled;
        $[5] = shareDisabledReason;
        $[6] = t5;
    } else t5 = $[6];
    const label = t5;
    let t6;
    if ($[7] !== messageId || $[8] !== sendAnalyticsEvent || $[9] !== shareUpToMessage) {
        t6 = (_event, analyticsEvent)=>{
            sendAnalyticsEvent(analyticsEvent.update({
                actionSubjectId: "shareUpToMessageButton"
            }));
            shareUpToMessage(messageId);
        };
        $[7] = messageId;
        $[8] = sendAnalyticsEvent;
        $[9] = shareUpToMessage;
        $[10] = t6;
    } else t6 = $[10];
    const onClick = t6;
    let t7;
    if ($[11] !== appearance || $[12] !== isDisabled || $[13] !== label || $[14] !== onClick || $[15] !== shape || $[16] !== spacing || $[17] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            type: "button",
            onClick: onClick,
            isDisabled: isDisabled,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))),
            appearance: appearance,
            spacing: spacing,
            label: label,
            shape: shape,
            testId: testId
        });
        $[11] = appearance;
        $[12] = isDisabled;
        $[13] = label;
        $[14] = onClick;
        $[15] = shape;
        $[16] = spacing;
        $[17] = testId;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ messageId: messageId, appearance: appearance = 'subtle', spacing: spacing = 'default', shape: shape = 'default', testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const shareContext = (0, $hUHHK.useShareUpToMessage)();
    // Hide when sharing is unavailable or the id is missing. Once the sharing
    // feature is present, keep the action visible and disable it until this
    // message becomes a shareable boundary, matching the header share action.
    if (!shareContext || !messageId) return null;
    // Past the guard `shareContext` is guaranteed non-null, so the handler can
    // call `shareUpToMessage` directly.
    const { shareUpToMessage: shareUpToMessage, isMessageShareable: isMessageShareable, shareDisabledReason: shareDisabledReason } = shareContext;
    const isDisabled = !isMessageShareable(messageId);
    const label = isDisabled ? (0, $eQC44.getShareButtonLabel)(shareDisabledReason ?? 'missing-valid-response', formatMessage) : formatMessage((0, $5Utui.default).shareUpToMessageLabel);
    const onClick = (_event, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'shareUpToMessageButton'
        }));
        shareUpToMessage(messageId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        type: "button",
        onClick: onClick,
        isDisabled: isDisabled,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))),
        appearance: appearance,
        spacing: spacing,
        label: label,
        shape: shape,
        testId: testId
    });
};
module.exports["ShareUpToMessageButton"] = $754bf9ebef4c6975$export$a8a2fa2f79d60d2b;

});

parcelRegister("l3d45", function(module, exports) {
/**
 * Checks if a user is an Atlassian employee based on their email domain.
 *
 * @param email - User's email address
 * @returns true if the email is from an Atlassian domain, false otherwise
 */ const $c95a10b7fa93ec3c$export$8d6db1f125405ad3 = (email)=>{
    if (!email) return false;
    return email.toLowerCase().endsWith('@atlassian.com');
};
module.exports["isAtlassianEmployee"] = $c95a10b7fa93ec3c$export$8d6db1f125405ad3;

});

parcelRegister("cWQ7I", function(module, exports) {

var $l3d45 = parcelRequire("l3d45");

const $3263823dc5249443$export$a5d62870777ae430 = (email, storeUserMessages)=>!!(0, $l3d45.isAtlassianEmployee)(email) && !!storeUserMessages;
module.exports["isInternalUserWithAutoIncludeHistory"] = $3263823dc5249443$export$a5d62870777ae430;

});

parcelRegister("dEP8O", function(module, exports) {

var $l3d45 = parcelRequire("l3d45");

const $55ce308edb15c3c5$export$25f958020f9d94a = (email)=>!!(0, $l3d45.isAtlassianEmployee)(email);
module.exports["shouldShowOptInPrompt"] = $55ce308edb15c3c5$export$25f958020f9d94a;

});

parcelRegister("1X2GM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f8f3c487953aead$var$DEFAULT_DELAY = 10000;
const $9f8f3c487953aead$export$9d0f4ae0a47d1ddb = (config = {})=>{
    const delay = config.delay ?? $9f8f3c487953aead$var$DEFAULT_DELAY;
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const timeoutRef = (0, $cozmU.useRef)();
    const onAutoDismissRef = (0, $cozmU.useRef)(config.onAutoDismiss);
    onAutoDismissRef.current = config.onAutoDismiss;
    const clearTimer = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
    }, []);
    const startTimer = (0, $cozmU.useCallback)(()=>{
        clearTimer();
        timeoutRef.current = setTimeout(()=>{
            setIsVisible(false);
            onAutoDismissRef.current?.();
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = undefined;
            }
        }, delay);
    }, [
        clearTimer,
        delay
    ]);
    const show = (0, $cozmU.useCallback)(()=>{
        setIsVisible(true);
        startTimer();
    }, [
        startTimer
    ]);
    const showWithoutTimer = (0, $cozmU.useCallback)(()=>{
        clearTimer();
        setIsVisible(true);
    }, [
        clearTimer
    ]);
    const hide = (0, $cozmU.useCallback)(()=>{
        clearTimer();
        setIsVisible(false);
    }, [
        clearTimer
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current && onAutoDismissRef.current) onAutoDismissRef.current();
            clearTimer();
        };
    }, [
        clearTimer
    ]);
    return {
        isVisible: isVisible,
        show: show,
        showWithoutTimer: showWithoutTimer,
        hide: hide,
        cancelTimer: clearTimer,
        restartTimer: startTimer
    };
};
module.exports["useAutoDismiss"] = $9f8f3c487953aead$export$9d0f4ae0a47d1ddb;

});

parcelRegister("8SDpb", function(module, exports) {
/**
 * Service for submitting AUP (Acceptable Use Policy) feedback to JSM.
 * This routes harmful content reports to a dedicated AUP endpoint.
 */ 
var $hlvTd = parcelRequire("hlvTd");


var $jTKfH = parcelRequire("jTKfH");

const $b280dacfec7666f7$var$AUP_FEEDBACK_ENTRYPOINT_ID = '1a3369da-be17-4f4d-9c11-bb2895beebc2';
const $b280dacfec7666f7$var$base64Encode = (str)=>{
    try {
        return btoa(unescape(encodeURIComponent(str)));
    } catch  {
        return str;
    }
};
const $b280dacfec7666f7$var$JSM_FIELD_IDS = {
    summary: 'summary',
    description: 'description',
    customerName: 'customfield_10045',
    canBeContacted: 'customfield_10043',
    enrollInResearch: 'customfield_10044',
    feedbackContext: 'customfield_10047'
};
const $b280dacfec7666f7$var$JSM_FIELD_VALUES = {
    canBeContactedAgree: [
        {
            id: '10109'
        }
    ],
    canBeContactedDecline: [
        {
            id: '10111'
        }
    ],
    enrollInResearchAgree: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDecline: [
        {
            id: '10112'
        }
    ]
};
const $b280dacfec7666f7$var$PACKAGE_VERSION = '1.0.0';
const $b280dacfec7666f7$export$d1311f0b03389cbc = async ({ metadata: metadata, customerName: customerName = 'unknown', email: email, feedbackText: feedbackText = '', includeInput: includeInput = false, enrollInResearch: enrollInResearch = false })=>{
    const summary = feedbackText ? feedbackText.replace(/\n/g, ' ').slice(0, 80) : 'Harmful Content Report';
    const description = `${feedbackText}

\`\`\`
${JSON.stringify(metadata, null, 2)}
\`\`\`
`;
    const canBeContactedValue = includeInput ? $b280dacfec7666f7$var$JSM_FIELD_VALUES.canBeContactedAgree : $b280dacfec7666f7$var$JSM_FIELD_VALUES.canBeContactedDecline;
    const enrollInResearchValue = enrollInResearch ? $b280dacfec7666f7$var$JSM_FIELD_VALUES.enrollInResearchAgree : $b280dacfec7666f7$var$JSM_FIELD_VALUES.enrollInResearchDecline;
    const feedbackContextParts = [];
    if (email) feedbackContextParts.push(`email: ${email}`);
    feedbackContextParts.push(`atlassian-account-id: ${metadata.aaid}`);
    if (metadata.origin) feedbackContextParts.push(`origin: ${metadata.origin}`);
    if (metadata.feedbackSource) feedbackContextParts.push(`feedbackSource: ${metadata.feedbackSource}`);
    if (metadata.feedbackTrigger) feedbackContextParts.push(`feedbackTrigger: ${metadata.feedbackTrigger}`);
    const feedbackContextValue = feedbackContextParts.join('\n');
    const fields = [
        {
            id: $b280dacfec7666f7$var$JSM_FIELD_IDS.summary,
            value: summary
        },
        {
            id: $b280dacfec7666f7$var$JSM_FIELD_IDS.description,
            value: description
        },
        {
            id: 'aaidOrHash'
        },
        {
            id: $b280dacfec7666f7$var$JSM_FIELD_IDS.customerName,
            value: customerName
        },
        {
            id: $b280dacfec7666f7$var$JSM_FIELD_IDS.canBeContacted,
            value: canBeContactedValue
        },
        {
            id: $b280dacfec7666f7$var$JSM_FIELD_IDS.enrollInResearch,
            value: enrollInResearchValue
        },
        {
            id: $b280dacfec7666f7$var$JSM_FIELD_IDS.feedbackContext,
            value: feedbackContextValue
        }
    ];
    const body = {
        feedback: {
            entrypointId: $b280dacfec7666f7$var$AUP_FEEDBACK_ENTRYPOINT_ID,
            entrypointUiVersion: $b280dacfec7666f7$var$PACKAGE_VERSION,
            fields: fields
        }
    };
    const postData = $b280dacfec7666f7$var$base64Encode(JSON.stringify(body));
    try {
        await (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/feedback-collector-api/v2/feedback',
            options: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: postData
                })
            }
        });
    } catch (err) {
        const statusCode = err instanceof (0, $jTKfH.FetchError) ? err.errorAttributes?.statusCode : undefined;
        (0, $hlvTd.logException)({
            exception: err instanceof Error ? err : new Error(String(err)),
            name: 'feedbackSubmissionError',
            tags: {
                feedbackSubmissionError: 'aup-feedback',
                ...statusCode ? {
                    httpStatusCode: String(statusCode)
                } : {}
            }
        });
        throw err;
    }
    return {
        success: true
    };
};
module.exports["submitAUPFeedbackToJSM"] = $b280dacfec7666f7$export$d1311f0b03389cbc;

});

parcelRegister("cMq9g", function(module, exports) {
/**
 * Service for submitting feedback directly to JSM/Socrates without the modal.
 * This replicates the @atlaskit/feedback-collector submission logic for V2 inline feedback.
 *
 * Endpoint: /gateway/api/feedback-collector-api/v2/feedback
 * Data flows to Socrates table: platform_product_feedback_collector
 */ 
var $hlvTd = parcelRequire("hlvTd");


var $jTKfH = parcelRequire("jTKfH");

// Use btoa for base64 encoding in browser
const $044182555b25a38a$var$base64Encode = (str)=>{
    try {
        return btoa(unescape(encodeURIComponent(str)));
    } catch  {
        // Fallback for environments where btoa might not work
        return str;
    }
};
//link to the Jira Board: https://customerfeedback.atlassian.net/jira/servicedesk/projects/AM/queues/custom/922
const $044182555b25a38a$var$JSM_FIELD_IDS = {
    summary: 'summary',
    description: 'description',
    customerName: 'customfield_10045',
    type: 'customfield_10042',
    canBeContacted: 'customfield_10043',
    enrollInResearch: 'customfield_10044',
    feedbackContext: 'customfield_10047'
};
const $044182555b25a38a$var$JSM_FIELD_VALUES = {
    typeComment: {
        id: '10106'
    },
    typeBug: {
        id: '10105'
    },
    typeSuggestion: {
        id: '10107'
    },
    typeQuestion: {
        id: '10108'
    },
    canBeContactedAgree: [
        {
            id: '10109'
        }
    ],
    canBeContactedDecline: [
        {
            id: '10111'
        }
    ],
    enrollInResearchAgree: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDecline: [
        {
            id: '10112'
        }
    ]
};
const $044182555b25a38a$var$PACKAGE_VERSION = '1.0.0';
/**
 * Maps feedback categories to JSM feedback type.
 */ const $044182555b25a38a$var$mapCategoriesToFeedbackType = (categories)=>{
    if (!categories || categories.length === 0) return $044182555b25a38a$var$JSM_FIELD_VALUES.typeComment;
    const bugCategories = [
        'inaccurate',
        'outOfDate'
    ];
    if (categories.some((cat)=>bugCategories.includes(cat))) return $044182555b25a38a$var$JSM_FIELD_VALUES.typeBug;
    const suggestionCategories = [
        'tooLong',
        'tooShort',
        'poorlySourced'
    ];
    if (categories.some((cat)=>suggestionCategories.includes(cat))) return $044182555b25a38a$var$JSM_FIELD_VALUES.typeSuggestion;
    return $044182555b25a38a$var$JSM_FIELD_VALUES.typeComment;
};
const $044182555b25a38a$export$e1bf8f0906651f30 = async ({ entryPointId: entryPointId, metadata: metadata, customerName: customerName = 'unknown', email: email })=>{
    const isDetailedFeedback = metadata.isDetailedFeedback ?? false;
    const userFeedbackText = metadata.additionalFeedback || '';
    const description = `${userFeedbackText}

\`\`\`
${JSON.stringify(metadata, null, 2)}
\`\`\`
`;
    const feedbackPrefix = metadata.answerQuality === 'good' ? 'Positive' : 'Negative';
    let summary = '';
    if (metadata.categories && metadata.categories.length > 0) summary = `${feedbackPrefix}: ${metadata.categories.join(', ')}`;
    else if (userFeedbackText) {
        const truncatedText = userFeedbackText.replace(/\n/g, ' ').slice(0, 100);
        summary = truncatedText.length < userFeedbackText.length ? `${truncatedText}...` : truncatedText;
    } else summary = `${feedbackPrefix} feedback - Quick thumbs`;
    const canBeContactedValue = metadata.includeMessages ? $044182555b25a38a$var$JSM_FIELD_VALUES.canBeContactedAgree : $044182555b25a38a$var$JSM_FIELD_VALUES.canBeContactedDecline;
    const enrollInResearchValue = metadata.enrollInResearch ? $044182555b25a38a$var$JSM_FIELD_VALUES.enrollInResearchAgree : $044182555b25a38a$var$JSM_FIELD_VALUES.enrollInResearchDecline;
    const feedbackTypeValue = isDetailedFeedback ? $044182555b25a38a$var$mapCategoriesToFeedbackType(metadata.categories) : $044182555b25a38a$var$JSM_FIELD_VALUES.typeComment;
    const feedbackContextParts = [];
    if (email) feedbackContextParts.push(`email: ${email}`);
    feedbackContextParts.push(`atlassian-account-id: ${metadata.aaid}`);
    if (metadata.origin) feedbackContextParts.push(`origin: ${metadata.origin}`);
    if (metadata.feedbackSource) feedbackContextParts.push(`feedbackSource: ${metadata.feedbackSource}`);
    if (metadata.feedbackTrigger) feedbackContextParts.push(`feedbackTrigger: ${metadata.feedbackTrigger}`);
    if (metadata.categories && metadata.categories.length > 0) feedbackContextParts.push(`categories: ${metadata.categories.join(', ')}`);
    const feedbackContextValue = feedbackContextParts.join('\n');
    const fields = [
        {
            id: $044182555b25a38a$var$JSM_FIELD_IDS.type,
            value: feedbackTypeValue
        },
        {
            id: $044182555b25a38a$var$JSM_FIELD_IDS.summary,
            value: summary
        },
        {
            id: $044182555b25a38a$var$JSM_FIELD_IDS.description,
            value: description
        },
        ...metadata.includeMessages ? [
            {
                id: 'aaidOrHash',
                value: metadata.aaid
            }
        ] : [],
        {
            id: $044182555b25a38a$var$JSM_FIELD_IDS.customerName,
            value: customerName
        },
        {
            id: $044182555b25a38a$var$JSM_FIELD_IDS.canBeContacted,
            value: canBeContactedValue
        },
        {
            id: $044182555b25a38a$var$JSM_FIELD_IDS.enrollInResearch,
            value: enrollInResearchValue
        },
        ...feedbackContextValue ? [
            {
                id: $044182555b25a38a$var$JSM_FIELD_IDS.feedbackContext,
                value: feedbackContextValue
            }
        ] : []
    ];
    const body = {
        feedback: {
            entrypointId: entryPointId,
            entrypointUiVersion: $044182555b25a38a$var$PACKAGE_VERSION,
            fields: fields
        }
    };
    const postData = $044182555b25a38a$var$base64Encode(JSON.stringify(body));
    try {
        await (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/feedback-collector-api/v2/feedback',
            options: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: postData
                })
            }
        });
    } catch (err) {
        const statusCode = err instanceof (0, $jTKfH.FetchError) ? err.errorAttributes?.statusCode : undefined;
        (0, $hlvTd.logException)({
            exception: err instanceof Error ? err : new Error(String(err)),
            name: 'feedbackSubmissionError',
            tags: {
                feedbackSubmissionError: 'jsm-feedback',
                ...statusCode ? {
                    httpStatusCode: String(statusCode)
                } : {}
            }
        });
        throw err;
    }
    return {
        success: true
    };
};
module.exports["submitQuickFeedbackToJSM"] = $044182555b25a38a$export$e1bf8f0906651f30;

});

parcelRegister("gg9X0", function(module, exports) {
/**
 * Service for sending feedback to Convo AI
 * Endpoint: /gateway/api/assist/rovo/v1/chat/conversation/{conversationId}/message/{messageId}/feedback
 */ const $56a78f5b498e953e$export$e99632e4ad5e3ea8 = async ({ conversationId: conversationId, messageId: messageId, feedbackValue: feedbackValue, feedbackText: feedbackText, feedbackCategories: feedbackCategories, productHeader: productHeader, experienceId: experienceId, channelId: channelId, cloudId: cloudId })=>{
    try {
        const url = `/gateway/api/assist/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/feedback`;
        const body = {
            feedback_value: feedbackValue
        };
        if (feedbackText) body.feedback_text = feedbackText;
        if (feedbackCategories && feedbackCategories.length > 0) body.feedback_categories = feedbackCategories;
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Product': productHeader,
                'X-Experience-Id': experienceId,
                'X-Channel-Id': channelId,
                'X-Cloudid': cloudId
            },
            credentials: 'include',
            body: JSON.stringify(body)
        });
        if (!response.ok) return Promise.reject(new Error(`Convo AI feedback request failed: ${response.status} ${response.statusText}`));
        return {
            success: true
        };
    } catch (error) {
        return Promise.reject(error);
    }
};
module.exports["sendConvoAIFeedback"] = $56a78f5b498e953e$export$e99632e4ad5e3ea8;

});

parcelRegister("bQupv", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $f410c414d86c0d56$export$1b78d6301ba6614 = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.seededConversation;
module.exports["getActionSeededConversationOptions"] = $f410c414d86c0d56$export$1b78d6301ba6614;

});

parcelRegister("fqtnH", function(module, exports) {
const $172339ad73e75be8$export$de435b1ae0c975f3 = {
    INSIGHTS: 'insights'
};
module.exports["TAGS"] = $172339ad73e75be8$export$de435b1ae0c975f3;

});

parcelRegister("lNd2W", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $ac236d4d9c4f5b4d$export$c5df045f791f45da = (adf)=>(0, $4EPzQ.reduce)(adf, (currentValue, node)=>node.type === 'text' && node.text ? currentValue + node.text : currentValue, '');
module.exports["extractPlainTextFromAdf"] = $ac236d4d9c4f5b4d$export$c5df045f791f45da;

});

parcelRegister("4RgKV", function(module, exports) {

var $4BHwn = parcelRequire("4BHwn");

const $b38a3411e044a7d2$export$24d2e7dc410ce2e5 = (chat, startFromMessageId, messageCount = 1)=>{
    const messageIndex = (0, $4BHwn.findStoreMessageIndex)(chat, startFromMessageId);
    if (messageIndex < 0) return [];
    const messageHistory = chat.slice(Math.max(0, messageIndex - messageCount), messageIndex + 1);
    return messageHistory;
};
module.exports["getMessageHistory"] = $b38a3411e044a7d2$export$24d2e7dc410ce2e5;

});

parcelRegister("1oo4W", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");

const $3084e0af351569fc$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        content: (0, $bkEBw.removeSensitiveData)(message.content)
    });
module.exports["removeSensitiveData"] = $3084e0af351569fc$export$efd4f6b5d168b654;

});

parcelRegister("ic2nu", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4e802170ba80f528$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    redactedAriaLabel: {
        id: "conversation-assistant.redacted-prompt.redacted-aria-label-nonfinal",
        defaultMessage: "redacted"
    },
    enforcementMessage: {
        id: "conversation-assistant.redacted-prompt.enforcement-message-nonfinal",
        defaultMessage: "Redacted by your organization"
    }
});
module.exports["messages"] = $4e802170ba80f528$export$defe85febe8b728c;

});

parcelRegister("5myly", function(module, exports) {
/**
 * @generated SignedSource<<fd0e2a908a9e136f53b59f7b8402f6e3>>
 * @relayHash 0eed17299c8b2bfbecafae06ea52f3e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 924cb16157e9c3601521d6495acb78aaf75fe02e71bd42acaeaa68dbe9cca148
const $3bd23fd2dcaaffcb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "identityAccountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "identityAccountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentResponseHatIdentityAccountQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "avatarRelay_user"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentResponseHatIdentityAccountQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "924cb16157e9c3601521d6495acb78aaf75fe02e71bd42acaeaa68dbe9cca148",
            "metadata": {},
            "name": "agentResponseHatIdentityAccountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3bd23fd2dcaaffcb$var$node.hash = "99c3bd88280ddb6509870547a637c991";
var $3bd23fd2dcaaffcb$export$2e2bcd8739ae039 = $3bd23fd2dcaaffcb$var$node;
module.exports["default"] = $3bd23fd2dcaaffcb$export$2e2bcd8739ae039;

});

parcelRegister("9qjJ9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");

// Rovo hex logo from `@atlaskit/logo/raw-icons` `rovoHexIcon`. Inlined rather than
// imported because that module bundles ~44 icon data URIs and does not tree-shake here, which
// would add ~9 kB to critical page-load routes (Jira Issue View, Confluence Edit Page). Keep this
// in sync with `rovo-mention.ts`, which uses the same data URI for default Rovo mention rows.
const $9afb2e5860bf50b3$var$ROVO_HEX_LOGO_DATA_URI = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $9afb2e5860bf50b3$export$b05b0a4d5a991909 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { name: t1, size: size } = t0;
    const name = t1 === undefined ? "Rovo" : t1;
    let t2;
    if ($[0] !== name || $[1] !== size) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            size: size,
            name: name,
            src: $9afb2e5860bf50b3$var$ROVO_HEX_LOGO_DATA_URI
        });
        $[0] = name;
        $[1] = size;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ name: name = 'Rovo', size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        size: size,
        name: name,
        src: $9afb2e5860bf50b3$var$ROVO_HEX_LOGO_DATA_URI
    });
module.exports["DefaultRovoAvatar"] = $9afb2e5860bf50b3$export$b05b0a4d5a991909;

});

parcelRegister("j0wI2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f84363b0a8745cbe$var$messages = (0, $kSwu1.defineMessages)({
    defaultRovoName: {
        id: "conversation-assistant.chat-history.store-assistant.agent-response-hat-messages.defaultRovoName",
        defaultMessage: "Rovo"
    }
});
var $f84363b0a8745cbe$export$2e2bcd8739ae039 = $f84363b0a8745cbe$var$messages;
module.exports["default"] = $f84363b0a8745cbe$export$2e2bcd8739ae039;

});

parcelRegister("5L9X9", function(module, exports) {

var $dZHHX = parcelRequire("dZHHX");


var $6krP0 = parcelRequire("6krP0");


var $9dpj4 = parcelRequire("9dpj4");

/**
 * Converts parsed Lumina layout to ADF JSON content array.
 * Sections are parsed into arrays (header + layout section), which are flattened.
 * Note: Type assertion is needed due to complex union types in ADF schema
 */ const $fcce681c8fe8429d$var$convertLuminaJsonToAdfContent = (luminaJson)=>{
    const content = [];
    for (const section of luminaJson){
        const parsedNodes = (0, $9dpj4.convertSection)(section, (0, $6krP0.luminaToAdfJsonNode));
        // convertSection returns an array (header + layout section), so we flatten it
        for (const node of parsedNodes)if (node) content.push(node);
    }
    return content;
};
const $fcce681c8fe8429d$export$125ef0acd23a6859 = (luminaSchema)=>{
    let luminaJson;
    // Parse lumina string if needed, otherwise use the provided parsed layout
    if (typeof luminaSchema === 'string') luminaJson = (0, $dZHHX.parseLuminaTagsToJSON)(luminaSchema);
    else luminaJson = luminaSchema;
    const content = $fcce681c8fe8429d$var$convertLuminaJsonToAdfContent(luminaJson);
    return {
        version: 1,
        type: 'doc',
        content: content
    };
};
module.exports["luminaToAdf"] = $fcce681c8fe8429d$export$125ef0acd23a6859;

});

parcelRegister("kjJc7", function(module, exports) {
const $07e1485dd1cb5a49$export$38cd9d96f6f2adc9 = (value)=>{
    return typeof value === 'object' && value !== null && value.type === 'doc' && Array.isArray(value.content);
};
module.exports["isAdfDoc"] = $07e1485dd1cb5a49$export$38cd9d96f6f2adc9;

});

parcelRegister("TBobf", function(module, exports) {

var $bMS22 = parcelRequire("bMS22");


var $6fWaX = parcelRequire("6fWaX");

const $713210419e3e77af$export$de60176d80391ddf = (mixed)=>{
    const trimmed = mixed.trim();
    if (trimmed.length === 0) return [];
    const root = (0, $bMS22.parse)(trimmed);
    // `<lumina>` is the outer wrapper the chat stream uses to delimit a payload.
    // The server only ever sends a single, top-level wrapper, so a one-level
    // unwrap is sufficient (no recursion needed).
    const flatNodes = [];
    for (const node of root.childNodes){
        const el = node;
        if (el.tagName?.toLowerCase() === 'lumina') for (const child of el.childNodes)flatNodes.push(child);
        else flatNodes.push(node);
    }
    const chunks = [];
    for (const node of flatNodes){
        const el = node;
        const tagName = el.tagName?.toLowerCase();
        const text = (tagName ? el.outerHTML : node.text)?.trim();
        if (!text) continue;
        const isLumina = tagName && (0, $6fWaX.LUMINA_TAGS).has(tagName);
        const luminaKind = tagName === 'section' ? 'lumina-document' : 'lumina-fragment';
        chunks.push({
            kind: isLumina ? luminaKind : 'prose',
            text: text
        });
    }
    return chunks;
};
module.exports["segmentLuminaAndProse"] = $713210419e3e77af$export$de60176d80391ddf;

});

parcelRegister("7lDGY", function(module, exports) {

var $a93Ml = parcelRequire("a93Ml");

const $5d85aed030404bd6$export$c2bdc25698e2bed1 = (content, markdownData)=>{
    if (!markdownData) return content;
    const luminaKeys = Object.keys(markdownData).filter((k)=>k.startsWith('lumina-') && !k.endsWith('-loading')).sort((a, b)=>{
        const ai = parseInt(a.substring(7), 10);
        const bi = parseInt(b.substring(7), 10);
        return ai - bi;
    });
    if (luminaKeys.length === 0) return content;
    let i = 0;
    return content.replace((0, $a93Ml.LUMINA_PLACEHOLDER_RE), ()=>{
        const key = luminaKeys[i++];
        if (!key) return '';
        const xml = markdownData[key] ?? '';
        return xml;
    });
};
module.exports["splicePlaceholders"] = $5d85aed030404bd6$export$c2bdc25698e2bed1;

});

parcelRegister("8YXeh", function(module, exports) {
const $d14f682bffdeec1c$export$bca18269f6b68bf = 'redacted-scribble';
const $d14f682bffdeec1c$export$425f49dce494f712 = 'com.rovo.guard';
module.exports["REDACT_EXTENSION_KEY"] = $d14f682bffdeec1c$export$bca18269f6b68bf;
module.exports["REDACT_EXTENSION_TYPE"] = $d14f682bffdeec1c$export$425f49dce494f712;

});

parcelRegister("6QFj4", function(module, exports) {
/**
 * @generated SignedSource<<fe7c174a30f330e5dd3ada4b22d69f4a>>
 * @relayHash 241cb10da29957359595c449811d3876
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a94a7ab5be96477770a5a137999c8ccb5ca8fea475b2b26730b0fe6bdf5e0e00
const $99930b318389fc17$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "cloudUrl"
            }
        ]
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isRequired"
    }, v9 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ 
        ]
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "concreteType": "JiraComponentConnection",
        "kind": "LinkedField",
        "name": "components",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraComponentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraComponent",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "componentId"
                            },
                            v4 /*: any*/ ,
                            v11 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v13 = [
        v5 /*: any*/ ,
        v11 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ], v14 = {
        "concreteType": "JiraUserConnection",
        "kind": "LinkedField",
        "name": "selectedUsersConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v13 /*: any*/ 
                    }
                ]
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "priorityId"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        },
        v11 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = [
        v16 /*: any*/ ,
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                },
                v11 /*: any*/ 
            ]
        },
        v11 /*: any*/ 
    ], v18 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v7 /*: any*/ 
        ]
    }, v19 = [
        v16 /*: any*/ ,
        v11 /*: any*/ 
    ], v20 = [
        {
            "concreteType": "JiraOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraOption",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v19 /*: any*/ 
                }
            ]
        }
    ], v21 = {
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": v20 /*: any*/ 
    }, v22 = {
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "selectedOptions",
        "plural": false,
        "selections": v20 /*: any*/ 
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        v16 /*: any*/ ,
        v11 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jiraCreateWithRovoPreviewCardQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectIdOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useAiCreateProjectContextQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query"
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "jiraMultiWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraMultiWorkItemPreviewCard"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jiraCreateWithRovoPreviewCardQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "JiraIssueTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueTypeId"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                    "kind": "LinkedField",
                                                    "name": "hierarchy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "level"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v10 /*: any*/ ,
                                                                            "type": "JiraIssueFieldConfiguration",
                                                                            "abstractKey": "__isJiraIssueFieldConfiguration"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v12 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraComponentsField"
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        v4 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v8 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueFieldConfiguration",
                                                                            "abstractKey": "__isJiraIssueFieldConfiguration"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "text"
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraRichText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "richText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraADF",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "adfValue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "convertedPlainText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "plainText"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraRichTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": v13 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isMulti"
                                                                                },
                                                                                v9 /*: any*/ ,
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraPeopleField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": v15 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraPriorityConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priorities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriorityEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v15 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraPriorityField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOptionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOptionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v17 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldOption",
                                                                                    "plural": false,
                                                                                    "selections": v17 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "date"
                                                                                }
                                                                            ],
                                                                            "type": "JiraDatePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "dateTime"
                                                                                }
                                                                            ],
                                                                            "type": "JiraDateTimePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "number"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "formatConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatStyle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatUnit"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraTimeTrackingField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOption",
                                                                                    "plural": false,
                                                                                    "selections": v19 /*: any*/ 
                                                                                },
                                                                                v21 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraRadioSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraCascadingOptionsConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cascadingOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCascadingOptionsEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOptions",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v23 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValues",
                                                                                                            "plural": true,
                                                                                                            "selections": v23 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCascadingSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraCheckboxesField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "uri"
                                                                                }
                                                                            ],
                                                                            "type": "JiraUrlField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraComponentsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v10 /*: any*/ ,
                                                                            "type": "JiraSprintField"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "xsmall"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "jira_isBetaAiFeaturesEnabled"
                }
            ]
        },
        "params": {
            "id": "a94a7ab5be96477770a5a137999c8ccb5ca8fea475b2b26730b0fe6bdf5e0e00",
            "metadata": {},
            "name": "jiraCreateWithRovoPreviewCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$99930b318389fc17$var$node.hash = "551097551ac6348fb0c743834d9a0244";
var $99930b318389fc17$export$2e2bcd8739ae039 = $99930b318389fc17$var$node;
module.exports["default"] = $99930b318389fc17$export$2e2bcd8739ae039;

});

parcelRegister("3EjfV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iRFKG = parcelRequire("iRFKG");


var $lRhY3 = parcelRequire("lRhY3");


var $2JXAC = parcelRequire("2JXAC");


var $7qHM3 = parcelRequire("7qHM3");

const $9257cafcb18fd0fc$var$messages = (0, $kSwu1.defineMessages)({
    workItem: {
        id: "navigation.preview-panel-global-objects.workItem",
        defaultMessage: "Jira work item"
    }
});
// Helper function to check if we're in an iframe - exported for testing
const $9257cafcb18fd0fc$var$isInIframe = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
/**
 * Constructs a proper embed URL by extracting query parameters and reconstructing the URL
 * @param url - The original URL
 * @param supportedObjects - Array of supported object types for previewPanels param
 * @returns A properly formatted embed URL with all query parameters at the end
 */ const $9257cafcb18fd0fc$var$buildIssueViewEmbedUrl = (url, supportedObjects = [
    'jira-issue'
])=>{
    try {
        const urlObj = new URL(url);
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs
        return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $9257cafcb18fd0fc$export$434665c07c6311d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { open: open } = (0, $lRhY3.usePreviewPanelsActions)();
    let t0;
    if ($[0] !== formatMessage || $[1] !== open) {
        t0 = (t1)=>{
            const { url: url, ari: ari, name: name, loadingState: loadingState, analyticsAttributes: analyticsAttributes, parentProduct: parentProduct } = t1;
            if ($9257cafcb18fd0fc$var$isInIframe()) {
                window.parent.postMessage({
                    type: "OPEN_PREVIEW_PANEL",
                    payload: {
                        url: url,
                        ari: ari,
                        name: name,
                        analyticsAttributes: analyticsAttributes
                    }
                }, "*");
                return;
            }
            open({
                panel: {
                    id: ari,
                    type: (0, $2JXAC.WORK_ITEM_GLOBAL_OBJECT_TYPE),
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qHM3.IFramePreviewPanel), {
                            name: formatMessage($9257cafcb18fd0fc$var$messages.workItem),
                            url: url,
                            iframeUrl: $9257cafcb18fd0fc$var$buildIssueViewEmbedUrl(url, [
                                (0, $2JXAC.WORK_ITEM_GLOBAL_OBJECT_TYPE)
                            ]),
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
                                label: ""
                            }),
                            panelType: (0, $2JXAC.WORK_ITEM_PANEL_TYPE),
                            product: (0, $2JXAC.JIRA_PRODUCT),
                            parentProduct: parentProduct,
                            ari: ari,
                            analyticsAttributes: analyticsAttributes,
                            loadingState: loadingState
                        }),
                    product: (0, $2JXAC.JIRA_PRODUCT)
                }
            });
        };
        $[0] = formatMessage;
        $[1] = open;
        $[2] = t0;
    } else t0 = $[2];
    const openPreviewPanel = t0;
    let t1;
    if ($[3] !== openPreviewPanel) {
        t1 = {
            openPreviewPanel: openPreviewPanel
        };
        $[3] = openPreviewPanel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { open: open } = (0, $lRhY3.usePreviewPanelsActions)();
    const openPreviewPanel = (0, $cozmU.useCallback)(({ url: url, ari: ari, name: name, loadingState: loadingState, analyticsAttributes: analyticsAttributes, parentProduct: parentProduct })=>{
        // Check if we're in an iframe (not the top-most frame)
        if ($9257cafcb18fd0fc$var$isInIframe()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name,
                    analyticsAttributes: analyticsAttributes
                }
            }, '*');
            return;
        }
        open({
            panel: {
                id: ari,
                type: (0, $2JXAC.WORK_ITEM_GLOBAL_OBJECT_TYPE),
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qHM3.IFramePreviewPanel), {
                        name: formatMessage($9257cafcb18fd0fc$var$messages.workItem),
                        url: url,
                        iframeUrl: $9257cafcb18fd0fc$var$buildIssueViewEmbedUrl(url, [
                            (0, $2JXAC.WORK_ITEM_GLOBAL_OBJECT_TYPE)
                        ]),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
                            label: ""
                        }),
                        panelType: (0, $2JXAC.WORK_ITEM_PANEL_TYPE),
                        product: (0, $2JXAC.JIRA_PRODUCT),
                        parentProduct: parentProduct,
                        ari: ari,
                        analyticsAttributes: analyticsAttributes,
                        loadingState: loadingState
                    }),
                product: (0, $2JXAC.JIRA_PRODUCT)
            }
        });
    }, [
        open,
        formatMessage
    ]);
    return {
        openPreviewPanel: openPreviewPanel
    };
};
module.exports["useWorkItemPreviewPanel"] = $9257cafcb18fd0fc$export$434665c07c6311d3;

});

parcelRegister("4AALj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $24dy7 = parcelRequire("24dy7");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $5e143ab6aa6f4daf$export$915e9e7bd4f0f96d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { errorMessage: errorMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "",
            size: "small"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== errorMessage) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.danger"
        }, errorMessage));
        $[1] = errorMessage;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ errorMessage: errorMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, errorMessage));
};
module.exports["ErrorMessage"] = $5e143ab6aa6f4daf$export$915e9e7bd4f0f96d;

});

parcelRegister("lwkg1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $iRFKG = parcelRequire("iRFKG");


var $f1iv3 = parcelRequire("f1iv3");


var $4aRua = parcelRequire("4aRua");


var $jKT15 = parcelRequire("jKT15");

const $2e66403d16d0e184$var$messages = (0, $kSwu1.defineMessages)({
    singleWorkItemPreviewHeaderTitle: {
        id: "jiraCreateWithRovoPreviewCard.singleWorkItemPreviewHeaderTitle",
        defaultMessage: "Create work item"
    },
    multiWorkItemPreviewHeaderTitle: {
        id: "jiraCreateWithRovoPreviewCard.multiWorkItemPreviewHeaderTitle",
        defaultMessage: "Create work items"
    }
});
const $2e66403d16d0e184$export$8787e88dc3e226a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isSelected: isSelected, showSingleWorkItemCard: showSingleWorkItemCard } = t0;
    let t1;
    if ($[0] !== showSingleWorkItemCard) {
        t1 = showSingleWorkItemCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
                fireExperimentExposure: false
            }) ? "" : "Work item"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
                fireExperimentExposure: false
            }) ? "" : "Work items"
        });
        $[0] = showSingleWorkItemCard;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== showSingleWorkItemCard) {
        t2 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showSingleWorkItemCard ? $2e66403d16d0e184$var$messages.singleWorkItemPreviewHeaderTitle : $2e66403d16d0e184$var$messages.multiWorkItemPreviewHeaderTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showSingleWorkItemCard ? $2e66403d16d0e184$var$messages.singleWorkItemPreviewHeaderTitle : $2e66403d16d0e184$var$messages.multiWorkItemPreviewHeaderTitle));
        $[2] = showSingleWorkItemCard;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isSelected || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
            previewProductLogo: t1,
            isLoading: true,
            isSelected: isSelected,
            previewHeaderTitle: t2
        });
        $[4] = isSelected;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ isSelected: isSelected, showSingleWorkItemCard: showSingleWorkItemCard })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
        previewProductLogo: showSingleWorkItemCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? '' : 'Work item'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? '' : 'Work items'
        }),
        isLoading: true,
        isSelected: isSelected,
        previewHeaderTitle: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showSingleWorkItemCard ? $2e66403d16d0e184$var$messages.singleWorkItemPreviewHeaderTitle : $2e66403d16d0e184$var$messages.multiWorkItemPreviewHeaderTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showSingleWorkItemCard ? $2e66403d16d0e184$var$messages.singleWorkItemPreviewHeaderTitle : $2e66403d16d0e184$var$messages.multiWorkItemPreviewHeaderTitle))
    });
};
module.exports["FallbackPreviewCard"] = $2e66403d16d0e184$export$8787e88dc3e226a8;

});

parcelRegister("fqVHc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hCByF = parcelRequire("hCByF");


var $5VM4i = parcelRequire("5VM4i");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $kz1Yj = parcelRequire("kz1Yj");


var $cC4M6 = parcelRequire("cC4M6");


var $kEZoA = parcelRequire("kEZoA");


var $fkQpA = parcelRequire("fkQpA");


var $j9Z2s = parcelRequire("j9Z2s");


var $7ChxK = parcelRequire("7ChxK");

const $ed102c9f2492363f$var$messages = (0, $kSwu1.defineMessages)({
    singleCreate: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.create-in-project",
        defaultMessage: "Create"
    },
    createAll: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.create-all",
        defaultMessage: "Create all"
    },
    createCount: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.create-count",
        defaultMessage: "Create {count}"
    },
    singleDismissAction: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.dismiss-action",
        defaultMessage: "Dismiss"
    },
    dismissAllAction: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.dismiss-all-action",
        defaultMessage: "Dismiss all"
    },
    dismissAllActionAccessibleLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.dismiss-all-action-accessible-label",
        defaultMessage: "Dismiss all work items"
    },
    singleDismissActionAccessibleLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.dismiss-action-accessible-label",
        defaultMessage: "Dismiss work item"
    },
    openPreview: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.open-preview",
        defaultMessage: "Preview"
    },
    openPreviewAccessibleLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.open-preview-accessible-label",
        defaultMessage: "Preview work items"
    },
    viewingNow: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.viewing-now",
        defaultMessage: "Viewing now"
    },
    refineInGic: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.edit-in-gic",
        defaultMessage: "Refine"
    },
    refineWorkItemAccessibleLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.refine-work-item-accessible-label",
        defaultMessage: "Refine work item"
    },
    createWorkItemAccessibleLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.create-work-item-accessible-label",
        defaultMessage: "Create work item"
    },
    createAllWorkItemsAccessibleLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.create-all-work-items-accessible-label",
        defaultMessage: "Create all work items"
    }
});
const $ed102c9f2492363f$var$DeclineButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { areButtonsDisabled: areButtonsDisabled, isSingleWorkItem: isSingleWorkItem, onDismiss: onDismiss } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== isSingleWorkItem) {
        t1 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? formatMessage(isSingleWorkItem ? $ed102c9f2492363f$var$messages.singleDismissActionAccessibleLabel : $ed102c9f2492363f$var$messages.dismissAllActionAccessibleLabel) : undefined;
        $[0] = formatMessage;
        $[1] = isSingleWorkItem;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = isSingleWorkItem ? $ed102c9f2492363f$var$messages.singleDismissAction : $ed102c9f2492363f$var$messages.dismissAllAction;
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== areButtonsDisabled || $[6] !== onDismiss || $[7] !== t1 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onDismiss,
            isDisabled: areButtonsDisabled,
            "aria-label": t1
        }, t3);
        $[5] = areButtonsDisabled;
        $[6] = onDismiss;
        $[7] = t1;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ areButtonsDisabled: areButtonsDisabled, isSingleWorkItem: isSingleWorkItem, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismiss,
        isDisabled: areButtonsDisabled,
        "aria-label": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? formatMessage(isSingleWorkItem ? $ed102c9f2492363f$var$messages.singleDismissActionAccessibleLabel : $ed102c9f2492363f$var$messages.dismissAllActionAccessibleLabel) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isSingleWorkItem ? $ed102c9f2492363f$var$messages.singleDismissAction : $ed102c9f2492363f$var$messages.dismissAllAction));
};
const $ed102c9f2492363f$var$EditInGicButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { areButtonsDisabled: areButtonsDisabled, gicEntryPointProps: gicEntryPointProps, selectedDraftWorkItem: selectedDraftWorkItem, projectId: projectId, isStagingArea: isStagingArea, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== selectedDraftWorkItem) {
        t1 = selectedDraftWorkItem ? (0, $7ChxK.isSubTaskWithoutCreatedParent)(selectedDraftWorkItem) : false;
        $[0] = selectedDraftWorkItem;
        $[1] = t1;
    } else t1 = $[1];
    const isSubTaskWithoutParent = t1;
    let t2;
    if ($[2] !== isStagingArea || $[3] !== sendAifcAnalyticsEvent) {
        t2 = ()=>{
            sendAifcAnalyticsEvent?.({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "createWorkItemsEditInGic",
                attributes: {
                    itemCount: 1,
                    isSingleWorkItem: true,
                    isStagingArea: isStagingArea
                }
            });
        };
        $[2] = isStagingArea;
        $[3] = sendAifcAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const onGicClick = t2;
    if (!selectedDraftWorkItem) return null;
    const t3 = areButtonsDisabled || isSubTaskWithoutParent;
    let t4;
    if ($[5] !== gicEntryPointProps || $[6] !== projectId || $[7] !== selectedDraftWorkItem) {
        t4 = {
            ...gicEntryPointProps,
            projectId: projectId,
            selectedDraftWorkItem: selectedDraftWorkItem
        };
        $[5] = gicEntryPointProps;
        $[6] = projectId;
        $[7] = selectedDraftWorkItem;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = selectedDraftWorkItem?.fields?.parent ?? undefined;
    let t6;
    if ($[9] !== gicEntryPointProps.cloudId || $[10] !== t5) {
        t6 = {
            cloudId: gicEntryPointProps.cloudId,
            parentIssue: t5
        };
        $[9] = gicEntryPointProps.cloudId;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            width: "large",
            shouldScrollInViewport: true
        };
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== formatMessage) {
        t8 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? formatMessage($ed102c9f2492363f$var$messages.refineWorkItemAccessibleLabel) : undefined;
        $[13] = formatMessage;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.refineInGic);
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== onGicClick || $[17] !== t3 || $[18] !== t4 || $[19] !== t6 || $[20] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cC4M6.ModalButtonTrigger), {
            appearance: "subtle",
            isDisabled: t3,
            onClick: onGicClick,
            entryPoint: (0, $j9Z2s.gicModalEntryPoint),
            entryPointProps: t4,
            entryPointParams: t6,
            modalProps: t7,
            "aria-label": t8
        }, t9);
        $[16] = onGicClick;
        $[17] = t3;
        $[18] = t4;
        $[19] = t6;
        $[20] = t8;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : ({ areButtonsDisabled: areButtonsDisabled, gicEntryPointProps: gicEntryPointProps, selectedDraftWorkItem: selectedDraftWorkItem, projectId: projectId, isStagingArea: isStagingArea, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isSubTaskWithoutParent = selectedDraftWorkItem ? (0, $7ChxK.isSubTaskWithoutCreatedParent)(selectedDraftWorkItem) : false;
    const onGicClick = (0, $cozmU.useCallback)(()=>{
        sendAifcAnalyticsEvent?.({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsEditInGic',
            attributes: {
                itemCount: 1,
                isSingleWorkItem: true,
                isStagingArea: isStagingArea
            }
        });
    }, [
        sendAifcAnalyticsEvent,
        isStagingArea
    ]);
    if (!selectedDraftWorkItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cC4M6.ModalButtonTrigger), {
        appearance: "subtle",
        isDisabled: areButtonsDisabled || isSubTaskWithoutParent,
        onClick: onGicClick,
        entryPoint: (0, $j9Z2s.gicModalEntryPoint),
        entryPointProps: {
            ...gicEntryPointProps,
            projectId: projectId,
            selectedDraftWorkItem: selectedDraftWorkItem
        },
        entryPointParams: {
            cloudId: gicEntryPointProps.cloudId,
            parentIssue: selectedDraftWorkItem?.fields?.parent ?? undefined
        },
        modalProps: {
            width: 'large',
            shouldScrollInViewport: true
        },
        "aria-label": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? formatMessage($ed102c9f2492363f$var$messages.refineWorkItemAccessibleLabel) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.refineInGic));
};
const $ed102c9f2492363f$var$PreviewButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { areButtonsDisabled: areButtonsDisabled, onPreviewClick: onPreviewClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? formatMessage($ed102c9f2492363f$var$messages.openPreviewAccessibleLabel) : undefined;
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.openPreview);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== areButtonsDisabled || $[4] !== onPreviewClick || $[5] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onPreviewClick,
            isDisabled: areButtonsDisabled,
            appearance: "subtle",
            "aria-label": t1
        }, t2);
        $[3] = areButtonsDisabled;
        $[4] = onPreviewClick;
        $[5] = t1;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ areButtonsDisabled: areButtonsDisabled, onPreviewClick: onPreviewClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onPreviewClick,
        isDisabled: areButtonsDisabled,
        appearance: "subtle",
        "aria-label": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? formatMessage($ed102c9f2492363f$var$messages.openPreviewAccessibleLabel) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.openPreview));
};
const $ed102c9f2492363f$var$getProduct = (product)=>{
    switch(product){
        case 'confluence':
            return 'confluence';
        case 'jira-software':
        case 'jira-core':
        case 'jsm':
        case 'jpd':
        case 'jira':
            return 'jira';
        case 'rovo':
        case 'atlas':
            return 'atlas';
        case 'bitbucket':
            return 'bitbucket';
        case 'admin':
            return 'admin';
        default:
            return 'unknown';
    }
};
const $ed102c9f2492363f$export$20d79cb3e53a70a3 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { product: product, query: query, project: project, cloudId: cloudId, messageId: messageId, isSingleWorkItem: isSingleWorkItem, areButtonsDisabled: t1, onDismiss: onDismiss, onBulkAccept: onBulkAccept, onCreateSuccess: onCreateSuccess, onCreateError: onCreateError, onPreviewClick: onPreviewClick, gicEntryPointProps: gicEntryPointProps, projectIdOrKey: projectIdOrKey, isStagingArea: isStagingArea, entryPoint: entryPoint, showSuccessFlagOnCreate: showSuccessFlagOnCreate, selectedItems: selectedItems, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const areButtonsDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tenantInfo = (0, $6SsN4.useFragment)((0, $5VM4i.default), query);
    const cloudUrl = tenantInfo?.tenantContexts?.[0]?.cloudUrl ?? "";
    const projectData = (0, $6SsN4.useFragment)((0, $hCByF.default), project);
    const isBetaAiFeaturesEnabled = tenantInfo?.jira_isBetaAiFeaturesEnabled ?? true;
    let t2;
    if ($[0] !== isBetaAiFeaturesEnabled || $[1] !== product) {
        t2 = isBetaAiFeaturesEnabled && $ed102c9f2492363f$var$getProduct(product) === "jira" && (0, $iDrrr.fg)("jira_aifc_enabled");
        $[0] = isBetaAiFeaturesEnabled;
        $[1] = product;
        $[2] = t2;
    } else t2 = $[2];
    const isPreviewAifcEnabled = t2;
    const projectId = projectData?.projectId ?? undefined;
    const draftWorkItemsToCreate = (0, $fkQpA.useGetDraftWorkItemsToCreate)(messageId);
    const selectedDraftWorkItem = draftWorkItemsToCreate[0];
    let t3;
    if ($[3] !== selectedItems) {
        t3 = (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "cohort", "control", {
            fireExperimentExposure: false
        }) === "checkboxes" && selectedItems && selectedItems?.size > 0;
        $[3] = selectedItems;
        $[4] = t3;
    } else t3 = $[4];
    const hasSelectedItems = t3;
    let t4;
    bb0: {
        if (isSingleWorkItem) {
            let t5;
            if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.singleCreate);
                $[5] = t5;
            } else t5 = $[5];
            t4 = t5;
            break bb0;
        }
        if (hasSelectedItems) {
            const totalItemCount = draftWorkItemsToCreate.reduce($ed102c9f2492363f$var$_temp, 0);
            if (selectedItems.size < totalItemCount) {
                let t5;
                if ($[6] !== selectedItems.size) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        ...$ed102c9f2492363f$var$messages.createCount,
                        values: {
                            count: selectedItems.size
                        }
                    });
                    $[6] = selectedItems.size;
                    $[7] = t5;
                } else t5 = $[7];
                t4 = t5;
                break bb0;
            }
        }
        let t5;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.createAll);
            $[8] = t5;
        } else t5 = $[8];
        t4 = t5;
    }
    const createButtonLabel = t4;
    let t5;
    if ($[9] !== draftWorkItemsToCreate || $[10] !== hasSelectedItems || $[11] !== selectedItems) {
        t5 = ()=>{
            let items = draftWorkItemsToCreate;
            if (hasSelectedItems) {
                const promotedChildren = [];
                items.forEach((item_0)=>{
                    if (selectedItems.has(item_0.invocationId)) return;
                    item_0.childWorkItems?.forEach((child)=>{
                        if (selectedItems.has(child.invocationId) && !(0, $7ChxK.isSubTask)(child)) promotedChildren.push({
                            ...child,
                            fields: {
                                ...child.fields,
                                parent: undefined
                            },
                            childWorkItems: []
                        });
                    });
                });
                items = items.filter((item_1)=>selectedItems.has(item_1.invocationId)).map((item_2)=>{
                    if (item_2.childWorkItems) return {
                        ...item_2,
                        childWorkItems: item_2.childWorkItems.filter((child_0)=>selectedItems.has(child_0.invocationId))
                    };
                    return item_2;
                }).concat(promotedChildren);
            }
            return Promise.resolve(items);
        };
        $[9] = draftWorkItemsToCreate;
        $[10] = hasSelectedItems;
        $[11] = selectedItems;
        $[12] = t5;
    } else t5 = $[12];
    const getActiveDraftWorkItems = t5;
    const t6 = isSingleWorkItem ?? false;
    let t7;
    if ($[13] !== areButtonsDisabled || $[14] !== onDismiss || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed102c9f2492363f$var$DeclineButton, {
            areButtonsDisabled: areButtonsDisabled,
            isSingleWorkItem: t6,
            onDismiss: onDismiss
        });
        $[13] = areButtonsDisabled;
        $[14] = onDismiss;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== areButtonsDisabled || $[18] !== gicEntryPointProps || $[19] !== isPreviewAifcEnabled || $[20] !== isSingleWorkItem || $[21] !== isStagingArea || $[22] !== onPreviewClick || $[23] !== projectId || $[24] !== selectedDraftWorkItem || $[25] !== sendAifcAnalyticsEvent) {
        t8 = isSingleWorkItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed102c9f2492363f$var$EditInGicButton, {
            areButtonsDisabled: areButtonsDisabled,
            gicEntryPointProps: gicEntryPointProps,
            selectedDraftWorkItem: selectedDraftWorkItem,
            projectId: projectId,
            isStagingArea: isStagingArea,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }) : isPreviewAifcEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed102c9f2492363f$var$PreviewButton, {
            areButtonsDisabled: areButtonsDisabled,
            onPreviewClick: onPreviewClick
        });
        $[17] = areButtonsDisabled;
        $[18] = gicEntryPointProps;
        $[19] = isPreviewAifcEnabled;
        $[20] = isSingleWorkItem;
        $[21] = isStagingArea;
        $[22] = onPreviewClick;
        $[23] = projectId;
        $[24] = selectedDraftWorkItem;
        $[25] = sendAifcAnalyticsEvent;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== formatMessage || $[28] !== isSingleWorkItem) {
        t9 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? formatMessage(isSingleWorkItem ? $ed102c9f2492363f$var$messages.createWorkItemAccessibleLabel : $ed102c9f2492363f$var$messages.createAllWorkItemsAccessibleLabel) : undefined;
        $[27] = formatMessage;
        $[28] = isSingleWorkItem;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== areButtonsDisabled || $[31] !== cloudId || $[32] !== cloudUrl || $[33] !== createButtonLabel || $[34] !== entryPoint || $[35] !== getActiveDraftWorkItems || $[36] !== isStagingArea || $[37] !== onBulkAccept || $[38] !== onCreateError || $[39] !== onCreateSuccess || $[40] !== projectIdOrKey || $[41] !== sendAifcAnalyticsEvent || $[42] !== showSuccessFlagOnCreate || $[43] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEZoA.CreateWorkItemsButton), {
            getDraftWorkItems: getActiveDraftWorkItems,
            onSuccess: onCreateSuccess,
            onError: onCreateError,
            cloudId: cloudId,
            cloudUrl: cloudUrl,
            projectIdOrKey: projectIdOrKey,
            buttonContent: createButtonLabel,
            testId: "jira-work-item-preview-card-create-button",
            isDisabled: areButtonsDisabled,
            showErrorsInFlag: false,
            showSuccessFlagOnCreate: showSuccessFlagOnCreate,
            onClick: onBulkAccept,
            isStagingArea: isStagingArea,
            entryPoint: entryPoint,
            ariaLabel: t9,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        });
        $[30] = areButtonsDisabled;
        $[31] = cloudId;
        $[32] = cloudUrl;
        $[33] = createButtonLabel;
        $[34] = entryPoint;
        $[35] = getActiveDraftWorkItems;
        $[36] = isStagingArea;
        $[37] = onBulkAccept;
        $[38] = onCreateError;
        $[39] = onCreateSuccess;
        $[40] = projectIdOrKey;
        $[41] = sendAifcAnalyticsEvent;
        $[42] = showSuccessFlagOnCreate;
        $[43] = t9;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] !== t10 || $[46] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.100",
            alignBlock: "center"
        }, t8, t10);
        $[45] = t10;
        $[46] = t8;
        $[47] = t11;
    } else t11 = $[47];
    let t12;
    if ($[48] !== t11 || $[49] !== t7) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            spread: "space-between",
            alignInline: "end",
            grow: "fill"
        }, t7, t11);
        $[48] = t11;
        $[49] = t7;
        $[50] = t12;
    } else t12 = $[50];
    return t12;
} : ({ product: product, query: query, project: project, cloudId: cloudId, messageId: messageId, isSingleWorkItem: isSingleWorkItem, areButtonsDisabled: areButtonsDisabled = false, onDismiss: onDismiss, onBulkAccept: onBulkAccept, onCreateSuccess: onCreateSuccess, onCreateError: onCreateError, onPreviewClick: onPreviewClick, gicEntryPointProps: gicEntryPointProps, projectIdOrKey: projectIdOrKey, isStagingArea: isStagingArea, entryPoint: entryPoint, showSuccessFlagOnCreate: showSuccessFlagOnCreate, selectedItems: selectedItems, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tenantInfo = (0, $6SsN4.useFragment)((0, $5VM4i.default), query);
    const cloudUrl = tenantInfo?.tenantContexts?.[0]?.cloudUrl ?? '';
    const projectData = (0, $6SsN4.useFragment)((0, $hCByF.default), project);
    const isBetaAiFeaturesEnabled = tenantInfo?.jira_isBetaAiFeaturesEnabled ?? true;
    const isPreviewAifcEnabled = isBetaAiFeaturesEnabled && $ed102c9f2492363f$var$getProduct(product) === 'jira' && (0, $iDrrr.fg)('jira_aifc_enabled');
    const projectId = projectData?.projectId ?? undefined;
    const draftWorkItemsToCreate = (0, $fkQpA.useGetDraftWorkItemsToCreate)(messageId);
    const selectedDraftWorkItem = draftWorkItemsToCreate[0];
    const hasSelectedItems = (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'checkboxes' && selectedItems && selectedItems?.size > 0;
    const createButtonLabel = (0, $cozmU.useMemo)(()=>{
        if (isSingleWorkItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.singleCreate);
        if (hasSelectedItems) {
            const totalItemCount = draftWorkItemsToCreate.reduce((count, item)=>count + 1 + (item.childWorkItems?.length ?? 0), 0);
            if (selectedItems.size < totalItemCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$ed102c9f2492363f$var$messages.createCount,
                values: {
                    count: selectedItems.size
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ed102c9f2492363f$var$messages.createAll);
    }, [
        isSingleWorkItem,
        hasSelectedItems,
        draftWorkItemsToCreate,
        selectedItems
    ]);
    const getActiveDraftWorkItems = (0, $cozmU.useCallback)(()=>{
        let items = draftWorkItemsToCreate;
        // Filter out unchecked issues. Child work items that are orphaned (ie. their parent was not checked)
        // are promoted to standalone work items.
        if (hasSelectedItems) {
            const promotedChildren = [];
            items.forEach((item_0)=>{
                if (selectedItems.has(item_0.invocationId)) return;
                item_0.childWorkItems?.forEach((child)=>{
                    if (selectedItems.has(child.invocationId) && !(0, $7ChxK.isSubTask)(child)) promotedChildren.push({
                        ...child,
                        fields: {
                            ...child.fields,
                            parent: undefined
                        },
                        childWorkItems: []
                    });
                });
            });
            items = items.filter((item_1)=>selectedItems.has(item_1.invocationId)).map((item_2)=>{
                if (item_2.childWorkItems) return {
                    ...item_2,
                    childWorkItems: item_2.childWorkItems.filter((child_0)=>selectedItems.has(child_0.invocationId))
                };
                return item_2;
            }).concat(promotedChildren);
        }
        return Promise.resolve(items);
    }, [
        draftWorkItemsToCreate,
        hasSelectedItems,
        selectedItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        spread: "space-between",
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed102c9f2492363f$var$DeclineButton, {
        areButtonsDisabled: areButtonsDisabled,
        isSingleWorkItem: isSingleWorkItem ?? false,
        onDismiss: onDismiss
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        alignBlock: "center"
    }, isSingleWorkItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed102c9f2492363f$var$EditInGicButton, {
        areButtonsDisabled: areButtonsDisabled,
        gicEntryPointProps: gicEntryPointProps,
        selectedDraftWorkItem: selectedDraftWorkItem,
        projectId: projectId,
        isStagingArea: isStagingArea,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    }) : isPreviewAifcEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed102c9f2492363f$var$PreviewButton, {
        areButtonsDisabled: areButtonsDisabled,
        onPreviewClick: onPreviewClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEZoA.CreateWorkItemsButton), {
        getDraftWorkItems: getActiveDraftWorkItems,
        onSuccess: onCreateSuccess,
        onError: onCreateError,
        cloudId: cloudId,
        cloudUrl: cloudUrl,
        projectIdOrKey: projectIdOrKey,
        buttonContent: createButtonLabel,
        testId: "jira-work-item-preview-card-create-button",
        isDisabled: areButtonsDisabled,
        showErrorsInFlag: false,
        showSuccessFlagOnCreate: showSuccessFlagOnCreate,
        onClick: onBulkAccept,
        isStagingArea: isStagingArea,
        entryPoint: entryPoint,
        ariaLabel: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? formatMessage(isSingleWorkItem ? $ed102c9f2492363f$var$messages.createWorkItemAccessibleLabel : $ed102c9f2492363f$var$messages.createAllWorkItemsAccessibleLabel) : undefined,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    })));
});
function $ed102c9f2492363f$var$_temp(count, item) {
    return count + 1 + (item.childWorkItems?.length ?? 0);
}
module.exports["PreviewFooterActions"] = $ed102c9f2492363f$export$20d79cb3e53a70a3;

});

parcelRegister("3M2fw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $lxF6e = parcelRequire("lxF6e");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $f1iv3 = parcelRequire("f1iv3");


var $4aRua = parcelRequire("4aRua");


var $jKT15 = parcelRequire("jKT15");


var $hu8st = parcelRequire("hu8st");


var $7e3Ro = parcelRequire("7e3Ro");

const $2aaa205c1a318a54$var$messages = (0, $kSwu1.defineMessages)({
    previewHeaderTitle: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.preview-header-title",
        defaultMessage: "Create work items"
    },
    openPreview: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.open-preview",
        defaultMessage: "Open preview"
    },
    viewingNow: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.viewing-now",
        defaultMessage: "Viewing now"
    }
});
const $2aaa205c1a318a54$export$b80f8cd6d4b4b1bb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { cloudId: cloudId, project: project, projectKey: projectKey, draftWorkItems: draftWorkItems, isCreated: isCreated, isSelected: isSelected, isEnabled: isEnabled, hideInlineButtons: hideInlineButtons, onDeclineWorkItem: onDeclineWorkItem, onInlineAccept: onInlineAccept, previewFooterActions: previewFooterActions, openWorkItemView: openWorkItemView, gicEntryPointProps: gicEntryPointProps, isStagingArea: isStagingArea, onProjectChange: onProjectChange, selectedItems: selectedItems, onToggleSelect: onToggleSelect, hasAnyCreatedItems: hasAnyCreatedItems, isCreating: isCreating, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const workItemsTableRef = (0, $6SsN4.useFragment)((0, $lxF6e.default), project);
    const projectId = workItemsTableRef.id;
    const projectName = workItemsTableRef.name;
    const projectIcon = workItemsTableRef.avatar?.xsmall ?? undefined;
    const hideFooterActions = isSelected || !isEnabled || isCreated || hasAnyCreatedItems;
    let t1;
    if ($[0] !== onProjectChange) {
        t1 = (t2)=>{
            const { projectKey: pk } = t2;
            return onProjectChange(pk);
        };
        $[0] = onProjectChange;
        $[1] = t1;
    } else t1 = $[1];
    const setProject = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
                fireExperimentExposure: false
            }) ? "" : "Work items"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2aaa205c1a318a54$var$messages.previewHeaderTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2aaa205c1a318a54$var$messages.previewHeaderTitle));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== cloudId || $[5] !== isCreated || $[6] !== isEnabled || $[7] !== projectIcon || $[8] !== projectId || $[9] !== projectKey || $[10] !== projectName || $[11] !== setProject) {
        t4 = (0, $cXtTj.default).getExperimentValue("jira-aifc-project-selector-in-chat-exp", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu8st.ProjectSelector), {
            isDisabled: !isEnabled || isCreated,
            siteId: cloudId,
            selectedProject: {
                label: projectName,
                value: projectId,
                projectKey: projectKey
            },
            selectedProjectIconUrl: projectIcon,
            setProject: setProject
        }) : null;
        $[4] = cloudId;
        $[5] = isCreated;
        $[6] = isEnabled;
        $[7] = projectIcon;
        $[8] = projectId;
        $[9] = projectKey;
        $[10] = projectName;
        $[11] = setProject;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== draftWorkItems || $[14] !== gicEntryPointProps || $[15] !== hasAnyCreatedItems || $[16] !== hideInlineButtons || $[17] !== isCreating || $[18] !== isStagingArea || $[19] !== onDeclineWorkItem || $[20] !== onInlineAccept || $[21] !== onToggleSelect || $[22] !== openWorkItemView || $[23] !== selectedItems || $[24] !== sendAifcAnalyticsEvent || $[25] !== workItemsTableRef) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e3Ro.WorkItemsTable), {
            project: workItemsTableRef,
            draftWorkItems: draftWorkItems,
            onDeclineWorkItem: onDeclineWorkItem,
            hideInlineButtons: hideInlineButtons,
            openWorkItemView: openWorkItemView,
            gicEntryPointProps: gicEntryPointProps,
            onInlineAccept: onInlineAccept,
            isStagingArea: isStagingArea,
            selectedItems: selectedItems,
            onToggleSelect: onToggleSelect,
            hasAnyCreatedItems: hasAnyCreatedItems,
            isCreating: isCreating,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        });
        $[13] = draftWorkItems;
        $[14] = gicEntryPointProps;
        $[15] = hasAnyCreatedItems;
        $[16] = hideInlineButtons;
        $[17] = isCreating;
        $[18] = isStagingArea;
        $[19] = onDeclineWorkItem;
        $[20] = onInlineAccept;
        $[21] = onToggleSelect;
        $[22] = openWorkItemView;
        $[23] = selectedItems;
        $[24] = sendAifcAnalyticsEvent;
        $[25] = workItemsTableRef;
        $[26] = t5;
    } else t5 = $[26];
    let t6;
    if ($[27] !== t4 || $[28] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[27] = t4;
        $[28] = t5;
        $[29] = t6;
    } else t6 = $[29];
    const t7 = hideFooterActions ? null : previewFooterActions;
    let t8;
    if ($[30] !== isCreated || $[31] !== isEnabled || $[32] !== isSelected || $[33] !== t6 || $[34] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
            testId: "conversation-assistant-preview-card.jira-multi-work-item-preview-card",
            previewProductLogo: t2,
            isSelected: isSelected,
            isEnabled: isEnabled,
            isCreated: isCreated,
            previewHeaderTitle: t3,
            previewContent: t6,
            previewFooterActions: t7
        });
        $[30] = isCreated;
        $[31] = isEnabled;
        $[32] = isSelected;
        $[33] = t6;
        $[34] = t7;
        $[35] = t8;
    } else t8 = $[35];
    return t8;
} : ({ cloudId: cloudId, project: project, projectKey: projectKey, draftWorkItems: draftWorkItems, isCreated: isCreated, isSelected: isSelected, isEnabled: isEnabled, hideInlineButtons: hideInlineButtons, onDeclineWorkItem: onDeclineWorkItem, onInlineAccept: onInlineAccept, previewFooterActions: previewFooterActions, openWorkItemView: openWorkItemView, gicEntryPointProps: gicEntryPointProps, isStagingArea: isStagingArea, onProjectChange: onProjectChange, selectedItems: selectedItems, onToggleSelect: onToggleSelect, hasAnyCreatedItems: hasAnyCreatedItems, isCreating: isCreating, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const workItemsTableRef = (0, $6SsN4.useFragment)((0, $lxF6e.default), project);
    // Project info of current project to initially be displayed in the project selector
    const projectId = workItemsTableRef.id;
    const projectName = workItemsTableRef.name;
    const projectIcon = workItemsTableRef.avatar?.xsmall ?? undefined;
    const hideFooterActions = isSelected || !isEnabled || isCreated || hasAnyCreatedItems;
    const setProject = (0, $cozmU.useCallback)(({ projectKey: pk })=>onProjectChange(pk), [
        onProjectChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
        testId: "conversation-assistant-preview-card.jira-multi-work-item-preview-card",
        previewProductLogo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? '' : 'Work items'
        }),
        isSelected: isSelected,
        isEnabled: isEnabled,
        isCreated: isCreated,
        previewHeaderTitle: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2aaa205c1a318a54$var$messages.previewHeaderTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2aaa205c1a318a54$var$messages.previewHeaderTitle)),
        previewContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $cXtTj.default).getExperimentValue('jira-aifc-project-selector-in-chat-exp', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu8st.ProjectSelector), {
            isDisabled: !isEnabled || isCreated,
            siteId: cloudId,
            selectedProject: {
                label: projectName,
                value: projectId,
                projectKey: projectKey
            },
            selectedProjectIconUrl: projectIcon,
            setProject: setProject
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e3Ro.WorkItemsTable), {
            project: workItemsTableRef,
            draftWorkItems: draftWorkItems,
            onDeclineWorkItem: onDeclineWorkItem,
            hideInlineButtons: hideInlineButtons,
            openWorkItemView: openWorkItemView,
            gicEntryPointProps: gicEntryPointProps,
            onInlineAccept: onInlineAccept,
            isStagingArea: isStagingArea,
            selectedItems: selectedItems,
            onToggleSelect: onToggleSelect,
            hasAnyCreatedItems: hasAnyCreatedItems,
            isCreating: isCreating,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        })),
        previewFooterActions: hideFooterActions ? null : previewFooterActions
    });
};
module.exports["JiraMultiWorkItemPreviewCard"] = $2aaa205c1a318a54$export$b80f8cd6d4b4b1bb;

});

parcelRegister("cymH2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iudWS = parcelRequire("iudWS");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $iRFKG = parcelRequire("iRFKG");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $jKT15 = parcelRequire("jKT15");


var $1IcZo = parcelRequire("1IcZo");

const $577929e8e464be32$var$messages = (0, $kSwu1.defineMessages)({
    previewHeaderTitle: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.preview-header-title",
        defaultMessage: "Create work item"
    },
    dismissAction: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.dismiss",
        defaultMessage: "Dismiss"
    },
    createAction: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.create",
        defaultMessage: "Create"
    },
    tempTaskTooltipLabel: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.temp-task-tooltip-label",
        defaultMessage: "Task"
    }
});
const $577929e8e464be32$var$styles = {
    issueKeyContainer: "_3YEZNOdnbC"
};
const $577929e8e464be32$var$PreviewHeader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { isCreated: isCreated, primaryDraftWorkItem: primaryDraftWorkItem } = t0;
    let t1;
    if ($[0] !== isCreated || $[1] !== primaryDraftWorkItem) {
        t1 = isCreated && primaryDraftWorkItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $577929e8e464be32$var$styles.issueKeyContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "regular",
            color: "color.text.subtlest",
            maxLines: 1
        }, primaryDraftWorkItem.createdIssueKey ?? "")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium",
            color: "color.text",
            maxLines: 1
        }, primaryDraftWorkItem.summary)) : (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $577929e8e464be32$var$messages.previewHeaderTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $577929e8e464be32$var$messages.previewHeaderTitle));
        $[0] = isCreated;
        $[1] = primaryDraftWorkItem;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ isCreated: isCreated, primaryDraftWorkItem: primaryDraftWorkItem })=>{
    return isCreated && primaryDraftWorkItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $577929e8e464be32$var$styles.issueKeyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "regular",
        color: "color.text.subtlest",
        maxLines: 1
    }, primaryDraftWorkItem.createdIssueKey ?? '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        color: "color.text",
        maxLines: 1
    }, primaryDraftWorkItem.summary)) : (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
        fireExperimentExposure: false
    }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h3",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $577929e8e464be32$var$messages.previewHeaderTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $577929e8e464be32$var$messages.previewHeaderTitle));
};
const $577929e8e464be32$export$916572e9a4d6d05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { cloudId: cloudId, queryRef: queryRef, isSelected: isSelected, isEnabled: isEnabled, isCreated: isCreated, draftWorkItems: draftWorkItems, previewFooterActions: previewFooterActions, onFieldChange: onFieldChange, openWorkItemView: openWorkItemView, isStagingArea: isStagingArea, messageId: messageId, onProjectChange: onProjectChange, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const cardRef = (0, $6SsN4.useFragment)((0, $iudWS.default), queryRef);
    const projectKey = cardRef?.jira_projectByIdOrKey?.key;
    const primaryDraftWorkItem = draftWorkItems[0];
    let t1;
    if ($[0] !== isCreated || $[1] !== openWorkItemView || $[2] !== primaryDraftWorkItem?.createdIssueKey) {
        t1 = ()=>{
            const createdIssueKey = isCreated ? primaryDraftWorkItem?.createdIssueKey : undefined;
            if (createdIssueKey) openWorkItemView(createdIssueKey);
        };
        $[0] = isCreated;
        $[1] = openWorkItemView;
        $[2] = primaryDraftWorkItem?.createdIssueKey;
        $[3] = t1;
    } else t1 = $[3];
    const onCardClick = t1;
    if (!projectKey) return null;
    const hideFooterActions = isSelected || !isEnabled || isCreated;
    const t2 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
        fireExperimentExposure: false
    }) ? "" : "Work item";
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: t2
        });
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isCreated || $[7] !== primaryDraftWorkItem) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($577929e8e464be32$var$PreviewHeader, {
            isCreated: isCreated,
            primaryDraftWorkItem: primaryDraftWorkItem
        });
        $[6] = isCreated;
        $[7] = primaryDraftWorkItem;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== cardRef?.jira_projectByIdOrKey || $[10] !== cloudId || $[11] !== isCreated || $[12] !== isEnabled || $[13] !== isStagingArea || $[14] !== messageId || $[15] !== onFieldChange || $[16] !== onProjectChange || $[17] !== primaryDraftWorkItem || $[18] !== projectKey || $[19] !== sendAifcAnalyticsEvent) {
        t5 = primaryDraftWorkItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IcZo.PreviewContent), {
            key: messageId,
            cloudId: cloudId,
            project: cardRef?.jira_projectByIdOrKey,
            workItem: primaryDraftWorkItem,
            projectKey: projectKey,
            onFieldChange: onFieldChange,
            isEditable: !!isEnabled,
            isCreated: isCreated,
            isStagingArea: isStagingArea,
            onProjectChange: onProjectChange,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }) : null;
        $[9] = cardRef?.jira_projectByIdOrKey;
        $[10] = cloudId;
        $[11] = isCreated;
        $[12] = isEnabled;
        $[13] = isStagingArea;
        $[14] = messageId;
        $[15] = onFieldChange;
        $[16] = onProjectChange;
        $[17] = primaryDraftWorkItem;
        $[18] = projectKey;
        $[19] = sendAifcAnalyticsEvent;
        $[20] = t5;
    } else t5 = $[20];
    const t6 = hideFooterActions ? null : previewFooterActions;
    let t7;
    if ($[21] !== isCreated || $[22] !== isEnabled || $[23] !== isSelected || $[24] !== onCardClick || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
            testId: "conversation-assistant-preview-card.jira-single-work-item-preview-card",
            previewProductLogo: t3,
            isSelected: isSelected,
            isEnabled: isEnabled,
            isCreated: isCreated,
            previewHeaderTitle: t4,
            previewContent: t5,
            previewFooterActions: t6,
            onCardClick: onCardClick,
            isSingleWorkItem: true
        });
        $[21] = isCreated;
        $[22] = isEnabled;
        $[23] = isSelected;
        $[24] = onCardClick;
        $[25] = t3;
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
    } else t7 = $[29];
    return t7;
} : ({ cloudId: cloudId, queryRef: queryRef, isSelected: isSelected, isEnabled: isEnabled, isCreated: isCreated, draftWorkItems: draftWorkItems, previewFooterActions: previewFooterActions, onFieldChange: onFieldChange, openWorkItemView: openWorkItemView, isStagingArea: isStagingArea, messageId: messageId, onProjectChange: onProjectChange, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const cardRef = (0, $6SsN4.useFragment)((0, $iudWS.default), queryRef);
    const projectKey = cardRef?.jira_projectByIdOrKey?.key;
    const primaryDraftWorkItem = draftWorkItems[0];
    const onCardClick = (0, $cozmU.useCallback)(()=>{
        const createdIssueKey = isCreated ? primaryDraftWorkItem?.createdIssueKey : undefined;
        if (createdIssueKey) openWorkItemView(createdIssueKey);
    }, [
        isCreated,
        openWorkItemView,
        primaryDraftWorkItem
    ]);
    if (!projectKey) return null;
    const hideFooterActions = isSelected || !isEnabled || isCreated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
        testId: "conversation-assistant-preview-card.jira-single-work-item-preview-card",
        previewProductLogo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? '' : 'Work item'
        }),
        isSelected: isSelected,
        isEnabled: isEnabled,
        isCreated: isCreated,
        previewHeaderTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($577929e8e464be32$var$PreviewHeader, {
            isCreated: isCreated,
            primaryDraftWorkItem: primaryDraftWorkItem
        }),
        previewContent: primaryDraftWorkItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IcZo.PreviewContent), {
            key: messageId,
            cloudId: cloudId,
            project: cardRef?.jira_projectByIdOrKey,
            workItem: primaryDraftWorkItem,
            projectKey: projectKey,
            onFieldChange: onFieldChange,
            isEditable: !!isEnabled,
            isCreated: isCreated,
            isStagingArea: isStagingArea,
            onProjectChange: onProjectChange,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }) : null,
        previewFooterActions: hideFooterActions ? null : previewFooterActions,
        onCardClick: onCardClick,
        isSingleWorkItem: true
    });
};
module.exports["JiraSingleWorkItemPreviewCard"] = $577929e8e464be32$export$916572e9a4d6d05;

});

parcelRegister("hTDfT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jR0Nw = parcelRequire("jR0Nw");


var $4MASx = parcelRequire("4MASx");


var $iEl0d = parcelRequire("iEl0d");


var $gQAiI = parcelRequire("gQAiI");


var $9XT2p = parcelRequire("9XT2p");

const $df10a9baf7e03c05$export$e0d4d1a33aca306e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { actions: actions, invokedActions: invokedActions, children: children, resolveActions: resolveActions } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [dismissedInvocationIds, setDismissedInvocationIds] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[1] = t2;
    } else t2 = $[1];
    const [invocationIdToCreatedIssueKey, setInvocationIdToCreatedIssueKey] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[2] !== actions || $[3] !== dismissedInvocationIds || $[4] !== invocationIdToCreatedIssueKey) {
        bb0: {
            if (Object.keys(invocationIdToCreatedIssueKey).length === 0 && dismissedInvocationIds.length === 0) {
                t3 = actions;
                break bb0;
            }
            const actionsToResolve = dismissedInvocationIds.length > 0 ? actions.map((action)=>({
                    ...action,
                    status: dismissedInvocationIds.includes(action.invocationId) ? (0, $9XT2p.MESSAGE_ACTION_INVOCATION_STATUSES).cancelled : action.status
                })) : actions;
            if (Object.keys(invocationIdToCreatedIssueKey).length === 0) {
                t3 = actionsToResolve;
                break bb0;
            }
            const newActions = [];
            actionsToResolve.forEach((action_0)=>{
                const createdIssueKey = invocationIdToCreatedIssueKey[action_0.invocationId];
                if (createdIssueKey) newActions.push({
                    ...action_0,
                    executedData: {
                        createdIssueKey: createdIssueKey
                    }
                });
            });
            t3 = newActions;
        }
        $[2] = actions;
        $[3] = dismissedInvocationIds;
        $[4] = invocationIdToCreatedIssueKey;
        $[5] = t3;
    } else t3 = $[5];
    const mappedActions = t3;
    const actionKey = mappedActions[0]?.key;
    let t4;
    if ($[6] !== actionKey || $[7] !== actions || $[8] !== invokedActions || $[9] !== resolveActions) {
        t4 = (on)=>{
            on((0, $iEl0d.JiraCreatedItemsCommand), (t5)=>{
                const { invocationIdToCreatedIssueKey: invocationIdsMap } = t5;
                setInvocationIdToCreatedIssueKey(invocationIdsMap);
            });
            on((0, $gQAiI.JiraDeclineItemCommand), (t6)=>{
                const { invocationId: invocationId } = t6;
                const workItemsToDecline = [
                    invocationId
                ];
                const summary = actions.find((action_1)=>action_1.invocationId === invocationId)?.data?.summary;
                actions.forEach((action_2)=>{
                    if (action_2.invocationId !== invocationId && action_2.status === (0, $9XT2p.MESSAGE_ACTION_INVOCATION_STATUSES).planned && !Object.keys(invokedActions ?? {}).includes(action_2.invocationId) && action_2.data?.fields?.parent === summary) workItemsToDecline.push(action_2.invocationId);
                });
                resolveActions(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, workItemsToDecline);
                setDismissedInvocationIds((prev)=>[
                        ...prev,
                        ...workItemsToDecline
                    ]);
            });
        };
        $[6] = actionKey;
        $[7] = actions;
        $[8] = invokedActions;
        $[9] = resolveActions;
        $[10] = t4;
    } else t4 = $[10];
    const setupHandler = t4;
    let t5;
    if ($[11] !== setupHandler) {
        t5 = {
            clientId: (0, $4MASx.JIRA_PREVIEW_CARD_CLIENT_ID),
            setupHandler: setupHandler
        };
        $[11] = setupHandler;
        $[12] = t5;
    } else t5 = $[12];
    (0, $jR0Nw.useRovoBridgeAPI)(t5);
    let t6;
    if ($[13] !== children || $[14] !== mappedActions) {
        t6 = children({
            actions: mappedActions
        });
        $[13] = children;
        $[14] = mappedActions;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6);
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ actions: actions, invokedActions: invokedActions, children: children, resolveActions: resolveActions })=>{
    // TODO: CRCS-4527 After resolveActions is called (e.g., on cancel), the parent's actions prop
    // may not update immediately on the next render. We should fix this.
    // dismissedInvocationIds is used as a workaround to optimistically reflect cancelled
    const [dismissedInvocationIds, setDismissedInvocationIds] = (0, $cozmU.useState)([]);
    const [invocationIdToCreatedIssueKey, setInvocationIdToCreatedIssueKey] = (0, $cozmU.useState)({});
    const mappedActions = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (Object.keys(invocationIdToCreatedIssueKey).length === 0 && dismissedInvocationIds.length === 0) return actions;
        const actionsToResolve = dismissedInvocationIds.length > 0 ? actions.map((action)=>({
                ...action,
                status: dismissedInvocationIds.includes(action.invocationId) ? (0, $9XT2p.MESSAGE_ACTION_INVOCATION_STATUSES).cancelled : action.status
            })) : actions;
        if (Object.keys(invocationIdToCreatedIssueKey).length === 0) return actionsToResolve;
        const newActions = [];
        actionsToResolve.forEach((action_0)=>{
            const createdIssueKey = invocationIdToCreatedIssueKey[action_0.invocationId];
            if (createdIssueKey) newActions.push({
                ...action_0,
                executedData: {
                    createdIssueKey: createdIssueKey
                }
            });
        });
        return newActions;
    }, [
        actions,
        invocationIdToCreatedIssueKey,
        dismissedInvocationIds
    ]);
    const actionKey = mappedActions[0]?.key;
    const setupHandler = (0, $cozmU.useCallback)((on)=>{
        on((0, $iEl0d.JiraCreatedItemsCommand), ({ invocationIdToCreatedIssueKey: invocationIdsMap })=>{
            setInvocationIdToCreatedIssueKey(invocationIdsMap);
        });
        on((0, $gQAiI.JiraDeclineItemCommand), ({ invocationId: invocationId })=>{
            const workItemsToDecline = [
                invocationId
            ];
            const summary = // eslint-disable-next-line @typescript-eslint/no-explicit-any
            actions.find((action_1)=>action_1.invocationId === invocationId)?.data?.summary;
            actions.forEach((action_2)=>{
                if (action_2.invocationId !== invocationId && action_2.status === (0, $9XT2p.MESSAGE_ACTION_INVOCATION_STATUSES).planned && !Object.keys(invokedActions ?? {}).includes(action_2.invocationId) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
                action_2.data?.fields?.parent === summary) workItemsToDecline.push(action_2.invocationId);
            });
            resolveActions(actionKey, (0, $9XT2p.MESSAGE_ACTION_RESOLUTIONS).cancel, workItemsToDecline);
            setDismissedInvocationIds((prev)=>[
                    ...prev,
                    ...workItemsToDecline
                ]);
        });
    }, [
        actionKey,
        actions,
        invokedActions,
        resolveActions
    ]);
    (0, $jR0Nw.useRovoBridgeAPI)({
        clientId: (0, $4MASx.JIRA_PREVIEW_CARD_CLIENT_ID),
        setupHandler: setupHandler
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        actions: mappedActions
    }));
};
const $df10a9baf7e03c05$export$ebed16d1abc5439d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ModalSyncBridgeAPI(t0) {
    const $ = (0, $bDgLe.c)(18);
    let actions;
    let children;
    let invokedActions;
    let isLastMessage;
    let props;
    if ($[0] !== t0) {
        ({ actions: actions, invokedActions: invokedActions, children: children, isLastMessage: isLastMessage, ...props } = t0);
        $[0] = t0;
        $[1] = actions;
        $[2] = children;
        $[3] = invokedActions;
        $[4] = isLastMessage;
        $[5] = props;
    } else {
        actions = $[1];
        children = $[2];
        invokedActions = $[3];
        isLastMessage = $[4];
        props = $[5];
    }
    if (!isLastMessage) {
        let t1;
        if ($[6] !== actions || $[7] !== children) {
            t1 = children({
                actions: actions
            });
            $[6] = actions;
            $[7] = children;
            $[8] = t1;
        } else t1 = $[8];
        let t2;
        if ($[9] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
            $[9] = t1;
            $[10] = t2;
        } else t2 = $[10];
        return t2;
    }
    let t1;
    if ($[11] !== children) {
        t1 = (t2)=>{
            const { actions: mappedActions } = t2;
            return children({
                actions: mappedActions
            });
        };
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    let t2;
    if ($[13] !== actions || $[14] !== invokedActions || $[15] !== props || $[16] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df10a9baf7e03c05$export$e0d4d1a33aca306e, {
            actions: actions,
            invokedActions: invokedActions,
            ...props
        }, t1);
        $[13] = actions;
        $[14] = invokedActions;
        $[15] = props;
        $[16] = t1;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : function ModalSyncBridgeAPI({ actions: actions, invokedActions: invokedActions, children: children, isLastMessage: isLastMessage, ...props }) {
    if (!isLastMessage) // If the message is not the last one with Jira creatable actions,
    // we can skip rendering the bridge and just return the children with the original actions.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        actions: actions
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df10a9baf7e03c05$export$e0d4d1a33aca306e, {
        actions: actions,
        invokedActions: invokedActions,
        ...props
    }, ({ actions: mappedActions })=>children({
            actions: mappedActions
        }));
};
module.exports["ModalSyncBridgeAPI"] = $df10a9baf7e03c05$export$ebed16d1abc5439d;

});

parcelRegister("h8IcZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $8dMxJ = parcelRequire("8dMxJ");

const $e2e2674405a993c2$var$styles = {
    staticScribble: "_0bjKvDcjp5 _3iDTPbccYA _0hPCNLDIqT _0KLXru98eZ _0jFU0VMmFU _3v5uP0hPpI _1RrJLit2nV",
    scribbleContainer: "_1UtDYzy7kJ _1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _0jFU0VMmFU _3v5uP0hPpI _1RrJLit2nV _0wOv4Q18ZR",
    scribbleSvg: "_49OCfRPgdg _4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _1pp6NdYbGa"
};
const $e2e2674405a993c2$var$EFFECTIVE_STROKE_WIDTH = Math.max(20 * (0, $8dMxJ.PARAMS).strokeWidth, 6); // 8px
const $e2e2674405a993c2$var$REFERENCE_LINE_HEIGHT = 20; // px — baseline for strokeCount scaling
/**
 * Generates cubic-bezier SVG path strings covering the span area.
 * Odd-indexed strokes are reversed (right→left) to produce a back-and-forth pen motion.
 */ function $e2e2674405a993c2$var$generateStrokes(width, height) {
    const spreadStart = height * (1 - (0, $8dMxJ.PARAMS).spread) / 2;
    const spreadHeight = height * (0, $8dMxJ.PARAMS).spread;
    const count = Math.max(Math.round((0, $8dMxJ.PARAMS).strokeCount * (height / $e2e2674405a993c2$var$REFERENCE_LINE_HEIGHT)), 1);
    return Array.from({
        length: count
    }, (_, i)=>{
        const t = count === 1 ? 0.5 : i / (count - 1);
        const yBase = spreadStart + t * spreadHeight;
        const jitterOffset = (Math.random() * 2 - 1) * (0, $8dMxJ.PARAMS).jitter;
        const y = Math.max(spreadStart, Math.min(spreadStart + spreadHeight, yBase + jitterOffset));
        const cx1y = y + (Math.random() * 2 - 1) * (0, $8dMxJ.PARAMS).wiggle;
        const cx2y = y + (Math.random() * 2 - 1) * (0, $8dMxJ.PARAMS).wiggle; // Alternate direction: even strokes go left→right, odd strokes go right→left.
        const leftToRight = i % 2 === 0;
        const x0 = leftToRight ? 0 : width;
        const x3 = leftToRight ? width : 0;
        const cx1x = leftToRight ? width * 0.3 + (Math.random() - 0.5) * width * 0.15 : width * 0.7 + (Math.random() - 0.5) * width * 0.15;
        const cx2x = leftToRight ? width * 0.7 + (Math.random() - 0.5) * width * 0.15 : width * 0.3 + (Math.random() - 0.5) * width * 0.15;
        return `M ${x0.toFixed(2)} ${y.toFixed(2)} C ${cx1x.toFixed(2)} ${cx1y.toFixed(2)} ${cx2x.toFixed(2)} ${cx2y.toFixed(2)} ${x3.toFixed(2)} ${y.toFixed(2)}`;
    });
} /**
   * Handles container measurement and stroke animation for a single scribble span.
   * Returns refs for the container and path elements alongside the derived path data and dimensions.
   */ 
const $e2e2674405a993c2$var$useScribbleAnimation = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScribbleAnimation(activationDelay) {
    const $ = (0, $bDgLe.c)(15);
    const containerRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const pathRefs = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[1] = t1;
    } else t1 = $[1];
    const [pathData, setPathData] = (0, $cozmU.useState)(t1);
    const [svgDims, setSvgDims] = (0, $cozmU.useState)(null);
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const el = containerRef.current;
            if (!el) return;
            const rafId = requestAnimationFrame(()=>{
                const { width: width, height: height } = el.getBoundingClientRect();
                const w = width || el.offsetWidth;
                const h = height || el.offsetHeight;
                if (w > 0 && h > 0) {
                    setSvgDims({
                        w: w,
                        h: h
                    });
                    setPathData($e2e2674405a993c2$var$generateStrokes(w, h));
                }
            });
            return ()=>cancelAnimationFrame(rafId);
        };
        t3 = [];
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] !== activationDelay || $[5] !== pathData.length || $[6] !== svgDims) {
        t4 = ()=>{
            if (!pathData.length || !svgDims) return;
            let setRafId;
            let animRafId;
            let timerId;
            setRafId = requestAnimationFrame(()=>{
                const paths = pathRefs.current.filter($e2e2674405a993c2$var$_temp);
                if (!paths.length) return;
                const lengths = paths.map($e2e2674405a993c2$var$_temp2);
                paths.forEach((p_1, i)=>{
                    p_1.style.strokeDasharray = String(lengths[i]);
                    p_1.style.strokeDashoffset = String(lengths[i]);
                });
                timerId = setTimeout(()=>{
                    const strokeDuration = (0, $8dMxJ.PARAMS).duration / paths.length;
                    const startTime = performance.now();
                    const tick = (now)=>{
                        const elapsed = now - startTime;
                        let stillAnimating = false;
                        paths.forEach((p_2, i_0)=>{
                            const strokeStart = i_0 * strokeDuration;
                            const strokeElapsed = elapsed - strokeStart;
                            if (strokeElapsed < 0) {
                                p_2.style.strokeDashoffset = String(lengths[i_0]);
                                stillAnimating = true;
                            } else if (strokeElapsed >= strokeDuration) p_2.style.strokeDashoffset = "0";
                            else {
                                const t = strokeElapsed / strokeDuration;
                                const progress = 1 - (1 - t) ** 2;
                                p_2.style.strokeDashoffset = String(lengths[i_0] * (1 - progress));
                                stillAnimating = true;
                            }
                        });
                        if (stillAnimating) animRafId = requestAnimationFrame(tick);
                    };
                    animRafId = requestAnimationFrame(tick);
                }, activationDelay);
            });
            return ()=>{
                cancelAnimationFrame(setRafId);
                clearTimeout(timerId);
                cancelAnimationFrame(animRafId);
            };
        };
        $[4] = activationDelay;
        $[5] = pathData.length;
        $[6] = svgDims;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== activationDelay || $[9] !== pathData || $[10] !== svgDims) {
        t5 = [
            pathData,
            svgDims,
            activationDelay
        ];
        $[8] = activationDelay;
        $[9] = pathData;
        $[10] = svgDims;
        $[11] = t5;
    } else t5 = $[11];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[12] !== pathData || $[13] !== svgDims) {
        t6 = {
            containerRef: containerRef,
            pathRefs: pathRefs,
            pathData: pathData,
            svgDims: svgDims
        };
        $[12] = pathData;
        $[13] = svgDims;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : function useScribbleAnimation(activationDelay) {
    const containerRef = (0, $cozmU.useRef)(null);
    const pathRefs = (0, $cozmU.useRef)([]);
    const [pathData, setPathData] = (0, $cozmU.useState)([]);
    const [svgDims, setSvgDims] = (0, $cozmU.useState)(null); // Measure the container and generate stroke paths after first paint.
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const rafId = requestAnimationFrame(()=>{
            const { width: width, height: height } = el.getBoundingClientRect();
            const w = width || el.offsetWidth;
            const h = height || el.offsetHeight;
            if (w > 0 && h > 0) {
                setSvgDims({
                    w: w,
                    h: h
                });
                setPathData($e2e2674405a993c2$var$generateStrokes(w, h));
            }
        });
        return ()=>cancelAnimationFrame(rafId);
    }, []); // Animate strokes via strokeDashoffset once paths are in the DOM.
    (0, $cozmU.useEffect)(()=>{
        if (!pathData.length || !svgDims) return;
        let setRafId;
        let animRafId;
        let timerId; // One rAF to let React flush the new <path> elements to the DOM.
        setRafId = requestAnimationFrame(()=>{
            const paths = pathRefs.current.filter((p)=>p !== null);
            if (!paths.length) return;
             // Cache path lengths and initialise to fully hidden.
            const lengths = paths.map((p_0)=>p_0.getTotalLength());
            paths.forEach((p_1, i)=>{
                p_1.style.strokeDasharray = String(lengths[i]);
                p_1.style.strokeDashoffset = String(lengths[i]);
            });
            timerId = setTimeout(()=>{
                // Each stroke draws sequentially — one at a time, like a pen scribbling.
                const strokeDuration = (0, $8dMxJ.PARAMS).duration / paths.length;
                const startTime = performance.now();
                const tick = (now)=>{
                    const elapsed = now - startTime;
                    let stillAnimating = false;
                    paths.forEach((p_2, i_0)=>{
                        const strokeStart = i_0 * strokeDuration;
                        const strokeElapsed = elapsed - strokeStart;
                        if (strokeElapsed < 0) {
                            // Not yet started — keep hidden.
                            p_2.style.strokeDashoffset = String(lengths[i_0]);
                            stillAnimating = true;
                        } else if (strokeElapsed >= strokeDuration) // Finished — fully drawn.
                        p_2.style.strokeDashoffset = '0';
                        else {
                            // Actively drawing — ease-out quadratic: progress = 1 - (1 - t)²
                            const t = strokeElapsed / strokeDuration;
                            const progress = 1 - (1 - t) ** 2;
                            p_2.style.strokeDashoffset = String(lengths[i_0] * (1 - progress));
                            stillAnimating = true;
                        }
                    });
                    if (stillAnimating) animRafId = requestAnimationFrame(tick);
                };
                animRafId = requestAnimationFrame(tick);
            }, activationDelay);
        });
        return ()=>{
            cancelAnimationFrame(setRafId); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            clearTimeout(timerId); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            cancelAnimationFrame(animRafId);
        };
    }, [
        pathData,
        svgDims,
        activationDelay
    ]);
    return {
        containerRef: containerRef,
        pathRefs: pathRefs,
        pathData: pathData,
        svgDims: svgDims
    };
};
function $e2e2674405a993c2$var$_temp2(p_0) {
    return p_0.getTotalLength();
}
function $e2e2674405a993c2$var$_temp(p) {
    return p !== null;
}
const $e2e2674405a993c2$var$ScribbleOverlay = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { pathData: pathData, svgDims: svgDims, pathRefs: pathRefs } = t0;
    const t1 = svgDims.w;
    const t2 = svgDims.h;
    const t3 = `0 0 ${svgDims.w} ${svgDims.h}`;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $e2e2674405a993c2$var$styles.scribbleSvg
        ]);
        $[0] = t4;
    } else t4 = $[0];
    let t5;
    if ($[1] !== pathData || $[2] !== pathRefs) {
        let t6;
        if ($[4] !== pathRefs) {
            t6 = (d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
                    key: i,
                    ref: (el)=>{
                        pathRefs.current[i] = el;
                    },
                    d: d,
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    style: {
                        strokeWidth: $e2e2674405a993c2$var$EFFECTIVE_STROKE_WIDTH
                    }
                });
            $[4] = pathRefs;
            $[5] = t6;
        } else t6 = $[5];
        t5 = pathData.map(t6);
        $[1] = pathData;
        $[2] = pathRefs;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[6] !== svgDims.h || $[7] !== svgDims.w || $[8] !== t3 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: t3,
            "aria-hidden": true,
            className: t4
        }, t5);
        $[6] = svgDims.h;
        $[7] = svgDims.w;
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ pathData: pathData, svgDims: svgDims, pathRefs: pathRefs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: svgDims.w,
        height: svgDims.h,
        viewBox: `0 0 ${svgDims.w} ${svgDims.h}`,
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $e2e2674405a993c2$var$styles.scribbleSvg
        ])
    }, pathData.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            key: i,
            ref: (el)=>{
                pathRefs.current[i] = el;
            },
            d: d,
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            style: {
                strokeWidth: $e2e2674405a993c2$var$EFFECTIVE_STROKE_WIDTH
            }
        })));
const $e2e2674405a993c2$var$ScribbleSpan = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { ariaLabel: ariaLabel, activationDelay: activationDelay } = t0;
    const { containerRef: containerRef, pathRefs: pathRefs, pathData: pathData, svgDims: svgDims } = $e2e2674405a993c2$var$useScribbleAnimation(activationDelay);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $e2e2674405a993c2$var$styles.scribbleContainer
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== pathData || $[2] !== pathRefs || $[3] !== svgDims) {
        t2 = svgDims && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2e2674405a993c2$var$ScribbleOverlay, {
            pathData: pathData,
            svgDims: svgDims,
            pathRefs: pathRefs
        });
        $[1] = pathData;
        $[2] = pathRefs;
        $[3] = svgDims;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== ariaLabel || $[6] !== containerRef || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: containerRef,
            role: "img",
            "aria-label": ariaLabel,
            className: t1
        }, t2);
        $[5] = ariaLabel;
        $[6] = containerRef;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ ariaLabel: ariaLabel, activationDelay: activationDelay })=>{
    const { containerRef: containerRef, pathRefs: pathRefs, pathData: pathData, svgDims: svgDims } = $e2e2674405a993c2$var$useScribbleAnimation(activationDelay);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: containerRef,
        role: "img",
        "aria-label": ariaLabel,
        className: (0, $hekY6.default)([
            $e2e2674405a993c2$var$styles.scribbleContainer
        ])
    }, svgDims && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2e2674405a993c2$var$ScribbleOverlay, {
        pathData: pathData,
        svgDims: svgDims,
        pathRefs: pathRefs
    }));
};
const $e2e2674405a993c2$var$StaticScribble = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] !== ariaLabel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e2e2674405a993c2$var$styles.staticScribble,
            role: "img",
            "aria-label": ariaLabel
        });
        $[0] = ariaLabel;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e2e2674405a993c2$var$styles.staticScribble,
        role: "img",
        "aria-label": ariaLabel
    });
const $e2e2674405a993c2$export$6bd7b5cb580806a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { ariaLabel: ariaLabel, delay: delay } = t0;
    let t1;
    if ($[0] !== ariaLabel || $[1] !== delay) {
        t1 = (0, $iDrrr.fg)("rovo-guard-redaction-scribble-animation") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2e2674405a993c2$var$ScribbleSpan, {
            ariaLabel: ariaLabel,
            activationDelay: delay
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2e2674405a993c2$var$StaticScribble, {
            ariaLabel: ariaLabel
        });
        $[0] = ariaLabel;
        $[1] = delay;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ ariaLabel: ariaLabel, delay: delay })=>(0, $iDrrr.fg)('rovo-guard-redaction-scribble-animation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2e2674405a993c2$var$ScribbleSpan, {
        ariaLabel: ariaLabel,
        activationDelay: delay
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2e2674405a993c2$var$StaticScribble, {
        ariaLabel: ariaLabel
    });
module.exports["RedactedToken"] = $e2e2674405a993c2$export$6bd7b5cb580806a2;

});

parcelRegister("3UaYh", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");


var $1njGe = parcelRequire("1njGe");

const $837b41b592905bbd$export$6ae41726a4a732f9 = (storeAssistant)=>{
    const message = storeAssistant.content.message.message;
    const backendAgentId = (0, $2yWJZ.trimToUndefined)(message.agent_author?.id);
    const authorId = (0, $2yWJZ.trimToUndefined)(message.author?.id);
    const authorNamedId = (0, $2yWJZ.trimToUndefined)(message.author?.external_config_reference ?? message.author?.named_id);
    if ((0, $2yWJZ.isDefaultRovoChat)({
        agentId: backendAgentId
    }) || backendAgentId === undefined && (0, $2yWJZ.isDefaultRovoChat)({
        agentId: authorId
    })) return {
        isDefault: true
    };
    // The backend agent author is authoritative when present. Treat the value as a
    // single routing token so a specialist UUID cannot be combined with a legacy
    // default named id from the display author.
    if (backendAgentId) return {
        id: backendAgentId,
        isDefault: false
    };
    const namedId = (0, $1njGe.normalizeIdentityValue)(authorNamedId);
    return {
        namedId: namedId,
        isDefault: !namedId
    };
};
module.exports["deriveResponseAuthorIdentity"] = $837b41b592905bbd$export$6ae41726a4a732f9;

});

parcelRegister("5zEJP", function(module, exports) {

var $2LKLB = parcelRequire("2LKLB");


var $ay0f3 = parcelRequire("ay0f3");

const $e33db918ab9297f9$var$getNonEmptyString = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $e33db918ab9297f9$export$241db868cb15605c = ({ shouldEnableAgentResponseHat: shouldEnableAgentResponseHat, canRenderAfterThinking: canRenderAfterThinking, currentResponseAuthor: currentResponseAuthor, previousAssistantAuthor: previousAssistantAuthor, responseAuthorAgent: responseAuthorAgent, backendAuthorIdentityAccountId: backendAuthorIdentityAccountId, isConversationActivelyGenerating: isConversationActivelyGenerating, streamingComplete: streamingComplete, hasAnswerContent: hasAnswerContent })=>{
    const isDefaultRovo = currentResponseAuthor.isDefault;
    // The by-agent-id lookup is only trustworthy if it actually resolved to THIS author.
    const responseAuthorAgentIdentityAccountId = (0, $2LKLB.agentMatchesAuthor)(responseAuthorAgent, currentResponseAuthor) ? $e33db918ab9297f9$var$getNonEmptyString(responseAuthorAgent?.identity_account_id) : undefined;
    // Default authors never carry a specialist identity account id.
    const authorIdentityAccountId = isDefaultRovo ? undefined : $e33db918ab9297f9$var$getNonEmptyString(backendAuthorIdentityAccountId);
    // Author's own identity wins over the lookup so the submit-time snapshot is used immediately.
    const agentIdentityAccountId = authorIdentityAccountId ?? responseAuthorAgentIdentityAccountId;
    // Deliberately scoped to the in-flight turn (not the FINAL_RESPONSE metric window), because
    // the answer streams as author-less ANSWER_PART events before `streamingComplete`.
    const isResponseStreamingActive = isConversationActivelyGenerating && !streamingComplete;
    const shouldReservePreAnswerSkeleton = isResponseStreamingActive && !hasAnswerContent;
    const isIdentityHydrating = !isDefaultRovo && Boolean(currentResponseAuthor.id) && isResponseStreamingActive && (!agentIdentityAccountId || shouldReservePreAnswerSkeleton);
    const hasCurrentResponseAuthorIdentity = Boolean(currentResponseAuthor.id || agentIdentityAccountId);
    const canDisplayCurrentResponseAuthor = isDefaultRovo || hasCurrentResponseAuthorIdentity;
    const hasMeaningfulAuthorTransition = (0, $ay0f3.shouldShowAgentResponseHat)({
        currentAuthor: currentResponseAuthor,
        previousAuthor: previousAssistantAuthor
    });
    // Reserve the hat before the first ANSWER_PART when a turn is already actively
    // generating. The thinking indicator's explicit handoff can lag until/after text
    // starts streaming; waiting for it lets the response text render first and then
    // jump downward when the hat appears.
    const hasResponseHatHandoff = canRenderAfterThinking;
    const shouldRenderAgentResponseHat = shouldEnableAgentResponseHat && hasResponseHatHandoff && canDisplayCurrentResponseAuthor && hasMeaningfulAuthorTransition;
    return {
        shouldRenderAgentResponseHat: shouldRenderAgentResponseHat,
        isDefaultRovo: isDefaultRovo,
        agentIdentityAccountId: agentIdentityAccountId,
        isIdentityHydrating: isIdentityHydrating
    };
};
module.exports["getResponseHatRenderState"] = $e33db918ab9297f9$export$241db868cb15605c;

});

parcelRegister("lTupu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bjY3F = parcelRequire("bjY3F");


var $jCmJN = parcelRequire("jCmJN");


var $9KnlJ = parcelRequire("9KnlJ");

const $dc1912a17518af52$var$messages = (0, $kSwu1.defineMessages)({
    creationErrorCustomTitle: {
        id: "jira-create-work-items.error-flag.custom-title",
        defaultMessage: "Couldn't create these work items due to {errorCount, plural, one {an error:} other {these errors:}}"
    },
    creationErrorDescription: {
        id: "jira-create-work-items.error-flag.description",
        defaultMessage: "We're having some trouble creating these work items. Refresh the page and try again."
    }
});
const $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY = 'jira-atlassian-work-item-create-all-field-types';
// Type predicate to safely check if an unknown value is a parent field with a string id.
// Needed because fields is Record<string, unknown> and fields.parent is unknown at runtime.
const $dc1912a17518af52$var$isParentField = (value)=>typeof value === 'object' && value !== null && 'id' in value && typeof value.id === 'string';
// Util to convert a string to sentence case
const $dc1912a17518af52$var$toSentenceCase = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $dc1912a17518af52$export$8992417dff99996e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { cloudId: cloudId, isStagingArea: isStagingArea, entryPoint: entryPoint, interactionModeExecuted: interactionModeExecuted } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    let t1;
    if ($[0] !== interactionModeExecuted) {
        t1 = interactionModeExecuted && {
            interactionModeExecuted: interactionModeExecuted
        };
        $[0] = interactionModeExecuted;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== entryPoint) {
        t2 = entryPoint && {
            entryPoint: entryPoint
        };
        $[2] = entryPoint;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = {
            ...t1,
            ...t2
        };
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const interactionModeExecutedAttributes = t3;
    let t4;
    if ($[7] !== cloudId || $[8] !== experienceTracker || $[9] !== formatMessage || $[10] !== interactionModeExecutedAttributes || $[11] !== isStagingArea || $[12] !== trackAIMAUEvent) {
        t4 = async (t5)=>{
            const { draftWorkItems: draftWorkItems } = t5;
            if ((0, $iDrrr.fg)("jira-aifc-track-ufo-experiences")) experienceTracker.start({
                id: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
                name: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK
            });
            if ((0, $iDrrr.fg)("rovo_skills_work_item_reliability_ufo")) experienceTracker.start({
                id: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
                name: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
                attributes: {
                    isStagingArea: isStagingArea
                }
            });
            const createdIssueKeys = [];
            const createdIssueIds = [];
            const errors = new Set();
            let cloudUrl = "";
            const invocationIdToCreatedIssueKey = {};
            const parentSummaryToIssueIdMapping = {};
            const bulkParentResponse = await (0, $jCmJN.createIssuesInBulk)({
                draftWorkItems: draftWorkItems,
                cloudId: cloudId
            });
            if (bulkParentResponse.isSuccess) for (const [index, createdParent] of bulkParentResponse.createdIssues.entries()){
                parentSummaryToIssueIdMapping[draftWorkItems[index].summary] = createdParent.id;
                createdIssueKeys.push(createdParent.key);
                createdIssueIds.push(createdParent.id);
                const invocationId = draftWorkItems[index].invocationId;
                invocationIdToCreatedIssueKey[invocationId] = createdParent.key;
                cloudUrl = bulkParentResponse.cloudUrl;
            }
            else bulkParentResponse.errorMessages.forEach((errorMessage)=>errors.add(errorMessage));
            const childWorkItems = draftWorkItems.flatMap($dc1912a17518af52$var$_temp).map((childWorkItem)=>{
                const rawParent = childWorkItem.fields.parent;
                const parent = $dc1912a17518af52$var$isParentField(rawParent) ? rawParent : undefined;
                const parentId = parent?.id ? parentSummaryToIssueIdMapping[parent.id] ?? undefined : undefined;
                if (!parentId) {
                    const { parent: _omitted, ...fieldsWithoutParent } = childWorkItem.fields;
                    return {
                        ...childWorkItem,
                        fields: fieldsWithoutParent
                    };
                }
                return {
                    ...childWorkItem,
                    fields: {
                        ...childWorkItem.fields,
                        parent: {
                            id: parentId
                        }
                    }
                };
            });
            if (childWorkItems.length !== 0) {
                const bulkChildrenResponse = await (0, $jCmJN.createIssuesInBulk)({
                    draftWorkItems: childWorkItems,
                    cloudId: cloudId
                });
                if (bulkChildrenResponse.isSuccess) for (const [index_0, createdChild] of bulkChildrenResponse.createdIssues.entries()){
                    createdIssueKeys.push(createdChild.key);
                    createdIssueIds.push(createdChild.id);
                    const invocationId_0 = childWorkItems[index_0].invocationId;
                    invocationIdToCreatedIssueKey[invocationId_0] = createdChild.key;
                }
                else bulkChildrenResponse.errorMessages.forEach((errorMessage_0)=>errors.add(errorMessage_0));
            }
            const totalCount = (0, $9KnlJ.getNumberIssuesFromDraftWorkItems)(draftWorkItems);
            if (totalCount === createdIssueKeys.length) {
                trackAIMAUEvent({
                    type: "actioned",
                    actionResult: "success",
                    source: "JiraAIFC",
                    proactive: false,
                    userGenerated: true,
                    attributes: {
                        ...interactionModeExecutedAttributes,
                        successCount: createdIssueKeys.length,
                        failureCount: totalCount - createdIssueKeys.length,
                        totalCount: totalCount,
                        actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                        isSingleWorkItem: totalCount === 1,
                        isStagingArea: isStagingArea
                    }
                });
                trackAIMAUEvent({
                    type: "adopted",
                    source: "JiraAIFC",
                    proactive: false,
                    userGenerated: true,
                    actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                    rovoModifiedObjects: createdIssueIds?.map($dc1912a17518af52$var$_temp2),
                    attributes: interactionModeExecutedAttributes
                });
                if ((0, $iDrrr.fg)("jira-aifc-track-ufo-experiences")) experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK
                });
                if ((0, $iDrrr.fg)("rovo_skills_work_item_reliability_ufo")) experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
                    attributes: {
                        isSingleWorkItem: totalCount === 1,
                        isStagingArea: isStagingArea,
                        totalCount: totalCount
                    }
                });
            } else {
                const errorMessage_1 = errors.size > 0 ? $dc1912a17518af52$var$toSentenceCase(Array.from(errors).join(", ")) : formatMessage($dc1912a17518af52$var$messages.creationErrorDescription);
                trackAIMAUEvent({
                    type: "actioned",
                    actionResult: createdIssueKeys.length > 0 ? "partial-failure" : "failure",
                    source: "JiraAIFC",
                    proactive: false,
                    userGenerated: true,
                    attributes: {
                        ...interactionModeExecutedAttributes,
                        successCount: createdIssueKeys.length,
                        failureCount: totalCount - createdIssueKeys.length,
                        totalCount: totalCount,
                        actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                        isSingleWorkItem: totalCount === 1,
                        isStagingArea: isStagingArea
                    }
                });
                if (createdIssueIds.length > 0) trackAIMAUEvent({
                    type: "adopted",
                    source: "JiraAIFC",
                    proactive: false,
                    userGenerated: true,
                    actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                    rovoModifiedObjects: createdIssueIds?.map($dc1912a17518af52$var$_temp3),
                    attributes: interactionModeExecutedAttributes
                });
                trackAIMAUEvent({
                    type: "error",
                    proactive: false,
                    source: "JiraAIFC",
                    attributes: {
                        totalCount: totalCount,
                        successCount: createdIssueKeys.length,
                        failureCount: totalCount - createdIssueKeys.length,
                        actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                        isSingleWorkItem: totalCount === 1,
                        isStagingArea: isStagingArea,
                        ...interactionModeExecutedAttributes,
                        error: errorMessage_1
                    }
                });
                if ((0, $iDrrr.fg)("jira-aifc-track-ufo-experiences")) experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
                    error: new Error(errorMessage_1)
                });
                if ((0, $iDrrr.fg)("rovo_skills_work_item_reliability_ufo")) experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
                    error: new Error(errorMessage_1),
                    attributes: {
                        isSingleWorkItem: totalCount === 1,
                        isStagingArea: isStagingArea,
                        totalCount: totalCount
                    }
                });
                return {
                    isSuccess: false,
                    errorMessage: errorMessage_1
                };
            }
            return {
                isSuccess: true,
                createdIssueIds: createdIssueIds,
                invocationIdToCreatedIssueKey: invocationIdToCreatedIssueKey,
                cloudUrl: cloudUrl
            };
        };
        $[7] = cloudId;
        $[8] = experienceTracker;
        $[9] = formatMessage;
        $[10] = interactionModeExecutedAttributes;
        $[11] = isStagingArea;
        $[12] = trackAIMAUEvent;
        $[13] = t4;
    } else t4 = $[13];
    const createIssues = t4;
    let t5;
    if ($[14] !== createIssues) {
        t5 = {
            createIssues: createIssues
        };
        $[14] = createIssues;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ cloudId: cloudId, isStagingArea: isStagingArea, entryPoint: entryPoint, interactionModeExecuted: interactionModeExecuted })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { trackAIMAUEvent: trackAIMAUEvent } = (0, $Ou0Zz.useAnalytics)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const interactionModeExecutedAttributes = (0, $cozmU.useMemo)(()=>({
            ...interactionModeExecuted && {
                interactionModeExecuted: interactionModeExecuted
            },
            ...entryPoint && {
                entryPoint: entryPoint
            }
        }), [
        entryPoint,
        interactionModeExecuted
    ]);
    const createIssues = (0, $cozmU.useCallback)(async ({ draftWorkItems: draftWorkItems })=>{
        // A single experience spans both the parent and child bulk-create requests.
        if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker.start({
            id: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
            name: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK
        });
        // Customer-visible reliability experience for the Jira Rovo "create work
        // item" EXECUTION moment (RovoSkillsExecutionWorkItemCreate), feeding the
        // FY27 99.5% success-minutes KR (ATLAS-129636). Keyed to the real create
        // outcome the user sees. Both the in-chat create and the AIFC canvas /
        // staging-area create use this same skill, so both are tracked; the
        // `isStagingArea` attribute records which surface it came from so the two
        // can be sliced apart downstream.
        if ((0, $iDrrr.fg)('rovo_skills_work_item_reliability_ufo')) experienceTracker.start({
            id: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
            name: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
            attributes: {
                isStagingArea: isStagingArea
            }
        });
        const createdIssueKeys = [];
        const createdIssueIds = [];
        const errors = new Set();
        let cloudUrl = '';
        // Maintain a map of createdIssueKey to invocationId
        const invocationIdToCreatedIssueKey = {};
        // Create all the parent issues
        const parentSummaryToIssueIdMapping = {};
        const bulkParentResponse = await (0, $jCmJN.createIssuesInBulk)({
            draftWorkItems: draftWorkItems,
            cloudId: cloudId
        });
        if (bulkParentResponse.isSuccess) for (const [index, createdParent] of bulkParentResponse.createdIssues.entries()){
            parentSummaryToIssueIdMapping[draftWorkItems[index].summary] = createdParent.id;
            createdIssueKeys.push(createdParent.key);
            createdIssueIds.push(createdParent.id);
            const invocationId = draftWorkItems[index].invocationId;
            invocationIdToCreatedIssueKey[invocationId] = createdParent.key;
            // The cloudUrl is the same for all created work items
            cloudUrl = bulkParentResponse.cloudUrl;
        }
        else bulkParentResponse.errorMessages.forEach((errorMessage)=>errors.add(errorMessage));
        // Create child issues, mapped to their created parent issues
        const childWorkItems = draftWorkItems.flatMap((workItem)=>workItem.childWorkItems ?? []).map((childWorkItem)=>{
            const rawParent = childWorkItem.fields.parent;
            const parent = $dc1912a17518af52$var$isParentField(rawParent) ? rawParent : undefined;
            const parentId = parent?.id ? parentSummaryToIssueIdMapping[parent.id] ?? undefined : undefined;
            if (!parentId) {
                // if this is a subtask, then this will fail
                const { parent: _omitted, ...fieldsWithoutParent } = childWorkItem.fields;
                return {
                    ...childWorkItem,
                    fields: fieldsWithoutParent
                };
            }
            return {
                ...childWorkItem,
                fields: {
                    ...childWorkItem.fields,
                    parent: {
                        id: parentId
                    }
                }
            };
        });
        if (childWorkItems.length !== 0) {
            const bulkChildrenResponse = await (0, $jCmJN.createIssuesInBulk)({
                draftWorkItems: childWorkItems,
                cloudId: cloudId
            });
            if (bulkChildrenResponse.isSuccess) for (const [index_0, createdChild] of bulkChildrenResponse.createdIssues.entries()){
                createdIssueKeys.push(createdChild.key);
                createdIssueIds.push(createdChild.id);
                const invocationId_0 = childWorkItems[index_0].invocationId;
                invocationIdToCreatedIssueKey[invocationId_0] = createdChild.key;
            }
            else bulkChildrenResponse.errorMessages.forEach((errorMessage_0)=>errors.add(errorMessage_0));
        }
        const totalCount = (0, $9KnlJ.getNumberIssuesFromDraftWorkItems)(draftWorkItems);
        if (totalCount === createdIssueKeys.length) {
            trackAIMAUEvent({
                type: 'actioned',
                actionResult: 'success',
                source: 'JiraAIFC',
                proactive: false,
                userGenerated: true,
                attributes: {
                    ...interactionModeExecutedAttributes,
                    successCount: createdIssueKeys.length,
                    failureCount: totalCount - createdIssueKeys.length,
                    totalCount: totalCount,
                    actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                    isSingleWorkItem: totalCount === 1,
                    isStagingArea: isStagingArea
                }
            });
            // track Rovo Assisted Work via object IDs
            trackAIMAUEvent({
                type: 'adopted',
                source: 'JiraAIFC',
                proactive: false,
                userGenerated: true,
                actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                rovoModifiedObjects: createdIssueIds?.map((id)=>({
                        objectType: 'work-item',
                        objectId: id
                    })),
                attributes: interactionModeExecutedAttributes
            });
            // Handling resolving all the conversation actions and opening the Rovo chat should be handled by
            // the consumer of the button
            // Handle close and opening the Rovo chat should be handled by the onClick function provided
            if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK
            });
            if ((0, $iDrrr.fg)('rovo_skills_work_item_reliability_ufo')) experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
                attributes: {
                    isSingleWorkItem: totalCount === 1,
                    isStagingArea: isStagingArea,
                    totalCount: totalCount
                }
            });
        } else {
            // Fall back to default error message if there are no errors from the bulk create API
            const errorMessage_1 = errors.size > 0 ? $dc1912a17518af52$var$toSentenceCase(Array.from(errors).join(', ')) : formatMessage($dc1912a17518af52$var$messages.creationErrorDescription);
            trackAIMAUEvent({
                type: 'actioned',
                actionResult: createdIssueKeys.length > 0 ? 'partial-failure' : 'failure',
                source: 'JiraAIFC',
                proactive: false,
                userGenerated: true,
                attributes: {
                    ...interactionModeExecutedAttributes,
                    successCount: createdIssueKeys.length,
                    failureCount: totalCount - createdIssueKeys.length,
                    totalCount: totalCount,
                    actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                    isSingleWorkItem: totalCount === 1,
                    isStagingArea: isStagingArea
                }
            });
            if (createdIssueIds.length > 0) trackAIMAUEvent({
                type: 'adopted',
                source: 'JiraAIFC',
                proactive: false,
                userGenerated: true,
                actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                rovoModifiedObjects: createdIssueIds?.map((id_0)=>({
                        objectType: 'work-item',
                        objectId: id_0
                    })),
                attributes: interactionModeExecutedAttributes
            });
            trackAIMAUEvent({
                type: 'error',
                proactive: false,
                source: 'JiraAIFC',
                attributes: {
                    totalCount: totalCount,
                    successCount: createdIssueKeys.length,
                    failureCount: totalCount - createdIssueKeys.length,
                    actionKey: $dc1912a17518af52$var$CREATE_WORK_ITEMS_ACTION_KEY,
                    isSingleWorkItem: totalCount === 1,
                    isStagingArea: isStagingArea,
                    ...interactionModeExecutedAttributes,
                    error: errorMessage_1
                }
            });
            if ((0, $iDrrr.fg)('jira-aifc-track-ufo-experiences')) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
                error: new Error(errorMessage_1)
            });
            if ((0, $iDrrr.fg)('rovo_skills_work_item_reliability_ufo')) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
                error: new Error(errorMessage_1),
                attributes: {
                    isSingleWorkItem: totalCount === 1,
                    isStagingArea: isStagingArea,
                    totalCount: totalCount
                }
            });
            return {
                isSuccess: false,
                errorMessage: errorMessage_1
            };
        }
        return {
            isSuccess: true,
            createdIssueIds: createdIssueIds,
            invocationIdToCreatedIssueKey: invocationIdToCreatedIssueKey,
            cloudUrl: cloudUrl
        };
    }, [
        cloudId,
        formatMessage,
        trackAIMAUEvent,
        experienceTracker,
        isStagingArea,
        interactionModeExecutedAttributes
    ]);
    return {
        createIssues: createIssues
    };
};
function $dc1912a17518af52$var$_temp(workItem) {
    return workItem.childWorkItems ?? [];
}
function $dc1912a17518af52$var$_temp2(id) {
    return {
        objectType: "work-item",
        objectId: id
    };
}
function $dc1912a17518af52$var$_temp3(id_0) {
    return {
        objectType: "work-item",
        objectId: id_0
    };
}
module.exports["useCreateIssues"] = $dc1912a17518af52$export$8992417dff99996e;

});

parcelRegister("ckYNb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4LtLd = parcelRequire("4LtLd");


var $cozmU = parcelRequire("cozmU");


var $f8dGE = parcelRequire("f8dGE");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $hCHQD = parcelRequire("hCHQD");


var $bcdSN = parcelRequire("bcdSN");


var $iKetF = parcelRequire("iKetF");

const $08ff585a152afa91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    missingRequiredField: {
        id: "jira-create-work-items.validation.missing-required-field",
        defaultMessage: "Field \u2018{fieldName}\u2019 is required for type \u2018{issueTypeName}\u2019"
    },
    noWorkItemsToCreate: {
        id: "jira-create-work-items.validation.no-work-items-to-create",
        defaultMessage: "No work items to create"
    },
    invalidFieldHierarchy: {
        id: "jira-create-work-items.validation.invalid-field-hierarchy",
        defaultMessage: "Invalid work type hierarchy for type \u2018{issueTypeName}\u2019"
    }
});
const $08ff585a152afa91$var$isEmpty = (value)=>value == null || // catches null / undefined
    String(value).trim() === '' || // catches '' and whitespace
    Array.isArray(value) && value.length === 0 || typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0;
/**
 * Converts a fields configuration GraphQL connection into a record mapping field IDs to their corresponding field configuration GraphQL node.
 *
 * @param fieldsConfiguration - The fields configuration object, which may be undefined.
 * @returns A record where each key is a field ID and each value is the corresponding field configuration.
 */ function $08ff585a152afa91$var$toFieldConfigurationNode(fieldsConfiguration) {
    if (!fieldsConfiguration) return {};
    return Object.fromEntries((fieldsConfiguration?.edges ?? []).filter(Boolean).map((edge)=>[
            edge?.node?.fieldId,
            edge?.node
        ]));
}
/**
 * Converts an `IssueTypeLike` object to an `IssueType` object.
 *
 * @param issueTypeLike - The source object containing issue type information.
 * @returns An `IssueType` object with mapped properties
 */ function $08ff585a152afa91$var$toIssueType(issueTypeLike) {
    return {
        issueTypeId: String(issueTypeLike.issueTypeId),
        name: issueTypeLike.name,
        hierarchyLevel: issueTypeLike.hierarchy?.level ?? 0,
        avatarUrl: issueTypeLike.avatar?.small ?? undefined,
        fieldsConfigurationNode: $08ff585a152afa91$var$toFieldConfigurationNode(issueTypeLike.fieldsConfiguration)
    };
}
/**
 * Builds a mapping of issue type IDs to their corresponding field configuration GraphQL nodes for a given project.
 * Iterates over the project's issue types and constructs an object where each key is an issue type ID,
 * and each value is the result of transforming the issue type node using `toIssueType`.
 *
 * @param project - The project GraphQL node containing issue types, or `null`/`undefined`.
 * @returns An object mapping issue type IDs to their field configurations.
 */ function $08ff585a152afa91$var$buildIssueTypeToFieldsConfiguration(project) {
    const issueTypeToFieldsConfiguration = {};
    project?.issueTypes?.edges?.forEach((issueTypeEdge)=>{
        const issueTypeNode = issueTypeEdge?.node;
        const issueTypeId = issueTypeNode?.issueTypeId;
        if (!issueTypeId) return;
        issueTypeToFieldsConfiguration[issueTypeId] = $08ff585a152afa91$var$toIssueType(issueTypeNode);
    });
    return issueTypeToFieldsConfiguration;
}
const $08ff585a152afa91$export$746e093b0677085c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { cloudId: cloudId, projectIdOrKey: projectIdOrKey, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    let t1;
    if ($[0] !== cloudId || $[1] !== environment || $[2] !== formatMessage || $[3] !== projectIdOrKey || $[4] !== sendAifcAnalyticsEvent) {
        t1 = async (draftWorkItemsOriginal)=>{
            const draftWorkItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(draftWorkItemsOriginal);
            const queryData = await (0, $6SsN4.fetchQuery)(environment, (0, $4LtLd.default), {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey
            }, {
                fetchPolicy: "network-only"
            }).toPromise();
            const issueTypeToFieldsConfigMap = $08ff585a152afa91$var$buildIssueTypeToFieldsConfiguration(queryData?.jira_projectByIdOrKey);
            if (!issueTypeToFieldsConfigMap) {
                sendAifcAnalyticsEvent?.({
                    action: "failed",
                    actionSubject: "validateIssuesToCreate",
                    attributes: {
                        reason: "noIssueTypeToFieldsConfigMap"
                    }
                });
                return;
            }
            if (draftWorkItems.length === 0) {
                sendAifcAnalyticsEvent?.({
                    action: "failed",
                    actionSubject: "validateIssuesToCreate",
                    attributes: {
                        reason: "noDraftWorkItems"
                    }
                });
                return {
                    success: false,
                    context: {
                        draftWorkItems: draftWorkItems,
                        issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                    },
                    error: formatMessage($08ff585a152afa91$export$defe85febe8b728c.noWorkItemsToCreate)
                };
            }
            const allDraftWorkItems = [
                ...draftWorkItems,
                ...draftWorkItems.flatMap($08ff585a152afa91$var$_temp)
            ];
            for (const draftWorkItem of allDraftWorkItems){
                const { issueTypeId: issueTypeId, fields: fields } = draftWorkItem;
                const fieldConfig = issueTypeToFieldsConfigMap[issueTypeId].fieldsConfigurationNode;
                const validFieldIds = new Set(Object.keys(fieldConfig));
                const requiredFields = Object.values(fieldConfig).filter($08ff585a152afa91$var$_temp2);
                const fieldIdsToRemove = Object.keys(fields).filter((fieldId)=>(!validFieldIds.has(fieldId) || $08ff585a152afa91$var$isEmpty(fields[fieldId])) && fieldId !== (0, $bcdSN.PARENT_FIELD_ID));
                for (const fieldId_0 of fieldIdsToRemove)delete draftWorkItem.fields[fieldId_0];
                const fieldProcessor = new (0, $iKetF.FieldProcessor)();
                for (const fieldId_1 of Object.keys(draftWorkItem.fields)){
                    if ((0, $bcdSN.USER_PICKER_FIELD_TYPES).includes(fieldConfig[fieldId_1]?.__typename)) {
                        if (Array.isArray(draftWorkItem.fields[fieldId_1])) draftWorkItem.fields[fieldId_1] = (0, $hCHQD.parseUsers)(draftWorkItem.fields[fieldId_1]).map($08ff585a152afa91$var$_temp3);
                        else draftWorkItem.fields[fieldId_1] = (0, $hCHQD.parseUser)(draftWorkItem.fields[fieldId_1])?.user?.accountId || null;
                    }
                    if (fieldId_1 === (0, $bcdSN.ISSUE_TYPE_FIELD_ID)) draftWorkItem.fields[fieldId_1] = (0, $hCHQD.parseIssueType)(draftWorkItem.fields[fieldId_1]);
                    draftWorkItem.fields[fieldId_1] = fieldProcessor.populateFieldPayload(fieldConfig[fieldId_1] ? fieldConfig[fieldId_1].type : "parent", fieldId_1, draftWorkItem.fields[fieldId_1]);
                }
                const { childWorkItems: childWorkItems } = draftWorkItem;
                const hasNestedChildren = childWorkItems?.some($08ff585a152afa91$var$_temp4);
                if (hasNestedChildren) sendAifcAnalyticsEvent?.({
                    action: "nestedChildWorkItems",
                    actionSubject: "validateIssuesToCreate",
                    attributes: {}
                });
                const parentHierarchyLevel = issueTypeToFieldsConfigMap[issueTypeId].hierarchyLevel;
                const isInvalidFieldHierarchy = childWorkItems?.some((child_0)=>issueTypeToFieldsConfigMap[child_0.issueTypeId].hierarchyLevel !== parentHierarchyLevel - 1);
                if (isInvalidFieldHierarchy) return {
                    success: false,
                    error: formatMessage($08ff585a152afa91$export$defe85febe8b728c.invalidFieldHierarchy, {
                        issueTypeName: issueTypeToFieldsConfigMap[issueTypeId].name
                    }),
                    context: {
                        draftWorkItems: draftWorkItems,
                        issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                    }
                };
                const seenFieldIds = new Set(Object.keys(draftWorkItem.fields));
                for (const requiredField of requiredFields){
                    if (requiredField.fieldId === (0, $bcdSN.REPORTER_FIELD_ID)) {
                        if (draftWorkItem.fields[0, $bcdSN.REPORTER_FIELD_ID] === null) delete draftWorkItem.fields[0, $bcdSN.REPORTER_FIELD_ID];
                        continue;
                    }
                    if (!seenFieldIds.has(requiredField.fieldId)) {
                        sendAifcAnalyticsEvent?.({
                            action: "failed",
                            actionSubject: "validateIssuesToCreate",
                            attributes: {
                                reason: "missingRequiredField",
                                fieldType: requiredField.__typename,
                                nativeIssueTypeName: [
                                    "Story",
                                    "Task",
                                    "Bug",
                                    "Epic",
                                    "Initiative",
                                    "Sub-task"
                                ].find((type)=>type === issueTypeToFieldsConfigMap[issueTypeId].name) || "__other"
                            }
                        });
                        return {
                            success: false,
                            error: formatMessage($08ff585a152afa91$export$defe85febe8b728c.missingRequiredField, {
                                fieldName: requiredField.name,
                                issueTypeName: issueTypeToFieldsConfigMap[issueTypeId].name
                            }),
                            context: {
                                draftWorkItems: draftWorkItems,
                                issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                            }
                        };
                    }
                }
            }
            return {
                success: true,
                context: {
                    draftWorkItems: draftWorkItems,
                    issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                }
            };
        };
        $[0] = cloudId;
        $[1] = environment;
        $[2] = formatMessage;
        $[3] = projectIdOrKey;
        $[4] = sendAifcAnalyticsEvent;
        $[5] = t1;
    } else t1 = $[5];
    const validateIssuesToCreate = t1;
    let t2;
    if ($[6] !== validateIssuesToCreate) {
        t2 = {
            validateIssuesToCreate: validateIssuesToCreate
        };
        $[6] = validateIssuesToCreate;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const validateIssuesToCreate = (0, $cozmU.useCallback)(async (draftWorkItemsOriginal)=>{
        const draftWorkItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(draftWorkItemsOriginal);
        const queryData = await (0, $6SsN4.fetchQuery)(environment, (0, $4LtLd.default), {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }, {
            fetchPolicy: 'network-only'
        }).toPromise();
        const issueTypeToFieldsConfigMap = $08ff585a152afa91$var$buildIssueTypeToFieldsConfiguration(queryData?.jira_projectByIdOrKey);
        if (!issueTypeToFieldsConfigMap) {
            sendAifcAnalyticsEvent?.({
                action: 'failed',
                actionSubject: 'validateIssuesToCreate',
                attributes: {
                    reason: 'noIssueTypeToFieldsConfigMap'
                }
            });
            return undefined;
        }
        if (draftWorkItems.length === 0) {
            sendAifcAnalyticsEvent?.({
                action: 'failed',
                actionSubject: 'validateIssuesToCreate',
                attributes: {
                    reason: 'noDraftWorkItems'
                }
            });
            return {
                success: false,
                context: {
                    draftWorkItems: draftWorkItems,
                    issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                },
                error: formatMessage($08ff585a152afa91$export$defe85febe8b728c.noWorkItemsToCreate)
            };
        }
        const allDraftWorkItems = [
            ...draftWorkItems,
            ...draftWorkItems.flatMap((parent)=>parent.childWorkItems || [])
        ];
        for (const draftWorkItem of allDraftWorkItems){
            const { issueTypeId: issueTypeId, fields: fields } = draftWorkItem;
            const fieldConfig = issueTypeToFieldsConfigMap[issueTypeId].fieldsConfigurationNode;
            const validFieldIds = new Set(Object.keys(fieldConfig));
            const requiredFields = Object.values(fieldConfig).filter((field)=>field.fieldConfig?.isRequired);
            // Remove any LLM-hallucinated fields from the draft work item
            // Skip parent field, since AGG field config can hide it
            const fieldIdsToRemove = Object.keys(fields).filter((fieldId)=>(!validFieldIds.has(fieldId) || $08ff585a152afa91$var$isEmpty(fields[fieldId])) && fieldId !== (0, $bcdSN.PARENT_FIELD_ID));
            for (const fieldId_0 of fieldIdsToRemove)delete draftWorkItem.fields[fieldId_0];
            // Transform fields to fit creation payload
            const fieldProcessor = new (0, $iKetF.FieldProcessor)();
            for (const fieldId_1 of Object.keys(draftWorkItem.fields)){
                if ((0, $bcdSN.USER_PICKER_FIELD_TYPES).includes(fieldConfig[fieldId_1]?.__typename)) {
                    if (Array.isArray(draftWorkItem.fields[fieldId_1])) draftWorkItem.fields[fieldId_1] = (0, $hCHQD.parseUsers)(draftWorkItem.fields[fieldId_1]).map((userWithWrapper)=>userWithWrapper?.user?.accountId || null);
                    else draftWorkItem.fields[fieldId_1] = (0, $hCHQD.parseUser)(draftWorkItem.fields[fieldId_1])?.user?.accountId || null;
                }
                if (fieldId_1 === (0, $bcdSN.ISSUE_TYPE_FIELD_ID)) draftWorkItem.fields[fieldId_1] = (0, $hCHQD.parseIssueType)(draftWorkItem.fields[fieldId_1]);
                draftWorkItem.fields[fieldId_1] = fieldProcessor.populateFieldPayload(fieldConfig[fieldId_1] ? fieldConfig[fieldId_1].type : 'parent', fieldId_1, draftWorkItem.fields[fieldId_1]);
            }
            // Check if any child work items have child work items themselves
            const { childWorkItems: childWorkItems } = draftWorkItem;
            const hasNestedChildren = childWorkItems?.some((child)=>child.childInvocationIds?.length);
            if (hasNestedChildren) sendAifcAnalyticsEvent?.({
                action: 'nestedChildWorkItems',
                actionSubject: 'validateIssuesToCreate',
                attributes: {}
            });
            // Check that all child work items have a hierarchy level that is 1 less than the parent's
            const parentHierarchyLevel = issueTypeToFieldsConfigMap[issueTypeId].hierarchyLevel;
            const isInvalidFieldHierarchy = childWorkItems?.some((child_0)=>issueTypeToFieldsConfigMap[child_0.issueTypeId].hierarchyLevel !== parentHierarchyLevel - 1);
            if (isInvalidFieldHierarchy) return {
                success: false,
                error: formatMessage($08ff585a152afa91$export$defe85febe8b728c.invalidFieldHierarchy, {
                    issueTypeName: issueTypeToFieldsConfigMap[issueTypeId].name
                }),
                context: {
                    draftWorkItems: draftWorkItems,
                    issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                }
            };
            // Check all required fields are present for issue creation
            const seenFieldIds = new Set(Object.keys(draftWorkItem.fields));
            for (const requiredField of requiredFields){
                // Specifically handle the reporter field, since when it's not passed to the Create API
                // it defaults to the current user
                if (requiredField.fieldId === (0, $bcdSN.REPORTER_FIELD_ID)) {
                    if (draftWorkItem.fields[0, $bcdSN.REPORTER_FIELD_ID] === null) delete draftWorkItem.fields[0, $bcdSN.REPORTER_FIELD_ID];
                    continue;
                }
                if (!seenFieldIds.has(requiredField.fieldId)) {
                    sendAifcAnalyticsEvent?.({
                        action: 'failed',
                        actionSubject: 'validateIssuesToCreate',
                        attributes: {
                            reason: 'missingRequiredField',
                            fieldType: requiredField.__typename,
                            nativeIssueTypeName: [
                                'Story',
                                'Task',
                                'Bug',
                                'Epic',
                                'Initiative',
                                'Sub-task'
                            ].find((type)=>type === issueTypeToFieldsConfigMap[issueTypeId].name) || '__other'
                        }
                    });
                    return {
                        success: false,
                        error: formatMessage($08ff585a152afa91$export$defe85febe8b728c.missingRequiredField, {
                            fieldName: requiredField.name,
                            issueTypeName: issueTypeToFieldsConfigMap[issueTypeId].name
                        }),
                        context: {
                            draftWorkItems: draftWorkItems,
                            issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
                        }
                    };
                }
            }
        }
        return {
            success: true,
            context: {
                draftWorkItems: draftWorkItems,
                issueTypeToFieldsConfigMap: issueTypeToFieldsConfigMap
            }
        };
    }, [
        formatMessage,
        sendAifcAnalyticsEvent,
        cloudId,
        environment,
        projectIdOrKey
    ]);
    return {
        validateIssuesToCreate: validateIssuesToCreate
    };
};
function $08ff585a152afa91$var$_temp(parent) {
    return parent.childWorkItems || [];
}
function $08ff585a152afa91$var$_temp2(field) {
    return field.fieldConfig?.isRequired;
}
function $08ff585a152afa91$var$_temp3(userWithWrapper) {
    return userWithWrapper?.user?.accountId || null;
}
function $08ff585a152afa91$var$_temp4(child) {
    return child.childInvocationIds?.length;
}
module.exports["useValidateIssuesToCreate"] = $08ff585a152afa91$export$746e093b0677085c;

});

parcelRegister("3jUgE", function(module, exports) {
/* ShowMorePopup.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $lpNn5 = parcelRequire("lpNn5");


var $aV6bG = parcelRequire("aV6bG");

const $962cc6a620371b37$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, items: items, ItemComponent: ItemComponent, PopupContentWrapper: PopupContentWrapper = (0, $cozmU.Fragment), maxLimit: maxLimit = 99, OverrideContentComponent: OverrideContentComponent, initialIsOpen: initialIsOpen = false, isHoverPopoverEnabled: isHoverPopoverEnabled = false })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(initialIsOpen);
    const list = items.slice(0, maxLimit);
    const content = (0, $cozmU.useCallback)(()=>list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, item))), [
        ItemComponent,
        list
    ]);
    if (items.length === 0) return null;
    const onClickTrigger = ()=>{
        setIsOpen(!isOpen);
    };
    const contentWithWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "list-with-popup.ui.show-more-popup.content",
            xcss: $962cc6a620371b37$var$styles.contentWrapper
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent);
    if (isHoverPopoverEnabled) {
        const hoverContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "list-with-popup.ui.show-more-popup.content",
            xcss: $962cc6a620371b37$var$styles.contentWrapper
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aV6bG.default), {
            content: hoverContent,
            placement: "bottom"
        }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                testId: "list-with-popup.ui.show-more-popup.items-count",
                onClick: onClickTrigger,
                ...triggerProps,
                xcss: $962cc6a620371b37$var$styles.itemsCountButton
            }, "+", list.length));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom",
        content: contentWithWrapper,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $962cc6a620371b37$var$TooltipContainer,
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                onClick: onClickTrigger,
                "aria-expanded": isOpen,
                xcss: $962cc6a620371b37$var$styles.itemsCountButton,
                onKeyDown: (e)=>{
                    if (e.key === ' ' || e.key === 'Enter') {
                        e.preventDefault();
                        onClickTrigger();
                    }
                    if (e.key === 'Escape') {
                        e.preventDefault();
                        setIsOpen(false);
                    }
                },
                testId: "list-with-popup.ui.show-more-popup.items-count"
            }, "+", list.length))
    });
};
const $962cc6a620371b37$var$TooltipContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $962cc6a620371b37$var$styles.tooltipContainer
    }));
const $962cc6a620371b37$var$styles = {
    tooltipContainer: "_1EqgXlN91d",
    itemsCountButton: "_0bjKvDzXzM _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _2Y7lL41Y8M _3iDTPbccYA _0hPCNLDIqT _1UtDYzy7kJ _0KLXru66of",
    contentWrapper: "_2Y7lL45zaO _4c065U5zaO"
};
var $962cc6a620371b37$export$2e2bcd8739ae039 = $962cc6a620371b37$var$ShowMorePopup;
module.exports["default"] = $962cc6a620371b37$export$2e2bcd8739ae039;

});

parcelRegister("k8Uuy", function(module, exports) {
/* ColoredTag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $jXedL = parcelRequire("jXedL");

const $96a61ee7f15c1217$var$styles = {
    container: "_2mHwu81Y8M _0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _2Y7lL41Y8M _4c065UPgdg _3SamIH1Y8M _2YLqiK1Y8M _3iDTPbccYA _0hPCNLDIqT _0jFU0VSPN1 _1EqgXlN91d _1UtDYzy7kJ _0KLXru66of",
    text: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _1EqgXlWD6W"
};
const $96a61ee7f15c1217$var$ColoredTag = ({ labelName: labelName, href: href, color: color, containerXcss: containerXcss, contentXcss: contentXcss, openLinksInNewTab: openLinksInNewTab, elemBefore: elemBefore })=>{
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    const isLink = Boolean(href);
    const Inner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $96a61ee7f15c1217$var$styles.container,
        onMouseEnter: isLink ? ()=>setHovered(true) : undefined,
        onMouseLeave: isLink ? ()=>setHovered(false) : undefined,
        style: {
            borderColor: color || undefined,
            backgroundColor: isLink && hovered ? "var(--ds-background-neutral-hovered, #0B120E24)" : undefined,
            textDecoration: isLink ? 'none' : undefined
        }
    }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: contentXcss ?? $96a61ee7f15c1217$var$styles.text,
        style: {
            textDecoration: isLink && hovered ? 'underline' : undefined
        }
    }, contentXcss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $96a61ee7f15c1217$var$styles.text
    }, labelName) : labelName));
    const WithContainer = containerXcss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: containerXcss
    }, Inner) : Inner;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXedL.default), {
        href: href,
        openLinksInNewTab: openLinksInNewTab
    }, WithContainer);
    return WithContainer;
};
var $96a61ee7f15c1217$export$2e2bcd8739ae039 = $96a61ee7f15c1217$var$ColoredTag;
module.exports["default"] = $96a61ee7f15c1217$export$2e2bcd8739ae039;

});

parcelRegister("jXedL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("g23UR");
var $5SM4Y = parcelRequire("5SM4Y");

const $7cb584b1d2d89776$var$Link = ({ onClick: onClick, openLinksInNewTab: openLinksInNewTab = false, wordBreak: wordBreak = true, shouldDisplayStrikethrough: shouldDisplayStrikethrough = false, ...rest })=>{
    const onClickForward = (0, $cozmU.useCallback)((e)=>{
        onClick && onClick(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cb584b1d2d89776$var$PropFilteredLink, {
        ...openLinksInNewTab ? {
            target: '_blank',
            rel: 'noopener'
        } : {},
        ...rest,
        onClick: onClickForward,
        style: {
            wordBreak: wordBreak ? 'break-word' : undefined,
            textDecoration: shouldDisplayStrikethrough ? 'line-through' : undefined
        }
    });
};
const $7cb584b1d2d89776$var$PropFilteredLink = ({ wordBreak: _wordBreak, shouldDisplayStrikethrough: _shouldDisplayStrikethrough, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SM4Y.default), rest);
var $7cb584b1d2d89776$export$2e2bcd8739ae039 = $7cb584b1d2d89776$var$Link;
module.exports["default"] = $7cb584b1d2d89776$export$2e2bcd8739ae039;

});

parcelRegister("14F6V", function(module, exports) {

var $eiLi2 = parcelRequire("eiLi2");


var $jTKfH = parcelRequire("jTKfH");


var $4Qaxv = parcelRequire("4Qaxv");

const $2b2b4c3af6a425bf$var$FETCH_SUGGESTIONS_DEBOUNCE_MS = 200;
const $2b2b4c3af6a425bf$var$debouncedFetch = (0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))((0, $jTKfH.performHttpFetch), $2b2b4c3af6a425bf$var$FETCH_SUGGESTIONS_DEBOUNCE_MS);
const $2b2b4c3af6a425bf$export$2457563589abded0 = (0, $4Qaxv.LruCache)(10);
const $2b2b4c3af6a425bf$export$ebf2f44fe450da2b = async (query, projectKey)=>{
    const cached = $2b2b4c3af6a425bf$export$2457563589abded0.get(query ?? '');
    let apiCall = cached?.value;
    if (!apiCall) {
        const request = $2b2b4c3af6a425bf$var$debouncedFetch({
            path: `/rest/api/3/user/recommend?${new URLSearchParams({
                context: 'People',
                project: projectKey,
                query: query ?? ''
            })}`,
            options: {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }
            }
        });
        $2b2b4c3af6a425bf$export$2457563589abded0.set(query ?? '', request);
        apiCall = request;
    }
    return apiCall.then((data)=>data.filter((item)=>item.accountType !== 'app' && item.accountId).map((item)=>{
            return {
                id: item.accountId,
                accountId: item.accountId,
                name: item.displayName || '',
                avatarUrl: item.avatarUrl || item.avatarUrls?.['32x32'] || ''
            };
        }));
};
module.exports["fetchSuggestions"] = $2b2b4c3af6a425bf$export$ebf2f44fe450da2b;

});

parcelRegister("2nJYx", function(module, exports) {
const $e1b3821a430c12de$export$cea6be08100fe80a = 'custom-text-field-container';
module.exports["CUSTOM_TEXT_FIELD_ID"] = $e1b3821a430c12de$export$cea6be08100fe80a;

});

parcelRegister("iPm7V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $20d7830c104e3929$export$d15e38bcd75fda7c = 256;
const $20d7830c104e3929$export$e143f4b09221a374 = 1000000007;
/****** COLOR PICKER ******/ const $20d7830c104e3929$var$messages = (0, $kSwu1.defineMessages)({
    greyLightest: {
        id: "@atlassian/option-color-picker.color-picker.grey-lightest",
        defaultMessage: "Grey lightest"
    },
    greyLighter: {
        id: "@atlassian/option-color-picker.color-picker.grey-lighter",
        defaultMessage: "Grey lighter"
    },
    grey: {
        id: "@atlassian/option-color-picker.color-picker.grey",
        defaultMessage: "Grey"
    },
    greyDarker: {
        id: "@atlassian/option-color-picker.color-picker.grey-darker",
        defaultMessage: "Grey darker"
    },
    greyDarkest: {
        id: "@atlassian/option-color-picker.color-picker.grey-darkest",
        defaultMessage: "Grey darkest"
    },
    purpleLightest: {
        id: "@atlassian/option-color-picker.color-picker.purple-lightest",
        defaultMessage: "Purple lightest"
    },
    purpleLighter: {
        id: "@atlassian/option-color-picker.color-picker.purple-lighter",
        defaultMessage: "Purple lighter"
    },
    purple: {
        id: "@atlassian/option-color-picker.color-picker.purple",
        defaultMessage: "Purple"
    },
    purpleDarker: {
        id: "@atlassian/option-color-picker.color-picker.purple-darker",
        defaultMessage: "Purple darker"
    },
    purpleDarkest: {
        id: "@atlassian/option-color-picker.color-picker.purple-darkest",
        defaultMessage: "Purple darkest"
    },
    blueLightest: {
        id: "@atlassian/option-color-picker.color-picker.blue-lightest",
        defaultMessage: "Blue lightest"
    },
    blueLighter: {
        id: "@atlassian/option-color-picker.color-picker.blue-lighter",
        defaultMessage: "Blue lighter"
    },
    blue: {
        id: "@atlassian/option-color-picker.color-picker.blue",
        defaultMessage: "Blue"
    },
    blueDarker: {
        id: "@atlassian/option-color-picker.color-picker.blue-darker",
        defaultMessage: "Blue darker"
    },
    blueDarkest: {
        id: "@atlassian/option-color-picker.color-picker.blue-darkest",
        defaultMessage: "Blue darkest"
    },
    tealLightest: {
        id: "@atlassian/option-color-picker.color-picker.teal-lightest",
        defaultMessage: "Teal lightest"
    },
    tealLighter: {
        id: "@atlassian/option-color-picker.color-picker.teal-lighter",
        defaultMessage: "Teal lighter"
    },
    teal: {
        id: "@atlassian/option-color-picker.color-picker.teal",
        defaultMessage: "Teal"
    },
    tealDarker: {
        id: "@atlassian/option-color-picker.color-picker.teal-darker",
        defaultMessage: "Teal darker"
    },
    tealDarkest: {
        id: "@atlassian/option-color-picker.color-picker.teal-darkest",
        defaultMessage: "Teal darkest"
    },
    greenLightest: {
        id: "@atlassian/option-color-picker.color-picker.green-lightest",
        defaultMessage: "Green lightest"
    },
    greenLighter: {
        id: "@atlassian/option-color-picker.color-picker.green-lighter",
        defaultMessage: "Green lighter"
    },
    green: {
        id: "@atlassian/option-color-picker.color-picker.green",
        defaultMessage: "Green"
    },
    greenDarker: {
        id: "@atlassian/option-color-picker.color-picker.green-darker",
        defaultMessage: "Green darker"
    },
    greenDarkest: {
        id: "@atlassian/option-color-picker.color-picker.green-darkest",
        defaultMessage: "Green darkest"
    },
    limeLightest: {
        id: "@atlassian/option-color-picker.color-picker.lime-lightest",
        defaultMessage: "Lime lightest"
    },
    limeLighter: {
        id: "@atlassian/option-color-picker.color-picker.lime-lighter",
        defaultMessage: "Lime lighter"
    },
    lime: {
        id: "@atlassian/option-color-picker.color-picker.lime",
        defaultMessage: "Lime"
    },
    limeDarker: {
        id: "@atlassian/option-color-picker.color-picker.lime-darker",
        defaultMessage: "Lime darker"
    },
    limeDarkest: {
        id: "@atlassian/option-color-picker.color-picker.lime-darkest",
        defaultMessage: "Lime darkest"
    },
    yellowLightest: {
        id: "@atlassian/option-color-picker.color-picker.yellow-lightest",
        defaultMessage: "Yellow lightest"
    },
    yellowLighter: {
        id: "@atlassian/option-color-picker.color-picker.yellow-lighter",
        defaultMessage: "Yellow lighter"
    },
    yellow: {
        id: "@atlassian/option-color-picker.color-picker.yellow",
        defaultMessage: "Yellow"
    },
    yellowDarker: {
        id: "@atlassian/option-color-picker.color-picker.yellow-darker",
        defaultMessage: "Yellow darker"
    },
    yellowDarkest: {
        id: "@atlassian/option-color-picker.color-picker.yellow-darkest",
        defaultMessage: "Yellow darkest"
    },
    orangeLightest: {
        id: "@atlassian/option-color-picker.color-picker.orange-lightest",
        defaultMessage: "Orange lightest"
    },
    orangeLighter: {
        id: "@atlassian/option-color-picker.color-picker.orange-lighter",
        defaultMessage: "Orange lighter"
    },
    orange: {
        id: "@atlassian/option-color-picker.color-picker.orange",
        defaultMessage: "Orange"
    },
    orangeDarker: {
        id: "@atlassian/option-color-picker.color-picker.orange-darker",
        defaultMessage: "Orange darker"
    },
    orangeDarkest: {
        id: "@atlassian/option-color-picker.color-picker.orange-darkest",
        defaultMessage: "Orange darkest"
    },
    redLightest: {
        id: "@atlassian/option-color-picker.color-picker.red-lightest",
        defaultMessage: "Red lightest"
    },
    redLighter: {
        id: "@atlassian/option-color-picker.color-picker.red-lighter",
        defaultMessage: "Red lighter"
    },
    red: {
        id: "@atlassian/option-color-picker.color-picker.red",
        defaultMessage: "Red"
    },
    redDarker: {
        id: "@atlassian/option-color-picker.color-picker.red-darker",
        defaultMessage: "Red darker"
    },
    redDarkest: {
        id: "@atlassian/option-color-picker.color-picker.red-darkest",
        defaultMessage: "Red darkest"
    },
    magentaLightest: {
        id: "@atlassian/option-color-picker.color-picker.magenta-lightest",
        defaultMessage: "Magenta lightest"
    },
    magentaLighter: {
        id: "@atlassian/option-color-picker.color-picker.magenta-lighter",
        defaultMessage: "Magenta lighter"
    },
    magenta: {
        id: "@atlassian/option-color-picker.color-picker.magenta",
        defaultMessage: "Magenta"
    },
    magentaDarker: {
        id: "@atlassian/option-color-picker.color-picker.magenta-darker",
        defaultMessage: "Magenta darker"
    },
    magentaDarkest: {
        id: "@atlassian/option-color-picker.color-picker.magenta-darkest",
        defaultMessage: "Magenta darkest"
    }
});
const $20d7830c104e3929$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    borderColor: "var(--ds-background-neutral, #0515240F)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: $20d7830c104e3929$var$messages.greyLightest
};
const $20d7830c104e3929$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)",
    borderColor: "var(--ds-background-neutral-hovered, #0B120E24)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: $20d7830c104e3929$var$messages.greyLighter
};
const $20d7830c104e3929$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #080F214A)",
    borderColor: "var(--ds-background-neutral-pressed, #080F214A)",
    textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
    messageLabel: $20d7830c104e3929$var$messages.grey
};
const $20d7830c104e3929$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
    borderColor: "var(--ds-border-accent-gray, #7D818A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.greyDarker
};
const $20d7830c104e3929$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #505258)",
    borderColor: "var(--ds-background-neutral-bold, #292A2E)",
    // grey700
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.greyDarkest
};
const $20d7830c104e3929$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    borderColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: $20d7830c104e3929$var$messages.purpleLightest
};
const $20d7830c104e3929$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    borderColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: $20d7830c104e3929$var$messages.purpleLighter
};
const $20d7830c104e3929$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    borderColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    messageLabel: $20d7830c104e3929$var$messages.purple
};
const $20d7830c104e3929$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #803FA5)",
    borderColor: "var(--ds-border-accent-purple, #AF59E1)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.purpleDarker
};
const $20d7830c104e3929$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #48245D)",
    borderColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.purpleDarkest
};
const $20d7830c104e3929$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    borderColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: $20d7830c104e3929$var$messages.blueLightest
};
const $20d7830c104e3929$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    borderColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: $20d7830c104e3929$var$messages.blueLighter
};
const $20d7830c104e3929$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    borderColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    textColor: "var(--ds-text-accent-blue-bolder, #123263)",
    messageLabel: $20d7830c104e3929$var$messages.blue
};
const $20d7830c104e3929$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #1558BC)",
    borderColor: "var(--ds-border-accent-blue, #357DE8)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.blueDarker
};
const $20d7830c104e3929$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #123263)",
    borderColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.blueDarkest
};
const $20d7830c104e3929$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    borderColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: $20d7830c104e3929$var$messages.tealLightest
};
const $20d7830c104e3929$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    borderColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: $20d7830c104e3929$var$messages.tealLighter
};
const $20d7830c104e3929$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    borderColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: $20d7830c104e3929$var$messages.teal
};
const $20d7830c104e3929$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    borderColor: "var(--ds-border-accent-teal, #2898BD)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.tealDarker
};
const $20d7830c104e3929$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    borderColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.tealDarkest
};
const $20d7830c104e3929$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    borderColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: $20d7830c104e3929$var$messages.greenLightest
};
const $20d7830c104e3929$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    borderColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: $20d7830c104e3929$var$messages.greenLighter
};
const $20d7830c104e3929$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    borderColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: $20d7830c104e3929$var$messages.green
};
const $20d7830c104e3929$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    borderColor: "var(--ds-border-accent-green, #22A06B)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.greenDarker
};
const $20d7830c104e3929$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    borderColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.greenDarkest
};
const $20d7830c104e3929$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    borderColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: $20d7830c104e3929$var$messages.limeLightest
};
const $20d7830c104e3929$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    borderColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: $20d7830c104e3929$var$messages.limeLighter
};
const $20d7830c104e3929$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    borderColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: $20d7830c104e3929$var$messages.lime
};
const $20d7830c104e3929$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    borderColor: "var(--ds-border-accent-lime, #6A9A23)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.limeDarker
};
const $20d7830c104e3929$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    borderColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.limeDarkest
};
const $20d7830c104e3929$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    borderColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: $20d7830c104e3929$var$messages.yellowLightest
};
const $20d7830c104e3929$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    borderColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: $20d7830c104e3929$var$messages.yellowLighter
};
const $20d7830c104e3929$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    borderColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: $20d7830c104e3929$var$messages.yellow
};
const $20d7830c104e3929$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    borderColor: "var(--ds-border-accent-yellow, #B38600)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.yellowDarker
};
const $20d7830c104e3929$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    borderColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.yellowDarkest
};
const $20d7830c104e3929$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    borderColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: $20d7830c104e3929$var$messages.orangeLightest
};
const $20d7830c104e3929$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    borderColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: $20d7830c104e3929$var$messages.orangeLighter
};
const $20d7830c104e3929$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    borderColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    textColor: "var(--ds-text-accent-orange-bolder, #693200)",
    messageLabel: $20d7830c104e3929$var$messages.orange
};
const $20d7830c104e3929$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
    borderColor: "var(--ds-border-accent-orange, #E06C00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.orangeDarker
};
const $20d7830c104e3929$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #693200)",
    borderColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.orangeDarkest
};
const $20d7830c104e3929$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    borderColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: $20d7830c104e3929$var$messages.redLightest
};
const $20d7830c104e3929$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    borderColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: $20d7830c104e3929$var$messages.redLighter
};
const $20d7830c104e3929$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    borderColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: $20d7830c104e3929$var$messages.red
};
const $20d7830c104e3929$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    borderColor: "var(--ds-border-accent-red, #E2483D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.redDarker
};
const $20d7830c104e3929$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    borderColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.redDarkest
};
const $20d7830c104e3929$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    borderColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: $20d7830c104e3929$var$messages.magentaLightest
};
const $20d7830c104e3929$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    borderColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: $20d7830c104e3929$var$messages.magentaLighter
};
const $20d7830c104e3929$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    borderColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: $20d7830c104e3929$var$messages.magenta
};
const $20d7830c104e3929$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    borderColor: "var(--ds-border-accent-magenta, #CD519D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.magentaDarker
};
const $20d7830c104e3929$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    borderColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: $20d7830c104e3929$var$messages.magentaDarkest
};
const $20d7830c104e3929$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $20d7830c104e3929$export$941ef40ef5fdd2b1 = "var(--ds-text, #292A2E)";
const $20d7830c104e3929$export$7f42563469df7e01 = [
    $20d7830c104e3929$var$GREY_LIGHTEST_META,
    $20d7830c104e3929$var$PURPLE_LIGHTEST_META,
    $20d7830c104e3929$var$BLUE_LIGHTEST_META,
    $20d7830c104e3929$var$TEAL_LIGHTEST_META,
    $20d7830c104e3929$var$GREEN_LIGHTEST_META,
    $20d7830c104e3929$var$LIME_LIGHTEST_META,
    $20d7830c104e3929$var$YELLOW_LIGHTEST_META,
    $20d7830c104e3929$var$ORANGE_LIGHTEST_META,
    $20d7830c104e3929$var$RED_LIGHTEST_META,
    $20d7830c104e3929$var$MAGENTA_LIGHTEST_META,
    $20d7830c104e3929$var$GREY_LIGHTER_META,
    $20d7830c104e3929$var$PURPLE_LIGHTER_META,
    $20d7830c104e3929$var$BLUE_LIGHTER_META,
    $20d7830c104e3929$var$TEAL_LIGHTER_META,
    $20d7830c104e3929$var$GREEN_LIGHTER_META,
    $20d7830c104e3929$var$LIME_LIGHTER_META,
    $20d7830c104e3929$var$YELLOW_LIGHTER_META,
    $20d7830c104e3929$var$ORANGE_LIGHTER_META,
    $20d7830c104e3929$var$RED_LIGHTER_META,
    $20d7830c104e3929$var$MAGENTA_LIGHTER_META,
    $20d7830c104e3929$export$11b75436f568ab00,
    $20d7830c104e3929$var$PURPLE_META,
    $20d7830c104e3929$var$BLUE_META,
    $20d7830c104e3929$var$TEAL_META,
    $20d7830c104e3929$var$GREEN_META,
    $20d7830c104e3929$var$LIME_META,
    $20d7830c104e3929$var$YELLOW_META,
    $20d7830c104e3929$var$ORANGE_META,
    $20d7830c104e3929$var$RED_META,
    $20d7830c104e3929$var$MAGENTA_META,
    $20d7830c104e3929$var$GREY_DARKER_META,
    $20d7830c104e3929$export$7c314e2461a7241b,
    $20d7830c104e3929$var$BLUE_DARKER_META,
    $20d7830c104e3929$export$6daaa1cc3f46f41,
    $20d7830c104e3929$var$GREEN_DARKER_META,
    $20d7830c104e3929$var$LIME_DARKER_META,
    $20d7830c104e3929$var$YELLOW_DARKER_META,
    $20d7830c104e3929$var$ORANGE_DARKER_META,
    $20d7830c104e3929$var$RED_DARKER_META,
    $20d7830c104e3929$var$MAGENTA_DARKER_META,
    $20d7830c104e3929$var$GREY_DARKEST_META,
    $20d7830c104e3929$var$PURPLE_DARKEST_META,
    $20d7830c104e3929$export$69c4eac71b813fba,
    $20d7830c104e3929$var$TEAL_DARKEST_META,
    $20d7830c104e3929$var$GREEN_DARKEST_META,
    $20d7830c104e3929$var$LIME_DARKEST_META,
    $20d7830c104e3929$var$YELLOW_DARKEST_META,
    $20d7830c104e3929$var$ORANGE_DARKEST_META,
    $20d7830c104e3929$var$RED_DARKEST_META,
    $20d7830c104e3929$var$MAGENTA_DARKEST_META
];
const $20d7830c104e3929$export$2c649adf8351b065 = [
    $20d7830c104e3929$var$PURPLE_META,
    $20d7830c104e3929$var$YELLOW_META,
    $20d7830c104e3929$var$GREEN_META,
    $20d7830c104e3929$var$TEAL_META,
    $20d7830c104e3929$var$RED_META,
    $20d7830c104e3929$var$ORANGE_META,
    $20d7830c104e3929$var$MAGENTA_META,
    $20d7830c104e3929$var$GREY_DARKER_META,
    $20d7830c104e3929$export$11b75436f568ab00
];
const $20d7830c104e3929$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$20d7830c104e3929$export$2c649adf8351b065.forEach((option)=>{
    $20d7830c104e3929$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $20d7830c104e3929$export$20b2b274810f728a = [
    $20d7830c104e3929$export$7c314e2461a7241b,
    $20d7830c104e3929$var$YELLOW_DARKER_META,
    $20d7830c104e3929$var$GREEN_DARKER_META,
    $20d7830c104e3929$export$6daaa1cc3f46f41,
    $20d7830c104e3929$var$RED_DARKER_META,
    $20d7830c104e3929$var$ORANGE_DARKER_META,
    $20d7830c104e3929$var$MAGENTA_DARKER_META,
    $20d7830c104e3929$var$GREY_DARKER_META,
    $20d7830c104e3929$var$GREY_DARKEST_META
];
const $20d7830c104e3929$export$7c14120abebd4749 = {};
$20d7830c104e3929$export$7f42563469df7e01.forEach((option)=>{
    $20d7830c104e3929$export$7c14120abebd4749[option.name] = option;
});
module.exports["HASH_RANDOMISER"] = $20d7830c104e3929$export$d15e38bcd75fda7c;
module.exports["MOD_VALUE"] = $20d7830c104e3929$export$e143f4b09221a374;
module.exports["GREY_META"] = $20d7830c104e3929$export$11b75436f568ab00;
module.exports["OPTION_COLOR_THEMES"] = $20d7830c104e3929$export$7f42563469df7e01;
module.exports["OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT"] = $20d7830c104e3929$export$2c649adf8351b065;
module.exports["OPTION_COLOR_THEMES_MAP"] = $20d7830c104e3929$export$7c14120abebd4749;

});

parcelRegister("fjEgq", function(module, exports) {
const $12054bb6acd6b165$export$4c5677df188c2495 = [
    'hourly',
    'daily',
    'weekdays',
    'custom'
];
const $12054bb6acd6b165$export$215ebe7970eaff4e = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
module.exports["FREQUENCY_VALUES"] = $12054bb6acd6b165$export$4c5677df188c2495;

});

parcelRegister("KvxxC", function(module, exports) {

var $SJBPH = parcelRequire("SJBPH");


var $fESy2 = parcelRequire("fESy2");

const $6ae33ba5ddb3578d$var$WEEKDAY_REF_ANCHOR = new Date(2024, 0, 1);
const $6ae33ba5ddb3578d$export$f9c20d3c74980581 = (frequency, formatMessage)=>{
    switch(frequency){
        case 'hourly':
            return formatMessage((0, $fESy2.default).frequencyOptionHourly);
        case 'daily':
            return formatMessage((0, $fESy2.default).frequencyOptionDaily);
        case 'weekdays':
            return formatMessage((0, $fESy2.default).frequencyOptionWeekdays);
        case 'custom':
            return formatMessage((0, $fESy2.default).frequencyOptionCustom);
        default:
            return frequency;
    }
};
const $6ae33ba5ddb3578d$export$f54b0914ac0519f8 = (day, formatDate)=>{
    const index = (0, $SJBPH.SCHEDULED_CHAT_DAYS).indexOf(day);
    const d = new Date($6ae33ba5ddb3578d$var$WEEKDAY_REF_ANCHOR);
    d.setDate(d.getDate() + index);
    return formatDate(d, {
        weekday: 'long'
    });
};
const $6ae33ba5ddb3578d$export$87ef3d8c7f595699 = (payload)=>{
    const errors = [];
    if (!payload.name?.trim()) errors.push('Name is required');
    return {
        isValid: errors.length === 0,
        errors: errors
    };
};
module.exports["frequencyLabelFor"] = $6ae33ba5ddb3578d$export$f9c20d3c74980581;
module.exports["weekdayLabelFor"] = $6ae33ba5ddb3578d$export$f54b0914ac0519f8;

});

parcelRegister("3CoEp", function(module, exports) {
const $d33209bbb5b85d5e$export$590dff6126d55b43 = 0.05;
module.exports["STEP_WEIGHT"] = $d33209bbb5b85d5e$export$590dff6126d55b43;

});

parcelRegister("lNAt2", function(module, exports) {
const $7e39e718c4e877b6$export$62ce0cc0b5f9371c = (steps)=>{
    return steps.length ? Math.max(...steps.map((step)=>step.order)) : 0;
};
module.exports["getLastStepOrder"] = $7e39e718c4e877b6$export$62ce0cc0b5f9371c;

});

parcelRegister("eOncg", function(module, exports) {
const $ac87ba94b06795d5$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $ac87ba94b06795d5$export$855ece989b15eb57 = (type)=>$ac87ba94b06795d5$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $ac87ba94b06795d5$export$855ece989b15eb57;

});

parcelRegister("SgG5A", function(module, exports) {
const $18dac20f4b110cd2$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $18dac20f4b110cd2$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $0a31fb228d2d8794$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $18dac20f4b110cd2$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $18dac20f4b110cd2$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $18dac20f4b110cd2$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};
module.exports["handleNavigation"] = $0a31fb228d2d8794$export$706ad1af8096e280;

});

parcelRegister("6xGiN", function(module, exports) {
const $4c36a37d1ec0bbb1$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $4c36a37d1ec0bbb1$export$9ccb639b7a119f61;

});

parcelRegister("e9sRm", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $4YmBn = parcelRequire("4YmBn");


var $dwFAv = parcelRequire("dwFAv");


var $6BBXc = parcelRequire("6BBXc");


var $dWqqf = parcelRequire("dWqqf");

const $665d55b10265191d$export$37d3126be6549b13 = 10000;


function $a4d84ae2aec06de7$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $eb3ax.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $6BBXc.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $dWqqf.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $dwFAv.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $4YmBn.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $dwFAv.getExpiresAt)((0, $665d55b10265191d$export$37d3126be6549b13))) : resourceMaxAge
    };
}
module.exports["createLoadingSlice"] = $a4d84ae2aec06de7$export$dc62515c8f0b52dd;

});

parcelRegister("i8FEH", function(module, exports) {

var $4YmBn = parcelRequire("4YmBn");

/**
 * Utility method to created async versions of getData functions
 */ const $d349493e195c3ff4$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $d349493e195c3ff4$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $d349493e195c3ff4$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $4YmBn.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $4YmBn.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $4YmBn.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("8QX4p", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1E1qs = parcelRequire("1E1qs");


var $3MfCJ = parcelRequire("3MfCJ");

var $6721002a4787153c$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $6721002a4787153c$var$fromEntries = ($6721002a4787153c$var$_Object$fromEntries = Object.fromEntries) != null ? $6721002a4787153c$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $6721002a4787153c$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $6721002a4787153c$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $6721002a4787153c$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($6721002a4787153c$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($6721002a4787153c$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($6721002a4787153c$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $6721002a4787153c$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($6721002a4787153c$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $6721002a4787153c$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$6721002a4787153c$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $6721002a4787153c$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($6721002a4787153c$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $6721002a4787153c$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($6721002a4787153c$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $6721002a4787153c$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($6721002a4787153c$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $6721002a4787153c$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $6721002a4787153c$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $6721002a4787153c$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $3MfCJ.getResourceState)(dependencyType, key)) || (0, $1E1qs.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $3MfCJ.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $eb3ax.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };
module.exports["actionWithDependencies"] = $6721002a4787153c$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $6721002a4787153c$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $6721002a4787153c$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $6721002a4787153c$export$75915f81f2a6540a;

});

parcelRegister("dwFAv", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $9d8e85fec38e0a64$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $9d8e85fec38e0a64$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $eb3ax.default)({}, slice, {
        expiresAt: $9d8e85fec38e0a64$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $9d8e85fec38e0a64$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $9d8e85fec38e0a64$export$18d1d420fd588368;

});

parcelRegister("6BBXc", function(module, exports) {
const $4cf3a39c2bd34eb8$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $4cf3a39c2bd34eb8$export$58634b3a58ae66b7;

});

parcelRegister("1E1qs", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $6xGiN = parcelRequire("6xGiN");


var $4YmBn = parcelRequire("4YmBn");


var $dwFAv = parcelRequire("dwFAv");

/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $606cd3eaec39a6c0$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $132aa1f927afd5af$export$fa8e33c3301e2e94 = ()=>(0, $eb3ax.default)({}, (0, $606cd3eaec39a6c0$export$2df85a734ff5ed27), {
        expiresAt: (0, $dwFAv.getExpiresAt)((0, $4YmBn.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $6xGiN.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $132aa1f927afd5af$export$fa8e33c3301e2e94;

});

parcelRegister("55wRK", function(module, exports) {
const $3b46e9dd564adca8$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $3b46e9dd564adca8$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$3b46e9dd564adca8$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $3b46e9dd564adca8$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $3b46e9dd564adca8$export$cd7fbe7e979df558;

});

parcelRegister("6HMxd", function(module, exports) {

var $55wRK = parcelRequire("55wRK");


var $aa6fF = parcelRequire("aa6fF");

const $4e1c68349cdf8550$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $aa6fF.routeHasResources)(nextRoute)) return [];
    if ((0, $aa6fF.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $55wRK.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $55wRK.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $4e1c68349cdf8550$export$7cbbc763e2f3d65d;

});

parcelRegister("8saqi", function(module, exports) {

var $3MfCJ = parcelRequire("3MfCJ");

const $627906188e1918cd$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $627906188e1918cd$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $627906188e1918cd$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $627906188e1918cd$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $627906188e1918cd$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $3MfCJ.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $627906188e1918cd$export$89440b7623c2c75c;

});

parcelRegister("3MfCJ", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $eb3ax = parcelRequire("eb3ax");

function $2c01f9588aa005df$var$_toPropertyKey(t) {
    var i = $2c01f9588aa005df$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $2c01f9588aa005df$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $2c01f9588aa005df$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $2c01f9588aa005df$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $eb3ax.default)({}, prefetching, {
                [type]: (0, $eb3ax.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $2c01f9588aa005df$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($2c01f9588aa005df$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $eb3ax.default)({}, data, {
                [type]: (0, $eb3ax.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $2c01f9588aa005df$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $2c01f9588aa005df$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1eVGO.default)(data, [
            type
        ].map($2c01f9588aa005df$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1eVGO.default)(resourceForType, [
                key
            ].map($2c01f9588aa005df$var$_toPropertyKey));
            setState({
                data: (0, $eb3ax.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["getPrefetchSlice"] = $2c01f9588aa005df$export$11374758be89e40;
module.exports["setPrefetchSlice"] = $2c01f9588aa005df$export$1e32615dc8354436;
module.exports["setResourceState"] = $2c01f9588aa005df$export$704f800f263b050e;
module.exports["getResourceState"] = $2c01f9588aa005df$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $2c01f9588aa005df$export$d40f35dc5952864b;

});

parcelRegister("aa6fF", function(module, exports) {
const $765fb0018d5d6de0$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $765fb0018d5d6de0$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $765fb0018d5d6de0$export$740886389191c640;
module.exports["routeHasChanged"] = $765fb0018d5d6de0$export$221027ff1aa38f82;

});

parcelRegister("bx2PP", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $8654f9ba606de45c$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $8654f9ba606de45c$var$NonError);
    }
}
const $8654f9ba606de45c$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $8654f9ba606de45c$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $8654f9ba606de45c$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $8654f9ba606de45c$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $8654f9ba606de45c$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $8654f9ba606de45c$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $8654f9ba606de45c$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $8654f9ba606de45c$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $8654f9ba606de45c$var$NonError(value);
};
module.exports["serializeError"] = $8654f9ba606de45c$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $8654f9ba606de45c$export$64cddc1e268e9046;

});

parcelRegister("c35iW", function(module, exports) {
const $8c59e1386e3868bb$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $8c59e1386e3868bb$var$isFresh = (resource)=>{
    if ($8c59e1386e3868bb$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $8c59e1386e3868bb$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($8c59e1386e3868bb$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $8c59e1386e3868bb$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $8c59e1386e3868bb$export$399de8c43d0ece3c;

});

parcelRegister("8Bqvb", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $6436562f2863ccc0$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $eb3ax.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $6436562f2863ccc0$export$2e4da1b414980956;

});

parcelRegister("dWqqf", function(module, exports) {
class $a2653017d0e0a75f$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $a2653017d0e0a75f$export$66d311bf29d5c89c;

});

parcelRegister("gX50G", function(module, exports) {
const $c5760ae8988d5a1f$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $c5760ae8988d5a1f$export$3ceb62baab058c6b;

});

parcelRegister("lRtsS", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("6xGiN")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("e9sRm")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("8QX4p")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("8QX4p")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("8QX4p")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("8QX4p")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("dwFAv")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("dwFAv")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("1E1qs")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("6HMxd")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("8saqi")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("3MfCJ")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("3MfCJ")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("3MfCJ")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("3MfCJ")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("3MfCJ")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("bx2PP")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("bx2PP")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("c35iW")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("c35iW")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("8Bqvb")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("dWqqf")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("gX50G")).transformData);

var $6xGiN = parcelRequire("6xGiN");


var $e9sRm = parcelRequire("e9sRm");


var $i8FEH = parcelRequire("i8FEH");


var $8QX4p = parcelRequire("8QX4p");


var $dwFAv = parcelRequire("dwFAv");


var $6BBXc = parcelRequire("6BBXc");


var $1E1qs = parcelRequire("1E1qs");


var $55wRK = parcelRequire("55wRK");


var $6HMxd = parcelRequire("6HMxd");


var $8saqi = parcelRequire("8saqi");


var $3MfCJ = parcelRequire("3MfCJ");


var $aa6fF = parcelRequire("aa6fF");


var $bx2PP = parcelRequire("bx2PP");


var $c35iW = parcelRequire("c35iW");


var $8Bqvb = parcelRequire("8Bqvb");


var $dWqqf = parcelRequire("dWqqf");


var $gX50G = parcelRequire("gX50G");


});

parcelRegister("i642l", function(module, exports) {
/**
 * @generated SignedSource<<64b6d8b86557338ce646901cf7430d6a>>
 * @relayHash d79a1b458e808407b82c4438022bf749
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00f3628c39a48153527b8dc43e0b0886e320b7dc266b3e8f4c82a245ba29c2fc
const $54b3f2d4dd4abf4e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "conversationId",
                    "variableName": "conversationId"
                }
            ],
            "concreteType": "ConvoAiUpdateConversationStatePayload",
            "kind": "LinkedField",
            "name": "convoAi_completeConversation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgenticPlanToolInChatCompleteConversationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgenticPlanToolInChatCompleteConversationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "00f3628c39a48153527b8dc43e0b0886e320b7dc266b3e8f4c82a245ba29c2fc",
            "metadata": {},
            "name": "AgenticPlanToolInChatCompleteConversationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$54b3f2d4dd4abf4e$var$node.hash = "f0d717c581b8c906f07ee272429490d6";
var $54b3f2d4dd4abf4e$export$2e2bcd8739ae039 = $54b3f2d4dd4abf4e$var$node;
module.exports["default"] = $54b3f2d4dd4abf4e$export$2e2bcd8739ae039;

});

parcelRegister("8PIsi", function(module, exports) {
/**
 * @generated SignedSource<<da726d4bd48e9ed5912c31ec3cd5973c>>
 * @relayHash be9380e0dc1226e249979c3a826857b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 72effeee1c7a4fd1048cb1e277e4018bfcfee280e407ca39d934cb2510e07be4
const $9a0202cb6c0655ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v3 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgenticPlanToolInChatQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AgenticPlanTool"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgenticPlanToolInChatQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "concreteType": "JiraRichTextField",
                                    "kind": "LinkedField",
                                    "name": "descriptionField",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraRichText",
                                            "kind": "LinkedField",
                                            "name": "richText",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "adfValue",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "72effeee1c7a4fd1048cb1e277e4018bfcfee280e407ca39d934cb2510e07be4",
            "metadata": {},
            "name": "AgenticPlanToolInChatQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9a0202cb6c0655ac$var$node.hash = "cbc3f2cc0ca7d80416a02ad903272bd4";
var $9a0202cb6c0655ac$export$2e2bcd8739ae039 = $9a0202cb6c0655ac$var$node;
module.exports["default"] = $9a0202cb6c0655ac$export$2e2bcd8739ae039;

});

parcelRegister("kp580", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b916b382d443b694c70482ec980866ec>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ const $eec4d9b8943404d8$export$82d1529631ebf0fd = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$f936b2d6e392668e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z'/> </svg> ";
const $eec4d9b8943404d8$export$ef4515a2b2e64fb9 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z'/> </svg> ";
const $eec4d9b8943404d8$export$e46fc5b9f36b0a2a = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727' clip-rule='evenodd'/> <path fill='%23101214' d='M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z'/> </svg> ";
const $eec4d9b8943404d8$export$937778b9dd7a3235 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z'/> </svg> ";
const $eec4d9b8943404d8$export$d994760fc7f4d251 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578'/> </svg> ";
const $eec4d9b8943404d8$export$4ed1e309cbc9944e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582'/> </svg> ";
const $eec4d9b8943404d8$export$f082a360c4afba79 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$591e8b3773b35267 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$a3743ca7417fb23c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z'/> <path fill='%23101214' d='M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z'/> </svg> ";
const $eec4d9b8943404d8$export$c7c3bc01199c13a4 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617'/> </svg> ";
const $eec4d9b8943404d8$export$d522b359cb8c5c04 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673'/> </svg> ";
const $eec4d9b8943404d8$export$52ddff92dfaa8b68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433'/> </svg> ";
const $eec4d9b8943404d8$export$9fbf2bb44326bb19 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$e293cb595239063c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z'/> </svg> ";
const $eec4d9b8943404d8$export$d9455021fb3d272f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <path fill='%2394c748' d='M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z'/> <path fill='%23101214' d='m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z'/> </svg> ";
const $eec4d9b8943404d8$export$3ed6243f17a53ae7 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <rect width='48' height='48' fill='%23c97cf4' rx='12'/> <path fill='%23101214' d='M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z'/> </svg> ";
const $eec4d9b8943404d8$export$2837c3a55abaa285 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z'/> </svg> ";
const $eec4d9b8943404d8$export$51f93e7b4b9eb293 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0'/> <path fill='%23101214' fill-rule='evenodd' d='M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$eb29548f99467d60 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $eec4d9b8943404d8$export$2aba1ca138d7bd07 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $eec4d9b8943404d8$export$2e2deae5fbafd37b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z'/> </svg> ";
const $eec4d9b8943404d8$export$c7a8f12525e3fb68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 32 32'> <g clip-path='url(%23clip0_95164_16219)'> <path fill='%23dddee1' d='M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z'/> <g clip-path='url(%23clip1_95164_16219)'> <path fill='%23101214' fill-rule='evenodd' d='M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z' clip-rule='evenodd'/> </g> </g> <defs> <clipPath id='clip0_95164_16219'> <path fill='%23fff' d='M0 0h32v32H0z'/> </clipPath> <clipPath id='clip1_95164_16219'> <path fill='%23fff' d='M2 2h28v28H2z'/> </clipPath> </defs> </svg> ";
const $eec4d9b8943404d8$export$817524b4a4c71959 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 55 55'> <path fill='%231868db' d='M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z'/> <path fill='%23fff' d='M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z'/> </svg> ";
const $eec4d9b8943404d8$export$645368f1ea0478bc = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z'/> </svg> ";
const $eec4d9b8943404d8$export$18c65aa2927f3995 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23c97cf4' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z'/> </svg> ";
const $eec4d9b8943404d8$export$8a1ee2e50fe5beb1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 25 24'> <path fill='%23fff' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5'/> <path stroke='%23dddee1' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z'/> <path fill='%231868db' d='M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z'/> </svg> ";
const $eec4d9b8943404d8$export$b90ef39cc7d9d158 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z'/> </svg> ";
const $eec4d9b8943404d8$export$fa286aa7e20bed9b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z'/> </svg> ";
const $eec4d9b8943404d8$export$668450ac5134d2b8 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23625df5' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $eec4d9b8943404d8$export$ce29d3d34b2cdd71 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $eec4d9b8943404d8$export$24d80805366b7b8f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z'/> </svg> ";
const $eec4d9b8943404d8$export$a07965903d0d8925 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848'/> </svg> ";
const $eec4d9b8943404d8$export$5d8aa0e5e461a369 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$5bde95973ddbe69b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678' clip-rule='evenodd'/> <path fill='%23101214' fill-rule='evenodd' d='M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$238fafeb4135d57 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z'/> <path fill='%23101214' d='M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75'/> </svg> ";
const $eec4d9b8943404d8$export$494586f00e0959f0 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$d82a05c5cfbe1aa1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z'/> <path fill='%23fff' d='M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691'/> </svg> ";
const $eec4d9b8943404d8$export$8687ffcdea58e000 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$dc9f14a5d9a626e2 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68'/> </svg> ";
const $eec4d9b8943404d8$export$d2c4cddab147c0da = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z' clip-rule='evenodd'/> <path fill='%23101214' d='M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z'/> </svg> ";
const $eec4d9b8943404d8$export$eaf28ddd8a75ca21 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$2475d3c354c72640 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63'/> </svg> ";
const $eec4d9b8943404d8$export$a1ac7613cb802f12 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231558bc' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z'/> </svg> ";
const $eec4d9b8943404d8$export$750778568a97222d = {
    admin: $eec4d9b8943404d8$export$82d1529631ebf0fd,
    align: $eec4d9b8943404d8$export$f936b2d6e392668e,
    analytics: $eec4d9b8943404d8$export$ef4515a2b2e64fb9,
    assets: $eec4d9b8943404d8$export$e46fc5b9f36b0a2a,
    bamboo: $eec4d9b8943404d8$export$937778b9dd7a3235,
    bitbucketDataCenter: $eec4d9b8943404d8$export$d994760fc7f4d251,
    bitbucket: $eec4d9b8943404d8$export$4ed1e309cbc9944e,
    chat: $eec4d9b8943404d8$export$f082a360c4afba79,
    companyHub: $eec4d9b8943404d8$export$591e8b3773b35267,
    compass: $eec4d9b8943404d8$export$a3743ca7417fb23c,
    confluenceDataCenter: $eec4d9b8943404d8$export$c7c3bc01199c13a4,
    confluence: $eec4d9b8943404d8$export$d522b359cb8c5c04,
    crowd: $eec4d9b8943404d8$export$52ddff92dfaa8b68,
    customLink: $eec4d9b8943404d8$export$9fbf2bb44326bb19,
    customerServiceManagement: $eec4d9b8943404d8$export$e293cb595239063c,
    dx: $eec4d9b8943404d8$export$d9455021fb3d272f,
    feedback: $eec4d9b8943404d8$export$3ed6243f17a53ae7,
    focus: $eec4d9b8943404d8$export$2837c3a55abaa285,
    goals: $eec4d9b8943404d8$export$51f93e7b4b9eb293,
    guardDetect: $eec4d9b8943404d8$export$eb29548f99467d60,
    guard: $eec4d9b8943404d8$export$2aba1ca138d7bd07,
    home: $eec4d9b8943404d8$export$2e2deae5fbafd37b,
    hub: $eec4d9b8943404d8$export$c7a8f12525e3fb68,
    jiraCodingAgent: $eec4d9b8943404d8$export$817524b4a4c71959,
    jiraDataCenter: $eec4d9b8943404d8$export$645368f1ea0478bc,
    jiraProductDiscovery: $eec4d9b8943404d8$export$18c65aa2927f3995,
    jiraServiceManagementDataCenter: $eec4d9b8943404d8$export$8a1ee2e50fe5beb1,
    jiraServiceManagement: $eec4d9b8943404d8$export$b90ef39cc7d9d158,
    jira: $eec4d9b8943404d8$export$fa286aa7e20bed9b,
    loomInternal: $eec4d9b8943404d8$export$668450ac5134d2b8,
    loom: $eec4d9b8943404d8$export$ce29d3d34b2cdd71,
    moreAtlassianApps: $eec4d9b8943404d8$export$24d80805366b7b8f,
    opsgenie: $eec4d9b8943404d8$export$a07965903d0d8925,
    projects: $eec4d9b8943404d8$export$5d8aa0e5e461a369,
    rovoDevAgent: $eec4d9b8943404d8$export$5bde95973ddbe69b,
    rovoDev: $eec4d9b8943404d8$export$238fafeb4135d57,
    rovoHex: $eec4d9b8943404d8$export$494586f00e0959f0,
    rovo: $eec4d9b8943404d8$export$d82a05c5cfbe1aa1,
    search: $eec4d9b8943404d8$export$8687ffcdea58e000,
    statuspage: $eec4d9b8943404d8$export$dc9f14a5d9a626e2,
    studio: $eec4d9b8943404d8$export$d2c4cddab147c0da,
    talent: $eec4d9b8943404d8$export$eaf28ddd8a75ca21,
    teams: $eec4d9b8943404d8$export$2475d3c354c72640,
    trello: $eec4d9b8943404d8$export$a1ac7613cb802f12
};
module.exports["rovoHexIcon"] = $eec4d9b8943404d8$export$494586f00e0959f0;

});

parcelRegister("bJveX", function(module, exports) {

var $axyhv = parcelRequire("axyhv");


var $cQ93H = parcelRequire("cQ93H");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");

var $iV65j = parcelRequire("iV65j");


var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $eNbr2 = parcelRequire("eNbr2");


var $4MnFz = parcelRequire("4MnFz");


var $7sJoX = parcelRequire("7sJoX");


var $24dy7 = parcelRequire("24dy7");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $3BY7M = parcelRequire("3BY7M");


var $lpNn5 = parcelRequire("lpNn5");


var $4n04n = parcelRequire("4n04n");


var $6rwn6 = parcelRequire("6rwn6");


var $kUcLs = parcelRequire("kUcLs");

parcelRequire("h9r4d");
var $kFTt2 = parcelRequire("kFTt2");


var $lqNTR = parcelRequire("lqNTR");


var $53mTv = parcelRequire("53mTv");


var $gFn8K = parcelRequire("gFn8K");


var $9xrOI = parcelRequire("9xrOI");


var $jTIEM = parcelRequire("jTIEM");

const $d267f533c20499e8$var$moreOptionsButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.moreOptionsButtonLabel",
    defaultMessage: "More Options"
});
const $d267f533c20499e8$var$startWorkingButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.startWorkingButtonLabel",
    defaultMessage: "Start working"
});
const $d267f533c20499e8$var$startWorkingTooltipMessage = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.startWorkingTooltip",
    defaultMessage: "Add plan to Description and start working"
});
const $d267f533c20499e8$var$updateDescriptionButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.updateDescriptionButtonLabel",
    defaultMessage: "Update description"
});
const $d267f533c20499e8$var$continueWithoutPublishButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.continueWithoutPublishButtonLabel",
    defaultMessage: "Continue without publishing"
});
const $d267f533c20499e8$var$continueButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.continueButtonLabel",
    defaultMessage: "Continue"
});
const $d267f533c20499e8$var$showMoreButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.showMoreButtonLabel",
    defaultMessage: "Show more"
});
const $d267f533c20499e8$var$showLessButtonLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.showLessButtonLabel",
    defaultMessage: "Show less"
});
const $d267f533c20499e8$var$editPlanLabel = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.editPlanLabel",
    defaultMessage: "Edit plan"
});
const $d267f533c20499e8$var$titleErrorFlagMessages = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.titleErrorFlagMessages",
    defaultMessage: "Something went wrong"
});
const $d267f533c20499e8$var$contentErrorFlagMessages = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.contentErrorFlagMessages",
    defaultMessage: "We couldn't update the issue description. Please try again."
});
const $d267f533c20499e8$var$tryAgainErrorFlagMessages = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.AgenticPlanTool.tryAgainErrorFlagMessages",
    defaultMessage: "Try again"
});
const $d267f533c20499e8$var$MAX_COLLAPSED_HEIGHT = 135;
const $d267f533c20499e8$var$styles = {
    editorWrapper: "_4kiQYAUofl _1mT5xdRAKS",
    editableEditorWrapper: "_0wOv4Q7zJH _313842B0rP _0adFHsB0rP _2XsHFMB0rP _0Of8r28HPE _1Znuxb8HPE _2Zuz6Q8HPE _1eOmH6o126",
    readOnlyEditorWrapper: "_0wOv4Q18ZR",
    contentContainer: "_1mT5xdRAKS",
    contentCollapsed: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3r13wc",
    contentExpanded: "_4bt5LAYvD1 _2WAcuGYvD1",
    contentExpandedChat: "_1wydGWS40j",
    contentCollapsedMask: "_3X9j4qIXLV",
    showMoreButtonWrapper: "_1mT5xdWVPG _0Bm75G2ADO _3OE6xYdnbC _4ApkO2dnbC _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _42Yu6B7dHp",
    showLessButtonWrapper: "_1mT5xdWVPG _0Bm75GdnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VpJKa _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _42Yu6B7dHp _1YKVNsdnbC _1kOSYt9v2r _3Z9K0wLrT7 _0qk6IKxt7V _2OgLIs7dHp",
    expandToggleButton: "_0bjKvDS5Zs _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _0KLXrulfZc _1UtDYzZpcK _1eOmH6d1Zr _0clgaMy7kJ _3gzVzLJNoT",
    readViewClickTarget: "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _3OE6xYdnbC _0wOv4QJxkL _0KLXrujOvk"
};
function $d267f533c20499e8$var$isAgenticPlanToolData(data) {
    if (typeof data !== 'object' || data === null) return false;
    const content = Reflect.get(data, 'content');
    const issueKey = Reflect.get(data, 'issueKey');
    return typeof content === 'string' && typeof issueKey === 'string';
}
function $d267f533c20499e8$export$42d8ca0d94a01d46({ message: message, onExecuteAgent: onExecuteAgent, footer: footer = (0, $gFn8K.defaultFooter), ContentWrapperComponent: ContentWrapperComponent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, isFromChat: isFromChat = false, hideFooter: hideFooter = false, issueRef: issueRef = null, isLoadingIssue: isLoadingIssue = false, onScrollIntoView: onScrollIntoView }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const [isUpdatingDescription, setIsUpdatingDescription] = (0, $cozmU.useState)(false);
    const action = message.actions?.[0];
    const actionData = $d267f533c20499e8$var$isAgenticPlanToolData(action?.data) ? action.data : undefined;
    const content = actionData?.content ?? '';
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isOverflowing, setIsOverflowing] = (0, $cozmU.useState)(false);
    const [isLinkingPlatformReady, setIsLinkingPlatformReady] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [editedAdf, setEditedAdf] = (0, $cozmU.useState)(null);
    const descriptionData = (0, $6SsN4.useFragment)((0, $cQ93H.default), issueRef);
    const issueKey = descriptionData?.key ?? actionData?.issueKey ?? '';
    const showOnlyContinueButton = !isLoadingIssue && descriptionData?.descriptionField?.id == null;
    const editorActionsRef = (0, $cozmU.useRef)(null);
    const footerRef = (0, $cozmU.useRef)(null);
    const handleContentRef = (0, $cozmU.useCallback)((node)=>{
        if (!node) return;
        setIsOverflowing(node.scrollHeight > $d267f533c20499e8$var$MAX_COLLAPSED_HEIGHT);
    }, []); // Hydrate the Linking Platform provider regex cache so smart links always render
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        (0, $kUcLs.hydrateLinkingPlatformCache)(globalThis.localStorage).finally(()=>{
            setIsLinkingPlatformReady(true);
        });
    }, []); // Parse content string → ADF DocNode once, memoised on content change and hydration of smart links cache
    const parsedAdf = (0, $cozmU.useMemo)(()=>(0, $6rwn6.encodeAdf)(content), [
        content,
        isLinkingPlatformReady
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const [commitMutation] = (0, $6SsN4.useMutation)((0, $axyhv.default));
    const showUpdateDescriptionErrorFlag = (0, $cozmU.useCallback)(({ errorMsg: errorMsg, isRetry: isRetry, onTryAgain: onTryAgain })=>{
        (0, $kFTt2.default)({
            meta: {
                id: 'agenticPlanToolUpdateDescription',
                packageName: (0, $53mTv.PACKAGE_NAME),
                teamName: (0, $53mTv.TEAM_NAME)
            },
            attributes: {
                error: errorMsg,
                issueKey: issueKey
            }
        });
        showFlag({
            id: 'agentic-plan-tool-update-description-error',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
            title: formatMessage($d267f533c20499e8$var$titleErrorFlagMessages),
            description: formatMessage($d267f533c20499e8$var$contentErrorFlagMessages),
            actions: onTryAgain ? [
                {
                    content: formatMessage($d267f533c20499e8$var$tryAgainErrorFlagMessages),
                    onClick: onTryAgain
                }
            ] : undefined
        });
        if (!isRetry) (0, $jTIEM.updateDescriptionUfoExperience).failure();
        setIsUpdatingDescription(false);
    }, [
        formatMessage,
        issueKey,
        showFlag
    ]);
    const resolveCurrentAdf = (0, $cozmU.useCallback)(async ()=>{
        if (isEditing && editorActionsRef.current) {
            const editorValue = await editorActionsRef.current.getValue();
            if (editorValue) return editorValue;
        }
        return editedAdf ?? parsedAdf;
    }, [
        editedAdf,
        isEditing,
        parsedAdf
    ]);
    const getPlanEditLevelForAdf = (0, $cozmU.useCallback)((latestAdf)=>{
        const originalPlanMarkdown = (0, $4n04n.adfToMarkdownPlus)(parsedAdf).markdown;
        const submittedPlanMarkdown = (0, $4n04n.adfToMarkdownPlus)(latestAdf).markdown;
        return (0, $9xrOI.getPlanEditLevel)(originalPlanMarkdown, submittedPlanMarkdown);
    }, [
        parsedAdf
    ]);
    const applyEditorChanges = (0, $cozmU.useCallback)((latestAdf)=>{
        if (!isEditing) return;
        setEditedAdf(latestAdf);
        setIsExpanded(true);
        setIsEditing(false);
    }, [
        isEditing
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(async ({ isRetry: isRetry } = {})=>{
        // When not editing, resolve synchronously to avoid microtask deferral
        // (important so that retry callbacks fire commitMutation in the same tick).
        const latestAdf = isEditing ? await resolveCurrentAdf() : editedAdf ?? parsedAdf;
        setIsUpdatingDescription(true);
        applyEditorChanges(latestAdf);
        if (!isRetry) (0, $jTIEM.updateDescriptionUfoExperience).start();
        const descriptionFieldId = descriptionData?.descriptionField?.id ?? undefined;
        const issueDescription = descriptionData?.descriptionField?.richText?.adfValue?.json ?? undefined;
        if (!descriptionFieldId) {
            showUpdateDescriptionErrorFlag({
                errorMsg: 'Description field not found for issue',
                isRetry: isRetry,
                onTryAgain: ()=>handleConfirm({
                        isRetry: true
                    })
            });
            return;
        }
        const existingContent = issueDescription?.content ?? [];
        const planContent = latestAdf.content ?? [];
        const updatedDescription = {
            type: 'doc',
            version: 1,
            content: [
                ...existingContent,
                ...existingContent.length > 0 && planContent.length > 0 ? [
                    {
                        type: 'rule'
                    }
                ] : [],
                ...planContent
            ]
        };
        commitMutation({
            variables: {
                input: {
                    id: descriptionFieldId,
                    operation: {
                        document: {
                            jsonValue: updatedDescription,
                            version: updatedDescription.version
                        },
                        operation: 'SET'
                    }
                }
            },
            onCompleted (data) {
                const payload = data?.jira?.updateRichTextField;
                if (!payload?.success) {
                    const errorMessage = payload?.errors?.map((e)=>e.message).join(', ') ?? 'Unknown error';
                    showUpdateDescriptionErrorFlag({
                        errorMsg: errorMessage,
                        isRetry: isRetry,
                        onTryAgain: ()=>handleConfirm({
                                isRetry: true
                            })
                    });
                } else {
                    if (!isRetry) (0, $jTIEM.updateDescriptionUfoExperience).success();
                    onScrollIntoView?.();
                    setIsUpdatingDescription(false);
                }
            },
            onError (error) {
                showUpdateDescriptionErrorFlag({
                    errorMsg: error.message,
                    isRetry: isRetry,
                    onTryAgain: ()=>handleConfirm({
                            isRetry: true
                        })
                });
            }
        });
        if (!isRetry) onExecuteAgent(latestAdf, issueKey, true, getPlanEditLevelForAdf(latestAdf));
    }, [
        applyEditorChanges,
        commitMutation,
        descriptionData,
        editedAdf,
        getPlanEditLevelForAdf,
        isEditing,
        issueKey,
        onExecuteAgent,
        parsedAdf,
        resolveCurrentAdf,
        showUpdateDescriptionErrorFlag,
        onScrollIntoView
    ]);
    const startEditing = (0, $cozmU.useCallback)(()=>{
        setIsEditing(true);
        setIsExpanded(true);
    }, []);
    const currentAdf = editedAdf ?? parsedAdf;
    const isPlanEditable = !isFromChat;
    const handleEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        editorActionsRef.current = editorActions;
    }, []);
    const handleEditorBlur = (0, $cozmU.useCallback)(async ()=>{
        try {
            const latestAdf = await resolveCurrentAdf();
            applyEditorChanges(latestAdf);
        } catch (error) {
            (0, $kFTt2.default)({
                meta: {
                    id: 'agenticPlanToolEditorBlur',
                    packageName: (0, $53mTv.PACKAGE_NAME),
                    teamName: (0, $53mTv.TEAM_NAME)
                },
                attributes: {
                    error: 'Unknown error during editor blur',
                    errorType: error instanceof Error ? error.name : typeof error,
                    issueKey: issueKey
                }
            });
        }
    }, [
        applyEditorChanges,
        issueKey,
        resolveCurrentAdf
    ]);
    const handleExpandToggle = (0, $cozmU.useCallback)(async ()=>{
        if (!isExpanded) {
            setIsExpanded(true);
            if (isPlanEditable) setIsEditing(true);
            return;
        }
        if (isEditing) {
            const latestAdf = await resolveCurrentAdf();
            setEditedAdf(latestAdf);
            setIsEditing(false);
        }
        setIsExpanded(false);
    }, [
        isEditing,
        isExpanded,
        isPlanEditable,
        resolveCurrentAdf
    ]);
    const handleContentBlur = (0, $cozmU.useCallback)((event)=>{
        // Only commit on blur while the editor is active.
        if (!isEditing) return;
         // Keep editing when focus stays inside the editor content region (for example
        // editor → editor toolbar) or moves to the footer action buttons. Footer actions
        // commit explicitly via their own handlers, so blur must NOT fire on editor → footer
        // (otherwise the resulting re-render swallows the button click → double-click bug).
        if (event.relatedTarget instanceof Node && (event.currentTarget.contains(event.relatedTarget) || footerRef.current?.contains(event.relatedTarget) === true)) return;
        handleEditorBlur();
    }, [
        handleEditorBlur,
        isEditing
    ]);
    const handleExecute = (0, $cozmU.useCallback)(async ()=>{
        const latestAdf = await resolveCurrentAdf(); // Commit the editor state on the click itself so footer actions take effect in a single
        // click without depending on the editor blur firing first.
        applyEditorChanges(latestAdf);
        onExecuteAgent(latestAdf, issueKey, false, getPlanEditLevelForAdf(latestAdf));
    }, [
        applyEditorChanges,
        getPlanEditLevelForAdf,
        onExecuteAgent,
        resolveCurrentAdf,
        issueKey
    ]);
    const actionButtons = (0, $cozmU.useMemo)(()=>{
        if ((0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: ()=>handleConfirm(),
            isLoading: isUpdatingDescription
        }, formatMessage($d267f533c20499e8$var$updateDescriptionButtonLabel));
        if (showOnlyContinueButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleExecute
        }, formatMessage($d267f533c20499e8$var$continueButtonLabel));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), {
            appearance: "primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage($d267f533c20499e8$var$startWorkingTooltipMessage)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...tooltipProps,
                onClick: ()=>handleConfirm(),
                isLoading: isUpdatingDescription
            }, formatMessage($d267f533c20499e8$var$startWorkingButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            shouldRenderToParent: true,
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    ref: triggerRef,
                    ...triggerProps,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
                    label: formatMessage($d267f533c20499e8$var$moreOptionsButtonLabel)
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: handleExecute
        }, formatMessage($d267f533c20499e8$var$continueWithoutPublishButtonLabel)))));
    }, [
        formatMessage,
        handleConfirm,
        handleExecute,
        isUpdatingDescription,
        showOnlyContinueButton
    ]);
    const dataProviders = (0, $cozmU.useMemo)(()=>new (0, $eNbr2.default)(), []);
    (0, $cozmU.useEffect)(()=>()=>dataProviders.destroy(), [
        dataProviders
    ]);
    const readOnlyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: handleContentRef,
        xcss: (0, $w6R6I.cx)($d267f533c20499e8$var$styles.editorWrapper, isPlanEditable ? $d267f533c20499e8$var$styles.editableEditorWrapper : $d267f533c20499e8$var$styles.readOnlyEditorWrapper, isExpanded ? $d267f533c20499e8$var$styles.contentExpanded : $d267f533c20499e8$var$styles.contentCollapsed, !isExpanded && isOverflowing ? $d267f533c20499e8$var$styles.contentCollapsedMask : undefined, isExpanded && isFromChat ? $d267f533c20499e8$var$styles.contentExpandedChat : undefined)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        appearance: "comment",
        document: currentAdf,
        dataProviders: dataProviders
    }), isPlanEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $d267f533c20499e8$var$styles.readViewClickTarget,
        "aria-label": formatMessage($d267f533c20499e8$var$editPlanLabel),
        onClick: startEditing
    }));
    const expandToggle = isOverflowing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isExpanded ? $d267f533c20499e8$var$styles.showLessButtonWrapper : $d267f533c20499e8$var$styles.showMoreButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $d267f533c20499e8$var$styles.expandToggleButton,
        onMouseDown: (event)=>event.preventDefault(),
        onClick: handleExpandToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium"
    }, formatMessage(isExpanded ? $d267f533c20499e8$var$showLessButtonLabel : $d267f533c20499e8$var$showMoreButtonLabel))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d267f533c20499e8$var$styles.contentContainer,
        onBlur: handleContentBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentWrapperComponent, null, isEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqNTR.AgenticPlanEditor), {
        defaultValue: currentAdf,
        onEditorReady: handleEditorReady
    }), expandToggle) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, readOnlyContent, expandToggle))), !hideFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: footerRef
    }, footer(actionButtons)));
}
module.exports["AgenticPlanTool"] = $d267f533c20499e8$export$42d8ca0d94a01d46;

});

parcelRegister("domWY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dw75i = parcelRequire("dw75i");

parcelRequire("h9r4d");
var $kFTt2 = parcelRequire("kFTt2");


var $53mTv = parcelRequire("53mTv");

const $8d7d045a8da17626$export$ba4d5f10209bd7f1 = ({ action: action, resolutionType: resolutionType, dataArguments: dataArguments })=>({
        key: action.key,
        tool_source: action.toolSource ?? undefined,
        invocation_id: action.invocationId,
        resolution: {
            type: resolutionType
        },
        data: {
            human_message_id: action.humanMessageId ?? '',
            arguments: dataArguments ?? {}
        }
    });
const $8d7d045a8da17626$export$a72735f19a2f3337 = (actions)=>actions.length > 0 && actions.every((a)=>a?.data != null);
const $8d7d045a8da17626$var$VALID_STATE = {
    [(0, $dw75i.ActionKeys).AgenticPlanTool]: [
        'planned',
        'finished',
        'cancelled'
    ],
    [(0, $dw75i.ActionKeys).MultipleChoiceQuestionsTool]: [
        'planned',
        'finished'
    ]
};
const $8d7d045a8da17626$export$a5ee6eb66100a359 = ({ actions: actions, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId, sendMessageConfirmedTools: sendMessageConfirmedTools, interactionSource: interactionSource, children: children })=>{
    const firstAction = actions[0];
    const [localActionState, setLocalActionState] = (0, $cozmU.useState)(firstAction?.status?.toLowerCase());
    if (!$8d7d045a8da17626$export$a72735f19a2f3337(actions) || !actions[0]) {
        (0, $kFTt2.default)({
            meta: {
                id: interactionSource,
                packageName: (0, $53mTv.PACKAGE_NAME),
                teamName: (0, $53mTv.TEAM_NAME)
            },
            attributes: {
                messageId: messageId
            }
        });
        return null;
    }
    const agenticActions = actions;
    if (!localActionState || !(firstAction.key in $8d7d045a8da17626$var$VALID_STATE) || !$8d7d045a8da17626$var$VALID_STATE[firstAction.key].includes(localActionState)) return null;
    const sendTools = (resolutionType, tools, analyticsAttributes)=>{
        sendMessageConfirmedTools({
            agentId: recipientAgentId,
            conversationId: conversationId,
            messageSources: {
                interactionSource: interactionSource
            },
            confirmed_tools: {
                message_id: messageId,
                tools: tools
            },
            actionedAnalyticsAttributes: analyticsAttributes
        });
        setLocalActionState(resolutionType === 'confirmed' ? 'finished' : 'cancelled');
    };
    const onConfirm = ({ actions: confirmedActions }, analyticsAttributes)=>{
        sendTools('confirmed', confirmedActions.map((action)=>$8d7d045a8da17626$export$ba4d5f10209bd7f1({
                action: action,
                resolutionType: 'confirmed',
                dataArguments: action.data
            })), {
            actionKey: firstAction.key,
            ...analyticsAttributes
        });
    };
    const handleOnDismiss = (_e, _analyticsEvent)=>{
        sendTools('cancelled', agenticActions.map((action)=>$8d7d045a8da17626$export$ba4d5f10209bd7f1({
                action: action,
                resolutionType: 'cancelled',
                dataArguments: action.data
            })), {
            agenticPlanDismissed: true,
            actionKey: firstAction.key
        });
    };
    const message = {
        actions: agenticActions
    };
    return children({
        onConfirm: onConfirm,
        handleOnDismiss: handleOnDismiss,
        message: message,
        localActionState: localActionState,
        markFinished: ()=>setLocalActionState('finished')
    });
};
module.exports["AgenticPlanWrapperInChat"] = $8d7d045a8da17626$export$a5ee6eb66100a359;

});

parcelRegister("7kKC5", function(module, exports) {
/* CollapsibleCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $3459f544bd0300f9$var$styles = {
    cardWrapper: "_30huDKOeNX _0bjKvDyzSk",
    cardHeader: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    cardHeaderExpanded: "_1x1D3gOeNX",
    cardContent: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    headerIconWrapper: "_3YEZNOdnbC _4xdlr0DIqT"
};
const $3459f544bd0300f9$var$collapseMessage = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.collapsible-card.collapse",
    defaultMessage: "Collapse"
});
const $3459f544bd0300f9$var$expandMessage = (0, $kSwu1.defineMessage)({
    id: "agentic-planning.collapsible-card.expand",
    defaultMessage: "Expand"
});
const $3459f544bd0300f9$export$80f39b42e5b764f4 = ({ title: title, subtitle: subtitle, children: children, isExpandable: isExpandable = false, defaultExpanded: defaultExpanded = true, headerIcon: headerIcon })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldShowContent = !isExpandable || isExpanded;
    const hasHeader = Boolean(title || headerIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3459f544bd0300f9$var$styles.cardWrapper,
        testId: "collapsible-card"
    }, hasHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3459f544bd0300f9$var$styles.cardHeader, shouldShowContent ? $3459f544bd0300f9$var$styles.cardHeaderExpanded : undefined)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3459f544bd0300f9$var$styles.headerIconWrapper
    }, headerIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "bold"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(subtitle) ? subtitle : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, subtitle))), isExpandable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        label: isExpanded ? formatMessage($3459f544bd0300f9$var$collapseMessage) : formatMessage($3459f544bd0300f9$var$expandMessage),
        onClick: ()=>setIsExpanded((prev)=>!prev)
    }))), shouldShowContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3459f544bd0300f9$var$styles.cardContent
    }, children));
};
module.exports["CollapsibleCard"] = $3459f544bd0300f9$export$80f39b42e5b764f4;

});

parcelRegister("53mTv", function(module, exports) {
const $44c37a2133248e5a$export$b8b9d90f9e5bd72b = 'agenticPlanning';
const $44c37a2133248e5a$export$d57b6b390e78d90f = 'Gravity-AI';
module.exports["PACKAGE_NAME"] = $44c37a2133248e5a$export$b8b9d90f9e5bd72b;
module.exports["TEAM_NAME"] = $44c37a2133248e5a$export$d57b6b390e78d90f;

});

parcelRegister("gFn8K", function(module, exports) {
/* DefaultWrappers.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $22YX5 = parcelRequire("22YX5");

var $4ez2K = parcelRequire("4ez2K");

const $90b3159b9f50023b$var$styles = {
    actionCardFooter: "_2bqfgdOeNX _37wbyuF05b _0aFT5vf5Xk _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    actionCardFooterOuterMargin: "_3138428HPE _1DCdHiB0rP"
};
const $90b3159b9f50023b$export$1eacf9c33f279a8a = (actionButtons)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22YX5.Bleed), {
        inline: "space.150",
        xcss: $90b3159b9f50023b$var$styles.actionCardFooterOuterMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.050",
        alignItems: "center",
        wrap: "wrap",
        xcss: $90b3159b9f50023b$var$styles.actionCardFooter
    }, actionButtons));
module.exports["defaultFooter"] = $90b3159b9f50023b$export$1eacf9c33f279a8a;

});

parcelRegister("7xhu8", function(module, exports) {
/* SystemMessage.tsx generated by @compiled/babel-plugin v2.0.0 */ // Copied over from the jira-update-work-item-fields-action-renderer package
// TODO: This component should be moved to a more generic package

var $cozmU = parcelRequire("cozmU");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $f691bc18e4a94ec9$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $f691bc18e4a94ec9$export$3f91b0466c5e5f77 = ({ message: message, isSuccessMessage: isSuccessMessage = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f691bc18e4a94ec9$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f691bc18e4a94ec9$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, isSuccessMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, message)));
};
module.exports["SystemMessage"] = $f691bc18e4a94ec9$export$3f91b0466c5e5f77;

});

parcelRegister("cr6ly", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $kp580 = parcelRequire("kp580");


var $iDrrr = parcelRequire("iDrrr");

parcelRequire("h9r4d");
var $kFTt2 = parcelRequire("kFTt2");


var $53mTv = parcelRequire("53mTv");

const $a974a678e321e25f$var$RovoHeaderIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        size: "small",
        name: "Rovo",
        appearance: "hexagon",
        src: (0, $kp580.rovoHexIcon),
        borderColor: "var(--ds-surface, #FFFFFF)",
        testId: "rovo-header-icon"
    });
const $a974a678e321e25f$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $a974a678e321e25f$var$isString = (value)=>typeof value === 'string';
// Parses and validates questions from raw data, returning typed MultipleChoiceQuestion[].
const $a974a678e321e25f$var$parseQuestions = (data)=>{
    if (!$a974a678e321e25f$var$isRecord(data) || !Array.isArray(data.questions)) return [];
    return data.questions.flatMap((q)=>{
        if (!$a974a678e321e25f$var$isRecord(q) || !$a974a678e321e25f$var$isString(q.id) || !$a974a678e321e25f$var$isString(q.question) || !Array.isArray(q.options)) return [];
        const options = q.options.flatMap((opt)=>{
            if (!$a974a678e321e25f$var$isRecord(opt) || !$a974a678e321e25f$var$isString(opt.id) || !$a974a678e321e25f$var$isString(opt.label)) return [];
            return [
                {
                    id: opt.id,
                    label: opt.label,
                    description: $a974a678e321e25f$var$isString(opt.description) ? opt.description : undefined
                }
            ];
        });
        return [
            {
                id: q.id,
                question: q.question,
                options: options
            }
        ];
    });
};
const $a974a678e321e25f$export$ab64950cbb22da27 = (data)=>{
    if (!$a974a678e321e25f$var$isRecord(data) || !Array.isArray(data.questions)) return {};
    return data.questions.reduce((acc, q)=>{
        if (!$a974a678e321e25f$var$isRecord(q) || !$a974a678e321e25f$var$isString(q.id)) return acc;
        const { answer: answer } = q;
        if (answer == null || $a974a678e321e25f$var$isString(answer)) acc[q.id] = answer ?? null;
        return acc;
    }, {});
};
// Converts parsed questions into the shape expected by AskQuestionCompletedView.
const $a974a678e321e25f$var$toCompletedView = (questions, answersByQuestionId)=>{
    const completedQuestions = [];
    const answers = {};
    questions.forEach((q, idx)=>{
        completedQuestions.push({
            header: '',
            question: q.question,
            options: q.options.map((opt)=>({
                    label: opt.label,
                    description: opt.description ?? ''
                }))
        });
        const answer = answersByQuestionId[q.id];
        if (answer == null) {
            answers[idx] = {
                type: 'auto'
            };
            return;
        }
        const optionIndex = q.options.findIndex((opt)=>opt.id === answer);
        answers[idx] = optionIndex >= 0 ? {
            type: 'option',
            optionIndex: optionIndex
        } : {
            type: 'custom',
            text: answer
        };
    });
    return {
        questions: completedQuestions,
        answers: answers
    };
};
const $a974a678e321e25f$export$ccac7d07ee494fe4 = ({ action: action, confirmedAnswers: confirmedAnswers, ContentRenderer: ContentRenderer, messageId: messageId, productKey: productKey, cloudId: cloudId, AskQuestionCompletedView: AskQuestionCompletedView })=>{
    const sourceQuestions = (0, $cozmU.useMemo)(()=>$a974a678e321e25f$var$parseQuestions(action?.data), [
        action
    ]);
    const executedAnswers = (0, $cozmU.useMemo)(()=>{
        const executedData = action?.executedData;
        if (!$a974a678e321e25f$var$isRecord(executedData) || !$a974a678e321e25f$var$isString(executedData.arguments)) return {};
        try {
            // executedData.arguments is a JSON string containing questions with answers embedded
            const executedArgs = JSON.parse(executedData.arguments);
            return $a974a678e321e25f$export$ab64950cbb22da27(executedArgs);
        } catch  {
            (0, $kFTt2.default)({
                meta: {
                    id: 'multipleChoiceAnswers',
                    packageName: (0, $53mTv.PACKAGE_NAME),
                    teamName: (0, $53mTv.TEAM_NAME)
                },
                attributes: {
                    error: 'Invalid executedData for multiple choice answers',
                    messageId: messageId
                }
            });
            return {};
        }
    }, [
        action,
        messageId
    ]);
    const { questions: questions, answers: answers } = (0, $cozmU.useMemo)(()=>{
        const answersByQuestionId = Object.keys(executedAnswers).length > 0 ? executedAnswers : confirmedAnswers;
        return $a974a678e321e25f$var$toCompletedView(sourceQuestions, answersByQuestionId);
    }, [
        sourceQuestions,
        executedAnswers,
        confirmedAnswers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AskQuestionCompletedView, {
        questions: questions,
        answers: answers,
        ContentRenderer: ContentRenderer,
        productKey: productKey,
        cloudId: cloudId,
        headerIcon: (0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent') ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a974a678e321e25f$var$RovoHeaderIcon, null)
    });
};
module.exports["parseAnswersByQuestionId"] = $a974a678e321e25f$export$ab64950cbb22da27;
module.exports["MultipleChoiceAnswers"] = $a974a678e321e25f$export$ccac7d07ee494fe4;

});

parcelRegister("8N6QU", function(module, exports) {
/* MultipleChoiceQuestionsTool.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $57p4j = parcelRequire("57p4j");

var $hc9K5 = parcelRequire("hc9K5");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $gFn8K = parcelRequire("gFn8K");

const $a665e4a3866a3774$var$FORWARD = 'forward';
const $a665e4a3866a3774$var$BACKWARD = 'backward';
const $a665e4a3866a3774$var$continuePlanningButtonLabel = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.continue-planning-button",
    defaultMessage: "Continue planning"
});
const $a665e4a3866a3774$var$skipAndContinuePlanningButtonLabel = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.skip-and-continue-planning-button",
    defaultMessage: "Skip and continue planning"
});
const $a665e4a3866a3774$var$skipButtonLabel = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.skip-button",
    defaultMessage: "Skip"
});
const $a665e4a3866a3774$var$nextButtonLabel = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.next-button",
    defaultMessage: "Next"
});
const $a665e4a3866a3774$var$previousQuestion = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.previous-question",
    defaultMessage: "Previous question"
});
const $a665e4a3866a3774$var$nextQuestion = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.next-question",
    defaultMessage: "Next question"
});
const $a665e4a3866a3774$var$otherOptionPlaceholder = (0, $kSwu1.defineMessage)({
    id: "ai-agent-sessions.multi-choice.other-placeholder",
    defaultMessage: "Tell {agentName} what to do"
});
const $a665e4a3866a3774$var$questionCounter = (0, $kSwu1.defineMessage)({
    id: "issue-ai-agent-sessions.multiple-choice.question-counter",
    defaultMessage: "{current} of {total}"
});
const $a665e4a3866a3774$var$isActionData = (data)=>{
    if (typeof data !== 'object' || data === null) return false;
    const questions = Reflect.get(data, 'questions');
    return questions === undefined || Array.isArray(questions);
};
const $a665e4a3866a3774$var$isAnswerValid = (answer)=>!!answer && answer.type !== 'SKIP' && (answer.type === 'PROVIDED_OPTION' || answer.customText?.trim() !== '');
const $a665e4a3866a3774$var$resolveAnswer = (answer)=>{
    if (!answer || answer.type === 'SKIP') return null;
    if (answer.type === 'OTHER_OPTION') return answer.customText ?? null;
    return answer.selectedOptionId;
};
const $a665e4a3866a3774$var$styles = {
    navHeader: "_1wydGW8HPE",
    navHeading: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3YEZNOdnbC",
    optionList: "_1LMyvKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    optionCard: "_2mHwu85zaO _0bjKvDKTcp _2Y7lL42ADO _3SamIH1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _2fwxA57p2s _0KLXru66of",
    optionCardWithHover: "_0wOv4Q7zJH _1eOmH6o126",
    optionCardSelected: "_0KLXruY9q9 _1eOmH6sumd",
    optionCardBody: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC",
    numberBadge: "_0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _3vBAKHWkXl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02SPN1 _0jFU0VSPN1 _3YEZNOdnbC",
    numberBadgeSelected: "_3vBAKHrzt2 _1UtDYzjTy9",
    otherTextfield: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2XsHFMTUhv"
};
function $a665e4a3866a3774$var$QuestionNav({ currentIndex: currentIndex, totalQuestions: totalQuestions, onPrevious: onPrevious, onNext: onNext }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))),
        label: formatMessage($a665e4a3866a3774$var$previousQuestion),
        isDisabled: currentIndex === 0,
        onClick: onPrevious,
        spacing: "compact"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($a665e4a3866a3774$var$questionCounter, {
        current: currentIndex + 1,
        total: totalQuestions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: formatMessage($a665e4a3866a3774$var$nextQuestion),
        isDisabled: currentIndex === totalQuestions - 1,
        onClick: onNext,
        spacing: "compact"
    }));
}
function $a665e4a3866a3774$var$ActionOption({ option: option, index: index, questionId: questionId, currentAnswer: currentAnswer, onSelect: onSelect }) {
    const isSelected = currentAnswer?.type === 'PROVIDED_OPTION' && currentAnswer.selectedOptionId === option.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($a665e4a3866a3774$var$styles.optionCard, $a665e4a3866a3774$var$styles.optionCardWithHover, isSelected && $a665e4a3866a3774$var$styles.optionCardSelected),
        onClick: ()=>onSelect({
                [questionId]: {
                    type: 'PROVIDED_OPTION',
                    selectedOptionId: option.id
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a665e4a3866a3774$var$styles.numberBadge, isSelected && $a665e4a3866a3774$var$styles.numberBadgeSelected)
    }, String(index)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a665e4a3866a3774$var$styles.optionCardBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: isSelected ? 'color.text.selected' : 'color.text'
    }, option.label), option.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isSelected ? 'color.text.selected' : 'color.text.subtle'
    }, option.description)));
}
function $a665e4a3866a3774$var$OtherOption({ index: index, currentAnswer: currentAnswer, inputRef: inputRef, agentName: agentName, questionId: questionId, onSelect: onSelect, onSubmit: onSubmit }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [text, setText] = (0, $cozmU.useState)(currentAnswer?.type === 'OTHER_OPTION' ? currentAnswer.customText : '');
    const handleTextChange = (e)=>{
        const newText = e.currentTarget.value;
        setText(newText);
        onSelect({
            type: 'OTHER_OPTION',
            customText: newText
        });
    };
    const handleOnSelect = ()=>{
        onSelect({
            type: 'OTHER_OPTION',
            customText: text
        });
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && text.trim()) {
            e.preventDefault();
            onSubmit({
                [questionId]: {
                    type: 'OTHER_OPTION',
                    customText: text.trim()
                }
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a665e4a3866a3774$var$styles.optionCard,
        testId: "ai-agent-sessions.option-other"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a665e4a3866a3774$var$styles.numberBadge, currentAnswer?.type === 'OTHER_OPTION' && $a665e4a3866a3774$var$styles.numberBadgeSelected)
    }, String(index)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a665e4a3866a3774$var$styles.otherTextfield
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        ref: inputRef,
        value: text,
        onChange: handleTextChange,
        onKeyDown: handleKeyDown,
        onFocus: handleOnSelect,
        placeholder: formatMessage($a665e4a3866a3774$var$otherOptionPlaceholder, {
            agentName: agentName
        }),
        appearance: "none"
    })));
}
const $a665e4a3866a3774$var$ActionButtons = ({ isLastQuestion: isLastQuestion, isCurrentAnswerValid: isCurrentAnswerValid, onSubmit: onSubmit, onSkip: onSkip })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (isLastQuestion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onSubmit
    }, isCurrentAnswerValid ? formatMessage($a665e4a3866a3774$var$continuePlanningButtonLabel) : formatMessage($a665e4a3866a3774$var$skipAndContinuePlanningButtonLabel));
    if (isCurrentAnswerValid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onSubmit
    }, formatMessage($a665e4a3866a3774$var$nextButtonLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onSkip,
        appearance: "subtle"
    }, formatMessage($a665e4a3866a3774$var$skipButtonLabel));
};
function $a665e4a3866a3774$export$9576001ba0d0a3c({ message: message, onConfirm: onConfirm, agentSessionInfo: agentSessionInfo, ContentWrapperComponent: ContentWrapperComponent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, footer: footer = (0, $gFn8K.defaultFooter) }) {
    const { agentName: agentName } = agentSessionInfo;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const actionKey = message.actions?.[0]?.key ?? '';
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const [direction, setDirection] = (0, $cozmU.useState)($a665e4a3866a3774$var$FORWARD);
    const [answers, setAnswers] = (0, $cozmU.useState)({});
    const action = message.actions?.[0];
    const { questions: questions = [] } = ($a665e4a3866a3774$var$isActionData(action?.data) ? action?.data : undefined) ?? {};
    const currentQuestion = questions[currentIndex];
    const totalQuestions = questions.length;
    const isLastQuestion = currentIndex === totalQuestions - 1;
    const currentAnswer = currentQuestion ? answers[currentQuestion.id] : undefined;
    const isCurrentAnswerValid = $a665e4a3866a3774$var$isAnswerValid(currentAnswer);
    const handleOnPrevious = ()=>{
        setDirection($a665e4a3866a3774$var$BACKWARD);
        setCurrentIndex((prev)=>prev > 0 ? prev - 1 : 0);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'multipleChoiceQuestionsToolPreviousQuestion',
            eventType: 'ui',
            attributes: {
                actionKey: actionKey
            }
        });
    };
    const advanceToNext = ()=>{
        setDirection($a665e4a3866a3774$var$FORWARD);
        setCurrentIndex((prev)=>prev < totalQuestions - 1 ? prev + 1 : prev);
    };
    const handleOnNext = ()=>{
        // Implicitly skip if the current question has no answer selected
        if (currentQuestion && !answers[currentQuestion.id]) setAnswers((prev)=>({
                ...prev,
                [currentQuestion.id]: {
                    type: 'SKIP'
                }
            }));
        advanceToNext();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'multipleChoiceQuestionsToolNextQuestion',
            eventType: 'ui',
            attributes: {
                actionKey: actionKey
            }
        });
    };
    const handleOnSkip = ()=>{
        setAnswers((prev)=>({
                ...prev,
                [currentQuestion.id]: {
                    type: 'SKIP'
                }
            }));
        advanceToNext();
    };
    const handleOnSubmit = async (pendingAnswers)=>{
        if (pendingAnswers) setAnswers((prev)=>({
                ...prev,
                ...pendingAnswers
            }));
        if (!isLastQuestion) {
            advanceToNext();
            return;
        }
        if (!action) return;
        const mergedAnswers = pendingAnswers ? {
            ...answers,
            ...pendingAnswers
        } : answers;
        const totalQuestionsCount = questions.length;
        const questionsSkipped = questions.filter((q)=>!mergedAnswers[q.id] || mergedAnswers[q.id].type === 'SKIP').length;
        const questionsWithOtherSelected = Object.values(mergedAnswers).filter((a)=>a != null && a.type === 'OTHER_OPTION').length;
        await onConfirm(undefined, undefined, {
            actions: [
                {
                    ...action,
                    // https://jplat.atlassian.net/browse/GRAVITYAI-4694 Currently, convoAI doesn't include the toolSource via the agent assignment flow. This is a temporary fix
                    toolSource: action.toolSource ?? 'CONVO_AI',
                    data: {
                        questions: questions.map((q)=>({
                                ...q,
                                answer: $a665e4a3866a3774$var$resolveAnswer(mergedAnswers[q.id])
                            }))
                    }
                }
            ]
        }, {
            totalQuestionsCount: totalQuestionsCount,
            questionsSkipped: questionsSkipped,
            questionsWithOtherSelected: questionsWithOtherSelected,
            isPreExecution: true
        }, {
            isAgentCollaboration: true
        });
    };
    const handleOptionSelect = (answer)=>{
        if (!currentQuestion) return;
        setAnswers((prev)=>({
                ...prev,
                [currentQuestion.id]: answer
            }));
    };
    const otherOptionRef = (0, $cozmU.useRef)(null);
    const handleNumberKeyDown = (e)=>{
        // Don't intercept if the user is typing in a text input (e.g. the Other option textfield)
        if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
        const num = parseInt(e.key, 10);
        if (isNaN(num) || num < 1 || !currentQuestion) return;
        const optionIndex = num - 1;
        if (optionIndex < currentQuestion.options.length) {
            // Select and auto-submit the corresponding provided option
            const option = currentQuestion.options[optionIndex];
            handleOnSubmit({
                [currentQuestion.id]: {
                    type: 'PROVIDED_OPTION',
                    selectedOptionId: option.id
                }
            });
        } else if (optionIndex === currentQuestion.options.length) {
            // Focus the Other option textfield without inserting the key character
            e.preventDefault();
            otherOptionRef.current?.focus();
        }
    };
    if (!currentQuestion) return null;
    const enterFrom = direction === $a665e4a3866a3774$var$BACKWARD ? 'left' : 'right';
    const bodyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onKeyDown: handleNumberKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a665e4a3866a3774$var$styles.navHeader,
        alignItems: "start",
        justifyContent: "space-between",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a665e4a3866a3774$var$styles.navHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        key: `header-${currentIndex}`,
        entranceDirection: enterFrom
    }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, currentQuestion.question), currentQuestion.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, currentQuestion.description))))), totalQuestions > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a665e4a3866a3774$var$QuestionNav, {
        currentIndex: currentIndex,
        totalQuestions: totalQuestions,
        onPrevious: handleOnPrevious,
        onNext: handleOnNext
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $a665e4a3866a3774$var$styles.optionList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hc9K5.default), {
        key: currentQuestion.id,
        delayStep: 50
    }, [
        ...currentQuestion.options.map((option, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                key: `${currentQuestion.id}-option-${i}`,
                entranceDirection: enterFrom
            }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a665e4a3866a3774$var$ActionOption, {
                    option: option,
                    index: i + 1,
                    questionId: currentQuestion.id,
                    currentAnswer: currentAnswer,
                    onSelect: handleOnSubmit
                })))),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            key: `other-${currentQuestion.id}`,
            entranceDirection: enterFrom
        }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a665e4a3866a3774$var$OtherOption, {
                index: currentQuestion.options.length + 1,
                currentAnswer: currentAnswer,
                inputRef: otherOptionRef,
                agentName: agentName,
                questionId: currentQuestion.id,
                onSelect: handleOptionSelect,
                onSubmit: handleOnSubmit
            })))
    ])));
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a665e4a3866a3774$var$ActionButtons, {
        isLastQuestion: isLastQuestion,
        isCurrentAnswerValid: isCurrentAnswerValid,
        onSubmit: handleOnSubmit,
        onSkip: handleOnSkip
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentWrapperComponent, null, bodyContent), footer(actionButtons));
}
module.exports["MultipleChoiceQuestionsTool"] = $a665e4a3866a3774$export$9576001ba0d0a3c;

});

parcelRegister("cLuNh", function(module, exports) {
/** The single set of canvas keys (which UI renders). Components live in rovodal-host. */ const $ef67197abe4ea7ef$export$38b9782d9f603963 = {
    jiraAdminAgentBlastRadiusCanvas: 'jira-admin-agent-blast-radius-canvas'
};
module.exports["RovodalCanvasKeys"] = $ef67197abe4ea7ef$export$38b9782d9f603963;

});

parcelRegister("1hUUd", function(module, exports) {
module.exports = new URL("jira-admin-agent.64897446.svg", import.meta.url).toString();

});

parcelRegister("8Fgjj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $kaPN1 = parcelRequire("kaPN1");


var $doYOO = parcelRequire("doYOO");


var $2swKg = parcelRequire("2swKg");


var $19FYy = parcelRequire("19FYy");


var $gPDwp = parcelRequire("gPDwp");


var $45b0j = parcelRequire("45b0j");


var $j1ipA = parcelRequire("j1ipA");


var $15gbR = parcelRequire("15gbR");

const $391937e5328ec099$export$3ea7cea71fc3a0e4 = ({ actions: actions, conversationId: conversationId, recipientAgentId: recipientAgentId, sendMessageConfirmedTools: sendMessageConfirmedTools, getStatus: getStatus, messageId: messageId, isCanvasOpen: isCanvasOpen, isCanvasLoading: isCanvasLoading = false, openCanvas: openCanvas, onDismissed: onDismissed, convertedPlan: convertedPlan })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Drives the footer to the dismissed (red pill) state immediately on dismiss, keeping the plan
    // details visible above it.
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    // Dismiss is terminal: once the user dismisses the plan, no further confirmations may be sent,
    // even if an accept was triggered in the same tick. A ref (not state) so the guard is effective
    // synchronously within the current render.
    const isDismissedRef = (0, $cozmU.useRef)(false);
    // Only step actions are applyable; the plan action is a container.
    const stepActions = (0, $cozmU.useMemo)(()=>actions.filter((action)=>action.data.actionType === 'step'), [
        actions
    ]);
    const invocationIds = (0, $cozmU.useMemo)(()=>stepActions.map((action)=>action.invocationId), [
        stepActions
    ]);
    // `useActionPlanApplyState` requires a `conversationId` string; `conversationId` here is
    // optional (per `AgentActionPayload`), so fall back to `''` the same way
    // `useActionInvocationStatuses` does internally.
    const { perStep: perStep, runApply: runApply } = (0, $gPDwp.useActionPlanApplyState)(conversationId ?? '', invocationIds);
    const renderMode = (0, $cozmU.useMemo)(()=>(0, $kaPN1.getRenderMode)(stepActions.map((action)=>({
                storedStatus: action.status || 'planned',
                currentStatus: getStatus(action),
                inProgress: perStep[action.invocationId]?.inProgress ?? false,
                error: perStep[action.invocationId]?.error
            }))), [
        stepActions,
        getStatus,
        perStep
    ]);
    const onAcceptAll = (0, $cozmU.useCallback)(async ()=>{
        // Do not execute accepted steps once the plan has been dismissed.
        if (isDismissedRef.current) return;
        const applyableActions = stepActions.filter((action)=>(action.status ?? 'planned') === 'planned').filter((action)=>getStatus(action) === 'idle');
        const idsToApply = applyableActions.map((action)=>action.invocationId);
        await runApply(idsToApply, async ()=>{
            await sendMessageConfirmedTools({
                agentId: recipientAgentId,
                confirmed_tools: {
                    message_id: messageId,
                    tools: applyableActions.map((action)=>({
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            resolution: {
                                type: 'confirmed'
                            },
                            data: {
                                human_message_id: action.humanMessageId ?? '',
                                arguments: action.data
                            }
                        }))
                },
                conversationId: conversationId
            });
        });
    }, [
        stepActions,
        conversationId,
        getStatus,
        messageId,
        recipientAgentId,
        sendMessageConfirmedTools,
        runApply
    ]);
    // NOTE: unlike `onAcceptAll`, this is intentionally left without any inProgress/error tracking,
    // matching its pre-existing behaviour of having no error handling of its own. See the
    // SoftwareEngineer's report for why this wasn't wired into `runApply`.
    const onDismissAll = (0, $cozmU.useCallback)(async ()=>{
        // Idempotent + terminal: guard against a double dismiss or an accept racing the dismiss.
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        // Show the dismissed (red pill) footer immediately (optimistic UI) and close the canvas,
        // without waiting for the backend round-trip.
        setIsDismissed(true);
        onDismissed?.();
        const applyableActions = stepActions.filter((action)=>(action.status ?? 'planned') === 'planned').filter((action)=>getStatus(action) === 'idle');
        const idsToApply = applyableActions.map((action)=>action.invocationId);
        await runApply(idsToApply, async ()=>{
            await sendMessageConfirmedTools({
                agentId: recipientAgentId,
                confirmed_tools: {
                    message_id: messageId,
                    tools: applyableActions.map((action)=>({
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            resolution: {
                                type: 'cancelled'
                            },
                            data: {
                                human_message_id: action.humanMessageId ?? '',
                                arguments: action.data
                            }
                        }))
                },
                conversationId: conversationId
            });
        });
    }, [
        stepActions,
        conversationId,
        getStatus,
        messageId,
        onDismissed,
        runApply,
        recipientAgentId,
        sendMessageConfirmedTools
    ]);
    // A local dismiss shows the cancelled (red pill) footer immediately; otherwise fall back to the
    // backend-derived render mode (also CANCELLED once every step is reported cancelled).
    const effectiveRenderMode = isDismissed ? 'CANCELLED' : renderMode;
    const topLevelPlan = convertedPlan.topLevelPlan;
    if (!topLevelPlan) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const { title: title, subtext: subtext, blastRadius: blastRadius } = topLevelPlan.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1ipA.ActionCardWrapper), {
        title: title,
        subtitle: subtext,
        defaultExpanded: true,
        isExpandable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2swKg.Entities), {
        entities: topLevelPlan.payload.entities
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $19FYy.IntentBody), {
        steps: topLevelPlan.steps
    }), topLevelPlan.plans.map((subPlan, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15gbR.SubPlan), {
            key: subPlan.id,
            plan: subPlan,
            isFirst: index === 0,
            isLast: index === topLevelPlan.plans.length - 1,
            number: index + 1
        }))), blastRadius?.summary === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $doYOO.emptyBlastRadiusSummaryMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, blastRadius.summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45b0j.ActionCardFooter), {
        renderMode: effectiveRenderMode,
        isCanvasOpen: isCanvasOpen,
        isCanvasLoading: isCanvasLoading,
        onAcceptPlan: onAcceptAll,
        onDismissPlan: onDismissAll,
        onReviewPlan: openCanvas
    }));
};
module.exports["JiraAdminAgentActionPlanCard"] = $391937e5328ec099$export$3ea7cea71fc3a0e4;

});

parcelRegister("bCDPT", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $5dfa32de8df7319c$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $5dfa32de8df7319c$var$CONFLUENCE_CREATE_SPACE_OPERATION = 'create_space';
const $5dfa32de8df7319c$var$CONFLUENCE_APPLICATION_TARGET_TYPE = 'application';
const $5dfa32de8df7319c$var$toAdfBodyValue = (body)=>typeof body === 'string' ? body : JSON.stringify(body);
const $5dfa32de8df7319c$var$buildSpaceKey = (spaceName)=>{
    const keyPrefix = spaceName.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
    const randomSuffix = Math.random().toString(36).slice(2, 7).toUpperCase();
    return `${keyPrefix || 'KB'}${randomSuffix}`;
};
const $5dfa32de8df7319c$var$getCreateSpacePath = ({ projectId: projectId, activationId: activationId, spaceName: spaceName, spaceKey: spaceKey })=>`${$5dfa32de8df7319c$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/v2/project/${projectId}/kb-settings/space?spaceKey=${encodeURIComponent(spaceKey)}&spaceName=${encodeURIComponent(spaceName)}`;
const $5dfa32de8df7319c$var$createConfluenceSpace = async ({ spaceName: spaceName, projectId: projectId, activationId: activationId })=>{
    const normalizedSpaceName = spaceName.trim();
    const spaceKey = $5dfa32de8df7319c$var$buildSpaceKey(normalizedSpaceName);
    const data = await (0, $jTKfH.performHttpFetch)({
        path: $5dfa32de8df7319c$var$getCreateSpacePath({
            projectId: projectId,
            activationId: activationId,
            spaceName: normalizedSpaceName,
            spaceKey: spaceKey
        }),
        options: {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    });
    if (!data.id || !data.key) throw new Error('Confluence space created without id');
    return {
        id: String(data.id),
        key: data.key
    };
};
const $5dfa32de8df7319c$var$canCurrentConfluenceUserCreateSpace = async ({ cloudId: cloudId })=>{
    try {
        const response = await (0, $jTKfH.performHttpFetch)({
            path: `/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/user/current?expand=operations`,
            options: {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                },
                credentials: 'include'
            }
        });
        if (!Array.isArray(response.operations)) return true;
        return response.operations.some(({ operation: operation, targetType: targetType })=>operation === $5dfa32de8df7319c$var$CONFLUENCE_CREATE_SPACE_OPERATION && targetType === $5dfa32de8df7319c$var$CONFLUENCE_APPLICATION_TARGET_TYPE);
    } catch  {
        return true;
    }
};
const $5dfa32de8df7319c$var$fetchProjectIdentifierById = async ({ projectId: projectId })=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: `/rest/api/2/project/${projectId}`,
        options: {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    });
    if (!response.key) throw new Error('Project details response missing key');
    return response.key;
};
const $5dfa32de8df7319c$var$fetchRovoSkillArticleById = async ({ projectId: projectId, activationId: activationId, articleId: articleId })=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: `${$5dfa32de8df7319c$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/rovo-skill-articles/${articleId}`,
        options: {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    });
    if (!response.articleId || !response.title) throw new Error('Rovo skill article response missing required fields');
    const normalizedBody = response.body && typeof response.body === 'object' && 'value' in response.body ? response.body.value : response.body;
    return {
        articleId: response.articleId,
        title: response.title,
        body: normalizedBody,
        rovoTopicId: response.rovoTopicId ?? ''
    };
};
const $5dfa32de8df7319c$var$updateRovoSkillArticleById = async ({ projectId: projectId, activationId: activationId, articleId: articleId, title: title, body: body, rovoTopicId: rovoTopicId })=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: `${$5dfa32de8df7319c$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/rovo-skill-articles/${articleId}`,
        options: {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                title: title,
                body: {
                    value: $5dfa32de8df7319c$var$toAdfBodyValue(body)
                },
                ...rovoTopicId !== undefined ? {
                    rovoTopicId: rovoTopicId
                } : {}
            })
        }
    });
    if (!response.articleId) throw new Error('Rovo skill article update response missing articleId');
    return {
        articleId: response.articleId
    };
};
const $5dfa32de8df7319c$var$deleteRovoSkillArticleById = async ({ projectId: projectId, activationId: activationId, articleId: articleId })=>{
    await (0, $jTKfH.performHttpFetch)({
        path: `${$5dfa32de8df7319c$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/rovo-skill-articles/${articleId}`,
        options: {
            method: 'DELETE',
            headers: {
                Accept: 'application/json'
            }
        }
    });
};
const $5dfa32de8df7319c$export$a97c30d8828ed17e = {
    createConfluenceSpace: $5dfa32de8df7319c$var$createConfluenceSpace,
    canCurrentConfluenceUserCreateSpace: $5dfa32de8df7319c$var$canCurrentConfluenceUserCreateSpace,
    fetchProjectIdentifierById: $5dfa32de8df7319c$var$fetchProjectIdentifierById,
    fetchRovoSkillArticleById: $5dfa32de8df7319c$var$fetchRovoSkillArticleById,
    updateRovoSkillArticleById: $5dfa32de8df7319c$var$updateRovoSkillArticleById,
    deleteRovoSkillArticleById: $5dfa32de8df7319c$var$deleteRovoSkillArticleById
};
module.exports["createKbApi"] = $5dfa32de8df7319c$export$a97c30d8828ed17e;

});

parcelRegister("5ScJC", function(module, exports) {
/* CreateKBCardFooter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $44v3s = parcelRequire("44v3s");

const $83e166f4f6803b7a$var$styles = {
    footer: "_2bqfgdOeNX _3iDTPbQ4SZ _37wbyuz9WS _0Of8r25zaO _1ZnuxbkG2W _1wydGW5zaO _2Zuz6QkG2W",
    footerActions: "_2mHwu81Y8M _3iDTPbQ4SZ _37wbyuz9WS"
};
const $83e166f4f6803b7a$export$e38aeb04f3736c4a = ({ mode: mode, onCreateDrafts: onCreateDrafts, onSaveForLater: onSaveForLater, onPublishAll: onPublishAll, onConfirm: onConfirm, onBack: onBack, onPublish: onPublish, isCreateDraftsLoading: isCreateDraftsLoading, isConfirmLoading: isConfirmLoading, isPublishLoading: isPublishLoading, isConfirmDisabled: isConfirmDisabled, isPublishDisabled: isPublishDisabled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const sendButtonClickedAnalytics = (buttonName)=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'clicked',
            actionSubject: 'jsmKbFromScratchFooterButton',
            actionSubjectId: 'jsmKbFromScratchFooterButtonClicked',
            attributes: {
                buttonName: buttonName,
                mode: mode
            }
        });
    };
    const handleBackClick = ()=>{
        sendButtonClickedAnalytics('back');
        onBack?.();
    };
    const handleConfirmClick = ()=>{
        sendButtonClickedAnalytics('confirm');
        onConfirm?.();
    };
    const handleSaveForLaterClick = ()=>{
        sendButtonClickedAnalytics('saveForLater');
        onSaveForLater?.();
    };
    const handlePublishAllClick = ()=>{
        sendButtonClickedAnalytics('publishAll');
        onPublishAll?.();
    };
    const handleCreateDraftsClick = ()=>{
        sendButtonClickedAnalytics('createDrafts');
        onCreateDrafts?.();
    };
    const handlePublishClick = ()=>{
        sendButtonClickedAnalytics('publish');
        onPublish?.();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $83e166f4f6803b7a$var$styles.footer,
        testId: "create-kb-card-footer"
    }, mode === 'FORM_ACTIONS' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $83e166f4f6803b7a$var$styles.footerActions
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: handleBackClick,
        appearance: "subtle",
        testId: "create-kb-card-back"
    }, formatMessage((0, $44v3s.createKbMessages).backCtaMessage)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: handleConfirmClick,
        appearance: "primary",
        testId: "create-kb-card-confirm",
        isLoading: isConfirmLoading,
        isDisabled: isConfirmDisabled
    }, formatMessage((0, $44v3s.createKbMessages).confirmCtaMessage))), mode === 'ARTICLE_ACTIONS' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $83e166f4f6803b7a$var$styles.footerActions
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleSaveForLaterClick,
        testId: "create-kb-card-save-for-later"
    }, formatMessage((0, $44v3s.createKbMessages).saveForLaterMessage)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handlePublishAllClick,
        testId: "create-kb-card-publish-all"
    }, formatMessage((0, $44v3s.createKbMessages).publishAllMessage))), mode === 'CREATE_DRAFTS' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $83e166f4f6803b7a$var$styles.footerActions
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: handleCreateDraftsClick,
        appearance: "default",
        testId: "create-kb-card-create-drafts",
        isLoading: isCreateDraftsLoading,
        isDisabled: isCreateDraftsLoading
    }, formatMessage((0, $44v3s.createKbMessages).ctaMessage))), mode === 'PUBLISH_ACTIONS' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $83e166f4f6803b7a$var$styles.footerActions
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: handleBackClick,
        appearance: "subtle",
        testId: "create-kb-card-back"
    }, formatMessage((0, $44v3s.createKbMessages).backCtaMessage)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handlePublishClick,
        testId: "create-kb-card-publish",
        isLoading: isPublishLoading,
        isDisabled: isPublishDisabled
    }, formatMessage((0, $44v3s.createKbMessages).publishCtaMessage))));
};
module.exports["CreateKBCardFooter"] = $83e166f4f6803b7a$export$e38aeb04f3736c4a;

});

parcelRegister("hEg6t", function(module, exports) {
/* CreateKBCardForm.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kB5K2 = parcelRequire("kB5K2");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $4yg9g = parcelRequire("4yg9g");


var $44v3s = parcelRequire("44v3s");

const $99cb4c5db23965d8$var$styles = {
    formBody: "_0Of8r25zaO _1ZnuxbkG2W _1wydGW5zaO _2Zuz6QkG2W"
};
const $99cb4c5db23965d8$export$8f77c81a871c13a8 = ({ spaceName: spaceName, onSpaceNameChange: onSpaceNameChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "create-kb-card-form",
        xcss: $99cb4c5db23965d8$var$styles.formBody
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: "create-kb-space-name"
    }, formatMessage((0, $44v3s.createKbMessages).nameLabelMessage)), /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        id: "create-kb-space-name",
        value: spaceName,
        onChange: (event)=>onSpaceNameChange(event.target.value),
        testId: "create-kb-space-name"
    }))));
};
module.exports["CreateKBCardForm"] = $99cb4c5db23965d8$export$8f77c81a871c13a8;

});

parcelRegister("c7JuL", function(module, exports) {
/* CreateKBCardHeader.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gznGh = parcelRequire("gznGh");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $44v3s = parcelRequire("44v3s");

const $ae69a735be8a79c3$var$styles = {
    header: "_1x1D3gOeNX _0Of8r25zaO _1ZnuxbkG2W _1wydGW5zaO _2Zuz6QkG2W"
};
const $ae69a735be8a79c3$export$76f3dc6f57948707 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075",
        testId: "create-kb-card-header",
        xcss: $ae69a735be8a79c3$var$styles.header
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gznGh))), {
        color: "var(--ds-icon-warning, #E06C00)",
        label: ""
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "large",
        weight: "bold",
        color: "color.text"
    }, formatMessage((0, $44v3s.createKbMessages).titleMessage)));
};
module.exports["CreateKBCardHeader"] = $ae69a735be8a79c3$export$76f3dc6f57948707;

});

parcelRegister("1CPzM", function(module, exports) {
/* CreateKBCardImagePreview.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $cbHKo = parcelRequire("cbHKo");


var $44v3s = parcelRequire("44v3s");

const $7d068a96c1526bea$var$styles = {
    imageContainer: "_39xV02N91d",
    image: "_3iDTPbvLZJ _39xV02N91d _0jFU0VGtpf _00EA0eiObl"
};
const $7d068a96c1526bea$export$d90cf7cfc248e04c = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7d068a96c1526bea$var$styles.imageContainer,
        testId: "create-kb-card-image-preview"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "img",
        alt: formatMessage((0, $44v3s.createKbMessages).headerImageAltMessage),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cbHKo))),
        xcss: $7d068a96c1526bea$var$styles.image
    }));
};
module.exports["CreateKBCardImagePreview"] = $7d068a96c1526bea$export$d90cf7cfc248e04c;

});

parcelRegister("5COam", function(module, exports) {
/* CreateKBCardPublishForm.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5Sv3D = parcelRequire("5Sv3D");


var $ad7Ou = parcelRequire("ad7Ou");


var $2uDbg = parcelRequire("2uDbg");


var $kB5K2 = parcelRequire("kB5K2");


var $gFEZF = parcelRequire("gFEZF");


var $a1ZzW = parcelRequire("a1ZzW");


var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $1JERl = parcelRequire("1JERl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $1HjbK = parcelRequire("1HjbK");


var $44v3s = parcelRequire("44v3s");

const $b3771ecbb5ac0d03$var$mapToSpaceOptions = (spaces)=>spaces.map(({ id: id, key: key, name: name })=>({
            label: name,
            value: id,
            key: key
        })).filter(({ value: value })=>Boolean(value));
const $b3771ecbb5ac0d03$var$styles = {
    formBody: "_0Of8r25zaO _1ZnuxbkG2W _1wydGW5zaO _2Zuz6QkG2W",
    infoRow: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLchRC",
    typeLabelRow: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    inlineEditReadView: "_4kiQYAZ49V"
};
const $b3771ecbb5ac0d03$export$36c975241c806c14 = ({ selectedType: selectedType, onSelectedTypeChange: onSelectedTypeChange, selectedSpace: selectedSpace, appLinkId: appLinkId, prefetchedSpaceOptions: prefetchedSpaceOptions, onSelectedSpaceChange: onSelectedSpaceChange, onPublishConsentChange: onPublishConsentChange, onPublishTargetChange: onPublishTargetChange, userId: userId, cloudId: cloudId, canCreateSpace: canCreateSpace, isFetchingCreateSpacePermission: isFetchingCreateSpacePermission, isPrefetchedSpaceOptionsLoading: isPrefetchedSpaceOptionsLoading, hasLinkSourceAlreadyHasContentError: hasLinkSourceAlreadyHasContentError = false, hasGenericActionError: hasGenericActionError = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { listEntities: listEntities } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const hasAppLinkId = Boolean(appLinkId);
    const [isCreateSpaceInlineEditVisible, setIsCreateSpaceInlineEditVisible] = (0, $cozmU.useState)(false);
    const [isNewSpaceConfirmed, setIsNewSpaceConfirmed] = (0, $cozmU.useState)(false);
    const [confirmedSpaceName, setConfirmedSpaceName] = (0, $cozmU.useState)('');
    const [isPublishToNewSpaceChecked, setIsPublishToNewSpaceChecked] = (0, $cozmU.useState)(false);
    const [isSpaceOptionsLoading, setIsSpaceOptionsLoading] = (0, $cozmU.useState)(isPrefetchedSpaceOptionsLoading);
    const shouldShowPublishToNewSpaceCheckbox = !appLinkId;
    const [searchInputValue, setSearchInputValue] = (0, $cozmU.useState)('');
    const latestSearchRequestIdRef = (0, $cozmU.useRef)(0);
    const baseSpaceOptionsRef = (0, $cozmU.useRef)(prefetchedSpaceOptions ?? []);
    const typeOptions = (0, $cozmU.useMemo)(()=>[
            {
                label: formatMessage((0, $44v3s.createKbMessages).typeInternalMessage),
                value: 'INTERNAL'
            },
            {
                label: formatMessage((0, $44v3s.createKbMessages).typeExternalMessage),
                value: 'EXTERNAL'
            }
        ], [
        formatMessage
    ]);
    const externalTypeOption = (0, $cozmU.useMemo)(()=>typeOptions.find((option)=>option.value === 'EXTERNAL') ?? typeOptions[0], [
        typeOptions
    ]);
    const [spaceOptions, setSpaceOptions] = (0, $cozmU.useState)(prefetchedSpaceOptions ?? []);
    const fetchSpaces = (0, $cozmU.useCallback)(async (query)=>{
        const entities = await listEntities(query, [
            'space'
        ]);
        return entities.reduce((spaces, entity)=>{
            if (!entity.id || !entity.key) return spaces;
            spaces.push({
                id: entity.id,
                key: entity.key,
                name: entity.name
            });
            return spaces;
        }, []);
    }, [
        listEntities
    ]);
    const [debouncedSearchSpaces, cancelDebouncedSearchSpaces] = (0, $5Sv3D.default)(async (searchInput, requestId)=>{
        setIsSpaceOptionsLoading(true);
        try {
            const matchedSpaces = await fetchSpaces(searchInput);
            if (requestId !== latestSearchRequestIdRef.current) return;
            setSpaceOptions($b3771ecbb5ac0d03$var$mapToSpaceOptions(matchedSpaces));
            setIsSpaceOptionsLoading(false);
        } catch  {
            if (requestId !== latestSearchRequestIdRef.current) return;
            setIsSpaceOptionsLoading(false);
        }
    }, 300);
    const handleCreateSpaceConfirm = (spaceName)=>{
        const trimmedSpaceName = spaceName.trim();
        if (!trimmedSpaceName) {
            setIsCreateSpaceInlineEditVisible(false);
            return;
        }
        setConfirmedSpaceName(trimmedSpaceName);
        setIsNewSpaceConfirmed(true);
        setIsCreateSpaceInlineEditVisible(false);
        onPublishTargetChange({
            newSpaceName: spaceName,
            isNewSpaceConfirmed: true
        });
    };
    (0, $cozmU.useEffect)(()=>{
        onPublishConsentChange({
            isRequired: isNewSpaceConfirmed && shouldShowPublishToNewSpaceCheckbox,
            isChecked: shouldShowPublishToNewSpaceCheckbox ? isPublishToNewSpaceChecked : true,
            isSpaceNameValid: confirmedSpaceName.trim().length > 0
        });
    }, [
        confirmedSpaceName,
        isNewSpaceConfirmed,
        isPublishToNewSpaceChecked,
        onPublishConsentChange,
        shouldShowPublishToNewSpaceCheckbox
    ]);
    (0, $cozmU.useEffect)(()=>{
        onPublishTargetChange({
            newSpaceName: isNewSpaceConfirmed ? confirmedSpaceName.trim() : null,
            isNewSpaceConfirmed: isNewSpaceConfirmed
        });
    }, [
        confirmedSpaceName,
        isNewSpaceConfirmed,
        onPublishTargetChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!hasAppLinkId && selectedType.value !== 'EXTERNAL') onSelectedTypeChange(externalTypeOption);
    }, [
        externalTypeOption,
        hasAppLinkId,
        onSelectedTypeChange,
        selectedType.value
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!userId) {
            setSpaceOptions([]);
            onSelectedSpaceChange(null);
            return;
        }
        const applySpaceOptions = (nextSpaceOptions, syncSelection = true)=>{
            setSpaceOptions(nextSpaceOptions);
            if (syncSelection) baseSpaceOptionsRef.current = nextSpaceOptions;
            if (!syncSelection) return;
             // Preserve explicit user selections (including searched results) even when
            // the base option list is reapplied.
            if (!selectedSpace) onSelectedSpaceChange(nextSpaceOptions[0] ?? null);
        };
        if (prefetchedSpaceOptions !== undefined) {
            if (prefetchedSpaceOptions === null) {
                setIsSpaceOptionsLoading(true);
                return;
            }
            applySpaceOptions(prefetchedSpaceOptions);
            setIsSpaceOptionsLoading(false);
            return;
        }
        let isCancelled = false;
        const loadSpaces = async ()=>{
            setIsSpaceOptionsLoading(true);
            const spaces = await fetchSpaces('');
            if (isCancelled) return;
            applySpaceOptions($b3771ecbb5ac0d03$var$mapToSpaceOptions(spaces));
            setIsSpaceOptionsLoading(false);
        };
        loadSpaces();
        return ()=>{
            isCancelled = true;
        };
    }, [
        fetchSpaces,
        onSelectedSpaceChange,
        prefetchedSpaceOptions,
        selectedSpace,
        userId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const normalizedSearchInput = searchInputValue.trim();
        if (!userId || normalizedSearchInput.length === 0) {
            cancelDebouncedSearchSpaces();
            setSpaceOptions(baseSpaceOptionsRef.current);
            setIsSpaceOptionsLoading(false);
            return;
        }
        const requestId = latestSearchRequestIdRef.current + 1;
        latestSearchRequestIdRef.current = requestId;
        debouncedSearchSpaces(normalizedSearchInput, requestId);
        return ()=>{
            cancelDebouncedSearchSpaces();
        };
    }, [
        cancelDebouncedSearchSpaces,
        debouncedSearchSpaces,
        searchInputValue,
        userId
    ]);
    const handleSpaceInputChange = (value, actionMeta)=>{
        if (actionMeta.action === 'input-change') setSearchInputValue(value);
        if (actionMeta.action === 'menu-close' || actionMeta.action === 'input-blur') setSearchInputValue('');
        return value;
    };
    const isCreateSpaceButtonDisabled = isFetchingCreateSpacePermission || !canCreateSpace;
    const showCreateSpacePermissionTooltip = hasAppLinkId && !isFetchingCreateSpacePermission && !canCreateSpace && (0, $iDrrr.fg)('jsm_kb_from_scratch_check_space_creation');
    const createSpacePermissionTooltip = formatMessage((0, $44v3s.createKbMessages).createSpaceDisabledTooltipMessage);
    const createSpacePermissionAriaLabel = showCreateSpacePermissionTooltip ? `${formatMessage((0, $44v3s.createKbMessages).createSpaceMessage)}. ${createSpacePermissionTooltip}` : undefined;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "create-kb-card-publish-form",
        xcss: $b3771ecbb5ac0d03$var$styles.formBody
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, hasAppLinkId ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $b3771ecbb5ac0d03$var$styles.typeLabelRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: "create-kb-publish-type"
    }, formatMessage((0, $44v3s.createKbMessages).typeLabelMessage)), /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: formatMessage((0, $44v3s.createKbMessages).typeTooltipMessage)
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        label: formatMessage((0, $44v3s.createKbMessages).typeInfoIconLabelMessage),
        color: "var(--ds-icon-subtle, #505258)"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        inputId: "create-kb-publish-type",
        options: typeOptions,
        value: selectedType,
        onChange: (option)=>option && onSelectedTypeChange(option),
        testId: "create-kb-publish-type"
    })) : null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, !hasAppLinkId ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: "create-kb-publish-space-name"
    }, formatMessage((0, $44v3s.createKbMessages).nameLabelMessage)), /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        id: "create-kb-publish-space-name",
        value: confirmedSpaceName,
        onChange: (event)=>{
            const nextSpaceName = event.target.value;
            setConfirmedSpaceName(nextSpaceName);
            setIsNewSpaceConfirmed(nextSpaceName.trim().length > 0);
        },
        testId: "create-kb-publish-space-name",
        autoFocus: true
    })), shouldShowPublishToNewSpaceCheckbox ? /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        isChecked: isPublishToNewSpaceChecked,
        onChange: (event)=>{
            setIsPublishToNewSpaceChecked(event.target.checked);
        },
        label: formatMessage((0, $44v3s.createKbMessages).publishToNewSpaceCheckboxLabelMessage),
        testId: "create-kb-card-publish-to-new-space-checkbox"
    }) : null) : isNewSpaceConfirmed ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: "create-kb-publish-space-name"
    }, formatMessage((0, $44v3s.createKbMessages).nameLabelMessage)), /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        id: "create-kb-publish-space-name",
        value: confirmedSpaceName,
        onChange: (event)=>setConfirmedSpaceName(event.target.value),
        testId: "create-kb-publish-space-name",
        autoFocus: true
    })), shouldShowPublishToNewSpaceCheckbox ? /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        isChecked: isPublishToNewSpaceChecked,
        onChange: (event)=>{
            setIsPublishToNewSpaceChecked(event.target.checked);
        },
        label: formatMessage((0, $44v3s.createKbMessages).publishToNewSpaceCheckboxLabelMessage),
        testId: "create-kb-card-publish-to-new-space-checkbox"
    }) : null) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, hasAppLinkId ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: "create-kb-publish-space"
    }, formatMessage((0, $44v3s.createKbMessages).selectSpaceLabelMessage)), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        inputId: "create-kb-publish-space",
        options: spaceOptions ?? [],
        value: selectedSpace,
        onChange: (option)=>onSelectedSpaceChange(option),
        testId: "create-kb-publish-space",
        isLoading: isSpaceOptionsLoading,
        onInputChange: handleSpaceInputChange,
        menuPosition: "fixed"
    })) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, isCreateSpaceInlineEditVisible ? /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        startWithEditViewOpen: true,
        defaultValue: "",
        label: formatMessage((0, $44v3s.createKbMessages).nameLabelMessage),
        onConfirm: handleCreateSpaceConfirm,
        onCancel: ()=>setIsCreateSpaceInlineEditVisible(false),
        readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $b3771ecbb5ac0d03$var$styles.inlineEditReadView
            }),
        editView: ({ errorMessage: _errorMessage, ...fieldProps }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                ...fieldProps,
                ref: ref,
                testId: "create-kb-card-create-space-inline-edit-input",
                autoFocus: true
            })
    }) : /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: showCreateSpacePermissionTooltip ? createSpacePermissionTooltip : null,
        canAppear: ()=>showCreateSpacePermissionTooltip
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>setIsCreateSpaceInlineEditVisible(true),
        testId: "create-kb-card-create-space",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        isDisabled: isCreateSpaceButtonDisabled,
        "aria-label": createSpacePermissionAriaLabel
    }, formatMessage((0, $44v3s.createKbMessages).createSpaceMessage)))))), hasLinkSourceAlreadyHasContentError ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $b3771ecbb5ac0d03$var$styles.infoRow
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text"
    }, formatMessage((0, $44v3s.createKbMessages).publishFormLinkingErrorMessage))) : hasGenericActionError ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $b3771ecbb5ac0d03$var$styles.infoRow
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text"
    }, formatMessage((0, $44v3s.createKbMessages).genericActionErrorMessage))) : !isNewSpaceConfirmed ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $b3771ecbb5ac0d03$var$styles.infoRow
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text"
    }, formatMessage((0, $44v3s.createKbMessages).publishFormDescriptionMessage))) : null));
};
module.exports["CreateKBCardPublishForm"] = $b3771ecbb5ac0d03$export$36c975241c806c14;

});

parcelRegister("44v3s", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9a1f9ea716bf85fe$var$titleMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.title",
    defaultMessage: "Create knowledge base"
});
const $9a1f9ea716bf85fe$var$ctaMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.cta",
    defaultMessage: "Create drafts"
});
const $9a1f9ea716bf85fe$var$headerImageAltMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.headerImageAlt",
    defaultMessage: "Knowledge base article preview"
});
const $9a1f9ea716bf85fe$var$nameLabelMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.nameLabel",
    defaultMessage: "Name your space"
});
const $9a1f9ea716bf85fe$var$typeLabelMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.typeLabel",
    defaultMessage: "Type"
});
const $9a1f9ea716bf85fe$var$selectSpaceLabelMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.selectSpaceLabel",
    defaultMessage: "Select space"
});
const $9a1f9ea716bf85fe$var$typeTooltipMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.typeTooltip",
    defaultMessage: "External spaces are visible to customers. Internal spaces are visible to agents only."
});
const $9a1f9ea716bf85fe$var$typeInfoIconLabelMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.typeInfoIconLabel",
    defaultMessage: "More information about knowledge base type"
});
const $9a1f9ea716bf85fe$var$typeExternalMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.typeExternal",
    defaultMessage: "External"
});
const $9a1f9ea716bf85fe$var$typeInternalMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.typeInternal",
    defaultMessage: "Internal"
});
const $9a1f9ea716bf85fe$var$confirmCtaMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.confirmCta",
    defaultMessage: "Confirm"
});
const $9a1f9ea716bf85fe$var$backCtaMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.backCta",
    defaultMessage: "Back"
});
const $9a1f9ea716bf85fe$var$spaceNamePlaceholderMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.spaceNamePlaceholder",
    defaultMessage: "IT service desk"
});
const $9a1f9ea716bf85fe$var$saveForLaterMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.saveForLater",
    defaultMessage: "Save for later"
});
const $9a1f9ea716bf85fe$var$publishAllMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.publishAll",
    defaultMessage: "Publish all"
});
const $9a1f9ea716bf85fe$var$publishCtaMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.publishCta",
    defaultMessage: "Publish"
});
const $9a1f9ea716bf85fe$var$createSpaceMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.createSpace",
    defaultMessage: "Create space"
});
const $9a1f9ea716bf85fe$var$createSpaceDisabledTooltipMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.createSpaceDisabledTooltip",
    defaultMessage: "You don't have permission to create spaces in Confluence."
});
const $9a1f9ea716bf85fe$var$publishFormDescriptionMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.publishFormDescription",
    defaultMessage: "All your articles will be visible when you link your space and create knowledge base."
});
const $9a1f9ea716bf85fe$var$publishFormLinkingErrorMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.publishFormLinkingError",
    defaultMessage: "Articles can't be published because your knowledge base already has content. You can add or edit articles directly from your knowledge base."
});
const $9a1f9ea716bf85fe$var$genericActionErrorMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.genericActionError",
    defaultMessage: "Something went wrong. Try again."
});
const $9a1f9ea716bf85fe$var$publishToNewSpaceCheckboxLabelMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-jsm-create-kb-card.controllers.create-kb.publishToNewSpaceCheckboxLabel",
    defaultMessage: "By continuing to publish, you agree to let us add Confluence app on your site. It appears on your bill with zero cost."
});
const $9a1f9ea716bf85fe$export$983b38a1587d5225 = {
    titleMessage: $9a1f9ea716bf85fe$var$titleMessage,
    ctaMessage: $9a1f9ea716bf85fe$var$ctaMessage,
    headerImageAltMessage: $9a1f9ea716bf85fe$var$headerImageAltMessage,
    nameLabelMessage: $9a1f9ea716bf85fe$var$nameLabelMessage,
    typeLabelMessage: $9a1f9ea716bf85fe$var$typeLabelMessage,
    selectSpaceLabelMessage: $9a1f9ea716bf85fe$var$selectSpaceLabelMessage,
    typeTooltipMessage: $9a1f9ea716bf85fe$var$typeTooltipMessage,
    typeInfoIconLabelMessage: $9a1f9ea716bf85fe$var$typeInfoIconLabelMessage,
    typeExternalMessage: $9a1f9ea716bf85fe$var$typeExternalMessage,
    typeInternalMessage: $9a1f9ea716bf85fe$var$typeInternalMessage,
    confirmCtaMessage: $9a1f9ea716bf85fe$var$confirmCtaMessage,
    backCtaMessage: $9a1f9ea716bf85fe$var$backCtaMessage,
    spaceNamePlaceholderMessage: $9a1f9ea716bf85fe$var$spaceNamePlaceholderMessage,
    saveForLaterMessage: $9a1f9ea716bf85fe$var$saveForLaterMessage,
    publishAllMessage: $9a1f9ea716bf85fe$var$publishAllMessage,
    publishCtaMessage: $9a1f9ea716bf85fe$var$publishCtaMessage,
    createSpaceMessage: $9a1f9ea716bf85fe$var$createSpaceMessage,
    createSpaceDisabledTooltipMessage: $9a1f9ea716bf85fe$var$createSpaceDisabledTooltipMessage,
    publishFormDescriptionMessage: $9a1f9ea716bf85fe$var$publishFormDescriptionMessage,
    publishFormLinkingErrorMessage: $9a1f9ea716bf85fe$var$publishFormLinkingErrorMessage,
    genericActionErrorMessage: $9a1f9ea716bf85fe$var$genericActionErrorMessage,
    publishToNewSpaceCheckboxLabelMessage: $9a1f9ea716bf85fe$var$publishToNewSpaceCheckboxLabelMessage
};
module.exports["createKbMessages"] = $9a1f9ea716bf85fe$export$983b38a1587d5225;

});

parcelRegister("hJIl5", function(module, exports) {

var $1hQ0e = parcelRequire("1hQ0e");

const $177e5dac85a57768$var$ACTIVATION_ID_META_KEY = 'ajs-activation-id';
const $177e5dac85a57768$var$getActivationIdFromMeta = ()=>{
    const metaTag = (0, $1hQ0e.getDocument)()?.querySelector(`meta[name="${$177e5dac85a57768$var$ACTIVATION_ID_META_KEY}"]`);
    const activationId = metaTag?.getAttribute('content')?.trim();
    return activationId ? activationId : null;
};
const $177e5dac85a57768$export$39d2bb5729ec518 = (_args)=>{
    return $177e5dac85a57768$var$getActivationIdFromMeta();
};
module.exports["useCreateKbActivationId"] = $177e5dac85a57768$export$39d2bb5729ec518;

});

parcelRegister("64qm3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b12f6940a8791185$export$7580a642bc320c45 = ({ isArticlesCard: isArticlesCard, isConfirmLoading: isConfirmLoading, projectIdentifier: projectIdentifier })=>{
    const [cardView, setCardView] = (0, $cozmU.useState)('IMAGE_PREVIEW');
    const [spaceName, setSpaceName] = (0, $cozmU.useState)('');
    const [selectedSpace, setSelectedSpace] = (0, $cozmU.useState)(null);
    const [publishNewSpaceName, setPublishNewSpaceName] = (0, $cozmU.useState)(null);
    const [isPublishConsentRequired, setIsPublishConsentRequired] = (0, $cozmU.useState)(false);
    const [isPublishConsentChecked, setIsPublishConsentChecked] = (0, $cozmU.useState)(false);
    const [isPublishSpaceNameValid, setIsPublishSpaceNameValid] = (0, $cozmU.useState)(true);
    const resetPublishState = (0, $cozmU.useCallback)(()=>{
        setIsPublishConsentRequired(false);
        setIsPublishConsentChecked(false);
        setIsPublishSpaceNameValid(true);
    }, []);
    const handleSaveForLater = (0, $cozmU.useCallback)(()=>{
        setCardView('CREATE_SPACE_FORM');
    }, []);
    const handlePublishAll = (0, $cozmU.useCallback)(()=>{
        resetPublishState();
        setCardView('PUBLISH_FORM');
    }, [
        resetPublishState
    ]);
    const handleBackToInitial = (0, $cozmU.useCallback)(()=>{
        resetPublishState();
        setCardView('IMAGE_PREVIEW');
    }, [
        resetPublishState
    ]);
    const handlePublishConsentChange = (0, $cozmU.useCallback)(({ isRequired: isRequired, isChecked: isChecked, isSpaceNameValid: isSpaceNameValid })=>{
        setIsPublishConsentRequired(isRequired);
        setIsPublishConsentChecked(isChecked);
        setIsPublishSpaceNameValid(isSpaceNameValid);
    }, []);
    const handlePublishTargetChange = (0, $cozmU.useCallback)(({ newSpaceName: newSpaceName })=>{
        setPublishNewSpaceName(newSpaceName);
    }, []);
    const footerMode = (0, $cozmU.useMemo)(()=>cardView === 'CREATE_SPACE_FORM' ? 'FORM_ACTIONS' : cardView === 'PUBLISH_FORM' ? 'PUBLISH_ACTIONS' : isArticlesCard ? 'ARTICLE_ACTIONS' : 'CREATE_DRAFTS', [
        cardView,
        isArticlesCard
    ]);
    const isConfirmDisabled = !spaceName.trim() || isConfirmLoading || !projectIdentifier;
    const isPublishDisabled = isConfirmLoading || !projectIdentifier || !publishNewSpaceName && !selectedSpace || isPublishConsentRequired && (!isPublishConsentChecked || !isPublishSpaceNameValid);
    return {
        cardView: cardView,
        spaceName: spaceName,
        setSpaceName: setSpaceName,
        selectedSpace: selectedSpace,
        setSelectedSpace: setSelectedSpace,
        publishNewSpaceName: publishNewSpaceName,
        isPublishConsentChecked: isPublishConsentChecked,
        handlePublishConsentChange: handlePublishConsentChange,
        handlePublishTargetChange: handlePublishTargetChange,
        handleSaveForLater: handleSaveForLater,
        handlePublishAll: handlePublishAll,
        handleBackToInitial: handleBackToInitial,
        footerMode: footerMode,
        isConfirmDisabled: isConfirmDisabled,
        isPublishDisabled: isPublishDisabled
    };
};
module.exports["useCreateKbCardViewState"] = $b12f6940a8791185$export$7580a642bc320c45;

});

parcelRegister("kiRnH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hlvTd = parcelRequire("hlvTd");


var $bCDPT = parcelRequire("bCDPT");

const $aeb74fc5cd187346$export$389b1a509cf30a3a = ({ projectId: projectId })=>{
    const [projectIdentifier, setProjectIdentifier] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        setProjectIdentifier(null);
        const fetchProjectIdentifier = async ()=>{
            try {
                const identifier = await (0, $bCDPT.createKbApi).fetchProjectIdentifierById({
                    projectId: projectId
                });
                if (isMounted) setProjectIdentifier(identifier);
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'CreateKBCardProjectIdentifierError',
                    tags: {
                        projectId: String(projectId)
                    }
                });
            }
        };
        fetchProjectIdentifier();
        return ()=>{
            isMounted = false;
        };
    }, [
        projectId
    ]);
    return projectIdentifier;
};
module.exports["useCreateKbProjectIdentifier"] = $aeb74fc5cd187346$export$389b1a509cf30a3a;

});

parcelRegister("aceGc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("63sT2");
var $dYn3u = parcelRequire("dYn3u");
var $8NccQ = parcelRequire("8NccQ");
parcelRequire("kgHuu");
var $3qdJ0 = parcelRequire("3qdJ0");


var $iDrrr = parcelRequire("iDrrr");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $bCDPT = parcelRequire("bCDPT");


var $9Bnz7 = parcelRequire("9Bnz7");


var $9Kqv9 = parcelRequire("9Kqv9");

const $b789bea87489d7ee$var$CONFLUENCE_CROSS_FLOW_SOURCE_COMPONENT = 'JSDKnowledgeBaseSetupXFlowUi';
const $b789bea87489d7ee$var$SPACE_LINK_PROPAGATION_DELAY_MS = 500;
const $b789bea87489d7ee$var$waitForSpaceLinkPropagation = ()=>new Promise((resolve)=>{
        setTimeout(resolve, $b789bea87489d7ee$var$SPACE_LINK_PROPAGATION_DELAY_MS);
    });
const $b789bea87489d7ee$var$waitForSpaceLinkPropagationIfEnabled = async ()=>{
    if (!(0, $iDrrr.fg)('jsm_kb_from_scratch_space_link_delay')) return;
    // Backend linkage is not immediately consistent; without a brief wait the article publish API
    // can return 4xx responses right after the space link succeeds.
    await $b789bea87489d7ee$var$waitForSpaceLinkPropagation();
};
const $b789bea87489d7ee$var$retryStepsFrom = {
    activateAppLink: [
        'activateAppLink',
        'createSpace',
        'linkSpace',
        'publishArticles'
    ],
    createSpace: [
        'createSpace',
        'linkSpace',
        'publishArticles'
    ],
    linkSpace: [
        'linkSpace',
        'publishArticles'
    ],
    publishArticles: [
        'publishArticles'
    ]
};
const $b789bea87489d7ee$var$getArticlesFingerprint = (articles)=>articles.map((article, index)=>({
            key: article.articleId,
            title: article.title,
            summary: article.summary ?? null,
            body: article.body ?? null,
            rovoTopicId: article.rovoTopicId ?? null
        }));
const $b789bea87489d7ee$var$createRetryExecutionContext = ({ retryStateRef: retryStateRef, signature: signature })=>{
    const existingRetryState = retryStateRef.current;
    const shouldRetryFailedStepsOnly = existingRetryState?.signature === signature && existingRetryState.failedSteps.length > 0;
    const failedSteps = new Set(shouldRetryFailedStepsOnly ? existingRetryState.failedSteps : []);
    const failedArticleKeys = new Set(shouldRetryFailedStepsOnly ? existingRetryState.failedArticleKeys : []);
    let createdSpace = shouldRetryFailedStepsOnly && existingRetryState ? existingRetryState.createdSpace : null;
    const persistFailureState = ()=>{
        retryStateRef.current = {
            signature: signature,
            failedSteps: Array.from(failedSteps),
            failedArticleKeys: Array.from(failedArticleKeys),
            createdSpace: createdSpace
        };
    };
    return {
        shouldRetryFailedStepsOnly: shouldRetryFailedStepsOnly,
        shouldRunStep: (step)=>!shouldRetryFailedStepsOnly || failedSteps.has(step),
        setCreatedSpace: (space)=>{
            createdSpace = space;
        },
        getCreatedSpace: ()=>createdSpace,
        failStep: (step)=>{
            failedSteps.clear();
            $b789bea87489d7ee$var$retryStepsFrom[step].forEach((retryStep)=>{
                failedSteps.add(retryStep);
            });
            failedArticleKeys.clear();
            persistFailureState();
        },
        failPublishArticles: (articleKeys)=>{
            failedSteps.clear();
            failedSteps.add('publishArticles');
            failedArticleKeys.clear();
            articleKeys.forEach((articleKey)=>{
                failedArticleKeys.add(articleKey);
            });
            persistFailureState();
        },
        clearStepFailure: (step)=>{
            failedSteps.delete(step);
        },
        clearRetryState: ()=>{
            retryStateRef.current = null;
        },
        selectArticlesToPublish: (articles)=>articles.map((article, index)=>({
                    article: article,
                    retryKey: article.articleId
                })).filter(({ retryKey: retryKey })=>{
                if (!shouldRetryFailedStepsOnly) return true;
                if (!failedSteps.has('publishArticles')) return false;
                if (failedArticleKeys.size === 0) return true;
                return failedArticleKeys.has(retryKey);
            })
    };
};
const $b789bea87489d7ee$var$runRetryableStep = async ({ context: context, step: step, execute: execute })=>{
    if (!context.shouldRunStep(step)) return;
    try {
        await execute();
        context.clearStepFailure(step);
    } catch (error) {
        context.failStep(step);
        throw error;
    }
};
const $b789bea87489d7ee$var$getFailedArticleKeys = (publishResults, articles)=>publishResults.map((result, index)=>({
            result: result,
            articleKey: articles[index].retryKey
        })).filter(({ result: result })=>result.status === 'rejected').map(({ articleKey: articleKey })=>articleKey);
const $b789bea87489d7ee$var$getFirstRejectedReason = (publishResults)=>{
    const rejectedResult = publishResults.find((result)=>result.status === 'rejected');
    return rejectedResult?.reason;
};
const $b789bea87489d7ee$var$getLinkSpaceSignature = (params)=>JSON.stringify({
        cloudId: params.cloudId,
        projectIdentifier: params.projectIdentifier,
        spaceId: params.spaceId,
        sourceVisibility: params.sourceVisibility,
        appLinkId: params.appLinkId
    });
const $b789bea87489d7ee$export$6072eb508a01fc0c = ({ cloudId: cloudId, projectId: projectId, projectIdentifier: projectIdentifier, jiraActivationId: jiraActivationId, appLinkId: appLinkId, stagingAreaArticles: stagingAreaArticles, linkSpaceToKnowledgeBase: linkSpaceToKnowledgeBase, closeModal: closeModal, onLinkSourceAlreadyHasContentErrorChange: onLinkSourceAlreadyHasContentErrorChange, onGenericPublishErrorChange: onGenericPublishErrorChange })=>{
    const [isConfirmLoading, setIsConfirmLoading] = (0, $cozmU.useState)(false);
    const crossFlow = (0, $8NccQ.useCrossFlow)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const confirmRetryStateRef = (0, $cozmU.useRef)(null);
    const publishRetryStateRef = (0, $cozmU.useRef)(null);
    const confirmLastSuccessfulLinkSignatureRef = (0, $cozmU.useRef)(null);
    const publishLastSuccessfulLinkSignatureRef = (0, $cozmU.useRef)(null);
    const handleConfirmCreateSpace = (0, $cozmU.useCallback)(async ({ spaceName: spaceName, selectedTypeValue: selectedTypeValue })=>{
        if (!spaceName.trim() || isConfirmLoading || !projectIdentifier || !jiraActivationId) return;
        try {
            onLinkSourceAlreadyHasContentErrorChange(false);
            onGenericPublishErrorChange(false);
            setIsConfirmLoading(true);
            const normalizedSpaceName = spaceName.trim();
            const normalizedArticles = stagingAreaArticles ?? [];
            const confirmSignature = JSON.stringify({
                spaceName: normalizedSpaceName,
                selectedTypeValue: selectedTypeValue,
                projectIdentifier: projectIdentifier,
                jiraActivationId: jiraActivationId,
                appLinkId: appLinkId,
                articles: $b789bea87489d7ee$var$getArticlesFingerprint(normalizedArticles)
            });
            const retryContext = $b789bea87489d7ee$var$createRetryExecutionContext({
                retryStateRef: confirmRetryStateRef,
                signature: confirmSignature
            });
            await $b789bea87489d7ee$var$runRetryableStep({
                context: retryContext,
                step: 'createSpace',
                execute: async ()=>{
                    const newlyCreatedSpace = await (0, $bCDPT.createKbApi).createConfluenceSpace({
                        spaceName: normalizedSpaceName,
                        projectId: projectId,
                        activationId: jiraActivationId
                    });
                    retryContext.setCreatedSpace({
                        id: newlyCreatedSpace.id,
                        key: newlyCreatedSpace.key
                    });
                }
            });
            const createdSpace = retryContext.getCreatedSpace();
            if (!createdSpace) {
                const error = new Error('Unable to resolve created space for confirm publish flow');
                retryContext.failStep('createSpace');
                throw error;
            }
            const linkSpaceParams = {
                cloudId: cloudId,
                projectIdentifier: projectIdentifier,
                spaceId: createdSpace.id,
                sourceVisibility: selectedTypeValue,
                appLinkId: appLinkId
            };
            const linkSpaceSignature = $b789bea87489d7ee$var$getLinkSpaceSignature(linkSpaceParams);
            if (confirmLastSuccessfulLinkSignatureRef.current === linkSpaceSignature) retryContext.clearStepFailure('linkSpace');
            else {
                await $b789bea87489d7ee$var$runRetryableStep({
                    context: retryContext,
                    step: 'linkSpace',
                    execute: async ()=>{
                        await linkSpaceToKnowledgeBase(linkSpaceParams);
                        confirmLastSuccessfulLinkSignatureRef.current = linkSpaceSignature;
                    }
                });
                await $b789bea87489d7ee$var$waitForSpaceLinkPropagationIfEnabled();
            }
            const articlesToPublish = retryContext.selectArticlesToPublish(normalizedArticles);
            if (articlesToPublish.length > 0) {
                const publishResults = await Promise.allSettled(articlesToPublish.map(({ article: article })=>(0, $9Bnz7.publishConfluenceArticle)({
                        projectId: projectId,
                        activationId: jiraActivationId,
                        spaceKey: createdSpace.key,
                        article: article,
                        status: 'DRAFT'
                    })));
                const nextFailedArticleKeys = $b789bea87489d7ee$var$getFailedArticleKeys(publishResults, articlesToPublish);
                if (nextFailedArticleKeys.length > 0) {
                    retryContext.failPublishArticles(nextFailedArticleKeys);
                    throw $b789bea87489d7ee$var$getFirstRejectedReason(publishResults) ?? new Error('Failed to publish one or more articles');
                }
            }
            retryContext.clearRetryState();
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'published',
                actionSubject: 'jsmKbFromScratchArticles',
                actionSubjectId: 'jsmKbFromScratchArticlesPublished',
                attributes: {
                    projectId: projectId,
                    activationId: jiraActivationId,
                    spaceId: createdSpace.id,
                    spaceKey: createdSpace.key,
                    publishStatus: 'DRAFT',
                    articleCount: stagingAreaArticles.length,
                    sourceVisibility: selectedTypeValue
                }
            });
            closeModal();
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'jsmKbFromScratchArticles',
                actionSubjectId: 'jsmKbFromScratchArticlesPublishFailed',
                attributes: {
                    projectId: projectId,
                    activationId: jiraActivationId,
                    publishStatus: 'DRAFT',
                    articleCount: stagingAreaArticles.length,
                    sourceVisibility: selectedTypeValue
                }
            });
            const isLinkSourceAlreadyHasContentError = (0, $9Kqv9.isCreateKbLinkSourceAlreadyHasContentError)(error);
            onLinkSourceAlreadyHasContentErrorChange(isLinkSourceAlreadyHasContentError);
            onGenericPublishErrorChange(!isLinkSourceAlreadyHasContentError);
            (0, $hlvTd.logException)({
                exception: error,
                name: 'CreateKbCardConfirmCreateSpaceError'
            });
        } finally{
            setIsConfirmLoading(false);
        }
    }, [
        appLinkId,
        closeModal,
        cloudId,
        isConfirmLoading,
        jiraActivationId,
        linkSpaceToKnowledgeBase,
        onGenericPublishErrorChange,
        onLinkSourceAlreadyHasContentErrorChange,
        projectId,
        projectIdentifier,
        sendAnalyticsEvent,
        stagingAreaArticles
    ]);
    const handlePublish = (0, $cozmU.useCallback)(async ({ publishNewSpaceName: publishNewSpaceName, isPublishToNewSpaceChecked: isPublishToNewSpaceChecked, selectedSpace: selectedSpace, selectedTypeValue: selectedTypeValue })=>{
        if (isConfirmLoading || !jiraActivationId || !projectIdentifier) return;
        try {
            onLinkSourceAlreadyHasContentErrorChange(false);
            onGenericPublishErrorChange(false);
            setIsConfirmLoading(true);
            const newSpaceName = publishNewSpaceName?.trim() ?? '';
            const shouldCreateNewSpace = newSpaceName.length > 0;
            const shouldActivateAppLink = shouldCreateNewSpace && !appLinkId && isPublishToNewSpaceChecked && (0, $iDrrr.fg)('jsm_kb_from_scratch_confluence_linking');
            const normalizedArticles = stagingAreaArticles ?? [];
            const publishSignature = JSON.stringify({
                publishNewSpaceName: newSpaceName,
                isPublishToNewSpaceChecked: isPublishToNewSpaceChecked,
                selectedSpaceId: selectedSpace?.value ?? null,
                selectedSpaceKey: selectedSpace?.key ?? null,
                selectedTypeValue: selectedTypeValue,
                projectIdentifier: projectIdentifier,
                jiraActivationId: jiraActivationId,
                appLinkId: appLinkId,
                articles: $b789bea87489d7ee$var$getArticlesFingerprint(normalizedArticles)
            });
            const retryContext = $b789bea87489d7ee$var$createRetryExecutionContext({
                retryStateRef: publishRetryStateRef,
                signature: publishSignature
            });
            let targetSpaceId = selectedSpace?.value ?? '';
            let targetSpaceKey = selectedSpace?.key ?? '';
            const createdSpace = retryContext.getCreatedSpace();
            if (createdSpace) {
                targetSpaceId = createdSpace.id;
                targetSpaceKey = createdSpace.key;
            }
            if (shouldCreateNewSpace) {
                if (shouldActivateAppLink) await $b789bea87489d7ee$var$runRetryableStep({
                    context: retryContext,
                    step: 'activateAppLink',
                    execute: async ()=>{
                        if (!crossFlow.isEnabled) {
                            sendAnalyticsEvent({
                                eventType: 'track',
                                action: 'failed',
                                actionSubject: 'jsmKbConfluenceCrossFlowActivation',
                                actionSubjectId: 'jsmKbConfluenceCrossFlowActivationFailed',
                                attributes: {
                                    projectId: projectId,
                                    activationId: jiraActivationId,
                                    sourceComponent: $b789bea87489d7ee$var$CONFLUENCE_CROSS_FLOW_SOURCE_COMPONENT,
                                    reason: 'crossFlowDisabled'
                                }
                            });
                            throw new Error('Confluence cross-flow is unavailable');
                        }
                        const status = await crossFlow.api.open({
                            journey: (0, $dYn3u.Journeys).GET_STARTED,
                            targetProduct: (0, $3qdJ0.Targets).CONFLUENCE,
                            sourceContext: 'jira',
                            sourceComponent: $b789bea87489d7ee$var$CONFLUENCE_CROSS_FLOW_SOURCE_COMPONENT,
                            experimentalOptions: {
                                isJSMKnowledgeBaseRollout: true
                            }
                        });
                        if (status.success === true) {
                            sendAnalyticsEvent({
                                eventType: 'track',
                                action: 'activated',
                                actionSubject: 'jsmKbConfluenceCrossFlowActivation',
                                actionSubjectId: 'jsmKbConfluenceCrossFlowActivationSucceeded',
                                attributes: {
                                    projectId: projectId,
                                    activationId: jiraActivationId,
                                    sourceComponent: $b789bea87489d7ee$var$CONFLUENCE_CROSS_FLOW_SOURCE_COMPONENT
                                }
                            });
                            return;
                        }
                        sendAnalyticsEvent({
                            eventType: 'track',
                            action: 'failed',
                            actionSubject: 'jsmKbConfluenceCrossFlowActivation',
                            actionSubjectId: 'jsmKbConfluenceCrossFlowActivationFailed',
                            attributes: {
                                projectId: projectId,
                                activationId: jiraActivationId,
                                sourceComponent: $b789bea87489d7ee$var$CONFLUENCE_CROSS_FLOW_SOURCE_COMPONENT,
                                reason: 'notActivated'
                            }
                        });
                        throw new Error('Confluence cross-flow activation was not completed');
                    }
                });
                await $b789bea87489d7ee$var$runRetryableStep({
                    context: retryContext,
                    step: 'createSpace',
                    execute: async ()=>{
                        const newlyCreatedSpace = await (0, $bCDPT.createKbApi).createConfluenceSpace({
                            spaceName: newSpaceName,
                            projectId: projectId,
                            activationId: jiraActivationId
                        });
                        const nextCreatedSpace = {
                            id: newlyCreatedSpace.id,
                            key: newlyCreatedSpace.key
                        };
                        retryContext.setCreatedSpace(nextCreatedSpace);
                        targetSpaceId = nextCreatedSpace.id;
                        targetSpaceKey = nextCreatedSpace.key;
                    }
                });
            } else if (!targetSpaceId || !targetSpaceKey) return;
            if (shouldCreateNewSpace && (!targetSpaceId || !targetSpaceKey)) {
                const error = new Error('Unable to resolve target space for publish flow');
                retryContext.failStep('createSpace');
                throw error;
            }
            const linkSpaceParams = {
                cloudId: cloudId,
                projectIdentifier: projectIdentifier,
                spaceId: targetSpaceId,
                sourceVisibility: selectedTypeValue,
                appLinkId: appLinkId
            };
            const linkSpaceSignature = $b789bea87489d7ee$var$getLinkSpaceSignature(linkSpaceParams);
            if (publishLastSuccessfulLinkSignatureRef.current === linkSpaceSignature) retryContext.clearStepFailure('linkSpace');
            else {
                await $b789bea87489d7ee$var$runRetryableStep({
                    context: retryContext,
                    step: 'linkSpace',
                    execute: async ()=>{
                        await linkSpaceToKnowledgeBase(linkSpaceParams);
                        publishLastSuccessfulLinkSignatureRef.current = linkSpaceSignature;
                    }
                });
                await $b789bea87489d7ee$var$waitForSpaceLinkPropagationIfEnabled();
            }
            const articlesToPublish = retryContext.selectArticlesToPublish(normalizedArticles);
            if (articlesToPublish.length > 0) {
                const publishResults = await Promise.allSettled(articlesToPublish.map(({ article: article })=>(0, $9Bnz7.publishConfluenceArticle)({
                        projectId: projectId,
                        activationId: jiraActivationId,
                        spaceKey: targetSpaceKey,
                        article: article,
                        status: 'CURRENT'
                    })));
                const nextFailedArticleKeys = $b789bea87489d7ee$var$getFailedArticleKeys(publishResults, articlesToPublish);
                if (nextFailedArticleKeys.length > 0) {
                    retryContext.failPublishArticles(nextFailedArticleKeys);
                    throw $b789bea87489d7ee$var$getFirstRejectedReason(publishResults) ?? new Error('Failed to publish one or more articles');
                }
            }
            retryContext.clearRetryState();
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'published',
                actionSubject: 'jsmKbFromScratchArticles',
                actionSubjectId: 'jsmKbFromScratchArticlesPublished',
                attributes: {
                    projectId: projectId,
                    activationId: jiraActivationId,
                    spaceId: targetSpaceId,
                    spaceKey: targetSpaceKey,
                    publishStatus: 'CURRENT',
                    articleCount: stagingAreaArticles.length,
                    sourceVisibility: selectedTypeValue
                }
            });
            closeModal();
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'jsmKbFromScratchArticles',
                actionSubjectId: 'jsmKbFromScratchArticlesPublishFailed',
                attributes: {
                    projectId: projectId,
                    activationId: jiraActivationId,
                    publishStatus: 'CURRENT',
                    articleCount: stagingAreaArticles.length,
                    sourceVisibility: selectedTypeValue
                }
            });
            const isLinkSourceAlreadyHasContentError = (0, $9Kqv9.isCreateKbLinkSourceAlreadyHasContentError)(error);
            onLinkSourceAlreadyHasContentErrorChange(isLinkSourceAlreadyHasContentError);
            onGenericPublishErrorChange(!isLinkSourceAlreadyHasContentError);
            (0, $hlvTd.logException)({
                exception: error,
                name: 'CreateKbCardPublishError'
            });
        } finally{
            setIsConfirmLoading(false);
        }
    }, [
        appLinkId,
        closeModal,
        cloudId,
        crossFlow,
        isConfirmLoading,
        jiraActivationId,
        linkSpaceToKnowledgeBase,
        onGenericPublishErrorChange,
        onLinkSourceAlreadyHasContentErrorChange,
        projectId,
        projectIdentifier,
        sendAnalyticsEvent,
        stagingAreaArticles
    ]);
    return {
        isConfirmLoading: isConfirmLoading,
        handleConfirmCreateSpace: handleConfirmCreateSpace,
        handlePublish: handlePublish
    };
};
module.exports["useCreateKbPublishHandlers"] = $b789bea87489d7ee$export$6072eb508a01fc0c;

});

parcelRegister("cXeLJ", function(module, exports) {

var $4qcxA = parcelRequire("4qcxA");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $hlvTd = parcelRequire("hlvTd");

const $2387952604d4adbd$export$f1e737ce8a40bfc2 = ({ cloudId: cloudId, projectIdentifier: projectIdentifier })=>{
    const [appLinkId, setAppLinkId] = (0, $cozmU.useState)(null);
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        const fetchAppLinkId = async ()=>{
            if (!projectIdentifier) {
                if (isMounted) setAppLinkId(null);
                return;
            }
            try {
                const response = await (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $4qcxA.default), {
                    projectIdentifier: projectIdentifier,
                    cloudId: cloudId
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                const nextAppLinkId = response?.knowledgeBase_confluenceAppLinkDetails?.__typename === 'KnowledgeBaseConfluenceAppLinkDetails' ? response.knowledgeBase_confluenceAppLinkDetails.appLinkId : null;
                if (isMounted) setAppLinkId(nextAppLinkId ?? null);
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'CreateKBCardServerLinkStatusQueryError',
                    tags: {
                        projectIdentifier: projectIdentifier,
                        cloudId: cloudId
                    }
                });
            }
        };
        fetchAppLinkId();
        return ()=>{
            isMounted = false;
        };
    }, [
        cloudId,
        projectIdentifier,
        relayEnvironment
    ]);
    return appLinkId;
};
module.exports["useCreateKbServerAppLinkId"] = $2387952604d4adbd$export$f1e737ce8a40bfc2;

});

parcelRegister("9Kqv9", function(module, exports) {

var $jFEee = parcelRequire("jFEee");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $aBKty = parcelRequire("aBKty");


var $5OelY = parcelRequire("5OelY");

const $4b7499de8355575b$export$9763c9af423f8030 = 'KB_ALREADY_HAS_CONTENT';
const $4b7499de8355575b$var$createLinkSourceAlreadyHasContentError = ()=>Object.assign(new Error('Confluence space was created but failed to link with the knowledge base because it already has content'), {
        code: $4b7499de8355575b$export$9763c9af423f8030
    });
const $4b7499de8355575b$export$13b3aed542dd75e4 = (error)=>Boolean(error && typeof error === 'object' && 'code' in error && error.code === $4b7499de8355575b$export$9763c9af423f8030);
const $4b7499de8355575b$var$getSourceAri = ({ cloudId: cloudId, spaceId: spaceId })=>(0, $5OelY.ConfluenceSpaceAri).create({
        siteId: cloudId,
        spaceId: spaceId
    }).toString();
const $4b7499de8355575b$var$getSourceContainerAri = ({ cloudId: cloudId })=>(0, $aBKty.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
const $4b7499de8355575b$export$d8f582e3ad388357 = ()=>{
    const [commitLinkSources] = (0, $6SsN4.useMutation)((0, $jFEee.default));
    const linkSpaceToKnowledgeBase = (0, $cozmU.useCallback)(async ({ cloudId: cloudId, projectIdentifier: projectIdentifier, spaceId: spaceId, sourceVisibility: sourceVisibility, appLinkId: appLinkId })=>new Promise((resolve, reject)=>{
            commitLinkSources({
                variables: {
                    cloudId: cloudId,
                    projectIdentifier: projectIdentifier,
                    sources: [
                        {
                            sourceARI: $4b7499de8355575b$var$getSourceAri({
                                cloudId: cloudId,
                                spaceId: spaceId
                            }),
                            sourceContainerARI: $4b7499de8355575b$var$getSourceContainerAri({
                                cloudId: cloudId
                            }),
                            visibility: sourceVisibility,
                            metadata: appLinkId ? {
                                applicationIdentifier: appLinkId
                            } : undefined
                        }
                    ]
                },
                onCompleted: (response, errors)=>{
                    if (errors?.length) {
                        reject(new Error(errors.map((error)=>error.message).join(', ')));
                        return;
                    }
                    const linkResult = response.knowledgeBase_linkSources?.linkSourceResults?.[0];
                    if (!linkResult?.success) {
                        reject($4b7499de8355575b$var$createLinkSourceAlreadyHasContentError());
                        return;
                    }
                    resolve();
                },
                onError: (error)=>reject(error)
            });
        }), [
        commitLinkSources
    ]);
    return {
        linkSpaceToKnowledgeBase: linkSpaceToKnowledgeBase
    };
};
module.exports["isCreateKbLinkSourceAlreadyHasContentError"] = $4b7499de8355575b$export$13b3aed542dd75e4;
module.exports["useCreateKbSourceLinking"] = $4b7499de8355575b$export$d8f582e3ad388357;

});

parcelRegister("k5EPe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $dw75i = parcelRequire("dw75i");


var $gzMZq = parcelRequire("gzMZq");


var $9Wwnb = parcelRequire("9Wwnb");


var $5Tn11 = parcelRequire("5Tn11");


var $8JVOU = parcelRequire("8JVOU");


var $bCDPT = parcelRequire("bCDPT");

const $75d47481f5429a89$var$isKBArticleData = (value)=>{
    if (!value || typeof value !== 'object') return false;
    const candidate = value;
    return typeof candidate.articleId === 'string' && typeof candidate.title === 'string' && Object.prototype.hasOwnProperty.call(candidate, 'body');
};
const $75d47481f5429a89$var$toKbDraftArticlesContext = (articles)=>articles.filter((article)=>typeof article.articleId === 'string' && article.articleId.length > 0 && typeof article.title === 'string').map((article)=>({
            articleId: article.articleId,
            isEdited: Boolean(article.isEdited),
            title: article.title
        }));
const $75d47481f5429a89$var$toPublishableKbArticles = (articles)=>articles.map((article)=>({
            articleId: article.articleId,
            title: article.title,
            summary: article.summary,
            body: article.body,
            rovoTopicId: article.rovoTopicId
        }));
const $75d47481f5429a89$export$80b0d3763bf3431a = ({ articleIds: articleIds, projectId: projectId, activationId: activationId, isLastActionMessage: isLastActionMessage })=>{
    const [stagingAreaArticles, setStagingAreaArticles] = (0, $cozmU.useState)([]);
    const { setAIFeatureContext: setAIFeatureContext } = (0, $gzMZq.useChatContextStoreActions)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const syncArticlesByIds = (0, $cozmU.useCallback)(async (articleIdsToSync)=>{
        if (!activationId || !articleIdsToSync.length) return;
        const fetchedArticleResults = await Promise.allSettled(articleIdsToSync.map((id)=>(0, $bCDPT.createKbApi).fetchRovoSkillArticleById({
                projectId: projectId,
                activationId: activationId,
                articleId: id
            })));
        const fetchedArticles = fetchedArticleResults.filter((result)=>result.status === 'fulfilled').map((result)=>result.value);
        const resolvedArticles = fetchedArticles.map((article)=>({
                articleId: article.articleId,
                title: article.title,
                summary: '',
                body: article.body ?? null,
                rovoTopicId: article.rovoTopicId
            }));
        const publishableArticles = $75d47481f5429a89$var$toPublishableKbArticles(resolvedArticles);
        if (!publishableArticles.length) return;
        setStagingAreaArticles(publishableArticles);
        setAIFeatureContext({
            contextKey: (0, $dw75i.JSM_CREATE_KB_ARTICLES_KEY),
            setContext: (_existingContext)=>({
                    kbDraftArticles: $75d47481f5429a89$var$toKbDraftArticlesContext(resolvedArticles)
                })
        });
    }, [
        projectId,
        activationId,
        setAIFeatureContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isLastActionMessage && (0, $iDrrr.fg)('jsm-kb-action-message-prop')) return;
        /** when new set of articleIds received */ sendAnalyticsEvent({
            eventType: 'track',
            action: 'generated',
            actionSubject: 'jsmKbFromScratchArticles',
            actionSubjectId: 'jsmKbFromScratchArticlesGenerated',
            attributes: {
                projectId: projectId,
                activationId: activationId,
                articleIds: articleIds,
                articleCount: articleIds.length
            }
        });
        syncArticlesByIds(articleIds);
    }, [
        articleIds,
        syncArticlesByIds,
        sendAnalyticsEvent,
        projectId,
        activationId,
        isLastActionMessage
    ]);
    const setupHandler = (0, $cozmU.useCallback)((on)=>{
        on((0, $8JVOU.JSMKBStagingAreaEventCommand), (payload)=>{
            if (payload.senderId === (0, $9Wwnb.JSM_CREATE_KB_STAGING_AREA_CLIENT_ID)) {
                if (payload.type !== 'articlesUpdated' && payload.type !== 'articleDeleted') return;
                const updatedArticles = payload.data?.articles;
                const updatedArticleId = payload.data?.articleId;
                if (!Array.isArray(updatedArticles)) return;
                const resolvedUpdatedArticles = updatedArticles.filter($75d47481f5429a89$var$isKBArticleData);
                const publishableUpdatedArticles = $75d47481f5429a89$var$toPublishableKbArticles(resolvedUpdatedArticles);
                setStagingAreaArticles(publishableUpdatedArticles);
                setAIFeatureContext({
                    contextKey: (0, $dw75i.JSM_CREATE_KB_ARTICLES_KEY),
                    setContext: (_existingContext)=>({
                            kbDraftArticles: $75d47481f5429a89$var$toKbDraftArticlesContext(resolvedUpdatedArticles)
                        })
                });
                if (payload.type === 'articleDeleted') {
                    if (!activationId || typeof updatedArticleId !== 'string' || !updatedArticleId) return;
                    (0, $bCDPT.createKbApi).deleteRovoSkillArticleById({
                        projectId: projectId,
                        activationId: activationId,
                        articleId: updatedArticleId
                    }).then(()=>{
                        sendAnalyticsEvent({
                            eventType: 'track',
                            action: 'deleted',
                            actionSubject: 'jsmKbFromScratchArticle',
                            actionSubjectId: 'jsmKbFromScratchArticleDeleteSuccessful',
                            attributes: {
                                projectId: projectId,
                                activationId: activationId,
                                articleId: updatedArticleId
                            }
                        });
                    }).catch((error)=>{
                        (0, $hlvTd.logException)({
                            exception: error,
                            name: 'CreateKbStagingAreaArticleDeleteError',
                            tags: {
                                projectId: String(projectId),
                                articleId: updatedArticleId
                            }
                        });
                    });
                    return;
                }
                if (!activationId || typeof updatedArticleId !== 'string' || !updatedArticleId) return;
                const updatedArticle = publishableUpdatedArticles.find((article)=>article.articleId === updatedArticleId);
                if (!updatedArticle || typeof updatedArticle.title !== 'string' || updatedArticle.title.trim().length === 0 || updatedArticle.body === undefined) return;
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'edited',
                    actionSubject: 'jsmKbFromScratchArticle',
                    actionSubjectId: 'jsmKbFromScratchArticleEdited',
                    attributes: {
                        projectId: projectId,
                        activationId: activationId,
                        articleId: updatedArticleId
                    }
                });
                (0, $bCDPT.createKbApi).updateRovoSkillArticleById({
                    projectId: projectId,
                    activationId: activationId,
                    articleId: updatedArticleId,
                    title: updatedArticle.title,
                    body: updatedArticle.body,
                    rovoTopicId: updatedArticle.rovoTopicId || null
                }).catch((error)=>{
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: 'CreateKbStagingAreaArticleUpdateError',
                        tags: {
                            projectId: String(projectId),
                            articleId: updatedArticleId
                        }
                    });
                });
                return;
            }
            if (payload.senderId !== (0, $5Tn11.ROVO_CHAT_CLIENT_ID)) return;
            const actionPayload = payload.data?.actions;
            if (!Array.isArray(actionPayload)) return;
            const payloadArticleIds = actionPayload.flatMap((action)=>action.data.articleIds ?? []).filter((id)=>typeof id === 'string');
            if (!payloadArticleIds.length) return;
            syncArticlesByIds(payloadArticleIds);
        });
    }, [
        activationId,
        projectId,
        sendAnalyticsEvent,
        setAIFeatureContext,
        syncArticlesByIds
    ]);
    return {
        stagingAreaArticles: stagingAreaArticles,
        setupHandler: setupHandler
    };
};
module.exports["useCreateKbStagingAreaSync"] = $75d47481f5429a89$export$80b0d3763bf3431a;

});

parcelRegister("icLLU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hlvTd = parcelRequire("hlvTd");


var $1HjbK = parcelRequire("1HjbK");

const $ef7d2c4a3de700d5$export$3c7a9aaa973ccc99 = ({ cloudId: cloudId, userId: userId })=>{
    const { listEntities: listEntities } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    const [prefetchedSpaceOptions, setPrefetchedSpaceOptions] = (0, $cozmU.useState)(null);
    const [isPrefetchedSpaceOptionsLoading, setIsPrefetchedSpaceOptionsLoading] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        if (!userId) {
            setIsPrefetchedSpaceOptionsLoading(false);
            setPrefetchedSpaceOptions([]);
            setIsPrefetchedSpaceOptionsLoading(false);
            return;
        }
        let isCancelled = false;
        setIsPrefetchedSpaceOptionsLoading(true);
        const loadSpaces = async ()=>{
            setIsPrefetchedSpaceOptionsLoading(true);
            try {
                const entities = await listEntities('', [
                    'space'
                ]);
                if (isCancelled) return;
                const prefetchedOptions = entities.reduce((spaces, entity)=>{
                    if (!entity.id || !entity.key) return spaces;
                    spaces.push({
                        label: entity.name,
                        value: entity.id,
                        key: entity.key
                    });
                    return spaces;
                }, []);
                setPrefetchedSpaceOptions(prefetchedOptions);
            } catch (exception) {
                if (isCancelled) return;
                (0, $hlvTd.logException)({
                    exception: exception,
                    name: 'CreateKbCardLoadRecommendedSpacesError'
                });
                setPrefetchedSpaceOptions([]);
            } finally{
                if (!isCancelled) setIsPrefetchedSpaceOptionsLoading(false);
            }
        };
        loadSpaces();
        return ()=>{
            isCancelled = true;
        };
    }, [
        listEntities,
        userId
    ]);
    return {
        prefetchedSpaceOptions: prefetchedSpaceOptions,
        isPrefetchedSpaceOptionsLoading: isPrefetchedSpaceOptionsLoading
    };
};
module.exports["usePrefetchedSpaceOptions"] = $ef7d2c4a3de700d5$export$3c7a9aaa973ccc99;

});

parcelRegister("ENvWX", function(module, exports) {
/**
 * @generated SignedSource<<7c46b36232802dc746960e92f9c26c97>>
 * @relayHash e7986e43df53d92e7848141e8170ba45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c35f3e250551153c070e50e076ad0a2921f5bb39383ff372c6a1bda58fda9a0b
const $9d1b064ccb661758$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintAris"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        },
        {
            "kind": "Literal",
            "name": "ignoreMissingFields",
            "value": true
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "text"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = [
        v12 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v11 /*: any*/ ,
        v5 /*: any*/ 
    ], v14 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "selectedUsersConnection(first:10)"
        }
    ], v15 = [
        v11 /*: any*/ ,
        v5 /*: any*/ 
    ], v16 = [
        {
            "kind": "ScalarField",
            "name": "timeInSeconds"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainUpdateWorkItemAllFieldTypesActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fieldIdsOrAliases",
                                                            "variableName": "fieldIdsOrAliases"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "sprintAris",
                                                            "variableName": "sprintAris"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "actionCard_updateWorkItemAllFieldTypesActionRenderer"
                                                },
                                                {
                                                    "args": v7 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainUpdateWorkItemAllFieldTypesActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "args": v7 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraIssueField"
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v10 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraRichText",
                                                                    "kind": "LinkedField",
                                                                    "name": "richText",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraADF",
                                                                            "kind": "LinkedField",
                                                                            "name": "adfValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "convertedPlainText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "plainText"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isTruncated"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraRichTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v13 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v14 /*: any*/ ,
                                                            "type": "JiraPeopleField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v14 /*: any*/ ,
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v15 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraTransitionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "transitions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTransitionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraTransition",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "transitionId"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "to",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        },
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": v15 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedLabelsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabelEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraLabel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraLabelsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueId"
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "summary"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraParentIssueField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "number"
                                                                }
                                                            ],
                                                            "type": "JiraNumberField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeTrackingSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isJiraConfiguredTimeTrackingEnabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "workingHoursPerDay"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "workingDaysPerWeek"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "defaultFormat"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "defaultUnit"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "originalEstimate",
                                                                    "plural": false,
                                                                    "selections": v16 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "remainingEstimate",
                                                                    "plural": false,
                                                                    "selections": v16 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeSpent",
                                                                    "plural": false,
                                                                    "selections": v16 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraTimeTrackingField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "colorKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraColorField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v15 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "fields": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "operation",
                                                                                    "value": "ALLOW"
                                                                                },
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "optionIds",
                                                                                    "variableName": "sprintAris"
                                                                                }
                                                                            ],
                                                                            "kind": "ObjectValue",
                                                                            "name": "filterById"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprints",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "sprintId"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c35f3e250551153c070e50e076ad0a2921f5bb39383ff372c6a1bda58fda9a0b",
            "metadata": {},
            "name": "mainUpdateWorkItemAllFieldTypesActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9d1b064ccb661758$var$node.hash = "447efb1142d55cfb7d9216e207e922af";
var $9d1b064ccb661758$export$2e2bcd8739ae039 = $9d1b064ccb661758$var$node;
module.exports["default"] = $9d1b064ccb661758$export$2e2bcd8739ae039;

});

parcelRegister("amxY5", function(module, exports) {

var $l9aOd = parcelRequire("l9aOd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/jira/sprint/manifest.ts
var $78b64ed7e9437c06$var$jiraSprintAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $l9aOd.JiraSprintAriResourceOwner),
    resourceType: (0, $l9aOd.JiraSprintAriResourceType),
    resourceIdSlug: "activation/{activationId}/{sprintId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        sprintId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/sprint/index.ts
var $78b64ed7e9437c06$export$7b39a2c7a06d5820 = class _JiraSprintAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get sprintId() {
        return this._sprintId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $78b64ed7e9437c06$var$jiraSprintAriStaticOpts.qualifier,
            platformQualifier: $78b64ed7e9437c06$var$jiraSprintAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $78b64ed7e9437c06$var$jiraSprintAriStaticOpts.resourceOwner,
            resourceType: $78b64ed7e9437c06$var$jiraSprintAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.sprintId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                sprintId: opts.sprintId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $78b64ed7e9437c06$var$jiraSprintAriStaticOpts);
        return new _JiraSprintAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $78b64ed7e9437c06$var$jiraSprintAriStaticOpts);
        return new _JiraSprintAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            sprintId: this.sprintId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._sprintId = opts.resourceIdSegmentValues.sprintId;
    }
};
module.exports["JiraSprintAri"] = $78b64ed7e9437c06$export$7b39a2c7a06d5820;

});

parcelRegister("buzLI", function(module, exports) {
const $0d85a84d382b3861$export$3c8d9557a6b7bd8c = (url)=>{
    if (!url) return undefined;
    try {
        const parsed = new URL(url);
        const { hostname: hostname } = parsed;
        if (hostname === 'loom.com' || hostname.endsWith('.loom.com')) return 'loom';
        if (parsed.pathname.startsWith('/wiki')) return 'confluence';
        return 'other';
    } catch  {
        return undefined;
    }
};
module.exports["classifySourceUrl"] = $0d85a84d382b3861$export$3c8d9557a6b7bd8c;

});

parcelRegister("hPfeh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9NjIz = parcelRequire("9NjIz");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $4yZQ6 = parcelRequire("4yZQ6");


var $lzRnO = parcelRequire("lzRnO");


var $2XbWi = parcelRequire("2XbWi");

const $d688c0171c57cef5$var$styles = {
    fieldsList: "_0Of8r21Y8M _2Zuz6Q2ADO _1Znuxb2ADO _1wydGW1Y8M"
}; /**
    * Renders an action card for updating Jira issue fields within the conversation assistant.
    *
    * @remarks
    * This component displays a card containing a header and a list of field update actions.
    * It uses Relay fragments to fetch the necessary Jira issue data and passes it to child components.
    *
    * @param queryRef - The Relay fragment reference for the Jira issue data.
    * @param actions - An array of action objects representing field updates to be rendered.
    * @param props - Additional props to be passed to the CardFieldsList component.
    * @param shouldOpen - Whether the card is expanded on render or not.
    *
    * @returns
    * Returns a Stack containing the card header and a list of field update actions.
    * If no data is available or there are no actions, returns null.
    */ 
const $d688c0171c57cef5$export$e1abe0f3fc33f39e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    let actions;
    let cloudId;
    let props;
    let queryRef;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ queryRef: queryRef, actions: actions, cloudId: cloudId, shouldExpand: t1, showButtons: t2, ...props } = t0);
        $[0] = t0;
        $[1] = actions;
        $[2] = cloudId;
        $[3] = props;
        $[4] = queryRef;
        $[5] = t1;
        $[6] = t2;
    } else {
        actions = $[1];
        cloudId = $[2];
        props = $[3];
        queryRef = $[4];
        t1 = $[5];
        t2 = $[6];
    }
    const shouldExpand = t1 === undefined ? false : t1;
    const showButtons = t2 === undefined ? true : t2;
    (0, $6cFsl.di)((0, $2XbWi.CardHeader), (0, $lzRnO.CardFieldsList));
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(shouldExpand);
    const data = (0, $6SsN4.useFragment)((0, $9NjIz.default), queryRef);
    if (!data || actions.length === 0) return null;
    let t3;
    if ($[7] !== isExpanded) {
        t3 = ()=>setIsExpanded(!isExpanded);
        $[7] = isExpanded;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== data || $[10] !== isExpanded || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XbWi.CardHeader), {
            queryRef: data,
            isExpanded: isExpanded,
            onClick: t3
        });
        $[9] = data;
        $[10] = isExpanded;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== actions || $[14] !== cloudId || $[15] !== data || $[16] !== isExpanded || $[17] !== props || $[18] !== showButtons) {
        t5 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d688c0171c57cef5$var$styles.fieldsList
        }, actions.map((action)=>{
            const { fieldKey: fieldKey } = (0, $4yZQ6.getActionData)(action);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lzRnO.CardFieldsList), {
                key: fieldKey,
                queryRef: data,
                action: action,
                cloudId: cloudId,
                showActionButtons: showButtons,
                ...props
            });
        }));
        $[13] = actions;
        $[14] = cloudId;
        $[15] = data;
        $[16] = isExpanded;
        $[17] = props;
        $[18] = showButtons;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== t4 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: "update-work-item-all-fields-action-renderer.ui.action-card"
        }, t4, t5);
        $[20] = t4;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
} : ({ queryRef: queryRef, actions: actions, cloudId: cloudId, shouldExpand: shouldExpand = false, showButtons: showButtons = true, ...props })=>{
    (0, $6cFsl.di)((0, $2XbWi.CardHeader), (0, $lzRnO.CardFieldsList));
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(shouldExpand);
    const data = (0, $6SsN4.useFragment)((0, $9NjIz.default), queryRef);
    if (!data || actions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "update-work-item-all-fields-action-renderer.ui.action-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XbWi.CardHeader), {
        queryRef: data,
        isExpanded: isExpanded,
        onClick: ()=>setIsExpanded(!isExpanded)
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d688c0171c57cef5$var$styles.fieldsList
    }, actions.map((action)=>{
        const { fieldKey: fieldKey } = (0, $4yZQ6.getActionData)(action);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lzRnO.CardFieldsList), {
            key: fieldKey,
            queryRef: data,
            action: action,
            cloudId: cloudId,
            showActionButtons: showButtons,
            ...props
        });
    })));
};
module.exports["ActionCard"] = $d688c0171c57cef5$export$e1abe0f3fc33f39e;

});

parcelRegister("2esis", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");


var $7832B = parcelRequire("7832B");

const $bcd850420d69e080$var$styles = {
    container: "_2sNsIg20Hp _1wydGW2ADO",
    cardContainer: "_3iDTPbccYA _1g5erGQ4SZ"
};
const $bcd850420d69e080$export$fcf06206b9ed3e10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { sourceUrl: sourceUrl } = t0;
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!sourceUrl) return null;
    let t1;
    if ($[0] !== sourceUrl) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $bcd850420d69e080$var$styles.cardContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                url: sourceUrl,
                appearance: "inline",
                truncateInline: true
            }));
        $[0] = sourceUrl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage || $[3] !== t1) {
        t2 = formatMessage((0, $7832B.messages).contextMessage, {
            card: t1
        });
        $[2] = formatMessage;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bcd850420d69e080$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t2));
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ sourceUrl: sourceUrl })=>{
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!sourceUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bcd850420d69e080$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $7832B.messages).contextMessage, {
        card: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $bcd850420d69e080$var$styles.cardContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                url: sourceUrl,
                appearance: "inline",
                truncateInline: true
            }))
    })));
};
module.exports["CardGroupContext"] = $bcd850420d69e080$export$fcf06206b9ed3e10;

});

parcelRegister("jtMHU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $4ez2K = parcelRequire("4ez2K");


var $lfoFx = parcelRequire("lfoFx");


var $7832B = parcelRequire("7832B");

const $e449d353199780fa$var$styles = {
    wrapper: "_2mHwu81Y8M _0Of8r28HPE _1wydGW5zaO _2Zuz6Q8HPE _1Znuxb8HPE _37wbyuz9WS _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $e449d353199780fa$export$cfa9c99e7901ed73 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onDismiss: onDismiss, onApplyUpdates: onApplyUpdates, isDisabled: t1, allActionsApplied: t2, isBulkActioning: t3 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const allActionsApplied = t2 === undefined ? false : t2;
    const isBulkActioning = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (allActionsApplied) return null;
    let t4;
    if ($[0] !== formatMessage || $[1] !== isBulkActioning || $[2] !== isDisabled || $[3] !== onApplyUpdates || $[4] !== onDismiss) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $e449d353199780fa$var$styles.wrapper
        }, isBulkActioning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            interactionName: "load"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onDismiss,
            isDisabled: isDisabled
        }, formatMessage((0, $7832B.messages).dismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onApplyUpdates,
            isDisabled: isDisabled
        }, formatMessage((0, $7832B.messages).acceptAllButton))));
        $[0] = formatMessage;
        $[1] = isBulkActioning;
        $[2] = isDisabled;
        $[3] = onApplyUpdates;
        $[4] = onDismiss;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ onDismiss: onDismiss, onApplyUpdates: onApplyUpdates, isDisabled: isDisabled = false, allActionsApplied: allActionsApplied = false, isBulkActioning: isBulkActioning = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (allActionsApplied) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e449d353199780fa$var$styles.wrapper
    }, isBulkActioning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "load"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismiss,
        isDisabled: isDisabled
    }, formatMessage((0, $7832B.messages).dismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onApplyUpdates,
        isDisabled: isDisabled
    }, formatMessage((0, $7832B.messages).acceptAllButton))));
};
module.exports["CardGroupFooter"] = $e449d353199780fa$export$cfa9c99e7901ed73;

});

parcelRegister("7832B", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9fa3f32a91f5d4f7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dismissButton: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.dismiss-button.non-final",
        defaultMessage: "Dismiss"
    },
    acceptAllButton: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.accept-all-button.non-final",
        defaultMessage: "Accept all"
    },
    allActionsDismissed: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.all-actions-dismissed.non-final",
        defaultMessage: "You've dismissed all suggested updates"
    },
    noValidSuggestionsProvided: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.no-valid-suggestions-provided.non-final",
        defaultMessage: "No suggestions, try prompting again."
    },
    allActionsAccepted: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.all-actions-accepted.non-final",
        defaultMessage: "You've accepted all suggested updates"
    },
    updateWorkItems: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.update-work-items.non-final",
        defaultMessage: "Update work items"
    },
    contextMessage: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.context-message.non-final",
        defaultMessage: "Based on your recent activities and ongoing projects, here are some recommended updates based on <card></card>"
    }
});
module.exports["messages"] = $9fa3f32a91f5d4f7$export$defe85febe8b728c;

});

parcelRegister("1johS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eh6Ml = parcelRequire("eh6Ml");


var $5avUB = parcelRequire("5avUB");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $4c1b9fff2dbafbec$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $4c1b9fff2dbafbec$export$3f91b0466c5e5f77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { message: message, variant: t1 } = t0;
    const variant = t1 === undefined ? "success" : t1;
    const Icon = variant === "error" ? (0, (/*@__PURE__*/$parcel$interopDefault($5avUB))) : (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml)));
    const iconColor = variant === "error" ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-text-success, #4C6B1F)";
    let t2;
    if ($[0] !== Icon || $[1] !== iconColor) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: iconColor
        });
        $[0] = Icon;
        $[1] = iconColor;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== message) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, message);
        $[3] = message;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4c1b9fff2dbafbec$var$styles.explainerContainer,
            alignItems: "center",
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $4c1b9fff2dbafbec$var$styles.explainer,
            alignBlock: "center",
            alignInline: "center"
        }, t2, t3));
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ message: message, variant: variant = 'success' })=>{
    const Icon = variant === 'error' ? (0, (/*@__PURE__*/$parcel$interopDefault($5avUB))) : (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml)));
    const iconColor = variant === 'error' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-text-success, #4C6B1F)";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4c1b9fff2dbafbec$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $4c1b9fff2dbafbec$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, message)));
};
module.exports["SystemMessage"] = $4c1b9fff2dbafbec$export$3f91b0466c5e5f77;

});

parcelRegister("1inBu", function(module, exports) {
/**
 * Safely parses a string into a `URL` object.
 *
 * Attempts to construct a `URL` from the provided `urlString`. If the string is not a valid URL,
 * the function returns `null` instead of throwing an error.
 *
 * @param urlString - The string to parse as a URL.
 * @returns The parsed `URL` object if successful, or `null` if parsing fails.
 */ function $9716b9eab1a8844b$var$safeParse(urlString) {
    try {
        return new URL(urlString);
    } catch  {
        return null;
    }
}
/**
 * Normalizes the query string of a given URL by optionally stripping specified parameters
 * and sorting the remaining parameters by key and value.
 *
 * @param url - The URL object whose query string will be normalized.
 * @param strip - A set of parameter names (case-insensitive) to remove from the query string.
 * @param normalizeOrder - If true, sorts the query parameters by key and value.
 * @returns The normalized query string, including the leading '?', or an empty string if there are no parameters.
 */ function $9716b9eab1a8844b$var$normalizeQuery(url, strip, normalizeOrder) {
    if (!url?.search) return '';
    const params = new URLSearchParams(url.search);
    if (strip.size) {
        for (const key of Array.from(params.keys()))if (strip.has(key.toLowerCase())) params.delete(key);
    }
    if (normalizeOrder) {
        const pairs = [];
        params.forEach((value, key)=>pairs.push([
                key,
                value
            ]));
        pairs.sort((a, b)=>a[0] === b[0] ? a[1].localeCompare(b[1]) : a[0].localeCompare(b[0]));
        const sorted = new URLSearchParams();
        for (const [key, value] of pairs)sorted.append(key, value);
        const queryString = sorted.toString();
        return queryString ? `?${queryString}` : '';
    }
    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
}
/**
 * Normalizes a given URL string by parsing its components, optionally stripping specified query parameters,
 * normalizing the order of query parameters, and handling invalid URLs.
 *
 * @param urlString - The URL string to normalize.
 * @param options - Optional configuration for normalization.
 * @param options.stripQueryParams - An array of query parameter names to remove from the URL.
 * @param options.normalizeQueryOrder - Whether to sort query parameters alphabetically. Defaults to true.
 * @param options.ignoreInvalid - If true, returns `null` instead of throwing an error for invalid URLs.
 * @returns A `NormalizedUrlParts` object containing the normalized URL components, or `null` if the URL is invalid and `ignoreInvalid` is set.
 * @throws {Error} If the URL is invalid and `ignoreInvalid` is not set.
 */ function $9716b9eab1a8844b$var$normalizeUrl(urlString, { stripQueryParams: stripQueryParams = [], normalizeQueryOrder: normalizeQueryOrder = true, ignoreInvalid: ignoreInvalid = false } = {}) {
    const url = $9716b9eab1a8844b$var$safeParse(urlString);
    if (!url) {
        if (ignoreInvalid) return null;
        throw new Error(`Invalid URL: ${urlString}`);
    }
    let pathname = url.pathname;
    if (pathname !== '/' && pathname.endsWith('/')) pathname = pathname.slice(0, -1);
    const search = $9716b9eab1a8844b$var$normalizeQuery(url, new Set(stripQueryParams.map((s)=>s.toLowerCase())), normalizeQueryOrder);
    const hash = url.hash;
    const segments = pathname.split('/').filter(Boolean);
    return {
        origin: url.origin,
        pathname: pathname,
        search: search,
        hash: hash,
        segments: segments,
        original: urlString
    };
}
/**
 * Finds the longest common URL prefix among a list of URLs.
 *
 * This function normalizes the input URLs and determines the shared origin and path prefix.
 * It can optionally include identical query strings and fragments if all URLs share them.
 * Invalid URLs can be ignored, and query parameters can be stripped or reordered for comparison.
 *
 * @param urlStrings - An array of URL strings to compare.
 * @param options - Configuration options for normalization and comparison.
 * @param options.includeIdenticalQuery - If true, includes the query string in the result only if all URLs share the same query string. Defaults to false.
 * @param options.includeIdenticalFragment - If true, includes the fragment in the result only if all URLs share the same fragment. Defaults to false.
 * @param options.ignoreInvalid - If true, ignores invalid URLs in the input array. Defaults to false.
 * @param options.stripQueryParams - An array of query parameter names to remove before comparison. Defaults to an empty array.
 * @param options.normalizeQueryOrder - If true, normalizes the order of query parameters for comparison. Defaults to true.
 * @returns The longest common URL prefix as a string, or an empty string if no common prefix exists.
 */ function $9716b9eab1a8844b$var$findCommonUrlPrefix(urlStrings, options = {}) {
    const { includeIdenticalQuery: includeIdenticalQuery = false, includeIdenticalFragment: includeIdenticalFragment = false, ignoreInvalid: ignoreInvalid = false, stripQueryParams: stripQueryParams = [], normalizeQueryOrder: normalizeQueryOrder = true } = options;
    if (!urlStrings.length) return '';
    const urlPartsList = [];
    for (const urlString of urlStrings){
        const urlParts = $9716b9eab1a8844b$var$normalizeUrl(urlString, {
            stripQueryParams: stripQueryParams,
            normalizeQueryOrder: normalizeQueryOrder,
            ignoreInvalid: ignoreInvalid
        });
        if (urlParts) urlPartsList.push(urlParts);
    }
    if (!urlPartsList.length) return '';
    const firstOrigin = urlPartsList[0].origin;
    if (!urlPartsList.every((urlPart)=>urlPart.origin === firstOrigin)) return '';
    const firstSegments = urlPartsList[0].segments;
    let index = 0;
    outer: for(; index < firstSegments.length; index++)for(let k = 1; k < urlPartsList.length; k++){
        if (urlPartsList[k].segments[index] !== firstSegments[index]) break outer;
    }
    const commonSegments = firstSegments.slice(0, index);
    let pathPart = commonSegments.length ? '/' + commonSegments.join('/') : '';
    // Optionally keep trailing slash (rarely necessary)
    if (pathPart && urlPartsList.every((n)=>n.segments.length === commonSegments.length && n.pathname.endsWith('/'))) pathPart += '/';
    const query = includeIdenticalQuery && urlPartsList.every((urlPart)=>urlPart.search === urlPartsList[0].search) ? urlPartsList[0].search : '';
    const hash = includeIdenticalFragment && urlPartsList.every((urlPart)=>urlPart.hash === urlPartsList[0].hash) ? urlPartsList[0].hash : '';
    return `${firstOrigin}${pathPart}${query}${hash}`;
}
function $9716b9eab1a8844b$export$976b8c0d63447a45(urls, options = {}) {
    const { truncateSingletonFullUrl: truncateSingletonFullUrl = false, includeIdenticalQuery: includeIdenticalQuery = false, includeIdenticalFragment: includeIdenticalFragment = false, ignoreInvalid: ignoreInvalid = false, stripQueryParams: stripQueryParams = [], normalizeQueryOrder: normalizeQueryOrder = true } = options;
    if (!urls.length) return [];
    // Normalize all URLs
    const urlPartsList = [];
    for (const urlString of urls){
        const urlParts = $9716b9eab1a8844b$var$normalizeUrl(urlString, {
            stripQueryParams: stripQueryParams,
            normalizeQueryOrder: normalizeQueryOrder,
            ignoreInvalid: ignoreInvalid
        });
        if (urlParts) urlPartsList.push(urlParts);
    }
    if (!urlPartsList.length) return [];
    const bucketsMap = new Map();
    for (const urlParts of urlPartsList){
        const key = `${urlParts.origin}${urlParts.pathname}`;
        const existing = bucketsMap.get(key);
        if (existing) existing.members.push(urlParts);
        else bucketsMap.set(key, {
            key: key,
            members: [
                urlParts
            ]
        });
    }
    const buckets = Array.from(bucketsMap.values());
    // Finalize groups
    const groups = buckets.map((bucket)=>{
        const members = bucket.members.map((m)=>m.original);
        const count = members.length;
        let base;
        if (count === 1) {
            if (truncateSingletonFullUrl) base = `${bucket.members[0].origin}${bucket.members[0].pathname}`;
            else {
                const urlParts = bucket.members[0];
                base = `${urlParts.origin}${urlParts.pathname}${urlParts.search}${urlParts.hash}`;
            }
        } else {
            base = $9716b9eab1a8844b$var$findCommonUrlPrefix(members, {
                includeIdenticalQuery: includeIdenticalQuery,
                includeIdenticalFragment: includeIdenticalFragment,
                ignoreInvalid: true,
                stripQueryParams: stripQueryParams,
                normalizeQueryOrder: normalizeQueryOrder
            });
            if (!base) base = bucket.members[0].origin;
        }
        return {
            base: base,
            count: count,
            members: members
        };
    });
    // Consolidate identical bases (edge case: strategy could produce different buckets yielding same prefix)
    const consolidated = new Map();
    for (const group of groups){
        const existing = consolidated.get(group.base);
        if (existing) {
            existing.count += group.count;
            existing.members.push(...group.members);
        } else consolidated.set(group.base, {
            ...group
        });
    }
    const finalGroups = Array.from(consolidated.values());
    finalGroups.sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.base.localeCompare(b.base);
    });
    return finalGroups;
}
module.exports["groupUrlsByFrequency"] = $9716b9eab1a8844b$export$976b8c0d63447a45;

});

parcelRegister("anCkD", function(module, exports) {
/**
 * @generated SignedSource<<5e4299d3dfa145359dfabeb73f519ad8>>
 * @relayHash 6099253c0ce17c19c7275b43148225b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d8c75894f9dd73a732c42ce9bf3a490cced69fbcd657ca3937bc1780e2aae5b
const $ce7203ca91647ea9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        },
        {
            "kind": "Literal",
            "name": "ignoreMissingFields",
            "value": true
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "text"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = [
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v10 /*: any*/ ,
        v4 /*: any*/ 
    ], v13 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v12 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "selectedUsersConnection(first:10)"
        }
    ], v14 = [
        v10 /*: any*/ ,
        v4 /*: any*/ 
    ], v15 = [
        {
            "kind": "ScalarField",
            "name": "timeInSeconds"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainUpdateWorkItemActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fieldIdsOrAliases",
                                                            "variableName": "fieldIdsOrAliases"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "actionCard_updateWorkItemFieldsActionRenderer"
                                                },
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainUpdateWorkItemActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraIssueField"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraRichText",
                                                                    "kind": "LinkedField",
                                                                    "name": "richText",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraADF",
                                                                            "kind": "LinkedField",
                                                                            "name": "adfValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "convertedPlainText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "plainText"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isTruncated"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraRichTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v13 /*: any*/ ,
                                                            "type": "JiraPeopleField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v13 /*: any*/ ,
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v14 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraTransitionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "transitions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTransitionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraTransition",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "transitionId"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "to",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        },
                                                                                        v4 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": v14 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedLabelsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabelEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraLabel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraLabelsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueId"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "summary"
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraParentIssueField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "number"
                                                                }
                                                            ],
                                                            "type": "JiraNumberField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeTrackingSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isJiraConfiguredTimeTrackingEnabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "workingHoursPerDay"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "workingDaysPerWeek"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "defaultFormat"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "defaultUnit"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "originalEstimate",
                                                                    "plural": false,
                                                                    "selections": v15 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "remainingEstimate",
                                                                    "plural": false,
                                                                    "selections": v15 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeSpent",
                                                                    "plural": false,
                                                                    "selections": v15 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraTimeTrackingField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "colorKey"
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraColorField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2d8c75894f9dd73a732c42ce9bf3a490cced69fbcd657ca3937bc1780e2aae5b",
            "metadata": {},
            "name": "mainUpdateWorkItemActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ce7203ca91647ea9$var$node.hash = "245c4d68894afd4912467b8044e2bce8";
var $ce7203ca91647ea9$export$2e2bcd8739ae039 = $ce7203ca91647ea9$var$node;
module.exports["default"] = $ce7203ca91647ea9$export$2e2bcd8739ae039;

});

parcelRegister("7s5qz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $981Ry = parcelRequire("981Ry");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $2wgzS = parcelRequire("2wgzS");


var $3aGiD = parcelRequire("3aGiD");

const $c8c3c9ced3820416$var$styles = {
    fieldsList: "_0Of8r21Y8M _2Zuz6Q2ADO _1Znuxb2ADO _1wydGW1Y8M"
}; /**
    * Renders an action card for updating Jira issue fields within the conversation assistant.
    *
    * @remarks
    * This component displays a card containing a header and a list of field update actions.
    * It uses Relay fragments to fetch the necessary Jira issue data and passes it to child components.
    *
    * @param queryRef - The Relay fragment reference for the Jira issue data.
    * @param actions - An array of action objects representing field updates to be rendered.
    * @param props - Additional props to be passed to the CardFieldsList component.
    * @param shouldOpen - Whether the card is expanded on render or not.
    *
    * @returns
    * Returns a Stack containing the card header and a list of field update actions.
    * If no data is available or there are no actions, returns null.
    */ 
const $c8c3c9ced3820416$export$e1abe0f3fc33f39e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    let actions;
    let cloudId;
    let props;
    let queryRef;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ queryRef: queryRef, actions: actions, cloudId: cloudId, shouldExpand: t1, showButtons: t2, ...props } = t0);
        $[0] = t0;
        $[1] = actions;
        $[2] = cloudId;
        $[3] = props;
        $[4] = queryRef;
        $[5] = t1;
        $[6] = t2;
    } else {
        actions = $[1];
        cloudId = $[2];
        props = $[3];
        queryRef = $[4];
        t1 = $[5];
        t2 = $[6];
    }
    const shouldExpand = t1 === undefined ? false : t1;
    const showButtons = t2 === undefined ? true : t2;
    (0, $6cFsl.di)((0, $3aGiD.CardHeader), (0, $2wgzS.CardFieldsList));
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(shouldExpand);
    const data = (0, $6SsN4.useFragment)((0, $981Ry.default), queryRef);
    if (!data || actions.length === 0) return null;
    let t3;
    if ($[7] !== isExpanded) {
        t3 = ()=>setIsExpanded(!isExpanded);
        $[7] = isExpanded;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== data || $[10] !== isExpanded || $[11] !== showButtons || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aGiD.CardHeader), {
            queryRef: data,
            isExpanded: isExpanded,
            showButtons: showButtons,
            onClick: t3
        });
        $[9] = data;
        $[10] = isExpanded;
        $[11] = showButtons;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== actions || $[15] !== cloudId || $[16] !== data || $[17] !== isExpanded || $[18] !== props || $[19] !== showButtons) {
        t5 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c8c3c9ced3820416$var$styles.fieldsList
        }, actions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wgzS.CardFieldsList), {
                key: action.data.fieldKey,
                queryRef: data,
                action: action,
                cloudId: cloudId,
                showActionButtons: showButtons,
                ...props
            })));
        $[14] = actions;
        $[15] = cloudId;
        $[16] = data;
        $[17] = isExpanded;
        $[18] = props;
        $[19] = showButtons;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== t4 || $[22] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: "update-work-item-fields-action-renderer.ui.action-card"
        }, t4, t5);
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ queryRef: queryRef, actions: actions, cloudId: cloudId, shouldExpand: shouldExpand = false, showButtons: showButtons = true, ...props })=>{
    (0, $6cFsl.di)((0, $3aGiD.CardHeader), (0, $2wgzS.CardFieldsList));
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(shouldExpand);
    const data = (0, $6SsN4.useFragment)((0, $981Ry.default), queryRef);
    if (!data || actions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "update-work-item-fields-action-renderer.ui.action-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aGiD.CardHeader), {
        queryRef: data,
        isExpanded: isExpanded,
        showButtons: showButtons,
        onClick: ()=>setIsExpanded(!isExpanded)
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c8c3c9ced3820416$var$styles.fieldsList
    }, actions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wgzS.CardFieldsList), {
            key: action.data.fieldKey,
            queryRef: data,
            action: action,
            cloudId: cloudId,
            showActionButtons: showButtons,
            ...props
        }))));
};
module.exports["ActionCard"] = $c8c3c9ced3820416$export$e1abe0f3fc33f39e;

});

parcelRegister("iFSBV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");


var $gYXXv = parcelRequire("gYXXv");

const $4cc19a7a7ed75c08$var$styles = {
    container: "_2sNsIg20Hp _1wydGW2ADO",
    cardContainer: "_3iDTPbccYA _1g5erGQ4SZ"
};
const $4cc19a7a7ed75c08$export$fcf06206b9ed3e10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { sourceUrl: sourceUrl } = t0;
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!sourceUrl) return null;
    let t1;
    if ($[0] !== sourceUrl) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4cc19a7a7ed75c08$var$styles.cardContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                url: sourceUrl,
                appearance: "inline",
                truncateInline: true
            }));
        $[0] = sourceUrl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage || $[3] !== t1) {
        t2 = formatMessage((0, $gYXXv.messages).contextMessage, {
            card: t1
        });
        $[2] = formatMessage;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4cc19a7a7ed75c08$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t2));
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ sourceUrl: sourceUrl })=>{
    (0, $6cFsl.di)((0, $l8wPz.Card));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!sourceUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4cc19a7a7ed75c08$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $gYXXv.messages).contextMessage, {
        card: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4cc19a7a7ed75c08$var$styles.cardContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                url: sourceUrl,
                appearance: "inline",
                truncateInline: true
            }))
    })));
};
module.exports["CardGroupContext"] = $4cc19a7a7ed75c08$export$fcf06206b9ed3e10;

});

parcelRegister("jEnev", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $4ez2K = parcelRequire("4ez2K");


var $lfoFx = parcelRequire("lfoFx");


var $gYXXv = parcelRequire("gYXXv");

const $935327be2979e938$var$styles = {
    wrapper: "_2mHwu81Y8M _0Of8r28HPE _1wydGW5zaO _2Zuz6Q8HPE _1Znuxb8HPE _37wbyuz9WS _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $935327be2979e938$export$cfa9c99e7901ed73 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onDismiss: onDismiss, onApplyUpdates: onApplyUpdates, isDisabled: t1, allActionsApplied: t2, isBulkActioning: t3 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const allActionsApplied = t2 === undefined ? false : t2;
    const isBulkActioning = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (allActionsApplied) return null;
    let t4;
    if ($[0] !== formatMessage || $[1] !== isBulkActioning || $[2] !== isDisabled || $[3] !== onApplyUpdates || $[4] !== onDismiss) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $935327be2979e938$var$styles.wrapper,
            testId: "update-work-item-fields-action-renderer.ui.card-group-footer"
        }, isBulkActioning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            interactionName: "load"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onDismiss,
            isDisabled: isDisabled
        }, formatMessage((0, $gYXXv.messages).dismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onApplyUpdates,
            isDisabled: isDisabled
        }, formatMessage((0, $gYXXv.messages).acceptAllButton))));
        $[0] = formatMessage;
        $[1] = isBulkActioning;
        $[2] = isDisabled;
        $[3] = onApplyUpdates;
        $[4] = onDismiss;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ onDismiss: onDismiss, onApplyUpdates: onApplyUpdates, isDisabled: isDisabled = false, allActionsApplied: allActionsApplied = false, isBulkActioning: isBulkActioning = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (allActionsApplied) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $935327be2979e938$var$styles.wrapper,
        testId: "update-work-item-fields-action-renderer.ui.card-group-footer"
    }, isBulkActioning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "load"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismiss,
        isDisabled: isDisabled
    }, formatMessage((0, $gYXXv.messages).dismissButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onApplyUpdates,
        isDisabled: isDisabled
    }, formatMessage((0, $gYXXv.messages).acceptAllButton))));
};
module.exports["CardGroupFooter"] = $935327be2979e938$export$cfa9c99e7901ed73;

});

parcelRegister("gYXXv", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f586b1e1fe97c291$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dismissButton: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.dismiss-button.non-final",
        defaultMessage: "Dismiss"
    },
    acceptAllButton: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.accept-all-button.non-final",
        defaultMessage: "Accept all"
    },
    allActionsDismissed: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.all-actions-dismissed.non-final",
        defaultMessage: "You've dismissed all suggested updates"
    },
    allActionsAccepted: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.all-actions-accepted.non-final",
        defaultMessage: "You've accepted all suggested updates"
    },
    updateWorkItems: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.update-work-items.non-final",
        defaultMessage: "Update work items"
    },
    contextMessage: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.context-message.non-final",
        defaultMessage: "Based on your recent activities and ongoing projects, here are some recommended updates based on <card></card>"
    }
});
module.exports["messages"] = $f586b1e1fe97c291$export$defe85febe8b728c;

});

parcelRegister("9hll1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eh6Ml = parcelRequire("eh6Ml");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $af1408d1bd9feae7$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $af1408d1bd9feae7$export$3f91b0466c5e5f77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { message: message } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-text-success, #4C6B1F)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== message) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $af1408d1bd9feae7$var$styles.explainerContainer,
            alignItems: "center",
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $af1408d1bd9feae7$var$styles.explainer,
            alignBlock: "center",
            alignInline: "center"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, message)));
        $[1] = message;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ message: message })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $af1408d1bd9feae7$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $af1408d1bd9feae7$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-text-success, #4C6B1F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, message)));
};
module.exports["SystemMessage"] = $af1408d1bd9feae7$export$3f91b0466c5e5f77;

});

parcelRegister("h0dXJ", function(module, exports) {
/**
 * Safely parses a string into a `URL` object.
 *
 * Attempts to construct a `URL` from the provided `urlString`. If the string is not a valid URL,
 * the function returns `null` instead of throwing an error.
 *
 * @param urlString - The string to parse as a URL.
 * @returns The parsed `URL` object if successful, or `null` if parsing fails.
 */ function $af8b2795445b9393$var$safeParse(urlString) {
    try {
        return new URL(urlString);
    } catch  {
        return null;
    }
}
/**
 * Normalizes the query string of a given URL by optionally stripping specified parameters
 * and sorting the remaining parameters by key and value.
 *
 * @param url - The URL object whose query string will be normalized.
 * @param strip - A set of parameter names (case-insensitive) to remove from the query string.
 * @param normalizeOrder - If true, sorts the query parameters by key and value.
 * @returns The normalized query string, including the leading '?', or an empty string if there are no parameters.
 */ function $af8b2795445b9393$var$normalizeQuery(url, strip, normalizeOrder) {
    if (!url?.search) return '';
    const params = new URLSearchParams(url.search);
    if (strip.size) {
        for (const key of Array.from(params.keys()))if (strip.has(key.toLowerCase())) params.delete(key);
    }
    if (normalizeOrder) {
        const pairs = [];
        params.forEach((value, key)=>pairs.push([
                key,
                value
            ]));
        pairs.sort((a, b)=>a[0] === b[0] ? a[1].localeCompare(b[1]) : a[0].localeCompare(b[0]));
        const sorted = new URLSearchParams();
        for (const [key, value] of pairs)sorted.append(key, value);
        const queryString = sorted.toString();
        return queryString ? `?${queryString}` : '';
    }
    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
}
/**
 * Normalizes a given URL string by parsing its components, optionally stripping specified query parameters,
 * normalizing the order of query parameters, and handling invalid URLs.
 *
 * @param urlString - The URL string to normalize.
 * @param options - Optional configuration for normalization.
 * @param options.stripQueryParams - An array of query parameter names to remove from the URL.
 * @param options.normalizeQueryOrder - Whether to sort query parameters alphabetically. Defaults to true.
 * @param options.ignoreInvalid - If true, returns `null` instead of throwing an error for invalid URLs.
 * @returns A `NormalizedUrlParts` object containing the normalized URL components, or `null` if the URL is invalid and `ignoreInvalid` is set.
 * @throws {Error} If the URL is invalid and `ignoreInvalid` is not set.
 */ function $af8b2795445b9393$var$normalizeUrl(urlString, { stripQueryParams: stripQueryParams = [], normalizeQueryOrder: normalizeQueryOrder = true, ignoreInvalid: ignoreInvalid = false } = {}) {
    const url = $af8b2795445b9393$var$safeParse(urlString);
    if (!url) {
        if (ignoreInvalid) return null;
        throw new Error(`Invalid URL: ${urlString}`);
    }
    let pathname = url.pathname;
    if (pathname !== '/' && pathname.endsWith('/')) pathname = pathname.slice(0, -1);
    const search = $af8b2795445b9393$var$normalizeQuery(url, new Set(stripQueryParams.map((s)=>s.toLowerCase())), normalizeQueryOrder);
    const hash = url.hash;
    const segments = pathname.split('/').filter(Boolean);
    return {
        origin: url.origin,
        pathname: pathname,
        search: search,
        hash: hash,
        segments: segments,
        original: urlString
    };
}
/**
 * Finds the longest common URL prefix among a list of URLs.
 *
 * This function normalizes the input URLs and determines the shared origin and path prefix.
 * It can optionally include identical query strings and fragments if all URLs share them.
 * Invalid URLs can be ignored, and query parameters can be stripped or reordered for comparison.
 *
 * @param urlStrings - An array of URL strings to compare.
 * @param options - Configuration options for normalization and comparison.
 * @param options.includeIdenticalQuery - If true, includes the query string in the result only if all URLs share the same query string. Defaults to false.
 * @param options.includeIdenticalFragment - If true, includes the fragment in the result only if all URLs share the same fragment. Defaults to false.
 * @param options.ignoreInvalid - If true, ignores invalid URLs in the input array. Defaults to false.
 * @param options.stripQueryParams - An array of query parameter names to remove before comparison. Defaults to an empty array.
 * @param options.normalizeQueryOrder - If true, normalizes the order of query parameters for comparison. Defaults to true.
 * @returns The longest common URL prefix as a string, or an empty string if no common prefix exists.
 */ function $af8b2795445b9393$var$findCommonUrlPrefix(urlStrings, options = {}) {
    const { includeIdenticalQuery: includeIdenticalQuery = false, includeIdenticalFragment: includeIdenticalFragment = false, ignoreInvalid: ignoreInvalid = false, stripQueryParams: stripQueryParams = [], normalizeQueryOrder: normalizeQueryOrder = true } = options;
    if (!urlStrings.length) return '';
    const urlPartsList = [];
    for (const urlString of urlStrings){
        const urlParts = $af8b2795445b9393$var$normalizeUrl(urlString, {
            stripQueryParams: stripQueryParams,
            normalizeQueryOrder: normalizeQueryOrder,
            ignoreInvalid: ignoreInvalid
        });
        if (urlParts) urlPartsList.push(urlParts);
    }
    if (!urlPartsList.length) return '';
    const firstOrigin = urlPartsList[0].origin;
    if (!urlPartsList.every((urlPart)=>urlPart.origin === firstOrigin)) return '';
    const firstSegments = urlPartsList[0].segments;
    let index = 0;
    outer: for(; index < firstSegments.length; index++)for(let k = 1; k < urlPartsList.length; k++){
        if (urlPartsList[k].segments[index] !== firstSegments[index]) break outer;
    }
    const commonSegments = firstSegments.slice(0, index);
    let pathPart = commonSegments.length ? '/' + commonSegments.join('/') : '';
    // Optionally keep trailing slash (rarely necessary)
    if (pathPart && urlPartsList.every((n)=>n.segments.length === commonSegments.length && n.pathname.endsWith('/'))) pathPart += '/';
    const query = includeIdenticalQuery && urlPartsList.every((urlPart)=>urlPart.search === urlPartsList[0].search) ? urlPartsList[0].search : '';
    const hash = includeIdenticalFragment && urlPartsList.every((urlPart)=>urlPart.hash === urlPartsList[0].hash) ? urlPartsList[0].hash : '';
    return `${firstOrigin}${pathPart}${query}${hash}`;
}
function $af8b2795445b9393$export$976b8c0d63447a45(urls, options = {}) {
    const { truncateSingletonFullUrl: truncateSingletonFullUrl = false, includeIdenticalQuery: includeIdenticalQuery = false, includeIdenticalFragment: includeIdenticalFragment = false, ignoreInvalid: ignoreInvalid = false, stripQueryParams: stripQueryParams = [], normalizeQueryOrder: normalizeQueryOrder = true } = options;
    if (!urls.length) return [];
    // Normalize all URLs
    const urlPartsList = [];
    for (const urlString of urls){
        const urlParts = $af8b2795445b9393$var$normalizeUrl(urlString, {
            stripQueryParams: stripQueryParams,
            normalizeQueryOrder: normalizeQueryOrder,
            ignoreInvalid: ignoreInvalid
        });
        if (urlParts) urlPartsList.push(urlParts);
    }
    if (!urlPartsList.length) return [];
    const bucketsMap = new Map();
    for (const urlParts of urlPartsList){
        const key = `${urlParts.origin}${urlParts.pathname}`;
        const existing = bucketsMap.get(key);
        if (existing) existing.members.push(urlParts);
        else bucketsMap.set(key, {
            key: key,
            members: [
                urlParts
            ]
        });
    }
    const buckets = Array.from(bucketsMap.values());
    // Finalize groups
    const groups = buckets.map((bucket)=>{
        const members = bucket.members.map((m)=>m.original);
        const count = members.length;
        let base;
        if (count === 1) {
            if (truncateSingletonFullUrl) base = `${bucket.members[0].origin}${bucket.members[0].pathname}`;
            else {
                const urlParts = bucket.members[0];
                base = `${urlParts.origin}${urlParts.pathname}${urlParts.search}${urlParts.hash}`;
            }
        } else {
            base = $af8b2795445b9393$var$findCommonUrlPrefix(members, {
                includeIdenticalQuery: includeIdenticalQuery,
                includeIdenticalFragment: includeIdenticalFragment,
                ignoreInvalid: true,
                stripQueryParams: stripQueryParams,
                normalizeQueryOrder: normalizeQueryOrder
            });
            if (!base) base = bucket.members[0].origin;
        }
        return {
            base: base,
            count: count,
            members: members
        };
    });
    // Consolidate identical bases (edge case: strategy could produce different buckets yielding same prefix)
    const consolidated = new Map();
    for (const group of groups){
        const existing = consolidated.get(group.base);
        if (existing) {
            existing.count += group.count;
            existing.members.push(...group.members);
        } else consolidated.set(group.base, {
            ...group
        });
    }
    const finalGroups = Array.from(consolidated.values());
    finalGroups.sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.base.localeCompare(b.base);
    });
    return finalGroups;
}
module.exports["groupUrlsByFrequency"] = $af8b2795445b9393$export$976b8c0d63447a45;

});

parcelRegister("8Me03", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hLyoT = parcelRequire("hLyoT");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $aLUFu = parcelRequire("aLUFu");


var $kGin2 = parcelRequire("kGin2");


var $6YxHK = parcelRequire("6YxHK");


var $aY1NH = parcelRequire("aY1NH");


var $4EdWe = parcelRequire("4EdWe");

const $22577d5bea83a4c6$var$styles = {
    container: "_23rrnH2HTN _0bjKvDKxmn _3iDTPbQ4SZ _0aFT5vbt8w _1UtDYzy7kJ _0KLXruqi9L _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _2OUyjtzwhj",
    content: "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _1DCdHi5zaO",
    footer: "_2mHwu85zaO _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
    footerDisclaimer: "_1EqgXlHakr",
    footerButtons: "_2mHwu82ADO _3iDTPbQ4SZ _3YEZNOdnbC"
};
const $22577d5bea83a4c6$var$ActionCardWithProjectData = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let projectAri;
    let props;
    if ($[0] !== t0) {
        ({ projectAri: projectAri, ...props } = t0);
        $[0] = t0;
        $[1] = projectAri;
        $[2] = props;
    } else {
        projectAri = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== projectAri) {
        t1 = {
            projectAri: projectAri
        };
        $[3] = projectAri;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[5] = t2;
    } else t2 = $[5];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $hLyoT.default), t1, t2);
    let t3;
    if ($[6] !== data || $[7] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardContent, {
            ...props,
            fragmentKey: data
        });
        $[6] = data;
        $[7] = props;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ projectAri: projectAri, ...props })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $hLyoT.default), {
        projectAri: projectAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardContent, {
        ...props,
        fragmentKey: data
    });
};
const $22577d5bea83a4c6$var$ActionCardContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { action: action, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, getReadonly: getReadonly, fragmentKey: fragmentKey } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action || $[1] !== getStatus) {
        t1 = getStatus(action);
        $[0] = action;
        $[1] = getStatus;
        $[2] = t1;
    } else t1 = $[2];
    const status = t1;
    let t2;
    if ($[3] !== action || $[4] !== getReadonly) {
        t2 = getReadonly(action);
        $[3] = action;
        $[4] = getReadonly;
        $[5] = t2;
    } else t2 = $[5];
    const readonly = t2;
    const isSubmitting = status === "started";
    const isDisabled = status !== "idle" || readonly;
    const currentUserId = fragmentKey?.me?.user?.id ?? undefined;
    const projectDetails = fragmentKey?.townsquare?.project ?? undefined;
    const hasProjectAri = fragmentKey != null;
    let t3;
    if ($[6] !== hasProjectAri) {
        t3 = hasProjectAri || !(0, $iDrrr.fg)("update_action_card_write_status_skill");
        $[6] = hasProjectAri;
        $[7] = t3;
    } else t3 = $[7];
    const showHeaderAndFooter = t3;
    let t4;
    if ($[8] !== action || $[9] !== projectDetails || $[10] !== showHeaderAndFooter) {
        t4 = showHeaderAndFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4EdWe.CardHeader), {
            action: action,
            fragmentKey: projectDetails
        });
        $[8] = action;
        $[9] = projectDetails;
        $[10] = showHeaderAndFooter;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== action) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kGin2.CardBody), {
            action: action
        });
        $[12] = action;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $22577d5bea83a4c6$var$styles.content
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== intl) {
        t7 = intl.formatMessage((0, $6YxHK.messages).disclaimer);
        $[17] = intl;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $22577d5bea83a4c6$var$styles.footerDisclaimer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, t7));
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== action || $[22] !== currentUserId || $[23] !== isDisabled || $[24] !== isSubmitting || $[25] !== onCancel || $[26] !== onConfirm || $[27] !== projectDetails || $[28] !== showHeaderAndFooter) {
        t9 = showHeaderAndFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $22577d5bea83a4c6$var$styles.footerButtons
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aY1NH.CardFooterWithTooltip), {
            action: action,
            onCancel: onCancel,
            onConfirm: onConfirm,
            isDisabled: isDisabled,
            isSubmitting: isSubmitting,
            currentUserId: currentUserId,
            fragmentKey: projectDetails
        }));
        $[21] = action;
        $[22] = currentUserId;
        $[23] = isDisabled;
        $[24] = isSubmitting;
        $[25] = onCancel;
        $[26] = onConfirm;
        $[27] = projectDetails;
        $[28] = showHeaderAndFooter;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== t8 || $[31] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $22577d5bea83a4c6$var$styles.footer
        }, t8, t9);
        $[30] = t8;
        $[31] = t9;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== t10 || $[34] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $22577d5bea83a4c6$var$styles.container,
            testId: "project-status-update-action-renderer.ui.action-card"
        }, t6, t10);
        $[33] = t10;
        $[34] = t6;
        $[35] = t11;
    } else t11 = $[35];
    return t11;
} : ({ action: action, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, getReadonly: getReadonly, fragmentKey: fragmentKey })=>{
    const intl = (0, $kSwu1.useIntl)();
    const status = getStatus(action);
    const readonly = getReadonly(action);
    const isSubmitting = status === 'started';
    const isDisabled = status !== 'idle' || readonly;
    const currentUserId = fragmentKey?.me?.user?.id ?? undefined;
    const projectDetails = fragmentKey?.townsquare?.project ?? undefined;
    const hasProjectAri = fragmentKey != null;
    const showHeaderAndFooter = hasProjectAri || !(0, $iDrrr.fg)('update_action_card_write_status_skill');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $22577d5bea83a4c6$var$styles.container,
        testId: "project-status-update-action-renderer.ui.action-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $22577d5bea83a4c6$var$styles.content
    }, showHeaderAndFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4EdWe.CardHeader), {
        action: action,
        fragmentKey: projectDetails
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kGin2.CardBody), {
        action: action
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $22577d5bea83a4c6$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $22577d5bea83a4c6$var$styles.footerDisclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, intl.formatMessage((0, $6YxHK.messages).disclaimer))), showHeaderAndFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $22577d5bea83a4c6$var$styles.footerButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aY1NH.CardFooterWithTooltip), {
        action: action,
        onCancel: onCancel,
        onConfirm: onConfirm,
        isDisabled: isDisabled,
        isSubmitting: isSubmitting,
        currentUserId: currentUserId,
        fragmentKey: projectDetails
    }))));
}; // add a function to parse the TownsquareProjectAri
const $22577d5bea83a4c6$var$parseTownsquareProjectAri = (projectId, cloudId)=>{
    try {
        return (0, $aLUFu.TownsquareProjectAri).create({
            siteId: cloudId,
            projectUuid: projectId
        }).toString();
    } catch  {}
    try {
        return (0, $aLUFu.TownsquareProjectAri).parse(projectId).toString();
    } catch  {
        return '';
    }
};
const $22577d5bea83a4c6$export$e1abe0f3fc33f39e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(13);
    const { action: action, cloudId: cloudId } = props;
    const projectId = action.data.projectId;
    let t0;
    if ($[0] !== cloudId || $[1] !== projectId) {
        t0 = $22577d5bea83a4c6$var$parseTownsquareProjectAri(projectId, cloudId);
        $[0] = cloudId;
        $[1] = projectId;
        $[2] = t0;
    } else t0 = $[2];
    const projectAri = t0;
    if (!action) return null;
    if (!projectAri) {
        let t1;
        if ($[3] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardContent, props);
            $[3] = props;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    let t1;
    if ($[5] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardContent, props);
        $[5] = props;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== projectAri || $[8] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardWithProjectData, {
            ...props,
            projectAri: projectAri
        });
        $[7] = projectAri;
        $[8] = props;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t1
        }, t2);
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : (props)=>{
    const { action: action, cloudId: cloudId } = props;
    const projectAri = (0, $cozmU.useMemo)(()=>{
        const projectId = action.data.projectId;
        return $22577d5bea83a4c6$var$parseTownsquareProjectAri(projectId, cloudId);
    }, [
        action.data.projectId,
        cloudId
    ]);
    if (!action) return null;
    if (!projectAri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardContent, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardContent, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22577d5bea83a4c6$var$ActionCardWithProjectData, {
        ...props,
        projectAri: projectAri
    }));
};
module.exports["ActionCard"] = $22577d5bea83a4c6$export$e1abe0f3fc33f39e;

});

parcelRegister("epG7a", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $bV5ZQ = parcelRequire("bV5ZQ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $chu6R = parcelRequire("chu6R");


var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $76ttD = parcelRequire("76ttD");


var $eIAKh = parcelRequire("eIAKh");


var $6KdAr = parcelRequire("6KdAr");


var $jzYu7 = parcelRequire("jzYu7");


var $7dQPx = parcelRequire("7dQPx");


var $6EWj2 = parcelRequire("6EWj2");


var $jbl5e = parcelRequire("jbl5e");


var $6ekqE = parcelRequire("6ekqE");


var $lM1KN = parcelRequire("lM1KN");


var $hmuK5 = parcelRequire("hmuK5");

const $654de7f3e49191cc$var$ArchiveTeamsCardContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { actions: actions, cloudId: cloudId, conversationId: conversationId, onConfirm: onConfirm, getReadonly: getReadonly, getStatus: getStatus, onCancel: onCancel } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [actionsToArchive, setActionsToArchive] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[1] = t2;
    } else t2 = $[1];
    const [actionsCurrentlyLoading, setActionsCurrentlyLoading] = (0, $cozmU.useState)(t2);
    const [selectedTeam, setSelectedTeam] = (0, $cozmU.useState)(null);
    let t3;
    if ($[2] !== actions || $[3] !== getStatus) {
        let t4;
        if ($[5] !== getStatus) {
            t4 = (action)=>!(0, $6KdAr.isActionResolved)(action, getStatus);
            $[5] = getStatus;
            $[6] = t4;
        } else t4 = $[6];
        t3 = actions.filter(t4);
        $[2] = actions;
        $[3] = getStatus;
        $[4] = t3;
    } else t3 = $[4];
    const visibleTeams = t3;
    let t4;
    if ($[7] !== actions || $[8] !== getStatus) {
        let t5;
        if ($[10] !== getStatus) {
            t5 = (action_0)=>(0, $6KdAr.isActionErrored)(action_0, getStatus);
            $[10] = getStatus;
            $[11] = t5;
        } else t5 = $[11];
        t4 = actions.filter(t5);
        $[7] = actions;
        $[8] = getStatus;
        $[9] = t4;
    } else t4 = $[9];
    const erroredTeams = t4;
    let t5;
    if ($[12] !== actions || $[13] !== getStatus) {
        let t6;
        if ($[15] !== getStatus) {
            t6 = (action_1)=>(0, $6KdAr.isActionFinished)(action_1, getStatus);
            $[15] = getStatus;
            $[16] = t6;
        } else t6 = $[16];
        t5 = actions.filter(t6);
        $[12] = actions;
        $[13] = getStatus;
        $[14] = t5;
    } else t5 = $[14];
    const archivedTeams = t5;
    let t6;
    if ($[17] !== actions || $[18] !== getReadonly) {
        let t7;
        if ($[20] !== getReadonly) {
            t7 = (action_2)=>(0, $6KdAr.isActionReadonly)(action_2, getReadonly);
            $[20] = getReadonly;
            $[21] = t7;
        } else t7 = $[21];
        t6 = actions.every(t7);
        $[17] = actions;
        $[18] = getReadonly;
        $[19] = t6;
    } else t6 = $[19];
    const allActionsAreReadonly = t6;
    const allActionsResolvedSuccessfully = actions.every((action_3)=>(0, $6KdAr.isActionResolved)(action_3, getStatus));
    let t7;
    if ($[22] !== actions || $[23] !== conversationId || $[24] !== getReadonly) {
        t7 = {
            conversationId: conversationId,
            actions: actions,
            getReadonly: getReadonly
        };
        $[22] = actions;
        $[23] = conversationId;
        $[24] = getReadonly;
        $[25] = t7;
    } else t7 = $[25];
    const { maybeAppendFollowUp: maybeAppendFollowUp } = (0, $eIAKh.useAppendCleanUpTeamsFollowUp)(t7);
    let t8;
    bb0: {
        if (actionsCurrentlyLoading.length > 0) {
            let t9;
            if ($[26] !== actionsCurrentlyLoading.length || $[27] !== formatMessage) {
                t9 = formatMessage((0, $hmuK5.default).archiving, {
                    teamCount: actionsCurrentlyLoading.length
                });
                $[26] = actionsCurrentlyLoading.length;
                $[27] = formatMessage;
                $[28] = t9;
            } else t9 = $[28];
            t8 = t9;
            break bb0;
        }
        if (allActionsAreReadonly && erroredTeams.length > 0) {
            let t9;
            if ($[29] !== erroredTeams.length || $[30] !== formatMessage) {
                t9 = formatMessage((0, $hmuK5.default).couldNotArchive, {
                    teamCount: erroredTeams.length
                });
                $[29] = erroredTeams.length;
                $[30] = formatMessage;
                $[31] = t9;
            } else t9 = $[31];
            let t10;
            if ($[32] !== t9) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    color: "color.text.warning"
                }, t9);
                $[32] = t9;
                $[33] = t10;
            } else t10 = $[33];
            t8 = t10;
            break bb0;
        }
        t8 = undefined;
    }
    const subtitle = t8;
    let t9;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (teamIds)=>{
            setActionsCurrentlyLoading(teamIds);
        };
        $[34] = t9;
    } else t9 = $[34];
    const handleArchivingChange = t9;
    let t10;
    if ($[35] !== maybeAppendFollowUp || $[36] !== onCancel || $[37] !== sendAnalyticsEvent) {
        t10 = async (team)=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "removeTeamFromCleanUpTeams",
                attributes: {
                    teamId: team.data.teamId
                }
            });
            await onCancel(team);
            setSelectedTeam((current)=>current?.data.teamId === team.data.teamId ? null : current);
            maybeAppendFollowUp([
                team
            ]);
        };
        $[35] = maybeAppendFollowUp;
        $[36] = onCancel;
        $[37] = sendAnalyticsEvent;
        $[38] = t10;
    } else t10 = $[38];
    const handleRemoveTeam = t10;
    let t11;
    if ($[39] !== sendAnalyticsEvent) {
        t11 = (teams)=>{
            if (teams.length > 0) sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "setTeamsToArchiveCleanUpTeams",
                attributes: {
                    teamCount: teams.length
                }
            });
            setActionsToArchive(teams);
        };
        $[39] = sendAnalyticsEvent;
        $[40] = t11;
    } else t11 = $[40];
    const handleArchiveTeam = t11;
    let t12;
    if ($[41] !== sendAnalyticsEvent) {
        t12 = (team_0)=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "viewTeamCardCleanUpTeams",
                attributes: {
                    teamId: team_0.data.teamId
                }
            });
            setSelectedTeam(team_0);
        };
        $[41] = sendAnalyticsEvent;
        $[42] = t12;
    } else t12 = $[42];
    const handleViewTeamCard = t12;
    if (allActionsResolvedSuccessfully) {
        let t13;
        if ($[43] !== archivedTeams.length || $[44] !== formatMessage) {
            t13 = archivedTeams.length > 0 && formatMessage((0, $hmuK5.default).archivedSuccess, {
                teamCount: archivedTeams.length
            });
            $[43] = archivedTeams.length;
            $[44] = formatMessage;
            $[45] = t13;
        } else t13 = $[45];
        let t14;
        if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            });
            $[46] = t14;
        } else t14 = $[46];
        let t15;
        if ($[47] !== t13) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lM1KN.CardWrapper), {
                key: "archived-teams-success-card",
                testId: "archive-teams-success-card",
                subtitle: t13,
                headerActionOverride: t14
            });
            $[47] = t13;
            $[48] = t15;
        } else t15 = $[48];
        return t15;
    }
    let t13;
    if ($[49] !== actionsCurrentlyLoading || $[50] !== allActionsAreReadonly || $[51] !== cloudId || $[52] !== getReadonly || $[53] !== getStatus || $[54] !== handleArchiveTeam || $[55] !== handleRemoveTeam || $[56] !== handleViewTeamCard || $[57] !== selectedTeam || $[58] !== visibleTeams) {
        t13 = selectedTeam ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ekqE.ArchiveTeamsCardTeamView), {
            team: selectedTeam,
            onBack: ()=>setSelectedTeam(null),
            onRemove: handleRemoveTeam,
            onArchive: handleArchiveTeam,
            cloudId: cloudId,
            isReadonly: (0, $6KdAr.isActionReadonly)(selectedTeam, getReadonly)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6EWj2.ArchiveTeamsCardListView), {
            teams: visibleTeams,
            onSelectTeam: handleViewTeamCard,
            onRemoveTeam: handleRemoveTeam,
            getStatus: getStatus,
            onArchive: handleArchiveTeam,
            actionsCurrentlyLoading: actionsCurrentlyLoading,
            isReadOnly: allActionsAreReadonly
        });
        $[49] = actionsCurrentlyLoading;
        $[50] = allActionsAreReadonly;
        $[51] = cloudId;
        $[52] = getReadonly;
        $[53] = getStatus;
        $[54] = handleArchiveTeam;
        $[55] = handleRemoveTeam;
        $[56] = handleViewTeamCard;
        $[57] = selectedTeam;
        $[58] = visibleTeams;
        $[59] = t13;
    } else t13 = $[59];
    let t14;
    if ($[60] !== actionsToArchive || $[61] !== maybeAppendFollowUp) {
        t14 = ()=>{
            setSelectedTeam(null);
            maybeAppendFollowUp(actionsToArchive);
        };
        $[60] = actionsToArchive;
        $[61] = maybeAppendFollowUp;
        $[62] = t14;
    } else t14 = $[62];
    let t15;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>setActionsToArchive([]);
        $[63] = t15;
    } else t15 = $[63];
    let t16;
    if ($[64] !== actionsToArchive || $[65] !== onConfirm || $[66] !== t14) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76ttD.ArchiveTeamsConfirmationModal), {
            actions: actionsToArchive,
            onConfirm: onConfirm,
            onArchiveComplete: t14,
            onClose: t15,
            onArchivingChange: handleArchivingChange
        });
        $[64] = actionsToArchive;
        $[65] = onConfirm;
        $[66] = t14;
        $[67] = t16;
    } else t16 = $[67];
    let t17;
    if ($[68] !== subtitle || $[69] !== t13 || $[70] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lM1KN.CardWrapper), {
            isExpandable: true,
            subtitle: subtitle,
            testId: "archive-teams-card"
        }, t13, t16);
        $[68] = subtitle;
        $[69] = t13;
        $[70] = t16;
        $[71] = t17;
    } else t17 = $[71];
    return t17;
} : ({ actions: actions, cloudId: cloudId, conversationId: conversationId, onConfirm: onConfirm, getReadonly: getReadonly, getStatus: getStatus, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [actionsToArchive, setActionsToArchive] = (0, $cozmU.useState)([]);
    const [actionsCurrentlyLoading, setActionsCurrentlyLoading] = (0, $cozmU.useState)([]);
    const [selectedTeam, setSelectedTeam] = (0, $cozmU.useState)(null);
    const visibleTeams = (0, $cozmU.useMemo)(()=>actions.filter((action)=>!(0, $6KdAr.isActionResolved)(action, getStatus)), [
        actions,
        getStatus
    ]);
    const erroredTeams = (0, $cozmU.useMemo)(()=>actions.filter((action_0)=>(0, $6KdAr.isActionErrored)(action_0, getStatus)), [
        actions,
        getStatus
    ]);
    const archivedTeams = (0, $cozmU.useMemo)(()=>actions.filter((action_1)=>(0, $6KdAr.isActionFinished)(action_1, getStatus)), [
        actions,
        getStatus
    ]);
    const allActionsAreReadonly = actions.every((action_2)=>(0, $6KdAr.isActionReadonly)(action_2, getReadonly));
    const allActionsResolvedSuccessfully = actions.every((action_3)=>(0, $6KdAr.isActionResolved)(action_3, getStatus));
    const { maybeAppendFollowUp: maybeAppendFollowUp } = (0, $eIAKh.useAppendCleanUpTeamsFollowUp)({
        conversationId: conversationId,
        actions: actions,
        getReadonly: getReadonly
    });
    const subtitle = (0, $cozmU.useMemo)(()=>{
        if (actionsCurrentlyLoading.length > 0) return formatMessage((0, $hmuK5.default).archiving, {
            teamCount: actionsCurrentlyLoading.length
        });
        if (allActionsAreReadonly && erroredTeams.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: 'color.text.warning'
        }, formatMessage((0, $hmuK5.default).couldNotArchive, {
            teamCount: erroredTeams.length
        }));
        return undefined;
    }, [
        actionsCurrentlyLoading.length,
        erroredTeams.length,
        formatMessage,
        allActionsAreReadonly
    ]);
    const handleArchivingChange = (0, $cozmU.useCallback)((teamIds)=>{
        setActionsCurrentlyLoading(teamIds);
    }, [
        setActionsCurrentlyLoading
    ]);
    const handleRemoveTeam = (0, $cozmU.useCallback)(async (team)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'removeTeamFromCleanUpTeams',
            attributes: {
                teamId: team.data.teamId
            }
        });
        await onCancel(team);
        setSelectedTeam((current)=>current?.data.teamId === team.data.teamId ? null : current);
        maybeAppendFollowUp([
            team
        ]);
    }, [
        onCancel,
        sendAnalyticsEvent,
        maybeAppendFollowUp
    ]);
    const handleArchiveTeam = (0, $cozmU.useCallback)((teams)=>{
        if (teams.length > 0) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'setTeamsToArchiveCleanUpTeams',
            attributes: {
                teamCount: teams.length
            }
        });
        setActionsToArchive(teams);
    }, [
        sendAnalyticsEvent,
        setActionsToArchive
    ]);
    const handleViewTeamCard = (0, $cozmU.useCallback)((team_0)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'viewTeamCardCleanUpTeams',
            attributes: {
                teamId: team_0.data.teamId
            }
        });
        setSelectedTeam(team_0);
    }, [
        sendAnalyticsEvent,
        setSelectedTeam
    ]);
    if (allActionsResolvedSuccessfully) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lM1KN.CardWrapper), {
        key: "archived-teams-success-card",
        testId: "archive-teams-success-card",
        subtitle: archivedTeams.length > 0 && formatMessage((0, $hmuK5.default).archivedSuccess, {
            teamCount: archivedTeams.length
        }),
        headerActionOverride: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lM1KN.CardWrapper), {
        isExpandable: true,
        subtitle: subtitle,
        testId: "archive-teams-card"
    }, selectedTeam ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ekqE.ArchiveTeamsCardTeamView), {
        team: selectedTeam,
        onBack: ()=>setSelectedTeam(null),
        onRemove: handleRemoveTeam,
        onArchive: handleArchiveTeam,
        cloudId: cloudId,
        isReadonly: (0, $6KdAr.isActionReadonly)(selectedTeam, getReadonly)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6EWj2.ArchiveTeamsCardListView), {
        teams: visibleTeams,
        onSelectTeam: handleViewTeamCard,
        onRemoveTeam: handleRemoveTeam,
        getStatus: getStatus,
        onArchive: handleArchiveTeam,
        actionsCurrentlyLoading: actionsCurrentlyLoading,
        isReadOnly: allActionsAreReadonly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76ttD.ArchiveTeamsConfirmationModal), {
        actions: actionsToArchive,
        onConfirm: onConfirm,
        onArchiveComplete: ()=>{
            setSelectedTeam(null);
            maybeAppendFollowUp(actionsToArchive);
        },
        onClose: ()=>setActionsToArchive([]),
        onArchivingChange: handleArchivingChange
    }));
};
const $654de7f3e49191cc$var$ArchiveTeamsCardWithHydration = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ArchiveTeamsCardWithHydration(props) {
    const $ = (0, $bDgLe.c)(16);
    let t0;
    if ($[0] !== props.actions) {
        t0 = props.actions.map($654de7f3e49191cc$var$_temp).filter($654de7f3e49191cc$var$_temp2);
        $[0] = props.actions;
        $[1] = t0;
    } else t0 = $[1];
    const teamIds = t0;
    let t1;
    if ($[2] !== props.cloudId || $[3] !== teamIds) {
        t1 = {
            teamIds: teamIds,
            siteId: props.cloudId,
            membersCount: (0, $7dQPx.TEAM_MEMBERS_PREVIEW_QUERY_FIRST)
        };
        $[2] = props.cloudId;
        $[3] = teamIds;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[5] = t2;
    } else t2 = $[5];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $bV5ZQ.default), t1, t2);
    let t3;
    if ($[6] !== data.team?.teamsV2) {
        t3 = ()=>{
            const map = new Map();
            for (const team of data.team?.teamsV2 ?? []){
                if (!team?.id) continue;
                const { id: id_0, ...teamWithoutId } = team;
                map.set(id_0, teamWithoutId);
            }
            return map;
        };
        $[6] = data.team?.teamsV2;
        $[7] = t3;
    } else t3 = $[7];
    data.team?.teamsV2;
    let t4;
    if ($[8] !== t3) {
        t4 = t3();
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const teamsV2Map = t4;
    let t5;
    if ($[10] !== props.actions || $[11] !== teamsV2Map) {
        const hydrated = (0, $jzYu7.buildHydratedArchiveTeamActions)(props.actions, teamsV2Map);
        t5 = (0, $jzYu7.sortHydratedArchiveTeamActions)(hydrated);
        $[10] = props.actions;
        $[11] = teamsV2Map;
        $[12] = t5;
    } else t5 = $[12];
    const enrichedActions = t5;
    let t6;
    if ($[13] !== enrichedActions || $[14] !== props) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($654de7f3e49191cc$var$ArchiveTeamsCardContent, {
            ...props,
            actions: enrichedActions
        });
        $[13] = enrichedActions;
        $[14] = props;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ArchiveTeamsCardWithHydration(props) {
    const teamIds = (0, $cozmU.useMemo)(()=>props.actions.map((a)=>a.data.teamId).filter((id)=>id != null && id !== ''), [
        props.actions
    ]);
    const data = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- data merged via buildHydratedArchiveTeamActions and passed to TeamItem/TeamCard */ (0, $bV5ZQ.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        teamIds: teamIds,
        siteId: props.cloudId,
        membersCount: (0, $7dQPx.TEAM_MEMBERS_PREVIEW_QUERY_FIRST)
    }, {
        fetchPolicy: 'store-or-network'
    });
    const teamsV2Map = (0, $cozmU.useMemo)(()=>{
        const map = new Map();
        for (const team of data.team?.teamsV2 ?? []){
            if (!team?.id) continue;
            const { id: id_0, ...teamWithoutId } = team;
            map.set(id_0, teamWithoutId);
        }
        return map;
    }, [
        data.team?.teamsV2
    ]);
    const enrichedActions = (0, $cozmU.useMemo)(()=>{
        const hydrated = (0, $jzYu7.buildHydratedArchiveTeamActions)(props.actions, teamsV2Map);
        return (0, $jzYu7.sortHydratedArchiveTeamActions)(hydrated);
    }, [
        props.actions,
        teamsV2Map
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($654de7f3e49191cc$var$ArchiveTeamsCardContent, {
        ...props,
        actions: enrichedActions
    });
};
function $654de7f3e49191cc$var$_temp2(id) {
    return id != null && id !== "";
}
function $654de7f3e49191cc$var$_temp(a) {
    return a.data.teamId;
}
const $654de7f3e49191cc$export$20fd4b7e8f327300 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ArchiveTeamsCard(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jbl5e.ArchiveTeamsCardSkeleton), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($654de7f3e49191cc$var$ArchiveTeamsCardWithHydration, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ArchiveTeamsCard(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jbl5e.ArchiveTeamsCardSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($654de7f3e49191cc$var$ArchiveTeamsCardWithHydration, props));
};
module.exports["ArchiveTeamsCard"] = $654de7f3e49191cc$export$20fd4b7e8f327300;

});

parcelRegister("b0L5M", function(module, exports) {

var $39vBG = parcelRequire("39vBG");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");

function $c01a088c3cfd172a$var$normalizeBoardFromNode(node) {
    if (!node) return null;
    if (node.__typename === 'JiraProject') return {
        name: node.projectName,
        url: node.webUrl ?? null
    };
    if (node.__typename === 'JiraBoard') {
        const name = node.boardName ?? null;
        if (name) return {
            name: name,
            url: node.boardUrl ?? null
        };
    }
    return null;
}
function $c01a088c3cfd172a$export$9bb331a0b400c976({ scopeId: scopeId, children: children }) {
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $39vBG.default), {
        id: scopeId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const board = (0, $cozmU.useMemo)(()=>$c01a088c3cfd172a$var$normalizeBoardFromNode(data.node), [
        data.node
    ]);
    return children(board);
}
module.exports["BoardQuery"] = $c01a088c3cfd172a$export$9bb331a0b400c976;

});

parcelRegister("iOVAY", function(module, exports) {

var $2V04G = parcelRequire("2V04G");


var $6pXtc = parcelRequire("6pXtc");


var $k5sGX = parcelRequire("k5sGX");


var $88RF3 = parcelRequire("88RF3");


var $hWL69 = parcelRequire("hWL69");


var $fjKr7 = parcelRequire("fjKr7");


var $gvq7D = parcelRequire("gvq7D");


var $MjdYo = parcelRequire("MjdYo");

function $0f18729db49d7603$var$hasValidPayloadStructure(payload, workById) {
    switch(payload.action){
        case (0, $gvq7D.CapacityPlanningActionType).UPDATE_CONTRIBUTIONS:
            return payload.inputs.contributions.length > 0 && $0f18729db49d7603$var$canRenderActionWithWork(payload.inputs.contributions[0].workId, workById);
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTOR_WORK:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTOR_WORK:
            return payload.inputs.contributorWorkAssociations.length > 0 && $0f18729db49d7603$var$canRenderActionWithWork(payload.inputs.contributorWorkAssociations[0].workId, workById);
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTORS:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTORS:
            return payload.inputs.contributorDataIds.length > 0;
        case (0, $gvq7D.CapacityPlanningActionType).CREATE_NON_PROJECT_WORK:
            return payload.inputs.name.length > 0 && payload.inputs.contributorDataId.length > 0;
        case (0, $gvq7D.CapacityPlanningActionType).RENAME_NON_PROJECT_WORK:
            return payload.inputs.id.length > 0 && payload.inputs.name.length > 0;
        case (0, $gvq7D.CapacityPlanningActionType).ADD_WORKS:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_WORKS:
            // for the add/remove works action, even the inputs.workDataIds expects an array of work ids,
            // but actually we only support one work id at a time, so we check the length of the array and the first element
            return payload.inputs.workDataIds.length > 0 && $0f18729db49d7603$var$canRenderActionWithWork(payload.inputs.workDataIds[0], workById);
        default:
            return false;
    }
}
function $0f18729db49d7603$var$canRenderActionWithWork(workId, workById) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(workId)) return false;
    const work = workById.get(workId);
    if (!work) return false;
    return !(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(work.hierarchyLevel) || $0f18729db49d7603$export$14c7f473f1b917fe(workId);
}
function $0f18729db49d7603$export$84e60dc3deedb5cb(workId) {
    return (0, $fjKr7.JiraIssueAri).check(workId);
}
function $0f18729db49d7603$export$14c7f473f1b917fe(workId) {
    return (0, $hWL69.CapacityPlanningCustomContributionTargetAri).check(workId);
}
function $0f18729db49d7603$export$ae4a99d29b5a645c(payload) {
    switch(payload.action){
        case (0, $gvq7D.CapacityPlanningActionType).UPDATE_CONTRIBUTIONS:
            {
                const first = payload.inputs.contributions?.[0];
                return first?.contributorDataId ?? null;
            }
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTOR_WORK:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTOR_WORK:
            {
                const first = payload.inputs.contributorWorkAssociations?.[0];
                return first?.contributorDataId ?? null;
            }
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTORS:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTORS:
            {
                const first = payload.inputs.contributorDataIds?.[0];
                return first ?? null;
            }
        case (0, $gvq7D.CapacityPlanningActionType).CREATE_NON_PROJECT_WORK:
            return payload.inputs.contributorDataId ?? null;
        case (0, $gvq7D.CapacityPlanningActionType).RENAME_NON_PROJECT_WORK:
            return 0, $MjdYo.ContributorIdOfNoPeopleGroup;
        default:
            return null;
    }
}
function $0f18729db49d7603$export$1cc61b27605010bd(payload) {
    switch(payload.action){
        case (0, $gvq7D.CapacityPlanningActionType).UPDATE_CONTRIBUTIONS:
            {
                const first = payload.inputs.contributions[0];
                return first?.workId ?? null;
            }
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTOR_WORK:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTOR_WORK:
            {
                const first = payload.inputs.contributorWorkAssociations[0];
                return first?.workId ?? null;
            }
        case (0, $gvq7D.CapacityPlanningActionType).RENAME_NON_PROJECT_WORK:
            return payload.inputs.id ?? null;
        case (0, $gvq7D.CapacityPlanningActionType).ADD_WORKS:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_WORKS:
            if (payload.inputs.workDataIds.length === 0) return null;
            // for the add/remove works action, even the inputs.workDataIds expects an array of work ids,
            // but actually we only support one work id at a time
            return payload.inputs.workDataIds[0] ?? null;
        default:
            return null;
    }
}
function $0f18729db49d7603$export$1befa014376df2f9(actions) {
    const contributorIdSet = new Set();
    const workIdSet = new Set();
    for (const action of actions){
        const payload = action.data;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(payload)) continue;
        const workId = $0f18729db49d7603$export$1cc61b27605010bd(payload);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(workId)) workIdSet.add(workId);
        const contributorId = $0f18729db49d7603$export$ae4a99d29b5a645c(payload);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(contributorId)) contributorIdSet.add(contributorId);
    }
    return {
        contributorIds: Array.from(contributorIdSet),
        workIds: Array.from(workIdSet)
    };
}
function $0f18729db49d7603$export$fa5eba17719c4cd7(actions, usersByAccountId, workById, viewType) {
    const actionsByWorkId = new Map();
    const actionsByContributorId = new Map();
    for (const action of actions){
        const payload = action.data;
        // in the hasValidPayloadStructure has checked if the work is valid
        if (!$0f18729db49d7603$var$hasValidPayloadStructure(payload, workById)) continue;
        const contributorId = $0f18729db49d7603$export$ae4a99d29b5a645c(payload);
        // in the work view, the add/remove works action will not have a contributor id, but it is valid to have a work id
        // so we check if the contributor id is nil or not in the people view
        if (viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE && ((0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(contributorId) || !usersByAccountId.has(contributorId) && contributorId !== (0, $MjdYo.ContributorIdOfNoPeopleGroup))) continue;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(contributorId)) {
            const actionsList = actionsByContributorId.get(contributorId) ?? [];
            actionsList.push(action);
            actionsByContributorId.set(contributorId, actionsList);
        }
        const workId = $0f18729db49d7603$export$1cc61b27605010bd(payload);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(workId)) {
            const workList = actionsByWorkId.get(workId) ?? [];
            workList.push(action);
            actionsByWorkId.set(workId, workList);
        }
    }
    return {
        actionsByWorkId: actionsByWorkId,
        actionsByContributorId: actionsByContributorId
    };
}
function $0f18729db49d7603$export$480f1aeb927a7d5d(action, getStatus) {
    const storeStatus = getStatus(action);
    return storeStatus !== 'idle' ? storeStatus : action.status ?? 'idle';
}
function $0f18729db49d7603$export$d1e7e80681cbc0e2(action, getStatus) {
    const status = $0f18729db49d7603$export$480f1aeb927a7d5d(action, getStatus);
    return status === 'finished' || status === 'errored' || status === 'cancelled';
}
function $0f18729db49d7603$export$51b3aff3a8a6e026(startDateStr, endDateStr) {
    const start = (0, $k5sGX.default)(startDateStr);
    const end = (0, $k5sGX.default)(endDateStr);
    if (isNaN(start.getTime()) || isNaN(end.getTime()) || end < start) return 1;
    const count = (0, $2V04G.default)({
        start: start,
        end: end
    }).filter((d)=>{
        const day = (0, $6pXtc.default)(d);
        return day !== 0 && day !== 6;
    }).length;
    return count > 0 ? count : 1;
}
function $0f18729db49d7603$export$7e5d69b2c1bd5400(totalHours, startDateStr, endDateStr) {
    const weekdays = $0f18729db49d7603$export$51b3aff3a8a6e026(startDateStr, endDateStr);
    return parseFloat((totalHours / weekdays * 5).toFixed(2));
}
module.exports["isCustomContributionTargetARI"] = $0f18729db49d7603$export$14c7f473f1b917fe;
module.exports["isJiraWorkARI"] = $0f18729db49d7603$export$84e60dc3deedb5cb;
module.exports["getContributorDataId"] = $0f18729db49d7603$export$ae4a99d29b5a645c;
module.exports["getWorkId"] = $0f18729db49d7603$export$1cc61b27605010bd;
module.exports["getIdsForHydration"] = $0f18729db49d7603$export$1befa014376df2f9;
module.exports["filterActionsByIndexWithHydration"] = $0f18729db49d7603$export$fa5eba17719c4cd7;
module.exports["isActionCompleted"] = $0f18729db49d7603$export$d1e7e80681cbc0e2;
module.exports["getWeeklyHours"] = $0f18729db49d7603$export$7e5d69b2c1bd5400;

});

parcelRegister("9wJps", function(module, exports) {

var $jfoJN = parcelRequire("jfoJN");


var $cozmU = parcelRequire("cozmU");


var $88RF3 = parcelRequire("88RF3");


var $6SsN4 = parcelRequire("6SsN4");


var $3iWYJ = parcelRequire("3iWYJ");

var $a0unS = parcelRequire("a0unS");

var $1eov5 = parcelRequire("1eov5");

var $9LE5K = parcelRequire("9LE5K");


var $fjKr7 = parcelRequire("fjKr7");


var $iOVAY = parcelRequire("iOVAY");

const $e98d4eb6019b9929$var$HIERARCHY_LEVEL_FIELD = 'hierarchyLevel';
const $e98d4eb6019b9929$var$HIERARCHY_LEVEL_MIN = 1;
/**
 * Builds JQL to fetch specific issues by id from parsed Jira ARIs.
 * Format: hierarchyLevel >= 1 AND id IN (11064, 11063)
 */ function $e98d4eb6019b9929$var$buildJqlFromParsedJiraAris(parsed) {
    if (parsed.length === 0) return null;
    const cloudId = parsed[0].siteId;
    const issueIds = parsed.map((p)=>p.issueId);
    const idClause = (0, $a0unS.default).terminalClause((0, $a0unS.default).field('id'), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_IN)), (0, $a0unS.default).listOperand(issueIds.map((0, $a0unS.default).valueOperand)));
    const hierarchyClause = (0, $a0unS.default).terminalClause((0, $a0unS.default).field($e98d4eb6019b9929$var$HIERARCHY_LEVEL_FIELD), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_GT_EQUALS)), (0, $a0unS.default).valueOperand(String($e98d4eb6019b9929$var$HIERARCHY_LEVEL_MIN)));
    const whereClause = (0, $a0unS.default).compoundClause((0, $a0unS.default).compoundOperator((0, $3iWYJ.COMPOUND_OPERATOR_AND)), [
        hierarchyClause,
        idClause
    ]);
    const jql = (0, $9LE5K.print)((0, $a0unS.default).jast((0, $a0unS.default).query(whereClause)));
    return {
        cloudId: cloudId,
        jql: jql,
        first: parsed.length
    };
}
function $e98d4eb6019b9929$var$buildResultFromData(data) {
    // Build map of users by account ID
    const usersByAccountId = new Map((data?.users ?? []).map((u)=>[
            u.id,
            {
                id: u.id,
                name: u.name,
                picture: u.picture
            }
        ]));
    // Build map of custom contribution targets by ID
    const customContributionTargets = (data?.cpls_customContributionTargetsByIds ?? []).flatMap((item)=>{
        const name = item?.name?.trim();
        return name ? [
            [
                item.id,
                {
                    id: item.id,
                    name: name
                }
            ]
        ] : [];
    });
    // Build map of Jira work items by ID
    const jiraWorkItems = (data?.jira?.issueSearch?.edges ?? []).flatMap((edge)=>{
        const node = edge?.node;
        const name = node?.summary?.trim();
        const url = node?.webUrl?.trim();
        const hierarchyLevel = node?.issueType?.hierarchy?.level;
        const issueTypeAvatarUrl = node?.issueTypeAvatarUrl?.trim();
        const issueTypeName = node?.issueType?.name?.trim();
        return !(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(node?.id) && name && url && !(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(hierarchyLevel) ? [
            [
                node.id,
                {
                    id: node.id,
                    name: name,
                    url: url,
                    hierarchyLevel: hierarchyLevel,
                    ...issueTypeAvatarUrl ? {
                        issueTypeAvatarUrl: issueTypeAvatarUrl,
                        issueTypeName: issueTypeName
                    } : {}
                }
            ]
        ] : [];
    });
    // Build map of all work items by ID
    const workById = new Map([
        ...customContributionTargets,
        ...jiraWorkItems
    ]);
    return {
        usersByAccountId: usersByAccountId,
        workById: workById
    };
}
function $e98d4eb6019b9929$export$22385cf11e3e8bd2({ contributorIds: contributorIds, workIds: workIds, children: children }) {
    // Get account IDs and workIds
    const accountIds = (0, $cozmU.useMemo)(()=>contributorIds ?? [], [
        contributorIds
    ]);
    // Parse Jira ARIs to get Jira issue IDs
    const parsedJiraIds = (0, $cozmU.useMemo)(()=>(workIds ?? []).filter((0, $iOVAY.isJiraWorkARI)).map((ari)=>(0, $fjKr7.JiraIssueAri).parse(ari).getVariables()), [
        workIds
    ]);
    const customContributionTargetIds = (0, $cozmU.useMemo)(()=>(workIds ?? []).filter((0, $iOVAY.isCustomContributionTargetARI)), [
        workIds
    ]);
    // Build JQL to fetch Jira work items
    const jiraParams = (0, $cozmU.useMemo)(()=>$e98d4eb6019b9929$var$buildJqlFromParsedJiraAris(parsedJiraIds), [
        parsedJiraIds
    ]);
    const includeJiraWorkItems = Boolean(jiraParams?.jql);
    const includeCustomContributionTargets = customContributionTargetIds.length > 0;
    const variables = (0, $cozmU.useMemo)(()=>({
            accountIds: [
                ...accountIds
            ].sort(),
            customContributionTargetIds: [
                ...customContributionTargetIds
            ].sort(),
            includeJiraWorkItems: includeJiraWorkItems,
            includeCustomContributionTargets: includeCustomContributionTargets,
            cloudId: jiraParams?.cloudId ?? '',
            jql: jiraParams?.jql,
            first: jiraParams?.first ?? 0
        }), [
        accountIds,
        customContributionTargetIds,
        includeJiraWorkItems,
        includeCustomContributionTargets,
        jiraParams?.cloudId,
        jiraParams?.jql,
        jiraParams?.first
    ]);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $jfoJN.default), variables, {
        fetchPolicy: 'store-or-network'
    });
    const result = (0, $cozmU.useMemo)(()=>$e98d4eb6019b9929$var$buildResultFromData(data), [
        data
    ]);
    return children(result);
}
module.exports["CapacityPlanningDataQuery"] = $e98d4eb6019b9929$export$22385cf11e3e8bd2;

});

parcelRegister("ifC4g", function(module, exports) {
/* footer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $4ez2K = parcelRequire("4ez2K");


var $lfoFx = parcelRequire("lfoFx");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");

const $5f8c68c08fb47e89$var$dismissButtonMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.dismiss-button.non-final",
    defaultMessage: "Dismiss"
});
const $5f8c68c08fb47e89$var$acceptAllButtonMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.accept-all-button.non-final",
    defaultMessage: "Accept all"
});
const $5f8c68c08fb47e89$var$acceptSelectedButtonMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.accept-selected-button.non-final",
    defaultMessage: "Accept selected"
});
const $5f8c68c08fb47e89$var$dismissSelectedButtonMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.dismiss-selected-button.non-final",
    defaultMessage: "Dismiss selected"
});
const $5f8c68c08fb47e89$var$footerStyles = {
    wrapper: "_2mHwu81Y8M _37wbyuz9WS"
};
function $5f8c68c08fb47e89$var$isActionIdle(action, getStatus) {
    return action.status === 'planned' && getStatus(action) === 'idle';
}
function $5f8c68c08fb47e89$export$5ce799fbcc56f72b({ displayedActions: displayedActions, selectedKeys: selectedKeys, getStatus: getStatus, onConfirm: onConfirm, onCancel: onCancel, onClearSelection: onClearSelection, allActionsApplied: allActionsApplied, viewType: viewType }) {
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isBulkActioning, setIsBulkActioning] = (0, $cozmU.useState)(false);
    const idleActions = displayedActions.filter((action)=>$5f8c68c08fb47e89$var$isActionIdle(action, getStatus));
    const selectedActions = displayedActions.filter((action_0)=>selectedKeys.has(action_0.invocationId));
    const selectedCount = selectedKeys.size;
    const getActionTypeCounts = (0, $cozmU.useCallback)((actions)=>actions.reduce((acc, action_1)=>{
            const actionType = action_1.data.action;
            acc[actionType] = (acc[actionType] ?? 0) + 1;
            return acc;
        }, {}), []);
    const fireAnalytics = (0, $cozmU.useCallback)((actionSubjectId, actions_0)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            attributes: {
                count: actions_0.length,
                viewType: viewType,
                actionTypeCounts: getActionTypeCounts(actions_0)
            }
        });
    }, [
        sendAnalyticsEvent,
        viewType,
        getActionTypeCounts
    ]);
    const runBulkAction = (0, $cozmU.useCallback)(async (actionsToRun, handler)=>{
        setIsBulkActioning(true);
        await Promise.all(actionsToRun.map((action_2)=>handler(action_2)));
        setIsBulkActioning(false);
    }, []);
    const onAcceptAll = (0, $cozmU.useCallback)(()=>{
        fireAnalytics('rovoCapacityPlanningAcceptAll', idleActions);
        return runBulkAction(idleActions, onConfirm);
    }, [
        fireAnalytics,
        runBulkAction,
        idleActions,
        onConfirm
    ]);
    const onDismissAll = (0, $cozmU.useCallback)(()=>{
        fireAnalytics('rovoCapacityPlanningDismissAll', idleActions);
        return runBulkAction(idleActions, onCancel);
    }, [
        fireAnalytics,
        runBulkAction,
        idleActions,
        onCancel
    ]);
    const onAcceptSelected = (0, $cozmU.useCallback)(async ()=>{
        const actionsToRun_0 = selectedActions.filter((action_3)=>$5f8c68c08fb47e89$var$isActionIdle(action_3, getStatus));
        fireAnalytics('rovoCapacityPlanningAcceptSelected', actionsToRun_0);
        await runBulkAction(actionsToRun_0, onConfirm);
        onClearSelection();
    }, [
        fireAnalytics,
        runBulkAction,
        selectedActions,
        getStatus,
        onConfirm,
        onClearSelection
    ]);
    const onDismissSelected = (0, $cozmU.useCallback)(async ()=>{
        const actionsToRun_1 = selectedActions.filter((action_4)=>$5f8c68c08fb47e89$var$isActionIdle(action_4, getStatus));
        fireAnalytics('rovoCapacityPlanningDismissSelected', actionsToRun_1);
        await runBulkAction(actionsToRun_1, onCancel);
        onClearSelection();
    }, [
        fireAnalytics,
        runBulkAction,
        selectedActions,
        getStatus,
        onCancel,
        onClearSelection
    ]);
    if (allActionsApplied) return null;
    const isDisabled = idleActions.length === 0;
    return /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, isBulkActioning ? /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "small",
        interactionName: "load"
    }) : selectedCount > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $5f8c68c08fb47e89$var$footerStyles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismissSelected,
        isDisabled: isDisabled
    }, formatMessage($5f8c68c08fb47e89$var$dismissSelectedButtonMessage)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onAcceptSelected,
        isDisabled: isDisabled
    }, formatMessage($5f8c68c08fb47e89$var$acceptSelectedButtonMessage))) : /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $5f8c68c08fb47e89$var$footerStyles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismissAll,
        isDisabled: isDisabled
    }, formatMessage($5f8c68c08fb47e89$var$dismissButtonMessage)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onAcceptAll,
        isDisabled: isDisabled
    }, formatMessage($5f8c68c08fb47e89$var$acceptAllButtonMessage))));
}
module.exports["CapacityPlanningCardFooter"] = $5f8c68c08fb47e89$export$5ce799fbcc56f72b;

});

parcelRegister("fBbRq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");


var $MjdYo = parcelRequire("MjdYo");


var $eGVo0 = parcelRequire("eGVo0");

const $febc16d91fdecd36$var$renameGroupMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.people-view.rename-group.non-final",
    defaultMessage: "Rename"
});
const $febc16d91fdecd36$export$b227035f304e4376 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PeopleView(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { actionsByIndex: actionsIndex, hydratedUsers: hydratedUsers, workById: workById, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== actionsIndex.actionsByContributorId) {
        t1 = Array.from(actionsIndex.actionsByContributorId.entries()).map($febc16d91fdecd36$var$_temp);
        $[0] = actionsIndex.actionsByContributorId;
        $[1] = t1;
    } else t1 = $[1];
    const contributorGroups = t1;
    let t2;
    if ($[2] !== contributorGroups || $[3] !== formatMessage || $[4] !== getStatus || $[5] !== hydratedUsers || $[6] !== onCancel || $[7] !== onConfirm || $[8] !== onSelectionChange || $[9] !== selectedKeys || $[10] !== workById) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, contributorGroups.map((group, index)=>{
            const isNoPeopleGroup = group.contributorDataId === (0, $MjdYo.ContributorIdOfNoPeopleGroup);
            return /*#__PURE__*/ $cozmU.createElement((0, $eGVo0.PersonGroup), {
                key: group.contributorDataId,
                group: group,
                user: isNoPeopleGroup ? {
                    id: "non-people",
                    name: formatMessage($febc16d91fdecd36$var$renameGroupMessage),
                    picture: ""
                } : hydratedUsers.get(group.contributorDataId),
                isRenameGroup: isNoPeopleGroup,
                defaultExpanded: index === 0,
                selectedKeys: selectedKeys,
                onSelectionChange: onSelectionChange,
                workById: workById,
                onConfirm: onConfirm,
                onCancel: onCancel,
                getStatus: getStatus,
                hydratedUsers: hydratedUsers
            });
        }));
        $[2] = contributorGroups;
        $[3] = formatMessage;
        $[4] = getStatus;
        $[5] = hydratedUsers;
        $[6] = onCancel;
        $[7] = onConfirm;
        $[8] = onSelectionChange;
        $[9] = selectedKeys;
        $[10] = workById;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
} : function PeopleView({ actionsByIndex: actionsIndex, hydratedUsers: hydratedUsers, workById: workById, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contributorGroups = (0, $cozmU.useMemo)(()=>Array.from(actionsIndex.actionsByContributorId.entries()).map(([contributorDataId, actions])=>({
                contributorDataId: contributorDataId,
                actions: actions
            })), [
        actionsIndex.actionsByContributorId
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, contributorGroups.map((group, index)=>{
        const isNoPeopleGroup = group.contributorDataId === (0, $MjdYo.ContributorIdOfNoPeopleGroup);
        return /*#__PURE__*/ $cozmU.createElement((0, $eGVo0.PersonGroup), {
            key: group.contributorDataId,
            group: group,
            user: isNoPeopleGroup ? {
                id: 'non-people',
                name: formatMessage($febc16d91fdecd36$var$renameGroupMessage),
                picture: ''
            } : hydratedUsers.get(group.contributorDataId),
            isRenameGroup: isNoPeopleGroup,
            defaultExpanded: index === 0,
            selectedKeys: selectedKeys,
            onSelectionChange: onSelectionChange,
            workById: workById,
            onConfirm: onConfirm,
            onCancel: onCancel,
            getStatus: getStatus,
            hydratedUsers: hydratedUsers
        });
    }));
};
function $febc16d91fdecd36$var$_temp(t0) {
    const [contributorDataId, actions] = t0;
    return {
        contributorDataId: contributorDataId,
        actions: actions
    };
}
module.exports["PeopleView"] = $febc16d91fdecd36$export$b227035f304e4376;

});

parcelRegister("1WhA9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eh6Ml = parcelRequire("eh6Ml");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $54441c71a31d25f1$var$allActionsAcceptedMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.all-actions-accepted.non-final",
    defaultMessage: "You've accepted all actions"
});
const $54441c71a31d25f1$var$allActionsDismissedMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.all-actions-dismissed.non-final",
    defaultMessage: "You've dismissed all actions"
});
const $54441c71a31d25f1$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $54441c71a31d25f1$export$fd7791ba9543ad74 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SuccessMessage(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { actions: actions, getStatus: getStatus } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== actions || $[1] !== getStatus) {
        let t2;
        if ($[3] !== getStatus) {
            t2 = (action)=>getStatus(action) === "finished" || action.status === "finished";
            $[3] = getStatus;
            $[4] = t2;
        } else t2 = $[4];
        t1 = actions.some(t2);
        $[0] = actions;
        $[1] = getStatus;
        $[2] = t1;
    } else t1 = $[2];
    const hasAcceptedActions = t1;
    let t2;
    if ($[5] !== formatMessage || $[6] !== hasAcceptedActions) {
        t2 = hasAcceptedActions ? formatMessage($54441c71a31d25f1$var$allActionsAcceptedMessage) : formatMessage($54441c71a31d25f1$var$allActionsDismissedMessage);
        $[5] = formatMessage;
        $[6] = hasAcceptedActions;
        $[7] = t2;
    } else t2 = $[7];
    const message = t2;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-text-success, #4C6B1F)"
        });
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== message) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $54441c71a31d25f1$var$styles.explainerContainer,
            alignItems: "center",
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $54441c71a31d25f1$var$styles.explainer,
            alignBlock: "center",
            alignInline: "center"
        }, t3, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, message)));
        $[9] = message;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function SuccessMessage({ actions: actions, getStatus: getStatus }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasAcceptedActions = actions.some((action)=>getStatus(action) === 'finished' || action.status === 'finished');
    const message = hasAcceptedActions ? formatMessage($54441c71a31d25f1$var$allActionsAcceptedMessage) : formatMessage($54441c71a31d25f1$var$allActionsDismissedMessage);
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $54441c71a31d25f1$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $54441c71a31d25f1$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-text-success, #4C6B1F)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, message)));
};
module.exports["SuccessMessage"] = $54441c71a31d25f1$export$fd7791ba9543ad74;

});

parcelRegister("MjdYo", function(module, exports) {
const $165b981c2eb7c8fd$export$536d9f3f8ce5138e = 'contributor-id-of-no-people';
const $165b981c2eb7c8fd$export$3eda04925e8d7a71 = {
    PEOPLE: 'PEOPLE',
    WORK: 'WORK'
};
module.exports["ContributorIdOfNoPeopleGroup"] = $165b981c2eb7c8fd$export$536d9f3f8ce5138e;
module.exports["VIEW_TYPE"] = $165b981c2eb7c8fd$export$3eda04925e8d7a71;

});

parcelRegister("kPnHr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");


var $6URz7 = parcelRequire("6URz7");

const $b27fd7f50c308911$export$faa2082206a26181 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkView(t0) {
    const $ = (0, $bDgLe.c)(25);
    const { actionsByIndex: actionsByIndex, hydratedUsers: hydratedUsers, workById: workById, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, expandAllGroups: t1 } = t0;
    const expandAllGroups = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== actionsByIndex.actionsByWorkId) {
        t2 = Array.from(actionsByIndex.actionsByWorkId.entries());
        $[0] = actionsByIndex.actionsByWorkId;
        $[1] = t2;
    } else t2 = $[1];
    let groups;
    if ($[2] !== actionsByIndex.actionsByContributorId || $[3] !== actionsByIndex.actionsByWorkId || $[4] !== t2) {
        groups = t2.map($b27fd7f50c308911$var$_temp);
        let t3;
        if ($[6] !== actionsByIndex.actionsByWorkId) {
            t3 = new Set(Array.from(actionsByIndex.actionsByWorkId.values()).flat().map($b27fd7f50c308911$var$_temp2));
            $[6] = actionsByIndex.actionsByWorkId;
            $[7] = t3;
        } else t3 = $[7];
        const actionsWithWork = t3;
        let t4;
        if ($[8] !== actionsByIndex.actionsByContributorId || $[9] !== actionsWithWork) {
            let t5;
            if ($[11] !== actionsWithWork) {
                t5 = (a_0)=>!actionsWithWork.has(a_0.invocationId);
                $[11] = actionsWithWork;
                $[12] = t5;
            } else t5 = $[12];
            t4 = Array.from(actionsByIndex.actionsByContributorId.values()).flat().filter(t5);
            $[8] = actionsByIndex.actionsByContributorId;
            $[9] = actionsWithWork;
            $[10] = t4;
        } else t4 = $[10];
        const actionsWithoutWork = t4;
        if (actionsWithoutWork.length > 0) {
            let t5;
            if ($[13] !== actionsWithoutWork) {
                t5 = {
                    workId: null,
                    actions: actionsWithoutWork
                };
                $[13] = actionsWithoutWork;
                $[14] = t5;
            } else t5 = $[14];
            groups.push(t5);
        }
        $[2] = actionsByIndex.actionsByContributorId;
        $[3] = actionsByIndex.actionsByWorkId;
        $[4] = t2;
        $[5] = groups;
    } else groups = $[5];
    const workGroups = groups;
    let t3;
    if ($[15] !== expandAllGroups || $[16] !== getStatus || $[17] !== hydratedUsers || $[18] !== onCancel || $[19] !== onConfirm || $[20] !== onSelectionChange || $[21] !== selectedKeys || $[22] !== workById || $[23] !== workGroups) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, workGroups.map((group, index)=>/*#__PURE__*/ $cozmU.createElement((0, $6URz7.WorkGroup), {
                key: group.workId ?? "__no_work__",
                group: group,
                defaultExpanded: expandAllGroups || (group.defaultExpanded ?? index === 0),
                selectedKeys: selectedKeys,
                onSelectionChange: onSelectionChange,
                workById: workById,
                hydratedUsers: hydratedUsers,
                onConfirm: onConfirm,
                onCancel: onCancel,
                getStatus: getStatus
            })));
        $[15] = expandAllGroups;
        $[16] = getStatus;
        $[17] = hydratedUsers;
        $[18] = onCancel;
        $[19] = onConfirm;
        $[20] = onSelectionChange;
        $[21] = selectedKeys;
        $[22] = workById;
        $[23] = workGroups;
        $[24] = t3;
    } else t3 = $[24];
    return t3;
} : function WorkView({ actionsByIndex: actionsByIndex, hydratedUsers: hydratedUsers, workById: workById, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, expandAllGroups: expandAllGroups = false }) {
    const workGroups = (0, $cozmU.useMemo)(()=>{
        const groups = Array.from(actionsByIndex.actionsByWorkId.entries()).map(([workId, actions])=>({
                workId: workId,
                actions: actions
            })); // Collect actions that have no associated work ID (e.g. ADD_CONTRIBUTORS / REMOVE_CONTRIBUTORS)
        const actionsWithWork = new Set(Array.from(actionsByIndex.actionsByWorkId.values()).flat().map((a)=>a.invocationId));
        const actionsWithoutWork = Array.from(actionsByIndex.actionsByContributorId.values()).flat().filter((a_0)=>!actionsWithWork.has(a_0.invocationId));
        if (actionsWithoutWork.length > 0) groups.push({
            workId: null,
            actions: actionsWithoutWork
        });
        return groups;
    }, [
        actionsByIndex
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, workGroups.map((group, index)=>/*#__PURE__*/ $cozmU.createElement((0, $6URz7.WorkGroup), {
            key: group.workId ?? '__no_work__',
            group: group,
            defaultExpanded: expandAllGroups || (group.defaultExpanded ?? index === 0),
            selectedKeys: selectedKeys,
            onSelectionChange: onSelectionChange,
            workById: workById,
            hydratedUsers: hydratedUsers,
            onConfirm: onConfirm,
            onCancel: onCancel,
            getStatus: getStatus
        })));
};
function $b27fd7f50c308911$var$_temp2(a) {
    return a.invocationId;
}
function $b27fd7f50c308911$var$_temp(t0) {
    const [workId, actions] = t0;
    return {
        workId: workId,
        actions: actions
    };
}
module.exports["WorkView"] = $b27fd7f50c308911$export$faa2082206a26181;

});

parcelRegister("i321f", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $351ae98846f5d502$var$messages = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.confluence-aifc-adf-update.action-message",
        defaultMessage: "Here's a summary of the suggested changes. Review them, then select <bold>Confirm</bold> when you're ready."
    },
    confirmButton: {
        id: "ai-mate.message-actions.confluence-aifc-adf-update.confirm-button",
        defaultMessage: "Confirm"
    },
    cancelButton: {
        id: "ai-mate.message-actions.confluence-aifc-adf-update.cancel-button",
        defaultMessage: "Cancel"
    },
    actionCardTitle: {
        id: "ai-mate.message-actions.confluence-aifc-adf-update.action-card-title",
        defaultMessage: "Edit content"
    }
});
var $351ae98846f5d502$export$2e2bcd8739ae039 = $351ae98846f5d502$var$messages;
module.exports["default"] = $351ae98846f5d502$export$2e2bcd8739ae039;

});

parcelRegister("dKH1M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f11489b040758ea1$var$messages = (0, $kSwu1.defineMessages)({
    cancelButton: {
        id: "conversation-assistant-message-actions.controllers.confluence-folder-create.cancelButton",
        defaultMessage: "Cancel"
    },
    cardTitle: {
        id: "conversation-assistant-message-actions.controllers.confluence-folder-create.cardTitle",
        defaultMessage: "{count, plural, one {Create folder} other {Create folders}}"
    },
    createButton: {
        id: "conversation-assistant-message-actions.controllers.confluence-folder-create.createButton",
        defaultMessage: "Create"
    },
    createSelectedButton: {
        id: "conversation-assistant-message-actions.controllers.confluence-folder-create.createSelectedButton",
        defaultMessage: "Create selected"
    },
    folderNameLabel: {
        id: "conversation-assistant-message-actions.controllers.confluence-folder-create.folderNameLabel",
        defaultMessage: "Folder name"
    },
    spaceLabel: {
        id: "conversation-assistant-message-actions.controllers.confluence-folder-create.spaceLabel",
        defaultMessage: "Space"
    }
});
var $f11489b040758ea1$export$2e2bcd8739ae039 = $f11489b040758ea1$var$messages;
module.exports["default"] = $f11489b040758ea1$export$2e2bcd8739ae039;

});

parcelRegister("c3tf0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $24dy7 = parcelRequire("24dy7");


var $3oEyF = parcelRequire("3oEyF");


var $iMnC5 = parcelRequire("iMnC5");


var $4yg9g = parcelRequire("4yg9g");


var $1JERl = parcelRequire("1JERl");

const $ef09623f13c93ba6$var$errorIconContainerStyles = {
    root: "_26BoRwN91d _03SyCPgVvo"
};
const $ef09623f13c93ba6$var$readViewForTextFieldStyles = {
    root: "_2sNsIgmnOE _4c065U2ADO _2Y7lL4gVvo _3iDTPbQ4SZ _1EqgXlN91d _3W2Oc8wPeg"
};
const $ef09623f13c93ba6$var$compactStyles = {
    root: "_4c065U1Y8M _2Y7lL4gVvo"
}; // TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Inline editable textfield__
 *
 * An inline editable textfield {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $ef09623f13c93ba6$var$InlineEditableTextfield = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isCompact: t0, defaultValue: defaultValue, placeholder: placeholder, testId: testId, onCancel: providedOnCancel } = props;
    const isCompact = t0 === undefined ? false : t0;
    const textFieldRef = (0, $cozmU.useRef)();
    let t1;
    if ($[0] !== defaultValue || $[1] !== providedOnCancel) {
        t1 = ()=>{
            if (textFieldRef.current) textFieldRef.current.value = defaultValue || "";
            providedOnCancel?.();
        };
        $[0] = defaultValue;
        $[1] = providedOnCancel;
        $[2] = t1;
    } else t1 = $[2];
    const onCancel = t1;
    let t2;
    if ($[3] !== isCompact || $[4] !== testId) {
        t2 = (t3)=>{
            const { errorMessage: errorMessage, isInvalid: isInvalid, ...props_0 } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oEyF.default), {
                isOpen: isInvalid,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    id: "error-message"
                }, errorMessage),
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...props_0,
                ref: textFieldRef,
                elemAfterInput: isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $ef09623f13c93ba6$var$errorIconContainerStyles.root
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "error",
                    color: "var(--ds-icon-danger, #C9372C)",
                    size: "small"
                })),
                testId: testId,
                isCompact: isCompact,
                autoFocus: true
            }));
        };
        $[3] = isCompact;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== defaultValue || $[7] !== isCompact || $[8] !== placeholder || $[9] !== testId) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ef09623f13c93ba6$var$readViewForTextFieldStyles.root, isCompact && $ef09623f13c93ba6$var$compactStyles.root),
                "data-compact": isCompact,
                testId: testId && `read-view-${testId}`
            }, defaultValue || placeholder);
        $[6] = defaultValue;
        $[7] = isCompact;
        $[8] = placeholder;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== defaultValue || $[12] !== onCancel || $[13] !== props || $[14] !== t2 || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
            ...props,
            onCancel: onCancel,
            defaultValue: defaultValue,
            editView: t2,
            readView: t3
        });
        $[11] = defaultValue;
        $[12] = onCancel;
        $[13] = props;
        $[14] = t2;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : (props)=>{
    const { isCompact: isCompact = false, defaultValue: defaultValue, placeholder: placeholder, testId: testId, onCancel: providedOnCancel } = props;
    const textFieldRef = (0, $cozmU.useRef)();
    const onCancel = (0, $cozmU.useCallback)(()=>{
        if (textFieldRef.current) textFieldRef.current.value = defaultValue || '';
        providedOnCancel?.();
    }, [
        defaultValue,
        providedOnCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...props,
        onCancel: onCancel,
        defaultValue: defaultValue,
        editView: ({ errorMessage: errorMessage, isInvalid: isInvalid, ...props_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oEyF.default), {
                isOpen: isInvalid,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    id: "error-message"
                }, errorMessage),
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...props_0,
                ref: textFieldRef,
                elemAfterInput: isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $ef09623f13c93ba6$var$errorIconContainerStyles.root
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "error",
                    color: "var(--ds-icon-danger, #C9372C)",
                    size: "small"
                })),
                testId: testId,
                isCompact: isCompact,
                autoFocus: true
            })),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ef09623f13c93ba6$var$readViewForTextFieldStyles.root, isCompact && $ef09623f13c93ba6$var$compactStyles.root),
                "data-compact": isCompact,
                testId: testId && `read-view-${testId}`
            }, defaultValue || placeholder)
    });
};
var $ef09623f13c93ba6$export$2e2bcd8739ae039 = $ef09623f13c93ba6$var$InlineEditableTextfield;
module.exports["default"] = $ef09623f13c93ba6$export$2e2bcd8739ae039;

});

parcelRegister("g3R09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dqxOF = parcelRequire("dqxOF");


var $1HjbK = parcelRequire("1HjbK");


var $jlxRT = parcelRequire("jlxRT");

const $987306b2b13c9eba$export$fe57af69b35ddf46 = (0, $jlxRT.extractContentId);
const $987306b2b13c9eba$var$HOOK_OUTPUT_PROPS = [
    'listEntities'
];
const $987306b2b13c9eba$var$omitHookOutputProps = (props, keys)=>Object.fromEntries(Object.entries(props).filter(([key])=>!keys.includes(key))); /**
                                                                                                                                                                                                                   * Memoized version of BaseConfluencePageSelector with custom comparison function.
                                                                                                                                                                                                                   */ 
const $987306b2b13c9eba$var$BaseConfluencePageSelector = /*#__PURE__*/ (0, $cozmU.memo)((0, $jlxRT.BaseConfluencePageSelectorInner), (prevProps, nextProps)=>(0, $dqxOF.shallowEqualObjects)($987306b2b13c9eba$var$omitHookOutputProps(prevProps, $987306b2b13c9eba$var$HOOK_OUTPUT_PROPS), $987306b2b13c9eba$var$omitHookOutputProps(nextProps, $987306b2b13c9eba$var$HOOK_OUTPUT_PROPS))); /**
                                                                                                                                                                                                                                * AFM consumers should use this web-specific component
                                                                                                                                                                                                                                */ 
const $987306b2b13c9eba$export$f49e3ba233a5a3cf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let cloudId;
    let contentTypes;
    let props;
    let spaceId;
    if ($[0] !== t0) {
        ({ cloudId: cloudId, spaceId: spaceId, contentTypes: contentTypes, ...props } = t0);
        $[0] = t0;
        $[1] = cloudId;
        $[2] = contentTypes;
        $[3] = props;
        $[4] = spaceId;
    } else {
        cloudId = $[1];
        contentTypes = $[2];
        props = $[3];
        spaceId = $[4];
    }
    const { listEntities: listEntities } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    let t1;
    if ($[5] !== contentTypes || $[6] !== listEntities || $[7] !== props || $[8] !== spaceId) {
        t1 = /*#__PURE__*/ $cozmU.createElement($987306b2b13c9eba$var$BaseConfluencePageSelector, {
            spaceId: spaceId,
            contentTypes: contentTypes,
            listEntities: listEntities,
            ...props
        });
        $[5] = contentTypes;
        $[6] = listEntities;
        $[7] = props;
        $[8] = spaceId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : ({ cloudId: cloudId, spaceId: spaceId, contentTypes: contentTypes, ...props })=>{
    const { listEntities: listEntities } = (0, $1HjbK.useConfluenceEntities)(cloudId);
    return /*#__PURE__*/ $cozmU.createElement($987306b2b13c9eba$var$BaseConfluencePageSelector, {
        spaceId: spaceId,
        contentTypes: contentTypes,
        listEntities: listEntities,
        ...props
    });
};
module.exports["ConfluencePageSelector"] = $987306b2b13c9eba$export$f49e3ba233a5a3cf;

});

parcelRegister("kN5Cw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $56612d86ac74c7fb$var$_default_1 = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.confluence-add-label.action-message",
        defaultMessage: "Here's the label I suggest adding to the page {name}. Take a look over it, then select <bold>Add Label</bold> when you're ready."
    },
    pageSelectorLabel: {
        id: "ai-mate.message-actions.confluence-add-label.space-selector-label",
        defaultMessage: "Page"
    },
    labelPlaceholder: {
        id: "ai-mate.message-actions.confluence-add-label.page-content-placeholder",
        defaultMessage: "Add your label here"
    },
    labelNameLabel: {
        id: "ai-mate.message-actions.confluence-add-label.label-name-label",
        defaultMessage: "Label name"
    },
    addLabelButton: {
        id: "ai-mate.message-actions.confluence-add-label.publish-button",
        defaultMessage: "Add label"
    },
    confluenceCommentCreateActionCardTitle: {
        id: "ai-mate.message-actions.confluence-add-label.action-card-title",
        defaultMessage: "Add label"
    }
});
var $56612d86ac74c7fb$export$2e2bcd8739ae039 = $56612d86ac74c7fb$var$_default_1;
module.exports["default"] = $56612d86ac74c7fb$export$2e2bcd8739ae039;

});

parcelRegister("7cWmx", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $14cdc5530e42d1d0$var$message = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.confluence-comment-create.action-message",
        defaultMessage: "Here's the comment I suggest adding to the page {name}. Take a look over it, then publish when you're ready."
    },
    pageSelectorLabel: {
        id: "ai-mate.message-actions.confluence-comment-create.page-selector-label",
        defaultMessage: "Page"
    },
    replyingAsLabel: {
        id: "ai-mate.message-actions.confluence-comment-create.replying-as-label",
        defaultMessage: "Replying as"
    },
    replyWithAgentText: {
        id: "ai-mate.message-actions.confluence-comment-create.reply-with-agent",
        defaultMessage: "{userName} with you"
    },
    commentMessageLabel: {
        id: "ai-mate.message-actions.confluence-comment-create.comment-message-label",
        defaultMessage: "Message"
    },
    commentPlaceholder: {
        id: "ai-mate.message-actions.confluence-comment-create.page-content-placeholder",
        defaultMessage: "Write your comment here"
    },
    publishButton: {
        id: "ai-mate.message-actions.confluence-comment-create.publish-button",
        defaultMessage: "Publish"
    },
    confluenceCommentCreateActionCardTitle: {
        id: "ai-mate.message-actions.confluence-comment-create.action-card-title",
        defaultMessage: "Add comment"
    },
    confluenceCommentCreateInlineActionCardTitle: {
        id: "ai-mate.message-actions.confluence-comment-create.action-card-title-inline",
        defaultMessage: "Add inline comment"
    },
    replyButton: {
        id: "ai-mate.message-actions.confluence-comment-create.reply-button",
        defaultMessage: "Add reply"
    },
    confluenceCommentCreateReplyActionCardTitle: {
        id: "ai-mate.message-actions.confluence-comment-create.action-card-title-reply",
        defaultMessage: "Reply in thread"
    }
});
var $14cdc5530e42d1d0$export$2e2bcd8739ae039 = $14cdc5530e42d1d0$var$message;
module.exports["default"] = $14cdc5530e42d1d0$export$2e2bcd8739ae039;

});

parcelRegister("3sxic", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3251c2fff18d8920$var$message = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.confluence-page-create.action-message",
        defaultMessage: "Here's the page content I suggest adding to the space {spaceName}. Take a look over it, then select <bold>Publish page</bold> when you're ready."
    },
    actionMessageLiveDoc: {
        id: "ai-mate.message-actions.confluence-page-create.action-message-live-doc",
        defaultMessage: "Here's the live doc content I suggest adding to the space {spaceName}. Take a look over it, then select <bold>Create live doc</bold> when you're ready."
    },
    spaceSelectorLabel: {
        id: "ai-mate.message-actions.confluence-page-create.space-selector-label",
        defaultMessage: "Space"
    },
    pageContentPlaceholder: {
        id: "ai-mate.message-actions.confluence-page-create.page-content-placeholder",
        defaultMessage: "Write your page content here"
    },
    publishPageButton: {
        id: "ai-mate.message-actions.confluence-page-create.publish-page-button",
        defaultMessage: "Publish page"
    },
    createLiveDocButton: {
        id: "ai-mate.message-actions.confluence-page-create.create-live-doc-button",
        defaultMessage: "Create live doc"
    },
    confluencePageCreateActionCardTitle: {
        id: "ai-mate.message-actions.confluence-page-create.action-card-title",
        defaultMessage: "Create page"
    }
});
var $3251c2fff18d8920$export$2e2bcd8739ae039 = $3251c2fff18d8920$var$message;
module.exports["default"] = $3251c2fff18d8920$export$2e2bcd8739ae039;

});

parcelRegister("gQM67", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9a3bc4e2c393acae$var$message = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.confluence-page-move.action-message",
        defaultMessage: "Here's the page I suggest moving to the target page. Take a look over it, then select <bold>Move Page</bold> when you're ready."
    },
    pageSelectorLabel: {
        id: "ai-mate.message-actions.confluence-page-move.space-selector-label",
        defaultMessage: "Parent page"
    },
    spaceSelectorLabel: {
        id: "ai-mate.message-actions.confluence-page-move.space-selector-label",
        defaultMessage: "Select a space"
    },
    movePageButton: {
        id: "ai-mate.message-actions.confluence-page-move.move-page-button",
        defaultMessage: "Move Page"
    },
    confluencePageMoveActionCardTitle: {
        id: "ai-mate.message-actions.confluence-page-move.action-card-title",
        defaultMessage: "Move Page"
    }
});
var $9a3bc4e2c393acae$export$2e2bcd8739ae039 = $9a3bc4e2c393acae$var$message;
module.exports["default"] = $9a3bc4e2c393acae$export$2e2bcd8739ae039;

});

parcelRegister("gHpCf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c5d0a02569e77525$var$message = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.confluence-page-rename.action-message",
        defaultMessage: "Here's the title I suggest renaming to the page {name}. Take a look over it, then select <bold>Rename Page</bold> when you're ready."
    },
    pageSelectorLabel: {
        id: "ai-mate.message-actions.confluence-page-rename.page-selector-label",
        defaultMessage: "Page"
    },
    titlePlaceholder: {
        id: "ai-mate.message-actions.confluence-page-rename.title-placeholder",
        defaultMessage: "Enter new page title"
    },
    titleLabel: {
        id: "ai-mate.message-actions.confluence-page-rename.title-label",
        defaultMessage: "New page title"
    },
    addLabelButton: {
        id: "ai-mate.message-actions.confluence-page-rename.rename-button",
        defaultMessage: "Rename page"
    },
    confluencePageRenameActionCardTitle: {
        id: "ai-mate.message-actions.confluence-page-rename.action-card-title",
        defaultMessage: "Rename page"
    }
});
var $c5d0a02569e77525$export$2e2bcd8739ae039 = $c5d0a02569e77525$var$message;
module.exports["default"] = $c5d0a02569e77525$export$2e2bcd8739ae039;

});

parcelRegister("7puYn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $6dfb7000534db86b$var$styles = {
    divider: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $6dfb7000534db86b$export$2e0a83ec2e27ecbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6dfb7000534db86b$var$styles.divider,
            backgroundColor: "color.background.neutral.subtle"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6dfb7000534db86b$var$styles.divider,
        backgroundColor: "color.background.neutral.subtle"
    });
};
module.exports["Divider"] = $6dfb7000534db86b$export$2e0a83ec2e27ecbb;

});

parcelRegister("Vkwix", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dcd9973cd94377cf$var$message = (0, $kSwu1.defineMessages)({
    exportToPageButton: {
        id: "ai-mate.message-actions.deep-research-actions.export-to-page-button",
        defaultMessage: "Export to page"
    },
    publishPageButton: {
        id: "ai-mate.message-actions.deep-research-actions.publish-page-button",
        defaultMessage: "Publish page"
    },
    spaceSelectorLabel: {
        id: "ai-mate.message-actions.deep-research-actions.space-selector-label",
        defaultMessage: "Space"
    },
    pageTitlePlaceholder: {
        id: "ai-mate.message-actions.deep-research-actions.page-title-placeholder",
        defaultMessage: "Write your page title here"
    },
    pageTitleLabel: {
        id: "ai-mate.message-actions.deep-research-actions.page-title-label",
        defaultMessage: "Page name"
    },
    editPageNameButtonLabel: {
        id: "ai-mate.message-actions.deep-research-actions.edit-page-name-button-label",
        defaultMessage: "Edit page name"
    }
});
var $dcd9973cd94377cf$export$2e2bcd8739ae039 = $dcd9973cd94377cf$var$message;
module.exports["default"] = $dcd9973cd94377cf$export$2e2bcd8739ae039;

});

parcelRegister("aM39D", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $ad7Ou = parcelRequire("ad7Ou");


var $7BfeF = parcelRequire("7BfeF");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $isp1U = parcelRequire("isp1U");


var $9qyl6 = parcelRequire("9qyl6");


var $bHdyi = parcelRequire("bHdyi");


var $eEgoJ = parcelRequire("eEgoJ");


var $fr9Wb = parcelRequire("fr9Wb");


var $95hQj = parcelRequire("95hQj");


var $gkWsQ = parcelRequire("gkWsQ");


var $ewvjY = parcelRequire("ewvjY");


var $5R7bA = parcelRequire("5R7bA");


var $ljAgM = parcelRequire("ljAgM");


var $6W6xO = parcelRequire("6W6xO");


var $79yHm = parcelRequire("79yHm");


var $iATgb = parcelRequire("iATgb");


var $9e6Xa = parcelRequire("9e6Xa");


var $e2rFc = parcelRequire("e2rFc");


var $hfdnF = parcelRequire("hfdnF");


var $6kwbC = parcelRequire("6kwbC");

const $27e1f53bad026cd3$var$styles = {
    footer: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS",
    fieldsWrapper: "_39xV02N91d _4ouGXIdnbC",
    commentInput: "_2O5Vij7dHp _4ouGXIdnbC"
};
const $27e1f53bad026cd3$export$ac4ab90ccf684041 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(155);
    const { action: action, cloudId: cloudId, orgId: orgId, readonly: t1, isActionFinished: t2, isSubmitting: t3, onConfirm: onConfirm } = t0;
    const readonly = t1 === undefined ? false : t1;
    const isActionFinished = t2 === undefined ? false : t2;
    const isSubmitting = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] !== action.data) {
        t4 = ()=>{
            const data = (0, $iATgb.normalizeFocusAskPayload)(action.data);
            return {
                name: data.name,
                description: data.description ?? "",
                justification: data.justification ?? "",
                targetDate: data.targetDate,
                commentData: data.commentData,
                links: data.links,
                submitter: data.submitter,
                owner: data.owner,
                submittingTeam: data.submittingTeam,
                receivingTeam: data.receivingTeam,
                priority: data.priority,
                impactedWork: data.impactedWork ? {
                    id: data?.impactedWork?.id ?? "",
                    link: data?.impactedWork?.link ?? ""
                } : null
            };
        };
        $[0] = action.data;
        $[1] = t4;
    } else t4 = $[1];
    const [formData, setFormData] = (0, $cozmU.useState)(t4);
    const currentUser = (0, $isp1U.useProfileController)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [isLinksEditorOpen, setIsLinksEditorOpen] = (0, $cozmU.useState)(false);
    const [impactedWorkStatus, setImpactedWorkStatus] = (0, $cozmU.useState)(formData.impactedWork ? "resolving" : "idle");
    const isCardReadOnly = readonly || isActionFinished;
    const buttonsDisabled = isCardReadOnly || isSubmitting;
    let t5;
    if ($[2] !== formData.name) {
        t5 = formData.name.trim();
        $[2] = formData.name;
        $[3] = t5;
    } else t5 = $[3];
    const trimmedName = t5;
    const isImpactedWorkBlockingCreate = impactedWorkStatus !== "idle" && impactedWorkStatus !== "resolved";
    let t6;
    if ($[4] !== buttonsDisabled || $[5] !== formData.name.length || $[6] !== formData.submitter?.id || $[7] !== isImpactedWorkBlockingCreate || $[8] !== isLinksEditorOpen || $[9] !== trimmedName) {
        t6 = buttonsDisabled || !trimmedName || !formData.submitter?.id?.trim() || formData.name.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH) || isLinksEditorOpen || isImpactedWorkBlockingCreate;
        $[4] = buttonsDisabled;
        $[5] = formData.name.length;
        $[6] = formData.submitter?.id;
        $[7] = isImpactedWorkBlockingCreate;
        $[8] = isLinksEditorOpen;
        $[9] = trimmedName;
        $[10] = t6;
    } else t6 = $[10];
    const isCreateButtonDisabled = t6;
    let t7;
    if ($[11] !== action || $[12] !== formData || $[13] !== isCreateButtonDisabled || $[14] !== onConfirm || $[15] !== trimmedName) {
        t7 = ()=>{
            if (isCreateButtonDisabled) return;
            onConfirm?.(action, {
                ...formData,
                name: trimmedName
            });
        };
        $[11] = action;
        $[12] = formData;
        $[13] = isCreateButtonDisabled;
        $[14] = onConfirm;
        $[15] = trimmedName;
        $[16] = t7;
    } else t7 = $[16];
    const handleConfirm = t7;
    let t8;
    if ($[17] !== buttonsDisabled) {
        t8 = ()=>{
            if (buttonsDisabled) return;
            setIsModalOpen(true);
        };
        $[17] = buttonsDisabled;
        $[18] = t8;
    } else t8 = $[18];
    const handleEditDetails = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setIsModalOpen(false);
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleModalClose = t9;
    let t10;
    if ($[20] !== action || $[21] !== buttonsDisabled || $[22] !== onConfirm) {
        t10 = (updatedData)=>{
            if (buttonsDisabled) {
                setIsModalOpen(false);
                return;
            }
            setFormData(updatedData);
            setIsModalOpen(false);
            setIsLinksEditorOpen(false);
            setImpactedWorkStatus(updatedData.impactedWork ? "resolving" : "idle");
            onConfirm?.(action, updatedData);
        };
        $[20] = action;
        $[21] = buttonsDisabled;
        $[22] = onConfirm;
        $[23] = t10;
    } else t10 = $[23];
    const handleModalSubmit = t10;
    let t11;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (value)=>{
            setFormData((prev)=>({
                    ...prev,
                    name: value
                }));
        };
        $[24] = t11;
    } else t11 = $[24];
    const handleNameChange = t11;
    let t12;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (value_0)=>{
            setFormData((prev_0)=>({
                    ...prev_0,
                    description: value_0
                }));
        };
        $[25] = t12;
    } else t12 = $[25];
    const handleDescriptionChange = t12;
    let t13;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (value_1)=>{
            setFormData((prev_1)=>({
                    ...prev_1,
                    justification: value_1
                }));
        };
        $[26] = t13;
    } else t13 = $[26];
    const handleJustificationChange = t13;
    let t14;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (user)=>{
            setFormData((prev_2)=>({
                    ...prev_2,
                    submitter: user
                }));
        };
        $[27] = t14;
    } else t14 = $[27];
    const handleSubmitterChange = t14;
    let t15;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (user_0)=>{
            setFormData((prev_3)=>({
                    ...prev_3,
                    owner: user_0
                }));
        };
        $[28] = t15;
    } else t15 = $[28];
    const handleOwnerChange = t15;
    let t16;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (field, value_2)=>{
            setFormData((prev_4)=>({
                    ...prev_4,
                    [field]: value_2
                }));
        };
        $[29] = t16;
    } else t16 = $[29];
    const handleFormDataUpdate = t16;
    const canEditLinks = !buttonsDisabled;
    const shouldShowImpactedWorkField = Boolean(formData.impactedWork) || impactedWorkStatus !== "idle";
    let t17;
    if ($[30] !== formData.name || $[31] !== formatMessage || $[32] !== isCardReadOnly) {
        t17 = isCardReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "large",
            weight: "bold"
        }, formData.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
            isRequired: true,
            defaultValue: formData.name,
            editView: (fieldProps)=>{
                const isMissing = !fieldProps.value.trim();
                const isTooLong = fieldProps.value.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                    ...fieldProps,
                    isCompact: true,
                    maxLength: (0, $gkWsQ.MAX_ASK_NAME_LENGTH),
                    isInvalid: isMissing || isTooLong
                }), isMissing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).bulkMissingInfo)), !isMissing && isTooLong && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).nameFieldTooLong, {
                    maxLength: (0, $gkWsQ.MAX_ASK_NAME_LENGTH)
                })));
            },
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "large",
                    weight: "bold"
                }, formData.name),
            onConfirm: (value_3)=>{
                const nextName = value_3.trim();
                if (nextName && value_3.length <= (0, $gkWsQ.MAX_ASK_NAME_LENGTH)) handleNameChange(nextName);
            },
            readViewFitContainerWidth: true
        });
        $[30] = formData.name;
        $[31] = formatMessage;
        $[32] = isCardReadOnly;
        $[33] = t17;
    } else t17 = $[33];
    let t18;
    if ($[34] !== formatMessage) {
        t18 = formatMessage((0, $79yHm.default).detailsSectionLabel);
        $[34] = formatMessage;
        $[35] = t18;
    } else t18 = $[35];
    let t19;
    if ($[36] !== formatMessage) {
        t19 = formatMessage((0, $79yHm.default).submitterFieldLabel);
        $[36] = formatMessage;
        $[37] = t19;
    } else t19 = $[37];
    let t20;
    if ($[38] !== buttonsDisabled || $[39] !== cloudId || $[40] !== formData.submitter) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
            appearance: "control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljAgM.UserPickerField), {
            name: "submitter",
            label: (0, $79yHm.default).submitterFieldLabel,
            placeholder: (0, $79yHm.default).submitterPickerPlaceholder,
            cloudId: cloudId,
            value: formData.submitter,
            onChange: handleSubmitterChange,
            isRequired: true,
            fieldId: "submitter-preview",
            isDisabled: buttonsDisabled,
            isClearable: false,
            hideLabel: true,
            isCompact: true,
            appearance: "subtle"
        }));
        $[38] = buttonsDisabled;
        $[39] = cloudId;
        $[40] = formData.submitter;
        $[41] = t20;
    } else t20 = $[41];
    let t21;
    if ($[42] !== t19 || $[43] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
            label: t19
        }, t20);
        $[42] = t19;
        $[43] = t20;
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] !== formatMessage) {
        t22 = formatMessage((0, $79yHm.default).receiverFieldLabel);
        $[45] = formatMessage;
        $[46] = t22;
    } else t22 = $[46];
    let t23;
    if ($[47] !== buttonsDisabled || $[48] !== cloudId || $[49] !== formData.owner) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
            appearance: "control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljAgM.UserPickerField), {
            name: "owner",
            label: (0, $79yHm.default).receiverFieldLabel,
            placeholder: (0, $79yHm.default).receiverPickerPlaceholder,
            cloudId: cloudId,
            value: formData.owner,
            onChange: handleOwnerChange,
            fieldId: "owner-preview",
            isDisabled: buttonsDisabled,
            hideLabel: true,
            isCompact: true,
            appearance: "subtle"
        }));
        $[47] = buttonsDisabled;
        $[48] = cloudId;
        $[49] = formData.owner;
        $[50] = t23;
    } else t23 = $[50];
    let t24;
    if ($[51] !== t22 || $[52] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
            label: t22
        }, t23);
        $[51] = t22;
        $[52] = t23;
        $[53] = t24;
    } else t24 = $[53];
    let t25;
    if ($[54] !== formatMessage) {
        t25 = formatMessage((0, $79yHm.default).priorityFieldLabel);
        $[54] = formatMessage;
        $[55] = t25;
    } else t25 = $[55];
    let t26;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = (value_4)=>handleFormDataUpdate("priority", value_4);
        $[56] = t26;
    } else t26 = $[56];
    let t27;
    if ($[57] !== buttonsDisabled || $[58] !== formData.priority) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
            appearance: "control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ewvjY.PriorityField), {
            value: formData.priority,
            onChange: t26,
            hideLabel: true,
            isCompact: true,
            appearance: "subtle",
            isDisabled: buttonsDisabled
        }));
        $[57] = buttonsDisabled;
        $[58] = formData.priority;
        $[59] = t27;
    } else t27 = $[59];
    let t28;
    if ($[60] !== t25 || $[61] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
            label: t25
        }, t27);
        $[60] = t25;
        $[61] = t27;
        $[62] = t28;
    } else t28 = $[62];
    let t29;
    if ($[63] !== buttonsDisabled || $[64] !== cloudId || $[65] !== formData.submittingTeam || $[66] !== formatMessage || $[67] !== orgId) {
        t29 = formData.submittingTeam && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
            label: formatMessage((0, $79yHm.default).submittingTeamFieldLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
            appearance: "control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5R7bA.TeamPickerField), {
            name: "submittingTeam",
            label: (0, $79yHm.default).submittingTeamFieldLabel,
            placeholder: (0, $79yHm.default).submittingTeamPickerPlaceholder,
            cloudId: cloudId,
            orgId: orgId,
            value: formData.submittingTeam,
            onChange: (team)=>handleFormDataUpdate("submittingTeam", team),
            fieldId: "submitting-team-preview",
            isDisabled: buttonsDisabled,
            hideLabel: true,
            isCompact: true,
            appearance: "subtle"
        })));
        $[63] = buttonsDisabled;
        $[64] = cloudId;
        $[65] = formData.submittingTeam;
        $[66] = formatMessage;
        $[67] = orgId;
        $[68] = t29;
    } else t29 = $[68];
    let t30;
    if ($[69] !== buttonsDisabled || $[70] !== cloudId || $[71] !== formData.receivingTeam || $[72] !== formatMessage || $[73] !== orgId) {
        t30 = formData.receivingTeam && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
            label: formatMessage((0, $79yHm.default).receivingTeamFieldLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
            appearance: "control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5R7bA.TeamPickerField), {
            name: "receivingTeam",
            label: (0, $79yHm.default).receivingTeamFieldLabel,
            placeholder: (0, $79yHm.default).receivingTeamPickerPlaceholder,
            cloudId: cloudId,
            orgId: orgId,
            value: formData.receivingTeam,
            onChange: (team_0)=>handleFormDataUpdate("receivingTeam", team_0),
            fieldId: "receiving-team-preview",
            isDisabled: buttonsDisabled,
            hideLabel: true,
            isCompact: true,
            appearance: "subtle"
        })));
        $[69] = buttonsDisabled;
        $[70] = cloudId;
        $[71] = formData.receivingTeam;
        $[72] = formatMessage;
        $[73] = orgId;
        $[74] = t30;
    } else t30 = $[74];
    let t31;
    if ($[75] !== t21 || $[76] !== t24 || $[77] !== t28 || $[78] !== t29 || $[79] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, t21, t24, t28, t29, t30);
        $[75] = t21;
        $[76] = t24;
        $[77] = t28;
        $[78] = t29;
        $[79] = t30;
        $[80] = t31;
    } else t31 = $[80];
    let t32;
    if ($[81] !== t18 || $[82] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kwbC.PreviewSection), {
            title: t18
        }, t31);
        $[81] = t18;
        $[82] = t31;
        $[83] = t32;
    } else t32 = $[83];
    let t33;
    if ($[84] !== formatMessage) {
        t33 = formatMessage((0, $79yHm.default).descriptionFieldLabel);
        $[84] = formatMessage;
        $[85] = t33;
    } else t33 = $[85];
    let t34;
    if ($[86] !== formatMessage) {
        t34 = formatMessage((0, $79yHm.default).descriptionEditorPlaceholder);
        $[86] = formatMessage;
        $[87] = t34;
    } else t34 = $[87];
    let t35;
    if ($[88] !== buttonsDisabled || $[89] !== formData.description || $[90] !== t33 || $[91] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hfdnF.InlineEditorSection), {
            title: t33,
            placeholder: t34,
            value: formData.description,
            onConfirm: handleDescriptionChange,
            isDisabled: buttonsDisabled
        });
        $[88] = buttonsDisabled;
        $[89] = formData.description;
        $[90] = t33;
        $[91] = t34;
        $[92] = t35;
    } else t35 = $[92];
    let t36;
    if ($[93] !== formatMessage) {
        t36 = formatMessage((0, $79yHm.default).justificationFieldLabel);
        $[93] = formatMessage;
        $[94] = t36;
    } else t36 = $[94];
    let t37;
    if ($[95] !== formatMessage) {
        t37 = formatMessage((0, $79yHm.default).justificationEditorPlaceholder);
        $[95] = formatMessage;
        $[96] = t37;
    } else t37 = $[96];
    let t38;
    if ($[97] !== buttonsDisabled || $[98] !== formData.justification || $[99] !== t36 || $[100] !== t37) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hfdnF.InlineEditorSection), {
            title: t36,
            placeholder: t37,
            value: formData.justification,
            onConfirm: handleJustificationChange,
            isDisabled: buttonsDisabled
        });
        $[97] = buttonsDisabled;
        $[98] = formData.justification;
        $[99] = t36;
        $[100] = t37;
        $[101] = t38;
    } else t38 = $[101];
    let t39;
    if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
        t39 = (nextLinks)=>handleFormDataUpdate("links", nextLinks);
        $[102] = t39;
    } else t39 = $[102];
    let t40;
    if ($[103] !== buttonsDisabled || $[104] !== canEditLinks || $[105] !== formData.links || $[106] !== isLinksEditorOpen) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95hQj.FocusAskLinksSection), {
            links: formData.links,
            onChange: t39,
            isEditorOpen: isLinksEditorOpen,
            onEditorOpenChange: setIsLinksEditorOpen,
            canEdit: canEditLinks,
            isDisabled: buttonsDisabled
        });
        $[103] = buttonsDisabled;
        $[104] = canEditLinks;
        $[105] = formData.links;
        $[106] = isLinksEditorOpen;
        $[107] = t40;
    } else t40 = $[107];
    let t41;
    if ($[108] !== buttonsDisabled || $[109] !== cloudId || $[110] !== formData.impactedWork || $[111] !== formatMessage || $[112] !== shouldShowImpactedWorkField) {
        t41 = shouldShowImpactedWorkField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kwbC.PreviewSection), {
            title: formatMessage((0, $79yHm.default).impactedItemFieldLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fr9Wb.ImpactedWorkField), {
            value: formData.impactedWork,
            cloudId: cloudId,
            onValueChange: (value_5)=>handleFormDataUpdate("impactedWork", value_5),
            onResolutionStatusChange: setImpactedWorkStatus,
            isDisabled: buttonsDisabled,
            hideLabel: true
        }));
        $[108] = buttonsDisabled;
        $[109] = cloudId;
        $[110] = formData.impactedWork;
        $[111] = formatMessage;
        $[112] = shouldShowImpactedWorkField;
        $[113] = t41;
    } else t41 = $[113];
    let t42;
    if ($[114] !== formatMessage) {
        t42 = formatMessage((0, $79yHm.default).commentsSectionLabel);
        $[114] = formatMessage;
        $[115] = t42;
    } else t42 = $[115];
    let t43;
    if ($[116] !== currentUser.avatarUrl || $[117] !== currentUser.displayName) {
        t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            name: currentUser.displayName,
            src: currentUser.avatarUrl,
            size: "small"
        });
        $[116] = currentUser.avatarUrl;
        $[117] = currentUser.displayName;
        $[118] = t43;
    } else t43 = $[118];
    let t44;
    if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
        t44 = (value_6)=>handleFormDataUpdate("commentData", value_6);
        $[119] = t44;
    } else t44 = $[119];
    let t45;
    if ($[120] !== buttonsDisabled || $[121] !== formData.commentData) {
        t45 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27e1f53bad026cd3$var$styles.commentInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eEgoJ.CommentField), {
            value: formData.commentData,
            onChange: t44,
            fieldId: "comment-preview",
            hideLabel: true,
            isCompact: true,
            isDisabled: buttonsDisabled
        }));
        $[120] = buttonsDisabled;
        $[121] = formData.commentData;
        $[122] = t45;
    } else t45 = $[122];
    let t46;
    if ($[123] !== t43 || $[124] !== t45) {
        t46 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t43, t45);
        $[123] = t43;
        $[124] = t45;
        $[125] = t46;
    } else t46 = $[125];
    let t47;
    if ($[126] !== t42 || $[127] !== t46) {
        t47 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kwbC.PreviewSection), {
            title: t42
        }, t46);
        $[126] = t42;
        $[127] = t46;
        $[128] = t47;
    } else t47 = $[128];
    let t48;
    if ($[129] !== t17 || $[130] !== t32 || $[131] !== t35 || $[132] !== t38 || $[133] !== t40 || $[134] !== t41 || $[135] !== t47) {
        t48 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            xcss: $27e1f53bad026cd3$var$styles.fieldsWrapper
        }, t17, t32, t35, t38, t40, t41, t47);
        $[129] = t17;
        $[130] = t32;
        $[131] = t35;
        $[132] = t38;
        $[133] = t40;
        $[134] = t41;
        $[135] = t47;
        $[136] = t48;
    } else t48 = $[136];
    let t49;
    if ($[137] !== buttonsDisabled || $[138] !== formatMessage || $[139] !== handleConfirm || $[140] !== handleEditDetails || $[141] !== isActionFinished || $[142] !== isCreateButtonDisabled || $[143] !== isSubmitting) {
        t49 = !isActionFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27e1f53bad026cd3$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleEditDetails,
            isDisabled: buttonsDisabled
        }, formatMessage((0, $79yHm.default).refineButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: isCreateButtonDisabled,
            isLoading: isSubmitting
        }, formatMessage((0, $79yHm.default).createButton))));
        $[137] = buttonsDisabled;
        $[138] = formatMessage;
        $[139] = handleConfirm;
        $[140] = handleEditDetails;
        $[141] = isActionFinished;
        $[142] = isCreateButtonDisabled;
        $[143] = isSubmitting;
        $[144] = t49;
    } else t49 = $[144];
    const t50 = isModalOpen ? "focus-ask-modal-open" : "focus-ask-modal-closed";
    const t51 = isModalOpen && !buttonsDisabled ? formData : null;
    let t52;
    if ($[145] !== cloudId || $[146] !== handleModalSubmit || $[147] !== orgId || $[148] !== t50 || $[149] !== t51) {
        t52 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bHdyi.FocusAskCreateModal), {
            key: t50,
            data: t51,
            cloudId: cloudId,
            orgId: orgId,
            onClose: handleModalClose,
            onSubmit: handleModalSubmit
        });
        $[145] = cloudId;
        $[146] = handleModalSubmit;
        $[147] = orgId;
        $[148] = t50;
        $[149] = t51;
        $[150] = t52;
    } else t52 = $[150];
    let t53;
    if ($[151] !== t48 || $[152] !== t49 || $[153] !== t52) {
        t53 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6W6xO.FocusAskActionCardWrapper), null, t48, t49, t52);
        $[151] = t48;
        $[152] = t49;
        $[153] = t52;
        $[154] = t53;
    } else t53 = $[154];
    return t53;
} : ({ action: action, cloudId: cloudId, orgId: orgId, readonly: readonly = false, isActionFinished: isActionFinished = false, isSubmitting: isSubmitting = false, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [formData, setFormData] = (0, $cozmU.useState)(()=>{
        const data = (0, $iATgb.normalizeFocusAskPayload)(action.data);
        return {
            name: data.name,
            description: data.description ?? '',
            justification: data.justification ?? '',
            targetDate: data.targetDate,
            commentData: data.commentData,
            links: data.links,
            submitter: data.submitter,
            owner: data.owner,
            submittingTeam: data.submittingTeam,
            receivingTeam: data.receivingTeam,
            priority: data.priority,
            impactedWork: data.impactedWork ? {
                id: data?.impactedWork?.id ?? '',
                link: data?.impactedWork?.link ?? ''
            } : null
        };
    });
    const currentUser = (0, $isp1U.useProfileController)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [isLinksEditorOpen, setIsLinksEditorOpen] = (0, $cozmU.useState)(false);
    const [impactedWorkStatus, setImpactedWorkStatus] = (0, $cozmU.useState)(formData.impactedWork ? 'resolving' : 'idle');
    const isCardReadOnly = readonly || isActionFinished;
    const buttonsDisabled = isCardReadOnly || isSubmitting;
    const trimmedName = formData.name.trim();
    const isImpactedWorkBlockingCreate = impactedWorkStatus !== 'idle' && impactedWorkStatus !== 'resolved';
    const isCreateButtonDisabled = buttonsDisabled || !trimmedName || !formData.submitter?.id?.trim() || formData.name.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH) || isLinksEditorOpen || isImpactedWorkBlockingCreate;
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        if (isCreateButtonDisabled) return;
        onConfirm?.(action, {
            ...formData,
            name: trimmedName
        });
    }, [
        onConfirm,
        action,
        formData,
        trimmedName,
        isCreateButtonDisabled
    ]);
    const handleEditDetails = (0, $cozmU.useCallback)(()=>{
        if (buttonsDisabled) return;
        setIsModalOpen(true);
    }, [
        buttonsDisabled
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        setIsModalOpen(false);
    }, []);
    const handleModalSubmit = (0, $cozmU.useCallback)((updatedData)=>{
        if (buttonsDisabled) {
            setIsModalOpen(false);
            return;
        }
        setFormData(updatedData);
        setIsModalOpen(false);
        setIsLinksEditorOpen(false);
        setImpactedWorkStatus(updatedData.impactedWork ? 'resolving' : 'idle');
        onConfirm?.(action, updatedData);
    }, [
        onConfirm,
        action,
        buttonsDisabled
    ]);
    const handleNameChange = (0, $cozmU.useCallback)((value)=>{
        setFormData((prev)=>({
                ...prev,
                name: value
            }));
    }, []);
    const handleDescriptionChange = (0, $cozmU.useCallback)((value_0)=>{
        setFormData((prev_0)=>({
                ...prev_0,
                description: value_0
            }));
    }, []);
    const handleJustificationChange = (0, $cozmU.useCallback)((value_1)=>{
        setFormData((prev_1)=>({
                ...prev_1,
                justification: value_1
            }));
    }, []);
    const handleSubmitterChange = (0, $cozmU.useCallback)((user)=>{
        setFormData((prev_2)=>({
                ...prev_2,
                submitter: user
            }));
    }, []);
    const handleOwnerChange = (0, $cozmU.useCallback)((user_0)=>{
        setFormData((prev_3)=>({
                ...prev_3,
                owner: user_0
            }));
    }, []);
    const handleFormDataUpdate = (0, $cozmU.useCallback)((field, value_2)=>{
        setFormData((prev_4)=>({
                ...prev_4,
                [field]: value_2
            }));
    }, []);
    const canEditLinks = !buttonsDisabled;
    const shouldShowImpactedWorkField = Boolean(formData.impactedWork) || impactedWorkStatus !== 'idle';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6W6xO.FocusAskActionCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $27e1f53bad026cd3$var$styles.fieldsWrapper
    }, isCardReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "bold"
    }, formData.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
        isRequired: true,
        defaultValue: formData.name,
        editView: (fieldProps)=>{
            const isMissing = !fieldProps.value.trim();
            const isTooLong = fieldProps.value.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...fieldProps,
                isCompact: true,
                maxLength: (0, $gkWsQ.MAX_ASK_NAME_LENGTH),
                isInvalid: isMissing || isTooLong
            }), isMissing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).bulkMissingInfo)), !isMissing && isTooLong && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).nameFieldTooLong, {
                maxLength: (0, $gkWsQ.MAX_ASK_NAME_LENGTH)
            })));
        },
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "large",
                weight: "bold"
            }, formData.name),
        onConfirm: (value_3)=>{
            const nextName = value_3.trim();
            if (nextName && value_3.length <= (0, $gkWsQ.MAX_ASK_NAME_LENGTH)) handleNameChange(nextName);
        },
        readViewFitContainerWidth: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kwbC.PreviewSection), {
        title: formatMessage((0, $79yHm.default).detailsSectionLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
        label: formatMessage((0, $79yHm.default).submitterFieldLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
        appearance: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljAgM.UserPickerField), {
        name: "submitter",
        label: (0, $79yHm.default).submitterFieldLabel,
        placeholder: (0, $79yHm.default).submitterPickerPlaceholder,
        cloudId: cloudId,
        value: formData.submitter,
        onChange: handleSubmitterChange,
        isRequired: true,
        fieldId: "submitter-preview",
        isDisabled: buttonsDisabled,
        isClearable: false,
        hideLabel: true,
        isCompact: true,
        appearance: "subtle"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
        label: formatMessage((0, $79yHm.default).receiverFieldLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
        appearance: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljAgM.UserPickerField), {
        name: "owner",
        label: (0, $79yHm.default).receiverFieldLabel,
        placeholder: (0, $79yHm.default).receiverPickerPlaceholder,
        cloudId: cloudId,
        value: formData.owner,
        onChange: handleOwnerChange,
        fieldId: "owner-preview",
        isDisabled: buttonsDisabled,
        hideLabel: true,
        isCompact: true,
        appearance: "subtle"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
        label: formatMessage((0, $79yHm.default).priorityFieldLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
        appearance: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ewvjY.PriorityField), {
        value: formData.priority,
        onChange: (value_4)=>handleFormDataUpdate('priority', value_4),
        hideLabel: true,
        isCompact: true,
        appearance: "subtle",
        isDisabled: buttonsDisabled
    }))), formData.submittingTeam && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
        label: formatMessage((0, $79yHm.default).submittingTeamFieldLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
        appearance: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5R7bA.TeamPickerField), {
        name: "submittingTeam",
        label: (0, $79yHm.default).submittingTeamFieldLabel,
        placeholder: (0, $79yHm.default).submittingTeamPickerPlaceholder,
        cloudId: cloudId,
        orgId: orgId,
        value: formData.submittingTeam,
        onChange: (team)=>handleFormDataUpdate('submittingTeam', team),
        fieldId: "submitting-team-preview",
        isDisabled: buttonsDisabled,
        hideLabel: true,
        isCompact: true,
        appearance: "subtle"
    }))), formData.receivingTeam && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2rFc.DetailRow), {
        label: formatMessage((0, $79yHm.default).receivingTeamFieldLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e6Xa.CompactDetailValue), {
        appearance: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5R7bA.TeamPickerField), {
        name: "receivingTeam",
        label: (0, $79yHm.default).receivingTeamFieldLabel,
        placeholder: (0, $79yHm.default).receivingTeamPickerPlaceholder,
        cloudId: cloudId,
        orgId: orgId,
        value: formData.receivingTeam,
        onChange: (team_0)=>handleFormDataUpdate('receivingTeam', team_0),
        fieldId: "receiving-team-preview",
        isDisabled: buttonsDisabled,
        hideLabel: true,
        isCompact: true,
        appearance: "subtle"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hfdnF.InlineEditorSection), {
        title: formatMessage((0, $79yHm.default).descriptionFieldLabel),
        placeholder: formatMessage((0, $79yHm.default).descriptionEditorPlaceholder),
        value: formData.description,
        onConfirm: handleDescriptionChange,
        isDisabled: buttonsDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hfdnF.InlineEditorSection), {
        title: formatMessage((0, $79yHm.default).justificationFieldLabel),
        placeholder: formatMessage((0, $79yHm.default).justificationEditorPlaceholder),
        value: formData.justification,
        onConfirm: handleJustificationChange,
        isDisabled: buttonsDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95hQj.FocusAskLinksSection), {
        links: formData.links,
        onChange: (nextLinks)=>handleFormDataUpdate('links', nextLinks),
        isEditorOpen: isLinksEditorOpen,
        onEditorOpenChange: setIsLinksEditorOpen,
        canEdit: canEditLinks,
        isDisabled: buttonsDisabled
    }), shouldShowImpactedWorkField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kwbC.PreviewSection), {
        title: formatMessage((0, $79yHm.default).impactedItemFieldLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fr9Wb.ImpactedWorkField), {
        value: formData.impactedWork,
        cloudId: cloudId,
        onValueChange: (value_5)=>handleFormDataUpdate('impactedWork', value_5),
        onResolutionStatusChange: setImpactedWorkStatus,
        isDisabled: buttonsDisabled,
        hideLabel: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kwbC.PreviewSection), {
        title: formatMessage((0, $79yHm.default).commentsSectionLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        name: currentUser.displayName,
        src: currentUser.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27e1f53bad026cd3$var$styles.commentInput
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eEgoJ.CommentField), {
        value: formData.commentData,
        onChange: (value_6)=>handleFormDataUpdate('commentData', value_6),
        fieldId: "comment-preview",
        hideLabel: true,
        isCompact: true,
        isDisabled: buttonsDisabled
    }))))), !isActionFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27e1f53bad026cd3$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleEditDetails,
        isDisabled: buttonsDisabled
    }, formatMessage((0, $79yHm.default).refineButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: isCreateButtonDisabled,
        isLoading: isSubmitting
    }, formatMessage((0, $79yHm.default).createButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bHdyi.FocusAskCreateModal), {
        key: isModalOpen ? 'focus-ask-modal-open' : 'focus-ask-modal-closed',
        data: isModalOpen && !buttonsDisabled ? formData : null,
        cloudId: cloudId,
        orgId: orgId,
        onClose: handleModalClose,
        onSubmit: handleModalSubmit
    }));
};
module.exports["FocusAskCreateRenderer"] = $27e1f53bad026cd3$export$ac4ab90ccf684041;

});

parcelRegister("1WLQN", function(module, exports) {
/* BulkFocusAskCreateAction.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hlvTd = parcelRequire("hlvTd");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $bHdyi = parcelRequire("bHdyi");


var $lCyXM = parcelRequire("lCyXM");


var $gkWsQ = parcelRequire("gkWsQ");


var $6W6xO = parcelRequire("6W6xO");


var $lp8ZK = parcelRequire("lp8ZK");


var $79yHm = parcelRequire("79yHm");


var $6qd8M = parcelRequire("6qd8M");


var $k7N8F = parcelRequire("k7N8F");

const $249f0561d4f82eb0$var$styles = {
    footerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3"
};
const $249f0561d4f82eb0$var$MAX_ASKS_PER_REQUEST = 25;
const $249f0561d4f82eb0$var$MAX_CREATED_ASK_LINK_EXTRACTION_DEPTH = 5;
const $249f0561d4f82eb0$var$CREATED_ASK_LINK_KEYS = [
    'link',
    'url',
    'href',
    'webUrl'
];
const $249f0561d4f82eb0$var$CREATED_ASK_COLLECTION_KEYS = [
    'asks',
    'items',
    'results',
    'data',
    'message',
    'message_metadata',
    'actionOutput',
    'urls'
];
const $249f0561d4f82eb0$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $249f0561d4f82eb0$var$isCreateAskErrorResponse = (value)=>$249f0561d4f82eb0$var$isRecord(value) && (typeof value.statusCode === 'number' && value.statusCode >= 400 || typeof value.errorMessage === 'string' && value.errorMessage.length > 0 || Array.isArray(value.errors) && value.errors.length > 0);
const $249f0561d4f82eb0$var$extractCreatedAskLinkFromRecord = (value, depth = 0)=>{
    if (depth > $249f0561d4f82eb0$var$MAX_CREATED_ASK_LINK_EXTRACTION_DEPTH || !$249f0561d4f82eb0$var$isRecord(value)) return undefined;
    for (const key of $249f0561d4f82eb0$var$CREATED_ASK_LINK_KEYS){
        const candidate = value[key];
        if (typeof candidate === 'string' && candidate.trim()) return candidate;
        const nestedLink = $249f0561d4f82eb0$var$extractCreatedAskLinkFromRecord(candidate, depth + 1);
        if (nestedLink) return nestedLink;
    }
    return undefined;
};
const $249f0561d4f82eb0$var$extractCreatedAskLinks = (value, depth = 0)=>{
    if (depth > $249f0561d4f82eb0$var$MAX_CREATED_ASK_LINK_EXTRACTION_DEPTH) return [];
    if (Array.isArray(value)) return value.flatMap((entry)=>{
        if (typeof entry === 'string') {
            const trimmed = entry.trim();
            return trimmed ? [
                trimmed
            ] : [];
        }
        return $249f0561d4f82eb0$var$extractCreatedAskLinks(entry, depth + 1);
    });
    if (!$249f0561d4f82eb0$var$isRecord(value)) return [];
    const directLink = $249f0561d4f82eb0$var$extractCreatedAskLinkFromRecord(value, depth);
    if (directLink) return [
        directLink
    ];
    for (const key of $249f0561d4f82eb0$var$CREATED_ASK_COLLECTION_KEYS){
        const candidate = value[key];
        if (candidate && candidate !== value) {
            const nestedLinks = $249f0561d4f82eb0$var$extractCreatedAskLinks(candidate, depth + 1);
            if (nestedLinks.length > 0) return nestedLinks;
        }
    }
    return [];
};
const $249f0561d4f82eb0$export$e77fe8d81211116e = (props)=>{
    (0, $6cFsl.di)((0, $bHdyi.FocusAskCreateModal));
    const { actions: actions, cloudId: cloudId, orgId: orgId, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId, sendMessageConfirmedTools: sendMessageConfirmedTools } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const action = actions[0];
    const asks = (0, $cozmU.useMemo)(()=>(0, $lCyXM.extractAsks)(action?.data), [
        action
    ]);
    const state = (0, $k7N8F.useBulkFocusAskState)(action?.invocationId ?? '', asks);
    const { rows: rows, getFormData: getFormData, updateFormData: updateFormData, removedIds: removedIds, removeRow: removeRow, dismissAllRows: dismissAllRows } = state;
    const [isSubmittingBulk, setIsSubmittingBulk] = (0, $cozmU.useState)(false);
    const [bulkOutcome, setBulkOutcome] = (0, $cozmU.useState)('idle');
    const [createdLinksByRowId, setCreatedLinksByRowId] = (0, $cozmU.useState)({});
    const [requestErrorMessage, setRequestErrorMessage] = (0, $cozmU.useState)(null);
    const [editedRowId, setEditedRowId] = (0, $cozmU.useState)(null);
    const visibleRows = (0, $cozmU.useMemo)(()=>rows.filter((row)=>!removedIds.has(row.rowId)), [
        rows,
        removedIds
    ]);
    const platformStatus = action ? getStatus(action) : 'idle';
    const isErrored = bulkOutcome === 'error' || platformStatus === 'errored';
    const allRowsCreated = !isErrored && (bulkOutcome === 'success' || platformStatus === 'finished');
    const rowsPendingCreation = (0, $cozmU.useMemo)(()=>allRowsCreated ? [] : visibleRows, [
        allRowsCreated,
        visibleRows
    ]);
    const invalidRowIds = (0, $cozmU.useMemo)(()=>{
        const invalid = new Set();
        for (const row_0 of rowsPendingCreation){
            const formData = getFormData(row_0.rowId);
            const trimmedName = formData.name.trim();
            if (!trimmedName || trimmedName.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH)) invalid.add(row_0.rowId);
        }
        return invalid;
    }, [
        rowsPendingCreation,
        getFormData
    ]);
    const getRowStatus = (0, $cozmU.useCallback)((_rowId)=>{
        if (isErrored) return 'errored';
        if (allRowsCreated) return 'created';
        if (isSubmittingBulk || platformStatus === 'started') return 'submitting';
        return 'idle';
    }, [
        allRowsCreated,
        isErrored,
        isSubmittingBulk,
        platformStatus
    ]);
    const applyCreatedLinks = (0, $cozmU.useCallback)((createdLinks)=>{
        setCreatedLinksByRowId((current)=>{
            const next = {
                ...current
            };
            rowsPendingCreation.forEach((row_1, index)=>{
                const link = createdLinks[index];
                if (link) next[row_1.rowId] = link;
            });
            return next;
        });
    }, [
        rowsPendingCreation
    ]);
    const handleCreateAll = (0, $cozmU.useCallback)(async ()=>{
        if (!action || rowsPendingCreation.length === 0 || invalidRowIds.size > 0) return;
        setRequestErrorMessage(null);
        setBulkOutcome('idle');
        setIsSubmittingBulk(true);
        const mergedAsks = rowsPendingCreation.map((row_2)=>(0, $lp8ZK.mergeFocusAskFormIntoPayload)(row_2.originalAsk, getFormData(row_2.rowId)));
        const data = {
            asks: mergedAsks
        };
        try {
            if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
                const idleActions = actions.filter((action_0)=>getStatus(action_0) === 'idle');
                const callbackData = await sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: 'focusAskCreateAction'
                    },
                    confirmed_tools: {
                        message_id: messageId,
                        tools: idleActions.map((idleAction)=>idleAction.invocationId === action.invocationId ? (0, $7eUSO.buildToolFromAction)(idleAction, 'confirmed', data) : (0, $7eUSO.buildToolFromAction)(idleAction, 'cancelled'))
                    }
                });
                if ($249f0561d4f82eb0$var$isCreateAskErrorResponse(callbackData)) {
                    setBulkOutcome('error');
                    setRequestErrorMessage(formatMessage((0, $79yHm.default).bulkRequestFailedMessage));
                }
                return;
            }
            const callbackData_0 = await onCustomDataConfirm(action, data, $249f0561d4f82eb0$var$extractCreatedAskLinks);
            if ($249f0561d4f82eb0$var$isCreateAskErrorResponse(callbackData_0)) {
                setBulkOutcome('error');
                setRequestErrorMessage(formatMessage((0, $79yHm.default).bulkRequestFailedMessage));
                return;
            }
            applyCreatedLinks(Array.isArray(callbackData_0) ? callbackData_0 : []);
            setBulkOutcome('success');
        } catch (error) {
            setBulkOutcome('error');
            setRequestErrorMessage(formatMessage((0, $79yHm.default).bulkRequestFailedMessage));
            (0, $hlvTd.logException)({
                exception: error,
                name: 'BulkFocusAskCreateAction.onCustomDataConfirm.failed',
                tags: {
                    component: 'BulkFocusAskCreateAction',
                    invocationId: action.invocationId
                }
            });
        } finally{
            setIsSubmittingBulk(false);
        }
    }, [
        action,
        rowsPendingCreation,
        invalidRowIds,
        getFormData,
        actions,
        getStatus,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        onCustomDataConfirm,
        applyCreatedLinks,
        formatMessage
    ]);
    const showFooter = rowsPendingCreation.length > 0 && (bulkOutcome === 'idle' || bulkOutcome === 'error' || isSubmittingBulk);
    const totalCount = rowsPendingCreation.length;
    const editedRowFormData = editedRowId ? getFormData(editedRowId) : null;
    const createAllDisabled = allRowsCreated || isSubmittingBulk || rowsPendingCreation.length === 0 || invalidRowIds.size > 0 || totalCount > $249f0561d4f82eb0$var$MAX_ASKS_PER_REQUEST;
    const handleOpenEdit = (0, $cozmU.useCallback)((rowId)=>{
        setEditedRowId(rowId);
    }, []);
    const handleCloseEdit = (0, $cozmU.useCallback)(()=>{
        setEditedRowId(null);
    }, []);
    const handleEditSubmit = (0, $cozmU.useCallback)((formData_0)=>{
        if (!editedRowId) return;
        updateFormData(editedRowId, formData_0);
        setEditedRowId(null);
    }, [
        editedRowId,
        updateFormData
    ]);
    const handleRemoveRow = (0, $cozmU.useCallback)((rowId_0)=>{
        removeRow(rowId_0);
        setCreatedLinksByRowId((current_0)=>{
            const next_0 = {
                ...current_0
            };
            delete next_0[rowId_0];
            return next_0;
        });
        setEditedRowId((currentRowId)=>currentRowId === rowId_0 ? null : currentRowId);
    }, [
        removeRow
    ]);
    const handleDismissAll = (0, $cozmU.useCallback)(()=>{
        dismissAllRows();
        setEditedRowId(null);
    }, [
        dismissAllRows
    ]);
    const loadingSummary = isSubmittingBulk ? formatMessage((0, $79yHm.default).bulkProgressMessage) : undefined;
    const failureSummary = !isSubmittingBulk && bulkOutcome === 'error' ? formatMessage((0, $79yHm.default).bulkFailureMessage) : undefined;
    const successSummary = bulkOutcome === 'success' ? formatMessage((0, $79yHm.default).bulkSuccessMessage, {
        count: visibleRows.length
    }) : undefined;
    const validationSummary = invalidRowIds.size > 0 ? formatMessage((0, $79yHm.default).bulkValidationMessage, {
        count: invalidRowIds.size
    }) : undefined;
    const overLimitSummary = totalCount > $249f0561d4f82eb0$var$MAX_ASKS_PER_REQUEST ? formatMessage((0, $79yHm.default).bulkOverLimitMessage, {
        limit: $249f0561d4f82eb0$var$MAX_ASKS_PER_REQUEST
    }) : undefined;
    if (!action || visibleRows.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6W6xO.FocusAskActionCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "bulk-focus-ask-rows"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, visibleRows.map((row_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6qd8M.BulkFocusAskRow), {
            key: row_3.rowId,
            rowId: row_3.rowId,
            formData: getFormData(row_3.rowId),
            status: getRowStatus(row_3.rowId),
            createdLink: createdLinksByRowId[row_3.rowId],
            onEdit: handleOpenEdit,
            onRemove: handleRemoveRow
        })))), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), {
        testId: "bulk-focus-ask-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $249f0561d4f82eb0$var$styles.footerContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleDismissAll,
        isDisabled: isSubmittingBulk,
        testId: "bulk-focus-ask-dismiss-all"
    }, formatMessage((0, $79yHm.default).bulkDismissAllButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, loadingSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, loadingSummary) : null, successSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, successSummary) : null, failureSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, failureSummary) : null, validationSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, validationSummary) : null, overLimitSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, overLimitSummary) : null, requestErrorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, requestErrorMessage) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleCreateAll,
        isDisabled: createAllDisabled,
        isLoading: isSubmittingBulk,
        testId: "bulk-focus-ask-create-all"
    }, formatMessage((0, $79yHm.default).bulkCreateAllButton, {
        count: totalCount
    }))))), editedRowFormData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bHdyi.FocusAskCreateModal), {
        data: editedRowFormData,
        cloudId: cloudId,
        orgId: orgId,
        onClose: handleCloseEdit,
        onSubmit: handleEditSubmit,
        title: (0, $79yHm.default).bulkEditModalTitle,
        submitLabel: (0, $79yHm.default).bulkEditModalSubmitButton
    }));
};
module.exports["BulkFocusAskCreateAction"] = $249f0561d4f82eb0$export$e77fe8d81211116e;

});

parcelRegister("lCyXM", function(module, exports) {
/**
 * Extracts the `asks` array from an action payload, tolerating either the
 * canonical `{ asks: [...] }` shape or a legacy flat payload (treated as a
 * single-ask batch). Returns an empty array if nothing usable is present.
 */ const $935a4d1f38989871$export$9de86cccd0cecc3 = (data)=>{
    if (data && typeof data === 'object' && !Array.isArray(data)) {
        const asks = data.asks;
        if (Array.isArray(asks)) return asks;
        // Legacy fallback: the planner used to emit a flat single-ask payload.
        // Treat it as a 1-item batch so history replay still renders.
        return [
            data
        ];
    }
    return [];
};
module.exports["extractAsks"] = $935a4d1f38989871$export$9de86cccd0cecc3;

});

parcelRegister("lp8ZK", function(module, exports) {

var $hkGKX = parcelRequire("hkGKX");


var $7LV0V = parcelRequire("7LV0V");

/**
 * Builds the canonical `comments` array from the editable comment ADF string.
 * Returns an empty array when the user left it blank so the BE sees an empty
 * collection rather than a stale `[{ data: '' }]` entry.
 */ function $89615040b9792217$var$buildComments(commentData) {
    const trimmed = commentData.trim();
    return trimmed ? [
        {
            data: trimmed
        }
    ] : [];
}
/**
 * Builds the canonical `links` array from the editable links. Empty URL rows
 * are omitted; only writes `linkText` when present so the shape stays minimal.
 */ function $89615040b9792217$var$buildLinks(links) {
    return links.map((link)=>{
        const trimmedUrl = link.url.trim();
        const trimmedText = link.linkText?.trim() ?? '';
        if (!trimmedUrl) return null;
        return trimmedText ? {
            url: trimmedUrl,
            linkText: trimmedText
        } : {
            url: trimmedUrl
        };
    }).filter((link)=>Boolean(link));
}
function $89615040b9792217$export$251eb8bad4784a94(originalData, formData) {
    const base = typeof originalData === 'object' && originalData !== null && !Array.isArray(originalData) ? {
        ...originalData
    } : {};
    for (const key of [
        'submitterAccountId',
        'ownerAccountId',
        'submitter',
        'owner',
        'submittingTeam',
        'receivingTeam',
        'submitterId',
        'ownerId',
        'submittingTeamId',
        'receivingTeamId',
        // Legacy flat shape — superseded by `comments` / `links` arrays below.
        'commentData',
        'linkUrl',
        'linkText'
    ])delete base[key];
    const targetDateIso = (0, $7LV0V.parseStringToIsoDay)(formData.targetDate.targetDate);
    delete base.targetDateType;
    delete base.impactedItem;
    const result = {
        ...base,
        name: formData.name,
        description: formData.description,
        justification: formData.justification,
        ...targetDateIso ? {
            targetDate: {
                targetDate: targetDateIso,
                targetDateType: 'DAY'
            }
        } : {
            targetDate: null
        },
        comments: $89615040b9792217$var$buildComments(formData.commentData),
        links: $89615040b9792217$var$buildLinks(formData.links),
        priority: formData.priority,
        impactedWorkId: formData.impactedWork?.id ?? null,
        ...formData.submitter ? {
            submitterId: (0, $hkGKX.identityAriFromResourceId)(formData.submitter.id, 'user')
        } : {},
        ...formData.owner ? {
            ownerId: (0, $hkGKX.identityAriFromResourceId)(formData.owner.id, 'user')
        } : {},
        ...formData.submittingTeam ? {
            submittingTeamId: (0, $hkGKX.identityAriFromResourceId)(formData.submittingTeam.id, 'team')
        } : {},
        ...formData.receivingTeam ? {
            receivingTeamId: (0, $hkGKX.identityAriFromResourceId)(formData.receivingTeam.id, 'team')
        } : {}
    };
    return result;
}
module.exports["mergeFocusAskFormIntoPayload"] = $89615040b9792217$export$251eb8bad4784a94;

});

parcelRegister("iATgb", function(module, exports) {

var $hkGKX = parcelRequire("hkGKX");


var $7LV0V = parcelRequire("7LV0V");

const $d63d558d68a59dc8$var$PRIORITIES = [
    'LOW',
    'MEDIUM',
    'HIGH',
    'HIGHEST',
    'CRITICAL'
];
/**
 * Checks if a value is a valid Focus Ask priority.
 */ function $d63d558d68a59dc8$var$isFocusAskPriority(value) {
    return typeof value === 'string' && $d63d558d68a59dc8$var$PRIORITIES.includes(value);
}
/**
 * Picks a string field from an object by trying each key in order.
 */ function $d63d558d68a59dc8$var$pickStringField(o, keys) {
    for (const k of keys){
        const v = o[k];
        if (typeof v === 'string' && v.trim()) return v.trim();
    }
    return '';
}
/**
 * Extracts the impacted work ARI from a bot action payload.
 *
 * The bot may send the ARI in two shapes:
 *   - Flat:   `{ impactedWorkId: 'ari:...' }`
 *   - Nested: `{ impactedWork: { id: 'ari:...' } }`
 *
 * This helper handles both without modifying the shared `pickStringField` utility.
 */ function $d63d558d68a59dc8$var$normalizeImpactedWorkId(record) {
    // Flat key — e.g. impactedWorkId: 'ari:...'
    if (typeof record.impactedWorkId === 'string' && record.impactedWorkId.trim()) return record.impactedWorkId.trim();
    // Nested object — e.g. impactedWork: { id: 'ari:...' }
    const nested = record.impactedWork;
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
        const id = nested.id;
        if (typeof id === 'string' && id.trim()) return id.trim();
    }
    return '';
}
/**
 * Picks an optional URL field from an object.
 */ function $d63d558d68a59dc8$var$pickOptionalUrl(o, keys) {
    const s = $d63d558d68a59dc8$var$pickStringField(o, keys);
    return s || undefined;
}
/**
 * Returns the first object element of an unknown array, or `null` if the input
 * is not a non-empty array of objects. Used to peel the first entry off the
 * `comments` / `links` wire arrays so the form (which only edits one of each
 * today) can hydrate from index 0.
 */ function $d63d558d68a59dc8$var$firstObjectInArray(value) {
    if (!Array.isArray(value) || value.length === 0) return null;
    const first = value[0];
    if (first && typeof first === 'object' && !Array.isArray(first)) return first;
    return null;
}
/**
 * Reads the user-editable comment string from the action payload. The
 * canonical shape is `comments: [{ data: string }]`. A legacy flat
 * `commentData: string` field is also accepted so older messages still render.
 */ function $d63d558d68a59dc8$var$normalizeCommentData(data) {
    if (typeof data === 'string') return data.trim();
    if (data && typeof data === 'object') return JSON.stringify(data);
    return '';
}
function $d63d558d68a59dc8$var$normalizeComment(record) {
    const firstComment = $d63d558d68a59dc8$var$firstObjectInArray(record.comments);
    if (firstComment) {
        const normalized = $d63d558d68a59dc8$var$normalizeCommentData(firstComment.data);
        if (normalized) return normalized;
    }
    return $d63d558d68a59dc8$var$normalizeCommentData(record.commentData);
}
/**
 * Reads the related-link fields from the action payload. The canonical shape is
 * `links: [{ url: string, linkText?: string }]`. Legacy flat `linkUrl` /
 * `linkText` fields are also accepted so older messages still render.
 */ function $d63d558d68a59dc8$var$normalizeLinks(record) {
    if (Array.isArray(record.links)) return record.links.map((link)=>{
        if (!link || typeof link !== 'object' || Array.isArray(link)) return null;
        const linkRecord = link;
        const url = typeof linkRecord.url === 'string' ? linkRecord.url.trim() : '';
        const linkText = typeof linkRecord.linkText === 'string' ? linkRecord.linkText.trim() : '';
        if (!url) return null;
        return linkText ? {
            url: url,
            linkText: linkText
        } : {
            url: url
        };
    }).filter((link)=>Boolean(link));
    const url = typeof record.linkUrl === 'string' ? record.linkUrl.trim() : '';
    const linkText = typeof record.linkText === 'string' ? record.linkText.trim() : '';
    if (!url) return [];
    return linkText ? [
        {
            url: url,
            linkText: linkText
        }
    ] : [
        {
            url: url
        }
    ];
}
/**
 * Parses user / team ARI and returns ID.
 */ function $d63d558d68a59dc8$var$parseParticipantId(nested, record, fallbackKeys, resource) {
    if (typeof nested === 'string' && nested.trim()) return (0, $hkGKX.resourceIdFromIdentityAri)(nested.trim(), resource);
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
        const o = nested;
        const raw = typeof o.id === 'string' && o.id || typeof o.accountId === 'string' && o.accountId || typeof o.teamId === 'string' && o.teamId || typeof o.ari === 'string' && o.ari;
        if (raw) return (0, $hkGKX.resourceIdFromIdentityAri)(raw, resource);
    }
    for (const key of fallbackKeys){
        const v = record[key];
        if (typeof v === 'string' && v.trim()) return (0, $hkGKX.resourceIdFromIdentityAri)(v.trim(), resource);
    }
    return null;
}
/**
 * Parses the record and returns a FocusAskUserData.
 */ function $d63d558d68a59dc8$var$parseFocusAskUser(nested, record, fallbackKeys) {
    const id = $d63d558d68a59dc8$var$parseParticipantId(nested, record, fallbackKeys, 'user');
    if (!id) return null;
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
        const o = nested;
        const name = $d63d558d68a59dc8$var$pickStringField(o, [
            'name',
            'displayName',
            'publicName',
            'nickname'
        ]) || id;
        const avatarUrl = $d63d558d68a59dc8$var$pickOptionalUrl(o, [
            'avatarUrl',
            'avatar',
            'picture'
        ]);
        return avatarUrl ? {
            id: id,
            name: name,
            avatarUrl: avatarUrl
        } : {
            id: id,
            name: name
        };
    }
    return {
        id: id,
        name: id
    };
}
/**
 * Parses the record and returns a FocusAskTeamData.
 */ function $d63d558d68a59dc8$var$parseFocusAskTeam(nested, record, fallbackKeys) {
    const id = $d63d558d68a59dc8$var$parseParticipantId(nested, record, fallbackKeys, 'team');
    if (!id) return null;
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
        const o = nested;
        const name = $d63d558d68a59dc8$var$pickStringField(o, [
            'name',
            'displayName',
            'teamName',
            'title'
        ]) || id;
        const avatarUrl = $d63d558d68a59dc8$var$pickOptionalUrl(o, [
            'avatarUrl',
            'avatar',
            'picture'
        ]);
        return avatarUrl ? {
            id: id,
            name: name,
            avatarUrl: avatarUrl
        } : {
            id: id,
            name: name
        };
    }
    return {
        id: id,
        name: id
    };
}
function $d63d558d68a59dc8$export$98ce14ad7800be48(data) {
    if (!data || typeof data !== 'object') return {
        name: '',
        description: '',
        justification: '',
        targetDate: (0, $7LV0V.emptyFocusAskTargetDateValue)(),
        impactedWork: null,
        commentData: '',
        links: [],
        submitter: null,
        owner: null,
        submittingTeam: null,
        receivingTeam: null,
        priority: 'MEDIUM'
    };
    const record = data;
    const impactedWorkId = $d63d558d68a59dc8$var$normalizeImpactedWorkId(record);
    const links = $d63d558d68a59dc8$var$normalizeLinks(record);
    return {
        name: typeof record.name === 'string' ? record.name : '',
        description: typeof record.description === 'string' ? record.description : '',
        justification: typeof record.justification === 'string' ? record.justification : '',
        targetDate: (0, $7LV0V.parseRecordToFocusAskTargetDateValue)(record),
        impactedWork: impactedWorkId ? {
            id: impactedWorkId,
            link: ''
        } : null,
        commentData: $d63d558d68a59dc8$var$normalizeComment(record),
        links: links,
        submitter: $d63d558d68a59dc8$var$parseFocusAskUser(record.submitter, record, [
            'submitterId',
            'submitterAccountId',
            'submitterARI',
            'submitterAri'
        ]),
        owner: $d63d558d68a59dc8$var$parseFocusAskUser(record.owner, record, [
            'ownerId',
            'ownerAccountId',
            'ownerARI',
            'ownerAri'
        ]),
        submittingTeam: $d63d558d68a59dc8$var$parseFocusAskTeam(record.submittingTeam, record, [
            'submittingTeamId',
            'submittingTeamARI',
            'submittingTeamAri'
        ]),
        receivingTeam: $d63d558d68a59dc8$var$parseFocusAskTeam(record.receivingTeam, record, [
            'receivingTeamId',
            'receivingTeamARI',
            'receivingTeamAri'
        ]),
        priority: $d63d558d68a59dc8$var$isFocusAskPriority(record.priority) ? record.priority : 'MEDIUM'
    };
}
module.exports["normalizeFocusAskPayload"] = $d63d558d68a59dc8$export$98ce14ad7800be48;

});

parcelRegister("8eTnP", function(module, exports) {
const $f5e90eb22c1a9b60$export$6eaee8a5698db74c = '/jira/itam/ham';
module.exports["HARDWARE_ROUTE_PATH"] = $f5e90eb22c1a9b60$export$6eaee8a5698db74c;

});

parcelRegister("9zEp7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $847208378cc8adb5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    leadInText: {
        id: "conversation-assistant-message-actions.controllers.ham-onboarding-hardware-link.leadInText",
        defaultMessage: "Follow this link to start managing your hardware:"
    },
    hardwareLinkLabel: {
        id: "conversation-assistant-message-actions.controllers.ham-onboarding-hardware-link.hardwareLinkLabel",
        defaultMessage: "Jira Service Management: Hardware"
    }
});
module.exports["messages"] = $847208378cc8adb5$export$defe85febe8b728c;

});

parcelRegister("5wTq5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $dbec8de5b1bc295f$var$styles = {
    grid: "_3iDTPbgBM8 _2iEGP2cMcx _17lj8p8HPE _42d1HA2ADO",
    row: "_3iDTPbcK7c",
    value: "_1pJiFIHZdu"
};
const $dbec8de5b1bc295f$export$2d15a5345b03eb48 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, value: value } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, label));
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== value) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dbec8de5b1bc295f$var$styles.value
        }, value);
        $[2] = value;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dbec8de5b1bc295f$var$styles.row
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ label: label, value: value })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $dbec8de5b1bc295f$var$styles.row
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, label)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $dbec8de5b1bc295f$var$styles.value
    }, value));
const $dbec8de5b1bc295f$export$18e0706eef16795b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dbec8de5b1bc295f$var$styles.grid
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $dbec8de5b1bc295f$var$styles.grid
    }, children);
module.exports["EntityValueGridRow"] = $dbec8de5b1bc295f$export$2d15a5345b03eb48;
module.exports["EntityValueGrid"] = $dbec8de5b1bc295f$export$18e0706eef16795b;

});

parcelRegister("c8XPX", function(module, exports) {
function $339fcc8fe1695ab5$export$5a3af1f74a406208(issues, issueKey) {
    const issue = issues.find((issue)=>issue.issueKey === issueKey);
    return issue.ari;
}
const $339fcc8fe1695ab5$export$3ae94a2503e890a1 = (dateStr)=>{
    if (!dateStr) return undefined;
    try {
        return new Date(dateStr).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch  {
        return dateStr;
    }
};
module.exports["findIssueAri"] = $339fcc8fe1695ab5$export$5a3af1f74a406208;
module.exports["formatDate"] = $339fcc8fe1695ab5$export$3ae94a2503e890a1;

});

parcelRegister("UlvU3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8417e85c1b08b73f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.title",
        defaultMessage: "Create sprint"
    },
    nameLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.nameLabel",
        defaultMessage: "Name"
    },
    goalLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.goalLabel",
        defaultMessage: "Goal"
    },
    startDateLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.startDateLabel",
        defaultMessage: "Start date"
    },
    endDateLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.endDateLabel",
        defaultMessage: "End date"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.confirmButton",
        defaultMessage: "Confirm"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.controllers.jira-create-sprint.cancelButton",
        defaultMessage: "Cancel"
    }
});
module.exports["messages"] = $8417e85c1b08b73f$export$defe85febe8b728c;

});

parcelRegister("e3ecr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2uDbg = parcelRequire("2uDbg");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $l8wPz = parcelRequire("l8wPz");


var $gmy1e = parcelRequire("gmy1e");


var $f5acS = parcelRequire("f5acS");

const $c24a1b1a71a6efa7$export$2be3f69a068a20b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { initialIssues: initialIssues, initialSelectedIssues: initialSelectedIssues, title: title, isInitiallyExpanded: isInitiallyExpanded, epicKey: epicKey, selectedIssuesByEpic: selectedIssuesByEpic, onIssuesSelected: onIssuesSelected, readonly: t1 } = t0;
    const readonly = t1 === undefined ? false : t1;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(isInitiallyExpanded);
    const { issues: issues, selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, toggleIssue: toggleIssue, toggleIssues: toggleIssues } = (0, $f5acS.useSelectedIssues)(initialIssues, initialSelectedIssues);
    let t2;
    if ($[0] !== selectedIssuesByEpic) {
        t2 = Object.entries(selectedIssuesByEpic ?? {});
        $[0] = selectedIssuesByEpic;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== epicKey || $[3] !== t2) {
        t3 = t2.filter((t4)=>{
            const [key] = t4;
            return key !== epicKey;
        }).flatMap($c24a1b1a71a6efa7$var$_temp);
        $[2] = epicKey;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const selectedIssuesInOtherEpics = t3;
    let t4;
    if ($[5] !== selectedIssuesInOtherEpics) {
        t4 = selectedIssuesInOtherEpics ?? [];
        $[5] = selectedIssuesInOtherEpics;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== areAllIssuesSelected || $[8] !== t4) {
        t5 = areAllIssuesSelected(t4);
        $[7] = areAllIssuesSelected;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    const allIssuesSelected = t5;
    let t6;
    if ($[10] !== onIssuesSelected || $[11] !== selectedIssueKeys) {
        t6 = ()=>{
            onIssuesSelected?.(selectedIssueKeys);
        };
        $[10] = onIssuesSelected;
        $[11] = selectedIssueKeys;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== selectedIssueKeys) {
        t7 = [
            selectedIssueKeys
        ];
        $[13] = selectedIssueKeys;
        $[14] = t7;
    } else t7 = $[14];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[15] !== toggleIssue) {
        t8 = (issueKey)=>{
            toggleIssue(issueKey);
        };
        $[15] = toggleIssue;
        $[16] = t8;
    } else t8 = $[16];
    const handleCheckboxChange = t8;
    let t9;
    if ($[17] !== allIssuesSelected || $[18] !== issues || $[19] !== selectedIssuesInOtherEpics || $[20] !== toggleIssues) {
        t9 = ()=>{
            const issueKeysToToggle = selectedIssuesInOtherEpics ? Object.keys(issues).filter((issueKey_0)=>!selectedIssuesInOtherEpics.includes(issueKey_0)) : Object.keys(issues);
            toggleIssues(issueKeysToToggle, !allIssuesSelected);
        };
        $[17] = allIssuesSelected;
        $[18] = issues;
        $[19] = selectedIssuesInOtherEpics;
        $[20] = toggleIssues;
        $[21] = t9;
    } else t9 = $[21];
    const handleSelectAllCheckboxChange = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            setIsExpanded($c24a1b1a71a6efa7$var$_temp2);
        };
        $[22] = t10;
    } else t10 = $[22];
    const handleExpandCollapse = t10;
    let t11;
    if ($[23] !== handleCheckboxChange || $[24] !== issues || $[25] !== readonly || $[26] !== selectedIssuesInOtherEpics) {
        t11 = ()=>Object.entries(issues).map((t12)=>{
                const [issueKey_1, t13] = t12;
                const { url: url, isSelected: isSelected } = t13;
                const isDisabled = readonly || selectedIssuesInOtherEpics?.includes(issueKey_1);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    key: issueKey_1,
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                    "aria-label": issueKey_1,
                    isChecked: isSelected,
                    isDisabled: isDisabled,
                    onChange: ()=>handleCheckboxChange(issueKey_1),
                    testId: "issue-selector-issue-checkbox"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                    url: url,
                    appearance: "inline",
                    platform: "web",
                    showHoverPreview: true
                }));
            });
        $[23] = handleCheckboxChange;
        $[24] = issues;
        $[25] = readonly;
        $[26] = selectedIssuesInOtherEpics;
        $[27] = t11;
    } else t11 = $[27];
    const renderIssueList = t11;
    let t12;
    if ($[28] !== allIssuesSelected || $[29] !== initialIssues.length || $[30] !== selectedIssueKeys) {
        t12 = {
            selectedIssueKeys: selectedIssueKeys,
            areAllIssuesSelected: allIssuesSelected,
            totalIssueCount: initialIssues.length
        };
        $[28] = allIssuesSelected;
        $[29] = initialIssues.length;
        $[30] = selectedIssueKeys;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== handleSelectAllCheckboxChange || $[33] !== isExpanded || $[34] !== readonly || $[35] !== t12 || $[36] !== title) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmy1e.IssueSelectorHeader), {
            title: title,
            issueState: t12,
            isExpanded: isExpanded,
            isDisabled: readonly,
            handleExpandCollapse: handleExpandCollapse,
            handleSelectAllCheckboxChange: handleSelectAllCheckboxChange
        });
        $[32] = handleSelectAllCheckboxChange;
        $[33] = isExpanded;
        $[34] = readonly;
        $[35] = t12;
        $[36] = title;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== isExpanded || $[39] !== renderIssueList) {
        t14 = isExpanded && renderIssueList();
        $[38] = isExpanded;
        $[39] = renderIssueList;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== t13 || $[42] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t13, t14));
        $[41] = t13;
        $[42] = t14;
        $[43] = t15;
    } else t15 = $[43];
    return t15;
} : ({ initialIssues: initialIssues, initialSelectedIssues: initialSelectedIssues, title: title, isInitiallyExpanded: isInitiallyExpanded, epicKey: epicKey, selectedIssuesByEpic: selectedIssuesByEpic, onIssuesSelected: onIssuesSelected, readonly: readonly = false })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(isInitiallyExpanded);
    const { issues: issues, selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, toggleIssue: toggleIssue, toggleIssues: toggleIssues } = (0, $f5acS.useSelectedIssues)(initialIssues, initialSelectedIssues);
    const selectedIssuesInOtherEpics = (0, $cozmU.useMemo)(()=>{
        return Object.entries(selectedIssuesByEpic ?? {}).filter(([key])=>key !== epicKey).flatMap(([, selectedIssues])=>selectedIssues);
    }, [
        epicKey,
        selectedIssuesByEpic
    ]);
    const allIssuesSelected = areAllIssuesSelected(selectedIssuesInOtherEpics ?? []);
    (0, $cozmU.useEffect)(()=>{
        onIssuesSelected?.(selectedIssueKeys);
    // intentionally omit onIssuesSelected from dependencies, so don't force consumer to memoize
    }, [
        selectedIssueKeys
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const handleCheckboxChange = (0, $cozmU.useCallback)((issueKey)=>{
        toggleIssue(issueKey);
    }, [
        toggleIssue
    ]);
    const handleSelectAllCheckboxChange = ()=>{
        const issueKeysToToggle = selectedIssuesInOtherEpics ? Object.keys(issues).filter((issueKey_0)=>!selectedIssuesInOtherEpics.includes(issueKey_0)) : Object.keys(issues);
        toggleIssues(issueKeysToToggle, !allIssuesSelected);
    };
    const handleExpandCollapse = ()=>{
        setIsExpanded((prev)=>!prev);
    };
    const renderIssueList = ()=>{
        return Object.entries(issues).map(([issueKey_1, { url: url, isSelected: isSelected }])=>{
            const isDisabled = readonly || selectedIssuesInOtherEpics?.includes(issueKey_1);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                key: issueKey_1,
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                "aria-label": issueKey_1,
                isChecked: isSelected,
                // For cases where the issue selector is used in a multi-epic context (i.e. Suggest Epics goal)
                // checkboxes should be disabled for issues that are already selected in other epics.
                isDisabled: isDisabled,
                onChange: ()=>handleCheckboxChange(issueKey_1),
                testId: "issue-selector-issue-checkbox"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                url: url,
                appearance: "inline",
                platform: "web",
                showHoverPreview: true
            }));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmy1e.IssueSelectorHeader), {
        title: title,
        issueState: {
            selectedIssueKeys: selectedIssueKeys,
            areAllIssuesSelected: allIssuesSelected,
            totalIssueCount: initialIssues.length
        },
        isExpanded: isExpanded,
        isDisabled: readonly,
        handleExpandCollapse: handleExpandCollapse,
        handleSelectAllCheckboxChange: handleSelectAllCheckboxChange
    }), isExpanded && renderIssueList()));
};
const $c24a1b1a71a6efa7$export$c12ade3be856227 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { initialIssues: initialIssues, initialSelectedIssues: initialSelectedIssues, title: title, onIssuesSelected: onIssuesSelected, readonly: t1 } = t0;
    const readonly = t1 === undefined ? false : t1;
    const { issues: issues, selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, toggleIssue: toggleIssue, toggleIssues: toggleIssues } = (0, $f5acS.useSelectedIssues)(initialIssues, initialSelectedIssues);
    let t2;
    if ($[0] !== issues) {
        t2 = Object.entries(issues).filter($c24a1b1a71a6efa7$var$_temp3).map($c24a1b1a71a6efa7$var$_temp4);
        $[0] = issues;
        $[1] = t2;
    } else t2 = $[1];
    const readonlyAndNonSelectedIssues = t2;
    let t3;
    if ($[2] !== issues) {
        t3 = Object.entries(issues).filter($c24a1b1a71a6efa7$var$_temp5).map($c24a1b1a71a6efa7$var$_temp6);
        $[2] = issues;
        $[3] = t3;
    } else t3 = $[3];
    const nonReadonlyIssues = t3;
    let t4;
    if ($[4] !== issues) {
        t4 = Object.keys(issues);
        $[4] = issues;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== issues || $[7] !== t4) {
        t5 = t4.filter((issueKey)=>issues[issueKey].isSelected && !issues[issueKey].readonly);
        $[6] = issues;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const nonReadOnlySelectedIssueKeys = t5;
    let t6;
    if ($[9] !== areAllIssuesSelected || $[10] !== readonlyAndNonSelectedIssues) {
        t6 = areAllIssuesSelected(readonlyAndNonSelectedIssues);
        $[9] = areAllIssuesSelected;
        $[10] = readonlyAndNonSelectedIssues;
        $[11] = t6;
    } else t6 = $[11];
    const allIssuesSelected = t6;
    let t7;
    if ($[12] !== initialIssues) {
        t7 = initialIssues.filter($c24a1b1a71a6efa7$var$_temp7);
        $[12] = initialIssues;
        $[13] = t7;
    } else t7 = $[13];
    const totalIssueCount = t7.length;
    let t8;
    if ($[14] !== onIssuesSelected || $[15] !== selectedIssueKeys) {
        t8 = ()=>{
            onIssuesSelected?.(selectedIssueKeys);
        };
        $[14] = onIssuesSelected;
        $[15] = selectedIssueKeys;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== selectedIssueKeys) {
        t9 = [
            selectedIssueKeys
        ];
        $[17] = selectedIssueKeys;
        $[18] = t9;
    } else t9 = $[18];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[19] !== toggleIssue) {
        t10 = (issueKey_0)=>{
            toggleIssue(issueKey_0);
        };
        $[19] = toggleIssue;
        $[20] = t10;
    } else t10 = $[20];
    const handleCheckboxChange = t10;
    let t11;
    if ($[21] !== allIssuesSelected || $[22] !== nonReadonlyIssues || $[23] !== toggleIssues) {
        t11 = ()=>{
            toggleIssues(nonReadonlyIssues, !allIssuesSelected);
        };
        $[21] = allIssuesSelected;
        $[22] = nonReadonlyIssues;
        $[23] = toggleIssues;
        $[24] = t11;
    } else t11 = $[24];
    const handleSelectAllCheckboxChange = t11;
    let t12;
    if ($[25] !== handleCheckboxChange || $[26] !== issues) {
        t12 = ()=>{
            const hasReadonlyUnselectedIssue = Object.values(issues).some($c24a1b1a71a6efa7$var$_temp8);
            const isResumptionMigrationEnabled = hasReadonlyUnselectedIssue && (0, $cXtTj.default).getExperimentValue("rovo_tools_resumption_migration_exp", "isEnabled", false);
            return Object.entries(issues).map((t13)=>{
                const [issueKey_1, t14] = t13;
                const { url: url, isSelected: isSelected_0, readonly: issueIsReadonly } = t14;
                const isDisabled = issueIsReadonly;
                const isChecked = isResumptionMigrationEnabled ? isSelected_0 : isDisabled || isSelected_0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    key: issueKey_1,
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                    "aria-label": issueKey_1,
                    isChecked: isChecked,
                    isDisabled: isDisabled,
                    onChange: ()=>handleCheckboxChange(issueKey_1),
                    testId: "issue-selector-issue-checkbox"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                    url: url,
                    appearance: "inline",
                    platform: "web",
                    showHoverPreview: true
                }));
            });
        };
        $[25] = handleCheckboxChange;
        $[26] = issues;
        $[27] = t12;
    } else t12 = $[27];
    const renderIssueList = t12;
    let t13;
    if ($[28] !== allIssuesSelected || $[29] !== nonReadOnlySelectedIssueKeys || $[30] !== totalIssueCount) {
        t13 = {
            selectedIssueKeys: nonReadOnlySelectedIssueKeys,
            areAllIssuesSelected: allIssuesSelected,
            totalIssueCount: totalIssueCount
        };
        $[28] = allIssuesSelected;
        $[29] = nonReadOnlySelectedIssueKeys;
        $[30] = totalIssueCount;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== handleSelectAllCheckboxChange || $[33] !== readonly || $[34] !== t13 || $[35] !== title) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmy1e.BulkIssueSelectorHeader), {
            title: title,
            issueState: t13,
            isDisabled: readonly,
            handleSelectAllCheckboxChange: handleSelectAllCheckboxChange
        });
        $[32] = handleSelectAllCheckboxChange;
        $[33] = readonly;
        $[34] = t13;
        $[35] = title;
        $[36] = t14;
    } else t14 = $[36];
    let t15;
    if ($[37] !== renderIssueList) {
        t15 = renderIssueList();
        $[37] = renderIssueList;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== t14 || $[40] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t14, t15));
        $[39] = t14;
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    return t16;
} : ({ initialIssues: initialIssues, initialSelectedIssues: initialSelectedIssues, title: title, onIssuesSelected: onIssuesSelected, readonly: readonly = false })=>{
    const { issues: issues, selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, toggleIssue: toggleIssue, toggleIssues: toggleIssues } = (0, $f5acS.useSelectedIssues)(initialIssues, initialSelectedIssues);
    const readonlyAndNonSelectedIssues = (0, $cozmU.useMemo)(()=>{
        return Object.entries(issues).filter(([_, issue])=>issue.readonly && !issue.isSelected).map(([key])=>key);
    }, [
        issues
    ]);
    const nonReadonlyIssues = (0, $cozmU.useMemo)(()=>{
        return Object.entries(issues).filter(([__0, issue_0])=>!issue_0.readonly).map(([key_0])=>key_0);
    }, [
        issues
    ]);
    const nonReadOnlySelectedIssueKeys = (0, $cozmU.useMemo)(()=>Object.keys(issues).filter((issueKey)=>issues[issueKey].isSelected && !issues[issueKey].readonly), [
        issues
    ]);
    const allIssuesSelected = areAllIssuesSelected(readonlyAndNonSelectedIssues);
    const totalIssueCount = initialIssues.filter((issue_1)=>!issue_1.readonly).length;
    (0, $cozmU.useEffect)(()=>{
        onIssuesSelected?.(selectedIssueKeys);
    // intentionally omit onIssuesSelected from dependencies, so don't force consumer to memoize
    }, [
        selectedIssueKeys
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const handleCheckboxChange = (0, $cozmU.useCallback)((issueKey_0)=>{
        toggleIssue(issueKey_0);
    }, [
        toggleIssue
    ]);
    const handleSelectAllCheckboxChange = ()=>{
        toggleIssues(nonReadonlyIssues, !allIssuesSelected);
    };
    const renderIssueList = ()=>{
        const hasReadonlyUnselectedIssue = Object.values(issues).some(({ isSelected: isSelected, readonly: readonly_0 })=>readonly_0 && !isSelected);
        const isResumptionMigrationEnabled = hasReadonlyUnselectedIssue && (0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false);
        return Object.entries(issues).map(([issueKey_1, { url: url, isSelected: isSelected_0, readonly: issueIsReadonly }])=>{
            const isDisabled = issueIsReadonly;
            const isChecked = isResumptionMigrationEnabled ? isSelected_0 : isDisabled || isSelected_0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                key: issueKey_1,
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                "aria-label": issueKey_1,
                isChecked: isChecked,
                // For cases where the issue selector is used in a multi-epic context (i.e. Suggest Epics goal)
                // checkboxes should be disabled for issues that are already selected in other epics.
                isDisabled: isDisabled,
                onChange: ()=>handleCheckboxChange(issueKey_1),
                testId: "issue-selector-issue-checkbox"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                url: url,
                appearance: "inline",
                platform: "web",
                showHoverPreview: true
            }));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmy1e.BulkIssueSelectorHeader), {
        title: title,
        issueState: {
            selectedIssueKeys: nonReadOnlySelectedIssueKeys,
            areAllIssuesSelected: allIssuesSelected,
            totalIssueCount: totalIssueCount
        },
        isDisabled: readonly,
        handleSelectAllCheckboxChange: handleSelectAllCheckboxChange
    }), renderIssueList()));
};
function $c24a1b1a71a6efa7$var$_temp(t0) {
    const [, selectedIssues] = t0;
    return selectedIssues;
}
function $c24a1b1a71a6efa7$var$_temp2(prev) {
    return !prev;
}
function $c24a1b1a71a6efa7$var$_temp3(t0) {
    const [, issue] = t0;
    return issue.readonly && !issue.isSelected;
}
function $c24a1b1a71a6efa7$var$_temp4(t0) {
    const [key] = t0;
    return key;
}
function $c24a1b1a71a6efa7$var$_temp5(t0) {
    const [, issue_0] = t0;
    return !issue_0.readonly;
}
function $c24a1b1a71a6efa7$var$_temp6(t0) {
    const [key_0] = t0;
    return key_0;
}
function $c24a1b1a71a6efa7$var$_temp7(issue_1) {
    return !issue_1.readonly;
}
function $c24a1b1a71a6efa7$var$_temp8(t0) {
    const { isSelected: isSelected, readonly: readonly_0 } = t0;
    return readonly_0 && !isSelected;
}
module.exports["IssueSelector"] = $c24a1b1a71a6efa7$export$2be3f69a068a20b0;
module.exports["BulkIssueSelector"] = $c24a1b1a71a6efa7$export$c12ade3be856227;

});

parcelRegister("gK83Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $haiCi = parcelRequire("haiCi");


var $6jcZN = parcelRequire("6jcZN");

const $fae225e86e789492$export$11734d36b0d66cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBulkAssignIssuesToEpic() {
    const $ = (0, $bDgLe.c)(3);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = async (selectedIssuesByEpic, cloudId)=>{
            setLoading(true);
            const assignOperations = Object.entries(selectedIssuesByEpic).map(async (t1)=>{
                const [epicIssueKey, issueAris] = t1;
                const taskId = await $fae225e86e789492$var$submitBulkAssignOperation(issueAris, epicIssueKey, cloudId);
                const poll = async (startTime)=>{
                    const isCompleted = await $fae225e86e789492$var$getBulkAssignProgress(cloudId, taskId, epicIssueKey);
                    if (!isCompleted && Date.now() - startTime < (0, $6jcZN.POLL_TIMEOUT_MS)) setTimeout(()=>poll(startTime), (0, $6jcZN.POLL_INTERVAL_MS));
                    else if (isCompleted) setLoading(false);
                };
                const startTime_0 = Date.now();
                await poll(startTime_0);
            });
            await Promise.all(assignOperations);
            setLoading(false);
            return true;
        };
        $[0] = t0;
    } else t0 = $[0];
    const initiateBulkOperation = t0;
    let t1;
    if ($[1] !== loading) {
        t1 = {
            loading: loading,
            initiateBulkOperation: initiateBulkOperation
        };
        $[1] = loading;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function useBulkAssignIssuesToEpic() {
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const initiateBulkOperation = (0, $cozmU.useCallback)(async (selectedIssuesByEpic, cloudId)=>{
        setLoading(true);
        const assignOperations = Object.entries(selectedIssuesByEpic).map(async ([epicIssueKey, issueAris])=>{
            const taskId = await $fae225e86e789492$var$submitBulkAssignOperation(issueAris, epicIssueKey, cloudId);
            const poll = async (startTime)=>{
                const isCompleted = await $fae225e86e789492$var$getBulkAssignProgress(cloudId, taskId, epicIssueKey);
                if (!isCompleted && Date.now() - startTime < (0, $6jcZN.POLL_TIMEOUT_MS)) setTimeout(()=>poll(startTime), (0, $6jcZN.POLL_INTERVAL_MS));
                else if (isCompleted) setLoading(false);
            };
            const startTime_0 = Date.now();
            await poll(startTime_0);
        });
        await Promise.all(assignOperations);
        setLoading(false);
        return true;
    }, []);
    return {
        loading: loading,
        initiateBulkOperation: initiateBulkOperation
    };
};
async function $fae225e86e789492$var$submitBulkAssignOperation(issueAris, epicIssueKey, cloudId) {
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: (0, $6jcZN.BulkAssignIssuesQuery),
        variables: {
            cloudId: cloudId,
            input: {
                bulkOperationType: 'BULK_EDIT',
                bulkOperationInput: {
                    bulkEditInput: {
                        selectedActions: [
                            'parent'
                        ],
                        selectedIssueIds: issueAris,
                        editedFieldsInput: {
                            parentField: {
                                issueId: epicIssueKey
                            }
                        }
                    }
                }
            }
        }
    });
    return response.data.jira.submitBulkOperation.progress.taskId;
}
async function $fae225e86e789492$var$getBulkAssignProgress(cloudId, taskId, epicIssueKey) {
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: (0, $6jcZN.BulkOperationProgressGraphQuery),
        variables: {
            cloudId: cloudId,
            taskId: taskId
        }
    });
    const progress = response.data.jira.bulkOperationProgress;
    if (!progress) throw new Error(`An unexpected error occurred while bulk assigning issues to epic ${epicIssueKey}`);
    else if (progress.status === 'COMPLETE') return Promise.resolve(true);
    else if (progress.failedAccessibleIssues && progress.failedAccessibleIssues.edges.length > 0) {
        const failedIssueKeys = progress.failedAccessibleIssues.edges.map((edge)=>edge.node.issue.key);
        const numberOfFailedIssues = failedIssueKeys.length;
        throw new Error(`Failed to assign ${numberOfFailedIssues} issues to epic ${epicIssueKey}: ${failedIssueKeys.join(', ')}`);
    }
    return Promise.resolve(false);
}
async function $fae225e86e789492$export$37debc2a346b7376({ projectId: projectId, issueTypeId: issueTypeId, summary: summary, description: description, assignee: assignee }) {
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: (0, $6jcZN.CreateJiraIssueQuery),
        variables: {
            input: {
                projectId: projectId,
                issueTypeId: issueTypeId,
                fields: {
                    singleLineTextFields: [
                        {
                            fieldId: 'summary',
                            text: summary
                        }
                    ],
                    ...assignee ? {
                        singleSelectUserPickerFields: [
                            {
                                fieldId: 'assignee',
                                user: {
                                    accountId: assignee
                                }
                            }
                        ]
                    } : {},
                    richTextFields: [
                        {
                            fieldId: 'description',
                            richText: {
                                wikiText: description
                            }
                        }
                    ]
                }
            }
        }
    });
    return {
        issueKey: response.data.jira.createIssue.issue?.key ?? null,
        issueUrl: response.data.jira.createIssue.issue?.webUrl ?? null
    };
}
module.exports["useBulkAssignIssuesToEpic"] = $fae225e86e789492$export$11734d36b0d66cbb;

});

parcelRegister("1hB0U", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $cb008adecb5bd419$var$message = (0, $kSwu1.defineMessages)({
    jiraEpicAssignButton: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-epic-assign-button",
        defaultMessage: "Add selected issues to {epicCount, plural, one {epic} other {epics}}"
    },
    jiraEpicSuggestTitleIssues: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-epic-suggest-title-issues",
        defaultMessage: "I found {count} {count, plural, one {issue that doesn\u2019t have a parent issue} other {issues that don\u2019t have parent issues}}, {andEpics}"
    },
    jiraEpicSuggestTitleAndEpics: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-epic-suggest-title-and-epics",
        defaultMessage: "and {count, plural, one {an epic} other {some epics}} we could link them to."
    },
    jiraEpicAssignButtonIssueTermRefresh: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-epic-assign-button-issue-term-refresh",
        defaultMessage: "Add selected work items to {epicCount, plural, one {epic} other {epics}}"
    },
    jiraIssuesDropdownTitleText: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issues-dropdown-title-text",
        defaultMessage: "Select work items to add to epic"
    },
    jiraEpicSuggestSubtitleText: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-epic-suggest-subtitle-text",
        defaultMessage: "Select the work items you want to add to {epicsCount, plural, one {this epic} other {these epics}}:"
    },
    jiraEpicSuggestActionCardTitle: {
        id: "ai-mate.message-actions.jira-epics-suggest.action-card-title",
        defaultMessage: "Assign work items to epics"
    },
    jiraAssignIssueSuccessMessageText: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-assign-issue-success-message-text",
        defaultMessage: "OK, I've added those work items to {totalEpics, plural, one {this epic} other {these epics}}:\\n{epicLinks}"
    },
    jiraBulkAssignIssueUnexpectedErrorMessageText: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-bulk-assign-issue-unexpected-error-message-text",
        defaultMessage: "Something went wrong while assigning work items to epics."
    },
    jiraAssignIssueErrorMessageText: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-assign-issue-error-message-text",
        defaultMessage: "Please select at least one work item to assign."
    }
});
var $cb008adecb5bd419$export$2e2bcd8739ae039 = $cb008adecb5bd419$var$message;
module.exports["default"] = $cb008adecb5bd419$export$2e2bcd8739ae039;

});

parcelRegister("lo1na", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6eff2e11da52b139$var$_default_1 = (0, $kSwu1.defineMessages)({
    jiraIssueAssignSelectIssuesTitle: {
        id: "ai-mate.message-actions.jira-issue-assign.select-issues-title",
        defaultMessage: "Select all work items"
    },
    jiraIssueAssignUpdateSelectedIssues: {
        id: "ai-mate.message-actions.jira-issue-assign.update-selected-issues",
        defaultMessage: "Assign selected work items"
    },
    jiraIssueAssignTitle: {
        id: "ai-mate.message-actions.jira-issue-assign.title",
        defaultMessage: "Here are the tickets you asked for. Choose the ones you'd like to assign, then select the assign button."
    },
    jiraIssueAssignActionCardTitle: {
        id: "ai-mate.message-actions.jira-issue-assign.action-card-title",
        defaultMessage: "Assign work items"
    },
    jiraIssueAssigneeTitle: {
        id: "ai-mate.message-actions.jira-issue-assign.assignee-title",
        defaultMessage: "Assignee"
    },
    jiraBulkIssueAssignErrorMessage: {
        id: "ai-mate.message-actions.jira-issue-assign.bulk-issue-assign-error-message",
        defaultMessage: "Something went wrong while assigning the work item."
    },
    jiraIssueAssignCancel: {
        id: "ai-mate.message-actions.jira-issue-assign.cancel",
        defaultMessage: "Cancel"
    }
});
var $6eff2e11da52b139$export$2e2bcd8739ae039 = $6eff2e11da52b139$var$_default_1;
module.exports["default"] = $6eff2e11da52b139$export$2e2bcd8739ae039;

});

parcelRegister("418I8", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fd30d79c3a1eafc2$var$message = (0, $kSwu1.defineMessages)({
    jiraIssueDeleteModalDialogCancelButton: {
        id: "jira-issue-delete.modal-dialog.cancel-button",
        defaultMessage: "Cancel"
    },
    jiraIssueDeleteModalDialogConfirmButton: {
        id: "jira-issue-delete.modal-dialog.confirm-button",
        defaultMessage: "Confirm"
    },
    jiraIssueDeleteButtonLabelText: {
        id: "jira-issue-delete.button.label-text",
        defaultMessage: "Delete selected work items"
    },
    jiraIssueDeleteButtonErrorMessageText: {
        id: "jira-issue-delete.button.error-message-text",
        defaultMessage: "Select at least one work item to delete"
    },
    jiraIssueDeleteModalDialogBodyText: {
        id: "jira-issue-delete.modal-dialog.body-text",
        defaultMessage: "Once you delete a Jira work item, it can't be recovered. Make sure you've carefully checked the work item{s} you're about to delete."
    },
    jiraIssueDeleteModalDialogTitleText: {
        id: "jira-issue-delete.modal-dialog.title-text",
        defaultMessage: "Delete work items"
    },
    jiraIssueDeleteListTitleText: {
        id: "jira-issue-delete.list-title-text",
        defaultMessage: "Select all work items"
    },
    jiraIssueDeleteActionCardTitle: {
        id: "jira-issue-delete.action-card-title",
        defaultMessage: "Delete work items"
    }
});
var $fd30d79c3a1eafc2$export$2e2bcd8739ae039 = $fd30d79c3a1eafc2$var$message;
module.exports["default"] = $fd30d79c3a1eafc2$export$2e2bcd8739ae039;

});

parcelRegister("i4ehy", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bb3bfdbb157715ef$var$message = (0, $kSwu1.defineMessages)({
    jiraIssueMoveListMessageText: {
        id: "jira-issue-move.list-message-text",
        defaultMessage: "Select the work items you want to move to a sprint:"
    },
    jiraIssueMoveButtonLabelText: {
        id: "jira-issue-move.button.move-label-text",
        defaultMessage: "Move selected work items to sprint"
    },
    jiraIssueMoveButtonErrorMessageText: {
        id: "jira-issue-move.button.error-message-text",
        defaultMessage: "Select at least one work item and one sprint to move"
    },
    jiraIssueMoveSprintSelectorText: {
        id: "jira-issue-move.sprint-selector.message-text",
        defaultMessage: "Select the sprint you want to move these work items into:"
    },
    jiraIssueMoveListTitleText: {
        id: "jira-issue-move.list-title-text",
        defaultMessage: "Select all"
    },
    jiraIssueMoveActionCardTitle: {
        id: "jira-issue-move.action-card-title",
        defaultMessage: "Move work items"
    }
});
var $bb3bfdbb157715ef$export$2e2bcd8739ae039 = $bb3bfdbb157715ef$var$message;
module.exports["default"] = $bb3bfdbb157715ef$export$2e2bcd8739ae039;

});

parcelRegister("d6lfC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1a9d7c2bbaf16442$var$_default_1 = (0, $kSwu1.defineMessages)({
    jiraIssueTransitionTitle: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.title",
        defaultMessage: "Here are the tickets that you asked for. Choose the ones you'd like to update, then select the update button."
    },
    jiraIssueTransitionSelectIssuesTitle: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.select-issues-title",
        defaultMessage: "Select all work items"
    },
    jiraIssueTransitionUpdateSelectedIssues: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.update-selected-issues",
        defaultMessage: "Update selected work items"
    },
    jiraIssueTransitionStatusTitle: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.status-title",
        defaultMessage: "Status"
    },
    jiraBulkIssueTransitionErrorMessage: {
        id: "ai-mate.message-actions.jira-issue-transition.bulk-issue-transition-error-message",
        defaultMessage: "Something went wrong while transitioning the work item."
    },
    jiraIssueTransitionActionCardTitle: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.action-card-title",
        defaultMessage: "Update selected work items"
    },
    jiraIssueTransitionCancel: {
        id: "ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.cancel",
        defaultMessage: "Cancel"
    }
});
var $1a9d7c2bbaf16442$export$2e2bcd8739ae039 = $1a9d7c2bbaf16442$var$_default_1;
module.exports["default"] = $1a9d7c2bbaf16442$export$2e2bcd8739ae039;

});

parcelRegister("4gYQi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $haiCi = parcelRequire("haiCi");

const $78eb7b4323ec0809$var$styles = {
    customControl: "_39xV02N91d"
};
const $78eb7b4323ec0809$export$e7db4b994264bbd3 = `
query GetStatuses($issueAris: [ID!]!) {
  jira {
    content: jiraFetchBulkOperationDetails(issueIds: $issueAris) @optIn(to: "JiraFetchBulkOperationDetailsResponse") {
      bulkTransitions(first: 100) {
        edges {
          node {
            transitions {
              edges {
                node {
                  id
                  transitionId
                  name
                  hasPreConditions
                  to {
                    id
                    name
                    statusId
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
const $78eb7b4323ec0809$export$3d9e9879f6c264e4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { issueAris: issueAris, setSelectedTransition: setSelectedTransition, selectedTransition: selectedTransition, isDisabled: isDisabled, defaultTransitionId: defaultTransitionId } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] !== defaultTransitionId || $[1] !== issueAris || $[2] !== setSelectedTransition) {
        t1 = async ()=>{
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $78eb7b4323ec0809$export$e7db4b994264bbd3,
                variables: {
                    issueAris: issueAris
                }
            });
            const transitions = response.data.jira.content.bulkTransitions?.edges?.flatMap($78eb7b4323ec0809$var$_temp2).filter($78eb7b4323ec0809$var$_temp3) || [];
            const selectedTransition_0 = transitions.find((transition)=>transition.value === defaultTransitionId);
            if (selectedTransition_0) setSelectedTransition(selectedTransition_0);
            return transitions;
        };
        $[0] = defaultTransitionId;
        $[1] = issueAris;
        $[2] = setSelectedTransition;
        $[3] = t1;
    } else t1 = $[3];
    const loadOptions = t1;
    let t2;
    if ($[4] !== setSelectedTransition) {
        t2 = (selectedOption)=>{
            if (selectedOption) setSelectedTransition(selectedOption);
        };
        $[4] = setSelectedTransition;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendAnalyticsEvent) {
        t3 = ()=>{
            sendAnalyticsEvent({
                action: "opened",
                actionSubject: "dropdown",
                actionSubjectId: "rovoJiraIssueTransitionStatusSelector"
            });
        };
        $[6] = sendAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Control: $78eb7b4323ec0809$var$CustomControl
        };
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== isDisabled || $[10] !== loadOptions || $[11] !== selectedTransition || $[12] !== t2 || $[13] !== t3) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
            testId: "jira-issue-create-transition-selector",
            isDisabled: isDisabled,
            spacing: "compact",
            appearance: "subtle",
            value: selectedTransition,
            defaultOptions: true,
            loadOptions: loadOptions,
            onChange: t2,
            onMenuOpen: t3,
            components: t4
        });
        $[9] = isDisabled;
        $[10] = loadOptions;
        $[11] = selectedTransition;
        $[12] = t2;
        $[13] = t3;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ issueAris: issueAris, setSelectedTransition: setSelectedTransition, selectedTransition: selectedTransition, isDisabled: isDisabled, defaultTransitionId: defaultTransitionId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const loadOptions = (0, $cozmU.useCallback)(async ()=>{
        const response = await (0, $haiCi.performGqlFetch)({
            gqlQuery: $78eb7b4323ec0809$export$e7db4b994264bbd3,
            variables: {
                issueAris: issueAris
            }
        });
        const transitions = response.data.jira.content.bulkTransitions?.edges?.flatMap((edge)=>edge?.node?.transitions?.edges?.map((transitionEdge)=>transitionEdge?.node && {
                    label: transitionEdge.node.name || '',
                    value: transitionEdge.node.transitionId || ''
                }) || []).filter((option)=>option !== null) || [];
        const selectedTransition_0 = transitions.find((transition)=>transition.value === defaultTransitionId);
        if (selectedTransition_0) setSelectedTransition(selectedTransition_0);
        return transitions;
    }, [
        defaultTransitionId,
        issueAris,
        setSelectedTransition
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        testId: "jira-issue-create-transition-selector",
        isDisabled: isDisabled,
        spacing: "compact",
        appearance: "subtle",
        value: selectedTransition,
        defaultOptions: true,
        loadOptions: loadOptions,
        onChange: (selectedOption)=>{
            if (selectedOption) setSelectedTransition(selectedOption);
        },
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoJiraIssueTransitionStatusSelector'
            });
        },
        components: {
            Control: $78eb7b4323ec0809$var$CustomControl
        }
    });
};
const $78eb7b4323ec0809$var$CustomControl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingInline: "space.100",
            xcss: $78eb7b4323ec0809$var$styles.customControl
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, children));
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, props, t1);
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ children: children, ...props })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, props, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        paddingInline: "space.100",
        xcss: $78eb7b4323ec0809$var$styles.customControl
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, children)));
};
function $78eb7b4323ec0809$var$_temp(transitionEdge) {
    return transitionEdge?.node && {
        label: transitionEdge.node.name || "",
        value: transitionEdge.node.transitionId || ""
    };
}
function $78eb7b4323ec0809$var$_temp2(edge) {
    return edge?.node?.transitions?.edges?.map($78eb7b4323ec0809$var$_temp) || [];
}
function $78eb7b4323ec0809$var$_temp3(option) {
    return option !== null;
}
module.exports["TransitionSelector"] = $78eb7b4323ec0809$export$3d9e9879f6c264e4;

});

parcelRegister("auJoE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8d4c17ce8f2f0191$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "conversation-assistant-message-actions.controllers.jira-move-to-sprint.title",
        defaultMessage: "Move to sprint"
    },
    sprintLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-move-to-sprint.sprintLabel",
        defaultMessage: "Sprint ID"
    },
    issuesLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-move-to-sprint.issuesLabel",
        defaultMessage: "{count, plural, one {Issue} other {Issues}}"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.controllers.jira-move-to-sprint.confirmButton",
        defaultMessage: "Confirm"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.controllers.jira-move-to-sprint.cancelButton",
        defaultMessage: "Cancel"
    }
});
module.exports["messages"] = $8d4c17ce8f2f0191$export$defe85febe8b728c;

});

parcelRegister("dgT8C", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dfe9a92c98142657$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.add-dependency.card-title",
        defaultMessage: "Add plan dependency"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.add-dependency.confirm-button",
        defaultMessage: "Add"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.add-dependency.cancel-button",
        defaultMessage: "Cancel"
    },
    dependencyTypeBlocks: {
        id: "conversation-assistant-message-actions.add-dependency.dependency-type-blocks",
        defaultMessage: "blocks"
    }
});
var $dfe9a92c98142657$export$2e2bcd8739ae039 = $dfe9a92c98142657$var$messages;
module.exports["default"] = $dfe9a92c98142657$export$2e2bcd8739ae039;

});

parcelRegister("esN88", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $46231c94b284006d$var$styles = {
    contentWrapper: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    card: "_2mHwu88HPE _0bjKvD8fU6 _30huDKOeNX _3iDTPbQ4SZ _0aFT5vbt8w _0Of8r28HPE _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO"
};
const $46231c94b284006d$export$77ef6ca21af9f8b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $46231c94b284006d$var$styles.contentWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $46231c94b284006d$var$styles.card
        }, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $46231c94b284006d$var$styles.contentWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $46231c94b284006d$var$styles.card
    }, children));
module.exports["EntityCard"] = $46231c94b284006d$export$77ef6ca21af9f8b1;

});

parcelRegister("lRbe2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $e91f3a18678be976$export$45efebcf60c534cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { icon: icon, title: title } = t0;
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: 1,
            weight: "semibold"
        }, title));
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== icon || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, icon, t1);
        $[2] = icon;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ icon: icon, title: title })=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, icon, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1,
        weight: "semibold"
    }, title)));
module.exports["EntityTitle"] = $e91f3a18678be976$export$45efebcf60c534cc;

});

parcelRegister("7PIET", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7c8fd600efd1a8cc$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.add-program-board.card-title",
        defaultMessage: "Create program board"
    },
    startDateLabel: {
        id: "conversation-assistant-message-actions.add-program-board.start-date-label",
        defaultMessage: "Start date"
    },
    columnDurationLabel: {
        id: "conversation-assistant-message-actions.add-program-board.column-duration-label",
        defaultMessage: "Column duration"
    },
    columnDurationValue: {
        id: "conversation-assistant-message-actions.add-program-board.column-duration-value",
        defaultMessage: "{count, plural, one {# week} other {# weeks}}"
    },
    numberOfColumnsLabel: {
        id: "conversation-assistant-message-actions.add-program-board.number-of-columns-label",
        defaultMessage: "Number of columns"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.add-program-board.confirm-button",
        defaultMessage: "Create"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.add-program-board.cancel-button",
        defaultMessage: "Cancel"
    }
});
var $7c8fd600efd1a8cc$export$2e2bcd8739ae039 = $7c8fd600efd1a8cc$var$messages;
module.exports["default"] = $7c8fd600efd1a8cc$export$2e2bcd8739ae039;

});

parcelRegister("ldf48", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $aac7fbf11a2dbb6f$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.create-release.card-title",
        defaultMessage: "Create plan release"
    },
    spaceLabel: {
        id: "conversation-assistant-message-actions.create-release.space-label",
        defaultMessage: "Space"
    },
    startDateLabel: {
        id: "conversation-assistant-message-actions.create-release.start-date-label",
        defaultMessage: "Start date"
    },
    releaseDateLabel: {
        id: "conversation-assistant-message-actions.create-release.release-date-label",
        defaultMessage: "Release date"
    },
    asEarlyAsPossible: {
        id: "conversation-assistant-message-actions.create-release.as-early-as-possible",
        defaultMessage: "As early as possible"
    },
    noReleaseDate: {
        id: "conversation-assistant-message-actions.create-release.no-release-date",
        defaultMessage: "No release date"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.create-release.confirm-button",
        defaultMessage: "Create"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.create-release.cancel-button",
        defaultMessage: "Cancel"
    }
});
var $aac7fbf11a2dbb6f$export$2e2bcd8739ae039 = $aac7fbf11a2dbb6f$var$messages;
module.exports["default"] = $aac7fbf11a2dbb6f$export$2e2bcd8739ae039;

});

parcelRegister("99tpl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $42f85c080d44b6b0$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.create-work-item.card-title",
        defaultMessage: "Create plan work item"
    },
    spaceLabel: {
        id: "conversation-assistant-message-actions.create-work-item.space-label",
        defaultMessage: "Space"
    },
    priorityLabel: {
        id: "conversation-assistant-message-actions.create-work-item.priority-label",
        defaultMessage: "Priority"
    },
    assigneeLabel: {
        id: "conversation-assistant-message-actions.create-work-item.assignee-label",
        defaultMessage: "Assignee"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.create-work-item.confirm-button",
        defaultMessage: "Create"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.create-work-item.cancel-button",
        defaultMessage: "Cancel"
    }
});
var $42f85c080d44b6b0$export$2e2bcd8739ae039 = $42f85c080d44b6b0$var$messages;
module.exports["default"] = $42f85c080d44b6b0$export$2e2bcd8739ae039;

});

parcelRegister("3Zygi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $20b6ee5ccef80674$var$messages = (0, $kSwu1.defineMessages)({
    startDateLabel: {
        id: "conversation-assistant-message-actions.delete-program-board.start-date-label",
        defaultMessage: "Start date"
    },
    columnDurationLabel: {
        id: "conversation-assistant-message-actions.delete-program-board.column-duration-label",
        defaultMessage: "Column duration"
    },
    columnDurationValue: {
        id: "conversation-assistant-message-actions.delete-program-board.column-duration-value",
        defaultMessage: "{count, plural, one {# week} other {# weeks}}"
    },
    numberOfColumnsLabel: {
        id: "conversation-assistant-message-actions.delete-program-board.number-of-columns-label",
        defaultMessage: "Number of columns"
    },
    cardTitle: {
        id: "conversation-assistant-message-actions.delete-program-board.card-title",
        defaultMessage: "Remove program board"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.delete-program-board.confirm-button",
        defaultMessage: "Remove"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.delete-program-board.cancel-button",
        defaultMessage: "Cancel"
    }
});
var $20b6ee5ccef80674$export$2e2bcd8739ae039 = $20b6ee5ccef80674$var$messages;
module.exports["default"] = $20b6ee5ccef80674$export$2e2bcd8739ae039;

});

parcelRegister("ioa75", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $58e1c3a166e57626$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.manage-features.card-title",
        defaultMessage: "Manage plan features"
    },
    releasesLabel: {
        id: "conversation-assistant-message-actions.manage-features.releases-label",
        defaultMessage: "Releases"
    },
    statusOn: {
        id: "conversation-assistant-message-actions.manage-features.status-on",
        defaultMessage: "On"
    },
    statusOff: {
        id: "conversation-assistant-message-actions.manage-features.status-off",
        defaultMessage: "Off"
    },
    turnOnButton: {
        id: "conversation-assistant-message-actions.manage-features.turn-on-button",
        defaultMessage: "Turn on"
    },
    turnOffButton: {
        id: "conversation-assistant-message-actions.manage-features.turn-off-button",
        defaultMessage: "Turn off"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.manage-features.cancel-button",
        defaultMessage: "Cancel"
    }
});
var $58e1c3a166e57626$export$2e2bcd8739ae039 = $58e1c3a166e57626$var$messages;
module.exports["default"] = $58e1c3a166e57626$export$2e2bcd8739ae039;

});

parcelRegister("lTpqN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8c2ad6eb20f1260b$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.remove-dependency.card-title",
        defaultMessage: "Remove plan dependency"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.remove-dependency.confirm-button",
        defaultMessage: "Remove"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.remove-dependency.cancel-button",
        defaultMessage: "Cancel"
    },
    dependencyTypeBlocks: {
        id: "conversation-assistant-message-actions.remove-dependency.dependency-type-blocks",
        defaultMessage: "blocks"
    }
});
var $8c2ad6eb20f1260b$export$2e2bcd8739ae039 = $8c2ad6eb20f1260b$var$messages;
module.exports["default"] = $8c2ad6eb20f1260b$export$2e2bcd8739ae039;

});

parcelRegister("dyQKF", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $cf0d5c61c7b446f9$var$messages = (0, $kSwu1.defineMessages)({
    addCardTitle: {
        id: "conversation-assistant-message-actions.work-source.add-card-title",
        defaultMessage: "Add plan work source"
    },
    removeCardTitle: {
        id: "conversation-assistant-message-actions.work-source.remove-card-title",
        defaultMessage: "Remove plan work source"
    },
    workSource: {
        id: "conversation-assistant-message-actions.work-source.work-source",
        defaultMessage: "Work source"
    },
    sourceTypeLabel: {
        id: "conversation-assistant-message-actions.work-source.source-type-label",
        defaultMessage: "Source type"
    },
    workItemsLabel: {
        id: "conversation-assistant-message-actions.work-source.work-items-label",
        defaultMessage: "Work items"
    },
    addButton: {
        id: "conversation-assistant-message-actions.work-source.add-button",
        defaultMessage: "Add"
    },
    removeButton: {
        id: "conversation-assistant-message-actions.work-source.remove-button",
        defaultMessage: "Remove"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.work-source.cancel-button",
        defaultMessage: "Cancel"
    }
});
var $cf0d5c61c7b446f9$export$2e2bcd8739ae039 = $cf0d5c61c7b446f9$var$messages;
module.exports["default"] = $cf0d5c61c7b446f9$export$2e2bcd8739ae039;

});

parcelRegister("h6odf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $945c0f2da4dfe1dd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.title",
        defaultMessage: "Start sprint"
    },
    completeTitle: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.completeTitle",
        defaultMessage: "Complete sprint"
    },
    nameLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.nameLabel",
        defaultMessage: "Name"
    },
    startDateLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.startDateLabel",
        defaultMessage: "Start date"
    },
    endDateLabel: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.endDateLabel",
        defaultMessage: "End date"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.confirmButton",
        defaultMessage: "Confirm"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.controllers.jira-board-start-sprint.cancelButton",
        defaultMessage: "Cancel"
    }
});
module.exports["messages"] = $945c0f2da4dfe1dd$export$defe85febe8b728c;

});

parcelRegister("7CSGi", function(module, exports) {

var $6acZZ = parcelRequire("6acZZ");


var $3iWYJ = parcelRequire("3iWYJ");


var $hCuGd = parcelRequire("hCuGd");


var $dsMnc = parcelRequire("dsMnc");


var $66cjO = parcelRequire("66cjO");


var $4AL0V = parcelRequire("4AL0V");

// Keyword sentinel that the builder emits for the JQL `EMPTY` keyword operand.
const $eb04a3b55469da85$var$EMPTY_KEYWORD_VALUE = 'EMPTY';
const $eb04a3b55469da85$var$singleOperandToValue = (operand)=>{
    switch(operand.operandType){
        case 0, $66cjO.OPERAND_TYPE_VALUE:
            return operand.value;
        case 0, $66cjO.OPERAND_TYPE_KEYWORD:
            return $eb04a3b55469da85$var$EMPTY_KEYWORD_VALUE;
        case 0, $66cjO.OPERAND_TYPE_FUNCTION:
            {
                const args = operand.arguments.map((argument)=>argument.value).join(', ');
                return `${operand.function.value}(${args})`;
            }
        default:
            // Nested list operands are not valid JQL, so there is nothing to extract here.
            return undefined;
    }
};
const $eb04a3b55469da85$var$operandToValues = (operand)=>{
    if (operand.operandType !== (0, $66cjO.OPERAND_TYPE_LIST)) {
        const value = $eb04a3b55469da85$var$singleOperandToValue(operand);
        return value === undefined ? [] : [
            value
        ];
    }
    const values = [];
    for (const value of operand.values){
        const resolved = $eb04a3b55469da85$var$singleOperandToValue(value);
        if (resolved !== undefined) values.push(resolved);
    }
    return values;
};
const $eb04a3b55469da85$export$71af299376656322 = (jql)=>{
    const trimmedJql = jql.trim();
    if (trimmedJql === '') return {
        clauses: [],
        isComplex: false,
        sortBy: undefined
    };
    const jast = new (0, $hCuGd.JastBuilder)().build(trimmedJql);
    const { query: query } = jast;
    if (!query) return {
        clauses: [],
        isComplex: false,
        sortBy: undefined
    };
    const clauses = [];
    let isComplex = false;
    (0, $dsMnc.walkAST)({
        enterTerminalClause: (clause)=>{
            if (clause.operator && clause.operand) {
                const predicates = clause.predicates.map((predicate)=>({
                        operator: predicate.operator.value,
                        value: predicate.operand ? $eb04a3b55469da85$var$operandToValues(predicate.operand) : []
                    }));
                clauses.push({
                    field: clause.field.value,
                    operator: clause.operator.value,
                    value: $eb04a3b55469da85$var$operandToValues(clause.operand),
                    ...predicates.length > 0 ? {
                        predicates: predicates
                    } : {}
                });
            } else if (clause.operator) {
                // CHANGED clauses always have an undefined operand (@atlaskit/jql-ast never resolves
                // one for them), so they'd otherwise be silently dropped. Fall back to the raw JQL
                // substring rather than losing the clause entirely.
                const [start, end] = clause.position ?? [
                    0,
                    -1
                ];
                clauses.push({
                    field: clause.field.value,
                    operator: clause.operator.value,
                    value: [],
                    rawText: trimmedJql.slice(start, end + 1)
                });
            }
        },
        // A NOT-wrapped clause can never be represented as flat chips.
        enterNotClause: ()=>{
            isComplex = true;
        },
        // A flat AND/OR of terminal clauses (e.g. "a = 1 AND b = 2 AND c = 3", or
        // "a = 1 OR a = 2") still flattens fine into chips, and so does a redundant
        // same-operator grouping (e.g. "(a = 1 AND b = 2) AND c = 3" is just "a = 1 AND
        // b = 2 AND c = 3"). A compound clause that nests a compound clause with a DIFFERENT
        // operator (e.g. "(a = 1 OR b = 2) AND c = 3") changes meaning when flattened, and so
        // does a FLAT OR across different fields (e.g. "a = 1 OR b = 2") — that also stops
        // meaning the same thing once flattened into stacked chips, which read as AND. A flat
        // OR of the SAME field (e.g. "a = 1 OR a = 2") is unaffected and stays non-complex. A
        // flat AND repeating the SAME field (e.g. "a = 1 AND a = 2") flattens into a chip
        // group visually identical to the OR case, but the semantics differ — AND across
        // equal/incompatible values is a contradictory filter — so that case is complex too.
        enterCompoundClause: (compoundClause)=>{
            const hasNestedDifferentOperator = compoundClause.clauses.some((clause)=>clause.clauseType === (0, $6acZZ.CLAUSE_TYPE_COMPOUND) && clause.operator.value !== compoundClause.operator.value);
            const terminalFields = compoundClause.clauses.filter((clause)=>clause.clauseType === (0, $6acZZ.CLAUSE_TYPE_TERMINAL)).map((clause)=>clause.field.value.toLowerCase());
            const hasFlatOrAcrossDifferentFields = compoundClause.operator.value === (0, $3iWYJ.COMPOUND_OPERATOR_OR) && new Set(terminalFields).size > 1;
            const hasFlatAndAcrossSameField = compoundClause.operator.value === (0, $3iWYJ.COMPOUND_OPERATOR_AND) && new Set(terminalFields).size < terminalFields.length;
            if (hasNestedDifferentOperator || hasFlatOrAcrossDifferentFields || hasFlatAndAcrossSameField) isComplex = true;
        }
    }, jast);
    const primarySortField = query.orderBy?.fields[0];
    const sortBy = primarySortField ? {
        field: primarySortField.field.value,
        // An omitted direction (e.g. "ORDER BY created") means JQL's default of ascending.
        direction: primarySortField.direction?.value ?? (0, $4AL0V.ORDER_BY_DIRECTION_ASC)
    } : undefined;
    // More than one ORDER BY field can't be represented by the single-field sort chip without
    // silently dropping the extra criteria, so fall back to raw JQL for the whole query.
    if ((query.orderBy?.fields.length ?? 0) > 1) isComplex = true;
    return {
        clauses: clauses,
        isComplex: isComplex,
        sortBy: sortBy
    };
};
module.exports["parseViewJql"] = $eb04a3b55469da85$export$71af299376656322;

});

parcelRegister("43bN1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $uUDXo = parcelRequire("uUDXo");

// hydrateDefaultValues resolves every submitted id against the users endpoint and fills any id it
// can't match with this sentinel name (not exported from @atlaskit/smart-user-picker), rather than
// omitting it. Since most literals we submit here are filter values that aren't accountIds at all,
// we must drop sentinel-labelled entries so non-user values keep rendering raw instead of "Unknown".
const $fbc429f3a5664006$var$UNRESOLVED_USER_NAME = 'Unknown';
function $fbc429f3a5664006$export$121e7622169bc125(ids, cloudId) {
    const [users, setUsers] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const idsKey = (0, $cozmU.useMemo)(()=>Array.from(new Set(ids)).sort().join(','), [
        ids
    ]);
    const requestKey = (0, $cozmU.useMemo)(()=>`${idsKey}::${cloudId}`, [
        idsKey,
        cloudId
    ]);
    const disposed = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            disposed.current = true;
        };
    }, []);
    const inFlightFor = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (ids.length === 0) {
            inFlightFor.current = null;
            setUsers([]);
            setIsLoading(false);
            setError(null);
            return;
        }
        if (inFlightFor.current === requestKey) return;
        inFlightFor.current = requestKey;
        setIsLoading(true);
        setError(null);
        const userIdentifiers = ids.map((id)=>({
                id: id,
                type: 'user'
            }));
        (0, $uUDXo.default)(undefined, userIdentifiers, 'people', cloudId).then((hydratedData)=>{
            if (disposed.current) return;
            if (inFlightFor.current !== requestKey) return;
            const fetchedUsers = Array.isArray(hydratedData) ? hydratedData : [
                hydratedData
            ];
            const fetchedUserMap = new Map();
            fetchedUsers.forEach((user)=>{
                if (user && 'name' in user && user.id && user.name && user.name !== $fbc429f3a5664006$var$UNRESOLVED_USER_NAME) fetchedUserMap.set(user.id, {
                    id: user.id,
                    name: user.name,
                    avatarUrl: user.avatarUrl || '',
                    type: 'user'
                });
            });
            const orderedUsers = ids.map((id)=>fetchedUserMap.get(id)).filter((user)=>user != null);
            setUsers(orderedUsers);
            setIsLoading(false);
            inFlightFor.current = null;
        }).catch((err)=>{
            if (disposed.current) return;
            if (inFlightFor.current === requestKey) {
                setError(err);
                setIsLoading(false);
                inFlightFor.current = null;
            }
        });
        return ()=>{
            inFlightFor.current = null;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- requestKey is a stable string derived from ids and cloudId, used intentionally to avoid infinite loops from array reference changes
    }, [
        requestKey
    ]);
    return {
        users: users,
        isLoading: isLoading,
        error: error
    };
}
module.exports["useHydratedFilterUsers"] = $fbc429f3a5664006$export$121e7622169bc125;

});

parcelRegister("20KBU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1eov5 = parcelRequire("1eov5");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $IOtUu = parcelRequire("IOtUu");


var $hgTng = parcelRequire("hgTng");

const $1f104f779412876e$var$styles = {
    fieldGroup: "_3YEZNOdnbC"
};
const $1f104f779412876e$var$NEGATED_OPERATORS = new Set([
    (0, $1eov5.OPERATOR_NOT_EQUALS),
    (0, $1eov5.OPERATOR_NOT_IN),
    (0, $1eov5.OPERATOR_NOT_LIKE),
    (0, $1eov5.OPERATOR_IS_NOT),
    (0, $1eov5.OPERATOR_WAS_NOT),
    (0, $1eov5.OPERATOR_WAS_NOT_IN)
]);
const $1f104f779412876e$var$FIELD_LABEL_MESSAGES = (0, $hgTng.default);
const $1f104f779412876e$var$resolveFieldLabel = (fieldKey, formatMessage, fields)=>{
    const message = $1f104f779412876e$var$FIELD_LABEL_MESSAGES[fieldKey.toLowerCase()];
    if (message) return formatMessage(message);
    const customField = fields?.find((field)=>field.jqlClause.toLowerCase() === fieldKey.toLowerCase());
    if (customField) return customField.fieldName;
    return fieldKey.charAt(0).toUpperCase() + fieldKey.slice(1);
};
const $1f104f779412876e$var$groupClausesByField = (clauses, formatMessage, fields)=>{
    const fieldOrder = [];
    const clausesByField = new Map();
    for (const clause of clauses){
        // Group by resolved display label, not the raw JQL field key, so aliased fields that
        // resolve to the same label (e.g. "type"/"issuetype" both -> "Work type") render as one
        // chip group instead of two identically-labeled ones.
        const fieldKey = $1f104f779412876e$var$resolveFieldLabel(clause.field, formatMessage, fields);
        if (!clausesByField.has(fieldKey)) {
            fieldOrder.push(fieldKey);
            clausesByField.set(fieldKey, []);
        }
        clausesByField.get(fieldKey).push(clause);
    }
    return fieldOrder.map((field)=>clausesByField.get(field));
};
const $1f104f779412876e$var$formatPredicates = (predicates, resolveValueText)=>{
    if (!predicates || predicates.length === 0) return '';
    return ' ' + predicates.map((predicate)=>`${predicate.operator} ${predicate.value.map(resolveValueText).join(', ')}`.trim()).join(' ');
};
const $1f104f779412876e$export$76491a32209f2dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { clauses: clauses, fields: fields, hydratedUserNamesById: hydratedUserNamesById } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== hydratedUserNamesById) {
        t1 = (value)=>hydratedUserNamesById?.get(value) ?? value;
        $[0] = hydratedUserNamesById;
        $[1] = t1;
    } else t1 = $[1];
    const resolveValueText = t1;
    if (clauses.length === 0) return null;
    let t2;
    if ($[2] !== clauses || $[3] !== fields || $[4] !== formatMessage || $[5] !== resolveValueText) {
        let t3;
        if ($[7] !== fields || $[8] !== formatMessage || $[9] !== resolveValueText) {
            t3 = (fieldClauses)=>{
                const { field: field } = fieldClauses[0];
                const fieldLabel = $1f104f779412876e$var$resolveFieldLabel(field, formatMessage, fields);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    key: field,
                    space: "space.050",
                    alignBlock: "center",
                    shouldWrap: true,
                    xcss: $1f104f779412876e$var$styles.fieldGroup
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    color: "color.text.subtle",
                    size: "small"
                }, fieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    space: "space.050",
                    shouldWrap: true,
                    role: "group",
                    "aria-label": fieldLabel
                }, fieldClauses.map((clause, index)=>{
                    if (clause.rawText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                        key: `raw-${index}`,
                        text: clause.rawText,
                        isRemovable: false,
                        color: "standard",
                        hasMargin: false
                    });
                    if (clause.operator === (0, $1eov5.OPERATOR_EQUALS) || clause.operator === (0, $1eov5.OPERATOR_IN)) return clause.value.map((value_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                            key: `${index}-${value_0}`,
                            text: resolveValueText(value_0),
                            isRemovable: false,
                            color: "standard",
                            hasMargin: false
                        }));
                    if ($1f104f779412876e$var$NEGATED_OPERATORS.has(clause.operator) || (0, $1eov5.COMPARISON_OPERATORS).includes(clause.operator)) return [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                            key: `${clause.operator}-operator-${index}`,
                            text: clause.operator,
                            isRemovable: false,
                            color: "standard",
                            hasMargin: false
                        }),
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                            key: `${clause.operator}-${index}-${clause.value.join(",")}`,
                            text: `${clause.value.map(resolveValueText).join(", ")}${$1f104f779412876e$var$formatPredicates(clause.predicates, resolveValueText)}`,
                            isRemovable: false,
                            color: "standard",
                            hasMargin: false
                        })
                    ];
                    return [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                            key: `${clause.operator}-${index}-${clause.value.join(",")}`,
                            text: `${clause.operator} ${clause.value.map(resolveValueText).join(", ")}${$1f104f779412876e$var$formatPredicates(clause.predicates, resolveValueText)}`,
                            isRemovable: false,
                            color: "standard",
                            hasMargin: false
                        })
                    ];
                })));
            };
            $[7] = fields;
            $[8] = formatMessage;
            $[9] = resolveValueText;
            $[10] = t3;
        } else t3 = $[10];
        t2 = $1f104f779412876e$var$groupClausesByField(clauses, formatMessage, fields).map(t3);
        $[2] = clauses;
        $[3] = fields;
        $[4] = formatMessage;
        $[5] = resolveValueText;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            rowSpace: "space.100",
            shouldWrap: true
        }, t2);
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ clauses: clauses, fields: fields, hydratedUserNamesById: hydratedUserNamesById })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolveValueText = (value)=>hydratedUserNamesById?.get(value) ?? value;
    if (clauses.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        rowSpace: "space.100",
        shouldWrap: true
    }, $1f104f779412876e$var$groupClausesByField(clauses, formatMessage, fields).map((fieldClauses)=>{
        const { field: field } = fieldClauses[0];
        const fieldLabel = $1f104f779412876e$var$resolveFieldLabel(field, formatMessage, fields);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: field,
            space: "space.050",
            alignBlock: "center",
            shouldWrap: true,
            xcss: $1f104f779412876e$var$styles.fieldGroup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, fieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            shouldWrap: true,
            role: "group",
            "aria-label": fieldLabel
        }, fieldClauses.map((clause, index)=>{
            if (clause.rawText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: `raw-${index}`,
                text: clause.rawText,
                isRemovable: false,
                color: "standard",
                hasMargin: false
            });
            if (clause.operator === (0, $1eov5.OPERATOR_EQUALS) || clause.operator === (0, $1eov5.OPERATOR_IN)) return clause.value.map((value_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                    key: `${index}-${value_0}`,
                    text: resolveValueText(value_0),
                    isRemovable: false,
                    color: "standard",
                    hasMargin: false
                }));
            if ($1f104f779412876e$var$NEGATED_OPERATORS.has(clause.operator) || (0, $1eov5.COMPARISON_OPERATORS).includes(clause.operator)) return [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                    key: `${clause.operator}-operator-${index}`,
                    text: clause.operator,
                    isRemovable: false,
                    color: "standard",
                    hasMargin: false
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                    key: `${clause.operator}-${index}-${clause.value.join(',')}`,
                    text: `${clause.value.map(resolveValueText).join(', ')}${$1f104f779412876e$var$formatPredicates(clause.predicates, resolveValueText)}`,
                    isRemovable: false,
                    color: "standard",
                    hasMargin: false
                })
            ];
            return [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                    key: `${clause.operator}-${index}-${clause.value.join(',')}`,
                    text: `${clause.operator} ${clause.value.map(resolveValueText).join(', ')}${$1f104f779412876e$var$formatPredicates(clause.predicates, resolveValueText)}`,
                    isRemovable: false,
                    color: "standard",
                    hasMargin: false
                })
            ];
        })));
    }));
};
const $1f104f779412876e$export$fd47155445340766 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { groupBy: groupBy, fields: fields } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== fields || $[1] !== formatMessage || $[2] !== groupBy) {
        t1 = $1f104f779412876e$var$resolveFieldLabel(groupBy, formatMessage, fields);
        $[0] = fields;
        $[1] = formatMessage;
        $[2] = groupBy;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: t1,
            isRemovable: false,
            color: "standard",
            hasMargin: false
        }));
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ groupBy: groupBy, fields: fields })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: $1f104f779412876e$var$resolveFieldLabel(groupBy, formatMessage, fields),
        isRemovable: false,
        color: "standard",
        hasMargin: false
    }));
};
const $1f104f779412876e$export$de5cef4e18592e4e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { field: field, direction: direction, fields: fields } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== field || $[1] !== fields || $[2] !== formatMessage) {
        t1 = $1f104f779412876e$var$resolveFieldLabel(field, formatMessage, fields);
        $[0] = field;
        $[1] = fields;
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = `${t1} ${direction}`;
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: t2,
            isRemovable: false,
            color: "standard",
            hasMargin: false
        }));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ field: field, direction: direction, fields: fields })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: `${$1f104f779412876e$var$resolveFieldLabel(field, formatMessage, fields)} ${direction}`,
        isRemovable: false,
        color: "standard",
        hasMargin: false
    }));
};
module.exports["ViewFilterChips"] = $1f104f779412876e$export$76491a32209f2dfc;
module.exports["ViewGroupChip"] = $1f104f779412876e$export$fd47155445340766;
module.exports["ViewSortChip"] = $1f104f779412876e$export$de5cef4e18592e4e;

});

parcelRegister("70CKC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $24dy7 = parcelRequire("24dy7");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hdBxM = parcelRequire("hdBxM");

const $96e2f6fa6ff44ccf$export$d36a2d2ee1d88893 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { errors: errors } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== errors || $[1] !== formatMessage) {
        let t2;
        if ($[3] !== formatMessage) {
            t2 = (error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center",
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "p"
                }, typeof error === "string" ? error : formatMessage(error, error.messageValues)));
            $[3] = formatMessage;
            $[4] = t2;
        } else t2 = $[4];
        t1 = errors.map(t2);
        $[0] = errors;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ errors: errors })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, errors.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, typeof error === 'string' ? error : formatMessage(error, error.messageValues)))));
};
const $96e2f6fa6ff44ccf$export$75e20a681c14082e = ({ children: children, invocationId: invocationId })=>{
    (0, $6cFsl.di)((0, $hdBxM.useSubscribe));
    const [errorData, setErrorData] = (0, $cozmU.useState)();
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate'
    }, (payload)=>{
        if (payload.type === 'generic-external-action-error' && invocationId === payload.data.invocationId) setErrorData(payload.data);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, children, errorData && errorData.errors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($96e2f6fa6ff44ccf$export$d36a2d2ee1d88893, {
        errors: errorData.errors
    }));
};
module.exports["WithGenericExternalActionError"] = $96e2f6fa6ff44ccf$export$75e20a681c14082e;

});

parcelRegister("5STmA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7e126157175914ea$var$_default_1 = (0, $kSwu1.defineMessages)({
    redirectToWorkflow: {
        id: "jira-workflow-editor.redirect.to.workflow",
        defaultMessage: "Review workflow in editor"
    },
    applyToWorkflow: {
        id: "jira-workflow-editor.apply.to.workflow.in.editor",
        defaultMessage: "Apply to workflow"
    },
    cancelAction: {
        id: "jira-workflow-editor.cancel.action.in.editor",
        defaultMessage: "Cancel"
    },
    jiraWorkflowEditorUIActionTitle: {
        id: "jira-workflow-editor.title.in.editor",
        defaultMessage: "Workflow editor"
    }
});
var $7e126157175914ea$export$2e2bcd8739ae039 = $7e126157175914ea$var$_default_1;
module.exports["default"] = $7e126157175914ea$export$2e2bcd8739ae039;

});

parcelRegister("clJ5E", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $29KNH = parcelRequire("29KNH");


var $1oj0n = parcelRequire("1oj0n");

const $7cca4ad7cf00262f$var$styles = {
    transitionIcon: "_39xV02cM5X _0jFU0VcM5X",
    card: "_0bjKvDKxmn _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _39xV02N91d _0Of8r28HPE _1Znuxb2ADO _1wydGW8HPE _2Zuz6Q2ADO _0KLXruqi9L"
};
const $7cca4ad7cf00262f$export$5c6c825ffa0b0c39 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (payload)=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const rule = (0, $29KNH.supportedRules)[payload.ruleTemplateKey];
    let t0;
    if ($[0] !== formatMessage || $[1] !== payload.ruleDescription || $[2] !== rule) {
        t0 = rule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $1oj0n.default).ruleHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $7cca4ad7cf00262f$var$styles.card,
            alignBlock: "start",
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: rule.icon.src,
            srcDark: rule.icon.srcDark,
            width: "28px",
            height: "28px",
            alt: formatMessage(rule.name)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, formatMessage(rule.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, payload.ruleDescription))));
        $[0] = formatMessage;
        $[1] = payload.ruleDescription;
        $[2] = rule;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (payload)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const rule = (0, $29KNH.supportedRules)[payload.ruleTemplateKey];
    return rule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $1oj0n.default).ruleHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $7cca4ad7cf00262f$var$styles.card,
        alignBlock: "start",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: rule.icon.src,
        srcDark: rule.icon.srcDark,
        width: "28px",
        height: "28px",
        alt: formatMessage(rule.name)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage(rule.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, payload.ruleDescription))));
};
module.exports["RuleAction"] = $7cca4ad7cf00262f$export$5c6c825ffa0b0c39;

});

parcelRegister("hyIrx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $aTF50 = parcelRequire("aTF50");


var $9KSWX = parcelRequire("9KSWX");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $8dd6z = parcelRequire("8dd6z");

const $e0a0574198705ead$var$statusCategoryToAppearenceMap = {
    UNDEFINED: 'neutral',
    TODO: 'neutral',
    DONE: 'success',
    IN_PROGRESS: 'information'
};
const $e0a0574198705ead$var$styles = {
    statusIcon: "_0bjKvDKxmn _39xV02oWWg _0jFU0VoWWg _0KLXrumhAQ _1UtDYzUktF",
    card: "_0bjKvDKxmn _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _39xV02N91d _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruqi9L"
};
const $e0a0574198705ead$export$3bf4876e6052a8c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (payload)=>{
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $8dd6z.default).statusHeading);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $e0a0574198705ead$var$styles.statusIcon,
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aTF50))), {
            label: ""
        }));
        $[4] = t2;
    } else t2 = $[4];
    const t3 = $e0a0574198705ead$var$statusCategoryToAppearenceMap[payload.statusCategory];
    let t4;
    if ($[5] !== payload.statusName || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $e0a0574198705ead$var$styles.card,
            alignBlock: "center",
            space: "space.150"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: t3
        }, payload.statusName));
        $[5] = payload.statusName;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t1 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t1, t4);
        $[8] = t1;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : (payload)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $8dd6z.default).statusHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $e0a0574198705ead$var$styles.card,
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e0a0574198705ead$var$styles.statusIcon,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aTF50))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: $e0a0574198705ead$var$statusCategoryToAppearenceMap[payload.statusCategory]
    }, payload.statusName)));
};
module.exports["StatusAction"] = $e0a0574198705ead$export$3bf4876e6052a8c2;

});

parcelRegister("48y3r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $aRvnq = parcelRequire("aRvnq");


var $iJGPY = parcelRequire("iJGPY");


var $9KSWX = parcelRequire("9KSWX");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $03OOf = parcelRequire("03OOf");

const $a70ebf3221326775$var$statusCategoryToAppearenceMap = {
    UNDEFINED: 'neutral',
    TODO: 'neutral',
    DONE: 'success',
    IN_PROGRESS: 'information'
};
const $a70ebf3221326775$var$styles = {
    transitionIcon: "_0bjKvDKxmn _39xV02oWWg _0jFU0VoWWg _0KLXrumhAQ _3YEZNOdnbC",
    card: "_0bjKvDKxmn _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _39xV02N91d _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruqi9L"
};
const $a70ebf3221326775$export$fcc3de24472e3bea = (0, $gtMdU.isReactCompilerActivePlatform)() ? (payload)=>{
    const $ = (0, $bDgLe.c)(24);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $03OOf.default).transitionHeading);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a70ebf3221326775$var$styles.transitionIcon,
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iJGPY))), {
            label: ""
        }));
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage || $[6] !== payload.links) {
        t3 = payload.links.length ? payload.links.map($a70ebf3221326775$var$_temp) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $03OOf.default).anyStatus));
        $[5] = formatMessage;
        $[6] = payload.links;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            wrap: "wrap"
        }, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== formatMessage) {
        t5 = formatMessage((0, $03OOf.default).to);
        $[10] = formatMessage;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            spacing: "spacious",
            label: t5,
            size: "small"
        });
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = $a70ebf3221326775$var$statusCategoryToAppearenceMap[payload.toStatusCategory ? payload.toStatusCategory : "UNDEFINED"];
    let t8;
    if ($[14] !== payload.toStatusName || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: t7
        }, payload.toStatusName);
        $[14] = payload.toStatusName;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $a70ebf3221326775$var$styles.card,
            space: "space.150"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            wrap: "wrap"
        }, t4, t6, t8));
        $[17] = t4;
        $[18] = t6;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t1 || $[22] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t1, t9);
        $[21] = t1;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
} : (payload)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $03OOf.default).transitionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $a70ebf3221326775$var$styles.card,
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a70ebf3221326775$var$styles.transitionIcon,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iJGPY))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        wrap: "wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.050",
        wrap: "wrap"
    }, payload.links.length ? payload.links.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: $a70ebf3221326775$var$statusCategoryToAppearenceMap[link.fromStatusCategory ? link.fromStatusCategory : 'UNDEFINED']
        }, link.fromStatusName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $03OOf.default).anyStatus))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        spacing: "spacious",
        label: formatMessage((0, $03OOf.default).to),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: $a70ebf3221326775$var$statusCategoryToAppearenceMap[payload.toStatusCategory ? payload.toStatusCategory : 'UNDEFINED']
    }, payload.toStatusName))));
};
function $a70ebf3221326775$var$_temp(link) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: $a70ebf3221326775$var$statusCategoryToAppearenceMap[link.fromStatusCategory ? link.fromStatusCategory : "UNDEFINED"]
    }, link.fromStatusName);
}
module.exports["TransitionAction"] = $a70ebf3221326775$export$fcc3de24472e3bea;

});

parcelRegister("kIlwI", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $ba12af9a95d1c52d$export$212f7b749ec4b6d2 = (data)=>{
    if (!data) return undefined;
    try {
        return JSON.parse(data);
    } catch  {
        return undefined;
    }
};
const $ba12af9a95d1c52d$export$5759aba79a56bf23 = (url, key, value)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.set(key, value);
        return urlObj.toString();
    } catch  {
        // If URL is invalid, return original URL
        return url;
    }
};
const $ba12af9a95d1c52d$export$bef94a5618bf18bf = (value)=>{
    if (!value) return false;
    try {
        new URL(value);
        return true;
    } catch  {
        return false;
    }
};
const $ba12af9a95d1c52d$export$4f7b3d1a43a33fed = (ari)=>{
    if (typeof ari !== 'string') return null;
    try {
        const result = (0, $7avaU.AnyAri).parse(ari);
        return result;
    } catch (error) {
        return null;
    }
};
module.exports["addQueryParam"] = $ba12af9a95d1c52d$export$5759aba79a56bf23;
module.exports["isValidUrl"] = $ba12af9a95d1c52d$export$bef94a5618bf18bf;
module.exports["parseAriSafely"] = $ba12af9a95d1c52d$export$4f7b3d1a43a33fed;

});

parcelRegister("fWQmA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f736ca7349dd0906$var$message = (0, $kSwu1.defineMessages)({
    jsmCreateRequestInstruction: {
        id: "conversation-assistant-message-actions.jsm-create-request.instruction",
        defaultMessage: "Review and edit the details below, then click {createButtonCopy} to create your request."
    },
    jsmRequestCreatedDescription: {
        id: "conversation-assistant-message-actions.jsm-create-embedded-request.created-description",
        defaultMessage: "Your service request has been created successfully."
    }
});
var $f736ca7349dd0906$export$2e2bcd8739ae039 = $f736ca7349dd0906$var$message;
module.exports["default"] = $f736ca7349dd0906$export$2e2bcd8739ae039;

});

parcelRegister("kclKa", function(module, exports) {
const $d969a2333ad0ef79$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $d969a2333ad0ef79$export$a305f130b289b818;

});

parcelRegister("y3pjR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $cPgiV = parcelRequire("cPgiV");


var $ihgil = parcelRequire("ihgil");

const $1612f80fa9d87a3a$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $1612f80fa9d87a3a$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentSection_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _2BK2Lld1Zr _1eOmH6d1Zr _3gzVzLJNoT",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    fieldList: "_2mHwu8gVvo _43nrzTdnbC _0rIjykdnbC _0LQT5EkG2W _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $1612f80fa9d87a3a$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $ihgil.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1612f80fa9d87a3a$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $1612f80fa9d87a3a$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "create-queue-card.expand-body-content"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1612f80fa9d87a3a$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $1612f80fa9d87a3a$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "create-queue-card.expand-body-content"
    }, formatMessage((0, $ihgil.messages).expandBodyContent)));
};
const $1612f80fa9d87a3a$export$ac6edbc9c7f18df2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $ihgil.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const el = contentSectionRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $1612f80fa9d87a3a$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[2] = t5;
    } else t5 = $[2];
    const measureBodyOverflow = t5;
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== payload.jql || $[5] !== payload.name) {
        t7 = [
            payload.name,
            payload.jql
        ];
        $[4] = payload.jql;
        $[5] = payload.name;
        $[6] = t7;
    } else t7 = $[6];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            measureBodyOverflow();
        };
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== payload.jql || $[9] !== payload.name || $[10] !== showExpandedBody) {
        t9 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.name,
            payload.jql
        ];
        $[8] = payload.jql;
        $[9] = payload.name;
        $[10] = showExpandedBody;
        $[11] = t9;
    } else t9 = $[11];
    (0, $cozmU.useLayoutEffect)(t8, t9);
    let t10;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t11 = [
            measureBodyOverflow
        ];
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t10, t11);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[14] = t12;
    } else t12 = $[14];
    const handleExpandBody = t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== ExpandCollapseIcon || $[17] !== formatMessage || $[18] !== heading || $[19] !== isClamped || $[20] !== isExpanded || $[21] !== isNextDisabled || $[22] !== isNextLoading || $[23] !== isSuccess || $[24] !== onNext || $[25] !== payload.jql || $[26] !== payload.name || $[27] !== showExpandedBody) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t13
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1612f80fa9d87a3a$var$styles.outermostWrapper,
            testId: "create-queue-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPgiV.CreateQueueCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $ihgil.messages).successPill, {
                name: payload.name
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1612f80fa9d87a3a$var$styles.outerColumn,
            testId: "create-queue-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($1612f80fa9d87a3a$var$styles.titleSection, !isExpanded && $1612f80fa9d87a3a$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $1612f80fa9d87a3a$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1612f80fa9d87a3a$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1612f80fa9d87a3a$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $ihgil.messages).collapseBodyContent : (0, $ihgil.messages).expandBodyContent),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "create-queue-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1612f80fa9d87a3a$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($1612f80fa9d87a3a$var$styles.contentSection, isClamped && $1612f80fa9d87a3a$var$styles.contentSection_clamped)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, formatMessage((0, $ihgil.messages).queueFiltersLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, payload.jql)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1612f80fa9d87a3a$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $1612f80fa9d87a3a$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "create-queue-card.next"
        }, formatMessage((0, $ihgil.messages).confirmButton))) : null)));
        $[16] = ExpandCollapseIcon;
        $[17] = formatMessage;
        $[18] = heading;
        $[19] = isClamped;
        $[20] = isExpanded;
        $[21] = isNextDisabled;
        $[22] = isNextLoading;
        $[23] = isSuccess;
        $[24] = onNext;
        $[25] = payload.jql;
        $[26] = payload.name;
        $[27] = showExpandedBody;
        $[28] = t14;
    } else t14 = $[28];
    return t14;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $ihgil.messages).cardTitle);
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $1612f80fa9d87a3a$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        payload.name,
        payload.jql
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.name,
        payload.jql
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1612f80fa9d87a3a$var$styles.outermostWrapper,
        testId: "create-queue-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPgiV.CreateQueueCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $ihgil.messages).successPill, {
            name: payload.name
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1612f80fa9d87a3a$var$styles.outerColumn,
        testId: "create-queue-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($1612f80fa9d87a3a$var$styles.titleSection, !isExpanded && $1612f80fa9d87a3a$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $1612f80fa9d87a3a$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1612f80fa9d87a3a$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1612f80fa9d87a3a$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $ihgil.messages).collapseBodyContent : (0, $ihgil.messages).expandBodyContent),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "create-queue-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1612f80fa9d87a3a$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($1612f80fa9d87a3a$var$styles.contentSection, isClamped && $1612f80fa9d87a3a$var$styles.contentSection_clamped)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $ihgil.messages).queueFiltersLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, payload.jql)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1612f80fa9d87a3a$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $1612f80fa9d87a3a$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "create-queue-card.next"
    }, formatMessage((0, $ihgil.messages).confirmButton))) : null)));
};
module.exports["CreateQueueCard"] = $1612f80fa9d87a3a$export$ac6edbc9c7f18df2;

});

parcelRegister("6RlNM", function(module, exports) {
const $11d63c49e9ba44ae$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $11d63c49e9ba44ae$export$a305f130b289b818;

});

parcelRegister("R76XZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $9gYyc = parcelRequire("9gYyc");


var $5ydg1 = parcelRequire("5ydg1");

const $fb00013d771fbfe2$var$EMPTY_QUEUES = [];
const $fb00013d771fbfe2$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $fb00013d771fbfe2$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentSection_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _2BK2Lld1Zr _1eOmH6d1Zr _3gzVzLJNoT",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    queueList: "_2mHwu8gVvo _43nrzTdnbC _0rIjykdnbC _0LQT5EkG2W _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $fb00013d771fbfe2$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $5ydg1.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb00013d771fbfe2$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $fb00013d771fbfe2$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "create-queue-group-card.expand-body-content"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb00013d771fbfe2$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $fb00013d771fbfe2$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "create-queue-group-card.expand-body-content"
    }, formatMessage((0, $5ydg1.messages).expandBodyContent)));
};
const $fb00013d771fbfe2$export$4946927f4c5d8e5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $5ydg1.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    const queues = payload.queues ?? $fb00013d771fbfe2$var$EMPTY_QUEUES;
    const hasQueues = queues.length > 0;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const el = contentSectionRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $fb00013d771fbfe2$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[2] = t5;
    } else t5 = $[2];
    const measureBodyOverflow = t5;
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== payload.name || $[5] !== queues) {
        t7 = [
            payload.name,
            queues
        ];
        $[4] = payload.name;
        $[5] = queues;
        $[6] = t7;
    } else t7 = $[6];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            measureBodyOverflow();
        };
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== payload.name || $[9] !== queues || $[10] !== showExpandedBody) {
        t9 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.name,
            queues
        ];
        $[8] = payload.name;
        $[9] = queues;
        $[10] = showExpandedBody;
        $[11] = t9;
    } else t9 = $[11];
    (0, $cozmU.useLayoutEffect)(t8, t9);
    let t10;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t11 = [
            measureBodyOverflow
        ];
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t10, t11);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[14] = t12;
    } else t12 = $[14];
    const handleExpandBody = t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== ExpandCollapseIcon || $[17] !== formatMessage || $[18] !== hasQueues || $[19] !== heading || $[20] !== isClamped || $[21] !== isExpanded || $[22] !== isNextDisabled || $[23] !== isNextLoading || $[24] !== isSuccess || $[25] !== onNext || $[26] !== payload.name || $[27] !== queues || $[28] !== showExpandedBody) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t13
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb00013d771fbfe2$var$styles.outermostWrapper,
            testId: "create-queue-group-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gYyc.CreateQueueGroupCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $5ydg1.messages).successPill, {
                name: payload.name
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb00013d771fbfe2$var$styles.outerColumn,
            testId: "create-queue-group-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($fb00013d771fbfe2$var$styles.titleSection, !isExpanded && $fb00013d771fbfe2$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $fb00013d771fbfe2$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb00013d771fbfe2$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb00013d771fbfe2$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $5ydg1.messages).collapseBodyContent : (0, $5ydg1.messages).expandBodyContent),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "create-queue-group-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fb00013d771fbfe2$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($fb00013d771fbfe2$var$styles.contentSection, isClamped && $fb00013d771fbfe2$var$styles.contentSection_clamped)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.name), hasQueues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, formatMessage((0, $5ydg1.messages).queuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $fb00013d771fbfe2$var$styles.queueList
        }, queues.map($fb00013d771fbfe2$var$_temp))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $5ydg1.messages).emptyQueuesDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb00013d771fbfe2$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $fb00013d771fbfe2$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "create-queue-group-card.next"
        }, formatMessage((0, $5ydg1.messages).confirmButton))) : null)));
        $[16] = ExpandCollapseIcon;
        $[17] = formatMessage;
        $[18] = hasQueues;
        $[19] = heading;
        $[20] = isClamped;
        $[21] = isExpanded;
        $[22] = isNextDisabled;
        $[23] = isNextLoading;
        $[24] = isSuccess;
        $[25] = onNext;
        $[26] = payload.name;
        $[27] = queues;
        $[28] = showExpandedBody;
        $[29] = t14;
    } else t14 = $[29];
    return t14;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $5ydg1.messages).cardTitle);
    const queues = payload.queues ?? $fb00013d771fbfe2$var$EMPTY_QUEUES;
    const hasQueues = queues.length > 0;
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $fb00013d771fbfe2$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        payload.name,
        queues
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.name,
        queues
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb00013d771fbfe2$var$styles.outermostWrapper,
        testId: "create-queue-group-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gYyc.CreateQueueGroupCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $5ydg1.messages).successPill, {
            name: payload.name
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb00013d771fbfe2$var$styles.outerColumn,
        testId: "create-queue-group-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($fb00013d771fbfe2$var$styles.titleSection, !isExpanded && $fb00013d771fbfe2$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $fb00013d771fbfe2$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb00013d771fbfe2$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb00013d771fbfe2$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $5ydg1.messages).collapseBodyContent : (0, $5ydg1.messages).expandBodyContent),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "create-queue-group-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fb00013d771fbfe2$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($fb00013d771fbfe2$var$styles.contentSection, isClamped && $fb00013d771fbfe2$var$styles.contentSection_clamped)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.name), hasQueues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $5ydg1.messages).queuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $fb00013d771fbfe2$var$styles.queueList
    }, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: queue.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, queue.name))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $5ydg1.messages).emptyQueuesDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb00013d771fbfe2$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $fb00013d771fbfe2$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "create-queue-group-card.next"
    }, formatMessage((0, $5ydg1.messages).confirmButton))) : null)));
};
function $fb00013d771fbfe2$var$_temp(queue) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        key: queue.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, queue.name));
}
module.exports["CreateQueueGroupCard"] = $fb00013d771fbfe2$export$4946927f4c5d8e5c;

});

parcelRegister("egY3r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $jlRK6 = parcelRequire("jlRK6");


var $4MnFz = parcelRequire("4MnFz");


var $1JERl = parcelRequire("1JERl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $6rwn6 = parcelRequire("6rwn6");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $dw75i = parcelRequire("dw75i");


var $9qyl6 = parcelRequire("9qyl6");


var $3bHU3 = parcelRequire("3bHU3");


var $hTVUf = parcelRequire("hTVUf");


var $gJxEM = parcelRequire("gJxEM");

const $a653455fc5911d13$var$styles = {
    negativeMarginTop: "_313842B0rP",
    fieldsWrapper: "_39xV02N91d",
    fieldLabel: "_3YEZNOdnbC"
};
const $a653455fc5911d13$export$e33703d19a1b7a60 = ({ onCustomDataActioned: _onCustomDataActioned, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, ContentRenderer: ContentRenderer, productKey: productKey, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $4MnFz.useFlags));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const action = actions[0];
    const status = getStatus(action);
    const readonly = getReadonly(action);
    const isActionDisabled = status !== 'idle' || readonly;
    const actionData = (0, $hTVUf.isActionWithInputs)(action) ? action.data.inputs : action.data; // Extract summary and description from either nested requestFieldValues or flat structure for backward compatibility
    const getSummary = ()=>{
        return actionData.requestFieldValues?.summary || actionData.summary;
    };
    const getDescription = ()=>{
        return actionData.requestFieldValues?.description || actionData.description;
    }; // Extract field information from both requestFieldValues and form.answers
    const formFieldValues = actionData.form?.answers ? (0, $hTVUf.convertFormAnswersToFieldValues)(actionData.form.answers) : {};
    const allFieldValues = {
        ...actionData.requestFieldValues,
        ...formFieldValues
    };
    const fieldInfo = Object.keys(allFieldValues).length > 0 ? (0, $hTVUf.createFieldInfoFromResponse)(allFieldValues, action.metadata?.requestFieldNames || actionData.requestFieldNames, action.metadata?.formFieldNames, action.metadata?.formFieldChoices, (0, $iDrrr.fg)('support_asset_field_for_raise_request') ? action.metadata?.assetNames ?? {} : {}) : [];
    const [inlineFormData, setInlineFormData] = (0, $cozmU.useState)({
        ...getSummary() && {
            summary: getSummary()
        },
        ...getDescription() && {
            description: getDescription()
        }
    });
    const handleCreateRequest = (0, $cozmU.useCallback)(async ()=>{
        if (isActionDisabled) return;
        try {
            // Create the request with updated summary and description
            // Maintain the original structure - if requestFieldValues exists, update it
            const updatedData = {
                ...actionData,
                ...actionData.requestFieldValues ? {
                    requestFieldValues: {
                        ...actionData.requestFieldValues,
                        ...inlineFormData.summary && {
                            summary: inlineFormData.summary
                        },
                        ...inlineFormData.description && {
                            description: inlineFormData.description
                        }
                    }
                } : {
                    ...inlineFormData.summary && {
                        summary: inlineFormData.summary
                    },
                    ...inlineFormData.description && {
                        description: inlineFormData.description
                    }
                }
            };
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'jsmCreateRequestActionUnifiedRenderer'
                },
                confirmed_tools: {
                    message_id: messageId,
                    tools: [
                        {
                            key: action.key,
                            tool_id: action.actionId,
                            tool_source: action.toolSource,
                            invocation_id: action.invocationId,
                            data: {
                                human_message_id: action.humanMessageId ?? '',
                                // The `create-request` tool expects the field values directly as its
                                // arguments, whereas the JSM create request tools expect them nested
                                // under `inputs`.
                                arguments: action.key === (0, $dw75i.CREATE_REQUEST_KEY) ? updatedData : {
                                    inputs: updatedData
                                }
                            }
                        }
                    ]
                }
            });
        } catch  {
            showFlag({
                id: 'jsm-request-error',
                title: formatMessage((0, $gJxEM.default).jsmRequestErrorTitle),
                description: formatMessage((0, $gJxEM.default).jsmRequestErrorDescription),
                appearance: 'error',
                isAutoDismiss: true
            });
        }
    }, [
        isActionDisabled,
        action,
        actionData,
        inlineFormData,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        showFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $a653455fc5911d13$var$styles.negativeMarginTop
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $gJxEM.default).jsmCreateRequestInstruction, {
        createButtonCopy: /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "strong"
        }, formatMessage((0, $gJxEM.default).createRequestButton))
    })), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $gJxEM.default).jsmCreateRequestTitle),
        product: "jsm"
    }, /*#__PURE__*/ $cozmU.createElement($a653455fc5911d13$var$JsmCreateRequestSuggestionPreview, {
        formData: inlineFormData,
        setFormData: setInlineFormData,
        isDisabled: isActionDisabled,
        action: action,
        productKey: productKey,
        cloudId: cloudId,
        ContentRenderer: ContentRenderer,
        messageId: "test-message-id"
    }), fieldInfo.length > 0 && /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $gJxEM.default).additionalFieldsLabel)), fieldInfo.map((field)=>/*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            key: field.id,
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $a653455fc5911d13$var$styles.fieldLabel
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "semibold",
            size: "small"
        }, field.label, ":")), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, field.type === 'doc' ? /*#__PURE__*/ $cozmU.createElement(ContentRenderer // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , {
            content: field.value,
            productKey: productKey,
            siteId: cloudId
        }) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small"
        }, field.displayValue || formatMessage((0, $gJxEM.default).fieldNotSet))))))), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        type: "submit",
        isDisabled: isActionDisabled,
        isLoading: status === 'started',
        onClick: (_, e)=>{
            handleCreateRequest();
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'rovoJsmCreateRequestSubmit'
            }));
        },
        interactionName: "ai-mate.jsm-create-request"
    }, formatMessage((0, $gJxEM.default).createRequestButton)))));
};
const $a653455fc5911d13$var$JsmCreateRequestSuggestionPreview = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { ContentRenderer: ContentRenderer, formData: formData, setFormData: setFormData, isDisabled: isDisabled, productKey: productKey, cloudId: cloudId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formData || $[1] !== setFormData) {
        t1 = (fieldName, fieldValue)=>{
            setFormData({
                ...formData,
                [fieldName]: fieldValue
            });
        };
        $[0] = formData;
        $[1] = setFormData;
        $[2] = t1;
    } else t1 = $[2];
    const handleOnChange = t1;
    let t2;
    if ($[3] !== cloudId || $[4] !== productKey) {
        t2 = {
            productKey: productKey,
            siteId: cloudId
        };
        $[3] = cloudId;
        $[4] = productKey;
        $[5] = t2;
    } else t2 = $[5];
    const { editorApi: editorApi, preset: preset } = (0, $3bHU3.useEditorPreset)(t2);
    let t3;
    if ($[6] !== formData.summary || $[7] !== formatMessage || $[8] !== handleOnChange || $[9] !== isDisabled) {
        t3 = formData.summary && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $gJxEM.default).summaryLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement("span", null, formData.summary) : /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            testId: "jsm-create-request-summary-field",
            defaultValue: formData.summary,
            editView: $a653455fc5911d13$var$_temp,
            readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formData.summary),
            onConfirm: (value)=>handleOnChange("summary", value),
            readViewFitContainerWidth: true
        })));
        $[6] = formData.summary;
        $[7] = formatMessage;
        $[8] = handleOnChange;
        $[9] = isDisabled;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== ContentRenderer || $[12] !== cloudId || $[13] !== editorApi?.core || $[14] !== formData.description || $[15] !== formatMessage || $[16] !== handleOnChange || $[17] !== isDisabled || $[18] !== preset || $[19] !== productKey) {
        t4 = formData.description && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $gJxEM.default).descriptionLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
            content: formData.description,
            productKey: productKey,
            siteId: cloudId
        }) : /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            testId: "issue-create-description-field",
            readViewFitContainerWidth: true,
            defaultValue: formData.description,
            keepEditViewOpenOnBlur: false,
            editView: (fieldProps_0, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    ref: ref
                }, /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                    minHeight: 50,
                    shouldFocus: true,
                    preset: preset,
                    maxHeight: 160,
                    appearance: "chromeless",
                    onChange: (_ev)=>{
                        editorApi?.core.actions.requestDocument((doc)=>{
                            const updatedDoc = doc?.content.length ? doc : null;
                            fieldProps_0.onChange(updatedDoc);
                        });
                    },
                    onEditorReady: (actions)=>{
                        if (formData.description) actions.replaceDocument((0, $6rwn6.encodeAdf)(formData.description));
                    }
                })),
            readView: ()=>/*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
                    content: formData.description,
                    productKey: productKey,
                    siteId: cloudId
                }),
            onConfirm: (value_0)=>{
                handleOnChange("description", value_0);
            }
        })));
        $[11] = ContentRenderer;
        $[12] = cloudId;
        $[13] = editorApi?.core;
        $[14] = formData.description;
        $[15] = formatMessage;
        $[16] = handleOnChange;
        $[17] = isDisabled;
        $[18] = preset;
        $[19] = productKey;
        $[20] = t4;
    } else t4 = $[20];
    let t5;
    if ($[21] !== t3 || $[22] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.150",
            direction: "column",
            xcss: $a653455fc5911d13$var$styles.fieldsWrapper
        }, t3, t4));
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
    } else t5 = $[23];
    return t5;
} : ({ action: _action, ContentRenderer: ContentRenderer, formData: formData, setFormData: setFormData, isDisabled: isDisabled, productKey: productKey, cloudId: cloudId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleOnChange = (fieldName, fieldValue)=>{
        setFormData({
            ...formData,
            [fieldName]: fieldValue
        });
    };
    const { editorApi: editorApi, preset: preset } = (0, $3bHU3.useEditorPreset)({
        productKey: productKey,
        siteId: cloudId
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.150",
        direction: "column",
        xcss: $a653455fc5911d13$var$styles.fieldsWrapper
    }, formData.summary && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $gJxEM.default).summaryLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement("span", null, formData.summary) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        testId: "jsm-create-request-summary-field",
        defaultValue: formData.summary,
        editView: ({ ...fieldProps })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                ...fieldProps,
                isCompact: true
            }),
        readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formData.summary),
        onConfirm: (value)=>handleOnChange('summary', value),
        readViewFitContainerWidth: true
    }))), formData.description && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $gJxEM.default).descriptionLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
        content: formData.description,
        productKey: productKey,
        siteId: cloudId
    }) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        testId: "issue-create-description-field",
        readViewFitContainerWidth: true,
        defaultValue: formData.description,
        keepEditViewOpenOnBlur: false,
        editView: (fieldProps_0, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ref: ref
            }, /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                minHeight: 50,
                shouldFocus: true,
                preset: preset,
                maxHeight: 160,
                appearance: "chromeless",
                onChange: (_ev)=>{
                    editorApi?.core.actions.requestDocument((doc)=>{
                        const updatedDoc = doc?.content.length ? doc : null;
                        fieldProps_0.onChange(updatedDoc);
                    });
                },
                onEditorReady: (actions)=>{
                    if (formData.description) actions.replaceDocument((0, $6rwn6.encodeAdf)(formData.description));
                }
            })),
        readView: ()=>/*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
                content: formData.description,
                productKey: productKey,
                siteId: cloudId
            }),
        onConfirm: (value_0)=>{
            handleOnChange('description', value_0);
        }
    })))));
};
function $a653455fc5911d13$var$_temp(t0) {
    const { ...fieldProps } = t0;
    return /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        ...fieldProps,
        isCompact: true
    });
}
module.exports["JsmCreateRequestActionUnifiedRenderer"] = $a653455fc5911d13$export$e33703d19a1b7a60;

});

parcelRegister("5tB2a", function(module, exports) {
const $972618e8675da849$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $972618e8675da849$export$a305f130b289b818;

});

parcelRegister("fm7Eo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $hWJgs = parcelRequire("hWJgs");


var $2qdFq = parcelRequire("2qdFq");

const $73d1e0ebe542fd80$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $73d1e0ebe542fd80$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentSection_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _2BK2Lld1Zr _1eOmH6d1Zr _3gzVzLJNoT",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP"
};
const $73d1e0ebe542fd80$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $2qdFq.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $73d1e0ebe542fd80$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $73d1e0ebe542fd80$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "create-request-type-card.expand-body-content"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $73d1e0ebe542fd80$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $73d1e0ebe542fd80$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "create-request-type-card.expand-body-content"
    }, formatMessage((0, $2qdFq.messages).expandBodyContent)));
};
const $73d1e0ebe542fd80$export$73d301eaa69d1e16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $2qdFq.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const el = contentSectionRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $73d1e0ebe542fd80$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[2] = t5;
    } else t5 = $[2];
    const measureBodyOverflow = t5;
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== payload.description || $[5] !== payload.name) {
        t7 = [
            payload.name,
            payload.description
        ];
        $[4] = payload.description;
        $[5] = payload.name;
        $[6] = t7;
    } else t7 = $[6];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            measureBodyOverflow();
        };
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== payload.description || $[9] !== payload.name || $[10] !== showExpandedBody) {
        t9 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.name,
            payload.description
        ];
        $[8] = payload.description;
        $[9] = payload.name;
        $[10] = showExpandedBody;
        $[11] = t9;
    } else t9 = $[11];
    (0, $cozmU.useLayoutEffect)(t8, t9);
    let t10;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t11 = [
            measureBodyOverflow
        ];
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t10, t11);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[14] = t12;
    } else t12 = $[14];
    const handleExpandBody = t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== ExpandCollapseIcon || $[17] !== formatMessage || $[18] !== heading || $[19] !== isClamped || $[20] !== isExpanded || $[21] !== isNextDisabled || $[22] !== isNextLoading || $[23] !== isSuccess || $[24] !== onNext || $[25] !== payload.description || $[26] !== payload.name || $[27] !== showExpandedBody) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t13
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $73d1e0ebe542fd80$var$styles.outermostWrapper,
            testId: "create-request-type-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hWJgs.CreateRequestTypeCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $2qdFq.messages).successPill, {
                name: payload.name
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $73d1e0ebe542fd80$var$styles.outerColumn,
            testId: "create-request-type-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($73d1e0ebe542fd80$var$styles.titleSection, !isExpanded && $73d1e0ebe542fd80$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $73d1e0ebe542fd80$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $73d1e0ebe542fd80$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $73d1e0ebe542fd80$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $2qdFq.messages).collapseSection : (0, $2qdFq.messages).expandSection),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "create-request-type-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $73d1e0ebe542fd80$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($73d1e0ebe542fd80$var$styles.contentSection, isClamped && $73d1e0ebe542fd80$var$styles.contentSection_clamped)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.name), payload.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, payload.description))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73d1e0ebe542fd80$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $73d1e0ebe542fd80$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "create-request-type-card.next"
        }, formatMessage((0, $2qdFq.messages).confirmButton))) : null)));
        $[16] = ExpandCollapseIcon;
        $[17] = formatMessage;
        $[18] = heading;
        $[19] = isClamped;
        $[20] = isExpanded;
        $[21] = isNextDisabled;
        $[22] = isNextLoading;
        $[23] = isSuccess;
        $[24] = onNext;
        $[25] = payload.description;
        $[26] = payload.name;
        $[27] = showExpandedBody;
        $[28] = t14;
    } else t14 = $[28];
    return t14;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $2qdFq.messages).cardTitle);
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $73d1e0ebe542fd80$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        payload.name,
        payload.description
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.name,
        payload.description
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $73d1e0ebe542fd80$var$styles.outermostWrapper,
        testId: "create-request-type-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hWJgs.CreateRequestTypeCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $2qdFq.messages).successPill, {
            name: payload.name
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $73d1e0ebe542fd80$var$styles.outerColumn,
        testId: "create-request-type-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($73d1e0ebe542fd80$var$styles.titleSection, !isExpanded && $73d1e0ebe542fd80$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $73d1e0ebe542fd80$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $73d1e0ebe542fd80$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $73d1e0ebe542fd80$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $2qdFq.messages).collapseSection : (0, $2qdFq.messages).expandSection),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "create-request-type-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $73d1e0ebe542fd80$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($73d1e0ebe542fd80$var$styles.contentSection, isClamped && $73d1e0ebe542fd80$var$styles.contentSection_clamped)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.name), payload.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, payload.description))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73d1e0ebe542fd80$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $73d1e0ebe542fd80$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "create-request-type-card.next"
    }, formatMessage((0, $2qdFq.messages).confirmButton))) : null)));
};
module.exports["CreateRequestTypeCard"] = $73d1e0ebe542fd80$export$73d301eaa69d1e16;

});

parcelRegister("cf3SG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $jlRK6 = parcelRequire("jlRK6");


var $cXtTj = parcelRequire("cXtTj");


var $4MnFz = parcelRequire("4MnFz");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $6rwn6 = parcelRequire("6rwn6");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $9qyl6 = parcelRequire("9qyl6");


var $7eUSO = parcelRequire("7eUSO");


var $3bHU3 = parcelRequire("3bHU3");


var $hTVUf = parcelRequire("hTVUf");


var $hsaYC = parcelRequire("hsaYC");

const $f90c1dc8d7a05bd4$var$styles = {
    negativeMarginTop: "_313842B0rP",
    fieldsWrapper: "_39xV02N91d",
    fieldLabel: "_3YEZNOdnbC"
};
const $f90c1dc8d7a05bd4$var$HIDDEN_FIELDS = [
    'serviceDeskId',
    'ServiceDeskId',
    'requestTypeId',
    'RequestTypeId'
];
const $f90c1dc8d7a05bd4$var$filterHiddenFields = (requestFieldValues)=>Object.fromEntries(Object.entries(requestFieldValues).filter(([key])=>!$f90c1dc8d7a05bd4$var$HIDDEN_FIELDS.includes(key)));
const $f90c1dc8d7a05bd4$export$b29dfd2f21fe021e = ({ onCustomDataActioned: _onCustomDataActioned, onCustomDataConfirm: onCustomDataConfirm, actions: actions, getStatus: getStatus, getReadonly: getReadonly, cloudId: cloudId, ContentRenderer: ContentRenderer, productKey: productKey, getCancelButton: getCancelButton, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId })=>{
    (0, $6cFsl.di)((0, $4MnFz.useFlags));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const action = actions[0];
    const status = getStatus(action);
    const readonly = getReadonly(action);
    const isActionDisabled = status !== 'idle' || readonly;
    const actionData = action.data; // Extract summary and description from either nested requestFieldValues or flat structure
    const getSummary = ()=>{
        return actionData.requestFieldValues?.summary || actionData.summary;
    };
    const getDescription = ()=>{
        return actionData.requestFieldValues?.description || actionData.description;
    }; // Extract field information, filtering out serviceDeskId and requestTypeId from display
    const fieldInfo = actionData.requestFieldValues ? (0, $hTVUf.createFieldInfoFromResponse)($f90c1dc8d7a05bd4$var$filterHiddenFields(actionData.requestFieldValues), action.metadata?.requestFieldNames || actionData.requestFieldNames) : [];
    const [inlineFormData, setInlineFormData] = (0, $cozmU.useState)({
        ...getSummary() && {
            summary: getSummary()
        },
        ...getDescription() && {
            description: getDescription()
        }
    });
    const handleStartChat = (0, $cozmU.useCallback)(async ()=>{
        if (isActionDisabled) return;
         // TODO: Remove this try/catch once the tools resumption migration is cleaned up
        // (kill switch and experiment removed, along with the legacy path).
        try {
            // Keep serviceDeskId and requestTypeId in the payload
            // but they're hidden from the UI
            const updatedData = {
                ...actionData,
                ...actionData.requestFieldValues ? {
                    requestFieldValues: {
                        ...actionData.requestFieldValues,
                        ...inlineFormData.summary && {
                            summary: inlineFormData.summary
                        },
                        ...inlineFormData.description && {
                            description: inlineFormData.description
                        }
                    }
                } : {
                    ...inlineFormData.summary && {
                        summary: inlineFormData.summary
                    },
                    ...inlineFormData.description && {
                        description: inlineFormData.description
                    }
                }
            };
            if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
                const plannedActions = actions.filter((action_0)=>getStatus(action_0) === 'idle');
                sendMessageConfirmedTools({
                    agentId: recipientAgentId,
                    conversationId: conversationId,
                    messageSources: {
                        interactionSource: 'jsmLivechatActionRenderer'
                    },
                    confirmed_tools: {
                        message_id: messageId ?? '',
                        tools: plannedActions.map((queuedAction)=>queuedAction.invocationId === action.invocationId ? (0, $7eUSO.buildToolFromAction)(queuedAction, 'confirmed', updatedData) : (0, $7eUSO.buildToolFromAction)(queuedAction, 'cancelled'))
                    }
                });
                return;
            }
            await onCustomDataConfirm(action, updatedData);
        } catch  {
            showFlag({
                id: 'jsm-livechat-error',
                title: formatMessage((0, $hsaYC.default).jsmLivechatErrorTitle),
                description: formatMessage((0, $hsaYC.default).jsmLivechatErrorDescription),
                appearance: 'error',
                isAutoDismiss: true
            });
        }
    }, [
        isActionDisabled,
        action,
        actions,
        actionData,
        inlineFormData,
        onCustomDataConfirm,
        showFlag,
        formatMessage,
        sendMessageConfirmedTools,
        recipientAgentId,
        conversationId,
        messageId,
        getStatus
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $f90c1dc8d7a05bd4$var$styles.negativeMarginTop
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $hsaYC.default).jsmLivechatInstruction, {
        startChatButtonCopy: /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "strong"
        }, formatMessage((0, $hsaYC.default).startChatButton))
    })), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        title: formatMessage((0, $hsaYC.default).jsmLivechatTitle),
        product: "jsm"
    }, /*#__PURE__*/ $cozmU.createElement($f90c1dc8d7a05bd4$var$JsmLivechatSuggestionPreview, {
        formData: inlineFormData,
        setFormData: setInlineFormData,
        isDisabled: isActionDisabled,
        action: action,
        productKey: productKey,
        cloudId: cloudId,
        ContentRenderer: ContentRenderer,
        messageId: "test-message-id"
    }), fieldInfo.length > 0 && /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $hsaYC.default).additionalFieldsLabel)), fieldInfo.map((field)=>/*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            key: field.id,
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $f90c1dc8d7a05bd4$var$styles.fieldLabel
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "semibold",
            size: "small"
        }, field.label, ":")), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, field.type === 'doc' ? /*#__PURE__*/ $cozmU.createElement(ContentRenderer // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , {
            content: field.value,
            productKey: productKey,
            siteId: cloudId
        }) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small"
        }, field.displayValue || 'Not set')))))), /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        type: "submit",
        isDisabled: isActionDisabled,
        isLoading: status === 'started',
        onClick: (_, e)=>{
            handleStartChat();
            sendAnalyticsEvent(e.update({
                actionSubjectId: 'rovoJsmLivechatSubmit'
            }));
        },
        interactionName: "ai-mate.jsm-livechat"
    }, formatMessage((0, $hsaYC.default).startChatButton)), getCancelButton(action, isActionDisabled)))));
};
const $f90c1dc8d7a05bd4$var$JsmLivechatSuggestionPreview = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { ContentRenderer: ContentRenderer, formData: formData, setFormData: setFormData, isDisabled: isDisabled, productKey: productKey, cloudId: cloudId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formData || $[1] !== setFormData) {
        t1 = (fieldName, fieldValue)=>{
            setFormData({
                ...formData,
                [fieldName]: fieldValue
            });
        };
        $[0] = formData;
        $[1] = setFormData;
        $[2] = t1;
    } else t1 = $[2];
    const handleOnChange = t1;
    let t2;
    if ($[3] !== cloudId || $[4] !== productKey) {
        t2 = {
            productKey: productKey,
            siteId: cloudId
        };
        $[3] = cloudId;
        $[4] = productKey;
        $[5] = t2;
    } else t2 = $[5];
    const { editorApi: editorApi, preset: preset } = (0, $3bHU3.useEditorPreset)(t2);
    let t3;
    if ($[6] !== formData.summary || $[7] !== formatMessage || $[8] !== handleOnChange || $[9] !== isDisabled) {
        t3 = formData.summary && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $hsaYC.default).summaryLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement("span", null, formData.summary) : /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            testId: "jsm-livechat-summary-field",
            defaultValue: formData.summary,
            editView: $f90c1dc8d7a05bd4$var$_temp,
            readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formData.summary),
            onConfirm: (value)=>handleOnChange("summary", value),
            readViewFitContainerWidth: true
        })));
        $[6] = formData.summary;
        $[7] = formatMessage;
        $[8] = handleOnChange;
        $[9] = isDisabled;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== ContentRenderer || $[12] !== cloudId || $[13] !== editorApi?.core || $[14] !== formData.description || $[15] !== formatMessage || $[16] !== handleOnChange || $[17] !== isDisabled || $[18] !== preset || $[19] !== productKey) {
        t4 = formData.description && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $hsaYC.default).descriptionLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
            content: formData.description,
            productKey: productKey,
            siteId: cloudId
        }) : /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            testId: "jsm-livechat-description-field",
            readViewFitContainerWidth: true,
            defaultValue: formData.description,
            keepEditViewOpenOnBlur: false,
            editView: (fieldProps_0, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    ref: ref
                }, /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                    minHeight: 50,
                    shouldFocus: true,
                    preset: preset,
                    maxHeight: 160,
                    appearance: "chromeless",
                    onChange: (_ev)=>{
                        editorApi?.core.actions.requestDocument((doc)=>{
                            const updatedDoc = doc?.content.length ? doc : null;
                            fieldProps_0.onChange(updatedDoc);
                        });
                    },
                    onEditorReady: (actions)=>{
                        if (formData.description) actions.replaceDocument((0, $6rwn6.encodeAdf)(formData.description));
                    }
                })),
            readView: ()=>/*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
                    content: formData.description,
                    productKey: productKey,
                    siteId: cloudId
                }),
            onConfirm: (value_0)=>{
                handleOnChange("description", value_0);
            }
        })));
        $[11] = ContentRenderer;
        $[12] = cloudId;
        $[13] = editorApi?.core;
        $[14] = formData.description;
        $[15] = formatMessage;
        $[16] = handleOnChange;
        $[17] = isDisabled;
        $[18] = preset;
        $[19] = productKey;
        $[20] = t4;
    } else t4 = $[20];
    let t5;
    if ($[21] !== t3 || $[22] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.150",
            direction: "column",
            xcss: $f90c1dc8d7a05bd4$var$styles.fieldsWrapper
        }, t3, t4));
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
    } else t5 = $[23];
    return t5;
} : ({ action: _action, ContentRenderer: ContentRenderer, formData: formData, setFormData: setFormData, isDisabled: isDisabled, productKey: productKey, cloudId: cloudId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleOnChange = (fieldName, fieldValue)=>{
        setFormData({
            ...formData,
            [fieldName]: fieldValue
        });
    };
    const { editorApi: editorApi, preset: preset } = (0, $3bHU3.useEditorPreset)({
        productKey: productKey,
        siteId: cloudId
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.150",
        direction: "column",
        xcss: $f90c1dc8d7a05bd4$var$styles.fieldsWrapper
    }, formData.summary && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $hsaYC.default).summaryLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement("span", null, formData.summary) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        testId: "jsm-livechat-summary-field",
        defaultValue: formData.summary,
        editView: ({ ...fieldProps })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                ...fieldProps,
                isCompact: true
            }),
        readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formData.summary),
        onConfirm: (value)=>handleOnChange('summary', value),
        readViewFitContainerWidth: true
    }))), formData.description && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $hsaYC.default).descriptionLabel)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, isDisabled ? /*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
        content: formData.description,
        productKey: productKey,
        siteId: cloudId
    }) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        testId: "jsm-livechat-description-field",
        readViewFitContainerWidth: true,
        defaultValue: formData.description,
        keepEditViewOpenOnBlur: false,
        editView: (fieldProps_0, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ref: ref
            }, /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                minHeight: 50,
                shouldFocus: true,
                preset: preset,
                maxHeight: 160,
                appearance: "chromeless",
                onChange: (_ev)=>{
                    editorApi?.core.actions.requestDocument((doc)=>{
                        const updatedDoc = doc?.content.length ? doc : null;
                        fieldProps_0.onChange(updatedDoc);
                    });
                },
                onEditorReady: (actions)=>{
                    if (formData.description) actions.replaceDocument((0, $6rwn6.encodeAdf)(formData.description));
                }
            })),
        readView: ()=>/*#__PURE__*/ $cozmU.createElement(ContentRenderer, {
                content: formData.description,
                productKey: productKey,
                siteId: cloudId
            }),
        onConfirm: (value_0)=>{
            handleOnChange('description', value_0);
        }
    })))));
};
function $f90c1dc8d7a05bd4$var$_temp(t0) {
    const { ...fieldProps } = t0;
    return /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        ...fieldProps,
        isCompact: true
    });
}
module.exports["JsmLivechatActionRenderer"] = $f90c1dc8d7a05bd4$export$b29dfd2f21fe021e;

});

parcelRegister("eexG9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $2uDbg = parcelRequire("2uDbg");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $bNNFr = parcelRequire("bNNFr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");


var $hMLWD = parcelRequire("hMLWD");


var $glSKz = parcelRequire("glSKz");


var $9R2yg = parcelRequire("9R2yg");

const $a621978a66dfec39$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _0NUa3rwBC3 _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3YEZNOdnbC _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    contentSection: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLFlnN _4xdlr0FlnN _4kiQYAdnbC _24h04i2Njc _2WAcuGIZbP _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    hardwareTypeItem: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d",
    hardwareTypeIcon: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    hardwareTypeIconImg: "_39xV02oWWg _0jFU0VoWWg",
    hardwareTypeName: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _3YEZNOdnbC _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $a621978a66dfec39$export$514443464f1372e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { payload: payload, onNext: onNext, onExpandToggle: onExpandToggle, onHardwareTypeToggle: onHardwareTypeToggle, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = new Set();
        $[0] = t4;
    } else t4 = $[0];
    const [selectedIndices, setSelectedIndices] = (0, $cozmU.useState)(t4);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t5;
    if ($[1] !== formatMessage) {
        t5 = formatMessage((0, $glSKz.messages).cardTitle);
        $[1] = formatMessage;
        $[2] = t5;
    } else t5 = $[2];
    const heading = t5;
    let t6;
    if ($[3] !== onHardwareTypeToggle || $[4] !== payload.hardwareTypes) {
        t6 = (index, checked)=>{
            setSelectedIndices((prev)=>{
                const nextSelectedIndices = new Set(prev);
                if (checked) nextSelectedIndices.add(index);
                else nextSelectedIndices.delete(index);
                return nextSelectedIndices;
            });
            onHardwareTypeToggle?.(payload.hardwareTypes[index]?.displayName ?? "", checked);
        };
        $[3] = onHardwareTypeToggle;
        $[4] = payload.hardwareTypes;
        $[5] = t6;
    } else t6 = $[5];
    const handleCheckboxChange = t6;
    const hasSelection = selectedIndices.size > 0;
    let t7;
    if ($[6] !== isExpanded || $[7] !== onExpandToggle) {
        t7 = ()=>{
            const nextIsExpanded = !isExpanded;
            setIsExpanded(nextIsExpanded);
            onExpandToggle?.(nextIsExpanded);
        };
        $[6] = isExpanded;
        $[7] = onExpandToggle;
        $[8] = t7;
    } else t7 = $[8];
    const handleExpandToggle = t7;
    let t8;
    if ($[9] !== onNext || $[10] !== payload.hardwareTypes || $[11] !== selectedIndices) {
        t8 = ()=>{
            const selectedDisplayNames = payload.hardwareTypes.filter((_, index_0)=>selectedIndices.has(index_0)).map($a621978a66dfec39$var$_temp);
            onNext(selectedDisplayNames);
        };
        $[9] = onNext;
        $[10] = payload.hardwareTypes;
        $[11] = selectedIndices;
        $[12] = t8;
    } else t8 = $[12];
    const handleNext = t8;
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== ExpandCollapseIcon || $[15] !== formatMessage || $[16] !== handleCheckboxChange || $[17] !== handleExpandToggle || $[18] !== handleNext || $[19] !== hasSelection || $[20] !== heading || $[21] !== isExpanded || $[22] !== isNextDisabled || $[23] !== isNextLoading || $[24] !== isSuccess || $[25] !== payload.hardwareTypes || $[26] !== selectedIndices || $[27] !== showExpandedBody) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t9
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a621978a66dfec39$var$styles.outermostWrapper,
            testId: "select-hardware-types-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9R2yg.SelectHardwareTypesCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $glSKz.messages).successPill)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a621978a66dfec39$var$styles.outerColumn,
            testId: "select-hardware-types-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($a621978a66dfec39$var$styles.titleSection, !isExpanded && $a621978a66dfec39$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a621978a66dfec39$var$styles.headerIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNNFr))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a621978a66dfec39$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a621978a66dfec39$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $glSKz.messages).collapseSection : (0, $glSKz.messages).expandSection),
            appearance: "subtle",
            spacing: "compact",
            onClick: handleExpandToggle,
            testId: "select-hardware-types-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a621978a66dfec39$var$styles.contentSection,
            testId: "select-hardware-types-card.options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, payload.hardwareTypes.map((hardwareType_0, index_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: index_1,
                xcss: $a621978a66dfec39$var$styles.hardwareTypeItem
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                isChecked: selectedIndices.has(index_1),
                onChange: (event)=>handleCheckboxChange(index_1, event.currentTarget.checked),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    gap: "space.100",
                    alignItems: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $a621978a66dfec39$var$styles.hardwareTypeIcon
                }, hardwareType_0.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    as: "img",
                    src: hardwareType_0.iconUrl,
                    alt: "",
                    xcss: $a621978a66dfec39$var$styles.hardwareTypeIconImg
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNNFr))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $a621978a66dfec39$var$styles.hardwareTypeName
                }, hardwareType_0.displayName)),
                testId: `select-hardware-types-card.checkbox-${index_1}`
            }))))) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a621978a66dfec39$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled || !hasSelection,
            testId: "select-hardware-types-card.next"
        }, formatMessage((0, $glSKz.messages).confirmButton))) : null)));
        $[14] = ExpandCollapseIcon;
        $[15] = formatMessage;
        $[16] = handleCheckboxChange;
        $[17] = handleExpandToggle;
        $[18] = handleNext;
        $[19] = hasSelection;
        $[20] = heading;
        $[21] = isExpanded;
        $[22] = isNextDisabled;
        $[23] = isNextLoading;
        $[24] = isSuccess;
        $[25] = payload.hardwareTypes;
        $[26] = selectedIndices;
        $[27] = showExpandedBody;
        $[28] = t10;
    } else t10 = $[28];
    return t10;
} : ({ payload: payload, onNext: onNext, onExpandToggle: onExpandToggle, onHardwareTypeToggle: onHardwareTypeToggle, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [selectedIndices, setSelectedIndices] = (0, $cozmU.useState)(new Set());
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $glSKz.messages).cardTitle);
    const handleCheckboxChange = (index, checked)=>{
        setSelectedIndices((prev)=>{
            const nextSelectedIndices = new Set(prev);
            if (checked) nextSelectedIndices.add(index);
            else nextSelectedIndices.delete(index);
            return nextSelectedIndices;
        });
        onHardwareTypeToggle?.(payload.hardwareTypes[index]?.displayName ?? '', checked);
    };
    const hasSelection = selectedIndices.size > 0;
    const handleExpandToggle = ()=>{
        const nextIsExpanded = !isExpanded;
        setIsExpanded(nextIsExpanded);
        onExpandToggle?.(nextIsExpanded);
    };
    const handleNext = ()=>{
        const selectedDisplayNames = payload.hardwareTypes.filter((_, index_0)=>selectedIndices.has(index_0)).map((hardwareType)=>hardwareType.displayName);
        onNext(selectedDisplayNames);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a621978a66dfec39$var$styles.outermostWrapper,
        testId: "select-hardware-types-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9R2yg.SelectHardwareTypesCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $glSKz.messages).successPill)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a621978a66dfec39$var$styles.outerColumn,
        testId: "select-hardware-types-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($a621978a66dfec39$var$styles.titleSection, !isExpanded && $a621978a66dfec39$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a621978a66dfec39$var$styles.headerIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNNFr))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a621978a66dfec39$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a621978a66dfec39$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $glSKz.messages).collapseSection : (0, $glSKz.messages).expandSection),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleExpandToggle,
        testId: "select-hardware-types-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a621978a66dfec39$var$styles.contentSection,
        testId: "select-hardware-types-card.options"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, payload.hardwareTypes.map((hardwareType_0, index_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: index_1,
            xcss: $a621978a66dfec39$var$styles.hardwareTypeItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            isChecked: selectedIndices.has(index_1),
            onChange: (event)=>handleCheckboxChange(index_1, event.currentTarget.checked),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                gap: "space.100",
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a621978a66dfec39$var$styles.hardwareTypeIcon
            }, hardwareType_0.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "img",
                src: hardwareType_0.iconUrl,
                alt: "",
                xcss: $a621978a66dfec39$var$styles.hardwareTypeIconImg
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNNFr))), {
                label: "",
                color: "var(--ds-icon, #292A2E)"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a621978a66dfec39$var$styles.hardwareTypeName
            }, hardwareType_0.displayName)),
            testId: `select-hardware-types-card.checkbox-${index_1}`
        }))))) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a621978a66dfec39$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled || !hasSelection,
        testId: "select-hardware-types-card.next"
    }, formatMessage((0, $glSKz.messages).confirmButton))) : null)));
};
function $a621978a66dfec39$var$_temp(hardwareType) {
    return hardwareType.displayName;
}
module.exports["SelectHardwareTypesCard"] = $a621978a66dfec39$export$514443464f1372e1;

});

parcelRegister("g9AEK", function(module, exports) {
const $6402798e1a8dc536$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
const $6402798e1a8dc536$export$f1d163dd7ab2778a = 'rovo-create-view-space';
module.exports["analyticsAttributes"] = $6402798e1a8dc536$export$a305f130b289b818;
module.exports["ROVO_CREATE_VIEW_SPACE_SOURCE"] = $6402798e1a8dc536$export$f1d163dd7ab2778a;

});

parcelRegister("ceCEH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $GMBc0 = parcelRequire("GMBc0");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $hMLWD = parcelRequire("hMLWD");


var $hu68Y = parcelRequire("hu68Y");


var $2u2Ud = parcelRequire("2u2Ud");


var $hLTYT = parcelRequire("hLTYT");


var $79CeW = parcelRequire("79CeW");

const $208f6c4f3ec2d8cf$var$styles = {
    container: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0KLXruqi9L _2OUyjtzwhj"
};
const $208f6c4f3ec2d8cf$var$ChannelAccessValue = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($GMBc0))), {
            label: "",
            color: "currentColor",
            testId: "jsm-solution-composer-plan-task-card.channel-access-icon"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $79CeW.messages).channelAccessClosedValue);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            space: "space.050",
            alignBlock: "center"
        }, t0, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($GMBc0))), {
        label: "",
        color: "currentColor",
        testId: "jsm-solution-composer-plan-task-card.channel-access-icon"
    }), formatMessage((0, $79CeW.messages).channelAccessClosedValue));
};
const $208f6c4f3ec2d8cf$export$45966d051be1808a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { title: title, sections: sections, onCreateSpace: onCreateSpace, isExecuted: isExecuted, projectKey: projectKey, projectName: projectName, isDisabled: isDisabled } = t0;
    (0, $6cFsl.di)((0, $hLTYT.TaskCardHeader), (0, $hu68Y.TaskCardContent), (0, $2u2Ud.TaskCardFooter));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasBeenActioned, setHasBeenActioned] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setHasBeenActioned(true);
        $[0] = t1;
    } else t1 = $[0];
    const handleActioned = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $iDrrr.fg)("rovo_chat_jsm_composer_s2_space_key_validation");
        $[1] = t2;
    } else t2 = $[1];
    const isSpaceKeyValidationEnabled = t2;
    let t3;
    if ($[2] !== formatMessage || $[3] !== projectKey || $[4] !== projectName || $[5] !== title) {
        t3 = isSpaceKeyValidationEnabled ? [
            {
                label: formatMessage((0, $79CeW.messages).spaceNameLabel),
                value: projectName ?? title
            },
            {
                label: formatMessage((0, $79CeW.messages).spaceKeyLabel),
                value: projectKey ?? ""
            },
            {
                label: formatMessage((0, $79CeW.messages).channelAccessLabel),
                value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($208f6c4f3ec2d8cf$var$ChannelAccessValue, null)
            }
        ] : undefined;
        $[2] = formatMessage;
        $[3] = projectKey;
        $[4] = projectName;
        $[5] = title;
        $[6] = t3;
    } else t3 = $[6];
    const summaryItems = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage || $[9] !== title) {
        t5 = isSpaceKeyValidationEnabled ? formatMessage((0, $79CeW.messages).cardTitle) : title;
        $[8] = formatMessage;
        $[9] = title;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== isExpanded) {
        t6 = ()=>setIsExpanded(!isExpanded);
        $[11] = isExpanded;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== isExpanded || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLTYT.TaskCardHeader), {
            title: t5,
            isExpanded: isExpanded,
            onToggle: t6
        });
        $[13] = isExpanded;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== hasBeenActioned || $[18] !== isDisabled || $[19] !== isExecuted || $[20] !== isExpanded || $[21] !== onCreateSpace || $[22] !== projectKey || $[23] !== sections || $[24] !== summaryItems) {
        t8 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu68Y.TaskCardContent), {
            sections: sections,
            summaryItems: summaryItems
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2u2Ud.TaskCardFooter), {
            onCreateSpace: onCreateSpace,
            isExecuted: isExecuted,
            projectKey: projectKey,
            isDisabled: isDisabled,
            hasBeenActioned: hasBeenActioned,
            onActioned: handleActioned
        })) : null;
        $[17] = hasBeenActioned;
        $[18] = isDisabled;
        $[19] = isExecuted;
        $[20] = isExpanded;
        $[21] = onCreateSpace;
        $[22] = projectKey;
        $[23] = sections;
        $[24] = summaryItems;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== t7 || $[27] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $208f6c4f3ec2d8cf$var$styles.container,
            testId: "jsm-solution-composer-plan-task-card"
        }, t7, t8));
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    return t9;
} : ({ title: title, sections: sections, onCreateSpace: onCreateSpace, isExecuted: isExecuted, projectKey: projectKey, projectName: projectName, isDisabled: isDisabled })=>{
    (0, $6cFsl.di)((0, $hLTYT.TaskCardHeader), (0, $hu68Y.TaskCardContent), (0, $2u2Ud.TaskCardFooter));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasBeenActioned, setHasBeenActioned] = (0, $cozmU.useState)(false);
    const handleActioned = (0, $cozmU.useCallback)(()=>setHasBeenActioned(true), []);
    const isSpaceKeyValidationEnabled = (0, $iDrrr.fg)('rovo_chat_jsm_composer_s2_space_key_validation');
    const summaryItems = isSpaceKeyValidationEnabled ? [
        {
            label: formatMessage((0, $79CeW.messages).spaceNameLabel),
            value: projectName ?? title
        },
        {
            label: formatMessage((0, $79CeW.messages).spaceKeyLabel),
            value: projectKey ?? ''
        },
        {
            label: formatMessage((0, $79CeW.messages).channelAccessLabel),
            value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($208f6c4f3ec2d8cf$var$ChannelAccessValue, null)
        }
    ] : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $208f6c4f3ec2d8cf$var$styles.container,
        testId: "jsm-solution-composer-plan-task-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLTYT.TaskCardHeader), {
        title: isSpaceKeyValidationEnabled ? formatMessage((0, $79CeW.messages).cardTitle) : title,
        isExpanded: isExpanded,
        onToggle: ()=>setIsExpanded(!isExpanded)
    }), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu68Y.TaskCardContent), {
        sections: sections,
        summaryItems: summaryItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2u2Ud.TaskCardFooter), {
        onCreateSpace: onCreateSpace,
        isExecuted: isExecuted,
        projectKey: projectKey,
        isDisabled: isDisabled,
        hasBeenActioned: hasBeenActioned,
        onActioned: handleActioned
    })) : null));
};
module.exports["TaskCard"] = $208f6c4f3ec2d8cf$export$45966d051be1808a;

});

parcelRegister("cp2w0", function(module, exports) {
const $451d5c58692b457e$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $451d5c58692b457e$export$a305f130b289b818;

});

parcelRegister("3M9ch", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $1sFBi = parcelRequire("1sFBi");


var $g6QTb = parcelRequire("g6QTb");

const $6056491925e4e449$var$EMPTY_COLUMNS = [];
const $6056491925e4e449$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $6056491925e4e449$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentSection_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _2BK2Lld1Zr _1eOmH6d1Zr _3gzVzLJNoT",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    fieldList: "_2mHwu8gVvo _43nrzTdnbC _0rIjykdnbC _0LQT5EkG2W _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $6056491925e4e449$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $1sFBi.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6056491925e4e449$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $6056491925e4e449$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "update-queue-card.expand-body-content"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6056491925e4e449$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $6056491925e4e449$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "update-queue-card.expand-body-content"
    }, formatMessage((0, $1sFBi.messages).expandBodyContent)));
};
const $6056491925e4e449$export$3348182dd308ff4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $1sFBi.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    const columns = payload.columns ?? $6056491925e4e449$var$EMPTY_COLUMNS;
    const hasColumns = columns.length > 0;
    let t5;
    if ($[2] !== columns) {
        t5 = columns.join("\0");
        $[2] = columns;
        $[3] = t5;
    } else t5 = $[3];
    const columnsSignature = t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            const el = contentSectionRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $6056491925e4e449$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[4] = t6;
    } else t6 = $[4];
    const measureBodyOverflow = t6;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== columnsSignature || $[7] !== payload.jql || $[8] !== payload.name) {
        t8 = [
            payload.name,
            payload.jql,
            columnsSignature
        ];
        $[6] = columnsSignature;
        $[7] = payload.jql;
        $[8] = payload.name;
        $[9] = t8;
    } else t8 = $[9];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            measureBodyOverflow();
        };
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== columnsSignature || $[12] !== payload.jql || $[13] !== payload.name || $[14] !== showExpandedBody) {
        t10 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.name,
            payload.jql,
            columnsSignature
        ];
        $[11] = columnsSignature;
        $[12] = payload.jql;
        $[13] = payload.name;
        $[14] = showExpandedBody;
        $[15] = t10;
    } else t10 = $[15];
    (0, $cozmU.useLayoutEffect)(t9, t10);
    let t11;
    let t12;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t12 = [
            measureBodyOverflow
        ];
        $[16] = t11;
        $[17] = t12;
    } else {
        t11 = $[16];
        t12 = $[17];
    }
    (0, $cozmU.useLayoutEffect)(t11, t12);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t13;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[18] = t13;
    } else t13 = $[18];
    const handleExpandBody = t13;
    let t14;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[19] = t14;
    } else t14 = $[19];
    let t15;
    if ($[20] !== ExpandCollapseIcon || $[21] !== columns || $[22] !== formatMessage || $[23] !== hasColumns || $[24] !== heading || $[25] !== isClamped || $[26] !== isExpanded || $[27] !== isNextDisabled || $[28] !== isNextLoading || $[29] !== isSuccess || $[30] !== onNext || $[31] !== payload.jql || $[32] !== payload.name || $[33] !== payload.queueName || $[34] !== showExpandedBody) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t14
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6056491925e4e449$var$styles.outermostWrapper,
            testId: "update-queue-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g6QTb.UpdateQueueCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $1sFBi.messages).successPill, {
                name: payload.queueName
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6056491925e4e449$var$styles.outerColumn,
            testId: "update-queue-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($6056491925e4e449$var$styles.titleSection, !isExpanded && $6056491925e4e449$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $6056491925e4e449$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6056491925e4e449$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6056491925e4e449$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $1sFBi.messages).collapseBodyContent : (0, $1sFBi.messages).expandBodyContent),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "update-queue-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6056491925e4e449$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($6056491925e4e449$var$styles.contentSection, isClamped && $6056491925e4e449$var$styles.contentSection_clamped)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.queueName), payload.name !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $1sFBi.messages).nameFieldLabel, {
            currentName: payload.queueName,
            newName: payload.name,
            bold: $6056491925e4e449$var$_temp
        })), payload.jql !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, formatMessage((0, $1sFBi.messages).jqlFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, payload.jql)), hasColumns ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, formatMessage((0, $1sFBi.messages).columnsFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $6056491925e4e449$var$styles.fieldList
        }, columns.map($6056491925e4e449$var$_temp2))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $1sFBi.messages).emptyColumnsDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6056491925e4e449$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $6056491925e4e449$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "update-queue-card.next"
        }, formatMessage((0, $1sFBi.messages).confirmButton))) : null)));
        $[20] = ExpandCollapseIcon;
        $[21] = columns;
        $[22] = formatMessage;
        $[23] = hasColumns;
        $[24] = heading;
        $[25] = isClamped;
        $[26] = isExpanded;
        $[27] = isNextDisabled;
        $[28] = isNextLoading;
        $[29] = isSuccess;
        $[30] = onNext;
        $[31] = payload.jql;
        $[32] = payload.name;
        $[33] = payload.queueName;
        $[34] = showExpandedBody;
        $[35] = t15;
    } else t15 = $[35];
    return t15;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $1sFBi.messages).cardTitle);
    const columns = payload.columns ?? $6056491925e4e449$var$EMPTY_COLUMNS;
    const hasColumns = columns.length > 0;
    const columnsSignature = columns.join('\u0000');
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $6056491925e4e449$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        payload.name,
        payload.jql,
        columnsSignature
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.name,
        payload.jql,
        columnsSignature
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6056491925e4e449$var$styles.outermostWrapper,
        testId: "update-queue-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g6QTb.UpdateQueueCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $1sFBi.messages).successPill, {
            name: payload.queueName
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6056491925e4e449$var$styles.outerColumn,
        testId: "update-queue-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($6056491925e4e449$var$styles.titleSection, !isExpanded && $6056491925e4e449$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $6056491925e4e449$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6056491925e4e449$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6056491925e4e449$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $1sFBi.messages).collapseBodyContent : (0, $1sFBi.messages).expandBodyContent),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "update-queue-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6056491925e4e449$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($6056491925e4e449$var$styles.contentSection, isClamped && $6056491925e4e449$var$styles.contentSection_clamped)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.queueName), payload.name !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $1sFBi.messages).nameFieldLabel, {
        currentName: payload.queueName,
        newName: payload.name,
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "span",
                weight: "bold"
            }, chunks)
    })), payload.jql !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $1sFBi.messages).jqlFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, payload.jql)), hasColumns ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $1sFBi.messages).columnsFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $6056491925e4e449$var$styles.fieldList
    }, columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: `${column}-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, column))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $1sFBi.messages).emptyColumnsDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6056491925e4e449$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $6056491925e4e449$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "update-queue-card.next"
    }, formatMessage((0, $1sFBi.messages).confirmButton))) : null)));
};
function $6056491925e4e449$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "bold"
    }, chunks);
}
function $6056491925e4e449$var$_temp2(column, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        key: `${column}-${index}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, column));
}
module.exports["UpdateQueueCard"] = $6056491925e4e449$export$3348182dd308ff4;

});

parcelRegister("856Cd", function(module, exports) {
const $147bb8bd9c3263b9$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $147bb8bd9c3263b9$export$a305f130b289b818;

});

parcelRegister("j1Rh2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $4QeNf = parcelRequire("4QeNf");


var $8eiw2 = parcelRequire("8eiw2");

const $27b5a0eeabd6e5fa$var$EMPTY_QUEUES = [];
const $27b5a0eeabd6e5fa$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $27b5a0eeabd6e5fa$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentSection_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _2BK2Lld1Zr _1eOmH6d1Zr _3gzVzLJNoT",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    queueList: "_2mHwu8gVvo _43nrzTdnbC _0rIjykdnbC _0LQT5EkG2W _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $27b5a0eeabd6e5fa$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $4QeNf.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27b5a0eeabd6e5fa$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $27b5a0eeabd6e5fa$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "update-queue-group-card.expand-body-content"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27b5a0eeabd6e5fa$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $27b5a0eeabd6e5fa$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "update-queue-group-card.expand-body-content"
    }, formatMessage((0, $4QeNf.messages).expandBodyContent)));
};
const $27b5a0eeabd6e5fa$export$fe5cb1e637ec9bdb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $4QeNf.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    const queues = payload.queues ?? $27b5a0eeabd6e5fa$var$EMPTY_QUEUES;
    const hasQueues = queues.length > 0;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const el = contentSectionRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $27b5a0eeabd6e5fa$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[2] = t5;
    } else t5 = $[2];
    const measureBodyOverflow = t5;
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== payload.name || $[5] !== queues) {
        t7 = [
            payload.name,
            queues
        ];
        $[4] = payload.name;
        $[5] = queues;
        $[6] = t7;
    } else t7 = $[6];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            measureBodyOverflow();
        };
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== payload.name || $[9] !== queues || $[10] !== showExpandedBody) {
        t9 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.name,
            queues
        ];
        $[8] = payload.name;
        $[9] = queues;
        $[10] = showExpandedBody;
        $[11] = t9;
    } else t9 = $[11];
    (0, $cozmU.useLayoutEffect)(t8, t9);
    let t10;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t11 = [
            measureBodyOverflow
        ];
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t10, t11);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[14] = t12;
    } else t12 = $[14];
    const handleExpandBody = t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== ExpandCollapseIcon || $[17] !== formatMessage || $[18] !== hasQueues || $[19] !== heading || $[20] !== isClamped || $[21] !== isExpanded || $[22] !== isNextDisabled || $[23] !== isNextLoading || $[24] !== isSuccess || $[25] !== onNext || $[26] !== payload.name || $[27] !== queues || $[28] !== showExpandedBody) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t13
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27b5a0eeabd6e5fa$var$styles.outermostWrapper,
            testId: "update-queue-group-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8eiw2.UpdateQueueGroupCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $4QeNf.messages).successPill, {
                name: payload.name
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27b5a0eeabd6e5fa$var$styles.outerColumn,
            testId: "update-queue-group-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($27b5a0eeabd6e5fa$var$styles.titleSection, !isExpanded && $27b5a0eeabd6e5fa$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $27b5a0eeabd6e5fa$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27b5a0eeabd6e5fa$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27b5a0eeabd6e5fa$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $4QeNf.messages).collapseBodyContent : (0, $4QeNf.messages).expandBodyContent),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "update-queue-group-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $27b5a0eeabd6e5fa$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($27b5a0eeabd6e5fa$var$styles.contentSection, isClamped && $27b5a0eeabd6e5fa$var$styles.contentSection_clamped)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.name), hasQueues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $4QeNf.messages).queuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $27b5a0eeabd6e5fa$var$styles.queueList
        }, queues.map($27b5a0eeabd6e5fa$var$_temp))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $4QeNf.messages).emptyQueuesDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($27b5a0eeabd6e5fa$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $27b5a0eeabd6e5fa$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "update-queue-group-card.next"
        }, formatMessage((0, $4QeNf.messages).confirmButton))) : null)));
        $[16] = ExpandCollapseIcon;
        $[17] = formatMessage;
        $[18] = hasQueues;
        $[19] = heading;
        $[20] = isClamped;
        $[21] = isExpanded;
        $[22] = isNextDisabled;
        $[23] = isNextLoading;
        $[24] = isSuccess;
        $[25] = onNext;
        $[26] = payload.name;
        $[27] = queues;
        $[28] = showExpandedBody;
        $[29] = t14;
    } else t14 = $[29];
    return t14;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $4QeNf.messages).cardTitle);
    const queues = payload.queues ?? $27b5a0eeabd6e5fa$var$EMPTY_QUEUES;
    const hasQueues = queues.length > 0;
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $27b5a0eeabd6e5fa$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        payload.name,
        queues
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.name,
        queues
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27b5a0eeabd6e5fa$var$styles.outermostWrapper,
        testId: "update-queue-group-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8eiw2.UpdateQueueGroupCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $4QeNf.messages).successPill, {
            name: payload.name
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27b5a0eeabd6e5fa$var$styles.outerColumn,
        testId: "update-queue-group-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($27b5a0eeabd6e5fa$var$styles.titleSection, !isExpanded && $27b5a0eeabd6e5fa$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $27b5a0eeabd6e5fa$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27b5a0eeabd6e5fa$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27b5a0eeabd6e5fa$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $4QeNf.messages).collapseBodyContent : (0, $4QeNf.messages).expandBodyContent),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "update-queue-group-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $27b5a0eeabd6e5fa$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($27b5a0eeabd6e5fa$var$styles.contentSection, isClamped && $27b5a0eeabd6e5fa$var$styles.contentSection_clamped)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.name), hasQueues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $4QeNf.messages).queuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $27b5a0eeabd6e5fa$var$styles.queueList
    }, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: queue.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, queue.name))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $4QeNf.messages).emptyQueuesDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($27b5a0eeabd6e5fa$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $27b5a0eeabd6e5fa$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "update-queue-group-card.next"
    }, formatMessage((0, $4QeNf.messages).confirmButton))) : null)));
};
function $27b5a0eeabd6e5fa$var$_temp(queue) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        key: queue.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, queue.name));
}
module.exports["UpdateQueueGroupCard"] = $27b5a0eeabd6e5fa$export$fe5cb1e637ec9bdb;

});

parcelRegister("9SCtB", function(module, exports) {
const $042e6f9e47f54c5d$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $042e6f9e47f54c5d$export$a305f130b289b818;

});

parcelRegister("5NIGF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $c1wJY = parcelRequire("c1wJY");


var $fs2ae = parcelRequire("fs2ae");

const $362ff9eadcba8ff0$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _0jFU0VbUtj _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _2WAcuGnQyn",
    contentSection_bodyExpanded: "_0jFU0VIZbP _2WAcuGYvD1",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oLfAA _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _23rrnHQ4MZ _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXru7Cj1 _42Yu6BgtVO _1YKVNsdnbC _1eOmH6qWX3 _3gzVzLutHW",
    showMoreButtonVisible: "_23rrnHWgmT _1YKVNs7dHp",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    fieldList: "_2mHwu8gVvo _43nrzTdnbC _0rIjykdnbC _0LQT5EkG2W _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $362ff9eadcba8ff0$var$BodyContentShowMoreToggle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isBodyExpanded: isBodyExpanded, onToggle: onToggle } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsHovered(true);
        t2 = ()=>setIsHovered(false);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    const t3 = isHovered && $362ff9eadcba8ff0$var$styles.showMoreButtonVisible;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $w6R6I.cx)($362ff9eadcba8ff0$var$styles.showMoreButton, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = isBodyExpanded ? (0, $c1wJY.messages).collapseBodyContent : (0, $c1wJY.messages).expandBodyContent;
    let t6;
    if ($[4] !== formatMessage || $[5] !== t5) {
        t6 = formatMessage(t5);
        $[4] = formatMessage;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== onToggle || $[8] !== t4 || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362ff9eadcba8ff0$var$styles.fadeOffZone,
            onMouseEnter: t1,
            onMouseLeave: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: t4,
            onClick: onToggle,
            testId: "update-request-type-card.expand-body-content"
        }, t6));
        $[7] = onToggle;
        $[8] = t4;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
} : ({ isBodyExpanded: isBodyExpanded, onToggle: onToggle })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362ff9eadcba8ff0$var$styles.fadeOffZone,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($362ff9eadcba8ff0$var$styles.showMoreButton, isHovered && $362ff9eadcba8ff0$var$styles.showMoreButtonVisible),
        onClick: onToggle,
        testId: "update-request-type-card.expand-body-content"
    }, formatMessage(isBodyExpanded ? (0, $c1wJY.messages).collapseBodyContent : (0, $c1wJY.messages).expandBodyContent)));
};
const $362ff9eadcba8ff0$export$44b39dee2c066898 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [isBodyContentExpanded, setIsBodyContentExpanded] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $c1wJY.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    let t5;
    if ($[2] !== payload.fieldNames) {
        t5 = payload.fieldNames ?? [];
        $[2] = payload.fieldNames;
        $[3] = t5;
    } else t5 = $[3];
    const fieldNames = t5;
    let t6;
    if ($[4] !== fieldNames) {
        t6 = fieldNames.join("\0");
        $[4] = fieldNames;
        $[5] = t6;
    } else t6 = $[5];
    const fieldNamesSignature = t6;
    let t7;
    if ($[6] !== isBodyContentExpanded) {
        t7 = ()=>{
            const el = contentSectionRef.current;
            if (!el || isBodyContentExpanded) return;
            setHasTruncatableBodyContent(el.scrollHeight > el.clientHeight);
        };
        $[6] = isBodyContentExpanded;
        $[7] = t7;
    } else t7 = $[7];
    const measureBodyOverflow = t7;
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setIsBodyContentExpanded(false);
        };
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== fieldNamesSignature || $[10] !== payload.requestTypeName) {
        t9 = [
            payload.requestTypeName,
            fieldNamesSignature
        ];
        $[9] = fieldNamesSignature;
        $[10] = payload.requestTypeName;
        $[11] = t9;
    } else t9 = $[11];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[12] !== measureBodyOverflow) {
        t10 = ()=>{
            measureBodyOverflow();
        };
        $[12] = measureBodyOverflow;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== fieldNamesSignature || $[15] !== measureBodyOverflow || $[16] !== payload.requestTypeName || $[17] !== showExpandedBody) {
        t11 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.requestTypeName,
            fieldNamesSignature
        ];
        $[14] = fieldNamesSignature;
        $[15] = measureBodyOverflow;
        $[16] = payload.requestTypeName;
        $[17] = showExpandedBody;
        $[18] = t11;
    } else t11 = $[18];
    (0, $cozmU.useLayoutEffect)(t10, t11);
    let t12;
    let t13;
    if ($[19] !== measureBodyOverflow) {
        t12 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t13 = [
            measureBodyOverflow
        ];
        $[19] = measureBodyOverflow;
        $[20] = t12;
        $[21] = t13;
    } else {
        t12 = $[20];
        t13 = $[21];
    }
    (0, $cozmU.useLayoutEffect)(t12, t13);
    let t14;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== ExpandCollapseIcon || $[24] !== fieldNames || $[25] !== formatMessage || $[26] !== hasTruncatableBodyContent || $[27] !== heading || $[28] !== isBodyContentExpanded || $[29] !== isExpanded || $[30] !== isNextDisabled || $[31] !== isNextLoading || $[32] !== isSuccess || $[33] !== onNext || $[34] !== payload.requestTypeName || $[35] !== showExpandedBody) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t14
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362ff9eadcba8ff0$var$styles.outermostWrapper,
            testId: "update-request-type-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs2ae.UpdateRequestTypeCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $c1wJY.messages).successPill, {
                requestType: payload.requestTypeName ?? ""
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362ff9eadcba8ff0$var$styles.outerColumn,
            testId: "update-request-type-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($362ff9eadcba8ff0$var$styles.titleSection, !isExpanded && $362ff9eadcba8ff0$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $362ff9eadcba8ff0$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362ff9eadcba8ff0$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362ff9eadcba8ff0$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $c1wJY.messages).collapseSection : (0, $c1wJY.messages).expandSection),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "update-request-type-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362ff9eadcba8ff0$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($362ff9eadcba8ff0$var$styles.contentSection, isBodyContentExpanded && $362ff9eadcba8ff0$var$styles.contentSection_bodyExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.requestTypeName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $c1wJY.messages).fieldsToAddHeading)), fieldNames.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $362ff9eadcba8ff0$var$styles.fieldList
        }, fieldNames.map($362ff9eadcba8ff0$var$_temp))))), hasTruncatableBodyContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($362ff9eadcba8ff0$var$BodyContentShowMoreToggle, {
            isBodyExpanded: isBodyContentExpanded,
            onToggle: ()=>setIsBodyContentExpanded(!isBodyContentExpanded)
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $362ff9eadcba8ff0$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "update-request-type-card.next"
        }, formatMessage((0, $c1wJY.messages).nextButton))) : null)));
        $[23] = ExpandCollapseIcon;
        $[24] = fieldNames;
        $[25] = formatMessage;
        $[26] = hasTruncatableBodyContent;
        $[27] = heading;
        $[28] = isBodyContentExpanded;
        $[29] = isExpanded;
        $[30] = isNextDisabled;
        $[31] = isNextLoading;
        $[32] = isSuccess;
        $[33] = onNext;
        $[34] = payload.requestTypeName;
        $[35] = showExpandedBody;
        $[36] = t15;
    } else t15 = $[36];
    return t15;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [isBodyContentExpanded, setIsBodyContentExpanded] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $c1wJY.messages).cardTitle);
    const fieldNames = payload.fieldNames ?? [];
    const fieldNamesSignature = fieldNames.join('\u0000');
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el || isBodyContentExpanded) return;
        setHasTruncatableBodyContent(el.scrollHeight > el.clientHeight);
    }, [
        isBodyContentExpanded
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsBodyContentExpanded(false);
    }, [
        payload.requestTypeName,
        fieldNamesSignature
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.requestTypeName,
        fieldNamesSignature
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362ff9eadcba8ff0$var$styles.outermostWrapper,
        testId: "update-request-type-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs2ae.UpdateRequestTypeCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $c1wJY.messages).successPill, {
            requestType: payload.requestTypeName ?? ''
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362ff9eadcba8ff0$var$styles.outerColumn,
        testId: "update-request-type-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($362ff9eadcba8ff0$var$styles.titleSection, !isExpanded && $362ff9eadcba8ff0$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $362ff9eadcba8ff0$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362ff9eadcba8ff0$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362ff9eadcba8ff0$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $c1wJY.messages).collapseSection : (0, $c1wJY.messages).expandSection),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "update-request-type-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362ff9eadcba8ff0$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($362ff9eadcba8ff0$var$styles.contentSection, isBodyContentExpanded && $362ff9eadcba8ff0$var$styles.contentSection_bodyExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.requestTypeName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $c1wJY.messages).fieldsToAddHeading)), fieldNames.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $362ff9eadcba8ff0$var$styles.fieldList
    }, fieldNames.map((name, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: `${name}-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, name))))))), hasTruncatableBodyContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($362ff9eadcba8ff0$var$BodyContentShowMoreToggle, {
        isBodyExpanded: isBodyContentExpanded,
        onToggle: ()=>setIsBodyContentExpanded(!isBodyContentExpanded)
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $362ff9eadcba8ff0$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "update-request-type-card.next"
    }, formatMessage((0, $c1wJY.messages).nextButton))) : null)));
};
function $362ff9eadcba8ff0$var$_temp(name, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        key: `${name}-${index}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, name));
}
module.exports["UpdateRequestTypeCard"] = $362ff9eadcba8ff0$export$44b39dee2c066898;

});

parcelRegister("D6UqO", function(module, exports) {
const $d4dc823de4c94dab$export$a305f130b289b818 = {
    proactiveGeneratedAI: 0,
    userGeneratedAI: 1,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $d4dc823de4c94dab$export$a305f130b289b818;

});

parcelRegister("b3xba", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $bNm29 = parcelRequire("bNm29");


var $1P1Uj = parcelRequire("1P1Uj");

const $56d6fd92a77a6267$var$EMPTY_PORTAL_GROUPS = [];
const $56d6fd92a77a6267$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $56d6fd92a77a6267$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentSection_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _2BK2Lld1Zr _1eOmH6d1Zr _3gzVzLJNoT",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    portalGroupList: "_2mHwu8gVvo _43nrzTdnbC _0rIjykdnbC _0LQT5EkG2W _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $56d6fd92a77a6267$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $bNm29.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $56d6fd92a77a6267$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $56d6fd92a77a6267$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "update-request-type-portal-groups-card.expand-body-content"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $56d6fd92a77a6267$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $56d6fd92a77a6267$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "update-request-type-portal-groups-card.expand-body-content"
    }, formatMessage((0, $bNm29.messages).expandBodyContent)));
};
const $56d6fd92a77a6267$export$e1e5060ea7701aed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $bNm29.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    const groups = payload.groups ?? $56d6fd92a77a6267$var$EMPTY_PORTAL_GROUPS;
    const hasGroups = groups.length > 0;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const el = contentSectionRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $56d6fd92a77a6267$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[2] = t5;
    } else t5 = $[2];
    const measureBodyOverflow = t5;
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== groups || $[5] !== payload.requestTypeId || $[6] !== payload.requestTypeName) {
        t7 = [
            payload.requestTypeId,
            payload.requestTypeName,
            groups
        ];
        $[4] = groups;
        $[5] = payload.requestTypeId;
        $[6] = payload.requestTypeName;
        $[7] = t7;
    } else t7 = $[7];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            measureBodyOverflow();
        };
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== groups || $[10] !== payload.requestTypeId || $[11] !== payload.requestTypeName || $[12] !== showExpandedBody) {
        t9 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.requestTypeId,
            payload.requestTypeName,
            groups
        ];
        $[9] = groups;
        $[10] = payload.requestTypeId;
        $[11] = payload.requestTypeName;
        $[12] = showExpandedBody;
        $[13] = t9;
    } else t9 = $[13];
    (0, $cozmU.useLayoutEffect)(t8, t9);
    let t10;
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t11 = [
            measureBodyOverflow
        ];
        $[14] = t10;
        $[15] = t11;
    } else {
        t10 = $[14];
        t11 = $[15];
    }
    (0, $cozmU.useLayoutEffect)(t10, t11);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t12;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[16] = t12;
    } else t12 = $[16];
    const handleExpandBody = t12;
    let t13;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== ExpandCollapseIcon || $[19] !== formatMessage || $[20] !== groups || $[21] !== hasGroups || $[22] !== heading || $[23] !== isClamped || $[24] !== isExpanded || $[25] !== isNextDisabled || $[26] !== isNextLoading || $[27] !== isSuccess || $[28] !== onNext || $[29] !== payload.requestTypeName || $[30] !== showExpandedBody) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t13
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $56d6fd92a77a6267$var$styles.outermostWrapper,
            testId: "update-request-type-portal-groups-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1P1Uj.UpdateRequestTypePortalGroupsCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $bNm29.messages).successPill, {
                requestTypeName: payload.requestTypeName
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $56d6fd92a77a6267$var$styles.outerColumn,
            testId: "update-request-type-portal-groups-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($56d6fd92a77a6267$var$styles.titleSection, !isExpanded && $56d6fd92a77a6267$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $56d6fd92a77a6267$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $56d6fd92a77a6267$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $56d6fd92a77a6267$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $bNm29.messages).collapseBodyContent : (0, $bNm29.messages).expandBodyContent),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "update-request-type-portal-groups-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $56d6fd92a77a6267$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($56d6fd92a77a6267$var$styles.contentSection, isClamped && $56d6fd92a77a6267$var$styles.contentSection_clamped)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.requestTypeName), hasGroups ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $bNm29.messages).groupsFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $56d6fd92a77a6267$var$styles.portalGroupList
        }, groups.map($56d6fd92a77a6267$var$_temp))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $bNm29.messages).emptyGroupsDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($56d6fd92a77a6267$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $56d6fd92a77a6267$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "update-request-type-portal-groups-card.next"
        }, formatMessage((0, $bNm29.messages).confirmButton))) : null)));
        $[18] = ExpandCollapseIcon;
        $[19] = formatMessage;
        $[20] = groups;
        $[21] = hasGroups;
        $[22] = heading;
        $[23] = isClamped;
        $[24] = isExpanded;
        $[25] = isNextDisabled;
        $[26] = isNextLoading;
        $[27] = isSuccess;
        $[28] = onNext;
        $[29] = payload.requestTypeName;
        $[30] = showExpandedBody;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $bNm29.messages).cardTitle);
    const groups = payload.groups ?? $56d6fd92a77a6267$var$EMPTY_PORTAL_GROUPS;
    const hasGroups = groups.length > 0;
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $56d6fd92a77a6267$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        payload.requestTypeId,
        payload.requestTypeName,
        groups
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.requestTypeId,
        payload.requestTypeName,
        groups
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $56d6fd92a77a6267$var$styles.outermostWrapper,
        testId: "update-request-type-portal-groups-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1P1Uj.UpdateRequestTypePortalGroupsCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $bNm29.messages).successPill, {
            requestTypeName: payload.requestTypeName
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $56d6fd92a77a6267$var$styles.outerColumn,
        testId: "update-request-type-portal-groups-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($56d6fd92a77a6267$var$styles.titleSection, !isExpanded && $56d6fd92a77a6267$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $56d6fd92a77a6267$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $56d6fd92a77a6267$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $56d6fd92a77a6267$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $bNm29.messages).collapseBodyContent : (0, $bNm29.messages).expandBodyContent),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "update-request-type-portal-groups-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $56d6fd92a77a6267$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($56d6fd92a77a6267$var$styles.contentSection, isClamped && $56d6fd92a77a6267$var$styles.contentSection_clamped)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.requestTypeName), hasGroups ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $bNm29.messages).groupsFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $56d6fd92a77a6267$var$styles.portalGroupList
    }, groups.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: group.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, group.name))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $bNm29.messages).emptyGroupsDescription)))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($56d6fd92a77a6267$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $56d6fd92a77a6267$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "update-request-type-portal-groups-card.next"
    }, formatMessage((0, $bNm29.messages).confirmButton))) : null)));
};
function $56d6fd92a77a6267$var$_temp(group) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        key: group.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, group.name));
}
module.exports["UpdateRequestTypePortalGroupsCard"] = $56d6fd92a77a6267$export$e1e5060ea7701aed;

});

parcelRegister("kyUYu", function(module, exports) {
const $3308b601cd47f72c$export$a305f130b289b818 = {
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0,
    isAIFeature: 1,
    inProductExperience: 'jsmComposer'
};
module.exports["analyticsAttributes"] = $3308b601cd47f72c$export$a305f130b289b818;

});

parcelRegister("8eC5Y", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hMLWD = parcelRequire("hMLWD");


var $i6XkY = parcelRequire("i6XkY");


var $iqA39 = parcelRequire("iqA39");

const $0a9d9844de49c9f9$var$styles = {
    outermostWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    outerColumn: "_0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d _24h04i2Njc _2OUyjtzwhj",
    titleSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    titleSection_collapsedEnd: "_1v9SsV8fU6 _3XDz3B8fU6",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    contentSection: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _0jFU0VbUtj _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _2WAcuGnQyn",
    contentSection_bodyExpanded: "_0jFU0VIZbP _2WAcuGYvD1 _1wydGWS40j",
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _23rrnHQ4MZ _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXru7Cj1 _42Yu6BgtVO _1YKVNsdnbC _3t4LwpWgmT _30D6Ku7dHp _2BK2LlqWX3 _1B4rbIWgmT _2OgLIs7dHp _1eOmH6qWX3 _3gzVzLutHW",
    footerSection: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0KLXruqi9L _1v9SsV8fU6 _3XDz3B8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    expandToggleWrap: "_0GTcwRIZbP",
    toggleZone_collapsed: "_3CkH9oLfAA",
    toggleZone_expanded: "_3CkH9oYbGa _0KLXrujOvk"
};
const $0a9d9844de49c9f9$var$BodyContentShowMoreToggle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { isBodyExpanded: isBodyExpanded, onToggle: onToggle } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = isBodyExpanded ? $0a9d9844de49c9f9$var$styles.toggleZone_expanded : $0a9d9844de49c9f9$var$styles.toggleZone_collapsed;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($0a9d9844de49c9f9$var$styles.fadeOffZone, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isBodyExpanded ? "update-request-type-workflow-card.collapse-body-content" : "update-request-type-workflow-card.expand-body-content";
    const t4 = isBodyExpanded ? (0, $i6XkY.messages).collapseBodyContent : (0, $i6XkY.messages).expandBodyContent;
    let t5;
    if ($[2] !== formatMessage || $[3] !== t4) {
        t5 = formatMessage(t4);
        $[2] = formatMessage;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== onToggle || $[6] !== t3 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $0a9d9844de49c9f9$var$styles.showMoreButton,
            onClick: onToggle,
            testId: t3
        }, t5);
        $[5] = onToggle;
        $[6] = t3;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t2 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, t6);
        $[9] = t2;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ isBodyExpanded: isBodyExpanded, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0a9d9844de49c9f9$var$styles.fadeOffZone, isBodyExpanded ? $0a9d9844de49c9f9$var$styles.toggleZone_expanded : $0a9d9844de49c9f9$var$styles.toggleZone_collapsed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $0a9d9844de49c9f9$var$styles.showMoreButton,
        onClick: onToggle,
        testId: isBodyExpanded ? 'update-request-type-workflow-card.collapse-body-content' : 'update-request-type-workflow-card.expand-body-content'
    }, formatMessage(isBodyExpanded ? (0, $i6XkY.messages).collapseBodyContent : (0, $i6XkY.messages).expandBodyContent)));
};
const $0a9d9844de49c9f9$export$165649399a24e048 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { payload: payload, onNext: onNext, isNextLoading: t1, isNextDisabled: t2, isSuccess: t3 } = t0;
    const isNextLoading = t1 === undefined ? false : t1;
    const isNextDisabled = t2 === undefined ? false : t2;
    const isSuccess = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [isBodyContentExpanded, setIsBodyContentExpanded] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $i6XkY.messages).cardTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    const heading = t4;
    let t5;
    if ($[2] !== isBodyContentExpanded) {
        t5 = ()=>{
            const el = contentSectionRef.current;
            if (!el || isBodyContentExpanded) return;
            setHasTruncatableBodyContent(el.scrollHeight > el.clientHeight);
        };
        $[2] = isBodyContentExpanded;
        $[3] = t5;
    } else t5 = $[3];
    const measureBodyOverflow = t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsBodyContentExpanded(false);
        };
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== payload.requestTypeId || $[6] !== payload.requestTypeName || $[7] !== payload.targetIssueTypeId || $[8] !== payload.targetIssueTypeName) {
        t7 = [
            payload.requestTypeId,
            payload.requestTypeName,
            payload.targetIssueTypeId,
            payload.targetIssueTypeName
        ];
        $[5] = payload.requestTypeId;
        $[6] = payload.requestTypeName;
        $[7] = payload.targetIssueTypeId;
        $[8] = payload.targetIssueTypeName;
        $[9] = t7;
    } else t7 = $[9];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[10] !== measureBodyOverflow) {
        t8 = ()=>{
            measureBodyOverflow();
        };
        $[10] = measureBodyOverflow;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== measureBodyOverflow || $[13] !== payload.requestTypeId || $[14] !== payload.requestTypeName || $[15] !== payload.targetIssueTypeId || $[16] !== payload.targetIssueTypeName || $[17] !== showExpandedBody) {
        t9 = [
            measureBodyOverflow,
            showExpandedBody,
            payload.requestTypeId,
            payload.requestTypeName,
            payload.targetIssueTypeId,
            payload.targetIssueTypeName
        ];
        $[12] = measureBodyOverflow;
        $[13] = payload.requestTypeId;
        $[14] = payload.requestTypeName;
        $[15] = payload.targetIssueTypeId;
        $[16] = payload.targetIssueTypeName;
        $[17] = showExpandedBody;
        $[18] = t9;
    } else t9 = $[18];
    (0, $cozmU.useLayoutEffect)(t8, t9);
    let t10;
    let t11;
    if ($[19] !== measureBodyOverflow) {
        t10 = ()=>{
            const el_0 = contentSectionRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t11 = [
            measureBodyOverflow
        ];
        $[19] = measureBodyOverflow;
        $[20] = t10;
        $[21] = t11;
    } else {
        t10 = $[20];
        t11 = $[21];
    }
    (0, $cozmU.useLayoutEffect)(t10, t11);
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== ExpandCollapseIcon || $[24] !== formatMessage || $[25] !== hasTruncatableBodyContent || $[26] !== heading || $[27] !== isBodyContentExpanded || $[28] !== isExpanded || $[29] !== isNextDisabled || $[30] !== isNextLoading || $[31] !== isSuccess || $[32] !== onNext || $[33] !== payload.requestTypeName || $[34] !== payload.targetIssueTypeName || $[35] !== showExpandedBody) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t12
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0a9d9844de49c9f9$var$styles.outermostWrapper,
            testId: "update-request-type-workflow-card.root"
        }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqA39.UpdateRequestTypeWorkflowCardSuccess), {
            heading: heading,
            successMessage: formatMessage((0, $i6XkY.messages).successPill, {
                requestTypeName: payload.requestTypeName
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0a9d9844de49c9f9$var$styles.outerColumn,
            testId: "update-request-type-workflow-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: (0, $w6R6I.cx)($0a9d9844de49c9f9$var$styles.titleSection, !isExpanded && $0a9d9844de49c9f9$var$styles.titleSection_collapsedEnd)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $0a9d9844de49c9f9$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0a9d9844de49c9f9$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0a9d9844de49c9f9$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: formatMessage(isExpanded ? (0, $i6XkY.messages).collapseBodyContent : (0, $i6XkY.messages).expandBodyContent),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setIsExpanded(!isExpanded),
            testId: "update-request-type-workflow-card.expand-toggle"
        }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0a9d9844de49c9f9$var$styles.contentSectionOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentSectionRef,
            xcss: (0, $w6R6I.cx)($0a9d9844de49c9f9$var$styles.contentSection, isBodyContentExpanded && $0a9d9844de49c9f9$var$styles.contentSection_bodyExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, payload.requestTypeName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, formatMessage((0, $i6XkY.messages).workflowDescription, {
            workTypeName: payload.targetIssueTypeName,
            bold: $0a9d9844de49c9f9$var$_temp
        })))), hasTruncatableBodyContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0a9d9844de49c9f9$var$BodyContentShowMoreToggle, {
            isBodyExpanded: isBodyContentExpanded,
            onToggle: ()=>setIsBodyContentExpanded(!isBodyContentExpanded)
        }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $0a9d9844de49c9f9$var$styles.footerSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onNext,
            isLoading: isNextLoading,
            isDisabled: isNextDisabled,
            testId: "update-request-type-workflow-card.next"
        }, formatMessage((0, $i6XkY.messages).confirmButton))) : null)));
        $[23] = ExpandCollapseIcon;
        $[24] = formatMessage;
        $[25] = hasTruncatableBodyContent;
        $[26] = heading;
        $[27] = isBodyContentExpanded;
        $[28] = isExpanded;
        $[29] = isNextDisabled;
        $[30] = isNextLoading;
        $[31] = isSuccess;
        $[32] = onNext;
        $[33] = payload.requestTypeName;
        $[34] = payload.targetIssueTypeName;
        $[35] = showExpandedBody;
        $[36] = t13;
    } else t13 = $[36];
    return t13;
} : ({ payload: payload, onNext: onNext, isNextLoading: isNextLoading = false, isNextDisabled: isNextDisabled = false, isSuccess: isSuccess = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(true);
    const [isBodyContentExpanded, setIsBodyContentExpanded] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentSectionRef = (0, $cozmU.useRef)(null);
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const showExpandedBody = !isSuccess && isExpanded;
    const heading = formatMessage((0, $i6XkY.messages).cardTitle);
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentSectionRef.current;
        if (!el || isBodyContentExpanded) return;
        setHasTruncatableBodyContent(el.scrollHeight > el.clientHeight);
    }, [
        isBodyContentExpanded
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsBodyContentExpanded(false);
    }, [
        payload.requestTypeId,
        payload.requestTypeName,
        payload.targetIssueTypeId,
        payload.targetIssueTypeName
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        showExpandedBody,
        payload.requestTypeId,
        payload.requestTypeName,
        payload.targetIssueTypeId,
        payload.targetIssueTypeName
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentSectionRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a9d9844de49c9f9$var$styles.outermostWrapper,
        testId: "update-request-type-workflow-card.root"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqA39.UpdateRequestTypeWorkflowCardSuccess), {
        heading: heading,
        successMessage: formatMessage((0, $i6XkY.messages).successPill, {
            requestTypeName: payload.requestTypeName
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a9d9844de49c9f9$var$styles.outerColumn,
        testId: "update-request-type-workflow-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($0a9d9844de49c9f9$var$styles.titleSection, !isExpanded && $0a9d9844de49c9f9$var$styles.titleSection_collapsedEnd)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $0a9d9844de49c9f9$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a9d9844de49c9f9$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a9d9844de49c9f9$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $i6XkY.messages).collapseBodyContent : (0, $i6XkY.messages).expandBodyContent),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "update-request-type-workflow-card.expand-toggle"
    }))), showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a9d9844de49c9f9$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentSectionRef,
        xcss: (0, $w6R6I.cx)($0a9d9844de49c9f9$var$styles.contentSection, isBodyContentExpanded && $0a9d9844de49c9f9$var$styles.contentSection_bodyExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, payload.requestTypeName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $i6XkY.messages).workflowDescription, {
        workTypeName: payload.targetIssueTypeName,
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "strong"
            }, chunks)
    })))), hasTruncatableBodyContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0a9d9844de49c9f9$var$BodyContentShowMoreToggle, {
        isBodyExpanded: isBodyContentExpanded,
        onToggle: ()=>setIsBodyContentExpanded(!isBodyContentExpanded)
    }) : null) : null, showExpandedBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $0a9d9844de49c9f9$var$styles.footerSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onNext,
        isLoading: isNextLoading,
        isDisabled: isNextDisabled,
        testId: "update-request-type-workflow-card.next"
    }, formatMessage((0, $i6XkY.messages).confirmButton))) : null)));
};
function $0a9d9844de49c9f9$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, chunks);
}
module.exports["UpdateRequestTypeWorkflowCard"] = $0a9d9844de49c9f9$export$165649399a24e048;

});

parcelRegister("oUCjh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $5Sv3D = parcelRequire("5Sv3D");


var $I7hWB = parcelRequire("I7hWB");


var $iFXu4 = parcelRequire("iFXu4");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $haiCi = parcelRequire("haiCi");


var $8d5Av = parcelRequire("8d5Av");

const $973c236f26f91162$var$styles = {
    customControl: "_39xV02N91d"
};
const $973c236f26f91162$var$DEBOUNCE_DELAY = 300;
const $973c236f26f91162$var$extractProjectFromARI = (input)=>{
    // Match the last number digits after "project/"
    const pattern = /project\/(\d+)$/;
    const match = input.match(pattern);
    return match ? match[1] : '';
};
const $973c236f26f91162$export$1f1bf7370aa8d830 = `
query GetProjects($query: String!, $siteAri: String!) {
  search {
		search(
			query: $query
			filters: {
				entities: ["ati:cloud:jira:project"],
				locations: [$siteAri],
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					... on SearchResultJiraProject {
						id
						title
						iconUrl
						url
						project {
							issueTypes {
								edges {
									node {
										issueTypeId
										name
										avatar {
											xsmall
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
`;
const $973c236f26f91162$export$a764642e4b725728 = ({ siteId: siteId, setProject: setProject, selectedProject: selectedProject, isDisabled: isDisabled = false })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch), (0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [allOptions, setAllOptions] = (0, $cozmU.useState)([]);
    const [displayedOptions, setDisplayedOptions] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const loadOptions = (0, $cozmU.useCallback)(async (value)=>{
        setIsLoading(true);
        try {
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $973c236f26f91162$export$1f1bf7370aa8d830,
                variables: {
                    query: value,
                    siteAri: `ari:cloud:confluence::site/${siteId}`
                }
            });
            return response.data?.search?.search?.edges?.map((edge)=>edge.node)?.map((item)=>({
                    label: item.title,
                    value: item.id,
                    issueTypes: item.project.issueTypes.edges.map(({ node: node })=>({
                            issueTypeId: node.issueTypeId,
                            name: node.name,
                            avatarUrl: node.avatar?.xsmall
                        }))
                })) ?? [];
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SearchJiraProjectsQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return [];
        } finally{
            setIsLoading(false);
        }
    }, [
        siteId
    ]);
    const sortOptionsWithSelectedFirst = (0, $cozmU.useCallback)((options)=>{
        if (!selectedProject?.value || !options || options.length === 0) return options || [];
        const otherOptions = options.filter((option)=>{
            let optionValue = option.value;
            if (typeof option.value === 'string') optionValue = $973c236f26f91162$var$extractProjectFromARI(option.value) || option.value;
            return optionValue !== selectedProject.value;
        });
        return [
            selectedProject,
            ...otherOptions
        ];
    }, [
        selectedProject
    ]); // Preload initial options when component mounts
    (0, $cozmU.useEffect)(()=>{
        const preloadOptions = async ()=>{
            if (allOptions.length === 0 && !isLoading) {
                const initialOptions = await loadOptions('');
                setAllOptions(initialOptions);
                setDisplayedOptions(initialOptions);
            }
        };
        preloadOptions();
    }, [
        allOptions.length,
        isLoading,
        loadOptions
    ]);
    const handleProjectChange = (0, $cozmU.useCallback)((selectedOption)=>{
        const selectedOptionValue = selectedOption?.value;
        if (!selectedOption || typeof selectedOptionValue !== 'string') return;
        const selectedOptionProjectId = $973c236f26f91162$var$extractProjectFromARI(selectedOptionValue) || selectedOptionValue;
        if (selectedOptionProjectId === selectedProject?.value) return;
        setProject({
            projectId: selectedOptionProjectId,
            projectName: selectedOption.label ?? '',
            issueTypes: selectedOption.issueTypes ?? []
        });
        if (!allOptions.some((option_0)=>option_0.value === selectedOptionValue)) setAllOptions((prev)=>[
                ...prev,
                selectedOption
            ]);
        setDisplayedOptions(allOptions);
    }, [
        selectedProject,
        setProject,
        allOptions
    ]);
    const [debouncedLoadOptions] = (0, $5Sv3D.default)(async (value_0)=>{
        setDisplayedOptions(await loadOptions(value_0));
    }, $973c236f26f91162$var$DEBOUNCE_DELAY);
    const handleInputChange = (0, $cozmU.useCallback)((inputValue, { action: action })=>{
        if (action === 'input-change') debouncedLoadOptions(inputValue);
    }, [
        debouncedLoadOptions
    ]);
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $8d5Av.messages).projectSelectorHeader)), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        testId: "require-information-tool-project-selector",
        spacing: "compact",
        appearance: "subtle",
        value: selectedProject,
        isLoading: isLoading,
        options: sortOptionsWithSelectedFirst(displayedOptions),
        onChange: handleProjectChange,
        onInputChange: handleInputChange,
        onMenuOpen: ()=>{
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'dropdown',
                actionSubjectId: 'rovoRequireInformationToolProjectSelector'
            });
        },
        onMenuClose: ()=>{
            setDisplayedOptions(allOptions);
        },
        components: {
            Control: $973c236f26f91162$var$CustomControl
        },
        disabled: isDisabled
    }));
};
const $973c236f26f91162$var$CustomControl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingInline: "space.100",
            xcss: $973c236f26f91162$var$styles.customControl
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t1, children));
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== props || $[7] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, props, t2);
        $[6] = props;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...props })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, props, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        paddingInline: "space.100",
        xcss: $973c236f26f91162$var$styles.customControl
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
        label: ""
    }), children)));
};
module.exports["ProjectSelector"] = $973c236f26f91162$export$a764642e4b725728;

});

parcelRegister("b11DE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $fU3O0 = parcelRequire("fU3O0");


var $5ZtfK = parcelRequire("5ZtfK");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $dB2wu = parcelRequire("dB2wu");


var $jKT15 = parcelRequire("jKT15");


var $jseyQ = parcelRequire("jseyQ");

const $cc575f0a8290c952$var$styles = {
    imageSection: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT",
    detailsSection: "_3138425zaO _1Znuxb5zaO _2Zuz6Q5zaO _1wydGW5zaO",
    footerActions: "_39xV02N91d"
};
const $cc575f0a8290c952$var$DetailRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { label: label, value: value, icon: icon } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "medium"
        }, label);
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== icon || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, icon, t1);
        $[2] = icon;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== value) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text",
            size: "medium"
        }, value);
        $[5] = value;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ label: label, value: value, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text",
        size: "medium"
    }, value));
const $cc575f0a8290c952$export$adc880b65a9df53b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { title: title, repeatLabel: repeatLabel, nextRunLabel: nextRunLabel, isSelected: t1, isEnabled: t2, onDeleteClick: onDeleteClick, onEditClick: onEditClick } = t0;
    const isSelected = t1 === undefined ? false : t1;
    const isEnabled = t2 === undefined ? true : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== title) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, title);
        $[1] = title;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== formatMessage || $[4] !== nextRunLabel) {
        t5 = formatMessage((0, $jseyQ.messages).nextRunAt, {
            nextRunLabel: nextRunLabel
        });
        $[3] = formatMessage;
        $[4] = nextRunLabel;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t4 || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, t4, t6);
        $[8] = t4;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $cc575f0a8290c952$var$styles.imageSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dB2wu))),
            alt: ""
        }));
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== formatMessage) {
        t9 = formatMessage((0, $jseyQ.messages).repeat);
        $[12] = formatMessage;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fU3O0))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== repeatLabel || $[16] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc575f0a8290c952$var$DetailRow, {
            label: t9,
            value: repeatLabel,
            icon: t10
        });
        $[15] = repeatLabel;
        $[16] = t9;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== formatMessage) {
        t12 = formatMessage((0, $jseyQ.messages).nextRun);
        $[18] = formatMessage;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== nextRunLabel || $[22] !== t12) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc575f0a8290c952$var$DetailRow, {
            label: t12,
            value: nextRunLabel,
            icon: t13
        });
        $[21] = nextRunLabel;
        $[22] = t12;
        $[23] = t14;
    } else t14 = $[23];
    let t15;
    if ($[24] !== t11 || $[25] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $cc575f0a8290c952$var$styles.detailsSection
        }, t11, t14));
        $[24] = t11;
        $[25] = t14;
        $[26] = t15;
    } else t15 = $[26];
    let t16;
    if ($[27] !== formatMessage) {
        t16 = formatMessage((0, $jseyQ.messages).delete);
        $[27] = formatMessage;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== onDeleteClick || $[30] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: onDeleteClick
        }, t16);
        $[29] = onDeleteClick;
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== formatMessage) {
        t18 = formatMessage((0, $jseyQ.messages).edit);
        $[32] = formatMessage;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== onEditClick || $[35] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onEditClick
        }, t18);
        $[34] = onEditClick;
        $[35] = t18;
        $[36] = t19;
    } else t19 = $[36];
    let t20;
    if ($[37] !== t17 || $[38] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $cc575f0a8290c952$var$styles.footerActions,
            alignInline: "end",
            alignBlock: "center",
            space: "space.100"
        }, t17, t19);
        $[37] = t17;
        $[38] = t19;
        $[39] = t20;
    } else t20 = $[39];
    let t21;
    if ($[40] !== isEnabled || $[41] !== isSelected || $[42] !== t15 || $[43] !== t20 || $[44] !== t7) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
            isSelected: isSelected,
            isEnabled: isEnabled,
            isCollapsible: true,
            noPadding: true,
            previewProductLogo: t3,
            previewHeaderTitle: t7,
            previewContent: t15,
            previewFooterActions: t20
        });
        $[40] = isEnabled;
        $[41] = isSelected;
        $[42] = t15;
        $[43] = t20;
        $[44] = t7;
        $[45] = t21;
    } else t21 = $[45];
    return t21;
} : ({ title: title, repeatLabel: repeatLabel, nextRunLabel: nextRunLabel, isSelected: isSelected = false, isEnabled: isEnabled = true, onDeleteClick: onDeleteClick, onEditClick: onEditClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKT15.BasePreviewCard), {
        isSelected: isSelected,
        isEnabled: isEnabled,
        isCollapsible: true,
        noPadding: true,
        previewProductLogo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }),
        previewHeaderTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, $jseyQ.messages).nextRunAt, {
            nextRunLabel: nextRunLabel
        }))),
        previewContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $cc575f0a8290c952$var$styles.imageSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dB2wu))),
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $cc575f0a8290c952$var$styles.detailsSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc575f0a8290c952$var$DetailRow, {
            label: formatMessage((0, $jseyQ.messages).repeat),
            value: repeatLabel,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fU3O0))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc575f0a8290c952$var$DetailRow, {
            label: formatMessage((0, $jseyQ.messages).nextRun),
            value: nextRunLabel,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            })
        }))),
        previewFooterActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $cc575f0a8290c952$var$styles.footerActions,
            alignInline: "end",
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: onDeleteClick
        }, formatMessage((0, $jseyQ.messages).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onEditClick
        }, formatMessage((0, $jseyQ.messages).edit)))
    });
};
module.exports["ScheduledChatPreviewCard"] = $cc575f0a8290c952$export$adc880b65a9df53b;

});

parcelRegister("1cBj4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $aXPTn = parcelRequire("aXPTn");


var $4Rdaf = parcelRequire("4Rdaf");

const $32e5b77f2a1ae0da$var$containerStyles = {
    card: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67"
};
const $32e5b77f2a1ae0da$var$styles = {
    contentWrapper: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $32e5b77f2a1ae0da$export$dee3d476e1765158 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { ruleName: ruleName, overview: overview, ContentRenderer: ContentRenderer, onConfirm: onConfirm, isDisabled: isDisabled, isSubmitting: isSubmitting, productKey: productKey, siteId: siteId } = t0;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    let t1;
    if ($[0] !== isOpen) {
        t1 = ()=>setIsOpen(!isOpen);
        $[0] = isOpen;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== isOpen || $[3] !== ruleName || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Rdaf.CardHeader), {
            ruleName: ruleName,
            isOpen: isOpen,
            onToggle: t1
        });
        $[2] = isOpen;
        $[3] = ruleName;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== ContentRenderer || $[7] !== isDisabled || $[8] !== isOpen || $[9] !== isSubmitting || $[10] !== onConfirm || $[11] !== overview || $[12] !== productKey || $[13] !== siteId) {
        t3 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $32e5b77f2a1ae0da$var$styles.contentWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentRenderer, {
            content: overview,
            productKey: productKey ?? "",
            siteId: siteId ?? ""
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXPTn.CardFooter), {
            onConfirm: onConfirm,
            isDisabled: isDisabled,
            isSubmitting: isSubmitting
        }));
        $[6] = ContentRenderer;
        $[7] = isDisabled;
        $[8] = isOpen;
        $[9] = isSubmitting;
        $[10] = onConfirm;
        $[11] = overview;
        $[12] = productKey;
        $[13] = siteId;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== t2 || $[16] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $32e5b77f2a1ae0da$var$containerStyles.card,
            testId: "studio-automation-create-rule-card"
        }, t2, t3);
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ ruleName: ruleName, overview: overview, ContentRenderer: ContentRenderer, onConfirm: onConfirm, isDisabled: isDisabled, isSubmitting: isSubmitting, productKey: productKey, siteId: siteId })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32e5b77f2a1ae0da$var$containerStyles.card,
        testId: "studio-automation-create-rule-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Rdaf.CardHeader), {
        ruleName: ruleName,
        isOpen: isOpen,
        onToggle: ()=>setIsOpen(!isOpen)
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32e5b77f2a1ae0da$var$styles.contentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentRenderer, {
        content: overview,
        productKey: productKey ?? '',
        siteId: siteId ?? ''
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXPTn.CardFooter), {
        onConfirm: onConfirm,
        isDisabled: isDisabled,
        isSubmitting: isSubmitting
    })));
};
module.exports["AutomationCreateRuleCard"] = $32e5b77f2a1ae0da$export$dee3d476e1765158;

});

parcelRegister("bxtuo", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $699063f2b884ff34$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.card-title",
        defaultMessage: "Automation flow"
    },
    buildButtonLabel: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.build-button-label",
        defaultMessage: "Build automation"
    },
    buildingButtonLabel: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.building-button-label",
        defaultMessage: "Building..."
    },
    buildAutomationErrorTitle: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.build-automation-error-title",
        defaultMessage: "Failed to create automation"
    },
    buildAutomationErrorDescription: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.build-automation-error-description",
        defaultMessage: "Something went wrong while creating the automation. Please try again."
    },
    expandCardLabel: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.expand-card-label",
        defaultMessage: "Expand card"
    },
    collapseCardLabel: {
        id: "conversation-assistant-message-actions.studio-automation-create-flow.collapse-card-label",
        defaultMessage: "Collapse card"
    }
});
var $699063f2b884ff34$export$2e2bcd8739ae039 = $699063f2b884ff34$var$messages;
module.exports["default"] = $699063f2b884ff34$export$2e2bcd8739ae039;

});

parcelRegister("7CT2C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $Ou0Zz = parcelRequire("Ou0Zz");

const $22a78b333bd22b93$export$b80a4da45f97e289 = ({ actionRenderer: actionRenderer })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage } = actionRenderer;
    const firstAction = actionRenderer.actions.at(0);
    const { invocationId: invocationId } = firstAction ?? {};
    const actionRef = (0, $cozmU.useRef)(firstAction);
    const isHistoricalMessageRef = (0, $cozmU.useRef)(isHistoricalMessage);
    isHistoricalMessageRef.current = isHistoricalMessage;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        const action = actionRef.current;
        if (!action) return;
        const attributes = {
            conversationId: conversationId,
            invocationId: invocationId,
            messageId: messageId,
            actionKey: action.key
        };
        // https://data-portal.internal.atlassian.com/analytics/registry/104714
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'createFlowPlanViewed',
            actionSubject: 'rule',
            attributes: attributes
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/104712
        if (!isHistoricalMessageRef.current) sendAnalyticsEvent({
            eventType: 'track',
            action: 'createFlowPlanGenerated',
            actionSubject: 'rule',
            attributes: attributes
        });
    }, [
        sendAnalyticsEvent,
        conversationId,
        invocationId,
        messageId
    ]);
    return null;
};
module.exports["RulePlanAnalytics"] = $22a78b333bd22b93$export$b80a4da45f97e289;

});

parcelRegister("eOfip", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2486e0fd4031b689$var$message = (0, $kSwu1.defineMessages)({
    actionMessage: {
        id: "ai-mate.message-actions.automation-rule-update-action.action-message",
        defaultMessage: "Updating automation"
    }
});
var $2486e0fd4031b689$export$2e2bcd8739ae039 = $2486e0fd4031b689$var$message;
module.exports["default"] = $2486e0fd4031b689$export$2e2bcd8739ae039;

});

parcelRegister("kQyXl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $00db238d86b1fb69$var$styles = {
    wrapper: "_0Of8r2Va5s"
};
const $00db238d86b1fb69$var$assignedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.assigned",
    defaultMessage: "I've assigned <b>{agentName}</b> to this work item."
});
const $00db238d86b1fb69$var$invokeMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.invoke",
    defaultMessage: "I've started a session with <b>{agentName}</b> on this work item."
});
const $00db238d86b1fb69$var$buildAndChatMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.buildAndChat",
    defaultMessage: "I've opened a new chat with <b>{agentName}</b>."
});
const $00db238d86b1fb69$var$assignFailedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.assignFailed",
    defaultMessage: "\u26A0\uFE0F Can't assign the agent. Select the <b>Assignee</b> field to try again."
});
const $00db238d86b1fb69$var$invokeFailedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.invokeFailed",
    defaultMessage: "\u26A0\uFE0F Can't start the agent session. Select <b>Agents</b> to try again."
});
const $00db238d86b1fb69$var$createFailedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.createFailed",
    defaultMessage: "Failed to create agent."
});
const $00db238d86b1fb69$var$draftPublishFailedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.draftPublishFailed",
    defaultMessage: "I created a draft agent, but something went wrong. Please go to Studio to publish the agent."
});
const $00db238d86b1fb69$var$buildAndChatFailedMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.buildAndChatFailed",
    defaultMessage: "\u26A0\uFE0F Can't start a chat with the agent. Try again."
});
const $00db238d86b1fb69$var$refineInStudioIssueAssignMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.refineInStudioIssueAssign",
    defaultMessage: "Looks like you're making some tweaks over in Studio. Once you've published the agent, come back to the work item and get it to start working using the <b>Assignee</b> field.{br}{br}Is there anything else I can help you with today?"
});
const $00db238d86b1fb69$var$refineInStudioIssueInvokeMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.refineInStudioIssueInvoke",
    defaultMessage: "Looks like you're making some tweaks to your agent in Studio. Once you've published it, come back to the work item and get it to start working using the <b>Agents</b> button.{br}{br}Is there anything else I can help you with today?"
});
const $00db238d86b1fb69$var$refineInStudioBuildAndChatMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.AgentCreationFollowUpText.refineInStudioBuildAndChat",
    defaultMessage: "Looks like you're making some tweaks over in Studio. Once you've published the agent, come back to Rovo Chat and start a chat with it.{br}{br}Is there anything else I can help you with today?"
});
const $00db238d86b1fb69$var$richTextValues = {
    b: (chunks)=>/*#__PURE__*/ $cozmU.createElement("b", null, chunks),
    br: /*#__PURE__*/ $cozmU.createElement("br", null)
};
const $00db238d86b1fb69$export$f37863304b2c8a78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { followUpResult: followUpResult } = t0;
    if (!followUpResult) return null;
    let t1;
    if ($[0] !== followUpResult.agentName || $[1] !== followUpResult.flowKey || $[2] !== followUpResult.type) {
        const getMessage = ()=>{
            switch(followUpResult.type){
                case "assigned":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$assignedMessage,
                        values: {
                            agentName: followUpResult.agentName,
                            ...$00db238d86b1fb69$var$richTextValues
                        }
                    });
                case "invoke":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$invokeMessage,
                        values: {
                            agentName: followUpResult.agentName,
                            ...$00db238d86b1fb69$var$richTextValues
                        }
                    });
                case "build_and_chat":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$buildAndChatMessage,
                        values: {
                            agentName: followUpResult.agentName,
                            ...$00db238d86b1fb69$var$richTextValues
                        }
                    });
                case "assign_failed":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$assignFailedMessage,
                        values: $00db238d86b1fb69$var$richTextValues
                    });
                case "invoke_failed":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$invokeFailedMessage,
                        values: $00db238d86b1fb69$var$richTextValues
                    });
                case "create_failed":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$createFailedMessage,
                        values: $00db238d86b1fb69$var$richTextValues
                    });
                case "draft_publish_failed":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$draftPublishFailedMessage,
                        values: $00db238d86b1fb69$var$richTextValues
                    });
                case "build_and_chat_failed":
                    return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$00db238d86b1fb69$var$buildAndChatFailedMessage,
                        values: $00db238d86b1fb69$var$richTextValues
                    });
                case "refine_in_studio":
                    switch(followUpResult.flowKey){
                        case "issue_assign":
                            return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                                ...$00db238d86b1fb69$var$refineInStudioIssueAssignMessage,
                                values: $00db238d86b1fb69$var$richTextValues
                            });
                        case "issue_invoke":
                            return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                                ...$00db238d86b1fb69$var$refineInStudioIssueInvokeMessage,
                                values: $00db238d86b1fb69$var$richTextValues
                            });
                        case "build_and_chat":
                            return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                                ...$00db238d86b1fb69$var$refineInStudioBuildAndChatMessage,
                                values: $00db238d86b1fb69$var$richTextValues
                            });
                    }
            }
        };
        t1 = getMessage();
        $[0] = followUpResult.agentName;
        $[1] = followUpResult.flowKey;
        $[2] = followUpResult.type;
        $[3] = t1;
    } else t1 = $[3];
    const message = t1;
    if (!message) return null;
    let t2;
    if ($[4] !== message) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $00db238d86b1fb69$var$styles.wrapper,
            testId: "rovo-create-agent-follow-up-text",
            role: "status"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, message));
        $[4] = message;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ followUpResult: followUpResult })=>{
    if (!followUpResult) return null;
    const getMessage = ()=>{
        switch(followUpResult.type){
            case 'assigned':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$assignedMessage,
                    values: {
                        agentName: followUpResult.agentName,
                        ...$00db238d86b1fb69$var$richTextValues
                    }
                });
            case 'invoke':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$invokeMessage,
                    values: {
                        agentName: followUpResult.agentName,
                        ...$00db238d86b1fb69$var$richTextValues
                    }
                });
            case 'build_and_chat':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$buildAndChatMessage,
                    values: {
                        agentName: followUpResult.agentName,
                        ...$00db238d86b1fb69$var$richTextValues
                    }
                });
            case 'assign_failed':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$assignFailedMessage,
                    values: $00db238d86b1fb69$var$richTextValues
                });
            case 'invoke_failed':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$invokeFailedMessage,
                    values: $00db238d86b1fb69$var$richTextValues
                });
            case 'create_failed':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$createFailedMessage,
                    values: $00db238d86b1fb69$var$richTextValues
                });
            case 'draft_publish_failed':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$draftPublishFailedMessage,
                    values: $00db238d86b1fb69$var$richTextValues
                });
            case 'build_and_chat_failed':
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$00db238d86b1fb69$var$buildAndChatFailedMessage,
                    values: $00db238d86b1fb69$var$richTextValues
                });
            case 'refine_in_studio':
                switch(followUpResult.flowKey){
                    case 'issue_assign':
                        return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                            ...$00db238d86b1fb69$var$refineInStudioIssueAssignMessage,
                            values: $00db238d86b1fb69$var$richTextValues
                        });
                    case 'issue_invoke':
                        return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                            ...$00db238d86b1fb69$var$refineInStudioIssueInvokeMessage,
                            values: $00db238d86b1fb69$var$richTextValues
                        });
                    case 'build_and_chat':
                        return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                            ...$00db238d86b1fb69$var$refineInStudioBuildAndChatMessage,
                            values: $00db238d86b1fb69$var$richTextValues
                        });
                }
        }
    };
    const message = getMessage();
    if (!message) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $00db238d86b1fb69$var$styles.wrapper,
        testId: "rovo-create-agent-follow-up-text",
        role: "status"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, message));
};
module.exports["AgentCreationFollowUpText"] = $00db238d86b1fb69$export$f37863304b2c8a78;

});

parcelRegister("jz5To", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iA8l9 = parcelRequire("iA8l9");


var $lRJVo = parcelRequire("lRJVo");


var $gbT5P = parcelRequire("gbT5P");


var $duz5q = parcelRequire("duz5q");

const $f28d02c7fc706391$export$89082d8e2b443425 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { actionRenderer: actionRenderer } = t0;
    const { conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage } = actionRenderer;
    let t1;
    if ($[0] !== actionRenderer.actions) {
        t1 = actionRenderer.actions.at(0) ?? {};
        $[0] = actionRenderer.actions;
        $[1] = t1;
    } else t1 = $[1];
    const { invocationId: invocationId } = t1;
    let t2;
    if ($[2] !== actionRenderer.actions) {
        t2 = actionRenderer.actions.at(0)?.data.agentMetadata?.jiraMetadata ?? {};
        $[2] = actionRenderer.actions;
        $[3] = t2;
    } else t2 = $[3];
    const { flowKey: flowKey, issueId: issueId } = t2;
    let t3;
    if ($[4] !== actionRenderer.actions) {
        t3 = actionRenderer.actions.at(0);
        $[4] = actionRenderer.actions;
        $[5] = t3;
    } else t3 = $[5];
    const actionRef = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            touchPoint: (0, $duz5q.GASV3_ANALYTICS_TOUCHPOINT_NAME)
        };
        $[6] = t4;
    } else t4 = $[6];
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)(t4);
    let t5;
    let t6;
    if ($[7] !== conversationId || $[8] !== flowKey || $[9] !== invocationId || $[10] !== isHistoricalMessage || $[11] !== issueId || $[12] !== messageId || $[13] !== trackAgentEvent) {
        t5 = ()=>{
            const plan = actionRef.current?.data.agent;
            if (!plan) return;
            const attributes = {
                conversationId: conversationId,
                invocationId: invocationId,
                messageId: messageId,
                ...(0, $lRJVo.getCreateAgentAnalyticsAttributes)({
                    flowKey: flowKey,
                    issueId: issueId
                }),
                ...(0, $gbT5P.getPlanAnalyticsAttributes)(plan)
            };
            trackAgentEvent({
                action: "createFlowPlanViewed",
                actionSubject: "rovoAgent",
                attributes: attributes
            });
            if (!isHistoricalMessage) trackAgentEvent({
                action: "createFlowPlanGenerated",
                actionSubject: "rovoAgent",
                attributes: attributes
            });
        };
        t6 = [
            trackAgentEvent,
            conversationId,
            invocationId,
            messageId,
            isHistoricalMessage,
            flowKey,
            issueId
        ];
        $[7] = conversationId;
        $[8] = flowKey;
        $[9] = invocationId;
        $[10] = isHistoricalMessage;
        $[11] = issueId;
        $[12] = messageId;
        $[13] = trackAgentEvent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
    return null;
} : ({ actionRenderer: actionRenderer })=>{
    const { conversationId: conversationId, messageId: messageId, isHistoricalMessage: isHistoricalMessage } = actionRenderer;
    const { invocationId: invocationId } = actionRenderer.actions.at(0) ?? {};
    const { flowKey: flowKey, issueId: issueId } = actionRenderer.actions.at(0)?.data.agentMetadata?.jiraMetadata ?? {};
    const actionRef = (0, $cozmU.useRef)(actionRenderer.actions.at(0));
    const { trackAgentEvent: trackAgentEvent } = (0, $iA8l9.useRovoAgentActionAnalytics)({
        touchPoint: (0, $duz5q.GASV3_ANALYTICS_TOUCHPOINT_NAME)
    });
    (0, $cozmU.useEffect)(()=>{
        const plan = actionRef.current?.data.agent;
        if (!plan) return;
        const attributes = {
            conversationId: conversationId,
            invocationId: invocationId,
            messageId: messageId,
            ...(0, $lRJVo.getCreateAgentAnalyticsAttributes)({
                flowKey: flowKey,
                issueId: issueId
            }),
            ...(0, $gbT5P.getPlanAnalyticsAttributes)(plan)
        };
        trackAgentEvent({
            action: 'createFlowPlanViewed',
            actionSubject: 'rovoAgent',
            attributes: attributes
        });
        if (!isHistoricalMessage) trackAgentEvent({
            action: 'createFlowPlanGenerated',
            actionSubject: 'rovoAgent',
            attributes: attributes
        });
    }, [
        trackAgentEvent,
        conversationId,
        invocationId,
        messageId,
        isHistoricalMessage,
        flowKey,
        issueId
    ]);
    return null;
};
module.exports["AgentPlanAnalytics"] = $f28d02c7fc706391$export$89082d8e2b443425;

});

parcelRegister("lRJVo", function(module, exports) {
const $9cde5f12da810ca6$export$605791b986f3df7b = ({ flowKey: flowKey, issueId: issueId })=>({
        issueId: issueId ?? undefined,
        inlineAgentCreationFlowKey: flowKey ?? undefined,
        ...flowKey && issueId ? {
            jiraInlineAgentCreationFlowKey: flowKey
        } : {}
    });
module.exports["getCreateAgentAnalyticsAttributes"] = $9cde5f12da810ca6$export$605791b986f3df7b;

});

parcelRegister("gbT5P", function(module, exports) {
const $2ee7616938605422$export$5b89d66cf19a0e8a = (plan)=>{
    const baseTools = plan.tools?.filter((t)=>t.definitionSource !== 'MCP_SERVER') ?? [];
    const baseMcpServers = plan.tools?.filter((t)=>t.definitionSource === 'MCP_SERVER') ?? [];
    const agentToolsList = baseTools.map((t)=>t.definitionId).filter(Boolean).sort().join(', ');
    const agentKnowledge = plan.knowledgeSources?.sources?.reduce((acc, src)=>{
        acc[src.source] = {
            enabled: !!src.enabled,
            filters: ''
        };
        return acc;
    }, {}) ?? null;
    const scenarioList = plan.scenarios?.map((scenario)=>{
        const scenarioTools = (scenario.tools ?? []).filter((t)=>t.definitionSource !== 'MCP_SERVER');
        const scenarioMcpServers = (scenario.tools ?? []).filter((t)=>t.definitionSource === 'MCP_SERVER');
        const scenarioToolIds = scenarioTools.map((t)=>t.definitionId).filter(Boolean);
        const scenarioKnowledge = scenario.knowledgeSources?.sources?.map(({ source: source })=>source) ?? null;
        const knowledgeType = scenario.knowledgeSources?.enabled ? scenarioKnowledge && scenarioKnowledge.length > 0 ? 'custom' : 'disabled' : 'all';
        return {
            toolCount: scenarioTools.length,
            toolsList: [
                ...scenarioToolIds
            ].sort().join(', '),
            mcpServerCount: scenarioMcpServers.length,
            knowledgeType: knowledgeType,
            knowledge: scenarioKnowledge,
            /** plans do not yet support skills */ skillCount: 0,
            skillsList: ''
        };
    }) ?? [];
    return {
        agentToolCount: baseTools.length,
        agentToolsList: agentToolsList,
        agentMcpServerCount: baseMcpServers.length,
        agentKnowledge: agentKnowledge,
        scenarioList: scenarioList,
        agentSkillCount: 0,
        agentSkillsList: '',
        agentType: plan.agentType
    };
};
module.exports["getPlanAnalyticsAttributes"] = $2ee7616938605422$export$5b89d66cf19a0e8a;

});

parcelRegister("duz5q", function(module, exports) {
/**
 * Source-of-truth for the `navigationSource` query param appended to Studio
 * URLs opened from the inline create-agent card. Shared between the
 * post-confirm "Refine in Studio" link (`StudioCreateAgentRenderer`) and the
 * published-state settings cog (`CreateAgentCardWithQuery`).
 */ const $438011fea80e2ce0$export$4ae088553be8e10b = 'rovo-chat-inline-create-agent';
const $438011fea80e2ce0$export$e25c03034fb18ce3 = 'rovo-chat-inline-create-agent';
module.exports["STUDIO_NAVIGATION_SOURCE"] = $438011fea80e2ce0$export$4ae088553be8e10b;
module.exports["GASV3_ANALYTICS_TOUCHPOINT_NAME"] = $438011fea80e2ce0$export$e25c03034fb18ce3;

});

parcelRegister("aJUzF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iuCeV = parcelRequire("iuCeV");


var $1kIzC = parcelRequire("1kIzC");


var $hFkBC = parcelRequire("hFkBC");

const $b249d489372dc7d7$export$84f308ef49c19a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { isPublished: t1, agentAri: agentAri, agentName: agentName, cloudId: cloudId, description: description, instructions: instructions, knowledge: knowledge, tools: tools, primaryAction: primaryAction, secondaryAction: secondaryAction, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, agentEditUrl: agentEditUrl, renderExperienceName: renderExperienceName, shouldRenderDetailedPublishedCard: t2 } = t0;
    const isPublished = t1 === undefined ? false : t1;
    const shouldRenderDetailedPublishedCard = t2 === undefined ? false : t2;
    if (isPublished && !shouldRenderDetailedPublishedCard) {
        let t3;
        if ($[0] !== renderExperienceName) {
            t3 = renderExperienceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
                name: renderExperienceName
            });
            $[0] = renderExperienceName;
            $[1] = t3;
        } else t3 = $[1];
        const t4 = agentAri || "";
        let t5;
        if ($[2] !== agentEditUrl || $[3] !== agentIdentityAccountId || $[4] !== agentName || $[5] !== agentNamedId || $[6] !== imageUrl || $[7] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hFkBC.CreateAgentCardPublished), {
                agentAri: t4,
                agentName: agentName,
                imageUrl: imageUrl,
                agentIdentityAccountId: agentIdentityAccountId,
                agentNamedId: agentNamedId,
                agentEditUrl: agentEditUrl
            });
            $[2] = agentEditUrl;
            $[3] = agentIdentityAccountId;
            $[4] = agentName;
            $[5] = agentNamedId;
            $[6] = imageUrl;
            $[7] = t4;
            $[8] = t5;
        } else t5 = $[8];
        let t6;
        if ($[9] !== t3 || $[10] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t5);
            $[9] = t3;
            $[10] = t5;
            $[11] = t6;
        } else t6 = $[11];
        return t6;
    }
    let t3;
    if ($[12] !== renderExperienceName) {
        t3 = renderExperienceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: renderExperienceName
        });
        $[12] = renderExperienceName;
        $[13] = t3;
    } else t3 = $[13];
    const t4 = isPublished ? "published" : undefined;
    let t5;
    if ($[14] !== agentAri || $[15] !== agentIdentityAccountId || $[16] !== agentName || $[17] !== agentNamedId || $[18] !== cloudId || $[19] !== description || $[20] !== imageUrl || $[21] !== instructions || $[22] !== knowledge || $[23] !== primaryAction || $[24] !== secondaryAction || $[25] !== t4 || $[26] !== tools) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kIzC.CreateAgentCardPlan), {
            agentAri: agentAri,
            agentName: agentName,
            cloudId: cloudId,
            description: description,
            instructions: instructions,
            knowledge: knowledge,
            tools: tools,
            imageUrl: imageUrl,
            agentIdentityAccountId: agentIdentityAccountId,
            agentNamedId: agentNamedId,
            status: t4,
            primaryAction: primaryAction,
            secondaryAction: secondaryAction,
            testId: "rovo-create-agent-card-wrapper"
        });
        $[14] = agentAri;
        $[15] = agentIdentityAccountId;
        $[16] = agentName;
        $[17] = agentNamedId;
        $[18] = cloudId;
        $[19] = description;
        $[20] = imageUrl;
        $[21] = instructions;
        $[22] = knowledge;
        $[23] = primaryAction;
        $[24] = secondaryAction;
        $[25] = t4;
        $[26] = tools;
        $[27] = t5;
    } else t5 = $[27];
    let t6;
    if ($[28] !== t3 || $[29] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t5);
        $[28] = t3;
        $[29] = t5;
        $[30] = t6;
    } else t6 = $[30];
    return t6;
} : ({ isPublished: isPublished = false, agentAri: agentAri, agentName: agentName, cloudId: cloudId, description: description, instructions: instructions, knowledge: knowledge, tools: tools, primaryAction: primaryAction, secondaryAction: secondaryAction, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, agentEditUrl: agentEditUrl, renderExperienceName: renderExperienceName, shouldRenderDetailedPublishedCard: shouldRenderDetailedPublishedCard = false })=>{
    if (isPublished && !shouldRenderDetailedPublishedCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderExperienceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: renderExperienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hFkBC.CreateAgentCardPublished), {
        agentAri: agentAri || '',
        agentName: agentName,
        imageUrl: imageUrl,
        agentIdentityAccountId: agentIdentityAccountId,
        agentNamedId: agentNamedId,
        agentEditUrl: agentEditUrl
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderExperienceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: renderExperienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kIzC.CreateAgentCardPlan), {
        agentAri: agentAri,
        agentName: agentName,
        cloudId: cloudId,
        description: description,
        instructions: instructions,
        knowledge: knowledge,
        tools: tools,
        imageUrl: imageUrl,
        agentIdentityAccountId: agentIdentityAccountId,
        agentNamedId: agentNamedId,
        status: isPublished ? 'published' : undefined,
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        testId: "rovo-create-agent-card-wrapper"
    }));
};
module.exports["CreateAgentCard"] = $b249d489372dc7d7$export$84f308ef49c19a8;

});

parcelRegister("e6wkD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

/**
 * Shimmer placeholder shown while the persisted agent is being fetched from
 * `agentStudio_agentById`. Visually approximates the final card's silhouette
 * (avatar + name line + body lines + tool pill row) so the layout doesn't
 * jump once hydration completes.
 *
 * The skeleton intentionally avoids rendering `<AgentAvatar>` because that
 * component eagerly resolves a per-agent avatar SVG chunk via dynamic
 * `import()` — substituting a static placeholder keeps the loading state
 * quick and free of lazy-chunk failures.
 *
 * Each placeholder shape uses Atlaskit's `<Skeleton>` primitive which
 * provides the standard shimmer animation when `isShimmering` is set.
 */ const $e6cea27b8c1db64c$var$styles = {
    card: "_0bjKvDKTcp _4c065U5zaO _2Y7lL45zaO _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _0KLXruqi9L"
};
const $e6cea27b8c1db64c$export$d946adc40c4ba5d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60%",
            height: 14,
            isShimmering: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: 10,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: 10,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "75%",
            height: 10,
            isShimmering: true
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e6cea27b8c1db64c$var$styles.card,
            testId: "rovo-create-agent-card-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t0, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 72,
            height: 20,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 72,
            height: 20,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 72,
            height: 20,
            isShimmering: true
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e6cea27b8c1db64c$var$styles.card,
        testId: "rovo-create-agent-card-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "60%",
        height: 14,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: 10,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: 10,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "75%",
        height: 10,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 72,
        height: 20,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 72,
        height: 20,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 72,
        height: 20,
        isShimmering: true
    }))));
};
module.exports["CreateAgentCardSkeleton"] = $e6cea27b8c1db64c$export$d946adc40c4ba5d3;

});

parcelRegister("gmat6", function(module, exports) {

var $kwQw5 = parcelRequire("kwQw5");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $fa8WQ = parcelRequire("fa8WQ");


var $duz5q = parcelRequire("duz5q");


var $fCOel = parcelRequire("fCOel");


var $aJUzF = parcelRequire("aJUzF");

const $afb7bb239f206838$var$mapKnowledgeFilters = (filters)=>({
        spaceFilter: filters?.spaceFilter ? [
            ...filters.spaceFilter
        ] : undefined,
        parentFilter: filters?.parentFilter ? [
            ...filters.parentFilter
        ] : undefined,
        projectFilter: filters?.projectFilter ? [
            ...filters.projectFilter
        ] : undefined
    });
const $afb7bb239f206838$export$1e802b99683783bb = ({ agentAri: agentAri = '', cloudId: cloudId, agentName: agentName, description: description, instructions: instructions, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, knowledge: planKnowledge, tools: planTools, primaryAction: primaryAction, secondaryAction: secondaryAction, renderExperienceName: renderExperienceName, shouldRenderDetailedPublishedCard: shouldRenderDetailedPublishedCard, renderPrimaryAction: renderPrimaryAction, renderSecondaryAction: renderSecondaryAction })=>{
    (0, $6cFsl.di)();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $kwQw5.default), {
        agentAri: agentAri,
        cloudId: cloudId ?? ''
    }, {
        fetchPolicy: 'store-or-network'
    });
    const hasVersionCapability = (0, $cozmU.useMemo)(()=>data.agentStudio_hasVersionCapability?.__typename === 'AgentStudioHasVersionCapability' ? Boolean(data.agentStudio_hasVersionCapability.hasVersionCapability) : false, // this is consistent with other similar usage patterns for this query
    [
        data.agentStudio_hasVersionCapability
    ]);
    const agent = (0, $cozmU.useMemo)(()=>data.agentStudio_agentById?.__typename === 'AgentStudioAssistant' ? data.agentStudio_agentById : null, [
        data.agentStudio_agentById
    ]);
    const tools = (0, $cozmU.useMemo)(()=>(agent?.tools ?? []).map((tool)=>({
                id: tool.id,
                displayName: tool.displayName ?? tool.id,
                tags: tool.tags ? [
                    ...tool.tags
                ] : undefined,
                iconUrl: tool.iconUrl ?? undefined,
                isActive: true
            })), [
        agent?.tools
    ]);
    const knowledge = (0, $cozmU.useMemo)(()=>{
        if (!agent?.knowledgeSources) return [];
        return [
            {
                enabled: agent.knowledgeSources.enabled ?? undefined,
                sources: (agent.knowledgeSources.sources ?? []).map((src)=>({
                        enabled: src.enabled ?? undefined,
                        source: src.source,
                        filters: $afb7bb239f206838$var$mapKnowledgeFilters(src.filters)
                    }))
            }
        ];
    }, [
        agent?.knowledgeSources
    ]);
    const agentEditUrl = (0, $cozmU.useMemo)(()=>{
        if (!cloudId || !agentAri) return undefined;
        const agentId = (0, $fCOel.getAgentIdFromAri)(agentAri);
        if (!agentId) return undefined;
        return (0, $fa8WQ.getAtlassianStudioAgentEditUrl)(cloudId, agentId, (0, $duz5q.STUDIO_NAVIGATION_SOURCE));
    }, [
        cloudId,
        agentAri
    ]);
    const isPublished = !!agentAri && (!hasVersionCapability || agent?.isPublished === true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aJUzF.CreateAgentCard), {
        isPublished: isPublished,
        agentAri: agentAri,
        cloudId: cloudId,
        agentName: agent?.name ?? agentName,
        description: agent?.description ?? description,
        instructions: agent?.instructions ?? instructions,
        imageUrl: agent?.icon ?? imageUrl,
        agentIdentityAccountId: agent?.identityAccountId ?? agentIdentityAccountId,
        agentNamedId: agent?.externalConfigReference ?? agentNamedId,
        knowledge: agent ? knowledge : planKnowledge,
        tools: agent ? tools : planTools,
        primaryAction: renderPrimaryAction?.({
            isPublished: isPublished
        }) ?? primaryAction,
        secondaryAction: renderSecondaryAction?.({
            isPublished: isPublished
        }) ?? secondaryAction,
        agentEditUrl: agentEditUrl,
        renderExperienceName: renderExperienceName,
        shouldRenderDetailedPublishedCard: shouldRenderDetailedPublishedCard
    });
};
module.exports["CreateAgentCardWithQuery"] = $afb7bb239f206838$export$1e802b99683783bb;

});

parcelRegister("igxiP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $24qrr = parcelRequire("24qrr");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $Ou0Zz = parcelRequire("Ou0Zz");

class $059f1ca96cb99353$export$3ce79db3bd954a5f extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = void 0;
        this.name = 'AssignAgentError';
        this.statusCode = statusCode;
    }
}
const $059f1ca96cb99353$var$MAX_ATTEMPTS = 7;
const $059f1ca96cb99353$var$INITIAL_RETRY_DELAY_MS = 1000;
const $059f1ca96cb99353$var$RETRY_BACKOFF_FACTOR = 2;
const $059f1ca96cb99353$var$buildAssigneeFieldAri = (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/assignee`;
const $059f1ca96cb99353$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $059f1ca96cb99353$export$1196f0a65d862ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { conversationId: conversationId, invocationId: invocationId, messageId: messageId } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [commit, isAssigning] = (0, $6SsN4.useMutation)((0, $24qrr.default));
    let t1;
    if ($[0] !== commit || $[1] !== conversationId || $[2] !== invocationId || $[3] !== messageId || $[4] !== sendAnalyticsEvent) {
        t1 = async (t2)=>{
            const { cloudId: cloudId, issueId: issueId, identityAccountId: identityAccountId } = t2;
            const fieldAri = $059f1ca96cb99353$var$buildAssigneeFieldAri(cloudId, issueId);
            const trackFailure = ()=>{
                sendAnalyticsEvent({
                    eventType: "track",
                    actionSubject: "assignAgent",
                    action: "failed",
                    attributes: {
                        analyticsSource: "inline-create-agent-card",
                        conversationId: conversationId,
                        invocationId: invocationId,
                        messageId: messageId,
                        issueId: issueId
                    }
                });
            };
            const attemptOnce = ()=>new Promise((resolve, reject)=>{
                    commit({
                        variables: {
                            input: {
                                id: fieldAri,
                                operation: {
                                    id: `ari:cloud:identity::user/${identityAccountId}`,
                                    operation: "SET"
                                }
                            }
                        },
                        onCompleted: (response, errors)=>{
                            if (errors && errors.length > 0) {
                                reject({
                                    message: errors.map($059f1ca96cb99353$var$_temp).join(", "),
                                    retryable: false
                                });
                                return;
                            }
                            const mutationResult = response.jira?.updateSingleSelectUserPickerField;
                            if (!mutationResult?.success) {
                                const statusCode = mutationResult?.errors?.[0]?.extensions?.statusCode;
                                const message = mutationResult?.errors?.[0]?.message ?? "Failed to assign agent";
                                const retryable = statusCode === 400;
                                reject({
                                    message: message,
                                    retryable: retryable,
                                    statusCode: statusCode
                                });
                                return;
                            }
                            sendAnalyticsEvent({
                                eventType: "track",
                                actionSubject: "issue",
                                action: "updated",
                                actionSubjectId: "ended",
                                attributes: {
                                    analyticsSource: "inline-create-agent-card",
                                    conversationId: conversationId,
                                    invocationId: invocationId,
                                    messageId: messageId,
                                    issueId: issueId,
                                    fieldType: "singleUserPicker",
                                    newValId: identityAccountId,
                                    actionTaken: "add",
                                    fieldKey: "assignee",
                                    is_new_1event: true
                                }
                            });
                            resolve({
                                data: response,
                                retryable: false
                            });
                        },
                        onError: (error)=>reject({
                                message: String(error),
                                retryable: false
                            })
                    });
                });
            let lastError;
            let delayMs = $059f1ca96cb99353$var$INITIAL_RETRY_DELAY_MS;
            for(let attempt = 1; attempt <= $059f1ca96cb99353$var$MAX_ATTEMPTS; attempt++)try {
                const { data: data } = await attemptOnce();
                return data;
            } catch (t3) {
                const err = t3;
                lastError = err;
                if (!lastError.retryable || attempt >= $059f1ca96cb99353$var$MAX_ATTEMPTS) break;
                await $059f1ca96cb99353$var$sleep(delayMs);
                delayMs = delayMs * $059f1ca96cb99353$var$RETRY_BACKOFF_FACTOR;
            }
            trackFailure();
            throw new $059f1ca96cb99353$export$3ce79db3bd954a5f(lastError?.message ?? "Failed to assign agent", lastError?.statusCode);
        };
        $[0] = commit;
        $[1] = conversationId;
        $[2] = invocationId;
        $[3] = messageId;
        $[4] = sendAnalyticsEvent;
        $[5] = t1;
    } else t1 = $[5];
    const assignAgent = t1;
    let t2;
    if ($[6] !== assignAgent || $[7] !== isAssigning) {
        t2 = {
            assignAgent: assignAgent,
            isAssigning: isAssigning
        };
        $[6] = assignAgent;
        $[7] = isAssigning;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ conversationId: conversationId, invocationId: invocationId, messageId: messageId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [commit, isAssigning] = (0, $6SsN4.useMutation)((0, $24qrr.default));
    const assignAgent = (0, $cozmU.useCallback)(async ({ cloudId: cloudId, issueId: issueId, identityAccountId: identityAccountId })=>{
        const fieldAri = $059f1ca96cb99353$var$buildAssigneeFieldAri(cloudId, issueId);
        const trackFailure = ()=>{
            sendAnalyticsEvent({
                eventType: 'track',
                actionSubject: 'assignAgent',
                action: 'failed',
                attributes: {
                    analyticsSource: 'inline-create-agent-card',
                    conversationId: conversationId,
                    invocationId: invocationId,
                    messageId: messageId,
                    issueId: issueId
                }
            });
        };
        // After agent creation, Identity may not have synced the new bot account
        // into Jira's user store yet. Retry with exponential backoff to handle the
        // race. Only transient errors (400 user-not-found) are retried — other
        // errors (e.g. 403 Forbidden) bail out immediately so we don't block the user.
        const attemptOnce = ()=>new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            id: fieldAri,
                            operation: {
                                id: `ari:cloud:identity::user/${identityAccountId}`,
                                operation: 'SET'
                            }
                        }
                    },
                    onCompleted: (response, errors)=>{
                        if (errors && errors.length > 0) {
                            reject({
                                message: errors.map((e)=>e.message).join(', '),
                                retryable: false
                            });
                            return;
                        }
                        const mutationResult = response.jira?.updateSingleSelectUserPickerField;
                        if (!mutationResult?.success) {
                            const statusCode = mutationResult?.errors?.[0]?.extensions?.statusCode;
                            const message = mutationResult?.errors?.[0]?.message ?? 'Failed to assign agent';
                            // 400 = user not yet synced to Jira's directory — transient, retry.
                            // Any other code (403 forbidden, 500, etc.) = permanent, bail immediately.
                            const retryable = statusCode === 400;
                            reject({
                                message: message,
                                retryable: retryable,
                                statusCode: statusCode
                            });
                            return;
                        }
                        sendAnalyticsEvent({
                            eventType: 'track',
                            actionSubject: 'issue',
                            action: 'updated',
                            actionSubjectId: 'ended',
                            attributes: {
                                analyticsSource: 'inline-create-agent-card',
                                conversationId: conversationId,
                                invocationId: invocationId,
                                messageId: messageId,
                                issueId: issueId,
                                fieldType: 'singleUserPicker',
                                newValId: identityAccountId,
                                actionTaken: 'add',
                                fieldKey: 'assignee',
                                is_new_1event: true
                            }
                        });
                        resolve({
                            data: response,
                            retryable: false
                        });
                    },
                    onError: (error)=>reject({
                            message: String(error),
                            retryable: false
                        })
                });
            });
        let lastError;
        let delayMs = $059f1ca96cb99353$var$INITIAL_RETRY_DELAY_MS;
        for(let attempt = 1; attempt <= $059f1ca96cb99353$var$MAX_ATTEMPTS; attempt++)try {
            const { data: data } = await attemptOnce();
            return data;
        } catch (err) {
            lastError = err;
            if (!lastError.retryable || attempt >= $059f1ca96cb99353$var$MAX_ATTEMPTS) break;
            await $059f1ca96cb99353$var$sleep(delayMs);
            delayMs *= $059f1ca96cb99353$var$RETRY_BACKOFF_FACTOR;
        }
        trackFailure();
        throw new $059f1ca96cb99353$export$3ce79db3bd954a5f(lastError?.message ?? 'Failed to assign agent', lastError?.statusCode);
    }, [
        commit,
        sendAnalyticsEvent,
        conversationId,
        invocationId,
        messageId
    ]);
    return {
        assignAgent: assignAgent,
        isAssigning: isAssigning
    };
};
function $059f1ca96cb99353$var$_temp(e) {
    return e.message;
}
module.exports["AssignAgentError"] = $059f1ca96cb99353$export$3ce79db3bd954a5f;
module.exports["useAssignAgent"] = $059f1ca96cb99353$export$1196f0a65d862ce;

});

parcelRegister("73C0I", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $6iTVQ = parcelRequire("6iTVQ");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $Ou0Zz = parcelRequire("Ou0Zz");

const $38ab285ffbe2b0df$export$93683aea53be33ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { conversationId: conversationId, invocationId: invocationId, messageId: messageId } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [commit, isInvoking] = (0, $6SsN4.useMutation)((0, $6iTVQ.default));
    let t1;
    if ($[0] !== commit || $[1] !== conversationId || $[2] !== invocationId || $[3] !== messageId || $[4] !== sendAnalyticsEvent) {
        t1 = (t2)=>{
            const { cloudId: cloudId, issueId: issueId, agentId: agentId, identityAccountId: identityAccountId } = t2;
            return new Promise((resolve, reject)=>{
                const trackFailure = ()=>{
                    sendAnalyticsEvent({
                        eventType: "track",
                        actionSubject: "invokeAgent",
                        action: "failed",
                        attributes: {
                            analyticsSource: "inline-create-agent-card",
                            conversationId: conversationId,
                            invocationId: invocationId,
                            messageId: messageId,
                            agentId: agentId,
                            issueId: issueId
                        }
                    });
                };
                commit({
                    variables: {
                        input: {
                            agentId: identityAccountId,
                            clientMutationId: crypto.randomUUID(),
                            cloudId: cloudId,
                            issueId: issueId
                        }
                    },
                    onCompleted: (response, errors)=>{
                        if (errors && errors.length > 0) {
                            trackFailure();
                            reject(new Error(errors.map($38ab285ffbe2b0df$var$_temp).join(", ")));
                            return;
                        }
                        if (!response.jira_startAiAgentSession?.success) {
                            const message = response.jira_startAiAgentSession?.errors?.[0]?.message ?? "Failed to invoke agent";
                            trackFailure();
                            reject(new Error(message));
                            return;
                        }
                        sendAnalyticsEvent({
                            eventType: "track",
                            actionSubject: "agentSession",
                            action: "triggered",
                            attributes: {
                                analyticsSource: "inline-create-agent-card",
                                conversationId: conversationId,
                                invocationId: invocationId,
                                messageId: messageId,
                                agentId: agentId,
                                issueId: issueId
                            }
                        });
                        resolve(response);
                    },
                    onError: (error)=>{
                        trackFailure();
                        reject(error);
                    }
                });
            });
        };
        $[0] = commit;
        $[1] = conversationId;
        $[2] = invocationId;
        $[3] = messageId;
        $[4] = sendAnalyticsEvent;
        $[5] = t1;
    } else t1 = $[5];
    const invokeAgent = t1;
    let t2;
    if ($[6] !== invokeAgent || $[7] !== isInvoking) {
        t2 = {
            invokeAgent: invokeAgent,
            isInvoking: isInvoking
        };
        $[6] = invokeAgent;
        $[7] = isInvoking;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ conversationId: conversationId, invocationId: invocationId, messageId: messageId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [commit, isInvoking] = (0, $6SsN4.useMutation)((0, $6iTVQ.default));
    const invokeAgent = (0, $cozmU.useCallback)(({ cloudId: cloudId, issueId: issueId, agentId: agentId, identityAccountId: identityAccountId })=>new Promise((resolve, reject)=>{
            const trackFailure = ()=>{
                sendAnalyticsEvent({
                    eventType: 'track',
                    actionSubject: 'invokeAgent',
                    action: 'failed',
                    attributes: {
                        analyticsSource: 'inline-create-agent-card',
                        conversationId: conversationId,
                        invocationId: invocationId,
                        messageId: messageId,
                        agentId: agentId,
                        issueId: issueId
                    }
                });
            };
            commit({
                variables: {
                    input: {
                        agentId: identityAccountId,
                        // alternatively we could consider swaping with uuid() package similar to Jira
                        clientMutationId: crypto.randomUUID(),
                        cloudId: cloudId,
                        issueId: issueId
                    }
                },
                onCompleted: (response, errors)=>{
                    if (errors && errors.length > 0) {
                        trackFailure();
                        reject(new Error(errors.map((e)=>e.message).join(', ')));
                        return;
                    }
                    if (!response.jira_startAiAgentSession?.success) {
                        const message = response.jira_startAiAgentSession?.errors?.[0]?.message ?? 'Failed to invoke agent';
                        trackFailure();
                        reject(new Error(message));
                        return;
                    }
                    sendAnalyticsEvent({
                        eventType: 'track',
                        actionSubject: 'agentSession',
                        action: 'triggered',
                        attributes: {
                            analyticsSource: 'inline-create-agent-card',
                            conversationId: conversationId,
                            invocationId: invocationId,
                            messageId: messageId,
                            agentId: agentId,
                            issueId: issueId
                        }
                    });
                    resolve(response);
                },
                onError: (error)=>{
                    trackFailure();
                    reject(error);
                }
            });
        }), [
        commit,
        sendAnalyticsEvent,
        conversationId,
        invocationId,
        messageId
    ]);
    return {
        invokeAgent: invokeAgent,
        isInvoking: isInvoking
    };
};
function $38ab285ffbe2b0df$var$_temp(e) {
    return e.message;
}
module.exports["useInvokeAgent"] = $38ab285ffbe2b0df$export$93683aea53be33ae;

});

parcelRegister("fCOel", function(module, exports) {
/**
 * Extracts the bare agent id (trailing segment) from a Rovo agent ARI of the
 * form `ari:cloud:rovo::agent/activation/{activationId}/{agentId}`. Studio's
 * `getAtlassianStudioAgentEditUrl` requires the bare id rather than the full
 * ARI. Returns `null` for empty/missing input so callers can guard before
 * building Studio URLs.
 */ const $b55ba01e1d6c44d8$export$92f11cf4e802b166 = (agentAri)=>agentAri?.split('/').pop() || null;
module.exports["getAgentIdFromAri"] = $b55ba01e1d6c44d8$export$92f11cf4e802b166;

});

parcelRegister("n2nLe", function(module, exports) {
/**
 * @generated SignedSource<<c91f5d06ed36c8f22343e4d852e7c5b4>>
 * @relayHash 68ca4675a5fc33f83d2b6fad0b42237e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9a203b75dacab534f5f6942b4eeab9968b032f84026f7d1f9879d26c0bf9593
const $2d0f14d12710a1d9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skillAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "contextAri",
            "variableName": "contextAri"
        },
        {
            "kind": "Variable",
            "name": "skillAri",
            "variableName": "skillAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "instructions"
    }, v6 = {
        "concreteType": "GraphIntegrationSkillUiMetadata",
        "kind": "LinkedField",
        "name": "uiMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "displayName"
            },
            {
                "kind": "ScalarField",
                "name": "helpText"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StudioCustomSkillRendererQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "GraphIntegrationSkill",
                    "kind": "LinkedField",
                    "name": "graphIntegration_skill",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StudioCustomSkillRendererQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "GraphIntegrationSkill",
                    "kind": "LinkedField",
                    "name": "graphIntegration_skill",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9a203b75dacab534f5f6942b4eeab9968b032f84026f7d1f9879d26c0bf9593",
            "metadata": {},
            "name": "StudioCustomSkillRendererQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2d0f14d12710a1d9$var$node.hash = "7582acc7a5c3d90b2c5887b42aabb678";
var $2d0f14d12710a1d9$export$2e2bcd8739ae039 = $2d0f14d12710a1d9$var$node;
module.exports["default"] = $2d0f14d12710a1d9$export$2e2bcd8739ae039;

});

parcelRegister("fZEQY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $c9zHD = parcelRequire("c9zHD");


var $I7hWB = parcelRequire("I7hWB");


var $h5LaW = parcelRequire("h5LaW");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6FNab = parcelRequire("6FNab");

var $3BY7M = parcelRequire("3BY7M");


var $lfoFx = parcelRequire("lfoFx");


var $9NPFC = parcelRequire("9NPFC");


var $l4Yt3 = parcelRequire("l4Yt3");

const $16e9488746f5e299$var$createAdfEncoder = ()=>new (0, $6FNab.ADFEncoder)((schema)=>new (0, $c9zHD.MarkdownTransformer)(schema));
let $16e9488746f5e299$var$adfEncoder;
const $16e9488746f5e299$var$getAdfEncoder = ()=>{
    if (!$16e9488746f5e299$var$adfEncoder) $16e9488746f5e299$var$adfEncoder = $16e9488746f5e299$var$createAdfEncoder();
    return $16e9488746f5e299$var$adfEncoder;
};
const $16e9488746f5e299$var$Markdown = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { source: source } = t0;
    let t1;
    if ($[0] !== source) {
        t1 = $16e9488746f5e299$var$getAdfEncoder().encode(source);
        $[0] = source;
        $[1] = t1;
    } else t1 = $[1];
    const adfDocument = t1;
    let t2;
    if ($[2] !== adfDocument) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: adfDocument
        });
        $[2] = adfDocument;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ source: source })=>{
    const adfDocument = (0, $cozmU.useMemo)(()=>$16e9488746f5e299$var$getAdfEncoder().encode(source), [
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: adfDocument
    });
};
// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------
/** Max height of the body when collapsed (px). */ const $16e9488746f5e299$var$COLLAPSED_MAX_HEIGHT = 200; // ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $16e9488746f5e299$var$styles = {
    card: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _24h04i2Njc _0KLXrulfZc _2YgrGrP0S5",
    header: "_2mHwu82ADO _4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    headerTitle: "_2mHwu82ADO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    bodyOuter: "_1mT5xdRAKS _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    bodyCollapsed: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3rgZxp",
    bodyInner: "_4c065U8HPE _2Y7lL45zaO",
    bodyInnerCollapsed: "_0xmtkoGXk2",
    fade: "_1mT5xdWVPG _3iC0zddnbC _1OKFqYdnbC _1ZB6UydnbC _0jFU0VljYU _3CkH9o565s _1pp6NdYbGa",
    toggleButtonSurface: "_0bjKvDKxmn _0KLXruoI2d _2OUyjtGk8v",
    floatingShowMore: "_1mT5xdWVPG _3iC0zd715P _1ZB6Uy8HPE _1VJPcajssS _42Yu6B7dHp",
    showLessWrapper: "_3iDTPbQ4SZ _37wbyuDIqT _46hvQm2ADO _0xmtko8HPE",
    sectionLabel: "_2sNsIgd8bj _1UtDYzKGUX",
    footer: "_4c065U8HPE _2Y7lL45zaO _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
const $16e9488746f5e299$var$Section = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, children: children } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.sectionLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label));
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075"
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ label: label, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.sectionLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children)); // ---------------------------------------------------------------------------
// Plan / draft state (expandable)
// ---------------------------------------------------------------------------
const $16e9488746f5e299$var$CustomSkillCardPlan = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { displayName: displayName, helpText: helpText, description: description, instructions: instructions, headerLabel: headerLabel, confirmLabel: confirmLabel, isDisabled: t1, isSubmitting: t2, isLoadingDetails: t3, onConfirm: onConfirm, confirmSlot: confirmSlot } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isSubmitting = t2 === undefined ? false : t2;
    const isLoadingDetails = t3 === undefined ? false : t3;
    const intl = (0, $kSwu1.useIntl)();
    const [isCardCollapsed, setIsCardCollapsed] = (0, $cozmU.useState)(false);
    const [isBodyExpanded, setIsBodyExpanded] = (0, $cozmU.useState)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsCardCollapsed($16e9488746f5e299$var$_temp);
        $[0] = t4;
    } else t4 = $[0];
    const toggleCard = t4;
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setIsBodyExpanded(true);
        $[1] = t5;
    } else t5 = $[1];
    const showMore = t5;
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsBodyExpanded(false);
        $[2] = t6;
    } else t6 = $[2];
    const showLess = t6;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            size: "small",
            label: "",
            backgroundColor: "transparent",
            hasBorder: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5LaW))), {
            label: ""
        }));
        $[3] = t7;
    } else t7 = $[3];
    let t8;
    if ($[4] !== headerLabel) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), headerLabel));
        $[4] = headerLabel;
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] !== intl || $[7] !== isLoadingDetails) {
        t9 = isLoadingDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            label: intl.formatMessage((0, $l4Yt3.messages).loadingDetailsLabel),
            testId: "custom-skill-card-details-spinner"
        });
        $[6] = intl;
        $[7] = isLoadingDetails;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t8 || $[10] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.headerTitle
        }, t7, t8, t9);
        $[9] = t8;
        $[10] = t9;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== intl || $[13] !== isCardCollapsed || $[14] !== isLoadingDetails) {
        t11 = !isLoadingDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            shape: "circle",
            icon: isCardCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
            label: intl.formatMessage(isCardCollapsed ? (0, $l4Yt3.messages).expandLabel : (0, $l4Yt3.messages).collapseLabel),
            onClick: toggleCard,
            testId: "custom-skill-card-toggle"
        });
        $[12] = intl;
        $[13] = isCardCollapsed;
        $[14] = isLoadingDetails;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.header
        }, t10, t11);
        $[16] = t10;
        $[17] = t11;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== confirmLabel || $[20] !== confirmSlot || $[21] !== description || $[22] !== displayName || $[23] !== helpText || $[24] !== instructions || $[25] !== isBodyExpanded || $[26] !== isCardCollapsed || $[27] !== isDisabled || $[28] !== isLoadingDetails || $[29] !== isSubmitting || $[30] !== onConfirm) {
        t13 = !isCardCollapsed && !isLoadingDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.bodyOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isBodyExpanded ? undefined : $16e9488746f5e299$var$styles.bodyCollapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($16e9488746f5e299$var$styles.bodyInner, !isBodyExpanded && $16e9488746f5e299$var$styles.bodyInnerCollapsed)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
            label: (0, $l4Yt3.messages).skillNameLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, displayName)), helpText && (0, $iDrrr.fg)("chat_skill_helptext_enabled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
            label: (0, $l4Yt3.messages).summaryLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, helpText)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
            label: (0, $l4Yt3.messages).descriptionLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, description)), instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
            label: (0, $l4Yt3.messages).instructionsLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Markdown, {
            source: instructions
        }))))), isBodyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.showLessWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.toggleButtonSurface
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            spacing: "compact",
            onClick: showLess,
            testId: "custom-skill-card-show-less"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $l4Yt3.messages).showLessLabel)))), !isBodyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.fade
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($16e9488746f5e299$var$styles.toggleButtonSurface, $16e9488746f5e299$var$styles.floatingShowMore)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            spacing: "compact",
            onClick: showMore,
            testId: "custom-skill-card-show-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $l4Yt3.messages).showMoreLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "end",
            alignItems: "center",
            gap: "space.100"
        }, confirmSlot ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: isDisabled || isSubmitting,
            isLoading: isSubmitting,
            onClick: onConfirm,
            testId: "custom-skill-card-confirm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), confirmLabel)))));
        $[19] = confirmLabel;
        $[20] = confirmSlot;
        $[21] = description;
        $[22] = displayName;
        $[23] = helpText;
        $[24] = instructions;
        $[25] = isBodyExpanded;
        $[26] = isCardCollapsed;
        $[27] = isDisabled;
        $[28] = isLoadingDetails;
        $[29] = isSubmitting;
        $[30] = onConfirm;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== t12 || $[33] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $16e9488746f5e299$var$styles.card,
            testId: "custom-skill-card"
        }, t12, t13);
        $[32] = t12;
        $[33] = t13;
        $[34] = t14;
    } else t14 = $[34];
    return t14;
} : ({ displayName: displayName, helpText: helpText, description: description, instructions: instructions, headerLabel: headerLabel, confirmLabel: confirmLabel, isDisabled: isDisabled = false, isSubmitting: isSubmitting = false, isLoadingDetails: isLoadingDetails = false, onConfirm: onConfirm, confirmSlot: confirmSlot })=>{
    const intl = (0, $kSwu1.useIntl)(); // Controls whether the whole card body+footer is visible
    const [isCardCollapsed, setIsCardCollapsed] = (0, $cozmU.useState)(false); // Controls whether the body content is height-limited (Show more)
    const [isBodyExpanded, setIsBodyExpanded] = (0, $cozmU.useState)(false);
    const toggleCard = ()=>setIsCardCollapsed((v)=>!v);
    const showMore = ()=>setIsBodyExpanded(true);
    const showLess = ()=>setIsBodyExpanded(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.card,
        testId: "custom-skill-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.headerTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        size: "small",
        label: "",
        backgroundColor: "transparent",
        hasBorder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5LaW))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), headerLabel)), isLoadingDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        label: intl.formatMessage((0, $l4Yt3.messages).loadingDetailsLabel),
        testId: "custom-skill-card-details-spinner"
    })), !isLoadingDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        shape: "circle",
        icon: isCardCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: intl.formatMessage(isCardCollapsed ? (0, $l4Yt3.messages).expandLabel : (0, $l4Yt3.messages).collapseLabel),
        onClick: toggleCard,
        testId: "custom-skill-card-toggle"
    })), !isCardCollapsed && !isLoadingDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.bodyOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isBodyExpanded ? undefined : $16e9488746f5e299$var$styles.bodyCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($16e9488746f5e299$var$styles.bodyInner, !isBodyExpanded && $16e9488746f5e299$var$styles.bodyInnerCollapsed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
        label: (0, $l4Yt3.messages).skillNameLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, displayName)), helpText && (0, $iDrrr.fg)('chat_skill_helptext_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
        label: (0, $l4Yt3.messages).summaryLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, helpText)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
        label: (0, $l4Yt3.messages).descriptionLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, description)), instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Section, {
        label: (0, $l4Yt3.messages).instructionsLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$Markdown, {
        source: instructions
    }))))), isBodyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.showLessWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.toggleButtonSurface
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: showLess,
        testId: "custom-skill-card-show-less"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $l4Yt3.messages).showLessLabel)))), !isBodyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.fade
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($16e9488746f5e299$var$styles.toggleButtonSurface, $16e9488746f5e299$var$styles.floatingShowMore)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: showMore,
        testId: "custom-skill-card-show-more"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $l4Yt3.messages).showMoreLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $16e9488746f5e299$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end",
        alignItems: "center",
        gap: "space.100"
    }, confirmSlot ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: isDisabled || isSubmitting,
        isLoading: isSubmitting,
        onClick: onConfirm,
        testId: "custom-skill-card-confirm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), confirmLabel))))));
};
const $16e9488746f5e299$export$d50df5066ccb319d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { displayName: displayName, helpText: helpText, description: description, instructions: instructions, headerLabel: headerLabel, confirmLabel: confirmLabel, isDisabled: isDisabled, isSubmitting: isSubmitting, isLoadingDetails: isLoadingDetails, onConfirm: onConfirm, confirmSlot: confirmSlot } = t0;
    let t1;
    if ($[0] !== confirmLabel || $[1] !== confirmSlot || $[2] !== description || $[3] !== displayName || $[4] !== headerLabel || $[5] !== helpText || $[6] !== instructions || $[7] !== isDisabled || $[8] !== isLoadingDetails || $[9] !== isSubmitting || $[10] !== onConfirm) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$CustomSkillCardPlan, {
            displayName: displayName,
            helpText: helpText,
            description: description,
            instructions: instructions,
            headerLabel: headerLabel,
            confirmLabel: confirmLabel,
            isDisabled: isDisabled,
            isSubmitting: isSubmitting,
            isLoadingDetails: isLoadingDetails,
            onConfirm: onConfirm,
            confirmSlot: confirmSlot
        });
        $[0] = confirmLabel;
        $[1] = confirmSlot;
        $[2] = description;
        $[3] = displayName;
        $[4] = headerLabel;
        $[5] = helpText;
        $[6] = instructions;
        $[7] = isDisabled;
        $[8] = isLoadingDetails;
        $[9] = isSubmitting;
        $[10] = onConfirm;
        $[11] = t1;
    } else t1 = $[11];
    return t1;
} : ({ displayName: displayName, helpText: helpText, description: description, instructions: instructions, headerLabel: headerLabel, confirmLabel: confirmLabel, isDisabled: isDisabled, isSubmitting: isSubmitting, isLoadingDetails: isLoadingDetails, onConfirm: onConfirm, confirmSlot: confirmSlot })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16e9488746f5e299$var$CustomSkillCardPlan, {
        displayName: displayName,
        helpText: helpText,
        description: description,
        instructions: instructions,
        headerLabel: headerLabel,
        confirmLabel: confirmLabel,
        isDisabled: isDisabled,
        isSubmitting: isSubmitting,
        isLoadingDetails: isLoadingDetails,
        onConfirm: onConfirm,
        confirmSlot: confirmSlot
    });
};
function $16e9488746f5e299$var$_temp(v) {
    return !v;
}
module.exports["CustomSkillCard"] = $16e9488746f5e299$export$d50df5066ccb319d;

});

parcelRegister("lvrah", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2UKhw = parcelRequire("2UKhw");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $aZuhc = parcelRequire("aZuhc");


var $cC4M6 = parcelRequire("cC4M6");


var $1Bxlw = parcelRequire("1Bxlw");


var $l4Yt3 = parcelRequire("l4Yt3");

// Match the skills directory modal width so the edit surface is consistent.
const $fc0d220d5c8da846$var$modalProps = {
    width: (0, $2UKhw.MODAL_WIDTH)
};
const $fc0d220d5c8da846$export$75630be87c5d24af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { cloudId: cloudId, skillAri: skillAri, cardType: cardType } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { invalidateSkillLibrary: invalidateSkillLibrary } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    let t1;
    if ($[0] !== cloudId || $[1] !== skillAri) {
        t1 = {
            cloudId: cloudId,
            skillAri: skillAri
        };
        $[0] = cloudId;
        $[1] = skillAri;
        $[2] = t1;
    } else t1 = $[2];
    const entryPointParams = t1;
    let t2;
    if ($[3] !== invalidateSkillLibrary) {
        t2 = {
            onSaved: invalidateSkillLibrary
        };
        $[3] = invalidateSkillLibrary;
        $[4] = t2;
    } else t2 = $[4];
    const entryPointProps = t2;
    let t3;
    if ($[5] !== cardType || $[6] !== sendAnalyticsEvent) {
        t3 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "editCustomSkillCard",
                attributes: {
                    cardType: cardType
                }
            });
        };
        $[5] = cardType;
        $[6] = sendAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $l4Yt3.messages).editLabel);
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== entryPointParams || $[10] !== entryPointProps || $[11] !== handleClick) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cC4M6.ModalButtonTrigger), {
            entryPoint: (0, $aZuhc.editSkillEntrypoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            modalProps: $fc0d220d5c8da846$var$modalProps,
            onClick: handleClick,
            testId: "custom-skill-card-edit"
        }, t4);
        $[9] = entryPointParams;
        $[10] = entryPointProps;
        $[11] = handleClick;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ cloudId: cloudId, skillAri: skillAri, cardType: cardType })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { invalidateSkillLibrary: invalidateSkillLibrary } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    const entryPointParams = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            skillAri: skillAri
        }), [
        cloudId,
        skillAri
    ]);
    const entryPointProps = (0, $cozmU.useMemo)(()=>({
            onSaved: invalidateSkillLibrary
        }), [
        invalidateSkillLibrary
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editCustomSkillCard',
            attributes: {
                cardType: cardType
            }
        });
    }, [
        sendAnalyticsEvent,
        cardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cC4M6.ModalButtonTrigger), {
        entryPoint: (0, $aZuhc.editSkillEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        modalProps: $fc0d220d5c8da846$var$modalProps,
        onClick: handleClick,
        testId: "custom-skill-card-edit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $l4Yt3.messages).editLabel));
};
module.exports["EditSkillModalButton"] = $fc0d220d5c8da846$export$75630be87c5d24af;

});

parcelRegister("fqeYe", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");

const $0fdd2f2f9d0ab77a$export$3830109e85f643be = (chat, invocationId)=>{
    for (const item of chat){
        if (!(0, $bxkJA.isStreamResponse)(item)) continue;
        const action = item.message?.message?.actions?.find((candidate)=>candidate.invocationId === invocationId);
        if (action?.executedData !== undefined) return action.executedData;
    }
    return undefined;
};
module.exports["getExecutedDataFromChat"] = $0fdd2f2f9d0ab77a$export$3830109e85f643be;

});

parcelRegister("l4Yt3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e218894e8cd02cbc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    createSkillHeaderLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.createSkillHeaderLabel",
        defaultMessage: "Create skill"
    },
    updateSkillHeaderLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.updateSkillHeaderLabel",
        defaultMessage: "Update skill"
    },
    skillNameLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.skillNameLabel",
        defaultMessage: "Skill name"
    },
    summaryLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.summaryLabel",
        defaultMessage: "Summary"
    },
    descriptionLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.descriptionLabel",
        defaultMessage: "Description"
    },
    instructionsLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.instructionsLabel",
        defaultMessage: "Instructions"
    },
    showMoreLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.showMoreLabel",
        defaultMessage: "Show more"
    },
    showLessLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.showLessLabel",
        defaultMessage: "Show less"
    },
    expandLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.expandLabel",
        defaultMessage: "Expand"
    },
    collapseLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.collapseLabel",
        defaultMessage: "Collapse"
    },
    cancelLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.cancelLabel",
        defaultMessage: "Cancel"
    },
    updateLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.updateLabel",
        defaultMessage: "Update"
    },
    confirmLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.confirmLabel",
        defaultMessage: "Confirm"
    },
    editLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.editLabel",
        defaultMessage: "Edit"
    },
    loadingDetailsLabel: {
        id: "conversation-assistant-message-actions.controllers.studio-custom-skill.loadingDetailsLabel",
        defaultMessage: "Loading skill details"
    }
});
module.exports["messages"] = $e218894e8cd02cbc$export$defe85febe8b728c;

});

parcelRegister("l7t3l", function(module, exports) {
/**
 * Skill ARIs read back from chat history, keyed by action invocation id.
 *
 * A custom skill card is remounted while it stays on screen — sending another message recreates the
 * message subtree — so an ARI held only in component state is lost and the card falls back from Edit
 * to Confirm. This cache lets the next mount seed itself on its first render.
 */ const $418cabca5ea65164$var$resolvedSkillAris = new Map();
const $418cabca5ea65164$export$fff60f44e702859 = (invocationId)=>invocationId === undefined ? undefined : $418cabca5ea65164$var$resolvedSkillAris.get(invocationId);
const $418cabca5ea65164$export$e6c7877da562d070 = (invocationId, skillAri)=>{
    $418cabca5ea65164$var$resolvedSkillAris.set(invocationId, skillAri);
};
const $418cabca5ea65164$export$87c9ede5d768a806 = (invocationId)=>{
    $418cabca5ea65164$var$resolvedSkillAris.delete(invocationId);
};
const $418cabca5ea65164$export$b8ac5a89f6c5564f = ()=>{
    $418cabca5ea65164$var$resolvedSkillAris.clear();
};
module.exports["getResolvedSkillAri"] = $418cabca5ea65164$export$fff60f44e702859;
module.exports["cacheResolvedSkillAri"] = $418cabca5ea65164$export$e6c7877da562d070;
module.exports["forgetResolvedSkillAri"] = $418cabca5ea65164$export$87c9ede5d768a806;

});

parcelRegister("9ZloL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $5350f907cf4c26e7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    confirmButton: {
        id: "conversation-assistant-message-actions.studio-landing-page-redirect.confirm-button",
        defaultMessage: "Confirm"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.studio-landing-page-redirect.cancel-button",
        defaultMessage: "Cancel"
    }
});
module.exports["messages"] = $5350f907cf4c26e7$export$defe85febe8b728c;

});

parcelRegister("kz8pi", function(module, exports) {
/**
 * @generated SignedSource<<a9a4594796ead72e232838fca4614997>>
 * @relayHash 0c6b8b98d8d0d7ed7883088733e72d20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d15800213457a7a87b727610562460e90dc37726520c34ca32a874f96272a4dd
const $6886b976dcf10159$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "solutionId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "solutionVersion"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "state"
    }, v7 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "solutionId",
                            "variableName": "solutionId"
                        },
                        {
                            "kind": "Variable",
                            "name": "solutionVersion",
                            "variableName": "solutionVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceAri"
                        }
                    ],
                    "concreteType": "StudioSolutionPlan",
                    "kind": "LinkedField",
                    "name": "studio_solutionPlan",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "solutionVersion"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentBuildNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "conversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "solutionId"
                        },
                        v6 /*: any*/ ,
                        {
                            "concreteType": "StudioBuilds",
                            "kind": "LinkedField",
                            "name": "builds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "StudioBuild",
                                    "kind": "LinkedField",
                                    "name": "sequence",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "condition": "shouldIncludeAri",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "associatedObjectAri"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dependencies"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "buildId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "overview"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "studioTriggerSolutionBuildSolutionPlanQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "studioTriggerSolutionBuildSolutionPlanQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "id": "d15800213457a7a87b727610562460e90dc37726520c34ca32a874f96272a4dd",
            "metadata": {},
            "name": "studioTriggerSolutionBuildSolutionPlanQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6886b976dcf10159$var$node.hash = "34d4a09e864f38362051dbaedb75dca9";
var $6886b976dcf10159$export$2e2bcd8739ae039 = $6886b976dcf10159$var$node;
module.exports["default"] = $6886b976dcf10159$export$2e2bcd8739ae039;

});

parcelRegister("d6044", function(module, exports) {

var $1uK7M = parcelRequire("1uK7M");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/studio/workspace/manifest.ts
var $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $1uK7M.StudioWorkspaceAriResourceOwner),
    resourceType: (0, $1uK7M.StudioWorkspaceAriResourceType),
    resourceIdSlug: "{workspaceId}",
    resourceIdSegmentFormats: {
        workspaceId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/studio/workspace/index.ts
var $988be2c3a9b8d2c6$export$b1c922ee878b8ada = class _StudioWorkspaceAri extends (0, $1gKSA.RegisteredAri) {
    get workspaceId() {
        return this._workspaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts);
        return new _StudioWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $988be2c3a9b8d2c6$var$studioWorkspaceAriStaticOpts);
        return new _StudioWorkspaceAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId
        };
    }
    constructor(opts){
        super(opts), this._workspaceId = opts.resourceIdSegmentValues.workspaceId;
    }
};
module.exports["StudioWorkspaceAri"] = $988be2c3a9b8d2c6$export$b1c922ee878b8ada;

});

parcelRegister("2MD0u", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $4MnFz = parcelRequire("4MnFz");


var $5avUB = parcelRequire("5avUB");


var $hdBxM = parcelRequire("hdBxM");


var $hlvTd = parcelRequire("hlvTd");


var $irUqK = parcelRequire("irUqK");

const $b8e62c3a31241405$export$659fdf76514fefe3 = ({ refetch: refetch })=>{
    (0, $6cFsl.di)((0, $hdBxM.Subscriber), (0, $4MnFz.useFlags));
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handlePubSubEvent = (0, $cozmU.useCallback)(async (payload)=>{
        if (payload.type !== 'solution-plan-state-updated') return;
        try {
            await refetch();
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'studio-plan-state-update-refetch-error'
            });
            showFlag({
                title: formatMessage((0, $irUqK.messages).solutionPlanStateUpdateErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                }),
                description: formatMessage((0, $irUqK.messages).solutionPlanStateUpdateErrorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        formatMessage,
        showFlag,
        refetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        topic: "ai-mate",
        onEvent: handlePubSubEvent
    });
};
module.exports["SolutionPlanStateUpdateListener"] = $b8e62c3a31241405$export$659fdf76514fefe3;

});

parcelRegister("1zNQN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $irnO2 = parcelRequire("irnO2");


var $hMLWD = parcelRequire("hMLWD");


var $lzU6z = parcelRequire("lzU6z");


var $ejUo1 = parcelRequire("ejUo1");


var $j9u6G = parcelRequire("j9u6G");


var $kgMbL = parcelRequire("kgMbL");


var $7txt6 = parcelRequire("7txt6");

const $cc2575bcaa2f3b4a$var$ANIMATION_DURATION = '350ms'; // no token exists for this yet, it seems. { durations.medium } from '@atlaskit/motion' === 350ms
const $cc2575bcaa2f3b4a$var$styles = {
    container: "_0bjKvDyzSk _2V7sgOj3og _3hxITip3yX _3vBAKHgqQ0",
    contentFooterContainer: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3rdnbC _1kOSYtLaAG _0qk6IKxt7V _3Z9K0wngV3",
    contentFooterContainer_opened: "_0NUa3rW9qI"
};
const $cc2575bcaa2f3b4a$var$nativeStyles = {
    contentFooterContainer: "_1YjuKt1Z7S"
};
const $cc2575bcaa2f3b4a$export$733bafe990c4aef4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { isLoading: isLoading, name: name, solutionVersion: solutionVersion, builds: builds, productKey: productKey, cloudId: cloudId, aaid: aaid, spaceId: spaceId, solutionId: solutionId, refetchSolutionPlan: refetchSolutionPlan, currentBuildNumber: currentBuildNumber, workspaceId: workspaceId, renderingTouchpoint: renderingTouchpoint, experienceTracker: experienceTracker, solutionState: solutionState } = t0;
    (0, $6cFsl.di)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== builds) {
        t1 = ()=>{
            setIsOpen(!(0, $lzU6z.isFullyBuilt)(builds));
        };
        t2 = [
            builds
        ];
        $[0] = builds;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== builds || $[4] !== experienceTracker || $[5] !== isLoading) {
        t3 = ()=>{
            if (!isLoading && builds.length > 0) setTimeout(()=>{
                experienceTracker?.succeed({
                    name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN
                });
            }, 10);
            else if (!isLoading && builds.length === 0) experienceTracker?.fail({
                name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
                error: new Error("No builds found for solution plan")
            });
        };
        t4 = [
            isLoading,
            builds,
            experienceTracker
        ];
        $[3] = builds;
        $[4] = experienceTracker;
        $[5] = isLoading;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] !== experienceTracker) {
        t5 = (error)=>{
            experienceTracker?.fail({
                name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
                error: error
            });
        };
        $[8] = experienceTracker;
        $[9] = t5;
    } else t5 = $[9];
    const handleErrorBoundaryError = t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== renderingTouchpoint || $[12] !== workspaceId) {
        t7 = (0, $iDrrr.fg)("fe_enable_sa_externally") && {
            workspaceId: workspaceId,
            renderingTouchpoint: renderingTouchpoint
        };
        $[11] = renderingTouchpoint;
        $[12] = workspaceId;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== aaid || $[15] !== builds || $[16] !== cloudId || $[17] !== currentBuildNumber || $[18] !== refetchSolutionPlan || $[19] !== solutionState || $[20] !== spaceId || $[21] !== t7) {
        t8 = {
            builds: builds,
            refetchSolutionPlan: refetchSolutionPlan,
            currentBuildNumber: currentBuildNumber,
            cloudId: cloudId,
            aaid: aaid,
            spaceId: spaceId,
            ...t7,
            solutionState: solutionState
        };
        $[14] = aaid;
        $[15] = builds;
        $[16] = cloudId;
        $[17] = currentBuildNumber;
        $[18] = refetchSolutionPlan;
        $[19] = solutionState;
        $[20] = spaceId;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== isOpen) {
        t9 = ()=>setIsOpen(!isOpen);
        $[23] = isOpen;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== isLoading || $[26] !== isOpen || $[27] !== name || $[28] !== solutionVersion || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kgMbL.CardHeader), {
            isLoading: isLoading,
            name: name,
            solutionVersion: solutionVersion,
            isOpen: isOpen,
            onToggle: t9
        });
        $[25] = isLoading;
        $[26] = isOpen;
        $[27] = name;
        $[28] = solutionVersion;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== cloudId || $[32] !== isLoading || $[33] !== isOpen || $[34] !== productKey) {
        t11 = !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($cc2575bcaa2f3b4a$var$styles.contentFooterContainer, isOpen && $cc2575bcaa2f3b4a$var$styles.contentFooterContainer_opened, $cc2575bcaa2f3b4a$var$nativeStyles.contentFooterContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ejUo1.CardContent), {
            productKey: productKey,
            siteId: cloudId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9u6G.CardFooter), null));
        $[31] = cloudId;
        $[32] = isLoading;
        $[33] = isOpen;
        $[34] = productKey;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] !== solutionId || $[37] !== t10 || $[38] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cc2575bcaa2f3b4a$var$styles.container,
            testId: "studio-trigger-solution-build-plan-card",
            "data-solution-id": solutionId
        }, t10, t11);
        $[36] = solutionId;
        $[37] = t10;
        $[38] = t11;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== t12 || $[41] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7txt6.SolutionPlanContext).Provider, {
            value: t8
        }, t12);
        $[40] = t12;
        $[41] = t8;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] !== handleErrorBoundaryError || $[44] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t6,
            onError: handleErrorBoundaryError
        }, t13);
        $[43] = handleErrorBoundaryError;
        $[44] = t13;
        $[45] = t14;
    } else t14 = $[45];
    return t14;
} : ({ isLoading: isLoading, name: name, solutionVersion: solutionVersion, builds: builds, productKey: productKey, cloudId: cloudId, aaid: aaid, spaceId: spaceId, solutionId: solutionId, refetchSolutionPlan: refetchSolutionPlan, currentBuildNumber: currentBuildNumber, workspaceId: workspaceId, renderingTouchpoint: renderingTouchpoint, experienceTracker: experienceTracker, solutionState: solutionState })=>{
    (0, $6cFsl.di)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsOpen(!(0, $lzU6z.isFullyBuilt)(builds));
    }, [
        builds
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isLoading && builds.length > 0) // Error boundary could throw error. Before succeeding the experience, we want to make sure any error is captured in the experience tracker
        setTimeout(()=>{
            experienceTracker?.succeed({
                name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN
            });
        }, 10);
        else if (!isLoading && builds.length === 0) experienceTracker?.fail({
            name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
            error: new Error('No builds found for solution plan')
        });
    }, [
        isLoading,
        builds,
        experienceTracker
    ]);
    const handleErrorBoundaryError = (error)=>{
        experienceTracker?.fail({
            name: (0, $irnO2.ExperienceName).STUDIO_TRIGGER_SOLUTION_PLAN,
            error: error
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        }),
        onError: handleErrorBoundaryError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7txt6.SolutionPlanContext).Provider, {
        value: {
            builds: builds,
            refetchSolutionPlan: refetchSolutionPlan,
            currentBuildNumber: currentBuildNumber,
            cloudId: cloudId,
            aaid: aaid,
            spaceId: spaceId,
            ...(0, $iDrrr.fg)('fe_enable_sa_externally') && {
                workspaceId: workspaceId,
                renderingTouchpoint: renderingTouchpoint
            },
            solutionState: solutionState
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cc2575bcaa2f3b4a$var$styles.container,
        testId: "studio-trigger-solution-build-plan-card",
        "data-solution-id": solutionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kgMbL.CardHeader), {
        isLoading: isLoading,
        name: name,
        solutionVersion: solutionVersion,
        isOpen: isOpen,
        onToggle: ()=>setIsOpen(!isOpen)
    }), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($cc2575bcaa2f3b4a$var$styles.contentFooterContainer, isOpen && $cc2575bcaa2f3b4a$var$styles.contentFooterContainer_opened, $cc2575bcaa2f3b4a$var$nativeStyles.contentFooterContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ejUo1.CardContent), {
        productKey: productKey,
        siteId: cloudId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9u6G.CardFooter), null)))));
};
module.exports["PlanCard"] = $cc2575bcaa2f3b4a$export$733bafe990c4aef4;

});

parcelRegister("l3JZO", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");

const $821098e0aefdd4a2$var$extractErrorMessage = async (response)=>{
    try {
        const data = await response.json();
        if (typeof data?.message === 'string' && data.message.trim()) return data.message;
    } catch  {
    // Ignore parse errors and fall back to generic message.
    }
    return undefined;
};
const $821098e0aefdd4a2$var$mapToSolutionPlan = (response)=>({
        ...response,
        builds: response.builds.sequence.map((build)=>({
                ...build,
                solutionId: response.id,
                solutionVersion: response.solutionVersion,
                conversationId: response.conversationId
            })).sort((a, b)=>a.number - b.number)
    });
const $821098e0aefdd4a2$export$f0dd0673e93a5e08 = async (workspaceId, solutionId, solutionVersion)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/solution-architect/solution/${solutionId}/version/${solutionVersion}`);
    if (!response.ok) throw new Error('Failed to fetch solution version');
    return $821098e0aefdd4a2$var$mapToSolutionPlan(await response.json());
};
const $821098e0aefdd4a2$export$63027c1d05b51dc0 = async (workspaceId, solutionId, solutionVersion, buildNumber)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/solution-architect/solution/${solutionId}/version/${solutionVersion}/build/${buildNumber}`, {
        method: 'POST'
    });
    if (!response.ok) {
        const errorMessage = await $821098e0aefdd4a2$var$extractErrorMessage(response);
        throw new (0, $8A2GO.ApiError)('Failed to post solution build', {
            statusCode: response.status,
            rawErrorMessage: errorMessage
        });
    }
    return response.json();
};
module.exports["fetchSolutionPlan"] = $821098e0aefdd4a2$export$f0dd0673e93a5e08;
module.exports["postSolutionBuild"] = $821098e0aefdd4a2$export$63027c1d05b51dc0;

});

parcelRegister("4Jq8D", function(module, exports) {
const $8ea809229cd4d09d$export$747c1f25cec575c5 = [
    'WAITING',
    'IN_PROGRESS',
    'SUCCESS',
    'FAILED'
];
const $8ea809229cd4d09d$export$62ec3d196fff50a8 = [
    'ROVO_AGENT',
    'AUTOMATION_RULE',
    'ECOSYSTEM_APP'
];
const $8ea809229cd4d09d$export$4db5273b50ddbae7 = [
    'DRAFT',
    'DISABLED',
    'IN_PROGRESS',
    'COMPLETED'
];
module.exports["BuildStateValues"] = $8ea809229cd4d09d$export$747c1f25cec575c5;
module.exports["BuildTypeValues"] = $8ea809229cd4d09d$export$62ec3d196fff50a8;
module.exports["PlanStateValues"] = $8ea809229cd4d09d$export$4db5273b50ddbae7;

});

parcelRegister("lzU6z", function(module, exports) {

var $dw75i = parcelRequire("dw75i");


var $8u7nd = parcelRequire("8u7nd");

const $69490662a3474dc2$export$51d72112e06829cd = (build, builds)=>{
    return build.state !== 'SUCCESS' && (build.type !== 'ECOSYSTEM_APP' || build.state !== 'IN_PROGRESS') && build.dependencies.every((dependency)=>builds.find((b)=>b.number === dependency)?.state === 'SUCCESS');
};
const $69490662a3474dc2$export$604d6d3047fe19fa = (builds, currentBuildNumber)=>{
    return builds.find((build)=>build.number === currentBuildNumber) ?? builds[builds.length - 1];
};
const $69490662a3474dc2$export$2f151960e3c91fe4 = (builds, currentBuildNumber)=>{
    const index = builds.findIndex((build)=>build.number === currentBuildNumber);
    return index === -1 ? builds.length - 1 : index;
};
const $69490662a3474dc2$export$80f26840bf98a209 = (builds)=>{
    return builds.every((build)=>build.state === 'SUCCESS');
};
const $69490662a3474dc2$var$BUILD_TYPE_OFFSET = {
    AUTOMATION_RULE: 0,
    ECOSYSTEM_APP: 3,
    ROVO_AGENT: 6
};
const $69490662a3474dc2$export$1d030495877beb9 = (index, buildType)=>{
    const offset = $69490662a3474dc2$var$BUILD_TYPE_OFFSET[buildType] ?? 0;
    return (0, $8u7nd.APPEARANCES)[(index + offset) % (0, $8u7nd.APPEARANCES).length];
};
const $69490662a3474dc2$export$121db070cc35e492 = (actions)=>{
    const filteredActions = actions.filter((action)=>{
        if (action.key !== (0, $dw75i.STUDIO_TRIGGER_SOLUTION_PLAN_KEY)) throw new Error(`Invalid action key for ${(0, $dw75i.STUDIO_TRIGGER_SOLUTION_PLAN_KEY)}`);
        return action;
    });
    return filteredActions;
};
const $69490662a3474dc2$var$getPathname = ()=>{
    return typeof window !== 'undefined' ? window.location.pathname : '';
};
const $69490662a3474dc2$export$909e3b7e06dde9bb = ()=>{
    const workspaceIdMatch = $69490662a3474dc2$var$getPathname().match(/\/w\/([^\/]+)/);
    return workspaceIdMatch ? workspaceIdMatch[1] : null;
};
const $69490662a3474dc2$export$d403b5beb9f5d1d2 = ()=>{
    const spaceIdMatch = $69490662a3474dc2$var$getPathname().match(/\/spaces\/([^\/]+)/);
    return spaceIdMatch ? spaceIdMatch[1] : null;
};
module.exports["isBuildEnabled"] = $69490662a3474dc2$export$51d72112e06829cd;
module.exports["getCurrentBuild"] = $69490662a3474dc2$export$604d6d3047fe19fa;
module.exports["getCurrentBuildIndex"] = $69490662a3474dc2$export$2f151960e3c91fe4;
module.exports["isFullyBuilt"] = $69490662a3474dc2$export$80f26840bf98a209;
module.exports["getAppearanceForIndex"] = $69490662a3474dc2$export$1d030495877beb9;
module.exports["getWorkspaceIdFromUrl"] = $69490662a3474dc2$export$909e3b7e06dde9bb;
module.exports["getSpaceIdFromUrl"] = $69490662a3474dc2$export$d403b5beb9f5d1d2;

});

parcelRegister("6eH8m", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e0bdcd43fec636ee$var$message = (0, $kSwu1.defineMessages)({
    confirmButton: {
        id: "ai-mate.studio-update-agent-draft.confirm-button",
        defaultMessage: "Confirm"
    }
});
var $e0bdcd43fec636ee$export$2e2bcd8739ae039 = $e0bdcd43fec636ee$var$message;
module.exports["default"] = $e0bdcd43fec636ee$export$2e2bcd8739ae039;

});

parcelRegister("iGaH9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $hdBxM = parcelRequire("hdBxM");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $7eUSO = parcelRequire("7eUSO");


var $BHtVq = parcelRequire("BHtVq");

const $df50a29de4985252$var$disabledActions = [
    'finished',
    'cancelled',
    'errored'
];
const $df50a29de4985252$export$1ed5732261bbf098 = ({ actionRenderer: actionRenderer, payload: payload })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const { actions: actions, onCancel: onCancel, getStatus: getStatus, onCustomDataConfirm: onCustomDataConfirm, cloudId: cloudId, productKey: productKey, sendMessageConfirmedTools: sendMessageConfirmedTools, recipientAgentId: recipientAgentId, conversationId: conversationId, messageId: messageId } = actionRenderer;
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).STUDIO_UPDATE_AGENT,
            name: (0, $irnO2.ExperienceName).STUDIO_UPDATE_AGENT
        });
    }, [
        experienceTracker
    ]);
    const firstAction = actions[0];
    const { data: data } = firstAction;
    const status = getStatus(firstAction);
    const isDisabled = status !== 'idle' || $df50a29de4985252$var$disabledActions.includes(firstAction.status);
    const isSubmitting = status === 'started';
    const onClick = async ()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_tools_resumption_migration_exp', 'isEnabled', false)) {
            const idleActions = actions.filter((action)=>getStatus(action) === 'idle');
            sendMessageConfirmedTools({
                agentId: recipientAgentId,
                conversationId: conversationId,
                messageSources: {
                    interactionSource: 'updateAgentRenderer'
                },
                confirmed_tools: {
                    message_id: messageId ?? '',
                    tools: idleActions.map((action_0)=>action_0.invocationId === firstAction.invocationId ? (0, $7eUSO.buildToolFromAction)(action_0, 'confirmed', data) : (0, $7eUSO.buildToolFromAction)(action_0, 'cancelled'))
                }
            });
        } else await onCustomDataConfirm(firstAction, data);
        publish(payload);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $BHtVq.AgentDiffCard), {
        onConfirm: onClick,
        onCancel: ()=>onCancel(firstAction),
        isDisabled: isDisabled,
        isSubmitting: isSubmitting,
        fields: data.fields,
        cloudId: cloudId,
        productKey: productKey,
        experienceTracker: experienceTracker
    });
};
module.exports["UpdateAgentBase"] = $df50a29de4985252$export$1ed5732261bbf098;

});

parcelRegister("l65d3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $fHs3z = parcelRequire("fHs3z");


var $50AFk = parcelRequire("50AFk");

const $37d952b25afec83f$export$6d3236a68e26d48e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const { onClick: onClick, appearance: t0, spacing: t1, shape: t2 } = props;
    const appearance = t0 === undefined ? "subtle" : t0;
    const spacing = t1 === undefined ? "compact" : t1;
    const shape = t2 === undefined ? "default" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== formatMessage) {
        t3 = formatMessage((0, $50AFk.default).copyResponseLabel);
        $[0] = formatMessage;
        $[1] = t3;
    } else t3 = $[1];
    const copyResponseLabel = t3;
    let t4;
    if ($[2] !== onClick) {
        t4 = (_, event)=>onClick(event);
        $[2] = onClick;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== appearance || $[5] !== copyResponseLabel || $[6] !== shape || $[7] !== spacing || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            type: "button",
            onClick: t4,
            icon: $37d952b25afec83f$var$_temp,
            appearance: appearance,
            spacing: spacing,
            label: copyResponseLabel,
            shape: shape
        });
        $[4] = appearance;
        $[5] = copyResponseLabel;
        $[6] = shape;
        $[7] = spacing;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : (props)=>{
    const { onClick: onClick, appearance: appearance = 'subtle', spacing: spacing = 'compact', shape: shape = 'default' } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const copyResponseLabel = formatMessage((0, $50AFk.default).copyResponseLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        type: "button",
        onClick: (_, event)=>onClick(event),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #505258)"
            }),
        appearance: appearance,
        spacing: spacing,
        label: copyResponseLabel,
        shape: shape
    });
};
function $37d952b25afec83f$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
        ...iconProps,
        color: "var(--ds-icon-subtle, #505258)"
    });
}
module.exports["CopyResponse"] = $37d952b25afec83f$export$6d3236a68e26d48e;

});

parcelRegister("1a3X7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $6gkxM = parcelRequire("6gkxM");


var $8whuT = parcelRequire("8whuT");

const $c9cc17d9be0c1a9f$export$cdd79dbcfe8bc104 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $8whuT.default).debugLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClick) {
        t2 = (_, event)=>onClick?.(event);
        $[2] = onClick;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            label: t1,
            type: "button",
            onClick: t2,
            icon: $c9cc17d9be0c1a9f$var$_temp,
            appearance: "subtle",
            spacing: "default"
        });
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $8whuT.default).debugLabel),
        type: "button",
        onClick: (_, event)=>onClick?.(event),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6gkxM))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #505258)"
            }),
        appearance: "subtle",
        spacing: "default"
    });
};
function $c9cc17d9be0c1a9f$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6gkxM))), {
        ...iconProps,
        color: "var(--ds-icon-subtle, #505258)"
    });
}
module.exports["DebugButton"] = $c9cc17d9be0c1a9f$export$cdd79dbcfe8bc104;

});

parcelRegister("eBtjL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cSbrJ = parcelRequire("cSbrJ");

const $6bf88afbcf3714fa$export$d75c4947865e9ea2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClick: onClick, isSelected: isSelected, spacing: spacing, testId: testId } = t0;
    let t1;
    if ($[0] !== isSelected || $[1] !== onClick || $[2] !== spacing || $[3] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSbrJ.LikeButton), {
            onClick: onClick,
            isSelected: isSelected,
            spacing: spacing,
            testId: testId,
            isDislike: true
        });
        $[0] = isSelected;
        $[1] = onClick;
        $[2] = spacing;
        $[3] = testId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ onClick: onClick, isSelected: isSelected, spacing: spacing, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSbrJ.LikeButton), {
        onClick: onClick,
        isSelected: isSelected,
        spacing: spacing,
        testId: testId,
        isDislike: true
    });
module.exports["DislikeAnswer"] = $6bf88afbcf3714fa$export$d75c4947865e9ea2;

});

parcelRegister("a6xuq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cSbrJ = parcelRequire("cSbrJ");

const $f23818aab70c4e77$export$2be38d8379966967 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClick: onClick, isSelected: isSelected, spacing: spacing, testId: testId } = t0;
    let t1;
    if ($[0] !== isSelected || $[1] !== onClick || $[2] !== spacing || $[3] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSbrJ.LikeButton), {
            onClick: onClick,
            isSelected: isSelected,
            spacing: spacing,
            testId: testId
        });
        $[0] = isSelected;
        $[1] = onClick;
        $[2] = spacing;
        $[3] = testId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ onClick: onClick, isSelected: isSelected, spacing: spacing, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSbrJ.LikeButton), {
        onClick: onClick,
        isSelected: isSelected,
        spacing: spacing,
        testId: testId
    });
module.exports["LikeAnswer"] = $f23818aab70c4e77$export$2be38d8379966967;

});

parcelRegister("bp00X", function(module, exports) {
async function $7210489a5a7a25b2$export$a120fa392ca6250c(content, markdownData, chartApiService) {
    if (!markdownData || !content.includes('[^chart^]')) return content;
    const chartPlaceholderRegex = /\[\^chart\^\]/g;
    const matches = Array.from(content.matchAll(chartPlaceholderRegex));
    if (matches.length === 0) return content;
    let result = content;
    let chartIndex = 0;
    for(let i = 0; i < matches.length; i++){
        const chartConfigKey = `chart-${chartIndex}`;
        const chartConfigJson = markdownData[chartConfigKey];
        if (chartConfigJson) try {
            const chartConfig = JSON.parse(chartConfigJson);
            const chartLinkResponse = await chartApiService.generateChartLink({
                chartType: chartConfig.chartType,
                data: chartConfig.data,
                chartTitle: chartConfig.chartTitle,
                subtitle: chartConfig.subtitle,
                xAccessor: chartConfig.xAccessor,
                yAccessor: chartConfig.yAccessor,
                labelAccessor: chartConfig.labelAccessor,
                valueAccessor: chartConfig.valueAccessor,
                colorAccessor: chartConfig.colorAccessor,
                metricsConfig: chartConfig.metricsConfig
            });
            result = result.replace('[^chart^]', chartLinkResponse.link);
        } catch  {
        // If chart link generation fails, leave the placeholder as is
        }
        chartIndex++;
    }
    return result;
}
module.exports["replaceChartPlaceholdersWithSmartLinks"] = $7210489a5a7a25b2$export$a120fa392ca6250c;

});

parcelRegister("jkyLh", function(module, exports) {

var $gIoZF = parcelRequire("gIoZF");

const $aa185fae2307a9e9$export$273d6f7298d665a = (content, markdownData)=>{
    const doc = (0, $gIoZF.buildAdfDocForRichText)(content, markdownData);
    return doc?.content ?? null;
};
module.exports["buildEditorInsertAdfFragment"] = $aa185fae2307a9e9$export$273d6f7298d665a;

});

parcelRegister("hKEkM", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $226890dc624cd335$var$message = (0, $kSwu1.defineMessages)({
    confluenceInsertButtonLabel: {
        id: "rovo-chat.store-assistant.insert-replace.confluence-insert-button-label",
        defaultMessage: "Insert into page"
    },
    jiraInsertButtonLabel: {
        id: "rovo-chat.store-assistant.insert-replace.jira-insert-button-label",
        defaultMessage: "Insert into work item"
    },
    genericInsertButtonLabel: {
        id: "rovo-chat.store-assistant.insert-replace.generic-insert-button-label",
        defaultMessage: "Insert"
    },
    replaceButtonLabel: {
        id: "rovo-chat.store-assistant.insert-replace.replace-button-label",
        defaultMessage: "Replace selection"
    },
    tooltipMessage: {
        id: "rovo-chat.store-assistant.insert-replace.tooltip-message",
        defaultMessage: "This feature isn\u2019t supported in your current context. Try selecting, writing, or editing text on the page."
    }
});
var $226890dc624cd335$export$2e2bcd8739ae039 = $226890dc624cd335$var$message;
module.exports["default"] = $226890dc624cd335$export$2e2bcd8739ae039;

});

parcelRegister("eQC44", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6675a9093812e265$export$896a5b4bd59d107a = (0, $kSwu1.defineMessages)({
    chatHeaderMoreMenuButtonLabel: {
        id: "ai-mate.rovo-chat-header.more-menu-button-label",
        defaultMessage: "More"
    },
    chatHeaderFeedbackButtonText: {
        id: "ai-mate.rovo-chat-header.feedback-button-text",
        defaultMessage: "Feedback"
    },
    chatHeaderDebugButtonText: {
        id: "ai-mate.rovo-chat-header.debug-button-label",
        defaultMessage: "Debug"
    },
    chatHeaderDebugIconLabel: {
        id: "ai-mate.rovo-chat-header.debug-icon-label",
        defaultMessage: "Debug"
    },
    chatHeaderFeedbackIconLabel: {
        id: "ai-mate.rovo-chat-header.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    chatHeaderGetHelpButtonText: {
        id: "ai-mate.rovo-chat-header.get-help-button-text",
        defaultMessage: "Get help"
    },
    chatHeaderGetHelpIconLabel: {
        id: "ai-mate.rovo-chat-header.get-help-icon-label",
        defaultMessage: "Get help"
    },
    chatHeaderCloseButton: {
        id: "ai-mate.rovo-chat-header.close-chat-header-button-label",
        defaultMessage: "Close"
    },
    chatHeaderRenameButtonText: {
        id: "ai-mate.rovo-chat-header.rename-button-text",
        defaultMessage: "Rename"
    },
    chatHeaderRenameIconLabel: {
        id: "ai-mate.rovo-chat-header.rename-icon-label",
        defaultMessage: "Rename"
    },
    chatHeaderDeleteButtonText: {
        id: "ai-mate.rovo-chat-header.delete-button-text",
        defaultMessage: "Delete"
    },
    chatHeaderDeleteIconLabel: {
        id: "ai-mate.rovo-chat-header.delete-icon-label",
        defaultMessage: "Delete"
    },
    chatHeaderDesktopAppButtonText: {
        id: "ai-mate.rovo-chat-header.desktop-app-button-text",
        defaultMessage: "Desktop app"
    },
    chatHeaderDesktopAppIconLabel: {
        id: "ai-mate.rovo-chat-header.desktop-app-icon-label",
        defaultMessage: "Desktop app"
    },
    chatHeaderSlackAppButtonText: {
        id: "ai-mate.rovo-chat-header.slack-app-button-text",
        defaultMessage: "Rovo for Slack"
    },
    chatHeaderSlackAppIconLabel: {
        id: "ai-mate.rovo-chat-header.slack-app-icon-label",
        defaultMessage: "Rovo for Slack"
    },
    chatHeaderTeamsAppButtonText: {
        id: "ai-mate.rovo-chat-header.teams-app-button-text",
        defaultMessage: "Rovo for Teams"
    },
    chatHeaderTeamsAppIconLabel: {
        id: "ai-mate.rovo-chat-header.teams-app-icon-label",
        defaultMessage: "Rovo for Teams"
    },
    chatHeaderChromeExtensionButtonText: {
        id: "ai-mate.rovo-chat-header.chrome-extension-button-text",
        defaultMessage: "Chrome Extension"
    },
    chatHeaderChromeExtensionIconLabel: {
        id: "ai-mate.rovo-chat-header.chrome-extension-icon-label",
        defaultMessage: "Chrome Extension"
    },
    chatHeaderMobileAppButtonText: {
        id: "ai-mate.rovo-chat-header.mobile-app-button-text",
        defaultMessage: "Mobile app"
    },
    chatHeaderMobileAppIconLabel: {
        id: "ai-mate.rovo-chat-header.mobile-app-icon-label",
        defaultMessage: "Mobile app"
    },
    chatHeaderMoreMenuBackButtonLabel: {
        id: "ai-mate.rovo-chat-header.more-menu-back-button-label",
        defaultMessage: "Back"
    },
    chatStoreUserMessagesLabel: {
        id: "ai-mate.chat-input.store-user-messages.label",
        defaultMessage: "Record conversation history and context to improve quality"
    },
    mobileAppSubMenuLabel: {
        id: "ai-mate.chat-header.mobile-app-sub-menu-label",
        defaultMessage: "Mobile app"
    },
    mobileAppSubMenuTitle: {
        id: "ai-mate.chat-header.mobile-app-sub-menu-title",
        defaultMessage: "Mobile app"
    },
    chatHeaderSwitchSiteButtonText: {
        id: "ai-mate.rovo-chat-header.switch-site-button-text",
        defaultMessage: "Switch site"
    },
    chatHeaderSettingsButtonText: {
        id: "ai-mate.rovo-chat-header.settings-button-text",
        defaultMessage: "Settings and memory"
    },
    chatHeaderSettingsIconLabel: {
        id: "ai-mate.rovo-chat-header.settings-icon-label",
        defaultMessage: "Settings and memory"
    },
    chatHeaderWhatsNewButtonText: {
        id: "ai-mate.rovo-chat-header.whats-new-button-text",
        defaultMessage: "What's new"
    },
    chatHeaderWhatsNewIconLabel: {
        id: "ai-mate.rovo-chat-header.whats-new-icon-label",
        defaultMessage: "What's new"
    },
    chatHeaderShareButtonText: {
        id: "ai-mate.rovo-chat-header.share-button-text",
        defaultMessage: "Share"
    },
    chatHeaderShareIconLabel: {
        id: "ai-mate.rovo-chat-header.share-icon-label",
        defaultMessage: "Share"
    },
    chatHeaderShareDisabledTooltip: {
        id: "ai-mate.rovo-chat-header.share-disabled-tooltip",
        defaultMessage: "You can share once Rovo finishes responding"
    },
    chatHeaderShareMissingValidResponseDisabledTooltip: {
        id: "ai-mate.rovo-chat-header.share-missing-valid-response-disabled-tooltip",
        defaultMessage: "Rovo needs to provide a valid response before you can share"
    },
    chatHeaderCliButtonText: {
        id: "ai-mate.rovo-chat-header.cli-button-text",
        defaultMessage: "Rovo CLI"
    }
});
const $6675a9093812e265$var$SHARE_BUTTON_MESSAGE_KEYS = {
    'rovo-response-in-progress': 'chatHeaderShareDisabledTooltip',
    'missing-valid-response': 'chatHeaderShareMissingValidResponseDisabledTooltip'
};
const $6675a9093812e265$export$c200f777fa479a56 = (disabledReason, formatMessage)=>formatMessage($6675a9093812e265$export$896a5b4bd59d107a[disabledReason ? $6675a9093812e265$var$SHARE_BUTTON_MESSAGE_KEYS[disabledReason] : 'chatHeaderShareButtonText']);
module.exports["chatHeaderMessages"] = $6675a9093812e265$export$896a5b4bd59d107a;
module.exports["getShareButtonLabel"] = $6675a9093812e265$export$c200f777fa479a56;

});

parcelRegister("hUHHK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $f4V7N = parcelRequire("f4V7N");

const $ea83d266f866f2e9$export$6d92fb7968359ca4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $f4V7N.ShareUpToMessageContext));
} : ()=>(0, $cozmU.useContext)((0, $f4V7N.ShareUpToMessageContext));
module.exports["useShareUpToMessage"] = $ea83d266f866f2e9$export$6d92fb7968359ca4;

});

parcelRegister("5Utui", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e8e6fd78734ceb97$var$message = (0, $kSwu1.defineMessages)({
    shareUpToMessageLabel: {
        id: "conversation-assistant.common.message-footer-buttons.share-response.shareUpToMessageMessages.shareUpToMessageLabel",
        defaultMessage: "Share chat up to this point"
    }
});
var $e8e6fd78734ceb97$export$2e2bcd8739ae039 = $e8e6fd78734ceb97$var$message;
module.exports["default"] = $e8e6fd78734ceb97$export$2e2bcd8739ae039;

});

parcelRegister("6krP0", function(module, exports) {

var $71cHN = parcelRequire("71cHN");


var $2T8yd = parcelRequire("2T8yd");


var $lbz6H = parcelRequire("lbz6H");


var $90kqV = parcelRequire("90kqV");


var $exWRW = parcelRequire("exWRW");


var $jFuky = parcelRequire("jFuky");

/**
 * Fallback converter for unrecognized Lumina tags.
 * convertMd is used because it maps to a paragraph node in ADF.
 */ const $7f8ca7b26c692a0c$var$fallbackConverter = (0, $jFuky.convertMd);
/**
 * A no-op converter that returns undefined.
 * Used for tags that are handled elsewhere or should be skipped.
 */ const $7f8ca7b26c692a0c$var$skipTag = ()=>undefined;
const $7f8ca7b26c692a0c$var$TAG_CONVERTERS = {
    h: (0, $jFuky.convertH),
    md: (0, $jFuky.convertMd),
    carousel: (0, $71cHN.convertCarousel),
    'smart-link': (0, $90kqV.convertSmartLink),
    'smart-link-list': (0, $exWRW.convertSmartLinkList),
    'action-card': (0, $71cHN.convertActionCard),
    'project-highlight-card': (0, $71cHN.convertProjectHighlightCard),
    'contact-card': (0, $71cHN.convertContactCard),
    'people-card': (0, $71cHN.convertPeopleCard),
    'report-lines': (0, $71cHN.convertReportLines),
    ul: (0, $2T8yd.convertList),
    ol: (0, $2T8yd.convertList),
    list: (0, $2T8yd.convertList),
    'jira-epic-progress': (0, $71cHN.convertJiraEpicProgress),
    'jira-burndown-chart': (0, $71cHN.convertJiraBurndownChart),
    'jira-work-distribution': (0, $71cHN.convertJiraWorkDistribution),
    'people-entity': (0, $lbz6H.convertPeopleEntity),
    'people-entity-list': (0, $lbz6H.convertPeopleEntityList),
    // Sections should be handled at the layout level by convertSection.
    // This no-op is only for the unexpected case of a section reaching this converter.
    section: $7f8ca7b26c692a0c$var$skipTag
};
const $7f8ca7b26c692a0c$export$afabb34bab74cd37 = (luminaNode)=>{
    const converter = $7f8ca7b26c692a0c$var$TAG_CONVERTERS[luminaNode.tag];
    // If there's a registered converter, use its result (even if undefined)
    if (converter) return converter(luminaNode, $7f8ca7b26c692a0c$export$afabb34bab74cd37);
    // For unregistered tags, fall back to paragraph
    return $7f8ca7b26c692a0c$var$fallbackConverter(luminaNode);
};
module.exports["luminaToAdfJsonNode"] = $7f8ca7b26c692a0c$export$afabb34bab74cd37;

});

parcelRegister("9dpj4", function(module, exports) {

var $41gqr = parcelRequire("41gqr");

/**
 * Splits a section into its component parts: header and content children.
 *
 * Returns an object containing:
 * - header: The header element (h tag) if present, otherwise undefined
 * - contentChildren: All non-header child elements (excluding strings)
 *
 * Note: String children are silently dropped during this split. The ParsedElementType
 * currently includes string as a union member, which may benefit from tightening.
 *
 * @param section The section element to split
 * @returns Object with header and contentChildren properties
 */ const $602b3ba80366da24$var$splitSectionParts = (section)=>{
    const children = Array.isArray(section.children) ? section.children : [];
    const header = children.find((0, $41gqr.isHeaderElement));
    const contentChildren = children.filter((child)=>!(0, $41gqr.isHeaderElement)(child) && typeof child !== 'string');
    return {
        header: header,
        contentChildren: contentChildren
    };
};
/**
 * Converts children to an array of ADF nodes, filtering out undefined results.
 */ const $602b3ba80366da24$var$convertChildrenToNodes = (children, convertTag)=>{
    return children.flatMap((child)=>convertTag(child) ?? []);
};
/**
 * Converts the layout content of a section based on its layout type attribute.
 *
 * Supports:
 * - "one-column" / "overview": Simple content flow (returns array of nodes)
 * - "two-columns": Left/right layout with 50/50 width (returns single layoutSection node)
 * - "two-rows": Top/bottom flow (returns array of nodes in order)
 *
 * Returns an array of ADF content nodes.
 */ const $602b3ba80366da24$var$convertLayoutContent = (section, contentChildren, convertTag)=>{
    const layoutType = section.attributes?.layout;
    switch(layoutType){
        case 'one-column':
        case 'overview':
            // For single column, convert all content as-is (no layout wrapper needed)
            return $602b3ba80366da24$var$convertChildrenToNodes(contentChildren, convertTag);
        case 'two-columns':
            {
                // Build layout columns using pos attribute,
                // falling back to array order when pos is not present.
                const content = contentChildren.reduce((acc, child, index)=>{
                    const node = convertTag(child);
                    if (node) {
                        // Use pos as source of truth when present, otherwise fall back to array order
                        const pos = child.attributes?.pos;
                        const isLeft = pos !== undefined ? pos === 'left' : index === 0;
                        acc[isLeft ? 0 : 1].content.push(node);
                    }
                    return acc;
                }, [
                    {
                        type: 'layoutColumn',
                        attrs: {
                            width: 50
                        },
                        content: []
                    },
                    {
                        type: 'layoutColumn',
                        attrs: {
                            width: 50
                        },
                        content: []
                    }
                ]);
                return [
                    {
                        type: 'layoutSection',
                        content: content
                    }
                ];
            }
        case 'two-rows':
            {
                // Sort by pos attribute (top before bottom),
                // falling back to array order when pos is not present.
                const getPriority = (pos)=>pos === 'top' ? 0 : pos === 'bottom' ? 2 : 1;
                const sorted = [
                    ...contentChildren
                ].sort((a, b)=>getPriority(a.attributes?.pos) - getPriority(b.attributes?.pos));
                return $602b3ba80366da24$var$convertChildrenToNodes(sorted, convertTag);
            }
        default:
            // Unknown layout type - return empty array
            return [];
    }
};
const $602b3ba80366da24$export$d90fc8b5da2324c9 = (section, convertTag)=>{
    const outputNodes = [];
    // Step 1: Split section into header and content children
    const { header: header, contentChildren: contentChildren } = $602b3ba80366da24$var$splitSectionParts(section);
    // Step 2: Convert and add header element (if present)
    if (header) {
        const headerNode = convertTag(header);
        if (headerNode) outputNodes.push(headerNode);
    }
    // Step 3: Convert content based on layout type
    const layoutNodes = $602b3ba80366da24$var$convertLayoutContent(section, contentChildren, convertTag);
    outputNodes.push(...layoutNodes);
    return outputNodes;
};
module.exports["convertSection"] = $602b3ba80366da24$export$d90fc8b5da2324c9;

});

parcelRegister("6fWaX", function(module, exports) {
/**
 * Allowlist of Lumina XML tag names that should be routed through `luminaToAdf`
 * instead of the markdown encoder. Anything else encountered in the parsed HTML
 * is treated as prose and serialised back via `outerHTML` so the markdown
 * encoder receives the unmodified original markup.
 */ const $ff19e0513ae4bbb6$export$fd223fd43425ef7a = new Set([
    'section',
    'md',
    'h',
    'smart-link',
    'smart-link-list',
    'people-entity',
    'people-entity-list',
    'people-card',
    'carousel'
]);
module.exports["LUMINA_TAGS"] = $ff19e0513ae4bbb6$export$fd223fd43425ef7a;

});

parcelRegister("a93Ml", function(module, exports) {
/**
 * Lumina placeholder pattern that the streaming markdown parser writes into the
 * message `content` whenever it strips a `◐…◑` lumina payload out for separate
 * storage. Matches `[^lumina^]` and `[^lumina-N^]` (the indexed variant used
 * when multiple lumina blocks appear in one message).
 */ const $984164c01ae5cccf$export$388cd925973c3720 = /\[\^lumina(?:-\d+)?\^\]/g;
module.exports["LUMINA_PLACEHOLDER_RE"] = $984164c01ae5cccf$export$388cd925973c3720;

});

parcelRegister("2JXAC", function(module, exports) {
// Copied from @atlassian/preview-panel-global-objects/src/constants.tsx
const $08c83ac8d07d7101$export$546a1bec96320e93 = 'jira-issue';
const $08c83ac8d07d7101$export$28c97ce1c65279e8 = 'jira-work-item';
const $08c83ac8d07d7101$export$2a7bac3392b8eef0 = 'jira';
module.exports["WORK_ITEM_GLOBAL_OBJECT_TYPE"] = $08c83ac8d07d7101$export$546a1bec96320e93;
module.exports["WORK_ITEM_PANEL_TYPE"] = $08c83ac8d07d7101$export$28c97ce1c65279e8;
module.exports["JIRA_PRODUCT"] = $08c83ac8d07d7101$export$2a7bac3392b8eef0;

});

parcelRegister("7qHM3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $NF6kd = parcelRequire("NF6kd");

var $l7jo6 = parcelRequire("l7jo6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $5WTxQ = parcelRequire("5WTxQ");

var $kMhHg = parcelRequire("kMhHg");

var $fE1YT = parcelRequire("fE1YT");

var $bRCqW = parcelRequire("bRCqW");


var $lRhY3 = parcelRequire("lRhY3");

const $1daa75de4f023b31$var$getAnalyticsEnv = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $l7jo6.envType).DEV;
    return (0, $l7jo6.envType).PROD;
};
const $1daa75de4f023b31$var$styles = {
    iframe: "_30huDKYbGa _39xV02N91d _0jFU0VN91d",
    body: "_3iDTPbQ4SZ _2O5Vij7dHp _2WAcuGIZbP",
    loadingContainer: "_39xV02N91d _0jFU0VN91d",
    iframeHidden: "_3iDTPbYbGa"
};
const $1daa75de4f023b31$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $1daa75de4f023b31$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes, loadingState: loadingState } = t0;
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)();
    let t1;
    if ($[0] !== ari) {
        t1 = ari ?? $1daa75de4f023b31$export$6c67178058384ea6(ari);
        $[0] = ari;
        $[1] = t1;
    } else t1 = $[1];
    const cloudId = t1;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [isIframeLoading, setIsIframeLoading] = (0, $cozmU.useState)(true);
    let t2;
    let t3;
    if ($[2] !== cloudId || $[3] !== product) {
        t2 = ()=>{
            setAnalyticsClient(()=>{
                const analyticsClient_0 = new (0, $NF6kd.default)({
                    product: product,
                    env: $1daa75de4f023b31$var$getAnalyticsEnv(window.location.hostname),
                    origin: (0, $l7jo6.originType).WEB
                });
                if (cloudId) analyticsClient_0?.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
                return analyticsClient_0;
            });
        };
        t3 = [
            product,
            cloudId
        ];
        $[2] = cloudId;
        $[3] = product;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    bb0: {
        if (!iframeUrl || !colorMode) {
            t4 = iframeUrl;
            break bb0;
        }
        let t5;
        if ($[6] !== colorMode || $[7] !== iframeUrl) {
            const url_0 = new URL(iframeUrl, window.location.origin);
            url_0.searchParams.set("themeMode", colorMode);
            t5 = url_0.toString();
            $[6] = colorMode;
            $[7] = iframeUrl;
            $[8] = t5;
        } else t5 = $[8];
        t4 = t5;
    }
    const iframeSrc = t4;
    const isLoadingStateAvailable = Boolean(loadingState);
    let t5;
    if ($[9] !== isLoadingStateAvailable) {
        t5 = ()=>{
            if (isLoadingStateAvailable && (0, $iDrrr.fg)("add_loading_state_in_preview_panel")) setIsIframeLoading(true);
        };
        $[9] = isLoadingStateAvailable;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== iframeUrl || $[12] !== isLoadingStateAvailable) {
        t6 = [
            iframeUrl,
            isLoadingStateAvailable
        ];
        $[11] = iframeUrl;
        $[12] = isLoadingStateAvailable;
        $[13] = t6;
    } else t6 = $[13];
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[14] !== isLoadingStateAvailable) {
        t7 = ()=>{
            if (isLoadingStateAvailable && (0, $iDrrr.fg)("add_loading_state_in_preview_panel")) setIsIframeLoading(false);
        };
        $[14] = isLoadingStateAvailable;
        $[15] = t7;
    } else t7 = $[15];
    const handleIframeLoad = t7;
    let t8;
    if ($[16] !== icon || $[17] !== name) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
            title: name,
            icon: icon
        });
        $[16] = icon;
        $[17] = name;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== analyticsClient || $[20] !== close || $[21] !== panelType || $[22] !== parentProduct || $[23] !== t8 || $[24] !== url) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
            onClose: close,
            url: url,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsClient: analyticsClient
        }, t8);
        $[19] = analyticsClient;
        $[20] = close;
        $[21] = panelType;
        $[22] = parentProduct;
        $[23] = t8;
        $[24] = url;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== analyticsAttributes) {
        t10 = (0, $iDrrr.fg)("add-trigger-point-key-attribute-to-preview-panel") && {
            analyticsAttributes: analyticsAttributes
        };
        $[26] = analyticsAttributes;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== isIframeLoading || $[29] !== isLoadingStateAvailable || $[30] !== loadingState) {
        t11 = isLoadingStateAvailable && isIframeLoading && loadingState && (0, $iDrrr.fg)("add_loading_state_in_preview_panel") && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $1daa75de4f023b31$var$styles.loadingContainer
            ])
        }, loadingState());
        $[28] = isIframeLoading;
        $[29] = isLoadingStateAvailable;
        $[30] = loadingState;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== handleIframeLoad) {
        t12 = (0, $iDrrr.fg)("add_loading_state_in_preview_panel") && {
            onLoad: handleIframeLoad
        };
        $[32] = handleIframeLoad;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== isIframeLoading || $[35] !== isLoadingStateAvailable) {
        t13 = (0, $hekY6.default)([
            $1daa75de4f023b31$var$styles.iframe,
            isLoadingStateAvailable && isIframeLoading && (0, $iDrrr.fg)("add_loading_state_in_preview_panel") && $1daa75de4f023b31$var$styles.iframeHidden
        ]);
        $[34] = isIframeLoading;
        $[35] = isLoadingStateAvailable;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== iframeSrc || $[38] !== name || $[39] !== t12 || $[40] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement("iframe", {
            src: iframeSrc,
            title: name,
            ...t12,
            className: t13
        });
        $[37] = iframeSrc;
        $[38] = name;
        $[39] = t12;
        $[40] = t13;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== analyticsClient || $[43] !== panelType || $[44] !== parentProduct || $[45] !== t10 || $[46] !== t11 || $[47] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
            styles: $1daa75de4f023b31$var$styles.body,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsClient: analyticsClient,
            ...t10
        }, t11, t14);
        $[42] = analyticsClient;
        $[43] = panelType;
        $[44] = parentProduct;
        $[45] = t10;
        $[46] = t11;
        $[47] = t14;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== t15 || $[50] !== t9) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, t9, t15);
        $[49] = t15;
        $[50] = t9;
        $[51] = t16;
    } else t16 = $[51];
    return t16;
} : ({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes, loadingState: loadingState })=>{
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)();
    const cloudId = ari ?? $1daa75de4f023b31$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [isIframeLoading, setIsIframeLoading] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient_0 = new (0, $NF6kd.default)({
                product: product,
                env: $1daa75de4f023b31$var$getAnalyticsEnv(window.location.hostname),
                origin: (0, $l7jo6.originType).WEB
            });
            if (cloudId) analyticsClient_0?.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
            return analyticsClient_0;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeSrc = (0, $cozmU.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url_0 = new URL(iframeUrl, window.location.origin);
        url_0.searchParams.set('themeMode', colorMode);
        return url_0.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    const isLoadingStateAvailable = Boolean(loadingState); // Reset loading state when the iframe URL changes
    (0, $cozmU.useEffect)(()=>{
        if (isLoadingStateAvailable && (0, $iDrrr.fg)('add_loading_state_in_preview_panel')) setIsIframeLoading(true);
    }, [
        iframeUrl,
        isLoadingStateAvailable
    ]);
    const handleIframeLoad = (0, $cozmU.useCallback)(()=>{
        if (isLoadingStateAvailable && (0, $iDrrr.fg)('add_loading_state_in_preview_panel')) setIsIframeLoading(false);
    }, [
        isLoadingStateAvailable
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
        onClose: close,
        url: url,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsClient: analyticsClient
    }, /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
        styles: $1daa75de4f023b31$var$styles.body,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsClient: analyticsClient,
        ...(0, $iDrrr.fg)('add-trigger-point-key-attribute-to-preview-panel') && {
            analyticsAttributes: analyticsAttributes
        }
    }, isLoadingStateAvailable && isIframeLoading && loadingState && (0, $iDrrr.fg)('add_loading_state_in_preview_panel') && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $1daa75de4f023b31$var$styles.loadingContainer
        ])
    }, loadingState()), /*#__PURE__*/ $cozmU.createElement("iframe", {
        src: iframeSrc,
        title: name,
        ...(0, $iDrrr.fg)('add_loading_state_in_preview_panel') && {
            onLoad: handleIframeLoad
        },
        className: (0, $hekY6.default)([
            $1daa75de4f023b31$var$styles.iframe,
            isLoadingStateAvailable && isIframeLoading && (0, $iDrrr.fg)('add_loading_state_in_preview_panel') && $1daa75de4f023b31$var$styles.iframeHidden
        ])
    })));
});
module.exports["IFramePreviewPanel"] = $1daa75de4f023b31$export$83f0623b6f97b032;

});

parcelRegister("hCByF", function(module, exports) {
/**
 * @generated SignedSource<<9bf35de890b895e91ed7afee4671de54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b2bbc5366591cd16$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        }
    ],
    "type": "JiraProject"
};
$b2bbc5366591cd16$var$node.hash = "9fa2aba307f6184ef940fa0abbe53f0a";
var $b2bbc5366591cd16$export$2e2bcd8739ae039 = $b2bbc5366591cd16$var$node;
module.exports["default"] = $b2bbc5366591cd16$export$2e2bcd8739ae039;

});

parcelRegister("5VM4i", function(module, exports) {
/**
 * @generated SignedSource<<1adf87a66eaffffa2b0c265cfa48f644>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b873d851744ca8c8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "jira_isBetaAiFeaturesEnabled"
        },
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "cloudIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ],
    "type": "Query"
};
$b873d851744ca8c8$var$node.hash = "bb842cd232d1b12e9c7fa38b40662a57";
var $b873d851744ca8c8$export$2e2bcd8739ae039 = $b873d851744ca8c8$var$node;
module.exports["default"] = $b873d851744ca8c8$export$2e2bcd8739ae039;

});

parcelRegister("j9Z2s", function(module, exports) {

var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $7ChxK = parcelRequire("7ChxK");


var $c1A61 = parcelRequire("c1A61");


const $dbca5e2a1796bbec$export$9061d7ed53cefc00 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("bzfOg")), {
        moduleId: "460cccc2",
        priority: "interaction",
        moduleId: 'conversation-assistant-preview-card_gic-modal-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId, parentIssue: parentIssue })=>({
            queries: {
                entrypointGicModalParentIssueQuery: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $c1A61.default),
                    variables: {
                        cloudId: cloudId,
                        parentIssueKey: parentIssue ?? '',
                        shouldFetchParentIssue: !!parentIssue && (0, $7ChxK.isValidJiraIssueKey)(parentIssue)
                    }
                }
            }
        })
});
module.exports["gicModalEntryPoint"] = $dbca5e2a1796bbec$export$9061d7ed53cefc00;

});

parcelRegister("lxF6e", function(module, exports) {
/**
 * @generated SignedSource<<0b306d1a04c24a5556fd21b8d33c23e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c708f7261b4255cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jiraMultiWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraMultiWorkItemPreviewCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_project"
        }
    ],
    "type": "JiraProject"
};
$c708f7261b4255cf$var$node.hash = "f71639cb93047632360b521baa36d3be";
var $c708f7261b4255cf$export$2e2bcd8739ae039 = $c708f7261b4255cf$var$node;
module.exports["default"] = $c708f7261b4255cf$export$2e2bcd8739ae039;

});

parcelRegister("hu8st", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $aOjGz = parcelRequire("aOjGz");


var $hAgam = parcelRequire("hAgam");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $l9ukq = parcelRequire("l9ukq");

var $6wGOF = parcelRequire("6wGOF");


var $lfoFx = parcelRequire("lfoFx");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $5Wv8d = parcelRequire("5Wv8d");

const $04fedbbeb1cf14ce$var$messages = (0, $kSwu1.defineMessages)({
    noProjectsFound: {
        id: "conversation-assistant.common.ui.project-selector.no-projects-found",
        defaultMessage: "No projects found"
    },
    spaceSelectorLabel: {
        id: "conversation-assistant-preview-card.common.project-selector.spaceSelectorLabel",
        defaultMessage: "{projectName} ({projectKey})"
    },
    searchProjectsPlaceholder: {
        id: "conversation-assistant-preview-card.common.project-selector.searchProjectsPlaceholder",
        defaultMessage: "Search projects"
    },
    projectSelectorLabel: {
        id: "conversation-assistant-preview-card.common.project-selector.projectSelectorLabel",
        defaultMessage: "Project"
    }
});
const $04fedbbeb1cf14ce$var$styles = {
    customControl: "_39xV02N91d",
    dropdownContent: "_0NUa3r4qGD _4ouGXIyt6F _2WAcuGIZbP",
    searchContainer: "_2Y7lL48HPE",
    projectSelectorIconOnlyDisabled: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0V9DVM _39xV029DVM"
};
const $04fedbbeb1cf14ce$var$useProjectIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (selectedProjectIconUrl)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== selectedProjectIconUrl) {
        t0 = (iconProps)=>selectedProjectIconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
                src: selectedProjectIconUrl,
                alt: "",
                "aria-hidden": true,
                width: 16,
                height: 16
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), iconProps);
        $[0] = selectedProjectIconUrl;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (selectedProjectIconUrl)=>(0, $cozmU.useCallback)((iconProps)=>selectedProjectIconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
            src: selectedProjectIconUrl,
            alt: "",
            "aria-hidden": true,
            width: 16,
            height: 16
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), iconProps), [
        selectedProjectIconUrl
    ]);
const $04fedbbeb1cf14ce$var$CustomControl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const { projectIcon: ProjectIcon } = props.selectProps;
    let t1;
    if ($[3] !== ProjectIcon) {
        t1 = ProjectIcon ? /*#__PURE__*/ $cozmU.createElement(ProjectIcon, {
            label: ""
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), {
            label: ""
        });
        $[3] = ProjectIcon;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== children || $[6] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            paddingInline: "space.100",
            xcss: $04fedbbeb1cf14ce$var$styles.customControl
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t1, children));
        $[5] = children;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== props || $[9] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, props, t2);
        $[8] = props;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, ...props })=>{
    const { projectIcon: ProjectIcon } = props.selectProps;
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, props, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        paddingInline: "space.100",
        xcss: $04fedbbeb1cf14ce$var$styles.customControl
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, ProjectIcon ? /*#__PURE__*/ $cozmU.createElement(ProjectIcon, {
        label: ""
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), {
        label: ""
    }), children)));
}; /**
    * Icon-only variant: renders an `IconButton` trigger that opens a `DropdownMenu`
    * with an inline search field. Mirrors the Jira modernised create experience
    * (`IssueCreateModernisedProjectPickerDropdown`).
    */ 
const $04fedbbeb1cf14ce$var$ProjectSelectorIconOnly = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { siteId: siteId, setProject: setProject, selectedProject: selectedProject, selectedProjectIconUrl: selectedProjectIconUrl, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDisabled || $[1] !== selectedProject || $[2] !== setProject || $[3] !== siteId) {
        t2 = {
            siteId: siteId,
            isDisabled: isDisabled,
            selectedProject: selectedProject,
            setProject: setProject
        };
        $[0] = isDisabled;
        $[1] = selectedProject;
        $[2] = setProject;
        $[3] = siteId;
        $[4] = t2;
    } else t2 = $[4];
    const { displayedOptions: displayedOptions, isLoading: isLoading, sortOptionsWithSelectedFirst: sortOptionsWithSelectedFirst, handleProjectChange: handleProjectChange, debouncedLoadOptions: debouncedLoadOptions, handleMenuOpen: handleMenuOpen, handleMenuClose: handleMenuClose } = (0, $5Wv8d.useProjectSearch)(t2);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [searchValue, setSearchValue] = (0, $cozmU.useState)("");
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const firstItemRef = (0, $cozmU.useRef)(null);
    const searchInputRef = (0, $cozmU.useRef)(null);
    const ProjectIcon = $04fedbbeb1cf14ce$var$useProjectIcon(selectedProjectIconUrl);
    let t3;
    if ($[5] !== debouncedLoadOptions) {
        t3 = (event)=>{
            const value = event.currentTarget.value;
            setSearchValue(value);
            debouncedLoadOptions(value);
        };
        $[5] = debouncedLoadOptions;
        $[6] = t3;
    } else t3 = $[6];
    const handleSearchInputChange = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (event_0)=>{
            if (event_0.key === "Tab" && !event_0.shiftKey || event_0.key === "ArrowDown") {
                event_0.preventDefault();
                event_0.stopPropagation();
                firstItemRef.current?.focus();
                return;
            }
            if (event_0.key !== "Escape" && !(event_0.key === "Tab" && event_0.shiftKey)) event_0.stopPropagation();
        };
        $[7] = t4;
    } else t4 = $[7];
    const handleSearchKeyDown = t4;
    const handleSearchMouseDown = $04fedbbeb1cf14ce$var$_temp;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event_2)=>{
            if (firstItemRef.current && event_2.target === firstItemRef.current && (event_2.key === "ArrowUp" || event_2.key === "Tab" && event_2.shiftKey)) {
                event_2.preventDefault();
                event_2.stopPropagation();
                searchInputRef.current?.focus();
            }
        };
        $[8] = t5;
    } else t5 = $[8];
    const handleDropdownContentKeyDown = t5;
    let t6;
    if ($[9] !== handleMenuClose || $[10] !== handleMenuOpen) {
        t6 = (args)=>{
            setIsDropdownOpen(args.isOpen);
            if (args.isOpen) handleMenuOpen();
            else {
                setSearchValue("");
                handleMenuClose();
            }
        };
        $[9] = handleMenuClose;
        $[10] = handleMenuOpen;
        $[11] = t6;
    } else t6 = $[11];
    const handleDropdownOpenChange = t6;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (element)=>{
            searchInputRef.current = element;
        };
        $[12] = t7;
    } else t7 = $[12];
    const handleSearchInputRef = t7;
    let t8;
    let t9;
    if ($[13] !== isDropdownOpen) {
        t8 = ()=>{
            if (isDropdownOpen) searchInputRef.current?.focus();
        };
        t9 = [
            isDropdownOpen
        ];
        $[13] = isDropdownOpen;
        $[14] = t8;
        $[15] = t9;
    } else {
        t8 = $[14];
        t9 = $[15];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[16] !== formatMessage || $[17] !== selectedProject) {
        t10 = selectedProject ? formatMessage($04fedbbeb1cf14ce$var$messages.spaceSelectorLabel, {
            projectName: selectedProject?.label,
            projectKey: selectedProject?.projectKey
        }) : undefined;
        $[16] = formatMessage;
        $[17] = selectedProject;
        $[18] = t10;
    } else t10 = $[18];
    const triggerLabel = t10;
    let t11;
    if ($[19] !== ProjectIcon || $[20] !== isDisabled || $[21] !== triggerLabel) {
        t11 = (t12)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t12;
            return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                content: triggerLabel,
                position: "top",
                hideTooltipOnClick: true
            }, (tooltipProps)=>isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    ...tooltipProps,
                    "aria-label": triggerLabel,
                    xcss: $04fedbbeb1cf14ce$var$styles.projectSelectorIconOnlyDisabled
                }, /*#__PURE__*/ $cozmU.createElement(ProjectIcon, {
                    label: ""
                })) : /*#__PURE__*/ $cozmU.createElement("span", tooltipProps, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    ...triggerProps,
                    ref: triggerRef,
                    icon: ProjectIcon,
                    spacing: "compact",
                    appearance: "subtle",
                    label: triggerLabel,
                    isTooltipDisabled: true,
                    testId: "jira-aifc-preview-card-project-selector-trigger"
                })));
        };
        $[19] = ProjectIcon;
        $[20] = isDisabled;
        $[21] = triggerLabel;
        $[22] = t11;
    } else t11 = $[22];
    const renderTrigger = t11;
    let T0;
    let T1;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t21;
    let t22;
    if ($[23] !== displayedOptions || $[24] !== formatMessage || $[25] !== handleDropdownOpenChange || $[26] !== handleProjectChange || $[27] !== handleSearchInputChange || $[28] !== isLoading || $[29] !== renderTrigger || $[30] !== searchValue || $[31] !== selectedProject?.value || $[32] !== sortOptionsWithSelectedFirst) {
        const sortedOptions = sortOptionsWithSelectedFirst(displayedOptions);
        const showEmptyState = !isLoading && sortedOptions.length === 0;
        T1 = (0, $3vgx3.default);
        t16 = renderTrigger;
        t17 = "bottom-start";
        t18 = handleDropdownOpenChange;
        t19 = "compact";
        t20 = true;
        t21 = false;
        t22 = "jira-aifc-preview-card-project-selector";
        T0 = (0, $iMnC5.Box);
        t12 = $04fedbbeb1cf14ce$var$styles.dropdownContent;
        t13 = handleDropdownContentKeyDown;
        let t23;
        if ($[46] !== formatMessage) {
            t23 = formatMessage($04fedbbeb1cf14ce$var$messages.searchProjectsPlaceholder);
            $[46] = formatMessage;
            $[47] = t23;
        } else t23 = $[47];
        let t24;
        if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
            t24 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                label: "",
                size: "medium"
            });
            $[48] = t24;
        } else t24 = $[48];
        let t25;
        if ($[49] !== isLoading) {
            t25 = isLoading ? /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: "small"
            }) : undefined;
            $[49] = isLoading;
            $[50] = t25;
        } else t25 = $[50];
        if ($[51] !== handleSearchInputChange || $[52] !== searchValue || $[53] !== t23 || $[54] !== t25) {
            t14 = /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $04fedbbeb1cf14ce$var$styles.searchContainer,
                onMouseDown: handleSearchMouseDown
            }, /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
                ref: handleSearchInputRef,
                placeholder: t23,
                value: searchValue,
                onChange: handleSearchInputChange,
                onKeyDown: handleSearchKeyDown,
                elemBeforeInput: t24,
                elemAfterInput: t25,
                isCompact: true,
                appearance: "none",
                autoComplete: "off",
                testId: "jira-aifc-preview-card-project-selector-search"
            })));
            $[51] = handleSearchInputChange;
            $[52] = searchValue;
            $[53] = t23;
            $[54] = t25;
            $[55] = t14;
        } else t14 = $[55];
        t15 = showEmptyState ? /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
            isDisabled: true
        }, formatMessage($04fedbbeb1cf14ce$var$messages.noProjectsFound)) : /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), {
            hasSeparator: true
        }, sortedOptions.map((option, index)=>{
            const iconUrl = (0, $5Wv8d.getOptionIconUrl)(option);
            return /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
                key: String(option.value),
                ref: index === 0 ? firstItemRef : undefined,
                isSelected: option.value === selectedProject?.value,
                onClick: ()=>handleProjectChange(option),
                elemBefore: iconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
                    src: iconUrl,
                    alt: "",
                    "aria-hidden": true,
                    width: 24,
                    height: 24
                }) : undefined
            }, option.label);
        }));
        $[23] = displayedOptions;
        $[24] = formatMessage;
        $[25] = handleDropdownOpenChange;
        $[26] = handleProjectChange;
        $[27] = handleSearchInputChange;
        $[28] = isLoading;
        $[29] = renderTrigger;
        $[30] = searchValue;
        $[31] = selectedProject?.value;
        $[32] = sortOptionsWithSelectedFirst;
        $[33] = T0;
        $[34] = T1;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = t16;
        $[40] = t17;
        $[41] = t18;
        $[42] = t19;
        $[43] = t20;
        $[44] = t21;
        $[45] = t22;
    } else {
        T0 = $[33];
        T1 = $[34];
        t12 = $[35];
        t13 = $[36];
        t14 = $[37];
        t15 = $[38];
        t16 = $[39];
        t17 = $[40];
        t18 = $[41];
        t19 = $[42];
        t20 = $[43];
        t21 = $[44];
        t22 = $[45];
    }
    let t23;
    if ($[56] !== T0 || $[57] !== t12 || $[58] !== t13 || $[59] !== t14 || $[60] !== t15) {
        t23 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t12,
            onKeyDown: t13
        }, t14, t15);
        $[56] = T0;
        $[57] = t12;
        $[58] = t13;
        $[59] = t14;
        $[60] = t15;
        $[61] = t23;
    } else t23 = $[61];
    let t24;
    if ($[62] !== T1 || $[63] !== t16 || $[64] !== t17 || $[65] !== t18 || $[66] !== t19 || $[67] !== t20 || $[68] !== t21 || $[69] !== t22 || $[70] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement(T1, {
            trigger: t16,
            placement: t17,
            onOpenChange: t18,
            spacing: t19,
            shouldRenderToParent: t20,
            autoFocus: t21,
            testId: t22
        }, t23);
        $[62] = T1;
        $[63] = t16;
        $[64] = t17;
        $[65] = t18;
        $[66] = t19;
        $[67] = t20;
        $[68] = t21;
        $[69] = t22;
        $[70] = t23;
        $[71] = t24;
    } else t24 = $[71];
    return t24;
} : ({ siteId: siteId, setProject: setProject, selectedProject: selectedProject, selectedProjectIconUrl: selectedProjectIconUrl, isDisabled: isDisabled = false })=>{
    const { displayedOptions: displayedOptions, isLoading: isLoading, sortOptionsWithSelectedFirst: sortOptionsWithSelectedFirst, handleProjectChange: handleProjectChange, debouncedLoadOptions: debouncedLoadOptions, handleMenuOpen: handleMenuOpen, handleMenuClose: handleMenuClose } = (0, $5Wv8d.useProjectSearch)({
        siteId: siteId,
        isDisabled: isDisabled,
        selectedProject: selectedProject,
        setProject: setProject
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [searchValue, setSearchValue] = (0, $cozmU.useState)('');
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const firstItemRef = (0, $cozmU.useRef)(null);
    const searchInputRef = (0, $cozmU.useRef)(null);
    const ProjectIcon = $04fedbbeb1cf14ce$var$useProjectIcon(selectedProjectIconUrl);
    const handleSearchInputChange = (0, $cozmU.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setSearchValue(value);
        debouncedLoadOptions(value);
    }, [
        debouncedLoadOptions
    ]);
    const handleSearchKeyDown = (0, $cozmU.useCallback)((event_0)=>{
        // Tab or ArrowDown moves focus from the input to the first dropdown item.
        if (event_0.key === 'Tab' && !event_0.shiftKey || event_0.key === 'ArrowDown') {
            event_0.preventDefault();
            event_0.stopPropagation();
            firstItemRef.current?.focus();
            return;
        } // Stop typing keys from being interpreted as DropdownMenu keyboard navigation
        // (otherwise letters would jump focus between menu items).
        if (event_0.key !== 'Escape' && !(event_0.key === 'Tab' && event_0.shiftKey)) event_0.stopPropagation();
    }, []);
    const handleSearchMouseDown = (0, $cozmU.useCallback)((event_1)=>{
        // Prevent DropdownMenu from stealing focus when clicking inside the search field.
        event_1.stopPropagation();
    }, []);
    const handleDropdownContentKeyDown = (0, $cozmU.useCallback)((event_2)=>{
        // ArrowUp / Shift+Tab on the first item returns focus to the search input.
        if (firstItemRef.current && event_2.target === firstItemRef.current && (event_2.key === 'ArrowUp' || event_2.key === 'Tab' && event_2.shiftKey)) {
            event_2.preventDefault();
            event_2.stopPropagation();
            searchInputRef.current?.focus();
        }
    }, []);
    const handleDropdownOpenChange = (0, $cozmU.useCallback)((args)=>{
        setIsDropdownOpen(args.isOpen);
        if (args.isOpen) handleMenuOpen();
        else {
            setSearchValue('');
            handleMenuClose();
        }
    }, [
        handleMenuOpen,
        handleMenuClose
    ]);
    const handleSearchInputRef = (0, $cozmU.useCallback)((element)=>{
        searchInputRef.current = element;
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (isDropdownOpen) searchInputRef.current?.focus();
    }, [
        isDropdownOpen
    ]);
    const triggerLabel = selectedProject ? formatMessage($04fedbbeb1cf14ce$var$messages.spaceSelectorLabel, {
        projectName: selectedProject?.label,
        projectKey: selectedProject?.projectKey
    }) : undefined;
    const renderTrigger = (0, $cozmU.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: triggerLabel,
            position: "top",
            hideTooltipOnClick: true
        }, (tooltipProps)=>isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ...tooltipProps,
                "aria-label": triggerLabel,
                xcss: $04fedbbeb1cf14ce$var$styles.projectSelectorIconOnlyDisabled
            }, /*#__PURE__*/ $cozmU.createElement(ProjectIcon, {
                label: ""
            })) : /*#__PURE__*/ $cozmU.createElement("span", tooltipProps, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: ProjectIcon,
                spacing: "compact",
                appearance: "subtle",
                label: triggerLabel,
                isTooltipDisabled: true,
                testId: "jira-aifc-preview-card-project-selector-trigger"
            }))), [
        ProjectIcon,
        triggerLabel,
        isDisabled
    ]);
    const sortedOptions = sortOptionsWithSelectedFirst(displayedOptions);
    const showEmptyState = !isLoading && sortedOptions.length === 0;
    return /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        trigger: renderTrigger,
        placement: "bottom-start",
        onOpenChange: handleDropdownOpenChange,
        spacing: "compact",
        shouldRenderToParent: true,
        autoFocus: false,
        testId: "jira-aifc-preview-card-project-selector"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $04fedbbeb1cf14ce$var$styles.dropdownContent,
        onKeyDown: handleDropdownContentKeyDown
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $04fedbbeb1cf14ce$var$styles.searchContainer,
        onMouseDown: handleSearchMouseDown
    }, /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        ref: handleSearchInputRef,
        placeholder: formatMessage($04fedbbeb1cf14ce$var$messages.searchProjectsPlaceholder),
        value: searchValue,
        onChange: handleSearchInputChange,
        onKeyDown: handleSearchKeyDown,
        elemBeforeInput: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: "",
            size: "medium"
        }),
        elemAfterInput: isLoading ? /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small"
        }) : undefined,
        isCompact: true,
        appearance: "none",
        autoComplete: "off",
        testId: "jira-aifc-preview-card-project-selector-search"
    }))), showEmptyState ? /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        isDisabled: true
    }, formatMessage($04fedbbeb1cf14ce$var$messages.noProjectsFound)) : /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), {
        hasSeparator: true
    }, sortedOptions.map((option, index)=>{
        const iconUrl = (0, $5Wv8d.getOptionIconUrl)(option);
        return /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
            key: String(option.value),
            ref: index === 0 ? firstItemRef : undefined,
            isSelected: option.value === selectedProject?.value,
            onClick: ()=>handleProjectChange(option),
            elemBefore: iconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
                src: iconUrl,
                alt: "",
                "aria-hidden": true,
                width: 24,
                height: 24
            }) : undefined
        }, option.label);
    }))));
};
/**
 * Full width variant: Standard `<Select>`-based variant of the project selector with an
 * inline search field.
 */ const $04fedbbeb1cf14ce$var$ProjectSelectorFullWidth = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { siteId: siteId, setProject: setProject, selectedProject: selectedProject, selectedProjectIconUrl: selectedProjectIconUrl, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDisabled || $[1] !== selectedProject || $[2] !== setProject || $[3] !== siteId) {
        t2 = {
            siteId: siteId,
            isDisabled: isDisabled,
            selectedProject: selectedProject,
            setProject: setProject
        };
        $[0] = isDisabled;
        $[1] = selectedProject;
        $[2] = setProject;
        $[3] = siteId;
        $[4] = t2;
    } else t2 = $[4];
    const { displayedOptions: displayedOptions, isLoading: isLoading, sortOptionsWithSelectedFirst: sortOptionsWithSelectedFirst, handleProjectChange: handleProjectChange, debouncedLoadOptions: debouncedLoadOptions, handleMenuOpen: handleMenuOpen, handleMenuClose: handleMenuClose } = (0, $5Wv8d.useProjectSearch)(t2);
    const ProjectIcon = $04fedbbeb1cf14ce$var$useProjectIcon(selectedProjectIconUrl);
    let t3;
    if ($[5] !== debouncedLoadOptions) {
        t3 = (inputValue, t4)=>{
            const { action: action } = t4;
            if (action === "input-change") debouncedLoadOptions(inputValue);
        };
        $[5] = debouncedLoadOptions;
        $[6] = t3;
    } else t3 = $[6];
    const handleInputChange = t3;
    let t4;
    if ($[7] !== handleMenuOpen || $[8] !== isDisabled) {
        t4 = ()=>{
            if (isDisabled) return;
            handleMenuOpen();
        };
        $[7] = handleMenuOpen;
        $[8] = isDisabled;
        $[9] = t4;
    } else t4 = $[9];
    const guardedHandleMenuOpen = t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[10] !== formatMessage) {
        t5 = formatMessage($04fedbbeb1cf14ce$var$messages.projectSelectorLabel);
        $[10] = formatMessage;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== displayedOptions || $[13] !== sortOptionsWithSelectedFirst) {
        t6 = sortOptionsWithSelectedFirst(displayedOptions);
        $[12] = displayedOptions;
        $[13] = sortOptionsWithSelectedFirst;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            Control: $04fedbbeb1cf14ce$var$CustomControl
        };
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== isDisabled) {
        t8 = isDisabled ? {
            menuIsOpen: false
        } : {};
        $[16] = isDisabled;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            menu: $04fedbbeb1cf14ce$var$_temp2,
            control: $04fedbbeb1cf14ce$var$_temp3
        };
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== ProjectIcon || $[20] !== guardedHandleMenuOpen || $[21] !== handleInputChange || $[22] !== handleMenuClose || $[23] !== handleProjectChange || $[24] !== isDisabled || $[25] !== isLoading || $[26] !== selectedProject || $[27] !== t5 || $[28] !== t6 || $[29] !== t8) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
            projectIcon: ProjectIcon,
            label: t5,
            testId: "jira-aifc-preview-card-project-selector",
            spacing: "compact",
            appearance: "default",
            value: selectedProject,
            isLoading: isLoading,
            options: t6,
            onChange: handleProjectChange,
            onInputChange: handleInputChange,
            onMenuOpen: guardedHandleMenuOpen,
            onMenuClose: handleMenuClose,
            components: t7,
            isDisabled: isDisabled,
            ...t8,
            styles: t9
        });
        $[19] = ProjectIcon;
        $[20] = guardedHandleMenuOpen;
        $[21] = handleInputChange;
        $[22] = handleMenuClose;
        $[23] = handleProjectChange;
        $[24] = isDisabled;
        $[25] = isLoading;
        $[26] = selectedProject;
        $[27] = t5;
        $[28] = t6;
        $[29] = t8;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ({ siteId: siteId, setProject: setProject, selectedProject: selectedProject, selectedProjectIconUrl: selectedProjectIconUrl, isDisabled: isDisabled = false })=>{
    const { displayedOptions: displayedOptions, isLoading: isLoading, sortOptionsWithSelectedFirst: sortOptionsWithSelectedFirst, handleProjectChange: handleProjectChange, debouncedLoadOptions: debouncedLoadOptions, handleMenuOpen: handleMenuOpen, handleMenuClose: handleMenuClose } = (0, $5Wv8d.useProjectSearch)({
        siteId: siteId,
        isDisabled: isDisabled,
        selectedProject: selectedProject,
        setProject: setProject
    });
    const ProjectIcon = $04fedbbeb1cf14ce$var$useProjectIcon(selectedProjectIconUrl);
    const handleInputChange = (0, $cozmU.useCallback)((inputValue, { action: action })=>{
        if (action === 'input-change') debouncedLoadOptions(inputValue);
    }, [
        debouncedLoadOptions
    ]);
    const guardedHandleMenuOpen = (0, $cozmU.useCallback)(()=>{
        if (isDisabled) return;
        handleMenuOpen();
    }, [
        isDisabled,
        handleMenuOpen
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        projectIcon: ProjectIcon,
        label: formatMessage($04fedbbeb1cf14ce$var$messages.projectSelectorLabel),
        testId: "jira-aifc-preview-card-project-selector",
        spacing: "compact",
        appearance: "default",
        value: selectedProject,
        isLoading: isLoading,
        options: sortOptionsWithSelectedFirst(displayedOptions),
        onChange: handleProjectChange,
        onInputChange: handleInputChange,
        onMenuOpen: guardedHandleMenuOpen,
        onMenuClose: handleMenuClose,
        components: {
            Control: $04fedbbeb1cf14ce$var$CustomControl
        },
        isDisabled: isDisabled,
        ...isDisabled ? {
            menuIsOpen: false
        } : {},
        styles: {
            // Raise the menu above the work items table's fade gradient and "Show more" button.
            menu: (base)=>({
                    ...base,
                    zIndex: 200
                }),
            control: (base_0)=>({
                    ...base_0,
                    borderColor: "var(--ds-border, #0B120E24)"
                })
        }
    });
}; /**
    * This component is used to select a project from Jira.
    * The icon only variant is used by the single work item preview card view.
    * Whereas the full width variant is used by the multi work item preview card view.
    *
    * @param siteId - The site ID of the Jira instance.
    * @param setProject - The function to set the project.
    * @param selectedProject - The selected project.
    * @param isDisabled - Whether the project selector is disabled.
    */ 
const $04fedbbeb1cf14ce$export$a764642e4b725728 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let rest;
    let t1;
    if ($[0] !== t0) {
        ({ isIconOnly: t1, ...rest } = t0);
        $[0] = t0;
        $[1] = rest;
        $[2] = t1;
    } else {
        rest = $[1];
        t1 = $[2];
    }
    const isIconOnly = t1 === undefined ? false : t1;
    let t2;
    if ($[3] !== isIconOnly || $[4] !== rest) {
        t2 = isIconOnly ? /*#__PURE__*/ $cozmU.createElement($04fedbbeb1cf14ce$var$ProjectSelectorIconOnly, rest) : /*#__PURE__*/ $cozmU.createElement($04fedbbeb1cf14ce$var$ProjectSelectorFullWidth, rest);
        $[3] = isIconOnly;
        $[4] = rest;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ isIconOnly: isIconOnly = false, ...rest })=>isIconOnly ? /*#__PURE__*/ $cozmU.createElement($04fedbbeb1cf14ce$var$ProjectSelectorIconOnly, rest) : /*#__PURE__*/ $cozmU.createElement($04fedbbeb1cf14ce$var$ProjectSelectorFullWidth, rest);
function $04fedbbeb1cf14ce$var$_temp(event_1) {
    event_1.stopPropagation();
}
function $04fedbbeb1cf14ce$var$_temp2(base) {
    return {
        ...base,
        zIndex: 200
    };
}
function $04fedbbeb1cf14ce$var$_temp3(base_0) {
    return {
        ...base_0,
        borderColor: "var(--ds-border, #0B120E24)"
    };
}
module.exports["ProjectSelector"] = $04fedbbeb1cf14ce$export$a764642e4b725728;

});

parcelRegister("7e3Ro", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $bNRRA = parcelRequire("bNRRA");


var $lrAX8 = parcelRequire("lrAX8");


var $fgX9l = parcelRequire("fgX9l");


var $SiFbN = parcelRequire("SiFbN");


var $6PaCk = parcelRequire("6PaCk");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $2uDbg = parcelRequire("2uDbg");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $eh6Ml = parcelRequire("eh6Ml");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $1eUdH = parcelRequire("1eUdH");


var $7ChxK = parcelRequire("7ChxK");


var $91ATo = parcelRequire("91ATo");

const $d0469b637840ebe0$var$messages = (0, $kSwu1.defineMessages)({
    checkMarkIcon: {
        id: "conversation-assistant-preview-card.conversation-assistant-preview-card.jira-create-with-rovo-preview-card.jira-multi-work-item-card.work-items-table.checkMarkIcon",
        defaultMessage: "Work item created"
    },
    showMoreSuggestions: {
        id: "conversation-assistant-preview-card.conversation-assistant-preview-card.jira-create-with-rovo-preview-card.jira-multi-work-item-card.work-items-table.showMoreSuggestions",
        defaultMessage: "Show {count} more suggestions"
    },
    showFewerSuggestions: {
        id: "conversation-assistant-preview-card.conversation-assistant-preview-card.jira-create-with-rovo-preview-card.jira-multi-work-item-card.work-items-table.showFewerSuggestions",
        defaultMessage: "Show fewer suggestions"
    },
    disabledCheckboxSubTask: {
        id: "conversation-assistant-preview-card.conversation-assistant-preview-card.jira-create-with-rovo-preview-card.jira-multi-work-item-card.work-items-table.disabledCheckboxSubTask",
        defaultMessage: "Select a parent to select this work item."
    },
    selectWorkItem: {
        id: "conversation-assistant-preview-card.conversation-assistant-preview-card.jira-create-with-rovo-preview-card.jira-multi-work-item-card.work-items-table.selectWorkItem",
        defaultMessage: "Select {summary}"
    }
});
const $d0469b637840ebe0$var$styles = {
    table: "_0bjKvDKxmn _1mT5xdRAKS _39xV02N91d",
    tableWithPadding: "_1wydGW2ADO",
    row: "_0bjKvDKxmn _1mT5xdRAKS _0Of8r2gVvo _1wydGWgVvo _1Znuxb2ADO _2Zuz6Q2ADO _1eOmH6o126",
    fadeOffZoneTruncated: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _3CkH9oLfAA _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    fadeOffZoneTruncatedBleed: "_3OE6xY4F84 _4ApkO24F84 _0Bm75G4F84",
    fadeOffZoneTruncatedStagingArea: "_1v9SsVyzSk _3XDz3ByzSk",
    fadeOffZoneExpanded: "_3CkH9oYbGa _0jFU0VxpxF",
    issueKeyWrapper: "_3YEZNOdnbC _1ANEUSLRg7",
    summaryWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    summaryWithActions: "_0adFHsyFLW",
    pressable: "_39xV02N91d _3iDTPbvLZJ _2fwxA5ecOK _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _23rrnHQ4MZ _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXru7Cj1 _42Yu6BgtVO _1YKVNsdnbC _1eOmH6qWX3 _3gzVzLutHW",
    showMoreButtonVisible: "_23rrnHWgmT _1YKVNs7dHp",
    showMoreButtonElevated: "_1mT5xdRAKS _2IhTonUgYP",
    checkboxWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _43nrzT5UaJ _0rIjyk5UaJ _0GTcwR5UaJ _2xTnZx5UaJ",
    hidden: "_3iDTPbYbGa",
    iconWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT",
    rowDisabled: "_1YKVNsVx3j _1pp6NdYbGa"
};
const $d0469b637840ebe0$var$Row = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { project: project, issueType: issueType, draftWorkItem: draftWorkItem, hideInlineButtons: hideInlineButtons, onDeclineWorkItem: onDeclineWorkItem, gicEntryPointProps: gicEntryPointProps, onInlineAccept: onInlineAccept, isStagingArea: isStagingArea, itemCount: itemCount, isSelected: isSelected, onToggleSelect: onToggleSelect, isRowDisabled: isRowDisabled, checkboxesMode: checkboxesMode, isCreating: isCreatingAll, isParentSelected: isParentSelected, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isCreating, setIsCreating] = (0, $cozmU.useState)(false);
    const { summary: summary } = draftWorkItem;
    const isCreated = Boolean(draftWorkItem.createdIssueKey);
    const showRowActions = isHovered && !hideInlineButtons && !isCreated && !isCreatingAll;
    let t1;
    if ($[0] !== draftWorkItem || $[1] !== onInlineAccept) {
        t1 = async ()=>{
            setIsCreating(true);
            const parent = draftWorkItem.fields.parent;
            const draftWorkItemToAccept = {
                ...draftWorkItem
            };
            if (parent && !(0, $7ChxK.isValidJiraIssueKey)(parent)) draftWorkItemToAccept.fields.parent = undefined;
            if (!parent) draftWorkItemToAccept.childWorkItems = [];
            await onInlineAccept({
                draftWorkItem: draftWorkItemToAccept
            });
            setIsCreating(false);
        };
        $[0] = draftWorkItem;
        $[1] = onInlineAccept;
        $[2] = t1;
    } else t1 = $[2];
    const handleInlineAccept = t1;
    let t2;
    if ($[3] !== draftWorkItem.childWorkItems || $[4] !== draftWorkItem.invocationId || $[5] !== onDeclineWorkItem || $[6] !== onToggleSelect) {
        t2 = (args)=>{
            if ((0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "cohort", "control") === "checkboxes") {
                onToggleSelect(draftWorkItem.invocationId, false);
                draftWorkItem.childWorkItems?.forEach((child)=>onToggleSelect(child.invocationId, false));
            }
            onDeclineWorkItem(args);
        };
        $[3] = draftWorkItem.childWorkItems;
        $[4] = draftWorkItem.invocationId;
        $[5] = onDeclineWorkItem;
        $[6] = onToggleSelect;
        $[7] = t2;
    } else t2 = $[7];
    const handleDeclineWorkItem = t2;
    const reserveActionSpace = showRowActions || isCreating;
    const projectRef = (0, $6SsN4.useFragment)((0, $6PaCk.default), project);
    const issueTypeData = (0, $6SsN4.useFragment)((0, $SiFbN.default), issueType);
    let t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsHovered(true);
        t4 = ()=>setIsHovered(false);
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    const t5 = isRowDisabled ? $d0469b637840ebe0$var$styles.rowDisabled : undefined;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.row);
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== checkboxesMode || $[12] !== draftWorkItem || $[13] !== formatMessage || $[14] !== isCreated || $[15] !== isCreatingAll || $[16] !== isHovered || $[17] !== isParentSelected || $[18] !== isSelected || $[19] !== issueTypeData || $[20] !== onToggleSelect || $[21] !== sendAifcAnalyticsEvent || $[22] !== summary) {
        t7 = isCreated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            color: "var(--ds-icon-success, #6A9A23)",
            label: formatMessage($d0469b637840ebe0$var$messages.checkMarkIcon)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d0469b637840ebe0$var$styles.issueKeyWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, draftWorkItem.createdIssueKey))) : (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "cohort", "control") === "checkboxes" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isHovered || checkboxesMode ? $d0469b637840ebe0$var$styles.checkboxWrapper : $d0469b637840ebe0$var$styles.hidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: (0, $7ChxK.isSubTaskWithoutCreatedParent)(draftWorkItem) && !isParentSelected ? formatMessage($d0469b637840ebe0$var$messages.disabledCheckboxSubTask) : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
            isChecked: isSelected,
            isDisabled: isCreatingAll || (0, $7ChxK.isSubTaskWithoutCreatedParent)(draftWorkItem) && !isParentSelected,
            onChange: ()=>{
                onToggleSelect(draftWorkItem.invocationId, !isSelected);
                sendAifcAnalyticsEvent?.({
                    action: "selected",
                    actionSubject: "option",
                    actionSubjectId: "createWorkItemsSuggestionToggled",
                    attributes: {
                        isSelected: !isSelected,
                        invocationId: draftWorkItem.invocationId
                    }
                });
            },
            "aria-label": formatMessage($d0469b637840ebe0$var$messages.selectWorkItem, {
                summary: summary
            })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isHovered || checkboxesMode ? $d0469b637840ebe0$var$styles.hidden : $d0469b637840ebe0$var$styles.iconWrapper
        }, issueTypeData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
            issueType: issueTypeData
        }))) : issueTypeData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
            issueType: issueTypeData
        });
        $[11] = checkboxesMode;
        $[12] = draftWorkItem;
        $[13] = formatMessage;
        $[14] = isCreated;
        $[15] = isCreatingAll;
        $[16] = isHovered;
        $[17] = isParentSelected;
        $[18] = isSelected;
        $[19] = issueTypeData;
        $[20] = onToggleSelect;
        $[21] = sendAifcAnalyticsEvent;
        $[22] = summary;
        $[23] = t7;
    } else t7 = $[23];
    const t8 = reserveActionSpace && $d0469b637840ebe0$var$styles.summaryWithActions;
    let t9;
    if ($[24] !== t8) {
        t9 = (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.summaryWrapper, t8);
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== summary) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, summary);
        $[26] = summary;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== t10 || $[29] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t9
        }, t10);
        $[28] = t10;
        $[29] = t9;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== draftWorkItem || $[32] !== gicEntryPointProps || $[33] !== handleDeclineWorkItem || $[34] !== handleInlineAccept || $[35] !== isCreating || $[36] !== isStagingArea || $[37] !== itemCount || $[38] !== projectRef || $[39] !== sendAifcAnalyticsEvent || $[40] !== showRowActions) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ATo.RowActions), {
            projectRef: projectRef,
            draftWorkItem: draftWorkItem,
            onDeclineWorkItem: handleDeclineWorkItem,
            onInlineAccept: handleInlineAccept,
            isCreating: isCreating,
            showRowActions: showRowActions,
            gicEntryPointProps: gicEntryPointProps,
            isStagingArea: isStagingArea,
            itemCount: itemCount,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        });
        $[31] = draftWorkItem;
        $[32] = gicEntryPointProps;
        $[33] = handleDeclineWorkItem;
        $[34] = handleInlineAccept;
        $[35] = isCreating;
        $[36] = isStagingArea;
        $[37] = itemCount;
        $[38] = projectRef;
        $[39] = sendAifcAnalyticsEvent;
        $[40] = showRowActions;
        $[41] = t12;
    } else t12 = $[41];
    let t13;
    if ($[42] !== t11 || $[43] !== t12 || $[44] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            xcss: t6
        }, t7, t11, t12);
        $[42] = t11;
        $[43] = t12;
        $[44] = t7;
        $[45] = t13;
    } else t13 = $[45];
    let t14;
    if ($[46] !== t13 || $[47] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: t3,
            onMouseLeave: t4,
            xcss: t5
        }, t13);
        $[46] = t13;
        $[47] = t5;
        $[48] = t14;
    } else t14 = $[48];
    return t14;
} : ({ project: project, issueType: issueType, draftWorkItem: draftWorkItem, hideInlineButtons: hideInlineButtons, onDeclineWorkItem: onDeclineWorkItem, gicEntryPointProps: gicEntryPointProps, onInlineAccept: onInlineAccept, isStagingArea: isStagingArea, itemCount: itemCount, isSelected: isSelected, onToggleSelect: onToggleSelect, isRowDisabled: isRowDisabled, checkboxesMode: checkboxesMode, isCreating: isCreatingAll, isParentSelected: isParentSelected, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isCreating, setIsCreating] = (0, $cozmU.useState)(false);
    const { summary: summary } = draftWorkItem;
    const isCreated = Boolean(draftWorkItem.createdIssueKey);
    const showRowActions = isHovered && !hideInlineButtons && !isCreated && !isCreatingAll;
    const handleInlineAccept = (0, $cozmU.useCallback)(async ()=>{
        setIsCreating(true);
        const parent = draftWorkItem.fields.parent;
        const draftWorkItemToAccept = {
            ...draftWorkItem
        };
        if (parent && !(0, $7ChxK.isValidJiraIssueKey)(parent)) draftWorkItemToAccept.fields.parent = undefined;
        if (!parent) // remove the child work items for the inline create
        draftWorkItemToAccept.childWorkItems = [];
        await onInlineAccept({
            draftWorkItem: draftWorkItemToAccept
        });
        setIsCreating(false);
    }, [
        onInlineAccept,
        draftWorkItem
    ]);
    const handleDeclineWorkItem = (0, $cozmU.useCallback)((args)=>{
        if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control') === 'checkboxes') {
            onToggleSelect(draftWorkItem.invocationId, false);
            draftWorkItem.childWorkItems?.forEach((child)=>onToggleSelect(child.invocationId, false));
        }
        onDeclineWorkItem(args);
    }, [
        onDeclineWorkItem,
        onToggleSelect,
        draftWorkItem.invocationId,
        draftWorkItem.childWorkItems
    ]); // Keep the summary truncated (room reserved for the action buttons) while creating,
    // even when the row is no longer hovered, so the text never overlaps the buttons.
    const reserveActionSpace = showRowActions || isCreating;
    const projectRef = (0, $6SsN4.useFragment)((0, $6PaCk.default), project);
    const issueTypeData = (0, $6SsN4.useFragment)((0, $SiFbN.default), issueType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        xcss: isRowDisabled ? $d0469b637840ebe0$var$styles.rowDisabled : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075",
        xcss: (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.row)
    }, isCreated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: formatMessage($d0469b637840ebe0$var$messages.checkMarkIcon)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d0469b637840ebe0$var$styles.issueKeyWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, draftWorkItem.createdIssueKey))) : (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control') === 'checkboxes' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isHovered || checkboxesMode ? $d0469b637840ebe0$var$styles.checkboxWrapper : $d0469b637840ebe0$var$styles.hidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: (0, $7ChxK.isSubTaskWithoutCreatedParent)(draftWorkItem) && !isParentSelected ? formatMessage($d0469b637840ebe0$var$messages.disabledCheckboxSubTask) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
        isChecked: isSelected,
        isDisabled: isCreatingAll || (0, $7ChxK.isSubTaskWithoutCreatedParent)(draftWorkItem) && !isParentSelected,
        onChange: ()=>{
            onToggleSelect(draftWorkItem.invocationId, !isSelected);
            sendAifcAnalyticsEvent?.({
                action: 'selected',
                actionSubject: 'option',
                actionSubjectId: 'createWorkItemsSuggestionToggled',
                attributes: {
                    isSelected: !isSelected,
                    invocationId: draftWorkItem.invocationId
                }
            });
        },
        "aria-label": formatMessage($d0469b637840ebe0$var$messages.selectWorkItem, {
            summary: summary
        })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isHovered || checkboxesMode ? $d0469b637840ebe0$var$styles.hidden : $d0469b637840ebe0$var$styles.iconWrapper
    }, issueTypeData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
        issueType: issueTypeData
    }))) : issueTypeData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
        issueType: issueTypeData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.summaryWrapper, reserveActionSpace && $d0469b637840ebe0$var$styles.summaryWithActions)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ATo.RowActions), {
        projectRef: projectRef,
        draftWorkItem: draftWorkItem,
        onDeclineWorkItem: handleDeclineWorkItem,
        onInlineAccept: handleInlineAccept,
        isCreating: isCreating,
        showRowActions: showRowActions,
        gicEntryPointProps: gicEntryPointProps,
        isStagingArea: isStagingArea,
        itemCount: itemCount,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    })));
};
const $d0469b637840ebe0$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { remainingCount: remainingCount, isTruncated: isTruncated, onToggle: onToggle, isStagingArea: isStagingArea } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = !isTruncated && $d0469b637840ebe0$var$styles.fadeOffZoneExpanded;
    const t2 = isStagingArea && $d0469b637840ebe0$var$styles.fadeOffZoneTruncatedStagingArea;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.fadeOffZoneTruncated, t1, $d0469b637840ebe0$var$styles.fadeOffZoneTruncatedBleed, t2);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHovered(true);
        t5 = ()=>setIsHovered(false);
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    const t6 = isHovered && $d0469b637840ebe0$var$styles.showMoreButtonVisible;
    const t7 = !isTruncated && $d0469b637840ebe0$var$styles.showMoreButtonElevated;
    let t8;
    if ($[5] !== t6 || $[6] !== t7) {
        t8 = (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.showMoreButton, t6, t7);
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== formatMessage || $[9] !== isTruncated || $[10] !== remainingCount) {
        t9 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? isTruncated ? formatMessage($d0469b637840ebe0$var$messages.showMoreSuggestions, {
            count: remainingCount
        }) : formatMessage($d0469b637840ebe0$var$messages.showFewerSuggestions) : undefined;
        $[8] = formatMessage;
        $[9] = isTruncated;
        $[10] = remainingCount;
        $[11] = t9;
    } else t9 = $[11];
    const t10 = isTruncated ? `Show ${remainingCount} more` : "Show less";
    let t11;
    if ($[12] !== onToggle || $[13] !== t10 || $[14] !== t8 || $[15] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: t8,
            onClick: onToggle,
            "aria-label": t9
        }, t10);
        $[12] = onToggle;
        $[13] = t10;
        $[14] = t8;
        $[15] = t9;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== t11 || $[18] !== t3) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3,
            onMouseEnter: t4,
            onMouseLeave: t5
        }, t11);
        $[17] = t11;
        $[18] = t3;
        $[19] = t12;
    } else t12 = $[19];
    return t12;
} : ({ remainingCount: remainingCount, isTruncated: isTruncated, onToggle: onToggle, isStagingArea: isStagingArea })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.fadeOffZoneTruncated, !isTruncated && $d0469b637840ebe0$var$styles.fadeOffZoneExpanded, $d0469b637840ebe0$var$styles.fadeOffZoneTruncatedBleed, isStagingArea && $d0469b637840ebe0$var$styles.fadeOffZoneTruncatedStagingArea),
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.showMoreButton, isHovered && $d0469b637840ebe0$var$styles.showMoreButtonVisible, !isTruncated && $d0469b637840ebe0$var$styles.showMoreButtonElevated),
        onClick: onToggle,
        "aria-label": (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? isTruncated ? formatMessage($d0469b637840ebe0$var$messages.showMoreSuggestions, {
            count: remainingCount
        }) : formatMessage($d0469b637840ebe0$var$messages.showFewerSuggestions) : undefined
    }, isTruncated ? `Show ${remainingCount} more` : 'Show less'));
};
const $d0469b637840ebe0$var$RowWithWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    let draftWorkItem;
    let isStagingArea;
    let issueType;
    let openWorkItemView;
    let project;
    let props;
    if ($[0] !== t0) {
        ({ openWorkItemView: openWorkItemView, draftWorkItem: draftWorkItem, project: project, issueType: issueType, isStagingArea: isStagingArea, ...props } = t0);
        $[0] = t0;
        $[1] = draftWorkItem;
        $[2] = isStagingArea;
        $[3] = issueType;
        $[4] = openWorkItemView;
        $[5] = project;
        $[6] = props;
    } else {
        draftWorkItem = $[1];
        isStagingArea = $[2];
        issueType = $[3];
        openWorkItemView = $[4];
        project = $[5];
        props = $[6];
    }
    let t1;
    if ($[7] !== draftWorkItem.createdIssueKey || $[8] !== openWorkItemView) {
        t1 = ()=>{
            openWorkItemView(draftWorkItem.createdIssueKey);
        };
        $[7] = draftWorkItem.createdIssueKey;
        $[8] = openWorkItemView;
        $[9] = t1;
    } else t1 = $[9];
    const onCardClick = t1;
    const rowRef = (0, $6SsN4.useFragment)((0, $fgX9l.default), project);
    const issueTypeData = (0, $6SsN4.useFragment)((0, $lrAX8.default), issueType);
    let t2;
    if ($[10] !== draftWorkItem || $[11] !== isStagingArea || $[12] !== issueTypeData || $[13] !== onCardClick || $[14] !== props || $[15] !== rowRef) {
        t2 = !draftWorkItem.createdIssueKey || isStagingArea ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$Row, {
            project: rowRef,
            issueType: issueTypeData,
            draftWorkItem: draftWorkItem,
            isStagingArea: isStagingArea,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            onClick: onCardClick,
            xcss: $d0469b637840ebe0$var$styles.pressable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$Row, {
            project: rowRef,
            issueType: issueTypeData,
            draftWorkItem: draftWorkItem,
            isStagingArea: isStagingArea,
            ...props
        }));
        $[10] = draftWorkItem;
        $[11] = isStagingArea;
        $[12] = issueTypeData;
        $[13] = onCardClick;
        $[14] = props;
        $[15] = rowRef;
        $[16] = t2;
    } else t2 = $[16];
    const rowElement = t2;
    if ((0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
        fireExperimentExposure: false
    })) {
        let t3;
        if ($[17] !== rowElement) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                role: "listitem"
            }, rowElement);
            $[17] = rowElement;
            $[18] = t3;
        } else t3 = $[18];
        return t3;
    }
    return rowElement;
} : ({ openWorkItemView: openWorkItemView, draftWorkItem: draftWorkItem, project: project, issueType: issueType, isStagingArea: isStagingArea, ...props })=>{
    const onCardClick = (0, $cozmU.useCallback)(()=>{
        openWorkItemView(draftWorkItem.createdIssueKey);
    }, [
        openWorkItemView,
        draftWorkItem.createdIssueKey
    ]);
    const rowRef = (0, $6SsN4.useFragment)((0, $fgX9l.default), project);
    const issueTypeData = (0, $6SsN4.useFragment)((0, $lrAX8.default), issueType);
    const rowElement = !draftWorkItem.createdIssueKey || isStagingArea ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$Row, {
        project: rowRef,
        issueType: issueTypeData,
        draftWorkItem: draftWorkItem,
        isStagingArea: isStagingArea,
        ...props
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onCardClick,
        xcss: $d0469b637840ebe0$var$styles.pressable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$Row, {
        project: rowRef,
        issueType: issueTypeData,
        draftWorkItem: draftWorkItem,
        isStagingArea: isStagingArea,
        ...props
    }));
    if ((0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
        fireExperimentExposure: false
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "listitem"
    }, rowElement);
    return rowElement;
}; /**
    * A simple component that renders a list of Jira work item suggestions.
    * Truncates this list at 5 items - if there are more than 5, then show a simple fade-off effect to indicate that there are more items.
    *
    * @param draftWorkItems - The list of work item suggestions to render.
    */ 
const $d0469b637840ebe0$export$33f5f9e2192018a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { project: project, draftWorkItems: initialDraftWorkItems, hideInlineButtons: hideInlineButtons, onDeclineWorkItem: onDeclineWorkItem, onInlineAccept: onInlineAccept, openWorkItemView: openWorkItemView, gicEntryPointProps: gicEntryPointProps, isStagingArea: isStagingArea, selectedItems: selectedItems, onToggleSelect: onToggleSelect, hasAnyCreatedItems: hasAnyCreatedItems, isCreating: isCreating, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const flattenedDraftWorkItems = initialDraftWorkItems.flatMap($d0469b637840ebe0$var$_temp);
    let t1;
    if ($[0] !== initialDraftWorkItems) {
        t1 = new Map(initialDraftWorkItems.flatMap($d0469b637840ebe0$var$_temp2));
        $[0] = initialDraftWorkItems;
        $[1] = t1;
    } else t1 = $[1];
    const childToParentMap = t1;
    const firstFiveWorkItems = flattenedDraftWorkItems.slice(0, 5);
    const remainingWorkItemsCount = flattenedDraftWorkItems.length - 5;
    const itemCount = flattenedDraftWorkItems.length;
    const [showTruncatedWorkItemsList, setShowTruncatedWorkItemsList] = (0, $cozmU.useState)(itemCount > 5);
    const workItemsToShow = showTruncatedWorkItemsList ? firstFiveWorkItems : flattenedDraftWorkItems;
    const workItemsTableRef = (0, $6SsN4.useFragment)((0, $bNRRA.default), project);
    workItemsTableRef.issueTypes?.edges;
    let t2;
    if ($[2] !== workItemsTableRef.issueTypes?.edges) {
        t2 = new Map(workItemsTableRef.issueTypes?.edges?.flatMap($d0469b637840ebe0$var$_temp3));
        $[2] = workItemsTableRef.issueTypes?.edges;
        $[3] = t2;
    } else t2 = $[3];
    const issueTypeMap = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $cXtTj.default).getExperimentValue("jira-aifc-a11y-fixes-preview-card", "isEnabled", false, {
            fireExperimentExposure: false
        });
        $[4] = t3;
    } else t3 = $[4];
    const isListSemanticsEnabled = t3;
    let t4;
    if ($[5] !== childToParentMap || $[6] !== gicEntryPointProps || $[7] !== hasAnyCreatedItems || $[8] !== hideInlineButtons || $[9] !== isCreating || $[10] !== isStagingArea || $[11] !== issueTypeMap || $[12] !== itemCount || $[13] !== onDeclineWorkItem || $[14] !== onInlineAccept || $[15] !== onToggleSelect || $[16] !== openWorkItemView || $[17] !== selectedItems || $[18] !== sendAifcAnalyticsEvent || $[19] !== workItemsTableRef) {
        t4 = (draftWorkItem_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$RowWithWrapper, {
                project: workItemsTableRef,
                issueType: issueTypeMap.get(draftWorkItem_0.issueTypeId) ?? null,
                key: draftWorkItem_0.invocationId,
                draftWorkItem: draftWorkItem_0,
                hideInlineButtons: hideInlineButtons,
                openWorkItemView: openWorkItemView,
                onDeclineWorkItem: onDeclineWorkItem,
                gicEntryPointProps: gicEntryPointProps,
                onInlineAccept: onInlineAccept,
                isStagingArea: isStagingArea,
                itemCount: itemCount,
                isSelected: selectedItems.has(draftWorkItem_0.invocationId),
                onToggleSelect: onToggleSelect,
                checkboxesMode: selectedItems.size > 0,
                isParentSelected: selectedItems.has(childToParentMap.get(draftWorkItem_0.invocationId) ?? ""),
                isCreating: isCreating && (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "cohort", "control", {
                    fireExperimentExposure: false
                }) === "checkboxes",
                isRowDisabled: (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "cohort", "control", {
                    fireExperimentExposure: false
                }) === "checkboxes" ? hasAnyCreatedItems && !draftWorkItem_0.createdIssueKey || isCreating && !selectedItems.has(draftWorkItem_0.invocationId) : false,
                sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
            });
        $[5] = childToParentMap;
        $[6] = gicEntryPointProps;
        $[7] = hasAnyCreatedItems;
        $[8] = hideInlineButtons;
        $[9] = isCreating;
        $[10] = isStagingArea;
        $[11] = issueTypeMap;
        $[12] = itemCount;
        $[13] = onDeclineWorkItem;
        $[14] = onInlineAccept;
        $[15] = onToggleSelect;
        $[16] = openWorkItemView;
        $[17] = selectedItems;
        $[18] = sendAifcAnalyticsEvent;
        $[19] = workItemsTableRef;
        $[20] = t4;
    } else t4 = $[20];
    const rows = workItemsToShow.map(t4);
    const t5 = !showTruncatedWorkItemsList && $d0469b637840ebe0$var$styles.tableWithPadding;
    let t6;
    if ($[21] !== t5) {
        t6 = (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.table, t5);
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== isListSemanticsEnabled || $[24] !== rows) {
        t7 = isListSemanticsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            role: "list"
        }, rows) : rows;
        $[23] = isListSemanticsEnabled;
        $[24] = rows;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== isStagingArea || $[27] !== remainingWorkItemsCount || $[28] !== setShowTruncatedWorkItemsList || $[29] !== showTruncatedWorkItemsList) {
        t8 = remainingWorkItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$ShowMoreButton, {
            remainingCount: remainingWorkItemsCount,
            isTruncated: showTruncatedWorkItemsList,
            onToggle: ()=>setShowTruncatedWorkItemsList($d0469b637840ebe0$var$_temp4),
            isStagingArea: isStagingArea
        });
        $[26] = isStagingArea;
        $[27] = remainingWorkItemsCount;
        $[28] = setShowTruncatedWorkItemsList;
        $[29] = showTruncatedWorkItemsList;
        $[30] = t8;
    } else t8 = $[30];
    let t9;
    if ($[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: t6
        }, t7, t8);
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t9;
    } else t9 = $[34];
    return t9;
} : ({ project: project, draftWorkItems: initialDraftWorkItems, hideInlineButtons: hideInlineButtons, onDeclineWorkItem: onDeclineWorkItem, onInlineAccept: onInlineAccept, openWorkItemView: openWorkItemView, gicEntryPointProps: gicEntryPointProps, isStagingArea: isStagingArea, selectedItems: selectedItems, onToggleSelect: onToggleSelect, hasAnyCreatedItems: hasAnyCreatedItems, isCreating: isCreating, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const flattenedDraftWorkItems = initialDraftWorkItems.flatMap((draftWorkItem)=>[
            draftWorkItem,
            ...draftWorkItem.childWorkItems ?? []
        ]);
    const childToParentMap = (0, $cozmU.useMemo)(()=>new Map(initialDraftWorkItems.flatMap((parent)=>(parent.childWorkItems ?? []).map((child)=>[
                    child.invocationId,
                    parent.invocationId
                ]))), [
        initialDraftWorkItems
    ]);
    const firstFiveWorkItems = flattenedDraftWorkItems.slice(0, 5);
    const remainingWorkItemsCount = flattenedDraftWorkItems.length - 5;
    const itemCount = flattenedDraftWorkItems.length;
    const [showTruncatedWorkItemsList, setShowTruncatedWorkItemsList] = (0, $cozmU.useState)(itemCount > 5);
    const workItemsToShow = showTruncatedWorkItemsList ? firstFiveWorkItems : flattenedDraftWorkItems;
    const workItemsTableRef = (0, $6SsN4.useFragment)((0, $bNRRA.default), project);
    const issueTypeMap = (0, $cozmU.useMemo)(()=>new Map(workItemsTableRef.issueTypes?.edges?.flatMap((edge)=>edge?.node ? [
                [
                    edge.node.issueTypeId,
                    edge.node
                ]
            ] : [])), [
        workItemsTableRef.issueTypes?.edges
    ]);
    const isListSemanticsEnabled = (0, $cXtTj.default).getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const rows = workItemsToShow.map((draftWorkItem_0)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$RowWithWrapper, {
            project: workItemsTableRef,
            issueType: issueTypeMap.get(draftWorkItem_0.issueTypeId) ?? null,
            key: draftWorkItem_0.invocationId,
            draftWorkItem: draftWorkItem_0,
            hideInlineButtons: hideInlineButtons,
            openWorkItemView: openWorkItemView,
            onDeclineWorkItem: onDeclineWorkItem,
            gicEntryPointProps: gicEntryPointProps,
            onInlineAccept: onInlineAccept,
            isStagingArea: isStagingArea,
            itemCount: itemCount,
            isSelected: selectedItems.has(draftWorkItem_0.invocationId),
            onToggleSelect: onToggleSelect,
            checkboxesMode: selectedItems.size > 0,
            isParentSelected: selectedItems.has(childToParentMap.get(draftWorkItem_0.invocationId) ?? ''),
            isCreating: isCreating && (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
                fireExperimentExposure: false
            }) === 'checkboxes',
            isRowDisabled: (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'cohort', 'control', {
                fireExperimentExposure: false
            }) === 'checkboxes' ? // Row disabled post-creation
            hasAnyCreatedItems && !draftWorkItem_0.createdIssueKey || // Row disabled during creation
            isCreating && !selectedItems.has(draftWorkItem_0.invocationId) : false,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($d0469b637840ebe0$var$styles.table, !showTruncatedWorkItemsList && $d0469b637840ebe0$var$styles.tableWithPadding)
    }, isListSemanticsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        role: "list"
    }, rows) : rows, remainingWorkItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0469b637840ebe0$var$ShowMoreButton, {
        remainingCount: remainingWorkItemsCount,
        isTruncated: showTruncatedWorkItemsList,
        onToggle: ()=>setShowTruncatedWorkItemsList((prev)=>!prev),
        isStagingArea: isStagingArea
    }));
};
function $d0469b637840ebe0$var$_temp(draftWorkItem) {
    return [
        draftWorkItem,
        ...draftWorkItem.childWorkItems ?? []
    ];
}
function $d0469b637840ebe0$var$_temp2(parent) {
    return (parent.childWorkItems ?? []).map((child)=>[
            child.invocationId,
            parent.invocationId
        ]);
}
function $d0469b637840ebe0$var$_temp3(edge) {
    return edge?.node ? [
        [
            edge.node.issueTypeId,
            edge.node
        ]
    ] : [];
}
function $d0469b637840ebe0$var$_temp4(prev) {
    return !prev;
}
module.exports["WorkItemsTable"] = $d0469b637840ebe0$export$33f5f9e2192018a5;

});

parcelRegister("iudWS", function(module, exports) {
/**
 * @generated SignedSource<<a83d03bd1e678ad7a75ce65404b20605>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea519af94110b164$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "projectIdOrKey"
        }
    ],
    "kind": "Fragment",
    "name": "jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "idOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "previewContent_AtlassianConversationAssistantPreviewCard"
                }
            ]
        }
    ],
    "type": "Query"
};
$ea519af94110b164$var$node.hash = "285076a290432900dc371c79d19d4238";
var $ea519af94110b164$export$2e2bcd8739ae039 = $ea519af94110b164$var$node;
module.exports["default"] = $ea519af94110b164$export$2e2bcd8739ae039;

});

parcelRegister("1IcZo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9jygb = parcelRequire("9jygb");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $1eUdH = parcelRequire("1eUdH");


var $hu8st = parcelRequire("hu8st");


var $ajIch = parcelRequire("ajIch");


var $iunf4 = parcelRequire("iunf4");

const $3d7b6b8171cac8bf$var$SUMMARY_FIELD_NAME = 'summary';
const $3d7b6b8171cac8bf$var$DESCRIPTION_FIELD_NAME = 'description';
const $3d7b6b8171cac8bf$var$ISSUE_TYPE_FIELD_NAME = 'issuetype';
const $3d7b6b8171cac8bf$var$FIELDS_NOT_RENDERED = new Set([
    $3d7b6b8171cac8bf$var$SUMMARY_FIELD_NAME,
    $3d7b6b8171cac8bf$var$DESCRIPTION_FIELD_NAME,
    $3d7b6b8171cac8bf$var$ISSUE_TYPE_FIELD_NAME
]);
const $3d7b6b8171cac8bf$var$isDefined = (value)=>value !== null && value !== undefined;
const $3d7b6b8171cac8bf$var$messages = (0, $kSwu1.defineMessages)({
    descriptionHeading: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.description-field",
        defaultMessage: "Description"
    },
    detailsHeading: {
        id: "ai-mate.conversation-assistant-preview-card.jira-preview-card.details-heading",
        defaultMessage: "Details"
    }
});
const $3d7b6b8171cac8bf$var$styles = {
    issueTypeIconWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0V9DVM _39xV029DVM"
};
const $3d7b6b8171cac8bf$var$getFieldsToRender = (projectData, workItem)=>{
    const issueType = projectData?.issueTypes?.edges?.find((edge)=>edge?.node?.issueTypeId === workItem.issueTypeId)?.node;
    if (!issueType) return null;
     // first find the correct issuetype based on the issueTypeId, then create a map of fieldId to {fieldNode, isRequired}
    const allFieldsMap = new Map();
    issueType.fieldsConfiguration?.edges?.forEach((fieldEdge)=>{
        const node = fieldEdge?.node;
        if (!node) return;
        allFieldsMap.set(node.fieldId, fieldEdge?.node);
    });
    const detailsFields = Object.entries(workItem?.fields ?? {}).map(([workItemFieldId, fieldValue])=>{
        return {
            workItemFieldId: workItemFieldId,
            fieldValue: fieldValue,
            fieldNode: allFieldsMap.get(workItemFieldId) ?? null
        };
    }) // We don't render the summary, description or issuetype in the details section
    .filter((field)=>!$3d7b6b8171cac8bf$var$FIELDS_NOT_RENDERED.has(field.workItemFieldId));
    const summaryField = {
        workItemFieldId: $3d7b6b8171cac8bf$var$SUMMARY_FIELD_NAME,
        fieldValue: workItem?.summary,
        fieldNode: allFieldsMap.get($3d7b6b8171cac8bf$var$SUMMARY_FIELD_NAME) ?? null
    };
    const descriptionField = {
        workItemFieldId: $3d7b6b8171cac8bf$var$DESCRIPTION_FIELD_NAME,
        fieldValue: workItem?.fields?.description,
        fieldNode: allFieldsMap.get($3d7b6b8171cac8bf$var$DESCRIPTION_FIELD_NAME) ?? null
    };
    return {
        issueType: issueType,
        summaryField: summaryField,
        descriptionField: descriptionField,
        detailsFields: detailsFields
    };
};
const $3d7b6b8171cac8bf$var$SectionHeading = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { heading: heading } = t0;
    let t1;
    if ($[0] !== heading) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, heading);
        $[0] = heading;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ heading: heading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, heading);
}; /**
    * The content that is displayed in the chat preview card.
    */ 
const $3d7b6b8171cac8bf$export$c2de4b1d76b4a933 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(50);
    const { cloudId: cloudId, isEditable: isEditable, isCreated: isCreated, project: project, workItem: workItem, projectKey: projectKey, onFieldChange: onFieldChange, isStagingArea: isStagingArea, onProjectChange: onProjectChange, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const projectData = (0, $6SsN4.useFragment)((0, $9jygb.default), project);
    const projectId = projectData.id;
    const projectName = projectData.name;
    const projectIcon = projectData.avatar?.xsmall ?? undefined;
    const invocationId = workItem.invocationId;
    let t1;
    if ($[0] !== projectData || $[1] !== workItem) {
        t1 = $3d7b6b8171cac8bf$var$getFieldsToRender(projectData, workItem);
        $[0] = projectData;
        $[1] = workItem;
        $[2] = t1;
    } else t1 = $[2];
    const fieldsToRender = t1;
    let t2;
    if ($[3] !== onProjectChange) {
        t2 = (t3)=>{
            const { projectKey: pk } = t3;
            return onProjectChange(pk);
        };
        $[3] = onProjectChange;
        $[4] = t2;
    } else t2 = $[4];
    const setProject = t2;
    if (!fieldsToRender || !fieldsToRender.issueType) return null;
    let t3;
    if ($[5] !== cloudId || $[6] !== fieldsToRender.issueType || $[7] !== isCreated || $[8] !== isEditable || $[9] !== projectIcon || $[10] !== projectId || $[11] !== projectKey || $[12] !== projectName || $[13] !== setProject) {
        t3 = (0, $cXtTj.default).getExperimentValue("jira-aifc-project-selector-in-chat-exp", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu8st.ProjectSelector), {
            isIconOnly: true,
            isDisabled: !isEditable || isCreated,
            siteId: cloudId,
            selectedProject: {
                label: projectName,
                value: projectId,
                projectKey: projectKey
            },
            selectedProjectIconUrl: projectIcon,
            setProject: setProject
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium",
            color: "color.text.subtlest"
        }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $3d7b6b8171cac8bf$var$styles.issueTypeIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
            issueType: fieldsToRender.issueType,
            showTooltip: true
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
            issueType: fieldsToRender.issueType,
            showTooltip: true
        }));
        $[5] = cloudId;
        $[6] = fieldsToRender.issueType;
        $[7] = isCreated;
        $[8] = isEditable;
        $[9] = projectIcon;
        $[10] = projectId;
        $[11] = projectKey;
        $[12] = projectName;
        $[13] = setProject;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== fieldsToRender.summaryField.fieldNode || $[16] !== fieldsToRender.summaryField.fieldValue || $[17] !== invocationId || $[18] !== isEditable || $[19] !== isStagingArea || $[20] !== onFieldChange || $[21] !== projectKey || $[22] !== sendAifcAnalyticsEvent) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajIch.Field), {
            field: fieldsToRender.summaryField.fieldNode,
            fieldValue: fieldsToRender.summaryField.fieldValue,
            onFieldChange: onFieldChange,
            projectKey: projectKey,
            invocationId: invocationId,
            isEditable: isEditable,
            as: "heading",
            isFullWidth: true,
            isStagingArea: isStagingArea,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        });
        $[15] = fieldsToRender.summaryField.fieldNode;
        $[16] = fieldsToRender.summaryField.fieldValue;
        $[17] = invocationId;
        $[18] = isEditable;
        $[19] = isStagingArea;
        $[20] = onFieldChange;
        $[21] = projectKey;
        $[22] = sendAifcAnalyticsEvent;
        $[23] = t4;
    } else t4 = $[23];
    let t5;
    if ($[24] !== t3 || $[25] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, t3, t4);
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
    } else t5 = $[26];
    let t6;
    if ($[27] !== fieldsToRender.descriptionField.fieldNode || $[28] !== fieldsToRender.descriptionField.fieldValue || $[29] !== formatMessage || $[30] !== invocationId || $[31] !== isEditable || $[32] !== isStagingArea || $[33] !== onFieldChange || $[34] !== projectKey || $[35] !== sendAifcAnalyticsEvent) {
        t6 = $3d7b6b8171cac8bf$var$isDefined(fieldsToRender.descriptionField.fieldValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d7b6b8171cac8bf$var$SectionHeading, {
            heading: formatMessage($3d7b6b8171cac8bf$var$messages.descriptionHeading)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajIch.Field), {
            field: fieldsToRender.descriptionField.fieldNode,
            fieldValue: fieldsToRender.descriptionField.fieldValue,
            onFieldChange: onFieldChange,
            projectKey: projectKey,
            invocationId: invocationId,
            isFullWidth: true,
            isEditable: isEditable,
            isStagingArea: isStagingArea,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }));
        $[27] = fieldsToRender.descriptionField.fieldNode;
        $[28] = fieldsToRender.descriptionField.fieldValue;
        $[29] = formatMessage;
        $[30] = invocationId;
        $[31] = isEditable;
        $[32] = isStagingArea;
        $[33] = onFieldChange;
        $[34] = projectKey;
        $[35] = sendAifcAnalyticsEvent;
        $[36] = t6;
    } else t6 = $[36];
    let t7;
    if ($[37] !== fieldsToRender.detailsFields || $[38] !== formatMessage || $[39] !== invocationId || $[40] !== isEditable || $[41] !== isStagingArea || $[42] !== onFieldChange || $[43] !== projectKey || $[44] !== sendAifcAnalyticsEvent) {
        t7 = fieldsToRender.detailsFields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d7b6b8171cac8bf$var$SectionHeading, {
            heading: formatMessage($3d7b6b8171cac8bf$var$messages.detailsHeading)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, fieldsToRender.detailsFields.map((t8)=>{
            const { workItemFieldId: workItemFieldId, fieldValue: fieldValue, fieldNode: fieldNode } = t8;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iunf4.WithFieldLabel), {
                key: workItemFieldId,
                fieldConfig: fieldNode,
                fallbackFieldName: workItemFieldId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajIch.Field), {
                field: fieldNode,
                fieldValue: fieldValue,
                onFieldChange: onFieldChange,
                projectKey: projectKey,
                invocationId: invocationId,
                isEditable: isEditable,
                isStagingArea: isStagingArea,
                sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
            }));
        })));
        $[37] = fieldsToRender.detailsFields;
        $[38] = formatMessage;
        $[39] = invocationId;
        $[40] = isEditable;
        $[41] = isStagingArea;
        $[42] = onFieldChange;
        $[43] = projectKey;
        $[44] = sendAifcAnalyticsEvent;
        $[45] = t7;
    } else t7 = $[45];
    let t8;
    if ($[46] !== t5 || $[47] !== t6 || $[48] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t5, t6, t7);
        $[46] = t5;
        $[47] = t6;
        $[48] = t7;
        $[49] = t8;
    } else t8 = $[49];
    return t8;
} : ({ cloudId: cloudId, isEditable: isEditable, isCreated: isCreated, project: project, workItem: workItem, projectKey: projectKey, onFieldChange: onFieldChange, isStagingArea: isStagingArea, onProjectChange: onProjectChange, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const projectData = (0, $6SsN4.useFragment)((0, $9jygb.default), project); // Project info of current project to initially be displayed in the project selector
    const projectId = projectData.id;
    const projectName = projectData.name;
    const projectIcon = projectData.avatar?.xsmall ?? undefined;
    const invocationId = workItem.invocationId;
    const fieldsToRender = (0, $cozmU.useMemo)(()=>$3d7b6b8171cac8bf$var$getFieldsToRender(projectData, workItem), [
        projectData,
        workItem
    ]);
    const setProject = (0, $cozmU.useCallback)(({ projectKey: pk })=>onProjectChange(pk), [
        onProjectChange
    ]);
    if (!fieldsToRender || !fieldsToRender.issueType) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, (0, $cXtTj.default).getExperimentValue('jira-aifc-project-selector-in-chat-exp', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hu8st.ProjectSelector), {
        isIconOnly: true,
        isDisabled: !isEditable || isCreated,
        siteId: cloudId,
        selectedProject: {
            label: projectName,
            value: projectId,
            projectKey: projectKey
        },
        selectedProjectIconUrl: projectIcon,
        setProject: setProject
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        color: "color.text.subtlest"
    }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3d7b6b8171cac8bf$var$styles.issueTypeIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
        issueType: fieldsToRender.issueType,
        showTooltip: true
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eUdH.JiraIssueTypeIcon), {
        issueType: fieldsToRender.issueType,
        showTooltip: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajIch.Field), {
        field: fieldsToRender.summaryField.fieldNode,
        fieldValue: fieldsToRender.summaryField.fieldValue,
        onFieldChange: onFieldChange,
        projectKey: projectKey,
        invocationId: invocationId,
        isEditable: isEditable,
        as: "heading",
        isFullWidth: true,
        isStagingArea: isStagingArea,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    })), $3d7b6b8171cac8bf$var$isDefined(fieldsToRender.descriptionField.fieldValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d7b6b8171cac8bf$var$SectionHeading, {
        heading: formatMessage($3d7b6b8171cac8bf$var$messages.descriptionHeading)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajIch.Field), {
        field: fieldsToRender.descriptionField.fieldNode,
        fieldValue: fieldsToRender.descriptionField.fieldValue,
        onFieldChange: onFieldChange,
        projectKey: projectKey,
        invocationId: invocationId,
        isFullWidth: true,
        isEditable: isEditable,
        isStagingArea: isStagingArea,
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    })), fieldsToRender.detailsFields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d7b6b8171cac8bf$var$SectionHeading, {
        heading: formatMessage($3d7b6b8171cac8bf$var$messages.detailsHeading)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, fieldsToRender.detailsFields.map(({ workItemFieldId: workItemFieldId, fieldValue: fieldValue, fieldNode: fieldNode })=>// Fallback to the fieldId if the fieldName is not found, specifically this handles the parent field
        // which may not exist in the response from the API
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iunf4.WithFieldLabel), {
            key: workItemFieldId,
            fieldConfig: fieldNode,
            fallbackFieldName: workItemFieldId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajIch.Field), {
            field: fieldNode,
            fieldValue: fieldValue,
            onFieldChange: onFieldChange,
            projectKey: projectKey,
            invocationId: invocationId,
            isEditable: isEditable,
            isStagingArea: isStagingArea,
            sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
        }))))));
};
module.exports["PreviewContent"] = $3d7b6b8171cac8bf$export$c2de4b1d76b4a933;

});

parcelRegister("8dMxJ", function(module, exports) {
const $049d8d70184350eb$export$f80c391eaed27b3 = {
    duration: 800,
    // ms — draw time per span
    delay: 400,
    // ms — pause before first span starts
    cascadeOffset: 10,
    // ms — gap between spans (cascade-in effect)
    strokeWidth: 0.4,
    // → Math.max(20 × 0.4, 6) = 8px effective stroke
    strokeCount: 5,
    // base strokes per ~20px line height
    wiggle: 1,
    // bezier control-point Y variance (px)
    spread: 0.7,
    // 70% of span height used by stroke stack
    jitter: 3 // random per-stroke Y offset (px)
};
module.exports["PARAMS"] = $049d8d70184350eb$export$f80c391eaed27b3;

});

parcelRegister("1njGe", function(module, exports) {

var $4AQlH = parcelRequire("4AQlH");

const $0bc7037c609880ea$export$e68ffcbbdb1975d7 = (0, $4AQlH.normalizeAgentIdentityValue);
module.exports["normalizeIdentityValue"] = $0bc7037c609880ea$export$e68ffcbbdb1975d7;

});

parcelRegister("2LKLB", function(module, exports) {

var $9iSLp = parcelRequire("9iSLp");


var $k43Ke = parcelRequire("k43Ke");

const $f2c617a34be6302c$export$5a53abb79eaa5cf9 = (agent, author)=>(0, $9iSLp.authorsMatch)((0, $k43Ke.deriveBaselineAuthorIdentity)(agent), author);
module.exports["agentMatchesAuthor"] = $f2c617a34be6302c$export$5a53abb79eaa5cf9;

});

parcelRegister("ay0f3", function(module, exports) {

var $9iSLp = parcelRequire("9iSLp");

const $03bed1371cd3b551$export$960d90241c46cd58 = ({ currentAuthor: currentAuthor, previousAuthor: previousAuthor })=>{
    if (!previousAuthor) return false;
    return !(0, $9iSLp.authorsMatch)(currentAuthor, previousAuthor);
};
module.exports["shouldShowAgentResponseHat"] = $03bed1371cd3b551$export$960d90241c46cd58;

});

parcelRegister("jCmJN", function(module, exports) {

var $hlvTd = parcelRequire("hlvTd");


var $bcdSN = parcelRequire("bcdSN");

const $d9d85e187fa15a4b$var$isValidJiraId = (keyOrId)=>Number.isInteger(Number(keyOrId));
const $d9d85e187fa15a4b$var$BASE_URL_REGEX = /^(https:\/\/[^\/]+)/;
// Jira Bulk Create API
const $d9d85e187fa15a4b$var$getBulkCreateUrl = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/bulk`;
// Extract cloudUrl from the first issue
const $d9d85e187fa15a4b$var$extractCloudUrl = (issues)=>{
    return issues[0]?.self.match($d9d85e187fa15a4b$var$BASE_URL_REGEX)?.[0] ?? '';
};
const $d9d85e187fa15a4b$export$83be75df5ca7f98e = async ({ draftWorkItems: draftWorkItems, cloudId: cloudId })=>{
    try {
        const url = $d9d85e187fa15a4b$var$getBulkCreateUrl(cloudId);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify($d9d85e187fa15a4b$export$b98716228e172354(draftWorkItems))
        });
        const data = await response.json();
        if (data.issues.length === 0 || data.errors.length > 0) {
            // Get unique errors that appear across all issues in the bulk create request
            const uniqueErrors = new Set(data.errors.flatMap((e)=>{
                if (Object.values(e.elementErrors.errors).length > 0) return Object.values(e.elementErrors.errors);
                return e.elementErrors.errorMessages;
            }));
            // Convert each error into sentence case
            return {
                isSuccess: false,
                errorMessages: Array.from(uniqueErrors)
            };
        }
        return {
            isSuccess: true,
            createdIssues: data.issues,
            cloudUrl: $d9d85e187fa15a4b$var$extractCloudUrl(data.issues)
        };
    } catch (err) {
        (0, $hlvTd.logException)({
            exception: err,
            name: 'CreateParentIssueBulkError'
        });
        // Return an empty array of error messages to indicate that the error is not related to the bulk create API
        return {
            isSuccess: false,
            errorMessages: []
        };
    }
};
const $d9d85e187fa15a4b$export$b98716228e172354 = (draftWorkItems)=>({
        issueUpdates: draftWorkItems.map((draftWorkItem)=>{
            const { projectIdOrKey: projectIdOrKey, issueTypeId: issueTypeId } = draftWorkItem;
            // Ensure parent and project fields have the correct field key
            const parentIdOrKey = draftWorkItem.fields?.parent?.id;
            const parentField = parentIdOrKey ? {
                parent: $d9d85e187fa15a4b$var$isValidJiraId(parentIdOrKey) ? {
                    id: parentIdOrKey
                } : {
                    key: parentIdOrKey
                }
            } : {};
            const projectField = $d9d85e187fa15a4b$var$isValidJiraId(projectIdOrKey) ? {
                id: projectIdOrKey
            } : {
                key: projectIdOrKey
            };
            // Update-operation fields (e.g. issuelinks, comment) are not accepted under
            // `fields` by the Jira bulk create API and must be sent under `update` as an
            // array of operation objects (e.g. `[{ add: <value> }]`).
            const fieldsToCreate = {};
            const fieldsToUpdate = {};
            for (const [fieldKey, fieldValue] of Object.entries(draftWorkItem.fields ?? {}))if ((0, $bcdSN.fieldTypeToPayload)[fieldKey]?.isUpdateOperation) fieldsToUpdate[fieldKey] = fieldValue;
            else fieldsToCreate[fieldKey] = fieldValue;
            return {
                fields: {
                    ...fieldsToCreate,
                    issuetype: {
                        id: issueTypeId
                    },
                    project: projectField,
                    ...parentField
                },
                update: fieldsToUpdate
            };
        })
    });
module.exports["createIssuesInBulk"] = $d9d85e187fa15a4b$export$83be75df5ca7f98e;

});

parcelRegister("9KnlJ", function(module, exports) {
const $7fe65d6f4dd08470$export$b9bd7f7612a0db12 = (draftWorkItems)=>{
    const childWorkItems = draftWorkItems.flatMap((workItem)=>workItem.childWorkItems ?? []);
    return draftWorkItems.length + childWorkItems.length;
};
module.exports["getNumberIssuesFromDraftWorkItems"] = $7fe65d6f4dd08470$export$b9bd7f7612a0db12;

});

parcelRegister("4LtLd", function(module, exports) {
/**
 * @generated SignedSource<<b294ea10a812336ce286f8580ec3ce97>>
 * @relayHash a25057f536fd63ecf0a382a876cdbe99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cc1a0d73557a5ea29e13f91971d8aec0ba3c13bce51ebb891b0c48b47449ddd
const $6c03bbd4afd81729$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldConfiguration",
        "abstractKey": "__isJiraIssueFieldConfiguration"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useValidateIssuesToCreateQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useValidateIssuesToCreateQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v10 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5cc1a0d73557a5ea29e13f91971d8aec0ba3c13bce51ebb891b0c48b47449ddd",
            "metadata": {},
            "name": "useValidateIssuesToCreateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c03bbd4afd81729$var$node.hash = "0f046b992049633a77db8aab5cb8eb16";
var $6c03bbd4afd81729$export$2e2bcd8739ae039 = $6c03bbd4afd81729$var$node;
module.exports["default"] = $6c03bbd4afd81729$export$2e2bcd8739ae039;

});

parcelRegister("iKetF", function(module, exports) {

var $htTUm = parcelRequire("htTUm");


var $bcdSN = parcelRequire("bcdSN");

class $5260836abc91267b$export$b20e9e0f6ffd0ce0 {
    /**
   * Populates the field payload by determining whether to update the `fieldsMap` or `updateMap`
   * and processing the given value according to the specified field type information.
   */ populateFieldPayload(fieldType, fieldId, fieldValue) {
        const payloadMapping = this.getPayloadMapping(fieldType);
        const type = payloadMapping?.inputType;
        const payloadStructure = this.getPayload(fieldId, fieldValue, payloadMapping);
        if (payloadMapping?.nullable && fieldValue === null) return null;
        if (type === 'array') return this.constructArrayPayloads(fieldValue, payloadStructure);
        if (type === 'object' && this.isObject(fieldValue) || this.isValueNode(fieldValue)) return this.constructPayload(payloadStructure, fieldValue, type);
        return fieldValue;
    }
    getPayloadMapping(fieldType) {
        return (0, $bcdSN.fieldTypeToPayload)[fieldType];
    }
    getPayload(fieldId, fieldValue, payloadMapping) {
        if (fieldId === (0, $bcdSN.PARENT_FIELD_ID)) {
            const stringValue = this.asText(fieldValue);
            // to unset the parent pass empty object
            if (stringValue === '') return {};
            // otherwise it's id
            return {
                id: 'VALUE'
            };
        }
        return payloadMapping?.payload;
    }
    constructPayload(payloadStructure, rawValue, type) {
        const value = this.convertToNumberOrValue(rawValue, type);
        if (payloadStructure === null || payloadStructure === undefined) return value;
        const payloadString = JSON.stringify(payloadStructure);
        let result = payloadString;
        // Handle ADF_VALUE replacement
        if (result.includes('"ADF_VALUE"')) {
            const adfValue = (0, $htTUm.markdownPlusToAdf)({
                markdown: this.asText(value)
            });
            result = result.replace('"ADF_VALUE"', JSON.stringify(adfValue));
        }
        // Handle VALUE replacement
        if (this.isObject(value)) result = result.replace('"VALUE"', JSON.stringify(value));
        else {
            const textValue = this.asText(value);
            result = result.replace('"VALUE"', JSON.stringify(textValue));
        }
        return JSON.parse(result);
    }
    constructArrayPayloads(value, payloadStructure) {
        const items = Array.isArray(value) ? value : this.convertToArray(value);
        const result = [];
        for (const item of items)if (this.isValueNode(item)) result.push(this.constructPayload(payloadStructure, item));
        return result;
    }
    convertToNumberOrValue(value, type) {
        const textValue = this.asText(value);
        switch(type){
            case 'integer':
                {
                    const intValue = this.toIntOrNull(textValue);
                    return intValue !== null ? intValue : value;
                }
            case 'float':
                {
                    const floatValue = this.toFloatOrNull(textValue);
                    return floatValue !== null ? floatValue : value;
                }
            default:
                return value;
        }
    }
    convertToArray(value) {
        try {
            const textValue = this.asText(value);
            const parsed = JSON.parse(textValue);
            if (Array.isArray(parsed)) return parsed;
            return [
                value
            ];
        } catch  {
            return [
                value
            ];
        }
    }
    isValueNode(value) {
        // A value node is a primitive value (string, number, boolean, null)
        // but not an object or array
        return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value === null;
    }
    isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }
    asText(value) {
        if (typeof value === 'string') return value;
        if (value === null || value === undefined) return '';
        if (typeof value === 'number' || typeof value === 'boolean') return String(value);
        if (this.isObject(value) || Array.isArray(value)) return JSON.stringify(value);
        return String(value);
    }
    toIntOrNull(value) {
        const parsed = parseInt(value, 10);
        // Check if it's a valid integer and the string representation matches
        if (!Number.isNaN(parsed) && parsed.toString() === value.trim()) return parsed;
        return null;
    }
    toFloatOrNull(value) {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed) && Number.isFinite(parsed)) return parsed;
        return null;
    }
}
module.exports["FieldProcessor"] = $5260836abc91267b$export$b20e9e0f6ffd0ce0;

});

parcelRegister("aV6bG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

const $bbbbe43a9c4e043e$var$HoverPopover = ({ content: content, placement: placement = 'bottom', openDelayMs: openDelayMs = 200, closeDelayMs: closeDelayMs = 80, children: children })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const openTimeout = (0, $cozmU.useRef)(null);
    const closeTimeout = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (openTimeout.current) window.clearTimeout(openTimeout.current);
            if (closeTimeout.current) window.clearTimeout(closeTimeout.current);
        };
    }, []);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (closeTimeout.current) {
            window.clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
        }
        openTimeout.current = window.setTimeout(()=>setIsOpen(true), openDelayMs);
    }, [
        openDelayMs
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (openTimeout.current) {
            window.clearTimeout(openTimeout.current);
            openTimeout.current = null;
        }
        closeTimeout.current = window.setTimeout(()=>setIsOpen(false), closeDelayMs);
    }, [
        closeDelayMs
    ]);
    const onKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            setIsOpen((prev)=>!prev);
            return;
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: placement,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }, content),
        trigger: (triggerProps)=>children({
                onKeyDown: onKeyDown,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ...triggerProps
            }),
        shouldUseCaptureOnOutsideClick: true,
        shouldRenderToParent: true,
        shouldReturnFocus: true
    });
};
var $bbbbe43a9c4e043e$export$2e2bcd8739ae039 = $bbbbe43a9c4e043e$var$HoverPopover;
module.exports["default"] = $bbbbe43a9c4e043e$export$2e2bcd8739ae039;

});

parcelRegister("4YmBn", function(module, exports) {
const $39ee4c49136aaea7$export$881d135f98d8d7d0 = 100;
const $39ee4c49136aaea7$export$9ab5bdcb8a1d6c34 = false;
const $39ee4c49136aaea7$export$12c1dc38ea1692da = 0;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $39ee4c49136aaea7$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $39ee4c49136aaea7$export$9ab5bdcb8a1d6c34;
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $39ee4c49136aaea7$export$12c1dc38ea1692da;

});

parcelRegister("axyhv", function(module, exports) {
/**
 * @generated SignedSource<<c1aed9b79ded38ee5e960c75d3d6da43>>
 * @relayHash 4dccfb345a03f362a171efbed26fae84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 20b50ca19300dd1b5ee2d33125429c8a18c63be647c9815bf5ddc55cc46e3077
const $39f3effb41113afe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "concreteType": "JiraRichText",
        "kind": "LinkedField",
        "name": "richText",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "json"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgenticPlanToolMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRichTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRichTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRichTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgenticPlanToolMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRichTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRichTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRichTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "20b50ca19300dd1b5ee2d33125429c8a18c63be647c9815bf5ddc55cc46e3077",
            "metadata": {},
            "name": "AgenticPlanToolMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$39f3effb41113afe$var$node.hash = "7bc30f89696d9f7e23b706360d93af32";
var $39f3effb41113afe$export$2e2bcd8739ae039 = $39f3effb41113afe$var$node;
module.exports["default"] = $39f3effb41113afe$export$2e2bcd8739ae039;

});

parcelRegister("cQ93H", function(module, exports) {
/**
 * @generated SignedSource<<1bee3edb7f4a8a2f930cb7bf92a0a253>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bbf420a31fc3f464$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AgenticPlanTool",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "JiraRichTextField",
            "kind": "LinkedField",
            "name": "descriptionField",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "adfValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$bbf420a31fc3f464$var$node.hash = "932025c076221e1472b5ea5f24b73002";
var $bbf420a31fc3f464$export$2e2bcd8739ae039 = $bbf420a31fc3f464$var$node;
module.exports["default"] = $bbf420a31fc3f464$export$2e2bcd8739ae039;

});

parcelRegister("lqNTR", function(module, exports) {
/* AgenticPlanEditor.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6RwwD = parcelRequire("6RwwD");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $iH6fo = parcelRequire("iH6fo");


var $dVPAB = parcelRequire("dVPAB");

// its internal toolbar/content padding with ReactRenderer. Keep these overrides scoped and minimal
// so edit mode can add the toolbar without horizontally shifting the plan text.
const $1352ae97b0a93a25$var$editorWrapperStyles = null;
function $1352ae97b0a93a25$var$AgenticPlanComposableEditor({ defaultValue: defaultValue, onEditorReady: onEditorReady }) {
    const editorProps = (0, $cozmU.useMemo)(()=>({
            appearance: 'comment',
            allowUndoRedoButtons: true,
            allowRule: true,
            allowTables: {
                advanced: true
            },
            defaultValue: defaultValue,
            minHeight: 0,
            smartLinks: {
                allowBlockCards: true,
                allowEmbeds: false,
                provider: Promise.resolve((0, $6RwwD.editorCardProvider))
            },
            textFormatting: {
                responsiveToolbarMenu: true
            }
        }), [
        defaultValue
    ]); /*  wires up all the standard editor plugins based on the editorProps */ 
    const universalPreset = (0, $iH6fo.default)({
        props: editorProps
    });
    const { preset: preset } = (0, $dVPAB.usePreset)(()=>universalPreset, [
        universalPreset
    ]);
    const handleEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        onEditorReady(editorActions);
    }, [
        onEditorReady
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1nw8nfdnbC _2y1Mt8dnbC _0nklAydnbC _0kcJEGdnbC _3QgMz9jOvk _22vWNpdnbC _3pOrvCdnbC _4Ea4ZWdnbC _1Ikv5mdnbC _0sa5HhdnbC _28tgLMjOvk _4w5zWbdnbC _4BgBFwdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        ...editorProps,
        onEditorReady: handleEditorReady,
        preset: preset,
        shouldFocus: true
    }));
}
function $1352ae97b0a93a25$export$1d2b469929b1e0dc(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1352ae97b0a93a25$var$AgenticPlanComposableEditor, props));
}
module.exports["AgenticPlanEditor"] = $1352ae97b0a93a25$export$1d2b469929b1e0dc;

});

parcelRegister("9xrOI", function(module, exports) {

var $4fqm1 = parcelRequire("4fqm1");

// Buckets use Levenshtein edits as a percentage of the larger plan:
// none = 0 changes, minimal = about <= 2 changes per 100 chars,
// moderate = about <= 15 changes per 100 chars, substantial = more than that.
const $b6c149850942c07d$var$MINIMAL_EDIT_RATIO = 0.02;
const $b6c149850942c07d$var$MODERATE_EDIT_RATIO = 0.15;
const $b6c149850942c07d$var$normalizePlan = (plan)=>plan.replace(/\r\n?/g, '\n').trim().replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n');
const $b6c149850942c07d$export$a6f273bf50f5292a = (originalPlan, submittedPlan)=>{
    const normalizedOriginal = $b6c149850942c07d$var$normalizePlan(originalPlan);
    const normalizedSubmitted = $b6c149850942c07d$var$normalizePlan(submittedPlan);
    if (normalizedOriginal === normalizedSubmitted) return 'none';
    const editRatio = (0, $4fqm1.distance)(normalizedOriginal, normalizedSubmitted) / Math.max(normalizedOriginal.length, normalizedSubmitted.length);
    if (editRatio <= $b6c149850942c07d$var$MINIMAL_EDIT_RATIO) return 'minimal';
    if (editRatio <= $b6c149850942c07d$var$MODERATE_EDIT_RATIO) return 'moderate';
    return 'substantial';
};
module.exports["getPlanEditLevel"] = $b6c149850942c07d$export$a6f273bf50f5292a;

});

parcelRegister("jTIEM", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $2be6be95b7ce01f5$export$e7b61a06f3466358 = new (0, $34VCg.UFOExperience)('agentic-planning-update-description', {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
});
module.exports["updateDescriptionUfoExperience"] = $2be6be95b7ce01f5$export$e7b61a06f3466358;

});

parcelRegister("gPDwp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1C0CS = parcelRequire("1C0CS");

function $2c67659c9549c7f5$export$24a57d0c8d0d54dc(conversationId, invocationIds) {
    const [perStep, actions] = (0, $1C0CS.useActionStepApplyEntriesHook)({
        conversationId: conversationId,
        invocationIds: invocationIds
    });
    const runApply = (0, $cozmU.useMemo)(()=>async (ids, fn)=>{
            for (const id of ids)actions.setInProgress(conversationId, id, true);
            try {
                await fn();
                for (const id of ids)actions.setError(conversationId, id, undefined);
            } catch (e) {
                const error = e instanceof Error ? e : new Error(String(e));
                for (const id of ids)actions.setError(conversationId, id, error);
            } finally{
                for (const id of ids)actions.setInProgress(conversationId, id, false);
            }
        }, [
        actions,
        conversationId
    ]);
    return {
        perStep: perStep,
        runApply: runApply
    };
}
module.exports["useActionPlanApplyState"] = $2c67659c9549c7f5$export$24a57d0c8d0d54dc;

});

parcelRegister("45b0j", function(module, exports) {
/* ActionCardFooter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $eh6Ml = parcelRequire("eh6Ml");


var $5avUB = parcelRequire("5avUB");


var $22YX5 = parcelRequire("22YX5");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $kGLnC = parcelRequire("kGLnC");

const $b0294a04f253f984$var$planDismissedMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.planDismissed.non-final",
    defaultMessage: "You've dismissed this plan"
});
const $b0294a04f253f984$var$dismissMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.dismiss",
    defaultMessage: "Cancel"
});
const $b0294a04f253f984$var$openPlanMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.openPlan",
    defaultMessage: "View details"
});
const $b0294a04f253f984$var$acceptPlanMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.acceptPlan",
    defaultMessage: "Apply changes"
});
const $b0294a04f253f984$var$completedMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.completed.non-final",
    defaultMessage: "Completed"
});
const $b0294a04f253f984$var$failedMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.failed.non-final",
    defaultMessage: "Couldn't apply"
});
const $b0294a04f253f984$var$retryMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardFooter.retry.non-final",
    defaultMessage: "Retry"
});
const $b0294a04f253f984$var$styles = {
    actionCardFooter: "_3zygPU9r67 _2IVJ4M6wH8 _22sfPnNvrM _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    actionCardFooterOuterMargin: "_3138428HPE _1DCdHiB0rP"
};
const $b0294a04f253f984$export$60124cef578bfa4 = ({ children: children, testId: testId, isCanvasOpen: isCanvasOpen = false, isCanvasLoading: isCanvasLoading = false, renderMode: renderMode, onAcceptPlan: onAcceptPlan, onDismissPlan: onDismissPlan, onReviewPlan: onReviewPlan })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (isCanvasOpen && !isCanvasLoading) return null;
     // A dismissed plan replaces all footer actions with the dismissed pill, while the plan details
    // above remain visible so the user can still see what was discarded.
    if (renderMode === 'CANCELLED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22YX5.Bleed), {
        inline: "space.150",
        xcss: $b0294a04f253f984$var$styles.actionCardFooterOuterMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b0294a04f253f984$var$styles.actionCardFooter,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kGLnC.SystemMessage), {
        message: formatMessage($b0294a04f253f984$var$planDismissedMessage),
        isSuccessMessage: false
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22YX5.Bleed), {
        inline: "space.150",
        xcss: $b0294a04f253f984$var$styles.actionCardFooterOuterMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b0294a04f253f984$var$styles.actionCardFooter,
        testId: testId
    }, renderMode === 'IN_PROGRESS' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "load"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onDismissPlan,
        isDisabled: isCanvasLoading
    }, formatMessage($b0294a04f253f984$var$dismissMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onReviewPlan,
        isLoading: isCanvasLoading
    }, formatMessage($b0294a04f253f984$var$openPlanMessage)), renderMode === 'ERROR' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.danger"
    }, formatMessage($b0294a04f253f984$var$failedMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onAcceptPlan
    }, formatMessage($b0294a04f253f984$var$retryMessage))), renderMode === 'COMPLETE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
        isDisabled: true
    }, formatMessage($b0294a04f253f984$var$completedMessage)), renderMode === 'IDLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onAcceptPlan,
        isDisabled: isCanvasLoading
    }, formatMessage($b0294a04f253f984$var$acceptPlanMessage)))), children));
};
module.exports["ActionCardFooter"] = $b0294a04f253f984$export$60124cef578bfa4;

});

parcelRegister("j1ipA", function(module, exports) {
/* ActionCardWrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $GErjr = parcelRequire("GErjr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $1e0834b67ba36071$var$collapseMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardWrapper.collapse",
    defaultMessage: "Collapse"
});
const $1e0834b67ba36071$var$numberLabelMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardWrapper.numberLabel.non-final",
    defaultMessage: "{index}."
});
const $1e0834b67ba36071$var$expandMessage = (0, $kSwu1.defineMessage)({
    id: "ai-mate-jira-admin-agent.jira-admin-agent.action-cards.ActionCardWrapper.expand",
    defaultMessage: "Expand"
});
const $1e0834b67ba36071$var$styles = {
    actionCardWrapper: "_3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM",
    actionCardHeader: "_0Of8r28HPE _1Znuxb8HPE _2Zuz6Q8HPE",
    actionCardHeaderPaddingBottom: "_1wydGW8HPE",
    topRadius: "_2C2kUQyzSk _1Lz9loyzSk",
    bottomRadius: "_1v9SsVyzSk _3XDz3ByzSk",
    noBorderTopOrBottom: "_2IVJ4MYbGa _3BoeIDYbGa",
    radiusFull: "_2C2kUQyzSk _1Lz9loyzSk _1v9SsVyzSk _3XDz3ByzSk",
    borderTop: "_3zygPU9r67 _2IVJ4M6wH8 _22sfPnNvrM",
    actionCardContentWrapper: "_0Of8r28HPE _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO",
    titleBold: "_2sNsIg1kXk"
};
const $1e0834b67ba36071$export$2061af696e09df60 = ({ title: title, subtitle: subtitle, children: children, isSubPlan: isSubPlan = false, defaultExpanded: defaultExpanded = false, borderOverride: borderOverride, index: index, isExpandable: isExpandable })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1e0834b67ba36071$var$styles.actionCardWrapper, (!isSubPlan || borderOverride === 'both') && $1e0834b67ba36071$var$styles.radiusFull, isSubPlan && borderOverride === 'top' && $1e0834b67ba36071$var$styles.topRadius, isSubPlan && borderOverride === 'bottom' && $1e0834b67ba36071$var$styles.bottomRadius, isSubPlan && !borderOverride && $1e0834b67ba36071$var$styles.noBorderTopOrBottom),
        testId: "action-card-wrapper"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1e0834b67ba36071$var$styles.actionCardHeader, (isSubPlan || !isExpanded) && $1e0834b67ba36071$var$styles.actionCardHeaderPaddingBottom)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, !isSubPlan && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
        label: "Plan"
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, index !== undefined ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $1e0834b67ba36071$var$styles.titleBold
    }, formatMessage($1e0834b67ba36071$var$numberLabelMessage, {
        index: index
    })) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $1e0834b67ba36071$var$styles.titleBold
    }, title)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, subtitle))), isExpandable && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: isExpanded ? formatMessage($1e0834b67ba36071$var$collapseMessage) : formatMessage($1e0834b67ba36071$var$expandMessage),
        onClick: ()=>setIsExpanded(!isExpanded)
    })))), isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1e0834b67ba36071$var$styles.actionCardContentWrapper, isSubPlan && $1e0834b67ba36071$var$styles.borderTop)
    }, children));
};
module.exports["ActionCardWrapper"] = $1e0834b67ba36071$export$2061af696e09df60;

});

parcelRegister("15gbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");


var $2swKg = parcelRequire("2swKg");


var $19FYy = parcelRequire("19FYy");


var $j1ipA = parcelRequire("j1ipA");

const $779a471cee156727$var$getBorderOverride = (isFirst, isLast)=>{
    if (isFirst && isLast) return 'both';
    if (isFirst) return 'top';
    if (isLast) return 'bottom';
    return undefined;
};
const $779a471cee156727$export$22a6e715852238cd = ({ plan: plan, isFirst: isFirst, isLast: isLast, number: number })=>{
    const { title: title, subtext: subtext } = plan.payload;
    const borderOverride = $779a471cee156727$var$getBorderOverride(isFirst, isLast);
    const hasEntities = plan.payload.entities?.fields !== undefined && plan.payload.entities.fields.length > 0 || plan.payload.entities?.spaces !== undefined && plan.payload.entities.spaces.length > 0 || plan.payload.entities?.workTypes !== undefined && plan.payload.entities.workTypes.length > 0;
    const hasIntentBody = plan.steps.length === 1 || plan.steps.length > 0 && plan.steps.every((step)=>step.actionSubject === 'field-options');
    const isExpandable = hasIntentBody || hasEntities;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1ipA.ActionCardWrapper), {
        title: title,
        subtitle: subtext,
        index: number,
        borderOverride: borderOverride,
        isExpandable: isExpandable,
        isSubPlan: true
    }, isExpandable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, hasEntities && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2swKg.Entities), {
        entities: plan.payload.entities
    }), hasIntentBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $19FYy.IntentBody), {
        steps: plan.steps
    })));
};
module.exports["SubPlan"] = $779a471cee156727$export$22a6e715852238cd;

});

parcelRegister("cbHKo", function(module, exports) {
module.exports = new URL("preview-card-kb-article-header.5bc0fa5c.svg", import.meta.url).toString();

});

parcelRegister("9Bnz7", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $b2bf1be4b4527a59$var$EMPTY_ARTICLE_ADF = {
    type: 'doc',
    version: 1,
    content: []
};
const $b2bf1be4b4527a59$var$isAdfDocNode = (value)=>typeof value === 'object' && value !== null && 'type' in value && value.type === 'doc';
const $b2bf1be4b4527a59$var$createParagraphDocument = (text)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: text
                    }
                ]
            }
        ]
    });
const $b2bf1be4b4527a59$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $b2bf1be4b4527a59$var$getCreateArticlePath = ({ projectId: projectId, activationId: activationId, spaceKey: spaceKey })=>`${$b2bf1be4b4527a59$var$JSD_APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/spaceKey/${encodeURIComponent(spaceKey)}/article`;
const $b2bf1be4b4527a59$var$getArticleAdfValue = (article)=>{
    const rawContent = article.body;
    if (!rawContent) return JSON.stringify($b2bf1be4b4527a59$var$EMPTY_ARTICLE_ADF);
    // If upstream already provided parsed ADF, preserve it as-is.
    if ($b2bf1be4b4527a59$var$isAdfDocNode(rawContent)) return JSON.stringify(rawContent);
    if (typeof rawContent !== 'string') return JSON.stringify($b2bf1be4b4527a59$var$EMPTY_ARTICLE_ADF);
    try {
        const parsedContent = JSON.parse(rawContent);
        if ($b2bf1be4b4527a59$var$isAdfDocNode(parsedContent)) return JSON.stringify(parsedContent);
        return JSON.stringify($b2bf1be4b4527a59$var$createParagraphDocument(rawContent));
    } catch  {
        return JSON.stringify($b2bf1be4b4527a59$var$createParagraphDocument(rawContent));
    }
};
const $b2bf1be4b4527a59$export$e96b22f30191ee52 = async ({ projectId: projectId, activationId: activationId, spaceKey: spaceKey, article: article, status: status })=>{
    await (0, $jTKfH.performHttpFetch)({
        path: $b2bf1be4b4527a59$var$getCreateArticlePath({
            projectId: projectId,
            activationId: activationId,
            spaceKey: spaceKey
        }),
        options: {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'page',
                title: article.title,
                status: status,
                body: $b2bf1be4b4527a59$var$getArticleAdfValue(article),
                isAiGenerated: true
            })
        }
    });
};
module.exports["publishConfluenceArticle"] = $b2bf1be4b4527a59$export$e96b22f30191ee52;

});

parcelRegister("4qcxA", function(module, exports) {
/**
 * @generated SignedSource<<2ba1fe58960884b501da3bab54e5b369>>
 * @relayHash e4f905af06ac0f2931b3d1537d1fc617
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82be96e5ec49e837f88198eea7549d67dc78391ab549d2a233b0d294ec155469
const $7dc39e0bb8ecde18$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdentifier"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdentifier",
                    "variableName": "projectIdentifier"
                }
            ],
            "kind": "LinkedField",
            "name": "knowledgeBase_confluenceAppLinkDetails",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appLinkId"
                        }
                    ],
                    "type": "KnowledgeBaseConfluenceAppLinkDetails"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateKbServerAppLinkIdQueryJsmCardQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateKbServerAppLinkIdQueryJsmCardQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "82be96e5ec49e837f88198eea7549d67dc78391ab549d2a233b0d294ec155469",
            "metadata": {},
            "name": "useCreateKbServerAppLinkIdQueryJsmCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7dc39e0bb8ecde18$var$node.hash = "46a8de515facf5e24f77ae76bdac4c07";
var $7dc39e0bb8ecde18$export$2e2bcd8739ae039 = $7dc39e0bb8ecde18$var$node;
module.exports["default"] = $7dc39e0bb8ecde18$export$2e2bcd8739ae039;

});

parcelRegister("jFEee", function(module, exports) {
/**
 * @generated SignedSource<<c4703147c75004d0c5b73959a2b8e86f>>
 * @relayHash 9a6b1b768dc0ce655365a9c20d064f90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e03eccd6f048973d35ac76ef4e52008c2226f066402af5d4277b0720789bd144
const $8357f2c0110fcc2b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdentifier"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sources"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdentifier",
                    "variableName": "projectIdentifier"
                },
                {
                    "kind": "Variable",
                    "name": "sources",
                    "variableName": "sources"
                }
            ],
            "concreteType": "KnowledgeBaseLinkSourcesResponse",
            "kind": "LinkedField",
            "name": "knowledgeBase_linkSources",
            "plural": false,
            "selections": [
                {
                    "concreteType": "KnowledgeBaseLinkSourceResult",
                    "kind": "LinkedField",
                    "name": "linkSourceResults",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateKbSourceLinkingMutationJsmCardMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateKbSourceLinkingMutationJsmCardMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "e03eccd6f048973d35ac76ef4e52008c2226f066402af5d4277b0720789bd144",
            "metadata": {},
            "name": "useCreateKbSourceLinkingMutationJsmCardMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8357f2c0110fcc2b$var$node.hash = "a19124cc7a50e197f97e53d7aaec84fd";
var $8357f2c0110fcc2b$export$2e2bcd8739ae039 = $8357f2c0110fcc2b$var$node;
module.exports["default"] = $8357f2c0110fcc2b$export$2e2bcd8739ae039;

});

parcelRegister("l9aOd", function(module, exports) {
// src/jira/sprint/types.ts
var $f652d2b061495377$export$7cac38a1fdf1a8f6 = "jira", $f652d2b061495377$export$d4fabededca793c1 = "sprint";
module.exports["JiraSprintAriResourceOwner"] = $f652d2b061495377$export$7cac38a1fdf1a8f6;
module.exports["JiraSprintAriResourceType"] = $f652d2b061495377$export$d4fabededca793c1;

});

parcelRegister("9NjIz", function(module, exports) {
/**
 * @generated SignedSource<<f6df72d73b7e95b7e48ea46ada64a43c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cb3ff0e6f3ae086e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldIdsOrAliases"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sprintAris"
        }
    ],
    "kind": "Fragment",
    "name": "actionCard_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardHeader_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "fieldIdsOrAliases",
                    "variableName": "fieldIdsOrAliases"
                },
                {
                    "kind": "Variable",
                    "name": "sprintAris",
                    "variableName": "sprintAris"
                }
            ],
            "kind": "FragmentSpread",
            "name": "cardFieldsList_updateWorkItemAllFieldTypesActionRenderer"
        }
    ],
    "type": "JiraIssue"
};
$cb3ff0e6f3ae086e$var$node.hash = "98ae4d49e9b05c3494c1be19e282f771";
var $cb3ff0e6f3ae086e$export$2e2bcd8739ae039 = $cb3ff0e6f3ae086e$var$node;
module.exports["default"] = $cb3ff0e6f3ae086e$export$2e2bcd8739ae039;

});

parcelRegister("lzRnO", function(module, exports) {

var $19egK = parcelRequire("19egK");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $1sCHt = parcelRequire("1sCHt");


var $cXtTj = parcelRequire("cXtTj");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $buzLI = parcelRequire("buzLI");


var $bCxtA = parcelRequire("bCxtA");


var $gwApo = parcelRequire("gwApo");


var $4yZQ6 = parcelRequire("4yZQ6");


var $dJqjR = parcelRequire("dJqjR");


var $2n1QA = parcelRequire("2n1QA");


var $gQkLW = parcelRequire("gQkLW");


var $7CPOj = parcelRequire("7CPOj");


var $jbxLJ = parcelRequire("jbxLJ");


var $7YLz1 = parcelRequire("7YLz1");


var $cdCKN = parcelRequire("cdCKN");


var $01x8r = parcelRequire("01x8r");


var $fMOw7 = parcelRequire("fMOw7");


var $cQmAj = parcelRequire("cQmAj");


var $bnvIx = parcelRequire("bnvIx");


var $3nlSH = parcelRequire("3nlSH");


var $63Ksk = parcelRequire("63Ksk");


var $9mlvG = parcelRequire("9mlvG");


var $77wfz = parcelRequire("77wfz");


var $6PEgK = parcelRequire("6PEgK");


var $ikVMQ = parcelRequire("ikVMQ");


var $g6X6z = parcelRequire("g6X6z");


var $6XxOd = parcelRequire("6XxOd");


var $iclxx = parcelRequire("iclxx");


var $kgviF = parcelRequire("kgviF");


var $i35Xi = parcelRequire("i35Xi");


var $1wqLa = parcelRequire("1wqLa");


var $2BDch = parcelRequire("2BDch");


var $5gGrJ = parcelRequire("5gGrJ");


var $ihct3 = parcelRequire("ihct3");


var $7cQjr = parcelRequire("7cQjr");


var $8q654 = parcelRequire("8q654");


var $6rrht = parcelRequire("6rrht");


var $iRNLz = parcelRequire("iRNLz");


var $lNkFf = parcelRequire("lNkFf");


var $2KmEz = parcelRequire("2KmEz");


var $bkiNa = parcelRequire("bkiNa");


var $UqbzZ = parcelRequire("UqbzZ");


var $csBJX = parcelRequire("csBJX");


var $h9KZF = parcelRequire("h9KZF");


var $18id6 = parcelRequire("18id6");


var $kR99p = parcelRequire("kR99p");


var $8JEzu = parcelRequire("8JEzu");


var $9meBx = parcelRequire("9meBx");


var $dHxi0 = parcelRequire("dHxi0");


var $fVBxJ = parcelRequire("fVBxJ");

const $470f1f76c629bcdf$var$styles = {
    root: "_23rrnH2HTN _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuchRC _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r21Y8M _1wydGW1Y8M _0wOv4Q18ZR _2xIroYnXvL _1eOmH6d1Zr",
    statusIconContainer: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT _0adFHs1Y8M",
    fieldsContainer: "_2mHwu81Y8M _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _2fwxA5ecOK",
    actionButtonsHidden: "_1YKVNsdnbC"
};
const $470f1f76c629bcdf$export$c522d2a712641b49 = ({ queryRef: queryRef, cloudId: cloudId, action: action, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, getReadonly: getReadonly, isBulkActioning: isBulkActioning = false, showActionButtons: showActionButtons = true, onInvalidAction: onInvalidAction, tooltipPosition: tooltipPosition = 'left' })=>{
    (0, $6cFsl.di)((0, $ihct3.SingleLineTextField), (0, $2BDch.RichTextField), (0, $8q654.SingleSelectUserPickerField), (0, $dHxi0.UsersField), (0, $2KmEz.StatusField), (0, $fMOw7.FlagField), (0, $77wfz.LabelsField), (0, $kgviF.PriorityField), (0, $jbxLJ.DatePickerField), (0, $cdCKN.DateTimePickerField), (0, $6XxOd.ParentIssueField), (0, $gQkLW.CommentField), (0, $bnvIx.GenericField), (0, $ikVMQ.NumberField), (0, $dJqjR.ColorField), (0, $gwApo.useFieldTooltip), (0, $csBJX.TeamViewField), (0, $63Ksk.IssueLinksField));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { fieldKey: fieldKey, fieldReasoning: fieldReasoning, sourceUrl: sourceUrl } = (0, $4yZQ6.getActionData)(action);
    const { tooltipContent: tooltipContent, registerTooltipProvider: registerTooltipProvider, rootHoverHandlers: rootHoverHandlers, focusHandlers: focusHandlers, isHovered: isHovered, isFocused: isFocused } = (0, $gwApo.useFieldTooltip)(fieldKey); // Persist last tooltip ReactNode so moving cursor to tooltip overlay doesn't lose field-specific content.
    const [persistedTooltipContent, setPersistedTooltipContent] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (tooltipContent != null) setPersistedTooltipContent(tooltipContent);
    }, [
        tooltipContent,
        fieldKey
    ]);
    const status = getStatus(action);
    const readonly = getReadonly(action);
    const isSubmitting = status === 'started' || action?.status === 'started';
    const isFailed = status === 'errored' || action?.status === 'errored';
    const isDisabled = status !== 'idle' || readonly;
    const isCompleted = status === 'finished' || action?.status === 'finished';
    const isCancelled = status === 'cancelled' || action?.status === 'cancelled';
    const isIdle = status === 'idle' && action?.status === 'planned'; // When an action is completed, we want to hide the icons and buttons when a user unhovers or focuses away from the action (aside from the success
    // icon, which is always visible after the action has been accepted). However, `isFocused` remains true even if we unfocus on the action after
    // it has been accepted or cancelled. Temporary fix for TEAM25EU until we find a proper fix to the focus issue.
    const isActionCompleted = isCompleted || isCancelled || isFailed;
    const issue = (0, $6SsN4.useFragment)((0, $19egK.default), queryRef); // This allows for custom fields types to be tracked in the analytics event.
    const fieldType = issue?.fieldsByIdOrAlias?.filter((field)=>field?.fieldId === fieldKey)?.[0]?.type ?? fieldKey;
    const analyticsAttributes = {
        fieldType: fieldType,
        hasReasoning: !!fieldReasoning,
        hasSourceUrl: !!sourceUrl,
        ...(0, $iDrrr.fg)('add-source-in-update-workitem-analytics') ? {
            sourceUrlType: (0, $buzLI.classifySourceUrl)(sourceUrl)
        } : {}
    };
    (0, $cozmU.useEffect)(()=>{
        if (isIdle) sendAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'suggestion',
            actionSubjectId: 'updateWorkField',
            attributes: {
                ...analyticsAttributes
            }
        });
         // Empty dependency array to ensure that we only fire the analytics event once when the suggestion renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fields = issue?.fieldsByIdOrAlias;
    const hasFields = Array.isArray(fields) && fields.length > 0;
    const filteredFields = (0, $cozmU.useMemo)(()=>hasFields ? fields.filter((field)=>Boolean(field)).filter((field)=>field?.fieldId === fieldKey || // Edge case with the custom time spent field - we still want to use timetracking to fetch its data.
            field?.fieldId === 'timetracking' && fieldKey === 'timespent') : [], [
        hasFields,
        fields,
        fieldKey
    ]);
    const onInvalidActionCallback = (0, $cozmU.useCallback)(()=>onInvalidAction?.(action), [
        onInvalidAction,
        action
    ]);
    const fieldsRegistry = (0, $cozmU.useMemo)(()=>{
        const registry = filteredFields.map((field)=>{
            switch(field?.__typename){
                case 'JiraSingleLineTextField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cQjr.SingleLineTextFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihct3.SingleLineTextField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraRichTextField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gGrJ.RichTextFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2BDch.RichTextField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraSingleSelectUserPickerField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6rrht.SingleSelectUserPickerFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8q654.SingleSelectUserPickerField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            onInvalidAction: onInvalidActionCallback
                        })
                    };
                case 'JiraMultipleSelectUserPickerField':
                case 'JiraPeopleField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fVBxJ.UsersFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHxi0.UsersField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider,
                            onInvalidAction: onInvalidActionCallback
                        })
                    };
                case 'JiraStatusField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bkiNa.StatusFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2KmEz.StatusField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            onInvalidAction: onInvalidActionCallback
                        })
                    };
                case 'JiraPriorityField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i35Xi.PriorityFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kgviF.PriorityField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            ...(0, $cXtTj.default).getExperimentValue('jira-ai-update-workitem-field-action-details-exp', 'isEnabled', false) ? {
                                registerTooltipProvider: registerTooltipProvider
                            } : {}
                        })
                    };
                case 'JiraLabelsField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6PEgK.LabelsFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77wfz.LabelsField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraFlagField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cQmAj.FlagFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fMOw7.FlagField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraDatePickerField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7YLz1.DatePickerFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jbxLJ.DatePickerField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraDateTimePickerField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01x8r.DateTimePickerFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdCKN.DateTimePickerField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraParentIssueField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iclxx.ParentIssueFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6XxOd.ParentIssueField), {
                            key: field.id,
                            cloudId: cloudId,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider,
                            onInvalidAction: onInvalidActionCallback
                        })
                    };
                case 'JiraNumberField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g6X6z.NumberFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ikVMQ.NumberField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraColorField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2n1QA.ColorFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dJqjR.ColorField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraTimeTrackingField':
                    if (fieldKey === 'timespent') return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kR99p.TimeSpentFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18id6.TimeSpentField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9meBx.TimeTrackingFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8JEzu.TimeTrackingField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraTeamViewField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h9KZF.TeamViewFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $csBJX.TeamViewField), {
                            cloudId: cloudId,
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider,
                            onInvalidAction: onInvalidActionCallback
                        })
                    };
                case 'JiraSprintField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNkFf.SprintFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iRNLz.SprintField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                default:
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3nlSH.GenericFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bnvIx.GenericField), {
                            key: field?.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
            }
        }).filter(Boolean);
        // Filter out null or undefined components
        // Ensure CommentField is added if action.data.fieldKey is 'comment'
        if (fieldKey === 'comment') {
            const key = `${action.data.updates[0]?.issueIdOrKey}-${fieldKey}-${action.invocationId}`;
            registry.push({
                key: key,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7CPOj.CommentFieldIcon), null),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gQkLW.CommentField), {
                    key: key,
                    action: action,
                    registerTooltipProvider: registerTooltipProvider
                })
            });
        } // Ensure IssueLinksField is added if action.data.fieldKey is 'issuelinks' as it is not a traditional list field.
        if (fieldKey === 'issuelinks') {
            const key = `${action.data.updates[0]?.issueIdOrKey}-${fieldKey}-${action.invocationId}`;
            registry.push({
                key: key,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9mlvG.IssueLinksFieldIcon), null),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63Ksk.IssueLinksField), {
                    key: key,
                    action: action,
                    registerTooltipProvider: registerTooltipProvider,
                    issueKey: issue?.key
                })
            });
        }
        return registry;
    }, [
        action,
        cloudId,
        filteredFields,
        registerTooltipProvider,
        fieldKey,
        onInvalidActionCallback,
        issue?.key
    ]);
    if (!action || fieldsRegistry.length === 0 && fieldKey !== 'comment') return null;
    if (isCancelled) return null;
    const effectiveTooltipContent = tooltipContent ?? persistedTooltipContent ?? (fieldReasoning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
        reasoning: fieldReasoning
    }) : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldsRegistry.map(({ key: key, icon: icon, component: component })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: `tooltip-${key}`,
            component: (0, $1wqLa.ReasoningTooltip),
            content: effectiveTooltipContent,
            position: tooltipPosition,
            delay: 0,
            canAppear: ()=>effectiveTooltipContent !== undefined
        }, ({ ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ...tooltipProps,
                ...rootHoverHandlers,
                xcss: $470f1f76c629bcdf$var$styles.root,
                tabIndex: 0,
                onFocus: (e)=>{
                    tooltipProps.onFocus?.(e);
                    focusHandlers.onFocus?.();
                },
                onBlur: (e)=>{
                    tooltipProps.onBlur?.(e);
                    focusHandlers.onBlur?.();
                },
                // a user could click on this Box (to no effect), and the status icons + action buttons would still be
                // shown when they hover away.
                onMouseDown: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $470f1f76c629bcdf$var$styles.statusIconContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $UqbzZ.StatusIcon), {
                showIcon: isActionCompleted ? isHovered : isHovered || isFocused,
                icon: icon,
                isCompleted: isCompleted,
                isLoading: isSubmitting,
                isFailed: isFailed,
                isBulkActioning: isBulkActioning
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $470f1f76c629bcdf$var$styles.fieldsContainer
            }, component), showActionButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.action-buttons",
                xcss: !(isActionCompleted ? isHovered : isHovered || isFocused) && $470f1f76c629bcdf$var$styles.actionButtonsHidden,
                space: "space.050",
                ...focusHandlers
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
                label: "Accept",
                spacing: "compact",
                appearance: "subtle",
                onClick: ()=>{
                    onConfirm(action);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'updateWorkAccept',
                        attributes: {
                            ...analyticsAttributes,
                            bulkActioned: false
                        }
                    });
                },
                isDisabled: isDisabled || isSubmitting || isBulkActioning
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: "Dismiss",
                spacing: "compact",
                appearance: "subtle",
                onClick: ()=>{
                    onCancel(action);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'updateWorkDismiss',
                        attributes: {
                            ...analyticsAttributes,
                            bulkActioned: false
                        }
                    });
                },
                isDisabled: isDisabled || isSubmitting || isBulkActioning
            }))))));
};
module.exports["CardFieldsList"] = $470f1f76c629bcdf$export$c522d2a712641b49;

});

parcelRegister("2XbWi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $6sL6W = parcelRequire("6sL6W");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $1sCHt = parcelRequire("1sCHt");

var $7WEaj = parcelRequire("7WEaj");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $V3JOP = parcelRequire("V3JOP");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

const $f1127282d3d31a9b$var$messages = (0, $kSwu1.defineMessages)({
    openInANewTab: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.openInANewTab",
        defaultMessage: "Open in a new tab"
    },
    expandSuggestions: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.expandSuggestions",
        defaultMessage: "Expand suggestions"
    },
    collapseSuggestions: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.collapseSuggestions",
        defaultMessage: "Collapse suggestions"
    }
});
const $f1127282d3d31a9b$export$60fc2903fffebabf = 'update-work-item-all-fields-action-renderer.ui.action-card.card-header.icon-buttons-container';
const $f1127282d3d31a9b$var$styles = {
    root: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _2LUO0CnQyn _0KiJDVnQyn _0lOvzGdnbC _0xjB70dnbC _0IUiaFYvD1 _3TSXWsYvD1 _3J3L54YvD1 _2sHFlXYvD1 _26VoxrIZbP _07LFmFIZbP _0YgHAG7dHp _3so6Jo7dHp",
    avatar: "_3138421Y8M _0adFHs1Y8M _1DCdHi1Y8M _2XsHFM1Y8M _4ouGXIE6Kk",
    workItemKeyContainer: "_4ouGXIE6Kk",
    pressable: "_0bjKvDKxmn _3iDTPbQ4SZ _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _2fwxA5ecOK _2O5Vij7dHp"
};
const $f1127282d3d31a9b$export$5665775b26e26c5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { queryRef: queryRef, isExpanded: isExpanded, onClick: onClick } = t0;
    (0, $6cFsl.di)((0, $lpNn5.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const issue = (0, $6SsN4.useFragment)((0, $6sL6W.default), queryRef);
    if (!issue) return null;
    const issueType = issue?.issueTypeField?.issueType;
    const issueUrl = issue?.webUrl ?? "";
    const t1 = `${issue.key}: ${issue?.summaryField?.text}`;
    const t2 = issueType?.name;
    const t3 = issueType?.avatar?.small ?? undefined;
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f1127282d3d31a9b$var$styles.avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: t2,
            src: t3,
            width: 16,
            height: 16
        }));
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = issue?.key;
    let t6;
    if ($[3] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f1127282d3d31a9b$var$styles.workItemKeyContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, t5));
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const t7 = issue?.summaryField?.text;
    let t8;
    if ($[5] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "strong",
            maxLines: 1
        }, t7);
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== t4 || $[8] !== t6 || $[9] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "center"
        }, t4, t6, t8);
        $[7] = t4;
        $[8] = t6;
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== t1 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "bottom",
            content: t1
        }, t9);
        $[11] = t1;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== onClick || $[15] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $f1127282d3d31a9b$var$styles.pressable,
            onClick: onClick,
            tabIndex: -1,
            onMouseDown: $f1127282d3d31a9b$var$_temp
        }, t10);
        $[14] = onClick;
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== formatMessage) {
        t12 = formatMessage($f1127282d3d31a9b$var$messages.openInANewTab);
        $[17] = formatMessage;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== formatMessage || $[20] !== issueUrl) {
        t13 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                ...tooltipProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage($f1127282d3d31a9b$var$messages.openInANewTab),
                href: issueUrl,
                target: "_blank",
                appearance: "subtle",
                spacing: "compact",
                testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.external-link-button",
                onMouseDown: $f1127282d3d31a9b$var$_temp2
            });
        $[19] = formatMessage;
        $[20] = issueUrl;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== t12 || $[23] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: $f1127282d3d31a9b$export$60fc2903fffebabf
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "bottom",
            content: t12,
            isScreenReaderAnnouncementDisabled: true
        }, t13));
        $[22] = t12;
        $[23] = t13;
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    let t16;
    if ($[25] !== formatMessage || $[26] !== isExpanded) {
        t16 = isExpanded ? formatMessage($f1127282d3d31a9b$var$messages.collapseSuggestions) : formatMessage($f1127282d3d31a9b$var$messages.expandSuggestions);
        $[25] = formatMessage;
        $[26] = isExpanded;
        $[27] = t16;
    } else t16 = $[27];
    let t17;
    if ($[28] !== onClick || $[29] !== t15 || $[30] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: t15,
            label: t16,
            onClick: onClick,
            appearance: "subtle",
            spacing: "compact",
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.expand-collapse-button",
            isTooltipDisabled: false,
            onMouseDown: $f1127282d3d31a9b$var$_temp3
        });
        $[28] = onClick;
        $[29] = t15;
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== t14 || $[33] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "center"
        }, t14, t17);
        $[32] = t14;
        $[33] = t17;
        $[34] = t18;
    } else t18 = $[34];
    let t19;
    if ($[35] !== t11 || $[36] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            xcss: $f1127282d3d31a9b$var$styles.root,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-header"
        }, t11, t18);
        $[35] = t11;
        $[36] = t18;
        $[37] = t19;
    } else t19 = $[37];
    return t19;
} : ({ queryRef: queryRef, isExpanded: isExpanded, onClick: onClick })=>{
    (0, $6cFsl.di)((0, $lpNn5.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const issue = (0, $6SsN4.useFragment)((0, $6sL6W.default), queryRef);
    if (!issue) return null;
    const issueType = issue?.issueTypeField?.issueType;
    const issueUrl = issue?.webUrl ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between",
        xcss: $f1127282d3d31a9b$var$styles.root,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $f1127282d3d31a9b$var$styles.pressable,
        onClick: onClick,
        tabIndex: -1,
        onMouseDown: (e)=>e.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "bottom",
        content: `${issue.key}: ${issue?.summaryField?.text}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f1127282d3d31a9b$var$styles.avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: issueType?.name,
        src: issueType?.avatar?.small ?? undefined,
        width: 16,
        height: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f1127282d3d31a9b$var$styles.workItemKeyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, issue?.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong",
        maxLines: 1
    }, issue?.summaryField?.text)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: $f1127282d3d31a9b$export$60fc2903fffebabf
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "bottom",
        content: formatMessage($f1127282d3d31a9b$var$messages.openInANewTab),
        isScreenReaderAnnouncementDisabled: true
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            ...tooltipProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            label: formatMessage($f1127282d3d31a9b$var$messages.openInANewTab),
            href: issueUrl,
            target: "_blank",
            appearance: "subtle",
            spacing: "compact",
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.external-link-button",
            // if a user hovers off the header after clicking these buttons, the buttons are not visible - before, they would remain
            // visible as they were still in focus.
            onMouseDown: (e_0)=>e_0.preventDefault()
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: isExpanded ? formatMessage($f1127282d3d31a9b$var$messages.collapseSuggestions) : formatMessage($f1127282d3d31a9b$var$messages.expandSuggestions),
        onClick: onClick,
        appearance: "subtle",
        spacing: "compact",
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-header.expand-collapse-button",
        isTooltipDisabled: false,
        // if a user hovers off the header after clicking these buttons, the buttons are not visible - before, they would remain
        // visible as they were still in focus.
        onMouseDown: (e_1)=>e_1.preventDefault()
    })));
};
function $f1127282d3d31a9b$var$_temp(e) {
    return e.preventDefault();
}
function $f1127282d3d31a9b$var$_temp2(e_0) {
    return e_0.preventDefault();
}
function $f1127282d3d31a9b$var$_temp3(e_1) {
    return e_1.preventDefault();
}
module.exports["CardHeader"] = $f1127282d3d31a9b$export$5665775b26e26c5d;

});

parcelRegister("981Ry", function(module, exports) {
/**
 * @generated SignedSource<<300bf84677d37baa1b921fd60bbdd33a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8e6e2030c8602bcf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldIdsOrAliases"
        }
    ],
    "kind": "Fragment",
    "name": "actionCard_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardHeader_updateWorkItemFieldsActionRenderer"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "fieldIdsOrAliases",
                    "variableName": "fieldIdsOrAliases"
                }
            ],
            "kind": "FragmentSpread",
            "name": "cardFieldsList_updateWorkItemFieldsActionRenderer"
        }
    ],
    "type": "JiraIssue"
};
$8e6e2030c8602bcf$var$node.hash = "c0ee2fc906799fb2c515e6571cea18f3";
var $8e6e2030c8602bcf$export$2e2bcd8739ae039 = $8e6e2030c8602bcf$var$node;
module.exports["default"] = $8e6e2030c8602bcf$export$2e2bcd8739ae039;

});

parcelRegister("2wgzS", function(module, exports) {

var $26N62 = parcelRequire("26N62");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $1sCHt = parcelRequire("1sCHt");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $buzLI = parcelRequire("buzLI");


var $i64u7 = parcelRequire("i64u7");


var $33Z0B = parcelRequire("33Z0B");


var $84bng = parcelRequire("84bng");


var $hx6zx = parcelRequire("hx6zx");


var $dP9dm = parcelRequire("dP9dm");


var $XVlOg = parcelRequire("XVlOg");


var $4J6wZ = parcelRequire("4J6wZ");


var $9fEbx = parcelRequire("9fEbx");


var $bdZ3v = parcelRequire("bdZ3v");


var $gZG3v = parcelRequire("gZG3v");


var $24pye = parcelRequire("24pye");


var $j7N3D = parcelRequire("j7N3D");


var $8i2Nw = parcelRequire("8i2Nw");


var $8msbG = parcelRequire("8msbG");


var $bPDZa = parcelRequire("bPDZa");


var $juWfe = parcelRequire("juWfe");


var $fUHlZ = parcelRequire("fUHlZ");


var $dZiPN = parcelRequire("dZiPN");


var $atHKC = parcelRequire("atHKC");


var $5npJQ = parcelRequire("5npJQ");


var $kxNz2 = parcelRequire("kxNz2");


var $hmppd = parcelRequire("hmppd");


var $2uuCi = parcelRequire("2uuCi");


var $zn4gW = parcelRequire("zn4gW");


var $2fohj = parcelRequire("2fohj");


var $eG3i6 = parcelRequire("eG3i6");


var $iygPg = parcelRequire("iygPg");


var $1rOeD = parcelRequire("1rOeD");


var $5cnnG = parcelRequire("5cnnG");


var $3C85b = parcelRequire("3C85b");


var $lAVCj = parcelRequire("lAVCj");


var $l9Fe2 = parcelRequire("l9Fe2");


var $fYjHB = parcelRequire("fYjHB");


var $gpyL1 = parcelRequire("gpyL1");


var $fVs75 = parcelRequire("fVs75");


var $dlexh = parcelRequire("dlexh");


var $dP04p = parcelRequire("dP04p");


var $7eLor = parcelRequire("7eLor");

const $e1926fc1ad18a2bf$var$styles = {
    root: "_23rrnH2HTN _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuchRC _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r21Y8M _1wydGW1Y8M _0wOv4Q18ZR _2xIroYnXvL _1eOmH6d1Zr",
    statusIconContainer: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT _0adFHs1Y8M",
    fieldsContainer: "_2mHwu81Y8M _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _2fwxA5ecOK",
    actionButtonsHidden: "_1YKVNsdnbC"
};
const $e1926fc1ad18a2bf$export$c522d2a712641b49 = ({ queryRef: queryRef, cloudId: cloudId, action: action, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, getReadonly: getReadonly, showActionButtons: showActionButtons = true })=>{
    (0, $6cFsl.di)((0, $eG3i6.SingleLineTextField), (0, $zn4gW.RichTextField), (0, $1rOeD.SingleSelectUserPickerField), (0, $dP04p.UsersField), (0, $3C85b.StatusField), (0, $24pye.FlagField), (0, $bPDZa.LabelsField), (0, $kxNz2.PriorityField), (0, $4J6wZ.DatePickerField), (0, $bdZ3v.DateTimePickerField), (0, $atHKC.ParentIssueField), (0, $dP9dm.CommentField), (0, $8i2Nw.GenericField), (0, $fUHlZ.NumberField), (0, $84bng.ColorField), (0, $33Z0B.useFieldTooltip));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { tooltipContent: tooltipContent, registerTooltipProvider: registerTooltipProvider, rootHoverHandlers: rootHoverHandlers, focusHandlers: focusHandlers, isHovered: isHovered, isFocused: isFocused } = (0, $33Z0B.useFieldTooltip)(action.data.fieldKey); // Persist last tooltip ReactNode so moving cursor to tooltip overlay doesn't lose field-specific content.
    const [persistedTooltipContent, setPersistedTooltipContent] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (tooltipContent != null) setPersistedTooltipContent(tooltipContent);
    }, [
        tooltipContent,
        action.data.fieldKey
    ]);
    const status = getStatus(action);
    const readonly = getReadonly(action);
    const isSubmitting = status === 'started' || action?.status === 'started';
    const isFailed = status === 'errored' || action?.status === 'errored';
    const isDisabled = status !== 'idle' || readonly;
    const isCompleted = status === 'finished' || action?.status === 'finished';
    const isCancelled = status === 'cancelled' || action?.status === 'cancelled';
    const isIdle = status === 'idle' && action?.status === 'planned'; // When an action is completed, we want to hide the icons and buttons when a user unhovers or focuses away from the action (aside from the success
    // icon, which is always visible after the action has been accepted). However, `isFocused` remains true even if we unfocus on the action after
    // it has been accepted or cancelled. Temporary fix for TEAM25EU until we find a proper fix to the focus issue.
    const isActionCompleted = isCompleted || isCancelled || isFailed;
    const issue = (0, $6SsN4.useFragment)((0, $26N62.default), queryRef); // This allows for custom fields types to be tracked in the analytics event.
    const fieldType = issue?.fieldsByIdOrAlias?.filter((field)=>field?.fieldId === action?.data?.fieldKey)?.[0]?.type ?? action.data.fieldKey;
    const analyticsAttributes = {
        fieldType: fieldType,
        hasReasoning: !!action.data.reasoning,
        hasSourceUrl: !!action.data.sourceUrl,
        ...(0, $iDrrr.fg)('add-source-in-update-workitem-analytics') ? {
            sourceUrlType: (0, $buzLI.classifySourceUrl)(action.data.sourceUrl)
        } : {}
    };
    (0, $cozmU.useEffect)(()=>{
        if (isIdle) sendAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'suggestion',
            actionSubjectId: 'updateWorkField',
            attributes: {
                ...analyticsAttributes
            }
        });
         // Empty dependency array to ensure that we only fire the analytics event once when the suggestion renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fields = issue?.fieldsByIdOrAlias;
    const hasFields = Array.isArray(fields) && fields.length > 0;
    const filteredFields = (0, $cozmU.useMemo)(()=>hasFields ? fields.filter((field)=>Boolean(field)).filter((field)=>field?.fieldId === action?.data?.fieldKey || // Edge case with the custom time spent field - we still want to use timetracking to fetch its data.
            field?.fieldId === 'timetracking' && action?.data?.fieldKey === 'timespent') : [], [
        hasFields,
        fields,
        action?.data?.fieldKey
    ]);
    const fieldsRegistry = (0, $cozmU.useMemo)(()=>{
        const registry = filteredFields.map((field)=>{
            switch(field?.__typename){
                case 'JiraSingleLineTextField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iygPg.SingleLineTextFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eG3i6.SingleLineTextField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraRichTextField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2fohj.RichTextFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $zn4gW.RichTextField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraSingleSelectUserPickerField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5cnnG.SingleSelectUserPickerFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1rOeD.SingleSelectUserPickerField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraMultipleSelectUserPickerField':
                case 'JiraPeopleField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7eLor.UsersFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dP04p.UsersField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraStatusField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lAVCj.StatusFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3C85b.StatusField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraPriorityField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hmppd.PriorityFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxNz2.PriorityField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraLabelsField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $juWfe.LabelsFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPDZa.LabelsField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraFlagField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j7N3D.FlagFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24pye.FlagField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraDatePickerField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fEbx.DatePickerFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4J6wZ.DatePickerField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraDateTimePickerField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gZG3v.DateTimePickerFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdZ3v.DateTimePickerField), {
                            key: field.id,
                            action: action,
                            queryRef: field
                        })
                    };
                case 'JiraParentIssueField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5npJQ.ParentIssueFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $atHKC.ParentIssueField), {
                            key: field.id,
                            cloudId: cloudId,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraNumberField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dZiPN.NumberFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fUHlZ.NumberField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraColorField':
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hx6zx.ColorFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84bng.ColorField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                case 'JiraTimeTrackingField':
                    if (action?.data?.fieldKey === 'timespent') return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gpyL1.TimeSpentFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYjHB.TimeSpentField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dlexh.TimeTrackingFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fVs75.TimeTrackingField), {
                            key: field.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
                default:
                    return {
                        key: field?.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8msbG.GenericFieldIcon), null),
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8i2Nw.GenericField), {
                            key: field?.id,
                            action: action,
                            queryRef: field,
                            registerTooltipProvider: registerTooltipProvider
                        })
                    };
            }
        }).filter(Boolean);
        // Filter out null or undefined components
        // Ensure CommentField is added if action.data.fieldKey is 'comment'
        if (action?.data?.fieldKey === 'comment') {
            const key = `${action.data.issueId}-${action.data.fieldKey}-${action.invocationId}`;
            registry.push({
                key: key,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $XVlOg.CommentFieldIcon), null),
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dP9dm.CommentField), {
                    key: key,
                    action: action,
                    registerTooltipProvider: registerTooltipProvider
                })
            });
        }
        return registry;
    }, [
        action,
        cloudId,
        filteredFields,
        registerTooltipProvider
    ]);
    if (!action || fieldsRegistry.length === 0 && action.data.fieldKey !== 'comment') return null;
    if (isCancelled) return null;
    const effectiveTooltipContent = tooltipContent ?? persistedTooltipContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
        reasoning: action?.data?.reasoning ?? null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldsRegistry.map(({ key: key, icon: icon, component: component })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: `tooltip-${key}`,
            component: (0, $2uuCi.ReasoningTooltip),
            content: effectiveTooltipContent,
            position: "left",
            delay: 0
        }, ({ ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ...tooltipProps,
                ...rootHoverHandlers,
                xcss: $e1926fc1ad18a2bf$var$styles.root,
                tabIndex: 0,
                onFocus: (e)=>{
                    tooltipProps.onFocus?.(e);
                    focusHandlers.onFocus?.();
                },
                onBlur: (e)=>{
                    tooltipProps.onBlur?.(e);
                    focusHandlers.onBlur?.();
                },
                // a user could click on this Box (to no effect), and the status icons + action buttons would still be
                // shown when they hover away.
                onMouseDown: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                testId: "update-work-item-fields-action-renderer.ui.card-fields-list"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $e1926fc1ad18a2bf$var$styles.statusIconContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9Fe2.StatusIcon), {
                showIcon: isActionCompleted ? isHovered : isHovered || isFocused,
                icon: icon,
                isCompleted: isCompleted,
                isLoading: isSubmitting,
                isFailed: isFailed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $e1926fc1ad18a2bf$var$styles.fieldsContainer
            }, component), showActionButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                testId: "update-work-item-fields-action-renderer.ui.card-fields-list.action-buttons",
                xcss: !(isActionCompleted ? isHovered : isHovered || isFocused) && $e1926fc1ad18a2bf$var$styles.actionButtonsHidden,
                space: "space.050",
                ...focusHandlers
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
                label: "Accept",
                spacing: "compact",
                appearance: "subtle",
                onClick: ()=>{
                    onConfirm(action);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'updateWorkAccept',
                        attributes: {
                            ...analyticsAttributes,
                            bulkActioned: false
                        }
                    });
                },
                isDisabled: isDisabled || isSubmitting
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: "Dismiss",
                spacing: "compact",
                appearance: "subtle",
                onClick: ()=>{
                    onCancel(action);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'updateWorkDismiss',
                        attributes: {
                            ...analyticsAttributes,
                            bulkActioned: false
                        }
                    });
                },
                isDisabled: isDisabled || isSubmitting
            }))))));
};
module.exports["CardFieldsList"] = $e1926fc1ad18a2bf$export$c522d2a712641b49;

});

parcelRegister("3aGiD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $egUPh = parcelRequire("egUPh");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $1sCHt = parcelRequire("1sCHt");

var $7WEaj = parcelRequire("7WEaj");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $V3JOP = parcelRequire("V3JOP");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

const $bc71998a404316e4$var$messages = (0, $kSwu1.defineMessages)({
    openInANewTab: {
        id: "update-work-item-fields-action-renderer.ui.action-card.card-header.openInANewTab",
        defaultMessage: "Open in a new tab"
    },
    expandSuggestions: {
        id: "update-work-item-fields-action-renderer.ui.action-card.card-header.expandSuggestions",
        defaultMessage: "Expand suggestions"
    },
    collapseSuggestions: {
        id: "update-work-item-fields-action-renderer.ui.action-card.card-header.collapseSuggestions",
        defaultMessage: "Collapse suggestions"
    }
});
const $bc71998a404316e4$export$60fc2903fffebabf = 'update-work-item-fields-action-renderer.ui.action-card.card-header.icon-buttons-container';
const $bc71998a404316e4$var$styles = {
    root: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _2YzrBZnQyn _2qzUsRnQyn _3AHEfjdnbC _1ITF8zdnbC _0zrch1YvD1 _0Kt2AlYvD1 _1FJB2wYvD1 _0QjyNNYvD1 _4GkcjwIZbP _2lMZOvIZbP _3ctfM07dHp _1ZfWof7dHp",
    avatar: "_3138421Y8M _0adFHs1Y8M _1DCdHi1Y8M _2XsHFM1Y8M _4ouGXIE6Kk",
    workItemKeyContainer: "_4ouGXIE6Kk",
    pressable: "_0bjKvDKxmn _3iDTPbQ4SZ _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _2fwxA5ecOK _2O5Vij7dHp"
};
const $bc71998a404316e4$export$5665775b26e26c5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { queryRef: queryRef, isExpanded: isExpanded, onClick: onClick, showButtons: t1 } = t0;
    const showButtons = t1 === undefined ? true : t1;
    (0, $6cFsl.di)((0, $lpNn5.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const issue = (0, $6SsN4.useFragment)((0, $egUPh.default), queryRef);
    if (!issue) return null;
    const issueType = issue?.issueTypeField?.issueType;
    const issueUrl = issue?.webUrl ?? "";
    const t2 = `${issue.key}: ${issue?.summaryField?.text}`;
    const t3 = issueType?.name;
    const t4 = issueType?.avatar?.small ?? undefined;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $bc71998a404316e4$var$styles.avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: t3,
            src: t4,
            width: 16,
            height: 16
        }));
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = issue?.key;
    let t7;
    if ($[3] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bc71998a404316e4$var$styles.workItemKeyContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, t6));
        $[3] = t6;
        $[4] = t7;
    } else t7 = $[4];
    const t8 = issue?.summaryField?.text;
    let t9;
    if ($[5] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "strong",
            maxLines: 1
        }, t8);
        $[5] = t8;
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] !== t5 || $[8] !== t7 || $[9] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "center"
        }, t5, t7, t9);
        $[7] = t5;
        $[8] = t7;
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== t10 || $[12] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "bottom",
            content: t2
        }, t10);
        $[11] = t10;
        $[12] = t2;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== onClick || $[15] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $bc71998a404316e4$var$styles.pressable,
            onClick: onClick,
            tabIndex: -1,
            onMouseDown: $bc71998a404316e4$var$_temp
        }, t11);
        $[14] = onClick;
        $[15] = t11;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== formatMessage || $[18] !== isExpanded || $[19] !== issueUrl || $[20] !== onClick || $[21] !== showButtons) {
        t13 = showButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: $bc71998a404316e4$export$60fc2903fffebabf
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "bottom",
            content: formatMessage($bc71998a404316e4$var$messages.openInANewTab),
            isScreenReaderAnnouncementDisabled: true
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                ...tooltipProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage($bc71998a404316e4$var$messages.openInANewTab),
                href: issueUrl,
                target: "_blank",
                appearance: "subtle",
                spacing: "compact",
                testId: "update-work-item-fields-action-renderer.ui.action-card.card-header.external-link-button",
                onMouseDown: $bc71998a404316e4$var$_temp2
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
            label: isExpanded ? formatMessage($bc71998a404316e4$var$messages.collapseSuggestions) : formatMessage($bc71998a404316e4$var$messages.expandSuggestions),
            onClick: onClick,
            appearance: "subtle",
            spacing: "compact",
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-header.expand-collapse-button",
            isTooltipDisabled: false,
            onMouseDown: $bc71998a404316e4$var$_temp3
        }));
        $[17] = formatMessage;
        $[18] = isExpanded;
        $[19] = issueUrl;
        $[20] = onClick;
        $[21] = showButtons;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t12 || $[24] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            xcss: $bc71998a404316e4$var$styles.root,
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-header"
        }, t12, t13);
        $[23] = t12;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    return t14;
} : ({ queryRef: queryRef, isExpanded: isExpanded, onClick: onClick, showButtons: showButtons = true })=>{
    (0, $6cFsl.di)((0, $lpNn5.default));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const issue = (0, $6SsN4.useFragment)((0, $egUPh.default), queryRef);
    if (!issue) return null;
    const issueType = issue?.issueTypeField?.issueType;
    const issueUrl = issue?.webUrl ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between",
        xcss: $bc71998a404316e4$var$styles.root,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $bc71998a404316e4$var$styles.pressable,
        onClick: onClick,
        tabIndex: -1,
        onMouseDown: (e)=>e.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "bottom",
        content: `${issue.key}: ${issue?.summaryField?.text}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $bc71998a404316e4$var$styles.avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: issueType?.name,
        src: issueType?.avatar?.small ?? undefined,
        width: 16,
        height: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bc71998a404316e4$var$styles.workItemKeyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, issue?.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong",
        maxLines: 1
    }, issue?.summaryField?.text)))), showButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: $bc71998a404316e4$export$60fc2903fffebabf
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "bottom",
        content: formatMessage($bc71998a404316e4$var$messages.openInANewTab),
        isScreenReaderAnnouncementDisabled: true
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            ...tooltipProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            label: formatMessage($bc71998a404316e4$var$messages.openInANewTab),
            href: issueUrl,
            target: "_blank",
            appearance: "subtle",
            spacing: "compact",
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-header.external-link-button",
            // if a user hovers off the header after clicking these buttons, the buttons are not visible - before, they would remain
            // visible as they were still in focus.
            onMouseDown: (e_0)=>e_0.preventDefault()
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: isExpanded ? formatMessage($bc71998a404316e4$var$messages.collapseSuggestions) : formatMessage($bc71998a404316e4$var$messages.expandSuggestions),
        onClick: onClick,
        appearance: "subtle",
        spacing: "compact",
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-header.expand-collapse-button",
        isTooltipDisabled: false,
        // if a user hovers off the header after clicking these buttons, the buttons are not visible - before, they would remain
        // visible as they were still in focus.
        onMouseDown: (e_1)=>e_1.preventDefault()
    })));
};
function $bc71998a404316e4$var$_temp(e) {
    return e.preventDefault();
}
function $bc71998a404316e4$var$_temp2(e_0) {
    return e_0.preventDefault();
}
function $bc71998a404316e4$var$_temp3(e_1) {
    return e_1.preventDefault();
}
module.exports["CardHeader"] = $bc71998a404316e4$export$5665775b26e26c5d;

});

parcelRegister("hLyoT", function(module, exports) {
/**
 * @generated SignedSource<<d32982b958af2c0966b4514d02a496a2>>
 * @relayHash 496a767b7160739c94b7867b12e039e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a07d521b29285cf076a17b0ede1d56ca532b17a8f1e4a74c2059981acf2d728
const $03aa8f322a9f745b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "projectAri"
        }
    ], v3 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v1 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actionCardProjectDetailsQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actionCardProjectDetailsQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "concreteType": "TownsquareIconURIs",
                                    "kind": "LinkedField",
                                    "name": "iconUrl",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareThemeURIs",
                                            "kind": "LinkedField",
                                            "name": "square",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "light"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dark"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectState",
                                    "kind": "LinkedField",
                                    "name": "state",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "dueDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareUserConnection",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v3 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a07d521b29285cf076a17b0ede1d56ca532b17a8f1e4a74c2059981acf2d728",
            "metadata": {},
            "name": "actionCardProjectDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$03aa8f322a9f745b$var$node.hash = "a410c6a3d1b50e2195c0fd22f1899865";
var $03aa8f322a9f745b$export$2e2bcd8739ae039 = $03aa8f322a9f745b$var$node;
module.exports["default"] = $03aa8f322a9f745b$export$2e2bcd8739ae039;

});

parcelRegister("kGin2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $2TUA1 = parcelRequire("2TUA1");


var $d8b6a = parcelRequire("d8b6a");


var $baXMQ = parcelRequire("baXMQ");


var $bBruU = parcelRequire("bBruU");


var $2YqCL = parcelRequire("2YqCL");

const $4ea9d5d6d32f81de$var$styles = {
    container: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $4ea9d5d6d32f81de$export$851de33184ecdac4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { action: action } = t0;
    let t1;
    if ($[0] !== action.data) {
        t1 = action.data || {};
        $[0] = action.data;
        $[1] = t1;
    } else t1 = $[1];
    const { summary: summary, updateNote: updateNote, highlightLearning: highlightLearning, highlightRisk: highlightRisk, highlightDecision: highlightDecision } = t1;
    let t2;
    if ($[2] !== summary) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2YqCL.SummaryField), {
            summary: summary
        });
        $[2] = summary;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== updateNote) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBruU.UpdateNoteField), {
            updateNote: updateNote
        });
        $[4] = updateNote;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== highlightRisk) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baXMQ.HighlightRiskField), {
            highlight: highlightRisk
        });
        $[6] = highlightRisk;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== highlightDecision) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TUA1.HighlightDecisionField), {
            highlight: highlightDecision
        });
        $[8] = highlightDecision;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== highlightLearning) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8b6a.HighlightLearningField), {
            highlight: highlightLearning
        });
        $[10] = highlightLearning;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ea9d5d6d32f81de$var$styles.container,
            testId: "project-status-update-action-renderer.ui.card-body"
        }, t2, t3, t4, t5, t6);
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ action: action })=>{
    const { summary: summary, updateNote: updateNote, highlightLearning: highlightLearning, highlightRisk: highlightRisk, highlightDecision: highlightDecision } = action.data || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ea9d5d6d32f81de$var$styles.container,
        testId: "project-status-update-action-renderer.ui.card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2YqCL.SummaryField), {
        summary: summary
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBruU.UpdateNoteField), {
        updateNote: updateNote
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baXMQ.HighlightRiskField), {
        highlight: highlightRisk
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TUA1.HighlightDecisionField), {
        highlight: highlightDecision
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8b6a.HighlightLearningField), {
        highlight: highlightLearning
    }));
};
module.exports["CardBody"] = $4ea9d5d6d32f81de$export$851de33184ecdac4;

});

parcelRegister("6YxHK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f9fe1967e95e8fb8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    disclaimer: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.disclaimer",
        defaultMessage: "May include information some users don't have permission to view. Review for sensitive or restricted content before sharing this update."
    }
});
module.exports["messages"] = $f9fe1967e95e8fb8$export$defe85febe8b728c;

});

parcelRegister("aY1NH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hYjiU = parcelRequire("hYjiU");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $ad7Ou = parcelRequire("ad7Ou");


var $lpNn5 = parcelRequire("lpNn5");


var $hFOCq = parcelRequire("hFOCq");

const $61d513cdb089ed6d$export$736619659e26a092 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { action: action, onConfirm: onConfirm, onCancel: onCancel, isDisabled: isDisabled, isSubmitting: isSubmitting, currentUserId: currentUserId, fragmentKey: fragmentKey } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const projectDetails = (0, $6SsN4.useFragment)((0, $hYjiU.default), fragmentKey);
    let t1;
    if ($[0] !== projectDetails?.members?.edges) {
        t1 = projectDetails?.members?.edges?.map($61d513cdb089ed6d$var$_temp);
        $[0] = projectDetails?.members?.edges;
        $[1] = t1;
    } else t1 = $[1];
    const projectMembers = t1;
    let t2;
    bb0: {
        if (!currentUserId || !projectMembers || projectMembers.length === 0) {
            t2 = false;
            break bb0;
        }
        let t3;
        if ($[2] !== currentUserId || $[3] !== projectMembers) {
            let t4;
            if ($[5] !== currentUserId) {
                t4 = (member)=>member?.id === currentUserId;
                $[5] = currentUserId;
                $[6] = t4;
            } else t4 = $[6];
            t3 = projectMembers.some(t4);
            $[2] = currentUserId;
            $[3] = projectMembers;
            $[4] = t3;
        } else t3 = $[4];
        t2 = t3;
    }
    const isUserAMember = t2;
    const isPostButtonDisabled = isDisabled || !isUserAMember;
    let t3;
    if ($[7] !== action || $[8] !== onCancel) {
        t3 = ()=>onCancel(action);
        $[7] = action;
        $[8] = onCancel;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== intl) {
        t4 = intl.formatMessage((0, $hFOCq.messages).ctaCancel);
        $[10] = intl;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isDisabled || $[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: t3,
            isDisabled: isDisabled
        }, t4);
        $[12] = isDisabled;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    const cancelButton = t5;
    let t6;
    if ($[16] !== action || $[17] !== onConfirm) {
        t6 = ()=>onConfirm(action);
        $[16] = action;
        $[17] = onConfirm;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== intl) {
        t7 = intl.formatMessage((0, $hFOCq.messages).ctaPostUpdate);
        $[19] = intl;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== isPostButtonDisabled || $[22] !== isSubmitting || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: t6,
            isDisabled: isPostButtonDisabled,
            isLoading: isSubmitting
        }, t7);
        $[21] = isPostButtonDisabled;
        $[22] = isSubmitting;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    const postButton = t8;
    if (isUserAMember) {
        let t9;
        if ($[26] !== cancelButton || $[27] !== postButton) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, cancelButton, postButton);
            $[26] = cancelButton;
            $[27] = postButton;
            $[28] = t9;
        } else t9 = $[28];
        return t9;
    }
    let t9;
    if ($[29] !== intl) {
        t9 = intl.formatMessage((0, $hFOCq.messages).ctaForbiddenPostUpdate);
        $[29] = intl;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== postButton) {
        t10 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", tooltipProps, postButton);
        $[31] = postButton;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== t10 || $[34] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t9,
            position: "top"
        }, t10);
        $[33] = t10;
        $[34] = t9;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] !== cancelButton || $[37] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, cancelButton, t11);
        $[36] = cancelButton;
        $[37] = t11;
        $[38] = t12;
    } else t12 = $[38];
    return t12;
} : ({ action: action, onConfirm: onConfirm, onCancel: onCancel, isDisabled: isDisabled, isSubmitting: isSubmitting, currentUserId: currentUserId, fragmentKey: fragmentKey })=>{
    const intl = (0, $kSwu1.useIntl)();
    const projectDetails = (0, $6SsN4.useFragment)((0, $hYjiU.default), fragmentKey);
    const projectMembers = projectDetails?.members?.edges?.map((node)=>node?.node);
    // Check if current user is a member of the project
    const isUserAMember = (0, $cozmU.useMemo)(()=>{
        if (!currentUserId || !projectMembers || projectMembers.length === 0) return false; // Disallow action if we can't determine membership
        return projectMembers.some((member)=>member?.id === currentUserId);
    }, [
        currentUserId,
        projectMembers
    ]);
    const isPostButtonDisabled = isDisabled || !isUserAMember;
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>onCancel(action),
        isDisabled: isDisabled
    }, intl.formatMessage((0, $hFOCq.messages).ctaCancel));
    const postButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>onConfirm(action),
        isDisabled: isPostButtonDisabled,
        isLoading: isSubmitting
    }, intl.formatMessage((0, $hFOCq.messages).ctaPostUpdate));
    if (isUserAMember) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, cancelButton, postButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, cancelButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage((0, $hFOCq.messages).ctaForbiddenPostUpdate),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", tooltipProps, postButton)));
};
const $61d513cdb089ed6d$export$e9897d434e0741ee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { action: action, onConfirm: onConfirm, onCancel: onCancel, isDisabled: isDisabled, isSubmitting: isSubmitting } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action || $[1] !== onCancel) {
        t1 = ()=>onCancel(action);
        $[0] = action;
        $[1] = onCancel;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== intl) {
        t2 = intl.formatMessage((0, $hFOCq.messages).ctaCancel);
        $[3] = intl;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isDisabled || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: t1,
            isDisabled: isDisabled
        }, t2);
        $[5] = isDisabled;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== action || $[10] !== onConfirm) {
        t4 = ()=>onConfirm(action);
        $[9] = action;
        $[10] = onConfirm;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== intl) {
        t5 = intl.formatMessage((0, $hFOCq.messages).ctaPostUpdate);
        $[12] = intl;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== isDisabled || $[15] !== isSubmitting || $[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: t4,
            isDisabled: isDisabled,
            isLoading: isSubmitting
        }, t5);
        $[14] = isDisabled;
        $[15] = isSubmitting;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t3 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t6);
        $[19] = t3;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
} : ({ action: action, onConfirm: onConfirm, onCancel: onCancel, isDisabled: isDisabled, isSubmitting: isSubmitting })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>onCancel(action),
        isDisabled: isDisabled
    }, intl.formatMessage((0, $hFOCq.messages).ctaCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>onConfirm(action),
        isDisabled: isDisabled,
        isLoading: isSubmitting
    }, intl.formatMessage((0, $hFOCq.messages).ctaPostUpdate)));
};
function $61d513cdb089ed6d$var$_temp(node) {
    return node?.node;
}
module.exports["CardFooterWithTooltip"] = $61d513cdb089ed6d$export$736619659e26a092;

});

parcelRegister("4EdWe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fhJzs = parcelRequire("fhJzs");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $7zNWH = parcelRequire("7zNWH");


var $6f85n = parcelRequire("6f85n");


var $4eDq7 = parcelRequire("4eDq7");

const $bf4af8478eff418f$var$styles = {
    container: "_3iDTPbccYA _37wbyuDIqT",
    topRow: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    bottomRow: "_3iDTPbccYA _0Of8r21Y8M",
    projectKey: "_3iDTPbQ4SZ _0hPCNLDIqT",
    projectStatus: "_2mHwu8gVvo _3iDTPbccYA _0hPCNLDIqT",
    projectName: "_2mHwu8gVvo _3iDTPbccYA _0hPCNLDIqT"
};
const $bf4af8478eff418f$export$5665775b26e26c5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { action: action, fragmentKey: fragmentKey } = t0;
    let t1;
    if ($[0] !== action.data) {
        t1 = action.data || {};
        $[0] = action.data;
        $[1] = t1;
    } else t1 = $[1];
    const { phase: phase, status: status, targetDate: targetDate } = t1;
    const projectDetails = (0, $6SsN4.useFragment)((0, $fhJzs.default), fragmentKey);
    let t2;
    if ($[2] !== projectDetails) {
        t2 = projectDetails || {};
        $[2] = projectDetails;
        $[3] = t2;
    } else t2 = $[3];
    const { name: projectName, key: projectKey, iconUrl: iconUrl, state: state, dueDate: fallbackDate } = t2;
    const intl = (0, $kSwu1.useIntl)();
    const projectStatus = phase && phase !== "in_progress" ? phase : status || state?.value;
    let t3;
    bb0: switch(projectStatus){
        case "paused":
            {
                let t4;
                if ($[4] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).phasePaused);
                    $[4] = intl;
                    $[5] = t4;
                } else t4 = $[5];
                t3 = t4;
                break bb0;
            }
        case "pending":
            {
                let t4;
                if ($[6] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).phasePending);
                    $[6] = intl;
                    $[7] = t4;
                } else t4 = $[7];
                t3 = t4;
                break bb0;
            }
        case "done":
            {
                let t4;
                if ($[8] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).phaseDone);
                    $[8] = intl;
                    $[9] = t4;
                } else t4 = $[9];
                t3 = t4;
                break bb0;
            }
        case "on_track":
            {
                let t4;
                if ($[10] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).statusOnTrack);
                    $[10] = intl;
                    $[11] = t4;
                } else t4 = $[11];
                t3 = t4;
                break bb0;
            }
        case "at_risk":
            {
                let t4;
                if ($[12] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).statusAtRisk);
                    $[12] = intl;
                    $[13] = t4;
                } else t4 = $[13];
                t3 = t4;
                break bb0;
            }
        case "off_track":
            {
                let t4;
                if ($[14] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).statusOffTrack);
                    $[14] = intl;
                    $[15] = t4;
                } else t4 = $[15];
                t3 = t4;
                break bb0;
            }
        case "cancelled":
            {
                let t4;
                if ($[16] !== intl) {
                    t4 = intl.formatMessage((0, $4eDq7.messages).phaseCancelled);
                    $[16] = intl;
                    $[17] = t4;
                } else t4 = $[17];
                t3 = t4;
                break bb0;
            }
        default:
            t3 = undefined;
    }
    const statusLozengeText = t3;
    let t4;
    bb1: switch(projectStatus){
        case "on_track":
            t4 = "success";
            break bb1;
        case "at_risk":
            t4 = "warning";
            break bb1;
        case "off_track":
            t4 = "danger";
            break bb1;
        default:
            t4 = "neutral";
    }
    const statusLozengeAppearance = t4;
    let t5;
    if ($[18] !== statusLozengeAppearance || $[19] !== statusLozengeText) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zNWH.StatusField), {
            statusLozengeText: statusLozengeText,
            statusLozengeAppearance: statusLozengeAppearance
        });
        $[18] = statusLozengeAppearance;
        $[19] = statusLozengeText;
        $[20] = t5;
    } else t5 = $[20];
    const t6 = fallbackDate?.label;
    let t7;
    if ($[21] !== t6 || $[22] !== targetDate) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f85n.TargetDateField), {
            targetDate: targetDate,
            fallbackDate: t6
        });
        $[21] = t6;
        $[22] = targetDate;
        $[23] = t7;
    } else t7 = $[23];
    let T0;
    let T1;
    let t10;
    let t11;
    let t12;
    let t8;
    let t9;
    if ($[24] !== fallbackDate?.label || $[25] !== intl || $[26] !== phase || $[27] !== projectKey || $[28] !== projectName || $[29] !== statusLozengeAppearance || $[30] !== statusLozengeText || $[31] !== t5 || $[32] !== t7 || $[33] !== targetDate) {
        t12 = Symbol.for("react.early_return_sentinel");
        bb2: {
            const statusTextProps = {
                status: t5,
                date: t7
            };
            if (!projectKey && !statusLozengeText && !targetDate?.date && !fallbackDate?.label && !projectName) {
                t12 = null;
                break bb2;
            }
            T1 = (0, $dinVW.Stack);
            t11 = $bf4af8478eff418f$var$styles.container;
            T0 = (0, $1l0kj.Inline);
            t8 = $bf4af8478eff418f$var$styles.topRow;
            let t13;
            if ($[41] !== projectKey) {
                t13 = projectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    color: "color.text.subtle"
                }, projectKey);
                $[41] = projectKey;
                $[42] = t13;
            } else t13 = $[42];
            if ($[43] !== t13) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $bf4af8478eff418f$var$styles.projectKey
                }, t13);
                $[43] = t13;
                $[44] = t9;
            } else t9 = $[44];
            t10 = statusLozengeText && (targetDate?.date || fallbackDate?.label) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle",
                size: "small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $bf4af8478eff418f$var$styles.projectStatus
            }, phase === "done" ? intl.formatMessage((0, $4eDq7.messages).statusOnDate, statusTextProps) : intl.formatMessage((0, $4eDq7.messages).statusForDate, statusTextProps))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $bf4af8478eff418f$var$styles.projectStatus
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zNWH.StatusField), {
                statusLozengeText: statusLozengeText,
                statusLozengeAppearance: statusLozengeAppearance
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f85n.TargetDateField), {
                targetDate: targetDate,
                fallbackDate: fallbackDate?.label
            }));
        }
        $[24] = fallbackDate?.label;
        $[25] = intl;
        $[26] = phase;
        $[27] = projectKey;
        $[28] = projectName;
        $[29] = statusLozengeAppearance;
        $[30] = statusLozengeText;
        $[31] = t5;
        $[32] = t7;
        $[33] = targetDate;
        $[34] = T0;
        $[35] = T1;
        $[36] = t10;
        $[37] = t11;
        $[38] = t12;
        $[39] = t8;
        $[40] = t9;
    } else {
        T0 = $[34];
        T1 = $[35];
        t10 = $[36];
        t11 = $[37];
        t12 = $[38];
        t8 = $[39];
        t9 = $[40];
    }
    if (t12 !== Symbol.for("react.early_return_sentinel")) return t12;
    let t13;
    if ($[45] !== T0 || $[46] !== t10 || $[47] !== t8 || $[48] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t8
        }, t9, t10);
        $[45] = T0;
        $[46] = t10;
        $[47] = t8;
        $[48] = t9;
        $[49] = t13;
    } else t13 = $[49];
    let t14;
    if ($[50] !== iconUrl || $[51] !== projectName) {
        t14 = projectName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $bf4af8478eff418f$var$styles.bottomRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $bf4af8478eff418f$var$styles.projectName
        }, iconUrl?.square && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: iconUrl.square?.light ?? "",
            srcDark: iconUrl.square?.dark ?? "",
            alt: "",
            width: 20,
            height: 20
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, projectName)));
        $[50] = iconUrl;
        $[51] = projectName;
        $[52] = t14;
    } else t14 = $[52];
    let t15;
    if ($[53] !== T1 || $[54] !== t11 || $[55] !== t13 || $[56] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            xcss: t11
        }, t13, t14);
        $[53] = T1;
        $[54] = t11;
        $[55] = t13;
        $[56] = t14;
        $[57] = t15;
    } else t15 = $[57];
    return t15;
} : ({ action: action, fragmentKey: fragmentKey })=>{
    const { phase: phase, status: status, targetDate: targetDate } = action.data || {};
    const projectDetails = (0, $6SsN4.useFragment)((0, $fhJzs.default), fragmentKey);
    const { name: projectName, key: projectKey, iconUrl: iconUrl, state: state, dueDate: fallbackDate } = projectDetails || {};
    const intl = (0, $kSwu1.useIntl)();
    const projectStatus = (0, $cozmU.useMemo)(()=>phase && phase !== 'in_progress' ? phase : status || state?.value, [
        phase,
        status,
        state
    ]);
    const statusLozengeText = (0, $cozmU.useMemo)(()=>{
        switch(projectStatus){
            case 'paused':
                return intl.formatMessage((0, $4eDq7.messages).phasePaused);
            case 'pending':
                return intl.formatMessage((0, $4eDq7.messages).phasePending);
            case 'done':
                return intl.formatMessage((0, $4eDq7.messages).phaseDone);
            case 'on_track':
                return intl.formatMessage((0, $4eDq7.messages).statusOnTrack);
            case 'at_risk':
                return intl.formatMessage((0, $4eDq7.messages).statusAtRisk);
            case 'off_track':
                return intl.formatMessage((0, $4eDq7.messages).statusOffTrack);
            case 'cancelled':
                return intl.formatMessage((0, $4eDq7.messages).phaseCancelled);
            default:
                return undefined;
        }
    }, [
        projectStatus,
        intl
    ]);
    const statusLozengeAppearance = (0, $cozmU.useMemo)(()=>{
        switch(projectStatus){
            case 'on_track':
                return 'success';
            case 'at_risk':
                return 'warning';
            case 'off_track':
                return 'danger';
            default:
                return 'neutral';
        }
    }, [
        projectStatus
    ]);
    const statusTextProps = {
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zNWH.StatusField), {
            statusLozengeText: statusLozengeText,
            statusLozengeAppearance: statusLozengeAppearance
        }),
        date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f85n.TargetDateField), {
            targetDate: targetDate,
            fallbackDate: fallbackDate?.label
        })
    };
    if (!projectKey && !statusLozengeText && !targetDate?.date && !fallbackDate?.label && !projectName) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $bf4af8478eff418f$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $bf4af8478eff418f$var$styles.topRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bf4af8478eff418f$var$styles.projectKey
    }, projectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, projectKey)), statusLozengeText && (targetDate?.date || fallbackDate?.label) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $bf4af8478eff418f$var$styles.projectStatus
    }, phase === 'done' ? intl.formatMessage((0, $4eDq7.messages).statusOnDate, statusTextProps) : intl.formatMessage((0, $4eDq7.messages).statusForDate, statusTextProps))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $bf4af8478eff418f$var$styles.projectStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zNWH.StatusField), {
        statusLozengeText: statusLozengeText,
        statusLozengeAppearance: statusLozengeAppearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f85n.TargetDateField), {
        targetDate: targetDate,
        fallbackDate: fallbackDate?.label
    }))), projectName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $bf4af8478eff418f$var$styles.bottomRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $bf4af8478eff418f$var$styles.projectName
    }, iconUrl?.square && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: iconUrl.square?.light ?? '',
        srcDark: iconUrl.square?.dark ?? '',
        alt: "",
        width: 20,
        height: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, projectName))));
};
module.exports["CardHeader"] = $bf4af8478eff418f$export$5665775b26e26c5d;

});

parcelRegister("bV5ZQ", function(module, exports) {
/**
 * @generated SignedSource<<93cb17b0d1bd622b684c062950cffb20>>
 * @relayHash 9bc759740b757fa71466e3102f83699b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 65d181f4ba6169b348e6d53031c7d6ed7a6d8f25f1dc03df19467bbe1ac7e97b
const $fb566c1d813605c4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "membersCount"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamIds"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "teamIds"
        },
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "description"
    }, v7 = {
        "kind": "ScalarField",
        "name": "state"
    }, v8 = {
        "kind": "ScalarField",
        "name": "membershipSettings"
    }, v9 = {
        "kind": "ScalarField",
        "name": "organizationId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v11 = {
        "kind": "ScalarField",
        "name": "largeAvatarImageUrl"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "membersCount"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "archiveTeamsCardQuery",
            "selections": [
                {
                    "concreteType": "TeamQuery",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "teamsV2",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "TeamType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "TeamMemberConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TeamMemberEdgeV2",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TeamMemberV2",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "member",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "archiveTeamsCardQuery",
            "selections": [
                {
                    "concreteType": "TeamQuery",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "teamsV2",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "TeamType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "TeamMemberConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TeamMemberEdgeV2",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TeamMemberV2",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "member",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v14 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "65d181f4ba6169b348e6d53031c7d6ed7a6d8f25f1dc03df19467bbe1ac7e97b",
            "metadata": {},
            "name": "archiveTeamsCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fb566c1d813605c4$var$node.hash = "26e26c93c670f190365db39a8f1d9674";
var $fb566c1d813605c4$export$2e2bcd8739ae039 = $fb566c1d813605c4$var$node;
module.exports["default"] = $fb566c1d813605c4$export$2e2bcd8739ae039;

});

parcelRegister("76ttD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $8N4EC = parcelRequire("8N4EC");

const $72378b4aa5766f6f$export$100d90646a4a7d9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { actions: actions, onClose: onClose, onConfirm: onConfirm, onArchiveComplete: onArchiveComplete, onArchivingChange: onArchivingChange } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isArchiving, setIsArchiving] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const teamCount = actions.length;
    let t1;
    if ($[0] !== onClose || $[1] !== sendAnalyticsEvent || $[2] !== teamCount) {
        t1 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "closeArchiveConfirmationModalCleanUpTeams",
                attributes: {
                    teamCount: teamCount
                }
            });
            onClose();
        };
        $[0] = onClose;
        $[1] = sendAnalyticsEvent;
        $[2] = teamCount;
        $[3] = t1;
    } else t1 = $[3];
    const handleClose = t1;
    let t2;
    if ($[4] !== actions || $[5] !== onArchiveComplete || $[6] !== onArchivingChange || $[7] !== onClose || $[8] !== onConfirm || $[9] !== sendAnalyticsEvent || $[10] !== teamCount) {
        t2 = async ()=>{
            if (!actions.length) {
                onClose();
                return;
            }
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "confirmArchiveCleanUpTeams",
                attributes: {
                    teamCount: teamCount
                }
            });
            setIsArchiving(true);
            onArchivingChange?.(actions.map($72378b4aa5766f6f$var$_temp));
            await Promise.all(actions.map(async (action)=>{
                await onConfirm(action);
            }));
            onArchiveComplete?.();
            onArchivingChange?.([]);
            setIsArchiving(false);
            onClose();
        };
        $[4] = actions;
        $[5] = onArchiveComplete;
        $[6] = onArchivingChange;
        $[7] = onClose;
        $[8] = onConfirm;
        $[9] = sendAnalyticsEvent;
        $[10] = teamCount;
        $[11] = t2;
    } else t2 = $[11];
    const handleConfirm = t2;
    let t3;
    if ($[12] !== actions[0]?.data || $[13] !== actions.length || $[14] !== formatMessage || $[15] !== handleClose || $[16] !== handleConfirm || $[17] !== isArchiving || $[18] !== teamCount) {
        t3 = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            width: "small",
            onClose: handleClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, formatMessage((0, $8N4EC.default).archiveModalTitle, {
            teamCount: teamCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, formatMessage((0, $8N4EC.default).archiveModalBodyLine1, {
            teamCount: teamCount
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, formatMessage((0, $8N4EC.default).archiveModalBodyLine2, {
            teamCount: teamCount,
            teamName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "span",
                weight: "bold"
            }, actions[0]?.data.displayName)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleClose,
            isDisabled: isArchiving
        }, formatMessage((0, $8N4EC.default).archiveModalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "warning",
            onClick: handleConfirm,
            isLoading: isArchiving
        }, formatMessage((0, $8N4EC.default).archiveModalConfirm, {
            teamCount: teamCount
        }))));
        $[12] = actions[0]?.data;
        $[13] = actions.length;
        $[14] = formatMessage;
        $[15] = handleClose;
        $[16] = handleConfirm;
        $[17] = isArchiving;
        $[18] = teamCount;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    if ($[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t3);
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : ({ actions: actions, onClose: onClose, onConfirm: onConfirm, onArchiveComplete: onArchiveComplete, onArchivingChange: onArchivingChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isArchiving, setIsArchiving] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const teamCount = actions.length;
    const handleClose = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'closeArchiveConfirmationModalCleanUpTeams',
            attributes: {
                teamCount: teamCount
            }
        });
        onClose();
    }, [
        onClose,
        sendAnalyticsEvent,
        teamCount
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(async ()=>{
        if (!actions.length) {
            onClose();
            return;
        }
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'confirmArchiveCleanUpTeams',
            attributes: {
                teamCount: teamCount
            }
        });
        setIsArchiving(true);
        onArchivingChange?.(actions.map((a)=>a.data.teamId));
        await Promise.all(actions.map(async (action)=>{
            await onConfirm(action);
        }));
        onArchiveComplete?.();
        onArchivingChange?.([]);
        setIsArchiving(false);
        onClose();
    }, [
        actions,
        onConfirm,
        onArchiveComplete,
        onClose,
        sendAnalyticsEvent,
        teamCount,
        onArchivingChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: "small",
        onClose: handleClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, formatMessage((0, $8N4EC.default).archiveModalTitle, {
        teamCount: teamCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, formatMessage((0, $8N4EC.default).archiveModalBodyLine1, {
        teamCount: teamCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, formatMessage((0, $8N4EC.default).archiveModalBodyLine2, {
        teamCount: teamCount,
        teamName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            weight: "bold"
        }, actions[0]?.data.displayName)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClose,
        isDisabled: isArchiving
    }, formatMessage((0, $8N4EC.default).archiveModalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: handleConfirm,
        isLoading: isArchiving
    }, formatMessage((0, $8N4EC.default).archiveModalConfirm, {
        teamCount: teamCount
    })))));
};
function $72378b4aa5766f6f$var$_temp(a) {
    return a.data.teamId;
}
module.exports["ArchiveTeamsConfirmationModal"] = $72378b4aa5766f6f$export$100d90646a4a7d9a;

});

parcelRegister("eIAKh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iW40i = parcelRequire("iW40i");


var $6KdAr = parcelRequire("6KdAr");

const $039325ca1f5b4fd2$var$messages = (0, $kSwu1.defineMessages)({
    runCleanUpTeamsAgain: {
        id: "conversation-assistant-message-actions.atlassian-team-update-archive.run-clean-up-teams-again",
        defaultMessage: "Run /clean-up-teams again"
    }
});
const $039325ca1f5b4fd2$var$isCleanUpTeamsFollowUp = (item, text)=>{
    if (item.type !== 'FOLLOW_UP') return false;
    const followUps = item.content.message.follow_ups;
    if (!followUps || followUps.length !== 1) return false;
    return followUps[0]?.text === text;
};
const $039325ca1f5b4fd2$export$90489aba497c2927 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { conversationId: conversationId, actions: actions, getReadonly: getReadonly } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getMessages: getMessages, setMessages: setMessages } = (0, $iW40i.useChatMessagesActions)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const completedTeamIdsRef = (0, $cozmU.useRef)(t1);
    let t2;
    if ($[1] !== actions || $[2] !== conversationId || $[3] !== formatMessage || $[4] !== getMessages || $[5] !== getReadonly || $[6] !== setMessages) {
        t2 = (completedActions)=>{
            if (!conversationId) return;
            completedActions.forEach((a)=>completedTeamIdsRef.current.add(a.data.teamId));
            const isLastAction = actions.every((a_0)=>completedTeamIdsRef.current.has(a_0.data.teamId) || (0, $6KdAr.isActionReadonly)(a_0, getReadonly));
            if (!isLastAction) return;
            const followUpText = formatMessage($039325ca1f5b4fd2$var$messages.runCleanUpTeamsAgain);
            const currentMessages = getMessages(conversationId);
            const dedupedMessages = currentMessages.filter((m)=>!$039325ca1f5b4fd2$var$isCleanUpTeamsFollowUp(m, followUpText));
            const followUpItem = {
                type: "FOLLOW_UP",
                content: {
                    type: "FOLLOW_UP_QUERIES",
                    message: {
                        follow_ups: [
                            {
                                type: "SYNTHETIC",
                                text: followUpText
                            }
                        ]
                    },
                    millisOffset: 0
                },
                id: Date.now()
            };
            setMessages(conversationId, [
                ...dedupedMessages,
                followUpItem
            ]);
        };
        $[1] = actions;
        $[2] = conversationId;
        $[3] = formatMessage;
        $[4] = getMessages;
        $[5] = getReadonly;
        $[6] = setMessages;
        $[7] = t2;
    } else t2 = $[7];
    const maybeAppendFollowUp = t2;
    let t3;
    if ($[8] !== maybeAppendFollowUp) {
        t3 = {
            maybeAppendFollowUp: maybeAppendFollowUp
        };
        $[8] = maybeAppendFollowUp;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ conversationId: conversationId, actions: actions, getReadonly: getReadonly })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getMessages: getMessages, setMessages: setMessages } = (0, $iW40i.useChatMessagesActions)();
    const completedTeamIdsRef = (0, $cozmU.useRef)(new Set());
    const maybeAppendFollowUp = (0, $cozmU.useCallback)((completedActions)=>{
        if (!conversationId) return;
        completedActions.forEach((a)=>completedTeamIdsRef.current.add(a.data.teamId));
        const isLastAction = actions.every((a_0)=>completedTeamIdsRef.current.has(a_0.data.teamId) || (0, $6KdAr.isActionReadonly)(a_0, getReadonly));
        if (!isLastAction) return;
        const followUpText = formatMessage($039325ca1f5b4fd2$var$messages.runCleanUpTeamsAgain);
        const currentMessages = getMessages(conversationId);
        const dedupedMessages = currentMessages.filter((m)=>!$039325ca1f5b4fd2$var$isCleanUpTeamsFollowUp(m, followUpText));
        const followUpItem = {
            type: 'FOLLOW_UP',
            content: {
                type: 'FOLLOW_UP_QUERIES',
                message: {
                    follow_ups: [
                        {
                            type: 'SYNTHETIC',
                            text: followUpText
                        }
                    ]
                },
                millisOffset: 0
            },
            id: Date.now()
        };
        setMessages(conversationId, [
            ...dedupedMessages,
            followUpItem
        ]);
    }, [
        conversationId,
        actions,
        getReadonly,
        formatMessage,
        getMessages,
        setMessages
    ]);
    return {
        maybeAppendFollowUp: maybeAppendFollowUp
    };
};
module.exports["useAppendCleanUpTeamsFollowUp"] = $039325ca1f5b4fd2$export$90489aba497c2927;

});

parcelRegister("6KdAr", function(module, exports) {
function $c5dbe5debc69f1a7$export$47c7c82f636907be(action, getReadonly) {
    return getReadonly(action) || action.data.state !== 'ACTIVE';
}
function $c5dbe5debc69f1a7$export$ad929b5725be0488(action, getStatus) {
    const status = getStatus(action);
    const actionStatus = action.status;
    const isResolved = (status)=>status === 'cancelled' || status === 'finished' || action.data.state !== 'ACTIVE';
    return isResolved(status) || isResolved(actionStatus);
}
function $c5dbe5debc69f1a7$export$6cd16eac97073ccf(action, getStatus) {
    return getStatus(action) === 'errored' || action.status === 'errored';
}
function $c5dbe5debc69f1a7$export$52f49d2ad4ccf77f(action, getStatus) {
    return getStatus(action) === 'finished' || action.status === 'finished' || action.data.state !== 'ACTIVE';
}
module.exports["isActionReadonly"] = $c5dbe5debc69f1a7$export$47c7c82f636907be;
module.exports["isActionResolved"] = $c5dbe5debc69f1a7$export$ad929b5725be0488;
module.exports["isActionErrored"] = $c5dbe5debc69f1a7$export$6cd16eac97073ccf;
module.exports["isActionFinished"] = $c5dbe5debc69f1a7$export$52f49d2ad4ccf77f;

});

parcelRegister("jzYu7", function(module, exports) {

var $8aQ9z = parcelRequire("8aQ9z");

function $7ab2e8f4f91d3cb1$export$a94a2d183d390d5e(actions, hydratedTeams) {
    return actions.map((action)=>{
        const hydratedData = hydratedTeams.get((0, $8aQ9z.toTeamAri)(action.data.teamId));
        if (hydratedData == null) return null;
        return {
            ...action,
            data: {
                ...action.data,
                ...hydratedData
            }
        };
    }).filter((action)=>action != null);
}
const $7ab2e8f4f91d3cb1$var$collator = new Intl.Collator(undefined, {
    sensitivity: 'base',
    numeric: true
});
function $7ab2e8f4f91d3cb1$export$d2d87f1880ea4cb6(actions) {
    return [
        ...actions
    ].sort((a, b)=>{
        const nameA = a.data.displayName?.trim() || '';
        const nameB = b.data.displayName?.trim() || '';
        const hasNameA = nameA.length > 0;
        const hasNameB = nameB.length > 0;
        if (hasNameA !== hasNameB) return hasNameA ? -1 : 1;
        return $7ab2e8f4f91d3cb1$var$collator.compare(nameA, nameB) || $7ab2e8f4f91d3cb1$var$collator.compare(a.data.teamId || '', b.data.teamId || '');
    });
}
module.exports["buildHydratedArchiveTeamActions"] = $7ab2e8f4f91d3cb1$export$a94a2d183d390d5e;
module.exports["sortHydratedArchiveTeamActions"] = $7ab2e8f4f91d3cb1$export$d2d87f1880ea4cb6;

});

parcelRegister("7dQPx", function(module, exports) {
const $40b819d82233f144$export$ff51939e1711d7ab = 20;
const $40b819d82233f144$export$57ebb0a7ffa166e1 = $40b819d82233f144$export$ff51939e1711d7ab + 1;
function $40b819d82233f144$export$d7fd25acc44d17ae(memberCount) {
    return memberCount > $40b819d82233f144$export$ff51939e1711d7ab ? `${$40b819d82233f144$export$ff51939e1711d7ab}+` : String(memberCount);
}
module.exports["TEAM_MEMBERS_PREVIEW_QUERY_FIRST"] = $40b819d82233f144$export$57ebb0a7ffa166e1;
module.exports["formatTeamMembersPreviewCount"] = $40b819d82233f144$export$d7fd25acc44d17ae;

});

parcelRegister("6EWj2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $31le2 = parcelRequire("31le2");


var $aRvnq = parcelRequire("aRvnq");


var $l3wuH = parcelRequire("l3wuH");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $6KdAr = parcelRequire("6KdAr");


var $6vTcx = parcelRequire("6vTcx");


var $hmuK5 = parcelRequire("hmuK5");


var $bGT0d = parcelRequire("bGT0d");

const $5c2f4e6eff02a6ff$var$INITIAL_VISIBLE_COUNT = 6;
const $5c2f4e6eff02a6ff$var$styles = {
    cardContent: "_1mT5xdRAKS _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    showMoreOrLessButton: "_0bjKvDuMRm _4c065U1Y8M _2Y7lL45zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _2OUyjtGk8v _0KLXrulfZc _1pp6NdIZbP _1eOmH6d1Zr _3gzVzLJNoT",
    showLessButtonContainer: "_4c065U2ADO _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    showMoreOrLessButtonLoading: "_1YKVNsVx3j"
};
const $5c2f4e6eff02a6ff$var$blurGradient = null;
const $5c2f4e6eff02a6ff$export$645fb210440eab5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(70);
    const { teams: teams, onSelectTeam: onSelectTeam, onRemoveTeam: onRemoveTeam, onArchive: onArchive, getStatus: getStatus, actionsCurrentlyLoading: t1, isReadOnly: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const actionsCurrentlyLoading = t3;
    const isReadOnly = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isShowingAll, setIsShowingAll] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t4;
    if ($[2] !== isShowingAll || $[3] !== teams) {
        t4 = isShowingAll ? teams : teams.slice(0, $5c2f4e6eff02a6ff$var$INITIAL_VISIBLE_COUNT);
        $[2] = isShowingAll;
        $[3] = teams;
        $[4] = t4;
    } else t4 = $[4];
    const visibleTeams = t4;
    const hiddenCount = teams.length - $5c2f4e6eff02a6ff$var$INITIAL_VISIBLE_COUNT;
    let t5;
    if ($[5] !== actionsCurrentlyLoading || $[6] !== formatMessage || $[7] !== getStatus || $[8] !== hiddenCount || $[9] !== isReadOnly || $[10] !== isShowingAll || $[11] !== onArchive || $[12] !== onRemoveTeam || $[13] !== onSelectTeam || $[14] !== sendAnalyticsEvent || $[15] !== teams || $[16] !== visibleTeams) {
        let t6;
        if ($[18] !== getStatus) {
            t6 = (team)=>!(0, $6KdAr.isActionResolved)(team, getStatus) && !(0, $6KdAr.isActionErrored)(team, getStatus);
            $[18] = getStatus;
            $[19] = t6;
        } else t6 = $[19];
        const actionableTeamsCount = teams.filter(t6).length;
        let t7;
        if ($[20] !== sendAnalyticsEvent) {
            t7 = (actionSubjectId)=>{
                sendAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId
                });
            };
            $[20] = sendAnalyticsEvent;
            $[21] = t7;
        } else t7 = $[21];
        const fireButtonClickEvent = t7;
        let t8;
        if ($[22] !== formatMessage) {
            t8 = formatMessage((0, $hmuK5.default).moreInfoTooltip);
            $[22] = formatMessage;
            $[23] = t8;
        } else t8 = $[23];
        let t9;
        if ($[24] !== onSelectTeam) {
            t9 = (team_0)=>onSelectTeam(team_0);
            $[24] = onSelectTeam;
            $[25] = t9;
        } else t9 = $[25];
        let t10;
        if ($[26] !== t8 || $[27] !== t9) {
            t10 = {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
                label: t8,
                onClick: t9
            };
            $[26] = t8;
            $[27] = t9;
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== formatMessage) {
            t11 = formatMessage((0, $hmuK5.default).archiveTeamButton);
            $[29] = formatMessage;
            $[30] = t11;
        } else t11 = $[30];
        let t12;
        if ($[31] !== onArchive) {
            t12 = (team_1)=>onArchive([
                    team_1
                ]);
            $[31] = onArchive;
            $[32] = t12;
        } else t12 = $[32];
        let t13;
        if ($[33] !== t11 || $[34] !== t12) {
            t13 = {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($31le2))),
                label: t11,
                onClick: t12
            };
            $[33] = t11;
            $[34] = t12;
            $[35] = t13;
        } else t13 = $[35];
        let t14;
        if ($[36] !== t10 || $[37] !== t13) {
            t14 = [
                t10,
                t13
            ];
            $[36] = t10;
            $[37] = t13;
            $[38] = t14;
        } else t14 = $[38];
        const teamItemHoverActions = t14;
        let t15;
        if ($[39] !== formatMessage) {
            t15 = formatMessage((0, $hmuK5.default).removeLabel);
            $[39] = formatMessage;
            $[40] = t15;
        } else t15 = $[40];
        let t16;
        if ($[41] !== onRemoveTeam) {
            t16 = async (team_2)=>await onRemoveTeam(team_2);
            $[41] = onRemoveTeam;
            $[42] = t16;
        } else t16 = $[42];
        let t17;
        if ($[43] !== t15 || $[44] !== t16) {
            t17 = [
                {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                    label: t15,
                    onClick: t16
                }
            ];
            $[43] = t15;
            $[44] = t16;
            $[45] = t17;
        } else t17 = $[45];
        const teamItemActions = t17;
        let t18;
        if ($[46] !== actionsCurrentlyLoading || $[47] !== getStatus || $[48] !== onSelectTeam || $[49] !== teamItemActions || $[50] !== teamItemHoverActions || $[51] !== visibleTeams) {
            let t19;
            if ($[53] !== actionsCurrentlyLoading || $[54] !== getStatus || $[55] !== onSelectTeam || $[56] !== teamItemActions || $[57] !== teamItemHoverActions) {
                t19 = (team_3)=>/*#__PURE__*/ $cozmU.createElement((0, $bGT0d.TeamItem), {
                        key: team_3.data.teamId,
                        team: team_3,
                        onClick: ()=>onSelectTeam(team_3),
                        actions: teamItemActions,
                        hoverActions: teamItemHoverActions,
                        isArchiving: actionsCurrentlyLoading.includes(team_3.data.teamId),
                        hasErrored: getStatus(team_3) === "errored"
                    });
                $[53] = actionsCurrentlyLoading;
                $[54] = getStatus;
                $[55] = onSelectTeam;
                $[56] = teamItemActions;
                $[57] = teamItemHoverActions;
                $[58] = t19;
            } else t19 = $[58];
            t18 = visibleTeams.map(t19);
            $[46] = actionsCurrentlyLoading;
            $[47] = getStatus;
            $[48] = onSelectTeam;
            $[49] = teamItemActions;
            $[50] = teamItemHoverActions;
            $[51] = visibleTeams;
            $[52] = t18;
        } else t18 = $[52];
        let t19;
        if ($[59] !== t18) {
            t19 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t18);
            $[59] = t18;
            $[60] = t19;
        } else t19 = $[60];
        let t20;
        if ($[61] !== actionsCurrentlyLoading || $[62] !== fireButtonClickEvent || $[63] !== formatMessage || $[64] !== hiddenCount || $[65] !== isShowingAll) {
            t20 = hiddenCount > 0 && (!isShowingAll ? /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    "_2uo31fkZ1O _1mT5xdWVPG _0Bm75GdnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VpJKa _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _1wydGW2ADO _1pp6NdYbGa"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                xcss: (0, $k12R1.cx)($5c2f4e6eff02a6ff$var$styles.showMoreOrLessButton, actionsCurrentlyLoading.length > 0 && $5c2f4e6eff02a6ff$var$styles.showMoreOrLessButtonLoading),
                onClick: ()=>{
                    fireButtonClickEvent("showMoreCleanUpTeams");
                    setIsShowingAll(true);
                },
                isDisabled: actionsCurrentlyLoading.length > 0
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                size: "small",
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage((0, $hmuK5.default).showMore, {
                count: hiddenCount
            })))) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $5c2f4e6eff02a6ff$var$styles.showLessButtonContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                xcss: (0, $k12R1.cx)($5c2f4e6eff02a6ff$var$styles.showMoreOrLessButton, actionsCurrentlyLoading.length > 0 && $5c2f4e6eff02a6ff$var$styles.showMoreOrLessButtonLoading),
                onClick: ()=>{
                    fireButtonClickEvent("showLessCleanUpTeams");
                    setIsShowingAll(false);
                },
                isDisabled: actionsCurrentlyLoading.length > 0
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                size: "small",
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage((0, $hmuK5.default).showLess, {
                count: hiddenCount
            })))));
            $[61] = actionsCurrentlyLoading;
            $[62] = fireButtonClickEvent;
            $[63] = formatMessage;
            $[64] = hiddenCount;
            $[65] = isShowingAll;
            $[66] = t20;
        } else t20 = $[66];
        let t21;
        if ($[67] !== t19 || $[68] !== t20) {
            t21 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $5c2f4e6eff02a6ff$var$styles.cardContent
            }, t19, t20);
            $[67] = t19;
            $[68] = t20;
            $[69] = t21;
        } else t21 = $[69];
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t21, !isReadOnly && /*#__PURE__*/ $cozmU.createElement((0, $6vTcx.CardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignInline: "end"
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: ()=>onArchive(teams),
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($31le2))),
            isDisabled: actionsCurrentlyLoading.length > 0 || actionableTeamsCount === 0
        }, formatMessage((0, $hmuK5.default).archiveButton, {
            teamCount: actionableTeamsCount
        })))));
        $[5] = actionsCurrentlyLoading;
        $[6] = formatMessage;
        $[7] = getStatus;
        $[8] = hiddenCount;
        $[9] = isReadOnly;
        $[10] = isShowingAll;
        $[11] = onArchive;
        $[12] = onRemoveTeam;
        $[13] = onSelectTeam;
        $[14] = sendAnalyticsEvent;
        $[15] = teams;
        $[16] = visibleTeams;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ teams: teams, onSelectTeam: onSelectTeam, onRemoveTeam: onRemoveTeam, onArchive: onArchive, getStatus: getStatus, actionsCurrentlyLoading: actionsCurrentlyLoading = [], isReadOnly: isReadOnly = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isShowingAll, setIsShowingAll] = (0, $cozmU.useState)(false);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const visibleTeams = (0, $cozmU.useMemo)(()=>isShowingAll ? teams : teams.slice(0, $5c2f4e6eff02a6ff$var$INITIAL_VISIBLE_COUNT), [
        teams,
        isShowingAll
    ]);
    const hiddenCount = teams.length - $5c2f4e6eff02a6ff$var$INITIAL_VISIBLE_COUNT;
    const actionableTeamsCount = teams.filter((team)=>!(0, $6KdAr.isActionResolved)(team, getStatus) && !(0, $6KdAr.isActionErrored)(team, getStatus)).length;
    const fireButtonClickEvent = (0, $cozmU.useCallback)((actionSubjectId)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId
        });
    }, [
        sendAnalyticsEvent
    ]);
    const teamItemHoverActions = (0, $cozmU.useMemo)(()=>[
            {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
                label: formatMessage((0, $hmuK5.default).moreInfoTooltip),
                onClick: (team_0)=>onSelectTeam(team_0)
            },
            {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($31le2))),
                label: formatMessage((0, $hmuK5.default).archiveTeamButton),
                onClick: (team_1)=>onArchive([
                        team_1
                    ])
            }
        ], [
        formatMessage,
        onArchive,
        onSelectTeam
    ]);
    const teamItemActions = (0, $cozmU.useMemo)(()=>[
            {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: formatMessage((0, $hmuK5.default).removeLabel),
                onClick: async (team_2)=>await onRemoveTeam(team_2)
            }
        ], [
        formatMessage,
        onRemoveTeam
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5c2f4e6eff02a6ff$var$styles.cardContent
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, visibleTeams.map((team_3)=>/*#__PURE__*/ $cozmU.createElement((0, $bGT0d.TeamItem), {
            key: team_3.data.teamId,
            team: team_3,
            onClick: ()=>onSelectTeam(team_3),
            actions: teamItemActions,
            hoverActions: teamItemHoverActions,
            isArchiving: actionsCurrentlyLoading.includes(team_3.data.teamId),
            hasErrored: getStatus(team_3) === 'errored'
        }))), hiddenCount > 0 && (!isShowingAll ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fkZ1O _1mT5xdWVPG _0Bm75GdnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VpJKa _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _1wydGW2ADO _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $k12R1.cx)($5c2f4e6eff02a6ff$var$styles.showMoreOrLessButton, actionsCurrentlyLoading.length > 0 && $5c2f4e6eff02a6ff$var$styles.showMoreOrLessButtonLoading),
        onClick: ()=>{
            fireButtonClickEvent('showMoreCleanUpTeams');
            setIsShowingAll(true);
        },
        isDisabled: actionsCurrentlyLoading.length > 0
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $hmuK5.default).showMore, {
        count: hiddenCount
    })))) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5c2f4e6eff02a6ff$var$styles.showLessButtonContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $k12R1.cx)($5c2f4e6eff02a6ff$var$styles.showMoreOrLessButton, actionsCurrentlyLoading.length > 0 && $5c2f4e6eff02a6ff$var$styles.showMoreOrLessButtonLoading),
        onClick: ()=>{
            fireButtonClickEvent('showLessCleanUpTeams');
            setIsShowingAll(false);
        },
        isDisabled: actionsCurrentlyLoading.length > 0
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $hmuK5.default).showLess, {
        count: hiddenCount
    })))))), !isReadOnly && /*#__PURE__*/ $cozmU.createElement((0, $6vTcx.CardFooter), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignInline: "end"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>onArchive(teams),
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($31le2))),
        isDisabled: actionsCurrentlyLoading.length > 0 || actionableTeamsCount === 0
    }, formatMessage((0, $hmuK5.default).archiveButton, {
        teamCount: actionableTeamsCount
    })))));
};
module.exports["ArchiveTeamsCardListView"] = $5c2f4e6eff02a6ff$export$645fb210440eab5c;

});

parcelRegister("jbl5e", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7Jde4 = parcelRequire("7Jde4");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $6441cad197d9e831$var$styles = {
    cardWrapper: "_0bjKvDyzSk _30huDKOeNX",
    cardContent: "_4c065U5zaO _2Y7lL45zaO"
};
const $6441cad197d9e831$export$6b08569716a540e2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ArchiveTeamsCardSkeleton() {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
            label: "",
            appearance: "gray",
            size: "medium"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $6441cad197d9e831$var$styles.cardWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6441cad197d9e831$var$styles.cardContent,
            testId: "archive-teams-card-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 140,
            height: 20,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 100,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }))))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function ArchiveTeamsCardSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $6441cad197d9e831$var$styles.cardWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6441cad197d9e831$var$styles.cardContent,
        testId: "archive-teams-card-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
        label: "",
        appearance: "gray",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 140,
        height: 20,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 100,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }))))));
};
module.exports["ArchiveTeamsCardSkeleton"] = $6441cad197d9e831$export$6b08569716a540e2;

});

parcelRegister("6ekqE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $31le2 = parcelRequire("31le2");


var $kdlgT = parcelRequire("kdlgT");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $eW61a = parcelRequire("eW61a");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $cMGrl = parcelRequire("cMGrl");


var $6vTcx = parcelRequire("6vTcx");


var $hmuK5 = parcelRequire("hmuK5");

const $40f3a8afb1b86374$var$styles = {
    content: "_0Of8r22ADO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $40f3a8afb1b86374$export$f0d14b789d2aef82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    const { team: team, onBack: onBack, onRemove: onRemove, onArchive: onArchive, cloudId: cloudId, isReadonly: t1 } = t0;
    const isReadonly = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $hmuK5.default).viewProfile);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== cloudId || $[3] !== sendAnalyticsEvent || $[4] !== team.data.teamId) {
        t3 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "viewTeamProfileCleanUpTeams",
                attributes: {
                    teamId: team.data.teamId
                }
            });
            const { onNavigate: onNavigate } = (0, $eW61a.navigateToTeamsApp)({
                type: "TEAM",
                payload: {
                    teamId: team.data.teamId
                },
                cloudId: cloudId
            });
            onNavigate();
        };
        $[2] = cloudId;
        $[3] = sendAnalyticsEvent;
        $[4] = team.data.teamId;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = {
            children: t2,
            onClick: t3
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage((0, $hmuK5.default).removeFromCleanUp);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== onRemove || $[12] !== team) {
        t6 = async ()=>await onRemove(team);
        $[11] = onRemove;
        $[12] = team;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== isReadonly || $[15] !== t5 || $[16] !== t6) {
        t7 = {
            children: t5,
            onClick: t6,
            isDisabled: isReadonly
        };
        $[14] = isReadonly;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t4 || $[19] !== t7) {
        t8 = [
            t4,
            t7
        ];
        $[18] = t4;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    const teamCardActions = t8;
    let t9;
    if ($[21] !== formatMessage) {
        t9 = formatMessage((0, $hmuK5.default).backLabel);
        $[21] = formatMessage;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== onBack || $[24] !== sendAnalyticsEvent || $[25] !== team.data.teamId) {
        t10 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "closeTeamCardCleanUpTeams",
                attributes: {
                    teamId: team.data.teamId
                }
            });
            onBack();
        };
        $[23] = onBack;
        $[24] = sendAnalyticsEvent;
        $[25] = team.data.teamId;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== t10 || $[28] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            label: t9,
            onClick: t10
        });
        $[27] = t10;
        $[28] = t9;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== cloudId || $[31] !== team || $[32] !== teamCardActions) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMGrl.TeamCard), {
            team: team,
            actions: teamCardActions,
            cloudId: cloudId
        });
        $[30] = cloudId;
        $[31] = team;
        $[32] = teamCardActions;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== t11 || $[35] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $40f3a8afb1b86374$var$styles.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t11, t12));
        $[34] = t11;
        $[35] = t12;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== formatMessage || $[38] !== isReadonly || $[39] !== onArchive || $[40] !== team) {
        t14 = !isReadonly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6vTcx.CardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignInline: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: ()=>onArchive([
                    team
                ]),
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($31le2)))
        }, formatMessage((0, $hmuK5.default).archiveButton, {
            teamCount: 1
        }))));
        $[37] = formatMessage;
        $[38] = isReadonly;
        $[39] = onArchive;
        $[40] = team;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== t13 || $[43] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t13, t14);
        $[42] = t13;
        $[43] = t14;
        $[44] = t15;
    } else t15 = $[44];
    return t15;
} : ({ team: team, onBack: onBack, onRemove: onRemove, onArchive: onArchive, cloudId: cloudId, isReadonly: isReadonly = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const teamCardActions = (0, $cozmU.useMemo)(()=>[
            {
                children: formatMessage((0, $hmuK5.default).viewProfile),
                onClick: ()=>{
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'viewTeamProfileCleanUpTeams',
                        attributes: {
                            teamId: team.data.teamId
                        }
                    });
                    const { onNavigate: onNavigate } = (0, $eW61a.navigateToTeamsApp)({
                        type: 'TEAM',
                        payload: {
                            teamId: team.data.teamId
                        },
                        cloudId: cloudId
                    });
                    onNavigate();
                }
            },
            {
                children: formatMessage((0, $hmuK5.default).removeFromCleanUp),
                onClick: async ()=>await onRemove(team),
                isDisabled: isReadonly
            }
        ], [
        formatMessage,
        onRemove,
        team,
        cloudId,
        sendAnalyticsEvent,
        isReadonly
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $40f3a8afb1b86374$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $hmuK5.default).backLabel),
        onClick: ()=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'closeTeamCardCleanUpTeams',
                attributes: {
                    teamId: team.data.teamId
                }
            });
            onBack();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMGrl.TeamCard), {
        team: team,
        actions: teamCardActions,
        cloudId: cloudId
    }))), !isReadonly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6vTcx.CardFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>onArchive([
                team
            ]),
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($31le2)))
    }, formatMessage((0, $hmuK5.default).archiveButton, {
        teamCount: 1
    })))));
};
module.exports["ArchiveTeamsCardTeamView"] = $40f3a8afb1b86374$export$f0d14b789d2aef82;

});

parcelRegister("lM1KN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7Jde4 = parcelRequire("7Jde4");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hmuK5 = parcelRequire("hmuK5");

const $cc6adb958385a618$var$styles = {
    cardWrapper: "_0bjKvDyzSk _30huDKOeNX",
    cardHeader: "_4c065U5zaO _2Y7lL45zaO",
    cardHeaderBorder: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67"
};
const $cc6adb958385a618$export$6aa22a823032b784 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { subtitle: subtitle, headerActionOverride: headerActionOverride, children: children, isExpandable: t1, testId: testId } = t0;
    const isExpandable = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(isExpandable);
    const t2 = isExpanded && $cc6adb958385a618$var$styles.cardHeaderBorder;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($cc6adb958385a618$var$styles.cardHeader, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
            label: "",
            appearance: "gray",
            size: "medium"
        });
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== formatMessage) {
        t5 = formatMessage((0, $hmuK5.default).cardTitle);
        $[3] = formatMessage;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t5);
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== subtitle) {
        t7 = subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, subtitle);
        $[7] = subtitle;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t6 || $[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, t6, t7));
        $[9] = t6;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== formatMessage || $[13] !== headerActionOverride || $[14] !== isExpandable || $[15] !== isExpanded) {
        t9 = headerActionOverride || isExpandable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
            label: isExpanded ? formatMessage((0, $hmuK5.default).collapseLabel) : formatMessage((0, $hmuK5.default).expandLabel),
            onClick: ()=>setIsExpanded($cc6adb958385a618$var$_temp)
        });
        $[12] = formatMessage;
        $[13] = headerActionOverride;
        $[14] = isExpandable;
        $[15] = isExpanded;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center",
            spread: "space-between"
        }, t8, t9);
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t3) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3,
            testId: "card-header"
        }, t10);
        $[20] = t10;
        $[21] = t3;
        $[22] = t11;
    } else t11 = $[22];
    const t12 = isExpanded && children;
    let t13;
    if ($[23] !== t11 || $[24] !== t12 || $[25] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $cc6adb958385a618$var$styles.cardWrapper,
            testId: testId
        }, t11, t12);
        $[23] = t11;
        $[24] = t12;
        $[25] = testId;
        $[26] = t13;
    } else t13 = $[26];
    return t13;
} : ({ subtitle: subtitle, headerActionOverride: headerActionOverride, children: children, isExpandable: isExpandable = false, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(isExpandable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $cc6adb958385a618$var$styles.cardWrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($cc6adb958385a618$var$styles.cardHeader, isExpanded && $cc6adb958385a618$var$styles.cardHeaderBorder),
        testId: "card-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
        label: "",
        appearance: "gray",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $hmuK5.default).cardTitle)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, subtitle))), headerActionOverride || isExpandable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        label: isExpanded ? formatMessage((0, $hmuK5.default).collapseLabel) : formatMessage((0, $hmuK5.default).expandLabel),
        onClick: ()=>setIsExpanded((prev)=>!prev)
    }))), isExpanded && children);
};
function $cc6adb958385a618$var$_temp(prev) {
    return !prev;
}
module.exports["CardWrapper"] = $cc6adb958385a618$export$6aa22a823032b784;

});

parcelRegister("hmuK5", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $53319daeab33a95c$var$message = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "atlassian-team-update-archive.card-title",
        defaultMessage: "Clean up teams"
    },
    collapseLabel: {
        id: "atlassian-team-update-archive.collapse-label",
        defaultMessage: "Collapse"
    },
    expandLabel: {
        id: "atlassian-team-update-archive.expand-label",
        defaultMessage: "Expand"
    },
    removeLabel: {
        id: "atlassian-team-update-archive.remove-label",
        defaultMessage: "Remove from clean up"
    },
    archiveButton: {
        id: "atlassian-team-update-archive.archive-button",
        defaultMessage: "{teamCount, plural, one {Archive team} other {Archive {teamCount} teams}}"
    },
    showMore: {
        id: "atlassian-team-update-archive.show-more",
        defaultMessage: "Show {count} more"
    },
    showLess: {
        id: "atlassian-team-update-archive.show-less",
        defaultMessage: "Show less"
    },
    backLabel: {
        id: "atlassian-team-update-archive.back-label",
        defaultMessage: "Back"
    },
    removeFromCleanUp: {
        id: "atlassian-team-update-archive.remove-from-clean-up",
        defaultMessage: "Remove from clean up"
    },
    moreInfoTooltip: {
        id: "atlassian-team-update-archive.more-info-tooltip",
        defaultMessage: "More info"
    },
    viewProfile: {
        id: "atlassian-team-update-archive.view-profile",
        defaultMessage: "View profile"
    },
    archiveTeamButton: {
        id: "atlassian-team-update-archive.archive-team-button",
        defaultMessage: "Archive team"
    },
    archivedSuccess: {
        id: "atlassian-team-update-archive.archived-success",
        defaultMessage: "{teamCount} {teamCount, plural, one {team} other {teams}} archived"
    },
    archiving: {
        id: "atlassian-team-update-archive.archiving",
        defaultMessage: "Archiving {teamCount} {teamCount, plural, one {team} other {teams}}"
    },
    couldNotArchive: {
        id: "atlassian-team-update-archive.could-not-archive",
        defaultMessage: "Error archiving {teamCount} {teamCount, plural, one {team} other {teams}}. Try again later."
    },
    teamDescription: {
        id: "atlassian-team-update-archive.team-description",
        defaultMessage: "{teamType} \xB7 {memberCount} {memberCount, plural, one {member} other {members}}"
    },
    teamDescriptionMembersOnly: {
        id: "atlassian-team-update-archive.team-description-members-only",
        defaultMessage: "{memberCount} {memberCount, plural, one {member} other {members}}"
    },
    errorTooltip: {
        id: "atlassian-team-update-archive.error-tooltip",
        defaultMessage: "Archive failed"
    }
});
var $53319daeab33a95c$export$2e2bcd8739ae039 = $53319daeab33a95c$var$message;
module.exports["default"] = $53319daeab33a95c$export$2e2bcd8739ae039;

});

parcelRegister("39vBG", function(module, exports) {
/**
 * @generated SignedSource<<62ca7df35924797c4423b59442159cd9>>
 * @relayHash cd6ca4ced42813fce13d5c26712c58f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cbaff40e7b9e8144e82f81f66177a2a2d8b4cea430a3a8397e4acd005c162e85
const $e13c0e01b2072768$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "projectName",
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraProject"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "boardName",
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "boardUrl"
            }
        ],
        "type": "JiraBoard"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BoardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BoardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cbaff40e7b9e8144e82f81f66177a2a2d8b4cea430a3a8397e4acd005c162e85",
            "metadata": {},
            "name": "BoardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e13c0e01b2072768$var$node.hash = "e9fcb9712b49de9e9e169801a5b67188";
var $e13c0e01b2072768$export$2e2bcd8739ae039 = $e13c0e01b2072768$var$node;
module.exports["default"] = $e13c0e01b2072768$export$2e2bcd8739ae039;

});

parcelRegister("6pXtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ac3355d140ba12f$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ac3355d140ba12f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("hWL69", function(module, exports) {

var $fRUA2 = parcelRequire("fRUA2");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/capacity-planning/custom-contribution-target/manifest.ts
var $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $fRUA2.CapacityPlanningCustomContributionTargetAriResourceOwner),
    resourceType: (0, $fRUA2.CapacityPlanningCustomContributionTargetAriResourceType),
    resourceIdSlug: "activation/{activationId}/{customContributionTargetId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        customContributionTargetId: /[a-zA-Z0-9\-]+/
    }
};
// src/capacity-planning/custom-contribution-target/index.ts
var $d10c632dda65dd2a$export$e50dfe483ea51d6e = class _CapacityPlanningCustomContributionTargetAri extends (0, $1gKSA.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get customContributionTargetId() {
        return this._customContributionTargetId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts.qualifier,
            platformQualifier: $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts.resourceOwner,
            resourceType: $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.customContributionTargetId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                customContributionTargetId: opts.customContributionTargetId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts);
        return new _CapacityPlanningCustomContributionTargetAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $d10c632dda65dd2a$var$capacityPlanningCustomContributionTargetAriStaticOpts);
        return new _CapacityPlanningCustomContributionTargetAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            customContributionTargetId: this.customContributionTargetId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._customContributionTargetId = opts.resourceIdSegmentValues.customContributionTargetId;
    }
};
module.exports["CapacityPlanningCustomContributionTargetAri"] = $d10c632dda65dd2a$export$e50dfe483ea51d6e;

});

parcelRegister("gvq7D", function(module, exports) {
const $6b885cbeb71297d5$export$ebd9610df706619e = {
    ADD_CONTRIBUTOR_WORK: 'ADD_CONTRIBUTOR_WORK',
    ADD_CONTRIBUTORS: 'ADD_CONTRIBUTORS',
    CREATE_NON_PROJECT_WORK: 'CREATE_NON_PROJECT_WORK',
    REMOVE_CONTRIBUTOR_WORK: 'REMOVE_CONTRIBUTOR_WORK',
    REMOVE_CONTRIBUTORS: 'REMOVE_CONTRIBUTORS',
    UPDATE_CONTRIBUTIONS: 'UPDATE_CONTRIBUTIONS',
    RENAME_NON_PROJECT_WORK: 'RENAME_NON_PROJECT_WORK',
    ADD_WORKS: 'ADD_WORKS',
    REMOVE_WORKS: 'REMOVE_WORKS'
};
module.exports["CapacityPlanningActionType"] = $6b885cbeb71297d5$export$ebd9610df706619e;

});

parcelRegister("jfoJN", function(module, exports) {
/**
 * @generated SignedSource<<b1658e648e8772add65d4e40ab306893>>
 * @relayHash 0dc33d5cea4519505c323d481be38bc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce77a625568783796bb04fd468769c2efb0e6bd5fb89a8b00e78d6c96faae77
const $29c00b929b3131ea$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "customContributionTargetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeCustomContributionTargets"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJiraWorkItems"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v11 = {
        "condition": "includeCustomContributionTargets",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "ids",
                        "variableName": "customContributionTargetIds"
                    }
                ],
                "concreteType": "CplsCustomContributionTarget",
                "kind": "LinkedField",
                "name": "cpls_customContributionTargetsByIds",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    v9 /*: any*/ 
                ]
            }
        ]
    }, v12 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v14 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v15 = {
        "kind": "ScalarField",
        "name": "issueTypeAvatarUrl"
    }, v16 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CapacityPlanningDataQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ 
                    ]
                },
                v11 /*: any*/ ,
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeJiraWorkItems",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CapacityPlanningDataQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ 
                    ]
                },
                v11 /*: any*/ ,
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeJiraWorkItems",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ce77a625568783796bb04fd468769c2efb0e6bd5fb89a8b00e78d6c96faae77",
            "metadata": {},
            "name": "CapacityPlanningDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$29c00b929b3131ea$var$node.hash = "8ccf6b6b40fca6179376a28d0f8f10de";
var $29c00b929b3131ea$export$2e2bcd8739ae039 = $29c00b929b3131ea$var$node;
module.exports["default"] = $29c00b929b3131ea$export$2e2bcd8739ae039;

});

parcelRegister("eGVo0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $gC2EJ = parcelRequire("gC2EJ");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $d64XA = parcelRequire("d64XA");


var $MjdYo = parcelRequire("MjdYo");

const $aadb4fdbbbd3b06d$var$AVATAR_SIZE = 24;
const $aadb4fdbbbd3b06d$var$styles = {
    gridContainer: "_3iDTPbgBM8 _2iEGP23XqY _0hPCNLDIqT _42d1HAdnbC",
    trigger: "_30huDKYbGa _2j3gqAg8pm _4c065U2ADO _2Y7lL4dnbC _3iDTPbgBM8 _2iEGP23XqY _0hPCNLDIqT _39xV02N91d _2fwxA5ecOK _0KLXrujOvk",
    avatarCell: "_2j3gqA7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    contentCell: "_2j3gqAiZR3 _2Zuz6Q2ADO",
    chevronCell: "_2j3gqA7LI7 _1UtDYzZpcK _1Znuxb1Y8M",
    actionsWrapper: "_2j3gqAg8pm _3iDTPbQ4SZ _0aFT5vbt8w _2Zuz6QFQfX"
};
const $aadb4fdbbbd3b06d$export$7c4b99cc9011b59f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PersonGroup(t0) {
    const $ = (0, $bDgLe.c)(30);
    const { group: group, user: user, isRenameGroup: t1, defaultExpanded: t2, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, workById: workById, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, hydratedUsers: hydratedUsers } = t0;
    const isRenameGroup = t1 === undefined ? false : t1;
    const defaultExpanded = t2 === undefined ? false : t2;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    let t3;
    if ($[0] !== user.name) {
        t3 = user.name?.trim() ?? "";
        $[0] = user.name;
        $[1] = t3;
    } else t3 = $[1];
    const displayName = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsExpanded($aadb4fdbbbd3b06d$var$_temp);
        $[2] = t4;
    } else t4 = $[2];
    const handleToggle = t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (e_0)=>{
            if (e_0.key === "Enter" || e_0.key === " ") {
                e_0.preventDefault();
                handleToggle();
            }
        };
        $[3] = t5;
    } else t5 = $[3];
    const handleKeyDown = t5;
    let t6;
    if ($[4] !== displayName || $[5] !== isRenameGroup || $[6] !== user.picture) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $aadb4fdbbbd3b06d$var$styles.avatarCell
        }, isRenameGroup ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            name: displayName,
            src: user.picture ?? undefined,
            size: "small"
        }));
        $[4] = displayName;
        $[5] = isRenameGroup;
        $[6] = user.picture;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== displayName) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $aadb4fdbbbd3b06d$var$styles.contentCell
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, displayName));
        $[8] = displayName;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== isExpanded) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $aadb4fdbbbd3b06d$var$styles.chevronCell
        }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }));
        $[10] = isExpanded;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== isExpanded || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $aadb4fdbbbd3b06d$var$styles.trigger,
            onClick: handleToggle,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "aria-expanded": isExpanded
        }, t6, t7, t8);
        $[12] = isExpanded;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== getStatus || $[18] !== group || $[19] !== hydratedUsers || $[20] !== isExpanded || $[21] !== onCancel || $[22] !== onConfirm || $[23] !== onSelectionChange || $[24] !== selectedKeys || $[25] !== workById) {
        t10 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $aadb4fdbbbd3b06d$var$styles.actionsWrapper
        }, group.actions.map((action)=>/*#__PURE__*/ $cozmU.createElement((0, $d64XA.ActionItem), {
                key: action.invocationId,
                action: action,
                payload: action.data,
                isChecked: selectedKeys.has(action.invocationId),
                onToggle: (checked)=>onSelectionChange(action.invocationId, checked),
                workById: workById,
                onConfirm: onConfirm,
                onCancel: onCancel,
                getStatus: getStatus,
                viewType: (0, $MjdYo.VIEW_TYPE).PEOPLE,
                hydratedUsers: hydratedUsers
            })));
        $[17] = getStatus;
        $[18] = group;
        $[19] = hydratedUsers;
        $[20] = isExpanded;
        $[21] = onCancel;
        $[22] = onConfirm;
        $[23] = onSelectionChange;
        $[24] = selectedKeys;
        $[25] = workById;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== t10 || $[28] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $aadb4fdbbbd3b06d$var$styles.gridContainer
        }, t9, t10);
        $[27] = t10;
        $[28] = t9;
        $[29] = t11;
    } else t11 = $[29];
    return t11;
} : function PersonGroup({ group: group, user: user, isRenameGroup: isRenameGroup = false, defaultExpanded: defaultExpanded = false, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, workById: workById, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus, hydratedUsers: hydratedUsers }) {
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const displayName = user.name?.trim() ?? '';
    const handleToggle = ()=>setIsExpanded((e)=>!e);
    const handleKeyDown = (e_0)=>{
        if (e_0.key === 'Enter' || e_0.key === ' ') {
            e_0.preventDefault();
            handleToggle();
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aadb4fdbbbd3b06d$var$styles.gridContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $aadb4fdbbbd3b06d$var$styles.trigger,
        onClick: handleToggle,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aadb4fdbbbd3b06d$var$styles.avatarCell
    }, isRenameGroup ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: "",
        size: "medium",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
        name: displayName,
        src: user.picture ?? undefined,
        size: "small"
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aadb4fdbbbd3b06d$var$styles.contentCell
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, displayName)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aadb4fdbbbd3b06d$var$styles.chevronCell
    }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        size: "small"
    }))), isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aadb4fdbbbd3b06d$var$styles.actionsWrapper
    }, group.actions.map((action)=>/*#__PURE__*/ $cozmU.createElement((0, $d64XA.ActionItem), {
            key: action.invocationId,
            action: action,
            payload: action.data,
            isChecked: selectedKeys.has(action.invocationId),
            onToggle: (checked)=>onSelectionChange(action.invocationId, checked),
            workById: workById,
            onConfirm: onConfirm,
            onCancel: onCancel,
            getStatus: getStatus,
            viewType: (0, $MjdYo.VIEW_TYPE).PEOPLE,
            hydratedUsers: hydratedUsers
        }))));
};
function $aadb4fdbbbd3b06d$var$_temp(e) {
    return !e;
}
module.exports["PersonGroup"] = $aadb4fdbbbd3b06d$export$7c4b99cc9011b59f;

});

parcelRegister("6URz7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $d64XA = parcelRequire("d64XA");


var $MjdYo = parcelRequire("MjdYo");


var $jVsqU = parcelRequire("jVsqU");

const $cd62a4f3d6889395$var$noWorkMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.work-view.no-work-group.non-final",
    defaultMessage: "No work item"
});
const $cd62a4f3d6889395$var$expandWorkGroupMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.capacity-planning.work-view.WorkGroup.expandWorkGroup",
    defaultMessage: "Expand work group"
});
const $cd62a4f3d6889395$var$collapseWorkGroupMessage = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.capacity-planning.work-view.WorkGroup.collapseWorkGroup",
    defaultMessage: "Collapse work group"
});
const $cd62a4f3d6889395$var$styles = {
    gridContainer: "_3iDTPbgBM8 _2iEGP2PwTR _0hPCNLDIqT _42d1HAdnbC",
    headerRow: "_2j3gqAg8pm _3iDTPbgBM8 _2iEGP2PwTR _0hPCNLDIqT _39xV02N91d",
    contentCell: "_4bt5LAnQyn _2WAcuGnQyn _2j3gqA7dHp _3B2K2Q7dHp _4c065U2ADO _4ouGXIdnbC _1EqgXlN91d _1Znuxb1Y8M _1pp6NdYbGa _42Yu6B7dHp",
    toggleButton: "_30huDKYbGa _2j3gqAg8pm _3B2K2Q7dHp _4c065U2ADO _2Y7lL4Pgdg _3iDTPbgBM8 _2iEGP2PwTR _0hPCNLDIqT _39xV02N91d _4ouGXIdnbC _2fwxA5ecOK _0KLXrujOvk",
    toggleIcon: "_2j3gqAiZR3 _3iDTPbQ4SZ _37wbyuDIqT _1UtDYzZpcK",
    actionsWrapper: "_2j3gqAg8pm _3iDTPbQ4SZ _0aFT5vbt8w _2Zuz6QFQfX",
    groupTitleText: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7"
};
const $cd62a4f3d6889395$export$3aad00ebfe229fe2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkGroup(t0) {
    const $ = (0, $bDgLe.c)(34);
    const { group: group, defaultExpanded: t1, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, workById: workById, hydratedUsers: hydratedUsers, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus } = t0;
    const defaultExpanded = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const firstPayload = group.actions.find($cd62a4f3d6889395$var$_temp)?.data ?? null;
    let t2;
    if ($[0] !== firstPayload || $[1] !== workById) {
        t2 = firstPayload ? /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
            payload: firstPayload,
            workById: workById,
            isGroupHeader: true
        }) : null;
        $[0] = firstPayload;
        $[1] = workById;
        $[2] = t2;
    } else t2 = $[2];
    const workItemNode = t2;
    let t3;
    if ($[3] !== formatMessage || $[4] !== workItemNode) {
        t3 = workItemNode ?? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cd62a4f3d6889395$var$styles.groupTitleText
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold"
        }, formatMessage($cd62a4f3d6889395$var$noWorkMessage)));
        $[3] = formatMessage;
        $[4] = workItemNode;
        $[5] = t3;
    } else t3 = $[5];
    const groupTitle = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsExpanded($cd62a4f3d6889395$var$_temp2);
        $[6] = t4;
    } else t4 = $[6];
    const handleToggle = t4;
    let t5;
    if ($[7] !== groupTitle) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cd62a4f3d6889395$var$styles.contentCell
        }, groupTitle);
        $[7] = groupTitle;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = isExpanded ? $cd62a4f3d6889395$var$collapseWorkGroupMessage : $cd62a4f3d6889395$var$expandWorkGroupMessage;
    let t7;
    if ($[9] !== formatMessage || $[10] !== t6) {
        t7 = formatMessage(t6);
        $[9] = formatMessage;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== isExpanded) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cd62a4f3d6889395$var$styles.toggleIcon
        }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }));
        $[12] = isExpanded;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== isExpanded || $[15] !== t7 || $[16] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $cd62a4f3d6889395$var$styles.toggleButton,
            onClick: handleToggle,
            "aria-expanded": isExpanded,
            "aria-label": t7
        }, t8);
        $[14] = isExpanded;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t5 || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cd62a4f3d6889395$var$styles.headerRow
        }, t5, t9);
        $[18] = t5;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== getStatus || $[22] !== group.actions || $[23] !== hydratedUsers || $[24] !== isExpanded || $[25] !== onCancel || $[26] !== onConfirm || $[27] !== onSelectionChange || $[28] !== selectedKeys || $[29] !== workById) {
        t11 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cd62a4f3d6889395$var$styles.actionsWrapper
        }, group.actions.filter($cd62a4f3d6889395$var$_temp3).map((action)=>/*#__PURE__*/ $cozmU.createElement((0, $d64XA.ActionItem), {
                key: action.invocationId,
                action: action,
                payload: action.data,
                isChecked: selectedKeys.has(action.invocationId),
                onToggle: (checked)=>onSelectionChange(action.invocationId, checked),
                workById: workById,
                hydratedUsers: hydratedUsers,
                viewType: (0, $MjdYo.VIEW_TYPE).WORK,
                onConfirm: onConfirm,
                onCancel: onCancel,
                getStatus: getStatus
            })));
        $[21] = getStatus;
        $[22] = group.actions;
        $[23] = hydratedUsers;
        $[24] = isExpanded;
        $[25] = onCancel;
        $[26] = onConfirm;
        $[27] = onSelectionChange;
        $[28] = selectedKeys;
        $[29] = workById;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== t10 || $[32] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cd62a4f3d6889395$var$styles.gridContainer
        }, t10, t11);
        $[31] = t10;
        $[32] = t11;
        $[33] = t12;
    } else t12 = $[33];
    return t12;
} : function WorkGroup({ group: group, defaultExpanded: defaultExpanded = false, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, workById: workById, hydratedUsers: hydratedUsers, onConfirm: onConfirm, onCancel: onCancel, getStatus: getStatus }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const firstPayload = group.actions.find((a)=>a.data != null)?.data ?? null;
    const workItemNode = firstPayload ? /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
        payload: firstPayload,
        workById: workById,
        isGroupHeader: true
    }) : null;
    const groupTitle = workItemNode ?? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cd62a4f3d6889395$var$styles.groupTitleText
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "bold"
    }, formatMessage($cd62a4f3d6889395$var$noWorkMessage)));
    const handleToggle = ()=>setIsExpanded((e)=>!e);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cd62a4f3d6889395$var$styles.gridContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cd62a4f3d6889395$var$styles.headerRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cd62a4f3d6889395$var$styles.contentCell
    }, groupTitle), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $cd62a4f3d6889395$var$styles.toggleButton,
        onClick: handleToggle,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(isExpanded ? $cd62a4f3d6889395$var$collapseWorkGroupMessage : $cd62a4f3d6889395$var$expandWorkGroupMessage)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cd62a4f3d6889395$var$styles.toggleIcon
    }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        size: "small"
    })))), isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cd62a4f3d6889395$var$styles.actionsWrapper
    }, group.actions.filter((a_0)=>a_0.data != null).map((action)=>/*#__PURE__*/ $cozmU.createElement((0, $d64XA.ActionItem), {
            key: action.invocationId,
            action: action,
            payload: action.data,
            isChecked: selectedKeys.has(action.invocationId),
            onToggle: (checked)=>onSelectionChange(action.invocationId, checked),
            workById: workById,
            hydratedUsers: hydratedUsers,
            viewType: (0, $MjdYo.VIEW_TYPE).WORK,
            onConfirm: onConfirm,
            onCancel: onCancel,
            getStatus: getStatus
        }))));
};
function $cd62a4f3d6889395$var$_temp3(a_0) {
    return a_0.data != null;
}
function $cd62a4f3d6889395$var$_temp2(e) {
    return !e;
}
function $cd62a4f3d6889395$var$_temp(a) {
    return a.data != null;
}
module.exports["WorkGroup"] = $cd62a4f3d6889395$export$3aad00ebfe229fe2;

});

parcelRegister("bHdyi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $dTHYM = parcelRequire("dTHYM");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $gkWsQ = parcelRequire("gkWsQ");


var $gDVnZ = parcelRequire("gDVnZ");


var $7LV0V = parcelRequire("7LV0V");


var $79yHm = parcelRequire("79yHm");

const $dfaf7f6bd5f3291f$var$DEFAULT_FORM_DATA = {
    name: '',
    description: '',
    justification: '',
    targetDate: (0, $7LV0V.emptyFocusAskTargetDateValue)(),
    commentData: '',
    links: [],
    submitter: null,
    owner: null,
    submittingTeam: null,
    receivingTeam: null,
    priority: 'MEDIUM',
    impactedWork: null
};
const $dfaf7f6bd5f3291f$export$32616e8e5a955c6a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { data: data, cloudId: cloudId, orgId: orgId, onClose: onClose, onSubmit: onSubmit, title: t1, submitLabel: t2 } = t0;
    const title = t1 === undefined ? (0, $79yHm.default).modalTitle : t1;
    const submitLabel = t2 === undefined ? (0, $79yHm.default).createButton : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== formatMessage) {
        t3 = formatMessage((0, $79yHm.default).commentPlaceholder);
        $[0] = formatMessage;
        $[1] = t3;
    } else t3 = $[1];
    const defaultComment = t3;
    let t4;
    if ($[2] !== data || $[3] !== defaultComment) {
        t4 = ()=>({
                ...data ?? $dfaf7f6bd5f3291f$var$DEFAULT_FORM_DATA,
                commentData: data?.commentData?.trim() ? data.commentData : defaultComment
            });
        $[2] = data;
        $[3] = defaultComment;
        $[4] = t4;
    } else t4 = $[4];
    const [formState, setFormState] = (0, $cozmU.useState)(t4);
    const [impactedWorkStatus, setImpactedWorkStatus] = (0, $cozmU.useState)(data?.impactedWork ? "resolving" : "idle");
    const previousDataRef = (0, $cozmU.useRef)(data);
    let t5;
    let t6;
    if ($[5] !== data || $[6] !== defaultComment) {
        t5 = ()=>{
            if (data && previousDataRef.current !== data) setFormState({
                ...data,
                commentData: data.commentData?.trim() ? data.commentData : defaultComment
            });
            previousDataRef.current = data;
        };
        t6 = [
            data,
            defaultComment
        ];
        $[5] = data;
        $[6] = defaultComment;
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useLayoutEffect)(t5, t6);
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (field, value)=>{
            setFormState((prev)=>({
                    ...prev,
                    [field]: value
                }));
        };
        $[9] = t7;
    } else t7 = $[9];
    const updateField = t7;
    const isImpactedWorkBlockingSubmit = impactedWorkStatus !== "idle" && impactedWorkStatus !== "resolved";
    let t8;
    if ($[10] !== formState.name || $[11] !== formState.submitter?.id || $[12] !== isImpactedWorkBlockingSubmit) {
        t8 = !formState.name.trim() || !formState.submitter?.id?.trim() || formState.name.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH) || isImpactedWorkBlockingSubmit;
        $[10] = formState.name;
        $[11] = formState.submitter?.id;
        $[12] = isImpactedWorkBlockingSubmit;
        $[13] = t8;
    } else t8 = $[13];
    const isSubmitDisabled = t8;
    let t9;
    if ($[14] !== formState || $[15] !== isSubmitDisabled || $[16] !== onSubmit) {
        t9 = ()=>{
            if (isSubmitDisabled) return;
            onSubmit({
                ...formState,
                name: formState.name.trim()
            });
        };
        $[14] = formState;
        $[15] = isSubmitDisabled;
        $[16] = onSubmit;
        $[17] = t9;
    } else t9 = $[17];
    const handleSubmit = t9;
    let t10;
    if ($[18] !== cloudId || $[19] !== data || $[20] !== formState || $[21] !== formatMessage || $[22] !== handleSubmit || $[23] !== isSubmitDisabled || $[24] !== onClose || $[25] !== orgId || $[26] !== submitLabel || $[27] !== title) {
        t10 = data && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: onClose,
            width: "medium",
            shouldScrollInViewport: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage(title))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handleSubmit
        }, ()=>/*#__PURE__*/ $cozmU.createElement("form", {
                onSubmit: (e)=>{
                    e.preventDefault();
                    handleSubmit();
                }
            }, /*#__PURE__*/ $cozmU.createElement((0, $gDVnZ.FocusAskFormFields), {
                formData: formState,
                onChange: updateField,
                cloudId: cloudId,
                orgId: orgId,
                fieldIdPrefix: "focus-ask-modal",
                onImpactedWorkResolutionStatusChange: setImpactedWorkStatus
            })))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $79yHm.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleSubmit,
            isDisabled: isSubmitDisabled
        }, formatMessage(submitLabel))));
        $[18] = cloudId;
        $[19] = data;
        $[20] = formState;
        $[21] = formatMessage;
        $[22] = handleSubmit;
        $[23] = isSubmitDisabled;
        $[24] = onClose;
        $[25] = orgId;
        $[26] = submitLabel;
        $[27] = title;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t10);
        $[29] = t10;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
} : ({ data: data, cloudId: cloudId, orgId: orgId, onClose: onClose, onSubmit: onSubmit, title: title = (0, $79yHm.default).modalTitle, submitLabel: submitLabel = (0, $79yHm.default).createButton })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const defaultComment = formatMessage((0, $79yHm.default).commentPlaceholder);
    const [formState, setFormState] = (0, $cozmU.useState)(()=>({
            ...data ?? $dfaf7f6bd5f3291f$var$DEFAULT_FORM_DATA,
            commentData: data?.commentData?.trim() ? data.commentData : defaultComment
        }));
    const [impactedWorkStatus, setImpactedWorkStatus] = (0, $cozmU.useState)(data?.impactedWork ? 'resolving' : 'idle');
    const previousDataRef = (0, $cozmU.useRef)(data);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (data && previousDataRef.current !== data) setFormState({
            ...data,
            commentData: data.commentData?.trim() ? data.commentData : defaultComment
        });
        previousDataRef.current = data;
    }, [
        data,
        defaultComment
    ]);
    const updateField = (0, $cozmU.useCallback)((field, value)=>{
        setFormState((prev)=>({
                ...prev,
                [field]: value
            }));
    }, []);
    const isImpactedWorkBlockingSubmit = impactedWorkStatus !== 'idle' && impactedWorkStatus !== 'resolved';
    const isSubmitDisabled = (0, $cozmU.useMemo)(()=>!formState.name.trim() || !formState.submitter?.id?.trim() || formState.name.length > (0, $gkWsQ.MAX_ASK_NAME_LENGTH) || isImpactedWorkBlockingSubmit, [
        formState.name,
        formState.submitter,
        isImpactedWorkBlockingSubmit
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if (isSubmitDisabled) return;
        onSubmit({
            ...formState,
            name: formState.name.trim()
        });
    }, [
        formState,
        isSubmitDisabled,
        onSubmit
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, data && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "medium",
        shouldScrollInViewport: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage(title))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit
    }, ()=>/*#__PURE__*/ $cozmU.createElement("form", {
            onSubmit: (e)=>{
                e.preventDefault();
                handleSubmit();
            }
        }, /*#__PURE__*/ $cozmU.createElement((0, $gDVnZ.FocusAskFormFields), {
            formData: formState,
            onChange: updateField,
            cloudId: cloudId,
            orgId: orgId,
            fieldIdPrefix: "focus-ask-modal",
            onImpactedWorkResolutionStatusChange: setImpactedWorkStatus
        })))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $79yHm.default).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSubmit,
        isDisabled: isSubmitDisabled
    }, formatMessage(submitLabel)))));
};
module.exports["FocusAskCreateModal"] = $dfaf7f6bd5f3291f$export$32616e8e5a955c6a;

});

parcelRegister("eEgoJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $79yHm = parcelRequire("79yHm");


var $eiETF = parcelRequire("eiETF");

const $9116a2b6987b7923$export$d688afa8f735de41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { value: value, onChange: onChange, fieldId: fieldId, hideLabel: t1, isCompact: t2, isDisabled: t3 } = t0;
    const hideLabel = t1 === undefined ? false : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const t4 = isCompact ? 160 : 300;
    let t5;
    if ($[0] !== fieldId || $[1] !== hideLabel || $[2] !== isDisabled || $[3] !== onChange || $[4] !== t4 || $[5] !== value) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $eiETF.EditorField), {
            name: fieldId,
            label: (0, $79yHm.default).commentFieldLabel,
            placeholder: (0, $79yHm.default).commentPlaceholder,
            value: value,
            onChange: onChange,
            hideLabel: hideLabel,
            maxHeight: t4,
            appearance: "chromeless",
            isDisabled: isDisabled
        });
        $[0] = fieldId;
        $[1] = hideLabel;
        $[2] = isDisabled;
        $[3] = onChange;
        $[4] = t4;
        $[5] = value;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ value: value, onChange: onChange, fieldId: fieldId, hideLabel: hideLabel = false, isCompact: isCompact = false, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $eiETF.EditorField), {
        name: fieldId,
        label: (0, $79yHm.default).commentFieldLabel,
        placeholder: (0, $79yHm.default).commentPlaceholder,
        value: value,
        onChange: onChange,
        hideLabel: hideLabel,
        maxHeight: isCompact ? 160 : 300,
        appearance: "chromeless",
        isDisabled: isDisabled
    });
};
module.exports["CommentField"] = $9116a2b6987b7923$export$d688afa8f735de41;

});

parcelRegister("fr9Wb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $9DzWa = parcelRequire("9DzWa");

var $dQLwo = parcelRequire("dQLwo");

var $5ZC7N = parcelRequire("5ZC7N");


var $dinVW = parcelRequire("dinVW");


var $4yg9g = parcelRequire("4yg9g");


var $79yHm = parcelRequire("79yHm");


var $8NeZ3 = parcelRequire("8NeZ3");

const $7f0b051189e25af5$var$ResolutionFeedback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { resolution: resolution } = t0;
    switch(resolution.status){
        case "idle":
            return null;
        case "resolving":
            {
                let t1;
                if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkResolving));
                    $[0] = t1;
                } else t1 = $[0];
                return t1;
            }
        case "invalidUrl":
            {
                let t1;
                if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkInvalidUrl));
                    $[1] = t1;
                } else t1 = $[1];
                return t1;
            }
        case "notFound":
            {
                let t1;
                if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkNotFound));
                    $[2] = t1;
                } else t1 = $[2];
                return t1;
            }
        case "resolved":
            {
                let t1;
                if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkResolvedSuccess));
                    $[3] = t1;
                } else t1 = $[3];
                return t1;
            }
        default:
            return null;
    }
} : ({ resolution: resolution })=>{
    switch(resolution.status){
        case 'idle':
            return null;
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkResolving));
        case 'invalidUrl':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkInvalidUrl));
        case 'notFound':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkNotFound));
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $79yHm.default).impactedWorkResolvedSuccess));
        default:
            return null;
    }
};
const $7f0b051189e25af5$export$8f8ed8d88337decd = ({ value: value, cloudId: cloudId, onValueChange: onValueChange, onResolutionStatusChange: onResolutionStatusChange, isDisabled: isDisabled = false, hideLabel: hideLabel = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const labelText = intl.formatMessage((0, $79yHm.default).impactedItemFieldLabel);
    const [inputValue, setInputValue] = (0, $cozmU.useState)(value?.link ?? '');
    const resolution = (0, $8NeZ3.useImpactedWorkResolution)(inputValue, cloudId, value);
    // Tracks whether we've already synced the resolved URL into inputValue (one-time).
    const hasSyncedResolvedUrl = (0, $cozmU.useRef)(false);
    const resolvedId = resolution.status === 'resolved' ? resolution.data.id : null;
    const resolvedLink = resolution.status === 'resolved' ? resolution.data.link : null;
    (0, $cozmU.useEffect)(()=>{
        if (resolution.status === 'resolved') {
            // One-time: sync the resolved URL into the input so the editable field shows
            // the URL rather than an empty field when the user opens the edit modal.
            if (!hasSyncedResolvedUrl.current && resolvedLink) {
                setInputValue(resolvedLink);
                hasSyncedResolvedUrl.current = true;
            }
            if (value?.id !== resolution.data.id) onValueChange(resolution.data);
            return;
        }
        // Any non-resolved state means we don't have a valid impacted item to
        // commit — clear the value.
        if (value !== null) onValueChange(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resolution.status,
        resolvedId,
        resolvedLink,
        value,
        onValueChange
    ]);
    // Notify the parent of every resolution-status change so it can gate form submission
    (0, $cozmU.useEffect)(()=>{
        onResolutionStatusChange?.(resolution.status);
    }, [
        resolution.status,
        onResolutionStatusChange
    ]);
    const isInvalidInput = resolution.status === 'invalidUrl' || resolution.status === 'notFound';
    if (hideLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        name: "impacted-work",
        value: inputValue,
        onChange: (event)=>setInputValue(event.currentTarget.value),
        placeholder: intl.formatMessage((0, $79yHm.default).impactedWorkPlaceholder),
        isInvalid: isInvalidInput,
        isDisabled: isDisabled,
        "aria-label": labelText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f0b051189e25af5$var$ResolutionFeedback, {
        resolution: resolution
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "impacted-work",
        label: labelText
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...fieldProps,
            value: inputValue,
            onChange: (event)=>setInputValue(event.currentTarget.value),
            placeholder: intl.formatMessage((0, $79yHm.default).impactedWorkPlaceholder),
            isInvalid: isInvalidInput,
            isDisabled: isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f0b051189e25af5$var$ResolutionFeedback, {
            resolution: resolution
        })))));
};
module.exports["ImpactedWorkField"] = $7f0b051189e25af5$export$8f8ed8d88337decd;

});

parcelRegister("95hQj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $kB5K2 = parcelRequire("kB5K2");


var $hpa99 = parcelRequire("hpa99");


var $gFEZF = parcelRequire("gFEZF");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $4yg9g = parcelRequire("4yg9g");


var $14vfv = parcelRequire("14vfv");


var $8eFI0 = parcelRequire("8eFI0");


var $79yHm = parcelRequire("79yHm");

const $ea038412b27856f6$var$styles = {
    section: "_39xV02N91d _4ouGXIdnbC",
    linksList: "_30huDKOeNX _0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn",
    linksEmptyState: "_30huDKOeNX _0bjKvDKxmn _2mHwu88HPE _0hPCNLDIqT _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _4kiQYAVQdk _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM _2fwxA5DIqT"
};
const $ea038412b27856f6$export$c7a4939f7cb650f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(61);
    const { links: links, onChange: onChange, isEditorOpen: isEditorOpen, onEditorOpenChange: onEditorOpenChange, canEdit: t1, isDisabled: t2 } = t0;
    const canEdit = t1 === undefined ? true : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const linkUrlFieldId = (0, $cozmU.useId)();
    const linkTextFieldId = (0, $cozmU.useId)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            text: "",
            url: ""
        };
        $[0] = t3;
    } else t3 = $[0];
    const [draft, setDraft] = (0, $cozmU.useState)(t3);
    let t4;
    if ($[1] !== links) {
        t4 = links.filter($ea038412b27856f6$var$_temp);
        $[1] = links;
        $[2] = t4;
    } else t4 = $[2];
    const visibleLinks = t4;
    const shouldShowLinks = visibleLinks.length > 0;
    const shouldRenderLinksSection = shouldShowLinks || canEdit || isEditorOpen;
    let t5;
    if ($[3] !== draft.url) {
        t5 = (0, $14vfv.isAllowedFocusAskLinkUrl)(draft.url);
        $[3] = draft.url;
        $[4] = t5;
    } else t5 = $[4];
    const isSaveDisabled = !t5;
    let t6;
    if ($[5] !== onEditorOpenChange) {
        t6 = ()=>{
            setDraft({
                text: "",
                url: ""
            });
            onEditorOpenChange(true);
        };
        $[5] = onEditorOpenChange;
        $[6] = t6;
    } else t6 = $[6];
    const handleOpenEditor = t6;
    let t7;
    if ($[7] !== onEditorOpenChange) {
        t7 = ()=>{
            setDraft({
                text: "",
                url: ""
            });
            onEditorOpenChange(false);
        };
        $[7] = onEditorOpenChange;
        $[8] = t7;
    } else t7 = $[8];
    const handleCancelEditor = t7;
    let t8;
    if ($[9] !== draft.text || $[10] !== draft.url || $[11] !== links || $[12] !== onChange || $[13] !== onEditorOpenChange) {
        t8 = ()=>{
            const nextUrl = (0, $14vfv.normalizeFocusAskLinkUrl)(draft.url);
            const nextText = draft.text.trim();
            if (!nextUrl) return;
            onChange([
                ...links,
                nextText ? {
                    url: nextUrl,
                    linkText: nextText
                } : {
                    url: nextUrl
                }
            ]);
            setDraft({
                text: "",
                url: ""
            });
            onEditorOpenChange(false);
        };
        $[9] = draft.text;
        $[10] = draft.url;
        $[11] = links;
        $[12] = onChange;
        $[13] = onEditorOpenChange;
        $[14] = t8;
    } else t8 = $[14];
    const handleSaveLink = t8;
    let t9;
    if ($[15] !== onChange || $[16] !== visibleLinks) {
        t9 = (indexToRemove)=>{
            onChange(visibleLinks.filter((_, index)=>index !== indexToRemove));
        };
        $[15] = onChange;
        $[16] = visibleLinks;
        $[17] = t9;
    } else t9 = $[17];
    const handleRemoveLink = t9;
    if (!shouldRenderLinksSection) return null;
    let t10;
    if ($[18] !== formatMessage) {
        t10 = formatMessage((0, $79yHm.default).linksSectionLabel);
        $[18] = formatMessage;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, t10);
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== canEdit || $[23] !== formatMessage || $[24] !== handleOpenEditor || $[25] !== isDisabled) {
        t12 = canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
            label: formatMessage((0, $79yHm.default).addLinkButtonLabel),
            onClick: handleOpenEditor,
            isDisabled: isDisabled
        });
        $[22] = canEdit;
        $[23] = formatMessage;
        $[24] = handleOpenEditor;
        $[25] = isDisabled;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== t11 || $[28] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center"
        }, t11, t12);
        $[27] = t11;
        $[28] = t12;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== canEdit || $[31] !== formatMessage || $[32] !== handleRemoveLink || $[33] !== shouldShowLinks || $[34] !== visibleLinks) {
        t14 = shouldShowLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.0",
            xcss: $ea038412b27856f6$var$styles.linksList
        }, visibleLinks.map((link_0, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8eFI0.FocusAskLinkRow), {
                key: `${link_0.url}-${index_0}`,
                link: link_0,
                canRemove: canEdit,
                removeLabel: formatMessage((0, $79yHm.default).removeLinkButtonLabel),
                onRemove: ()=>handleRemoveLink(index_0),
                showDivider: index_0 < visibleLinks.length - 1
            })));
        $[30] = canEdit;
        $[31] = formatMessage;
        $[32] = handleRemoveLink;
        $[33] = shouldShowLinks;
        $[34] = visibleLinks;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== draft.text || $[37] !== draft.url || $[38] !== formatMessage || $[39] !== handleCancelEditor || $[40] !== handleSaveLink || $[41] !== isDisabled || $[42] !== isEditorOpen || $[43] !== isSaveDisabled || $[44] !== linkTextFieldId || $[45] !== linkUrlFieldId) {
        t15 = isEditorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: linkUrlFieldId
        }, formatMessage((0, $79yHm.default).linkUrlFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            id: linkUrlFieldId,
            value: draft.url,
            onChange: (event)=>setDraft((prev)=>({
                        ...prev,
                        url: event.target.value
                    })),
            placeholder: formatMessage((0, $79yHm.default).linkUrlFieldPlaceholder),
            isCompact: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: linkTextFieldId
        }, formatMessage((0, $79yHm.default).linkTextFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            id: linkTextFieldId,
            value: draft.text,
            onChange: (event_0)=>setDraft((prev_0)=>({
                        ...prev_0,
                        text: event_0.target.value
                    })),
            placeholder: formatMessage((0, $79yHm.default).linkTextFieldPlaceholder),
            isCompact: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleCancelEditor
        }, formatMessage((0, $79yHm.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleSaveLink,
            isDisabled: isDisabled || isSaveDisabled
        }, formatMessage((0, $79yHm.default).saveLinkButtonLabel))));
        $[36] = draft.text;
        $[37] = draft.url;
        $[38] = formatMessage;
        $[39] = handleCancelEditor;
        $[40] = handleSaveLink;
        $[41] = isDisabled;
        $[42] = isEditorOpen;
        $[43] = isSaveDisabled;
        $[44] = linkTextFieldId;
        $[45] = linkUrlFieldId;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== canEdit || $[48] !== formatMessage || $[49] !== handleOpenEditor || $[50] !== isDisabled || $[51] !== isEditorOpen || $[52] !== shouldShowLinks) {
        t16 = !shouldShowLinks && !isEditorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ea038412b27856f6$var$styles.linksEmptyState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $79yHm.default).linksEmptyStateDescription))), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleOpenEditor,
            isDisabled: isDisabled
        }, formatMessage((0, $79yHm.default).addLinkButtonLabel)));
        $[47] = canEdit;
        $[48] = formatMessage;
        $[49] = handleOpenEditor;
        $[50] = isDisabled;
        $[51] = isEditorOpen;
        $[52] = shouldShowLinks;
        $[53] = t16;
    } else t16 = $[53];
    let t17;
    if ($[54] !== t14 || $[55] !== t15 || $[56] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t14, t15, t16);
        $[54] = t14;
        $[55] = t15;
        $[56] = t16;
        $[57] = t17;
    } else t17 = $[57];
    let t18;
    if ($[58] !== t13 || $[59] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: $ea038412b27856f6$var$styles.section
        }, t13, t17);
        $[58] = t13;
        $[59] = t17;
        $[60] = t18;
    } else t18 = $[60];
    return t18;
} : ({ links: links, onChange: onChange, isEditorOpen: isEditorOpen, onEditorOpenChange: onEditorOpenChange, canEdit: canEdit = true, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const linkUrlFieldId = (0, $cozmU.useId)();
    const linkTextFieldId = (0, $cozmU.useId)();
    const [draft, setDraft] = (0, $cozmU.useState)({
        text: '',
        url: ''
    });
    const visibleLinks = links.filter((link)=>link.url.trim());
    const shouldShowLinks = visibleLinks.length > 0;
    const shouldRenderLinksSection = shouldShowLinks || canEdit || isEditorOpen;
    const isSaveDisabled = !(0, $14vfv.isAllowedFocusAskLinkUrl)(draft.url);
    const handleOpenEditor = (0, $cozmU.useCallback)(()=>{
        setDraft({
            text: '',
            url: ''
        });
        onEditorOpenChange(true);
    }, [
        onEditorOpenChange
    ]);
    const handleCancelEditor = (0, $cozmU.useCallback)(()=>{
        setDraft({
            text: '',
            url: ''
        });
        onEditorOpenChange(false);
    }, [
        onEditorOpenChange
    ]);
    const handleSaveLink = (0, $cozmU.useCallback)(()=>{
        // Normalize the same way the modal's LinkForm does, so a bare "asd" is
        // stored (and displayed) as "http://asd/". Invalid URLs are rejected.
        const nextUrl = (0, $14vfv.normalizeFocusAskLinkUrl)(draft.url);
        const nextText = draft.text.trim();
        if (!nextUrl) return;
        onChange([
            ...links,
            nextText ? {
                url: nextUrl,
                linkText: nextText
            } : {
                url: nextUrl
            }
        ]);
        setDraft({
            text: '',
            url: ''
        });
        onEditorOpenChange(false);
    }, [
        draft.text,
        draft.url,
        links,
        onChange,
        onEditorOpenChange
    ]);
    const handleRemoveLink = (0, $cozmU.useCallback)((indexToRemove)=>{
        onChange(visibleLinks.filter((_, index)=>index !== indexToRemove));
    }, [
        onChange,
        visibleLinks
    ]);
    if (!shouldRenderLinksSection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $ea038412b27856f6$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $79yHm.default).linksSectionLabel)), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        label: formatMessage((0, $79yHm.default).addLinkButtonLabel),
        onClick: handleOpenEditor,
        isDisabled: isDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, shouldShowLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0",
        xcss: $ea038412b27856f6$var$styles.linksList
    }, visibleLinks.map((link_0, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8eFI0.FocusAskLinkRow), {
            key: `${link_0.url}-${index_0}`,
            link: link_0,
            canRemove: canEdit,
            removeLabel: formatMessage((0, $79yHm.default).removeLinkButtonLabel),
            onRemove: ()=>handleRemoveLink(index_0),
            showDivider: index_0 < visibleLinks.length - 1
        }))), isEditorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: linkUrlFieldId
    }, formatMessage((0, $79yHm.default).linkUrlFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: linkUrlFieldId,
        value: draft.url,
        onChange: (event)=>setDraft((prev)=>({
                    ...prev,
                    url: event.target.value
                })),
        placeholder: formatMessage((0, $79yHm.default).linkUrlFieldPlaceholder),
        isCompact: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: linkTextFieldId
    }, formatMessage((0, $79yHm.default).linkTextFieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: linkTextFieldId,
        value: draft.text,
        onChange: (event_0)=>setDraft((prev_0)=>({
                    ...prev_0,
                    text: event_0.target.value
                })),
        placeholder: formatMessage((0, $79yHm.default).linkTextFieldPlaceholder),
        isCompact: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancelEditor
    }, formatMessage((0, $79yHm.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSaveLink,
        isDisabled: isDisabled || isSaveDisabled
    }, formatMessage((0, $79yHm.default).saveLinkButtonLabel)))), !shouldShowLinks && !isEditorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ea038412b27856f6$var$styles.linksEmptyState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $79yHm.default).linksEmptyStateDescription))), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleOpenEditor,
        isDisabled: isDisabled
    }, formatMessage((0, $79yHm.default).addLinkButtonLabel)))));
};
function $ea038412b27856f6$var$_temp(link) {
    return link.url.trim();
}
module.exports["FocusAskLinksSection"] = $ea038412b27856f6$export$c7a4939f7cb650f1;

});

parcelRegister("gkWsQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $dQLwo = parcelRequire("dQLwo");


var $4yg9g = parcelRequire("4yg9g");


var $79yHm = parcelRequire("79yHm");

const $f35c490f62b231f5$export$e58279b6ecf400d8 = 255;
const $f35c490f62b231f5$export$bddb202a49c0685b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { value: value, onChange: onChange } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== value) {
        t1 = value.trim();
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    const isMissing = !t1;
    const isTooLong = value.length > $f35c490f62b231f5$export$e58279b6ecf400d8;
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $79yHm.default).nameFieldLabel);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage || $[5] !== isMissing || $[6] !== isTooLong || $[7] !== onChange || $[8] !== value) {
        t3 = (t4)=>{
            const { fieldProps: fieldProps } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...fieldProps,
                value: value,
                onChange: (e)=>onChange(e.target.value),
                testId: "focus-ask-name-field",
                maxLength: $f35c490f62b231f5$export$e58279b6ecf400d8,
                isInvalid: isMissing || isTooLong
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, isMissing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).bulkMissingInfo)), !isMissing && isTooLong && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).nameFieldTooLong, {
                maxLength: $f35c490f62b231f5$export$e58279b6ecf400d8
            }))));
        };
        $[4] = formatMessage;
        $[5] = isMissing;
        $[6] = isTooLong;
        $[7] = onChange;
        $[8] = value;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            label: t2,
            isRequired: true
        }, t3);
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isMissing = !value.trim();
    const isTooLong = value.length > $f35c490f62b231f5$export$e58279b6ecf400d8;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "name",
        label: formatMessage((0, $79yHm.default).nameFieldLabel),
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...fieldProps,
            value: value,
            onChange: (e)=>onChange(e.target.value),
            testId: "focus-ask-name-field",
            maxLength: $f35c490f62b231f5$export$e58279b6ecf400d8,
            isInvalid: isMissing || isTooLong
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, isMissing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).bulkMissingInfo)), !isMissing && isTooLong && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $79yHm.default).nameFieldTooLong, {
            maxLength: $f35c490f62b231f5$export$e58279b6ecf400d8
        })))));
};
module.exports["MAX_ASK_NAME_LENGTH"] = $f35c490f62b231f5$export$e58279b6ecf400d8;
module.exports["NameField"] = $f35c490f62b231f5$export$bddb202a49c0685b;

});

parcelRegister("ewvjY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dUI0h = parcelRequire("dUI0h");


var $2SuBW = parcelRequire("2SuBW");


var $1tj8s = parcelRequire("1tj8s");


var $gsQhG = parcelRequire("gsQhG");


var $5yfjd = parcelRequire("5yfjd");


var $14iVz = parcelRequire("14iVz");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $79yHm = parcelRequire("79yHm");

const $cb78230187f2d238$var$priorityIcons = {
    LOW: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5yfjd))), {
        label: "",
        color: "var(--ds-icon-information, #357DE8)"
    }),
    MEDIUM: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($14iVz))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    }),
    HIGH: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1tj8s))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }),
    HIGHEST: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gsQhG))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }),
    CRITICAL: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2SuBW))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    })
};
const $cb78230187f2d238$var$COMPACT_CONTROL_HEIGHT = '2.5rem';
const $cb78230187f2d238$var$styles = {
    compactSubtleControl: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0jFU0VF6tL _4ouGXIdnbC _1eOmH6o126"
};
const $cb78230187f2d238$var$compactSubtleSelectStyles = {
    container: (base)=>({
            ...base,
            width: '100%',
            height: $cb78230187f2d238$var$COMPACT_CONTROL_HEIGHT,
            minWidth: 0
        }),
    control: (base)=>({
            ...base,
            alignItems: 'center',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            cursor: 'pointer',
            height: $cb78230187f2d238$var$COMPACT_CONTROL_HEIGHT,
            minHeight: $cb78230187f2d238$var$COMPACT_CONTROL_HEIGHT,
            width: '100%',
            '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none'
            }
        }),
    valueContainer: (base)=>({
            ...base,
            alignItems: 'center',
            display: 'flex',
            height: $cb78230187f2d238$var$COMPACT_CONTROL_HEIGHT,
            minWidth: 0,
            paddingTop: "var(--ds-space-0, 0px)",
            paddingBottom: "var(--ds-space-0, 0px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-050, 4px)"
        }),
    input: (base)=>({
            ...base,
            marginTop: "var(--ds-space-0, 0px)",
            marginBottom: "var(--ds-space-0, 0px)",
            paddingTop: "var(--ds-space-0, 0px)",
            paddingBottom: "var(--ds-space-0, 0px)"
        }),
    singleValue: (base)=>({
            ...base,
            marginLeft: "var(--ds-space-0, 0px)",
            marginRight: "var(--ds-space-0, 0px)",
            maxWidth: '100%'
        }),
    indicatorsContainer: (base)=>({
            ...base,
            alignItems: 'center',
            height: $cb78230187f2d238$var$COMPACT_CONTROL_HEIGHT
        }),
    dropdownIndicator: (base)=>({
            ...base,
            paddingTop: "var(--ds-space-050, 4px)",
            paddingRight: "var(--ds-space-075, 6px)",
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-075, 6px)"
        })
};
const $cb78230187f2d238$export$f1adf0a84590c483 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { value: value, onChange: onChange, hideLabel: t1, isCompact: t2, width: t3, appearance: appearance, isDisabled: t4 } = t0;
    const hideLabel = t1 === undefined ? false : t1;
    const isCompact = t2 === undefined ? false : t2;
    const width = t3 === undefined ? "100%" : t3;
    const isDisabled = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== formatMessage) {
        t5 = formatMessage((0, $79yHm.default).priorityFieldLabel);
        $[0] = formatMessage;
        $[1] = t5;
    } else t5 = $[1];
    const labelText = t5;
    let t6;
    if ($[2] !== formatMessage) {
        t6 = formatMessage((0, $79yHm.default).priorityLow);
        $[2] = formatMessage;
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== t6) {
        t7 = {
            label: t6,
            value: "LOW"
        };
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage((0, $79yHm.default).priorityMedium);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = {
            label: t8,
            value: "MEDIUM"
        };
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== formatMessage) {
        t10 = formatMessage((0, $79yHm.default).priorityHigh);
        $[10] = formatMessage;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== t10) {
        t11 = {
            label: t10,
            value: "HIGH"
        };
        $[12] = t10;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== formatMessage) {
        t12 = formatMessage((0, $79yHm.default).priorityHighest);
        $[14] = formatMessage;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12) {
        t13 = {
            label: t12,
            value: "HIGHEST"
        };
        $[16] = t12;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== formatMessage) {
        t14 = formatMessage((0, $79yHm.default).priorityCritical);
        $[18] = formatMessage;
        $[19] = t14;
    } else t14 = $[19];
    let t15;
    if ($[20] !== t14) {
        t15 = {
            label: t14,
            value: "CRITICAL"
        };
        $[20] = t14;
        $[21] = t15;
    } else t15 = $[21];
    let t16;
    if ($[22] !== t11 || $[23] !== t13 || $[24] !== t15 || $[25] !== t7 || $[26] !== t9) {
        t16 = [
            t7,
            t9,
            t11,
            t13,
            t15
        ];
        $[22] = t11;
        $[23] = t13;
        $[24] = t15;
        $[25] = t7;
        $[26] = t9;
        $[27] = t16;
    } else t16 = $[27];
    const priorityOptions = t16;
    let t17;
    if ($[28] !== priorityOptions || $[29] !== value) {
        t17 = priorityOptions.find((o)=>o.value === value) ?? priorityOptions[1];
        $[28] = priorityOptions;
        $[29] = value;
        $[30] = t17;
    } else t17 = $[30];
    const selectedPriority = t17;
    const formatPriorityOptionLabel = $cb78230187f2d238$var$_temp;
    let t18;
    if ($[31] !== onChange) {
        t18 = (selected)=>onChange(selected?.value ?? "MEDIUM");
        $[31] = onChange;
        $[32] = t18;
    } else t18 = $[32];
    const t19 = isCompact ? "compact" : "default";
    const t20 = isCompact && appearance === "subtle" ? $cb78230187f2d238$var$compactSubtleSelectStyles : undefined;
    const t21 = hideLabel ? labelText : undefined;
    let t22;
    if ($[33] !== appearance || $[34] !== isDisabled || $[35] !== priorityOptions || $[36] !== selectedPriority || $[37] !== t18 || $[38] !== t19 || $[39] !== t20 || $[40] !== t21 || $[41] !== width) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
            options: priorityOptions,
            value: selectedPriority,
            onChange: t18,
            formatOptionLabel: formatPriorityOptionLabel,
            testId: "focus-ask-priority-field",
            spacing: t19,
            width: width,
            appearance: appearance,
            styles: t20,
            "aria-label": t21,
            isDisabled: isDisabled
        });
        $[33] = appearance;
        $[34] = isDisabled;
        $[35] = priorityOptions;
        $[36] = selectedPriority;
        $[37] = t18;
        $[38] = t19;
        $[39] = t20;
        $[40] = t21;
        $[41] = width;
        $[42] = t22;
    } else t22 = $[42];
    const select = t22;
    let t23;
    if ($[43] !== appearance || $[44] !== isCompact || $[45] !== isDisabled || $[46] !== select) {
        t23 = isCompact && appearance === "subtle" && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cb78230187f2d238$var$styles.compactSubtleControl
        }, select) : select;
        $[43] = appearance;
        $[44] = isCompact;
        $[45] = isDisabled;
        $[46] = select;
        $[47] = t23;
    } else t23 = $[47];
    const field = t23;
    let t24;
    if ($[48] !== field || $[49] !== hideLabel || $[50] !== labelText) {
        t24 = hideLabel ? field : /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: "priority",
            label: labelText
        }, ()=>field);
        $[48] = field;
        $[49] = hideLabel;
        $[50] = labelText;
        $[51] = t24;
    } else t24 = $[51];
    return t24;
} : ({ value: value, onChange: onChange, hideLabel: hideLabel = false, isCompact: isCompact = false, width: width = '100%', appearance: appearance, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelText = formatMessage((0, $79yHm.default).priorityFieldLabel);
    const priorityOptions = (0, $cozmU.useMemo)(()=>[
            {
                label: formatMessage((0, $79yHm.default).priorityLow),
                value: 'LOW'
            },
            {
                label: formatMessage((0, $79yHm.default).priorityMedium),
                value: 'MEDIUM'
            },
            {
                label: formatMessage((0, $79yHm.default).priorityHigh),
                value: 'HIGH'
            },
            {
                label: formatMessage((0, $79yHm.default).priorityHighest),
                value: 'HIGHEST'
            },
            {
                label: formatMessage((0, $79yHm.default).priorityCritical),
                value: 'CRITICAL'
            }
        ], [
        formatMessage
    ]);
    const selectedPriority = (0, $cozmU.useMemo)(()=>priorityOptions.find((o)=>o.value === value) ?? priorityOptions[1], [
        value,
        priorityOptions
    ]);
    const formatPriorityOptionLabel = (option, _meta)=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            role: "none",
            justifyContent: "center",
            alignItems: "center"
        }, $cb78230187f2d238$var$priorityIcons[option.value]), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, option.label));
    const select = /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        options: priorityOptions,
        value: selectedPriority,
        onChange: (selected)=>onChange(selected?.value ?? 'MEDIUM'),
        formatOptionLabel: formatPriorityOptionLabel,
        testId: "focus-ask-priority-field",
        spacing: isCompact ? 'compact' : 'default',
        width: width,
        appearance: appearance,
        styles: isCompact && appearance === 'subtle' ? $cb78230187f2d238$var$compactSubtleSelectStyles : undefined,
        "aria-label": hideLabel ? labelText : undefined,
        isDisabled: isDisabled
    });
    const field = isCompact && appearance === 'subtle' && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cb78230187f2d238$var$styles.compactSubtleControl
    }, select) : select;
    return hideLabel ? field : /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
        name: "priority",
        label: labelText
    }, ()=>field);
};
function $cb78230187f2d238$var$_temp(option, _meta) {
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        role: "none",
        justifyContent: "center",
        alignItems: "center"
    }, $cb78230187f2d238$var$priorityIcons[option.value]), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, option.label));
}
module.exports["PriorityField"] = $cb78230187f2d238$export$f1adf0a84590c483;

});

parcelRegister("5R7bA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dUI0h = parcelRequire("dUI0h");


var $iMnC5 = parcelRequire("iMnC5");


var $24tIi = parcelRequire("24tIi");

var $f1uNX = parcelRequire("f1uNX");

function $fc043094bf8e2344$var$teamOptionToData(team) {
    const id = team.id;
    const name = team.name?.trim() ? team.name.trim() : id;
    const avatarUrl = team.avatarUrl;
    return avatarUrl ? {
        id: id,
        name: name,
        avatarUrl: avatarUrl
    } : {
        id: id,
        name: name
    };
}
const $fc043094bf8e2344$var$styles = {
    compactSubtleControl: "_0bjKvDKxmn _1eOmH6o126"
};
const $fc043094bf8e2344$var$COMPACT_CONTROL_HEIGHT = '2.5rem';
const $fc043094bf8e2344$export$8b8af6aee5e099e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { name: name, label: label, placeholder: placeholder, cloudId: cloudId, orgId: orgId, value: value, onChange: onChange, isRequired: isRequired, fieldId: fieldId, isDisabled: t1, isClearable: t2, hideLabel: t3, isCompact: t4, width: t5, appearance: appearance } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isClearable = t2 === undefined ? true : t2;
    const hideLabel = t3 === undefined ? false : t3;
    const isCompact = t4 === undefined ? false : t4;
    const width = t5 === undefined ? "100%" : t5;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t6;
    if ($[0] !== formatMessage || $[1] !== label) {
        t6 = formatMessage(label);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t6;
    } else t6 = $[2];
    const labelText = t6;
    let t7;
    if ($[3] !== onChange) {
        t7 = (selected)=>{
            if (!selected || Array.isArray(selected)) {
                onChange(null);
                return;
            }
            if ((0, $f1uNX.isTeam)(selected)) {
                onChange($fc043094bf8e2344$var$teamOptionToData(selected));
                return;
            }
            onChange(null);
        };
        $[3] = onChange;
        $[4] = t7;
    } else t7 = $[4];
    const handleChange = t7;
    const pickerKey = `${fieldId}-${value?.id ?? "empty"}`;
    const t8 = fieldId ?? "";
    const t9 = isCompact ? $fc043094bf8e2344$var$COMPACT_CONTROL_HEIGHT : undefined;
    const t10 = isCompact ? $fc043094bf8e2344$var$COMPACT_CONTROL_HEIGHT : undefined;
    const t11 = appearance === "subtle";
    let t12;
    if ($[5] !== formatMessage || $[6] !== placeholder) {
        t12 = formatMessage(placeholder);
        $[5] = formatMessage;
        $[6] = placeholder;
        $[7] = t12;
    } else t12 = $[7];
    const t13 = hideLabel ? labelText : undefined;
    let t14;
    if ($[8] !== value) {
        t14 = value ? {
            id: value.id,
            type: "team"
        } : undefined;
        $[8] = value;
        $[9] = t14;
    } else t14 = $[9];
    let t15;
    if ($[10] !== cloudId || $[11] !== handleChange || $[12] !== isClearable || $[13] !== isCompact || $[14] !== isDisabled || $[15] !== isRequired || $[16] !== orgId || $[17] !== pickerKey || $[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t8 || $[24] !== t9 || $[25] !== width) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $24tIi.default), {
            key: pickerKey,
            fieldId: t8,
            productKey: "people",
            siteId: cloudId,
            orgId: orgId,
            width: width,
            height: t9,
            minHeight: t10,
            noBorder: isCompact,
            subtle: t11,
            includeGroups: false,
            includeUsers: false,
            includeTeams: true,
            verifiedTeams: false,
            placeholder: t12,
            placeholderAvatar: "team",
            isClearable: isClearable,
            isDisabled: isDisabled,
            ariaLabel: t13,
            required: isRequired,
            prefetch: true,
            defaultValue: t14,
            onChange: handleChange,
            maxOptions: 10
        });
        $[10] = cloudId;
        $[11] = handleChange;
        $[12] = isClearable;
        $[13] = isCompact;
        $[14] = isDisabled;
        $[15] = isRequired;
        $[16] = orgId;
        $[17] = pickerKey;
        $[18] = t10;
        $[19] = t11;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t8;
        $[24] = t9;
        $[25] = width;
        $[26] = t15;
    } else t15 = $[26];
    const smartUserPicker = t15;
    let t16;
    if ($[27] !== appearance || $[28] !== isCompact || $[29] !== isDisabled || $[30] !== smartUserPicker) {
        t16 = isCompact && appearance === "subtle" && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $fc043094bf8e2344$var$styles.compactSubtleControl
        }, smartUserPicker) : smartUserPicker;
        $[27] = appearance;
        $[28] = isCompact;
        $[29] = isDisabled;
        $[30] = smartUserPicker;
        $[31] = t16;
    } else t16 = $[31];
    const picker = t16;
    if (hideLabel) return picker;
    let t17;
    if ($[32] !== picker) {
        t17 = ()=>picker;
        $[32] = picker;
        $[33] = t17;
    } else t17 = $[33];
    let t18;
    if ($[34] !== isRequired || $[35] !== labelText || $[36] !== name || $[37] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: name,
            label: labelText,
            isRequired: isRequired
        }, t17);
        $[34] = isRequired;
        $[35] = labelText;
        $[36] = name;
        $[37] = t17;
        $[38] = t18;
    } else t18 = $[38];
    return t18;
} : ({ name: name, label: label, placeholder: placeholder, cloudId: cloudId, orgId: orgId, value: value, onChange: onChange, isRequired: isRequired, fieldId: fieldId, isDisabled: isDisabled = false, isClearable: isClearable = true, hideLabel: hideLabel = false, isCompact: isCompact = false, width: width = '100%', appearance: appearance })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelText = formatMessage(label);
    const handleChange = (selected)=>{
        if (!selected || Array.isArray(selected)) {
            onChange(null);
            return;
        }
        if ((0, $f1uNX.isTeam)(selected)) {
            onChange($fc043094bf8e2344$var$teamOptionToData(selected));
            return;
        }
        onChange(null);
    };
    const pickerKey = `${fieldId}-${value?.id ?? 'empty'}`;
    const smartUserPicker = /*#__PURE__*/ $cozmU.createElement((0, $24tIi.default), {
        key: pickerKey,
        fieldId: fieldId ?? '',
        productKey: "people",
        siteId: cloudId,
        orgId: orgId,
        width: width,
        height: isCompact ? $fc043094bf8e2344$var$COMPACT_CONTROL_HEIGHT : undefined,
        minHeight: isCompact ? $fc043094bf8e2344$var$COMPACT_CONTROL_HEIGHT : undefined,
        noBorder: isCompact,
        subtle: appearance === 'subtle',
        includeGroups: false,
        includeUsers: false,
        includeTeams: true,
        verifiedTeams: false,
        placeholder: formatMessage(placeholder),
        placeholderAvatar: "team",
        isClearable: isClearable,
        isDisabled: isDisabled,
        ariaLabel: hideLabel ? labelText : undefined,
        required: isRequired,
        prefetch: true,
        defaultValue: value ? {
            id: value.id,
            type: 'team'
        } : undefined,
        onChange: handleChange,
        maxOptions: 10
    });
    const picker = isCompact && appearance === 'subtle' && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $fc043094bf8e2344$var$styles.compactSubtleControl
    }, smartUserPicker) : smartUserPicker;
    if (hideLabel) return picker;
    return /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
        name: name,
        label: labelText,
        isRequired: isRequired
    }, ()=>picker);
};
module.exports["TeamPickerField"] = $fc043094bf8e2344$export$8b8af6aee5e099e;

});

parcelRegister("ljAgM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dUI0h = parcelRequire("dUI0h");


var $iMnC5 = parcelRequire("iMnC5");


var $24tIi = parcelRequire("24tIi");


var $hkGKX = parcelRequire("hkGKX");

function $fca10f710d6bf1cb$var$isUserOption(option) {
    return option?.type === 'user' || option?.type === 'external_user';
}
function $fca10f710d6bf1cb$var$optionToFocusAskUser(option) {
    if (!option || !$fca10f710d6bf1cb$var$isUserOption(option)) return null;
    const id = (0, $hkGKX.resourceIdFromIdentityAri)(option.id, 'user');
    const name = option.name?.trim() ? option.name.trim() : id;
    const avatarUrl = option.avatarUrl;
    return avatarUrl ? {
        id: id,
        name: name,
        avatarUrl: avatarUrl
    } : {
        id: id,
        name: name
    };
}
const $fca10f710d6bf1cb$var$styles = {
    compactSubtleControl: "_0bjKvDKxmn _1eOmH6o126"
};
const $fca10f710d6bf1cb$var$COMPACT_CONTROL_HEIGHT = '2.5rem';
const $fca10f710d6bf1cb$export$28330f131a0f5a7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { name: name, label: label, placeholder: placeholder, cloudId: cloudId, value: value, onChange: onChange, isRequired: isRequired, fieldId: fieldId, isDisabled: t1, isClearable: t2, hideLabel: t3, isCompact: t4, width: t5, appearance: appearance } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isClearable = t2 === undefined ? true : t2;
    const hideLabel = t3 === undefined ? false : t3;
    const isCompact = t4 === undefined ? false : t4;
    const width = t5 === undefined ? "100%" : t5;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t6;
    if ($[0] !== formatMessage || $[1] !== label) {
        t6 = formatMessage(label);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t6;
    } else t6 = $[2];
    const labelText = t6;
    let t7;
    if ($[3] !== value) {
        t7 = value ? (0, $hkGKX.resourceIdFromIdentityAri)(value.id, "user") : undefined;
        $[3] = value;
        $[4] = t7;
    } else t7 = $[4];
    const pickerUserId = t7;
    const [selectedUser, setSelectedUser] = (0, $cozmU.useState)(undefined);
    const pickerKey = `${fieldId}-${pickerUserId ?? "empty"}`;
    let t8;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setSelectedUser(undefined);
        };
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] !== pickerUserId) {
        t9 = [
            pickerUserId
        ];
        $[6] = pickerUserId;
        $[7] = t9;
    } else t9 = $[7];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[8] !== pickerUserId) {
        t10 = pickerUserId ? {
            id: pickerUserId,
            type: "user"
        } : undefined;
        $[8] = pickerUserId;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== formatMessage || $[11] !== placeholder) {
        t11 = formatMessage(placeholder);
        $[10] = formatMessage;
        $[11] = placeholder;
        $[12] = t11;
    } else t11 = $[12];
    const t12 = isCompact ? $fca10f710d6bf1cb$var$COMPACT_CONTROL_HEIGHT : undefined;
    const t13 = isCompact ? $fca10f710d6bf1cb$var$COMPACT_CONTROL_HEIGHT : undefined;
    const t14 = appearance === "subtle";
    const t15 = hideLabel ? labelText : undefined;
    let t16;
    if ($[13] !== onChange) {
        t16 = (newValue)=>{
            const next = newValue;
            setSelectedUser(next && $fca10f710d6bf1cb$var$isUserOption(next) ? next : undefined);
            onChange($fca10f710d6bf1cb$var$optionToFocusAskUser(next ?? null));
        };
        $[13] = onChange;
        $[14] = t16;
    } else t16 = $[14];
    let t17;
    if ($[15] !== cloudId || $[16] !== fieldId || $[17] !== isClearable || $[18] !== isCompact || $[19] !== isDisabled || $[20] !== isRequired || $[21] !== pickerKey || $[22] !== selectedUser || $[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== t14 || $[28] !== t15 || $[29] !== t16 || $[30] !== width) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $24tIi.default), {
            key: pickerKey,
            fieldId: fieldId,
            defaultValue: t10,
            isClearable: isClearable,
            isDisabled: isDisabled,
            placeholder: t11,
            prefetch: true,
            productKey: "people",
            siteId: cloudId,
            width: width,
            height: t12,
            minHeight: t13,
            noBorder: isCompact,
            subtle: t14,
            ariaLabel: t15,
            required: isRequired,
            includeGroups: false,
            includeTeams: false,
            value: selectedUser,
            onChange: t16,
            maxOptions: 10
        });
        $[15] = cloudId;
        $[16] = fieldId;
        $[17] = isClearable;
        $[18] = isCompact;
        $[19] = isDisabled;
        $[20] = isRequired;
        $[21] = pickerKey;
        $[22] = selectedUser;
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
        $[28] = t15;
        $[29] = t16;
        $[30] = width;
        $[31] = t17;
    } else t17 = $[31];
    const smartUserPicker = t17;
    let t18;
    if ($[32] !== appearance || $[33] !== isCompact || $[34] !== isDisabled || $[35] !== smartUserPicker) {
        t18 = isCompact && appearance === "subtle" && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $fca10f710d6bf1cb$var$styles.compactSubtleControl
        }, smartUserPicker) : smartUserPicker;
        $[32] = appearance;
        $[33] = isCompact;
        $[34] = isDisabled;
        $[35] = smartUserPicker;
        $[36] = t18;
    } else t18 = $[36];
    const picker = t18;
    if (hideLabel) return picker;
    let t19;
    if ($[37] !== picker) {
        t19 = ()=>picker;
        $[37] = picker;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] !== isRequired || $[40] !== labelText || $[41] !== name || $[42] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: name,
            label: labelText,
            isRequired: isRequired
        }, t19);
        $[39] = isRequired;
        $[40] = labelText;
        $[41] = name;
        $[42] = t19;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
} : ({ name: name, label: label, placeholder: placeholder, cloudId: cloudId, value: value, onChange: onChange, isRequired: isRequired, fieldId: fieldId, isDisabled: isDisabled = false, isClearable: isClearable = true, hideLabel: hideLabel = false, isCompact: isCompact = false, width: width = '100%', appearance: appearance })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelText = formatMessage(label);
    const pickerUserId = value ? (0, $hkGKX.resourceIdFromIdentityAri)(value.id, 'user') : undefined;
    const [selectedUser, setSelectedUser] = (0, $cozmU.useState)(undefined);
    const pickerKey = `${fieldId}-${pickerUserId ?? 'empty'}`;
    (0, $cozmU.useEffect)(()=>{
        setSelectedUser(undefined);
    }, [
        pickerUserId
    ]);
    const smartUserPicker = /*#__PURE__*/ $cozmU.createElement((0, $24tIi.default), {
        key: pickerKey,
        fieldId: fieldId,
        defaultValue: pickerUserId ? {
            id: pickerUserId,
            type: 'user'
        } : undefined,
        isClearable: isClearable,
        isDisabled: isDisabled,
        placeholder: formatMessage(placeholder),
        prefetch: true,
        productKey: "people",
        siteId: cloudId,
        width: width,
        height: isCompact ? $fca10f710d6bf1cb$var$COMPACT_CONTROL_HEIGHT : undefined,
        minHeight: isCompact ? $fca10f710d6bf1cb$var$COMPACT_CONTROL_HEIGHT : undefined,
        noBorder: isCompact,
        subtle: appearance === 'subtle',
        ariaLabel: hideLabel ? labelText : undefined,
        required: isRequired,
        includeGroups: false,
        includeTeams: false,
        value: selectedUser,
        onChange: (newValue)=>{
            const next = newValue;
            setSelectedUser(next && $fca10f710d6bf1cb$var$isUserOption(next) ? next : undefined);
            onChange($fca10f710d6bf1cb$var$optionToFocusAskUser(next ?? null));
        },
        maxOptions: 10
    });
    const picker = isCompact && appearance === 'subtle' && !isDisabled ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $fca10f710d6bf1cb$var$styles.compactSubtleControl
    }, smartUserPicker) : smartUserPicker;
    if (hideLabel) return picker;
    return /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
        name: name,
        label: labelText,
        isRequired: isRequired
    }, ()=>picker);
};
module.exports["UserPickerField"] = $fca10f710d6bf1cb$export$28330f131a0f5a7e;

});

parcelRegister("6W6xO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $9qyl6 = parcelRequire("9qyl6");


var $79yHm = parcelRequire("79yHm");

const $aac8f6d83e138e81$var$styles = {
    cardHoverShadow: "_0bjKvDyzSk _23rrnHF92K _3fSdSTGk8v"
};
const $aac8f6d83e138e81$export$ea0d31676376d00d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $79yHm.default).cardTitle);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $aac8f6d83e138e81$var$styles.cardHoverShadow
        }, /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
            isExpandable: true,
            isTitleBold: true,
            title: t1,
            product: "focus-ask"
        }, children));
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $aac8f6d83e138e81$var$styles.cardHoverShadow
    }, /*#__PURE__*/ $cozmU.createElement((0, $9qyl6.ActionCardWrapper), {
        isExpandable: true,
        isTitleBold: true,
        title: formatMessage((0, $79yHm.default).cardTitle),
        product: "focus-ask"
    }, children));
};
module.exports["FocusAskActionCardWrapper"] = $aac8f6d83e138e81$export$ea0d31676376d00d;

});

parcelRegister("79yHm", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $5d35429e2e70a426$var$messages = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.focus-ask-create.card-title",
        defaultMessage: "Create ask"
    },
    modalTitle: {
        id: "conversation-assistant-message-actions.focus-ask-create.modal-title",
        defaultMessage: "Create"
    },
    nameFieldTooLong: {
        id: "conversation-assistant-message-actions.focus-ask-create.name-field-too-long",
        defaultMessage: "Name must be less than or equal to {maxLength} characters"
    },
    nameFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.name-field-label",
        defaultMessage: "Name"
    },
    priorityFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.priority-field-label",
        defaultMessage: "Priority"
    },
    detailsSectionLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.detailsSectionLabel",
        defaultMessage: "Details"
    },
    createButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.create-button",
        defaultMessage: "Create"
    },
    cancelButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.cancel-button",
        defaultMessage: "Cancel"
    },
    descriptionFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.description-field-label",
        defaultMessage: "Description"
    },
    descriptionEditorPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.description-editor-placeholder",
        defaultMessage: "What needs to be done?"
    },
    justificationFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.justification-field-label",
        defaultMessage: "Justification"
    },
    justificationEditorPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.justification-editor-placeholder",
        defaultMessage: "Why do we need it?"
    },
    refineButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.refine-button",
        defaultMessage: "Refine"
    },
    targetDateFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.target-date-field-label",
        defaultMessage: "Target date"
    },
    targetDatePickerClear: {
        id: "conversation-assistant-message-actions.focus-ask-create.target-date-picker-clear",
        defaultMessage: "Clear target date"
    },
    targetDatePickerOpenCalendar: {
        id: "conversation-assistant-message-actions.focus-ask-create.target-date-picker-open-calendar",
        defaultMessage: "Open calendar"
    },
    impactedItemLinkLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-item-link-label",
        defaultMessage: "View impacted work item"
    },
    impactedItemFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-item-field-label",
        defaultMessage: "Impacted item"
    },
    commentFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.comment-field-label",
        defaultMessage: "Comment"
    },
    commentPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.comment-placeholder",
        defaultMessage: "Add a comment"
    },
    linkFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.link-field-label",
        defaultMessage: "Link"
    },
    linksSectionLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.linksSectionLabel",
        defaultMessage: "Links"
    },
    addLinkButtonLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.addLinkButtonLabel",
        defaultMessage: "Add link"
    },
    removeLinkButtonLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.removeLinkButtonLabel",
        defaultMessage: "Remove link"
    },
    linksEmptyStateDescription: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.linksEmptyStateDescription",
        defaultMessage: "Bring together the content needed to understand an ask"
    },
    linkUrlFieldLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.linkUrlFieldLabel",
        defaultMessage: "URL"
    },
    linkUrlFieldPlaceholder: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.linkUrlFieldPlaceholder",
        defaultMessage: "https://www.example.com"
    },
    linkTextFieldLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.linkTextFieldLabel",
        defaultMessage: "Link text"
    },
    linkTextFieldPlaceholder: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.linkTextFieldPlaceholder",
        defaultMessage: "Add a description"
    },
    saveLinkButtonLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.saveLinkButtonLabel",
        defaultMessage: "Add"
    },
    commentsSectionLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.commentsSectionLabel",
        defaultMessage: "Comments"
    },
    submitterFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.submitter-field-label",
        defaultMessage: "Submitter"
    },
    receiverFieldLabel: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.receiverFieldLabel",
        defaultMessage: "Receiver"
    },
    submittingTeamFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.submitting-team-field-label",
        defaultMessage: "Submitting team"
    },
    receivingTeamFieldLabel: {
        id: "conversation-assistant-message-actions.focus-ask-create.receiving-team-field-label",
        defaultMessage: "Receiving team"
    },
    submitterPickerPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.submitter-picker-placeholder",
        defaultMessage: "Select a submitter"
    },
    receiverPickerPlaceholder: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.receiverPickerPlaceholder",
        defaultMessage: "Select a receiver"
    },
    submittingTeamPickerPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.submitting-team-picker-placeholder",
        defaultMessage: "Select a submitting team"
    },
    receivingTeamPickerPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.receiving-team-picker-placeholder",
        defaultMessage: "Select a receiving team"
    },
    impactedWorkPlaceholder: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-work-placeholder",
        defaultMessage: "Paste a link to an impacted item"
    },
    impactedWorkInvalidUrl: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-work-invalid-url",
        defaultMessage: "Invalid URL. Try pasting a different link."
    },
    impactedWorkNotFound: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-work-not-found",
        defaultMessage: "We couldn\u2019t find a match. Try searching with different terms."
    },
    impactedWorkResolving: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-work-resolving",
        defaultMessage: "Resolving link\u2026"
    },
    impactedWorkResolvedSuccess: {
        id: "conversation-assistant-message-actions.focus-ask-create.impacted-work-resolved-success",
        defaultMessage: "Found this item \u2014 it will be linked to your ask"
    },
    priorityLow: {
        id: "conversation-assistant-message-actions.focus-ask-create.priority-low",
        defaultMessage: "Low"
    },
    priorityMedium: {
        id: "conversation-assistant-message-actions.focus-ask-create.priority-medium",
        defaultMessage: "Medium"
    },
    priorityHigh: {
        id: "conversation-assistant-message-actions.focus-ask-create.priority-high",
        defaultMessage: "High"
    },
    priorityHighest: {
        id: "conversation-assistant-message-actions.focus-ask-create.priority-highest",
        defaultMessage: "Highest"
    },
    priorityCritical: {
        id: "conversation-assistant-message-actions.focus-ask-create.priority-critical",
        defaultMessage: "Critical"
    },
    bulkCreateAllButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-create-all-button",
        defaultMessage: "Create all ({count})"
    },
    bulkDismissAllButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-dismiss-all-button",
        defaultMessage: "Dismiss all"
    },
    bulkRowEditButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-row-edit-button",
        defaultMessage: "Edit ask"
    },
    bulkRowRemoveButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-row-remove-button",
        defaultMessage: "Remove from list"
    },
    bulkRowUntitled: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-row-untitled",
        defaultMessage: "Untitled Focus Ask"
    },
    bulkRowStatusErrored: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-row-status-errored",
        defaultMessage: "Failed to create"
    },
    bulkRowStatusCreated: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-row-status-created",
        defaultMessage: "Created"
    },
    bulkMissingInfo: {
        id: "conversation-assistant-message-actions.controllers.focus-ask-create.bulkMissingInfo",
        defaultMessage: "Missing info"
    },
    bulkProgressMessage: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-progress",
        defaultMessage: "Submitting\u2026"
    },
    bulkFailureMessage: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-failure-summary",
        defaultMessage: "Request failed"
    },
    bulkSuccessMessage: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-success",
        defaultMessage: "{count, plural, one {Ask created successfully} other {Asks created successfully}}"
    },
    bulkOverLimitMessage: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-over-limit",
        defaultMessage: "Too many asks. Reduce to {limit} or fewer."
    },
    bulkValidationMessage: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-validation",
        defaultMessage: "{count} asks need attention before creating."
    },
    bulkRequestFailedMessage: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-request-failed",
        defaultMessage: "Some asks failed. Review highlighted rows and try again."
    },
    bulkEditModalTitle: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-edit-modal-title",
        defaultMessage: "Edit ask"
    },
    bulkEditModalSubmitButton: {
        id: "conversation-assistant-message-actions.focus-ask-create.bulk-edit-modal-submit-button",
        defaultMessage: "Save"
    }
});
var $5d35429e2e70a426$export$2e2bcd8739ae039 = $5d35429e2e70a426$var$messages;
module.exports["default"] = $5d35429e2e70a426$export$2e2bcd8739ae039;

});

parcelRegister("9e6Xa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $f7959ce29f6da3dd$var$styles = {
    compactControl: "_39xV02EHJr _1EqgXlN91d",
    compactValueControl: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2Y7lL42ADO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0jFU0VF6tL _4ouGXIdnbC _1eOmH6o126",
    compactValueControlDisabled: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2Y7lL42ADO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0jFU0VF6tL _4ouGXIdnbC"
};
const $f7959ce29f6da3dd$export$a15b69d0969cf6df = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, appearance: t1, isDisabled: t2 } = t0;
    const appearance = t1 === undefined ? "value" : t1;
    const isDisabled = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== children || $[2] !== isDisabled) {
        t3 = appearance === "control" ? children : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: isDisabled ? $f7959ce29f6da3dd$var$styles.compactValueControlDisabled : $f7959ce29f6da3dd$var$styles.compactValueControl
        }, children);
        $[0] = appearance;
        $[1] = children;
        $[2] = isDisabled;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $f7959ce29f6da3dd$var$styles.compactControl
        }, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ children: children, appearance: appearance = 'value', isDisabled: isDisabled = false })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f7959ce29f6da3dd$var$styles.compactControl
    }, appearance === 'control' ? children : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isDisabled ? $f7959ce29f6da3dd$var$styles.compactValueControlDisabled : $f7959ce29f6da3dd$var$styles.compactValueControl
    }, children));
module.exports["CompactDetailValue"] = $f7959ce29f6da3dd$export$a15b69d0969cf6df;

});

parcelRegister("e2rFc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $2cce5ca74dbe14cc$var$DETAIL_ROW_HEIGHT = '2.5rem';
const $2cce5ca74dbe14cc$var$styles = {
    detailRow: "_0jFU0VF6tL _4kiQYAF6tL",
    detailLabel: "_39xV02h7gN _3YEZNOdnbC",
    detailValue: "_4ouGXIdnbC _2O5Vij7dHp"
};
const $2cce5ca74dbe14cc$export$3ea9d70abca6f185 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, children: children } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2cce5ca74dbe14cc$var$styles.detailLabel
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, label));
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2cce5ca74dbe14cc$var$styles.detailValue
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $2cce5ca74dbe14cc$var$styles.detailRow
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ label: label, children: children })=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $2cce5ca74dbe14cc$var$styles.detailRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2cce5ca74dbe14cc$var$styles.detailLabel
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, label)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2cce5ca74dbe14cc$var$styles.detailValue
    }, children));
module.exports["DetailRow"] = $2cce5ca74dbe14cc$export$3ea9d70abca6f185;

});

parcelRegister("hfdnF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $d7j1D = parcelRequire("d7j1D");


var $1JERl = parcelRequire("1JERl");


var $iMnC5 = parcelRequire("iMnC5");


var $5MdA4 = parcelRequire("5MdA4");


var $4eicX = parcelRequire("4eicX");


var $6kwbC = parcelRequire("6kwbC");

const $81466fcb1dee905a$export$f7fb2ca24b10c9e0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { title: title, placeholder: placeholder, value: value, onConfirm: onConfirm, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { editorApi: editorApi, preset: preset } = (0, $5MdA4.useEditorPreset)(placeholder);
    if (isDisabled) {
        let t2;
        if ($[0] !== preset || $[1] !== value) {
            t2 = /*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4eicX.RichTextEditor), {
                value: value,
                preset: preset,
                disabled: true
            }));
            $[0] = preset;
            $[1] = value;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== t2 || $[4] !== title) {
            t3 = /*#__PURE__*/ $cozmU.createElement((0, $6kwbC.PreviewSection), {
                title: title
            }, t2);
            $[3] = t2;
            $[4] = title;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t2;
    if ($[6] !== editorApi || $[7] !== preset || $[8] !== value) {
        t2 = (fieldProps, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ref: ref
            }, /*#__PURE__*/ $cozmU.createElement((0, $4eicX.RichTextEditor), {
                value: value,
                preset: preset,
                editorApi: editorApi,
                shouldFocus: true,
                onChange: fieldProps.onChange
            }));
        $[6] = editorApi;
        $[7] = preset;
        $[8] = value;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== preset || $[11] !== value) {
        t3 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $4eicX.RichTextEditor), {
                value: value,
                preset: preset
            });
        $[10] = preset;
        $[11] = value;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== onConfirm || $[14] !== t2 || $[15] !== t3 || $[16] !== value) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
            readViewFitContainerWidth: true,
            defaultValue: value,
            keepEditViewOpenOnBlur: false,
            editView: t2,
            readView: t3,
            onConfirm: onConfirm
        }));
        $[13] = onConfirm;
        $[14] = t2;
        $[15] = t3;
        $[16] = value;
        $[17] = t4;
    } else t4 = $[17];
    let t5;
    if ($[18] !== t4 || $[19] !== title) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $6kwbC.PreviewSection), {
            title: title
        }, t4);
        $[18] = t4;
        $[19] = title;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ title: title, placeholder: placeholder, value: value, onConfirm: onConfirm, isDisabled: isDisabled = false })=>{
    const { editorApi: editorApi, preset: preset } = (0, $5MdA4.useEditorPreset)(placeholder);
    if (isDisabled) return /*#__PURE__*/ $cozmU.createElement((0, $6kwbC.PreviewSection), {
        title: title
    }, /*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4eicX.RichTextEditor), {
        value: value,
        preset: preset,
        disabled: true
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $6kwbC.PreviewSection), {
        title: title
    }, /*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1JERl.default), {
        readViewFitContainerWidth: true,
        defaultValue: value,
        keepEditViewOpenOnBlur: false,
        editView: (fieldProps, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ref: ref
            }, /*#__PURE__*/ $cozmU.createElement((0, $4eicX.RichTextEditor), {
                value: value,
                preset: preset,
                editorApi: editorApi,
                shouldFocus: true,
                onChange: fieldProps.onChange
            })),
        readView: ()=>/*#__PURE__*/ $cozmU.createElement((0, $4eicX.RichTextEditor), {
                value: value,
                preset: preset
            }),
        onConfirm: onConfirm
    })));
};
module.exports["InlineEditorSection"] = $81466fcb1dee905a$export$f7fb2ca24b10c9e0;

});

parcelRegister("6kwbC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $4001072870d5747a$var$styles = {
    section: "_39xV02N91d _4ouGXIdnbC"
};
const $4001072870d5747a$export$429c3ce13cf3b5c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { title: title, children: children } = t0;
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, title);
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: $4001072870d5747a$var$styles.section
        }, t1, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ title: title, children: children })=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $4001072870d5747a$var$styles.section
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, title), children);
module.exports["PreviewSection"] = $4001072870d5747a$export$429c3ce13cf3b5c7;

});

parcelRegister("6qd8M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $gC2EJ = parcelRequire("gC2EJ");


var $24dy7 = parcelRequire("24dy7");


var $chu6R = parcelRequire("chu6R");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $79yHm = parcelRequire("79yHm");

const $9dd83ec87ed77db5$var$styles = {
    card: "_0bjKvDKxmn _39xV02N91d _0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE _3iDTPbvLZJ _1eOmH6o126",
    headerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    nameText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7"
};
const $9dd83ec87ed77db5$var$RowStatusIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { status: status } = t0;
    if (status === "submitting") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small"
            });
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (status === "created") {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            });
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (status === "errored") {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            });
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    return null;
} : ({ status: status })=>{
    if (status === 'submitting') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    });
    if (status === 'created') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
    if (status === 'errored') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
    return null;
};
const $9dd83ec87ed77db5$var$RowStatusLabel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { status: status } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (status === "created") {
        let t1;
        if ($[0] !== formatMessage) {
            t1 = formatMessage((0, $79yHm.default).bulkRowStatusCreated);
            $[0] = formatMessage;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtle"
            }, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (status === "errored") {
        let t1;
        if ($[4] !== formatMessage) {
            t1 = formatMessage((0, $79yHm.default).bulkRowStatusErrored);
            $[4] = formatMessage;
            $[5] = t1;
        } else t1 = $[5];
        let t2;
        if ($[6] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.danger"
            }, t1);
            $[6] = t1;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    return null;
} : ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (status === 'created') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $79yHm.default).bulkRowStatusCreated));
    if (status === 'errored') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.danger"
    }, formatMessage((0, $79yHm.default).bulkRowStatusErrored));
    return null;
};
const $9dd83ec87ed77db5$export$b44aa0b8fdceb5f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { rowId: rowId, formData: formData, status: status, createdLink: createdLink, onEdit: onEdit, onRemove: onRemove } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isInteractive = status === "idle" || status === "errored";
    const isFinished = status === "created";
    let t1;
    if ($[0] !== formData.name || $[1] !== formatMessage) {
        t1 = formData.name.trim() || formatMessage((0, $79yHm.default).bulkRowUntitled);
        $[0] = formData.name;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const displayName = t1;
    let t2;
    if ($[3] !== isInteractive || $[4] !== onEdit || $[5] !== rowId) {
        t2 = (e)=>{
            e.stopPropagation();
            if (!isInteractive) return;
            onEdit(rowId);
        };
        $[3] = isInteractive;
        $[4] = onEdit;
        $[5] = rowId;
        $[6] = t2;
    } else t2 = $[6];
    const handleEdit = t2;
    let t3;
    if ($[7] !== onRemove || $[8] !== rowId) {
        t3 = (e_0)=>{
            e_0.stopPropagation();
            onRemove(rowId);
        };
        $[7] = onRemove;
        $[8] = rowId;
        $[9] = t3;
    } else t3 = $[9];
    const handleRemove = t3;
    const t4 = `bulk-focus-ask-row-${rowId}`;
    let t5;
    if ($[10] !== status) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9dd83ec87ed77db5$var$RowStatusIcon, {
            status: status
        });
        $[10] = status;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== createdLink || $[13] !== displayName || $[14] !== isFinished) {
        t6 = isFinished && createdLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: createdLink,
            target: "_blank",
            rel: "noopener noreferrer"
        }, displayName) : displayName;
        $[12] = createdLink;
        $[13] = displayName;
        $[14] = isFinished;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, t6);
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== status) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9dd83ec87ed77db5$var$RowStatusLabel, {
            status: status
        });
        $[18] = status;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t5 || $[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $9dd83ec87ed77db5$var$styles.nameText
        }, t5, t7, t8);
        $[20] = t5;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== formatMessage || $[25] !== handleEdit || $[26] !== handleRemove || $[27] !== isInteractive || $[28] !== rowId) {
        t10 = isInteractive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            label: formatMessage((0, $79yHm.default).bulkRowEditButton),
            appearance: "subtle",
            spacing: "compact",
            onClick: handleEdit,
            testId: `bulk-focus-ask-row-edit-${rowId}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $79yHm.default).bulkRowRemoveButton),
            appearance: "subtle",
            spacing: "compact",
            onClick: handleRemove,
            testId: `bulk-focus-ask-row-remove-${rowId}`
        }));
        $[24] = formatMessage;
        $[25] = handleEdit;
        $[26] = handleRemove;
        $[27] = isInteractive;
        $[28] = rowId;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, t10);
        $[30] = t10;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== t11 || $[33] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9dd83ec87ed77db5$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9dd83ec87ed77db5$var$styles.headerContent
        }, t9, t11));
        $[32] = t11;
        $[33] = t9;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== t12 || $[36] !== t4) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: t4
        }, t12);
        $[35] = t12;
        $[36] = t4;
        $[37] = t13;
    } else t13 = $[37];
    return t13;
} : ({ rowId: rowId, formData: formData, status: status, createdLink: createdLink, onEdit: onEdit, onRemove: onRemove })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isInteractive = status === 'idle' || status === 'errored';
    const isFinished = status === 'created';
    const displayName = formData.name.trim() || formatMessage((0, $79yHm.default).bulkRowUntitled);
    const handleEdit = (e)=>{
        e.stopPropagation();
        if (!isInteractive) return;
        onEdit(rowId);
    };
    const handleRemove = (e_0)=>{
        e_0.stopPropagation();
        onRemove(rowId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `bulk-focus-ask-row-${rowId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9dd83ec87ed77db5$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9dd83ec87ed77db5$var$styles.headerContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $9dd83ec87ed77db5$var$styles.nameText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9dd83ec87ed77db5$var$RowStatusIcon, {
        status: status
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, isFinished && createdLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: createdLink,
        target: "_blank",
        rel: "noopener noreferrer"
    }, displayName) : displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9dd83ec87ed77db5$var$RowStatusLabel, {
        status: status
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, isInteractive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        label: formatMessage((0, $79yHm.default).bulkRowEditButton),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleEdit,
        testId: `bulk-focus-ask-row-edit-${rowId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $79yHm.default).bulkRowRemoveButton),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleRemove,
        testId: `bulk-focus-ask-row-remove-${rowId}`
    }))))));
};
module.exports["BulkFocusAskRow"] = $9dd83ec87ed77db5$export$b44aa0b8fdceb5f2;

});

parcelRegister("k7N8F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iATgb = parcelRequire("iATgb");

const $fcd75a2b70214c21$var$buildRowId = (invocationId, index)=>`${invocationId || 'focus-ask'}#${index}`;
const $fcd75a2b70214c21$export$1e246d2048a9da42 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (invocationId, asks)=>{
    const $ = (0, $bDgLe.c)(24);
    let t0;
    if ($[0] !== asks || $[1] !== invocationId) {
        let t1;
        if ($[3] !== invocationId) {
            t1 = (ask, index)=>({
                    rowId: $fcd75a2b70214c21$var$buildRowId(invocationId, index),
                    originalAsk: ask
                });
            $[3] = invocationId;
            $[4] = t1;
        } else t1 = $[4];
        t0 = asks.map(t1);
        $[0] = asks;
        $[1] = invocationId;
        $[2] = t0;
    } else t0 = $[2];
    const rows = t0;
    let map;
    if ($[5] !== rows) {
        map = {};
        for (const row of rows)map[row.rowId] = (0, $iATgb.normalizeFocusAskPayload)(row.originalAsk);
        $[5] = rows;
        $[6] = map;
    } else map = $[6];
    const initialForms = map;
    const [formByRowId, setFormByRowId] = (0, $cozmU.useState)(initialForms);
    const [removedIds, setRemovedIds] = (0, $cozmU.useState)($fcd75a2b70214c21$var$_temp);
    let t1;
    if ($[7] !== formByRowId || $[8] !== initialForms) {
        t1 = (rowId)=>formByRowId[rowId] ?? initialForms[rowId];
        $[7] = formByRowId;
        $[8] = initialForms;
        $[9] = t1;
    } else t1 = $[9];
    const getFormData = t1;
    let t2;
    if ($[10] !== initialForms) {
        t2 = (rowId_0, field, value)=>{
            setFormByRowId((prev)=>{
                const current = prev[rowId_0] ?? initialForms[rowId_0];
                if (!current) return prev;
                return {
                    ...prev,
                    [rowId_0]: {
                        ...current,
                        [field]: value
                    }
                };
            });
        };
        $[10] = initialForms;
        $[11] = t2;
    } else t2 = $[11];
    const updateField = t2;
    let t3;
    if ($[12] !== initialForms) {
        t3 = (rowId_1, formData)=>{
            setFormByRowId((prev_0)=>{
                if (!prev_0[rowId_1] && !initialForms[rowId_1]) return prev_0;
                return {
                    ...prev_0,
                    [rowId_1]: formData
                };
            });
        };
        $[12] = initialForms;
        $[13] = t3;
    } else t3 = $[13];
    const updateFormData = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (rowId_2)=>{
            setRemovedIds((prev_1)=>{
                if (prev_1.has(rowId_2)) return prev_1;
                const next = new Set(prev_1);
                next.add(rowId_2);
                return next;
            });
        };
        $[14] = t4;
    } else t4 = $[14];
    const removeRow = t4;
    let t5;
    if ($[15] !== rows) {
        t5 = ()=>{
            setRemovedIds(new Set(rows.map($fcd75a2b70214c21$var$_temp2)));
        };
        $[15] = rows;
        $[16] = t5;
    } else t5 = $[16];
    const dismissAllRows = t5;
    let t6;
    if ($[17] !== dismissAllRows || $[18] !== getFormData || $[19] !== removedIds || $[20] !== rows || $[21] !== updateField || $[22] !== updateFormData) {
        t6 = {
            rows: rows,
            getFormData: getFormData,
            updateField: updateField,
            updateFormData: updateFormData,
            removedIds: removedIds,
            removeRow: removeRow,
            dismissAllRows: dismissAllRows
        };
        $[17] = dismissAllRows;
        $[18] = getFormData;
        $[19] = removedIds;
        $[20] = rows;
        $[21] = updateField;
        $[22] = updateFormData;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : (invocationId, asks)=>{
    // Synthesise stable rows from the initial asks array. We intentionally only
    // recompute when the underlying asks reference changes (i.e. a fresh message
    // arrives) — local edits/removals are layered on top via the state below.
    const rows = (0, $cozmU.useMemo)(()=>asks.map((ask, index)=>({
                rowId: $fcd75a2b70214c21$var$buildRowId(invocationId, index),
                originalAsk: ask
            })), [
        asks,
        invocationId
    ]);
    const initialForms = (0, $cozmU.useMemo)(()=>{
        const map = {};
        for (const row of rows)map[row.rowId] = (0, $iATgb.normalizeFocusAskPayload)(row.originalAsk);
        return map;
    }, [
        rows
    ]);
    const [formByRowId, setFormByRowId] = (0, $cozmU.useState)(initialForms);
    const [removedIds, setRemovedIds] = (0, $cozmU.useState)(()=>new Set());
    const getFormData = (0, $cozmU.useCallback)((rowId)=>formByRowId[rowId] ?? initialForms[rowId], [
        formByRowId,
        initialForms
    ]);
    const updateField = (0, $cozmU.useCallback)((rowId_0, field, value)=>{
        setFormByRowId((prev)=>{
            const current = prev[rowId_0] ?? initialForms[rowId_0];
            if (!current) return prev;
            return {
                ...prev,
                [rowId_0]: {
                    ...current,
                    [field]: value
                }
            };
        });
    }, [
        initialForms
    ]);
    const updateFormData = (0, $cozmU.useCallback)((rowId_1, formData)=>{
        setFormByRowId((prev_0)=>{
            if (!prev_0[rowId_1] && !initialForms[rowId_1]) return prev_0;
            return {
                ...prev_0,
                [rowId_1]: formData
            };
        });
    }, [
        initialForms
    ]);
    const removeRow = (0, $cozmU.useCallback)((rowId_2)=>{
        setRemovedIds((prev_1)=>{
            if (prev_1.has(rowId_2)) return prev_1;
            const next = new Set(prev_1);
            next.add(rowId_2);
            return next;
        });
    }, []);
    const dismissAllRows = (0, $cozmU.useCallback)(()=>{
        setRemovedIds(new Set(rows.map((row_0)=>row_0.rowId)));
    }, [
        rows
    ]);
    return {
        rows: rows,
        getFormData: getFormData,
        updateField: updateField,
        updateFormData: updateFormData,
        removedIds: removedIds,
        removeRow: removeRow,
        dismissAllRows: dismissAllRows
    };
};
function $fcd75a2b70214c21$var$_temp() {
    return new Set();
}
function $fcd75a2b70214c21$var$_temp2(row_0) {
    return row_0.rowId;
}
module.exports["useBulkFocusAskState"] = $fcd75a2b70214c21$export$1e246d2048a9da42;

});

parcelRegister("hkGKX", function(module, exports) {
/**
 * Extracts the ID from a user / team ARI.
 */ function $e6091fe12907d2dc$export$3af5ef4846957e36(ref, resource) {
    const trimmed = ref.trim();
    if (!trimmed.startsWith('ari:')) return trimmed;
    const label = resource === 'user' ? 'user' : 'team';
    const identityMarker = `::${label}/`;
    const identityIdx = trimmed.indexOf(identityMarker);
    if (identityIdx !== -1) return trimmed.slice(identityIdx + identityMarker.length).split(/[/?#]/)[0] ?? trimmed;
    const slashMarker = `/${label}/`;
    const slashIdx = trimmed.indexOf(slashMarker);
    if (slashIdx !== -1) return trimmed.slice(slashIdx + slashMarker.length).split(/[/?#]/)[0] ?? trimmed;
    return trimmed;
}
const $e6091fe12907d2dc$var$USER_ARI_PREFIX = 'ari:cloud:identity::user/';
const $e6091fe12907d2dc$var$TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
function $e6091fe12907d2dc$export$5adfc43a1317c2f3(resourceId, resource) {
    const trimmed = resourceId.trim();
    if (!trimmed) return resource === 'user' ? $e6091fe12907d2dc$var$USER_ARI_PREFIX : $e6091fe12907d2dc$var$TEAM_ARI_PREFIX;
    if (trimmed.startsWith('ari:')) return trimmed;
    return resource === 'user' ? `${$e6091fe12907d2dc$var$USER_ARI_PREFIX}${trimmed}` : `${$e6091fe12907d2dc$var$TEAM_ARI_PREFIX}${trimmed}`;
}
module.exports["resourceIdFromIdentityAri"] = $e6091fe12907d2dc$export$3af5ef4846957e36;
module.exports["identityAriFromResourceId"] = $e6091fe12907d2dc$export$5adfc43a1317c2f3;

});

parcelRegister("7LV0V", function(module, exports) {
/** Formatted like "YYYY-MM-DD". */ const $84fcb1c8aece6d68$var$ISO_DAY_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
function $84fcb1c8aece6d68$export$3cb804ff8e56d9e6(raw) {
    const trimmed = raw.trim();
    if (!trimmed) return '';
    const isoMatch = $84fcb1c8aece6d68$var$ISO_DAY_ONLY.exec(trimmed);
    if (isoMatch) return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
    return '';
}
function $84fcb1c8aece6d68$export$a9180159eab600b3(isoDay) {
    const trimmed = isoDay.trim();
    const m = $84fcb1c8aece6d68$var$ISO_DAY_ONLY.exec(trimmed);
    if (!m) return undefined;
    const y = Number(m[1]);
    const mo = Number(m[2]) - 1;
    const d = Number(m[3]);
    const date = new Date(y, mo, d);
    return Number.isNaN(date.getTime()) ? undefined : date;
}
function $84fcb1c8aece6d68$export$ced9ff0b06f148c4(raw, formatDate) {
    const trimmed = raw.trim();
    const parsed = $84fcb1c8aece6d68$export$a9180159eab600b3(trimmed);
    if (parsed !== undefined) return formatDate(parsed, {
        dateStyle: 'medium'
    });
    return '';
}
function $84fcb1c8aece6d68$export$fd63889bab14d2bd(record) {
    const td = record.targetDate;
    if (typeof td === 'string') return td;
    if (td && typeof td === 'object' && !Array.isArray(td)) {
        const o = td;
        if (typeof o.targetDate === 'string') return o.targetDate;
        const date = o.date;
        if (typeof date === 'string') return date;
    }
    return '';
}
function $84fcb1c8aece6d68$export$67fea97923382bf6(record) {
    const raw = $84fcb1c8aece6d68$export$fd63889bab14d2bd(record);
    const iso = $84fcb1c8aece6d68$export$3cb804ff8e56d9e6(raw);
    if (iso) return {
        targetDate: iso,
        targetDateType: 'DAY'
    };
    return {
        targetDate: ''
    };
}
function $84fcb1c8aece6d68$export$53feccc49aea24d5() {
    return {
        targetDate: ''
    };
}
module.exports["parseStringToIsoDay"] = $84fcb1c8aece6d68$export$3cb804ff8e56d9e6;
module.exports["parseRecordToFocusAskTargetDateValue"] = $84fcb1c8aece6d68$export$67fea97923382bf6;
module.exports["emptyFocusAskTargetDateValue"] = $84fcb1c8aece6d68$export$53feccc49aea24d5;

});

parcelRegister("gmy1e", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $2uDbg = parcelRequire("2uDbg");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $l9wjm = parcelRequire("l9wjm");

const $d7dab257a2f6770c$var$styles = {
    selectedIssuesLabel: "_2XsHFM1Y8M _1kk5Tku7m9 _1UtDYzZpcK",
    title: "_2XsHFM1Y8M"
};
const $d7dab257a2f6770c$export$1467c63988aa0968 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { title: title, issueState: t1, isExpanded: isExpanded, isDisabled: isDisabled, handleExpandCollapse: handleExpandCollapse, handleSelectAllCheckboxChange: handleSelectAllCheckboxChange } = t0;
    const { selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, totalIssueCount: totalIssueCount } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $l9wjm.messages).selectAllCheckboxLabel);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = selectedIssueKeys.length > 0;
    const t4 = !areAllIssuesSelected && selectedIssueKeys.length > 0;
    let t5;
    if ($[2] !== handleSelectAllCheckboxChange || $[3] !== isDisabled || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
            "aria-label": t2,
            testId: "issue-selector-select-all-checkbox",
            isChecked: t3,
            isDisabled: isDisabled,
            isIndeterminate: t4,
            onChange: handleSelectAllCheckboxChange
        });
        $[2] = handleSelectAllCheckboxChange;
        $[3] = isDisabled;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== isExpanded) {
        t6 = (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            });
        $[8] = isExpanded;
        $[9] = t6;
    } else t6 = $[9];
    const t7 = isExpanded ? (0, $l9wjm.messages).collapseButtonLabelText : (0, $l9wjm.messages).expandButtonLabelText;
    let t8;
    if ($[10] !== formatMessage || $[11] !== t7) {
        t8 = formatMessage(t7);
        $[10] = formatMessage;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== handleExpandCollapse || $[14] !== t6 || $[15] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t6,
            label: t8,
            onClick: handleExpandCollapse
        });
        $[13] = handleExpandCollapse;
        $[14] = t6;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== formatMessage || $[18] !== selectedIssueKeys.length || $[19] !== totalIssueCount) {
        t10 = formatMessage((0, $l9wjm.messages).selectedIssuesLabel, {
            issueCount: totalIssueCount,
            selectedIssueCount: selectedIssueKeys.length
        });
        $[17] = formatMessage;
        $[18] = selectedIssueKeys.length;
        $[19] = totalIssueCount;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $d7dab257a2f6770c$var$styles.selectedIssuesLabel
        }, t10);
        $[21] = t10;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== title) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7dab257a2f6770c$var$styles.title
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, title, t11));
        $[23] = t11;
        $[24] = title;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== t12 || $[27] !== t5 || $[28] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t5, t9, t12);
        $[26] = t12;
        $[27] = t5;
        $[28] = t9;
        $[29] = t13;
    } else t13 = $[29];
    return t13;
} : ({ title: title, issueState: { selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, totalIssueCount: totalIssueCount }, isExpanded: isExpanded, isDisabled: isDisabled, handleExpandCollapse: handleExpandCollapse, handleSelectAllCheckboxChange: handleSelectAllCheckboxChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        "aria-label": formatMessage((0, $l9wjm.messages).selectAllCheckboxLabel),
        testId: "issue-selector-select-all-checkbox",
        isChecked: selectedIssueKeys.length > 0,
        isDisabled: isDisabled,
        isIndeterminate: !areAllIssuesSelected && selectedIssueKeys.length > 0,
        onChange: handleSelectAllCheckboxChange
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage(isExpanded ? (0, $l9wjm.messages).collapseButtonLabelText : (0, $l9wjm.messages).expandButtonLabelText),
        onClick: handleExpandCollapse
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7dab257a2f6770c$var$styles.title
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, title, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d7dab257a2f6770c$var$styles.selectedIssuesLabel
    }, formatMessage((0, $l9wjm.messages).selectedIssuesLabel, {
        issueCount: totalIssueCount,
        selectedIssueCount: selectedIssueKeys.length
    })))));
};
const $d7dab257a2f6770c$export$3f6daf9b579dc88c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { title: title, issueState: t1, isDisabled: isDisabled, handleSelectAllCheckboxChange: handleSelectAllCheckboxChange } = t0;
    const { selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $l9wjm.messages).selectAllCheckboxLabel);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = selectedIssueKeys.length > 0;
    const t4 = !areAllIssuesSelected && selectedIssueKeys.length > 0;
    let t5;
    if ($[2] !== handleSelectAllCheckboxChange || $[3] !== isDisabled || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
            "aria-label": t2,
            testId: "issue-selector-select-all-checkbox",
            isChecked: t3,
            isDisabled: isDisabled,
            isIndeterminate: t4,
            onChange: handleSelectAllCheckboxChange
        });
        $[2] = handleSelectAllCheckboxChange;
        $[3] = isDisabled;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== title) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7dab257a2f6770c$var$styles.title
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, title));
        $[8] = title;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t5, t6);
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : ({ title: title, issueState: { selectedIssueKeys: selectedIssueKeys, areAllIssuesSelected: areAllIssuesSelected, totalIssueCount: totalIssueCount }, isDisabled: isDisabled, handleSelectAllCheckboxChange: handleSelectAllCheckboxChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        "aria-label": formatMessage((0, $l9wjm.messages).selectAllCheckboxLabel),
        testId: "issue-selector-select-all-checkbox",
        isChecked: selectedIssueKeys.length > 0,
        isDisabled: isDisabled,
        isIndeterminate: !areAllIssuesSelected && selectedIssueKeys.length > 0,
        onChange: handleSelectAllCheckboxChange
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7dab257a2f6770c$var$styles.title
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, title)));
};
module.exports["IssueSelectorHeader"] = $d7dab257a2f6770c$export$1467c63988aa0968;
module.exports["BulkIssueSelectorHeader"] = $d7dab257a2f6770c$export$3f6daf9b579dc88c;

});

parcelRegister("f5acS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $81e11ba16edc3a0c$export$a435421a00d3bee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (issueList, initialSelectedIssues)=>{
    const $ = (0, $bDgLe.c)(21);
    let t0;
    if ($[0] !== initialSelectedIssues || $[1] !== issueList) {
        t0 = ()=>{
            const initialSelectedSet = new Set(initialSelectedIssues || []);
            return Object.fromEntries(issueList.map((t1)=>{
                const { issueKey: issueKey, url: url, readonly: readonly } = t1;
                return [
                    issueKey,
                    {
                        isSelected: initialSelectedSet.has(issueKey),
                        url: url,
                        readonly: readonly
                    }
                ];
            }));
        };
        $[0] = initialSelectedIssues;
        $[1] = issueList;
        $[2] = t0;
    } else t0 = $[2];
    const [issues, setIssues] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[3] !== issueList || $[4] !== issues) {
        t1 = ()=>{
            const hasChanges = issueList.some((t3)=>{
                const { issueKey: issueKey_0, readonly: readonly_0 } = t3;
                const currentIssue = issues[issueKey_0];
                return !currentIssue || currentIssue.readonly !== readonly_0;
            }) || Object.keys(issues).length !== issueList.length;
            if (hasChanges) setIssues((prevIssues)=>Object.fromEntries(issueList.map((t4)=>{
                    const { issueKey: issueKey_1, url: url_0, readonly: readonly_1 } = t4;
                    return [
                        issueKey_1,
                        {
                            isSelected: prevIssues[issueKey_1]?.isSelected ?? false,
                            url: url_0,
                            readonly: readonly_1
                        }
                    ];
                })));
        };
        t2 = [
            issueList,
            setIssues,
            issues
        ];
        $[3] = issueList;
        $[4] = issues;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== issues) {
        t3 = Object.keys(issues);
        $[7] = issues;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== issues || $[10] !== t3) {
        t4 = t3.filter((issueKey_2)=>issues[issueKey_2].isSelected);
        $[9] = issues;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    const selectedIssueKeys = t4;
    let t5;
    if ($[12] !== issues || $[13] !== selectedIssueKeys) {
        t5 = (disabledIssues)=>{
            if (disabledIssues.length) return selectedIssueKeys.length === Object.keys(issues).filter((issueKey_3)=>!disabledIssues.includes(issueKey_3)).length;
            return selectedIssueKeys.length === Object.keys(issues).length;
        };
        $[12] = issues;
        $[13] = selectedIssueKeys;
        $[14] = t5;
    } else t5 = $[14];
    const areAllIssuesSelected = t5;
    let t6;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (issueKey_4)=>{
            setIssues((prevIssues_0)=>({
                    ...prevIssues_0,
                    [issueKey_4]: {
                        ...prevIssues_0[issueKey_4],
                        isSelected: !prevIssues_0[issueKey_4].isSelected
                    }
                }));
        };
        $[15] = t6;
    } else t6 = $[15];
    const toggleIssue = t6;
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (issueKeys, newCheckboxState)=>{
            setIssues((prevIssues_1)=>{
                const newIssues = {
                    ...prevIssues_1
                };
                issueKeys.forEach((issueKey_5)=>{
                    if (newIssues[issueKey_5]) newIssues[issueKey_5].isSelected = newCheckboxState;
                });
                return newIssues;
            });
        };
        $[16] = t7;
    } else t7 = $[16];
    const toggleIssues = t7;
    let t8;
    if ($[17] !== areAllIssuesSelected || $[18] !== issues || $[19] !== selectedIssueKeys) {
        t8 = {
            issues: issues,
            selectedIssueKeys: selectedIssueKeys,
            areAllIssuesSelected: areAllIssuesSelected,
            toggleIssue: toggleIssue,
            toggleIssues: toggleIssues
        };
        $[17] = areAllIssuesSelected;
        $[18] = issues;
        $[19] = selectedIssueKeys;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : (issueList, initialSelectedIssues)=>{
    const [issues, setIssues] = (0, $cozmU.useState)(()=>{
        const initialSelectedSet = new Set(initialSelectedIssues || []);
        return Object.fromEntries(issueList.map(({ issueKey: issueKey, url: url, readonly: readonly })=>[
                issueKey,
                {
                    isSelected: initialSelectedSet.has(issueKey),
                    url: url,
                    readonly: readonly
                }
            ]));
    });
    (0, $cozmU.useEffect)(()=>{
        const hasChanges = issueList.some(({ issueKey: issueKey_0, readonly: readonly_0 })=>{
            const currentIssue = issues[issueKey_0];
            return !currentIssue || currentIssue.readonly !== readonly_0;
        }) || Object.keys(issues).length !== issueList.length;
        if (hasChanges) setIssues((prevIssues)=>Object.fromEntries(issueList.map(({ issueKey: issueKey_1, url: url_0, readonly: readonly_1 })=>[
                    issueKey_1,
                    {
                        isSelected: prevIssues[issueKey_1]?.isSelected ?? false,
                        url: url_0,
                        readonly: readonly_1
                    }
                ])));
    }, [
        issueList,
        setIssues,
        issues
    ]);
    const selectedIssueKeys = (0, $cozmU.useMemo)(()=>Object.keys(issues).filter((issueKey_2)=>issues[issueKey_2].isSelected), [
        issues
    ]);
    const areAllIssuesSelected = (0, $cozmU.useCallback)((disabledIssues)=>{
        if (disabledIssues.length) return selectedIssueKeys.length === Object.keys(issues).filter((issueKey_3)=>!disabledIssues.includes(issueKey_3)).length;
        return selectedIssueKeys.length === Object.keys(issues).length;
    }, [
        selectedIssueKeys,
        issues
    ]);
    const toggleIssue = (0, $cozmU.useCallback)((issueKey_4)=>{
        setIssues((prevIssues_0)=>({
                ...prevIssues_0,
                [issueKey_4]: {
                    ...prevIssues_0[issueKey_4],
                    isSelected: !prevIssues_0[issueKey_4].isSelected
                }
            }));
    }, []);
    const toggleIssues = (0, $cozmU.useCallback)((issueKeys, newCheckboxState)=>{
        setIssues((prevIssues_1)=>{
            const newIssues = {
                ...prevIssues_1
            };
            issueKeys.forEach((issueKey_5)=>{
                if (newIssues[issueKey_5]) newIssues[issueKey_5].isSelected = newCheckboxState;
            });
            return newIssues;
        });
    }, []);
    return {
        issues: issues,
        selectedIssueKeys: selectedIssueKeys,
        areAllIssuesSelected: areAllIssuesSelected,
        toggleIssue: toggleIssue,
        toggleIssues: toggleIssues
    };
};
module.exports["useSelectedIssues"] = $81e11ba16edc3a0c$export$a435421a00d3bee;

});

parcelRegister("6jcZN", function(module, exports) {
const $0964f1f0b42f9626$export$a13844a47fb4dd31 = `
mutation bulkAssignIssuesToEpic($cloudId: ID!, $input: JiraSubmitBulkOperationInput!) {
	jira {
		submitBulkOperation(cloudId: $cloudId, input: $input) @optIn(to: "JiraBulkEditSubmitSpike") {
			success
			errors {
				message
			}
			progress {
				taskId
			}
		}
	}
}
`;
const $0964f1f0b42f9626$export$9b265e6c936934a = `
	query fetchBulkOperationProgress($cloudId: ID!, $taskId: ID!) {
		jira {
			bulkOperationProgress(cloudId: $cloudId, taskId: $taskId) @optIn(to: "JiraIssueBulkOperationProgress") {
				status
				failedAccessibleIssues {
					edges {
						node {
							issue {
								key
							}
						}
					}
				}
			}
		}
	}
`;
const $0964f1f0b42f9626$export$b9eb18173c8056ff = `
mutation CreateJiraIssue($input: JiraIssueCreateInput!) {
  jira {
    createIssue(input: $input) @optIn(to: "JiraIssueCreateMutation") {
      success
      issue {
        id
        issueId
        key
		webUrl
      }
    }
  }
}
`;
const $0964f1f0b42f9626$export$ee14340141c11674 = 500;
const $0964f1f0b42f9626$export$f75d5d225702159 = 60000;
module.exports["BulkAssignIssuesQuery"] = $0964f1f0b42f9626$export$a13844a47fb4dd31;
module.exports["BulkOperationProgressGraphQuery"] = $0964f1f0b42f9626$export$9b265e6c936934a;
module.exports["CreateJiraIssueQuery"] = $0964f1f0b42f9626$export$b9eb18173c8056ff;
module.exports["POLL_INTERVAL_MS"] = $0964f1f0b42f9626$export$ee14340141c11674;
module.exports["POLL_TIMEOUT_MS"] = $0964f1f0b42f9626$export$f75d5d225702159;

});

parcelRegister("hgTng", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $78c79ba81ddfb26c$var$messages = (0, $kSwu1.defineMessages)({
    assignee: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.assignee",
        defaultMessage: "Assignee"
    },
    reporter: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.reporter",
        defaultMessage: "Reporter"
    },
    priority: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.priority",
        defaultMessage: "Priority"
    },
    status: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.status",
        defaultMessage: "Status"
    },
    type: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.type",
        defaultMessage: "Work type"
    },
    issuetype: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuetype",
        defaultMessage: "Work type"
    },
    project: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.project",
        defaultMessage: "Project"
    },
    labels: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.labels",
        defaultMessage: "Labels"
    },
    created: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.created",
        defaultMessage: "Created"
    },
    updated: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.updated",
        defaultMessage: "Updated"
    },
    duedate: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.duedate",
        defaultMessage: "Due date"
    },
    sprint: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.sprint",
        defaultMessage: "Sprint"
    },
    parent: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.parent",
        defaultMessage: "Parent"
    },
    resolution: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.resolution",
        defaultMessage: "Resolution"
    },
    fixversion: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.fixversion",
        defaultMessage: "Fix version"
    },
    affectedversion: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.affectedversion",
        defaultMessage: "Affected version"
    },
    approvals: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.approvals",
        defaultMessage: "Approvals"
    },
    attachments: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.attachments",
        defaultMessage: "Attachments"
    },
    category: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.category",
        defaultMessage: "Category"
    },
    comment: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.comment",
        defaultMessage: "Comment"
    },
    creator: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.creator",
        defaultMessage: "Creator"
    },
    description: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.description",
        defaultMessage: "Description"
    },
    due: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.due",
        defaultMessage: "Due date"
    },
    environment: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.environment",
        defaultMessage: "Environment"
    },
    filter: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.filter",
        defaultMessage: "Filter"
    },
    issuekey: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuekey",
        defaultMessage: "Key"
    },
    issuelink: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuelink",
        defaultMessage: "Linked issues"
    },
    issuelinktype: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuelinktype",
        defaultMessage: "Link type"
    },
    epiclink: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.epiclink",
        defaultMessage: "Epic Link"
    },
    lastviewed: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.lastviewed",
        defaultMessage: "Last viewed"
    },
    level: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.level",
        defaultMessage: "Security level"
    },
    originalestimate: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.originalestimate",
        defaultMessage: "Original estimate"
    },
    remainingestimate: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.remainingestimate",
        defaultMessage: "Remaining estimate"
    },
    statuscategory: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.statuscategory",
        defaultMessage: "Status category"
    },
    summary: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.summary",
        defaultMessage: "Summary"
    },
    text: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.text",
        defaultMessage: "Text"
    },
    timespent: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.timespent",
        defaultMessage: "Time spent"
    },
    voter: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.voter",
        defaultMessage: "Voter"
    },
    votes: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.votes",
        defaultMessage: "Votes"
    },
    watcher: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.watcher",
        defaultMessage: "Watcher"
    },
    watchers: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.watchers",
        defaultMessage: "Watchers"
    },
    worklogcomment: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.worklogcomment",
        defaultMessage: "Log work comment"
    },
    worklogdate: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.worklogdate",
        defaultMessage: "Log work date"
    },
    workratio: {
        id: "conversation-assistant-message-actions.jira-view-create-and-configure.field-label.workratio",
        defaultMessage: "Work ratio"
    }
});
var $78c79ba81ddfb26c$export$2e2bcd8739ae039 = $78c79ba81ddfb26c$var$messages;
module.exports["default"] = $78c79ba81ddfb26c$export$2e2bcd8739ae039;

});

parcelRegister("29KNH", function(module, exports) {

var $l8HtA = parcelRequire("l8HtA");


var $9IJcW = parcelRequire("9IJcW");


var $74viJ = parcelRequire("74viJ");


var $2gdYO = parcelRequire("2gdYO");


var $8SSbk = parcelRequire("8SSbk");


var $5AwQJ = parcelRequire("5AwQJ");


var $1wNfB = parcelRequire("1wNfB");


var $1Wnig = parcelRequire("1Wnig");


var $dq2hb = parcelRequire("dq2hb");


var $6OfbT = parcelRequire("6OfbT");


var $1oj0n = parcelRequire("1oj0n");

const $4c9d421efe277a89$export$5540dd442706886a = {
    ['system:change-assignee']: {
        name: (0, $1oj0n.default).changeAssigneeRuleName,
        ruleType: 'Function',
        icon: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9IJcW))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l8HtA)))
        }
    },
    ['system:check-field-value']: {
        name: (0, $1oj0n.default).checkFieldValueRuleName,
        ruleType: 'Condition',
        icon: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1Wnig))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1wNfB)))
        }
    },
    ['system:restrict-issue-transition']: {
        name: (0, $1oj0n.default).restrictIssueTransitionRuleName,
        ruleType: 'Condition',
        icon: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2gdYO))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($74viJ)))
        }
    },
    ['system:update-field']: {
        name: (0, $1oj0n.default).updateFieldRuleName,
        ruleType: 'Function',
        icon: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5AwQJ))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8SSbk)))
        }
    },
    ['system:validate-field-value']: {
        name: (0, $1oj0n.default).validateFieldRuleName,
        ruleType: 'Validator',
        icon: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6OfbT))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dq2hb)))
        }
    }
};
module.exports["supportedRules"] = $4c9d421efe277a89$export$5540dd442706886a;

});

parcelRegister("1oj0n", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d68bf2405f6d6dd0$var$_default_1 = (0, $kSwu1.defineMessages)({
    changeAssigneeRuleName: {
        id: "jira-workflow-editor.workflow-builder.change-assignee-rule-name",
        defaultMessage: "Assign a work item"
    },
    checkFieldValueRuleName: {
        id: "jira-workflow-editor.workflow-builder.check-field-value-rule-name",
        defaultMessage: "Restrict to when a field is a specific value"
    },
    restrictIssueTransitionRuleName: {
        id: "jira-workflow-editor.workflow-builder.restrict-issue-transition-rule-name",
        defaultMessage: "Restrict who can move a work item"
    },
    updateFieldRuleName: {
        id: "jira-workflow-editor.workflow-builder.update-field-rule-name",
        defaultMessage: "Update a work item field"
    },
    validateFieldRuleName: {
        id: "jira-workflow-editor.workflow-builder.validate-field-rule-name",
        defaultMessage: "Validate a field"
    },
    ruleHeading: {
        id: "jira-workflow-editor.workflow-builder.status-heading",
        defaultMessage: "Rule"
    }
});
var $d68bf2405f6d6dd0$export$2e2bcd8739ae039 = $d68bf2405f6d6dd0$var$_default_1;
module.exports["default"] = $d68bf2405f6d6dd0$export$2e2bcd8739ae039;

});

parcelRegister("8dd6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $95648aa88b891c60$var$_default_1 = (0, $kSwu1.defineMessages)({
    statusHeading: {
        id: "jira-workflow-editor.workflow-builder.status-heading",
        defaultMessage: "Status"
    }
});
var $95648aa88b891c60$export$2e2bcd8739ae039 = $95648aa88b891c60$var$_default_1;
module.exports["default"] = $95648aa88b891c60$export$2e2bcd8739ae039;

});

parcelRegister("03OOf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $11f647a4f4c6e39e$var$_default_1 = (0, $kSwu1.defineMessages)({
    to: {
        id: "jira-workflow-editor.workflow-builder.transition.path.to",
        defaultMessage: "to"
    },
    transitionHeading: {
        id: "jira-workflow-editor.workflow-builder.transition-heading",
        defaultMessage: "Transition"
    },
    anyStatus: {
        id: "jira-workflow-editor.workflow-builder.any-status",
        defaultMessage: "Any Status"
    }
});
var $11f647a4f4c6e39e$export$2e2bcd8739ae039 = $11f647a4f4c6e39e$var$_default_1;
module.exports["default"] = $11f647a4f4c6e39e$export$2e2bcd8739ae039;

});

parcelRegister("cPgiV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $c090d992f4ddd041$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02Xvy6 _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $c090d992f4ddd041$export$f8acc7966a1e7852 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $c090d992f4ddd041$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $c090d992f4ddd041$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c090d992f4ddd041$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c090d992f4ddd041$var$styles.successSection,
            testId: "create-queue-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c090d992f4ddd041$var$styles.successPillLayout,
            testId: "create-queue-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $c090d992f4ddd041$var$styles.successPill,
            testId: "create-queue-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c090d992f4ddd041$var$styles.successRoot,
            testId: "create-queue-card"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c090d992f4ddd041$var$styles.successRoot,
        testId: "create-queue-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $c090d992f4ddd041$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $c090d992f4ddd041$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c090d992f4ddd041$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c090d992f4ddd041$var$styles.successSection,
        testId: "create-queue-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c090d992f4ddd041$var$styles.successPillLayout,
        testId: "create-queue-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $c090d992f4ddd041$var$styles.successPill,
        testId: "create-queue-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["CreateQueueCardSuccess"] = $c090d992f4ddd041$export$f8acc7966a1e7852;

});

parcelRegister("ihgil", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $66f6c2e488a44da0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue.card-title",
        defaultMessage: "Create queue"
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue.confirm-button",
        defaultMessage: "Create"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue.success-pill",
        defaultMessage: "You've created \"{name}\""
    },
    queueFiltersLabel: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue.queue-filters-label",
        defaultMessage: "JQL queue filters"
    }
});
module.exports["messages"] = $66f6c2e488a44da0$export$defe85febe8b728c;

});

parcelRegister("9gYyc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $4bf0bf7183d3f8f6$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $4bf0bf7183d3f8f6$export$df5de1ce499597af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4bf0bf7183d3f8f6$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4bf0bf7183d3f8f6$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4bf0bf7183d3f8f6$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4bf0bf7183d3f8f6$var$styles.successSection,
            testId: "create-queue-group-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4bf0bf7183d3f8f6$var$styles.successPillLayout,
            testId: "create-queue-group-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4bf0bf7183d3f8f6$var$styles.successPill,
            testId: "create-queue-group-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4bf0bf7183d3f8f6$var$styles.successRoot,
            testId: "create-queue-group-card"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4bf0bf7183d3f8f6$var$styles.successRoot,
        testId: "create-queue-group-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4bf0bf7183d3f8f6$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4bf0bf7183d3f8f6$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4bf0bf7183d3f8f6$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4bf0bf7183d3f8f6$var$styles.successSection,
        testId: "create-queue-group-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4bf0bf7183d3f8f6$var$styles.successPillLayout,
        testId: "create-queue-group-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4bf0bf7183d3f8f6$var$styles.successPill,
        testId: "create-queue-group-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["CreateQueueGroupCardSuccess"] = $4bf0bf7183d3f8f6$export$df5de1ce499597af;

});

parcelRegister("5ydg1", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0ffef823b48c2ee0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.card-title",
        defaultMessage: "Create priority group"
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.confirm-button",
        defaultMessage: "Create"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.success-pill",
        defaultMessage: "You've created \"{name}\" group"
    },
    queuesLabel: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.queues-label",
        defaultMessage: "Add queues"
    },
    emptyQueuesDescription: {
        id: "ai-mate.conversation-assistant-message-actions.create-queue-group.empty-queues-description",
        defaultMessage: "Once created, add queues to help your team stay focused on critical work."
    }
});
module.exports["messages"] = $0ffef823b48c2ee0$export$defe85febe8b728c;

});

parcelRegister("3bHU3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $6RwwD = parcelRequire("6RwwD");


var $4nt1R = parcelRequire("4nt1R");


var $dVPAB = parcelRequire("dVPAB");


var $40ukF = parcelRequire("40ukF");


var $iVGec = parcelRequire("iVGec");


var $hFvHs = parcelRequire("hFvHs");


var $63nNo = parcelRequire("63nNo");


var $2ZvWx = parcelRequire("2ZvWx");


var $cDpdq = parcelRequire("cDpdq");


var $drBXV = parcelRequire("drBXV");

const $c0810ec5a3f2c502$export$451e6f6982270493 = 16000;
const $c0810ec5a3f2c502$export$22e9fc2aa16bb38f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { productKey: productKey, siteId: siteId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== productKey || $[1] !== siteId) {
        t1 = {
            cloudId: siteId,
            product: productKey
        };
        $[0] = productKey;
        $[1] = siteId;
        $[2] = t1;
    } else t1 = $[2];
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(undefined, t1);
    let t2;
    if ($[3] !== formatMessage || $[4] !== linkPicker) {
        t2 = ()=>(0, $4nt1R.createDefaultPreset)({
                placeholder: {
                    placeholder: formatMessage((0, $drBXV.default).jiraIssueCreateDescriptionEditorPlaceholder)
                },
                hyperlinkOptions: {
                    linkPicker: linkPicker
                },
                blockType: {
                    allowBlockType: {
                        exclude: [
                            "heading"
                        ]
                    }
                }
            }).add([
                (0, $63nNo.default),
                $c0810ec5a3f2c502$export$451e6f6982270493
            ]).add((0, $2ZvWx.mentionsPlugin)).add((0, $iVGec.gridPlugin)).add([
                (0, $40ukF.cardPlugin),
                {
                    allowBlockCards: false,
                    allowEmbeds: false,
                    linkPicker: linkPicker,
                    provider: Promise.resolve((0, $6RwwD.editorCardProvider))
                }
            ]).add((0, $hFvHs.listPlugin));
        $[3] = formatMessage;
        $[4] = linkPicker;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[6] = t3;
    } else t3 = $[6];
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(t2, t3);
    let t4;
    if ($[7] !== editorApi || $[8] !== preset) {
        t4 = {
            preset: preset,
            editorApi: editorApi
        };
        $[7] = editorApi;
        $[8] = preset;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ productKey: productKey, siteId: siteId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(undefined, {
        cloudId: siteId,
        product: productKey
    });
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(()=>{
        return (0, $4nt1R.createDefaultPreset)({
            placeholder: {
                placeholder: formatMessage((0, $drBXV.default).jiraIssueCreateDescriptionEditorPlaceholder)
            },
            hyperlinkOptions: {
                linkPicker: linkPicker
            },
            blockType: {
                allowBlockType: {
                    exclude: [
                        'heading'
                    ]
                }
            }
        }).add([
            (0, $63nNo.default),
            $c0810ec5a3f2c502$export$451e6f6982270493
        ]).add((0, $2ZvWx.mentionsPlugin)).add((0, $iVGec.gridPlugin)).add([
            (0, $40ukF.cardPlugin),
            {
                allowBlockCards: false,
                allowEmbeds: false,
                linkPicker: linkPicker,
                provider: Promise.resolve((0, $6RwwD.editorCardProvider))
            }
        ]).add((0, $hFvHs.listPlugin));
    }, []);
    return {
        preset: preset,
        editorApi: editorApi
    };
};
module.exports["useEditorPreset"] = $c0810ec5a3f2c502$export$22e9fc2aa16bb38f;

});

parcelRegister("hTVUf", function(module, exports) {
const $8b522113f3bbf9f0$export$5fdc42997169a20e = (requestFieldValues)=>Object.entries(requestFieldValues).filter(([key, value])=>key !== 'summary' && key !== 'description' && value !== undefined && value !== null && value !== '');
// Helper function to format cascading select values
const $8b522113f3bbf9f0$var$formatCascadingSelectValue = (value)=>{
    let result = value.value;
    if (value.child) result += ` > ${$8b522113f3bbf9f0$var$formatCascadingSelectValue(value.child)}`;
    return result;
};
// Helper function to check if an array is an asset/CMDB field (array of { objectId, workspaceId, id } objects)
const $8b522113f3bbf9f0$var$isAssetField = (value)=>{
    return value.length > 0 && value.every((item)=>item && typeof item === 'object' && 'objectId' in item && 'workspaceId' in item && 'id' in item);
};
// Helper function to check if an array is a multiselect field (array of { value: string } objects)
const $8b522113f3bbf9f0$var$isMultiselectField = (value)=>{
    return value.length > 0 && value.every((item)=>item && typeof item === 'object' && 'value' in item && typeof item.value === 'string');
};
// Helper function to check if an array is a components field (array of { name: string } objects)
const $8b522113f3bbf9f0$var$isComponentsField = (value)=>{
    return value.length > 0 && value.every((item)=>item && typeof item === 'object' && 'name' in item && !('id' in item) && typeof item.name === 'string');
};
// Helper function to check if an object is a cascading select field
const $8b522113f3bbf9f0$var$isCascadingSelectField = (value)=>{
    return Boolean(value && typeof value === 'object' && 'value' in value && typeof value.value === 'string' && (!('child' in value) || typeof value.child === 'object' && value.child !== null));
};
const $8b522113f3bbf9f0$export$1eaed8884d05b5e5 = (requestFieldValues = {}, requestFieldNames = {}, formFieldNames = {}, formFieldChoices = {}, assetNames = {})=>{
    const choiceMaps = formFieldChoices && typeof formFieldChoices === 'object' ? formFieldChoices : {};
    return $8b522113f3bbf9f0$export$5fdc42997169a20e(requestFieldValues).map(([fieldId, value])=>{
        // Handle different field types
        let displayValue = '';
        let actualValue;
        let fieldType = 'unknown';
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            // Handle object values
            if ($8b522113f3bbf9f0$var$isCascadingSelectField(value)) {
                // Handle cascading select field
                actualValue = value;
                fieldType = 'cascading';
                displayValue = $8b522113f3bbf9f0$var$formatCascadingSelectValue(value);
            } else if ('value' in value) {
                // Handle nested value object like { value: "High" }
                actualValue = value.value;
                displayValue = String(actualValue);
            } else if ('name' in value && 'id' in value) {
                // Handle user field like { name: "John Doe", id: "123" }
                actualValue = value.name;
                fieldType = 'user';
                displayValue = String(actualValue);
            } else if ('name' in value && !('id' in value)) {
                // Handle priority field like { name: "High" }
                actualValue = value.name;
                fieldType = 'priority';
                displayValue = String(actualValue);
            } else if ('type' in value && 'content' in value) {
                // Handle ADF document field like { type: "doc", content: [...] }
                actualValue = value;
                fieldType = 'doc';
                displayValue = '[Rich Text Content]'; // Placeholder for ADF content
            } else {
                // Handle other object types
                actualValue = value;
                displayValue = String(actualValue);
            }
        } else if (Array.isArray(value)) {
            // Handle array values
            actualValue = value;
            // Check if it's an asset/CMDB field (array of { objectId, workspaceId, id } objects)
            if ($8b522113f3bbf9f0$var$isAssetField(value)) {
                fieldType = 'asset';
                displayValue = value// eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map((item)=>assetNames[item.objectId] ?? item.objectId).join(', ');
            } else if ($8b522113f3bbf9f0$var$isMultiselectField(value)) {
                // Check if it's a multiselect field (array of { value: string } objects)
                fieldType = 'multiselect';
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                displayValue = value.map((item)=>item.value).join(', ');
            } else if ($8b522113f3bbf9f0$var$isComponentsField(value)) {
                // Check if it's a components field (array of { name: string } objects)
                fieldType = 'components';
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                displayValue = value.map((item)=>item.name).join(', ');
            } else if (value.length > 0 && value[0] && typeof value[0] === 'object' && 'name' in value[0] && 'id' in value[0]) {
                // Check if it's an array of user objects
                fieldType = 'user';
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                displayValue = value.map((user)=>user.name).join(', ');
            } else {
                // Handle other array types (e.g. form choice IDs or asset choices)
                const choiceMap = choiceMaps[fieldId];
                if (choiceMap && value.every((item)=>typeof item === 'string')) displayValue = value.map((item)=>choiceMap[item] || String(item)).join(', ');
                else if (Object.keys(assetNames).length > 0 && value.every((item)=>typeof item === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:.+$/i.test(item))) // Handle asset choices in form answers (format: "workspaceId:objectId")
                displayValue = value.map((item)=>{
                    const objectId = item.split(':').slice(1).join(':');
                    return assetNames[objectId] ?? item;
                }).join(', ');
                else displayValue = value.join(', ');
            }
        } else {
            // Handle direct values
            actualValue = value;
            const choiceMap = choiceMaps[fieldId];
            if (choiceMap && typeof actualValue === 'string') displayValue = choiceMap[actualValue] || actualValue;
            else displayValue = String(actualValue);
        }
        return {
            id: fieldId,
            label: String(requestFieldNames[fieldId] || formFieldNames[fieldId] || fieldId),
            type: fieldType,
            value: actualValue,
            displayValue: displayValue
        };
    });
};
const $8b522113f3bbf9f0$export$2d57c2f62672dce2 = (formAnswers = {})=>{
    const fieldValues = {};
    Object.entries(formAnswers).forEach(([questionId, answer])=>{
        if (answer.text !== undefined) fieldValues[questionId] = answer.text;
        else if (answer.user !== undefined) fieldValues[questionId] = answer.user;
        else if (Array.isArray(answer.users)) fieldValues[questionId] = answer.users;
        else if (Array.isArray(answer.choices)) fieldValues[questionId] = answer.choices;
        else if (typeof answer.date === 'string' && typeof answer.time === 'string' && answer.date && answer.time) fieldValues[questionId] = `${answer.date} ${answer.time}`;
        else if (answer.date !== undefined) fieldValues[questionId] = answer.date;
        else if (answer.time !== undefined) fieldValues[questionId] = answer.time;
        else {
            // Preserve any primitive fallback values to avoid silently hiding fields.
            const fallbackValue = Object.values(answer).find((value)=>typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean');
            if (fallbackValue !== undefined) fieldValues[questionId] = fallbackValue;
        }
    });
    return fieldValues;
};
const $8b522113f3bbf9f0$export$348154f6a97f5dba = (action)=>{
    return 'inputs' in action.data ? true : false;
};
module.exports["createFieldInfoFromResponse"] = $8b522113f3bbf9f0$export$1eaed8884d05b5e5;
module.exports["convertFormAnswersToFieldValues"] = $8b522113f3bbf9f0$export$2d57c2f62672dce2;
module.exports["isActionWithInputs"] = $8b522113f3bbf9f0$export$348154f6a97f5dba;

});

parcelRegister("gJxEM", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3931609aaa46a0e2$var$message = (0, $kSwu1.defineMessages)({
    jsmCreateRequestInstruction: {
        id: "conversation-assistant-message-actions.jsm-create-request.instruction-1",
        defaultMessage: "Review and edit the details below, then click {createButtonCopy} to raise your request."
    },
    jsmCreateRequestTitle: {
        id: "conversation-assistant-message-actions.jsm-create-request.title",
        defaultMessage: "Create request"
    },
    summaryLabel: {
        id: "conversation-assistant-message-actions.jsm-create-request.summary-label",
        defaultMessage: "Summary"
    },
    descriptionLabel: {
        id: "conversation-assistant-message-actions.jsm-create-request.description-label",
        defaultMessage: "Description"
    },
    createRequestButton: {
        id: "conversation-assistant-message-actions.jsm-create-request.create-request-button-1",
        defaultMessage: "Raise request"
    },
    jsmRequestCreatedTitle: {
        id: "conversation-assistant-message-actions.jsm-create-request.created-title-1",
        defaultMessage: "Request raised"
    },
    jsmRequestCreatedDescription: {
        id: "conversation-assistant-message-actions.jsm-create-request.created-description-1",
        defaultMessage: "Your service request has been raised successfully."
    },
    jsmRequestErrorTitle: {
        id: "conversation-assistant-message-actions.jsm-create-request.error-title-1",
        defaultMessage: "Error raising request"
    },
    jsmRequestErrorDescription: {
        id: "conversation-assistant-message-actions.jsm-create-request.error-description-1",
        defaultMessage: "There was an error raising your service request. Please try again."
    },
    additionalFieldsLabel: {
        id: "conversation-assistant-message-actions.jsm-create-request.additional-fields-label",
        defaultMessage: "Additional Fields:"
    },
    fieldNotSet: {
        id: "conversation-assistant-message-actions.jsm-create-request.field-not-set",
        defaultMessage: "Not set"
    }
});
var $3931609aaa46a0e2$export$2e2bcd8739ae039 = $3931609aaa46a0e2$var$message;
module.exports["default"] = $3931609aaa46a0e2$export$2e2bcd8739ae039;

});

parcelRegister("hWJgs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $8500a890cf5bb886$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02Xvy6 _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $8500a890cf5bb886$export$c339557d044cff16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $8500a890cf5bb886$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $8500a890cf5bb886$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8500a890cf5bb886$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8500a890cf5bb886$var$styles.successSection,
            testId: "create-request-type-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8500a890cf5bb886$var$styles.successPillLayout,
            testId: "create-request-type-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $8500a890cf5bb886$var$styles.successPill,
            testId: "create-request-type-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8500a890cf5bb886$var$styles.successRoot,
            testId: "create-request-type-card"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8500a890cf5bb886$var$styles.successRoot,
        testId: "create-request-type-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $8500a890cf5bb886$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $8500a890cf5bb886$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8500a890cf5bb886$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8500a890cf5bb886$var$styles.successSection,
        testId: "create-request-type-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8500a890cf5bb886$var$styles.successPillLayout,
        testId: "create-request-type-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $8500a890cf5bb886$var$styles.successPill,
        testId: "create-request-type-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["CreateRequestTypeCardSuccess"] = $8500a890cf5bb886$export$c339557d044cff16;

});

parcelRegister("2qdFq", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $58538c585aa4f628$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.card-title",
        defaultMessage: "Create request type"
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.confirm-button",
        defaultMessage: "Create"
    },
    expandSection: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.expand-section",
        defaultMessage: "Show more"
    },
    collapseSection: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.collapse-section",
        defaultMessage: "Show less"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.create-request-type.success-pill",
        defaultMessage: "You've created \"{name}\""
    }
});
module.exports["messages"] = $58538c585aa4f628$export$defe85febe8b728c;

});

parcelRegister("hsaYC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $099d6655e878111b$var$message = (0, $kSwu1.defineMessages)({
    jsmLivechatInstruction: {
        id: "conversation-assistant-message-actions.jsm-livechat.instruction",
        defaultMessage: "Review and edit the details below, then click {startChatButtonCopy} to connect with a live agent."
    },
    jsmLivechatTitle: {
        id: "conversation-assistant-message-actions.jsm-livechat.title",
        defaultMessage: "Chat with live agent"
    },
    summaryLabel: {
        id: "conversation-assistant-message-actions.jsm-livechat.summary-label",
        defaultMessage: "Summary"
    },
    descriptionLabel: {
        id: "conversation-assistant-message-actions.jsm-livechat.description-label",
        defaultMessage: "Description"
    },
    startChatButton: {
        id: "conversation-assistant-message-actions.jsm-livechat.start-chat-button",
        defaultMessage: "Start chat"
    },
    jsmLivechatErrorTitle: {
        id: "conversation-assistant-message-actions.jsm-livechat.error-title",
        defaultMessage: "Error starting chat"
    },
    jsmLivechatErrorDescription: {
        id: "conversation-assistant-message-actions.jsm-livechat.error-description",
        defaultMessage: "There was an error starting the live chat. Please try again."
    },
    additionalFieldsLabel: {
        id: "conversation-assistant-message-actions.jsm-livechat.additional-fields-label",
        defaultMessage: "Additional Fields:"
    }
});
var $099d6655e878111b$export$2e2bcd8739ae039 = $099d6655e878111b$var$message;
module.exports["default"] = $099d6655e878111b$export$2e2bcd8739ae039;

});

parcelRegister("glSKz", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $cb26439ce7c1da60$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.select-hardware-types.card-title",
        defaultMessage: "Select hardware types"
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.select-hardware-types.confirm-button",
        defaultMessage: "Start setup"
    },
    expandSection: {
        id: "ai-mate.conversation-assistant-message-actions.select-hardware-types.expand-section",
        defaultMessage: "Show more"
    },
    collapseSection: {
        id: "ai-mate.conversation-assistant-message-actions.select-hardware-types.collapse-section",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.select-hardware-types.success-pill",
        defaultMessage: "Hardware types selected successfully"
    }
});
module.exports["messages"] = $cb26439ce7c1da60$export$defe85febe8b728c;

});

parcelRegister("9R2yg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $2dupP = parcelRequire("2dupP");


var $eh6Ml = parcelRequire("eh6Ml");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $2a858543d4a71f5c$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02Xvy6 _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $2a858543d4a71f5c$export$5c024938a44ae4b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $2a858543d4a71f5c$var$styles.headerIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2dupP))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $2a858543d4a71f5c$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2a858543d4a71f5c$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2a858543d4a71f5c$var$styles.successSection,
            testId: "select-hardware-types-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2a858543d4a71f5c$var$styles.successPillLayout,
            testId: "select-hardware-types-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $2a858543d4a71f5c$var$styles.successPill,
            testId: "select-hardware-types-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2a858543d4a71f5c$var$styles.successRoot,
            testId: "select-hardware-types-card"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2a858543d4a71f5c$var$styles.successRoot,
        testId: "select-hardware-types-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $2a858543d4a71f5c$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $2a858543d4a71f5c$var$styles.headerIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2dupP))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2a858543d4a71f5c$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2a858543d4a71f5c$var$styles.successSection,
        testId: "select-hardware-types-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2a858543d4a71f5c$var$styles.successPillLayout,
        testId: "select-hardware-types-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $2a858543d4a71f5c$var$styles.successPill,
        testId: "select-hardware-types-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["SelectHardwareTypesCardSuccess"] = $2a858543d4a71f5c$export$5c024938a44ae4b7;

});

parcelRegister("hu68Y", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $9InHK = parcelRequire("9InHK");


var $7cN3Y = parcelRequire("7cN3Y");

const $c96f1a44299021f0$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX = 242;
const $c96f1a44299021f0$var$styles = {
    contentSectionOuter: "_1mT5xdRAKS _39xV02N91d _4xdlr0FlnN",
    contentInner: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4xdlr0FlnN _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    contentInner_clamped: "_0NUa3rscCB _2WAcuGnQyn",
    sectionList: "_4xdlr0FlnN _4ouGXIdnbC",
    fadeOffZone: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VUofl _39xV02N91d _3CkH9oxIbU _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButton: "_0bjKvDyzSk _2sNsIg7NXe _4c065U1Y8M _2Y7lL48HPE _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzZpcK _0KLXrulfZc _42Yu6BgtVO _1eOmH6d1Zr _3gzVzLJNoT"
};
const $c96f1a44299021f0$var$ShowMoreButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onExpand: onExpand } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $7cN3Y.messages).expandBodyContent);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onExpand || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c96f1a44299021f0$var$styles.fadeOffZone
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $c96f1a44299021f0$var$styles.showMoreButton,
            onClick: onExpand,
            testId: "jsm-solution-composer-plan-task-card.content-expand-button"
        }, t1));
        $[2] = onExpand;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c96f1a44299021f0$var$styles.fadeOffZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $c96f1a44299021f0$var$styles.showMoreButton,
        onClick: onExpand,
        testId: "jsm-solution-composer-plan-task-card.content-expand-button"
    }, formatMessage((0, $7cN3Y.messages).expandBodyContent)));
};
const $c96f1a44299021f0$export$cd58b8b0fb5784c0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { sections: sections, summaryItems: summaryItems } = t0;
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentInnerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const el = contentInnerRef.current;
            if (!el) return;
            setHasTruncatableBodyContent(el.scrollHeight > $c96f1a44299021f0$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
        };
        $[0] = t1;
    } else t1 = $[0];
    const measureBodyOverflow = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setHasUserExpandedBody(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== sections) {
        t3 = [
            sections
        ];
        $[2] = sections;
        $[3] = t3;
    } else t3 = $[3];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            measureBodyOverflow();
        };
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== sections) {
        t5 = [
            measureBodyOverflow,
            sections
        ];
        $[5] = sections;
        $[6] = t5;
    } else t5 = $[6];
    (0, $cozmU.useLayoutEffect)(t4, t5);
    let t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            const el_0 = contentInnerRef.current;
            if (!el_0 || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(()=>{
                measureBodyOverflow();
            });
            observer.observe(el_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t7 = [
            measureBodyOverflow
        ];
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    (0, $cozmU.useLayoutEffect)(t6, t7);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setHasUserExpandedBody(true);
        };
        $[9] = t8;
    } else t8 = $[9];
    const handleExpandBody = t8;
    const t9 = isClamped && $c96f1a44299021f0$var$styles.contentInner_clamped;
    let t10;
    if ($[10] !== t9) {
        t10 = (0, $w6R6I.cx)($c96f1a44299021f0$var$styles.contentInner, t9);
        $[10] = t9;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== summaryItems) {
        t11 = summaryItems && summaryItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9InHK.CardMetadataSummary), {
            items: summaryItems
        }) : null;
        $[12] = summaryItems;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== sections) {
        t12 = sections.map($c96f1a44299021f0$var$_temp);
        $[14] = sections;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.200",
            xcss: $c96f1a44299021f0$var$styles.sectionList
        }, t12);
        $[16] = t12;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== t10 || $[19] !== t11 || $[20] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: contentInnerRef,
            testId: "jsm-solution-composer-plan-task-card.content",
            xcss: t10
        }, t11, t13);
        $[18] = t10;
        $[19] = t11;
        $[20] = t13;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== isClamped) {
        t15 = isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c96f1a44299021f0$var$ShowMoreButton, {
            onExpand: handleExpandBody
        }) : null;
        $[22] = isClamped;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t14 || $[25] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c96f1a44299021f0$var$styles.contentSectionOuter
        }, t14, t15);
        $[24] = t14;
        $[25] = t15;
        $[26] = t16;
    } else t16 = $[26];
    return t16;
} : ({ sections: sections, summaryItems: summaryItems })=>{
    const [hasUserExpandedBody, setHasUserExpandedBody] = (0, $cozmU.useState)(false);
    const [hasTruncatableBodyContent, setHasTruncatableBodyContent] = (0, $cozmU.useState)(false);
    const contentInnerRef = (0, $cozmU.useRef)(null);
    const measureBodyOverflow = (0, $cozmU.useCallback)(()=>{
        const el = contentInnerRef.current;
        if (!el) return;
        setHasTruncatableBodyContent(el.scrollHeight > $c96f1a44299021f0$var$MAX_BODY_HEIGHT_BEFORE_TRUNCATE_PX);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        setHasUserExpandedBody(false);
    }, [
        sections
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measureBodyOverflow();
    }, [
        measureBodyOverflow,
        sections
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const el_0 = contentInnerRef.current;
        if (!el_0 || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            measureBodyOverflow();
        });
        observer.observe(el_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        measureBodyOverflow
    ]);
    const isClamped = hasTruncatableBodyContent && !hasUserExpandedBody;
    const handleExpandBody = (0, $cozmU.useCallback)(()=>{
        setHasUserExpandedBody(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c96f1a44299021f0$var$styles.contentSectionOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: contentInnerRef,
        testId: "jsm-solution-composer-plan-task-card.content",
        xcss: (0, $w6R6I.cx)($c96f1a44299021f0$var$styles.contentInner, isClamped && $c96f1a44299021f0$var$styles.contentInner_clamped)
    }, summaryItems && summaryItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9InHK.CardMetadataSummary), {
        items: summaryItems
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.200",
        xcss: $c96f1a44299021f0$var$styles.sectionList
    }, sections.map((section)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            key: section.title,
            direction: "column",
            alignItems: "start",
            gap: "space.100",
            xcss: $c96f1a44299021f0$var$styles.sectionList
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, section.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "regular",
            color: "color.text"
        }, section.description))))), isClamped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c96f1a44299021f0$var$ShowMoreButton, {
        onExpand: handleExpandBody
    }) : null);
};
function $c96f1a44299021f0$var$_temp(section) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        key: section.title,
        direction: "column",
        alignItems: "start",
        gap: "space.100",
        xcss: $c96f1a44299021f0$var$styles.sectionList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, section.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "regular",
        color: "color.text"
    }, section.description));
}
module.exports["TaskCardContent"] = $c96f1a44299021f0$export$cd58b8b0fb5784c0;

});

parcelRegister("2u2Ud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $eKMV3 = parcelRequire("eKMV3");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $g9AEK = parcelRequire("g9AEK");


var $7qe5K = parcelRequire("7qe5K");

const $718aada07c2e49d2$var$styles = {
    container: "_2mHwu82ADO _2bqfgdOeNX _3iDTPbQ4SZ _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _37wbyuz9WS _0hPCNLDIqT _4xdlr0FlnN"
};
const $718aada07c2e49d2$export$b3f18c2c00c25877 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { onCreateSpace: onCreateSpace, isExecuted: isExecuted, projectKey: projectKey, isDisabled: isDisabled, hasBeenActioned: hasBeenActioned, onActioned: onActioned } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] !== onActioned || $[1] !== onCreateSpace || $[2] !== sendAnalyticsEvent) {
        t1 = (_, analyticsEvent)=>{
            onCreateSpace();
            onActioned();
            sendAnalyticsEvent(analyticsEvent.update({
                actionSubjectId: "jsmSolutionComposerPlanCreateSpaceButton",
                attributes: (0, $g9AEK.analyticsAttributes)
            }));
        };
        $[0] = onActioned;
        $[1] = onCreateSpace;
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const handleCreateSpace = t1;
    const viewSpaceHref = isExecuted && projectKey ? `${window.location.origin}/jira/servicedesk/projects/${projectKey}/getting-started?source=${0, $g9AEK.ROVO_CREATE_VIEW_SPACE_SOURCE}` : undefined;
    let t2;
    if ($[4] !== formatMessage || $[5] !== handleCreateSpace || $[6] !== hasBeenActioned || $[7] !== isDisabled || $[8] !== viewSpaceHref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $718aada07c2e49d2$var$styles.container
        }, viewSpaceHref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "primary",
            href: viewSpaceHref
        }, formatMessage((0, $7qe5K.messages).viewSpace)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: isDisabled || hasBeenActioned,
            onClick: handleCreateSpace
        }, formatMessage((0, $7qe5K.messages).createSpace)));
        $[4] = formatMessage;
        $[5] = handleCreateSpace;
        $[6] = hasBeenActioned;
        $[7] = isDisabled;
        $[8] = viewSpaceHref;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ onCreateSpace: onCreateSpace, isExecuted: isExecuted, projectKey: projectKey, isDisabled: isDisabled, hasBeenActioned: hasBeenActioned, onActioned: onActioned })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleCreateSpace = (0, $cozmU.useCallback)((_, analyticsEvent)=>{
        onCreateSpace();
        onActioned();
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'jsmSolutionComposerPlanCreateSpaceButton',
            attributes: (0, $g9AEK.analyticsAttributes)
        }));
    }, [
        onCreateSpace,
        onActioned,
        sendAnalyticsEvent
    ]);
    const viewSpaceHref = isExecuted && projectKey ? `${window.location.origin}/jira/servicedesk/projects/${projectKey}/getting-started?source=${0, $g9AEK.ROVO_CREATE_VIEW_SPACE_SOURCE}` : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $718aada07c2e49d2$var$styles.container
    }, viewSpaceHref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "primary",
        href: viewSpaceHref
    }, formatMessage((0, $7qe5K.messages).viewSpace)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: isDisabled || hasBeenActioned,
        onClick: handleCreateSpace
    }, formatMessage((0, $7qe5K.messages).createSpace)));
};
module.exports["TaskCardFooter"] = $718aada07c2e49d2$export$b3f18c2c00c25877;

});

parcelRegister("hLTYT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $aOjGz = parcelRequire("aOjGz");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $g9AEK = parcelRequire("g9AEK");


var $jIgdB = parcelRequire("jIgdB");

const $bf759e00c48bdd51$var$styles = {
    container: "_2mHwu88HPE _1x1D3gOeNX _3iDTPbQ4SZ _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0hPCNLDIqT _4xdlr0FlnN",
    container_collapsed: "_1x1D3gYbGa",
    iconHeadingRow: "_2mHwu88HPE _2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _3iDTPbQ4SZ _0hPCNLDIqT",
    headingWrapper: "_2fwxA5DIqT",
    expandToggleWrap: "_0GTcwRIZbP"
};
const $bf759e00c48bdd51$export$2d3de61272482ca = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { title: title, isExpanded: isExpanded, onToggle: onToggle } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    let t1;
    if ($[0] !== isExpanded || $[1] !== onToggle || $[2] !== sendAnalyticsEvent) {
        t1 = (_, analyticsEvent)=>{
            onToggle();
            sendAnalyticsEvent(analyticsEvent.update({
                action: isExpanded ? "collapsed" : "expanded",
                actionSubject: "iconButton",
                actionSubjectId: "jsmSolutionComposerPlanTaskCardHeaderToggle",
                attributes: (0, $g9AEK.analyticsAttributes)
            }));
        };
        $[0] = isExpanded;
        $[1] = onToggle;
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const handleToggleClick = t1;
    const t2 = !isExpanded && $bf759e00c48bdd51$var$styles.container_collapsed;
    let t3;
    if ($[4] !== t2) {
        t3 = (0, $w6R6I.cx)($bf759e00c48bdd51$var$styles.container, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))),
            label: "",
            appearance: "gray",
            size: "medium"
        });
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $bf759e00c48bdd51$var$styles.iconHeadingRow
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bf759e00c48bdd51$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            color: "color.text"
        }, title)));
        $[7] = title;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = isExpanded ? (0, $jIgdB.messages).collapseSection : (0, $jIgdB.messages).expandSection;
    let t7;
    if ($[9] !== formatMessage || $[10] !== t6) {
        t7 = formatMessage(t6);
        $[9] = formatMessage;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== ExpandCollapseIcon || $[13] !== handleToggleClick || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bf759e00c48bdd51$var$styles.expandToggleWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: ExpandCollapseIcon,
            label: t7,
            appearance: "subtle",
            spacing: "compact",
            onClick: handleToggleClick,
            testId: "jsm-solution-composer-plan-task-card.header-expand-toggle"
        }));
        $[12] = ExpandCollapseIcon;
        $[13] = handleToggleClick;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t3 || $[17] !== t5 || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: t3
        }, t5, t8);
        $[16] = t3;
        $[17] = t5;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ title: title, isExpanded: isExpanded, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const ExpandCollapseIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const handleToggleClick = (0, $cozmU.useCallback)((_, analyticsEvent)=>{
        onToggle();
        sendAnalyticsEvent(analyticsEvent.update({
            action: isExpanded ? 'collapsed' : 'expanded',
            actionSubject: 'iconButton',
            actionSubjectId: 'jsmSolutionComposerPlanTaskCardHeaderToggle',
            attributes: (0, $g9AEK.analyticsAttributes)
        }));
    }, [
        onToggle,
        sendAnalyticsEvent,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($bf759e00c48bdd51$var$styles.container, !isExpanded && $bf759e00c48bdd51$var$styles.container_collapsed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $bf759e00c48bdd51$var$styles.iconHeadingRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))),
        label: "",
        appearance: "gray",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bf759e00c48bdd51$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        color: "color.text"
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bf759e00c48bdd51$var$styles.expandToggleWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ExpandCollapseIcon,
        label: formatMessage(isExpanded ? (0, $jIgdB.messages).collapseSection : (0, $jIgdB.messages).expandSection),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleToggleClick,
        testId: "jsm-solution-composer-plan-task-card.header-expand-toggle"
    })));
};
module.exports["TaskCardHeader"] = $bf759e00c48bdd51$export$2d3de61272482ca;

});

parcelRegister("79CeW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $244df5bdb2d0e0e1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "jsm-solution-composer-plan.task-card.card-title",
        defaultMessage: "Create Jira Service Management space"
    },
    spaceNameLabel: {
        id: "jsm-solution-composer-plan.task-card.space-name-label",
        defaultMessage: "Space name"
    },
    spaceKeyLabel: {
        id: "jsm-solution-composer-plan.task-card.space-key-label",
        defaultMessage: "Space key"
    },
    channelAccessLabel: {
        id: "jsm-solution-composer-plan.task-card.channel-access-label",
        defaultMessage: "Channel access"
    },
    channelAccessClosedValue: {
        id: "jsm-solution-composer-plan.task-card.channel-access-closed-value",
        defaultMessage: "Restricted"
    }
});
module.exports["messages"] = $244df5bdb2d0e0e1$export$defe85febe8b728c;

});

parcelRegister("1sFBi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ea13c5db586e3072$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.card-title",
        defaultMessage: "Update queue"
    },
    nameFieldLabel: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.name-field-label",
        defaultMessage: "Update queue name from \"<bold>{currentName}</bold>\" to \"<bold>{newName}</bold>\""
    },
    jqlFieldLabel: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.jql-field-label",
        defaultMessage: "Update JQL queue filters"
    },
    columnsFieldLabel: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.columns-field-label",
        defaultMessage: "Following are the updated the columns for this queue:"
    },
    emptyColumnsDescription: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.empty-columns-description",
        defaultMessage: "This queue has no columns. Add columns to show your team how the queue is ordered."
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.confirm-button",
        defaultMessage: "Update"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue.success-pill",
        defaultMessage: "You've updated \"{name}\""
    }
});
module.exports["messages"] = $ea13c5db586e3072$export$defe85febe8b728c;

});

parcelRegister("g6QTb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $bdca7499cd7b700d$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02Xvy6 _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $bdca7499cd7b700d$export$ede05b312b5ac321 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $bdca7499cd7b700d$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $bdca7499cd7b700d$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bdca7499cd7b700d$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bdca7499cd7b700d$var$styles.successSection,
            testId: "update-queue-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bdca7499cd7b700d$var$styles.successPillLayout,
            testId: "update-queue-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $bdca7499cd7b700d$var$styles.successPill,
            testId: "update-queue-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bdca7499cd7b700d$var$styles.successRoot,
            testId: "update-queue-card"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bdca7499cd7b700d$var$styles.successRoot,
        testId: "update-queue-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $bdca7499cd7b700d$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $bdca7499cd7b700d$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bdca7499cd7b700d$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bdca7499cd7b700d$var$styles.successSection,
        testId: "update-queue-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bdca7499cd7b700d$var$styles.successPillLayout,
        testId: "update-queue-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $bdca7499cd7b700d$var$styles.successPill,
        testId: "update-queue-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["UpdateQueueCardSuccess"] = $bdca7499cd7b700d$export$ede05b312b5ac321;

});

parcelRegister("4QeNf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3f90cd100ab94386$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.card-title",
        defaultMessage: "Update priority group"
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.confirm-button",
        defaultMessage: "Update"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.success-pill",
        defaultMessage: "You've updated \"{name}\" group"
    },
    queuesLabel: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.queues-label",
        defaultMessage: "Following are the updated queues in this group:"
    },
    emptyQueuesDescription: {
        id: "ai-mate.conversation-assistant-message-actions.update-queue-group.empty-queues-description",
        defaultMessage: "This group will have no queues."
    }
});
module.exports["messages"] = $3f90cd100ab94386$export$defe85febe8b728c;

});

parcelRegister("8eiw2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $f8285bf32ec7270e$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $f8285bf32ec7270e$export$6b22e6817b1e6bca = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f8285bf32ec7270e$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f8285bf32ec7270e$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8285bf32ec7270e$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8285bf32ec7270e$var$styles.successSection,
            testId: "update-queue-group-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8285bf32ec7270e$var$styles.successPillLayout,
            testId: "update-queue-group-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f8285bf32ec7270e$var$styles.successPill,
            testId: "update-queue-group-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f8285bf32ec7270e$var$styles.successRoot,
            testId: "update-queue-group-card-success"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8285bf32ec7270e$var$styles.successRoot,
        testId: "update-queue-group-card-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f8285bf32ec7270e$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f8285bf32ec7270e$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8285bf32ec7270e$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8285bf32ec7270e$var$styles.successSection,
        testId: "update-queue-group-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f8285bf32ec7270e$var$styles.successPillLayout,
        testId: "update-queue-group-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f8285bf32ec7270e$var$styles.successPill,
        testId: "update-queue-group-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["UpdateQueueGroupCardSuccess"] = $f8285bf32ec7270e$export$6b22e6817b1e6bca;

});

parcelRegister("c1wJY", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4a867c15f34aa31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.card-title",
        defaultMessage: "Update request type"
    },
    fieldsToAddHeading: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.fields-to-add-heading",
        defaultMessage: "Fields to add:"
    },
    nextButton: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.next-button",
        defaultMessage: "Update"
    },
    expandSection: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.expand-section",
        defaultMessage: "Show more"
    },
    collapseSection: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.collapse-section",
        defaultMessage: "Show less"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type.success-pill",
        defaultMessage: "You've updated \"{requestType}\""
    }
});
module.exports["messages"] = $4a867c15f34aa31c$export$defe85febe8b728c;

});

parcelRegister("fs2ae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $4711aad2e7f43b5e$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02Xvy6 _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $4711aad2e7f43b5e$export$eb9b11d4445413e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4711aad2e7f43b5e$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4711aad2e7f43b5e$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4711aad2e7f43b5e$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4711aad2e7f43b5e$var$styles.successSection,
            testId: "update-request-type-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4711aad2e7f43b5e$var$styles.successPillLayout,
            testId: "update-request-type-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $4711aad2e7f43b5e$var$styles.successPill,
            justifyContent: "center",
            alignItems: "center",
            testId: "update-request-type-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            align: "center"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4711aad2e7f43b5e$var$styles.successRoot,
            testId: "update-request-type-card"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4711aad2e7f43b5e$var$styles.successRoot,
        testId: "update-request-type-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4711aad2e7f43b5e$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4711aad2e7f43b5e$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4711aad2e7f43b5e$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4711aad2e7f43b5e$var$styles.successSection,
        testId: "update-request-type-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4711aad2e7f43b5e$var$styles.successPillLayout,
        testId: "update-request-type-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $4711aad2e7f43b5e$var$styles.successPill,
        justifyContent: "center",
        alignItems: "center",
        testId: "update-request-type-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        align: "center"
    }, successMessage)))));
};
module.exports["UpdateRequestTypeCardSuccess"] = $4711aad2e7f43b5e$export$eb9b11d4445413e1;

});

parcelRegister("bNm29", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $5c4a31c95a38bf2b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.card-title",
        defaultMessage: "Update request type"
    },
    groupsFieldLabel: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.groups-field-label",
        defaultMessage: "Following are the updated portal groups:"
    },
    emptyGroupsDescription: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.empty-groups-description",
        defaultMessage: "This request type won\u2019t be assigned to any portal groups, so it won't appear in your help center."
    },
    confirmButton: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.confirm-button",
        defaultMessage: "Update"
    },
    expandBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.expand-body-content",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.collapse-body-content",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.success-pill",
        defaultMessage: "You've updated \"{requestTypeName}\""
    }
});
module.exports["messages"] = $5c4a31c95a38bf2b$export$defe85febe8b728c;

});

parcelRegister("1P1Uj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $f164e372dbeaf178$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $f164e372dbeaf178$export$51ccc0ea7533ca0b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f164e372dbeaf178$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f164e372dbeaf178$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f164e372dbeaf178$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f164e372dbeaf178$var$styles.successSection,
            testId: "update-request-type-portal-groups-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f164e372dbeaf178$var$styles.successPillLayout,
            testId: "update-request-type-portal-groups-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $f164e372dbeaf178$var$styles.successPill,
            testId: "update-request-type-portal-groups-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f164e372dbeaf178$var$styles.successRoot,
            testId: "update-request-type-portal-groups-card-success"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f164e372dbeaf178$var$styles.successRoot,
        testId: "update-request-type-portal-groups-card-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f164e372dbeaf178$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f164e372dbeaf178$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f164e372dbeaf178$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f164e372dbeaf178$var$styles.successSection,
        testId: "update-request-type-portal-groups-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f164e372dbeaf178$var$styles.successPillLayout,
        testId: "update-request-type-portal-groups-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $f164e372dbeaf178$var$styles.successPill,
        testId: "update-request-type-portal-groups-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["UpdateRequestTypePortalGroupsCardSuccess"] = $f164e372dbeaf178$export$51ccc0ea7533ca0b;

});

parcelRegister("i6XkY", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $84b570d894f68984$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardTitle: {
        id: "conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.cardTitle",
        defaultMessage: "Update request type"
    },
    workflowDescription: {
        id: "conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.workflowDescription",
        defaultMessage: "Update work type to <bold>\"{workTypeName}\"</bold>"
    },
    confirmButton: {
        id: "conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.confirmButton",
        defaultMessage: "Update"
    },
    expandBodyContent: {
        id: "conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.expandBodyContent",
        defaultMessage: "Show more"
    },
    collapseBodyContent: {
        id: "conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.collapseBodyContent",
        defaultMessage: "Show less"
    },
    successPill: {
        id: "conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.successPill",
        defaultMessage: "You've updated \"{requestTypeName}\""
    }
});
module.exports["messages"] = $84b570d894f68984$export$defe85febe8b728c;

});

parcelRegister("iqA39", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iRFKG = parcelRequire("iRFKG");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $a73d774d6a849275$var$styles = {
    successRoot: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _24h04i2Njc",
    titleSection: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc _0jFU0V9LX5 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru7Cj1",
    headerWorkItemIconWrap: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    headingWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _4ouGXIdnbC",
    successSection: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _4xdlr0FlnN _0KLXruqi9L",
    successPillLayout: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    successPill: "_2mHwu8gVvo _0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $a73d774d6a849275$export$4e2381833994e33 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { heading: heading, successMessage: successMessage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a73d774d6a849275$var$styles.headerWorkItemIconWrap,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            label: "",
            spacing: "none",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a73d774d6a849275$var$styles.titleSection
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a73d774d6a849275$var$styles.headingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, heading)));
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "none"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== successMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a73d774d6a849275$var$styles.successSection,
            testId: "update-request-type-workflow-card.success-pill-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a73d774d6a849275$var$styles.successPillLayout,
            testId: "update-request-type-workflow-card.success-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a73d774d6a849275$var$styles.successPill,
            testId: "update-request-type-workflow-card.success-pill"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, successMessage))));
        $[4] = successMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a73d774d6a849275$var$styles.successRoot,
            testId: "update-request-type-workflow-card-success"
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ heading: heading, successMessage: successMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a73d774d6a849275$var$styles.successRoot,
        testId: "update-request-type-workflow-card-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a73d774d6a849275$var$styles.titleSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a73d774d6a849275$var$styles.headerWorkItemIconWrap,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a73d774d6a849275$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a73d774d6a849275$var$styles.successSection,
        testId: "update-request-type-workflow-card.success-pill-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a73d774d6a849275$var$styles.successPillLayout,
        testId: "update-request-type-workflow-card.success-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a73d774d6a849275$var$styles.successPill,
        testId: "update-request-type-workflow-card.success-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, successMessage)))));
};
module.exports["UpdateRequestTypeWorkflowCardSuccess"] = $a73d774d6a849275$export$4e2381833994e33;

});

parcelRegister("8d5Av", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $38c7672f02922c73$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    projectSelectorHeader: {
        id: "conversation-assistant-message-actions.require-information-tool.project-selector.header",
        defaultMessage: "Select a project"
    }
});
module.exports["messages"] = $38c7672f02922c73$export$defe85febe8b728c;

});

parcelRegister("dB2wu", function(module, exports) {
module.exports = new URL("scheduled-chat-header.0130110c.svg", import.meta.url).toString();

});

parcelRegister("jseyQ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f66edcd150a82a1e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    repeat: {
        id: "conversation-assistant-ui-components.scheduled-chat-preview-card.repeat",
        defaultMessage: "Repeat"
    },
    nextRun: {
        id: "conversation-assistant-ui-components.scheduled-chat-preview-card.next-run",
        defaultMessage: "Next run"
    },
    nextRunAt: {
        id: "conversation-assistant-ui-components.scheduled-chat-preview-card.next-run-at",
        defaultMessage: "Next run {nextRunLabel}"
    },
    delete: {
        id: "conversation-assistant-ui-components.scheduled-chat-preview-card.delete",
        defaultMessage: "Delete"
    },
    edit: {
        id: "conversation-assistant-ui-components.scheduled-chat-preview-card.edit",
        defaultMessage: "Edit"
    }
});
module.exports["messages"] = $f66edcd150a82a1e$export$defe85febe8b728c;

});

parcelRegister("aXPTn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $bxtuo = parcelRequire("bxtuo");

const $eb5e53c63ef33975$var$styles = {
    footer: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $eb5e53c63ef33975$export$e9897d434e0741ee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onConfirm: onConfirm, isDisabled: isDisabled, isSubmitting: isSubmitting } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = isSubmitting ? (0, $bxtuo.default).buildingButtonLabel : (0, $bxtuo.default).buildButtonLabel;
    let t2;
    if ($[0] !== formatMessage || $[1] !== t1) {
        t2 = formatMessage(t1);
        $[0] = formatMessage;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== isDisabled || $[4] !== onConfirm || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $eb5e53c63ef33975$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onConfirm,
            isDisabled: isDisabled
        }, t2));
        $[3] = isDisabled;
        $[4] = onConfirm;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onConfirm: onConfirm, isDisabled: isDisabled, isSubmitting: isSubmitting })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eb5e53c63ef33975$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onConfirm,
        isDisabled: isDisabled
    }, formatMessage(isSubmitting ? (0, $bxtuo.default).buildingButtonLabel : (0, $bxtuo.default).buildButtonLabel)));
};
module.exports["CardFooter"] = $eb5e53c63ef33975$export$e9897d434e0741ee;

});

parcelRegister("4Rdaf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $hMaHH = parcelRequire("hMaHH");


var $lSQgn = parcelRequire("lSQgn");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $bxtuo = parcelRequire("bxtuo");

const $f9390d4421035fda$var$styles = {
    container: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
};
const $f9390d4421035fda$export$5665775b26e26c5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { ruleName: ruleName, isOpen: isOpen, onToggle: onToggle } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $bxtuo.default).cardTitle);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            label: t1,
            appearance: "orange",
            size: "small"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ruleName) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, ruleName);
        $[4] = ruleName;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $bxtuo.default).cardTitle);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column"
        }, t3, t5);
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t2 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.100"
        }, t2, t6);
        $[13] = t2;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const t9 = isOpen ? (0, $bxtuo.default).collapseCardLabel : (0, $bxtuo.default).expandCardLabel;
    let t10;
    if ($[16] !== formatMessage || $[17] !== t9) {
        t10 = formatMessage(t9);
        $[16] = formatMessage;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== onToggle || $[20] !== t10 || $[21] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: t8,
            label: t10,
            appearance: "subtle",
            spacing: "compact",
            onClick: onToggle,
            testId: "studio-automation-create-rule-card.toggle-button"
        }));
        $[19] = onToggle;
        $[20] = t10;
        $[21] = t8;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t7) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            xcss: $f9390d4421035fda$var$styles.container
        }, t7, t11);
        $[23] = t11;
        $[24] = t7;
        $[25] = t12;
    } else t12 = $[25];
    return t12;
} : ({ ruleName: ruleName, isOpen: isOpen, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        xcss: $f9390d4421035fda$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: formatMessage((0, $bxtuo.default).cardTitle),
        appearance: "orange",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, ruleName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $bxtuo.default).cardTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        label: formatMessage(isOpen ? (0, $bxtuo.default).collapseCardLabel : (0, $bxtuo.default).expandCardLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: onToggle,
        testId: "studio-automation-create-rule-card.toggle-button"
    })));
};
module.exports["CardHeader"] = $f9390d4421035fda$export$5665775b26e26c5d;

});

parcelRegister("1kIzC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $j6vyT = parcelRequire("j6vyT");


var $hMaHH = parcelRequire("hMaHH");


var $lSQgn = parcelRequire("lSQgn");


var $9KSWX = parcelRequire("9KSWX");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6gGPb = parcelRequire("6gGPb");


var $jSIe3 = parcelRequire("jSIe3");

const $e2fa267f7f51f57d$var$headerLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPlan.headerLabel",
    defaultMessage: "Agent plan"
});
const $e2fa267f7f51f57d$var$headerLabelDraft = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPlan.headerLabelDraft",
    defaultMessage: "Agent"
});
const $e2fa267f7f51f57d$var$draftLozenge = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPlan.draftLozenge",
    defaultMessage: "Draft"
});
const $e2fa267f7f51f57d$var$publishedLozenge = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPlan.publishedLozenge",
    defaultMessage: "Published"
});
const $e2fa267f7f51f57d$var$shortAndBriefLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPlan.shortAndBriefLabel",
    defaultMessage: "Short and brief"
});
const $e2fa267f7f51f57d$var$styles = {
    card: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _24h04i2Njc _0KLXrulfZc",
    header: "_4c065U8HPE _2Y7lL48HPE",
    headerTopRow: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    headerLabels: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLDIqT",
    headerContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    titleRow: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    avatarWrapper: "_3YEZNOdnbC",
    titleText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    titleSpan: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1ANEUSLRg7 _39HuIbz8Lp",
    bodyWrapper: "_4c065U8HPE _2Y7lL48HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    footer: "_4c065U8HPE _2Y7lL48HPE _39xV02N91d _24h04i2Njc _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $e2fa267f7f51f57d$export$4ea0f01a15b10f5a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { agentAri: agentAri, agentName: agentName, cloudId: cloudId, description: description, instructions: instructions, knowledge: knowledge, tools: tools, status: status, primaryAction: primaryAction, secondaryAction: secondaryAction, testId: testId, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const cardStatus = status ?? (agentAri ? "draft" : "plan");
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsExpanded(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleExpand = t1;
    const t2 = cardStatus === "plan" ? $e2fa267f7f51f57d$var$headerLabel : $e2fa267f7f51f57d$var$headerLabelDraft;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t2));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== cardStatus) {
        t4 = cardStatus === "draft" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "neutral"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e2fa267f7f51f57d$var$draftLozenge));
        $[3] = cardStatus;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== cardStatus) {
        t5 = cardStatus === "published" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "success"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e2fa267f7f51f57d$var$publishedLozenge));
        $[5] = cardStatus;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.headerLabels
        }, t3, t4, t5);
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== agentAri || $[12] !== agentIdentityAccountId || $[13] !== agentName || $[14] !== agentNamedId || $[15] !== imageUrl) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.avatarWrapper
        }, !agentAri && !imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            label: "",
            appearance: "red",
            size: "medium"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentId: agentAri,
            agentIdentityAccountId: agentIdentityAccountId,
            agentNamedId: agentNamedId,
            imageUrl: imageUrl,
            name: agentName,
            size: "medium"
        }));
        $[11] = agentAri;
        $[12] = agentIdentityAccountId;
        $[13] = agentName;
        $[14] = agentNamedId;
        $[15] = imageUrl;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== agentName) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.titleText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small",
            as: "h3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $e2fa267f7f51f57d$var$styles.titleSpan
        }, agentName)));
        $[17] = agentName;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t7 || $[20] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.titleRow
        }, t7, t8);
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== t6 || $[23] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075",
            xcss: $e2fa267f7f51f57d$var$styles.headerContent
        }, t6, t9);
        $[22] = t6;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== intl || $[26] !== isExpanded) {
        t11 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
            label: intl.formatMessage($e2fa267f7f51f57d$var$shortAndBriefLabel),
            onClick: ()=>setIsExpanded(false),
            testId: "rovo-create-agent-card-collapse"
        });
        $[25] = intl;
        $[26] = isExpanded;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== t10 || $[29] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.header
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "space-between",
            gap: "space.100"
        }, t10, t11));
        $[28] = t10;
        $[29] = t11;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== cloudId || $[32] !== description || $[33] !== instructions || $[34] !== isExpanded || $[35] !== knowledge || $[36] !== tools) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.bodyWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jSIe3.ExpandableBody), {
            cloudId: cloudId,
            description: description,
            instructions: instructions,
            knowledge: knowledge,
            tools: tools,
            isExpanded: isExpanded,
            onExpand: handleExpand
        }));
        $[31] = cloudId;
        $[32] = description;
        $[33] = instructions;
        $[34] = isExpanded;
        $[35] = knowledge;
        $[36] = tools;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== primaryAction || $[39] !== secondaryAction) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "end",
            alignItems: "center",
            gap: "space.100"
        }, secondaryAction, primaryAction));
        $[38] = primaryAction;
        $[39] = secondaryAction;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== t12 || $[42] !== t13 || $[43] !== t14 || $[44] !== testId) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2fa267f7f51f57d$var$styles.card,
            testId: testId
        }, t12, t13, t14);
        $[41] = t12;
        $[42] = t13;
        $[43] = t14;
        $[44] = testId;
        $[45] = t15;
    } else t15 = $[45];
    return t15;
} : ({ agentAri: agentAri, agentName: agentName, cloudId: cloudId, description: description, instructions: instructions, knowledge: knowledge, tools: tools, status: status, primaryAction: primaryAction, secondaryAction: secondaryAction, testId: testId, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const cardStatus = status ?? (agentAri ? 'draft' : 'plan');
    const handleExpand = ()=>{
        setIsExpanded(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.card,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075",
        xcss: $e2fa267f7f51f57d$var$styles.headerContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.headerLabels
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), cardStatus === 'plan' ? $e2fa267f7f51f57d$var$headerLabel : $e2fa267f7f51f57d$var$headerLabelDraft)), cardStatus === 'draft' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e2fa267f7f51f57d$var$draftLozenge)), cardStatus === 'published' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e2fa267f7f51f57d$var$publishedLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.avatarWrapper
    }, !agentAri && !imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: "",
        appearance: "red",
        size: "medium"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentId: agentAri,
        agentIdentityAccountId: agentIdentityAccountId,
        agentNamedId: agentNamedId,
        imageUrl: imageUrl,
        name: agentName,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.titleText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $e2fa267f7f51f57d$var$styles.titleSpan
    }, agentName))))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: intl.formatMessage($e2fa267f7f51f57d$var$shortAndBriefLabel),
        onClick: ()=>setIsExpanded(false),
        testId: "rovo-create-agent-card-collapse"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.bodyWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jSIe3.ExpandableBody), {
        cloudId: cloudId,
        description: description,
        instructions: instructions,
        knowledge: knowledge,
        tools: tools,
        isExpanded: isExpanded,
        onExpand: handleExpand
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e2fa267f7f51f57d$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end",
        alignItems: "center",
        gap: "space.100"
    }, secondaryAction, primaryAction)));
};
module.exports["CreateAgentCardPlan"] = $e2fa267f7f51f57d$export$4ea0f01a15b10f5a;

});

parcelRegister("hFkBC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7WEaj = parcelRequire("7WEaj");


var $I7hWB = parcelRequire("I7hWB");


var $11OF7 = parcelRequire("11OF7");


var $9KSWX = parcelRequire("9KSWX");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");


var $6gGPb = parcelRequire("6gGPb");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $fCOel = parcelRequire("fCOel");

const $a3ad307f46a6a813$var$settingsButtonLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPublished.settingsButtonLabel",
    defaultMessage: "Open agent settings"
});
const $a3ad307f46a6a813$var$publishedStateLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.CreateAgentCardPublished.publishedStateLabel",
    defaultMessage: "Published"
});
const $a3ad307f46a6a813$var$styles = {
    card: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXrulfZc",
    titleRow: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    avatarWrapper: "_3YEZNOdnbC",
    titleText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    titleSpan: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1ANEUSLRg7 _39HuIbz8Lp"
};
const $a3ad307f46a6a813$export$235eb893a093ee3d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { agentAri: agentAri, agentName: agentName, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, agentEditUrl: agentEditUrl } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] !== agentAri || $[1] !== sendAnalyticsEvent) {
        t1 = (_, analyticsEvent)=>{
            sendAnalyticsEvent(analyticsEvent.update({
                actionSubjectId: "editAgentInStudio",
                attributes: {
                    analyticsSource: "inline-create-agent-card",
                    agentId: (0, $fCOel.getAgentIdFromAri)(agentAri) ?? undefined
                }
            }));
        };
        $[0] = agentAri;
        $[1] = sendAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const handleSettingsClick = t1;
    let t2;
    if ($[3] !== agentAri || $[4] !== agentIdentityAccountId || $[5] !== agentName || $[6] !== agentNamedId || $[7] !== imageUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a3ad307f46a6a813$var$styles.avatarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentId: agentAri,
            agentIdentityAccountId: agentIdentityAccountId,
            agentNamedId: agentNamedId,
            imageUrl: imageUrl,
            name: agentName,
            size: "medium"
        }));
        $[3] = agentAri;
        $[4] = agentIdentityAccountId;
        $[5] = agentName;
        $[6] = agentNamedId;
        $[7] = imageUrl;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== agentName) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a3ad307f46a6a813$var$styles.titleText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            title: agentName,
            xcss: $a3ad307f46a6a813$var$styles.titleSpan
        }, agentName)));
        $[9] = agentName;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.100",
            xcss: $a3ad307f46a6a813$var$styles.titleRow
        }, t2, t3);
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "success"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a3ad307f46a6a813$var$publishedStateLabel));
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== agentEditUrl || $[16] !== handleSettingsClick || $[17] !== intl) {
        t6 = agentEditUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
            label: intl.formatMessage($a3ad307f46a6a813$var$settingsButtonLabel),
            href: agentEditUrl,
            target: "_blank",
            onClick: handleSettingsClick,
            testId: "create-agent-card-published-settings-link",
            isTooltipDisabled: false
        });
        $[15] = agentEditUrl;
        $[16] = handleSettingsClick;
        $[17] = intl;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.100"
        }, t5, t6);
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t4 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a3ad307f46a6a813$var$styles.card,
            testId: "create-agent-card-published"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "space.100"
        }, t4, t7));
        $[21] = t4;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ agentAri: agentAri, agentName: agentName, imageUrl: imageUrl, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, agentEditUrl: agentEditUrl })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleSettingsClick = (0, $cozmU.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'editAgentInStudio',
            attributes: {
                analyticsSource: 'inline-create-agent-card',
                agentId: (0, $fCOel.getAgentIdFromAri)(agentAri) ?? undefined
            }
        }));
    }, [
        sendAnalyticsEvent,
        agentAri
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a3ad307f46a6a813$var$styles.card,
        testId: "create-agent-card-published"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100",
        xcss: $a3ad307f46a6a813$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a3ad307f46a6a813$var$styles.avatarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentId: agentAri,
        agentIdentityAccountId: agentIdentityAccountId,
        agentNamedId: agentNamedId,
        imageUrl: imageUrl,
        name: agentName,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a3ad307f46a6a813$var$styles.titleText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        title: agentName,
        xcss: $a3ad307f46a6a813$var$styles.titleSpan
    }, agentName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a3ad307f46a6a813$var$publishedStateLabel)), agentEditUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        label: intl.formatMessage($a3ad307f46a6a813$var$settingsButtonLabel),
        href: agentEditUrl,
        target: "_blank",
        onClick: handleSettingsClick,
        testId: "create-agent-card-published-settings-link",
        isTooltipDisabled: false
    }))));
};
module.exports["CreateAgentCardPublished"] = $a3ad307f46a6a813$export$235eb893a093ee3d;

});

parcelRegister("kwQw5", function(module, exports) {
/**
 * @generated SignedSource<<7293d8ecd88ece9cf44392fe9dae3016>>
 * @relayHash be3ffe57a6699e732683a057c27d3dd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 69d6526f56dacd1d3663ac1b0f60b3fe2342071cc2be9ec7370b35eb81408f57
const $bec039341f78aeb5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "agentAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ],
        "kind": "LinkedField",
        "name": "agentStudio_hasVersionCapability",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasVersionCapability"
                    }
                ],
                "type": "AgentStudioHasVersionCapability"
            }
        ]
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "description"
    }, v7 = {
        "kind": "ScalarField",
        "name": "instructions"
    }, v8 = {
        "kind": "ScalarField",
        "name": "icon"
    }, v9 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "externalConfigReference"
    }, v11 = {
        "kind": "ScalarField",
        "name": "isPublished"
    }, v12 = {
        "concreteType": "AgentStudioTool",
        "kind": "LinkedField",
        "name": "tools",
        "plural": true,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "displayName"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tags"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "enabled"
    }, v14 = {
        "kind": "ScalarField",
        "name": "source"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "spaceFilter"
            },
            {
                "kind": "ScalarField",
                "name": "parentFilter"
            }
        ],
        "type": "AgentStudioConfluenceKnowledgeFilter"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "projectFilter"
            }
        ],
        "type": "AgentStudioJiraKnowledgeFilter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateAgentCardWithQueryAgentByIdQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "agentStudio_agentById",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v4 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    v9 /*: any*/ ,
                                    v10 /*: any*/ ,
                                    v11 /*: any*/ ,
                                    v12 /*: any*/ ,
                                    {
                                        "concreteType": "AgentStudioKnowledgeConfiguration",
                                        "kind": "LinkedField",
                                        "name": "knowledgeSources",
                                        "plural": false,
                                        "selections": [
                                            v13 /*: any*/ ,
                                            {
                                                "concreteType": "AgentStudioKnowledgeSource",
                                                "kind": "LinkedField",
                                                "name": "sources",
                                                "plural": true,
                                                "selections": [
                                                    v13 /*: any*/ ,
                                                    v14 /*: any*/ ,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "filters",
                                                        "plural": false,
                                                        "selections": [
                                                            v15 /*: any*/ ,
                                                            v16 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "AgentStudioAssistant"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateAgentCardWithQueryAgentByIdQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentById",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AgentStudioKnowledgeConfiguration",
                                    "kind": "LinkedField",
                                    "name": "knowledgeSources",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "AgentStudioKnowledgeSource",
                                            "kind": "LinkedField",
                                            "name": "sources",
                                            "plural": true,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "filters",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "AgentStudioAssistant"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ 
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "69d6526f56dacd1d3663ac1b0f60b3fe2342071cc2be9ec7370b35eb81408f57",
            "metadata": {},
            "name": "CreateAgentCardWithQueryAgentByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bec039341f78aeb5$var$node.hash = "f07f77bf3c4b3c57c244f3b14cee3d23";
var $bec039341f78aeb5$export$2e2bcd8739ae039 = $bec039341f78aeb5$var$node;
module.exports["default"] = $bec039341f78aeb5$export$2e2bcd8739ae039;

});

parcelRegister("24qrr", function(module, exports) {
/**
 * @generated SignedSource<<c41823ec709c0612ac072a35871729db>>
 * @relayHash 240cade59b2f58ea39d1ed91f187d39b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e670ce2637d76c4eb964a7000ad159da4d015b465c6fd75906569db106d30c82
const $b65caf2a930bd1e9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAssignAgentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAssignAgentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e670ce2637d76c4eb964a7000ad159da4d015b465c6fd75906569db106d30c82",
            "metadata": {},
            "name": "useAssignAgentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b65caf2a930bd1e9$var$node.hash = "4666c9e93cc821bbcd66c4ef1a69004d";
var $b65caf2a930bd1e9$export$2e2bcd8739ae039 = $b65caf2a930bd1e9$var$node;
module.exports["default"] = $b65caf2a930bd1e9$export$2e2bcd8739ae039;

});

parcelRegister("6iTVQ", function(module, exports) {
/**
 * @generated SignedSource<<291076e0a4ccd7e3608cc385bf8b99d9>>
 * @relayHash 2d211eb85e0b1bb12867127403ed141b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f437601a6f2a8054512ed84beb0000c8b748083d981b068b40adda9d78e68f0
const $4aff57abbb1baf1b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInvokeAgentMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraStartAiAgentSessionPayload",
                    "kind": "LinkedField",
                    "name": "jira_startAiAgentSession",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInvokeAgentMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraStartAiAgentSessionPayload",
                    "kind": "LinkedField",
                    "name": "jira_startAiAgentSession",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2f437601a6f2a8054512ed84beb0000c8b748083d981b068b40adda9d78e68f0",
            "metadata": {},
            "name": "useInvokeAgentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4aff57abbb1baf1b$var$node.hash = "903b5a44ea93397968c19407067dc5f9";
var $4aff57abbb1baf1b$export$2e2bcd8739ae039 = $4aff57abbb1baf1b$var$node;
module.exports["default"] = $4aff57abbb1baf1b$export$2e2bcd8739ae039;

});

parcelRegister("aZuhc", function(module, exports) {

var $kTGj5 = parcelRequire("kTGj5");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $eTjNs = parcelRequire("eTjNs");


const $72027cf30b7a0a3f$export$81d379b0c69f865e = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("9nGMF")), {
        moduleId: "a3e8bc90",
        moduleName: "EditSkillModal",
        priority: "interaction",
        moduleId: 'custom-skills-edit-skill-entrypoint-id',
        moduleName: 'custom-skills-edit-skill-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId, skillAri: skillAri })=>({
            queries: {
                editSkillQuery: {
                    parameters: (0, $eTjNs.default),
                    variables: {
                        skillAri: skillAri,
                        contextAri: (0, $kTGj5.PlatformSiteAri).create({
                            siteId: cloudId
                        }).toString()
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                skillAri: skillAri
            }
        })
});
module.exports["editSkillEntrypoint"] = $72027cf30b7a0a3f$export$81d379b0c69f865e;

});

parcelRegister("1uK7M", function(module, exports) {
// src/studio/workspace/types.ts
var $116c5f21c6f2e932$export$d24c7c9a6a764930 = "studio", $116c5f21c6f2e932$export$3b0bff5644c1c632 = "workspace";
module.exports["StudioWorkspaceAriResourceOwner"] = $116c5f21c6f2e932$export$d24c7c9a6a764930;
module.exports["StudioWorkspaceAriResourceType"] = $116c5f21c6f2e932$export$3b0bff5644c1c632;

});

parcelRegister("irUqK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2f69df83cb387f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    solutionPlanStateUpdateErrorTitle: {
        id: "studio-foundations.solution-plan-state-update-listener.solution-plan-state-update-error-title",
        defaultMessage: "Error"
    },
    solutionPlanStateUpdateErrorDescription: {
        id: "studio-foundations.solution-plan-state-update-listener.solution-plan-state-update-error-description",
        defaultMessage: "Something went wrong while updating the solution plan"
    }
});
module.exports["messages"] = $2f69df83cb387f91$export$defe85febe8b728c;

});

parcelRegister("ejUo1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $jLnA6 = parcelRequire("jLnA6");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $5HApy = parcelRequire("5HApy");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $1VhsF = parcelRequire("1VhsF");


var $hMjUh = parcelRequire("hMjUh");

var $dkVNA = parcelRequire("dkVNA");

var $gRGWz = parcelRequire("gRGWz");


var $1PVOM = parcelRequire("1PVOM");


var $lzU6z = parcelRequire("lzU6z");


var $7txt6 = parcelRequire("7txt6");


var $VGHbH = parcelRequire("VGHbH");


var $hntO9 = parcelRequire("hntO9");


var $az160 = parcelRequire("az160");

const $196cfd01c6f3f78e$var$ANIMATION_DURATION = '350ms'; // no token exists for this yet, it seems. { durations.medium } from '@atlaskit/motion' === 350ms
const $196cfd01c6f3f78e$var$styles = {
    cardContent: "_4bt5LAoWuR _2WAcuGoWuR _23rrnHLaAG _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0NUa3rPIoL _1mT5xdRAKS _0qk6IKN8t6 _3Z9K0wngV3 _22sfPnj3og _2IVJ4Mp3yX _3zygPUgqQ0",
    cardContent__gradientSkrim: "_23rrnH9v2r _1mT5xdWVPG _0Bm75GdnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VfI2J _0qk6IKN8t6 _3Z9K0wngV3",
    cardContent_expanded: "_0NUa3rW9qI",
    cardContent_expanded__gradientSkrim: "_1YKVNsdnbC _1pp6NdYbGa",
    panel: "_0Of8r28HPE _1wydGW8HPE",
    chevronDownIconContainer: "_0bjKvDS5Zs _39xV02Uofl _0jFU0VUofl _0KLXrulfZc _2OUyjtGk8v",
    hidden: "_0fKRyPnQyn _1mT5xdWVPG _1pp6NdYbGa",
    moreButtonBorder: "_2O5Vij7dHp _4xdlr0FlnN _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0GwItXDIqT",
    dropdownContainer: "_39xV02E6Kk",
    tabWrapper: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    tabListWrapper: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    tabRow: "_3TGfC9LRg7"
};
const $196cfd01c6f3f78e$var$nativeStyles = {
    cardContent: "_1YjuKt1Z7S",
    cardContent__gradientSkrim: "_3CkH9ort2G"
};
const $196cfd01c6f3f78e$export$64ef9b8c11710c47 = ({ productKey: productKey, siteId: siteId })=>{
    (0, $6cFsl.di)((0, $7txt6.useSolutionPlan));
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { builds: builds, currentBuildNumber: currentBuildNumber } = (0, $7txt6.useSolutionPlan)();
    const [selectedTabIndex, setSelectedTabIndex] = (0, $cozmU.useState)(()=>(0, $lzU6z.getCurrentBuildIndex)(builds, currentBuildNumber));
    const { tabListRef: tabListRef, moreButtonRef: moreButtonRef, hasOverflow: hasOverflow, hiddenTabIndices: hiddenTabIndices } = (0, $az160.useOverflowTabs)(selectedTabIndex);
    (0, $cozmU.useEffect)(()=>{
        setSelectedTabIndex((0, $lzU6z.getCurrentBuildIndex)(builds, currentBuildNumber));
    }, [
        builds,
        currentBuildNumber
    ]);
    if (builds.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $196cfd01c6f3f78e$var$styles.cardContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: formatMessage((0, $hntO9.messages).noBuildsTitle),
        appearance: "error"
    }, formatMessage((0, $hntO9.messages).noBuildsDescription)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($196cfd01c6f3f78e$var$styles.cardContent, isExpanded && $196cfd01c6f3f78e$var$styles.cardContent_expanded, $196cfd01c6f3f78e$var$nativeStyles.cardContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, builds.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: tabListRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        id: "studio-trigger-solution-build-plan-card-tabs",
        onChange: (index)=>setSelectedTabIndex(index),
        selected: selectedTabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $196cfd01c6f3f78e$var$styles.tabRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $196cfd01c6f3f78e$var$styles.tabListWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, builds.map((build, index_0)=>{
        const isHidden = hiddenTabIndices.has(index_0);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: build.number,
            xcss: isHidden ? $196cfd01c6f3f78e$var$styles.hidden : $196cfd01c6f3f78e$var$styles.tabWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VGHbH.BuildTab), {
            build: build,
            label: build.name,
            index: index_0,
            stepNumber: index_0 + 1
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $196cfd01c6f3f78e$var$styles.moreButtonBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: moreButtonRef,
        xcss: !hasOverflow ? $196cfd01c6f3f78e$var$styles.hidden : $196cfd01c6f3f78e$var$styles.dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                ref: triggerRef,
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050"
            }, formatMessage((0, $hntO9.messages).moreButtonLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, hiddenTabIndices.size)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, Array.from(hiddenTabIndices.values()).map((tabIndex)=>{
        const build_0 = builds[tabIndex];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: build_0.number,
            onClick: ()=>setSelectedTabIndex(tabIndex)
        }, formatMessage((0, $hntO9.messages).tabLabelWithStep, {
            stepNumber: tabIndex + 1,
            label: build_0.name
        }));
    })))))), builds.map((build_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), {
            key: build_1.number
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.200",
            xcss: $196cfd01c6f3f78e$var$styles.panel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: build_1.overview,
            productKey: productKey,
            siteId: siteId
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: builds[0].overview,
        productKey: productKey,
        siteId: siteId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($196cfd01c6f3f78e$var$styles.cardContent__gradientSkrim, $196cfd01c6f3f78e$var$nativeStyles.cardContent__gradientSkrim, isExpanded && $196cfd01c6f3f78e$var$styles.cardContent_expanded__gradientSkrim),
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $196cfd01c6f3f78e$var$styles.chevronDownIconContainer,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        label: formatMessage((0, $hntO9.messages).expandCardLabel),
        shape: "circle",
        onClick: ()=>setIsExpanded(!isExpanded),
        testId: "studio-trigger-solution-build-plan-card.chevron-down-icon-button",
        "data-expanded": isExpanded
    }))));
};
module.exports["CardContent"] = $196cfd01c6f3f78e$export$64ef9b8c11710c47;

});

parcelRegister("j9u6G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4ez2K = parcelRequire("4ez2K");


var $lzU6z = parcelRequire("lzU6z");


var $ffqiV = parcelRequire("ffqiV");


var $jZK23 = parcelRequire("jZK23");


var $bkJmI = parcelRequire("bkJmI");


var $7txt6 = parcelRequire("7txt6");

const $7e5fbcd301d7c68a$var$styles = {
    container: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $7e5fbcd301d7c68a$var$CapabilityFooterActions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { build: build } = t0;
    switch(build.type){
        case "ROVO_AGENT":
            {
                let t1;
                if ($[0] !== build) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffqiV.AgentFooterActions), {
                        build: build
                    });
                    $[0] = build;
                    $[1] = t1;
                } else t1 = $[1];
                return t1;
            }
        case "ECOSYSTEM_APP":
            {
                let t1;
                if ($[2] !== build) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZK23.AppFooterActions), {
                        build: build
                    });
                    $[2] = build;
                    $[3] = t1;
                } else t1 = $[3];
                return t1;
            }
        case "AUTOMATION_RULE":
            {
                let t1;
                if ($[4] !== build) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bkJmI.AutomationFooterActions), {
                        build: build
                    });
                    $[4] = build;
                    $[5] = t1;
                } else t1 = $[5];
                return t1;
            }
    }
} : ({ build: build })=>{
    switch(build.type){
        case 'ROVO_AGENT':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffqiV.AgentFooterActions), {
                build: build
            });
        case 'ECOSYSTEM_APP':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZK23.AppFooterActions), {
                build: build
            });
        case 'AUTOMATION_RULE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bkJmI.AutomationFooterActions), {
                build: build
            });
    }
};
const $7e5fbcd301d7c68a$export$e9897d434e0741ee = ()=>{
    (0, $6cFsl.di)((0, $7txt6.useSolutionPlan));
    const { builds: builds, currentBuildNumber: currentBuildNumber } = (0, $7txt6.useSolutionPlan)();
    const currentBuild = (0, $lzU6z.getCurrentBuild)(builds, currentBuildNumber);
    if ((0, $lzU6z.isFullyBuilt)(builds)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        xcss: $7e5fbcd301d7c68a$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e5fbcd301d7c68a$var$CapabilityFooterActions, {
        build: currentBuild
    }));
};
module.exports["CardFooter"] = $7e5fbcd301d7c68a$export$e9897d434e0741ee;

});

parcelRegister("kgMbL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $7sJoX = parcelRequire("7sJoX");


var $hMaHH = parcelRequire("hMaHH");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $7txt6 = parcelRequire("7txt6");


var $hjQT2 = parcelRequire("hjQT2");

const $d41a24f29e2d0601$var$ANIMATION_DURATION = '350ms'; // no token exists for this yet, it seems. { durations.medium } from '@atlaskit/motion' === 350ms
const $d41a24f29e2d0601$var$styles = {
    container: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    miniIconButton: "_23rrnHC67X _0qk6IKN8t6 _3Z9K0wngV3",
    miniIconButton_opened: "_1VJPcal236"
};
const $d41a24f29e2d0601$var$getBuildCompletionPercentage = (builds)=>{
    if (builds.length === 0) return 0;
    return Math.round(builds.filter((build)=>build.state === 'SUCCESS').length / builds.length * 100);
};
const $d41a24f29e2d0601$export$5665775b26e26c5d = ({ isLoading: isLoading, name: name, solutionVersion: solutionVersion, isOpen: isOpen, onToggle: onToggle })=>{
    (0, $6cFsl.di)((0, $7txt6.useSolutionPlan));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { builds: builds } = (0, $7txt6.useSolutionPlan)();
    const completion = $d41a24f29e2d0601$var$getBuildCompletionPercentage(builds);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        xcss: $d41a24f29e2d0601$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: "File",
        appearance: "orange",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $hjQT2.messages).planCardVersion, {
        solutionVersion: solutionVersion
    }), " \u2022", ' ', formatMessage((0, $hjQT2.messages).planCardCompletion, {
        completion: completion
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        interactionName: "studio-trigger-solution-build-plan-card-solution-loading",
        testId: "studio-trigger-solution-build-plan-card.loading-indicator"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($d41a24f29e2d0601$var$styles.miniIconButton, isOpen && $d41a24f29e2d0601$var$styles.miniIconButton_opened)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small",
                testId: "studio-trigger-solution-build-plan-card.chevron-down-icon"
            })),
        label: formatMessage(isOpen ? (0, $hjQT2.messages).closeCardLabel : (0, $hjQT2.messages).openCardLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: onToggle,
        testId: "studio-trigger-solution-build-plan-card.open-close-card-icon-button"
    })));
};
module.exports["CardHeader"] = $d41a24f29e2d0601$export$5665775b26e26c5d;

});

parcelRegister("7txt6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $56959f7ada1e4413$export$cec530ee5aeb8c02 = /*#__PURE__*/ (0, $cozmU.createContext)({
    builds: [],
    currentBuildNumber: 0,
    refetchSolutionPlan: ()=>{},
    cloudId: '',
    aaid: '',
    spaceId: '',
    workspaceId: '',
    solutionState: 'DRAFT'
});
const $56959f7ada1e4413$export$9a78803644047618 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const solutionPlanContext = (0, $cozmU.useContext)($56959f7ada1e4413$export$cec530ee5aeb8c02);
    if (!solutionPlanContext) throw new Error("useSolutionPlan must be used within a SolutionPlanContext");
    return solutionPlanContext;
} : ()=>{
    const solutionPlanContext = (0, $cozmU.useContext)($56959f7ada1e4413$export$cec530ee5aeb8c02);
    if (!solutionPlanContext) throw new Error('useSolutionPlan must be used within a SolutionPlanContext');
    return solutionPlanContext;
};
module.exports["SolutionPlanContext"] = $56959f7ada1e4413$export$cec530ee5aeb8c02;
module.exports["useSolutionPlan"] = $56959f7ada1e4413$export$9a78803644047618;

});

parcelRegister("8u7nd", function(module, exports) {
const $2d254c8df85ff837$export$9aa713c49cf52433 = [
    'gray',
    'red',
    'orange',
    'yellow',
    'lime',
    'green',
    'teal',
    'blue',
    'purple',
    'magenta'
];
module.exports["APPEARANCES"] = $2d254c8df85ff837$export$9aa713c49cf52433;

});

parcelRegister("BHtVq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $dIT3V = parcelRequire("dIT3V");


var $GErjr = parcelRequire("GErjr");


var $6m2p9 = parcelRequire("6m2p9");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $9fP2S = parcelRequire("9fP2S");


var $1PVOM = parcelRequire("1PVOM");


var $irnO2 = parcelRequire("irnO2");


var $hMLWD = parcelRequire("hMLWD");


var $ha4hi = parcelRequire("ha4hi");


var $iPNLv = parcelRequire("iPNLv");


var $c5DsI = parcelRequire("c5DsI");


var $9qyl6 = parcelRequire("9qyl6");


var $9PskX = parcelRequire("9PskX");


var $6swnh = parcelRequire("6swnh");


var $5P3mR = parcelRequire("5P3mR");


var $1wBYh = parcelRequire("1wBYh");

const $90ec7adc9de34b1b$var$styles = {
    cardContainer: "_0bjKvDyzSk _30huDKOeNX"
};
const $90ec7adc9de34b1b$var$BooleanFieldRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { value: value } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== value) {
        t1 = value ? formatMessage((0, $6swnh.default).enabledValue) : formatMessage((0, $6swnh.default).disabledValue);
        $[0] = formatMessage;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, value ? formatMessage((0, $6swnh.default).enabledValue) : formatMessage((0, $6swnh.default).disabledValue));
};
const $90ec7adc9de34b1b$var$AgentKnowledgeSourcesRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { knowledgeSources: knowledgeSources, cloudId: cloudId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== knowledgeSources.sources) {
        t1 = knowledgeSources.sources?.some($90ec7adc9de34b1b$var$_temp) ?? false;
        $[0] = knowledgeSources.sources;
        $[1] = t1;
    } else t1 = $[1];
    const customEnabled = t1;
    const allOrgEnabled = knowledgeSources.enabled === false;
    const noOrg = !customEnabled && knowledgeSources.enabled === true;
    let t2;
    if ($[2] !== allOrgEnabled || $[3] !== formatMessage) {
        t2 = allOrgEnabled && formatMessage((0, $6swnh.default).allOrganisationalKnowledge);
        $[2] = allOrgEnabled;
        $[3] = formatMessage;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== cloudId || $[6] !== customEnabled || $[7] !== knowledgeSources.enabled || $[8] !== knowledgeSources.sources) {
        t3 = customEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fP2S.KnowledgePillList), {
            cloudId: cloudId,
            knowledge: [
                {
                    enabled: knowledgeSources.enabled,
                    sources: knowledgeSources.sources?.map($90ec7adc9de34b1b$var$_temp2)
                }
            ]
        });
        $[5] = cloudId;
        $[6] = customEnabled;
        $[7] = knowledgeSources.enabled;
        $[8] = knowledgeSources.sources;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== formatMessage || $[11] !== noOrg) {
        t4 = noOrg && formatMessage((0, $6swnh.default).noOrganisationalKnowledge);
        $[10] = formatMessage;
        $[11] = noOrg;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, t2, t3, t4);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ knowledgeSources: knowledgeSources, cloudId: cloudId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const customEnabled = knowledgeSources.sources?.some((s)=>s.enabled) ?? false;
    const allOrgEnabled = knowledgeSources.enabled === false;
    const noOrg = !customEnabled && knowledgeSources.enabled === true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, allOrgEnabled && formatMessage((0, $6swnh.default).allOrganisationalKnowledge), customEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fP2S.KnowledgePillList), {
        cloudId: cloudId,
        knowledge: [
            {
                enabled: knowledgeSources.enabled,
                sources: knowledgeSources.sources?.map((source)=>({
                        enabled: source.enabled,
                        source: source.source,
                        filters: {
                            spaceFilter: source.filters?.confluenceFilter?.spaceFilter?.concat(),
                            parentFilter: source.filters?.confluenceFilter?.parentFilter?.concat(),
                            projectFilter: source.filters?.jiraFilter?.projectFilter?.concat(),
                            jsmProjectFilter: source.filters?.jsmFilter?.jsmProjectFilter?.concat()
                        }
                    }))
            }
        ]
    }), noOrg && formatMessage((0, $6swnh.default).noOrganisationalKnowledge));
};
const $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo = {
    description: {
        label: (0, $6swnh.default).descriptionTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldRenderProps.fieldValue === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PskX.DeleteFieldRenderer), {
                fieldName: fieldRenderProps.fieldName || ''
            }) : fieldRenderProps.fieldValue)
    },
    behavior: {
        label: (0, $6swnh.default).behaviorTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldRenderProps.fieldValue === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PskX.DeleteFieldRenderer), {
                fieldName: fieldRenderProps.fieldName || ''
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                content: fieldRenderProps.fieldValue,
                productKey: fieldRenderProps.productKey,
                siteId: fieldRenderProps.cloudId ?? ''
            }))
    },
    name: {
        label: (0, $6swnh.default).nameTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldRenderProps.fieldValue)
    },
    conversationStarters: {
        label: (0, $6swnh.default).conversationStartersTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, fieldRenderProps.fieldValue?.map((line, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: index
                }, line)));
        }
    },
    scenarios: {
        label: ()=>(0, $iDrrr.fg)('sa_support_scenario_refresh') ? (0, $6swnh.default).scenariosTitle : (0, $6swnh.default).scenariosTitleLegacy,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dIT3V))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5P3mR.ScenarioContentRenderer), {
                scenarioToUpdate: fieldRenderProps.fieldValue,
                cloudId: fieldRenderProps.cloudId || '',
                productKey: fieldRenderProps.productKey
            })
    },
    instructions: {
        label: (0, $6swnh.default).instructionsTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fieldRenderProps.fieldValue === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PskX.DeleteFieldRenderer), {
                fieldName: fieldRenderProps.fieldName || ''
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
                content: fieldRenderProps.fieldValue,
                productKey: fieldRenderProps.productKey,
                siteId: fieldRenderProps.cloudId ?? ''
            }))
    },
    isDeepResearchEnabled: {
        label: (0, $6swnh.default).isDeepResearchEnabledTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90ec7adc9de34b1b$var$BooleanFieldRenderer, {
                value: fieldRenderProps.fieldValue
            })
    },
    isWebSearchEnabled: {
        label: (0, $6swnh.default).isWebSearchEnabledTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90ec7adc9de34b1b$var$BooleanFieldRenderer, {
                value: fieldRenderProps.fieldValue
            })
    },
    knowledgeSources: {
        label: (0, $6swnh.default).knowledgeSourcesTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90ec7adc9de34b1b$var$AgentKnowledgeSourcesRenderer, {
                knowledgeSources: fieldRenderProps.fieldValue,
                cloudId: fieldRenderProps.cloudId ?? ''
            })
    },
    tools: {
        label: ()=>(0, $iDrrr.fg)('sa_support_scenario_refresh') ? (0, $6swnh.default).toolsTitle : (0, $6swnh.default).toolsTitleLegacy,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>{
            const actions = fieldRenderProps.fieldValue.map((tool)=>({
                    actionKey: tool.toolId,
                    iconUrl: tool.iconUrl,
                    name: tool.displayName,
                    tags: tool.tags,
                    isActive: true
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1wBYh.SkillList), {
                actions: actions
            });
        }
    },
    agenticSkills: {
        label: (0, $6swnh.default).agenticSkillsTitle,
        icon: (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                label: label
            }),
        renderer: (fieldRenderProps)=>{
            const actions = fieldRenderProps.fieldValue.map((skill)=>({
                    actionKey: skill.skillAri,
                    icon: skill.iconKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ha4hi.SkillIcon), {
                        iconKey: skill.iconKey
                    }) : undefined,
                    name: skill.displayName,
                    tags: skill.tags,
                    isActive: true
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1wBYh.SkillList), {
                actions: actions
            });
        }
    }
};
const $90ec7adc9de34b1b$var$resolveLabel = (label)=>typeof label === 'function' ? label() : label;
const $90ec7adc9de34b1b$export$30aa87e3ee380fc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { onConfirm: onConfirm, onCancel: onCancel, experienceTracker: experienceTracker, isDisabled: isDisabled, isSubmitting: isSubmitting, fields: fields, cloudId: cloudId, productKey: productKey } = t0;
    (0, $6cFsl.di)((0, $9EOlJ.ErrorBoundary));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== cloudId || $[1] !== fields || $[2] !== formatMessage || $[3] !== productKey) {
        t1 = Object.keys(fields).filter((key)=>{
            const v2OnlyFields = [
                "instructions",
                "isDeepResearchEnabled",
                "isWebSearchEnabled",
                "knowledgeSources",
                "tools"
            ];
            const isAgenticSkillsField = key === "agenticSkills";
            return fields[key] != null && (isAgenticSkillsField ? (0, $iDrrr.fg)("sltns-1102-agentic-skills") : v2OnlyFields.includes(key) ? (0, $iDrrr.fg)("sa_support_scenario_refresh") : true);
        }).flatMap((fieldKey)=>{
            const resolvedLabel = $90ec7adc9de34b1b$var$resolveLabel($90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].label);
            if (fieldKey !== "scenarios") return {
                id: fieldKey,
                title: formatMessage(resolvedLabel),
                icon: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].icon(formatMessage(resolvedLabel)),
                content: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].renderer({
                    fieldValue: fields[fieldKey],
                    fieldName: formatMessage(resolvedLabel),
                    cloudId: cloudId,
                    productKey: productKey
                })
            };
            return fields.scenarios.map((scenarioToUpdate, index)=>({
                    id: fieldKey + index,
                    title: formatMessage(resolvedLabel),
                    subtitle: scenarioToUpdate.scenario.name,
                    icon: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].icon(formatMessage(resolvedLabel)),
                    content: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].renderer({
                        fieldValue: scenarioToUpdate,
                        cloudId: cloudId,
                        productKey: productKey
                    })
                }));
        });
        $[0] = cloudId;
        $[1] = fields;
        $[2] = formatMessage;
        $[3] = productKey;
        $[4] = t1;
    } else t1 = $[4];
    const accordionCardList = t1;
    let t2;
    if ($[5] !== formatMessage) {
        t2 = formatMessage((0, $6swnh.default).rejectButton);
        $[5] = formatMessage;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== isDisabled || $[8] !== isSubmitting || $[9] !== onCancel || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isLoading: isSubmitting,
            isDisabled: isDisabled,
            onClick: onCancel
        }, t2);
        $[7] = isDisabled;
        $[8] = isSubmitting;
        $[9] = onCancel;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== accordionCardList.length || $[13] !== formatMessage) {
        t4 = accordionCardList.length > 1 ? formatMessage((0, $6swnh.default).acceptAllButton) : formatMessage((0, $6swnh.default).acceptButton);
        $[12] = accordionCardList.length;
        $[13] = formatMessage;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== isDisabled || $[16] !== isSubmitting || $[17] !== onConfirm || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isLoading: isSubmitting,
            isDisabled: isDisabled,
            onClick: onConfirm
        }, t4);
        $[15] = isDisabled;
        $[16] = isSubmitting;
        $[17] = onConfirm;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), {
            testId: "agent-diff-card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150"
        }, t3, t5));
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    const actionCardFooter = t6;
    const hasAccordionCards = accordionCardList.length > 0;
    let t7;
    let t8;
    if ($[23] !== experienceTracker || $[24] !== hasAccordionCards) {
        t7 = ()=>{
            if (hasAccordionCards) experienceTracker?.succeed({
                name: (0, $irnO2.ExperienceName).STUDIO_UPDATE_AGENT
            });
        };
        t8 = [
            experienceTracker,
            hasAccordionCards
        ];
        $[23] = experienceTracker;
        $[24] = hasAccordionCards;
        $[25] = t7;
        $[26] = t8;
    } else {
        t7 = $[25];
        t8 = $[26];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[27] !== experienceTracker) {
        t9 = (error)=>{
            experienceTracker?.fail({
                name: (0, $irnO2.ExperienceName).STUDIO_UPDATE_AGENT,
                error: error
            });
        };
        $[27] = experienceTracker;
        $[28] = t9;
    } else t9 = $[28];
    const handleRenderError = t9;
    let t10;
    if ($[29] !== accordionCardList || $[30] !== formatMessage) {
        t10 = accordionCardList.length === 1 ? accordionCardList[0] : {
            id: "agent-diff-card",
            title: formatMessage((0, $6swnh.default).actionCardTitle),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
                label: formatMessage((0, $6swnh.default).actionCardTitle)
            }),
            subtitle: formatMessage((0, $6swnh.default).agentPlanCardSubtitle, {
                numberOfChanges: accordionCardList.length
            }),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5DsI.AccordionCardList), {
                items: accordionCardList
            })
        };
        $[29] = accordionCardList;
        $[30] = formatMessage;
        $[31] = t10;
    } else t10 = $[31];
    const cardItem = t10;
    let t11;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        });
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $hekY6.default)([
            $90ec7adc9de34b1b$var$styles.cardContainer
        ]);
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== actionCardFooter || $[35] !== cardItem) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t12
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPNLv.AccordionCard), {
            item: cardItem,
            isExpanded: true,
            isExpandable: false,
            onToggle: $90ec7adc9de34b1b$var$_temp3,
            isFirst: true
        }, actionCardFooter));
        $[34] = actionCardFooter;
        $[35] = cardItem;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== handleRenderError || $[38] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t11,
            onError: handleRenderError
        }, t13);
        $[37] = handleRenderError;
        $[38] = t13;
        $[39] = t14;
    } else t14 = $[39];
    return t14;
} : ({ onConfirm: onConfirm, onCancel: onCancel, experienceTracker: experienceTracker, isDisabled: isDisabled, isSubmitting: isSubmitting, fields: fields, cloudId: cloudId, productKey: productKey })=>{
    (0, $6cFsl.di)((0, $9EOlJ.ErrorBoundary));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const accordionCardList = Object.keys(fields).filter((key)=>{
        const v2OnlyFields = [
            'instructions',
            'isDeepResearchEnabled',
            'isWebSearchEnabled',
            'knowledgeSources',
            'tools'
        ];
        const isAgenticSkillsField = key === 'agenticSkills';
        return fields[key] != null && (isAgenticSkillsField ? (0, $iDrrr.fg)('sltns-1102-agentic-skills') : v2OnlyFields.includes(key) ? (0, $iDrrr.fg)('sa_support_scenario_refresh') : true);
    }).flatMap((fieldKey)=>{
        const resolvedLabel = $90ec7adc9de34b1b$var$resolveLabel($90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].label);
        if (fieldKey !== 'scenarios') return {
            id: fieldKey,
            title: formatMessage(resolvedLabel),
            icon: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].icon(formatMessage(resolvedLabel)),
            content: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].renderer({
                fieldValue: fields[fieldKey],
                fieldName: formatMessage(resolvedLabel),
                cloudId: cloudId,
                productKey: productKey
            })
        };
        return fields['scenarios'].map((scenarioToUpdate, index)=>({
                id: fieldKey + index,
                title: formatMessage(resolvedLabel),
                subtitle: scenarioToUpdate.scenario.name,
                icon: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].icon(formatMessage(resolvedLabel)),
                content: $90ec7adc9de34b1b$var$mapFieldsToDisplayInfo[fieldKey].renderer({
                    fieldValue: scenarioToUpdate,
                    cloudId: cloudId,
                    productKey: productKey
                })
            }));
    });
    const actionCardFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qyl6.ActionCardFooter), {
        testId: "agent-diff-card-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isLoading: isSubmitting,
        isDisabled: isDisabled,
        onClick: onCancel
    }, formatMessage((0, $6swnh.default).rejectButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isLoading: isSubmitting,
        isDisabled: isDisabled,
        onClick: onConfirm
    }, accordionCardList.length > 1 ? formatMessage((0, $6swnh.default).acceptAllButton) : formatMessage((0, $6swnh.default).acceptButton))));
    const hasAccordionCards = accordionCardList.length > 0;
    (0, $cozmU.useEffect)(()=>{
        if (hasAccordionCards) experienceTracker?.succeed({
            name: (0, $irnO2.ExperienceName).STUDIO_UPDATE_AGENT
        });
    }, [
        experienceTracker,
        hasAccordionCards
    ]);
    const handleRenderError = (0, $cozmU.useCallback)((error)=>{
        experienceTracker?.fail({
            name: (0, $irnO2.ExperienceName).STUDIO_UPDATE_AGENT,
            error: error
        });
    }, [
        experienceTracker
    ]);
    const cardItem = accordionCardList.length === 1 ? accordionCardList[0] : {
        id: 'agent-diff-card',
        title: formatMessage((0, $6swnh.default).actionCardTitle),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
            label: formatMessage((0, $6swnh.default).actionCardTitle)
        }),
        subtitle: formatMessage((0, $6swnh.default).agentPlanCardSubtitle, {
            numberOfChanges: accordionCardList.length
        }),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5DsI.AccordionCardList), {
            items: accordionCardList
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMLWD.ChatGenericError), {
            errorType: "generic"
        }),
        onError: handleRenderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $90ec7adc9de34b1b$var$styles.cardContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPNLv.AccordionCard), {
        item: cardItem,
        isExpanded: true,
        isExpandable: false,
        onToggle: ()=>{},
        isFirst: true
    }, actionCardFooter)));
};
function $90ec7adc9de34b1b$var$_temp(s) {
    return s.enabled;
}
function $90ec7adc9de34b1b$var$_temp2(source) {
    return {
        enabled: source.enabled,
        source: source.source,
        filters: {
            spaceFilter: source.filters?.confluenceFilter?.spaceFilter?.concat(),
            parentFilter: source.filters?.confluenceFilter?.parentFilter?.concat(),
            projectFilter: source.filters?.jiraFilter?.projectFilter?.concat(),
            jsmProjectFilter: source.filters?.jsmFilter?.jsmProjectFilter?.concat()
        }
    };
}
function $90ec7adc9de34b1b$var$_temp3() {}
module.exports["AgentDiffCard"] = $90ec7adc9de34b1b$export$30aa87e3ee380fc0;

});

parcelRegister("50AFk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bb5c5e7fdf332ebf$var$messages = (0, $kSwu1.defineMessages)({
    copyResponseLabel: {
        id: "chatHistory.storeAssistant.copyResponseLabel",
        defaultMessage: "Copy"
    }
});
var $bb5c5e7fdf332ebf$export$2e2bcd8739ae039 = $bb5c5e7fdf332ebf$var$messages;
module.exports["default"] = $bb5c5e7fdf332ebf$export$2e2bcd8739ae039;

});

parcelRegister("8whuT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c969b8e0ae8d332c$var$messages = (0, $kSwu1.defineMessages)({
    debugLabel: {
        id: "chatHistory.storeAssistant.debugLabel",
        defaultMessage: "Debug response"
    }
});
var $c969b8e0ae8d332c$export$2e2bcd8739ae039 = $c969b8e0ae8d332c$var$messages;
module.exports["default"] = $c969b8e0ae8d332c$export$2e2bcd8739ae039;

});

parcelRegister("cSbrJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");


var $8UJhp = parcelRequire("8UJhp");

const $f68c4a35c0b876d3$var$getIconComponent = (isDislike, isSelected)=>{
    const Icon = isDislike ? (0, (/*@__PURE__*/$parcel$interopDefault($93fnf))) : (0, (/*@__PURE__*/$parcel$interopDefault($c8bBH)));
    const iconColor = isSelected ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)";
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: iconColor
        });
};
const $f68c4a35c0b876d3$export$2125312a3d5f3d92 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { onClick: onClick, isDislike: isDislike, isSelected: isSelected, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "compact" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== isDislike) {
        t2 = isDislike ? formatMessage((0, $8UJhp.default).badResponseLabel) : formatMessage((0, $8UJhp.default).goodResponseLabel);
        $[0] = formatMessage;
        $[1] = isDislike;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== onClick) {
        t3 = (_, event)=>onClick(event);
        $[3] = onClick;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = isDislike ?? false;
    const t5 = !!isSelected;
    let t6;
    if ($[5] !== t4 || $[6] !== t5) {
        t6 = $f68c4a35c0b876d3$var$getIconComponent(t4, t5);
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const t7 = !!isSelected;
    let t8;
    if ($[8] !== spacing || $[9] !== t2 || $[10] !== t3 || $[11] !== t6 || $[12] !== t7 || $[13] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            label: t2,
            type: "button",
            testId: testId,
            onClick: t3,
            icon: t6,
            appearance: "subtle",
            spacing: spacing,
            shape: "default",
            isSelected: t7
        });
        $[8] = spacing;
        $[9] = t2;
        $[10] = t3;
        $[11] = t6;
        $[12] = t7;
        $[13] = testId;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ onClick: onClick, isDislike: isDislike, isSelected: isSelected, spacing: spacing = 'compact', testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        label: isDislike ? formatMessage((0, $8UJhp.default).badResponseLabel) : formatMessage((0, $8UJhp.default).goodResponseLabel),
        type: "button",
        testId: testId,
        onClick: (_, event)=>onClick(event),
        icon: $f68c4a35c0b876d3$var$getIconComponent(isDislike ?? false, !!isSelected),
        appearance: "subtle",
        spacing: spacing,
        shape: "default",
        isSelected: !!isSelected
    });
};
module.exports["LikeButton"] = $f68c4a35c0b876d3$export$2125312a3d5f3d92;

});

parcelRegister("f4V7N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a5ed5280770af3b5$export$3b64b13bb814b3e8 = (0, $cozmU.createContext)(undefined);
module.exports["ShareUpToMessageContext"] = $a5ed5280770af3b5$export$3b64b13bb814b3e8;

});

parcelRegister("71cHN", function(module, exports) {
const $8b8cc215c7e094fe$export$f78e277be6fb250f = ()=>undefined;
const $8b8cc215c7e094fe$export$539aeb93e2161592 = ()=>undefined;
const $8b8cc215c7e094fe$export$222b24351b133056 = ()=>undefined;
const $8b8cc215c7e094fe$export$eaa0ef967743006b = ()=>undefined;
const $8b8cc215c7e094fe$export$ce5a0d6090fe85d = (luminaNode)=>{
    const attrs = luminaNode.attributes ?? {};
    const { name: name, job_title: jobTitle, location: location, email: email, url: url } = attrs;
    // If URL is present, return a blockCard linking to the person's profile
    if (url) {
        const blockCard = {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
        return blockCard;
    }
    // For fallback rendering, a people card must have at least a name to be valid
    if (!name) return undefined;
    // Build single paragraph with bold name followed by details
    const content = [
        {
            type: 'text',
            text: name,
            marks: [
                {
                    type: 'strong'
                }
            ]
        }
    ];
    const details = [
        jobTitle,
        location,
        email
    ].filter((d)=>Boolean(d));
    for (const detail of details)content.push({
        type: 'hardBreak'
    }, {
        type: 'text',
        text: detail
    });
    return {
        type: 'paragraph',
        content: content
    };
};
const $8b8cc215c7e094fe$export$e74824dbba9bca2b = ()=>undefined;
const $8b8cc215c7e094fe$export$d686d6c95c08bf24 = ()=>undefined;
const $8b8cc215c7e094fe$export$ee1bd232931e8a68 = ()=>undefined;
const $8b8cc215c7e094fe$export$390d0b14d82fba5 = ()=>undefined;
module.exports["convertCarousel"] = $8b8cc215c7e094fe$export$f78e277be6fb250f;
module.exports["convertActionCard"] = $8b8cc215c7e094fe$export$539aeb93e2161592;
module.exports["convertProjectHighlightCard"] = $8b8cc215c7e094fe$export$222b24351b133056;
module.exports["convertContactCard"] = $8b8cc215c7e094fe$export$eaa0ef967743006b;
module.exports["convertPeopleCard"] = $8b8cc215c7e094fe$export$ce5a0d6090fe85d;
module.exports["convertReportLines"] = $8b8cc215c7e094fe$export$e74824dbba9bca2b;
module.exports["convertJiraEpicProgress"] = $8b8cc215c7e094fe$export$d686d6c95c08bf24;
module.exports["convertJiraBurndownChart"] = $8b8cc215c7e094fe$export$ee1bd232931e8a68;
module.exports["convertJiraWorkDistribution"] = $8b8cc215c7e094fe$export$390d0b14d82fba5;

});

parcelRegister("2T8yd", function(module, exports) {
/**
 * Converts a Lumina list item node to an ADF list item node.
 * Recursively converts child nodes and wraps text in paragraphs.
 *
 * Returns undefined if the list item has no content.
 */ const $7287ae092a8ddd39$var$convertListItem = (luminaNode, recursiveConvert)=>{
    let children;
    if (Array.isArray(luminaNode.children)) children = luminaNode.children;
    else if (typeof luminaNode.children === 'string') children = [
        luminaNode.children
    ];
    else children = [];
    const content = [];
    for (const child of children)if (typeof child === 'string') content.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: child
            }
        ]
    });
    else {
        const converted = recursiveConvert(child);
        if (converted !== undefined) content.push(converted);
    }
    if (content.length === 0) return undefined;
    return {
        type: 'listItem',
        content: content
    };
};
const $7287ae092a8ddd39$export$25f0e92ed67918e2 = (luminaNode, recursiveConvert)=>{
    const children = Array.isArray(luminaNode.children) ? luminaNode.children : [];
    const content = [];
    for (const child of children){
        if (typeof child === 'string') continue;
        const converted = $7287ae092a8ddd39$var$convertListItem(child, recursiveConvert);
        if (converted) content.push(converted);
    }
    if (content.length === 0) return undefined;
    return luminaNode.tag === 'ol' ? {
        type: 'orderedList',
        content: content
    } : {
        type: 'bulletList',
        content: content
    };
};
module.exports["convertList"] = $7287ae092a8ddd39$export$25f0e92ed67918e2;

});

parcelRegister("lbz6H", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $1lsdL = parcelRequire("1lsdL");

const $68b96700187d12d2$var$buildMentionText = (name)=>{
    if (!name) return '@';
    return name.startsWith('@') ? name : `@${name}`;
};
const $68b96700187d12d2$var$buildMention = (accountId, name)=>({
        type: 'mention',
        attrs: {
            id: accountId,
            text: $68b96700187d12d2$var$buildMentionText(name),
            userType: 'DEFAULT',
            accessLevel: 'CONTAINER'
        }
    });
const $68b96700187d12d2$export$f05a2b4d9943de47 = (luminaNode)=>{
    const attributes = luminaNode.attributes;
    const accountId = attributes?.accountId;
    const name = attributes?.name?.trim();
    if (!accountId) return undefined;
    if ((0, $iDrrr.fg)('kd_lumina_convert_people_as_adf')) return {
        type: 'paragraph',
        content: [
            $68b96700187d12d2$var$buildMention(accountId, name)
        ]
    };
    // Pre-gate behaviour: text fallback so any other Lumina-to-ADF consumer
    // (besides the gated chat copy button) keeps producing plain-text output.
    return {
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: 'Person',
                marks: [
                    {
                        type: 'strong'
                    }
                ]
            },
            {
                type: 'text',
                text: ` (${accountId})`
            }
        ]
    };
};
const $68b96700187d12d2$export$a3baa82e842193b6 = (luminaNode)=>{
    const list = luminaNode;
    const people = (0, $1lsdL.getUniquePeopleEntitiesFromList)(list);
    const items = [];
    for (const person of people){
        const inner = $68b96700187d12d2$export$f05a2b4d9943de47({
            tag: 'people-entity',
            attributes: person,
            children: []
        });
        if (inner === undefined) continue;
        items.push({
            type: 'listItem',
            content: [
                inner
            ]
        });
    }
    if (!items.length) return undefined;
    return {
        type: 'bulletList',
        content: items
    };
};
module.exports["convertPeopleEntity"] = $68b96700187d12d2$export$f05a2b4d9943de47;
module.exports["convertPeopleEntityList"] = $68b96700187d12d2$export$a3baa82e842193b6;

});

parcelRegister("90kqV", function(module, exports) {
/**
 * Default layout for embed cards
 */ const $f145e8dd704872a4$var$DEFAULT_EMBED_LAYOUT = 'wide';
const $f145e8dd704872a4$export$9c713024b3528514 = (luminaNode)=>{
    const attrs = luminaNode.attributes;
    const url = attrs?.url;
    // Smart links require a URL to be valid
    if (!url) return undefined;
    const display = attrs?.display ?? 'inline';
    switch(display){
        case 'block':
            {
                const blockCard = {
                    type: 'blockCard',
                    attrs: {
                        url: url
                    }
                };
                return blockCard;
            }
        case 'embed':
            {
                const parsedWidth = attrs?.width ? parseInt(attrs.width, 10) : undefined;
                const width = parsedWidth !== undefined && !isNaN(parsedWidth) ? parsedWidth : undefined;
                const embedCard = {
                    type: 'embedCard',
                    attrs: {
                        url: url,
                        layout: $f145e8dd704872a4$var$DEFAULT_EMBED_LAYOUT,
                        ...width !== undefined && {
                            width: width
                        }
                    }
                };
                return embedCard;
            }
        case 'inline':
        default:
            {
                // Inline cards must be wrapped in a paragraph in ADF
                const paragraph = {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'inlineCard',
                            attrs: {
                                url: url
                            }
                        }
                    ]
                };
                return paragraph;
            }
    }
};
module.exports["convertSmartLink"] = $f145e8dd704872a4$export$9c713024b3528514;

});

parcelRegister("exWRW", function(module, exports) {

var $hcxmK = parcelRequire("hcxmK");

// Narrows a smart-link-list child to a SmartLinkListItemType, so the converter
// can discriminate `<item>` nodes without an unchecked `as` cast. `<item>` is
// not part of the general ParsedElementType union, hence the local guard.
const $e354257a9dfe7117$var$isSmartLinkListItem = (child)=>typeof child === 'object' && child !== null && child.tag === 'item';
const $e354257a9dfe7117$export$9ab21cf3e475dda2 = (luminaNode)=>{
    const { children: children } = luminaNode;
    if (typeof children === 'string') return undefined;
    if (!Array.isArray(children) || children.length === 0) return undefined;
    const listItems = [];
    // Malformed children (non-`item` tags, missing/unsafe URLs) are intentionally
    // skipped rather than throwing: copy/paste must degrade gracefully and never
    // fail mid-conversion on imperfect LLM output. Valid items are still emitted.
    for (const child of children){
        if (!$e354257a9dfe7117$var$isSmartLinkListItem(child)) continue;
        const url = child.attributes?.url;
        if (typeof url !== 'string' || url.length === 0) continue;
        if (!(0, $hcxmK.isHttpUrl)(url)) continue;
        listItems.push({
            type: 'listItem',
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'inlineCard',
                            attrs: {
                                url: url
                            }
                        }
                    ]
                }
            ]
        });
    }
    if (listItems.length === 0) return undefined;
    return {
        type: 'bulletList',
        content: listItems
    };
};
module.exports["convertSmartLinkList"] = $e354257a9dfe7117$export$9ab21cf3e475dda2;

});

parcelRegister("jFuky", function(module, exports) {
/**
 * Turns children (direct string or array that may contain strings) into ADF text content.
 * Returns an empty text node by default.
 */ const $d27257a06c4bc6bc$var$childrenToTextContent = (children)=>{
    if (typeof children === 'string') return [
        {
            type: 'text',
            text: children
        }
    ];
    if (Array.isArray(children)) return children.flatMap((item)=>typeof item === 'string' ? [
            {
                type: 'text',
                text: item
            }
        ] : []);
    return [
        {
            type: 'text',
            text: ''
        }
    ];
};
const $d27257a06c4bc6bc$export$298b49e83d4826b9 = (luminaNode)=>{
    const content = $d27257a06c4bc6bc$var$childrenToTextContent(luminaNode.children);
    const attrs = luminaNode.attributes;
    return {
        type: 'heading',
        attrs: {
            level: parseInt(attrs?.level ?? '2') || 2
        },
        ...content.length > 0 && {
            content: content
        }
    };
};
const $d27257a06c4bc6bc$export$b45c6900253be097 = (luminaNode)=>{
    const content = $d27257a06c4bc6bc$var$childrenToTextContent(luminaNode.children);
    return {
        type: 'paragraph',
        ...content.length > 0 && {
            content: content
        }
    };
};
module.exports["convertH"] = $d27257a06c4bc6bc$export$298b49e83d4826b9;
module.exports["convertMd"] = $d27257a06c4bc6bc$export$b45c6900253be097;

});

parcelRegister("c1A61", function(module, exports) {
/**
 * @generated SignedSource<<8752b104456cc40db63c0d66b0e11335>>
 * @relayHash e457255d0330dca09a8fe6de476f84d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c78aa5a2cc3a60b4efa24d70362b4bc69d7aa78e86eeee24ac142722c78689d
const $652b367e9e6a7358$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentIssueKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldFetchParentIssue"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "parentIssueKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entrypointGicModalParentIssueQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldFetchParentIssue",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entrypointGicModalParentIssueQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldFetchParentIssue",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c78aa5a2cc3a60b4efa24d70362b4bc69d7aa78e86eeee24ac142722c78689d",
            "metadata": {},
            "name": "entrypointGicModalParentIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$652b367e9e6a7358$var$node.hash = "ba8513d5335b969e816daddb6705bf83";
var $652b367e9e6a7358$export$2e2bcd8739ae039 = $652b367e9e6a7358$var$node;
module.exports["default"] = $652b367e9e6a7358$export$2e2bcd8739ae039;

});

parcelRegister("5Wv8d", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5Sv3D = parcelRequire("5Sv3D");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $haiCi = parcelRequire("haiCi");

const $52f30782f3897d13$var$DEBOUNCE_DELAY = 300;
const $52f30782f3897d13$var$SearchJiraProjectsQuery = `
query GetProjects($query: String!, $siteAri: String!) {
  search {
		search(
			query: $query
			filters: {
				entities: ["ati:cloud:jira:project"],
				locations: [$siteAri],
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					... on SearchResultJiraProject {
						id
						projectKey
						title
						iconUrl
						url
						project {
							issueTypes {
								edges {
									node {
										issueTypeId
										name
										avatar {
											xsmall
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
`;
const $52f30782f3897d13$var$extractProjectFromARI = (input)=>{
    // Match the last numeric segment after "project/"
    const pattern = /project\/(\d+)$/;
    const match = input.match(pattern);
    return match ? match[1] : '';
};
const $52f30782f3897d13$export$ee4222fd4f81f7a8 = (option)=>option.iconUrl;
const $52f30782f3897d13$export$50eea053f4b6fc32 = ({ siteId: siteId, isDisabled: isDisabled = false, selectedProject: selectedProject, setProject: setProject })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch), (0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [allOptions, setAllOptions] = (0, $cozmU.useState)([]);
    const [displayedOptions, setDisplayedOptions] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const hasFetchedInitialOptions = (0, $cozmU.useRef)(false);
    const loadOptions = (0, $cozmU.useCallback)(async (value)=>{
        setIsLoading(true);
        try {
            const response = await (0, $haiCi.performGqlFetch)({
                gqlQuery: $52f30782f3897d13$var$SearchJiraProjectsQuery,
                variables: {
                    query: value,
                    siteAri: `ari:cloud:jira::site/${siteId}`
                }
            });
            return response.data?.search?.search?.edges?.map((edge)=>edge.node)?.map((item)=>({
                    projectKey: item.projectKey,
                    label: item.title,
                    value: item.id,
                    iconUrl: item.iconUrl,
                    issueTypes: item.project.issueTypes.edges.map(({ node: node })=>({
                            issueTypeId: node.issueTypeId,
                            name: node.name,
                            avatarUrl: node.avatar?.xsmall
                        }))
                })) ?? [];
        } catch (error) {
            (0, $hlvTd.logException)({
                exception: error,
                name: 'SearchJiraProjectsQueryError',
                tags: {
                    cloudId: siteId
                }
            });
            return [];
        } finally{
            hasFetchedInitialOptions.current = true;
            setIsLoading(false);
        }
    }, [
        siteId
    ]);
    const sortOptionsWithSelectedFirst = (0, $cozmU.useCallback)((options)=>{
        if (!selectedProject?.value || !options || options.length === 0) return options || [];
        const selectedId = $52f30782f3897d13$var$extractProjectFromARI(String(selectedProject.value)) || String(selectedProject.value);
        const otherOptions = options.filter((option)=>{
            const optionId = typeof option.value === 'string' ? $52f30782f3897d13$var$extractProjectFromARI(option.value) || option.value : option.value;
            return optionId !== selectedId;
        });
        return [
            selectedProject,
            ...otherOptions
        ];
    }, [
        selectedProject
    ]);
    (0, $cozmU.useEffect)(()=>{
        const preloadOptions = async ()=>{
            if (allOptions.length === 0 && !isLoading && !isDisabled && !hasFetchedInitialOptions.current) {
                const initialOptions = await loadOptions('');
                setAllOptions(initialOptions);
                setDisplayedOptions(initialOptions);
            }
        };
        preloadOptions();
    }, [
        allOptions.length,
        isDisabled,
        isLoading,
        loadOptions
    ]);
    const handleProjectChange = (0, $cozmU.useCallback)((selectedOption)=>{
        const selectedOptionValue = selectedOption?.value;
        if (!selectedOption || typeof selectedOptionValue !== 'string') return;
        const selectedOptionProjectId = $52f30782f3897d13$var$extractProjectFromARI(selectedOptionValue) || selectedOptionValue;
        if (selectedOptionProjectId === selectedProject?.value) return;
        setProject({
            projectId: selectedOptionProjectId,
            projectKey: selectedOption.projectKey ?? '',
            projectName: selectedOption.label ?? '',
            issueTypes: selectedOption.issueTypes ?? []
        });
        if (!allOptions.some((option_0)=>option_0.value === selectedOptionValue)) setAllOptions((prev)=>[
                ...prev,
                selectedOption
            ]);
        setDisplayedOptions(allOptions);
    }, [
        selectedProject,
        setProject,
        allOptions
    ]);
    const [debouncedLoadOptions] = (0, $5Sv3D.default)(async (value_0)=>{
        setDisplayedOptions(await loadOptions(value_0));
    }, $52f30782f3897d13$var$DEBOUNCE_DELAY);
    const handleMenuOpen = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown',
            actionSubjectId: 'jiraAifcPreviewCardProjectSelector'
        });
    }, [
        sendAnalyticsEvent
    ]);
    const handleMenuClose = (0, $cozmU.useCallback)(()=>{
        setDisplayedOptions(allOptions);
    }, [
        allOptions
    ]);
    return {
        displayedOptions: displayedOptions,
        isLoading: isLoading,
        sortOptionsWithSelectedFirst: sortOptionsWithSelectedFirst,
        handleProjectChange: handleProjectChange,
        debouncedLoadOptions: debouncedLoadOptions,
        handleMenuOpen: handleMenuOpen,
        handleMenuClose: handleMenuClose
    };
};
module.exports["getOptionIconUrl"] = $52f30782f3897d13$export$ee4222fd4f81f7a8;
module.exports["useProjectSearch"] = $52f30782f3897d13$export$50eea053f4b6fc32;

});

parcelRegister("bNRRA", function(module, exports) {
/**
 * @generated SignedSource<<a94147a40958c942233d08b59f52b3ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5cb0ec10d76b491b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_project",
    "selections": [
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project"
        }
    ],
    "type": "JiraProject"
};
$5cb0ec10d76b491b$var$node.hash = "6cf7587a93e258bda6babd41521d0231";
var $5cb0ec10d76b491b$export$2e2bcd8739ae039 = $5cb0ec10d76b491b$var$node;
module.exports["default"] = $5cb0ec10d76b491b$export$2e2bcd8739ae039;

});

parcelRegister("lrAX8", function(module, exports) {
/**
 * @generated SignedSource<<43c06b7fe1071bcd18ff894dcb0edbe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41e99d2a4bc6c985$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType"
        }
    ],
    "type": "JiraIssueType"
};
$41e99d2a4bc6c985$var$node.hash = "2291f6a1b2e0e539ce7eb0194f65644e";
var $41e99d2a4bc6c985$export$2e2bcd8739ae039 = $41e99d2a4bc6c985$var$node;
module.exports["default"] = $41e99d2a4bc6c985$export$2e2bcd8739ae039;

});

parcelRegister("fgX9l", function(module, exports) {
/**
 * @generated SignedSource<<920e906ffddb61cf4d80feb06405d2a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa97591019148977$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project"
        }
    ],
    "type": "JiraProject"
};
$aa97591019148977$var$node.hash = "1974182e7e485e4aff7803510054da1e";
var $aa97591019148977$export$2e2bcd8739ae039 = $aa97591019148977$var$node;
module.exports["default"] = $aa97591019148977$export$2e2bcd8739ae039;

});

parcelRegister("SiFbN", function(module, exports) {
/**
 * @generated SignedSource<<fe0639851d82b3c6d915c12ce4c9d041>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f15c152730b7425d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "JiraIssueTypeIcon_Platform"
        }
    ],
    "type": "JiraIssueType"
};
$f15c152730b7425d$var$node.hash = "3d777c04058ec8abae13d390800dd4aa";
var $f15c152730b7425d$export$2e2bcd8739ae039 = $f15c152730b7425d$var$node;
module.exports["default"] = $f15c152730b7425d$export$2e2bcd8739ae039;

});

parcelRegister("6PaCk", function(module, exports) {
/**
 * @generated SignedSource<<d6b0dd0bdeabfafe484c88a6864955a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dc7083e9d5a8f748$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "rowActions_AtlassianConversationAssistantPreviewCard"
        }
    ],
    "type": "JiraProject"
};
$dc7083e9d5a8f748$var$node.hash = "eb5bc0ec6c01815099a03cf046cf04b8";
var $dc7083e9d5a8f748$export$2e2bcd8739ae039 = $dc7083e9d5a8f748$var$node;
module.exports["default"] = $dc7083e9d5a8f748$export$2e2bcd8739ae039;

});

parcelRegister("1eUdH", function(module, exports) {

var $1dQeb = parcelRequire("1dQeb");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $cJ0FD = parcelRequire("cJ0FD");


var $lpNn5 = parcelRequire("lpNn5");

const $096f7b8d30ea586d$export$4c9df703a65e2d78 = ({ issueType: issueType, showTooltip: showTooltip })=>{
    const data = (0, $6SsN4.useFragment)((0, $1dQeb.default), issueType);
    const name = data.name;
    const avatarUrl = data.avatar?.small;
    const image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: avatarUrl ?? undefined,
        alt: name,
        width: 16
    });
    if (showTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: name
    }, image);
    return image;
};
module.exports["JiraIssueTypeIcon"] = $096f7b8d30ea586d$export$4c9df703a65e2d78;

});

parcelRegister("91ATo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $2ZX6j = parcelRequire("2ZX6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $1sCHt = parcelRequire("1sCHt");


var $cXtTj = parcelRequire("cXtTj");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $gC2EJ = parcelRequire("gC2EJ");


var $1l0kj = parcelRequire("1l0kj");


var $lpNn5 = parcelRequire("lpNn5");


var $gYLQo = parcelRequire("gYLQo");


var $j9Z2s = parcelRequire("j9Z2s");


var $7ChxK = parcelRequire("7ChxK");

const $c719133cbb12e741$var$messages = (0, $kSwu1.defineMessages)({
    editWorkItem: {
        id: "jiraCreateWithRovoPreviewCard.editWorkItem",
        defaultMessage: "Edit work item"
    },
    declineWorkItem: {
        id: "jiraCreateWithRovoPreviewCard.declineWorkItem",
        defaultMessage: "Decline work item"
    },
    acceptWorkItem: {
        id: "jiraCreateWithRovoPreviewCard.acceptWorkItem",
        defaultMessage: "Accept work item"
    },
    disabledInlineCreate: {
        id: "jiraCreateWithRovoPreviewCard.disabledInlineCreate",
        defaultMessage: "Create or add a parent to accept this work item."
    },
    disabledInlineEdit: {
        id: "jiraCreateWithRovoPreviewCard.disabledInlineEdit",
        defaultMessage: "Create or add a parent to edit this work item."
    }
});
const $c719133cbb12e741$var$styles = {
    inlineButtons: "_0bjKvDKxmn _1mT5xdWVPG _4ApkO22ADO _0wOv4Q7zJH _0KLXru66of"
};
const $c719133cbb12e741$export$523acc1bb0ce2e43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { projectRef: projectRef, draftWorkItem: draftWorkItem, onDeclineWorkItem: onDeclineWorkItem, onInlineAccept: onInlineAccept, isCreating: isCreating, showRowActions: showRowActions, gicEntryPointProps: gicEntryPointProps, isStagingArea: isStagingArea, itemCount: itemCount, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const projectData = (0, $6SsN4.useFragment)((0, $2ZX6j.default), projectRef);
    const projectId = projectData?.projectId ?? undefined;
    let t1;
    if ($[0] !== draftWorkItem.invocationId || $[1] !== onDeclineWorkItem) {
        t1 = ()=>{
            onDeclineWorkItem({
                invocationId: draftWorkItem.invocationId
            });
        };
        $[0] = draftWorkItem.invocationId;
        $[1] = onDeclineWorkItem;
        $[2] = t1;
    } else t1 = $[2];
    const handleOnDecline = t1;
    let t2;
    if ($[3] !== draftWorkItem) {
        t2 = (0, $7ChxK.isSubTaskWithoutCreatedParent)(draftWorkItem);
        $[3] = draftWorkItem;
        $[4] = t2;
    } else t2 = $[4];
    const isSubTaskWithoutParent = t2;
    const showActions = isCreating || showRowActions;
    const hasCreatedIssueKey = draftWorkItem.createdIssueKey;
    let t3;
    if ($[5] !== isStagingArea || $[6] !== itemCount || $[7] !== sendAifcAnalyticsEvent) {
        t3 = ()=>{
            sendAifcAnalyticsEvent?.({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "createWorkItemsEditInGic",
                attributes: {
                    itemCount: itemCount,
                    isSingleWorkItem: false,
                    isStagingArea: isStagingArea
                }
            });
        };
        $[5] = isStagingArea;
        $[6] = itemCount;
        $[7] = sendAifcAnalyticsEvent;
        $[8] = t3;
    } else t3 = $[8];
    const onGicClick = t3;
    if (!showActions || hasCreatedIssueKey) return null;
    let t4;
    if ($[9] !== formatMessage || $[10] !== isCreating || $[11] !== isSubTaskWithoutParent || $[12] !== onInlineAccept) {
        t4 = !(0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: isSubTaskWithoutParent ? formatMessage($c719133cbb12e741$var$messages.disabledInlineCreate) : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $c719133cbb12e741$var$_temp,
            label: formatMessage($c719133cbb12e741$var$messages.acceptWorkItem),
            appearance: "subtle",
            spacing: "compact",
            onClick: onInlineAccept,
            isDisabled: isSubTaskWithoutParent,
            isLoading: isCreating
        }));
        $[9] = formatMessage;
        $[10] = isCreating;
        $[11] = isSubTaskWithoutParent;
        $[12] = onInlineAccept;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage || $[15] !== isSubTaskWithoutParent) {
        t5 = isSubTaskWithoutParent ? formatMessage($c719133cbb12e741$var$messages.disabledInlineEdit) : undefined;
        $[14] = formatMessage;
        $[15] = isSubTaskWithoutParent;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== formatMessage) {
        t6 = formatMessage($c719133cbb12e741$var$messages.editWorkItem);
        $[17] = formatMessage;
        $[18] = t6;
    } else t6 = $[18];
    const t7 = isSubTaskWithoutParent || isCreating;
    let t8;
    if ($[19] !== draftWorkItem || $[20] !== gicEntryPointProps || $[21] !== projectId) {
        t8 = {
            ...gicEntryPointProps,
            selectedDraftWorkItem: draftWorkItem,
            projectId: projectId
        };
        $[19] = draftWorkItem;
        $[20] = gicEntryPointProps;
        $[21] = projectId;
        $[22] = t8;
    } else t8 = $[22];
    const t9 = draftWorkItem?.fields?.parent ?? undefined;
    let t10;
    if ($[23] !== gicEntryPointProps.cloudId || $[24] !== t9) {
        t10 = {
            cloudId: gicEntryPointProps.cloudId,
            parentIssue: t9
        };
        $[23] = gicEntryPointProps.cloudId;
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            width: "large",
            shouldScrollInViewport: true
        };
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== onGicClick || $[28] !== t10 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gYLQo.ModalIconButtonTrigger), {
            icon: $c719133cbb12e741$var$_temp2,
            label: t6,
            appearance: "subtle",
            spacing: "compact",
            entryPoint: (0, $j9Z2s.gicModalEntryPoint),
            onClick: onGicClick,
            isDisabled: t7,
            entryPointProps: t8,
            entryPointParams: t10,
            modalProps: t11
        });
        $[27] = onGicClick;
        $[28] = t10;
        $[29] = t6;
        $[30] = t7;
        $[31] = t8;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] !== t12 || $[34] !== t5) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t5
        }, t12);
        $[33] = t12;
        $[34] = t5;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== formatMessage) {
        t14 = formatMessage($c719133cbb12e741$var$messages.declineWorkItem);
        $[36] = formatMessage;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== handleOnDecline || $[39] !== isCreating || $[40] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $c719133cbb12e741$var$_temp3,
            label: t14,
            appearance: "subtle",
            spacing: "compact",
            onClick: handleOnDecline,
            isDisabled: isCreating
        });
        $[38] = handleOnDecline;
        $[39] = isCreating;
        $[40] = t14;
        $[41] = t15;
    } else t15 = $[41];
    let t16;
    if ($[42] !== t13 || $[43] !== t15 || $[44] !== t4) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            xcss: $c719133cbb12e741$var$styles.inlineButtons
        }, t4, t13, t15);
        $[42] = t13;
        $[43] = t15;
        $[44] = t4;
        $[45] = t16;
    } else t16 = $[45];
    return t16;
} : ({ projectRef: projectRef, draftWorkItem: draftWorkItem, onDeclineWorkItem: onDeclineWorkItem, onInlineAccept: onInlineAccept, isCreating: isCreating, showRowActions: showRowActions, gicEntryPointProps: gicEntryPointProps, isStagingArea: isStagingArea, itemCount: itemCount, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const projectData = (0, $6SsN4.useFragment)((0, $2ZX6j.default), projectRef);
    const projectId = projectData?.projectId ?? undefined;
    const handleOnDecline = (0, $cozmU.useCallback)(()=>{
        onDeclineWorkItem({
            invocationId: draftWorkItem.invocationId
        });
    }, [
        onDeclineWorkItem,
        draftWorkItem.invocationId
    ]);
    const isSubTaskWithoutParent = (0, $7ChxK.isSubTaskWithoutCreatedParent)(draftWorkItem);
    const showActions = isCreating || showRowActions; // Don't show actions if the work item has already been created
    const hasCreatedIssueKey = draftWorkItem.createdIssueKey;
    const onGicClick = (0, $cozmU.useCallback)(()=>{
        sendAifcAnalyticsEvent?.({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWorkItemsEditInGic',
            attributes: {
                itemCount: itemCount,
                isSingleWorkItem: false,
                isStagingArea: isStagingArea
            }
        });
    }, [
        sendAifcAnalyticsEvent,
        isStagingArea,
        itemCount
    ]);
    if (!showActions || hasCreatedIssueKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $c719133cbb12e741$var$styles.inlineButtons
    }, !(0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isSubTaskWithoutParent ? formatMessage($c719133cbb12e741$var$messages.disabledInlineCreate) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage($c719133cbb12e741$var$messages.acceptWorkItem),
        appearance: "subtle",
        spacing: "compact",
        onClick: onInlineAccept,
        isDisabled: isSubTaskWithoutParent,
        isLoading: isCreating
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isSubTaskWithoutParent ? formatMessage($c719133cbb12e741$var$messages.disabledInlineEdit) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gYLQo.ModalIconButtonTrigger), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                ...iconProps_0,
                size: "small"
            }),
        label: formatMessage($c719133cbb12e741$var$messages.editWorkItem),
        appearance: "subtle",
        spacing: "compact",
        entryPoint: (0, $j9Z2s.gicModalEntryPoint),
        onClick: onGicClick,
        isDisabled: isSubTaskWithoutParent || isCreating,
        entryPointProps: {
            ...gicEntryPointProps,
            selectedDraftWorkItem: draftWorkItem,
            projectId: projectId
        },
        entryPointParams: {
            cloudId: gicEntryPointProps.cloudId,
            parentIssue: draftWorkItem?.fields?.parent ?? undefined
        },
        modalProps: {
            width: 'large',
            shouldScrollInViewport: true
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_1,
                size: "small"
            }),
        label: formatMessage($c719133cbb12e741$var$messages.declineWorkItem),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleOnDecline,
        isDisabled: isCreating
    }));
};
function $c719133cbb12e741$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        ...iconProps,
        size: "small"
    });
}
function $c719133cbb12e741$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        ...iconProps_0,
        size: "small"
    });
}
function $c719133cbb12e741$var$_temp3(iconProps_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_1,
        size: "small"
    });
}
module.exports["RowActions"] = $c719133cbb12e741$export$523acc1bb0ce2e43;

});

parcelRegister("9jygb", function(module, exports) {
/**
 * @generated SignedSource<<70051d1814e5f6273e5804bb61994e31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f543825e1fb1f92$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "previewContent_AtlassianConversationAssistantPreviewCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "JiraIssueTypeIcon_Platform"
                                },
                                {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "field_AtlassianConversationAssistantPreviewCard"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "withFieldLabel_AtlassianConversationAssistantPreviewCard"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$6f543825e1fb1f92$var$node.hash = "1fab6b10b4450c713cca747d62df8a1c";
var $6f543825e1fb1f92$export$2e2bcd8739ae039 = $6f543825e1fb1f92$var$node;
module.exports["default"] = $6f543825e1fb1f92$export$2e2bcd8739ae039;

});

parcelRegister("ajIch", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hTt4H = parcelRequire("hTt4H");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $jNOAq = parcelRequire("jNOAq");


var $gYtwq = parcelRequire("gYtwq");


var $dX04h = parcelRequire("dX04h");


var $nti55 = parcelRequire("nti55");


var $hzIKQ = parcelRequire("hzIKQ");


var $9Gvh5 = parcelRequire("9Gvh5");


var $hTOEa = parcelRequire("hTOEa");


var $g0hFf = parcelRequire("g0hFf");


var $gpQ9H = parcelRequire("gpQ9H");


var $eAi78 = parcelRequire("eAi78");


var $h7OKx = parcelRequire("h7OKx");


var $hzmZ3 = parcelRequire("hzmZ3");


var $k28ss = parcelRequire("k28ss");


var $7QeEQ = parcelRequire("7QeEQ");


var $671V0 = parcelRequire("671V0");


var $ifOkh = parcelRequire("ifOkh");


var $f4HfZ = parcelRequire("f4HfZ");


var $bKWb7 = parcelRequire("bKWb7");


var $7R0Ml = parcelRequire("7R0Ml");


var $QLwYi = parcelRequire("QLwYi");


var $7ChxK = parcelRequire("7ChxK");

const $5e321107f0a653e7$export$a455218a85c89869 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(120);
    const { as: as, field: field, fieldValue: fieldValue, invocationId: invocationId, isFullWidth: isFullWidth, isEditable: isEditable, projectKey: projectKey, onFieldChange: onFieldChange, isStagingArea: isStagingArea, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent } = t0;
    const fieldData = (0, $6SsN4.useFragment)((0, $hTt4H.default), field);
    const fieldType = fieldData?.__typename;
    const isRequired = !!fieldData?.fieldConfig?.isRequired;
    let t1;
    if ($[0] !== fieldData?.fieldId || $[1] !== fieldType || $[2] !== invocationId || $[3] !== isRequired || $[4] !== isStagingArea || $[5] !== onFieldChange || $[6] !== sendAifcAnalyticsEvent) {
        t1 = (newValue, t2)=>{
            const skipFireAnalytics = t2 === undefined ? false : t2;
            onFieldChange(invocationId, fieldData?.fieldId ?? "", newValue, skipFireAnalytics);
            if (!skipFireAnalytics) sendAifcAnalyticsEvent?.({
                action: "applied",
                actionSubject: "inlineEdit",
                actionSubjectId: "createWorkItemsInlineEdit",
                attributes: {
                    isSingleWorkItem: true,
                    source: "createWithRovoPreviewCard",
                    fieldType: fieldType,
                    isRequired: isRequired,
                    isSystemField: (0, $7ChxK.isSystemField)(fieldData?.fieldId),
                    isStagingArea: isStagingArea
                }
            });
        };
        $[0] = fieldData?.fieldId;
        $[1] = fieldType;
        $[2] = invocationId;
        $[3] = isRequired;
        $[4] = isStagingArea;
        $[5] = onFieldChange;
        $[6] = sendAifcAnalyticsEvent;
        $[7] = t1;
    } else t1 = $[7];
    fieldData?.fieldId;
    const onChange = t1;
    let t2;
    bb0: {
        if (typeof fieldValue === "object" && fieldValue !== null) {
            if ("user" in fieldValue && typeof fieldValue.user === "object" && fieldValue.user !== null && "name" in fieldValue.user) {
                t2 = String(fieldValue.user.name);
                break bb0;
            }
            if ("value" in fieldValue) {
                t2 = String(fieldValue.value);
                break bb0;
            }
            if ("label" in fieldValue) {
                t2 = String(fieldValue.label);
                break bb0;
            }
            if ("id" in fieldValue) {
                t2 = String(fieldValue.id);
                break bb0;
            }
        }
        t2 = String(fieldValue);
    }
    const valueToRender = t2;
    switch(fieldData?.__typename){
        case "JiraSingleLineTextField":
            {
                let t3;
                if ($[8] !== as || $[9] !== fieldData || $[10] !== fieldValue || $[11] !== isEditable || $[12] !== isFullWidth || $[13] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $671V0.JiraSingleLineTextField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable,
                        as: as,
                        isFullWidth: isFullWidth
                    });
                    $[8] = as;
                    $[9] = fieldData;
                    $[10] = fieldValue;
                    $[11] = isEditable;
                    $[12] = isFullWidth;
                    $[13] = onChange;
                    $[14] = t3;
                } else t3 = $[14];
                return t3;
            }
        case "JiraRichTextField":
            {
                let t3;
                if ($[15] !== fieldData || $[16] !== fieldValue || $[17] !== isEditable || $[18] !== isFullWidth || $[19] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QeEQ.JiraRichTextField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        isFieldEditable: isEditable,
                        onChange: onChange,
                        isFullWidth: isFullWidth
                    });
                    $[15] = fieldData;
                    $[16] = fieldValue;
                    $[17] = isEditable;
                    $[18] = isFullWidth;
                    $[19] = onChange;
                    $[20] = t3;
                } else t3 = $[20];
                return t3;
            }
        case "JiraSingleSelectUserPickerField":
            {
                let t3;
                if ($[21] !== fieldData || $[22] !== fieldValue || $[23] !== isEditable || $[24] !== onChange || $[25] !== projectKey) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4HfZ.JiraSingleSelectUserPickerField), {
                        field: fieldData,
                        fieldId: fieldData.fieldId,
                        fieldValue: fieldValue,
                        isFieldEditable: isEditable,
                        onChange: onChange,
                        projectKey: projectKey
                    });
                    $[21] = fieldData;
                    $[22] = fieldValue;
                    $[23] = isEditable;
                    $[24] = onChange;
                    $[25] = projectKey;
                    $[26] = t3;
                } else t3 = $[26];
                return t3;
            }
        case "JiraMultipleSelectUserPickerField":
            {
                let t3;
                if ($[27] !== fieldData || $[28] !== fieldValue || $[29] !== isEditable || $[30] !== onChange || $[31] !== projectKey) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gpQ9H.JiraMultipleSelectUserPickerField), {
                        field: fieldData,
                        fieldId: fieldData.fieldId,
                        fieldValue: fieldValue,
                        isFieldEditable: isEditable,
                        onChange: onChange,
                        projectKey: projectKey
                    });
                    $[27] = fieldData;
                    $[28] = fieldValue;
                    $[29] = isEditable;
                    $[30] = onChange;
                    $[31] = projectKey;
                    $[32] = t3;
                } else t3 = $[32];
                return t3;
            }
        case "JiraPeopleField":
            {
                let t3;
                if ($[33] !== fieldData || $[34] !== fieldValue || $[35] !== isEditable || $[36] !== onChange || $[37] !== projectKey) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h7OKx.JiraPeopleField), {
                        field: fieldData,
                        fieldId: fieldData.fieldId,
                        fieldValue: fieldValue,
                        isFieldEditable: isEditable,
                        onChange: onChange,
                        projectKey: projectKey
                    });
                    $[33] = fieldData;
                    $[34] = fieldValue;
                    $[35] = isEditable;
                    $[36] = onChange;
                    $[37] = projectKey;
                    $[38] = t3;
                } else t3 = $[38];
                return t3;
            }
        case "JiraPriorityField":
            {
                let t3;
                if ($[39] !== fieldData || $[40] !== fieldValue || $[41] !== isEditable || $[42] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzmZ3.JiraPriorityField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[39] = fieldData;
                    $[40] = fieldValue;
                    $[41] = isEditable;
                    $[42] = onChange;
                    $[43] = t3;
                } else t3 = $[43];
                return t3;
            }
        case "JiraSingleSelectField":
            {
                let t3;
                if ($[44] !== fieldData || $[45] !== fieldValue || $[46] !== isEditable || $[47] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifOkh.JiraSingleSelectField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[44] = fieldData;
                    $[45] = fieldValue;
                    $[46] = isEditable;
                    $[47] = onChange;
                    $[48] = t3;
                } else t3 = $[48];
                return t3;
            }
        case "JiraMultipleSelectField":
            {
                let t3;
                if ($[49] !== fieldData || $[50] !== fieldValue || $[51] !== isEditable || $[52] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g0hFf.JiraMultipleSelectField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[49] = fieldData;
                    $[50] = fieldValue;
                    $[51] = isEditable;
                    $[52] = onChange;
                    $[53] = t3;
                } else t3 = $[53];
                return t3;
            }
        case "JiraDatePickerField":
            {
                let t3;
                if ($[54] !== fieldData || $[55] !== fieldValue || $[56] !== isEditable || $[57] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $nti55.JiraDatePickerField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[54] = fieldData;
                    $[55] = fieldValue;
                    $[56] = isEditable;
                    $[57] = onChange;
                    $[58] = t3;
                } else t3 = $[58];
                return t3;
            }
        case "JiraDateTimePickerField":
            {
                let t3;
                if ($[59] !== fieldData || $[60] !== fieldValue || $[61] !== isEditable || $[62] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzIKQ.JiraDateTimePickerField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[59] = fieldData;
                    $[60] = fieldValue;
                    $[61] = isEditable;
                    $[62] = onChange;
                    $[63] = t3;
                } else t3 = $[63];
                return t3;
            }
        case "JiraNumberField":
            {
                let t3;
                if ($[64] !== fieldData || $[65] !== fieldValue || $[66] !== isEditable || $[67] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eAi78.JiraNumberField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[64] = fieldData;
                    $[65] = fieldValue;
                    $[66] = isEditable;
                    $[67] = onChange;
                    $[68] = t3;
                } else t3 = $[68];
                return t3;
            }
        case "JiraTimeTrackingField":
            {
                let t3;
                if ($[69] !== fieldData || $[70] !== fieldValue || $[71] !== isEditable || $[72] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7R0Ml.JiraTimeTrackingField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[69] = fieldData;
                    $[70] = fieldValue;
                    $[71] = isEditable;
                    $[72] = onChange;
                    $[73] = t3;
                } else t3 = $[73];
                return t3;
            }
        case "JiraRadioSelectField":
            {
                let t3;
                if ($[74] !== fieldData || $[75] !== fieldValue || $[76] !== isEditable || $[77] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k28ss.JiraRadioSelectField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[74] = fieldData;
                    $[75] = fieldValue;
                    $[76] = isEditable;
                    $[77] = onChange;
                    $[78] = t3;
                } else t3 = $[78];
                return t3;
            }
        case "JiraLabelsField":
            {
                let t3;
                if ($[79] !== fieldData || $[80] !== fieldValue || $[81] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTOEa.JiraLabelsField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange
                    });
                    $[79] = fieldData;
                    $[80] = fieldValue;
                    $[81] = onChange;
                    $[82] = t3;
                } else t3 = $[82];
                return t3;
            }
        case "JiraCascadingSelectField":
            {
                let t3;
                if ($[83] !== fieldData || $[84] !== fieldValue || $[85] !== isEditable || $[86] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jNOAq.JiraCascadingSelectField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[83] = fieldData;
                    $[84] = fieldValue;
                    $[85] = isEditable;
                    $[86] = onChange;
                    $[87] = t3;
                } else t3 = $[87];
                return t3;
            }
        case "JiraCheckboxesField":
            {
                let t3;
                if ($[88] !== fieldData || $[89] !== fieldValue || $[90] !== isEditable || $[91] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gYtwq.JiraCheckboxesField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[88] = fieldData;
                    $[89] = fieldValue;
                    $[90] = isEditable;
                    $[91] = onChange;
                    $[92] = t3;
                } else t3 = $[92];
                return t3;
            }
        case "JiraUrlField":
            {
                let t3;
                if ($[93] !== fieldData || $[94] !== fieldValue || $[95] !== isEditable || $[96] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QLwYi.JiraUrlField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[93] = fieldData;
                    $[94] = fieldValue;
                    $[95] = isEditable;
                    $[96] = onChange;
                    $[97] = t3;
                } else t3 = $[97];
                return t3;
            }
        case "JiraComponentsField":
            {
                let t3;
                if ($[98] !== fieldData || $[99] !== fieldValue || $[100] !== isEditable || $[101] !== onChange) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dX04h.JiraComponentsField), {
                        field: fieldData,
                        fieldValue: fieldValue,
                        onChange: onChange,
                        isFieldEditable: isEditable
                    });
                    $[98] = fieldData;
                    $[99] = fieldValue;
                    $[100] = isEditable;
                    $[101] = onChange;
                    $[102] = t3;
                } else t3 = $[102];
                return t3;
            }
        case "JiraIssueLinkField":
            {
                let t3;
                if ($[103] !== fieldValue) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Gvh5.JiraIssueLinkField), {
                        fieldValue: fieldValue
                    });
                    $[103] = fieldValue;
                    $[104] = t3;
                } else t3 = $[104];
                return t3;
            }
        case "JiraSprintField":
            {
                if ((0, $iDrrr.fg)("jira-aifc-editable-sprint-field")) {
                    let t3;
                    if ($[105] !== fieldData || $[106] !== fieldValue || $[107] !== isEditable || $[108] !== onChange) {
                        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bKWb7.JiraSprintField), {
                            field: fieldData,
                            fieldValue: fieldValue,
                            onChange: onChange,
                            isFieldEditable: isEditable
                        });
                        $[105] = fieldData;
                        $[106] = fieldValue;
                        $[107] = isEditable;
                        $[108] = onChange;
                        $[109] = t3;
                    } else t3 = $[109];
                    return t3;
                }
                let t3;
                if ($[110] !== fieldValue || $[111] !== valueToRender) {
                    t3 = (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? valueToRender : String(fieldValue);
                    $[110] = fieldValue;
                    $[111] = valueToRender;
                    $[112] = t3;
                } else t3 = $[112];
                let t4;
                if ($[113] !== t3) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        size: "medium"
                    }, t3);
                    $[113] = t3;
                    $[114] = t4;
                } else t4 = $[114];
                return t4;
            }
        default:
            {
                let t3;
                if ($[115] !== fieldValue || $[116] !== valueToRender) {
                    t3 = (0, $cXtTj.default).getExperimentValue("jira-aifc-workflow-resumption-ui-updates", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? valueToRender : String(fieldValue);
                    $[115] = fieldValue;
                    $[116] = valueToRender;
                    $[117] = t3;
                } else t3 = $[117];
                let t4;
                if ($[118] !== t3) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        size: "medium"
                    }, t3);
                    $[118] = t3;
                    $[119] = t4;
                } else t4 = $[119];
                return t4;
            }
    }
} : ({ as: as, field: field, fieldValue: fieldValue, invocationId: invocationId, isFullWidth: isFullWidth, isEditable: isEditable, projectKey: projectKey, onFieldChange: onFieldChange, isStagingArea: isStagingArea, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const fieldData = (0, $6SsN4.useFragment)((0, $hTt4H.default), field);
    const fieldType = fieldData?.__typename;
    const isRequired = !!fieldData?.fieldConfig?.isRequired;
    const onChange = (0, $cozmU.useCallback)((newValue, skipFireAnalytics = false)=>{
        onFieldChange(invocationId, fieldData?.fieldId ?? '', newValue, skipFireAnalytics);
        if (!skipFireAnalytics) sendAifcAnalyticsEvent?.({
            action: 'applied',
            actionSubject: 'inlineEdit',
            actionSubjectId: 'createWorkItemsInlineEdit',
            attributes: {
                // Only available in single work item preview card
                isSingleWorkItem: true,
                source: 'createWithRovoPreviewCard',
                fieldType: fieldType,
                isRequired: isRequired,
                isSystemField: (0, $7ChxK.isSystemField)(fieldData?.fieldId),
                isStagingArea: isStagingArea
            }
        });
    }, [
        onFieldChange,
        invocationId,
        fieldData?.fieldId,
        sendAifcAnalyticsEvent,
        fieldType,
        isRequired,
        isStagingArea
    ]);
    // Checking common schema patterns for a value if the fieldValue is an object to
    // mitigate the rendering of [object Object] as the fieldValue
    const valueToRender = (0, $cozmU.useMemo)(()=>{
        if (typeof fieldValue === 'object' && fieldValue !== null) {
            if ('user' in fieldValue && typeof fieldValue.user === 'object' && fieldValue.user !== null && 'name' in fieldValue.user) return String(fieldValue.user.name);
            if ('value' in fieldValue) return String(fieldValue.value);
            if ('label' in fieldValue) return String(fieldValue.label);
            if ('id' in fieldValue) return String(fieldValue.id);
        }
        return String(fieldValue);
    }, [
        fieldValue
    ]);
    switch(fieldData?.__typename){
        case 'JiraSingleLineTextField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $671V0.JiraSingleLineTextField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable,
                as: as,
                isFullWidth: isFullWidth
            });
        case 'JiraRichTextField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QeEQ.JiraRichTextField), {
                field: fieldData,
                fieldValue: fieldValue,
                isFieldEditable: isEditable,
                onChange: onChange,
                isFullWidth: isFullWidth
            });
        case 'JiraSingleSelectUserPickerField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4HfZ.JiraSingleSelectUserPickerField), {
                field: fieldData,
                fieldId: fieldData.fieldId,
                fieldValue: fieldValue,
                isFieldEditable: isEditable,
                onChange: onChange,
                projectKey: projectKey
            });
        case 'JiraMultipleSelectUserPickerField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gpQ9H.JiraMultipleSelectUserPickerField), {
                field: fieldData,
                fieldId: fieldData.fieldId,
                fieldValue: fieldValue,
                isFieldEditable: isEditable,
                onChange: onChange,
                projectKey: projectKey
            });
        case 'JiraPeopleField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h7OKx.JiraPeopleField), {
                field: fieldData,
                fieldId: fieldData.fieldId,
                fieldValue: fieldValue,
                isFieldEditable: isEditable,
                onChange: onChange,
                projectKey: projectKey
            });
        case 'JiraPriorityField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzmZ3.JiraPriorityField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraSingleSelectField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifOkh.JiraSingleSelectField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraMultipleSelectField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g0hFf.JiraMultipleSelectField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraDatePickerField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $nti55.JiraDatePickerField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraDateTimePickerField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzIKQ.JiraDateTimePickerField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraNumberField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eAi78.JiraNumberField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraTimeTrackingField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7R0Ml.JiraTimeTrackingField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraRadioSelectField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k28ss.JiraRadioSelectField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraLabelsField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTOEa.JiraLabelsField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange
            });
        case 'JiraCascadingSelectField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jNOAq.JiraCascadingSelectField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraCheckboxesField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gYtwq.JiraCheckboxesField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraUrlField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QLwYi.JiraUrlField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraComponentsField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dX04h.JiraComponentsField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
        case 'JiraIssueLinkField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Gvh5.JiraIssueLinkField), {
                fieldValue: fieldValue
            });
        case 'JiraSprintField':
            if ((0, $iDrrr.fg)('jira-aifc-editable-sprint-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bKWb7.JiraSprintField), {
                field: fieldData,
                fieldValue: fieldValue,
                onChange: onChange,
                isFieldEditable: isEditable
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium"
            }, (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? valueToRender : String(fieldValue));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium"
            }, (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
                fireExperimentExposure: false
            }) ? valueToRender : String(fieldValue));
    }
};
module.exports["Field"] = $5e321107f0a653e7$export$a455218a85c89869;

});

parcelRegister("iunf4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $ahNbn = parcelRequire("ahNbn");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $9Gchh = parcelRequire("9Gchh");

const $9d41bbed675fe61a$var$styles = {
    labelContainer: "_4bt5LAnQyn _2WAcuGnQyn _1EqgXliLlu",
    labelTextStylesHorizontal: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1ANEUSLRg7 _39HuIbz8Lp _39xV02N91d",
    labelTextStylesVertical: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1ANEUSLRg7 _39HuIbz8Lp _39xV02N91d"
};
const $9d41bbed675fe61a$export$8aeb9941ff7b4e00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { fieldConfig: fieldConfig, fallbackFieldName: fallbackFieldName, children: children } = t0;
    const fieldConfigData = (0, $6SsN4.useFragment)((0, $ahNbn.default), fieldConfig);
    let t1;
    if ($[0] !== fallbackFieldName || $[1] !== fieldConfigData) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9d41bbed675fe61a$var$styles.labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $9d41bbed675fe61a$var$styles.labelTextStylesHorizontal
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Gchh.FieldLabel), {
            fallbackFieldName: fallbackFieldName,
            fieldConfig: fieldConfigData
        })));
        $[0] = fallbackFieldName;
        $[1] = fieldConfigData;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children);
        $[3] = children;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ fieldConfig: fieldConfig, fallbackFieldName: fallbackFieldName, children: children })=>{
    const fieldConfigData = (0, $6SsN4.useFragment)((0, $ahNbn.default), fieldConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9d41bbed675fe61a$var$styles.labelContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $9d41bbed675fe61a$var$styles.labelTextStylesHorizontal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Gchh.FieldLabel), {
        fallbackFieldName: fallbackFieldName,
        fieldConfig: fieldConfigData
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children));
};
module.exports["WithFieldLabel"] = $9d41bbed675fe61a$export$8aeb9941ff7b4e00;

});

parcelRegister("9iSLp", function(module, exports) {
const $53ad22e4a9416d5e$export$2628054cf01c2f66 = (first, second)=>{
    if (!first || !second || first.isDefault || second.isDefault) return Boolean(first?.isDefault && second?.isDefault);
    return Boolean(first.id && second.id && first.id === second.id || first.namedId && second.namedId && first.namedId === second.namedId);
};
module.exports["authorsMatch"] = $53ad22e4a9416d5e$export$2628054cf01c2f66;

});

parcelRegister("k43Ke", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");


var $1njGe = parcelRequire("1njGe");

const $efd6a998aa1460f4$export$28f2ca9c6712ac80 = (agent)=>{
    if (agent?.is_default) return {
        isDefault: true
    };
    const agentId = (0, $2yWJZ.trimToUndefined)(agent?.id);
    const agentNamedId = (0, $2yWJZ.trimToUndefined)(agent?.external_config_reference ?? agent?.named_id);
    if (agentId) {
        if ((0, $2yWJZ.isDefaultRovoChat)({
            agentId: agentId
        })) return {
            isDefault: true
        };
        return {
            id: agentId,
            namedId: (0, $1njGe.normalizeIdentityValue)(agentNamedId),
            isDefault: false
        };
    }
    const namedId = (0, $1njGe.normalizeIdentityValue)(agentNamedId);
    return {
        namedId: namedId,
        isDefault: !namedId
    };
};
module.exports["deriveBaselineAuthorIdentity"] = $efd6a998aa1460f4$export$28f2ca9c6712ac80;

});

parcelRegister("kGLnC", function(module, exports) {
/* SystemMessage.tsx generated by @compiled/babel-plugin v2.0.0 */ // Copied from @atlassian/agentic-planning (src/SystemMessage.tsx), which itself
// notes it should live in a more generic package. Copied here to avoid a new
// cross-package dependency until a shared home exists (JIAA-229).

var $cozmU = parcelRequire("cozmU");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $9135d40118b1d714$var$styles = {
    explainerContainer: "_2mHwu88HPE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    explainer: "_2mHwu8gVvo _0bjKvDS5Zs _30huDKOeNX _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $9135d40118b1d714$export$3f91b0466c5e5f77 = ({ message: message, isSuccessMessage: isSuccessMessage = true, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $9135d40118b1d714$var$styles.explainerContainer,
        alignItems: "center",
        justifyContent: "center",
        direction: "column",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $9135d40118b1d714$var$styles.explainer,
        alignBlock: "center",
        alignInline: "center"
    }, isSuccessMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, message)));
};
module.exports["SystemMessage"] = $9135d40118b1d714$export$3f91b0466c5e5f77;

});

parcelRegister("19egK", function(module, exports) {
/**
 * @generated SignedSource<<6d1ea130a2e61e576cffd375c90236b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9b523e8ced3af913$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldIdsOrAliases"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sprintAris"
        }
    ],
    "kind": "Fragment",
    "name": "cardFieldsList_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "idsOrAliases",
                    "variableName": "fieldIdsOrAliases"
                },
                {
                    "kind": "Literal",
                    "name": "ignoreMissingFields",
                    "value": true
                }
            ],
            "kind": "LinkedField",
            "name": "fieldsByIdOrAlias",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "fieldId"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleLineTextField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "richTextField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "usersField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "priorityField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "labelsField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "flagField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "datePickerField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "parentIssueField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "numberField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "timeTrackingField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "timeSpentField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "colorField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "teamViewField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "genericField_updateWorkItemAllFieldTypesActionRenderer"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "sprintAris",
                            "variableName": "sprintAris"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "sprintField_updateWorkItemAllFieldTypesActionRenderer"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$9b523e8ced3af913$var$node.hash = "45bc75363da5da36e5c66b99b003fdf3";
var $9b523e8ced3af913$export$2e2bcd8739ae039 = $9b523e8ced3af913$var$node;
module.exports["default"] = $9b523e8ced3af913$export$2e2bcd8739ae039;

});

parcelRegister("bCxtA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $ba3aca845995d887$var$messages = (0, $kSwu1.defineMessages)({
    currentValue: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.rich-text-field.current-value",
        defaultMessage: "Current {name}"
    },
    suggestedValue: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.rich-text-field.suggested-value",
        defaultMessage: "Suggested update"
    }
});
const $ba3aca845995d887$var$styles = {
    container: "_2Y7lL4NHnM",
    withTopSpace: "_0Of8r25zaO",
    withBorder: "_22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $ba3aca845995d887$export$73daa61329af8a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { reasoning: reasoning, current: current, suggested: suggested, fieldName: fieldName, currentLabel: currentLabel, currentMaxLines: t1, suggestedLabel: suggestedLabel, suggestedMaxLines: t2, additionalSuggestions: t3 } = t0;
    const currentMaxLines = t1 === undefined ? 5 : t1;
    const suggestedMaxLines = t2 === undefined ? 10 : t2;
    let t4;
    if ($[0] !== t3) {
        t4 = t3 === undefined ? [] : t3;
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const additionalSuggestions = t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!reasoning && !current && !suggested && !((0, $cXtTj.default).getExperimentValue("jira-ai-update-workitem-field-action-details-exp", "isEnabled", false) && additionalSuggestions.some($ba3aca845995d887$var$_temp))) return null;
    let t5;
    if ($[2] !== reasoning) {
        t5 = reasoning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ba3aca845995d887$var$styles.container,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.reasoning"
        }, typeof reasoning === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, reasoning) : reasoning);
        $[2] = reasoning;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== current || $[5] !== currentLabel || $[6] !== currentMaxLines || $[7] !== fieldName || $[8] !== formatMessage || $[9] !== reasoning) {
        t6 = current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ba3aca845995d887$var$styles.container, !!reasoning && $ba3aca845995d887$var$styles.withTopSpace, !!reasoning && $ba3aca845995d887$var$styles.withBorder),
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.current"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, currentLabel ? currentLabel : formatMessage($ba3aca845995d887$var$messages.currentValue, {
            name: fieldName?.toLowerCase() ?? ""
        })), typeof current === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: currentMaxLines
        }, current) : current));
        $[4] = current;
        $[5] = currentLabel;
        $[6] = currentMaxLines;
        $[7] = fieldName;
        $[8] = formatMessage;
        $[9] = reasoning;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== current || $[12] !== formatMessage || $[13] !== reasoning || $[14] !== suggested || $[15] !== suggestedLabel || $[16] !== suggestedMaxLines) {
        t7 = suggested && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ba3aca845995d887$var$styles.container, (!!current || !!reasoning) && $ba3aca845995d887$var$styles.withTopSpace, (!!current || !!reasoning) && $ba3aca845995d887$var$styles.withBorder),
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.suggested"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, suggestedLabel ? suggestedLabel : formatMessage($ba3aca845995d887$var$messages.suggestedValue)), typeof suggested === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: suggestedMaxLines
        }, suggested) : suggested));
        $[11] = current;
        $[12] = formatMessage;
        $[13] = reasoning;
        $[14] = suggested;
        $[15] = suggestedLabel;
        $[16] = suggestedMaxLines;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== additionalSuggestions || $[19] !== current || $[20] !== formatMessage || $[21] !== reasoning) {
        let t9;
        if ($[23] !== current || $[24] !== formatMessage || $[25] !== reasoning) {
            t9 = (t10)=>{
                const { suggested: suggested_0, label: label, maxLines: t11, testIdSuffix: testIdSuffix } = t10;
                const maxLines = t11 === undefined ? 10 : t11;
                return suggested_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: (0, $w6R6I.cx)($ba3aca845995d887$var$styles.container, (!!current || !!suggested_0 || !!reasoning) && $ba3aca845995d887$var$styles.withTopSpace, (!!current || !!suggested_0 || !!reasoning) && $ba3aca845995d887$var$styles.withBorder),
                    testId: $ba3aca845995d887$var$getAdditionalTestId(testIdSuffix),
                    key: label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    space: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                    size: "xsmall"
                }, label ? label : formatMessage($ba3aca845995d887$var$messages.suggestedValue)), typeof suggested_0 === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    maxLines: maxLines
                }, suggested_0) : suggested_0));
            };
            $[23] = current;
            $[24] = formatMessage;
            $[25] = reasoning;
            $[26] = t9;
        } else t9 = $[26];
        t8 = additionalSuggestions.map(t9);
        $[18] = additionalSuggestions;
        $[19] = current;
        $[20] = formatMessage;
        $[21] = reasoning;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[27] !== t5 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content",
            space: "space.200"
        }, t5, t6, t7, t8);
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    return t9;
} : ({ reasoning: reasoning, current: current, suggested: suggested, fieldName: fieldName, currentLabel: currentLabel, currentMaxLines: currentMaxLines = 5, suggestedLabel: suggestedLabel, suggestedMaxLines: suggestedMaxLines = 10, additionalSuggestions: additionalSuggestions = [] })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!reasoning && !current && !suggested && !((0, $cXtTj.default).getExperimentValue('jira-ai-update-workitem-field-action-details-exp', 'isEnabled', false) && additionalSuggestions.some((s)=>s.suggested))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content",
        space: "space.200"
    }, reasoning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ba3aca845995d887$var$styles.container,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.reasoning"
    }, typeof reasoning === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, reasoning) : reasoning), current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ba3aca845995d887$var$styles.container, !!reasoning && $ba3aca845995d887$var$styles.withTopSpace, !!reasoning && $ba3aca845995d887$var$styles.withBorder),
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.current"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, currentLabel ? currentLabel : formatMessage($ba3aca845995d887$var$messages.currentValue, {
        name: fieldName?.toLowerCase() ?? ''
    })), typeof current === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: currentMaxLines
    }, current) : current)), suggested && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ba3aca845995d887$var$styles.container, (!!current || !!reasoning) && $ba3aca845995d887$var$styles.withTopSpace, (!!current || !!reasoning) && $ba3aca845995d887$var$styles.withBorder),
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.suggested"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, suggestedLabel ? suggestedLabel : formatMessage($ba3aca845995d887$var$messages.suggestedValue)), typeof suggested === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: suggestedMaxLines
    }, suggested) : suggested)), additionalSuggestions.map(({ suggested: suggested_0, label: label, maxLines: maxLines = 10, testIdSuffix: testIdSuffix })=>suggested_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ba3aca845995d887$var$styles.container, (!!current || !!suggested_0 || !!reasoning) && $ba3aca845995d887$var$styles.withTopSpace, (!!current || !!suggested_0 || !!reasoning) && $ba3aca845995d887$var$styles.withBorder),
            testId: $ba3aca845995d887$var$getAdditionalTestId(testIdSuffix),
            key: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, label ? label : formatMessage($ba3aca845995d887$var$messages.suggestedValue)), typeof suggested_0 === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: maxLines
        }, suggested_0) : suggested_0))));
};
const $ba3aca845995d887$var$getAdditionalTestId = (testIdSuffix = '')=>{
    const suffix = testIdSuffix ? `.${testIdSuffix}` : '';
    return `update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.additional-suggestion${suffix}`;
};
function $ba3aca845995d887$var$_temp(s) {
    return s.suggested;
}
module.exports["FieldTooltipContent"] = $ba3aca845995d887$export$73daa61329af8a4;

});

parcelRegister("gwApo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0f0b4032293d866a$export$96debe0893d09d09 = (targetFieldKey)=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const [customTooltipContent, setCustomTooltipContent] = (0, $cozmU.useState)(null);
    const providerRef = (0, $cozmU.useRef)(null);
    const registerTooltipProvider = (0, $cozmU.useCallback)((fieldId, provider)=>{
        if (fieldId !== targetFieldKey) return;
        if (provider == null) {
            if (providerRef.current) {
                providerRef.current = null;
                setCustomTooltipContent(null);
            }
            return;
        }
        providerRef.current = provider;
        if (isHovered || isFocused) try {
            setCustomTooltipContent(provider() ?? null);
        } catch  {
            setCustomTooltipContent(null);
        }
    }, [
        targetFieldKey,
        isHovered,
        isFocused
    ]);
    // Recompute on visibility state changes.
    (0, $cozmU.useEffect)(()=>{
        if (isHovered || isFocused) {
            if (providerRef.current) try {
                setCustomTooltipContent(providerRef.current() ?? null);
            } catch  {
                setCustomTooltipContent(null);
            }
            else setCustomTooltipContent(null);
        } else setCustomTooltipContent(null);
    }, [
        isHovered,
        isFocused
    ]);
    const rootHoverHandlers = {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    };
    const focusHandlers = {
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    };
    return {
        isHovered: isHovered,
        isFocused: isFocused,
        tooltipContent: customTooltipContent,
        registerTooltipProvider: registerTooltipProvider,
        rootHoverHandlers: rootHoverHandlers,
        focusHandlers: focusHandlers
    };
};
module.exports["useFieldTooltip"] = $0f0b4032293d866a$export$96debe0893d09d09;

});

parcelRegister("dJqjR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hlSvw = parcelRequire("hlSvw");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $b5cd17da0ddc71aa$var$messages = (0, $kSwu1.defineMessages)({
    updateWorkItemColor: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-color-field.update-work-item-color",
        defaultMessage: "Update work item color to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-color-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $b5cd17da0ddc71aa$export$b865d4358897bb17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action) {
        t1 = (0, $4yZQ6.getActionData)(action);
        $[0] = action;
        $[1] = t1;
    } else t1 = $[1];
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = t1;
    const data = (0, $6SsN4.useFragment)((0, $hlSvw.default), queryRef);
    const getColorLabel = $b5cd17da0ddc71aa$var$_temp2;
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    let t2;
    if ($[2] !== data) {
        t2 = data?.color?.colorKey ? getColorLabel(data.color.colorKey) : undefined;
        $[2] = data;
        $[3] = t2;
    } else t2 = $[3];
    const currentColorLabel = t2;
    let t3;
    if ($[4] !== fieldValue) {
        t3 = fieldValue ? getColorLabel(String(fieldValue)) : undefined;
        $[4] = fieldValue;
        $[5] = t3;
    } else t3 = $[5];
    const suggestedColorLabel = t3;
    const colorLabel = suggestedColorLabel || "";
    let t4;
    if ($[6] !== currentColorLabel || $[7] !== data?.name || $[8] !== fieldReasoning || $[9] !== suggestedColorLabel) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                fieldName: data?.name,
                current: currentColorLabel,
                suggested: suggestedColorLabel
            });
        $[6] = currentColorLabel;
        $[7] = data?.name;
        $[8] = fieldReasoning;
        $[9] = suggestedColorLabel;
        $[10] = t4;
    } else t4 = $[10];
    data?.name;
    const toolTipContentProvider = t4;
    let t5;
    if ($[11] !== fieldKey || $[12] !== isFieldRenderable || $[13] !== registerTooltipProvider || $[14] !== toolTipContentProvider) {
        t5 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: isFieldRenderable
        };
        $[11] = fieldKey;
        $[12] = isFieldRenderable;
        $[13] = registerTooltipProvider;
        $[14] = toolTipContentProvider;
        $[15] = t5;
    } else t5 = $[15];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t5);
    if (!data?.fieldId || !data?.name || !isFieldRenderable) return null;
    const t6 = isUpdatingAction ? $b5cd17da0ddc71aa$var$messages.updateWorkItemColor : $b5cd17da0ddc71aa$var$messages.clearAction;
    let t7;
    if ($[16] !== colorLabel || $[17] !== data?.name || $[18] !== formatMessage || $[19] !== t6) {
        t7 = formatMessage(t6, {
            fieldName: data?.name?.toLowerCase(),
            fieldValue: colorLabel
        });
        $[16] = colorLabel;
        $[17] = data?.name;
        $[18] = formatMessage;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.jira-color-field"
        }, t7);
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $hlSvw.default), queryRef);
    const getColorLabel = (colorKey)=>colorKey.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (char)=>char.toUpperCase());
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    const currentColorLabel = data?.color?.colorKey ? getColorLabel(data.color.colorKey) : undefined;
    const suggestedColorLabel = fieldValue ? getColorLabel(String(fieldValue)) : undefined;
    const colorLabel = suggestedColorLabel || '';
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            current: currentColorLabel,
            suggested: suggestedColorLabel
        }), [
        fieldReasoning,
        data?.name,
        currentColorLabel,
        suggestedColorLabel
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!data?.fieldId || !data?.name || !isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.jira-color-field"
    }, formatMessage(isUpdatingAction ? $b5cd17da0ddc71aa$var$messages.updateWorkItemColor : $b5cd17da0ddc71aa$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase(),
        fieldValue: colorLabel
    }));
};
function $b5cd17da0ddc71aa$var$_temp(char) {
    return char.toUpperCase();
}
function $b5cd17da0ddc71aa$var$_temp2(colorKey) {
    return colorKey.toLowerCase().replace(/_/g, " ").replace(/^\w/, $b5cd17da0ddc71aa$var$_temp);
}
module.exports["ColorField"] = $b5cd17da0ddc71aa$export$b865d4358897bb17;

});

parcelRegister("2n1QA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iqP6y = parcelRequire("iqP6y");

const $bb93718cc3c0214a$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-color-field.icon-label",
        defaultMessage: "Color field icon"
    }
});
const $bb93718cc3c0214a$export$eb83eed9be8a6ec4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ColorFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($bb93718cc3c0214a$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqP6y))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function ColorFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqP6y))), {
        label: formatMessage($bb93718cc3c0214a$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["ColorFieldIcon"] = $bb93718cc3c0214a$export$eb83eed9be8a6ec4;

});

parcelRegister("gQkLW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $45c04c34450d7f6d$var$messages = (0, $kSwu1.defineMessages)({
    action: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.flag-field.comment.non-final",
        defaultMessage: "Add comment"
    }
});
const $45c04c34450d7f6d$export$d688afa8f735de41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action) {
        t1 = (0, $4yZQ6.getActionData)(action);
        $[0] = action;
        $[1] = t1;
    } else t1 = $[1];
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = t1;
    const isFieldRenderable = fieldKey === "comment";
    let t2;
    if ($[2] !== fieldReasoning || $[3] !== fieldValue) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                suggested: fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : undefined
            });
        $[2] = fieldReasoning;
        $[3] = fieldValue;
        $[4] = t2;
    } else t2 = $[4];
    const toolTipContentProvider = t2;
    let t3;
    if ($[5] !== fieldKey || $[6] !== isFieldRenderable || $[7] !== registerTooltipProvider || $[8] !== toolTipContentProvider) {
        t3 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: isFieldRenderable
        };
        $[5] = fieldKey;
        $[6] = isFieldRenderable;
        $[7] = registerTooltipProvider;
        $[8] = toolTipContentProvider;
        $[9] = t3;
    } else t3 = $[9];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t3);
    const comment = String(fieldValue)?.trim();
    if (!isFieldRenderable || !comment) return null;
    let t4;
    if ($[10] !== formatMessage) {
        t4 = formatMessage($45c04c34450d7f6d$var$messages.action);
        $[10] = formatMessage;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.comment-field"
        }, t4);
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const isFieldRenderable = fieldKey === 'comment';
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            suggested: fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : undefined
        }), [
        fieldValue,
        fieldReasoning
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    const comment = String(fieldValue)?.trim();
    if (!isFieldRenderable || !comment) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.comment-field"
    }, formatMessage($45c04c34450d7f6d$var$messages.action));
};
module.exports["CommentField"] = $45c04c34450d7f6d$export$d688afa8f735de41;

});

parcelRegister("7CPOj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eDtFr = parcelRequire("eDtFr");

const $4696f3f6084fbe4a$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.comment-field.label.non-final",
        defaultMessage: "Comment field icon"
    }
});
const $4696f3f6084fbe4a$export$6d46c9121b9582b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($4696f3f6084fbe4a$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function CommentFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
        label: formatMessage($4696f3f6084fbe4a$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["CommentFieldIcon"] = $4696f3f6084fbe4a$export$6d46c9121b9582b1;

});

parcelRegister("jbxLJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cPvf5 = parcelRequire("cPvf5");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $4yZQ6 = parcelRequire("4yZQ6");


var $gYXDX = parcelRequire("gYXDX");

const $6ff8ce8d18ec5af8$var$messages = (0, $kSwu1.defineMessages)({
    set: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.date-picker-field.set",
        defaultMessage: "Set {name} to {value}"
    },
    unset: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.date-picker-field.unset",
        defaultMessage: "Remove date from {name}"
    }
});
const $6ff8ce8d18ec5af8$export$34dc4cfa15ead1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $cPvf5.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== fieldKey) return null;
    const fieldName = data?.name ? data.name.toLowerCase() : fieldKey;
    const formattedDate = (0, $gYXDX.formatSuggestedDate)(fieldValue, formatDate);
    const T0 = (0, $4aRua.Text);
    const t1 = "color.text.subtle";
    const t2 = 1;
    const t3 = "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.date-picker-field";
    const t4 = formattedDate ? formatMessage($6ff8ce8d18ec5af8$var$messages.set, {
        name: fieldName,
        value: formattedDate
    }) : formatMessage($6ff8ce8d18ec5af8$var$messages.unset, {
        name: fieldName
    });
    let t5;
    if ($[0] !== T0 || $[1] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            color: t1,
            maxLines: t2,
            testId: t3
        }, t4);
        $[0] = T0;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    return t5;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $cPvf5.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== fieldKey) return null;
    const fieldName = data?.name ? data.name.toLowerCase() : fieldKey;
    const formattedDate = (0, $gYXDX.formatSuggestedDate)(fieldValue, formatDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.date-picker-field"
    }, formattedDate ? formatMessage($6ff8ce8d18ec5af8$var$messages.set, {
        name: fieldName,
        value: formattedDate
    }) : formatMessage($6ff8ce8d18ec5af8$var$messages.unset, {
        name: fieldName
    }));
};
module.exports["DatePickerField"] = $6ff8ce8d18ec5af8$export$34dc4cfa15ead1;

});

parcelRegister("7YLz1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $824lD = parcelRequire("824lD");

const $a95c1252c7a905d0$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.date-picker-field.icon-label",
        defaultMessage: "Date picker field icon"
    }
});
const $a95c1252c7a905d0$export$50a3c68589054367 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DatePickerFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($a95c1252c7a905d0$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function DatePickerFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
        label: formatMessage($a95c1252c7a905d0$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["DatePickerFieldIcon"] = $a95c1252c7a905d0$export$50a3c68589054367;

});

parcelRegister("cdCKN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fZ8tq = parcelRequire("fZ8tq");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $6okNK = parcelRequire("6okNK");


var $4yZQ6 = parcelRequire("4yZQ6");

const $54dd26b41c725f50$var$messages = (0, $kSwu1.defineMessages)({
    setScheduledDate: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.date-picker-field.set-scheduled-date",
        defaultMessage: "Set {name} to {value}"
    },
    unset: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.date-picker-field.unset",
        defaultMessage: "Remove date from {name}"
    }
});
const $54dd26b41c725f50$export$9b9f2b8abb7a04e5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $fZ8tq.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== fieldKey) return null;
    const rawValue = fieldValue;
    const value = (0, $6okNK.formatSuggestedDateTime)(rawValue, formatDate);
    const T0 = (0, $4aRua.Text);
    const t1 = "color.text.subtle";
    const t2 = 1;
    const t3 = "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.date-time-picker-field";
    const t4 = value ? formatMessage($54dd26b41c725f50$var$messages.setScheduledDate, {
        name: data?.name.toLowerCase(),
        value: value
    }) : formatMessage($54dd26b41c725f50$var$messages.unset, {
        name: data?.name.toLowerCase()
    });
    let t5;
    if ($[0] !== T0 || $[1] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            color: t1,
            maxLines: t2,
            testId: t3
        }, t4);
        $[0] = T0;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    return t5;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $fZ8tq.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== fieldKey) return null;
    const rawValue = fieldValue;
    const value = (0, $6okNK.formatSuggestedDateTime)(rawValue, formatDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.date-time-picker-field"
    }, value ? formatMessage($54dd26b41c725f50$var$messages.setScheduledDate, {
        name: data?.name.toLowerCase(),
        value: value
    }) : formatMessage($54dd26b41c725f50$var$messages.unset, {
        name: data?.name.toLowerCase()
    }));
};
module.exports["DateTimePickerField"] = $54dd26b41c725f50$export$9b9f2b8abb7a04e5;

});

parcelRegister("01x8r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5ZtfK = parcelRequire("5ZtfK");

const $77fc8e754353465a$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.date-time-picker-field.icon-label",
        defaultMessage: "Date time picker field icon"
    }
});
const $77fc8e754353465a$export$9b0d4b8d0d256e40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DateTimePickerFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($77fc8e754353465a$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function DateTimePickerFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        label: formatMessage($77fc8e754353465a$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["DateTimePickerFieldIcon"] = $77fc8e754353465a$export$9b0d4b8d0d256e40;

});

parcelRegister("fMOw7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fWp8m = parcelRequire("fWp8m");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $4yZQ6 = parcelRequire("4yZQ6");


var $7bqat = parcelRequire("7bqat");

const $83f9385b1a7b686f$var$messages = (0, $kSwu1.defineMessages)({
    flagged: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.flag-field.flagged",
        defaultMessage: "Add flag"
    },
    unflagged: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.flag-field.unflagged",
        defaultMessage: "Remove flag"
    }
});
const $83f9385b1a7b686f$export$1186cf6e3d8a37ad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $fWp8m.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== fieldKey) return null;
    const flagged = (0, $7bqat.isFlagged)(fieldValue);
    let t1;
    if ($[0] !== flagged || $[1] !== formatMessage) {
        t1 = flagged ? formatMessage($83f9385b1a7b686f$var$messages.flagged) : formatMessage($83f9385b1a7b686f$var$messages.unflagged);
        $[0] = flagged;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.flag-field"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $fWp8m.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== fieldKey) return null;
    const flagged = (0, $7bqat.isFlagged)(fieldValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.flag-field"
    }, flagged ? formatMessage($83f9385b1a7b686f$var$messages.flagged) : formatMessage($83f9385b1a7b686f$var$messages.unflagged));
};
module.exports["FlagField"] = $83f9385b1a7b686f$export$1186cf6e3d8a37ad;

});

parcelRegister("cQmAj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gMfOo = parcelRequire("gMfOo");

const $6f459ef86cca935b$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.flag-field.icon-label",
        defaultMessage: "Flag field icon"
    }
});
const $6f459ef86cca935b$export$4b802cc289729e33 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($6f459ef86cca935b$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMfOo))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function FlagFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMfOo))), {
        label: formatMessage($6f459ef86cca935b$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["FlagFieldIcon"] = $6f459ef86cca935b$export$4b802cc289729e33;

});

parcelRegister("bnvIx", function(module, exports) {

var $6Am9a = parcelRequire("6Am9a");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $bcb41510ce71c90a$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.generic-field.updateAction",
        defaultMessage: "Update {fieldName} to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.generic-field.clearAction",
        defaultMessage: "Clear {fieldName}"
    }
});
function $bcb41510ce71c90a$var$sanitizeFieldName(value) {
    if (typeof value === 'string') return value?.trim()?.toLowerCase();
    return String(value);
}
function $bcb41510ce71c90a$var$sanitizeFieldValue(value) {
    if (typeof value === 'string') return value?.trim();
    if (Array.isArray(value)) return value?.join(', ');
    return String(value);
}
function $bcb41510ce71c90a$var$isObject(value) {
    return typeof value === 'object' && value !== null;
}
function $bcb41510ce71c90a$var$hasRenderableValue(value) {
    if (Array.isArray(value)) return !value.some($bcb41510ce71c90a$var$isObject);
    return !$bcb41510ce71c90a$var$isObject(value);
}
const $bcb41510ce71c90a$export$a49ce3bbbd0d81e5 = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $6Am9a.default), queryRef);
    const isFieldRenderable = data.fieldId === fieldKey;
    const isUpdateAction = isFieldRenderable && !!fieldValue;
    const isUnrenderableUpdate = isUpdateAction && !$bcb41510ce71c90a$var$hasRenderableValue(fieldValue);
    (0, $cozmU.useEffect)(()=>{
        if (isUnrenderableUpdate && (0, $iDrrr.fg)('jira-track-invalid-update-workitem-actions')) sendAnalyticsEvent({
            eventType: 'operational',
            action: 'detected',
            actionSubject: 'invalidField',
            actionSubjectId: 'updateWorkActionRenderer',
            attributes: {
                fieldType: (0, $4yZQ6.toReportableFieldType)(fieldKey),
                renderer: 'generic',
                anomaly: 'objectValue',
                invocationId: action.invocationId
            }
        });
    }, [
        isUnrenderableUpdate,
        fieldKey,
        action.invocationId,
        sendAnalyticsEvent
    ]);
    const formattedMessage = isUpdateAction ? formatMessage($bcb41510ce71c90a$var$messages.updateAction, {
        fieldName: $bcb41510ce71c90a$var$sanitizeFieldName(data?.name),
        fieldValue: $bcb41510ce71c90a$var$sanitizeFieldValue(fieldValue)
    }) : formatMessage($bcb41510ce71c90a$var$messages.clearAction, {
        fieldName: $bcb41510ce71c90a$var$sanitizeFieldName(data?.name)
    });
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            suggested: fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : undefined
        }), [
        fieldValue,
        fieldReasoning,
        data?.name
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable || !data?.name) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.generic-field"
    }, formattedMessage);
};
module.exports["GenericField"] = $bcb41510ce71c90a$export$a49ce3bbbd0d81e5;

});

parcelRegister("3nlSH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3DMf9 = parcelRequire("3DMf9");

const $eefcc41c87d6565b$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.generic-field.icon-label",
        defaultMessage: "Generic field icon"
    }
});
const $eefcc41c87d6565b$export$18ac7b7bf9261c40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GenericFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($eefcc41c87d6565b$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function GenericFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
        label: formatMessage($eefcc41c87d6565b$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["GenericFieldIcon"] = $eefcc41c87d6565b$export$18ac7b7bf9261c40;

});

parcelRegister("63Ksk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $gvpzp = parcelRequire("gvpzp");

const $ecda86acf68671f8$var$messages = (0, $kSwu1.defineMessages)({
    update: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-issue-links-field.update",
        defaultMessage: "Add issue link"
    },
    updateWithRelationship: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-issue-links-field.update-with-relationship.non-final",
        defaultMessage: "Link ''{relationship}'' work item: {issueKey}"
    }
});
const $ecda86acf68671f8$export$5939eb0b0c440cdc = ({ action: action, registerTooltipProvider: registerTooltipProvider, issueKey: issueKey })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const isFieldRenderable = fieldKey === 'issuelinks';
    const { type: type, outwardIssue: outwardIssue } = (0, $gvpzp.toIssueLinksFieldValue)(fieldValue) ?? {};
    const shouldNotRenderField = !isFieldRenderable || !type?.name || !outwardIssue?.key;
    // Track when this renders nothing (empty row) due to an unexpected issuelinks shape.
    (0, $cozmU.useEffect)(()=>{
        if (shouldNotRenderField && (0, $iDrrr.fg)('jira-track-invalid-update-workitem-actions')) sendAnalyticsEvent({
            eventType: 'operational',
            action: 'detected',
            actionSubject: 'invalidField',
            actionSubjectId: 'updateWorkActionRenderer',
            attributes: {
                fieldType: 'issuelinks',
                anomaly: 'malformedShape',
                invocationId: action.invocationId
            }
        });
    }, [
        shouldNotRenderField,
        action.invocationId,
        sendAnalyticsEvent
    ]);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            suggested: type?.name && outwardIssue?.key ? `${issueKey} ${type?.name.toLowerCase()} ${outwardIssue?.key}` : undefined
        }), [
        fieldReasoning,
        type?.name,
        outwardIssue?.key,
        issueKey
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (shouldNotRenderField) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.issue-links-field"
    }, (0, $cXtTj.default).getExperimentValue('jira-ai-update-workitem-field-action-details-exp', 'isEnabled', false) ? formatMessage($ecda86acf68671f8$var$messages.updateWithRelationship, {
        relationship: type.name,
        issueKey: outwardIssue.key
    }) : formatMessage($ecda86acf68671f8$var$messages.update));
};
module.exports["IssueLinksField"] = $ecda86acf68671f8$export$5939eb0b0c440cdc;

});

parcelRegister("9mlvG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4THFE = parcelRequire("4THFE");

const $44c988f707004a6d$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-issue-links-field.icon-label",
        defaultMessage: "Issue links field icon"
    }
});
const $44c988f707004a6d$export$2c3003916d7e3b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IssueLinksFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($44c988f707004a6d$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function IssueLinksFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
        label: formatMessage($44c988f707004a6d$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["IssueLinksFieldIcon"] = $44c988f707004a6d$export$2c3003916d7e3b00;

});

parcelRegister("77wfz", function(module, exports) {

var $5PsWn = parcelRequire("5PsWn");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $IOtUu = parcelRequire("IOtUu");


var $3DjKS = parcelRequire("3DjKS");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $6Fflc = parcelRequire("6Fflc");

const $5bfd3310d06a64bf$var$messages = (0, $kSwu1.defineMessages)({
    suggestedLabelsToAdd: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.labels-field.suggestedLabelsToAdd.non-final",
        defaultMessage: "Suggested labels to add"
    },
    suggestedLabelsToRemove: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.labels-field.suggestedLabelsToRemove.non-final",
        defaultMessage: "Suggested labels to remove"
    },
    updateLabels: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.labels-field.updateLabels.non-final",
        defaultMessage: "Update labels"
    },
    addLabels: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.labels-field.addLabels.non-final",
        defaultMessage: "Add labels"
    }
});
const $5bfd3310d06a64bf$var$getDefinedLabels = (labels)=>labels.filter((label)=>label !== undefined && label !== null);
const $5bfd3310d06a64bf$export$b5a86c9a622796ff = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $5PsWn.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey && fieldKey === 'labels';
    const suggestedLabels = (0, $cozmU.useMemo)(()=>(0, $6Fflc.parseLabels)(fieldValue), [
        fieldValue
    ]);
    const currentLabels = (0, $cozmU.useMemo)(()=>data?.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name) ?? [], [
        data?.selectedLabelsConnection
    ]);
    const addedLabels = (0, $cozmU.useMemo)(()=>suggestedLabels?.filter((label)=>!currentLabels?.includes(label ?? '')) ?? [], [
        suggestedLabels,
        currentLabels
    ]);
    const removedLabels = (0, $cozmU.useMemo)(()=>currentLabels.filter((label_0)=>!suggestedLabels?.includes(label_0 ?? '')), [
        currentLabels,
        suggestedLabels
    ]);
    const isSameValueSuggested = isFieldRenderable && action.status === 'planned' && suggestedLabels !== null && addedLabels.length === 0 && removedLabels.length === 0;
    (0, $cozmU.useEffect)(()=>{
        if (isSameValueSuggested && (0, $iDrrr.fg)('jira-track-invalid-update-workitem-actions')) sendAnalyticsEvent({
            eventType: 'operational',
            action: 'detected',
            actionSubject: 'invalidField',
            actionSubjectId: 'updateWorkActionRenderer',
            attributes: {
                fieldType: 'labels',
                anomaly: 'sameValueSuggested',
                invocationId: action.invocationId
            }
        });
    }, [
        isSameValueSuggested,
        action.invocationId,
        sendAnalyticsEvent
    ]);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        const currentLabels_0 = data?.selectedLabelsConnection?.edges?.map((edge_0)=>edge_0?.node?.name) ?? [];
        const current = currentLabels_0.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, currentLabels_0.filter((label_1)=>label_1 !== undefined && label_1 !== null).map((label_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: label_2,
                text: label_2,
                isRemovable: false
            }))) : null;
        const suggestedToAdd = addedLabels?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, addedLabels.filter((label_3)=>label_3 !== undefined && label_3 !== null).map((label_4)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: label_4,
                text: label_4,
                isRemovable: false
            }))) : null;
        const suggestedToRemove = removedLabels?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, removedLabels.filter((label_5)=>label_5 !== undefined && label_5 !== null).map((label_6)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: label_6,
                text: label_6,
                isRemovable: false
            }))) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            current: current,
            additionalSuggestions: [
                {
                    suggested: addedLabels.length > 0 ? suggestedToAdd : null,
                    label: formatMessage($5bfd3310d06a64bf$var$messages.suggestedLabelsToAdd),
                    testIdSuffix: 'suggested-labels-to-add'
                },
                {
                    suggested: removedLabels.length > 0 ? suggestedToRemove : null,
                    label: formatMessage($5bfd3310d06a64bf$var$messages.suggestedLabelsToRemove),
                    testIdSuffix: 'suggested-labels-to-remove'
                }
            ],
            fieldName: data?.name
        });
    }, [
        fieldReasoning,
        data?.name,
        data?.selectedLabelsConnection?.edges,
        formatMessage,
        addedLabels,
        removedLabels
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    const inlineAddedLabels = (0, $cozmU.useMemo)(()=>$5bfd3310d06a64bf$var$getDefinedLabels(addedLabels), [
        addedLabels
    ]);
    const inlineRemovedLabels = (0, $cozmU.useMemo)(()=>$5bfd3310d06a64bf$var$getDefinedLabels(removedLabels), [
        removedLabels
    ]);
    if (!isFieldRenderable) return null;
    if (inlineAddedLabels.length > 0 && inlineRemovedLabels.length === 0 && (0, $cXtTj.default).getExperimentValue('jira-ai-update-workitem-field-action-details-exp', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050",
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.labels-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1
    }, formatMessage($5bfd3310d06a64bf$var$messages.addLabels)), inlineAddedLabels.map((label_7)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: label_7,
            text: label_7,
            isRemovable: false,
            hasMargin: false
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.labels-field"
    }, formatMessage($5bfd3310d06a64bf$var$messages.updateLabels));
};
module.exports["LabelsField"] = $5bfd3310d06a64bf$export$b5a86c9a622796ff;

});

parcelRegister("6PEgK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $EzOZy = parcelRequire("EzOZy");

const $6eb66b37cccb53fb$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.labels-field.icon-label",
        defaultMessage: "Labels field icon"
    }
});
const $6eb66b37cccb53fb$export$53bf460ad929f103 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelsFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($6eb66b37cccb53fb$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function LabelsFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
        label: formatMessage($6eb66b37cccb53fb$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["LabelsFieldIcon"] = $6eb66b37cccb53fb$export$53bf460ad929f103;

});

parcelRegister("ikVMQ", function(module, exports) {

var $kPpgw = parcelRequire("kPpgw");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $81cd62647cc402bc$var$messages = (0, $kSwu1.defineMessages)({
    setAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-number-field.setStorypoints",
        defaultMessage: "Set {fieldName} to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-number-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $81cd62647cc402bc$export$63c5fa0b2fdccd2e = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $kPpgw.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            current: data?.number ? String(data.number) : undefined,
            suggested: fieldValue ? String(fieldValue) : undefined
        }), [
        fieldValue,
        fieldReasoning,
        data?.name,
        data?.number
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!data?.fieldId || !data?.name || data?.fieldId !== fieldKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.jira-number-field"
    }, isUpdatingAction ? formatMessage($81cd62647cc402bc$var$messages.setAction, {
        fieldName: data?.name?.toLowerCase(),
        fieldValue: fieldValue ? String(fieldValue) : undefined
    }) : formatMessage($81cd62647cc402bc$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["NumberField"] = $81cd62647cc402bc$export$63c5fa0b2fdccd2e;

});

parcelRegister("g6X6z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3p3yp = parcelRequire("3p3yp");

const $5a298c001105f28e$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.jira-number-field.icon-label",
        defaultMessage: "Number field icon"
    }
});
const $5a298c001105f28e$export$ba7020b38dce665e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NumberFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($5a298c001105f28e$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3p3yp))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function NumberFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3p3yp))), {
        label: formatMessage($5a298c001105f28e$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["NumberFieldIcon"] = $5a298c001105f28e$export$ba7020b38dce665e;

});

parcelRegister("6XxOd", function(module, exports) {

var $ervmy = parcelRequire("ervmy");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $lYwdb = parcelRequire("lYwdb");


var $lxuSf = parcelRequire("lxuSf");

const $9054b6d0b950bcef$var$messages = (0, $kSwu1.defineMessages)({
    addToParentWorkItem: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.parent-issue-field.addToParentWorkItem",
        defaultMessage: "Add to parent work item"
    },
    addParentWorkItem: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.parent-issue-field.addParentWorkItem.non-final",
        defaultMessage: "Add parent work item: {parentIssue}"
    },
    unassign: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.parent-issue-field.unassign",
        defaultMessage: "Unassign parent"
    }
});
const $9054b6d0b950bcef$export$38904296a16cf133 = ({ cloudId: cloudId, queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider, onInvalidAction: onInvalidAction })=>{
    (0, $6cFsl.di)((0, $lxuSf.useHydratedIssue));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $ervmy.default), queryRef);
    const proposedParentId = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue?.toString() || null;
    const isFieldRenderable = data?.fieldId === 'parent' && data.fieldId === fieldKey;
    const needsHydration = Boolean(isFieldRenderable && proposedParentId && proposedParentId !== data?.parentIssue?.issueId);
    const hydratedData = (0, $lxuSf.useHydratedIssue)(cloudId, proposedParentId, needsHydration, onInvalidAction);
    const parentIssue = needsHydration && hydratedData ? {
        issue: hydratedData.issue,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        issue: data?.parentIssue,
        isLoading: false,
        error: null
    };
    const { issue: issue, isLoading: isLoading, error: error } = parentIssue;
    const isAssignable = (issue || isLoading) && proposedParentId;
    const isNotFound = !issue && !isLoading && proposedParentId;
    const formattedMessage = isAssignable ? (0, $cXtTj.default).getExperimentValue('jira-ai-update-workitem-field-action-details-exp', 'isEnabled', false) && issue?.key ? formatMessage($9054b6d0b950bcef$var$messages.addParentWorkItem, {
        parentIssue: issue.summary ? `${issue.key} ${issue.summary}` : issue.key
    }) : formatMessage($9054b6d0b950bcef$var$messages.addToParentWorkItem) : formatMessage($9054b6d0b950bcef$var$messages.unassign);
    // Compute tooltip content provider logic
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        if (!isFieldRenderable) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            current: data?.parentIssue ? `${data.parentIssue.key}: ${data.parentIssue.summary}` : undefined,
            suggested: issue ? `${issue?.key}: ${issue?.summary}` : undefined,
            fieldName: data?.name
        });
    }, [
        fieldReasoning,
        data.parentIssue,
        data?.name,
        isFieldRenderable,
        issue
    ]);
    // Register tooltip content provider
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable || isNotFound || error) return null;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lYwdb.ParentIssueFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.parent-issue-field"
    }, formattedMessage);
};
module.exports["ParentIssueField"] = $9054b6d0b950bcef$export$38904296a16cf133;

});

parcelRegister("iclxx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4THFE = parcelRequire("4THFE");

const $e06ec9392f0890c8$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.parent-issue-field.icon-label",
        defaultMessage: "Parent issue field icon"
    }
});
const $e06ec9392f0890c8$export$b112572493a09818 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ParentIssueFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($e06ec9392f0890c8$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function ParentIssueFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
        label: formatMessage($e06ec9392f0890c8$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["ParentIssueFieldIcon"] = $e06ec9392f0890c8$export$b112572493a09818;

});

parcelRegister("kgviF", function(module, exports) {

var $9t9D5 = parcelRequire("9t9D5");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $17b90f5d22758690$var$messages = (0, $kSwu1.defineMessages)({
    action: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.priority-field.action",
        defaultMessage: "Set priority to {value}"
    },
    setPriority: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.priority-field.setPriority",
        defaultMessage: "Set priority from {originalValue} to {value}"
    }
});
const $17b90f5d22758690$export$f1adf0a84590c483 = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $9t9D5.default), queryRef);
    const isFieldRenderable = Boolean(data?.fieldId) && data.fieldId === fieldKey;
    const value = String(fieldValue ?? '').trim();
    const formattedMessage = data?.priority?.name ? formatMessage($17b90f5d22758690$var$messages.setPriority, {
        originalValue: data.priority.name,
        value: value
    }) : formatMessage($17b90f5d22758690$var$messages.action, {
        value: value
    });
    const isSameValueSuggested = isFieldRenderable && action.status === 'planned' && Boolean(data?.priority?.name) && data?.priority?.name === value;
    (0, $cozmU.useEffect)(()=>{
        if (isSameValueSuggested && (0, $iDrrr.fg)('jira-track-invalid-update-workitem-actions')) sendAnalyticsEvent({
            eventType: 'operational',
            action: 'detected',
            actionSubject: 'invalidField',
            actionSubjectId: 'updateWorkActionRenderer',
            attributes: {
                fieldType: 'priority',
                anomaly: 'sameValueSuggested',
                invocationId: action.invocationId
            }
        });
    }, [
        isSameValueSuggested,
        action.invocationId,
        sendAnalyticsEvent
    ]);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            additionalSuggestions: [
                {
                    suggested: formattedMessage,
                    testIdSuffix: 'priority-suggested-update'
                }
            ]
        }), [
        fieldReasoning,
        formattedMessage
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable && (0, $cXtTj.default).getExperimentValue('jira-ai-update-workitem-field-action-details-exp', 'isEnabled', false)
    });
    if (!isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.priority-field"
    }, formattedMessage);
};
module.exports["PriorityField"] = $17b90f5d22758690$export$f1adf0a84590c483;

});

parcelRegister("i35Xi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lCTy3 = parcelRequire("lCTy3");

const $1d53d271e015bb0b$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.priority-field.icon-label",
        defaultMessage: "Priority field icon"
    }
});
const $1d53d271e015bb0b$export$2c0601a1439a407a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PriorityFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($1d53d271e015bb0b$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function PriorityFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
        label: formatMessage($1d53d271e015bb0b$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["PriorityFieldIcon"] = $1d53d271e015bb0b$export$2c0601a1439a407a;

});

parcelRegister("1wqLa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1B9Aq = parcelRequire("1B9Aq");

const $8d2f44033eac8439$var$styles = {
    root: "_0bjKvDzXzM _0KLXru7Cj1 _0Of8r2NHnM _1wydGWNHnM _2Zuz6QPgdg _1ZnuxbPgdg _2OUyjtGk8v _1EqgXlBfNa"
}; // Taken from the @atlaskit/tooltip customisation example
const $8d2f44033eac8439$export$294333047ae80f88 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ReasoningTooltip(t0, ref) {
    const $ = (0, $bDgLe.c)(11);
    let children;
    let className;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = rest;
    } else {
        children = $[1];
        className = $[2];
        rest = $[3];
    }
    let t1;
    if ($[4] !== className) {
        t1 = (0, $hekY6.default)([
            $8d2f44033eac8439$var$styles.root,
            className
        ]);
        $[4] = className;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $1B9Aq.default), {
            ...rest,
            className: t1,
            ref: ref
        }, children);
        $[6] = children;
        $[7] = ref;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function ReasoningTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ $cozmU.createElement((0, $1B9Aq.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hekY6.default)([
            $8d2f44033eac8439$var$styles.root,
            className
        ]),
        ref: ref
    }, children);
});
module.exports["ReasoningTooltip"] = $8d2f44033eac8439$export$294333047ae80f88;

});

parcelRegister("2BDch", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9Ld6b = parcelRequire("9Ld6b");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $884a00d2d8e8d8ba$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.rich-text-field.update-action",
        defaultMessage: "Update {fieldName}"
    },
    clearAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.rich-text-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $884a00d2d8e8d8ba$export$b3ef8585d8cbf390 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action) {
        t1 = (0, $4yZQ6.getActionData)(action);
        $[0] = action;
        $[1] = t1;
    } else t1 = $[1];
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = t1;
    const data = (0, $6SsN4.useFragment)((0, $9Ld6b.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    let t2;
    if ($[2] !== data?.name || $[3] !== data?.richText?.adfValue?.convertedPlainText?.isTruncated || $[4] !== data?.richText?.adfValue?.convertedPlainText?.plainText || $[5] !== fieldReasoning || $[6] !== fieldValue || $[7] !== isFieldRenderable) {
        t2 = ()=>{
            if (!isFieldRenderable) return null;
            const currentPlainText = data?.richText?.adfValue?.convertedPlainText?.plainText;
            const isTruncated = data?.richText?.adfValue?.convertedPlainText?.isTruncated;
            const current = currentPlainText ? `${currentPlainText}${isTruncated ? "..." : ""}` : undefined;
            const suggested = fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                current: current,
                suggested: suggested,
                fieldName: data?.name
            });
        };
        $[2] = data?.name;
        $[3] = data?.richText?.adfValue?.convertedPlainText?.isTruncated;
        $[4] = data?.richText?.adfValue?.convertedPlainText?.plainText;
        $[5] = fieldReasoning;
        $[6] = fieldValue;
        $[7] = isFieldRenderable;
        $[8] = t2;
    } else t2 = $[8];
    data?.name;
    data?.richText?.adfValue?.convertedPlainText?.isTruncated;
    data?.richText?.adfValue?.convertedPlainText?.plainText;
    const toolTipContentProvider = t2;
    let t3;
    if ($[9] !== fieldKey || $[10] !== isFieldRenderable || $[11] !== registerTooltipProvider || $[12] !== toolTipContentProvider) {
        t3 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: isFieldRenderable
        };
        $[9] = fieldKey;
        $[10] = isFieldRenderable;
        $[11] = registerTooltipProvider;
        $[12] = toolTipContentProvider;
        $[13] = t3;
    } else t3 = $[13];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t3);
    if (!isFieldRenderable) return null;
    const t4 = isUpdatingAction ? $884a00d2d8e8d8ba$var$messages.updateAction : $884a00d2d8e8d8ba$var$messages.clearAction;
    let t5;
    if ($[14] !== data?.name || $[15] !== formatMessage || $[16] !== t4) {
        t5 = formatMessage(t4, {
            fieldName: data?.name?.toLowerCase()
        });
        $[14] = data?.name;
        $[15] = formatMessage;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.rich-text-field"
        }, t5);
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $9Ld6b.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        if (!isFieldRenderable) return null;
        const currentPlainText = data?.richText?.adfValue?.convertedPlainText?.plainText;
        const isTruncated = data?.richText?.adfValue?.convertedPlainText?.isTruncated;
        const current = currentPlainText ? `${currentPlainText}${isTruncated ? '...' : ''}` : undefined;
        const suggested = fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            current: current,
            suggested: suggested,
            fieldName: data?.name
        });
    }, [
        fieldValue,
        fieldReasoning,
        data?.name,
        data?.richText?.adfValue?.convertedPlainText?.isTruncated,
        data?.richText?.adfValue?.convertedPlainText?.plainText,
        isFieldRenderable
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.rich-text-field"
    }, formatMessage(isUpdatingAction ? $884a00d2d8e8d8ba$var$messages.updateAction : $884a00d2d8e8d8ba$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["RichTextField"] = $884a00d2d8e8d8ba$export$b3ef8585d8cbf390;

});

parcelRegister("5gGrJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $f922E = parcelRequire("f922E");

const $729b0003eeb55c34$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.rich-text-field.icon-label",
        defaultMessage: "Rich text field icon"
    }
});
const $729b0003eeb55c34$export$ea984df189348ddd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RichTextFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($729b0003eeb55c34$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function RichTextFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
        label: formatMessage($729b0003eeb55c34$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["RichTextFieldIcon"] = $729b0003eeb55c34$export$ea984df189348ddd;

});

parcelRegister("ihct3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dzzUs = parcelRequire("dzzUs");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $9c0af9059243b367$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-line-text-field.update-action",
        defaultMessage: "Update {fieldName}"
    },
    clearAction: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-line-text-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $9c0af9059243b367$export$2df72f2d4f169d3a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action) {
        t1 = (0, $4yZQ6.getActionData)(action);
        $[0] = action;
        $[1] = t1;
    } else t1 = $[1];
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = t1;
    const data = (0, $6SsN4.useFragment)((0, $dzzUs.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    let t2;
    if ($[2] !== data?.name || $[3] !== data?.text || $[4] !== fieldReasoning || $[5] !== fieldValue) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                fieldName: data?.name,
                current: data?.text,
                suggested: fieldValue ? String(fieldValue) : undefined
            });
        $[2] = data?.name;
        $[3] = data?.text;
        $[4] = fieldReasoning;
        $[5] = fieldValue;
        $[6] = t2;
    } else t2 = $[6];
    data?.name;
    data?.text;
    const toolTipContentProvider = t2;
    let t3;
    if ($[7] !== fieldKey || $[8] !== isFieldRenderable || $[9] !== registerTooltipProvider || $[10] !== toolTipContentProvider) {
        t3 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: isFieldRenderable
        };
        $[7] = fieldKey;
        $[8] = isFieldRenderable;
        $[9] = registerTooltipProvider;
        $[10] = toolTipContentProvider;
        $[11] = t3;
    } else t3 = $[11];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t3);
    if (!data?.fieldId || !data?.name || data?.fieldId !== fieldKey) return null;
    const t4 = isUpdatingAction ? $9c0af9059243b367$var$messages.updateAction : $9c0af9059243b367$var$messages.clearAction;
    let t5;
    if ($[12] !== data?.name || $[13] !== formatMessage || $[14] !== t4) {
        t5 = formatMessage(t4, {
            fieldName: data?.name?.toLowerCase()
        });
        $[12] = data?.name;
        $[13] = formatMessage;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.single-line-text-field"
        }, t5);
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $dzzUs.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isUpdatingAction = Boolean(fieldValue);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            current: data?.text,
            suggested: fieldValue ? String(fieldValue) : undefined
        }), [
        fieldValue,
        fieldReasoning,
        data?.name,
        data?.text
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!data?.fieldId || !data?.name || data?.fieldId !== fieldKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.single-line-text-field"
    }, formatMessage(isUpdatingAction ? $9c0af9059243b367$var$messages.updateAction : $9c0af9059243b367$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["SingleLineTextField"] = $9c0af9059243b367$export$2df72f2d4f169d3a;

});

parcelRegister("7cQjr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $f922E = parcelRequire("f922E");

const $7afa7d40383607fa$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-line-text-field.icon-label",
        defaultMessage: "Single line text field icon"
    }
});
const $7afa7d40383607fa$export$3b40e79d3ed7455b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SingleLineTextFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($7afa7d40383607fa$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function SingleLineTextFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
        label: formatMessage($7afa7d40383607fa$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["SingleLineTextFieldIcon"] = $7afa7d40383607fa$export$3b40e79d3ed7455b;

});

parcelRegister("8q654", function(module, exports) {

var $ldc10 = parcelRequire("ldc10");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $4yZQ6 = parcelRequire("4yZQ6");


var $8JWzs = parcelRequire("8JWzs");


var $17its = parcelRequire("17its");

const $7d690314225a0af9$var$messages = (0, $kSwu1.defineMessages)({
    assign: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-select-user-picker-field.assign",
        defaultMessage: "Assign to {userName}"
    },
    assignGeneric: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-select-user-picker-field.assign-generic",
        defaultMessage: "Assign {userName} to {fieldName}"
    },
    unassign: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-select-user-picker-field.unassign",
        defaultMessage: "Unassign user"
    },
    unassignGeneric: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-select-user-picker-field.unassign-generic",
        defaultMessage: "Unassign user from {fieldName}"
    },
    assignWithOriginalUser: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-select-user-picker-field.assign-with-original-user",
        defaultMessage: "Assigning from {originalUser} to {userName}"
    }
});
const $7d690314225a0af9$export$cf7ea957fe955a49 = ({ queryRef: queryRef, action: action, onInvalidAction: onInvalidAction })=>{
    (0, $6cFsl.di)((0, $17its.useHydratedUser));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $ldc10.default), queryRef);
    const suggestedUserAccountId = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue?.toString() || null;
    const isFieldRenderable = Boolean(data?.fieldId && data.fieldId === fieldKey);
    const needsHydration = Boolean(isFieldRenderable && suggestedUserAccountId && suggestedUserAccountId !== data?.user?.accountId);
    const hydratedData = (0, $17its.useHydratedUser)(suggestedUserAccountId, needsHydration, onInvalidAction);
    const { user: user, isLoading: isLoading, error: error } = needsHydration && hydratedData ? {
        user: hydratedData.user,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        user: data?.user,
        isLoading: false,
        error: null
    };
    const isAssignable = Boolean((user || isLoading) && suggestedUserAccountId);
    const isNotFound = Boolean(!user && !isLoading && suggestedUserAccountId);
    const assignMessage = data?.user?.accountId && data?.user?.accountId !== user?.accountId ? formatMessage($7d690314225a0af9$var$messages.assignWithOriginalUser, {
        originalUser: data?.user?.name,
        userName: user?.name
    }) : formatMessage(data?.fieldId === 'assignee' ? $7d690314225a0af9$var$messages.assign : $7d690314225a0af9$var$messages.assignGeneric, {
        userName: user?.name,
        ...data?.fieldId !== 'assignee' && {
            fieldName: data?.name
        }
    });
    const unassignMessage = formatMessage(data?.fieldId === 'assignee' ? $7d690314225a0af9$var$messages.unassign : $7d690314225a0af9$var$messages.unassignGeneric, {
        ...data?.fieldId !== 'assignee' && {
            fieldName: data?.name
        }
    });
    const formattedMessage = isAssignable ? assignMessage : unassignMessage;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8JWzs.SingleSelectUserPickerFieldSkeleton), null);
    if (!isFieldRenderable || isNotFound || error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.single-select-user-picker-field"
    }, formattedMessage);
};
module.exports["SingleSelectUserPickerField"] = $7d690314225a0af9$export$cf7ea957fe955a49;

});

parcelRegister("6rrht", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6dcFV = parcelRequire("6dcFV");

const $42abf4b25afbf12b$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.single-select-user-picker-field.icon-label",
        defaultMessage: "Single select user picker field icon"
    }
});
const $42abf4b25afbf12b$export$d631b99125c4a277 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SingleSelectUserPickerFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($42abf4b25afbf12b$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6dcFV))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function SingleSelectUserPickerFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6dcFV))), {
        label: formatMessage($42abf4b25afbf12b$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["SingleSelectUserPickerFieldIcon"] = $42abf4b25afbf12b$export$d631b99125c4a277;

});

parcelRegister("iRNLz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hLPNh = parcelRequire("hLPNh");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");

const $c3d479d5cc8fd76a$var$messages = (0, $kSwu1.defineMessages)({
    set: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.sprint-field.set",
        defaultMessage: "Move work item to sprint"
    },
    remove: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.sprint-field.remove",
        defaultMessage: "Remove work item from sprint"
    }
});
const $c3d479d5cc8fd76a$export$617303ef516d5a01 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let fieldKey;
    let fieldReasoning;
    let t1;
    if ($[0] !== action) {
        const { fieldKey: t2, fieldValue: fieldValue, fieldReasoning: t3 } = (0, $4yZQ6.getActionData)(action);
        fieldKey = t2;
        fieldReasoning = t3;
        t1 = typeof fieldValue === "string" ? fieldValue.trim() : fieldValue?.toString() || null;
        $[0] = action;
        $[1] = fieldKey;
        $[2] = fieldReasoning;
        $[3] = t1;
    } else {
        fieldKey = $[1];
        fieldReasoning = $[2];
        t1 = $[3];
    }
    const suggestedSprintId = t1;
    const data = (0, $6SsN4.useFragment)((0, $hLPNh.default), queryRef);
    const isFieldRenderable = Boolean(data?.fieldId && data.fieldId === fieldKey);
    const currentSprint = data?.selectedSprintsConnection?.edges?.[0]?.node ?? null;
    const currentSprintName = currentSprint?.name ?? null;
    let t2;
    if ($[4] !== data?.sprints?.edges || $[5] !== suggestedSprintId) {
        const sprints = data?.sprints?.edges?.map($c3d479d5cc8fd76a$var$_temp) ?? [];
        let t3;
        if ($[7] !== suggestedSprintId) {
            t3 = (sprint)=>sprint?.sprintId === suggestedSprintId;
            $[7] = suggestedSprintId;
            $[8] = t3;
        } else t3 = $[8];
        t2 = sprints.find(t3);
        $[4] = data?.sprints?.edges;
        $[5] = suggestedSprintId;
        $[6] = t2;
    } else t2 = $[6];
    const suggestedSprint = t2;
    let t3;
    if ($[9] !== currentSprintName || $[10] !== data?.name || $[11] !== fieldReasoning || $[12] !== suggestedSprint?.name) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                fieldName: data?.name,
                current: currentSprintName,
                suggested: suggestedSprint?.name
            });
        $[9] = currentSprintName;
        $[10] = data?.name;
        $[11] = fieldReasoning;
        $[12] = suggestedSprint?.name;
        $[13] = t3;
    } else t3 = $[13];
    data?.name;
    suggestedSprint?.name;
    const toolTipContentProvider = t3;
    let t4;
    if ($[14] !== fieldKey || $[15] !== isFieldRenderable || $[16] !== registerTooltipProvider || $[17] !== toolTipContentProvider) {
        t4 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: isFieldRenderable
        };
        $[14] = fieldKey;
        $[15] = isFieldRenderable;
        $[16] = registerTooltipProvider;
        $[17] = toolTipContentProvider;
        $[18] = t4;
    } else t4 = $[18];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t4);
    if (!isFieldRenderable) return null;
    let t5;
    if ($[19] !== formatMessage || $[20] !== suggestedSprintId) {
        t5 = suggestedSprintId ? formatMessage($c3d479d5cc8fd76a$var$messages.set) : formatMessage($c3d479d5cc8fd76a$var$messages.remove);
        $[19] = formatMessage;
        $[20] = suggestedSprintId;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.sprint-field"
        }, t5);
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const suggestedSprintId = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue?.toString() || null;
    const data = (0, $6SsN4.useFragment)((0, $hLPNh.default), queryRef);
    const isFieldRenderable = Boolean(data?.fieldId && data.fieldId === fieldKey);
    const currentSprint = data?.selectedSprintsConnection?.edges?.[0]?.node ?? null;
    const currentSprintName = currentSprint?.name ?? null;
    const sprints = data?.sprints?.edges?.map((edge)=>edge?.node) ?? [];
    const suggestedSprint = sprints.find((sprint)=>sprint?.sprintId === suggestedSprintId);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            current: currentSprintName,
            suggested: suggestedSprint?.name
        }), [
        fieldReasoning,
        data?.name,
        currentSprintName,
        suggestedSprint?.name
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.sprint-field"
    }, suggestedSprintId ? formatMessage($c3d479d5cc8fd76a$var$messages.set) : formatMessage($c3d479d5cc8fd76a$var$messages.remove));
};
function $c3d479d5cc8fd76a$var$_temp(edge) {
    return edge?.node;
}
module.exports["SprintField"] = $c3d479d5cc8fd76a$export$617303ef516d5a01;

});

parcelRegister("lNkFf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jerDQ = parcelRequire("jerDQ");

const $dc8739f36830dd76$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.sprint-field.icon-label",
        defaultMessage: "Sprint field icon"
    }
});
const $dc8739f36830dd76$export$99383437a0a3b5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SprintFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($dc8739f36830dd76$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jerDQ))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function SprintFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jerDQ))), {
        label: formatMessage($dc8739f36830dd76$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["SprintFieldIcon"] = $dc8739f36830dd76$export$99383437a0a3b5d;

});

parcelRegister("2KmEz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $d2Au0 = parcelRequire("d2Au0");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $4yZQ6 = parcelRequire("4yZQ6");


var $ayiQL = parcelRequire("ayiQL");

const $1f426f0621f7a4bb$var$messages = (0, $kSwu1.defineMessages)({
    action: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.status-field.action",
        defaultMessage: "Move to {newStatus}"
    },
    moveFromOriginalStatus: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.status-field.move-from-original-status",
        defaultMessage: "Move from {originalStatus} to {newStatus}"
    }
});
const $1f426f0621f7a4bb$export$28769ce7cf4b59f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { queryRef: queryRef, action: action, onInvalidAction: onInvalidAction } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== action) {
        t1 = (0, $4yZQ6.getActionData)(action);
        $[0] = action;
        $[1] = t1;
    } else t1 = $[1];
    const { fieldKey: fieldKey, fieldValue: fieldValue } = t1;
    const data = (0, $6SsN4.useFragment)((0, $d2Au0.default), queryRef);
    const fieldIdMatches = data?.fieldId === fieldKey;
    const suggestedTransitionId = Number(fieldValue);
    let t2;
    if ($[2] !== suggestedTransitionId) {
        t2 = Number.isNaN(suggestedTransitionId);
        $[2] = suggestedTransitionId;
        $[3] = t2;
    } else t2 = $[3];
    const isValidNumericTransition = !t2;
    let t3;
    bb0: {
        if (!fieldIdMatches) {
            t3 = undefined;
            break bb0;
        }
        if (!isValidNumericTransition) {
            let t4;
            if ($[4] !== fieldValue) {
                t4 = typeof fieldValue === "string" ? String(fieldValue).trim() : undefined;
                $[4] = fieldValue;
                $[5] = t4;
            } else t4 = $[5];
            t3 = t4;
            break bb0;
        }
        let t4;
        if ($[6] !== data?.transitions?.edges || $[7] !== suggestedTransitionId) {
            t4 = data?.transitions?.edges?.find((edge)=>edge?.node?.transitionId === suggestedTransitionId)?.node?.to?.name;
            $[6] = data?.transitions?.edges;
            $[7] = suggestedTransitionId;
            $[8] = t4;
        } else t4 = $[8];
        t3 = t4;
    }
    const statusName = t3;
    (0, $ayiQL.useStaleTransitionGuard)(!statusName, onInvalidAction);
    if (!fieldIdMatches || !statusName) return null;
    let t4;
    if ($[9] !== data?.status?.name || $[10] !== formatMessage || $[11] !== isValidNumericTransition || $[12] !== statusName) {
        t4 = data?.status?.name && isValidNumericTransition ? formatMessage($1f426f0621f7a4bb$var$messages.moveFromOriginalStatus, {
            originalStatus: data?.status?.name,
            newStatus: statusName
        }) : formatMessage($1f426f0621f7a4bb$var$messages.action, {
            newStatus: statusName
        });
        $[9] = data?.status?.name;
        $[10] = formatMessage;
        $[11] = isValidNumericTransition;
        $[12] = statusName;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.status-field",
            color: "color.text.subtle",
            maxLines: 1
        }, t4);
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ queryRef: queryRef, action: action, onInvalidAction: onInvalidAction })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $d2Au0.default), queryRef);
    const fieldIdMatches = data?.fieldId === fieldKey;
    const suggestedTransitionId = Number(fieldValue);
    const isValidNumericTransition = !Number.isNaN(suggestedTransitionId);
    const statusName = (0, $cozmU.useMemo)(()=>{
        if (!fieldIdMatches) return undefined;
        if (!isValidNumericTransition) return typeof fieldValue === 'string' ? String(fieldValue).trim() : undefined;
        return data?.transitions?.edges?.find((edge)=>edge?.node?.transitionId === suggestedTransitionId)?.node?.to?.name;
    }, [
        data,
        fieldIdMatches,
        isValidNumericTransition,
        suggestedTransitionId,
        fieldValue
    ]);
    (0, $ayiQL.useStaleTransitionGuard)(!statusName, onInvalidAction);
    if (!fieldIdMatches || !statusName) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.status-field",
        color: "color.text.subtle",
        maxLines: 1
    }, data?.status?.name && isValidNumericTransition ? formatMessage($1f426f0621f7a4bb$var$messages.moveFromOriginalStatus, {
        originalStatus: data?.status?.name,
        newStatus: statusName
    }) : formatMessage($1f426f0621f7a4bb$var$messages.action, {
        newStatus: statusName
    }));
};
module.exports["StatusField"] = $1f426f0621f7a4bb$export$28769ce7cf4b59f9;

});

parcelRegister("bkiNa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $c5NbL = parcelRequire("c5NbL");

const $6497da8d85bae696$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.status-field.icon-label",
        defaultMessage: "Status field icon"
    }
});
const $6497da8d85bae696$export$fae2110e65128aee = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StatusFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($6497da8d85bae696$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5NbL))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function StatusFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5NbL))), {
        label: formatMessage($6497da8d85bae696$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["StatusFieldIcon"] = $6497da8d85bae696$export$fae2110e65128aee;

});

parcelRegister("UqbzZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $3DMf9 = parcelRequire("3DMf9");


var $iMnC5 = parcelRequire("iMnC5");


var $a9aSv = parcelRequire("a9aSv");

const $3f66e7c40a797b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    actionCompleted: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.action-completed.non-final",
        defaultMessage: "Action completed"
    },
    actionFailed: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.action-failed.non-final",
        defaultMessage: "Action failed"
    },
    defaultFieldIconLabel: {
        id: "conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.generic-field-icon-label.non-final",
        defaultMessage: "Field icon"
    }
});
const $3f66e7c40a797b37$var$styles = {
    root: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconHidden: "_1YKVNsdnbC _39xV02oWWg _0jFU0VoWWg"
};
const $3f66e7c40a797b37$export$b131c49b26d3f427 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { showIcon: showIcon, icon: icon, isCompleted: isCompleted, isLoading: isLoading, isFailed: isFailed, isBulkActioning: t1 } = t0;
    const isBulkActioning = t1 === undefined ? false : t1;
    (0, $6cFsl.di)((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    bb0: {
        if (isLoading) {
            let t3;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.status-icon.loading",
                    width: "24px",
                    height: "24px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                });
                $[0] = t3;
            } else t3 = $[0];
            t2 = t3;
            break bb0;
        }
        if (isFailed) {
            let t3;
            if ($[1] !== formatMessage) {
                t3 = formatMessage($3f66e7c40a797b37$export$defe85febe8b728c.actionFailed);
                $[1] = formatMessage;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    label: t3,
                    color: "var(--ds-icon-danger, #C9372C)",
                    size: "small"
                });
                $[3] = t3;
                $[4] = t4;
            } else t4 = $[4];
            t2 = t4;
            break bb0;
        }
        if (isCompleted) {
            let t3;
            if ($[5] !== formatMessage) {
                t3 = formatMessage($3f66e7c40a797b37$export$defe85febe8b728c.actionCompleted);
                $[5] = formatMessage;
                $[6] = t3;
            } else t3 = $[6];
            let t4;
            if ($[7] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    label: t3,
                    color: "var(--ds-icon-success, #6A9A23)",
                    size: "small"
                });
                $[7] = t3;
                $[8] = t4;
            } else t4 = $[8];
            t2 = t4;
            break bb0;
        }
        if (isBulkActioning) {
            let t3;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.status-icon.loading",
                    width: "24px",
                    height: "24px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                });
                $[9] = t3;
            } else t3 = $[9];
            t2 = t3;
            break bb0;
        }
        if (!icon) {
            let t3;
            if ($[10] !== formatMessage) {
                t3 = formatMessage($3f66e7c40a797b37$export$defe85febe8b728c.defaultFieldIconLabel);
                $[10] = formatMessage;
                $[11] = t3;
            } else t3 = $[11];
            let t4;
            if ($[12] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
                    label: t3,
                    size: "small",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[12] = t3;
                $[13] = t4;
            } else t4 = $[13];
            t2 = t4;
            break bb0;
        }
        t2 = icon;
    }
    const displayIcon = t2;
    const shouldDisplayIcon = showIcon || isCompleted || isLoading || isFailed || isBulkActioning;
    const t3 = shouldDisplayIcon ? $3f66e7c40a797b37$var$styles.root : $3f66e7c40a797b37$var$styles.iconHidden;
    let t4;
    if ($[14] !== displayIcon || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.status-icon.container",
            xcss: t3
        }, displayIcon);
        $[14] = displayIcon;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ showIcon: showIcon, icon: icon, isCompleted: isCompleted, isLoading: isLoading, isFailed: isFailed, isBulkActioning: isBulkActioning = false })=>{
    (0, $6cFsl.di)((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const displayIcon = (0, $cozmU.useMemo)(()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.status-icon.loading",
            width: "24px",
            height: "24px",
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        });
        if (isFailed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: formatMessage($3f66e7c40a797b37$export$defe85febe8b728c.actionFailed),
            color: "var(--ds-icon-danger, #C9372C)",
            size: "small"
        });
        if (isCompleted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: formatMessage($3f66e7c40a797b37$export$defe85febe8b728c.actionCompleted),
            color: "var(--ds-icon-success, #6A9A23)",
            size: "small"
        });
         // We don't want to override the fail/completed status icons if we are bulk dismissing an issue, andh
        // hence we render the skeleton after the checks if so.
        if (isBulkActioning) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.status-icon.loading",
            width: "24px",
            height: "24px",
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        });
        if (!icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: formatMessage($3f66e7c40a797b37$export$defe85febe8b728c.defaultFieldIconLabel),
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
         // Display the icon corresponding to the field type
        return icon;
    }, [
        icon,
        isCompleted,
        isLoading,
        isFailed,
        formatMessage,
        isBulkActioning
    ]);
    const shouldDisplayIcon = showIcon || isCompleted || isLoading || isFailed || isBulkActioning;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "update-work-item-all-fields-action-renderer.ui.card-fields-list.status-icon.container",
        xcss: shouldDisplayIcon ? $3f66e7c40a797b37$var$styles.root : $3f66e7c40a797b37$var$styles.iconHidden
    }, displayIcon);
};
module.exports["StatusIcon"] = $3f66e7c40a797b37$export$b131c49b26d3f427;

});

parcelRegister("csBJX", function(module, exports) {

var $k0LRW = parcelRequire("k0LRW");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $3UbkS = parcelRequire("3UbkS");


var $h4UtQ = parcelRequire("h4UtQ");

const $aaf8e04c30813006$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-team-view-field.update-action",
        defaultMessage: "Set team to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-team-view-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $aaf8e04c30813006$export$c2047b15369e215a = ({ cloudId: cloudId, queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider, onInvalidAction: onInvalidAction })=>{
    (0, $6cFsl.di)((0, $h4UtQ.useHydratedTeam));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $k0LRW.default), queryRef);
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    // TODO: Case when we're unassigning teams - is it null or empty string, or what with this schema?
    const suggestedTeamId = fieldValue ? String(fieldValue) : undefined;
    const isFieldRenderable = Boolean(data?.fieldId === fieldKey && data?.name);
    const isUpdatingAction = Boolean(fieldValue);
    const hydratedData = (0, $h4UtQ.useHydratedTeam)(suggestedTeamId, cloudId, true, onInvalidAction);
    const { teamId: hydratedTeamId, displayName: hydratedTeamName, isLoading: isLoading, error: error } = hydratedData ? {
        teamId: hydratedData.team?.teamId,
        displayName: hydratedData.team?.displayName,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        teamId: null,
        displayName: null,
        isLoading: false,
        error: null
    };
    const isNotFound = !hydratedTeamId && !isLoading && !!suggestedTeamId;
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            current: data?.selectedTeam?.jiraSuppliedName,
            suggested: hydratedTeamName
        }), [
        fieldReasoning,
        data?.name,
        data?.selectedTeam?.jiraSuppliedName,
        hydratedTeamName
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable || error || isNotFound) return null;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3UbkS.TeamViewFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.jira-team-view-field"
    }, formatMessage(isUpdatingAction ? $aaf8e04c30813006$var$messages.updateAction : $aaf8e04c30813006$var$messages.clearAction, {
        currentTeam: data?.selectedTeam?.jiraSuppliedName,
        fieldValue: hydratedTeamName,
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["TeamViewField"] = $aaf8e04c30813006$export$c2047b15369e215a;

});

parcelRegister("h9KZF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dflgH = parcelRequire("dflgH");

const $f6294b29d9958e5c$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.team-view-field.icon-label",
        defaultMessage: "Team view field icon"
    }
});
const $f6294b29d9958e5c$export$66bd7f664e0c12ea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($f6294b29d9958e5c$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dflgH))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dflgH))), {
        label: formatMessage($f6294b29d9958e5c$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["TeamViewFieldIcon"] = $f6294b29d9958e5c$export$66bd7f664e0c12ea;

});

parcelRegister("18id6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $feXV7 = parcelRequire("feXV7");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $6okNK = parcelRequire("6okNK");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $iYaJ6 = parcelRequire("iYaJ6");


var $g2LNR = parcelRequire("g2LNR");

const $deac1b4744acb265$var$messages = (0, $kSwu1.defineMessages)({
    timeSpentLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.time-spent-label",
        defaultMessage: "Current time spent"
    },
    timeSpentSuggestedLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.time-spent-suggested-label",
        defaultMessage: "Suggested time spent"
    },
    startDateSuggestedLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.start-date-suggested-label",
        defaultMessage: "Suggested start date"
    },
    commentSuggestedLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.comment-suggested-label",
        defaultMessage: "Suggested comment"
    },
    set: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.set-label",
        defaultMessage: "Set time spent to {timeSpent}"
    }
});
const $deac1b4744acb265$export$7a4022552042d611 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $feXV7.default), queryRef);
    const isFieldRenderable = data?.fieldId === "timetracking" && fieldKey === "timespent";
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const fieldValues = (0, $g2LNR.toTimeSpentFieldValue)(fieldValue);
    const suggestedTimeSpent = fieldValues?.timeSpent;
    const suggestedStarted = fieldValues?.started;
    const suggestedComment = fieldValues?.comment;
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled && !!suggestedTimeSpent;
    const { defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {};
    const t1 = data?.timeSpent?.timeInSeconds;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $iYaJ6.formatSecondsToHuman)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const currentTimeSpent = t2;
    const normalizedSuggestedSeconds = (0, $iYaJ6.parseSuggestionToSeconds)(suggestedTimeSpent || "", {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    let t3;
    if ($[2] !== defaultFormat || $[3] !== defaultUnit || $[4] !== normalizedSuggestedSeconds || $[5] !== suggestedTimeSpent || $[6] !== workingDaysPerWeek || $[7] !== workingHoursPerDay) {
        t3 = normalizedSuggestedSeconds != null ? (0, $iYaJ6.formatSecondsWithSettings)(normalizedSuggestedSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedTimeSpent;
        $[2] = defaultFormat;
        $[3] = defaultUnit;
        $[4] = normalizedSuggestedSeconds;
        $[5] = suggestedTimeSpent;
        $[6] = workingDaysPerWeek;
        $[7] = workingHoursPerDay;
        $[8] = t3;
    } else t3 = $[8];
    const normalizedOriginalValue = t3;
    let t4;
    if ($[9] !== currentTimeSpent || $[10] !== data?.name || $[11] !== fieldReasoning || $[12] !== formatDate || $[13] !== formatMessage || $[14] !== normalizedOriginalValue || $[15] !== suggestedComment || $[16] !== suggestedStarted) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                fieldName: data?.name,
                current: currentTimeSpent,
                currentLabel: formatMessage($deac1b4744acb265$var$messages.timeSpentLabel),
                suggested: normalizedOriginalValue,
                suggestedLabel: formatMessage($deac1b4744acb265$var$messages.timeSpentSuggestedLabel),
                additionalSuggestions: [
                    {
                        suggested: (0, $6okNK.formatSuggestedDateTime)(suggestedStarted, formatDate),
                        label: formatMessage($deac1b4744acb265$var$messages.startDateSuggestedLabel),
                        testIdSuffix: "time-spent-field-start-date-suggestion"
                    },
                    {
                        suggested: suggestedComment,
                        label: formatMessage($deac1b4744acb265$var$messages.commentSuggestedLabel),
                        testIdSuffix: "time-spent-field-comment-suggestion"
                    }
                ]
            });
        $[9] = currentTimeSpent;
        $[10] = data?.name;
        $[11] = fieldReasoning;
        $[12] = formatDate;
        $[13] = formatMessage;
        $[14] = normalizedOriginalValue;
        $[15] = suggestedComment;
        $[16] = suggestedStarted;
        $[17] = t4;
    } else t4 = $[17];
    data?.name;
    const toolTipContentProvider = t4;
    let t5;
    if ($[18] !== fieldKey || $[19] !== registerTooltipProvider || $[20] !== shouldRender || $[21] !== toolTipContentProvider) {
        t5 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: shouldRender
        };
        $[18] = fieldKey;
        $[19] = registerTooltipProvider;
        $[20] = shouldRender;
        $[21] = toolTipContentProvider;
        $[22] = t5;
    } else t5 = $[22];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t5);
    if (!shouldRender) return null;
    let t6;
    if ($[23] !== formatMessage || $[24] !== normalizedOriginalValue) {
        t6 = formatMessage($deac1b4744acb265$var$messages.set, {
            timeSpent: normalizedOriginalValue
        });
        $[23] = formatMessage;
        $[24] = normalizedOriginalValue;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.time-spent-field"
        }, t6);
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    return t7;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $feXV7.default), queryRef);
    const isFieldRenderable = data?.fieldId === 'timetracking' && fieldKey === 'timespent';
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const fieldValues = (0, $g2LNR.toTimeSpentFieldValue)(fieldValue);
    const suggestedTimeSpent = fieldValues?.timeSpent;
    const suggestedStarted = fieldValues?.started;
    const suggestedComment = fieldValues?.comment;
    // There cannot be a case where we "clear" the timespent - there always must be a value.
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled && !!suggestedTimeSpent;
    const { defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {};
    const currentTimeSpent = (0, $iYaJ6.formatSecondsToHuman)(data?.timeSpent?.timeInSeconds);
    const normalizedSuggestedSeconds = (0, $iYaJ6.parseSuggestionToSeconds)(suggestedTimeSpent || '', {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedOriginalValue = (0, $cozmU.useMemo)(()=>normalizedSuggestedSeconds != null ? (0, $iYaJ6.formatSecondsWithSettings)(normalizedSuggestedSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedTimeSpent, [
        normalizedSuggestedSeconds,
        defaultUnit,
        defaultFormat,
        workingHoursPerDay,
        workingDaysPerWeek,
        suggestedTimeSpent
    ]);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            current: currentTimeSpent,
            currentLabel: formatMessage($deac1b4744acb265$var$messages.timeSpentLabel),
            suggested: normalizedOriginalValue,
            suggestedLabel: formatMessage($deac1b4744acb265$var$messages.timeSpentSuggestedLabel),
            additionalSuggestions: [
                {
                    suggested: (0, $6okNK.formatSuggestedDateTime)(suggestedStarted, formatDate),
                    label: formatMessage($deac1b4744acb265$var$messages.startDateSuggestedLabel),
                    testIdSuffix: 'time-spent-field-start-date-suggestion'
                },
                {
                    suggested: suggestedComment,
                    label: formatMessage($deac1b4744acb265$var$messages.commentSuggestedLabel),
                    testIdSuffix: 'time-spent-field-comment-suggestion'
                }
            ]
        }), [
        fieldReasoning,
        data?.name,
        currentTimeSpent,
        normalizedOriginalValue,
        suggestedStarted,
        suggestedComment,
        formatMessage,
        formatDate
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: shouldRender
    });
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.time-spent-field"
    }, formatMessage($deac1b4744acb265$var$messages.set, {
        timeSpent: normalizedOriginalValue
    }));
};
module.exports["TimeSpentField"] = $deac1b4744acb265$export$7a4022552042d611;

});

parcelRegister("kR99p", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eU4qe = parcelRequire("eU4qe");

const $cc065c398e4e0893$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-spent-field.icon-label",
        defaultMessage: "Time spent field"
    }
});
const $cc065c398e4e0893$export$75e8a761b9ab73fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($cc065c398e4e0893$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eU4qe))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eU4qe))), {
        label: formatMessage($cc065c398e4e0893$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["TimeSpentFieldIcon"] = $cc065c398e4e0893$export$75e8a761b9ab73fe;

});

parcelRegister("8JEzu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iELRi = parcelRequire("iELRi");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $iYaJ6 = parcelRequire("iYaJ6");


var $golg3 = parcelRequire("golg3");

const $0ceba58989ddaf10$var$messages = (0, $kSwu1.defineMessages)({
    originalEstimateLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-estimate-label",
        defaultMessage: "Current original estimate"
    },
    remainingEstimateLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.remaining-estimate-label",
        defaultMessage: "Current remaining estimate"
    },
    originalEstimateSuggestedLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-estimate-suggested",
        defaultMessage: "Suggested original estimate"
    },
    remainingEstimateSuggestedLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.remaining-estimate-suggested",
        defaultMessage: "Suggested remaining estimate"
    }
});
const $0ceba58989ddaf10$export$1c882bff9d1eb3f8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $iELRi.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled;
    const fieldValues = (0, $golg3.toTimeTrackingFieldValue)(fieldValue);
    const suggestedOriginalEstimate = fieldValues?.originalEstimate;
    const suggestedRemainingEstimate = fieldValues?.remainingEstimate;
    const { defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {};
    const normalizedOriginalSeconds = (0, $iYaJ6.parseSuggestionToSeconds)(suggestedOriginalEstimate || "", {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedRemainingSeconds = (0, $iYaJ6.parseSuggestionToSeconds)(suggestedRemainingEstimate || "", {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    let t1;
    if ($[0] !== defaultFormat || $[1] !== defaultUnit || $[2] !== normalizedOriginalSeconds || $[3] !== suggestedOriginalEstimate || $[4] !== workingDaysPerWeek || $[5] !== workingHoursPerDay) {
        t1 = normalizedOriginalSeconds != null ? (0, $iYaJ6.formatSecondsWithSettings)(normalizedOriginalSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedOriginalEstimate;
        $[0] = defaultFormat;
        $[1] = defaultUnit;
        $[2] = normalizedOriginalSeconds;
        $[3] = suggestedOriginalEstimate;
        $[4] = workingDaysPerWeek;
        $[5] = workingHoursPerDay;
        $[6] = t1;
    } else t1 = $[6];
    const normalizedOriginalValue = t1;
    let t2;
    if ($[7] !== defaultFormat || $[8] !== defaultUnit || $[9] !== normalizedRemainingSeconds || $[10] !== suggestedRemainingEstimate || $[11] !== workingDaysPerWeek || $[12] !== workingHoursPerDay) {
        t2 = normalizedRemainingSeconds != null ? (0, $iYaJ6.formatSecondsWithSettings)(normalizedRemainingSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedRemainingEstimate;
        $[7] = defaultFormat;
        $[8] = defaultUnit;
        $[9] = normalizedRemainingSeconds;
        $[10] = suggestedRemainingEstimate;
        $[11] = workingDaysPerWeek;
        $[12] = workingHoursPerDay;
        $[13] = t2;
    } else t2 = $[13];
    const normalizedRemainingValue = t2;
    const t3 = data?.originalEstimate?.timeInSeconds ?? null;
    let t4;
    if ($[14] !== t3) {
        t4 = (0, $iYaJ6.formatSecondsToHuman)(t3);
        $[14] = t3;
        $[15] = t4;
    } else t4 = $[15];
    const normalizedCurrentOriginalValue = t4;
    const t5 = data?.remainingEstimate?.timeInSeconds ?? null;
    let t6;
    if ($[16] !== t5) {
        t6 = (0, $iYaJ6.formatSecondsToHuman)(t5);
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    const normalizedCurrentRemainingValue = t6;
    let t7;
    if ($[18] !== data?.name || $[19] !== fieldReasoning || $[20] !== formatMessage || $[21] !== normalizedCurrentOriginalValue || $[22] !== normalizedCurrentRemainingValue || $[23] !== normalizedOriginalValue || $[24] !== normalizedRemainingValue || $[25] !== suggestedOriginalEstimate || $[26] !== suggestedRemainingEstimate) {
        t7 = ()=>{
            const getSuggestedOriginal = ()=>{
                if (suggestedOriginalEstimate === undefined) return suggestedOriginalEstimate;
                if (suggestedOriginalEstimate) return normalizedOriginalValue;
                return suggestedRemainingEstimate ? normalizedRemainingValue : normalizedCurrentRemainingValue;
            };
            const getSuggestedRemaining = ()=>{
                if (suggestedRemainingEstimate === undefined) return suggestedRemainingEstimate;
                if (suggestedRemainingEstimate) return normalizedRemainingValue;
                return suggestedOriginalEstimate ? normalizedOriginalValue : normalizedCurrentOriginalValue;
            };
            const originalAndRemainingCleared = suggestedOriginalEstimate !== undefined && !suggestedOriginalEstimate && suggestedRemainingEstimate !== undefined && !suggestedRemainingEstimate;
            const suggestedOriginal = originalAndRemainingCleared ? null : getSuggestedOriginal();
            const suggestedRemaining = originalAndRemainingCleared ? null : getSuggestedRemaining();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
                reasoning: fieldReasoning,
                fieldName: data?.name,
                additionalSuggestions: [
                    {
                        suggested: suggestedOriginalEstimate !== undefined && normalizedCurrentOriginalValue,
                        label: formatMessage($0ceba58989ddaf10$var$messages.originalEstimateLabel),
                        testIdSuffix: "original-estimate-current"
                    },
                    {
                        suggested: suggestedRemainingEstimate !== undefined && normalizedCurrentRemainingValue,
                        label: formatMessage($0ceba58989ddaf10$var$messages.remainingEstimateLabel),
                        testIdSuffix: "remaining-estimate-current"
                    },
                    {
                        suggested: suggestedOriginal,
                        label: formatMessage($0ceba58989ddaf10$var$messages.originalEstimateSuggestedLabel),
                        testIdSuffix: "original-estimate-suggested"
                    },
                    {
                        suggested: suggestedRemaining,
                        label: formatMessage($0ceba58989ddaf10$var$messages.remainingEstimateSuggestedLabel),
                        testIdSuffix: "remaining-estimate-suggested"
                    }
                ]
            });
        };
        $[18] = data?.name;
        $[19] = fieldReasoning;
        $[20] = formatMessage;
        $[21] = normalizedCurrentOriginalValue;
        $[22] = normalizedCurrentRemainingValue;
        $[23] = normalizedOriginalValue;
        $[24] = normalizedRemainingValue;
        $[25] = suggestedOriginalEstimate;
        $[26] = suggestedRemainingEstimate;
        $[27] = t7;
    } else t7 = $[27];
    data?.name;
    const toolTipContentProvider = t7;
    let t8;
    if ($[28] !== fieldKey || $[29] !== registerTooltipProvider || $[30] !== shouldRender || $[31] !== toolTipContentProvider) {
        t8 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: fieldKey,
            provider: toolTipContentProvider,
            enabled: shouldRender
        };
        $[28] = fieldKey;
        $[29] = registerTooltipProvider;
        $[30] = shouldRender;
        $[31] = toolTipContentProvider;
        $[32] = t8;
    } else t8 = $[32];
    (0, $92bnZ.useRegisterTooltipContentProvider)(t8);
    if (!shouldRender) return null;
    let t9;
    if ($[33] !== formatMessage || $[34] !== normalizedCurrentOriginalValue || $[35] !== normalizedCurrentRemainingValue || $[36] !== normalizedOriginalValue || $[37] !== normalizedRemainingValue || $[38] !== suggestedOriginalEstimate || $[39] !== suggestedRemainingEstimate) {
        t9 = (0, $golg3.getFieldTextCopy)({
            suggestedOriginalEstimate: suggestedOriginalEstimate,
            suggestedRemainingEstimate: suggestedRemainingEstimate,
            normalizedOriginalValue: normalizedOriginalValue,
            normalizedRemainingValue: normalizedRemainingValue,
            normalizedCurrentOriginalValue: normalizedCurrentOriginalValue,
            normalizedCurrentRemainingValue: normalizedCurrentRemainingValue,
            formatMessage: formatMessage
        });
        $[33] = formatMessage;
        $[34] = normalizedCurrentOriginalValue;
        $[35] = normalizedCurrentRemainingValue;
        $[36] = normalizedOriginalValue;
        $[37] = normalizedRemainingValue;
        $[38] = suggestedOriginalEstimate;
        $[39] = suggestedRemainingEstimate;
        $[40] = t9;
    } else t9 = $[40];
    const value = t9;
    let t10;
    if ($[41] !== value) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.remaining-time-estimate-field"
        }, value);
        $[41] = value;
        $[42] = t10;
    } else t10 = $[42];
    return t10;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $iELRi.default), queryRef);
    const isFieldRenderable = data?.fieldId === fieldKey;
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled;
    const fieldValues = (0, $golg3.toTimeTrackingFieldValue)(fieldValue);
    const suggestedOriginalEstimate = fieldValues?.originalEstimate;
    const suggestedRemainingEstimate = fieldValues?.remainingEstimate;
    const { defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {};
    const normalizedOriginalSeconds = (0, $iYaJ6.parseSuggestionToSeconds)(suggestedOriginalEstimate || '', {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedRemainingSeconds = (0, $iYaJ6.parseSuggestionToSeconds)(suggestedRemainingEstimate || '', {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedOriginalValue = (0, $cozmU.useMemo)(()=>normalizedOriginalSeconds != null ? (0, $iYaJ6.formatSecondsWithSettings)(normalizedOriginalSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedOriginalEstimate, [
        normalizedOriginalSeconds,
        defaultUnit,
        defaultFormat,
        workingHoursPerDay,
        workingDaysPerWeek,
        suggestedOriginalEstimate
    ]);
    const normalizedRemainingValue = (0, $cozmU.useMemo)(()=>normalizedRemainingSeconds != null ? (0, $iYaJ6.formatSecondsWithSettings)(normalizedRemainingSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedRemainingEstimate, [
        normalizedRemainingSeconds,
        defaultUnit,
        defaultFormat,
        workingHoursPerDay,
        workingDaysPerWeek,
        suggestedRemainingEstimate
    ]);
    const normalizedCurrentOriginalValue = (0, $iYaJ6.formatSecondsToHuman)(data?.originalEstimate?.timeInSeconds ?? null);
    const normalizedCurrentRemainingValue = (0, $iYaJ6.formatSecondsToHuman)(data?.remainingEstimate?.timeInSeconds ?? null);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        /*
    	The time tracking field has some confusing behaviour when it comes to setting the original and remaining estimates.
    	The shape of the object we receive as an action (and send to the API) is as so:
    	{
    		originalEstimate?: string | nulll   // undefined if doesn't have a value
    		remainingEstimate?: string | null   // undefined if doesn't have a value
    	}
    	* Note that passing in an empty string ('') or null both act as "clearing" the estimate field.
    		When we provide a valid value (e.g a string like '7d', '2h', '1w 6d 7h'), the API handles this as we expect it to for
    	original and remaining estimates - it updates the value as we would expect.
    		However, when we "clear" fields, the API behaves less intuitively. If we pass in an empty string/null, the API call
    	will be successful, but the field will not be cleared. Instead it will take the value of the other estimate field
    	and use that.
    		For example, suppose we have a Jira work item has an original estimate of '7d' and a remaining estimate of '3d'.
    	If we send the following object to the API:
    	{
    		remainingEstimate: '',
    	}
    	The API will set the remainingEstimate to '7d' now, obtaining this value from the original estimate. The same is true
    	if we set originalEstimate to a cleared value.
    		However, if we clear both fields by sending the following object to the API:
    	{
    		originalEstimate: '',
    		remainingEstimate: '',
    	}
    	The API will clear both fields, as we would expect.
    		The code below thus handles this behaviour for the suggested estimate values through the following process:
    	Suppose we have a Jira work item has an original estimate of '7d' and a remaining estimate of '3d'.
    	1) If the estimate is undefined, return the undefined object (this isn't going to be changed/rendered)
    	Example in originalEstimate scope
    	{
    		remainingEstimate: '7d',
    	}
    	suggestedValue = undefined
    		2) If the estimate is truthy (i.e not an empty string/null), we use that value
    	Example in originalEstimate scope
    	{
    		originalEstimate: '5d',
    	}
    	suggestedValue = '5d'
    		3) If the other estimate is truthy, we will use the suggested value of the other estimate field.
    	Example in originalEstimate scope
    	{
    		originalEstimate: ''
    		remainingEstimate: '5d'
    	}
    	suggestedValue = '5d'
    		4) If that is not available, (i.e the current estimate is falsy AND the other estimate is falsy), we use the current value of the other estimate field.
    	Example in originalEstimate scope
    	{
    		originalEstimate: ''
    	}
    	suggestedValue = '3d'
    		* Note: 3) and 4) are the same logic as the BE code: https://atlassian.slack.com/archives/C092WQZSBSP/p1762146479675429?thread_ts=1761885651.797099&cid=C092WQZSBSP
    	There is also the case where if both estimates are cleared, then both suggested values will be null so we don't render any suggested
    	values as we are clearing the fields.
    */ const getSuggestedOriginal = ()=>{
            if (suggestedOriginalEstimate === undefined) return suggestedOriginalEstimate;
            if (suggestedOriginalEstimate) return normalizedOriginalValue;
            return suggestedRemainingEstimate ? normalizedRemainingValue : normalizedCurrentRemainingValue;
        };
        const getSuggestedRemaining = ()=>{
            if (suggestedRemainingEstimate === undefined) return suggestedRemainingEstimate;
            if (suggestedRemainingEstimate) return normalizedRemainingValue;
            return suggestedOriginalEstimate ? normalizedOriginalValue : normalizedCurrentOriginalValue;
        };
        // Check if both estimates are explicitly cleared (empty/null, not undefined)
        const originalAndRemainingCleared = suggestedOriginalEstimate !== undefined && !suggestedOriginalEstimate && suggestedRemainingEstimate !== undefined && !suggestedRemainingEstimate;
        // If both are cleared, show null. Otherwise, compute the suggested values.
        const suggestedOriginal = originalAndRemainingCleared ? null : getSuggestedOriginal();
        const suggestedRemaining = originalAndRemainingCleared ? null : getSuggestedRemaining();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            fieldName: data?.name,
            additionalSuggestions: [
                {
                    suggested: suggestedOriginalEstimate !== undefined && normalizedCurrentOriginalValue,
                    label: formatMessage($0ceba58989ddaf10$var$messages.originalEstimateLabel),
                    testIdSuffix: 'original-estimate-current'
                },
                {
                    suggested: suggestedRemainingEstimate !== undefined && normalizedCurrentRemainingValue,
                    label: formatMessage($0ceba58989ddaf10$var$messages.remainingEstimateLabel),
                    testIdSuffix: 'remaining-estimate-current'
                },
                {
                    suggested: suggestedOriginal,
                    label: formatMessage($0ceba58989ddaf10$var$messages.originalEstimateSuggestedLabel),
                    testIdSuffix: 'original-estimate-suggested'
                },
                {
                    suggested: suggestedRemaining,
                    label: formatMessage($0ceba58989ddaf10$var$messages.remainingEstimateSuggestedLabel),
                    testIdSuffix: 'remaining-estimate-suggested'
                }
            ]
        });
    }, [
        fieldReasoning,
        data?.name,
        suggestedOriginalEstimate,
        suggestedRemainingEstimate,
        normalizedOriginalValue,
        normalizedRemainingValue,
        normalizedCurrentOriginalValue,
        normalizedCurrentRemainingValue,
        formatMessage
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: shouldRender
    });
    if (!shouldRender) return null;
    const value = (0, $golg3.getFieldTextCopy)({
        suggestedOriginalEstimate: suggestedOriginalEstimate,
        suggestedRemainingEstimate: suggestedRemainingEstimate,
        normalizedOriginalValue: normalizedOriginalValue,
        normalizedRemainingValue: normalizedRemainingValue,
        normalizedCurrentOriginalValue: normalizedCurrentOriginalValue,
        normalizedCurrentRemainingValue: normalizedCurrentRemainingValue,
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.remaining-time-estimate-field"
    }, value);
};
module.exports["TimeTrackingField"] = $0ceba58989ddaf10$export$1c882bff9d1eb3f8;

});

parcelRegister("9meBx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5ZtfK = parcelRequire("5ZtfK");

const $20e76d0eeacd6dc4$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.time-tracking-field.icon-label",
        defaultMessage: "Time tracking field"
    }
});
const $20e76d0eeacd6dc4$export$2bd7bc4060d82fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($20e76d0eeacd6dc4$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        label: formatMessage($20e76d0eeacd6dc4$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["TimeTrackingFieldIcon"] = $20e76d0eeacd6dc4$export$2bd7bc4060d82fb;

});

parcelRegister("dHxi0", function(module, exports) {

var $emY7T = parcelRequire("emY7T");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $bCxtA = parcelRequire("bCxtA");


var $92bnZ = parcelRequire("92bnZ");


var $4yZQ6 = parcelRequire("4yZQ6");


var $4xEYr = parcelRequire("4xEYr");


var $bNYTA = parcelRequire("bNYTA");


var $2EyVz = parcelRequire("2EyVz");

const $fa573d38d2e4aa35$var$messages = (0, $kSwu1.defineMessages)({
    assign: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.users-field.assign",
        defaultMessage: "Assign {userNames} to {fieldName}"
    },
    unassign: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.users-field.unassign",
        defaultMessage: "Unassign users from {fieldName}"
    }
});
const $fa573d38d2e4aa35$export$6d307bc561db97fc = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider, onInvalidAction: onInvalidAction })=>{
    (0, $6cFsl.di)((0, $bNYTA.useHydratedUsers));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fieldKey: fieldKey, fieldValue: fieldValue, fieldReasoning: fieldReasoning } = (0, $4yZQ6.getActionData)(action);
    const data = (0, $6SsN4.useFragment)((0, $emY7T.default), queryRef);
    const suggestedUserAccountIds = (0, $cozmU.useMemo)(()=>(0, $4xEYr.parseSuggestedAccountIds)(fieldValue), [
        fieldValue
    ]);
    // Determine if we need to hydrate: if any suggested id is not present in current field data
    const currentSelectedIds = (data?.selectedUsersConnection?.edges ?? []).map((edge)=>edge?.node?.accountId).filter((accountId)=>typeof accountId === 'string');
    const isFieldRenderable = data?.fieldId === fieldKey;
    const needsHydration = Boolean(isFieldRenderable && suggestedUserAccountIds.some((accountId_0)=>!currentSelectedIds.includes(accountId_0)));
    const hydratedData = (0, $bNYTA.useHydratedUsers)(suggestedUserAccountIds, needsHydration, onInvalidAction);
    const { users: users, isLoading: isLoading, error: error } = needsHydration && hydratedData ? {
        users: hydratedData.users,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        users: (data?.selectedUsersConnection?.edges ?? []).map((edge_0)=>edge_0?.node).filter(Boolean).map((userAccount)=>({
                accountId: userAccount?.accountId,
                name: userAccount?.name ?? null
            })),
        isLoading: false,
        error: null
    };
    const isAssignable = (users?.length ?? 0) > 0 && suggestedUserAccountIds.length > 0;
    const isNotFound = (users?.length ?? 0) === 0 && !isLoading && suggestedUserAccountIds.length > 0;
    const userNames = (()=>{
        const names = (users ?? []).map((user)=>user.name).filter(Boolean).sort();
        if (names.length <= 1) return names.join('');
        return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    })();
    const assignMessage = formatMessage($fa573d38d2e4aa35$var$messages.assign, {
        userNames: userNames,
        fieldName: data?.name
    });
    const unassignMessage = formatMessage($fa573d38d2e4aa35$var$messages.unassign, {
        fieldName: data?.name
    });
    const formattedMessage = isAssignable ? assignMessage : unassignMessage;
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCxtA.FieldTooltipContent), {
            reasoning: fieldReasoning,
            suggested: userNames,
            fieldName: data?.name
        }), [
        fieldReasoning,
        userNames,
        data?.name
    ]);
    (0, $92bnZ.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable && !isNotFound && !error
    });
    if (!isFieldRenderable || isNotFound || error) return null;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2EyVz.UsersFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.users-field"
    }, formattedMessage);
};
module.exports["UsersField"] = $fa573d38d2e4aa35$export$6d307bc561db97fc;

});

parcelRegister("fVBxJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fBqzD = parcelRequire("fBqzD");

const $77cbb9a8963ed134$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.users-field.icon-label",
        defaultMessage: "Users field icon"
    }
});
const $77cbb9a8963ed134$export$604891a7e8902ee6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UsersFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($77cbb9a8963ed134$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function UsersFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
        label: formatMessage($77cbb9a8963ed134$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["UsersFieldIcon"] = $77cbb9a8963ed134$export$604891a7e8902ee6;

});

parcelRegister("6sL6W", function(module, exports) {
/**
 * @generated SignedSource<<d24f8e478899f66e842d2dc4d4d9e33b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b85fe60255b02a0c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardHeader_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "JiraSingleLineTextField",
            "kind": "LinkedField",
            "name": "summaryField",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "text"
                }
            ]
        },
        {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ],
    "type": "JiraIssue"
};
$b85fe60255b02a0c$var$node.hash = "8d8b4a0dd0f004bf80742a321be87063";
var $b85fe60255b02a0c$export$2e2bcd8739ae039 = $b85fe60255b02a0c$var$node;
module.exports["default"] = $b85fe60255b02a0c$export$2e2bcd8739ae039;

});

parcelRegister("26N62", function(module, exports) {
/**
 * @generated SignedSource<<0a3acbd8055a080237a2d90b154934ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d4120da16d458e5e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldIdsOrAliases"
        }
    ],
    "kind": "Fragment",
    "name": "cardFieldsList_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "idsOrAliases",
                    "variableName": "fieldIdsOrAliases"
                },
                {
                    "kind": "Literal",
                    "name": "ignoreMissingFields",
                    "value": true
                }
            ],
            "kind": "LinkedField",
            "name": "fieldsByIdOrAlias",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "fieldId"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleLineTextField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "richTextField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleSelectUserPickerField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "usersField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "priorityField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "labelsField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "flagField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "datePickerField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "dateTimePickerField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "parentIssueField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "numberField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "timeTrackingField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "timeSpentField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "colorField_updateWorkItemFieldsActionRenderer"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "genericField_updateWorkItemFieldsActionRenderer"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$d4120da16d458e5e$var$node.hash = "0f54e478bb681c45db2546d20f4b3f2e";
var $d4120da16d458e5e$export$2e2bcd8739ae039 = $d4120da16d458e5e$var$node;
module.exports["default"] = $d4120da16d458e5e$export$2e2bcd8739ae039;

});

parcelRegister("i64u7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $b5ec7167d757f685$var$messages = (0, $kSwu1.defineMessages)({
    currentValue: {
        id: "update-work-item-fields-action-renderer.ui.action-card.rich-text-field.current-value",
        defaultMessage: "Current {name}"
    },
    suggestedValue: {
        id: "update-work-item-fields-action-renderer.ui.action-card.rich-text-field.suggested-value",
        defaultMessage: "Suggested update"
    }
});
const $b5ec7167d757f685$var$styles = {
    container: "_2Y7lL4NHnM",
    withTopSpace: "_0Of8r25zaO",
    withBorder: "_22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $b5ec7167d757f685$export$73daa61329af8a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { reasoning: reasoning, current: current, suggested: suggested, fieldName: fieldName, currentLabel: currentLabel, currentMaxLines: t1, suggestedLabel: suggestedLabel, suggestedMaxLines: t2, additionalSuggestions: t3 } = t0;
    const currentMaxLines = t1 === undefined ? 5 : t1;
    const suggestedMaxLines = t2 === undefined ? 10 : t2;
    let t4;
    if ($[0] !== t3) {
        t4 = t3 === undefined ? [] : t3;
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const additionalSuggestions = t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!reasoning && !current && !suggested) return null;
    let t5;
    if ($[2] !== reasoning) {
        t5 = reasoning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b5ec7167d757f685$var$styles.container,
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.reasoning"
        }, typeof reasoning === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, reasoning) : reasoning);
        $[2] = reasoning;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== current || $[5] !== currentLabel || $[6] !== currentMaxLines || $[7] !== fieldName || $[8] !== formatMessage || $[9] !== reasoning) {
        t6 = current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b5ec7167d757f685$var$styles.container, !!reasoning && $b5ec7167d757f685$var$styles.withTopSpace),
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.current"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, currentLabel ? currentLabel : formatMessage($b5ec7167d757f685$var$messages.currentValue, {
            name: fieldName?.toLowerCase() ?? ""
        })), typeof current === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: currentMaxLines
        }, current) : current));
        $[4] = current;
        $[5] = currentLabel;
        $[6] = currentMaxLines;
        $[7] = fieldName;
        $[8] = formatMessage;
        $[9] = reasoning;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== current || $[12] !== formatMessage || $[13] !== reasoning || $[14] !== suggested || $[15] !== suggestedLabel || $[16] !== suggestedMaxLines) {
        t7 = suggested && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b5ec7167d757f685$var$styles.container, (!!current || !!reasoning) && $b5ec7167d757f685$var$styles.withTopSpace, (!!current || !!reasoning) && $b5ec7167d757f685$var$styles.withBorder),
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.suggested"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, suggestedLabel ? suggestedLabel : formatMessage($b5ec7167d757f685$var$messages.suggestedValue)), typeof suggested === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: suggestedMaxLines
        }, suggested) : suggested));
        $[11] = current;
        $[12] = formatMessage;
        $[13] = reasoning;
        $[14] = suggested;
        $[15] = suggestedLabel;
        $[16] = suggestedMaxLines;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== additionalSuggestions || $[19] !== current || $[20] !== formatMessage || $[21] !== reasoning) {
        let t9;
        if ($[23] !== current || $[24] !== formatMessage || $[25] !== reasoning) {
            t9 = (t10)=>{
                const { suggested: suggested_0, label: label, maxLines: t11, testIdSuffix: testIdSuffix } = t10;
                const maxLines = t11 === undefined ? 10 : t11;
                return suggested_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: (0, $w6R6I.cx)($b5ec7167d757f685$var$styles.container, (!!current || !!suggested_0 || !!reasoning) && $b5ec7167d757f685$var$styles.withTopSpace, (!!current || !!suggested_0 || !!reasoning) && $b5ec7167d757f685$var$styles.withBorder),
                    testId: $b5ec7167d757f685$var$getAdditionalTestId(testIdSuffix)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    space: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                    size: "xsmall"
                }, label ? label : formatMessage($b5ec7167d757f685$var$messages.suggestedValue)), typeof suggested_0 === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    maxLines: maxLines
                }, suggested_0) : suggested_0));
            };
            $[23] = current;
            $[24] = formatMessage;
            $[25] = reasoning;
            $[26] = t9;
        } else t9 = $[26];
        t8 = additionalSuggestions.map(t9);
        $[18] = additionalSuggestions;
        $[19] = current;
        $[20] = formatMessage;
        $[21] = reasoning;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[27] !== t5 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content",
            space: "space.200"
        }, t5, t6, t7, t8);
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    return t9;
} : ({ reasoning: reasoning, current: current, suggested: suggested, fieldName: fieldName, currentLabel: currentLabel, currentMaxLines: currentMaxLines = 5, suggestedLabel: suggestedLabel, suggestedMaxLines: suggestedMaxLines = 10, additionalSuggestions: additionalSuggestions = [] })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!reasoning && !current && !suggested) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content",
        space: "space.200"
    }, reasoning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b5ec7167d757f685$var$styles.container,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.reasoning"
    }, typeof reasoning === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, reasoning) : reasoning), current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b5ec7167d757f685$var$styles.container, !!reasoning && $b5ec7167d757f685$var$styles.withTopSpace),
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.current"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, currentLabel ? currentLabel : formatMessage($b5ec7167d757f685$var$messages.currentValue, {
        name: fieldName?.toLowerCase() ?? ''
    })), typeof current === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: currentMaxLines
    }, current) : current)), suggested && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b5ec7167d757f685$var$styles.container, (!!current || !!reasoning) && $b5ec7167d757f685$var$styles.withTopSpace, (!!current || !!reasoning) && $b5ec7167d757f685$var$styles.withBorder),
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.suggested"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, suggestedLabel ? suggestedLabel : formatMessage($b5ec7167d757f685$var$messages.suggestedValue)), typeof suggested === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: suggestedMaxLines
    }, suggested) : suggested)), additionalSuggestions.map(({ suggested: suggested_0, label: label, maxLines: maxLines = 10, testIdSuffix: testIdSuffix })=>suggested_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b5ec7167d757f685$var$styles.container, (!!current || !!suggested_0 || !!reasoning) && $b5ec7167d757f685$var$styles.withTopSpace, (!!current || !!suggested_0 || !!reasoning) && $b5ec7167d757f685$var$styles.withBorder),
            testId: $b5ec7167d757f685$var$getAdditionalTestId(testIdSuffix)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, label ? label : formatMessage($b5ec7167d757f685$var$messages.suggestedValue)), typeof suggested_0 === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: maxLines
        }, suggested_0) : suggested_0))));
};
const $b5ec7167d757f685$var$getAdditionalTestId = (testIdSuffix = '')=>{
    const suffix = testIdSuffix ? `.${testIdSuffix}` : '';
    return `update-work-item-fields-action-renderer.ui.action-card.card-fields-list.field-tooltip-content.additional-suggestion${suffix}`;
};
module.exports["FieldTooltipContent"] = $b5ec7167d757f685$export$73daa61329af8a4;

});

parcelRegister("33Z0B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $50b12226cbd9f6fb$export$96debe0893d09d09 = (targetFieldKey)=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const [customTooltipContent, setCustomTooltipContent] = (0, $cozmU.useState)(null);
    const providerRef = (0, $cozmU.useRef)(null);
    const registerTooltipProvider = (0, $cozmU.useCallback)((fieldId, provider)=>{
        if (fieldId !== targetFieldKey) return;
        if (provider == null) {
            if (providerRef.current) {
                providerRef.current = null;
                setCustomTooltipContent(null);
            }
            return;
        }
        providerRef.current = provider;
        if (isHovered || isFocused) try {
            setCustomTooltipContent(provider() ?? null);
        } catch  {
            setCustomTooltipContent(null);
        }
    }, [
        targetFieldKey,
        isHovered,
        isFocused
    ]);
    // Recompute on visibility state changes.
    (0, $cozmU.useEffect)(()=>{
        if (isHovered || isFocused) {
            if (providerRef.current) try {
                setCustomTooltipContent(providerRef.current() ?? null);
            } catch  {
                setCustomTooltipContent(null);
            }
            else setCustomTooltipContent(null);
        } else setCustomTooltipContent(null);
    }, [
        isHovered,
        isFocused
    ]);
    const rootHoverHandlers = {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    };
    const focusHandlers = {
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    };
    return {
        isHovered: isHovered,
        isFocused: isFocused,
        tooltipContent: customTooltipContent,
        registerTooltipProvider: registerTooltipProvider,
        rootHoverHandlers: rootHoverHandlers,
        focusHandlers: focusHandlers
    };
};
module.exports["useFieldTooltip"] = $50b12226cbd9f6fb$export$96debe0893d09d09;

});

parcelRegister("84bng", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eyfek = parcelRequire("eyfek");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");

const $37a5eac99e234fee$var$messages = (0, $kSwu1.defineMessages)({
    updateWorkItemColor: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-color-field.update-work-item-color",
        defaultMessage: "Update work item color to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-color-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $37a5eac99e234fee$export$b865d4358897bb17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $eyfek.default), queryRef);
    const getColorLabel = $37a5eac99e234fee$var$_temp2;
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isUpdatingAction = Boolean(action?.data?.fieldValue);
    let t1;
    if ($[0] !== data) {
        t1 = data?.color?.colorKey ? getColorLabel(data.color.colorKey) : undefined;
        $[0] = data;
        $[1] = t1;
    } else t1 = $[1];
    const currentColorLabel = t1;
    let t2;
    if ($[2] !== action) {
        t2 = action?.data?.fieldValue ? getColorLabel(String(action.data.fieldValue)) : undefined;
        $[2] = action;
        $[3] = t2;
    } else t2 = $[3];
    const suggestedColorLabel = t2;
    const colorLabel = suggestedColorLabel || "";
    let t3;
    if ($[4] !== action?.data?.reasoning || $[5] !== currentColorLabel || $[6] !== data?.name || $[7] !== suggestedColorLabel) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
                reasoning: action?.data?.reasoning,
                fieldName: data?.name,
                current: currentColorLabel,
                suggested: suggestedColorLabel
            });
        $[4] = action?.data?.reasoning;
        $[5] = currentColorLabel;
        $[6] = data?.name;
        $[7] = suggestedColorLabel;
        $[8] = t3;
    } else t3 = $[8];
    action?.data?.reasoning;
    data?.name;
    const toolTipContentProvider = t3;
    const t4 = action?.data?.fieldKey;
    let t5;
    if ($[9] !== isFieldRenderable || $[10] !== registerTooltipProvider || $[11] !== t4 || $[12] !== toolTipContentProvider) {
        t5 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: t4,
            provider: toolTipContentProvider,
            enabled: isFieldRenderable
        };
        $[9] = isFieldRenderable;
        $[10] = registerTooltipProvider;
        $[11] = t4;
        $[12] = toolTipContentProvider;
        $[13] = t5;
    } else t5 = $[13];
    (0, $agB5R.useRegisterTooltipContentProvider)(t5);
    if (!data?.fieldId || !data?.name || !isFieldRenderable) return null;
    const t6 = isUpdatingAction ? $37a5eac99e234fee$var$messages.updateWorkItemColor : $37a5eac99e234fee$var$messages.clearAction;
    let t7;
    if ($[14] !== colorLabel || $[15] !== data?.name || $[16] !== formatMessage || $[17] !== t6) {
        t7 = formatMessage(t6, {
            fieldName: data?.name?.toLowerCase(),
            fieldValue: colorLabel
        });
        $[14] = colorLabel;
        $[15] = data?.name;
        $[16] = formatMessage;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.jira-color-field"
        }, t7);
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $eyfek.default), queryRef);
    const getColorLabel = (colorKey)=>colorKey.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (char)=>char.toUpperCase());
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isUpdatingAction = Boolean(action?.data?.fieldValue);
    const currentColorLabel = data?.color?.colorKey ? getColorLabel(data.color.colorKey) : undefined;
    const suggestedColorLabel = action?.data?.fieldValue ? getColorLabel(String(action.data.fieldValue)) : undefined;
    const colorLabel = suggestedColorLabel || '';
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            fieldName: data?.name,
            current: currentColorLabel,
            suggested: suggestedColorLabel
        }), [
        action?.data?.reasoning,
        data?.name,
        currentColorLabel,
        suggestedColorLabel
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!data?.fieldId || !data?.name || !isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.jira-color-field"
    }, formatMessage(isUpdatingAction ? $37a5eac99e234fee$var$messages.updateWorkItemColor : $37a5eac99e234fee$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase(),
        fieldValue: colorLabel
    }));
};
function $37a5eac99e234fee$var$_temp(char) {
    return char.toUpperCase();
}
function $37a5eac99e234fee$var$_temp2(colorKey) {
    return colorKey.toLowerCase().replace(/_/g, " ").replace(/^\w/, $37a5eac99e234fee$var$_temp);
}
module.exports["ColorField"] = $37a5eac99e234fee$export$b865d4358897bb17;

});

parcelRegister("hx6zx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iqP6y = parcelRequire("iqP6y");

const $6681224d77c89d6f$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-color-field.icon-label",
        defaultMessage: "Color field icon"
    }
});
const $6681224d77c89d6f$export$eb83eed9be8a6ec4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ColorFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($6681224d77c89d6f$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqP6y))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function ColorFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqP6y))), {
        label: formatMessage($6681224d77c89d6f$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["ColorFieldIcon"] = $6681224d77c89d6f$export$eb83eed9be8a6ec4;

});

parcelRegister("dP9dm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");

const $90b533b8c6362b49$var$messages = (0, $kSwu1.defineMessages)({
    action: {
        id: "update-work-item-fields-action-renderer.ui.action-card.flag-field.comment.non-final",
        defaultMessage: "Add comment"
    }
});
const $90b533b8c6362b49$export$d688afa8f735de41 = ({ action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isFieldRenderable = action?.data?.fieldKey === 'comment';
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            suggested: action?.data?.fieldValue !== undefined && action?.data?.fieldValue !== null ? String(action.data.fieldValue) : undefined
        }), [
        action?.data?.fieldValue,
        action?.data?.reasoning
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable) return null;
    const comment = String(action.data.fieldValue)?.trim();
    if (!comment) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.comment-field"
    }, formatMessage($90b533b8c6362b49$var$messages.action));
};
module.exports["CommentField"] = $90b533b8c6362b49$export$d688afa8f735de41;

});

parcelRegister("XVlOg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eDtFr = parcelRequire("eDtFr");

const $e3805e956b740b31$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.comment-field.label.non-final",
        defaultMessage: "Comment field icon"
    }
});
const $e3805e956b740b31$export$6d46c9121b9582b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($e3805e956b740b31$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function CommentFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
        label: formatMessage($e3805e956b740b31$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["CommentFieldIcon"] = $e3805e956b740b31$export$6d46c9121b9582b1;

});

parcelRegister("4J6wZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hzAn1 = parcelRequire("hzAn1");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $caPVv = parcelRequire("caPVv");

const $74ed360bb64da5f8$var$messages = (0, $kSwu1.defineMessages)({
    set: {
        id: "update-work-item-fields-action-renderer.ui.action-card.date-picker-field.set",
        defaultMessage: "Set {name} to {value}"
    },
    unset: {
        id: "update-work-item-fields-action-renderer.ui.action-card.date-picker-field.unset",
        defaultMessage: "Remove date from {name}"
    }
});
const $74ed360bb64da5f8$export$34dc4cfa15ead1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $hzAn1.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== action.data.fieldKey || $[1] !== action.data.fieldValue || $[2] !== data || $[3] !== formatDate || $[4] !== formatMessage) {
        const fieldName = data?.name ? data.name.toLowerCase() : action.data.fieldKey;
        const formattedDate = (0, $caPVv.formatSuggestedDate)(action.data.fieldValue, formatDate);
        T0 = (0, $4aRua.Text);
        t1 = "color.text.subtle";
        t2 = 1;
        t3 = "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.date-picker-field";
        t4 = formattedDate ? formatMessage($74ed360bb64da5f8$var$messages.set, {
            name: fieldName,
            value: formattedDate
        }) : formatMessage($74ed360bb64da5f8$var$messages.unset, {
            name: fieldName
        });
        $[0] = action.data.fieldKey;
        $[1] = action.data.fieldValue;
        $[2] = data;
        $[3] = formatDate;
        $[4] = formatMessage;
        $[5] = T0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else {
        T0 = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
    }
    let t5;
    if ($[10] !== T0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            color: t1,
            maxLines: t2,
            testId: t3
        }, t4);
        $[10] = T0;
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $hzAn1.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    const fieldName = data?.name ? data.name.toLowerCase() : action.data.fieldKey;
    const formattedDate = (0, $caPVv.formatSuggestedDate)(action.data.fieldValue, formatDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.date-picker-field"
    }, formattedDate ? formatMessage($74ed360bb64da5f8$var$messages.set, {
        name: fieldName,
        value: formattedDate
    }) : formatMessage($74ed360bb64da5f8$var$messages.unset, {
        name: fieldName
    }));
};
module.exports["DatePickerField"] = $74ed360bb64da5f8$export$34dc4cfa15ead1;

});

parcelRegister("9fEbx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $824lD = parcelRequire("824lD");

const $c4625022380da1fb$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.date-picker-field.icon-label",
        defaultMessage: "Date picker field icon"
    }
});
const $c4625022380da1fb$export$50a3c68589054367 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DatePickerFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($c4625022380da1fb$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function DatePickerFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
        label: formatMessage($c4625022380da1fb$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["DatePickerFieldIcon"] = $c4625022380da1fb$export$50a3c68589054367;

});

parcelRegister("bdZ3v", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $8eljq = parcelRequire("8eljq");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $cfM17 = parcelRequire("cfM17");

const $937b8f6a079ed639$var$messages = (0, $kSwu1.defineMessages)({
    setScheduledDate: {
        id: "update-work-item-fields-action-renderer.ui.action-card.date-picker-field.set-scheduled-date",
        defaultMessage: "Set {name} to {value}"
    },
    unset: {
        id: "update-work-item-fields-action-renderer.ui.action-card.date-picker-field.unset",
        defaultMessage: "Remove date from {name}"
    }
});
const $937b8f6a079ed639$export$9b9f2b8abb7a04e5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $8eljq.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    const rawValue = action.data.fieldValue;
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== data?.name || $[1] !== formatDate || $[2] !== formatMessage || $[3] !== rawValue) {
        const value = (0, $cfM17.formatSuggestedDateTime)(rawValue, formatDate);
        T0 = (0, $4aRua.Text);
        t1 = "color.text.subtle";
        t2 = 1;
        t3 = "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.date-time-picker-field";
        t4 = value ? formatMessage($937b8f6a079ed639$var$messages.setScheduledDate, {
            name: data?.name.toLowerCase(),
            value: value
        }) : formatMessage($937b8f6a079ed639$var$messages.unset, {
            name: data?.name.toLowerCase()
        });
        $[0] = data?.name;
        $[1] = formatDate;
        $[2] = formatMessage;
        $[3] = rawValue;
        $[4] = T0;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else {
        T0 = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
        t4 = $[8];
    }
    let t5;
    if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            color: t1,
            maxLines: t2,
            testId: t3
        }, t4);
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $8eljq.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    const rawValue = action.data.fieldValue;
    const value = (0, $cfM17.formatSuggestedDateTime)(rawValue, formatDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.date-time-picker-field"
    }, value ? formatMessage($937b8f6a079ed639$var$messages.setScheduledDate, {
        name: data?.name.toLowerCase(),
        value: value
    }) : formatMessage($937b8f6a079ed639$var$messages.unset, {
        name: data?.name.toLowerCase()
    }));
};
module.exports["DateTimePickerField"] = $937b8f6a079ed639$export$9b9f2b8abb7a04e5;

});

parcelRegister("gZG3v", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5ZtfK = parcelRequire("5ZtfK");

const $e77d8daf454341f0$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.date-time-picker-field.icon-label",
        defaultMessage: "Date time picker field icon"
    }
});
const $e77d8daf454341f0$export$9b0d4b8d0d256e40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DateTimePickerFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($e77d8daf454341f0$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function DateTimePickerFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        label: formatMessage($e77d8daf454341f0$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["DateTimePickerFieldIcon"] = $e77d8daf454341f0$export$9b0d4b8d0d256e40;

});

parcelRegister("24pye", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kzUKj = parcelRequire("kzUKj");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $ihrZg = parcelRequire("ihrZg");

const $54e46bc4e4ab7f5e$var$messages = (0, $kSwu1.defineMessages)({
    flagged: {
        id: "update-work-item-fields-action-renderer.ui.action-card.flag-field.flagged",
        defaultMessage: "Add flag"
    },
    unflagged: {
        id: "update-work-item-fields-action-renderer.ui.action-card.flag-field.unflagged",
        defaultMessage: "Remove flag"
    }
});
const $54e46bc4e4ab7f5e$export$1186cf6e3d8a37ad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $kzUKj.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    let t1;
    if ($[0] !== action.data.fieldValue) {
        t1 = (0, $ihrZg.isFlagged)(action.data.fieldValue);
        $[0] = action.data.fieldValue;
        $[1] = t1;
    } else t1 = $[1];
    const flagged = t1;
    let t2;
    if ($[2] !== flagged || $[3] !== formatMessage) {
        t2 = flagged ? formatMessage($54e46bc4e4ab7f5e$var$messages.flagged) : formatMessage($54e46bc4e4ab7f5e$var$messages.unflagged);
        $[2] = flagged;
        $[3] = formatMessage;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.flag-field"
        }, t2);
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $kzUKj.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    const flagged = (0, $ihrZg.isFlagged)(action.data.fieldValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.flag-field"
    }, flagged ? formatMessage($54e46bc4e4ab7f5e$var$messages.flagged) : formatMessage($54e46bc4e4ab7f5e$var$messages.unflagged));
};
module.exports["FlagField"] = $54e46bc4e4ab7f5e$export$1186cf6e3d8a37ad;

});

parcelRegister("j7N3D", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gMfOo = parcelRequire("gMfOo");

const $71449fc7eb494afb$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.flag-field.icon-label",
        defaultMessage: "Flag field icon"
    }
});
const $71449fc7eb494afb$export$4b802cc289729e33 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($71449fc7eb494afb$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMfOo))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function FlagFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMfOo))), {
        label: formatMessage($71449fc7eb494afb$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["FlagFieldIcon"] = $71449fc7eb494afb$export$4b802cc289729e33;

});

parcelRegister("8i2Nw", function(module, exports) {

var $ilJfi = parcelRequire("ilJfi");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");


var $u9Ee1 = parcelRequire("u9Ee1");

const $58275520b17d6611$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.generic-field.updateAction",
        defaultMessage: "Update {fieldName} to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.generic-field.clearAction",
        defaultMessage: "Clear {fieldName}"
    }
});
const $58275520b17d6611$export$a49ce3bbbd0d81e5 = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $ilJfi.default), queryRef);
    const isFieldRenderable = data.fieldId === action?.data?.fieldKey;
    const isUpdateAction = isFieldRenderable && !!action?.data?.fieldValue;
    const formattedMessage = isUpdateAction ? formatMessage($58275520b17d6611$var$messages.updateAction, {
        fieldName: (0, $u9Ee1.sanitizeFieldName)(data?.name),
        fieldValue: (0, $u9Ee1.sanitizeFieldValue)(action?.data?.fieldValue)
    }) : formatMessage($58275520b17d6611$var$messages.clearAction, {
        fieldName: (0, $u9Ee1.sanitizeFieldName)(data?.name)
    });
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            fieldName: data?.name,
            suggested: action?.data?.fieldValue ? (0, $u9Ee1.sanitizeFieldValue)(action.data.fieldValue) : undefined
        }), [
        action.data.fieldValue,
        action.data?.reasoning,
        data?.name
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable || !data?.name) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.generic-field"
    }, formattedMessage);
};
module.exports["GenericField"] = $58275520b17d6611$export$a49ce3bbbd0d81e5;

});

parcelRegister("8msbG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3DMf9 = parcelRequire("3DMf9");

const $45b044db17ab42d0$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.generic-field.icon-label",
        defaultMessage: "Generic field icon"
    }
});
const $45b044db17ab42d0$export$18ac7b7bf9261c40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GenericFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($45b044db17ab42d0$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function GenericFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
        label: formatMessage($45b044db17ab42d0$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["GenericFieldIcon"] = $45b044db17ab42d0$export$18ac7b7bf9261c40;

});

parcelRegister("bPDZa", function(module, exports) {

var $hnFrp = parcelRequire("hnFrp");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $IOtUu = parcelRequire("IOtUu");


var $3DjKS = parcelRequire("3DjKS");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");


var $cCmlF = parcelRequire("cCmlF");

const $ec635d2c3552ed0f$var$messages = (0, $kSwu1.defineMessages)({
    suggestedLabelsToAdd: {
        id: "update-work-item-fields-action-renderer.ui.action-card.labels-field.suggestedLabelsToAdd.non-final",
        defaultMessage: "Suggested labels to add"
    },
    suggestedLabelsToRemove: {
        id: "update-work-item-fields-action-renderer.ui.action-card.labels-field.suggestedLabelsToRemove.non-final",
        defaultMessage: "Suggested labels to remove"
    },
    updateLabels: {
        id: "update-work-item-fields-action-renderer.ui.action-card.labels-field.updateLabels.non-final",
        defaultMessage: "Update labels"
    }
});
const $ec635d2c3552ed0f$export$b5a86c9a622796ff = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $hnFrp.default), queryRef);
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey && action?.data?.fieldKey === 'labels';
    const suggestedLabels = (0, $cozmU.useMemo)(()=>(0, $cCmlF.parseLabels)(action.data.fieldValue), [
        action?.data?.fieldValue
    ]);
    const currentLabels = (0, $cozmU.useMemo)(()=>data?.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name) ?? [], [
        data?.selectedLabelsConnection
    ]);
    const addedLabels = (0, $cozmU.useMemo)(()=>suggestedLabels?.filter((label)=>!currentLabels?.includes(label ?? '')) ?? [], [
        suggestedLabels,
        currentLabels
    ]);
    const removedLabels = (0, $cozmU.useMemo)(()=>currentLabels.filter((label_0)=>!suggestedLabels?.includes(label_0 ?? '')), [
        currentLabels,
        suggestedLabels
    ]);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        const currentLabels_0 = data?.selectedLabelsConnection?.edges?.map((edge_0)=>edge_0?.node?.name) ?? [];
        const current = currentLabels_0.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, currentLabels_0.filter((label_1)=>label_1 !== undefined && label_1 !== null).map((label_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: label_2,
                text: label_2,
                isRemovable: false
            }))) : null;
        const suggestedToAdd = addedLabels?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, addedLabels.filter((label_3)=>label_3 !== undefined && label_3 !== null).map((label_4)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: label_4,
                text: label_4,
                isRemovable: false
            }))) : null;
        const suggestedToRemove = removedLabels?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, removedLabels.filter((label_5)=>label_5 !== undefined && label_5 !== null).map((label_6)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
                key: label_6,
                text: label_6,
                isRemovable: false
            }))) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            current: current,
            additionalSuggestions: [
                {
                    suggested: addedLabels.length > 0 ? suggestedToAdd : null,
                    label: formatMessage($ec635d2c3552ed0f$var$messages.suggestedLabelsToAdd),
                    testIdSuffix: 'suggested-labels-to-add'
                },
                {
                    suggested: removedLabels.length > 0 ? suggestedToRemove : null,
                    label: formatMessage($ec635d2c3552ed0f$var$messages.suggestedLabelsToRemove),
                    testIdSuffix: 'suggested-labels-to-remove'
                }
            ],
            fieldName: data?.name
        });
    }, [
        action?.data?.reasoning,
        data?.name,
        data?.selectedLabelsConnection?.edges,
        formatMessage,
        addedLabels,
        removedLabels
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.labels-field"
    }, formatMessage($ec635d2c3552ed0f$var$messages.updateLabels));
};
module.exports["LabelsField"] = $ec635d2c3552ed0f$export$b5a86c9a622796ff;

});

parcelRegister("juWfe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $EzOZy = parcelRequire("EzOZy");

const $9d9c3173fa58a172$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.labels-field.icon-label",
        defaultMessage: "Labels field icon"
    }
});
const $9d9c3173fa58a172$export$53bf460ad929f103 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelsFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($9d9c3173fa58a172$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function LabelsFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
        label: formatMessage($9d9c3173fa58a172$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["LabelsFieldIcon"] = $9d9c3173fa58a172$export$53bf460ad929f103;

});

parcelRegister("fUHlZ", function(module, exports) {

var $elZLk = parcelRequire("elZLk");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");

const $56a2914104214b1b$var$messages = (0, $kSwu1.defineMessages)({
    setAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-number-field.setStorypoints",
        defaultMessage: "Set {fieldName} to {fieldValue}"
    },
    clearAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-number-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $56a2914104214b1b$export$63c5fa0b2fdccd2e = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $elZLk.default), queryRef);
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isUpdatingAction = Boolean(action?.data?.fieldValue);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            fieldName: data?.name,
            current: data?.number ? String(data.number) : undefined,
            suggested: action?.data?.fieldValue ? String(action.data.fieldValue) : undefined
        }), [
        action.data.fieldValue,
        action.data?.reasoning,
        data?.name,
        data?.number
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!data?.fieldId || !data?.name || data?.fieldId !== action.data.fieldKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.jira-number-field"
    }, isUpdatingAction ? formatMessage($56a2914104214b1b$var$messages.setAction, {
        fieldName: data?.name?.toLowerCase(),
        fieldValue: action?.data?.fieldValue ? String(action.data.fieldValue) : undefined
    }) : formatMessage($56a2914104214b1b$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["NumberField"] = $56a2914104214b1b$export$63c5fa0b2fdccd2e;

});

parcelRegister("dZiPN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3p3yp = parcelRequire("3p3yp");

const $05ee8bd2506b447e$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.jira-number-field.icon-label",
        defaultMessage: "Number field icon"
    }
});
const $05ee8bd2506b447e$export$ba7020b38dce665e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NumberFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($05ee8bd2506b447e$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3p3yp))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function NumberFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3p3yp))), {
        label: formatMessage($05ee8bd2506b447e$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["NumberFieldIcon"] = $05ee8bd2506b447e$export$ba7020b38dce665e;

});

parcelRegister("atHKC", function(module, exports) {

var $afI4f = parcelRequire("afI4f");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");


var $lcIbO = parcelRequire("lcIbO");


var $8lRJP = parcelRequire("8lRJP");

const $057107e6c4028432$var$messages = (0, $kSwu1.defineMessages)({
    addToParentWorkItem: {
        id: "update-work-item-fields-action-renderer.ui.action-card.parent-issue-field.addToParentWorkItem",
        defaultMessage: "Add to parent work item"
    },
    unassign: {
        id: "update-work-item-fields-action-renderer.ui.action-card.parent-issue-field.unassign",
        defaultMessage: "Unassign parent"
    }
});
const $057107e6c4028432$export$38904296a16cf133 = ({ cloudId: cloudId, queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    (0, $6cFsl.di)((0, $8lRJP.useHydratedIssue));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $afI4f.default), queryRef);
    const proposedParentId = typeof action?.data?.fieldValue === 'string' ? action.data.fieldValue.trim() : action?.data?.fieldValue?.toString() || null;
    const isFieldRenderable = data?.fieldId === 'parent' && data.fieldId === action?.data?.fieldKey;
    const needsHydration = Boolean(isFieldRenderable && proposedParentId && proposedParentId !== data?.parentIssue?.issueId);
    const hydratedData = (0, $8lRJP.useHydratedIssue)(cloudId, proposedParentId, needsHydration);
    const parentIssue = needsHydration && hydratedData ? {
        issue: hydratedData.issue,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        issue: data?.parentIssue,
        isLoading: false,
        error: null
    };
    const { issue: issue, isLoading: isLoading, error: error } = parentIssue;
    const isAssignable = (issue || isLoading) && proposedParentId;
    const isNotFound = !issue && !isLoading && proposedParentId;
    const formattedMessage = isAssignable ? formatMessage($057107e6c4028432$var$messages.addToParentWorkItem, {
        value: isLoading ? '' : `${issue?.key}: ${issue?.summary}`
    }) : formatMessage($057107e6c4028432$var$messages.unassign);
    // Compute tooltip content provider logic
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        if (!isFieldRenderable) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            current: data?.parentIssue ? `${data.parentIssue.key}: ${data.parentIssue.summary}` : undefined,
            suggested: issue ? `${issue?.key}: ${issue?.summary}` : undefined,
            fieldName: data?.name
        });
    }, [
        action?.data?.reasoning,
        data.parentIssue,
        data?.name,
        isFieldRenderable,
        issue
    ]);
    // Register tooltip content provider
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable || isNotFound || error) return null;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lcIbO.ParentIssueFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.parent-issue-field"
    }, formattedMessage);
};
module.exports["ParentIssueField"] = $057107e6c4028432$export$38904296a16cf133;

});

parcelRegister("5npJQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4THFE = parcelRequire("4THFE");

const $026f66449b66ad98$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.parent-issue-field.icon-label",
        defaultMessage: "Parent issue field icon"
    }
});
const $026f66449b66ad98$export$b112572493a09818 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ParentIssueFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($026f66449b66ad98$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function ParentIssueFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
        label: formatMessage($026f66449b66ad98$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["ParentIssueFieldIcon"] = $026f66449b66ad98$export$b112572493a09818;

});

parcelRegister("kxNz2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $7JqUm = parcelRequire("7JqUm");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");

const $c3b04ca968d6f850$var$messages = (0, $kSwu1.defineMessages)({
    action: {
        id: "update-work-item-fields-action-renderer.ui.action-card.priority-field.action",
        defaultMessage: "Set priority to {value}"
    },
    setPriority: {
        id: "update-work-item-fields-action-renderer.ui.action-card.priority-field.setPriority",
        defaultMessage: "Set priority from {originalValue} to {value}"
    }
});
const $c3b04ca968d6f850$export$f1adf0a84590c483 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { queryRef: queryRef, action: action } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $7JqUm.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    const t1 = action.data.fieldValue ?? "";
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== data?.priority?.name || $[1] !== formatMessage || $[2] !== t1) {
        const value = String(t1).trim();
        T0 = (0, $4aRua.Text);
        t2 = "color.text.subtle";
        t3 = 1;
        t4 = "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.priority-field";
        t5 = data?.priority?.name ? formatMessage($c3b04ca968d6f850$var$messages.setPriority, {
            originalValue: data?.priority?.name,
            value: value
        }) : formatMessage($c3b04ca968d6f850$var$messages.action, {
            value: value
        });
        $[0] = data?.priority?.name;
        $[1] = formatMessage;
        $[2] = t1;
        $[3] = T0;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else {
        T0 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
        t5 = $[7];
    }
    let t6;
    if ($[8] !== T0 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            color: t2,
            maxLines: t3,
            testId: t4
        }, t5);
        $[8] = T0;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $7JqUm.default), queryRef);
    if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) return null;
    const value = String(action.data.fieldValue ?? '').trim();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.priority-field"
    }, data?.priority?.name ? formatMessage($c3b04ca968d6f850$var$messages.setPriority, {
        originalValue: data?.priority?.name,
        value: value
    }) : formatMessage($c3b04ca968d6f850$var$messages.action, {
        value: value
    }));
};
module.exports["PriorityField"] = $c3b04ca968d6f850$export$f1adf0a84590c483;

});

parcelRegister("hmppd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lCTy3 = parcelRequire("lCTy3");

const $ac07bb2833513399$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.priority-field.icon-label",
        defaultMessage: "Priority field icon"
    }
});
const $ac07bb2833513399$export$2c0601a1439a407a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PriorityFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($ac07bb2833513399$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function PriorityFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
        label: formatMessage($ac07bb2833513399$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["PriorityFieldIcon"] = $ac07bb2833513399$export$2c0601a1439a407a;

});

parcelRegister("2uuCi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1B9Aq = parcelRequire("1B9Aq");

const $660c74a701ad4c02$var$styles = {
    root: "_0bjKvDzXzM _0KLXru7Cj1 _0Of8r2NHnM _1wydGWNHnM _2Zuz6QPgdg _1ZnuxbPgdg _2OUyjtGk8v _1EqgXlBfNa"
}; // Taken from the @atlaskit/tooltip customisation example
const $660c74a701ad4c02$export$294333047ae80f88 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ReasoningTooltip(t0, ref) {
    const $ = (0, $bDgLe.c)(11);
    let children;
    let className;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = rest;
    } else {
        children = $[1];
        className = $[2];
        rest = $[3];
    }
    let t1;
    if ($[4] !== className) {
        t1 = (0, $hekY6.default)([
            $660c74a701ad4c02$var$styles.root,
            className
        ]);
        $[4] = className;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $1B9Aq.default), {
            ...rest,
            className: t1,
            ref: ref
        }, children);
        $[6] = children;
        $[7] = ref;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function ReasoningTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ $cozmU.createElement((0, $1B9Aq.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hekY6.default)([
            $660c74a701ad4c02$var$styles.root,
            className
        ]),
        ref: ref
    }, children);
});
module.exports["ReasoningTooltip"] = $660c74a701ad4c02$export$294333047ae80f88;

});

parcelRegister("zn4gW", function(module, exports) {

var $cv7iN = parcelRequire("cv7iN");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");

const $12a3c31a43d2be96$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.rich-text-field.update-action",
        defaultMessage: "Update {fieldName}"
    },
    clearAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.rich-text-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $12a3c31a43d2be96$export$b3ef8585d8cbf390 = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $cv7iN.default), queryRef);
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isUpdatingAction = Boolean(action?.data?.fieldValue);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        if (!isFieldRenderable) return null;
        const currentPlainText = data?.richText?.adfValue?.convertedPlainText?.plainText;
        const isTruncated = data?.richText?.adfValue?.convertedPlainText?.isTruncated;
        const current = currentPlainText ? `${currentPlainText}${isTruncated ? '...' : ''}` : undefined;
        const suggested = action?.data?.fieldValue !== undefined && action?.data?.fieldValue !== null ? String(action.data.fieldValue) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            current: current,
            suggested: suggested,
            fieldName: data?.name
        });
    }, [
        action.data.fieldValue,
        action.data?.reasoning,
        data?.name,
        data?.richText?.adfValue?.convertedPlainText?.isTruncated,
        data?.richText?.adfValue?.convertedPlainText?.plainText,
        isFieldRenderable
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!isFieldRenderable) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.rich-text-field"
    }, formatMessage(isUpdatingAction ? $12a3c31a43d2be96$var$messages.updateAction : $12a3c31a43d2be96$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["RichTextField"] = $12a3c31a43d2be96$export$b3ef8585d8cbf390;

});

parcelRegister("2fohj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $f922E = parcelRequire("f922E");

const $7fce5fe67a4bbc34$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.rich-text-field.icon-label",
        defaultMessage: "Rich text field icon"
    }
});
const $7fce5fe67a4bbc34$export$ea984df189348ddd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RichTextFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($7fce5fe67a4bbc34$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function RichTextFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
        label: formatMessage($7fce5fe67a4bbc34$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["RichTextFieldIcon"] = $7fce5fe67a4bbc34$export$ea984df189348ddd;

});

parcelRegister("eG3i6", function(module, exports) {

var $dTSq1 = parcelRequire("dTSq1");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");

const $afd98a526d204866$var$messages = (0, $kSwu1.defineMessages)({
    updateAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-line-text-field.update-action",
        defaultMessage: "Update {fieldName}"
    },
    clearAction: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-line-text-field.clear-action",
        defaultMessage: "Clear {fieldName}"
    }
});
const $afd98a526d204866$export$2df72f2d4f169d3a = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $dTSq1.default), queryRef);
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isUpdatingAction = Boolean(action?.data?.fieldValue);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            fieldName: data?.name,
            current: data?.text,
            suggested: action?.data?.fieldValue ? String(action.data.fieldValue) : undefined
        }), [
        action.data.fieldValue,
        action.data?.reasoning,
        data?.name,
        data?.text
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable
    });
    if (!data?.fieldId || !data?.name || data?.fieldId !== action.data.fieldKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.single-line-text-field"
    }, formatMessage(isUpdatingAction ? $afd98a526d204866$var$messages.updateAction : $afd98a526d204866$var$messages.clearAction, {
        fieldName: data?.name?.toLowerCase()
    }));
};
module.exports["SingleLineTextField"] = $afd98a526d204866$export$2df72f2d4f169d3a;

});

parcelRegister("iygPg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $f922E = parcelRequire("f922E");

const $db25d9e7b4e115f6$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-line-text-field.icon-label",
        defaultMessage: "Single line text field icon"
    }
});
const $db25d9e7b4e115f6$export$3b40e79d3ed7455b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SingleLineTextFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($db25d9e7b4e115f6$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function SingleLineTextFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
        label: formatMessage($db25d9e7b4e115f6$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["SingleLineTextFieldIcon"] = $db25d9e7b4e115f6$export$3b40e79d3ed7455b;

});

parcelRegister("1rOeD", function(module, exports) {

var $cqkn1 = parcelRequire("cqkn1");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $7Z0GE = parcelRequire("7Z0GE");


var $lxaXk = parcelRequire("lxaXk");

const $8aa6f1ad95f218aa$var$messages = (0, $kSwu1.defineMessages)({
    assign: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.assign",
        defaultMessage: "Assign to {userName}"
    },
    assignGeneric: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.assign-generic",
        defaultMessage: "Assign {userName} to {fieldName}"
    },
    unassign: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.unassign",
        defaultMessage: "Unassign user"
    },
    unassignGeneric: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.unassign-generic",
        defaultMessage: "Unassign user from {fieldName}"
    },
    assignWithOriginalUser: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.assign-with-original-user",
        defaultMessage: "Assigning from {originalUser} to {userName}"
    }
});
const $8aa6f1ad95f218aa$export$cf7ea957fe955a49 = ({ queryRef: queryRef, action: action })=>{
    (0, $6cFsl.di)((0, $lxaXk.useHydratedUser));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $cqkn1.default), queryRef);
    const suggestedUserAccountId = typeof action?.data?.fieldValue === 'string' ? action.data.fieldValue.trim() : action?.data?.fieldValue?.toString() || null;
    const isFieldRenderable = Boolean(data?.fieldId && data.fieldId === action.data.fieldKey);
    const needsHydration = Boolean(isFieldRenderable && suggestedUserAccountId && suggestedUserAccountId !== data?.user?.accountId);
    const hydratedData = (0, $lxaXk.useHydratedUser)(suggestedUserAccountId, needsHydration);
    const { user: user, isLoading: isLoading, error: error } = needsHydration && hydratedData ? {
        user: hydratedData.user,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        user: data?.user,
        isLoading: false,
        error: null
    };
    const isAssignable = (user || isLoading) && suggestedUserAccountId;
    const isNotFound = !user && !isLoading && suggestedUserAccountId;
    if (!isFieldRenderable || isNotFound || error) return null;
    const assignMessage = data?.user?.accountId && data?.user?.accountId !== user?.accountId ? formatMessage($8aa6f1ad95f218aa$var$messages.assignWithOriginalUser, {
        originalUser: data?.user?.name,
        userName: user?.name
    }) : formatMessage(data?.fieldId === 'assignee' ? $8aa6f1ad95f218aa$var$messages.assign : $8aa6f1ad95f218aa$var$messages.assignGeneric, {
        userName: user?.name,
        ...data?.fieldId !== 'assignee' && {
            fieldName: data?.name
        }
    });
    const unassignMessage = formatMessage(data?.fieldId === 'assignee' ? $8aa6f1ad95f218aa$var$messages.unassign : $8aa6f1ad95f218aa$var$messages.unassignGeneric, {
        ...data?.fieldId !== 'assignee' && {
            fieldName: data?.name
        }
    });
    const formattedMessage = isAssignable ? assignMessage : unassignMessage;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Z0GE.SingleSelectUserPickerFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.single-select-user-picker-field"
    }, formattedMessage);
};
module.exports["SingleSelectUserPickerField"] = $8aa6f1ad95f218aa$export$cf7ea957fe955a49;

});

parcelRegister("5cnnG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6dcFV = parcelRequire("6dcFV");

const $6142ad2cc819ce8a$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.icon-label",
        defaultMessage: "Single select user picker field icon"
    }
});
const $6142ad2cc819ce8a$export$d631b99125c4a277 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SingleSelectUserPickerFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($6142ad2cc819ce8a$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6dcFV))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function SingleSelectUserPickerFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6dcFV))), {
        label: formatMessage($6142ad2cc819ce8a$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["SingleSelectUserPickerFieldIcon"] = $6142ad2cc819ce8a$export$d631b99125c4a277;

});

parcelRegister("3C85b", function(module, exports) {

var $eTzLE = parcelRequire("eTzLE");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");

const $849dfe0bd2730b06$var$messages = (0, $kSwu1.defineMessages)({
    action: {
        id: "update-work-item-fields-action-renderer.ui.action-card.status-field.action",
        defaultMessage: "Move to {newStatus}"
    },
    moveFromOriginalStatus: {
        id: "update-work-item-fields-action-renderer.ui.action-card.status-field.move-from-original-status",
        defaultMessage: "Move from {originalStatus} to {newStatus}"
    }
});
const $849dfe0bd2730b06$export$28769ce7cf4b59f9 = ({ queryRef: queryRef, action: action })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $eTzLE.default), queryRef);
    const fieldIdMatches = data?.fieldId === action.data.fieldKey;
    const suggestedTransitionId = Number(action?.data?.fieldValue);
    const isValidNumericTransition = !Number.isNaN(suggestedTransitionId);
    const statusName = (0, $cozmU.useMemo)(()=>{
        if (!fieldIdMatches) return undefined;
        if (!isValidNumericTransition) return typeof action?.data?.fieldValue === 'string' ? String(action.data.fieldValue).trim() : undefined;
        return data?.transitions?.edges?.find((edge)=>edge?.node?.transitionId === suggestedTransitionId)?.node?.to?.name;
    }, [
        data,
        fieldIdMatches,
        isValidNumericTransition,
        suggestedTransitionId,
        action?.data?.fieldValue
    ]);
    if (!fieldIdMatches || !statusName) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.status-field",
        color: "color.text.subtle",
        maxLines: 1
    }, data?.status?.name && isValidNumericTransition ? formatMessage($849dfe0bd2730b06$var$messages.moveFromOriginalStatus, {
        originalStatus: data?.status?.name,
        newStatus: statusName
    }) : formatMessage($849dfe0bd2730b06$var$messages.action, {
        newStatus: statusName
    }));
};
module.exports["StatusField"] = $849dfe0bd2730b06$export$28769ce7cf4b59f9;

});

parcelRegister("lAVCj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $c5NbL = parcelRequire("c5NbL");

const $7354f3cdab51ba76$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.status-field.icon-label",
        defaultMessage: "Status field icon"
    }
});
const $7354f3cdab51ba76$export$fae2110e65128aee = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StatusFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($7354f3cdab51ba76$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5NbL))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function StatusFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5NbL))), {
        label: formatMessage($7354f3cdab51ba76$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["StatusFieldIcon"] = $7354f3cdab51ba76$export$fae2110e65128aee;

});

parcelRegister("l9Fe2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $3DMf9 = parcelRequire("3DMf9");


var $iMnC5 = parcelRequire("iMnC5");


var $a9aSv = parcelRequire("a9aSv");

const $9d5a07159a156123$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    actionCompleted: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.action-completed.non-final",
        defaultMessage: "Action completed"
    },
    actionFailed: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.action-failed.non-final",
        defaultMessage: "Action failed"
    },
    defaultFieldIconLabel: {
        id: "conversation-assistant-message-actions.jira-update-work-item-fields-action-renderer.generic-field-icon-label.non-final",
        defaultMessage: "Field icon"
    }
});
const $9d5a07159a156123$var$styles = {
    root: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconHidden: "_1YKVNsdnbC _39xV02oWWg _0jFU0VoWWg"
};
const $9d5a07159a156123$export$b131c49b26d3f427 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { showIcon: showIcon, icon: icon, isCompleted: isCompleted, isLoading: isLoading, isFailed: isFailed } = t0;
    (0, $6cFsl.di)((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    bb0: {
        if (isLoading) {
            let t2;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "update-work-item-fields-action-renderer.ui.card-fields-list.status-icon.loading",
                    width: "24px",
                    height: "24px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                });
                $[0] = t2;
            } else t2 = $[0];
            t1 = t2;
            break bb0;
        }
        if (isFailed) {
            let t2;
            if ($[1] !== formatMessage) {
                t2 = formatMessage($9d5a07159a156123$export$defe85febe8b728c.actionFailed);
                $[1] = formatMessage;
                $[2] = t2;
            } else t2 = $[2];
            let t3;
            if ($[3] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    label: t2,
                    color: "var(--ds-icon-danger, #C9372C)",
                    size: "small"
                });
                $[3] = t2;
                $[4] = t3;
            } else t3 = $[4];
            t1 = t3;
            break bb0;
        }
        if (isCompleted) {
            let t2;
            if ($[5] !== formatMessage) {
                t2 = formatMessage($9d5a07159a156123$export$defe85febe8b728c.actionCompleted);
                $[5] = formatMessage;
                $[6] = t2;
            } else t2 = $[6];
            let t3;
            if ($[7] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    label: t2,
                    color: "var(--ds-icon-success, #6A9A23)",
                    size: "small"
                });
                $[7] = t2;
                $[8] = t3;
            } else t3 = $[8];
            t1 = t3;
            break bb0;
        }
        if (!icon) {
            let t2;
            if ($[9] !== formatMessage) {
                t2 = formatMessage($9d5a07159a156123$export$defe85febe8b728c.defaultFieldIconLabel);
                $[9] = formatMessage;
                $[10] = t2;
            } else t2 = $[10];
            let t3;
            if ($[11] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
                    label: t2,
                    size: "small",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[11] = t2;
                $[12] = t3;
            } else t3 = $[12];
            t1 = t3;
            break bb0;
        }
        t1 = icon;
    }
    const displayIcon = t1;
    const shouldDisplayIcon = showIcon || isCompleted || isLoading || isFailed;
    const t2 = shouldDisplayIcon ? $9d5a07159a156123$var$styles.root : $9d5a07159a156123$var$styles.iconHidden;
    let t3;
    if ($[13] !== displayIcon || $[14] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "update-work-item-fields-action-renderer.ui.card-fields-list.status-icon.container",
            xcss: t2
        }, displayIcon);
        $[13] = displayIcon;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : ({ showIcon: showIcon, icon: icon, isCompleted: isCompleted, isLoading: isLoading, isFailed: isFailed })=>{
    (0, $6cFsl.di)((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const displayIcon = (0, $cozmU.useMemo)(()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "update-work-item-fields-action-renderer.ui.card-fields-list.status-icon.loading",
            width: "24px",
            height: "24px",
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        });
        if (isFailed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: formatMessage($9d5a07159a156123$export$defe85febe8b728c.actionFailed),
            color: "var(--ds-icon-danger, #C9372C)",
            size: "small"
        });
        if (isCompleted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: formatMessage($9d5a07159a156123$export$defe85febe8b728c.actionCompleted),
            color: "var(--ds-icon-success, #6A9A23)",
            size: "small"
        });
        if (!icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3DMf9))), {
            label: formatMessage($9d5a07159a156123$export$defe85febe8b728c.defaultFieldIconLabel),
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
         // Display the icon corresponding to the field type
        return icon;
    }, [
        icon,
        isCompleted,
        isLoading,
        isFailed,
        formatMessage
    ]);
    const shouldDisplayIcon = showIcon || isCompleted || isLoading || isFailed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "update-work-item-fields-action-renderer.ui.card-fields-list.status-icon.container",
        xcss: shouldDisplayIcon ? $9d5a07159a156123$var$styles.root : $9d5a07159a156123$var$styles.iconHidden
    }, displayIcon);
};
module.exports["StatusIcon"] = $9d5a07159a156123$export$b131c49b26d3f427;

});

parcelRegister("fYjHB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $1Iy7Z = parcelRequire("1Iy7Z");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $cfM17 = parcelRequire("cfM17");


var $agB5R = parcelRequire("agB5R");


var $cE5H8 = parcelRequire("cE5H8");


var $cIviZ = parcelRequire("cIviZ");

const $e33c754014b0c604$var$messages = (0, $kSwu1.defineMessages)({
    timeSpentLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-spent-field.time-spent-label",
        defaultMessage: "Current time spent"
    },
    timeSpentSuggestedLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-spent-field.time-spent-suggested-label",
        defaultMessage: "Suggested time spent"
    },
    startDateSuggestedLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-spent-field.start-date-suggested-label",
        defaultMessage: "Suggested start date"
    },
    commentSuggestedLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-spent-field.comment-suggested-label",
        defaultMessage: "Suggested comment"
    },
    set: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-spent-field.set-label",
        defaultMessage: "Set time spent to {timeSpent}"
    }
});
const $e33c754014b0c604$export$7a4022552042d611 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $1Iy7Z.default), queryRef);
    const isFieldRenderable = data?.fieldId === "timetracking" && action?.data?.fieldKey === "timespent";
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    let currentTimeSpent;
    let defaultFormat;
    let defaultUnit;
    let shouldRender;
    let suggestedComment;
    let suggestedStarted;
    let suggestedTimeSpent;
    let t1;
    let workingDaysPerWeek;
    let workingHoursPerDay;
    if ($[0] !== action?.data?.fieldValue || $[1] !== data?.timeSpent?.timeInSeconds || $[2] !== data?.timeTrackingSettings || $[3] !== isFieldRenderable || $[4] !== isTimeTrackingEnabled) {
        const fieldValue = (0, $cIviZ.toTimeSpentFieldValue)(action?.data?.fieldValue);
        suggestedTimeSpent = fieldValue?.timeSpent;
        suggestedStarted = fieldValue?.started;
        suggestedComment = fieldValue?.comment;
        shouldRender = isFieldRenderable && isTimeTrackingEnabled && !!suggestedTimeSpent;
        ({ defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {});
        const t2 = data?.timeSpent?.timeInSeconds;
        let t3;
        if ($[15] !== t2) {
            t3 = (0, $cE5H8.formatSecondsToHuman)(t2);
            $[15] = t2;
            $[16] = t3;
        } else t3 = $[16];
        currentTimeSpent = t3;
        t1 = (0, $cE5H8.parseSuggestionToSeconds)(suggestedTimeSpent || "", {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        });
        $[0] = action?.data?.fieldValue;
        $[1] = data?.timeSpent?.timeInSeconds;
        $[2] = data?.timeTrackingSettings;
        $[3] = isFieldRenderable;
        $[4] = isTimeTrackingEnabled;
        $[5] = currentTimeSpent;
        $[6] = defaultFormat;
        $[7] = defaultUnit;
        $[8] = shouldRender;
        $[9] = suggestedComment;
        $[10] = suggestedStarted;
        $[11] = suggestedTimeSpent;
        $[12] = t1;
        $[13] = workingDaysPerWeek;
        $[14] = workingHoursPerDay;
    } else {
        currentTimeSpent = $[5];
        defaultFormat = $[6];
        defaultUnit = $[7];
        shouldRender = $[8];
        suggestedComment = $[9];
        suggestedStarted = $[10];
        suggestedTimeSpent = $[11];
        t1 = $[12];
        workingDaysPerWeek = $[13];
        workingHoursPerDay = $[14];
    }
    const normalizedSuggestedSeconds = t1;
    let t2;
    if ($[17] !== defaultFormat || $[18] !== defaultUnit || $[19] !== normalizedSuggestedSeconds || $[20] !== suggestedTimeSpent || $[21] !== workingDaysPerWeek || $[22] !== workingHoursPerDay) {
        t2 = normalizedSuggestedSeconds != null ? (0, $cE5H8.formatSecondsWithSettings)(normalizedSuggestedSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedTimeSpent;
        $[17] = defaultFormat;
        $[18] = defaultUnit;
        $[19] = normalizedSuggestedSeconds;
        $[20] = suggestedTimeSpent;
        $[21] = workingDaysPerWeek;
        $[22] = workingHoursPerDay;
        $[23] = t2;
    } else t2 = $[23];
    const normalizedOriginalValue = t2;
    let t3;
    if ($[24] !== action?.data?.reasoning || $[25] !== currentTimeSpent || $[26] !== data?.name || $[27] !== formatDate || $[28] !== formatMessage || $[29] !== normalizedOriginalValue || $[30] !== suggestedComment || $[31] !== suggestedStarted) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
                reasoning: action?.data?.reasoning,
                fieldName: data?.name,
                current: currentTimeSpent,
                currentLabel: formatMessage($e33c754014b0c604$var$messages.timeSpentLabel),
                suggested: normalizedOriginalValue,
                suggestedLabel: formatMessage($e33c754014b0c604$var$messages.timeSpentSuggestedLabel),
                additionalSuggestions: [
                    {
                        suggested: (0, $cfM17.formatSuggestedDateTime)(suggestedStarted, formatDate),
                        label: formatMessage($e33c754014b0c604$var$messages.startDateSuggestedLabel),
                        testIdSuffix: "time-spent-field-start-date-suggestion"
                    },
                    {
                        suggested: suggestedComment,
                        label: formatMessage($e33c754014b0c604$var$messages.commentSuggestedLabel),
                        testIdSuffix: "time-spent-field-comment-suggestion"
                    }
                ]
            });
        $[24] = action?.data?.reasoning;
        $[25] = currentTimeSpent;
        $[26] = data?.name;
        $[27] = formatDate;
        $[28] = formatMessage;
        $[29] = normalizedOriginalValue;
        $[30] = suggestedComment;
        $[31] = suggestedStarted;
        $[32] = t3;
    } else t3 = $[32];
    action?.data?.reasoning;
    data?.name;
    const toolTipContentProvider = t3;
    const t4 = action?.data?.fieldKey;
    let t5;
    if ($[33] !== registerTooltipProvider || $[34] !== shouldRender || $[35] !== t4 || $[36] !== toolTipContentProvider) {
        t5 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: t4,
            provider: toolTipContentProvider,
            enabled: shouldRender
        };
        $[33] = registerTooltipProvider;
        $[34] = shouldRender;
        $[35] = t4;
        $[36] = toolTipContentProvider;
        $[37] = t5;
    } else t5 = $[37];
    (0, $agB5R.useRegisterTooltipContentProvider)(t5);
    if (!shouldRender) return null;
    let t6;
    if ($[38] !== formatMessage || $[39] !== normalizedOriginalValue) {
        t6 = formatMessage($e33c754014b0c604$var$messages.set, {
            timeSpent: normalizedOriginalValue
        });
        $[38] = formatMessage;
        $[39] = normalizedOriginalValue;
        $[40] = t6;
    } else t6 = $[40];
    let t7;
    if ($[41] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.time-spent-field"
        }, t6);
        $[41] = t6;
        $[42] = t7;
    } else t7 = $[42];
    return t7;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $1Iy7Z.default), queryRef);
    const isFieldRenderable = data?.fieldId === 'timetracking' && action?.data?.fieldKey === 'timespent';
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const fieldValue = (0, $cIviZ.toTimeSpentFieldValue)(action?.data?.fieldValue);
    const suggestedTimeSpent = fieldValue?.timeSpent;
    const suggestedStarted = fieldValue?.started;
    const suggestedComment = fieldValue?.comment;
    // There cannot be a case where we "clear" the timespent - there always must be a value.
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled && !!suggestedTimeSpent;
    const { defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {};
    const currentTimeSpent = (0, $cE5H8.formatSecondsToHuman)(data?.timeSpent?.timeInSeconds);
    const normalizedSuggestedSeconds = (0, $cE5H8.parseSuggestionToSeconds)(suggestedTimeSpent || '', {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedOriginalValue = (0, $cozmU.useMemo)(()=>normalizedSuggestedSeconds != null ? (0, $cE5H8.formatSecondsWithSettings)(normalizedSuggestedSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedTimeSpent, [
        normalizedSuggestedSeconds,
        defaultUnit,
        defaultFormat,
        workingHoursPerDay,
        workingDaysPerWeek,
        suggestedTimeSpent
    ]);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            fieldName: data?.name,
            current: currentTimeSpent,
            currentLabel: formatMessage($e33c754014b0c604$var$messages.timeSpentLabel),
            suggested: normalizedOriginalValue,
            suggestedLabel: formatMessage($e33c754014b0c604$var$messages.timeSpentSuggestedLabel),
            additionalSuggestions: [
                {
                    suggested: (0, $cfM17.formatSuggestedDateTime)(suggestedStarted, formatDate),
                    label: formatMessage($e33c754014b0c604$var$messages.startDateSuggestedLabel),
                    testIdSuffix: 'time-spent-field-start-date-suggestion'
                },
                {
                    suggested: suggestedComment,
                    label: formatMessage($e33c754014b0c604$var$messages.commentSuggestedLabel),
                    testIdSuffix: 'time-spent-field-comment-suggestion'
                }
            ]
        }), [
        action?.data?.reasoning,
        data?.name,
        currentTimeSpent,
        normalizedOriginalValue,
        suggestedStarted,
        suggestedComment,
        formatMessage,
        formatDate
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: shouldRender
    });
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.time-spent-field"
    }, formatMessage($e33c754014b0c604$var$messages.set, {
        timeSpent: normalizedOriginalValue
    }));
};
module.exports["TimeSpentField"] = $e33c754014b0c604$export$7a4022552042d611;

});

parcelRegister("gpyL1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eU4qe = parcelRequire("eU4qe");

const $9e33d37c203dc73d$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-spent-field.icon-label",
        defaultMessage: "Time spent field"
    }
});
const $9e33d37c203dc73d$export$75e8a761b9ab73fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($9e33d37c203dc73d$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eU4qe))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eU4qe))), {
        label: formatMessage($9e33d37c203dc73d$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["TimeSpentFieldIcon"] = $9e33d37c203dc73d$export$75e8a761b9ab73fe;

});

parcelRegister("fVs75", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kPhuI = parcelRequire("kPhuI");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");


var $cE5H8 = parcelRequire("cE5H8");


var $cSrlg = parcelRequire("cSrlg");

const $b6856777ea75fac5$var$messages = (0, $kSwu1.defineMessages)({
    originalEstimateLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-estimate-label",
        defaultMessage: "Current original estimate"
    },
    remainingEstimateLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.remaining-estimate-label",
        defaultMessage: "Current remaining estimate"
    },
    originalEstimateSuggestedLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-estimate-suggested",
        defaultMessage: "Suggested original estimate"
    },
    remainingEstimateSuggestedLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.remaining-estimate-suggested",
        defaultMessage: "Suggested remaining estimate"
    }
});
const $b6856777ea75fac5$export$1c882bff9d1eb3f8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $kPhuI.default), queryRef);
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled;
    let defaultFormat;
    let defaultUnit;
    let normalizedOriginalSeconds;
    let suggestedOriginalEstimate;
    let suggestedRemainingEstimate;
    let t1;
    let workingDaysPerWeek;
    let workingHoursPerDay;
    if ($[0] !== action?.data?.fieldValue || $[1] !== data?.timeTrackingSettings) {
        const fieldValue = (0, $cSrlg.toTimeTrackingFieldValue)(action?.data?.fieldValue);
        suggestedOriginalEstimate = fieldValue?.originalEstimate;
        suggestedRemainingEstimate = fieldValue?.remainingEstimate;
        ({ defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {});
        normalizedOriginalSeconds = (0, $cE5H8.parseSuggestionToSeconds)(suggestedOriginalEstimate || "", {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        });
        t1 = (0, $cE5H8.parseSuggestionToSeconds)(suggestedRemainingEstimate || "", {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        });
        $[0] = action?.data?.fieldValue;
        $[1] = data?.timeTrackingSettings;
        $[2] = defaultFormat;
        $[3] = defaultUnit;
        $[4] = normalizedOriginalSeconds;
        $[5] = suggestedOriginalEstimate;
        $[6] = suggestedRemainingEstimate;
        $[7] = t1;
        $[8] = workingDaysPerWeek;
        $[9] = workingHoursPerDay;
    } else {
        defaultFormat = $[2];
        defaultUnit = $[3];
        normalizedOriginalSeconds = $[4];
        suggestedOriginalEstimate = $[5];
        suggestedRemainingEstimate = $[6];
        t1 = $[7];
        workingDaysPerWeek = $[8];
        workingHoursPerDay = $[9];
    }
    const normalizedRemainingSeconds = t1;
    let t2;
    if ($[10] !== defaultFormat || $[11] !== defaultUnit || $[12] !== normalizedOriginalSeconds || $[13] !== suggestedOriginalEstimate || $[14] !== workingDaysPerWeek || $[15] !== workingHoursPerDay) {
        t2 = normalizedOriginalSeconds != null ? (0, $cE5H8.formatSecondsWithSettings)(normalizedOriginalSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedOriginalEstimate;
        $[10] = defaultFormat;
        $[11] = defaultUnit;
        $[12] = normalizedOriginalSeconds;
        $[13] = suggestedOriginalEstimate;
        $[14] = workingDaysPerWeek;
        $[15] = workingHoursPerDay;
        $[16] = t2;
    } else t2 = $[16];
    const normalizedOriginalValue = t2;
    let t3;
    if ($[17] !== defaultFormat || $[18] !== defaultUnit || $[19] !== normalizedRemainingSeconds || $[20] !== suggestedRemainingEstimate || $[21] !== workingDaysPerWeek || $[22] !== workingHoursPerDay) {
        t3 = normalizedRemainingSeconds != null ? (0, $cE5H8.formatSecondsWithSettings)(normalizedRemainingSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedRemainingEstimate;
        $[17] = defaultFormat;
        $[18] = defaultUnit;
        $[19] = normalizedRemainingSeconds;
        $[20] = suggestedRemainingEstimate;
        $[21] = workingDaysPerWeek;
        $[22] = workingHoursPerDay;
        $[23] = t3;
    } else t3 = $[23];
    const normalizedRemainingValue = t3;
    const t4 = data?.originalEstimate?.timeInSeconds ?? null;
    let t5;
    if ($[24] !== t4) {
        t5 = (0, $cE5H8.formatSecondsToHuman)(t4);
        $[24] = t4;
        $[25] = t5;
    } else t5 = $[25];
    const normalizedCurrentOriginalValue = t5;
    const t6 = data?.remainingEstimate?.timeInSeconds ?? null;
    let t7;
    if ($[26] !== t6) {
        t7 = (0, $cE5H8.formatSecondsToHuman)(t6);
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    const normalizedCurrentRemainingValue = t7;
    let t8;
    if ($[28] !== action?.data?.reasoning || $[29] !== data?.name || $[30] !== formatMessage || $[31] !== normalizedCurrentOriginalValue || $[32] !== normalizedCurrentRemainingValue || $[33] !== normalizedOriginalValue || $[34] !== normalizedRemainingValue || $[35] !== suggestedOriginalEstimate || $[36] !== suggestedRemainingEstimate) {
        t8 = ()=>{
            const getSuggestedOriginal = ()=>{
                if (suggestedOriginalEstimate === undefined) return suggestedOriginalEstimate;
                if (suggestedOriginalEstimate) return normalizedOriginalValue;
                return suggestedRemainingEstimate ? normalizedRemainingValue : normalizedCurrentRemainingValue;
            };
            const getSuggestedRemaining = ()=>{
                if (suggestedRemainingEstimate === undefined) return suggestedRemainingEstimate;
                if (suggestedRemainingEstimate) return normalizedRemainingValue;
                return suggestedOriginalEstimate ? normalizedOriginalValue : normalizedCurrentOriginalValue;
            };
            const originalAndRemainingCleared = suggestedOriginalEstimate !== undefined && !suggestedOriginalEstimate && suggestedRemainingEstimate !== undefined && !suggestedRemainingEstimate;
            const suggestedOriginal = originalAndRemainingCleared ? null : getSuggestedOriginal();
            const suggestedRemaining = originalAndRemainingCleared ? null : getSuggestedRemaining();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
                reasoning: action?.data?.reasoning,
                fieldName: data?.name,
                additionalSuggestions: [
                    {
                        suggested: suggestedOriginalEstimate !== undefined && normalizedCurrentOriginalValue,
                        label: formatMessage($b6856777ea75fac5$var$messages.originalEstimateLabel),
                        testIdSuffix: "original-estimate-current"
                    },
                    {
                        suggested: suggestedRemainingEstimate !== undefined && normalizedCurrentRemainingValue,
                        label: formatMessage($b6856777ea75fac5$var$messages.remainingEstimateLabel),
                        testIdSuffix: "remaining-estimate-current"
                    },
                    {
                        suggested: suggestedOriginal,
                        label: formatMessage($b6856777ea75fac5$var$messages.originalEstimateSuggestedLabel),
                        testIdSuffix: "original-estimate-suggested"
                    },
                    {
                        suggested: suggestedRemaining,
                        label: formatMessage($b6856777ea75fac5$var$messages.remainingEstimateSuggestedLabel),
                        testIdSuffix: "remaining-estimate-suggested"
                    }
                ]
            });
        };
        $[28] = action?.data?.reasoning;
        $[29] = data?.name;
        $[30] = formatMessage;
        $[31] = normalizedCurrentOriginalValue;
        $[32] = normalizedCurrentRemainingValue;
        $[33] = normalizedOriginalValue;
        $[34] = normalizedRemainingValue;
        $[35] = suggestedOriginalEstimate;
        $[36] = suggestedRemainingEstimate;
        $[37] = t8;
    } else t8 = $[37];
    action?.data?.reasoning;
    data?.name;
    const toolTipContentProvider = t8;
    const t9 = action?.data?.fieldKey;
    let t10;
    if ($[38] !== registerTooltipProvider || $[39] !== shouldRender || $[40] !== t9 || $[41] !== toolTipContentProvider) {
        t10 = {
            registerTooltipProvider: registerTooltipProvider,
            fieldId: t9,
            provider: toolTipContentProvider,
            enabled: shouldRender
        };
        $[38] = registerTooltipProvider;
        $[39] = shouldRender;
        $[40] = t9;
        $[41] = toolTipContentProvider;
        $[42] = t10;
    } else t10 = $[42];
    (0, $agB5R.useRegisterTooltipContentProvider)(t10);
    if (!shouldRender) return null;
    let t11;
    if ($[43] !== formatMessage || $[44] !== normalizedCurrentOriginalValue || $[45] !== normalizedCurrentRemainingValue || $[46] !== normalizedOriginalValue || $[47] !== normalizedRemainingValue || $[48] !== suggestedOriginalEstimate || $[49] !== suggestedRemainingEstimate) {
        t11 = (0, $cSrlg.getFieldTextCopy)({
            suggestedOriginalEstimate: suggestedOriginalEstimate,
            suggestedRemainingEstimate: suggestedRemainingEstimate,
            normalizedOriginalValue: normalizedOriginalValue,
            normalizedRemainingValue: normalizedRemainingValue,
            normalizedCurrentOriginalValue: normalizedCurrentOriginalValue,
            normalizedCurrentRemainingValue: normalizedCurrentRemainingValue,
            formatMessage: formatMessage
        });
        $[43] = formatMessage;
        $[44] = normalizedCurrentOriginalValue;
        $[45] = normalizedCurrentRemainingValue;
        $[46] = normalizedOriginalValue;
        $[47] = normalizedRemainingValue;
        $[48] = suggestedOriginalEstimate;
        $[49] = suggestedRemainingEstimate;
        $[50] = t11;
    } else t11 = $[50];
    const value = t11;
    let t12;
    if ($[51] !== value) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            maxLines: 1,
            testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.remaining-time-estimate-field"
        }, value);
        $[51] = value;
        $[52] = t12;
    } else t12 = $[52];
    return t12;
} : ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $kPhuI.default), queryRef);
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const isTimeTrackingEnabled = !!data?.timeTrackingSettings?.isJiraConfiguredTimeTrackingEnabled;
    const shouldRender = isFieldRenderable && isTimeTrackingEnabled;
    const fieldValue = (0, $cSrlg.toTimeTrackingFieldValue)(action?.data?.fieldValue);
    const suggestedOriginalEstimate = fieldValue?.originalEstimate;
    const suggestedRemainingEstimate = fieldValue?.remainingEstimate;
    const { defaultUnit: defaultUnit, defaultFormat: defaultFormat, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek } = data?.timeTrackingSettings ?? {};
    const normalizedOriginalSeconds = (0, $cE5H8.parseSuggestionToSeconds)(suggestedOriginalEstimate || '', {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedRemainingSeconds = (0, $cE5H8.parseSuggestionToSeconds)(suggestedRemainingEstimate || '', {
        defaultUnit: defaultUnit,
        defaultFormat: defaultFormat,
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek
    });
    const normalizedOriginalValue = (0, $cozmU.useMemo)(()=>normalizedOriginalSeconds != null ? (0, $cE5H8.formatSecondsWithSettings)(normalizedOriginalSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedOriginalEstimate, [
        normalizedOriginalSeconds,
        defaultUnit,
        defaultFormat,
        workingHoursPerDay,
        workingDaysPerWeek,
        suggestedOriginalEstimate
    ]);
    const normalizedRemainingValue = (0, $cozmU.useMemo)(()=>normalizedRemainingSeconds != null ? (0, $cE5H8.formatSecondsWithSettings)(normalizedRemainingSeconds, {
            defaultUnit: defaultUnit,
            defaultFormat: defaultFormat,
            workingHoursPerDay: workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek
        }) : suggestedRemainingEstimate, [
        normalizedRemainingSeconds,
        defaultUnit,
        defaultFormat,
        workingHoursPerDay,
        workingDaysPerWeek,
        suggestedRemainingEstimate
    ]);
    const normalizedCurrentOriginalValue = (0, $cE5H8.formatSecondsToHuman)(data?.originalEstimate?.timeInSeconds ?? null);
    const normalizedCurrentRemainingValue = (0, $cE5H8.formatSecondsToHuman)(data?.remainingEstimate?.timeInSeconds ?? null);
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>{
        /*
    	The time tracking field has some confusing behaviour when it comes to setting the original and remaining estimates.
    	The shape of the object we receive as an action (and send to the API) is as so:
    	{
    		originalEstimate?: string | nulll   // undefined if doesn't have a value
    		remainingEstimate?: string | null   // undefined if doesn't have a value
    	}
    	* Note that passing in an empty string ('') or null both act as "clearing" the estimate field.
    		When we provide a valid value (e.g a string like '7d', '2h', '1w 6d 7h'), the API handles this as we expect it to for
    	original and remaining estimates - it updates the value as we would expect.
    		However, when we "clear" fields, the API behaves less intuitively. If we pass in an empty string/null, the API call
    	will be successful, but the field will not be cleared. Instead it will take the value of the other estimate field
    	and use that.
    		For example, suppose we have a Jira work item has an original estimate of '7d' and a remaining estimate of '3d'.
    	If we send the following object to the API:
    	{
    		remainingEstimate: '',
    	}
    	The API will set the remainingEstimate to '7d' now, obtaining this value from the original estimate. The same is true
    	if we set originalEstimate to a cleared value.
    		However, if we clear both fields by sending the following object to the API:
    	{
    		originalEstimate: '',
    		remainingEstimate: '',
    	}
    	The API will clear both fields, as we would expect.
    		The code below thus handles this behaviour for the suggested estimate values through the following process:
    	Suppose we have a Jira work item has an original estimate of '7d' and a remaining estimate of '3d'.
    	1) If the estimate is undefined, return the undefined object (this isn't going to be changed/rendered)
    	Example in originalEstimate scope
    	{
    		remainingEstimate: '7d',
    	}
    	suggestedValue = undefined
    		2) If the estimate is truthy (i.e not an empty string/null), we use that value
    	Example in originalEstimate scope
    	{
    		originalEstimate: '5d',
    	}
    	suggestedValue = '5d'
    		3) If the other estimate is truthy, we will use the suggested value of the other estimate field.
    	Example in originalEstimate scope
    	{
    		originalEstimate: ''
    		remainingEstimate: '5d'
    	}
    	suggestedValue = '5d'
    		4) If that is not available, (i.e the current estimate is falsy AND the other estimate is falsy), we use the current value of the other estimate field.
    	Example in originalEstimate scope
    	{
    		originalEstimate: ''
    	}
    	suggestedValue = '3d'
    		* Note: 3) and 4) are the same logic as the BE code: https://atlassian.slack.com/archives/C092WQZSBSP/p1762146479675429?thread_ts=1761885651.797099&cid=C092WQZSBSP
    	There is also the case where if both estimates are cleared, then both suggested values will be null so we don't render any suggested
    	values as we are clearing the fields.
    */ const getSuggestedOriginal = ()=>{
            if (suggestedOriginalEstimate === undefined) return suggestedOriginalEstimate;
            if (suggestedOriginalEstimate) return normalizedOriginalValue;
            return suggestedRemainingEstimate ? normalizedRemainingValue : normalizedCurrentRemainingValue;
        };
        const getSuggestedRemaining = ()=>{
            if (suggestedRemainingEstimate === undefined) return suggestedRemainingEstimate;
            if (suggestedRemainingEstimate) return normalizedRemainingValue;
            return suggestedOriginalEstimate ? normalizedOriginalValue : normalizedCurrentOriginalValue;
        };
        // Check if both estimates are explicitly cleared (empty/null, not undefined)
        const originalAndRemainingCleared = suggestedOriginalEstimate !== undefined && !suggestedOriginalEstimate && suggestedRemainingEstimate !== undefined && !suggestedRemainingEstimate;
        // If both are cleared, show null. Otherwise, compute the suggested values.
        const suggestedOriginal = originalAndRemainingCleared ? null : getSuggestedOriginal();
        const suggestedRemaining = originalAndRemainingCleared ? null : getSuggestedRemaining();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            fieldName: data?.name,
            additionalSuggestions: [
                {
                    suggested: suggestedOriginalEstimate !== undefined && normalizedCurrentOriginalValue,
                    label: formatMessage($b6856777ea75fac5$var$messages.originalEstimateLabel),
                    testIdSuffix: 'original-estimate-current'
                },
                {
                    suggested: suggestedRemainingEstimate !== undefined && normalizedCurrentRemainingValue,
                    label: formatMessage($b6856777ea75fac5$var$messages.remainingEstimateLabel),
                    testIdSuffix: 'remaining-estimate-current'
                },
                {
                    suggested: suggestedOriginal,
                    label: formatMessage($b6856777ea75fac5$var$messages.originalEstimateSuggestedLabel),
                    testIdSuffix: 'original-estimate-suggested'
                },
                {
                    suggested: suggestedRemaining,
                    label: formatMessage($b6856777ea75fac5$var$messages.remainingEstimateSuggestedLabel),
                    testIdSuffix: 'remaining-estimate-suggested'
                }
            ]
        });
    }, [
        action?.data?.reasoning,
        data?.name,
        suggestedOriginalEstimate,
        suggestedRemainingEstimate,
        normalizedOriginalValue,
        normalizedRemainingValue,
        normalizedCurrentOriginalValue,
        normalizedCurrentRemainingValue,
        formatMessage
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: shouldRender
    });
    if (!shouldRender) return null;
    const value = (0, $cSrlg.getFieldTextCopy)({
        suggestedOriginalEstimate: suggestedOriginalEstimate,
        suggestedRemainingEstimate: suggestedRemainingEstimate,
        normalizedOriginalValue: normalizedOriginalValue,
        normalizedRemainingValue: normalizedRemainingValue,
        normalizedCurrentOriginalValue: normalizedCurrentOriginalValue,
        normalizedCurrentRemainingValue: normalizedCurrentRemainingValue,
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.remaining-time-estimate-field"
    }, value);
};
module.exports["TimeTrackingField"] = $b6856777ea75fac5$export$1c882bff9d1eb3f8;

});

parcelRegister("dlexh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5ZtfK = parcelRequire("5ZtfK");

const $d8d84e5034069272$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.time-tracking-field.icon-label",
        defaultMessage: "Time tracking field"
    }
});
const $d8d84e5034069272$export$2bd7bc4060d82fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($d8d84e5034069272$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        label: formatMessage($d8d84e5034069272$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["TimeTrackingFieldIcon"] = $d8d84e5034069272$export$2bd7bc4060d82fb;

});

parcelRegister("dP04p", function(module, exports) {

var $lpPTZ = parcelRequire("lpPTZ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4aRua = parcelRequire("4aRua");


var $i64u7 = parcelRequire("i64u7");


var $agB5R = parcelRequire("agB5R");


var $jsqhm = parcelRequire("jsqhm");


var $5FZpD = parcelRequire("5FZpD");


var $c5P3M = parcelRequire("c5P3M");

const $a7caed66b09f3fe3$var$messages = (0, $kSwu1.defineMessages)({
    assign: {
        id: "update-work-item-fields-action-renderer.ui.action-card.users-field.assign",
        defaultMessage: "Assign {userNames} to {fieldName}"
    },
    unassign: {
        id: "update-work-item-fields-action-renderer.ui.action-card.users-field.unassign",
        defaultMessage: "Unassign users from {fieldName}"
    }
});
const $a7caed66b09f3fe3$export$6d307bc561db97fc = ({ queryRef: queryRef, action: action, registerTooltipProvider: registerTooltipProvider })=>{
    (0, $6cFsl.di)((0, $5FZpD.useHydratedUsers));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const data = (0, $6SsN4.useFragment)((0, $lpPTZ.default), queryRef);
    const suggestedUserAccountIds = (0, $cozmU.useMemo)(()=>(0, $jsqhm.parseSuggestedAccountIds)(action?.data?.fieldValue), [
        action?.data?.fieldValue
    ]);
    // Determine if we need to hydrate: if any suggested id is not present in current field data
    const currentSelectedIds = (data?.selectedUsersConnection?.edges ?? []).map((edge)=>edge?.node?.accountId).filter((accountId)=>typeof accountId === 'string');
    const isFieldRenderable = data?.fieldId === action?.data?.fieldKey;
    const needsHydration = Boolean(isFieldRenderable && suggestedUserAccountIds.some((accountId_0)=>!currentSelectedIds.includes(accountId_0)));
    const hydratedData = (0, $5FZpD.useHydratedUsers)(suggestedUserAccountIds, needsHydration);
    const { users: users, isLoading: isLoading, error: error } = needsHydration && hydratedData ? {
        users: hydratedData.users,
        isLoading: hydratedData.isLoading,
        error: hydratedData.error
    } : {
        users: (data?.selectedUsersConnection?.edges ?? []).map((edge_0)=>edge_0?.node).filter(Boolean).map((userAccount)=>({
                accountId: userAccount?.accountId,
                name: userAccount?.name ?? null
            })),
        isLoading: false,
        error: null
    };
    const isAssignable = (users?.length ?? 0) > 0 && suggestedUserAccountIds.length > 0;
    const isNotFound = (users?.length ?? 0) === 0 && !isLoading && suggestedUserAccountIds.length > 0;
    const userNames = (()=>{
        const names = (users ?? []).map((user)=>user.name).filter(Boolean).sort();
        if (names.length <= 1) return names.join('');
        return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    })();
    const assignMessage = formatMessage($a7caed66b09f3fe3$var$messages.assign, {
        userNames: userNames,
        fieldName: data?.name
    });
    const unassignMessage = formatMessage($a7caed66b09f3fe3$var$messages.unassign, {
        fieldName: data?.name
    });
    const formattedMessage = isAssignable ? assignMessage : unassignMessage;
    const toolTipContentProvider = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i64u7.FieldTooltipContent), {
            reasoning: action?.data?.reasoning,
            suggested: userNames,
            fieldName: data?.name
        }), [
        action?.data?.reasoning,
        userNames,
        data?.name
    ]);
    (0, $agB5R.useRegisterTooltipContentProvider)({
        registerTooltipProvider: registerTooltipProvider,
        fieldId: action?.data?.fieldKey,
        provider: toolTipContentProvider,
        enabled: isFieldRenderable && !isNotFound && !error
    });
    if (!isFieldRenderable || isNotFound || error) return null;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5P3M.UsersFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        maxLines: 1,
        testId: "update-work-item-fields-action-renderer.ui.action-card.card-fields-list.users-field"
    }, formattedMessage);
};
module.exports["UsersField"] = $a7caed66b09f3fe3$export$6d307bc561db97fc;

});

parcelRegister("7eLor", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fBqzD = parcelRequire("fBqzD");

const $836ed94d0e880924$var$messages = (0, $kSwu1.defineMessages)({
    iconLabel: {
        id: "update-work-item-fields-action-renderer.ui.action-card.users-field.icon-label",
        defaultMessage: "Users field icon"
    }
});
const $836ed94d0e880924$export$604891a7e8902ee6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UsersFieldIcon() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($836ed94d0e880924$var$messages.iconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
            label: t0,
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function UsersFieldIcon() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
        label: formatMessage($836ed94d0e880924$var$messages.iconLabel),
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    });
};
module.exports["UsersFieldIcon"] = $836ed94d0e880924$export$604891a7e8902ee6;

});

parcelRegister("egUPh", function(module, exports) {
/**
 * @generated SignedSource<<9fbf224f115d08a50934b2c78e9d2b43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $479d931244f7f119$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardHeader_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "JiraSingleLineTextField",
            "kind": "LinkedField",
            "name": "summaryField",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "text"
                }
            ]
        },
        {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ],
    "type": "JiraIssue"
};
$479d931244f7f119$var$node.hash = "5b3b52ad60affa4654ab2d2c0cbc2470";
var $479d931244f7f119$export$2e2bcd8739ae039 = $479d931244f7f119$var$node;
module.exports["default"] = $479d931244f7f119$export$2e2bcd8739ae039;

});

parcelRegister("2TUA1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dimUV = parcelRequire("dimUV");


var $lLyfm = parcelRequire("lLyfm");


var $4qBrT = parcelRequire("4qBrT");

const $715fb6b28ad41fbc$export$339c2dc2a84b809f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { highlight: highlight } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            size: "medium",
            label: "",
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== highlight?.summary || $[2] !== intl) {
        t2 = highlight?.summary || intl.formatMessage((0, $4qBrT.messages).newDecision);
        $[1] = highlight?.summary;
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = highlight?.description;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
            icon: t1,
            title: t2,
            description: t3,
            testId: "project-status-update-action-renderer.ui.highlight-decision"
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ highlight: highlight })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            size: "medium",
            label: "",
            color: "var(--ds-icon-accent-green, #22A06B)"
        }),
        title: highlight?.summary || intl.formatMessage((0, $4qBrT.messages).newDecision),
        description: highlight?.description,
        testId: "project-status-update-action-renderer.ui.highlight-decision"
    });
};
module.exports["HighlightDecisionField"] = $715fb6b28ad41fbc$export$339c2dc2a84b809f;

});

parcelRegister("d8b6a", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dVbiN = parcelRequire("dVbiN");


var $lLyfm = parcelRequire("lLyfm");


var $4qBrT = parcelRequire("4qBrT");

const $b36bd2dfb0419554$export$1c9d481d55ccb011 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { highlight: highlight } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
            size: "medium",
            label: "",
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== highlight?.summary || $[2] !== intl) {
        t2 = highlight?.summary || intl.formatMessage((0, $4qBrT.messages).newLearning);
        $[1] = highlight?.summary;
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = highlight?.description;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
            icon: t1,
            title: t2,
            description: t3,
            testId: "project-status-update-action-renderer.ui.highlight-learning"
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ highlight: highlight })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
            size: "medium",
            label: "",
            color: "var(--ds-icon-accent-yellow, #B38600)"
        }),
        title: highlight?.summary || intl.formatMessage((0, $4qBrT.messages).newLearning),
        description: highlight?.description,
        testId: "project-status-update-action-renderer.ui.highlight-learning"
    });
};
module.exports["HighlightLearningField"] = $b36bd2dfb0419554$export$1c9d481d55ccb011;

});

parcelRegister("baXMQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $QrYx2 = parcelRequire("QrYx2");


var $lLyfm = parcelRequire("lLyfm");


var $4qBrT = parcelRequire("4qBrT");

const $f5cd1a56af528551$export$cb8bfb5b0a76fd12 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { highlight: highlight } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QrYx2))), {
            size: "medium",
            label: "",
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== highlight?.summary || $[2] !== intl) {
        t2 = highlight?.summary || intl.formatMessage((0, $4qBrT.messages).newRisk);
        $[1] = highlight?.summary;
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = highlight?.description;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
            icon: t1,
            title: t2,
            description: t3,
            testId: "project-status-update-action-renderer.ui.highlight-risk"
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ highlight: highlight })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QrYx2))), {
            size: "medium",
            label: "",
            color: "var(--ds-icon-accent-red, #C9372C)"
        }),
        title: highlight?.summary || intl.formatMessage((0, $4qBrT.messages).newRisk),
        description: highlight?.description,
        testId: "project-status-update-action-renderer.ui.highlight-risk"
    });
};
module.exports["HighlightRiskField"] = $f5cd1a56af528551$export$cb8bfb5b0a76fd12;

});

parcelRegister("bBruU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hMaHH = parcelRequire("hMaHH");


var $lLyfm = parcelRequire("lLyfm");


var $4qBrT = parcelRequire("4qBrT");

const $8cf35d90f50e33a4$export$dc79ccc5921dd68d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { updateNote: updateNote } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            size: "medium",
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl || $[2] !== updateNote?.summary) {
        t2 = updateNote?.summary ?? intl.formatMessage((0, $4qBrT.messages).moreDetail);
        $[1] = intl;
        $[2] = updateNote?.summary;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = updateNote?.description;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
            icon: t1,
            title: t2,
            description: t3,
            testId: "project-status-update-action-renderer.ui.update-note"
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ updateNote: updateNote })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLyfm.AdditionalNoteBase), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            size: "medium",
            label: ""
        }),
        title: updateNote?.summary ?? intl.formatMessage((0, $4qBrT.messages).moreDetail),
        description: updateNote?.description,
        testId: "project-status-update-action-renderer.ui.update-note"
    });
};
module.exports["UpdateNoteField"] = $8cf35d90f50e33a4$export$dc79ccc5921dd68d;

});

parcelRegister("2YqCL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5HApy = parcelRequire("5HApy");


var $1l0kj = parcelRequire("1l0kj");


var $3BY7M = parcelRequire("3BY7M");


var $6rwn6 = parcelRequire("6rwn6");

const $6297ee90b0efd01b$var$styles = {
    container: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $6297ee90b0efd01b$export$b75b6a6cc3a70ff8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { summary: summary } = t0;
    if (!summary) return null;
    let t1;
    if ($[0] !== summary) {
        t1 = (0, $6rwn6.encodeAdf)(summary);
        $[0] = summary;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $6297ee90b0efd01b$var$styles.container,
            testId: "project-status-update-action-renderer.ui.summary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: t1
        })));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ summary: summary })=>{
    if (!summary) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $6297ee90b0efd01b$var$styles.container,
        testId: "project-status-update-action-renderer.ui.summary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: (0, $6rwn6.encodeAdf)(summary)
    })));
};
module.exports["SummaryField"] = $6297ee90b0efd01b$export$b75b6a6cc3a70ff8;

});

parcelRegister("hYjiU", function(module, exports) {
/**
 * @generated SignedSource<<b1925faea66fd371ea9056cb2a0e7bca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19ec467d98baee33$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip",
    "selections": [
        {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "TownsquareProject"
};
$19ec467d98baee33$var$node.hash = "8191eccd37f2b80fef62227d972d0794";
var $19ec467d98baee33$export$2e2bcd8739ae039 = $19ec467d98baee33$var$node;
module.exports["default"] = $19ec467d98baee33$export$2e2bcd8739ae039;

});

parcelRegister("hFOCq", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b7f310cf4289088b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ctaCancel: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.cta-cancel.non-final",
        defaultMessage: "Cancel"
    },
    ctaPostUpdate: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.cta-post-update.non-final",
        defaultMessage: "Post update"
    },
    ctaForbiddenPostUpdate: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.cta-forbidden-post-update.non-final",
        defaultMessage: "Only contributors to this project can post updates."
    }
});
module.exports["messages"] = $b7f310cf4289088b$export$defe85febe8b728c;

});

parcelRegister("fhJzs", function(module, exports) {
/**
 * @generated SignedSource<<7b07e0214ce80ea3898889917b3de6fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d467564aa68e268e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "TownsquareIconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareThemeURIs",
                    "kind": "LinkedField",
                    "name": "square",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "light"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "dark"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "TownsquareProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        },
        {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "dueDate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "label"
                }
            ]
        }
    ],
    "type": "TownsquareProject"
};
$d467564aa68e268e$var$node.hash = "84a9297c972c839e664374b242fe5f52";
var $d467564aa68e268e$export$2e2bcd8739ae039 = $d467564aa68e268e$var$node;
module.exports["default"] = $d467564aa68e268e$export$2e2bcd8739ae039;

});

parcelRegister("7zNWH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9KSWX = parcelRequire("9KSWX");


var $1l0kj = parcelRequire("1l0kj");

const $fd5e82c85d99fa36$var$styles = {
    container: "_3iDTPbccYA _0hPCNLDIqT"
};
const $fd5e82c85d99fa36$export$28769ce7cf4b59f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { statusLozengeText: statusLozengeText, statusLozengeAppearance: statusLozengeAppearance } = t0;
    if (!statusLozengeText) return null;
    let t1;
    if ($[0] !== statusLozengeAppearance || $[1] !== statusLozengeText) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $fd5e82c85d99fa36$var$styles.container,
            testId: "project-status-update-action-renderer.ui.status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: statusLozengeAppearance,
            isBold: true
        }, statusLozengeText));
        $[0] = statusLozengeAppearance;
        $[1] = statusLozengeText;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ statusLozengeText: statusLozengeText, statusLozengeAppearance: statusLozengeAppearance })=>{
    if (!statusLozengeText) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $fd5e82c85d99fa36$var$styles.container,
        testId: "project-status-update-action-renderer.ui.status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: statusLozengeAppearance,
        isBold: true
    }, statusLozengeText));
};
module.exports["StatusField"] = $fd5e82c85d99fa36$export$28769ce7cf4b59f9;

});

parcelRegister("6f85n", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $824lD = parcelRequire("824lD");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $b8NXT = parcelRequire("b8NXT");

const $9d1eee3530a8c147$var$styles = {
    container: "_2mHwu81Y8M _30huDKOeNX _0bjKvDKxmn _3iDTPbccYA _0hPCNLDIqT _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6Q1Y8M _1UtDYzZpcK",
    icon: "_3iDTPbccYA _1UtDYzZpcK"
};
const $9d1eee3530a8c147$export$ae74b42c274d850c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { targetDate: targetDate, fallbackDate: fallbackDate } = t0;
    const intl = (0, $kSwu1.useIntl)();
    if (!targetDate?.date && !fallbackDate) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $9d1eee3530a8c147$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
            size: "medium",
            label: ""
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== fallbackDate || $[2] !== intl || $[3] !== targetDate) {
        t2 = targetDate?.date ? (0, $b8NXT.formatDateForDisplay)(targetDate.date, intl.locale, targetDate.confidence) : fallbackDate;
        $[1] = fallbackDate;
        $[2] = intl;
        $[3] = targetDate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            testId: "project-status-update-action-renderer.ui.target-date"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $9d1eee3530a8c147$var$styles.container
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, t2)));
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ targetDate: targetDate, fallbackDate: fallbackDate })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (!targetDate?.date && !fallbackDate) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        testId: "project-status-update-action-renderer.ui.target-date"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $9d1eee3530a8c147$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $9d1eee3530a8c147$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
        size: "medium",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, targetDate?.date ? (0, $b8NXT.formatDateForDisplay)(targetDate.date, intl.locale, targetDate.confidence) : fallbackDate)));
};
module.exports["TargetDateField"] = $9d1eee3530a8c147$export$ae74b42c274d850c;

});

parcelRegister("4eDq7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $42938c1e77b01ce7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    statusOnTrack: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-on-track.non-final",
        defaultMessage: "On track"
    },
    statusAtRisk: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-at-risk.non-final",
        defaultMessage: "At risk"
    },
    statusOffTrack: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-off-track.non-final",
        defaultMessage: "Off track"
    },
    phasePaused: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-paused.non-final",
        defaultMessage: "Paused"
    },
    phasePending: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-pending.non-final",
        defaultMessage: "Pending"
    },
    phaseInProgress: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-in-progress.non-final",
        defaultMessage: "In progress"
    },
    phaseDone: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-done.non-final",
        defaultMessage: "Completed \uD83C\uDF89"
    },
    phaseCancelled: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-cancelled.non-final",
        defaultMessage: "Cancelled"
    },
    statusForDate: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-for-date.non-final",
        defaultMessage: "{status} for {date}"
    },
    statusOnDate: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-on-date.non-final",
        defaultMessage: "{status} on {date}"
    }
});
module.exports["messages"] = $42938c1e77b01ce7$export$defe85febe8b728c;

});

parcelRegister("8N4EC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6efadab7d34def72$var$message = (0, $kSwu1.defineMessages)({
    archiveModalTitle: {
        id: "atlassian-team-update-archive.archive-modal-title",
        defaultMessage: "{teamCount, plural, one {Archive team?} other {Archive {teamCount} teams?}}"
    },
    archiveModalBodyLine1: {
        id: "atlassian-team-update-archive.archive-modal-body-line-1",
        defaultMessage: "Once archived, {teamCount, plural, one {this} other {these}} team's name, membership, and details can no longer be changed."
    },
    archiveModalBodyLine2: {
        id: "atlassian-team-update-archive.archive-modal-body-line-2",
        defaultMessage: "{teamCount, plural, one {{teamName}} other {Archived teams}} will not appear in search, but any connections to work will remain."
    },
    archiveModalCancel: {
        id: "atlassian-team-update-archive.archive-modal-cancel",
        defaultMessage: "Cancel"
    },
    archiveModalConfirm: {
        id: "atlassian-team-update-archive.archive-modal-confirm",
        defaultMessage: "{teamCount, plural, one {Archive} other {Archive all}}"
    },
    archiveErrorTitleSingle: {
        id: "atlassian-team-update-archive.archive-error-title-single",
        defaultMessage: "Failed to archive team"
    },
    archiveErrorTitleBatch: {
        id: "atlassian-team-update-archive.archive-error-title-batch",
        defaultMessage: "Failed to archive teams"
    },
    archiveErrorDescription: {
        id: "atlassian-team-update-archive.archive-error-description",
        defaultMessage: "Something went wrong. Please try again."
    },
    archiveErrorGeneric: {
        id: "atlassian-team-update-archive.archive-error-generic",
        defaultMessage: "Failed to archive team"
    }
});
var $6efadab7d34def72$export$2e2bcd8739ae039 = $6efadab7d34def72$var$message;
module.exports["default"] = $6efadab7d34def72$export$2e2bcd8739ae039;

});

parcelRegister("8aQ9z", function(module, exports) {

var $iJxD8 = parcelRequire("iJxD8");

function $a59fc9048aa81845$export$434bc7569b17bc77(teamId) {
    try {
        if ((0, $iJxD8.IdentityTeamAri).check(teamId)) return teamId;
        return (0, $iJxD8.IdentityTeamAri).create({
            teamId: teamId
        }).toString();
    } catch  {
        return teamId;
    }
}
module.exports["toTeamAri"] = $a59fc9048aa81845$export$434bc7569b17bc77;

});

parcelRegister("6vTcx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $29deb30407f4e3a2$var$styles = {
    cardFooter: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $29deb30407f4e3a2$export$e9897d434e0741ee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $29deb30407f4e3a2$var$styles.cardFooter
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $29deb30407f4e3a2$var$styles.cardFooter
    }, children);
};
module.exports["CardFooter"] = $29deb30407f4e3a2$export$e9897d434e0741ee;

});

parcelRegister("bGT0d", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $aXvOq = parcelRequire("aXvOq");


var $7dQPx = parcelRequire("7dQPx");


var $hmuK5 = parcelRequire("hmuK5");

const $5f67b446d699649a$var$styles = {
    teamRow: "_0bjKvD8fU6 _4c065UgVvo _2Y7lL42ADO _39xV02N91d _2fwxA57p2s _0KLXrulfZc _0wOv4Q7zJH _1eOmH6d1Zr _3gzVzLJNoT",
    hiddenActionsBase: "_3iDTPbYbGa",
    hiddenActionsVisible: "_3iDTPbQ4SZ",
    teamRowDisabled: "_1pp6NdYbGa",
    teamRowContentDisabled: "_1YKVNsVx3j",
    iconWrapper: "_4c065U1Y8M _2Y7lL41Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $5f67b446d699649a$var$iconButtonDefaultProps = {
    isTooltipDisabled: false,
    appearance: 'subtle',
    spacing: 'compact'
};
const $5f67b446d699649a$var$IconWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5f67b446d699649a$var$styles.iconWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5f67b446d699649a$var$styles.iconWrapper
    }, children);
};
const $5f67b446d699649a$export$b2d4156b904068b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(84);
    const { team: team, onClick: onClick, actions: actions, hoverActions: hoverActions, isArchiving: t1, hasErrored: t2 } = t0;
    const isArchiving = t1 === undefined ? false : t1;
    const hasErrored = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isActionLoading, setIsActionLoading] = (0, $cozmU.useState)(false);
    let T0;
    let T1;
    let T2;
    let T3;
    let renderActions;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] !== actions || $[1] !== formatMessage || $[2] !== hasErrored || $[3] !== hoverActions || $[4] !== isActionLoading || $[5] !== isArchiving || $[6] !== isHovered || $[7] !== onClick || $[8] !== team) {
        const members = team.data.members?.edges?.map($5f67b446d699649a$var$_temp).filter(Boolean) ?? [];
        const memberCount = (0, $7dQPx.formatTeamMembersPreviewCount)(members.length);
        const teamTypeName = team.data.type?.name;
        const isDisabled = isArchiving || isActionLoading;
        const getDescription = ()=>{
            const hasMembersData = team.data.members?.edges != null;
            if (teamTypeName && hasMembersData) return formatMessage((0, $hmuK5.default).teamDescription, {
                teamType: teamTypeName,
                memberCount: memberCount
            });
            if (teamTypeName) return teamTypeName;
            if (hasMembersData) return formatMessage((0, $hmuK5.default).teamDescriptionMembersOnly, {
                memberCount: memberCount
            });
        };
        let t20;
        if ($[31] !== onClick) {
            t20 = (e_0)=>{
                if (onClick && (e_0.key === "Enter" || e_0.key === " ")) {
                    e_0.preventDefault();
                    onClick();
                }
            };
            $[31] = onClick;
            $[32] = t20;
        } else t20 = $[32];
        const handleKeyDown = t20;
        let t21;
        if ($[33] !== team) {
            t21 = (props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    key: `${props.label}-${index}`,
                    ...$5f67b446d699649a$var$iconButtonDefaultProps,
                    ...props,
                    onClick: async (e_1)=>{
                        e_1.stopPropagation();
                        setIsActionLoading(true);
                        await props.onClick?.(team);
                        setIsActionLoading(false);
                    }
                });
            $[33] = team;
            $[34] = t21;
        } else t21 = $[34];
        const renderActionButton = t21;
        let t22;
        if ($[35] !== actions || $[36] !== formatMessage || $[37] !== hasErrored || $[38] !== hoverActions || $[39] !== isActionLoading || $[40] !== isArchiving || $[41] !== isHovered || $[42] !== renderActionButton) {
            t22 = ()=>{
                if (hasErrored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: formatMessage((0, $hmuK5.default).errorTooltip)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f67b446d699649a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "",
                    color: "var(--ds-icon-warning, #E06C00)",
                    size: "medium"
                })));
                if (isArchiving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f67b446d699649a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                    size: "small"
                }));
                if (isActionLoading) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hoverActions && hoverActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    xcss: (0, $w6R6I.cx)($5f67b446d699649a$var$styles.hiddenActionsBase, isHovered && $5f67b446d699649a$var$styles.hiddenActionsVisible)
                }, hoverActions.map(renderActionButton)), actions?.map(renderActionButton));
            };
            $[35] = actions;
            $[36] = formatMessage;
            $[37] = hasErrored;
            $[38] = hoverActions;
            $[39] = isActionLoading;
            $[40] = isArchiving;
            $[41] = isHovered;
            $[42] = renderActionButton;
            $[43] = t22;
        } else t22 = $[43];
        renderActions = t22;
        T3 = (0, $iMnC5.Box);
        t11 = "archive-teams-card-team-item";
        t12 = onClick;
        const t23 = isDisabled && $5f67b446d699649a$var$styles.teamRowDisabled;
        if ($[44] !== t23) {
            t13 = (0, $w6R6I.cx)($5f67b446d699649a$var$styles.teamRow, t23);
            $[44] = t23;
            $[45] = t13;
        } else t13 = $[45];
        if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = ()=>setIsHovered(true);
            t15 = ()=>setIsHovered(false);
            t16 = ()=>setIsHovered(true);
            t17 = (e_2)=>{
                if (!e_2.currentTarget.contains(e_2.relatedTarget)) setIsHovered(false);
            };
            $[46] = t14;
            $[47] = t15;
            $[48] = t16;
            $[49] = t17;
        } else {
            t14 = $[46];
            t15 = $[47];
            t16 = $[48];
            t17 = $[49];
        }
        t18 = onClick ? 0 : undefined;
        t19 = handleKeyDown;
        T2 = (0, $1l0kj.Inline);
        t8 = "space.100";
        t9 = "center";
        t10 = "space-between";
        T1 = (0, $iMnC5.Box);
        t7 = isDisabled ? $5f67b446d699649a$var$styles.teamRowContentDisabled : undefined;
        T0 = (0, $aXvOq.TeamInlinePreview);
        t3 = team.data.teamId;
        t4 = team.data.displayName ?? "";
        t5 = team.data.largeAvatarImageUrl ?? undefined;
        t6 = getDescription();
        $[0] = actions;
        $[1] = formatMessage;
        $[2] = hasErrored;
        $[3] = hoverActions;
        $[4] = isActionLoading;
        $[5] = isArchiving;
        $[6] = isHovered;
        $[7] = onClick;
        $[8] = team;
        $[9] = T0;
        $[10] = T1;
        $[11] = T2;
        $[12] = T3;
        $[13] = renderActions;
        $[14] = t10;
        $[15] = t11;
        $[16] = t12;
        $[17] = t13;
        $[18] = t14;
        $[19] = t15;
        $[20] = t16;
        $[21] = t17;
        $[22] = t18;
        $[23] = t19;
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else {
        T0 = $[9];
        T1 = $[10];
        T2 = $[11];
        T3 = $[12];
        renderActions = $[13];
        t10 = $[14];
        t11 = $[15];
        t12 = $[16];
        t13 = $[17];
        t14 = $[18];
        t15 = $[19];
        t16 = $[20];
        t17 = $[21];
        t18 = $[22];
        t19 = $[23];
        t3 = $[24];
        t4 = $[25];
        t5 = $[26];
        t6 = $[27];
        t7 = $[28];
        t8 = $[29];
        t9 = $[30];
    }
    const t20 = team.data.isVerified ?? undefined;
    let t21;
    if ($[50] !== T0 || $[51] !== t20 || $[52] !== t3 || $[53] !== t4 || $[54] !== t5 || $[55] !== t6) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            teamId: t3,
            teamName: t4,
            overrideAvatarUrl: t5,
            description: t6,
            isVerified: t20,
            singleLine: true
        });
        $[50] = T0;
        $[51] = t20;
        $[52] = t3;
        $[53] = t4;
        $[54] = t5;
        $[55] = t6;
        $[56] = t21;
    } else t21 = $[56];
    let t22;
    if ($[57] !== T1 || $[58] !== t21 || $[59] !== t7) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            xcss: t7
        }, t21);
        $[57] = T1;
        $[58] = t21;
        $[59] = t7;
        $[60] = t22;
    } else t22 = $[60];
    let t23;
    if ($[61] !== renderActions) {
        t23 = renderActions();
        $[61] = renderActions;
        $[62] = t23;
    } else t23 = $[62];
    let t24;
    if ($[63] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, t23);
        $[63] = t23;
        $[64] = t24;
    } else t24 = $[64];
    let t25;
    if ($[65] !== T2 || $[66] !== t10 || $[67] !== t22 || $[68] !== t24 || $[69] !== t8 || $[70] !== t9) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T2, {
            space: t8,
            alignBlock: t9,
            spread: t10
        }, t22, t24);
        $[65] = T2;
        $[66] = t10;
        $[67] = t22;
        $[68] = t24;
        $[69] = t8;
        $[70] = t9;
        $[71] = t25;
    } else t25 = $[71];
    let t26;
    if ($[72] !== T3 || $[73] !== t11 || $[74] !== t12 || $[75] !== t13 || $[76] !== t14 || $[77] !== t15 || $[78] !== t16 || $[79] !== t17 || $[80] !== t18 || $[81] !== t19 || $[82] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T3, {
            testId: t11,
            onClick: t12,
            xcss: t13,
            onMouseEnter: t14,
            onMouseLeave: t15,
            onFocus: t16,
            onBlur: t17,
            tabIndex: t18,
            onKeyDown: t19
        }, t25);
        $[72] = T3;
        $[73] = t11;
        $[74] = t12;
        $[75] = t13;
        $[76] = t14;
        $[77] = t15;
        $[78] = t16;
        $[79] = t17;
        $[80] = t18;
        $[81] = t19;
        $[82] = t25;
        $[83] = t26;
    } else t26 = $[83];
    return t26;
} : ({ team: team, onClick: onClick, actions: actions, hoverActions: hoverActions, isArchiving: isArchiving = false, hasErrored: hasErrored = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isActionLoading, setIsActionLoading] = (0, $cozmU.useState)(false);
    const members = team.data.members?.edges?.map((e)=>e?.node?.member).filter(Boolean) ?? [];
    const memberCount = (0, $7dQPx.formatTeamMembersPreviewCount)(members.length);
    const teamTypeName = team.data.type?.name;
    const isDisabled = isArchiving || isActionLoading;
    const getDescription = ()=>{
        const hasMembersData = team.data.members?.edges != null;
        if (teamTypeName && hasMembersData) return formatMessage((0, $hmuK5.default).teamDescription, {
            teamType: teamTypeName,
            memberCount: memberCount
        });
        if (teamTypeName) return teamTypeName;
        if (hasMembersData) return formatMessage((0, $hmuK5.default).teamDescriptionMembersOnly, {
            memberCount: memberCount
        });
        return undefined;
    };
    const handleKeyDown = (e_0)=>{
        if (onClick && (e_0.key === 'Enter' || e_0.key === ' ')) {
            e_0.preventDefault();
            onClick();
        }
    };
    const renderActionButton = (props, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            key: `${props.label}-${index}`,
            ...$5f67b446d699649a$var$iconButtonDefaultProps,
            ...props,
            onClick: async (e_1)=>{
                e_1.stopPropagation();
                setIsActionLoading(true);
                await props.onClick?.(team);
                setIsActionLoading(false);
            }
        });
    };
    const renderActions = ()=>{
        if (hasErrored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $hmuK5.default).errorTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f67b446d699649a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-warning, #E06C00)",
            size: "medium"
        })));
        if (isArchiving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f67b446d699649a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small"
        }));
        if (isActionLoading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hoverActions && hoverActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: (0, $w6R6I.cx)($5f67b446d699649a$var$styles.hiddenActionsBase, isHovered && $5f67b446d699649a$var$styles.hiddenActionsVisible)
        }, hoverActions.map(renderActionButton)), actions?.map(renderActionButton));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "archive-teams-card-team-item",
        onClick: onClick,
        xcss: (0, $w6R6I.cx)($5f67b446d699649a$var$styles.teamRow, isDisabled && $5f67b446d699649a$var$styles.teamRowDisabled),
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: (e_2)=>{
            if (!e_2.currentTarget.contains(e_2.relatedTarget)) setIsHovered(false);
        },
        tabIndex: onClick ? 0 : undefined,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isDisabled ? $5f67b446d699649a$var$styles.teamRowContentDisabled : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXvOq.TeamInlinePreview), {
        teamId: team.data.teamId,
        teamName: team.data.displayName ?? '',
        overrideAvatarUrl: team.data.largeAvatarImageUrl ?? undefined,
        description: getDescription(),
        isVerified: team.data.isVerified ?? undefined,
        singleLine: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, renderActions())));
};
function $5f67b446d699649a$var$_temp(e) {
    return e?.node?.member;
}
module.exports["TeamItem"] = $5f67b446d699649a$export$b2d4156b904068b0;

});

parcelRegister("cMGrl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $aXvOq = parcelRequire("aXvOq");


var $hmuK5 = parcelRequire("hmuK5");


var $7dQPx = parcelRequire("7dQPx");


var $4IqDi = parcelRequire("4IqDi");

const $6b28e887c1ed6681$export$c3e84fe0e2864908 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { team: team, actions: actions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [loadingActionIdx, setLoadingActionIdx] = (0, $cozmU.useState)(null);
    let T0;
    let T1;
    let T2;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== formatMessage || $[1] !== team.data.displayName || $[2] !== team.data.isVerified || $[3] !== team.data.largeAvatarImageUrl || $[4] !== team.data.members?.edges || $[5] !== team.data.teamId || $[6] !== team.data.type?.name) {
        const members = team.data.members?.edges?.map($6b28e887c1ed6681$var$_temp).filter(Boolean) ?? [];
        const memberCount = (0, $7dQPx.formatTeamMembersPreviewCount)(members.length);
        const teamTypeName = team.data.type?.name;
        const getDescription = ()=>{
            const hasMembersData = team.data.members?.edges != null;
            if (teamTypeName && hasMembersData) return formatMessage((0, $hmuK5.default).teamDescription, {
                teamType: teamTypeName,
                memberCount: memberCount
            });
            if (teamTypeName) return teamTypeName;
            if (hasMembersData) return formatMessage((0, $hmuK5.default).teamDescriptionMembersOnly, {
                memberCount: memberCount
            });
        };
        T2 = (0, $dinVW.Stack);
        t4 = "space.150";
        T1 = (0, $dinVW.Stack);
        t2 = "space.100";
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXvOq.TeamInlinePreview), {
            teamId: team.data.teamId,
            teamName: team.data.displayName ?? "",
            description: getDescription(),
            overrideAvatarUrl: team.data.largeAvatarImageUrl ?? undefined,
            isVerified: team.data.isVerified ?? undefined,
            singleLine: true
        });
        T0 = (0, $4IqDi.TeamMembersAvatarGroup);
        t1 = members.map($6b28e887c1ed6681$var$_temp2);
        $[0] = formatMessage;
        $[1] = team.data.displayName;
        $[2] = team.data.isVerified;
        $[3] = team.data.largeAvatarImageUrl;
        $[4] = team.data.members?.edges;
        $[5] = team.data.teamId;
        $[6] = team.data.type?.name;
        $[7] = T0;
        $[8] = T1;
        $[9] = T2;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
    } else {
        T0 = $[7];
        T1 = $[8];
        T2 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
    }
    let t5;
    if ($[14] !== T0 || $[15] !== t1) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            members: t1
        });
        $[14] = T0;
        $[15] = t1;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== team.data.description) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 3
        }, team.data.description);
        $[17] = team.data.description;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== T1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t5 || $[23] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            space: t2
        }, t3, t5, t6);
        $[19] = T1;
        $[20] = t2;
        $[21] = t3;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== actions || $[26] !== loadingActionIdx || $[27] !== team) {
        let t9;
        if ($[29] !== loadingActionIdx || $[30] !== team) {
            t9 = (action, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    ...action,
                    key: idx,
                    spacing: "compact",
                    onClick: async ()=>{
                        setLoadingActionIdx(idx);
                        await action.onClick(team);
                        setLoadingActionIdx(null);
                    },
                    isLoading: loadingActionIdx === idx
                }, action.children);
            $[29] = loadingActionIdx;
            $[30] = team;
            $[31] = t9;
        } else t9 = $[31];
        t8 = actions.map(t9);
        $[25] = actions;
        $[26] = loadingActionIdx;
        $[27] = team;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[32] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, t8);
        $[32] = t8;
        $[33] = t9;
    } else t9 = $[33];
    let t10;
    if ($[34] !== T2 || $[35] !== t4 || $[36] !== t7 || $[37] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T2, {
            space: t4
        }, t7, t9);
        $[34] = T2;
        $[35] = t4;
        $[36] = t7;
        $[37] = t9;
        $[38] = t10;
    } else t10 = $[38];
    return t10;
} : ({ team: team, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [loadingActionIdx, setLoadingActionIdx] = (0, $cozmU.useState)(null);
    const members = team.data.members?.edges?.map((e)=>e?.node?.member).filter(Boolean) ?? [];
    const memberCount = (0, $7dQPx.formatTeamMembersPreviewCount)(members.length);
    const teamTypeName = team.data.type?.name;
    const getDescription = ()=>{
        const hasMembersData = team.data.members?.edges != null;
        if (teamTypeName && hasMembersData) return formatMessage((0, $hmuK5.default).teamDescription, {
            teamType: teamTypeName,
            memberCount: memberCount
        });
        if (teamTypeName) return teamTypeName;
        if (hasMembersData) return formatMessage((0, $hmuK5.default).teamDescriptionMembersOnly, {
            memberCount: memberCount
        });
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXvOq.TeamInlinePreview), {
        teamId: team.data.teamId,
        teamName: team.data.displayName ?? '',
        description: getDescription(),
        overrideAvatarUrl: team.data.largeAvatarImageUrl ?? undefined,
        isVerified: team.data.isVerified ?? undefined,
        singleLine: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4IqDi.TeamMembersAvatarGroup), {
        members: members.map((m)=>({
                accountId: m?.accountId ?? '',
                name: m?.name ?? '',
                picture: m?.picture ?? undefined
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 3
    }, team.data.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075"
    }, actions.map((action, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            ...action,
            key: idx,
            spacing: "compact",
            onClick: async ()=>{
                setLoadingActionIdx(idx);
                await action.onClick(team);
                setLoadingActionIdx(null);
            },
            isLoading: loadingActionIdx === idx
        }, action.children))));
};
function $6b28e887c1ed6681$var$_temp(e) {
    return e?.node?.member;
}
function $6b28e887c1ed6681$var$_temp2(m) {
    return {
        accountId: m?.accountId ?? "",
        name: m?.name ?? "",
        picture: m?.picture ?? undefined
    };
}
module.exports["TeamCard"] = $6b28e887c1ed6681$export$c3e84fe0e2864908;

});

parcelRegister("fRUA2", function(module, exports) {
// src/capacity-planning/custom-contribution-target/types.ts
var $b8d7b1ee3faf6071$export$bb415cdf58c4719 = "capacity-planning", $b8d7b1ee3faf6071$export$54b2ab8050a66c0d = "custom-contribution-target";
module.exports["CapacityPlanningCustomContributionTargetAriResourceOwner"] = $b8d7b1ee3faf6071$export$bb415cdf58c4719;
module.exports["CapacityPlanningCustomContributionTargetAriResourceType"] = $b8d7b1ee3faf6071$export$54b2ab8050a66c0d;

});

parcelRegister("d64XA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $1sCHt = parcelRequire("1sCHt");


var $2uDbg = parcelRequire("2uDbg");


var $w6R6I = parcelRequire("w6R6I");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $gvq7D = parcelRequire("gvq7D");


var $iOVAY = parcelRequire("iOVAY");


var $MjdYo = parcelRequire("MjdYo");


var $jVsqU = parcelRequire("jVsqU");

const $5a3c9a7d72e5a761$var$checkboxLabelMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item-checkbox",
    defaultMessage: "Select action"
});
const $5a3c9a7d72e5a761$var$acceptLabelMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item-accept",
    defaultMessage: "Accept"
});
const $5a3c9a7d72e5a761$var$dismissLabelMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item-dismiss",
    defaultMessage: "Dismiss"
});
const $5a3c9a7d72e5a761$var$addContributorMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.add-person-to-view",
    defaultMessage: "Add to capacity plan"
});
const $5a3c9a7d72e5a761$var$allocateToWorkMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-to-work",
    defaultMessage: "Allocate to {workItem}"
});
const $5a3c9a7d72e5a761$var$allocateToContributorMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-to-contributor",
    defaultMessage: "Allocate to \"{contributorName}\""
});
const $5a3c9a7d72e5a761$var$createNonProjectWorkMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.create-non-project-work",
    defaultMessage: "Allocate to {nonProjectWorkItem}"
});
const $5a3c9a7d72e5a761$var$allocateContributionMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-from-to-at",
    defaultMessage: "Allocate to {workItem} from {startDate} to {endDate} at {value}{valueUnit}"
});
const $5a3c9a7d72e5a761$var$allocateContributionHoursMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-from-to-hours",
    defaultMessage: "Allocate to {workItem} for {value} hours each week from {startDate} to {endDate}"
});
const $5a3c9a7d72e5a761$var$allocateContributionHoursSingleDayMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-hours-single-day",
    defaultMessage: "Allocate to {workItem} for {value} hours on {startDate}"
});
const $5a3c9a7d72e5a761$var$allocateContributionDaysMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-from-to-days",
    defaultMessage: "Allocate to {workItem} for {value} days from {startDate} to {endDate}"
});
const $5a3c9a7d72e5a761$var$allocateContributionDaysSingleDayMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-days-single-day",
    defaultMessage: "Allocate to {workItem} on {startDate}"
});
const $5a3c9a7d72e5a761$var$allocateContributionPercentageMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-from-to-percentage",
    defaultMessage: "Allocate to {workItem} from {startDate} to {endDate} at {value}{valueUnit}"
});
const $5a3c9a7d72e5a761$var$allocateContributionPercentageSingleDayMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.allocate-percentage-single-day",
    defaultMessage: "Allocate to {workItem} on {startDate} at {value}{valueUnit}"
});
const $5a3c9a7d72e5a761$var$removeFromWorkMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.remove-from-work",
    defaultMessage: "Remove from {workItem}"
});
const $5a3c9a7d72e5a761$var$unitPercentMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.unit-percent",
    defaultMessage: "%"
});
const $5a3c9a7d72e5a761$var$unitHoursMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.unit-hours",
    defaultMessage: " hours"
});
const $5a3c9a7d72e5a761$var$unitDaysMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.unit-days",
    defaultMessage: " days"
});
const $5a3c9a7d72e5a761$var$removeContributorMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.remove-person-from-view",
    defaultMessage: "Remove from capacity plan"
});
const $5a3c9a7d72e5a761$var$renameNonProjectWorkMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-item.rename-non-project-work",
    defaultMessage: "Rename {currentName} to {newName}"
});
const $5a3c9a7d72e5a761$var$actionCompletedMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-completed",
    defaultMessage: "Action completed"
});
const $5a3c9a7d72e5a761$var$actionFailedMessage = (0, $kSwu1.defineMessage)({
    id: "capacity-planning.action-failed",
    defaultMessage: "Action failed"
});
const $5a3c9a7d72e5a761$var$ICON_COLUMN_WIDTH = 24;
const $5a3c9a7d72e5a761$var$styles = {
    root: "_0bjKvDKxmn _3iDTPbgBM8 _2iEGP23XqY _0hPCNLDIqT _2XsHFM5UaJ _0adFHs5UaJ _2Zuz6Q1Y8M _1Znuxb1Y8M _0Of8r21Y8M _1wydGW1Y8M _1eOmH6d1Zr",
    label: "_4bt5LAYvD1 _2WAcuGYvD1 _2j3gqAiZR3 _2Zuz6QgVvo _4ouGXIdnbC _1EqgXlN91d",
    labelContent: "_4bt5LAYvD1 _2WAcuGYvD1 _4ouGXIdnbC _1EqgXlN91d _1ANEUSzUZr _3W2Oc8wPeg",
    actionButtons: "_2j3gqA7LI7 _1YKVNs7dHp",
    actionButtonsHidden: "_1YKVNsdnbC _1pp6NdYbGa",
    checkbox: "_1YKVNs7dHp _3iDTPbQ4SZ _37wbyuDIqT",
    checkboxHidden: "_1YKVNsdnbC",
    statusIcon: "_2j3gqA7dHp _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _2p6ht9DIqT"
};
const $5a3c9a7d72e5a761$var$ActionItemStatus = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ActionItemStatus(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { isChecked: isChecked, onToggle: onToggle, showCheckbox: showCheckbox, status: status } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== isChecked || $[1] !== onToggle) {
        t1 = (e)=>{
            onToggle(!isChecked);
            e.target.blur();
        };
        $[0] = isChecked;
        $[1] = onToggle;
        $[2] = t1;
    } else t1 = $[2];
    const handleChange = t1;
    switch(status){
        case "started":
            {
                let t2;
                if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                    t2 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                        size: "small",
                        interactionName: "load"
                    });
                    $[3] = t2;
                } else t2 = $[3];
                return t2;
            }
        case "finished":
            {
                let t2;
                if ($[4] !== formatMessage) {
                    t2 = formatMessage($5a3c9a7d72e5a761$var$actionCompletedMessage);
                    $[4] = formatMessage;
                    $[5] = t2;
                } else t2 = $[5];
                let t3;
                if ($[6] !== t2) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                        label: t2,
                        color: "var(--ds-icon-success, #6A9A23)",
                        size: "medium"
                    });
                    $[6] = t2;
                    $[7] = t3;
                } else t3 = $[7];
                return t3;
            }
        case "errored":
        case "cancelled":
            {
                let t2;
                if ($[8] !== formatMessage) {
                    t2 = formatMessage($5a3c9a7d72e5a761$var$actionFailedMessage);
                    $[8] = formatMessage;
                    $[9] = t2;
                } else t2 = $[9];
                let t3;
                if ($[10] !== t2) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                        label: t2,
                        color: "var(--ds-icon-danger, #C9372C)",
                        size: "medium"
                    });
                    $[10] = t2;
                    $[11] = t3;
                } else t3 = $[11];
                return t3;
            }
        default:
            {
                const t2 = !showCheckbox && $5a3c9a7d72e5a761$var$styles.checkboxHidden;
                let t3;
                if ($[12] !== t2) {
                    t3 = (0, $w6R6I.cx)($5a3c9a7d72e5a761$var$styles.checkbox, t2);
                    $[12] = t2;
                    $[13] = t3;
                } else t3 = $[13];
                let t4;
                if ($[14] !== formatMessage) {
                    t4 = formatMessage($5a3c9a7d72e5a761$var$checkboxLabelMessage);
                    $[14] = formatMessage;
                    $[15] = t4;
                } else t4 = $[15];
                let t5;
                if ($[16] !== handleChange || $[17] !== isChecked || $[18] !== t4) {
                    t5 = /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
                        "aria-label": t4,
                        isChecked: isChecked,
                        onChange: handleChange
                    });
                    $[16] = handleChange;
                    $[17] = isChecked;
                    $[18] = t4;
                    $[19] = t5;
                } else t5 = $[19];
                let t6;
                if ($[20] !== t3 || $[21] !== t5) {
                    t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        xcss: t3
                    }, t5);
                    $[20] = t3;
                    $[21] = t5;
                    $[22] = t6;
                } else t6 = $[22];
                return t6;
            }
    }
} : function ActionItemStatus({ isChecked: isChecked, onToggle: onToggle, showCheckbox: showCheckbox, status: status }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleChange = (e)=>{
        onToggle(!isChecked);
        e.target.blur();
    };
    switch(status){
        case 'started':
            return /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: "small",
                interactionName: "load"
            });
        case 'finished':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                label: formatMessage($5a3c9a7d72e5a761$var$actionCompletedMessage),
                color: "var(--ds-icon-success, #6A9A23)",
                size: "medium"
            });
        case 'errored':
        case 'cancelled':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: formatMessage($5a3c9a7d72e5a761$var$actionFailedMessage),
                color: "var(--ds-icon-danger, #C9372C)",
                size: "medium"
            });
        default:
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($5a3c9a7d72e5a761$var$styles.checkbox, !showCheckbox && $5a3c9a7d72e5a761$var$styles.checkboxHidden)
            }, /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
                "aria-label": formatMessage($5a3c9a7d72e5a761$var$checkboxLabelMessage),
                isChecked: isChecked,
                onChange: handleChange
            }));
    }
};
const $5a3c9a7d72e5a761$var$ActionItemLabel = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ActionItemLabel(t0) {
    const $ = (0, $bDgLe.c)(69);
    const { payload: payload, workById: workById, viewType: viewType, hydratedUsers: hydratedUsers } = t0;
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatDate) {
        t1 = (dateString)=>{
            const timestamp = Date.parse(dateString);
            if (Number.isNaN(timestamp)) return dateString;
            const date = new Date(timestamp);
            return formatDate(date, {
                month: "short",
                day: "numeric"
            });
        };
        $[0] = formatDate;
        $[1] = t1;
    } else t1 = $[1];
    const formatContributionDate = t1;
    let t2;
    if ($[2] !== formatMessage) {
        t2 = (valueType)=>{
            switch(valueType?.toUpperCase()){
                case "PERCENTAGE":
                    return formatMessage($5a3c9a7d72e5a761$var$unitPercentMessage);
                case "HOURS":
                    return formatMessage($5a3c9a7d72e5a761$var$unitHoursMessage);
                case "DAYS":
                    return formatMessage($5a3c9a7d72e5a761$var$unitDaysMessage);
                default:
                    return "";
            }
        };
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    const getValueUnit = t2;
    switch(payload.action){
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTOR_WORK:
            {
                if (viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE) {
                    let t3;
                    if ($[4] !== payload || $[5] !== workById) {
                        t3 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                            ...$5a3c9a7d72e5a761$var$allocateToWorkMessage,
                            values: {
                                workItem: /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
                                    payload: payload,
                                    workById: workById
                                })
                            }
                        });
                        $[4] = payload;
                        $[5] = workById;
                        $[6] = t3;
                    } else t3 = $[6];
                    return t3;
                }
                let T0;
                let t3;
                let t4;
                if ($[7] !== hydratedUsers || $[8] !== payload) {
                    const contributorDataId_0 = (0, $iOVAY.getContributorDataId)(payload);
                    T0 = (0, $kSwu1.FormattedMessage);
                    t4 = $5a3c9a7d72e5a761$var$allocateToContributorMessage;
                    t3 = (contributorDataId_0 ? hydratedUsers.get(contributorDataId_0)?.name : undefined) ?? contributorDataId_0 ?? "";
                    $[7] = hydratedUsers;
                    $[8] = payload;
                    $[9] = T0;
                    $[10] = t3;
                    $[11] = t4;
                } else {
                    T0 = $[9];
                    t3 = $[10];
                    t4 = $[11];
                }
                let t5;
                if ($[12] !== t3) {
                    t5 = {
                        contributorName: t3
                    };
                    $[12] = t3;
                    $[13] = t5;
                } else t5 = $[13];
                let t6;
                if ($[14] !== T0 || $[15] !== t4 || $[16] !== t5) {
                    t6 = /*#__PURE__*/ $cozmU.createElement(T0, {
                        ...t4,
                        values: t5
                    });
                    $[14] = T0;
                    $[15] = t4;
                    $[16] = t5;
                    $[17] = t6;
                } else t6 = $[17];
                return t6;
            }
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTORS:
        case (0, $gvq7D.CapacityPlanningActionType).ADD_WORKS:
            {
                let t3;
                if ($[18] !== formatMessage) {
                    t3 = formatMessage($5a3c9a7d72e5a761$var$addContributorMessage);
                    $[18] = formatMessage;
                    $[19] = t3;
                } else t3 = $[19];
                return t3;
            }
        case (0, $gvq7D.CapacityPlanningActionType).CREATE_NON_PROJECT_WORK:
            {
                const t3 = `'${payload.inputs.name}'`;
                let t4;
                if ($[20] !== formatMessage || $[21] !== t3) {
                    t4 = formatMessage($5a3c9a7d72e5a761$var$createNonProjectWorkMessage, {
                        nonProjectWorkItem: t3
                    });
                    $[20] = formatMessage;
                    $[21] = t3;
                    $[22] = t4;
                } else t4 = $[22];
                return t4;
            }
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTOR_WORK:
            {
                let workItem;
                if ($[23] !== hydratedUsers || $[24] !== payload || $[25] !== viewType || $[26] !== workById) {
                    const contributorDataId = (0, $iOVAY.getContributorDataId)(payload);
                    workItem = "";
                    if (viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE) {
                        let t3;
                        if ($[28] !== payload || $[29] !== workById) {
                            t3 = /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
                                payload: payload,
                                workById: workById
                            });
                            $[28] = payload;
                            $[29] = workById;
                            $[30] = t3;
                        } else t3 = $[30];
                        workItem = t3;
                    } else if (contributorDataId) workItem = `"${hydratedUsers.get(contributorDataId)?.name ?? ""}"`;
                    $[23] = hydratedUsers;
                    $[24] = payload;
                    $[25] = viewType;
                    $[26] = workById;
                    $[27] = workItem;
                } else workItem = $[27];
                let t3;
                if ($[31] !== workItem) {
                    t3 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$5a3c9a7d72e5a761$var$removeFromWorkMessage,
                        values: {
                            workItem: workItem
                        }
                    });
                    $[31] = workItem;
                    $[32] = t3;
                } else t3 = $[32];
                return t3;
            }
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTORS:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_WORKS:
            {
                let t3;
                if ($[33] !== formatMessage) {
                    t3 = formatMessage($5a3c9a7d72e5a761$var$removeContributorMessage);
                    $[33] = formatMessage;
                    $[34] = t3;
                } else t3 = $[34];
                return t3;
            }
        case (0, $gvq7D.CapacityPlanningActionType).UPDATE_CONTRIBUTIONS:
            {
                const first = payload.inputs.contributions[0];
                let t3;
                if ($[35] !== first.valueType) {
                    t3 = first.valueType?.toUpperCase();
                    $[35] = first.valueType;
                    $[36] = t3;
                } else t3 = $[36];
                const valueType_0 = t3;
                const isSingleDay = first.startDate === first.endDate;
                let t4;
                if ($[37] !== first.endDate || $[38] !== first.startDate || $[39] !== first.value || $[40] !== isSingleDay || $[41] !== valueType_0) {
                    t4 = valueType_0 === "HOURS" && !isSingleDay ? (0, $iOVAY.getWeeklyHours)(first.value, first.startDate, first.endDate) : first.value;
                    $[37] = first.endDate;
                    $[38] = first.startDate;
                    $[39] = first.value;
                    $[40] = isSingleDay;
                    $[41] = valueType_0;
                    $[42] = t4;
                } else t4 = $[42];
                const displayValue = t4;
                let messageToUse;
                bb0: switch(valueType_0){
                    case "HOURS":
                        messageToUse = isSingleDay ? $5a3c9a7d72e5a761$var$allocateContributionHoursSingleDayMessage : $5a3c9a7d72e5a761$var$allocateContributionHoursMessage;
                        break bb0;
                    case "DAYS":
                        messageToUse = isSingleDay ? $5a3c9a7d72e5a761$var$allocateContributionDaysSingleDayMessage : $5a3c9a7d72e5a761$var$allocateContributionDaysMessage;
                        break bb0;
                    case "PERCENTAGE":
                        messageToUse = isSingleDay ? $5a3c9a7d72e5a761$var$allocateContributionPercentageSingleDayMessage : $5a3c9a7d72e5a761$var$allocateContributionPercentageMessage;
                        break bb0;
                    default:
                        messageToUse = $5a3c9a7d72e5a761$var$allocateContributionMessage;
                }
                const t5 = messageToUse;
                let t6;
                if ($[43] !== first.endDate || $[44] !== formatContributionDate) {
                    t6 = formatContributionDate(first.endDate);
                    $[43] = first.endDate;
                    $[44] = formatContributionDate;
                    $[45] = t6;
                } else t6 = $[45];
                let t7;
                if ($[46] !== first.startDate || $[47] !== formatContributionDate) {
                    t7 = formatContributionDate(first.startDate);
                    $[46] = first.startDate;
                    $[47] = formatContributionDate;
                    $[48] = t7;
                } else t7 = $[48];
                let t8;
                if ($[49] !== first.valueType || $[50] !== getValueUnit) {
                    t8 = getValueUnit(first.valueType);
                    $[49] = first.valueType;
                    $[50] = getValueUnit;
                    $[51] = t8;
                } else t8 = $[51];
                let t9;
                if ($[52] !== hydratedUsers || $[53] !== payload || $[54] !== viewType || $[55] !== workById) {
                    t9 = viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE ? /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
                        payload: payload,
                        workById: workById
                    }) : (0, $iOVAY.getContributorDataId)(payload) ? `"${hydratedUsers.get((0, $iOVAY.getContributorDataId)(payload))?.name ?? ""}"` : "";
                    $[52] = hydratedUsers;
                    $[53] = payload;
                    $[54] = viewType;
                    $[55] = workById;
                    $[56] = t9;
                } else t9 = $[56];
                let t10;
                if ($[57] !== displayValue || $[58] !== t6 || $[59] !== t7 || $[60] !== t8 || $[61] !== t9) {
                    t10 = {
                        endDate: t6,
                        startDate: t7,
                        value: displayValue,
                        valueUnit: t8,
                        workItem: t9
                    };
                    $[57] = displayValue;
                    $[58] = t6;
                    $[59] = t7;
                    $[60] = t8;
                    $[61] = t9;
                    $[62] = t10;
                } else t10 = $[62];
                let t11;
                if ($[63] !== messageToUse || $[64] !== t10) {
                    t11 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...t5,
                        values: t10
                    });
                    $[63] = messageToUse;
                    $[64] = t10;
                    $[65] = t11;
                } else t11 = $[65];
                return t11;
            }
        case (0, $gvq7D.CapacityPlanningActionType).RENAME_NON_PROJECT_WORK:
            {
                const currentName = workById.get(payload.inputs.id)?.name ?? payload.inputs.id;
                const t3 = `'${currentName}'`;
                const t4 = `'${payload.inputs.name}'`;
                let t5;
                if ($[66] !== t3 || $[67] !== t4) {
                    t5 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                        ...$5a3c9a7d72e5a761$var$renameNonProjectWorkMessage,
                        values: {
                            currentName: t3,
                            newName: t4
                        }
                    });
                    $[66] = t3;
                    $[67] = t4;
                    $[68] = t5;
                } else t5 = $[68];
                return t5;
            }
        default:
            return "";
    }
} : function ActionItemLabel({ payload: payload, workById: workById, viewType: viewType, hydratedUsers: hydratedUsers }) {
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const formatContributionDate = (dateString)=>{
        const timestamp = Date.parse(dateString);
        if (Number.isNaN(timestamp)) return dateString;
        const date = new Date(timestamp);
        return formatDate(date, {
            month: 'short',
            day: 'numeric'
        });
    };
    const getValueUnit = (valueType)=>{
        switch(valueType?.toUpperCase()){
            case 'PERCENTAGE':
                return formatMessage($5a3c9a7d72e5a761$var$unitPercentMessage);
            case 'HOURS':
                return formatMessage($5a3c9a7d72e5a761$var$unitHoursMessage);
            case 'DAYS':
                return formatMessage($5a3c9a7d72e5a761$var$unitDaysMessage);
            default:
                return '';
        }
    };
    switch(payload.action){
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTOR_WORK:
            {
                if (viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE) // note: keep it as FormattedMessage otherwise the work item will be rendered as a string instead of a React node
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$5a3c9a7d72e5a761$var$allocateToWorkMessage,
                    values: {
                        workItem: /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
                            payload: payload,
                            workById: workById
                        })
                    }
                });
                const contributorDataId_0 = (0, $iOVAY.getContributorDataId)(payload);
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$5a3c9a7d72e5a761$var$allocateToContributorMessage,
                    values: {
                        contributorName: (contributorDataId_0 ? hydratedUsers.get(contributorDataId_0)?.name : undefined) ?? contributorDataId_0 ?? ''
                    }
                });
            }
        case (0, $gvq7D.CapacityPlanningActionType).ADD_CONTRIBUTORS:
        case (0, $gvq7D.CapacityPlanningActionType).ADD_WORKS:
            return formatMessage($5a3c9a7d72e5a761$var$addContributorMessage);
        case (0, $gvq7D.CapacityPlanningActionType).CREATE_NON_PROJECT_WORK:
            return formatMessage($5a3c9a7d72e5a761$var$createNonProjectWorkMessage, {
                nonProjectWorkItem: `'${payload.inputs.name}'`
            });
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTOR_WORK:
            {
                const contributorDataId = (0, $iOVAY.getContributorDataId)(payload);
                let workItem = '';
                if (viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE) workItem = /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
                    payload: payload,
                    workById: workById
                });
                else if (contributorDataId) workItem = `"${hydratedUsers.get(contributorDataId)?.name ?? ''}"`;
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$5a3c9a7d72e5a761$var$removeFromWorkMessage,
                    values: {
                        workItem: workItem
                    }
                });
            }
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_CONTRIBUTORS:
        case (0, $gvq7D.CapacityPlanningActionType).REMOVE_WORKS:
            return formatMessage($5a3c9a7d72e5a761$var$removeContributorMessage);
        case (0, $gvq7D.CapacityPlanningActionType).UPDATE_CONTRIBUTIONS:
            {
                const first = payload.inputs.contributions[0];
                const valueType_0 = first.valueType?.toUpperCase();
                const isSingleDay = first.startDate === first.endDate; // For multi-day HOURS allocations, convert the total hours to a weekly equivalent
                // so the card reads "X hours each week" rather than the raw total.
                const displayValue = valueType_0 === 'HOURS' && !isSingleDay ? (0, $iOVAY.getWeeklyHours)(first.value, first.startDate, first.endDate) : first.value;
                let messageToUse;
                switch(valueType_0){
                    case 'HOURS':
                        messageToUse = isSingleDay ? $5a3c9a7d72e5a761$var$allocateContributionHoursSingleDayMessage : $5a3c9a7d72e5a761$var$allocateContributionHoursMessage;
                        break;
                    case 'DAYS':
                        messageToUse = isSingleDay ? $5a3c9a7d72e5a761$var$allocateContributionDaysSingleDayMessage : $5a3c9a7d72e5a761$var$allocateContributionDaysMessage;
                        break;
                    case 'PERCENTAGE':
                        messageToUse = isSingleDay ? $5a3c9a7d72e5a761$var$allocateContributionPercentageSingleDayMessage : $5a3c9a7d72e5a761$var$allocateContributionPercentageMessage;
                        break;
                    default:
                        messageToUse = $5a3c9a7d72e5a761$var$allocateContributionMessage;
                        break;
                }
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...messageToUse,
                    values: {
                        endDate: formatContributionDate(first.endDate),
                        startDate: formatContributionDate(first.startDate),
                        value: displayValue,
                        valueUnit: getValueUnit(first.valueType),
                        workItem: viewType === (0, $MjdYo.VIEW_TYPE).PEOPLE ? /*#__PURE__*/ $cozmU.createElement((0, $jVsqU.default), {
                            payload: payload,
                            workById: workById
                        }) : (0, $iOVAY.getContributorDataId)(payload) ? `"${hydratedUsers.get((0, $iOVAY.getContributorDataId)(payload))?.name ?? ''}"` : ''
                    }
                });
            }
        case (0, $gvq7D.CapacityPlanningActionType).RENAME_NON_PROJECT_WORK:
            {
                const currentName = workById.get(payload.inputs.id)?.name ?? payload.inputs.id;
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$5a3c9a7d72e5a761$var$renameNonProjectWorkMessage,
                    values: {
                        currentName: `'${currentName}'`,
                        newName: `'${payload.inputs.name}'`
                    }
                });
            }
        default:
            return '';
    }
};
function $5a3c9a7d72e5a761$export$ac06cb4ab481cfab({ action: action, getStatus: getStatus, isChecked: isChecked, onCancel: onCancel, onConfirm: onConfirm, onToggle: onToggle, payload: payload, workById: workById, viewType: viewType, hydratedUsers: hydratedUsers }) {
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>setIsHovered(true), []);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>setIsHovered(false), []);
    const status = getStatus(action);
    const isDisabled = status !== 'idle';
    const effectiveStatus = isDisabled ? status : action.status ?? 'idle';
    const isSubmitting = effectiveStatus === 'started';
    const isActionCompleted = effectiveStatus === 'finished' || effectiveStatus === 'errored' || effectiveStatus === 'cancelled';
    const showCheckbox = !isActionCompleted && (isHovered || isChecked);
    const showActionButtons = !isActionCompleted && isHovered;
    const handleAccept = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoCapacityPlanningSingleAccept',
            eventType: 'ui',
            attributes: {
                actionType: payload.action,
                viewType: viewType
            }
        });
        return onConfirm(action);
    }, [
        sendAnalyticsEvent,
        payload.action,
        viewType,
        action,
        onConfirm
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoCapacityPlanningSingleDismiss',
            eventType: 'ui',
            attributes: {
                actionType: payload.action,
                viewType: viewType
            }
        });
        return onCancel(action);
    }, [
        sendAnalyticsEvent,
        payload.action,
        viewType,
        action,
        onCancel
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5a3c9a7d72e5a761$var$styles.root,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: `capacity-planning-action-${action.invocationId}`
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5a3c9a7d72e5a761$var$styles.statusIcon
    }, /*#__PURE__*/ $cozmU.createElement($5a3c9a7d72e5a761$var$ActionItemStatus, {
        isChecked: isChecked,
        onToggle: onToggle,
        showCheckbox: showCheckbox,
        status: effectiveStatus
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $5a3c9a7d72e5a761$var$styles.label
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $5a3c9a7d72e5a761$var$styles.labelContent
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle",
        as: "span"
    }, /*#__PURE__*/ $cozmU.createElement($5a3c9a7d72e5a761$var$ActionItemLabel, {
        payload: payload,
        workById: workById,
        viewType: viewType,
        hydratedUsers: hydratedUsers
    })))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($5a3c9a7d72e5a761$var$styles.actionButtons, !showActionButtons && $5a3c9a7d72e5a761$var$styles.actionButtonsHidden),
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                ...iconProps,
                label: ""
            }),
        label: formatMessage($5a3c9a7d72e5a761$var$acceptLabelMessage),
        spacing: "compact",
        appearance: "subtle",
        onClick: handleAccept,
        isDisabled: isDisabled || isSubmitting
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                label: ""
            }),
        label: formatMessage($5a3c9a7d72e5a761$var$dismissLabelMessage),
        spacing: "compact",
        appearance: "subtle",
        onClick: handleDismiss,
        isDisabled: isDisabled || isSubmitting
    })));
}
module.exports["ActionItem"] = $5a3c9a7d72e5a761$export$ac06cb4ab481cfab;

});

parcelRegister("jVsqU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bXJJJ = parcelRequire("bXJJJ");


var $cJ0FD = parcelRequire("cJ0FD");


var $5HApy = parcelRequire("5HApy");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");


var $lpNn5 = parcelRequire("lpNn5");


var $iOVAY = parcelRequire("iOVAY");

const $69ab186fa59b754f$var$styles = {
    card: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbccYA _0hPCNLDIqT _1RrJLit2nV _1VJPca0u59 _3YEZNOdnbC _4ouGXIdnbC _1EqgXlN91d",
    headerLinkWrap: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1EqgXlN91d",
    headerWorkLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _4ouGXIdnbC _39xV02N91d _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7 _3iDTPbvLZJ",
    headerWorkAnchor: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _4ouGXIdnbC _39xV02N91d _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7 _3iDTPbvLZJ _1pp6NdIZbP",
    headerWorkName: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7",
    headerWorkRow: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1EqgXlN91d _39xV02N91d",
    issueTypeIconWrap: "_2Y7lL4gVvo _4c065U1Y8M _3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT"
};
const $69ab186fa59b754f$export$d6218fd1964a0c4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemFromHydratedWork(t0) {
    const $ = (0, $bDgLe.c)(24);
    const { work: work, isGroupHeader: isGroupHeader } = t0;
    if (isGroupHeader) {
        if (work.url) {
            let t1;
            if ($[0] !== work.issueTypeAvatarUrl || $[1] !== work.issueTypeName) {
                t1 = work.issueTypeAvatarUrl ? work.issueTypeName ? /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                    content: work.issueTypeName
                }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $69ab186fa59b754f$var$styles.issueTypeIconWrap
                }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                    alt: work.issueTypeName,
                    src: work.issueTypeAvatarUrl,
                    srcDark: work.issueTypeAvatarUrl,
                    width: 16,
                    height: 16
                }))) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $69ab186fa59b754f$var$styles.issueTypeIconWrap
                }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                    alt: "",
                    src: work.issueTypeAvatarUrl,
                    srcDark: work.issueTypeAvatarUrl,
                    width: 16,
                    height: 16
                })) : null;
                $[0] = work.issueTypeAvatarUrl;
                $[1] = work.issueTypeName;
                $[2] = t1;
            } else t1 = $[2];
            let t2;
            if ($[3] !== work.name) {
                t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $69ab186fa59b754f$var$styles.headerWorkName
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    size: "medium",
                    weight: "bold",
                    as: "span"
                }, work.name));
                $[3] = work.name;
                $[4] = t2;
            } else t2 = $[4];
            let t3;
            if ($[5] !== t2 || $[6] !== work.url) {
                t3 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
                    href: work.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    xcss: $69ab186fa59b754f$var$styles.headerWorkAnchor,
                    onClick: $69ab186fa59b754f$var$_temp
                }, t2);
                $[5] = t2;
                $[6] = work.url;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== t3 || $[9] !== work.name) {
                t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $69ab186fa59b754f$var$styles.headerLinkWrap
                }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                    content: work.name
                }, t3));
                $[8] = t3;
                $[9] = work.name;
                $[10] = t4;
            } else t4 = $[10];
            let t5;
            if ($[11] !== t1 || $[12] !== t4) {
                t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.050",
                    xcss: $69ab186fa59b754f$var$styles.headerWorkRow
                }, t1, t4);
                $[11] = t1;
                $[12] = t4;
                $[13] = t5;
            } else t5 = $[13];
            return t5;
        } else {
            let t1;
            if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $69ab186fa59b754f$var$styles.issueTypeIconWrap
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bXJJJ))), {
                    label: ""
                }));
                $[14] = t1;
            } else t1 = $[14];
            let t2;
            if ($[15] !== work.name) {
                t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $69ab186fa59b754f$var$styles.headerWorkLink
                }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $69ab186fa59b754f$var$styles.headerWorkName
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    size: "medium",
                    weight: "bold",
                    as: "span"
                }, work.name)));
                $[15] = work.name;
                $[16] = t2;
            } else t2 = $[16];
            let t3;
            if ($[17] !== t2 || $[18] !== work.name) {
                t3 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.050",
                    xcss: $69ab186fa59b754f$var$styles.headerWorkRow
                }, t1, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $69ab186fa59b754f$var$styles.headerLinkWrap
                }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                    content: work.name
                }, t2)));
                $[17] = t2;
                $[18] = work.name;
                $[19] = t3;
            } else t3 = $[19];
            return t3;
        }
    } else if (work.url) {
        let t1;
        if ($[20] !== work.url) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $69ab186fa59b754f$var$styles.card
            }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $l8wPz.Card), {
                url: work.url,
                appearance: "inline",
                showHoverPreview: true,
                truncateInline: true
            })));
            $[20] = work.url;
            $[21] = t1;
        } else t1 = $[21];
        return t1;
    } else {
        let t1;
        if ($[22] !== work.name) {
            t1 = /*#__PURE__*/ $cozmU.createElement("span", null, "'", work.name, "'");
            $[22] = work.name;
            $[23] = t1;
        } else t1 = $[23];
        return t1;
    }
} : function WorkItemFromHydratedWork({ work: work, isGroupHeader: isGroupHeader }) {
    // render the work item in the group header
    if (isGroupHeader) {
        if (work.url) // the jira work item has a url
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            xcss: $69ab186fa59b754f$var$styles.headerWorkRow
        }, work.issueTypeAvatarUrl ? work.issueTypeName ? /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: work.issueTypeName
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.issueTypeIconWrap
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            alt: work.issueTypeName,
            src: work.issueTypeAvatarUrl,
            srcDark: work.issueTypeAvatarUrl,
            width: 16,
            height: 16
        }))) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.issueTypeIconWrap
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            alt: "",
            src: work.issueTypeAvatarUrl,
            srcDark: work.issueTypeAvatarUrl,
            width: 16,
            height: 16
        })) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.headerLinkWrap
        }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: work.name
        }, /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            href: work.url,
            target: "_blank",
            rel: "noopener noreferrer",
            xcss: $69ab186fa59b754f$var$styles.headerWorkAnchor,
            onClick: (e)=>e.stopPropagation()
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $69ab186fa59b754f$var$styles.headerWorkName
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold",
            as: "span"
        }, work.name))))));
        else // non project work item doesn't have the url
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            xcss: $69ab186fa59b754f$var$styles.headerWorkRow
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.issueTypeIconWrap
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bXJJJ))), {
            label: ""
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.headerLinkWrap
        }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: work.name
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.headerWorkLink
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $69ab186fa59b754f$var$styles.headerWorkName
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold",
            as: "span"
        }, work.name))))));
    } else {
        // render the work item in the action label
        // render the jira work item
        if (work.url) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $69ab186fa59b754f$var$styles.card
        }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $l8wPz.Card), {
            url: work.url,
            appearance: "inline",
            showHoverPreview: true,
            truncateInline: true
        })));
        else // render the non project work item
        return /*#__PURE__*/ $cozmU.createElement("span", null, "'", work.name, "'");
    }
};
function $69ab186fa59b754f$var$_temp(e) {
    return e.stopPropagation();
}
const $69ab186fa59b754f$var$WorkItemNode = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemNode(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { payload: payload, workById: workById, isGroupHeader: isGroupHeader } = t0;
    let t1;
    if ($[0] !== payload || $[1] !== workById) {
        const workId = (0, $iOVAY.getWorkId)(payload);
        t1 = workId ? workById.get(workId) : undefined;
        $[0] = payload;
        $[1] = workById;
        $[2] = t1;
    } else t1 = $[2];
    const resolved = t1;
    if (!resolved) return null;
    let t2;
    if ($[3] !== isGroupHeader || $[4] !== resolved) {
        t2 = /*#__PURE__*/ $cozmU.createElement($69ab186fa59b754f$export$d6218fd1964a0c4f, {
            work: resolved,
            isGroupHeader: isGroupHeader
        });
        $[3] = isGroupHeader;
        $[4] = resolved;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function WorkItemNode({ payload: payload, workById: workById, isGroupHeader: isGroupHeader }) {
    const workId = (0, $iOVAY.getWorkId)(payload);
    const resolved = workId ? workById.get(workId) : undefined;
    if (!resolved) return null;
    return /*#__PURE__*/ $cozmU.createElement($69ab186fa59b754f$export$d6218fd1964a0c4f, {
        work: resolved,
        isGroupHeader: isGroupHeader
    });
};
var $69ab186fa59b754f$export$2e2bcd8739ae039 = $69ab186fa59b754f$var$WorkItemNode;
module.exports["default"] = $69ab186fa59b754f$export$2e2bcd8739ae039;

});

parcelRegister("gDVnZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $eEgoJ = parcelRequire("eEgoJ");


var $eiETF = parcelRequire("eiETF");


var $fr9Wb = parcelRequire("fr9Wb");


var $gKdbs = parcelRequire("gKdbs");


var $gkWsQ = parcelRequire("gkWsQ");


var $ewvjY = parcelRequire("ewvjY");


var $2tueL = parcelRequire("2tueL");


var $5R7bA = parcelRequire("5R7bA");


var $ljAgM = parcelRequire("ljAgM");


var $79yHm = parcelRequire("79yHm");

const $ac13053eed62f9c3$var$styles = {
    formBody: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $ac13053eed62f9c3$export$4f6ce086d4c5b55f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(88);
    const { formData: formData, onChange: onChange, cloudId: cloudId, orgId: orgId, fieldIdPrefix: fieldIdPrefix, onImpactedWorkResolutionStatusChange: onImpactedWorkResolutionStatusChange } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $ac13053eed62f9c3$var$styles.formBody
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onChange) {
        t2 = (value)=>onChange("name", value);
        $[1] = onChange;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== formData.name || $[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $gkWsQ.NameField), {
            value: formData.name,
            onChange: t2
        });
        $[3] = formData.name;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onChange) {
        t4 = (value_0)=>onChange("description", value_0);
        $[6] = onChange;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formData.description || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $eiETF.EditorField), {
            name: "description",
            label: (0, $79yHm.default).descriptionFieldLabel,
            placeholder: (0, $79yHm.default).descriptionEditorPlaceholder,
            value: formData.description,
            onChange: t4
        });
        $[8] = formData.description;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== onChange) {
        t6 = (value_1)=>onChange("justification", value_1);
        $[11] = onChange;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== formData.justification || $[14] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $eiETF.EditorField), {
            name: "justification",
            label: (0, $79yHm.default).justificationFieldLabel,
            placeholder: (0, $79yHm.default).justificationEditorPlaceholder,
            value: formData.justification,
            onChange: t6
        });
        $[13] = formData.justification;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== onChange) {
        t8 = (value_2)=>onChange("targetDate", value_2);
        $[16] = onChange;
        $[17] = t8;
    } else t8 = $[17];
    const t9 = `${fieldIdPrefix}-targetDate`;
    let t10;
    if ($[18] !== formData.targetDate || $[19] !== t8 || $[20] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $2tueL.TargetDateField), {
            value: formData.targetDate,
            onChange: t8,
            fieldId: t9
        });
        $[18] = formData.targetDate;
        $[19] = t8;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== onChange) {
        t11 = (value_3)=>onChange("impactedWork", value_3);
        $[22] = onChange;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== cloudId || $[25] !== formData.impactedWork || $[26] !== onImpactedWorkResolutionStatusChange || $[27] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $fr9Wb.ImpactedWorkField), {
            value: formData.impactedWork,
            cloudId: cloudId,
            onValueChange: t11,
            onResolutionStatusChange: onImpactedWorkResolutionStatusChange
        });
        $[24] = cloudId;
        $[25] = formData.impactedWork;
        $[26] = onImpactedWorkResolutionStatusChange;
        $[27] = t11;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== onChange) {
        t13 = (value_4)=>onChange("links", value_4);
        $[29] = onChange;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== formData.links || $[32] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $gKdbs.LinksField), {
            links: formData.links,
            onChange: t13
        });
        $[31] = formData.links;
        $[32] = t13;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== onChange) {
        t15 = (value_5)=>onChange("commentData", value_5);
        $[34] = onChange;
        $[35] = t15;
    } else t15 = $[35];
    const t16 = `${fieldIdPrefix}-comment`;
    let t17;
    if ($[36] !== formData.commentData || $[37] !== t15 || $[38] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $eEgoJ.CommentField), {
            value: formData.commentData,
            onChange: t15,
            fieldId: t16
        });
        $[36] = formData.commentData;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== onChange) {
        t18 = (user)=>onChange("submitter", user ?? null);
        $[40] = onChange;
        $[41] = t18;
    } else t18 = $[41];
    const t19 = `${fieldIdPrefix}-submitter`;
    let t20;
    if ($[42] !== cloudId || $[43] !== formData.submitter || $[44] !== t18 || $[45] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $ljAgM.UserPickerField), {
            name: "submitter",
            label: (0, $79yHm.default).submitterFieldLabel,
            placeholder: (0, $79yHm.default).submitterPickerPlaceholder,
            cloudId: cloudId,
            value: formData.submitter,
            onChange: t18,
            isRequired: true,
            fieldId: t19,
            isClearable: false
        });
        $[42] = cloudId;
        $[43] = formData.submitter;
        $[44] = t18;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    let t21;
    if ($[47] !== onChange) {
        t21 = (user_0)=>onChange("owner", user_0 ?? null);
        $[47] = onChange;
        $[48] = t21;
    } else t21 = $[48];
    const t22 = `${fieldIdPrefix}-owner`;
    let t23;
    if ($[49] !== cloudId || $[50] !== formData.owner || $[51] !== t21 || $[52] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $ljAgM.UserPickerField), {
            name: "owner",
            label: (0, $79yHm.default).receiverFieldLabel,
            placeholder: (0, $79yHm.default).receiverPickerPlaceholder,
            cloudId: cloudId,
            value: formData.owner,
            onChange: t21,
            fieldId: t22
        });
        $[49] = cloudId;
        $[50] = formData.owner;
        $[51] = t21;
        $[52] = t22;
        $[53] = t23;
    } else t23 = $[53];
    const t24 = `${fieldIdPrefix}-submittingTeam`;
    let t25;
    if ($[54] !== onChange) {
        t25 = (team)=>onChange("submittingTeam", team ?? null);
        $[54] = onChange;
        $[55] = t25;
    } else t25 = $[55];
    let t26;
    if ($[56] !== cloudId || $[57] !== formData.submittingTeam || $[58] !== orgId || $[59] !== t24 || $[60] !== t25) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $5R7bA.TeamPickerField), {
            name: "submittingTeam",
            label: (0, $79yHm.default).submittingTeamFieldLabel,
            placeholder: (0, $79yHm.default).submittingTeamPickerPlaceholder,
            cloudId: cloudId,
            orgId: orgId,
            fieldId: t24,
            value: formData.submittingTeam,
            onChange: t25
        });
        $[56] = cloudId;
        $[57] = formData.submittingTeam;
        $[58] = orgId;
        $[59] = t24;
        $[60] = t25;
        $[61] = t26;
    } else t26 = $[61];
    const t27 = `${fieldIdPrefix}-receivingTeam`;
    let t28;
    if ($[62] !== onChange) {
        t28 = (team_0)=>onChange("receivingTeam", team_0 ?? null);
        $[62] = onChange;
        $[63] = t28;
    } else t28 = $[63];
    let t29;
    if ($[64] !== cloudId || $[65] !== formData.receivingTeam || $[66] !== orgId || $[67] !== t27 || $[68] !== t28) {
        t29 = /*#__PURE__*/ $cozmU.createElement((0, $5R7bA.TeamPickerField), {
            name: "receivingTeam",
            label: (0, $79yHm.default).receivingTeamFieldLabel,
            placeholder: (0, $79yHm.default).receivingTeamPickerPlaceholder,
            cloudId: cloudId,
            orgId: orgId,
            fieldId: t27,
            value: formData.receivingTeam,
            onChange: t28
        });
        $[64] = cloudId;
        $[65] = formData.receivingTeam;
        $[66] = orgId;
        $[67] = t27;
        $[68] = t28;
        $[69] = t29;
    } else t29 = $[69];
    let t30;
    if ($[70] !== onChange) {
        t30 = (value_6)=>onChange("priority", value_6);
        $[70] = onChange;
        $[71] = t30;
    } else t30 = $[71];
    let t31;
    if ($[72] !== formData.priority || $[73] !== t30) {
        t31 = /*#__PURE__*/ $cozmU.createElement((0, $ewvjY.PriorityField), {
            value: formData.priority,
            onChange: t30
        });
        $[72] = formData.priority;
        $[73] = t30;
        $[74] = t31;
    } else t31 = $[74];
    let t32;
    if ($[75] !== t10 || $[76] !== t12 || $[77] !== t14 || $[78] !== t17 || $[79] !== t20 || $[80] !== t23 || $[81] !== t26 || $[82] !== t29 || $[83] !== t3 || $[84] !== t31 || $[85] !== t5 || $[86] !== t7) {
        t32 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, t3, t5, t7, t10, t12, t14, t17, t20, t23, t26, t29, t31);
        $[75] = t10;
        $[76] = t12;
        $[77] = t14;
        $[78] = t17;
        $[79] = t20;
        $[80] = t23;
        $[81] = t26;
        $[82] = t29;
        $[83] = t3;
        $[84] = t31;
        $[85] = t5;
        $[86] = t7;
        $[87] = t32;
    } else t32 = $[87];
    return t32;
} : ({ formData: formData, onChange: onChange, cloudId: cloudId, orgId: orgId, fieldIdPrefix: fieldIdPrefix, onImpactedWorkResolutionStatusChange: onImpactedWorkResolutionStatusChange })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac13053eed62f9c3$var$styles.formBody
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $gkWsQ.NameField), {
        value: formData.name,
        onChange: (value)=>onChange('name', value)
    }), /*#__PURE__*/ $cozmU.createElement((0, $eiETF.EditorField), {
        name: "description",
        label: (0, $79yHm.default).descriptionFieldLabel,
        placeholder: (0, $79yHm.default).descriptionEditorPlaceholder,
        value: formData.description,
        onChange: (value_0)=>onChange('description', value_0)
    }), /*#__PURE__*/ $cozmU.createElement((0, $eiETF.EditorField), {
        name: "justification",
        label: (0, $79yHm.default).justificationFieldLabel,
        placeholder: (0, $79yHm.default).justificationEditorPlaceholder,
        value: formData.justification,
        onChange: (value_1)=>onChange('justification', value_1)
    }), /*#__PURE__*/ $cozmU.createElement((0, $2tueL.TargetDateField), {
        value: formData.targetDate,
        onChange: (value_2)=>onChange('targetDate', value_2),
        fieldId: `${fieldIdPrefix}-targetDate`
    }), /*#__PURE__*/ $cozmU.createElement((0, $fr9Wb.ImpactedWorkField), {
        value: formData.impactedWork,
        cloudId: cloudId,
        onValueChange: (value_3)=>onChange('impactedWork', value_3),
        onResolutionStatusChange: onImpactedWorkResolutionStatusChange
    }), /*#__PURE__*/ $cozmU.createElement((0, $gKdbs.LinksField), {
        links: formData.links,
        onChange: (value_4)=>onChange('links', value_4)
    }), /*#__PURE__*/ $cozmU.createElement((0, $eEgoJ.CommentField), {
        value: formData.commentData,
        onChange: (value_5)=>onChange('commentData', value_5),
        fieldId: `${fieldIdPrefix}-comment`
    }), /*#__PURE__*/ $cozmU.createElement((0, $ljAgM.UserPickerField), {
        name: "submitter",
        label: (0, $79yHm.default).submitterFieldLabel,
        placeholder: (0, $79yHm.default).submitterPickerPlaceholder,
        cloudId: cloudId,
        value: formData.submitter,
        onChange: (user)=>onChange('submitter', user ?? null),
        isRequired: true,
        fieldId: `${fieldIdPrefix}-submitter`,
        isClearable: false
    }), /*#__PURE__*/ $cozmU.createElement((0, $ljAgM.UserPickerField), {
        name: "owner",
        label: (0, $79yHm.default).receiverFieldLabel,
        placeholder: (0, $79yHm.default).receiverPickerPlaceholder,
        cloudId: cloudId,
        value: formData.owner,
        onChange: (user_0)=>onChange('owner', user_0 ?? null),
        fieldId: `${fieldIdPrefix}-owner`
    }), /*#__PURE__*/ $cozmU.createElement((0, $5R7bA.TeamPickerField), {
        name: "submittingTeam",
        label: (0, $79yHm.default).submittingTeamFieldLabel,
        placeholder: (0, $79yHm.default).submittingTeamPickerPlaceholder,
        cloudId: cloudId,
        orgId: orgId,
        fieldId: `${fieldIdPrefix}-submittingTeam`,
        value: formData.submittingTeam,
        onChange: (team)=>onChange('submittingTeam', team ?? null)
    }), /*#__PURE__*/ $cozmU.createElement((0, $5R7bA.TeamPickerField), {
        name: "receivingTeam",
        label: (0, $79yHm.default).receivingTeamFieldLabel,
        placeholder: (0, $79yHm.default).receivingTeamPickerPlaceholder,
        cloudId: cloudId,
        orgId: orgId,
        fieldId: `${fieldIdPrefix}-receivingTeam`,
        value: formData.receivingTeam,
        onChange: (team_0)=>onChange('receivingTeam', team_0 ?? null)
    }), /*#__PURE__*/ $cozmU.createElement((0, $ewvjY.PriorityField), {
        value: formData.priority,
        onChange: (value_6)=>onChange('priority', value_6)
    }));
};
module.exports["FocusAskFormFields"] = $ac13053eed62f9c3$export$4f6ce086d4c5b55f;

});

parcelRegister("eiETF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bMenv = parcelRequire("bMenv");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dUI0h = parcelRequire("dUI0h");


var $iMnC5 = parcelRequire("iMnC5");


var $icFc2 = parcelRequire("icFc2");


var $5MdA4 = parcelRequire("5MdA4");

const $ef8e69874dd8042a$var$styles = {
    chromelessEditorBox: "_0bjKvDKTcp _2Y7lL42ADO _3vBAKH9r67 _2V7sgO2M4S _3hxITi6wH8 _46hvQmgVvo _0KLXru7Cj1 _0wOv4QJxkL _1jJ2xknXvL"
};
const $ef8e69874dd8042a$export$96dd7ead462788e5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { name: name, label: label, placeholder: placeholder, value: value, onChange: onChange, testId: testId, hideLabel: t1, maxHeight: t2, appearance: t3, isDisabled: t4 } = t0;
    const hideLabel = t1 === undefined ? false : t1;
    const maxHeight = t2 === undefined ? 300 : t2;
    const appearance = t3 === undefined ? "comment" : t3;
    const isDisabled = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== formatMessage || $[1] !== label) {
        t5 = formatMessage(label);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t5;
    } else t5 = $[2];
    const fieldLabel = t5;
    let t6;
    if ($[3] !== formatMessage || $[4] !== placeholder) {
        t6 = formatMessage(placeholder);
        $[3] = formatMessage;
        $[4] = placeholder;
        $[5] = t6;
    } else t6 = $[5];
    const { editorApi: editorApi, preset: preset } = (0, $5MdA4.useEditorPreset)(t6);
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = new (0, $bMenv.default)();
        $[6] = t7;
    } else t7 = $[6];
    const editorActions = t7;
    let t8;
    if ($[7] !== editorApi?.core.actions || $[8] !== onChange) {
        t8 = ()=>{
            editorApi?.core.actions.requestDocument((doc)=>{
                onChange((0, $icFc2.serializeEditorDocument)(doc));
            });
        };
        $[7] = editorApi?.core.actions;
        $[8] = onChange;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== value) {
        t9 = (actions)=>{
            if (value) actions.replaceDocument(value);
        };
        $[10] = value;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== appearance || $[13] !== fieldLabel || $[14] !== isDisabled || $[15] !== maxHeight || $[16] !== preset || $[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
            maxHeight: maxHeight,
            shouldFocus: false,
            preset: preset,
            appearance: appearance,
            assistiveLabel: fieldLabel,
            disabled: isDisabled,
            onChange: t8,
            onEditorReady: t9
        });
        $[12] = appearance;
        $[13] = fieldLabel;
        $[14] = isDisabled;
        $[15] = maxHeight;
        $[16] = preset;
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    const composableEditor = t10;
    let t11;
    if ($[20] !== appearance || $[21] !== composableEditor || $[22] !== testId) {
        t11 = appearance === "chromeless" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), {
            editorActions: editorActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: testId,
            xcss: $ef8e69874dd8042a$var$styles.chromelessEditorBox
        }, composableEditor)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), {
            editorActions: editorActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: testId
        }, composableEditor));
        $[20] = appearance;
        $[21] = composableEditor;
        $[22] = testId;
        $[23] = t11;
    } else t11 = $[23];
    const editor = t11;
    if (hideLabel) return editor;
    let t12;
    if ($[24] !== editor) {
        t12 = ()=>editor;
        $[24] = editor;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== fieldLabel || $[27] !== name || $[28] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: name,
            label: fieldLabel
        }, t12);
        $[26] = fieldLabel;
        $[27] = name;
        $[28] = t12;
        $[29] = t13;
    } else t13 = $[29];
    return t13;
} : ({ name: name, label: label, placeholder: placeholder, value: value, onChange: onChange, testId: testId, hideLabel: hideLabel = false, maxHeight: maxHeight = 300, appearance: appearance = 'comment', isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fieldLabel = formatMessage(label);
    const { editorApi: editorApi, preset: preset } = (0, $5MdA4.useEditorPreset)(formatMessage(placeholder));
    const editorActions = (0, $cozmU.useMemo)(()=>new (0, $bMenv.default)(), []);
    const composableEditor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        maxHeight: maxHeight,
        shouldFocus: false,
        preset: preset,
        appearance: appearance,
        assistiveLabel: fieldLabel,
        disabled: isDisabled,
        onChange: ()=>{
            editorApi?.core.actions.requestDocument((doc)=>{
                onChange((0, $icFc2.serializeEditorDocument)(doc));
            });
        },
        onEditorReady: (actions)=>{
            if (value) actions.replaceDocument(value);
        }
    });
    const editor = appearance === 'chromeless' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: $ef8e69874dd8042a$var$styles.chromelessEditorBox
    }, composableEditor)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId
    }, composableEditor));
    if (hideLabel) return editor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: name,
        label: fieldLabel
    }, ()=>editor);
};
module.exports["EditorField"] = $ef8e69874dd8042a$export$96dd7ead462788e5;

});

parcelRegister("8NeZ3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $jXPru = parcelRequire("jXPru");


var $lNNC4 = parcelRequire("lNNC4");


var $cwf0p = parcelRequire("cwf0p");


var $2a8RQ = parcelRequire("2a8RQ");

const $60fce5301c00c257$var$DEBOUNCE_MS = 350;
const $60fce5301c00c257$export$520ba977ea973f60 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (input, cloudId, initialValue)=>{
    const $ = (0, $bDgLe.c)(16);
    let t0;
    if ($[0] !== input) {
        t0 = input.trim();
        $[0] = input;
        $[1] = t0;
    } else t0 = $[1];
    const trimmed = t0;
    const [debouncedInput] = (0, $jXPru.default)(trimmed, $60fce5301c00c257$var$DEBOUNCE_MS);
    const resolveAri = trimmed.length === 0 ? initialValue?.id : null;
    const resolveLink = debouncedInput || initialValue?.link || null;
    let t1;
    if ($[2] !== resolveAri || $[3] !== resolveLink) {
        t1 = {
            ari: resolveAri,
            link: resolveLink
        };
        $[2] = resolveAri;
        $[3] = resolveLink;
        $[4] = t1;
    } else t1 = $[4];
    const { ari: ari, link: link, isFetching: isFetching, error: error } = (0, $cwf0p.useResolveImpactedWorkInput)(t1);
    const ariValidation = (0, $2a8RQ.useValidateImpactedWorkAri)(ari, cloudId, link);
    if (trimmed.length === 0 && !initialValue?.id) {
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "idle"
            };
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    if (trimmed.length > 0 && !(0, $lNNC4.isValidImpactedWorkUrl)(trimmed)) {
        let t2;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "invalidUrl"
            };
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    if (debouncedInput !== trimmed) {
        let t2;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "resolving"
            };
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    if (isFetching) {
        let t2;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "resolving"
            };
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    if (error) {
        let t2;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "notFound"
            };
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    }
    if (!ari || !link) {
        let t2;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "notFound"
            };
            $[10] = t2;
        } else t2 = $[10];
        return t2;
    }
    if (ariValidation.status === "loading") {
        let t2;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "resolving"
            };
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    if (ariValidation.status === "notFound" || ariValidation.status === "error") {
        let t2;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                status: "notFound"
            };
            $[12] = t2;
        } else t2 = $[12];
        return t2;
    }
    let t2;
    if ($[13] !== ari || $[14] !== link) {
        t2 = {
            status: "resolved",
            data: {
                id: ari,
                link: link
            }
        };
        $[13] = ari;
        $[14] = link;
        $[15] = t2;
    } else t2 = $[15];
    return t2;
} : (input, cloudId, initialValue)=>{
    const trimmed = input.trim();
    const [debouncedInput] = (0, $jXPru.default)(trimmed, $60fce5301c00c257$var$DEBOUNCE_MS);
    // When input is empty and initialValue has only an ARI, use it to resolve the URL.
    // The moment the user types anything, debouncedInput takes over as the link.
    const resolveAri = trimmed.length === 0 ? initialValue?.id : null;
    const resolveLink = debouncedInput || initialValue?.link || null;
    const { ari: ari, link: link, isFetching: isFetching, error: error } = (0, $cwf0p.useResolveImpactedWorkInput)({
        ari: resolveAri,
        link: resolveLink
    });
    // Validates ARI for correct type, org, site connected, etc.
    const ariValidation = (0, $2a8RQ.useValidateImpactedWorkAri)(ari, cloudId, link);
    // Empty/invalid input is decided without waiting for the debounce, so the UI reacts instantly.
    if (trimmed.length === 0 && !initialValue?.id) return {
        status: 'idle'
    };
    if (trimmed.length > 0 && !(0, $lNNC4.isValidImpactedWorkUrl)(trimmed)) return {
        status: 'invalidUrl'
    };
    // User has typed valid input but the debounce hasn't caught up yet —
    // render the 'resolving' state so we don't briefly flash a stale error.
    if (debouncedInput !== trimmed) return {
        status: 'resolving'
    };
    if (isFetching) return {
        status: 'resolving'
    };
    if (error) return {
        status: 'notFound'
    }; // Will surface not found message for errors.
    // Done fetching with no explicit API error, but resolver could not resolve to an ARI.
    if (!ari || !link) return {
        status: 'notFound'
    };
    // ARI scope validation — handles both type validation (unsupported) and scope validation (org/site checks).
    if (ariValidation.status === 'loading') return {
        status: 'resolving'
    };
    if (ariValidation.status === 'notFound' || ariValidation.status === 'error') return {
        status: 'notFound'
    };
    return {
        status: 'resolved',
        data: {
            id: ari,
            link: link
        }
    };
};
module.exports["useImpactedWorkResolution"] = $60fce5301c00c257$export$520ba977ea973f60;

});

parcelRegister("14vfv", function(module, exports) {
const $6ee3d240e7cc687b$export$83aa3517a8a0474c = (url)=>{
    let normalizedUrl = url.trim();
    if (!normalizedUrl) return null;
    if (!normalizedUrl.includes('://')) normalizedUrl = `http://${normalizedUrl}`;
    try {
        return new URL(normalizedUrl).href;
    } catch  {
        return null;
    }
};
const $6ee3d240e7cc687b$export$51b8fa1a845bc93f = (url)=>Boolean($6ee3d240e7cc687b$export$83aa3517a8a0474c(url));
module.exports["normalizeFocusAskLinkUrl"] = $6ee3d240e7cc687b$export$83aa3517a8a0474c;
module.exports["isAllowedFocusAskLinkUrl"] = $6ee3d240e7cc687b$export$51b8fa1a845bc93f;

});

parcelRegister("8eFI0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $kTb7m = parcelRequire("kTb7m");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $14vfv = parcelRequire("14vfv");

const $0464d38f62078554$var$styles = {
    linkItem: "_0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO",
    linkItemDivider: "_1x1D3gOeNX",
    linkItemContent: "_2O5Vij7dHp _4ouGXIdnbC",
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzy7kJ _2ipzJpy7kJ _2nTuUYy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMy7kJ",
    linkRemoveButton: "_23rrnHWgmT _1YKVNsdnbC _1pp6NdYbGa _0fKRyPnQyn",
    linkRemoveButtonVisible: "_1YKVNs7dHp _1pp6NdIZbP _0fKRyPYvD1"
};
const $0464d38f62078554$export$e8a29209bc020926 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(27);
    const { link: link, ariaLabel: ariaLabel, canRemove: t0, onRemove: onRemove, removeLabel: removeLabel, showDivider: t1 } = props;
    const canRemove = t0 === undefined ? false : t0;
    const showDivider = t1 === undefined ? false : t1;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const shouldShowRemoveButton = isHovered || isFocused;
    const shouldRenderRemoveButton = canRemove && onRemove && removeLabel;
    let t2;
    if ($[0] !== link.linkText || $[1] !== link.url) {
        t2 = link.linkText?.trim() || link.url;
        $[0] = link.linkText;
        $[1] = link.url;
        $[2] = t2;
    } else t2 = $[2];
    const linkText = t2;
    let t3;
    if ($[3] !== link.url) {
        t3 = (0, $14vfv.normalizeFocusAskLinkUrl)(link.url);
        $[3] = link.url;
        $[4] = t3;
    } else t3 = $[4];
    const safeHref = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsFocused(false);
        };
        $[5] = t4;
    } else t4 = $[5];
    const handleBlur = t4;
    const t5 = showDivider && $0464d38f62078554$var$styles.linkItemDivider;
    let t6;
    if ($[6] !== t5) {
        t6 = (0, $w6R6I.cx)($0464d38f62078554$var$styles.linkItem, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    let t8;
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        t9 = ()=>setIsFocused(true);
        $[8] = t7;
        $[9] = t8;
        $[10] = t9;
    } else {
        t7 = $[8];
        t8 = $[9];
        t9 = $[10];
    }
    let t10;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "",
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        });
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== ariaLabel || $[13] !== linkText || $[14] !== safeHref) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            xcss: $0464d38f62078554$var$styles.linkItemContent
        }, t10, safeHref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: safeHref,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": ariaLabel,
            xcss: $0464d38f62078554$var$styles.link
        }, linkText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, linkText));
        $[12] = ariaLabel;
        $[13] = linkText;
        $[14] = safeHref;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== onRemove || $[17] !== removeLabel || $[18] !== shouldRenderRemoveButton || $[19] !== shouldShowRemoveButton) {
        t12 = shouldRenderRemoveButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($0464d38f62078554$var$styles.linkRemoveButton, shouldShowRemoveButton && $0464d38f62078554$var$styles.linkRemoveButtonVisible)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: removeLabel,
            onClick: onRemove
        }));
        $[16] = onRemove;
        $[17] = removeLabel;
        $[18] = shouldRenderRemoveButton;
        $[19] = shouldShowRemoveButton;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t11 || $[22] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, t11, t12);
        $[21] = t11;
        $[22] = t12;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== t6) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t6,
            onMouseEnter: t7,
            onMouseLeave: t8,
            onFocus: t9,
            onBlur: handleBlur
        }, t13);
        $[24] = t13;
        $[25] = t6;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : (props)=>{
    const { link: link, ariaLabel: ariaLabel, canRemove: canRemove = false, onRemove: onRemove, removeLabel: removeLabel, showDivider: showDivider = false } = props;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const shouldShowRemoveButton = isHovered || isFocused;
    const shouldRenderRemoveButton = canRemove && onRemove && removeLabel;
    const linkText = link.linkText?.trim() || link.url;
    const safeHref = (0, $14vfv.normalizeFocusAskLinkUrl)(link.url);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) setIsFocused(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0464d38f62078554$var$styles.linkItem, showDivider && $0464d38f62078554$var$styles.linkItemDivider),
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsFocused(true),
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        xcss: $0464d38f62078554$var$styles.linkItemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        size: "small",
        color: "var(--ds-icon, #292A2E)"
    }), safeHref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: safeHref,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": ariaLabel,
        xcss: $0464d38f62078554$var$styles.link
    }, linkText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, linkText)), shouldRenderRemoveButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0464d38f62078554$var$styles.linkRemoveButton, shouldShowRemoveButton && $0464d38f62078554$var$styles.linkRemoveButtonVisible)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: removeLabel,
        onClick: onRemove
    }))));
};
module.exports["FocusAskLinkRow"] = $0464d38f62078554$export$e8a29209bc020926;

});

parcelRegister("5MdA4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4nt1R = parcelRequire("4nt1R");


var $dVPAB = parcelRequire("dVPAB");


var $iVGec = parcelRequire("iVGec");


var $hFvHs = parcelRequire("hFvHs");


var $63nNo = parcelRequire("63nNo");


var $8PVlW = parcelRequire("8PVlW");


var $4y9hw = parcelRequire("4y9hw");


var $k8SUN = parcelRequire("k8SUN");


var $laiso = parcelRequire("laiso");


var $5HQgD = parcelRequire("5HQgD");


var $2hEu6 = parcelRequire("2hEu6");


var $drevR = parcelRequire("drevR");


var $jIG3b = parcelRequire("jIG3b");


var $gkbos = parcelRequire("gkbos");


var $1171P = parcelRequire("1171P");

const $cfb40ead37ed051d$export$451e6f6982270493 = 16000;
const $cfb40ead37ed051d$var$buildPreset = (placeholder)=>(0, $4nt1R.createDefaultPreset)({
        paste: {
            sanitizePrivateContent: true
        },
        placeholder: {
            placeholder: placeholder
        },
        blockType: {
            allowBlockType: {
                exclude: [
                    'heading'
                ]
            }
        },
        allowUndoRedoButtons: true
    }).add([
        (0, $63nNo.default),
        $cfb40ead37ed051d$export$451e6f6982270493
    ]).add((0, $iVGec.gridPlugin)).add([
        (0, $k8SUN.expandPlugin),
        {
            allowInsertion: true
        }
    ]).add((0, $2hEu6.rulePlugin)).add((0, $jIG3b.tasksAndDecisionsPlugin)).add((0, $4y9hw.default)).add((0, $drevR.statusPlugin)).add((0, $gkbos.textColorPlugin)).add([
        (0, $laiso.helpDialogPlugin),
        true
    ]).add((0, $hFvHs.listPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        {
            allowHeadingAndParagraphIndentation: true,
            showIndentationButtons: false
        }
    ]).add((0, $5HQgD.insertBlockPlugin)).add((0, $8PVlW.contentInsertionPlugin));
const $cfb40ead37ed051d$export$22e9fc2aa16bb38f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placeholder)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== placeholder) {
        t0 = ()=>$cfb40ead37ed051d$var$buildPreset(placeholder);
        $[0] = placeholder;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[2] = t1;
    } else t1 = $[2];
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(t0, t1);
    let t2;
    if ($[3] !== editorApi || $[4] !== preset) {
        t2 = {
            preset: preset,
            editorApi: editorApi
        };
        $[3] = editorApi;
        $[4] = preset;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (placeholder)=>{
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(()=>$cfb40ead37ed051d$var$buildPreset(placeholder), []);
    return {
        preset: preset,
        editorApi: editorApi
    };
};
module.exports["useEditorPreset"] = $cfb40ead37ed051d$export$22e9fc2aa16bb38f;

});

parcelRegister("4eicX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlRK6 = parcelRequire("jlRK6");


var $icFc2 = parcelRequire("icFc2");

const $0779eeaf32b08882$export$a4ff4468fa943a6c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { value: value, preset: preset, editorApi: editorApi, shouldFocus: shouldFocus, onChange: onChange, disabled: t1 } = t0;
    const disabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== editorApi?.core || $[1] !== onChange) {
        t2 = ()=>{
            editorApi?.core.actions.requestDocument((doc)=>{
                onChange?.((0, $icFc2.serializeEditorDocument)(doc));
            });
        };
        $[0] = editorApi?.core;
        $[1] = onChange;
        $[2] = t2;
    } else t2 = $[2];
    const handleChange = t2;
    const t3 = onChange ? handleChange : undefined;
    let t4;
    if ($[3] !== value) {
        t4 = (actions)=>{
            if (value) actions.replaceDocument(value);
        };
        $[3] = value;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== disabled || $[6] !== preset || $[7] !== shouldFocus || $[8] !== t3 || $[9] !== t4 || $[10] !== value) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
            key: value,
            shouldFocus: shouldFocus,
            disabled: disabled,
            preset: preset,
            maxHeight: 160,
            appearance: "chromeless",
            onChange: t3,
            onEditorReady: t4
        });
        $[5] = disabled;
        $[6] = preset;
        $[7] = shouldFocus;
        $[8] = t3;
        $[9] = t4;
        $[10] = value;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ value: value, preset: preset, editorApi: editorApi, shouldFocus: shouldFocus, onChange: onChange, disabled: disabled = false })=>{
    const handleChange = (0, $cozmU.useCallback)(()=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            onChange?.((0, $icFc2.serializeEditorDocument)(doc));
        });
    }, [
        editorApi,
        onChange
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
        key: value,
        shouldFocus: shouldFocus,
        disabled: disabled,
        preset: preset,
        maxHeight: 160,
        appearance: "chromeless",
        onChange: onChange ? handleChange : undefined,
        onEditorReady: (actions)=>{
            if (value) actions.replaceDocument(value);
        }
    });
};
module.exports["RichTextEditor"] = $0779eeaf32b08882$export$a4ff4468fa943a6c;

});

parcelRegister("l9wjm", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $099f2fb04018af90$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    selectedIssuesLabel: {
        id: "issue-selector.selected-issues-label",
        defaultMessage: "{selectedIssueCount, select, 0 {} other {({selectedIssueCount} selected)}}"
    },
    expandButtonLabelText: {
        id: "issue-selector.expand-button-label-text",
        defaultMessage: "Expand list"
    },
    collapseButtonLabelText: {
        id: "issue-selector.collapse-button-label-text",
        defaultMessage: "Collapse list"
    },
    selectAllCheckboxLabel: {
        id: "issue-selector.select-all-checkbox-label",
        defaultMessage: "Select all"
    }
});
module.exports["messages"] = $099f2fb04018af90$export$defe85febe8b728c;

});

parcelRegister("l8HtA", function(module, exports) {
module.exports = new URL("avatar-with-arrow-darkmode.d9464bf1.svg", import.meta.url).toString();

});

parcelRegister("9IJcW", function(module, exports) {
module.exports = new URL("avatar-with-arrow.71e68580.svg", import.meta.url).toString();

});

parcelRegister("74viJ", function(module, exports) {
module.exports = new URL("avatar-with-lock-darkmode.39948dbb.svg", import.meta.url).toString();

});

parcelRegister("2gdYO", function(module, exports) {
module.exports = new URL("avatar-with-lock.b0750eee.svg", import.meta.url).toString();

});

parcelRegister("8SSbk", function(module, exports) {
module.exports = new URL("pencilled-field-with-arrow-darkmode.9a09e770.svg", import.meta.url).toString();

});

parcelRegister("5AwQJ", function(module, exports) {
module.exports = new URL("pencilled-field-with-arrow.6615a67d.svg", import.meta.url).toString();

});

parcelRegister("1wNfB", function(module, exports) {
module.exports = new URL("text-field-with-lock-darkmode.6b00710c.svg", import.meta.url).toString();

});

parcelRegister("1Wnig", function(module, exports) {
module.exports = new URL("text-field-with-lock.548927e7.svg", import.meta.url).toString();

});

parcelRegister("dq2hb", function(module, exports) {
module.exports = new URL("text-field-with-tick-darkmode.49503976.svg", import.meta.url).toString();

});

parcelRegister("6OfbT", function(module, exports) {
module.exports = new URL("text-field-with-tick.9650a889.svg", import.meta.url).toString();

});

parcelRegister("drBXV", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7b7c24ee33d4d354$var$_default_1 = (0, $kSwu1.defineMessages)({
    jiraIssueCreateDescriptionEditorPlaceholder: {
        id: "ai-mate.chat-history.store-assistant.message-actions.issue-create.suggestion-preview.description-placeholder",
        defaultMessage: "Description"
    }
});
var $7b7c24ee33d4d354$export$2e2bcd8739ae039 = $7b7c24ee33d4d354$var$_default_1;
module.exports["default"] = $7b7c24ee33d4d354$export$2e2bcd8739ae039;

});

parcelRegister("9InHK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3dac30258b56a8b0$var$styles = {
    container: "_2mHwu85zaO _0bjKvD8fU6 _3iDTPbQ4SZ _4xdlr0FlnN _39xV02N91d _24h04i2Njc _0KLXrunmFW _0Of8r28HPE _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO",
    item: "_2mHwu81Y8M _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC",
    itemWithDivider: "_2YmqfPOeNX _0LQT5E5zaO",
    label: "_2sNsIgd8bj _1UtDYzZpcK"
};
const $3dac30258b56a8b0$export$b1a9f7ca1a9a0cd5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { items: items } = t0;
    let t1;
    if ($[0] !== items) {
        t1 = items.map($3dac30258b56a8b0$var$_temp);
        $[0] = items;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $3dac30258b56a8b0$var$styles.container,
            testId: "jsm-solution-composer-plan-task-card.metadata-summary"
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ items: items })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3dac30258b56a8b0$var$styles.container,
        testId: "jsm-solution-composer-plan-task-card.metadata-summary"
    }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: item.label,
            xcss: (0, $w6R6I.cx)($3dac30258b56a8b0$var$styles.item, index > 0 && $3dac30258b56a8b0$var$styles.itemWithDivider)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $3dac30258b56a8b0$var$styles.label
        }, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "regular",
            color: "color.text"
        }, item.value))));
};
function $3dac30258b56a8b0$var$_temp(item, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: item.label,
        xcss: (0, $w6R6I.cx)($3dac30258b56a8b0$var$styles.item, index > 0 && $3dac30258b56a8b0$var$styles.itemWithDivider)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $3dac30258b56a8b0$var$styles.label
    }, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "regular",
        color: "color.text"
    }, item.value));
}
module.exports["CardMetadataSummary"] = $3dac30258b56a8b0$export$b1a9f7ca1a9a0cd5;

});

parcelRegister("7cN3Y", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $78ee5c797329a666$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    expandBodyContent: {
        id: "jsm-solution-composer-plan.task-card.card-content.expand-body-content",
        defaultMessage: "Show more"
    }
});
module.exports["messages"] = $78ee5c797329a666$export$defe85febe8b728c;

});

parcelRegister("7qe5K", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6cd0d8e1d0280e29$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    createSpace: {
        id: "jsm-solution-composer-plan.task-card.card-footer.create-space",
        defaultMessage: "Create space"
    },
    viewSpace: {
        id: "jsm-solution-composer-plan.task-card.card-footer.view-space",
        defaultMessage: "View space"
    }
});
module.exports["messages"] = $6cd0d8e1d0280e29$export$defe85febe8b728c;

});

parcelRegister("jIgdB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $04f5856fd8842a4a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    expandSection: {
        id: "jsm-solution-composer-plan.task-card.card-header.expand-section",
        defaultMessage: "Expand section"
    },
    collapseSection: {
        id: "jsm-solution-composer-plan.task-card.card-header.collapse-section",
        defaultMessage: "Collapse section"
    }
});
module.exports["messages"] = $04f5856fd8842a4a$export$defe85febe8b728c;

});

parcelRegister("jSIe3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $c9zHD = parcelRequire("c9zHD");


var $7sJoX = parcelRequire("7sJoX");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");


var $6FNab = parcelRequire("6FNab");

var $3BY7M = parcelRequire("3BY7M");


var $76qWr = parcelRequire("76qWr");


var $737YC = parcelRequire("737YC");


var $9fP2S = parcelRequire("9fP2S");

// Module-scoped so we only build the schema/transformer once per app session.
const $0436077bbb9407ca$var$adfEncoder = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $c9zHD.MarkdownTransformer)(schema));
const $0436077bbb9407ca$var$Markdown = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { source: source } = t0;
    let t1;
    if ($[0] !== source) {
        t1 = $0436077bbb9407ca$var$adfEncoder.encode(source);
        $[0] = source;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: t1
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: $0436077bbb9407ca$var$adfEncoder.encode(source)
    });
const $0436077bbb9407ca$var$descriptionLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.descriptionLabel",
    defaultMessage: "Description"
});
const $0436077bbb9407ca$var$instructionsLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.instructionsLabel",
    defaultMessage: "Instructions"
});
const $0436077bbb9407ca$var$knowledgeLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.knowledgeLabel",
    defaultMessage: "Knowledge"
});
const $0436077bbb9407ca$var$toolsLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.toolsLabel",
    defaultMessage: "Tools"
});
const $0436077bbb9407ca$var$expandLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.expandLabel",
    defaultMessage: "Show more"
});
const $0436077bbb9407ca$var$showMoreToolsLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.showMoreToolsLabel",
    defaultMessage: "Show more"
});
const $0436077bbb9407ca$var$showMoreToolsAriaLabel = (0, $kSwu1.defineMessage)({
    id: "conversation-assistant-message-actions.controllers.studio-create-agent.create-agent-card.ExpandableBody.showMoreToolsAriaLabel",
    defaultMessage: "Show more tools"
});
const $0436077bbb9407ca$var$MAX_VISIBLE_TOOLS = 5;
const $0436077bbb9407ca$var$CLOSED_BODY_MAX_HEIGHT = 145;
const $0436077bbb9407ca$var$FADE_HEIGHT = 60;
const $0436077bbb9407ca$var$styles = {
    wrapper: "_1mT5xdRAKS",
    bodyClosed: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3rCnfV",
    fade: "_0TuepkdnbC _1mT5xdWVPG _1ZB6UydnbC _0jFU0VfI2J _3CkH9o565s _1pp6NdYbGa",
    floatingChevron: "_0bjKvDS5Zs _1mT5xdWVPG _3iC0zd715P _1ZB6Uy2ADO _1VJPcajssS _1pp6NdIZbP _42Yu6B7dHp _2OUyjtGk8v _0KLXruoI2d",
    sectionLabel: "_2sNsIgd8bj _1UtDYzKGUX"
};
const $0436077bbb9407ca$var$Section = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, children: children } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0436077bbb9407ca$var$styles.sectionLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label));
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075"
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ label: label, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0436077bbb9407ca$var$styles.sectionLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children));
const $0436077bbb9407ca$var$ToolsList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { tools: tools } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const [showAll, setShowAll] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== showAll || $[1] !== tools) {
        t1 = showAll ? tools : tools.slice(0, $0436077bbb9407ca$var$MAX_VISIBLE_TOOLS);
        $[0] = showAll;
        $[1] = tools;
        $[2] = t1;
    } else t1 = $[2];
    const visibleTools = t1;
    const overflow = tools.length - $0436077bbb9407ca$var$MAX_VISIBLE_TOOLS;
    const hasMore = overflow > 0;
    let t2;
    if ($[3] !== visibleTools) {
        t2 = visibleTools.map($0436077bbb9407ca$var$_temp);
        $[3] = visibleTools;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== hasMore || $[6] !== overflow || $[7] !== showAll) {
        t3 = !showAll && hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
            content: `+ ${overflow}`,
            fullWidth: true
        });
        $[5] = hasMore;
        $[6] = overflow;
        $[7] = showAll;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            rowGap: "space.050",
            columnGap: "space.075",
            wrap: "wrap",
            alignItems: "center"
        }, t2, t3);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== hasMore || $[13] !== intl || $[14] !== showAll) {
        t5 = hasMore && !showAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            spacing: "compact",
            "aria-label": intl.formatMessage($0436077bbb9407ca$var$showMoreToolsAriaLabel),
            onClick: ()=>setShowAll(true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0436077bbb9407ca$var$showMoreToolsLabel));
        $[12] = hasMore;
        $[13] = intl;
        $[14] = showAll;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075",
            alignInline: "start"
        }, t4, t5);
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ tools: tools })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [showAll, setShowAll] = (0, $cozmU.useState)(false);
    const visibleTools = showAll ? tools : tools.slice(0, $0436077bbb9407ca$var$MAX_VISIBLE_TOOLS);
    const overflow = tools.length - $0436077bbb9407ca$var$MAX_VISIBLE_TOOLS;
    const hasMore = overflow > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        rowGap: "space.050",
        columnGap: "space.075",
        wrap: "wrap",
        alignItems: "center"
    }, visibleTools.map((tool, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: `tool-pill-${tool.id}-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76qWr.AgentActionPill), {
            action: {
                id: tool.id,
                displayName: tool.displayName,
                tags: tool.tags,
                iconUrl: tool.iconUrl
            },
            isActive: tool.isActive ?? true
        }))), !showAll && hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
        content: `+ ${overflow}`,
        fullWidth: true
    })), hasMore && !showAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        "aria-label": intl.formatMessage($0436077bbb9407ca$var$showMoreToolsAriaLabel),
        onClick: ()=>setShowAll(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0436077bbb9407ca$var$showMoreToolsLabel)));
};
const $0436077bbb9407ca$export$c18e573300f962ba = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { cloudId: cloudId, description: description, instructions: instructions, knowledge: knowledge, tools: tools, isExpanded: isExpanded, onExpand: onExpand } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== knowledge) {
        t1 = knowledge.some($0436077bbb9407ca$var$_temp3);
        $[0] = knowledge;
        $[1] = t1;
    } else t1 = $[1];
    const hasVisibleKnowledge = t1;
    const t2 = isExpanded ? undefined : $0436077bbb9407ca$var$styles.bodyClosed;
    let t3;
    if ($[2] !== description) {
        t3 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
            label: $0436077bbb9407ca$var$descriptionLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Markdown, {
            source: description
        }));
        $[2] = description;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== instructions) {
        t4 = instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
            label: $0436077bbb9407ca$var$instructionsLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Markdown, {
            source: instructions
        }));
        $[4] = instructions;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== cloudId || $[7] !== hasVisibleKnowledge || $[8] !== knowledge) {
        t5 = hasVisibleKnowledge && cloudId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
            label: $0436077bbb9407ca$var$knowledgeLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fP2S.KnowledgePillList), {
            cloudId: cloudId,
            knowledge: knowledge,
            preferDirectConnectorFetch: true
        }));
        $[6] = cloudId;
        $[7] = hasVisibleKnowledge;
        $[8] = knowledge;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== tools) {
        t6 = tools.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
            label: $0436077bbb9407ca$var$toolsLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$ToolsList, {
            tools: tools
        }));
        $[10] = tools;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t3, t4, t5, t6);
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t2 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, t7);
        $[17] = t2;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== intl || $[21] !== isExpanded || $[22] !== onExpand) {
        t9 = !isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0436077bbb9407ca$var$styles.fade
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0436077bbb9407ca$var$styles.floatingChevron
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "rovo-create-agent-card-expand",
            appearance: "default",
            shape: "circle",
            isTooltipDisabled: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
            label: intl.formatMessage($0436077bbb9407ca$var$expandLabel),
            onClick: onExpand
        })));
        $[20] = intl;
        $[21] = isExpanded;
        $[22] = onExpand;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0436077bbb9407ca$var$styles.wrapper
        }, t8, t9);
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ cloudId: cloudId, description: description, instructions: instructions, knowledge: knowledge, tools: tools, isExpanded: isExpanded, onExpand: onExpand })=>{
    const intl = (0, $kSwu1.useIntl)();
    const hasVisibleKnowledge = (0, $cozmU.useMemo)(()=>knowledge.some((edge)=>edge.enabled && edge.sources?.some((source)=>source?.enabled)), [
        knowledge
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0436077bbb9407ca$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isExpanded ? undefined : $0436077bbb9407ca$var$styles.bodyClosed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
        label: $0436077bbb9407ca$var$descriptionLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Markdown, {
        source: description
    })), instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
        label: $0436077bbb9407ca$var$instructionsLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Markdown, {
        source: instructions
    })), hasVisibleKnowledge && cloudId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
        label: $0436077bbb9407ca$var$knowledgeLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fP2S.KnowledgePillList), {
        cloudId: cloudId,
        knowledge: knowledge,
        preferDirectConnectorFetch: true
    })), tools.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$Section, {
        label: $0436077bbb9407ca$var$toolsLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0436077bbb9407ca$var$ToolsList, {
        tools: tools
    })))), !isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0436077bbb9407ca$var$styles.fade
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0436077bbb9407ca$var$styles.floatingChevron
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "rovo-create-agent-card-expand",
        appearance: "default",
        shape: "circle",
        isTooltipDisabled: false,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        label: intl.formatMessage($0436077bbb9407ca$var$expandLabel),
        onClick: onExpand
    }))));
};
function $0436077bbb9407ca$var$_temp(tool, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: `tool-pill-${tool.id}-${index}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76qWr.AgentActionPill), {
        action: {
            id: tool.id,
            displayName: tool.displayName,
            tags: tool.tags,
            iconUrl: tool.iconUrl
        },
        isActive: tool.isActive ?? true
    }));
}
function $0436077bbb9407ca$var$_temp2(source) {
    return source?.enabled;
}
function $0436077bbb9407ca$var$_temp3(edge) {
    return edge.enabled && edge.sources?.some($0436077bbb9407ca$var$_temp2);
}
module.exports["ExpandableBody"] = $0436077bbb9407ca$export$c18e573300f962ba;

});

parcelRegister("VGHbH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $bxtKM = parcelRequire("bxtKM");


var $lpNn5 = parcelRequire("lpNn5");


var $hntO9 = parcelRequire("hntO9");


var $a6w1L = parcelRequire("a6w1L");

const $87498c345205fb07$var$styles = {
    container: "_0Of8r21Y8M _1wydGW1Y8M",
    textContainer: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
};
const $87498c345205fb07$export$f068bfbae04c947c = ({ build: build, label: label, index: index, stepNumber: stepNumber })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const textRef = (0, $cozmU.useRef)(null);
    const isTruncated = textRef.current && textRef.current?.scrollWidth > textRef.current?.clientWidth;
    const displayLabel = formatMessage((0, $hntO9.messages).tabLabelWithStep, {
        stepNumber: stepNumber,
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isTruncated ? displayLabel : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100",
        xcss: $87498c345205fb07$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6w1L.BuildTabIcon), {
        build: build,
        index: index
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: textRef,
        xcss: $87498c345205fb07$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, displayLabel)))));
};
module.exports["BuildTab"] = $87498c345205fb07$export$f068bfbae04c947c;

});

parcelRegister("hntO9", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $924879f389ada4b5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    expandCardLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.expand-card-label",
        defaultMessage: "Expand card"
    },
    noBuildsTitle: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.no-builds-title",
        defaultMessage: "No builds available"
    },
    noBuildsDescription: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.no-builds-description",
        defaultMessage: "No builds available for this solution"
    },
    moreButtonLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.more-button-label",
        defaultMessage: "More"
    },
    tabLabelWithStep: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.tab-label-with-step",
        defaultMessage: "Step {stepNumber}: {label}"
    }
});
module.exports["messages"] = $924879f389ada4b5$export$defe85febe8b728c;

});

parcelRegister("az160", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $9ae54f74183efc9d$var$EMPTY_SET = new Set();
const $9ae54f74183efc9d$export$ac9a0a91682aac1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOverflowTabs(selectedTabIndex) {
    const $ = (0, $bDgLe.c)(9);
    const tabListContainerRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useRef)(null);
    const [hasOverflow, setHasOverflow] = (0, $cozmU.useState)(false);
    const [hiddenTabIndices, setHiddenTabIndices] = (0, $cozmU.useState)($9ae54f74183efc9d$var$EMPTY_SET);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const tabWidthsRef = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] !== selectedTabIndex) {
        t1 = ()=>{
            const containerEl = tabListContainerRef.current;
            if (!containerEl) return;
            const tabs = containerEl.querySelectorAll("[role=\"tab\"]");
            if (tabs.length === 0) {
                setHasOverflow(false);
                setHiddenTabIndices($9ae54f74183efc9d$var$EMPTY_SET);
                return;
            }
            if (tabWidthsRef.current.length === 0) tabWidthsRef.current = Array.from(tabs).map($9ae54f74183efc9d$var$_temp);
            const tabWidths = tabWidthsRef.current;
            const totalTabWidth = tabWidths.reduce($9ae54f74183efc9d$var$_temp2, 0);
            const containerWidth = containerEl.clientWidth;
            if (totalTabWidth <= containerWidth) {
                setHasOverflow(false);
                setHiddenTabIndices($9ae54f74183efc9d$var$EMPTY_SET);
                return;
            }
            setHasOverflow(true);
            const moreButtonWidth = moreButtonRef.current?.getBoundingClientRect().width ?? 0;
            const selectedTabWidth = tabWidths[selectedTabIndex] ?? 0;
            let remainingWidth = containerWidth - selectedTabWidth - moreButtonWidth;
            const hidden = new Set();
            for(let i = 0; i < tabWidths.length; i++){
                if (i === selectedTabIndex) continue;
                if (tabWidths[i] <= remainingWidth) remainingWidth = remainingWidth - tabWidths[i];
                else hidden.add(i);
            }
            setHiddenTabIndices(hidden);
        };
        $[1] = selectedTabIndex;
        $[2] = t1;
    } else t1 = $[2];
    const checkOverflow = t1;
    let t2;
    let t3;
    if ($[3] !== checkOverflow) {
        t2 = ()=>{
            const containerEl_0 = tabListContainerRef.current;
            if (!containerEl_0) return;
            const observer = new ResizeObserver(()=>{
                tabWidthsRef.current = [];
                checkOverflow();
            });
            observer.observe(containerEl_0);
            return ()=>{
                observer.disconnect();
            };
        };
        t3 = [
            checkOverflow
        ];
        $[3] = checkOverflow;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[6] !== hasOverflow || $[7] !== hiddenTabIndices) {
        t4 = {
            tabListRef: tabListContainerRef,
            moreButtonRef: moreButtonRef,
            hasOverflow: hasOverflow,
            hiddenTabIndices: hiddenTabIndices
        };
        $[6] = hasOverflow;
        $[7] = hiddenTabIndices;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function useOverflowTabs(selectedTabIndex) {
    const tabListContainerRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useRef)(null);
    const [hasOverflow, setHasOverflow] = (0, $cozmU.useState)(false);
    const [hiddenTabIndices, setHiddenTabIndices] = (0, $cozmU.useState)($9ae54f74183efc9d$var$EMPTY_SET);
    const tabWidthsRef = (0, $cozmU.useRef)([]);
    const checkOverflow = (0, $cozmU.useCallback)(()=>{
        const containerEl = tabListContainerRef.current;
        if (!containerEl) return;
        const tabs = containerEl.querySelectorAll('[role="tab"]');
        if (tabs.length === 0) {
            setHasOverflow(false);
            setHiddenTabIndices($9ae54f74183efc9d$var$EMPTY_SET);
            return;
        }
        // Capture tab widths on the first measurement (before any are hidden).
        // Use scrollWidth to get the natural (untruncated) width of each tab.
        if (tabWidthsRef.current.length === 0) tabWidthsRef.current = Array.from(tabs).map((tab)=>tab.scrollWidth);
        const tabWidths = tabWidthsRef.current;
        const totalTabWidth = tabWidths.reduce((sum, w)=>sum + w, 0);
        const containerWidth = containerEl.clientWidth;
        if (totalTabWidth <= containerWidth) {
            setHasOverflow(false);
            setHiddenTabIndices($9ae54f74183efc9d$var$EMPTY_SET);
            return;
        }
        setHasOverflow(true);
        const moreButtonWidth = moreButtonRef.current?.getBoundingClientRect().width ?? 0;
        // Always show the selected tab (it may truncate)
        const selectedTabWidth = tabWidths[selectedTabIndex] ?? 0;
        let remainingWidth = containerWidth - selectedTabWidth - moreButtonWidth;
        const hidden = new Set();
        for(let i = 0; i < tabWidths.length; i++){
            if (i === selectedTabIndex) continue;
            // Only show a non-selected tab if its full width fits
            if (tabWidths[i] <= remainingWidth) remainingWidth -= tabWidths[i];
            else hidden.add(i);
        }
        setHiddenTabIndices(hidden);
    }, [
        selectedTabIndex
    ]);
    (0, $cozmU.useEffect)(()=>{
        const containerEl_0 = tabListContainerRef.current;
        if (!containerEl_0) return;
        const observer = new ResizeObserver(()=>{
            tabWidthsRef.current = [];
            checkOverflow();
        });
        observer.observe(containerEl_0);
        return ()=>{
            observer.disconnect();
        };
    }, [
        checkOverflow
    ]);
    return {
        tabListRef: tabListContainerRef,
        moreButtonRef: moreButtonRef,
        hasOverflow: hasOverflow,
        hiddenTabIndices: hiddenTabIndices
    };
};
/**
 * A no-op version of useOverflowTabs for when the responsive tabs feature gate is disabled.
 * Returns refs that are never attached to anything and always reports no overflow.
 */ function $9ae54f74183efc9d$var$_temp2(sum, w) {
    return sum + w;
}
function $9ae54f74183efc9d$var$_temp(tab) {
    return tab.scrollWidth;
}
const $9ae54f74183efc9d$export$9cb2f79b1f72bfa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOverflowTabsNoop(_selectedTabIndex) {
    const $ = (0, $bDgLe.c)(1);
    const tabListRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            tabListRef: tabListRef,
            moreButtonRef: moreButtonRef,
            hasOverflow: false,
            hiddenTabIndices: $9ae54f74183efc9d$var$EMPTY_SET
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function useOverflowTabsNoop(_selectedTabIndex) {
    const tabListRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useRef)(null);
    return {
        tabListRef: tabListRef,
        moreButtonRef: moreButtonRef,
        hasOverflow: false,
        hiddenTabIndices: $9ae54f74183efc9d$var$EMPTY_SET
    };
};
module.exports["useOverflowTabs"] = $9ae54f74183efc9d$export$ac9a0a91682aac1e;

});

parcelRegister("ffqiV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4vdac = parcelRequire("4vdac");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $88DFk = parcelRequire("88DFk");


var $hdBxM = parcelRequire("hdBxM");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $if0Cf = parcelRequire("if0Cf");


var $7txt6 = parcelRequire("7txt6");


var $hS6Fc = parcelRequire("hS6Fc");


var $2bqQJ = parcelRequire("2bqQJ");


var $j9ZfO = parcelRequire("j9ZfO");

const $f78bb64edc4a9dbb$var$BuildAgentButton = ({ build: build, canManageAgents: canManageAgents })=>{
    (0, $6cFsl.di)((0, $hS6Fc.useHandoffAction));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isSubmitting: isSubmitting, startHandoff: startHandoff } = (0, $hS6Fc.useHandoffAction)(build, {
        handoffPayloadDataFactory: (solutionBuildResponse)=>({
                ...(0, $iDrrr.fg)('rovo_agent_versioning_enabled') && {
                    ari: solutionBuildResponse.ari
                },
                buildId: solutionBuildResponse.buildId,
                type: 'ROVO_AGENT',
                conversationId: build.conversationId
            })
    });
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [, { trackCreateSession: trackCreateSession }] = (0, $88DFk.useRovoAgentCreateAnalytics)({
        touchPoint: 'solution-architect-plan-card'
    });
    const additionalAnalyticsAttributesEnabled = (0, $iDrrr.fg)('additional-analytics-params-for-sa');
    const handleClick = ()=>{
        startHandoff();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'agentSolutionPlanDraft',
            attributes: {
                buildType: build.type,
                buildNumber: build.number,
                buildState: build.state,
                solutionId: build.solutionId,
                solutionVersion: build.solutionVersion,
                conversationId: build.conversationId,
                ...additionalAnalyticsAttributesEnabled && {
                    draftBuildId: build.id
                }
            }
        });
        trackCreateSession('saDraft', {
            draftBuildId: build.id
        });
    };
    const renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
            build: build,
            appearance: "primary",
            onClick: handleClick,
            isLoading: isSubmitting,
            isDisabled: !canManageAgents
        }, formatMessage((0, $j9ZfO.messages).buildAgentButtonLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip),
        canAppear: ()=>!canManageAgents
    }, renderButton());
};
const $f78bb64edc4a9dbb$var$isActivationLifecycleEvent = (payload)=>[
        'solution-architect-agent-activation-flow-started',
        'solution-architect-agent-activation-flow-stopped'
    ].includes(payload.type);
const $f78bb64edc4a9dbb$var$ActivateAgentButton = ({ build: build, canManageAgents: canManageAgents })=>{
    (0, $6cFsl.di)((0, $hS6Fc.useHandoffAction), (0, $hdBxM.usePublish));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const [activationInProgress, setActivationInProgress] = (0, $cozmU.useState)(false);
    const handleSubscriberEvent = (payload)=>{
        if (!$f78bb64edc4a9dbb$var$isActivationLifecycleEvent(payload) || payload.data.draftBuildId !== build.id) return;
        switch(payload.type){
            case 'solution-architect-agent-activation-flow-started':
                setActivationInProgress(true);
                break;
            case 'solution-architect-agent-activation-flow-stopped':
                setActivationInProgress(false);
                break;
        }
    };
    /**
   * When activating an agent from the plan card, we do the initial handoff call
   * first to ensure redirecting to the draft agent page. And then we publish a
   * solution-architect-agent-activation event to notify the agent studio to activate
   * the agent.
   *
   * This is likely to change in the future, when we support draft agent and can
   * activate the agent directly from the plan card.
   */ const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [, { trackCreateSession: trackCreateSession }] = (0, $88DFk.useRovoAgentCreateAnalytics)({
        touchPoint: 'solution-architect-plan-card'
    });
    const { startHandoff: startHandoff } = (0, $hS6Fc.useHandoffAction)(build, {
        handoffPayloadDataFactory: (solutionBuildResponse)=>({
                buildId: solutionBuildResponse.buildId,
                ...(0, $iDrrr.fg)('rovo_agent_versioning_enabled') && {
                    ari: solutionBuildResponse.ari
                },
                type: 'ROVO_AGENT',
                conversationId: build.conversationId,
                ...(0, $iDrrr.fg)('fe_enable_sa_externally') && {
                    shouldActivateAgent: true
                }
            }),
        ...!(0, $iDrrr.fg)('fe_enable_sa_externally') && {
            onSuccessCallback: (solutionBuildResponse_0)=>{
                publish({
                    type: 'solution-architect-agent-activation',
                    source: 'ai-mate',
                    data: {
                        draftBuildId: solutionBuildResponse_0.buildId,
                        ...(0, $iDrrr.fg)('rovo_agent_versioning_enabled') && {
                            ari: solutionBuildResponse_0.ari
                        }
                    }
                });
            }
        }
    });
    const additionalAnalyticsAttributesEnabled = (0, $iDrrr.fg)('additional-analytics-params-for-sa');
    const handleClick = ()=>{
        publish({
            type: 'solution-architect-agent-activation-flow-started',
            source: 'ai-mate',
            data: {
                draftBuildId: build.id
            }
        });
        startHandoff();
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'activated',
            actionSubject: 'solutionPlan',
            actionSubjectId: 'agentSolutionPlan',
            ...additionalAnalyticsAttributesEnabled && {
                draftBuildId: build.id
            }
        });
        trackCreateSession('createFlowActivate', {
            draftBuildId: build.id
        });
    };
    const renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
            build: build,
            appearance: "primary",
            onClick: handleClick,
            isLoading: activationInProgress,
            isDisabled: !canManageAgents
        }, formatMessage(build.ari && (0, $iDrrr.fg)('rovo_agent_versioning_enabled') ? (0, $j9ZfO.messages).publishAgentButtonLabel : (0, $j9ZfO.messages).activateAgentButtonLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        topic: "ai-mate",
        onEvent: handleSubscriberEvent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip),
        canAppear: ()=>!canManageAgents
    }, renderButton()));
};
// LoadingButton is used as a fallback for the Suspense component while the permissions query is loading.
const $f78bb64edc4a9dbb$var$LoadingButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { build: build } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = build.state === "WAITING" ? (0, $j9ZfO.messages).buildAgentButtonLabel : (0, $j9ZfO.messages).activateAgentButtonLabel;
    let t1;
    if ($[0] !== formatMessage || $[1] !== message) {
        t1 = formatMessage(message);
        $[0] = formatMessage;
        $[1] = message;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== build || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
            build: build,
            appearance: "primary",
            isLoading: true
        }, t1);
        $[3] = build;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ build: build })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = build.state === 'WAITING' ? (0, $j9ZfO.messages).buildAgentButtonLabel : (0, $j9ZfO.messages).activateAgentButtonLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
        build: build,
        appearance: "primary",
        isLoading: true
    }, formatMessage(message));
};
const $f78bb64edc4a9dbb$var$AgentFooterActionsWithQuery = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { build: build } = t0;
    (0, $6cFsl.di)();
    const { cloudId: cloudId } = (0, $7txt6.useSolutionPlan)();
    const t1 = cloudId || "";
    const t2 = !cloudId;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            cloudId: t1,
            skip: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $4vdac.default), t3);
    const canManageAgents = !!data.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents;
    let t4;
    if ($[3] !== build || $[4] !== canManageAgents) {
        t4 = build.state === "WAITING" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$BuildAgentButton, {
            build: build,
            canManageAgents: canManageAgents
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$ActivateAgentButton, {
            build: build,
            canManageAgents: canManageAgents
        });
        $[3] = build;
        $[4] = canManageAgents;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ build: build })=>{
    (0, $6cFsl.di)();
    const { cloudId: cloudId } = (0, $7txt6.useSolutionPlan)();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $4vdac.default), {
        cloudId: cloudId || '',
        skip: !cloudId
    });
    const canManageAgents = !!data.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents;
    return build.state === 'WAITING' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$BuildAgentButton, {
        build: build,
        canManageAgents: canManageAgents
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$ActivateAgentButton, {
        build: build,
        canManageAgents: canManageAgents
    });
};
const $f78bb64edc4a9dbb$export$48a911a2ace19cf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$LoadingButton, props)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$AgentFooterActionsWithQuery, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$LoadingButton, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f78bb64edc4a9dbb$var$AgentFooterActionsWithQuery, props));
};
module.exports["AgentFooterActions"] = $f78bb64edc4a9dbb$export$48a911a2ace19cf9;

});

parcelRegister("jZK23", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $4ez2K = parcelRequire("4ez2K");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $k6kJT = parcelRequire("k6kJT");


var $6OT4g = parcelRequire("6OT4g");


var $lzU6z = parcelRequire("lzU6z");


var $if0Cf = parcelRequire("if0Cf");


var $7txt6 = parcelRequire("7txt6");


var $hS6Fc = parcelRequire("hS6Fc");


var $2bqQJ = parcelRequire("2bqQJ");


var $hVeqT = parcelRequire("hVeqT");

const $45e615ea5d0a68a4$var$AppFooterActionsInner = ({ build: build, canManageApp: canManageApp, loadingPermissions: loadingPermissions })=>{
    (0, $6cFsl.di)((0, $hS6Fc.useHandoffAction));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const additionalAnalyticsAttributesEnabled = (0, $iDrrr.fg)('additional-analytics-params-for-sa');
    const { isSubmitting: isSubmittingForBuild, startHandoff: startHandoffForBuild } = (0, $hS6Fc.useHandoffAction)(build, {
        handoffPayloadDataFactory: (solutionBuildResponse)=>({
                ari: solutionBuildResponse.ari,
                type: 'ECOSYSTEM_APP',
                conversationId: build.conversationId,
                appBuilderAutoStart: true
            })
    });
    const { isSubmitting: isSubmittingForReview, startHandoff: startHandoffForReview } = (0, $hS6Fc.useHandoffAction)(build, {
        handoffPayloadDataFactory: (solutionBuildResponse_0)=>({
                ari: solutionBuildResponse_0.ari,
                type: 'ECOSYSTEM_APP',
                conversationId: build.conversationId,
                appBuilderAutoStart: false
            })
    });
    const handleClickBuild = ()=>{
        startHandoffForBuild();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'appSolutionPlanDraft',
            attributes: {
                buildType: build.type,
                buildNumber: build.number,
                buildState: build.state,
                solutionId: build.solutionId,
                solutionVersion: build.solutionVersion,
                conversationId: build.conversationId,
                ...additionalAnalyticsAttributesEnabled && {
                    draftBuildId: build.id
                }
            }
        });
    };
    const handleClickReview = ()=>{
        startHandoffForReview();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'appSolutionPlanReviewSpec',
            attributes: {
                buildType: build.type,
                buildNumber: build.number,
                buildState: build.state,
                solutionId: build.solutionId,
                solutionVersion: build.solutionVersion,
                conversationId: build.conversationId,
                ...additionalAnalyticsAttributesEnabled && {
                    draftBuildId: build.id
                }
            }
        });
    };
    const isLoadingBuildApp = loadingPermissions || isSubmittingForBuild;
    const isLoadingReviewSpecs = loadingPermissions || isSubmittingForReview;
    const isDisabled = !canManageApp;
    const renderButtons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
            build: build,
            appearance: "primary",
            onClick: handleClickBuild,
            isLoading: isLoadingBuildApp,
            isDisabled: isDisabled
        }, formatMessage((0, $hVeqT.messages).buildAppButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
            build: build,
            onClick: handleClickReview,
            isLoading: isLoadingReviewSpecs,
            isDisabled: isDisabled
        }, formatMessage((0, $hVeqT.messages).reviewSpecsButtonLabel)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip),
        canAppear: ()=>!canManageApp && !loadingPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, renderButtons()));
};
const $45e615ea5d0a68a4$var$AppFooterActionsLegacy = ({ build: build })=>{
    (0, $6cFsl.di)((0, $lzU6z.getWorkspaceIdFromUrl), (0, $6OT4g.useLegacyWorkspacePermissions));
    const workspaceIdFromUrl = (0, $cozmU.useMemo)((0, $lzU6z.getWorkspaceIdFromUrl), []) || '';
    const { loading: loadingPermissions, permissions: permissions } = (0, $6OT4g.useLegacyWorkspacePermissions)(workspaceIdFromUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsInner, {
        build: build,
        canManageApp: permissions.manageApp,
        loadingPermissions: loadingPermissions
    });
};
const $45e615ea5d0a68a4$var$AppFooterActionsWithQuery = ({ build: build })=>{
    (0, $6cFsl.di)((0, $7txt6.useSolutionPlan), (0, $k6kJT.WorkspacePermissionsProvider));
    const { workspaceId: workspaceId, spaceId: spaceId, aaid: aaid } = (0, $7txt6.useSolutionPlan)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k6kJT.WorkspacePermissionsProvider), {
        workspaceId: workspaceId || '',
        spaceId: spaceId || '',
        accountId: aaid
    }, ({ permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsInner, {
            build: build,
            canManageApp: permissions.manageApp,
            loadingPermissions: false
        }));
};
const $45e615ea5d0a68a4$var$AppFooterActionsLoading = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { build: build } = t0;
    let t1;
    if ($[0] !== build) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsInner, {
            build: build,
            canManageApp: false,
            loadingPermissions: true
        });
        $[0] = build;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ build: build })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsInner, {
        build: build,
        canManageApp: false,
        loadingPermissions: true
    });
const $45e615ea5d0a68a4$export$8c1725da75e9d037 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { build: build } = t0;
    let t1;
    if ($[0] !== build) {
        t1 = (0, $iDrrr.fg)("fe_enable_sa_externally") && (0, $iDrrr.fg)("sltns-1069-popup-blocked-bug-fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsLoading, {
                build: build
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsWithQuery, {
            build: build
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsLegacy, {
            build: build
        });
        $[0] = build;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ build: build })=>{
    // one flag is dependent on the other and the original flag is in RTs whereas the latter isn't
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return (0, $iDrrr.fg)('fe_enable_sa_externally') && (0, $iDrrr.fg)('sltns-1069-popup-blocked-bug-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsLoading, {
            build: build
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsWithQuery, {
        build: build
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45e615ea5d0a68a4$var$AppFooterActionsLegacy, {
        build: build
    });
};
module.exports["AppFooterActions"] = $45e615ea5d0a68a4$export$8c1725da75e9d037;

});

parcelRegister("bkJmI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $iV65j = parcelRequire("iV65j");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $4MnFz = parcelRequire("4MnFz");


var $7sJoX = parcelRequire("7sJoX");


var $5avUB = parcelRequire("5avUB");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $k6kJT = parcelRequire("k6kJT");


var $6OT4g = parcelRequire("6OT4g");


var $lzU6z = parcelRequire("lzU6z");


var $if0Cf = parcelRequire("if0Cf");


var $7txt6 = parcelRequire("7txt6");


var $hS6Fc = parcelRequire("hS6Fc");


var $2bqQJ = parcelRequire("2bqQJ");


var $4kBlh = parcelRequire("4kBlh");


var $5DDRP = parcelRequire("5DDRP");

const $fa3aa94264317eb7$var$BuildAutomationButton = ({ build: build, canManageAutomation: canManageAutomation, loadingPermissions: loadingPermissions, permissionDeniedTooltip: permissionDeniedTooltip, sendAnalytics: sendAnalytics })=>{
    (0, $6cFsl.di)((0, $lpNn5.default), (0, $hS6Fc.useHandoffAction));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isSubmitting: isSubmitting, startHandoff: startHandoff } = (0, $hS6Fc.useHandoffAction)(build, {
        handoffPayloadDataFactory: (solutionBuildResponse)=>({
                buildId: solutionBuildResponse.buildId,
                type: 'AUTOMATION_RULE',
                conversationId: build.conversationId
            })
    });
    const handleClick = ()=>{
        startHandoff();
        sendAnalytics({
            action: 'clicked',
            subjectId: 'automationSolutionPlan'
        });
    };
    const isLoading = loadingPermissions || isSubmitting;
    const isDisabled = !canManageAutomation;
    const isFlow = (0, $iDrrr.fg)('studio-rename-rule-to-flow');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: permissionDeniedTooltip,
        canAppear: ()=>!canManageAutomation && !loadingPermissions
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $if0Cf.ActionButton), {
            build: build,
            appearance: "primary",
            testId: "build-automation-button",
            onClick: handleClick,
            isLoading: isLoading,
            isDisabled: isDisabled
        }, isFlow ? formatMessage((0, $4kBlh.messages).buildAutomationActionLabel) : formatMessage((0, $4kBlh.messages).buildAutomationActionLabelOld)));
};
const $fa3aa94264317eb7$var$SaveOrPublishAutomationButton = ({ build: build, canManageAutomation: canManageAutomation, loadingPermissions: loadingPermissions, permissionDeniedTooltip: permissionDeniedTooltip, workspaceId: workspaceId, spaceId: spaceId, sendAnalytics: sendAnalytics })=>{
    (0, $6cFsl.di)((0, $5DDRP.saveAutomation), (0, $lpNn5.default), (0, $7txt6.useSolutionPlan));
    const [isSaving, setIsSaving] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { refetchSolutionPlan: refetchSolutionPlan } = (0, $7txt6.useSolutionPlan)();
    const isLoading = loadingPermissions || isSaving;
    const isDisabled = !canManageAutomation || !workspaceId || !spaceId || isSaving;
    const handleSave = async (publish)=>{
        setIsSaving(true);
        const subjectId = publish ? 'saveAndEnableAutomation' : 'saveAutomation';
        sendAnalytics({
            action: 'clicked',
            subjectId: subjectId
        });
        try {
            await (0, $5DDRP.saveAutomation)({
                buildId: build.id,
                workspaceId: workspaceId,
                spaceId: spaceId,
                publish: publish
            });
            refetchSolutionPlan();
        } catch  {
            sendAnalytics({
                action: 'failed',
                subjectId: subjectId
            });
            showFlag({
                title: formatMessage((0, $4kBlh.messages).saveAutomationErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                }),
                description: formatMessage((0, $4kBlh.messages).saveAutomationErrorDescription),
                isAutoDismiss: true
            });
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: permissionDeniedTooltip,
        canAppear: ()=>!canManageAutomation && !loadingPermissions
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), {
            appearance: "primary",
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: ()=>{
                handleSave(true);
            },
            isLoading: isLoading,
            testId: "save-and-publish-automation-button"
        }, formatMessage((0, $4kBlh.messages).saveAndPublishAutomationActionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            shouldRenderToParent: true,
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    ...triggerProps,
                    ref: triggerRef,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
                    label: formatMessage((0, $4kBlh.messages).saveOrPublishAutomationDropdownTriggerLabel),
                    testId: "save-or-publish-automation-dropdown-trigger"
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: ()=>{
                handleSave(false);
            },
            testId: "save-automation-dropdown-item"
        }, formatMessage((0, $4kBlh.messages).saveAutomationActionLabel))))));
};
const $fa3aa94264317eb7$var$AutomationFooterActionsInner = ({ build: build, canManageAutomation: canManageAutomation, loadingPermissions: loadingPermissions, permissionDeniedTooltip: permissionDeniedTooltip, workspaceId: workspaceId, spaceId: spaceId })=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const additionalAnalyticsAttributesEnabled = (0, $iDrrr.fg)('additional-analytics-params-for-sa');
    const sendAnalytics = (0, $cozmU.useCallback)(({ action: action, subjectId: subjectId })=>{
        sendAnalyticsEvent({
            eventType: action === 'failed' ? 'operational' : 'ui',
            action: action,
            actionSubject: 'button',
            actionSubjectId: subjectId,
            attributes: {
                buildType: build.type,
                buildNumber: build.number,
                buildState: build.state,
                solutionId: build.solutionId,
                solutionVersion: build.solutionVersion,
                conversationId: build.conversationId,
                ...additionalAnalyticsAttributesEnabled && {
                    draftBuildId: build.id
                }
            }
        });
    }, [
        additionalAnalyticsAttributesEnabled,
        build.conversationId,
        build.id,
        build.number,
        build.solutionId,
        build.solutionVersion,
        build.state,
        build.type,
        sendAnalyticsEvent
    ]);
    if (build.state === 'IN_PROGRESS' && (0, $iDrrr.fg)('sltns-1051-save-automation-button')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$SaveOrPublishAutomationButton, {
        build: build,
        canManageAutomation: canManageAutomation,
        loadingPermissions: loadingPermissions,
        permissionDeniedTooltip: permissionDeniedTooltip,
        workspaceId: workspaceId,
        spaceId: spaceId,
        sendAnalytics: sendAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$BuildAutomationButton, {
        build: build,
        canManageAutomation: canManageAutomation,
        loadingPermissions: loadingPermissions,
        permissionDeniedTooltip: permissionDeniedTooltip,
        workspaceId: workspaceId,
        spaceId: spaceId,
        sendAnalytics: sendAnalytics
    });
};
const $fa3aa94264317eb7$var$AutomationFooterActionsLegacy = ({ build: build })=>{
    (0, $6cFsl.di)((0, $lzU6z.getWorkspaceIdFromUrl), (0, $6OT4g.useLegacyWorkspacePermissions), (0, $7txt6.useSolutionPlan));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const workspaceIdFromUrl = (0, $cozmU.useMemo)((0, $lzU6z.getWorkspaceIdFromUrl), []) || '';
    const spaceIdFromUrl = (0, $cozmU.useMemo)((0, $lzU6z.getSpaceIdFromUrl), []) || '';
    const { loading: loadingPermissions, permissions: permissions } = (0, $6OT4g.useLegacyWorkspacePermissions)(workspaceIdFromUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsInner, {
        build: build,
        canManageAutomation: permissions.manageAutomation,
        loadingPermissions: loadingPermissions,
        permissionDeniedTooltip: formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip),
        workspaceId: workspaceIdFromUrl,
        spaceId: spaceIdFromUrl
    });
};
const $fa3aa94264317eb7$var$AutomationFooterActionsWithQuery = ({ build: build })=>{
    (0, $6cFsl.di)((0, $7txt6.useSolutionPlan), (0, $k6kJT.WorkspacePermissionsProvider));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { workspaceId: workspaceId, spaceId: spaceId, aaid: aaid } = (0, $7txt6.useSolutionPlan)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k6kJT.WorkspacePermissionsProvider), {
        workspaceId: workspaceId || '',
        spaceId: spaceId || '',
        accountId: aaid
    }, ({ permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsInner, {
            build: build,
            canManageAutomation: permissions.manageAutomation,
            loadingPermissions: false,
            permissionDeniedTooltip: formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip),
            workspaceId: workspaceId || '',
            spaceId: spaceId || ''
        }));
};
const $fa3aa94264317eb7$var$AutomationFooterActionsLoading = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { build: build } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== build || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsInner, {
            build: build,
            canManageAutomation: false,
            loadingPermissions: true,
            permissionDeniedTooltip: t1,
            workspaceId: "",
            spaceId: ""
        });
        $[2] = build;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ build: build })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsInner, {
        build: build,
        canManageAutomation: false,
        loadingPermissions: true,
        permissionDeniedTooltip: formatMessage((0, $2bqQJ.messages).permissionDeniedTooltip),
        workspaceId: "",
        spaceId: ""
    });
};
const $fa3aa94264317eb7$export$1f4e1647d05e99ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { build: build } = t0;
    let t1;
    if ($[0] !== build) {
        t1 = (0, $iDrrr.fg)("fe_enable_sa_externally") && (0, $iDrrr.fg)("sltns-1069-popup-blocked-bug-fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsLoading, {
                build: build
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsWithQuery, {
            build: build
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsLegacy, {
            build: build
        });
        $[0] = build;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ build: build })=>{
    // one flag is dependent on the other and the original flag is in RTs whereas the latter isn't
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return (0, $iDrrr.fg)('fe_enable_sa_externally') && (0, $iDrrr.fg)('sltns-1069-popup-blocked-bug-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsLoading, {
            build: build
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsWithQuery, {
        build: build
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa3aa94264317eb7$var$AutomationFooterActionsLegacy, {
        build: build
    });
};
module.exports["AutomationFooterActions"] = $fa3aa94264317eb7$export$1f4e1647d05e99ec;

});

parcelRegister("hjQT2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $da77bec4f78d487d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    planCardVersion: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.plan-card-version",
        defaultMessage: "Plan v{solutionVersion}"
    },
    planCardCompletion: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.plan-card-completion",
        defaultMessage: "{completion}% completion"
    },
    openCardLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.open-card-label",
        defaultMessage: "Open"
    },
    closeCardLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.close-card-label",
        defaultMessage: "Close"
    }
});
module.exports["messages"] = $da77bec4f78d487d$export$defe85febe8b728c;

});

parcelRegister("9fP2S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $737YC = parcelRequire("737YC");


var $bApiv = parcelRequire("bApiv");

const $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW = 5;
const $702edf08d89aa499$export$768cfa20d3e975b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { knowledge: knowledge, cloudId: cloudId, elemAfter: elemAfter, limit: t1, preferDirectConnectorFetch: preferDirectConnectorFetch, agentCreatorType: agentCreatorType } = t0;
    const limit = t1 === undefined ? $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW : t1;
    (0, $6cFsl.di)();
    let t2;
    if ($[0] !== knowledge) {
        t2 = knowledge?.filter($702edf08d89aa499$var$_temp);
        $[0] = knowledge;
        $[1] = t2;
    } else t2 = $[1];
    const enabledKnowledge = t2;
    let t3;
    if ($[2] !== enabledKnowledge) {
        t3 = enabledKnowledge?.flatMap($702edf08d89aa499$var$_temp2).filter($702edf08d89aa499$var$_temp3).reduce($702edf08d89aa499$var$_temp4, []) ?? [];
        $[2] = enabledKnowledge;
        $[3] = t3;
    } else t3 = $[3];
    const allEnabledFilters = t3;
    let t4;
    if ($[4] !== allEnabledFilters || $[5] !== enabledKnowledge) {
        t4 = enabledKnowledge?.flatMap($702edf08d89aa499$var$_temp5).filter((source_1)=>{
            const sourceCloudId_0 = source_1?.cloudId ?? null;
            if (!source_1?.enabled || [
                "confluence",
                "jira",
                "jsm"
            ].includes(source_1.source) && allEnabledFilters.some((f_0)=>f_0.source === source_1.source && f_0.cloudId === sourceCloudId_0)) return false;
            return true;
        }).reduce($702edf08d89aa499$var$_temp6, []) ?? [];
        $[4] = allEnabledFilters;
        $[5] = enabledKnowledge;
        $[6] = t4;
    } else t4 = $[6];
    const allEnabledSources = t4;
    const allEnabledSources_0 = allEnabledSources;
    let t5;
    if ($[7] !== allEnabledFilters || $[8] !== allEnabledSources_0) {
        t5 = allEnabledFilters.concat(allEnabledSources_0);
        $[7] = allEnabledFilters;
        $[8] = allEnabledSources_0;
        $[9] = t5;
    } else t5 = $[9];
    const allCombinedSources = t5;
    const showMoreEnabled = limit > 0;
    let t6;
    if ($[10] !== allCombinedSources || $[11] !== limit) {
        t6 = allCombinedSources.slice(0, limit > 0 ? limit : undefined);
        $[10] = allCombinedSources;
        $[11] = limit;
        $[12] = t6;
    } else t6 = $[12];
    const firstFiveSources = t6;
    let t7;
    if ($[13] !== agentCreatorType || $[14] !== allCombinedSources.length || $[15] !== cloudId || $[16] !== elemAfter || $[17] !== firstFiveSources || $[18] !== preferDirectConnectorFetch || $[19] !== showMoreEnabled) {
        let t8;
        if ($[21] !== agentCreatorType || $[22] !== allCombinedSources.length || $[23] !== cloudId || $[24] !== elemAfter || $[25] !== preferDirectConnectorFetch || $[26] !== showMoreEnabled) {
            t8 = (source_3, index)=>{
                const isLastSource = index === $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    key: `knowledge-source-${index}`,
                    spread: "space-between",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bApiv.KnowledgeSourcePill), {
                    ari: source_3.ari,
                    source: source_3.source,
                    cloudId: source_3.cloudId || cloudId,
                    preferDirectConnectorFetch: preferDirectConnectorFetch,
                    agentCreatorType: agentCreatorType
                }), isLastSource && allCombinedSources.length > $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW && showMoreEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
                    content: `+ ${allCombinedSources.length - $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW}`,
                    fullWidth: true
                })), elemAfter?.(source_3));
            };
            $[21] = agentCreatorType;
            $[22] = allCombinedSources.length;
            $[23] = cloudId;
            $[24] = elemAfter;
            $[25] = preferDirectConnectorFetch;
            $[26] = showMoreEnabled;
            $[27] = t8;
        } else t8 = $[27];
        t7 = firstFiveSources.map(t8);
        $[13] = agentCreatorType;
        $[14] = allCombinedSources.length;
        $[15] = cloudId;
        $[16] = elemAfter;
        $[17] = firstFiveSources;
        $[18] = preferDirectConnectorFetch;
        $[19] = showMoreEnabled;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t7);
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ knowledge: knowledge, cloudId: cloudId, elemAfter: elemAfter, limit: limit = $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW, preferDirectConnectorFetch: preferDirectConnectorFetch, agentCreatorType: agentCreatorType })=>{
    (0, $6cFsl.di)();
    const enabledKnowledge = (0, $cozmU.useMemo)(()=>{
        return knowledge?.filter((edge)=>edge.enabled);
    }, [
        knowledge
    ]);
    const allEnabledFilters = (0, $cozmU.useMemo)(()=>{
        return enabledKnowledge?.flatMap((edge_0)=>edge_0.sources).filter((source)=>source?.enabled ?? false).reduce((acc, source_0)=>{
            const aris = [
                ...source_0?.filters?.parentFilter ?? [],
                ...source_0?.filters?.projectFilter ?? [],
                ...source_0?.filters?.jsmProjectFilter ?? [],
                ...source_0?.filters?.spaceFilter ?? [],
                ...source_0?.filters?.helpCenterAri ? [
                    source_0.filters.helpCenterAri
                ] : []
            ];
            const sourceCloudId = source_0.cloudId ?? null;
            aris.forEach((ari)=>{
                if (!acc.some((f)=>f.ari === ari && f.source === source_0.source && f.cloudId === sourceCloudId)) acc.push({
                    source: source_0.source,
                    ari: ari,
                    resourceType: source_0.resourceType,
                    cloudId: sourceCloudId
                });
            });
            return acc;
        }, []) ?? [];
    }, [
        enabledKnowledge
    ]);
    const allEnabledSources_0 = (0, $cozmU.useMemo)(()=>{
        const allEnabledSources = enabledKnowledge?.flatMap((edge_1)=>edge_1.sources).filter((source_1)=>{
            const sourceCloudId_0 = source_1?.cloudId ?? null;
            // If confluence or jira is enabled with no filters
            // it means that the knowledge is scoped to all projects / content
            if (!source_1?.enabled || [
                'confluence',
                'jira',
                'jsm'
            ].includes(source_1.source) && allEnabledFilters.some((f_0)=>f_0.source === source_1.source && f_0.cloudId === sourceCloudId_0)) return false;
            return true;
        }).reduce((acc_0, source_2)=>{
            const sourceCloudId_1 = source_2.cloudId ?? null;
            if (!acc_0.some((s)=>s.source === source_2.source && s.cloudId === sourceCloudId_1)) acc_0.push({
                source: source_2.source,
                resourceType: source_2.resourceType,
                cloudId: sourceCloudId_1
            });
            return acc_0;
        }, []) ?? [];
        return allEnabledSources;
    }, [
        allEnabledFilters,
        enabledKnowledge
    ]);
    const allCombinedSources = (0, $cozmU.useMemo)(()=>{
        return allEnabledFilters.concat(allEnabledSources_0);
    }, [
        allEnabledFilters,
        allEnabledSources_0
    ]);
    const showMoreEnabled = limit > 0;
    const firstFiveSources = (0, $cozmU.useMemo)(()=>allCombinedSources.slice(0, limit > 0 ? limit : undefined), [
        allCombinedSources,
        limit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, firstFiveSources.map((source_3, index)=>{
        const isLastSource = index === $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: `knowledge-source-${index}`,
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bApiv.KnowledgeSourcePill), {
            ari: source_3.ari,
            source: source_3.source,
            cloudId: source_3.cloudId || cloudId,
            preferDirectConnectorFetch: preferDirectConnectorFetch,
            agentCreatorType: agentCreatorType
        }), isLastSource && allCombinedSources.length > $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW && showMoreEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
            content: `+ ${allCombinedSources.length - $702edf08d89aa499$var$NUMBER_OF_SOURCES_TO_SHOW}`,
            fullWidth: true
        })), elemAfter?.(source_3));
    }));
};
function $702edf08d89aa499$var$_temp(edge) {
    return edge.enabled;
}
function $702edf08d89aa499$var$_temp2(edge_0) {
    return edge_0.sources;
}
function $702edf08d89aa499$var$_temp3(source) {
    return source?.enabled ?? false;
}
function $702edf08d89aa499$var$_temp4(acc, source_0) {
    const aris = [
        ...source_0?.filters?.parentFilter ?? [],
        ...source_0?.filters?.projectFilter ?? [],
        ...source_0?.filters?.jsmProjectFilter ?? [],
        ...source_0?.filters?.spaceFilter ?? [],
        ...source_0?.filters?.helpCenterAri ? [
            source_0.filters.helpCenterAri
        ] : []
    ];
    const sourceCloudId = source_0.cloudId ?? null;
    aris.forEach((ari)=>{
        if (!acc.some((f)=>f.ari === ari && f.source === source_0.source && f.cloudId === sourceCloudId)) acc.push({
            source: source_0.source,
            ari: ari,
            resourceType: source_0.resourceType,
            cloudId: sourceCloudId
        });
    });
    return acc;
}
function $702edf08d89aa499$var$_temp5(edge_1) {
    return edge_1.sources;
}
function $702edf08d89aa499$var$_temp6(acc_0, source_2) {
    const sourceCloudId_1 = source_2.cloudId ?? null;
    if (!acc_0.some((s)=>s.source === source_2.source && s.cloudId === sourceCloudId_1)) acc_0.push({
        source: source_2.source,
        resourceType: source_2.resourceType,
        cloudId: sourceCloudId_1
    });
    return acc_0;
}
module.exports["KnowledgePillList"] = $702edf08d89aa499$export$768cfa20d3e975b;

});

parcelRegister("iPNLv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $9NPFC = parcelRequire("9NPFC");


var $1Itzb = parcelRequire("1Itzb");

const $2b6dcf23ca56f7b4$var$styles = {
    card: "_4bt5LAnQyn _2WAcuGnQyn _2bqfgdOeNX",
    cardFirst: "_4bt5LAnQyn _2WAcuGnQyn _2bqfgdYbGa",
    cardHeader: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    cardContent: "_1Znuxb5zaO _2Zuz6Q5zaO _1wydGW2ADO _0KLXru66of",
    cardHeaderText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    cardFooter: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
};
const $2b6dcf23ca56f7b4$export$ab46cfb2e18b51ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { item: item, isExpanded: isExpanded, isExpandable: t1, onToggle: onToggle, isFirst: isFirst, children: children } = t0;
    const isExpandable = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t2 = isFirst ? $2b6dcf23ca56f7b4$var$styles.cardFirst : $2b6dcf23ca56f7b4$var$styles.card;
    const t3 = `accordion-card-${item.id}`;
    const t4 = `accordion-card-header-${item.id}`;
    let t5;
    if ($[0] !== item.icon || $[1] !== item.title) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
            label: item.title
        }, item.icon);
        $[0] = item.icon;
        $[1] = item.title;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== item.title) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, item.title);
        $[3] = item.title;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== item.subtitle) {
        t7 = item.subtitle && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, item.subtitle);
        $[5] = item.subtitle;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6 || $[8] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t6, t7);
        $[7] = t6;
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t5 || $[11] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $2b6dcf23ca56f7b4$var$styles.cardHeaderText
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t5, t8)));
        $[10] = t5;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== formatMessage || $[14] !== isExpandable || $[15] !== isExpanded || $[16] !== item.id || $[17] !== onToggle) {
        t10 = isExpandable && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    size: "small"
                }),
            label: isExpanded ? formatMessage((0, $1Itzb.default).collapse) : formatMessage((0, $1Itzb.default).expand),
            onClick: (e)=>{
                e.stopPropagation();
                onToggle(item.id);
            },
            testId: `accordion-card-toggle-${item.id}`
        });
        $[13] = formatMessage;
        $[14] = isExpandable;
        $[15] = isExpanded;
        $[16] = item.id;
        $[17] = onToggle;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== t10 || $[20] !== t4 || $[21] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2b6dcf23ca56f7b4$var$styles.cardHeader,
            testId: t4
        }, t9, t10);
        $[19] = t10;
        $[20] = t4;
        $[21] = t9;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== isExpanded || $[24] !== item.content || $[25] !== item.id) {
        t12 = isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2b6dcf23ca56f7b4$var$styles.cardContent,
            testId: `accordion-card-content-${item.id}`
        }, item.content);
        $[23] = isExpanded;
        $[24] = item.content;
        $[25] = item.id;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== children) {
        t13 = children && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2b6dcf23ca56f7b4$var$styles.cardFooter
        }, children);
        $[27] = children;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t2 || $[33] !== t3) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t2,
            testId: t3
        }, t11, t12, t13);
        $[29] = t11;
        $[30] = t12;
        $[31] = t13;
        $[32] = t2;
        $[33] = t3;
        $[34] = t14;
    } else t14 = $[34];
    return t14;
} : ({ item: item, isExpanded: isExpanded, isExpandable: isExpandable = true, onToggle: onToggle, isFirst: isFirst, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isFirst ? $2b6dcf23ca56f7b4$var$styles.cardFirst : $2b6dcf23ca56f7b4$var$styles.card,
        testId: `accordion-card-${item.id}`
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2b6dcf23ca56f7b4$var$styles.cardHeader,
        testId: `accordion-card-header-${item.id}`
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $2b6dcf23ca56f7b4$var$styles.cardHeaderText
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: item.title
    }, item.icon), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, item.title), item.subtitle && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, item.subtitle))))), isExpandable && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: isExpanded ? formatMessage((0, $1Itzb.default).collapse) : formatMessage((0, $1Itzb.default).expand),
        onClick: (e)=>{
            e.stopPropagation();
            onToggle(item.id);
        },
        testId: `accordion-card-toggle-${item.id}`
    })), isExpanded && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2b6dcf23ca56f7b4$var$styles.cardContent,
        testId: `accordion-card-content-${item.id}`
    }, item.content), children && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2b6dcf23ca56f7b4$var$styles.cardFooter
    }, children));
};
module.exports["AccordionCard"] = $2b6dcf23ca56f7b4$export$ab46cfb2e18b51ae;

});

parcelRegister("c5DsI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $iPNLv = parcelRequire("iPNLv");

const $dadea68f13a92a15$var$styles = {
    cardsContainer: "_0bjKvDyzSk _30huDKOeNX _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $dadea68f13a92a15$export$17da51d991c166f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { items: items, initialExpandedId: initialExpandedId, testId: t1 } = t0;
    const testId = t1 === undefined ? "accordion-cards" : t1;
    const [expandedCardId, setExpandedCardId] = (0, $cozmU.useState)(initialExpandedId ?? null);
    let t2;
    if ($[0] !== expandedCardId) {
        t2 = (cardId)=>{
            const newExpandedId = expandedCardId === cardId ? null : cardId;
            setExpandedCardId(newExpandedId);
        };
        $[0] = expandedCardId;
        $[1] = t2;
    } else t2 = $[1];
    const handleCardClick = t2;
    let t3;
    if ($[2] !== expandedCardId || $[3] !== handleCardClick || $[4] !== items) {
        let t4;
        if ($[6] !== expandedCardId || $[7] !== handleCardClick) {
            t4 = (item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iPNLv.AccordionCard), {
                    key: item.id,
                    item: item,
                    isExpanded: item.id === expandedCardId,
                    onToggle: handleCardClick,
                    isFirst: index === 0
                });
            $[6] = expandedCardId;
            $[7] = handleCardClick;
            $[8] = t4;
        } else t4 = $[8];
        t3 = items.map(t4);
        $[2] = expandedCardId;
        $[3] = handleCardClick;
        $[4] = items;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[9] !== t3 || $[10] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $dadea68f13a92a15$var$styles.cardsContainer,
            testId: testId
        }, t3);
        $[9] = t3;
        $[10] = testId;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ items: items, initialExpandedId: initialExpandedId, testId: testId = 'accordion-cards' })=>{
    const [expandedCardId, setExpandedCardId] = (0, $cozmU.useState)(initialExpandedId ?? null);
    const handleCardClick = (0, $cozmU.useCallback)((cardId)=>{
        const newExpandedId = expandedCardId === cardId ? null : cardId;
        setExpandedCardId(newExpandedId);
    }, [
        expandedCardId
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $dadea68f13a92a15$var$styles.cardsContainer,
        testId: testId
    }, items.map((item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iPNLv.AccordionCard), {
            key: item.id,
            item: item,
            isExpanded: item.id === expandedCardId,
            onToggle: handleCardClick,
            isFirst: index === 0
        })));
};
module.exports["AccordionCardList"] = $dadea68f13a92a15$export$17da51d991c166f;

});

parcelRegister("9PskX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDfTs = parcelRequire("iDfTs");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $5R8ns = parcelRequire("5R8ns");

const $338e632044215770$export$57c6889292a794c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { fieldName: fieldName, deleteDescription: deleteDescription } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $5R8ns.default).deleteIconLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: t1,
            color: "var(--ds-icon-danger, #C9372C)"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== deleteDescription || $[5] !== fieldName || $[6] !== formatMessage) {
        t3 = deleteDescription ? deleteDescription : formatMessage((0, $5R8ns.default).defaultDeleteDescription, {
            fieldName: fieldName
        });
        $[4] = deleteDescription;
        $[5] = fieldName;
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t2 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t2, t4);
        $[10] = t2;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ fieldName: fieldName, deleteDescription: deleteDescription })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
        label: formatMessage((0, $5R8ns.default).deleteIconLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, deleteDescription ? deleteDescription : formatMessage((0, $5R8ns.default).defaultDeleteDescription, {
        fieldName: fieldName
    })));
};
module.exports["DeleteFieldRenderer"] = $338e632044215770$export$57c6889292a794c3;

});

parcelRegister("6swnh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f7647681b637093d$var$message = (0, $kSwu1.defineMessages)({
    acceptButton: {
        id: "ai-mate.studio-update-agent.agent-diff.accept-button",
        defaultMessage: "Accept"
    },
    acceptAllButton: {
        id: "ai-mate.studio-update-agent.agent-diff.accept-all-button",
        defaultMessage: "Accept all"
    },
    rejectButton: {
        id: "ai-mate.studio-update-agent.agent-diff.reject-button",
        defaultMessage: "Reject"
    },
    actionCardTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card-title",
        defaultMessage: "Plan update"
    },
    descriptionTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.description.title",
        defaultMessage: "Description"
    },
    nameTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.name.title",
        defaultMessage: "Name"
    },
    behaviorTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.behavior.title",
        defaultMessage: "Behavior"
    },
    conversationStartersTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.conversation-starters.title",
        defaultMessage: "Conversation Starters"
    },
    scenariosTitleLegacy: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.scenarios-legacy.title",
        defaultMessage: "Scenarios"
    },
    scenariosTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.scenarios.title",
        defaultMessage: "Subagents"
    },
    agentPlanCardSubtitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.agent-plan-card-subtitle",
        defaultMessage: "{numberOfChanges} changes"
    },
    removeFieldDescription: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.remove-field-description",
        defaultMessage: "Remove {fieldName}."
    },
    instructionsTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.instructions-title",
        defaultMessage: "Instructions"
    },
    isDeepResearchEnabledTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.deep-research-title",
        defaultMessage: "Deep Research"
    },
    isWebSearchEnabledTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.web-search-title",
        defaultMessage: "Web Search"
    },
    knowledgeSourcesTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.knowledge-sources-title",
        defaultMessage: "Knowledge"
    },
    agenticSkillsTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.agentic-skills.title",
        defaultMessage: "Skills"
    },
    toolsTitleLegacy: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.tools-legacy.title",
        defaultMessage: "Skills"
    },
    toolsTitle: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.tools.title",
        defaultMessage: "Tools"
    },
    enabledValue: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.enabled-value",
        defaultMessage: "Enabled"
    },
    disabledValue: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.disabled-value",
        defaultMessage: "Disabled"
    },
    allOrganisationalKnowledge: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.all-organisational-knowledge",
        defaultMessage: "All organisational knowledge."
    },
    noOrganisationalKnowledge: {
        id: "ai-mate.studio-update-agent.agent-diff.action-card.field.no-organisational-knowledge",
        defaultMessage: "No organisational knowledge."
    }
});
var $f7647681b637093d$export$2e2bcd8739ae039 = $f7647681b637093d$var$message;
module.exports["default"] = $f7647681b637093d$export$2e2bcd8739ae039;

});

parcelRegister("5P3mR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $9fP2S = parcelRequire("9fP2S");


var $1PVOM = parcelRequire("1PVOM");


var $9PskX = parcelRequire("9PskX");


var $iG8JX = parcelRequire("iG8JX");


var $1wBYh = parcelRequire("1wBYh");

const $d93c2bf197460d18$var$styles = {
    heading: "_2sNsIgd8bj _1UtDYzKGUX _1DCdHi2ADO",
    section: "_1DCdHi5zaO"
};
const $d93c2bf197460d18$export$a367280fed6967b4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { scenarioToUpdate: scenarioToUpdate, cloudId: cloudId, productKey: productKey } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { scenario: scenario, updateMode: updateMode } = scenarioToUpdate;
    let t1;
    if ($[0] !== scenario.actions || $[1] !== scenario.scenarioVersion || $[2] !== scenario.tools) {
        const tools = scenario.scenarioVersion === 2 && scenario.tools ? scenario.tools?.map($d93c2bf197460d18$var$_temp) : [];
        const mcpTools = scenario.scenarioVersion !== 2 && scenario.tools ? scenario.tools?.filter($d93c2bf197460d18$var$_temp2).map($d93c2bf197460d18$var$_temp3) : [];
        const mcpServers = scenario.scenarioVersion !== 2 && scenario.tools ? scenario.tools?.filter($d93c2bf197460d18$var$_temp4).map($d93c2bf197460d18$var$_temp5) : [];
        const actions = scenario.scenarioVersion !== 2 && scenario.actions ? scenario.actions?.map($d93c2bf197460d18$var$_temp6) : [];
        t1 = [
            ...tools,
            ...mcpTools,
            ...mcpServers,
            ...actions
        ];
        $[0] = scenario.actions;
        $[1] = scenario.scenarioVersion;
        $[2] = scenario.tools;
        $[3] = t1;
    } else t1 = $[3];
    const allActions = t1;
    if (updateMode === "REMOVE") {
        const t2 = scenario.name;
        let t3;
        if ($[4] !== formatMessage || $[5] !== scenario.name) {
            t3 = formatMessage((0, $iG8JX.default).deleteDescription, {
                scenarioName: scenario.name
            });
            $[4] = formatMessage;
            $[5] = scenario.name;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== scenario.name || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PskX.DeleteFieldRenderer), {
                fieldName: t2,
                deleteDescription: t3
            });
            $[7] = scenario.name;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t2;
    if ($[10] !== scenario.knowledgeSources?.sources) {
        t2 = scenario.knowledgeSources?.sources?.some($d93c2bf197460d18$var$_temp7) ?? false;
        $[10] = scenario.knowledgeSources?.sources;
        $[11] = t2;
    } else t2 = $[11];
    const customKnowledgeSourcesEnabled = t2;
    const allOrganisationalKnowledgeEnabled = scenario.knowledgeSources?.enabled === false;
    const noOrganisationalKnowledge = !customKnowledgeSourcesEnabled && scenario.knowledgeSources?.enabled === true;
    let t3;
    if ($[12] !== formatMessage || $[13] !== scenario.invocationDescription) {
        t3 = scenario.invocationDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $d93c2bf197460d18$var$styles.section
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d93c2bf197460d18$var$styles.heading
        }, formatMessage((0, $iG8JX.default).invocationDescriptionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, scenario.invocationDescription));
        $[12] = formatMessage;
        $[13] = scenario.invocationDescription;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== cloudId || $[16] !== formatMessage || $[17] !== productKey || $[18] !== scenario.instructions) {
        t4 = scenario.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $d93c2bf197460d18$var$styles.section
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d93c2bf197460d18$var$styles.heading
        }, formatMessage((0, $iG8JX.default).instructionsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
            content: scenario.instructions,
            productKey: productKey,
            siteId: cloudId
        }));
        $[15] = cloudId;
        $[16] = formatMessage;
        $[17] = productKey;
        $[18] = scenario.instructions;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== allActions || $[21] !== formatMessage) {
        t5 = allActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $d93c2bf197460d18$var$styles.section
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d93c2bf197460d18$var$styles.heading
        }, formatMessage((0, $iG8JX.default).skillsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1wBYh.SkillList), {
            actions: allActions
        }));
        $[20] = allActions;
        $[21] = formatMessage;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== allOrganisationalKnowledgeEnabled || $[24] !== cloudId || $[25] !== customKnowledgeSourcesEnabled || $[26] !== formatMessage || $[27] !== noOrganisationalKnowledge || $[28] !== scenario.knowledgeSources) {
        t6 = scenario.knowledgeSources && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $d93c2bf197460d18$var$styles.section
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d93c2bf197460d18$var$styles.heading
        }, formatMessage((0, $iG8JX.default).knowledgeSourcesTitle)), allOrganisationalKnowledgeEnabled && formatMessage((0, $iG8JX.default).allOrganisationalKnowledge), customKnowledgeSourcesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fP2S.KnowledgePillList), {
            cloudId: cloudId,
            knowledge: [
                {
                    enabled: scenario?.knowledgeSources?.enabled,
                    sources: scenario?.knowledgeSources?.sources?.map($d93c2bf197460d18$var$_temp8)
                }
            ]
        }), noOrganisationalKnowledge && formatMessage((0, $iG8JX.default).noOrganisationalKnowledge));
        $[23] = allOrganisationalKnowledgeEnabled;
        $[24] = cloudId;
        $[25] = customKnowledgeSourcesEnabled;
        $[26] = formatMessage;
        $[27] = noOrganisationalKnowledge;
        $[28] = scenario.knowledgeSources;
        $[29] = t6;
    } else t6 = $[29];
    let t7;
    if ($[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t5, t6);
        $[30] = t3;
        $[31] = t4;
        $[32] = t5;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : ({ scenarioToUpdate: scenarioToUpdate, cloudId: cloudId, productKey: productKey })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { scenario: scenario, updateMode: updateMode } = scenarioToUpdate;
    const tools = scenario.scenarioVersion === 2 && scenario.tools ? scenario.tools?.map((tool)=>({
            actionKey: tool.toolId,
            iconUrl: tool.iconUrl,
            name: tool.displayName,
            tags: tool.tags,
            isActive: true
        })) : [];
    const mcpTools = scenario.scenarioVersion !== 2 && scenario.tools ? scenario.tools?.filter((tool_0)=>tool_0.definitionSource === 'MCP_TOOL').map((tool_1)=>({
            actionKey: tool_1.toolId,
            iconUrl: tool_1.iconUrl,
            name: tool_1.displayName,
            tags: tool_1.tags,
            isActive: true
        })) : [];
    const mcpServers = scenario.scenarioVersion !== 2 && scenario.tools ? scenario.tools?.filter((tool_2)=>tool_2.definitionSource === 'MCP_SERVER').map((tool_3)=>({
            actionKey: tool_3.toolId,
            iconUrl: tool_3.iconUrl,
            name: tool_3.displayName,
            tags: tool_3.tags,
            isActive: true
        })) : [];
    const actions = scenario.scenarioVersion !== 2 && scenario.actions ? scenario.actions?.map((action)=>({
            ...action,
            isActive: true
        })) : [];
    const allActions = [
        ...tools,
        ...mcpTools,
        ...mcpServers,
        ...actions
    ];
    if (updateMode === 'REMOVE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PskX.DeleteFieldRenderer), {
        fieldName: scenario.name,
        deleteDescription: formatMessage((0, $iG8JX.default).deleteDescription, {
            scenarioName: scenario.name
        })
    });
    const customKnowledgeSourcesEnabled = scenario.knowledgeSources?.sources?.some((source)=>source.enabled) ?? false;
    const allOrganisationalKnowledgeEnabled = scenario.knowledgeSources?.enabled === false;
    const noOrganisationalKnowledge = !customKnowledgeSourcesEnabled && scenario.knowledgeSources?.enabled === true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, scenario.invocationDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $d93c2bf197460d18$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d93c2bf197460d18$var$styles.heading
    }, formatMessage((0, $iG8JX.default).invocationDescriptionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, scenario.invocationDescription)), scenario.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $d93c2bf197460d18$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d93c2bf197460d18$var$styles.heading
    }, formatMessage((0, $iG8JX.default).instructionsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PVOM.ContentRenderer), {
        content: scenario.instructions,
        productKey: productKey,
        siteId: cloudId
    })), allActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $d93c2bf197460d18$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d93c2bf197460d18$var$styles.heading
    }, formatMessage((0, $iG8JX.default).skillsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1wBYh.SkillList), {
        actions: allActions
    })), scenario.knowledgeSources && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $d93c2bf197460d18$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d93c2bf197460d18$var$styles.heading
    }, formatMessage((0, $iG8JX.default).knowledgeSourcesTitle)), allOrganisationalKnowledgeEnabled && formatMessage((0, $iG8JX.default).allOrganisationalKnowledge), customKnowledgeSourcesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fP2S.KnowledgePillList), {
        cloudId: cloudId,
        knowledge: [
            {
                enabled: scenario?.knowledgeSources?.enabled,
                sources: scenario?.knowledgeSources?.sources?.map((source_0)=>({
                        enabled: source_0?.enabled,
                        source: source_0?.source,
                        filters: {
                            spaceFilter: source_0?.filters?.confluenceFilter?.spaceFilter?.concat(),
                            parentFilter: source_0?.filters?.confluenceFilter?.parentFilter?.concat(),
                            projectFilter: source_0?.filters?.jiraFilter?.projectFilter?.concat(),
                            jsmProjectFilter: source_0?.filters?.jsmFilter?.jsmProjectFilter?.concat()
                        }
                    }))
            }
        ]
    }), noOrganisationalKnowledge && formatMessage((0, $iG8JX.default).noOrganisationalKnowledge)));
};
function $d93c2bf197460d18$var$_temp(tool) {
    return {
        actionKey: tool.toolId,
        iconUrl: tool.iconUrl,
        name: tool.displayName,
        tags: tool.tags,
        isActive: true
    };
}
function $d93c2bf197460d18$var$_temp2(tool_0) {
    return tool_0.definitionSource === "MCP_TOOL";
}
function $d93c2bf197460d18$var$_temp3(tool_1) {
    return {
        actionKey: tool_1.toolId,
        iconUrl: tool_1.iconUrl,
        name: tool_1.displayName,
        tags: tool_1.tags,
        isActive: true
    };
}
function $d93c2bf197460d18$var$_temp4(tool_2) {
    return tool_2.definitionSource === "MCP_SERVER";
}
function $d93c2bf197460d18$var$_temp5(tool_3) {
    return {
        actionKey: tool_3.toolId,
        iconUrl: tool_3.iconUrl,
        name: tool_3.displayName,
        tags: tool_3.tags,
        isActive: true
    };
}
function $d93c2bf197460d18$var$_temp6(action) {
    return {
        ...action,
        isActive: true
    };
}
function $d93c2bf197460d18$var$_temp7(source) {
    return source.enabled;
}
function $d93c2bf197460d18$var$_temp8(source_0) {
    return {
        enabled: source_0?.enabled,
        source: source_0?.source,
        filters: {
            spaceFilter: source_0?.filters?.confluenceFilter?.spaceFilter?.concat(),
            parentFilter: source_0?.filters?.confluenceFilter?.parentFilter?.concat(),
            projectFilter: source_0?.filters?.jiraFilter?.projectFilter?.concat(),
            jsmProjectFilter: source_0?.filters?.jsmFilter?.jsmProjectFilter?.concat()
        }
    };
}
module.exports["ScenarioContentRenderer"] = $d93c2bf197460d18$export$a367280fed6967b4;

});

parcelRegister("1wBYh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $76qWr = parcelRequire("76qWr");

const $992f75487e3a1588$export$c6ea693c6bd346ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { actions: actions } = t0;
    let t1;
    if ($[0] !== actions) {
        t1 = actions.map($992f75487e3a1588$var$_temp);
        $[0] = actions;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, actions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            key: `skill-pill-${action.actionKey}`,
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76qWr.AgentActionPill), {
            action: {
                id: action.actionKey,
                displayName: action.name,
                icon: action.icon,
                tags: action.tags,
                iconUrl: action.iconUrl
            },
            isActive: action.isActive
        }))));
};
function $992f75487e3a1588$var$_temp(action) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        key: `skill-pill-${action.actionKey}`,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76qWr.AgentActionPill), {
        action: {
            id: action.actionKey,
            displayName: action.name,
            icon: action.icon,
            tags: action.tags,
            iconUrl: action.iconUrl
        },
        isActive: action.isActive
    }));
}
module.exports["SkillList"] = $992f75487e3a1588$export$c6ea693c6bd346ab;

});

parcelRegister("8UJhp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e900323dedd88e49$var$messages = (0, $kSwu1.defineMessages)({
    goodResponseLabel: {
        id: "chatHistory.storeAssistant.goodResponseLabel",
        defaultMessage: "Good response"
    },
    badResponseLabel: {
        id: "chatHistory.storeAssistant.badResponseLabel",
        defaultMessage: "Bad response"
    }
});
var $e900323dedd88e49$export$2e2bcd8739ae039 = $e900323dedd88e49$var$messages;
module.exports["default"] = $e900323dedd88e49$export$2e2bcd8739ae039;

});

parcelRegister("hcxmK", function(module, exports) {
// smart-link-list items become inlineCards, which only resolve http(s) URLs, so
// item/card URLs must be restricted to http(s) — anything else (javascript:,
// data:, mailto:, relative, #frag) is neither card-resolvable nor (for script
// schemes) safe.
//
// NOTE: this duplicates `isHttpUrl` in conversation-assistant's
// clipboard-serialiser (which cannot depend on this package); the two MUST stay
// in sync — the 'isHttpUrl cross-package contract' tests in
// clipboard-serialiser-test.ts check both against the same list of test URLs to
// catch drift.
const $54fb5be83b00bedc$var$HTTP_URL_RE = /^https?:/i;
const $54fb5be83b00bedc$export$206c3129b8bb1b4f = (url)=>$54fb5be83b00bedc$var$HTTP_URL_RE.test(url.trim());
module.exports["isHttpUrl"] = $54fb5be83b00bedc$export$206c3129b8bb1b4f;

});

parcelRegister("1dQeb", function(module, exports) {
/**
 * @generated SignedSource<<02e61598a9c3b7388c4b6a029d39953a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62ce2af3825ee807$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraIssueTypeIcon_Platform",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "small"
                }
            ]
        }
    ],
    "type": "JiraIssueType"
};
$62ce2af3825ee807$var$node.hash = "6f9309d38428a5c37de5c49fcc3fac28";
var $62ce2af3825ee807$export$2e2bcd8739ae039 = $62ce2af3825ee807$var$node;
module.exports["default"] = $62ce2af3825ee807$export$2e2bcd8739ae039;

});

parcelRegister("2ZX6j", function(module, exports) {
/**
 * @generated SignedSource<<c118b4a0c28bd2737fdb58805cc0e6b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a753b9839b82d0e7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "rowActions_AtlassianConversationAssistantPreviewCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        }
    ],
    "type": "JiraProject"
};
$a753b9839b82d0e7$var$node.hash = "e7eb31a17a077a75b82350b332a1bf6d";
var $a753b9839b82d0e7$export$2e2bcd8739ae039 = $a753b9839b82d0e7$var$node;
module.exports["default"] = $a753b9839b82d0e7$export$2e2bcd8739ae039;

});

parcelRegister("gYLQo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $1aX82 = parcelRequire("1aX82");

function $1d5db0e7d3481da7$export$342cd542f78d419d({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, preloadOnFocus: preloadOnFocus, loadingText: loadingText, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aX82.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        preloadOnFocus: preloadOnFocus,
        loadingText: loadingText
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ref: ref,
            ...buttonProps
        }));
}
module.exports["ModalIconButtonTrigger"] = $1d5db0e7d3481da7$export$342cd542f78d419d;

});

parcelRegister("hTt4H", function(module, exports) {
/**
 * @generated SignedSource<<9c82bd32fed659b538271dccdfd849fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db2d7013cd7147e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "field_AtlassianConversationAssistantPreviewCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isRequired"
                        }
                    ]
                }
            ],
            "type": "JiraIssueFieldConfiguration",
            "abstractKey": "__isJiraIssueFieldConfiguration"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraSingleLineTextField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraRichTextField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraSingleSelectUserPickerField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraMultipleSelectUserPickerField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraPeopleField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraPriorityField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraSingleSelectField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraDatePickerField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraDateTimePickerField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraNumberField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraTimeTrackingField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraRadioSelectField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraMultipleSelectField"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraLabelsField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraCascadingSelectField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraCheckboxesField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraUrlField_Platform"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraComponentsField"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraSprintField_Platform"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$db2d7013cd7147e1$var$node.hash = "c61606bf06f6391e91c28975c50b3d90";
var $db2d7013cd7147e1$export$2e2bcd8739ae039 = $db2d7013cd7147e1$var$node;
module.exports["default"] = $db2d7013cd7147e1$export$2e2bcd8739ae039;

});

parcelRegister("ahNbn", function(module, exports) {
/**
 * @generated SignedSource<<4b8878c4c4ae6d636d65d87ffd372249>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3b8c3730c4e0cbf1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "withFieldLabel_AtlassianConversationAssistantPreviewCard",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "fieldLabel_AtlassianConversationAssistantPreviewCard"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$3b8c3730c4e0cbf1$var$node.hash = "7a13656f5931b6c1efb58f603c133064";
var $3b8c3730c4e0cbf1$export$2e2bcd8739ae039 = $3b8c3730c4e0cbf1$var$node;
module.exports["default"] = $3b8c3730c4e0cbf1$export$2e2bcd8739ae039;

});

parcelRegister("9Gchh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $izKsM = parcelRequire("izKsM");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $hpa99 = parcelRequire("hpa99");


var $4aRua = parcelRequire("4aRua");

const $b35047ee9f2a1e18$export$1acdcf5a973a8414 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { fieldConfig: fieldConfig, fallbackFieldName: fallbackFieldName } = t0;
    const fieldConfigData = (0, $6SsN4.useFragment)((0, $izKsM.default), fieldConfig ?? null);
    const t1 = fieldConfigData?.name ?? fallbackFieldName;
    let t2;
    if ($[0] !== t1) {
        t2 = $b35047ee9f2a1e18$var$toSentenceCase(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fieldConfigData?.fieldConfig?.isRequired) {
        t3 = fieldConfigData?.fieldConfig?.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null);
        $[2] = fieldConfigData?.fieldConfig?.isRequired;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "regular",
            color: "color.text.subtlest"
        }, t2, ":", t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ fieldConfig: fieldConfig, fallbackFieldName: fallbackFieldName })=>{
    const fieldConfigData = (0, $6SsN4.useFragment)((0, $izKsM.default), fieldConfig ?? null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "regular",
        color: "color.text.subtlest"
    }, $b35047ee9f2a1e18$var$toSentenceCase(fieldConfigData?.name ?? fallbackFieldName), ":", fieldConfigData?.fieldConfig?.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
};
function $b35047ee9f2a1e18$var$toSentenceCase(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports["FieldLabel"] = $b35047ee9f2a1e18$export$1acdcf5a973a8414;

});

parcelRegister("hlSvw", function(module, exports) {
/**
 * @generated SignedSource<<d8c52567044da8192eea9f04db85d9f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e5b2547aa762f8ad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "colorField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                }
            ]
        }
    ],
    "type": "JiraColorField"
};
$e5b2547aa762f8ad$var$node.hash = "d565084b3ddceb0c4961cc96e0747547";
var $e5b2547aa762f8ad$export$2e2bcd8739ae039 = $e5b2547aa762f8ad$var$node;
module.exports["default"] = $e5b2547aa762f8ad$export$2e2bcd8739ae039;

});

parcelRegister("92bnZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $548805fce3cd9c25$export$41ebd7778026fc1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterTooltipContentProvider(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { registerTooltipProvider: registerTooltipProvider, fieldId: fieldId, provider: provider, enabled: t1 } = t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== enabled || $[1] !== fieldId || $[2] !== provider || $[3] !== registerTooltipProvider) {
        t2 = ()=>{
            if (!enabled || !registerTooltipProvider || !fieldId) return;
            registerTooltipProvider(fieldId, provider ?? null);
            return ()=>{
                registerTooltipProvider(fieldId, null);
            };
        };
        t3 = [
            registerTooltipProvider,
            fieldId,
            provider,
            enabled
        ];
        $[0] = enabled;
        $[1] = fieldId;
        $[2] = provider;
        $[3] = registerTooltipProvider;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useRegisterTooltipContentProvider({ registerTooltipProvider: registerTooltipProvider, fieldId: fieldId, provider: provider, enabled: enabled = true }) {
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !registerTooltipProvider || !fieldId) return;
        // Register current provider (can be null which effectively clears it)
        registerTooltipProvider(fieldId, provider ?? null);
        // Cleanup always clears the provider to avoid stale content retention.
        return ()=>{
            registerTooltipProvider(fieldId, null);
        };
    }, [
        registerTooltipProvider,
        fieldId,
        provider,
        enabled
    ]);
};
module.exports["useRegisterTooltipContentProvider"] = $548805fce3cd9c25$export$41ebd7778026fc1e;

});

parcelRegister("cPvf5", function(module, exports) {
/**
 * @generated SignedSource<<a2fdab68eacb488b1e6738bdafd66b83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $caf88bee9f1ff500$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "datePickerField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraDatePickerField"
};
$caf88bee9f1ff500$var$node.hash = "0d380d0ab2a0f9cab300ceca61bf6d48";
var $caf88bee9f1ff500$export$2e2bcd8739ae039 = $caf88bee9f1ff500$var$node;
module.exports["default"] = $caf88bee9f1ff500$export$2e2bcd8739ae039;

});

parcelRegister("gYXDX", function(module, exports) {
const $f982aa2168f87803$var$getDefaultFormatDateOptions = ()=>({
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    });
function $f982aa2168f87803$export$de3020c9fe9cee67(value, formatDate) {
    if (!value) return undefined;
    const defaultFormatDateOptions = $f982aa2168f87803$var$getDefaultFormatDateOptions();
    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        if (trimmedValue.length === 0) return undefined;
        // ISO date-only string
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) {
            const isoDate = new Date(trimmedValue);
            if (!Number.isNaN(isoDate.getTime())) return formatDate(isoDate, defaultFormatDateOptions);
            return trimmedValue;
        }
        // ISO timestamp - extract date and format
        const timestampMatch = trimmedValue.match(/^(\d{4}-\d{2}-\d{2})T/);
        if (timestampMatch) {
            const isoDate = new Date(timestampMatch[1]);
            if (!Number.isNaN(isoDate.getTime())) return formatDate(isoDate, defaultFormatDateOptions);
            return timestampMatch[1];
        }
        return trimmedValue;
    }
    if (typeof value === 'number') {
        const date = new Date(value);
        if (!Number.isNaN(date.getTime())) return formatDate(date, defaultFormatDateOptions);
    }
    return String(value);
}
module.exports["formatSuggestedDate"] = $f982aa2168f87803$export$de3020c9fe9cee67;

});

parcelRegister("fZ8tq", function(module, exports) {
/**
 * @generated SignedSource<<caa86ba0194d4a38716a03fa3e34bc69>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20610fd02e0df99c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$20610fd02e0df99c$var$node.hash = "3e67b2e6fb0f14ced5c69254cfab5c08";
var $20610fd02e0df99c$export$2e2bcd8739ae039 = $20610fd02e0df99c$var$node;
module.exports["default"] = $20610fd02e0df99c$export$2e2bcd8739ae039;

});

parcelRegister("6okNK", function(module, exports) {
const $dc71caed912264db$var$getDefaultFormatDateOptions = ()=>({
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
function $dc71caed912264db$export$654d14d3bb6fb466(value, formatDate) {
    if (!value) return undefined;
    const defaultFormatDateOptions = $dc71caed912264db$var$getDefaultFormatDateOptions();
    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        if (trimmedValue.length === 0) return undefined;
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(trimmedValue)) {
            const isoDate = new Date(trimmedValue);
            if (!Number.isNaN(isoDate.getTime())) return formatDate(isoDate, defaultFormatDateOptions);
            return trimmedValue;
        }
        return trimmedValue;
    }
    if (typeof value === 'number') {
        const date = new Date(value);
        if (!Number.isNaN(date.getTime())) return formatDate(date, defaultFormatDateOptions);
    }
    return String(value);
}
module.exports["formatSuggestedDateTime"] = $dc71caed912264db$export$654d14d3bb6fb466;

});

parcelRegister("fWp8m", function(module, exports) {
/**
 * @generated SignedSource<<5963940c4abe3ea0ef3d90eddcb73b85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5db687ae5ec6dd52$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "flagField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraFlagField"
};
$5db687ae5ec6dd52$var$node.hash = "4eb8b9578220c67e9a4bd89c32e06374";
var $5db687ae5ec6dd52$export$2e2bcd8739ae039 = $5db687ae5ec6dd52$var$node;
module.exports["default"] = $5db687ae5ec6dd52$export$2e2bcd8739ae039;

});

parcelRegister("7bqat", function(module, exports) {
/**
 * Normalises assorted representations of the Jira flag field into a boolean.
 * Accepted truthy representations:
 *  - boolean true
 *  - non-empty array
 *  - string 'true'
 *  - stringified array (single or double quotes) with at least one element e.g. "['Impediment']" / '["Impediment"]'
 * Everything else (including malformed / non-parsable bracketed strings) is treated as unflagged.
 */ function $35151fd3f6762976$export$3cb039149a6e8bec(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;
    if (Array.isArray(value)) return value.length > 0 && value.includes('Impediment');
    if (typeof value === 'string') {
        const stringValue = value.trim();
        if (stringValue === 'true') return true;
        if (stringValue === 'false' || stringValue === '' || stringValue === '[]') return false;
        // Heuristic: looks like an array string
        if (stringValue.startsWith('[') && stringValue.endsWith(']')) {
            let candidate = stringValue;
            // If it only has single quotes, convert to double quotes for JSON.parse
            if (!stringValue.includes('"') && stringValue.includes("'")) candidate = stringValue.replace(/'/g, '"');
            try {
                const parsed = JSON.parse(candidate);
                if (Array.isArray(parsed)) return parsed.length > 0 && parsed.includes('Impediment');
            } catch  {
                // Parsing failed – treat malformed bracketed content as unflagged now.
                return false;
            }
            // Non‑array parsed result -> not flagged
            return false;
        }
    }
    return false;
}
var $35151fd3f6762976$export$2e2bcd8739ae039 = $35151fd3f6762976$export$3cb039149a6e8bec;
module.exports["isFlagged"] = $35151fd3f6762976$export$3cb039149a6e8bec;

});

parcelRegister("6Am9a", function(module, exports) {
/**
 * @generated SignedSource<<b090570abc78639c9284d566d1ccd0a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41a4b870a951baad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "genericField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$41a4b870a951baad$var$node.hash = "f482a17d9c275aafd154d3d2b7cc26e8";
var $41a4b870a951baad$export$2e2bcd8739ae039 = $41a4b870a951baad$var$node;
module.exports["default"] = $41a4b870a951baad$export$2e2bcd8739ae039;

});

parcelRegister("gvpzp", function(module, exports) {
function $98e6489f1e1358b5$var$isIssueLinksFieldValue(value) {
    return typeof value === 'object' && value !== null && 'type' in value && typeof value.type === 'object' && value.type !== null && 'name' in value.type && typeof value.type.name === 'string' && 'outwardIssue' in value && typeof value.outwardIssue === 'object' && value.outwardIssue !== null && 'key' in value.outwardIssue && typeof value.outwardIssue.key === 'string';
}
function $98e6489f1e1358b5$export$9dd8d1d07039e5f5(value) {
    return $98e6489f1e1358b5$var$isIssueLinksFieldValue(value) ? value : undefined;
}
module.exports["toIssueLinksFieldValue"] = $98e6489f1e1358b5$export$9dd8d1d07039e5f5;

});

parcelRegister("5PsWn", function(module, exports) {
/**
 * @generated SignedSource<<2e9fb63a4cd563f32ccf8670a2937c19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $973c5e412dc0e683$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labelsField_updateWorkItemAllFieldTypesActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            v0 /*: any*/ ,
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$973c5e412dc0e683$var$node.hash = "b59a97dae1e9873b26141ba1b406aca1";
var $973c5e412dc0e683$export$2e2bcd8739ae039 = $973c5e412dc0e683$var$node;
module.exports["default"] = $973c5e412dc0e683$export$2e2bcd8739ae039;

});

parcelRegister("6Fflc", function(module, exports) {
function $27be867bc3da6b25$var$isNonEmptyStringArray(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
function $27be867bc3da6b25$export$3a71dfd0eab58a09(value) {
    if (Array.isArray(value)) {
        const filtered = value.filter($27be867bc3da6b25$var$isNonEmptyStringArray);
        return filtered.length ? filtered : null;
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return null;
        // JSON-looking input: if it starts with '[' we only accept it when it also ends with ']'.
        if (trimmed.startsWith('[')) {
            if (!trimmed.endsWith(']')) return null;
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                    const filtered = parsed.filter($27be867bc3da6b25$var$isNonEmptyStringArray);
                    return filtered.length ? filtered : null;
                }
                return null;
            } catch  {
                return null;
            }
        }
        // If it is a single comma-separated string, split into labels (fallback behavior)
        if (trimmed.includes(',')) {
            const parts = trimmed.split(',').map((s)=>s.trim()).filter(Boolean);
            return parts.length ? parts : null;
        }
        // Treat any single non-empty string as one label
        return [
            trimmed
        ];
    }
    return null;
}
module.exports["parseLabels"] = $27be867bc3da6b25$export$3a71dfd0eab58a09;

});

parcelRegister("kPpgw", function(module, exports) {
/**
 * @generated SignedSource<<e9e7971505a01cdea8ebe1a76e02f4b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f90aec1a712bd069$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "numberField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$f90aec1a712bd069$var$node.hash = "edd3d50f232d5628dc08cba6adc0c6d4";
var $f90aec1a712bd069$export$2e2bcd8739ae039 = $f90aec1a712bd069$var$node;
module.exports["default"] = $f90aec1a712bd069$export$2e2bcd8739ae039;

});

parcelRegister("ervmy", function(module, exports) {
/**
 * @generated SignedSource<<3eea4a210418ad4f63180bb4f8987bb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae78a77914033ed0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parentIssueField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$ae78a77914033ed0$var$node.hash = "df03cce0d71b2661f1eae77f41c9c694";
var $ae78a77914033ed0$export$2e2bcd8739ae039 = $ae78a77914033ed0$var$node;
module.exports["default"] = $ae78a77914033ed0$export$2e2bcd8739ae039;

});

parcelRegister("lYwdb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $1d5f4d0dfe0b37cd$export$e2b1918ff1ac008b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "parent-issue-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "parent-issue-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
module.exports["ParentIssueFieldSkeleton"] = $1d5f4d0dfe0b37cd$export$e2b1918ff1ac008b;

});

parcelRegister("lxuSf", function(module, exports) {

var $9gQhQ = parcelRequire("9gQhQ");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");


var $3iWYJ = parcelRequire("3iWYJ");

var $a0unS = parcelRequire("a0unS");

var $1eov5 = parcelRequire("1eov5");

var $9LE5K = parcelRequire("9LE5K");


var $4yZQ6 = parcelRequire("4yZQ6");

function $615e95890c093a6b$export$928f2fb4dc38339(cloudId, suggestedIssueId, shouldHydrate, onInvalidAction) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [issue, setIssue] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    // Cleanup on unmount
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    // Reset state when no issue ID or rendering is disabled
    const resetState = (0, $cozmU.useCallback)(()=>{
        if (inFlightFor.current) {
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        }
        setIssue(null);
        setIsLoading(false);
        setError(null);
    }, []);
    // Check if the issue is already hydrated
    const isAlreadyHydrated = (0, $cozmU.useCallback)((issueId)=>issue && (issue.issueId === issueId || issue.key === issueId) && issue.summary, [
        issue
    ]);
    // Cancel any previous in-flight request
    const cancelPreviousRequest = (0, $cozmU.useCallback)(()=>{
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
    }, []);
    // Cancel the subscription
    const cancelSubscription = (0, $cozmU.useCallback)((subscription, issueId)=>{
        if (activeSubscription.current === subscription) {
            subscription.unsubscribe();
            activeSubscription.current = null;
            if (inFlightFor.current === issueId) inFlightFor.current = null;
        }
    }, []);
    const jql = (0, $cozmU.useMemo)(()=>{
        if (!suggestedIssueId) return '';
        const jqlQuery = (0, $a0unS.default).query();
        if ((0, $4yZQ6.isIssueKey)(suggestedIssueId)) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field((0, $4yZQ6.ISSUE_KEY_FIELD_KEY)), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_EQUALS)), (0, $a0unS.default).valueOperand(suggestedIssueId)), (0, $3iWYJ.COMPOUND_OPERATOR_AND));
        else if ((0, $4yZQ6.isIssueId)(suggestedIssueId)) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field((0, $4yZQ6.ISSUE_ID_FIELD_KEY)), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_EQUALS)), (0, $a0unS.default).valueOperand(suggestedIssueId)), (0, $3iWYJ.COMPOUND_OPERATOR_AND));
        return (0, $9LE5K.print)((0, $a0unS.default).jast(jqlQuery));
    }, [
        suggestedIssueId
    ]);
    // Fetch and hydrate issue data
    (0, $cozmU.useEffect)(()=>{
        if (!suggestedIssueId || !shouldHydrate) {
            resetState();
            return;
        }
        if (isAlreadyHydrated(suggestedIssueId)) return;
        cancelPreviousRequest();
        inFlightFor.current = suggestedIssueId;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $9gQhQ.default), {
            cloudId: cloudId,
            jql: jql
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current || inFlightFor.current !== suggestedIssueId) return;
                const issue = response?.jira?.issueSearch?.edges?.[0]?.node;
                if (issue) setIssue({
                    issueId: issue.issueId,
                    key: issue.key,
                    summary: issue.summary ?? null
                });
                else {
                    setIssue(null);
                    onInvalidAction?.();
                }
                setIsLoading(false);
            },
            error: (err)=>{
                if (disposed.current || inFlightFor.current !== suggestedIssueId) return;
                setError(err);
                setIsLoading(false);
                onInvalidAction?.();
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === suggestedIssueId) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>cancelSubscription(subscription, suggestedIssueId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        suggestedIssueId,
        environment,
        shouldHydrate,
        cloudId,
        resetState,
        isAlreadyHydrated,
        cancelPreviousRequest,
        cancelSubscription,
        jql
    ]);
    if (!suggestedIssueId || !shouldHydrate) return null;
    return {
        issue: issue,
        isLoading: isLoading,
        error: error
    };
}
module.exports["useHydratedIssue"] = $615e95890c093a6b$export$928f2fb4dc38339;

});

parcelRegister("9t9D5", function(module, exports) {
/**
 * @generated SignedSource<<0ea15696312b442f7b547eb23e7f700c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $53c038e93d54b756$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priorityField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$53c038e93d54b756$var$node.hash = "6938ec4d6a6506763265af6b3316604c";
var $53c038e93d54b756$export$2e2bcd8739ae039 = $53c038e93d54b756$var$node;
module.exports["default"] = $53c038e93d54b756$export$2e2bcd8739ae039;

});

parcelRegister("9Ld6b", function(module, exports) {
/**
 * @generated SignedSource<<4c145094a523615abcb4e080095214cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $365b88d0be9b697c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "richTextField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAdfToConvertedPlainText",
                            "kind": "LinkedField",
                            "name": "convertedPlainText",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "plainText"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isTruncated"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$365b88d0be9b697c$var$node.hash = "bcb0952cd0e535e516f7ff3e6858fbbb";
var $365b88d0be9b697c$export$2e2bcd8739ae039 = $365b88d0be9b697c$var$node;
module.exports["default"] = $365b88d0be9b697c$export$2e2bcd8739ae039;

});

parcelRegister("dzzUs", function(module, exports) {
/**
 * @generated SignedSource<<2ee91f20586b934a01393d9013260fea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84ced703a6a1958d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineTextField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$84ced703a6a1958d$var$node.hash = "a1bc87480e2246f8f89d091013b2daa1";
var $84ced703a6a1958d$export$2e2bcd8739ae039 = $84ced703a6a1958d$var$node;
module.exports["default"] = $84ced703a6a1958d$export$2e2bcd8739ae039;

});

parcelRegister("ldc10", function(module, exports) {
/**
 * @generated SignedSource<<c7413d8d023e04f6cc90b5abcf284330>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ff153defb512a25$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$0ff153defb512a25$var$node.hash = "cbff593391c984a93de503c9ab16098d";
var $0ff153defb512a25$export$2e2bcd8739ae039 = $0ff153defb512a25$var$node;
module.exports["default"] = $0ff153defb512a25$export$2e2bcd8739ae039;

});

parcelRegister("8JWzs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $6a6ecff40a445592$export$a409882f4d472281 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "single-select-user-picker-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "single-select-user-picker-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
};
module.exports["SingleSelectUserPickerFieldSkeleton"] = $6a6ecff40a445592$export$a409882f4d472281;

});

parcelRegister("17its", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $1wTHs = parcelRequire("1wTHs");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");

const $d246d4a0534967e2$export$a6881b2ed83fb629 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHydratedUser(suggestedUserAccountId, shouldHydrate, onInvalidAction) {
    const $ = (0, $bDgLe.c)(15);
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [user, setUser] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            disposed.current = false;
            return ()=>{
                disposed.current = true;
                activeSubscription.current?.unsubscribe();
                activeSubscription.current = null;
                inFlightFor.current = null;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== environment || $[3] !== onInvalidAction || $[4] !== shouldHydrate || $[5] !== suggestedUserAccountId || $[6] !== user) {
        t2 = ()=>{
            if (!suggestedUserAccountId || !shouldHydrate) {
                if (inFlightFor.current) {
                    activeSubscription.current?.unsubscribe();
                    activeSubscription.current = null;
                    inFlightFor.current = null;
                }
                setUser(null);
                setIsLoading(false);
                setError(null);
                return;
            }
            if (user && user.accountId === suggestedUserAccountId && user.name) return;
            if (inFlightFor.current === suggestedUserAccountId) return;
            if (activeSubscription.current) {
                activeSubscription.current.unsubscribe();
                activeSubscription.current = null;
            }
            inFlightFor.current = suggestedUserAccountId;
            setIsLoading(true);
            setError(null);
            const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $1wTHs.default), {
                accountId: suggestedUserAccountId
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (response)=>{
                    if (disposed.current) return;
                    if (inFlightFor.current !== suggestedUserAccountId) return;
                    if (response?.user?.accountId) setUser({
                        accountId: response.user.accountId,
                        name: response.user.name
                    });
                    else {
                        setUser(null);
                        onInvalidAction?.();
                    }
                    setIsLoading(false);
                },
                error: (error_0)=>{
                    if (disposed.current) return;
                    if (inFlightFor.current === suggestedUserAccountId) {
                        setError(error_0);
                        setIsLoading(false);
                        onInvalidAction?.();
                    }
                },
                complete: ()=>{
                    if (!disposed.current && inFlightFor.current === suggestedUserAccountId) setIsLoading(false);
                }
            });
            activeSubscription.current = subscription;
            return ()=>{
                if (activeSubscription.current === subscription) {
                    subscription.unsubscribe();
                    activeSubscription.current = null;
                    if (inFlightFor.current === suggestedUserAccountId) inFlightFor.current = null;
                }
            };
        };
        $[2] = environment;
        $[3] = onInvalidAction;
        $[4] = shouldHydrate;
        $[5] = suggestedUserAccountId;
        $[6] = user;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== environment || $[9] !== suggestedUserAccountId) {
        t3 = [
            suggestedUserAccountId,
            environment
        ];
        $[8] = environment;
        $[9] = suggestedUserAccountId;
        $[10] = t3;
    } else t3 = $[10];
    (0, $cozmU.useEffect)(t2, t3);
    if (!suggestedUserAccountId) return null;
    let t4;
    if ($[11] !== error || $[12] !== isLoading || $[13] !== user) {
        t4 = {
            user: user,
            isLoading: isLoading,
            error: error
        };
        $[11] = error;
        $[12] = isLoading;
        $[13] = user;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : function useHydratedUser(suggestedUserAccountId, shouldHydrate, onInvalidAction) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [user, setUser] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!suggestedUserAccountId || !shouldHydrate) {
            // reset state for missing id and do not issue a query
            if (inFlightFor.current) {
                activeSubscription.current?.unsubscribe();
                activeSubscription.current = null;
                inFlightFor.current = null;
            }
            setUser(null);
            setIsLoading(false);
            setError(null);
            return;
        }
        if (user && user.accountId === suggestedUserAccountId && user.name) return; // already hydrated fully
        if (inFlightFor.current === suggestedUserAccountId) return; // request already in flight for this id
        // cancel any previous in-flight subscription for a different id
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
        inFlightFor.current = suggestedUserAccountId;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $1wTHs.default), {
            accountId: suggestedUserAccountId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current) return;
                if (inFlightFor.current !== suggestedUserAccountId) return;
                 // stale
                if (response?.user?.accountId) setUser({
                    accountId: response.user.accountId,
                    name: response.user.name
                });
                else {
                    setUser(null);
                    onInvalidAction?.();
                }
                setIsLoading(false);
            },
            error: (error_0)=>{
                if (disposed.current) return;
                if (inFlightFor.current === suggestedUserAccountId) {
                    setError(error_0);
                    setIsLoading(false);
                    onInvalidAction?.();
                }
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === suggestedUserAccountId) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>{
            if (activeSubscription.current === subscription) {
                subscription.unsubscribe();
                activeSubscription.current = null;
                if (inFlightFor.current === suggestedUserAccountId) inFlightFor.current = null;
            }
        };
    // We intentionally exclude user/isLoading from deps to avoid refetch loops
    }, [
        suggestedUserAccountId,
        environment
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!suggestedUserAccountId) return null; // maintain external contract returning null when no account id supplied
    return {
        user: user,
        isLoading: isLoading,
        error: error
    };
};
module.exports["useHydratedUser"] = $d246d4a0534967e2$export$a6881b2ed83fb629;

});

parcelRegister("hLPNh", function(module, exports) {
/**
 * @generated SignedSource<<f698263b5ee5a6e03bbf997226089316>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $189ae26ff93cb255$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sprintAris"
            }
        ],
        "kind": "Fragment",
        "name": "sprintField_updateWorkItemAllFieldTypesActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            v0 /*: any*/ ,
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Literal",
                                "name": "operation",
                                "value": "ALLOW"
                            },
                            {
                                "kind": "Variable",
                                "name": "optionIds",
                                "variableName": "sprintAris"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "filterById"
                    }
                ],
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "sprints",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSprintField"
    };
}();
$189ae26ff93cb255$var$node.hash = "9575e235ecac91131bd2985a846a65c9";
var $189ae26ff93cb255$export$2e2bcd8739ae039 = $189ae26ff93cb255$var$node;
module.exports["default"] = $189ae26ff93cb255$export$2e2bcd8739ae039;

});

parcelRegister("d2Au0", function(module, exports) {
/**
 * @generated SignedSource<<a962155d9fc3e2b188b94fd9b8d61849>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4fc6685199a981c1$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "statusField_updateWorkItemAllFieldTypesActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraTransitionConnection",
                "kind": "LinkedField",
                "name": "transitions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTransitionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraTransition",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "transitionId"
                                    },
                                    {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "to",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraStatusField"
    };
}();
$4fc6685199a981c1$var$node.hash = "0e0c841b03c9df5b0f83cb878e1419bc";
var $4fc6685199a981c1$export$2e2bcd8739ae039 = $4fc6685199a981c1$var$node;
module.exports["default"] = $4fc6685199a981c1$export$2e2bcd8739ae039;

});

parcelRegister("ayiQL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");

const $93cbe7b6bf7742c4$var$useStaleTransitionGuardEnabled = (isStaleTransition, onInvalidAction)=>{
    (0, $cozmU.useEffect)(()=>{
        if (isStaleTransition) onInvalidAction?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isStaleTransition
    ]);
};
const $93cbe7b6bf7742c4$export$3fba9f35a2359f8c = (0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)('jira-status-action-transition-validation'), $93cbe7b6bf7742c4$var$useStaleTransitionGuardEnabled, ()=>{});
module.exports["useStaleTransitionGuard"] = $93cbe7b6bf7742c4$export$3fba9f35a2359f8c;

});

parcelRegister("k0LRW", function(module, exports) {
/**
 * @generated SignedSource<<1970d9ccf588eee43c715c4266d9b484>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a41f1c261aef961f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "teamViewField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$a41f1c261aef961f$var$node.hash = "4a8fd3de7d89710b50ff703426a3ba47";
var $a41f1c261aef961f$export$2e2bcd8739ae039 = $a41f1c261aef961f$var$node;
module.exports["default"] = $a41f1c261aef961f$export$2e2bcd8739ae039;

});

parcelRegister("3UbkS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $cbaabac1eb95b990$export$6a24ef8b4e219807 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "team-view-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "team-view-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
};
module.exports["TeamViewFieldSkeleton"] = $cbaabac1eb95b990$export$6a24ef8b4e219807;

});

parcelRegister("h4UtQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fcu3m = parcelRequire("fcu3m");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");

const $c02ff4972450ba5c$export$cde4996ca7f1bdb6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHydratedTeam(id, cloudId, shouldHydrate, onInvalidAction) {
    const $ = (0, $bDgLe.c)(17);
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [team, setTeam] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            disposed.current = false;
            return ()=>{
                disposed.current = true;
                activeSubscription.current?.unsubscribe();
                activeSubscription.current = null;
                inFlightFor.current = null;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== cloudId || $[3] !== environment || $[4] !== id || $[5] !== onInvalidAction || $[6] !== shouldHydrate || $[7] !== team) {
        t2 = ()=>{
            if (!id || !cloudId || !shouldHydrate) {
                if (inFlightFor.current) {
                    activeSubscription.current?.unsubscribe();
                    activeSubscription.current = null;
                    inFlightFor.current = null;
                }
                setTeam(null);
                setIsLoading(false);
                setError(null);
                return;
            }
            if (team && team.teamId === id && team.displayName) return;
            if (inFlightFor.current === id) return;
            if (activeSubscription.current) {
                activeSubscription.current.unsubscribe();
                activeSubscription.current = null;
            }
            inFlightFor.current = id;
            setIsLoading(true);
            setError(null);
            const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $fcu3m.default), {
                id: id,
                siteId: cloudId
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (response)=>{
                    if (disposed.current) return;
                    if (inFlightFor.current !== id) return;
                    if (response?.team?.teamV2) setTeam({
                        teamId: response.team.teamV2.id,
                        displayName: response.team.teamV2.displayName ?? ""
                    });
                    else {
                        setTeam(null);
                        onInvalidAction?.();
                    }
                    setIsLoading(false);
                },
                error: (error_0)=>{
                    if (disposed.current) return;
                    if (inFlightFor.current === id) {
                        setError(error_0);
                        setIsLoading(false);
                        onInvalidAction?.();
                    }
                },
                complete: ()=>{
                    if (!disposed.current && inFlightFor.current === id) setIsLoading(false);
                }
            });
            activeSubscription.current = subscription;
            return ()=>{
                if (activeSubscription.current === subscription) {
                    subscription.unsubscribe();
                    activeSubscription.current = null;
                    if (inFlightFor.current === id) inFlightFor.current = null;
                }
            };
        };
        $[2] = cloudId;
        $[3] = environment;
        $[4] = id;
        $[5] = onInvalidAction;
        $[6] = shouldHydrate;
        $[7] = team;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== cloudId || $[10] !== environment || $[11] !== id) {
        t3 = [
            id,
            cloudId,
            environment
        ];
        $[9] = cloudId;
        $[10] = environment;
        $[11] = id;
        $[12] = t3;
    } else t3 = $[12];
    (0, $cozmU.useEffect)(t2, t3);
    if (!id) return null;
    let t4;
    if ($[13] !== error || $[14] !== isLoading || $[15] !== team) {
        t4 = {
            team: team,
            isLoading: isLoading,
            error: error
        };
        $[13] = error;
        $[14] = isLoading;
        $[15] = team;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : function useHydratedTeam(id, cloudId, shouldHydrate, onInvalidAction) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [team, setTeam] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!id || !cloudId || !shouldHydrate) {
            // reset state for missing id and do not issue a query
            if (inFlightFor.current) {
                activeSubscription.current?.unsubscribe();
                activeSubscription.current = null;
                inFlightFor.current = null;
            }
            setTeam(null);
            setIsLoading(false);
            setError(null);
            return;
        }
        if (team && team.teamId === id && team.displayName) return; // already hydrated fully
        if (inFlightFor.current === id) return; // request already in flight for this id
        // cancel any previous in-flight subscription for a different id
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
        inFlightFor.current = id;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $fcu3m.default), {
            id: id,
            siteId: cloudId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current) return;
                if (inFlightFor.current !== id) return;
                 // stale
                if (response?.team?.teamV2) setTeam({
                    teamId: response.team.teamV2.id,
                    displayName: response.team.teamV2.displayName ?? ''
                });
                else {
                    setTeam(null);
                    onInvalidAction?.();
                }
                setIsLoading(false);
            },
            error: (error_0)=>{
                if (disposed.current) return;
                if (inFlightFor.current === id) {
                    setError(error_0);
                    setIsLoading(false);
                    onInvalidAction?.();
                }
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === id) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>{
            if (activeSubscription.current === subscription) {
                subscription.unsubscribe();
                activeSubscription.current = null;
                if (inFlightFor.current === id) inFlightFor.current = null;
            }
        };
    // We intentionally exclude user/isLoading from deps to avoid refetch loops
    }, [
        id,
        cloudId,
        environment
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!id) return null; // maintain external contract returning null when no team id supplied
    return {
        team: team,
        isLoading: isLoading,
        error: error
    };
};
module.exports["useHydratedTeam"] = $c02ff4972450ba5c$export$cde4996ca7f1bdb6;

});

parcelRegister("feXV7", function(module, exports) {
/**
 * @generated SignedSource<<fb3510232bd6b23213be0740787bd56c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $76bd6afc717e1e5e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "timeSpentField_updateWorkItemAllFieldTypesActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isJiraConfiguredTimeTrackingEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        },
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "timeSpent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$76bd6afc717e1e5e$var$node.hash = "5b79fa22666faae5c531637fa5da2495";
var $76bd6afc717e1e5e$export$2e2bcd8739ae039 = $76bd6afc717e1e5e$var$node;
module.exports["default"] = $76bd6afc717e1e5e$export$2e2bcd8739ae039;

});

parcelRegister("iYaJ6", function(module, exports) {
function $c50a9ddd8b3cb6fa$var$normalizeDefaultUnit(unit) {
    const u = (unit || '').toString().trim().toUpperCase();
    switch(u){
        case 'M':
        case 'MINUTE':
            return 'm';
        case 'H':
        case 'HOUR':
            return 'h';
        case 'D':
        case 'DAY':
            return 'd';
        case 'W':
        case 'WEEK':
            return 'w';
        default:
            return 'h';
    }
}
function $c50a9ddd8b3cb6fa$export$12fa006f8c81adb2(seconds) {
    if (!seconds || seconds <= 0) return null;
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor(seconds % 3600 / 60);
    const parts = [];
    if (hrs > 0) parts.push(`${hrs}h`);
    if (mins > 0) parts.push(`${mins}m`);
    return parts.length ? parts.join(' ') : '0m';
}
function $c50a9ddd8b3cb6fa$export$224de29a6bf17186(input, settings) {
    if (!input) return null;
    const trimmed = input.trim().toLowerCase();
    if (!trimmed) return null;
    const H = settings?.workingHoursPerDay || 8;
    const D = settings?.workingDaysPerWeek || 5;
    const unitMap = {
        m: 60,
        h: 3600,
        d: 3600 * H,
        w: 3600 * H * D
    };
    let total = 0;
    const regex = /(\d+)\s*([wdhm])/g;
    let found = false;
    let match;
    while(match = regex.exec(trimmed)){
        found = true;
        const qty = parseInt(match[1], 10);
        const unit = match[2];
        total += qty * (unitMap[unit] || 0);
    }
    if (found) return total || null;
    // Fallback: if no explicit unit was provided, use defaultUnit (accepts enum or short forms)
    const numeric = parseInt(trimmed, 10);
    if (!Number.isNaN(numeric) && numeric >= 0) {
        const def = $c50a9ddd8b3cb6fa$var$normalizeDefaultUnit(settings?.defaultUnit || 'HOUR');
        return numeric * (unitMap[def] || unitMap.h);
    }
    return null;
}
function $c50a9ddd8b3cb6fa$export$25f5618f67b8bbf0(seconds, settings) {
    if (seconds == null || seconds < 0) return null;
    const H = settings?.workingHoursPerDay || 8;
    const D = settings?.workingDaysPerWeek || 5;
    const secPerMin = 60;
    const secPerHour = 3600;
    const secPerDay = H * secPerHour;
    const secPerWeek = D * secPerDay;
    function formatPretty(totalSeconds) {
        let remaining = totalSeconds;
        const w = Math.floor(remaining / secPerWeek);
        remaining -= w * secPerWeek;
        const d = Math.floor(remaining / secPerDay);
        remaining -= d * secPerDay;
        const h = Math.floor(remaining / secPerHour);
        remaining -= h * secPerHour;
        const m = Math.floor(remaining / secPerMin);
        const parts = [];
        if (w) parts.push(`${w}w`);
        if (d) parts.push(`${d}d`);
        if (h) parts.push(`${h}h`);
        if (m) parts.push(`${m}m`);
        return parts.length ? parts.join(' ') : '0m';
    }
    function formatHours(totalSeconds) {
        const h = Math.floor(totalSeconds / secPerHour);
        const m = Math.round(totalSeconds % secPerHour / secPerMin);
        if (m === 0) return `${h}h`;
        return `${h}h ${m}m`;
    }
    function formatDays(totalSeconds) {
        const d = Math.floor(totalSeconds / secPerDay);
        const remainder = totalSeconds % secPerDay;
        const h = Math.floor(remainder / secPerHour);
        const m = Math.round(remainder % secPerHour / secPerMin);
        const parts = [];
        if (d) parts.push(`${d}d`);
        if (h) parts.push(`${h}h`);
        if (m) parts.push(`${m}m`);
        return parts.length ? parts.join(' ') : '0m';
    }
    switch(settings?.defaultFormat){
        case 'HOURS':
            return formatHours(seconds);
        case 'DAYS':
            return formatDays(seconds);
        case 'PRETTY':
        default:
            return formatPretty(seconds);
    }
}
module.exports["formatSecondsToHuman"] = $c50a9ddd8b3cb6fa$export$12fa006f8c81adb2;
module.exports["parseSuggestionToSeconds"] = $c50a9ddd8b3cb6fa$export$224de29a6bf17186;
module.exports["formatSecondsWithSettings"] = $c50a9ddd8b3cb6fa$export$25f5618f67b8bbf0;

});

parcelRegister("g2LNR", function(module, exports) {
function $8d6316d398d314c0$var$isTimeSpentField(value) {
    const validKeys = new Set([
        'timeSpent',
        'started',
        'comment'
    ]);
    return typeof value === 'object' && value !== null && 'timeSpent' in value && Object.keys(value).every((key)=>validKeys.has(key));
}
function $8d6316d398d314c0$export$5e829b7a93e3ebd1(value) {
    return $8d6316d398d314c0$var$isTimeSpentField(value) ? value : undefined;
}
module.exports["toTimeSpentFieldValue"] = $8d6316d398d314c0$export$5e829b7a93e3ebd1;

});

parcelRegister("iELRi", function(module, exports) {
/**
 * @generated SignedSource<<ccfc54ee63e09301d381c20cf5b8525d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcfafa8bf8b04b0f$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "timeInSeconds"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "timeTrackingField_updateWorkItemAllFieldTypesActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraTimeTrackingSettings",
                "kind": "LinkedField",
                "name": "timeTrackingSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isJiraConfiguredTimeTrackingEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "workingHoursPerDay"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "workingDaysPerWeek"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "defaultFormat"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "defaultUnit"
                    }
                ]
            },
            {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "remainingEstimate",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraTimeTrackingField"
    };
}();
$dcfafa8bf8b04b0f$var$node.hash = "5fec1c5c5a346c0074448461f24f884c";
var $dcfafa8bf8b04b0f$export$2e2bcd8739ae039 = $dcfafa8bf8b04b0f$var$node;
module.exports["default"] = $dcfafa8bf8b04b0f$export$2e2bcd8739ae039;

});

parcelRegister("golg3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a9d6bd43faba3505$var$messages = (0, $kSwu1.defineMessages)({
    originalEstimate: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-estimate",
        defaultMessage: "Set original time estimate to {value}"
    },
    remainingEstimate: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.remaining-estimate",
        defaultMessage: "Set remaining time estimate to {value}"
    },
    originalAndRemainingEstimate: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-and-remaining-estimate",
        defaultMessage: "Set original time estimate to {originalEstimate}, remaining to {remainingEstimate}"
    },
    clearOriginalAndRemainingEstimate: {
        id: "update-work-item-all-fields-action-renderer.ui.action-card.remaining-time-estimate-field.clear-original-and-remaining-estimate",
        defaultMessage: "Clear original and remaining time estimates"
    }
});
function $a9d6bd43faba3505$var$isTimeTrackingField(value) {
    return typeof value === 'object' && value !== null && ('originalEstimate' in value || 'remainingEstimate' in value);
}
function $a9d6bd43faba3505$export$3648efb6c51f1086(value) {
    return $a9d6bd43faba3505$var$isTimeTrackingField(value) ? value : undefined;
}
function $a9d6bd43faba3505$export$a61d1de70e18a41a({ suggestedOriginalEstimate: suggestedOriginalEstimate, suggestedRemainingEstimate: suggestedRemainingEstimate, normalizedOriginalValue: normalizedOriginalValue, normalizedRemainingValue: normalizedRemainingValue, normalizedCurrentOriginalValue: normalizedCurrentOriginalValue, normalizedCurrentRemainingValue: normalizedCurrentRemainingValue, formatMessage: formatMessage }) {
    // Note that if a value is empty, it indicates that the estimate is being removed/cleared. If a value is undefined,
    // it indicates that the estimate is not being set/changed.
    const originalCleared = suggestedOriginalEstimate === '' || suggestedOriginalEstimate === null;
    const remainingCleared = suggestedRemainingEstimate === '' || suggestedRemainingEstimate === null;
    // Both estimates are present, so display copy text for both estimates
    if (suggestedOriginalEstimate && suggestedRemainingEstimate) return formatMessage($a9d6bd43faba3505$var$messages.originalAndRemainingEstimate, {
        originalEstimate: normalizedOriginalValue,
        remainingEstimate: normalizedRemainingValue
    });
    // One estimate present, the other is undefined (i.e is not in the object), so only
    // display the estimate copy text.
    if (suggestedOriginalEstimate && suggestedRemainingEstimate === undefined) return formatMessage($a9d6bd43faba3505$var$messages.originalEstimate, {
        value: normalizedOriginalValue
    });
    if (suggestedRemainingEstimate && suggestedOriginalEstimate === undefined) return formatMessage($a9d6bd43faba3505$var$messages.remainingEstimate, {
        value: normalizedRemainingValue
    });
    // One estimate present, the other is empty (i.e is cleared), the cleared estimate gets set
    // to the new estimate's value.
    if (suggestedOriginalEstimate && remainingCleared) return formatMessage($a9d6bd43faba3505$var$messages.originalAndRemainingEstimate, {
        originalEstimate: normalizedOriginalValue,
        remainingEstimate: normalizedOriginalValue
    });
    if (suggestedRemainingEstimate && originalCleared) return formatMessage($a9d6bd43faba3505$var$messages.originalAndRemainingEstimate, {
        originalEstimate: normalizedRemainingValue,
        remainingEstimate: normalizedRemainingValue
    });
    // One estimate is empty (i.e is cleared) and the other is undefined (i.e is not in the object), the cleared
    // estimate gets set to the other estimate's value.
    if (originalCleared && suggestedRemainingEstimate === undefined) return formatMessage($a9d6bd43faba3505$var$messages.originalEstimate, {
        value: normalizedCurrentRemainingValue
    });
    if (suggestedOriginalEstimate === undefined && remainingCleared) return formatMessage($a9d6bd43faba3505$var$messages.remainingEstimate, {
        value: normalizedCurrentOriginalValue
    });
    // Both estimates are empty (i.e both are cleared), so display the cleared copy text.
    if (originalCleared && remainingCleared) return formatMessage($a9d6bd43faba3505$var$messages.clearOriginalAndRemainingEstimate);
    // No estimates are present, so return null.
    return null;
}
module.exports["toTimeTrackingFieldValue"] = $a9d6bd43faba3505$export$3648efb6c51f1086;
module.exports["getFieldTextCopy"] = $a9d6bd43faba3505$export$a61d1de70e18a41a;

});

parcelRegister("emY7T", function(module, exports) {
/**
 * @generated SignedSource<<4c8bd2f9594381391ed3a5bad70979ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50a11864728737dc$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        v0 /*: any*/ ,
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedUsersConnection(first:10)"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "usersField_updateWorkItemAllFieldTypesActionRenderer",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": v1 /*: any*/ ,
                "type": "JiraPeopleField"
            },
            {
                "kind": "InlineFragment",
                "selections": v1 /*: any*/ ,
                "type": "JiraMultipleSelectUserPickerField"
            }
        ],
        "type": "JiraIssueField",
        "abstractKey": "__isJiraIssueField"
    };
}();
$50a11864728737dc$var$node.hash = "39c970a1d25061e97f184bd7ed9364c6";
var $50a11864728737dc$export$2e2bcd8739ae039 = $50a11864728737dc$var$node;
module.exports["default"] = $50a11864728737dc$export$2e2bcd8739ae039;

});

parcelRegister("4xEYr", function(module, exports) {
/**
 * Sanitizes an array of values by filtering out falsy values,
 * converting each remaining value to a string, and trimming whitespace.
 *
 * @param values - The array of values to sanitize.
 * @returns An array of trimmed string representations of the truthy input values.
 */ function $9008453e600340f4$var$sanitizeAaids(values) {
    return values.filter(Boolean).map(String).map((value)=>value.trim()).filter(Boolean);
}
function $9008453e600340f4$export$95bc0487f9b5188(fieldValue) {
    if (!fieldValue) return [];
    if (Array.isArray(fieldValue)) return $9008453e600340f4$var$sanitizeAaids(fieldValue);
    if (typeof fieldValue === 'string') {
        const trimmed = fieldValue.trim();
        if (!trimmed) return [];
        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) return $9008453e600340f4$var$sanitizeAaids(parsed);
            // If parsed is a string, treat as single value
            if (typeof parsed === 'string') return [
                parsed.trim()
            ].filter(Boolean);
        } catch  {
        // Not valid JSON, fallback below
        }
        // Fallback: treat as single AAID, or comma-separated list
        if (trimmed.includes(',')) return $9008453e600340f4$var$sanitizeAaids(trimmed.split(','));
        return [
            trimmed
        ];
    }
    // Fallback: stringify unknown types
    return [
        String(fieldValue)
    ].filter(Boolean);
}
module.exports["parseSuggestedAccountIds"] = $9008453e600340f4$export$95bc0487f9b5188;

});

parcelRegister("bNYTA", function(module, exports) {

var $jDu2v = parcelRequire("jDu2v");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");

function $e802160c08f5728d$var$normalizeAccountIds(ids) {
    return Array.from(new Set((ids ?? []).map(String).map((s)=>s.trim()).filter(Boolean))).sort();
}
// Check if the accountIds are already hydrated
function $e802160c08f5728d$var$isAlreadyHydrated(users, accountIds) {
    return users.length > 0 && accountIds.every((accountId)=>users.some((user)=>user.accountId === accountId && user.name));
}
function $e802160c08f5728d$export$f1de398e9368e7f1(suggestedAccountIds, shouldHydrate, onInvalidAction) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [users, setUsers] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const accountIds = (0, $cozmU.useMemo)(()=>$e802160c08f5728d$var$normalizeAccountIds(suggestedAccountIds), [
        suggestedAccountIds
    ]);
    // accountIdsKey is used as a stable dependency for useEffect and request tracking.
    // This avoids infinite update loops caused by new array references on every render.
    const accountIdsKey = accountIds.join(',');
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    const resetState = (0, $cozmU.useCallback)(()=>{
        if (inFlightFor.current) {
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        }
        setUsers([]);
        setIsLoading(false);
        setError(null);
    }, []);
    // Cancel any previous in-flight request
    const cancelPreviousRequest = (0, $cozmU.useCallback)(()=>{
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
    }, []);
    // Cancel the subscription
    const cancelSubscription = (0, $cozmU.useCallback)((subscription, key)=>{
        if (activeSubscription.current === subscription) {
            subscription.unsubscribe();
            activeSubscription.current = null;
            if (inFlightFor.current === key) inFlightFor.current = null;
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (accountIds.length === 0 || !shouldHydrate) {
            resetState();
            return;
        }
        if ($e802160c08f5728d$var$isAlreadyHydrated(users, accountIds)) return; // already hydrated
        if (inFlightFor.current === accountIdsKey) return; // request already in flight for this set
        // cancel any previous in-flight subscription
        cancelPreviousRequest();
        inFlightFor.current = accountIdsKey;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $jDu2v.default), {
            accountIds: accountIds
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current) return;
                if (inFlightFor.current !== accountIdsKey) return;
                const hydratedUsers = (response?.users ?? []).filter(Boolean).map((user)=>({
                        accountId: user?.accountId,
                        name: user?.name ?? null
                    }));
                setUsers(hydratedUsers);
                setIsLoading(false);
            },
            error: (error)=>{
                if (disposed.current) return;
                if (inFlightFor.current === accountIdsKey) {
                    setError(error);
                    onInvalidAction?.();
                    setIsLoading(false);
                }
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === accountIdsKey) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>cancelSubscription(subscription, accountIdsKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cancelPreviousRequest,
        cancelSubscription,
        environment,
        resetState,
        shouldHydrate,
        accountIdsKey
    ]);
    if (accountIds.length === 0 || !shouldHydrate) return null;
    return {
        users: users,
        isLoading: isLoading,
        error: error
    };
}
module.exports["useHydratedUsers"] = $e802160c08f5728d$export$f1de398e9368e7f1;

});

parcelRegister("2EyVz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $76a09780ecc4d8a6$export$9756b64f930b5ec1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "users-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "users-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
};
module.exports["UsersFieldSkeleton"] = $76a09780ecc4d8a6$export$9756b64f930b5ec1;

});

parcelRegister("eyfek", function(module, exports) {
/**
 * @generated SignedSource<<6d8b0b03b818499a87e33f9fa109cb6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c0632c1dc9846faa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "colorField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                }
            ]
        }
    ],
    "type": "JiraColorField"
};
$c0632c1dc9846faa$var$node.hash = "70826ff7f56c2f65c9e1a5f68022b7ab";
var $c0632c1dc9846faa$export$2e2bcd8739ae039 = $c0632c1dc9846faa$var$node;
module.exports["default"] = $c0632c1dc9846faa$export$2e2bcd8739ae039;

});

parcelRegister("agB5R", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $9f2f6aa178b93f0a$export$41ebd7778026fc1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterTooltipContentProvider(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { registerTooltipProvider: registerTooltipProvider, fieldId: fieldId, provider: provider, enabled: t1 } = t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== enabled || $[1] !== fieldId || $[2] !== provider || $[3] !== registerTooltipProvider) {
        t2 = ()=>{
            if (!enabled || !registerTooltipProvider || !fieldId) return;
            registerTooltipProvider(fieldId, provider ?? null);
            return ()=>{
                registerTooltipProvider(fieldId, null);
            };
        };
        t3 = [
            registerTooltipProvider,
            fieldId,
            provider,
            enabled
        ];
        $[0] = enabled;
        $[1] = fieldId;
        $[2] = provider;
        $[3] = registerTooltipProvider;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useRegisterTooltipContentProvider({ registerTooltipProvider: registerTooltipProvider, fieldId: fieldId, provider: provider, enabled: enabled = true }) {
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !registerTooltipProvider || !fieldId) return;
        // Register current provider (can be null which effectively clears it)
        registerTooltipProvider(fieldId, provider ?? null);
        // Cleanup always clears the provider to avoid stale content retention.
        return ()=>{
            registerTooltipProvider(fieldId, null);
        };
    }, [
        registerTooltipProvider,
        fieldId,
        provider,
        enabled
    ]);
};
module.exports["useRegisterTooltipContentProvider"] = $9f2f6aa178b93f0a$export$41ebd7778026fc1e;

});

parcelRegister("hzAn1", function(module, exports) {
/**
 * @generated SignedSource<<5dde0c581aca37263ed8e363759f0d89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca98e32fb6524bae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "datePickerField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraDatePickerField"
};
$ca98e32fb6524bae$var$node.hash = "79f4380b0255b1c99a5c97635b2d3805";
var $ca98e32fb6524bae$export$2e2bcd8739ae039 = $ca98e32fb6524bae$var$node;
module.exports["default"] = $ca98e32fb6524bae$export$2e2bcd8739ae039;

});

parcelRegister("caPVv", function(module, exports) {
const $ded5b2c34fb6fa4c$var$getDefaultFormatDateOptions = ()=>({
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    });
function $ded5b2c34fb6fa4c$export$de3020c9fe9cee67(value, formatDate) {
    if (!value) return undefined;
    const defaultFormatDateOptions = $ded5b2c34fb6fa4c$var$getDefaultFormatDateOptions();
    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        if (trimmedValue.length === 0) return undefined;
        // ISO date-only string
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) {
            const isoDate = new Date(trimmedValue);
            if (!Number.isNaN(isoDate.getTime())) return formatDate(isoDate, defaultFormatDateOptions);
            return trimmedValue;
        }
        // ISO timestamp - extract date and format
        const timestampMatch = trimmedValue.match(/^(\d{4}-\d{2}-\d{2})T/);
        if (timestampMatch) {
            const isoDate = new Date(timestampMatch[1]);
            if (!Number.isNaN(isoDate.getTime())) return formatDate(isoDate, defaultFormatDateOptions);
            return timestampMatch[1];
        }
        return trimmedValue;
    }
    if (typeof value === 'number') {
        const date = new Date(value);
        if (!Number.isNaN(date.getTime())) return formatDate(date, defaultFormatDateOptions);
    }
    return String(value);
}
module.exports["formatSuggestedDate"] = $ded5b2c34fb6fa4c$export$de3020c9fe9cee67;

});

parcelRegister("8eljq", function(module, exports) {
/**
 * @generated SignedSource<<fb56386a6751496eba36df8017fa85c5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $800d89eafaaef6fc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTimePickerField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$800d89eafaaef6fc$var$node.hash = "22f49b636a0649200c32b60259f823b0";
var $800d89eafaaef6fc$export$2e2bcd8739ae039 = $800d89eafaaef6fc$var$node;
module.exports["default"] = $800d89eafaaef6fc$export$2e2bcd8739ae039;

});

parcelRegister("cfM17", function(module, exports) {
const $923e2d7f84591713$var$getDefaultFormatDateOptions = ()=>({
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
function $923e2d7f84591713$export$654d14d3bb6fb466(value, formatDate) {
    if (!value) return undefined;
    const defaultFormatDateOptions = $923e2d7f84591713$var$getDefaultFormatDateOptions();
    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        if (trimmedValue.length === 0) return undefined;
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(trimmedValue)) {
            const isoDate = new Date(trimmedValue);
            if (!Number.isNaN(isoDate.getTime())) return formatDate(isoDate, defaultFormatDateOptions);
            return trimmedValue;
        }
        return trimmedValue;
    }
    if (typeof value === 'number') {
        const date = new Date(value);
        if (!Number.isNaN(date.getTime())) return formatDate(date, defaultFormatDateOptions);
    }
    return String(value);
}
module.exports["formatSuggestedDateTime"] = $923e2d7f84591713$export$654d14d3bb6fb466;

});

parcelRegister("kzUKj", function(module, exports) {
/**
 * @generated SignedSource<<bdb2b5ab249157988e273a4ca6b0c033>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $370914f5bde874a6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "flagField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraFlagField"
};
$370914f5bde874a6$var$node.hash = "aa3dff23883f87fdc3d3e46f3e4613f0";
var $370914f5bde874a6$export$2e2bcd8739ae039 = $370914f5bde874a6$var$node;
module.exports["default"] = $370914f5bde874a6$export$2e2bcd8739ae039;

});

parcelRegister("ihrZg", function(module, exports) {
/**
 * Normalises assorted representations of the Jira flag field into a boolean.
 * Accepted truthy representations:
 *  - boolean true
 *  - non-empty array
 *  - string 'true'
 *  - stringified array (single or double quotes) with at least one element e.g. "['Impediment']" / '["Impediment"]'
 * Everything else (including malformed / non-parsable bracketed strings) is treated as unflagged.
 */ function $02c1b8b2e6a11940$export$3cb039149a6e8bec(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;
    if (Array.isArray(value)) return value.length > 0 && value.includes('Impediment');
    if (typeof value === 'string') {
        const stringValue = value.trim();
        if (stringValue === 'true') return true;
        if (stringValue === 'false' || stringValue === '' || stringValue === '[]') return false;
        // Heuristic: looks like an array string
        if (stringValue.startsWith('[') && stringValue.endsWith(']')) {
            let candidate = stringValue;
            // If it only has single quotes, convert to double quotes for JSON.parse
            if (!stringValue.includes('"') && stringValue.includes("'")) candidate = stringValue.replace(/'/g, '"');
            try {
                const parsed = JSON.parse(candidate);
                if (Array.isArray(parsed)) return parsed.length > 0 && parsed.includes('Impediment');
            } catch  {
                // Parsing failed – treat malformed bracketed content as unflagged now.
                return false;
            }
            // Non‑array parsed result -> not flagged
            return false;
        }
    }
    return false;
}
var $02c1b8b2e6a11940$export$2e2bcd8739ae039 = $02c1b8b2e6a11940$export$3cb039149a6e8bec;
module.exports["isFlagged"] = $02c1b8b2e6a11940$export$3cb039149a6e8bec;

});

parcelRegister("ilJfi", function(module, exports) {
/**
 * @generated SignedSource<<d46bfe5a013fc9c5f452e86a516e8e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20f637acb8303211$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "genericField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$20f637acb8303211$var$node.hash = "2df905f7f13429193928878e2ea28fe7";
var $20f637acb8303211$export$2e2bcd8739ae039 = $20f637acb8303211$var$node;
module.exports["default"] = $20f637acb8303211$export$2e2bcd8739ae039;

});

parcelRegister("u9Ee1", function(module, exports) {
const $6f5cba5d83c1c82c$var$COMMON_KEYS = [
    'id',
    'key',
    'name'
];
function $6f5cba5d83c1c82c$var$formatIdentifier(str) {
    return str.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\s+/g, ' ').trim().toLowerCase();
}
function $6f5cba5d83c1c82c$var$isIdentifier(str) {
    return /[a-z]/.test(str) && /[A-Z]/.test(str) || /_/.test(str);
}
function $6f5cba5d83c1c82c$var$formatValue(str, shouldLowercase = false) {
    const trimmed = str.trim();
    if (shouldLowercase) return $6f5cba5d83c1c82c$var$formatIdentifier(trimmed);
    return $6f5cba5d83c1c82c$var$isIdentifier(trimmed) ? $6f5cba5d83c1c82c$var$formatIdentifier(trimmed) : trimmed;
}
function $6f5cba5d83c1c82c$var$extractCommonKeyValues(obj) {
    return $6f5cba5d83c1c82c$var$COMMON_KEYS.filter((key)=>key in obj && (obj[key] === null || typeof obj[key] !== 'object')).map((key)=>{
        const value = String(obj[key]);
        if (key === 'name') return value;
        return $6f5cba5d83c1c82c$var$formatValue(value);
    });
}
function $6f5cba5d83c1c82c$var$formatObject(obj) {
    const parts = [];
    for (const [key, value] of Object.entries(obj)){
        const formattedKey = $6f5cba5d83c1c82c$var$formatIdentifier(key);
        if ($6f5cba5d83c1c82c$var$COMMON_KEYS.includes(key) && (value === null || typeof value !== 'object')) {
            parts.push($6f5cba5d83c1c82c$var$formatValue(String(value)));
            continue;
        }
        if (Array.isArray(value)) {
            if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
                const formatted = value.map((item)=>{
                    if (typeof item === 'object' && item !== null) {
                        const commonValues = $6f5cba5d83c1c82c$var$extractCommonKeyValues(item);
                        return commonValues.length > 0 ? `(${commonValues.join(', ')})` : `(${$6f5cba5d83c1c82c$var$formatObject(item)})`;
                    }
                    return String(item);
                }).join(', ');
                parts.push(`${formattedKey} ${formatted}`);
            } else {
                const formatted = value.map((item)=>$6f5cba5d83c1c82c$var$formatValue(String(item))).join(', ');
                parts.push(`${formattedKey}: ${formatted}`);
            }
            continue;
        }
        if (value !== null && typeof value === 'object') {
            const nested = value;
            const nestedKeys = Object.keys(nested);
            const commonKeys = nestedKeys.filter((k)=>$6f5cba5d83c1c82c$var$COMMON_KEYS.includes(k));
            if (commonKeys.length === 1 && nestedKeys.length === 1) parts.push(`${formattedKey}: ${$6f5cba5d83c1c82c$var$formatValue(String(nested[commonKeys[0]]))}`);
            else parts.push(`${formattedKey}: (${$6f5cba5d83c1c82c$var$formatObject(nested)})`);
            continue;
        }
        parts.push(`${formattedKey}: ${$6f5cba5d83c1c82c$var$formatValue(String(value))}`);
    }
    return parts.join(', ');
}
function $6f5cba5d83c1c82c$export$4a9c38fec6876a9e(value) {
    if (typeof value === 'string') return $6f5cba5d83c1c82c$var$formatIdentifier(value);
    if (Array.isArray(value)) return value.map(String).join(',');
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) return $6f5cba5d83c1c82c$var$formatObject(value);
    return String(value);
}
function $6f5cba5d83c1c82c$export$db22d31c00e5eb2f(value) {
    if (typeof value === 'string') return $6f5cba5d83c1c82c$var$formatValue(value);
    if (Array.isArray(value)) {
        if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null) return value.map((item)=>$6f5cba5d83c1c82c$var$formatObject(item)).join('; ');
        return value.map((item)=>$6f5cba5d83c1c82c$var$formatValue(String(item))).join(', ');
    }
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) return $6f5cba5d83c1c82c$var$formatObject(value);
    return String(value);
}
module.exports["sanitizeFieldName"] = $6f5cba5d83c1c82c$export$4a9c38fec6876a9e;
module.exports["sanitizeFieldValue"] = $6f5cba5d83c1c82c$export$db22d31c00e5eb2f;

});

parcelRegister("hnFrp", function(module, exports) {
/**
 * @generated SignedSource<<891a09b5c3e2260d6aabd81e07d17243>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d3d38701efea042$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labelsField_updateWorkItemFieldsActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            v0 /*: any*/ ,
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$5d3d38701efea042$var$node.hash = "af0b93fc2b1fa7900e6e04a8f8d4109f";
var $5d3d38701efea042$export$2e2bcd8739ae039 = $5d3d38701efea042$var$node;
module.exports["default"] = $5d3d38701efea042$export$2e2bcd8739ae039;

});

parcelRegister("cCmlF", function(module, exports) {
function $1673924ae227f608$var$isNonEmptyStringArray(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
function $1673924ae227f608$export$3a71dfd0eab58a09(value) {
    if (Array.isArray(value)) {
        const filtered = value.filter($1673924ae227f608$var$isNonEmptyStringArray);
        return filtered.length ? filtered : null;
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return null;
        // JSON-looking input: if it starts with '[' we only accept it when it also ends with ']'.
        if (trimmed.startsWith('[')) {
            if (!trimmed.endsWith(']')) return null;
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                    const filtered = parsed.filter($1673924ae227f608$var$isNonEmptyStringArray);
                    return filtered.length ? filtered : null;
                }
                return null;
            } catch  {
                return null;
            }
        }
        // If it is a single comma-separated string, split into labels (fallback behavior)
        if (trimmed.includes(',')) {
            const parts = trimmed.split(',').map((s)=>s.trim()).filter(Boolean);
            return parts.length ? parts : null;
        }
        // Treat any single non-empty string as one label
        return [
            trimmed
        ];
    }
    return null;
}
module.exports["parseLabels"] = $1673924ae227f608$export$3a71dfd0eab58a09;

});

parcelRegister("elZLk", function(module, exports) {
/**
 * @generated SignedSource<<30df3bb751b08db7d0a3ff9584574b0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f4f9e77dfa28e09$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "numberField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$6f4f9e77dfa28e09$var$node.hash = "f81c561dab5bc9ccfc5e9906bce11f8a";
var $6f4f9e77dfa28e09$export$2e2bcd8739ae039 = $6f4f9e77dfa28e09$var$node;
module.exports["default"] = $6f4f9e77dfa28e09$export$2e2bcd8739ae039;

});

parcelRegister("afI4f", function(module, exports) {
/**
 * @generated SignedSource<<caed1cc1b92f58d64a22809a9ebbf891>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f4f2ec42a5e2274$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parentIssueField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$0f4f2ec42a5e2274$var$node.hash = "a4a14dae923ead052fad903fcbfd9e9a";
var $0f4f2ec42a5e2274$export$2e2bcd8739ae039 = $0f4f2ec42a5e2274$var$node;
module.exports["default"] = $0f4f2ec42a5e2274$export$2e2bcd8739ae039;

});

parcelRegister("lcIbO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $4cbe2c11096825ca$export$e2b1918ff1ac008b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "parent-issue-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "parent-issue-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
module.exports["ParentIssueFieldSkeleton"] = $4cbe2c11096825ca$export$e2b1918ff1ac008b;

});

parcelRegister("8lRJP", function(module, exports) {

var $75LG8 = parcelRequire("75LG8");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");


var $3iWYJ = parcelRequire("3iWYJ");

var $a0unS = parcelRequire("a0unS");

var $1eov5 = parcelRequire("1eov5");

var $9LE5K = parcelRequire("9LE5K");


var $2TX7O = parcelRequire("2TX7O");

function $81e6974e2e5c8a96$export$928f2fb4dc38339(cloudId, suggestedIssueId, shouldHydrate) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [issue, setIssue] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    // Cleanup on unmount
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    // Reset state when no issue ID or rendering is disabled
    const resetState = (0, $cozmU.useCallback)(()=>{
        if (inFlightFor.current) {
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        }
        setIssue(null);
        setIsLoading(false);
        setError(null);
    }, []);
    // Check if the issue is already hydrated
    const isAlreadyHydrated = (0, $cozmU.useCallback)((issueId)=>issue && (issue.issueId === issueId || issue.key === issueId) && issue.summary, [
        issue
    ]);
    // Cancel any previous in-flight request
    const cancelPreviousRequest = (0, $cozmU.useCallback)(()=>{
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
    }, []);
    // Cancel the subscription
    const cancelSubscription = (0, $cozmU.useCallback)((subscription, issueId)=>{
        if (activeSubscription.current === subscription) {
            subscription.unsubscribe();
            activeSubscription.current = null;
            if (inFlightFor.current === issueId) inFlightFor.current = null;
        }
    }, []);
    const jql = (0, $cozmU.useMemo)(()=>{
        if (!suggestedIssueId) return '';
        const jqlQuery = (0, $a0unS.default).query();
        if ((0, $2TX7O.isIssueKey)(suggestedIssueId)) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field((0, $2TX7O.ISSUE_KEY_FIELD_KEY)), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_EQUALS)), (0, $a0unS.default).valueOperand(suggestedIssueId)), (0, $3iWYJ.COMPOUND_OPERATOR_AND));
        else if ((0, $2TX7O.isIssueId)(suggestedIssueId)) jqlQuery.appendClause((0, $a0unS.default).terminalClause((0, $a0unS.default).field((0, $2TX7O.ISSUE_ID_FIELD_KEY)), (0, $a0unS.default).operator((0, $1eov5.OPERATOR_EQUALS)), (0, $a0unS.default).valueOperand(suggestedIssueId)), (0, $3iWYJ.COMPOUND_OPERATOR_AND));
        return (0, $9LE5K.print)((0, $a0unS.default).jast(jqlQuery));
    }, [
        suggestedIssueId
    ]);
    // Fetch and hydrate issue data
    (0, $cozmU.useEffect)(()=>{
        if (!suggestedIssueId || !shouldHydrate) {
            resetState();
            return;
        }
        if (isAlreadyHydrated(suggestedIssueId)) return;
        cancelPreviousRequest();
        inFlightFor.current = suggestedIssueId;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $75LG8.default), {
            cloudId: cloudId,
            jql: jql
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current || inFlightFor.current !== suggestedIssueId) return;
                const issue = response?.jira?.issueSearch?.edges?.[0]?.node;
                if (issue) setIssue({
                    issueId: issue.issueId,
                    key: issue.key,
                    summary: issue.summary ?? null
                });
                else setIssue(null);
                setIsLoading(false);
            },
            error: (err)=>{
                if (disposed.current || inFlightFor.current !== suggestedIssueId) return;
                setError(err);
                setIsLoading(false);
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === suggestedIssueId) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>cancelSubscription(subscription, suggestedIssueId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        suggestedIssueId,
        environment,
        shouldHydrate,
        cloudId,
        resetState,
        isAlreadyHydrated,
        cancelPreviousRequest,
        cancelSubscription,
        jql
    ]);
    if (!suggestedIssueId || !shouldHydrate) return null;
    return {
        issue: issue,
        isLoading: isLoading,
        error: error
    };
}
module.exports["useHydratedIssue"] = $81e6974e2e5c8a96$export$928f2fb4dc38339;

});

parcelRegister("7JqUm", function(module, exports) {
/**
 * @generated SignedSource<<6b484ac581edb20a31e384dcd3b101fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1f53650f0944759$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priorityField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$a1f53650f0944759$var$node.hash = "8a19b32833d3f0442322814c42d5ad63";
var $a1f53650f0944759$export$2e2bcd8739ae039 = $a1f53650f0944759$var$node;
module.exports["default"] = $a1f53650f0944759$export$2e2bcd8739ae039;

});

parcelRegister("cv7iN", function(module, exports) {
/**
 * @generated SignedSource<<8de1ee1d52930efd34be75fcbdee3c87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1607264ad6f164c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "richTextField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAdfToConvertedPlainText",
                            "kind": "LinkedField",
                            "name": "convertedPlainText",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "plainText"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isTruncated"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$d1607264ad6f164c$var$node.hash = "4be08a78c6400b4c754e9f0598a9d9a8";
var $d1607264ad6f164c$export$2e2bcd8739ae039 = $d1607264ad6f164c$var$node;
module.exports["default"] = $d1607264ad6f164c$export$2e2bcd8739ae039;

});

parcelRegister("dTSq1", function(module, exports) {
/**
 * @generated SignedSource<<8c33e0bc5dad948051d02d25988170f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e60baa94b9b9ad7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineTextField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$4e60baa94b9b9ad7$var$node.hash = "d71c1f45d496146796b6591f451b896b";
var $4e60baa94b9b9ad7$export$2e2bcd8739ae039 = $4e60baa94b9b9ad7$var$node;
module.exports["default"] = $4e60baa94b9b9ad7$export$2e2bcd8739ae039;

});

parcelRegister("cqkn1", function(module, exports) {
/**
 * @generated SignedSource<<ba116be328d0697df92f16caba7e1958>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bed6ff43ef22e2f1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleSelectUserPickerField_updateWorkItemFieldsActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$bed6ff43ef22e2f1$var$node.hash = "27c0bd0944bbeb46192d989bc4da96a5";
var $bed6ff43ef22e2f1$export$2e2bcd8739ae039 = $bed6ff43ef22e2f1$var$node;
module.exports["default"] = $bed6ff43ef22e2f1$export$2e2bcd8739ae039;

});

parcelRegister("7Z0GE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $bc9823f65177fc9d$export$a409882f4d472281 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "single-select-user-picker-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "single-select-user-picker-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
};
module.exports["SingleSelectUserPickerFieldSkeleton"] = $bc9823f65177fc9d$export$a409882f4d472281;

});

parcelRegister("lxaXk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dl6HD = parcelRequire("dl6HD");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");

const $1bc797d91abd3faf$export$a6881b2ed83fb629 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHydratedUser(suggestedUserAccountId, shouldHydrate) {
    const $ = (0, $bDgLe.c)(14);
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [user, setUser] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            disposed.current = false;
            return ()=>{
                disposed.current = true;
                activeSubscription.current?.unsubscribe();
                activeSubscription.current = null;
                inFlightFor.current = null;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== environment || $[3] !== shouldHydrate || $[4] !== suggestedUserAccountId || $[5] !== user) {
        t2 = ()=>{
            if (!suggestedUserAccountId || !shouldHydrate) {
                if (inFlightFor.current) {
                    activeSubscription.current?.unsubscribe();
                    activeSubscription.current = null;
                    inFlightFor.current = null;
                }
                setUser(null);
                setIsLoading(false);
                setError(null);
                return;
            }
            if (user && user.accountId === suggestedUserAccountId && user.name) return;
            if (inFlightFor.current === suggestedUserAccountId) return;
            if (activeSubscription.current) {
                activeSubscription.current.unsubscribe();
                activeSubscription.current = null;
            }
            inFlightFor.current = suggestedUserAccountId;
            setIsLoading(true);
            setError(null);
            const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $dl6HD.default), {
                accountId: suggestedUserAccountId
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (response)=>{
                    if (disposed.current) return;
                    if (inFlightFor.current !== suggestedUserAccountId) return;
                    if (response?.user?.accountId) setUser({
                        accountId: response.user.accountId,
                        name: response.user.name
                    });
                    else setUser(null);
                    setIsLoading(false);
                },
                error: (error_0)=>{
                    if (disposed.current) return;
                    if (inFlightFor.current === suggestedUserAccountId) {
                        setError(error_0);
                        setIsLoading(false);
                    }
                },
                complete: ()=>{
                    if (!disposed.current && inFlightFor.current === suggestedUserAccountId) setIsLoading(false);
                }
            });
            activeSubscription.current = subscription;
            return ()=>{
                if (activeSubscription.current === subscription) {
                    subscription.unsubscribe();
                    activeSubscription.current = null;
                    if (inFlightFor.current === suggestedUserAccountId) inFlightFor.current = null;
                }
            };
        };
        $[2] = environment;
        $[3] = shouldHydrate;
        $[4] = suggestedUserAccountId;
        $[5] = user;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== environment || $[8] !== suggestedUserAccountId) {
        t3 = [
            suggestedUserAccountId,
            environment
        ];
        $[7] = environment;
        $[8] = suggestedUserAccountId;
        $[9] = t3;
    } else t3 = $[9];
    (0, $cozmU.useEffect)(t2, t3);
    if (!suggestedUserAccountId) return null;
    let t4;
    if ($[10] !== error || $[11] !== isLoading || $[12] !== user) {
        t4 = {
            user: user,
            isLoading: isLoading,
            error: error
        };
        $[10] = error;
        $[11] = isLoading;
        $[12] = user;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useHydratedUser(suggestedUserAccountId, shouldHydrate) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [user, setUser] = (0, $cozmU.useState)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!suggestedUserAccountId || !shouldHydrate) {
            // reset state for missing id and do not issue a query
            if (inFlightFor.current) {
                activeSubscription.current?.unsubscribe();
                activeSubscription.current = null;
                inFlightFor.current = null;
            }
            setUser(null);
            setIsLoading(false);
            setError(null);
            return;
        }
        if (user && user.accountId === suggestedUserAccountId && user.name) return; // already hydrated fully
        if (inFlightFor.current === suggestedUserAccountId) return; // request already in flight for this id
        // cancel any previous in-flight subscription for a different id
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
        inFlightFor.current = suggestedUserAccountId;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $dl6HD.default), {
            accountId: suggestedUserAccountId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current) return;
                if (inFlightFor.current !== suggestedUserAccountId) return;
                 // stale
                if (response?.user?.accountId) setUser({
                    accountId: response.user.accountId,
                    name: response.user.name
                });
                else setUser(null);
                setIsLoading(false);
            },
            error: (error_0)=>{
                if (disposed.current) return;
                if (inFlightFor.current === suggestedUserAccountId) {
                    setError(error_0);
                    setIsLoading(false);
                }
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === suggestedUserAccountId) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>{
            if (activeSubscription.current === subscription) {
                subscription.unsubscribe();
                activeSubscription.current = null;
                if (inFlightFor.current === suggestedUserAccountId) inFlightFor.current = null;
            }
        };
    // We intentionally exclude user/isLoading from deps to avoid refetch loops
    }, [
        suggestedUserAccountId,
        environment
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!suggestedUserAccountId) return null; // maintain external contract returning null when no account id supplied
    return {
        user: user,
        isLoading: isLoading,
        error: error
    };
};
module.exports["useHydratedUser"] = $1bc797d91abd3faf$export$a6881b2ed83fb629;

});

parcelRegister("eTzLE", function(module, exports) {
/**
 * @generated SignedSource<<d061800d263fa5c80ad44d16844ce14e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f9748abfe0f90d2$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "statusField_updateWorkItemFieldsActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraTransitionConnection",
                "kind": "LinkedField",
                "name": "transitions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTransitionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraTransition",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "transitionId"
                                    },
                                    {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "to",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraStatusField"
    };
}();
$5f9748abfe0f90d2$var$node.hash = "fb23f08e5297002e3515870205f10d8d";
var $5f9748abfe0f90d2$export$2e2bcd8739ae039 = $5f9748abfe0f90d2$var$node;
module.exports["default"] = $5f9748abfe0f90d2$export$2e2bcd8739ae039;

});

parcelRegister("1Iy7Z", function(module, exports) {
/**
 * @generated SignedSource<<17e65c4e37f8f977a477d43cc32a8bb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1608bbeb87d29490$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "timeSpentField_updateWorkItemFieldsActionRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isJiraConfiguredTimeTrackingEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        },
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "timeSpent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$1608bbeb87d29490$var$node.hash = "49f036b56e6dbebd7bd50865073bb864";
var $1608bbeb87d29490$export$2e2bcd8739ae039 = $1608bbeb87d29490$var$node;
module.exports["default"] = $1608bbeb87d29490$export$2e2bcd8739ae039;

});

parcelRegister("cE5H8", function(module, exports) {
function $fcd155fba86f905c$var$normalizeDefaultUnit(unit) {
    const u = (unit || '').toString().trim().toUpperCase();
    switch(u){
        case 'M':
        case 'MINUTE':
            return 'm';
        case 'H':
        case 'HOUR':
            return 'h';
        case 'D':
        case 'DAY':
            return 'd';
        case 'W':
        case 'WEEK':
            return 'w';
        default:
            return 'h';
    }
}
function $fcd155fba86f905c$export$12fa006f8c81adb2(seconds) {
    if (!seconds || seconds <= 0) return null;
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor(seconds % 3600 / 60);
    const parts = [];
    if (hrs > 0) parts.push(`${hrs}h`);
    if (mins > 0) parts.push(`${mins}m`);
    return parts.length ? parts.join(' ') : '0m';
}
function $fcd155fba86f905c$export$224de29a6bf17186(input, settings) {
    if (!input) return null;
    const trimmed = input.trim().toLowerCase();
    if (!trimmed) return null;
    const H = settings?.workingHoursPerDay || 8;
    const D = settings?.workingDaysPerWeek || 5;
    const unitMap = {
        m: 60,
        h: 3600,
        d: 3600 * H,
        w: 3600 * H * D
    };
    let total = 0;
    const regex = /(\d+)\s*([wdhm])/g;
    let found = false;
    let match;
    while(match = regex.exec(trimmed)){
        found = true;
        const qty = parseInt(match[1], 10);
        const unit = match[2];
        total += qty * (unitMap[unit] || 0);
    }
    if (found) return total || null;
    // Fallback: if no explicit unit was provided, use defaultUnit (accepts enum or short forms)
    const numeric = parseInt(trimmed, 10);
    if (!Number.isNaN(numeric) && numeric >= 0) {
        const def = $fcd155fba86f905c$var$normalizeDefaultUnit(settings?.defaultUnit || 'HOUR');
        return numeric * (unitMap[def] || unitMap.h);
    }
    return null;
}
function $fcd155fba86f905c$export$25f5618f67b8bbf0(seconds, settings) {
    if (seconds == null || seconds < 0) return null;
    const H = settings?.workingHoursPerDay || 8;
    const D = settings?.workingDaysPerWeek || 5;
    const secPerMin = 60;
    const secPerHour = 3600;
    const secPerDay = H * secPerHour;
    const secPerWeek = D * secPerDay;
    function formatPretty(totalSeconds) {
        let remaining = totalSeconds;
        const w = Math.floor(remaining / secPerWeek);
        remaining -= w * secPerWeek;
        const d = Math.floor(remaining / secPerDay);
        remaining -= d * secPerDay;
        const h = Math.floor(remaining / secPerHour);
        remaining -= h * secPerHour;
        const m = Math.floor(remaining / secPerMin);
        const parts = [];
        if (w) parts.push(`${w}w`);
        if (d) parts.push(`${d}d`);
        if (h) parts.push(`${h}h`);
        if (m) parts.push(`${m}m`);
        return parts.length ? parts.join(' ') : '0m';
    }
    function formatHours(totalSeconds) {
        const h = Math.floor(totalSeconds / secPerHour);
        const m = Math.round(totalSeconds % secPerHour / secPerMin);
        if (m === 0) return `${h}h`;
        return `${h}h ${m}m`;
    }
    function formatDays(totalSeconds) {
        const d = Math.floor(totalSeconds / secPerDay);
        const remainder = totalSeconds % secPerDay;
        const h = Math.floor(remainder / secPerHour);
        const m = Math.round(remainder % secPerHour / secPerMin);
        const parts = [];
        if (d) parts.push(`${d}d`);
        if (h) parts.push(`${h}h`);
        if (m) parts.push(`${m}m`);
        return parts.length ? parts.join(' ') : '0m';
    }
    switch(settings?.defaultFormat){
        case 'HOURS':
            return formatHours(seconds);
        case 'DAYS':
            return formatDays(seconds);
        case 'PRETTY':
        default:
            return formatPretty(seconds);
    }
}
module.exports["formatSecondsToHuman"] = $fcd155fba86f905c$export$12fa006f8c81adb2;
module.exports["parseSuggestionToSeconds"] = $fcd155fba86f905c$export$224de29a6bf17186;
module.exports["formatSecondsWithSettings"] = $fcd155fba86f905c$export$25f5618f67b8bbf0;

});

parcelRegister("cIviZ", function(module, exports) {
function $41e977b31a5246d9$var$isTimeSpentField(value) {
    const validKeys = new Set([
        'timeSpent',
        'started',
        'comment'
    ]);
    return typeof value === 'object' && value !== null && 'timeSpent' in value && Object.keys(value).every((key)=>validKeys.has(key));
}
function $41e977b31a5246d9$export$5e829b7a93e3ebd1(value) {
    return $41e977b31a5246d9$var$isTimeSpentField(value) ? value : undefined;
}
module.exports["toTimeSpentFieldValue"] = $41e977b31a5246d9$export$5e829b7a93e3ebd1;

});

parcelRegister("kPhuI", function(module, exports) {
/**
 * @generated SignedSource<<e2a8531ddccd9346459e6bfc99628df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3df78a0b0cad995a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "timeInSeconds"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "timeTrackingField_updateWorkItemFieldsActionRenderer",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraTimeTrackingSettings",
                "kind": "LinkedField",
                "name": "timeTrackingSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isJiraConfiguredTimeTrackingEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "workingHoursPerDay"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "workingDaysPerWeek"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "defaultFormat"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "defaultUnit"
                    }
                ]
            },
            {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "remainingEstimate",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraTimeTrackingField"
    };
}();
$3df78a0b0cad995a$var$node.hash = "5fb522c14746070777fbe1f3fa7da46f";
var $3df78a0b0cad995a$export$2e2bcd8739ae039 = $3df78a0b0cad995a$var$node;
module.exports["default"] = $3df78a0b0cad995a$export$2e2bcd8739ae039;

});

parcelRegister("cSrlg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b3f605416cfac03b$var$messages = (0, $kSwu1.defineMessages)({
    originalEstimate: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-estimate",
        defaultMessage: "Set original time estimate to {value}"
    },
    remainingEstimate: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.remaining-estimate",
        defaultMessage: "Set remaining time estimate to {value}"
    },
    originalAndRemainingEstimate: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.original-and-remaining-estimate",
        defaultMessage: "Set original time estimate to {originalEstimate}, remaining to {remainingEstimate}"
    },
    clearOriginalAndRemainingEstimate: {
        id: "update-work-item-fields-action-renderer.ui.action-card.remaining-time-estimate-field.clear-original-and-remaining-estimate",
        defaultMessage: "Clear original and remaining time estimates"
    }
});
function $b3f605416cfac03b$var$isTimeTrackingField(value) {
    return typeof value === 'object' && value !== null && ('originalEstimate' in value || 'remainingEstimate' in value);
}
function $b3f605416cfac03b$export$3648efb6c51f1086(value) {
    return $b3f605416cfac03b$var$isTimeTrackingField(value) ? value : undefined;
}
function $b3f605416cfac03b$export$a61d1de70e18a41a({ suggestedOriginalEstimate: suggestedOriginalEstimate, suggestedRemainingEstimate: suggestedRemainingEstimate, normalizedOriginalValue: normalizedOriginalValue, normalizedRemainingValue: normalizedRemainingValue, normalizedCurrentOriginalValue: normalizedCurrentOriginalValue, normalizedCurrentRemainingValue: normalizedCurrentRemainingValue, formatMessage: formatMessage }) {
    // Note that if a value is empty, it indicates that the estimate is being removed/cleared. If a value is undefined,
    // it indicates that the estimate is not being set/changed.
    const originalCleared = suggestedOriginalEstimate === '' || suggestedOriginalEstimate === null;
    const remainingCleared = suggestedRemainingEstimate === '' || suggestedRemainingEstimate === null;
    // Both estimates are present, so display copy text for both estimates
    if (suggestedOriginalEstimate && suggestedRemainingEstimate) return formatMessage($b3f605416cfac03b$var$messages.originalAndRemainingEstimate, {
        originalEstimate: normalizedOriginalValue,
        remainingEstimate: normalizedRemainingValue
    });
    // One estimate present, the other is undefined (i.e is not in the object), so only
    // display the estimate copy text.
    if (suggestedOriginalEstimate && suggestedRemainingEstimate === undefined) return formatMessage($b3f605416cfac03b$var$messages.originalEstimate, {
        value: normalizedOriginalValue
    });
    if (suggestedRemainingEstimate && suggestedOriginalEstimate === undefined) return formatMessage($b3f605416cfac03b$var$messages.remainingEstimate, {
        value: normalizedRemainingValue
    });
    // One estimate present, the other is empty (i.e is cleared), the cleared estimate gets set
    // to the new estimate's value.
    if (suggestedOriginalEstimate && remainingCleared) return formatMessage($b3f605416cfac03b$var$messages.originalAndRemainingEstimate, {
        originalEstimate: normalizedOriginalValue,
        remainingEstimate: normalizedOriginalValue
    });
    if (suggestedRemainingEstimate && originalCleared) return formatMessage($b3f605416cfac03b$var$messages.originalAndRemainingEstimate, {
        originalEstimate: normalizedRemainingValue,
        remainingEstimate: normalizedRemainingValue
    });
    // One estimate is empty (i.e is cleared) and the other is undefined (i.e is not in the object), the cleared
    // estimate gets set to the other estimate's value.
    if (originalCleared && suggestedRemainingEstimate === undefined) return formatMessage($b3f605416cfac03b$var$messages.originalEstimate, {
        value: normalizedCurrentRemainingValue
    });
    if (suggestedOriginalEstimate === undefined && remainingCleared) return formatMessage($b3f605416cfac03b$var$messages.remainingEstimate, {
        value: normalizedCurrentOriginalValue
    });
    // Both estimates are empty (i.e both are cleared), so display the cleared copy text.
    if (originalCleared && remainingCleared) return formatMessage($b3f605416cfac03b$var$messages.clearOriginalAndRemainingEstimate);
    // No estimates are present, so return null.
    return null;
}
module.exports["toTimeTrackingFieldValue"] = $b3f605416cfac03b$export$3648efb6c51f1086;
module.exports["getFieldTextCopy"] = $b3f605416cfac03b$export$a61d1de70e18a41a;

});

parcelRegister("lpPTZ", function(module, exports) {
/**
 * @generated SignedSource<<f08cf80f8e94b6820f224feb42cd7247>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0bd0cbfae3c25229$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        v0 /*: any*/ ,
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedUsersConnection(first:10)"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "usersField_updateWorkItemFieldsActionRenderer",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": v1 /*: any*/ ,
                "type": "JiraPeopleField"
            },
            {
                "kind": "InlineFragment",
                "selections": v1 /*: any*/ ,
                "type": "JiraMultipleSelectUserPickerField"
            }
        ],
        "type": "JiraIssueField",
        "abstractKey": "__isJiraIssueField"
    };
}();
$0bd0cbfae3c25229$var$node.hash = "3b4bd59e8fb3446c8f7507895834aa0a";
var $0bd0cbfae3c25229$export$2e2bcd8739ae039 = $0bd0cbfae3c25229$var$node;
module.exports["default"] = $0bd0cbfae3c25229$export$2e2bcd8739ae039;

});

parcelRegister("jsqhm", function(module, exports) {
/**
 * Sanitizes an array of values by filtering out falsy values,
 * converting each remaining value to a string, and trimming whitespace.
 *
 * @param values - The array of values to sanitize.
 * @returns An array of trimmed string representations of the truthy input values.
 */ function $dd43fabe4f5ea840$var$sanitizeAaids(values) {
    return values.filter(Boolean).map(String).map((value)=>value.trim()).filter(Boolean);
}
function $dd43fabe4f5ea840$export$95bc0487f9b5188(fieldValue) {
    if (!fieldValue) return [];
    if (Array.isArray(fieldValue)) return $dd43fabe4f5ea840$var$sanitizeAaids(fieldValue);
    if (typeof fieldValue === 'string') {
        const trimmed = fieldValue.trim();
        if (!trimmed) return [];
        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) return $dd43fabe4f5ea840$var$sanitizeAaids(parsed);
            // If parsed is a string, treat as single value
            if (typeof parsed === 'string') return [
                parsed.trim()
            ].filter(Boolean);
        } catch  {
        // Not valid JSON, fallback below
        }
        // Fallback: treat as single AAID, or comma-separated list
        if (trimmed.includes(',')) return $dd43fabe4f5ea840$var$sanitizeAaids(trimmed.split(','));
        return [
            trimmed
        ];
    }
    // Fallback: stringify unknown types
    return [
        String(fieldValue)
    ].filter(Boolean);
}
module.exports["parseSuggestedAccountIds"] = $dd43fabe4f5ea840$export$95bc0487f9b5188;

});

parcelRegister("5FZpD", function(module, exports) {

var $k8Wet = parcelRequire("k8Wet");


var $cozmU = parcelRequire("cozmU");


var $isb4V = parcelRequire("isb4V");


var $eqEJl = parcelRequire("eqEJl");

function $23b4d7bfa310449e$var$normalizeAccountIds(ids) {
    return Array.from(new Set((ids ?? []).map(String).map((s)=>s.trim()).filter(Boolean))).sort();
}
// Check if the accountIds are already hydrated
function $23b4d7bfa310449e$var$isAlreadyHydrated(users, accountIds) {
    return users.length > 0 && accountIds.every((accountId)=>users.some((user)=>user.accountId === accountId && user.name));
}
function $23b4d7bfa310449e$export$f1de398e9368e7f1(suggestedAccountIds, shouldHydrate) {
    const environment = (0, $isb4V.useRelayEnvironment)();
    const [users, setUsers] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const accountIds = (0, $cozmU.useMemo)(()=>$23b4d7bfa310449e$var$normalizeAccountIds(suggestedAccountIds), [
        suggestedAccountIds
    ]);
    // accountIdsKey is used as a stable dependency for useEffect and request tracking.
    // This avoids infinite update loops caused by new array references on every render.
    const accountIdsKey = accountIds.join(',');
    const inFlightFor = (0, $cozmU.useRef)(null);
    const activeSubscription = (0, $cozmU.useRef)(null);
    const disposed = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        disposed.current = false;
        return ()=>{
            disposed.current = true;
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        };
    }, []);
    const resetState = (0, $cozmU.useCallback)(()=>{
        if (inFlightFor.current) {
            activeSubscription.current?.unsubscribe();
            activeSubscription.current = null;
            inFlightFor.current = null;
        }
        setUsers([]);
        setIsLoading(false);
        setError(null);
    }, []);
    // Cancel any previous in-flight request
    const cancelPreviousRequest = (0, $cozmU.useCallback)(()=>{
        if (activeSubscription.current) {
            activeSubscription.current.unsubscribe();
            activeSubscription.current = null;
        }
    }, []);
    // Cancel the subscription
    const cancelSubscription = (0, $cozmU.useCallback)((subscription, key)=>{
        if (activeSubscription.current === subscription) {
            subscription.unsubscribe();
            activeSubscription.current = null;
            if (inFlightFor.current === key) inFlightFor.current = null;
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (accountIds.length === 0 || !shouldHydrate) {
            resetState();
            return;
        }
        if ($23b4d7bfa310449e$var$isAlreadyHydrated(users, accountIds)) return; // already hydrated
        if (inFlightFor.current === accountIdsKey) return; // request already in flight for this set
        // cancel any previous in-flight subscription
        cancelPreviousRequest();
        inFlightFor.current = accountIdsKey;
        setIsLoading(true);
        setError(null);
        const subscription = (0, $eqEJl.fetchQuery)(environment, (0, $k8Wet.default), {
            accountIds: accountIds
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                if (disposed.current) return;
                if (inFlightFor.current !== accountIdsKey) return;
                const hydratedUsers = (response?.users ?? []).filter(Boolean).map((user)=>({
                        accountId: user?.accountId,
                        name: user?.name ?? null
                    }));
                setUsers(hydratedUsers);
                setIsLoading(false);
            },
            error: (error)=>{
                if (disposed.current) return;
                if (inFlightFor.current === accountIdsKey) {
                    setError(error);
                    setIsLoading(false);
                }
            },
            complete: ()=>{
                if (!disposed.current && inFlightFor.current === accountIdsKey) setIsLoading(false);
            }
        });
        activeSubscription.current = subscription;
        return ()=>cancelSubscription(subscription, accountIdsKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cancelPreviousRequest,
        cancelSubscription,
        environment,
        resetState,
        shouldHydrate,
        accountIdsKey
    ]);
    if (accountIds.length === 0 || !shouldHydrate) return null;
    return {
        users: users,
        isLoading: isLoading,
        error: error
    };
}
module.exports["useHydratedUsers"] = $23b4d7bfa310449e$export$f1de398e9368e7f1;

});

parcelRegister("c5P3M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $f854ace48e8ad26c$export$9756b64f930b5ec1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "users-field-skeleton",
            width: "250px",
            height: "16px",
            isShimmering: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        testId: "users-field-skeleton",
        width: "250px",
        height: "16px",
        isShimmering: true
    });
};
module.exports["UsersFieldSkeleton"] = $f854ace48e8ad26c$export$9756b64f930b5ec1;

});

parcelRegister("lLyfm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5HApy = parcelRequire("5HApy");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $3BY7M = parcelRequire("3BY7M");


var $6rwn6 = parcelRequire("6rwn6");

const $449f4fda7fea02e2$var$styles = {
    container: "_2mHwu8Pgdg _30huDKOeNX _0bjKvDKxmn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT",
    summary: "_2mHwu82ADO _3iDTPbccYA _0hPCNLDIqT _0Of8r28HPE _1ZnuxbkG2W _1wydGW8HPE _2Zuz6QkG2W",
    icon: "_3iDTPbccYA _1UtDYzZpcK",
    divider: "_2bqfgdOeNX",
    content: "_0Of8r28HPE _1ZnuxbkG2W _1wydGW8HPE _2Zuz6QkG2W"
};
const $449f4fda7fea02e2$export$72f2f0a72b7cde43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { icon: icon, title: title, description: description, testId: testId } = t0;
    if (!description) return null;
    let t1;
    if ($[0] !== icon) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $449f4fda7fea02e2$var$styles.icon
        }, icon);
        $[0] = icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, title);
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $449f4fda7fea02e2$var$styles.summary
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $449f4fda7fea02e2$var$styles.divider
        });
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== description) {
        t5 = (0, $6rwn6.encodeAdf)(description);
        $[8] = description;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $449f4fda7fea02e2$var$styles.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: t5
        })));
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6 || $[14] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $449f4fda7fea02e2$var$styles.container,
            testId: testId
        }, t3, t4, t6);
        $[12] = t3;
        $[13] = t6;
        $[14] = testId;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
} : ({ icon: icon, title: title, description: description, testId: testId })=>{
    if (!description) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $449f4fda7fea02e2$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $449f4fda7fea02e2$var$styles.summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $449f4fda7fea02e2$var$styles.icon
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $449f4fda7fea02e2$var$styles.divider
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $449f4fda7fea02e2$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: (0, $6rwn6.encodeAdf)(description)
    }))));
};
module.exports["AdditionalNoteBase"] = $449f4fda7fea02e2$export$72f2f0a72b7cde43;

});

parcelRegister("4qBrT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f3ac2edeee5cc6e8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moreDetail: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.more-detail.non-final",
        defaultMessage: "More detail"
    },
    newLearning: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.new-learning.non-final",
        defaultMessage: "New learning"
    },
    newRisk: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.new-risk.non-final",
        defaultMessage: "New risk"
    },
    newDecision: {
        id: "conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.new-decision.non-final",
        defaultMessage: "New decision"
    }
});
module.exports["messages"] = $f3ac2edeee5cc6e8$export$defe85febe8b728c;

});

parcelRegister("b8NXT", function(module, exports) {

var $3vMGL = parcelRequire("3vMGL");

// Matches a plain ISO date string without time information (YYYY-MM-DD)
const $402896c80f6bb16f$var$ISO_YMD_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;
function $402896c80f6bb16f$export$bea76c49158eff2b(isoDate, locale = 'en', confidence) {
    // For YYYY-MM-DD, construct a UTC midnight date; always format in UTC
    let date;
    const ymdMatch = $402896c80f6bb16f$var$ISO_YMD_REGEX.exec(isoDate);
    if (ymdMatch) {
        const year = Number(ymdMatch[1]);
        const monthZeroBased = Number(ymdMatch[2]) - 1;
        const day = Number(ymdMatch[3]);
        // Construct in UTC so local timezone won't shift the calendar day
        date = new Date(Date.UTC(year, monthZeroBased, day));
    } else // Fall back to built-in parsing for other date/time inputs
    date = new Date(isoDate);
    // If parsing failed, return the original input unchanged
    if (isNaN(date.getTime())) return isoDate;
    try {
        const dateYear = date.getUTCFullYear();
        const currentYear = new Date().getUTCFullYear();
        const includeYear = dateYear !== currentYear;
        if (confidence === 'MONTH') {
            // Month (long), optionally append year
            const l10n = (0, $3vMGL.createLocalizationProvider)(locale, {
                month: 'long',
                timeZone: 'UTC'
            });
            const parts = l10n.formatToParts(date);
            if (parts.month) return includeYear ? `${parts.month} ${dateYear}` : parts.month;
            return new Intl.DateTimeFormat(locale, {
                month: 'long',
                timeZone: 'UTC'
            }).format(date) + (includeYear ? ` ${dateYear}` : '');
        }
        if (confidence === 'QUARTER') {
            // Determine quarter bounds and show localized short month range
            const month = date.getUTCMonth(); // 0-11
            const quarter = Math.floor(month / 3); // 0-3
            const startMonth = quarter * 3;
            const endMonth = startMonth + 2;
            const startDate = new Date(Date.UTC(dateYear, startMonth, 1));
            const endDate = new Date(Date.UTC(dateYear, endMonth, 1));
            const l10n = (0, $3vMGL.createLocalizationProvider)(locale, {
                month: 'short',
                timeZone: 'UTC'
            });
            const startParts = l10n.formatToParts(startDate);
            const endParts = l10n.formatToParts(endDate);
            const startLabel = startParts.month || new Intl.DateTimeFormat(locale, {
                month: 'short',
                timeZone: 'UTC'
            }).format(startDate);
            const endLabel = endParts.month || new Intl.DateTimeFormat(locale, {
                month: 'short',
                timeZone: 'UTC'
            }).format(endDate);
            return includeYear ? `${startLabel}\u{2013}${endLabel} ${dateYear}` : `${startLabel}\u{2013}${endLabel}`;
        }
        // Default (DAY) -> show day short month, optionally append year
        const l10n = (0, $3vMGL.createLocalizationProvider)(locale, {
            day: 'numeric',
            month: 'short',
            timeZone: 'UTC'
        });
        const parts = l10n.formatToParts(date);
        if (parts.day && parts.month) return includeYear ? `${parts.day} ${parts.month} ${dateYear}` : `${parts.day} ${parts.month}`;
        return new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: 'short',
            timeZone: 'UTC'
        }).format(date) + (includeYear ? ` ${dateYear}` : '');
    } catch  {
        // Final fallback using toLocaleDateString in UTC
        return date.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC'
        });
    }
}
module.exports["formatDateForDisplay"] = $402896c80f6bb16f$export$bea76c49158eff2b;

});

parcelRegister("4IqDi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bcDqz = parcelRequire("bcDqz");

const $11230e1ca0cdcea3$var$MAX_AVATAR_DISPLAY_COUNT = 5;
const $11230e1ca0cdcea3$export$8c952844d253645a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { members: members } = t0;
    if (members.length === 0) return null;
    let t1;
    if ($[0] !== members) {
        t1 = members.map($11230e1ca0cdcea3$var$_temp);
        $[0] = members;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== members.length) {
        t2 = members.length > $11230e1ca0cdcea3$var$MAX_AVATAR_DISPLAY_COUNT ? {
            MoreIndicator: {
                render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...props,
                        count: members.length - $11230e1ca0cdcea3$var$MAX_AVATAR_DISPLAY_COUNT + 1
                    })
            }
        } : undefined;
        $[2] = members.length;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
            size: "small",
            appearance: "stack",
            data: t1,
            overrides: t2
        });
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ members: members })=>{
    if (members.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        size: "small",
        appearance: "stack",
        data: members.map((member)=>({
                key: member.accountId,
                name: member.name,
                src: member.picture ?? undefined
            })),
        overrides: members.length > $11230e1ca0cdcea3$var$MAX_AVATAR_DISPLAY_COUNT ? {
            MoreIndicator: {
                render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...props,
                        count: members.length - $11230e1ca0cdcea3$var$MAX_AVATAR_DISPLAY_COUNT + 1
                    })
            }
        } : undefined
    });
};
function $11230e1ca0cdcea3$var$_temp(member) {
    return {
        key: member.accountId,
        name: member.name,
        src: member.picture ?? undefined
    };
}
module.exports["TeamMembersAvatarGroup"] = $11230e1ca0cdcea3$export$8c952844d253645a;

});

parcelRegister("gKdbs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $95hQj = parcelRequire("95hQj");

const $f42494994ab28aa4$export$c89d4b0890a242f4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { links: links, onChange: onChange } = t0;
    const [isEditorOpen, setIsEditorOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isEditorOpen || $[1] !== links || $[2] !== onChange) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $95hQj.FocusAskLinksSection), {
            links: links,
            onChange: onChange,
            isEditorOpen: isEditorOpen,
            onEditorOpenChange: setIsEditorOpen
        });
        $[0] = isEditorOpen;
        $[1] = links;
        $[2] = onChange;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ links: links, onChange: onChange })=>{
    const [isEditorOpen, setIsEditorOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $95hQj.FocusAskLinksSection), {
        links: links,
        onChange: onChange,
        isEditorOpen: isEditorOpen,
        onEditorOpenChange: setIsEditorOpen
    });
};
module.exports["LinksField"] = $f42494994ab28aa4$export$c89d4b0890a242f4;

});

parcelRegister("2tueL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lF9wS = parcelRequire("lF9wS");


var $dUI0h = parcelRequire("dUI0h");


var $iMnC5 = parcelRequire("iMnC5");


var $1TlML = parcelRequire("1TlML");


var $7LV0V = parcelRequire("7LV0V");


var $79yHm = parcelRequire("79yHm");

const $460d6e788b116ff5$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function $460d6e788b116ff5$var$toPickerValue(raw) {
    const trimmed = raw.trim();
    if (!trimmed) return undefined;
    return $460d6e788b116ff5$var$ISO_DATE.test(trimmed) ? trimmed : undefined;
}
/** Local calendar day as YYYY-MM-DD (DatePicker `minDate` / `maxDate` contract). */ function $460d6e788b116ff5$var$formatLocalIsoDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
const $460d6e788b116ff5$var$styles = {
    fullWidth: "_39xV02N91d"
};
const $460d6e788b116ff5$export$ae74b42c274d850c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { value: value, onChange: onChange, hideLabel: t1, isCompact: t2, fieldId: t3, isDisabled: t4, appearance: appearance } = t0;
    const hideLabel = t1 === undefined ? false : t1;
    const isCompact = t2 === undefined ? false : t2;
    const fieldId = t3 === undefined ? "focus-ask-target-date-field" : t3;
    const isDisabled = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== formatMessage) {
        t5 = formatMessage((0, $79yHm.default).targetDateFieldLabel);
        $[0] = formatMessage;
        $[1] = t5;
    } else t5 = $[1];
    const labelText = t5;
    const t6 = `${fieldId}-input`;
    let t7;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = $460d6e788b116ff5$var$formatLocalIsoDate(new Date());
        $[2] = t7;
    } else t7 = $[2];
    let t8;
    if ($[3] !== value.targetDate) {
        t8 = $460d6e788b116ff5$var$toPickerValue(value.targetDate);
        $[3] = value.targetDate;
        $[4] = t8;
    } else t8 = $[4];
    let t9;
    if ($[5] !== onChange) {
        t9 = (v)=>onChange(v ? {
                targetDate: (0, $7LV0V.parseStringToIsoDay)(v),
                targetDateType: "DAY"
            } : {
                targetDate: ""
            });
        $[5] = onChange;
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] !== formatMessage) {
        t10 = formatMessage((0, $79yHm.default).targetDatePickerClear);
        $[7] = formatMessage;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== formatMessage) {
        t11 = formatMessage((0, $79yHm.default).targetDatePickerOpenCalendar);
        $[9] = formatMessage;
        $[10] = t11;
    } else t11 = $[10];
    const t12 = isCompact ? "compact" : "default";
    let t13;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {
            styles: (0, $1TlML.mergeStyles)({
                container: $460d6e788b116ff5$var$_temp
            })
        };
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== appearance || $[13] !== fieldId || $[14] !== isDisabled || $[15] !== labelText || $[16] !== locale || $[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t6 || $[21] !== t8 || $[22] !== t9) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $460d6e788b116ff5$var$styles.fullWidth
        }, /*#__PURE__*/ $cozmU.createElement((0, $lF9wS.default), {
            id: t6,
            testId: fieldId,
            locale: locale,
            minDate: t7,
            value: t8,
            onChange: t9,
            clearControlLabel: t10,
            shouldShowCalendarButton: true,
            label: labelText,
            inputLabel: labelText,
            openCalendarLabel: t11,
            spacing: t12,
            isDisabled: isDisabled,
            appearance: appearance,
            selectProps: t13
        }));
        $[12] = appearance;
        $[13] = fieldId;
        $[14] = isDisabled;
        $[15] = labelText;
        $[16] = locale;
        $[17] = t10;
        $[18] = t11;
        $[19] = t12;
        $[20] = t6;
        $[21] = t8;
        $[22] = t9;
        $[23] = t14;
    } else t14 = $[23];
    const datePicker = t14;
    if (hideLabel) return datePicker;
    let t15;
    if ($[24] !== datePicker) {
        t15 = ()=>datePicker;
        $[24] = datePicker;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== labelText || $[27] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: "targetDate",
            label: labelText
        }, t15);
        $[26] = labelText;
        $[27] = t15;
        $[28] = t16;
    } else t16 = $[28];
    return t16;
} : ({ value: value, onChange: onChange, hideLabel: hideLabel = false, isCompact: isCompact = false, fieldId: fieldId = 'focus-ask-target-date-field', isDisabled: isDisabled = false, appearance: appearance })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const labelText = formatMessage((0, $79yHm.default).targetDateFieldLabel);
    const datePicker = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $460d6e788b116ff5$var$styles.fullWidth
    }, /*#__PURE__*/ $cozmU.createElement((0, $lF9wS.default), {
        id: `${fieldId}-input`,
        testId: fieldId,
        locale: locale,
        minDate: $460d6e788b116ff5$var$formatLocalIsoDate(new Date()),
        value: $460d6e788b116ff5$var$toPickerValue(value.targetDate),
        onChange: (v)=>onChange(v ? {
                targetDate: (0, $7LV0V.parseStringToIsoDay)(v),
                targetDateType: 'DAY'
            } : {
                targetDate: ''
            }),
        clearControlLabel: formatMessage((0, $79yHm.default).targetDatePickerClear),
        shouldShowCalendarButton: true,
        label: labelText,
        inputLabel: labelText,
        openCalendarLabel: formatMessage((0, $79yHm.default).targetDatePickerOpenCalendar),
        spacing: isCompact ? 'compact' : 'default',
        isDisabled: isDisabled,
        appearance: appearance,
        selectProps: {
            styles: (0, $1TlML.mergeStyles)({
                container: (provided)=>({
                        ...provided,
                        width: '100%'
                    })
            })
        }
    }));
    if (hideLabel) return datePicker;
    return /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
        name: "targetDate",
        label: labelText
    }, ()=>datePicker);
};
function $460d6e788b116ff5$var$_temp(provided) {
    return {
        ...provided,
        width: "100%"
    };
}
module.exports["TargetDateField"] = $460d6e788b116ff5$export$ae74b42c274d850c;

});

parcelRegister("icFc2", function(module, exports) {

var $7NH0n = parcelRequire("7NH0n");

const $b14b8956ef8242f5$export$d5bb28e0dea851e7 = (doc)=>{
    // Treat an empty or whitespace-only document as no value, so a comment /
    // description / justification made of only spaces is never stored.
    if (!doc?.content?.length || (0, $7NH0n.isEditorDocumentEmpty)(doc)) return '';
    return JSON.stringify(doc);
};
module.exports["serializeEditorDocument"] = $b14b8956ef8242f5$export$d5bb28e0dea851e7;

});

parcelRegister("lNNC4", function(module, exports) {

var $kIlwI = parcelRequire("kIlwI");

const $8c9cfa36ca402c76$export$73effb48743ae2f8 = (url)=>(0, $kIlwI.isValidUrl)(url);
module.exports["isValidImpactedWorkUrl"] = $8c9cfa36ca402c76$export$73effb48743ae2f8;

});

parcelRegister("cwf0p", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $5SS4O = parcelRequire("5SS4O");


var $haiCi = parcelRequire("haiCi");


var $lNNC4 = parcelRequire("lNNC4");

/**
 * AGG node query: resolves an ARI to its web URL.
 * Supports JiraIssue (webUrl), TownsquareProject (url), JiraAlignAggProject (mercuryProjectUrl).
 */ const $ee5b78f4c00141f8$var$RESOLVE_ARI_TO_URL_QUERY = `
	query useResolveImpactedWorkInput($ari: ID!) {
		node(id: $ari) {
			id
			__typename
			... on JiraIssue {
				webUrl
			}
			... on TownsquareProject {
				url
			}
			... on JiraAlignAggProject {
				mercuryProjectUrl
			}
		}
	}
`;
const $ee5b78f4c00141f8$export$3b69f4d752179f49 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { ari: ari, link: link } = t0;
    const t1 = link ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $lNNC4.isValidImpactedWorkUrl)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const useLinkPath = t2;
    const useAriPath = !useLinkPath && !!ari;
    const t3 = link ?? "";
    let t4;
    if ($[2] !== t3) {
        t4 = [
            "impacted-work-resolver",
            t3
        ];
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== link) {
        t5 = async ()=>{
            const response = await fetch("/gateway/api/object-resolver/resolve", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    resourceUrl: link
                })
            });
            if (response.status === 404) throw new Error("Object resolver returned 404");
            if (!response.ok) throw new Error(`${response.status}: Failed to resolve impacted work`);
            const json = await response.json();
            if (json.meta?.access !== "granted") throw new Error("Access denied");
            return json;
        };
        $[4] = link;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t4 || $[7] !== t5 || $[8] !== useLinkPath) {
        t6 = {
            queryKey: t4,
            enabled: useLinkPath,
            queryFn: t5
        };
        $[6] = t4;
        $[7] = t5;
        $[8] = useLinkPath;
        $[9] = t6;
    } else t6 = $[9];
    const { data: urlData, isFetching: urlFetching, error: urlError } = (0, $5SS4O.useQuery)(t6);
    const t7 = ari ?? "";
    let t8;
    if ($[10] !== t7) {
        t8 = [
            "focus-ask-resolve-ari-to-url",
            t7
        ];
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== ari) {
        t9 = ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $ee5b78f4c00141f8$var$RESOLVE_ARI_TO_URL_QUERY,
                variables: {
                    ari: ari ?? ""
                }
            });
        $[12] = ari;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t8 || $[15] !== t9 || $[16] !== useAriPath) {
        t10 = {
            queryKey: t8,
            enabled: useAriPath,
            queryFn: t9
        };
        $[14] = t8;
        $[15] = t9;
        $[16] = useAriPath;
        $[17] = t10;
    } else t10 = $[17];
    const { data: ariData, isFetching: ariFetching, error: ariError } = (0, $5SS4O.useQuery)(t10);
    if (useLinkPath) {
        const t11 = urlData?.data?.["atlassian:ari"] ?? null;
        const t12 = urlData?.data?.url ?? null;
        let t13;
        if ($[18] !== t11 || $[19] !== t12 || $[20] !== urlError || $[21] !== urlFetching) {
            t13 = {
                ari: t11,
                link: t12,
                isFetching: urlFetching,
                error: urlError
            };
            $[18] = t11;
            $[19] = t12;
            $[20] = urlError;
            $[21] = urlFetching;
            $[22] = t13;
        } else t13 = $[22];
        return t13;
    }
    if (useAriPath) {
        const node = ariData?.data?.node;
        const resolvedUrl = node?.webUrl ?? node?.url ?? node?.mercuryProjectUrl ?? null;
        const t11 = ari ?? null;
        const t12 = ariError ?? null;
        let t13;
        if ($[23] !== ariFetching || $[24] !== resolvedUrl || $[25] !== t11 || $[26] !== t12) {
            t13 = {
                ari: t11,
                link: resolvedUrl,
                isFetching: ariFetching,
                error: t12
            };
            $[23] = ariFetching;
            $[24] = resolvedUrl;
            $[25] = t11;
            $[26] = t12;
            $[27] = t13;
        } else t13 = $[27];
        return t13;
    }
    let t11;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            ari: null,
            link: null,
            isFetching: false,
            error: null
        };
        $[28] = t11;
    } else t11 = $[28];
    return t11;
} : ({ ari: ari, link: link })=>{
    const useLinkPath = (0, $lNNC4.isValidImpactedWorkUrl)(link ?? '');
    const useAriPath = !useLinkPath && !!ari;
    // Link path: resolve URL → ARI + link via object-resolver.
    const { data: urlData, isFetching: urlFetching, error: urlError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'impacted-work-resolver',
            link ?? ''
        ],
        enabled: useLinkPath,
        queryFn: async ()=>{
            const response = await fetch('/gateway/api/object-resolver/resolve', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    resourceUrl: link
                })
            });
            if (response.status === 404) throw new Error('Object resolver returned 404');
            if (!response.ok) throw new Error(`${response.status}: Failed to resolve impacted work`);
            const json = await response.json();
            if (json.meta?.access !== 'granted') throw new Error('Access denied');
            return json;
        }
    });
    // ARI path: resolve ARI → URL via AGG node query.
    const { data: ariData, isFetching: ariFetching, error: ariError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'focus-ask-resolve-ari-to-url',
            ari ?? ''
        ],
        enabled: useAriPath,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $ee5b78f4c00141f8$var$RESOLVE_ARI_TO_URL_QUERY,
                variables: {
                    ari: ari ?? ''
                }
            })
    });
    if (useLinkPath) return {
        ari: urlData?.data?.['atlassian:ari'] ?? null,
        link: urlData?.data?.url ?? null,
        isFetching: urlFetching,
        error: urlError
    };
    if (useAriPath) {
        const node = ariData?.data?.node;
        const resolvedUrl = node?.webUrl ?? node?.url ?? node?.mercuryProjectUrl ?? null;
        return {
            ari: ari ?? null,
            link: resolvedUrl,
            isFetching: ariFetching,
            error: ariError ?? null
        };
    }
    return {
        ari: null,
        link: null,
        isFetching: false,
        error: null
    };
};
module.exports["useResolveImpactedWorkInput"] = $ee5b78f4c00141f8$export$3b69f4d752179f49;

});

parcelRegister("2a8RQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kIlwI = parcelRequire("kIlwI");


var $hZpNo = parcelRequire("hZpNo");


var $hEzMq = parcelRequire("hEzMq");


var $b1qeE = parcelRequire("b1qeE");

const $b06cae1d0089f1ad$export$7fd113f72ad35357 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (ari, currentCloudId, link)=>{
    const $ = (0, $bDgLe.c)(1);
    const jiraResult = (0, $hEzMq.useValidateJiraIssueAri)(ari, currentCloudId);
    const townsquareResult = (0, $b1qeE.useValidateTownsquareProjectAri)(ari);
    const jiraAlignResult = (0, $hZpNo.useValidateJiraAlignProjectAri)(ari, currentCloudId, link);
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    if (parsed?.resourceOwner === "jira" && parsed?.resourceType === "issue") return jiraResult;
    if (parsed?.resourceOwner === "townsquare" && parsed?.resourceType === "project") return townsquareResult;
    if (parsed?.resourceOwner === "jira-align" && parsed?.resourceType === "project") return jiraAlignResult;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            status: "notFound"
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (ari, currentCloudId, link)=>{
    const jiraResult = (0, $hEzMq.useValidateJiraIssueAri)(ari, currentCloudId);
    const townsquareResult = (0, $b1qeE.useValidateTownsquareProjectAri)(ari);
    const jiraAlignResult = (0, $hZpNo.useValidateJiraAlignProjectAri)(ari, currentCloudId, link);
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    if (parsed?.resourceOwner === 'jira' && parsed?.resourceType === 'issue') return jiraResult;
    if (parsed?.resourceOwner === 'townsquare' && parsed?.resourceType === 'project') return townsquareResult;
    if (parsed?.resourceOwner === 'jira-align' && parsed?.resourceType === 'project') return jiraAlignResult;
    return {
        status: 'notFound'
    };
};
module.exports["useValidateImpactedWorkAri"] = $b06cae1d0089f1ad$export$7fd113f72ad35357;

});

parcelRegister("737YC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");

const $a2e864741bb4fb99$var$styles = {
    statusWrapperStylesFullWidth: "_30huDKOeNX _0bjKvDKxmn _1Znuxb1Y8M _2Zuz6Q1Y8M _39xV02E6Kk _0jFU0VoWWg",
    statusWrapper: "_30huDKOeNX _0bjKvDKxmn _1Znuxb1Y8M _2Zuz6Q1Y8M _39xV02gZxp _0jFU0VoWWg",
    pressable: "_0bjKvDKxmn _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXru66of _1eOmH6o126",
    disabled: "_1YKVNsVx3j"
};
const $a2e864741bb4fb99$export$22baa1361f64e591 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { icon: icon, content: content, fullWidth: fullWidth, testId: testId, onClick: onClick, isDisabledOpacity: t1 } = t0;
    const isDisabledOpacity = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== content || $[1] !== fullWidth || $[2] !== icon || $[3] !== isDisabledOpacity || $[4] !== testId) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center",
                xcss: (0, $w6R6I.cx)(fullWidth ? $a2e864741bb4fb99$var$styles.statusWrapperStylesFullWidth : $a2e864741bb4fb99$var$styles.statusWrapper, isDisabledOpacity && $a2e864741bb4fb99$var$styles.disabled),
                testId: testId
            }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                maxLines: 1
            }, content));
        $[0] = content;
        $[1] = fullWidth;
        $[2] = icon;
        $[3] = isDisabledOpacity;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    const renderContent = t2;
    if (onClick) {
        let t3;
        if ($[6] !== renderContent) {
            t3 = renderContent();
            $[6] = renderContent;
            $[7] = t3;
        } else t3 = $[7];
        let t4;
        if ($[8] !== onClick || $[9] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                onClick: onClick,
                xcss: $a2e864741bb4fb99$var$styles.pressable
            }, t3);
            $[8] = onClick;
            $[9] = t3;
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
    let t3;
    if ($[11] !== renderContent) {
        t3 = renderContent();
        $[11] = renderContent;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ icon: icon, content: content, fullWidth: fullWidth, testId: testId, onClick: onClick, isDisabledOpacity: isDisabledOpacity = false })=>{
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            xcss: (0, $w6R6I.cx)(fullWidth ? $a2e864741bb4fb99$var$styles.statusWrapperStylesFullWidth : $a2e864741bb4fb99$var$styles.statusWrapper, isDisabledOpacity && $a2e864741bb4fb99$var$styles.disabled),
            testId: testId
        }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, content));
    };
    if (onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onClick,
        xcss: $a2e864741bb4fb99$var$styles.pressable
    }, renderContent());
    return renderContent();
};
module.exports["InlineIconText"] = $a2e864741bb4fb99$export$22baa1361f64e591;

});

parcelRegister("a6w1L", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ieqKY = parcelRequire("ieqKY");


var $kPcTY = parcelRequire("kPcTY");


var $1zBKt = parcelRequire("1zBKt");

const $94f0346251095bc2$export$71a931ad123ef84c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { build: build, index: index } = t0;
    switch(build.type){
        case "AUTOMATION_RULE":
            {
                let t1;
                if ($[0] !== index) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zBKt.AutomationBuildTabIcon), {
                        index: index
                    });
                    $[0] = index;
                    $[1] = t1;
                } else t1 = $[1];
                return t1;
            }
        case "ECOSYSTEM_APP":
            {
                let t1;
                if ($[2] !== index) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kPcTY.AppBuildTabIcon), {
                        index: index
                    });
                    $[2] = index;
                    $[3] = t1;
                } else t1 = $[3];
                return t1;
            }
        case "ROVO_AGENT":
            {
                let t1;
                if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ieqKY.AgentBuildTabIcon), null);
                    $[4] = t1;
                } else t1 = $[4];
                return t1;
            }
    }
} : ({ build: build, index: index })=>{
    switch(build.type){
        case 'AUTOMATION_RULE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zBKt.AutomationBuildTabIcon), {
                index: index
            });
        case 'ECOSYSTEM_APP':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kPcTY.AppBuildTabIcon), {
                index: index
            });
        case 'ROVO_AGENT':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ieqKY.AgentBuildTabIcon), null);
    }
};
module.exports["BuildTabIcon"] = $94f0346251095bc2$export$71a931ad123ef84c;

});

parcelRegister("4vdac", function(module, exports) {
/**
 * @generated SignedSource<<a91bc638dac771ab3c4c7fa068ffe5e5>>
 * @relayHash 68adab032e8f566c79f381dd7ea1152e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b41c128f2ce78a777b61640a63f0abb1a5625097c0df6df38a2c7474b995e75a
const $76a01642c3b5c439$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "footerActions_AtlassianAtlassianStudioQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianStudio_userSiteContext",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "footerActions_AtlassianAtlassianStudioQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianStudio_userSiteContext",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b41c128f2ce78a777b61640a63f0abb1a5625097c0df6df38a2c7474b995e75a",
            "metadata": {},
            "name": "footerActions_AtlassianAtlassianStudioQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$76a01642c3b5c439$var$node.hash = "8c2f231f9c12b50ac95db455099ffc3d";
var $76a01642c3b5c439$export$2e2bcd8739ae039 = $76a01642c3b5c439$var$node;
module.exports["default"] = $76a01642c3b5c439$export$2e2bcd8739ae039;

});

parcelRegister("if0Cf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");


var $lzU6z = parcelRequire("lzU6z");


var $7txt6 = parcelRequire("7txt6");


var $avyk4 = parcelRequire("avyk4");

const $1c1079395e26a6fb$export$cfc7921d29ef7b80 = ({ build: build, children: children, isComingSoon: isComingSoon, isDisabled: isDisabled = false, ...props })=>{
    (0, $6cFsl.di)((0, $7txt6.useSolutionPlan));
    const { builds: builds, solutionState: solutionState } = (0, $7txt6.useSolutionPlan)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isDisabled: isDisabled || isComingSoon || !(0, $lzU6z.isBuildEnabled)(build, builds) || solutionState === 'DISABLED',
        ...props
    }, children, isComingSoon && ` (${formatMessage((0, $avyk4.messages).comingSoonTagLabel)})`);
};
module.exports["ActionButton"] = $1c1079395e26a6fb$export$cfc7921d29ef7b80;

});

parcelRegister("hS6Fc", function(module, exports) {

var $dfsz1 = parcelRequire("dfsz1");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $4MnFz = parcelRequire("4MnFz");


var $5avUB = parcelRequire("5avUB");


var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");


var $hdBxM = parcelRequire("hdBxM");


var $d6044 = parcelRequire("d6044");


var $fa8WQ = parcelRequire("fa8WQ");


var $hlvTd = parcelRequire("hlvTd");


var $kuIhJ = parcelRequire("kuIhJ");


var $isp1U = parcelRequire("isp1U");


var $l3JZO = parcelRequire("l3JZO");


var $lzU6z = parcelRequire("lzU6z");


var $7txt6 = parcelRequire("7txt6");


var $jfauV = parcelRequire("jfauV");

const $03fa71caeeb1ec14$var$noopMutation = ()=>({
        dispose: ()=>{}
    });
const $03fa71caeeb1ec14$var$useMutation = (0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)('fe_enable_sa_externally'), (0, $6SsN4.useMutation), ()=>[
        $03fa71caeeb1ec14$var$noopMutation,
        false
    ]);
const $03fa71caeeb1ec14$var$noopMutationOld = async ()=>undefined;
const $03fa71caeeb1ec14$var$useMutationOldGated = (0, $2zVsi.functionWithCondition)(()=>!(0, $iDrrr.fg)('fe_enable_sa_externally'), (...args)=>{
    (0, $6cFsl.di)();
    return (0, $kuIhJ.useMutation)(...args);
}, ()=>({
        mutate: $03fa71caeeb1ec14$var$noopMutationOld,
        isSubmitting: false,
        data: null,
        error: null
    }));
const $03fa71caeeb1ec14$export$c00a69f0d67109ed = (build, options)=>{
    (0, $6cFsl.di)((0, $hdBxM.usePublish));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { refetchSolutionPlan: refetchSolutionPlan, workspaceId: workspaceIdNew, cloudId: cloudId, renderingTouchpoint: renderingTouchpoint } = (0, $7txt6.useSolutionPlan)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { email: email } = (0, $isp1U.useProfileController)();
    const { solutionId: solutionId, solutionVersion: solutionVersion, number: buildNumber } = build;
    const workspaceIdOld = (0, $lzU6z.getWorkspaceIdFromUrl)();
    const workspaceId = (0, $iDrrr.fg)('fe_enable_sa_externally') ? workspaceIdNew : workspaceIdOld;
    const [mutate, isSubmittingNew] = $03fa71caeeb1ec14$var$useMutation((0, $dfsz1.default));
    const { isSubmitting: isSubmittingOld, mutate: mutateOld } = $03fa71caeeb1ec14$var$useMutationOldGated({
        mutationFn: ()=>(0, $l3JZO.postSolutionBuild)(workspaceId ?? '', solutionId, solutionVersion, buildNumber),
        onSuccess: (solutionBuildResponse)=>{
            const payload = {
                type: 'solution-architect-handoff',
                source: 'ai-mate',
                data: options.handoffPayloadDataFactory(solutionBuildResponse)
            };
            if (renderingTouchpoint !== 'studio' && (0, $iDrrr.fg)('fe_enable_sa_externally')) {
                // When action trigger outside of studio, we will open a new tab to the solution build in studio.
                const publishTrigger = btoa(JSON.stringify(payload));
                const path = `/w/${workspaceId}/landing`;
                const url = new URL((0, $fa8WQ.getStudioPath)(path, email));
                url.searchParams.set('publishTrigger', publishTrigger);
                window.open(url.toString(), '_blank');
                return;
            }
            publish(payload);
            refetchSolutionPlan();
            options.onSuccessCallback?.(solutionBuildResponse);
        },
        onError: (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: 'studio-trigger-solution-build-action-button-error'
            });
            const backendMessage = error.errorAttributes.rawErrorMessage;
            const shouldShowBackendMessage = backendMessage && (error.errorAttributes.statusCode === 429 || error.errorAttributes.statusCode === 403);
            showFlag({
                title: formatMessage((0, $jfauV.messages).solutionBuildErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                }),
                description: shouldShowBackendMessage ? backendMessage : formatMessage((0, $jfauV.messages).solutionBuildErrorDescription),
                isAutoDismiss: true
            });
        }
    });
    const triggerError = (0, $cozmU.useCallback)((error_0)=>{
        if (!(0, $iDrrr.fg)('fe_enable_sa_externally')) return;
        (0, $hlvTd.logException)({
            exception: error_0,
            name: 'studio-trigger-solution-build-action-button-error'
        });
        showFlag({
            title: formatMessage((0, $jfauV.messages).solutionBuildErrorTitle),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
            description: formatMessage((0, $jfauV.messages).solutionBuildErrorDescription),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const startHandoff = (0, $cozmU.useCallback)(()=>{
        if (!(0, $iDrrr.fg)('fe_enable_sa_externally')) return mutateOld(undefined);
        const workspaceAri = (0, $d6044.StudioWorkspaceAri).create({
            workspaceId: workspaceId ?? ''
        }).toString();
        return mutate({
            variables: {
                input: {
                    solutionId: solutionId,
                    solutionVersion: Number(solutionVersion),
                    buildNumber: buildNumber,
                    workspaceId: workspaceAri
                },
                skip: !workspaceId
            },
            onError: triggerError,
            onCompleted: (response, errors)=>{
                if (errors && errors.length > 0) return triggerError(errors[0]);
                const solutionBuildResponse_0 = response?.studio_createDraftBuild?.build;
                const isBuildResponseValid = (data)=>!!(data?.state && data?.type);
                if (!isBuildResponseValid(solutionBuildResponse_0)) return triggerError(new Error('No build information returned from server'));
                const payload_0 = {
                    type: 'solution-architect-handoff',
                    source: 'ai-mate',
                    data: options.handoffPayloadDataFactory(solutionBuildResponse_0)
                };
                if (renderingTouchpoint !== 'studio') {
                    // When triggered outside of studio, navigate to the
                    // solution build in studio. The same-tab navigation path
                    // (gated on `sltns-1069-popup-blocked-bug-fix`) avoids the
                    // browser's popup blocker, which rejects the new-tab
                    // `window.open` call once the click's transient
                    // user-activation has expired during the async mutation.
                    const publishTrigger_0 = btoa(JSON.stringify(payload_0));
                    const path_0 = `/w/${workspaceId}/landing`;
                    let handoffUrl;
                    const url_0 = new URL((0, $fa8WQ.getStudioPath)(path_0, email));
                    url_0.searchParams.set('publishTrigger', publishTrigger_0);
                    url_0.searchParams.set('siteId', cloudId);
                    handoffUrl = url_0.toString();
                    if ((0, $iDrrr.fg)('sltns-1069-popup-blocked-bug-fix')) window.location.assign(handoffUrl);
                    else window.open(handoffUrl, '_blank');
                    return;
                }
                publish(payload_0);
                refetchSolutionPlan();
                options.onSuccessCallback?.(solutionBuildResponse_0);
            }
        });
    }, [
        cloudId,
        mutate,
        solutionId,
        solutionVersion,
        buildNumber,
        workspaceId,
        renderingTouchpoint,
        email,
        refetchSolutionPlan,
        options,
        publish,
        triggerError,
        mutateOld
    ]);
    const isSubmitting = (0, $iDrrr.fg)('fe_enable_sa_externally') ? isSubmittingNew : isSubmittingOld;
    return {
        isSubmitting: isSubmitting,
        startHandoff: startHandoff
    };
};
module.exports["useHandoffAction"] = $03fa71caeeb1ec14$export$c00a69f0d67109ed;

});

parcelRegister("2bqQJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $964e445ff87f918e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    permissionDeniedTooltip: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.permission-denied-tooltip",
        defaultMessage: "You may not have the correct permission to create this solution"
    }
});
module.exports["messages"] = $964e445ff87f918e$export$defe85febe8b728c;

});

parcelRegister("j9ZfO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $347e4220e38afa0f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    buildAgentButtonLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-agent-button-label",
        defaultMessage: "Build agent"
    },
    activateAgentButtonLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.activate-agent-button-label",
        defaultMessage: "Activate agent"
    },
    publishAgentButtonLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.publish-agent-button-label",
        defaultMessage: "Publish agent"
    }
});
module.exports["messages"] = $347e4220e38afa0f$export$defe85febe8b728c;

});

parcelRegister("k6kJT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gFCxl = parcelRequire("gFCxl");

parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");

var $7f5e0741c73dfc91$var$WorkspacePermission = /*#__PURE__*/ function(WorkspacePermission) {
    WorkspacePermission["manageAutomation"] = "workspace/manage-automation";
    WorkspacePermission["manageApp"] = "workspace/manage-app";
    return WorkspacePermission;
}($7f5e0741c73dfc91$var$WorkspacePermission || {});
const $7f5e0741c73dfc91$var$getBulkPermittedVariables = (workspaceId, spaceId, accountId)=>{
    const principalId = `ari:cloud:identity::user/${accountId}`;
    const resourceId = `ari:cloud:studio::space/${workspaceId}/${spaceId}`;
    const permissionIds = [
        "workspace/manage-app",
        "workspace/manage-automation"
    ];
    return {
        principalIds: [
            principalId,
            principalId
        ],
        resourceIds: [
            resourceId,
            resourceId
        ],
        permissionIds: permissionIds,
        dontRequirePrincipalsInSite: [
            true,
            true
        ],
        skip: !workspaceId || !spaceId || !accountId
    };
};
const $7f5e0741c73dfc91$var$isPermissionPermitted = (permittedResults, permissionId)=>permittedResults?.some((result)=>result?.permissionId === permissionId && result?.permitted === true) ?? false;
const $7f5e0741c73dfc91$export$2497a61d08ee1154 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { workspaceId: workspaceId, spaceId: spaceId, accountId: accountId, children: children } = t0;
    const t1 = accountId ?? "";
    let t2;
    if ($[0] !== spaceId || $[1] !== t1 || $[2] !== workspaceId) {
        t2 = $7f5e0741c73dfc91$var$getBulkPermittedVariables(workspaceId, spaceId, t1);
        $[0] = spaceId;
        $[1] = t1;
        $[2] = workspaceId;
        $[3] = t2;
    } else t2 = $[3];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $gFCxl.default), t2);
    let t3;
    if ($[4] !== children || $[5] !== data.bulkPermitted) {
        const permissions = {
            manageAutomation: $7f5e0741c73dfc91$var$isPermissionPermitted(data.bulkPermitted, "workspace/manage-automation"),
            manageApp: $7f5e0741c73dfc91$var$isPermissionPermitted(data.bulkPermitted, "workspace/manage-app")
        };
        t3 = children({
            permissions: permissions
        });
        $[4] = children;
        $[5] = data.bulkPermitted;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ workspaceId: workspaceId, spaceId: spaceId, accountId: accountId, children: children })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $gFCxl.default), $7f5e0741c73dfc91$var$getBulkPermittedVariables(workspaceId, spaceId, accountId ?? ''));
    const permissions = {
        manageAutomation: $7f5e0741c73dfc91$var$isPermissionPermitted(data.bulkPermitted, "workspace/manage-automation"),
        manageApp: $7f5e0741c73dfc91$var$isPermissionPermitted(data.bulkPermitted, "workspace/manage-app")
    };
    return children({
        permissions: permissions
    });
};
module.exports["WorkspacePermissionsProvider"] = $7f5e0741c73dfc91$export$2497a61d08ee1154;

});

parcelRegister("6OT4g", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $5SS4O = parcelRequire("5SS4O");

var $31f40a2ab07c1111$var$WorkspacePermission = /*#__PURE__*/ function(WorkspacePermission) {
    WorkspacePermission["manageAutomation"] = "workspace/manage-automation";
    WorkspacePermission["manageApp"] = "workspace/manage-app";
    return WorkspacePermission;
}($31f40a2ab07c1111$var$WorkspacePermission || {});
const $31f40a2ab07c1111$var$fetchOrgContextData = async (workspaceId)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/context`);
    if (!response.ok) throw new Error('Failed to fetch studio workspace context data');
    return response.json();
};
const $31f40a2ab07c1111$export$8a2edc7baa49110 = (workspaceId)=>{
    (0, $6cFsl.di)((0, $5SS4O.useQuery));
    const { data: data, isFetching: loading } = (0, $5SS4O.useQuery)({
        queryKey: [
            'workspacePermissions',
            workspaceId
        ],
        queryFn: ()=>$31f40a2ab07c1111$var$fetchOrgContextData(workspaceId),
        enabled: !!workspaceId
    });
    const permissions = {
        manageAutomation: data?.permissions.includes("workspace/manage-automation") ?? false,
        manageApp: data?.permissions.includes("workspace/manage-app") ?? false
    };
    return {
        permissions: permissions,
        loading: loading
    };
};
module.exports["useLegacyWorkspacePermissions"] = $31f40a2ab07c1111$export$8a2edc7baa49110;

});

parcelRegister("hVeqT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $91660d228c212368$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    buildAppButtonLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-app-button-label",
        defaultMessage: "Build app"
    },
    reviewSpecsButtonLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.review-specs-button-label",
        defaultMessage: "Review app specs"
    }
});
module.exports["messages"] = $91660d228c212368$export$defe85febe8b728c;

});

parcelRegister("4kBlh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ec389246768539bf$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    buildAutomationActionLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-automation-action-label",
        defaultMessage: "Build flow"
    },
    buildAutomationActionLabelOld: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-automation-action-label-old",
        defaultMessage: "Build automation"
    },
    saveAndPublishAutomationActionLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-and-publish-automation-action-label",
        defaultMessage: "Save and enable automation"
    },
    saveAutomationActionLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-automation-action-label",
        defaultMessage: "Save without enabling"
    },
    saveOrPublishAutomationDropdownTriggerLabel: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-or-publish-automation-dropdown-trigger-label",
        defaultMessage: "More save options"
    },
    saveAutomationErrorTitle: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-automation-error-title",
        defaultMessage: "We couldn't save this automation"
    },
    saveAutomationErrorDescription: {
        id: "conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-automation-error-description",
        defaultMessage: "Something went wrong while saving. Please try again."
    }
});
module.exports["messages"] = $ec389246768539bf$export$defe85febe8b728c;

});

parcelRegister("5DDRP", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $3SlQf = parcelRequire("3SlQf");


var $9NDDx = parcelRequire("9NDDx");


var $1P2f3 = parcelRequire("1P2f3");

function $23d14d76039e52a4$var$getDraftRulePayload(draftContent) {
    if (draftContent.rule) return {
        ruleConfig: draftContent.rule,
        newConnections: draftContent.connections
    };
    if (draftContent.specification) {
        const specification = JSON.parse(draftContent.specification);
        return {
            ruleConfig: specification.rule,
            newConnections: specification.connections
        };
    }
    return {};
}
function $23d14d76039e52a4$var$buildStudioSc3RulesBasePath(workspaceId, spaceId) {
    const appEnv = typeof $1P2f3 !== 'undefined' ? undefined : undefined;
    const windowEnv = typeof window !== 'undefined' ? window.__env__ : undefined;
    const env = appEnv === 'prod' || appEnv === 'prod-east' || windowEnv === 'prod' || windowEnv === 'prod-east' ? 'pro' : 'staging';
    return `/gateway/api/automation/sc3/o/studio/t/workspace/i/${workspaceId}/internal-api/${env}/rest/${spaceId}/rule`;
}
async function $23d14d76039e52a4$export$2fc5110127ff6a02({ buildId: buildId, workspaceId: workspaceId, spaceId: spaceId, publish: publish }) {
    (0, $6cFsl.di)(fetch, (0, $3SlQf.fetchDraftBuild), (0, $9NDDx.updateBuildState));
    const draftBuild = await (0, $3SlQf.fetchDraftBuild)(buildId, workspaceId);
    const draftContent = JSON.parse(draftBuild.draftContent);
    const { ruleConfig: ruleConfig, newConnections: newConnections } = $23d14d76039e52a4$var$getDraftRulePayload(draftContent);
    if (!ruleConfig) throw new Error('Invalid draft content: missing rule.');
    const existingTags = Array.isArray(ruleConfig.tags) ? ruleConfig.tags : [];
    const body = {
        ruleConfigBean: {
            ...ruleConfig,
            state: publish ? 'ENABLED' : 'DISABLED',
            isNewRule: true,
            tags: [
                ...existingTags,
                {
                    tagType: 'SOURCE',
                    tagValue: 'studio-sa-create'
                }
            ]
        },
        newConnections: newConnections
    };
    const response = await fetch($23d14d76039e52a4$var$buildStudioSc3RulesBasePath(workspaceId, spaceId), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*'
        },
        credentials: 'include',
        body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Failed to create automation rule.');
    const text = await response.text();
    const created = text ? JSON.parse(text) : {};
    const ruleAri = created.idUuid ? `ari:cloud:automation::rule/${created.idUuid}` : undefined;
    try {
        await (0, $9NDDx.updateBuildState)(workspaceId, {
            buildId: buildId,
            state: 'SUCCESS',
            objectAri: ruleAri
        });
    } catch  {
    // The automation rule was created successfully. Do not reject here, otherwise retrying
    // would create a duplicate rule; the user can still see the saved state locally.
    }
}
module.exports["saveAutomation"] = $23d14d76039e52a4$export$2fc5110127ff6a02;

});

parcelRegister("bApiv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cJ0FD = parcelRequire("cJ0FD");


var $NlHoa = parcelRequire("NlHoa");


var $iDrrr = parcelRequire("iDrrr");


var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");


var $5SS4O = parcelRequire("5SS4O");


var $7pCWA = parcelRequire("7pCWA");


var $dKfWr = parcelRequire("dKfWr");


var $appkN = parcelRequire("appkN");


var $737YC = parcelRequire("737YC");


var $beSzn = parcelRequire("beSzn");

const $9e56f18a2689287e$export$ff72774749e05dd7 = 'ai-mate';
const $9e56f18a2689287e$export$816ea3d7b8fa48a8 = 'rovo';
const $9e56f18a2689287e$export$f19743e42644aa2c = 'atlassian-agent-studio';
const $9e56f18a2689287e$export$994aa04139f558bd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { ari: ari, source: source, cloudId: cloudId, preferDirectConnectorFetch: t1, agentCreatorType: agentCreatorType } = t0;
    const preferDirectConnectorFetch = t1 === undefined ? false : t1;
    (0, $6cFsl.di)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const useConnectorData = preferDirectConnectorFetch;
    const [storedSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [storedIsFetching] = (0, $7pCWA.useConnectorsIsFetching)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            "X-Channel-Id": $9e56f18a2689287e$export$f19743e42644aa2c
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== cloudId) {
        t3 = {
            product: $9e56f18a2689287e$export$816ea3d7b8fa48a8,
            touchpointSource: "atlassian-agent-studio-rovo-knowledge-card-knowledge-list",
            experienceId: $9e56f18a2689287e$export$ff72774749e05dd7,
            siteId: cloudId,
            headers: t2
        };
        $[1] = cloudId;
        $[2] = t3;
    } else t3 = $[2];
    const assistanceServiceParams = t3;
    let t4;
    if ($[3] !== agentCreatorType || $[4] !== assistanceServiceParams || $[5] !== useConnectorData) {
        t4 = {
            agentCreatorType: agentCreatorType,
            assistanceServiceParams: assistanceServiceParams,
            enabled: useConnectorData
        };
        $[3] = agentCreatorType;
        $[4] = assistanceServiceParams;
        $[5] = useConnectorData;
        $[6] = t4;
    } else t4 = $[6];
    const { enabledKnowledgeSources: enabledKnowledgeSources, isFetching: isFetching } = (0, $dKfWr.useKnowledgeConnectors)(t4);
    const sources = useConnectorData ? enabledKnowledgeSources : storedSources;
    const fetching = useConnectorData ? isFetching : storedIsFetching;
    const isHelpCenterAri = ari?.includes("help-center") ?? false;
    const t5 = ari ?? "";
    let t6;
    if ($[7] !== t5) {
        t6 = [
            "knowledge-source-pill",
            t5
        ];
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== ari || $[10] !== cloudId) {
        t7 = async ()=>{
            if (!ari) return;
            const service = new (0, $appkN.KnowledgeFilterServiceImpl)(cloudId);
            const entities = await service.getEntitiesByAris({
                aris: [
                    ari
                ]
            });
            if (entities.length > 0) return entities[0];
        };
        $[9] = ari;
        $[10] = cloudId;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = !!ari;
    let t9;
    if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
        t9 = {
            queryKey: t6,
            queryFn: t7,
            enabled: t8
        };
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    const { data: entity, isFetching: isFetchingEntity } = (0, $5SS4O.useQuery)(t9);
    if (fetching || isFetchingEntity) {
        let t10;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                isShimmering: true,
                width: 100,
                height: 16
            });
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    if (!ari) {
        let t10;
        if ($[17] !== formatMessage || $[18] !== source || $[19] !== sources) {
            let t11;
            if ($[21] !== source) {
                t11 = (s)=>s.source === source;
                $[21] = source;
                $[22] = t11;
            } else t11 = $[22];
            const sourceDetails = sources.find(t11);
            const sourceName = sourceDetails?.friendlyName ?? source;
            const iconUrl = sourceDetails?.iconUrl;
            let t12;
            bb0: {
                if (source === "jira" || source === "jsm") {
                    let t13;
                    if ($[23] !== formatMessage) {
                        t13 = formatMessage((0, $beSzn.default).allSpaces);
                        $[23] = formatMessage;
                        $[24] = t13;
                    } else t13 = $[24];
                    t12 = t13;
                    break bb0;
                }
                if (source === "confluence") {
                    let t13;
                    if ($[25] !== formatMessage) {
                        t13 = formatMessage((0, $beSzn.default).allContent);
                        $[25] = formatMessage;
                        $[26] = t13;
                    } else t13 = $[26];
                    t12 = t13;
                    break bb0;
                }
                t12 = sourceName;
            }
            const content = t12;
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
                icon: iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                    src: sourceDetails?.iconUrl,
                    width: 16,
                    height: 16,
                    alt: formatMessage((0, $beSzn.default).knowledgeSourcePill, {
                        knowledgeSource: sourceName
                    })
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    size: "xsmall",
                    appearance: "brand"
                }),
                content: content,
                fullWidth: true
            });
            $[17] = formatMessage;
            $[18] = source;
            $[19] = sources;
            $[20] = t10;
        } else t10 = $[20];
        return t10;
    }
    if (!entity) return null;
    if (isHelpCenterAri && (0, $iDrrr.fg)("agent_studio_jsm_help_center_knowledge")) {
        let t10;
        if ($[27] !== sources) {
            t10 = sources.find($9e56f18a2689287e$var$_temp);
            $[27] = sources;
            $[28] = t10;
        } else t10 = $[28];
        const jsmSource = t10;
        const iconUrl_0 = jsmSource?.iconUrl;
        let t11;
        if ($[29] !== entity.displayName || $[30] !== formatMessage || $[31] !== iconUrl_0) {
            t11 = iconUrl_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: iconUrl_0,
                width: 16,
                height: 16,
                alt: formatMessage((0, $beSzn.default).knowledgeSourcePill, {
                    knowledgeSource: entity.displayName
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                size: "xsmall",
                appearance: "brand"
            });
            $[29] = entity.displayName;
            $[30] = formatMessage;
            $[31] = iconUrl_0;
            $[32] = t11;
        } else t11 = $[32];
        let t12;
        if ($[33] !== entity.displayName || $[34] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
                icon: t11,
                content: entity.displayName,
                fullWidth: true
            });
            $[33] = entity.displayName;
            $[34] = t11;
            $[35] = t12;
        } else t12 = $[35];
        return t12;
    }
    let t10;
    if ($[36] !== entity.url) {
        t10 = (event)=>{
            event.preventDefault();
            window.open(entity?.url, "_blank", "noopener, noreferrer");
        };
        $[36] = entity.url;
        $[37] = t10;
    } else t10 = $[37];
    let t11;
    if ($[38] !== entity.url || $[39] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            url: entity.url,
            appearance: "inline",
            showHoverPreview: true,
            onClick: t10
        });
        $[38] = entity.url;
        $[39] = t10;
        $[40] = t11;
    } else t11 = $[40];
    return t11;
} : ({ ari: ari, source: source, cloudId: cloudId, preferDirectConnectorFetch: preferDirectConnectorFetch = false, agentCreatorType: agentCreatorType })=>{
    (0, $6cFsl.di)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const useConnectorData = preferDirectConnectorFetch;
    const [storedSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [storedIsFetching] = (0, $7pCWA.useConnectorsIsFetching)();
    const assistanceServiceParams = {
        product: $9e56f18a2689287e$export$816ea3d7b8fa48a8,
        touchpointSource: 'atlassian-agent-studio-rovo-knowledge-card-knowledge-list',
        experienceId: $9e56f18a2689287e$export$ff72774749e05dd7,
        siteId: cloudId,
        headers: {
            'X-Channel-Id': $9e56f18a2689287e$export$f19743e42644aa2c
        }
    };
    const { enabledKnowledgeSources: enabledKnowledgeSources, isFetching: isFetching } = (0, $dKfWr.useKnowledgeConnectors)({
        agentCreatorType: agentCreatorType,
        assistanceServiceParams: assistanceServiceParams,
        enabled: useConnectorData
    });
    const sources = useConnectorData ? enabledKnowledgeSources : storedSources;
    const fetching = useConnectorData ? isFetching : storedIsFetching;
    const isHelpCenterAri = ari?.includes('help-center') ?? false;
    const { data: entity, isFetching: isFetchingEntity } = (0, $5SS4O.useQuery)({
        queryKey: [
            'knowledge-source-pill',
            ari ?? ''
        ],
        queryFn: async ()=>{
            if (!ari) return;
            const service = new (0, $appkN.KnowledgeFilterServiceImpl)(cloudId);
            const entities = await service.getEntitiesByAris({
                aris: [
                    ari
                ]
            });
            if (entities.length > 0) return entities[0];
        },
        enabled: !!ari
    });
    if (fetching || isFetchingEntity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 100,
        height: 16
    });
    if (!ari) {
        const sourceDetails = sources.find((s)=>s.source === source);
        const sourceName = sourceDetails?.friendlyName ?? source;
        const iconUrl = sourceDetails?.iconUrl;
        const content = (()=>{
            if (source === 'jira' || source === 'jsm') return formatMessage((0, $beSzn.default).allSpaces);
            if (source === 'confluence') return formatMessage((0, $beSzn.default).allContent);
            return sourceName;
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
            icon: iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: sourceDetails?.iconUrl,
                width: 16,
                height: 16,
                alt: formatMessage((0, $beSzn.default).knowledgeSourcePill, {
                    knowledgeSource: sourceName
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                size: "xsmall",
                appearance: "brand"
            }),
            content: content,
            fullWidth: true
        });
    }
    if (!entity) return null;
    // Help center: SmartCard does not support it; show name from GQL (KnowledgeFilterService) + JSM icon
    if (isHelpCenterAri && (0, $iDrrr.fg)('agent_studio_jsm_help_center_knowledge')) {
        const jsmSource = sources.find((s_0)=>s_0.source === 'jsm');
        const iconUrl_0 = jsmSource?.iconUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $737YC.InlineIconText), {
            icon: iconUrl_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: iconUrl_0,
                width: 16,
                height: 16,
                alt: formatMessage((0, $beSzn.default).knowledgeSourcePill, {
                    knowledgeSource: entity.displayName
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                size: "xsmall",
                appearance: "brand"
            }),
            content: entity.displayName,
            fullWidth: true
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        url: entity.url,
        appearance: "inline",
        showHoverPreview: true,
        onClick: (event)=>{
            event.preventDefault();
            window.open(entity?.url, '_blank', 'noopener, noreferrer');
        }
    });
};
function $9e56f18a2689287e$var$_temp(s_0) {
    return s_0.source === "jsm";
}
module.exports["KnowledgeSourcePill"] = $9e56f18a2689287e$export$994aa04139f558bd;

});

parcelRegister("1Itzb", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $de6d3638a13821a2$var$message = (0, $kSwu1.defineMessages)({
    collapse: {
        id: "ai-mate.conversation-assistant-message-actions.expandable-cards.collapse",
        defaultMessage: "Collapse"
    },
    expand: {
        id: "ai-mate.conversation-assistant-message-actions.expandable-cards.expand",
        defaultMessage: "Expand"
    }
});
var $de6d3638a13821a2$export$2e2bcd8739ae039 = $de6d3638a13821a2$var$message;
module.exports["default"] = $de6d3638a13821a2$export$2e2bcd8739ae039;

});

parcelRegister("5R8ns", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f2a00d6beb4ae070$var$_default_1 = (0, $kSwu1.defineMessages)({
    deleteIconLabel: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.delete-field-renderer.delete-icon-label",
        defaultMessage: "Delete field value"
    },
    defaultDeleteDescription: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.delete-field-renderer.delete-description",
        defaultMessage: "Delete {fieldName}."
    }
});
var $f2a00d6beb4ae070$export$2e2bcd8739ae039 = $f2a00d6beb4ae070$var$_default_1;
module.exports["default"] = $f2a00d6beb4ae070$export$2e2bcd8739ae039;

});

parcelRegister("iG8JX", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c60b511097acd4aa$var$message = (0, $kSwu1.defineMessages)({
    instructionsTitle: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.instructions-title",
        defaultMessage: "Instructions"
    },
    skillsTitle: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.skills-title",
        defaultMessage: "Skills"
    },
    invocationDescriptionTitle: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.invocation-description-title",
        defaultMessage: "Trigger"
    },
    knowledgeSourcesTitle: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.knowledge-sources-title",
        defaultMessage: "Knowledge"
    },
    deleteDescription: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.delete-description",
        defaultMessage: "Delete the {scenarioName} scenario."
    },
    allOrganisationalKnowledge: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.all-organisational-knowledge",
        defaultMessage: "All organisational knowledge."
    },
    noOrganisationalKnowledge: {
        id: "ai-mate.studio-update-agent-draft.agent-diff.scenario-content.no-organisational-knowledge",
        defaultMessage: "No organisational knowledge."
    }
});
var $c60b511097acd4aa$export$2e2bcd8739ae039 = $c60b511097acd4aa$var$message;
module.exports["default"] = $c60b511097acd4aa$export$2e2bcd8739ae039;

});

parcelRegister("izKsM", function(module, exports) {
/**
 * @generated SignedSource<<34eaf41991f99f2d4401a4cd7ea70c95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43497a9a5e1a2fee$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "fieldLabel_AtlassianConversationAssistantPreviewCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isRequired"
                        }
                    ]
                }
            ],
            "type": "JiraIssueFieldConfiguration",
            "abstractKey": "__isJiraIssueFieldConfiguration"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$43497a9a5e1a2fee$var$node.hash = "5dbc4ccc26c8e0c2514a3bba87465edc";
var $43497a9a5e1a2fee$export$2e2bcd8739ae039 = $43497a9a5e1a2fee$var$node;
module.exports["default"] = $43497a9a5e1a2fee$export$2e2bcd8739ae039;

});

parcelRegister("9gQhQ", function(module, exports) {
/**
 * @generated SignedSource<<975e1bbe95514827c18fec92da2a5490>>
 * @relayHash c71930bef2d0ea40edd3a89d9d752751
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7fcb7060496f052d94a6b36f9dfc7dc3a7c89d8c8dd0cbd9effb5e042079061d
const $1e3bc2e271ca208e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "summary"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedIssueAllFieldTypesActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedIssueAllFieldTypesActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7fcb7060496f052d94a6b36f9dfc7dc3a7c89d8c8dd0cbd9effb5e042079061d",
            "metadata": {},
            "name": "useHydratedIssueAllFieldTypesActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e3bc2e271ca208e$var$node.hash = "cf8c63897fa9c9fd26949d9c0e6b979a";
var $1e3bc2e271ca208e$export$2e2bcd8739ae039 = $1e3bc2e271ca208e$var$node;
module.exports["default"] = $1e3bc2e271ca208e$export$2e2bcd8739ae039;

});

parcelRegister("1wTHs", function(module, exports) {
/**
 * @generated SignedSource<<43547f61e318489a27a581d518631126>>
 * @relayHash d6c407f23219e71e14e9285e9f5dd7a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dfcd9b2473acf3f5ac1ef94507121e7be47e0e06d4101c74498cbc9b65f8d3b9
const $f29cc08d0178ba71$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedUserAllFieldTypesActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedUserAllFieldTypesActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dfcd9b2473acf3f5ac1ef94507121e7be47e0e06d4101c74498cbc9b65f8d3b9",
            "metadata": {},
            "name": "useHydratedUserAllFieldTypesActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f29cc08d0178ba71$var$node.hash = "cf30a9c78aaca4bbe847e44977270fbf";
var $f29cc08d0178ba71$export$2e2bcd8739ae039 = $f29cc08d0178ba71$var$node;
module.exports["default"] = $f29cc08d0178ba71$export$2e2bcd8739ae039;

});

parcelRegister("fcu3m", function(module, exports) {
/**
 * @generated SignedSource<<1621b3653b0c3b6625307da8a58a5d20>>
 * @relayHash c21186b602c639ace15c259b6ab0118f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbbb92b7baf48abf179aeb395a0d185c2db3c27a6b19a72a9264990c3303cfad
const $b8616e9e43d1c078$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteId"
        }
    ], v1 = [
        {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        },
                        {
                            "kind": "Variable",
                            "name": "siteId",
                            "variableName": "siteId"
                        }
                    ],
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "teamV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedTeamAllFieldTypesActionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedTeamAllFieldTypesActionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "dbbb92b7baf48abf179aeb395a0d185c2db3c27a6b19a72a9264990c3303cfad",
            "metadata": {},
            "name": "useHydratedTeamAllFieldTypesActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b8616e9e43d1c078$var$node.hash = "c8a6bed4928f92e22f9055edf70fd356";
var $b8616e9e43d1c078$export$2e2bcd8739ae039 = $b8616e9e43d1c078$var$node;
module.exports["default"] = $b8616e9e43d1c078$export$2e2bcd8739ae039;

});

parcelRegister("jDu2v", function(module, exports) {
/**
 * @generated SignedSource<<31b8e2c5e56008a8c8a0fbb403d7a99e>>
 * @relayHash d670549f7a402c964f0a5905be798305
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9108556c45ad3147d2ee8bbff6898ee8523eac5ef3d33401d769de0b996900d
const $7b1f8adc90e65dff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedUsersAllFieldTypesActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedUsersAllFieldTypesActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9108556c45ad3147d2ee8bbff6898ee8523eac5ef3d33401d769de0b996900d",
            "metadata": {},
            "name": "useHydratedUsersAllFieldTypesActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7b1f8adc90e65dff$var$node.hash = "4e32efd56d5c3f4895438325c248e124";
var $7b1f8adc90e65dff$export$2e2bcd8739ae039 = $7b1f8adc90e65dff$var$node;
module.exports["default"] = $7b1f8adc90e65dff$export$2e2bcd8739ae039;

});

parcelRegister("75LG8", function(module, exports) {
/**
 * @generated SignedSource<<188fae1f16a3a56688f16f0783c9d12e>>
 * @relayHash 193d8471f67524b135c55542a56c67a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70ca45a6e4ec054399f379e2b1bc4e2a9b6290f0e792a3ab28f3cf3a588338aa
const $199b02725ab03861$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "summary"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedIssueActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedIssueActionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "70ca45a6e4ec054399f379e2b1bc4e2a9b6290f0e792a3ab28f3cf3a588338aa",
            "metadata": {},
            "name": "useHydratedIssueActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$199b02725ab03861$var$node.hash = "0e103cc8693b6ff037cb1034ac9ed8b6";
var $199b02725ab03861$export$2e2bcd8739ae039 = $199b02725ab03861$var$node;
module.exports["default"] = $199b02725ab03861$export$2e2bcd8739ae039;

});

parcelRegister("dl6HD", function(module, exports) {
/**
 * @generated SignedSource<<8e1dd7330f3285da1e07c8ca86eafb2b>>
 * @relayHash f74e33bc9be174a4d6b558164fef3bf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc2e2831829da0b701bd8252e62b52d36081547c0f389423088ca06ec3bf3714
const $b4b38775a466f335$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedUserActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedUserActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fc2e2831829da0b701bd8252e62b52d36081547c0f389423088ca06ec3bf3714",
            "metadata": {},
            "name": "useHydratedUserActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b4b38775a466f335$var$node.hash = "e3ff2f2be58904e2718220901d15c2ad";
var $b4b38775a466f335$export$2e2bcd8739ae039 = $b4b38775a466f335$var$node;
module.exports["default"] = $b4b38775a466f335$export$2e2bcd8739ae039;

});

parcelRegister("k8Wet", function(module, exports) {
/**
 * @generated SignedSource<<8801e86970bd1da28663d27ca6b39542>>
 * @relayHash 1252806a474b1689d4d2152dc3a259d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d6ebcf2b38f29cf82c34188897b86a3f97a1267afad9f8350e078cbfa0b1e8d
const $acf58dcb2ba75d6a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHydratedUsersActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHydratedUsersActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d6ebcf2b38f29cf82c34188897b86a3f97a1267afad9f8350e078cbfa0b1e8d",
            "metadata": {},
            "name": "useHydratedUsersActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$acf58dcb2ba75d6a$var$node.hash = "02a8c4a7d9974799b2f1f9023608a650";
var $acf58dcb2ba75d6a$export$2e2bcd8739ae039 = $acf58dcb2ba75d6a$var$node;
module.exports["default"] = $acf58dcb2ba75d6a$export$2e2bcd8739ae039;

});

parcelRegister("7NH0n", function(module, exports) {
// ADF node types that only ever wrap other content — a document built solely
// from these plus whitespace text is considered empty.
const $643b51bf75b55d24$var$CONTAINER_ADF_TYPES = new Set([
    'doc',
    'paragraph'
]);
/** True when an ADF node holds non-whitespace text or any non-container node. */ const $643b51bf75b55d24$var$nodeHasContent = (node)=>{
    if (!node || typeof node !== 'object') return false;
    const { type: type, text: text, content: content } = node;
    if (type === 'text') return typeof text === 'string' && text.trim().length > 0;
    // A non-text, non-container node (media, mention, emoji, inline card, …) is
    // itself meaningful content.
    if (type && !$643b51bf75b55d24$var$CONTAINER_ADF_TYPES.has(type)) return true;
    return Array.isArray(content) && content.some($643b51bf75b55d24$var$nodeHasContent);
};
const $643b51bf75b55d24$export$2290b569010a6e15 = (node)=>!$643b51bf75b55d24$var$nodeHasContent(node);
module.exports["isEditorDocumentEmpty"] = $643b51bf75b55d24$export$2290b569010a6e15;

});

parcelRegister("hZpNo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $5SS4O = parcelRequire("5SS4O");


var $haiCi = parcelRequire("haiCi");


var $kIlwI = parcelRequire("kIlwI");


var $k0ogf = parcelRequire("k0ogf");


var $Mrc7T = parcelRequire("Mrc7T");

const $a298e334bb4c667d$var$TENANT_CONTEXTS_QUERY = `
	query useValidateJiraAlignProjectAriTenantContexts(
		$url: String!
		$currentCloudId: ID!
	) {
		byHost: tenantContexts(hostNames: [$url]) {
			orgId
		}
		byCloudId: tenantContexts(cloudIds: [$currentCloudId]) {
			orgId
		}
	}
`;
const $a298e334bb4c667d$var$IS_SANDBOX_QUERY = `
	query useValidateJiraAlignProjectAriIsSandbox($cloudId: ID!) {
		mercury @optIn(to: "Mercury") {
			workspaceContext(cloudId: $cloudId) {
				isSandbox
			}
		}
	}
`;
const $a298e334bb4c667d$var$JA_SITES_BY_ORG_QUERY = `
	query useValidateJiraAlignProjectAriJiraAlignSites($orgId: String!, $env: String!) {
		jiraAlignAgg_sitesByOrgId(orgId: $orgId, env: $env) @optIn(to: "JiraAlignAgg") {
			id
		}
	}
`;
const $a298e334bb4c667d$export$172c636c286e3a4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (ari, currentCloudId, link)=>{
    const $ = (0, $bDgLe.c)(38);
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    const ariCloudId = parsed?.resourceOwner === "jira-align" ? parsed.cloudId ?? null : null;
    const orgsEnabled = !!ariCloudId && !!currentCloudId && !!link;
    const t0 = link ?? "";
    let t1;
    if ($[0] !== currentCloudId || $[1] !== t0) {
        t1 = [
            "focus-ask-impacted-work-validate-ja-project-orgs",
            currentCloudId,
            t0
        ];
        $[0] = currentCloudId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== currentCloudId || $[4] !== link) {
        t2 = ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $a298e334bb4c667d$var$TENANT_CONTEXTS_QUERY,
                variables: {
                    url: (0, $k0ogf.extractHostname)(link),
                    currentCloudId: currentCloudId
                }
            });
        $[3] = currentCloudId;
        $[4] = link;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== orgsEnabled || $[7] !== t1 || $[8] !== t2) {
        t3 = {
            queryKey: t1,
            enabled: orgsEnabled,
            queryFn: t2
        };
        $[6] = orgsEnabled;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const { data: orgs, isFetching: orgsLoading, error: orgsError } = (0, $5SS4O.useQuery)(t3);
    let t4;
    if ($[10] !== currentCloudId) {
        t4 = [
            "focus-ask-impacted-work-validate-ja-project-is-sandbox",
            currentCloudId
        ];
        $[10] = currentCloudId;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== currentCloudId) {
        t5 = ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $a298e334bb4c667d$var$IS_SANDBOX_QUERY,
                variables: {
                    cloudId: currentCloudId
                }
            });
        $[12] = currentCloudId;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== orgsEnabled || $[15] !== t4 || $[16] !== t5) {
        t6 = {
            queryKey: t4,
            enabled: orgsEnabled,
            queryFn: t5
        };
        $[14] = orgsEnabled;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    const { data: sandboxData, isFetching: sandboxLoading, error: sandboxError } = (0, $5SS4O.useQuery)(t6);
    const workspaceOrg = orgs?.data?.byCloudId?.[0]?.orgId;
    const ariOrg = orgs?.data?.byHost?.[0]?.orgId;
    const isSandbox = sandboxData?.data?.mercury?.workspaceContext?.isSandbox;
    const jaEnv = isSandbox === true ? "sandbox" : (0, $Mrc7T.isStagingEnvironment)() ? "dev" : "production";
    const jaSitesEnabled = !!ariCloudId && !!workspaceOrg && !!ariOrg && workspaceOrg === ariOrg && isSandbox !== undefined;
    const t7 = workspaceOrg ?? "";
    let t8;
    if ($[18] !== jaEnv || $[19] !== t7) {
        t8 = [
            "focus-ask-impacted-work-validate-ja-project-sites",
            t7,
            jaEnv
        ];
        $[18] = jaEnv;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== jaEnv || $[22] !== workspaceOrg) {
        t9 = ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $a298e334bb4c667d$var$JA_SITES_BY_ORG_QUERY,
                variables: {
                    orgId: workspaceOrg ?? "",
                    env: jaEnv
                }
            });
        $[21] = jaEnv;
        $[22] = workspaceOrg;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== jaSitesEnabled || $[25] !== t8 || $[26] !== t9) {
        t10 = {
            queryKey: t8,
            enabled: jaSitesEnabled,
            queryFn: t9
        };
        $[24] = jaSitesEnabled;
        $[25] = t8;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    const { data: jaSites, isFetching: jaLoading, error: jaError } = (0, $5SS4O.useQuery)(t10);
    if (!ariCloudId) {
        let t11;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "notFound"
            };
            $[28] = t11;
        } else t11 = $[28];
        return t11;
    }
    if (orgsLoading || sandboxLoading || jaLoading) {
        let t11;
        if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "loading"
            };
            $[29] = t11;
        } else t11 = $[29];
        return t11;
    }
    if (orgsEnabled && orgs === undefined && !orgsError) {
        let t11;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "loading"
            };
            $[30] = t11;
        } else t11 = $[30];
        return t11;
    }
    if (orgsEnabled && sandboxData === undefined && !sandboxError) {
        let t11;
        if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "loading"
            };
            $[31] = t11;
        } else t11 = $[31];
        return t11;
    }
    if (orgsEnabled && sandboxData != null && isSandbox === undefined && !sandboxError) {
        let t11;
        if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "notFound"
            };
            $[32] = t11;
        } else t11 = $[32];
        return t11;
    }
    if (jaSitesEnabled && jaSites === undefined && !jaError) {
        let t11;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "loading"
            };
            $[33] = t11;
        } else t11 = $[33];
        return t11;
    }
    if (orgsError || sandboxError || jaError) {
        let t11;
        if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "error"
            };
            $[34] = t11;
        } else t11 = $[34];
        return t11;
    }
    if (!workspaceOrg || !ariOrg || ariOrg !== workspaceOrg) {
        let t11;
        if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "notFound"
            };
            $[35] = t11;
        } else t11 = $[35];
        return t11;
    }
    const jaInstanceCloudIds = jaSites?.data?.jiraAlignAgg_sitesByOrgId?.map($a298e334bb4c667d$var$_temp).filter($a298e334bb4c667d$var$_temp2) ?? [];
    if (!jaInstanceCloudIds.includes(ariCloudId)) {
        let t11;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                status: "notFound"
            };
            $[36] = t11;
        } else t11 = $[36];
        return t11;
    }
    let t11;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            status: "inWorkspace"
        };
        $[37] = t11;
    } else t11 = $[37];
    return t11;
} : (ari, currentCloudId, link)=>{
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    const ariCloudId = parsed?.resourceOwner === 'jira-align' ? parsed.cloudId ?? null : null;
    const orgsEnabled = !!ariCloudId && !!currentCloudId && !!link;
    const { data: orgs, isFetching: orgsLoading, error: orgsError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'focus-ask-impacted-work-validate-ja-project-orgs',
            currentCloudId,
            link ?? ''
        ],
        enabled: orgsEnabled,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $a298e334bb4c667d$var$TENANT_CONTEXTS_QUERY,
                variables: {
                    url: (0, $k0ogf.extractHostname)(link),
                    currentCloudId: currentCloudId
                }
            })
    });
    const { data: sandboxData, isFetching: sandboxLoading, error: sandboxError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'focus-ask-impacted-work-validate-ja-project-is-sandbox',
            currentCloudId
        ],
        enabled: orgsEnabled,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $a298e334bb4c667d$var$IS_SANDBOX_QUERY,
                variables: {
                    cloudId: currentCloudId
                }
            })
    });
    const workspaceOrg = orgs?.data?.byCloudId?.[0]?.orgId;
    const ariOrg = orgs?.data?.byHost?.[0]?.orgId;
    const isSandbox = sandboxData?.data?.mercury?.workspaceContext?.isSandbox;
    // Mirrors Mercury's logic: sandbox workspaces always use 'sandbox';
    // otherwise 'dev' on Atlassian staging deploys, 'production' elsewhere.
    const jaEnv = isSandbox === true ? 'sandbox' : (0, $Mrc7T.isStagingEnvironment)() ? 'dev' : 'production';
    const jaSitesEnabled = !!ariCloudId && !!workspaceOrg && !!ariOrg && workspaceOrg === ariOrg && isSandbox !== undefined;
    const { data: jaSites, isFetching: jaLoading, error: jaError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'focus-ask-impacted-work-validate-ja-project-sites',
            workspaceOrg ?? '',
            jaEnv
        ],
        enabled: jaSitesEnabled,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $a298e334bb4c667d$var$JA_SITES_BY_ORG_QUERY,
                variables: {
                    orgId: workspaceOrg ?? '',
                    env: jaEnv
                }
            })
    });
    if (!ariCloudId) return {
        status: 'notFound'
    };
    if (orgsLoading || sandboxLoading || jaLoading) return {
        status: 'loading'
    };
    if (orgsEnabled && orgs === undefined && !orgsError) return {
        status: 'loading'
    }; // orgs enabled but not yet in flight
    if (orgsEnabled && sandboxData === undefined && !sandboxError) return {
        status: 'loading'
    }; // sandbox enabled but not yet in flight
    if (orgsEnabled && sandboxData != null && isSandbox === undefined && !sandboxError) return {
        status: 'notFound'
    }; // sandbox query resolved but workspaceContext was null (e.g. permission denied)
    if (jaSitesEnabled && jaSites === undefined && !jaError) return {
        status: 'loading'
    }; // jaSites enabled but not yet in flight
    if (orgsError || sandboxError || jaError) return {
        status: 'error'
    };
    if (!workspaceOrg || !ariOrg || ariOrg !== workspaceOrg) return {
        status: 'notFound'
    };
    const jaInstanceCloudIds = jaSites?.data?.jiraAlignAgg_sitesByOrgId?.map((site)=>(0, $kIlwI.parseAriSafely)(site.id)?.resourceId).filter((id)=>Boolean(id)) ?? [];
    if (!jaInstanceCloudIds.includes(ariCloudId)) return {
        status: 'notFound'
    };
    return {
        status: 'inWorkspace'
    };
};
function $a298e334bb4c667d$var$_temp(site) {
    return (0, $kIlwI.parseAriSafely)(site.id)?.resourceId;
}
function $a298e334bb4c667d$var$_temp2(id) {
    return Boolean(id);
}
module.exports["useValidateJiraAlignProjectAri"] = $a298e334bb4c667d$export$172c636c286e3a4b;

});

parcelRegister("hEzMq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $5SS4O = parcelRequire("5SS4O");


var $haiCi = parcelRequire("haiCi");


var $kIlwI = parcelRequire("kIlwI");

const $e5b47050ec44c654$var$TENANT_CONTEXTS_QUERY = `
	query useValidateJiraIssueAriTenantContexts($cloudIds: [ID!]!) {
		tenantContexts(cloudIds: $cloudIds) {
			cloudId
			orgId
		}
	}
`;
const $e5b47050ec44c654$var$USER_ACCESSIBLE_JIRA_SITES_QUERY = `
	query useValidateJiraIssueAriUserAccessibleJiraSites($cloudId: ID!) {
		mercury_jiraProvider @optIn(to: "Mercury") {
			userAccessibleConnectedJiraSites(cloudId: $cloudId) {
				edges {
					node {
						id
					}
				}
			}
		}
	}
`;
const $e5b47050ec44c654$export$b418a8454f0b211f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (ari, currentCloudId)=>{
    const $ = (0, $bDgLe.c)(10);
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    const ariCloudId = parsed?.resourceOwner === "jira" ? parsed.cloudId ?? null : null;
    const queriesEnabled = !!ariCloudId && !!currentCloudId;
    const { data: orgs, isFetching: orgsLoading, error: orgsError } = (0, $5SS4O.useQuery)({
        queryKey: [
            "focus-ask-impacted-work-validate-jira-issue-orgs",
            currentCloudId,
            ariCloudId ?? ""
        ],
        enabled: queriesEnabled,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $e5b47050ec44c654$var$TENANT_CONTEXTS_QUERY,
                variables: {
                    cloudIds: [
                        currentCloudId,
                        ariCloudId ?? currentCloudId
                    ]
                }
            })
    });
    let t0;
    if ($[0] !== currentCloudId) {
        t0 = ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $e5b47050ec44c654$var$USER_ACCESSIBLE_JIRA_SITES_QUERY,
                variables: {
                    cloudId: currentCloudId
                }
            });
        $[0] = currentCloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: sites, isFetching: sitesLoading, error: sitesError } = (0, $5SS4O.useQuery)({
        queryKey: [
            "focus-ask-impacted-work-validate-jira-issue-sites",
            currentCloudId,
            ariCloudId ?? ""
        ],
        enabled: queriesEnabled,
        queryFn: t0
    });
    if (!ariCloudId) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "notFound"
            };
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    if (orgsLoading || sitesLoading) {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "loading"
            };
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    if (queriesEnabled && orgs === undefined && !orgsError) {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "loading"
            };
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    if (queriesEnabled && sites === undefined && !sitesError) {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "loading"
            };
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    if (orgsError || sitesError) {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "error"
            };
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    const workspaceOrg = orgs?.data?.tenantContexts?.find((c)=>c.cloudId === currentCloudId)?.orgId;
    const ariOrg = orgs?.data?.tenantContexts?.find((c_0)=>c_0.cloudId === ariCloudId)?.orgId;
    if (!workspaceOrg || !ariOrg || workspaceOrg !== ariOrg) {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "notFound"
            };
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
    const connectedCloudIds = sites?.data?.mercury_jiraProvider?.userAccessibleConnectedJiraSites?.edges?.map($e5b47050ec44c654$var$_temp).filter($e5b47050ec44c654$var$_temp2) ?? [];
    if (!connectedCloudIds.includes(ariCloudId)) {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                status: "notFound"
            };
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    let t1;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            status: "inWorkspace"
        };
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (ari, currentCloudId)=>{
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    const ariCloudId = parsed?.resourceOwner === 'jira' ? parsed.cloudId ?? null : null;
    const queriesEnabled = !!ariCloudId && !!currentCloudId;
    const { data: orgs, isFetching: orgsLoading, error: orgsError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'focus-ask-impacted-work-validate-jira-issue-orgs',
            currentCloudId,
            ariCloudId ?? ''
        ],
        enabled: queriesEnabled,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $e5b47050ec44c654$var$TENANT_CONTEXTS_QUERY,
                // The `ariCloudId` is guaranteed non-null here by the `enabled` flag above,
                // but TypeScript can't infer that — fall back to the workspace cloudId
                // as a safe no-op (the query is disabled, so the value is never used).
                variables: {
                    cloudIds: [
                        currentCloudId,
                        ariCloudId ?? currentCloudId
                    ]
                }
            })
    });
    const { data: sites, isFetching: sitesLoading, error: sitesError } = (0, $5SS4O.useQuery)({
        queryKey: [
            'focus-ask-impacted-work-validate-jira-issue-sites',
            currentCloudId,
            ariCloudId ?? ''
        ],
        enabled: queriesEnabled,
        queryFn: ()=>(0, $haiCi.performGqlFetch)({
                gqlQuery: $e5b47050ec44c654$var$USER_ACCESSIBLE_JIRA_SITES_QUERY,
                variables: {
                    cloudId: currentCloudId
                }
            })
    });
    if (!ariCloudId) return {
        status: 'notFound'
    };
    if (orgsLoading || sitesLoading) return {
        status: 'loading'
    };
    if (queriesEnabled && orgs === undefined && !orgsError) return {
        status: 'loading'
    };
    if (queriesEnabled && sites === undefined && !sitesError) return {
        status: 'loading'
    };
    if (orgsError || sitesError) return {
        status: 'error'
    };
    const workspaceOrg = orgs?.data?.tenantContexts?.find((c)=>c.cloudId === currentCloudId)?.orgId;
    const ariOrg = orgs?.data?.tenantContexts?.find((c_0)=>c_0.cloudId === ariCloudId)?.orgId;
    if (!workspaceOrg || !ariOrg || workspaceOrg !== ariOrg) return {
        status: 'notFound'
    };
    const connectedCloudIds = sites?.data?.mercury_jiraProvider?.userAccessibleConnectedJiraSites?.edges?.map((edge)=>(0, $kIlwI.parseAriSafely)(edge.node.id)?.resourceId).filter((id)=>Boolean(id)) ?? [];
    if (!connectedCloudIds.includes(ariCloudId)) return {
        status: 'notFound'
    };
    return {
        status: 'inWorkspace'
    };
};
function $e5b47050ec44c654$var$_temp(edge) {
    return (0, $kIlwI.parseAriSafely)(edge.node.id)?.resourceId;
}
function $e5b47050ec44c654$var$_temp2(id) {
    return Boolean(id);
}
module.exports["useValidateJiraIssueAri"] = $e5b47050ec44c654$export$b418a8454f0b211f;

});

parcelRegister("b1qeE", function(module, exports) {

var $kIlwI = parcelRequire("kIlwI");

const $56f6d32d34d8044e$export$af3690602393c657 = (ari)=>{
    const parsed = ari ? (0, $kIlwI.parseAriSafely)(ari) : null;
    if (parsed?.resourceOwner !== 'townsquare' || parsed?.resourceType !== 'project') return {
        status: 'notFound'
    };
    return {
        status: 'inWorkspace'
    };
};
module.exports["useValidateTownsquareProjectAri"] = $56f6d32d34d8044e$export$af3690602393c657;

});

parcelRegister("ieqKY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6gGPb = parcelRequire("6gGPb");


var $77jVu = parcelRequire("77jVu");

const $5a0ad0ea14089888$export$dc13db59f8d5a76d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $77jVu.messages).rovoAgentIconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            label: t0,
            size: "small"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        label: formatMessage((0, $77jVu.messages).rovoAgentIconLabel),
        size: "small"
    });
};
module.exports["AgentBuildTabIcon"] = $5a0ad0ea14089888$export$dc13db59f8d5a76d;

});

parcelRegister("kPcTY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6Ec6w = parcelRequire("6Ec6w");


var $lSQgn = parcelRequire("lSQgn");


var $aCpho = parcelRequire("aCpho");


var $iZNeU = parcelRequire("iZNeU");

const $f611132f16bafa21$export$ab36c34ef9f10876 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { index: index } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appearance = (0, $aCpho.useAppearanceForIndex)(index, "ECOSYSTEM_APP");
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $iZNeU.messages).ecosystemAppIconLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                label: formatMessage((0, $iZNeU.messages).ecosystemAppIconLabel)
            });
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== appearance || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            size: "small",
            appearance: appearance,
            label: t1,
            icon: t2
        });
        $[4] = appearance;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appearance = (0, $aCpho.useAppearanceForIndex)(index, 'ECOSYSTEM_APP');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        size: "small",
        appearance: appearance,
        label: formatMessage((0, $iZNeU.messages).ecosystemAppIconLabel),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                label: formatMessage((0, $iZNeU.messages).ecosystemAppIconLabel)
            })
    });
};
module.exports["AppBuildTabIcon"] = $f611132f16bafa21$export$ab36c34ef9f10876;

});

parcelRegister("1zBKt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hMcNB = parcelRequire("hMcNB");


var $lSQgn = parcelRequire("lSQgn");


var $aCpho = parcelRequire("aCpho");


var $7iaRR = parcelRequire("7iaRR");

const $bb623bc368a9e5cc$export$df304b6598b9efc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { index: index } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appearance = (0, $aCpho.useAppearanceForIndex)(index, "AUTOMATION_RULE");
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $7iaRR.messages).automationRuleIconLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                label: formatMessage((0, $7iaRR.messages).automationRuleIconLabel)
            });
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== appearance || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            size: "small",
            appearance: appearance,
            label: t1,
            icon: t2
        });
        $[4] = appearance;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appearance = (0, $aCpho.useAppearanceForIndex)(index, 'AUTOMATION_RULE');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        size: "small",
        appearance: appearance,
        label: formatMessage((0, $7iaRR.messages).automationRuleIconLabel),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                label: formatMessage((0, $7iaRR.messages).automationRuleIconLabel)
            })
    });
};
module.exports["AutomationBuildTabIcon"] = $bb623bc368a9e5cc$export$df304b6598b9efc4;

});

parcelRegister("avyk4", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3b25ad9af32944ea$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    comingSoonTagLabel: {
        id: "ai-mate.conversation-assistant-message-actions.studio-trigger-solution-build.plan-card.card-footer.action-button.coming-soon-tag-label",
        defaultMessage: "Coming soon"
    }
});
module.exports["messages"] = $3b25ad9af32944ea$export$defe85febe8b728c;

});

parcelRegister("dfsz1", function(module, exports) {
/**
 * @generated SignedSource<<33de0ecc9919114a701fc0135c4d6f1e>>
 * @relayHash e24b0da0f9667d2c9d18dd27b057b166
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 429cf356462ed5a82d27ab42cba9744a88f0cec50846d920caf9b5b4097bc6a9
const $146317962dca7e4f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "StudioCreateDraftBuildPayload",
                    "kind": "LinkedField",
                    "name": "studio_createDraftBuild",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "StudioCreateDraftBuildDetails",
                            "kind": "LinkedField",
                            "name": "build",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "buildId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHandoffAction_planBuildMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHandoffAction_planBuildMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "429cf356462ed5a82d27ab42cba9744a88f0cec50846d920caf9b5b4097bc6a9",
            "metadata": {},
            "name": "useHandoffAction_planBuildMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$146317962dca7e4f$var$node.hash = "68a9e008c5970ab00f32a54d7ac2706c";
var $146317962dca7e4f$export$2e2bcd8739ae039 = $146317962dca7e4f$var$node;
module.exports["default"] = $146317962dca7e4f$export$2e2bcd8739ae039;

});

parcelRegister("jfauV", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e38922a375b1c02a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    solutionBuildErrorTitle: {
        id: "ai-mate.conversation-assistant-message-actions.studio-trigger-solution-build.plan-card.card-footer.action-button.solution-build-error-title",
        defaultMessage: "Error"
    },
    solutionBuildErrorDescription: {
        id: "ai-mate.conversation-assistant-message-actions.studio-trigger-solution-build.plan-card.card-footer.action-button.solution-build-error-description",
        defaultMessage: "Failed to trigger solution build"
    }
});
module.exports["messages"] = $e38922a375b1c02a$export$defe85febe8b728c;

});

parcelRegister("gFCxl", function(module, exports) {
/**
 * @generated SignedSource<<8119a2ab6b251379545967d26a4c553f>>
 * @relayHash 019931ecb4d62478ada7dcb38c369407
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c1006bb595d5871def9b45953f93abb35e05f3b2f761dfc9ca352ec5a7d5225c
const $89c7c250e57bc41e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dontRequirePrincipalsInSite"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v5 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "dontRequirePrincipalsInSite",
                            "variableName": "dontRequirePrincipalsInSite"
                        },
                        {
                            "kind": "Variable",
                            "name": "permissionIds",
                            "variableName": "permissionIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "principalIds",
                            "variableName": "principalIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "resourceIds",
                            "variableName": "resourceIds"
                        }
                    ],
                    "concreteType": "BulkPermittedResponse",
                    "kind": "LinkedField",
                    "name": "bulkPermitted",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "permitted"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WorkspacePermissionsProviderQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WorkspacePermissionsProviderQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "c1006bb595d5871def9b45953f93abb35e05f3b2f761dfc9ca352ec5a7d5225c",
            "metadata": {},
            "name": "WorkspacePermissionsProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$89c7c250e57bc41e$var$node.hash = "8e0438daab88aeec8fade1b553ab0b21";
var $89c7c250e57bc41e$export$2e2bcd8739ae039 = $89c7c250e57bc41e$var$node;
module.exports["default"] = $89c7c250e57bc41e$export$2e2bcd8739ae039;

});

parcelRegister("3SlQf", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");

async function $28e5da19d930832e$export$c7c7cb988344a4bd(buildId, workspaceId) {
    (0, $6cFsl.di)(fetch);
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/solution-architect/draft-build/${buildId}`, {
        credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch draft build.');
    return response.json();
}
module.exports["fetchDraftBuild"] = $28e5da19d930832e$export$c7c7cb988344a4bd;

});

parcelRegister("9NDDx", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");

async function $7dc74af9cffc1377$export$45c281132cd9bd64(workspaceId, { buildId: buildId, state: state, objectAri: objectAri }) {
    (0, $6cFsl.di)(fetch);
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/solution-architect/build-reference`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
            buildId: buildId,
            updates: {
                state: state,
                ari: objectAri
            }
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to update build state.');
}
module.exports["updateBuildState"] = $7dc74af9cffc1377$export$45c281132cd9bd64;

});

parcelRegister("dKfWr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $0ec2379b784ba2a3$export$88014f3d16427d4b = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled = true, agentCreatorType: agentCreatorType })=>{
    const { data: data, isFetching: isFetching, refetch: refetch } = (0, $5SS4O.useQuery)({
        queryKey: [
            'getKnowledgeConnectors',
            agentCreatorType ?? ''
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
            });
            return assistanceService.getAgentKnowledgeConfiguration(agentCreatorType);
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: enabled
    });
    const isConnectorEnabled = (0, $cozmU.useCallback)((type)=>{
        return data?.knowledgeSources?.some((value)=>value.source === type) ?? false;
    }, [
        data
    ]);
    const enabledKnowledgeSources = (0, $cozmU.useMemo)(()=>{
        return data?.knowledgeSources ?? [];
    }, [
        data
    ]);
    return {
        enabledKnowledgeSources: enabledKnowledgeSources,
        isConnectorEnabled: isConnectorEnabled,
        isFetching: isFetching,
        refetch: refetch
    };
});
module.exports["useKnowledgeConnectors"] = $0ec2379b784ba2a3$export$88014f3d16427d4b;

});

parcelRegister("beSzn", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4c44c6d88127f24d$var$message = (0, $kSwu1.defineMessages)({
    knowledgeSourcePill: {
        id: "knowledgeSourcePill.alt.label",
        defaultMessage: "Icon for {knowledgeSource}"
    },
    allSpaces: {
        id: "allSpaces.label",
        defaultMessage: "All spaces"
    },
    allContent: {
        id: "allContent.label",
        defaultMessage: "All content"
    }
});
var $4c44c6d88127f24d$export$2e2bcd8739ae039 = $4c44c6d88127f24d$var$message;
module.exports["default"] = $4c44c6d88127f24d$export$2e2bcd8739ae039;

});

parcelRegister("k0ogf", function(module, exports) {
/**
 * Safely extracts the hostname from a URL string.
 * Returns an empty string if the URL is invalid or null.
 *
 * Used by the Jira Align project ARI validator to convert a resolved
 * URL (e.g. `https://mock.jiraalign.com/EpicGrid?EpicID=1`) into a
 * bare hostname (`mock.jiraalign.com`) for the `tenantContexts(hostNames: ...)`
 * GQL lookup.
 */ const $19ba0984a7c0d2b9$export$b1f55e94ac826a0b = (url)=>{
    try {
        return new URL(url ?? '').hostname;
    } catch  {
        return '';
    }
};
module.exports["extractHostname"] = $19ba0984a7c0d2b9$export$b1f55e94ac826a0b;

});

parcelRegister("Mrc7T", function(module, exports) {
/**
 * Detects whether the current page is running in a staging Atlassian
 * environment based on `window.location.host`.
 *
 * Mirrors the logic from
 * `@atlassian/conversation-assistant-viz/utils/env-helpers.isStaging`,
 * inlined here to avoid taking a cross-package dep just for this branch
 * in JA env selection.
 *
 * Used by the JA validator to decide between `'dev'` (staging) and
 * `'production'` (everything else) when sandbox is false.
 */ const $665ce2ca3e7ffd89$export$b3e1bb4c27c63f89 = ()=>{
    if (typeof window === 'undefined') return false;
    const host = window.location.host;
    return host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com') || host.includes('trellis.coffee');
};
module.exports["isStagingEnvironment"] = $665ce2ca3e7ffd89$export$b3e1bb4c27c63f89;

});

parcelRegister("77jVu", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f2549eef5339467f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    rovoAgentIconLabel: {
        id: "studio-trigger-solution-build-plan-card.title-icon-picker.rovo-agent-icon-label",
        defaultMessage: "Rovo Agent"
    }
});
module.exports["messages"] = $f2549eef5339467f$export$defe85febe8b728c;

});

parcelRegister("aCpho", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $lzU6z = parcelRequire("lzU6z");

const $302082df08910e12$export$40ffaa49efff59e8 = (index, buildType)=>{
    (0, $6cFsl.di)((0, $lzU6z.getAppearanceForIndex));
    return (0, $lzU6z.getAppearanceForIndex)(index, buildType);
};
module.exports["useAppearanceForIndex"] = $302082df08910e12$export$40ffaa49efff59e8;

});

parcelRegister("iZNeU", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $667241dbbf0470cd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ecosystemAppIconLabel: {
        id: "studio-trigger-solution-build-plan-card.title-icon-picker.ecosystem-app-icon-label",
        defaultMessage: "Ecosystem App"
    }
});
module.exports["messages"] = $667241dbbf0470cd$export$defe85febe8b728c;

});

parcelRegister("7iaRR", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $39422e26b8491518$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    automationRuleIconLabel: {
        id: "studio-trigger-solution-build-plan-card.title-icon-picker.automation-rule-icon-label",
        defaultMessage: "Automation Rule"
    }
});
module.exports["messages"] = $39422e26b8491518$export$defe85febe8b728c;

});


//# sourceMappingURL=ConversationAssistant.a3904377.js.map
